
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("gDUp5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d74f79dab68f2a54$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $keOMr = parcelRequire("keOMr");

var $inDCU = parcelRequire("inDCU");

var $kJlBc = parcelRequire("kJlBc");

var $6vrw7 = parcelRequire("6vrw7");

var $2wMrb = parcelRequire("2wMrb");

var $k7z6h = parcelRequire("k7z6h");

var $9ov06 = parcelRequire("9ov06");

var $jcBIF = parcelRequire("jcBIF");
const $d74f79dab68f2a54$var$IssueWithoutRouterFunctional = (props)=>{
    const issueKey = (0, $6vrw7.toIssueKey)(props.match.params.issueKey || '');
    const isEmbedMode = (0, $keOMr.useIsEmbedMode)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ov06.StartIssueMetric), {
        issueKey: issueKey,
        isEmbedMode: isEmbedMode
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inDCU.SetBootstrapBundleReadyMark), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k7z6h.default), {
        issueKey: issueKey,
        location: props.location
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2wMrb.ProjectSubProductUpdater), {
        allowMonolithDeferral: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jcBIF.default), null)));
};
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
$d74f79dab68f2a54$export$2e2bcd8739ae039 = (0, $kJlBc.withRouter)($d74f79dab68f2a54$var$IssueWithoutRouterFunctional);

});
parcelRegister("keOMr", function(module, exports) {

$parcel$export(module.exports, "useIsEmbedMode", () => $e37727bc1c1720b6$export$1b3c1ba6ee047da9);

var $eUqFw = parcelRequire("eUqFw");

var $sFzm1 = parcelRequire("sFzm1");

var $sFzm1 = parcelRequire("sFzm1");
const $e37727bc1c1720b6$export$1b3c1ba6ee047da9 = ()=>(0, $eUqFw.useContext)((0, $sFzm1.EmbedModeContext));

});
parcelRegister("sFzm1", function(module, exports) {

$parcel$export(module.exports, "EmbedModeContext", () => $8c69a6d02011f63a$export$5eb07b3c7c0b0771);
$parcel$export(module.exports, "EmbedModeProvider", () => $8c69a6d02011f63a$export$9daaf42d62e1c430);

var $eUqFw = parcelRequire("eUqFw");
const $8c69a6d02011f63a$export$5eb07b3c7c0b0771 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const { Provider: $8c69a6d02011f63a$var$Provider } = $8c69a6d02011f63a$export$5eb07b3c7c0b0771;
const $8c69a6d02011f63a$var$handleEmbedLinkClick = (e)=>{
    const eventTarget = e.target;
    if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') // link
    eventTarget.target = '_blank';
};
// When issue view is loaded within an iframe, it needs to follow the proper
// element elevation principles, found here: https://hello.atlassian.net/wiki/spaces/~460573267/pages/2355983526/Jira+Dark+Mode+-+UI+Guidelines#Element-elevation-basics
// Unfortunately the current elevation is set in the global-container, which is loaded before this Provider so
// we have to override the overrider to ensure that the proper elevation is set
const $8c69a6d02011f63a$var$DarkModeMonolithStyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    #jira-frontend {
                        background: ${"var(--ds-surface-overlay, white)"};
                    }
                `
        }
    });
const $8c69a6d02011f63a$export$9daaf42d62e1c430 = ({ children: children })=>{
    (0, $eUqFw.useEffect)(()=>{
        window.addEventListener('click', $8c69a6d02011f63a$var$handleEmbedLinkClick, true);
        return ()=>{
            window.removeEventListener('click', $8c69a6d02011f63a$var$handleEmbedLinkClick);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c69a6d02011f63a$var$DarkModeMonolithStyleOverride, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c69a6d02011f63a$var$Provider, {
        value: true
    }, children));
};

});


parcelRegister("inDCU", function(module, exports) {

$parcel$export(module.exports, "SetBootstrapBundleReadyMark", () => $f59b0dd69e4560bf$export$336667852b20afff);
$parcel$export(module.exports, "SetBundleReadyMark", () => $f59b0dd69e4560bf$export$6204e01bde3d2625);
$parcel$export(module.exports, "SetCustomMark", () => (parcelRequire("eZGdd")).default);

var $eUqFw = parcelRequire("eUqFw");


var $eZGdd = parcelRequire("eZGdd");

var $3dxBh = parcelRequire("3dxBh");

var $7vf5z = parcelRequire("7vf5z");

var $hqj5v = parcelRequire("hqj5v");


var $ifyPR = parcelRequire("ifyPR");

const $f59b0dd69e4560bf$export$336667852b20afff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZGdd.default), {
        name: "appBootstrapBundleReady"
    });
const $f59b0dd69e4560bf$export$6204e01bde3d2625 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZGdd.default), {
        name: (0, $37f655a4e4d5690e$export$ff834eccc35b9089)
    });
const $f59b0dd69e4560bf$export$f9a192d46021c340 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZGdd.default), {
        name: (0, $37f655a4e4d5690e$export$86b05e34d462ead8)
    });

});
const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("eZGdd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1717fc440f3604c9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $0S0fK = parcelRequire("0S0fK");
class $1717fc440f3604c9$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { name: name } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0S0fK.default).Consumer, null, ({ pageId: pageId, onCustomMark: onCustomMark })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
                op: onCustomMark,
                args: [
                    name,
                    pageId
                ]
            }));
    }
}

});
parcelRegister("3viaK", function(module, exports) {

$parcel$export(module.exports, "default", () => $114bcd9b637bc682$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");
// eslint-disable-next-line jira/react/no-class-components
class $114bcd9b637bc682$var$OpTrigger extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(this.props.args, nextProps.args);
    }
    componentDidUpdate() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $114bcd9b637bc682$export$2e2bcd8739ae039 = $114bcd9b637bc682$var$OpTrigger;

});

parcelRegister("0S0fK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f943d45ee0ecaf49$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $f943d45ee0ecaf49$var$contextName = 'SpaApdexAnalytics';
var $f943d45ee0ecaf49$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.createContext)($f943d45ee0ecaf49$var$contextName);

});


parcelRegister("3dxBh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b1c4436e864f401$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ICvxP = parcelRequire("ICvxP");
var $6iz4v = parcelRequire("6iz4v");

var $3viaK = parcelRequire("3viaK");

var $6xYPC = parcelRequire("6xYPC");

var $87isp = parcelRequire("87isp");


var $0S0fK = parcelRequire("0S0fK");

var $1cNJ6 = parcelRequire("1cNJ6");
class $8b1c4436e864f401$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { children: children, pageId: pageId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0S0fK.default).Provider, {
            // @ts-expect-error - TS2322 - Type '{ pageId: string; onReady: (metricKeyForInitialRender: string, metricKeyForTransition: string, extra: { [key: string]: string | number | boolean; } | undefined, metric: BM3Metric) => void; onCustomMark: (markName: string) => void; }' is not assignable to type 'string'.
            value: {
                pageId: pageId,
                onReady: this.onReady,
                onCustomMark: this.onCustomMark
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: this.onStart,
            args: [
                pageId
            ]
        }), children));
    }
    constructor(...args){
        super(...args);
        this.customMarks = [];
        this.onStart = ()=>{
            (0, $ICvxP.default)((0, $37f655a4e4d5690e$export$56940a9488e85199));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$45c4b6bf7935c69a));
        };
        this.onCustomMark = (markName)=>{
            (0, $6iz4v.setMark)((0, $1cNJ6.getPrefixedMarkName)(markName));
            // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
            this.customMarks.push(markName);
        };
        this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
            metric.stop({
                customData: extra
            });
            if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
        };
    }
}

});
parcelRegister("6xYPC", function(module, exports) {

$parcel$export(module.exports, "stopLowPriorityEventDelay", () => $4b25e5ad6cfac913$export$a928755af449867);
$parcel$export(module.exports, "startLowPriorityEventDelay", () => $4b25e5ad6cfac913$export$8bb8df5a93e9525);
$parcel$export(module.exports, "default", () => $4b25e5ad6cfac913$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ICvxP = parcelRequire("ICvxP");
var $6iz4v = parcelRequire("6iz4v");

var $cbwiM = parcelRequire("cbwiM");

var $3FyZ4 = parcelRequire("3FyZ4");

var $epT40 = parcelRequire("epT40");

var $87isp = parcelRequire("87isp");

const $4b25e5ad6cfac913$var$STOP_DELAY_TIMEOUT = 10000;
let $4b25e5ad6cfac913$var$stopDelayTimeout;
let $4b25e5ad6cfac913$var$lastDelayActionPromise = (0, $3FyZ4.getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
const $4b25e5ad6cfac913$export$a928755af449867 = ()=>{
    $4b25e5ad6cfac913$var$lastDelayActionPromise = $4b25e5ad6cfac913$var$lastDelayActionPromise.then((client)=>{
        if (!(0, $cbwiM.isEventDelayActive)()) return client;
        clearTimeout($4b25e5ad6cfac913$var$stopDelayTimeout);
        // stopLowPriorityEventDelay performs a flush of the delayed events,
        // so the delayed period needs to be marked as ended _before_ calling that method.
        (0, $6iz4v.setMark)((0, $9f18a423c52d71b6$export$2d91d3eed1108e72));
        (0, $cbwiM.setEventDelayActive)(false);
        client.stopLowPriorityEventDelay();
        return client;
    });
};
const $4b25e5ad6cfac913$export$8bb8df5a93e9525 = ()=>{
    $4b25e5ad6cfac913$var$lastDelayActionPromise = $4b25e5ad6cfac913$var$lastDelayActionPromise.then((client)=>{
        // If startLowPriorityEventDelay is called when it's already active, then we are just extending
        // the delay period, so we don't want to reset any metadata we have captured about the original start.
        if (!(0, $cbwiM.isEventDelayActive)()) {
            (0, $ICvxP.default)((0, $9f18a423c52d71b6$export$358721a9d6125914));
            (0, $6iz4v.setMark)((0, $9f18a423c52d71b6$export$b2122dce85a27912));
        }
        client.startLowPriorityEventDelay();
        (0, $cbwiM.setEventDelayActive)(true);
        clearTimeout($4b25e5ad6cfac913$var$stopDelayTimeout);
        $4b25e5ad6cfac913$var$stopDelayTimeout = setTimeout($4b25e5ad6cfac913$export$a928755af449867, $4b25e5ad6cfac913$var$STOP_DELAY_TIMEOUT);
        return client;
    });
};
const $4b25e5ad6cfac913$export$778ebe2a4fab1ba7 = ()=>$4b25e5ad6cfac913$var$lastDelayActionPromise;
const $4b25e5ad6cfac913$var$EventDelayController = ()=>{
    const [loadedState] = (0, $epT40.default)();
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * The delay mechanism is currently locked so that only automatic exposure events
		 * can leverage it.
		 * We can remove the performance overhead of starting and stopping critical sections when
		 * these events won't be getting fired.
		 */ if (!loadedState.hasLoaded && (0, $87isp.isAutomaticExposureCollectionEnabled)()) $4b25e5ad6cfac913$export$8bb8df5a93e9525();
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
var $4b25e5ad6cfac913$export$2e2bcd8739ae039 = $4b25e5ad6cfac913$var$EventDelayController;

});
parcelRegister("cbwiM", function(module, exports) {

$parcel$export(module.exports, "setEventDelayActive", () => $00304183c2d9ac4d$export$9a4add6d6ddcc1a);
$parcel$export(module.exports, "isEventDelayActive", () => $00304183c2d9ac4d$export$3536b0184fa98d19);
let $00304183c2d9ac4d$var$eventDelayActive = false;
const $00304183c2d9ac4d$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
    $00304183c2d9ac4d$var$eventDelayActive = isEventDelayActive;
};
const $00304183c2d9ac4d$export$3536b0184fa98d19 = ()=>$00304183c2d9ac4d$var$eventDelayActive;

});

parcelRegister("epT40", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9158c027ae7ce81$export$2e2bcd8739ae039);

var $ggKAj = parcelRequire("ggKAj");


var $cfLkw = parcelRequire("cfLkw");
const $c9158c027ae7ce81$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    const determineHasLoaded = ()=>{
        /*
		 * During a transition, the top navigation is the only app loading. Additionally, legacy pages generally
		 * render a LegacyPage component, analytics, or nothing at all.
		 *
		 * This code ensures that the page is considered loaded when the content has finished loading in the
		 * SPA, or when the top navigation has finished loading for legacy pages.
		 *
		 * Ideally the LegacyPage component should include an app for the content, but the usage of route components
		 * in legacy routes is inconsistent and would need thorough testing. This should be good enough for now.
		 */ if (appIds.length === 1 && appIds[0] === (0, $9c22638d2f17f9db$export$3a54edb6ba4daa82)) return !__SPA__;
        return appIds.length ? appIds.filter((id)=>id !== (0, $9c22638d2f17f9db$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
    };
    const hasLoaded = determineHasLoaded();
    return {
        hasLoaded: hasLoaded
    };
};
const $c9158c027ae7ce81$var$usePageLoadedSubscriber = (0, $ggKAj.createHook)((0, $cfLkw.default), {
    selector: $c9158c027ae7ce81$export$4a361c7505f72f5c
});
var $c9158c027ae7ce81$export$2e2bcd8739ae039 = $c9158c027ae7ce81$var$usePageLoadedSubscriber;

});
const $9c22638d2f17f9db$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $9c22638d2f17f9db$export$2ee9e5a3556c1e43 = 'SIDEBAR';

parcelRegister("cfLkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e76bb655f4dbc8c$export$2e2bcd8739ae039);

var $a61MH = parcelRequire("a61MH");

var $hompL = parcelRequire("hompL");

var $a2pDC = parcelRequire("a2pDC");
const $7e76bb655f4dbc8c$export$d4c72bab9d6cc13a = {
    transitionCheckTimestamp: -1,
    currentPage: {
        uuid: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
        startTime: typeof performance !== 'undefined' && performance.timing !== undefined && performance.timing.navigationStart || 0,
        apps: {},
        userLocation: ''
    },
    visitedPages: [],
    navigation: {
        isCollapsed: false,
        viewId: 'noView',
        viewType: '',
        projectType: null,
        isInitialEventSent: false,
        pageId: null,
        nextViewId: ''
    }
};
const $7e76bb655f4dbc8c$var$store = (0, $a61MH.createStore)({
    name: 'spa-state',
    initialState: $7e76bb655f4dbc8c$export$d4c72bab9d6cc13a,
    actions: $a2pDC
});
var $7e76bb655f4dbc8c$export$2e2bcd8739ae039 = $7e76bb655f4dbc8c$var$store;

});
parcelRegister("a2pDC", function(module, exports) {

$parcel$export(module.exports, "setAppStart", () => (parcelRequire("gKuw7")).setAppStart);
$parcel$export(module.exports, "setAppReady", () => (parcelRequire("gKuw7")).setAppReady);
$parcel$export(module.exports, "setAppStartWithAppId", () => (parcelRequire("gKuw7")).setAppStartWithAppId);
$parcel$export(module.exports, "setAppReadyWithAppId", () => (parcelRequire("gKuw7")).setAppReadyWithAppId);
$parcel$export(module.exports, "setAppErrorReady", () => (parcelRequire("gKuw7")).setAppErrorReady);
$parcel$export(module.exports, "setTimeoutReady", () => (parcelRequire("gKuw7")).setTimeoutReady);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => (parcelRequire("gKuw7")).setTimeoutReadyWithAppId);
$parcel$export(module.exports, "resetCurrentPage", () => (parcelRequire("gKuw7")).resetCurrentPage);
$parcel$export(module.exports, "setResourceMetrics", () => (parcelRequire("gKuw7")).setResourceMetrics);

var $gKuw7 = parcelRequire("gKuw7");

});
parcelRegister("gKuw7", function(module, exports) {

$parcel$export(module.exports, "resetCurrentPage", () => $1354b0144a8be88b$export$5639685a1fb81722);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => $1354b0144a8be88b$export$8a98548dad2fa97b);
$parcel$export(module.exports, "setTimeoutReady", () => $1354b0144a8be88b$export$b9cc4378ea785421);
$parcel$export(module.exports, "setAppStartWithAppId", () => $1354b0144a8be88b$export$9d528722f2ff2999);
$parcel$export(module.exports, "setAppStart", () => $1354b0144a8be88b$export$71192061050856ad);
$parcel$export(module.exports, "setAppReadyWithAppId", () => $1354b0144a8be88b$export$6a25429a42d30f9a);
$parcel$export(module.exports, "setAppReady", () => $1354b0144a8be88b$export$fc59cc4ed9bba7cd);
$parcel$export(module.exports, "setAppErrorReady", () => $1354b0144a8be88b$export$aff63c1e41443b6a);
$parcel$export(module.exports, "setResourceMetrics", () => $1354b0144a8be88b$export$8ad155d489dcf34d);

var $hompL = parcelRequire("hompL");

var $3tabS = parcelRequire("3tabS");

var $1ybV0 = parcelRequire("1ybV0");

var $keguF = parcelRequire("keguF");

var $4nnPJ = parcelRequire("4nnPJ");

var $ULuRM = parcelRequire("ULuRM");
const $1354b0144a8be88b$export$7bd623b29ec8e1eb = 10000;
const $1354b0144a8be88b$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        performance.mark('resetCurrentPage');
        (0, $3tabS.browserMetrics).startPageLoad({
            isInitial: false
        });
        (0, $ULuRM.default)(nextRouteUfoName, nextRouteName);
        if ((0, $1ybV0.ff)('uip.ufo')) {
            (0, $4nnPJ.GlobalPageLoadExperience).abort({
                force: true
            });
            (0, $4nnPJ.GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
        }
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
            currentPage: {
                uuid: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                apps: {},
                startTime: Date.now(),
                userLocation: ''
            },
            visitedPages: [
                ...currentState.visitedPages,
                {
                    ...currentState.currentPage
                }
            ],
            transitionCheckTimestamp: 0
        });
    };
const $1354b0144a8be88b$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
            const apps = {
                ...currentPage.apps
            };
            if (apps[appId] && apps[appId].expectingTimeout) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            timeoutTime: timeoutTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        }
    };
const $1354b0144a8be88b$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($1354b0144a8be88b$export$8a98548dad2fa97b(appId, timeoutTime));
    };
const $1354b0144a8be88b$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
            const timeoutId = setTimeout(()=>{
                dispatch($1354b0144a8be88b$export$8a98548dad2fa97b(appId));
            }, $1354b0144a8be88b$export$7bd623b29ec8e1eb);
            const updatedPage = {
                ...currentPage,
                userLocation: (0, $keguF.getUserLocation)(),
                apps: {
                    ...currentPage.apps,
                    [appId]: {
                        startTime: startTime,
                        expectingTimeout: timeoutId
                    }
                }
            };
            setState({
                // @ts-expect-error - TS2322 - Type '{ userLocation: string; apps: { [x: string]: AppState | { startTime: number; expectingTimeout: NodeJS.Timeout; }; }; uuid: string; startTime: number; resources?: ResourceMetrics[] | undefined; }' is not assignable to type 'PageTiming'.
                currentPage: updatedPage
            });
        }
    };
const $1354b0144a8be88b$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($1354b0144a8be88b$export$9d528722f2ff2999(appId, startTime));
    };
const $1354b0144a8be88b$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
            const apps = {
                ...currentPage.apps
            };
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(currentPage.apps[appId].expectingTimeout);
            const updatedPage = {
                ...currentPage,
                apps: {
                    ...apps,
                    [appId]: {
                        ...apps[appId],
                        endTime: endTime,
                        expectingTimeout: 0
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $1354b0144a8be88b$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($1354b0144a8be88b$export$6a25429a42d30f9a(appId, endTime));
    };
const $1354b0144a8be88b$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
            const updatedPage = {
                ...currentPage,
                apps: {
                    'error-page': {
                        endTime: Date.now()
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $1354b0144a8be88b$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            currentPage: {
                ...currentState.currentPage,
                resources: [
                    ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                    resourceMetrics
                ]
            }
        });
    };

});




const $9f18a423c52d71b6$export$358721a9d6125914 = 'event-delay-controller.';
const $9f18a423c52d71b6$export$b2122dce85a27912 = `${$9f18a423c52d71b6$export$358721a9d6125914}start`;
const $9f18a423c52d71b6$export$2d91d3eed1108e72 = `${$9f18a423c52d71b6$export$358721a9d6125914}end`;


parcelRegister("1cNJ6", function(module, exports) {

$parcel$export(module.exports, "getPrefixedMarkName", () => $c844db40c28c8d19$export$c8f0e9837e7e9425);

const $c844db40c28c8d19$export$c8f0e9837e7e9425 = (name)=>`${0, $37f655a4e4d5690e$export$56940a9488e85199}${name}`;

});


parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $4nnPJ = parcelRequire("4nnPJ");

var $1QVWH = parcelRequire("1QVWH");

var $j2Yjr = parcelRequire("j2Yjr");

var $gnIbC = parcelRequire("gnIbC");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QVWH.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j2Yjr.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $gnIbC.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("1QVWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4fbf7a0879450da$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $a4fbf7a0879450da$export$d12f56a472cdbe6c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $a4fbf7a0879450da$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    (0, $eUqFw.useMemo)(()=>{
        if (!interactionContext) return;
        interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $a4fbf7a0879450da$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $fVaJL.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("j2Yjr", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $9cfce24b860b88bd$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $9cfce24b860b88bd$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $9cfce24b860b88bd$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $9cfce24b860b88bd$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $9cfce24b860b88bd$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fVaJL.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $3tabS = parcelRequire("3tabS");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");
var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $5iuyH = parcelRequire("5iuyH");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $3tabS.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
    (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    return null;
};

});


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $4nnPJ = parcelRequire("4nnPJ");

var $5iuyH = parcelRequire("5iuyH");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fVaJL.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fVaJL.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $gnIbC = parcelRequire("gnIbC");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("hqj5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd515edca209afee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0S0fK = parcelRequire("0S0fK");

var $7vf5z = parcelRequire("7vf5z");
// eslint-disable-next-line jira/react/no-class-components
class $dd515edca209afee$var$ApdexActions extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = (0, $7vf5z.baseDefaultProps);
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, children: children, metric: metric } = this.props;
        (0, $7vf5z.checkAndEmitApdexSignal)(appName, metricKey);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0S0fK.default).Consumer, null, ({ onReady: onReady })=>children({
                submit: ()=>onReady(metricKey || `jira.fe.spa.initial-render.${String(appName)}`, metricKey || `jira.fe.spa.transition.${String(appName)}`, extra, metric)
            }));
    }
}
var $dd515edca209afee$export$2e2bcd8739ae039 = $dd515edca209afee$var$ApdexActions;

});


parcelRegister("2wMrb", function(module, exports) {

$parcel$export(module.exports, "ProjectSubProductUpdater", () => $967eaa8dc0617775$export$bfbf80c212b0dcb9);

var $eUqFw = parcelRequire("eUqFw");

var $SEaoU = parcelRequire("SEaoU");
var $i889l = parcelRequire("i889l");

var $fO5rB = parcelRequire("fO5rB");

var $6QL9v = parcelRequire("6QL9v");
const $967eaa8dc0617775$export$bfbf80c212b0dcb9 = ({ allowMonolithDeferral: allowMonolithDeferral = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $SEaoU.ContainerContextSubscriber), null, ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, data && (0, $i889l.isProjectContext)(data) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
            subProduct: (0, $6QL9v.subProductFromProjectType)(data.project.type),
            allowMonolithDeferral: allowMonolithDeferral
        })));

});
parcelRegister("SEaoU", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $753bd1908e635680$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $753bd1908e635680$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $4MmfV = parcelRequire("4MmfV");
var $kXWpU = parcelRequire("kXWpU");

var $3HCkE = parcelRequire("3HCkE");

var $e8UKN = parcelRequire("e8UKN");
const $753bd1908e635680$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $3HCkE.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource));
    const projectContext = (0, $eUqFw.useMemo)(()=>data && (0, $e8UKN.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $753bd1908e635680$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $3HCkE.useResource)((0, $4MmfV.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $eUqFw.useMemo)(()=>data && (0, $e8UKN.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $753bd1908e635680$export$c7066c2d215990cf = ()=>{
    const projectContext = $753bd1908e635680$var$useProjectContext();
    const userBoardContext = $753bd1908e635680$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $753bd1908e635680$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $753bd1908e635680$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$753bd1908e635680$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("4MmfV", function(module, exports) {

$parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", () => $ca35414721fafc7a$export$5839dd8142de842e);

var $gUUjF = parcelRequire("gUUjF");

var $3HCkE = parcelRequire("3HCkE");

var $ElVpH = parcelRequire("ElVpH");

var $9SjeY = parcelRequire("9SjeY");
const $ca35414721fafc7a$export$5839dd8142de842e = (0, $3HCkE.createResource)({
    type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $ElVpH.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $ElVpH.getBoardId)(match, query);
        if (boardId == null) return null;
        try {
            const response = await (0, $9SjeY.fetchUserBoardNavigationData)(boardId);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
            return null;
        }
    },
    maxAge: 300000
});

});
parcelRegister("ElVpH", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $478ce79be34a38cd$export$557c2f222778cea6);
const $478ce79be34a38cd$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];

});

parcelRegister("9SjeY", function(module, exports) {

$parcel$export(module.exports, "fetchUserBoardNavigationData", () => $7d7ff3f2c7ca5c69$export$306fb49fca60b34);

var $lRmyA = parcelRequire("lRmyA");
const $7d7ff3f2c7ca5c69$export$306fb49fca60b34 = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
};

});


parcelRegister("kXWpU", function(module, exports) {

$parcel$export(module.exports, "getIdentifier", () => $4181ab9f0d3720b7$export$adb27ddab077e944);
$parcel$export(module.exports, "staticProjectSidebarNavigationResource", () => $4181ab9f0d3720b7$export$f2dfc0f7b2d92691);

var $exb0h = parcelRequire("exb0h");

var $kdp9J = parcelRequire("kdp9J");

var $3HCkE = parcelRequire("3HCkE");

var $ElVpH = parcelRequire("ElVpH");
var $9zYls = parcelRequire("9zYls");

var $LWmvk = parcelRequire("LWmvk");
const $4181ab9f0d3720b7$export$adb27ddab077e944 = (routeName, match, query)=>{
    /**
	 * `boardId` as an identifier should not be returned for JSM boards route,
	 * skip boards on `SERVICEDESK_BOARDS` or `SERVICEDESK_CALENDAR` route.
	 */ if (routeName === (0, $exb0h.ROUTE_NAMES).SERVICEDESK_BOARDS || routeName === (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CALENDAR || query['servicedesk.serviceDeskId']) {
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        return (0, $kdp9J.getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId
        });
    }
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    const boardId = (0, $ElVpH.getBoardId)(match, query);
    return (0, $kdp9J.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId,
        boardId: boardId
    });
};
const $4181ab9f0d3720b7$var$getRouterKey = (routeName, match, query)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = $4181ab9f0d3720b7$export$adb27ddab077e944(routeName, match, query);
    // Next-Gen software projects contain only one board. Hence, using the project key itself
    if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
    return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
};
const $4181ab9f0d3720b7$export$f2dfc0f7b2d92691 = (0, $3HCkE.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
    getKey: ({ match: match, query: query, route: { name: name } })=>$4181ab9f0d3720b7$var$getRouterKey(name, match, query),
    /**
	 * is called on resource's init fetch, or .refresh()
	 */ getData: async ({ match: match, query: query, route: { name: name } })=>{
        const scopeIdentifier = $4181ab9f0d3720b7$export$adb27ddab077e944(name, match, query);
        if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
        const navInfo = await (0, $LWmvk.fetchProjectSidebarNavInfo)(scopeIdentifier);
        return navInfo;
    },
    maxAge: 300000
});

});
parcelRegister("9zYls", function(module, exports) {

$parcel$export(module.exports, "getProjectKeyId", () => $5d8459da4a60e5c9$export$1f7213d0f9054f06);
const $5d8459da4a60e5c9$export$1f7213d0f9054f06 = (match, query)=>{
    // handle reports legacy url or project settings details
    const projectId = query.selectedProjectId || query.pid || query.projectId || query['project.id'];
    const projectKey = match.params.projectKey || query.projectKey || query['project.key'] || (match.params.issueKey || '').split('-')[0];
    return {
        projectKey: projectKey,
        projectId: projectId
    };
};

});

parcelRegister("LWmvk", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarNavInfo", () => $586cfcaef75ec717$export$8a51470472777e11);

var $lRmyA = parcelRequire("lRmyA");
const $586cfcaef75ec717$export$8a51470472777e11 = (scopeIdentifier)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
    if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
    let queryParam = '';
    switch(identifierType){
        case 'boardId':
            queryParam = `boardId=${identifierValue}`;
            break;
        case 'projectKey':
        case 'projectId':
            queryParam = `projectIdOrKey=${identifierValue}`;
            break;
        default:
            break;
    }
    return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
};

});


parcelRegister("e8UKN", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $4c7bf04e2602d89a$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $4c7bf04e2602d89a$export$d17fffd59c7b3c60);

var $7ZZxN = parcelRequire("7ZZxN");

var $eWsAG = parcelRequire("eWsAG");
const $4c7bf04e2602d89a$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $4c7bf04e2602d89a$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $4c7bf04e2602d89a$var$getProjectType = (projectType)=>{
    switch(projectType){
        case 'business':
            return 0, $7ZZxN.CORE_PROJECT;
        case 'software':
            return 0, $7ZZxN.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $7ZZxN.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $4c7bf04e2602d89a$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $eWsAG.extractData)(projectNavInfo);
    const scope = $4c7bf04e2602d89a$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $4c7bf04e2602d89a$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $eWsAG.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});
parcelRegister("eWsAG", function(module, exports) {

$parcel$export(module.exports, "getStyle", () => $994f1ddfe6829bdc$export$3d2f074408bd1b82);
$parcel$export(module.exports, "extractData", () => $994f1ddfe6829bdc$export$9df5fa0a366163d2);

var $7ZZxN = parcelRequire("7ZZxN");
const $994f1ddfe6829bdc$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, $7ZZxN.ProjectStyle).NEXT_GEN : (0, $7ZZxN.ProjectStyle).CLASSIC;
const $994f1ddfe6829bdc$var$getProject = (project)=>({
        avatarUrl: project.avatarUrls['48x48'],
        id: Number(project.id),
        isSimplified: project.simplified,
        key: project.key,
        name: project.name,
        style: $994f1ddfe6829bdc$export$3d2f074408bd1b82(project.simplified),
        type: project.projectTypeKey
    });
const $994f1ddfe6829bdc$export$9df5fa0a366163d2 = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraWorkManagementNavData.project) : null;
        case 'jira_software':
            return jiraSoftwareNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraSoftwareNavData.project) : null;
        case 'jira_service_management':
            return jiraServiceManagementNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraServiceManagementNavData.project) : null;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraProductDiscoveryNavData.project) : null;
        case null:
        default:
            return null;
    }
};

});



parcelRegister("i889l", function(module, exports) {

$parcel$export(module.exports, "isProjectContext", () => $bedad64595855821$export$d46e75e464bf2407);
$parcel$export(module.exports, "isUserContext", () => $bedad64595855821$export$8d1083037a4a6250);
const $bedad64595855821$export$d46e75e464bf2407 = (containerContext)=>containerContext.project !== undefined;
const $bedad64595855821$export$8d1083037a4a6250 = (containerContext)=>containerContext.user !== undefined;

});

parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.subProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("lgxha", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c6fb1eab8416e3f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line jira/react/no-class-components
class $7c6fb1eab8416e3f$var$OpTrigger extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $7c6fb1eab8416e3f$export$2e2bcd8739ae039 = $7c6fb1eab8416e3f$var$OpTrigger;

});

parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "subProductFromProjectType", () => $c2784746c0813b99$export$246e1e2a5c86a633);
const $c2784746c0813b99$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 'business':
            return 'core';
        case 'product_discovery':
        case 'software':
            return 'software';
        case 'service_desk':
            return 'serviceDesk';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            projectType;
            return 'unknown';
    }
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});



parcelRegister("k7z6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c5e4559359622a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");
const $d9c5e4559359622a$var$SanitiseUrl = ({ issueKey: issueKey, location: location, children: children })=>{
    const upperCaseKey = issueKey.toUpperCase();
    if (issueKey && issueKey !== upperCaseKey) {
        const newLocation = {
            pathname: location.pathname.replace(issueKey, upperCaseKey),
            search: '',
            hash: ''
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: newLocation
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
var $d9c5e4559359622a$export$2e2bcd8739ae039 = $d9c5e4559359622a$var$SanitiseUrl;

});

parcelRegister("9ov06", function(module, exports) {

$parcel$export(module.exports, "StartIssueMetric", () => $dd91d22edd3e900e$export$118f8ed53bd8d233);

var $eUqFw = parcelRequire("eUqFw");

var $ifyPR = parcelRequire("ifyPR");

var $45wsB = parcelRequire("45wsB");

var $6QdhH = parcelRequire("6QdhH");
const $dd91d22edd3e900e$var$startPageLoad = (isEmbedMode)=>{
    let metric = (0, $6QdhH.fullPageIssueViewLoad);
    if (isEmbedMode) metric = (0, $6QdhH.embedPageIssueViewLoad);
    metric.startPageLoad();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
};
class $dd91d22edd3e900e$export$118f8ed53bd8d233 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        /**
		 * This needs to be in a constructor (or equivalent) in order to run
		 * synchronously during the inital render of the component. Running
		 * "correctly" according to react in eg. a useEffect block will make
		 * the start time for metrics incorrect.
		 */ $dd91d22edd3e900e$var$startPageLoad(props.isEmbedMode);
    }
    componentDidUpdate(prevProps) {
        if (this.props.issueKey !== prevProps.issueKey) $dd91d22edd3e900e$var$startPageLoad(this.props.isEmbedMode);
    }
    render() {
        return null;
    }
}

});
parcelRegister("6QdhH", function(module, exports) {

$parcel$export(module.exports, "fullPageIssueViewLoad", () => $9748d5bfda160982$export$13db3a415019a2c6);
$parcel$export(module.exports, "embedPageIssueViewLoad", () => $9748d5bfda160982$export$e84becc0aabd0ae9);

var $lEpcX = parcelRequire("lEpcX");

var $g0N0Z = parcelRequire("g0N0Z");
const $9748d5bfda160982$export$13db3a415019a2c6 = (0, $lEpcX.metrics).pageLoad({
    key: 'issue-view',
    until: (0, $g0N0Z.issueViewLoad),
    include: [
        (0, $g0N0Z.issueViewLoad)
    ],
    ssr: {
        doneAsFmp: true
    },
    featureFlags: [
        'opsgenie-consolidation-transitioning-state_d7vm9'
    ]
});
const $9748d5bfda160982$export$e84becc0aabd0ae9 = (0, $lEpcX.metrics).pageLoad({
    key: 'issue-view-embed',
    until: (0, $g0N0Z.issueViewLoad),
    include: [
        (0, $g0N0Z.issueViewLoad)
    ],
    ssr: {
        doneAsFmp: true
    }
});

});
parcelRegister("g0N0Z", function(module, exports) {

$parcel$export(module.exports, "issueViewLoad", () => $95fa1cd4aae1a34f$export$49371c2cc4aaa4f6);
$parcel$export(module.exports, "issueViewOnPageLoad", () => $95fa1cd4aae1a34f$export$2f6837d06b669285);
$parcel$export(module.exports, "embeddedIssueViewLoad", () => $95fa1cd4aae1a34f$export$9d773f01a8da623e);
$parcel$export(module.exports, "epicDropdownOpenInteraction", () => $95fa1cd4aae1a34f$export$8d33579ffe76aa5b);
$parcel$export(module.exports, "epicModalOpenInteraction", () => $95fa1cd4aae1a34f$export$8f0deabe791d5bb9);

var $lEpcX = parcelRequire("lEpcX");

const $95fa1cd4aae1a34f$export$49371c2cc4aaa4f6 = (0, $lEpcX.metrics).custom({
    key: 'issue-view-load',
    virtual: true,
    timings: [
        {
            key: 'legacy-tti-2021',
            startMark: 'metrics_init',
            endMark: $848ef1328a091c81$export$b292c195104c50d3
        },
        {
            key: 'timeBlockedOnBackend',
            startMark: $848ef1328a091c81$export$e64e32643802b552,
            endMark: $848ef1328a091c81$export$e52cc35f872875f7
        }
    ]
});
const $95fa1cd4aae1a34f$export$2f6837d06b669285 = (0, $lEpcX.metrics).custom({
    key: 'issue-view-on-page-load',
    timings: [
        {
            key: 'issue-mounted',
            endMark: $848ef1328a091c81$export$3a9e4a905dec520d
        },
        {
            key: 'latest-lcp',
            endMark: $848ef1328a091c81$export$4d1080224e02ef0b
        }
    ]
});
const $95fa1cd4aae1a34f$export$9d773f01a8da623e = (0, $lEpcX.metrics).custom({
    key: 'embedded-issue-view-load',
    until: $95fa1cd4aae1a34f$export$49371c2cc4aaa4f6,
    include: [
        $95fa1cd4aae1a34f$export$49371c2cc4aaa4f6
    ]
});
const $95fa1cd4aae1a34f$export$1e32b6c8e1e31a3d = (0, $lEpcX.metrics).pageLoad({
    key: 'service-management.queues.issue'
});
const $95fa1cd4aae1a34f$export$4be279014c4d8d39 = (0, $lEpcX.metrics).pageLoad({
    key: 'service-management.reports.issue'
});
const $95fa1cd4aae1a34f$export$8d33579ffe76aa5b = (0, $lEpcX.metrics).interaction({
    key: 'issue-epic-dropdown-menu-open'
});
const $95fa1cd4aae1a34f$export$8f0deabe791d5bb9 = (0, $lEpcX.metrics).interaction({
    key: 'issue-epic-modal-open'
});

});
const $848ef1328a091c81$export$625e4e4c6eb56930 = 'ISSUE_FRAGMENT_READY_MARK';
const $848ef1328a091c81$export$10082883a7f4ea4d = 'ISSUE_START_RENDERING_MARK';
const $848ef1328a091c81$export$62c04f0e896827e3 = 'ISSUE_PREVIEW_RENDERED';
const $848ef1328a091c81$export$5db08809a3f311ed = 'ISSUE_FETCHED_MARK';
const $848ef1328a091c81$export$c21b33196a19ec61 = 'ISSUE_START_FETCHING_DATA';
const $848ef1328a091c81$export$e64e32643802b552 = 'ISSUE_READY_FOR_DATA';
const $848ef1328a091c81$export$e52cc35f872875f7 = 'ISSUE_DATA_AVAILABLE';
const $848ef1328a091c81$export$91b5cb94c32a9b = 'ISSUE_CACHED_CONTENT_LOADED';
const $848ef1328a091c81$export$205779a1d31dbc62 = 'ssr.issue.rendered';
const $848ef1328a091c81$export$bfb91b09e6b87d3c = 'ISSUE_START_GIRA_FETCH';
const $848ef1328a091c81$export$beb8599162403c36 = 'ISSUE_FINISH_GIRA_FETCH';
const $848ef1328a091c81$export$3a9e4a905dec520d = 'ISSUE_MOUNTED';
const $848ef1328a091c81$export$7f7b606f70e669e6 = 'ISSUE_RENDERED';
const $848ef1328a091c81$export$b292c195104c50d3 = 'ISSUE_LEGACY_INTERACTIVE';
const $848ef1328a091c81$export$434b58ebadf14df2 = 'ISSUE_SPA_MARKED_READY_END_OF_CRITICAL_PATH';
const $848ef1328a091c81$export$4d1080224e02ef0b = 'LCP_CANDIDATE';
const $848ef1328a091c81$export$a98a3196940af8fa = 'issueViewCriticalData-agg-suspense';
const $848ef1328a091c81$export$7b35970640b1e1c0 = 'issueViewCriticalData-gira-suspense';
const $848ef1328a091c81$export$1ea0ab50283b82a8 = 'issueViewCriticalData-redux';




parcelRegister("jcBIF", function(module, exports) {

$parcel$export(module.exports, "default", () => $eae268ad4b27fabd$export$2e2bcd8739ae039);

var $hFmdR = parcelRequire("hFmdR");


var $1b94d = parcelRequire("1b94d");
var $eae268ad4b27fabd$export$2e2bcd8739ae039 = (0, $hFmdR.AnalyticsSource)('fullIssue', (0, $41ea3621645e2acc$export$f636b5b56f1d624a))((0, $1b94d.MainIssueView));

});
parcelRegister("hFmdR", function(module, exports) {

$parcel$export(module.exports, "AnalyticsSource", () => $3d95c57ea565c569$export$6890652a1aff7d1c);
$parcel$export(module.exports, "AnalyticsSubject", () => $3d95c57ea565c569$export$ec9f54bd4341ceb);

var $1ngde = parcelRequire("1ngde");
const $3d95c57ea565c569$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, $1ngde.default)({
            source: `${name}${type}`
        })(WrappedComponent);
const $3d95c57ea565c569$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, $1ngde.default)({
            actionSubject: name,
            attributes: attributes
        })(WrappedComponent);

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("1b94d", function(module, exports) {

$parcel$export(module.exports, "MainIssueView", () => $22a69d8438608b8c$export$d716dc1eb304dcb1);

var $eUqFw = parcelRequire("eUqFw");


var $1ybV0 = parcelRequire("1ybV0");

var $jBy23 = parcelRequire("jBy23");


var $gvvf0 = parcelRequire("gvvf0");

var $keOMr = parcelRequire("keOMr");

var $9OxOE = parcelRequire("9OxOE");

var $9zAkH = parcelRequire("9zAkH");

var $9mxRp = parcelRequire("9mxRp");

var $48mPv = parcelRequire("48mPv");
var $d7Wfe = parcelRequire("d7Wfe");
var $bsdZ2 = parcelRequire("bsdZ2");

var $kJlBc = parcelRequire("kJlBc");

var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $dvBSb = parcelRequire("dvBSb");

var $6vrw7 = parcelRequire("6vrw7");

var $78d1w = parcelRequire("78d1w");

var $gd0Sp = parcelRequire("gd0Sp");

var $jK1pm = parcelRequire("jK1pm");

var $1rx5k = parcelRequire("1rx5k");

var $h4S45 = parcelRequire("h4S45");
const $22a69d8438608b8c$var$isEcClientEnabled = ()=>{
    const experiences = (0, $1ybV0.getFeatureFlagValue)('odin.ec.client.integration.issueview', '').split(',');
    return Array.isArray(experiences) && experiences.includes('standalone-issue-view');
};
const $22a69d8438608b8c$export$d716dc1eb304dcb1 = ({ configuration: configuration, rapidViewId: rapidViewId })=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [paramIssueKey] = (0, $kJlBc.usePathParam)('issueKey');
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const [{ isInitialRender: isInitialRender }] = (0, $78d1w.useSpaStateTransition)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let saveIssueMutationToCache;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let onChange = {};
    if ($22a69d8438608b8c$var$isEcClientEnabled()) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        saveIssueMutationToCache = (0, $bsdZ2.useEcClient)().saveIssueMutationToCache;
        onChange = {
            onChange: (event)=>{
                const analyticsEventObj = createAnalyticsEvent({});
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                if (configWithoutAppKey.onChange && event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                configWithoutAppKey.onChange(event);
                const analyticsDataKey = {
                    analyticsEventObj: analyticsEventObj,
                    analyticsMetadata: {
                        scenario: 'standalone-issue-view'
                    }
                };
                if (event?.type === 'FIELD_CHANGED') saveIssueMutationToCache(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                new (0, $48mPv.default)(event?.issueId, (0, $d7Wfe.MutationSource).UPDATE), analyticsDataKey, {
                    errorMsg: 'FAILED_ISSUEVIEW',
                    error: true
                });
            }
        };
    }
    /*
	 * Both useIssueViewRelayRouteResource and useWaitForPrefetchData are backed by route resources which:
	 *  - Are all `isBrowserOnly: true` resources (they never run in SSR)
	 *  - in an initial page load: the network request is kicked off from `src/entry/vendorless-entries/issue-app/index.tsx`
	 *  - in an SPA transition: the network request is kicked off normally via route resources' `getData` (or `getDataLoader`) methods triggered by the router itself when the result of `getKey` changes
	 */ const { queryReference: queryReference } = (0, $dvBSb.useIssueViewRelayRouteResource)({
        suspendWhenLoading: true
    }); // Suspends until an async bundle is fetched, does not block on data returning
    const { loading: loading, promise: promise } = (0, $gvvf0.useWaitForPrefetchData)();
    (0, $9OxOE.blockedOnBackendEntryLog).initialiseBlockedOnBackendStateForUpdatedKey(paramIssueKey);
    if (isInitialRender) {
        (0, $9OxOE.blockedOnBackendEntryLog).markStartBackendBlockingTimestamp((0, $848ef1328a091c81$export$7b35970640b1e1c0)); // before we potentially suspend for gira data, lets mark that we're about to start blocking on the data. Suspense woun't resolve until after usePreloadedQuery in AppProvider though, so don't fire the data-available mark until then
        // IMPORTANT - for initial-load suspend until early-data is loaded, for transitions and preload errors just render
        const waitCondition = loading;
        if (waitCondition) // throw a promise for suspense boundary to catch
        throw promise;
        (0, $9OxOE.blockedOnBackendEntryLog).markEndBackendBlockingTimestamp((0, $848ef1328a091c81$export$7b35970640b1e1c0)); // If we reach this point, either we never suspended (and the blocking duration will be effectively 0) or we did and we will capture the blocking time
    }
    const issueKeyFromRouter = (0, $6vrw7.toIssueKey)(paramIssueKey || '');
    const projectKey = (0, $jBy23.extractProjectKey)(issueKeyFromRouter);
    const issueKey = (0, $6vrw7.toIssueKey)(issueKeyFromRouter);
    let issueId;
    const { baseUrl: baseUrl, locale: locale } = tenantContext;
    const { applicationKey: applicationKey, ...configWithoutAppKey } = configuration || {};
    const onIssueKeyChange = (0, $eUqFw.useCallback)((param)=>{
        push(`${baseUrl}/browse/${param.toIssueKey}`);
    }, [
        push,
        baseUrl
    ]);
    const onIssueDelete = (0, $eUqFw.useCallback)(()=>{
        window.location.assign(`${baseUrl}/browse/${projectKey}`);
    }, [
        projectKey,
        baseUrl
    ]);
    let analyticsSource = (0, $0100842672acae20$export$b19f949fb9713614);
    const isEmbedMode = (0, $keOMr.useIsEmbedMode)();
    if (isEmbedMode) analyticsSource = (0, $0100842672acae20$export$a5132300c5214280);
    const issueViewContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1rx5k.FullPageIssueContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9zAkH.IssueAppWithRouteResources), {
        ...configWithoutAppKey,
        ...onChange,
        issueKey: issueKey,
        issueId: issueId,
        baseUrl: (0, $6vrw7.toBaseUrl)(baseUrl),
        locale: locale,
        analyticsSource: analyticsSource,
        isSpaEnabled: true,
        rapidViewId: rapidViewId,
        history: null,
        onIssueKeyChange: onIssueKeyChange,
        oldViewUrl: (0, $h4S45.getLegacyIssueViewUrl)(),
        onIssueDeleteSuccess: onIssueDelete,
        shouldSetInitialFocus: true,
        shouldShowRootProjectsBreadcrumb: true,
        shouldShowProjectLevelBreadcrumb: true,
        isStickyHeaderOffset: true,
        issueMaxWidth: (0, $9mxRp.getIssueContainerMaxWidth)(),
        preloadedQuery: queryReference
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "issue-view"
    }, issueViewContainer);
};

});
const $0100842672acae20$export$53d41ff2666118e1 = 'agility-backlog';
const $0100842672acae20$export$7552fe2669628499 = 'bitbucket-issue';
const $0100842672acae20$export$41a718da0a8636f4 = 'connect-issue';
const $0100842672acae20$export$cebf0bc8b2ccaf57 = 'core-issue';
const $0100842672acae20$export$82540942fb014b0a = 'business-calendar';
const $0100842672acae20$export$7ca28938a07e0c33 = 'business-list';
const $0100842672acae20$export$f6cf06aaaeb58a54 = 'business-timeline';
const $0100842672acae20$export$b2c0462ff17aa26e = 'business-board';
const $0100842672acae20$export$a607850ebccd28ac = 'business-approvals';
const $0100842672acae20$export$1da6cede3561048f = 'business-files';
const $0100842672acae20$export$b19f949fb9713614 = 'full-issue';
const $0100842672acae20$export$a5132300c5214280 = 'embed-issue';
const $0100842672acae20$export$710114090a811b37 = 'global-issue-navigator-issue';
const $0100842672acae20$export$ce88447986394f2d = 'mobile-issue';
const $0100842672acae20$export$6a90d9196d330040 = 'project-issue-navigator';
const $0100842672acae20$export$2247c9059c171db1 = 'roadmap-issue';
const $0100842672acae20$export$cd16d39c55c569d0 = 'simple-software-board';
const $0100842672acae20$export$f72626bf0d75dfad = 'software-backlog-issue';
const $0100842672acae20$export$778b4609e784cb27 = 'software-deployments-issue';
const $0100842672acae20$export$5b73d694a6048002 = 'version-detail-issue';
const $0100842672acae20$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $0100842672acae20$export$21b5b7189add7861 = 'software-incidents-issue';
const $0100842672acae20$export$9c5d81b901471b27 = 'software-issue';
const $0100842672acae20$export$1735f6ad917dc411 = 'change-calendar';
const $0100842672acae20$export$7063ee6d0035a982 = 'queues-issue-view';
const $0100842672acae20$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $0100842672acae20$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $0100842672acae20$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("jBy23", function(module, exports) {

$parcel$export(module.exports, "extractProjectKey", () => $7901038b5997e3c0$export$f1a2e4721b127828);

var $6vrw7 = parcelRequire("6vrw7");
const $7901038b5997e3c0$export$f1a2e4721b127828 = (issueKey)=>(0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);

});

parcelRegister("gvvf0", function(module, exports) {

$parcel$export(module.exports, "useWaitForPrefetchData", () => $d11c17118bea55af$export$9fd9d028c4285a9c);

var $3HCkE = parcelRequire("3HCkE");

var $iudJZ = parcelRequire("iudJZ");

var $4aNa2 = parcelRequire("4aNa2");

var $go191 = parcelRequire("go191");
const $d11c17118bea55af$export$9fd9d028c4285a9c = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resources = [
        (0, $3HCkE.useResource)((0, $iudJZ.issueGiraDataResource))
    ];
    const loading = resources.some(({ loading: v })=>v);
    const error = resources.map(({ error: v })=>v).find(Boolean) || null;
    const promise = Promise.all(resources.map(({ promise: v })=>v)).then(()=>undefined);
    return {
        loading: loading,
        error: error,
        promise: promise
    };
};

});
parcelRegister("iudJZ", function(module, exports) {

$parcel$export(module.exports, "issueGiraDataResource", () => $10cd2c2c1f752564$export$37badecd288c49f4);

var $3HCkE = parcelRequire("3HCkE");

var $9PXNH = parcelRequire("9PXNH");

var $2skem = parcelRequire("2skem");

var $danRw = parcelRequire("danRw");
const $10cd2c2c1f752564$export$37badecd288c49f4 = (0, $3HCkE.createResource)((0, $2skem.withResourceEarlyData)({
    type: 'ISSUE_GIRA_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $danRw.default)(...args),
    isBrowserOnly: true
}));

});
parcelRegister("9PXNH", function(module, exports) {

$parcel$export(module.exports, "getIssueKey", () => $e9269e5be910ba89$export$4a030f6192bebe03);
const $e9269e5be910ba89$export$4a030f6192bebe03 = (match)=>{
    const fromMatch = match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : null;
    return fromMatch;
};

});

parcelRegister("2skem", function(module, exports) {

$parcel$export(module.exports, "MIN_MAX_AGE", () => $74b0242981e8d241$export$5664a170ac5a9781);
$parcel$export(module.exports, "withResourceEarlyData", () => $74b0242981e8d241$export$22da5fb8c8200986);
const $74b0242981e8d241$export$5664a170ac5a9781 = 5000;
const $74b0242981e8d241$export$22da5fb8c8200986 = ({ type: type, getData: next, getDataLoader: getDataLoader, ...rest })=>{
    const getData = (...args)=>{
        performance.mark(`issueViewEarlyScripts:${type}:withResourceEarlyData:called`);
        if (type in window) {
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const promise = window[type];
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            delete window[type];
            getDataLoader && promise.then(getDataLoader);
            return promise;
        }
        if (getDataLoader) return getDataLoader().then(({ default: getDataPromise })=>getDataPromise(...args));
        return next && next(...args);
    };
    return {
        ...rest,
        type: type,
        getData: getData
    };
};

});

parcelRegister("danRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $42978606795502c9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $3l0Oz = parcelRequire("3l0Oz");

var $1aPBP = parcelRequire("1aPBP");
var $9PXNH = parcelRequire("9PXNH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42978606795502c9$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const issueKey = (0, $9PXNH.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const { baseUrl: baseUrl } = tenantContext;
        const data = await (0, $3l0Oz.default)(baseUrl, issueKey);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $1aPBP.createResourceError)({
            component: 'spa.view.routes.issue-view.gira.getData',
            message: 'An error was thrown while prefetching issue gira data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("3l0Oz", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc2ad8759ea4740f$export$2e2bcd8739ae039);

var $lEpcX = parcelRequire("lEpcX");

var $jBy23 = parcelRequire("jBy23");

var $gIOVj = parcelRequire("gIOVj");

var $a60Hj = parcelRequire("a60Hj");

var $kXzsJ = parcelRequire("kXzsJ");
const $cc2ad8759ea4740f$var$ISSUE_GIRA_DATA = 'issue-gira-data';
const $cc2ad8759ea4740f$var$timeToFetchIssueGiraDataMetric = (0, $lEpcX.metrics).custom({
    key: $cc2ad8759ea4740f$var$ISSUE_GIRA_DATA
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cc2ad8759ea4740f$export$2e2bcd8739ae039 = async (baseUrl, issueKey)=>{
    const projectKey = (0, $jBy23.extractProjectKey)(issueKey);
    const variables = {
        issueKey: issueKey,
        projectKey: projectKey
    };
    const payload = {
        query: (0, $gIOVj.buildIssueQuery)(),
        variables: variables,
        operationName: (0, $gIOVj.ISSUE_VIEW_INTERACTIVE_QUERY)
    };
    if ((0, $a60Hj.isInSample)()) $cc2ad8759ea4740f$var$timeToFetchIssueGiraDataMetric.start();
    try {
        const response = await (0, $kXzsJ.getClient)(baseUrl).query(payload);
        // Best-effort attempt to provide `issueId` and is not guaranteed
        const issueId = response.data?.viewIssue?.issueId;
        $cc2ad8759ea4740f$var$timeToFetchIssueGiraDataMetric.stop({
            customData: issueId ? {
                issueId: issueId
            } : null
        });
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // Cancel the metric and re-throw the error
        $cc2ad8759ea4740f$var$timeToFetchIssueGiraDataMetric.cancel();
        throw error;
    }
};

});
parcelRegister("gIOVj", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", () => $8fd02e0075f962e8$export$1780a132c0453fee);
$parcel$export(module.exports, "getGiraUrl", () => $8fd02e0075f962e8$export$aefb19023b2eda55);
$parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", () => $8fd02e0075f962e8$export$79eba9bf6dc9960d);
$parcel$export(module.exports, "buildIssueQuery", () => $8fd02e0075f962e8$export$222ae9aca08830f0);
$parcel$export(module.exports, "getGiraRequestOptions", () => $8fd02e0075f962e8$export$e1542dc7ff749de8);
$parcel$export(module.exports, "getContentPanelsQuery", () => (parcelRequire("7IE2L")).getContentPanelsQuery);
$parcel$export(module.exports, "getEcosystemQuery", () => (parcelRequire("gIud4")).getEcosystemQuery);

var $bKxX9 = parcelRequire("bKxX9");

var $k0k8C = parcelRequire("k0k8C");

var $cs6Z7 = parcelRequire("cs6Z7");

var $6wu6G = parcelRequire("6wu6G");

var $h9ZPQ = parcelRequire("h9ZPQ");
var $8b8FO = parcelRequire("8b8FO");
var $iKlzi = parcelRequire("iKlzi");
var $7IE2L = parcelRequire("7IE2L");
var $gIud4 = parcelRequire("gIud4");
var $78jDL = parcelRequire("78jDL");
var $bjRBT = parcelRequire("bjRBT");
var $aEsk2 = parcelRequire("aEsk2");
var $k94eC = parcelRequire("k94eC");
var $9U1Mc = parcelRequire("9U1Mc");
var $1zKic = parcelRequire("1zKic");
var $4825Q = parcelRequire("4825Q");
var $cEBFL = parcelRequire("cEBFL");
const $8fd02e0075f962e8$var$CREATED_ORDER_DESCENDING = '-created';
const $8fd02e0075f962e8$export$1780a132c0453fee = 'issueViewInteractiveQuery';
const $8fd02e0075f962e8$export$aefb19023b2eda55 = (baseUrl, operation)=>`${baseUrl}/rest/gira/1/${(0, $k0k8C.appendOperationQuery)(operation)}`;
const $8fd02e0075f962e8$var$viewIssueQuery = ()=>`
    viewIssue(issueKey: $issueKey) {
        ${(0, $cs6Z7.getIsOldValueRequested)((0, $6wu6G.GIRA_AGG_MIGRATION_ISARCHIVED_FLAG)) ? (0, $78jDL.getIsArchivedQuery)() : ''}
        canCreateSubTask
        ${(0, $6wu6G.isIssueExportControlEnabled)() ? 'canExportIssue' : ''}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $8b8FO.default)({
        maxResults: (0, $cEBFL.NUM_INITIAL_COMMENTS_TO_LOAD),
        startAt: 0,
        orderBy: $8fd02e0075f962e8$var$CREATED_ORDER_DESCENDING,
        commentAmount: Math.floor((0, $cEBFL.NUM_INITIAL_COMMENTS_TO_LOAD))
    })}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $4825Q.default)({
        startAt: 0,
        worklogAmount: Math.floor((0, $cEBFL.NUM_INITIAL_WORKLOGS_TO_LOAD))
    })}
        ${(0, $gIud4.getEcosystemQuery)()}
        ${(0, $7IE2L.getContentPanelsQuery)()}
        ${(0, $bKxX9.ff)('issue-view-remove-glancesfield-from-query_fyj0g') ? (0, $gIud4.getLegacyRightWebPanelsQuery)() : (0, $gIud4.getGlancesQuery)()}
		${// only fetch dead glancesField if it's already removed (using legacyRightWebPanels)
    (0, $bKxX9.ff)('issue-view-remove-glancesfield-from-query_fyj0g') && (0, $bKxX9.ff)('implement-dead-glancesfield-query_f71sc') ? (0, $gIud4.getGlancesQuery)() : ''}
        ${(0, $bKxX9.ff)('issue.details.gira-agg-migration-attachments_ecebe') ? 'totalAttachmentsCount' : (0, $h9ZPQ.default)()}
        ${(0, $iKlzi.getContainersByTypeQuery)()}
        ${(0, $1zKic.getRemoteLinksQuery)()}
    }
`;
const $8fd02e0075f962e8$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
const $8fd02e0075f962e8$export$58eaa2ae4a5a410a = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    }
`;
const $8fd02e0075f962e8$export$222ae9aca08830f0 = ()=>`
query ${$8fd02e0075f962e8$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$8fd02e0075f962e8$export$58eaa2ae4a5a410a()}
        ${(0, $aEsk2.default)()}
        ${$8fd02e0075f962e8$var$viewIssueQuery()}
        ${(0, $bjRBT.getJiraSettingsQuery)()}
        ${(0, $k94eC.default)()}
        ${(0, $9U1Mc.default)()}
    }

`;
const $8fd02e0075f962e8$export$e1542dc7ff749de8 = (issueKey, projectKey)=>{
    const payload = {
        operationName: $8fd02e0075f962e8$export$1780a132c0453fee,
        query: $8fd02e0075f962e8$export$222ae9aca08830f0(),
        variables: {
            issueKey: issueKey,
            projectKey: projectKey
        }
    };
    return {
        method: 'POST',
        body: JSON.stringify(payload)
    };
};

});
parcelRegister("k0k8C", function(module, exports) {

$parcel$export(module.exports, "appendOperationQuery", () => $c7bfdca12e254eb8$export$69694c3add0f6058);
const $c7bfdca12e254eb8$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("cs6Z7", function(module, exports) {

$parcel$export(module.exports, "getIsOldValueRequested", () => $712ffcbbea6809c2$export$117d07493a3c1dce);
$parcel$export(module.exports, "getIsNewValueRequested", () => $712ffcbbea6809c2$export$7cdf481ce732d27f);

var $bKxX9 = parcelRequire("bKxX9");
const $712ffcbbea6809c2$var$getConsistencyCheckFeatureFlag = (featureFlagName, defaultValue = 'OLD')=>{
    const possibleValues = [
        'NEW',
        'CHECK_RETURN_NEW',
        'CHECK',
        'OLD'
    ];
    return (0, $bKxX9.getMultivariateFeatureFlag)(featureFlagName, defaultValue, possibleValues);
};
const $712ffcbbea6809c2$export$117d07493a3c1dce = (featureFlagName)=>{
    const featureFlagValue = $712ffcbbea6809c2$var$getConsistencyCheckFeatureFlag(featureFlagName);
    return featureFlagValue === 'OLD' || featureFlagValue === 'CHECK_RETURN_NEW' || featureFlagValue === 'CHECK';
};
const $712ffcbbea6809c2$export$7cdf481ce732d27f = (featureFlagName)=>{
    const featureFlagValue = $712ffcbbea6809c2$var$getConsistencyCheckFeatureFlag(featureFlagName);
    return featureFlagValue === 'NEW' || featureFlagValue === 'CHECK_RETURN_NEW' || featureFlagValue === 'CHECK';
};

});

parcelRegister("6wu6G", function(module, exports) {

$parcel$export(module.exports, "isOutsiderCommentFFEnabled", () => $54a10774de0b57ab$export$9b34ffa85a930ecd);
$parcel$export(module.exports, "isParentInIssueViewEnabled", () => $54a10774de0b57ab$export$9c7fa56ed1fa2e15);
$parcel$export(module.exports, "isJsmTimelineEnabled", () => $54a10774de0b57ab$export$575e1bf822db15b5);
$parcel$export(module.exports, "GIRA_AGG_MIGRATION_ISARCHIVED_FLAG", () => $54a10774de0b57ab$export$f53cbe8a5052e3e0);
$parcel$export(module.exports, "isIssueExportControlEnabled", () => $54a10774de0b57ab$export$e92cc7310d059d3e);

var $bKxX9 = parcelRequire("bKxX9");
const $54a10774de0b57ab$export$9b34ffa85a930ecd = ()=>(0, $bKxX9.ff)('display-outsider-comment-field_4x7u7', false);
const $54a10774de0b57ab$export$9c7fa56ed1fa2e15 = ()=>(0, $bKxX9.ff)('parent-field-in-issue-view_x4zn4', false);
const $54a10774de0b57ab$export$575e1bf822db15b5 = ()=>(0, $bKxX9.ff)('jsm-timelines-phase-2_70gja', false);
const $54a10774de0b57ab$export$f53cbe8a5052e3e0 = 'issue.details.gira-agg-migration-isarchived';
const $54a10774de0b57ab$export$e92cc7310d059d3e = ()=>(0, $bKxX9.ff)('dlp-gordian-enabled', false); // </gordian>

});

parcelRegister("h9ZPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c28c20ef01249d5c$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $c28c20ef01249d5c$export$2e2bcd8739ae039 = ()=>`attachments(orderDirection: DESC, orderField: CREATED, maxResults: 12) {
        nodes {
          id
          filename
          mimetype
          mediaApiFileId
          createdDate
          filesize
          parentName
          author {
              accountId
          }
          parentId
          hasRestrictedParent
        }
        totalCount
        deletableCount
      }
`;

});

parcelRegister("8b8FO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b9fb32e2d7fc8e2$export$2e2bcd8739ae039);

var $8c9rb = parcelRequire("8c9rb");

var $6wu6G = parcelRequire("6wu6G");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7b9fb32e2d7fc8e2$export$2e2bcd8739ae039 = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount })=>{
    const commentPermalinkId = (0, $8c9rb.getPermalinkId)((0, $8c9rb.COMMENTS));
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
    const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
    const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    const jiraCommentVisibility = ` jiraCommentVisibility {
    __typename
    ...on JiraRoleVisibility {
      name
    }
    ...on JiraGroupVisibility {
      group {
        groupId
        name
      }
    }
  }`;
    const passOutsiderComment = (0, $6wu6G.isOutsiderCommentFFEnabled)();
    return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                ${jiraCommentVisibility}
                created
                updated
                jsdPublic
                bodyAdf
                ${passOutsiderComment ? 'jsdAuthorCanSeeRequest' : ''}
                ${(0, $6wu6G.isJsmTimelineEnabled)() ? 'eventOccurredAt' : ''}
                ${(0, $6wu6G.isJsmTimelineEnabled)() ? 'jsdIncidentActivityViewHidden' : ''}
            }
            totalCount
            startIndex
        }
    `;
};

});
parcelRegister("8c9rb", function(module, exports) {

$parcel$export(module.exports, "COMMENTS", () => $227761ce6e538457$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $227761ce6e538457$export$df36fc05622c402);
$parcel$export(module.exports, "getPermalinkId", () => $227761ce6e538457$export$bf42dbba4c31080e);
const $227761ce6e538457$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};
const $227761ce6e538457$export$4cab9dfa8fc858f4 = 'COMMENTS';
const $227761ce6e538457$export$df36fc05622c402 = 'WORKLOG';
const $227761ce6e538457$var$getAllUrlParams = ()=>{
    // get query string from  window
    let queryString = window.location.search.slice(1);
    // we'll store the parameters here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const arr = queryString.split('&');
        for(let i = 0; i < arr.length; i += 1){
            // separate the keys and the values
            const a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            const paramName = a[0];
            const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
            obj[paramName] = paramValue;
        }
    }
    return obj;
};
const $227761ce6e538457$export$bf42dbba4c31080e = (targetPermalinkType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    if (!$227761ce6e538457$export$b18d061fc042df1a[targetPermalinkType]) return null;
    const urlParams = $227761ce6e538457$var$getAllUrlParams();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    return urlParams[$227761ce6e538457$export$b18d061fc042df1a[targetPermalinkType]];
};

});


parcelRegister("iKlzi", function(module, exports) {

$parcel$export(module.exports, "getContainersByTypeQuery", () => $f3b1ff3f54778e3d$export$63131b2831854cc);
const $f3b1ff3f54778e3d$export$63131b2831854cc = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;

});

parcelRegister("7IE2L", function(module, exports) {

$parcel$export(module.exports, "getContentPanelsQuery", () => $431a6f81d3096fcd$export$e6f14eac549b679d);
const $431a6f81d3096fcd$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
const $431a6f81d3096fcd$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$431a6f81d3096fcd$var$getContentPanelNode()}
            }
        }
    }
`;
const $431a6f81d3096fcd$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$431a6f81d3096fcd$var$getContentPanelNode()}
            }
        }
    }
`;
const $431a6f81d3096fcd$export$e6f14eac549b679d = ()=>`
    ${$431a6f81d3096fcd$var$getContentPanelsConnectionQuery()}
    ${$431a6f81d3096fcd$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;

});

parcelRegister("gIud4", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $7b5055fce2a30c91$export$edefef8c65e08bd2);
$parcel$export(module.exports, "getGlancesQuery", () => $7b5055fce2a30c91$export$ca7e7bf9f1b931a2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $7b5055fce2a30c91$export$92c9a3dc7076af51);

var $bKxX9 = parcelRequire("bKxX9");
const $7b5055fce2a30c91$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
const $7b5055fce2a30c91$export$edefef8c65e08bd2 = ()=>`
    ecosystem {
      ${!(0, $bKxX9.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? `
      operations {
        name
        url: href
        icon {
          url
        }
        tooltip
        styleClass
      }` : ''}
      ${!(0, $bKxX9.ff)('issue-view-remove-activitypanels-from-critical-fetch_43ozj') ? `
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }    
    ` : ''}
      ${!(0, $bKxX9.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on') ? `
      backgroundScripts {
        iframe {
          addonKey
          moduleKey
          options
        }
        shouldReloadOnRefresh
      }` : ''}
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${$7b5055fce2a30c91$var$getForgeQuery()}
    }
`;
const $7b5055fce2a30c91$export$ca7e7bf9f1b931a2 = ()=>`
        glancesField {
          fieldKey
          value {
            name
            status
            iframe {
              addonKey
              moduleKey
              options
            }
            icon {
              url
            }
            content
            type
          }
        }
      `;
const $7b5055fce2a30c91$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;

});

parcelRegister("78jDL", function(module, exports) {

$parcel$export(module.exports, "getIsArchivedQuery", () => $70934e0e589cd253$export$2b9ee7163e124831);
const $70934e0e589cd253$export$2b9ee7163e124831 = ()=>'isArchived';

});

parcelRegister("bjRBT", function(module, exports) {

$parcel$export(module.exports, "getJiraSettingsQuery", () => $fc5601890f738e54$export$191f50c0f86b85ec);
const $fc5601890f738e54$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
const $fc5601890f738e54$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
const $fc5601890f738e54$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;

});

parcelRegister("aEsk2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad384184792593f0$export$2e2bcd8739ae039);

var $hCNRu = parcelRequire("hCNRu");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad384184792593f0$export$2e2bcd8739ae039 = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, $hCNRu.getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;

});
parcelRegister("hCNRu", function(module, exports) {

$parcel$export(module.exports, "getMaxTokenLength", () => $64be2f4b2ff25f7a$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $64be2f4b2ff25f7a$var$nonIE11MaxTokenLength = 2 ** 16;
const $64be2f4b2ff25f7a$export$e40f2acaf1a50b00 = ()=>$64be2f4b2ff25f7a$var$nonIE11MaxTokenLength;

});


parcelRegister("k94eC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2892695ccbce2fe$export$2e2bcd8739ae039);
// A list of all keys of permissions that this transformer supports.
const $c2892695ccbce2fe$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CLONE_ISSUE'
    ];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c2892695ccbce2fe$export$2e2bcd8739ae039 = ()=>`
    permissions(issueKey:$issueKey, keys:["${$c2892695ccbce2fe$export$9fc40cb6f3529ef().join('","')}"]) {
        key
        havePermission
    }
`;

});

parcelRegister("9U1Mc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4c00732e1b938da$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $a4c00732e1b938da$export$2e2bcd8739ae039 = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;

});

parcelRegister("1zKic", function(module, exports) {

$parcel$export(module.exports, "getRemoteLinksQuery", () => $785a81b5a18b3dbb$export$6bbc6b72b0b57f25);
const $785a81b5a18b3dbb$export$6bbc6b72b0b57f25 = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }            
`;

});

parcelRegister("4825Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a565ae6a7a72917$export$2e2bcd8739ae039);

var $8c9rb = parcelRequire("8c9rb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7a565ae6a7a72917$export$2e2bcd8739ae039 = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount })=>{
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const worklogPermalinkId = (0, $8c9rb.getPermalinkId)((0, $8c9rb.WORKLOG));
    if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
    const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
    const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
    return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
};

});

parcelRegister("cEBFL", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $918a33e666c5e78d$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $918a33e666c5e78d$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $918a33e666c5e78d$export$aeae6fc40846cf9f);

var $7IE2L = parcelRequire("7IE2L");

var $gIud4 = parcelRequire("gIud4");

var $78jDL = parcelRequire("78jDL");


var $h9ZPQ = parcelRequire("h9ZPQ");

var $8b8FO = parcelRequire("8b8FO");

var $4825Q = parcelRequire("4825Q");

var $bjRBT = parcelRequire("bjRBT");

var $aEsk2 = parcelRequire("aEsk2");

var $k94eC = parcelRequire("k94eC");

var $9U1Mc = parcelRequire("9U1Mc");

var $iKlzi = parcelRequire("iKlzi");

var $1zKic = parcelRequire("1zKic");

const $918a33e666c5e78d$export$c46d621c29194aa4 = 5;
const $918a33e666c5e78d$export$304a6c004edb30d8 = '-created';
const $918a33e666c5e78d$export$b2e398ce246f55b3 = 5;
const $918a33e666c5e78d$export$1c36ecc9afd61c73 = '-started';
const $918a33e666c5e78d$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});


parcelRegister("a60Hj", function(module, exports) {

$parcel$export(module.exports, "isInSample", () => $433b34397a9756c8$export$a994c91d08ead5ff);

const $433b34397a9756c8$export$a994c91d08ead5ff = (sampleRate = (0, $3e173c13cba9c734$export$9fc1f2d681a9e609))=>Math.random() <= 1 / sampleRate;

});
/**
 * Sample rates are defined as the inverse.
 * e.g. a sample rate of 100 = 1 in 100 events are sent.
 */ const $3e173c13cba9c734$export$9fc1f2d681a9e609 = 100; // 1%


parcelRegister("kXzsJ", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $04aa819d4030995f$export$6bb76d6eba7e258c);

var $2OdyW = parcelRequire("2OdyW");

var $gIOVj = parcelRequire("gIOVj");
const $04aa819d4030995f$var$makeFetchClient = (baseUrl)=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $2OdyW.default)((0, $gIOVj.getGiraUrl)(baseUrl, operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            })
    });
let $04aa819d4030995f$var$client;
const $04aa819d4030995f$export$6bb76d6eba7e258c = (baseUrl)=>{
    if (!$04aa819d4030995f$var$client) $04aa819d4030995f$var$client = $04aa819d4030995f$var$makeFetchClient(baseUrl);
    return $04aa819d4030995f$var$client;
};

});


parcelRegister("1aPBP", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $ab2f50dfea4673ae$export$13487d18466bc8a5);

var $gUUjF = parcelRequire("gUUjF");
class $ab2f50dfea4673ae$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $ab2f50dfea4673ae$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $ab2f50dfea4673ae$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});



parcelRegister("4aNa2", function(module, exports) {

$parcel$export(module.exports, "useLazyLoadingResourceManager", () => $3571fdf0be318de1$export$106915b4fed31d8e);

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $1Shgg = parcelRequire("1Shgg");
var $3l0Oz = parcelRequire("3l0Oz");
var $lwu0A = parcelRequire("lwu0A");

var $dWLk9 = parcelRequire("dWLk9");

var $f4Jgp = parcelRequire("f4Jgp");

var $go191 = parcelRequire("go191");
const $3571fdf0be318de1$export$106915b4fed31d8e = (issueKey)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const onIssueKeyChange = ({ prefetchedResourceManager: prefetchedResourceManager })=>{
        const getCachedGiraDataPromise = ()=>{
            const giraPromise = (0, $go191.getCacheEntry)(issueKey);
            if (giraPromise) return giraPromise;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $3l0Oz.default)('', issueKey);
        };
        const giraPromise = (0, $1ybV0.ff)('jwm.preload-issue-view-critical-data') ? getCachedGiraDataPromise() : (0, $3l0Oz.default)('', issueKey);
        prefetchedResourceManager.setGiraPromise(giraPromise);
        const aggPromise = (0, $1Shgg.default)(issueKey, cloudId, environment);
        prefetchedResourceManager.setAggPromise(aggPromise);
        if ((0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w')) {
            const giraNonCriticalPromise = (0, $lwu0A.fetchIssueGiraNonCriticalData)(issueKey);
            prefetchedResourceManager.setGiraNonCriticalPromise(giraNonCriticalPromise);
        }
    };
    return (0, $f4Jgp.useSelfClearingPrefetchedResourceManager)(issueKey, onIssueKeyChange);
};

});
parcelRegister("1Shgg", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b656283bfe7be2c$export$2e2bcd8739ae039);
/* The relay/unused-fields rule is disabled as this file is only responsible for fetching from AGG.
 * When we decompose this query and move to Relay fragments this will be removed.
 */ 
var $iWLL0 = parcelRequire("iWLL0");

var $lEpcX = parcelRequire("lEpcX");

var $jBy23 = parcelRequire("jBy23");
var $9CSL7 = parcelRequire("9CSL7");

var $2mP8r = parcelRequire("2mP8r");

var $a60Hj = parcelRequire("a60Hj");

var $15ZJO = parcelRequire("15ZJO");

var $5udmX = parcelRequire("5udmX");
const $0b656283bfe7be2c$var$ISSUE_AGG_DATA = 'issue-agg-data';
const $0b656283bfe7be2c$export$dd71b5ce8587d263 = (0, $lEpcX.metrics).custom({
    key: $0b656283bfe7be2c$var$ISSUE_AGG_DATA
});
const $0b656283bfe7be2c$export$fa9f856ee3665118 = (key)=>{
    const errors = (0, $15ZJO.stopCaptureGraphQlErrors)(key).filter((errorWrapper)=>errorWrapper.meta.operationName === (0, $9CSL7.ISSUE_AGG_OPERATION_NAME)).flatMap((errorWrapper)=>errorWrapper.errors);
    return errors;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0b656283bfe7be2c$export$2e2bcd8739ae039 = async (issueKey, cloudId, environment)=>{
    if ((0, $a60Hj.isInSample)()) $0b656283bfe7be2c$export$dd71b5ce8587d263.start();
    // ConcreteRequest has params, but ReaderFragment doesn't
    const operationName = 'params' in (0, $9CSL7.issueAggDataQueryGraphqlTag) ? (0, $9CSL7.issueAggDataQueryGraphqlTag).params.name : '';
    (0, $5udmX.startCapturingTraceIds)(operationName);
    const id = (0, $15ZJO.startCaptureGraphQlErrors)();
    const projectKey = (0, $jBy23.extractProjectKey)(issueKey);
    const data = await (0, $iWLL0.fetchQuery)(environment, (0, $9CSL7.issueAggDataQueryGraphqlTag), {
        cloudId: cloudId,
        issueKey: issueKey,
        projectKey: projectKey,
        ...(0, $2mP8r.getMainIssueViewAggQueryFeatureFlagVariables)()
    }).toPromise().catch((error)=>{
        // Cancel the metric and re-throw the error
        $0b656283bfe7be2c$export$dd71b5ce8587d263.cancel();
        throw error;
    });
    const errors = $0b656283bfe7be2c$export$fa9f856ee3665118(id);
    const traceId = (0, $5udmX.getTraceIds)(operationName)[0] ?? '';
    (0, $5udmX.stopCapturingTraceIds)(operationName);
    // Best-effort attempt to provide `issueId` and is not guaranteed
    const issueId = data?.jira.issueByKey?.issueId;
    $0b656283bfe7be2c$export$dd71b5ce8587d263.stop({
        customData: issueId ? {
            issueId: issueId
        } : null
    });
    return {
        data: data,
        errors: errors,
        traceId: traceId
    };
};

});
parcelRegister("9CSL7", function(module, exports) {

$parcel$export(module.exports, "issueAggDataQueryGraphqlTag", () => $316d7377a3d73c5a$export$243f19ca16de2a73);
$parcel$export(module.exports, "ISSUE_AGG_OPERATION_NAME", () => $316d7377a3d73c5a$export$ed901bd7b6900e98);
$parcel$export(module.exports, "issueAggQuery", () => (parcelRequire("lT4yi")).default);

var $lT4yi = parcelRequire("lT4yi");

var $lT4yi = parcelRequire("lT4yi");

var $jBy23 = parcelRequire("jBy23");

var $2mP8r = parcelRequire("2mP8r");
const $316d7377a3d73c5a$export$243f19ca16de2a73 = (0, $lT4yi.default);
const $316d7377a3d73c5a$export$ed901bd7b6900e98 = (0, $lT4yi.default).params.name;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$316d7377a3d73c5a$export$2e2bcd8739ae039 = (issueKey, cloudId)=>{
    const projectKey = (0, $jBy23.extractProjectKey)(issueKey);
    return {
        operationName: $316d7377a3d73c5a$export$ed901bd7b6900e98,
        query: (0, $lT4yi.default).params.text,
        variables: {
            cloudId: cloudId,
            issueKey: issueKey,
            projectKey: projectKey,
            ...(0, $2mP8r.getMainIssueViewAggQueryFeatureFlagVariables)()
        }
    };
};

});
parcelRegister("lT4yi", function(module, exports) {

$parcel$export(module.exports, "default", () => $04e695b9f5fc0bb0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<892dd1126f9c375a140a6ffc63d86885>>
 * @relayHash 8fecacabe46771ea2cc96b3cc62f9c72
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5c935b5b49b17fbea11e10a5708bd3178ec8ad8332a715ad2614caa6c7b18df

var $cNy9K = parcelRequire("cNy9K");
const $04e695b9f5fc0bb0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "giraAGGMigrationAttachmentsFlag"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "giraAGGMigrationIsArchivedFlag"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isCompassComponentsEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRelayReleaseVersionFieldIssueViewIntegrationEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueViewRelayCascadingSelectFlag"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueViewRelayGoalsFlag"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jsmProductsEntitlementsM2Flag"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "parentInIssueViewFlag"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = {
        "args": v12 /*: any*/ ,
        "kind": "ScalarField",
        "name": "childIssuesLimit"
    }, v14 = {
        "kind": "ScalarField",
        "name": "epicLinkFieldKey"
    }, v15 = {
        "args": v12 /*: any*/ ,
        "kind": "ScalarField",
        "name": "isSubtasksEnabled"
    }, v16 = {
        "args": v12 /*: any*/ ,
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "globalTimeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isJiraConfiguredTimeTrackingEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v17 = {
        "args": v12 /*: any*/ ,
        "concreteType": "JiraUserPreferences",
        "kind": "LinkedField",
        "name": "userPreferences",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isIssueViewAttachmentReferenceFlagDismissed"
            },
            {
                "kind": "ScalarField",
                "name": "isIssueViewChildIssuesLimitBestPracticeFlagDismissed"
            },
            {
                "kind": "ScalarField",
                "name": "isIssueViewHideDoneChildIssuesFilterEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "isIssueViewPinnedFieldsBannerDismissed"
            },
            {
                "kind": "ScalarField",
                "name": "issueViewActivityFeedSortOrder"
            },
            {
                "kind": "ScalarField",
                "name": "issueViewAttachmentPanelViewMode"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "projectKey",
                        "variableName": "projectKey"
                    }
                ],
                "kind": "ScalarField",
                "name": "issueViewPinnedFields"
            },
            {
                "kind": "ScalarField",
                "name": "issueViewPinnedFieldsBannerLastInteracted"
            },
            {
                "kind": "ScalarField",
                "name": "issueViewSidebarResizeRatio"
            },
            {
                "kind": "ScalarField",
                "name": "issueViewTimestampDisplayMode"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "linkTypeId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "inwards"
    }, v20 = {
        "kind": "ScalarField",
        "name": "outwards"
    }, v21 = [
        v11 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v22 = {
        "kind": "ScalarField",
        "name": "screenId"
    }, v23 = {
        "kind": "ScalarField",
        "name": "errorRetrievingData"
    }, v24 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v25 = {
        "kind": "ScalarField",
        "name": "key"
    }, v26 = {
        "kind": "ScalarField",
        "name": "level"
    }, v27 = {
        "kind": "ScalarField",
        "name": "name"
    }, v28 = {
        "kind": "ScalarField",
        "name": "id"
    }, v29 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "description"
    }, v31 = {
        "kind": "ScalarField",
        "name": "xsmall"
    }, v32 = {
        "kind": "ScalarField",
        "name": "small"
    }, v33 = {
        "kind": "ScalarField",
        "name": "medium"
    }, v34 = {
        "kind": "ScalarField",
        "name": "large"
    }, v35 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v36 = {
        "kind": "ScalarField",
        "name": "colorKey"
    }, v37 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            v36 /*: any*/ 
        ]
    }, v38 = {
        "kind": "ScalarField",
        "name": "guidelines"
    }, v39 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ]
    }, v40 = {
        "kind": "ScalarField",
        "name": "isEditableInIssueView"
    }, v41 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldConfiguration",
        "abstractKey": "__isJiraIssueFieldConfiguration"
    }, v42 = {
        "kind": "InlineFragment",
        "selections": [
            v40 /*: any*/ ,
            v41 /*: any*/ ,
            v28 /*: any*/ 
        ],
        "type": "JiraIssueField",
        "abstractKey": "__isJiraIssueField"
    }, v43 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v44 = {
        "kind": "ScalarField",
        "name": "type"
    }, v45 = {
        "kind": "ScalarField",
        "name": "serviceId"
    }, v46 = {
        "kind": "ScalarField",
        "name": "searchUrl"
    }, v47 = {
        "kind": "ScalarField",
        "name": "value"
    }, v48 = {
        "concreteType": "JiraAssetConnection",
        "kind": "LinkedField",
        "name": "selectedAssetsConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraAssetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraAsset",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "appKey"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "originId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "serializedOrigin"
                            },
                            v47 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v49 = {
        "kind": "ScalarField",
        "name": "isInsightAvailable"
    }, v50 = {
        "kind": "ScalarField",
        "name": "wasInsightRequestSuccessful"
    }, v51 = [
        {
            "concreteType": "JiraCmdbConfigAttributeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "node"
                }
            ]
        }
    ], v52 = {
        "kind": "ScalarField",
        "name": "objectSchemaId"
    }, v53 = {
        "concreteType": "JiraCmdbFieldConfig",
        "kind": "LinkedField",
        "name": "cmdbFieldConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraCmdbConfigAttributeConnection",
                "kind": "LinkedField",
                "name": "attributesDisplayedOnIssue",
                "plural": false,
                "selections": v51 /*: any*/ 
            },
            {
                "concreteType": "JiraCmdbConfigAttributeConnection",
                "kind": "LinkedField",
                "name": "attributesIncludedInAutoCompleteSearch",
                "plural": false,
                "selections": v51 /*: any*/ 
            },
            v52 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "multiple"
            }
        ]
    }, v54 = {
        "kind": "ScalarField",
        "name": "label"
    }, v55 = {
        "kind": "ScalarField",
        "name": "objectGlobalId"
    }, v56 = {
        "kind": "ScalarField",
        "name": "objectId"
    }, v57 = {
        "kind": "ScalarField",
        "name": "objectKey"
    }, v58 = {
        "kind": "ScalarField",
        "name": "workspaceId"
    }, v59 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v60 = {
        "concreteType": "JiraCmdbMediaClientConfig",
        "kind": "LinkedField",
        "name": "mediaClientConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "clientId"
            },
            {
                "kind": "ScalarField",
                "name": "fileId"
            },
            {
                "kind": "ScalarField",
                "name": "issuer"
            },
            {
                "kind": "ScalarField",
                "name": "mediaBaseUrl"
            },
            {
                "kind": "ScalarField",
                "name": "mediaJwtToken"
            }
        ]
    }, v61 = {
        "kind": "ScalarField",
        "name": "url48"
    }, v62 = {
        "kind": "ScalarField",
        "name": "objectTypeId"
    }, v63 = {
        "concreteType": "JiraCmdbIcon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            v27 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "url16"
            },
            v61 /*: any*/ 
        ]
    }, v64 = {
        "kind": "ScalarField",
        "name": "attributeId"
    }, v65 = {
        "kind": "ScalarField",
        "name": "objectTypeAttributeId"
    }, v66 = [
        v28 /*: any*/ ,
        v27 /*: any*/ 
    ], v67 = {
        "concreteType": "JiraCmdbObjectTypeAttribute",
        "kind": "LinkedField",
        "name": "objectTypeAttribute",
        "plural": false,
        "selections": [
            v54 /*: any*/ ,
            v27 /*: any*/ ,
            {
                "concreteType": "JiraCmdbDefaultType",
                "kind": "LinkedField",
                "name": "defaultType",
                "plural": false,
                "selections": v66 /*: any*/ 
            },
            v44 /*: any*/ 
        ]
    }, v68 = {
        "kind": "ScalarField",
        "name": "displayValue"
    }, v69 = {
        "kind": "ScalarField",
        "name": "searchValue"
    }, v70 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v71 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v72 = {
        "concreteType": "JiraCmdbStatusType",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "category"
            },
            v28 /*: any*/ ,
            v27 /*: any*/ 
        ]
    }, v73 = [
        v27 /*: any*/ 
    ], v74 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            v27 /*: any*/ ,
            v25 /*: any*/ ,
            {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    v34 /*: any*/ 
                ]
            }
        ]
    }, v75 = {
        "kind": "ScalarField",
        "name": "url"
    }, v76 = {
        "concreteType": "JiraCmdbBitbucketRepository",
        "kind": "LinkedField",
        "name": "bitbucketRepo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "uuid"
            },
            v27 /*: any*/ ,
            v75 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "avatarUrl"
            }
        ]
    }, v77 = {
        "concreteType": "JiraOpsgenieTeam",
        "kind": "LinkedField",
        "name": "opsgenieTeam",
        "plural": false,
        "selections": [
            v27 /*: any*/ ,
            v28 /*: any*/ ,
            v75 /*: any*/ 
        ]
    }, v78 = {
        "concreteType": "JiraCmdbAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            v60 /*: any*/ ,
            v61 /*: any*/ 
        ]
    }, v79 = {
        "concreteType": "JiraCmdbObject",
        "kind": "LinkedField",
        "name": "referencedObject",
        "plural": false,
        "selections": [
            v55 /*: any*/ ,
            v58 /*: any*/ ,
            v57 /*: any*/ ,
            v54 /*: any*/ ,
            v78 /*: any*/ ,
            v56 /*: any*/ 
        ]
    }, v80 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v81 = {
        "kind": "ScalarField",
        "name": "isDisabled"
    }, v82 = [
        v28 /*: any*/ ,
        v80 /*: any*/ ,
        v47 /*: any*/ ,
        v81 /*: any*/ 
    ], v83 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "parentOptionValue",
        "plural": false,
        "selections": v82 /*: any*/ 
    }, v84 = {
        "concreteType": "JiraCascadingOption",
        "kind": "LinkedField",
        "name": "cascadingOption",
        "plural": false,
        "selections": [
            v83 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "childOptionValue",
                "plural": false,
                "selections": v82 /*: any*/ 
            }
        ]
    }, v85 = {
        "condition": "issueViewRelayCascadingSelectFlag",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "concreteType": "JiraCascadingOptionsConnection",
                "kind": "LinkedField",
                "name": "cascadingOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCascadingOptionsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCascadingOptions",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v83 /*: any*/ ,
                                    {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "childOptionValues",
                                        "plural": true,
                                        "selections": v82 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v86 = [
        {
            "concreteType": "JiraOptionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraOption",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": v82 /*: any*/ 
                }
            ]
        }
    ], v87 = {
        "concreteType": "JiraOptionConnection",
        "kind": "LinkedField",
        "name": "selectedOptions",
        "plural": false,
        "selections": v86 /*: any*/ 
    }, v88 = {
        "alias": "checkboxesFieldOptions",
        "concreteType": "JiraOptionConnection",
        "kind": "LinkedField",
        "name": "fieldOptions",
        "plural": false,
        "selections": v86 /*: any*/ 
    }, v89 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            v36 /*: any*/ 
        ]
    }, v90 = [
        {
            "concreteType": "JiraComponentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraComponent",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v28 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "componentId"
                        },
                        v27 /*: any*/ ,
                        v30 /*: any*/ ,
                        {
                            "condition": "isCompassComponentsEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "metadata"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v91 = {
        "concreteType": "JiraComponentConnection",
        "kind": "LinkedField",
        "name": "selectedComponentsConnection",
        "plural": false,
        "selections": v90 /*: any*/ 
    }, v92 = {
        "concreteType": "JiraComponentConnection",
        "kind": "LinkedField",
        "name": "components",
        "plural": false,
        "selections": v90 /*: any*/ 
    }, v93 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v94 = [
        v42 /*: any*/ ,
        v43 /*: any*/ ,
        v27 /*: any*/ ,
        v44 /*: any*/ ,
        v30 /*: any*/ ,
        v93 /*: any*/ 
    ], v95 = {
        "alias": "connectMultiSelectFieldOptions",
        "concreteType": "JiraOptionConnection",
        "kind": "LinkedField",
        "name": "fieldOptions",
        "plural": false,
        "selections": v86 /*: any*/ 
    }, v96 = {
        "kind": "ScalarField",
        "name": "number"
    }, v97 = {
        "concreteType": "JiraRichText",
        "kind": "LinkedField",
        "name": "richText",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "plainText"
            },
            {
                "concreteType": "JiraADF",
                "kind": "LinkedField",
                "name": "adfValue",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "json"
                    }
                ]
            }
        ]
    }, v98 = {
        "kind": "ScalarField",
        "name": "renderer"
    }, v99 = [
        v42 /*: any*/ ,
        v43 /*: any*/ ,
        v27 /*: any*/ ,
        v44 /*: any*/ ,
        v30 /*: any*/ ,
        v97 /*: any*/ ,
        v98 /*: any*/ 
    ], v100 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "fieldOption",
        "plural": false,
        "selections": v82 /*: any*/ 
    }, v101 = {
        "alias": "connectSingleSelectFieldOptions",
        "concreteType": "JiraOptionConnection",
        "kind": "LinkedField",
        "name": "fieldOptions",
        "plural": false,
        "selections": v86 /*: any*/ 
    }, v102 = {
        "kind": "ScalarField",
        "name": "text"
    }, v103 = [
        v42 /*: any*/ ,
        v43 /*: any*/ ,
        v27 /*: any*/ ,
        v44 /*: any*/ ,
        v30 /*: any*/ ,
        v102 /*: any*/ 
    ], v104 = {
        "kind": "ScalarField",
        "name": "date"
    }, v105 = {
        "kind": "ScalarField",
        "name": "color"
    }, v106 = {
        "concreteType": "JiraEpic",
        "kind": "LinkedField",
        "name": "epic",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            v24 /*: any*/ ,
            v27 /*: any*/ ,
            v25 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "summary"
            },
            v105 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "done"
            }
        ]
    }, v107 = {
        "concreteType": "JiraFlag",
        "kind": "LinkedField",
        "name": "flag",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isFlagged"
            }
        ]
    }, v108 = {
        "kind": "ScalarField",
        "name": "groupId"
    }, v109 = [
        v28 /*: any*/ ,
        v108 /*: any*/ ,
        v27 /*: any*/ 
    ], v110 = {
        "concreteType": "JiraGroup",
        "kind": "LinkedField",
        "name": "selectedGroup",
        "plural": false,
        "selections": v109 /*: any*/ 
    }, v111 = {
        "concreteType": "JiraGroupConnection",
        "kind": "LinkedField",
        "name": "selectedGroupsConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraGroupEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": v109 /*: any*/ 
                    }
                ]
            }
        ]
    }, v112 = {
        "kind": "ScalarField",
        "name": "object"
    }, v113 = {
        "concreteType": "JiraLabelConnection",
        "kind": "LinkedField",
        "name": "selectedLabelsConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraLabelEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraLabel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "labelId"
                            },
                            v27 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v114 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v115 = {
        "kind": "ScalarField",
        "name": "email"
    }, v116 = {
        "kind": "ScalarField",
        "name": "zoneinfo"
    }, v117 = {
        "kind": "ScalarField",
        "name": "locale"
    }, v118 = [
        v115 /*: any*/ ,
        v116 /*: any*/ ,
        v117 /*: any*/ 
    ], v119 = {
        "kind": "InlineFragment",
        "selections": v118 /*: any*/ ,
        "type": "AtlassianAccountUser"
    }, v120 = {
        "kind": "InlineFragment",
        "selections": v118 /*: any*/ ,
        "type": "CustomerUser"
    }, v121 = [
        v35 /*: any*/ ,
        v70 /*: any*/ ,
        v114 /*: any*/ ,
        v27 /*: any*/ ,
        v71 /*: any*/ ,
        v119 /*: any*/ ,
        v120 /*: any*/ 
    ], v122 = {
        "concreteType": "JiraUserConnection",
        "kind": "LinkedField",
        "name": "selectedUsersConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": v121 /*: any*/ 
                    }
                ]
            }
        ]
    }, v123 = {
        "concreteType": "JiraRoleConnection",
        "kind": "LinkedField",
        "name": "selectedRolesConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraRoleEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraRole",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v28 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "roleId"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v124 = [
        v42 /*: any*/ ,
        v43 /*: any*/ ,
        v27 /*: any*/ ,
        v44 /*: any*/ ,
        v30 /*: any*/ ,
        v122 /*: any*/ ,
        v46 /*: any*/ 
    ], v125 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v126 = {
        "kind": "ScalarField",
        "name": "status"
    }, v127 = [
        {
            "concreteType": "JiraVersionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v28 /*: any*/ ,
                        v125 /*: any*/ ,
                        v27 /*: any*/ ,
                        v126 /*: any*/ ,
                        v30 /*: any*/ 
                    ]
                }
            ]
        }
    ], v128 = {
        "concreteType": "JiraVersionConnection",
        "kind": "LinkedField",
        "name": "selectedVersionsConnection",
        "plural": false,
        "selections": v127 /*: any*/ 
    }, v129 = {
        "condition": "isRelayReleaseVersionFieldIssueViewIntegrationEnabled",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "alias": "multiPickerVersions",
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "versions",
                "plural": false,
                "selections": v127 /*: any*/ 
            }
        ]
    }, v130 = {
        "kind": "ScalarField",
        "name": "isStoryPointField"
    }, v131 = [
        {
            "kind": "ScalarField",
            "name": "timeInSeconds"
        }
    ], v132 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": v131 /*: any*/ 
    }, v133 = {
        "concreteType": "JiraParentVisibility",
        "kind": "LinkedField",
        "name": "parentVisibility",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasEpicLinkFieldDependency"
            },
            {
                "kind": "ScalarField",
                "name": "canUseParentLinkField"
            }
        ]
    }, v134 = [
        {
            "kind": "Literal",
            "name": "ids",
            "value": [
                "issuetype",
                "project",
                "summary"
            ]
        }
    ], v135 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v136 = {
        "kind": "ScalarField",
        "name": "canSetIssueRestriction"
    }, v137 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v138 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v139 = {
        "concreteType": "JiraSimilarIssues",
        "kind": "LinkedField",
        "name": "similarIssues",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "featureEnabled"
            }
        ]
    }, v140 = {
        "kind": "InlineFragment",
        "selections": [
            v43 /*: any*/ ,
            v27 /*: any*/ ,
            v44 /*: any*/ ,
            v30 /*: any*/ ,
            v102 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v141 = {
        "kind": "ScalarField",
        "name": "isMulti"
    }, v142 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v143 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v144 = {
        "kind": "ScalarField",
        "name": "sequence"
    }, v145 = [
        v142 /*: any*/ ,
        v27 /*: any*/ ,
        v143 /*: any*/ ,
        v144 /*: any*/ ,
        v105 /*: any*/ 
    ], v146 = {
        "concreteType": "JiraProformaForms",
        "kind": "LinkedField",
        "name": "proformaForms",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasProjectForms"
            },
            {
                "kind": "ScalarField",
                "name": "hasIssueForms"
            },
            {
                "kind": "ScalarField",
                "name": "isHarmonisationEnabled"
            }
        ]
    }, v147 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "selectedOption",
        "plural": false,
        "selections": v82 /*: any*/ 
    }, v148 = {
        "alias": "radioSelectFieldOptions",
        "concreteType": "JiraOptionConnection",
        "kind": "LinkedField",
        "name": "fieldOptions",
        "plural": false,
        "selections": v86 /*: any*/ 
    }, v149 = [
        v28 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "resolutionId"
        },
        v27 /*: any*/ 
    ], v150 = {
        "concreteType": "JiraResolution",
        "kind": "LinkedField",
        "name": "resolution",
        "plural": false,
        "selections": v149 /*: any*/ 
    }, v151 = {
        "concreteType": "JiraResolutionConnection",
        "kind": "LinkedField",
        "name": "resolutions",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraResolutionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraResolution",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": v149 /*: any*/ 
                    }
                ]
            }
        ]
    }, v152 = {
        "kind": "ScalarField",
        "name": "securityId"
    }, v153 = [
        v27 /*: any*/ ,
        v152 /*: any*/ ,
        v30 /*: any*/ 
    ], v154 = {
        "kind": "ScalarField",
        "name": "approvalState"
    }, v155 = {
        "kind": "ScalarField",
        "name": "categoryId"
    }, v156 = {
        "concreteType": "JiraServiceManagementApprovalStatus",
        "kind": "LinkedField",
        "name": "approvedStatus",
        "plural": false,
        "selections": [
            v155 /*: any*/ ,
            v27 /*: any*/ 
        ]
    }, v157 = {
        "kind": "ScalarField",
        "name": "jiraRest"
    }, v158 = {
        "kind": "ScalarField",
        "name": "memberCount"
    }, v159 = {
        "kind": "ScalarField",
        "name": "approvedCount"
    }, v160 = [
        v115 /*: any*/ ,
        v116 /*: any*/ 
    ], v161 = {
        "kind": "InlineFragment",
        "selections": v160 /*: any*/ ,
        "type": "AtlassianAccountUser"
    }, v162 = {
        "kind": "InlineFragment",
        "selections": v160 /*: any*/ ,
        "type": "CustomerUser"
    }, v163 = {
        "kind": "ScalarField",
        "name": "approverDecision"
    }, v164 = {
        "kind": "ScalarField",
        "name": "canAnswerApproval"
    }, v165 = {
        "kind": "ScalarField",
        "name": "fieldName"
    }, v166 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v167 = {
        "kind": "ScalarField",
        "name": "finalDecision"
    }, v168 = {
        "kind": "ScalarField",
        "name": "pendingApprovalCount"
    }, v169 = {
        "concreteType": "JiraServiceManagementApprovalStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            v27 /*: any*/ ,
            v155 /*: any*/ 
        ]
    }, v170 = {
        "kind": "ScalarField",
        "name": "completedDate"
    }, v171 = {
        "concreteType": "JiraServiceManagementApprovalStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v27 /*: any*/ ,
            v155 /*: any*/ 
        ]
    }, v172 = {
        "kind": "ScalarField",
        "name": "majorIncident"
    }, v173 = {
        "concreteType": "JiraServiceManagementOrganizationConnection",
        "kind": "LinkedField",
        "name": "selectedOrganizationsConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraServiceManagementOrganizationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraServiceManagementOrganization",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "organizationId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "organizationName"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "domain"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v174 = {
        "concreteType": "JiraServiceManagementFeedback",
        "kind": "LinkedField",
        "name": "feedback",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "rating"
            }
        ]
    }, v175 = [
        {
            "kind": "ScalarField",
            "name": "languageCode"
        },
        {
            "kind": "ScalarField",
            "name": "displayName"
        }
    ], v176 = {
        "concreteType": "JiraServiceManagementLanguage",
        "kind": "LinkedField",
        "name": "language",
        "plural": false,
        "selections": v175 /*: any*/ 
    }, v177 = {
        "concreteType": "JiraServiceManagementLanguage",
        "kind": "LinkedField",
        "name": "languages",
        "plural": true,
        "selections": v175 /*: any*/ 
    }, v178 = [
        v31 /*: any*/ ,
        v32 /*: any*/ ,
        v33 /*: any*/ ,
        v34 /*: any*/ 
    ], v179 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": v178 /*: any*/ 
    }, v180 = {
        "concreteType": "JiraServiceManagementRequestType",
        "kind": "LinkedField",
        "name": "requestType",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "requestTypeId"
            },
            v27 /*: any*/ ,
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v28 /*: any*/ ,
                    v29 /*: any*/ 
                ]
            },
            v179 /*: any*/ 
        ]
    }, v181 = {
        "kind": "ScalarField",
        "name": "canonicalAccountId"
    }, v182 = {
        "kind": "ScalarField",
        "name": "teamId"
    }, v183 = {
        "kind": "InlineFragment",
        "selections": [
            v182 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "teamName"
            }
        ],
        "type": "JiraServiceManagementTeamResponder"
    }, v184 = [
        v116 /*: any*/ ,
        v117 /*: any*/ 
    ], v185 = {
        "kind": "InlineFragment",
        "selections": v184 /*: any*/ ,
        "type": "AtlassianAccountUser"
    }, v186 = {
        "kind": "InlineFragment",
        "selections": v184 /*: any*/ ,
        "type": "CustomerUser"
    }, v187 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v70 /*: any*/ ,
            v114 /*: any*/ ,
            v27 /*: any*/ ,
            v71 /*: any*/ ,
            v185 /*: any*/ ,
            v186 /*: any*/ 
        ]
    }, v188 = {
        "kind": "ScalarField",
        "name": "startDate"
    }, v189 = [
        v28 /*: any*/ ,
        v125 /*: any*/ ,
        v27 /*: any*/ ,
        v143 /*: any*/ ,
        v126 /*: any*/ ,
        v30 /*: any*/ ,
        v188 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "releaseDate"
        }
    ], v190 = {
        "concreteType": "JiraVersion",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": v189 /*: any*/ 
    }, v191 = {
        "alias": "singlePickerVersions",
        "concreteType": "JiraVersionConnection",
        "kind": "LinkedField",
        "name": "versions",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraVersionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraVersion",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": v189 /*: any*/ 
                    }
                ]
            }
        ]
    }, v192 = {
        "kind": "ScalarField",
        "name": "sprintId"
    }, v193 = {
        "kind": "ScalarField",
        "name": "state"
    }, v194 = {
        "kind": "ScalarField",
        "name": "boardName"
    }, v195 = {
        "kind": "ScalarField",
        "name": "endDate"
    }, v196 = {
        "kind": "ScalarField",
        "name": "completionDate"
    }, v197 = {
        "kind": "ScalarField",
        "name": "goal"
    }, v198 = {
        "kind": "ScalarField",
        "name": "statusId"
    }, v199 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v200 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            v199 /*: any*/ 
        ]
    }, v201 = {
        "kind": "ScalarField",
        "name": "isShared"
    }, v202 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            v33 /*: any*/ 
        ]
    }, v203 = {
        "concreteType": "JiraTeamView",
        "kind": "LinkedField",
        "name": "selectedTeam",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jiraSuppliedVisibility"
            },
            {
                "kind": "ScalarField",
                "name": "jiraSuppliedName"
            },
            {
                "kind": "ScalarField",
                "name": "jiraSuppliedId"
            },
            {
                "kind": "ScalarField",
                "name": "jiraSuppliedTeamId"
            },
            {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "jiraSuppliedAvatar",
                "plural": false,
                "selections": v178 /*: any*/ 
            }
        ]
    }, v204 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "remainingEstimate",
        "plural": false,
        "selections": v131 /*: any*/ 
    }, v205 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "timeSpent",
        "plural": false,
        "selections": v131 /*: any*/ 
    }, v206 = {
        "kind": "ScalarField",
        "name": "uri"
    }, v207 = {
        "kind": "ScalarField",
        "name": "count"
    }, v208 = {
        "concreteType": "JiraVote",
        "kind": "LinkedField",
        "name": "vote",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasVoted"
            },
            v207 /*: any*/ 
        ]
    }, v209 = {
        "concreteType": "JiraWatch",
        "kind": "LinkedField",
        "name": "watch",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isWatching"
            },
            v207 /*: any*/ 
        ]
    }, v210 = {
        "concreteType": "JiraServiceManagementProduct",
        "kind": "LinkedField",
        "name": "product",
        "plural": false,
        "selections": v66 /*: any*/ 
    }, v211 = [
        v28 /*: any*/ 
    ], v212 = {
        "kind": "LinkedField",
        "name": "entity",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v211 /*: any*/ ,
                "type": "JiraServiceManagementEntitlementCustomer"
            },
            {
                "kind": "InlineFragment",
                "selections": v211 /*: any*/ ,
                "type": "JiraServiceManagementEntitlementOrganization"
            }
        ]
    }, v213 = {
        "concreteType": "JiraServiceManagementEntitlement",
        "kind": "LinkedField",
        "name": "selectedEntitlement",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            v210 /*: any*/ ,
            {
                "condition": "jsmProductsEntitlementsM2Flag",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v212 /*: any*/ 
                ]
            }
        ]
    }, v214 = {
        "kind": "InlineFragment",
        "selections": [
            v40 /*: any*/ ,
            v41 /*: any*/ 
        ],
        "type": "JiraIssueField",
        "abstractKey": "__isJiraIssueField"
    }, v215 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v216 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v217 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1
            }
        ],
        "concreteType": "JiraGoalConnection",
        "kind": "LinkedField",
        "name": "selectedGoals",
        "plural": false,
        "selections": [
            v216 /*: any*/ ,
            {
                "concreteType": "JiraGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v28 /*: any*/ ,
                            v27 /*: any*/ ,
                            v126 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "selectedGoals(first:1)"
    }, v218 = {
        "condition": "issueViewRelayGoalsFlag",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v217 /*: any*/ 
        ]
    }, v219 = [
        {
            "kind": "Literal",
            "name": "activeProjectsOnly",
            "value": true
        }
    ], v220 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v221 = [
        v35 /*: any*/ ,
        v43 /*: any*/ ,
        v44 /*: any*/ ,
        v96 /*: any*/ ,
        v130 /*: any*/ 
    ], v222 = [
        {
            "kind": "Literal",
            "name": "ids",
            "value": [
                "assignee",
                "created",
                "issuetype",
                "priority",
                "status",
                "summary",
                "timetracking",
                "updated"
            ]
        }
    ], v223 = {
        "kind": "InlineFragment",
        "selections": [
            v43 /*: any*/ ,
            v44 /*: any*/ ,
            v102 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v224 = {
        "kind": "InlineFragment",
        "selections": [
            v43 /*: any*/ ,
            v44 /*: any*/ ,
            v132 /*: any*/ ,
            v204 /*: any*/ ,
            v205 /*: any*/ 
        ],
        "type": "JiraTimeTrackingField"
    }, v225 = {
        "kind": "InlineFragment",
        "selections": [
            v43 /*: any*/ ,
            v44 /*: any*/ ,
            v93 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v226 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "search"
            }
        ],
        "type": "JiraChildIssuesExceedingLimit"
    }, v227 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v228 = {
        "kind": "ScalarField",
        "name": "issueLinkId"
    }, v229 = {
        "kind": "ScalarField",
        "name": "direction"
    }, v230 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v231 = [
        {
            "kind": "Literal",
            "name": "ids",
            "value": [
                "assignee",
                "issuetype",
                "priority",
                "status",
                "summary"
            ]
        }
    ], v232 = {
        "kind": "ScalarField",
        "name": "colorName"
    }, v233 = {
        "kind": "InlineFragment",
        "selections": [
            v43 /*: any*/ ,
            v27 /*: any*/ ,
            v44 /*: any*/ ,
            v102 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v234 = {
        "condition": "giraAGGMigrationIsArchivedFlag",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isArchived"
            }
        ]
    }, v235 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 12
        },
        {
            "kind": "Literal",
            "name": "sortBy",
            "value": {
                "field": "CREATED",
                "order": "DESC"
            }
        }
    ], v236 = {
        "kind": "ScalarField",
        "name": "attachmentId"
    }, v237 = {
        "kind": "ScalarField",
        "name": "fileName"
    }, v238 = {
        "kind": "ScalarField",
        "name": "mimeType"
    }, v239 = {
        "kind": "ScalarField",
        "name": "mediaApiFileId"
    }, v240 = {
        "kind": "ScalarField",
        "name": "created"
    }, v241 = {
        "kind": "ScalarField",
        "name": "fileSize"
    }, v242 = {
        "kind": "ScalarField",
        "name": "parentName"
    }, v243 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v244 = {
        "kind": "ScalarField",
        "name": "hasRestrictedParent"
    }, v245 = [
        v26 /*: any*/ ,
        v27 /*: any*/ 
    ], v246 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": v245 /*: any*/ 
    }, v247 = [
        v28 /*: any*/ ,
        v29 /*: any*/ ,
        v27 /*: any*/ ,
        v30 /*: any*/ ,
        v179 /*: any*/ ,
        v246 /*: any*/ 
    ], v248 = [
        {
            "concreteType": "JiraIssueTypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": v247 /*: any*/ 
                }
            ]
        }
    ], v249 = {
        "kind": "InlineFragment",
        "selections": [
            v30 /*: any*/ 
        ],
        "type": "JiraIssueField",
        "abstractKey": "__isJiraIssueField"
    }, v250 = [
        v47 /*: any*/ ,
        v28 /*: any*/ ,
        v80 /*: any*/ ,
        v81 /*: any*/ 
    ], v251 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v199 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v252 = [
        v35 /*: any*/ ,
        v70 /*: any*/ ,
        v28 /*: any*/ 
    ], v253 = [
        {
            "concreteType": "JiraIssueFieldEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v35 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": v252 /*: any*/ 
                                }
                            ],
                            "type": "JiraSingleSelectUserPickerField"
                        },
                        v28 /*: any*/ 
                    ]
                }
            ]
        }
    ], v254 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            v36 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v255 = {
        "kind": "ScalarField",
        "name": "definition"
    }, v256 = [
        v28 /*: any*/ ,
        v27 /*: any*/ ,
        v254 /*: any*/ ,
        v38 /*: any*/ ,
        v255 /*: any*/ 
    ], v257 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v70 /*: any*/ ,
            v27 /*: any*/ ,
            v71 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v258 = [
        v43 /*: any*/ ,
        v27 /*: any*/ ,
        v44 /*: any*/ ,
        v30 /*: any*/ ,
        v93 /*: any*/ ,
        v214 /*: any*/ 
    ], v259 = [
        v43 /*: any*/ ,
        v27 /*: any*/ ,
        v44 /*: any*/ ,
        v30 /*: any*/ ,
        v97 /*: any*/ ,
        v98 /*: any*/ ,
        v214 /*: any*/ 
    ], v260 = [
        v43 /*: any*/ ,
        v27 /*: any*/ ,
        v44 /*: any*/ ,
        v30 /*: any*/ ,
        v102 /*: any*/ ,
        v214 /*: any*/ 
    ], v261 = [
        v35 /*: any*/ ,
        v70 /*: any*/ ,
        v114 /*: any*/ ,
        v27 /*: any*/ ,
        v71 /*: any*/ ,
        v119 /*: any*/ ,
        v120 /*: any*/ ,
        v28 /*: any*/ 
    ], v262 = {
        "concreteType": "JiraUserConnection",
        "kind": "LinkedField",
        "name": "selectedUsersConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": v261 /*: any*/ 
                    }
                ]
            }
        ]
    }, v263 = {
        "concreteType": "JiraIssueType",
        "kind": "LinkedField",
        "name": "issueType",
        "plural": false,
        "selections": v247 /*: any*/ 
    }, v264 = [
        v43 /*: any*/ ,
        v27 /*: any*/ ,
        v44 /*: any*/ ,
        v30 /*: any*/ ,
        v262 /*: any*/ ,
        v46 /*: any*/ ,
        v214 /*: any*/ 
    ], v265 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v27 /*: any*/ ,
            v135 /*: any*/ ,
            v136 /*: any*/ ,
            v137 /*: any*/ ,
            v138 /*: any*/ ,
            v126 /*: any*/ ,
            {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    v33 /*: any*/ ,
                    v34 /*: any*/ 
                ]
            },
            v139 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v266 = [
        v142 /*: any*/ ,
        v27 /*: any*/ ,
        v143 /*: any*/ ,
        v144 /*: any*/ ,
        v105 /*: any*/ ,
        v28 /*: any*/ 
    ], v267 = [
        v27 /*: any*/ ,
        v152 /*: any*/ ,
        v30 /*: any*/ ,
        v28 /*: any*/ 
    ], v268 = [
        v35 /*: any*/ ,
        v70 /*: any*/ ,
        v114 /*: any*/ ,
        v27 /*: any*/ ,
        v71 /*: any*/ ,
        v161 /*: any*/ ,
        v162 /*: any*/ ,
        v28 /*: any*/ 
    ], v269 = [
        {
            "kind": "LinkedField",
            "name": "approver",
            "plural": false,
            "selections": v268 /*: any*/ 
        },
        v163 /*: any*/ 
    ], v270 = {
        "concreteType": "JiraServiceManagementApproverConnection",
        "kind": "LinkedField",
        "name": "approvers",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraServiceManagementApproverEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraServiceManagementApprover",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": v269 /*: any*/ 
                    }
                ]
            }
        ]
    }, v271 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v70 /*: any*/ ,
            v114 /*: any*/ ,
            v27 /*: any*/ ,
            v71 /*: any*/ ,
            v185 /*: any*/ ,
            v186 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v272 = [
        v35 /*: any*/ ,
        v43 /*: any*/ ,
        v44 /*: any*/ ,
        v96 /*: any*/ ,
        v130 /*: any*/ ,
        v28 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainIssueAggQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ ,
                            v17 /*: any*/ ,
                            {
                                "args": v12 /*: any*/ ,
                                "concreteType": "JiraIssueLinkTypeConnection",
                                "kind": "LinkedField",
                                "name": "issueLinkTypes",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueLinkTypeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueLinkType",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v18 /*: any*/ ,
                                                    v19 /*: any*/ ,
                                                    v20 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": v21 /*: any*/ ,
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issueByKey",
                                "plural": false,
                                "selections": [
                                    v22 /*: any*/ ,
                                    {
                                        "kind": "RequiredField",
                                        "field": v23 /*: any*/ ,
                                        "action": "LOG",
                                        "path": "jira.issueByKey.errorRetrievingData"
                                    },
                                    v24 /*: any*/ ,
                                    v25 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueTypeHierarchyLevel",
                                        "kind": "LinkedField",
                                        "name": "hierarchyLevelAbove",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v26 /*: any*/ ,
                                                "action": "LOG",
                                                "path": "jira.issueByKey.hierarchyLevelAbove.level"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v27 /*: any*/ ,
                                                "action": "LOG",
                                                "path": "jira.issueByKey.hierarchyLevelAbove.name"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraIssueTypeHierarchyLevel",
                                        "kind": "LinkedField",
                                        "name": "hierarchyLevelBelow",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v26 /*: any*/ ,
                                                "action": "LOG",
                                                "path": "jira.issueByKey.hierarchyLevelBelow.level"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v27 /*: any*/ ,
                                                "action": "LOG",
                                                "path": "jira.issueByKey.hierarchyLevelBelow.name"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraIssueTypeConnection",
                                        "kind": "LinkedField",
                                        "name": "issueTypesForHierarchyAbove",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueTypeEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v28 /*: any*/ ,
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v29 /*: any*/ ,
                                                                "action": "LOG",
                                                                "path": "jira.issueByKey.issueTypesForHierarchyAbove.edges.node.issueTypeId"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v27 /*: any*/ ,
                                                                "action": "LOG",
                                                                "path": "jira.issueByKey.issueTypesForHierarchyAbove.edges.node.name"
                                                            },
                                                            v30 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraAvatar",
                                                                "kind": "LinkedField",
                                                                "name": "avatar",
                                                                "plural": false,
                                                                "selections": [
                                                                    v31 /*: any*/ ,
                                                                    v32 /*: any*/ ,
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v33 /*: any*/ ,
                                                                        "action": "LOG",
                                                                        "path": "jira.issueByKey.issueTypesForHierarchyAbove.edges.node.avatar.medium"
                                                                    },
                                                                    v34 /*: any*/ 
                                                                ]
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                    "kind": "LinkedField",
                                                                    "name": "hierarchy",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v26 /*: any*/ ,
                                                                            "action": "LOG",
                                                                            "path": "jira.issueByKey.issueTypesForHierarchyAbove.edges.node.hierarchy.level"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v27 /*: any*/ ,
                                                                            "action": "LOG",
                                                                            "path": "jira.issueByKey.issueTypesForHierarchyAbove.edges.node.hierarchy.name"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "LOG",
                                                                "path": "jira.issueByKey.issueTypesForHierarchyAbove.edges.node.hierarchy"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraIssueTypeConnection",
                                        "kind": "LinkedField",
                                        "name": "issueTypesForHierarchyBelow",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueTypeEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v28 /*: any*/ ,
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v29 /*: any*/ ,
                                                                "action": "LOG",
                                                                "path": "jira.issueByKey.issueTypesForHierarchyBelow.edges.node.issueTypeId"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v27 /*: any*/ ,
                                                                "action": "LOG",
                                                                "path": "jira.issueByKey.issueTypesForHierarchyBelow.edges.node.name"
                                                            },
                                                            v30 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraAvatar",
                                                                "kind": "LinkedField",
                                                                "name": "avatar",
                                                                "plural": false,
                                                                "selections": [
                                                                    v31 /*: any*/ ,
                                                                    v32 /*: any*/ ,
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v33 /*: any*/ ,
                                                                        "action": "LOG",
                                                                        "path": "jira.issueByKey.issueTypesForHierarchyBelow.edges.node.avatar.medium"
                                                                    },
                                                                    v34 /*: any*/ 
                                                                ]
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                    "kind": "LinkedField",
                                                                    "name": "hierarchy",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v26 /*: any*/ ,
                                                                            "action": "LOG",
                                                                            "path": "jira.issueByKey.issueTypesForHierarchyBelow.edges.node.hierarchy.level"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v27 /*: any*/ ,
                                                                            "action": "LOG",
                                                                            "path": "jira.issueByKey.issueTypesForHierarchyBelow.edges.node.hierarchy.name"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "LOG",
                                                                "path": "jira.issueByKey.issueTypesForHierarchyBelow.edges.node.hierarchy"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraIssueTypeConnection",
                                        "kind": "LinkedField",
                                        "name": "issueTypesForHierarchySame",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueTypeEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v28 /*: any*/ ,
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v29 /*: any*/ ,
                                                                "action": "LOG",
                                                                "path": "jira.issueByKey.issueTypesForHierarchySame.edges.node.issueTypeId"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v27 /*: any*/ ,
                                                                "action": "LOG",
                                                                "path": "jira.issueByKey.issueTypesForHierarchySame.edges.node.name"
                                                            },
                                                            v30 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraAvatar",
                                                                "kind": "LinkedField",
                                                                "name": "avatar",
                                                                "plural": false,
                                                                "selections": [
                                                                    v31 /*: any*/ ,
                                                                    v32 /*: any*/ ,
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v33 /*: any*/ ,
                                                                        "action": "LOG",
                                                                        "path": "jira.issueByKey.issueTypesForHierarchySame.edges.node.avatar.medium"
                                                                    },
                                                                    v34 /*: any*/ 
                                                                ]
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                    "kind": "LinkedField",
                                                                    "name": "hierarchy",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v26 /*: any*/ ,
                                                                            "action": "LOG",
                                                                            "path": "jira.issueByKey.issueTypesForHierarchySame.edges.node.hierarchy.level"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v27 /*: any*/ ,
                                                                            "action": "LOG",
                                                                            "path": "jira.issueByKey.issueTypesForHierarchySame.edges.node.hierarchy.name"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "LOG",
                                                                "path": "jira.issueByKey.issueTypesForHierarchySame.edges.node.hierarchy"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v35 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraClassificationLevel",
                                                                        "kind": "LinkedField",
                                                                        "name": "classificationLevel",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v27 /*: any*/ ,
                                                                            v37 /*: any*/ ,
                                                                            v38 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": "editViewPopup_issueClassificationBadge_ClassificationEditViewPopup"
                                                                    },
                                                                    v28 /*: any*/ ,
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraDataClassificationField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraAffectedServiceConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedAffectedServicesConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraAffectedServiceEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraAffectedService",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "RequiredField",
                                                                                                "field": v45 /*: any*/ ,
                                                                                                "action": "LOG",
                                                                                                "path": "jira.issueByKey.fields.edges.node.selectedAffectedServicesConnection.edges.node.serviceId"
                                                                                            },
                                                                                            v27 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraAffectedServicesField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v48 /*: any*/ ,
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraAssetField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v47 /*: any*/ 
                                                                ],
                                                                "type": "JiraBooleanField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v46 /*: any*/ ,
                                                                    v49 /*: any*/ ,
                                                                    v50 /*: any*/ ,
                                                                    v53 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraCmdbObjectConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedCmdbObjectsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraCmdbObjectEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraCmdbObject",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v54 /*: any*/ ,
                                                                                            v55 /*: any*/ ,
                                                                                            v56 /*: any*/ ,
                                                                                            v57 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "RequiredField",
                                                                                                "field": v58 /*: any*/ ,
                                                                                                "action": "LOG",
                                                                                                "path": "jira.issueByKey.fields.edges.node.selectedCmdbObjectsConnection.edges.node.workspaceId"
                                                                                            },
                                                                                            v59 /*: any*/ ,
                                                                                            {
                                                                                                "concreteType": "JiraCmdbAvatar",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "avatar",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v60 /*: any*/ ,
                                                                                                    {
                                                                                                        "kind": "RequiredField",
                                                                                                        "field": v61 /*: any*/ ,
                                                                                                        "action": "LOG",
                                                                                                        "path": "jira.issueByKey.fields.edges.node.selectedCmdbObjectsConnection.edges.node.avatar.url48"
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "kind": "RequiredField",
                                                                                                "field": {
                                                                                                    "concreteType": "JiraCmdbObjectType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "objectType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v62 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v52 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "RequiredField",
                                                                                                            "field": v63 /*: any*/ ,
                                                                                                            "action": "LOG",
                                                                                                            "path": "jira.issueByKey.fields.edges.node.selectedCmdbObjectsConnection.edges.node.objectType.icon"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                "action": "LOG",
                                                                                                "path": "jira.issueByKey.fields.edges.node.selectedCmdbObjectsConnection.edges.node.objectType"
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "JiraCmdbAttributeConnection",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "attributes",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraCmdbAttributeEdge",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "edges",
                                                                                                        "plural": true,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraCmdbAttribute",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "node",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    v64 /*: any*/ ,
                                                                                                                    v65 /*: any*/ ,
                                                                                                                    {
                                                                                                                        "kind": "RequiredField",
                                                                                                                        "field": v67 /*: any*/ ,
                                                                                                                        "action": "LOG",
                                                                                                                        "path": "jira.issueByKey.fields.edges.node.selectedCmdbObjectsConnection.edges.node.attributes.edges.node.objectTypeAttribute"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "concreteType": "JiraCmdbObjectAttributeValueConnection",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "objectAttributeValues",
                                                                                                                        "plural": false,
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "concreteType": "JiraCmdbObjectAttributeValueEdge",
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "edges",
                                                                                                                                "plural": true,
                                                                                                                                "selections": [
                                                                                                                                    {
                                                                                                                                        "concreteType": "JiraCmdbObjectAttributeValue",
                                                                                                                                        "kind": "LinkedField",
                                                                                                                                        "name": "node",
                                                                                                                                        "plural": false,
                                                                                                                                        "selections": [
                                                                                                                                            v68 /*: any*/ ,
                                                                                                                                            v69 /*: any*/ ,
                                                                                                                                            v47 /*: any*/ ,
                                                                                                                                            {
                                                                                                                                                "kind": "LinkedField",
                                                                                                                                                "name": "user",
                                                                                                                                                "plural": false,
                                                                                                                                                "selections": [
                                                                                                                                                    v70 /*: any*/ ,
                                                                                                                                                    v27 /*: any*/ ,
                                                                                                                                                    v71 /*: any*/ 
                                                                                                                                                ]
                                                                                                                                            },
                                                                                                                                            v72 /*: any*/ ,
                                                                                                                                            {
                                                                                                                                                "concreteType": "JiraGroup",
                                                                                                                                                "kind": "LinkedField",
                                                                                                                                                "name": "group",
                                                                                                                                                "plural": false,
                                                                                                                                                "selections": v73 /*: any*/ 
                                                                                                                                            },
                                                                                                                                            v74 /*: any*/ ,
                                                                                                                                            v76 /*: any*/ ,
                                                                                                                                            v77 /*: any*/ ,
                                                                                                                                            v79 /*: any*/ 
                                                                                                                                        ]
                                                                                                                                    }
                                                                                                                                ]
                                                                                                                            }
                                                                                                                        ]
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraCMDBField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v84 /*: any*/ ,
                                                                    v85 /*: any*/ 
                                                                ],
                                                                "type": "JiraCascadingSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v87 /*: any*/ ,
                                                                    v88 /*: any*/ 
                                                                ],
                                                                "type": "JiraCheckboxesField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v89 /*: any*/ 
                                                                ],
                                                                "type": "JiraColorField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v91 /*: any*/ ,
                                                                    v92 /*: any*/ 
                                                                ],
                                                                "type": "JiraComponentsField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v94 /*: any*/ ,
                                                                "type": "JiraConnectDateTimeField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v87 /*: any*/ ,
                                                                    v95 /*: any*/ 
                                                                ],
                                                                "type": "JiraConnectMultipleSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v96 /*: any*/ 
                                                                ],
                                                                "type": "JiraConnectNumberField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v99 /*: any*/ ,
                                                                "type": "JiraConnectRichTextField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v100 /*: any*/ ,
                                                                    v101 /*: any*/ ,
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraConnectSingleSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v103 /*: any*/ ,
                                                                "type": "JiraConnectTextField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v104 /*: any*/ 
                                                                ],
                                                                "type": "JiraDatePickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v94 /*: any*/ ,
                                                                "type": "JiraDateTimePickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v106 /*: any*/ ,
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraEpicLinkField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v107 /*: any*/ 
                                                                ],
                                                                "type": "JiraFlagField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v110 /*: any*/ ,
                                                                    v98 /*: any*/ 
                                                                ],
                                                                "type": "JiraForgeGroupField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v111 /*: any*/ ,
                                                                    v98 /*: any*/ 
                                                                ],
                                                                "type": "JiraForgeGroupsField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v96 /*: any*/ ,
                                                                    v98 /*: any*/ 
                                                                ],
                                                                "type": "JiraForgeNumberField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v112 /*: any*/ ,
                                                                    v98 /*: any*/ 
                                                                ],
                                                                "type": "JiraForgeObjectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v102 /*: any*/ ,
                                                                    v98 /*: any*/ 
                                                                ],
                                                                "type": "JiraForgeStringField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v113 /*: any*/ ,
                                                                    v98 /*: any*/ ,
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraForgeStringsField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": v121 /*: any*/ 
                                                                    },
                                                                    v98 /*: any*/ ,
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraForgeUserField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v122 /*: any*/ ,
                                                                    v98 /*: any*/ ,
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraForgeUsersField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v123 /*: any*/ ,
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraIssueRestrictionField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v28 /*: any*/ ,
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v29 /*: any*/ ,
                                                                                "action": "LOG",
                                                                                "path": "jira.issueByKey.fields.edges.node.issueType.issueTypeId"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v27 /*: any*/ ,
                                                                                "action": "LOG",
                                                                                "path": "jira.issueByKey.fields.edges.node.issueType.name"
                                                                            },
                                                                            v30 /*: any*/ ,
                                                                            {
                                                                                "concreteType": "JiraAvatar",
                                                                                "kind": "LinkedField",
                                                                                "name": "avatar",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v31 /*: any*/ ,
                                                                                    v32 /*: any*/ ,
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v33 /*: any*/ ,
                                                                                        "action": "LOG",
                                                                                        "path": "jira.issueByKey.fields.edges.node.issueType.avatar.medium"
                                                                                    },
                                                                                    v34 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "hierarchy",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v26 /*: any*/ ,
                                                                                            "action": "LOG",
                                                                                            "path": "jira.issueByKey.fields.edges.node.issueType.hierarchy.level"
                                                                                        },
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v27 /*: any*/ ,
                                                                                            "action": "LOG",
                                                                                            "path": "jira.issueByKey.fields.edges.node.issueType.hierarchy.name"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "LOG",
                                                                                "path": "jira.issueByKey.fields.edges.node.issueType.hierarchy"
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraIssueTypeField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v113 /*: any*/ ,
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraLabelsField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraGroupConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedGroupsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraGroupEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraGroup",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v108 /*: any*/ ,
                                                                                            v27 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraMultipleGroupPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v87 /*: any*/ ,
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraMultipleSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v124 /*: any*/ ,
                                                                "type": "JiraMultipleSelectUserPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v128 /*: any*/ ,
                                                                    v129 /*: any*/ 
                                                                ],
                                                                "type": "JiraMultipleVersionPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v96 /*: any*/ ,
                                                                    v130 /*: any*/ 
                                                                ],
                                                                "type": "JiraNumberField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v132 /*: any*/ 
                                                                ],
                                                                "type": "JiraOriginalTimeEstimateField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v133 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraIssue",
                                                                        "kind": "LinkedField",
                                                                        "name": "parentIssue",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v28 /*: any*/ ,
                                                                            v24 /*: any*/ ,
                                                                            v25 /*: any*/ ,
                                                                            v59 /*: any*/ ,
                                                                            {
                                                                                "condition": "parentInIssueViewFlag",
                                                                                "kind": "Condition",
                                                                                "passingValue": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraColorField",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "issueColorField",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v37 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "args": v134 /*: any*/ ,
                                                                                "concreteType": "JiraIssueFieldConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "fieldsById",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v35 /*: any*/ ,
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v43 /*: any*/ ,
                                                                                                            v27 /*: any*/ ,
                                                                                                            v44 /*: any*/ ,
                                                                                                            v30 /*: any*/ ,
                                                                                                            {
                                                                                                                "concreteType": "JiraIssueType",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "issueType",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    v28 /*: any*/ ,
                                                                                                                    {
                                                                                                                        "kind": "RequiredField",
                                                                                                                        "field": v29 /*: any*/ ,
                                                                                                                        "action": "LOG",
                                                                                                                        "path": "jira.issueByKey.fields.edges.node.parentIssue.fieldsById.edges.node.issueType.issueTypeId"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "RequiredField",
                                                                                                                        "field": v27 /*: any*/ ,
                                                                                                                        "action": "LOG",
                                                                                                                        "path": "jira.issueByKey.fields.edges.node.parentIssue.fieldsById.edges.node.issueType.name"
                                                                                                                    },
                                                                                                                    v30 /*: any*/ ,
                                                                                                                    {
                                                                                                                        "concreteType": "JiraAvatar",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "avatar",
                                                                                                                        "plural": false,
                                                                                                                        "selections": [
                                                                                                                            v31 /*: any*/ ,
                                                                                                                            v32 /*: any*/ ,
                                                                                                                            {
                                                                                                                                "kind": "RequiredField",
                                                                                                                                "field": v33 /*: any*/ ,
                                                                                                                                "action": "LOG",
                                                                                                                                "path": "jira.issueByKey.fields.edges.node.parentIssue.fieldsById.edges.node.issueType.avatar.medium"
                                                                                                                            },
                                                                                                                            v34 /*: any*/ 
                                                                                                                        ]
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "RequiredField",
                                                                                                                        "field": {
                                                                                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "hierarchy",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "RequiredField",
                                                                                                                                    "field": v26 /*: any*/ ,
                                                                                                                                    "action": "LOG",
                                                                                                                                    "path": "jira.issueByKey.fields.edges.node.parentIssue.fieldsById.edges.node.issueType.hierarchy.level"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "RequiredField",
                                                                                                                                    "field": v27 /*: any*/ ,
                                                                                                                                    "action": "LOG",
                                                                                                                                    "path": "jira.issueByKey.fields.edges.node.parentIssue.fieldsById.edges.node.issueType.hierarchy.name"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        "action": "LOG",
                                                                                                                        "path": "jira.issueByKey.fields.edges.node.parentIssue.fieldsById.edges.node.issueType.hierarchy"
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraIssueTypeField"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v43 /*: any*/ ,
                                                                                                            v27 /*: any*/ ,
                                                                                                            v44 /*: any*/ ,
                                                                                                            v30 /*: any*/ ,
                                                                                                            v46 /*: any*/ ,
                                                                                                            {
                                                                                                                "concreteType": "JiraProject",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "project",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    v25 /*: any*/ ,
                                                                                                                    v27 /*: any*/ ,
                                                                                                                    {
                                                                                                                        "kind": "RequiredField",
                                                                                                                        "field": v135 /*: any*/ ,
                                                                                                                        "action": "LOG",
                                                                                                                        "path": "jira.issueByKey.fields.edges.node.parentIssue.fieldsById.edges.node.project.projectId"
                                                                                                                    },
                                                                                                                    v136 /*: any*/ ,
                                                                                                                    v137 /*: any*/ ,
                                                                                                                    v138 /*: any*/ ,
                                                                                                                    v126 /*: any*/ ,
                                                                                                                    {
                                                                                                                        "kind": "RequiredField",
                                                                                                                        "field": {
                                                                                                                            "concreteType": "JiraAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v33 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "RequiredField",
                                                                                                                                    "field": v34 /*: any*/ ,
                                                                                                                                    "action": "LOG",
                                                                                                                                    "path": "jira.issueByKey.fields.edges.node.parentIssue.fieldsById.edges.node.project.avatar.large"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        "action": "LOG",
                                                                                                                        "path": "jira.issueByKey.fields.edges.node.parentIssue.fieldsById.edges.node.project.avatar"
                                                                                                                    },
                                                                                                                    v139 /*: any*/ 
                                                                                                                ]
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraProjectField"
                                                                                                    },
                                                                                                    v140 /*: any*/ 
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\"])"
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraParentIssueField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v122 /*: any*/ ,
                                                                    v141 /*: any*/ ,
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraPeopleField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraPriority",
                                                                        "kind": "LinkedField",
                                                                        "name": "priority",
                                                                        "plural": false,
                                                                        "selections": v145 /*: any*/ 
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraPriorityConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "priorities",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraPriorityEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraPriority",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": v145 /*: any*/ 
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraPriorityField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v146 /*: any*/ 
                                                                ],
                                                                "type": "JiraProformaFormsField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v46 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraProject",
                                                                        "kind": "LinkedField",
                                                                        "name": "project",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v25 /*: any*/ ,
                                                                            v27 /*: any*/ ,
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v135 /*: any*/ ,
                                                                                "action": "LOG",
                                                                                "path": "jira.issueByKey.fields.edges.node.project.projectId"
                                                                            },
                                                                            v136 /*: any*/ ,
                                                                            v137 /*: any*/ ,
                                                                            v138 /*: any*/ ,
                                                                            v126 /*: any*/ ,
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "JiraAvatar",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "avatar",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v33 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v34 /*: any*/ ,
                                                                                            "action": "LOG",
                                                                                            "path": "jira.issueByKey.fields.edges.node.project.avatar.large"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "LOG",
                                                                                "path": "jira.issueByKey.fields.edges.node.project.avatar"
                                                                            },
                                                                            v139 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraProjectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v147 /*: any*/ ,
                                                                    v148 /*: any*/ 
                                                                ],
                                                                "type": "JiraRadioSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v150 /*: any*/ ,
                                                                    v151 /*: any*/ 
                                                                ],
                                                                "type": "JiraResolutionField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v99 /*: any*/ ,
                                                                "type": "JiraRichTextField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraSecurityLevel",
                                                                        "kind": "LinkedField",
                                                                        "name": "securityLevel",
                                                                        "plural": false,
                                                                        "selections": v153 /*: any*/ 
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraSecurityLevelConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "securityLevels",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSecurityLevelEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraSecurityLevel",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": v153 /*: any*/ 
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraSecurityLevelField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraServiceManagementActiveApproval",
                                                                        "kind": "LinkedField",
                                                                        "name": "activeApproval",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v28 /*: any*/ ,
                                                                            v154 /*: any*/ ,
                                                                            v156 /*: any*/ ,
                                                                            {
                                                                                "concreteType": "JiraServiceManagementApproverPrincipalConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "approverPrincipals",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraServiceManagementApproverPrincipalEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v35 /*: any*/ ,
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "RequiredField",
                                                                                                                "field": {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "user",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "RequiredField",
                                                                                                                            "field": v70 /*: any*/ ,
                                                                                                                            "action": "LOG",
                                                                                                                            "path": "jira.issueByKey.fields.edges.node.activeApproval.approverPrincipals.edges.node.user.accountId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "RequiredField",
                                                                                                                            "field": v27 /*: any*/ ,
                                                                                                                            "action": "LOG",
                                                                                                                            "path": "jira.issueByKey.fields.edges.node.activeApproval.approverPrincipals.edges.node.user.name"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "RequiredField",
                                                                                                                            "field": v71 /*: any*/ ,
                                                                                                                            "action": "LOG",
                                                                                                                            "path": "jira.issueByKey.fields.edges.node.activeApproval.approverPrincipals.edges.node.user.picture"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                "action": "LOG",
                                                                                                                "path": "jira.issueByKey.fields.edges.node.activeApproval.approverPrincipals.edges.node.user"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "RequiredField",
                                                                                                                "field": v157 /*: any*/ ,
                                                                                                                "action": "LOG",
                                                                                                                "path": "jira.issueByKey.fields.edges.node.activeApproval.approverPrincipals.edges.node.jiraRest"
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraServiceManagementUserApproverPrincipal"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "RequiredField",
                                                                                                                "field": v108 /*: any*/ ,
                                                                                                                "action": "LOG",
                                                                                                                "path": "jira.issueByKey.fields.edges.node.activeApproval.approverPrincipals.edges.node.groupId"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "RequiredField",
                                                                                                                "field": v27 /*: any*/ ,
                                                                                                                "action": "LOG",
                                                                                                                "path": "jira.issueByKey.fields.edges.node.activeApproval.approverPrincipals.edges.node.name"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "RequiredField",
                                                                                                                "field": v158 /*: any*/ ,
                                                                                                                "action": "LOG",
                                                                                                                "path": "jira.issueByKey.fields.edges.node.activeApproval.approverPrincipals.edges.node.memberCount"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "RequiredField",
                                                                                                                "field": v159 /*: any*/ ,
                                                                                                                "action": "LOG",
                                                                                                                "path": "jira.issueByKey.fields.edges.node.activeApproval.approverPrincipals.edges.node.approvedCount"
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraServiceManagementGroupApproverPrincipal"
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "concreteType": "JiraServiceManagementApproverConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "approvers",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraServiceManagementApproverEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraServiceManagementApprover",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "RequiredField",
                                                                                                        "field": {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "approver",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "RequiredField",
                                                                                                                    "field": v70 /*: any*/ ,
                                                                                                                    "action": "LOG",
                                                                                                                    "path": "jira.issueByKey.fields.edges.node.activeApproval.approvers.edges.node.approver.accountId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "RequiredField",
                                                                                                                    "field": v114 /*: any*/ ,
                                                                                                                    "action": "LOG",
                                                                                                                    "path": "jira.issueByKey.fields.edges.node.activeApproval.approvers.edges.node.approver.accountStatus"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "RequiredField",
                                                                                                                    "field": v27 /*: any*/ ,
                                                                                                                    "action": "LOG",
                                                                                                                    "path": "jira.issueByKey.fields.edges.node.activeApproval.approvers.edges.node.approver.name"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "RequiredField",
                                                                                                                    "field": v71 /*: any*/ ,
                                                                                                                    "action": "LOG",
                                                                                                                    "path": "jira.issueByKey.fields.edges.node.activeApproval.approvers.edges.node.approver.picture"
                                                                                                                },
                                                                                                                v161 /*: any*/ ,
                                                                                                                v162 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        "action": "LOG",
                                                                                                        "path": "jira.issueByKey.fields.edges.node.activeApproval.approvers.edges.node.approver"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "RequiredField",
                                                                                                        "field": v163 /*: any*/ ,
                                                                                                        "action": "LOG",
                                                                                                        "path": "jira.issueByKey.fields.edges.node.activeApproval.approvers.edges.node.approverDecision"
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v164 /*: any*/ ,
                                                                                "action": "LOG",
                                                                                "path": "jira.issueByKey.fields.edges.node.activeApproval.canAnswerApproval"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "JiraServiceManagementApprovalConfiguration",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "configurations",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": {
                                                                                                "concreteType": "JiraServiceManagementApproversConfiguration",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "approversConfigurations",
                                                                                                "plural": true,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "RequiredField",
                                                                                                        "field": v44 /*: any*/ ,
                                                                                                        "action": "LOG",
                                                                                                        "path": "jira.issueByKey.fields.edges.node.activeApproval.configurations.approversConfigurations.type"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "RequiredField",
                                                                                                        "field": v165 /*: any*/ ,
                                                                                                        "action": "LOG",
                                                                                                        "path": "jira.issueByKey.fields.edges.node.activeApproval.configurations.approversConfigurations.fieldName"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "RequiredField",
                                                                                                        "field": v43 /*: any*/ ,
                                                                                                        "action": "LOG",
                                                                                                        "path": "jira.issueByKey.fields.edges.node.activeApproval.configurations.approversConfigurations.fieldId"
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            "action": "LOG",
                                                                                            "path": "jira.issueByKey.fields.edges.node.activeApproval.configurations.approversConfigurations"
                                                                                        },
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": {
                                                                                                "concreteType": "JiraServiceManagementApprovalCondition",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "condition",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "RequiredField",
                                                                                                        "field": v44 /*: any*/ ,
                                                                                                        "action": "LOG",
                                                                                                        "path": "jira.issueByKey.fields.edges.node.activeApproval.configurations.condition.type"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "RequiredField",
                                                                                                        "field": v47 /*: any*/ ,
                                                                                                        "action": "LOG",
                                                                                                        "path": "jira.issueByKey.fields.edges.node.activeApproval.configurations.condition.value"
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            "action": "LOG",
                                                                                            "path": "jira.issueByKey.fields.edges.node.activeApproval.configurations.condition"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "LOG",
                                                                                "path": "jira.issueByKey.fields.edges.node.activeApproval.configurations"
                                                                            },
                                                                            v166 /*: any*/ ,
                                                                            {
                                                                                "concreteType": "JiraServiceManagementDecisionConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "decisions",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraServiceManagementDecisionEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraServiceManagementDecision",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "RequiredField",
                                                                                                        "field": {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "approver",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "RequiredField",
                                                                                                                    "field": v70 /*: any*/ ,
                                                                                                                    "action": "LOG",
                                                                                                                    "path": "jira.issueByKey.fields.edges.node.activeApproval.decisions.edges.node.approver.accountId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "RequiredField",
                                                                                                                    "field": v114 /*: any*/ ,
                                                                                                                    "action": "LOG",
                                                                                                                    "path": "jira.issueByKey.fields.edges.node.activeApproval.decisions.edges.node.approver.accountStatus"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "RequiredField",
                                                                                                                    "field": v27 /*: any*/ ,
                                                                                                                    "action": "LOG",
                                                                                                                    "path": "jira.issueByKey.fields.edges.node.activeApproval.decisions.edges.node.approver.name"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "RequiredField",
                                                                                                                    "field": v71 /*: any*/ ,
                                                                                                                    "action": "LOG",
                                                                                                                    "path": "jira.issueByKey.fields.edges.node.activeApproval.decisions.edges.node.approver.picture"
                                                                                                                },
                                                                                                                v161 /*: any*/ ,
                                                                                                                v162 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        "action": "LOG",
                                                                                                        "path": "jira.issueByKey.fields.edges.node.activeApproval.decisions.edges.node.approver"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "RequiredField",
                                                                                                        "field": v163 /*: any*/ ,
                                                                                                        "action": "LOG",
                                                                                                        "path": "jira.issueByKey.fields.edges.node.activeApproval.decisions.edges.node.approverDecision"
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "concreteType": "JiraUserConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "excludedApprovers",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraUserEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "RequiredField",
                                                                                                        "field": v70 /*: any*/ ,
                                                                                                        "action": "LOG",
                                                                                                        "path": "jira.issueByKey.fields.edges.node.activeApproval.excludedApprovers.edges.node.accountId"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "RequiredField",
                                                                                                        "field": v114 /*: any*/ ,
                                                                                                        "action": "LOG",
                                                                                                        "path": "jira.issueByKey.fields.edges.node.activeApproval.excludedApprovers.edges.node.accountStatus"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "RequiredField",
                                                                                                        "field": v27 /*: any*/ ,
                                                                                                        "action": "LOG",
                                                                                                        "path": "jira.issueByKey.fields.edges.node.activeApproval.excludedApprovers.edges.node.name"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "RequiredField",
                                                                                                        "field": v71 /*: any*/ ,
                                                                                                        "action": "LOG",
                                                                                                        "path": "jira.issueByKey.fields.edges.node.activeApproval.excludedApprovers.edges.node.picture"
                                                                                                    },
                                                                                                    v161 /*: any*/ ,
                                                                                                    v162 /*: any*/ 
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v167 /*: any*/ ,
                                                                                "action": "LOG",
                                                                                "path": "jira.issueByKey.fields.edges.node.activeApproval.finalDecision"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v27 /*: any*/ ,
                                                                                "action": "LOG",
                                                                                "path": "jira.issueByKey.fields.edges.node.activeApproval.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v168 /*: any*/ ,
                                                                                "action": "LOG",
                                                                                "path": "jira.issueByKey.fields.edges.node.activeApproval.pendingApprovalCount"
                                                                            },
                                                                            v169 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraServiceManagementCompletedApprovalConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "completedApprovalsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraServiceManagementCompletedApprovalEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraServiceManagementCompletedApproval",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v28 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "RequiredField",
                                                                                                "field": v27 /*: any*/ ,
                                                                                                "action": "LOG",
                                                                                                "path": "jira.issueByKey.fields.edges.node.completedApprovalsConnection.edges.node.name"
                                                                                            },
                                                                                            {
                                                                                                "kind": "RequiredField",
                                                                                                "field": v167 /*: any*/ ,
                                                                                                "action": "LOG",
                                                                                                "path": "jira.issueByKey.fields.edges.node.completedApprovalsConnection.edges.node.finalDecision"
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "JiraServiceManagementApproverConnection",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "approvers",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraServiceManagementApproverEdge",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "edges",
                                                                                                        "plural": true,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraServiceManagementApprover",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "node",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "kind": "RequiredField",
                                                                                                                        "field": {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "approver",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "RequiredField",
                                                                                                                                    "field": v70 /*: any*/ ,
                                                                                                                                    "action": "LOG",
                                                                                                                                    "path": "jira.issueByKey.fields.edges.node.completedApprovalsConnection.edges.node.approvers.edges.node.approver.accountId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "RequiredField",
                                                                                                                                    "field": v114 /*: any*/ ,
                                                                                                                                    "action": "LOG",
                                                                                                                                    "path": "jira.issueByKey.fields.edges.node.completedApprovalsConnection.edges.node.approvers.edges.node.approver.accountStatus"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "RequiredField",
                                                                                                                                    "field": v27 /*: any*/ ,
                                                                                                                                    "action": "LOG",
                                                                                                                                    "path": "jira.issueByKey.fields.edges.node.completedApprovalsConnection.edges.node.approvers.edges.node.approver.name"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "RequiredField",
                                                                                                                                    "field": v71 /*: any*/ ,
                                                                                                                                    "action": "LOG",
                                                                                                                                    "path": "jira.issueByKey.fields.edges.node.completedApprovalsConnection.edges.node.approvers.edges.node.approver.picture"
                                                                                                                                },
                                                                                                                                v161 /*: any*/ ,
                                                                                                                                v162 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        "action": "LOG",
                                                                                                                        "path": "jira.issueByKey.fields.edges.node.completedApprovalsConnection.edges.node.approvers.edges.node.approver"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "RequiredField",
                                                                                                                        "field": v163 /*: any*/ ,
                                                                                                                        "action": "LOG",
                                                                                                                        "path": "jira.issueByKey.fields.edges.node.completedApprovalsConnection.edges.node.approvers.edges.node.approverDecision"
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            v166 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "RequiredField",
                                                                                                "field": v170 /*: any*/ ,
                                                                                                "action": "LOG",
                                                                                                "path": "jira.issueByKey.fields.edges.node.completedApprovalsConnection.edges.node.completedDate"
                                                                                            },
                                                                                            v171 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraServiceManagementApprovalField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v172 /*: any*/ 
                                                                ],
                                                                "type": "JiraServiceManagementMajorIncidentField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v173 /*: any*/ ,
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraServiceManagementOrganizationField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v124 /*: any*/ ,
                                                                "type": "JiraServiceManagementPeopleField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v174 /*: any*/ 
                                                                ],
                                                                "type": "JiraServiceManagementRequestFeedbackField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v176 /*: any*/ ,
                                                                    v177 /*: any*/ 
                                                                ],
                                                                "type": "JiraServiceManagementRequestLanguageField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v180 /*: any*/ 
                                                                ],
                                                                "type": "JiraServiceManagementRequestTypeField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v46 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraServiceManagementResponderConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "respondersConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraServiceManagementResponderEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v35 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "user",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v181 /*: any*/ ,
                                                                                                            v71 /*: any*/ ,
                                                                                                            v27 /*: any*/ 
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraServiceManagementUserResponder"
                                                                                            },
                                                                                            v183 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraServiceManagementRespondersField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v110 /*: any*/ ,
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleGroupPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v103 /*: any*/ ,
                                                                "type": "JiraSingleLineTextField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v100 /*: any*/ ,
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v187 /*: any*/ ,
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleSelectUserPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v190 /*: any*/ ,
                                                                    v191 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleVersionPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraSprintConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedSprintsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSprintEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraSprint",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v28 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "RequiredField",
                                                                                                "field": v192 /*: any*/ ,
                                                                                                "action": "LOG",
                                                                                                "path": "jira.issueByKey.fields.edges.node.selectedSprintsConnection.edges.node.sprintId"
                                                                                            },
                                                                                            {
                                                                                                "kind": "RequiredField",
                                                                                                "field": v27 /*: any*/ ,
                                                                                                "action": "LOG",
                                                                                                "path": "jira.issueByKey.fields.edges.node.selectedSprintsConnection.edges.node.name"
                                                                                            },
                                                                                            v193 /*: any*/ ,
                                                                                            v194 /*: any*/ ,
                                                                                            v188 /*: any*/ ,
                                                                                            v195 /*: any*/ ,
                                                                                            v196 /*: any*/ ,
                                                                                            v197 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraSprintField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "status",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v28 /*: any*/ ,
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v27 /*: any*/ ,
                                                                                "action": "LOG",
                                                                                "path": "jira.issueByKey.fields.edges.node.status.name"
                                                                            },
                                                                            v30 /*: any*/ ,
                                                                            v198 /*: any*/ ,
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v200 /*: any*/ ,
                                                                                "action": "LOG",
                                                                                "path": "jira.issueByKey.fields.edges.node.status.statusCategory"
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraStatusField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraTeam",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedTeam",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v182 /*: any*/ ,
                                                                            v27 /*: any*/ ,
                                                                            v201 /*: any*/ ,
                                                                            v202 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraTeamField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v203 /*: any*/ ,
                                                                    v46 /*: any*/ 
                                                                ],
                                                                "type": "JiraTeamViewField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v132 /*: any*/ ,
                                                                    v204 /*: any*/ ,
                                                                    v205 /*: any*/ 
                                                                ],
                                                                "type": "JiraTimeTrackingField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v206 /*: any*/ 
                                                                ],
                                                                "type": "JiraUrlField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v208 /*: any*/ 
                                                                ],
                                                                "type": "JiraVotesField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v209 /*: any*/ 
                                                                ],
                                                                "type": "JiraWatchesField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v93 /*: any*/ ,
                                                                    v98 /*: any*/ 
                                                                ],
                                                                "type": "JiraForgeDatetimeField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v104 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v98 /*: any*/ 
                                                                ],
                                                                "type": "JiraForgeDateField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v28 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v44 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v213 /*: any*/ ,
                                                                    v214 /*: any*/ ,
                                                                    v215 /*: any*/ 
                                                                ],
                                                                "type": "JiraServiceManagementEntitlementField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v44 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v30 /*: any*/ ,
                                                                    v42 /*: any*/ ,
                                                                    v218 /*: any*/ 
                                                                ],
                                                                "type": "JiraGoalsField"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "childIssues",
                                        "plural": false,
                                        "selections": [
                                            v35 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "args": v219 /*: any*/ ,
                                                        "concreteType": "JiraIssueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issues",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssue",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v25 /*: any*/ ,
                                                                            v24 /*: any*/ ,
                                                                            v59 /*: any*/ ,
                                                                            v220 /*: any*/ ,
                                                                            {
                                                                                "concreteType": "JiraNumberField",
                                                                                "kind": "LinkedField",
                                                                                "name": "storyPointEstimateField",
                                                                                "plural": false,
                                                                                "selections": v221 /*: any*/ 
                                                                            },
                                                                            {
                                                                                "concreteType": "JiraNumberField",
                                                                                "kind": "LinkedField",
                                                                                "name": "storyPointsField",
                                                                                "plural": false,
                                                                                "selections": v221 /*: any*/ 
                                                                            },
                                                                            {
                                                                                "args": v222 /*: any*/ ,
                                                                                "concreteType": "JiraIssueFieldConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "fieldsById",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v35 /*: any*/ ,
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v43 /*: any*/ ,
                                                                                                            v44 /*: any*/ ,
                                                                                                            {
                                                                                                                "concreteType": "JiraIssueType",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "issueType",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "kind": "RequiredField",
                                                                                                                        "field": v29 /*: any*/ ,
                                                                                                                        "action": "LOG",
                                                                                                                        "path": "jira.issueByKey.childIssues.issues.edges.node.fieldsById.edges.node.issueType.issueTypeId"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "RequiredField",
                                                                                                                        "field": v27 /*: any*/ ,
                                                                                                                        "action": "LOG",
                                                                                                                        "path": "jira.issueByKey.childIssues.issues.edges.node.fieldsById.edges.node.issueType.name"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "concreteType": "JiraAvatar",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "avatar",
                                                                                                                        "plural": false,
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "kind": "RequiredField",
                                                                                                                                "field": v33 /*: any*/ ,
                                                                                                                                "action": "LOG",
                                                                                                                                "path": "jira.issueByKey.childIssues.issues.edges.node.fieldsById.edges.node.issueType.avatar.medium"
                                                                                                                            }
                                                                                                                        ]
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "RequiredField",
                                                                                                                        "field": {
                                                                                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "hierarchy",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "RequiredField",
                                                                                                                                    "field": v26 /*: any*/ ,
                                                                                                                                    "action": "LOG",
                                                                                                                                    "path": "jira.issueByKey.childIssues.issues.edges.node.fieldsById.edges.node.issueType.hierarchy.level"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        "action": "LOG",
                                                                                                                        "path": "jira.issueByKey.childIssues.issues.edges.node.fieldsById.edges.node.issueType.hierarchy"
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraIssueTypeField"
                                                                                                    },
                                                                                                    v223 /*: any*/ ,
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v43 /*: any*/ ,
                                                                                                            v44 /*: any*/ ,
                                                                                                            {
                                                                                                                "concreteType": "JiraPriority",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "priority",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    v142 /*: any*/ ,
                                                                                                                    v27 /*: any*/ ,
                                                                                                                    v144 /*: any*/ ,
                                                                                                                    v143 /*: any*/ 
                                                                                                                ]
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraPriorityField"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v43 /*: any*/ ,
                                                                                                            v44 /*: any*/ ,
                                                                                                            {
                                                                                                                "concreteType": "JiraStatus",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "status",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "kind": "RequiredField",
                                                                                                                        "field": v27 /*: any*/ ,
                                                                                                                        "action": "LOG",
                                                                                                                        "path": "jira.issueByKey.childIssues.issues.edges.node.fieldsById.edges.node.status.name"
                                                                                                                    },
                                                                                                                    v198 /*: any*/ ,
                                                                                                                    {
                                                                                                                        "kind": "RequiredField",
                                                                                                                        "field": {
                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "statusCategory",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v199 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        "action": "LOG",
                                                                                                                        "path": "jira.issueByKey.childIssues.issues.edges.node.fieldsById.edges.node.status.statusCategory"
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraStatusField"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v43 /*: any*/ ,
                                                                                                            v44 /*: any*/ ,
                                                                                                            {
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "user",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    v35 /*: any*/ ,
                                                                                                                    v70 /*: any*/ ,
                                                                                                                    v114 /*: any*/ ,
                                                                                                                    v27 /*: any*/ ,
                                                                                                                    v71 /*: any*/ 
                                                                                                                ]
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraSingleSelectUserPickerField"
                                                                                                    },
                                                                                                    v224 /*: any*/ ,
                                                                                                    v225 /*: any*/ 
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "storageKey": "fieldsById(ids:[\"assignee\",\"created\",\"issuetype\",\"priority\",\"status\",\"summary\",\"timetracking\",\"updated\"])"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "storageKey": "issues(activeProjectsOnly:true)"
                                                    }
                                                ],
                                                "type": "JiraChildIssuesWithinLimit"
                                            },
                                            v226 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "args": v227 /*: any*/ ,
                                        "concreteType": "JiraIssueLinkConnection",
                                        "kind": "LinkedField",
                                        "name": "issueLinks",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueLinkEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueLink",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v28 /*: any*/ ,
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v228 /*: any*/ ,
                                                                "action": "LOG",
                                                                "path": "jira.issueByKey.issueLinks.edges.node.issueLinkId"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v229 /*: any*/ ,
                                                                "action": "LOG",
                                                                "path": "jira.issueByKey.issueLinks.edges.node.direction"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v230 /*: any*/ ,
                                                                "action": "LOG",
                                                                "path": "jira.issueByKey.issueLinks.edges.node.relationName"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraIssueLinkType",
                                                                    "kind": "LinkedField",
                                                                    "name": "type",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v18 /*: any*/ ,
                                                                            "action": "LOG",
                                                                            "path": "jira.issueByKey.issueLinks.edges.node.type.linkTypeId"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "LOG",
                                                                "path": "jira.issueByKey.issueLinks.edges.node.type"
                                                            },
                                                            {
                                                                "concreteType": "JiraIssue",
                                                                "kind": "LinkedField",
                                                                "name": "issue",
                                                                "plural": false,
                                                                "selections": [
                                                                    v28 /*: any*/ ,
                                                                    v24 /*: any*/ ,
                                                                    v25 /*: any*/ ,
                                                                    v59 /*: any*/ ,
                                                                    v220 /*: any*/ ,
                                                                    {
                                                                        "args": v231 /*: any*/ ,
                                                                        "concreteType": "JiraIssueFieldConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "fieldsById",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueFieldEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v35 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    v43 /*: any*/ ,
                                                                                                    v27 /*: any*/ ,
                                                                                                    v44 /*: any*/ ,
                                                                                                    {
                                                                                                        "concreteType": "JiraStatus",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "status",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v28 /*: any*/ ,
                                                                                                            {
                                                                                                                "kind": "RequiredField",
                                                                                                                "field": v27 /*: any*/ ,
                                                                                                                "action": "LOG",
                                                                                                                "path": "jira.issueByKey.issueLinks.edges.node.issue.fieldsById.edges.node.status.name"
                                                                                                            },
                                                                                                            v198 /*: any*/ ,
                                                                                                            {
                                                                                                                "kind": "RequiredField",
                                                                                                                "field": {
                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusCategory",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v199 /*: any*/ ,
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "RequiredField",
                                                                                                                            "field": v27 /*: any*/ ,
                                                                                                                            "action": "LOG",
                                                                                                                            "path": "jira.issueByKey.issueLinks.edges.node.issue.fieldsById.edges.node.status.statusCategory.name"
                                                                                                                        },
                                                                                                                        v232 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                "action": "LOG",
                                                                                                                "path": "jira.issueByKey.issueLinks.edges.node.issue.fieldsById.edges.node.status.statusCategory"
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraStatusField"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    v43 /*: any*/ ,
                                                                                                    v27 /*: any*/ ,
                                                                                                    v44 /*: any*/ ,
                                                                                                    {
                                                                                                        "concreteType": "JiraPriority",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "priority",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v142 /*: any*/ ,
                                                                                                            v27 /*: any*/ ,
                                                                                                            v144 /*: any*/ ,
                                                                                                            v143 /*: any*/ ,
                                                                                                            v105 /*: any*/ 
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraPriorityField"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    v43 /*: any*/ ,
                                                                                                    v27 /*: any*/ ,
                                                                                                    v44 /*: any*/ ,
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueType",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "issueType",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v28 /*: any*/ ,
                                                                                                            {
                                                                                                                "kind": "RequiredField",
                                                                                                                "field": v29 /*: any*/ ,
                                                                                                                "action": "LOG",
                                                                                                                "path": "jira.issueByKey.issueLinks.edges.node.issue.fieldsById.edges.node.issueType.issueTypeId"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "RequiredField",
                                                                                                                "field": v27 /*: any*/ ,
                                                                                                                "action": "LOG",
                                                                                                                "path": "jira.issueByKey.issueLinks.edges.node.issue.fieldsById.edges.node.issueType.name"
                                                                                                            },
                                                                                                            {
                                                                                                                "concreteType": "JiraAvatar",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "avatar",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    v31 /*: any*/ ,
                                                                                                                    v32 /*: any*/ ,
                                                                                                                    {
                                                                                                                        "kind": "RequiredField",
                                                                                                                        "field": v33 /*: any*/ ,
                                                                                                                        "action": "LOG",
                                                                                                                        "path": "jira.issueByKey.issueLinks.edges.node.issue.fieldsById.edges.node.issueType.avatar.medium"
                                                                                                                    },
                                                                                                                    v34 /*: any*/ 
                                                                                                                ]
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "RequiredField",
                                                                                                                "field": {
                                                                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "hierarchy",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "RequiredField",
                                                                                                                            "field": v26 /*: any*/ ,
                                                                                                                            "action": "LOG",
                                                                                                                            "path": "jira.issueByKey.issueLinks.edges.node.issue.fieldsById.edges.node.issueType.hierarchy.level"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "RequiredField",
                                                                                                                            "field": v27 /*: any*/ ,
                                                                                                                            "action": "LOG",
                                                                                                                            "path": "jira.issueByKey.issueLinks.edges.node.issue.fieldsById.edges.node.issueType.hierarchy.name"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                "action": "LOG",
                                                                                                                "path": "jira.issueByKey.issueLinks.edges.node.issue.fieldsById.edges.node.issueType.hierarchy"
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraIssueTypeField"
                                                                                            },
                                                                                            v233 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    v43 /*: any*/ ,
                                                                                                    v27 /*: any*/ ,
                                                                                                    v44 /*: any*/ ,
                                                                                                    v187 /*: any*/ 
                                                                                                ],
                                                                                                "type": "JiraSingleSelectUserPickerField"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "storageKey": "fieldsById(ids:[\"assignee\",\"issuetype\",\"priority\",\"status\",\"summary\"])"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "issueLinks(first:1000)"
                                    },
                                    v234 /*: any*/ ,
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "issueViewRelayCascadingSelectFlag",
                                                "variableName": "issueViewRelayCascadingSelectFlag"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "issueViewRelayGoalsFlag",
                                                "variableName": "issueViewRelayGoalsFlag"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "jsmProductsEntitlementsM2Flag",
                                                "variableName": "jsmProductsEntitlementsM2Flag"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "src_issueViewLayoutTemplatesItemList_ItemList"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "prefetchFieldSuggestions_issueView_MaybePrefetchFieldSuggestions"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ui_issueFieldDataClassification_IssueViewDataClassification"
                                    },
                                    {
                                        "condition": "giraAGGMigrationAttachmentsFlag",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": v235 /*: any*/ ,
                                                "concreteType": "JiraAttachmentConnection",
                                                "kind": "LinkedField",
                                                "name": "attachments",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraAttachmentEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v35 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v236 /*: any*/ ,
                                                                            v237 /*: any*/ ,
                                                                            v238 /*: any*/ ,
                                                                            v239 /*: any*/ ,
                                                                            v240 /*: any*/ ,
                                                                            v241 /*: any*/ ,
                                                                            v242 /*: any*/ ,
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "author",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v70 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            v243 /*: any*/ ,
                                                                            v244 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraPlatformAttachment"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "attachments(first:12,sortBy:{\"field\":\"CREATED\",\"order\":\"DESC\"})"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v5 /*: any*/ ,
                v10 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v2 /*: any*/ ,
                v9 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v8 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainIssueAggQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        {
                            "args": v12 /*: any*/ ,
                            "concreteType": "JiraIssueLinkTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLinkTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueLinkType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v28 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v21 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                    "kind": "LinkedField",
                                    "name": "hierarchyLevelAbove",
                                    "plural": false,
                                    "selections": v245 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                    "kind": "LinkedField",
                                    "name": "hierarchyLevelBelow",
                                    "plural": false,
                                    "selections": v245 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypesForHierarchyAbove",
                                    "plural": false,
                                    "selections": v248 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypesForHierarchyBelow",
                                    "plural": false,
                                    "selections": v248 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypesForHierarchySame",
                                    "plural": false,
                                    "selections": v248 /*: any*/ 
                                },
                                {
                                    "alias": "fieldFragments",
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v35 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraIssueField"
                                                        },
                                                        v43 /*: any*/ ,
                                                        v44 /*: any*/ ,
                                                        v28 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "args": v227 /*: any*/ ,
                                                                            "concreteType": "JiraLabelConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "selectedLabelsConnection",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v216 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraLabelEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraLabel",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": v73 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                        },
                                                                        v27 /*: any*/ ,
                                                                        v39 /*: any*/ ,
                                                                        v249 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraLabelsField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraOption",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldOption",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v47 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v80 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v39 /*: any*/ ,
                                                                        v249 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraSingleSelectField"
                                                                },
                                                                {
                                                                    "condition": "issueViewRelayCascadingSelectFlag",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v27 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraCascadingOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "cascadingOption",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "parentOptionValue",
                                                                                            "plural": false,
                                                                                            "selections": v250 /*: any*/ 
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "childOptionValue",
                                                                                            "plural": false,
                                                                                            "selections": v250 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v39 /*: any*/ ,
                                                                                v249 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraCascadingSelectField"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "jsmProductsEntitlementsM2Flag",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v27 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraServiceManagementEntitlement",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedEntitlement",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v28 /*: any*/ ,
                                                                                        v210 /*: any*/ ,
                                                                                        v212 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v215 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraServiceManagementEntitlementField"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "issueViewRelayGoalsFlag",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v27 /*: any*/ ,
                                                                                v39 /*: any*/ ,
                                                                                v217 /*: any*/ ,
                                                                                v249 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraGoalsField"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "status",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "ids",
                                            "value": [
                                                "status"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldsById",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v35 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v251 /*: any*/ ,
                                                                        v28 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraStatusField"
                                                        },
                                                        v28 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "fieldsById(ids:[\"status\"])"
                                },
                                {
                                    "alias": "reporter",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "ids",
                                            "value": [
                                                "reporter"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldsById",
                                    "plural": false,
                                    "selections": v253 /*: any*/ ,
                                    "storageKey": "fieldsById(ids:[\"reporter\"])"
                                },
                                {
                                    "alias": "assignee",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "ids",
                                            "value": [
                                                "assignee"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldsById",
                                    "plural": false,
                                    "selections": v253 /*: any*/ ,
                                    "storageKey": "fieldsById(ids:[\"assignee\"])"
                                },
                                {
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v35 /*: any*/ ,
                                                        v28 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraClassificationLevel",
                                                                    "kind": "LinkedField",
                                                                    "name": "classificationLevel",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v254 /*: any*/ ,
                                                                        v38 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v255 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "filterByCriteria",
                                                                            "value": {
                                                                                "filterByStatus": [
                                                                                    "PUBLISHED"
                                                                                ],
                                                                                "filterByType": [
                                                                                    "USER"
                                                                                ]
                                                                            }
                                                                        },
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "first",
                                                                            "value": 10
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraClassificationLevelConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "classificationLevels",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraClassificationLevelEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraClassificationLevel",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v256 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "classificationLevels(filterByCriteria:{\"filterByStatus\":[\"PUBLISHED\"],\"filterByType\":[\"USER\"]},first:10)"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "classificationLevelSource"
                                                                },
                                                                {
                                                                    "concreteType": "JiraClassificationLevel",
                                                                    "kind": "LinkedField",
                                                                    "name": "defaultClassificationLevel",
                                                                    "plural": false,
                                                                    "selections": v256 /*: any*/ 
                                                                },
                                                                v39 /*: any*/ 
                                                            ],
                                                            "type": "JiraDataClassificationField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedAffectedServicesConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAffectedService",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v45 /*: any*/ ,
                                                                                        v27 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraAffectedServicesField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v48 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraAssetField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v47 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraBooleanField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v49 /*: any*/ ,
                                                                v50 /*: any*/ ,
                                                                v53 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedCmdbObjectsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraCmdbObject",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v54 /*: any*/ ,
                                                                                        v55 /*: any*/ ,
                                                                                        v56 /*: any*/ ,
                                                                                        v57 /*: any*/ ,
                                                                                        v58 /*: any*/ ,
                                                                                        v59 /*: any*/ ,
                                                                                        v78 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraCmdbObjectType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "objectType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v62 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v52 /*: any*/ ,
                                                                                                v63 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraCmdbAttributeConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "attributes",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbAttributeEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbAttribute",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v64 /*: any*/ ,
                                                                                                                v65 /*: any*/ ,
                                                                                                                v67 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObjectAttributeValueConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "objectAttributeValues",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbObjectAttributeValueEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbObjectAttributeValue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v68 /*: any*/ ,
                                                                                                                                        v69 /*: any*/ ,
                                                                                                                                        v47 /*: any*/ ,
                                                                                                                                        v257 /*: any*/ ,
                                                                                                                                        v72 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraGroup",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "group",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v27 /*: any*/ ,
                                                                                                                                                v28 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v74 /*: any*/ ,
                                                                                                                                        v76 /*: any*/ ,
                                                                                                                                        v77 /*: any*/ ,
                                                                                                                                        v79 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraCMDBField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v84 /*: any*/ ,
                                                                v214 /*: any*/ ,
                                                                v85 /*: any*/ 
                                                            ],
                                                            "type": "JiraCascadingSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v87 /*: any*/ ,
                                                                v88 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraCheckboxesField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v89 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraColorField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v91 /*: any*/ ,
                                                                v92 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraComponentsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v258 /*: any*/ ,
                                                            "type": "JiraConnectDateTimeField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v87 /*: any*/ ,
                                                                v95 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraConnectMultipleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v96 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraConnectNumberField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v259 /*: any*/ ,
                                                            "type": "JiraConnectRichTextField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v100 /*: any*/ ,
                                                                v101 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraConnectSingleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v260 /*: any*/ ,
                                                            "type": "JiraConnectTextField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v104 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraDatePickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v258 /*: any*/ ,
                                                            "type": "JiraDateTimePickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v106 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraEpicLinkField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v107 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraFlagField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v110 /*: any*/ ,
                                                                v98 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraForgeGroupField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v111 /*: any*/ ,
                                                                v98 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraForgeGroupsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v96 /*: any*/ ,
                                                                v98 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraForgeNumberField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v112 /*: any*/ ,
                                                                v98 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraForgeObjectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v102 /*: any*/ ,
                                                                v98 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraForgeStringField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v113 /*: any*/ ,
                                                                v98 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraForgeStringsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": v261 /*: any*/ 
                                                                },
                                                                v98 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraForgeUserField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v262 /*: any*/ ,
                                                                v98 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraForgeUsersField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v123 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraIssueRestrictionField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v263 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraIssueTypeField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v113 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraLabelsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraGroupConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedGroupsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraGroupEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraGroup",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v108 /*: any*/ ,
                                                                                        v27 /*: any*/ ,
                                                                                        v28 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleGroupPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v87 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v264 /*: any*/ ,
                                                            "type": "JiraMultipleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v128 /*: any*/ ,
                                                                v214 /*: any*/ ,
                                                                v129 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleVersionPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v96 /*: any*/ ,
                                                                v130 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraNumberField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v132 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraOriginalTimeEstimateField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v133 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v28 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        {
                                                                            "condition": "parentInIssueViewFlag",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraColorField",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueColorField",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v254 /*: any*/ ,
                                                                                        v28 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": v134 /*: any*/ ,
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v43 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v44 /*: any*/ ,
                                                                                                        v30 /*: any*/ ,
                                                                                                        v263 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v43 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v44 /*: any*/ ,
                                                                                                        v30 /*: any*/ ,
                                                                                                        v46 /*: any*/ ,
                                                                                                        v265 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                v140 /*: any*/ ,
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\"])"
                                                                        }
                                                                    ]
                                                                },
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraParentIssueField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v262 /*: any*/ ,
                                                                v141 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraPeopleField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": v266 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "JiraPriorityConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "priorities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraPriorityEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraPriority",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v266 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraPriorityField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v146 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraProformaFormsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v265 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraProjectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v147 /*: any*/ ,
                                                                v148 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraRadioSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v150 /*: any*/ ,
                                                                v151 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraResolutionField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v259 /*: any*/ ,
                                                            "type": "JiraRichTextField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraSecurityLevel",
                                                                    "kind": "LinkedField",
                                                                    "name": "securityLevel",
                                                                    "plural": false,
                                                                    "selections": v267 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "JiraSecurityLevelConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "securityLevels",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSecurityLevelEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSecurityLevel",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v267 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraSecurityLevelField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraServiceManagementActiveApproval",
                                                                    "kind": "LinkedField",
                                                                    "name": "activeApproval",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v28 /*: any*/ ,
                                                                        v154 /*: any*/ ,
                                                                        v156 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraServiceManagementApproverPrincipalConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "approverPrincipals",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraServiceManagementApproverPrincipalEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v257 /*: any*/ ,
                                                                                                        v157 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraServiceManagementUserApproverPrincipal"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v108 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v158 /*: any*/ ,
                                                                                                        v159 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraServiceManagementGroupApproverPrincipal"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v270 /*: any*/ ,
                                                                        v164 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraServiceManagementApprovalConfiguration",
                                                                            "kind": "LinkedField",
                                                                            "name": "configurations",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraServiceManagementApproversConfiguration",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "approversConfigurations",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v44 /*: any*/ ,
                                                                                        v165 /*: any*/ ,
                                                                                        v43 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraServiceManagementApprovalCondition",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "condition",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v44 /*: any*/ ,
                                                                                        v47 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v166 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraServiceManagementDecisionConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "decisions",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraServiceManagementDecisionEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraServiceManagementDecision",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": v269 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraUserConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "excludedApprovers",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraUserEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": v268 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v167 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v168 /*: any*/ ,
                                                                        v169 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraServiceManagementCompletedApprovalConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "completedApprovalsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraServiceManagementCompletedApprovalEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraServiceManagementCompletedApproval",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v28 /*: any*/ ,
                                                                                        v27 /*: any*/ ,
                                                                                        v167 /*: any*/ ,
                                                                                        v270 /*: any*/ ,
                                                                                        v166 /*: any*/ ,
                                                                                        v170 /*: any*/ ,
                                                                                        v171 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraServiceManagementApprovalField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v172 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraServiceManagementMajorIncidentField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v173 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraServiceManagementOrganizationField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v264 /*: any*/ ,
                                                            "type": "JiraServiceManagementPeopleField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v174 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraServiceManagementRequestFeedbackField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v176 /*: any*/ ,
                                                                v177 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraServiceManagementRequestLanguageField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v180 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraServiceManagementRequestTypeField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraServiceManagementResponderConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "respondersConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraServiceManagementResponderEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v181 /*: any*/ ,
                                                                                                        v71 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementUserResponder"
                                                                                        },
                                                                                        v183 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraServiceManagementRespondersField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v110 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleGroupPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v260 /*: any*/ ,
                                                            "type": "JiraSingleLineTextField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v100 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v271 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v190 /*: any*/ ,
                                                                v191 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleVersionPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraSprintConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedSprintsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprintEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprint",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v28 /*: any*/ ,
                                                                                        v192 /*: any*/ ,
                                                                                        v27 /*: any*/ ,
                                                                                        v193 /*: any*/ ,
                                                                                        v194 /*: any*/ ,
                                                                                        v188 /*: any*/ ,
                                                                                        v195 /*: any*/ ,
                                                                                        v196 /*: any*/ ,
                                                                                        v197 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraSprintField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v28 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v30 /*: any*/ ,
                                                                        v198 /*: any*/ ,
                                                                        v200 /*: any*/ 
                                                                    ]
                                                                },
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraStatusField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraTeam",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedTeam",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v182 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v201 /*: any*/ ,
                                                                        v202 /*: any*/ ,
                                                                        v28 /*: any*/ 
                                                                    ]
                                                                },
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraTeamField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v203 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraTeamViewField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v132 /*: any*/ ,
                                                                v204 /*: any*/ ,
                                                                v205 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraTimeTrackingField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v206 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraUrlField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v208 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraVotesField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v209 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraWatchesField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v93 /*: any*/ ,
                                                                v98 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraForgeDatetimeField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v104 /*: any*/ ,
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v98 /*: any*/ ,
                                                                v214 /*: any*/ 
                                                            ],
                                                            "type": "JiraForgeDateField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v43 /*: any*/ ,
                                                                v213 /*: any*/ ,
                                                                v214 /*: any*/ ,
                                                                v215 /*: any*/ 
                                                            ],
                                                            "type": "JiraServiceManagementEntitlementField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v44 /*: any*/ ,
                                                                v43 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v214 /*: any*/ ,
                                                                v218 /*: any*/ 
                                                            ],
                                                            "type": "JiraGoalsField"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "childIssues",
                                    "plural": false,
                                    "selections": [
                                        v35 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v219 /*: any*/ ,
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v25 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v220 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraNumberField",
                                                                            "kind": "LinkedField",
                                                                            "name": "storyPointEstimateField",
                                                                            "plural": false,
                                                                            "selections": v272 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraNumberField",
                                                                            "kind": "LinkedField",
                                                                            "name": "storyPointsField",
                                                                            "plural": false,
                                                                            "selections": v272 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "args": v222 /*: any*/ ,
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v43 /*: any*/ ,
                                                                                                        v44 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v29 /*: any*/ ,
                                                                                                                v27 /*: any*/ ,
                                                                                                                v202 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "hierarchy",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                v223 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v43 /*: any*/ ,
                                                                                                        v44 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v142 /*: any*/ ,
                                                                                                                v27 /*: any*/ ,
                                                                                                                v144 /*: any*/ ,
                                                                                                                v143 /*: any*/ ,
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v43 /*: any*/ ,
                                                                                                        v44 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v27 /*: any*/ ,
                                                                                                                v198 /*: any*/ ,
                                                                                                                v251 /*: any*/ ,
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v43 /*: any*/ ,
                                                                                                        v44 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v35 /*: any*/ ,
                                                                                                                v70 /*: any*/ ,
                                                                                                                v114 /*: any*/ ,
                                                                                                                v27 /*: any*/ ,
                                                                                                                v71 /*: any*/ ,
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                v224 /*: any*/ ,
                                                                                                v225 /*: any*/ ,
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldsById(ids:[\"assignee\",\"created\",\"issuetype\",\"priority\",\"status\",\"summary\",\"timetracking\",\"updated\"])"
                                                                        },
                                                                        v28 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "issues(activeProjectsOnly:true)"
                                                }
                                            ],
                                            "type": "JiraChildIssuesWithinLimit"
                                        },
                                        v226 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v227 /*: any*/ ,
                                    "concreteType": "JiraIssueLinkConnection",
                                    "kind": "LinkedField",
                                    "name": "issueLinks",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueLinkEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueLink",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v28 /*: any*/ ,
                                                        v228 /*: any*/ ,
                                                        v229 /*: any*/ ,
                                                        v230 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueLinkType",
                                                            "kind": "LinkedField",
                                                            "name": "type",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                v28 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "issue",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                v24 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                v59 /*: any*/ ,
                                                                v220 /*: any*/ ,
                                                                {
                                                                    "args": v231 /*: any*/ ,
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v43 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v44 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v198 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                v199 /*: any*/ ,
                                                                                                                v25 /*: any*/ ,
                                                                                                                v27 /*: any*/ ,
                                                                                                                v232 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v43 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v44 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v142 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v144 /*: any*/ ,
                                                                                                        v143 /*: any*/ ,
                                                                                                        v105 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v43 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v44 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v29 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v179 /*: any*/ ,
                                                                                                        v246 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        v233 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v43 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v44 /*: any*/ ,
                                                                                                v271 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        v28 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"assignee\",\"issuetype\",\"priority\",\"status\",\"summary\"])"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "issueLinks(first:1000)"
                                },
                                v28 /*: any*/ ,
                                v234 /*: any*/ ,
                                {
                                    "condition": "giraAGGMigrationAttachmentsFlag",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v235 /*: any*/ ,
                                            "concreteType": "JiraAttachmentConnection",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraAttachmentEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v236 /*: any*/ ,
                                                                        v237 /*: any*/ ,
                                                                        v238 /*: any*/ ,
                                                                        v239 /*: any*/ ,
                                                                        v240 /*: any*/ ,
                                                                        v241 /*: any*/ ,
                                                                        v242 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "author",
                                                                            "plural": false,
                                                                            "selections": v252 /*: any*/ 
                                                                        },
                                                                        v243 /*: any*/ ,
                                                                        v244 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraPlatformAttachment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v211 /*: any*/ ,
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "attachments(first:12,sortBy:{\"field\":\"CREATED\",\"order\":\"DESC\"})"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e5c935b5b49b17fbea11e10a5708bd3178ec8ad8332a715ad2614caa6c7b18df",
            "metadata": {},
            "name": "mainIssueAggQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$04e695b9f5fc0bb0$var$node.hash = "c5f9f2f32fd3ef0396b640553bf91e6a";
(0, $cNy9K.PreloadableQueryRegistry).set($04e695b9f5fc0bb0$var$node.params.id, $04e695b9f5fc0bb0$var$node);
var $04e695b9f5fc0bb0$export$2e2bcd8739ae039 = $04e695b9f5fc0bb0$var$node;

});

parcelRegister("2mP8r", function(module, exports) {

$parcel$export(module.exports, "getMainIssueViewAggQueryFeatureFlagVariables", () => $ad8d90d6e49d6bf3$export$3dd406718c5846c6);

var $bKxX9 = parcelRequire("bKxX9");

var $cs6Z7 = parcelRequire("cs6Z7");

var $6wu6G = parcelRequire("6wu6G");
const $ad8d90d6e49d6bf3$export$3dd406718c5846c6 = ()=>({
        issueViewRelayCascadingSelectFlag: (0, $bKxX9.ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration'),
        giraAGGMigrationIsArchivedFlag: (0, $cs6Z7.getIsNewValueRequested)((0, $6wu6G.GIRA_AGG_MIGRATION_ISARCHIVED_FLAG)),
        parentInIssueViewFlag: (0, $6wu6G.isParentInIssueViewEnabled)(),
        isCompassComponentsEnabled: (0, $bKxX9.ff)('compass-components-in-jira-components_xw42u', false),
        giraAGGMigrationAttachmentsFlag: (0, $bKxX9.ff)('issue.details.gira-agg-migration-attachments_ecebe'),
        jsmProductsEntitlementsM2Flag: (0, $bKxX9.ff)('products-and-entitlements-m2'),
        isRelayReleaseVersionFieldIssueViewIntegrationEnabled: (0, $bKxX9.ff)('issue.details.relay-release-version-field-issue-view-integration'),
        issueViewRelayGoalsFlag: (0, $bKxX9.ff)('hrz-716-integrate-goal-picker-into-issue-view', false)
    });

});



parcelRegister("lwu0A", function(module, exports) {

$parcel$export(module.exports, "nonCriticalGiraQueryExperienceTracking", () => $aea8e6a6bf82674d$export$f382deefb24f95ae);
$parcel$export(module.exports, "fetchIssueGiraNonCriticalData", () => $aea8e6a6bf82674d$export$58a9221a6c5306db);

var $1ybV0 = parcelRequire("1ybV0");

var $7EhAs = parcelRequire("7EhAs");

var $ieUuV = parcelRequire("ieUuV");

var $4ceCM = parcelRequire("4ceCM");

var $kXzsJ = parcelRequire("kXzsJ");
const $aea8e6a6bf82674d$var$nonCriticalGiraQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId, isEarlyFetch: isEarlyFetch })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: isEarlyFetch ? 'issueEarlyFetchNonCriticalGiraQuery' : 'issueNonCriticalGiraQuery',
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: `Issue View ${isEarlyFetch ? 'Early Fetch ' : ''}Non Critical Gira Query`,
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $aea8e6a6bf82674d$export$f382deefb24f95ae = ({ wasExperienceSuccessful: wasExperienceSuccessful, isEarlyFetch: isEarlyFetch, error: error })=>{
    (0, $4ceCM.sendExperienceAnalytics)($aea8e6a6bf82674d$var$nonCriticalGiraQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error instanceof (0, $7EhAs.default) && error.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $7EhAs.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {},
        isEarlyFetch: isEarlyFetch
    }));
};
const $aea8e6a6bf82674d$var$isNonCriticalGiraQueryExperienceTrackingEnabled = ()=>(0, $1ybV0.ff)('issue.details.non-critical-gira-query-experience-tracking', false);
const $aea8e6a6bf82674d$export$58a9221a6c5306db = async (issueKey)=>{
    const variables = {
        issueKey: issueKey
    };
    const payload = {
        query: (0, $ieUuV.buildNonCriticalGiraQuery)(),
        variables: variables,
        operationName: (0, $ieUuV.ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY)
    };
    if (!$aea8e6a6bf82674d$var$isNonCriticalGiraQueryExperienceTrackingEnabled()) {
        const response = await (0, $kXzsJ.getClient)('').query(payload);
        return response;
    }
    try {
        const response = await (0, $kXzsJ.getClient)('').query(payload);
        $aea8e6a6bf82674d$export$f382deefb24f95ae({
            wasExperienceSuccessful: true,
            isEarlyFetch: false
        });
        return response;
    } catch (error) {
        $aea8e6a6bf82674d$export$f382deefb24f95ae({
            wasExperienceSuccessful: false,
            isEarlyFetch: false,
            error: error instanceof (0, $7EhAs.default) ? error : undefined
        });
        throw error;
    }
};

});
parcelRegister("ieUuV", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY", () => $62451518e89bf947$export$857f1602ca5b9d99);
$parcel$export(module.exports, "buildNonCriticalGiraQuery", () => $62451518e89bf947$export$df3c3aa9d6d3f431);
$parcel$export(module.exports, "getNonCriticalGiraQueryRequestOptions", () => $62451518e89bf947$export$555194bfc9159fa3);

var $bKxX9 = parcelRequire("bKxX9");

var $knMkV = parcelRequire("knMkV");
const $62451518e89bf947$export$857f1602ca5b9d99 = 'issueViewNonCriticalGiraQuery';
const $62451518e89bf947$export$df3c3aa9d6d3f431 = ()=>`
query ${$62451518e89bf947$export$857f1602ca5b9d99}($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        ${(0, $knMkV.getEcosystemQuery)()}
        ${(0, $bKxX9.ff)('issue.details.gira-agg-migration-attachments_ecebe') ? 'deletableAttachmentsCount' : ''}
    }
}`;
const $62451518e89bf947$export$555194bfc9159fa3 = (issueKey)=>({
        method: 'POST',
        body: JSON.stringify({
            operationName: $62451518e89bf947$export$857f1602ca5b9d99,
            query: $62451518e89bf947$export$df3c3aa9d6d3f431(),
            variables: {
                issueKey: issueKey
            }
        })
    });

});
parcelRegister("knMkV", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $039ea2834e0e4840$export$edefef8c65e08bd2);

var $bKxX9 = parcelRequire("bKxX9");
const $039ea2834e0e4840$export$edefef8c65e08bd2 = ()=>`
  ecosystem {
    operations {
      name
      url: href
      tooltip
      styleClass
    }
    ${(0, $bKxX9.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on') ? `
    backgroundScripts {
      iframe {
        addonKey
        moduleKey
        options
      }
      shouldReloadOnRefresh
    }` : ''}
    ${(0, $bKxX9.ff)('issue-view-remove-activitypanels-from-critical-fetch_43ozj') ? `
    activityPanels {
      name
      iframe {
        addonKey
        moduleKey
        options
      }
    }
  ` : ''}
  }
`;

});


parcelRegister("4ceCM", function(module, exports) {

$parcel$export(module.exports, "sendExperienceAnalytics", () => $bd135bf39efe6af3$export$4a95ada1b8228562);

var $2vzCR = parcelRequire("2vzCR");

var $9lmTX = parcelRequire("9lmTX");

var $bKxX9 = parcelRequire("bKxX9");

var $6rW04 = parcelRequire("6rW04");

var $3WQZN = parcelRequire("3WQZN");
const $bd135bf39efe6af3$var$isSynthetic = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';
function $bd135bf39efe6af3$export$4a95ada1b8228562(experienceDescription) {
    const additionalContext = {};
    if ((0, $bKxX9.ff)('issue.details.shard-and-region-to-slo-analytics')) {
        const shard = (0, $6rW04.default)('ajs-shard');
        const region = (0, $6rW04.default)('ajs-region');
        Object.assign(additionalContext, {
            shard: shard,
            region: region
        });
    }
    if ((0, $bKxX9.ff)('issue.details.feature-flags-to-slo-analytics')) {
        const enabledFeatureFlags = Object.fromEntries([
            ...(0, $3WQZN.allFeatureFlagsAccessed)
        ].filter(([, value])=>value));
        Object.assign(additionalContext, {
            enabledFeatureFlags: enabledFeatureFlags
        });
    }
    const synthetics = {
        additionalAttributes: {
            synthetic: $bd135bf39efe6af3$var$isSynthetic(),
            ...additionalContext
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(experienceDescription, synthetics);
    (0, $9lmTX.default)(experienceDescription);
}

});
parcelRegister("9lmTX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a22cac565d88251d$export$2e2bcd8739ae039);

var $3FyZ4 = parcelRequire("3FyZ4");

var $6WXNs = parcelRequire("6WXNs");
var $eIp1n = parcelRequire("eIp1n");
const $a22cac565d88251d$var$transformApplication = (application)=>{
    switch(application){
        case 0, $eIp1n.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $eIp1n.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $eIp1n.JIRA_CORE:
            return 'jira-core';
        case 0, $eIp1n.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $eIp1n.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $a22cac565d88251d$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $6WXNs.FREE_EDITION:
            return 'jedi';
        case 0, $6WXNs.STANDARD_EDITION:
            return 'standard';
        case 0, $6WXNs.PREMIUM_EDITION:
            return 'premium';
        case 0, $6WXNs.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $a22cac565d88251d$var$transformAction = (action, wasExperienceSuccesful)=>{
    if (action !== undefined) return action;
    return wasExperienceSuccesful ? 'taskSuccess' : 'taskFail';
};
const $a22cac565d88251d$var$createAnalyticsEvent = ({ experience: experience, wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, field: field, hasEdit: hasEdit, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: $a22cac565d88251d$var$transformAction(action, wasExperienceSuccesful),
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            task: experience,
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...location ? {
                reason: location
            } : {},
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...field ? {
                field: field
            } : {},
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...typeof hasEdit === 'boolean' ? {
                hasEdit: hasEdit
            } : {},
            analyticsSource: analyticsSource,
            application: $a22cac565d88251d$var$transformApplication(application),
            edition: $a22cac565d88251d$var$transformEdition(edition)
        }
    });
var /**
 * @param {String} experienceDescription.experience
 * @param {Boolean} experienceDescription.wasExperienceSuccesful - Deprecated: Instead set `action` to `taskSuccess` (previously `true`), `taskFail` (previously `false`) or `taskAbort`
 * @param {Action} experienceDescription.action
 * @param {String} experienceDescription.location
 * @param {String} experienceDescription.field
 * @param {String} experienceDescription.hasEdit
 * @param {String} experienceDescription.analyticsSource
 * @param {String} experienceDescription.application
 * @param {Application} experienceDescription.edition
 * @param {ApplicationEdition} experienceDescription.additionalAttributes
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$a22cac565d88251d$export$2e2bcd8739ae039 = (experienceDescription)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $a22cac565d88251d$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};

});



parcelRegister("dWLk9", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $15ea95bdeaf03a79$export$9da0f7c65f28ed16);

var $gd0Sp = parcelRequire("gd0Sp");
const $15ea95bdeaf03a79$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("f4Jgp", function(module, exports) {

$parcel$export(module.exports, "PrefetchedResourceStoreContainer", () => $a37b59a2e896cabf$export$f6f048efa5d827b1);
$parcel$export(module.exports, "useSelfClearingPrefetchedResourceManager", () => $a37b59a2e896cabf$export$bddf12826deaa1d2);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
class $a37b59a2e896cabf$var$PrefetchedResourceManager {
    setAllData(data) {
        this.allData = data;
    }
    setAllPromises(promises) {
        this.issueMediaUserAuth = promises.mediaUserAuthPromise;
        this.issueMediaUploadPermission = promises.mediaUploadPermissionPromise;
        this.issueMediaReadPermission = promises.mediaReadPermissionPromise;
        this.issueGiraData = promises.issueGiraDataPromise;
        this.issueAggData = promises.issueAggDataPromise;
    }
    setGiraPromise(promise) {
        this.issueGiraData = promise;
    }
    setAggPromise(promise) {
        this.issueAggData = promise;
    }
    setAggData(data) {
        this.allData.issueAggData = data;
    }
    setForgePromise(promise) {
        this.issueForgeData = promise;
    }
    setGiraNonCriticalPromise(promise) {
        this.issueGiraNonCriticalData = promise;
    }
    getAllPromises() {
        return [
            this.issueMediaUserAuth,
            this.issueMediaUploadPermission,
            this.issueMediaReadPermission,
            this.issueGiraData,
            this.issueAggData
        ];
    }
    clearAll() {
        this.allData = {};
        this.issueMediaReadPermission = null;
        this.issueMediaUploadPermission = null;
        this.issueMediaUserAuth = null;
        this.issueGiraData = null;
        this.issueForgeData = null;
        this.issueAggData = null;
    }
    clearGiraNonCriticalData() {
        this.issueGiraNonCriticalData = null;
    }
    constructor(){
        this.issueMediaUserAuth = null;
        this.issueMediaReadPermission = null;
        this.issueMediaUploadPermission = null;
        this.issueGiraData = null;
        this.issueAggData = null;
        this.issueForgeData = null;
        this.issueGiraNonCriticalData = null;
        this.allData = {};
        this.getGiraData = ()=>this.allData.issueGiraData && this.allData.issueGiraData.data;
        this.getGiraErrors = ()=>this.allData.issueGiraData?.errors;
        this.getAggData = ()=>this.allData.issueAggData && this.allData.issueAggData.data;
        this.getAggErrors = ()=>this.allData.issueAggData?.errors;
        this.getMediaUser = ()=>this.allData.mediaUserAuth;
        this.getMediaReadPermission = ()=>this.allData.mediaReadPermission;
        this.getMediaUploadPermission = ()=>this.allData.mediaUploadPermission;
        // Helper
        this.isAllDataReady = ()=>Boolean(this.getGiraData() && this.getAggData());
        this.containsInitialPromises = ()=>Boolean(this.issueMediaUploadPermission && this.issueMediaUserAuth && this.issueMediaReadPermission && this.issueGiraData && this.issueAggData);
    }
}
var $a37b59a2e896cabf$export$2e2bcd8739ae039 = $a37b59a2e896cabf$var$PrefetchedResourceManager;
const $a37b59a2e896cabf$export$f6f048efa5d827b1 = (0, $heB5U.createContainer)();
const $a37b59a2e896cabf$var$PrefetchedResourceManagerStore = (0, $a61MH.createStore)({
    name: 'issue-view-prefetched-resource-manager',
    containedBy: $a37b59a2e896cabf$export$f6f048efa5d827b1,
    initialState: {
        prefetchedResourceManager: new $a37b59a2e896cabf$var$PrefetchedResourceManager()
    },
    actions: {},
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    prefetchedResourceManager: new $a37b59a2e896cabf$var$PrefetchedResourceManager()
                });
            }
    }
});
const $a37b59a2e896cabf$var$usePrefetchedResourceStore = (0, $ggKAj.createStateHook)($a37b59a2e896cabf$var$PrefetchedResourceManagerStore, {
    selector: ({ prefetchedResourceManager: prefetchedResourceManager })=>prefetchedResourceManager
});
function $a37b59a2e896cabf$export$bddf12826deaa1d2(issueKey, onIssueKeyChange) {
    const prefetchedResourceManager = $a37b59a2e896cabf$var$usePrefetchedResourceStore();
    // By inspecting and mutating an object stored in sweet state instead of `useState` or `useRef`
    // we avoid losing state when a render aborts (eg from suspense).
    // Which allows us to guarantee that onIssueKeyChange only runs once when the issue-key updates
    // even though we're running in the render phase instead of a useEffect
    if (issueKey !== prefetchedResourceManager.issueKey) {
        prefetchedResourceManager.issueKey = issueKey;
        prefetchedResourceManager.clearAll();
        onIssueKeyChange?.({
            issueKey: issueKey,
            prefetchedResourceManager: prefetchedResourceManager
        });
    }
    return prefetchedResourceManager;
}

});

parcelRegister("go191", function(module, exports) {

$parcel$export(module.exports, "setCacheEntry", () => $62bbe64876e0a557$export$887205bd69d98616);
$parcel$export(module.exports, "getCacheEntry", () => $62bbe64876e0a557$export$96ebd2cbd0b02255);
$parcel$export(module.exports, "hasCacheEntry", () => $62bbe64876e0a557$export$508dd20a392e9f51);
$parcel$export(module.exports, "clearCache", () => $62bbe64876e0a557$export$d2adf65b87e47523);
const $62bbe64876e0a557$export$1cb3db646823c411 = new Map();
const $62bbe64876e0a557$export$887205bd69d98616 = (issueKey, promise)=>{
    if ($62bbe64876e0a557$export$1cb3db646823c411.has(issueKey)) return;
    $62bbe64876e0a557$export$1cb3db646823c411.set(issueKey, promise);
};
const $62bbe64876e0a557$export$96ebd2cbd0b02255 = (issueKey)=>$62bbe64876e0a557$export$1cb3db646823c411.get(issueKey);
const $62bbe64876e0a557$export$508dd20a392e9f51 = (issueKey)=>$62bbe64876e0a557$export$1cb3db646823c411.has(issueKey);
const $62bbe64876e0a557$export$d2adf65b87e47523 = ()=>$62bbe64876e0a557$export$1cb3db646823c411.clear();

});



parcelRegister("9OxOE", function(module, exports) {

$parcel$export(module.exports, "blockedOnBackendEntryLog", () => $93a7d723277e8ab3$export$dd1b3502b1e8ca97);
$parcel$export(module.exports, "getBackendBlockingTime", () => $93a7d723277e8ab3$export$8720c1f879c7ca46);

var $6iz4v = parcelRequire("6iz4v");


var $fxvfh = parcelRequire("fxvfh");

var $aLdVB = parcelRequire("aLdVB");
const $93a7d723277e8ab3$export$dd1b3502b1e8ca97 = (0, $fxvfh.createBlockedOnBackendEntryLog)();
function $93a7d723277e8ab3$var$measureBlockingEntry(measureName, backendBlockingStart, backendBlockingEnd) {
    (0, $6iz4v.setMark)(`${measureName}Start`, {
        startTime: backendBlockingStart
    });
    (0, $6iz4v.setMark)(`${measureName}End`, {
        startTime: backendBlockingEnd
    });
    (0, $6iz4v.setMeasure)(`${measureName}`, `${measureName}Start`, `${measureName}End`);
}
const $93a7d723277e8ab3$export$8720c1f879c7ca46 = (args)=>{
    const { blockingStart: blockingStartOrZero, totalBlockingDuration: totalBlockingDuration } = (0, $aLdVB.getSimplifiedBlockingTime)($93a7d723277e8ab3$export$dd1b3502b1e8ca97);
    const backendBlockingStart = Math.max(args.issueViewLoad.startTime, blockingStartOrZero);
    // Add the marks to the issueViewLoad BM3 event
    const backendBlockingEnd = backendBlockingStart + totalBlockingDuration;
    args.issueViewLoad.mark($848ef1328a091c81$export$e52cc35f872875f7, backendBlockingEnd);
    args.issueViewLoad.mark($848ef1328a091c81$export$e64e32643802b552, backendBlockingStart);
    $93a7d723277e8ab3$export$dd1b3502b1e8ca97.getBlockedOnBackendEntries().forEach(([blockingReason, { blockingStart: blockingStart, blockingEnd: blockingEnd }])=>$93a7d723277e8ab3$var$measureBlockingEntry(`issueView_blockedOnBackend_${blockingReason}`, blockingStart, blockingEnd));
    return {
        issueDataAvailable: backendBlockingEnd,
        issueReadyForData: backendBlockingStart
    };
};

});
parcelRegister("fxvfh", function(module, exports) {

$parcel$export(module.exports, "createBlockedOnBackendEntryLog", () => $929fa833717a1818$export$44ddca89673a78bc);
const $929fa833717a1818$export$44ddca89673a78bc = ()=>{
    const blockedOnBackendState = {
        timestamps: {}
    };
    // Internal use, use initialiseBlockedOnBackendStateForUpdatedKey externally
    const clearBlockedOnBackendState = ()=>{
        blockedOnBackendState.timestamps = {};
        blockedOnBackendState.currentKey = undefined;
    };
    // Internal use, use markStartBackendBlockingTimestamp or markEndBackendBlockingTimestamp
    const getOrCreateTimestampsEntryForKey = (blockingReasonKey)=>{
        let blockingDurationTimestamps = blockedOnBackendState.timestamps[blockingReasonKey];
        if (!blockingDurationTimestamps) {
            blockingDurationTimestamps = {};
            blockedOnBackendState.timestamps[blockingReasonKey] = blockingDurationTimestamps;
        }
        return blockingDurationTimestamps;
    };
    /**
	 * Initialise the store for a given key string.
	 * Only resets the state the first if the key string updates from its initial undefined OR if the key updates from the last time this was called
	 */ const initialiseBlockedOnBackendStateForUpdatedKey = (key)=>{
        if (key !== blockedOnBackendState.currentKey) {
            clearBlockedOnBackendState();
            blockedOnBackendState.currentKey = key;
        }
    };
    /**
	 * Fire this to mark the start of being blocked on backend for a given reason.
	 * @param blockingReasonKey An identifier for the reason for blocking. Until state is re-initialised, this reason cannot be used again to start a blocking span. Overlapping reasons will not be double counted
	 * @param timestamp optional, defaults to current time
	 */ const markStartBackendBlockingTimestamp = (blockingReasonKey, timestamp = performance.now())=>{
        const blockingDurationTimestamps = getOrCreateTimestampsEntryForKey(blockingReasonKey);
        if (!blockingDurationTimestamps.blockingStart) blockingDurationTimestamps.blockingStart = timestamp;
    };
    /**
	 * Fire this to mark the end of being blocked on backend for a given reason
	 * @param blockingReasonKey
	 * @param timestamp optional, defaults to current time
	 */ const markEndBackendBlockingTimestamp = (blockingReasonKey, timestamp = performance.now())=>{
        const blockingDurationTimestamps = getOrCreateTimestampsEntryForKey(blockingReasonKey);
        if (!blockingDurationTimestamps.blockingEnd) blockingDurationTimestamps.blockingEnd = timestamp;
    };
    /**
	 * Return a list of the entries gathered so far
	 * @param sorted whether the returned results should be sorted based on their start time. true by default
	 */ const getBlockedOnBackendEntries = ({ sorted: sorted = true } = {})=>{
        let entries = Object.entries(blockedOnBackendState.timestamps).filter((entry)=>{
            const [, blockingTimestamps] = entry;
            return blockingTimestamps.blockingStart != null && blockingTimestamps.blockingEnd != null && blockingTimestamps.blockingStart <= blockingTimestamps.blockingEnd;
        });
        if (sorted) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        entries = entries.sort(([, { blockingStart: start1 }], [, { blockingStart: start2 }])=>start1 - start2);
        return entries;
    };
    return {
        initialiseBlockedOnBackendStateForUpdatedKey: initialiseBlockedOnBackendStateForUpdatedKey,
        markStartBackendBlockingTimestamp: markStartBackendBlockingTimestamp,
        markEndBackendBlockingTimestamp: markEndBackendBlockingTimestamp,
        getBlockedOnBackendEntries: getBlockedOnBackendEntries
    };
};

});

parcelRegister("aLdVB", function(module, exports) {

$parcel$export(module.exports, "getSimplifiedBlockingTime", () => $da7b43236f8323c7$export$580550d1d1ffca6c);

var $iHCl1 = parcelRequire("iHCl1");
const $da7b43236f8323c7$export$580550d1d1ffca6c = (entryLog)=>{
    const blockingTimestampEntries = entryLog.getBlockedOnBackendEntries({
        sorted: true
    });
    const blockingSpans = (0, $iHCl1.mergeOverlappingBlockingEntries)(blockingTimestampEntries);
    const blockingStartTimes = blockingSpans.map(({ blockingStart: blockingStart })=>blockingStart ?? 0);
    const blockingDurations = blockingSpans.map(({ blockingEnd: blockingEnd, blockingStart: blockingStart })=>blockingEnd - blockingStart);
    const blockingStart = Math.min(...blockingStartTimes.length ? blockingStartTimes : [
        0
    ]);
    const totalBlockingDuration = blockingDurations.reduce((a, b)=>a + b, 0);
    return {
        blockingStart: blockingStart,
        totalBlockingDuration: totalBlockingDuration
    };
};

});
parcelRegister("iHCl1", function(module, exports) {

$parcel$export(module.exports, "mergeOverlappingBlockingEntries", () => $1e46ae3ace8b54ee$export$e63ec487944afc72);
function $1e46ae3ace8b54ee$export$e63ec487944afc72(blockingTimestampEntriesSortedByStartTime) {
    return blockingTimestampEntriesSortedByStartTime.reduce((nonOverlappingSpans, [, { blockingStart: blockingStart, blockingEnd: blockingEnd }])=>{
        const lastSpan = nonOverlappingSpans[nonOverlappingSpans.length - 1];
        if (!lastSpan || blockingStart > lastSpan.blockingEnd) nonOverlappingSpans.push({
            blockingStart: blockingStart,
            blockingEnd: blockingEnd
        }); // add the span as-is to the known non-overlapping spans
        else if (lastSpan.blockingEnd < blockingEnd) lastSpan.blockingEnd = blockingEnd;
        return nonOverlappingSpans;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    []);
}

});



parcelRegister("9zAkH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "useMarkStartIssue", () => $d0592fb9ef27c1e7$export$4c581e637836aad);
$parcel$export(module.exports, "IssueAppWithRouteResources", () => $d0592fb9ef27c1e7$export$9c23739d7fb3072c);
$parcel$export(module.exports, "default", () => $d0592fb9ef27c1e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $hFmdR = parcelRequire("hFmdR");



var $7GSu6 = parcelRequire("7GSu6");

var $cSEXi = parcelRequire("cSEXi");

var $5gJbo = parcelRequire("5gJbo");

var $k1wt3 = parcelRequire("k1wt3");

var $f4Jgp = parcelRequire("f4Jgp");

var $kB5wN = parcelRequire("kB5wN");

var $2inY8 = parcelRequire("2inY8");

var $5Vkv7 = parcelRequire("5Vkv7");

var $isela = parcelRequire("isela");

var $cGfT1 = parcelRequire("cGfT1");

var $dZlbi = parcelRequire("dZlbi");

var $cLIc8 = parcelRequire("cLIc8");

var $fPlP8 = parcelRequire("fPlP8");

var $gGtKh = parcelRequire("gGtKh");

var $hzcvF = parcelRequire("hzcvF");

var $c4qEZ = parcelRequire("c4qEZ");

var $6M8Uw = parcelRequire("6M8Uw");

var $cyQ1m = parcelRequire("cyQ1m");

var $idiDE = parcelRequire("idiDE");

var $8HMCF = parcelRequire("8HMCF");

var $jc4kK = parcelRequire("jc4kK");

var $68fMC = parcelRequire("68fMC");

var $bV8gg = parcelRequire("bV8gg");

var $bS6yX = parcelRequire("bS6yX");

var $gTJ9x = parcelRequire("gTJ9x");

var $03M3s = parcelRequire("03M3s");
var $htnxe = parcelRequire("htnxe");

var $6Zcji = parcelRequire("6Zcji");

var $cMPNN = parcelRequire("cMPNN");

var $1No38 = parcelRequire("1No38");

var $2u9YV = parcelRequire("2u9YV");
/**
 * Locations that allow to close on Escape being pressed
 */ const $d0592fb9ef27c1e7$var$closeOnEscapeLocations = new Set([
    (0, $0100842672acae20$export$9c5d81b901471b27),
    (0, $0100842672acae20$export$53d41ff2666118e1)
]);
// "embed-issue" analyticSource is set from "browse/{issueKey}/embed" route
// and we consider this as a full page despite the use of word embed in it's name.
const $d0592fb9ef27c1e7$var$isFullPage = (analyticsSource)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [
        (0, $0100842672acae20$export$b19f949fb9713614),
        (0, $0100842672acae20$export$a5132300c5214280)
    ].includes(analyticsSource);
const $d0592fb9ef27c1e7$var$getRenderFeedbackForErrorBoundary = (analyticsSource)=>{
    // this should ideally be using isClickthroughAllowedSelector within the feedback component
    if ((0, $cLIc8.clickthroughAllowedSources).includes(analyticsSource)) return ()=>(0, $gTJ9x.renderFeedback)('');
    return undefined;
};
// TODO Decomp BENTO-12515 - convert to functional component
// eslint-disable-next-line jira/react/no-class-components
class $d0592fb9ef27c1e7$var$IssueAppInner extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            isLoadedWithPage: false,
            isSpaEnabled: false,
            shouldShowRootProjectsBreadcrumb: false,
            viewModeOptions: {
                viewModeSwitchEnabled: false
            },
            onClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onIssueDeleteSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onIssueDeleteFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    componentDidMount() {
        if (this.canCloseOnEsc()) document.addEventListener('keydown', this.onEscape);
    }
    componentWillUnmount() {
        if (this.canCloseOnEsc()) document.removeEventListener('keydown', this.onEscape);
    }
    renderHeader() {
        const { onClose: onClose, shouldShowCloseButton: shouldShowCloseButton, shouldShowProjectLevelBreadcrumb: shouldShowProjectLevelBreadcrumb, shouldShowRootProjectsBreadcrumb: shouldShowRootProjectsBreadcrumb, onIssueDeleteSuccess: onIssueDeleteSuccess, onIssueDeleteFailure: onIssueDeleteFailure, viewModeOptions: viewModeOptions } = this.props;
        if (!this.isMobile()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fPlP8.default), {
            shouldUseDeprecatedScrollParent: true,
            elementId: (0, $cSEXi.ELID_ISSUE_HEADER),
            style: {
                // TODO Delete this comment after verifying space token -> previous value ``${gridSize * 3}px``
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                paddingLeft: "var(--ds-space-300, 24px)",
                // TODO Delete this comment after verifying space token -> previous value ``${gridSize * 3}px``
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                paddingRight: "var(--ds-space-300, 24px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dZlbi.default), {
            shouldShowCloseButton: !!shouldShowCloseButton,
            shouldShowProjectLevelBreadcrumb: !!shouldShowProjectLevelBreadcrumb,
            shouldShowRootProjectsBreadcrumb: !!shouldShowRootProjectsBreadcrumb,
            issueDeleteCallbacks: {
                onIssueDeleteSuccess: onIssueDeleteSuccess,
                onIssueDeleteFailure: onIssueDeleteFailure
            },
            onClose: onClose,
            renderFeedback: this.getRenderFeedback(),
            viewModeOptions: viewModeOptions
        }));
    }
    render() {
        const { analyticsSource: analyticsSource, analyticsMetadata: analyticsMetadata, backButtonUrl: backButtonUrl, dispatchExternalActionRef: dispatchExternalActionRef, ecosystemEnabled: ecosystemEnabled, estimationStatistic: estimationStatistic, history: history, isLoadedWithPage: isLoadedWithPage, isSpaEnabled: isSpaEnabled, issueActions: issueActions, issueKey: issueKey, loginRedirectUrl: loginRedirectUrl, metrics: metrics, onChange: onChange, onError: onError, onIssueKeyChange: onIssueKeyChange, rapidViewId: rapidViewId, rapidViewMap: rapidViewMap, viewModeOptions: viewModeOptions, issueMaxWidth: issueMaxWidth, issueNavigatorData: issueNavigatorData, prefetchedResourceManager: prefetchedResourceManager, issueAggQueryData: issueAggQueryData } = this.props;
        const appProviderProps = {
            analyticsSource: analyticsSource,
            analyticsMetadata: analyticsMetadata,
            backButtonUrl: backButtonUrl,
            dispatchExternalActionRef: dispatchExternalActionRef,
            ecosystemEnabled: ecosystemEnabled,
            estimationStatistic: estimationStatistic,
            history: history,
            isLoadedWithPage: isLoadedWithPage,
            isSpaEnabled: isSpaEnabled,
            issueActions: issueActions,
            issueKey: issueKey,
            issueNavigatorData: issueNavigatorData,
            loginRedirectUrl: loginRedirectUrl,
            metrics: metrics,
            onChange: onChange,
            onError: onError,
            onIssueKeyChange: onIssueKeyChange,
            rapidViewId: rapidViewId,
            rapidViewMap: rapidViewMap,
            viewMode: viewModeOptions && viewModeOptions.viewMode
        };
        const SingleColumnSectionWrapperFF = !this.isMobile() ? (0, $1No38.SingleColumnSectionWrapper) : (0, $eUqFw.Fragment);
        const SingleColumnSectionWrapperInnerFF = !this.isMobile() ? (0, $1No38.SingleColumnSectionWrapperInner) : (0, $eUqFw.Fragment);
        const compactModeChildren = (issueViewRelayFragment)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GSu6.StickyHeaderTrackerContainer), {
                scope: "issue-app"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SingleColumnSectionWrapperFF, {
                issueMaxWidth: issueMaxWidth
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SingleColumnSectionWrapperInnerFF, null, this.renderChangeboardingTour(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bV8gg.default), {
                renderTopBanner: this.renderStorageLimitsBanner
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bV8gg.default), {
                renderTopBanner: this.renderTopBanner
            }), this.renderHeader())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $68fMC.default), null), this.renderIssueView(issueViewRelayFragment), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Zcji.default), {
                currentIssueKey: issueKey
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cMPNN.default), {
                currentIssueKey: issueKey
            }));
        const renderAppProviderChildren = (issueViewRelayFragment)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $isela.default), {
                location: analyticsSource
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kB5wN.CompactModeProvider), null, compactModeChildren(issueViewRelayFragment)));
        // the appProvider no longer throws errors on AGG failures, the error boundary needs to be pulled above the IssueViewCriticalQueryPreloader
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
            name: "issue-app"
        }, this.isFullPage(analyticsSource) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $03M3s.default), {
            prefetchedResourceManager: prefetchedResourceManager,
            issueAggQueryData: issueAggQueryData,
            preloadedQuery: undefined,
            giraResponsePromise: undefined,
            ...appProviderProps
        }, renderAppProviderChildren));
    }
    constructor(...args){
        super(...args);
        this.onEscape = (event)=>{
            if ((0, $5gJbo.isKeyEscapeEvent)(event)) {
                this.props.onClose();
                event.preventDefault();
            }
        };
        this.canCloseOnEsc = ()=>$d0592fb9ef27c1e7$var$closeOnEscapeLocations.has(this.props.analyticsSource);
        this.getRenderFeedback = ()=>{
            const { analyticsSource: analyticsSource } = this.props;
            // this should ideally be using isClickthroughAllowedSelector within the feedback component
            if ((0, $cLIc8.clickthroughAllowedSources).includes(analyticsSource)) return 0, $gTJ9x.renderFeedback;
            return undefined;
        };
        this.renderStorageLimitsBanner = ()=>{
            const { analyticsSource: analyticsSource } = this.props;
            if ((0, $cLIc8.clickthroughAllowedSources).includes(analyticsSource)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyQ1m.StorageLimitsBanner), {
                isFullWidth: true
            });
            return null;
        };
        this.renderTopBanner = ()=>{
            const { analyticsSource: analyticsSource } = this.props;
            if ((0, $cLIc8.clickthroughAllowedSources).includes(analyticsSource)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8HMCF.UpFlowPersistentUpgradeBanner), {
                isBannerEnabled: true,
                isFullWidth: true
            });
            return null;
        };
        this.renderIssueView = (issueViewRelayFragment)=>{
            const issueViewProps = this.getIssueViewProps(issueViewRelayFragment);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2u9YV.default), issueViewProps);
        };
        this.renderChangeboardingTour = ()=>{
            /** sources that show "take a tour" in the dropdown  */ const analyticsSourceTourWhitelist = [
                (0, $0100842672acae20$export$b19f949fb9713614),
                (0, $0100842672acae20$export$7063ee6d0035a982),
                (0, $0100842672acae20$export$5bd5011b6596a0e7),
                (0, $0100842672acae20$export$cebf0bc8b2ccaf57)
            ];
            const shouldRenderChangeboarding = analyticsSourceTourWhitelist.includes(this.props.analyticsSource);
            return shouldRenderChangeboarding ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bS6yX.ChangeBoardingTour), null) : null;
        };
        this.isMobile = ()=>this.props.analyticsSource === (0, $0100842672acae20$export$ce88447986394f2d);
        this.isFullPage = (analyticsSource)=>$d0592fb9ef27c1e7$var$isFullPage(analyticsSource);
        this.getIssueViewProps = (issueViewRelayFragment)=>({
                renderFeedback: this.getRenderFeedback(),
                issueDeleteCallbacks: {
                    onIssueDeleteSuccess: this.props.onIssueDeleteSuccess,
                    onIssueDeleteFailure: this.props.onIssueDeleteFailure
                },
                viewModeOptions: this.props.viewModeOptions,
                onClose: this.props.onClose,
                shouldSetInitialFocus: this.props.shouldSetInitialFocus,
                shouldShowProjectLevelBreadcrumb: this.props.shouldShowProjectLevelBreadcrumb,
                shouldShowRootProjectsBreadcrumb: this.props.shouldShowProjectLevelBreadcrumb,
                shouldShowCloseButton: this.props.shouldShowCloseButton,
                issueMaxWidth: this.props.issueMaxWidth,
                isScrollingHotkeysDisabled: this.props.isScrollingHotkeysDisabled,
                issueViewRelayFragment: issueViewRelayFragment
            });
    }
}
const $d0592fb9ef27c1e7$export$4c581e637836aad = (props)=>{
    const { analyticsSource: analyticsSource, issueKey: issueKey } = props;
    const previousCurrentIssueKey = (0, $hzcvF.usePrevious)(issueKey);
    (0, $eUqFw.useMemo)(()=>{
        if (issueKey !== previousCurrentIssueKey) (0, $jc4kK.markStartIssue)($d0592fb9ef27c1e7$var$isFullPage(analyticsSource));
    }, [
        analyticsSource,
        issueKey,
        previousCurrentIssueKey
    ]);
};
function $d0592fb9ef27c1e7$var$renderWithErrorBoundary(props, node) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Vkv7.IssueViewExperienceTrackingProviders), {
        issueKey: props.issueKey,
        analyticsSource: props.analyticsSource,
        isExperienceReady: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2inY8.IssueViewErrorBoundary), {
        errorBoundaryId: "issue-view-app-provider",
        renderFeedback: $d0592fb9ef27c1e7$var$getRenderFeedbackForErrorBoundary(props.analyticsSource),
        loginRedirectUrl: props.loginRedirectUrl,
        issueKey: props.issueKey,
        fallback: (errorComponent)=>props.viewModeOptions?.viewMode === (0, $935e771f19f8ea28$export$705305d6da432040) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGfT1.ErrorPage), {
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                onClose: props.onClose ?? (()=>{}),
                renderFeedback: $d0592fb9ef27c1e7$var$getRenderFeedbackForErrorBoundary(props.analyticsSource)
            }, errorComponent) : errorComponent
    }, node));
}
const $d0592fb9ef27c1e7$var$IssueAppInnerWithAnalyticsSubject = (0, $hFmdR.AnalyticsSubject)('issue')($d0592fb9ef27c1e7$var$IssueAppInner);
const $d0592fb9ef27c1e7$export$9c23739d7fb3072c = ({ preloadedQuery: preloadedQuery, ...props })=>{
    $d0592fb9ef27c1e7$export$4c581e637836aad(props);
    return preloadedQuery ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f4Jgp.PrefetchedResourceStoreContainer), null, $d0592fb9ef27c1e7$var$renderWithErrorBoundary(props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $htnxe.IssueViewRouteResourceConsumer), {
        issueKey: props.issueKey,
        preloadedQuery: preloadedQuery
    }, ({ prefetchedResourceManager: prefetchedResourceManager, issueAggQueryData: issueAggQueryData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0592fb9ef27c1e7$var$IssueAppInnerWithAnalyticsSubject, {
            ...props,
            prefetchedResourceManager: prefetchedResourceManager,
            issueAggQueryData: issueAggQueryData
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), null);
};
const $d0592fb9ef27c1e7$var$IssueAppWithCriticalQueryPreloader = (props)=>{
    $d0592fb9ef27c1e7$export$4c581e637836aad(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f4Jgp.PrefetchedResourceStoreContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-view-skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), null)
    }, $d0592fb9ef27c1e7$var$renderWithErrorBoundary(props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $htnxe.IssueViewCriticalQueryPreloader), {
        issueKey: props.issueKey
    }, ({ prefetchedResourceManager: prefetchedResourceManager, issueAggQueryData: issueAggQueryData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0592fb9ef27c1e7$var$IssueAppInnerWithAnalyticsSubject, {
            ...props,
            prefetchedResourceManager: prefetchedResourceManager,
            issueAggQueryData: issueAggQueryData
        })))));
};
var $d0592fb9ef27c1e7$export$2e2bcd8739ae039 = $d0592fb9ef27c1e7$var$IssueAppWithCriticalQueryPreloader;
(0, $k1wt3.markEvalEnd)();

});
const $935e771f19f8ea28$export$98c0ebc22792f04 = 'MODAL';
const $935e771f19f8ea28$export$705305d6da432040 = 'SIDEBAR';
const $935e771f19f8ea28$export$2d037fdba4f67558 = 'DEFAULT';
const $935e771f19f8ea28$export$8bcece6b344db0b9 = 'FIELD';
const $935e771f19f8ea28$export$f65dd83d96b675ee = 'DEV_SUMMARY';
const $935e771f19f8ea28$export$971ccedc18d35178 = 'RELEASES_PANEL';
const $935e771f19f8ea28$export$18e4c648db363204 = 'PANEL';
const $935e771f19f8ea28$export$7f66491e43ca5015 = 'TAB';

parcelRegister("7GSu6", function(module, exports) {

$parcel$export(module.exports, "useStickyHeaderOffset", () => $3bb2e15d52f8119e$export$c33bd22044e575d1);
$parcel$export(module.exports, "useStickyHeaderRegistration", () => $3bb2e15d52f8119e$export$291da52247620252);
$parcel$export(module.exports, "StickyHeaderTrackerContainer", () => $3bb2e15d52f8119e$export$f6f412040608a75c);
$parcel$export(module.exports, "useStickyHeader", () => $3bb2e15d52f8119e$export$3a5ae2edeb8648ad);
/*
This service tracks sticky headers and keeps a ref to the tallest one.
*/ 
var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $44sqT = parcelRequire("44sqT");
const $3bb2e15d52f8119e$var$initialState = {
    offset: 0,
    stickies: null,
    headerRef: null,
    headerHeight: undefined
};
/**
 * Of all the stickies which are currently registered (i.e. stuck to the top)
 * which one is the tallest? We can dock other things to that.
 */ const $3bb2e15d52f8119e$var$findTallestHeader = (stickies)=>[
        ...stickies.values()
    ].reduce((tallest, current)=>{
        // note the side effect - without ResizeObserver not yet reported result or disabled we will read height directly
        // eslint-disable-next-line no-param-reassign
        current.height = (current.height ?? current.ref.current?.clientHeight) || 0;
        return current.height >= (tallest?.height || 0) ? current : tallest;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    undefined);
const $3bb2e15d52f8119e$var$Store = (0, $a61MH.createStore)({
    initialState: $3bb2e15d52f8119e$var$initialState,
    actions: {
        /**
		 * recalculates current header information
		 */ invalidate: ()=>({ setState: setState, getState: getState })=>{
                const { stickies: stickies } = getState();
                if (!stickies) return;
                const tallest = $3bb2e15d52f8119e$var$findTallestHeader(stickies);
                setState(tallest ? {
                    headerRef: tallest.ref,
                    headerHeight: (tallest.height || 0) + (tallest.options.marginBottom || 0)
                } : {
                    headerRef: null,
                    headerHeight: undefined
                });
            },
        registerSticky: (name, stickyRef, options = {})=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
                // initial value of Store not wrapped in a Container is "null"
                const stickies = getState().stickies || new Map();
                // set stickies back as they might be re-initialized.
                // Setting back the same value causes no effect
                setState({
                    stickies: stickies
                });
                if (stickies.has(name)) return;
                const stick = {
                    ref: stickyRef,
                    options: options,
                    height: undefined,
                    observer: undefined
                };
                stickies.set(name, stick);
                // set to "non-undefined" to prune "clientHeight" branch and speedup rendering
                // resize observer will trigger after initial setup and measure node in the "best time"(for Browser)
                // configureResizeObserver will "undo" this if ResizeObserver is not supported
                stick.height = 0;
                stick.observer = (0, $44sqT.configureResizeObserver)(stickyRef.current, ({ height: height })=>{
                    stick.height = height;
                    dispatch($3bb2e15d52f8119e$var$Store.actions.invalidate());
                });
            },
        deregisterSticky: (name)=>({ getState: getState, dispatch: dispatch })=>{
                const { stickies: stickies } = getState();
                const record = stickies?.get(name);
                if (!record || !stickies) return;
                record.observer?.disconnect();
                stickies.delete(name);
                dispatch($3bb2e15d52f8119e$var$Store.actions.invalidate());
            }
    },
    name: 'sticky-header'
});
const $3bb2e15d52f8119e$export$6b384e0f28444f38 = (0, $dYfll.createSubscriber)($3bb2e15d52f8119e$var$Store);
const $3bb2e15d52f8119e$var$StickyHeaderTrackerStateContainer = (0, $heB5U.createContainer)($3bb2e15d52f8119e$var$Store, {
    onInit: ()=>({ setState: setState }, options)=>setState({
                stickies: new Map(),
                offset: options.offset || 0
            }),
    onCleanup: ()=>({ getState: getState })=>{
            getState().stickies?.forEach(({ observer: observer })=>{
                if (observer) observer.disconnect();
            });
        },
    onUpdate: ()=>({ setState: setState, dispatch: dispatch }, options)=>{
            setState(options);
            dispatch($3bb2e15d52f8119e$var$Store.actions.invalidate());
        }
});
const $3bb2e15d52f8119e$export$8c6a43adadd5655b = (0, $ggKAj.createHook)($3bb2e15d52f8119e$var$Store);
const $3bb2e15d52f8119e$export$c33bd22044e575d1 = (0, $ggKAj.createStateHook)($3bb2e15d52f8119e$var$Store, {
    selector: (state)=>(state.headerHeight || 0) + state.offset
});
const $3bb2e15d52f8119e$export$291da52247620252 = (0, $ggKAj.createActionsHook)($3bb2e15d52f8119e$var$Store);
const $3bb2e15d52f8119e$export$f6f412040608a75c = ({ scope: scope, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3bb2e15d52f8119e$var$StickyHeaderTrackerStateContainer, {
        scope: scope,
        offset: $3bb2e15d52f8119e$export$c33bd22044e575d1()
    }, children);
const $3bb2e15d52f8119e$export$3a5ae2edeb8648ad = ()=>[
        $3bb2e15d52f8119e$export$c33bd22044e575d1(),
        true
    ];

});
parcelRegister("44sqT", function(module, exports) {

$parcel$export(module.exports, "configureResizeObserver", () => $0f53881a61bcd1f4$export$6f2bc10c2cabce07);
const $0f53881a61bcd1f4$export$6f2bc10c2cabce07 = (element, callback)=>{
    if (element && window.ResizeObserver) {
        /*
		 * it's more common to have one observer to track multiple elements using single Observer
		 * using multiple ones here to simplify logic
		 * plus there just a few headings to track
		 */ const observer = new ResizeObserver((entries)=>{
            const { borderBoxSize: borderBoxSize } = entries[0];
            // JIV-13952: borderBoxSize might have length of 0, it also might not array at all for old browsers (Firefox < 69 )
            // in this case fallback to `undefined` which will trigger `clientHeight`-based calculations at findTallestHeader
            // borderBoxSize might not be present as well
            const height = borderBoxSize?.[0]?.blockSize;
            callback({
                height: height
            });
        });
        observer.observe(element);
        return observer;
    }
    // in case of ResizeObserver not supported - reactivate `clientHeight fallback`
    callback({
        height: undefined
    });
    return undefined;
};

});


parcelRegister("cSEXi", function(module, exports) {

$parcel$export(module.exports, "issueAppModalWrapperClassName", () => $071d2ef9b60c04f2$export$6bf7918be801e6c5);
$parcel$export(module.exports, "MODAL_DROPDOWN_PORTAL_CLASS_NAME", () => $071d2ef9b60c04f2$export$bab98b619b4558be);
$parcel$export(module.exports, "EDITOR_DROPDOWN_PORTAL_CLASS_NAME", () => $071d2ef9b60c04f2$export$2ec9dc4e52ec0b5d);
$parcel$export(module.exports, "EDITOR_END_CLASS_NAME", () => $071d2ef9b60c04f2$export$18cffbebfac64f6d);
$parcel$export(module.exports, "EDITOR_START_CLASS_NAME", () => $071d2ef9b60c04f2$export$ebb284f63692b8b2);
$parcel$export(module.exports, "ELID_ISSUE_HEADER", () => $071d2ef9b60c04f2$export$4ca9dd62cc85a6c6);
$parcel$export(module.exports, "ELID_ISSUE_HEADER_ACTIONS", () => $071d2ef9b60c04f2$export$23d48b936935fa57);
$parcel$export(module.exports, "AGG_ISSUE_ERROR_ANALYTICS", () => $071d2ef9b60c04f2$export$66553a9be1be2f7e);

var $0NycV = parcelRequire("0NycV");

var $4Xcha = parcelRequire("4Xcha");

var $anFLA = parcelRequire("anFLA");

var $hc60A = parcelRequire("hc60A");

var $eTy9x = parcelRequire("eTy9x");

var $fkvsU = parcelRequire("fkvsU");




var $hU5kA = parcelRequire("hU5kA");

var $cUHte = parcelRequire("cUHte");


var $cd8TS = parcelRequire("cd8TS");
const $071d2ef9b60c04f2$export$6bf7918be801e6c5 = '_issue-app-modal-dialog-wrapper';
const $071d2ef9b60c04f2$export$bab98b619b4558be = 'issue-app-modal-ak-dropdown-portal';
const $071d2ef9b60c04f2$export$2ec9dc4e52ec0b5d = 'issue-app-modal-editor-dropdown-portal';
const $071d2ef9b60c04f2$export$18cffbebfac64f6d = 'issue-editor-end';
const $071d2ef9b60c04f2$export$ebb284f63692b8b2 = 'issue-editor-start';
const $071d2ef9b60c04f2$export$3ef7e400a3598524 = 'issue.error';
const $071d2ef9b60c04f2$export$4ca9dd62cc85a6c6 = 'jira-issue-header';
const $071d2ef9b60c04f2$export$23d48b936935fa57 = 'jira-issue-header-actions';
const $071d2ef9b60c04f2$export$66553a9be1be2f7e = 'issue.error.agg';

});
parcelRegister("0NycV", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_WATCHING_ERROR", () => $033d5acebc8ea430$export$ec8031e221d27341);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_GENERIC", () => $033d5acebc8ea430$export$78f84210a13989cb);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_INVALID", () => $033d5acebc8ea430$export$10b0b01977598ffc);
$parcel$export(module.exports, "COMMENT_CONTENT_EXCEEDED_ERROR", () => $033d5acebc8ea430$export$9b38ca770beaf3d0);
$parcel$export(module.exports, "SAVE_COMMENT_SUCCESS_FLAG_MESSAGE", () => $033d5acebc8ea430$export$eef81693e817e3a6);
$parcel$export(module.exports, "COMMENT_FUTURE_TIME_ERROR", () => $033d5acebc8ea430$export$a0d4d86bde270ad6);
$parcel$export(module.exports, "COMMENT_DELETE_ERROR", () => $033d5acebc8ea430$export$6b6cd1b99772a4a1);
$parcel$export(module.exports, "EDITOR_ERROR", () => $033d5acebc8ea430$export$2e48be8618f1b4f8);
$parcel$export(module.exports, "ATTACHMENT_ADD_ERROR", () => $033d5acebc8ea430$export$c060b7873ebc2eb3);
$parcel$export(module.exports, "ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR", () => $033d5acebc8ea430$export$1f8e6f6f8d64a715);
$parcel$export(module.exports, "ATTACHMENT_ADD_SUCCESS", () => $033d5acebc8ea430$export$1f92a25b34c4df93);
$parcel$export(module.exports, "DELETE_LINKED_ISSUE_ERROR", () => $033d5acebc8ea430$export$d8750340852b965e);
$parcel$export(module.exports, "REMOTE_LINK_VALIDATION_ERROR", () => $033d5acebc8ea430$export$f0962d071c2a358a);
$parcel$export(module.exports, "ATTACHMENT_DELETE_ERROR", () => $033d5acebc8ea430$export$ef7767ceecf9097c);
$parcel$export(module.exports, "WATCH_TOGGLE_UPDATE_ERROR", () => $033d5acebc8ea430$export$516af79f4e3b8794);
$parcel$export(module.exports, "FETCH_WATCHERS_ERROR", () => $033d5acebc8ea430$export$cde4105f7711a10a);
$parcel$export(module.exports, "STOP_WATCHING_SUCCESS", () => $033d5acebc8ea430$export$f674d1f44f57f99d);
$parcel$export(module.exports, "START_WATCHING_SUCCESS", () => $033d5acebc8ea430$export$bff6b5ab70bcec53);
$parcel$export(module.exports, "REMOVE_WATCHER_ERROR", () => $033d5acebc8ea430$export$37934e343a22c4e6);
$parcel$export(module.exports, "ADD_WATCHER_ERROR", () => $033d5acebc8ea430$export$6a1827094c1ef6d8);
$parcel$export(module.exports, "SUBTASKS_REORDER_ERROR_GENERIC", () => $033d5acebc8ea430$export$bb96d519395e5dcc);
$parcel$export(module.exports, "LOG_WORK_CONFIRM_ERROR", () => $033d5acebc8ea430$export$18bd55ba676f8b6d);
$parcel$export(module.exports, "ASSIGN_TO_ME_SUCCESS", () => $033d5acebc8ea430$export$1249a100986a9489);
$parcel$export(module.exports, "REMOVE_FROM_ME_SUCCESS", () => $033d5acebc8ea430$export$6b737093486e5a4e);
$parcel$export(module.exports, "CREATE_CHILD_ISSUE_ERROR", () => $033d5acebc8ea430$export$a2723f15441225d0);
$parcel$export(module.exports, "LINK_CHILD_ISSUE_ERROR", () => $033d5acebc8ea430$export$569f7258d337be55);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_SUCCESS", () => $033d5acebc8ea430$export$f92af4e9761d23b9);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_ERROR", () => $033d5acebc8ea430$export$16dc9ff6a8822a90);
$parcel$export(module.exports, "DELETE_ISSUE_ERROR", () => $033d5acebc8ea430$export$d4030883b7b7a04);
$parcel$export(module.exports, "ADD_WORKLOG_SUCCESS", () => $033d5acebc8ea430$export$2519b72aefd62ee3);
$parcel$export(module.exports, "ADD_WORKLOG_FAILURE", () => $033d5acebc8ea430$export$190e4e4a6ee2a0a2);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$f1709ebef49207cc);
$parcel$export(module.exports, "UPDATE_TIME_REMAINING_FAILURE", () => $033d5acebc8ea430$export$bde55584c7518e8d);
$parcel$export(module.exports, "EDIT_WORKLOG_SUCCESS", () => $033d5acebc8ea430$export$cf8d549e537c67d3);
$parcel$export(module.exports, "EDIT_WORKLOG_FAILURE", () => $033d5acebc8ea430$export$2d33e591258e36a8);
$parcel$export(module.exports, "DELETE_WORKLOG_SUCCESS", () => $033d5acebc8ea430$export$b595535e9bb1a2a2);
$parcel$export(module.exports, "DELETE_WORKLOG_FAILURE", () => $033d5acebc8ea430$export$c3739a68f63b7e09);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_CONFIRM_ERROR", () => $033d5acebc8ea430$export$6ba6cb22d5a3c521);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR", () => $033d5acebc8ea430$export$b1a41c9183097dc);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_REQUIRED_ERROR", () => $033d5acebc8ea430$export$67544887e2b37fbc);
$parcel$export(module.exports, "DELETE_CONFLUENCE_PAGE_LINK_FAILED", () => $033d5acebc8ea430$export$67566c205c72838a);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_ERROR", () => $033d5acebc8ea430$export$733fe45ab8c75209);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_SUCCESS", () => $033d5acebc8ea430$export$9d1386a2d0651ca9);
$parcel$export(module.exports, "EDIT_EPIC_COLOUR_ERROR", () => $033d5acebc8ea430$export$56094d7f6af14eac);
$parcel$export(module.exports, "EDIT_ISSUE_COLOUR_ERROR", () => $033d5acebc8ea430$export$92d58445895900f9);
$parcel$export(module.exports, "FETCH_JIRA_APP_LINKS_ERROR", () => $033d5acebc8ea430$export$75d850be4d27b98e);
$parcel$export(module.exports, "CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$9030bf81702823b8);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$a2a71fb6b193e549);
$parcel$export(module.exports, "ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$8c5e4d3dfe9a1c32);
$parcel$export(module.exports, "ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$49d11338d75de478);
$parcel$export(module.exports, "ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$3573d8ff428b4c8f);
$parcel$export(module.exports, "COMMENTS_LIMIT_EXCEEDED_FIELDS_LIST", () => $033d5acebc8ea430$export$c0657c5ed1bbfed4);
const $033d5acebc8ea430$export$ec8031e221d27341 = 'TOGGLE_WATCHING_ERROR';
const $033d5acebc8ea430$export$78f84210a13989cb = 'COMMENT_ADD_ERROR_GENERIC';
const $033d5acebc8ea430$export$10b0b01977598ffc = 'COMMENT_ADD_ERROR_INVALID';
const $033d5acebc8ea430$export$9b38ca770beaf3d0 = 'COMMENT_CONTENT_EXCEEDED_ERROR';
const $033d5acebc8ea430$export$eef81693e817e3a6 = 'SAVE_COMMENT_SUCCESS_FLAG_MESSAGE';
const $033d5acebc8ea430$export$a0d4d86bde270ad6 = 'COMMENT_FUTURE_TIME_ERROR';
const $033d5acebc8ea430$export$6b6cd1b99772a4a1 = 'COMMENT_DELETE_ERROR';
const $033d5acebc8ea430$export$2e48be8618f1b4f8 = 'EDITOR_ERROR';
const $033d5acebc8ea430$export$c060b7873ebc2eb3 = 'ATTACHMENT_ADD_ERROR';
const $033d5acebc8ea430$export$1f8e6f6f8d64a715 = 'ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR';
const $033d5acebc8ea430$export$1f92a25b34c4df93 = 'ATTACHMENT_ADD_SUCCESS';
const $033d5acebc8ea430$export$d8750340852b965e = 'DELETE_LINKED_ISSUE_ERROR';
const $033d5acebc8ea430$export$f0962d071c2a358a = 'REMOTE_LINK_VALIDATION_ERROR';
const $033d5acebc8ea430$export$ef7767ceecf9097c = 'ATTACHMENT_DELETE_ERROR';
const $033d5acebc8ea430$export$516af79f4e3b8794 = 'WATCH_TOGGLE_UPDATE_ERROR';
const $033d5acebc8ea430$export$cde4105f7711a10a = 'FETCH_WATCHERS_ERROR';
const $033d5acebc8ea430$export$f674d1f44f57f99d = 'STOP_WATCHING_SUCCESS';
const $033d5acebc8ea430$export$bff6b5ab70bcec53 = 'START_WATCHING_SUCCESS';
const $033d5acebc8ea430$export$37934e343a22c4e6 = 'REMOVE_WATCHER_ERROR';
const $033d5acebc8ea430$export$6a1827094c1ef6d8 = 'ADD_WATCHER_ERROR';
const $033d5acebc8ea430$export$bb96d519395e5dcc = 'SUBTASKS_REORDER_ERROR_GENERIC';
const $033d5acebc8ea430$export$18bd55ba676f8b6d = 'LOG_WORK_CONFIRM_ERROR';
const $033d5acebc8ea430$export$1249a100986a9489 = 'ASSIGN_TO_ME_SUCCESS';
const $033d5acebc8ea430$export$6b737093486e5a4e = 'REMOVE_FROM_ME_SUCCESS';
const $033d5acebc8ea430$export$a2723f15441225d0 = 'CREATE_CHILD_ISSUE_ERROR';
const $033d5acebc8ea430$export$569f7258d337be55 = 'LINK_CHILD_ISSUE_ERROR';
const $033d5acebc8ea430$export$f92af4e9761d23b9 = 'CHANGE_ISSUE_TYPE_SUCCESS';
const $033d5acebc8ea430$export$16dc9ff6a8822a90 = 'CHANGE_ISSUE_TYPE_ERROR';
const $033d5acebc8ea430$export$d4030883b7b7a04 = 'DELETE_ISSUE_ERROR';
const $033d5acebc8ea430$export$2519b72aefd62ee3 = 'ADD_WORKLOG_SUCCESS';
const $033d5acebc8ea430$export$190e4e4a6ee2a0a2 = 'ADD_WORKLOG_FAILURE';
const $033d5acebc8ea430$export$f1709ebef49207cc = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$2357f9add92f1c9b = 'UPDATE_TIME_REMAINING_SUCCESS';
const $033d5acebc8ea430$export$bde55584c7518e8d = 'UPDATE_TIME_REMAINING_FAILURE';
const $033d5acebc8ea430$export$cf8d549e537c67d3 = 'EDIT_WORKLOG_SUCCESS';
const $033d5acebc8ea430$export$2d33e591258e36a8 = 'EDIT_WORKLOG_FAILURE';
const $033d5acebc8ea430$export$b595535e9bb1a2a2 = 'DELETE_WORKLOG_SUCCESS';
const $033d5acebc8ea430$export$c3739a68f63b7e09 = 'DELETE_WORKLOG_FAILURE';
const $033d5acebc8ea430$export$6ba6cb22d5a3c521 = 'RICH_CONTENT_FIELD_CONFIRM_ERROR';
const $033d5acebc8ea430$export$b1a41c9183097dc = 'RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR';
const $033d5acebc8ea430$export$67544887e2b37fbc = 'RICH_CONTENT_FIELD_REQUIRED_ERROR';
const $033d5acebc8ea430$export$67566c205c72838a = 'DELETE_CONFLUENCE_PAGE_LINK_FAILED';
const $033d5acebc8ea430$export$e3245a362f751a4a = 'DELETE_WEB_LINK_FAILED';
const $033d5acebc8ea430$export$3408969e4d418350 = 'CLICKTHROUGH_BANNER_DISMISS_SUCCESS';
const $033d5acebc8ea430$export$733fe45ab8c75209 = 'SAVE_APPROVAL_ANSWER_ERROR';
const $033d5acebc8ea430$export$9d1386a2d0651ca9 = 'SAVE_APPROVAL_ANSWER_SUCCESS';
const $033d5acebc8ea430$export$56094d7f6af14eac = 'EDIT_EPIC_COLOUR_ERROR';
const $033d5acebc8ea430$export$92d58445895900f9 = 'EDIT_ISSUE_COLOUR_ERROR';
const $033d5acebc8ea430$export$75d850be4d27b98e = 'FETCH_JIRA_APP_LINKS_ERROR';
const $033d5acebc8ea430$export$9030bf81702823b8 = 'CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$a2a71fb6b193e549 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$2dd786d54c8f9397 = 'COMMENTS_INTERNAL_SERVER_ERROR';
const $033d5acebc8ea430$export$8c5e4d3dfe9a1c32 = 'ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$49d11338d75de478 = 'ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$3573d8ff428b4c8f = 'ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$c0657c5ed1bbfed4 = [
    $033d5acebc8ea430$export$a2a71fb6b193e549,
    $033d5acebc8ea430$export$3573d8ff428b4c8f
];

});

parcelRegister("4Xcha", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $c7ce8bed5d2ff289$export$89b6937a83edcaa6);
$parcel$export(module.exports, "EXCEEDED_LIMIT_INITIAL_LOAD", () => $c7ce8bed5d2ff289$export$763881dbba851043);
$parcel$export(module.exports, "EXCEEDED_LIMIT_AFTER_LOAD", () => $c7ce8bed5d2ff289$export$8a23145a6d5f95e3);
$parcel$export(module.exports, "WITHIN_LIMIT", () => $c7ce8bed5d2ff289$export$a7af19981a3e4baf);
$parcel$export(module.exports, "HREF", () => $c7ce8bed5d2ff289$export$74921a9774a80542);
$parcel$export(module.exports, "IN_PRODUCT_HELP", () => $c7ce8bed5d2ff289$export$cd480f5ec4739dab);
$parcel$export(module.exports, "WHAT_ARE_ISSUE_TYPES_URL", () => $c7ce8bed5d2ff289$export$470a531b30a8dea1);
$parcel$export(module.exports, "IN_PRODUCT_HELP_ARTICLE_IDS", () => $c7ce8bed5d2ff289$export$3691506c72823b65);
$parcel$export(module.exports, "DISMISSED", () => $c7ce8bed5d2ff289$export$6a4add537aaf5560);
$parcel$export(module.exports, "DEFAULT_ASSIGNEE_PERMISSION_ERROR_MESSAGE", () => $c7ce8bed5d2ff289$export$6d6e3176028f2228);
$parcel$export(module.exports, "DEFAULT_ASSIGNEE_PERMISSION_ERROR_MESSAGE_FE", () => $c7ce8bed5d2ff289$export$17d19a319fd47c32);
$parcel$export(module.exports, "GIC_CALLBACK_PAYLOAD_INLINE_CREATE_ID", () => $c7ce8bed5d2ff289$export$9e448086914e060);
$parcel$export(module.exports, "GIC_CALLBACK_PAYLOAD_AI_BREAKDOWN_CREATE_ID", () => $c7ce8bed5d2ff289$export$2dd6afd9432dbc93);

var $7ZZxN = parcelRequire("7ZZxN");
const $c7ce8bed5d2ff289$var$CHILD_ISSUES_LIMIT = 500;
const $c7ce8bed5d2ff289$export$89b6937a83edcaa6 = ()=>$c7ce8bed5d2ff289$var$CHILD_ISSUES_LIMIT;
const $c7ce8bed5d2ff289$export$763881dbba851043 = 'EXCEEDED_LIMIT_INITIAL_LOAD';
const $c7ce8bed5d2ff289$export$8a23145a6d5f95e3 = 'EXCEEDED_LIMIT_AFTER_LOAD';
const $c7ce8bed5d2ff289$export$a7af19981a3e4baf = 'WITHIN_LIMIT';
const $c7ce8bed5d2ff289$export$74921a9774a80542 = 'HREF';
const $c7ce8bed5d2ff289$export$cd480f5ec4739dab = 'IN_PRODUCT_HELP';
const $c7ce8bed5d2ff289$export$470a531b30a8dea1 = 'https://support.atlassian.com/jira-cloud-administration/docs/what-are-issue-types/';
const $c7ce8bed5d2ff289$export$3691506c72823b65 = {
    [(0, $7ZZxN.CORE_PROJECT)]: '2uhc4ieBPinkLJlWbdhXkC',
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'z6BNb3cPucF3fi5UA85Ma',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: '6feRxZzkYUHez8TwHTjSut',
    [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: null
};
const $c7ce8bed5d2ff289$export$6a4add537aaf5560 = 'dismissed';
const $c7ce8bed5d2ff289$export$6d6e3176028f2228 = 'The default assignee does NOT have ASSIGNABLE permission OR Unassigned issues are turned off.';
const $c7ce8bed5d2ff289$export$17d19a319fd47c32 = "The default assignee doesn\u2019t have the Assignable User permission, or unassigned issues are turned off.";
const $c7ce8bed5d2ff289$export$9e448086914e060 = 'issue-view-child-issues-panel-inline-create';
const $c7ce8bed5d2ff289$export$2dd6afd9432dbc93 = 'issue-view-child-issues-panel-ai-breakdown-create';

});

parcelRegister("anFLA", function(module, exports) {

$parcel$export(module.exports, "EVENTS_TO_LISTEN", () => $d020b8e21ff30f0f$export$d117134317cf0005);
$parcel$export(module.exports, "REALTIME_EVENTS_ANALYTICS_SAMPLE_RATE", () => $d020b8e21ff30f0f$export$d23f2e4951d99e4e);

const $d020b8e21ff30f0f$export$d117134317cf0005 = [
    (0, $1d129cd1c8b202ad$export$b22142e61b3fdbee),
    (0, $1d129cd1c8b202ad$export$773466d9acc404c0)
];
const $d020b8e21ff30f0f$export$d23f2e4951d99e4e = 100;

});
const $1d129cd1c8b202ad$export$86d416e8d15777d = 'avi:jira:assigned:issue';
const $1d129cd1c8b202ad$export$b22a14d5dac59664 = 'avi:jira:created:issue';
const $1d129cd1c8b202ad$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
const $1d129cd1c8b202ad$export$d9bc8850eeef9f60 = 'avi:jira:transitioned:issue';
const $1d129cd1c8b202ad$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
const $1d129cd1c8b202ad$export$773466d9acc404c0 = 'avi:jira:commented:issue';
const $1d129cd1c8b202ad$export$6b7e46ea0442b66c = 'avi:jira:updated:issue_parent_association';
const $1d129cd1c8b202ad$export$6024bd0c20931af3 = 'avi:jira-software:update:board-scope-issues';


parcelRegister("hc60A", function(module, exports) {

$parcel$export(module.exports, "ALL_ACTIVITY", () => $c4e4580e4e5263cc$export$97c6fb50aec7ca13);
$parcel$export(module.exports, "APPROVALS", () => $c4e4580e4e5263cc$export$d9f961719f63a946);
$parcel$export(module.exports, "COMMENTS", () => $c4e4580e4e5263cc$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "HISTORY", () => $c4e4580e4e5263cc$export$149eb684a26496a2);
$parcel$export(module.exports, "WORKLOG", () => $c4e4580e4e5263cc$export$df36fc05622c402);
$parcel$export(module.exports, "FORGE", () => $c4e4580e4e5263cc$export$567a44a77f893138);
$parcel$export(module.exports, "CONNECT", () => $c4e4580e4e5263cc$export$df50b52b1548c0dc);

var $fkvsU = parcelRequire("fkvsU");
const $c4e4580e4e5263cc$export$97c6fb50aec7ca13 = 'AllActivity';
const $c4e4580e4e5263cc$export$d9f961719f63a946 = 'Approvals';
const $c4e4580e4e5263cc$export$4cab9dfa8fc858f4 = 'Comments';
const $c4e4580e4e5263cc$export$149eb684a26496a2 = 'History';
const $c4e4580e4e5263cc$export$df36fc05622c402 = 'Worklog';
const $c4e4580e4e5263cc$export$567a44a77f893138 = (0, $fkvsU.FORGE_ENTITY_TYPE);
const $c4e4580e4e5263cc$export$df50b52b1548c0dc = (0, $fkvsU.CONNECT_ENTITY_TYPE);

});
parcelRegister("fkvsU", function(module, exports) {

$parcel$export(module.exports, "FORGE_ENTITY_TYPE", () => $f4e7965032899654$export$6f3804b3f188f650);
$parcel$export(module.exports, "CONNECT_ENTITY_TYPE", () => $f4e7965032899654$export$1b2059a011c9174d);
const $f4e7965032899654$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';
const $f4e7965032899654$export$1b2059a011c9174d = 'CONNECT_ENTITY_TYPE';
const $f4e7965032899654$export$38f0fc1cf1f24cba = [
    $f4e7965032899654$export$6f3804b3f188f650,
    $f4e7965032899654$export$1b2059a011c9174d
];

});


parcelRegister("eTy9x", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_ITEMS_TO_LOAD", () => $0bfbe56dc89f06eb$export$724fbfb10c203824);
$parcel$export(module.exports, "NUM_INITIAL_ITEMS_TO_LOAD_FOR_POST_LOAD_ACTIONS", () => $0bfbe56dc89f06eb$export$a1162d3036fadf0e);
$parcel$export(module.exports, "NUM_PAGED_ITEMS_TO_LOAD", () => $0bfbe56dc89f06eb$export$ed7e687bbd42b4a7);
$parcel$export(module.exports, "NUM_PAGED_ITEMS_TO_LOAD_OLD", () => $0bfbe56dc89f06eb$export$9b2f842ae6d3541d);
$parcel$export(module.exports, "LOAD_NEWER_BUTTON", () => $0bfbe56dc89f06eb$export$4f2e52b6b9be5088);
$parcel$export(module.exports, "LOAD_OLDER_BUTTON", () => $0bfbe56dc89f06eb$export$ed33f944ab1a1bb0);

var $c9TLT = parcelRequire("c9TLT");
const $0bfbe56dc89f06eb$export$724fbfb10c203824 = 5;
const $0bfbe56dc89f06eb$export$a1162d3036fadf0e = 100;
const $0bfbe56dc89f06eb$export$ed7e687bbd42b4a7 = 100;
const $0bfbe56dc89f06eb$export$9b2f842ae6d3541d = 10;
const $0bfbe56dc89f06eb$export$ef42ae71539e03a7 = `${3 * (0, $c9TLT.gridSize)}px`;
const $0bfbe56dc89f06eb$export$4f2e52b6b9be5088 = 'LOAD_NEWER_BUTTON';
const $0bfbe56dc89f06eb$export$ed33f944ab1a1bb0 = 'LOAD_OLDER_BUTTON';

});

const $b7817a5fa36c8dd6$export$37b67b9fa9f77199 = 'APPLINK_MISSING';
const $b7817a5fa36c8dd6$export$d1fe0e8f550fe68d = 'APPLINK_REQ_AUTH';
const $b7817a5fa36c8dd6$export$a6054426471fb4c4 = 'REMOTE_SERVER';
const $b7817a5fa36c8dd6$export$cdf8a4853fe35e61 = 'REMOTE_LINK_MISSING';

const $9e13bb906b1e3579$export$87b07f66f76af007 = 1000;
const $9e13bb906b1e3579$export$7cf28317477c9e48 = 'w';

const $b0dbf452addbddfb$export$cb17e3c17bc50301 = 'Epic';
const $b0dbf452addbddfb$export$d29cf9c8492f955d = 'Base';
const $b0dbf452addbddfb$export$7fbc739f2667a35e = 'Subtask';

parcelRegister("hU5kA", function(module, exports) {

$parcel$export(module.exports, "noPermissions", () => $da02f2b558500d9a$export$3fd167bac6ff056b);
const $da02f2b558500d9a$export$c7b3dd87fc15b364 = {
    canDeleteAllWorklogs: false,
    canDeleteOwnWorklogs: false,
    canEditAllWorklogs: false,
    canEditOwnWorklogs: false,
    canLogWork: false
};
const $da02f2b558500d9a$export$3fd167bac6ff056b = {
    canAddComments: false,
    canAdministerJira: false,
    canAdministerProject: false,
    canAssignIssues: false,
    canBeAssignedToIssues: false,
    canCloneIssue: false,
    canCreateAttachments: false,
    canCreateChildren: false,
    canCreateSubtask: false,
    canDeleteAllAttachments: false,
    canDeleteAllComments: false,
    canDeleteIssue: false,
    canDeleteOwnAttachments: false,
    canDeleteOwnComments: false,
    canEditAllComments: false,
    canEditIssues: false,
    canEditOwnComments: false,
    canLinkIssues: false,
    canManageWatchers: false,
    canMoveIssue: false,
    canModifyReporter: false,
    canScheduleIssues: false,
    canViewWatchers: false,
    canBrowseUsers: false,
    ...$da02f2b558500d9a$export$c7b3dd87fc15b364,
    canUseServiceDeskAgentFeatures: false,
    canViewDevTools: false,
    canExportIssue: false
};

});

parcelRegister("cUHte", function(module, exports) {

$parcel$export(module.exports, "fetchFieldDataPerf", () => $e54dd57964efa8b8$export$b97d963a8496fa2f);
$parcel$export(module.exports, "fetchCommentsPerf", () => $e54dd57964efa8b8$export$179836a99669cbe7);
$parcel$export(module.exports, "fetchIssueLinkPerf", () => $e54dd57964efa8b8$export$8d0984a0f9f31117);
$parcel$export(module.exports, "fetchSubtaskTypesPerf", () => $e54dd57964efa8b8$export$c1324bd586e9a53a);
$parcel$export(module.exports, "fetchUploadPerf", () => $e54dd57964efa8b8$export$72fcc6cb1cdc70e0);
$parcel$export(module.exports, "fetchUserAuthPerf", () => $e54dd57964efa8b8$export$4052b1eae3373c3b);
$parcel$export(module.exports, "fetchViewContextPerf", () => $e54dd57964efa8b8$export$b4e2588a18d8d980);
$parcel$export(module.exports, "fetchIssuePropertiesPerf", () => $e54dd57964efa8b8$export$2ee73dd298bdfe8a);
const $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX = 'ISSUE_DETAILS';
const $e54dd57964efa8b8$var$FETCH_FIELD_DATA_REQUEST = 'FETCH_FIELD_DATA';
const $e54dd57964efa8b8$var$FETCH_INITIAL_COMMENTS_REQUEST = 'FETCH_INITIAL_COMMENTS';
const $e54dd57964efa8b8$var$FETCH_ISSUE_LINK_TYPES_REQUEST = 'FETCH_ISSUE_LINK_TYPES';
const $e54dd57964efa8b8$var$FETCH_SUBTASK_TYPES_REQUEST = 'FETCH_SUBTASK_TYPES';
const $e54dd57964efa8b8$var$FETCH_UPLOAD_CONTEXT_REQUEST = 'FETCH_LOAD_CONTEXT';
const $e54dd57964efa8b8$var$FETCH_USER_AUTH_REQUEST = 'FETCH_USER_AUTH';
const $e54dd57964efa8b8$var$FETCH_VIEW_CONTEXT_REQUEST = 'FETCH_VIEW_CONTEXT';
const $e54dd57964efa8b8$var$FETCH_ISSUE_PROPERTIES_REQUEST = 'FETCH_ISSUE_PROPERTIES';
const $e54dd57964efa8b8$export$b97d963a8496fa2f = {
    key: $e54dd57964efa8b8$var$FETCH_FIELD_DATA_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$179836a99669cbe7 = {
    key: $e54dd57964efa8b8$var$FETCH_INITIAL_COMMENTS_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$8d0984a0f9f31117 = {
    key: $e54dd57964efa8b8$var$FETCH_ISSUE_LINK_TYPES_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$c1324bd586e9a53a = {
    key: $e54dd57964efa8b8$var$FETCH_SUBTASK_TYPES_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$72fcc6cb1cdc70e0 = {
    key: $e54dd57964efa8b8$var$FETCH_UPLOAD_CONTEXT_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$4052b1eae3373c3b = {
    key: $e54dd57964efa8b8$var$FETCH_USER_AUTH_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$b4e2588a18d8d980 = {
    key: $e54dd57964efa8b8$var$FETCH_VIEW_CONTEXT_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$2ee73dd298bdfe8a = {
    key: $e54dd57964efa8b8$var$FETCH_ISSUE_PROPERTIES_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};

});

const $ab2aafcdf11a1361$export$dcd281f501ceae1a = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.pinned-fields';
const $ab2aafcdf11a1361$export$e1184c3be46bd7cb = false;
const $ab2aafcdf11a1361$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $ab2aafcdf11a1361$export$988f0f6f6457039a = 'status-and-approval-spotlight';

parcelRegister("cd8TS", function(module, exports) {

$parcel$export(module.exports, "ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $626ce0fd98ef0025$export$dd2d62bc7ec6ce51);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $626ce0fd98ef0025$export$db1ab2b83dc17aa9);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $626ce0fd98ef0025$export$940ce115dba33e55);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $626ce0fd98ef0025$export$4ec1f3604b85d553);
$parcel$export(module.exports, "ISSUE_LIMIT_FIELDS_ERROR_MESSAGE_LIST", () => $626ce0fd98ef0025$export$e65b95e776ce6f27);
const $626ce0fd98ef0025$export$dd2d62bc7ec6ce51 = 'ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $626ce0fd98ef0025$export$db1ab2b83dc17aa9 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED: 5000';
const $626ce0fd98ef0025$export$940ce115dba33e55 = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED: 5000';
const $626ce0fd98ef0025$export$4ec1f3604b85d553 = 'REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $626ce0fd98ef0025$export$e65b95e776ce6f27 = [
    $626ce0fd98ef0025$export$dd2d62bc7ec6ce51,
    $626ce0fd98ef0025$export$db1ab2b83dc17aa9,
    $626ce0fd98ef0025$export$940ce115dba33e55,
    $626ce0fd98ef0025$export$4ec1f3604b85d553
];

});


parcelRegister("5gJbo", function(module, exports) {

$parcel$export(module.exports, "isKeyEscapeEvent", () => $b19c0635624b3ec6$export$55acadd0a00b2c6e);
$parcel$export(module.exports, "isKeyEnterEvent", () => $b19c0635624b3ec6$export$3b92ce7075cba73b);
$parcel$export(module.exports, "isLeftClickOnly", () => $b19c0635624b3ec6$export$27f1841767effbd2);
$parcel$export(module.exports, "isMiddleClick", () => $b19c0635624b3ec6$export$fcc04c6d1a417b0c);
$parcel$export(module.exports, "isCmdOrCtrlClick", () => $b19c0635624b3ec6$export$a8cc8ed95260f0c);
const $b19c0635624b3ec6$export$55acadd0a00b2c6e = (e)=>e && e instanceof window.KeyboardEvent && e.key === 'Escape'; /* Esc */ 
const $b19c0635624b3ec6$export$3b92ce7075cba73b = (e)=>e.keyCode === 13; /* Enter */ 
const $b19c0635624b3ec6$export$698c4f0ff5e11e52 = (event)=>event.button === 0;
const $b19c0635624b3ec6$export$27f1841767effbd2 = (event)=>$b19c0635624b3ec6$export$698c4f0ff5e11e52(event) && !(event.metaKey || event.ctrlKey);
const $b19c0635624b3ec6$export$fcc04c6d1a417b0c = (event)=>event.button === 1;
const $b19c0635624b3ec6$export$a8cc8ed95260f0c = (event)=>$b19c0635624b3ec6$export$698c4f0ff5e11e52(event) && (event.metaKey || event.ctrlKey);

});

parcelRegister("k1wt3", function(module, exports) {

$parcel$export(module.exports, "markEvalEnd", () => $691d4fa136d98e84$export$31bb403682fe86df);
/* eslint-disable no-restricted-properties */ /**
 * This is an eval user timing for the issue-app. We are using the performance directly so we don't
 * accidentally bring in any code that may have side effects or runtime code during the script eval.
 */ const $691d4fa136d98e84$var$mark = (name)=>{
    try {
        window.performance.mark(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
    // void
    }
};
const $691d4fa136d98e84$export$90956e5618017bd9 = 'jira.issue-view.issue-app.eval-start';
const $691d4fa136d98e84$export$cf41e944500697d8 = 'jira.issue-view.issue-app.eval-end';
$691d4fa136d98e84$var$mark($691d4fa136d98e84$export$90956e5618017bd9);
const $691d4fa136d98e84$export$31bb403682fe86df = ()=>$691d4fa136d98e84$var$mark($691d4fa136d98e84$export$cf41e944500697d8);
const $691d4fa136d98e84$export$ad8521ec6f014680 = ()=>{
    try {
        window.performance.measure('jira.issue-view.issue-app.eval', $691d4fa136d98e84$export$90956e5618017bd9, $691d4fa136d98e84$export$cf41e944500697d8);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
    // / void
    }
};

});

parcelRegister("kB5wN", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $628d22027b8eaf89$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $628d22027b8eaf89$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $628d22027b8eaf89$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6mgGK = parcelRequire("6mgGK");

var $kJlBc = parcelRequire("kJlBc");

var $fruGB = parcelRequire("fruGB");
const $628d22027b8eaf89$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const { Provider: $628d22027b8eaf89$var$Provider, Consumer: $628d22027b8eaf89$var$Consumer } = $628d22027b8eaf89$export$37eeac5cc5245b18;
const $628d22027b8eaf89$export$55a90a8e865a39b5 = 700;
const $628d22027b8eaf89$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$628d22027b8eaf89$export$55a90a8e865a39b5}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $628d22027b8eaf89$var$useRouteKey() {
    const [routeState] = (0, $kJlBc.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $628d22027b8eaf89$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $628d22027b8eaf89$var$useRouteKey();
    (0, $fruGB.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $fruGB.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $ebe79147dfe00ff9$export$ee15e0cd1efafcb4);
        (0, $fruGB.setCachedIsCompactValue)(defaultState, key);
    }
    const [isCompact, setIsCompact] = (0, $eUqFw.useState)(defaultState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($628d22027b8eaf89$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6mgGK.ContainerQueryObserver), {
        query: $628d22027b8eaf89$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY,
        onChange: (state)=>{
            (0, $fruGB.setCachedIsCompactValue)(state, key);
            setIsCompact(state);
        },
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($628d22027b8eaf89$var$Provider, {
        value: isCompact
    }, children));
};
const $628d22027b8eaf89$export$20feb77b5b617e44 = $628d22027b8eaf89$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $628d22027b8eaf89$var$StyledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6mgGK", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $2f0f372a50da62d9$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

const $2f0f372a50da62d9$var$QueryContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
let $2f0f372a50da62d9$var$currentIdSeed = 0;
function $2f0f372a50da62d9$var$generateAttributeValue() {
    return `indicator-span-${$2f0f372a50da62d9$var$currentIdSeed++}`;
}
function $2f0f372a50da62d9$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $ebe79147dfe00ff9$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $eUqFw.useState)(defaultState);
    const handleQueryStatusChange = (0, $eUqFw.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f0f372a50da62d9$var$QueryContext.Provider, {
        value: active
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f0f372a50da62d9$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $2f0f372a50da62d9$export$b66a67697973e01() {
    const currentState = (0, $eUqFw.useContext)($2f0f372a50da62d9$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $2f0f372a50da62d9$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $eUqFw.useMemo)(()=>$2f0f372a50da62d9$var$generateAttributeValue(), []);
    const spanRef = (0, $eUqFw.useRef)(null);
    const containerRef = (0, $eUqFw.useRef)(null);
    const currentState = $2f0f372a50da62d9$export$b66a67697973e01();
    (0, $eUqFw.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f0f372a50da62d9$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh; 
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f0f372a50da62d9$var$ContainerToBeQueried = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});
const $ebe79147dfe00ff9$export$ee15e0cd1efafcb4 = false;


parcelRegister("fruGB", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $592157d792cf61e1$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $592157d792cf61e1$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $592157d792cf61e1$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $592157d792cf61e1$var$cachedIsCompactValues = {};
let $592157d792cf61e1$var$previousRouteKey;
function $592157d792cf61e1$export$c47621d55d10906c(key) {
    return $592157d792cf61e1$var$cachedIsCompactValues[key];
}
function $592157d792cf61e1$export$568b2dd75c2027b4(isCompactValue, key) {
    $592157d792cf61e1$var$cachedIsCompactValues[key] = isCompactValue;
}
function $592157d792cf61e1$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $592157d792cf61e1$var$previousRouteKey) {
        $592157d792cf61e1$var$previousRouteKey = currentRouteKey;
        delete $592157d792cf61e1$var$cachedIsCompactValues[$592157d792cf61e1$var$previousRouteKey];
    }
}

});


parcelRegister("2inY8", function(module, exports) {

$parcel$export(module.exports, "IssueViewErrorBoundary", () => $b45248a4deb0ef6e$export$ad407ede05121cc1);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $cxdSy = parcelRequire("cxdSy");

var $dxcfv = parcelRequire("dxcfv");

var $1fY91 = parcelRequire("1fY91");
const $b45248a4deb0ef6e$export$ad407ede05121cc1 = ({ errorBoundaryId: errorBoundaryId, children: children, issueKey: issueKey, loginRedirectUrl: loginRedirectUrl, fallback: fallback })=>{
    const accountIdLoggedInUser = (0, $dxcfv.useAccountId)();
    const [caughtError, setCaughtError] = (0, $eUqFw.useState)();
    const [errorKey, setErrorKey] = (0, $eUqFw.useState)(0);
    // We are purposely not using the usePrevious/usePreviousWithInitial hook as it has its own useEffect internally meaning
    // because of asynchronicity when we are checking it to update the error key it is not up to date so we need to manage this state ourselves
    const previousIssueKeyRef = (0, $eUqFw.useRef)(issueKey);
    (0, $eUqFw.useEffect)(()=>{
        if (issueKey !== previousIssueKeyRef.current && caughtError) {
            // When we error we are incrementing the key so that we completely remount the issue view + AppProvider as the error will otherwise be cached
            setErrorKey((key)=>key + 1);
            setCaughtError(undefined);
        }
        previousIssueKeyRef.current = issueKey;
    }, [
        issueKey,
        caughtError,
        previousIssueKeyRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        key: errorKey,
        id: errorBoundaryId,
        /* eslint-disable-next-line jira/js/package-name-enforcer-for-error-boundary */ packageName: "issue",
        onError: (_, error)=>{
            setCaughtError(error);
        },
        fallback: (errorProps)=>{
            const { errorType: errorType, errorAttributes: errorAttributes } = (0, $cxdSy.getIssueErrorAttributes)(errorProps.error, accountIdLoggedInUser);
            const isIssueKeyFresh = issueKey === previousIssueKeyRef.current;
            // We should avoid tracking the error if the issue key has changed as this means we are remounting the issue view
            const errorComponent = isIssueKeyFresh ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1fY91.IssueErrorViewWithSuccessTracking), {
                errorType: errorType,
                loginRedirectUrl: loginRedirectUrl,
                errorAttributes: errorAttributes
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, null);
            if (fallback) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallback(errorComponent, errorType));
            return errorComponent;
        }
    }, children);
};

});
parcelRegister("cxdSy", function(module, exports) {

$parcel$export(module.exports, "statusCodesNotImpactingReliability", () => $8c5c4fc5d8a6606e$export$501df64f0fda1d63);
$parcel$export(module.exports, "getIssueErrorAttributes", () => $8c5c4fc5d8a6606e$export$23bbdbaa14274cfd);
$parcel$export(module.exports, "loginViaRedirectUrl", () => $8c5c4fc5d8a6606e$export$796a2c2756dc1f12);
$parcel$export(module.exports, "getIssueLimitErrorField", () => $8c5c4fc5d8a6606e$export$aba25149bb9fdf05);


var $7byHA = parcelRequire("7byHA");
var $JRB5w = parcelRequire("JRB5w");


var $cd8TS = parcelRequire("cd8TS");
var $0NycV = parcelRequire("0NycV");

var $7PTrm = parcelRequire("7PTrm");
const $8c5c4fc5d8a6606e$var$isIssueNetworkError = (error)=>(0, $JRB5w.isClientFetchError)(error) || (0, $JRB5w.isHttpClientErrorResponse)(error) || error instanceof (0, $7byHA.default) || error instanceof (0, $7PTrm.IssueViewFetchError);
const $8c5c4fc5d8a6606e$export$d3ca0619504206aa = new Set([
    (0, $12cc22d0c60f7bfc$export$99405616af30f11f),
    (0, $12cc22d0c60f7bfc$export$683dbe11f74cd161),
    (0, $12cc22d0c60f7bfc$export$4e094d34a5cb1872),
    (0, $12cc22d0c60f7bfc$export$f10b32dfda12e96e)
]);
const $8c5c4fc5d8a6606e$export$501df64f0fda1d63 = [
    (0, $1c3fbb431a173cc6$export$9de493bcd9b1d977),
    (0, $1c3fbb431a173cc6$export$4a3cb39801694eee),
    (0, $1c3fbb431a173cc6$export$fa405bbf47d510e2),
    (0, $1c3fbb431a173cc6$export$3b48aba8957000cd),
    (0, $1c3fbb431a173cc6$export$6763168a631449a2)
];
const $8c5c4fc5d8a6606e$var$isPreCalculatedErrorType = (error)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $8c5c4fc5d8a6606e$export$d3ca0619504206aa.has(error.message);
const $8c5c4fc5d8a6606e$export$23bbdbaa14274cfd = (error, accountIdLoggedInUser)=>{
    // TODO Cleanup with JIV-14818
    if ($8c5c4fc5d8a6606e$var$isPreCalculatedErrorType(error)) return {
        errorType: error.message,
        errorAttributes: error.errorAttributes
    };
    const errorType = (0, $12cc22d0c60f7bfc$export$f10b32dfda12e96e);
    const errorAttributes = {
        errorMessage: error.message
    };
    if ($8c5c4fc5d8a6606e$var$isIssueNetworkError(error)) {
        const { statusCode: statusCode, traceId: traceId } = error;
        Object.assign(errorAttributes, {
            statusCode: statusCode,
            traceId: traceId
        });
        if (!accountIdLoggedInUser || statusCode === (0, $1c3fbb431a173cc6$export$67d19e9a991baa07)) return {
            errorType: (0, $12cc22d0c60f7bfc$export$99405616af30f11f),
            errorAttributes: errorAttributes
        };
        if (statusCode === (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef) || statusCode === (0, $1c3fbb431a173cc6$export$a3269a3914b007e3)) return {
            errorType: (0, $12cc22d0c60f7bfc$export$4e094d34a5cb1872),
            errorAttributes: errorAttributes
        };
        // Relay Error - could be mainIssueAggQuery
        if (error instanceof (0, $7PTrm.IssueViewFetchError) && error?.getIsRelayError()) {
            if ((0, $JRB5w.isClientFetchError)(error) || statusCode && $8c5c4fc5d8a6606e$export$501df64f0fda1d63.includes(statusCode)) return {
                errorType: (0, $12cc22d0c60f7bfc$export$683dbe11f74cd161),
                errorAttributes: errorAttributes
            };
            // If the statusCode is undefine for Relay Error we want to set it as UNKNOWN_ERROR to (taskFail)
            return {
                errorType: (0, $12cc22d0c60f7bfc$export$f10b32dfda12e96e),
                errorAttributes: errorAttributes
            };
        }
        // Return CONNECTIVITY_ERROR if the statusCode is undefined for un-relay error
        if (!statusCode || $8c5c4fc5d8a6606e$export$501df64f0fda1d63.includes(statusCode)) return {
            errorType: (0, $12cc22d0c60f7bfc$export$683dbe11f74cd161),
            errorAttributes: errorAttributes
        };
    }
    return {
        errorType: errorType,
        errorAttributes: errorAttributes
    };
};
const $8c5c4fc5d8a6606e$export$796a2c2756dc1f12 = async (loginRedirectUrl)=>{
    if (!loginRedirectUrl) return;
    const encodedRedirectUrl = encodeURIComponent(loginRedirectUrl);
    const logInUrl = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    window.open(logInUrl, '_blank');
};
const $8c5c4fc5d8a6606e$export$aba25149bb9fdf05 = (error)=>{
    const errorMessagesList = error.message.split('; ');
    if (errorMessagesList.length === 0) return undefined;
    const fieldLimitErrorList = (0, $cd8TS.ISSUE_LIMIT_FIELDS_ERROR_MESSAGE_LIST).filter((fieldLimitErrorMessage)=>errorMessagesList.some((message)=>message.includes(fieldLimitErrorMessage)));
    // we prioritise comments/worklogs, if there are limits for both comments/worklogs and attachments.
    if (fieldLimitErrorList.includes((0, $cd8TS.COMMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE))) return 0, $0NycV.COMMENTS_PER_ISSUE_LIMIT_EXCEEDED;
    if (fieldLimitErrorList.includes((0, $cd8TS.WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE))) return 0, $0NycV.WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED;
    if (fieldLimitErrorList.includes((0, $cd8TS.ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE))) return 0, $0NycV.ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED;
    if (fieldLimitErrorList.includes((0, $cd8TS.REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE))) return 0, $0NycV.ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED;
    return undefined;
};

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;

const $12cc22d0c60f7bfc$export$99405616af30f11f = 'AUTHENTICATION_ERROR';
const $12cc22d0c60f7bfc$export$683dbe11f74cd161 = 'CONNECTIVITY_ERROR';
const $12cc22d0c60f7bfc$export$4e094d34a5cb1872 = 'NOT_FOUND_OR_NO_PERMISSION_ERROR';
const $12cc22d0c60f7bfc$export$f10b32dfda12e96e = 'UNKNOWN_ERROR';

parcelRegister("7PTrm", function(module, exports) {

$parcel$export(module.exports, "IssueViewFetchError", () => $05747139f04adb80$export$4802e881d6c7820d);

var $lgAsZ = parcelRequire("lgAsZ");

var $7byHA = parcelRequire("7byHA");
class $05747139f04adb80$export$4802e881d6c7820d extends (0, $lgAsZ.default) {
    constructor(error, endpoint, traceId, isRelayError){
        super(error.message);
        this.error = error;
        this.endpoint = endpoint;
        this.traceId = traceId;
        this.isRelayError = isRelayError;
        this.endpoint = endpoint;
        this.error = error;
        this.message = error.message;
        if (error instanceof (0, $7byHA.default)) {
            if (error.traceId != null) this.traceId = error.traceId;
            this.statusCode = error.statusCode;
        }
        if (error instanceof $05747139f04adb80$export$4802e881d6c7820d) {
            this.error = error.error;
            this.statusCode = error.statusCode;
            this.traceId = error.traceId;
        }
        // set traceId from AGG, only if not set already
        if (!this.traceId && traceId && traceId !== '') this.traceId = traceId;
    }
    getIsRelayError() {
        return this.isRelayError === true;
    }
}

});


parcelRegister("dxcfv", function(module, exports) {

$parcel$export(module.exports, "useAccountId", () => $45cd5aaa8359ff91$export$e72033e0f5baa3e);

var $gd0Sp = parcelRequire("gd0Sp");
const $45cd5aaa8359ff91$export$e72033e0f5baa3e = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.atlassianAccountId || null;
};

});

parcelRegister("1fY91", function(module, exports) {

$parcel$export(module.exports, "IssueErrorViewWithSuccessTracking", () => $a020121d620c9cf0$export$613132bd44508f94);

var $eUqFw = parcelRequire("eUqFw");


var $bu2rt = parcelRequire("bu2rt");
var $iH6jq = parcelRequire("iH6jq");
var $cavjE = parcelRequire("cavjE");

var $kwMhr = parcelRequire("kwMhr");parcelRequire("4QRaC");
var $kwMhr = parcelRequire("kwMhr");
const $a020121d620c9cf0$export$89b139fb36e37b91 = 'issue.views.issue-details.error.ui.issue-error-view-with-success-tracking.view-experience-success-tracker';
const $a020121d620c9cf0$export$3c2027d4354ad97e = 'issue.views.issue-details.error.ui.issue-error-view-with-success-tracking.view-experience-failure-tracker';
const $a020121d620c9cf0$export$613132bd44508f94 = ({ errorType: errorType, loginRedirectUrl: loginRedirectUrl, errorAttributes: errorAttributes })=>{
    switch(errorType){
        case 0, $12cc22d0c60f7bfc$export$99405616af30f11f:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
                "data-testid": $a020121d620c9cf0$export$89b139fb36e37b91,
                location: "auth-error"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bu2rt.AuthenticationErrorView), {
                loginRedirectUrl: loginRedirectUrl
            }));
        case 0, $12cc22d0c60f7bfc$export$4e094d34a5cb1872:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
                "data-testid": $a020121d620c9cf0$export$89b139fb36e37b91,
                location: "not-found-or-no-permission-error"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iH6jq.PermissionErrorView), null));
        case 0, $12cc22d0c60f7bfc$export$683dbe11f74cd161:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cavjE.UnknownErrorView), null);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
                "data-testid": $a020121d620c9cf0$export$3c2027d4354ad97e,
                location: "unknown-error",
                failureEventAttributes: errorAttributes
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cavjE.UnknownErrorView), null));
    }
};

});
parcelRegister("bu2rt", function(module, exports) {

$parcel$export(module.exports, "AuthenticationErrorView", () => $b1fb2c8b421523ce$export$6307a9e183fac24d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lVx5t = parcelRequire("lVx5t");

var $gAcfY = parcelRequire("gAcfY");

var $cxdSy = parcelRequire("cxdSy");

var $g46NL = parcelRequire("g46NL");
const $b1fb2c8b421523ce$export$6307a9e183fac24d = ({ loginRedirectUrl: loginRedirectUrl })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAcfY.ErrorDisplay), {
        header: formatMessage((0, $g46NL.messages).authErrorHeader),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1fb2c8b421523ce$var$Image, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($lVx5t))),
            alt: ""
        })
    }, loginRedirectUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: ()=>(0, $cxdSy.loginViaRedirectUrl)(loginRedirectUrl),
        interactionName: "auto-generated.jira-issue-view-errors.ui.authentication-error-view.button"
    }, formatMessage((0, $g46NL.messages).authButton)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b1fb2c8b421523ce$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1lit _otyrpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lVx5t", function(module, exports) {
module.exports = new URL("authentication-error.b1895c4e.svg", import.meta.url).toString();

});

parcelRegister("gAcfY", function(module, exports) {

$parcel$export(module.exports, "ErrorDisplay", () => $72830fdda25402b0$export$d56b0569bceb92ae);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $72830fdda25402b0$export$d56b0569bceb92ae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($72830fdda25402b0$var$Container, {
        "data-testid": "issue-view-errors.common.ui.error-display.permission-error-display"
    }, props.image, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($72830fdda25402b0$var$Heading, null, props.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($72830fdda25402b0$var$Description, null, props.description), props.children);
$72830fdda25402b0$export$d56b0569bceb92ae.defaultProps = {
    description: undefined,
    children: null
};
/**
 * Duplicated from `src/packages/issue/issue-view/src/views/issue-details/issue-modal/styled.tsx`
 *
 * TODO: Derive properly on `src/packages/issue/issue-view/src/views/issue-details/error` cleanup
 */ const $72830fdda25402b0$var$modalDialogContainerSelectorName = 'jira.issue-view.issue-details.modal-dialog-container';
const $72830fdda25402b0$var$MODAL_DIALOG_CONTAINER_COMPONENT_SELECTOR = `[data-component-selector="${$72830fdda25402b0$var$modalDialogContainerSelectorName}"]`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $72830fdda25402b0$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _2lx21bp4 _syaz1fxt _1e0c1txw _1bah1h6o _4cvr1h6o _ca0qxncg _17ipxncg _1ksgidpf",
            __cmplp.className
        ])
    });
});
const $72830fdda25402b0$var$Heading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybgktf _k48p8n31 _19pkutpp _otyrutpp _p12f1osq",
            __cmplp.className
        ])
    });
});
const $72830fdda25402b0$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("g46NL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $75937ee78ad2a786$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $75937ee78ad2a786$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    authErrorHeader: {
        "id": "issue-view-errors.authentication-error-view.auth-error-header",
        "defaultMessage": "Log in to Jira to see this issue"
    },
    authButton: {
        "id": "issue-view-errors.authentication-error-view.auth-button",
        "defaultMessage": "Log in"
    }
});

});


parcelRegister("iH6jq", function(module, exports) {

$parcel$export(module.exports, "PermissionErrorView", () => $481adf0d32cb7785$export$1bd3db7a0a8884d3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bi3Wi = parcelRequire("bi3Wi");

var $gAcfY = parcelRequire("gAcfY");

var $lXKjT = parcelRequire("lXKjT");
const $481adf0d32cb7785$export$1bd3db7a0a8884d3 = ()=>{
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAcfY.ErrorDisplay), {
        header: intl.formatMessage((0, $lXKjT.messages).permissionErrorHeader),
        description: intl.formatMessage((0, $lXKjT.messages).permissionErrorDescription),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($481adf0d32cb7785$var$Image, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($bi3Wi))),
            alt: ""
        })
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $481adf0d32cb7785$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i53f4 _1bsb10bg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bi3Wi", function(module, exports) {
module.exports = new URL("permission-error.da9ec123.svg", import.meta.url).toString();

});

parcelRegister("lXKjT", function(module, exports) {

$parcel$export(module.exports, "messages", () => $44ae321cec7c5988$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $44ae321cec7c5988$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    permissionErrorHeader: {
        "id": "issue-view-errors.permission-error-view.permission-error-header",
        "defaultMessage": "You don't have access to this issue"
    },
    permissionErrorDescription: {
        "id": "issue-view-errors.permission-error-view.permission-error-description",
        "defaultMessage": "Make sure the issue exists in this project. If it does, ask a project admin for permission to see the project's issues."
    }
});

});


parcelRegister("cavjE", function(module, exports) {

$parcel$export(module.exports, "UnknownErrorView", () => $6c37277dc48ad946$export$f23f26771420affd);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4fDL1 = parcelRequire("4fDL1");

var $gAcfY = parcelRequire("gAcfY");

var $iSa7H = parcelRequire("iSa7H");
const $6c37277dc48ad946$export$f23f26771420affd = ()=>{
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAcfY.ErrorDisplay), {
        header: intl.formatMessage((0, $iSa7H.messages).unknownErrorHeader),
        description: intl.formatMessage((0, $iSa7H.messages).unknownErrorDescription),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c37277dc48ad946$var$Image, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($4fDL1))),
            alt: ""
        })
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c37277dc48ad946$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1j4a _1bsb68cl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4fDL1", function(module, exports) {
module.exports = new URL("unknown-error.af4eba12.svg", import.meta.url).toString();

});

parcelRegister("iSa7H", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1416a448c428a41e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1416a448c428a41e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    unknownErrorHeader: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-header",
        "defaultMessage": "We couldn't connect to that issue"
    },
    unknownErrorDescription: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-description",
        "defaultMessage": "Make sure that this issue actually exists in that project. If it does, try again in a few minutes. If you still can't link to the issue, contact your Jira admin."
    }
});

});


parcelRegister("4QRaC", function(module, exports) {

$parcel$export(module.exports, "withViewExperienceTracker", () => $d6baf6aa4530b931$export$52092272c0483371);
$parcel$export(module.exports, "WithViewExperienceTrackerWrapper", () => $d6baf6aa4530b931$export$4d8a317342a74fe6);
$parcel$export(module.exports, "withFieldViewExperienceTracker", () => $d6baf6aa4530b931$export$81204a5705466426);
$parcel$export(module.exports, "ViewExperienceSuccessTracker", () => (parcelRequire("kwMhr")).ExperienceSuccessTracker);

var $eUqFw = parcelRequire("eUqFw");

var $kwMhr = parcelRequire("kwMhr");
var $8yne0 = parcelRequire("8yne0");

var $lqalZ = parcelRequire("lqalZ");

var $fokFV = parcelRequire("fokFV");

var $cJkBv = parcelRequire("cJkBv");

var $6qe7E = parcelRequire("6qe7E");
const $d6baf6aa4530b931$export$52092272c0483371 = (location)=>// FIXME: JIV-17455: improve type inheritance
    // eslint-disable-next-line  @typescript-eslint/no-unnecessary-type-constraint, @typescript-eslint/no-explicit-any
    (ComponentBeingTracked)=>{
        const WithViewExperienceTracker = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), {
                location: location
            }, ({ onExperienceSuccess: onExperienceSuccess })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentBeingTracked, {
                    onExperienceSuccess: onExperienceSuccess,
                    ...props
                }));
        WithViewExperienceTracker.displayName = `WithViewExperienceTracker(${(0, $cJkBv.getComponentDisplayName)(ComponentBeingTracked)})`;
        return WithViewExperienceTracker;
    };
const $d6baf6aa4530b931$export$4d8a317342a74fe6 = ({ fieldType: fieldType, locationSuffix: locationSuffix, children: children })=>{
    const fieldTypeExperienceTrackingWhitelist = fieldType && (0, $6qe7E.getFieldViewTrackerProviderWhitelist)(fieldType);
    const location = (0, $eUqFw.useMemo)(()=>[
            'field',
            fieldType,
            ...locationSuffix ? [
                locationSuffix
            ] : []
        ].join('-'), [
        fieldType,
        locationSuffix
    ]);
    if (fieldType == null || fieldTypeExperienceTrackingWhitelist === (0, $6qe7E.NEVER_TRACKING_FIELD_VIEW_EXPERIENCE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    const parentProviders = Array.isArray(fieldTypeExperienceTrackingWhitelist) ? fieldTypeExperienceTrackingWhitelist : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
        location: location,
        parentProviders: parentProviders
    }, children);
};
const $d6baf6aa4530b931$export$81204a5705466426 = (locationSuffix)=>(ComponentBeingTracked)=>{
        const WithViewExperienceTracker = ({ fieldType: fieldType, ownProps: ownProps })=>{
            const fieldTypeExperienceTrackingWhitelist = fieldType && (0, $6qe7E.getFieldViewTrackerProviderWhitelist)(fieldType);
            if (fieldType == null || fieldTypeExperienceTrackingWhitelist === (0, $6qe7E.NEVER_TRACKING_FIELD_VIEW_EXPERIENCE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentBeingTracked, ownProps);
            const parentProviders = Array.isArray(fieldTypeExperienceTrackingWhitelist) ? fieldTypeExperienceTrackingWhitelist : null;
            const location = [
                'field',
                fieldType,
                ...locationSuffix ? [
                    locationSuffix
                ] : []
            ].join('-');
            return(// If the component mounts without throwing or mounting its own failure component, then the field has succeeded
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
                location: location,
                parentProviders: parentProviders
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentBeingTracked, ownProps)));
        };
        WithViewExperienceTracker.displayName = `WithFieldViewExperienceTracker(${(0, $cJkBv.getComponentDisplayName)(ComponentBeingTracked)}`;
        return (0, $lqalZ.connect)((state, ownProps)=>({
                fieldType: (0, $fokFV.fieldTypeSelector)(ownProps.fieldId)(state)
            }), null, ({ fieldType: fieldType }, dispatchProps, ownProps)=>({
                fieldType: fieldType,
                ownProps: ownProps
            }))(WithViewExperienceTracker);
    };

});
parcelRegister("lqalZ", function(module, exports) {

$parcel$export(module.exports, "connect", () => $494449a639f989a5$export$64605811ab45167f);
$parcel$export(module.exports, "Provider", () => $494449a639f989a5$export$2881499e37b75b9a);

var $lNNXV = parcelRequire("lNNXV");
const $494449a639f989a5$export$64605811ab45167f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = Object.freeze({}))=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (component)=>(0, $lNNXV.connect)(mapStateToProps, mapDispatchToProps, mergeProps, {
            ...options,
            forceV8: true
        })(component); // eslint-disable-line @typescript-eslint/no-explicit-any
const $494449a639f989a5$export$2881499e37b75b9a = (0, $lNNXV.Provider8Wrapped);

});

parcelRegister("fokFV", function(module, exports) {

$parcel$export(module.exports, "fieldsSelector", () => $d3e83eef394576d0$export$e1512647ca813bfa);
$parcel$export(module.exports, "getFieldHandlingSpecialFields", () => $d3e83eef394576d0$export$46dde968006cd8d4);
$parcel$export(module.exports, "fieldByCustomTypeSelector", () => $d3e83eef394576d0$export$72dfc619a02c972c);
$parcel$export(module.exports, "customFieldIdSelector", () => $d3e83eef394576d0$export$8ad8506b941e30dc);
$parcel$export(module.exports, "fieldSelector", () => $d3e83eef394576d0$export$4ee5e7baedf94214);
$parcel$export(module.exports, "hasIssueLinksSelector", () => $d3e83eef394576d0$export$3c65f67962ca81cc);
$parcel$export(module.exports, "hasSubtasksSelector", () => $d3e83eef394576d0$export$f363078714850fd9);
$parcel$export(module.exports, "hasSubtasksValuesSelector", () => $d3e83eef394576d0$export$689f8f96c9d81e1b);
$parcel$export(module.exports, "hasPortfolioChildIssuesSelector", () => $d3e83eef394576d0$export$724b8972771ff092);
$parcel$export(module.exports, "hasPortfolioChildIssueValuesSelector", () => $d3e83eef394576d0$export$c6d2d4f8e243ac37);
$parcel$export(module.exports, "hasChildrenIssuesSelector", () => $d3e83eef394576d0$export$29f34d4d7c528e9c);
$parcel$export(module.exports, "hasChildrenIssueValuesSelector", () => $d3e83eef394576d0$export$9034aaa32d45814b);
$parcel$export(module.exports, "childIssuesLimitUrlSelector", () => $d3e83eef394576d0$export$762e13908aaafb2d);
$parcel$export(module.exports, "availableFieldIdsSelector", () => $d3e83eef394576d0$export$641248fa887fb9ea);
$parcel$export(module.exports, "fieldSchemaConfigurationSelector", () => $d3e83eef394576d0$export$3c65874760e68948);
$parcel$export(module.exports, "isFieldEditableSelector", () => $d3e83eef394576d0$export$76ece3d8c4244af2);
$parcel$export(module.exports, "fieldNameSelector", () => $d3e83eef394576d0$export$2d1abc174b8a710e);
$parcel$export(module.exports, "fieldMetaKeySelector", () => $d3e83eef394576d0$export$351970d5fcbd0b29);
$parcel$export(module.exports, "fieldARISelector", () => $d3e83eef394576d0$export$f6363cecfaa3a9b0);
$parcel$export(module.exports, "fieldAutoCompleteUrlSelector", () => $d3e83eef394576d0$export$d27105f13ab27906);
$parcel$export(module.exports, "fieldAllowedValuesSelector", () => $d3e83eef394576d0$export$351dc1c32c2771ea);
$parcel$export(module.exports, "isFieldRequiredSelector", () => $d3e83eef394576d0$export$4c5f76e28914074);
$parcel$export(module.exports, "fieldTypeSelector", () => $d3e83eef394576d0$export$9e2f15437ff59992);
$parcel$export(module.exports, "fieldPersistedValueSelector", () => $d3e83eef394576d0$export$ae4660b0b7ebeee9);
$parcel$export(module.exports, "fieldPendingValueSelector", () => $d3e83eef394576d0$export$2ae929653dce6648);
$parcel$export(module.exports, "fieldEditingValueSelector", () => $d3e83eef394576d0$export$487becf51bedcd03);
$parcel$export(module.exports, "fieldEditingAdfValueSelector", () => $d3e83eef394576d0$export$31406f841bca5b75);
$parcel$export(module.exports, "fieldHtmlValueSelector", () => $d3e83eef394576d0$export$e69c8171ecd8fde2);
$parcel$export(module.exports, "isFieldEditingSelector", () => $d3e83eef394576d0$export$29e6b1cade110749);
$parcel$export(module.exports, "fieldEditSessionIdSelector", () => $d3e83eef394576d0$export$c53ab145ef243c95);
$parcel$export(module.exports, "isFieldWaitingSelector", () => $d3e83eef394576d0$export$30e972ebce44d9b8);
$parcel$export(module.exports, "fieldInvalidMessageSelector", () => $d3e83eef394576d0$export$d323462f155519c3);
$parcel$export(module.exports, "fieldInvalidSelector", () => $d3e83eef394576d0$export$e35f4d21d9739426);
$parcel$export(module.exports, "isRichTextFieldSelector", () => $d3e83eef394576d0$export$120a4249e9b3c231);
$parcel$export(module.exports, "richTextFieldIdsSelector", () => $d3e83eef394576d0$export$862745d3ab4003e5);
$parcel$export(module.exports, "isRichTextFieldEditingSelector", () => $d3e83eef394576d0$export$df9b7004d8b93e46);
$parcel$export(module.exports, "isMultilineFieldSelector", () => $d3e83eef394576d0$export$4d0b1fe809ae5e75);
$parcel$export(module.exports, "getEditingMultilineFieldIdsSelector", () => $d3e83eef394576d0$export$2469330614f0dba9);
$parcel$export(module.exports, "getVersionsFieldIds", () => $d3e83eef394576d0$export$a2fc0905011957cb);

var $df4Sl = parcelRequire("df4Sl");

var $8i1R8 = parcelRequire("8i1R8");

var $gUUjF = parcelRequire("gUUjF");


var $btjMs = parcelRequire("btjMs");

var $f9RL0 = parcelRequire("f9RL0");

var $lO4Or = parcelRequire("lO4Or");


var $5JqpU = parcelRequire("5JqpU");

var $9BmVu = parcelRequire("9BmVu");

var $7K0ls = parcelRequire("7K0ls");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d3e83eef394576d0$var$STABLE_EMPTY_ARRAY = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d3e83eef394576d0$var$STABLE_EMPTY_OBJECT = {};
const $d3e83eef394576d0$export$e1512647ca813bfa = (state)=>state.fields || $d3e83eef394576d0$var$STABLE_EMPTY_OBJECT;
const $d3e83eef394576d0$var$getFieldByCustomType = (customType, fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(fields, (field)=>(field.schema && field.schema.custom) === customType);
const $d3e83eef394576d0$export$46dde968006cd8d4 = (fieldId, fields)=>{
    let field = fields[fieldId];
    const customSystemFields = (0, $f9RL0.specialFields)();
    if (!field && Object.keys(customSystemFields).includes(fieldId)) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        const customType = customSystemFields[fieldId];
        // @ts-expect-error - TS2322 - Type 'Field | undefined' is not assignable to type 'Field'.
        field = $d3e83eef394576d0$var$getFieldByCustomType(customType, fields);
    }
    return field;
};
const $d3e83eef394576d0$export$cb67eba45dd11f50 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>!!fields[fieldId]);
const $d3e83eef394576d0$export$309344981947f228 = (fieldsState, fieldName)=>Array.isArray(fieldsState[fieldName]?.value) ? fieldsState[fieldName].value.length > 0 : fieldsState[fieldName]?.value != null;
const $d3e83eef394576d0$export$72dfc619a02c972c = (customType)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>$d3e83eef394576d0$var$getFieldByCustomType(customType, fields));
const $d3e83eef394576d0$export$8ad8506b941e30dc = (customFieldType)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$72dfc619a02c972c(customFieldType), (customField)=>{
        const idCandidates = customField ? customField.key.match(/customfield_(\d+)$/i) : null;
        return idCandidates ? +idCandidates[1] : null;
    });
const $d3e83eef394576d0$export$4ee5e7baedf94214 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>$d3e83eef394576d0$export$46dde968006cd8d4(fieldId, fields));
const $d3e83eef394576d0$export$b8de62018cc85a18 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>$d3e83eef394576d0$export$46dde968006cd8d4(fieldId, fields));
const $d3e83eef394576d0$export$3c65f67962ca81cc = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $ebc098a76317be78$export$a5fc282ab2bf9b89)));
const $d3e83eef394576d0$export$f363078714850fd9 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes('subtasks'));
const $d3e83eef394576d0$export$689f8f96c9d81e1b = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>$d3e83eef394576d0$export$309344981947f228(fields, 'subtasks'));
const $d3e83eef394576d0$export$724b8972771ff092 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $f9RL0.PORTFOLIO_CHILD_ISSUES)));
const $d3e83eef394576d0$export$c6d2d4f8e243ac37 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>$d3e83eef394576d0$export$309344981947f228(fields, (0, $f9RL0.PORTFOLIO_CHILD_ISSUES)));
const $d3e83eef394576d0$export$29f34d4d7c528e9c = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $f9RL0.CHILDREN_ISSUES)));
const $d3e83eef394576d0$export$9034aaa32d45814b = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>$d3e83eef394576d0$export$309344981947f228(fields, (0, $f9RL0.CHILDREN_ISSUES)));
const $d3e83eef394576d0$export$762e13908aaafb2d = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>{
    const getChildIssueUrlSelector = (fieldId)=>fields?.[fieldId]?.issueLimitUrl || '';
    return getChildIssueUrlSelector;
});
const $d3e83eef394576d0$export$9ee3b3f5d4ad4423 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>Object.keys(fields).map((fieldKey)=>$d3e83eef394576d0$export$46dde968006cd8d4(fieldKey, fields)).filter(Boolean));
const $d3e83eef394576d0$export$641248fa887fb9ea = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>Object.keys(fields));
const $d3e83eef394576d0$export$e50b5889a6b86caf = (field)=>field ? field.editable : false;
const $d3e83eef394576d0$export$3c65874760e68948 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.schema && field.schema.configuration && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        field.schema.configuration.reduce((config, { key: key, value: value })=>({
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...config,
                [key]: value
            }), {}));
const $d3e83eef394576d0$export$76ece3d8c4244af2 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>$d3e83eef394576d0$export$e50b5889a6b86caf(field));
const $d3e83eef394576d0$export$2d1abc174b8a710e = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>{
        if (field && field.title) return field.title;
        (0, $gUUjF.default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
        return '';
    });
const $d3e83eef394576d0$export$d20285fb6e3fb007 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$b8de62018cc85a18, (state, { fieldId: fieldId })=>fieldId, (field, fieldId)=>{
    if (field?.title) return field.title;
    (0, $gUUjF.default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
    return '';
});
const $d3e83eef394576d0$export$351970d5fcbd0b29 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.key);
const $d3e83eef394576d0$export$f6363cecfaa3a9b0 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.ari : undefined);
const $d3e83eef394576d0$export$d27105f13ab27906 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.autoCompleteUrl);
const $d3e83eef394576d0$export$351dc1c32c2771ea = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.allowedValues : $d3e83eef394576d0$var$STABLE_EMPTY_ARRAY);
const $d3e83eef394576d0$export$4c5f76e28914074 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.required : false);
const $d3e83eef394576d0$export$9e2f15437ff59992 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $btjMs.getFieldType)(field));
const $d3e83eef394576d0$export$ae4660b0b7ebeee9 = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.value);
const $d3e83eef394576d0$export$bf3f8fd2c145740 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$b8de62018cc85a18, (field)=>field?.value);
const $d3e83eef394576d0$export$2ae929653dce6648 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $7K0ls.default)(field));
const $d3e83eef394576d0$export$487becf51bedcd03 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $9BmVu.default)(field));
const $d3e83eef394576d0$export$31406f841bca5b75 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (field)=>field && (0, $9BmVu.getEditingAdfValue)(field));
const $d3e83eef394576d0$export$e69c8171ecd8fde2 = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.renderedValue);
const $d3e83eef394576d0$export$4e96991314eba25 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$b8de62018cc85a18, (field)=>field?.renderedValue);
const $d3e83eef394576d0$export$18ec1d851ee244b3 = (field)=>field ? field.editingValue !== undefined : false;
const $d3e83eef394576d0$export$29e6b1cade110749 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>$d3e83eef394576d0$export$18ec1d851ee244b3(field));
const $d3e83eef394576d0$export$c53ab145ef243c95 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>(field ? field.fieldEditSessionId : null) || '');
const $d3e83eef394576d0$export$30e972ebce44d9b8 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.pendingValue !== undefined : false);
const $d3e83eef394576d0$export$d323462f155519c3 = (fieldId, fallbackInvalidMessage)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && (field.isInvalid ? field.invalidMessage || fallbackInvalidMessage : null));
const $d3e83eef394576d0$export$e35f4d21d9739426 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>Boolean(field && field.isInvalid));
const $d3e83eef394576d0$export$448aaad27e620666 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.schema && field.schema.renderer);
const $d3e83eef394576d0$export$94cc87cea4e06b09 = (fieldType)=>fieldType === (0, $lO4Or.TEXT_AREA_CF_TYPE) || fieldType === (0, $f9RL0.ENVIRONMENT) || fieldType === (0, $f9RL0.DESCRIPTION);
const $d3e83eef394576d0$export$120a4249e9b3c231 = (fieldId)=>(0, $df4Sl.createSelector)((0, $5JqpU.isServiceDeskSelector), $d3e83eef394576d0$export$9e2f15437ff59992(fieldId), $d3e83eef394576d0$export$448aaad27e620666(fieldId), (isServiceDesk, fieldType, fieldRenderer)=>{
        const isDescription = fieldId === (0, $f9RL0.DESCRIPTION);
        const isMultilineRichTextField = $d3e83eef394576d0$export$94cc87cea4e06b09(fieldType) && fieldRenderer === (0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c);
        return isDescription || isMultilineRichTextField;
    });
const $d3e83eef394576d0$export$862745d3ab4003e5 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (state)=>state, (fields, state)=>Object.keys(fields).filter((fieldId)=>$d3e83eef394576d0$export$120a4249e9b3c231(fieldId)(state)));
const $d3e83eef394576d0$export$df9b7004d8b93e46 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$862745d3ab4003e5, (state)=>state, (richTextFieldIds, state)=>richTextFieldIds.some((fieldId)=>$d3e83eef394576d0$export$29e6b1cade110749(fieldId)(state)));
const $d3e83eef394576d0$export$4d0b1fe809ae5e75 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$9e2f15437ff59992(fieldId), (fieldType)=>$d3e83eef394576d0$export$94cc87cea4e06b09(fieldType));
const $d3e83eef394576d0$export$3263c202444b0e0 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (state)=>state, (fields, state)=>Object.keys(fields).filter((fieldId)=>$d3e83eef394576d0$export$4d0b1fe809ae5e75(fieldId)(state)));
const $d3e83eef394576d0$export$2469330614f0dba9 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$3263c202444b0e0, (state)=>state, (multilineFieldsIds, state)=>multilineFieldsIds.filter((fieldId)=>$d3e83eef394576d0$export$29e6b1cade110749(fieldId)(state)));
const $d3e83eef394576d0$export$a2fc0905011957cb = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214((0, $f9RL0.FIX_VERSIONS)), $d3e83eef394576d0$export$4ee5e7baedf94214((0, $f9RL0.AFFECTS_VERSIONS)), (fixVersions, affectsVersions)=>{
    const ids = [];
    if (fixVersions) ids.push(fixVersions.key);
    if (affectsVersions) ids.push(affectsVersions.key);
    return ids;
});

});
parcelRegister("8i1R8", function(module, exports) {

var $e5OGm = parcelRequire("e5OGm");

var $k61d1 = parcelRequire("k61d1");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $609171b9cff1596d$var$find = $e5OGm($k61d1);
module.exports = $609171b9cff1596d$var$find;

});
parcelRegister("e5OGm", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $jxg5X = parcelRequire("jxg5X");

var $8nrDO = parcelRequire("8nrDO");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a428d8bbecbff7a6$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$jxg5X(collection)) {
            var iteratee = $7qARj(predicate, 3);
            collection = $8nrDO(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $a428d8bbecbff7a6$var$createFind;

});

parcelRegister("k61d1", function(module, exports) {

var $9mB9u = parcelRequire("9mB9u");

var $7qARj = parcelRequire("7qARj");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ea154e499f779271$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $ea154e499f779271$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $hNahz(fromIndex);
    if (index < 0) index = $ea154e499f779271$var$nativeMax(length + index, 0);
    return $9mB9u(array, $7qARj(predicate, 3), index);
}
module.exports = $ea154e499f779271$var$findIndex;

});


const $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $c7e7b1d3600a0c0f$export$a4a240cb4053b29f = 'jira-text-renderer';
const $c7e7b1d3600a0c0f$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("btjMs", function(module, exports) {

$parcel$export(module.exports, "getFieldType", () => $2e3967e17ab00816$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isRichTextSupported", () => $2e3967e17ab00816$export$24d1b07fa0e9f9f1);


var $f9RL0 = parcelRequire("f9RL0");

var $lO4Or = parcelRequire("lO4Or");
const $2e3967e17ab00816$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $f9RL0.specialFields)();
    return [
        ...(0, $f9RL0.customFieldsToDisplay)().filter((cf)=>!(0, $f9RL0.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $lO4Or.FLAGGED_CF_TYPE)
    ];
};
const $2e3967e17ab00816$export$f521834fc2bfcd81 = (custom)=>$2e3967e17ab00816$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $2e3967e17ab00816$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $2e3967e17ab00816$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
const $2e3967e17ab00816$export$24d1b07fa0e9f9f1 = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? fieldSchema.type === (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE) && fieldSchema.renderer === (0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c) || $2e3967e17ab00816$export$b9089a6e41ed43aa(field) === (0, $lO4Or.DESCRIPTION_TYPE) : false;
};

});
parcelRegister("f9RL0", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $3183c1ede6a2aff4$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $3183c1ede6a2aff4$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $3183c1ede6a2aff4$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $3183c1ede6a2aff4$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $3183c1ede6a2aff4$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $3183c1ede6a2aff4$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $3183c1ede6a2aff4$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $3183c1ede6a2aff4$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $3183c1ede6a2aff4$export$6d7021166edc895c);
$parcel$export(module.exports, "PRIORITY", () => $3183c1ede6a2aff4$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $3183c1ede6a2aff4$export$79b91d4669dcadcb);
$parcel$export(module.exports, "DEV_SUMMARY", () => $3183c1ede6a2aff4$export$950d47e775e208ee);
$parcel$export(module.exports, "EPIC", () => $3183c1ede6a2aff4$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $3183c1ede6a2aff4$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $3183c1ede6a2aff4$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $3183c1ede6a2aff4$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $3183c1ede6a2aff4$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $3183c1ede6a2aff4$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $3183c1ede6a2aff4$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $3183c1ede6a2aff4$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SLA_PANEL", () => $3183c1ede6a2aff4$export$1d0e0bb6a21b800b);
$parcel$export(module.exports, "LINKED_ALERTS", () => $3183c1ede6a2aff4$export$340fac260c3e3637);
$parcel$export(module.exports, "CHAT_CHANNEL", () => $3183c1ede6a2aff4$export$24ec4dcc8e5b08ef);
$parcel$export(module.exports, "MSTEAMS_CHANNEL", () => $3183c1ede6a2aff4$export$8631065e0909313);
$parcel$export(module.exports, "ZOOM_MEETING", () => $3183c1ede6a2aff4$export$3c4dccba7d7e0acb);
$parcel$export(module.exports, "CONFERENCE_CALL", () => $3183c1ede6a2aff4$export$cd5e9246357daec3);
$parcel$export(module.exports, "KNOWLEDGE_BASE", () => $3183c1ede6a2aff4$export$203643a6fd9496a0);
$parcel$export(module.exports, "SENTIMENT", () => $3183c1ede6a2aff4$export$9c83bd19c3ffd90d);
$parcel$export(module.exports, "ASSET_ONBOARDING", () => $3183c1ede6a2aff4$export$c5c04443c6097d6e);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS", () => $3183c1ede6a2aff4$export$26d855f4cd7e5fe9);
$parcel$export(module.exports, "SUMMARY", () => $3183c1ede6a2aff4$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $3183c1ede6a2aff4$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $3183c1ede6a2aff4$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $3183c1ede6a2aff4$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $3183c1ede6a2aff4$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $3183c1ede6a2aff4$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $3183c1ede6a2aff4$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $3183c1ede6a2aff4$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $3183c1ede6a2aff4$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $3183c1ede6a2aff4$export$aba22e09a66f6826);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $3183c1ede6a2aff4$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $3183c1ede6a2aff4$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $3183c1ede6a2aff4$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $3183c1ede6a2aff4$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $3183c1ede6a2aff4$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $3183c1ede6a2aff4$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $3183c1ede6a2aff4$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $3183c1ede6a2aff4$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $3183c1ede6a2aff4$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $3183c1ede6a2aff4$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $3183c1ede6a2aff4$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $3183c1ede6a2aff4$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $3183c1ede6a2aff4$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $3183c1ede6a2aff4$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $3183c1ede6a2aff4$export$902f6c5cc939598a);

var $2wUFy = parcelRequire("2wUFy");

var $7ZZxN = parcelRequire("7ZZxN");

var $lO4Or = parcelRequire("lO4Or");
const $3183c1ede6a2aff4$export$ebb48b08205007c5 = 'issuetype';
const $3183c1ede6a2aff4$export$a464614f8f5fe986 = 'summary';
const $3183c1ede6a2aff4$export$a311a3c9b207604e = 'parent';
const $3183c1ede6a2aff4$export$2a4f270075a033de = 'parent-issue';
const $3183c1ede6a2aff4$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $3183c1ede6a2aff4$export$289917d9a7031e1d = 'watches';
const $3183c1ede6a2aff4$export$81614f6dc3be5b00 = 'votes';
const $3183c1ede6a2aff4$export$72a5630aa398d6b4 = 'security';
const $3183c1ede6a2aff4$export$caf1ff54fbdf44bf = 'issuerestriction';
const $3183c1ede6a2aff4$export$f8f7545d2bb78afb = 'assignee';
const $3183c1ede6a2aff4$export$6d7021166edc895c = 'reporter';
const $3183c1ede6a2aff4$export$cf7e173386d30cdd = 'duedate';
const $3183c1ede6a2aff4$export$bb34f3538ba26c7e = 'priority';
const $3183c1ede6a2aff4$export$79b91d4669dcadcb = 'labels';
const $3183c1ede6a2aff4$export$cbedbfe2cd0caec7 = 'components';
const $3183c1ede6a2aff4$export$950d47e775e208ee = 'devSummary';
const $3183c1ede6a2aff4$export$f91d2bb4cc99fa5e = 'releases';
const $3183c1ede6a2aff4$export$a316570a0dbfd2b0 = 'sprint';
const $3183c1ede6a2aff4$export$405b6d72f2d243a9 = 'storyPointsField';
const $3183c1ede6a2aff4$export$3cb4a99a332e4186 = 'epic';
const $3183c1ede6a2aff4$export$d7e18f5730074533 = 'fixVersions';
const $3183c1ede6a2aff4$export$c435f0000304e508 = 'versions';
const $3183c1ede6a2aff4$export$ee99ef6ee562a446 = 'timetracking';
const $3183c1ede6a2aff4$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $3183c1ede6a2aff4$export$e50006273435e7d4 = 'status';
const $3183c1ede6a2aff4$export$f1a6ce22cbb7eb32 = 'resolution';
const $3183c1ede6a2aff4$export$ff39ebd4bb12b718 = 'created';
const $3183c1ede6a2aff4$export$cd8e68094cb5c3cb = 'updated';
const $3183c1ede6a2aff4$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $3183c1ede6a2aff4$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $3183c1ede6a2aff4$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $3183c1ede6a2aff4$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $3183c1ede6a2aff4$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $3183c1ede6a2aff4$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $3183c1ede6a2aff4$export$203643a6fd9496a0 = 'KNOWLEDGE_BASE';
const $3183c1ede6a2aff4$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $3183c1ede6a2aff4$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $3183c1ede6a2aff4$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $3183c1ede6a2aff4$export$913055729e1380b2 = 'summary';
const $3183c1ede6a2aff4$export$d44826c816b5619b = 'description';
const $3183c1ede6a2aff4$export$a29989082612d0d9 = 'comment';
const $3183c1ede6a2aff4$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $3183c1ede6a2aff4$export$3b3d0889022c85b3 = 'children-issues';
const $3183c1ede6a2aff4$export$be46596bc6608f3b = 'environment';
const $3183c1ede6a2aff4$export$f528fadbfdb3c25e = 'subtasks';
const $3183c1ede6a2aff4$export$f10e53e8928b61bd = 'dataclassification';
const $3183c1ede6a2aff4$export$e0dfb65d1047c53c = (0, $lO4Or.PARENT_CF_TYPE);
const $3183c1ede6a2aff4$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $3183c1ede6a2aff4$export$cdbd1eb3b05729e0 = 'flagActions';
const $3183c1ede6a2aff4$export$c161a774ec2e7e56 = 'cardCoverActions';
const $3183c1ede6a2aff4$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$3183c1ede6a2aff4$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$3183c1ede6a2aff4$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$3183c1ede6a2aff4$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $lO4Or.TEAM_CF_TYPE)]: (0, $lO4Or.TEAM_CF_TYPE),
        [(0, $lO4Or.PARENT_CF_TYPE)]: (0, $lO4Or.PARENT_CF_TYPE),
        [(0, $lO4Or.BASELINE_START_CF_TYPE)]: (0, $lO4Or.BASELINE_START_CF_TYPE),
        [(0, $lO4Or.BASELINE_END_CF_TYPE)]: (0, $lO4Or.BASELINE_END_CF_TYPE),
        [(0, $lO4Or.COLOR_CF_TYPE)]: (0, $lO4Or.COLOR_CF_TYPE),
        [(0, $lO4Or.EPIC_COLOR_TYPE)]: (0, $lO4Or.EPIC_COLOR_TYPE),
        [(0, $lO4Or.EPIC_NAME_TYPE)]: (0, $lO4Or.EPIC_NAME_TYPE)
    };
    return fields;
};
const $3183c1ede6a2aff4$export$87934b3672715c91 = [
    (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $3183c1ede6a2aff4$var$serviceDeskCustomFields = [
    (0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $lO4Or.ORGANIZATIONS_CF_TYPE),
    (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE),
    (0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE),
    (0, $lO4Or.APPROVALS_CF_TYPE),
    (0, $lO4Or.APPROVERS_LIST_CF_TYPE),
    (0, $lO4Or.REQUEST_TYPE_CF_TYPE),
    (0, $lO4Or.CMDB_OBJECT_CF_TYPE),
    (0, $lO4Or.RESPONDERS_CF_TYPE),
    (0, $lO4Or.MAJOR_INCIDENT_CF_TYPE),
    (0, $lO4Or.ENTITLEMENT_CF_TYPE)
];
const $3183c1ede6a2aff4$export$efd443bccc4c01ed = ()=>[
        (0, $lO4Or.LABELS_CF_TYPE),
        (0, $lO4Or.TEXT_CF_TYPE),
        (0, $lO4Or.MULTI_USER_CF_TYPE),
        (0, $lO4Or.PARTICIPANTS_CF_TYPE),
        (0, $lO4Or.URL_CF_TYPE),
        (0, $lO4Or.NUMBER_CF_TYPE),
        (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $lO4Or.SELECT_CF_TYPE),
        (0, $lO4Or.MULTI_SELECT_CF_TYPE),
        (0, $lO4Or.VERSION_CF_TYPE),
        (0, $lO4Or.TEXT_AREA_CF_TYPE),
        (0, $lO4Or.MULTI_VERSION_CF_TYPE),
        (0, $lO4Or.DATE_CF_TYPE),
        (0, $lO4Or.GROUP_CF_TYPE),
        (0, $lO4Or.MULTI_GROUP_CF_TYPE),
        (0, $lO4Or.USER_CF_TYPE),
        (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
        (0, $lO4Or.RADIO_BUTTONS_CF_TYPE),
        (0, $lO4Or.DATETIME_CF_TYPE),
        (0, $lO4Or.ASSETS_CF_TYPE),
        (0, $lO4Or.SERVICE_ENTITY_CF_TYPE),
        (0, $lO4Or.PEOPLE_CF_TYPE),
        (0, $lO4Or.CASCADING_SELECT_CF_TYPE),
        (0, $lO4Or.PROJECT_PICKER_CF_TYPE),
        (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
        (0, $lO4Or.READ_ONLY_CF_TYPE),
        (0, $lO4Or.EPIC_STATUS_TYPE),
        (0, $lO4Or.MESSAGE_VIEW_CF_TYPE),
        (0, $lO4Or.MESSAGE_EDIT_CF_TYPE),
        (0, $lO4Or.CATEGORY_TYPE),
        (0, $lO4Or.GOALS_CF_TYPE),
        ...$3183c1ede6a2aff4$export$87934b3672715c91,
        ...$3183c1ede6a2aff4$var$serviceDeskCustomFields
    ];
const $3183c1ede6a2aff4$export$a18b3a656ee9c709 = {
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $7ZZxN.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $3183c1ede6a2aff4$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $3183c1ede6a2aff4$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $2wUFy.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $2wUFy.default).SOFTWARE_ISSUE,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $2wUFy.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0,
            $3183c1ede6a2aff4$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $2wUFy.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $2wUFy.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $3183c1ede6a2aff4$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $2wUFy.default).MOBILE_ISSUE,
        issueActions: []
    });
const $3183c1ede6a2aff4$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $2wUFy.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $2wUFy.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (config.isSimplified) return $3183c1ede6a2aff4$export$aebf676dfa727a1c();
            return $3183c1ede6a2aff4$export$27e0678365e5dcff();
        case 0, $7ZZxN.CORE_PROJECT:
            return $3183c1ede6a2aff4$export$381ce08838c53afa();
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return $3183c1ede6a2aff4$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $3183c1ede6a2aff4$export$27e0678365e5dcff();
    }
    return $3183c1ede6a2aff4$export$27e0678365e5dcff();
};

});
parcelRegister("2wUFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $78d48529cb7f139c$export$2e2bcd8739ae039);
const $78d48529cb7f139c$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $78d48529cb7f139c$export$2e2bcd8739ae039 = $78d48529cb7f139c$var$keys;

});



const $ebc098a76317be78$export$e18419056f3d184a = 'assignee';
const $ebc098a76317be78$export$45cafdfd629c3ca1 = 'reporter';
const $ebc098a76317be78$export$d5bc879e3b748593 = 'description';
const $ebc098a76317be78$export$a68dbc90211df1a8 = 'fixVersions';
const $ebc098a76317be78$export$93605f2a09aa8d26 = 'labels';
const $ebc098a76317be78$export$4420b7468f889692 = 'status';
const $ebc098a76317be78$export$e7cf1830fe735d1f = 'summary';
const $ebc098a76317be78$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $ebc098a76317be78$export$a5fc282ab2bf9b89 = 'issuelinks';
const $ebc098a76317be78$export$b52547457d714bc0 = 'epic-issues';
const $ebc098a76317be78$export$3cca6e37a5823d5a = 'children-issues';
const $ebc098a76317be78$export$98a935eb30de54ab = 'components';

parcelRegister("5JqpU", function(module, exports) {

$parcel$export(module.exports, "contextSelector", () => $2109a7cb7c7dfa9a$export$c420c9f40402ab6d);
$parcel$export(module.exports, "accountIdloggedInUserSelector", () => $2109a7cb7c7dfa9a$export$cb29341089829e17);
$parcel$export(module.exports, "orgIdSelector", () => $2109a7cb7c7dfa9a$export$24984a39db14d8);
$parcel$export(module.exports, "baseUrlSelector", () => $2109a7cb7c7dfa9a$export$1ca9a92a5f28e233);
$parcel$export(module.exports, "loginRedirectUrlSelector", () => $2109a7cb7c7dfa9a$export$767583fcce1653ec);
$parcel$export(module.exports, "issueKeySelector", () => $2109a7cb7c7dfa9a$export$d22bc6271070f453);
$parcel$export(module.exports, "issueIdSelector", () => $2109a7cb7c7dfa9a$export$31efbca30077ec1e);
$parcel$export(module.exports, "projectKeySelector", () => $2109a7cb7c7dfa9a$export$404de5ac601b84bc);
$parcel$export(module.exports, "analyticsSourceSelector", () => $2109a7cb7c7dfa9a$export$85a9d212d56669b4);
$parcel$export(module.exports, "analyticsMetadataSelector", () => $2109a7cb7c7dfa9a$export$8e1c68de0b1434ee);
$parcel$export(module.exports, "cloudIdSelector", () => $2109a7cb7c7dfa9a$export$b5a643cfff945455);
$parcel$export(module.exports, "activationIdSelector", () => $2109a7cb7c7dfa9a$export$2335b963a9875096);
$parcel$export(module.exports, "isAnonymousSelector", () => $2109a7cb7c7dfa9a$export$a165ec261432d0b8);
$parcel$export(module.exports, "localeSelector", () => $2109a7cb7c7dfa9a$export$f7b7935883444b11);
$parcel$export(module.exports, "issueActionsSelector", () => $2109a7cb7c7dfa9a$export$b62cb5286b153905);
$parcel$export(module.exports, "applicationKeySelector", () => $2109a7cb7c7dfa9a$export$6c7d07328f197de7);
$parcel$export(module.exports, "isMobileSelector", () => $2109a7cb7c7dfa9a$export$4cbb8c74e98876a5);
$parcel$export(module.exports, "isBitbucketSelector", () => $2109a7cb7c7dfa9a$export$245e5ba54167b84a);
$parcel$export(module.exports, "isServiceDeskSelector", () => $2109a7cb7c7dfa9a$export$43d733e4b7e8c7d0);
$parcel$export(module.exports, "isEcosystemEnabledSelector", () => $2109a7cb7c7dfa9a$export$9bffc1987c753bd9);
$parcel$export(module.exports, "rapidViewIdSelector", () => $2109a7cb7c7dfa9a$export$718e830000b27a0e);
$parcel$export(module.exports, "boardTypeSelector", () => $2109a7cb7c7dfa9a$export$5af08fd769c0f0);
$parcel$export(module.exports, "boardIdSelector", () => $2109a7cb7c7dfa9a$export$955e7dbf76b61f80);
$parcel$export(module.exports, "siteAdminStatusSelector", () => $2109a7cb7c7dfa9a$export$93badd2a066af8bd);
$parcel$export(module.exports, "licensedProductsSelector", () => $2109a7cb7c7dfa9a$export$f29192b357e6beca);
$parcel$export(module.exports, "appPermissionsSelector", () => $2109a7cb7c7dfa9a$export$5b71e1eb43056b6c);
$parcel$export(module.exports, "isModalSelector", () => $2109a7cb7c7dfa9a$export$5fa593caa6a15917);
$parcel$export(module.exports, "shouldRenderHeaderSelector", () => $2109a7cb7c7dfa9a$export$631793d49dec78de);
$parcel$export(module.exports, "viewModeSelector", () => $2109a7cb7c7dfa9a$export$1f11fe78e4f22d45);
$parcel$export(module.exports, "appEditionsSelector", () => $2109a7cb7c7dfa9a$export$28ca74e18c8f4529);
$parcel$export(module.exports, "tenantHasActiveServiceDeskLicenseSelector", () => $2109a7cb7c7dfa9a$export$96c87532aec3474a);

var $df4Sl = parcelRequire("df4Sl");


var $e91YZ = parcelRequire("e91YZ");

var $jBy23 = parcelRequire("jBy23");

var $f9RL0 = parcelRequire("f9RL0");

var $7HKaW = parcelRequire("7HKaW");
var $6vrw7 = parcelRequire("6vrw7");
const $2109a7cb7c7dfa9a$export$c420c9f40402ab6d = (state)=>state.context;
const $2109a7cb7c7dfa9a$export$cb29341089829e17 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.atlassianAccountId);
const $2109a7cb7c7dfa9a$export$24984a39db14d8 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context?.orgId || null);
const $2109a7cb7c7dfa9a$export$1ca9a92a5f28e233 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.baseUrl);
const $2109a7cb7c7dfa9a$export$767583fcce1653ec = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.loginRedirectUrl);
const $2109a7cb7c7dfa9a$export$d22bc6271070f453 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>(0, $6vrw7.toIssueKey)(context.issueKey));
const $2109a7cb7c7dfa9a$export$31efbca30077ec1e = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.issueId);
const $2109a7cb7c7dfa9a$export$404de5ac601b84bc = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$d22bc6271070f453, (issueKey)=>(0, $jBy23.extractProjectKey)(issueKey));
const $2109a7cb7c7dfa9a$export$85a9d212d56669b4 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.analyticsSource !== undefined ? context.analyticsSource : undefined);
const $2109a7cb7c7dfa9a$export$8e1c68de0b1434ee = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.analyticsMetadata !== undefined ? context.analyticsMetadata : undefined);
const $2109a7cb7c7dfa9a$export$b5a643cfff945455 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.cloudId || (0, $6vrw7.toCloudId)(''));
const $2109a7cb7c7dfa9a$export$2335b963a9875096 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.activationId || (0, $6vrw7.toActivationId)(''));
const $2109a7cb7c7dfa9a$export$a165ec261432d0b8 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.isAnonymous);
const $2109a7cb7c7dfa9a$export$f7b7935883444b11 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.locale);
const $2109a7cb7c7dfa9a$export$b62cb5286b153905 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.issueActions || []);
const $2109a7cb7c7dfa9a$export$6c7d07328f197de7 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.applicationKey);
const $2109a7cb7c7dfa9a$export$4cbb8c74e98876a5 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$2109a7cb7c7dfa9a$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $0100842672acae20$export$ce88447986394f2d));
const $2109a7cb7c7dfa9a$export$6fbe1dbaf5b67cc5 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $f9RL0.simpleSoftwareBoardConfiguration)().applicationKey || applicationKey === (0, $f9RL0.standardRoadmapConfiguration)().applicationKey);
const $2109a7cb7c7dfa9a$export$7479ef2453efd3b4 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $f9RL0.softwareConfiguration)().applicationKey);
const $2109a7cb7c7dfa9a$export$245e5ba54167b84a = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$2109a7cb7c7dfa9a$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $0100842672acae20$export$7552fe2669628499));
const $2109a7cb7c7dfa9a$export$43d733e4b7e8c7d0 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $f9RL0.serviceDeskConfiguration)().applicationKey);
const $2109a7cb7c7dfa9a$export$9bffc1987c753bd9 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>!!context.ecosystemEnabled);
const $2109a7cb7c7dfa9a$export$718e830000b27a0e = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.rapidViewId);
const $2109a7cb7c7dfa9a$export$8065de5fbcf23af5 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.estimationStatistic || null);
const $2109a7cb7c7dfa9a$export$5af08fd769c0f0 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.boardType);
const $2109a7cb7c7dfa9a$export$955e7dbf76b61f80 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.boardId);
const $2109a7cb7c7dfa9a$export$93badd2a066af8bd = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.siteAdminStatus);
const $2109a7cb7c7dfa9a$export$b468116a08f9183e = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.productCrossSellConfig);
const $2109a7cb7c7dfa9a$export$f29192b357e6beca = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.licensedProducts);
const $2109a7cb7c7dfa9a$export$5b71e1eb43056b6c = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.appPermissions);
const $2109a7cb7c7dfa9a$export$5fa593caa6a15917 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.isModal);
const $2109a7cb7c7dfa9a$export$631793d49dec78de = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$5fa593caa6a15917, $2109a7cb7c7dfa9a$export$4cbb8c74e98876a5, (isModal, isMobile)=>!isModal && !isMobile);
const $2109a7cb7c7dfa9a$export$1f11fe78e4f22d45 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.viewMode);
const $2109a7cb7c7dfa9a$export$28ca74e18c8f4529 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.appEditions);
const $2109a7cb7c7dfa9a$export$beea798086c18f0a = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.licenseStates);
const $2109a7cb7c7dfa9a$export$40487a15195e570e = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.serviceDesk === (0, $7HKaW.LICENSE_STATE_ACTIVE));
const $2109a7cb7c7dfa9a$export$96c87532aec3474a = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$f29192b357e6beca, $2109a7cb7c7dfa9a$export$40487a15195e570e, (licensedProducts, isServiceDeskLicenseActive)=>licensedProducts && licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SERVICEDESK] && isServiceDeskLicenseActive);

});

parcelRegister("9BmVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d346be13db9b307d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getEditingAdfValue", () => $d346be13db9b307d$export$a799cf637c5b7727);

var $7K0ls = parcelRequire("7K0ls");
var /**
 * Returns the first available value for a given field.
 * editingValue => pendingValue => value
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$d346be13db9b307d$export$2e2bcd8739ae039 = (field)=>typeof field.editingValue !== 'undefined' ? field.editingValue : (0, $7K0ls.default)(field);
const $d346be13db9b307d$export$a799cf637c5b7727 = (field)=>field.editingValue || (0, $7K0ls.getPendingAdfValue)(field);

});
parcelRegister("7K0ls", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d564564465be8d6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getPendingAdfValue", () => $8d564564465be8d6$export$5012210a9f91b010);
var /**
 * Returns the first available value for a given field, excluding editingValue
 * pendingValue => value
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$8d564564465be8d6$export$2e2bcd8739ae039 = (field)=>typeof field.pendingValue !== 'undefined' ? field.pendingValue : field.value;
const $8d564564465be8d6$export$5012210a9f91b010 = (field)=>field.pendingValue || field.adfValue || field.value;

});



parcelRegister("cJkBv", function(module, exports) {

$parcel$export(module.exports, "getComponentDisplayName", () => $2f48871b4587cf74$export$45e8c698cf7a36ef);
const $2f48871b4587cf74$export$45e8c698cf7a36ef = (WrappedComponent)=>WrappedComponent.displayName || WrappedComponent.name || 'Component';

});

parcelRegister("6qe7E", function(module, exports) {

$parcel$export(module.exports, "NEVER_TRACKING_FIELD_VIEW_EXPERIENCE", () => $23734a0df4e0d7c9$export$f34d908b831ad254);
$parcel$export(module.exports, "getFieldViewTrackerProviderWhitelist", () => $23734a0df4e0d7c9$export$3e3d8f59a22f8c7f);

var $lO4Or = parcelRequire("lO4Or");
const $23734a0df4e0d7c9$export$caa2c82331910f7b = 'ALWAYS_TRACKING';
const $23734a0df4e0d7c9$export$f34d908b831ad254 = 'NEVER_TRACKING';
const $23734a0df4e0d7c9$export$3837dc18364f7c06 = 'requestDetailsPanel';
// ...
// Meaning of entries in this map:
// * Missing field type - do not track the field's experience at all
// * Field type present with ALWAYS_TRACKING - Indicates that the field type should get a ViewExperienceTracker that always reports to the nearest experience provider
// * Field type present with a list of strings - All fields of this type will only report successes/failures when mounted directly inside an experience provider by this name (or sub experience provider with this location)
const $23734a0df4e0d7c9$var$viewTrackerProviderWhitelistByFieldType = {
    // Always tracking
    [(0, $lO4Or.DESCRIPTION_TYPE)]: $23734a0df4e0d7c9$export$caa2c82331910f7b,
    // Never tracking (if a field type is missing from this whole map, this category applies, items listed below are for clarity)
    [(0, $lO4Or.ECOSYSTEM_GLANCE_TYPE)]: $23734a0df4e0d7c9$export$f34d908b831ad254,
    [(0, $lO4Or.FORGE_GLANCE_TYPE)]: $23734a0df4e0d7c9$export$f34d908b831ad254,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: $23734a0df4e0d7c9$export$f34d908b831ad254,
    [(0, $lO4Or.REPORTER_TYPE)]: $23734a0df4e0d7c9$export$f34d908b831ad254,
    [(0, $lO4Or.SPRINT_TYPE)]: $23734a0df4e0d7c9$export$f34d908b831ad254,
    [(0, $lO4Or.STORY_POINTS_TYPE)]: $23734a0df4e0d7c9$export$f34d908b831ad254,
    [(0, $lO4Or.EPIC_TYPE)]: $23734a0df4e0d7c9$export$f34d908b831ad254,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $23734a0df4e0d7c9$export$f34d908b831ad254,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $23734a0df4e0d7c9$export$f34d908b831ad254,
    [(0, $lO4Or.DEV_SUMMARY_TYPE)]: $23734a0df4e0d7c9$export$f34d908b831ad254,
    [(0, $lO4Or.RELEASES_TYPE)]: $23734a0df4e0d7c9$export$f34d908b831ad254,
    [(0, $lO4Or.ASSETS_CF_TYPE)]: $23734a0df4e0d7c9$export$f34d908b831ad254,
    [(0, $lO4Or.ASSET_ONBOARDING_TYPE)]: $23734a0df4e0d7c9$export$f34d908b831ad254,
    [(0, $lO4Or.SERVICE_ENTITY_CF_TYPE)]: $23734a0df4e0d7c9$export$f34d908b831ad254,
    // Tracking only when mounted directly inside specific experience providers
    [(0, $lO4Or.LABELS_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.COMPONENTS_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.DUE_DATE_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.PRIORITY_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.ENVIRONMENT_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    // @ts-expect-error([Part of upgrade 4.9-5.4]) - An object literal cannot have multiple properties with the same name.
    [(0, $lO4Or.LABELS_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    // @ts-expect-error([Part of upgrade 4.9-5.4]) - An object literal cannot have multiple properties with the same name.
    [(0, $lO4Or.COMPONENTS_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.APPROVALS_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.KNOWLEDGE_BASE_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.SLA_PANEL_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.SENTIMENT_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.TIME_TRACKING_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.PARENT_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.BASELINE_START_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.BASELINE_END_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.LABELS_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.TEXT_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.URL_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.NUMBER_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.SELECT_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.VERSION_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.DATE_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.GROUP_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.USER_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.DATETIME_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.TEAM_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.REQUEST_TYPE_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.ORGANIZATIONS_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.COLOR_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.MESSAGE_VIEW_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.MESSAGE_EDIT_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ],
    [(0, $lO4Or.ENTITLEMENT_CF_TYPE)]: [
        $23734a0df4e0d7c9$export$3837dc18364f7c06
    ]
};
const $23734a0df4e0d7c9$export$3e3d8f59a22f8c7f = (fieldType)=>{
    const whitelist = $23734a0df4e0d7c9$var$viewTrackerProviderWhitelistByFieldType[fieldType];
    if (whitelist === undefined) return $23734a0df4e0d7c9$export$f34d908b831ad254;
    return whitelist;
};

});




parcelRegister("5Vkv7", function(module, exports) {

$parcel$export(module.exports, "IssueViewExperienceTrackingProviders", () => $bb2a54697b062b5e$export$6855f77cd9795208);

var $eUqFw = parcelRequire("eUqFw");

var $9EHc8 = parcelRequire("9EHc8");

var $jUWXQ = parcelRequire("jUWXQ");

var $1ybV0 = parcelRequire("1ybV0");

var $bNe1g = parcelRequire("bNe1g");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");

var $3WQZN = parcelRequire("3WQZN");
const $bb2a54697b062b5e$export$6855f77cd9795208 = ({ analyticsSource: analyticsSource, children: children, isExperienceReady: isExperienceReady, issueKey: issueKey })=>{
    const { data: data } = (0, $bNe1g.useProjectContext)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const projectType = data?.projectType;
    const application = projectType ? (0, $eIp1n.getApplicationForProject)(projectType) : null;
    const edition = application ? (0, $6WXNs.getEdition)(application, appEditions) : null;
    const getAdditionalAttributes = ()=>{
        if ((0, $1ybV0.ff)('issue-view.send-ufo-flags-in-slo-events_wyrfy')) return {
            featureFlags: Object.fromEntries((0, $3WQZN.allFeatureFlagsAccessed))
        };
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
        additionalAttributes: getAdditionalAttributes(),
        experience: "viewIssue",
        experienceId: issueKey,
        application: application,
        edition: edition,
        analyticsSource: analyticsSource,
        isExperienceReady: isExperienceReady
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jUWXQ.default), {
        experience: "editIssue",
        application: application,
        edition: edition,
        analyticsSource: analyticsSource
    }, children));
};

});
parcelRegister("9EHc8", function(module, exports) {

$parcel$export(module.exports, "ViewExperienceTrackingProvider", () => $617962e6a5e395d0$export$a5efa46877be148f);
$parcel$export(module.exports, "SubExperienceTrackingProvider", () => $617962e6a5e395d0$export$e0241c84ce5db240);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $1YJkI = parcelRequire("1YJkI");

var $8yne0 = parcelRequire("8yne0");

var $8nLP2 = parcelRequire("8nLP2");
const $617962e6a5e395d0$export$a5efa46877be148f = ({ isExperienceReady: isExperienceReady, experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nLP2.default), {
        isExperienceReady: isExperienceReady,
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: additionalAttributes
    }, children);
$617962e6a5e395d0$export$a5efa46877be148f.defaultProps = {
    isExperienceReady: true,
    experienceId: null,
    additionalAttributes: {}
};
var $617962e6a5e395d0$export$2e2bcd8739ae039 = $617962e6a5e395d0$export$a5efa46877be148f;
const $617962e6a5e395d0$export$e0241c84ce5db240 = ({ children: children, location: location, parentProviders: parentProviders })=>// DO NOT use `useContext` or `static contextType = ...` to consume this context
    // as the tree walker used in SSR does not support hooks
    // and SSR does not support `static contextType` setting
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YJkI.default).Consumer, null, (context)=>{
        if (context == null) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('experience-sub-provider.missing-provider', 'Experience sub-provider rendered without a parent provider');
            return children;
        }
        const { experienceId: experienceId } = context;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), {
            location: location,
            parentProviders: parentProviders
        }, (trackerCallbacks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nLP2.default), {
                parentTrackerCallbacks: trackerCallbacks,
                experience: location,
                experienceId: experienceId,
                analyticsSource: null,
                application: null,
                edition: null,
                isExperienceReady: true
            }, children));
    });
$617962e6a5e395d0$export$e0241c84ce5db240.defaultProps = {
    parentProviders: null
};

});
parcelRegister("8nLP2", function(module, exports) {

$parcel$export(module.exports, "default", () => $392c2e4759c6c8b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9lmTX = parcelRequire("9lmTX");


var $1YJkI = parcelRequire("1YJkI");
class $392c2e4759c6c8b5$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            parentTrackerCallbacks: null,
            additionalAttributes: {}
        };
    }
    constructor(props){
        super(props);
        this.onPending = ()=>{
            this.pendingCount += 1;
            this.shouldTrackExperience = true;
            this.checkAndStartTimer();
        };
        this.onSuccess = ()=>{
            this.pendingCount -= 1;
            this.checkAndStartTimer();
        };
        this.onFailure = (location, additionalAttributes)=>{
            // We need to track failure *immediately*, otherwise this component may
            // be unmounted and we'd miss our chance.
            this.trackExperience({
                wasExperienceSuccesful: false,
                location: location,
                additionalAttributes: additionalAttributes
            });
        };
        this.onAbort = (location, additionalAttributes)=>{
            this.trackExperience({
                wasExperienceSuccesful: false,
                action: (0, $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8),
                location: location,
                additionalAttributes: additionalAttributes
            });
        };
        this.resetExperience();
    }
    componentDidMount() {
        this.checkAndStartTimer();
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
    }
    componentDidCatch(error) {
        // This catches any errors that bubble up to the Provider that
        // may not be caught by any ExperienceTrackers
        this.trackExperience({
            wasExperienceSuccesful: false,
            location: 'error-reached-provider',
            additionalAttributes: {
                errorMessage: error.message,
                errorName: error.name
            }
        });
        // We're deliberately rethrowing the error here because we don't want to interfere with
        // any error handling the container app may have in place.
        throw error;
    }
    componentWillUnmount() {
        clearTimeout(this.timerId);
    }
    checkAndStartTimer() {
        if (this.shouldTrackExperience && this.props.isExperienceReady) this.startTimer();
    }
    startTimer() {
        clearTimeout(this.timerId);
        // @ts-expect-error - TS2322 - Type 'Timeout' is not assignable to type 'number'.
        this.timerId = setTimeout(()=>{
            if (this.pendingCount === 0) this.trackExperience({
                wasExperienceSuccesful: true
            });
        }, 1000);
    }
    // Resetting must not call setState since this can be executed in the render phase
    resetExperience() {
        clearTimeout(this.timerId);
        this.timerId = undefined;
        this.shouldTrackExperience = false;
        this.hasTrackedExperience = false;
        this.pendingCount = 0;
        this.memoizedContext = {
            consumerCallbacks: {
                onPending: this.onPending,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure,
                onAbort: this.onAbort
            },
            experienceId: this.props.experienceId,
            experience: this.props.experience
        };
    }
    trackExperience({ wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, additionalAttributes: additionalAttributes }) {
        if (this.hasTrackedExperience) // We only ever want to send a single success/failure event for an experience
        return;
        this.hasTrackedExperience = true;
        const { parentTrackerCallbacks: parentTrackerCallbacks, additionalAttributes: additionalAttributesFromProps } = this.props;
        if (parentTrackerCallbacks) {
            if (wasExperienceSuccesful) parentTrackerCallbacks.onExperienceSuccess();
            else parentTrackerCallbacks.onExperienceFailure(location, {
                ...additionalAttributesFromProps,
                ...additionalAttributes
            });
        } else {
            const { experience: experience } = this.memoizedContext;
            const { analyticsSource: analyticsSource, application: application, edition: edition } = this.props;
            analyticsSource && (0, $9lmTX.default)({
                experience: experience,
                action: action,
                wasExperienceSuccesful: wasExperienceSuccesful,
                location: location,
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: {
                    ...additionalAttributesFromProps,
                    ...additionalAttributes
                }
            });
        }
    }
    // Check every render to reset the experience state instance variables
    checkExperienceIdForExperienceReset() {
        if (this.memoizedContext.experienceId !== this.props.experienceId) this.resetExperience();
    }
    render() {
        this.checkExperienceIdForExperienceReset();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YJkI.default).Provider, {
            value: this.memoizedContext
        }, this.props.children);
    }
}

});
const $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $99e7a4e4cbcb5db0$export$b48b3d1872522384 = 'taskFail';
const $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8 = 'taskAbort';



parcelRegister("jUWXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $545a45c061d1fd76$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $9lmTX = parcelRequire("9lmTX");

var $kogDC = parcelRequire("kogDC");
const $545a45c061d1fd76$var$DEBOUNCE_DELAY = 1000;
class $545a45c061d1fd76$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    trackFailure(field, errorMessage, additionalAttributes) {
        const { analyticsSource: analyticsSource, experience: experience, application: application, edition: edition } = this.props;
        (0, $9lmTX.default)({
            experience: experience,
            wasExperienceSuccesful: false,
            field: field,
            application: application,
            edition: edition,
            analyticsSource: analyticsSource,
            additionalAttributes: {
                ...additionalAttributes,
                errorMessage: errorMessage
            }
        });
    }
    render() {
        return(// @ts-expect-error - TS2322 - Type 'DebouncedFunc<(field: string, errorMessage: string, additionalAttributes?: Attributes | undefined) => void>' is not assignable to type '(field: string) => void'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kogDC.default).Provider, {
            value: {
                onFailure: this.onFailure
            }
        }, this.props.children));
    }
    constructor(...args){
        super(...args);
        this.onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(this.trackFailure.bind(this), $545a45c061d1fd76$var$DEBOUNCE_DELAY);
    }
}

});
parcelRegister("kogDC", function(module, exports) {

$parcel$export(module.exports, "default", () => $36bd34074dad1817$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $36bd34074dad1817$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});


parcelRegister("bNe1g", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $a10c8c1f49371370$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $a10c8c1f49371370$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $a10c8c1f49371370$export$a85f6b5857d2176);

var $eUqFw = parcelRequire("eUqFw");

var $3HCkE = parcelRequire("3HCkE");

var $ixwgj = parcelRequire("ixwgj");
const $a10c8c1f49371370$export$8f31c2503e1efa93 = ()=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $3HCkE.useResource)((0, $ixwgj.projectContextResourceWithCache));
    const updateCache = (0, $eUqFw.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $a10c8c1f49371370$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $a10c8c1f49371370$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $a10c8c1f49371370$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $a10c8c1f49371370$export$8f31c2503e1efa93();
    return children(projectContext);
};

});
parcelRegister("ixwgj", function(module, exports) {

$parcel$export(module.exports, "projectContextResource", () => $97b06b2828b1be93$export$27ad0d75c619be68);
$parcel$export(module.exports, "projectContextResourceWithCache", () => $97b06b2828b1be93$export$d75816e37af81473);

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");


const $97b06b2828b1be93$var$getDataLoader = ()=>(parcelRequire("ajizA"));
const $97b06b2828b1be93$export$27ad0d75c619be68 = (0, $3HCkE.createResource)({
    type: (0, $e9754370217fd66e$export$80a60a092d9ab81),
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return projectKey || projectId;
    },
    getDataLoader: $97b06b2828b1be93$var$getDataLoader,
    maxAge: 1800000
});
const $97b06b2828b1be93$export$d75816e37af81473 = $97b06b2828b1be93$export$27ad0d75c619be68;

});
const $e9754370217fd66e$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("ajizA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cLVTX');
        const value = parcelRequire('6oUEv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cLVTX").then(()=>parcelRequire('6oUEv'));
}

});



parcelRegister("ab6rA", function(module, exports) {

$parcel$export(module.exports, "useAppEditions", () => $75e408c194026ea5$export$92ed15881fc090d7);

var $gd0Sp = parcelRequire("gd0Sp");
const $75e408c194026ea5$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});


parcelRegister("isela", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb795038160fea47$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $heNSb = parcelRequire("heNSb");

var $hJ992 = parcelRequire("hJ992");

var $fWeG1 = parcelRequire("fWeG1");
const $fb795038160fea47$export$c2baaef75fac62b = ({ location: location })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ value: value }] = (0, $fWeG1.useSummaryField)({
        issueKey: issueKey
    });
    if (location !== (0, $0100842672acae20$export$b19f949fb9713614) && location !== (0, $0100842672acae20$export$7063ee6d0035a982) && location !== (0, $0100842672acae20$export$5bd5011b6596a0e7) && location !== (0, $0100842672acae20$export$14a8072f422804fd)) return null;
    if (value === null || value === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: `[${issueKey}] ${value}`
    });
};
var $fb795038160fea47$export$2e2bcd8739ae039 = $fb795038160fea47$export$c2baaef75fac62b;

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});
parcelRegister("1TtYL", function(module, exports) {

$parcel$export(module.exports, "DocumentTitleContainer", () => $d28b8ffe196ad843$export$1aad43993172f16f);
$parcel$export(module.exports, "DocumentTitleSubscriber", () => $d28b8ffe196ad843$export$b88d5abf3e0bec8c);
$parcel$export(module.exports, "DocumentTitleHelper", () => $d28b8ffe196ad843$export$573bf8d2ae7d60dc);

var $eUqFw = parcelRequire("eUqFw");

var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $98Lej = parcelRequire("98Lej");

var $3fq1f = parcelRequire("3fq1f");
const $d28b8ffe196ad843$var$initialState = {
    title: '',
    defaultTitle: '',
    contextArray: []
};
const $d28b8ffe196ad843$var$Store = (0, $a61MH.createStore)({
    name: 'document-title',
    initialState: $d28b8ffe196ad843$var$initialState,
    actions: $98Lej
});
const $d28b8ffe196ad843$export$1aad43993172f16f = (0, $heB5U.createContainer)($d28b8ffe196ad843$var$Store, {
    displayName: 'DocumentTitleContainer'
});
const $d28b8ffe196ad843$export$b88d5abf3e0bec8c = (0, $dYfll.createSubscriber)($d28b8ffe196ad843$var$Store, {
    displayName: 'DocumentTitleSubscriber'
});
class $d28b8ffe196ad843$export$573bf8d2ae7d60dc extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.myself = Symbol('document title identifier');
        this.props.addDocumentTitle(this.myself);
    }
    componentDidMount() {
        this.updateTitle();
    }
    componentDidUpdate() {
        this.updateTitle();
    }
    componentWillUnmount() {
        this.props.removeDocumentTitle(this.myself);
        this.updateTitle();
    }
    updateTitle() {
        if ((0, $3fq1f.checkDocumentTitle)(this.myself, this.props.contextArray)) this.props.setTitle(this.props.title);
    }
    render() {
        return null;
    }
}

});
parcelRegister("98Lej", function(module, exports) {

$parcel$export(module.exports, "setTitle", () => (parcelRequire("hzX2Z")).default);
$parcel$export(module.exports, "addDocumentTitle", () => (parcelRequire("aIEib")).addDocumentTitle);
$parcel$export(module.exports, "removeDocumentTitle", () => (parcelRequire("h3oaR")).removeDocumentTitle);

var $hzX2Z = parcelRequire("hzX2Z");

var $aIEib = parcelRequire("aIEib");

var $h3oaR = parcelRequire("h3oaR");

});
parcelRegister("hzX2Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $badd7a809fe968ef$export$2e2bcd8739ae039);

var $3fq1f = parcelRequire("3fq1f");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$badd7a809fe968ef$export$2e2bcd8739ae039 = (title)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
        const state = getState();
        const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
        const newTitle = (0, $3fq1f.createTitleFromTemplate)(title, titleTemplate);
        document.title = newTitle;
        setState({
            ...state,
            title: newTitle
        });
    };

});
parcelRegister("3fq1f", function(module, exports) {

$parcel$export(module.exports, "createTitleFromTemplate", () => $5992d599a50ec92a$export$3795256dd54a9c9d);
$parcel$export(module.exports, "ripTitleTemplateFromMeta", () => $5992d599a50ec92a$export$b7d18105f80195c);
$parcel$export(module.exports, "checkDocumentTitle", () => $5992d599a50ec92a$export$7f8be70a0bed1bae);
const $5992d599a50ec92a$export$3795256dd54a9c9d = (title, template)=>template.replace(/%s/, title);
const $5992d599a50ec92a$export$b7d18105f80195c = (getMeta)=>getMeta('ajs-app-title');
const $5992d599a50ec92a$export$7f8be70a0bed1bae = (title, contextArray)=>{
    if (contextArray[contextArray.length - 1] === title) return true;
    return false;
};

});


parcelRegister("aIEib", function(module, exports) {

$parcel$export(module.exports, "addDocumentTitle", () => $65d14c1ffc455bbb$export$a0c188c0ea474bb8);
const $65d14c1ffc455bbb$export$a0c188c0ea474bb8 = (title)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        contextArray.push(title);
        setState({
            contextArray: contextArray
        });
    };

});

parcelRegister("h3oaR", function(module, exports) {

$parcel$export(module.exports, "removeDocumentTitle", () => $06c2c915252a36d1$export$e844009b77f80a72);
const $06c2c915252a36d1$export$e844009b77f80a72 = (title)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        setState({
            contextArray: contextArray.filter((symbol)=>symbol !== title)
        });
    };

});




parcelRegister("hJ992", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $7e3614f655e5103c$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $7e3614f655e5103c$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $7e3614f655e5103c$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $7e3614f655e5103c$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $7e3614f655e5103c$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $7e3614f655e5103c$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $7e3614f655e5103c$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $7e3614f655e5103c$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $7e3614f655e5103c$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $7e3614f655e5103c$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $7e3614f655e5103c$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $7e3614f655e5103c$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $7e3614f655e5103c$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $7e3614f655e5103c$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $7e3614f655e5103c$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $7e3614f655e5103c$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $7e3614f655e5103c$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $7e3614f655e5103c$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $7e3614f655e5103c$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $7e3614f655e5103c$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiOptInEnabled", () => $7e3614f655e5103c$export$b131d9f6da853161);

var $eUqFw = parcelRequire("eUqFw");


var $e91YZ = parcelRequire("e91YZ");

var $7HKaW = parcelRequire("7HKaW");
var $6vrw7 = parcelRequire("6vrw7");

var $j3FUN = parcelRequire("j3FUN");
var $jBTMs = parcelRequire("jBTMs");

var $hWdjG = parcelRequire("hWdjG");
const $7e3614f655e5103c$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $hWdjG.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $7e3614f655e5103c$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $hWdjG.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $7e3614f655e5103c$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $7e3614f655e5103c$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $7e3614f655e5103c$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $hWdjG.useIssueContextStoreIsModal)();
    return isModal;
};
const $7e3614f655e5103c$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $7e3614f655e5103c$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $hWdjG.useIssueContextStoreIssueId)();
    return issueId;
};
const $7e3614f655e5103c$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $hWdjG.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $7e3614f655e5103c$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $hWdjG.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $7e3614f655e5103c$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return (0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
};
const $7e3614f655e5103c$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $hWdjG.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $7e3614f655e5103c$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $hWdjG.useIssueContextStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        resetDetailView
    ]);
    return [
        undefined,
        actions
    ];
};
const $7e3614f655e5103c$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $hWdjG.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $7e3614f655e5103c$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $hWdjG.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $7e3614f655e5103c$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $hWdjG.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $7e3614f655e5103c$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $hWdjG.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $7e3614f655e5103c$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $hWdjG.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $7e3614f655e5103c$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $hWdjG.useIssueContextStoreViewMode)();
    return viewMode;
};
const $7e3614f655e5103c$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $hWdjG.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $7e3614f655e5103c$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $hWdjG.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $7e3614f655e5103c$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $hWdjG.useIssueContextStoreBoardId)();
    return boardId;
};
const $7e3614f655e5103c$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $hWdjG.useIssueContextStoreBoardType)();
    return boardType;
};
const $7e3614f655e5103c$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $hWdjG.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $7e3614f655e5103c$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $hWdjG.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $7e3614f655e5103c$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $hWdjG.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $7e3614f655e5103c$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $hWdjG.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $7e3614f655e5103c$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $hWdjG.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const licenseStates = (0, $jBTMs.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $7HKaW.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $7e3614f655e5103c$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$b19f949fb9713614);
};
const $7e3614f655e5103c$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$a5132300c5214280);
};
const $7e3614f655e5103c$export$b131d9f6da853161 = ()=>{
    const [isAiOptInEnabled] = (0, $hWdjG.useIssueContextIsAiOptInEnabled)();
    return isAiOptInEnabled;
};

});
parcelRegister("j3FUN", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $02df0e5ac33ae573$export$54d534cc91e54850);

var $gd0Sp = parcelRequire("gd0Sp");
const $02df0e5ac33ae573$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("jBTMs", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $0a5df676eadd90b5$export$268651a63abe408a);

var $gd0Sp = parcelRequire("gd0Sp");
const $0a5df676eadd90b5$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("hWdjG", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $c495211a89197754$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $c495211a89197754$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $c495211a89197754$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $c495211a89197754$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $c495211a89197754$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $c495211a89197754$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $c495211a89197754$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $c495211a89197754$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $c495211a89197754$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $c495211a89197754$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $c495211a89197754$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $c495211a89197754$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $c495211a89197754$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $c495211a89197754$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $c495211a89197754$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $c495211a89197754$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $c495211a89197754$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $c495211a89197754$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $c495211a89197754$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $c495211a89197754$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $c495211a89197754$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $c495211a89197754$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $c495211a89197754$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiOptInEnabled", () => $c495211a89197754$export$7e70ee570119a0a7);
$parcel$export(module.exports, "IssueContextContainer", () => $c495211a89197754$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $c495211a89197754$export$965360ae27fcae98);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $6vrw7 = parcelRequire("6vrw7");

var $lDYuK = parcelRequire("lDYuK");

var $8d785 = parcelRequire("8d785");

var $hHM8F = parcelRequire("hHM8F");
const $c495211a89197754$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $6vrw7.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $lDYuK.getBoardDetailViewMode)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false
};
const $c495211a89197754$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-context',
    initialState: $c495211a89197754$export$d4c72bab9d6cc13a,
    actions: $8d785.actions
});
const $c495211a89197754$var$getIssueContext = (state)=>state;
const $c495211a89197754$var$getIsModal = (state)=>state.isModal;
const $c495211a89197754$var$getIssueKey = (state)=>state.issueKey;
const $c495211a89197754$var$getIsArchived = (state)=>state.isArchived;
const $c495211a89197754$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $c495211a89197754$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $c495211a89197754$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $c495211a89197754$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $c495211a89197754$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $c495211a89197754$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $c495211a89197754$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $c495211a89197754$var$getIsLoading = (state)=>state.isLoading;
const $c495211a89197754$var$getViewMode = (state)=>state.viewMode;
const $c495211a89197754$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $c495211a89197754$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $c495211a89197754$var$getBoardId = (state)=>state.boardId;
const $c495211a89197754$var$getBoardType = (state)=>state.boardType;
const $c495211a89197754$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $c495211a89197754$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $c495211a89197754$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $c495211a89197754$var$getRapidViewId = (state)=>state.rapidViewId;
const $c495211a89197754$var$getViewScreenId = (state)=>state.viewScreenId;
const $c495211a89197754$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $c495211a89197754$export$f6e0a3ee03299fbc = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueContext
});
const $c495211a89197754$export$abdbea56d86b4aac = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesLimit)
});
const $c495211a89197754$export$326ff2b963d51c5c = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesIssueLimitUrls)
});
const $c495211a89197754$export$44bcaaabb74e402b = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueKey
});
const $c495211a89197754$export$332dcee0cf9f4e45 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueId
});
const $c495211a89197754$export$c940355b1fc6e1c4 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsArchived
});
const $c495211a89197754$export$b9eebaa1da421997 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsClassifyEditEnabled
});
const $c495211a89197754$export$daa47fd600e43a32 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsModal
});
const $c495211a89197754$export$ba2e9546ab5ba6f = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewScreenId
});
const $c495211a89197754$export$74d38d6c437efc1b = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getAnalyticsSource
});
const $c495211a89197754$export$2092528ee170d9e7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewMap
});
const $c495211a89197754$export$57898374e6239a5a = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getMaxTokenLength
});
const $c495211a89197754$export$ff0264ec4c015dc1 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoadedWithPage
});
const $c495211a89197754$export$6c8b81f6dca8c23d = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getEstimationStatistic
});
const $c495211a89197754$export$fe7085456138f0fc = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoading
});
const $c495211a89197754$export$c339e36468c12443 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewMode
});
const $c495211a89197754$export$ef3bfa2642bb98cd = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBackButtonUrl
});
const $c495211a89197754$export$8accd063c74cd455 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueNavigatorData
});
const $c495211a89197754$export$e7edffc2a20027e7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardId
});
const $c495211a89197754$export$48aaa3a6bc2085d7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardType
});
const $c495211a89197754$export$4a4b96bcf5166327 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsSpaEnabled
});
const $c495211a89197754$export$bbd8ba0180545556 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getLoginRedirectUrl
});
const $c495211a89197754$export$aaa89627762c7d00 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getOnIssueKeyChange
});
const $c495211a89197754$export$796589b0ec52848a = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewId
});
const $c495211a89197754$export$7e70ee570119a0a7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsAiOptInEnabled
});
const $c495211a89197754$export$93db6a8f3342dddf = (0, $heB5U.createContainer)($c495211a89197754$export$6f57813fe9f31bf9);
const $c495211a89197754$export$965360ae27fcae98 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("lDYuK", function(module, exports) {

$parcel$export(module.exports, "setBoardDetailViewMode", () => $1ed8663d5b2b533f$export$5aec23d4b2954b61);
$parcel$export(module.exports, "getBoardDetailViewMode", () => $1ed8663d5b2b533f$export$30296c2892a21468);
$parcel$export(module.exports, "getSwimlaneModeSetting", () => $1ed8663d5b2b533f$export$1708c8217a67f3f9);

var $aZaPn = parcelRequire("aZaPn");

var $idwtd = parcelRequire("idwtd");
const $1ed8663d5b2b533f$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('software');
const $1ed8663d5b2b533f$var$GROUP_BY_SELECTION = 'gh.groupBySelection.';
const $1ed8663d5b2b533f$export$5aec23d4b2954b61 = (detailViewMode)=>$1ed8663d5b2b533f$var$localStorage.set((0, $idwtd.BOARD_DETAIL_VIEW_MODE), detailViewMode);
const $1ed8663d5b2b533f$export$30296c2892a21468 = ()=>$1ed8663d5b2b533f$var$localStorage.get((0, $idwtd.BOARD_DETAIL_VIEW_MODE)) || (0, $idwtd.DETAIL_VIEW_DEFAULT);
const $1ed8663d5b2b533f$export$1708c8217a67f3f9 = (boardId)=>{
    const data = $1ed8663d5b2b533f$var$localStorage.get(`${$1ed8663d5b2b533f$var$GROUP_BY_SELECTION}${boardId}`);
    if (!data) return null;
    return data;
};

});
parcelRegister("aZaPn", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageProvider", () => $e83d7abe46867842$export$697e65b1658f821b);
$parcel$export(module.exports, "createLocalExpirableStorageProvider", () => $e83d7abe46867842$export$59acef2b3ab1df90);

var $jqvCZ = parcelRequire("jqvCZ");

var $avHyR = parcelRequire("avHyR");

var $kkXA4 = parcelRequire("kkXA4");
const $e83d7abe46867842$export$697e65b1658f821b = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>(0, $avHyR.createStorageProvider)(appPrefix, (0, $kkXA4.makeLocalStore)()));
const $e83d7abe46867842$export$59acef2b3ab1df90 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const store = (0, $kkXA4.makeLocalExpirableStore)();
    return store.namespace(appPrefix);
});

});
parcelRegister("avHyR", function(module, exports) {

$parcel$export(module.exports, "plugins", () => $e7af9f5944d51b15$export$8b3ca321c77fdea6);
$parcel$export(module.exports, "createStorageProvider", () => $e7af9f5944d51b15$export$8441605555fbd60c);

var $2y3XF = parcelRequire("2y3XF");

var $4b9NC = parcelRequire("4b9NC");
const $e7af9f5944d51b15$export$8b3ca321c77fdea6 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
    (0, $4b9NC.default)
];
const $e7af9f5944d51b15$export$8441605555fbd60c = (appPrefix, store)=>store.namespace(appPrefix);

});
parcelRegister("4b9NC", function(module, exports) {

$parcel$export(module.exports, "default", () => $19af1635632d325b$export$2e2bcd8739ae039);

var $guiFP = parcelRequire("guiFP");

var $gjqa4 = parcelRequire("gjqa4");
/**
 * Enhances storage operations with automated cleanup capabilities. This includes tracking
 * item timestamps for age-based cleanup, handling storage limits by removing older items,
 * and providing utility functions for managing storage contents. Designed to ensure
 * efficient use of storage space without manual intervention.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $19af1635632d325b$var$cleanUpPlugin() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $gjqa4.NAMESPACE));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function set(superFn, key, val) {
        try {
            if (!self.hasNamespace((0, $gjqa4.NAMESPACE))) timestamps.set(key, Date.now());
            superFn();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // storage is full. Relevant only for localStorage
            if (e.code === (0, $gjqa4.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $gjqa4.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                // 22 - the correct code most browsers use
                // 1014 - Firefox's code
                (0, $guiFP.default)({
                    meta: {
                        id: 'browserLocalStorageFullError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        namespace: self._namespacePrefix
                    },
                    error: e
                });
                if (self.cleanWhenFull()) self.set(superFn, key, val);
            } else {
                (0, $guiFP.default)({
                    meta: {
                        id: 'storageCleanupPluginError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        isLegacyFunction: false
                    },
                    error: e
                });
                throw e;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function remove(superFn, key) {
        if (!self.hasNamespace((0, $gjqa4.NAMESPACE))) timestamps.remove(key);
        return superFn();
    }
    // quite stupid way of getting totals, but current library supports only this.each()
    function getTotalCount() {
        let count = 0;
        self.each(()=>{
            count += 1;
        });
        return count;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function cleanWhenFull(superFn, minAge = (0, $gjqa4.FOUR_WEEKS)) {
        const currTime = Date.now();
        const numKeysBefore = self.getTotalCount();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self.each((_value, key)=>{
            // return correct value for current collection
            // and return null for timestamps collection
            const created = !self.hasNamespace((0, $gjqa4.NAMESPACE)) ? timestamps.get(key) : null;
            if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
        });
        const itemsRemovedCount = numKeysBefore - self.getTotalCount();
        if (!itemsRemovedCount && minAge - (0, $gjqa4.ONE_WEEK) >= (0, $gjqa4.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $gjqa4.ONE_WEEK));
        return itemsRemovedCount === 0;
    }
    return {
        set: set,
        remove: remove,
        cleanWhenFull: cleanWhenFull,
        getTotalCount: getTotalCount
    };
}
var $19af1635632d325b$export$2e2bcd8739ae039 = $19af1635632d325b$var$cleanUpPlugin;

});
parcelRegister("gjqa4", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE", () => $cf4854539b53d7dc$export$6aad947bda0f3f46);
$parcel$export(module.exports, "ONE_WEEK", () => $cf4854539b53d7dc$export$8187f416f1cc43d8);
$parcel$export(module.exports, "FOUR_WEEKS", () => $cf4854539b53d7dc$export$6e952fa7d47190cf);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", () => $cf4854539b53d7dc$export$da99ebca8f453abd);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", () => $cf4854539b53d7dc$export$ea28dfd9333cda2d);
const $cf4854539b53d7dc$export$6aad947bda0f3f46 = 'timestamps';
const $cf4854539b53d7dc$export$8187f416f1cc43d8 = 604800000;
const $cf4854539b53d7dc$export$6e952fa7d47190cf = 4 * $cf4854539b53d7dc$export$8187f416f1cc43d8;
const $cf4854539b53d7dc$export$da99ebca8f453abd = 22;
const $cf4854539b53d7dc$export$ea28dfd9333cda2d = 1014;

});



parcelRegister("kkXA4", function(module, exports) {

$parcel$export(module.exports, "makeLocalStore", () => $b4e518dc83f214e8$export$b2631085fe8db7af);
$parcel$export(module.exports, "makeLocalExpirableStore", () => $b4e518dc83f214e8$export$cf816b43e73de947);

var $2y3XF = parcelRequire("2y3XF");

var $gleLd = parcelRequire("gleLd");

var $ZGlKn = parcelRequire("ZGlKn");

var $5rWiD = parcelRequire("5rWiD");

var $gpWeB = parcelRequire("gpWeB");

var $avHyR = parcelRequire("avHyR");
const $b4e518dc83f214e8$export$b2631085fe8db7af = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($5rWiD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], (0, $avHyR.plugins));
const $b4e518dc83f214e8$export$cf816b43e73de947 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($5rWiD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gleLd)))
    ]);

});


parcelRegister("idwtd", function(module, exports) {

$parcel$export(module.exports, "DETAIL_VIEW_SIDEBAR", () => $9ab19831f05a709e$export$dfb67e34e4333816);
$parcel$export(module.exports, "DETAIL_VIEW_MODAL", () => $9ab19831f05a709e$export$1d6094128a3bfe4a);
$parcel$export(module.exports, "DETAIL_VIEW_DEFAULT", () => $9ab19831f05a709e$export$ad4637adae7d3e97);
$parcel$export(module.exports, "BOARD_DETAIL_VIEW_MODE", () => $9ab19831f05a709e$export$201bf1eb7c447afa);
$parcel$export(module.exports, "swimlaneModeToStrategies", () => $9ab19831f05a709e$export$6b0228c67b1e82cf);
const $9ab19831f05a709e$export$dfb67e34e4333816 = 'SIDEBAR';
const $9ab19831f05a709e$export$1d6094128a3bfe4a = 'MODAL';
const $9ab19831f05a709e$export$ad4637adae7d3e97 = 'DEFAULT';
const $9ab19831f05a709e$export$201bf1eb7c447afa = 'board-detail-view-mode';
const $9ab19831f05a709e$export$6b0228c67b1e82cf = {
    NO_SWIMLANE: 'none',
    SWIMLANE_BY_JQL: 'jql',
    SWIMLANE_BY_ASSIGNEE: 'assignee',
    SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST: 'assigneeunassignedfirst',
    SWIMLANE_BY_PARENT_ISSUE: 'issueparent',
    SWIMLANE_BY_SUBTASK: 'issuechildren',
    SWIMLANE_BY_PROJECT: 'project',
    SWIMLANE_BY_TEAM: 'team',
    SWIMLANE_BY_REQUEST_TYPE: 'requesttype'
};

});


parcelRegister("8d785", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0a3f8ba487c482e8$export$e324594224ef24da);

var $lDYuK = parcelRequire("lDYuK");

var $idwtd = parcelRequire("idwtd");

var $hHM8F = parcelRequire("hHM8F");
const $0a3f8ba487c482e8$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || getState().viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || getState().viewMode
        });
    };
const $0a3f8ba487c482e8$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $0a3f8ba487c482e8$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $hHM8F.getChildIssuesLimit)(getState());
const $0a3f8ba487c482e8$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $0a3f8ba487c482e8$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $0a3f8ba487c482e8$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $0a3f8ba487c482e8$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $0a3f8ba487c482e8$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $0a3f8ba487c482e8$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $0a3f8ba487c482e8$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $lDYuK.setBoardDetailViewMode)((0, $idwtd.DETAIL_VIEW_MODAL));
        setState({
            viewMode: (0, $idwtd.DETAIL_VIEW_MODAL)
        });
    };
const $0a3f8ba487c482e8$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $lDYuK.setBoardDetailViewMode)((0, $idwtd.DETAIL_VIEW_SIDEBAR));
        setState({
            viewMode: (0, $idwtd.DETAIL_VIEW_SIDEBAR)
        });
    };
const $0a3f8ba487c482e8$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $lDYuK.getBoardDetailViewMode)()
        });
    };
const $0a3f8ba487c482e8$export$e324594224ef24da = {
    setIssueContext: $0a3f8ba487c482e8$export$784a03c4b74da53e,
    mergeIssueContext: $0a3f8ba487c482e8$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $0a3f8ba487c482e8$export$89b6937a83edcaa6,
    getMaxTokenLength: $0a3f8ba487c482e8$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $0a3f8ba487c482e8$export$2fe981b90be13483,
    getBackButtonUrl: $0a3f8ba487c482e8$export$afce556782490aae,
    getIsSpaEnabled: $0a3f8ba487c482e8$export$711dfa096bf81f2d,
    getIssueKey: $0a3f8ba487c482e8$export$4a030f6192bebe03,
    getIsArchived: $0a3f8ba487c482e8$export$b41341ac6c74ca6,
    setDetailViewAsModal: $0a3f8ba487c482e8$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $0a3f8ba487c482e8$export$b303af51de56a0e,
    resetDetailView: $0a3f8ba487c482e8$export$75007d125f198b78
};

});
parcelRegister("hHM8F", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $a9a8c93b5bcca8ab$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $a9a8c93b5bcca8ab$export$8f43520910e8128c);

var $gUUjF = parcelRequire("gUUjF");

// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData(`${(0, $7643f341d271ccc9$export$25a759e49d5049db)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $a9a8c93b5bcca8ab$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $a9a8c93b5bcca8ab$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});
const $7643f341d271ccc9$export$25a759e49d5049db = 'issue.issue-context-service';





parcelRegister("fWeG1", function(module, exports) {

$parcel$export(module.exports, "useSummaryField", () => $6c5f7158a1132680$export$a01f0885983ceff0);

var $illlw = parcelRequire("illlw");

var $1ybV0 = parcelRequire("1ybV0");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $6c5f7158a1132680$export$a01f0885983ceff0 = ({ issueKey: issueKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, onSaveField: onSaveField })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, (0, $lO4Or.SUMMARY_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'schema.type', 'string');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $lO4Or.SUMMARY_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        // delete this condition and keep code inside when removing the isIncrementPlanningEnabled FF
        ...(0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1') && onSaveField && {
            saveField: onSaveField
        }
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("gGiWF", function(module, exports) {

$parcel$export(module.exports, "useEditField", () => $04407df9ae6d3d74$export$343e962d356c0af1);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5oStv = parcelRequire("5oStv");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");

var $7byHA = parcelRequire("7byHA");

var $hJ992 = parcelRequire("hJ992");

var $8wbQu = parcelRequire("8wbQu");

var $7eDnP = parcelRequire("7eDnP");

var $8p8vy = parcelRequire("8p8vy");

var $3koWU = parcelRequire("3koWU");

var $jMP2a = parcelRequire("jMP2a");

var $kmr29 = parcelRequire("kmr29");

var $fecbI = parcelRequire("fecbI");
/**
 * Some responses contain `fields` property without `fieldKey`.
 * We must avoid changing the state of this fields by checking `fieldKey` property in the `fields`.
 * @param response
 * @param fieldKey
 */ const $04407df9ae6d3d74$var$getFieldValue = (response, fieldKey)=>{
    if (!response) return null;
    if (response.fields) {
        if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
        return null;
    }
    return response;
};
const $04407df9ae6d3d74$var$shouldCallSetFieldValue = (response, fieldKey)=>{
    if (!response) return false;
    if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
    return true;
};
const $04407df9ae6d3d74$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
    // di-ignore - Please fix parent-switcher examples
    const baseUrl = '';
    const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $04407df9ae6d3d74$var$getFieldValue, saveField: saveField = (0, $fecbI.defaultSaveField), saveFieldById: saveFieldById = (0, $fecbI.defaultSaveFieldById), addValuesToField: addValuesToField = (0, $fecbI.defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, $fecbI.defaultRemoveValuesFromField), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) } = fieldOptions;
    // We need to track the mounted state as it is possible that a component
    // using this hook can be unmounted before the async edit operation is completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $3koWU.useIsMounted)();
    const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const resetError = (0, $eUqFw.useCallback)(()=>{
        if (isMounted.current) setError(null);
    }, [
        setError,
        isMounted
    ]);
    const editFieldValue = (0, $eUqFw.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
        isOptimistic: true
    })=>{
        let result;
        const analyticsData = {
            editOperationType: editOperationType,
            issueId: issueId,
            fieldKey: analyticsFieldKeyAlias ?? fieldKey,
            fieldType: analyticsFieldTypeAlias ?? fieldType
        };
        if (isMounted.current) {
            setLoading(true);
            setError(null);
        }
        try {
            onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
            if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
            result = await editOperation(issueKey, fieldKey, valuesForOperation, baseUrl, meta);
            const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
            $04407df9ae6d3d74$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
            onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent);
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            result = Promise.reject(ex);
            onFailure(ex, valuesForOperation);
            setFieldValue(issueKey, fieldKey, fieldValue);
            if (isMounted.current) setError(ex);
            const isValidationError = ex instanceof (0, $7byHA.ValidationError);
            if (!isValidationError) (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                fieldKey: fieldKey,
                fieldType: (0, $1ybV0.ff)('issue.detail.issue-view-story-point-field-type-analytics_n9ha6') ? analyticsFieldTypeAlias ?? fieldType : fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $JRB5w.isClientFetchError)(ex)
            });
        }
        if (isMounted.current) setLoading(false);
        return result;
    }, [
        issueId,
        analyticsFieldKeyAlias,
        fieldKey,
        analyticsFieldTypeAlias,
        fieldType,
        isMounted,
        onSubmit,
        fieldValue,
        setFieldValue,
        issueKey,
        onSuccess,
        onFailure,
        mapNonOptimisticResponse
    ]);
    const saveValue = (0, $eUqFw.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
        editFieldValue,
        saveField
    ]);
    const saveById = (0, $eUqFw.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
            isOptimistic: false
        }), [
        editFieldValue,
        saveFieldById
    ]);
    const addValues = (0, $eUqFw.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
        editFieldValue,
        addValuesToField
    ]);
    const removeValues = (0, $eUqFw.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
        editFieldValue,
        removeValuesFromField
    ]);
    return [
        {
            value: fieldValue,
            loading: loading,
            error: error
        },
        {
            saveById: saveById,
            saveValue: saveValue,
            addValues: addValues,
            removeValues: removeValues,
            resetError: resetError
        }
    ];
};
const $04407df9ae6d3d74$export$76d937477b5f784a = (issueKey)=>{
    const contextualIssueId = (0, $hJ992.useIssueId)();
    const contextualIssueKey = (0, $hJ992.useIssueKey)();
    return contextualIssueKey === issueKey ? contextualIssueId : null;
};
const $04407df9ae6d3d74$export$343e962d356c0af1 = (fieldOptions)=>{
    const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) } = fieldOptions;
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $8p8vy.useIssueViewFieldUpdateEvents)();
    const contextualIssueId = $04407df9ae6d3d74$export$76d937477b5f784a(issueKey);
    const issueId = issueIdFromFieldOptions ?? contextualIssueId;
    const isEditFromIssueView = (0, $8wbQu.useIsEditFromIssueView);
    const onSubmitFn = (0, $eUqFw.useCallback)((oldValue, newValue, meta, event)=>{
        onSubmit(oldValue, newValue, meta, event);
        issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
    }, [
        fieldChangeRequested,
        fieldKey,
        issueId,
        onSubmit
    ]);
    const onSuccessFn = (0, $eUqFw.useCallback)(async (fieldValue, event)=>{
        onSuccess(fieldValue);
        issueId && fieldChanged(issueId, fieldKey, fieldValue);
        if (!isEditFromIssueView(event)) try {
            const reason = (0, $7eDnP.Reason).SoftRefresh;
            // eslint-disable-next-line jira/wrm/no-load-bridge
            await (0, $5oStv.default).refreshIssuePageThrowable(issueKey, reason);
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
        }
    }, [
        fieldChanged,
        fieldKey,
        isEditFromIssueView,
        issueId,
        issueKey,
        onSuccess
    ]);
    const onFailureFn = (0, $eUqFw.useCallback)((error, failedValue)=>{
        onFailure(error, failedValue);
        issueId && fieldChangeFailed(issueId, fieldKey);
    }, [
        fieldChangeFailed,
        fieldKey,
        issueId,
        onFailure
    ]);
    return $04407df9ae6d3d74$export$3796d3fdbc2e6b54({
        ...fieldOptions,
        onSubmit: onSubmitFn,
        onSuccess: onSuccessFn,
        onFailure: onFailureFn
    });
};

});
parcelRegister("5oStv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdea36b35279d86d$export$2e2bcd8739ae039);

var $7eDnP = parcelRequire("7eDnP");
const $bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addEventListener = (event, callback)=>{
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeEventListener = (event, callback)=>{
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addRefreshIssueListener = (callback)=>$bdea36b35279d86d$var$addEventListener($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeRefreshIssueListener = (callback)=>$bdea36b35279d86d$var$removeEventListener($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addUpdateIssueGlanceListener = (callback)=>$bdea36b35279d86d$var$addEventListener($bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeUpdateIssueGlanceListener = (callback)=>$bdea36b35279d86d$var$removeEventListener($bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $bdea36b35279d86d$var$refreshIssuePageThrowable = (issueKey, reason = (0, $7eDnP.Reason).OnDemand)=>{
    try {
        document.dispatchEvent(new CustomEvent($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $bdea36b35279d86d$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $bdea36b35279d86d$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bdea36b35279d86d$export$2e2bcd8739ae039 = {
    addRefreshIssueListener: $bdea36b35279d86d$var$addRefreshIssueListener,
    removeRefreshIssueListener: $bdea36b35279d86d$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $bdea36b35279d86d$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $bdea36b35279d86d$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $bdea36b35279d86d$var$refreshIssuePageThrowable,
    refreshIssuePage: $bdea36b35279d86d$var$refreshIssuePage
};

});
parcelRegister("7eDnP", function(module, exports) {

$parcel$export(module.exports, "Reason", () => $501d104507444a18$export$fe867595c4640fb1);
const $501d104507444a18$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME'
};

});


parcelRegister("8wbQu", function(module, exports) {

$parcel$export(module.exports, "useIsEditFromIssueView", () => $e05e50438955dd5a$export$870b996a6c1c7896);

var $hRcYT = parcelRequire("hRcYT");

var $iKlrz = parcelRequire("iKlrz");
const $e05e50438955dd5a$export$870b996a6c1c7896 = (event)=>{
    const ISSUE_VIEW_SOURCES = [
        'fullIssueScreen',
        'boardIssueViewScreen',
        'backlogScreen',
        'agility-backlogScreen',
        'issueNavigatorEmbeddedIssueViewScreen',
        'globalIssueNavigatorIssueScreen',
        'mobileIssueScreen',
        'classicRoadmapScreen',
        'roadmapScreen',
        'versionDetailsIssueScreen',
        'bitbucketIssueScreen',
        'jsmQueueAgentViewSidebarScreen',
        'viewQueueIssueScreen',
        'jswModalIssueAppScreen',
        'jwmModalIssueAppScreen',
        'jswSidebarIssueAppScreen',
        'jwmSidebarIssueAppScreen'
    ];
    const { payload: { source: source } } = (0, $iKlrz.getEvent)(event);
    if (!source) return false;
    if (ISSUE_VIEW_SOURCES.includes(source)) // event originated from issue view location
    return true;
    if (source.startsWith((0, $hRcYT.PACKAGE_NAME_GASV3))) // event originated from forge app, which can only be mounted in issue view for field editing
    return true;
    return false;
};

});
parcelRegister("hRcYT", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME_GASV3", () => $7ddaf55383536638$export$f892f621fb508154);
$parcel$export(module.exports, "MODULE_TYPE_TRIGGER", () => $7ddaf55383536638$export$ed63b053e04e26df);
$parcel$export(module.exports, "MODULE_TYPE_EXTENSION", () => $7ddaf55383536638$export$725bacc669333eef);
$parcel$export(module.exports, "FORGE_SAMPLING_RATE", () => $7ddaf55383536638$export$d920cee73ec094d0);
$parcel$export(module.exports, "PERFORMANCE_KEYS", () => $7ddaf55383536638$export$f048d91ccaf92408);
$parcel$export(module.exports, "UI_ACTIONS", () => $7ddaf55383536638$export$2b7367f125154866);
$parcel$export(module.exports, "OPERATIONAL_ACTIONS", () => $7ddaf55383536638$export$42bcca5cae2ce90b);
$parcel$export(module.exports, "TRACK_ACTIONS", () => $7ddaf55383536638$export$2af0438304d7c4b2);
// TODO ARKEN-359: uniformise GASv3/BM3 keys to use kebab lowercase
const $7ddaf55383536638$export$f892f621fb508154 = 'jiraForgeUi';
const $7ddaf55383536638$export$273f5980517336e2 = 'jiraforgeui';
const $7ddaf55383536638$export$ed63b053e04e26df = 'trigger';
const $7ddaf55383536638$export$725bacc669333eef = 'extension';
const $7ddaf55383536638$export$d920cee73ec094d0 = 10;
const $7ddaf55383536638$export$f048d91ccaf92408 = {
    FORGE_MODULES: {
        FETCH_TIME: `${$7ddaf55383536638$export$273f5980517336e2}.forge-modules.fetch-time`,
        LOAD_TIME: `${$7ddaf55383536638$export$273f5980517336e2}.forge-modules.load-time`
    },
    REAL_TIME_ISSUE_EVENTS: {
        INVOKE_TIME: `${$7ddaf55383536638$export$273f5980517336e2}.real-time-issue-events.invoke-time`
    },
    MARKS: {
        TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
        TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
    }
};
const $7ddaf55383536638$export$2b7367f125154866 = {
    CLICKED: 'clicked',
    SELECTED: 'selected',
    CANCELED: 'canceled',
    ACTION_CLICKED: 'action clicked',
    COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
    REMOVE_CLICKED: 'remove clicked'
};
const $7ddaf55383536638$export$42bcca5cae2ce90b = {
    FAILED: 'failed',
    INITIALIZED: 'initialized',
    EDIT_FAILED: 'edit failed',
    ACTION_FAILED: 'action failed',
    SAVE_FAILED: 'save failed',
    REMOVE_FAILED: 'remove failed',
    UPDATE_FAILED: 'update failed'
};
const $7ddaf55383536638$export$2af0438304d7c4b2 = {
    EDITED: 'edited',
    SAVED: 'saved',
    REMOVED: 'removed',
    ACTION_SUCCEED: 'action succeed',
    UPDATE_SUCCEED: 'update succeed'
};

});


parcelRegister("8p8vy", function(module, exports) {

$parcel$export(module.exports, "useIssueViewFieldUpdateEvents", () => $0829b81e40dd527a$export$444af741f6d8f512);
$parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", () => $0829b81e40dd527a$export$f9eb49cc2f0e28ce);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $k3tie = parcelRequire("k3tie");
const $0829b81e40dd527a$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
        if (typeof eventHandler !== 'function') // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const { eventHandlers: eventHandlers } = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
        const typeEventHandlers = eventHandlers[type];
        setState({
            eventHandlers: {
                ...eventHandlers,
                [type]: typeEventHandlers.concat([
                    eventHandler
                ])
            }
        });
        return ()=>{
            const { eventHandlers: eventHandlersForUnregister } = getState();
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
            const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
            const newTypeEventHandlers = typeEventHandlersForUnregister.filter(// @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
            (handler)=>handler !== eventHandler);
            setState({
                eventHandlers: {
                    ...eventHandlersForUnregister,
                    [type]: newTypeEventHandlers
                }
            });
        };
    };
const $0829b81e40dd527a$var$fieldChanged = (issueId, fieldId, fieldValue)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                fieldId: // field id is required to be compatible with v1 onChange API
                fieldId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: fieldValue
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGED
            });
        });
    };
const $0829b81e40dd527a$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_FAILED
            });
        });
    };
const $0829b81e40dd527a$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: fieldValue,
                    additionalProperties: additionalProperties
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_REQUESTED
            });
        });
    };
const $0829b81e40dd527a$var$actions = {
    fieldChanged: $0829b81e40dd527a$var$fieldChanged,
    fieldChangeFailed: $0829b81e40dd527a$var$fieldChangeFailed,
    fieldChangeRequested: $0829b81e40dd527a$var$fieldChangeRequested,
    registerEventHandler: $0829b81e40dd527a$var$registerEventHandler
};
// this is a global state
const $0829b81e40dd527a$var$store = (0, $a61MH.createStore)({
    name: 'issue-view-field-update-events',
    initialState: {
        eventHandlers: {
            onChange: []
        }
    },
    actions: $0829b81e40dd527a$var$actions
});
const $0829b81e40dd527a$export$444af741f6d8f512 = (0, $ggKAj.createHook)($0829b81e40dd527a$var$store, {
    selector: null
});
const $0829b81e40dd527a$export$f9eb49cc2f0e28ce = (0, $heB5U.createContainer)($0829b81e40dd527a$var$store);

});
parcelRegister("k3tie", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $8f27d9da737621d3$export$8db21fc94823e1cc);
// Copied over from `src/packages/issue/issue-view/src/model/change-type.js`
const $8f27d9da737621d3$export$8b9b8ed7fbac313c = 'FIELD_CHANGE_REQUESTED';
const $8f27d9da737621d3$export$f567ac9d3526e5ce = 'FIELD_CHANGED';
const $8f27d9da737621d3$export$7c15aaba9a26f469 = 'FIELD_CHANGE_FAILED';
const $8f27d9da737621d3$export$8db21fc94823e1cc = {
    [$8f27d9da737621d3$export$8b9b8ed7fbac313c]: $8f27d9da737621d3$export$8b9b8ed7fbac313c,
    [$8f27d9da737621d3$export$7c15aaba9a26f469]: $8f27d9da737621d3$export$7c15aaba9a26f469,
    [$8f27d9da737621d3$export$f567ac9d3526e5ce]: $8f27d9da737621d3$export$f567ac9d3526e5ce
};

});


parcelRegister("3koWU", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c314bd343c8e5174$export$80c2a3957bcb42ea);

var $eUqFw = parcelRequire("eUqFw");
const $c314bd343c8e5174$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});

parcelRegister("kmr29", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $da19d1ee706d4a81$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $da19d1ee706d4a81$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useFieldValuesForIssues", () => $da19d1ee706d4a81$export$ac289b84121829df);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $da19d1ee706d4a81$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $da19d1ee706d4a81$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $da19d1ee706d4a81$export$612d9bcb0c9d8976);

var $eUqFw = parcelRequire("eUqFw");

var $2vzCR = parcelRequire("2vzCR");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
const $da19d1ee706d4a81$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $da19d1ee706d4a81$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $da19d1ee706d4a81$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $da19d1ee706d4a81$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $da19d1ee706d4a81$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState()[issueKey], fields)
        });
    };
const $da19d1ee706d4a81$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState(), newIssues));
    };
const $da19d1ee706d4a81$var$actions = {
    setFieldValue: $da19d1ee706d4a81$var$setFieldValue,
    getFieldValue: $da19d1ee706d4a81$var$getFieldValue,
    setIssue: $da19d1ee706d4a81$var$setIssue,
    mergeIssue: $da19d1ee706d4a81$var$mergeIssue,
    setIssues: $da19d1ee706d4a81$var$setIssues,
    mergeIssues: $da19d1ee706d4a81$export$11aa02e14fdf7753
};
// this is a global store
const $da19d1ee706d4a81$var$store = (0, $a61MH.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $da19d1ee706d4a81$var$actions
});
const $da19d1ee706d4a81$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$da19d1ee706d4a81$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $da19d1ee706d4a81$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $da19d1ee706d4a81$var$getAllFields = (state, issueKey)=>state[issueKey];
const $da19d1ee706d4a81$export$b79fae7fbe3ac392 = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$export$25b73e671fe7a8fa = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getAllFields
});
const $da19d1ee706d4a81$export$ac289b84121829df = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$915cdeec521b54f7 = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$4e5f1f4ed08d155e = (0, $dYfll.createSubscriber)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$var$useFieldValueStoreActions = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: null
});
const $da19d1ee706d4a81$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $da19d1ee706d4a81$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $eUqFw.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("fecbI", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $4eca3d717c3df3ee$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $4eca3d717c3df3ee$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $4eca3d717c3df3ee$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $4eca3d717c3df3ee$export$33b78476f5d734b3);

var $lRmyA = parcelRequire("lRmyA");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4eca3d717c3df3ee$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $4eca3d717c3df3ee$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $4eca3d717c3df3ee$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});


parcelRegister("8411R", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $7e02dfdf3441382d$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $7e02dfdf3441382d$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $7e02dfdf3441382d$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $7e02dfdf3441382d$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $7e02dfdf3441382d$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $7e02dfdf3441382d$export$28a22fd0dedf31b7);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $lRmyA = parcelRequire("lRmyA");

var $3koWU = parcelRequire("3koWU");

var $6rkLV = parcelRequire("6rkLV");
const $7e02dfdf3441382d$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $7e02dfdf3441382d$var$fetchData = async (issueKey)=>{
    const response = await (0, $lRmyA.performPostRequest)('/rest/graphql/1/', {
        body: JSON.stringify({
            query: $7e02dfdf3441382d$export$9715ac6597e498fd(),
            variables: {
                issueKey: issueKey
            }
        })
    });
    if (response && response.data && response.data.issue && response.data.issue.fields) return response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
    (result, field)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [field.key]: {
                autoCompleteUrl: field.autoCompleteUrl,
                allowedValues: field.allowedValues,
                isEditable: field.editable,
                isRequired: field.required,
                schema: field.schema,
                title: field.title,
                ...field.description ? {
                    description: field.description
                } : {}
            }
        }), {});
    return null;
};
const $7e02dfdf3441382d$var$requestSet = new Set();
const $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $7e02dfdf3441382d$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $3koWU.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $6rkLV.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $eUqFw.useState)(()=>!skipRefresh && value === undefined && !$7e02dfdf3441382d$var$requestSet.has(issueKey));
    const getData = (0, $eUqFw.useCallback)(async ()=>{
        setLoading(true);
        $7e02dfdf3441382d$var$requestSet.add(issueKey);
        const result = await $7e02dfdf3441382d$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $7e02dfdf3441382d$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const shouldGetData = !skipRefresh && !$7e02dfdf3441382d$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return [
        {
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $6rkLV.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $6rkLV.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $eUqFw.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $6rkLV.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $6rkLV.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $7e02dfdf3441382d$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return [
        {
            value: value
        }
    ];
};
const $7e02dfdf3441382d$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $6rkLV.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return [
        {
            value: value
        }
    ];
};
const $7e02dfdf3441382d$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $6rkLV.useFieldConfigStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("6rkLV", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $2581b610ec8db8fc$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $2581b610ec8db8fc$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $2581b610ec8db8fc$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $2581b610ec8db8fc$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $2581b610ec8db8fc$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $2581b610ec8db8fc$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $2581b610ec8db8fc$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $2581b610ec8db8fc$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $2581b610ec8db8fc$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $df4Sl = parcelRequire("df4Sl");

var $2vzCR = parcelRequire("2vzCR");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $2581b610ec8db8fc$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $2581b610ec8db8fc$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $2581b610ec8db8fc$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $2581b610ec8db8fc$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState(), newIssues));
    };
const $2581b610ec8db8fc$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $2581b610ec8db8fc$var$actions = {
    setIssueConfig: $2581b610ec8db8fc$var$setIssueConfig,
    setIssuesConfig: $2581b610ec8db8fc$var$setIssuesConfig,
    mergeIssueConfig: $2581b610ec8db8fc$var$mergeIssueConfig,
    mergeIssuesConfig: $2581b610ec8db8fc$var$mergeIssuesConfig,
    setFieldConfigValue: $2581b610ec8db8fc$var$setFieldConfigValue
};
// this is a global state
const $2581b610ec8db8fc$var$store = (0, $a61MH.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $2581b610ec8db8fc$var$actions
});
const $2581b610ec8db8fc$var$getIssueFieldConfig = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $2581b610ec8db8fc$export$52f51db4e2b3da57 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$store, {
    selector: $2581b610ec8db8fc$var$getIssueFieldConfig
});
const $2581b610ec8db8fc$var$getFieldConfig = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $2581b610ec8db8fc$var$getFieldConfigWithLabel = (0, $df4Sl.createSelector)($2581b610ec8db8fc$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $2581b610ec8db8fc$var$getFieldOptionsOverrides = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $2581b610ec8db8fc$export$f9beb98c7488fd61 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$store, {
    selector: $2581b610ec8db8fc$var$getFieldConfig
});
const $2581b610ec8db8fc$export$314199caf05d245 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$store, {
    selector: null
});
const $2581b610ec8db8fc$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $2581b610ec8db8fc$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $2581b610ec8db8fc$var$overridesActions = {
    setFieldConfigOverridesValue: $2581b610ec8db8fc$var$setOverrides,
    resetOverridesStore: $2581b610ec8db8fc$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $2581b610ec8db8fc$var$overridesStore = (0, $a61MH.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $2581b610ec8db8fc$var$overridesActions
});
const $2581b610ec8db8fc$export$ff357cf5a96ec0c6 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getIssueFieldConfig
});
const $2581b610ec8db8fc$export$6e41e9c34587d557 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldConfig
});
const $2581b610ec8db8fc$export$e704d739927bd1d6 = (0, $ggKAj.createStateHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldConfigWithLabel
});
const $2581b610ec8db8fc$export$d94ae842140da412 = (0, $ggKAj.createActionsHook)($2581b610ec8db8fc$var$overridesStore);
const $2581b610ec8db8fc$export$bfea9bb9bad7bc8f = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldOptionsOverrides
});
const $2581b610ec8db8fc$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $2581b610ec8db8fc$export$982ff1008c2e2780 = (0, $ggKAj.createStateHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getIsFieldBusySelector
});

});




parcelRegister("cGfT1", function(module, exports) {

$parcel$export(module.exports, "ErrorPage", () => $103ce4cfd94db8d4$export$c120a0e80fd44ca6);

var $eUqFw = parcelRequire("eUqFw");

var $iJjlA = parcelRequire("iJjlA");

var $ildWd = parcelRequire("ildWd");
const $103ce4cfd94db8d4$export$c120a0e80fd44ca6 = ({ onClose: onClose, renderFeedback: renderFeedback, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJjlA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ildWd.ErrorHeader), {
        onClose: onClose,
        renderFeedback: renderFeedback
    }), children);

});
parcelRegister("iJjlA", function(module, exports) {

$parcel$export(module.exports, "issuePageGridColumns", () => $3b85c9c10172f521$export$332bef93ac29ef76);
$parcel$export(module.exports, "default", () => $3b85c9c10172f521$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* TODO(@compiled/react codemod): "ThemeProvider" is not exported from "@compiled/react" at the moment. Please find an alternative for it. */ // This component exists as a layer between @atlaskit/modal-dialog and @atlaskit/page/grid
// There is collisions between who owns the padding between these 2 components, so
// we can isolate any necessary overrides within this file until the responsibilities
// are resolved

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $j7bQJ = parcelRequire("j7bQJ");

var $6i6yG = parcelRequire("6i6yG");
const $3b85c9c10172f521$export$332bef93ac29ef76 = 10;
const $3b85c9c10172f521$var$theme = {
    columns: $3b85c9c10172f521$export$332bef93ac29ef76
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3b85c9c10172f521$export$2e2bcd8739ae039 = ({ children: children, isCompact: isCompact = false, hasMultipleScrollingColumns: hasMultipleScrollingColumns })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwce8.ThemeProvider), {
        theme: $3b85c9c10172f521$var$theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3b85c9c10172f521$var$GridPaddingOverride, {
        isCompact: isCompact,
        hasMultipleScrollingColumns: hasMultipleScrollingColumns,
        "data-component-selector": (0, $6i6yG.gridPaddingOverrideSelectorName)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7bQJ.default), {
        spacing: "comfortable",
        layout: "fluid"
    }, children)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b85c9c10172f521$var$GridPaddingOverride = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasMultipleScrollingColumns: hasMultipleScrollingColumns, isCompact: isCompact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1st4zhr": (0, $9t7rW.default)(__cmplp.isCompact ? 0 : "var(--ds-space-050, 4px)")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogwtidpf _6tinidpf _1cezidpf _m3zkidpf _7yjtidpf _ldgnidpf _un3pidpf _29hzidpf",
            __cmplp.hasMultipleScrollingColumns ? "_4t3i1osq _1e0c1txw _2lx21bp4 _15y61q9c _k8em1osq _dzc24jg8" : "_19bv1doe _10a1idpf _1c9eidpf _wfyiidpf _mxn3idpf _1q0p1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j7bQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cf405c5617943d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");

var $gw8fk = parcelRequire("gw8fk");

var $6tahE = parcelRequire("6tahE");

var $02LzD = parcelRequire("02LzD");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $21cf405c5617943d$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const { medium: medium } = (0, $eUqFw.useContext)((0, $6tahE.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $cuCEk.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $cuCEk.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02LzD.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gw8fk.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $21cf405c5617943d$export$2e2bcd8739ae039 = $21cf405c5617943d$var$GridWrapper;

});
parcelRegister("cuCEk", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $63536614c324c20f$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $63536614c324c20f$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $63536614c324c20f$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $63536614c324c20f$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $63536614c324c20f$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $63536614c324c20f$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $63536614c324c20f$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $63536614c324c20f$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $63536614c324c20f$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $63536614c324c20f$export$936829b4511db3e4);
const $63536614c324c20f$export$3aaf3a78c909ea56 = 8;
const $63536614c324c20f$export$74797698e12f8baa = 12;
const $63536614c324c20f$export$b8241a1616ab1b96 = $63536614c324c20f$export$3aaf3a78c909ea56 * 10;
const $63536614c324c20f$export$2a89a65a43bab52d = {
    comfortable: $63536614c324c20f$export$3aaf3a78c909ea56 * 5,
    cosy: $63536614c324c20f$export$3aaf3a78c909ea56 * 2,
    compact: $63536614c324c20f$export$3aaf3a78c909ea56 * 0.5
};
const $63536614c324c20f$export$8ec7372efd74b753 = 'cosy';
const $63536614c324c20f$export$d77f83c3d17a7b8a = 52;
const $63536614c324c20f$export$f8725d21f81f3e01 = 0;
const $63536614c324c20f$export$2303d2bd9eeff99a = 'fixed';
const $63536614c324c20f$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $63536614c324c20f$export$8b7e31f391e6e681 = '--ds-column-span';
const $63536614c324c20f$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("gw8fk", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $7946ba115b4da3a8$export$ef2184bd89960b14);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
function $7946ba115b4da3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7946ba115b4da3a8$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $7946ba115b4da3a8$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $cuCEk.varColumnsNum)}) * ${(0, $cuCEk.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $7946ba115b4da3a8$var$nestedGridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $cuCEk.varGridSpacing)}))`
});
const $7946ba115b4da3a8$export$ef2184bd89960b14 = ({ layout: layout = (0, $cuCEk.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7946ba115b4da3a8$var$gridStyles,
            $7946ba115b4da3a8$var$gridLayoutStyles[layout],
            isNested && $7946ba115b4da3a8$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varGridSpacing)]: `${(0, $cuCEk.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("02LzD", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $abe6d6b3e91c4986$export$11cae3e04ab99fae);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");
const $abe6d6b3e91c4986$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $cuCEk.defaultSpacing),
    columns: (0, $cuCEk.defaultGridColumns)
});

});


parcelRegister("6tahE", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $384e4fce86f51330$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $384e4fce86f51330$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
var $384e4fce86f51330$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($384e4fce86f51330$var$ColumnVariant || ($384e4fce86f51330$var$ColumnVariant = {}));
const $384e4fce86f51330$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $cuCEk.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $384e4fce86f51330$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $384e4fce86f51330$var$singleColumnWidth = `(${$384e4fce86f51330$var$availableWidth} / var(${(0, $cuCEk.varColumnsNum)}))`;
const $384e4fce86f51330$var$gridColumnStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} - var(${(0, $cuCEk.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $384e4fce86f51330$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} *  var(${(0, $cuCEk.varColumnSpan)}) - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $384e4fce86f51330$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    medium: (0, $cuCEk.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $384e4fce86f51330$var$GridColumn = ({ medium: medium = (0, $cuCEk.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $384e4fce86f51330$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)($384e4fce86f51330$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $384e4fce86f51330$var$gridColumnStyles,
            $384e4fce86f51330$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $384e4fce86f51330$export$2e2bcd8739ae039 = $384e4fce86f51330$var$GridColumn;

});


parcelRegister("6i6yG", function(module, exports) {

$parcel$export(module.exports, "issueViewBottomPadding", () => $b67ea92080df9175$export$eef7f451cbef64c8);
$parcel$export(module.exports, "fullPageIssueWrapperMarginTop", () => $b67ea92080df9175$export$fdb4c0fadd606c3b);
$parcel$export(module.exports, "gridPaddingOverrideSelectorName", () => $b67ea92080df9175$export$af24d4a8aa45d895);

var $c9TLT = parcelRequire("c9TLT");
const $b67ea92080df9175$export$eef7f451cbef64c8 = 4 * (0, $c9TLT.gridSize);
const $b67ea92080df9175$export$fdb4c0fadd606c3b = (0, $c9TLT.gridSize) * 3;
const $b67ea92080df9175$export$af24d4a8aa45d895 = 'jira-issue-view-issue-page-grid-padding-override';
const $b67ea92080df9175$export$b341291ebfdfd154 = `[data-component-selector="${$b67ea92080df9175$export$af24d4a8aa45d895}"]`;

});


parcelRegister("ildWd", function(module, exports) {

$parcel$export(module.exports, "ErrorHeader", () => $a163932e05bf1305$export$412fa15b195faa12);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8sN8t = parcelRequire("8sN8t");

var $h97Af = parcelRequire("h97Af");

var $eMxRI = parcelRequire("eMxRI");

var $3i5oM = parcelRequire("3i5oM");

const $a163932e05bf1305$export$412fa15b195faa12 = ({ onClose: onClose, renderFeedback: renderFeedback })=>{
    let renderFeedbackWithWrapper;
    if (renderFeedback) {
        const feedback = renderFeedback();
        renderFeedbackWithWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
            name: (0, $eMxRI.GIVE_FEEDBACK)
        }, feedback);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $362c02c5f509c4a8$export$815d1bc13ccc1639)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a163932e05bf1305$var$HeaderButtonsContainer, null, renderFeedbackWithWrapper, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3i5oM.default), {
        onClose: onClose
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $362c02c5f509c4a8$export$1fbdc9738484a32b)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a163932e05bf1305$var$HeaderButtonsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3 _1bsb1osq _zulpu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eMxRI", function(module, exports) {

$parcel$export(module.exports, "BOARD_SIDEBAR", () => $5a120aeb28a0304e$export$d84e7970e2d564af);
$parcel$export(module.exports, "EDIT_FIELD", () => $5a120aeb28a0304e$export$256eddbefbf4b2ce);
$parcel$export(module.exports, "GIVE_FEEDBACK", () => $5a120aeb28a0304e$export$3c1bb52064935485);
$parcel$export(module.exports, "STATUS_AND_APPROVAL_SPOTLIGHT", () => $5a120aeb28a0304e$export$988f0f6f6457039a);
$parcel$export(module.exports, "STATUS_SPOTLIGHT", () => $5a120aeb28a0304e$export$b11eec52127ca1f1);
$parcel$export(module.exports, "ISSUE_FIELD_SPOTLIGHT_PREFIX", () => $5a120aeb28a0304e$export$2028cf1423b28cf8);
const $5a120aeb28a0304e$export$d84e7970e2d564af = 'BOARD_SIDEBAR';
const $5a120aeb28a0304e$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $5a120aeb28a0304e$export$3c1bb52064935485 = 'GIVE_FEEDBACK';
const $5a120aeb28a0304e$export$95f98990d7202b31 = 'SHOW_MORE';
const $5a120aeb28a0304e$export$988f0f6f6457039a = 'status-and-approval-spotlight';
const $5a120aeb28a0304e$export$b11eec52127ca1f1 = 'status-spotlight';
const $5a120aeb28a0304e$export$e5820f3349d3bcf0 = 'reporter-spotlight';
const $5a120aeb28a0304e$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $5a120aeb28a0304e$export$43c3daf5ccfeb2da = {
    ASSIGNEE: {
        TIME_TO_RENDER_INITIAL_SUGGESTIONS: 'jira.fe.issue.fields.assignee.time-to.render-initial-suggestions',
        TIME_TO_REFLECT_INPUT_RESULT: 'jira.fe.issue.fields.assignee.time-to.reflect-input-results',
        TIME_TO_REFLECT_SELECTED: 'jira.fe.issue.fields.assignee.time-to.reflect-selected',
        TIME_TO_ASSIGN_TO_ME_VIA_SHORTCUT: 'jira.fe.issue.fields.assignee.time-to.assign-to-me-via-shortcut'
    },
    SUMMARY: {
        TIME_TO_RENDER_EDIT_VIEW: 'jira.fe.issue.field.summary.time-to.render-edit-view',
        TIME_TO_RENDER_READ_VIEW_ON_CONFIRM: 'jira.fe.issue.field.summary.time-to.render-read-view-on-confirm',
        TIME_TO_RENDER_READ_VIEW_ON_CANCEL: 'jira.fe.issue.field.summary.time-to.render-read-view-on-cancel'
    },
    LABELS: {
        TIME_TO_RENDER_INITIAL_SUGGESTIONS: 'jira.fe.issue.fields.labels.time-to.render-initial-suggestions',
        TIME_TO_REFLECT_INPUT_RESULT: 'jira.fe.issue.fields.labels.time-to.reflect-input-results',
        TIME_TO_RENDER_READ_VIEW_ON_CONFIRM: 'jira.fe.issue.field.labels.time-to.render-read-view-on-confirm',
        TIME_TO_RENDER_READ_VIEW_ON_CANCEL: 'jira.fe.issue.field.labels.time-to.render-read-view-on-cancel',
        TIME_TO_REFLECT_SELECTED_EXISTING: 'jira.fe.issue.fields.labels.time-to.reflect-selected-existing',
        TIME_TO_REFLECT_SELECTED_NEW: 'jira.fe.issue.fields.labels.time-to.reflect-selected-new',
        TIME_TO_REFLECT_REMOVED_EXISTING: 'jira.fe.issue.fields.labels.time-to.reflect-removed-existing'
    },
    STORY_POINTS: {
        TIME_TO_RENDER_EDIT_VIEW: 'jira.fe.issue.field.story-points.time-to.render-edit-view',
        TIME_TO_RENDER_READ_VIEW_ON_CONFIRM: 'jira.fe.issue.field.story-points.time-to.render-read-view-on-confirm',
        TIME_TO_RENDER_READ_VIEW_ON_CANCEL: 'jira.fe.issue.field.story-points.time-to.render-read-view-on-cancel'
    },
    ISSUE_LINKS: {
        TIME_TO_REFLECT_SELECTED_ISSUE: 'jira.fe.issue.fields.issue-links.time-to.reflect-selected-issue',
        TIME_TO_REFLECT_REMOVED_ISSUE: 'jira.fe.issue.fields.issue-links.time-to.reflect-removed-issue',
        TIME_TO_REFLECT_INPUT_RESULT: 'jira.fe.issue.fields.issue-links.time-to.reflect-input-results',
        TIME_TO_RENDER_LINKED_ISSUE: 'jira.fe.issue.fields.issue-links.time-to.render-linked-issue',
        TIME_TO_RENDER_NEW_LINKED_ISSUE_INPUT: 'jira.fe.issue.fields.issue-links.time-to.render-new-linked-issue-input'
    },
    SPRINT: {
        TIME_TO_REFLECT_SELECTED_SPRINT: 'jira.fe.issue.fields.sprint.time-to.reflect-selected-sprint',
        TIME_TO_REFLECT_REMOVED_SPRINT: 'jira.fe.issue.fields.sprint.time-to.reflect-removed-sprint',
        TIME_TO_REFLECT_INPUT_RESULT: 'jira.fe.issue.fields.sprint.time-to.reflect-input-results',
        TIME_TO_RENDER_READ_VIEW: 'jira.fe.issue.fields.sprint.time-to.render-read-view',
        TIME_TO_RENDER_INITIAL_SUGGESTIONS: 'jira.fe.issue.fields.sprint.time-to.render-initial-suggestions'
    },
    PRIORITY: {
        TIME_TO_RENDER_READ_VIEW: 'jira.fe.issue.fields.priority.time-to.render-read-view',
        TIME_TO_RENDER_SUGGESTIONS: 'jira.fe.issue.fields.priority.time-to.render-suggestions',
        TIME_TO_REFLECT_PRIORITY_UPDATE: 'jira.fe.issue.fields.priority.time-to.reflect-priority-update'
    },
    COMMENTS: {
        TIME_TO_RENDER_NEW_COMMENT_EDITOR: 'jira.fe.issue.fields.comments.time-to.render-new-comment-editor',
        TIME_TO_RENDER_SAVED_COMMENT: 'jira.fe.issue.fields.comments.time-to.render-saved-comment'
    },
    DESCRIPTION: {
        TIME_TO_RENDER_EDIT_VIEW: 'jira.fe.issue.field.description.time-to.render-edit-view',
        TIME_TO_SAVE_UPDATED_DESCRIPTION: 'jira.fe.issue.field.description.time-to.save-updated-description',
        TIME_TO_SAVE_UNCHANGED_DESCRIPTION: 'jira.fe.issue.field.description.time-to.save-unchanged-description'
    },
    EPIC_LINKS: {
        TIME_TO_FETCH_INPUT_RESULTS_EPIC_PICKER_ENABLED: 'jira.fe.issue.fields.epic-link.time-to.fetch-input-results.epic-picker-enabled',
        TIME_TO_FETCH_INPUT_RESULTS_EPIC_PICKER_DISABLED: 'jira.fe.issue.fields.epic-link.time-to.fetch-input-results.epic-picker-disabled'
    }
};

});

parcelRegister("3i5oM", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaa0b49a110cef1f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $8cU5f = parcelRequire("8cU5f");

var $90IgZ = parcelRequire("90IgZ");
var $4ksts = parcelRequire("4ksts");
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ const $eaa0b49a110cef1f$var$messages = (0, $90IgZ.defineMessages)({
    label: {
        "id": "issue.label-for-modal-close-button",
        "defaultMessage": "Close"
    }
});
const $eaa0b49a110cef1f$export$ea8f8606c95eab82 = ({ onClose: onClose })=>{
    const intlCloseText = (0, $4ksts.useIntlV2)().formatMessage($eaa0b49a110cef1f$var$messages.label);
    const closeIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
        label: "",
        size: "medium"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: intlCloseText,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": intlCloseText,
        appearance: "subtle",
        spacing: "default",
        iconBefore: closeIcon,
        onClick: onClose,
        interactionName: "auto-generated.jira-issue-view-foundation.button"
    })));
};
var $eaa0b49a110cef1f$export$2e2bcd8739ae039 = $eaa0b49a110cef1f$export$ea8f8606c95eab82;

});
parcelRegister("4ksts", function(module, exports) {

$parcel$export(module.exports, "useIntlV2", () => $32efc9cfc8f5c011$export$d82607073b68786);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1IqwQ = parcelRequire("1IqwQ");
const $32efc9cfc8f5c011$export$d82607073b68786 = ()=>{
    const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatRelativeTime: formatRelativeTime, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, $5JgJ2.default)();
    // Only recreate intl object if reference to originral intl changes.
    const memoisedIntl = (0, $eUqFw.useMemo)(()=>{
        const modifiedIntl = {
            // Now is deprecated since version 2: https://github.com/formatjs/formatjs/issues/1409
            now: ()=>Date.now(),
            messages: // @ts-expect-error - TS2322 - Type 'Record<string, string> | Record<string, MessageFormatElement[]>' is not assignable to type '{ [id: string]: string; }'.
            messages,
            locale: locale,
            formats: formats,
            formatDate: formatDate,
            formatMessage: formatMessage,
            formatHTMLMessage: (descriptor, values)=>formatMessage(descriptor, values, {
                    ignoreTag: true
                }),
            formatNumber: formatNumber,
            formatRelative: (date, opts)=>{
                const { time: time, unit: unit } = (0, $1IqwQ.getRelativeTimeAndUnit)(date);
                return formatRelativeTime(time, unit, opts);
            },
            formatPlural: formatPlural,
            formatTime: formatTime
        };
        return modifiedIntl;
    }, [
        formatDate,
        formatMessage,
        formatPlural,
        formatRelativeTime,
        formatTime,
        formatNumber,
        formats,
        locale,
        messages
    ]);
    return memoisedIntl;
};

});
parcelRegister("1IqwQ", function(module, exports) {

$parcel$export(module.exports, "getRelativeTimeAndUnit", () => $6a7dda3450af4d49$export$307c4b8ee56b97bb);
$parcel$export(module.exports, "FormattedRelativeV2", () => $6a7dda3450af4d49$export$7317ee2f88fd1276);

var $eUqFw = parcelRequire("eUqFw");

var $9KU0P = parcelRequire("9KU0P");

var $8M1qS = parcelRequire("8M1qS");
const $6a7dda3450af4d49$var$getTimeInUnits = (unitValue)=>{
    const seconds = unitValue / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    const weeks = days / 7;
    const months = weeks / 4;
    const years = months / 12;
    return {
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: days,
        weeks: weeks,
        months: months,
        years: years
    };
};
const $6a7dda3450af4d49$export$307c4b8ee56b97bb = (value, units)=>{
    const timeInMilliseconds = new Date(value);
    // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    const delta = timeInMilliseconds - Date.now();
    let valueInUnit;
    if (!units) {
        const { value: time, unit: unit } = (0, $9KU0P.selectUnit)(timeInMilliseconds, new Date());
        return {
            time: time,
            unit: unit
        };
    }
    const { seconds: seconds, minutes: minutes, hours: hours, days: days, weeks: weeks, months: months, years: years } = $6a7dda3450af4d49$var$getTimeInUnits(delta);
    switch(units){
        case 'second':
            valueInUnit = seconds;
            break;
        case 'minute':
            valueInUnit = minutes;
            break;
        case 'hour':
            valueInUnit = hours;
            break;
        case 'day':
            valueInUnit = days;
            break;
        case 'week':
            valueInUnit = weeks;
            break;
        case 'month':
            valueInUnit = months;
            break;
        case 'year':
            valueInUnit = years;
            break;
        default:
            valueInUnit = 0;
            break;
    }
    return {
        time: Math.ceil(valueInUnit),
        unit: units
    };
};
const $6a7dda3450af4d49$export$7317ee2f88fd1276 = ({ value: value, units: units, children: children, style: style, format: format, updateInterval: updateInterval })=>{
    const { time: time, unit: unit } = $6a7dda3450af4d49$export$307c4b8ee56b97bb(value, units);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8M1qS.default), {
        value: time,
        unit: unit,
        numeric: style === 'numeric' ? 'always' : 'auto',
        format: format,
        updateIntervalInSeconds: updateInterval
    }, children);
};
$6a7dda3450af4d49$export$7317ee2f88fd1276.displayName = 'FormattedRelative';

});



const $362c02c5f509c4a8$export$5591d394d996216 = 258;
const $362c02c5f509c4a8$export$f60b6aa2b9634ff5 = 'HEADER_BREADCRUMBS_COMPACT_BEGIN_MARK';
const $362c02c5f509c4a8$export$3ae50e95ee18c4e3 = 'HEADER_BREADCRUMBS_COMPACT_END_MARK';
const $362c02c5f509c4a8$export$815d1bc13ccc1639 = 'HEADER_ACTIONS_COMPACT_BEGIN_MARK';
const $362c02c5f509c4a8$export$1fbdc9738484a32b = 'HEADER_ACTIONS_COMPACT_END_MARK';



parcelRegister("dZlbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $704a17405b788eb9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $6tahE = parcelRequire("6tahE");

var $h97Af = parcelRequire("h97Af");

var $5G3JL = parcelRequire("5G3JL");

var $iJjlA = parcelRequire("iJjlA");

var $jyFd9 = parcelRequire("jyFd9");


var $cjdp5 = parcelRequire("cjdp5");

var $dGpvN = parcelRequire("dGpvN");
const $704a17405b788eb9$export$dde038394a519e94 = (props)=>{
    const { shouldShowCloseButton: shouldShowCloseButton, onClose: onClose, renderFeedback: renderFeedback, isCompact: isCompact, viewModeOptions: viewModeOptions, issueDeleteCallbacks: issueDeleteCallbacks = {}, shouldShowProjectLevelBreadcrumb: shouldShowProjectLevelBreadcrumb, shouldShowRootProjectsBreadcrumb: shouldShowRootProjectsBreadcrumb } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJjlA.default), {
        isCompact: isCompact
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6tahE.default), {
        medium: (0, $iJjlA.issuePageGridColumns)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($704a17405b788eb9$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $362c02c5f509c4a8$export$f60b6aa2b9634ff5)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dGpvN.HeaderBreadcrumbs), {
        shouldShowProjectLevelBreadcrumb: shouldShowProjectLevelBreadcrumb,
        shouldShowRootProjectsBreadcrumb: shouldShowRootProjectsBreadcrumb,
        // @ts-expect-error TS2322 isCompact does not exist on typ
        isCompact: isCompact
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $362c02c5f509c4a8$export$3ae50e95ee18c4e3)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $362c02c5f509c4a8$export$815d1bc13ccc1639)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cjdp5.HeaderActions), {
        renderFeedback: renderFeedback,
        issueDeleteCallbacks: issueDeleteCallbacks,
        viewModeOptions: viewModeOptions,
        onClose: onClose,
        shouldShowCloseButton: shouldShowCloseButton,
        // @ts-expect-error TS2322 - Property isCompact does not exist on typ
        isCompact: isCompact
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $362c02c5f509c4a8$export$1fbdc9738484a32b)
    }))));
};
// FIXME: remove default props
$704a17405b788eb9$export$dde038394a519e94.defaultProps = {
    shouldShowCloseButton: false,
    shouldShowProjectLevelBreadcrumb: false,
    shouldShowRootProjectsBreadcrumb: false,
    renderFeedback: ()=>null,
    viewModeOptions: {
        viewModeSwitchEnabled: false
    },
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
$704a17405b788eb9$export$dde038394a519e94.displayName = 'Header';
var $704a17405b788eb9$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $jyFd9.default))($704a17405b788eb9$export$dde038394a519e94);
/*
    In https://jdog.jira-dev.com/browse/BENTO-809 we needed to prevent newlines
    from being copied when the user selects the issue key. In order to do this,
    we grow the LeftAligned portion and selectively apply padding to the Left
    and RightAligned containers so that the space taken up by the issue key is
    larger, and therefore gives the user a larger area to select the issue key
    in.
*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $704a17405b788eb9$var$HeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tkezwfg _otyrv77o _1e0c1txw _1bah1yb4 _4t3i1osq _4cvr1y6m",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5G3JL", function(module, exports) {

$parcel$export(module.exports, "flowWithSafeComponent", () => $f22fdb74f0008064$export$2931b3e1758fcd88);

var $c8Guq = parcelRequire("c8Guq");

var $wKt79 = parcelRequire("wKt79");
function $f22fdb74f0008064$export$2931b3e1758fcd88(...functions) {
    return (ComponentToWrap, FallbackComponent)=>(0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))(...functions, (0, $wKt79.safeComponent)({
            FallbackComponent: FallbackComponent
        }))(ComponentToWrap);
}

});
parcelRegister("wKt79", function(module, exports) {

$parcel$export(module.exports, "safeComponent", () => $6a091eeb5eedbc70$export$661573a6135234cd);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $ciZ8Y = parcelRequire("ciZ8Y");
const $6a091eeb5eedbc70$var$logLocationPrefix = 'issue.error-boundary.';
const $6a091eeb5eedbc70$var$componentErrorMessage = 'An uncaught error has occurred in a React component';
const $6a091eeb5eedbc70$var$getDisplayName = (UnsafeComponent)=>UnsafeComponent.displayName || UnsafeComponent.name || 'UnsafeComponent';
class $6a091eeb5eedbc70$export$f42bc933f51d0006 {
    constructor(componentName){
        this.handleError = (error, _componentStack)=>(0, $gUUjF.default).safeErrorWithoutCustomerData(this.logLocation, $6a091eeb5eedbc70$var$componentErrorMessage, error);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.callSafely = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        thisArg, fn, ...args)=>{
            try {
                return fn && fn.apply(thisArg, args);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                this.handleError(e);
            }
            return null;
        };
        this.logLocation = `${$6a091eeb5eedbc70$var$logLocationPrefix}${componentName}`;
    }
}
const $6a091eeb5eedbc70$var$makeSafe = (UnsafeComponent, FallbackComponent, componentNameOverride)=>{
    const componentName = componentNameOverride || $6a091eeb5eedbc70$var$getDisplayName(UnsafeComponent);
    const getDisplayNamePrefix = ()=>{
        if (componentNameOverride) return 'Fallback';
        if (FallbackComponent) return 'SafeWithFallback';
        return 'Safe';
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const SafeComponent = ({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
            prefixOverride: "issue",
            id: `${getDisplayNamePrefix()}(${componentName})`,
            render: ()=>{
                if (!FallbackComponent) return null;
                // We should also catch errors in the fallback component
                const SafeFallback = $6a091eeb5eedbc70$var$makeSafe(FallbackComponent, null, componentName);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SafeFallback, props);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UnsafeComponent, props));
    SafeComponent.displayName = `${getDisplayNamePrefix()}(${componentName})`;
    return SafeComponent;
};
const $6a091eeb5eedbc70$export$661573a6135234cd = (options = {})=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (UnsafeComponent)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        $6a091eeb5eedbc70$var$makeSafe(UnsafeComponent, options.FallbackComponent);

});


parcelRegister("jyFd9", function(module, exports) {

$parcel$export(module.exports, "useIsCompactMode", () => $a7e2833a00fbf7c3$export$793e1206aa528384);
$parcel$export(module.exports, "default", () => $a7e2833a00fbf7c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kB5wN = parcelRequire("kB5wN");

var $kB5wN = parcelRequire("kB5wN");
const $a7e2833a00fbf7c3$export$793e1206aa528384 = ()=>(0, $eUqFw.useContext)((0, $kB5wN.CompactModeContext));
var // FIXME: JIV-17455 should be fully typed
// eslint-disable-next-line jira/import/no-anonymous-default-export
$a7e2833a00fbf7c3$export$2e2bcd8739ae039 = (WrappedComponent)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kB5wN.CompactModeConsumer), null, (isCompact)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                isCompact: isCompact
            }));

});

parcelRegister("cjdp5", function(module, exports) {

$parcel$export(module.exports, "HeaderActions", () => $494679356625e6b8$export$223875819fd7cf93);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $8sN8t = parcelRequire("8sN8t");

var $eMxRI = parcelRequire("eMxRI");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $5JqpU = parcelRequire("5JqpU");

var $6RrgN = parcelRequire("6RrgN");

var $bXTjt = parcelRequire("bXTjt");

var $3i5oM = parcelRequire("3i5oM");

var $liHZp = parcelRequire("liHZp");

var $7pBZB = parcelRequire("7pBZB");

var $4qrRK = parcelRequire("4qrRK");

var $2aobN = parcelRequire("2aobN");

var $g4xFV = parcelRequire("g4xFV");
const $494679356625e6b8$export$d990779bb924b935 = ({ onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), renderFeedback: renderFeedback = ()=>null, shouldShowCloseButton: shouldShowCloseButton = false, issueDeleteCallbacks: issueDeleteCallbacks = {}, viewModeOptions: viewModeOptions = {
    viewModeSwitchEnabled: false
}, applicationKey: applicationKey })=>{
    let feedbackComponent;
    if (renderFeedback) {
        const feedback = renderFeedback(applicationKey, true);
        if (feedback != null) feedbackComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
            name: (0, $eMxRI.GIVE_FEEDBACK)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($494679356625e6b8$var$FeedbackWrapper, null, feedback));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($494679356625e6b8$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($494679356625e6b8$var$UnselectableRightAligned, null, feedbackComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7pBZB.SecurityLevelIcon), {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.issue-base.foundation.header.header-actions.security-level-icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $liHZp.IssueRestriction), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6RrgN.Watchers), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2aobN.Voters), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4qrRK.ShareButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bXTjt.AsyncIssueActions), {
        issueDeleteCallbacks: issueDeleteCallbacks,
        viewModeOptions: viewModeOptions,
        onClose: onClose
    }), shouldShowCloseButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3i5oM.default), {
        onClose: onClose
    }) : null));
};
$494679356625e6b8$export$d990779bb924b935.displayName = 'HeaderActionsView';
const $494679356625e6b8$export$223875819fd7cf93 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        // FIXME: JIV-17455. This field can be null
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        applicationKey: (0, $5JqpU.applicationKeySelector)(state)
    }), {}))($494679356625e6b8$export$d990779bb924b935);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $494679356625e6b8$var$HeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tkezwfg _2hwxidpf _18u01wug _otyrv77o _4t3i1osq _4cvr1h6o _p12f1osq _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $494679356625e6b8$var$UnselectableRightAligned = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $g4xFV.RightAligned), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_uiztglyw",
            __cmplp.className
        ])
    });
});
const $494679356625e6b8$var$FeedbackWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6RrgN", function(module, exports) {

$parcel$export(module.exports, "Watchers", () => $d9c25779da1bfcbe$export$695c721ef91b9d0c);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $lqalZ = parcelRequire("lqalZ");

var $jZDJX = parcelRequire("jZDJX");

var $h8Su3 = parcelRequire("h8Su3");

var $dxcfv = parcelRequire("dxcfv");

var $jHNVz = parcelRequire("jHNVz");

const $d9c25779da1bfcbe$export$5d1b8f67b61244b8 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("h77l2")), {
    moduleId: "./src/packages/issue/watchers/src/index.tsx"
});
const $d9c25779da1bfcbe$var$WatchersItem = ({ isWatchesPresent: isWatchesPresent, isLoading: isLoading, error: error })=>{
    const loggedInAccountId = (0, $dxcfv.useAccountId)();
    const shouldRenderWatchers = !error && !!loggedInAccountId;
    const isWatchersLoading = !isWatchesPresent || isLoading;
    if (!shouldRenderWatchers) return null;
    if (isWatchersLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jHNVz.IssueWatchersLoading), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jHNVz.IssueWatchersBoundary), {
        packageName: "issue",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jHNVz.IssueWatchersLoading), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9c25779da1bfcbe$export$5d1b8f67b61244b8, null));
};
const $d9c25779da1bfcbe$export$695c721ef91b9d0c = (0, $lqalZ.connect)((state)=>({
        isWatchesPresent: (0, $h8Su3.isWatchesPresentSelector)(state),
        isLoading: (0, $jZDJX.isLoadingSelector)(state),
        error: (0, $jZDJX.errorSelector)(state)
    }), {})($d9c25779da1bfcbe$var$WatchersItem);

});
parcelRegister("jZDJX", function(module, exports) {

$parcel$export(module.exports, "entitiesSelector", () => $ea753f2b3db28e48$export$ccebe5cc5854d0fa);
$parcel$export(module.exports, "projectSelector", () => $ea753f2b3db28e48$export$852a6c34ff1a2e77);
$parcel$export(module.exports, "uiSelector", () => $ea753f2b3db28e48$export$185c0864c82372e3);
$parcel$export(module.exports, "entitiesIssueSelector", () => $ea753f2b3db28e48$export$fa3ac1f794979805);
$parcel$export(module.exports, "entitiesRefreshedOnSelector", () => $ea753f2b3db28e48$export$c4ebdc93969b82cc);
$parcel$export(module.exports, "flagsSelector", () => $ea753f2b3db28e48$export$40cfdc5e96db7759);
$parcel$export(module.exports, "projectIdSelector", () => $ea753f2b3db28e48$export$4c9d6034f65d22f4);
$parcel$export(module.exports, "projectIdsSelector", () => $ea753f2b3db28e48$export$9edb3f63d1bd8546);
$parcel$export(module.exports, "projectKeySelector", () => $ea753f2b3db28e48$export$404de5ac601b84bc);
$parcel$export(module.exports, "projectTypeSelector", () => $ea753f2b3db28e48$export$69316f88206ca90b);
$parcel$export(module.exports, "isSimplifiedProjectSelector", () => $ea753f2b3db28e48$export$d94d544d4b2e1310);
$parcel$export(module.exports, "loggedInUserDetailsSelector", () => $ea753f2b3db28e48$export$b5a68452fc64275d);
$parcel$export(module.exports, "loggedInUserAvatarUrlSelector", () => $ea753f2b3db28e48$export$e0efa9c12379be7a);
$parcel$export(module.exports, "loggedInUserDisplayNameSelector", () => $ea753f2b3db28e48$export$4f56a07246719eb0);
$parcel$export(module.exports, "parentIssueEntitySelector", () => $ea753f2b3db28e48$export$e10c57d263d23c49);
$parcel$export(module.exports, "loggedInUserTimeZoneSelector", () => $ea753f2b3db28e48$export$ac6f9fd801c94fff);
$parcel$export(module.exports, "idSelector", () => $ea753f2b3db28e48$export$66c501bed2fcd648);
$parcel$export(module.exports, "isClassicProjectSelector", () => $ea753f2b3db28e48$export$45347d9f8a67561b);
$parcel$export(module.exports, "isLoadingSelector", () => $ea753f2b3db28e48$export$c077f23183070903);
$parcel$export(module.exports, "doNotUseIsLoadingPromiseSelector", () => $ea753f2b3db28e48$export$2ca9575c7da6bf18);
$parcel$export(module.exports, "isPreviewSelector", () => $ea753f2b3db28e48$export$b33a1a8958a8d805);
$parcel$export(module.exports, "isCompletedLoadingSelector", () => $ea753f2b3db28e48$export$9b99fb9e23fc133);
$parcel$export(module.exports, "loadingStageSelector", () => $ea753f2b3db28e48$export$18bc980d36bf93d);
$parcel$export(module.exports, "isDeleteIssueModalOpenSelector", () => $ea753f2b3db28e48$export$7cfd3e0dd7059b87);
$parcel$export(module.exports, "isDeletingIssueSelector", () => $ea753f2b3db28e48$export$d414d8eddcb409e4);
$parcel$export(module.exports, "didIssueDeleteFailSelector", () => $ea753f2b3db28e48$export$834732624d2c73e1);
$parcel$export(module.exports, "errorSelector", () => $ea753f2b3db28e48$export$47aec13333381be0);
$parcel$export(module.exports, "errorMessageSelector", () => $ea753f2b3db28e48$export$9b1097e17c0e6dc2);
$parcel$export(module.exports, "getUserByIdSelector", () => $ea753f2b3db28e48$export$801a2f2bd4059665);
$parcel$export(module.exports, "parentLevelIssuesSelector", () => $ea753f2b3db28e48$export$aa8980c49aba4478);
$parcel$export(module.exports, "baseAriSelector", () => $ea753f2b3db28e48$export$fa12ae06e35ebd67);
$parcel$export(module.exports, "issueAriSelector", () => $ea753f2b3db28e48$export$a2cdbba2136e72d3);
$parcel$export(module.exports, "epicLinkFieldKeySelector", () => $ea753f2b3db28e48$export$27abc48b8d528300);
$parcel$export(module.exports, "isEpicSelector", () => $ea753f2b3db28e48$export$6e8ebe94ad8bb62b);
$parcel$export(module.exports, "isServiceDeskSelector", () => $ea753f2b3db28e48$export$43d733e4b7e8c7d0);

var $df4Sl = parcelRequire("df4Sl");

var $7ZZxN = parcelRequire("7ZZxN");


var $f9RL0 = parcelRequire("f9RL0");

var $6vrw7 = parcelRequire("6vrw7");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");
const $ea753f2b3db28e48$export$ccebe5cc5854d0fa = (state)=>state.entities;
const $ea753f2b3db28e48$export$852a6c34ff1a2e77 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>entities ? entities.project : null);
const $ea753f2b3db28e48$export$185c0864c82372e3 = (state)=>state.ui;
const $ea753f2b3db28e48$export$27493ac3d8611290 = (state)=>state.agile;
const $ea753f2b3db28e48$export$fa3ac1f794979805 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>entities.issue);
const $ea753f2b3db28e48$export$c4ebdc93969b82cc = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>entities.refreshedOn);
const $ea753f2b3db28e48$export$40cfdc5e96db7759 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.flags);
const $ea753f2b3db28e48$export$4c9d6034f65d22f4 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$852a6c34ff1a2e77, (project)=>project && project.projectId ? project.projectId : null);
const $ea753f2b3db28e48$export$9edb3f63d1bd8546 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$852a6c34ff1a2e77, (project)=>project && project.projectId ? [
        project.projectId
    ] : []);
const $ea753f2b3db28e48$export$404de5ac601b84bc = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$852a6c34ff1a2e77, (project)=>project ? project.projectKey : null);
const $ea753f2b3db28e48$export$69316f88206ca90b = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$852a6c34ff1a2e77, (project)=>project && project.projectType ? project.projectType : null);
const $ea753f2b3db28e48$export$d94d544d4b2e1310 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$852a6c34ff1a2e77, (project)=>!!project && project.isSimplified);
const $ea753f2b3db28e48$export$b5a68452fc64275d = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (0, $5JqpU.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>loggedInAccountId ? entities.users[loggedInAccountId] : null);
const $ea753f2b3db28e48$export$e0efa9c12379be7a = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (0, $5JqpU.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>{
    const loggedInUser = loggedInAccountId ? entities.users[loggedInAccountId] : null;
    return loggedInUser ? loggedInUser.avatarUrl : null;
});
const $ea753f2b3db28e48$export$4f56a07246719eb0 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (0, $5JqpU.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>{
    const loggedInUser = loggedInAccountId ? entities.users[loggedInAccountId] : null;
    return loggedInUser ? loggedInUser.displayName : null;
});
const $ea753f2b3db28e48$export$e10c57d263d23c49 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>entities.parentIssue);
const $ea753f2b3db28e48$export$ac6f9fd801c94fff = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$b5a68452fc64275d, (loggedInUser)=>loggedInUser ? loggedInUser.timeZone : undefined);
const $ea753f2b3db28e48$export$66c501bed2fcd648 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$fa3ac1f794979805, (issue)=>issue && (0, $6vrw7.toIssueId)(issue.id));
const $ea753f2b3db28e48$export$45347d9f8a67561b = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$d94d544d4b2e1310, (isSimplified)=>!isSimplified);
const $ea753f2b3db28e48$export$c077f23183070903 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $d6ff0428d6ad71a2$export$26d55645375ca9a));
const $ea753f2b3db28e48$export$2ca9575c7da6bf18 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.doNotUseIsLoadingPromise);
const $ea753f2b3db28e48$export$b33a1a8958a8d805 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $d6ff0428d6ad71a2$export$1b56cc494043d9bf));
const $ea753f2b3db28e48$export$9b99fb9e23fc133 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $d6ff0428d6ad71a2$export$1660a2d7c2fff354));
const $ea753f2b3db28e48$export$18bc980d36bf93d = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.loadingStage);
const $ea753f2b3db28e48$export$7cfd3e0dd7059b87 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>!!(ui.issueDeletion && ui.issueDeletion.isDeleteIssueModalOpen));
const $ea753f2b3db28e48$export$d414d8eddcb409e4 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.issueDeletion ? ui.issueDeletion.isDeletingIssue : false);
const $ea753f2b3db28e48$export$834732624d2c73e1 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.issueDeletion ? ui.issueDeletion.didIssueDeleteFail : false);
const $ea753f2b3db28e48$export$47aec13333381be0 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.error);
const $ea753f2b3db28e48$export$9b1097e17c0e6dc2 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.errorMessage);
const $ea753f2b3db28e48$export$801a2f2bd4059665 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>(userId)=>userId ? entities.users[userId] : undefined);
const $ea753f2b3db28e48$export$aa8980c49aba4478 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>entities.parentLevelIssues);
const $ea753f2b3db28e48$export$a60a6c96db10acc4 = ()=>'jira';
const $ea753f2b3db28e48$export$57c6957997fb7f1d = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$69316f88206ca90b, (0, $7ZZxN.projectTypeToCanonicalId));
const $ea753f2b3db28e48$export$fa12ae06e35ebd67 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$a60a6c96db10acc4, (0, $5JqpU.cloudIdSelector), (resourceOwner, cloudId)=>cloudId ? `ari:cloud:${resourceOwner}:${cloudId}` : null);
const $ea753f2b3db28e48$export$a2cdbba2136e72d3 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$fa12ae06e35ebd67, $ea753f2b3db28e48$export$66c501bed2fcd648, (baseAri, issueId)=>{
    if (!baseAri || !issueId) return null;
    return `${baseAri}:issue/${issueId}`;
});
const $ea753f2b3db28e48$export$27abc48b8d528300 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$27493ac3d8611290, (agile)=>agile && agile.epic && agile.epic.key || null);
const $ea753f2b3db28e48$export$d062a59cf4fc9cec = (fields)=>({}).hasOwnProperty.call(fields, (0, $f9RL0.EPIC_ISSUES));
const $ea753f2b3db28e48$export$6e8ebe94ad8bb62b = (0, $df4Sl.createSelector)((0, $fokFV.fieldsSelector), (fields)=>$ea753f2b3db28e48$export$d062a59cf4fc9cec(fields));
const $ea753f2b3db28e48$export$43d733e4b7e8c7d0 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$69316f88206ca90b, (projectType)=>projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT));

});
const $d6ff0428d6ad71a2$export$26d55645375ca9a = 'LOADING';
const $d6ff0428d6ad71a2$export$1b56cc494043d9bf = 'PREVIEW';
const $d6ff0428d6ad71a2$export$1660a2d7c2fff354 = 'COMPLETE';


parcelRegister("h8Su3", function(module, exports) {

$parcel$export(module.exports, "isWatchesPresentSelector", () => $9a8ff69d3f85de3a$export$e816b6a086b3ada9);

var $df4Sl = parcelRequire("df4Sl");

var $f9RL0 = parcelRequire("f9RL0");

var $fokFV = parcelRequire("fokFV");
const $9a8ff69d3f85de3a$var$watchesSelector = (0, $fokFV.fieldSelector)((0, $f9RL0.WATCHES));
const $9a8ff69d3f85de3a$export$e816b6a086b3ada9 = (0, $df4Sl.createSelector)($9a8ff69d3f85de3a$var$watchesSelector, (watches)=>!!watches);

});

parcelRegister("jHNVz", function(module, exports) {

$parcel$export(module.exports, "IssueWatchersLoading", () => $26c5d8fcffdf40dc$export$5bfaf8b643f85490);
$parcel$export(module.exports, "IssueWatchersBoundary", () => $26c5d8fcffdf40dc$export$4a3b62ef2933ce9a);
/* async.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jHMvH = parcelRequire("jHMvH");

var $PdmhA = parcelRequire("PdmhA");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $541P3 = parcelRequire("541P3");

var $gGtKh = parcelRequire("gGtKh");
const $26c5d8fcffdf40dc$export$5bfaf8b643f85490 = ()=>(0, $541P3.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "issue-view-watchers.loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26c5d8fcffdf40dc$var$WatchIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jHMvH))), {
        label: "",
        size: "medium",
        primaryColor: `var(--ds-icon-disabled, ${(0, $PdmhA).N30})`
    }))));
const $26c5d8fcffdf40dc$export$4a3b62ef2933ce9a = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-watchers",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-watchers",
        fallback: fallback
    }, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26c5d8fcffdf40dc$var$WatchIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _18s8t1ds",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jHMvH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e587a998fd060edd$var$_react = $e587a998fd060edd$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e587a998fd060edd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e587a998fd060edd$var$WatchIcon = (props)=>/*#__PURE__*/ $e587a998fd060edd$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M12 18c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6m0-14C6.48 4 2 8.841 2 12c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8"/><path d="M11.977 13.984c-1.103 0-2-.897-2-2s.897-2 2-2c1.104 0 2 .897 2 2s-.896 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.207 0 4-1.794 4-4s-1.793-4-4-4"/></g></svg>`
    }, props));
$e587a998fd060edd$var$WatchIcon.displayName = 'WatchIcon';
var $e587a998fd060edd$var$_default = $e587a998fd060edd$var$WatchIcon;
module.exports.default = $e587a998fd060edd$var$_default;

});

parcelRegister("541P3", function(module, exports) {

$parcel$export(module.exports, "default", () => $407fda47f321697a$export$2e2bcd8739ae039);

var $eoCgY = parcelRequire("eoCgY");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$407fda47f321697a$export$2e2bcd8739ae039 = (loadingComponent)=>{
    const renderer = (0, (/*@__PURE__*/$parcel$interopDefault($eoCgY)))(loadingComponent) ? loadingComponent : ()=>loadingComponent || null;
    return renderer();
};

});


parcelRegister("h77l2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('8a5co')
        ]);
        const value = parcelRequire('8883X');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("8a5co")
    ]).then(()=>parcelRequire('8883X'));
}

});


parcelRegister("bXTjt", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueActions", () => $efeac51f905357e5$export$ddc8459d705ee2ef);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $hn5ZU = parcelRequire("hn5ZU");

var $gGtKh = parcelRequire("gGtKh");

const $efeac51f905357e5$var$LazyIssueActionsMenu = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("oCelM")), {
    moduleId: "./src/packages/issue/issue-view-foundation/src/issue-actions/index.tsx"
});
const $efeac51f905357e5$export$ddc8459d705ee2ef = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-issue-actions-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hn5ZU.default), {
            isDisabled: true,
            getMeatballMenuData: ()=>[]
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($efeac51f905357e5$var$LazyIssueActionsMenu, props));

});
parcelRegister("hn5ZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $afc34b9c88b239dd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $c9TLT = parcelRequire("c9TLT");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $47EmH = parcelRequire("47EmH");

var $f2KOq = parcelRequire("f2KOq");
const $afc34b9c88b239dd$export$f48224de87d33a65 = ()=>(0, $eUqFw.useState)(false);
const $afc34b9c88b239dd$var$MeatballMenu = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ hasPulse: hasPulse, isDisabled: isDisabled, isLoading: isLoading, getMeatballMenuData: getMeatballMenuData }, ref)=>{
    const [isOpen, setOpen] = $afc34b9c88b239dd$export$f48224de87d33a65();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleOpen = (0, $eUqFw.useCallback)(()=>{
        setOpen(true);
        const analyticsEvent = createAnalyticsEvent({
            action: 'click',
            actionSubject: 'dropdownItem'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueActionsOpenChanged');
    }, [
        createAnalyticsEvent,
        setOpen
    ]);
    const handleClose = (0, $eUqFw.useCallback)(()=>{
        setOpen(false);
        const analyticsEvent = createAnalyticsEvent({
            action: 'click',
            actionSubject: 'dropdownItem'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueActionsOpenChanged');
    }, [
        createAnalyticsEvent,
        setOpen
    ]);
    const loadContent = (0, $eUqFw.useCallback)(()=>{
        const dropdownGroups = getMeatballMenuData().filter(({ items: items })=>items.length > 0).map((dropdownGroupData, dropdownGroupIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $47EmH.default), {
                key: dropdownGroupData.key,
                dropdownGroupData: dropdownGroupData,
                isFirst: dropdownGroupIndex === 0,
                onClick: handleClose
            }));
        return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($afc34b9c88b239dd$var$MenuMinimumWidth, {
            "data-testid": "issue.issue-meatball-menu.content"
        }, dropdownGroups));
    }, [
        getMeatballMenuData,
        handleClose
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape' && isOpen) {
            // FIXME: JIV-15402, provide better support for this functionality
            // See https://jplat.atlassian.net/browse/JIV-15402
            event.nativeEvent?.stopImmediatePropagation();
            setOpen(false);
        }
    }, [
        isOpen,
        setOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($afc34b9c88b239dd$var$Container, {
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        boundary: "clippingParents",
        isOpen: isOpen,
        placement: "auto-end",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f2KOq.default), {
                isOpen: isOpen,
                hasPulse: hasPulse === true,
                isDisabled: isDisabled,
                isLoading: isLoading,
                ref: ref,
                onClick: isOpen ? handleClose : handleOpen
            })),
        onClose: handleClose,
        content: loadContent,
        zIndex: (0, $c9TLT.layers).modal
    }));
});
$afc34b9c88b239dd$var$MeatballMenu.defaultProps = {
    hasPulse: false,
    isDisabled: false,
    isLoading: false
};
var $afc34b9c88b239dd$export$2e2bcd8739ae039 = $afc34b9c88b239dd$var$MeatballMenu;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $afc34b9c88b239dd$var$MenuMinimumWidth = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91w81 _c71l10j7 _1yt4swc3 _5pqwx0ol _1ggm1bs6 _et1gidpf _15o9idpf _6z94idpf _1k9uidpf",
            __cmplp.className
        ])
    });
});
const $afc34b9c88b239dd$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1bgi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("47EmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c2c3821cfd5e168$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eMD3i = parcelRequire("eMD3i");
var $8BKky = parcelRequire("8BKky");
const $5c2c3821cfd5e168$var$DropdownGroup = ({ dropdownGroupData: { items: items, name: name }, isFirst: isFirst, onClick: onClick })=>{
    const showTitle = name && name.length > 0 ? name : undefined;
    const dropdownItemGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eMD3i.default), {
        testId: "issue-meatball-menu.ui.dropdown-group.popup-menu-group",
        minWidth: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5c2c3821cfd5e168$var$StyledSection, {
        testId: "issue-meatball-menu.ui.dropdown-group.styled-section",
        title: showTitle
    }, items.map((item, i)=>// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: i,
            onClick: onClick
        }, item))));
    if (isFirst) return dropdownItemGroup;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5c2c3821cfd5e168$var$TopBorder, null, dropdownItemGroup);
};
var $5c2c3821cfd5e168$export$2e2bcd8739ae039 = $5c2c3821cfd5e168$var$DropdownGroup;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c2c3821cfd5e168$var$StyledSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8BKky.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1am1s8vo _1scf1bpf",
            __cmplp.className
        ])
    });
});
const $5c2c3821cfd5e168$var$TopBorder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_x3do1l7n",
            __cmplp.className
        ])
    });
});
$5c2c3821cfd5e168$var$TopBorder.displayName = 'TopBorder';

});
parcelRegister("eMD3i", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d4de9f5740e2589$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");
/**
 * @deprecated refer to MenuGroup, explicitly set maxWidth and minWidth
 */ const $6d4de9f5740e2589$var$PopupMenuGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, ...rest })=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    });
var $6d4de9f5740e2589$export$2e2bcd8739ae039 = $6d4de9f5740e2589$var$PopupMenuGroup;

});


parcelRegister("f2KOq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7643cba1a0917fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");

var $jG1wZ = parcelRequire("jG1wZ");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aCjBz = parcelRequire("aCjBz");

var $37m9A = parcelRequire("37m9A");
const $d7643cba1a0917fc$var$DropdownTrigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isOpen: isOpen, isDisabled: isDisabled, isLoading: isLoading, hasPulse: hasPulse, onClick: onClick }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const intlTooltipText = formatMessage((0, $aCjBz.default).actions);
    const buttonTheme = hasPulse ? (0, $37m9A.pulseButtonTheme) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: intlTooltipText,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        testId: "issue-meatball-menu.ui.dropdown-trigger.button",
        "aria-label": intlTooltipText,
        "aria-expanded": isOpen,
        "aria-haspopup": "true",
        isDisabled: isDisabled,
        isLoading: isLoading,
        appearance: "subtle",
        spacing: "default",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
            label: "",
            size: "medium"
        }),
        theme: buttonTheme,
        isSelected: isOpen,
        onClick: onClick,
        interactionName: "auto-generated.issue-meatball-menu.ui.dropdown-trigger.button.button",
        ref: ref
    }));
});
$d7643cba1a0917fc$var$DropdownTrigger.defaultProps = {
    hasPulse: false,
    isDisabled: false
};
var $d7643cba1a0917fc$export$2e2bcd8739ae039 = $d7643cba1a0917fc$var$DropdownTrigger;

});
parcelRegister("aCjBz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0fa5462c586e28b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d0fa5462c586e28b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    actions: {
        "id": "issue-meatball-menu.dropdown-trigger.actions",
        "defaultMessage": "Actions"
    }
});

});

parcelRegister("37m9A", function(module, exports) {

$parcel$export(module.exports, "pulseButtonTheme", () => $e76bb7082097b023$export$92ba812fbeb0b655);

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");
const $e76bb7082097b023$var$pulseAnimation = /*#__PURE__*/ (0, $kwce8.keyframes)({
    to: {
        boxShadow: '0 0 0 10px transparent'
    }
});
const $e76bb7082097b023$export$92ba812fbeb0b655 = (current, props)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(props);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        ...rest,
        buttonStyles: {
            ...buttonStyles,
            borderRadius: '4px',
            animation: `${$e76bb7082097b023$var$pulseAnimation} 1.45s 3 cubic-bezier(0.66, 0, 0, 1)`,
            animationDelay: '0.5s',
            boxShadow: `0 0 0 0 ${`var(--ds-border-discovery, ${(0, $PdmhA).P300})`}`
        }
    };
};

});



parcelRegister("oCelM", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('5wUYd')
        ]);
        const value = parcelRequire('aWUkU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("5wUYd")
    ]).then(()=>parcelRequire('aWUkU'));
}

});


parcelRegister("liHZp", function(module, exports) {

$parcel$export(module.exports, "IssueRestriction", () => $2e9bc0e52afd3897$export$89eee50f75efed21);
/**
 * ISSUE RESTRICTION IN ISSUE VIEW Screen
 * Details can be found here -
 * https://hello.atlassian.net/wiki/spaces/JPCE/pages/613261740/LDR+View+Issue+API+changes+for+supporting+Issue+Security+in+Next-Gen
 * https://hello.atlassian.net/wiki/spaces/JPCE/pages/574029166/Issue+restrictions+E2E+journey
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $gxhIB = parcelRequire("gxhIB");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $gbger = parcelRequire("gbger");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $i7sR4 = parcelRequire("i7sR4");

var $dv9do = parcelRequire("dv9do");

var $6vrw7 = parcelRequire("6vrw7");

const $2e9bc0e52afd3897$var$restrictionType = (0, $208bbe7b47bba6a4$export$76a449e52fa0e1e8);
const $2e9bc0e52afd3897$var$IssueRestrictionWrapper = ({ currentIssueRestriction: currentIssueRestriction, isIssueRestrictionDisplayForIssue: isIssueRestrictionDisplayForIssue, hasError: hasError, issueKey: issueKey, projectKey: projectKey, edition: edition, isSubtask: isSubtask })=>{
    if (!hasError && isIssueRestrictionDisplayForIssue) {
        if (!isSubtask || currentIssueRestriction.length > 0) return(// @ts-expect-error - TS2322 - Type '{ entityKey: string; currentRestrictions: Value[]; restrictionType: string; projectKeyOrId: string; edition: ApplicationEdition; isSubtask: boolean; }' is not assignable to type 'IntrinsicAttributes & { children?: ReactNode; }'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gxhIB.default), {
            entityKey: (0, $6vrw7.toIssueKey)(issueKey),
            currentRestrictions: currentIssueRestriction,
            restrictionType: $2e9bc0e52afd3897$var$restrictionType,
            projectKeyOrId: (0, $6vrw7.toProjectKey)(projectKey),
            edition: edition,
            isSubtask: isSubtask
        }));
    }
    return null;
};
const $2e9bc0e52afd3897$export$89eee50f75efed21 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        currentIssueRestriction: (0, $i7sR4.currentIssueRestrictionSelector)(state),
        isIssueRestrictionDisplayForIssue: (0, $i7sR4.isIssueRestrictionDisplaySelector)(state),
        hasError: !!(0, $jZDJX.errorSelector)(state),
        // FIXME: JIV-17455. This field can be null
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        projectKey: (0, $jZDJX.projectKeySelector)(state),
        issueKey: (0, $5JqpU.issueKeySelector)(state),
        // FIXME: JIV-17455. This field can be null
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        edition: (0, $gbger.applicationEditionSelector)(state),
        isSubtask: (0, $dv9do.isSubtaskSelector)(state)
    }), {}))($2e9bc0e52afd3897$var$IssueRestrictionWrapper);

});
parcelRegister("gxhIB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3737f32d40ff0d36$export$2e2bcd8739ae039);

var $cUDDU = parcelRequire("cUDDU");

var $3737f32d40ff0d36$export$2e2bcd8739ae039 = (0, $cUDDU.default);

});
parcelRegister("cUDDU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d233982feea8f616$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $h97Af = parcelRequire("h97Af");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");


const $d233982feea8f616$var$LazyComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("3lbPP")), {
    moduleId: "./src/packages/permissions-administration/components/issue-restrictions/src/index.tsx"
});
const $d233982feea8f616$export$e5a7492bd8bb1fd4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-issue-restrictions",
        packageName: "issue-restrictions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-restrictions",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $fb50ff59568b356f$export$37312a67c3e314c6)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d233982feea8f616$var$LazyComponent, props)));
var $d233982feea8f616$export$2e2bcd8739ae039 = $d233982feea8f616$export$e5a7492bd8bb1fd4;

});
const $fb50ff59568b356f$export$37312a67c3e314c6 = 'ISSUE_RESTRICTIONS_LOAD_START_MARK_KEY';
const $fb50ff59568b356f$export$a71624947af1f122 = 'FETCH_ERROR';
const $fb50ff59568b356f$export$5a6682b09e16b7fa = 'UPDATE_ERROR';
const $fb50ff59568b356f$export$1c032771554e03db = 'restrictIssueLockButton';
const $fb50ff59568b356f$export$3af63f51be227fae = 'restrictIssueTypeLockButton';
const $fb50ff59568b356f$export$d772ee215e2d9868 = 'fetchRestrictionsErrorIssueView';
const $fb50ff59568b356f$export$9c393db1dc1a09f7 = 'fetchRestrictionsErrorIssueType';
const $fb50ff59568b356f$export$803b3b52d08cecd3 = 'updateRestrictionsErrorIssueView';
const $fb50ff59568b356f$export$60e2729e41168875 = 'updateRestrictionsErrorIssueType';
const $fb50ff59568b356f$export$51b9d4d064970c0e = 'restrictIssue';
const $fb50ff59568b356f$export$91a9ac838458a66c = 'restrictIssueType';
const $fb50ff59568b356f$export$ba05689ba94f1226 = 'issueRestrictionsUpflow';
const $fb50ff59568b356f$export$beef6497ee5478cf = 'restrictIssueLockButton';
const $fb50ff59568b356f$export$817755ba3b739979 = 'restrictIssueTypeLockButton';
const $fb50ff59568b356f$export$ed570898792dd4dd = 'applyIssueRestrictionButton';
const $fb50ff59568b356f$export$ef86b3398a40460a = 'applyIssueTypeRestrictionButton';
const $fb50ff59568b356f$export$ad3f61314358c605 = 'applyIssueRestrictionCancelButton';
const $fb50ff59568b356f$export$88718285a1fc2009 = 'applyIssueTypeRestrictionCancelButton';
const $fb50ff59568b356f$export$2283d8b1e2cce15 = 'projectSettingsIssueRestrictions';
const $fb50ff59568b356f$export$e60eefa5c05746a3 = 'projectSettingsIssueTypeRestrictions';
const $fb50ff59568b356f$export$60b8dc53fdc5b8ee = 'updateRestrictionsIssueTypeService';
const $fb50ff59568b356f$export$42c727ffae7faea1 = 'updateRestrictionsIssueService';
const $fb50ff59568b356f$export$6d36e3b8d33fcd1f = 'fetchRestrictionsIssueTypeService';
const $fb50ff59568b356f$export$fb156e237aa0d5c1 = 'fetchRestrictionsIssueService';
const $fb50ff59568b356f$export$d34f30df311211be = '4bxuXus1tIdOVkhCHELmbn';
const $fb50ff59568b356f$export$997e23a0aec74966 = 'https://support.atlassian.com/jira-software-cloud/docs/next-gen-permissions';
const $fb50ff59568b356f$export$b8b9d90f9e5bd72b = 'projectSettingsIssuePermissions';

parcelRegister("3lbPP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('7TnFr')
        ]);
        const value = parcelRequire('567pH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("7TnFr")
    ]).then(()=>parcelRequire('567pH'));
}

});


const $208bbe7b47bba6a4$export$76a449e52fa0e1e8 = 'ISSUE'; // RestrictionType is passed from IssueView and IssueType screen to differentiate the update API for issueRestriction
const $208bbe7b47bba6a4$export$ebb48b08205007c5 = 'ISSUE_TYPE';


parcelRegister("gbger", function(module, exports) {

$parcel$export(module.exports, "applicationSelector", () => $e5c42d9a07444d10$export$5b2ad1bf581a1d7b);
$parcel$export(module.exports, "applicationEditionSelector", () => $e5c42d9a07444d10$export$5b57e92e8e2b669a);

var $df4Sl = parcelRequire("df4Sl");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");
const $e5c42d9a07444d10$export$5b2ad1bf581a1d7b = (0, $df4Sl.createSelector)((0, $jZDJX.projectTypeSelector), (projectType)=>projectType ? (0, $eIp1n.getApplicationForProject)(projectType) : null);
const $e5c42d9a07444d10$export$5b57e92e8e2b669a = (0, $df4Sl.createSelector)([
    (0, $5JqpU.appEditionsSelector),
    $e5c42d9a07444d10$export$5b2ad1bf581a1d7b
], (editions, application)=>application ? (0, $6WXNs.getEdition)(application, editions) : null);

});

parcelRegister("i7sR4", function(module, exports) {

$parcel$export(module.exports, "currentIssueRestrictionSelector", () => $258cd0ad82630715$export$b100441211755c3b);
$parcel$export(module.exports, "isIssueRestrictionDisplaySelector", () => $258cd0ad82630715$export$43c7af8b4ba3f2eb);

var $df4Sl = parcelRequire("df4Sl");

var $f9RL0 = parcelRequire("f9RL0");

var $fokFV = parcelRequire("fokFV");
const $258cd0ad82630715$export$6af9a8cf08271903 = (0, $fokFV.fieldSelector)((0, $f9RL0.ISSUE_RESTRICTION));
const $258cd0ad82630715$export$b100441211755c3b = (0, $df4Sl.createSelector)($258cd0ad82630715$export$6af9a8cf08271903, (currentRestriction)=>currentRestriction && currentRestriction.value && currentRestriction.value.issuerestrictions && currentRestriction.value.issuerestrictions.projectrole || []);
const $258cd0ad82630715$export$43c7af8b4ba3f2eb = (0, $df4Sl.createSelector)($258cd0ad82630715$export$6af9a8cf08271903, (currentRestriction)=>currentRestriction && currentRestriction.value && currentRestriction.value.shouldDisplay || false);

});

parcelRegister("dv9do", function(module, exports) {

$parcel$export(module.exports, "isSubtaskSelector", () => $ebb19174331d951e$export$15fea4741156936);
$parcel$export(module.exports, "subtaskEntitiesSelector", () => $ebb19174331d951e$export$17e529874841c746);
$parcel$export(module.exports, "hasSubtasksSelector", () => $ebb19174331d951e$export$f363078714850fd9);
$parcel$export(module.exports, "canCreateSubtaskSelector", () => $ebb19174331d951e$export$151aaebeef1cfe63);

var $df4Sl = parcelRequire("df4Sl");

var $f9RL0 = parcelRequire("f9RL0");


var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $eeyEP = parcelRequire("eeyEP");

var $1b2Vj = parcelRequire("1b2Vj");

var $9D3Vo = parcelRequire("9D3Vo");

var $kndnY = parcelRequire("kndnY");

var $6Fp9G = parcelRequire("6Fp9G");
const $ebb19174331d951e$export$15fea4741156936 = (0, $df4Sl.createSelector)((0, $9D3Vo.issueTypeSelector), (issueType)=>!!(issueType && issueType.subtask));
const $ebb19174331d951e$export$17e529874841c746 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.subtasks);
const $ebb19174331d951e$export$f363078714850fd9 = (0, $df4Sl.createSelector)($ebb19174331d951e$export$17e529874841c746, (0, $fokFV.childIssuesLimitUrlSelector), (subtasks, getChildIssuesLimitUrl)=>subtasks.length > 0 || Boolean(getChildIssuesLimitUrl((0, $f9RL0.SUBTASKS))));
const $ebb19174331d951e$export$899afcd59181acbb = (0, $df4Sl.createSelector)((0, $jZDJX.isSimplifiedProjectSelector), (0, $1b2Vj.isIssueBaseLevel), (0, $eeyEP.hasChildrenIssuesSelector), $ebb19174331d951e$export$f363078714850fd9, (isSimplifiedProject, issueBaseLevel, hasChildrenIssues, hasSubtasks)=>isSimplifiedProject ? issueBaseLevel && hasChildrenIssues : hasSubtasks);
const $ebb19174331d951e$export$58b46fbc7ab224f6 = (0, $df4Sl.createSelector)((0, $6Fp9G.hasUnsupportedTypeSelector), (0, $kndnY.projectHasSubtaskValidatorsSelector), (hasRequiredFields, hasSubtaskValidators)=>hasRequiredFields || hasSubtaskValidators);
const $ebb19174331d951e$export$94f22e5d109e9b04 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), ({ jiraSettings: jiraSettings })=>jiraSettings.subtasksConfiguration.enabled);
const $ebb19174331d951e$export$151aaebeef1cfe63 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), $ebb19174331d951e$export$15fea4741156936, (0, $6Fp9G.isSubtaskTypesPresentSelector), $ebb19174331d951e$export$58b46fbc7ab224f6, (0, $5JqpU.isMobileSelector), (0, $5JqpU.isBitbucketSelector), (0, $5JqpU.isServiceDeskSelector), (0, $jZDJX.isSimplifiedProjectSelector), $ebb19174331d951e$export$94f22e5d109e9b04, (0, $jZDJX.projectSelector), ({ canCreateSubtask: canCreateSubtask }, isSubtask, typesPresent, shouldUseFallbackDialog, isMobile, isBitbucket, isServicedesk, isSimplified, subtasksEnabled, project)=>{
    const shouldHideForMobileOrBitbucket = shouldUseFallbackDialog ? isMobile || isBitbucket : false;
    const isProjectActive = (project?.projectStatus ?? (0, $5bd9e96e4d7e8aee$export$62113557945f790a)) === (0, $5bd9e96e4d7e8aee$export$62113557945f790a);
    const shouldShowSubtask = isServicedesk ? !isSimplified : true;
    return !!(canCreateSubtask && !isSubtask && typesPresent && !shouldHideForMobileOrBitbucket && shouldShowSubtask && subtasksEnabled && isProjectActive);
});

});
const $5bd9e96e4d7e8aee$export$62113557945f790a = 'PROJECT_ACTIVE';
const $5bd9e96e4d7e8aee$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $5bd9e96e4d7e8aee$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';

parcelRegister("9F6MO", function(module, exports) {

$parcel$export(module.exports, "permissionsSelector", () => $f28a7cb0a30833d7$export$7a13e26fbaa74911);
$parcel$export(module.exports, "canBeAssignedToIssuesPermissionsSelector", () => $f28a7cb0a30833d7$export$6da6e9cc5af6cc92);
$parcel$export(module.exports, "canAdministerProjectPermissionsSelector", () => $f28a7cb0a30833d7$export$106fd3c30fc8b230);
$parcel$export(module.exports, "canAdministerJiraPermissionsSelector", () => $f28a7cb0a30833d7$export$adf4ccad5657586d);
$parcel$export(module.exports, "canModifyReporterPermissionsSelector", () => $f28a7cb0a30833d7$export$85a3c8518f632ff1);
$parcel$export(module.exports, "canExportIssueSelector", () => $f28a7cb0a30833d7$export$a409252beda5dd99);
$parcel$export(module.exports, "watchersPermissionsSelector", () => $f28a7cb0a30833d7$export$b3bd1cf4683807d8);
$parcel$export(module.exports, "canViewDevToolsPermissionsSelector", () => $f28a7cb0a30833d7$export$dfc7b576e23ac861);
$parcel$export(module.exports, "canUseServiceDeskAgentFeaturesSelector", () => $f28a7cb0a30833d7$export$1b79be16305d8111);

var $df4Sl = parcelRequire("df4Sl");

var $czx3b = parcelRequire("czx3b");

var $7ZZxN = parcelRequire("7ZZxN");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");
const $f28a7cb0a30833d7$var$internalPermissionsSelector = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.permissions);
const $f28a7cb0a30833d7$var$jsdPermissionsSetThatNeedApplicationRoleAndAgentPerm = new Set([
    // In the BE this is not technically a veto'd permission, however it simplifies the FE code to pretend that it is.
    'canUseServiceDeskAgentFeatures',
    // Normal veto'd permissions as per ServiceDeskCollaboratorPermissionOverrideStrategy in BE
    'canEditIssues',
    'canTransitionIssues',
    'canScheduleIssues',
    'canMoveIssue',
    'canAssignIssues',
    'canBeAssignedToIssues',
    'canDeleteIssue',
    'canManageWatchers',
    'canEditAllComments',
    'canDeleteAllComments',
    'canDeleteAllAttachments',
    'canLogWork',
    'canEditOwnWorklogs',
    'canEditAllWorklogs',
    'canDeleteOwnWorklogs',
    'canDeleteAllWorklogs',
    // These should be vetoed, but aren't requested by JFE yet
    'canResolveIssues',
    'canViewReadonlyWorkflow',
    'canCloseIssues',
    'canModifyReporter',
    'canSetIssueSecurity'
]);
const $f28a7cb0a30833d7$export$7a13e26fbaa74911 = (0, $df4Sl.createSelector)((0, $5JqpU.appPermissionsSelector), (0, $jZDJX.projectTypeSelector), $f28a7cb0a30833d7$var$internalPermissionsSelector, (0, $5JqpU.tenantHasActiveServiceDeskLicenseSelector), (applicationPermissions, projectType, permissions, tenantHasActiveServiceDeskLicense)=>{
    if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT) && tenantHasActiveServiceDeskLicense) {
        const { canUseServiceDeskAgentFeatures: canUseServiceDeskAgentFeatures } = permissions;
        const hasJsdAppRole = applicationPermissions.hasServiceDeskAccess;
        return (0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(permissions, (hasPermission, key)=>$f28a7cb0a30833d7$var$jsdPermissionsSetThatNeedApplicationRoleAndAgentPerm.has(key) ? hasPermission && hasJsdAppRole && canUseServiceDeskAgentFeatures : hasPermission);
    }
    return permissions;
});
const $f28a7cb0a30833d7$export$6da6e9cc5af6cc92 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>!!permissions.canBeAssignedToIssues);
const $f28a7cb0a30833d7$export$106fd3c30fc8b230 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>!!permissions.canAdministerProject);
const $f28a7cb0a30833d7$export$adf4ccad5657586d = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>!!permissions.canAdministerJira);
const $f28a7cb0a30833d7$var$canViewWatchersPermissionsSelector = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canViewWatchers);
const $f28a7cb0a30833d7$var$canManageWatchersPermissionsSelector = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canManageWatchers);
const $f28a7cb0a30833d7$export$85a3c8518f632ff1 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canModifyReporter);
const $f28a7cb0a30833d7$export$a409252beda5dd99 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canExportIssue);
const $f28a7cb0a30833d7$export$b3bd1cf4683807d8 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$var$canViewWatchersPermissionsSelector, $f28a7cb0a30833d7$var$canManageWatchersPermissionsSelector, (canViewWatchers, canManageWatchers)=>({
        canViewWatchers: canViewWatchers,
        canManageWatchers: canManageWatchers
    }));
const $f28a7cb0a30833d7$export$ca6b7f39a3de4ff9 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canBrowseUsers);
const $f28a7cb0a30833d7$export$dfc7b576e23ac861 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canViewDevTools);
const $f28a7cb0a30833d7$export$1b79be16305d8111 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canUseServiceDeskAgentFeatures);

});

parcelRegister("eeyEP", function(module, exports) {

$parcel$export(module.exports, "hasChildrenIssuesSelector", () => $2579e5337c5b7c8d$export$29f34d4d7c528e9c);

var $df4Sl = parcelRequire("df4Sl");

var $8blac = parcelRequire("8blac");

var $lO4Or = parcelRequire("lO4Or");

var $fokFV = parcelRequire("fokFV");
const $2579e5337c5b7c8d$var$childrenIssueSelector = (0, $fokFV.fieldSelector)((0, $lO4Or.CHILDREN_ISSUES));
const $2579e5337c5b7c8d$export$29f34d4d7c528e9c = (0, $df4Sl.createSelector)($2579e5337c5b7c8d$var$childrenIssueSelector, (0, $fokFV.childIssuesLimitUrlSelector), (childrenIssues, getChildIssuesLimitUrl)=>childrenIssues ? !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(childrenIssues.value) || Boolean(getChildIssuesLimitUrl((0, $lO4Or.CHILDREN_ISSUES))) : false);

});

parcelRegister("1b2Vj", function(module, exports) {

$parcel$export(module.exports, "supportedChildIssueTypesEntitiesSelector", () => $6915515a9b677dd8$export$1e8043fccfcba3b9);
$parcel$export(module.exports, "supportsChildCreationSelector", () => $6915515a9b677dd8$export$1af32b549149f3d9);
$parcel$export(module.exports, "parentLevelIssueTypeIdsSelector", () => $6915515a9b677dd8$export$be50776e2ae27cf6);
$parcel$export(module.exports, "parentLevelIssueTypeNamesSelector", () => $6915515a9b677dd8$export$57b3549670d3627b);
$parcel$export(module.exports, "sameLevelIssueTypesIdsSelector", () => $6915515a9b677dd8$export$a81bfe971074142b);
$parcel$export(module.exports, "hierarchyLevelSelector", () => $6915515a9b677dd8$export$4f7eb1d272a8015);
$parcel$export(module.exports, "isIssueBaseLevel", () => $6915515a9b677dd8$export$d9c73da87a448c4);
$parcel$export(module.exports, "canLinkToParentSelector", () => $6915515a9b677dd8$export$5530450eb840ecb2);

var $df4Sl = parcelRequire("df4Sl");

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $3l6tm = parcelRequire("3l6tm");

var $lO4Or = parcelRequire("lO4Or");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $7FqHc = parcelRequire("7FqHc");
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $6915515a9b677dd8$var$childLevelValueSelector = (0, $fokFV.fieldPersistedValueSelector)((0, $lO4Or.HIERARCHY_LEVEL_BELOW)) || null;
const $6915515a9b677dd8$var$isChildLevelSubtaskLevelSelector = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$childLevelValueSelector, (childLevelFieldValue)=>{
    if (!childLevelFieldValue) return false;
    return (0, $3l6tm.isSubtaskHierarchyLevel)(childLevelFieldValue.level);
});
const $6915515a9b677dd8$export$7a45e255c239753 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$childLevelValueSelector, (childLevelValue)=>childLevelValue && childLevelValue.issueTypes || []);
const $6915515a9b677dd8$export$1e8043fccfcba3b9 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), $6915515a9b677dd8$export$7a45e255c239753, (entities, supportedIssueTypes)=>{
    const allIssueTypes = entities.issueTypes;
    const supportedIssueTypeIds = supportedIssueTypes.map((issueType)=>issueType.id);
    return allIssueTypes.filter(// @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
    (issueType)=>supportedIssueTypeIds.indexOf(issueType.id) !== -1);
});
const $6915515a9b677dd8$export$889669c31998ff1f = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), $6915515a9b677dd8$export$7a45e255c239753, (permissions, supportedChildIssueTypes)=>permissions.canCreateChildren && !!supportedChildIssueTypes.length);
const $6915515a9b677dd8$export$fd5ce009bb011181 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), $6915515a9b677dd8$export$7a45e255c239753, $6915515a9b677dd8$var$isChildLevelSubtaskLevelSelector, (0, $jZDJX.isSimplifiedProjectSelector), (permissions, supportedChildIssueTypes, isChildLevelSubtask, isSimplifiedProject)=>permissions.canCreateChildren && !!supportedChildIssueTypes.length && (isSimplifiedProject ? true : !isChildLevelSubtask));
const $6915515a9b677dd8$export$1af32b549149f3d9 = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e'), $6915515a9b677dd8$export$fd5ce009bb011181, $6915515a9b677dd8$export$889669c31998ff1f);
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $6915515a9b677dd8$var$parentLevelValueSelector = (0, $fokFV.fieldPersistedValueSelector)((0, $lO4Or.HIERARCHY_LEVEL_ABOVE)) || null;
const $6915515a9b677dd8$export$55a6507420d37093 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && (parentLevelValue.name || null));
const $6915515a9b677dd8$export$be50776e2ae27cf6 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && parentLevelValue.issueTypeIds.map(String) || []);
const $6915515a9b677dd8$export$57b3549670d3627b = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && parentLevelValue.issueTypes.map((type)=>type.name).filter((name)=>name) || []);
const $6915515a9b677dd8$export$121e4a84c99db916 = (0, $df4Sl.createSelector)($6915515a9b677dd8$export$be50776e2ae27cf6, (parentLevelValue)=>parentLevelValue.length > 0);
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $6915515a9b677dd8$var$sameLevelValueSelector = (0, $fokFV.fieldPersistedValueSelector)((0, $lO4Or.HIERARCHY_LEVEL_SAME_LEVEL)) || null;
const $6915515a9b677dd8$export$26996c7f0f08c0d8 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$sameLevelValueSelector, (sameLevelFieldValue)=>{
    if (!sameLevelFieldValue) return false;
    return (0, $3l6tm.isSubtaskHierarchyLevel)(sameLevelFieldValue.level);
});
const $6915515a9b677dd8$export$a81bfe971074142b = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$sameLevelValueSelector, (sameLevelFieldValue)=>sameLevelFieldValue ? sameLevelFieldValue.issueTypeIds.map(String) : []);
const $6915515a9b677dd8$export$4f7eb1d272a8015 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$sameLevelValueSelector, (sameLevelFieldValue)=>sameLevelFieldValue ? (0, $3l6tm.toHierarchyLevel)(sameLevelFieldValue.level) : null);
const $6915515a9b677dd8$export$d9c73da87a448c4 = (0, $df4Sl.createSelector)($6915515a9b677dd8$export$4f7eb1d272a8015, (level)=>{
    if (level == null) // Some product types (JSM, Core, ...) do not support hierarchies at all and will not return this field.
    // For these, all issues are considered to be "Base" level.
    return true;
    return (0, $3l6tm.isBaseHierarchyLevel)(level);
});
const $6915515a9b677dd8$export$5530450eb840ecb2 = (0, $df4Sl.createSelector)($6915515a9b677dd8$export$55a6507420d37093, (0, $7FqHc.canEditIssuesSelector), $6915515a9b677dd8$export$121e4a84c99db916, (parentLevelName, shouldShowAddParent, hasParentIssueTypeId)=>Boolean(parentLevelName) && shouldShowAddParent && hasParentIssueTypeId);

});
parcelRegister("8LJqN", function(module, exports) {

$parcel$export(module.exports, "functionWithCondition", () => $96fc75653c9b207d$export$af3c0e82a18fc057);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $96fc75653c9b207d$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $96fc75653c9b207d$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $96fc75653c9b207d$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});

parcelRegister("3l6tm", function(module, exports) {

$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", () => $493876d3567385f4$export$2294cfc7730248df);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", () => $493876d3567385f4$export$961a1d6da881600c);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", () => $493876d3567385f4$export$e11dea67b88ee556);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", () => $493876d3567385f4$export$9ad20e435294162a);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", () => $493876d3567385f4$export$a454b3474c5ee5f5);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", () => $493876d3567385f4$export$b69c1b48ce8f83de);
$parcel$export(module.exports, "BASE_HIERARCHY_TYPE", () => $493876d3567385f4$export$ba7c785763a2a58f);
$parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", () => $493876d3567385f4$export$e09d07f2dcff2603);
$parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", () => $493876d3567385f4$export$1165245f61159842);
$parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", () => $493876d3567385f4$export$8a96a83b3f957e58);
$parcel$export(module.exports, "toHierarchyLevel", () => $493876d3567385f4$export$c0c893ca5ccae9dd);
$parcel$export(module.exports, "isBaseHierarchyLevel", () => $493876d3567385f4$export$bcf91a9d8c5b0f58);
$parcel$export(module.exports, "isEpicHierarchyLevel", () => $493876d3567385f4$export$e415cf60723c7aae);
$parcel$export(module.exports, "isSubtaskHierarchyLevel", () => $493876d3567385f4$export$41f00a40e2ebd6e8);
$parcel$export(module.exports, "getHierarchyLevelType", () => $493876d3567385f4$export$556b686fea6fb229);
$parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", () => $493876d3567385f4$export$638ac52227e67c8);
const $493876d3567385f4$export$2294cfc7730248df = 4;
const $493876d3567385f4$export$961a1d6da881600c = 3;
const $493876d3567385f4$export$e11dea67b88ee556 = 2;
const $493876d3567385f4$export$9ad20e435294162a = 1;
const $493876d3567385f4$export$a454b3474c5ee5f5 = 0;
const $493876d3567385f4$export$b69c1b48ce8f83de = -1;
const $493876d3567385f4$export$ba7c785763a2a58f = 'BASE';
const $493876d3567385f4$export$e09d07f2dcff2603 = 'CHILD';
const $493876d3567385f4$export$1165245f61159842 = 'PARENT';
const $493876d3567385f4$export$8a96a83b3f957e58 = 'EPIC';
const $493876d3567385f4$export$c0c893ca5ccae9dd = (level)=>level;
const $493876d3567385f4$export$bcf91a9d8c5b0f58 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return true;
    return numericLevel === $493876d3567385f4$export$a454b3474c5ee5f5;
};
const $493876d3567385f4$export$e415cf60723c7aae = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $493876d3567385f4$export$9ad20e435294162a;
};
const $493876d3567385f4$export$41f00a40e2ebd6e8 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $493876d3567385f4$export$b69c1b48ce8f83de;
};
const $493876d3567385f4$export$556b686fea6fb229 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) > 0) return $493876d3567385f4$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $493876d3567385f4$export$e09d07f2dcff2603;
    return $493876d3567385f4$export$ba7c785763a2a58f;
};
const $493876d3567385f4$export$638ac52227e67c8 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) === 1) return $493876d3567385f4$export$8a96a83b3f957e58;
    if (Number(hierarchyLevel) > 1) return $493876d3567385f4$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $493876d3567385f4$export$e09d07f2dcff2603;
    return $493876d3567385f4$export$ba7c785763a2a58f;
};

});

parcelRegister("7FqHc", function(module, exports) {

$parcel$export(module.exports, "canEditIssuesSelector", () => $82be12fe73ce8456$export$cdd6892c8add3e54);
$parcel$export(module.exports, "canLinkIssuesSelector", () => $82be12fe73ce8456$export$50487d0d29271836);

var $df4Sl = parcelRequire("df4Sl");

var $9F6MO = parcelRequire("9F6MO");
const $82be12fe73ce8456$export$a7a483ca0afc4ab3 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canCloneIssue);
const $82be12fe73ce8456$export$c1f4ef01259b4eb = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canDeleteIssue);
const $82be12fe73ce8456$export$2f9dd165cbf0c5ea = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canMoveIssue);
const $82be12fe73ce8456$export$cdd6892c8add3e54 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canEditIssues);
const $82be12fe73ce8456$export$f48030c6644c0c4d = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canAdministerJira || permissions.canAdministerProject);
const $82be12fe73ce8456$export$4e8dac873f71d13e = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canAssignIssues);
const $82be12fe73ce8456$export$50487d0d29271836 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canLinkIssues);

});


parcelRegister("9D3Vo", function(module, exports) {

$parcel$export(module.exports, "createFullIssueUrl", () => $77aaf5a68eaa155c$export$f107e3172d0c8a79);
$parcel$export(module.exports, "issueTypeSelector", () => $77aaf5a68eaa155c$export$c5a236f192993436);
$parcel$export(module.exports, "issueUrlSelector", () => $77aaf5a68eaa155c$export$7855e152de23b9ca);
$parcel$export(module.exports, "fullIssueUrlSelector", () => $77aaf5a68eaa155c$export$14eeb219bfe6649b);
$parcel$export(module.exports, "issueTypeNameSelector", () => $77aaf5a68eaa155c$export$477df8db13e4dac3);
$parcel$export(module.exports, "issueTypeHierarchyLevelSelector", () => $77aaf5a68eaa155c$export$2bcfec06e5c80ef6);
$parcel$export(module.exports, "issueTypeIdSelector", () => $77aaf5a68eaa155c$export$22410768c09b3a82);
$parcel$export(module.exports, "issueTypeIconUrlSelector", () => $77aaf5a68eaa155c$export$4cf7e4622f7b8aee);
$parcel$export(module.exports, "isIssueTypeFieldEditableSelector", () => $77aaf5a68eaa155c$export$580b385a93b77724);
$parcel$export(module.exports, "getParentIssuesSelector", () => $77aaf5a68eaa155c$export$1e6d1c8ba22c2162);

var $df4Sl = parcelRequire("df4Sl");

var $f9RL0 = parcelRequire("f9RL0");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");
// @ts-expect-error - TS2304 - Cannot find name 'BaseUrl'. | TS7006 - Parameter 'issueKey' implicitly has an 'any' type.
const $77aaf5a68eaa155c$var$createRelativeIssueUrl = (baseUrl, issueKey)=>`${baseUrl ? baseUrl.replace(/\/?$/, '/') : '/'}browse/${issueKey}`;
const $77aaf5a68eaa155c$export$f107e3172d0c8a79 = (baseUrl, issueKey)=>`${window.location.protocol}//${window.location.host}${$77aaf5a68eaa155c$var$createRelativeIssueUrl(baseUrl, issueKey)}`;
const $77aaf5a68eaa155c$var$issueTypeFieldSelector = (0, $fokFV.fieldSelector)((0, $f9RL0.ISSUE_TYPE));
const $77aaf5a68eaa155c$var$subtaskIssueFieldSelector = (0, $fokFV.fieldSelector)((0, $f9RL0.SUBTASK_PARENT));
const $77aaf5a68eaa155c$var$portfolioParentFieldSelector = (0, $fokFV.fieldSelector)((0, $f9RL0.PARENT));
const $77aaf5a68eaa155c$export$c5a236f192993436 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$issueTypeFieldSelector, (issueType)=>issueType && issueType.value);
const $77aaf5a68eaa155c$export$7855e152de23b9ca = (0, $df4Sl.createSelector)((0, $5JqpU.baseUrlSelector), (0, $5JqpU.issueKeySelector), $77aaf5a68eaa155c$var$createRelativeIssueUrl);
const $77aaf5a68eaa155c$export$14eeb219bfe6649b = (0, $df4Sl.createSelector)((0, $5JqpU.baseUrlSelector), (0, $5JqpU.issueKeySelector), $77aaf5a68eaa155c$export$f107e3172d0c8a79);
const $77aaf5a68eaa155c$export$477df8db13e4dac3 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$export$c5a236f192993436, (issueType)=>issueType && issueType.name);
const $77aaf5a68eaa155c$export$2bcfec06e5c80ef6 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$export$c5a236f192993436, (issueType)=>{
    if (!issueType) return null;
    return issueType && issueType.hierarchyLevel;
});
const $77aaf5a68eaa155c$export$22410768c09b3a82 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$export$c5a236f192993436, (issueType)=>issueType && issueType.id);
const $77aaf5a68eaa155c$export$4cf7e4622f7b8aee = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$export$c5a236f192993436, (issueType)=>issueType && issueType.iconUrl);
const $77aaf5a68eaa155c$export$580b385a93b77724 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$issueTypeFieldSelector, (issueType)=>issueType && Boolean(issueType.editable));
const $77aaf5a68eaa155c$var$transformParentIssue = (issue, baseUrl)=>issue ? {
        summary: issue.summary,
        key: issue.key,
        url: $77aaf5a68eaa155c$var$createRelativeIssueUrl(baseUrl, issue.key),
        issueTypeName: issue.issueTypeName || '',
        issueTypeIconUrl: issue.issueTypeIconUrl || ''
    } : null;
// @ts-expect-error - TS7006 - Parameter 'issue' implicitly has an 'any' type.
const $77aaf5a68eaa155c$var$transformSubtaskParentIssue = (issue, baseUrl)=>issue ? {
        summary: issue.fields.summary,
        key: issue.key,
        url: $77aaf5a68eaa155c$var$createRelativeIssueUrl(baseUrl, issue.key),
        issueTypeName: issue.issueTypeName || '',
        issueTypeIconUrl: issue.issueTypeIconUrl || ''
    } : null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $77aaf5a68eaa155c$var$transformPortfolioParentIssue = (value, baseUrl)=>value && value.data ? {
        summary: value.data.summary,
        key: value.data.key,
        url: $77aaf5a68eaa155c$var$createRelativeIssueUrl(baseUrl, value.data.key),
        issueTypeName: value.data.issueTypeName || '',
        issueTypeIconUrl: value.data.issueTypeIconUrl || ''
    } : null;
const $77aaf5a68eaa155c$export$77f9f02e63a0906f = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$portfolioParentFieldSelector, (0, $5JqpU.baseUrlSelector), (portfolioParentIssue, baseUrl)=>$77aaf5a68eaa155c$var$transformPortfolioParentIssue(portfolioParentIssue && portfolioParentIssue.value, baseUrl));
const $77aaf5a68eaa155c$var$subtaskIssueParentSelector = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$subtaskIssueFieldSelector, (0, $5JqpU.baseUrlSelector), (subtaskIssue, baseUrl)=>$77aaf5a68eaa155c$var$transformSubtaskParentIssue(subtaskIssue && subtaskIssue.value, baseUrl));
const $77aaf5a68eaa155c$var$parentIssueSelector = (0, $df4Sl.createSelector)((0, $jZDJX.parentIssueEntitySelector), (0, $5JqpU.baseUrlSelector), (parentIssue, baseUrl)=>$77aaf5a68eaa155c$var$transformParentIssue(parentIssue, baseUrl));
const $77aaf5a68eaa155c$export$dfeb83ef40558422 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$parentIssueSelector, $77aaf5a68eaa155c$var$subtaskIssueParentSelector, $77aaf5a68eaa155c$export$77f9f02e63a0906f, (parentIssue, subtaskIssue, portfolioParentIssue)=>parentIssue || subtaskIssue || portfolioParentIssue);
const $77aaf5a68eaa155c$export$1e6d1c8ba22c2162 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$parentIssueSelector, (parentIssue)=>[
        parentIssue
    ].filter(Boolean));

});

parcelRegister("kndnY", function(module, exports) {

$parcel$export(module.exports, "projectHasSubtaskValidatorsSelector", () => $d92659ac5d07e0a6$export$ecfed315b19a7565);

var $df4Sl = parcelRequire("df4Sl");

const $d92659ac5d07e0a6$var$hasSubtaskValidators = (hasValidators)=>hasValidators.status === (0, $97086cfe7b0ec751$export$4c02edeb1b5e410a) && hasValidators.value;
const $d92659ac5d07e0a6$var$unknown = (hasValidators)=>hasValidators.status === (0, $97086cfe7b0ec751$export$26d55645375ca9a) || hasValidators.status === (0, $97086cfe7b0ec751$export$d71930f7f5807a72);
const $d92659ac5d07e0a6$export$ecfed315b19a7565 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.validators, (validators)=>{
    const val = validators.projectHasSubtaskValidators;
    return $d92659ac5d07e0a6$var$hasSubtaskValidators(val) || $d92659ac5d07e0a6$var$unknown(val);
});

});
const $97086cfe7b0ec751$export$26d55645375ca9a = 'LOADING';
const $97086cfe7b0ec751$export$d71930f7f5807a72 = 'FAILED';
const $97086cfe7b0ec751$export$4c02edeb1b5e410a = 'LOADED';


parcelRegister("6Fp9G", function(module, exports) {

$parcel$export(module.exports, "subtaskTypesSelector", () => $d7237d4b8f5dc461$export$86a4f97fc27a0c44);
$parcel$export(module.exports, "isSubtaskTypesPresentSelector", () => $d7237d4b8f5dc461$export$9a147dcac364dd81);
$parcel$export(module.exports, "hasUnsupportedTypeSelector", () => $d7237d4b8f5dc461$export$3fbfbdcf57f34c2);

var $df4Sl = parcelRequire("df4Sl");

var $ke6cX = parcelRequire("ke6cX");
const $d7237d4b8f5dc461$export$86a4f97fc27a0c44 = (0, $df4Sl.createSelector)((0, $ke6cX.issueTypesSelector), (issueTypes)=>issueTypes.filter((type)=>type.subtask));
const $d7237d4b8f5dc461$export$9a147dcac364dd81 = (0, $df4Sl.createSelector)($d7237d4b8f5dc461$export$86a4f97fc27a0c44, (subtaskTypes)=>subtaskTypes.length >= 1);
const $d7237d4b8f5dc461$export$3fbfbdcf57f34c2 = (0, $df4Sl.createSelector)($d7237d4b8f5dc461$export$86a4f97fc27a0c44, (subtaskTypes)=>!!subtaskTypes.find((0, $ke6cX.hasUnsupportedType)));

});
parcelRegister("ke6cX", function(module, exports) {

$parcel$export(module.exports, "issueTypesSelector", () => $4a7e93d9a88b268c$export$f5378064bf877b95);
$parcel$export(module.exports, "hasUnsupportedType", () => $4a7e93d9a88b268c$export$1f59505fa2d77635);
$parcel$export(module.exports, "issueTypesForClassicProjectEpicSelector", () => $4a7e93d9a88b268c$export$a0efcb09d3e23dc1);
$parcel$export(module.exports, "fetchIssueTypesStatusSelector", () => $4a7e93d9a88b268c$export$bfbb65ccb13a16eb);

var $df4Sl = parcelRequire("df4Sl");

var $8blac = parcelRequire("8blac");

var $jZDJX = parcelRequire("jZDJX");

var $9D3Vo = parcelRequire("9D3Vo");
const $4a7e93d9a88b268c$export$f5378064bf877b95 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.issueTypes);
// A collection of issue fields which are marked as `required`
// for the creation of an issue, but are considered as 'provided' since
// the data for these fields is supplied by JIRA.
const $4a7e93d9a88b268c$var$providedRequiredFields = [
    'summary',
    'issuetype',
    'parent',
    'project'
];
const $4a7e93d9a88b268c$var$isRequiredFieldProvided = (fieldName)=>$4a7e93d9a88b268c$var$providedRequiredFields.find((providedFieldName)=>fieldName === providedFieldName);
// A field is considered 'unsupported' if not provided by JIRA,
// has no default value, and is a `required` field.
const $4a7e93d9a88b268c$var$hasUnsupportedRequiredField = (fields)=>// @ts-expect-error - TS2769 - No overload matches this call.
    !!Object.keys(fields).find((fieldName)=>!$4a7e93d9a88b268c$var$isRequiredFieldProvided(fieldName) && // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        !fields[fieldName].hasDefaultValue && // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        fields[fieldName].required);
const $4a7e93d9a88b268c$export$1f59505fa2d77635 = (issueType)=>(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(issueType.fields) || $4a7e93d9a88b268c$var$hasUnsupportedRequiredField(issueType.fields);
const $4a7e93d9a88b268c$export$a0efcb09d3e23dc1 = (0, $df4Sl.createSelector)($4a7e93d9a88b268c$export$f5378064bf877b95, (0, $9D3Vo.issueTypeSelector), (0, $jZDJX.isEpicSelector), (issueTypes, currentIssueType, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isCurrentIssueAnEpic)=>{
    const epicIssueTypeId = isCurrentIssueAnEpic && currentIssueType && currentIssueType.id;
    return issueTypes.filter(// @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'number' and 'string | boolean | undefined' have no overlap.
    (issueType)=>!issueType.subtask && issueType.id !== epicIssueTypeId);
});
const $4a7e93d9a88b268c$export$bfbb65ccb13a16eb = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.fetchIssueTypesStatus);

});




parcelRegister("7pBZB", function(module, exports) {

$parcel$export(module.exports, "SecurityLevelIcon", () => $7c33951bbfe1d178$export$482ce75384e817f3);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $kmr29 = parcelRequire("kmr29");

var $hQZB7 = parcelRequire("hQZB7");
var $eC9xp = parcelRequire("eC9xp");

var $5G3JL = parcelRequire("5G3JL");

var $f9RL0 = parcelRequire("f9RL0");

var $lqalZ = parcelRequire("lqalZ");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $fVCj0 = parcelRequire("fVCj0");

var $4OMUb = parcelRequire("4OMUb");

const $7c33951bbfe1d178$export$983247f68f9c0072 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("4TTMr")), {
    moduleId: "./src/packages/issue/fields/security-level/src/index.tsx"
});
const $7c33951bbfe1d178$var$SecurityLevelIconItem = ({ securityLevelItems: securityLevelItems, isSecurityLevelEnabledForIssue: isSecurityLevelEnabledForIssue, isSecurityLevelEditable: isSecurityLevelEditable, error: error, issueKey: issueKey, onSuccess: onSuccess })=>{
    const [fieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $f9RL0.SECURITY)
    });
    if (!error && isSecurityLevelEnabledForIssue) {
        const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eC9xp.Loading), {
            initialValue: fieldValue
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hQZB7.IssueSecurityLevelFieldBoundary), {
            packageName: "issue",
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c33951bbfe1d178$export$983247f68f9c0072, {
            issueKey: issueKey,
            initialValue: fieldValue || null,
            allowedValues: securityLevelItems,
            isEditable: isSecurityLevelEditable,
            onSuccess: onSuccess
        }));
    }
    return null;
};
const $7c33951bbfe1d178$export$482ce75384e817f3 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        securityLevelItems: (0, $4OMUb.allowedValuesSelector)(state),
        isSecurityLevelEnabledForIssue: Boolean((0, $4OMUb.isEnabledForCurrentIssueSelector)(state)),
        isSecurityLevelEditable: (0, $4OMUb.isEditableSelector)(state),
        error: (0, $jZDJX.errorSelector)(state),
        issueKey: (0, $5JqpU.issueKeySelector)(state)
    }), (dispatch)=>({
        onSuccess: (value)=>dispatch((0, $fVCj0.sweetStateFieldUpdated)((0, $f9RL0.SECURITY), value))
    })))($7c33951bbfe1d178$var$SecurityLevelIconItem);

});
parcelRegister("hQZB7", function(module, exports) {

$parcel$export(module.exports, "IssueSecurityLevelFieldBoundary", () => $2cc0e2755666b30e$export$8102a438cb2f5f92);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $eC9xp = parcelRequire("eC9xp");
const $2cc0e2755666b30e$export$8102a438cb2f5f92 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-security-level-field",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-security-level-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("eC9xp", function(module, exports) {

$parcel$export(module.exports, "Loading", () => $5cc3f846f69bc796$export$669f6ea7d267feaf);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $7u4fN = parcelRequire("7u4fN");

var $f4A0J = parcelRequire("f4A0J");

var $8HBl8 = parcelRequire("8HBl8");

var $PdmhA = parcelRequire("PdmhA");

var $2tH9g = parcelRequire("2tH9g");
const $5cc3f846f69bc796$export$669f6ea7d267feaf = (props)=>{
    const { initialValue: initialValue } = props;
    const Icon = initialValue ? (0, (/*@__PURE__*/$parcel$interopDefault($f4A0J))) : (0, (/*@__PURE__*/$parcel$interopDefault($8HBl8)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "default",
        isDisabled: true,
        iconBefore: // @ts-expect-error - TS2739 - Type '{ children: Element; }' is missing the following properties from type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { isActive: boolean; hasSecurityLevel: boolean; }, any>>': isActive, hasSecurityLevel
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5cc3f846f69bc796$var$LoadingButtonContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            label: ""
        })),
        interactionName: "auto-generated.jira-issue-field-security-level.ui.loading.button"
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5cc3f846f69bc796$var$LoadingButtonContent = /*#__PURE__*/ (0, $kwce8.default)((0, $2tH9g.ButtonContent)).withConfig({
    componentId: "sc-1v0j3w3-0"
})({
    color: `var(--ds-icon-disabled, ${(0, $PdmhA).N30})`
});

});
parcelRegister("f4A0J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02d4f449435745cf$var$_react = $02d4f449435745cf$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $02d4f449435745cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $02d4f449435745cf$var$LockFilledIcon = (props)=>/*#__PURE__*/ $02d4f449435745cf$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0112 4a4 4 0 014 4.002V10a2 2 0 012 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 016 18v-6c0-1.102.897-1.995 2-2zm2 0h4V8.002A2.001 2.001 0 0012 6c-1.102 0-2 .898-2 2.002V10zm2 7a2 2 0 100-4 2 2 0 000 4z"/></svg>`
    }, props));
$02d4f449435745cf$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $02d4f449435745cf$var$_default = $02d4f449435745cf$var$LockFilledIcon;
module.exports.default = $02d4f449435745cf$var$_default;

});

parcelRegister("8HBl8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $655f4dcb2f3febd5$var$_react = $655f4dcb2f3febd5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $655f4dcb2f3febd5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $655f4dcb2f3febd5$var$UnlockIcon = (props)=>/*#__PURE__*/ $655f4dcb2f3febd5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M5 11.009C5 9.899 5.897 9 7.006 9h9.988A2.01 2.01 0 0119 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.009 2.009 0 015 18.991V11.01zM7 11v8h10v-8H7z"/><circle cx="12" cy="15" r="2"/><path d="M8 6.251v-.249A4.004 4.004 0 0112 2a4 4 0 014 4.002V6.5h-2v-.498A2.001 2.001 0 0012 4c-1.102 0-2 .898-2 2.002V11H8V6.251zm6 .249h2a1 1 0 01-2 0z"/></g></svg>`
    }, props));
$655f4dcb2f3febd5$var$UnlockIcon.displayName = 'UnlockIcon';
var $655f4dcb2f3febd5$var$_default = $655f4dcb2f3febd5$var$UnlockIcon;
module.exports.default = $655f4dcb2f3febd5$var$_default;

});

parcelRegister("2tH9g", function(module, exports) {

$parcel$export(module.exports, "ButtonContent", () => $9c68c7110e069cb1$export$260bb228dedc7e4f);

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");
const $9c68c7110e069cb1$export$260bb228dedc7e4f = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8dumid-0"
})`display:flex;align-items:center;color:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>{
    if (props.isActive) return `var(--ds-icon-brand, ${(0, $PdmhA).N0})`;
    if (props.hasSecurityLevel) return `var(--ds-icon-danger, ${(0, $PdmhA).R400})`;
    return null;
}};`;

});



parcelRegister("fVCj0", function(module, exports) {

$parcel$export(module.exports, "FIELD_SAVE_REQUEST", () => $902163b5c2f843a6$export$3f59a7eb90e36843);
$parcel$export(module.exports, "fieldSaveRequest", () => $902163b5c2f843a6$export$335fca637cd982e4);
$parcel$export(module.exports, "FIELD_SAVE_SUCCESS", () => $902163b5c2f843a6$export$d9454bd2cac01f4e);
$parcel$export(module.exports, "fieldSaveSuccess", () => $902163b5c2f843a6$export$7c7dca2709339ac4);
$parcel$export(module.exports, "FIELD_SAVE_FAILURE", () => $902163b5c2f843a6$export$a44dd5d3aced253b);
$parcel$export(module.exports, "fieldSaveFailure", () => $902163b5c2f843a6$export$730c9a4f39e16b3f);
$parcel$export(module.exports, "SWEET_STATE_FIELD_SAVE_FAILURE", () => $902163b5c2f843a6$export$2d9aba1f42c158b);
$parcel$export(module.exports, "sweetStateFieldSaveFailure", () => $902163b5c2f843a6$export$d5fa2570b5a5568e);
$parcel$export(module.exports, "fieldSaveSuccessWithPastedContent", () => $902163b5c2f843a6$export$29ce961a0b243e8e);
$parcel$export(module.exports, "FIELD_UPDATED", () => $902163b5c2f843a6$export$c0f8e20d872095b5);
$parcel$export(module.exports, "fieldUpdated", () => $902163b5c2f843a6$export$8cd5b1a72497c9b1);
$parcel$export(module.exports, "SWEET_STATE_FIELD_UPDATED", () => $902163b5c2f843a6$export$124a5e893dae8156);
$parcel$export(module.exports, "sweetStateFieldUpdated", () => $902163b5c2f843a6$export$c19f432af75bfdb6);
$parcel$export(module.exports, "FIELD_CONFIRM_NEW_FIELD", () => $902163b5c2f843a6$export$85eddf7a008960b8);
$parcel$export(module.exports, "fieldConfirmNewField", () => $902163b5c2f843a6$export$5f6841555ecc90f6);
$parcel$export(module.exports, "FIELD_CONFIRM_FAILURE_NEW_FIELD", () => $902163b5c2f843a6$export$d30636f57fb724cc);
$parcel$export(module.exports, "fieldConfirmFailureNewField", () => $902163b5c2f843a6$export$404cd00ef34f434f);
$parcel$export(module.exports, "FIELD_UPDATE", () => $902163b5c2f843a6$export$4dd6a5a4f4f303ba);
$parcel$export(module.exports, "fieldUpdate", () => $902163b5c2f843a6$export$8636ea797fb5a6d3);
const $902163b5c2f843a6$export$3f59a7eb90e36843 = 'FIELD_SAVE_REQUEST';
const $902163b5c2f843a6$export$335fca637cd982e4 = (fieldId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
value, fieldOptions, saveFieldData, // eslint-disable-next-line @typescript-eslint/no-explicit-any
analyticsEvent, fieldAnalyticsData, shouldFetchViewContext = false)=>({
        type: $902163b5c2f843a6$export$3f59a7eb90e36843,
        payload: {
            fieldId: fieldId,
            value: value,
            fieldOptions: fieldOptions,
            saveFieldData: // @ts-expect-error - TS2322 - Type 'T | null | undefined' is not assignable to type 'T | undefined'.
            saveFieldData,
            analyticsEvent: analyticsEvent,
            shouldFetchViewContext: shouldFetchViewContext,
            // passed through as the 'eventData' prop because the analytics epic
            // that picks this up will spread the data in eventData into the final
            // analyticsObject
            ...fieldAnalyticsData && {
                eventData: fieldAnalyticsData
            }
        }
    });
const $902163b5c2f843a6$export$d9454bd2cac01f4e = 'FIELD_SAVE_SUCCESS';
const $902163b5c2f843a6$export$7c7dca2709339ac4 = (fieldId, fieldOptions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
fieldValue, // eslint-disable-next-line @typescript-eslint/no-explicit-any
saveFieldResult, meta)=>({
        type: $902163b5c2f843a6$export$d9454bd2cac01f4e,
        payload: {
            fieldId: fieldId,
            fieldOptions: fieldOptions,
            fieldValue: fieldValue,
            saveFieldResult: saveFieldResult
        },
        meta: meta
    });
const $902163b5c2f843a6$export$a44dd5d3aced253b = 'FIELD_SAVE_FAILURE';
const $902163b5c2f843a6$export$730c9a4f39e16b3f = (fieldId, invalidMessage, error, fieldOptions)=>({
        type: $902163b5c2f843a6$export$a44dd5d3aced253b,
        payload: {
            fieldId: fieldId,
            invalidMessage: invalidMessage,
            error: error,
            fieldOptions: fieldOptions
        }
    });
const $902163b5c2f843a6$export$2d9aba1f42c158b = 'SWEET_STATE_FIELD_SAVE_FAILURE';
const $902163b5c2f843a6$export$d5fa2570b5a5568e = (fieldId, invalidMessage, error, fieldOptions)=>({
        type: $902163b5c2f843a6$export$2d9aba1f42c158b,
        payload: {
            fieldId: fieldId,
            invalidMessage: invalidMessage,
            error: error,
            fieldOptions: fieldOptions
        }
    });
const $902163b5c2f843a6$export$91dd86462e5a4fd7 = 'FIELD_SAVE_SUCCESS_WITH_PASTED_CONTENT';
const $902163b5c2f843a6$export$29ce961a0b243e8e = (fieldId, fieldOptions, value, pastedContent)=>({
        type: $902163b5c2f843a6$export$91dd86462e5a4fd7,
        payload: {
            fieldId: fieldId,
            fieldOptions: fieldOptions,
            value: value,
            pastedContent: pastedContent
        }
    });
const $902163b5c2f843a6$export$c0f8e20d872095b5 = 'FIELD_UPDATED';
const $902163b5c2f843a6$export$8cd5b1a72497c9b1 = (fieldId, fieldValue, extraParams)=>({
        type: $902163b5c2f843a6$export$c0f8e20d872095b5,
        payload: {
            fieldId: fieldId,
            fieldValue: fieldValue,
            extraParams: extraParams
        }
    });
const $902163b5c2f843a6$export$124a5e893dae8156 = 'SWEET_STATE_FIELD_UPDATED';
const $902163b5c2f843a6$export$c19f432af75bfdb6 = (fieldId, fieldValue, extraParams)=>({
        type: $902163b5c2f843a6$export$124a5e893dae8156,
        payload: {
            fieldId: fieldId,
            fieldValue: fieldValue,
            extraParams: extraParams
        }
    });
const $902163b5c2f843a6$export$85eddf7a008960b8 = 'FIELD_CONFIRM_NEW_FIELD';
const $902163b5c2f843a6$export$5f6841555ecc90f6 = (fieldId, fieldValue)=>({
        type: $902163b5c2f843a6$export$85eddf7a008960b8,
        payload: {
            fieldId: fieldId,
            fieldValue: fieldValue
        }
    });
const $902163b5c2f843a6$export$d30636f57fb724cc = 'FIELD_CONFIRM_FAILURE_NEW_FIELD';
const $902163b5c2f843a6$export$404cd00ef34f434f = (fieldId, fieldValue)=>({
        type: $902163b5c2f843a6$export$d30636f57fb724cc,
        payload: {
            fieldId: fieldId,
            fieldValue: fieldValue
        }
    });
const $902163b5c2f843a6$export$4dd6a5a4f4f303ba = 'FIELD_UPDATE';
const $902163b5c2f843a6$export$8636ea797fb5a6d3 = (fieldId, fieldValue, fieldOptions)=>({
        type: $902163b5c2f843a6$export$4dd6a5a4f4f303ba,
        payload: {
            fieldId: fieldId,
            fieldValue: fieldValue,
            fieldOptions: fieldOptions
        }
    });

});

parcelRegister("4OMUb", function(module, exports) {

$parcel$export(module.exports, "allowedValuesSelector", () => $45b7026005e7c5b0$export$5ac0280ea0244f02);
$parcel$export(module.exports, "isEnabledForCurrentIssueSelector", () => $45b7026005e7c5b0$export$15db44bfb1731402);
$parcel$export(module.exports, "isEditableSelector", () => $45b7026005e7c5b0$export$c1ae0fa851a148a8);
$parcel$export(module.exports, "analyticsSelector", () => $45b7026005e7c5b0$export$fc884c4edbdade82);

var $df4Sl = parcelRequire("df4Sl");

var $f9RL0 = parcelRequire("f9RL0");

var $fokFV = parcelRequire("fokFV");

var $dv9do = parcelRequire("dv9do");
const $45b7026005e7c5b0$var$securitySelector = (0, $fokFV.fieldSelector)((0, $f9RL0.SECURITY));
const $45b7026005e7c5b0$export$c494199bca5463e3 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$45b7026005e7c5b0$var$securitySelector, (security)=>security && security.value || null);
const $45b7026005e7c5b0$export$5ac0280ea0244f02 = (0, $df4Sl.createSelector)($45b7026005e7c5b0$var$securitySelector, (security)=>security && security.allowedValues || []);
const $45b7026005e7c5b0$export$15db44bfb1731402 = (0, $df4Sl.createSelector)($45b7026005e7c5b0$export$c494199bca5463e3, $45b7026005e7c5b0$export$5ac0280ea0244f02, (value, allowedValues)=>value || allowedValues && allowedValues.length > 0);
const $45b7026005e7c5b0$export$c1ae0fa851a148a8 = (0, $df4Sl.createSelector)((0, $fokFV.isFieldEditableSelector)((0, $f9RL0.SECURITY)), (0, $dv9do.isSubtaskSelector), (isEditable, isSubtask)=>isEditable && !isSubtask);
const $45b7026005e7c5b0$export$fc884c4edbdade82 = (0, $df4Sl.createSelector)($45b7026005e7c5b0$export$c494199bca5463e3, $45b7026005e7c5b0$export$5ac0280ea0244f02, $45b7026005e7c5b0$export$c1ae0fa851a148a8, (value, allowedValues, isEditable)=>({
        hasSecurityLevel: value != null,
        securityLevelAllowedValuesCount: allowedValues.length,
        hasSecurityLevelEditPermissions: isEditable
    }));

});

parcelRegister("4TTMr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('fvVH7')
        ]);
        const value = parcelRequire('i8xDy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("fvVH7")
    ]).then(()=>parcelRequire('i8xDy'));
}

});


parcelRegister("4qrRK", function(module, exports) {

$parcel$export(module.exports, "ShareButton", () => $f4ea4ea5b5191ba7$export$e980dfbc2840e8bc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $jZDJX = parcelRequire("jZDJX");

var $dxcfv = parcelRequire("dxcfv");

var $chC1G = parcelRequire("chC1G");
var $fQ7Iw = parcelRequire("fQ7Iw");
const $f4ea4ea5b5191ba7$var$ShareButtonItem = ({ error: error = null, isLoading: isLoading })=>{
    const loggedInAccountId = (0, $dxcfv.useAccountId)();
    return !error && loggedInAccountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f4ea4ea5b5191ba7$var$ShareWrapper, null, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ7Iw.ShareLoadingPlaceholder), {
        triggerButtonStyle: "icon-only"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $chC1G.default), null)) : null;
};
const $f4ea4ea5b5191ba7$export$e980dfbc2840e8bc = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        isLoading: (0, $jZDJX.isLoadingSelector)(state),
        error: (0, $jZDJX.errorSelector)(state)
    }), {}))($f4ea4ea5b5191ba7$var$ShareButtonItem);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f4ea4ea5b5191ba7$var$ShareWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("chC1G", function(module, exports) {

$parcel$export(module.exports, "default", () => $42e49371cfa5f9e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $hJ992 = parcelRequire("hJ992");

var $fWeG1 = parcelRequire("fWeG1");

var $eSHKF = parcelRequire("eSHKF");

var $3Tszs = parcelRequire("3Tszs");

var $h6vrr = parcelRequire("h6vrr");

var $lhz9J = parcelRequire("lhz9J");

var $hzcvF = parcelRequire("hzcvF");

var $fQ7Iw = parcelRequire("fQ7Iw");

var $iSNkS = parcelRequire("iSNkS");

var $hfslX = parcelRequire("hfslX");
const $42e49371cfa5f9e7$export$669d2c201e84ea21 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ value: summary }] = (0, $fWeG1.useSummaryField)({
        issueKey: issueKey
    });
    const issueAri = (0, $3Tszs.useIssueAri)();
    const { shareIntegrations: shareIntegrations } = (0, $hfslX.useShareIntegrations)();
    const issueUrl = (0, $eSHKF.useIssueAbsoluteUrl)();
    const subProductId = (0, $h6vrr.useSubProductId)();
    const [shareDropdownTriggerCount, { resetComponent: resetComponent }] = (0, $lhz9J.useShareKeyboardShortcutsStore)();
    const prevShareShortcutTriggerCount = (0, $hzcvF.usePreviousWithInitial)(shareDropdownTriggerCount);
    // clean up - reset trigger when we unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>()=>resetComponent('shareDropdownTriggerCount'), []);
    let mode = 'off';
    if (shareIntegrations && shareIntegrations.length > 0) mode = (0, $79xbN.expValEquals)('pi_jira_share_to_slack_experiment', 'cohort', 'variation') ? 'menu' : 'tabs';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ7Iw.default), {
        integrationType: (0, $iSNkS.integrationTypes).BENTO_ISSUE,
        integrationMode: mode,
        objectAri: issueAri,
        productId: "jira",
        shareContentType: "issue",
        shareIntegrations: shareIntegrations,
        shareLink: issueUrl,
        shareTitle: summary ?? '',
        shouldAutoDismissFlag: false,
        // @ts-expect-error - TS2322 - Type 'SubProductId' is not assignable to type 'ProductId'.
        subProductId: subProductId,
        triggerButtonStyle: "icon-only",
        shareShortcutTriggerCount: shareDropdownTriggerCount,
        prevShareShortcutTriggerCount: prevShareShortcutTriggerCount
    });
};
var $42e49371cfa5f9e7$export$2e2bcd8739ae039 = $42e49371cfa5f9e7$export$669d2c201e84ea21;

});
parcelRegister("79xbN", function(module, exports) {

$parcel$export(module.exports, "expVal", () => $2783c762502a41a6$export$9db1624a8af791a4);
$parcel$export(module.exports, "expValEquals", () => $2783c762502a41a6$export$45abdb3f977b5b14);
$parcel$export(module.exports, "UNSAFE_noExposureExp", () => $2783c762502a41a6$export$677f9fa2e1ae6fec);

var $i49pH = parcelRequire("i49pH");

var $9bn72 = parcelRequire("9bn72");

var $3WQZN = parcelRequire("3WQZN");
function $2783c762502a41a6$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    // Handle vendorless scripts use of gates
    (0, $9bn72.UNSAFE_initIfNeeded)();
    const value = (0, $i49pH.default).getExperimentValue(experimentName, param, defaultValue);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $3WQZN.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $2783c762502a41a6$export$45abdb3f977b5b14(experimentName, param, comparatorValue) {
    return $2783c762502a41a6$export$9db1624a8af791a4(experimentName, param, null) === comparatorValue;
}
class $2783c762502a41a6$var$ExperimentConfig {
    constructor(experimentName, config){
        this._experimentName = experimentName;
        this._config = config;
    }
    get(key, defaultValue, typeGuard) {
        const value = this._config.get(key, defaultValue, typeGuard);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $3WQZN.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return value;
    }
}
const $2783c762502a41a6$var$cache = new Map();
function $2783c762502a41a6$export$677f9fa2e1ae6fec(experimentName) {
    let instance = $2783c762502a41a6$var$cache.get(experimentName);
    if (instance == null) {
        // Handle vendorless scripts use of gates
        (0, $9bn72.UNSAFE_initIfNeeded)();
        const config = (0, $i49pH.default).getExperiment(experimentName, {
            fireExperimentExposure: false
        });
        const fireExposure = ()=>(0, $i49pH.default).manuallyLogExperimentExposure(experimentName);
        instance = [
            new $2783c762502a41a6$var$ExperimentConfig(experimentName, config),
            fireExposure
        ];
        $2783c762502a41a6$var$cache.set(experimentName, instance);
    }
    return instance;
}

});

parcelRegister("eSHKF", function(module, exports) {

$parcel$export(module.exports, "useIssueAbsoluteUrl", () => $be57dfe48dfb2180$export$58cb76f1bb98531f);

var $hJ992 = parcelRequire("hJ992");
const $be57dfe48dfb2180$export$58cb76f1bb98531f = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    return `${window.location.protocol}//${window.location.host}/browse/${issueKey}`;
};

});

parcelRegister("3Tszs", function(module, exports) {

$parcel$export(module.exports, "useIssueAri", () => $81b7cb64c6be6c5d$export$f56776f1b409b56d);

var $hJ992 = parcelRequire("hJ992");

var $huI7r = parcelRequire("huI7r");

var $dWLk9 = parcelRequire("dWLk9");
const $81b7cb64c6be6c5d$export$f56776f1b409b56d = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const issueId = (0, $hJ992.useIssueId)();
    return (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ?? ''
    });
};

});

parcelRegister("h6vrr", function(module, exports) {

$parcel$export(module.exports, "useSubProductId", () => $9ac565dd59cbe965$export$9a0ac6a88a50b5a3);

var $7ZZxN = parcelRequire("7ZZxN");

var $hJ992 = parcelRequire("hJ992");

var $guDlK = parcelRequire("guDlK");
const $9ac565dd59cbe965$export$9a0ac6a88a50b5a3 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    return (0, $7ZZxN.projectTypeToCanonicalId)(projectType ?? null);
};

});
parcelRegister("guDlK", function(module, exports) {

$parcel$export(module.exports, "useProjectKey", () => $598d4d607d97d3ec$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectContextActions", () => $598d4d607d97d3ec$export$bd73624ca941f105);
$parcel$export(module.exports, "useProjectType", () => $598d4d607d97d3ec$export$6de29d851c914935);
$parcel$export(module.exports, "useProjectContext", () => $598d4d607d97d3ec$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useApplication", () => $598d4d607d97d3ec$export$aaf75bb403fe1fb5);
$parcel$export(module.exports, "useEdition", () => $598d4d607d97d3ec$export$d56c02945cf5a9e5);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $598d4d607d97d3ec$export$524ef4f6102ed540);
$parcel$export(module.exports, "useIsClassicProject", () => $598d4d607d97d3ec$export$e2cf96f40a8867ce);
$parcel$export(module.exports, "useProjectId", () => $598d4d607d97d3ec$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectStatus", () => $598d4d607d97d3ec$export$30f16f2782a4113b);
$parcel$export(module.exports, "useProjectConfiguration", () => $598d4d607d97d3ec$export$af19ad68b52fa1a6);
$parcel$export(module.exports, "useProjectIssueTypes", () => $598d4d607d97d3ec$export$80bef597b440cf71);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3FyZ4 = parcelRequire("3FyZ4");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");
var $6vrw7 = parcelRequire("6vrw7");

var $gd0Sp = parcelRequire("gd0Sp");

var $lbuGg = parcelRequire("lbuGg");

var $9ZB9O = parcelRequire("9ZB9O");
const $598d4d607d97d3ec$export$f87be37f8e8be65 = (issueKey)=>(0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
const $598d4d607d97d3ec$export$bd73624ca941f105 = ()=>{
    const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, $lbuGg.useProjectContextActionStore)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setProjectContext: setProjectContext,
            mergeProjectProperty: mergeProjectProperty
        }), [
        setProjectContext,
        mergeProjectProperty
    ]);
    return [
        null,
        actions
    ];
};
const $598d4d607d97d3ec$export$6de29d851c914935 = (projectKey)=>{
    const [projectType] = (0, $lbuGg.useProjectContextProjectTypeStore)({
        projectKey: projectKey
    });
    return projectType;
};
const $598d4d607d97d3ec$export$8f31c2503e1efa93 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext;
};
const $598d4d607d97d3ec$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
    const projectType = $598d4d607d97d3ec$export$6de29d851c914935(projectKey);
    if (projectType === undefined) {
        if ((0, $1ybV0.ff)('ken-432-missing-project-key-log_hr7zv')) (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            client.getInstance().sendTrackEvent({
                action: 'project-type-investigation',
                attributes: {
                    message: 'projectType was missing inside the hook'
                },
                actionSubject: 'project-context',
                source: 'project-context-service'
            });
        });
        if (failSafely) return undefined;
        throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
    }
    return (0, $eIp1n.getApplicationForProject)(projectType);
};
const $598d4d607d97d3ec$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
    const { appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const application = $598d4d607d97d3ec$export$aaf75bb403fe1fb5(projectKey, failSafely);
    if (!application) return undefined;
    return (0, $6WXNs.getEdition)(application, appEditions);
};
const $598d4d607d97d3ec$export$524ef4f6102ed540 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.isSimplified || false;
};
const $598d4d607d97d3ec$export$e2cf96f40a8867ce = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return !projectContext?.isSimplified;
};
const $598d4d607d97d3ec$export$16d1475ed6c26568 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectId;
};
const $598d4d607d97d3ec$export$30f16f2782a4113b = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectStatus;
};
const $598d4d607d97d3ec$export$af19ad68b52fa1a6 = (projectKey)=>{
    const projectType = $598d4d607d97d3ec$export$6de29d851c914935(projectKey);
    const isSimplified = $598d4d607d97d3ec$export$524ef4f6102ed540(projectKey);
    return (0, $9ZB9O.getIssueConfiguration)({
        isSimplified: isSimplified,
        projectType: projectType
    });
};
const $598d4d607d97d3ec$export$654dd2c557853fbe = (projectKey)=>{
    const [projectName] = (0, $lbuGg.useProjectContextProjectNameStore)({
        projectKey: projectKey
    });
    return projectName;
};
const $598d4d607d97d3ec$export$80bef597b440cf71 = (projectKey)=>{
    const [issueTypes] = (0, $lbuGg.useProjectContextIssueTypesStore)({
        projectKey: projectKey
    });
    return issueTypes;
};

});
parcelRegister("lbuGg", function(module, exports) {

$parcel$export(module.exports, "useProjectContextActionStore", () => $4715ac6bc4ce2fb7$export$9afb89c1fe103bbe);
$parcel$export(module.exports, "useProjectContextStore", () => $4715ac6bc4ce2fb7$export$8b09478b33186ec);
$parcel$export(module.exports, "useProjectContextProjectTypeStore", () => $4715ac6bc4ce2fb7$export$f2e1ed3b2b4707cb);
$parcel$export(module.exports, "useProjectContextProjectNameStore", () => $4715ac6bc4ce2fb7$export$9469fde70658518);
$parcel$export(module.exports, "useProjectContextIssueTypesStore", () => $4715ac6bc4ce2fb7$export$f73e9904779f6be5);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $bAXOf = parcelRequire("bAXOf");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4715ac6bc4ce2fb7$var$initialState = {};
const $4715ac6bc4ce2fb7$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'project-context',
    initialState: $4715ac6bc4ce2fb7$var$initialState,
    actions: $bAXOf
});
const $4715ac6bc4ce2fb7$export$9afb89c1fe103bbe = (0, $ggKAj.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: null
});
const $4715ac6bc4ce2fb7$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
const $4715ac6bc4ce2fb7$export$8b09478b33186ec = (0, $ggKAj.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectContext
});
const $4715ac6bc4ce2fb7$var$getProjectType = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectType;
};
const $4715ac6bc4ce2fb7$export$f2e1ed3b2b4707cb = (0, $ggKAj.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectType
});
const $4715ac6bc4ce2fb7$var$getProjectName = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectName;
};
const $4715ac6bc4ce2fb7$export$9469fde70658518 = (0, $ggKAj.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectName
});
const $4715ac6bc4ce2fb7$var$getIssueTypes = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.issueTypes;
};
const $4715ac6bc4ce2fb7$export$f73e9904779f6be5 = (0, $ggKAj.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getIssueTypes
});

});
parcelRegister("bAXOf", function(module, exports) {

$parcel$export(module.exports, "setProjectContext", () => $f8fc64b164fe014a$export$d64151aab9ae5f09);
$parcel$export(module.exports, "mergeProjectProperty", () => $f8fc64b164fe014a$export$78f1c6052937615f);
const $f8fc64b164fe014a$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: projectContext
        });
    };
const $f8fc64b164fe014a$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentProjectContext = currentState[key];
        const newProjectContext = {
            ...currentProjectContext,
            ...projectContext
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: newProjectContext
        });
    };

});


parcelRegister("9ZB9O", function(module, exports) {

$parcel$export(module.exports, "getIssueConfiguration", () => $78bf57e6f575c3aa$export$902f6c5cc939598a);

var $2wUFy = parcelRequire("2wUFy");

var $7ZZxN = parcelRequire("7ZZxN");
const $78bf57e6f575c3aa$export$cdbd1eb3b05729e0 = 'flagActions';
const $78bf57e6f575c3aa$export$c161a774ec2e7e56 = 'cardCoverActions';
const $78bf57e6f575c3aa$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $78bf57e6f575c3aa$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $2wUFy.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $2wUFy.default).SOFTWARE_ISSUE,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $2wUFy.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0,
            $78bf57e6f575c3aa$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $2wUFy.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $2wUFy.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $78bf57e6f575c3aa$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $2wUFy.default).MOBILE_ISSUE,
        issueActions: []
    });
const $78bf57e6f575c3aa$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $2wUFy.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (config.isSimplified) return $78bf57e6f575c3aa$export$aebf676dfa727a1c();
            return $78bf57e6f575c3aa$export$27e0678365e5dcff();
        case 0, $7ZZxN.CORE_PROJECT:
            return $78bf57e6f575c3aa$export$381ce08838c53afa();
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return $78bf57e6f575c3aa$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $78bf57e6f575c3aa$export$27e0678365e5dcff();
    }
    return $78bf57e6f575c3aa$export$27e0678365e5dcff();
};

});



parcelRegister("lhz9J", function(module, exports) {

$parcel$export(module.exports, "IssueKeyboardShortcutsContainer", () => $75c0db4390733bd0$export$6110051b47239bb2);
$parcel$export(module.exports, "useShareKeyboardShortcutsStore", () => $75c0db4390733bd0$export$6f95e0a3a3615217);
$parcel$export(module.exports, "useIssueScrollKeyboardShortcutsStore", () => $75c0db4390733bd0$export$6141b8d2e32970a2);
$parcel$export(module.exports, "useIssueKeyboardShortcutsActions", () => $75c0db4390733bd0$export$2f06a2988f9cccbb);
$parcel$export(module.exports, "useStatusKeyboardShortcutsStore", () => $75c0db4390733bd0$export$ee47ae43f405aaca);
$parcel$export(module.exports, "useFocusedPanelKeyboardShortcutsStore", () => $75c0db4390733bd0$export$700a6326aa73644c);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

const $75c0db4390733bd0$var$initialState = {
    shareDropdownTriggerCount: 0,
    issueScrollTriggerCount: 0,
    focusedPanel: 'LEFT',
    [(0, $c51eac624bf70214$export$823ced5880c3b947)]: 0
};
const $75c0db4390733bd0$var$actions = {
    triggerComponent: (property)=>({ setState: setState, getState: getState })=>{
            const current = getState()[property];
            setState({
                [property]: current + 1
            });
        },
    resetComponent: (property)=>({ setState: setState })=>{
            setState({
                [property]: 0
            });
        },
    triggerFocusedPanel: (panel)=>({ setState: setState, getState: getState })=>{
            const current = getState().issueScrollTriggerCount;
            setState({
                focusedPanel: panel,
                issueScrollTriggerCount: current + 1
            });
        }
};
const $75c0db4390733bd0$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    name: 'keyboard-shortcuts',
    initialState: $75c0db4390733bd0$var$initialState,
    actions: $75c0db4390733bd0$var$actions
});
const $75c0db4390733bd0$export$838ce57976d13393 = (0, $dYfll.createSubscriber)($75c0db4390733bd0$export$390f32400eaf98c9);
const $75c0db4390733bd0$export$6110051b47239bb2 = (0, $heB5U.createContainer)($75c0db4390733bd0$export$390f32400eaf98c9);
const $75c0db4390733bd0$export$6f95e0a3a3615217 = (0, $ggKAj.createHook)($75c0db4390733bd0$export$390f32400eaf98c9, {
    selector: (state)=>state.shareDropdownTriggerCount
});
const $75c0db4390733bd0$export$6141b8d2e32970a2 = (0, $ggKAj.createHook)($75c0db4390733bd0$export$390f32400eaf98c9, {
    selector: (state)=>state.issueScrollTriggerCount
});
const $75c0db4390733bd0$export$2f06a2988f9cccbb = (0, $ggKAj.createHook)($75c0db4390733bd0$export$390f32400eaf98c9, {
    selector: null
});
const $75c0db4390733bd0$export$ee47ae43f405aaca = (0, $ggKAj.createHook)($75c0db4390733bd0$export$390f32400eaf98c9, {
    selector: (state)=>state[0, $c51eac624bf70214$export$823ced5880c3b947]
});
const $75c0db4390733bd0$export$700a6326aa73644c = (0, $ggKAj.createHook)($75c0db4390733bd0$export$390f32400eaf98c9, {
    selector: (state)=>state.focusedPanel
});
const $75c0db4390733bd0$export$5f9028243a1c2cee = (0, $ggKAj.createHook)($75c0db4390733bd0$export$390f32400eaf98c9, {
    selector: (state)=>state
});

});
// Bento has a high priority, almost like a modal
const $c51eac624bf70214$export$5a8469c8c819903a = 999;
const $c51eac624bf70214$export$2d6fe2e6cc62871b = 'a';
const $c51eac624bf70214$export$11f922ab4c2bc975 = 'd';
const $c51eac624bf70214$export$d9f01f9198f4f46d = 'i';
const $c51eac624bf70214$export$a3a1bc4fb02429c0 = 'l';
const $c51eac624bf70214$export$cd076067c17f863b = 'm';
const $c51eac624bf70214$export$2a8b4d6d636c136a = 'q';
const $c51eac624bf70214$export$8a7d6f43ad50b2bd = 'S';
const $c51eac624bf70214$export$b8edcdd7ea916239 = 'arrowleft';
const $c51eac624bf70214$export$b456fa9fa3286243 = 'arrowright';
const $c51eac624bf70214$export$32994802cb4c7299 = 'arrowup';
const $c51eac624bf70214$export$1087a95d873a944d = 'arrowdown';
const $c51eac624bf70214$export$ea7513f4d878349f = '.';
const $c51eac624bf70214$export$b79eb5bea471245c = 'j';
const $c51eac624bf70214$export$e83c62092c76344b = 'k';
const $c51eac624bf70214$export$7a320fd695b170f = 'n';
const $c51eac624bf70214$export$cb37104427efce2a = 'p';
const $c51eac624bf70214$export$823ced5880c3b947 = 'statusDropdownTriggerCount';
const $c51eac624bf70214$export$6ecc0ff22f952299 = 'shift+s';


parcelRegister("hzcvF", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $42dfce76254176f5$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousWithInitial", () => $42dfce76254176f5$export$23fbbb2e62c4a911);

var $eUqFw = parcelRequire("eUqFw");
const $42dfce76254176f5$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $42dfce76254176f5$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $eUqFw.useRef)(value);
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});

parcelRegister("fQ7Iw", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $eb292e1f91805d5c$export$5619d05bf511476b);
$parcel$export(module.exports, "default", () => $eb292e1f91805d5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $dFWNP = parcelRequire("dFWNP");

var $PdmhA = parcelRequire("PdmhA");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $8nUKh = parcelRequire("8nUKh");

const $eb292e1f91805d5c$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
            size: "medium",
            label: formatMessage((0, $8nUKh.messages).shareTriggerButtonText),
            primaryColor: `var(--ds-icon, ${(0, $PdmhA).N30})`
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $8nUKh.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $eb292e1f91805d5c$var$ShareButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("9XSbA")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb292e1f91805d5c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$var$ShareButton, props)));

});
parcelRegister("dFWNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f4cb7ac67043f68$var$_react = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9f4cb7ac67043f68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9f4cb7ac67043f68$var$ShareIcon = (props)=>/*#__PURE__*/ $9f4cb7ac67043f68$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 15a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2zm12-4a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2zm0 14a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2z" fill-rule="nonzero"/><path d="M7 13.562l8.66 5 1-1.732-8.66-5z"/><path d="M7 10.83l1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props));
$9f4cb7ac67043f68$var$ShareIcon.displayName = 'ShareIcon';
var $9f4cb7ac67043f68$var$_default = $9f4cb7ac67043f68$var$ShareIcon;
module.exports.default = $9f4cb7ac67043f68$var$_default;

});

parcelRegister("8nUKh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c445af617ae0da86$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c445af617ae0da86$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("9XSbA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('dsiAd'),
            load('h2MrD'),
            load('bYT2S'),
            load('2xQrm')
        ]);
        const value = parcelRequire('iHQJU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("dsiAd"),
        load("h2MrD"),
        load("bYT2S"),
        load("2xQrm")
    ]).then(()=>parcelRequire('iHQJU'));
}

});


parcelRegister("iSNkS", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $60586429dc17d610$export$a7359bcfb0ca8e98);
const $60586429dc17d610$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments'
};

});

parcelRegister("hfslX", function(module, exports) {

$parcel$export(module.exports, "useShareIntegrations", () => $b36423e50cabd739$export$58a9f7a7ab3466f4);

var $eUqFw = parcelRequire("eUqFw");

var $4K830 = parcelRequire("4K830");

var $8q0kG = parcelRequire("8q0kG");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $dWLk9 = parcelRequire("dWLk9");

var $gWV0M = parcelRequire("gWV0M");
var $ljgr5 = parcelRequire("ljgr5");
const $b36423e50cabd739$export$58a9f7a7ab3466f4 = (shareContentType)=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const ineligibilityReasons = (0, $eUqFw.useMemo)(()=>{
        const reasons = [];
        if ((0, $8q0kG.default)()) reasons.push('notDesktop');
        // All Share to Slack must be disabled in FedRAMP environment as
        // Slack Jira Integration app is not available in FedRAMP
        if ((0, $1ybV0.ff)('confluence.frontend.growth.fedramp-check-isolation') && (0, $4K830.isFedRamp)()) reasons.push('isFedRAMP');
        return reasons;
    }, []);
    const shareIntegrations = (0, $eUqFw.useMemo)(()=>ineligibilityReasons.length === 0 ? [
            {
                type: 'Slack',
                Icon: (0, $ljgr5.default),
                Content: ({ onClose: onClose, changeTab: changeTab })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWV0M.ShareToSlack), {
                        showFlag: showFlag,
                        product: "jira",
                        channel: "productAnalytics",
                        onClose: onClose,
                        cloudId: cloudId,
                        changeTab: changeTab,
                        shareContentType: shareContentType
                    })
            }
        ] : [], [
        ineligibilityReasons.length,
        showFlag,
        cloudId,
        shareContentType
    ]);
    return {
        shareIntegrations: shareIntegrations
    };
};

});
parcelRegister("8q0kG", function(module, exports) {

$parcel$export(module.exports, "isSupportedUserAgent", () => $6d434a87228f5691$export$2b0f0a801c573b06);
$parcel$export(module.exports, "isAndroidUserAgent", () => $6d434a87228f5691$export$6053d3a1e6477e0f);
$parcel$export(module.exports, "isTabletUserAgent", () => $6d434a87228f5691$export$a33e336659bb3eb6);
$parcel$export(module.exports, "shouldShowReturnToMobileBanner", () => $6d434a87228f5691$export$604401c0b63e5273);
$parcel$export(module.exports, "shouldShowDismissButton", () => $6d434a87228f5691$export$5ad7f0440f4fd036);
$parcel$export(module.exports, "determineOperatingSystemAttribute", () => $6d434a87228f5691$export$d9f2497f8d710783);
$parcel$export(module.exports, "default", () => $6d434a87228f5691$export$2e2bcd8739ae039);

var $aqZcy = parcelRequire("aqZcy");
/*
This logic was ported from MobileUtils class from jira monolith to 
provide the same conditions for checking whether the user agent is mobile or not.
*/ const $6d434a87228f5691$var$DESKTOP_SWITCH_COOKIE_KEY = 'jira.mobile.desktop.switch';
const $6d434a87228f5691$var$ANDROID_CHROME_USER_AGENT = new RegExp('Chrome/[.\\d]* Mobile');
const $6d434a87228f5691$var$OLD_ANDROID_USER_AGENT = new RegExp('Linux;(?: U;)? Android (?:[23]\\.\\d|4\\.0\\.[12])');
const $6d434a87228f5691$var$MOBILE_USER_AGENT = new RegExp('(iPhone;|iPhone Simulator;|iPad;|iPod;|iPod touch;|Linux;(?: U;)? Android)');
const $6d434a87228f5691$var$MOBILE_STRING_IN_USER_AGENT = new RegExp('Mobile');
const $6d434a87228f5691$var$IPAD_USER_AGENT = new RegExp('iPad;');
const $6d434a87228f5691$var$IOS_USER_AGENT = new RegExp('(iPhone;|iPad;|iPod;)');
const $6d434a87228f5691$export$2b0f0a801c573b06 = ()=>{
    if (!navigator || !navigator.userAgent || !navigator.userAgent.length) return false;
    return $6d434a87228f5691$var$ANDROID_CHROME_USER_AGENT.test(navigator.userAgent) || $6d434a87228f5691$var$MOBILE_USER_AGENT.test(navigator.userAgent) && !$6d434a87228f5691$var$OLD_ANDROID_USER_AGENT.test(navigator.userAgent);
};
const $6d434a87228f5691$export$6053d3a1e6477e0f = ()=>$6d434a87228f5691$var$ANDROID_CHROME_USER_AGENT.test(navigator.userAgent) || $6d434a87228f5691$var$OLD_ANDROID_USER_AGENT.test(navigator.userAgent);
const $6d434a87228f5691$export$b4161aa2f4036482 = ()=>$6d434a87228f5691$var$IOS_USER_AGENT.test(navigator.userAgent);
const $6d434a87228f5691$export$a33e336659bb3eb6 = ()=>{
    if (!navigator || !navigator.userAgent || !navigator.userAgent.length) return false;
    return $6d434a87228f5691$var$IPAD_USER_AGENT.test(navigator.userAgent) || $6d434a87228f5691$export$6053d3a1e6477e0f() && !$6d434a87228f5691$var$MOBILE_STRING_IN_USER_AGENT.test(navigator.userAgent);
};
const $6d434a87228f5691$var$isDesktopSwitchEnabled = ()=>(0, $aqZcy.getCookie)($6d434a87228f5691$var$DESKTOP_SWITCH_COOKIE_KEY) === 'true';
const $6d434a87228f5691$var$isMobileUserAgent = ()=>$6d434a87228f5691$export$2b0f0a801c573b06() && !$6d434a87228f5691$var$isDesktopSwitchEnabled();
const $6d434a87228f5691$export$604401c0b63e5273 = ()=>$6d434a87228f5691$export$2b0f0a801c573b06();
const $6d434a87228f5691$export$5ad7f0440f4fd036 = ()=>$6d434a87228f5691$export$604401c0b63e5273() && $6d434a87228f5691$export$a33e336659bb3eb6();
const $6d434a87228f5691$export$d9f2497f8d710783 = ()=>{
    if ($6d434a87228f5691$export$b4161aa2f4036482()) return 'ios';
    if ($6d434a87228f5691$export$6053d3a1e6477e0f()) return 'android';
    return 'other';
};
var $6d434a87228f5691$export$2e2bcd8739ae039 = $6d434a87228f5691$var$isMobileUserAgent;

});
parcelRegister("aqZcy", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $5345d14aecffdbc4$export$4be65e66cfa2648a);

var $k4bKv = parcelRequire("k4bKv");
function $5345d14aecffdbc4$export$4be65e66cfa2648a(key) {
    return key ? (0, $k4bKv.getCookie)(key) : (0, $k4bKv.getCookie)();
}

});
parcelRegister("k4bKv", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $e9bd4b7e86b1280b$export$4be65e66cfa2648a);

var $M2DFp = parcelRequire("M2DFp");

var $XHGTv = parcelRequire("XHGTv");

var $5mY09 = parcelRequire("5mY09");

var $8nVWJ = parcelRequire("8nVWJ");
function $e9bd4b7e86b1280b$export$4be65e66cfa2648a(key) {
    try {
        if ((0, $XHGTv.getBooleanFF)('platform.moonjelly.browser-storage-controls')) (0, $5mY09.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))).get();
    } catch (e) {
        (0, $8nVWJ.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});
parcelRegister("5mY09", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsClient", () => $3e8d8cd8a57e154c$export$fde53e78fd93a54d);
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $3e8d8cd8a57e154c$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUIEvent", () => $3e8d8cd8a57e154c$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $3e8d8cd8a57e154c$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $3e8d8cd8a57e154c$export$1ba525b8a711eaac);

var $aYU4Z = parcelRequire("aYU4Z");
var $hRleJ = parcelRequire("hRleJ");

var $XHGTv = parcelRequire("XHGTv");

var $2SDTs = parcelRequire("2SDTs");

var $8nVWJ = parcelRequire("8nVWJ");

var $1Xs0X = parcelRequire("1Xs0X");

var $8iPDg = parcelRequire("8iPDg");
const $3e8d8cd8a57e154c$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.')) return (0, $hRleJ.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $hRleJ.envType).DEV;
    return (0, $hRleJ.envType).PROD;
};
const $3e8d8cd8a57e154c$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $3e8d8cd8a57e154c$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $3e8d8cd8a57e154c$export$78d7c0236b4fece9(pathname);
    return {
        domain: `${origin}${productPath}`,
        product: productPath.slice(1)
    };
};
const $3e8d8cd8a57e154c$var$decorateEventAttributes = (attributes)=>{
    var _getBscGlobalState$pr, _getBscGlobalState$pr2;
    const { domain: domain, product: product } = $3e8d8cd8a57e154c$export$fce3dd735e04d566();
    return {
        // eslint-disable-next-line @atlaskit/platform/no-invalid-feature-flag-usage
        featureFlagOn: (0, $XHGTv.getBooleanFF)('platform.moonjelly.browser-storage-controls'),
        packageName: $1Xs0X.packageName,
        packageVersion: $1Xs0X.packageVersion,
        domain: domain,
        product: (_getBscGlobalState$pr = (_getBscGlobalState$pr2 = (0, $2SDTs.getBscGlobalState)().product) === null || _getBscGlobalState$pr2 === void 0 ? void 0 : _getBscGlobalState$pr2.toLowerCase()) !== null && _getBscGlobalState$pr !== void 0 ? _getBscGlobalState$pr : product,
        ...attributes && attributes
    };
};
const $3e8d8cd8a57e154c$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $2SDTs.getBscGlobalState)().analyticsEnabled) instance = new (0, $aYU4Z.default)({
                env: $3e8d8cd8a57e154c$var$getEnvironment(),
                product: 'atlassianCookies'
            }, {
                // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                // When set to false, the client will use a stargate proxy for the current URL to send events
                // to GAS. Said another way:
                // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                // false => events are sent to <the current domain>/gasv3/api/v1/batch
                //
                // By default, this should be set to false.  If you need to validate that analytics events
                // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                // won't be able to proxy to GAS via stargate.
                useLegacyUrl: false,
                disableCookiePersistence: true
            });
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            (0, $8nVWJ.Logger).error(`Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $2SDTs.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $3e8d8cd8a57e154c$export$5bfe55348e7aebc1(properties) {
    (0, $8iPDg.withAnalyticsEventSampling)(properties.action, ()=>{
        var _getAnalyticsClient;
        return (_getAnalyticsClient = $3e8d8cd8a57e154c$export$fde53e78fd93a54d()) === null || _getAnalyticsClient === void 0 ? void 0 : _getAnalyticsClient.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $3e8d8cd8a57e154c$var$decorateEventAttributes(properties.attributes)
        });
    });
}
function $3e8d8cd8a57e154c$export$1aecf263098db667(properties) {
    var _getAnalyticsClient2;
    (_getAnalyticsClient2 = $3e8d8cd8a57e154c$export$fde53e78fd93a54d()) === null || _getAnalyticsClient2 === void 0 || _getAnalyticsClient2.sendUIEvent({
        ...properties,
        attributes: $3e8d8cd8a57e154c$var$decorateEventAttributes(properties.attributes)
    });
}
function $3e8d8cd8a57e154c$export$22a3b1671f38a193(properties) {
    var _getAnalyticsClient3;
    (_getAnalyticsClient3 = $3e8d8cd8a57e154c$export$fde53e78fd93a54d()) === null || _getAnalyticsClient3 === void 0 || _getAnalyticsClient3.sendScreenEvent({
        ...properties,
        attributes: $3e8d8cd8a57e154c$var$decorateEventAttributes(properties.attributes)
    });
}
function $3e8d8cd8a57e154c$export$1ba525b8a711eaac(properties) {
    var _getAnalyticsClient4;
    (_getAnalyticsClient4 = $3e8d8cd8a57e154c$export$fde53e78fd93a54d()) === null || _getAnalyticsClient4 === void 0 || _getAnalyticsClient4.sendTrackEvent({
        ...properties,
        attributes: $3e8d8cd8a57e154c$var$decorateEventAttributes(properties.attributes)
    });
}

});
parcelRegister("2SDTs", function(module, exports) {

$parcel$export(module.exports, "getBscGlobalState", () => $218f91e81d89a291$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "initializeGlobalState", () => $218f91e81d89a291$export$882c4530c58781d8);
let $218f91e81d89a291$var$localAnalyticsEnabled;
let $218f91e81d89a291$var$localProduct;
const $218f91e81d89a291$export$3b78a1ea01f5ec28 = ()=>{
    if ($218f91e81d89a291$var$localAnalyticsEnabled == null) $218f91e81d89a291$var$localAnalyticsEnabled = true;
    return {
        analyticsEnabled: $218f91e81d89a291$var$localAnalyticsEnabled,
        product: $218f91e81d89a291$var$localProduct
    };
};
const $218f91e81d89a291$export$882c4530c58781d8 = ({ analyticsEnabled: analyticsEnabled = true, product: product = 'NONE' } = {})=>{
    $218f91e81d89a291$var$localAnalyticsEnabled = analyticsEnabled;
    $218f91e81d89a291$var$localProduct = product;
};
const $218f91e81d89a291$export$ac7c2edd09656c05 = ()=>{
    $218f91e81d89a291$var$localAnalyticsEnabled = undefined;
    $218f91e81d89a291$var$localProduct = undefined;
};

});

parcelRegister("8nVWJ", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $61ad6ba52a9e5843$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $5mY09 = parcelRequire("5mY09");
const $61ad6ba52a9e5843$var$LOG_PREFIX = '[browser-storage-controls]';
class $61ad6ba52a9e5843$export$efa9a398d6368992 {
    static info(message, metadata) {
        console.log(`${$61ad6ba52a9e5843$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static error(message, metadata) {
        console.error(`${$61ad6ba52a9e5843$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            (0, $5mY09.sendPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata ? JSON.stringify(metadata) : '');
    }
    static warn(message, metadata) {
        console.warn(`${$61ad6ba52a9e5843$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
}

});

parcelRegister("1Xs0X", function(module, exports) {

$parcel$export(module.exports, "packageName", () => $16d10839711d7081$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $16d10839711d7081$export$91546b032799aa40);
const $16d10839711d7081$export$9345d7360ffe0722 = "@atlassian/browser-storage-controls";
const $16d10839711d7081$export$91546b032799aa40 = "2.8.4";

});

parcelRegister("8iPDg", function(module, exports) {

$parcel$export(module.exports, "withAnalyticsEventSampling", () => $60b80e4377618ef6$export$67b6e87f323cb6ad);

var $d6j3n = parcelRequire("d6j3n");

var $jyzhV = parcelRequire("jyzhV");

var $aynK1 = parcelRequire("aynK1");
const $60b80e4377618ef6$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $60b80e4377618ef6$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $60b80e4377618ef6$var$loadSamplingConfig() {
    if ((0, $d6j3n.cache).cachedSamplingConfig) return (0, $d6j3n.cache).cachedSamplingConfig;
    if ((0, $jyzhV.isSSR)()) return undefined;
    const controlsData = await (0, $aynK1.loadStorageControlsData)();
    const analyticsSamplingRatioConfigs = controlsData === null || controlsData === void 0 ? void 0 : controlsData.analyticsSamplingRatio;
    (0, $d6j3n.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $60b80e4377618ef6$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($60b80e4377618ef6$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $60b80e4377618ef6$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $60b80e4377618ef6$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig !== null && remoteSamplingConfig !== void 0 ? remoteSamplingConfig : $60b80e4377618ef6$export$1138592b3c099377;
    const samplingRatio = (samplingConfig === null || samplingConfig === void 0 ? void 0 : samplingConfig[analyticsEventKey]) !== undefined ? samplingConfig[analyticsEventKey] : $60b80e4377618ef6$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $60b80e4377618ef6$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
        ________
       /\       \
      /()\   ()  \
     /    \_______\
     \    /()     /
      \()/   ()  /
       \/_____()/
   */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $60b80e4377618ef6$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $60b80e4377618ef6$export$b286f5e8716d11ad(analyticsEventKey);
    $60b80e4377618ef6$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("d6j3n", function(module, exports) {

$parcel$export(module.exports, "cache", () => $989a9d835e85a46c$export$69a3209f1a06c04d);

var $b7x1y = parcelRequire("b7x1y");
const $989a9d835e85a46c$export$69a3209f1a06c04d = new (0, $b7x1y.CachedSamplingConfig)();

});
parcelRegister("b7x1y", function(module, exports) {

$parcel$export(module.exports, "CachedSamplingConfig", () => $8189f708c11aed60$export$b886edaf6623554a);
// The categories.json file is already configured to be cached by the browser, but for this sampling
// config, it's even less important to manage stale values. Most BSC API interaction is done on
// application startup.  So we may as well cache this in memory once per app load and not retrieve
// it from local disk for each event emitted.
class $8189f708c11aed60$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

});


parcelRegister("jyzhV", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $e3cc90c23182ed8f$export$48d7c418edadb60c);

var $aYU4Z = parcelRequire("aYU4Z");

var $XHGTv = parcelRequire("XHGTv");

var $8nVWJ = parcelRequire("8nVWJ");
const $e3cc90c23182ed8f$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $XHGTv.getBooleanFF);
    const isMissingAnalyticsWebClient = !Boolean((0, $aYU4Z.default));
    // When rendering from the server document/window may not be available
    if (isMissingNecessaryBrowserUtils) (0, $8nVWJ.Logger).warn('Browser context is not available.');
    if (isMissingBooleanFF) (0, $8nVWJ.Logger).warn('Platform Feature Flag library is not available');
    if (!(0, $aYU4Z.default)) (0, $8nVWJ.Logger).warn('analytics-web-client is not available');
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});

parcelRegister("aynK1", function(module, exports) {

$parcel$export(module.exports, "loadStorageControlsData", () => $7aef7ee2a0c69006$export$4dbb842f063ffea4);

var $8nVWJ = parcelRequire("8nVWJ");
const $7aef7ee2a0c69006$export$ab0619f627170401 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';
/**
 * Cache variable for storing categorized cookies cache
 */ let $7aef7ee2a0c69006$var$localResponseCache;
/**
 * Cache variable for storing a promise that's been fired by a different invocation of loadStorageControls
 *
 * Allows for many invocations to happen simultaneously, and for only one fetch to go out
 */ let $7aef7ee2a0c69006$var$localResponsePromiseCache;
/**
 * Cache variable for storing the promise returned from the response object's json method
 *
 * Ensures we don't invoke response.json multiple times
 */ let $7aef7ee2a0c69006$var$localResponseJsonPromiseCache;
const $7aef7ee2a0c69006$export$19bc72f5ccd901a6 = ()=>{
    $7aef7ee2a0c69006$var$localResponseCache = undefined;
    $7aef7ee2a0c69006$var$localResponsePromiseCache = undefined;
    $7aef7ee2a0c69006$var$localResponseJsonPromiseCache = undefined;
};
/**
 * Unpacks the response promise from the categories CDN
 *
 * errors if that request was unsuccessful, returns the categories data otherwise
 *
 */ const $7aef7ee2a0c69006$var$handleCategoriesResponse = async (responsePromise)=>{
    if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
    const response = await responsePromise;
    if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
    // Checks if we've already fired the response.json() promise
    $7aef7ee2a0c69006$var$localResponseJsonPromiseCache = $7aef7ee2a0c69006$var$localResponseJsonPromiseCache || (response === null || response === void 0 ? void 0 : response.json());
    return $7aef7ee2a0c69006$var$localResponseJsonPromiseCache;
};
const $7aef7ee2a0c69006$export$4dbb842f063ffea4 = async ()=>{
    if ($7aef7ee2a0c69006$var$localResponseCache) return $7aef7ee2a0c69006$var$localResponseCache;
    else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
    try {
        if (!$7aef7ee2a0c69006$var$localResponsePromiseCache) // invoke CDN and cache the promise
        $7aef7ee2a0c69006$var$localResponsePromiseCache = fetch($7aef7ee2a0c69006$export$ab0619f627170401);
        // unpack response
        $7aef7ee2a0c69006$var$localResponseCache = await $7aef7ee2a0c69006$var$handleCategoriesResponse($7aef7ee2a0c69006$var$localResponsePromiseCache);
        return $7aef7ee2a0c69006$var$localResponseCache;
    } catch (e) {
        (0, $8nVWJ.Logger).errorWithOperationalEvent({
            action: 'loadStorageControlsError',
            message: e.message || ''
        });
        $7aef7ee2a0c69006$export$19bc72f5ccd901a6();
    }
};

});






parcelRegister("gWV0M", function(module, exports) {

$parcel$export(module.exports, "ShareToSlack", () => $acb191acb45641f8$export$2cc56764fd9edb21);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $335P8 = parcelRequire("335P8");

var $ljgr5 = parcelRequire("ljgr5");
const $acb191acb45641f8$export$2cc56764fd9edb21 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async-share-to-slack",
        packageName: "integrations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-to-slack",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $335P8.StyledShareToSlackLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $335P8.StyledShareToSlack), props)));

});
parcelRegister("335P8", function(module, exports) {

$parcel$export(module.exports, "StyledShareToSlack", () => $7cc4332b79a68bdd$export$9aeb6210c91511b9);
$parcel$export(module.exports, "StyledShareToSlackLoader", () => $7cc4332b79a68bdd$export$d3f97cc63e3ee02);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");

var $d3qIv = parcelRequire("d3qIv");
const $7cc4332b79a68bdd$export$9aeb6210c91511b9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $d3qIv.LazyShareToSlack), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8ax2b",
            __cmplp.className
        ])
    });
});
const $7cc4332b79a68bdd$export$d3f97cc63e3ee02 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $4Bees.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d3qIv", function(module, exports) {

$parcel$export(module.exports, "LazyShareToSlack", () => $3114157f9b395570$export$24281652e6b89b3b);

var $7rh0R = parcelRequire("7rh0R");

const $3114157f9b395570$export$24281652e6b89b3b = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("4QmWq")), {
    ssr: false,
    moduleId: "./node_modules/@atlassian/integrations/dist/cjs/share-to-slack/ui/index.js"
});

});
parcelRegister("4QmWq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('7PLTL')
        ]);
        const value = parcelRequire('2vsPL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("7PLTL")
    ]).then(()=>parcelRequire('2vsPL'));
}

});



parcelRegister("ljgr5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f66b2d378eff6fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1f66b2d378eff6fc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.50403 13.8563C7.50403 14.727 6.79278 15.4382 5.92212 15.4382C5.05146 15.4382 4.34021 14.727 4.34021 13.8563C4.34021 12.9857 5.05146 12.2744 5.92212 12.2744H7.50403V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.30115 13.8563C8.30115 12.9857 9.0124 12.2744 9.88307 12.2744C10.7537 12.2744 11.465 12.9857 11.465 13.8563V17.8172C11.465 18.6879 10.7537 19.3991 9.88307 19.3991C9.0124 19.3991 8.30115 18.6879 8.30115 17.8172V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.88307 7.50415C9.0124 7.50415 8.30115 6.79291 8.30115 5.92224C8.30115 5.05158 9.0124 4.34033 9.88307 4.34033C10.7537 4.34033 11.465 5.05158 11.465 5.92224V7.50415H9.88307Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.88304 8.30127C10.7537 8.30127 11.465 9.01251 11.465 9.88317C11.465 10.7538 10.7537 11.4651 9.88304 11.4651H5.92212C5.05146 11.4651 4.34021 10.7538 4.34021 9.88317C4.34021 9.01251 5.05146 8.30127 5.92212 8.30127H9.88304Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16.2354 9.88317C16.2354 9.01251 16.9466 8.30127 17.8172 8.30127C18.6879 8.30127 19.3991 9.01251 19.3991 9.88317C19.3991 10.7538 18.6879 11.4651 17.8172 11.4651H16.2354V9.88317Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15.4381 9.88316C15.4381 10.7538 14.7269 11.4651 13.8562 11.4651C12.9855 11.4651 12.2743 10.7538 12.2743 9.88316V5.92225C12.2743 5.05158 12.9855 4.34033 13.8562 4.34033C14.7269 4.34033 15.4381 5.05158 15.4381 5.92225V9.88316Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.8562 16.2354C14.7269 16.2354 15.4381 16.9466 15.4381 17.8172C15.4381 18.6879 14.7269 19.3991 13.8562 19.3991C12.9855 19.3991 12.2743 18.6879 12.2743 17.8172V16.2354H13.8562Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.8562 15.4382C12.9855 15.4382 12.2743 14.727 12.2743 13.8563C12.2743 12.9857 12.9855 12.2744 13.8562 12.2744H17.8171C18.6878 12.2744 19.399 12.9857 19.399 13.8563C19.399 14.727 18.6878 15.4382 17.8171 15.4382H13.8562Z",
        fill: "#ECB22E"
    }));

});





parcelRegister("2aobN", function(module, exports) {

$parcel$export(module.exports, "Voters", () => $eb53ed4f770bb4a3$export$59272dc72b349ef8);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $fvQWm = parcelRequire("fvQWm");

var $PdmhA = parcelRequire("PdmhA");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $4qFYB = parcelRequire("4qFYB");
var $bQ0xL = parcelRequire("bQ0xL");

var $541P3 = parcelRequire("541P3");

var $f9RL0 = parcelRequire("f9RL0");

var $lqalZ = parcelRequire("lqalZ");

var $jZDJX = parcelRequire("jZDJX");

var $fVCj0 = parcelRequire("fVCj0");

var $dxcfv = parcelRequire("dxcfv");
const $eb53ed4f770bb4a3$var$DisabledVoteIcon = ()=>(0, $541P3.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb53ed4f770bb4a3$var$VoteIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fvQWm))), {
        size: "medium",
        primaryColor: `var(--ds-icon-disabled, ${(0, $PdmhA).N30})`,
        label: "",
        testId: "issue-view-foundation.header.voters.like-icon"
    })));
const $eb53ed4f770bb4a3$var$VotersItem = ({ hasError: hasError, isIssueLoading: isIssueLoading, onFieldUpdated: onFieldUpdated })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const loggedInAccountId = (0, $dxcfv.useAccountId)();
    const [value] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $b5480508c6d356f8$export$2124c2b3a156dbd6)
    });
    if (hasError || !loggedInAccountId) return null;
    if (isIssueLoading || !value) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb53ed4f770bb4a3$var$DisabledVoteIcon, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue.details.vote-action"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bQ0xL.VotersListContainer), {
        scope: issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4qFYB.IssueVoters), {
        onFieldUpdated: onFieldUpdated
    })));
};
const $eb53ed4f770bb4a3$export$59272dc72b349ef8 = (0, $lqalZ.connect)((state)=>({
        hasError: !!(0, $jZDJX.errorSelector)(state),
        isIssueLoading: (0, $jZDJX.isLoadingSelector)(state)
    }), (dispatch)=>({
        onFieldUpdated: (value)=>{
            dispatch((0, $fVCj0.fieldUpdated)((0, $f9RL0.VOTES), value));
        }
    }))($eb53ed4f770bb4a3$var$VotersItem);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eb53ed4f770bb4a3$var$VoteIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt418iy",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fvQWm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4b2d116ed1df772$var$_react = $b4b2d116ed1df772$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b4b2d116ed1df772$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b4b2d116ed1df772$var$LikeIcon = (props)=>/*#__PURE__*/ $b4b2d116ed1df772$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4 12v7a.971.971 0 00.278.704.99.99 0 00.701.296H6v-9H4.98a.99.99 0 00-.701.296A.971.971 0 004 12zm15.281-.96a3.046 3.046 0 00-2.321-1.061h-2.634c.04-.181.08-.36.11-.532.515-2.934 0-4-.504-4.594A2.432 2.432 0 0012.075 4a3.078 3.078 0 00-2.968 2.751c-.393 1.839-.454 2-.968 2.725l-.768 1.089a2.011 2.011 0 00-.363 1.141v6.273c.001.532.216 1.041.596 1.416s.896.585 1.433.584h7.247a3.014 3.014 0 002.997-2.507l.677-4a2.963 2.963 0 00-.677-2.432zm-1.998 6.1a1.007 1.007 0 01-1 .835H9.038v-6.269l.767-1.089a7.577 7.577 0 001.302-3.509c.036-.543.255-1.209.969-1.108.714.1.575 1.916.363 3.1a19.712 19.712 0 01-.868 2.882l5.39-.008c.297-.001.58.128.773.352a.993.993 0 01.226.813l-.676 4.001z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$b4b2d116ed1df772$var$LikeIcon.displayName = 'LikeIcon';
var $b4b2d116ed1df772$var$_default = $b4b2d116ed1df772$var$LikeIcon;
module.exports.default = $b4b2d116ed1df772$var$_default;

});

const $b5480508c6d356f8$export$2124c2b3a156dbd6 = 'votes';

parcelRegister("4qFYB", function(module, exports) {

$parcel$export(module.exports, "IssueVoters", () => $4182635599cce554$export$a498d897651bd6fb);

var $eUqFw = parcelRequire("eUqFw");

var $5uliR = parcelRequire("5uliR");

var $dJq7O = parcelRequire("dJq7O");
var $MjJdY = parcelRequire("MjJdY");
const $4182635599cce554$export$a4c456d2795197ba = ({ onFieldUpdated: onFieldUpdated })=>{
    const disableVotingProps = (0, $5uliR.useDisableResolvedIssueVoting)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $MjJdY.default), {
        disableVotingProps: disableVotingProps,
        onFieldUpdated: onFieldUpdated
    });
};
const $4182635599cce554$export$a498d897651bd6fb = ({ onFieldUpdated: onFieldUpdated })=>{
    const disableVotingProps = (0, $5uliR.useDisableResolvedIssueVoting)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dJq7O.default), {
        disableVotingProps: disableVotingProps,
        onFieldUpdated: onFieldUpdated
    });
};

});
parcelRegister("5uliR", function(module, exports) {

$parcel$export(module.exports, "useDisableResolvedIssueVoting", () => $1d4221bfcc9f993b$export$63ad103d2a845dbe);

var $eUqFw = parcelRequire("eUqFw");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $iAlBP = parcelRequire("iAlBP");
const $1d4221bfcc9f993b$export$63ad103d2a845dbe = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const [statusFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: 'status'
    });
    const isDisabled = (0, $eUqFw.useMemo)(()=>(0, $8Qd0L.statusCategoryForId)(statusFieldValue?.statusCategory.id) === (0, $8Qd0L.DONE), [
        statusFieldValue
    ]);
    const tooltips = (0, $eUqFw.useMemo)(()=>isDisabled ? {
            addVote: formatMessage((0, $iAlBP.default).addVoteDisabledTooltip),
            removeVote: formatMessage((0, $iAlBP.default).removeVoteDisabledTooltip)
        } : undefined, [
        formatMessage,
        isDisabled
    ]);
    return {
        isDisabled: isDisabled,
        tooltips: tooltips
    };
};

});
parcelRegister("iAlBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1caaa210c5c4a6b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d1caaa210c5c4a6b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addVoteDisabledTooltip: {
        "id": "issue-field-voters.services.disable-resolved-issue-voting-service.add-vote-disabled-tooltip",
        "defaultMessage": "You can't vote on resolved issues"
    },
    removeVoteDisabledTooltip: {
        "id": "issue-field-voters.services.disable-resolved-issue-voting-service.remove-vote-disabled-tooltip",
        "defaultMessage": "You can't change your vote on resolved issues"
    }
});

});


parcelRegister("dJq7O", function(module, exports) {

$parcel$export(module.exports, "default", () => $db83236023efaa14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $5YYzL = parcelRequire("5YYzL");

var $7kcD1 = parcelRequire("7kcD1");

var $MjJdY = parcelRequire("MjJdY");
const $db83236023efaa14$export$59272dc72b349ef8 = ({ disableVotingProps: disableVotingProps, onFieldUpdated: onFieldUpdated })=>{
    const projectKey = (0, $hJ992.useProjectKey)();
    const [permissions] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const hasViewVotersPermissions = permissions.canViewVoters;
    if (hasViewVotersPermissions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7kcD1.default), {
        disableVotingProps: disableVotingProps,
        onFieldUpdated: onFieldUpdated
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $MjJdY.default), {
        disableVotingProps: disableVotingProps,
        onFieldUpdated: onFieldUpdated
    });
};
var $db83236023efaa14$export$2e2bcd8739ae039 = $db83236023efaa14$export$59272dc72b349ef8;

});
parcelRegister("5YYzL", function(module, exports) {

$parcel$export(module.exports, "useProjectPermissions", () => $bc17d6d67083dab8$export$c6c6b35628cf47a8);
$parcel$export(module.exports, "useCanAdministerProject", () => $bc17d6d67083dab8$export$f39ed5a161efa614);
$parcel$export(module.exports, "useCanAdministerJira", () => $bc17d6d67083dab8$export$ec12ddafd19b95ac);
$parcel$export(module.exports, "useCanConfigureIssue", () => $bc17d6d67083dab8$export$e7267b8a084eadb3);
$parcel$export(module.exports, "useCanUseServiceDeskAgentFeatures", () => $bc17d6d67083dab8$export$756d7c97077a2f76);
$parcel$export(module.exports, "useProjectPermissionsActions", () => $bc17d6d67083dab8$export$86c656cdb87052cd);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");

var $anOKD = parcelRequire("anOKD");
const $bc17d6d67083dab8$export$c6c6b35628cf47a8 = (projectKey)=>{
    const [permissions, { setProjectPermissions: setProjectPermissions }] = (0, $anOKD.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const actions = (0, $eUqFw.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        permissions,
        actions
    ];
};
const $bc17d6d67083dab8$export$f39ed5a161efa614 = (projectKey)=>{
    const [permissions] = (0, $anOKD.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerProject;
};
const $bc17d6d67083dab8$export$ec12ddafd19b95ac = (projectKey)=>{
    const [permissions] = (0, $anOKD.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerJira;
};
const $bc17d6d67083dab8$export$e7267b8a084eadb3 = (projectKey)=>{
    const canConfigureAdministerProject = $bc17d6d67083dab8$export$f39ed5a161efa614(projectKey);
    const canAdministerJira = $bc17d6d67083dab8$export$ec12ddafd19b95ac(projectKey);
    return canConfigureAdministerProject || canAdministerJira;
};
const $bc17d6d67083dab8$export$756d7c97077a2f76 = (projectKey)=>{
    const [permissions] = (0, $anOKD.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { appPermissions: appPermissions } = (0, $gd0Sp.useTenantContext)();
    return permissions.canUseServiceDeskAgentFeatures && appPermissions?.hasServiceDeskAccess;
};
const $bc17d6d67083dab8$export$86c656cdb87052cd = ()=>{
    const [, { setProjectPermissions: setProjectPermissions }] = (0, $anOKD.useProjectPermissionsStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("anOKD", function(module, exports) {

$parcel$export(module.exports, "defaultPermissions", () => $777dfd95ecbd2e05$export$ccfee65526b322ca);
$parcel$export(module.exports, "useProjectPermissionsStore", () => $777dfd95ecbd2e05$export$4919fa09a3d81224);
$parcel$export(module.exports, "useProjectPermissionsStoreActions", () => $777dfd95ecbd2e05$export$e8436ef485b33bdb);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $1TYLm = parcelRequire("1TYLm");
const $777dfd95ecbd2e05$export$ccfee65526b322ca = {
    canAddComments: false,
    canAdministerJira: false,
    canAdministerProject: false,
    canAssignIssues: false,
    canBeAssignedToIssues: false,
    canCloneIssue: false,
    canCreateAttachments: false,
    canCreateChildren: false,
    canCreateSubtask: false,
    canDeleteAllAttachments: false,
    canDeleteAllComments: false,
    canDeleteAllWorklogs: false,
    canDeleteIssue: false,
    canDeleteOwnAttachments: false,
    canDeleteOwnComments: false,
    canDeleteOwnWorklogs: false,
    canEditAllComments: false,
    canEditAllWorklogs: false,
    canEditIssues: false,
    canEditOwnComments: false,
    canEditOwnWorklogs: false,
    canLinkIssues: false,
    canLogWork: false,
    canManageWatchers: false,
    canMoveIssue: false,
    canModifyReporter: false,
    canScheduleIssues: false,
    canUseServiceDeskAgentFeatures: false,
    canBrowseUsers: false,
    canViewDevTools: false,
    canViewWatchers: false,
    canViewVoters: false,
    canCreateIssuesInClassicProjectEpic: false,
    canResolveIssues: false,
    canExportIssue: false
};
const $777dfd95ecbd2e05$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'project-permissions',
    initialState: {},
    actions: $1TYLm
});
const $777dfd95ecbd2e05$var$getProjectPermissionSelector = (state, { projectKey: projectKey })=>state[projectKey] || $777dfd95ecbd2e05$export$ccfee65526b322ca;
const $777dfd95ecbd2e05$export$4919fa09a3d81224 = (0, $ggKAj.createHook)($777dfd95ecbd2e05$export$6f57813fe9f31bf9, {
    selector: $777dfd95ecbd2e05$var$getProjectPermissionSelector
});
const $777dfd95ecbd2e05$export$e8436ef485b33bdb = (0, $ggKAj.createHook)($777dfd95ecbd2e05$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("1TYLm", function(module, exports) {

$parcel$export(module.exports, "setProjectPermissions", () => $54a1a48853cdbc94$export$53f5cc27627e5fe3);
const $54a1a48853cdbc94$export$53f5cc27627e5fe3 = (projectKey, permissions)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [projectKey]: permissions
        });
    };

});



parcelRegister("7kcD1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa5294cd141a43d3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $7rh0R = parcelRequire("7rh0R");

var $3MV1G = parcelRequire("3MV1G");

var $4Bees = parcelRequire("4Bees");

var $c9TLT = parcelRequire("c9TLT");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $gGtKh = parcelRequire("gGtKh");


var $eELJk = parcelRequire("eELJk");


var $en4Qn = parcelRequire("en4Qn");

var $fnaax = parcelRequire("fnaax");

const $fa5294cd141a43d3$export$59308621e1a05692 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("pZEHP")), {
    moduleId: "./src/packages/issue/fields/voters/src/ui/dropdown-content/index.tsx"
});
// eslint-disable-next-line jira/styled/styled-component-order, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa5294cd141a43d3$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3is0l4 _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $fa5294cd141a43d3$var$fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa5294cd141a43d3$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
    size: "medium"
}));
const $fa5294cd141a43d3$var$LazyDropdownContent = ({ setCloseDropdown: setCloseDropdown, disableVotingProps: disableVotingProps, onFieldUpdated: onFieldUpdated })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-voters-list",
        packageName: "issue",
        render: ()=>$fa5294cd141a43d3$var$fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "dropdown-content",
        fallback: $fa5294cd141a43d3$var$fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa5294cd141a43d3$export$59308621e1a05692, {
        setCloseDropdown: setCloseDropdown,
        disableVotingProps: disableVotingProps,
        onFieldUpdated: onFieldUpdated
    })));
const $fa5294cd141a43d3$export$8056ec75e5668943 = ({ disableVotingProps: disableVotingProps, onFieldUpdated: onFieldUpdated })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ hasVoted: hasVoted, votes: votes }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $b5480508c6d356f8$export$2124c2b3a156dbd6)
    });
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const ariaLabel = (0, $eUqFw.useMemo)(()=>formatMessage((0, $eELJk.getVoteLabelForDropdown)(hasVoted, votes), {
            votes: votes
        }), [
        formatMessage,
        hasVoted,
        votes
    ]);
    const tooltip = formatMessage((0, $en4Qn.default).voteOptionsTooltip);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const toggleDropdown = (0, $eUqFw.useCallback)(()=>{
        setIsOpen((prevIsOpen)=>!prevIsOpen);
    }, []);
    const closeDropdown = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa5294cd141a43d3$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        boundary: "clippingParents",
        isOpen: isOpen,
        placement: "auto-end",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnaax.default), {
                onClick: toggleDropdown,
                tooltip: tooltip,
                ariaLabel: ariaLabel,
                isSelected: isOpen
            })),
        onClose: closeDropdown,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa5294cd141a43d3$var$ContentWrapper, {
                "data-testid": (0, $586041dd7eda8be8$export$dac753b5aac391f1)
            }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa5294cd141a43d3$var$LazyDropdownContent, {
                setCloseDropdown: closeDropdown,
                onFieldUpdated: onFieldUpdated,
                disableVotingProps: disableVotingProps
            })),
        zIndex: (0, $c9TLT.layers).modal
    }));
};
var $fa5294cd141a43d3$export$2e2bcd8739ae039 // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $fa5294cd141a43d3$export$8056ec75e5668943;
const $fa5294cd141a43d3$var$Container = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "echpvz-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-role='droplistContent']": {
        overflow: 'visible'
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa5294cd141a43d3$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbp3fh _1tkes0l4 _1yt4skji",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eELJk", function(module, exports) {

$parcel$export(module.exports, "getVoteLabelForDropdown", () => $59a9b170c3915276$export$92fde000a5413466);
$parcel$export(module.exports, "getLabelForToggleWithSelfVote", () => $59a9b170c3915276$export$55ee1e7303e0fa7d);
$parcel$export(module.exports, "getLabelForToggleWithoutSelfVote", () => $59a9b170c3915276$export$bef3b9a24732e64f);

var $en4Qn = parcelRequire("en4Qn");
const $59a9b170c3915276$export$92fde000a5413466 = (hasVoted, votes)=>{
    if (hasVoted) return (0, $en4Qn.default).voteCountWithSelfLabel;
    return votes ? (0, $en4Qn.default).voteCountWithoutSelfLabel : (0, $en4Qn.default).noOneHasVotedLabel;
};
const $59a9b170c3915276$export$55ee1e7303e0fa7d = ()=>(0, $en4Qn.default).voteCountWithSelfLabelForToggle;
const $59a9b170c3915276$export$bef3b9a24732e64f = (votes)=>votes ? (0, $en4Qn.default).voteCountWithoutSelfLabelForToggle : (0, $en4Qn.default).noOneHasVotedLabelForToggle;

});
parcelRegister("en4Qn", function(module, exports) {

$parcel$export(module.exports, "default", () => $5397f1b6351954a0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5397f1b6351954a0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    fetchVotersListFailedTitle: {
        "id": "issue-field-voters.fetch-voters-list-failed-title",
        "defaultMessage": "We couldn't load the voters list"
    },
    fetchVotersListFailedDescription: {
        "id": "issue-field-voters.fetch-voters-list-failed-description",
        "defaultMessage": "Check your connection, then give it another try."
    },
    updateVoteFailedTitle: {
        "id": "issue-field-voters.update-vote-failed-title",
        "defaultMessage": "We couldn't update your vote status"
    },
    updateVoteFailedDescription: {
        "id": "issue-field-voters.update-vote-failed-description",
        "defaultMessage": "Check your connection, then try clicking vote again."
    },
    addVoteLabel: {
        "id": "issue-field-voters.add-vote-label",
        "defaultMessage": "Vote for this issue"
    },
    removeVoteLabel: {
        "id": "issue-field-voters.remove-vote-label",
        "defaultMessage": "Remove Vote"
    },
    voteOptionsTooltip: {
        "id": "issue-field-voters.vote-options-tooltip",
        "defaultMessage": "Vote options"
    },
    emptyVotersMessage: {
        "id": "issue-field-voters.empty-voters-message",
        "defaultMessage": "No one has voted for this issue"
    },
    votersListLabel: {
        "id": "issue-field-voters.voters-list-label",
        "defaultMessage": "Voted for this issue"
    },
    voteCountWithSelfLabel: {
        "id": "issue-field-voters.vote-count-with-self-label",
        "defaultMessage": "Vote options: You've voted for this issue. {votes, plural, one {# person has} other {# people have}} voted."
    },
    voteCountWithoutSelfLabel: {
        "id": "issue-field-voters.vote-count-without-self-label",
        "defaultMessage": "Vote options: {votes, plural, one {# person has} other {# people have}} voted for this issue."
    },
    noOneHasVotedLabel: {
        "id": "issue-field-voters.no-one-has-voted-label",
        "defaultMessage": "Vote options: No one has voted for this issue yet."
    },
    voteCountWithoutSelfLabelForToggle: {
        "id": "issue-field-voters.vote-count-without-self-label-for-toggle",
        "defaultMessage": "Vote for this issue: {votes, plural, one {# person has} other {# people have}} voted for this issue."
    },
    noOneHasVotedLabelForToggle: {
        "id": "issue-field-voters.no-one-has-voted-label-for-toggle",
        "defaultMessage": "Vote for this issue: No one has voted for this issue yet."
    },
    voteCountWithSelfLabelForToggle: {
        "id": "issue-field-voters.vote-count-with-self-label-for-toggle",
        "defaultMessage": "Remove Vote: You've voted for this issue. {votes, plural, one {# person has} other {# people have}} voted."
    }
});

});


/**
 * This file can be shared between production app code, storybook and cypress
 * because production app code, storybook and cypress should not import codes together directly.
 */ const $586041dd7eda8be8$export$dac753b5aac391f1 = 'issue.fields.voters.dropdown';
const $586041dd7eda8be8$export$71c19201b90b2aec = 'issue-field-voters.ui.button.styled-button';

parcelRegister("fnaax", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f0fd2e74328f446$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");


var $9Fs4V = parcelRequire("9Fs4V");

var $lvmAW = parcelRequire("lvmAW");
const $2f0fd2e74328f446$export$402a0948b9a71808 = ({ onClick: onClick, tooltip: // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'string'.
tooltip = null, isSelected: isSelected = false, isDisabled: isDisabled = false, ariaLabel: ariaLabel = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltip,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lvmAW.StyledButton), {
        testId: (0, $586041dd7eda8be8$export$71c19201b90b2aec),
        onClick: onClick,
        isSelected: isSelected,
        appearance: "subtle",
        spacing: "default",
        "aria-label": ariaLabel,
        "aria-expanded": isSelected,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Fs4V.default), {
        isSelected: isSelected
    })));
var $2f0fd2e74328f446$export$2e2bcd8739ae039 = $2f0fd2e74328f446$export$402a0948b9a71808;

});
parcelRegister("9Fs4V", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5d6891b4754214f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $fvQWm = parcelRequire("fvQWm");

var $PdmhA = parcelRequire("PdmhA");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $5ZMpE = parcelRequire("5ZMpE");


var $j6pgF = parcelRequire("j6pgF");
const $d5d6891b4754214f$var$VoteIcon = ({ isSelected: isSelected = false })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ hasVoted: hasVoted, votes: votes }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $b5480508c6d356f8$export$2124c2b3a156dbd6)
    });
    const likedIcon = (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fvQWm))), {
        label: "",
        size: "medium",
        primaryColor: `var(--ds-icon-selected, ${(0, $PdmhA.B400)})`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j6pgF.default), {
        label: "",
        size: "medium"
    });
    const unlikedIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fvQWm))), {
        label: "",
        size: "medium"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5d6891b4754214f$var$IconWrapper, {
        hasVoted: hasVoted,
        isSelected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5d6891b4754214f$var$ButtonIcon, null, hasVoted ? likedIcon : unlikedIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5d6891b4754214f$export$7ed12d2a5241e393.Counter, {
        "data-testid": "issue-field-voters.ui.icon.counter",
        hasVoters: votes !== 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZMpE))), null, votes !== 0 ? votes : '')));
};
var $d5d6891b4754214f$export$2e2bcd8739ae039 // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d5d6891b4754214f$var$VoteIcon;
const $d5d6891b4754214f$var$IconWrapper = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-1nlnqj5-0"
})({
    display: 'flex',
    alignItems: 'center'
}, // eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.hasVoted && !props.isSelected ? `color: ${`var(--ds-icon-brand, ${(0, $PdmhA).B500})`};` : '');
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5d6891b4754214f$var$ButtonIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $d5d6891b4754214f$export$7ed12d2a5241e393 = {
    // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
    Counter: (0, $kwce8.default).span.withConfig({
        componentId: "sc-1nlnqj5-1"
    })((props)=>({
            minWidth: props.hasVoters ? '15px' : '0'
        }))
};

});
parcelRegister("5ZMpE", function(module, exports) {

var $eUqFw = parcelRequire("eUqFw");
var $45d834046867c7b1$var$D = $eUqFw.createElement;

var $5cnfB = parcelRequire("5cnfB");

var $jnHSM = parcelRequire("jnHSM");
var $45d834046867c7b1$var$symbol = $eUqFw.createElement.bind(null, $jnHSM);
var $45d834046867c7b1$var$TransitiveNumber = $5cnfB({
    getDefaultProps: function() {
        return {
            className: null,
            enableInitialAnimation: false
        };
    },
    render: function() {
        var value = this.props.children.toString();
        // Invert animation direction when negative number is supplied.
        var inverted = value[0] === '-';
        return $45d834046867c7b1$var$D('span', {
            className: this.props.className,
            style: {
                whiteSpace: 'pre'
            }
        }, value.split('').map(function(s, index) {
            return $45d834046867c7b1$var$symbol({
                symbol: s,
                inverted: inverted,
                enableInitialAnimation: this.props.enableInitialAnimation,
                key: index
            });
        }, this));
    }
});
module.exports = $45d834046867c7b1$var$TransitiveNumber;

});
parcelRegister("5cnfB", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $eUqFw = parcelRequire("eUqFw");

var $7vk30 = parcelRequire("7vk30");
if (typeof $eUqFw === 'undefined') throw Error("create-react-class could not find the React object. If you are using script tags, make sure that React is being loaded before create-react-class.");
// Hack to grab NoopUpdateQueue from isomorphic React
var $3c901bd9e365bd7d$var$ReactNoopUpdateQueue = new $eUqFw.Component().updater;
module.exports = $7vk30($eUqFw.Component, $eUqFw.isValidElement, $3c901bd9e365bd7d$var$ReactNoopUpdateQueue);

});
parcelRegister("7vk30", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $8aUjw = parcelRequire("8aUjw");
// -- Inlined from fbjs --
var $576afaa5c323d2d6$var$emptyObject = {};
var $576afaa5c323d2d6$var$validateFormat = function validateFormat(format) {};
function $576afaa5c323d2d6$var$_invariant(condition, format, a, b, c, d, e, f) {
    $576afaa5c323d2d6$var$validateFormat(format);
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
}
var $576afaa5c323d2d6$var$warning = function() {};
var $576afaa5c323d2d6$var$printWarning;
// /-- Inlined from fbjs --
var $576afaa5c323d2d6$var$MIXINS_KEY = 'mixins';
// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function $576afaa5c323d2d6$var$identity(fn) {
    return fn;
}
var $576afaa5c323d2d6$var$ReactPropTypeLocationNames;
$576afaa5c323d2d6$var$ReactPropTypeLocationNames = {};
function $576afaa5c323d2d6$var$factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
    /**
   * Policies that describe methods in `ReactClassInterface`.
   */ var injectedMixins = [];
    /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */ var ReactClassInterface = {
        /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */ mixins: 'DEFINE_MANY',
        /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */ statics: 'DEFINE_MANY',
        /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */ propTypes: 'DEFINE_MANY',
        /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */ contextTypes: 'DEFINE_MANY',
        /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */ childContextTypes: 'DEFINE_MANY',
        // ==== Definition methods ====
        /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */ getDefaultProps: 'DEFINE_MANY_MERGED',
        /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */ getInitialState: 'DEFINE_MANY_MERGED',
        /**
     * @return {object}
     * @optional
     */ getChildContext: 'DEFINE_MANY_MERGED',
        /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */ render: 'DEFINE_ONCE',
        // ==== Delegate methods ====
        /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */ componentWillMount: 'DEFINE_MANY',
        /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */ componentDidMount: 'DEFINE_MANY',
        /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */ componentWillReceiveProps: 'DEFINE_MANY',
        /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */ shouldComponentUpdate: 'DEFINE_ONCE',
        /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */ componentWillUpdate: 'DEFINE_MANY',
        /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */ componentDidUpdate: 'DEFINE_MANY',
        /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */ componentWillUnmount: 'DEFINE_MANY',
        /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */ UNSAFE_componentWillMount: 'DEFINE_MANY',
        /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */ UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
        /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */ UNSAFE_componentWillUpdate: 'DEFINE_MANY',
        // ==== Advanced methods ====
        /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */ updateComponent: 'OVERRIDE_BASE'
    };
    /**
   * Similar to ReactClassInterface but for static methods.
   */ var ReactClassStaticInterface = {
        /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */ getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
    };
    /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */ var RESERVED_SPEC_KEYS = {
        displayName: function(Constructor, displayName) {
            Constructor.displayName = displayName;
        },
        mixins: function(Constructor, mixins) {
            if (mixins) for(var i = 0; i < mixins.length; i++)mixSpecIntoComponent(Constructor, mixins[i]);
        },
        childContextTypes: function(Constructor, childContextTypes) {
            Constructor.childContextTypes = $8aUjw({}, Constructor.childContextTypes, childContextTypes);
        },
        contextTypes: function(Constructor, contextTypes) {
            Constructor.contextTypes = $8aUjw({}, Constructor.contextTypes, contextTypes);
        },
        /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */ getDefaultProps: function(Constructor, getDefaultProps) {
            if (Constructor.getDefaultProps) Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
            else Constructor.getDefaultProps = getDefaultProps;
        },
        propTypes: function(Constructor, propTypes) {
            Constructor.propTypes = $8aUjw({}, Constructor.propTypes, propTypes);
        },
        statics: function(Constructor, statics) {
            mixStaticSpecIntoComponent(Constructor, statics);
        },
        autobind: function() {}
    };
    function validateTypeDef(Constructor, typeDef, location) {
        for(var propName in typeDef)typeDef.hasOwnProperty(propName);
    }
    function validateMethodOverride(isAlreadyDefined, name) {
        var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
        // Disallow overriding of base class methods unless explicitly allowed.
        if (ReactClassMixin.hasOwnProperty(name)) $576afaa5c323d2d6$var$_invariant(specPolicy === 'OVERRIDE_BASE', "ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.", name);
        // Disallow defining methods more than once unless explicitly allowed.
        if (isAlreadyDefined) $576afaa5c323d2d6$var$_invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', "ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.", name);
    }
    /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */ function mixSpecIntoComponent(Constructor, spec) {
        if (!spec) {
            var typeofSpec, isMixinValid;
            return;
        }
        $576afaa5c323d2d6$var$_invariant(typeof spec !== 'function', "ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object.");
        $576afaa5c323d2d6$var$_invariant(!isValidElement(spec), "ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object.");
        var proto = Constructor.prototype;
        var autoBindPairs = proto.__reactAutoBindPairs;
        // By handling mixins before any other properties, we ensure the same
        // chaining order is applied to methods with DEFINE_MANY policy, whether
        // mixins are listed before or after these methods in the spec.
        if (spec.hasOwnProperty($576afaa5c323d2d6$var$MIXINS_KEY)) RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
        for(var name in spec){
            if (!spec.hasOwnProperty(name)) continue;
            if (name === $576afaa5c323d2d6$var$MIXINS_KEY) continue;
            var property = spec[name];
            var isAlreadyDefined = proto.hasOwnProperty(name);
            validateMethodOverride(isAlreadyDefined, name);
            if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) RESERVED_SPEC_KEYS[name](Constructor, property);
            else {
                // Setup methods on prototype:
                // The following member methods should not be automatically bound:
                // 1. Expected ReactClass methods (in the "interface").
                // 2. Overridden methods (that were mixed in).
                var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
                var isFunction = typeof property === 'function';
                var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
                if (shouldAutoBind) {
                    autoBindPairs.push(name, property);
                    proto[name] = property;
                } else if (isAlreadyDefined) {
                    var specPolicy = ReactClassInterface[name];
                    // These cases should already be caught by validateMethodOverride.
                    $576afaa5c323d2d6$var$_invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), "ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.", specPolicy, name);
                    // For methods which are defined more than once, call the existing
                    // methods before calling the new property, merging if appropriate.
                    if (specPolicy === 'DEFINE_MANY_MERGED') proto[name] = createMergedResultFunction(proto[name], property);
                    else if (specPolicy === 'DEFINE_MANY') proto[name] = createChainedFunction(proto[name], property);
                } else proto[name] = property;
            }
        }
    }
    function mixStaticSpecIntoComponent(Constructor, statics) {
        if (!statics) return;
        for(var name in statics){
            var property = statics[name];
            if (!statics.hasOwnProperty(name)) continue;
            var isReserved = name in RESERVED_SPEC_KEYS;
            $576afaa5c323d2d6$var$_invariant(!isReserved, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name);
            var isAlreadyDefined = name in Constructor;
            if (isAlreadyDefined) {
                var specPolicy = ReactClassStaticInterface.hasOwnProperty(name) ? ReactClassStaticInterface[name] : null;
                $576afaa5c323d2d6$var$_invariant(specPolicy === 'DEFINE_MANY_MERGED', "ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.", name);
                Constructor[name] = createMergedResultFunction(Constructor[name], property);
                return;
            }
            Constructor[name] = property;
        }
    }
    /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */ function mergeIntoWithNoDuplicateKeys(one, two) {
        $576afaa5c323d2d6$var$_invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');
        for(var key in two)if (two.hasOwnProperty(key)) {
            $576afaa5c323d2d6$var$_invariant(one[key] === undefined, "mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.", key);
            one[key] = two[key];
        }
        return one;
    }
    /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */ function createMergedResultFunction(one, two) {
        return function mergedResult() {
            var a = one.apply(this, arguments);
            var b = two.apply(this, arguments);
            if (a == null) return b;
            else if (b == null) return a;
            var c = {};
            mergeIntoWithNoDuplicateKeys(c, a);
            mergeIntoWithNoDuplicateKeys(c, b);
            return c;
        };
    }
    /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */ function createChainedFunction(one, two) {
        return function chainedFunction() {
            one.apply(this, arguments);
            two.apply(this, arguments);
        };
    }
    /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */ function bindAutoBindMethod(component, method) {
        var boundMethod = method.bind(component);
        var componentName, _bind;
        return boundMethod;
    }
    /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */ function bindAutoBindMethods(component) {
        var pairs = component.__reactAutoBindPairs;
        for(var i = 0; i < pairs.length; i += 2){
            var autoBindKey = pairs[i];
            var method = pairs[i + 1];
            component[autoBindKey] = bindAutoBindMethod(component, method);
        }
    }
    var IsMountedPreMixin = {
        componentDidMount: function() {
            this.__isMounted = true;
        }
    };
    var IsMountedPostMixin = {
        componentWillUnmount: function() {
            this.__isMounted = false;
        }
    };
    /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */ var ReactClassMixin = {
        /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */ replaceState: function(newState, callback) {
            this.updater.enqueueReplaceState(this, newState, callback);
        },
        /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */ isMounted: function() {
            return !!this.__isMounted;
        }
    };
    var ReactClassComponent = function() {};
    $8aUjw(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
    /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */ function createClass(spec) {
        // To keep our warnings more understandable, we'll use a little hack here to
        // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
        // unnecessarily identify a class without displayName as 'Constructor'.
        var Constructor = $576afaa5c323d2d6$var$identity(function(props, context, updater) {
            // Wire up auto-binding
            if (this.__reactAutoBindPairs.length) bindAutoBindMethods(this);
            this.props = props;
            this.context = context;
            this.refs = $576afaa5c323d2d6$var$emptyObject;
            this.updater = updater || ReactNoopUpdateQueue;
            this.state = null;
            // ReactClasses doesn't have constructors. Instead, they use the
            // getInitialState and componentWillMount methods for initialization.
            var initialState = this.getInitialState ? this.getInitialState() : null;
            $576afaa5c323d2d6$var$_invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
            this.state = initialState;
        });
        Constructor.prototype = new ReactClassComponent();
        Constructor.prototype.constructor = Constructor;
        Constructor.prototype.__reactAutoBindPairs = [];
        injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
        mixSpecIntoComponent(Constructor, IsMountedPreMixin);
        mixSpecIntoComponent(Constructor, spec);
        mixSpecIntoComponent(Constructor, IsMountedPostMixin);
        // Initialize the defaultProps property after all mixins have been merged.
        if (Constructor.getDefaultProps) Constructor.defaultProps = Constructor.getDefaultProps();
        $576afaa5c323d2d6$var$_invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');
        // Reduce time spent doing lookups by setting these on the prototype.
        for(var methodName in ReactClassInterface)if (!Constructor.prototype[methodName]) Constructor.prototype[methodName] = null;
        return Constructor;
    }
    return createClass;
}
module.exports = $576afaa5c323d2d6$var$factory;

});


parcelRegister("jnHSM", function(module, exports) {

var $eUqFw = parcelRequire("eUqFw");
var $e1c23476250ebb58$var$D = $eUqFw.createElement;

var $lEfVV = parcelRequire("lEfVV");
var $e1c23476250ebb58$require$findDOMNode = $lEfVV.findDOMNode;

var $5cnfB = parcelRequire("5cnfB");

var $jRMvi = parcelRequire("jRMvi");
var $e1c23476250ebb58$var$transition = $eUqFw.createElement.bind(null, $jRMvi);
var $e1c23476250ebb58$var$Symbol = $5cnfB({
    getInitialState: function() {
        return {
            previous: null,
            decrementing: false,
            initialRender: true
        };
    },
    componentDidMount: function() {
        $e1c23476250ebb58$require$findDOMNode(this).addEventListener('transitionend', this.removePrevious);
    },
    componentWillUnmount: function() {
        $e1c23476250ebb58$require$findDOMNode(this).removeEventListener('transitionend', this.removePrevious);
    },
    componentWillReceiveProps: function(nextProps) {
        if (nextProps.symbol !== this.props.symbol) {
            var decrementing = $e1c23476250ebb58$var$isDecrementing(this.props.symbol, nextProps.symbol);
            this.setState({
                previous: this.props.symbol,
                decrementing: this.props.inverted ? !decrementing : decrementing,
                initialRender: false
            });
        }
    },
    shouldComponentUpdate: function(nextProps, nextState) {
        return nextProps.symbol !== this.props.symbol || nextState.previous !== this.state.previous;
    },
    removePrevious: function() {
        this.setState({
            previous: null
        });
    },
    render: function() {
        return $e1c23476250ebb58$var$D('span', {
            style: {
                position: 'relative',
                display: 'inline-block'
            }
        }, // Have to render this transparent spacer span to mitigate the issue
        // when Safari would not animate transition if changing `position`
        // from `absolute` to `static`.
        this.renderSpacer(), this.renderTransitionIn(), this.renderTransitionOut());
    },
    renderSpacer: function() {
        return $e1c23476250ebb58$var$D('span', {
            style: {
                visibility: 'hidden'
            }
        }, this.props.symbol);
    },
    renderTransitionIn: function() {
        return $e1c23476250ebb58$var$transition({
            value: this.props.symbol,
            goingUp: this.state.decrementing,
            animateEntrance: this.state.initialRender ? this.props.enableInitialAnimation : true,
            key: this.props.symbol
        });
    },
    renderTransitionOut: function() {
        if (this.state.previous !== null) return $e1c23476250ebb58$var$transition({
            value: this.state.previous,
            goingUp: this.state.decrementing,
            out: true,
            key: this.state.previous
        });
        return null;
    }
});
module.exports = $e1c23476250ebb58$var$Symbol;
function $e1c23476250ebb58$var$isDecrementing(a, b) {
    var numberA = Number(a);
    var numberB = Number(b);
    // Special case when going from 9 or 6 to 0 (and back).
    if (Math.abs(numberB - numberA) !== 1) return numberA === 0;
    else return numberB < numberA;
}

});
parcelRegister("jRMvi", function(module, exports) {

var $eUqFw = parcelRequire("eUqFw");
var $e768976a29c90d47$var$D = $eUqFw.createElement;

var $lEfVV = parcelRequire("lEfVV");
var $e768976a29c90d47$require$findDOMNode = $lEfVV.findDOMNode;

var $5cnfB = parcelRequire("5cnfB");
var $e768976a29c90d47$var$Transition = $5cnfB({
    getInitialState: function() {
        return {
            in: this.props.out ? true : !this.props.animateEntrance
        };
    },
    componentDidMount: function() {
        this._timeout = $e768976a29c90d47$var$raf(this.tada);
    },
    componentWillUnmount: function() {
        $e768976a29c90d47$var$caf(this._timeout);
    },
    tada: function() {
        // Force element reflow to ensure correct animation in FF.
        $e768976a29c90d47$require$findDOMNode(this).offsetWidth;
        this.setState({
            in: true
        });
    },
    getAppearance: function() {
        var transform = this.getTransform();
        return {
            display: 'inline-block',
            // Can't dynamically change `position` from `absolute` to `static` -
            // it will break transition animation in Safari.
            position: 'absolute',
            left: 0,
            WebkitTransition: '-webkit-transform 0.2s, opacity 0.2s',
            transition: 'transform 0.2s, opacity 0.2s',
            WebkitTransform: transform,
            transform: transform,
            opacity: this.isHidden() ? 0 : 1,
            pointerEvents: 'none'
        };
    },
    getTransform: function() {
        if (this.props.out) return $e768976a29c90d47$var$translateY(this.props.goingUp);
        if (!this.state.in) return $e768976a29c90d47$var$translateY(!this.props.goingUp);
        // This has better text rendering in FF than simply `none`.
        return 'translateY(0) translateZ(0)';
    },
    isHidden: function() {
        return this.props.out || !this.state.in;
    },
    render: function() {
        return $e768976a29c90d47$var$D('span', {
            style: this.getAppearance()
        }, this.props.value);
    }
});
module.exports = $e768976a29c90d47$var$Transition;
function $e768976a29c90d47$var$raf(fn) {
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(fn);
    else return setTimeout(fn, 0);
}
function $e768976a29c90d47$var$caf(timer) {
    if (typeof window.cancelAnimationFrame === 'function') return window.cancelAnimationFrame(timer);
    else return clearTimeout(timer);
}
function $e768976a29c90d47$var$translateY(isUp) {
    return 'translateY(' + (isUp ? '-' : '') + '60%) translateZ(0)';
}

});



parcelRegister("j6pgF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1e6c40f7613c1e4$export$2e2bcd8739ae039);
// This file is temporary and eventually this icon will be in atlaskit

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $c1e6c40f7613c1e4$var$likeIconFilled = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        id: "like-filled-a",
        d: "M4.00029867,12.0000031 L4.00029867,19.0000031 C3.99379083,19.2619469 4.0938648,19.5154845 4.27800285,19.7035645 C4.46214091,19.8916445 4.71487577,19.9984685 4.97933941,20.0000031 L5.99875297,20.0000031 L5.99875297,11.0000031 L4.97933941,11.0000031 C4.71487577,11.0015345 4.46214091,11.1083586 4.27800285,11.2964386 C4.0938648,11.4845186 3.99379083,11.7380562 4.00029867,12.0000031 Z M19.2814088,11.0400031 C18.7031035,10.3648275 17.8537454,9.97663317 16.959972,9.97900342 L14.3256459,9.97900342 C14.3660187,9.79800348 14.4063915,9.61900354 14.4366711,9.4470036 C14.9514245,6.5130046 14.4366711,5.44700497 13.9320109,4.85300517 C13.4705845,4.31076256 12.7907146,3.99849428 12.0748615,4 C10.5305357,4.05274499 9.2630356,5.22781051 9.10745966,6.75100452 C8.71382472,8.59000389 8.6532655,8.75100384 8.13851212,9.47600359 L7.37142865,10.5650032 C7.13702441,10.900368 7.01037109,11.2980817 7.00807332,11.7060028 L7.00807332,17.9790007 C7.0094101,18.5107601 7.22390249,19.0202137 7.60436426,19.3952867 C7.98482603,19.7703597 8.50009148,19.9803277 9.03680723,19.9790426 L16.2837274,19.9790426 C17.7690249,19.9867984 19.0398298,18.9240081 19.2814088,17.4720009 L19.9576535,13.4720022 C20.1064636,12.6021375 19.8588502,11.7116379 19.2814088,11.0400031 Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("use", {
        fill: "currentColor",
        xlinkHref: "#like-filled-a"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "inherit",
        d: "M17.2829545,17.140001 C17.2013522,17.6232979 16.7783039,17.9768163 16.2837274,17.9750077 L9.03680723,17.9750077 L9.03680723,11.7060028 L9.8038907,10.6170032 C10.5252697,9.572607 10.9727451,8.36664508 11.105914,7.1080044 C11.1422788,6.56547046 11.3606605,5.89943888 12.0748615,6.00000478 C12.7890625,6.10057068 12.6501741,7.91600412 12.4382168,9.10000372 C12.2228565,10.0810361 11.9326853,11.0444672 11.5702013,11.9820027 L16.959972,11.9740027 C17.2574249,11.9729101 17.5402185,12.1018688 17.7328364,12.3264423 C17.9254544,12.5510157 18.0082813,12.848334 17.9591992,13.1390023 L17.2829545,17.140001 Z"
    })));
const $c1e6c40f7613c1e4$var$LikeIconFilled = ({ size: size, label: label, secondaryColor: secondaryColor = "var(--ds-icon-accent-blue, #B3D4FF)" })=>// @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => JSX.Element' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $c1e6c40f7613c1e4$var$likeIconFilled,
        size: size,
        label: label,
        secondaryColor: secondaryColor
    });
var $c1e6c40f7613c1e4$export$2e2bcd8739ae039 = $c1e6c40f7613c1e4$var$LikeIconFilled;

});


parcelRegister("lvmAW", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $153c56668bf14859$export$2d5d2ba3c7c8c40b);

var $kwce8 = parcelRequire("kwce8");

var $7u4fN = parcelRequire("7u4fN");
const $153c56668bf14859$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
(0, $kwce8.default)((0, $7u4fN.default)).withConfig({
    componentId: "v67syn-0"
})({
    '&&': {
        padding: `0 ${"var(--ds-space-050, 4px)"}`,
        alignItems: 'center'
    }
});

});


parcelRegister("pZEHP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('5U571')
        ]);
        const value = parcelRequire('2jwsu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("5U571")
    ]).then(()=>parcelRequire('2jwsu'));
}

});


parcelRegister("MjJdY", function(module, exports) {

$parcel$export(module.exports, "default", () => $04d1d18b7149c6e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $hD6GJ = parcelRequire("hD6GJ");

var $fvQWm = parcelRequire("fvQWm");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eELJk = parcelRequire("eELJk");

var $en4Qn = parcelRequire("en4Qn");

var $hKSab = parcelRequire("hKSab");

var $fnaax = parcelRequire("fnaax");

var $j6pgF = parcelRequire("j6pgF");
const $04d1d18b7149c6e0$export$a4c456d2795197ba = ({ onClick: onClick, isDropdownItem: isDropdownItem = false, disableVotingProps: disableVotingProps = {
    isDisabled: false
}, onFieldUpdated: onFieldUpdated })=>{
    const { isDisabled: isDisabled, tooltips: tooltips } = disableVotingProps;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ value: value }, { toggleValue: toggleValue }] = (0, $hKSab.useVoteField)({
        onFieldUpdated: onFieldUpdated
    });
    const { buttonLabel: buttonLabel, disabledTooltip: disabledTooltip, ariaLabel: ariaLabel } = (0, $eUqFw.useMemo)(()=>value.hasVoted ? {
            buttonLabel: formatMessage((0, $en4Qn.default).removeVoteLabel),
            disabledTooltip: tooltips?.removeVote,
            ariaLabel: formatMessage((0, $eELJk.getLabelForToggleWithSelfVote)(), {
                votes: value.votes
            })
        } : {
            buttonLabel: formatMessage((0, $en4Qn.default).addVoteLabel),
            disabledTooltip: tooltips?.addVote,
            ariaLabel: formatMessage((0, $eELJk.getLabelForToggleWithoutSelfVote)(value.votes), {
                votes: value.votes
            })
        }, [
        value.hasVoted,
        value.votes,
        formatMessage,
        tooltips?.removeVote,
        tooltips?.addVote
    ]);
    const toggleVote = (0, $eUqFw.useCallback)(()=>{
        onClick?.();
        toggleValue(isDropdownItem);
    }, [
        isDropdownItem,
        onClick,
        toggleValue
    ]);
    if (isDropdownItem) {
        const itemAriaLabel = {
            'aria-label': !isDisabled || disabledTooltip === undefined ? undefined : disabledTooltip
        };
        const likeIcon = (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fvQWm))), {
            label: "",
            size: "medium",
            primaryColor: `var(--ds-icon-selected, ${(0, $PdmhA.B400)})`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j6pgF.default), {
            label: "",
            size: "medium"
        });
        const unlikeIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fvQWm))), {
            label: "",
            size: "medium"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            testId: "issue-field-voters.ui.vote-toggle.tooltip",
            content: !isDisabled || disabledTooltip === undefined ? null : disabledTooltip
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($04d1d18b7149c6e0$var$StyledDropdownItem, {
            elemBefore: value.hasVoted ? unlikeIcon : likeIcon,
            onClick: toggleVote,
            isDisabled: isDisabled,
            ...itemAriaLabel
        }, buttonLabel));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnaax.default), {
        tooltip: isDisabled ? disabledTooltip : buttonLabel,
        onClick: toggleVote,
        ariaLabel: isDisabled ? disabledTooltip : ariaLabel,
        isDisabled: isDisabled
    });
};
var $04d1d18b7149c6e0$export$2e2bcd8739ae039 = $04d1d18b7149c6e0$export$a4c456d2795197ba;
// eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04d1d18b7149c6e0$var$StyledDropdownItem = /*#__PURE__*/ (0, $kwce8.default)((0, $hD6GJ.default)).withConfig({
    componentId: "sc-1jn4s30-0"
})({
    '&&&': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"} 7px`
    }
});

});
parcelRegister("hKSab", function(module, exports) {

$parcel$export(module.exports, "useVoteField", () => $c07b0aaf754007b4$export$12c0518f12451881);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $lRmyA = parcelRequire("lRmyA");

var $k8Qyf = parcelRequire("k8Qyf");

var $hJ992 = parcelRequire("hJ992");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");


var $en4Qn = parcelRequire("en4Qn");

var $JJjCv = parcelRequire("JJjCv");

var $1AV57 = parcelRequire("1AV57");
const $c07b0aaf754007b4$var$saveField = ({ issueKey: issueKey, newValue: newValue, baseUrl: baseUrl })=>{
    if (newValue.hasVoted) return (0, $lRmyA.performPostRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/votes`);
    return (0, $lRmyA.performDeleteRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/votes`);
};
const $c07b0aaf754007b4$export$12c0518f12451881 = ({ onFieldUpdated: onFieldUpdated })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [, { setLoggedInUserActionVote: setLoggedInUserActionVote, setLoggedInUserActionUnvote: setLoggedInUserActionUnvote }] = (0, $JJjCv.useVotersList)();
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, (0, $b5480508c6d356f8$export$2124c2b3a156dbd6));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'schema.type', (0, $b5480508c6d356f8$export$2124c2b3a156dbd6));
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onFailure = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'failedValue' implicitly has an 'any' type.
    (_, failedValue)=>{
        showFlag({
            type: 'error',
            title: (0, $en4Qn.default).updateVoteFailedTitle,
            description: (0, $en4Qn.default).updateVoteFailedDescription
        });
        failedValue.hasVoted ? setLoggedInUserActionUnvote() : setLoggedInUserActionVote();
    }, [
        showFlag,
        setLoggedInUserActionUnvote,
        setLoggedInUserActionVote
    ]);
    const saveVoteField = (_issueKey, _fieldKey, newValue, baseUrl)=>$c07b0aaf754007b4$var$saveField({
            issueKey: issueKey,
            newValue: newValue,
            baseUrl: (0, $6vrw7.toBaseUrl)(baseUrl)
        });
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $b5480508c6d356f8$export$2124c2b3a156dbd6),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: {
            hasVoted: false,
            votes: 0
        },
        saveField: saveVoteField,
        onFailure: onFailure,
        onSuccess: onFieldUpdated
    });
    const toggleValue = (0, $eUqFw.useCallback)((isDropdownItem = false)=>{
        const didToggleOn = !value.hasVoted;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, didToggleOn ? 'voteAdded' : 'voteRemoved', {
            viewMode: isDropdownItem ? 'showVotersList' : 'hideVotersList'
        });
        // optimistic sync the voters store
        didToggleOn ? setLoggedInUserActionVote() : setLoggedInUserActionUnvote();
        saveValue((0, $1AV57.calculateVote)(didToggleOn, value), null, analyticsEvent);
    }, [
        value,
        createAnalyticsEvent,
        setLoggedInUserActionVote,
        setLoggedInUserActionUnvote,
        saveValue
    ]);
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            toggleValue: toggleValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("JJjCv", function(module, exports) {

$parcel$export(module.exports, "useVotersList", () => $759303fc9be18e0b$export$71aef39324a470d3);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $lRmyA = parcelRequire("lRmyA");

var $k8Qyf = parcelRequire("k8Qyf");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $lGLse = parcelRequire("lGLse");


var $en4Qn = parcelRequire("en4Qn");

var $bQ0xL = parcelRequire("bQ0xL");

var $hoIar = parcelRequire("hoIar");

var $jtqOv = parcelRequire("jtqOv");
const $759303fc9be18e0b$export$71aef39324a470d3 = ()=>{
    const [{ data: loggedInUserData }] = (0, $lGLse.useUserSubscriber)();
    const [voters, { setVoters: setVoters }] = (0, $bQ0xL.useVotersListStoreVoters)();
    const [loggedInUserAction, { setLoggedInUserAction: setLoggedInUserAction }] = (0, $bQ0xL.useVotersListStoreLoggedInUserAction)();
    const baseUrl = '';
    const issueKey = (0, $hJ992.useIssueKey)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [voteFieldValue, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $b5480508c6d356f8$export$2124c2b3a156dbd6)
    });
    const [serviceDidFetch, setServiceDidFetch] = (0, $eUqFw.useState)(false);
    const request = (0, $eUqFw.useCallback)(()=>(0, $lRmyA.performGetRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/votes`), [
        baseUrl,
        issueKey
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $eEzyV.useService)(request);
    const transformedVoters = (0, $eUqFw.useMemo)(()=>{
        if (data && data.voters) return data.voters.map((0, $jtqOv.transformServerUserToVoter));
        return voters;
    // Only run this hook when data changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (data && data.voters) {
            setVoters(transformedVoters);
            setServiceDidFetch(true);
        }
    }, [
        data,
        setVoters,
        transformedVoters
    ]);
    const visibleVoters = (0, $eUqFw.useMemo)(()=>{
        const loggedInUser = loggedInUserData ? (0, $jtqOv.transformServerUserToVoter)(loggedInUserData) : null;
        switch(loggedInUserAction){
            case (0, $hoIar.LOGGED_IN_USER_ACTION).ADDED:
                return (0, $jtqOv.addLoggedInUserToVoters)(transformedVoters, loggedInUser);
            case (0, $hoIar.LOGGED_IN_USER_ACTION).REMOVED:
                return (0, $jtqOv.removeLoggedInUserFromVoters)(transformedVoters, loggedInUser);
            default:
                return transformedVoters;
        }
    }, [
        loggedInUserData,
        loggedInUserAction,
        transformedVoters
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) showFlag({
            type: 'error',
            title: (0, $en4Qn.default).fetchVotersListFailedTitle,
            description: (0, $en4Qn.default).fetchVotersListFailedDescription
        });
    }, [
        error,
        showFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // re-sync the votes field store
        if (serviceDidFetch && voteFieldValue.votes !== visibleVoters.length) {
            const noLoggedInUserAction = loggedInUserAction === undefined;
            setFieldValue(issueKey, (0, $b5480508c6d356f8$export$2124c2b3a156dbd6), {
                ...voteFieldValue,
                votes: visibleVoters.length,
                hasVoted: noLoggedInUserAction ? voteFieldValue.hasVoted : loggedInUserAction === (0, $hoIar.LOGGED_IN_USER_ACTION).ADDED
            });
        }
        setServiceDidFetch(false);
    // Only run this hook when we receieve response from the server
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        serviceDidFetch
    ]);
    const setLoggedInUserActionVote = (0, $eUqFw.useCallback)(()=>{
        setLoggedInUserAction((0, $hoIar.LOGGED_IN_USER_ACTION).ADDED);
    }, [
        setLoggedInUserAction
    ]);
    const setLoggedInUserActionUnvote = (0, $eUqFw.useCallback)(()=>{
        setLoggedInUserAction((0, $hoIar.LOGGED_IN_USER_ACTION).REMOVED);
    }, [
        setLoggedInUserAction
    ]);
    const refreshVoters = (0, $eUqFw.useCallback)(()=>{
        if (!loading) fetch();
    }, [
        fetch,
        loading
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>({
            setLoggedInUserActionVote: setLoggedInUserActionVote,
            setLoggedInUserActionUnvote: setLoggedInUserActionUnvote,
            refreshVoters: refreshVoters
        }), [
        setLoggedInUserActionVote,
        refreshVoters,
        setLoggedInUserActionUnvote
    ]);
    return [
        {
            voters: visibleVoters,
            isFetching: loading,
            error: error
        },
        actions
    ];
};

});
parcelRegister("eEzyV", function(module, exports) {

$parcel$export(module.exports, "useService", () => $cbb15d4da2e9ab10$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $cbb15d4da2e9ab10$export$c963713a27525aaf);

var $eUqFw = parcelRequire("eUqFw");
const $cbb15d4da2e9ab10$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $eUqFw.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $eUqFw.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $cbb15d4da2e9ab10$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $eUqFw.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $cbb15d4da2e9ab10$export$6de4685a6c88b4e9(request, initialState);
    (0, $eUqFw.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});

parcelRegister("lGLse", function(module, exports) {

$parcel$export(module.exports, "UserContainer", () => $033cdb69b2583281$export$7ff085589970ee0a);
$parcel$export(module.exports, "useUserSubscriber", () => $033cdb69b2583281$export$4e61bbf568682a96);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $kdNL5 = parcelRequire("kdNL5");
const $033cdb69b2583281$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $033cdb69b2583281$var$Store = (0, $a61MH.createStore)({
    name: 'user',
    initialState: $033cdb69b2583281$var$initialState,
    actions: $kdNL5
});
const $033cdb69b2583281$export$7ff085589970ee0a = (0, $heB5U.createContainer)($033cdb69b2583281$var$Store);
const $033cdb69b2583281$export$4e61bbf568682a96 = (0, $ggKAj.createHook)($033cdb69b2583281$var$Store);

});
parcelRegister("kdNL5", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $dd4efebc20057365$export$e7aa7bc5c1b3cfb3);

var $1TLNE = parcelRequire("1TLNE");
const $dd4efebc20057365$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!params || currentState.loading || currentState.data && !forceRefetch) return;
        setState({
            loading: true
        });
        try {
            const data = await (0, $1TLNE.fetchData)({
                params: params,
                header: header
            });
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("1TLNE", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $7f578fc13a1a3e40$export$8134c072fddab6a5);

var $53ciZ = parcelRequire("53ciZ");

var $lRmyA = parcelRequire("lRmyA");
const $7f578fc13a1a3e40$export$8134c072fddab6a5 = ({ params: params, header: header })=>{
    const queryParams = {
        ...params,
        expand: Object.keys(params.expand || {}).filter((key)=>params.expand && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            params.expand[key])
    };
    const query = (0, $53ciZ.stringify)(queryParams, {
        arrayFormat: 'none'
    });
    const queryString = query ? `?${query}` : '';
    const requestUrl = `/rest/api/2/user${queryString}`;
    // @ts-expect-error - TS2345 - Argument of type '{ headers: HeaderParamForceAccountId; } | {}' is not assignable to parameter of type 'RequestInit | undefined'.
    return (0, $lRmyA.performGetRequest)(requestUrl, header ? {
        headers: header
    } : {});
};

});



parcelRegister("bQ0xL", function(module, exports) {

$parcel$export(module.exports, "useVotersListStoreVoters", () => $3f9df93a59244e2a$export$58ac79c706dadae0);
$parcel$export(module.exports, "useVotersListStoreLoggedInUserAction", () => $3f9df93a59244e2a$export$b03c3785ce522f2d);
$parcel$export(module.exports, "VotersListContainer", () => $3f9df93a59244e2a$export$dca8ca6486438911);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $8g3hr = parcelRequire("8g3hr");
const $3f9df93a59244e2a$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-voters',
    initialState: {
        voters: [],
        loggedInUserAction: undefined
    },
    actions: $8g3hr
});
const $3f9df93a59244e2a$var$getVoters = (state)=>state.voters;
const $3f9df93a59244e2a$var$getLoggedInUserAction = (state)=>state.loggedInUserAction;
const $3f9df93a59244e2a$export$58ac79c706dadae0 = (0, $ggKAj.createHook)($3f9df93a59244e2a$export$6f57813fe9f31bf9, {
    selector: $3f9df93a59244e2a$var$getVoters
});
const $3f9df93a59244e2a$export$b03c3785ce522f2d = (0, $ggKAj.createHook)($3f9df93a59244e2a$export$6f57813fe9f31bf9, {
    selector: $3f9df93a59244e2a$var$getLoggedInUserAction
});
const $3f9df93a59244e2a$export$dca8ca6486438911 = (0, $heB5U.createContainer)($3f9df93a59244e2a$export$6f57813fe9f31bf9);

});
parcelRegister("8g3hr", function(module, exports) {

$parcel$export(module.exports, "setVoters", () => $5746255d455e65e9$export$ac21b87ac21736c7);
$parcel$export(module.exports, "setLoggedInUserAction", () => $5746255d455e65e9$export$6ca6249c7ee7e477);
const $5746255d455e65e9$export$ac21b87ac21736c7 = (voters)=>({ setState: setState })=>{
        setState({
            voters: voters
        });
    };
const $5746255d455e65e9$export$6ca6249c7ee7e477 = (loggedInUserAction)=>({ setState: setState })=>{
        setState({
            loggedInUserAction: loggedInUserAction
        });
    };

});


parcelRegister("hoIar", function(module, exports) {

$parcel$export(module.exports, "LOGGED_IN_USER_ACTION", () => $7d0df51806105b7f$export$5c17246b48e158cf);
const $7d0df51806105b7f$export$5c17246b48e158cf = {
    ADDED: 'ADDED',
    REMOVED: 'REMOVED'
};

});

parcelRegister("jtqOv", function(module, exports) {

$parcel$export(module.exports, "addLoggedInUserToVoters", () => $6db1042a8262bf8d$export$a676994a8a739c64);
$parcel$export(module.exports, "removeLoggedInUserFromVoters", () => $6db1042a8262bf8d$export$1349a1b86e8b255);
$parcel$export(module.exports, "transformServerUserToVoter", () => $6db1042a8262bf8d$export$926dc6c95aaa02f3);

var $6vrw7 = parcelRequire("6vrw7");
const $6db1042a8262bf8d$export$a676994a8a739c64 = (voters, loggedInUser)=>{
    if (!loggedInUser || voters.findIndex((voter)=>voter.id === loggedInUser.id) !== -1) return voters;
    const newVoters = [
        ...voters,
        loggedInUser
    ];
    return newVoters.sort((v1, v2)=>v1.displayName.localeCompare(v2.displayName));
};
const $6db1042a8262bf8d$export$1349a1b86e8b255 = (voters, loggedInUser)=>{
    if (!loggedInUser) return voters;
    return voters.filter((voter)=>voter.id !== loggedInUser.id);
};
const $6db1042a8262bf8d$export$926dc6c95aaa02f3 = (user)=>({
        id: (0, $6vrw7.toAccountId)(user.accountId),
        displayName: user.displayName,
        avatarUrl: user.avatarUrls && user.avatarUrls['48x48']
    });

});


parcelRegister("1AV57", function(module, exports) {

$parcel$export(module.exports, "calculateVote", () => $040aac2cb3d13ac5$export$d6e31269930938aa);
const $040aac2cb3d13ac5$export$d6e31269930938aa = (didVote, value)=>{
    if (didVote) return {
        ...value,
        votes: value.votes + 1,
        hasVoted: true
    };
    return {
        ...value,
        votes: value.votes - 1,
        hasVoted: false
    };
};

});






parcelRegister("g4xFV", function(module, exports) {

$parcel$export(module.exports, "RightAligned", () => $32524247563ce72d$export$2a3b18dc26442f62);
$parcel$export(module.exports, "HeaderWrapper", () => $32524247563ce72d$export$960a49cc3d27a090);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c9TLT = parcelRequire("c9TLT");
const $32524247563ce72d$export$f1b28391e7683e79 = (0, $c9TLT.gridSize) * 2.5;
const $32524247563ce72d$export$2a3b18dc26442f62 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c _c71lzwfg _16jlkb7n _1o9zidpf _i0dl1wug _1bahesu3 _6myxpxbi _1loov47k",
            __cmplp.className
        ])
    });
});
const $32524247563ce72d$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tkezwfg _2hwxidpf _18u01wug _otyrv77o _4t3i1osq _4cvr1h6o _p12f1osq _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});

});


parcelRegister("dGpvN", function(module, exports) {

$parcel$export(module.exports, "HeaderBreadcrumbs", () => $508cc26a35b7bc9c$export$769be228bd55a997);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hJ992 = parcelRequire("hJ992");

var $5G3JL = parcelRequire("5G3JL");

var $jyFd9 = parcelRequire("jyFd9");

var $keOMr = parcelRequire("keOMr");

var $lqalZ = parcelRequire("lqalZ");

var $jZDJX = parcelRequire("jZDJX");

var $5DXDo = parcelRequire("5DXDo");

var $8DKOT = parcelRequire("8DKOT");

var $g4xFV = parcelRequire("g4xFV");

var $1HYWN = parcelRequire("1HYWN");
const $508cc26a35b7bc9c$export$ff9a4c6039f830f8 = ({ error: error = null, isCompact: isCompact, shouldShowProjectLevelBreadcrumb: shouldShowProjectLevelBreadcrumb = false, shouldShowRootProjectsBreadcrumb: shouldShowRootProjectsBreadcrumb = false })=>{
    const backButtonUrl = (0, $hJ992.useBackButtonUrl)();
    if (error !== null) return null;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbedMode = (0, $keOMr.useIsEmbedMode)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($508cc26a35b7bc9c$var$HeaderBreadcrumbsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($508cc26a35b7bc9c$var$LeftAligned, {
        isCompact: isCompact
    }, backButtonUrl !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5DXDo.default), {
        url: backButtonUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8DKOT.default), {
        externalId: "issue",
        shouldShowProjectLevelBreadcrumb: isEmbedMode ? false : shouldShowProjectLevelBreadcrumb,
        shouldShowRootProjectsBreadcrumb: isEmbedMode ? false : shouldShowRootProjectsBreadcrumb
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HYWN.IssueNavigator), null)));
};
const $508cc26a35b7bc9c$export$769be228bd55a997 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        error: (0, $jZDJX.errorSelector)(state)
    })))((0, $jyFd9.default)($508cc26a35b7bc9c$export$ff9a4c6039f830f8));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $508cc26a35b7bc9c$var$HeaderBreadcrumbsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $g4xFV.HeaderWrapper), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0idpf",
            __cmplp.className
        ])
    });
});
const $508cc26a35b7bc9c$var$LeftAligned = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompact: isCompact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _16jlkb7n _1reoewfl _18m9ewfl _1looidpf _6myxv47k",
            __cmplp.isCompact && "_1wyb1crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5DXDo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c7fd8b5eb7bfc0c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dXKde = parcelRequire("dXKde");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dpYvI = parcelRequire("dpYvI");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $y4muQ = parcelRequire("y4muQ");
var $9c7fd8b5eb7bfc0c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)(({ url: url })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'backFromIssueViewButton');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9c7fd8b5eb7bfc0c$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpYvI.BreadCrumbsButton), {
        href: url,
        appearance: "subtle",
        onClick: handleClick,
        component: __SPA__ ? (0, $kJlBc.Link) : undefined,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dXKde))), {
            label: "",
            size: "medium",
            primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N300})`
        })
    }, formatMessage((0, $y4muQ.default).back)));
});
const $9c7fd8b5eb7bfc0c$var$wrapperStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.150',
    marginLeft: 'space.negative.150'
});

});
parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a2a4a1e4b9148f86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M9.005 10.995l4.593-4.593a.99.99 0 111.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 01-1.4 1.4L9.005 12.41a1 1 0 010-1.414z"/></svg>`
    }, props));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;
module.exports.default = $a2a4a1e4b9148f86$var$_default;

});

parcelRegister("dpYvI", function(module, exports) {

$parcel$export(module.exports, "BreadCrumbsButton", () => $498d604621b1c366$export$c583952538a26cbb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $498d604621b1c366$export$c583952538a26cbb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12r21nn1 _1w901hzk _btpd1tcg _1kba1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("y4muQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b985ce936d0a09d5$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $b985ce936d0a09d5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    back: {
        "id": "issue.views.issue-base.foundation.back-button.back",
        "defaultMessage": "Back"
    }
});

});


parcelRegister("8DKOT", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a7998e1ed45aa85$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $hFmdR = parcelRequire("hFmdR");
var $eGI9v = parcelRequire("eGI9v");
var $6rCaY = parcelRequire("6rCaY");
var $8un0w = parcelRequire("8un0w");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $4ksts = parcelRequire("4ksts");

var $hJ992 = parcelRequire("hJ992");

var $8411R = parcelRequire("8411R");

var $f9RL0 = parcelRequire("f9RL0");

var $4QRaC = parcelRequire("4QRaC");

var $lqalZ = parcelRequire("lqalZ");

var $lV5H0 = parcelRequire("lV5H0");

var $1OJS4 = parcelRequire("1OJS4");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $1b2Vj = parcelRequire("1b2Vj");

var $9D3Vo = parcelRequire("9D3Vo");

var $igGhc = parcelRequire("igGhc");

var $lO4Or = parcelRequire("lO4Or");


var $kJlBc = parcelRequire("kJlBc");

var $8UC2I = parcelRequire("8UC2I");
const $5a7998e1ed45aa85$var$IssueBreadcrumbsWithHooks = ({ projectName: projectName, projectAvatarUrl: projectAvatarUrl, ...props })=>{
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const onIssueKeyChange = (0, $hJ992.useOnIssueKeyChange)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const intl = (0, $4ksts.useIntlV2)();
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, (0, $lO4Or.PARENT_TYPE));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue.issue-view.foundation.breadcrumbs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8UC2I.IssueBreadcrumbs), {
        pushAction: push,
        onIssueKeyChange: onIssueKeyChange,
        issueKey: issueKey,
        projectName: projectName || '',
        projectAvatarUrl: projectAvatarUrl || '',
        intl: intl,
        isEditable: fieldConfig?.value?.isEditable,
        ...props
    }));
};
const $5a7998e1ed45aa85$var$IssueBreadcrumbsWithStore = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $lqalZ.connect)((state)=>{
    const isSimplifiedProject = (0, $jZDJX.isSimplifiedProjectSelector)(state);
    return {
        error: (0, $jZDJX.errorSelector)(state),
        isSimplifiedProject: isSimplifiedProject,
        isLoadingComplete: (0, $jZDJX.isCompletedLoadingSelector)(state),
        issueSummary: (0, $fokFV.fieldPersistedValueSelector)((0, $f9RL0.SUMMARY))(state) || '',
        relativeIssueUrl: (0, $9D3Vo.issueUrlSelector)(state),
        fullIssueUrl: (0, $9D3Vo.fullIssueUrlSelector)(state),
        issueTypeName: (0, $9D3Vo.issueTypeNameSelector)(state),
        issueTypeIconUrl: (0, $9D3Vo.issueTypeIconUrlSelector)(state),
        parentIssues: (0, $9D3Vo.getParentIssuesSelector)(state),
        projectName: (0, $igGhc.projectNameSelector)(state),
        projectUrl: (0, $lV5H0.getProjectUrl)((0, $5JqpU.baseUrlSelector)(state), (0, $5JqpU.projectKeySelector)(state)),
        projectAvatarUrl: (0, $igGhc.projectAvatarUrlSelector)(state),
        // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'. | TS2345 - Argument of type '{}' is not assignable to parameter of type 'Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>'.
        isIssueTypeFieldEditable: (0, $9D3Vo.isIssueTypeFieldEditableSelector)(state),
        canLinkToParent: (0, $1b2Vj.canLinkToParentSelector)(state),
        issueHierarchyLevel: !isSimplifiedProject ? (0, $9D3Vo.issueTypeHierarchyLevelSelector)(state) : (0, $1b2Vj.hierarchyLevelSelector)(state),
        parentLevelIssueTypeNames: (0, $1b2Vj.parentLevelIssueTypeNamesSelector)(state)
    };
}, (dispatch)=>({
        onParentClick: ({ childIssueKey: childIssueKey, parentIssueKey: parentIssueKey, onIssueKeyChange: onIssueKeyChange })=>{
            onIssueKeyChange && onIssueKeyChange({
                fromIssueKey: childIssueKey,
                toIssueKey: parentIssueKey,
                meta: {
                    location: 'breadcrumbs'
                }
            });
            if (!__SPA__) dispatch((0, $1OJS4.navigateToNewIssue)({
                fromIssueKey: childIssueKey,
                toIssueKey: parentIssueKey
            }));
        },
        onProjectClick: (projectUrl, pushAction)=>{
            dispatch((0, $1OJS4.navigateToProject)(projectUrl, pushAction));
        }
    })), (0, $6rCaY.default)((state)=>{
    const analyticsSource = (0, $5JqpU.analyticsSourceSelector)(state);
    const isSimplifiedProject = (0, $jZDJX.isSimplifiedProjectSelector)(state);
    const project = (0, $igGhc.projectSelector)(state);
    return {
        attributes: {
            issueHierarchyLevel: (0, $1b2Vj.hierarchyLevelSelector)(state),
            analyticsSource: `issue-view (${String(analyticsSource)})`,
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject ? 'next-gen' : 'classic'
        },
        containerType: 'project',
        containerId: project ? `${project.projectId}` : ''
    };
}))($5a7998e1ed45aa85$var$IssueBreadcrumbsWithHooks);
var $5a7998e1ed45aa85$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $hFmdR.AnalyticsSource)('breadcrumbs', (0, $41ea3621645e2acc$export$f636b5b56f1d624a)), (0, $4QRaC.withViewExperienceTracker)('breadcrumbs'), (0, $eGI9v.default)('breadcrumbsItem', {
    onRootBreadcrumbClick: 'clicked',
    onProjectClick: 'clicked',
    onParentClick: 'clicked',
    onClick: 'clicked'
}), (0, $8un0w.default)({
    onCopyClick: 'copyUrlLink',
    onRootBreadcrumbClick: 'navigateToProjectsList',
    onProjectClick: 'navigateToProject',
    onParentClick: 'navigateToParentIssue',
    onClick: 'navigateToCurrentIssue'
}))($5a7998e1ed45aa85$var$IssueBreadcrumbsWithStore);

});
parcelRegister("6rCaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b495978a3e51511d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $aw5Sy = parcelRequire("aw5Sy");

var $lNNXV = parcelRequire("lNNXV");
var $1TrR5 = parcelRequire("1TrR5");

var $hZVJT = parcelRequire("hZVJT");

var $klunD = parcelRequire("klunD");
const $b495978a3e51511d$var$ReduxAnalyticsData = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToAnalytics, connectOptions = {})=>(WrappedComponent)=>{
        // eslint-disable-next-line jira/react/no-class-components
        class ComponentWrappedInAnalytics extends (0, $eUqFw.Component) {
            static{
                this.displayName = `ReduxAnalyticsData(${WrappedComponent.displayName || WrappedComponent.name})`;
            }
            static{
                this.defaultProps = {
                    analyticsContext: {}
                };
            }
            render() {
                const { analyticsContext: analyticsContext, ...componentProps } = this.props;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
                    data: analyticsContext
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, componentProps));
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const mapStateToProps = (state, ownProps)=>({
                analyticsContext: (0, $klunD.default)(mapStateToAnalytics(state, ownProps))
            });
        const mapStateToPropsFactory = ()=>{
            const analyticsContextSelectorInstance = (0, $5iWql.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (state, ownProps)=>(0, $klunD.default)(mapStateToAnalytics(state, ownProps)));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (state, ownProps)=>({
                    analyticsContext: analyticsContextSelectorInstance(state, ownProps)
                });
        };
        return (0, $lNNXV.connect)((0, $1TrR5.functionWithFFRedux)(mapStateToPropsFactory, // @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 2 or more, but got 0.
        mapStateToProps), ()=>({}), null, {
            // to prevent connected component from unnecessary re-render
            areStatePropsEqual: (nextProps, prevProps)=>{
                const { attributes: prevAttributes, ...prevFields } = prevProps.analyticsContext;
                const { attributes: nextAttributes, ...nextFields } = nextProps.analyticsContext;
                return (0, $hZVJT.default)(prevAttributes, nextAttributes) && (0, $hZVJT.default)(prevFields, nextFields);
            },
            ...connectOptions
        })(ComponentWrappedInAnalytics);
    };
var $b495978a3e51511d$export$2e2bcd8739ae039 = $b495978a3e51511d$var$ReduxAnalyticsData;

});
parcelRegister("hZVJT", function(module, exports) {

$parcel$export(module.exports, "default", () => $831c3a9dcafdabca$export$2e2bcd8739ae039);
const $831c3a9dcafdabca$var$isArrayEqual = (array1 = [], array2 = [])=>{
    if (array1 === array2) return true;
    // check one level deep
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};
var // one level check to see if object references are equal
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$831c3a9dcafdabca$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'never[]'.
    if (!$831c3a9dcafdabca$var$isArrayEqual(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        const value = obj1[key];
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        // @ts-expect-error - TS2345 - Argument of type 'any[]' is not assignable to parameter of type 'never[]'.
        return Array.isArray(nextValue) && Array.isArray(value) && $831c3a9dcafdabca$var$isArrayEqual(value, nextValue);
    });
    return areValuesEqual;
};

});


parcelRegister("8un0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $da3e17e369dbbaa5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $etqm0 = parcelRequire("etqm0");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $da3e17e369dbbaa5$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $eUqFw.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $da3e17e369dbbaa5$export$2e2bcd8739ae039 = $da3e17e369dbbaa5$var$fireWithUIAnalytics;

});

parcelRegister("lV5H0", function(module, exports) {

$parcel$export(module.exports, "getIssueHtmlUrl", () => $93884aef1f460cc2$export$980675a7de50ce0);
$parcel$export(module.exports, "getProjectUrl", () => $93884aef1f460cc2$export$951b86b8e730b952);
$parcel$export(module.exports, "getIssueApiUrl", () => $93884aef1f460cc2$export$d272fd56b6d0dc52);
$parcel$export(module.exports, "getSearchUrl", () => $93884aef1f460cc2$export$7d4675b206f57488);
$parcel$export(module.exports, "getIssueLinksUrl", () => $93884aef1f460cc2$export$ae795571d37c5406);
$parcel$export(module.exports, "getUnresolvedIssueHistoryUrlForLinking", () => $93884aef1f460cc2$export$4154e76bc75c99c);
$parcel$export(module.exports, "getAllIssuesHistoryUrl", () => $93884aef1f460cc2$export$f24e380684652fbd);
$parcel$export(module.exports, "getProjectCreateMetaUrl", () => $93884aef1f460cc2$export$32d9cfe7b3acbc06);
$parcel$export(module.exports, "getSaveIssueLinksUrl", () => $93884aef1f460cc2$export$56b511e89ffbb26d);
$parcel$export(module.exports, "getSaveRemoteIssueLinksUrl", () => $93884aef1f460cc2$export$a434563209b2c0d5);
$parcel$export(module.exports, "getConfluenceAppLinksUrl", () => $93884aef1f460cc2$export$978b4dafe600c258);
$parcel$export(module.exports, "getJiraAppLinksUrl", () => $93884aef1f460cc2$export$93f583c2c015af94);
$parcel$export(module.exports, "getRemoteUnresolvedIssueHistoryUrlForLinking", () => $93884aef1f460cc2$export$f29f072d4d7d83a6);
$parcel$export(module.exports, "getRemoteAllIssuesHistoryUrl", () => $93884aef1f460cc2$export$9f037c40a3c6354d);

var $6vrw7 = parcelRequire("6vrw7");
const $93884aef1f460cc2$var$JIRA_ISSUE_KEY_REGEX = /^([A-Z][A-Z0-9]+)-([0-9]*)$/i;
const $93884aef1f460cc2$var$parseProjectKey = (query)=>{
    if (query) {
        const parsedGroups = $93884aef1f460cc2$var$JIRA_ISSUE_KEY_REGEX.exec(query);
        if (parsedGroups && parsedGroups.length === 3) return parsedGroups[1];
    }
    return undefined;
};
const $93884aef1f460cc2$export$980675a7de50ce0 = (baseUrl, issueKey)=>(0, $6vrw7.toHref)(`${baseUrl}/browse/${issueKey}`);
const $93884aef1f460cc2$export$951b86b8e730b952 = (baseUrl, projectKey)=>(0, $6vrw7.toHref)(`${baseUrl}/browse/${projectKey}`);
const $93884aef1f460cc2$export$d272fd56b6d0dc52 = (baseUrl, issueKey)=>(0, $6vrw7.toHref)(`${baseUrl}/rest/api/2/issue/${issueKey}`);
const $93884aef1f460cc2$export$7d4675b206f57488 = (baseUrl)=>(0, $6vrw7.toHref)(`${baseUrl}/rest/api/2/search`);
const $93884aef1f460cc2$export$2b4ff0eccee89e88 = (baseUrl)=>(0, $6vrw7.toHref)(`${baseUrl}/rest/api/3/search`);
const $93884aef1f460cc2$export$ae795571d37c5406 = (baseUrl, issueKey)=>(0, $6vrw7.toHref)(`${baseUrl}/rest/api/2/issue/${issueKey}?fields=issuelinks`);
const $93884aef1f460cc2$export$861bc7e3177d2ead = (baseUrl, issueKey)=>(0, $6vrw7.toHref)(`${baseUrl}/rest/api/2/issue/${issueKey}`);
const $93884aef1f460cc2$export$8f5e67d216051900 = (baseUrl)=>(0, $6vrw7.toHref)(`${baseUrl}/rest/api/2/issueLinkType`);
const $93884aef1f460cc2$var$getIssuePickerUrl = (baseUrl, currentJQL, issueKey, query)=>(0, $6vrw7.toHref)(`${baseUrl}/rest/api/2/issue/picker?currentIssueKey=${issueKey}&showSubTasks=true&showSubTaskParent=true&query=${encodeURIComponent(query)}&currentJQL=${encodeURIComponent(currentJQL)}`);
// next-gen JSD issues may not have the resolution field and instead use statusCategory,
// but all others (classic JSD/JSW, next-gen JSW) prefer resolution
const $93884aef1f460cc2$var$unresolvedAndOrder = '(resolution = Unresolved or statusCategory != Done) ORDER BY priority DESC, updated DESC';
const $93884aef1f460cc2$export$4154e76bc75c99c = (baseUrl, issueKey, query)=>{
    let currentJQL = `project in projectsWhereUserHasPermission("Link Issues") AND ${$93884aef1f460cc2$var$unresolvedAndOrder}`;
    const projectKey = $93884aef1f460cc2$var$parseProjectKey(query);
    if (projectKey) currentJQL = `project = "${projectKey.toUpperCase()}" AND ${currentJQL}`;
    return $93884aef1f460cc2$var$getIssuePickerUrl(baseUrl, currentJQL, issueKey, query);
};
const $93884aef1f460cc2$export$f24e380684652fbd = (baseUrl, currentIssueKey, queryIssueKey)=>{
    let currentJQL = '';
    const projectKey = $93884aef1f460cc2$var$parseProjectKey(queryIssueKey);
    if (projectKey) currentJQL = `project = "${projectKey.toUpperCase()}" ORDER BY priority DESC, updated DESC`;
    return $93884aef1f460cc2$var$getIssuePickerUrl(baseUrl, currentJQL, currentIssueKey, queryIssueKey);
};
const $93884aef1f460cc2$export$32d9cfe7b3acbc06 = (baseUrl, projectKey)=>(0, $6vrw7.toHref)(`${baseUrl}/rest/api/2/issue/createmeta?projectKeys=${projectKey}&expand=projects.issuetypes.fields`);
const $93884aef1f460cc2$export$56b511e89ffbb26d = (baseUrl)=>(0, $6vrw7.toHref)(`${baseUrl}/rest/api/2/issueLink`);
const $93884aef1f460cc2$export$a434563209b2c0d5 = (baseUrl, currentIssueIdOrKey)=>(0, $6vrw7.toHref)(`${baseUrl}/rest/remoteJiraIssueLink/1/remoteJira/${currentIssueIdOrKey}/createIssueLink`);
const $93884aef1f460cc2$export$5647e6bbf2b3526f = (baseUrl)=>(0, $6vrw7.toHref)(`${baseUrl}/rest/graphql/1/`);
const $93884aef1f460cc2$var$changeboardingLastInteractedKey = 'jira.user.issue.changeboarding.lastinteracted';
const $93884aef1f460cc2$export$3c904884ce1bc59f = (baseUrl)=>(0, $6vrw7.toHref)(`${baseUrl}/rest/api/2/mypreferences?key=${$93884aef1f460cc2$var$changeboardingLastInteractedKey}`);
const $93884aef1f460cc2$export$978b4dafe600c258 = (baseUrl)=>(0, $6vrw7.toHref)(`${baseUrl}/rest/confluenceIssueLink/1/confluence/applink`);
const $93884aef1f460cc2$export$93f583c2c015af94 = (baseUrl, issueKey)=>(0, $6vrw7.toHref)(`${baseUrl}/rest/issueLinkAppLink/1/appLink/info?type=com.atlassian.applinks.api.application.jira.JiraApplicationType&issueIdOrKey=${issueKey}`);
const $93884aef1f460cc2$var$getRemoteIssuePickerUrl = (baseUrl, currentJQL, query, appLinkId)=>(0, $6vrw7.toHref)(`${baseUrl}/rest/remoteJiraIssueLink/1/remoteJira/picker?showSubTasks=true&showSubTaskParent=true&query=${encodeURIComponent(query)}&currentJQL=${encodeURIComponent(currentJQL)}&appId=${appLinkId}`);
const $93884aef1f460cc2$export$f29f072d4d7d83a6 = (baseUrl, query, appId)=>{
    let currentJQL = $93884aef1f460cc2$var$unresolvedAndOrder;
    const projectKey = $93884aef1f460cc2$var$parseProjectKey(query);
    if (projectKey) currentJQL = `project = "${projectKey.toUpperCase()}" AND ${currentJQL}`;
    return $93884aef1f460cc2$var$getRemoteIssuePickerUrl(baseUrl, currentJQL, query, appId);
};
const $93884aef1f460cc2$export$9f037c40a3c6354d = (baseUrl, queryIssueKey, appLinkId)=>{
    let currentJQL = '';
    const projectKey = $93884aef1f460cc2$var$parseProjectKey(queryIssueKey);
    if (projectKey) currentJQL = `project = "${projectKey.toUpperCase()}" ORDER BY priority DESC, updated DESC`;
    return $93884aef1f460cc2$var$getRemoteIssuePickerUrl(baseUrl, currentJQL, queryIssueKey, appLinkId);
};
const $93884aef1f460cc2$export$4a506dd972334914 = (baseUrl)=>(0, $6vrw7.toHref)(`${baseUrl}/rest/remoteJiraIssueLink/1/remoteJira/picker`);

});

parcelRegister("1OJS4", function(module, exports) {

$parcel$export(module.exports, "NAVIGATE_TO_NEW_ISSUE", () => $da88f02e99dbf408$export$d0ac6cb8ef1a1046);
$parcel$export(module.exports, "navigateToNewIssue", () => $da88f02e99dbf408$export$ad51bfb819159e8d);
$parcel$export(module.exports, "NAVIGATE_TO_PROJECT", () => $da88f02e99dbf408$export$4a5df21a621d5368);
$parcel$export(module.exports, "navigateToProject", () => $da88f02e99dbf408$export$3a7ca3dc4e5f85b);
$parcel$export(module.exports, "NAVIGATE_TO_SPRINT", () => $da88f02e99dbf408$export$5cfd1ece386b1673);
$parcel$export(module.exports, "navigateToSprint", () => $da88f02e99dbf408$export$bc4ae1ec1f5c845c);
$parcel$export(module.exports, "LOAD_NEW_ISSUE", () => $da88f02e99dbf408$export$91f493d7f98d90f7);
$parcel$export(module.exports, "loadNewIssue", () => $da88f02e99dbf408$export$6d1df46e423efe20);
$parcel$export(module.exports, "LOAD_RECENT_ISSUE", () => $da88f02e99dbf408$export$434e8157f3dabf7);
$parcel$export(module.exports, "loadRecentIssue", () => $da88f02e99dbf408$export$23e47b1e87713cf9);
const $da88f02e99dbf408$export$d0ac6cb8ef1a1046 = 'NAVIGATE_TO_NEW_ISSUE';
const $da88f02e99dbf408$export$ad51bfb819159e8d = ({ fromIssueKey: fromIssueKey, toIssueKey: toIssueKey })=>({
        type: $da88f02e99dbf408$export$d0ac6cb8ef1a1046,
        payload: {
            fromIssueKey: fromIssueKey,
            toIssueKey: toIssueKey
        }
    });
const $da88f02e99dbf408$export$4a5df21a621d5368 = 'NAVIGATE_TO_PROJECT';
const $da88f02e99dbf408$export$3a7ca3dc4e5f85b = (projectUrl, pushAction)=>({
        type: $da88f02e99dbf408$export$4a5df21a621d5368,
        payload: {
            projectUrl: projectUrl,
            pushAction: pushAction
        }
    });
const $da88f02e99dbf408$export$5cfd1ece386b1673 = 'NAVIGATE_TO_SPRINT';
const $da88f02e99dbf408$export$bc4ae1ec1f5c845c = (sprintId)=>({
        type: $da88f02e99dbf408$export$5cfd1ece386b1673,
        payload: {
            sprintId: sprintId
        }
    });
const $da88f02e99dbf408$export$91f493d7f98d90f7 = 'LOAD_NEW_ISSUE';
const $da88f02e99dbf408$export$6d1df46e423efe20 = (issueKey)=>({
        type: $da88f02e99dbf408$export$91f493d7f98d90f7,
        payload: {
            issueKey: issueKey
        }
    });
const $da88f02e99dbf408$export$434e8157f3dabf7 = 'LOAD_RECENT_ISSUE';
const $da88f02e99dbf408$export$23e47b1e87713cf9 = (issueKey, issueState)=>({
        type: $da88f02e99dbf408$export$434e8157f3dabf7,
        payload: {
            issueKey: issueKey,
            issueState: issueState
        }
    });

});

parcelRegister("igGhc", function(module, exports) {

$parcel$export(module.exports, "projectSelector", () => $3d1ba2e9fb18d1c3$export$852a6c34ff1a2e77);
$parcel$export(module.exports, "projectNameSelector", () => $3d1ba2e9fb18d1c3$export$aa9f20f9c212aac2);
$parcel$export(module.exports, "projectAvatarUrlSelector", () => $3d1ba2e9fb18d1c3$export$ca1574af8d67d649);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $3d1ba2e9fb18d1c3$export$852a6c34ff1a2e77 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.project);
const $3d1ba2e9fb18d1c3$export$aa9f20f9c212aac2 = (0, $df4Sl.createSelector)($3d1ba2e9fb18d1c3$export$852a6c34ff1a2e77, (project)=>project ? project.projectName : null);
const $3d1ba2e9fb18d1c3$export$ca1574af8d67d649 = (0, $df4Sl.createSelector)($3d1ba2e9fb18d1c3$export$852a6c34ff1a2e77, (project)=>project ? project.avatarUrl : null);

});

parcelRegister("8UC2I", function(module, exports) {

$parcel$export(module.exports, "IssueBreadcrumbs", () => $7eb636a28e1628ea$export$3719fea556ec58e8);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $bm5l8 = parcelRequire("bm5l8");
var $asKFY = parcelRequire("asKFY");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $3l6tm = parcelRequire("3l6tm");

var $jMP2a = parcelRequire("jMP2a");

var $6vrw7 = parcelRequire("6vrw7");

var $ivR9L = parcelRequire("ivR9L");

var $3HUo3 = parcelRequire("3HUo3");

var $5zHtE = parcelRequire("5zHtE");

var $3AaYy = parcelRequire("3AaYy");

var $jgeG5 = parcelRequire("jgeG5");

var $1o3dn = parcelRequire("1o3dn");
class $7eb636a28e1628ea$export$3719fea556ec58e8 extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'IssueBreadcrumbs';
    }
    static{
        this.defaultProps = {
            isSimplifiedProject: false,
            isLoadingComplete: false,
            issueTypeName: '',
            issueTypeIconUrl: '',
            issueHierarchyLevel: 0,
            shouldShowRootProjectsBreadcrumb: false,
            error: null,
            parentIssues: [],
            onCopyClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onExperienceSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    componentDidMount() {
        this.props.onExperienceSuccess();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.parentIssues.length > 0 !== this.props.parentIssues.length > 0 && this.isFocusReturnToTrigger) // Set the focus back to trigger while view changing between add parent to edit parent buttons
        requestAnimationFrame(()=>{
            this.parentTriggerRef.current?.focus();
            this.isFocusReturnToTrigger = false;
        });
        else this.isFocusReturnToTrigger = false;
    }
    render() {
        const { error: error, isSimplifiedProject: isSimplifiedProject, isLoadingComplete: isLoadingComplete, shouldShowProjectLevelBreadcrumb: shouldShowProjectLevelBreadcrumb, shouldShowRootProjectsBreadcrumb: shouldShowRootProjectsBreadcrumb, projectName: projectName, projectUrl: projectUrl, projectAvatarUrl: projectAvatarUrl, parentIssues: parentIssues, isIssueTypeFieldEditable: isIssueTypeFieldEditable, issueKey: issueKey, issueTypeName: issueTypeName, issueTypeIconUrl: issueTypeIconUrl, relativeIssueUrl: relativeIssueUrl, fullIssueUrl: fullIssueUrl, onCopyClick: onCopyClick, intl: { formatMessage: formatMessage }, canLinkToParent: canLinkToParent, issueHierarchyLevel: issueHierarchyLevel, parentLevelIssueTypeNames: parentLevelIssueTypeNames, isEditable: isEditable } = this.props;
        const hasParents = parentIssues.length > 0;
        const isIssueParentSwitcherReady = canLinkToParent && error === null && isLoadingComplete;
        const isParentEditable = isEditable !== undefined ? isEditable : true;
        const showIssueParentSwitcher = isParentEditable && (isSimplifiedProject && issueHierarchyLevel === (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_BASE) || !isSimplifiedProject) && isIssueParentSwitcherReady;
        const extraProps = {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            triggerRef: this.parentTriggerRef,
            onAddOrRemoveParent: this.onAddOrRemoveParent
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1o3dn.BreadcrumbsWrapper), {
            "data-component-selector": (0, $1o3dn.BREADCRUMBS_WRAPPER_SELECTOR_NAME)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $asKFY.default), {
            maxItems: 5,
            label: (0, $1ybV0.ff)('jca11y-1358-new-issue-navigator-issue-view-inappropriate-label-used-for-landmark_th9pe') ? formatMessage((0, $5zHtE.default).breadcrumbNavLabel) : undefined
        }, shouldShowRootProjectsBreadcrumb && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7eb636a28e1628ea$var$BreadcrumbsProjectsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bm5l8.default), {
            /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.foundation.breadcrumbs.item",
            href: "/jira/projects",
            text: formatMessage((0, $5zHtE.default).rootProjectsLink),
            onClick: this.onRootBreadcrumbClick
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jgeG5.default), {
            shouldShowProjectLevelBreadcrumb: shouldShowProjectLevelBreadcrumb,
            projectName: projectName,
            projectUrl: projectUrl,
            projectAvatarUrl: projectAvatarUrl,
            onClick: this.onProjectClick
        }), hasParents ? parentIssues.map((parentIssue, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3AaYy.default), {
                key: index,
                isSimplifiedProject: isSimplifiedProject,
                isDisabled: !isParentEditable || !isIssueParentSwitcherReady,
                parentIssue: parentIssue,
                currentIssueKey: issueKey,
                issueHierarchyLevel: issueHierarchyLevel,
                onClick: this.onParentClick(parentIssue ? parentIssue.key : ''),
                ...extraProps
            })) : showIssueParentSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ivR9L.default), {
            isSimplifiedProject: isSimplifiedProject,
            issueTypeName: parentLevelIssueTypeNames[0],
            issueHierarchyLevel: issueHierarchyLevel,
            ...extraProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3HUo3.default), {
            isSimplifiedProject: isSimplifiedProject,
            isIssueTypeFieldEditable: isIssueTypeFieldEditable,
            issueKey: issueKey,
            issueTypeName: issueTypeName,
            issueTypeIconUrl: issueTypeIconUrl,
            relativeIssueUrl: relativeIssueUrl,
            fullIssueUrl: fullIssueUrl,
            onClick: this.onClick,
            onCopyClick: onCopyClick
        })));
    }
    constructor(...args){
        super(...args);
        this.parentTriggerRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.isFocusReturnToTrigger = false;
        this.onClick = (event)=>{
            this.props.onClick(event);
        };
        this.onProjectClick = (event)=>{
            if (event.ctrlKey || event.metaKey || event.shiftKey) return;
            event.preventDefault();
            const { projectUrl: projectUrl, onProjectClick: onProjectClick } = this.props;
            projectUrl && onProjectClick(projectUrl, this.props.pushAction);
        };
        this.onParentClick = (parentIssueKey)=>(event, analyticsEvent)=>{
                if (event.ctrlKey || event.metaKey || event.shiftKey) return;
                event.preventDefault();
                const { onParentClick: onParentClick, issueKey: issueKey } = this.props;
                const parentKey = (0, $6vrw7.toIssueKey)(parentIssueKey);
                onParentClick({
                    childIssueKey: issueKey,
                    parentIssueKey: parentKey,
                    onIssueKeyChange: this.props.onIssueKeyChange
                });
                if (analyticsEvent) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'breadcrumbsParentIssue clicked');
                else (0, $guiFP.default)({
                    error: new Error('analyticsEvent is required'),
                    meta: {
                        id: 'breadcrumbs',
                        /* eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics */ packageName: 'jiraIssueView',
                        teamName: 'bento'
                    }
                });
            };
        this.onRootBreadcrumbClick = (event)=>{
            if (event.ctrlKey || event.metaKey || event.shiftKey) return;
            const { onRootBreadcrumbClick: onRootBreadcrumbClick } = this.props;
            onRootBreadcrumbClick();
        };
        this.onAddOrRemoveParent = ()=>{
            this.isFocusReturnToTrigger = true;
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7eb636a28e1628ea$var$BreadcrumbsProjectsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2hwxv77o _4cvr1h6o _19bv1b66 _18u0r5cr _1ywu1txw _aetr1n76 _tua5idpf _gkt51h6o _z0aiftgi _18d3otz2 _1h9u1oud",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bm5l8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6802065d7b1f5207$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7rh0R = parcelRequire("7rh0R");

var $XHGTv = parcelRequire("XHGTv");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $5eukW = parcelRequire("5eukW");

var $fwtof = parcelRequire("fwtof");
function $6802065d7b1f5207$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6802065d7b1f5207$var$height = (0, $lcnyw.gridSize)() * 3 / (0, $lcnyw.fontSize)();

const $6802065d7b1f5207$var$AKTooltip = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("18Hlr")), {
    ssr: false,
    moduleId: "../platform/packages/design-system/tooltip/src/index.ts"
});
const $6802065d7b1f5207$var$itemWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    maxWidth: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${$6802065d7b1f5207$var$height}em`,
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    flexDirection: 'row',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: `${$6802065d7b1f5207$var$height}em`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:not(:last-child)::after': {
        width: '8px',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-100, 8px)"}`,
        flexShrink: 0,
        content: '"/"',
        textAlign: 'center'
    }
});
const $6802065d7b1f5207$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $6802065d7b1f5207$var$ICON_WIDTH_ESTIMATE = 24;
const $6802065d7b1f5207$var$staticItemWithTruncationStyles = /*#__PURE__*/ (0, $byn9U.css)({
    maxWidth: `var(${$6802065d7b1f5207$var$VAR_STEP_TRUNCATION_WIDTH})`,
    fontWeight: "var(--ds-font-weight-regular, 400)"
});
const $6802065d7b1f5207$var$staticItemWithoutTruncationStyles = {
    name: "yaiu3b",
    styles: "min-width:0;flex-shrink:1;font-weight:var(--ds-font-weight-regular, 400)"
};
const $6802065d7b1f5207$var$BreadcrumbsItem = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const buttonRef = (0, $eUqFw.useRef)(null);
    const { truncationWidth: truncationWidth, text: text, onTooltipShown: onTooltipShown, ...restButtonProps } = props;
    // If icons are provided we include their width in the truncation calculation to ensure we're as accurate as possible.
    // Note: this assumes icons are 24px wide which should be almost always.
    // Not really an issue if the icons are smaller, just that truncation occurs slightly earlier than you may want.
    let iconWidthAllowance = 0;
    if (props.iconBefore) iconWidthAllowance += $6802065d7b1f5207$var$ICON_WIDTH_ESTIMATE;
    if (props.iconAfter) iconWidthAllowance += $6802065d7b1f5207$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, showTooltip] = (0, $fwtof.default)(truncationWidth, buttonRef.current, iconWidthAllowance);
    const buttonProps = {
        ...restButtonProps,
        ref: buttonRef,
        hasOverflow: hasOverflow
    };
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$6802065d7b1f5207$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = truncationWidth ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $5eukW.default), {
        ...buttonProps,
        css: $6802065d7b1f5207$var$staticItemWithTruncationStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicItemStyles
    }, text) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $5eukW.default), {
        ...buttonProps,
        css: $6802065d7b1f5207$var$staticItemWithoutTruncationStyles
    }, text);
    if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.remove-lazy-loading-of-tooltip-in-breadcrumbs_pki8p')) return /*#__PURE__*/ (0, $byn9U.jsx)("li", {
        css: $6802065d7b1f5207$var$itemWrapperStyles
    }, showTooltip ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: text,
        position: "bottom",
        onShow: onTooltipShown
    }, step) : step);
    return /*#__PURE__*/ (0, $byn9U.jsx)("li", {
        css: $6802065d7b1f5207$var$itemWrapperStyles
    }, showTooltip ? /* The div exists because of tooltip */ /*#__PURE__*/ (0, $byn9U.jsx)((0, $7rh0R.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $byn9U.jsx)("div", null, step)
    }, /*#__PURE__*/ (0, $byn9U.jsx)($6802065d7b1f5207$var$AKTooltip, {
        content: text,
        position: "bottom",
        onShow: onTooltipShown
    }, step)) : step);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6802065d7b1f5207$export$2e2bcd8739ae039 = $6802065d7b1f5207$var$BreadcrumbsItem;

});
parcelRegister("5eukW", function(module, exports) {

$parcel$export(module.exports, "default", () => $69c4b1ea675a45cb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $7u4fN = parcelRequire("7u4fN");

var $5Q9wj = parcelRequire("5Q9wj");
const $69c4b1ea675a45cb$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: undefined,
    packageVersion: undefined
};
const $69c4b1ea675a45cb$var$noop = (0, $5Q9wj.default);
var $69c4b1ea675a45cb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ hasOverflow: hasOverflow = true, href: href = '#', onClick: onClickProvided = $69c4b1ea675a45cb$var$noop, analyticsContext: analyticsContext, iconBefore: iconBefore, iconAfter: iconAfter, ...props }, ref)=>{
    const handleClicked = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$69c4b1ea675a45cb$var$analyticsAttributes
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        spacing: "none",
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        href: href,
        ...props
    });
});

});

parcelRegister("fwtof", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae4167537c909a75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $ae4167537c909a75$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $eUqFw.useState)(true);
    const [showTooltip, setShowTooltip] = (0, $eUqFw.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $eUqFw.useEffect)(()=>{
        if (truncationWidth && buttonRefCurrent) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});

parcelRegister("18Hlr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('d9TBY');
        const value = parcelRequire('fxbL4');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("d9TBY").then(()=>parcelRequire('fxbL4'));
}

});


parcelRegister("asKFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fe49be245af1af9$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $PdmhA = parcelRequire("PdmhA");

var $1xCDT = parcelRequire("1xCDT");

var $f8Yph = parcelRequire("f8Yph");
function $5fe49be245af1af9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5fe49be245af1af9$var$defaultMaxItems = 8;
const $5fe49be245af1af9$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $5fe49be245af1af9$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $5fe49be245af1af9$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children;
const $5fe49be245af1af9$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: undefined,
    packageVersion: undefined
};
const $5fe49be245af1af9$var$noop = (0, $5Q9wj.default);
const $5fe49be245af1af9$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $5fe49be245af1af9$var$breadcrumbStyles = {
    name: "m6vsls",
    styles: "display:flex;margin:var(--ds-space-0, 0px);padding:var(--ds-space-0, 0px);flex-wrap:wrap"
};
const $5fe49be245af1af9$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, isNavigation: isNavigation = true, maxItems: maxItems = $5fe49be245af1af9$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $5fe49be245af1af9$var$noop, analyticsContext: analyticsContext, label: label = $5fe49be245af1af9$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $5fe49be245af1af9$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $eUqFw.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $eUqFw.useState)(false);
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $5fe49be245af1af9$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealed = ()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($5fe49be245af1af9$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    };
    (0, $f8Yph.useOnRevealed)(focusFirstRevealed, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$5fe49be245af1af9$var$analyticsAttributes
    });
    const childrenArray = $5fe49be245af1af9$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $byn9U.jsx)((0, $1xCDT.default), {
                key: "ellipsis",
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    const Component = isNavigation ? 'nav' : 'div';
    return /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        "aria-label": label,
        ref: (0, $1lQG9.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)("ol", {
        "data-testid": testId,
        css: $5fe49be245af1af9$var$breadcrumbStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`
        }
    }, breadcrumbsItems));
});
const $5fe49be245af1af9$var$Breadcrumbs = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)($5fe49be245af1af9$var$InnerBreadcrumbs, {
        ...props,
        ref: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5fe49be245af1af9$export$2e2bcd8739ae039 = $5fe49be245af1af9$var$Breadcrumbs;

});
parcelRegister("1xCDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $253eb3de3ba0dc58$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7u4fN = parcelRequire("7u4fN");

var $5Q9wj = parcelRequire("5Q9wj");

var $lcnyw = parcelRequire("lcnyw");
const $253eb3de3ba0dc58$var$height = (0, $lcnyw.gridSize)() * 3 / (0, $lcnyw.fontSize)();
const $253eb3de3ba0dc58$var$noop = (0, $5Q9wj.default);
const $253eb3de3ba0dc58$var$itemWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    maxWidth: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${$253eb3de3ba0dc58$var$height}em`,
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    flexDirection: 'row',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: `${$253eb3de3ba0dc58$var$height}em`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:not(:last-child)::after': {
        width: "var(--ds-space-100, 8px)",
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-100, 8px)"}`,
        flexShrink: 0,
        content: '"/"',
        textAlign: 'center'
    }
});
const $253eb3de3ba0dc58$var$EllipsisItem = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { onClick: onClick = $253eb3de3ba0dc58$var$noop, testId: testId, label: label } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("li", {
        css: $253eb3de3ba0dc58$var$itemWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        appearance: "subtle-link",
        spacing: "none",
        testId: testId,
        onClick: onClick,
        "aria-label": label
    }, "\u2026"));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$253eb3de3ba0dc58$export$2e2bcd8739ae039 = $253eb3de3ba0dc58$var$EllipsisItem;

});

parcelRegister("f8Yph", function(module, exports) {

$parcel$export(module.exports, "useOnRevealed", () => $3d09583e8ce00568$export$e9c4922b2ecf808a);

var $eUqFw = parcelRequire("eUqFw");

var $d7Ieg = parcelRequire("d7Ieg");
function $3d09583e8ce00568$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $d7Ieg.default)(isExpanded);
    (0, $eUqFw.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});


parcelRegister("ivR9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c25a199c2634396$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");


var $h8auO = parcelRequire("h8auO");

var $aWUQ5 = parcelRequire("aWUQ5");

var $5zHtE = parcelRequire("5zHtE");

var $1o3dn = parcelRequire("1o3dn");
const $4c25a199c2634396$export$ea8cb745998276ab = ({ isSimplifiedProject: isSimplifiedProject = false, issueTypeName: issueTypeName = (0, $b0dbf452addbddfb$export$cb17e3c17bc50301), issueHierarchyLevel: issueHierarchyLevel, triggerRef: triggerRef = {
    current: null
}, onAddOrRemoveParent: onAddOrRemoveParent = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const breadcrumbsItemRef = (0, $eUqFw.useRef)();
    const target = issueTypeName && issueTypeName !== (0, $b0dbf452addbddfb$export$cb17e3c17bc50301) ? issueTypeName : (0, $b0dbf452addbddfb$export$cb17e3c17bc50301).toLowerCase();
    /**
   * - For orphan issues in TMP projects, we display "Add <issueTypeName>"
   * - For orphan issues in CMP projects, we display "Add parent"
   *
   * See https://hello.jira.atlassian.cloud/browse/JPO-25790 for future reference
   *
   * @returns MessageDescriptor
   */ const getIssueParentSwitcherLabel = ()=>{
        if (isSimplifiedProject) return formatMessage((0, $5zHtE.default).addParent, {
            target: target
        });
        return formatMessage((0, $5zHtE.default).addParentLabel);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1o3dn.IssueContainer), {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "issue.views.issue-base.foundation.breadcrumbs.add-parent.breadcrumb-add-parent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h8auO.default), {
        clickRef: breadcrumbsItemRef,
        isOpen: isOpen,
        isOrphan: true,
        issueTypeName: issueTypeName,
        onOpenChange: (newIsOpenState)=>setIsOpen(newIsOpenState),
        text: (0, $aWUQ5.truncateBreadcrumbs)(getIssueParentSwitcherLabel()),
        issueHierarchyLevel: issueHierarchyLevel,
        onAddOrRemoveParent: onAddOrRemoveParent,
        triggerRef: triggerRef
    }));
};
var $4c25a199c2634396$export$2e2bcd8739ae039 = $4c25a199c2634396$export$ea8cb745998276ab;

});
parcelRegister("h8auO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c0d2d14439e4290$export$2e2bcd8739ae039);

var $1ngde = parcelRequire("1ngde");

var $8un0w = parcelRequire("8un0w");

var $1ybV0 = parcelRequire("1ybV0");

var $5G3JL = parcelRequire("5G3JL");

var $g0N0Z = parcelRequire("g0N0Z");

var $lqalZ = parcelRequire("lqalZ");

var $2W4Cf = parcelRequire("2W4Cf");

var $jZDJX = parcelRequire("jZDJX");

var $cAorm = parcelRequire("cAorm");

var $ke6cX = parcelRequire("ke6cX");

var $arB8a = parcelRequire("arB8a");
var $1c0d2d14439e4290$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $1ngde.default)({
    componentName: 'dropdownMenu'
}), (0, $8un0w.default)({
    onToggle: 'toggled',
    onClick: 'clicked'
}), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ projectId: number | null; issueTypes: IssueType[]; issues: Issue[]; issueParents: IssueParent[]; isSimplifiedProject: boolean; } & { fetchIssueParents: () => void; setIssueParent: (issues: Issue[], parentId?: string | undefined) => void; setIssueParentOptimistic: (issues: Issue[...' is not assignable to parameter of type 'FlowStep<WithUIAnalyticsEvent<PropsWithoutRef<PropsWithoutRef<LibraryManagedAttributes<Component, Props & WithContextProps>> & RefAttributes<...>>, { ...; }>, ConnectedComponent<...>>'.
(0, $lqalZ.connect)((state)=>({
        projectId: (0, $jZDJX.projectIdSelector)(state),
        issueTypes: (0, $ke6cX.issueTypesSelector)(state),
        issues: (0, $cAorm.assignIssueParentModalIssuesSelector)(state),
        issueParents: (0, $jZDJX.parentLevelIssuesSelector)(state),
        isSimplifiedProject: (0, $jZDJX.isSimplifiedProjectSelector)(state)
    }), (dispatch)=>({
        fetchIssueParents: ()=>{
            dispatch((0, $1ybV0.ff)('com.atlassian.jira.customhierarchy.parent.candidates.with.info.endpoints.enabled') ? (0, $2W4Cf.fetchIssueParentsWithInfoRequest)() : (0, $2W4Cf.fetchIssueParentsRequest)());
        },
        setIssueParent: (issues, parentId)=>{
            dispatch(parentId ? (0, $2W4Cf.setParentRequest)(issues, parentId) : (0, $2W4Cf.unsetParentRequest)(issues));
        },
        setIssueParentOptimistic: (issues, parent)=>{
            dispatch((0, $2W4Cf.setParentOptimistic)(issues, parent, Promise.resolve()));
        },
        onViewAllParentsClick: ()=>{
            (0, $g0N0Z.epicModalOpenInteraction).start();
            dispatch((0, $2W4Cf.showAssignIssueParentModal)());
        }
    })))((0, $arB8a.default));

});
parcelRegister("2W4Cf", function(module, exports) {

$parcel$export(module.exports, "SHOW_ASSIGN_ISSUE_PARENT_MODAL", () => $141fb605cbba55d1$export$a1239bded0580595);
$parcel$export(module.exports, "showAssignIssueParentModal", () => $141fb605cbba55d1$export$bde7b0aee6aed1e);
$parcel$export(module.exports, "HIDE_ASSIGN_ISSUE_PARENT_MODAL", () => $141fb605cbba55d1$export$5a2556acdb3df33b);
$parcel$export(module.exports, "hideAssignIssueParentModal", () => $141fb605cbba55d1$export$bac41e77c8fec802);
$parcel$export(module.exports, "FETCH_ISSUE_PARENTS_REQUEST", () => $141fb605cbba55d1$export$21f69bdd7ba8b193);
$parcel$export(module.exports, "FETCH_ISSUE_PARENTS_WITH_INFO_REQUEST", () => $141fb605cbba55d1$export$7d17e33748287210);
$parcel$export(module.exports, "fetchIssueParentsRequest", () => $141fb605cbba55d1$export$36e385314e692f10);
$parcel$export(module.exports, "fetchIssueParentsWithInfoRequest", () => $141fb605cbba55d1$export$3a5b21b1eb2041c1);
$parcel$export(module.exports, "FETCH_ISSUE_PARENTS_SUCCESS", () => $141fb605cbba55d1$export$508e8a99e28c8ba6);
$parcel$export(module.exports, "FETCH_ISSUE_PARENTS_WITH_INFO_SUCCESS", () => $141fb605cbba55d1$export$e28772b0e8246b07);
$parcel$export(module.exports, "fetchIssueParentsSuccess", () => $141fb605cbba55d1$export$6aae00e95296228);
$parcel$export(module.exports, "fetchIssueParentsWithInfoSuccess", () => $141fb605cbba55d1$export$4a639f3abbd5eb4b);
$parcel$export(module.exports, "fetchIssueParentsFailure", () => $141fb605cbba55d1$export$cb3e70c7802e157a);
$parcel$export(module.exports, "SET_PARENT_REQUEST", () => $141fb605cbba55d1$export$a9997889c2786335);
$parcel$export(module.exports, "setParentRequest", () => $141fb605cbba55d1$export$456590193fae2157);
$parcel$export(module.exports, "SET_PARENT_OPTIMISTIC", () => $141fb605cbba55d1$export$f12fa57c5a24cc9f);
$parcel$export(module.exports, "setParentOptimistic", () => $141fb605cbba55d1$export$c2dcedde7d23b594);
$parcel$export(module.exports, "UNSET_PARENT_REQUEST", () => $141fb605cbba55d1$export$28936e606d963d);
$parcel$export(module.exports, "unsetParentRequest", () => $141fb605cbba55d1$export$361639149c1ff558);
$parcel$export(module.exports, "SET_PARENT_SUCCESS", () => $141fb605cbba55d1$export$4bb036ce8efdbcff);
$parcel$export(module.exports, "setParentSuccess", () => $141fb605cbba55d1$export$6db24407ee10b2d3);
$parcel$export(module.exports, "UNSET_PARENT_SUCCESS", () => $141fb605cbba55d1$export$fe453787af036e5f);
$parcel$export(module.exports, "unsetParentSuccess", () => $141fb605cbba55d1$export$60feaf55fd14c76a);
const $141fb605cbba55d1$export$a1239bded0580595 = 'SHOW_ASSIGN_ISSUE_PARENT_MODAL';
const $141fb605cbba55d1$export$bde7b0aee6aed1e = ()=>({
        type: $141fb605cbba55d1$export$a1239bded0580595
    });
const $141fb605cbba55d1$export$5a2556acdb3df33b = 'HIDE_ASSIGN_ISSUE_PARENT_MODAL';
const $141fb605cbba55d1$export$bac41e77c8fec802 = ()=>({
        type: $141fb605cbba55d1$export$5a2556acdb3df33b
    });
const $141fb605cbba55d1$export$21f69bdd7ba8b193 = 'FETCH_ISSUE_PARENTS_REQUEST';
const $141fb605cbba55d1$export$7d17e33748287210 = 'FETCH_ISSUE_PARENTS_WITH_INFO_REQUEST';
const $141fb605cbba55d1$export$36e385314e692f10 = ()=>({
        type: $141fb605cbba55d1$export$21f69bdd7ba8b193
    });
const $141fb605cbba55d1$export$3a5b21b1eb2041c1 = ()=>({
        type: $141fb605cbba55d1$export$7d17e33748287210
    });
const $141fb605cbba55d1$export$508e8a99e28c8ba6 = 'FETCH_ISSUE_PARENTS_SUCCESS';
const $141fb605cbba55d1$export$e28772b0e8246b07 = 'FETCH_ISSUE_PARENTS_WITH_INFO_SUCCESS';
const $141fb605cbba55d1$export$6aae00e95296228 = (issueParents = [])=>({
        type: $141fb605cbba55d1$export$508e8a99e28c8ba6,
        payload: issueParents
    });
const $141fb605cbba55d1$export$4a639f3abbd5eb4b = (issueParentsWithInfo = {
    candidates: []
})=>({
        type: $141fb605cbba55d1$export$e28772b0e8246b07,
        payload: issueParentsWithInfo
    });
const $141fb605cbba55d1$export$9b00a612c76291ba = 'FETCH_ISSUE_PARENTS_FAILURE';
const $141fb605cbba55d1$export$cb3e70c7802e157a = ()=>({
        type: $141fb605cbba55d1$export$9b00a612c76291ba
    });
const $141fb605cbba55d1$export$a9997889c2786335 = 'SET_PARENT_REQUEST';
const $141fb605cbba55d1$export$456590193fae2157 = (issues, parentId)=>({
        type: $141fb605cbba55d1$export$a9997889c2786335,
        payload: {
            issues: issues,
            parentId: parentId
        }
    });
const $141fb605cbba55d1$export$f12fa57c5a24cc9f = 'SET_PARENT_OPTIMISTIC';
const $141fb605cbba55d1$export$c2dcedde7d23b594 = (issues, parentIssue, requestPromise)=>({
        type: $141fb605cbba55d1$export$f12fa57c5a24cc9f,
        payload: {
            issues: issues,
            parentIssue: parentIssue,
            requestPromise: requestPromise
        }
    });
const $141fb605cbba55d1$export$28936e606d963d = 'UNSET_PARENT_REQUEST';
const $141fb605cbba55d1$export$361639149c1ff558 = (issues)=>({
        type: $141fb605cbba55d1$export$28936e606d963d,
        payload: {
            issues: issues
        }
    });
const $141fb605cbba55d1$export$4bb036ce8efdbcff = 'SET_PARENT_SUCCESS';
const $141fb605cbba55d1$export$6db24407ee10b2d3 = (parentIssue, oldParentIdsByIssueIds)=>({
        type: $141fb605cbba55d1$export$4bb036ce8efdbcff,
        payload: {
            parentIssue: parentIssue,
            oldParentIdsByIssueIds: oldParentIdsByIssueIds
        }
    });
const $141fb605cbba55d1$export$5c2ad12189bbd49d = 'SET_PARENT_FAILURE';
const $141fb605cbba55d1$export$c7950a8b245b9032 = ()=>({
        type: $141fb605cbba55d1$export$5c2ad12189bbd49d
    });
const $141fb605cbba55d1$export$fe453787af036e5f = 'UNSET_PARENT_SUCCESS';
const $141fb605cbba55d1$export$60feaf55fd14c76a = (oldParentIdsByIssueIds)=>({
        type: $141fb605cbba55d1$export$fe453787af036e5f,
        payload: {
            oldParentIdsByIssueIds: oldParentIdsByIssueIds
        }
    });
const $141fb605cbba55d1$export$ab972ebdce5decb = 'UNSET_PARENT_FAILURE';
const $141fb605cbba55d1$export$df5db15564db21af = ()=>({
        type: $141fb605cbba55d1$export$ab972ebdce5decb
    });

});

parcelRegister("cAorm", function(module, exports) {

$parcel$export(module.exports, "isAssignIssueParentModalOpen", () => $4dad3ebffadedb3e$export$964aa9f8b115dff5);
$parcel$export(module.exports, "assignIssueParentModalIssuesSelector", () => $4dad3ebffadedb3e$export$70113fc37a5b0e38);
$parcel$export(module.exports, "shouldHideUnassignOptionSelector", () => $4dad3ebffadedb3e$export$b3fe8816d7942498);

var $df4Sl = parcelRequire("df4Sl");

var $3l6tm = parcelRequire("3l6tm");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $9D3Vo = parcelRequire("9D3Vo");
const $4dad3ebffadedb3e$export$964aa9f8b115dff5 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.assignIssueParentModal.isOpen);
const $4dad3ebffadedb3e$export$70113fc37a5b0e38 = (0, $df4Sl.createSelector)((0, $5JqpU.contextSelector), (0, $jZDJX.parentIssueEntitySelector), (context, parentIssue)=>[
        {
            id: context.issueId,
            key: context.issueKey,
            parentId: parentIssue && parentIssue.id
        }
    ]);
const $4dad3ebffadedb3e$export$b3fe8816d7942498 = (0, $df4Sl.createSelector)((0, $9D3Vo.issueTypeSelector), (issueType)=>{
    // The issue type may be undefined while the Issue View Modal is still loading
    if (issueType === undefined) return false;
    return (0, $3l6tm.isSubtaskHierarchyLevel)(issueType.hierarchyLevel);
});

});

parcelRegister("arB8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a349858a86de631$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $89sIt = parcelRequire("89sIt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $8cU5f = parcelRequire("8cU5f");

var $hnzPP = parcelRequire("hnzPP");

var $2ijRB = parcelRequire("2ijRB");

var $gUUjF = parcelRequire("gUUjF");

var $lgxha = parcelRequire("lgxha");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8411R = parcelRequire("8411R");
var $kmr29 = parcelRequire("kmr29");

var $5lmKE = parcelRequire("5lmKE");

var $3l6tm = parcelRequire("3l6tm");


var $g0N0Z = parcelRequire("g0N0Z");

var $dpYvI = parcelRequire("dpYvI");

var $2KzVh = parcelRequire("2KzVh");

var $ctR9z = parcelRequire("ctR9z");

var $lO4Or = parcelRequire("lO4Or");

var $hzcvF = parcelRequire("hzcvF");

var $g8JvH = parcelRequire("g8JvH");
var $bFzGY = parcelRequire("bFzGY");

var $iVF7F = parcelRequire("iVF7F");

var $3drMT = parcelRequire("3drMT");

var $gy9so = parcelRequire("gy9so");

var $9jeRf = parcelRequire("9jeRf");

var $8iS2J = parcelRequire("8iS2J");
const $9a349858a86de631$export$c0117b1abc6c64e3 = (0, $g8JvH.AnalyticsEventToProps)('dropdownItem', {
    onClick: 'clicked'
})((0, $hD6GJ.default));
const $9a349858a86de631$export$3577dda93610669f = ({ isDisabled: isDisabled = false, isOrphan: isOrphan = false, issueTypes: issueTypes = [], issues: issues = [], issueParents: issueParents = [], isOpen: isOpenInProps = false, issueKey: issueKey = '', currentIssueKey: currentIssueKey = '', issueTypeName: issueTypeName = '', issueTypeIconUrl: issueTypeIconUrl = '', issueHierarchyLevel: issueHierarchyLevel = 0, clickRef: clickRef = null, projectId: projectId = null, isSimplifiedProject: isSimplifiedProject, fetchIssueParents: fetchIssueParents = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), setIssueParent: setIssueParent = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), setIssueParentOptimistic: setIssueParentOptimistic = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), text: text = '', onOpenChange: onOpenChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSelect: onSelect = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onViewAllParentsClick: onViewAllParentsClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onToggle: onToggle, onClick: onClick, openIssueCreateModal: openIssueCreateModal, triggerRef: triggerRef = {
    current: null
}, onAddOrRemoveParent: onAddOrRemoveParent = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const hasSetParentEntitlementForAboveLevelOne = (0, $5lmKE.useHasSetParentEntitlementForAboveLevelOne)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $iVF7F.useModalDialogActions)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(isOpenInProps);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(!issueParents.length);
    const previousIsOpen = (0, $hzcvF.usePrevious)(isOpenInProps);
    const previousIssueParents = (0, $hzcvF.usePrevious)(issueParents);
    const [fieldConfig] = (0, $8411R.useFieldConfig)(currentIssueKey, (0, $lO4Or.PARENT_TYPE));
    const [valueInSweetState] = (0, $kmr29.useFieldValue)({
        issueKey: issues[0].key,
        fieldKey: (0, $lO4Or.PARENT_TYPE)
    });
    const issueKeyInSweetState = valueInSweetState?.key || null;
    const isMounted = (0, $eUqFw.useRef)(false);
    const hasFetched = previousIssueParents !== undefined && issueParents !== previousIssueParents;
    const issueParentsWithRecentlySelected = (0, $8iS2J.useIssueParentsWithRecentlySelected)({
        issueParents: issueParents,
        hasFetched: hasFetched
    });
    (0, $8iS2J.useSyncLoadingState)({
        isLoading: isLoading,
        setIsLoading: setIsLoading,
        issueParentsWithRecentlySelected: issueParentsWithRecentlySelected
    });
    (0, $3drMT.isRemoveBaseLevelConditionForParentSuggestionsEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8iS2J.useSyncIssueParentsToParentFieldSuggestionCache)({
        isSimplifiedProject: isSimplifiedProject,
        hasFetched: hasFetched,
        issueParents: issueParents,
        isOpen: isOpen
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8iS2J.useSyncIssueParentsToParentFieldSuggestionCacheOld)({
        isSimplifiedProject: isSimplifiedProject,
        issueHierarchyLevelIsBase: issueHierarchyLevel === (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_BASE),
        hasFetched: hasFetched,
        issueParents: issueParents,
        isOpen: isOpen
    });
    const addToRecentlySelectedParents = (0, $8iS2J.useAddToRecentlySelectedParents)({
        issueParents: issueParents
    });
    (0, $eUqFw.useEffect)(()=>{
        if (((0, $3drMT.isRemoveBaseLevelConditionForParentSuggestionsEnabled)() ? true : issueHierarchyLevel === 0) && isMounted.current) {
            if (!valueInSweetState) setIssueParentOptimistic(issues, null);
            else if (issueKey !== valueInSweetState.key) setIssueParentOptimistic(issues, {
                id: valueInSweetState.id,
                summary: valueInSweetState.fields.summary,
                key: valueInSweetState.key,
                issueType: {
                    id: valueInSweetState.fields.issuetype.id,
                    name: valueInSweetState.fields.issuetype.name,
                    iconUrl: valueInSweetState.fields.issuetype.iconUrl
                },
                color: valueInSweetState.color
            });
        }
        isMounted.current = true; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        issueKeyInSweetState
    ]);
    const toggleMenu = (0, $eUqFw.useCallback)((isOpenInArgs)=>{
        setIsOpen(isOpenInArgs);
        if (!isOpenInArgs) return;
        if (!hasSetParentEntitlementForAboveLevelOne && issueHierarchyLevel != null && issueHierarchyLevel >= 1) {
            setIsLoading(false);
            return;
        }
        (0, $g0N0Z.epicDropdownOpenInteraction).start();
        fetchIssueParents();
    }, [
        fetchIssueParents,
        issueHierarchyLevel,
        hasSetParentEntitlementForAboveLevelOne
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (previousIsOpen !== undefined) {
            if (isOpenInProps !== previousIsOpen && isOpenInProps !== isOpen) toggleMenu(isOpenInProps);
        }
        if (previousIssueParents !== undefined) {
            if (issueParents !== previousIssueParents) // suppress isLoading state when issueParents are fetched
            isLoading && setIsLoading(false);
        }
    }, [
        isLoading,
        isOpen,
        issueParents,
        isOpenInProps,
        previousIsOpen,
        previousIssueParents,
        toggleMenu
    ]);
    const handleOnItemClick = (0, $eUqFw.useCallback)((userAction, { parentId: newParentId, keepMenuOpen: keepMenuOpen = false } = {})=>(event, analyticsEvent)=>{
            switch(userAction){
                case 'add parent':
                case 'change parent':
                    addToRecentlySelectedParents && newParentId && addToRecentlySelectedParents(newParentId);
                    setIssueParent(issues, newParentId);
                    userAction === 'add parent' && onAddOrRemoveParent();
                    break;
                case 'remove parent':
                    setIssueParent(issues);
                    onAddOrRemoveParent();
                    break;
                case 'open modal':
                    onViewAllParentsClick();
                    setReturnFocusTo(triggerRef);
                    onAddOrRemoveParent();
                    break;
                case 'create parent':
                    {
                        const issueTypeId = String((issueTypes.find(({ name: name })=>name === issueTypeName) || {}).id);
                        if (projectId === null || !issueTypeId) (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-parent-switcher.create.issue.failure', 'Failed to create the first epic via global issue create', {
                            projectId: projectId,
                            issueTypeId: issueTypeId
                        });
                        (0, $8iS2J.globalIssueCreateTrigger)(projectId, issueTypeId, openIssueCreateModal);
                        break;
                    }
                default:
                    break;
            }
            onClick(analyticsEvent.update({
                userAction: userAction
            }));
            onSelect && onSelect();
            !keepMenuOpen && toggleMenu(false);
        }, [
        addToRecentlySelectedParents,
        issueTypeName,
        issueTypes,
        issues,
        onAddOrRemoveParent,
        onClick,
        onSelect,
        onViewAllParentsClick,
        openIssueCreateModal,
        projectId,
        setIssueParent,
        setReturnFocusTo,
        toggleMenu,
        triggerRef
    ]);
    const getMessageContent = (0, $eUqFw.useCallback)((epicMessage, defaultMessage, multipleTargets = true)=>{
        const target = issueTypeName !== (0, $b0dbf452addbddfb$export$cb17e3c17bc50301) ? '' : `${(0, $b0dbf452addbddfb$export$cb17e3c17bc50301).toLowerCase()}${multipleTargets ? 's' : ''}`;
        return issueTypeName && issueHierarchyLevel === 0 ? formatMessage(epicMessage, {
            target: target
        }) : formatMessage(defaultMessage);
    }, [
        formatMessage,
        issueHierarchyLevel,
        issueTypeName
    ]);
    const tooltipContent = (0, $eUqFw.useMemo)(()=>{
        if (fieldConfig?.value?.isEditable === false) // no need to check for ifOrphan as the Add button is not shown when not editable
        return formatMessage((0, $gy9so.default).uneditableParent, {
            issueTypeName: issueTypeName
        });
         /**
       * - For orphan issues in TMP projects, we display "Add <issueTypeName>"
       * - For orphan issues in CMP projects, we display "Add parent"
       *
       * See https://hello.jira.atlassian.cloud/browse/JPO-25790 for future reference
       *
       * @returns MessageDescriptor
       */ 
        if (isSimplifiedProject && issueTypeName && issueHierarchyLevel === 0) {
            const target = issueTypeName !== (0, $b0dbf452addbddfb$export$cb17e3c17bc50301) ? issueTypeName : (0, $b0dbf452addbddfb$export$cb17e3c17bc50301).toLowerCase();
            return formatMessage(isOrphan ? (0, $gy9so.default).triggerTooltipAddEpic : (0, $gy9so.default).triggerTooltipChangeEpic, {
                issueTypeName: issueTypeName,
                target: target
            });
        }
        return formatMessage(isOrphan ? (0, $gy9so.default).triggerTooltipAddParent : (0, $gy9so.default).triggerTooltipChangeParent, {
            issueTypeName: issueTypeName ? `${issueTypeName} - ` : ''
        });
    }, [
        fieldConfig,
        formatMessage,
        isOrphan,
        isSimplifiedProject,
        issueHierarchyLevel,
        issueTypeName
    ]);
    const renderIssueParentItem = (0, $eUqFw.useCallback)((issueParent)=>{
        const { id: id, key: key, summary: summary, issueType: { name: name, iconUrl: iconUrl } } = issueParent;
        const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
            alt: name || '',
            url: iconUrl
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a349858a86de631$export$c0117b1abc6c64e3, {
            key: key,
            elemBefore: icon,
            testId: "issue-view-foundation.issue-parent-switcher.dropdown-item-issue-parent",
            onClick: handleOnItemClick(`${isOrphan ? 'add' : 'change'} parent`, {
                parentId: id
            })
        }, key, " ", summary);
    }, [
        handleOnItemClick,
        isOrphan
    ]);
    const renderDropdownItemGroup = (0, $eUqFw.useCallback)((recentIssueParents)=>isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a349858a86de631$var$PreloaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            testId: "issue-view-foundation.issue-parent-switcher.spinner",
            size: "large"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
            title: getMessageContent((0, $gy9so.default).dropdownTitleEpic, (0, $gy9so.default).dropdownTitle)
        }, recentIssueParents.map((item)=>renderIssueParentItem(item))), [
        getMessageContent,
        isLoading,
        renderIssueParentItem
    ]);
    const dropdownMenu = (0, $eUqFw.useMemo)(()=>{
        const target = issueTypeName && issueTypeName !== (0, $b0dbf452addbddfb$export$cb17e3c17bc50301) ? issueTypeName : (0, $b0dbf452addbddfb$export$cb17e3c17bc50301).toLowerCase();
        if (!hasSetParentEntitlementForAboveLevelOne && issueHierarchyLevel !== null && issueHierarchyLevel >= 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a349858a86de631$var$NoEntitlementContainer, null, formatMessage((0, $gy9so.default).noEntitlementSpork, {
            target: target
        })), !isOrphan && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a349858a86de631$export$c0117b1abc6c64e3, {
            onClick: handleOnItemClick('remove parent')
        }, formatMessage((0, $gy9so.default).unlinkParent))));
        const recentIssueParents = issueParentsWithRecentlySelected.filter((issueParent)=>issueParent.key !== issueKey).slice(0, 5);
        const showEmptyContainer = issueHierarchyLevel === 0 && !isLoading && !issueParentsWithRecentlySelected.length;
        return showEmptyContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a349858a86de631$var$EmptyContainer, null, formatMessage((0, $gy9so.default).dropdownEmpty, {
            target: target
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            spacing: "compact",
            onClick: handleOnItemClick('create parent', {
                keepMenuOpen: true
            }),
            "data-testId": "issue.views.issue-base.foundation.issue-parent-switcher.empty-container-button",
            interactionName: "auto-generated.jira-issue-view-foundation.issue-parent-switcher.button"
        }, target), ".") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (isLoading || recentIssueParents.length > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jeRf.SeparatorWrapper), null, renderDropdownItemGroup(recentIssueParents)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, !isOrphan && issueHierarchyLevel === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a349858a86de631$export$c0117b1abc6c64e3, {
            onClick: handleOnItemClick('remove parent')
        }, formatMessage((0, $gy9so.default).unlinkParent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a349858a86de631$export$c0117b1abc6c64e3, {
            onClick: handleOnItemClick('open modal'),
            testId: "issue-view-foundation.issue-parent-switcher.view-all"
        }, getMessageContent((0, $gy9so.default).viewEpics, (0, $gy9so.default).viewParents))), !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
            op: ()=>{
                (0, $g0N0Z.epicDropdownOpenInteraction).stop();
            }
        }));
    }, [
        formatMessage,
        getMessageContent,
        handleOnItemClick,
        isLoading,
        isOrphan,
        issueHierarchyLevel,
        issueKey,
        issueParentsWithRecentlySelected,
        issueTypeName,
        renderDropdownItemGroup,
        hasSetParentEntitlementForAboveLevelOne
    ]);
    const handleOnOpenChange = (0, $eUqFw.useCallback)(({ isOpen: isOpenInArgs, event: event })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        }); // @ts-expect-error - TS2339 - Property 'button' does not exist on type 'HTMLElement'.
        const insideBreadcrumb = event && clickRef?.current?.button.contains(event.target);
        if (issues[0] !== undefined) analyticsEvent.update({
            epicSelectedId: issues[0].parentId
        });
        onToggle(analyticsEvent);
        toggleMenu(isOpenInArgs);
        onOpenChange && !insideBreadcrumb && onOpenChange(isOpenInArgs);
    }, [
        clickRef,
        issues,
        onOpenChange,
        onToggle,
        toggleMenu,
        createAnalyticsEvent
    ]);
    const triggerButton = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'triggerRef' implicitly has an 'any' type.
    ({ triggerRef: ref, ...triggerProps })=>{
        const lTriggerButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpYvI.BreadCrumbsButton), {
            ...triggerProps,
            testId: "issue.views.issue-base.foundation.issue-parent-switcher.button" // eslint-disable-next-line react-hooks/rules-of-hooks
            ,
            ref: (0, $2KzVh.default)(ref, triggerRef),
            "aria-label": tooltipContent,
            "aria-expanded": isOpen,
            isDisabled: isDisabled,
            spacing: "compact",
            appearance: "subtle",
            iconBefore: !isOrphan && issueTypeIconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
                alt: issueTypeName || '',
                url: issueTypeIconUrl
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($89sIt))), {
                size: "small",
                label: ""
            })
        }, text);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $9a349858a86de631$var$triggerButtonContainerStyles
        }, isOrphan ? lTriggerButton : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            position: "top",
            content: tooltipContent,
            delay: 0,
            testId: "issue.views.issue-base.foundation.issue-parent-switcher.tooltip"
        }, lTriggerButton));
    }, [
        isDisabled,
        isOpen,
        isOrphan,
        issueTypeIconUrl,
        issueTypeName,
        text,
        tooltipContent,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.foundation.issue-parent-switcher.dropdown",
        isOpen: isOpen,
        trigger: triggerButton,
        onOpenChange: handleOnOpenChange
    }, dropdownMenu);
};
$9a349858a86de631$export$3577dda93610669f.displayName = 'IssueParentSwitcher';
const $9a349858a86de631$var$IssueParentSwitcherWithIntl = $9a349858a86de631$export$3577dda93610669f;
const $9a349858a86de631$var$IssueParentSwitcherWithGICProvider = (0, $ctR9z.withNewGICProvider)($9a349858a86de631$var$IssueParentSwitcherWithIntl);
var $9a349858a86de631$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $2ijRB.default)((0, $3drMT.isModernGlobalIssueCreateTriggerEnabled), $9a349858a86de631$var$IssueParentSwitcherWithGICProvider, $9a349858a86de631$var$IssueParentSwitcherWithIntl);
const $9a349858a86de631$var$PreloaderContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1ul993m8 _1tkezddy _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9a349858a86de631$var$EmptyContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbuuw1 _1yt4utpp _1gflidpf _1oh2idpf _yhjmidpf _99ztidpf _1gqnidpf _1m2uidpf _11lvidpf _9n9oidpf _1hbsidpf _1ipkidpf _1u71idpf _1kdcidpf _y2qtidpf _3glyidpf _fl8bidpf _1w2uidpf _amb618uv _e4km18uv",
            __cmplp.className
        ])
    });
});
const $9a349858a86de631$var$triggerButtonContainerStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9a349858a86de631$var$NoEntitlementContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1178 _1yt4utpp _n7zl1l7n _syaz1wmz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("89sIt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ef570750d61ee3c$var$_react = $5ef570750d61ee3c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $5ef570750d61ee3c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5ef570750d61ee3c$var$EditFilledIcon = (props)=>/*#__PURE__*/ $5ef570750d61ee3c$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4.02 19.23a1 1 0 001.18 1.18l3.81-.78-4.21-4.21-.78 3.81zM19.844 6.707l-2.12-2.122A1.997 1.997 0 0016.308 4c-.512 0-1.024.195-1.415.585l-9.757 9.758 4.95 4.95 9.757-9.758a2 2 0 000-2.828z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$5ef570750d61ee3c$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $5ef570750d61ee3c$var$_default = $5ef570750d61ee3c$var$EditFilledIcon;
module.exports.default = $5ef570750d61ee3c$var$_default;

});

parcelRegister("hnzPP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca9fc3da0c774fa7$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/react/handler-naming */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");
const $ca9fc3da0c774fa7$export$c6d2b2df39d78e5b = (0, $c9TLT.gridSize) * 2;
class $ca9fc3da0c774fa7$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            url: undefined,
            title: undefined,
            alt: undefined,
            width: $ca9fc3da0c774fa7$export$c6d2b2df39d78e5b,
            height: $ca9fc3da0c774fa7$export$c6d2b2df39d78e5b,
            fallback: undefined
        };
    }
    render() {
        const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
        const width = this.convertSize(this.props.width);
        const height = this.convertSize(this.props.height);
        if (this.state.isBroken && fallback) return fallback();
        return url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ca9fc3da0c774fa7$var$Image, {
            src: url,
            width: width,
            height: height,
            title: title ?? undefined,
            alt: alt ?? '',
            onError: this.onError,
            draggable: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ca9fc3da0c774fa7$var$ImagePlaceholder, {
            width: width,
            height: height,
            "data-testid": "common-components-async-icon.placeholder"
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isBroken: false
        };
        this.onError = ()=>{
            this.setState({
                isBroken: true
            });
        };
        this.convertSize = (size)=>size ? `${size}px` : '0';
    }
}
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca9fc3da0c774fa7$var$ImagePlaceholder = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "owe24v-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $PdmhA).N30,
        borderRadius: '3px',
        display: 'flex',
        flex: 'none'
    }));
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca9fc3da0c774fa7$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2ijRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $63c0d8b469289537$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var /**
 * @deprecated this does not support useRef and is being moved into a new package.
 * Use @atlassian/jira-feature-flagging-utils and componentWithCondition instead.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$63c0d8b469289537$export$2e2bcd8739ae039 = (conditionGetter, ComponentTrue, ComponentFalse)=>{
    const ComponentWithCondition = (props)=>// @ts-expect-error - TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'. | TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'.
        conditionGetter() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentTrue, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentFalse, props);
    if (conditionGetter.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
    // @ts-expect-error - TS2322 - Type '{ (props: P): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<P, any>'.
    return ComponentWithCondition;
};

});

parcelRegister("5lmKE", function(module, exports) {

$parcel$export(module.exports, "useHasSetParentEntitlementForAboveLevelOne", () => $8a9986621b2e673b$export$411df52843644871);

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");
const $8a9986621b2e673b$export$411df52843644871 = ()=>{
    const { software: software } = (0, $ab6rA.useAppEditions)();
    return software === (0, $6WXNs.PREMIUM_EDITION);
};

});

parcelRegister("2KzVh", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $0be6a57b715845c4$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $0be6a57b715845c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0be6a57b715845c4$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $0be6a57b715845c4$export$2e2bcd8739ae039(...refs) {
    return (0, $eUqFw.useMemo)(()=>$0be6a57b715845c4$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});

parcelRegister("ctR9z", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $bd445758cecbab8c$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "withNewGICProvider", () => $bd445758cecbab8c$export$558a195c5bfe3787);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $hompL = parcelRequire("hompL");

var $1ybV0 = parcelRequire("1ybV0");

var $dfh7z = parcelRequire("dfh7z");

var $dEMIg = parcelRequire("dEMIg");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3HCkE = parcelRequire("3HCkE");

var $ellXt = parcelRequire("ellXt");


var $dgsxZ = parcelRequire("dgsxZ");
const $bd445758cecbab8c$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $dEMIg.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $33ffe55cb7bcdadc$export$8d987f6e80b74000),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // Analytics property for board with custom filter and icc enabled
    isCustomBoardWithIcc: false
};
const $bd445758cecbab8c$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $dgsxZ.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $dgsxZ.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $bd445758cecbab8c$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $dgsxZ.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $dfh7z.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            if (!(0, $1ybV0.ff)('linked-alerts-in-gic_onvr6')) return;
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $bd445758cecbab8c$var$store = (0, $a61MH.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $bd445758cecbab8c$export$d4c72bab9d6cc13a,
    actions: $bd445758cecbab8c$export$e324594224ef24da
});
const $bd445758cecbab8c$var$useTriggerIssueCreateModalState = (0, $ggKAj.createStateHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$var$useTriggerIssueCreateModalActions = (0, $ggKAj.createActionsHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$export$71e0eb7b8a91a156 = ()=>{
    const createState = $bd445758cecbab8c$var$useTriggerIssueCreateModalState();
    const createActions = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $bd445758cecbab8c$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
};
const $bd445758cecbab8c$export$4c674fe824b8f278 = (0, $dYfll.createSubscriber)($bd445758cecbab8c$var$store);
function $bd445758cecbab8c$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $bd445758cecbab8c$export$71e0eb7b8a91a156();
        const { data: data } = (0, $3HCkE.useResource)((0, $ellXt.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("dfh7z", function(module, exports) {

$parcel$export(module.exports, "CreateIssueUFOExperience", () => $5fd686e53a19cbe0$export$cd75c112ac11a83b);
$parcel$export(module.exports, "StatusFieldLoad", () => $5fd686e53a19cbe0$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $5fd686e53a19cbe0$export$70208657c8d471a7);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $5fd686e53a19cbe0$export$cd75c112ac11a83b = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $5fd686e53a19cbe0$export$e890e797a25e655c = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $5fd686e53a19cbe0$export$70208657c8d471a7 = new (0, $kDfSL.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'modern-global-issue-create.modal.issue-submit'
});

});

parcelRegister("dEMIg", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $dd9f36fe091541c8$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $dd9f36fe091541c8$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $dd9f36fe091541c8$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $dd9f36fe091541c8$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $dd9f36fe091541c8$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $dd9f36fe091541c8$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $dd9f36fe091541c8$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $dd9f36fe091541c8$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $dd9f36fe091541c8$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $dd9f36fe091541c8$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $dd9f36fe091541c8$export$8170252f0ea43511);

const $dd9f36fe091541c8$export$17bcab948893a9ba = 'worklog';
const $dd9f36fe091541c8$export$b1c05b34d317c074 = 'REQUIRED';
const $dd9f36fe091541c8$export$f10b32dfda12e96e = 'unknown';
const $dd9f36fe091541c8$export$e5e4b8c32e68dd0b = 'networkError';
const $dd9f36fe091541c8$export$2d06efb8146cd043 = 'graphQLError';
const $dd9f36fe091541c8$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $dd9f36fe091541c8$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $dd9f36fe091541c8$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $dd9f36fe091541c8$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $dd9f36fe091541c8$export$aac4661200ba4104 = 'worklog_startDate';
const $dd9f36fe091541c8$export$a23c32d5cf54cba0 = 'worklog_description';
const $dd9f36fe091541c8$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $dd9f36fe091541c8$export$63fd567c1d0aca19 = [
    ...$dd9f36fe091541c8$export$74ab3898ae683660,
    $dd9f36fe091541c8$export$a1a7caa1e4a73c9f,
    $dd9f36fe091541c8$export$cf70f9220e6a2f50,
    $dd9f36fe091541c8$export$aac4661200ba4104,
    $dd9f36fe091541c8$export$a23c32d5cf54cba0
];
const $dd9f36fe091541c8$export$983715bb9b0f9b2c = {
    [$dd9f36fe091541c8$export$17bcab948893a9ba]: $dd9f36fe091541c8$export$63fd567c1d0aca19
};
const $dd9f36fe091541c8$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $dd9f36fe091541c8$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $dd9f36fe091541c8$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $dd9f36fe091541c8$export$8170252f0ea43511 = 'QuickCreateIssue';

});
// error types
const $8b8bfa076f313cc4$export$6c8cb487d6ffc522 = 'QueryError';
const $8b8bfa076f313cc4$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $8b8bfa076f313cc4$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $8b8bfa076f313cc4$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $8b8bfa076f313cc4$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $8b8bfa076f313cc4$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $8b8bfa076f313cc4$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $8b8bfa076f313cc4$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $8b8bfa076f313cc4$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $8b8bfa076f313cc4$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $8b8bfa076f313cc4$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $8b8bfa076f313cc4$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


parcelRegister("ellXt", function(module, exports) {

$parcel$export(module.exports, "gicOptInStatusResources", () => $d1ab65e118ce0b83$export$14c89b6b6a261524);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");

const $d1ab65e118ce0b83$export$14c89b6b6a261524 = (0, $3HCkE.createResource)({
    type: (0, $937f75d7d64d5d05$export$fe522736b61f6709),
    getKey: ()=>'gic_optin_status',
    getData: async ()=>{
        let gicOptInStatus = null;
        try {
            gicOptInStatus = await (0, $lRmyA.performGetRequest)('/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e.statusCode !== 404) (0, $gUUjF.default).safeErrorWithoutCustomerData('spa.router.resources.navigation.gicVisibility', 'getGICVisibility', e);
        }
        return {
            gicOptInStatus: gicOptInStatus ?? {
                isEnabled: false
            }
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $937f75d7d64d5d05$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';


const $33ffe55cb7bcdadc$export$a05673a22505d5ee = 'forge-open-issue-create';
const $33ffe55cb7bcdadc$export$c78d329777576aa0 = 'global-create-button';
const $33ffe55cb7bcdadc$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $33ffe55cb7bcdadc$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $33ffe55cb7bcdadc$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $33ffe55cb7bcdadc$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $33ffe55cb7bcdadc$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $33ffe55cb7bcdadc$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $33ffe55cb7bcdadc$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $33ffe55cb7bcdadc$export$9bc326812a93707 = 'jsw-security-create-issue';
const $33ffe55cb7bcdadc$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $33ffe55cb7bcdadc$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $33ffe55cb7bcdadc$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $33ffe55cb7bcdadc$export$235b856f54db8916 = 'jwm-board-create-issue';
const $33ffe55cb7bcdadc$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $33ffe55cb7bcdadc$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $33ffe55cb7bcdadc$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $33ffe55cb7bcdadc$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $33ffe55cb7bcdadc$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $33ffe55cb7bcdadc$export$aa348159181703a0 = 'software-create-issue-dialog';
const $33ffe55cb7bcdadc$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $33ffe55cb7bcdadc$export$718822a309bffada = 'create-linked-issue-command-palette';
const $33ffe55cb7bcdadc$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $33ffe55cb7bcdadc$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $33ffe55cb7bcdadc$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $33ffe55cb7bcdadc$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $33ffe55cb7bcdadc$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $33ffe55cb7bcdadc$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $33ffe55cb7bcdadc$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $33ffe55cb7bcdadc$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $33ffe55cb7bcdadc$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $33ffe55cb7bcdadc$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $33ffe55cb7bcdadc$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $33ffe55cb7bcdadc$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $33ffe55cb7bcdadc$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $33ffe55cb7bcdadc$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $33ffe55cb7bcdadc$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $33ffe55cb7bcdadc$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $33ffe55cb7bcdadc$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $33ffe55cb7bcdadc$export$145eb8935a34e85e = 'jwm-inline-create';
const $33ffe55cb7bcdadc$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';

parcelRegister("dgsxZ", function(module, exports) {

$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $b8d8e5356c7976a6$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $b8d8e5356c7976a6$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $b8d8e5356c7976a6$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $b8d8e5356c7976a6$export$720579602bb055a2);

var $dfh7z = parcelRequire("dfh7z");
var $fqKjL = parcelRequire("fqKjL");

var $hBkQt = parcelRequire("hBkQt");

var $duQ8C = parcelRequire("duQ8C");
const $b8d8e5356c7976a6$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $dfh7z.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $fqKjL.globalIssueCreateModalLoadSubsequent) : (0, $fqKjL.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $duQ8C.default)('global-issue.create-modal-subsequent');
    else (0, $duQ8C.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $hBkQt.startGlobalIssueCreateTTIWithAdjustments)();
};
const $b8d8e5356c7976a6$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $b8d8e5356c7976a6$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $b8d8e5356c7976a6$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("fqKjL", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $de2993c8c3fea479$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $de2993c8c3fea479$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $de2993c8c3fea479$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $de2993c8c3fea479$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $de2993c8c3fea479$export$c1592e4d8d98963e);

var $lEpcX = parcelRequire("lEpcX");
const $de2993c8c3fea479$export$5a01a7fa84b239c8 = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $de2993c8c3fea479$export$c50ad3c31b6fcfc6 = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $de2993c8c3fea479$export$4b2382574525bb0f = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $de2993c8c3fea479$export$7839bdaa2f6a2385 = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $de2993c8c3fea479$export$c1592e4d8d98963e = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("hBkQt", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $362542d6dd943f24$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $362542d6dd943f24$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $362542d6dd943f24$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $362542d6dd943f24$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $362542d6dd943f24$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $362542d6dd943f24$export$d86f4868694f2aa7);

var $lEpcX = parcelRequire("lEpcX");

var $gGRYc = parcelRequire("gGRYc");
const $362542d6dd943f24$export$9f3d6f17e1da7874 = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $362542d6dd943f24$export$457c9fb71ad5b3a9 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.start();
};
const $362542d6dd943f24$export$ef664dac649a716c = ()=>$362542d6dd943f24$export$9f3d6f17e1da7874.mark('gic-tti');
const $362542d6dd943f24$export$30ca4c461fab486c = (customData)=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $362542d6dd943f24$export$27f2445288b528c = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.cancel();
};
const $362542d6dd943f24$export$7a2709fc1e33401a = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $362542d6dd943f24$export$cf3893335c93e33b = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $362542d6dd943f24$export$d86f4868694f2aa7 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});
parcelRegister("gGRYc", function(module, exports) {

$parcel$export(module.exports, "TTIFFs", () => $05ae9ccc47102fc0$export$c396ba1504d97f3f);
const $05ae9ccc47102fc0$export$c396ba1504d97f3f = [];

});




parcelRegister("g8JvH", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $4e66802e461455f0$export$3e9ef96ba97ea9dc);

var $2jDha = parcelRequire("2jDha");
const $4e66802e461455f0$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $4e66802e461455f0$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $2jDha.default)($4e66802e461455f0$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("iVF7F", function(module, exports) {

$parcel$export(module.exports, "useModalDialogActions", () => $e75a117282f2e4ce$export$3cf2e4b6d3541465);
$parcel$export(module.exports, "useReturnFocusTo", () => $e75a117282f2e4ce$export$217308a4ece853b2);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $ljoN7 = parcelRequire("ljoN7");

var $6469v = parcelRequire("6469v");

var $2cPCG = parcelRequire("2cPCG");
const $e75a117282f2e4ce$var$Store = (0, $a61MH.createStore)({
    name: 'JiraSoftwareModalDialog',
    initialState: $ljoN7.initialState,
    actions: $6469v.actions
});
const $e75a117282f2e4ce$export$3cf2e4b6d3541465 = (0, $ggKAj.createActionsHook)($e75a117282f2e4ce$var$Store);
const $e75a117282f2e4ce$export$217308a4ece853b2 = (0, $ggKAj.createStateHook)($e75a117282f2e4ce$var$Store, {
    selector: (0, $2cPCG.getReturnFocusTo)
});

});
parcelRegister("ljoN7", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $4b47f7b3171df3ff$export$d4c72bab9d6cc13a);
const $4b47f7b3171df3ff$export$d4c72bab9d6cc13a = {
    returnFocusTo: null
};

});

parcelRegister("6469v", function(module, exports) {

$parcel$export(module.exports, "actions", () => $efa2fbefc0c70f4e$export$e324594224ef24da);
const $efa2fbefc0c70f4e$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
        setState({
            returnFocusTo: returnFocusTo
        });
    };
const $efa2fbefc0c70f4e$export$e324594224ef24da = {
    setReturnFocusTo: $efa2fbefc0c70f4e$export$b263d1e638b131c2
};

});

parcelRegister("2cPCG", function(module, exports) {

$parcel$export(module.exports, "getReturnFocusTo", () => $5b8cf428aaed92c7$export$d5f8692765ccd209);
const $5b8cf428aaed92c7$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;

});


parcelRegister("3drMT", function(module, exports) {

$parcel$export(module.exports, "isModernGlobalIssueCreateTriggerEnabled", () => $6069d29037669439$export$67305b99ef59566c);
$parcel$export(module.exports, "isRemoveBaseLevelConditionForParentSuggestionsEnabled", () => $6069d29037669439$export$5482c2be5ddc77ae);
$parcel$export(module.exports, "isIssueExportControlEnabled", () => $6069d29037669439$export$e92cc7310d059d3e);

var $1ybV0 = parcelRequire("1ybV0");
const $6069d29037669439$export$67305b99ef59566c = ()=>(0, $1ybV0.ff)('project.config.pce.modern.global-issue-create.trigger', false);
const $6069d29037669439$export$5482c2be5ddc77ae = ()=>(0, $1ybV0.ff)('remove-base-level-condition-for-parent-suggestion-cache_z9a5e', false);
const $6069d29037669439$export$e92cc7310d059d3e = ()=>(0, $1ybV0.ff)('dlp-gordian-enabled', false);

});

parcelRegister("gy9so", function(module, exports) {

$parcel$export(module.exports, "default", () => $680270d6c3d22f1e$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $680270d6c3d22f1e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    triggerTooltipAddEpic: {
        "id": "issue.details.issue-parent-switcher-trigger-tooltip-add-epic",
        "defaultMessage": "{issueTypeName} - Add {target}"
    },
    triggerTooltipChangeEpic: {
        "id": "issue.details.issue-parent-switcher-trigger-tooltip-change-epic",
        "defaultMessage": "{issueTypeName} - Change {target}"
    },
    uneditableParent: {
        "id": "issue.details.issue-parent-switcher-uneditable-parent",
        "defaultMessage": "{issueTypeName} - You can't edit the parent of this issue"
    },
    triggerTooltipAddParent: {
        "id": "issue.details.issue-parent-switcher-trigger-tooltip-add-parent",
        "defaultMessage": "{issueTypeName}Add parent"
    },
    triggerTooltipChangeParent: {
        "id": "issue.details.issue-parent-switcher-trigger-tooltip-change-parent",
        "defaultMessage": "{issueTypeName}Change parent"
    },
    dropdownEmpty: {
        "id": "issue.details.issue-parent-switcher-dropdown-empty",
        "defaultMessage": "No {target} has been created in this project. Create your first "
    },
    noEntitlementSpork: {
        "id": "issue.details.issue-parent-switcher-no-entitlement-spork",
        "defaultMessage": "You can only add or change the parent of issues at this hierarchy level in Jira Premium"
    },
    dropdownTitleEpic: {
        "id": "issue.details.issue-parent-switcher-dropdown-title-epic",
        "defaultMessage": "Recent {target}"
    },
    viewEpics: {
        "id": "issue.details.issue-parent-switcher-view-epics",
        "defaultMessage": "View all {target}"
    },
    dropdownTitle: {
        "id": "issue.details.issue-parent-switcher-dropdown-title",
        "defaultMessage": "Recent parents"
    },
    unlinkParent: {
        "id": "issue.details.issue-parent-switcher-unlink-parent",
        "defaultMessage": "Unlink parent"
    },
    viewParents: {
        "id": "issue.details.issue-parent-switcher-view-parents",
        "defaultMessage": "View all parents"
    }
});

});

parcelRegister("9jeRf", function(module, exports) {

$parcel$export(module.exports, "SeparatorWrapper", () => $c2d4923157887fcb$export$e23646282177e979);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $c2d4923157887fcb$export$e23646282177e979 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n7zl1l7n",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8iS2J", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTrigger", () => $92413969fedba622$export$2bf5aef7583a1c4e);
$parcel$export(module.exports, "useSyncIssueParentsToParentFieldSuggestionCache", () => $92413969fedba622$export$c915aff22588344e);
$parcel$export(module.exports, "useSyncIssueParentsToParentFieldSuggestionCacheOld", () => $92413969fedba622$export$204af72ce0d5dabf);
$parcel$export(module.exports, "useIssueParentsWithRecentlySelected", () => $92413969fedba622$export$af2e30abd1debc25);
$parcel$export(module.exports, "useAddToRecentlySelectedParents", () => $92413969fedba622$export$f4f007f836a8867);
$parcel$export(module.exports, "useSyncLoadingState", () => $92413969fedba622$export$8ab56cbc158731e6);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $ldc41 = parcelRequire("ldc41");
var $kyj9j = parcelRequire("kyj9j");

const $92413969fedba622$export$2bf5aef7583a1c4e = (projectId, issueTypeId, openIssueCreateModal)=>{
    // If window.WRM is not available yet, just ignore the action.
    if (openIssueCreateModal && window.IssueCreate && window.IssueCreate.Visibility) {
        const { isEnabled: isEnabled } = window.IssueCreate.Visibility;
        if (isEnabled) {
            const dataPayload = {};
            if (projectId !== null && projectId !== undefined) dataPayload.project = {
                projectId: projectId
            };
            if (issueTypeId !== null && issueTypeId !== undefined) dataPayload.issueType = {
                issueTypeId: issueTypeId
            };
            openIssueCreateModal({
                payload: dataPayload,
                triggerPointKey: (0, $33ffe55cb7bcdadc$export$aa348159181703a0)
            });
            return;
        }
    }
    if (window.WRM) // eslint-disable-next-line jira/wrm/no-wrm-require
    window.WRM.require(// eslint-disable-next-line jira/wrm/no-wr-prefix
    [
        'wr!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue'
    ], ()=>{
        const form = window.JIRA.Forms.createCreateIssueForm({
            pid: projectId,
            issueType: issueTypeId
        });
        const dialog = form.asDialog({
            id: 'software-create-issue-dialog'
        });
        dialog.show();
    });
};
const $92413969fedba622$export$c915aff22588344e = ({ isSimplifiedProject: isSimplifiedProject, hasFetched: hasFetched, issueParents: issueParents, isOpen: isOpen })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { setPrefetchedParents: setPrefetchedParents } = (0, $kyj9j.useParentFieldSuggestionsCache)({
        issueKey: issueKey
    });
    (0, $eUqFw.useEffect)(()=>{
        if (isOpen && hasFetched) setPrefetchedParents(issueParents);
    }, [
        hasFetched,
        isSimplifiedProject,
        issueParents,
        setPrefetchedParents,
        isOpen
    ]);
};
const $92413969fedba622$export$204af72ce0d5dabf = ({ isSimplifiedProject: isSimplifiedProject, issueHierarchyLevelIsBase: issueHierarchyLevelIsBase, hasFetched: hasFetched, issueParents: issueParents, isOpen: isOpen })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { setPrefetchedParents: setPrefetchedParents } = (0, $kyj9j.useParentFieldSuggestionsCache)({
        issueKey: issueKey
    });
    (0, $eUqFw.useEffect)(()=>{
        if (issueHierarchyLevelIsBase && isOpen && hasFetched) setPrefetchedParents(issueParents);
    }, [
        hasFetched,
        isSimplifiedProject,
        issueHierarchyLevelIsBase,
        issueParents,
        setPrefetchedParents,
        isOpen
    ]);
};
const $92413969fedba622$export$af2e30abd1debc25 = ({ issueParents: issueParents, hasFetched: hasFetched })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { prefetchedParents: prefetchedParents, recentlySelectedParents: recentlySelectedParents } = (0, $kyj9j.useParentFieldSuggestionsCache)({
        issueKey: issueKey
    });
    return (0, $eUqFw.useMemo)(()=>(0, $ldc41.joinSuggestionsWithPrioritisedRecentlySelected)({
            recentlySelected: recentlySelectedParents,
            prefetched: hasFetched ? issueParents : prefetchedParents || []
        }), [
        hasFetched,
        issueParents,
        prefetchedParents,
        recentlySelectedParents
    ]);
};
const $92413969fedba622$export$f4f007f836a8867 = ({ issueParents: issueParents })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { setRecentlySelectedParent: setRecentlySelectedParent } = (0, $kyj9j.useParentFieldSuggestionsCache)({
        issueKey: issueKey
    });
    return (0, $eUqFw.useCallback)((parentId)=>{
        const parent = issueParents.find((p)=>p.id === parentId);
        parent && setRecentlySelectedParent(parent);
    }, [
        issueParents,
        setRecentlySelectedParent
    ]);
};
const $92413969fedba622$export$8ab56cbc158731e6 = ({ isLoading: isLoading, setIsLoading: setIsLoading, issueParentsWithRecentlySelected: issueParentsWithRecentlySelected })=>{
    (0, $eUqFw.useEffect)(()=>{
        if (issueParentsWithRecentlySelected.length && isLoading) setIsLoading(false);
    }, [
        isLoading,
        issueParentsWithRecentlySelected.length,
        setIsLoading
    ]);
};

});
parcelRegister("ldc41", function(module, exports) {

$parcel$export(module.exports, "joinSuggestionsWithPrioritisedRecentlySelected", () => $96816f5efba4efa9$export$a2310d06b0de81c6);
const $96816f5efba4efa9$export$a2310d06b0de81c6 = ({ recentlySelected: recentlySelected, prefetched: prefetched })=>{
    if (!recentlySelected.length) return prefetched;
    const updatedRecentlySelected = recentlySelected.reduce((suggestions, suggestion)=>{
        const suggestionInPrefetched = prefetched.find((p)=>p.id === suggestion.id);
        if (suggestionInPrefetched) suggestions.push(suggestionInPrefetched);
        return suggestions;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, []);
    const recentlySelectedIds = updatedRecentlySelected.map((s)=>s.id);
    const filteredPrefetched = prefetched.filter((prefetchedSuggestion)=>!recentlySelectedIds.includes(prefetchedSuggestion.id));
    return [
        ...updatedRecentlySelected,
        ...filteredPrefetched
    ];
};

});

parcelRegister("kyj9j", function(module, exports) {

$parcel$export(module.exports, "useParentFieldSuggestionsCache", () => $2bccf0f7fa5f2a7b$export$670e2c28245a2490);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $guDlK = parcelRequire("guDlK");

var $afxkA = parcelRequire("afxkA");
const $2bccf0f7fa5f2a7b$var$MAX_RECENTLY_SELECTED_PARENTS = 5;
const $2bccf0f7fa5f2a7b$export$670e2c28245a2490 = ({ issueKey: issueKey })=>{
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const { setRecentlySelectedItem: setRecentlySelectedItem, setPrefetched: setPrefetched } = (0, $afxkA.useFieldsSuggestionsActions)();
    const prefetchedParents = (0, $afxkA.useFieldPrefetched)({
        type: (0, $lO4Or.PARENT_TYPE),
        projectKey: projectKey
    });
    const recentlySelectedParents = (0, $afxkA.useFieldRecentlySelected)({
        type: (0, $lO4Or.PARENT_TYPE),
        projectKey: projectKey
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const setPrefetchedParents = (0, $eUqFw.useCallback)((prefetched)=>setPrefetched({
            fieldKey: (0, $lO4Or.PARENT_TYPE),
            projectKey: projectKey,
            prefetched: prefetched
        }), [
        projectKey,
        setPrefetched
    ]);
    const setRecentlySelectedParent = (0, $eUqFw.useCallback)((selected)=>{
        // The validation is necessary because there are a few scenarios where the id is actually a number, but the existing typing from external sources (incorrectly) specifies it as a string.
        // An example includes, submitting a parent from the picker API, in the view all modals.
        const selectedWithValidation = typeof selected.id === 'string' ? selected : {
            ...selected,
            id: `${selected.id}`
        };
        const selectedInPrefetchedParents = (prefetchedParents || []).find((prefetchedParent)=>prefetchedParent.id === selectedWithValidation.id);
        if (!selectedInPrefetchedParents) {
            // We use this event for our monitoring how often it happens that an epic, which is out of the prefetched, is selected from modal.
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'parentIssue couldntBeSetAsRecentlySelected');
            return;
        }
        setRecentlySelectedItem({
            fieldKey: (0, $lO4Or.PARENT_TYPE),
            projectKey: projectKey,
            maxLength: $2bccf0f7fa5f2a7b$var$MAX_RECENTLY_SELECTED_PARENTS,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            selected: selectedWithValidation
        });
    }, [
        projectKey,
        setRecentlySelectedItem,
        createAnalyticsEvent,
        prefetchedParents
    ]);
    return {
        recentlySelectedParents: recentlySelectedParents || [],
        prefetchedParents: prefetchedParents,
        setPrefetchedParents: setPrefetchedParents,
        setRecentlySelectedParent: setRecentlySelectedParent
    };
};

});
parcelRegister("afxkA", function(module, exports) {

$parcel$export(module.exports, "useFieldsSuggestionsActions", () => $8c83af746038118c$export$b3e9a9a14cf144b7);
$parcel$export(module.exports, "useFieldPrefetched", () => $8c83af746038118c$export$171150c44527d45e);
$parcel$export(module.exports, "useFieldRecentlySelected", () => $8c83af746038118c$export$c63959073e68decc);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $lO4Or = parcelRequire("lO4Or");

var $iapsc = parcelRequire("iapsc");
const $8c83af746038118c$var$initialState = {
    [(0, $lO4Or.PARENT_TYPE)]: {}
};
const $8c83af746038118c$var$Store = (0, $a61MH.createStore)({
    initialState: $8c83af746038118c$var$initialState,
    actions: $iapsc.actions,
    name: 'jsw-issue-fields-suggestion-cache'
});
const $8c83af746038118c$export$b3e9a9a14cf144b7 = (0, $ggKAj.createActionsHook)($8c83af746038118c$var$Store);
const $8c83af746038118c$export$1350951b0e4df77a = (0, $ggKAj.createStateHook)($8c83af746038118c$var$Store);
const $8c83af746038118c$var$getFieldPrefetched = (state, { type: type, projectKey: projectKey })=>state[type][projectKey]?.prefetched;
const $8c83af746038118c$export$171150c44527d45e = (0, $ggKAj.createStateHook)($8c83af746038118c$var$Store, {
    selector: $8c83af746038118c$var$getFieldPrefetched
});
const $8c83af746038118c$export$9a130e7c76b485b9 = (state, { type: type, projectKey: projectKey })=>state[type][projectKey]?.recentlySelected;
const $8c83af746038118c$export$c63959073e68decc = (0, $ggKAj.createStateHook)($8c83af746038118c$var$Store, {
    selector: $8c83af746038118c$export$9a130e7c76b485b9
});

});
parcelRegister("iapsc", function(module, exports) {

$parcel$export(module.exports, "actions", () => $2d779cba30e9eeb3$export$e324594224ef24da);

var $gZ4YI = parcelRequire("gZ4YI");

var $atO7j = parcelRequire("atO7j");
const $2d779cba30e9eeb3$export$e324594224ef24da = {
    setPrefetched: $gZ4YI.setPrefetched,
    setRecentlySelectedItem: $atO7j.setRecentlySelectedItem
};

});
parcelRegister("gZ4YI", function(module, exports) {

$parcel$export(module.exports, "setPrefetched", () => $aa449d229ed8f602$export$f2008984ec5f4ee5);

var $8e64e = parcelRequire("8e64e");
const $aa449d229ed8f602$export$f2008984ec5f4ee5 = (props)=>(0, $8e64e.setFieldCache)({
        ...props
    });

});
parcelRegister("8e64e", function(module, exports) {

$parcel$export(module.exports, "setFieldCache", () => $fccd784d64663a48$export$87d8fe0577e5bc84);

var $hTLlD = parcelRequire("hTLlD");
const $fccd784d64663a48$export$87d8fe0577e5bc84 = ({ fieldKey: fieldKey, projectKey: projectKey, prefetched: prefetched, recentlySelected: recentlySelected })=>({ setState: setState, getState: getState })=>{
        const fieldVal = getState()[fieldKey];
        const projectVal = fieldVal[projectKey];
        const newFieldVal = {
            ...fieldVal,
            [projectKey]: {
                ...projectVal,
                ...prefetched ? {
                    prefetched: prefetched
                } : {},
                ...recentlySelected ? {
                    recentlySelected: recentlySelected
                } : {}
            }
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(fieldVal, newFieldVal)) return;
        setState({
            [fieldKey]: newFieldVal
        });
    };

});


parcelRegister("atO7j", function(module, exports) {

$parcel$export(module.exports, "setRecentlySelectedItem", () => $e695fcb7d8024833$export$1ac384b4eb79b77b);

var $8e64e = parcelRequire("8e64e");

var $jd0zu = parcelRequire("jd0zu");
const $e695fcb7d8024833$export$1ac384b4eb79b77b = ({ fieldKey: fieldKey, projectKey: projectKey, selected: selected, maxLength: maxLength })=>({ getState: getState, dispatch: dispatch })=>{
        const recentlySelected = getState()[fieldKey][projectKey]?.recentlySelected || [];
        const recentlySelectedWithoutNewSelected = (0, $jd0zu.getRecentlySelectedWithoutNewSelected)({
            selections: recentlySelected,
            newlySelected: selected
        });
        const newRecentlySelected = [
            selected,
            ...recentlySelectedWithoutNewSelected
        ];
        const newRecentlySelectedOfMaxLength = newRecentlySelected.length <= maxLength ? newRecentlySelected : newRecentlySelected.slice(0, maxLength);
        dispatch((0, $8e64e.setFieldCache)({
            fieldKey: fieldKey,
            projectKey: projectKey,
            recentlySelected: newRecentlySelectedOfMaxLength
        }));
    };

});
parcelRegister("jd0zu", function(module, exports) {

$parcel$export(module.exports, "getRecentlySelectedWithoutNewSelected", () => $da9962b6266b503c$export$18e242ce8f65cb2);
const $da9962b6266b503c$export$18e242ce8f65cb2 = ({ selections: selections, newlySelected: newlySelected })=>selections.filter((selection)=>selection.id !== newlySelected.id);

});








parcelRegister("aWUQ5", function(module, exports) {

$parcel$export(module.exports, "truncateBreadcrumbs", () => $8f9a026af8c0eda6$export$6df5e937f862bb9e);
const $8f9a026af8c0eda6$export$6df5e937f862bb9e = (text)=>{
    const charLimit = 20;
    if (text === null) return '';
    return text.length > charLimit ? `${text.slice(0, charLimit)}...` : text;
};

});

parcelRegister("5zHtE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4dd3400b58d87e3$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $d4dd3400b58d87e3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addParent: {
        "id": "issue.details.add-parent",
        "defaultMessage": "Add {target}"
    },
    addParentLabel: {
        "id": "issue.details.add-parent-label",
        "defaultMessage": "Add parent"
    },
    copy: {
        "id": "issue.details.copy-to-clipboard",
        "defaultMessage": "Copy link to issue"
    },
    rootProjectsLink: {
        "id": "issue.details.root-projects-link",
        "defaultMessage": "Projects"
    },
    breadcrumbNavLabel: {
        "id": "issue.details.breadcrumb-nav-label",
        "defaultMessage": "Issue breadcrumbs"
    }
});

});

parcelRegister("1o3dn", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsWrapper", () => $5f860407e29eaea8$export$85f84040e645a2c9);
$parcel$export(module.exports, "BREADCRUMBS_WRAPPER_SELECTOR_NAME", () => $5f860407e29eaea8$export$29ed65371bf28351);
$parcel$export(module.exports, "IssueContainer", () => $5f860407e29eaea8$export$3a21072ad7cca6f6);
$parcel$export(module.exports, "IconPaddingWrapper", () => $5f860407e29eaea8$export$492a7f4e3ada6712);
$parcel$export(module.exports, "ProjectIconWrapper", () => $5f860407e29eaea8$export$95df31f080228875);
$parcel$export(module.exports, "ProjectContainer", () => $5f860407e29eaea8$export$4ee32776d0814bc1);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $5f860407e29eaea8$export$85f84040e645a2c9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlidpf _1reoewfl _18m9ewfl _11c8qk37",
            __cmplp.className
        ])
    });
});
const $5f860407e29eaea8$export$29ed65371bf28351 = 'breadcrumbs-wrapper';
const $5f860407e29eaea8$var$BREADCRUMBS_WRAPPER_SELECTOR = `[data-component-selector="${$5f860407e29eaea8$export$29ed65371bf28351}"]`;
const $5f860407e29eaea8$export$534d10f1c5b9c7b3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_tzy4idpf _v5641n2p _t9ecs3yl _el88kb7n _10aj1xty _1h7hkb7n _1bvq1ygq",
            __cmplp.className
        ])
    });
});
const $5f860407e29eaea8$export$3a21072ad7cca6f6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { fixExtraDivider: fixExtraDivider, shouldTruncate: shouldTruncate, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _4cvr1h6o _1ywu1txw _aetr1n76 _tua5idpf _18d3otz2 _gkt51h6o _z0aiftgi _1h9u1oud _17qdb3bt",
            __cmplp.fixExtraDivider ? "_838zglyw" : "_838z1ule",
            __cmplp.shouldTruncate && "_1jxkuuw1",
            __cmplp.className
        ])
    });
});
const $5f860407e29eaea8$export$492a7f4e3ada6712 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f3u2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $5f860407e29eaea8$export$95df31f080228875 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $5f860407e29eaea8$export$4ee32776d0814bc1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { fixExtraDivider: fixExtraDivider, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _p12f1mjv _19bv1b66 _4cvr1h6o _1ywu1txw _aetr1n76 _tua5idpf _18d3otz2 _gkt51h6o _z0aiftgi _1h9u1oud",
            __cmplp.fixExtraDivider ? "_838zglyw" : "_838z1ule",
            __cmplp.className
        ])
    });
});

});


parcelRegister("3HUo3", function(module, exports) {

$parcel$export(module.exports, "default", () => $03d0fd4363cba499$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $bm5l8 = parcelRequire("bm5l8");

var $8cU5f = parcelRequire("8cU5f");

var $hnzPP = parcelRequire("hnzPP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fWeG1 = parcelRequire("fWeG1");

var $ll3Ms = parcelRequire("ll3Ms");

var $6vrw7 = parcelRequire("6vrw7");

var $g3rTM = parcelRequire("g3rTM");

var $1qEvI = parcelRequire("1qEvI");

var $5zHtE = parcelRequire("5zHtE");

var $1o3dn = parcelRequire("1o3dn");
const $03d0fd4363cba499$export$1711531201a0c4b7 = ({ isVisible: isVisible, fullIssueUrl: fullIssueUrl, onCopyClick: onCopyClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const label = formatMessage((0, $5zHtE.default).copy);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ll3Ms.PermalinkButton), {
        id: "BreadcrumbCurrentIssue",
        label: label,
        fullIssueUrl: fullIssueUrl,
        // @ts-expect-error the type definition expects (AnalyticsEvent) but instead receives (SyntheticEvent, AnalyticsEvent)
        onCopyClick: onCopyClick,
        isVisible: isVisible
    });
};
const $03d0fd4363cba499$export$4de7c20e9aab7169 = ({ isSimplifiedProject: isSimplifiedProject, issueKey: issueKey, relativeIssueUrl: relativeIssueUrl, onClick: onClick })=>{
    const [{ value: summaryValue }] = (0, $fWeG1.useSummaryField)({
        issueKey: issueKey
    });
    const breadCrumbsTooltip = summaryValue || '';
    return isSimplifiedProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: `${issueKey}: ${breadCrumbsTooltip}`,
        position: "top",
        delay: 0,
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.foundation.breadcrumbs.current-issue.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bm5l8.default), {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.foundation.breadcrumbs.current-issue.item",
        key: "issueKeyBreadcrumbItem",
        href: relativeIssueUrl,
        onClick: onClick,
        text: issueKey,
        target: "_blank"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bm5l8.default), {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.foundation.breadcrumbs.current-issue.item",
        key: "issueKeyBreadcrumbItem",
        href: relativeIssueUrl,
        onClick: onClick,
        text: issueKey,
        target: "_blank"
    }));
};
const $03d0fd4363cba499$export$7ef4ea2d204ff97b = ({ isSimplifiedProject: isSimplifiedProject = false, isIssueTypeFieldEditable: isIssueTypeFieldEditable = false, issueKey: issueKey = (0, $6vrw7.toIssueKey)(''), issueTypeName: issueTypeName = '', issueTypeIconUrl: issueTypeIconUrl = '', relativeIssueUrl: relativeIssueUrl = '', fullIssueUrl: fullIssueUrl = '', onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onCopyClick: onCopyClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>{
    const [isVisible, setIsVisible] = (0, $eUqFw.useState)(false);
    const show = ()=>setIsVisible(true);
    const hide = ()=>setIsVisible(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1o3dn.IssueContainer), {
        onMouseLeave: hide,
        onMouseEnter: show,
        onFocus: show,
        onBlur: hide,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "issue.views.issue-base.foundation.breadcrumbs.breadcrumb-current-issue-container",
        fixExtraDivider: true
    }, isIssueTypeFieldEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3rTM.default), {
        key: "issueTypeChanger",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
            url: issueTypeIconUrl,
            alt: issueTypeName
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1qEvI.default), {
        issueTypeName: issueTypeName,
        issueTypeIconUrl: issueTypeIconUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03d0fd4363cba499$export$4de7c20e9aab7169, {
        isSimplifiedProject: isSimplifiedProject,
        issueKey: issueKey,
        relativeIssueUrl: relativeIssueUrl,
        onClick: onClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03d0fd4363cba499$export$1711531201a0c4b7, {
        isVisible: isVisible,
        fullIssueUrl: fullIssueUrl,
        onCopyClick: onCopyClick
    }));
};
var $03d0fd4363cba499$export$2e2bcd8739ae039 = $03d0fd4363cba499$export$7ef4ea2d204ff97b;

});
parcelRegister("ll3Ms", function(module, exports) {

$parcel$export(module.exports, "PermalinkButton", () => $50963179c44c7696$export$5fefac30f3d7c99b);
/* async.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $50963179c44c7696$var$LazyPermalinkButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("aG2NS")).then((exportedModule)=>exportedModule.PermalinkButton), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view-common/src/component/permalink-button/button/view.tsx"
});
const $50963179c44c7696$export$5fefac30f3d7c99b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-view-lazy-permalink",
        packageName: "jiraIssueView"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-view-lazy-permalink",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50963179c44c7696$var$EmptyState, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50963179c44c7696$var$LazyPermalinkButton, props)));
$50963179c44c7696$export$5fefac30f3d7c99b.displayName = 'PermalinkButton'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $50963179c44c7696$var$EmptyState = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qv77o _1e0c1o8l _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aG2NS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('kCFrV')
        ]);
        const value = parcelRequire('jVTU6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("kCFrV")
    ]).then(()=>parcelRequire('jVTU6'));
}

});


parcelRegister("g3rTM", function(module, exports) {

$parcel$export(module.exports, "default", () => $badb482d424a53e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $lqalZ = parcelRequire("lqalZ");

var $ltjPP = parcelRequire("ltjPP");

var $jZDJX = parcelRequire("jZDJX");

var $8hjkr = parcelRequire("8hjkr");

var $zdfJ3 = parcelRequire("zdfJ3");
var $badb482d424a53e7$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state)=>({
        issueTypes: (0, $8hjkr.availableProjectIssueTypesSelector)(state),
        issueId: (0, $jZDJX.idSelector)(state),
        isOpen: (0, $8hjkr.shouldShowIssueTypeList)(state)
    }), {
    showIssueTypeList: $ltjPP.showIssueTypeList,
    loadIssueTypes: (0, $ltjPP.projectIssueTypeRequest),
    changeIssueType: (0, $ltjPP.simpleChangeIssueTypeRequest)
})((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "change-issue-type",
        packageName: "issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $zdfJ3.default), props)));

});
parcelRegister("ltjPP", function(module, exports) {

$parcel$export(module.exports, "PROJECT_ISSUE_TYPES_REQUEST", () => $53872e2eb87e12c7$export$af6d551c82cd92b);
$parcel$export(module.exports, "projectIssueTypeRequest", () => $53872e2eb87e12c7$export$db8174b6034fa4ac);
$parcel$export(module.exports, "PROJECT_ISSUE_TYPES_REQUEST_SUCCESS", () => $53872e2eb87e12c7$export$54a6946713068ff5);
$parcel$export(module.exports, "projectIssueTypeSuccess", () => $53872e2eb87e12c7$export$fcd0f3df12225789);
$parcel$export(module.exports, "projectIssueTypeFailure", () => $53872e2eb87e12c7$export$1600505a81889aa1);
$parcel$export(module.exports, "SIMPLE_CHANGE_ISSUE_TYPE_REQUEST", () => $53872e2eb87e12c7$export$7c079e8280a06012);
$parcel$export(module.exports, "simpleChangeIssueTypeRequest", () => $53872e2eb87e12c7$export$bd833aa0ca65cc);
$parcel$export(module.exports, "SIMPLE_CHANGE_ISSUE_TYPE_REQUEST_SUCCESS", () => $53872e2eb87e12c7$export$1c20cd6a0cd0a597);
$parcel$export(module.exports, "simpleChangeIssueTypeSuccess", () => $53872e2eb87e12c7$export$ee92817175c04960);
$parcel$export(module.exports, "SIMPLE_CHANGE_ISSUE_TYPE_REQUEST_FAILURE", () => $53872e2eb87e12c7$export$e48a2d460701809f);
$parcel$export(module.exports, "simpleChangeIssueTypeFailure", () => $53872e2eb87e12c7$export$dc1e2bd1441a5a98);
$parcel$export(module.exports, "SIMPLE_CHANGE_ISSUE_TYPE_NOT_ALLOWED", () => $53872e2eb87e12c7$export$baa4d08f085d4286);
$parcel$export(module.exports, "simpleChangeIssueTypeNotAllowed", () => $53872e2eb87e12c7$export$7d929f5bf219d055);
$parcel$export(module.exports, "SHOW_ISSUE_TYPE_LIST", () => $53872e2eb87e12c7$export$26f04a2e92ceb379);
$parcel$export(module.exports, "showIssueTypeList", () => $53872e2eb87e12c7$export$57694e1eb48f053d);

var $f9RL0 = parcelRequire("f9RL0");
const $53872e2eb87e12c7$export$af6d551c82cd92b = 'PROJECT_ISSUE_TYPES_REQUEST';
const $53872e2eb87e12c7$export$db8174b6034fa4ac = (projectKey)=>({
        type: $53872e2eb87e12c7$export$af6d551c82cd92b,
        payload: projectKey
    });
const $53872e2eb87e12c7$export$54a6946713068ff5 = 'PROJECT_ISSUE_TYPES_REQUEST_SUCCESS';
const $53872e2eb87e12c7$export$fcd0f3df12225789 = (projectTypes)=>({
        type: $53872e2eb87e12c7$export$54a6946713068ff5,
        payload: projectTypes
    });
const $53872e2eb87e12c7$export$5091e5a4f7df1918 = 'PROJECT_ISSUE_TYPES_REQUEST_FAILURE';
const $53872e2eb87e12c7$export$1600505a81889aa1 = (errorMsg)=>({
        type: $53872e2eb87e12c7$export$5091e5a4f7df1918,
        payload: errorMsg
    });
const $53872e2eb87e12c7$export$7c079e8280a06012 = 'SIMPLE_CHANGE_ISSUE_TYPE_REQUEST';
const $53872e2eb87e12c7$export$bd833aa0ca65cc = (issueKey, issueId, currentType, targetType, analyticsEvent)=>({
        type: $53872e2eb87e12c7$export$7c079e8280a06012,
        payload: {
            issueKey: issueKey,
            issueId: issueId,
            currentType: currentType,
            targetType: targetType,
            analyticsEvent: analyticsEvent
        }
    });
const $53872e2eb87e12c7$export$1c20cd6a0cd0a597 = 'SIMPLE_CHANGE_ISSUE_TYPE_REQUEST_SUCCESS';
const $53872e2eb87e12c7$export$ee92817175c04960 = (issueKey, targetTypeName)=>({
        type: $53872e2eb87e12c7$export$1c20cd6a0cd0a597,
        payload: {
            issueKey: issueKey,
            targetTypeName: targetTypeName,
            fieldId: (0, $f9RL0.ISSUE_TYPE)
        }
    });
const $53872e2eb87e12c7$export$e48a2d460701809f = 'SIMPLE_CHANGE_ISSUE_TYPE_REQUEST_FAILURE';
const $53872e2eb87e12c7$export$dc1e2bd1441a5a98 = (error)=>({
        type: $53872e2eb87e12c7$export$e48a2d460701809f,
        payload: error
    });
const $53872e2eb87e12c7$export$baa4d08f085d4286 = 'SIMPLE_CHANGE_ISSUE_TYPE_NOT_ALLOWED';
const $53872e2eb87e12c7$export$7d929f5bf219d055 = (issueId, currentType, targetType)=>({
        type: $53872e2eb87e12c7$export$baa4d08f085d4286,
        payload: {
            issueId: issueId,
            currentType: currentType,
            targetType: targetType
        }
    });
const $53872e2eb87e12c7$export$26f04a2e92ceb379 = 'SHOW_ISSUE_TYPE_LIST';
const $53872e2eb87e12c7$export$57694e1eb48f053d = (isOpen)=>({
        type: $53872e2eb87e12c7$export$26f04a2e92ceb379,
        payload: isOpen
    });

});

parcelRegister("8hjkr", function(module, exports) {

$parcel$export(module.exports, "availableProjectIssueTypesSelector", () => $27cb9fad44151c56$export$8bae65c4419442c1);
$parcel$export(module.exports, "shouldShowIssueTypeList", () => $27cb9fad44151c56$export$37eb3cdcb1c1f5f);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");

var $1b2Vj = parcelRequire("1b2Vj");
const $27cb9fad44151c56$export$8bae65c4419442c1 = (0, $df4Sl.createSelector)((0, $jZDJX.projectSelector), (0, $1b2Vj.sameLevelIssueTypesIdsSelector), (0, $jZDJX.isSimplifiedProjectSelector), (project, sameLevelIssueTypesIds, isSimplifiedProject)=>{
    const issueTypes = project && project.issueTypes || [];
    // We want to restrict the available issue types to the ones at the same level in next gen projects
    return isSimplifiedProject ? issueTypes.filter((issuetype)=>sameLevelIssueTypesIds.includes(issuetype.id)) : issueTypes;
});
const $27cb9fad44151c56$export$37eb3cdcb1c1f5f = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>!!(ui.issueType && ui.issueType.shouldShowIssueTypeList));

});

parcelRegister("zdfJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8500b18fb825cf55$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $hnzPP = parcelRequire("hnzPP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $a87O2 = parcelRequire("a87O2");

var $3Q2zv = parcelRequire("3Q2zv");
const $8500b18fb825cf55$var$filterSubTaskTypePredicate = (currentType, targetType)=>{
    if (currentType.subtask) return targetType.subtask;
    return true;
};
const $8500b18fb825cf55$var$ChangeIssueType = ({ isOpen: isOpen, icon: icon, issueTypes: issueTypes, issueId: issueId, showIssueTypeList: showIssueTypeList, loadIssueTypes: loadIssueTypes, changeIssueType: changeIssueType })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const [currentType] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: 'issuetype'
    });
    const projectKey = (0, $hJ992.useProjectKey)();
    const handleItemClick = (0, $eUqFw.useCallback)((nextType)=>{
        if (issueId !== null) {
            changeIssueType(issueKey, issueId, currentType, nextType, // todo: check context componentName
            createAnalyticsEvent({}));
            showIssueTypeList(false);
        }
    }, [
        changeIssueType,
        createAnalyticsEvent,
        currentType,
        issueId,
        issueKey,
        showIssueTypeList
    ]);
    const handleOpenChange = (0, $eUqFw.useCallback)(({ isOpen: eventPropIsOpen })=>{
        showIssueTypeList(eventPropIsOpen);
    }, [
        showIssueTypeList
    ]);
    const handleButtonClick = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        if (projectKey) {
            if (!isOpen) // todo: check this event, missing atlaskit button info
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                name: 'changeIssueTypeDropdown'
            }), 'button clicked', 'changeIssueTypeDropdownButton');
            showIssueTypeList(!isOpen);
        }
    }, [
        isOpen,
        projectKey,
        showIssueTypeList
    ]);
    const renderedIssueTypes = (0, $eUqFw.useMemo)(()=>{
        if (currentType && issueTypes && issueTypes.length !== 0) {
            const transformedIssueTypes = issueTypes.filter((type)=>type.id !== currentType.id).filter((type)=>$8500b18fb825cf55$var$filterSubTaskTypePredicate(currentType, type)).map((issueType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                    testId: `issue.views.issue-base.foundation.change-issue-type.item.${issueType.id}`,
                    key: issueType.id,
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
                        url: issueType.iconUrl,
                        alt: ""
                    }),
                    onClick: ()=>handleItemClick(issueType)
                }, issueType.name));
            return [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                    testId: `issue.views.issue-base.foundation.change-issue-type.item.${currentType.id}`,
                    key: currentType.id,
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
                        url: currentType.iconUrl,
                        alt: ""
                    }),
                    onClick: ()=>handleItemClick(currentType)
                }, currentType.name),
                ...transformedIssueTypes
            ];
        }
        return null;
    }, [
        currentType,
        handleItemClick,
        issueTypes
    ]);
    const firstRun = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>{
        // only load issues on component updates
        if (!firstRun.current && projectKey) loadIssueTypes(projectKey);
        else firstRun.current = false;
    }, [
        projectKey,
        isOpen,
        loadIssueTypes
    ]);
    const renderTriggerButton = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'triggerRef' implicitly has an 'any' type.
    ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Q2zv.default), {
            ...props,
            icon: icon,
            issueType: currentType && currentType.name ? currentType.name : '',
            onClick: handleButtonClick,
            ref: triggerRef
        }), [
        currentType,
        handleButtonClick,
        icon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.foundation.change-issue-type.dropdown",
        trigger: renderTriggerButton,
        placement: "bottom-start",
        appearance: "default",
        // @ts-expect-error - TS2769 - No overload matches this call.
        onOpenChange: handleOpenChange,
        isOpen: isOpen,
        isTriggerNotTabbable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        title: formatMessage((0, $a87O2.default).changeTypeGroupName)
    }, renderedIssueTypes));
};
var $8500b18fb825cf55$export$2e2bcd8739ae039 = $8500b18fb825cf55$var$ChangeIssueType;

});
parcelRegister("a87O2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1783c17b7d4334ee$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $1783c17b7d4334ee$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    changeType: {
        "id": "issue.details.change-issue-type",
        "defaultMessage": "{issueType} - Change issue type"
    },
    changeTypeGroupName: {
        "id": "issue.details.change-issue-type-groupname",
        "defaultMessage": "Change Issue Type"
    }
});

});

parcelRegister("3Q2zv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3b2cac2f5266bb1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $a87O2 = parcelRequire("a87O2");

var $1m70C = parcelRequire("1m70C");
const $e3b2cac2f5266bb1$var$TriggerButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ issueType: issueType, icon: icon, onClick: onClick, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1m70C.TriggerButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.foundation.change-issue-type.tooltip",
        position: "top",
        content: formatMessage((0, $a87O2.default).changeType, {
            issueType: issueType
        }),
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.foundation.change-issue-type.button",
        "aria-label": formatMessage((0, $a87O2.default).changeType, {
            issueType: issueType
        }),
        spacing: "compact",
        appearance: "subtle",
        onClick: onClick,
        iconBefore: icon,
        ref: ref,
        interactionName: "auto-generated.issue.views.issue-base.foundation.change-issue-type.button.button"
    })));
});
var $e3b2cac2f5266bb1$export$2e2bcd8739ae039 = $e3b2cac2f5266bb1$var$TriggerButton;

});
parcelRegister("1m70C", function(module, exports) {

$parcel$export(module.exports, "TriggerButtonContainer", () => $416cf9db1efca9b2$export$f9822f04f3bc7f4c);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $416cf9db1efca9b2$export$f9822f04f3bc7f4c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f31b66 _11c81oud",
            __cmplp.className
        ])
    });
});

});




parcelRegister("1qEvI", function(module, exports) {

$parcel$export(module.exports, "default", () => $2736cd070e6dd359$export$2e2bcd8739ae039);

var $8IjU8 = parcelRequire("8IjU8");
var $2736cd070e6dd359$export$2e2bcd8739ae039 = (0, $8IjU8.View);

});
parcelRegister("8IjU8", function(module, exports) {

$parcel$export(module.exports, "View", () => $dc4a0f52379ba5ef$export$27a5bd065ad55220);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $8cU5f = parcelRequire("8cU5f");

var $hnzPP = parcelRequire("hnzPP");

var $4ksts = parcelRequire("4ksts");

var $18MWD = parcelRequire("18MWD");
const $dc4a0f52379ba5ef$export$27a5bd065ad55220 = ({ issueTypeIconUrl: issueTypeIconUrl, issueTypeName: issueTypeName })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "top",
        content: formatMessage((0, $18MWD.default).uneditableIssueType, {
            issueTypeName: issueTypeName
        }),
        truncate: true,
        delay: 0,
        testId: "issue-view-foundation.noneditable-issue-type.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dc4a0f52379ba5ef$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        spacing: "compact",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
            url: issueTypeIconUrl,
            alt: issueTypeName
        }),
        isDisabled: true,
        interactionName: "auto-generated.jira-issue-view-foundation.noneditable-issue-type.button",
        testId: "issue-view-foundation.noneditable-issue-type.button"
    })));
};
var $dc4a0f52379ba5ef$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $dc4a0f52379ba5ef$export$27a5bd065ad55220;
const $dc4a0f52379ba5ef$var$ButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80om13gf _9e68glyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("18MWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7a6efd50714ad4a$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $b7a6efd50714ad4a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    uneditableIssueType: {
        "id": "issue.details.uneditable-issue-type",
        "defaultMessage": "{issueTypeName} - You cannot edit this issue type in this project."
    }
});

});




parcelRegister("3AaYy", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d13c8f27aa74da6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $bm5l8 = parcelRequire("bm5l8");

var $8cU5f = parcelRequire("8cU5f");

var $h8auO = parcelRequire("h8auO");

var $aWUQ5 = parcelRequire("aWUQ5");

var $1o3dn = parcelRequire("1o3dn");
class $5d13c8f27aa74da6$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isSimplifiedProject: false,
            isDisabled: true,
            issueHierarchyLevel: 0,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            triggerRef: {
                current: null
            },
            onAddOrRemoveParent: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    renderBreadcrumbsItem() {
        const { isSimplifiedProject: isSimplifiedProject, parentIssue: parentIssue, onClick: onClick } = this.props;
        const { key: key, summary: summary, url: url } = parentIssue;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: `${key}: ${summary}`,
            position: "top",
            delay: 0,
            /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.foundation.breadcrumbs.parent-issue.tooltip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bm5l8.default), {
            /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.foundation.breadcrumbs.parent-issue.item",
            href: url,
            onClick: onClick,
            text: (0, $aWUQ5.truncateBreadcrumbs)(key),
            truncationWidth: isSimplifiedProject ? undefined : 300
        }));
    }
    render() {
        const { isDisabled: isDisabled, parentIssue: parentIssue, issueHierarchyLevel: issueHierarchyLevel, currentIssueKey: currentIssueKey, triggerRef: triggerRef, onAddOrRemoveParent: onAddOrRemoveParent } = this.props;
        const { key: key, issueTypeName: issueTypeName, issueTypeIconUrl: issueTypeIconUrl } = parentIssue;
        const breadcrumbsItemWithTooltip = this.renderBreadcrumbsItem();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1o3dn.IssueContainer), {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "issue.views.issue-base.foundation.breadcrumbs.breadcrumb-parent-issue-container",
            onMouseEnter: !isDisabled ? this.onHoveredChange(true) : undefined,
            onMouseLeave: !isDisabled ? this.onHoveredChange(false) : undefined,
            fixExtraDivider: true,
            shouldTruncate: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h8auO.default), {
            isDisabled: isDisabled,
            currentIssueKey: currentIssueKey,
            issueKey: key,
            issueTypeName: issueTypeName,
            issueTypeIconUrl: this.state.isHovered ? '' : issueTypeIconUrl,
            issueHierarchyLevel: issueHierarchyLevel,
            onSelect: this.onHoveredChange(false),
            onAddOrRemoveParent: onAddOrRemoveParent,
            triggerRef: triggerRef
        }), breadcrumbsItemWithTooltip);
    }
    constructor(...args){
        super(...args);
        this.state = {
            isHovered: false
        };
        this.onHoveredChange = (isHovered)=>()=>{
                this.setState({
                    isHovered: isHovered
                });
            };
    }
}

});

parcelRegister("jgeG5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b5d0eeda47c140f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $bm5l8 = parcelRequire("bm5l8");

var $8cU5f = parcelRequire("8cU5f");

var $hnzPP = parcelRequire("hnzPP");

var $aWUQ5 = parcelRequire("aWUQ5");

var $1o3dn = parcelRequire("1o3dn");
const $1b5d0eeda47c140f$export$94082c7b16aecae = ({ shouldShowProjectLevelBreadcrumb: shouldShowProjectLevelBreadcrumb = false, projectName: projectName = '', projectUrl: projectUrl = '', projectAvatarUrl: projectAvatarUrl = '', onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>{
    const showProjectBreadcrumb = Boolean(shouldShowProjectLevelBreadcrumb && projectName && projectUrl);
    const asyncIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
        url: projectAvatarUrl,
        alt: projectName
    });
    const projectIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1o3dn.IconPaddingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1o3dn.ProjectIconWrapper), null, asyncIcon));
    const breadcrumbsItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bm5l8.default), {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.foundation.breadcrumbs.project.item",
        href: projectUrl,
        onClick: onClick,
        text: (0, $aWUQ5.truncateBreadcrumbs)(projectName),
        truncationWidth: 0,
        iconBefore: projectIcon
    });
    return showProjectBreadcrumb ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1o3dn.ProjectContainer), {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.issue-base.foundation.breadcrumbs.project.container",
        fixExtraDivider: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: projectName,
        position: "top",
        delay: 0,
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.foundation.breadcrumbs.project.tooltip"
    }, breadcrumbsItem)) : null;
};
var $1b5d0eeda47c140f$export$2e2bcd8739ae039 = $1b5d0eeda47c140f$export$94082c7b16aecae;

});



parcelRegister("1HYWN", function(module, exports) {

$parcel$export(module.exports, "IssueNavigator", () => $79c190a3bcf4d30f$export$7ce7655f9203948d);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $5xnoX = parcelRequire("5xnoX");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $5usGB = parcelRequire("5usGB");

var $7qP5e = parcelRequire("7qP5e");
const $79c190a3bcf4d30f$var$FireNavigatorShownAnalyticsEvent = ({ issueKey: issueKey })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueViewHeaderIssueNavigationButtons shown');
    }, [
        createAnalyticsEvent,
        issueKey
    ]);
    return null;
};
const $79c190a3bcf4d30f$export$7ce7655f9203948d = ()=>{
    const issueNavigatorData = (0, $hJ992.useIssueNavigatorData)();
    const backButtonUrl = (0, $hJ992.useBackButtonUrl)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!issueNavigatorData || !backButtonUrl) return null;
    const { issueKey: issueKey, issueKeys: issueKeys, knownIssueKeys: knownIssueKeys, issuesCount: issuesCount } = issueNavigatorData;
    const index = knownIssueKeys.indexOf(issueKey);
    if (index === -1) return null;
    const createHandleOnClick = (actionSubjectId)=>(_event, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, actionSubjectId);
        };
    const canNavigateNext = index < knownIssueKeys.length - 1;
    const isLastIssue = issueKeys.indexOf(issueKey) === issuesCount - 1;
    const nextContent = !isLastIssue ? formatMessage((0, $5usGB.default).canNotNavigateNextIssueTooltip) : '';
    const nextToolTipContent = canNavigateNext ? formatMessage((0, $5usGB.default).nextIssueIssueTooltip, {
        issueKey: knownIssueKeys[index + 1]
    }) : nextContent;
    const canNavigatePrevious = index > 0;
    const isFirstIssue = issueKeys.indexOf(issueKey) === 0;
    const previousContent = !isFirstIssue ? formatMessage((0, $5usGB.default).canNotNavigatePrevioustIssueTooltip) : '';
    const previousToolTipContent = canNavigatePrevious ? formatMessage((0, $5usGB.default).previousIssueTooltip, {
        issueKey: knownIssueKeys[index - 1]
    }) : previousContent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            navIssuesCount: issuesCount,
            navCurrentIssueIndex: issueKeys.indexOf(issueKey),
            canNavigatePrevious: canNavigatePrevious,
            canNavigateNext: canNavigateNext,
            isLastNavigationIssue: isLastIssue
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($79c190a3bcf4d30f$var$FireNavigatorShownAnalyticsEvent, {
        issueKey: issueKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qP5e.IssueNavigatorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: previousToolTipContent,
        position: "bottom",
        testId: "issue-view-foundation.header.header-breadcrumbs.issue-navigator.navigate-previous-button-tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        isDisabled: !canNavigatePrevious,
        href: `${backButtonUrl}/${knownIssueKeys[index - 1]}`,
        onClick: createHandleOnClick('navigatePreviousIssueClicked'),
        component: (0, $kJlBc.Link),
        "data-testId": "issue-view-foundation.header.header-breadcrumbs.issue-navigator.navigate-previous-button",
        "aria-label": canNavigatePrevious ? previousToolTipContent : undefined,
        interactionName: "auto-generated.jira-issue-view-foundation.header.header-breadcrumbs.issue-navigator.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))), {
        size: "medium",
        label: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qP5e.ButtonsSpacer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: nextToolTipContent,
        position: "bottom",
        testId: "issue-view-foundation.header.header-breadcrumbs.issue-navigator.navigate-next-button-tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        isDisabled: !canNavigateNext,
        href: `${backButtonUrl}/${knownIssueKeys[index + 1]}`,
        onClick: createHandleOnClick('navigateNextIssueClicked'),
        component: (0, $kJlBc.Link),
        "data-testId": "issue-view-foundation.header.header-breadcrumbs.issue-navigator.navigate-next-button",
        "aria-label": canNavigateNext ? nextToolTipContent : undefined,
        interactionName: "auto-generated.jira-issue-view-foundation.header.header-breadcrumbs.issue-navigator.button1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        size: "medium",
        label: ""
    })))));
};

});
parcelRegister("5xnoX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40822fe6f5908262$var$_react = $40822fe6f5908262$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $40822fe6f5908262$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $40822fe6f5908262$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $40822fe6f5908262$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.221 9.322l-2.929 2.955a1.009 1.009 0 000 1.419.986.986 0 001.405 0l2.298-2.317 2.307 2.327a.989.989 0 001.407 0 1.01 1.01 0 000-1.419l-2.94-2.965A1.106 1.106 0 0011.991 9c-.279 0-.557.107-.77.322z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$40822fe6f5908262$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $40822fe6f5908262$var$_default = $40822fe6f5908262$var$ChevronUpIcon;
module.exports.default = $40822fe6f5908262$var$_default;

});

parcelRegister("5usGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ff0d5680c35a5de$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8ff0d5680c35a5de$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    previousIssueTooltip: {
        "id": "issue-view-foundation.header.header-breadcrumbs.issue-navigator.previous-issue-tooltip",
        "defaultMessage": "Previous issue \u2018{issueKey}\u2019"
    },
    nextIssueIssueTooltip: {
        "id": "issue-view-foundation.header.header-breadcrumbs.issue-navigator.next-issue-issue-tooltip",
        "defaultMessage": "Next issue \u2018{issueKey}\u2019"
    },
    canNotNavigateNextIssueTooltip: {
        "id": "issue-view-foundation.header.header-breadcrumbs.issue-navigator.can-not-navigate-next-issue-tooltip",
        "defaultMessage": "We can\u2019t show any more issues. Go to your queue to view all issues."
    },
    canNotNavigatePrevioustIssueTooltip: {
        "id": "issue-view-foundation.header.header-breadcrumbs.issue-navigator.can-not-navigate-previoust-issue-tooltip",
        "defaultMessage": "We can\u2019t show previous issues. Go to your queue to view all issues."
    }
});

});

parcelRegister("7qP5e", function(module, exports) {

$parcel$export(module.exports, "IssueNavigatorWrapper", () => $273f9a399f47f4f7$export$4700c3a8833cb856);
$parcel$export(module.exports, "ButtonsSpacer", () => $273f9a399f47f4f7$export$4f3a0dacb1f2d9f4);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $273f9a399f47f4f7$export$4700c3a8833cb856 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _18u0xmi2 _ep9tidpf _9r1zidpf _f5gaidpf _hstcidpf _iijb1wug _1la1n7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _13t3n7od",
            __cmplp.className
        ])
    });
});
const $273f9a399f47f4f7$export$4f3a0dacb1f2d9f4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbu2gc",
            __cmplp.className
        ])
    });
});

});




parcelRegister("cLIc8", function(module, exports) {

$parcel$export(module.exports, "clickthroughAllowedSources", () => $e9e9feb1f9ac81c4$export$115d81db844d000a);

const $e9e9feb1f9ac81c4$export$115d81db844d000a = [
    (0, $0100842672acae20$export$b19f949fb9713614),
    (0, $0100842672acae20$export$7063ee6d0035a982),
    (0, $0100842672acae20$export$5bd5011b6596a0e7)
];

});

parcelRegister("fPlP8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7897ae8e918c2903$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ISSUE_HEADER_SHADOW_HEIGHT", () => $7897ae8e918c2903$export$1ac29aacffef2119);
$parcel$export(module.exports, "stickyLineExtraLengthLeft", () => $7897ae8e918c2903$export$151f426648c18e57);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $a576Y = parcelRequire("a576Y");

var $c9TLT = parcelRequire("c9TLT");

var $7GSu6 = parcelRequire("7GSu6");

var $hzhuB = parcelRequire("hzhuB");

var $keOMr = parcelRequire("keOMr");

var $jBZ6y = parcelRequire("jBZ6y");
const $7897ae8e918c2903$var$STICKY_NAME = 'sticky-header';
const $7897ae8e918c2903$var$StickyHeader = ({ shouldUseDeprecatedScrollParent: shouldUseDeprecatedScrollParent = false, scrollContainer: scrollContainer, elementId: elementId, children: children, style: style })=>{
    const isEmbedMode = (0, $keOMr.useIsEmbedMode)();
    const [shouldShowKeyline, setShouldShowKeyline] = (0, $eUqFw.useState)(false);
    const [deprecatedScrollParent, setDeprecatedScrollParent] = (0, $eUqFw.useState)(null);
    const innerElRef = (0, $eUqFw.useRef)(null);
    const { registerSticky: registerSticky, deregisterSticky: deregisterSticky } = (0, $7GSu6.useStickyHeaderRegistration)();
    const innerEl = (0, $eUqFw.useCallback)((node)=>{
        innerElRef.current = node;
        if (shouldUseDeprecatedScrollParent) setDeprecatedScrollParent((0, $hzhuB.getScrollParent)(node));
    }, [
        shouldUseDeprecatedScrollParent
    ]);
    const container = (0, $eUqFw.useMemo)(()=>(shouldUseDeprecatedScrollParent ? deprecatedScrollParent : scrollContainer) ?? null, [
        shouldUseDeprecatedScrollParent,
        deprecatedScrollParent,
        scrollContainer
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // this element is constantly sticky. Conditional register is not an option
        registerSticky($7897ae8e918c2903$var$STICKY_NAME, innerElRef, {
            marginBottom: $7897ae8e918c2903$export$f1124d7277333cc0
        });
        return ()=>deregisterSticky($7897ae8e918c2903$var$STICKY_NAME);
    }, [
        registerSticky,
        deregisterSticky
    ]);
    const calculateShouldShowKeyline = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(()=>{
            if (container && innerElRef.current) {
                const innerRect = innerElRef.current.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();
                const containerTop = Math.max(containerRect.top, 0);
                const newShouldShowKeyline = container.scrollTop > 0 && innerRect.top <= containerTop;
                setShouldShowKeyline(newShouldShowKeyline);
            }
        }, 100), [
        container
    ]);
    (0, $eUqFw.useEffect)(()=>{
        calculateShouldShowKeyline();
        // FIXME: on MobileView this container will point to a non-correct scrollable parent
        // instead it shall point on body
        container && container.addEventListener('scroll', calculateShouldShowKeyline);
        return ()=>{
            container && container.removeEventListener('scroll', calculateShouldShowKeyline);
        };
    }, [
        container,
        calculateShouldShowKeyline
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7897ae8e918c2903$var$StickyWrapper, {
        topOffset: 0,
        id: elementId,
        showKeyline: shouldShowKeyline,
        ref: innerEl,
        /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        isEmbedMode: isEmbedMode,
        "data-testid": "issue-view-sticky-header-container.sticky-header"
    }, children);
};
var $7897ae8e918c2903$export$2e2bcd8739ae039 = $7897ae8e918c2903$var$StickyHeader;
const $7897ae8e918c2903$export$1ac29aacffef2119 = 2;
const $7897ae8e918c2903$export$151f426648c18e57 = (0, $c9TLT.gridSize);
const $7897ae8e918c2903$export$700cfed6512060b3 = (0, $c9TLT.layers).card - 1;
const $7897ae8e918c2903$export$f1124d7277333cc0 = -1; // without '-1px' - part of underlying page/text is shown sometimes on top of header on scroll
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7897ae8e918c2903$var$StickyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEmbedMode: isEmbedMode, topOffset: topOffset, showKeyline: showKeyline, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_52dnyy": (0, $9t7rW.default)((0, $jBZ6y.issueViewLayers).stickyHeaderBreadcrumbs),
            "--_1dtg6dp": (0, $9t7rW.default)(`${__cmplp.topOffset + $7897ae8e918c2903$export$f1124d7277333cc0}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1axi1if8 _1ae3xs22 _s9qlu2gc _nn8px0bf _vggst94y _uto9d5jx",
            __cmplp.isEmbedMode ? "_r3721bhr" : "_r372vuon",
            __cmplp.showKeyline ? "_igsxj5kh" : undefined,
            __cmplp.className
        ])
    });
});
$7897ae8e918c2903$var$StickyWrapper.displayName = 'StickyWrapper';

});
parcelRegister("hzhuB", function(module, exports) {

$parcel$export(module.exports, "getScrollParent", () => $c093b320872244af$export$cfa2225e87938781);
// Analog of jquery .scrollParent(). Taken from https://stackoverflow.com/a/42543908/1343917
const $c093b320872244af$export$cfa2225e87938781 = (element, shouldExcludeStaticParent = true)=>{
    if (!element || !element.parentElement) return null;
    let style = getComputedStyle(element);
    const excludeStaticParent = shouldExcludeStaticParent && style.position === 'absolute';
    const overflowRegex = /(auto|scroll)/; // overflow-x: hidden will make overflowY to be 'auto' automatically (by W3C spec)
    if (style.position === 'fixed') return document.body;
    // @ts-expect-error - TS2322 - Type 'HTMLElement | null' is not assignable to type 'HTMLElement'.
    for(let parent = element.parentElement; parent; parent = parent && parent.parentElement){
        style = getComputedStyle(parent);
        const shouldIgnoreElement = excludeStaticParent && style.position === 'static';
        if (!shouldIgnoreElement && overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return null;
};

});

parcelRegister("jBZ6y", function(module, exports) {

$parcel$export(module.exports, "issueViewLayers", () => $e5ed9d56a136efa3$export$c9d6c43f7977c226);

var $c9TLT = parcelRequire("c9TLT");
const $e5ed9d56a136efa3$var$baseLayer = (0, $c9TLT.layers).card;
const $e5ed9d56a136efa3$export$c9d6c43f7977c226 = {
    ...(0, $c9TLT.layers),
    baseLayer: $e5ed9d56a136efa3$var$baseLayer,
    stickyHeaderBreadcrumbs: $e5ed9d56a136efa3$var$baseLayer - 1,
    // the group header needs to sit below the jira issue header (stickyHeaderBreadcrumbs),
    // be higher than the editor header and be lower than
    // the modal layer (used for field menus that show on top of the group header)
    groupStickyHeader: $e5ed9d56a136efa3$var$baseLayer - 2,
    // editor popup should be portaled to a node "above" Issue Dialog
    editorTooltip: (0, $c9TLT.layers).modal + 1
};

});


parcelRegister("c4qEZ", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $d58942287640a101$export$49addbcdecb6e6ff);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $kB5wN = parcelRequire("kB5wN");

var $8ICxF = parcelRequire("8ICxF");

var $brt18 = parcelRequire("brt18");
const $d58942287640a101$var$fullpageStyles = null;
const $d58942287640a101$var$modalStyles = null;
const $d58942287640a101$var$customSpacingStyles = null;
const $d58942287640a101$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $d58942287640a101$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $d58942287640a101$var$fullpageStyles : null,
        isModalView === true ? $d58942287640a101$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kB5wN.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($brt18))),
        className: (0, $7JEyt.default)([
            "_p12f1ypn _18s85ogf _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};

});
parcelRegister("8ICxF", function(module, exports) {

$parcel$export(module.exports, "AppSkeletonImage", () => $f467e6485d9792e8$export$45b107c5dc7b51a5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/react/no-classname-attribute */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $5JgJ2 = parcelRequire("5JgJ2");

var $84CBi = parcelRequire("84CBi");

var $h1hCM = parcelRequire("h1hCM");
const $f467e6485d9792e8$var$skeletonImageStyles = null;
const $f467e6485d9792e8$export$45b107c5dc7b51a5 = ({ src: src, className: className, containerStyles: containerStyles })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "app-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f467e6485d9792e8$var$SkeletonWrapper // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: src,
        alt: `${formatMessage((0, $h1hCM.default).loading)}...`,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _vchhusvi _1bsb1osq _1dqonqa1 _1h6d3acm _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
            className
        ])
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f467e6485d9792e8$var$SkeletonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h1hCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b5b2a6284984f9f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0b5b2a6284984f9f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    loading: {
        "id": "skeletons.common.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("brt18", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.31d538db.svg", import.meta.url).toString();

});


parcelRegister("cyQ1m", function(module, exports) {

$parcel$export(module.exports, "StorageLimitsBanner", () => $dfd96f3cb7f5a040$export$3250e2c90ae56dd9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfd96f3cb7f5a040$var$LazyStorageLimitBanner = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("d5jIw")), {
    ssr: false,
    moduleId: "./src/packages/growth/storage-limits/src/ui/index.tsx"
});
const $dfd96f3cb7f5a040$export$3250e2c90ae56dd9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: (0, $8cd287fa797c55ed$export$5dec3c05c01dac30),
        packageName: (0, $8cd287fa797c55ed$export$b8b9d90f9e5bd72b),
        teamName: "flywheel-tako",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "storage-limits-banner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dfd96f3cb7f5a040$var$LazyStorageLimitBanner, props)));

});
const $8cd287fa797c55ed$export$bab748d4654ac4a5 = 0.9;
const $8cd287fa797c55ed$export$b8b9d90f9e5bd72b = 'jiraGrowthStorageLimits';
const $8cd287fa797c55ed$export$df9953733f41292a = 'storageLimitsBanner';
const $8cd287fa797c55ed$export$5dec3c05c01dac30 = 'asyncStorageLimitsBanner';
const $8cd287fa797c55ed$export$3aad3de2cc377789 = 'jira_software_free_is_ccp_billing_admins';

parcelRegister("d5jIw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iBTRu');
        const value = parcelRequire('i4DKK');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iBTRu").then(()=>parcelRequire('i4DKK'));
}

});


parcelRegister("idiDE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8ff5844edbd42f4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $5iuyH = parcelRequire("5iuyH");

var $adEL3 = parcelRequire("adEL3");
const $b8ff5844edbd42f4$var$newContextWithUfoContext = (context, interactionContext)=>context && interactionContext && {
        ...context,
        getInteractionContext: ()=>interactionContext
    };
const $b8ff5844edbd42f4$var$flowRight = (functionList)=>(arg)=>functionList.reduceRight((acc, fn)=>fn(acc), arg);
const $b8ff5844edbd42f4$var$renderContextProviderIfNonNull = (Context, contextValue)=>(node)=>contextValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Context.Provider, {
            value: contextValue
        }, node) : node;
function $b8ff5844edbd42f4$var$JiraUFOLabelWrapper({ children: children }) {
    const context = (0, $5iuyH.useInteractionContext)();
    const rllProfilerContext = (0, $eUqFw.useContext)((0, $7rh0R.ProfilerContext));
    const relayProfilerContext = (0, $eUqFw.useContext)((0, $iWLL0.ProfilerContext));
    const newRllProfilerContext = (0, $eUqFw.useMemo)(()=>({
            current: $b8ff5844edbd42f4$var$newContextWithUfoContext(rllProfilerContext?.current, context)
        }), [
        context,
        rllProfilerContext
    ]);
    const newRelayProfilerContext = (0, $eUqFw.useMemo)(()=>$b8ff5844edbd42f4$var$newContextWithUfoContext(relayProfilerContext, context), [
        context,
        relayProfilerContext
    ]);
    // Produces the following but only renders a provider if its context is not null
    // <RelayProfilerContext.Provider ...>
    //   <RLLProfilerContext.Provider ...>
    //     {children}
    //   </...etc
    return $b8ff5844edbd42f4$var$flowRight([
        $b8ff5844edbd42f4$var$renderContextProviderIfNonNull((0, $iWLL0.ProfilerContext), newRelayProfilerContext),
        $b8ff5844edbd42f4$var$renderContextProviderIfNonNull((0, $7rh0R.ProfilerContext), newRllProfilerContext)
    ])(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children));
}
function $b8ff5844edbd42f4$export$2e2bcd8739ae039({ name: name, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adEL3.default), {
        name: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b8ff5844edbd42f4$var$JiraUFOLabelWrapper, null, children));
}

});
parcelRegister("adEL3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecd8165bfe78bf8d$export$2e2bcd8739ae039);

var $jL1z3 = parcelRequire("jL1z3");
var $ecd8165bfe78bf8d$export$2e2bcd8739ae039 = (0, $jL1z3.default);

});
parcelRegister("jL1z3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9c1936ffc5634d4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");
function $f9c1936ffc5634d4$export$2e2bcd8739ae039({ name: name, children: children }) {
    const context = (0, $5iuyH.useInteractionContext)();
    const newContext = (0, $eUqFw.useMemo)(()=>{
        if (context) return {
            ...context,
            labelStack: context.labelStack == null ? [
                {
                    name: name
                }
            ] : [
                ...context.labelStack,
                {
                    name: name
                }
            ]
        };
        else return context;
    }, [
        context,
        name
    ]);
    return context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5iuyH.default).Provider, {
        value: newContext
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
}

});



parcelRegister("8HMCF", function(module, exports) {

$parcel$export(module.exports, "UpFlowPersistentUpgradeBanner", () => $1ded51f6d1fe0671$export$39832316603e4613);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $bNa2U = parcelRequire("bNa2U");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1ded51f6d1fe0671$var$LazyUpFlowPersistentUpgradeBanner = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("7dvmu")), {
    ssr: false,
    moduleId: "./src/packages/growth/up-flow/persistent-upgrade-banner/src/main.tsx"
});
const $1ded51f6d1fe0671$export$39832316603e4613 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: (0, $bNa2U.PERSISTENT_UPGRADE_ANALYTICS_SOURCE),
        packageName: (0, $bNa2U.PERSISTENT_UPGRADE_TOUCHPOINT_BANNER),
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "up-flow-persistent-upgrade-banner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ded51f6d1fe0671$var$LazyUpFlowPersistentUpgradeBanner, props)));

});
parcelRegister("bNa2U", function(module, exports) {

$parcel$export(module.exports, "PERSISTENT_UPGRADE_PRE_TRIAL_FREE_EDITION", () => $d4c4bcb569ddbdc8$export$75e961f06f21e171);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_ANALYTICS_SOURCE", () => $d4c4bcb569ddbdc8$export$bebf43b5d37dab0);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_ANALYTICS_UPGRADE_FLOW", () => $d4c4bcb569ddbdc8$export$cbfd75a8d4af5ce5);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_UPFLOW_MODAL_FLOW", () => $d4c4bcb569ddbdc8$export$a2684b22124cc502);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_TOUCHPOINT_BANNER", () => $d4c4bcb569ddbdc8$export$e54a73280ddbd89);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_TOUCHPOINT_BANNER_VIEWED", () => $d4c4bcb569ddbdc8$export$96913d5371f745ad);
$parcel$export(module.exports, "MAX_CADENCE_INDEX", () => $d4c4bcb569ddbdc8$export$b8743c23616e54ee);
$parcel$export(module.exports, "KEY_USER_PROPERTIES_JSW", () => $d4c4bcb569ddbdc8$export$6a69b5601e7d435);
$parcel$export(module.exports, "KEY_USER_PROPERTIES_JSM", () => $d4c4bcb569ddbdc8$export$364c2b43630f5cb5);
$parcel$export(module.exports, "BANNER_CADENCE_INFO", () => $d4c4bcb569ddbdc8$export$ec6ce1b450620e5c);
$parcel$export(module.exports, "SEND_OPERATIONAL_EVENT", () => $d4c4bcb569ddbdc8$export$8b4682bf35504518);
$parcel$export(module.exports, "API_SUCCESS", () => $d4c4bcb569ddbdc8$export$6d01cae610456af2);
$parcel$export(module.exports, "API_FAIL", () => $d4c4bcb569ddbdc8$export$6a238c78062d3b8d);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL", () => $d4c4bcb569ddbdc8$export$d094ee3fcda994eb);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL_SUCCESS", () => $d4c4bcb569ddbdc8$export$8357ebd56fd8e5ea);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL_FAIL", () => $d4c4bcb569ddbdc8$export$252ee5e4ed4943dc);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL", () => $d4c4bcb569ddbdc8$export$f3310dd86ae4284b);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL_SUCCESS", () => $d4c4bcb569ddbdc8$export$5e4635b476d2b497);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL_FAIL", () => $d4c4bcb569ddbdc8$export$b49d6161d5ea4a0a);
$parcel$export(module.exports, "PERSISTENT_PRETRIAL_BANNER_CADENCES_MS", () => $d4c4bcb569ddbdc8$export$55aa1fd7f74b53);
const $d4c4bcb569ddbdc8$export$75e961f06f21e171 = 'pre-trial';
const $d4c4bcb569ddbdc8$export$bebf43b5d37dab0 = 'persistentUpgrade';
const $d4c4bcb569ddbdc8$export$cbfd75a8d4af5ce5 = 'upgradeFlow';
const $d4c4bcb569ddbdc8$export$a2684b22124cc502 = 'persistent-upgrade';
const $d4c4bcb569ddbdc8$export$e54a73280ddbd89 = 'persistentUpgradeBanner';
const $d4c4bcb569ddbdc8$export$96913d5371f745ad = 'persistentUpgradeBanner viewed';
const $d4c4bcb569ddbdc8$export$b8743c23616e54ee = 3;
const $d4c4bcb569ddbdc8$export$6a69b5601e7d435 = 'growth-puet-banner-cadence';
const $d4c4bcb569ddbdc8$export$364c2b43630f5cb5 = 'growth-puet-banner-cadence-jsm';
const $d4c4bcb569ddbdc8$export$ec6ce1b450620e5c = 'Banner Cadence Info';
const $d4c4bcb569ddbdc8$export$8b4682bf35504518 = 'sendOperationalEvent';
const $d4c4bcb569ddbdc8$export$6d01cae610456af2 = 'success';
const $d4c4bcb569ddbdc8$export$6a238c78062d3b8d = 'failed';
const $d4c4bcb569ddbdc8$export$d094ee3fcda994eb = 'getUserPropertyApiCall';
const $d4c4bcb569ddbdc8$export$8357ebd56fd8e5ea = 'getUserPropertyApiCall success';
const $d4c4bcb569ddbdc8$export$252ee5e4ed4943dc = 'getUserPropertyApiCall failed';
const $d4c4bcb569ddbdc8$export$f3310dd86ae4284b = 'setUserPropertyApiCall';
const $d4c4bcb569ddbdc8$export$5e4635b476d2b497 = 'setUserPropertyApiCall success';
const $d4c4bcb569ddbdc8$export$b49d6161d5ea4a0a = 'setUserPropertyApiCall failed';
const $d4c4bcb569ddbdc8$export$55aa1fd7f74b53 = [
    0,
    604800000,
    1814400000,
    3628800000
];

});

parcelRegister("7dvmu", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('g8JKE');
        const value = parcelRequire('27Md7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("g8JKE").then(()=>parcelRequire('27Md7'));
}

});


parcelRegister("jc4kK", function(module, exports) {

$parcel$export(module.exports, "markFragmentReady", () => $3ef0a8a6a82c0ed3$export$f35671de67f03a2b);
$parcel$export(module.exports, "initialiseMetrics", () => $3ef0a8a6a82c0ed3$export$1ac307e078c767d0);
$parcel$export(module.exports, "markIssueStartRendering", () => $3ef0a8a6a82c0ed3$export$c039505b02c87616);
$parcel$export(module.exports, "markIssueRender", () => $3ef0a8a6a82c0ed3$export$c16cf8a32075f588);
$parcel$export(module.exports, "markIssueLegacyInteractive", () => $3ef0a8a6a82c0ed3$export$4d5d547fdbe28097);
$parcel$export(module.exports, "markSPAReadyEndOfCriticalPath", () => $3ef0a8a6a82c0ed3$export$a45a77102d75517f);
$parcel$export(module.exports, "markIssueInteractive", () => $3ef0a8a6a82c0ed3$export$e57956c4b76a36f);
$parcel$export(module.exports, "markIssueOnPageLoadEvent", () => $3ef0a8a6a82c0ed3$export$c30d9392d27ab5a8);
$parcel$export(module.exports, "markStartIssue", () => $3ef0a8a6a82c0ed3$export$71cdf78946f275c);
$parcel$export(module.exports, "markIssuePreviewRendered", () => $3ef0a8a6a82c0ed3$export$7f5545008a1e5a18);
$parcel$export(module.exports, "setIsInitialRender", () => $3ef0a8a6a82c0ed3$export$eedeaa0a5b3bd3d1);
$parcel$export(module.exports, "isFullIssueView", () => $3ef0a8a6a82c0ed3$export$db2ef91f6ace96c7);

var $hompL = parcelRequire("hompL");

var $hknOo = parcelRequire("hknOo");

var $6iz4v = parcelRequire("6iz4v");

var $gUUjF = parcelRequire("gUUjF");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");


var $RvFPW = parcelRequire("RvFPW");

var $g0N0Z = parcelRequire("g0N0Z");

var $8Bhia = parcelRequire("8Bhia");

var $782cd = parcelRequire("782cd");

var $lMwBY = parcelRequire("lMwBY");

var $6M8Uw = parcelRequire("6M8Uw");
var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $iTvzN = parcelRequire("iTvzN");

var $1QVWH = parcelRequire("1QVWH");

var $j2Yjr = parcelRequire("j2Yjr");

var $3WQZN = parcelRequire("3WQZN");

var $fVaJL = parcelRequire("fVaJL");

var $9OxOE = parcelRequire("9OxOE");

var $aQQHY = parcelRequire("aQQHY");

var $7iu2Y = parcelRequire("7iu2Y");

var $gU59E = parcelRequire("gU59E");

var $7YIVI = parcelRequire("7YIVI");
const $3ef0a8a6a82c0ed3$var$LOG_LOCATION = 'issue.metrics';
let $3ef0a8a6a82c0ed3$var$state;
const $3ef0a8a6a82c0ed3$var$getSsrMark = ()=>{
    const ssrMark = (0, $6iz4v.getMark)((0, $hknOo.SPA_SSR_RENDERED_MARK));
    if (ssrMark != null) return Math.floor(ssrMark.startTime);
    return null;
};
const $3ef0a8a6a82c0ed3$var$setMarkWithError = (markName)=>{
    try {
        (0, $6iz4v.setMark)(markName);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData($3ef0a8a6a82c0ed3$var$LOG_LOCATION, 'Setting performance mark failed', error);
    }
};
const $3ef0a8a6a82c0ed3$export$f35671de67f03a2b = ()=>{
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$625e4e4c6eb56930);
};
const $3ef0a8a6a82c0ed3$export$1ac307e078c767d0 = (options)=>{
    try {
        const { issueContextActions: issueContextActions, isLoadedWithPage: isLoadedWithPage, isSPA: isSPA, isRecentIssue: isRecentIssue, recentIssuesCount: recentIssuesCount, dataProvider: dataProvider, analyticsSource: analyticsSource, store: store, route: route } = options;
        $3ef0a8a6a82c0ed3$var$state = new (0, $gU59E.default)({
            isLoadedWithPage: isLoadedWithPage,
            isSPA: isSPA,
            isRecentIssue: isRecentIssue,
            analyticsSource: analyticsSource,
            recentIssuesCount: recentIssuesCount,
            correlationId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
            // @ts-expect-error - TS2322 - Type '{ analyticsKey: ApplicationKey | undefined; viewMode: any; issueId: string | undefined; }' is not assignable to type 'MetricsProps'.
            lazyMetricsProps: ()=>(0, $7YIVI.metricsStateSelector)(store.getState()),
            timingDataReporter: ()=>({
                    ...(0, $782cd.serverTimingSelector)(store.getState()),
                    ...(0, $RvFPW.getFetchIssueNetworkTimes)()
                }),
            issueScaleabilityReporter: (0, $7iu2Y.issueScaleabilityReporterFactory)(store, issueContextActions),
            dataProvider: dataProvider,
            route: route
        });
        // Marking init of bm3
        (0, $g0N0Z.issueViewLoad).mark('metrics_init');
        (0, $g0N0Z.issueViewOnPageLoad).mark('metrics_init');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData($3ef0a8a6a82c0ed3$var$LOG_LOCATION, 'Failed to initialise issue metrics', error);
    }
};
const $3ef0a8a6a82c0ed3$export$c039505b02c87616 = ()=>{
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$10082883a7f4ea4d);
    (0, $g0N0Z.issueViewLoad).mark($848ef1328a091c81$export$10082883a7f4ea4d);
};
const $3ef0a8a6a82c0ed3$export$c16cf8a32075f588 = ()=>{
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$7f7b606f70e669e6);
    (0, $g0N0Z.issueViewOnPageLoad).mark($848ef1328a091c81$export$7f7b606f70e669e6);
};
const $3ef0a8a6a82c0ed3$export$4d5d547fdbe28097 = ()=>{
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$b292c195104c50d3);
    (0, $g0N0Z.issueViewLoad).mark($848ef1328a091c81$export$b292c195104c50d3);
};
const $3ef0a8a6a82c0ed3$export$8bc8bca4478fe6d7 = (markTime)=>{
    (0, $g0N0Z.issueViewOnPageLoad).mark($848ef1328a091c81$export$4d1080224e02ef0b, markTime);
};
const $3ef0a8a6a82c0ed3$export$a45a77102d75517f = ()=>{
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$434b58ebadf14df2);
    (0, $g0N0Z.issueViewLoad).mark($848ef1328a091c81$export$434b58ebadf14df2);
};
const $3ef0a8a6a82c0ed3$var$getSharedCustomData = ()=>({
        ...$3ef0a8a6a82c0ed3$var$state.getIssueScaleabilityReporter()(),
        ...(0, $aQQHY.getIssueViewFeatureFlags)(),
        ...(0, $1ybV0.ff)('ken-100-add-all-featureflags-to-issue-view-performance-events_kmez7') ? {
            featureFlags: Object.fromEntries((0, $3WQZN.allFeatureFlagsAccessed))
        } : {},
        ...(0, $9OxOE.getBackendBlockingTime)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issueViewLoad: (0, $g0N0Z.issueViewLoad)
        }),
        isBentoRecentIssue: $3ef0a8a6a82c0ed3$var$state.getIsRecentIssue(),
        bentoRecentIssuesCount: $3ef0a8a6a82c0ed3$var$state.getRecentIssuesCount(),
        correlationId: $3ef0a8a6a82c0ed3$var$state.getCorrelationId()
    });
const $3ef0a8a6a82c0ed3$export$e57956c4b76a36f = ({ lastTransitionTime: // TODO JIV-14563 Fixup or remove embeddedIssueTTI in BM3 metrics due to broken lastTransitionStartTime
// @ts-expect-error - this has never been wired up correctly, I only just discovered it by adding types for the data that is actually passed through.
lastTransitionTime })=>{
    const isFullIssue = $3ef0a8a6a82c0ed3$var$state.getIsFullIssue();
    $3ef0a8a6a82c0ed3$var$state.setInteractiveEnd(performance.now());
    if ($3ef0a8a6a82c0ed3$var$state) {
        const startTime = lastTransitionTime || $3ef0a8a6a82c0ed3$var$state.getStartTime();
        if ($3ef0a8a6a82c0ed3$var$state.getIsFullIssue()) (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
        const perfConfig = {
            stopTime: $3ef0a8a6a82c0ed3$var$state.getInteractiveEnd(),
            customData: {
                ...$3ef0a8a6a82c0ed3$var$getSharedCustomData(),
                ...!isFullIssue ? {
                    embeddedIssueFMP: Math.floor($3ef0a8a6a82c0ed3$var$state.getFMP()),
                    embeddedIssueTTI: Math.floor($3ef0a8a6a82c0ed3$var$state.getInteractiveEnd() - startTime),
                    analyticsSource: $3ef0a8a6a82c0ed3$var$state.getAnalyticsSource()
                } : {}
            }
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $1QVWH.addUFOCustomData)(perfConfig.customData);
        const ufoMetricKey = isFullIssue ? 'issue-view' : 'issue-embed';
        (0, $fVaJL.addApdexToAll)({
            key: ufoMetricKey,
            startTime: isFullIssue ? undefined : (0, $g0N0Z.embeddedIssueViewLoad).getData()?.start ?? undefined,
            stopTime: perfConfig.stopTime
        });
        if (isFullIssue) (0, $j2Yjr.addBM3TimingsToUFO)((0, $g0N0Z.issueViewLoad).getData()?.marks, (0, $g0N0Z.issueViewLoad).getData()?.config.timings);
        if (isFullIssue && (0, $8Bhia.isBM3EmitOnRafTopExperiencesEnabled)()) (0, $lMwBY.afterPaintEmit)(()=>{
            // @ts-expect-error payload type mismatch with optional values
            (0, $g0N0Z.issueViewLoad).stop(perfConfig);
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $g0N0Z.issueViewLoad));
        else // @ts-expect-error payload type mismatch with optional values
        (0, $g0N0Z.issueViewLoad).stop(perfConfig);
        (0, $iTvzN.markUimTtiIssueViewLoaded)();
        if (!isFullIssue) // See markStartIssue for more information.
        {
            if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
        }
    }
};
const $3ef0a8a6a82c0ed3$var$getBrowserNavigationMetrics = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0 || !(entries[0] instanceof PerformanceNavigationTiming)) return null;
    const navigation = entries[0];
    return {
        connectEnd: Math.round(navigation.connectEnd),
        connectStart: Math.round(navigation.connectStart),
        domComplete: Math.round(navigation.domComplete),
        domContentLoadedEventEnd: Math.round(navigation.domContentLoadedEventEnd),
        domContentLoadedEventStart: Math.round(navigation.domContentLoadedEventStart),
        domInteractive: Math.round(navigation.domInteractive),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        fetchStart: Math.round(navigation.fetchStart),
        loadEventStart: Math.round(navigation.loadEventStart),
        requestStart: Math.round(navigation.requestStart),
        responseEnd: Math.round(navigation.responseEnd),
        responseStart: Math.round(navigation.responseStart),
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        redirectCount: navigation.redirectCount,
        type: navigation.type
    };
};
const $3ef0a8a6a82c0ed3$export$c30d9392d27ab5a8 = ()=>{
    const isFullIssue = $3ef0a8a6a82c0ed3$var$state.getIsFullIssue();
    if (!isFullIssue) return;
    if ($3ef0a8a6a82c0ed3$var$state) {
        try {
            new PerformanceObserver((entryList)=>{
                entryList.getEntries().forEach((entry)=>$3ef0a8a6a82c0ed3$export$8bc8bca4478fe6d7(entry.startTime));
            }).observe({
                type: 'largest-contentful-paint',
                buffered: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
        // do nothing
        }
        const customData = {
            ...$3ef0a8a6a82c0ed3$var$getSharedCustomData(),
            browserNavigationMetrics: $3ef0a8a6a82c0ed3$var$getBrowserNavigationMetrics()
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $g0N0Z.issueViewOnPageLoad).stop(customData);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $1QVWH.addUFOCustomData)(customData);
    }
};
const $3ef0a8a6a82c0ed3$export$71cdf78946f275c = (isFullPage = false)=>{
    if (!isFullPage) {
        (0, $g0N0Z.embeddedIssueViewLoad).start({
            startTime: performance.now()
        });
        /**
		 * All SPA full page loads already start the event delay through the
		 * usePageLoadedSubscriber hook in @atlassian/jira-event-delay-controller.
		 * The embedded views need to start this critical section explicitly here because
		 * there is no equivalent hook that is generically applicable to all experiences.
		 *
		 * The only events that currently leverage the delay mechanism are the automatic
		 * exposure events, so we can avoid the overhead of starting this critical section
		 * if it won't be necessary.
		 */ if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.startLowPriorityEventDelay)();
    }
    if (isFullPage) (0, $g0N0Z.issueViewOnPageLoad).start({
        startTime: 0
    });
    (0, $g0N0Z.issueViewLoad).start();
    (0, $iTvzN.startUimTti)();
};
const $3ef0a8a6a82c0ed3$export$7f5545008a1e5a18 = ({ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime })=>{
    const ssrMark = $3ef0a8a6a82c0ed3$var$getSsrMark();
    const previewTime = performance.now();
    const startTime = $3ef0a8a6a82c0ed3$var$state.getStartTime();
    let fmp = 0;
    if ($3ef0a8a6a82c0ed3$var$state.getIsFullIssue()) {
        if (isInitialRender) // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
        fmp = ssrMark;
        else fmp = previewTime - (lastTransitionStartTime || startTime);
    } else fmp = previewTime - startTime;
    (0, $g0N0Z.issueViewLoad).mark($848ef1328a091c81$export$62c04f0e896827e3);
    (0, $g0N0Z.issueViewOnPageLoad).mark($848ef1328a091c81$export$62c04f0e896827e3);
    $3ef0a8a6a82c0ed3$var$state.setFMP(fmp);
    $3ef0a8a6a82c0ed3$var$state.setPreviewEnd(previewTime);
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$62c04f0e896827e3);
};
const $3ef0a8a6a82c0ed3$export$eedeaa0a5b3bd3d1 = (isInitialRender)=>{
    if ($3ef0a8a6a82c0ed3$var$state) $3ef0a8a6a82c0ed3$var$state.setIsLoadedWithPage(isInitialRender);
};
const $3ef0a8a6a82c0ed3$export$db2ef91f6ace96c7 = ()=>$3ef0a8a6a82c0ed3$var$state && $3ef0a8a6a82c0ed3$var$state.getIsFullIssue();

});
parcelRegister("RvFPW", function(module, exports) {

$parcel$export(module.exports, "clearFetchIssueNetworkTimes", () => $65ddff06319f9633$export$8d777cefeb6b914e);
$parcel$export(module.exports, "getFetchIssueNetworkTimes", () => $65ddff06319f9633$export$48cecd0d00931806);

var $8uNQc = parcelRequire("8uNQc");
var $8ITzY = parcelRequire("8ITzY");

var $cUHte = parcelRequire("cUHte");
const $65ddff06319f9633$var$fetchIssueNetworkMarks = [
    (0, $cUHte.fetchUploadPerf),
    (0, $cUHte.fetchCommentsPerf),
    (0, $cUHte.fetchIssuePropertiesPerf),
    (0, $cUHte.fetchIssueLinkPerf),
    (0, $cUHte.fetchViewContextPerf),
    (0, $cUHte.fetchSubtaskTypesPerf),
    (0, $cUHte.fetchFieldDataPerf),
    (0, $cUHte.fetchUserAuthPerf)
];
// Data remains the same once called once (for the same issue), so we cache it
// here for future requests for this data due to the calculation wiping the
//  performance marks required to calculate.  It does however need to be reset
// in cases like subtask click throughs when we load a new issue.
let $65ddff06319f9633$var$fetchIssueNetworkTimes;
const $65ddff06319f9633$var$calculateFetchIssueNetworkTimes = ()=>{
    const issueNetworkTimes = $65ddff06319f9633$var$fetchIssueNetworkMarks.reduce((obj, perf)=>{
        const beginMarkName = `BEGIN_${perf.prefix}_${perf.key}`;
        const endMarkName = `END_${perf.prefix}_${perf.key}`;
        const networkTime = (0, $8ITzY.timeBetweenMarks)(beginMarkName, endMarkName);
        if (networkTime != null && networkTime > 0) {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            const aggregated = {
                ...obj,
                [`${perf.key}_NETWORK`]: networkTime
            };
            // This is vital to clear mark after use.  Or next call will failed to add the mark of same name.
            if ((0, $8uNQc.default).clearMarks) {
                (0, $8uNQc.default).clearMarks(beginMarkName);
                (0, $8uNQc.default).clearMarks(endMarkName);
            }
            return aggregated;
        }
        return obj;
    }, {});
    return issueNetworkTimes;
};
const $65ddff06319f9633$export$8d777cefeb6b914e = ()=>{
    $65ddff06319f9633$var$fetchIssueNetworkMarks.forEach((perf)=>{
        const beginMarkName = `BEGIN_${perf.prefix}_${perf.key}`;
        const endMarkName = `END_${perf.prefix}_${perf.key}`;
        if ((0, $8uNQc.default).clearMarks) {
            (0, $8uNQc.default).clearMarks(beginMarkName);
            (0, $8uNQc.default).clearMarks(endMarkName);
        }
    });
    $65ddff06319f9633$var$fetchIssueNetworkTimes = null;
    window.ISSUE_DATA_AVAILABLE = null;
};
const $65ddff06319f9633$export$48cecd0d00931806 = ()=>{
    if (!$65ddff06319f9633$var$fetchIssueNetworkTimes) $65ddff06319f9633$var$fetchIssueNetworkTimes = $65ddff06319f9633$var$calculateFetchIssueNetworkTimes();
    return $65ddff06319f9633$var$fetchIssueNetworkTimes;
};

});

parcelRegister("8Bhia", function(module, exports) {

$parcel$export(module.exports, "isAllPerfFeatureFlagsEnabled", () => $706d7ea06981f598$export$a9f38f9f0d6f10af);
$parcel$export(module.exports, "isEcosystemRHSAppsSLOEventsEnabled", () => $706d7ea06981f598$export$7f9b8abba870f429);
$parcel$export(module.exports, "isChildIssuePanelConfigurationEnabled", () => $706d7ea06981f598$export$b5be9eaa7fce369);
$parcel$export(module.exports, "isIssueViewCommentRender", () => $706d7ea06981f598$export$9e18785497c1673b);
$parcel$export(module.exports, "isIssueViewCommentFetch", () => $706d7ea06981f598$export$35c0c8db33387f4d);
$parcel$export(module.exports, "isEcosystemLeftPanel", () => $706d7ea06981f598$export$6e4f76cd76a804da);
$parcel$export(module.exports, "isDataClassificationEnabled", () => $706d7ea06981f598$export$c8aa8a13c42858dd);
$parcel$export(module.exports, "isModernGlobalIssueCreateTriggerLinkedIssueEnabled", () => $706d7ea06981f598$export$3041d162b6562717);
$parcel$export(module.exports, "isIssueFetchEpicPrefetchedAGGQueryLoggingEnabled", () => $706d7ea06981f598$export$7af43b56ceb4b148);
$parcel$export(module.exports, "isIssueViewActivityFeedUIFixesEnabled", () => $706d7ea06981f598$export$11c3bd37c4149e8a);
$parcel$export(module.exports, "isRelayCascadingSelectFieldIssueViewIntegrationEnabled", () => $706d7ea06981f598$export$91d9e9331bcb489f);
$parcel$export(module.exports, "isIssueViewMigratedStreamEnabled", () => $706d7ea06981f598$export$4bef98bf98ff2cb);
$parcel$export(module.exports, "isGiraAGGConsistencyCheckEnabled", () => $706d7ea06981f598$export$3c97eb4b6ff2fec1);
$parcel$export(module.exports, "isJiraIssueViewEditorAIEnabled", () => $706d7ea06981f598$export$183bff9fcee964a2);
$parcel$export(module.exports, "isIssueViewAdminGlobalOptInAiEnabled", () => $706d7ea06981f598$export$a42a9ff4a537eac1);
$parcel$export(module.exports, "isJiraIntelligentIssueBreakdownEnabled", () => $706d7ea06981f598$export$bb7bcfe9ba7992e5);
$parcel$export(module.exports, "isJiraSmartSummaryPlatformEnabled", () => $706d7ea06981f598$export$be02cc41570f884f);
$parcel$export(module.exports, "isJiraAIWorkBreakdownOnboardingEnabled", () => $706d7ea06981f598$export$25f1a380ac523ab1);
$parcel$export(module.exports, "isJiraAIFooterDisclaimerUpdateEnabled", () => $706d7ea06981f598$export$34d9ef88b4191110);
$parcel$export(module.exports, "isIssueTypeSelectHierarchyFixEnabled", () => $706d7ea06981f598$export$b9ecdb2af6d8a25);
$parcel$export(module.exports, "isShardAndRegionToSLOAnalyticsEnabled", () => $706d7ea06981f598$export$a1b2fc5741a7de01);
$parcel$export(module.exports, "isFeatureFlagsToSLOAnalyticsEnabled", () => $706d7ea06981f598$export$b1c6c927b1de3746);
$parcel$export(module.exports, "isJiraAiWorkBreakdownDisclaimerUpdateEnabled", () => $706d7ea06981f598$export$3694fdeb5d384181);
$parcel$export(module.exports, "isA11yForIssueKeyStrikethroughEnabled", () => $706d7ea06981f598$export$4166161ebaa7c45b);
$parcel$export(module.exports, "isIssueViewRemoveConnectOperationsFromCriticalFetchEnabled", () => $706d7ea06981f598$export$c3e066f7be7868e8);
$parcel$export(module.exports, "isMediaInlineEnabled", () => $706d7ea06981f598$export$a3e5d5dfe1ed90ed);
$parcel$export(module.exports, "isTeamsCustomFieldTypeEnabled", () => $706d7ea06981f598$export$d7d142f5ac020394);
$parcel$export(module.exports, "isInviteFromAssignEnabled", () => $706d7ea06981f598$export$cdd5c612352d7bf0);
$parcel$export(module.exports, "getInviteFromAssignModalCohort", () => $706d7ea06981f598$export$5b9220081498abd7);
$parcel$export(module.exports, "isInviteFromAssignModalFeEnabled", () => $706d7ea06981f598$export$89f18660d3a3bb78);
$parcel$export(module.exports, "isFedRampCheckEnabled", () => $706d7ea06981f598$export$dd98acc8d28f3c1e);
$parcel$export(module.exports, "isStoryPointAnalyticsEnabled", () => $706d7ea06981f598$export$f0ece2538dd9e423);
$parcel$export(module.exports, "isTrelloCardIntegrationPatch", () => $706d7ea06981f598$export$ca7c31f03d6e8f02);
$parcel$export(module.exports, "isNewEditorAiFeedbackCollectorEnabled", () => $706d7ea06981f598$export$2ed16947150cc8c);
$parcel$export(module.exports, "isIssueCommentsHardLimitsFlagEnabled", () => $706d7ea06981f598$export$dcc4742bc52ec465);
$parcel$export(module.exports, "isIssueWorklogsHardLimitsFlagEnabled", () => $706d7ea06981f598$export$fa2b2d3091ee4acb);
$parcel$export(module.exports, "isIssueConfluenceLinksHardLimitsFlagEnabled", () => $706d7ea06981f598$export$8138f2ec6e2b730c);
$parcel$export(module.exports, "isNotifyAdminModalHardLimitsEnabled", () => $706d7ea06981f598$export$b014ef5adbdaef11);
$parcel$export(module.exports, "isSmartSummariesNewDisclaimerEnabled", () => $706d7ea06981f598$export$d6f2a732166d94ed);
$parcel$export(module.exports, "isNavigationBlockAIWorkBreakdownEnabled", () => $706d7ea06981f598$export$750399b1f64b9999);
$parcel$export(module.exports, "issueDetailsHardLimitsMilestone1Enabled", () => $706d7ea06981f598$export$d0ed2d8440fb5bbc);
$parcel$export(module.exports, "issueDetailsHardLimitsIssueRemoteLinkEnabled", () => $706d7ea06981f598$export$41470180bace44ba);
$parcel$export(module.exports, "issueDetailsHardLimitsIssueAttachmentsEnabled", () => $706d7ea06981f598$export$9a5cf06e051f6deb);
$parcel$export(module.exports, "issueDetailsHardLimitsIssueWeblinksEnabled", () => $706d7ea06981f598$export$e3bcb7ed6340e909);
$parcel$export(module.exports, "isIssueDetailsConnectIframeAnalyticsEnabled", () => $706d7ea06981f598$export$f8fd4a9894f78b39);
$parcel$export(module.exports, "isChangeboardingForParentEnabled", () => $706d7ea06981f598$export$a0e01c32249a7097);
$parcel$export(module.exports, "isOptimisticWeblinksFixEnabled", () => $706d7ea06981f598$export$dbaa92a1f690c8fe);
$parcel$export(module.exports, "isFetchingDataWithRetries", () => $706d7ea06981f598$export$9173cd015e7cd827);
$parcel$export(module.exports, "getPerformanceTrackingConfiguration", () => $706d7ea06981f598$export$78dd97cfaffb6fb1);
$parcel$export(module.exports, "getValidTransactionsTrackingConfiguration", () => $706d7ea06981f598$export$a801da94b6dd586b);
$parcel$export(module.exports, "isEditorUFOEnabled", () => $706d7ea06981f598$export$fd99e03c299972d3);
$parcel$export(module.exports, "getTTRSeverityTrackingConfiguration", () => $706d7ea06981f598$export$6fb6e5d98b15585b);
$parcel$export(module.exports, "getUnsupportedContentLevelsTrackingConfiguration", () => $706d7ea06981f598$export$eccecfefbd48225b);
$parcel$export(module.exports, "isSpecBasedValidatorEnabled", () => $706d7ea06981f598$export$ef24e9eecc594777);
$parcel$export(module.exports, "isJiraXSRFTokenMigrationEnabled", () => $706d7ea06981f598$export$1d7c6e59897ba9bd);
$parcel$export(module.exports, "isConfluenceRecentlyViewedOnStargate", () => $706d7ea06981f598$export$4de795e680cd02b6);
$parcel$export(module.exports, "isModernGlobalIssueCreateTriggerEnabled", () => $706d7ea06981f598$export$67305b99ef59566c);
$parcel$export(module.exports, "isCreateLinkedIssueTriggerPointEnabled", () => $706d7ea06981f598$export$fa44fb942e45b85d);
$parcel$export(module.exports, "isModernGlobalSubtaskIssueCreateTriggerEnabled", () => $706d7ea06981f598$export$9ba0da55e7f403e1);
$parcel$export(module.exports, "isModernGICEnabledForSubtask", () => $706d7ea06981f598$export$dbaf42ba39b66293);
$parcel$export(module.exports, "isProformaHarmonisationFFEnabled", () => $706d7ea06981f598$export$5dc774c58824d858);
$parcel$export(module.exports, "isHideEpicLinkFromIssueViewForEpicRenamingBetaEnabled", () => $706d7ea06981f598$export$73957227bab0d3f7);
$parcel$export(module.exports, "isDisableEpicLinkAndParentLinkFieldsEnabled", () => $706d7ea06981f598$export$dd5401dbc8bdbdfb);
$parcel$export(module.exports, "isRequestIsDoneWhenRequestingParentCandidatesEnabled", () => $706d7ea06981f598$export$c197f8974183a4f0);
$parcel$export(module.exports, "isRemoveParentLinkFromIssueViewEnabled", () => $706d7ea06981f598$export$6e06c78fd874f07f);
$parcel$export(module.exports, "isParentInIssueViewEnabled", () => $706d7ea06981f598$export$9c7fa56ed1fa2e15);
$parcel$export(module.exports, "isParentCandidatesWithInfoEndpointsEnabled", () => $706d7ea06981f598$export$a61a8bf51a079b0b);
$parcel$export(module.exports, "isSwitcherooRealtimeExposuresTestFlagEnabled", () => $706d7ea06981f598$export$a73c9c09ec24e5e9);
$parcel$export(module.exports, "isOutsiderCommentFFEnabled", () => $706d7ea06981f598$export$9b34ffa85a930ecd);
$parcel$export(module.exports, "isPlaceHolderTemplateE2EEnabled", () => $706d7ea06981f598$export$4df93ecfbfdca877);
$parcel$export(module.exports, "isCompalIssueActionsEnabled", () => $706d7ea06981f598$export$641196cc6a6481ea);
$parcel$export(module.exports, "isCompalIssueActionsFollowUpImprovementsEnabled", () => $706d7ea06981f598$export$7c0bd221ecbf9b57);
$parcel$export(module.exports, "isCompalIssueActionsVeryHighPriorityEnabled", () => $706d7ea06981f598$export$d5d401f0a31e62ea);
$parcel$export(module.exports, "isSelectableFieldEditViewIntegrationEnabled", () => $706d7ea06981f598$export$e253ac70cea0d36b);
$parcel$export(module.exports, "isFixIssueViewHotKeysAreLeakingToIssueCreate", () => $706d7ea06981f598$export$61d4e9ef0fef0224);
$parcel$export(module.exports, "isIwbSubscriptionTimeoutEnabled", () => $706d7ea06981f598$export$4a85497d19ac1931);
$parcel$export(module.exports, "isRemoveIssueAttachmentPanelViewedEventEnabled", () => $706d7ea06981f598$export$ecfec49bad872d16);
$parcel$export(module.exports, "isUFOFlagInSLOEventEnabled", () => $706d7ea06981f598$export$e1e64981aa865a03);
$parcel$export(module.exports, "isJiraSmartSummaryOnboardingEnabled", () => $706d7ea06981f598$export$5194de77e8750c41);
$parcel$export(module.exports, "isJiraSmartSummaryAIMateEndpointEnabled", () => $706d7ea06981f598$export$3cfaae79d46ba7ee);
$parcel$export(module.exports, "isDefinitionCheckConfluenceAccessEnabled", () => $706d7ea06981f598$export$edfcfe610bd14d1);
$parcel$export(module.exports, "IsAIWorkBreakdownNewUiEnabled", () => $706d7ea06981f598$export$34d90e61db572fb4);
$parcel$export(module.exports, "isStatusInGicEnabled", () => $706d7ea06981f598$export$30cd538422d6ae26);
$parcel$export(module.exports, "isJsmSmartRequestSummaryEnabled", () => $706d7ea06981f598$export$7e4aef4ae0b914e2);
$parcel$export(module.exports, "isAltTextOnImagesEnabled", () => $706d7ea06981f598$export$9591540fa082da5a);
$parcel$export(module.exports, "useM4LayoutDataInBentoConsistencyCheckValue", () => $706d7ea06981f598$export$df603fd34aea93ca);
$parcel$export(module.exports, "ISSUE_DETAILS_SORTING_PINNED_FIELDS", () => $706d7ea06981f598$export$e6ec1a9a62cbf071);
$parcel$export(module.exports, "isSortingPinnedFieldsEnabled", () => $706d7ea06981f598$export$cce5c39a2a1dacf1);
$parcel$export(module.exports, "getEnableFlexibleBlockCardInIssueEditor", () => $706d7ea06981f598$export$408491224a0c915b);
$parcel$export(module.exports, "isTeamFieldInSubtasksEnabled", () => $706d7ea06981f598$export$150e448c819201a7);
$parcel$export(module.exports, "isOfferingCatalogueFeaturesEnabled", () => $706d7ea06981f598$export$369fa0ed6b2504fb);
$parcel$export(module.exports, "isRendererTtiTrackingEnabled", () => $706d7ea06981f598$export$b236d4b6aec7c4c3);
$parcel$export(module.exports, "isPriorityFieldTooltipEnabled", () => $706d7ea06981f598$export$a792a3f88a852f06);
$parcel$export(module.exports, "isJsmTimelineEnabled", () => $706d7ea06981f598$export$575e1bf822db15b5);
$parcel$export(module.exports, "isCannedResponseFFEnabled", () => $706d7ea06981f598$export$9f71233b08c04922);
$parcel$export(module.exports, "isSignatureCrFFEnabled", () => $706d7ea06981f598$export$8521761ebcf26351);
$parcel$export(module.exports, "isRespondersFieldAvailableInAllProjectsEnabled", () => $706d7ea06981f598$export$6f0be57bd65ee8bc);
$parcel$export(module.exports, "isEcClientEnabled", () => $706d7ea06981f598$export$e3bafd4acea73c60);
$parcel$export(module.exports, "isOverrideCreationDateEnabled", () => $706d7ea06981f598$export$dda3a2d16a2e0a31);
$parcel$export(module.exports, "isDeleteissueViewMetricsEnabled", () => $706d7ea06981f598$export$fad47591ae56c23f);
$parcel$export(module.exports, "is4xxRequestsIgnoreEnabled", () => $706d7ea06981f598$export$6d1f8ae8cf9bbc71);
$parcel$export(module.exports, "isMiddleClickFixEnabled", () => $706d7ea06981f598$export$7dbe34739b0d70b8);
$parcel$export(module.exports, "isLogForMissingProjectTypeEnabled", () => $706d7ea06981f598$export$3fa1b10a7b484874);
$parcel$export(module.exports, "isGiraAGGIsArchivedEnabled", () => $706d7ea06981f598$export$6604067817758030);
$parcel$export(module.exports, "isArchivedIssuesPageLinkEnabled", () => $706d7ea06981f598$export$c108c03095e0e655);
$parcel$export(module.exports, "isBM3EmitOnRafTopExperiencesEnabled", () => $706d7ea06981f598$export$ee410f0ba32dc900);
$parcel$export(module.exports, "isCustomMessageForLinkingWithoutPermissionsEnabled", () => $706d7ea06981f598$export$3068bf83bd6f9396);
$parcel$export(module.exports, "isSearchByEmailInMultiselectUserPickerEnabled", () => $706d7ea06981f598$export$da019fa3d31e5c7e);
$parcel$export(module.exports, "isRelayReleaseVersionFieldIssueViewIntegrationEnabled", () => $706d7ea06981f598$export$48d407f97269c8fa);
$parcel$export(module.exports, "isAsyncFieldOptionsTechDebtEnabled", () => $706d7ea06981f598$export$8a90e3b075447800);
$parcel$export(module.exports, "isJsmFixIncompatibleRequestTypeInconsistenciesEnabled", () => $706d7ea06981f598$export$733566d04cfe61b1);
$parcel$export(module.exports, "PlaceHolderTemplateFlags", () => $706d7ea06981f598$export$bf10032e4a734a65);
$parcel$export(module.exports, "getPlaceHolderTemplateVariant", () => $706d7ea06981f598$export$fb512d5beec30a90);
$parcel$export(module.exports, "isConfluencePageDummyLinkExperiment", () => $706d7ea06981f598$export$6e7dfb06c9e45ae7);
$parcel$export(module.exports, "isConfluencePageDummyLinkEnabled", () => $706d7ea06981f598$export$ef28379ba310de6e);
$parcel$export(module.exports, "isStopLoadingFieldConfigTwiceEnabled", () => $706d7ea06981f598$export$98dcb5ffd7beaf00);
$parcel$export(module.exports, "isNonCriticalGiraQueryExperienceTrackingEnabled", () => $706d7ea06981f598$export$8ea052ed520b62bc);
$parcel$export(module.exports, "isSHA256EnabledForMediaConfig", () => $706d7ea06981f598$export$a88e7ad1ce082e7d);
$parcel$export(module.exports, "isFilterIssueChangedEvents", () => $706d7ea06981f598$export$d616286874a25f83);
$parcel$export(module.exports, "isJiraForgeExtensionChangesForAegisEnabled", () => $706d7ea06981f598$export$496e94e3da873a49);
$parcel$export(module.exports, "isDisableUnneededForgeMetricsEnabled", () => $706d7ea06981f598$export$cd0e0ab900757d23);
$parcel$export(module.exports, "isAnotherExtensionContextForForgeBackgroundScriptsEnabled", () => $706d7ea06981f598$export$ea998c148f057985);
$parcel$export(module.exports, "isCompassComponentsEnabled", () => $706d7ea06981f598$export$33008660eb5353ef);
$parcel$export(module.exports, "isConferenceCallFieldHidden", () => $706d7ea06981f598$export$176e4d6701700463);
$parcel$export(module.exports, "isIssueLinkLimitEnabled", () => $706d7ea06981f598$export$c567845e4f18ee11);
$parcel$export(module.exports, "isCreateConfluencePagesEnabled", () => $706d7ea06981f598$export$2b839c758c080224);
$parcel$export(module.exports, "isOptimiseEditorOnchangeCallsEnabled", () => $706d7ea06981f598$export$7411486b04537f62);
$parcel$export(module.exports, "isMentionsAnalyticsEnabled", () => $706d7ea06981f598$export$281da19089438270);
$parcel$export(module.exports, "isNewLinkPickerEnabled", () => $706d7ea06981f598$export$ae2025957f2940e4);
$parcel$export(module.exports, "isLinkCreateExtensionEnabled", () => $706d7ea06981f598$export$1b84fec141e29939);
$parcel$export(module.exports, "isTraceIdForRelayErrorsEnabled", () => $706d7ea06981f598$export$d83d25e87b40c475);
$parcel$export(module.exports, "getJiraIssuesDatasourceEnabled", () => $706d7ea06981f598$export$1c607d9b866655e1);
$parcel$export(module.exports, "shouldUseNewEditorCardProvider", () => $706d7ea06981f598$export$8c74256e92f57afb);
$parcel$export(module.exports, "isIssueViewFitAndFinishEnabled", () => $706d7ea06981f598$export$e4799b5b27449650);
$parcel$export(module.exports, "isMentionsIndicatorEnabled", () => $706d7ea06981f598$export$5cb6179ec1a74a5a);
$parcel$export(module.exports, "isDevOpsAppRecommenderEnabled", () => $706d7ea06981f598$export$882e8ff421f7744c);
$parcel$export(module.exports, "isIssueViewRemoveEcosystemBackgroundScriptsFromTTIEnabled", () => $706d7ea06981f598$export$c3737cff1b9064df);
$parcel$export(module.exports, "isIssueDescriptionReadingAidEnabled", () => $706d7ea06981f598$export$f16a46bb33ebb09c);
$parcel$export(module.exports, "isIssueDescriptionAcronymsHighlightEnabled", () => $706d7ea06981f598$export$7071b16bdeedd7e0);
$parcel$export(module.exports, "isIssueViewUnlinkGlancesFieldFromUi", () => $706d7ea06981f598$export$709da340f602ae6e);
$parcel$export(module.exports, "isIssueViewRemoveGlancesFieldFromQuery", () => $706d7ea06981f598$export$8db987307934d214);
$parcel$export(module.exports, "isIssueViewImplementDeadGlancesFieldQuery", () => $706d7ea06981f598$export$694fa8b8c523f4cc);
$parcel$export(module.exports, "isAggMigrationAttachmentsEnabled", () => $706d7ea06981f598$export$5a53bba8e442c4f9);
$parcel$export(module.exports, "isA11yFixMissingIssueViewLableEnabled", () => $706d7ea06981f598$export$e91c29ee5b520dd2);
$parcel$export(module.exports, "isA11yFixMissingBreadcrumbLableEnabled", () => $706d7ea06981f598$export$704bed27f6f61d03);
$parcel$export(module.exports, "isIssueViewWhiteboardsStandaloneEnabled", () => $706d7ea06981f598$export$6f64fb042a8db7d9);
$parcel$export(module.exports, "isDynamicEditButtonLabelEnabled", () => $706d7ea06981f598$export$27d85e4af83ec7f9);
$parcel$export(module.exports, "isInlineEditLiteApiChangesEnabled", () => $706d7ea06981f598$export$c44cfb78376198a8);
$parcel$export(module.exports, "isPriorityInlineEditingEnabled", () => $706d7ea06981f598$export$40382276d1d4088d);
$parcel$export(module.exports, "isNinColumnResizingEnabled", () => $706d7ea06981f598$export$1f76c12fbdafb975);
$parcel$export(module.exports, "isEmbeddedConfluenceIssueViewCrossJoinEnabled", () => $706d7ea06981f598$export$667dd70f296d7a79);
$parcel$export(module.exports, "isEmbeddedConfluenceIssueLinkedPageCrossJoinEnabled", () => $706d7ea06981f598$export$8d9e5c2fc560d7fb);
$parcel$export(module.exports, "isEmbeddedConfluenceIssueViewDeferSpaceSelectionEnabled", () => $706d7ea06981f598$export$712b6916406c5e2a);
$parcel$export(module.exports, "isWorkflowDataServiceHookEnabled", () => $706d7ea06981f598$export$60184d6d974595a9);
$parcel$export(module.exports, "isIssueViewRemoveEcosystemActivityPanelsFromTTIEnabled", () => $706d7ea06981f598$export$b7098c14b9be61bc);
$parcel$export(module.exports, "ISSUE_VIEW_CHILD_PANEL_STANDARDIZATION", () => $706d7ea06981f598$export$2b5abc219e47210a);
$parcel$export(module.exports, "isListViewChildIssuePanelStandardizationEnabled", () => $706d7ea06981f598$export$43153f9815dd9925);
$parcel$export(module.exports, "isGoalsFieldEnabledInIssueView", () => $706d7ea06981f598$export$602a082cd6009b66);
$parcel$export(module.exports, "isCascadingSelectEditViewChangesEnabled", () => $706d7ea06981f598$export$6397044ce736d61c);
$parcel$export(module.exports, "isTokensAndStyledComponentsMigrationEnabled", () => $706d7ea06981f598$export$590b056868f89976);
$parcel$export(module.exports, "isIssueArchivalFeatureEnabled", () => $706d7ea06981f598$export$f67982569b9aab31);
$parcel$export(module.exports, "isIssueDateFieldSavedOnChange", () => $706d7ea06981f598$export$694f7148d449e12);
$parcel$export(module.exports, "isProductsAndEntitlementsMilestone2Enabled", () => $706d7ea06981f598$export$9d25c3a3874f1891);
$parcel$export(module.exports, "isSentimentFieldEnabled", () => $706d7ea06981f598$export$cd66b30e1a3ad3b0);
$parcel$export(module.exports, "isIssueExportControlEnabled", () => $706d7ea06981f598$export$e92cc7310d059d3e);
$parcel$export(module.exports, "isIssueViewClassificationLevelEditabilityEnabled", () => $706d7ea06981f598$export$ab71258032925094);
$parcel$export(module.exports, "isDeleteLinkedIssueSLOEnabled", () => $706d7ea06981f598$export$2923d3b89bbda235);
$parcel$export(module.exports, "isDeleteIssueSLOEnabled", () => $706d7ea06981f598$export$2a8d8394ee2d63);
$parcel$export(module.exports, "isFixForJracloud82752Enabled", () => $706d7ea06981f598$export$a4c7fa43d0cf493);
$parcel$export(module.exports, "isCompalParentStatusCategoryIdEnabled", () => $706d7ea06981f598$export$8d6eb687c2a90c8c);
$parcel$export(module.exports, "isJSMRestrictInternalCommentVisibilityEnabled", () => $706d7ea06981f598$export$5dbdd9e44df66fdb);
$parcel$export(module.exports, "isIssueViewFitAndFinishM2Enabled", () => $706d7ea06981f598$export$61a4e4e1a79114de);
$parcel$export(module.exports, "aggUseIsEditableInViewFlag", () => $706d7ea06981f598$export$9e983b29015333eb);
$parcel$export(module.exports, "isLoomRecordVideoQuickButtonEnabled", () => $706d7ea06981f598$export$9542d839b69c5844);
$parcel$export(module.exports, "isLinkedPagesBugFixEnabled", () => $706d7ea06981f598$export$35cba8f6a1edcd6a);
$parcel$export(module.exports, "isUIMCascadingSelectFieldEnablead", () => $706d7ea06981f598$export$418f24ad76008d74);
$parcel$export(module.exports, "isLinkedWhiteboardBugFixEnabled", () => $706d7ea06981f598$export$be7c055598b19df);
$parcel$export(module.exports, "createIssueStatusButtonBugFixFlag", () => $706d7ea06981f598$export$493fb54a3aa25afb);
$parcel$export(module.exports, "sprintFieldLongTextFixFlag", () => $706d7ea06981f598$export$24744533e9559f1e);
$parcel$export(module.exports, "isAIUpsellPremiumTrailEnabled", () => $706d7ea06981f598$export$63beab816c3f18b1);
$parcel$export(module.exports, "isEmbeddedConfluenceCreateContentCrossFlowEnabled", () => $706d7ea06981f598$export$8fa51a766c2ece72);
$parcel$export(module.exports, "isRendererDefaultSmartLinksValueEnabled", () => $706d7ea06981f598$export$36797146406f89b2);
$parcel$export(module.exports, "isHoverCardAISummariesEnabled", () => $706d7ea06981f598$export$68300000ff0840c3);
$parcel$export(module.exports, "isIssueViewDesignsImprovedSchemaEnabled", () => $706d7ea06981f598$export$7d8f401804d751fc);
$parcel$export(module.exports, "isImprovingStaleJSMApprovalPanelEnabled", () => $706d7ea06981f598$export$b6cfe54a20ef8834);
$parcel$export(module.exports, "isAffectsVersionsFieldSupportForIVEnabled", () => $706d7ea06981f598$export$71ed36e51616c829);
$parcel$export(module.exports, "isIssueViewNudgeExperimentEnabled", () => $706d7ea06981f598$export$d9ce3c80c1cc862d);
$parcel$export(module.exports, "isApprovalsGlancePanelToCollapsibleContextGroupEnabled", () => $706d7ea06981f598$export$9e54bab54faf7459);
$parcel$export(module.exports, "isConfluenceIntegrationsAdminControlsEnabled", () => $706d7ea06981f598$export$268b11901e56613a);
$parcel$export(module.exports, "isCascadingSelectSupportForUIMEnabled", () => $706d7ea06981f598$export$4399c72174f6c25d);
$parcel$export(module.exports, "isWhiteboardStandaloneEnabled", () => $706d7ea06981f598$export$18b62f1e8801aa0f);
$parcel$export(module.exports, "isFitAndFinishFullPageMilestone2", () => $706d7ea06981f598$export$56ceecd3414268e0);
$parcel$export(module.exports, "isCrossJoinContentPreviewEnabled", () => $706d7ea06981f598$export$ce9fb45735ec88ee);
$parcel$export(module.exports, "isConfluenceContentFunctionalComponentEnabled", () => $706d7ea06981f598$export$9deda930d52d668b);
$parcel$export(module.exports, "shouldRemoveIssueTypeARI", () => $706d7ea06981f598$export$68ee3addb9261f10);
$parcel$export(module.exports, "isHandleIssueCommentsEmptyEnabled", () => $706d7ea06981f598$export$bbd89fe4e4d7eff9);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");


var $caTc0 = parcelRequire("caTc0");
const $706d7ea06981f598$export$a9f38f9f0d6f10af = ()=>(0, $1ybV0.ff)('ken-100-add-all-featureflags-to-issue-view-performance-events_kmez7');
const $706d7ea06981f598$export$7f9b8abba870f429 = ()=>(0, $1ybV0.ff)('instrumentation-of-issue-ecosystem-reliability-slo-metrics-rhs_tpmqi');
const $706d7ea06981f598$export$b5be9eaa7fce369 = ()=>(0, $1ybV0.ff)('configurable-child-issues-panel_3ht06', false);
const $706d7ea06981f598$export$9e18785497c1673b = ()=>(0, $1ybV0.ff)('issue-comment-render_tt9jk');
const $706d7ea06981f598$export$35c0c8db33387f4d = ()=>(0, $1ybV0.ff)('issue-comment-fetch_9eeal');
const $706d7ea06981f598$export$6e4f76cd76a804da = ()=>(0, $1ybV0.ff)('ecosystem_content_panel_lhs_6eptr');
const $706d7ea06981f598$export$c8aa8a13c42858dd = ()=>(0, $1ybV0.ff)('jira-issue-history-data-classification_mhyjw', false);
const $706d7ea06981f598$export$3041d162b6562717 = ()=>(0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view', false);
const $706d7ea06981f598$export$7af43b56ceb4b148 = ()=>(0, $1ybV0.ff)('issue.details.issue-fetch-epic-prefetched-agg-query-logging', false);
const $706d7ea06981f598$export$11c3bd37c4149e8a = ()=>(0, $1ybV0.ff)('jira-issue-view-activity-feed-ui-fixes', false);
const $706d7ea06981f598$export$91d9e9331bcb489f = ()=>(0, $1ybV0.ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration');
const $706d7ea06981f598$export$4bef98bf98ff2cb = ()=>(0, $1ybV0.ff)('issue.details.migration-migrated-stream', false);
const $706d7ea06981f598$export$3c97eb4b6ff2fec1 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('issue.details.gira-agg-consistency-check-master-flag', 'OLD', [
        'OLD',
        'NEW',
        'CHECK',
        'CHECK_RETURN_NEW'
    ]) === 'CHECK';
const $706d7ea06981f598$export$183bff9fcee964a2 = ()=>(0, $1ybV0.ff)('issue.details.jira-issue-view-editor-ai_sozy', false);
const $706d7ea06981f598$export$a42a9ff4a537eac1 = ()=>(0, $1ybV0.ff)('issue-view-admin-global-opt-in-ai', false);
const $706d7ea06981f598$export$bb7bcfe9ba7992e5 = ()=>(0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl', false);
const $706d7ea06981f598$export$be02cc41570f884f = ()=>(0, $1ybV0.ff)('issue.details.jira-smart-summary-platform_0jta9', false);
const $706d7ea06981f598$export$25f1a380ac523ab1 = ()=>(0, $1ybV0.ff)('jira-ai-work-breakdown-onboarding', false);
const $706d7ea06981f598$export$34d9ef88b4191110 = ()=>(0, $1ybV0.ff)('jira-ai-footer-disclaimer-update', false);
const $706d7ea06981f598$export$b9ecdb2af6d8a25 = ()=>(0, $1ybV0.ff)('issue.details.issue-type-select-hierarchy-fix', false);
const $706d7ea06981f598$export$a1b2fc5741a7de01 = ()=>(0, $1ybV0.ff)('issue.details.shard-and-region-to-slo-analytics', false);
const $706d7ea06981f598$export$b1c6c927b1de3746 = ()=>(0, $1ybV0.ff)('issue.details.feature-flags-to-slo-analytics', false);
const $706d7ea06981f598$export$3694fdeb5d384181 = ()=>(0, $1ybV0.ff)('jira-ai-work-breakdown-disclaimer-update', false);
const $706d7ea06981f598$export$4166161ebaa7c45b = ()=>(0, $1ybV0.ff)('issue-view-a11y-for-issue-key-strikethrough_3xavq', false);
const $706d7ea06981f598$export$c3e066f7be7868e8 = ()=>(0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w');
const $706d7ea06981f598$export$a3e5d5dfe1ed90ed = ()=>(0, $1ybV0.ff)('issue.details.media-inline', false);
const $706d7ea06981f598$export$d7d142f5ac020394 = ()=>(0, $1ybV0.ff)('jira.teams.enable-new-custom-field-types', false);
const $706d7ea06981f598$export$cdd5c612352d7bf0 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('invite.from.assign', (0, $1Iui1.NOT_ENROLLED), [
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.NOT_ENROLLED),
        (0, $1Iui1.VARIATION)
    ]) === (0, $1Iui1.VARIATION);
const $706d7ea06981f598$export$5b9220081498abd7 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('invite.from.assign.modal', 'not-enrolled', [
        'control',
        'not-enrolled',
        'variation'
    ]);
const $706d7ea06981f598$export$89f18660d3a3bb78 = ()=>(0, $1ybV0.ff)('invite.from.assign.modal.fe.event', false);
const $706d7ea06981f598$export$dd98acc8d28f3c1e = ()=>(0, $1ybV0.ff)('confluence.frontend.growth.fedramp-check-isolation', false);
const $706d7ea06981f598$export$f0ece2538dd9e423 = ()=>(0, $1ybV0.ff)('issue.detail.issue-view-story-point-field-type-analytics_n9ha6');
const $706d7ea06981f598$export$ca7c31f03d6e8f02 = ()=>(0, $1ybV0.ff)('trello.card.integration.patch', false);
const $706d7ea06981f598$export$2ed16947150cc8c = ()=>(0, $1ybV0.ff)('issue.details.update-jira-editor-ai-feedback-collector_qv6kk');
const $706d7ea06981f598$export$dcc4742bc52ec465 = ()=>(0, $1ybV0.ff)('comment-limit-exceed-warning-flag_3rx53', false);
const $706d7ea06981f598$export$fa2b2d3091ee4acb = ()=>(0, $1ybV0.ff)('worklog-limit-exceed-warning-flag_hh86h', false);
const $706d7ea06981f598$export$8138f2ec6e2b730c = ()=>(0, $1ybV0.ff)('confluence-link-limit-exceed-warning-flag_1ycku', false);
const $706d7ea06981f598$export$b014ef5adbdaef11 = ()=>(0, $1ybV0.ff)('hard-limits-modal-admin_wo9xn', false);
const $706d7ea06981f598$export$d6f2a732166d94ed = ()=>(0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u', false);
const $706d7ea06981f598$export$750399b1f64b9999 = ()=>(0, $1ybV0.ff)('navigation-blocker-for-ai-work-breakdown_tb7cx', false);
const $706d7ea06981f598$export$d0ed2d8440fb5bbc = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.milestone-1');
const $706d7ea06981f598$export$41470180bace44ba = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.issue-remote-link');
const $706d7ea06981f598$export$9a5cf06e051f6deb = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.issue-attachments-limit');
const $706d7ea06981f598$export$e3bcb7ed6340e909 = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.issue-weblinks-limit');
const $706d7ea06981f598$export$f8fd4a9894f78b39 = ()=>(0, $1ybV0.ff)('issue.details.connect-iframe-analytics');
const $706d7ea06981f598$export$a0e01c32249a7097 = ()=>(0, $1ybV0.ff)('parent-field-changeboarding_4ljdy', false);
const $706d7ea06981f598$export$dbaa92a1f690c8fe = ()=>(0, $1ybV0.ff)('issue.details.display-flag-on-optimistic-weblinks-error');
const $706d7ea06981f598$export$9173cd015e7cd827 = ()=>(0, $1ybV0.ff)('issue-view-fetchallappdatawithretries-timeout_ad77o');
const $706d7ea06981f598$export$78dd97cfaffb6fb1 = ()=>(0, $1ybV0.getFeatureFlagValue)('issue.details.editor.performance-tracking', {});
const $706d7ea06981f598$export$a801da94b6dd586b = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const value = (0, $1ybV0.getFeatureFlagValue)('issue.details.editor.valid-transactions-tracking', {});
    // workaround as editor is interpreting an empty object as enabled: https://product-fabric.atlassian.net/browse/ED-12432
    const enabled = typeof value === 'object' && Object.keys(value).length;
    return enabled ? value : undefined;
};
const $706d7ea06981f598$export$fd99e03c299972d3 = ()=>(0, $1ybV0.ff)('issue.details.editor.ufo', false);
const $706d7ea06981f598$export$6fb6e5d98b15585b = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $1ybV0.getFeatureFlagValue)('issue.details.renderer.ttr-severity-tracking', {});
const $706d7ea06981f598$export$eccecfefbd48225b = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $1ybV0.getFeatureFlagValue)('issue.details.renderer.unsupported-content-levels-tracking', {});
const $706d7ea06981f598$export$ef24e9eecc594777 = ()=>(0, $1ybV0.ff)('issue.details.renderer.spec-based-validator');
const $706d7ea06981f598$export$1d7c6e59897ba9bd = ()=>(0, $1ybV0.ff)('migrate-jira-xsrf-token_hfu9d', false);
const $706d7ea06981f598$export$4de795e680cd02b6 = ()=>(0, $1ybV0.ff)('jira-issue-view-confluence-recently-viewed-stargate', false);
const $706d7ea06981f598$export$67305b99ef59566c = ()=>(0, $1ybV0.ff)('project.config.pce.modern.global-issue-create.trigger', false);
const $706d7ea06981f598$export$fa44fb942e45b85d = ()=>(0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view', false);
const $706d7ea06981f598$export$9ba0da55e7f403e1 = ()=>(0, $1ybV0.ff)('project.config.pce.modern.global-subtask-issue-create-trigger', false);
const $706d7ea06981f598$export$dbaf42ba39b66293 = ()=>$706d7ea06981f598$export$67305b99ef59566c() && $706d7ea06981f598$export$9ba0da55e7f403e1();
const $706d7ea06981f598$export$5dc774c58824d858 = ()=>(0, $1ybV0.ff)('proforma-harmonisation-main_ca6ff', false);
const $706d7ea06981f598$export$73957227bab0d3f7 = ()=>(0, $1ybV0.ff)('hide-epic-link-from-issue-view-for-epic-renaming-beta_r1g77', false);
const $706d7ea06981f598$export$dd5401dbc8bdbdfb = ()=>(0, $1ybV0.ff)('disable-epic-link-and-parent-link-fields-in-issue-view-and-gic_zixrt', false);
const $706d7ea06981f598$export$c197f8974183a4f0 = ()=>(0, $1ybV0.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy', false);
const $706d7ea06981f598$export$6e06c78fd874f07f = ()=>(0, $1ybV0.ff)('remove-parent-link-from-issue-view_4t7dy', false);
const $706d7ea06981f598$export$9c7fa56ed1fa2e15 = ()=>(0, $1ybV0.ff)('parent-field-in-issue-view_x4zn4', false);
const $706d7ea06981f598$export$a61a8bf51a079b0b = ()=>(0, $1ybV0.ff)('com.atlassian.jira.customhierarchy.parent.candidates.with.info.endpoints.enabled', false);
const $706d7ea06981f598$export$a73c9c09ec24e5e9 = ()=>(0, $1ybV0.ff)('switcheroo-realtime-exposures-test-flag_648u4', false);
const $706d7ea06981f598$export$9b34ffa85a930ecd = ()=>(0, $1ybV0.ff)('display-outsider-comment-field_4x7u7', false);
const $706d7ea06981f598$export$4df93ecfbfdca877 = ()=>(0, $1ybV0.ff)('jira.issue-view.placeholder-template-e2e-iteration', false);
const $706d7ea06981f598$export$641196cc6a6481ea = ()=>(0, $1ybV0.ff)('compal-issue-actions', false);
const $706d7ea06981f598$export$7c0bd221ecbf9b57 = ()=>()=>(0, $1ybV0.ff)('compal-issue-actions-follow-up-improvements_y49xu', false);
const $706d7ea06981f598$export$d5d401f0a31e62ea = ()=>()=>(0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r', false);
const $706d7ea06981f598$export$e253ac70cea0d36b = ()=>(0, $1ybV0.ff)('issue.details.follow-up-relay-multi-select-field-issue-view-integration', false);
const $706d7ea06981f598$export$61d4e9ef0fef0224 = ()=>(0, $1ybV0.ff)('fix-issue-view-hotkeys-are-leaking-to-issue-create_38fpl');
const $706d7ea06981f598$export$4a85497d19ac1931 = ()=>(0, $1ybV0.ff)('iwb-subscription-timeout_g05rq');
const $706d7ea06981f598$export$ecfec49bad872d16 = ()=>(0, $1ybV0.ff)('remove-issueattachmentpanel-viewed-event_w282l');
const $706d7ea06981f598$export$e1e64981aa865a03 = ()=>(0, $1ybV0.ff)('issue-view.send-ufo-flags-in-slo-events_wyrfy', false);
const $706d7ea06981f598$export$5194de77e8750c41 = ()=>(0, $1ybV0.ff)('jira-issue-view-smart-summary-onboarding_jmzm7', false);
const $706d7ea06981f598$export$3cfaae79d46ba7ee = ()=>(0, $1ybV0.ff)('issue.details-smart-summary-with-ai-mate_qqug7.', false);
const $706d7ea06981f598$export$edfcfe610bd14d1 = ()=>(0, $1ybV0.ff)('issue-view-disable-definition-feature-if-the-user-doesnt-have-confluence-access_inh6g', false);
const $706d7ea06981f598$export$34d90e61db572fb4 = ()=>(0, $1ybV0.ff)('jira-ai-work-breakdown-new-ui_z0inn', false);
const $706d7ea06981f598$export$30cd538422d6ae26 = ()=>(0, $1ybV0.ff)('issue.details.gic.add_status_field', false);
const $706d7ea06981f598$export$7e4aef4ae0b914e2 = ()=>(0, $1ybV0.ff)('enable-jsm-smart-request-summary_kva1r', false);
const $706d7ea06981f598$export$9591540fa082da5a = ()=>(0, $1ybV0.ff)('editor.renderer-alt-text-on-images', false);
const $706d7ea06981f598$export$df603fd34aea93ca = ()=>(0, $1ybV0.getFeatureFlagValue)('project.config.pce.use-m4-issue-layout-data-in-bento.with-consistency-check', 'OLD');
const $706d7ea06981f598$export$e6ec1a9a62cbf071 = 'issue.details.sorting-pinned-fields';
const $706d7ea06981f598$export$cce5c39a2a1dacf1 = ()=>(0, $1ybV0.ff)('issue.details.sorting-pinned-fields', false);
const $706d7ea06981f598$export$408491224a0c915b = ()=>(0, $1ybV0.ff)('issue.details.editor.enable-flexible-block-card');
const $706d7ea06981f598$export$150e448c819201a7 = ()=>(0, $1ybV0.ff)('jira.frontend.ptc.team-field-in-subtasks', false);
const $706d7ea06981f598$export$369fa0ed6b2504fb = ()=>(0, $1ybV0.ff)('offeringcataloguefeatures-resource-layer-in-frontend_o5pnu', false);
const $706d7ea06981f598$export$b236d4b6aec7c4c3 = ()=>(0, $1ybV0.ff)('issue.details.renderer.tti-tracking', false);
const $706d7ea06981f598$export$a792a3f88a852f06 = ()=>(0, $1ybV0.ff)('sea-2830-improve-accessibility-of-priority-field-in-backlog-card_k53tq', false);
const $706d7ea06981f598$export$575e1bf822db15b5 = ()=>(0, $1ybV0.ff)('jsm-timelines-phase-2_70gja', false);
const $706d7ea06981f598$export$9f71233b08c04922 = ()=>(0, $1ybV0.ff)('jsm-canned-response', false);
const $706d7ea06981f598$export$8521761ebcf26351 = ()=>(0, $1ybV0.ff)('jsm-agent-signature-cr-enabled', false);
const $706d7ea06981f598$export$6f0be57bd65ee8bc = ()=>(0, $1ybV0.ff)('responders-field-in-all-projects-issues-ui', false);
const $706d7ea06981f598$export$e3bafd4acea73c60 = ()=>{
    const experiences = (0, $1ybV0.getFeatureFlagValue)('odin.ec.client.integration.issueview', '');
    return experiences.length > 0;
};
const $706d7ea06981f598$export$dda3a2d16a2e0a31 = ()=>(0, $1ybV0.ff)('override-date-for-attachment-timestamp-in-film-strip_ymajc');
const $706d7ea06981f598$export$fad47591ae56c23f = ()=>(0, $1ybV0.ff)('metric-for-issue-delete-inside-issue-view_baxre');
const $706d7ea06981f598$export$6d1f8ae8cf9bbc71 = ()=>(0, $1ybV0.ff)('ken-429-restrict-4xx-error_vi8v7', false);
const $706d7ea06981f598$export$7dbe34739b0d70b8 = ()=>(0, $1ybV0.ff)('ken-524-fix-middle-click-issue-for-linked-issues_x1hgl', false);
const $706d7ea06981f598$export$3fa1b10a7b484874 = ()=>(0, $1ybV0.ff)('ken-432-missing-project-key-log_hr7zv', false);
const $706d7ea06981f598$export$6604067817758030 = ()=>{
    const featureFlagValue = (0, $1ybV0.getMultivariateFeatureFlag)('issue.details.gira-agg-migration-isarchived', 'OLD', [
        'OLD',
        'NEW',
        'CHECK',
        'CHECK_RETURN_NEW'
    ]);
    return featureFlagValue === 'NEW' || featureFlagValue === 'CHECK_RETURN_NEW' || featureFlagValue === 'CHECK';
};
const $706d7ea06981f598$export$c108c03095e0e655 = ()=>(0, $1ybV0.ff)('enable-archived-issues-page-link', false);
const $706d7ea06981f598$export$ee410f0ba32dc900 = ()=>(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences', false);
const $706d7ea06981f598$export$3068bf83bd6f9396 = ()=>(0, $1ybV0.ff)('issue.details.custom-message-for-linking-with-no-permissions_k7qsn', false);
const $706d7ea06981f598$export$da019fa3d31e5c7e = ()=>(0, $1ybV0.ff)('issue-view.enable-search-by-email-in-multiselect-user-picker-field', false);
const $706d7ea06981f598$export$48d407f97269c8fa = ()=>(0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration', false);
const $706d7ea06981f598$export$8a90e3b075447800 = ()=>(0, $1ybV0.ff)('issue.details.async-field-options-tech-debt', false);
const $706d7ea06981f598$export$733566d04cfe61b1 = ()=>(0, $1ybV0.ff)('jsm-fix-invalid-request-type-inconsistencies_x7maw', false);
const $706d7ea06981f598$export$bf10032e4a734a65 = {
    CROSS_FLOW: 'jira.issue-view.placeholder-template-cross-flow'
};
const $706d7ea06981f598$export$fb512d5beec30a90 = (experiment)=>experiment ? (0, $1ybV0.getMultivariateFeatureFlag)(experiment, (0, $1Iui1.NOT_ENROLLED), [
        (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7),
        (0, $3401608855dcf8dc$export$c52ae1847ec8c2c),
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.NOT_ENROLLED)
    ]) : (0, $1Iui1.NOT_ENROLLED);
const $706d7ea06981f598$export$6e7dfb06c9e45ae7 = ()=>[
        (0, $1Iui1.CONTROL),
        (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7)
    ].includes($706d7ea06981f598$export$fb512d5beec30a90($706d7ea06981f598$export$bf10032e4a734a65.CROSS_FLOW));
const $706d7ea06981f598$export$ef28379ba310de6e = (experiment)=>$706d7ea06981f598$export$fb512d5beec30a90(experiment) === (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7);
const $706d7ea06981f598$export$98dcb5ffd7beaf00 = ()=>(0, $1ybV0.ff)('jracloud-81255-stop-loading-field-config-twice_jfdek', false);
const $706d7ea06981f598$export$8ea052ed520b62bc = ()=>(0, $1ybV0.ff)('issue.details.non-critical-gira-query-experience-tracking', false);
const $706d7ea06981f598$export$a88e7ad1ce082e7d = ()=>(0, $1ybV0.ff)('issue.details.update-media-config-to-sha256', false);
const $706d7ea06981f598$export$d616286874a25f83 = ()=>(0, $1ybV0.ff)('filter-issue-changed-connect-app-events-to-non-dialogs');
const $706d7ea06981f598$export$496e94e3da873a49 = ()=>(0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x');
const $706d7ea06981f598$export$cd0e0ab900757d23 = ()=>(0, $1ybV0.ff)('remove-invalid-forge-metrics_n3ddj');
const $706d7ea06981f598$export$ea998c148f057985 = ()=>(0, $1ybV0.ff)('change-the-way-we-get-project-context-for-forge-background-scripts_smqab');
const $706d7ea06981f598$export$33008660eb5353ef = ()=>(0, $1ybV0.ff)('compass-components-in-jira-components_xw42u', false);
const $706d7ea06981f598$export$176e4d6701700463 = ()=>(0, $1ybV0.ff)('hide-icc-for-all-users_avyh5', false);
const $706d7ea06981f598$export$c567845e4f18ee11 = ()=>(0, $1ybV0.ff)('issue.details.issue-link-limit-exceed-warning-flag');
const $706d7ea06981f598$export$2b839c758c080224 = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-pages', false);
const $706d7ea06981f598$export$7411486b04537f62 = ()=>(0, $1ybV0.ff)('issue-details-optimise-editor-onchange-calls_bb4fq', false);
const $706d7ea06981f598$export$281da19089438270 = ()=>(0, $1ybV0.ff)('sea-2350-analytics-for-mentions-in-board-and-backlog_2gkji');
const $706d7ea06981f598$export$ae2025957f2940e4 = ()=>(0, $1ybV0.ff)('platform.linking-platform.link-picker_tgrho', false);
const $706d7ea06981f598$export$1b84fec141e29939 = ()=>(0, $1ybV0.ff)('platform.linking-platform.link-create-extension_e6gj3', false);
const $706d7ea06981f598$export$d83d25e87b40c475 = ()=>(0, $1ybV0.ff)('issue.view-add-traceids-to-issue-view-relay-errors_vm8h2');
const $706d7ea06981f598$export$1c607d9b866655e1 = ()=>(0, $1ybV0.ff)('platform.linking-platform.datasource-jira_issues', false);
const $706d7ea06981f598$export$8c74256e92f57afb = ()=>(0, $1ybV0.ff)('platform.linking-platform.use-new-editor-card-provider', false);
const $706d7ea06981f598$export$e4799b5b27449650 = ()=>(0, $1ybV0.ff)('issue-view-fit-and-finish-full-page_o3hrn', false);
const $706d7ea06981f598$export$5cb6179ec1a74a5a = ()=>(0, $caTc0.isInMentionsIndicatorExperimentCohort)();
const $706d7ea06981f598$export$882e8ff421f7744c = ()=>(0, $1ybV0.ff)('devops_app_recommendation_on_link_paste', false) && (0, $79xbN.expValEquals)('devops_app_recommendation_on_link_paste', 'cohort', 'variation');
const $706d7ea06981f598$export$c3737cff1b9064df = ()=>(0, $1ybV0.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on');
const $706d7ea06981f598$export$f16a46bb33ebb09c = ()=>(0, $1ybV0.ff)('feature.reading-aid-in-issue-description', false);
const $706d7ea06981f598$export$7071b16bdeedd7e0 = ()=>(0, $1ybV0.ff)('jira-reading-aid-acronyms-highlight_3hr5i');
const $706d7ea06981f598$export$709da340f602ae6e = ()=>(0, $1ybV0.ff)('issue-view-unlink-glancefield-from-ui_8a5yg');
const $706d7ea06981f598$export$8db987307934d214 = ()=>(0, $1ybV0.ff)('issue-view-remove-glancesfield-from-query_fyj0g');
const $706d7ea06981f598$export$694fa8b8c523f4cc = ()=>(0, $1ybV0.ff)('implement-dead-glancesfield-query_f71sc');
const $706d7ea06981f598$export$5a53bba8e442c4f9 = ()=>(0, $1ybV0.ff)('issue.details.gira-agg-migration-attachments_ecebe', false);
const $706d7ea06981f598$export$e91c29ee5b520dd2 = ()=>(0, $1ybV0.ff)('jca11y-1432-view-and-edit-issues-bug-track-board-issue-view-full-view-strikethrough-done-status-of-the-issue-is-not-announced-by-screen-reader_hfmug', false);
const $706d7ea06981f598$export$704bed27f6f61d03 = ()=>(0, $1ybV0.ff)('jca11y-1358-new-issue-navigator-issue-view-inappropriate-label-used-for-landmark_th9pe', false);
const $706d7ea06981f598$export$6f64fb042a8db7d9 = ()=>(0, $1ybV0.ff)('jira-issue-view-whiteboards-standalone', false);
const $706d7ea06981f598$export$27d85e4af83ec7f9 = ()=>(0, $1ybV0.ff)('a11y-jira-team-enable-dynamic-edit-button-label-for-issue-field_mpv9f', false);
const $706d7ea06981f598$export$c44cfb78376198a8 = ()=>(0, $1ybV0.ff)('one-issue-table-inline-edit-lite-api-changes');
const $706d7ea06981f598$export$40382276d1d4088d = ()=>(0, $1ybV0.ff)('nin-priority-inline-edit');
const $706d7ea06981f598$export$1f76c12fbdafb975 = ()=>(0, $1ybV0.ff)('nin-resizable-columns_8z4eo');
const $706d7ea06981f598$export$667dd70f296d7a79 = ()=>(0, $1ybV0.ff)('platform_embed-conf_jira-issue_create_cross-join', false);
const $706d7ea06981f598$export$8d9e5c2fc560d7fb = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.linked-page-cross-join', false);
const $706d7ea06981f598$export$712b6916406c5e2a = ()=>(0, $1ybV0.ff)('platform_embed-conf_jira-issue_co-use', false);
const $706d7ea06981f598$export$60184d6d974595a9 = ()=>(0, $1ybV0.ff)('use-view-workflow-service-hook_8y6bk', false);
const $706d7ea06981f598$export$b7098c14b9be61bc = ()=>(0, $1ybV0.ff)('issue-view-remove-activitypanels-from-critical-fetch_43ozj');
const $706d7ea06981f598$export$2b5abc219e47210a = 'jira-issue-view_child-issue-panel-standardisation_76s8e';
const $706d7ea06981f598$export$43153f9815dd9925 = ()=>(0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e', false);
const $706d7ea06981f598$export$602a082cd6009b66 = ()=>(0, $1ybV0.ff)('hrz-716-integrate-goal-picker-into-issue-view', false);
const $706d7ea06981f598$export$6397044ce736d61c = ()=>(0, $1ybV0.ff)('changes-in-cascade-select-edit-view-for-form-field_acoii', false);
const $706d7ea06981f598$export$590b056868f89976 = ()=>(0, $1ybV0.ff)('im-tokens-and-styled-components-migration_qpsld', false);
const $706d7ea06981f598$export$f67982569b9aab31 = ()=>(0, $1ybV0.ff)('issue-unarchival_wdpb9', false);
const $706d7ea06981f598$export$694f7148d449e12 = ()=>(0, $1ybV0.ff)('teamcamp.confirm-issue-date-field-onchange-instead-of-onblur');
const $706d7ea06981f598$export$9d25c3a3874f1891 = ()=>(0, $1ybV0.ff)('products-and-entitlements-m2', false);
const $706d7ea06981f598$export$cd66b30e1a3ad3b0 = ()=>(0, $1ybV0.ff)('jsm-sentiment-analysis_1dage', false);
const $706d7ea06981f598$export$e92cc7310d059d3e = ()=>(0, $1ybV0.ff)('dlp-gordian-enabled', false);
const $706d7ea06981f598$export$ab71258032925094 = ()=>(0, $1ybV0.ff)('issue-view-classification-level-editability_88zal', false);
const $706d7ea06981f598$export$2923d3b89bbda235 = ()=>(0, $1ybV0.ff)('analytics_event_for_deletion_of_linked_issue_1ufi8', false);
const $706d7ea06981f598$export$2a8d8394ee2d63 = ()=>(0, $1ybV0.ff)('metric_for_issue_delete_for_slo_o418h', false);
const $706d7ea06981f598$export$a4c7fa43d0cf493 = ()=>(0, $1ybV0.ff)('fix-for-jracloud-82752_e3pl6', false);
const $706d7ea06981f598$export$8d6eb687c2a90c8c = ()=>(0, $1ybV0.ff)('compal-issue-actions-parent-statuscategoryid_s2esc', false);
const $706d7ea06981f598$export$5dbdd9e44df66fdb = ()=>(0, $1ybV0.ff)('jsm-restrict-internal-comment-visibility', false);
const $706d7ea06981f598$export$61a4e4e1a79114de = ()=>(0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i', false);
const $706d7ea06981f598$export$9e983b29015333eb = ()=>(0, $1ybV0.ff)('jiv-17158-agg-use-iseditableinview_8nogh', false);
const $706d7ea06981f598$export$9542d839b69c5844 = ()=>(0, $1ybV0.ff)('loom-quick-action-button-in-issue-view_pvh5u', false);
const $706d7ea06981f598$export$35cba8f6a1edcd6a = ()=>(0, $1ybV0.ff)('linked-pages-embedded-bug-fix', false);
const $706d7ea06981f598$export$418f24ad76008d74 = ()=>(0, $1ybV0.ff)('uim-cascading-select-field-support-gic_h1cda', false);
const $706d7ea06981f598$export$be7c055598b19df = ()=>(0, $1ybV0.ff)('linked-whiteboards-embedded-bug-fix', false);
const $706d7ea06981f598$export$493fb54a3aa25afb = ()=>(0, $1ybV0.ff)('create-issue-status-button-bug-fix-jiv-17893_hg8fs', false);
const $706d7ea06981f598$export$24744533e9559f1e = ()=>(0, $1ybV0.ff)('sprint-field-long-text-bug_fo95j', false);
const $706d7ea06981f598$export$63beab816c3f18b1 = ()=>(0, $1ybV0.ff)('jsw-premium-edition-eval-admin-ai-upsell_djht5', false);
const $706d7ea06981f598$export$8fa51a766c2ece72 = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-content-crossflow', false);
const $706d7ea06981f598$export$36797146406f89b2 = ()=>(0, $1ybV0.ff)('platform.linking-platform.jira-renderer-use-default-smartlinks-value', false);
const $706d7ea06981f598$export$68300000ff0840c3 = ()=>(0, $1ybV0.ff)('platform.linking-platform.smart-card.hover-card-ai-summaries', false);
const $706d7ea06981f598$export$7d8f401804d751fc = ()=>(0, $1ybV0.ff)('issue-view-designs-improved-schema', false);
const $706d7ea06981f598$export$b6cfe54a20ef8834 = ()=>(0, $1ybV0.ff)('improving-stale-jsm-approval-panel_9hkh2', false);
const $706d7ea06981f598$export$71ed36e51616c829 = ()=>(0, $1ybV0.ff)('forge-ui-modifications-affects-versions-field-support-iv_ff6mj', false);
const $706d7ea06981f598$export$d9ce3c80c1cc862d = ()=>(0, $1ybV0.ff)('jsw.xflow.issue-view-nudge-experiment', false);
const $706d7ea06981f598$export$9e54bab54faf7459 = ()=>(0, $1ybV0.ff)('convert-approvals-glance-to-collapsible-context-group_gqbgz', false);
const $706d7ea06981f598$export$268b11901e56613a = ()=>(0, $1ybV0.ff)('confluence-admin-product-controls', false);
const $706d7ea06981f598$export$4399c72174f6c25d = ()=>(0, $1ybV0.ff)('jsw.xflow.issue-view-nudge-experiment', false);
const $706d7ea06981f598$export$18b62f1e8801aa0f = ()=>(0, $1ybV0.ff)('jira-issue-view-whiteboards-standalone', false);
const $706d7ea06981f598$export$56ceecd3414268e0 = ()=>(0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i', false);
const $706d7ea06981f598$export$ce9fb45735ec88ee = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.linked-page-cross-join', false);
const $706d7ea06981f598$export$9deda930d52d668b = ()=>(0, $1ybV0.ff)('jira-issue-view-confluence-content-functional-component', false);
const $706d7ea06981f598$export$68ee3addb9261f10 = ()=>(0, $1ybV0.ff)('gravityai-1081-remove-issuetype-ari_rr9yb', false);
const $706d7ea06981f598$export$bbd89fe4e4d7eff9 = ()=>(0, $1ybV0.ff)('catch-issue-comments-empty-response-errors_o2gkc', false); // bjayaramareddy

});
parcelRegister("1Iui1", function(module, exports) {

$parcel$export(module.exports, "COHORT", () => $1524157debf2fd00$export$3d370c33621572df);
$parcel$export(module.exports, "NOT_ENROLLED", () => $1524157debf2fd00$export$5b7423264d48ab04);
$parcel$export(module.exports, "CONTROL", () => $1524157debf2fd00$export$43f367b3e957f219);
$parcel$export(module.exports, "EXPERIMENT", () => $1524157debf2fd00$export$9ba2bc3b1bdc1519);
$parcel$export(module.exports, "VARIATION", () => $1524157debf2fd00$export$fa04ad826acc90da);
$parcel$export(module.exports, "VAR1", () => $1524157debf2fd00$export$6486974e39493fa6);
$parcel$export(module.exports, "VAR2", () => $1524157debf2fd00$export$7d994996134ad562);

var $1ybV0 = parcelRequire("1ybV0");
const $1524157debf2fd00$export$3d370c33621572df = 'cohort';
const $1524157debf2fd00$export$5b7423264d48ab04 = 'not-enrolled';
const $1524157debf2fd00$export$43f367b3e957f219 = 'control';
const $1524157debf2fd00$export$9ba2bc3b1bdc1519 = 'experiment';
const $1524157debf2fd00$export$fa04ad826acc90da = 'variation';
const $1524157debf2fd00$export$6486974e39493fa6 = 'variation-1';
const $1524157debf2fd00$export$7d994996134ad562 = 'variation-2';
const $1524157debf2fd00$export$795e7d69b248dcd0 = 'variation-3';
const $1524157debf2fd00$export$c9c947c57470b787 = 'variation-4';
const $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $1524157debf2fd00$export$5b7423264d48ab04,
    $1524157debf2fd00$export$43f367b3e957f219,
    $1524157debf2fd00$export$9ba2bc3b1bdc1519,
    $1524157debf2fd00$export$fa04ad826acc90da,
    $1524157debf2fd00$export$6486974e39493fa6,
    $1524157debf2fd00$export$7d994996134ad562,
    $1524157debf2fd00$export$795e7d69b248dcd0,
    $1524157debf2fd00$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$1524157debf2fd00$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $1ybV0.getMultivariateFeatureFlag)(experimentFeatureFlag, $1524157debf2fd00$export$5b7423264d48ab04, validExperimentGroups);

});

const $3401608855dcf8dc$export$fb6fa89d43ed06f7 = 'variant-contextual';
const $3401608855dcf8dc$export$c52ae1847ec8c2c = 'variant-contextual-not-enrolled';

parcelRegister("caTc0", function(module, exports) {

$parcel$export(module.exports, "isInMentionsIndicatorExperimentCohort", () => $09e2035ec940dd58$export$4d1c47e616b7a5fb);

var $79xbN = parcelRequire("79xbN");
function $09e2035ec940dd58$export$4d1c47e616b7a5fb() {
    return (0, $79xbN.expValEquals)('mentions_in_board_and_backlog_ver_2', 'cohort', 'test');
}

});


parcelRegister("782cd", function(module, exports) {

$parcel$export(module.exports, "serverTimingSelector", () => $51fba4a554a079cc$export$a0b21c7e17057a47);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $51fba4a554a079cc$export$8ef68fa2b28a6d0f = (state)=>state.timing;
const $51fba4a554a079cc$export$a0b21c7e17057a47 = (0, $df4Sl.createSelector)($51fba4a554a079cc$export$8ef68fa2b28a6d0f, (0, $jZDJX.isLoadingSelector), (timing, isLoading)=>isLoading ? undefined : timing.server);

});

parcelRegister("lMwBY", function(module, exports) {

$parcel$export(module.exports, "afterPaintEmit", () => $6a5d9a384a9292d0$export$dc4c3408669b8f4e);

var $6iz4v = parcelRequire("6iz4v");

const $6a5d9a384a9292d0$export$dc4c3408669b8f4e = (emitMetrics, metric)=>{
    const stopTime = performance.now();
    setTimeout(()=>{
        metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        setTimeout(()=>{
            emitMetrics(stopTime);
        }, 500);
    });
};

});

parcelRegister("iTvzN", function(module, exports) {

$parcel$export(module.exports, "startUimTti", () => $f4d69f5c84cf80c8$export$1422384676f6de7a);
$parcel$export(module.exports, "markUimTtiIssueViewLoaded", () => $f4d69f5c84cf80c8$export$5a9389b70d93def2);
$parcel$export(module.exports, "stopTTI", () => $f4d69f5c84cf80c8$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $f4d69f5c84cf80c8$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $f4d69f5c84cf80c8$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $f4d69f5c84cf80c8$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $f4d69f5c84cf80c8$export$d86f4868694f2aa7);

var $lEpcX = parcelRequire("lEpcX");

var $gGRYc = parcelRequire("gGRYc");
const $f4d69f5c84cf80c8$var$uimInIssueViewTTI = (0, $lEpcX.metrics).interaction({
    key: 'ui-modifications-in-issue-view',
    timings: [
        {
            key: 'issue-view-tti-delta',
            startMark: 'issue-view-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $f4d69f5c84cf80c8$export$1422384676f6de7a = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.start();
};
const $f4d69f5c84cf80c8$export$5a9389b70d93def2 = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.mark('issue-view-tti');
};
const $f4d69f5c84cf80c8$export$30ca4c461fab486c = (customData)=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.stop({
        customData: customData
    });
};
const $f4d69f5c84cf80c8$export$27f2445288b528c = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.cancel();
};
const $f4d69f5c84cf80c8$export$7a2709fc1e33401a = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.mark('iframe-load');
};
const $f4d69f5c84cf80c8$export$cf3893335c93e33b = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.mark('fields-registered');
};
const $f4d69f5c84cf80c8$export$d86f4868694f2aa7 = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.mark('oninit-resolved');
};

});

parcelRegister("aQQHY", function(module, exports) {

$parcel$export(module.exports, "getIssueViewFeatureFlags", () => $ecf9b697f5563ad9$export$1997224f7610e14);

var $eoCgY = parcelRequire("eoCgY");

var $kCvLy = parcelRequire("kCvLy");
const $ecf9b697f5563ad9$export$1997224f7610e14 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const featureFlagReport = {};
    Object.entries($kCvLy).forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([featureFlagName, featureFlagFunc])=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eoCgY)))(featureFlagFunc)) featureFlagReport[featureFlagName] = featureFlagFunc();
    });
    return featureFlagReport;
};

});
parcelRegister("kCvLy", function(module, exports) {
/**
 * We need this file to be separate from feature-flags.tsx because somehow it effects
 * the way that the code is parsed and converted to AST and used by src/packages/issue/test-util/src/utils.tsx.
 */ // eslint-disable-next-line jira/tangerine-no-export-star

var $8Bhia = parcelRequire("8Bhia");
$parcel$exportWildcard(module.exports, $8Bhia);

});


parcelRegister("7iu2Y", function(module, exports) {

$parcel$export(module.exports, "issueScaleabilityReporterFactory", () => $c5094ff7f20cdaa9$export$9f6c068bd6582299);

var $1ybV0 = parcelRequire("1ybV0");


var $6azHZ = parcelRequire("6azHZ");

var $f9RL0 = parcelRequire("f9RL0");

var $kSuBQ = parcelRequire("kSuBQ");

var $4sNXH = parcelRequire("4sNXH");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $8CSFK = parcelRequire("8CSFK");

var $8QKSg = parcelRequire("8QKSg");

var $1b2Vj = parcelRequire("1b2Vj");

var $cj1Xt = parcelRequire("cj1Xt");

var $9D3Vo = parcelRequire("9D3Vo");

var $dmojD = parcelRequire("dmojD");

var $cFY86 = parcelRequire("cFY86");

var $ke6cX = parcelRequire("ke6cX");

var $6Fp9G = parcelRequire("6Fp9G");

var $dv9do = parcelRequire("dv9do");

var $lO4Or = parcelRequire("lO4Or");

var $9s86T = parcelRequire("9s86T");

var $6VKiL = parcelRequire("6VKiL");
const $c5094ff7f20cdaa9$var$getCascadingSelectFields = (state)=>Object.values((0, $fokFV.fieldsSelector)(state)).filter((fieldValues)=>fieldValues.schema.custom === (0, $lO4Or.CASCADING_SELECT_CF_TYPE));
const $c5094ff7f20cdaa9$var$getAtlassianTeamFields = (state)=>Object.values((0, $fokFV.fieldsSelector)(state)).filter((fieldValues)=>fieldValues.schema.custom === (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c5094ff7f20cdaa9$var$getCascadingSelectOptionChildrenCount = (cascadingSelectFieldValue)=>{
    if (cascadingSelectFieldValue.length === 0) return 0;
    return Object.values(cascadingSelectFieldValue).reduce((accumulatedCount, parentValue)=>accumulatedCount + (parentValue?.children?.length || 1), 0);
};
const $c5094ff7f20cdaa9$var$getCascadingSelectOptionsTotalCount = (state)=>{
    const cascadingSelectFields = $c5094ff7f20cdaa9$var$getCascadingSelectFields(state);
    if (cascadingSelectFields.length === 0) return 0;
    return cascadingSelectFields.reduce((accumulatedCount, cascadingSelectField)=>accumulatedCount + ($c5094ff7f20cdaa9$var$getCascadingSelectOptionChildrenCount(cascadingSelectField.allowedValues) || 1), 0);
};
const $c5094ff7f20cdaa9$export$ae327590f8230d00 = ({ projectKey: projectKey, ecosystem: ecosystem, forge: forge })=>{
    let open = 0;
    let closed = 0;
    if (projectKey !== undefined) {
        // The context groups store the state of open / closed inside local storage, so we need to get access to that
        // here. It's not held in redux which is why we look it up this way.
        const groupLocalStorageName = (0, $kSuBQ.getGroupLocalStorageName)(projectKey, 'context-group');
        try {
            // It's possible panels are uninstalled and not removed from localstorage, so we need to check they are installed
            // otherwise the analytics may be incorrectly advising how many panels are open
            const installedPanels = [
                ...ecosystem.map((item)=>`${groupLocalStorageName}-${(0, $4sNXH.generateContextPanelId)(item)}`),
                ...forge.map((item)=>`${groupLocalStorageName}-${item.id}`)
            ];
            open = Object.values((0, $kSuBQ.getGroupsLocalStorage)(installedPanels, (0, $ab2aafcdf11a1361$export$e1184c3be46bd7cb))).filter(Boolean).length;
            // Panels may not exist in localStorage but may be installed, in which case they are closed as this is the default state
            closed = installedPanels.length - open;
        } catch  {
        // No action required
        }
    }
    return {
        open: open,
        closed: closed
    };
};
const $c5094ff7f20cdaa9$export$9f6c068bd6582299 = (store, issueContextActions)=>()=>{
        const state = store.getState();
        const { permalinkType: permalinkType } = (0, $9s86T.getPermalinkTypeAndId)() || {};
        const childIssues = (0, $fokFV.fieldSelector)((0, $lO4Or.CHILDREN_ISSUES))(state);
        const proformaHarmonisation = (0, $fokFV.fieldSelector)((0, $lO4Or.PROFORMA_FORMS))(state);
        const { open: contextPanelOpenCount, closed: contextPanelClosedCount } = $c5094ff7f20cdaa9$export$ae327590f8230d00({
            projectKey: state?.entities?.project?.projectKey,
            ecosystem: (0, $8CSFK.contextPanelEntitiesSelector)(state),
            forge: (0, $8QKSg.forgeContextPanelsSelector)(state)
        });
        const subtaskCount = (0, $fokFV.childIssuesLimitUrlSelector)(state)((0, $f9RL0.SUBTASKS)) && issueContextActions ? (0, $6azHZ.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : (0, $dv9do.subtaskEntitiesSelector)(state).length;
        const childIssuesCount = (0, $fokFV.childIssuesLimitUrlSelector)(state)((0, $lO4Or.CHILDREN_ISSUES)) && issueContextActions ? (0, $6azHZ.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : childIssues?.value.length ?? 0;
        // If a portfolio issue is over the limit we cannot tell because
        // only the subtasks panel is displayed. Once the portfolio issue
        // type hierarchy level is a value > 1 then we can set this to ">100".
        let portfolioChildIssueCount;
        let actualSubtaskCount;
        let actualChildIssueCount;
        let actualEpicIssueCount;
        let epicIssueCount;
        const subtasks = (0, $fokFV.fieldSelector)((0, $f9RL0.SUBTASKS))(state);
        const epicIssues = (0, $fokFV.fieldSelector)((0, $f9RL0.EPIC_ISSUES))(state);
        const portfolioChildIssues = (0, $fokFV.fieldSelector)((0, $f9RL0.PORTFOLIO_CHILD_ISSUES))(state);
        const getChildIssuesLimitUrl = (0, $fokFV.childIssuesLimitUrlSelector)(state);
        const isEpicIssuesOverLimit = Boolean(getChildIssuesLimitUrl((0, $f9RL0.EPIC_ISSUES)));
        const isOverLimit = Boolean(getChildIssuesLimitUrl((0, $f9RL0.SUBTASKS))) || Boolean(getChildIssuesLimitUrl((0, $lO4Or.CHILDREN_ISSUES))) || isEpicIssuesOverLimit;
        if (isOverLimit) {
            actualChildIssueCount = childIssues?.originalContentLength ?? 0;
            actualEpicIssueCount = epicIssues?.originalContentLength ?? 0;
            // If epic issue is over the limit, we exclude the subtasks field
            // from the store. So we need to grab the data from the epicIssues field.
            actualSubtaskCount = isEpicIssuesOverLimit ? epicIssues?.otherOriginalChildIssuesLength ?? 0 : subtasks?.originalContentLength ?? 0;
            epicIssueCount = isEpicIssuesOverLimit && issueContextActions ? (0, $6azHZ.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : epicIssues?.originalContentLength ?? 0;
            // If portfolio issue is over the limit, we exclude the portfolio-child-issues field
            // from the store. So we need to grab the data from the subtasks field.
            portfolioChildIssueCount = subtasks?.otherOriginalChildIssuesLength ?? 0;
        } else {
            actualChildIssueCount = childIssues?.value.length ?? 0;
            actualSubtaskCount = subtasks?.value.length ?? 0;
            actualEpicIssueCount = epicIssues?.value.length ?? 0;
            portfolioChildIssueCount = portfolioChildIssues?.value.length ?? 0;
            epicIssueCount = actualEpicIssueCount;
        }
        // Properties added here show up in:
        // - jira.fe.custom.issue-view-on-page-load
        // - jira.fe.page-load.issue-view
        // - and jira.fe.custom.embedded-issue-view-load
        // Verify these in the BM3 tab of the Chrome Analytics extension.
        return {
            ecosystemGlances: (0, $8CSFK.glancesSelector)(state).length,
            ecosystemContentPanels: (0, $8CSFK.allContentPanelsSelector)(state).length,
            contextPanelOpenCount: contextPanelOpenCount,
            contextPanelClosedCount: contextPanelClosedCount,
            ...!(0, $1ybV0.ff)('issue-view-remove-activitypanels-from-critical-fetch_43ozj') ? {
                ecosystemActivityPanels: (0, $8CSFK.activityPanelsSelector)(state).length
            } : {},
            ...!(0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? {
                ecosystemOperations: (0, $8CSFK.operationsSelector)(state).length
            } : {},
            ecosystemCustomsFields: (0, $cj1Xt.ecosystemCustomFieldIdsSelector)(state).length,
            childIssues: childIssuesCount,
            linkIssueCount: (0, $cFY86.combinedLinkedIssueCountSelector)(state),
            subtaskCount: subtaskCount,
            actualChildIssueCount: actualChildIssueCount,
            actualSubtaskCount: actualSubtaskCount,
            actualEpicIssueCount: actualEpicIssueCount,
            actualPortfolioChildIssueCount: portfolioChildIssueCount,
            epicIssueCount: epicIssueCount,
            portfolioChildIssueCount: portfolioChildIssueCount,
            issueId: (0, $5JqpU.issueIdSelector)(state),
            commentsTotalCount: (0, $dmojD.totalCommentsSelector)(state),
            hasCommentPermalink: permalinkType === (0, $6VKiL.COMMENTS),
            cascadingSelectCount: $c5094ff7f20cdaa9$var$getCascadingSelectFields(state).length,
            isAtlassianTeamFieldEnabled: $c5094ff7f20cdaa9$var$getAtlassianTeamFields(state).length > 0,
            cascadingSelectOptionsTotalCount: $c5094ff7f20cdaa9$var$getCascadingSelectOptionsTotalCount(state),
            proformaHarmonisationEnabled: proformaHarmonisation ? proformaHarmonisation.value.isHarmonisationEnabled : false,
            hasSubtasksTypes: (0, $6Fp9G.isSubtaskTypesPresentSelector)(state),
            issueTypesCount: (0, $ke6cX.issueTypesSelector)(state).length,
            issueTypeHierarchyLevel: !(0, $jZDJX.isSimplifiedProjectSelector)(state) ? (0, $9D3Vo.issueTypeHierarchyLevelSelector)(state) : (0, $1b2Vj.hierarchyLevelSelector)(state)
        };
    };

});
parcelRegister("6azHZ", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimitExceededAnalyticsCount", () => $fdeece38e8748ab6$export$8cbe27041ec414b7);

var $8Y8Vi = parcelRequire("8Y8Vi");
const $fdeece38e8748ab6$export$1e3c128c36bad9a4 = 'CHILD_ISSUES_LIMIT_EXCEEDED';
const $fdeece38e8748ab6$export$8cbe27041ec414b7 = (childIssuesLimit)=>`>${childIssuesLimit}`;

});
parcelRegister("8Y8Vi", function(module, exports) {

$parcel$export(module.exports, "associatedIssueErrorTypes", () => $91892c2c67b32e99$export$e1cf8628ef0f1215);
const $91892c2c67b32e99$export$e1cf8628ef0f1215 = {
    createChild: 'createChild',
    linkChild: 'linkChild'
};

});


parcelRegister("kSuBQ", function(module, exports) {

$parcel$export(module.exports, "getGroupLocalStorageName", () => $d054c54ec3a75126$export$a3b190a19b138f2e);
$parcel$export(module.exports, "isGroupPanelOpen", () => $d054c54ec3a75126$export$e79995f22545fd3e);
$parcel$export(module.exports, "getGroupsLocalStorage", () => $d054c54ec3a75126$export$d0a5ccc42f3bcd33);
$parcel$export(module.exports, "useGroupLocalStorage", () => $d054c54ec3a75126$export$4e1a840a45fb467c);

var $eUqFw = parcelRequire("eUqFw");
const $d054c54ec3a75126$export$a3b190a19b138f2e = (projectKey, id)=>`group.state.${projectKey}.${id}`;
const $d054c54ec3a75126$export$a7e7b7df48874d2c = (keyName, defaultValue)=>{
    try {
        const item = window.localStorage.getItem(keyName);
        if (item === 'true') return true;
        if (item === 'false') return false;
        throw Error('Invalid group state value');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        return defaultValue;
    }
};
const $d054c54ec3a75126$export$e79995f22545fd3e = (projectKey, group, panelId, defaultValue)=>{
    const groupLocalStorageName = $d054c54ec3a75126$export$a3b190a19b138f2e(projectKey, group);
    return $d054c54ec3a75126$export$a7e7b7df48874d2c(`${groupLocalStorageName}-${panelId}`, defaultValue);
};
const $d054c54ec3a75126$export$d0a5ccc42f3bcd33 = (keyNames, initialOpened)=>{
    const items = {};
    keyNames.forEach((key)=>{
        items[key] = $d054c54ec3a75126$export$a7e7b7df48874d2c(key, initialOpened);
    });
    return items;
};
const $d054c54ec3a75126$export$4e1a840a45fb467c = (projectKey, id, initialOpened)=>{
    const keyName = $d054c54ec3a75126$export$a3b190a19b138f2e(projectKey, id);
    const [storedValue, setStoredValue] = (0, $eUqFw.useState)(()=>$d054c54ec3a75126$export$a7e7b7df48874d2c(keyName, initialOpened));
    const setValue = (0, $eUqFw.useCallback)((value)=>{
        try {
            setStoredValue(value);
            window.localStorage.setItem(keyName, String(value));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (_) {
        // Not decided what we do when we reach here.
        }
    }, [
        keyName
    ]);
    return [
        storedValue,
        setValue
    ];
};

});

parcelRegister("4sNXH", function(module, exports) {

$parcel$export(module.exports, "shouldHideNullUneditableField", () => $677ed9cfdaabf5a5$export$e7987ba89f8e2996);
$parcel$export(module.exports, "ecosystemGlancesToLayoutItem", () => $677ed9cfdaabf5a5$export$8dd9174e11169a13);
$parcel$export(module.exports, "ecosystemContextsToLayoutItem", () => $677ed9cfdaabf5a5$export$ff0381f8ed1f6cc7);
$parcel$export(module.exports, "useForgeGlancesAsLayoutItems", () => $677ed9cfdaabf5a5$export$969c8278a214a2d9);
$parcel$export(module.exports, "useForgeContextPanelsAsLayoutItems", () => $677ed9cfdaabf5a5$export$b4095ac407369aa0);
$parcel$export(module.exports, "addChangeboardingRefToFirstItem", () => $677ed9cfdaabf5a5$export$b7aff69af7ee8f70);
$parcel$export(module.exports, "getPinnedFieldItems", () => $677ed9cfdaabf5a5$export$7fc9f8048722ede9);
$parcel$export(module.exports, "generateContextPanelId", () => $677ed9cfdaabf5a5$export$c55ff2c236d30544);

var $8i1R8 = parcelRequire("8i1R8");

var $fTsDx = parcelRequire("fTsDx");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $bLiXo = parcelRequire("bLiXo");

var $fkvsU = parcelRequire("fkvsU");


var $4faf8 = parcelRequire("4faf8");

var $f9RL0 = parcelRequire("f9RL0");

var $2Sajo = parcelRequire("2Sajo");


var $g8to1 = parcelRequire("g8to1");

var $lO4Or = parcelRequire("lO4Or");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");
const $677ed9cfdaabf5a5$export$87af144309c7a3c5 = (canLogTime, isNativeJiraTimeTrackingEnabled)=>// Here we assume that if the time tracking field is an available field
    // but isNativeJiraTimeTrackingEnabled is false, a 3rd party time tracking app is installed.
    isNativeJiraTimeTrackingEnabled ? !canLogTime : false;
const $677ed9cfdaabf5a5$var$getFieldByCustomType = (customType, fieldsConfiguration)=>(0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(fieldsConfiguration, (field)=>(field.schema && field.schema.custom) === customType);
const $677ed9cfdaabf5a5$var$getFieldConfiguration = (fieldId, fields)=>{
    const field = fields[fieldId];
    const customSystemFields = (0, $f9RL0.specialFields)();
    const condition = !field && Object.prototype.hasOwnProperty.call(customSystemFields, fieldId);
    if (condition) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        const customType = customSystemFields[fieldId];
        return $677ed9cfdaabf5a5$var$getFieldByCustomType(customType, fields);
    }
    return field;
};
const $677ed9cfdaabf5a5$export$e7987ba89f8e2996 = (itemId, issueFieldsConfig, value, canLogTime, isNativeJiraTimeTrackingEnabled)=>{
    const fieldConfig = $677ed9cfdaabf5a5$var$getFieldConfiguration(itemId, issueFieldsConfig);
    const fieldType = (0, $g8to1.getFieldType)(fieldConfig);
    if ((0, $g8to1.getPanels)().includes(itemId)) return false;
    if (!fieldConfig || fieldType === undefined) return true;
    if ((0, $g8to1.isEmpty)(value) && !fieldConfig.isEditable) {
        if (itemId === (0, $lO4Or.ASSIGNEE_TYPE) || fieldType === (0, $lO4Or.REQUEST_TYPE_CF_TYPE) || fieldType === (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE)) return false;
        // ARKEN-40: Forge custom fields with readonly and an empty value must still be shown as primary or secondary items
        if ((0, $4faf8.isForgeField)(fieldConfig)) return false;
        if (itemId === (0, $lO4Or.TIME_TRACKING_TYPE)) return $677ed9cfdaabf5a5$export$87af144309c7a3c5(canLogTime, isNativeJiraTimeTrackingEnabled);
        return true;
    }
    return false;
};
const $677ed9cfdaabf5a5$export$8dd9174e11169a13 = (ecosystemGlances)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = Object.keys(ecosystemGlances).reduce((acc, next)=>{
        const ecosystem = ecosystemGlances[next];
        const modules = Object.keys(ecosystem).map((moduleKey)=>ecosystem[moduleKey]);
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        return [
            ...acc,
            ...modules
        ];
    }, []);
    return result.map((connectGlance)=>({
            id: `${0, $lO4Or.ECOSYSTEM_GLANCE_TYPE}__${connectGlance.appKey}__${connectGlance.moduleKey}`,
            type: (0, $lO4Or.ECOSYSTEM_GLANCE_TYPE),
            payload: {
                ...connectGlance,
                glanceType: (0, $fkvsU.CONNECT_ENTITY_TYPE)
            }
        }));
};
const $677ed9cfdaabf5a5$export$ff0381f8ed1f6cc7 = (ecosystemContextPanels)=>{
    const contextPanels = [];
    Object.values(ecosystemContextPanels).forEach((contextPanelObject)=>{
        contextPanels.push(Object.values(contextPanelObject)[0]);
    });
    return contextPanels.map((connectContextPanel)=>({
            id: `${0, $lO4Or.ECOSYSTEM_CONTEXT_TYPE}__${connectContextPanel.appKey}__${connectContextPanel.moduleKey}`,
            type: (0, $lO4Or.ECOSYSTEM_CONTEXT_TYPE),
            payload: {
                ...connectContextPanel,
                contextPanelType: (0, $fkvsU.CONNECT_ENTITY_TYPE)
            }
        }));
};
const $677ed9cfdaabf5a5$var$ISSUE_TYPE = 'issuetype';
const $677ed9cfdaabf5a5$export$ea6c3ae2bd3a5510 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const issueId = (0, $hJ992.useIssueId)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const [permissions] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const projectId = (0, $guDlK.useProjectId)(projectKey);
    const [issueType] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: $677ed9cfdaabf5a5$var$ISSUE_TYPE
    });
    return {
        issueId: issueId || null,
        issueKey: issueKey,
        issueType: issueType && issueType.name,
        projectId: projectId,
        projectKey: projectKey,
        projectType: projectType || null,
        // Prop normalisation copied from original redux selector - Props names are exposed externally.
        canAddComments: permissions.canAddComments,
        canAdministerJira: permissions.canAdministerJira,
        canAdministerProjects: permissions.canAdministerProject,
        canAssignIssues: permissions.canAssignIssues,
        canBeAssignedToIssues: permissions.canBeAssignedToIssues,
        canCloneIssues: permissions.canCloneIssue,
        canCreateAttachments: permissions.canCreateAttachments,
        canCreateChildren: permissions.canCreateChildren,
        canCreateSubtasks: permissions.canCreateSubtask,
        canDeleteAllAttachments: permissions.canDeleteAllAttachments,
        canDeleteAllComments: permissions.canDeleteAllComments,
        canDeleteAllWorklogs: permissions.canDeleteAllWorklogs,
        canDeleteIssues: permissions.canDeleteIssue,
        canDeleteOwnAttachments: permissions.canDeleteOwnAttachments,
        canDeleteOwnComments: permissions.canDeleteOwnComments,
        canDeleteOwnWorklogs: permissions.canDeleteOwnWorklogs,
        canEditAllComments: permissions.canEditAllComments,
        canEditAllWorklogs: permissions.canEditAllWorklogs,
        canEditIssues: permissions.canEditIssues,
        canEditOwnComments: permissions.canEditOwnComments,
        canEditOwnWorklogs: permissions.canEditOwnWorklogs,
        canLinkIssues: permissions.canLinkIssues,
        canLogWork: permissions.canLogWork,
        canManageWatchers: permissions.canManageWatchers,
        canModifyReporters: permissions.canModifyReporter,
        canMoveIssues: permissions.canMoveIssue,
        canScheduleIssues: permissions.canScheduleIssues,
        canUseServiceManagementAgentFeatures: permissions.canUseServiceDeskAgentFeatures,
        canBrowseUsers: permissions.canBrowseUsers,
        canViewDevTools: permissions.canViewDevTools,
        canViewWatchers: permissions.canViewWatchers
    };
};
const $677ed9cfdaabf5a5$export$969c8278a214a2d9 = ()=>{
    const [forgeGlances] = (0, $2Sajo.useForgeGlances)();
    const staticContext = $677ed9cfdaabf5a5$export$ea6c3ae2bd3a5510();
    return forgeGlances.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, staticContext)).map((forgeGlance)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: icon } } = forgeGlance;
        return {
            id: id,
            type: (0, $lO4Or.FORGE_GLANCE_TYPE),
            payload: {
                label: label,
                title: title,
                status: status,
                icon: icon,
                extension: forgeGlance,
                glanceType: (0, $fe92e572161b5748$export$6f3804b3f188f650),
                moduleKey: id,
                appKey: id
            }
        };
    });
};
const $677ed9cfdaabf5a5$export$b4095ac407369aa0 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const { ecosystemEnabled: ecosystemEnabled } = (0, $guDlK.useProjectConfiguration)(projectKey);
    const [forgeContextPanels] = (0, $2Sajo.useForgeContextPanels)();
    const staticContext = $677ed9cfdaabf5a5$export$ea6c3ae2bd3a5510();
    if (!ecosystemEnabled) return [];
    return forgeContextPanels.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, staticContext)).map((contextPanels)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: url } } = contextPanels;
        return {
            id: id,
            type: (0, $bLiXo.FORGE_CONTEXT_TYPE),
            payload: {
                type: (0, $bLiXo.FORGE_CONTEXT_TYPE),
                label: label,
                name: title,
                status: status || null,
                icon: url ? {
                    url: url
                } : null,
                extension: contextPanels,
                contextPanelType: (0, $fe92e572161b5748$export$6f3804b3f188f650),
                moduleKey: id,
                appKey: id,
                options: null
            }
        };
    });
};
const $677ed9cfdaabf5a5$export$b7aff69af7ee8f70 = (items)=>{
    let wrapperAdded = false;
    const allowedTypes = [
        (0, $bLiXo.layoutContainerItemTypes).field,
        (0, $bLiXo.layoutContainerItemTypes).panel
    ];
    const disallowedIds = [
        (0, $lO4Or.ASSIGNEE_TYPE),
        (0, $lO4Or.SLA_PANEL_TYPE)
    ];
    return items.map((item)=>{
        const typename = item.type !== undefined ? item.type : '';
        // @ts-expect-error - TS2345 - Argument of type 'any' is not assignable to parameter of type 'never'.
        if (!wrapperAdded && !disallowedIds.includes(item.id) && allowedTypes.includes(typename)) {
            wrapperAdded = true;
            // if it was added to csat field and csat field to be removed later in servicedesk template, this effectively won't work
            return {
                ...item,
                globalRef: (0, $ab3fc2ac1a2f2638$export$95ff4d03075475e2)
            };
        }
        return item;
    });
};
const $677ed9cfdaabf5a5$export$7fc9f8048722ede9 = (dedupedItems, pinnedFields)=>pinnedFields.reduce((result, pinnedId)=>{
        const item = dedupedItems.find((dedupedItem)=>dedupedItem.type === (0, $bLiXo.layoutContainerItemTypes).field && dedupedItem.fieldItemId === pinnedId || dedupedItem.type === (0, $bLiXo.layoutContainerItemTypes).panel && dedupedItem.panelItemId === pinnedId);
        if (item !== undefined) result.push(item);
        return result;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, []);
const $677ed9cfdaabf5a5$export$c55ff2c236d30544 = ({ appKey: appKey, moduleKey: moduleKey })=>`${0, $lO4Or.ECOSYSTEM_CONTEXT_TYPE}__${appKey}__${moduleKey}`;

});
parcelRegister("fTsDx", function(module, exports) {

$parcel$export(module.exports, "doesExtensionMeetConditions", () => $f49523f1e6c1d89f$export$b1e4ed7044e85aa3);

var $iPaeE = parcelRequire("iPaeE");

var $e91YZ = parcelRequire("e91YZ");
const $f49523f1e6c1d89f$export$b1e4ed7044e85aa3 = (extension, extraContext)=>{
    const { displayConditions: displayConditions } = extension.properties;
    const { appPermissions: { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess }, isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const context = {
        // Whatever extension needs
        ...extraContext,
        isAdmin: // User info
        isAdmin,
        isLoggedIn: !isAnonymous,
        isSiteAdmin: isSiteAdmin,
        hasSoftwareAccess: // App permissions
        hasSoftwareAccess,
        hasServiceManagementAccess: hasServiceDeskAccess,
        hasCoreAccess: hasCoreAccess
    };
    return displayConditions ? (0, $iPaeE.doesMeetConditions)(displayConditions, context) : true;
};

});

parcelRegister("bLiXo", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $9366007edb455895$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $9366007edb455895$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $9366007edb455895$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $9366007edb455895$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $9366007edb455895$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $9366007edb455895$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $9366007edb455895$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $9366007edb455895$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $9366007edb455895$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $9366007edb455895$export$5507f31126c8b283);
const $9366007edb455895$export$99ad62164189f781 = 'ecosystemGlance';
const $9366007edb455895$export$7719ef6e9283671 = 'forgeGlance';
const $9366007edb455895$export$bfebea5ce2e1887a = 'ecosystemContext';
const $9366007edb455895$export$be8e68fb1aed253e = 'forgeContext';
const $9366007edb455895$export$7bf561e6ab380ea1 = 'context';
const $9366007edb455895$export$f42c11634d75863e = 'content';
const $9366007edb455895$export$b38842736b6dbc1d = 'content-request';
const $9366007edb455895$export$bc9fa2d93b5fabae = 'FIELD';
const $9366007edb455895$var$STATUS_TYPE = 'STATUS';
const $9366007edb455895$var$TAB_TYPE = 'TAB';
const $9366007edb455895$var$PANEL_TYPE = 'PANEL';
const $9366007edb455895$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
const $9366007edb455895$var$FORGE_TYPE = 'FORGE';
const $9366007edb455895$export$605c43f1b33ab69 = 'SUMMARY';
const $9366007edb455895$export$e655b77b9efe622f = 'CustomItem';
const $9366007edb455895$export$5cf403de05e9bea = 'FieldSectionItem';
const $9366007edb455895$export$30f7f9a86f182492 = 'TabLayout';
const $9366007edb455895$export$196e597ad9a97f7a = 'PanelSectionItem';
const $9366007edb455895$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
const $9366007edb455895$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $9366007edb455895$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};

});

/**
 * Opt into the new issue view modal key. To be cleaned up with issue.details.opt-back-in
 * This key is stored in the API and should not be renamed.
 * @see https://hello.atlassian.net/wiki/spaces/JIE/pages/920124493/How+to+re-set+new+Bento+Change+Boarding#Re-set-Opt-In-Back-Modal
 */ const $ab3fc2ac1a2f2638$export$a3338d0a4845edfa = 'jira.details.opt-in-back.next-reminding-date';
const $ab3fc2ac1a2f2638$export$26de4b42c139644c = 'jira.user.issue.should.show.welcome.message';
const $ab3fc2ac1a2f2638$export$ece45f325779a5d5 = 'jira.user.issue.opt.in.back.modal.has.dismissed';
const $ab3fc2ac1a2f2638$export$4603581e6066a63f = 'jira.user.issue.opt.in.back.banner.has.dismissed';
const $ab3fc2ac1a2f2638$export$af60a7ae4202be66 = 'issue-details-changeboarding';
const $ab3fc2ac1a2f2638$export$7b98e5a33c854454 = 30;
const $ab3fc2ac1a2f2638$export$956fcd3a2e5c48a8 = 'SOFTWARE_ISSUE_STATUS';
const $ab3fc2ac1a2f2638$export$ebb7dcd60318cfac = 'SERVICEDESK_ISSUE_STATUS';
const $ab3fc2ac1a2f2638$export$a446d697df3d6b2c = 'SERVICEDESK_REQUEST_PANEL';
const $ab3fc2ac1a2f2638$export$d3dadb39db0c423 = 'SERVICEDESK_CREATE_COMMENT_ACTIONS';
const $ab3fc2ac1a2f2638$export$75867eab2abae162 = 'SERVICEDESK_PLACEHOLDER_CREATE_COMMENT_ACTIONS';
const $ab3fc2ac1a2f2638$export$483d9bcbbd8280a6 = 'status-spotlight';
const $ab3fc2ac1a2f2638$export$95f98990d7202b31 = 'SHOW_MORE';
const $ab3fc2ac1a2f2638$export$95ff4d03075475e2 = 'PIN_FIELD';
const $ab3fc2ac1a2f2638$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $ab3fc2ac1a2f2638$export$6f48b612d5c03f4d = 'PERMALINK';
const $ab3fc2ac1a2f2638$export$d84e7970e2d564af = 'BOARD_SIDEBAR';
const $ab3fc2ac1a2f2638$export$fa5ad81958817beb = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.details-group';
const $ab3fc2ac1a2f2638$export$1ba8bc5ff9e50d09 = 'QUICK_ADDS';
const $ab3fc2ac1a2f2638$export$f9baa44349b5d6b8 = 'JSW_ACTIVITY_FEED_BUTTONS';
const $ab3fc2ac1a2f2638$export$f49830a0e4ffb3f9 = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.sla-group';
const $ab3fc2ac1a2f2638$export$efb12103a5e32a1e = 'PIN_FIELD_PLACEHOLDER_BANNER';
const $ab3fc2ac1a2f2638$export$4288bce987c22af4 = 'PINNED_FIELDS_PANEL';

parcelRegister("4faf8", function(module, exports) {

$parcel$export(module.exports, "isForgeField", () => $45669342ae4293ea$export$f4484ef180517e0e);
$parcel$export(module.exports, "getForgeFieldType", () => $45669342ae4293ea$export$3f8bcfe7fea0362a);

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $lO4Or = parcelRequire("lO4Or");
const $45669342ae4293ea$export$f4484ef180517e0e = (field)=>field && (0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(field, 'schema.custom') && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(field.schema.custom) && field.schema.custom.includes('ari:cloud:ecosystem::extension');
const $45669342ae4293ea$export$3f8bcfe7fea0362a = (field)=>{
    if (!$45669342ae4293ea$export$f4484ef180517e0e(field)) return null;
    return 0, $lO4Or.FORGE_CUSTOM_FIELD_TYPE;
};

});

parcelRegister("2Sajo", function(module, exports) {

$parcel$export(module.exports, "useForgeGlances", () => $dcae2a1bd36bdf24$export$dc79f3e7b8a6c3e1);
$parcel$export(module.exports, "useForgeContextPanels", () => $dcae2a1bd36bdf24$export$a1a589b738ca01b8);
$parcel$export(module.exports, "useForgeDataComplete", () => $dcae2a1bd36bdf24$export$db75d05b888b2963);
$parcel$export(module.exports, "useForgeCustomField", () => $dcae2a1bd36bdf24$export$2a006c08e9ab6fc3);
$parcel$export(module.exports, "useForgeActions", () => $dcae2a1bd36bdf24$export$4f3ebb446fd03f21);
$parcel$export(module.exports, "useForgeLoadingFailed", () => $dcae2a1bd36bdf24$export$25b2fc6a75c5447b);
$parcel$export(module.exports, "useForgeUimModules", () => $dcae2a1bd36bdf24$export$37d5ed3ba137e5df);
$parcel$export(module.exports, "useHasBlockedExtensions", () => $dcae2a1bd36bdf24$export$955dca49c49bfb60);
$parcel$export(module.exports, "useBlockedExtensions", () => $dcae2a1bd36bdf24$export$61349d0d8e89be3);
$parcel$export(module.exports, "useIsForgeDataEmpty", () => $dcae2a1bd36bdf24$export$57f2fa4b04feb8c2);

var $eUqFw = parcelRequire("eUqFw");

var $kFGm5 = parcelRequire("kFGm5");

var $ala54 = parcelRequire("ala54");

var $2W5Mi = parcelRequire("2W5Mi");
const $dcae2a1bd36bdf24$export$dc79f3e7b8a6c3e1 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return [
        forge.issueGlance
    ];
};
const $dcae2a1bd36bdf24$export$a1a589b738ca01b8 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return [
        forge.issueContext
    ];
};
const $dcae2a1bd36bdf24$export$db75d05b888b2963 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return [
        forge.isForgeDataComplete
    ];
};
const $dcae2a1bd36bdf24$export$1a3a35919478733d = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return [
        [
            ...forge.customField,
            ...forge.customFieldType
        ]
    ];
};
const $dcae2a1bd36bdf24$export$2a006c08e9ab6fc3 = (extensionId)=>{
    const [customFieldExtensions] = $dcae2a1bd36bdf24$export$1a3a35919478733d();
    return (0, $ala54.useMemoizedStateObject)((0, $eUqFw.useMemo)(()=>customFieldExtensions.find((ext)=>ext.id === extensionId), [
        customFieldExtensions,
        extensionId
    ]));
};
const $dcae2a1bd36bdf24$export$4f3ebb446fd03f21 = ()=>{
    const [, actions] = (0, $2W5Mi.useForgeActionsStore)();
    return [
        undefined,
        actions
    ];
};
const $dcae2a1bd36bdf24$export$25b2fc6a75c5447b = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return forge.isForgeLoadingFailed;
};
const $dcae2a1bd36bdf24$export$37d5ed3ba137e5df = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return forge.uiModifications;
};
const $dcae2a1bd36bdf24$export$955dca49c49bfb60 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return (0, $eUqFw.useMemo)(()=>forge.blockedExtensions ? Object.values((0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(forge.blockedExtensions, [
            'jiraIssueViewBackgroundScript',
            'jiraUiModifications'
        ])).some((blockedExtensions)=>blockedExtensions.length > 0) : false, [
        forge.blockedExtensions
    ]);
};
const $dcae2a1bd36bdf24$export$61349d0d8e89be3 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return forge.blockedExtensions;
};
const $dcae2a1bd36bdf24$export$57f2fa4b04feb8c2 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    const isExtensionsEmpty = Object.keys(forge).every((key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        Array.isArray(forge[key]) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        forge[key].length === 0 : true);
    const isBlockedExtensionsEmpty = Object.keys(forge.blockedExtensions).every(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (key)=>forge.blockedExtensions[key].length === 0);
    return isExtensionsEmpty && isBlockedExtensionsEmpty;
};

});
parcelRegister("ala54", function(module, exports) {

$parcel$export(module.exports, "useMemoizedStateObject", () => $18a93586b800a37c$export$cc725e2aa41de44a);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");
const $18a93586b800a37c$export$cc725e2aa41de44a = (data, equalityCheck = (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))))=>{
    const memoizedData = (0, $eUqFw.useRef)(data);
    return (0, $eUqFw.useMemo)(()=>{
        if (!equalityCheck(data, memoizedData.current)) {
            memoizedData.current = data;
            return data;
        }
        return memoizedData.current;
    }, [
        data,
        equalityCheck
    ]);
};

});

parcelRegister("2W5Mi", function(module, exports) {

$parcel$export(module.exports, "useForgeStore", () => $f3300ca6503131e5$export$10f3118dc1498dfc);
$parcel$export(module.exports, "useForgeActionsStore", () => $f3300ca6503131e5$export$7dd6be1114d73937);
$parcel$export(module.exports, "ForceStoreContainer", () => $f3300ca6503131e5$export$540c057b33607be9);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $eazmh = parcelRequire("eazmh");
const $f3300ca6503131e5$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-view-layout-forge-apps-service',
    initialState: {
        issueGlance: [],
        issueContext: [],
        issueAction: [],
        issuePanel: [],
        issueActivity: [],
        customField: [],
        issueViewBackgroundScript: [],
        customFieldType: [],
        activeAction: null,
        uiModifications: [],
        isForgeLoadingFailed: false,
        isForgeDataComplete: false,
        blockedExtensions: {
            issueGlance: [],
            issueContext: [],
            issueAction: [],
            issuePanel: [],
            issueActivity: [],
            customField: [],
            issueViewBackgroundScript: [],
            customFieldType: [],
            uiModifications: []
        },
        // Not rate limited
        forgeRateLimitedUntil: 0,
        failedEventsCount: 0
    },
    actions: $eazmh
});
const $f3300ca6503131e5$export$10f3118dc1498dfc = (0, $ggKAj.createHook)($f3300ca6503131e5$export$6f57813fe9f31bf9);
const $f3300ca6503131e5$export$7dd6be1114d73937 = (0, $ggKAj.createHook)($f3300ca6503131e5$export$6f57813fe9f31bf9, {
    selector: null
});
const $f3300ca6503131e5$export$540c057b33607be9 = (0, $heB5U.createContainer)($f3300ca6503131e5$export$6f57813fe9f31bf9);

});
parcelRegister("eazmh", function(module, exports) {

$parcel$export(module.exports, "setForge", () => $4b1f8e23931858cc$export$8307a9da1b91b3b4);
$parcel$export(module.exports, "setForgeLoadingFailed", () => $4b1f8e23931858cc$export$7ff580b28fd472d0);
$parcel$export(module.exports, "setFailedEventsCount", () => $4b1f8e23931858cc$export$2c9ac2591e62f664);
$parcel$export(module.exports, "isForgeRateLimited", () => $4b1f8e23931858cc$export$161809ef1d8417c5);

var $7wgLf = parcelRequire("7wgLf");
const $4b1f8e23931858cc$export$8307a9da1b91b3b4 = (forge)=>({ setState: setState })=>{
        setState(forge);
    };
const $4b1f8e23931858cc$export$7ff580b28fd472d0 = ()=>({ setState: setState })=>{
        setState({
            isForgeLoadingFailed: true
        });
    };
const $4b1f8e23931858cc$export$2c9ac2591e62f664 = (param)=>({ setState: setState, getState: getState })=>{
        if (typeof param === 'function') {
            const currentFailedEventsCount = getState().failedEventsCount;
            const result = param(currentFailedEventsCount);
            setState({
                failedEventsCount: result,
                forgeRateLimitedUntil: (0, $7wgLf.calculateRateLimitedUntil)(result)
            });
            return;
        }
        setState({
            failedEventsCount: param,
            forgeRateLimitedUntil: (0, $7wgLf.calculateRateLimitedUntil)(param)
        });
    };
const $4b1f8e23931858cc$export$161809ef1d8417c5 = ()=>({ getState: getState })=>{
        const state = getState();
        const throttleTime = state.forgeRateLimitedUntil - Date.now();
        return throttleTime > 0;
    };

});
parcelRegister("7wgLf", function(module, exports) {

$parcel$export(module.exports, "calculateRateLimitedUntil", () => $169737d2797a25da$export$d47414e51d623595);
/**
 * Defines the time gaps between retries in seconds for rate limited requests.
 * The first value is 0, because the first retry should be immediate.
 */ const $169737d2797a25da$export$565f18fa3aa433b0 = [
    0,
    3,
    8,
    21
];
function $169737d2797a25da$export$d47414e51d623595(failedEventsCount) {
    const currentDate = new Date();
    const gap = $169737d2797a25da$export$565f18fa3aa433b0[Math.min($169737d2797a25da$export$565f18fa3aa433b0.length - 1, failedEventsCount)];
    return gap ? new Date(currentDate.getTime() + gap * 1000).getTime() : 0;
}

});




const $fe92e572161b5748$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';

parcelRegister("g8to1", function(module, exports) {

$parcel$export(module.exports, "getPanels", () => $55eb035be1758949$export$be078297eeb6e8a2);
$parcel$export(module.exports, "isEmpty", () => $55eb035be1758949$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "getAtlassianCustomFieldType", () => $55eb035be1758949$export$f521834fc2bfcd81);
$parcel$export(module.exports, "fieldTypeHandler", () => $55eb035be1758949$export$b2cc0ead6ce019e3);
$parcel$export(module.exports, "getFieldType", () => $55eb035be1758949$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isUnsupportedItem", () => $55eb035be1758949$export$3d38168d24278ebb);

var $1c8hB = parcelRequire("1c8hB");

var $ldoFd = parcelRequire("ldoFd");

var $jtsd5 = parcelRequire("jtsd5");

var $4K830 = parcelRequire("4K830");

var $1ybV0 = parcelRequire("1ybV0");

var $bLiXo = parcelRequire("bLiXo");

var $4faf8 = parcelRequire("4faf8");

var $f9RL0 = parcelRequire("f9RL0");

var $dZWHl = parcelRequire("dZWHl");

var $lO4Or = parcelRequire("lO4Or");
const $55eb035be1758949$export$272b07e3e852ec4 = [
    (0, $f9RL0.DEV_SUMMARY),
    (0, $f9RL0.SLA_PANEL),
    (0, $f9RL0.KNOWLEDGE_BASE),
    (0, $f9RL0.ASSET_ONBOARDING),
    (0, $f9RL0.SENTIMENT)
];
const $55eb035be1758949$export$be078297eeb6e8a2 = ()=>[
        ...$55eb035be1758949$export$272b07e3e852ec4,
        (0, $f9RL0.LINKED_ALERTS),
        ...(0, $4K830.isFedRamp)() ? [] : [
            (0, $f9RL0.CHAT_CHANNEL)
        ],
        ...(0, $4K830.isFedRamp)() ? [] : [
            (0, $f9RL0.MSTEAMS_CHANNEL)
        ],
        ...(0, $4K830.isFedRamp)() ? [] : [
            (0, $f9RL0.ZOOM_MEETING)
        ],
        (0, $f9RL0.MANAGE_STAKEHOLDERS),
        ...(0, $1ybV0.ff)('hide-icc-for-all-users_avyh5') ? [] : [
            (0, $f9RL0.CONFERENCE_CALL)
        ]
    ];
const $55eb035be1758949$export$dd1bc94b04021eeb = (value)=>{
    if ((0, $1ybV0.ff)('fix-for-jracloud-82752_e3pl6')) return (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) || (0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(value) && value.length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($jtsd5)))(value) && Object.keys(value).length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($jtsd5)))(value) && value.type === 'doc' && value.content && Object.keys(value.content).length === 0;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) || (0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(value) && value.length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($jtsd5)))(value) && Object.keys(value).length === 0;
};
const $55eb035be1758949$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $f9RL0.specialFields)();
    return [
        ...(0, $f9RL0.customFieldsToDisplay)().filter((cf)=>!(0, $f9RL0.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $lO4Or.FLAGGED_CF_TYPE)
    ];
};
const $55eb035be1758949$export$f521834fc2bfcd81 = (custom)=>$55eb035be1758949$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $55eb035be1758949$export$b2cc0ead6ce019e3 = (fieldConfig, layoutItem)=>{
    const id = (0, $dZWHl.getLayoutItemId)(layoutItem);
    const { type: type } = layoutItem;
    if (type === (0, $bLiXo.layoutContainerItemTypes).tab || type === (0, $lO4Or.ECOSYSTEM_GLANCE_TYPE) || type === (0, $lO4Or.FORGE_GLANCE_TYPE) || type === (0, $lO4Or.ECOSYSTEM_CONTEXT_TYPE) || type === (0, $bLiXo.FORGE_CONTEXT_TYPE)) return {
        type: type,
        id: id
    };
    if ($55eb035be1758949$export$be078297eeb6e8a2().includes(id)) return {
        id: id,
        type: id
    };
    const forgeCustomField = (0, $4faf8.getForgeFieldType)(fieldConfig);
    if (forgeCustomField !== null) return {
        type: forgeCustomField,
        id: id
    };
    const fieldSchema = fieldConfig?.schema || {};
    const systemType = fieldSchema.system !== null ? fieldSchema.system : '';
    return {
        type: $55eb035be1758949$export$f521834fc2bfcd81(fieldSchema.custom) || systemType || fieldSchema.type,
        id: id
    };
};
const $55eb035be1758949$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $55eb035be1758949$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
// This typing exists to ensure that we include fields here when adding new ones.
const $55eb035be1758949$var$BASE_SUPPORTED_ITEMS = {
    // @ts-expect-error - TS2322 - Type '{ ecosystemGlance: boolean; forgeGlance: boolean; "com.pyxis.greenhopper.jira:gh-epic-status": true; "com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect": true; assignee: true; ... 75 more ...; "com.pyxis.greenhopper.jira:gh-epic-label": true; }' is not assignable to type 'CheckFieldTypeDefinitions<CheckedLegacyFieldTypeDefinitions<boolean>, IgnoredFieldChecks<boolean>>'.
    [(0, $lO4Or.ECOSYSTEM_GLANCE_TYPE)]: true,
    [(0, $lO4Or.FORGE_GLANCE_TYPE)]: true,
    [(0, $bLiXo.FORGE_CONTEXT_TYPE)]: true,
    [(0, $lO4Or.ECOSYSTEM_CONTEXT_TYPE)]: true,
    [(0, $lO4Or.EPIC_STATUS_TYPE)]: true,
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: true,
    [(0, $lO4Or.REPORTER_TYPE)]: true,
    [(0, $lO4Or.DESCRIPTION_TYPE)]: true,
    [(0, $lO4Or.ENVIRONMENT_TYPE)]: true,
    [(0, $lO4Or.DUE_DATE_TYPE)]: true,
    [(0, $lO4Or.PRIORITY_TYPE)]: true,
    [(0, $lO4Or.LABELS_TYPE)]: true,
    [(0, $lO4Or.COMPONENTS_TYPE)]: true,
    [(0, $lO4Or.SPRINT_TYPE)]: true,
    [(0, $lO4Or.STORY_POINTS_TYPE)]: true,
    [(0, $lO4Or.EPIC_TYPE)]: true,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: true,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: true,
    [(0, $lO4Or.TIME_TRACKING_TYPE)]: true,
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: true,
    [(0, $lO4Or.LABELS_CF_TYPE)]: true,
    [(0, $lO4Or.TEXT_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: true,
    [(0, $lO4Or.PARTICIPANTS_CF_TYPE)]: true,
    [(0, $lO4Or.URL_CF_TYPE)]: true,
    [(0, $lO4Or.NUMBER_CF_TYPE)]: true,
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: true,
    [(0, $lO4Or.SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.VERSION_CF_TYPE)]: true,
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: true,
    [(0, $lO4Or.DATE_CF_TYPE)]: true,
    [(0, $lO4Or.GROUP_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: true,
    [(0, $lO4Or.USER_CF_TYPE)]: true,
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: true,
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: true,
    [(0, $lO4Or.DATETIME_CF_TYPE)]: true,
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: true,
    [(0, $lO4Or.TEAM_CF_TYPE)]: true,
    [(0, $lO4Or.PARENT_CF_TYPE)]: true,
    [(0, $lO4Or.PARENT_FIELD_TYPE)]: true,
    [(0, $lO4Or.BASELINE_START_CF_TYPE)]: true,
    [(0, $lO4Or.BASELINE_END_CF_TYPE)]: true,
    [(0, $lO4Or.COLOR_CF_TYPE)]: true,
    [(0, $lO4Or.REQUEST_TYPE_CF_TYPE)]: true,
    [(0, $lO4Or.APPROVALS_CF_TYPE)]: true,
    [(0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE)]: true,
    [(0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE)]: true,
    [(0, $lO4Or.ORGANIZATIONS_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE)]: true,
    [(0, $lO4Or.ASSETS_CF_TYPE)]: true,
    [(0, $lO4Or.SERVICE_ENTITY_CF_TYPE)]: true,
    [(0, $lO4Or.APPROVERS_LIST_CF_TYPE)]: true,
    [(0, $lO4Or.CMDB_OBJECT_CF_TYPE)]: true,
    [(0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_GROUPS_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_STRINGS_CF_TYPE)]: true,
    [(0, $lO4Or.READ_ONLY_CF_TYPE)]: true,
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: true,
    [(0, $lO4Or.FORGE_CUSTOM_FIELD_TYPE)]: true,
    [(0, $lO4Or.KNOWLEDGE_BASE_TYPE)]: true,
    [(0, $lO4Or.SLA_PANEL_TYPE)]: true,
    [(0, $lO4Or.SENTIMENT_TYPE)]: true,
    [(0, $lO4Or.DEV_SUMMARY_TYPE)]: true,
    [(0, $lO4Or.RELEASES_TYPE)]: true,
    [(0, $lO4Or.ASSET_ONBOARDING_TYPE)]: true,
    [(0, $lO4Or.LINKED_ALERTS_TYPE)]: true,
    [(0, $lO4Or.CHAT_CHANNEL_TYPE)]: !(0, $4K830.isFedRamp)(),
    [(0, $lO4Or.MSTEAMS_CHANNEL_TYPE)]: !(0, $4K830.isFedRamp)(),
    [(0, $lO4Or.ZOOM_MEETING_TYPE)]: !(0, $4K830.isFedRamp)(),
    [(0, $lO4Or.MANAGE_STAKEHOLDERS_TYPE)]: true,
    // eslint-disable-next-line jira/ff/no-module-level-eval
    [(0, $lO4Or.CONFERENCE_CALL_TYPE)]: !(0, $1ybV0.ff)('hide-icc-for-all-users_avyh5'),
    [(0, $lO4Or.RESPONDERS_CF_TYPE)]: true,
    [(0, $lO4Or.MAJOR_INCIDENT_CF_TYPE)]: true,
    [(0, $lO4Or.MESSAGE_EDIT_CF_TYPE)]: true,
    [(0, $lO4Or.MESSAGE_VIEW_CF_TYPE)]: true,
    [(0, $lO4Or.EPIC_NAME_TYPE)]: true,
    [(0, $lO4Or.CATEGORY_TYPE)]: true,
    [(0, $lO4Or.ENTITLEMENT_CF_TYPE)]: true,
    [(0, $lO4Or.GOALS_CF_TYPE)]: true
};
const $55eb035be1758949$export$3d38168d24278ebb = (type)=>!$55eb035be1758949$var$BASE_SUPPORTED_ITEMS[type];

});
parcelRegister("dZWHl", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemId", () => $b8d413cf2e7e532a$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $b8d413cf2e7e532a$export$355607dae809ec65);

var $bLiXo = parcelRequire("bLiXo");
const $b8d413cf2e7e532a$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $bLiXo.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $bLiXo.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $bLiXo.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $b8d413cf2e7e532a$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($b8d413cf2e7e532a$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $bLiXo.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $b8d413cf2e7e532a$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});



parcelRegister("8CSFK", function(module, exports) {

$parcel$export(module.exports, "ecosystemBackgroundScriptsSelector", () => $ed8f699fce32689f$export$4bf619a76f77f026);
$parcel$export(module.exports, "issueViewBackgroundScriptsSelector", () => $ed8f699fce32689f$export$eef935056c1a5112);
$parcel$export(module.exports, "issueContentPanelsSelector", () => $ed8f699fce32689f$export$80fcdb58a34c02a8);
$parcel$export(module.exports, "isIssueContentPanelCustomisedSelector", () => $ed8f699fce32689f$export$7d77b0f1f3d84166);
$parcel$export(module.exports, "canInstallAddonsSelector", () => $ed8f699fce32689f$export$779e1275bbd7ba59);
$parcel$export(module.exports, "isIssueCreatedAfterEcosystemOnSelector", () => $ed8f699fce32689f$export$528e2c054f1a65f6);
$parcel$export(module.exports, "contextPanelEntitiesSelector", () => $ed8f699fce32689f$export$830512515d42357);
$parcel$export(module.exports, "glancesSelector", () => $ed8f699fce32689f$export$d73d3447fc053be);
$parcel$export(module.exports, "ecosystemGlancesSelector", () => $ed8f699fce32689f$export$df7140249f849373);
$parcel$export(module.exports, "glancePanelSelector", () => $ed8f699fce32689f$export$e8938da368c7c5c4);
$parcel$export(module.exports, "allContentPanelsSelector", () => $ed8f699fce32689f$export$7bc028a03185fc96);
$parcel$export(module.exports, "ecosystemAllPanelsSelector", () => $ed8f699fce32689f$export$47d3fa7df862ae6f);
$parcel$export(module.exports, "activitiesComparator", () => $ed8f699fce32689f$export$b2c15e41218fc96);
$parcel$export(module.exports, "ecosystemAddedContentPanelsSelector", () => $ed8f699fce32689f$export$a48c28ad36cb708e);
$parcel$export(module.exports, "selectedContentPanelSelector", () => $ed8f699fce32689f$export$1a9c93efcb1ffec7);
$parcel$export(module.exports, "operationsSelector", () => $ed8f699fce32689f$export$5244c0030b3a418e);
$parcel$export(module.exports, "ecosystemOperationsSelector", () => $ed8f699fce32689f$export$5d88ae12b2751fc1);
$parcel$export(module.exports, "activityPanelsSelector", () => $ed8f699fce32689f$export$dd6c9850f9e61a72);
$parcel$export(module.exports, "ecosystemActivityPanelsSelector", () => $ed8f699fce32689f$export$9222e43f5478367f);

var $df4Sl = parcelRequire("df4Sl");

var $6ZDS2 = parcelRequire("6ZDS2");

var $gdPSX = parcelRequire("gdPSX");

var $7C4za = parcelRequire("7C4za");

var $fkvsU = parcelRequire("fkvsU");

var $duMa0 = parcelRequire("duMa0");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");


var $9Hrk7 = parcelRequire("9Hrk7");

var $8QKSg = parcelRequire("8QKSg");
const $ed8f699fce32689f$export$4bf619a76f77f026 = (0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>ecosystem.backgroundScripts || []);
const $ed8f699fce32689f$export$eef935056c1a5112 = (0, $df4Sl.createSelector)((0, $9Hrk7.forgeEntitiesSelector), (forge)=>forge.backgroundScripts || []);
const $ed8f699fce32689f$export$80fcdb58a34c02a8 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.issueContentPanels || []);
const $ed8f699fce32689f$export$7d77b0f1f3d84166 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>!!entities.issueContentPanels && entities.issueContentPanels.includes((0, $6c91ecd17276581e$export$bdafa6b589be8b30)));
const $ed8f699fce32689f$export$779e1275bbd7ba59 = (0, $df4Sl.createSelector)((0, $9F6MO.canAdministerJiraPermissionsSelector), (canAdministerJira)=>canAdministerJira);
const $ed8f699fce32689f$export$528e2c054f1a65f6 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.ecosystem && !!entities.ecosystem.ecosystemOnDate && // @ts-expect-error - TS2345 - Argument of type 'AuthoredTimestamp | undefined' is not assignable to parameter of type 'string'.
    Date.parse(entities.createdDate) > entities.ecosystem.ecosystemOnDate);
const $ed8f699fce32689f$var$extractSecondLevelDeepValuesFromObject = (obj)=>Object.keys(obj || {}).flatMap((key)=>Object.values(obj ? obj[key] : {}));
const $ed8f699fce32689f$var$glanceEntitiesSelector = (0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>$ed8f699fce32689f$var$extractSecondLevelDeepValuesFromObject(ecosystem.glances || {}));
const $ed8f699fce32689f$export$830512515d42357 = (0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>$ed8f699fce32689f$var$extractSecondLevelDeepValuesFromObject(ecosystem.contextPanels));
const $ed8f699fce32689f$var$contentPanelsEntitiesSelector = (0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>$ed8f699fce32689f$var$extractSecondLevelDeepValuesFromObject(ecosystem.contentPanels));
const $ed8f699fce32689f$var$activityPanelsEntitiesSelector = (0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>$ed8f699fce32689f$var$extractSecondLevelDeepValuesFromObject(ecosystem.activityPanels || {}));
const $ed8f699fce32689f$export$7fec16e3d5cd5f4e = (selector)=>(0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), selector, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (ecosystemEnabled, otherSelector)=>ecosystemEnabled && otherSelector || []);
const $ed8f699fce32689f$export$d73d3447fc053be = $ed8f699fce32689f$export$7fec16e3d5cd5f4e((0, $df4Sl.createSelector)($ed8f699fce32689f$var$glanceEntitiesSelector, (glanceEntities)=>glanceEntities.map((entity)=>({
            appKey: entity.appKey,
            moduleKey: entity.moduleKey,
            name: entity.name,
            icon: entity.icon && entity.icon.url && {
                url: entity.icon.url
            },
            label: entity.label,
            status: entity.status,
            type: entity.type,
            glanceType: (0, $fkvsU.CONNECT_ENTITY_TYPE)
        }))));
const $ed8f699fce32689f$export$df7140249f849373 = (0, $df4Sl.createSelector)([
    (0, $8QKSg.forgeGlancesSelector),
    $ed8f699fce32689f$export$d73d3447fc053be
], (forge, connect)=>[
        ...forge,
        ...connect
    ]);
const $ed8f699fce32689f$export$e8938da368c7c5c4 = (appKey, moduleKey)=>(0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.glances && ecosystem.glances[appKey] && ecosystem.glances[appKey][moduleKey]);
const $ed8f699fce32689f$export$7bc028a03185fc96 = $ed8f699fce32689f$export$7fec16e3d5cd5f4e((0, $df4Sl.createSelector)($ed8f699fce32689f$var$contentPanelsEntitiesSelector, (contentPanelEntities)=>contentPanelEntities));
const $ed8f699fce32689f$export$47d3fa7df862ae6f = (0, $df4Sl.createSelector)([
    (0, $8QKSg.forgePanelsSelector),
    $ed8f699fce32689f$export$7bc028a03185fc96
], (forge, connect)=>[
        ...forge,
        ...connect
    ]);
const $ed8f699fce32689f$var$panelsComparator = (firstPanel, secondPanel)=>{
    // The sort order rule:
    // 1. Forge panels without quick add button (no dateAdded prop)
    // 2. Forge panels sorted by date added (oldest > newest)
    // 3. Connect panels, sorting criteria won't be changed
    if (firstPanel.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
        // @ts-expect-error - TS2339 - Property 'dateAdded' does not exist on type 'AddedPanel'.
        const firstValue = firstPanel.dateAdded || 1;
        if (secondPanel.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
            // @ts-expect-error - TS2339 - Property 'dateAdded' does not exist on type 'AddedPanel'.
            const secondValue = secondPanel.dateAdded || 1;
            return firstValue - secondValue;
        }
        return firstValue;
    }
    return Infinity;
};
const $ed8f699fce32689f$var$sortPanels = (allPanelsToAddedPanels)=>allPanelsToAddedPanels// @ts-expect-error - TS2769 - No overload matches this call.
    .map((panel)=>[].concat(panel)).sort((firstPanel, secondPanel)=>$ed8f699fce32689f$var$panelsComparator(firstPanel[0], secondPanel[0]));
const $ed8f699fce32689f$export$b2c15e41218fc96 = (firstActivity, secondActivity)=>{
    // The sort order rule:
    // 1. Forge activity ordered alphabetically.
    // 2. Connect panels, sorting criteria won't be changed
    if (firstActivity.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
        const firstValue = firstActivity.name.toLowerCase();
        if (secondActivity.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
            const secondValue = secondActivity.name.toLowerCase();
            if (firstValue < secondValue) return -Infinity;
            if (firstValue > secondValue) return Infinity;
            return 0;
        }
        return Infinity;
    }
    return Infinity;
};
const $ed8f699fce32689f$export$a48c28ad36cb708e = $ed8f699fce32689f$export$7fec16e3d5cd5f4e((0, $df4Sl.createSelector)($ed8f699fce32689f$export$80fcdb58a34c02a8, $ed8f699fce32689f$export$47d3fa7df862ae6f, $ed8f699fce32689f$export$7d77b0f1f3d84166, $ed8f699fce32689f$export$528e2c054f1a65f6, (0, $5JqpU.analyticsSourceSelector), (selectedPanels, allPanels, customised, newIssue, analyticsSource)=>{
    const allPanelsToAddedPanels = allPanels.map((panel)=>{
        // Forge-defined panels
        if (panel.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const forgePanel = panel;
            // For a transition period we always render panels without a quick add button
            if (!forgePanel.iconUrl) return forgePanel;
            const prefix = `${forgePanel.appKey}/${forgePanel.moduleKey}-`;
            const filteredSelectedPanels = selectedPanels.filter((sPanel)=>(0, $7C4za.isKeyMatchPrefix)(sPanel, prefix)).map((sPanel)=>{
                const panelProperties = (0, $duMa0.parseForgeIssuePanel)(sPanel);
                if (panelProperties == null) (0, $gdPSX.fireOperationalFailedEvent)(analyticsSource, {
                    error: Error(`Panel key doesn't match regexp: ${sPanel}`)
                });
                return panelProperties && {
                    ...forgePanel,
                    dateAdded: panelProperties.added,
                    panelInstanceId: panelProperties.id
                };
            }).filter(Boolean);
            return filteredSelectedPanels.length > 0 && filteredSelectedPanels;
        }
        // Connect-defined panels
        if (!customised && !newIssue) return panel;
        const isSelected = selectedPanels.includes(`${panel.appKey}_${panel.moduleKey}`) || // BENTO-2491 SelectedPanels could be saved using keys without tailing digits
        selectedPanels.includes(`${panel.appKey}_${(0, $duMa0.removeTimestamp)(panel.moduleKey, 10)}`) || panel.showByDefault;
        return isSelected && panel;
    });
    const addedPanels = (0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))($ed8f699fce32689f$var$sortPanels(allPanelsToAddedPanels.filter(Boolean)));
    return addedPanels;
}));
const $ed8f699fce32689f$export$9f3aeb87662f360b = (appKey, moduleKey)=>(0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.contentPanels && ecosystem.contentPanels[appKey] && ecosystem.contentPanels[appKey][moduleKey]);
const $ed8f699fce32689f$export$1a9c93efcb1ffec7 = (appKey, moduleKey)=>(0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>Boolean(ecosystem && ecosystem.selectedContentPanel && (ecosystem.selectedContentPanel === `${appKey}_${moduleKey}` || ecosystem.selectedContentPanel === `${appKey}_${(0, $duMa0.removeTimestamp)(moduleKey, 10)}`)));
const $ed8f699fce32689f$export$5244c0030b3a418e = $ed8f699fce32689f$export$7fec16e3d5cd5f4e((0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>ecosystem.operations || []));
const $ed8f699fce32689f$export$5d88ae12b2751fc1 = $ed8f699fce32689f$export$7fec16e3d5cd5f4e((0, $df4Sl.createSelector)([
    (0, $8QKSg.forgeIssueActionsSelector),
    $ed8f699fce32689f$export$5244c0030b3a418e
], (forge, connect)=>[
        ...forge,
        ...connect
    ]));
const $ed8f699fce32689f$export$dd6c9850f9e61a72 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), $ed8f699fce32689f$var$activityPanelsEntitiesSelector, (isEcosystemEnabled, activityPanelEntities)=>isEcosystemEnabled ? activityPanelEntities.map((entity)=>({
            name: entity.name,
            appKey: entity.appKey,
            moduleKey: entity.moduleKey,
            options: entity.options,
            type: (0, $fkvsU.CONNECT_ENTITY_TYPE)
        })) : []);
const $ed8f699fce32689f$export$9222e43f5478367f = (0, $df4Sl.createSelector)([
    (0, $8QKSg.forgeIssueActivitySelector),
    $ed8f699fce32689f$export$dd6c9850f9e61a72
], (forge, connect)=>[
        ...forge,
        ...connect
    ].sort($ed8f699fce32689f$export$b2c15e41218fc96));

});
parcelRegister("gdPSX", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $efc14f04fccc55bd$export$add44f896fb31ba3);
$parcel$export(module.exports, "fireUiActionClickedEvent", () => $efc14f04fccc55bd$export$a645c87ca2607d94);
$parcel$export(module.exports, "fireTrackActionSucceedEvent", () => $efc14f04fccc55bd$export$435f030e21a120be);
$parcel$export(module.exports, "fireOperationalActionFailedEvent", () => $efc14f04fccc55bd$export$828a66ad00e9a886);
$parcel$export(module.exports, "fireTrackSavedEvent", () => $efc14f04fccc55bd$export$1dbf5d2537a38bd8);
$parcel$export(module.exports, "fireOperationalSaveFailedEvent", () => $efc14f04fccc55bd$export$cda76554fa8eee1d);
$parcel$export(module.exports, "fireUiRemoveClickedEvent", () => $efc14f04fccc55bd$export$2e4d409fc887e7e);
$parcel$export(module.exports, "fireTrackRemovedEvent", () => $efc14f04fccc55bd$export$daf10221407e1b30);
$parcel$export(module.exports, "fireOperationalRemoveFailedEvent", () => $efc14f04fccc55bd$export$d12e864ea545eb36);
$parcel$export(module.exports, "fireUiTriggerSelectedEvent", () => $efc14f04fccc55bd$export$4d7a3fdb2dd15cbb);
$parcel$export(module.exports, "fireUiCollapseExpandClickedEvent", () => $efc14f04fccc55bd$export$c157193e598947ac);
$parcel$export(module.exports, "fireTrackUpdateSucceedEvent", () => $efc14f04fccc55bd$export$98e4a25792520246);
$parcel$export(module.exports, "fireOperationalUpdateFailedEvent", () => $efc14f04fccc55bd$export$9ee09996d253231a);

var $2Rqjr = parcelRequire("2Rqjr");

var $8XU7c = parcelRequire("8XU7c");

var $cYWDh = parcelRequire("cYWDh");

var $d6g7g = parcelRequire("d6g7g");

var $hRcYT = parcelRequire("hRcYT");
const $efc14f04fccc55bd$var$moduleEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.ISSUE_PANEL_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_EXTENSION)
});
const $efc14f04fccc55bd$var$triggerEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.ISSUE_PANEL_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER)
});
const $efc14f04fccc55bd$export$add44f896fb31ba3 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).FAILED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$a645c87ca2607d94 = (source, attributes)=>(0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).ACTION_CLICKED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$435f030e21a120be = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).ACTION_SUCCEED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$828a66ad00e9a886 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).ACTION_FAILED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$1dbf5d2537a38bd8 = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).SAVED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$cda76554fa8eee1d = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).SAVE_FAILED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$2e4d409fc887e7e = (source, attributes)=>(0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).REMOVE_CLICKED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$daf10221407e1b30 = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).REMOVED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$d12e864ea545eb36 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).REMOVE_FAILED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$4d7a3fdb2dd15cbb = (source, attributes)=>{
    (0, $d6g7g.forgeModulesLoadTime).start({
        startTime: performance.now()
    });
    return (0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).SELECTED, {
        id: $efc14f04fccc55bd$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};
const $efc14f04fccc55bd$export$c157193e598947ac = (source, attributes)=>(0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).COLLAPSE_EXPAND_CLICKED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$98e4a25792520246 = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).UPDATE_SUCCEED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$9ee09996d253231a = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).UPDATE_FAILED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });

});
parcelRegister("2Rqjr", function(module, exports) {

$parcel$export(module.exports, "STAGING_ENVIRONMENT", () => $24e2ca1817bcdc8d$export$71acbd662c478c42);
$parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", () => $24e2ca1817bcdc8d$export$978072fd3fd149);
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", () => $24e2ca1817bcdc8d$export$ebc15d9cebfd6063);
$parcel$export(module.exports, "ISSUE_ACTION_MODULE", () => $24e2ca1817bcdc8d$export$fcc4a18f46f80f16);
$parcel$export(module.exports, "ISSUE_GLANCE_MODULE", () => $24e2ca1817bcdc8d$export$259bab989b0129d0);
$parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", () => $24e2ca1817bcdc8d$export$75f224942f595e13);
$parcel$export(module.exports, "ISSUE_PANEL_MODULE", () => $24e2ca1817bcdc8d$export$ba0968f9752844);
$parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", () => $24e2ca1817bcdc8d$export$cc20a5638825fbb0);
$parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", () => $24e2ca1817bcdc8d$export$9069d4b945c3d532);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $24e2ca1817bcdc8d$export$811b7f067a43b422);
$parcel$export(module.exports, "CUSTOM_FIELD_MODULE", () => $24e2ca1817bcdc8d$export$e3887d6bafe8a17);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", () => $24e2ca1817bcdc8d$export$7b7866c04a2ad947);
$parcel$export(module.exports, "ADMIN_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$52e4945e96bd2aa0);
$parcel$export(module.exports, "PROJECT_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$151b03356f566603);
$parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$ea0d6ac082b0d636);
$parcel$export(module.exports, "GLOBAL_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$31ac745ab2add7cc);
$parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", () => $24e2ca1817bcdc8d$export$353acf28daa75c79);
$parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", () => $24e2ca1817bcdc8d$export$25627f012b21b0b9);
$parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", () => $24e2ca1817bcdc8d$export$42d6a8740fd42e58);
$parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", () => $24e2ca1817bcdc8d$export$a7186e5a73395db4);
$parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", () => $24e2ca1817bcdc8d$export$8fbcfe84dc845d17);
$parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$8af4cb794979f60d);
$parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", () => $24e2ca1817bcdc8d$export$5592ab836d562168);
$parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", () => $24e2ca1817bcdc8d$export$842eb4236828ac9);
$parcel$export(module.exports, "SUPPORTED_MODULES", () => $24e2ca1817bcdc8d$export$9b1a91242ce2a1b7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $24e2ca1817bcdc8d$export$2b8aeda236486576);
$parcel$export(module.exports, "ENTRY_POINT_VIEW", () => $24e2ca1817bcdc8d$export$c41ce1ec1ea6e73d);
$parcel$export(module.exports, "ENTRY_POINT_CREATE", () => $24e2ca1817bcdc8d$export$b37d58c3ed77c139);
$parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", () => $24e2ca1817bcdc8d$export$ab94dbd1d02ac251);
$parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", () => $24e2ca1817bcdc8d$export$b6a67a3131c6c48d);
$parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", () => $24e2ca1817bcdc8d$export$b75dc2bfd20898fe);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", () => $24e2ca1817bcdc8d$export$8e96118a698216cb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", () => $24e2ca1817bcdc8d$export$9b72a8e9b92658fb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", () => $24e2ca1817bcdc8d$export$2d6539e7d0553ae7);
$parcel$export(module.exports, "SOURCE_UNKNOWN", () => $24e2ca1817bcdc8d$export$ecbd7135d66cb322);
$parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", () => $24e2ca1817bcdc8d$export$61d882aa7aba51c);
$parcel$export(module.exports, "SOURCE_ISSUE_VIEW", () => $24e2ca1817bcdc8d$export$46cb92762d68a048);
$parcel$export(module.exports, "SOURCE_NAVIGATION", () => $24e2ca1817bcdc8d$export$fe90e46aea58e30b);
$parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", () => $24e2ca1817bcdc8d$export$c5ccbdb9893f2a6a);
$parcel$export(module.exports, "SOURCE_ROUTER", () => $24e2ca1817bcdc8d$export$eae46a3c13473a8d);
$parcel$export(module.exports, "SOURCE_LEGACY", () => $24e2ca1817bcdc8d$export$ac11ee191d09688f);
$parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", () => $24e2ca1817bcdc8d$export$4346e4e240c84319);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", () => $24e2ca1817bcdc8d$export$4b6228758e800433);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", () => $24e2ca1817bcdc8d$export$70495c8cc141a7a4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", () => $24e2ca1817bcdc8d$export$bc3d408418fdf9d2);
$parcel$export(module.exports, "EMPTY_EXTENSIONS_OBJECT", () => $24e2ca1817bcdc8d$export$a48dade1864725a);
$parcel$export(module.exports, "getEmptyExtensionsObject", () => $24e2ca1817bcdc8d$export$218a328f66b86f7d);
$parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", () => $24e2ca1817bcdc8d$export$3193d714ab54ee26);
$parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $24e2ca1817bcdc8d$export$df7774a415710cce);
$parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $24e2ca1817bcdc8d$export$51ab2784839ce348);
const $24e2ca1817bcdc8d$export$9af0088c49bdedb = 'PRODUCTION';
const $24e2ca1817bcdc8d$export$71acbd662c478c42 = 'STAGING';
const $24e2ca1817bcdc8d$export$978072fd3fd149 = 'DEVELOPMENT';
const $24e2ca1817bcdc8d$export$ebc15d9cebfd6063 = 'default';
const $24e2ca1817bcdc8d$export$fcc4a18f46f80f16 = 'jira:issueAction';
const $24e2ca1817bcdc8d$export$259bab989b0129d0 = 'jira:issueGlance';
const $24e2ca1817bcdc8d$export$75f224942f595e13 = 'jira:issueContext';
const $24e2ca1817bcdc8d$export$ba0968f9752844 = 'jira:issuePanel';
const $24e2ca1817bcdc8d$export$cc20a5638825fbb0 = 'jira:issueActivity';
const $24e2ca1817bcdc8d$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
const $24e2ca1817bcdc8d$export$811b7f067a43b422 = 'jira:uiModifications';
const $24e2ca1817bcdc8d$export$e3887d6bafe8a17 = 'jira:customField';
const $24e2ca1817bcdc8d$export$7b7866c04a2ad947 = 'jira:customFieldType';
const $24e2ca1817bcdc8d$export$52e4945e96bd2aa0 = 'jira:adminPage';
const $24e2ca1817bcdc8d$export$151b03356f566603 = 'jira:projectPage';
const $24e2ca1817bcdc8d$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
const $24e2ca1817bcdc8d$export$31ac745ab2add7cc = 'jira:globalPage';
const $24e2ca1817bcdc8d$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
const $24e2ca1817bcdc8d$export$25627f012b21b0b9 = 'jira:dashboardGadget';
const $24e2ca1817bcdc8d$export$42d6a8740fd42e58 = 'jira:workflowValidator';
const $24e2ca1817bcdc8d$export$a7186e5a73395db4 = 'jira:workflowCondition';
const $24e2ca1817bcdc8d$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
const $24e2ca1817bcdc8d$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
const $24e2ca1817bcdc8d$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
const $24e2ca1817bcdc8d$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
const $24e2ca1817bcdc8d$export$9b1a91242ce2a1b7 = [
    $24e2ca1817bcdc8d$export$fcc4a18f46f80f16,
    $24e2ca1817bcdc8d$export$259bab989b0129d0,
    $24e2ca1817bcdc8d$export$75f224942f595e13,
    $24e2ca1817bcdc8d$export$ba0968f9752844,
    $24e2ca1817bcdc8d$export$cc20a5638825fbb0,
    $24e2ca1817bcdc8d$export$9069d4b945c3d532,
    $24e2ca1817bcdc8d$export$811b7f067a43b422,
    $24e2ca1817bcdc8d$export$e3887d6bafe8a17,
    $24e2ca1817bcdc8d$export$7b7866c04a2ad947,
    $24e2ca1817bcdc8d$export$52e4945e96bd2aa0,
    $24e2ca1817bcdc8d$export$151b03356f566603,
    $24e2ca1817bcdc8d$export$ea0d6ac082b0d636,
    $24e2ca1817bcdc8d$export$31ac745ab2add7cc,
    $24e2ca1817bcdc8d$export$353acf28daa75c79,
    $24e2ca1817bcdc8d$export$25627f012b21b0b9,
    $24e2ca1817bcdc8d$export$8af4cb794979f60d,
    $24e2ca1817bcdc8d$export$5592ab836d562168,
    $24e2ca1817bcdc8d$export$842eb4236828ac9,
    $24e2ca1817bcdc8d$export$42d6a8740fd42e58,
    $24e2ca1817bcdc8d$export$a7186e5a73395db4,
    $24e2ca1817bcdc8d$export$8fbcfe84dc845d17
];
const $24e2ca1817bcdc8d$export$2b8aeda236486576 = 'edit';
const $24e2ca1817bcdc8d$export$c41ce1ec1ea6e73d = 'view';
const $24e2ca1817bcdc8d$export$b37d58c3ed77c139 = 'create';
const $24e2ca1817bcdc8d$export$ab94dbd1d02ac251 = 'contextConfig';
const $24e2ca1817bcdc8d$export$b6a67a3131c6c48d = 'none';
const $24e2ca1817bcdc8d$export$b75dc2bfd20898fe = 5;
const $24e2ca1817bcdc8d$export$8e96118a698216cb = 'native';
const $24e2ca1817bcdc8d$export$9b72a8e9b92658fb = 'basic';
const $24e2ca1817bcdc8d$export$2d6539e7d0553ae7 = 'blank';
const $24e2ca1817bcdc8d$export$ecbd7135d66cb322 = 'unknownSource';
const $24e2ca1817bcdc8d$export$61d882aa7aba51c = 'global-issue-create';
const $24e2ca1817bcdc8d$export$46cb92762d68a048 = 'issue-view';
const $24e2ca1817bcdc8d$export$fe90e46aea58e30b = 'navigation';
const $24e2ca1817bcdc8d$export$c5ccbdb9893f2a6a = 'full-page-app';
const $24e2ca1817bcdc8d$export$eae46a3c13473a8d = 'router';
const $24e2ca1817bcdc8d$export$ac11ee191d09688f = 'legacy';
const $24e2ca1817bcdc8d$export$6d00582aa947900f = 'workflow-list';
const $24e2ca1817bcdc8d$export$4346e4e240c84319 = 'organization-panel';
const $24e2ca1817bcdc8d$export$4b6228758e800433 = 'jira';
const $24e2ca1817bcdc8d$export$70495c8cc141a7a4 = 'jsm';
const $24e2ca1817bcdc8d$export$bc3d408418fdf9d2 = 'cmdb';
const $24e2ca1817bcdc8d$export$a48dade1864725a = {
    jiraIssueAction: [],
    jiraIssueContext: [],
    jiraIssueGlance: [],
    jiraIssuePanel: [],
    jiraIssueActivity: [],
    jiraIssueViewBackgroundScript: [],
    jiraCustomField: [],
    jiraCustomFieldType: [],
    jiraUiModifications: [],
    jiraAdminPage: [],
    jiraGlobalPage: [],
    jiraProjectPage: [],
    jiraProjectSettingsPage: [],
    jiraDashboardBackgroundScript: [],
    jiraDashboardGadget: [],
    jiraServiceManagementQueuePage: [],
    jiraServiceManagementOrganizationPanel: [],
    jiraServiceManagementAssetsImportType: [],
    jiraWorkflowValidator: [],
    jiraWorkflowCondition: [],
    jiraWorkflowPostFunction: []
};
/**
 * The above EMPTY_EXTENSIONS_OBJECT sometimes is mutated.
 * @see getEmptyExtensionsObject
 */ const $24e2ca1817bcdc8d$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
    ...$24e2ca1817bcdc8d$export$a48dade1864725a
};
const $24e2ca1817bcdc8d$export$218a328f66b86f7d = ()=>({
        ...$24e2ca1817bcdc8d$var$STABLE_EMPTY_EXTENSIONS_OBJECT
    });
const $24e2ca1817bcdc8d$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
const $24e2ca1817bcdc8d$export$df7774a415710cce = 'com.atlassian.forge:';
const $24e2ca1817bcdc8d$export$51ab2784839ce348 = `${$24e2ca1817bcdc8d$export$df7774a415710cce}${$24e2ca1817bcdc8d$export$3193d714ab54ee26}`;

});

parcelRegister("8XU7c", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $ea56d020133ed4ec$export$5639f6a927500d9);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $ea56d020133ed4ec$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getEventActionName", () => $ea56d020133ed4ec$export$644ccb9a67b9a9c1);

var $2Rqjr = parcelRequire("2Rqjr");

var $TrUS5 = parcelRequire("TrUS5");

var $hRcYT = parcelRequire("hRcYT");


var $eTZsp = parcelRequire("eTZsp");

var $d6g7g = parcelRequire("d6g7g");
const $ea56d020133ed4ec$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $ea56d020133ed4ec$var$prepareModuleMode = (entryPoint)=>`${$ea56d020133ed4ec$var$capitalizeFirstLetter(entryPoint)}`;
const $ea56d020133ed4ec$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $ea56d020133ed4ec$var$prepareModuleName = (moduleName)=>(0, $2Rqjr.SUPPORTED_MODULES).includes(moduleName) ? $ea56d020133ed4ec$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $ea56d020133ed4ec$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hRcYT.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $ea56d020133ed4ec$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>(0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
const $ea56d020133ed4ec$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hRcYT.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});
parcelRegister("TrUS5", function(module, exports) {

$parcel$export(module.exports, "toEventId", () => $157b5a46da0774f4$export$75e84ef5a3771f9a);
const $157b5a46da0774f4$export$75e84ef5a3771f9a = (value)=>value;

});

parcelRegister("eTZsp", function(module, exports) {

$parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", () => $11a471eb077355bb$export$23de3198bfe70090);
$parcel$export(module.exports, "FAILED_TO_FETCH", () => $11a471eb077355bb$export$f52aa41ccd776f01);
$parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", () => $11a471eb077355bb$export$31d2ab0be67934f0);
$parcel$export(module.exports, "RATE_LIMITING", () => $11a471eb077355bb$export$7a1bd8c001e7e9c);
$parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", () => $11a471eb077355bb$export$89a175d4190df42e);
$parcel$export(module.exports, "userConsentErrorRegex", () => $11a471eb077355bb$export$dddade71b333c01d);
$parcel$export(module.exports, "getErrorType", () => $11a471eb077355bb$export$e19f9f08a6d79fd2);

var $7rh0R = parcelRequire("7rh0R");


var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");
const $11a471eb077355bb$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504',
    GADGET_PREFERENCES: 'failed to put gadget preference: Error server response: 429'
};
const $11a471eb077355bb$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $11a471eb077355bb$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $11a471eb077355bb$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $11a471eb077355bb$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $11a471eb077355bb$export$89a175d4190df42e = 'Invoke value functions failed:';
const $11a471eb077355bb$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $11a471eb077355bb$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if ((0, $7rh0R.isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $11a471eb077355bb$export$e19f9f08a6d79fd2 = (error)=>{
    if (error == null) return 'NULL_OR_UNDEFINED';
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $11a471eb077355bb$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $11a471eb077355bb$export$23de3198bfe70090;
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($11a471eb077355bb$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($11a471eb077355bb$export$89a175d4190df42e, 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $1c3fbb431a173cc6$export$9de493bcd9b1d977);
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $1c3fbb431a173cc6$export$fa405bbf47d510e2);
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    if ((0, $1ybV0.ff)('uim-new-error-type-remove-child-on-node_z8jgj')) {
        // In case of React error message:
        // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
        const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
        if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    }
    if ($11a471eb077355bb$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($11a471eb077355bb$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $JRB5w.isClientFetchError)(error)) return $11a471eb077355bb$export$f52aa41ccd776f01;
    return 'OTHER';
};

});

parcelRegister("d6g7g", function(module, exports) {

$parcel$export(module.exports, "forgeModulesFetchTime", () => $2f54a22cce56cf6f$export$cd129f3639657eae);
$parcel$export(module.exports, "forgeModulesLoadTime", () => $2f54a22cce56cf6f$export$12a4984e133f471e);
$parcel$export(module.exports, "forgeModulesConcurrentLoadTime", () => $2f54a22cce56cf6f$export$292f3b557281044f);
$parcel$export(module.exports, "realTimeIssueEventInvokeTime", () => $2f54a22cce56cf6f$export$89ace7e2bb7d7685);
$parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", () => $2f54a22cce56cf6f$export$94f65f3b2556df23);
$parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", () => $2f54a22cce56cf6f$export$116d5e25caf0018d);
$parcel$export(module.exports, "customFieldPageSegmentLoadMetric", () => $2f54a22cce56cf6f$export$3bd38623c2543fc0);
$parcel$export(module.exports, "customFieldInteractionMetric", () => $2f54a22cce56cf6f$export$a318f99472db73c8);

var $lEpcX = parcelRequire("lEpcX");

var $8uNQc = parcelRequire("8uNQc");

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");

var $hRcYT = parcelRequire("hRcYT");
const $2f54a22cce56cf6f$export$cd129f3639657eae = (0, $lEpcX.metrics).custom({
    key: (0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
});
const $2f54a22cce56cf6f$export$12a4984e133f471e = (0, $lEpcX.metrics).custom({
    key: (0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
});
const $2f54a22cce56cf6f$export$292f3b557281044f = (0, $lEpcX.metrics).concurrent.custom({
    key: (0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
});
const $2f54a22cce56cf6f$export$89ace7e2bb7d7685 = new (0, $kDfSL.UFOExperience)((0, $hRcYT.PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
async function $2f54a22cce56cf6f$export$94f65f3b2556df23(startMark, endMark, fn) {
    if ((0, $8uNQc.default).getEntriesByName(startMark).length > 0 || (0, $8uNQc.default).getEntriesByName(endMark).length > 0) return fn();
    (0, $8uNQc.default).mark(startMark);
    const result = await fn();
    (0, $8uNQc.default).mark(endMark);
    return result;
}
const $2f54a22cce56cf6f$export$116d5e25caf0018d = (metric, additionalTimings)=>{
    additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
            ...(0, $8uNQc.default).getEntriesByName(startMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: cleanStart,
                    cleanEnd: undefined
                })),
            ...(0, $8uNQc.default).getEntriesByName(endMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: undefined,
                    cleanEnd: cleanEnd
                }))
        ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
        metric.mark(name, startTime);
        if (cleanStart || cleanEnd) (0, $8uNQc.default).clearMarks(name);
    });
};
const $2f54a22cce56cf6f$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, $lEpcX.metrics).pageSegmentLoad({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings,
            {
                key: 'tti',
                startMark: (0, $hRcYT.PERFORMANCE_KEYS).MARKS.TTI_START,
                endMark: (0, $hRcYT.PERFORMANCE_KEYS).MARKS.TTI_END
            }
        ]
    });
const $2f54a22cce56cf6f$export$a318f99472db73c8 = (additionalTimings = [])=>(0, $lEpcX.metrics).interaction({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings
        ]
    });

});


parcelRegister("cYWDh", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $6b16192b91ad756a$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireUiEvent", () => $6b16192b91ad756a$export$bed7f228c94e5f2a);
$parcel$export(module.exports, "fireTrackEvent", () => $6b16192b91ad756a$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireInitializationEvent", () => $6b16192b91ad756a$export$390a62413962e4f0);

var $3FyZ4 = parcelRequire("3FyZ4");

var $hRcYT = parcelRequire("hRcYT");

var $bBGpO = parcelRequire("bBGpO");

var $7ALvE = parcelRequire("7ALvE");

var $29pIG = parcelRequire("29pIG");
const $6b16192b91ad756a$var$createAnalyticsProps = ({ id: id, source: // Since source is required in sendOperationalEvent and sendUIEvent we need to pass here a fallback
// in case source is not provided
source = 'unknownSource', action: action, attributes: attributes })=>({
        actionSubject: `${0, $hRcYT.PACKAGE_NAME_GASV3}.${id}`,
        attributes: (0, $bBGpO.createAttributes)(attributes),
        source: source,
        action: action
    });
const $6b16192b91ad756a$var$getAnalyticsClient = async ()=>(await (0, $3FyZ4.getAnalyticsWebClientPromise)()).getInstance();
const $6b16192b91ad756a$var$sendOperationalEvent = async (props)=>(await $6b16192b91ad756a$var$getAnalyticsClient()).sendOperationalEvent($6b16192b91ad756a$var$createAnalyticsProps(props));
const $6b16192b91ad756a$var$sendUiEvent = async (props)=>(await $6b16192b91ad756a$var$getAnalyticsClient()).sendUIEvent($6b16192b91ad756a$var$createAnalyticsProps(props));
const $6b16192b91ad756a$var$sendTrackEvent = async (props)=>(await $6b16192b91ad756a$var$getAnalyticsClient()).sendTrackEvent($6b16192b91ad756a$var$createAnalyticsProps(props));
const $6b16192b91ad756a$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$6b16192b91ad756a$var$sendOperationalEvent({
        ...eventProps,
        source: (0, $bBGpO.parseSource)(source),
        action: action
    });
const $6b16192b91ad756a$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$6b16192b91ad756a$var$sendUiEvent({
        ...eventProps,
        source: (0, $bBGpO.parseSource)(source),
        action: action
    });
const $6b16192b91ad756a$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$6b16192b91ad756a$var$sendTrackEvent({
        ...eventProps,
        source: (0, $bBGpO.parseSource)(source),
        action: action
    });
const $6b16192b91ad756a$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
        $6b16192b91ad756a$export$a1fb57756f0de62b(action, {
            id: id,
            attributes: attributes,
            source: source
        }),
        attributes?.error && (0, $7ALvE.logError)((0, $7ALvE.ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, $29pIG.isSynthetic)().toString()}, id=${id}, source=${(0, $bBGpO.parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
    ]);

});
parcelRegister("bBGpO", function(module, exports) {

$parcel$export(module.exports, "parseSource", () => $c13c8af67eb85442$export$e98201ef9a88ba70);
$parcel$export(module.exports, "createAttributes", () => $c13c8af67eb85442$export$c7c9603a6b1fd815);

var $7PHyj = parcelRequire("7PHyj");

var $f4SFV = parcelRequire("f4SFV");

var $eTZsp = parcelRequire("eTZsp");

var $29pIG = parcelRequire("29pIG");
const $c13c8af67eb85442$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
const $c13c8af67eb85442$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $c13c8af67eb85442$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: (0, $29pIG.isSynthetic)(),
        isOverridingFragments: (0, $f4SFV.isOverridingFragments)(),
        isSSR: false
    };
    if (rawAttributes) {
        const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
        if (source) attributes.source = $c13c8af67eb85442$export$e98201ef9a88ba70(source);
        if (error) {
            attributes.error = $c13c8af67eb85442$export$78c6267359db7e73(error);
            attributes.errorType = (0, $eTZsp.getErrorType)(error);
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7PHyj)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});
parcelRegister("f4SFV", function(module, exports) {

$parcel$export(module.exports, "isOverridingFragments", () => $131b22271a46e6fc$export$1d1321d2b374d697);
const $131b22271a46e6fc$export$1d1321d2b374d697 = ()=>{
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};

});

parcelRegister("29pIG", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $4e7b61ea3e7b237b$export$947749d756ccb0a);

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");
const $4e7b61ea3e7b237b$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $6rW04.default)('ajs-is-synthetic') === 'true' || (0, $1ybV0.ff)('issue.details.forge-ui-synthetic-check');

});


parcelRegister("7ALvE", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_UTIL", () => $d44e65d0fc9da8f1$export$d1e4f308040bb0d5);
$parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", () => $d44e65d0fc9da8f1$export$36f315a5c6daf40b);
$parcel$export(module.exports, "logError", () => $d44e65d0fc9da8f1$export$58da9968c3170cb1);

var $gUUjF = parcelRequire("gUUjF");

var $hRcYT = parcelRequire("hRcYT");
const $d44e65d0fc9da8f1$export$e31edcd35abe3bb1 = 'environment-mapping';
const $d44e65d0fc9da8f1$export$d1e4f308040bb0d5 = 'analytics';
const $d44e65d0fc9da8f1$export$36f315a5c6daf40b = 'custom-field-object-type';
const $d44e65d0fc9da8f1$export$6ee8198f29fffdb4 = {
    [$d44e65d0fc9da8f1$export$d1e4f308040bb0d5]: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.error.utils.analytics`,
    [$d44e65d0fc9da8f1$export$e31edcd35abe3bb1]: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
    [$d44e65d0fc9da8f1$export$36f315a5c6daf40b]: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
};
const $d44e65d0fc9da8f1$export$58da9968c3170cb1 = (key, message, event)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData($d44e65d0fc9da8f1$export$6ee8198f29fffdb4[key], message, event);
};

});



parcelRegister("7C4za", function(module, exports) {

$parcel$export(module.exports, "toForgeKey", () => $7c20fcbbb166c6a7$export$fef910e3c6a21573);
$parcel$export(module.exports, "toForgeKeyWithDate", () => $7c20fcbbb166c6a7$export$4a8bc976ef8470fb);
$parcel$export(module.exports, "toForgeKeyFromExtensionId", () => $7c20fcbbb166c6a7$export$72368b9e5ac31f04);
$parcel$export(module.exports, "toConnectKey", () => $7c20fcbbb166c6a7$export$f1cde82a5f64810e);
$parcel$export(module.exports, "toEcosystemKeys", () => $7c20fcbbb166c6a7$export$c9483bbc66b4fb20);
$parcel$export(module.exports, "isForgeExtension", () => $7c20fcbbb166c6a7$export$b0ed77f2dd403096);
$parcel$export(module.exports, "isKeyMatchPrefix", () => $7c20fcbbb166c6a7$export$75f2b72396a13fc0);

var $2Rqjr = parcelRequire("2Rqjr");
const $7c20fcbbb166c6a7$export$fef910e3c6a21573 = (appKey, moduleKey)=>`${appKey}/${moduleKey}`;
const $7c20fcbbb166c6a7$export$4a8bc976ef8470fb = (appKey, moduleKey, panelInstanceId, dateAdded)=>`${appKey}/${moduleKey}-${panelInstanceId}-${dateAdded}`;
const $7c20fcbbb166c6a7$export$72368b9e5ac31f04 = (extensionId, panelInstanceId, dateAdded)=>panelInstanceId != null ? `${extensionId}-${panelInstanceId}-${dateAdded}` : `${extensionId}-${0, $2Rqjr.NONE_PANEL_INSTANCE_ID}-${dateAdded}`;
const $7c20fcbbb166c6a7$export$f1cde82a5f64810e = (appKey, moduleKey)=>`${appKey}_${moduleKey}`;
const $7c20fcbbb166c6a7$export$c9483bbc66b4fb20 = (extensionId)=>{
    const [prefix, appId, envId, ...rest] = extensionId.split('/');
    const appKey = [
        prefix,
        appId,
        envId
    ].join('/');
    const moduleKey = rest.join('/');
    return {
        appKey: appKey,
        moduleKey: moduleKey
    };
};
const $7c20fcbbb166c6a7$export$b0ed77f2dd403096 = (appKey)=>appKey.startsWith((0, $2Rqjr.FORGE_FIELD_TYPE_PREFIX));
const $7c20fcbbb166c6a7$export$75f2b72396a13fc0 = (key, prefix)=>key.startsWith(prefix) && /^\w+-\d+$/.test(key.slice(prefix.length));

});

parcelRegister("duMa0", function(module, exports) {

$parcel$export(module.exports, "removeTimestamp", () => $5a77e887744126ed$export$8144a1156e1fc1b3);
$parcel$export(module.exports, "parseForgeIssuePanel", () => $5a77e887744126ed$export$a21b4e384e411f26);
// when input is like 'my-issue-content-panel-5794110541888792068', output is 'my-issue-content-panel'
const $5a77e887744126ed$export$8144a1156e1fc1b3 = (str, minDigitsLen = 0)=>{
    const indexOfHyphen = str.lastIndexOf('-');
    const tail = str.substr(indexOfHyphen + 1);
    if (/^\d+$/.test(tail) && tail.length >= minDigitsLen) return str.substr(0, indexOfHyphen);
    return str;
};
const $5a77e887744126ed$export$a21b4e384e411f26 = (panelKey)=>{
    const match = panelKey.match(/^(.*)-(\w+)-(\d+)$/);
    if (match == null) return null;
    const [, extensionId, id, timestamp] = match;
    const added = Number(timestamp);
    return {
        extensionId: extensionId,
        id: id,
        added: added
    };
};

});

const $6c91ecd17276581e$export$bdafa6b589be8b30 = 'issue.content.panel.customised.flag';

parcelRegister("9Hrk7", function(module, exports) {

$parcel$export(module.exports, "ecosystemEntitiesSelector", () => $683f24d420bc5103$export$8db07a5bb000e56f);
$parcel$export(module.exports, "forgeEntitiesSelector", () => $683f24d420bc5103$export$92b32d478f0e29fb);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");

var $k8iGR = parcelRequire("k8iGR");
const $683f24d420bc5103$export$8db07a5bb000e56f = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.ecosystem || {});
const $683f24d420bc5103$export$92b32d478f0e29fb = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.forge || (0, $k8iGR.initialState));

});
parcelRegister("k8iGR", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $9fdfda2b324e48f8$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $9fdfda2b324e48f8$export$2e2bcd8739ae039);

var $i7QJO = parcelRequire("i7QJO");

var $5nezI = parcelRequire("5nezI");

var $fYteL = parcelRequire("fYteL");
const $9fdfda2b324e48f8$export$d4c72bab9d6cc13a = {
    actions: [],
    glances: [],
    issueContexts: [],
    panels: [],
    activities: [],
    customFields: [],
    customFieldTypes: [],
    backgroundScripts: [],
    activeAction: null,
    panelsKeys: {
        newPanels: [],
        collapsedPanels: []
    },
    uiModifications: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9fdfda2b324e48f8$export$2e2bcd8739ae039 = (state = $9fdfda2b324e48f8$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $i7QJO.FETCH_FORGE_SUCCESS:
            return {
                ...state,
                actions: action.payload.issueAction,
                glances: action.payload.issueGlance,
                issueContexts: action.payload.issueContext,
                panels: action.payload.issuePanel,
                activities: action.payload.issueActivity,
                customFields: action.payload.customField,
                customFieldTypes: action.payload.customFieldType,
                backgroundScripts: action.payload.issueViewBackgroundScript,
                activeAction: null,
                panelsKeys: {
                    ...state.panelsKeys,
                    newPanels: []
                },
                uiModifications: action.payload.uiModifications
            };
        case 0, $i7QJO.FORGE_ISSUE_ACTION_EXEC:
            return {
                ...state,
                activeAction: {
                    action: action.payload,
                    isLoading: true
                }
            };
        case 0, $i7QJO.FORGE_ISSUE_ACTION_RENDERED:
            return {
                ...state,
                // @ts-expect-error - TS2322 - Type '{ isLoading: false; action?: Action | undefined; }' is not assignable to type 'ActiveAction'.
                activeAction: {
                    ...state.activeAction,
                    isLoading: false
                }
            };
        case 0, $i7QJO.FORGE_ISSUE_ACTION_CLOSE:
            return {
                ...state,
                activeAction: null
            };
        case 0, $i7QJO.FORGE_ISSUE_PANEL_ADDED:
            return {
                ...state,
                panelsKeys: {
                    ...state.panelsKeys,
                    newPanels: [
                        ...state.panelsKeys.newPanels,
                        action.payload
                    ]
                }
            };
        case 0, $i7QJO.FORGE_NEW_ISSUE_PANEL_UNTRACK:
            {
                const removedPanelKey = action.payload;
                const { panelsKeys: panelsKeys } = state;
                return {
                    ...state,
                    panelsKeys: {
                        ...panelsKeys,
                        newPanels: panelsKeys.newPanels.filter((panelKey)=>panelKey !== removedPanelKey)
                    }
                };
            }
        case 0, $i7QJO.FORGE_ISSUE_PANEL_REMOVED:
            {
                const removedPanelKey = action.payload;
                return {
                    ...state,
                    panelsKeys: {
                        newPanels: state.panelsKeys.newPanels.filter((panelKey)=>panelKey !== removedPanelKey),
                        collapsedPanels: state.panelsKeys.collapsedPanels.filter((panelKey)=>panelKey !== removedPanelKey)
                    }
                };
            }
        case 0, $i7QJO.FORGE_ISSUE_PANEL_UPDATED:
            {
                const { panelKey: panelKey, collapsed: collapsed } = action.payload;
                const updatedCollapsedPanels = collapsed ? Array.from(new Set([
                    ...state.panelsKeys.collapsedPanels,
                    panelKey
                ])) : state.panelsKeys.collapsedPanels.filter((key)=>key !== panelKey);
                return {
                    ...state,
                    panelsKeys: {
                        ...state.panelsKeys,
                        collapsedPanels: updatedCollapsedPanels
                    }
                };
            }
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
        case 0, $fYteL.REFRESH_ISSUE_SUCCESS:
        case 0, $5nezI.FETCH_ISSUE_REMOTE_DATA_SUCCESS:
            {
                const collapsedPanels = action.payload.forgeIssueProperties?.collapsedPanels || [];
                return {
                    ...state,
                    panelsKeys: {
                        ...state.panelsKeys,
                        collapsedPanels: Array.from(new Set([
                            ...state.panelsKeys.collapsedPanels,
                            ...collapsedPanels
                        ]))
                    }
                };
            }
        default:
            return state;
    }
};

});
parcelRegister("i7QJO", function(module, exports) {

$parcel$export(module.exports, "FETCH_FORGE_SUCCESS", () => $2c680f99c3f1e6c8$export$b40fce05e753d390);
$parcel$export(module.exports, "fetchForgeSuccess", () => $2c680f99c3f1e6c8$export$1b05a0184822bc74);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_EXEC", () => $2c680f99c3f1e6c8$export$8c062df60fb76839);
$parcel$export(module.exports, "forgeIssueActionExec", () => $2c680f99c3f1e6c8$export$3a189763780c504b);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_RENDERED", () => $2c680f99c3f1e6c8$export$dd307b8c5e0de67d);
$parcel$export(module.exports, "forgeIssueActionRendered", () => $2c680f99c3f1e6c8$export$2484a0b7a9a14f92);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_CLOSE", () => $2c680f99c3f1e6c8$export$d91b51ae909f8e95);
$parcel$export(module.exports, "forgeIssueActionClose", () => $2c680f99c3f1e6c8$export$335a03a463c5945a);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_ADDED", () => $2c680f99c3f1e6c8$export$7d7831d10e022e0);
$parcel$export(module.exports, "forgeIssuePanelAdded", () => $2c680f99c3f1e6c8$export$f24c609edeac582f);
$parcel$export(module.exports, "FORGE_NEW_ISSUE_PANEL_UNTRACK", () => $2c680f99c3f1e6c8$export$d36cecbf4e320d4a);
$parcel$export(module.exports, "forgeNewIssuePanelUntrack", () => $2c680f99c3f1e6c8$export$b93b979485d242c8);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_REMOVED", () => $2c680f99c3f1e6c8$export$798e467d6a4cb5c);
$parcel$export(module.exports, "forgeIssuePanelRemoved", () => $2c680f99c3f1e6c8$export$b584e6f1797702be);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_UPDATE_REQUEST", () => $2c680f99c3f1e6c8$export$bb2e005bc0498829);
$parcel$export(module.exports, "forgeIssuePanelUpdateRequest", () => $2c680f99c3f1e6c8$export$c67c4f64ec92ba7f);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_UPDATED", () => $2c680f99c3f1e6c8$export$2ce5fe154022894b);
$parcel$export(module.exports, "forgeIssuePanelUpdated", () => $2c680f99c3f1e6c8$export$e2eebb5b364492ce);
const $2c680f99c3f1e6c8$export$b40fce05e753d390 = 'FETCH_FORGE_SUCCESS';
const $2c680f99c3f1e6c8$export$1b05a0184822bc74 = (payload)=>({
        type: $2c680f99c3f1e6c8$export$b40fce05e753d390,
        payload: payload
    });
const $2c680f99c3f1e6c8$export$8c062df60fb76839 = 'FORGE_ISSUE_ACTION_EXEC';
const $2c680f99c3f1e6c8$export$3a189763780c504b = (action)=>({
        type: $2c680f99c3f1e6c8$export$8c062df60fb76839,
        payload: action
    });
const $2c680f99c3f1e6c8$export$dd307b8c5e0de67d = 'FORGE_ISSUE_ACTION_RENDERED';
const $2c680f99c3f1e6c8$export$2484a0b7a9a14f92 = ()=>({
        type: $2c680f99c3f1e6c8$export$dd307b8c5e0de67d
    });
const $2c680f99c3f1e6c8$export$d91b51ae909f8e95 = 'FORGE_ISSUE_ACTION_CLOSE';
const $2c680f99c3f1e6c8$export$335a03a463c5945a = ()=>({
        type: $2c680f99c3f1e6c8$export$d91b51ae909f8e95
    });
const $2c680f99c3f1e6c8$export$7d7831d10e022e0 = 'FORGE_ISSUE_PANEL_ADDED';
const $2c680f99c3f1e6c8$export$f24c609edeac582f = (issuePanelKey)=>({
        type: $2c680f99c3f1e6c8$export$7d7831d10e022e0,
        payload: issuePanelKey
    });
const $2c680f99c3f1e6c8$export$d36cecbf4e320d4a = 'FORGE_NEW_ISSUE_PANEL_UNTRACK';
const $2c680f99c3f1e6c8$export$b93b979485d242c8 = (issuePanelKey)=>({
        type: $2c680f99c3f1e6c8$export$d36cecbf4e320d4a,
        payload: issuePanelKey
    });
const $2c680f99c3f1e6c8$export$798e467d6a4cb5c = 'FORGE_ISSUE_PANEL_REMOVED';
const $2c680f99c3f1e6c8$export$b584e6f1797702be = (issuePanelKey)=>({
        type: $2c680f99c3f1e6c8$export$798e467d6a4cb5c,
        payload: issuePanelKey
    });
const $2c680f99c3f1e6c8$export$bb2e005bc0498829 = 'FORGE_ISSUE_PANEL_UPDATE_REQUEST';
const $2c680f99c3f1e6c8$export$c67c4f64ec92ba7f = (payload)=>({
        type: $2c680f99c3f1e6c8$export$bb2e005bc0498829,
        payload: payload
    });
const $2c680f99c3f1e6c8$export$2ce5fe154022894b = 'FORGE_ISSUE_PANEL_UPDATED';
const $2c680f99c3f1e6c8$export$e2eebb5b364492ce = (payload)=>({
        type: $2c680f99c3f1e6c8$export$2ce5fe154022894b,
        payload: payload
    });

});

parcelRegister("5nezI", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_REQUEST", () => $739b73405dd64b1d$export$d8a6e69b46d6d184);
$parcel$export(module.exports, "fetchIssueRemoteDataRequest", () => $739b73405dd64b1d$export$222125e4e0f166e4);
$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_SUCCESS", () => $739b73405dd64b1d$export$2cdd723fc40cdd47);
$parcel$export(module.exports, "fetchIssueRemoteDataSuccess", () => $739b73405dd64b1d$export$615a2d29b149df95);
$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_FAILURE", () => $739b73405dd64b1d$export$396f0d977db541d9);
$parcel$export(module.exports, "fetchIssueRemoteDataFailure", () => $739b73405dd64b1d$export$f7fd18472eaf2b77);
const $739b73405dd64b1d$export$d8a6e69b46d6d184 = 'FETCH_ISSUE_REMOTE_DATA_REQUEST';
const $739b73405dd64b1d$export$222125e4e0f166e4 = (issueKey)=>({
        type: $739b73405dd64b1d$export$d8a6e69b46d6d184,
        payload: issueKey
    });
const $739b73405dd64b1d$export$2cdd723fc40cdd47 = 'FETCH_ISSUE_REMOTE_DATA_SUCCESS';
const $739b73405dd64b1d$export$615a2d29b149df95 = (entities)=>({
        type: $739b73405dd64b1d$export$2cdd723fc40cdd47,
        payload: entities
    });
const $739b73405dd64b1d$export$396f0d977db541d9 = 'FETCH_ISSUE_REMOTE_DATA_FAILURE';
const $739b73405dd64b1d$export$f7fd18472eaf2b77 = ()=>({
        type: $739b73405dd64b1d$export$396f0d977db541d9
    });

});

parcelRegister("fYteL", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REQUEST", () => $98506972d7379203$export$afc8565512ebbf99);
$parcel$export(module.exports, "fetchIssueRequest", () => $98506972d7379203$export$ff7cd1a46115d8ca);
$parcel$export(module.exports, "FETCH_ISSUE_SUCCESS", () => $98506972d7379203$export$c32d0e1f370b7914);
$parcel$export(module.exports, "fetchIssueSuccess", () => $98506972d7379203$export$1e39a30e3f37e9d1);
$parcel$export(module.exports, "FETCH_ISSUE_FAILURE", () => $98506972d7379203$export$700ca24f76d5bbe6);
$parcel$export(module.exports, "fetchIssueFailure", () => $98506972d7379203$export$625e6e61fad65793);
$parcel$export(module.exports, "REFRESH_ISSUE_REQUEST", () => $98506972d7379203$export$b48f53bf5b842d57);
$parcel$export(module.exports, "refreshIssueRequest", () => $98506972d7379203$export$ccd0db94940d9159);
$parcel$export(module.exports, "CANCEL_REFRESH_ISSUE_REQUEST", () => $98506972d7379203$export$6b6ca6acd76420d1);
$parcel$export(module.exports, "cancelRefreshIssueRequest", () => $98506972d7379203$export$a7629a657f902cbc);
$parcel$export(module.exports, "REFRESH_ISSUE_SUCCESS", () => $98506972d7379203$export$de11c913f06a7952);
$parcel$export(module.exports, "refreshIssueSuccess", () => $98506972d7379203$export$cbd1c08fb706639c);
$parcel$export(module.exports, "FETCH_FORGE_REQUEST", () => $98506972d7379203$export$36b76b7384d868f3);
$parcel$export(module.exports, "fetchForgeRequest", () => $98506972d7379203$export$6ce2430992033a55);
const $98506972d7379203$export$afc8565512ebbf99 = 'FETCH_ISSUE_REQUEST';
const $98506972d7379203$export$ff7cd1a46115d8ca = ()=>({
        type: $98506972d7379203$export$afc8565512ebbf99
    });
const $98506972d7379203$export$c32d0e1f370b7914 = 'FETCH_ISSUE_SUCCESS';
const $98506972d7379203$export$1e39a30e3f37e9d1 = (entities)=>({
        type: $98506972d7379203$export$c32d0e1f370b7914,
        payload: entities
    });
const $98506972d7379203$export$700ca24f76d5bbe6 = 'FETCH_ISSUE_FAILURE';
const $98506972d7379203$export$625e6e61fad65793 = (failureDescription)=>({
        type: $98506972d7379203$export$700ca24f76d5bbe6,
        payload: failureDescription
    });
const $98506972d7379203$export$b48f53bf5b842d57 = 'REFRESH_ISSUE_REQUEST';
const $98506972d7379203$export$ccd0db94940d9159 = (payload, meta)=>({
        type: $98506972d7379203$export$b48f53bf5b842d57,
        payload: payload,
        meta: meta
    });
const $98506972d7379203$export$6b6ca6acd76420d1 = 'CANCEL_REFRESH_ISSUE_REQUEST';
const $98506972d7379203$export$a7629a657f902cbc = ()=>({
        type: $98506972d7379203$export$6b6ca6acd76420d1
    });
const $98506972d7379203$export$de11c913f06a7952 = 'REFRESH_ISSUE_SUCCESS';
const $98506972d7379203$export$cbd1c08fb706639c = (entities)=>({
        type: $98506972d7379203$export$de11c913f06a7952,
        payload: entities
    });
const $98506972d7379203$export$36b76b7384d868f3 = 'FETCH_FORGE_REQUEST';
const $98506972d7379203$export$6ce2430992033a55 = ()=>({
        type: $98506972d7379203$export$36b76b7384d868f3
    });

});



parcelRegister("8QKSg", function(module, exports) {

$parcel$export(module.exports, "forgeContextPanelsSelector", () => $0fae948f4d8718f3$export$94c701814d50fed3);
$parcel$export(module.exports, "forgeGlancesSelector", () => $0fae948f4d8718f3$export$92747468cb57714e);
$parcel$export(module.exports, "forgeUiModificationsSelector", () => $0fae948f4d8718f3$export$325ea69d1eb5eda0);
$parcel$export(module.exports, "forgeIssueActionsSelector", () => $0fae948f4d8718f3$export$9bcd40b01af57823);
$parcel$export(module.exports, "forgePanelsSelector", () => $0fae948f4d8718f3$export$ca115d43abfd7206);
$parcel$export(module.exports, "forgeUserCanSaveIssuePanelSelector", () => $0fae948f4d8718f3$export$ae25fce59e44b253);
$parcel$export(module.exports, "forgeJustAddedPanelSelector", () => $0fae948f4d8718f3$export$9c375a0b9a6e5017);
$parcel$export(module.exports, "forgeActiveIssueActionSelector", () => $0fae948f4d8718f3$export$ccad5f28efcec42d);
$parcel$export(module.exports, "forgeIssueDataSelector", () => $0fae948f4d8718f3$export$d3cd515b7639ce61);
$parcel$export(module.exports, "forgeIssueActivitySelector", () => $0fae948f4d8718f3$export$18ce84b90b4920eb);
$parcel$export(module.exports, "isForgePanelNewToIssueSelector", () => $0fae948f4d8718f3$export$97dadedc102bebdf);
$parcel$export(module.exports, "getForgeIssuePanel", () => $0fae948f4d8718f3$export$b01f1fc9eba6d8cd);
$parcel$export(module.exports, "forgeIsCollapsedPanelSelector", () => $0fae948f4d8718f3$export$3d7856e5c65d2291);

var $df4Sl = parcelRequire("df4Sl");

var $ldoFd = parcelRequire("ldoFd");

var $fTsDx = parcelRequire("fTsDx");

var $7C4za = parcelRequire("7C4za");

var $bLiXo = parcelRequire("bLiXo");

var $fkvsU = parcelRequire("fkvsU");

var $duMa0 = parcelRequire("duMa0");

var $6vrw7 = parcelRequire("6vrw7");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $9D3Vo = parcelRequire("9D3Vo");

var $9Hrk7 = parcelRequire("9Hrk7");
const $0fae948f4d8718f3$var$filterExtensions = (list, staticContext)=>list.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, staticContext));
const $0fae948f4d8718f3$var$sortIssuePanels = (first, second)=>{
    if (first.name === second.name) return 0;
    return first.name > second.name ? 1 : -1;
};
const $0fae948f4d8718f3$export$b302c9df74ede99a = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (0, $5JqpU.issueIdSelector), (0, $5JqpU.issueKeySelector), (0, $9D3Vo.issueTypeNameSelector), (0, $jZDJX.projectIdSelector), (0, $5JqpU.projectKeySelector), (0, $jZDJX.projectTypeSelector), (permissions, issueId, issueKey, issueType, projectId, projectKey, projectType)=>({
        issueId: issueId || null,
        issueKey: issueKey,
        issueType: issueType,
        projectId: projectId,
        projectKey: projectKey,
        projectType: projectType || null,
        // Instead of dumping permissions as is we'd like to normalize prop names a bit
        // as they are exposed externally and have to look respectable
        canAddComments: permissions.canAddComments,
        canAdministerJira: permissions.canAdministerJira,
        canAdministerProjects: permissions.canAdministerProject,
        canAssignIssues: permissions.canAssignIssues,
        canBeAssignedToIssues: permissions.canBeAssignedToIssues,
        canCloneIssues: permissions.canCloneIssue,
        canCreateAttachments: permissions.canCreateAttachments,
        canCreateChildren: permissions.canCreateChildren,
        canCreateSubtasks: permissions.canCreateSubtask,
        canDeleteAllAttachments: permissions.canDeleteAllAttachments,
        canDeleteAllComments: permissions.canDeleteAllComments,
        canDeleteAllWorklogs: permissions.canDeleteAllWorklogs,
        canDeleteIssues: permissions.canDeleteIssue,
        canDeleteOwnAttachments: permissions.canDeleteOwnAttachments,
        canDeleteOwnComments: permissions.canDeleteOwnComments,
        canDeleteOwnWorklogs: permissions.canDeleteOwnWorklogs,
        canEditAllComments: permissions.canEditAllComments,
        canEditAllWorklogs: permissions.canEditAllWorklogs,
        canEditIssues: permissions.canEditIssues,
        canEditOwnComments: permissions.canEditOwnComments,
        canEditOwnWorklogs: permissions.canEditOwnWorklogs,
        canLinkIssues: permissions.canLinkIssues,
        canLogWork: permissions.canLogWork,
        canManageWatchers: permissions.canManageWatchers,
        canModifyReporters: permissions.canModifyReporter,
        canMoveIssues: permissions.canMoveIssue,
        canScheduleIssues: permissions.canScheduleIssues,
        canUseServiceManagementAgentFeatures: permissions.canUseServiceDeskAgentFeatures,
        canBrowseUsers: permissions.canBrowseUsers,
        canViewDevTools: permissions.canViewDevTools,
        canViewWatchers: permissions.canViewWatchers,
        canExportIssue: permissions.canExportIssue
    }));
const $0fae948f4d8718f3$export$94c701814d50fed3 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.issueContexts)) return [];
    return forge.issueContexts.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, issueViewStaticContext)).map((contextPanels)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: url } } = contextPanels;
        return {
            id: id,
            type: (0, $bLiXo.FORGE_CONTEXT_TYPE),
            payload: {
                type: (0, $bLiXo.FORGE_CONTEXT_TYPE),
                label: label,
                name: title,
                status: status || null,
                icon: url ? {
                    url: url
                } : null,
                contextPanelType: (0, $fkvsU.FORGE_ENTITY_TYPE),
                moduleKey: id,
                appKey: id,
                options: null
            }
        };
    });
});
const $0fae948f4d8718f3$export$92747468cb57714e = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.glances)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.glances, issueViewStaticContext).map((extension)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: icon } } = extension;
        return {
            title: title,
            label: label,
            status: status,
            icon: icon,
            extension: extension,
            glanceType: (0, $fkvsU.FORGE_ENTITY_TYPE),
            // Legacy props, too much refactoring needed in order to get rid of them
            moduleKey: id,
            appKey: id
        };
    });
});
const $0fae948f4d8718f3$export$325ea69d1eb5eda0 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.uiModifications)) return [];
    return forge.uiModifications;
});
const $0fae948f4d8718f3$export$9bcd40b01af57823 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.actions)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.actions, issueViewStaticContext).map((extension)=>{
        const { id: id, properties: { title: title } } = extension;
        return {
            id: id,
            title: title,
            extension: extension,
            type: (0, $fkvsU.FORGE_ENTITY_TYPE)
        };
    });
});
const $0fae948f4d8718f3$export$ca115d43abfd7206 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.panels)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.panels, issueViewStaticContext).filter((extension)=>extension.properties.icon != null).map((extension)=>{
        const { id: id, properties: { title: title, icon: icon, allowMultiple: allowMultiple } } = extension;
        const { appKey: appKey, moduleKey: moduleKey } = (0, $7C4za.toEcosystemKeys)(id);
        return {
            name: title,
            tooltip: title,
            iconUrl: icon,
            extension: extension,
            allowMultiple: !!allowMultiple,
            showByDefault: false,
            type: (0, $fkvsU.FORGE_ENTITY_TYPE),
            moduleKey: moduleKey,
            appKey: appKey
        };
    }).sort($0fae948f4d8718f3$var$sortIssuePanels);
});
const $0fae948f4d8718f3$export$ae25fce59e44b253 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, issueViewStaticContext)=>isEcosystemEnabled && issueViewStaticContext.canEditIssues);
const $0fae948f4d8718f3$export$9c375a0b9a6e5017 = (panelKey)=>(0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.selectedContentPanel === panelKey);
const $0fae948f4d8718f3$export$38dd8c9ba1d48d98 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.customFields)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.customFields, issueViewStaticContext);
});
const $0fae948f4d8718f3$export$9cef69a20109a92c = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.customFieldTypes)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.customFieldTypes, issueViewStaticContext);
});
const $0fae948f4d8718f3$export$2f1d736b0e7e1293 = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$38dd8c9ba1d48d98, (fields)=>fields.length > 0);
const $0fae948f4d8718f3$export$252a589d17b14921 = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$9cef69a20109a92c, (fieldsTypes)=>fieldsTypes.length > 0);
const $0fae948f4d8718f3$export$89b67d7e4e300f7d = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$2f1d736b0e7e1293, $0fae948f4d8718f3$export$252a589d17b14921, (hasCustomFields, hasCustomFieldTypes)=>hasCustomFields || hasCustomFieldTypes);
const $0fae948f4d8718f3$export$e824cf91ff446be9 = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$38dd8c9ba1d48d98, $0fae948f4d8718f3$export$9cef69a20109a92c, (customFields, customFieldTypes)=>[
        ...customFields,
        ...customFieldTypes
    ]);
const $0fae948f4d8718f3$export$ccad5f28efcec42d = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled) return null;
    return forge.activeAction || null;
});
const $0fae948f4d8718f3$export$e04b25b621339356 = (0, $df4Sl.createSelector)((0, $fokFV.fieldsSelector), (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>fields[fieldId]?.schema.custom || '');
const $0fae948f4d8718f3$export$fbab82209930cdab = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$e824cf91ff446be9, $0fae948f4d8718f3$export$e04b25b621339356, (forgeFields, extensionId)=>{
    const extension = forgeFields.find((field)=>field.id === extensionId);
    return extension || null;
});
const $0fae948f4d8718f3$export$c9095ffee4d5bbc0 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$e04b25b621339356, $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, extensionId, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.customFields) || !Array.isArray(forge.customFieldTypes)) return false;
    const extension = [
        ...forge.customFields,
        ...forge.customFieldTypes
    ].find((field)=>field.id === extensionId);
    return !extension ? false : !(0, $fTsDx.doesExtensionMeetConditions)(extension, issueViewStaticContext);
});
const $0fae948f4d8718f3$export$7640f867620fe598 = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$fbab82209930cdab, (extension)=>{
    if (!extension) return false;
    const hasRenderingFunction = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(extension.properties.function);
    const hasFormatterDefined = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(extension.properties.formatter);
    return !hasRenderingFunction && hasFormatterDefined;
});
const $0fae948f4d8718f3$export$d3cd515b7639ce61 = (0, $df4Sl.createSelector)((0, $5JqpU.issueKeySelector), (0, $5JqpU.issueIdSelector), (0, $9D3Vo.issueTypeIdSelector), (0, $9D3Vo.issueTypeNameSelector), (0, $5JqpU.projectKeySelector), (0, $jZDJX.projectIdSelector), (0, $jZDJX.projectTypeSelector), (issueKey, issueId, issueTypeId, issueType, projectKey, projectId, projectType)=>({
        issue: {
            key: issueKey,
            id: issueId,
            type: issueType,
            typeId: issueTypeId
        },
        project: {
            id: projectId !== null ? (0, $6vrw7.toProjectId)(projectId.toString()) : projectId,
            key: projectKey,
            type: projectType
        }
    }));
const $0fae948f4d8718f3$export$18ce84b90b4920eb = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.actions)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.activities, issueViewStaticContext).map((extension)=>{
        const { id: id, properties: { title: title } } = extension;
        const { appKey: appKey, moduleKey: moduleKey } = (0, $7C4za.toEcosystemKeys)(id);
        return {
            name: title,
            extension: extension,
            type: (0, $fkvsU.FORGE_ENTITY_TYPE),
            moduleKey: moduleKey,
            appKey: appKey
        };
    });
});
const $0fae948f4d8718f3$export$97dadedc102bebdf = (0, $df4Sl.createSelector)((0, $9Hrk7.forgeEntitiesSelector), (_, issuePanelKey)=>issuePanelKey, (forge, issuePanelKey)=>forge.panelsKeys.newPanels.includes(issuePanelKey));
const $0fae948f4d8718f3$export$b01f1fc9eba6d8cd = (forgePanelKey)=>(0, $df4Sl.createSelector)($0fae948f4d8718f3$export$ca115d43abfd7206, (panels)=>{
        const { extensionId: extensionId } = (0, $duMa0.parseForgeIssuePanel)(forgePanelKey) || {};
        return panels.find((panel)=>extensionId === panel.extension.id);
    });
const $0fae948f4d8718f3$export$3d7856e5c65d2291 = (0, $df4Sl.createSelector)((0, $9Hrk7.forgeEntitiesSelector), (_, issuePanelKey)=>issuePanelKey, (forge, issuePanelKey)=>forge.panelsKeys.collapsedPanels.includes(issuePanelKey));

});


parcelRegister("cj1Xt", function(module, exports) {

$parcel$export(module.exports, "ecosystemCustomFieldIdsSelector", () => $c6007774372d78ef$export$c16e6010c2ccc7b2);

var $df4Sl = parcelRequire("df4Sl");

var $btjMs = parcelRequire("btjMs");

var $f9RL0 = parcelRequire("f9RL0");

var $fokFV = parcelRequire("fokFV");
const $c6007774372d78ef$export$1caf4359a6680b64 = (0, $df4Sl.createSelector)((0, $fokFV.fieldsSelector), (fields)=>Object.keys(fields).filter((id)=>{
        const type = (0, $btjMs.getFieldType)(fields[id]);
        return type && (0, $f9RL0.customFieldsToDisplay)().includes(type);
    }));
const $c6007774372d78ef$export$c16e6010c2ccc7b2 = (0, $df4Sl.createSelector)((0, $fokFV.fieldsSelector), (fields)=>Object.keys(fields).filter((id)=>{
        const type = (0, $btjMs.getFieldType)(fields[id]);
        return type && (0, $f9RL0.ecosystemCustomFields).includes(type);
    }));

});

parcelRegister("dmojD", function(module, exports) {

$parcel$export(module.exports, "entitiesCommentsSelector", () => $2fc412f4c8af7d4e$export$2bcb958351592bb9);
$parcel$export(module.exports, "totalCommentsSelector", () => $2fc412f4c8af7d4e$export$3873a5701cda7746);
$parcel$export(module.exports, "startIndexCommentsSelector", () => $2fc412f4c8af7d4e$export$10621129a0e171e5);
$parcel$export(module.exports, "loadedCommentsSelector", () => $2fc412f4c8af7d4e$export$c3802eebab78988b);
$parcel$export(module.exports, "isLoadingMoreCommentsSelector", () => $2fc412f4c8af7d4e$export$5d4ebbdab84a3a1);
$parcel$export(module.exports, "hasScrolledPermalinkCommentSelector", () => $2fc412f4c8af7d4e$export$3190c124f9d4af8a);
$parcel$export(module.exports, "loadingStageSelector", () => $2fc412f4c8af7d4e$export$18bc980d36bf93d);
$parcel$export(module.exports, "commentAuthorSelector", () => $2fc412f4c8af7d4e$export$6f6ac03c75ab3545);
$parcel$export(module.exports, "commentUpdateAuthorSelector", () => $2fc412f4c8af7d4e$export$7190d6fab16715b8);
$parcel$export(module.exports, "commentEditingBodySelector", () => $2fc412f4c8af7d4e$export$3e2634438f2a9b1a);
$parcel$export(module.exports, "commentEditingVisibilitySelector", () => $2fc412f4c8af7d4e$export$3c2f8c0a34054ef7);
$parcel$export(module.exports, "commentEditingOrViewBodyAdfSelector", () => $2fc412f4c8af7d4e$export$b0e0bc0c48cf00e6);
$parcel$export(module.exports, "commentOutsiderCommentSelector", () => $2fc412f4c8af7d4e$export$e7022c391905c53f);
$parcel$export(module.exports, "commentBodyHtmlSelector", () => $2fc412f4c8af7d4e$export$b9c6e85825c49cba);
$parcel$export(module.exports, "commentCreatedDateSelector", () => $2fc412f4c8af7d4e$export$b580f3d971b4e6fb);
$parcel$export(module.exports, "commentUpdatedDateSelector", () => $2fc412f4c8af7d4e$export$8b9935e49715b2d6);
$parcel$export(module.exports, "commentEditedSelector", () => $2fc412f4c8af7d4e$export$eff4fd551b2f55a1);
$parcel$export(module.exports, "pendingCommentSelector", () => $2fc412f4c8af7d4e$export$d63578bef1057cae);
$parcel$export(module.exports, "commentIsOptimisticSelector", () => $2fc412f4c8af7d4e$export$be047268481f07d8);
$parcel$export(module.exports, "commentSaveFailedSelector", () => $2fc412f4c8af7d4e$export$72075ae8ef4d6f6a);
$parcel$export(module.exports, "commentHasDeleteModalSelector", () => $2fc412f4c8af7d4e$export$c756ab72f25508bb);
$parcel$export(module.exports, "commentVisibilitySelector", () => $2fc412f4c8af7d4e$export$2cf9d22f626e5db0);
$parcel$export(module.exports, "commentEditingOrViewVisibilitySelector", () => $2fc412f4c8af7d4e$export$82fbf902093fe491);
$parcel$export(module.exports, "commentEditingEventOccurredAtSelector", () => $2fc412f4c8af7d4e$export$d820e1c3ac105e35);
$parcel$export(module.exports, "commentEventOccurredAtSelector", () => $2fc412f4c8af7d4e$export$9c8937d1bd8cf4a);
$parcel$export(module.exports, "commentJsdIncidentActivityViewHiddenSelector", () => $2fc412f4c8af7d4e$export$8c7be677b9a2cbf3);
$parcel$export(module.exports, "isInternalCommentSelector", () => $2fc412f4c8af7d4e$export$b99aa78c1374f9fe);
$parcel$export(module.exports, "isEditingInternalCommentSelector", () => $2fc412f4c8af7d4e$export$54205c8c886a2b43);
$parcel$export(module.exports, "canAddCommentsSelector", () => $2fc412f4c8af7d4e$export$a34c155854eb296b);
$parcel$export(module.exports, "canDeleteCommentSelector", () => $2fc412f4c8af7d4e$export$8cc876bb72dc09b7);
$parcel$export(module.exports, "canEditCommentSelector", () => $2fc412f4c8af7d4e$export$eb110f3a00a8432);
$parcel$export(module.exports, "visibleCommentIdsSelector", () => $2fc412f4c8af7d4e$export$3b3d01d442cb684a);
$parcel$export(module.exports, "sortedVisibleCommentIdsSelector", () => $2fc412f4c8af7d4e$export$81c523e14f04df2d);
$parcel$export(module.exports, "isEditingCommentSelector", () => $2fc412f4c8af7d4e$export$6eba3f548a7f384e);
$parcel$export(module.exports, "getEditingCommentIdsSelector", () => $2fc412f4c8af7d4e$export$3a00787e516c672c);
$parcel$export(module.exports, "commentIdsSelector", () => $2fc412f4c8af7d4e$export$4c04cd370caea884);
$parcel$export(module.exports, "isEditingAnyCommentSelector", () => $2fc412f4c8af7d4e$export$2e24e984817b4c7b);
$parcel$export(module.exports, "isAddCommentEditorExpandedSelector", () => $2fc412f4c8af7d4e$export$5373a6bfd674797c);
$parcel$export(module.exports, "addCommentEditorForceFocusSelector", () => $2fc412f4c8af7d4e$export$37aee7d1ec9d42d3);
$parcel$export(module.exports, "isCommentEditorOpenSelector", () => $2fc412f4c8af7d4e$export$6df0ef2ac2b35c13);
$parcel$export(module.exports, "isCommentAttachmentInProgressSelector", () => $2fc412f4c8af7d4e$export$f140c5c89826efc6);
$parcel$export(module.exports, "isCommentVisibilityRestrictionSupportedSelector", () => $2fc412f4c8af7d4e$export$2ce513eb85289331);

var $df4Sl = parcelRequire("df4Sl");

var $hvbu2 = parcelRequire("hvbu2");

var $78IOp = parcelRequire("78IOp");

var $kirCf = parcelRequire("kirCf");

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");


var $f6MOn = parcelRequire("f6MOn");

var $8aR1q = parcelRequire("8aR1q");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $gIyTt = parcelRequire("gIyTt");

var $gzLYm = parcelRequire("gzLYm");
const $2fc412f4c8af7d4e$export$9832028921909a8f = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.pendingDeletedIds);
const $2fc412f4c8af7d4e$export$2bcb958351592bb9 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.comments);
const $2fc412f4c8af7d4e$export$3873a5701cda7746 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.totalComments);
const $2fc412f4c8af7d4e$export$10621129a0e171e5 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.commentsStartIndex);
const $2fc412f4c8af7d4e$export$c3802eebab78988b = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.loadedComments);
const $2fc412f4c8af7d4e$export$5d4ebbdab84a3a1 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.isLoadingMoreComments);
const $2fc412f4c8af7d4e$export$3190c124f9d4af8a = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.hasScrolledPermalinkComment);
const $2fc412f4c8af7d4e$export$cb15fb58f04e4339 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.pendingSavedValues);
const $2fc412f4c8af7d4e$var$deleteModalCommentIdSelector = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.deleteModalCommentId);
const $2fc412f4c8af7d4e$export$18bc980d36bf93d = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.loadingStage);
const $2fc412f4c8af7d4e$export$f82d111da9150583 = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$2bcb958351592bb9, $2fc412f4c8af7d4e$export$cb15fb58f04e4339, (comments, optimisticComments)=>({
        ...comments,
        ...optimisticComments
    }));
const $2fc412f4c8af7d4e$var$commentSelector = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$f82d111da9150583, (comments)=>comments[commentId]);
// If the user is anonymous, then they are not considered comment author
const $2fc412f4c8af7d4e$var$isUserCommentAuthorSelector = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (0, $5JqpU.accountIdloggedInUserSelector), (comment, loggedInUserId)=>loggedInUserId !== null && loggedInUserId === (comment && comment.authorId));
const $2fc412f4c8af7d4e$var$authorSelector = (commentId, authorIdPropertyName)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (0, $jZDJX.getUserByIdSelector), (comment, userByIdSelector)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'OptimisticComment | PersistedComment'.
        comment && comment[authorIdPropertyName] ? userByIdSelector(comment[authorIdPropertyName]) : null);
const $2fc412f4c8af7d4e$var$uiAllCommentsSelector = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui && ui.comments || null);
const $2fc412f4c8af7d4e$var$uiAllCommentEditorsSelector = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiAllCommentsSelector, (uiComments)=>uiComments && uiComments.commentEditors || null);
const $2fc412f4c8af7d4e$var$uiCommentEditorSelector = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiAllCommentEditorsSelector, (uiCommentEditors)=>uiCommentEditors && uiCommentEditors[commentId] || null);
const $2fc412f4c8af7d4e$export$6f6ac03c75ab3545 = (commentId)=>$2fc412f4c8af7d4e$var$authorSelector(commentId, 'authorId');
const $2fc412f4c8af7d4e$export$7190d6fab16715b8 = (commentId)=>$2fc412f4c8af7d4e$var$authorSelector(commentId, 'updateAuthorId');
const $2fc412f4c8af7d4e$export$3e2634438f2a9b1a = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.editingValue || null);
const $2fc412f4c8af7d4e$export$3c2f8c0a34054ef7 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.visibility || null);
const $2fc412f4c8af7d4e$export$b0e0bc0c48cf00e6 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$3e2634438f2a9b1a(commentId), $2fc412f4c8af7d4e$var$commentSelector(commentId), (editingComment, comment)=>editingComment || comment && comment.bodyAdf || null);
const $2fc412f4c8af7d4e$export$e7022c391905c53f = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.jsdAuthorCanSeeRequest : null);
const $2fc412f4c8af7d4e$export$b9c6e85825c49cba = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.bodyHtml : null);
const $2fc412f4c8af7d4e$export$b580f3d971b4e6fb = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.createdDate : null);
const $2fc412f4c8af7d4e$export$8b9935e49715b2d6 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.updatedDate : null);
const $2fc412f4c8af7d4e$export$eff4fd551b2f55a1 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.edited : null);
const $2fc412f4c8af7d4e$export$d63578bef1057cae = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$cb15fb58f04e4339, (pendingComments)=>pendingComments[commentId]);
const $2fc412f4c8af7d4e$export$be047268481f07d8 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$d63578bef1057cae(commentId), (pendingComment)=>!!pendingComment);
const $2fc412f4c8af7d4e$export$72075ae8ef4d6f6a = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$d63578bef1057cae(commentId), (pendingComment)=>!!(pendingComment && pendingComment.hasSaveFailed));
const $2fc412f4c8af7d4e$export$c756ab72f25508bb = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$deleteModalCommentIdSelector, (deleteModalCommentId)=>deleteModalCommentId === commentId);
const $2fc412f4c8af7d4e$export$2cf9d22f626e5db0 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.visibility : (0, $f6MOn.COMMENT_VISIBILITY_PUBLIC));
const $2fc412f4c8af7d4e$var$commentIsInternalSelector = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.isInternal : false);
const $2fc412f4c8af7d4e$export$82fbf902093fe491 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$3c2f8c0a34054ef7(commentId), $2fc412f4c8af7d4e$export$2cf9d22f626e5db0(commentId), (editingVisibility, visibility)=>editingVisibility || visibility);
const $2fc412f4c8af7d4e$export$d820e1c3ac105e35 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.eventOccurredAt || null);
const $2fc412f4c8af7d4e$export$9c8937d1bd8cf4a = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment && comment.eventOccurredAt ? comment.eventOccurredAt : null);
const $2fc412f4c8af7d4e$export$9b5c22d8443e21d6 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$d820e1c3ac105e35(commentId), $2fc412f4c8af7d4e$export$9c8937d1bd8cf4a(commentId), (editingEventOccurredAt, eventOccurredAt)=>editingEventOccurredAt || eventOccurredAt);
const $2fc412f4c8af7d4e$export$8c7be677b9a2cbf3 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment && typeof comment.jsdIncidentActivityViewHidden === 'boolean' ? comment.jsdIncidentActivityViewHidden : null);
const $2fc412f4c8af7d4e$export$b99aa78c1374f9fe = (commentId)=>(0, $df4Sl.createSelector)((0, $5JqpU.isServiceDeskSelector), $2fc412f4c8af7d4e$var$commentIsInternalSelector(commentId), (isServiceDeskComment, isInternal)=>isServiceDeskComment && isInternal);
const $2fc412f4c8af7d4e$export$54205c8c886a2b43 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiCommentEditorSelector(commentId), (commentEditor)=>commentEditor?.isInternal ?? true);
const $2fc412f4c8af7d4e$export$a34c155854eb296b = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canAddComments);
const $2fc412f4c8af7d4e$export$8cc876bb72dc09b7 = (commentId)=>(0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), $2fc412f4c8af7d4e$var$isUserCommentAuthorSelector(commentId), (permissions, isUserCommentAuthor)=>permissions.canDeleteAllComments || permissions.canDeleteOwnComments && isUserCommentAuthor);
const $2fc412f4c8af7d4e$export$eb110f3a00a8432 = (commentId)=>(0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), $2fc412f4c8af7d4e$var$isUserCommentAuthorSelector(commentId), (permissions, isUserCommentAuthor)=>permissions.canEditAllComments || permissions.canEditOwnComments && isUserCommentAuthor);
const $2fc412f4c8af7d4e$var$mapIdToCommentSortInfo = (comments)=>(id)=>{
        const comment = comments[id];
        return {
            id: id,
            createdDate: new Date(comment.createdDate),
            eventOccurredAt: comment.eventOccurredAt ? new Date(comment.eventOccurredAt) : null
        };
    };
const $2fc412f4c8af7d4e$var$compareComments = (a, b)=>{
    if (a.eventOccurredAt && b.eventOccurredAt && (0, $78IOp.default)(a.eventOccurredAt, b.eventOccurredAt) === 0) return (0, $78IOp.default)(a.createdDate, b.createdDate);
    const dateForA = a.eventOccurredAt ? a.eventOccurredAt : a.createdDate;
    const dateForB = b.eventOccurredAt ? b.eventOccurredAt : b.createdDate;
    return (0, $78IOp.default)(dateForA, dateForB);
};
const $2fc412f4c8af7d4e$var$visibleCommentIdsSelectorOld = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$f82d111da9150583, $2fc412f4c8af7d4e$export$9832028921909a8f, (comments, deletedIds)=>{
    // filter out any comments currently pending deletion
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>!deletedIds.includes(id));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map((id)=>({
            id: id,
            createdDate: new Date(comments[id].createdDate)
        })).sort((a, b)=>(0, $78IOp.default)(a.createdDate, b.createdDate)).map((comment)=>comment.id);
    return sortedIds;
});
const $2fc412f4c8af7d4e$var$visibleCommentIdsSelectorNew = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$f82d111da9150583, $2fc412f4c8af7d4e$export$9832028921909a8f, (comments, deletedIds)=>{
    // filter out any comments currently pending deletion
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>!deletedIds.includes(id));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map($2fc412f4c8af7d4e$var$mapIdToCommentSortInfo(comments)).sort($2fc412f4c8af7d4e$var$compareComments).map((comment)=>comment.id);
    return sortedIds;
});
const $2fc412f4c8af7d4e$export$3b3d01d442cb684a = (0, $8aR1q.selectorWithCondition)((0, $gIyTt.isJsmTimelineEnabled), $2fc412f4c8af7d4e$var$visibleCommentIdsSelectorNew, $2fc412f4c8af7d4e$var$visibleCommentIdsSelectorOld);
const $2fc412f4c8af7d4e$var$compareCommentsInclSortOrderType = (sortOrderType)=>(a, b)=>{
        if (a.eventOccurredAt && b.eventOccurredAt && (0, $78IOp.default)(a.eventOccurredAt, b.eventOccurredAt) === 0) return sortOrderType === (0, $25476979aca7c7e0$export$e86669f498228fff) ? (0, $78IOp.default)(a.createdDate, b.createdDate) : (0, $kirCf.default)(a.createdDate, b.createdDate);
        const dateForA = a.eventOccurredAt ? a.eventOccurredAt : a.createdDate;
        const dateForB = b.eventOccurredAt ? b.eventOccurredAt : b.createdDate;
        return sortOrderType === (0, $25476979aca7c7e0$export$e86669f498228fff) ? (0, $78IOp.default)(dateForA, dateForB) : (0, $kirCf.default)(dateForA, dateForB);
    };
const $2fc412f4c8af7d4e$var$sortedVisibleCommentIdsSelectorOld = (0, $df4Sl.createSelector)((0, $gzLYm.getSelectedActivitySortOrder), $2fc412f4c8af7d4e$export$f82d111da9150583, $2fc412f4c8af7d4e$export$9832028921909a8f, (sortOrderType, comments, deletedIds)=>{
    // filter out any comments currently pending deletion
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>!deletedIds.includes(id));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map((id)=>{
        const comment = comments[id];
        return {
            id: id,
            createdDate: new Date(comment.createdDate)
        };
    }).sort((a, b)=>sortOrderType === (0, $25476979aca7c7e0$export$e86669f498228fff) ? (0, $78IOp.default)(a.createdDate, b.createdDate) : (0, $kirCf.default)(a.createdDate, b.createdDate)).map((comment)=>comment.id);
    return sortedIds;
});
const $2fc412f4c8af7d4e$var$sortedVisibleCommentIdsSelectorNew = (0, $df4Sl.createSelector)((0, $gzLYm.getSelectedActivitySortOrder), $2fc412f4c8af7d4e$export$f82d111da9150583, $2fc412f4c8af7d4e$export$9832028921909a8f, (sortOrderType, comments, deletedIds)=>{
    // filter out any comments currently pending deletion
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>!deletedIds.includes(id));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map($2fc412f4c8af7d4e$var$mapIdToCommentSortInfo(comments)).sort($2fc412f4c8af7d4e$var$compareCommentsInclSortOrderType(sortOrderType)).map((comment)=>comment.id);
    return sortedIds;
});
const $2fc412f4c8af7d4e$export$81c523e14f04df2d = (0, $8aR1q.selectorWithCondition)((0, $gIyTt.isJsmTimelineEnabled), $2fc412f4c8af7d4e$var$sortedVisibleCommentIdsSelectorNew, $2fc412f4c8af7d4e$var$sortedVisibleCommentIdsSelectorOld);
const $2fc412f4c8af7d4e$export$6eba3f548a7f384e = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiCommentEditorSelector(commentId), (commentEditor)=>!!commentEditor && commentEditor.isEditing);
const $2fc412f4c8af7d4e$export$3a00787e516c672c = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$3b3d01d442cb684a, (state)=>state, (visibleCommentIds, state)=>visibleCommentIds.filter((commentId)=>$2fc412f4c8af7d4e$export$6eba3f548a7f384e(commentId)(state)));
const $2fc412f4c8af7d4e$export$4c04cd370caea884 = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$2bcb958351592bb9, (comments)=>comments ? Object.keys(comments).filter((key)=>typeof comments[key] === 'object') : []);
const $2fc412f4c8af7d4e$export$2e24e984817b4c7b = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$4c04cd370caea884, (state)=>state, (commentIds, state)=>commentIds.some((id)=>$2fc412f4c8af7d4e$export$6eba3f548a7f384e(id)(state)));
const $2fc412f4c8af7d4e$export$5373a6bfd674797c = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.addCommentEditorExpand || false);
const $2fc412f4c8af7d4e$export$37aee7d1ec9d42d3 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.addCommentEditorForceFocus || 0);
const $2fc412f4c8af7d4e$export$6df0ef2ac2b35c13 = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$5373a6bfd674797c, $2fc412f4c8af7d4e$var$uiAllCommentEditorsSelector, (isAddCommentEditorExpanded, commentEditors)=>isAddCommentEditorExpanded || (commentEditors ? (0, (/*@__PURE__*/$parcel$interopDefault($hvbu2)))(commentEditors).some((editor)=>editor.isEditing) : false));
const $2fc412f4c8af7d4e$export$f140c5c89826efc6 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.isCommentAttachmentInProgress);
const $2fc412f4c8af7d4e$export$82d184f5a79c6a3d = (0, $df4Sl.createSelector)((0, $jZDJX.isSimplifiedProjectSelector), (0, $jZDJX.projectTypeSelector), (isSimplified, projectType)=>!isSimplified && (projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT)));
const $2fc412f4c8af7d4e$export$e17f2dbd8456d708 = (0, $df4Sl.createSelector)((0, $jZDJX.isSimplifiedProjectSelector), (0, $jZDJX.projectTypeSelector), (isSimplified, projectType)=>!isSimplified && (projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT) || projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)));
const $2fc412f4c8af7d4e$export$2ce513eb85289331 = (0, $8aR1q.selectorWithCondition)(()=>(0, $1ybV0.ff)('jsm-restrict-internal-comment-visibility'), $2fc412f4c8af7d4e$export$e17f2dbd8456d708, $2fc412f4c8af7d4e$export$82d184f5a79c6a3d);

});
// Activity sort order
const $25476979aca7c7e0$export$eda5fe8da1abb04c = 'NEWEST_FIRST';
const $25476979aca7c7e0$export$e86669f498228fff = 'OLDEST_FIRST';

parcelRegister("f6MOn", function(module, exports) {

$parcel$export(module.exports, "SAVE_COMMENT_LOADING", () => $125592c68d6a8334$export$ea56f55e95ac48c4);
$parcel$export(module.exports, "LOADING", () => $125592c68d6a8334$export$26d55645375ca9a);
$parcel$export(module.exports, "COMPLETE", () => $125592c68d6a8334$export$1660a2d7c2fff354);
$parcel$export(module.exports, "COMMENT_VISIBILITY_PUBLIC", () => $125592c68d6a8334$export$5dd24cf16d0bbf18);
$parcel$export(module.exports, "COMMENT_VISIBILITY_TYPE_PUBLIC", () => $b9bd3ab49fd3c4c9$export$a3863626f98a38c2);

const $125592c68d6a8334$export$34e5759f24cbaeac = (value)=>value;
const $125592c68d6a8334$export$ea56f55e95ac48c4 = 'SAVE_COMMENT_LOADING';
const $125592c68d6a8334$export$26d55645375ca9a = 'LOADING';
const $125592c68d6a8334$export$1660a2d7c2fff354 = 'COMPLETE';
const $125592c68d6a8334$export$5dd24cf16d0bbf18 = {
    type: (0, $b9bd3ab49fd3c4c9$export$a3863626f98a38c2),
    value: ''
};

});
const $b9bd3ab49fd3c4c9$export$537a061b2f9c8800 = 'group';
const $b9bd3ab49fd3c4c9$export$28a8bb936dce2def = 'role';
const $b9bd3ab49fd3c4c9$export$a3863626f98a38c2 = 'public';


parcelRegister("8aR1q", function(module, exports) {

$parcel$export(module.exports, "selectorWithCondition", () => $af2d2bdf884c8cd1$export$6be2ebff06b95055);
const $af2d2bdf884c8cd1$export$6be2ebff06b95055 = (condition, selectorTrue, selectorFalse)=>{
    const selector = (...args)=>{
        if (condition()) return selectorTrue(...args);
        return selectorFalse(...args);
    };
    return selector;
};

});

parcelRegister("gIyTt", function(module, exports) {

$parcel$export(module.exports, "isJsmTimelineEnabled", () => $b83585f211a8f289$export$575e1bf822db15b5);

var $1ybV0 = parcelRequire("1ybV0");
const $b83585f211a8f289$export$575e1bf822db15b5 = ()=>(0, $1ybV0.ff)('jsm-timelines-phase-2_70gja', false);

});

parcelRegister("gzLYm", function(module, exports) {

$parcel$export(module.exports, "getSelectedActivityItem", () => $297516f6b6fa6295$export$49b8848afae8c381);
$parcel$export(module.exports, "getSelectedActivitySortOrder", () => $297516f6b6fa6295$export$7091381d8f3bc5cc);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $297516f6b6fa6295$var$getUiActivityFeed = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.activityFeed);
const $297516f6b6fa6295$export$49b8848afae8c381 = (0, $df4Sl.createSelector)($297516f6b6fa6295$var$getUiActivityFeed, (activityFeed)=>activityFeed.selectedActivityItem);
const $297516f6b6fa6295$export$7091381d8f3bc5cc = (0, $df4Sl.createSelector)($297516f6b6fa6295$var$getUiActivityFeed, (activityFeed)=>activityFeed.selectedActivitySortOrder);

});


parcelRegister("cFY86", function(module, exports) {

$parcel$export(module.exports, "isIssueLinksEnabledSelector", () => $a8031e8c92164db2$export$a8cf8910b8314c1a);
$parcel$export(module.exports, "remoteIssuesSelector", () => $a8031e8c92164db2$export$13978ee723866c4d);
$parcel$export(module.exports, "optimisticLinksDataSelector", () => $a8031e8c92164db2$export$819781ef7e99d6c7);
$parcel$export(module.exports, "hasCombinedIssueLinksSelector", () => $a8031e8c92164db2$export$8b1b2dfb6701d22c);
$parcel$export(module.exports, "combinedLinkedIssueCountSelector", () => $a8031e8c92164db2$export$7e10bfdc67ac9362);
$parcel$export(module.exports, "combinedLinksSelector", () => $a8031e8c92164db2$export$a101eb6fc884a8a0);
$parcel$export(module.exports, "issueLinkSelector", () => $a8031e8c92164db2$export$b82f4900195f5854);
$parcel$export(module.exports, "linkedIssueSelector", () => $a8031e8c92164db2$export$f5f26ceb5c86ee0);
$parcel$export(module.exports, "quickAddClickedCountSelector", () => $a8031e8c92164db2$export$d545d81c8e208408);
$parcel$export(module.exports, "isOpenedFromJsmSimilarIssuesSelector", () => $a8031e8c92164db2$export$3bf48255064c85d5);
$parcel$export(module.exports, "quickAddClickedIssueSelector", () => $a8031e8c92164db2$export$2c43c6abed5983de);
$parcel$export(module.exports, "shouldDisplayAddLinksSelector", () => $a8031e8c92164db2$export$5757979a0baa9c47);
$parcel$export(module.exports, "canCreateLinkedIssueSelector", () => $a8031e8c92164db2$export$99914e520087b170);

var $df4Sl = parcelRequire("df4Sl");

var $8blac = parcelRequire("8blac");

var $3LiTJ = parcelRequire("3LiTJ");

var $3cdA4 = parcelRequire("3cdA4");

var $03XEB = parcelRequire("03XEB");

var $jZDJX = parcelRequire("jZDJX");
/**
 * selectors for issue links
 *
 * issue links state looks like
 * issueLinks: {
 *  issueLinks: [
 *      link1,
 *      link2
 *  ],
 *  linkedIssueKeys: ['KEY-1', 'KEY-2'],
 *  linkedIssues: {
 *      'KEY-1': issue1,
 *      'KEY-2': issue2
 *  }
 * }
 */ const $a8031e8c92164db2$var$issueLinksRootSelector = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.issueLinks);
const $a8031e8c92164db2$export$a8cf8910b8314c1a = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (root)=>!!root);
const $a8031e8c92164db2$var$linksDataSelector = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.issueLinks);
const $a8031e8c92164db2$export$13978ee723866c4d = (state)=>state.entities.remoteIssueLinks.remoteIssues;
const $a8031e8c92164db2$export$819781ef7e99d6c7 = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$linksDataSelector, (issueLinks)=>issueLinks && (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))(issueLinks, (link)=>link.isOptimistic));
const $a8031e8c92164db2$var$linkedIssuesSelector = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.linkedIssues);
const $a8031e8c92164db2$export$701dc165268e44de = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks?.linkedIssueKeys || []);
const $a8031e8c92164db2$export$3c65f67962ca81cc = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$linksDataSelector, (links)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(links));
const $a8031e8c92164db2$export$8b1b2dfb6701d22c = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$linksDataSelector, $a8031e8c92164db2$export$13978ee723866c4d, (links, remoteLinks)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(links) || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(remoteLinks));
const $a8031e8c92164db2$export$7e10bfdc67ac9362 = (0, $df4Sl.createSelector)($a8031e8c92164db2$export$701dc165268e44de, $a8031e8c92164db2$export$13978ee723866c4d, (links, remoteLinks)=>links.length + remoteLinks.length);
const $a8031e8c92164db2$export$f9c1778e36ca60f9 = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$linksDataSelector, $a8031e8c92164db2$var$linkedIssuesSelector, (links, issues)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(links)) return (0, (/*@__PURE__*/$parcel$interopDefault($3cdA4)))(links).filter((link)=>!link.isDeleted && !!link.linkedIssueKey).map((link)=>({
            ...link,
            linkedIssue: issues[link.linkedIssueKey]
        })) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((linksMap, link)=>Object.assign(linksMap, {
            [link.typeName]: [
                ...linksMap[link.typeName] || [],
                link
            ]
        }), {});
    return null;
});
const $a8031e8c92164db2$export$a101eb6fc884a8a0 = (0, $df4Sl.createSelector)($a8031e8c92164db2$export$f9c1778e36ca60f9, $a8031e8c92164db2$export$13978ee723866c4d, (links, remoteIssues)=>{
    if (links == null && remoteIssues.length === 0) return null;
    const extractBasicIssueDetails = (remoteIssueLinkEntity)=>({
            id: remoteIssueLinkEntity.remoteIssueId,
            issueKey: remoteIssueLinkEntity.issueKey,
            issueLink: remoteIssueLinkEntity.issueLinkUrl,
            issueSummary: remoteIssueLinkEntity.summary,
            issueTypeIconUrl: remoteIssueLinkEntity.iconUrl
        });
    // FIXME: JIV-15410 - expected to return IssueLink[]
    return remoteIssues.reduce((combinedLinks, remoteIssue)=>{
        const { issueDetails: issueDetails, relationship: relationship, id: id, issueKey: issueKey, issueLinkUrl: issueLinkUrl, remoteIssueLinkError: remoteIssueLinkError, globalId: globalId, isSaved: isSaved, isLoading: isLoading, isOptimistic: isOptimistic, hasError: hasError, isDeleted: isDeleted } = remoteIssue;
        if (relationship != null && isDeleted !== true) return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...combinedLinks,
            [relationship]: [
                ...combinedLinks[relationship] || [],
                {
                    id: id.toString(),
                    direction: (0, $03XEB.OUTWARD_LINK_DIRECTION),
                    typeName: relationship,
                    linkedIssueKey: issueKey,
                    linkedIssue: issueDetails || extractBasicIssueDetails(remoteIssue),
                    isRemote: true,
                    globalId: globalId,
                    remoteServerHostname: new URL(issueLinkUrl).hostname,
                    remoteIssueLinkError: remoteIssueLinkError,
                    isSaved: isSaved,
                    isLoading: isLoading,
                    isOptimistic: isOptimistic,
                    hasError: hasError
                }
            ]
        };
        return combinedLinks;
    }, {
        ...links
    });
});
const $a8031e8c92164db2$export$b82f4900195f5854 = (issueLinkId)=>(0, $df4Sl.createSelector)($a8031e8c92164db2$var$linksDataSelector, (links)=>links && links[issueLinkId] || null);
const $a8031e8c92164db2$export$f5f26ceb5c86ee0 = (issueKey)=>(0, $df4Sl.createSelector)($a8031e8c92164db2$var$linkedIssuesSelector, (linkedIssues)=>linkedIssues && linkedIssues[issueKey] || null);
const $a8031e8c92164db2$export$d545d81c8e208408 = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.quickAddClicked);
const $a8031e8c92164db2$export$3bf48255064c85d5 = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>!!issueLinks?.isOpenedFromJsmSimilarIssues);
const $a8031e8c92164db2$export$2c43c6abed5983de = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.quickAddClickedIssue);
const $a8031e8c92164db2$export$5757979a0baa9c47 = (0, $df4Sl.createSelector)($a8031e8c92164db2$export$d545d81c8e208408, (count)=>!!count);
const $a8031e8c92164db2$export$99914e520087b170 = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.canCreateLinkedIssue);

});
parcelRegister("3cdA4", function(module, exports) {

var $bQoXG = parcelRequire("bQoXG");

var $b69Sx = parcelRequire("b69Sx");

var $fjnSB = parcelRequire("fjnSB");

var $jxg5X = parcelRequire("jxg5X");

var $4ZYEI = parcelRequire("4ZYEI");

var $hQ6NY = parcelRequire("hQ6NY");

var $c1eMI = parcelRequire("c1eMI");

var $bAWWz = parcelRequire("bAWWz");

var $aSldm = parcelRequire("aSldm");

var $hvbu2 = parcelRequire("hvbu2");
/** `Object#toString` result references. */ var $253d06f861bc4c67$var$mapTag = '[object Map]', $253d06f861bc4c67$var$setTag = '[object Set]';
/** Built-in value references. */ var $253d06f861bc4c67$var$symIterator = $bQoXG ? $bQoXG.iterator : undefined;
/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function $253d06f861bc4c67$var$toArray(value) {
    if (!value) return [];
    if ($jxg5X(value)) return $4ZYEI(value) ? $aSldm(value) : $b69Sx(value);
    if ($253d06f861bc4c67$var$symIterator && value[$253d06f861bc4c67$var$symIterator]) return $hQ6NY(value[$253d06f861bc4c67$var$symIterator]());
    var tag = $fjnSB(value), func = tag == $253d06f861bc4c67$var$mapTag ? $c1eMI : tag == $253d06f861bc4c67$var$setTag ? $bAWWz : $hvbu2;
    return func(value);
}
module.exports = $253d06f861bc4c67$var$toArray;

});
parcelRegister("4ZYEI", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $1c8hB = parcelRequire("1c8hB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $3a3be8dd1917bddc$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $3a3be8dd1917bddc$var$isString(value) {
    return typeof value == 'string' || !$1c8hB(value) && $hYEMs(value) && $2OY5s(value) == $3a3be8dd1917bddc$var$stringTag;
}
module.exports = $3a3be8dd1917bddc$var$isString;

});

parcelRegister("hQ6NY", function(module, exports) {
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function $cfcc92505e25a5f1$var$iteratorToArray(iterator) {
    var data, result = [];
    while(!(data = iterator.next()).done)result.push(data.value);
    return result;
}
module.exports = $cfcc92505e25a5f1$var$iteratorToArray;

});


parcelRegister("03XEB", function(module, exports) {

$parcel$export(module.exports, "INWARD_LINK_DIRECTION", () => $dc38a98d5f20359c$export$b5e2b68b0fa7f1c8);
$parcel$export(module.exports, "OUTWARD_LINK_DIRECTION", () => $dc38a98d5f20359c$export$5dec99d71ec794ba);
$parcel$export(module.exports, "BOTH_LINK_DIRECTION", () => $dc38a98d5f20359c$export$6cdcf74878b11d34);
$parcel$export(module.exports, "IssueLinkDirectionTypes", () => $dc38a98d5f20359c$export$4b7bcc27238c61b9);
const $dc38a98d5f20359c$export$b5e2b68b0fa7f1c8 = 'INWARD';
const $dc38a98d5f20359c$export$5dec99d71ec794ba = 'OUTWARD';
const $dc38a98d5f20359c$export$6cdcf74878b11d34 = 'BOTH';
const $dc38a98d5f20359c$export$4b7bcc27238c61b9 = {
    [$dc38a98d5f20359c$export$b5e2b68b0fa7f1c8]: $dc38a98d5f20359c$export$b5e2b68b0fa7f1c8,
    [$dc38a98d5f20359c$export$5dec99d71ec794ba]: $dc38a98d5f20359c$export$5dec99d71ec794ba,
    [$dc38a98d5f20359c$export$6cdcf74878b11d34]: $dc38a98d5f20359c$export$6cdcf74878b11d34
};

});


parcelRegister("9s86T", function(module, exports) {

$parcel$export(module.exports, "getPermalinkTypeAndId", () => $6e310a2be6a89df8$export$f72cac1fa8a03e80);
$parcel$export(module.exports, "getPermalinkStatus", () => $6e310a2be6a89df8$export$f79ae8c396759c89);
$parcel$export(module.exports, "getUrlPermalinkParameter", () => $6e310a2be6a89df8$export$b66f3e03c722c21c);
$parcel$export(module.exports, "WORKLOG", () => (parcelRequire("6VKiL")).WORKLOG);
$parcel$export(module.exports, "COMMENTS", () => (parcelRequire("6VKiL")).COMMENTS);
$parcel$export(module.exports, "PermalinkType", () => (parcelRequire("6VKiL")).PermalinkType);

var $5iWql = parcelRequire("5iWql");

var $53ciZ = parcelRequire("53ciZ");

var $6VKiL = parcelRequire("6VKiL");
const $6e310a2be6a89df8$export$58d3deae755361f = (0, $5iWql.default)((searchString)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parseUrl(searchString).query;
    if (params[(0, $6VKiL.PermalinkType).COMMENTS]) return {
        permalinkType: (0, $6VKiL.COMMENTS),
        permalinkId: params[(0, $6VKiL.PermalinkType).COMMENTS]
    };
    if (params[(0, $6VKiL.PermalinkType).WORKLOG]) return {
        permalinkType: (0, $6VKiL.WORKLOG),
        permalinkId: params[(0, $6VKiL.PermalinkType).WORKLOG]
    };
    return null;
});
const $6e310a2be6a89df8$export$f72cac1fa8a03e80 = ()=>$6e310a2be6a89df8$export$58d3deae755361f(window.location.search);
const $6e310a2be6a89df8$export$f79ae8c396759c89 = (targetPermalinkType)=>{
    const { permalinkId: permalinkId, permalinkType: permalinkType } = $6e310a2be6a89df8$export$f72cac1fa8a03e80() || {};
    const hasPermalink = permalinkType === targetPermalinkType && permalinkId != null;
    return {
        hasPermalink: hasPermalink,
        permalinkId: hasPermalink ? permalinkId : ''
    };
};
const $6e310a2be6a89df8$export$b66f3e03c722c21c = (id, permalinkType)=>{
    const pathName = window.location.pathname;
    let urlQueryParam = `?${permalinkType}=${id}`;
    // in backlogs/modal view, next-gen board view, or jsd queues view
    if (/\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/.test(pathName) || /\/jira\/people\/.*\/boards\/.*/.test(pathName) || pathName === '/secure/RapidBoard.jspa' || pathName.startsWith('/jira/software/projects/') && pathName.split('/')[5] === 'boards' || pathName.startsWith('/jira/servicedesk/projects/') && pathName.split('/')[5] === 'queues') {
        const url = new URL(window.location.href);
        // delete the opposite to avoid doubling up param in url
        url.searchParams.delete(permalinkType === (0, $6VKiL.PermalinkType).WORKLOG ? (0, $6VKiL.PermalinkType).COMMENTS : (0, $6VKiL.PermalinkType).WORKLOG);
        url.searchParams.set(permalinkType, id);
        urlQueryParam = url.search;
    }
    return urlQueryParam;
};

});
parcelRegister("6VKiL", function(module, exports) {

$parcel$export(module.exports, "COMMENTS", () => $5c63d4511ab79db4$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $5c63d4511ab79db4$export$df36fc05622c402);
$parcel$export(module.exports, "PermalinkType", () => $5c63d4511ab79db4$export$b18d061fc042df1a);
const $5c63d4511ab79db4$export$4cab9dfa8fc858f4 = 'Comments';
const $5c63d4511ab79db4$export$df36fc05622c402 = 'Worklog';
const $5c63d4511ab79db4$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};

});



parcelRegister("gU59E", function(module, exports) {

$parcel$export(module.exports, "default", () => $f78fb3da3b537c5c$export$2e2bcd8739ae039);
class $f78fb3da3b537c5c$export$2e2bcd8739ae039 {
    constructor(state){
        this.hasLoadedEditor = false;
        this.startTime = Math.floor(performance.now()) // start time in origin relative  millis
        ;
        this.immutableState = state;
        this.isLoadedWithPage = state.isLoadedWithPage;
    }
    lazyMetricsProps() {
        return this.immutableState.lazyMetricsProps;
    }
    getDataProvider() {
        return this.immutableState.dataProvider;
    }
    getIsFullIssue() {
        return this.immutableState.analyticsSource === 'full-issue';
    }
    getIsLoadedWithPage() {
        return this.immutableState.isLoadedWithPage;
    }
    setIsLoadedWithPage(newValue) {
        this.isLoadedWithPage = newValue;
    }
    getIsSPA() {
        return this.immutableState.isSPA;
    }
    getIsRecentIssue() {
        return this.immutableState.isRecentIssue;
    }
    getRecentIssuesCount() {
        return this.immutableState.recentIssuesCount;
    }
    getAnalyticsSource() {
        return this.immutableState.analyticsSource;
    }
    getCorrelationId() {
        return this.immutableState.correlationId;
    }
    getIssueScaleabilityReporter() {
        return this.immutableState.issueScaleabilityReporter;
    }
    getStartTime() {
        return this.startTime;
    }
    setPreviewEnd(end) {
        this.previewEnd = end === null ? 0 : Math.floor(end);
    }
    getPreviewEnd() {
        return this.previewEnd;
    }
    setFMP(end) {
        this.fmp = end === null ? 0 : Math.floor(end);
    }
    getFMP() {
        return this.fmp;
    }
    setInteractiveEnd(millisSinceEpoch) {
        this.interactiveEnd = millisSinceEpoch;
    }
    getInteractiveEnd() {
        return this.interactiveEnd;
    }
    setTrueInteractiveEnd(millisSinceEpoch) {
        this.trueInteractiveEnd = Math.floor(millisSinceEpoch);
    }
    getTrueInteractiveEnd() {
        return Math.floor(this.trueInteractiveEnd);
    }
    getHasLoadedEditor() {
        return this.hasLoadedEditor;
    }
    getIsInitial() {
        return this.getIsFullIssue() && !this.getIsSPA();
    }
    getLocation() {
        const { route: route } = this.immutableState;
        const routeName = route?.name;
        return routeName || '';
    }
}

});

parcelRegister("7YIVI", function(module, exports) {

$parcel$export(module.exports, "metricsStateSelector", () => $fe3be24289bfe219$export$8cfb2e5f509cb762);

var $df4Sl = parcelRequire("df4Sl");

var $01hTQ = parcelRequire("01hTQ");

var $5JqpU = parcelRequire("5JqpU");
const $fe3be24289bfe219$export$8cfb2e5f509cb762 = (0, $df4Sl.createSelector)((0, $5JqpU.applicationKeySelector), (0, $5JqpU.viewModeSelector), (0, $5JqpU.issueIdSelector), (analyticsKey, viewMode, issueId)=>({
        analyticsKey: analyticsKey,
        viewMode: (0, $01hTQ.getSafeViewMode)(viewMode),
        issueId: issueId
    }));

});
parcelRegister("01hTQ", function(module, exports) {

$parcel$export(module.exports, "getSafeViewMode", () => $36ca2814f036e464$export$abc152b4d639d329);

const $36ca2814f036e464$var$getViewMode = ()=>window.localStorage && window.localStorage.getItem('gh.ghx-issue-fragment-view-mode') || 'default';
const $36ca2814f036e464$var$mapPredefinedViewMode = (predefinedViewMode)=>{
    switch(predefinedViewMode){
        case 0, $935e771f19f8ea28$export$98c0ebc22792f04:
            return 'modal';
        case 0, $935e771f19f8ea28$export$705305d6da432040:
            return 'sidebar';
        default:
            return null;
    }
};
const $36ca2814f036e464$export$abc152b4d639d329 = (predefinedViewMode = null)=>$36ca2814f036e464$var$mapPredefinedViewMode(predefinedViewMode) || $36ca2814f036e464$var$getViewMode().replace(/"/g, '');

});



parcelRegister("68fMC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8d7aa218754ee9a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $dxopF = parcelRequire("dxopF");

var $dRH1v = parcelRequire("dRH1v");

var $hJ992 = parcelRequire("hJ992");

var $kyj9j = parcelRequire("kyj9j");

var $g0N0Z = parcelRequire("g0N0Z");

var $lqalZ = parcelRequire("lqalZ");

var $2W4Cf = parcelRequire("2W4Cf");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $1b2Vj = parcelRequire("1b2Vj");

var $cAorm = parcelRequire("cAorm");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a8d7aa218754ee9a$var$AssignIssueParentModal = (0, $7rh0R.lazy)(()=>(parcelRequire("f5mhf")), {
    moduleId: "./src/packages/assign-issue-parent-modal/src/index.tsx"
});
const $a8d7aa218754ee9a$export$c31df4bd766f9c35 = (state)=>{
    const analyticsSource = (0, $5JqpU.analyticsSourceSelector)(state);
    const projectId = (0, $jZDJX.projectIdSelector)(state);
    const projectIds = (0, $jZDJX.projectIdsSelector)(state);
    return {
        isOpen: (0, $cAorm.isAssignIssueParentModalOpen)(state),
        issues: (0, $cAorm.assignIssueParentModalIssuesSelector)(state),
        issueParents: (0, $jZDJX.parentLevelIssuesSelector)(state),
        issueHierarchyLevel: (0, $1b2Vj.hierarchyLevelSelector)(state),
        isSimplifiedProject: (0, $jZDJX.isSimplifiedProjectSelector)(state),
        issueParentTypeIds: (0, $1b2Vj.parentLevelIssueTypeIdsSelector)(state),
        shouldHideUnassignOption: (0, $cAorm.shouldHideUnassignOptionSelector)(state),
        parentIssueTypeName: (0, $1b2Vj.parentLevelIssueTypeNamesSelector)(state)[0],
        baseUrl: (0, $5JqpU.baseUrlSelector)(state),
        // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
        currentProjectId: projectId,
        projectIds: projectIds,
        analyticsSource: `issue-view (${String(analyticsSource)})`
    };
};
const $a8d7aa218754ee9a$export$9e6a17cf56877796 = (dispatch)=>({
        onClose: ()=>{
            dispatch((0, $2W4Cf.hideAssignIssueParentModal)());
        },
        onSubmit: (issues, issueParentId, issueParent, requestPromise)=>{
            // @ts-expect-error - Argument of type '{ type: "SET_PARENT_OPTIMISTIC"; payload: { issues: Issue[]; parentIssue: IssueParent | null; requestPromise: Promise<unknown>; }; }' is not assignable to parameter of type 'Action'.
            dispatch((0, $2W4Cf.setParentOptimistic)(issues, issueParent, requestPromise));
        }
    });
const $a8d7aa218754ee9a$var$ModalWithTransition = ({ isOpen: isOpen, onSubmit: onSubmit, ...props })=>{
    const onReady = (0, $eUqFw.useCallback)(()=>{
        (0, $g0N0Z.epicModalOpenInteraction).stop();
    }, []);
    const issueKey = (0, $hJ992.useIssueKey)();
    const { setRecentlySelectedParent: setRecentlySelectedParent } = (0, $kyj9j.useParentFieldSuggestionsCache)({
        issueKey: issueKey
    });
    const handleSubmit = (issues, issueParentId, issueParent, requestPromise)=>{
        issueParent && setRecentlySelectedParent(issueParent);
        onSubmit(issues, issueParentId, issueParent, requestPromise);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRH1v.AssignIssueParentModalBoundary), {
        packageName: "issue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a8d7aa218754ee9a$var$AssignIssueParentModal, {
        ...props,
        onReady: onReady,
        onSubmit: handleSubmit
    })));
};
var $a8d7aa218754ee9a$export$2e2bcd8739ae039 = (0, $lqalZ.connect)($a8d7aa218754ee9a$export$c31df4bd766f9c35, $a8d7aa218754ee9a$export$9e6a17cf56877796)($a8d7aa218754ee9a$var$ModalWithTransition);

});
parcelRegister("dRH1v", function(module, exports) {

$parcel$export(module.exports, "AssignIssueParentModalBoundary", () => $442934592c247c59$export$eb6171d83c7b32bb);

var $eUqFw = parcelRequire("eUqFw");

var $cyVXS = parcelRequire("cyVXS");
const $442934592c247c59$export$eb6171d83c7b32bb = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "assign-issue-parent-modal",
        ...props
    }, children);

});
parcelRegister("cyVXS", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $f96d169c5da11246$export$c3f500e812fb1bb3);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $fee69 = parcelRequire("fee69");

var $gGtKh = parcelRequire("gGtKh");
const $f96d169c5da11246$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eUqFw.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});


parcelRegister("f5mhf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('5Xulb')
        ]);
        const value = parcelRequire('3RLUO');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("5Xulb")
    ]).then(()=>parcelRequire('3RLUO'));
}

});


parcelRegister("bV8gg", function(module, exports) {

$parcel$export(module.exports, "default", () => $47f087f5dda5393f$export$2e2bcd8739ae039);

var $lqalZ = parcelRequire("lqalZ");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $2wM53 = parcelRequire("2wM53");
var $47f087f5dda5393f$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state)=>({
        applicationKey: (0, $5JqpU.applicationKeySelector)(state),
        isProjectSimplified: (0, $jZDJX.isSimplifiedProjectSelector)(state)
    }), {})((0, $2wM53.default));

});
parcelRegister("2wM53", function(module, exports) {

$parcel$export(module.exports, "default", () => $282dcc89d7cb2af6$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props
const $282dcc89d7cb2af6$var$Banner = ({ renderTopBanner: renderTopBanner, applicationKey: applicationKey, isProjectSimplified: isProjectSimplified })=>renderTopBanner ? renderTopBanner(applicationKey, isProjectSimplified) : null;
var $282dcc89d7cb2af6$export$2e2bcd8739ae039 = $282dcc89d7cb2af6$var$Banner;

});


parcelRegister("bS6yX", function(module, exports) {

$parcel$export(module.exports, "ChangeBoardingTour", () => $19bfe6a019f0fd6a$export$7a5d9e816c95cba2);

var $eUqFw = parcelRequire("eUqFw");

var $gNNLn = parcelRequire("gNNLn");

var $78VkS = parcelRequire("78VkS");
const $19bfe6a019f0fd6a$export$7a5d9e816c95cba2 = ()=>{
    const [hasEditField, hasShowMoreLink] = (0, $78VkS.useChangeboardingTourProps)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gNNLn.AsyncOptInBackOnboarding), {
        hasShowMoreLink: hasShowMoreLink,
        hasEditField: hasEditField
    });
};
var $19bfe6a019f0fd6a$export$2e2bcd8739ae039 = $19bfe6a019f0fd6a$export$7a5d9e816c95cba2;

});
parcelRegister("gNNLn", function(module, exports) {

$parcel$export(module.exports, "AsyncOptInBackOnboarding", () => $83134de4a2ee02a0$export$6ba590103d216184);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

const $83134de4a2ee02a0$export$a58518d5f598ef1a = (0, $7rh0R.lazy)(()=>(parcelRequire("i9GMc")), {
    moduleId: "./src/packages/issue/onboarding-modal/src/ui/onboarding/index.tsx"
});
const $83134de4a2ee02a0$export$6ba590103d216184 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-onboarding-modal-lazy",
        packageName: "jira-issue-onboarding-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-issue-details-onboarding-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($83134de4a2ee02a0$export$a58518d5f598ef1a, props)));

});
parcelRegister("i9GMc", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3ncsF');
        const value = parcelRequire('iy7c7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3ncsF").then(()=>parcelRequire('iy7c7'));
}

});


parcelRegister("78VkS", function(module, exports) {

$parcel$export(module.exports, "useChangeboardingTourProps", () => $69d4c86ba23d4ad0$export$240433d3eef757df);

var $f9RL0 = parcelRequire("f9RL0");

var $dZWHl = parcelRequire("dZWHl");

var $eBJVm = parcelRequire("eBJVm");

var $iWtAM = parcelRequire("iWtAM");

var $hVEzR = parcelRequire("hVEzR");
const $69d4c86ba23d4ad0$export$240433d3eef757df = ()=>{
    // Because this can be rendered in different 'locations' we need to ensure that the correct template key is used
    // otherwise we may not display the appropriate always primary and visible fields.
    const templateKey = (0, $eBJVm.useTemplateRendererKey)();
    const [{ visibleItems: visibleItems, hiddenItems: hiddenItems }] = (0, $hVEzR.useVisibleHiddenItems)((0, $iWtAM.ALWAYS_PRIMARY_AND_VISIBLE)[templateKey]);
    const hasVisibleAssignee = visibleItems.map((0, $dZWHl.getLayoutItemId)).some((id)=>id === (0, $f9RL0.ASSIGNEE));
    const hasHiddenItems = hiddenItems.length > 0;
    return [
        hasVisibleAssignee,
        hasHiddenItems
    ];
};

});
parcelRegister("eBJVm", function(module, exports) {

$parcel$export(module.exports, "useTemplateRendererKey", () => $e9472aeec5033994$export$91e99709cb9898a6);

var $7ZZxN = parcelRequire("7ZZxN");

var $hJ992 = parcelRequire("hJ992");

var $iWtAM = parcelRequire("iWtAM");

var $guDlK = parcelRequire("guDlK");
const $e9472aeec5033994$export$91e99709cb9898a6 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 0, $iWtAM.JSD_TEMPLATE;
        case 0, $7ZZxN.CORE_PROJECT:
            return 0, $iWtAM.JWM_TEMPLATE;
        default:
            return 0, $iWtAM.DEFAULT_TEMPLATE;
    }
};

});
parcelRegister("iWtAM", function(module, exports) {

$parcel$export(module.exports, "JSD_TEMPLATE", () => $2ac51fa9ec343237$export$c4a928b7b9d2e600);
$parcel$export(module.exports, "JWM_TEMPLATE", () => $2ac51fa9ec343237$export$d4a666f9dfb7b24b);
$parcel$export(module.exports, "DEFAULT_TEMPLATE", () => $2ac51fa9ec343237$export$2c7bf01e7a415e01);
$parcel$export(module.exports, "SLA_PANEL_ID", () => $2ac51fa9ec343237$export$5b6db4b03a303e65);
$parcel$export(module.exports, "ALWAYS_PRIMARY_AND_VISIBLE", () => $2ac51fa9ec343237$export$7fb5d6aa1d55189);

var $lO4Or = parcelRequire("lO4Or");
const $2ac51fa9ec343237$export$c4a928b7b9d2e600 = 'JSD_TEMPLATE';
const $2ac51fa9ec343237$export$d4a666f9dfb7b24b = 'JWM_TEMPLATE';
const $2ac51fa9ec343237$export$2c7bf01e7a415e01 = 'DEFAULT_TEMPLATE';
const $2ac51fa9ec343237$export$5b6db4b03a303e65 = 'sla-panel';
const $2ac51fa9ec343237$export$46936232f0c9f7c8 = 'customer-context';
const $2ac51fa9ec343237$export$7fb5d6aa1d55189 = {
    [$2ac51fa9ec343237$export$c4a928b7b9d2e600]: [
        (0, $lO4Or.SLA_PANEL_TYPE),
        (0, $lO4Or.CUSTOMER_CONTEXT_TYPE),
        (0, $lO4Or.ASSET_ONBOARDING_TYPE)
    ],
    /*
	 * The Dev Panel is a JSW only field, but because of the way the JSW plugin creates the field it is
	 * also available in Core as well, and therefore needs to be considered in the default template.
	 */ [$2ac51fa9ec343237$export$d4a666f9dfb7b24b]: [
        (0, $lO4Or.DEV_SUMMARY_TYPE)
    ],
    [$2ac51fa9ec343237$export$2c7bf01e7a415e01]: [
        (0, $lO4Or.DEV_SUMMARY_TYPE)
    ]
};

});


parcelRegister("hVEzR", function(module, exports) {

$parcel$export(module.exports, "useVisibleHiddenItems", () => $68acdf49db09faf5$export$dfabd711083401bb);

var $eUqFw = parcelRequire("eUqFw");

var $bwbFz = parcelRequire("bwbFz");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $dZWHl = parcelRequire("dZWHl");

var $g8to1 = parcelRequire("g8to1");

var $i3F8E = parcelRequire("i3F8E");
const $68acdf49db09faf5$var$EMPTY_ARRAY = [];
const $68acdf49db09faf5$export$dfabd711083401bb = (alwaysPrimaryFieldIds = [])=>{
    const items = (0, $i3F8E.usePrimarySecondaryItems)(alwaysPrimaryFieldIds);
    const { pinnedFields: pinnedFields, primaryItems: primaryItems, secondaryItems: secondaryItems, forgeItems: forgeItems, ecosystemItems: ecosystemItems, apps: apps } = items;
    const issueKey = (0, $hJ992.useIssueKey)();
    const totalItems = [
        ...pinnedFields,
        ...primaryItems,
        ...secondaryItems
    ];
    const [issueFieldsValues] = (0, $kmr29.useFieldsValues)(issueKey);
    const [initiallyHiddenSecondaryFields = $68acdf49db09faf5$var$EMPTY_ARRAY, initiallyVisibleSecondaryFields = $68acdf49db09faf5$var$EMPTY_ARRAY] = (0, (/*@__PURE__*/$parcel$interopDefault($bwbFz)))(secondaryItems, (item)=>(0, $g8to1.isEmpty)(issueFieldsValues?.[(0, $dZWHl.getLayoutItemId)(item)]));
    const [hiddenSecondaryFields, setHiddenSecondaryFields] = (0, $eUqFw.useState)(initiallyHiddenSecondaryFields);
    const [visibleSecondaryFields, setVisibleSecondaryFields] = (0, $eUqFw.useState)(initiallyVisibleSecondaryFields);
    const [pinnedFieldsLength, setPinnedFieldsLength] = (0, $eUqFw.useState)(pinnedFields.length);
    const [totalItemsLength, setTotalItemsLength] = (0, $eUqFw.useState)(totalItems.length);
    const updateHiddenSecondaryFields = ()=>{
        const hiddenItemsArray = secondaryItems.filter((item)=>(0, $g8to1.isEmpty)(issueFieldsValues?.[(0, $dZWHl.getLayoutItemId)(item)]));
        const visibleSecondaryItems = secondaryItems.filter((item)=>!(0, $g8to1.isEmpty)(issueFieldsValues?.[(0, $dZWHl.getLayoutItemId)(item)]));
        setHiddenSecondaryFields(hiddenItemsArray);
        setVisibleSecondaryFields(visibleSecondaryItems);
    };
    const hasPinnedFieldsChanged = pinnedFieldsLength !== pinnedFields.length;
    if (hasPinnedFieldsChanged) {
        setPinnedFieldsLength(pinnedFields.length);
        updateHiddenSecondaryFields();
    }
    const hasItemsLengthChanged = totalItemsLength !== totalItems.length;
    if (hasItemsLengthChanged) {
        setTotalItemsLength(totalItems.length);
        updateHiddenSecondaryFields();
    }
    const layout = {
        pinnedFields: // Pinned fields at the top
        pinnedFields,
        // Details
        visibleItems: [
            ...primaryItems,
            ...visibleSecondaryFields,
            ...forgeItems,
            ...ecosystemItems
        ],
        // Fields with no values set get hidden in a separate panel at the bottom
        hiddenItems: hiddenSecondaryFields,
        apps: apps
    };
    return [
        layout,
        updateHiddenSecondaryFields
    ];
};

});
parcelRegister("i3F8E", function(module, exports) {

$parcel$export(module.exports, "usePrimarySecondaryItems", () => $f7a6e584df9c73b7$export$e18294397c0f3133);

var $lyOYo = parcelRequire("lyOYo");


var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");
var $8411R = parcelRequire("8411R");

var $uo395 = parcelRequire("uo395");

var $bLiXo = parcelRequire("bLiXo");

var $2V7AK = parcelRequire("2V7AK");

var $dZWHl = parcelRequire("dZWHl");
var $fCyzk = parcelRequire("fCyzk");

var $lO4Or = parcelRequire("lO4Or");

var $guDlK = parcelRequire("guDlK");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");

var $6bhHe = parcelRequire("6bhHe");

var $4sNXH = parcelRequire("4sNXH");
const $f7a6e584df9c73b7$var$emptyLayout = ()=>({
        primaryItems: [],
        secondaryItems: [],
        ecosystemItems: [],
        forgeItems: [],
        pinnedFields: [],
        apps: {
            contextPanels: []
        }
    });
// devSummary is a mandatory field, however we only add it to nextGen here cause nextGen and classic treat it differently.
// in a classic project devSummary field is always added to layout config and cannot be removed from there (although can be hidden)
// and therefore is always part of API response.
// We don't have this for next gen and hence need to add it on frontend.
const $f7a6e584df9c73b7$var$nextGenMandatoryFields = [
    {
        type: (0, $bLiXo.layoutContainerItemTypes).panel,
        panelItemId: (0, $lO4Or.DEV_SUMMARY_TYPE)
    }
];
const $f7a6e584df9c73b7$export$e18294397c0f3133 = (alwaysPrimaryFieldIds = [])=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const { ecosystemEnabled: ecosystemEnabled } = (0, $guDlK.useProjectConfiguration)(projectKey);
    const projectContext = (0, $guDlK.useProjectContext)(projectKey);
    const [pinnedFields] = (0, $uo395.usePinnedFields)(issueKey);
    const [ecosystemGlances] = (0, $2V7AK.useEcosystemGlances)();
    const [ecosystemContextPanelsItems] = (0, $2V7AK.useEcosystemContextPanels)();
    const [primaryItems] = (0, $fCyzk.useLayoutContainerByType)(issueKey, 'PRIMARY');
    const [secondaryItems] = (0, $fCyzk.useLayoutContainerByType)(issueKey, 'SECONDARY');
    const [issueFieldsValues] = (0, $kmr29.useFieldsValues)(issueKey);
    const [{ value: issueFieldsConfig }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    const [timeTrackingConfiguration] = (0, $6bhHe.useTimeTrackingConfiguration)();
    const [permissions] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const analyticsSource = (0, $hJ992.useAnalyticsSource)();
    const forgeGlanceItems = (0, $4sNXH.useForgeGlancesAsLayoutItems)();
    const forgeContextPanelItems = (0, $4sNXH.useForgeContextPanelsAsLayoutItems)();
    const isNextGen = projectContext === undefined ? false : projectContext.isSimplified;
    const estimationStatisticFieldId = (0, $hJ992.useEstimationStatistic)();
    if (!issueFieldsConfig) return $f7a6e584df9c73b7$var$emptyLayout();
    const ecosystemGlanceLayoutItems = (0, $4sNXH.ecosystemGlancesToLayoutItem)(ecosystemGlances);
    const forgeGlanceLayoutItems = ecosystemEnabled === true ? forgeGlanceItems : [];
    const ecosystemContextPanelItems = (0, $4sNXH.ecosystemContextsToLayoutItem)(ecosystemContextPanelsItems);
    const isNativeJiraTimeTrackingEnabled = timeTrackingConfiguration.isTimeTrackingEnabled && issueFieldsConfig[0, $lO4Or.TIME_TRACKING_TYPE] !== undefined;
    const isMobile = analyticsSource === (0, $0100842672acae20$export$ce88447986394f2d);
    const canLogWork = isNativeJiraTimeTrackingEnabled && permissions.canLogWork && !isMobile;
    const items = [
        ...primaryItems,
        ...secondaryItems,
        ...isNextGen ? $f7a6e584df9c73b7$var$nextGenMandatoryFields : []
    ];
    const dedupedItems = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(items, (0, $dZWHl.getLayoutItemId));
    const layout = $f7a6e584df9c73b7$var$emptyLayout();
    const pinnedFieldsSet = new Set(pinnedFields);
    const alwaysPrimaryFieldsSet = new Set(alwaysPrimaryFieldIds);
    const secondaryItemFieldsSet = new Set(secondaryItems.map((item)=>(0, $dZWHl.getLayoutItemId)(item)) || []);
    dedupedItems.forEach((contextItem)=>{
        const id = (0, $dZWHl.getLayoutItemId)(contextItem);
        if (pinnedFieldsSet.has(id)) return;
        // 1. The estimation statistic field ID state only exists on pages that need it. On those
        // pages, the field must be a primary item, regardless of the issue layout configuration.
        // 2. Products can specify field IDs they want to hoist into the primary items at all times.
        if (id === estimationStatisticFieldId || alwaysPrimaryFieldsSet.has(id)) {
            layout.primaryItems.push(contextItem);
            return;
        }
        // Empty read-only fields should be skipped
        if ((0, $4sNXH.shouldHideNullUneditableField)(id, issueFieldsConfig, issueFieldsValues?.[id], canLogWork, isNativeJiraTimeTrackingEnabled)) return;
        if (secondaryItemFieldsSet.has(id)) layout.secondaryItems.push(contextItem);
        else layout.primaryItems.push(contextItem);
    });
    layout.primaryItems = (0, $4sNXH.addChangeboardingRefToFirstItem)([
        ...layout.primaryItems
    ]);
    layout.ecosystemItems = ecosystemGlanceLayoutItems;
    layout.forgeItems = forgeGlanceLayoutItems;
    layout.pinnedFields = (0, $4sNXH.getPinnedFieldItems)(dedupedItems, pinnedFields);
    layout.apps.contextPanels = [
        ...ecosystemContextPanelItems,
        ...forgeContextPanelItems
    ];
    return layout;
};

});
parcelRegister("uo395", function(module, exports) {

$parcel$export(module.exports, "fieldPinButtonSelectorName", () => $419c27286bf0e967$export$81b416e5079a19d);
$parcel$export(module.exports, "FIELD_PIN_BUTTON_COMPONENT_SELECTOR", () => $419c27286bf0e967$export$6283d7e3dfea3fc0);
$parcel$export(module.exports, "unpinnedIconWrapperSelectorName", () => $419c27286bf0e967$export$5ac005c8855961e4);
$parcel$export(module.exports, "UNPINNED_ICON_WRAPPER_COMPONENT_SELECTOR", () => $419c27286bf0e967$export$ce49ab4122be954d);
$parcel$export(module.exports, "fieldPinWithButtonSelectorName", () => $419c27286bf0e967$export$66eb55d72c2996fe);
$parcel$export(module.exports, "PIN_BUTTON_WRAPPER_COMPONENT_SELECTOR", () => $419c27286bf0e967$export$f76e9f356c65c948);
$parcel$export(module.exports, "isFieldPinned", () => $419c27286bf0e967$export$15d2e586d5f57232);
$parcel$export(module.exports, "encodePinnedFields", () => $419c27286bf0e967$export$a26485c67d3d39ab);
$parcel$export(module.exports, "usePinnedFields", () => $419c27286bf0e967$export$ef3db8d9ff40b53a);

var $eUqFw = parcelRequire("eUqFw");

var $i9pAn = parcelRequire("i9pAn");

var $guDlK = parcelRequire("guDlK");

var $7h6vQ = parcelRequire("7h6vQ");
const $419c27286bf0e967$export$177569d991526294 = {
    PINNED_FIELDS: 'jira.user.issue.details.pinned-fields',
    ATTACHMENT_VIEW: 'jira.user.issue.attachment.view'
};
const $419c27286bf0e967$export$81b416e5079a19d = 'jira-issue-field-pin-field-pin-button';
const $419c27286bf0e967$export$6283d7e3dfea3fc0 = `[data-component-selector="${$419c27286bf0e967$export$81b416e5079a19d}"]`;
const $419c27286bf0e967$export$5ac005c8855961e4 = 'jira-issue-field-pin-unpinned-icon-wrapper';
const $419c27286bf0e967$export$ce49ab4122be954d = `[data-component-selector="${$419c27286bf0e967$export$5ac005c8855961e4}"]`;
const $419c27286bf0e967$export$66eb55d72c2996fe = 'jira-issue-field-pin-with-button-wrapper';
const $419c27286bf0e967$export$f76e9f356c65c948 = `[data-component-selector="${$419c27286bf0e967$export$66eb55d72c2996fe}"]`;
const $419c27286bf0e967$export$14202689ff202a64 = 255;
const $419c27286bf0e967$export$21fad9415db37df = (projectKey)=>{
    if (!projectKey) return $419c27286bf0e967$export$177569d991526294.PINNED_FIELDS;
    return `${$419c27286bf0e967$export$177569d991526294.PINNED_FIELDS}.${projectKey}`;
};
const $419c27286bf0e967$export$15d2e586d5f57232 = (pinnedFields, fieldId)=>{
    if (!pinnedFields || !Array.isArray(pinnedFields || !fieldId)) return false;
    return pinnedFields.includes(fieldId);
};
const $419c27286bf0e967$export$dc516a57c030b84a = (pinnedFields)=>{
    if (pinnedFields === undefined || pinnedFields === null || pinnedFields === '' || pinnedFields === 'null') return [];
    // TODO: Temporary until preferences API is extended (the .trim())
    return pinnedFields.trim().split(',');
};
const $419c27286bf0e967$export$a26485c67d3d39ab = (pinnedFields)=>{
    // Null value will delete the preference key
    if (pinnedFields.filter((e)=>typeof e === 'string' && e !== '').length === 0) return 'null';
    return pinnedFields.join(',');
};
const $419c27286bf0e967$export$ef3db8d9ff40b53a = (issueKey)=>{
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const preferenceName = $419c27286bf0e967$export$21fad9415db37df(projectKey);
    const [rawPinnedFields, setPinnedFieldsUserPreferences] = (0, $i9pAn.useUserPreferencesValue)(preferenceName);
    const pinnedFields = $419c27286bf0e967$export$dc516a57c030b84a(rawPinnedFields);
    const setPinnedFields = (newPinnedFields)=>{
        const encoded = $419c27286bf0e967$export$a26485c67d3d39ab(newPinnedFields);
        if (newPinnedFields.length > 0) {
            if (encoded.length > $419c27286bf0e967$export$14202689ff202a64) return false;
            setPinnedFieldsUserPreferences.setValue(encoded);
            return true;
        }
        setPinnedFieldsUserPreferences.deleteValue();
        return true;
    };
    if ((0, $7h6vQ.isSortingPinnedFieldsEnabled)()) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- Move callback to setPinnedFields when cleaning isSortingPinnedFieldsEnabled https://hello.atlassian.net/browse/DEE-914
        const setPinnedFieldsWithFF = (0, $eUqFw.useCallback)((newPinnedFields)=>{
            const encoded = $419c27286bf0e967$export$a26485c67d3d39ab(newPinnedFields);
            if (newPinnedFields.length > 0) {
                if (encoded.length > $419c27286bf0e967$export$14202689ff202a64) return false;
                setPinnedFieldsUserPreferences.setValue(encoded);
                return true;
            }
            setPinnedFieldsUserPreferences.deleteValue();
            return true;
        }, [
            setPinnedFieldsUserPreferences
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks -- Remove ternary when cleaning isSortingPinnedFieldsEnabled https://hello.atlassian.net/browse/DEE-914
        const sortPinnedField = (0, $eUqFw.useCallback)((idSource, idDestination, hasMovedUp)=>{
            const decodedFields = $419c27286bf0e967$export$dc516a57c030b84a(rawPinnedFields);
            const indexSource = decodedFields.indexOf(idSource);
            if (indexSource === -1) return;
            decodedFields.splice(indexSource, 1);
            let indexDestination = decodedFields.indexOf(idDestination);
            if (indexDestination === -1) return;
            if (!hasMovedUp) indexDestination += 1;
            decodedFields.splice(indexDestination, 0, idSource);
            setPinnedFieldsWithFF(decodedFields);
        }, [
            rawPinnedFields,
            setPinnedFieldsWithFF
        ]);
        return [
            pinnedFields,
            setPinnedFields,
            sortPinnedField
        ];
    }
    return [
        pinnedFields,
        setPinnedFields
    ];
};

});
parcelRegister("i9pAn", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesValue", () => $0735c0eb8f9298bc$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $0735c0eb8f9298bc$export$eefe4b2985e8203e);

var $eUqFw = parcelRequire("eUqFw");

var $lNFDn = parcelRequire("lNFDn");

var $duUIT = parcelRequire("duUIT");
const $0735c0eb8f9298bc$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const baseUrl = '';
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $lNFDn.useUserPreferencesStoreValue)(userPreferenceKey);
    const setValue = (0, $eUqFw.useCallback)((newValue)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        return (0, $duUIT.saveUserPreferenceValue)(baseUrl, userPreferenceKey, newValue);
    }, [
        baseUrl,
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $eUqFw.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $duUIT.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
    }, [
        baseUrl,
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    const setUserPreferences = (0, $eUqFw.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue
        }), [
        setValue,
        deleteValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $0735c0eb8f9298bc$export$eefe4b2985e8203e = ()=>{
    const baseUrl = '';
    const [, actions] = (0, $lNFDn.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $eUqFw.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $duUIT.saveUserPreferenceValue)(baseUrl, userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $duUIT.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions,
        baseUrl
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("lNFDn", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $c14aa03e7fb8e4ad$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $c14aa03e7fb8e4ad$export$4d156074562bac9a);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $fB99X = parcelRequire("fB99X");
const $c14aa03e7fb8e4ad$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $fB99X.actions
});
const $c14aa03e7fb8e4ad$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $c14aa03e7fb8e4ad$export$46e7eeb2fc34fab8 = (0, $ggKAj.createHook)($c14aa03e7fb8e4ad$export$6f57813fe9f31bf9, {
    selector: $c14aa03e7fb8e4ad$var$getUserPreference
});
const $c14aa03e7fb8e4ad$export$4d156074562bac9a = (0, $ggKAj.createHook)($c14aa03e7fb8e4ad$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("fB99X", function(module, exports) {

$parcel$export(module.exports, "actions", () => $15d29e400e18f42d$export$e324594224ef24da);
const $15d29e400e18f42d$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $15d29e400e18f42d$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $15d29e400e18f42d$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $15d29e400e18f42d$export$df0a4f67b9888111 = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $15d29e400e18f42d$export$e324594224ef24da = {
    setUserPreferenceValue: $15d29e400e18f42d$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $15d29e400e18f42d$var$deleteUserPreferenceValue,
    setUserPreferences: $15d29e400e18f42d$var$setUserPreferences,
    getUserPreferenceValue: $15d29e400e18f42d$export$df0a4f67b9888111
};

});


parcelRegister("duUIT", function(module, exports) {

$parcel$export(module.exports, "saveUserPreferenceValue", () => $15d896639d90b0d5$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $15d896639d90b0d5$export$a60a810760d07867);

var $lRmyA = parcelRequire("lRmyA");
const $15d896639d90b0d5$export$bebe1b9e9f4cbf16 = async (baseUrl, userPreferenceKey, value)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    });
const $15d896639d90b0d5$export$a60a810760d07867 = async (baseUrl, userPreferenceKey)=>(0, $lRmyA.performDeleteRequest)(`${baseUrl}/rest/api/2/mypreferences?key=${userPreferenceKey}`);

});


parcelRegister("7h6vQ", function(module, exports) {

$parcel$export(module.exports, "isSortingPinnedFieldsEnabled", () => $be4779056e2d7419$export$cce5c39a2a1dacf1);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $1ybV0 = parcelRequire("1ybV0");
const $be4779056e2d7419$export$e6ec1a9a62cbf071 = 'issue.details.sorting-pinned-fields';
const $be4779056e2d7419$export$cce5c39a2a1dacf1 = ()=>(0, $1ybV0.ff)('issue.details.sorting-pinned-fields', false); // </wviveiro>

});


parcelRegister("2V7AK", function(module, exports) {

$parcel$export(module.exports, "useEcosystemGlances", () => $f1f9da171478d60b$export$b3c06b6a58d82cd3);
$parcel$export(module.exports, "useEcosystemContextPanels", () => $f1f9da171478d60b$export$27e3db7432b1e803);
$parcel$export(module.exports, "useEcosystemContentPanel", () => $f1f9da171478d60b$export$f686d4345ef2726d);
$parcel$export(module.exports, "useEcosystemGlancePanel", () => $f1f9da171478d60b$export$eeeed30e794424c0);
$parcel$export(module.exports, "useIsTempoInstalled", () => $f1f9da171478d60b$export$ad8c7ffbb8b02bed);
$parcel$export(module.exports, "useEcosystemActions", () => $f1f9da171478d60b$export$4f622c941bb4766f);
$parcel$export(module.exports, "useIsEcosystemDataLoadedFor", () => $f1f9da171478d60b$export$2db1e36df11116a2);


var $2GHKf = parcelRequire("2GHKf");
const $f1f9da171478d60b$export$b3c06b6a58d82cd3 = ()=>{
    const [glances] = (0, $2GHKf.useEcosystemStoreGlancePanels)();
    return [
        glances
    ];
};
const $f1f9da171478d60b$export$27e3db7432b1e803 = ()=>{
    const [contextPanels] = (0, $2GHKf.useEcosystemStoreContextPanels)();
    return [
        contextPanels
    ];
};
const $f1f9da171478d60b$export$f686d4345ef2726d = (appKey, moduleKey)=>{
    const [contentPanel] = (0, $2GHKf.useEcosystemStoreContentPanels)();
    return contentPanel[appKey]?.[moduleKey];
};
const $f1f9da171478d60b$export$eeeed30e794424c0 = (appKey, moduleKey)=>{
    const [contentPanel] = $f1f9da171478d60b$export$b3c06b6a58d82cd3();
    return contentPanel[appKey]?.[moduleKey];
};
const $f1f9da171478d60b$export$ad8c7ffbb8b02bed = ()=>{
    const [contentPanel] = (0, $2GHKf.useEcosystemStoreContentPanels)();
    return (0, $527e387b5463bb8f$export$55e70cfe49cb8f44) in contentPanel;
};
const $f1f9da171478d60b$export$4f622c941bb4766f = ()=>{
    const [, { setEcosystem: setEcosystem }] = (0, $2GHKf.useEcosystemActionsStore)();
    return [
        undefined,
        {
            setEcosystem: setEcosystem
        }
    ];
};
const $f1f9da171478d60b$export$2db1e36df11116a2 = (issueKey)=>(0, $2GHKf.useEcosystemStoreKey)() === issueKey;

});
const $527e387b5463bb8f$export$55e70cfe49cb8f44 = 'io.tempo.jira';

parcelRegister("2GHKf", function(module, exports) {

$parcel$export(module.exports, "EcosystemStoreContainer", () => $560f3a8f4df13647$export$524b5c6ceec20831);
$parcel$export(module.exports, "useEcosystemStoreContentPanels", () => $560f3a8f4df13647$export$c831458e82b348a5);
$parcel$export(module.exports, "useEcosystemStoreContextPanels", () => $560f3a8f4df13647$export$d10193f47c81cda5);
$parcel$export(module.exports, "useEcosystemStoreGlancePanels", () => $560f3a8f4df13647$export$18fe684002aa76e9);
$parcel$export(module.exports, "useEcosystemStoreKey", () => $560f3a8f4df13647$export$1ef0ed59215cf7c3);
$parcel$export(module.exports, "useEcosystemActionsStore", () => $560f3a8f4df13647$export$922ed2a0b249560a);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $IDAT3 = parcelRequire("IDAT3");
const $560f3a8f4df13647$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-view-layout-ecosystem-service',
    initialState: {
        activityPanels: {},
        canInstallAddons: false,
        contentPanels: {},
        backgroundScripts: [],
        ecosystemOnDate: 0,
        glances: {},
        contextPanels: {},
        operations: [],
        issueKey: ''
    },
    actions: $IDAT3
});
const $560f3a8f4df13647$export$524b5c6ceec20831 = (0, $heB5U.createContainer)($560f3a8f4df13647$export$6f57813fe9f31bf9);
const $560f3a8f4df13647$export$c831458e82b348a5 = (0, $ggKAj.createHook)($560f3a8f4df13647$export$6f57813fe9f31bf9, {
    selector: (state)=>state.contentPanels
});
const $560f3a8f4df13647$export$d10193f47c81cda5 = (0, $ggKAj.createHook)($560f3a8f4df13647$export$6f57813fe9f31bf9, {
    selector: (state)=>state.contextPanels
});
const $560f3a8f4df13647$export$18fe684002aa76e9 = (0, $ggKAj.createHook)($560f3a8f4df13647$export$6f57813fe9f31bf9, {
    selector: (state)=>state.glances
});
const $560f3a8f4df13647$export$1ef0ed59215cf7c3 = (0, $ggKAj.createStateHook)($560f3a8f4df13647$export$6f57813fe9f31bf9, {
    selector: (state)=>state.issueKey
});
const $560f3a8f4df13647$export$922ed2a0b249560a = (0, $ggKAj.createHook)($560f3a8f4df13647$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("IDAT3", function(module, exports) {

$parcel$export(module.exports, "setEcosystem", () => $3295d3491910458a$export$a38245f38447fc7);
const $3295d3491910458a$export$a38245f38447fc7 = (ecosystem, issueKey)=>({ setState: setState })=>{
        if (ecosystem) setState({
            ...ecosystem,
            issueKey: issueKey
        });
    };

});



parcelRegister("fCyzk", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainers", () => $e36b02950fa95313$export$d146dfa0384f99a3);
$parcel$export(module.exports, "useLayoutContainerByType", () => $e36b02950fa95313$export$5f49a43487b268);
$parcel$export(module.exports, "useIssueLayoutGlance", () => $e36b02950fa95313$export$fd7f0cc3d2b405e6);
$parcel$export(module.exports, "useIssueLayoutContextPanel", () => $e36b02950fa95313$export$5962da0433486667);
$parcel$export(module.exports, "useIssueLayoutActions", () => $e36b02950fa95313$export$1e5e9fc877a47cd9);

var $eUqFw = parcelRequire("eUqFw");

var $iccB7 = parcelRequire("iccB7");

var $i4Rdz = parcelRequire("i4Rdz");

var $dZWHl = parcelRequire("dZWHl");
const $e36b02950fa95313$export$d146dfa0384f99a3 = (issueKey)=>{
    const [containers] = (0, $i4Rdz.useIssueLayoutContainersStore)(issueKey);
    return [
        containers
    ];
};
const $e36b02950fa95313$export$5f49a43487b268 = (issueKey, type)=>{
    const [containers] = (0, $i4Rdz.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    // Forge app with UI Modifications module can hide selected fields using
    // UI modifications Field API. We are removing them here from the layout fields
    const fieldsHiddenByUim = (0, $iccB7.useEnabledHiddenFields)();
    return [
        (0, $dZWHl.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim)
    ];
};
const $e36b02950fa95313$export$fd7f0cc3d2b405e6 = (issueKey)=>{
    const [glance] = (0, $i4Rdz.useIssueLayoutGlanceStore)(issueKey);
    return [
        glance
    ];
};
const $e36b02950fa95313$export$5962da0433486667 = (issueKey)=>{
    const [contextPanel] = (0, $i4Rdz.useIssueLayoutContextPanelStore)(issueKey);
    return [
        contextPanel
    ];
};
const $e36b02950fa95313$export$1e5e9fc877a47cd9 = ()=>{
    const [, actions] = (0, $i4Rdz.useIssueLayoutActionsStore)();
    const setIssueViewContainersLayout = (0, $eUqFw.useCallback)((issueKey, containersByType)=>{
        actions.setIssueViewContainersLayout(issueKey, containersByType);
    }, [
        actions
    ]);
    const setIssueViewLayoutGlance = (0, $eUqFw.useCallback)((issueKey, glance)=>{
        actions.setIssueViewLayoutGlance(issueKey, glance);
    }, [
        actions
    ]);
    const setIssueViewLayoutContextPanel = (0, $eUqFw.useCallback)((issueKey, newContextPanel)=>{
        actions.setIssueViewLayoutContextPanel(issueKey, newContextPanel);
    }, [
        actions
    ]);
    return [
        null,
        {
            setIssueViewContainersLayout: setIssueViewContainersLayout,
            setIssueViewLayoutGlance: setIssueViewLayoutGlance,
            setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel
        }
    ];
};

});
parcelRegister("iccB7", function(module, exports) {

$parcel$export(module.exports, "useEnabledHiddenFields", () => $ac07c79a9db105e6$export$bb6c2b9159c3f32b);

var $ig7wC = parcelRequire("ig7wC");

var $j8qRK = parcelRequire("j8qRK");
const $ac07c79a9db105e6$export$bb6c2b9159c3f32b = ()=>{
    const adjustmentsAreEnabled = (0, $ig7wC.useAdjustmentsEnabled)();
    const hiddenFields = (0, $j8qRK.useHiddenFields)();
    if (!adjustmentsAreEnabled) return [];
    return hiddenFields;
};

});
parcelRegister("ig7wC", function(module, exports) {

$parcel$export(module.exports, "store", () => $1aa7dabd47e15b99$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $1aa7dabd47e15b99$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $1aa7dabd47e15b99$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $1aa7dabd47e15b99$export$5eb9c167b683d125);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

const $1aa7dabd47e15b99$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatusDeprecated: (0, $e4bc45ef063f6e5f$export$39d15f3568f5a72c),
    uiModificationsConsentStatus: {}
};
const $1aa7dabd47e15b99$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($1aa7dabd47e15b99$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatusDeprecated: (enabled)=>({ setState: setState })=>{
            setState({
                uiModificationsConsentStatusDeprecated: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $1aa7dabd47e15b99$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-adjustments-context',
    initialState: $1aa7dabd47e15b99$var$initialState,
    actions: $1aa7dabd47e15b99$export$e324594224ef24da
});
const $1aa7dabd47e15b99$export$a12f82a132dee079 = (0, $ggKAj.createHook)($1aa7dabd47e15b99$export$6f57813fe9f31bf9);
const $1aa7dabd47e15b99$export$358ad850b2f6d6fe = (0, $ggKAj.createStateHook)($1aa7dabd47e15b99$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $1aa7dabd47e15b99$export$4f2729981f4b81d2 = (0, $ggKAj.createActionsHook)($1aa7dabd47e15b99$export$6f57813fe9f31bf9);
const $1aa7dabd47e15b99$export$5eb9c167b683d125 = (0, $heB5U.createContainer)($1aa7dabd47e15b99$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});
const $e4bc45ef063f6e5f$export$39d15f3568f5a72c = 'unknown';
const $e4bc45ef063f6e5f$export$d67d63332ce3ce38 = 'required';
const $e4bc45ef063f6e5f$export$45ca911896c5084f = 'consented';


parcelRegister("j8qRK", function(module, exports) {

$parcel$export(module.exports, "useHiddenFields", () => $38e581b1f1652aa4$export$de6fdc67c945e596);

var $bj4JM = parcelRequire("bj4JM");
var $ggKAj = parcelRequire("ggKAj");

var $fcNlw = parcelRequire("fcNlw");
const $38e581b1f1652aa4$var$selectHiddenFields = (0, $bj4JM.createSelector)((state)=>state.formData, (state)=>state.appliedChanges, (formData, appliedChanges)=>{
    if (formData === null) return [];
    return Object.entries(formData).filter(([fieldId, field])=>appliedChanges?.[fieldId]?.isVisible !== undefined ? !appliedChanges[fieldId].isVisible : !field.isVisible).map(([fieldId])=>fieldId);
});
const $38e581b1f1652aa4$export$de6fdc67c945e596 = (0, $ggKAj.createStateHook)((0, $fcNlw.store), {
    selector: $38e581b1f1652aa4$var$selectHiddenFields
});

});
parcelRegister("fcNlw", function(module, exports) {

$parcel$export(module.exports, "store", () => $712150835f54079d$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $712150835f54079d$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useAnalyticsData", () => $712150835f54079d$export$45885672916a1436);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $712150835f54079d$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $712150835f54079d$export$677b3e34bd14c681);

var $8blac = parcelRequire("8blac");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $1ybV0 = parcelRequire("1ybV0");

var $2bv99 = parcelRequire("2bv99");

parcelRequire("B0Z3S");
var $lpNv8 = parcelRequire("lpNv8");
var $B0Z3S = parcelRequire("B0Z3S");
var $fxgW1 = parcelRequire("fxgW1");
var $9V8vn = parcelRequire("9V8vn");
var $5hhPg = parcelRequire("5hhPg");
var $4BYh6 = parcelRequire("4BYh6");
var $5v1Sk = parcelRequire("5v1Sk");
var $doolD = parcelRequire("doolD");
var $4QLO7 = parcelRequire("4QLO7");
var $3P2qm = parcelRequire("3P2qm");
var $lpNv8 = parcelRequire("lpNv8");
var $7mVyC = parcelRequire("7mVyC");
var $b2p8u = parcelRequire("b2p8u");
var $gwHjs = parcelRequire("gwHjs");
var $juRVB = parcelRequire("juRVB");
var $cQ3jb = parcelRequire("cQ3jb");
var $2ugNi = parcelRequire("2ugNi");
var $51sNT = parcelRequire("51sNT");

var $7h8I4 = parcelRequire("7h8I4");
var $hGbVp = parcelRequire("hGbVp");
var $lB1pd = parcelRequire("lB1pd");
const $712150835f54079d$var$name = 'issue-adjustments';
const $712150835f54079d$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    analyticsData: {},
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    buffer: {},
    bufferTimeouts: {},
    bufferErrors: null,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appsErrors: {}
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $712150835f54079d$var$triggerFieldInitializationKey, viewType: $712150835f54079d$var$scopedViewType, numberOfSupportedFields: $712150835f54079d$var$numberOfSupportedFields, ...$712150835f54079d$var$stateForResetAllFields } = $712150835f54079d$export$d4c72bab9d6cc13a;
const $712150835f54079d$var$multiAppsBufferingActions = {
    bufferChanges: $B0Z3S.bufferChanges,
    bufferTimeout: $B0Z3S.bufferTimeout,
    handleBufferAllAppsError: $fxgW1.handleBufferAllAppsError,
    sendBufferFinalMetrics: $b2p8u.sendBufferFinalMetrics,
    sendBufferConflictMetrics: $b2p8u.sendBufferConflictMetrics,
    initializeOnInitBuffer: $B0Z3S.initializeOnInitBuffer,
    clearAllBufferTimeouts: $9V8vn.clearAllBufferTimeouts,
    clearBufferForChangeId: $9V8vn.clearBufferForChangeId,
    addBufferError: $lpNv8.addBufferError,
    resetBufferErrors: $lpNv8.resetBufferErrors
};
const $712150835f54079d$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $5v1Sk.processChange,
    setFieldValue: $gwHjs.setFieldValue,
    initializeField: $5hhPg.initializeField,
    startFieldsInitialisationTimeout: $juRVB.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $juRVB.successFieldsInitalisation,
    ...$712150835f54079d$var$multiAppsBufferingActions,
    registerFields: $4QLO7.registerFields,
    unregisterFields: $4QLO7.unregisterFields,
    unregisterAllFieldsOfChangeId: $4QLO7.unregisterAllFieldsOfChangeId,
    processIframeChanges: $doolD.processIframeChanges,
    // TODO: remove updateFieldsOld with forge-ui-modifications-validation-errors-returned-to-app_hdzmw clean up
    updateFieldsOld: ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, viewContext: viewContext, environment: environment, appId: appId })=>async ({ setState: setState, getState: getState }, { viewType: viewType })=>{
            const appliedChanges = getState().appliedChanges || {};
            const formData = getState().formData || {};
            const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields, registeredFieldsDeprecated: registeredFieldsDeprecated } = getState();
            const { changesToApply: changesToApply, incomingFormData: incomingFormData } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
                // Do not update fields that are not inside initialized data.
                // Validates if the field that comes from Iframe is supported
                // - because we add to formData only the supported ones.
                const fieldData = formData[fieldId];
                const internalMetadata = internalFormMetadata[fieldId];
                const fieldIsRegistered = (0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw') ? (0, $7h8I4.fieldWasRegistered)(registeredFields, changeId, fieldId, appId) : (0, $7h8I4.fieldWasRegisteredDeprecated)(registeredFieldsDeprecated, changeId, fieldId);
                // Only registered field Ids can be updated.
                if (!fieldIsRegistered || !fieldData) {
                    // eslint-disable-next-line no-console
                    console.warn(`UIM tried to apply changes to the unregistered field ${fieldId}`);
                    (0, $2bv99.fireOperationalAnalyticsWithoutContext)('applyChanges', 'unregisteredField', viewType, {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId
                    });
                    return acc;
                }
                const lookupData = {
                    [(0, $6b8c146c2dd688bb$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                    [(0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $6b8c146c2dd688bb$export$3a106242c8f57ac2]
                };
                // It updates properties in each field to avoid removing unchanged props for
                // selected field by another app or another onChange update.
                // Only supported properties are allowed.
                const supportedFieldChanges = await (0, $lB1pd.transformFieldFromIframe)({
                    fieldType: fieldData.fieldType,
                    fieldId: fieldId,
                    fieldFromIframe: fieldsChanges?.[fieldId],
                    lookupData: lookupData,
                    viewType: viewType,
                    tenantContext: tenantContext,
                    viewContext: viewContext,
                    environment: environment
                });
                // It converts changes to 'public' format to update the formData
                const publicShapeChanges = (0, $lB1pd.transformFieldToIframe)(supportedFieldChanges, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
                const transformedFieldChanges = (0, $hGbVp.mapFieldPropsFromPublicToInternalShape)(supportedFieldChanges, viewType, fieldData.fieldType);
                const combinedChangesToApply = {
                    ...appliedChanges[fieldId],
                    ...transformedFieldChanges
                };
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(combinedChangesToApply)) {
                    (await acc).changesToApply[fieldId] = combinedChangesToApply;
                    (await acc).incomingFormData[fieldId] = {
                        ...formData[fieldId],
                        ...publicShapeChanges
                    };
                }
                return acc;
            }, Promise.resolve({
                changesToApply: {
                    ...appliedChanges
                },
                incomingFormData: {
                    ...formData
                }
            }));
            setState({
                appliedChanges: changesToApply,
                formData: incomingFormData
            });
        },
    updateFields: $2ugNi.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            if ((0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw')) dispatch((0, $9V8vn.clearAllBufferTimeouts)());
            setState($712150835f54079d$var$stateForResetAllFields);
        },
    setError: $7mVyC.setError,
    resetError: $7mVyC.resetError,
    setAnalyticsData: (analyticsData)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().analyticsData ?? {};
            setState({
                analyticsData: {
                    ...previousState,
                    ...analyticsData
                }
            });
        },
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $3P2qm.setAppErrors,
    resetAppErrors: $3P2qm.resetAppErrors,
    initializeScreenTabs: $4BYh6.initializeScreenTabs,
    updateScreenTabs: $51sNT.updateScreenTabs,
    updateActiveScreenTab: $cQ3jb.updateActiveScreenTab
};
const $712150835f54079d$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: $712150835f54079d$var$name,
    initialState: $712150835f54079d$export$d4c72bab9d6cc13a,
    actions: $712150835f54079d$export$e324594224ef24da
});
const $712150835f54079d$export$37792a602e748c08 = (0, $ggKAj.createHook)($712150835f54079d$export$6f57813fe9f31bf9);
const $712150835f54079d$var$stableEmptyFieldFromIframe = {};
const $712150835f54079d$export$df4b0714e8177e0e = (0, $ggKAj.createHook)($712150835f54079d$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $712150835f54079d$var$stableEmptyFieldFromIframe
});
const $712150835f54079d$export$45885672916a1436 = (0, $ggKAj.createHook)($712150835f54079d$export$6f57813fe9f31bf9, {
    selector: (state)=>state.analyticsData
});
const $712150835f54079d$export$cb9a014ec14556d8 = (0, $ggKAj.createActionsHook)($712150835f54079d$export$6f57813fe9f31bf9);
const $712150835f54079d$export$677b3e34bd14c681 = (0, $ggKAj.createHook)($712150835f54079d$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("2bv99", function(module, exports) {

$parcel$export(module.exports, "fireOperationalAnalyticsWithoutContext", () => $9bb7bb1bc373c32d$export$92f0a000de1dacb3);
$parcel$export(module.exports, "fireOperationalAnalyticsWithContext", () => $9bb7bb1bc373c32d$export$5ac7b3728975936c);
// jira-frontend/browse/src/packages/platform/observability/product-analytics-bridge/README.md#Tracking outside of UI

var $jMP2a = parcelRequire("jMP2a");

var $3DOEL = parcelRequire("3DOEL");
const $9bb7bb1bc373c32d$export$92f0a000de1dacb3 = (actionSubject, action, viewType, attributes = {})=>(0, $3DOEL.getAnalyticsWebClient)().getInstance().sendOperationalEvent({
        action: action,
        actionSubject: `jiraUiModifications.${actionSubject}`,
        source: viewType,
        attributes: {
            ...attributes,
            viewType: viewType
        }
    });
const $9bb7bb1bc373c32d$export$5ac7b3728975936c = (event, id, viewType, attributes = {})=>{
    (0, $jMP2a.fireOperationalAnalytics)(event, `jiraUiModifications.${id}`, {
        ...attributes,
        viewType: viewType
    });
};

});

const $6b8c146c2dd688bb$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $6b8c146c2dd688bb$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $6b8c146c2dd688bb$export$f5d5f6bb902f1027 = '-1';
const $6b8c146c2dd688bb$export$106087dcfd4fb129 = 100;

parcelRegister("B0Z3S", function(module, exports) {

$parcel$export(module.exports, "bufferChanges", () => $eb7ae82fbbeb5c60$export$15f16f4bde8a8eea);
$parcel$export(module.exports, "bufferTimeout", () => $eb7ae82fbbeb5c60$export$ada544fa4df33ac7);
$parcel$export(module.exports, "initializeOnInitBuffer", () => $eb7ae82fbbeb5c60$export$496162694df22caf);
$parcel$export(module.exports, "addBufferError", () => (parcelRequire("lpNv8")).addBufferError);
$parcel$export(module.exports, "handleBufferAllAppsError", () => (parcelRequire("fxgW1")).handleBufferAllAppsError);

var $1ybV0 = parcelRequire("1ybV0");

var $2bv99 = parcelRequire("2bv99");

var $gA4iv = parcelRequire("gA4iv");

var $7mVyC = parcelRequire("7mVyC");

var $kjZtG = parcelRequire("kjZtG");

var $ke5CN = parcelRequire("ke5CN");

var $9V8vn = parcelRequire("9V8vn");

var $fxgW1 = parcelRequire("fxgW1");

var $lpNv8 = parcelRequire("lpNv8");

var $b2p8u = parcelRequire("b2p8u");

var $3Oj61 = parcelRequire("3Oj61");
const $eb7ae82fbbeb5c60$export$b181ece3dc0959e0 = 10000;
const $eb7ae82fbbeb5c60$var$getMultiAppBufferingTimeoutMs = ()=>(0, $1ybV0.getFeatureFlagValue)('forge-ui-modifications-multi-app-buffer-timeout', $eb7ae82fbbeb5c60$export$b181ece3dc0959e0);
const $eb7ae82fbbeb5c60$export$15f16f4bde8a8eea = ({ changeId: changeId, appId: appId, fieldsChanges: fieldsChanges, context: context })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { buffer: buffer, bufferTimeouts: bufferTimeouts } = getState();
        const previousBuffer = buffer[changeId] || {};
        const previousAppBuffer = previousBuffer[appId] || {};
        const bufferForChangeId = {
            ...previousBuffer,
            [appId]: {
                ...previousAppBuffer,
                ...fieldsChanges
            }
        };
        if ((0, $ke5CN.changesReadyToApply)(bufferForChangeId)) {
            clearTimeout(bufferTimeouts[changeId]);
            try {
                await dispatch((0, $kjZtG.validateNoConflictAndApply)(bufferForChangeId, changeId, context));
            } catch (err) {
                dispatch((0, $fxgW1.handleBufferAllAppsError)({
                    err: err,
                    changeId: changeId,
                    bufferForChangeId: bufferForChangeId
                }));
            }
        } else setState({
            buffer: {
                ...buffer,
                [changeId]: bufferForChangeId
            }
        });
        if (bufferTimeouts[changeId] === undefined) {
            const timeout = setTimeout(async ()=>{
                try {
                    await dispatch($eb7ae82fbbeb5c60$export$ada544fa4df33ac7(changeId, context));
                } catch (err) {
                    dispatch((0, $fxgW1.handleBufferAllAppsError)({
                        err: err,
                        changeId: changeId,
                        bufferForChangeId: bufferForChangeId
                    }));
                }
            }, $eb7ae82fbbeb5c60$var$getMultiAppBufferingTimeoutMs());
            setState({
                bufferTimeouts: {
                    ...bufferTimeouts,
                    [changeId]: timeout
                }
            });
        }
    };
const $eb7ae82fbbeb5c60$export$ada544fa4df33ac7 = (changeId, context)=>async ({ getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { buffer: buffer, bufferErrors: bufferErrors } = getState();
        const bufferForChangeId = buffer[changeId] || {};
        const appsWithTimeout = (0, $3Oj61.findAppsWhichDidNotSendChangesBeforeTimeout)(bufferForChangeId);
        if (appsWithTimeout.length) {
            // display timeout flag only if other buffering errors did not appear previously to the user
            if (bufferErrors === null) dispatch((0, $7mVyC.setError)({
                errorCode: 'BUFFERING_TIMEOUT'
            }));
            dispatch((0, $lpNv8.addBufferError)('BUFFERING_TIMEOUT'));
            (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'buffer timeout', viewType, {
                changeId: changeId,
                allAppIds: Object.keys(bufferForChangeId).join(),
                timedOutAppIds: appsWithTimeout.join()
            });
        }
        await dispatch((0, $kjZtG.validateNoConflictAndApply)(bufferForChangeId, changeId, context));
    };
const $eb7ae82fbbeb5c60$export$496162694df22caf = (appsIds)=>({ setState: setState, getState: getState })=>{
        const { buffer: buffer } = getState();
        const bufferForOnInit = {};
        appsIds.forEach((appId)=>{
            bufferForOnInit[appId] = null;
        });
        setState({
            buffer: {
                ...buffer,
                [(0, $gA4iv.ON_INIT_CHANGE_ID)]: bufferForOnInit
            }
        });
    };

});
parcelRegister("gA4iv", function(module, exports) {

$parcel$export(module.exports, "ON_INIT_CHANGE_ID", () => $7e6df3ec5ab54baa$export$415cc1afa6445f90);
/**
 * @atlassian/jira-issue-create is still using the constants from the current issue-adjustments
 * package, this dependency should be removed in further cyclic deps fix
 */ // eslint-disable-next-line jira/export/no-external-exports

const $7e6df3ec5ab54baa$export$415cc1afa6445f90 = 'onInitChangeId';

});

parcelRegister("7mVyC", function(module, exports) {

$parcel$export(module.exports, "setError", () => $dfad354765909d34$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $dfad354765909d34$export$7e5930c6217b1d4e);

var $1ybV0 = parcelRequire("1ybV0");
const $dfad354765909d34$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: (0, $1ybV0.ff)('forge-ui-modifications-validation-errors-returned-to-app_hdzmw') ? errorProperties.fieldName : undefined
            }
        });
    };
const $dfad354765909d34$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("kjZtG", function(module, exports) {

$parcel$export(module.exports, "validateNoConflictAndApply", () => $dc51ceae4b610127$export$7c7bcb610d80b592);

var $2bv99 = parcelRequire("2bv99");

var $fsCiP = parcelRequire("fsCiP");

var $3P2qm = parcelRequire("3P2qm");

var $7mVyC = parcelRequire("7mVyC");

var $4QLO7 = parcelRequire("4QLO7");

var $2ugNi = parcelRequire("2ugNi");

var $9V8vn = parcelRequire("9V8vn");

var $lpNv8 = parcelRequire("lpNv8");

var $b2p8u = parcelRequire("b2p8u");

var $3Oj61 = parcelRequire("3Oj61");
const $dc51ceae4b610127$export$7c7bcb610d80b592 = (bufferForChangeId, changeId, context)=>async ({ dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const hasConflict = (0, $3Oj61.doBufferedChangesHaveAConflict)({
            bufferForChangeId: bufferForChangeId
        });
        const applyBufferedChangesSequentially = async ()=>{
            for (const [appId, fieldsChanges] of Object.entries(bufferForChangeId))if (fieldsChanges !== null) // In general await should not be used inside loops, because it changes parallel processing
            // of promises to sequential. In our case sequential processing is desired.
            // Without it, 2nd buffered app changes override 1st buffered app changes.
            // With sequential processing, appliedChanges are saved in UIM store before next changes are processed.
            // eslint-disable-next-line no-await-in-loop
            await applyAppChanges(fieldsChanges, appId);
        };
        const applyAppChanges = async (fieldsChanges, appId)=>{
            const { cloudId: cloudId, activationId: activationId, issueId: issueId, environment: environment, getAsyncLookupData: getAsyncLookupData } = context;
            const lookupDataFromApi = await getAsyncLookupData(fieldsChanges);
            try {
                await dispatch((0, $2ugNi.updateFields)({
                    changeId: changeId,
                    fieldsChanges: fieldsChanges,
                    lookupDataFromApi: lookupDataFromApi,
                    tenantContext: {
                        cloudId: cloudId,
                        activationId: activationId
                    },
                    viewContext: {
                        issueId: issueId
                    },
                    environment: environment,
                    appId: appId
                }));
            } catch (err) {
                if (err instanceof (0, $fsCiP.UiModificationsFieldsValidationError)) {
                    (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'fieldsChangesValidation failed', viewType, {
                        ...err.attributes
                    });
                    dispatch((0, $7mVyC.setError)({
                        errorCode: 'APPLY_BUFFER_CHANGES_ERROR'
                    }));
                    dispatch((0, $lpNv8.addBufferError)('APPLY_BUFFER_CHANGES_ERROR'));
                    // Setting app errors from transformers to pass them to the onErrorCallback
                    dispatch((0, $3P2qm.setAppErrors)({
                        errors: err.attributes.errors,
                        appId: appId
                    }));
                    return;
                }
                throw err;
            } finally{
                dispatch((0, $4QLO7.unregisterFields)({
                    changeId: changeId,
                    appId: appId
                }));
            }
        };
        if (hasConflict) {
            dispatch((0, $7mVyC.setError)({
                errorCode: 'MULTI_APP_CONFLICT'
            }));
            dispatch((0, $lpNv8.addBufferError)('MULTI_APP_CONFLICT'));
            dispatch((0, $b2p8u.sendBufferConflictMetrics)(changeId, bufferForChangeId));
        } else {
            await applyBufferedChangesSequentially();
            dispatch((0, $b2p8u.sendBufferFinalMetrics)(changeId, bufferForChangeId));
        }
        dispatch((0, $4QLO7.unregisterAllFieldsOfChangeId)(changeId));
        dispatch((0, $9V8vn.clearBufferForChangeId)({
            changeId: changeId
        }));
        dispatch((0, $lpNv8.resetBufferErrors)());
    };

});
parcelRegister("fsCiP", function(module, exports) {

$parcel$export(module.exports, "FIELD_VALIDATION_ERROR", () => $b179e025ecadff0b$export$d1996cb46a690190);
$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $b179e025ecadff0b$export$9e8b5e552e255163);
const $b179e025ecadff0b$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
class $b179e025ecadff0b$export$9e8b5e552e255163 extends Error {
    constructor(message, attributes, cause){
        super(message, cause);
        this.attributes = attributes;
    }
}

});

parcelRegister("3P2qm", function(module, exports) {

$parcel$export(module.exports, "setAppErrors", () => $a351a7797518b436$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "resetAppErrors", () => $a351a7797518b436$export$24c821207687a907);
const $a351a7797518b436$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $a351a7797518b436$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("4QLO7", function(module, exports) {

$parcel$export(module.exports, "registerFields", () => $745940e83e6bea58$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $745940e83e6bea58$export$1ca69a85bb7273de);
$parcel$export(module.exports, "unregisterAllFieldsOfChangeId", () => $745940e83e6bea58$export$973336095fd0befc);

var $kFGm5 = parcelRequire("kFGm5");

var $1ybV0 = parcelRequire("1ybV0");

var $59LUk = parcelRequire("59LUk");
const $745940e83e6bea58$export$c327a17109f9f677 = ({ nextRegisteredFields: nextRegisteredFields, changeId: changeId, buffer: buffer })=>{
    const currentBufferForChangeId = buffer[changeId] || {};
    const appsToBuffer = (0, $59LUk.findAppsToBufferForChangeId)({
        registeredFieldsMap: nextRegisteredFields,
        changeId: changeId
    });
    const bufferForChangeId = {};
    appsToBuffer.forEach((appIdToBuffer)=>{
        bufferForChangeId[appIdToBuffer] = null;
    });
    return {
        ...bufferForChangeId,
        ...currentBufferForChangeId
    };
};
const $745940e83e6bea58$var$registerFieldsFFOn = ({ getState: getState, setState: setState, changeId: changeId, appId: appId, fieldsToBeRegistered: fieldsToBeRegistered })=>{
    const { registeredFields: registeredFields, buffer: buffer } = getState();
    const appFields = registeredFields[appId] || {};
    const appChangeIdFields = appFields[changeId] || [];
    const nextRegisteredFields = {
        ...registeredFields,
        [appId]: {
            ...appFields,
            [changeId]: [
                ...appChangeIdFields,
                ...fieldsToBeRegistered
            ]
        }
    };
    const bufferForChangeId = $745940e83e6bea58$export$c327a17109f9f677({
        nextRegisteredFields: nextRegisteredFields,
        changeId: changeId,
        buffer: buffer
    });
    setState({
        registeredFields: {
            ...nextRegisteredFields
        },
        buffer: {
            ...buffer,
            ...Object.keys(bufferForChangeId).length && {
                [changeId]: bufferForChangeId
            }
        }
    });
};
const $745940e83e6bea58$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        if ((0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw')) $745940e83e6bea58$var$registerFieldsFFOn({
            getState: getState,
            setState: setState,
            changeId: changeId,
            appId: appId,
            fieldsToBeRegistered: fieldsToBeRegistered
        });
        else {
            const alreadyRegisteredFields = getState().registeredFieldsDeprecated;
            setState({
                registeredFieldsDeprecated: {
                    ...alreadyRegisteredFields,
                    [changeId]: fieldsToBeRegistered
                }
            });
        }
    };
const $745940e83e6bea58$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        if ((0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw')) {
            const { registeredFields: registeredFields } = getState();
            const registeredAppFields = registeredFields[appId] || {};
            const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(registeredAppFields, changeId);
            setState({
                registeredFields: {
                    ...registeredFields,
                    [appId]: nextRegisteredAppFields
                }
            });
        } else setState({
            registeredFieldsDeprecated: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(getState().registeredFieldsDeprecated, changeId)
        });
    };
const $745940e83e6bea58$export$973336095fd0befc = (changeId)=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const nextRegisteredFields = {};
        Object.entries(registeredFields).forEach(([appId, registeredAppFields])=>{
            if (registeredAppFields) nextRegisteredFields[appId] = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(registeredAppFields, changeId);
        });
        setState({
            registeredFields: {
                ...nextRegisteredFields
            }
        });
    };

});
parcelRegister("59LUk", function(module, exports) {

$parcel$export(module.exports, "findAppsToBufferForChangeId", () => $8f338195a0adcdd4$export$69bf78514084d05f);
const $8f338195a0adcdd4$export$69bf78514084d05f = ({ registeredFieldsMap: registeredFieldsMap, changeId: changeId })=>{
    const fieldsRegisteredByApps = {};
    const appsToBuffer = new Set();
    Object.entries(registeredFieldsMap).forEach(([appId, appRegisteredFields])=>{
        const fields = appRegisteredFields?.[changeId];
        if (!fields) return;
        fields.forEach((fieldId)=>{
            if (fieldsRegisteredByApps[fieldId]) {
                fieldsRegisteredByApps[fieldId].add(appId);
                fieldsRegisteredByApps[fieldId].forEach((applicationId)=>appsToBuffer.add(applicationId));
            } else {
                fieldsRegisteredByApps[fieldId] = new Set();
                fieldsRegisteredByApps[fieldId].add(appId);
            }
        });
    });
    return appsToBuffer;
};

});


parcelRegister("2ugNi", function(module, exports) {

$parcel$export(module.exports, "updateFields", () => $0896ca7411360473$export$cceae62fd4d1ef0a);

var $8blac = parcelRequire("8blac");

var $1ybV0 = parcelRequire("1ybV0");

var $2bv99 = parcelRequire("2bv99");


var $7h8I4 = parcelRequire("7h8I4");
var $hGbVp = parcelRequire("hGbVp");
var $lB1pd = parcelRequire("lB1pd");

var $fsCiP = parcelRequire("fsCiP");

var $fUNS1 = parcelRequire("fUNS1");

var $7CbIv = parcelRequire("7CbIv");
const $0896ca7411360473$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, viewContext: viewContext, environment: environment, appId: appId })=>async ({ setState: setState, getState: getState }, { viewType: viewType })=>{
        const appliedChanges = getState().appliedChanges || {};
        const formData = getState().formData || {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields, registeredFieldsDeprecated: registeredFieldsDeprecated } = getState();
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw') ? (0, $7h8I4.fieldWasRegistered)(registeredFields, changeId, fieldId, appId) : (0, $7h8I4.fieldWasRegisteredDeprecated)(registeredFieldsDeprecated, changeId, fieldId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                // eslint-disable-next-line no-console
                console.warn(`UIM tried to apply changes to the unregistered field ${fieldId}`);
                (0, $2bv99.fireOperationalAnalyticsWithoutContext)('applyChanges', 'unregisteredField', viewType, {
                    message: 'Attempt to apply changes to a field that was not registered',
                    fieldId: fieldId
                });
                return acc;
            }
            const lookupData = {
                [(0, $6b8c146c2dd688bb$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $6b8c146c2dd688bb$export$3a106242c8f57ac2]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $7CbIv.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                viewContext: viewContext,
                environment: environment
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $lB1pd.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $hGbVp.mapFieldPropsFromPublicToInternalShape)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(combinedChangesToApply)) {
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(errorsByField)) throw new (0, $fsCiP.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $fUNS1.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
    };

});
parcelRegister("7h8I4", function(module, exports) {

$parcel$export(module.exports, "fieldWasRegisteredDeprecated", () => $86ebc8f98d26cbd3$export$fce3a63433d10493);
$parcel$export(module.exports, "fieldWasRegistered", () => $86ebc8f98d26cbd3$export$fbe9157c12cb4e7b);
const $86ebc8f98d26cbd3$export$fce3a63433d10493 = (registeredFields, changeId, fieldId)=>registeredFields[changeId]?.includes(fieldId);
const $86ebc8f98d26cbd3$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("hGbVp", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropsFromPublicToInternalShape", () => $29afb4d5faeca466$export$120a0679b3388948);

var $8ibkc = parcelRequire("8ibkc");
const $29afb4d5faeca466$export$120a0679b3388948 = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});
parcelRegister("8ibkc", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $9883d6a43ab701de$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $9883d6a43ab701de$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $9883d6a43ab701de$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isProjectTypeSupported", () => $9883d6a43ab701de$export$cd7c26587dda4120);
$parcel$export(module.exports, "getAnalytics", () => $9883d6a43ab701de$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $9883d6a43ab701de$export$ef45e4471aa21b27);
$parcel$export(module.exports, "isScreenTabsSupportEnabled", () => $9883d6a43ab701de$export$71e5898a2b967ce3);

var $h1jSL = parcelRequire("h1jSL");

var $7vcoF = parcelRequire("7vcoF");
const $9883d6a43ab701de$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $9883d6a43ab701de$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $7vcoF.supportedViews)[viewType];
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $9883d6a43ab701de$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$9883d6a43ab701de$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $h1jSL.fireIAErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $9883d6a43ab701de$export$e4330d77fd93d1de = (viewType)=>$9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
const $9883d6a43ab701de$export$72171ea4e785fc66 = (viewType)=>$9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedProjectTypes();
function $9883d6a43ab701de$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $9883d6a43ab701de$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $9883d6a43ab701de$export$20eabd2b3ada6bf3(viewType) {
    return $9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $9883d6a43ab701de$export$cd7c26587dda4120(project, viewType) {
    return $9883d6a43ab701de$export$72171ea4e785fc66(viewType).includes(project.type);
}
function $9883d6a43ab701de$export$b0297573c90085aa(viewType) {
    return $9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $9883d6a43ab701de$export$c0728caa743a409e(viewType) {
    return $9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $9883d6a43ab701de$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $9883d6a43ab701de$export$c0728caa743a409e(viewType).has(triggerPoint);
const $9883d6a43ab701de$export$71e5898a2b967ce3 = (viewType)=>$9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).isScreenTabsSupportEnabled();

});
parcelRegister("h1jSL", function(module, exports) {

$parcel$export(module.exports, "fireIAErrorAnalytics", () => $31b678c9ad2da8b8$export$319cadf5a1a1b6a7);
$parcel$export(module.exports, "fireUIMErrorAnalytics", () => $31b678c9ad2da8b8$export$7ca48916618a8ab2);

var $guiFP = parcelRequire("guiFP");

var $eTZsp = parcelRequire("eTZsp");

var $bKI0B = parcelRequire("bKI0B");
const $31b678c9ad2da8b8$export$319cadf5a1a1b6a7 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const supportedViews = (0, $bKI0B.getSupportedViewTypes)();
    const errorType = (0, $eTZsp.getErrorType)(error);
    const packageName = supportedViews.indexOf(viewType) >= 0 ? `${viewType}jiraUiModifications` : 'jiraUiModifications';
    (0, $guiFP.default)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        attributes: {
            errorType: errorType,
            ...attributes
        }
    });
};
const $31b678c9ad2da8b8$export$7ca48916618a8ab2 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $eTZsp.getErrorType)(error);
    const packageName = 'jiraUiModifications';
    (0, $guiFP.default)({
        event: event,
        meta: {
            id: id,
            teamName: 'unbox',
            packageName: packageName
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        attributes: {
            errorType: errorType,
            ...attributes,
            viewType: viewType
        }
    });
};

});
parcelRegister("bKI0B", function(module, exports) {

$parcel$export(module.exports, "GIC_VIEW_TYPE", () => $f2036ab73f830785$export$e615b7e9b8fb4715);
$parcel$export(module.exports, "ISSUE_VIEW_VIEW_TYPE", () => $f2036ab73f830785$export$7de257fbae219dde);
$parcel$export(module.exports, "ISSUE_TRANSITION_VIEW_TYPE", () => $f2036ab73f830785$export$a415896b28cb78d7);
$parcel$export(module.exports, "getSupportedViewTypes", () => $f2036ab73f830785$export$d85868cf60d9efa6);

var $1ybV0 = parcelRequire("1ybV0");
const $f2036ab73f830785$export$e615b7e9b8fb4715 = 'GIC';
const $f2036ab73f830785$export$7de257fbae219dde = 'IssueView';
const $f2036ab73f830785$export$a415896b28cb78d7 = 'IssueTransition';
const $f2036ab73f830785$export$d85868cf60d9efa6 = ()=>[
        $f2036ab73f830785$export$e615b7e9b8fb4715,
        $f2036ab73f830785$export$7de257fbae219dde,
        ...(0, $1ybV0.ff)('ui-modifications-on-issue-transition-view_7z1g0') ? [
            $f2036ab73f830785$export$a415896b28cb78d7
        ] : []
    ];

});


parcelRegister("7vcoF", function(module, exports) {

$parcel$export(module.exports, "supportedViews", () => $729488f5ba158c79$export$a13e14fcae9906a8);

var $bKI0B = parcelRequire("bKI0B");

var $a2GLQ = parcelRequire("a2GLQ");

var $ke9hW = parcelRequire("ke9hW");

var $5ZW9L = parcelRequire("5ZW9L");
const $729488f5ba158c79$export$a13e14fcae9906a8 = {
    [(0, $bKI0B.GIC_VIEW_TYPE)]: new (0, $a2GLQ.GICViewConfiguration)(),
    [(0, $bKI0B.ISSUE_VIEW_VIEW_TYPE)]: new (0, $5ZW9L.IssueViewViewConfiguration)(),
    [(0, $bKI0B.ISSUE_TRANSITION_VIEW_TYPE)]: new (0, $ke9hW.IssueTransitionViewConfiguration)()
};

});
parcelRegister("a2GLQ", function(module, exports) {

$parcel$export(module.exports, "GICViewConfiguration", () => $f4be71a1bc47c7c5$export$99b59685fcab4ee);

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");


var $lO4Or = parcelRequire("lO4Or");

var $hBkQt = parcelRequire("hBkQt");


var $8QLPP = parcelRequire("8QLPP");

var $axvW5 = parcelRequire("axvW5");

var $hBOxC = parcelRequire("hBOxC");

var $9aEJT = parcelRequire("9aEJT");

var $e8h5r = parcelRequire("e8h5r");

var $e793N = parcelRequire("e793N");

var $incV3 = parcelRequire("incV3");

var $htzHC = parcelRequire("htzHC");

var $7AbVk = parcelRequire("7AbVk");

var $gLagZ = parcelRequire("gLagZ");

var $hFkmH = parcelRequire("hFkmH");

var $feRPz = parcelRequire("feRPz");

var $9Ek5r = parcelRequire("9Ek5r");

var $1h6vN = parcelRequire("1h6vN");

var $2xymT = parcelRequire("2xymT");

var $8TLBS = parcelRequire("8TLBS");

var $f8ZvF = parcelRequire("f8ZvF");

var $9lHpT = parcelRequire("9lHpT");

var $egpDR = parcelRequire("egpDR");

var $4WWvu = parcelRequire("4WWvu");

var $48mC7 = parcelRequire("48mC7");

var $l29kV = parcelRequire("l29kV");

var $jJReM = parcelRequire("jJReM");

var $iLshM = parcelRequire("iLshM");

var $k1kz4 = parcelRequire("k1kz4");

var $3sHes = parcelRequire("3sHes");

var $1Wx7H = parcelRequire("1Wx7H");

var $9dJRK = parcelRequire("9dJRK");

var $dxSfw = parcelRequire("dxSfw");

var $bxDqf = parcelRequire("bxDqf");

var $6fCXk = parcelRequire("6fCXk");

var $eRMH7 = parcelRequire("eRMH7");

var $459V5 = parcelRequire("459V5");
class $f4be71a1bc47c7c5$export$99b59685fcab4ee {
    getSupportedFieldsConfiguration() {
        const commonFieldValidators = (0, $2xymT.getCommonFieldValidators)();
        return {
            [(0, $lO4Or.SUMMARY_TYPE)]: {
                // It contains also supported field properties.
                // Validator MUST be added here to make given property supported.
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $6fCXk.singleLineTextFieldSetValueValidator)
                },
                // Transformers are optional per property, if missing the value will be used as is
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $6fCXk.singleLineTextFieldGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.PRIORITY_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $gLagZ.validatePrioritySetValue),
                    optionsVisibility: (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $1Wx7H.prioritySetValueTransformer),
                    optionsVisibility: (0, $1Wx7H.transformPrioritySetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $1Wx7H.transformPriorityGetValue),
                    optionsVisibility: (0, $1Wx7H.transformPriorityGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $lO4Or.ASSIGNEE_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $8QLPP.assigneeSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $8QLPP.assigneeSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $8QLPP.assigneeGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            },
            [(0, $lO4Or.USER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $1h6vN.userPickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $eRMH7.userPickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $eRMH7.userPickerGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            },
            [(0, $lO4Or.LABELS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $incV3.labelsSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $incV3.labelsSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $incV3.labelsGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.DESCRIPTION_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $9lHpT.validateDescriptionAndParagraphSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $9lHpT.descriptionAndParagraphSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $9lHpT.descriptionAndParagraphGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $9Ek5r.selectSetValueValidator),
                    optionsVisibility: (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $bxDqf.selectSetValueTransformer),
                    optionsVisibility: (0, $bxDqf.transformSelectSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $bxDqf.selectGetValueTransformer),
                    optionsVisibility: (0, $bxDqf.transformSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $9lHpT.validateDescriptionAndParagraphSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $9lHpT.descriptionAndParagraphSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $9lHpT.descriptionAndParagraphGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $l29kV.validateMultiSelectSetValue),
                    optionsVisibility: (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $l29kV.multiSelectSetValueTransformer),
                    optionsVisibility: (0, $l29kV.transformMultiSelectSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $l29kV.multiSelectGetValueTransformer),
                    optionsVisibility: (0, $l29kV.transformMultiSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $lO4Or.PEOPLE_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $3sHes.peopleSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $3sHes.peopleSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $3sHes.peopleGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            },
            [(0, $lO4Or.MULTI_USER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $jJReM.multiUserPickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $jJReM.multiUserPickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $jJReM.multiUserPickerGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            },
            [(0, $lO4Or.TEXT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $6fCXk.singleLineTextFieldSetValueValidator)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $6fCXk.singleLineTextFieldGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $48mC7.validateMultiCheckboxSetValue),
                    optionsVisibility: (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $48mC7.multiCheckboxSetValueTransformer),
                    optionsVisibility: (0, $48mC7.transformMultiCheckboxSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $48mC7.multiCheckboxGetValueTransformer),
                    optionsVisibility: (0, $48mC7.transformMultiCheckboxGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $lO4Or.COMPONENTS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $f8ZvF.validateComponentsSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $f8ZvF.componentsSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $f8ZvF.componentsGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                requiredScopes: (0, $hBOxC.componentsRequiredScopes)
            },
            [(0, $lO4Or.REPORTER_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $feRPz.reporterSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $dxSfw.reporterSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $dxSfw.reporterGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            },
            [(0, $lO4Or.FIX_VERSIONS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $egpDR.fixVersionsSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $egpDR.fixVersionsSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $egpDR.fixVersionsGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                requiredScopes: (0, $egpDR.fixVersionsRequiredScopes)
            },
            [(0, $lO4Or.ISSUE_TYPE)]: {
                publicShapeValidators: {
                    value: (0, $e793N.issueTypeSetValueValidator),
                    optionsVisibility: (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $4WWvu.issueTypeSetValueTransformer),
                    optionsVisibility: (0, $4WWvu.transformIssueTypeSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $4WWvu.issueTypeGetValueTransformer),
                    optionsVisibility: (0, $4WWvu.transformIssueTypeGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $lO4Or.URL_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $6fCXk.singleLineTextFieldSetValueValidator)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $6fCXk.singleLineTextFieldGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.DATE_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $9aEJT.datePickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $9aEJT.datePickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $9aEJT.datePickerGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.DATETIME_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $e8h5r.validateDateTimePickerSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $e8h5r.transformDateTimePickerSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $e8h5r.transformDateTimePickerGetValue)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $hFkmH.radioButtonsSetValueValidator),
                    optionsVisibility: (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $9dJRK.radioButtonsSetValueTransformer),
                    optionsVisibility: (0, $9dJRK.transformRadioButtonsSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $9dJRK.radioButtonsGetValueTransformer),
                    optionsVisibility: (0, $9dJRK.transformRadioButtonsGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $lO4Or.NUMBER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $htzHC.validateNumberValue)
                },
                publicToInternalTransformers: {
                    value: (0, $iLshM.transformNumberToInternalValue)
                },
                internalToPublicTransformers: {
                    value: (0, $iLshM.transformNumberToPublicValue)
                },
                emitChangeOn: 'blur',
                requiredScopes: (0, $iLshM.numberIssueGicScopes)
            },
            [(0, $lO4Or.PARENT_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $7AbVk.parentSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $k1kz4.parentSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $k1kz4.parentGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $axvW5.validateCascadingSelectSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $8TLBS.transformSetValueCascadingSelect)
                },
                internalToPublicTransformers: {
                    value: (0, $8TLBS.transformGetValueCascadingSelect)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901)
            }
        };
    }
    getSupportedFieldTypes() {
        const supportedFieldTypes = [
            (0, $lO4Or.SUMMARY_TYPE),
            (0, $lO4Or.PRIORITY_TYPE),
            (0, $lO4Or.ASSIGNEE_TYPE),
            (0, $lO4Or.LABELS_TYPE),
            (0, $lO4Or.DESCRIPTION_TYPE),
            (0, $lO4Or.SELECT_CF_TYPE),
            (0, $lO4Or.TEXT_AREA_CF_TYPE),
            (0, $lO4Or.MULTI_SELECT_CF_TYPE),
            (0, $lO4Or.USER_CF_TYPE),
            (0, $lO4Or.TEXT_CF_TYPE),
            (0, $lO4Or.MULTI_USER_CF_TYPE),
            (0, $lO4Or.PEOPLE_CF_TYPE),
            (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
            (0, $lO4Or.REPORTER_TYPE),
            (0, $lO4Or.COMPONENTS_TYPE),
            (0, $lO4Or.FIX_VERSIONS_TYPE),
            (0, $lO4Or.ISSUE_TYPE),
            (0, $lO4Or.DATE_CF_TYPE),
            (0, $lO4Or.DATETIME_CF_TYPE),
            (0, $lO4Or.URL_CF_TYPE),
            (0, $lO4Or.RADIO_BUTTONS_CF_TYPE),
            (0, $lO4Or.NUMBER_CF_TYPE),
            (0, $lO4Or.PARENT_TYPE)
        ];
        if ((0, $1ybV0.ff)('uim-cascading-select-field-support-gic_h1cda')) supportedFieldTypes.push((0, $lO4Or.CASCADING_SELECT_CF_TYPE));
        return supportedFieldTypes;
    }
    getSupportedProjectTypes() {
        return [
            (0, $7ZZxN.SOFTWARE_PROJECT),
            (0, $7ZZxN.CORE_PROJECT)
        ];
    }
    getConsentMessage() {
        return (0, $459V5.default).obligatoryUimGicConsentMessage;
    }
    getAnalytics() {
        return this.analytics;
    }
    getSupportedTriggerPointsConfiguration() {
        return new Set([
            (0, $33ffe55cb7bcdadc$export$a05673a22505d5ee),
            (0, $33ffe55cb7bcdadc$export$c78d329777576aa0),
            (0, $33ffe55cb7bcdadc$export$affdc3af7a9a4677),
            (0, $33ffe55cb7bcdadc$export$7e9cfd1f59e60910),
            (0, $33ffe55cb7bcdadc$export$946ec0b21cb84fd0),
            (0, $33ffe55cb7bcdadc$export$708499dcd016e5e9)
        ]);
    }
    constructor(){
        this.analytics = {
            stopTTI: $hBkQt.stopTTI,
            cancelTTI: $hBkQt.cancelTTI,
            markIframeLoad: $hBkQt.markIframeLoad,
            markFieldsRegistered: $hBkQt.markFieldsRegistered,
            markOnInitResolved: $hBkQt.markOnInitResolved
        };
        this.isScreenTabsSupportEnabled = ()=>true;
    }
}

});
parcelRegister("8QLPP", function(module, exports) {

$parcel$export(module.exports, "assigneeSetValueValidator", () => $0661eaaab34eb369$export$a1b37d5eeb401ad6);
$parcel$export(module.exports, "assigneeSetValueTransformer", () => $0661eaaab34eb369$export$d1aadee23fc64b9d);
$parcel$export(module.exports, "assigneeGetValueTransformer", () => $0661eaaab34eb369$export$166948efaac892d3);
$parcel$export(module.exports, "assigneeScopes", () => $0661eaaab34eb369$export$3c9d4db6ddd2a8e6);

var $2Vsz9 = parcelRequire("2Vsz9");

var $4XB9o = parcelRequire("4XB9o");

var $8xPow = parcelRequire("8xPow");

var $9DCyM = parcelRequire("9DCyM");
const $0661eaaab34eb369$export$a1b37d5eeb401ad6 = (value)=>value === null || (0, $8xPow.isNotEmptyString)(value);
const $0661eaaab34eb369$export$d1aadee23fc64b9d = (value, lookupValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, lookupValues, 'accountId');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    const { accountId: accountId, name: displayName, picture: picture } = foundValue;
    return {
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': picture
        }
    };
};
const $0661eaaab34eb369$export$166948efaac892d3 = (value)=>{
    if (value === null) return null;
    const { accountId: accountId } = value;
    return {
        accountId: accountId
    };
};
const $0661eaaab34eb369$export$3c9d4db6ddd2a8e6 = {
    ...(0, $4XB9o.baseScopesRequiredPerField),
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        'read:user:jira'
    ],
    coarse: [
        ...(0, $4XB9o.baseScopesRequiredPerField).coarse,
        'read:jira-user'
    ]
};

});
parcelRegister("2Vsz9", function(module, exports) {

$parcel$export(module.exports, "FieldValueLookupError", () => $583216437d6b2342$export$73c2f0689b6c4a5a);
class $583216437d6b2342$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("4XB9o", function(module, exports) {

$parcel$export(module.exports, "baseScopesRequiredPerField", () => $321feced323efbab$export$ec1ba7c44413935f);
const $321feced323efbab$export$ec1ba7c44413935f = {
    granular: [
        'read:field:jira',
        'write:field:jira',
        'read:field-configuration:jira',
        'write:field-configuration:jira'
    ],
    coarse: [
        'read:jira-work',
        'write:jira-work',
        'manage:jira-configuration'
    ]
};

});

parcelRegister("8xPow", function(module, exports) {

$parcel$export(module.exports, "isNotEmptyString", () => $5bbf28343919e2e5$export$582443c7ead02173);
const $5bbf28343919e2e5$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';

});

parcelRegister("9DCyM", function(module, exports) {

$parcel$export(module.exports, "singleValueLookup", () => $cb00830fef4b3a2b$export$93a99fc9939aad85);
/**
 * Finds a single entity from a provided list of entities
 *
 * @param value - the value search being made by
 * @param lookupValues - list of entities where search is being made
 * @param lookupKey - property name of the entity from the lookupValues list with which value will be compared
 */ const $cb00830fef4b3a2b$export$93a99fc9939aad85 = (value, // eslint-disable-next-line @typescript-eslint/no-explicit-any
lookupValues = [], lookupKey)=>lookupValues.find((option)=>option[lookupKey] === value);

});


parcelRegister("axvW5", function(module, exports) {

$parcel$export(module.exports, "validateCascadingSelectSetValue", () => $783211acf76ed798$export$2d586ab6ce4d7126);

var $8xPow = parcelRequire("8xPow");
const $783211acf76ed798$export$2d586ab6ce4d7126 = (value)=>value === null || typeof value === 'object' && 'parentId' in value && 'childId' in value && (0, $8xPow.isNotEmptyString)(value.parentId) && ((0, $8xPow.isNotEmptyString)(value.childId) || value.childId === null);

});

parcelRegister("hBOxC", function(module, exports) {

$parcel$export(module.exports, "validateComponentsSetValue", () => $2df75154b7318e72$export$c65e64c3a855d5d2);
$parcel$export(module.exports, "componentsRequiredScopes", () => $2df75154b7318e72$export$a818a96eabdabcb);


var $4XB9o = parcelRequire("4XB9o");

var $8xPow = parcelRequire("8xPow");
const $2df75154b7318e72$export$c65e64c3a855d5d2 = (value)=>Array.isArray(value) && value.length <= (0, $6b8c146c2dd688bb$export$106087dcfd4fb129) && value.every((0, $8xPow.isNotEmptyString));
const $2df75154b7318e72$export$a818a96eabdabcb = {
    ...(0, $4XB9o.baseScopesRequiredPerField),
    granular: [
        'read:project.component:jira',
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        'write:field.default-value:jira'
    ]
};

});

parcelRegister("9aEJT", function(module, exports) {

$parcel$export(module.exports, "datePickerSetValueValidator", () => $7e4f3bba2e0dcf4b$export$c003579a97a2459e);
$parcel$export(module.exports, "datePickerSetValueTransformer", () => $7e4f3bba2e0dcf4b$export$cfb5350c1b8d2150);
$parcel$export(module.exports, "datePickerGetValueTransformer", () => $7e4f3bba2e0dcf4b$export$e844c6ac3a5cbef7);

var $EN9B6 = parcelRequire("EN9B6");
var $7ueqz = parcelRequire("7ueqz");
var $5YjhU = parcelRequire("5YjhU");
var $3xcI8 = parcelRequire("3xcI8");
// Date picker accepts only date string in format yyyy-MM-dd, so we need to validate it
// The date format is consistent with API contract
const $7e4f3bba2e0dcf4b$var$dateHasExpectedFormat = (date)=>{
    const dateFormat = 'yyyy-MM-dd';
    // `parse` doesn't respect strict format, see known issue https://github.com/date-fns/date-fns/issues/942
    // where format yyyy-MM-dd date 2022-10-2 is parsed successfully but shouldn't
    if (typeof date !== 'string' || dateFormat.length !== date.length) return false;
    const parsedDate = (0, $5YjhU.default)(date, dateFormat, new Date());
    return (0, $7ueqz.default)(parsedDate);
};
const $7e4f3bba2e0dcf4b$export$c003579a97a2459e = (value)=>value === null || $7e4f3bba2e0dcf4b$var$dateHasExpectedFormat(value);
const $7e4f3bba2e0dcf4b$export$cfb5350c1b8d2150 = (publicValue)=>publicValue === null ? '' : publicValue;
const $7e4f3bba2e0dcf4b$export$e844c6ac3a5cbef7 = (internalValue)=>{
    if (!internalValue) return null;
    const parsedDate = (0, $3xcI8.default)(internalValue);
    if ((0, $7ueqz.default)(parsedDate)) return (0, $EN9B6.default)(parsedDate, 'yyyy-MM-dd');
    throw new Error(`Invalid date was provided: ${internalValue}`);
};

});

parcelRegister("e8h5r", function(module, exports) {

$parcel$export(module.exports, "validateDateTimePickerSetValue", () => $3a1f121e49e0e6cd$export$7930ddff407505cc);
$parcel$export(module.exports, "transformDateTimePickerSetValue", () => $3a1f121e49e0e6cd$export$e81204f19744e19f);
$parcel$export(module.exports, "transformDateTimePickerGetValue", () => $3a1f121e49e0e6cd$export$4cb6c79fda4a9c74);

var $EN9B6 = parcelRequire("EN9B6");
var $kCEEd = parcelRequire("kCEEd");
var $7ueqz = parcelRequire("7ueqz");
var $3xcI8 = parcelRequire("3xcI8");
// Date time picker accepts only date string in format YYYY-MM-DDThh:mm:ssTZD
const $3a1f121e49e0e6cd$var$formatString = "yyyy-MM-dd'T'HH:mmxxx";
const $3a1f121e49e0e6cd$export$a886f5166a4d311e = (fullDate)=>{
    if (typeof fullDate !== 'string') return false;
    return (0, $kCEEd.default)(fullDate, $3a1f121e49e0e6cd$var$formatString) && (0, $7ueqz.default)((0, $3xcI8.default)(fullDate));
};
const $3a1f121e49e0e6cd$export$7930ddff407505cc = (value)=>value === null || $3a1f121e49e0e6cd$export$a886f5166a4d311e(value);
const $3a1f121e49e0e6cd$export$e81204f19744e19f = (publicValue)=>publicValue === null ? '' : publicValue;
const $3a1f121e49e0e6cd$export$4cb6c79fda4a9c74 = (internalValue)=>{
    if (!internalValue) return null;
    const parsedDate = (0, $3xcI8.default)(internalValue);
    if ((0, $7ueqz.default)(parsedDate)) return (0, $EN9B6.default)(parsedDate, $3a1f121e49e0e6cd$var$formatString);
    throw new Error(`Invalid date was provided: ${internalValue}`);
};

});

parcelRegister("e793N", function(module, exports) {

$parcel$export(module.exports, "issueTypeSetValueValidator", () => $b7ee4c8a0d7e5e1e$export$19e9b52e41260d79);

var $8xPow = parcelRequire("8xPow");
const $b7ee4c8a0d7e5e1e$export$19e9b52e41260d79 = (value)=>(0, $8xPow.isNotEmptyString)(value);

});

parcelRegister("incV3", function(module, exports) {

$parcel$export(module.exports, "labelsRequiredScopes", () => $23eda58696bf9a04$export$5397fc4189b6d690);
$parcel$export(module.exports, "labelsSetValueValidator", () => $23eda58696bf9a04$export$e67b5652c846b5f);
$parcel$export(module.exports, "labelsSetValueTransformer", () => $23eda58696bf9a04$export$861e9d180b68fea1);
$parcel$export(module.exports, "labelsGetValueTransformer", () => $23eda58696bf9a04$export$b0b12fd0b1cd9d3a);

var $4XB9o = parcelRequire("4XB9o");
const $23eda58696bf9a04$export$5397fc4189b6d690 = {
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        'read:label:jira'
    ],
    coarse: [
        ...(0, $4XB9o.baseScopesRequiredPerField).coarse
    ]
};
const $23eda58696bf9a04$export$e67b5652c846b5f = (value)=>typeof value === 'object' && value !== null && Array.isArray(value) && value.every((label)=>typeof label === 'string' && label !== '');
const $23eda58696bf9a04$export$861e9d180b68fea1 = (publicValue)=>publicValue.map((label)=>({
            value: label,
            label: label
        }));
const $23eda58696bf9a04$export$b0b12fd0b1cd9d3a = (internalValue)=>internalValue.map(({ value: value })=>value);

});

parcelRegister("htzHC", function(module, exports) {

$parcel$export(module.exports, "validateNumberValue", () => $fa6f50589319585e$export$aeb074bfcd7963bd);
$parcel$export(module.exports, "numberScopes", () => $fa6f50589319585e$export$2ddc76933cd1391c);

var $4XB9o = parcelRequire("4XB9o");
const $fa6f50589319585e$export$aeb074bfcd7963bd = (value)=>value === null || typeof value === 'number';
const $fa6f50589319585e$export$2ddc76933cd1391c = (0, $4XB9o.baseScopesRequiredPerField);

});

parcelRegister("7AbVk", function(module, exports) {

$parcel$export(module.exports, "parentSetValueValidator", () => $6122b026ea76dee9$export$ada98fdbc0faa607);
$parcel$export(module.exports, "parentScopes", () => $6122b026ea76dee9$export$bdc8bd505789b6e8);

var $4XB9o = parcelRequire("4XB9o");

var $8xPow = parcelRequire("8xPow");
const $6122b026ea76dee9$export$ada98fdbc0faa607 = (value)=>value === null || (0, $8xPow.isNotEmptyString)(value);
const $6122b026ea76dee9$export$bdc8bd505789b6e8 = (0, $4XB9o.baseScopesRequiredPerField);

});

parcelRegister("gLagZ", function(module, exports) {

$parcel$export(module.exports, "validatePrioritySetValue", () => $e35fe104200f1bd7$export$feb916d6d9ca4953);
$parcel$export(module.exports, "priorityScopes", () => $e35fe104200f1bd7$export$de5c165bee5efef2);

var $4XB9o = parcelRequire("4XB9o");

var $8xPow = parcelRequire("8xPow");
const $e35fe104200f1bd7$export$feb916d6d9ca4953 = (value)=>(0, $8xPow.isNotEmptyString)(value);
const $e35fe104200f1bd7$export$de5c165bee5efef2 = {
    ...(0, $4XB9o.baseScopesRequiredPerField),
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        'read:priority:jira'
    ]
};

});

parcelRegister("hFkmH", function(module, exports) {

$parcel$export(module.exports, "radioButtonsSetValueValidator", () => $35c8b6ff54e234a0$export$fd2e39ca7399c512);
$parcel$export(module.exports, "radioButtonsScopes", () => $35c8b6ff54e234a0$export$baef9137cbf80a51);

var $4XB9o = parcelRequire("4XB9o");

var $8xPow = parcelRequire("8xPow");
const $35c8b6ff54e234a0$export$fd2e39ca7399c512 = (value)=>value === null || (0, $8xPow.isNotEmptyString)(value);
const $35c8b6ff54e234a0$export$baef9137cbf80a51 = (0, $4XB9o.baseScopesRequiredPerField);

});

parcelRegister("feRPz", function(module, exports) {

$parcel$export(module.exports, "reporterSetValueValidator", () => $ac17a534dc1fcb45$export$b8b018eb25bdb4d8);

var $fBuJM = parcelRequire("fBuJM");

var $8xPow = parcelRequire("8xPow");
const $ac17a534dc1fcb45$export$b8b018eb25bdb4d8 = (value)=>// We should omit automatic id special value so it won't be picked up by this field
    // It is only applicable to the assignee field
    value === null || (0, $8xPow.isNotEmptyString)(value) && (0, $fBuJM.isNotAutomaticId)(value);

});
parcelRegister("fBuJM", function(module, exports) {

$parcel$export(module.exports, "isNotAutomaticId", () => $0c75b2f3b403ad8c$export$ab4c3a3c49d7add);

const $0c75b2f3b403ad8c$export$ab4c3a3c49d7add = (value)=>value !== (0, $6b8c146c2dd688bb$export$f5d5f6bb902f1027);

});


parcelRegister("9Ek5r", function(module, exports) {

$parcel$export(module.exports, "selectSetValueValidator", () => $0e072097323757a8$export$c02b1c2a574ca4c7);
$parcel$export(module.exports, "selectWithAriSetValueValidator", () => $0e072097323757a8$export$f22935386c756879);
$parcel$export(module.exports, "selectScopes", () => $0e072097323757a8$export$cb76f902c880ecb4);

var $4XB9o = parcelRequire("4XB9o");

var $6lwHh = parcelRequire("6lwHh");

var $8xPow = parcelRequire("8xPow");
const $0e072097323757a8$export$c02b1c2a574ca4c7 = (value)=>value === null || (0, $8xPow.isNotEmptyString)(value);
const $0e072097323757a8$export$f22935386c756879 = (value)=>value === null || (0, $8xPow.isNotEmptyString)(value) && (0, $6lwHh.isAriResourceIdValid)(value);
const $0e072097323757a8$export$cb76f902c880ecb4 = (0, $4XB9o.baseScopesRequiredPerField);

});
parcelRegister("6lwHh", function(module, exports) {

$parcel$export(module.exports, "isAriResourceIdValid", () => $0007d4320dc46b59$export$4d1e9901084f3bf6);

var $2rn3r = parcelRequire("2rn3r");
const $0007d4320dc46b59$var$CLOUD_ID_MOCK = 'cloud-id';
const $0007d4320dc46b59$var$ACTIOVATION_ID_MOCK = 'activation-id';
const $0007d4320dc46b59$var$FIELD_ID_MOCK = 'field-1';
const $0007d4320dc46b59$export$4d1e9901084f3bf6 = (optionId)=>{
    try {
        (0, $2rn3r.JiraIssueFieldOptionAri).create({
            siteId: $0007d4320dc46b59$var$CLOUD_ID_MOCK,
            activationId: $0007d4320dc46b59$var$ACTIOVATION_ID_MOCK,
            fieldId: $0007d4320dc46b59$var$FIELD_ID_MOCK,
            optionId: optionId
        });
        return true;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("2rn3r", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAri", () => $396674cae5287926$export$e3bc1ec22f941fbe);

var $7HlAi = parcelRequire("7HlAi");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/issue-field-option/manifest.ts
var $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $7HlAi.JiraIssueFieldOptionAriResourceOwner),
    resourceType: (0, $7HlAi.JiraIssueFieldOptionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/,
        // eslint-disable-line no-useless-escape
        optionId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/issue-field-option/index.ts
var $396674cae5287926$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldId() {
        return this._fieldId;
    }
    get optionId() {
        return this._optionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
            platformQualifier: $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
            resourceType: $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldId: opts.fieldId,
                optionId: opts.optionId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldId: this.fieldId,
            optionId: this.optionId
        };
    }
};

});
parcelRegister("7HlAi", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", () => $5632bebec8ddd527$export$eb4f4cf0880fe5a8);
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", () => $5632bebec8ddd527$export$4bec333360908e78);
// src/jira/issue-field-option/types.ts
var $5632bebec8ddd527$export$eb4f4cf0880fe5a8 = "jira", $5632bebec8ddd527$export$4bec333360908e78 = "issue-field-option";

});

parcelRegister("v8cEo", function(module, exports) {

$parcel$export(module.exports, "RegisteredAri", () => $81a8d536c343a20d$export$579ee78b1dcf0a11);

var $dCoVL = parcelRequire("dCoVL");
// src/core/registered-ari.ts
var $81a8d536c343a20d$export$579ee78b1dcf0a11 = class extends (0, $dCoVL.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $dCoVL.AnyAri).parse(this.toString());
    }
};

});




parcelRegister("1h6vN", function(module, exports) {

$parcel$export(module.exports, "userPickerSetValueValidator", () => $0eb8d1cc295999fc$export$e01dbe42b757ec);

var $fBuJM = parcelRequire("fBuJM");

var $8xPow = parcelRequire("8xPow");
const $0eb8d1cc295999fc$export$e01dbe42b757ec = (value)=>// We should omit automatic id special value, so it won't be picked up by this field
    // It is only applicable to the assignee field
    value === null || (0, $8xPow.isNotEmptyString)(value) && (0, $fBuJM.isNotAutomaticId)(value);

});

parcelRegister("2xymT", function(module, exports) {

$parcel$export(module.exports, "getCommonFieldValidators", () => $b3ce4d907a850501$export$68248012b0fecf7d);
$parcel$export(module.exports, "validateSetOptionsVisibilityRule", () => $b3ce4d907a850501$export$cb8a43658ea03ec7);

var $fkCu1 = parcelRequire("fkCu1");

var $iNF54 = parcelRequire("iNF54");

var $h1jSL = parcelRequire("h1jSL");

var $fN5n7 = parcelRequire("fN5n7");

var $8xPow = parcelRequire("8xPow");

var $bM27I = parcelRequire("bM27I");
const $b3ce4d907a850501$export$68248012b0fecf7d = ()=>({
        fieldName: (value)=>typeof value === 'string',
        isVisible: (value)=>typeof value === 'boolean',
        description: $b3ce4d907a850501$export$b5ccb7b3af83de7e,
        isReadOnly: (value, { isReadOnlyBySystem: isReadOnlyBySystem })=>typeof value === 'boolean' && (value || !value && !isReadOnlyBySystem),
        isRequired: (value, { isRequiredBySystem: isRequiredBySystem })=>typeof value === 'boolean' && (value || !value && !isRequiredBySystem)
    });
const $b3ce4d907a850501$export$b5ccb7b3af83de7e = async (value)=>{
    if (typeof value !== 'string') return false;
    if (value === '') return true;
    // turn into ADF
    try {
        const adfValue = await (0, $iNF54.convertWikiToAdfAsync)(value);
        if (!adfValue) return false;
        // find image nodes that contain external URLs.
        (0, $fkCu1.traverse)(adfValue, {
            media: (node)=>{
                if (node.attrs?.type === 'external' && node.attrs.url !== undefined) // ADF cannot contain external urls due to the possibility of data egress.
                throw new (0, $fN5n7.ExternalImageValidationError)('Cannot contain external images');
            }
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        // ExternalImageValidationError will be thrown if there is an external image
        if (!(err instanceof (0, $fN5n7.ExternalImageValidationError))) // TODO: use valid value of issueType instead of undefined in fireIAErrorAnalytics call. There is a task for it - https://ecosystem-platform.atlassian.net/browse/UIM-1651;
        (0, $h1jSL.fireIAErrorAnalytics)({
            error: err,
            id: 'descriptionWikiValidationException',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
            viewType: undefined,
            attributes: {
                errorCause: err?.cause,
                message: err.message
            }
        });
        return false;
    }
    return true;
};
const $b3ce4d907a850501$export$cb8a43658ea03ec7 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
optionsVisibility)=>(0, $bM27I.isObject)(optionsVisibility) && typeof optionsVisibility.isVisible === 'boolean' && Array.isArray(optionsVisibility.options) && optionsVisibility.options.every((0, $8xPow.isNotEmptyString));

});
parcelRegister("fkCu1", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $b2969341350ff1fe$export$df3f009e3d155b20);
function $b2969341350ff1fe$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $b2969341350ff1fe$export$df3f009e3d155b20(adf, visitors) {
    if (!$b2969341350ff1fe$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $b2969341350ff1fe$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $b2969341350ff1fe$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $b2969341350ff1fe$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});

parcelRegister("iNF54", function(module, exports) {

$parcel$export(module.exports, "convertWikiToAdfAsync", () => $75db0e1c09df6ee1$export$8e1b3b0130ee3556);



const $75db0e1c09df6ee1$export$8e1b3b0130ee3556 = async (wiki)=>{
    if (wiki === null || wiki === undefined || wiki === '') return Promise.resolve(null);
    const wikiPromise = await (parcelRequire("3Scyi"));
    const schemaPromise = await Promise.resolve((parcelRequire("9wcjJ")));
    const jsonPromise = await Promise.resolve((parcelRequire("8450v")));
    const [{ defaultSchema: defaultSchema }, { WikiMarkupTransformer: WikiMarkupTransformer }, { JSONTransformer: JSONTransformer }] = await Promise.all([
        schemaPromise,
        wikiPromise,
        jsonPromise
    ]);
    const wikiTransformer = new WikiMarkupTransformer(defaultSchema);
    const adfTransformer = new JSONTransformer();
    const pmNode = wikiTransformer.parse(wiki);
    return adfTransformer.encode(pmNode);
};

});
parcelRegister("3Scyi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ehmSd');
        const value = parcelRequire('jyxHj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ehmSd").then(()=>parcelRequire('jyxHj'));
}

});


parcelRegister("fN5n7", function(module, exports) {

$parcel$export(module.exports, "ExternalImageValidationError", () => $2acabb1059cc5ecc$export$af6b052883945124);
class $2acabb1059cc5ecc$export$af6b052883945124 extends Error {
}

});

parcelRegister("bM27I", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $26654f2e3eecc1da$export$a6cdc56e425d0d0a);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $26654f2e3eecc1da$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object' && value !== null;

});


parcelRegister("8TLBS", function(module, exports) {

$parcel$export(module.exports, "transformSetValueCascadingSelect", () => $403aed697acc707b$export$905a8d55c641a71e);
$parcel$export(module.exports, "transformGetValueCascadingSelect", () => $403aed697acc707b$export$47e9770ed0d1c344);

var $2Vsz9 = parcelRequire("2Vsz9");

var $8xPow = parcelRequire("8xPow");

var $9DCyM = parcelRequire("9DCyM");
const $403aed697acc707b$var$findCascadingSelectLookupValues = (lookupData, parentId, childId)=>{
    const foundOption = lookupData.find((currentOption)=>currentOption.parentOptionValue.id === parentId);
    if (!foundOption) throw new (0, $2Vsz9.FieldValueLookupError)();
    const value = {
        parent: foundOption.parentOptionValue,
        child: childId !== null ? (0, $9DCyM.singleValueLookup)(childId, foundOption.childOptionValues, 'id') : childId
    };
    return value;
};
const $403aed697acc707b$export$905a8d55c641a71e = (value, allowedValues)=>{
    if (value === null) return null;
    const cascadingSelectValue = $403aed697acc707b$var$findCascadingSelectLookupValues(allowedValues, value.parentId, value.childId);
    if (!(0, $8xPow.isNotEmptyString)(cascadingSelectValue.parent.value)) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        label: cascadingSelectValue.parent.value,
        value: cascadingSelectValue.parent.id,
        child: cascadingSelectValue.child ? {
            label: cascadingSelectValue.child.value,
            value: cascadingSelectValue.child.id
        } : null
    };
};
const $403aed697acc707b$export$47e9770ed0d1c344 = (cascadingValue)=>{
    if (!cascadingValue) return null;
    const { label: label, value: value, child: child } = cascadingValue;
    return child?.label && child?.value ? {
        parent: {
            id: value,
            value: label
        },
        child: {
            id: child.value,
            value: child.label
        }
    } : {
        parent: {
            id: value,
            value: label
        },
        child: null
    };
};

});

parcelRegister("f8ZvF", function(module, exports) {

$parcel$export(module.exports, "validateComponentsSetValue", () => $ada74a8f069458d4$export$c65e64c3a855d5d2);
$parcel$export(module.exports, "componentsGetValueTransformer", () => $ada74a8f069458d4$export$b6f14754491cc7aa);
$parcel$export(module.exports, "componentsSetValueTransformer", () => $ada74a8f069458d4$export$777b614991f65d18);

var $2Vsz9 = parcelRequire("2Vsz9");

var $jgrDo = parcelRequire("jgrDo");

var $8xPow = parcelRequire("8xPow");

var $eF9ai = parcelRequire("eF9ai");
const $ada74a8f069458d4$export$c65e64c3a855d5d2 = (value)=>Array.isArray(value) && value.every((0, $8xPow.isNotEmptyString));
const $ada74a8f069458d4$export$b6f14754491cc7aa = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: id, label: name })=>({
            id: id,
            name: name
        }));
};
const $ada74a8f069458d4$export$777b614991f65d18 = (publicValue, lookupValues)=>{
    if (!publicValue.length) return [];
    const filteredLookupValues = (0, $eF9ai.multiValueLookup)(publicValue, lookupValues, 'id');
    if (publicValue.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(publicValue, lookupValues, 'id');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ id: value, name: label })=>({
            value: value,
            label: label
        }));
};

});
parcelRegister("jgrDo", function(module, exports) {

$parcel$export(module.exports, "getValueLookupValuesDiff", () => $6997272717cb1667$export$6ebcd48e99f6b85);
/**
 * Finds the difference between provided ids and the list of available entities, by returning a list of
 * ids that weren't found in that entities list
 *
 * @param value - the list of values search being made by
 * @param lookupValues - list of entities with full information about all valid ids
 * @param lookupKey - property name of the entity from the lookupValues list with which value will be compared
 */ const $6997272717cb1667$export$6ebcd48e99f6b85 = (value, // eslint-disable-next-line @typescript-eslint/no-explicit-any
lookupValues = [], lookupKey)=>value.filter((id)=>!lookupValues.some((option)=>option[lookupKey] === id));

});

parcelRegister("eF9ai", function(module, exports) {

$parcel$export(module.exports, "multiValueLookup", () => $46ed71582596a5f2$export$12a8af52bc9e513e);
/**
 * Finds multiple entities from a provided list of entities
 *
 * @param value - the list of values search being made by
 * @param lookupValues - list of entities where search is being made
 * @param lookupKey - property name of the entity from the lookupValues list with which value will be compared
 */ const $46ed71582596a5f2$export$12a8af52bc9e513e = (value, // eslint-disable-next-line @typescript-eslint/no-explicit-any
lookupValues = [], lookupKey)=>lookupValues.filter((option)=>value.includes(option[lookupKey]));

});


parcelRegister("9lHpT", function(module, exports) {

$parcel$export(module.exports, "validateDescriptionAndParagraphSetValue", () => $b801949b1978c966$export$55c0a47975b0f67);
$parcel$export(module.exports, "descriptionAndParagraphSetValueTransformer", () => $b801949b1978c966$export$8596d284a0b8650f);
$parcel$export(module.exports, "descriptionAndParagraphGetValueTransformer", () => $b801949b1978c966$export$736f124bc0a7d673);

var $kFGm5 = parcelRequire("kFGm5");

var $9tBd5 = parcelRequire("9tBd5");


var $cw2gk = parcelRequire("cw2gk");
const $b801949b1978c966$export$55c0a47975b0f67 = (value, { fieldRenderer: fieldRenderer }, _createAnalyticsEvent, extra)=>{
    switch(fieldRenderer){
        case 0, $c059ef17c7f90619$export$31a6c27df1f927b2:
            return (0, $cw2gk.isValidADF)({
                newValue: value,
                currentValue: extra.currentField?.value,
                viewType: extra.viewType
            });
        case 0, $c059ef17c7f90619$export$95433ac963f4aebe:
            return Promise.resolve(typeof value === 'string');
        default:
            return Promise.resolve(false);
    }
};
const $b801949b1978c966$export$8596d284a0b8650f = (value)=>{
    if (typeof value === 'string') return value;
    return {
        ...value,
        overrideRequired: true
    };
};
const $b801949b1978c966$export$736f124bc0a7d673 = (value, fieldRenderer)=>{
    if (value === undefined) // The `convertTextToAdf` call will give us an "empty ADF object":
    // {
    //   "type": "doc",
    //   "version": 1,
    //   "content": [
    //     {
    //       "type": "paragraph",
    //       "content": []
    //     }
    //   ]
    // }
    return fieldRenderer === (0, $c059ef17c7f90619$export$31a6c27df1f927b2) ? (0, $9tBd5.convertTextToAdf)('') : '';
    if (typeof value === 'string') return value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(value, 'overrideRequired');
};

});
parcelRegister("9tBd5", function(module, exports) {

$parcel$export(module.exports, "convertTextToAdf", () => $61e37c91a1a26fa0$export$c10cf32c4acc1d57);

var $8Eye5 = parcelRequire("8Eye5");
var $5RBN8 = parcelRequire("5RBN8");

var $eZmml = parcelRequire("eZmml");
const $61e37c91a1a26fa0$export$c10cf32c4acc1d57 = (text)=>{
    if (text === '') return (0, $eZmml.getEmptyADF)();
    return (0, $8Eye5.doc)((0, $5RBN8.paragraph)(text));
};

});
parcelRegister("8Eye5", function(module, exports) {

$parcel$export(module.exports, "doc", () => $64cc9bc5a575f896$export$2a111da947c407d2);
const $64cc9bc5a575f896$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });

});

parcelRegister("5RBN8", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $444f37983bf19337$export$9c206ddddb32a9b);

var $jQZv4 = parcelRequire("jQZv4");
const $444f37983bf19337$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $jQZv4.createTextNodes)(content)
    });

});
parcelRegister("jQZv4", function(module, exports) {

$parcel$export(module.exports, "createTextNodes", () => $e74294460ddc7558$export$3a269a5941b62f04);

var $cPV8x = parcelRequire("cPV8x");
function $e74294460ddc7558$export$3a269a5941b62f04(nodes) {
    return nodes.map($e74294460ddc7558$export$72b9432ea0656b50);
}
function $e74294460ddc7558$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $cPV8x.text)(str) : str;
}

});
parcelRegister("cPV8x", function(module, exports) {

$parcel$export(module.exports, "text", () => $9586919870ac22c8$export$6f093cfa640b7166);
const $9586919870ac22c8$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});



parcelRegister("eZmml", function(module, exports) {

$parcel$export(module.exports, "getEmptyADF", () => $ae981b4922a7f015$export$d109ab46c9575565);
// https://product-fabric.atlassian.net/wiki/spaces/ADF/pages/881362244/ADF+Change+42+Uniform+Empty+ADF+Representation
const $ae981b4922a7f015$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});


/**
 * `graphql-field-type` are a duplicate of `graphql-field-types` from `@atlassian/jira-issue-create`
 * located in src/packages/issue-create/issue-create-modal/src/common/constants/graphql-field-types.tsx
 * This was done to prevent cyclic dependencies between packages.
 * Only field types the UIM currently support or plan to support were taken from the referenced file.
 */ // graphql __typename
const $c059ef17c7f90619$export$2d5a62a3515ad4c6 = 'JiraIssueTypeField';
const $c059ef17c7f90619$export$23ca38ad884e35f1 = 'JiraSingleLineTextField';
const $c059ef17c7f90619$export$31a6c27df1f927b2 = 'JiraRichTextField';
const $c059ef17c7f90619$export$30b2c2de5e3007a4 = 'JiraComponentsField';
const $c059ef17c7f90619$export$3849bb04b4eee607 = 'JiraSingleSelectUserPickerField';
const $c059ef17c7f90619$export$eca94ae30cb92d8 = 'JiraMultipleSelectUserPickerField';
const $c059ef17c7f90619$export$2bb9d057bad89bfa = 'JiraPeopleField';
const $c059ef17c7f90619$export$64c7789e86344de5 = 'JiraLabelsField';
const $c059ef17c7f90619$export$de14210faa5f2099 = 'JiraPriorityField';
const $c059ef17c7f90619$export$e0b268941120d761 = 'JiraDatePickerField';
const $c059ef17c7f90619$export$f2b56433dc0af401 = 'JiraUrlField';
const $c059ef17c7f90619$export$d10237d945259f96 = 'JiraCheckboxesField';
const $c059ef17c7f90619$export$27854f490d658fc4 = 'JiraRadioSelectField';
const $c059ef17c7f90619$export$fb8861017089d392 = 'JiraSingleSelectField';
const $c059ef17c7f90619$export$2055419ff013de79 = 'JiraMultipleSelectField';
const $c059ef17c7f90619$export$f7a08bf17a7ac661 = 'JiraAssigneeField';
const $c059ef17c7f90619$export$d64150fd9c66969c = 'JiraReporterField';
const $c059ef17c7f90619$export$95433ac963f4aebe = 'JiraTextAreaField';

parcelRegister("cw2gk", function(module, exports) {

$parcel$export(module.exports, "isValidADF", () => $1fdb475b2c590568$export$94ea512f7afe62e4);

var $2UdGp = parcelRequire("2UdGp");

var $hTLlD = parcelRequire("hTLlD");

var $8Eye5 = parcelRequire("8Eye5");

var $fkCu1 = parcelRequire("fkCu1");

var $2bv99 = parcelRequire("2bv99");

const $1fdb475b2c590568$var$getADFValidator = async ()=>{
    const { validator: validator } = await (parcelRequire("dZ4UM"));
    return validator;
};
const $1fdb475b2c590568$var$validateAdfExternalUrls = (adf)=>{
    try {
        (0, $fkCu1.traverse)(adf, {
            media: (node)=>{
                if (node.attrs?.type === 'external' && node.attrs?.url !== undefined) throw new Error('Cannot contain external images');
            },
            blockCard: ()=>{
                throw new Error('Cannot contain blockCard');
            },
            embedCard: ()=>{
                throw new Error('Cannot contain embedCard');
            }
        });
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return false;
    }
};
const $1fdb475b2c590568$export$6f13dd7501a16a00 = (newValue, currentValue)=>{
    // If there is no user input or defaultValue set, we just validate the `externalValue` directly
    if (!currentValue || !currentValue.content.length) return $1fdb475b2c590568$var$validateAdfExternalUrls(newValue);
    // Find the diff nodes between the new value and the current value
    const foundDiffNodes = (0, (/*@__PURE__*/$parcel$interopDefault($2UdGp)))(newValue.content, currentValue.content, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
    // Format `foundDiffNodes` into a valid ADF doc
    const formattedDiffAdf = (0, $8Eye5.doc)(...foundDiffNodes);
    return $1fdb475b2c590568$var$validateAdfExternalUrls(formattedDiffAdf);
};
const $1fdb475b2c590568$export$94ea512f7afe62e4 = async ({ newValue: newValue, currentValue: currentValue, viewType: viewType })=>{
    const validator = await $1fdb475b2c590568$var$getADFValidator();
    const validate = validator();
    const validationStartTime = performance.now();
    try {
        const isValidAdfNewValue = // Additionaly to ADF validator it chekcs version property since ADF validator checks only existance of it.
        Object.hasOwnProperty.call(newValue, 'version') && typeof newValue.version === 'number' && !Number.isNaN(newValue.version) && validate(newValue).valid;
        const isValidAdf = isValidAdfNewValue && $1fdb475b2c590568$export$6f13dd7501a16a00(newValue, currentValue);
        (0, $2bv99.fireOperationalAnalyticsWithoutContext)('adfValidation', 'completed', viewType, {
            validatedInMs: Math.floor(performance.now() - validationStartTime)
        });
        return isValidAdf;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("2UdGp", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $hKE3p = parcelRequire("hKE3p");

var $9eFtX = parcelRequire("9eFtX");

var $cRpul = parcelRequire("cRpul");

var $iTvqy = parcelRequire("iTvqy");
/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */ var $21db6ce926da14e3$var$differenceWith = $9eFtX(function(array, values) {
    var comparator = $iTvqy(values);
    if ($cRpul(comparator)) comparator = undefined;
    return $cRpul(array) ? $fa0Ox(array, $hKE3p(values, 1, $cRpul, true), undefined, comparator) : [];
});
module.exports = $21db6ce926da14e3$var$differenceWith;

});
parcelRegister("fa0Ox", function(module, exports) {

var $lYFvJ = parcelRequire("lYFvJ");

var $lqZWH = parcelRequire("lqZWH");

var $6v6uu = parcelRequire("6v6uu");

var $kJvGp = parcelRequire("kJvGp");

var $74vSq = parcelRequire("74vSq");

var $8AO5Q = parcelRequire("8AO5Q");
/** Used as the size to enable large array optimizations. */ var $b0986bd506ee8a3d$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $b0986bd506ee8a3d$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $lqZWH, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $kJvGp(values, $74vSq(iteratee));
    if (comparator) {
        includes = $6v6uu;
        isCommon = false;
    } else if (values.length >= $b0986bd506ee8a3d$var$LARGE_ARRAY_SIZE) {
        includes = $8AO5Q;
        isCommon = false;
        values = new $lYFvJ(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $b0986bd506ee8a3d$var$baseDifference;

});


parcelRegister("dZ4UM", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3PvDb');
        const value = parcelRequire('3muFz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3PvDb").then(()=>parcelRequire('3muFz'));
}

});



parcelRegister("egpDR", function(module, exports) {

$parcel$export(module.exports, "fixVersionsSetValueValidator", () => $73d66582b3f1a757$export$423303d5750f732c);
$parcel$export(module.exports, "fixVersionsSetValueTransformer", () => $73d66582b3f1a757$export$c547ae6abfa5aec3);
$parcel$export(module.exports, "fixVersionsGetValueTransformer", () => $73d66582b3f1a757$export$38bcbf0b6f4dc1a4);
$parcel$export(module.exports, "fixVersionsRequiredScopes", () => $73d66582b3f1a757$export$e96d6401e1e42c0a);

var $2Vsz9 = parcelRequire("2Vsz9");

var $1NIGg = parcelRequire("1NIGg");

var $jgrDo = parcelRequire("jgrDo");

var $8xPow = parcelRequire("8xPow");

var $eF9ai = parcelRequire("eF9ai");
const $73d66582b3f1a757$export$423303d5750f732c = (value)=>Array.isArray(value) && value.every((0, $8xPow.isNotEmptyString));
const $73d66582b3f1a757$export$c547ae6abfa5aec3 = (values, lookupValues)=>{
    if (!values.length) return [];
    const filteredLookupValues = (0, $eF9ai.multiValueLookup)(values, lookupValues, 'id');
    if (values.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(values, filteredLookupValues, 'id');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ name: name, id: id })=>({
            label: name,
            value: id
        }));
};
const $73d66582b3f1a757$export$38bcbf0b6f4dc1a4 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: value,
            name: label
        }));
};
const $73d66582b3f1a757$export$e96d6401e1e42c0a = {
    ...(0, $1NIGg.versionsRequiredScopes),
    granular: [
        ...(0, $1NIGg.versionsRequiredScopes).granular,
        'write:field.default-value:jira'
    ]
};

});
parcelRegister("1NIGg", function(module, exports) {

$parcel$export(module.exports, "validateVersionValue", () => $2e28f5c68ce7d201$export$f3e581e8b1e2479a);
$parcel$export(module.exports, "versionsRequiredScopes", () => $2e28f5c68ce7d201$export$60db61c485973ad9);


var $4XB9o = parcelRequire("4XB9o");

var $8xPow = parcelRequire("8xPow");
const $2e28f5c68ce7d201$export$f3e581e8b1e2479a = (value)=>Array.isArray(value) && value.every((0, $8xPow.isNotEmptyString)) && value.length <= (0, $6b8c146c2dd688bb$export$106087dcfd4fb129);
const $2e28f5c68ce7d201$export$60db61c485973ad9 = {
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        'read:project-version:jira'
    ],
    coarse: [
        ...(0, $4XB9o.baseScopesRequiredPerField).coarse
    ]
};

});


parcelRegister("4WWvu", function(module, exports) {

$parcel$export(module.exports, "issueTypeSetValueTransformer", () => $eaa6af66d18c4d64$export$93e4fd33c48f4977);
$parcel$export(module.exports, "issueTypeGetValueTransformer", () => $eaa6af66d18c4d64$export$391657d4e7f81237);
$parcel$export(module.exports, "transformIssueTypeSetOptionsVisibility", () => $eaa6af66d18c4d64$export$db493bcecec5fb56);
$parcel$export(module.exports, "transformIssueTypeGetOptionsVisibility", () => $eaa6af66d18c4d64$export$3a886340b0f20858);

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $j55UJ = parcelRequire("j55UJ");

var $9DCyM = parcelRequire("9DCyM");
const $eaa6af66d18c4d64$export$93e4fd33c48f4977 = (value, lookupValues)=>{
    const lookupValue = (0, $9DCyM.singleValueLookup)(value, lookupValues, 'value');
    if (!lookupValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        iconUrl: lookupValue.iconUrl,
        label: lookupValue.label,
        value: lookupValue.value
    };
};
const $eaa6af66d18c4d64$export$391657d4e7f81237 = (value)=>{
    /**
	 * Switching between projects with UIM context doesn't reset the IA context in a timely
	 * manner, that's why we still have `adjustmentsAreEnabled` resulting in `true` even
	 * though the context should have been reset and the undecorated component should have rendered first.
	 * As a result, issue type field sends `null` as a value to the value decorator just
	 * before the context reset is being triggered.
	 * `null` won't be sent to jira-bridge because after the context is reset, the actual issue type option is being set.
	 */ if (!value) return null;
    return {
        id: value.value,
        name: value.label
    };
};
const $eaa6af66d18c4d64$export$db493bcecec5fb56 = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');
const $eaa6af66d18c4d64$export$3a886340b0f20858 = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');

});
parcelRegister("240Nk", function(module, exports) {

$parcel$export(module.exports, "applyOptionsVisibilityRule", () => $2a0f351d50eb18bb$export$642f3f0b0177721e);
const $2a0f351d50eb18bb$export$642f3f0b0177721e = ({ options: options, isVisible: isVisible }, lookupValues = [], optionKey)=>isVisible ? lookupValues.filter((value)=>options.includes(value[optionKey])) : lookupValues.filter((value)=>!options.includes(value[optionKey]));

});

parcelRegister("j55UJ", function(module, exports) {

$parcel$export(module.exports, "getAvailableOptionsVisibilityRule", () => $faf933437c2b998e$export$d614c43ae91f42cd);
const $faf933437c2b998e$export$d614c43ae91f42cd = ({ options: options, isVisible: isVisible }, lookupValues = [], optionKey)=>({
        isVisible: isVisible,
        options: options.filter((option)=>lookupValues.some((value)=>value[optionKey] === option))
    });

});


parcelRegister("48mC7", function(module, exports) {

$parcel$export(module.exports, "transformMultiCheckboxSetOptionsVisibility", () => $6ba40f250c6b77ad$export$115a0b8c81087c2c);
$parcel$export(module.exports, "transformMultiCheckboxGetOptionsVisibility", () => $6ba40f250c6b77ad$export$4471ab017a7abd7);
$parcel$export(module.exports, "validateMultiCheckboxSetValue", () => $6ba40f250c6b77ad$export$56639f1c650d9ba5);
$parcel$export(module.exports, "multiCheckboxSetValueTransformer", () => $6ba40f250c6b77ad$export$9ba1ee83cc9456ba);
$parcel$export(module.exports, "multiCheckboxGetValueTransformer", () => $6ba40f250c6b77ad$export$6d15ce1cc0bdffe7);

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $j55UJ = parcelRequire("j55UJ");

var $jgrDo = parcelRequire("jgrDo");

var $8xPow = parcelRequire("8xPow");

var $eF9ai = parcelRequire("eF9ai");
const $6ba40f250c6b77ad$export$115a0b8c81087c2c = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $6ba40f250c6b77ad$export$4471ab017a7abd7 = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $6ba40f250c6b77ad$export$56639f1c650d9ba5 = (value)=>Array.isArray(value) && value.every((0, $8xPow.isNotEmptyString));
const $6ba40f250c6b77ad$export$9ba1ee83cc9456ba = (publicValue, allowedValues)=>{
    if (!publicValue.length) return [];
    const foundValue = (0, $eF9ai.multiValueLookup)(publicValue, allowedValues, 'id');
    if (foundValue.length !== publicValue.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(publicValue, foundValue, 'id');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return foundValue.map(({ value: value, id: id })=>({
            label: value,
            value: id
        }));
};
const $6ba40f250c6b77ad$export$6d15ce1cc0bdffe7 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: value,
            value: label
        }));
};

});

parcelRegister("l29kV", function(module, exports) {

$parcel$export(module.exports, "transformMultiSelectSetOptionsVisibility", () => $61d58bb7e967fbc8$export$464f5c048bb44fae);
$parcel$export(module.exports, "transformMultiSelectGetOptionsVisibility", () => $61d58bb7e967fbc8$export$16ec76c8ef15bfca);
$parcel$export(module.exports, "validateMultiSelectSetValue", () => $61d58bb7e967fbc8$export$7002ea8d8a6dd444);
$parcel$export(module.exports, "multiSelectSetValueTransformer", () => $61d58bb7e967fbc8$export$87ccfa5280a3288f);
$parcel$export(module.exports, "multiSelectGetValueTransformer", () => $61d58bb7e967fbc8$export$9992ce1903b64c5);

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $j55UJ = parcelRequire("j55UJ");

var $jgrDo = parcelRequire("jgrDo");

var $8xPow = parcelRequire("8xPow");

var $eF9ai = parcelRequire("eF9ai");
const $61d58bb7e967fbc8$export$464f5c048bb44fae = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $61d58bb7e967fbc8$export$16ec76c8ef15bfca = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $61d58bb7e967fbc8$export$7002ea8d8a6dd444 = (value)=>Array.isArray(value) && value.every((0, $8xPow.isNotEmptyString));
const $61d58bb7e967fbc8$export$87ccfa5280a3288f = (values, lookupValues)=>{
    if (!values.length) return [];
    const filteredValues = (0, $eF9ai.multiValueLookup)(values, lookupValues, 'id');
    if (filteredValues.length !== values.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(values, filteredValues, 'id');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredValues.map((val)=>({
            label: val.value,
            value: val.id
        }));
};
const $61d58bb7e967fbc8$export$9992ce1903b64c5 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: value,
            value: label
        }));
};

});

parcelRegister("jJReM", function(module, exports) {

$parcel$export(module.exports, "multiUserPickerSetValueValidator", () => $634c9a1b5c875da9$export$161337c705ff4d65);
$parcel$export(module.exports, "multiUserPickerSetValueTransformer", () => $634c9a1b5c875da9$export$206658c0c308733e);
$parcel$export(module.exports, "multiUserPickerGetValueTransformer", () => $634c9a1b5c875da9$export$68e3fe5737fc7137);

var $2Vsz9 = parcelRequire("2Vsz9");

var $jgrDo = parcelRequire("jgrDo");

var $fBuJM = parcelRequire("fBuJM");

var $8xPow = parcelRequire("8xPow");

var $eF9ai = parcelRequire("eF9ai");
const $634c9a1b5c875da9$export$161337c705ff4d65 = (value)=>Array.isArray(value) && // We should omit automatic id special value so it won't be picked up by this field
    // It is only applicable to the assignee field
    value.every((option)=>(0, $8xPow.isNotEmptyString)(option) && (0, $fBuJM.isNotAutomaticId)(option));
const $634c9a1b5c875da9$export$206658c0c308733e = (values, lookupValues)=>{
    if (!values.length) return [];
    const filteredLookupValues = (0, $eF9ai.multiValueLookup)(values, lookupValues, 'accountId');
    if (values.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(values, filteredLookupValues, 'accountId');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ accountId: id, name: name, picture: avatarUrl })=>({
            id: id,
            name: name,
            avatarUrl: avatarUrl
        }));
};
const $634c9a1b5c875da9$export$68e3fe5737fc7137 = (value)=>{
    if (!value) return [];
    return value.map(({ id: id })=>({
            accountId: id
        }));
};

});

parcelRegister("iLshM", function(module, exports) {

$parcel$export(module.exports, "transformNumberToInternalValue", () => $a1a418ce68cea4d2$export$bdbd8c4d6c9c2efe);
$parcel$export(module.exports, "transformNumberToPublicValue", () => $a1a418ce68cea4d2$export$8bdc28b51a4acc44);
$parcel$export(module.exports, "numberIssueGicScopes", () => $a1a418ce68cea4d2$export$b7e1c026b8f78970);

var $htzHC = parcelRequire("htzHC");
const $a1a418ce68cea4d2$export$bdbd8c4d6c9c2efe = (publicValue)=>publicValue === null ? '' : String(publicValue);
const $a1a418ce68cea4d2$export$8bdc28b51a4acc44 = (internalValue)=>[
        undefined,
        ''
    ].includes(internalValue) ? null : Number(internalValue);
const $a1a418ce68cea4d2$export$b7e1c026b8f78970 = {
    ...(0, $htzHC.numberScopes),
    granular: [
        ...(0, $htzHC.numberScopes).granular,
        'write:field.default-value:jira'
    ]
};

});

parcelRegister("k1kz4", function(module, exports) {

$parcel$export(module.exports, "parentSetValueTransformer", () => $90bf3720d66e7be7$export$a65d296b5d388a59);
$parcel$export(module.exports, "parentGetValueTransformer", () => $90bf3720d66e7be7$export$ea591224dc3a0141);

var $lPQPn = parcelRequire("lPQPn");

var $2Vsz9 = parcelRequire("2Vsz9");


var $5Xfbd = parcelRequire("5Xfbd");
async function $90bf3720d66e7be7$export$a65d296b5d388a59(value, _lookupValues, { tenantContext: tenantContext }) {
    if (value === null) return null;
    try {
        const parentIssueDetails = await (0, $5Xfbd.fetchParentIssueDetails)(tenantContext.cloudId, value);
        if (!parentIssueDetails) throw new (0, $2Vsz9.FieldValueLookupError)(`Parent issue with issueId "${value}" not found`, {
            cause: (0, $23d97971f71f1cd0$export$4a4db137834138dd)
        });
        const issue = parentIssueDetails.jira?.issueById;
        const fields = issue?.fieldsById?.edges;
        if (!issue || !issue.issueId || !issue.key || !fields) throw new (0, $2Vsz9.FieldValueLookupError)(`Error fetching data for parent issue with issueId "${value}"`, {
            cause: (0, $23d97971f71f1cd0$export$aa7d91b2fd1ba261)
        });
        let issueTypeField = null;
        let summaryField = null;
        let statusField = null;
        for (const field of fields){
            if ((0, $5Xfbd.isJiraIssueTypeFieldNode)(field?.node)) issueTypeField = field?.node ?? null;
            else if ((0, $5Xfbd.isJiraSingleLineTextFieldNode)(field?.node)) summaryField = field?.node ?? null;
            else if ((0, $5Xfbd.isJiraStatusFieldNode)(field?.node)) statusField = field?.node ?? null;
        }
        if (!issueTypeField || !summaryField || !statusField) throw new (0, $2Vsz9.FieldValueLookupError)(`Error fetching data for parent issue with issueId "${value}"`, {
            cause: (0, $23d97971f71f1cd0$export$aa7d91b2fd1ba261)
        });
        return {
            color: (0, $lPQPn.asColor)(parentIssueDetails.jira?.issueById?.issueColorField?.color?.colorKey) ?? undefined,
            value: parentIssueDetails.jira.issueById.issueId,
            isDone: (0, $5Xfbd.checkParentIssueIsDone)(statusField),
            key: parentIssueDetails.jira.issueById.key,
            label: summaryField.text,
            fields: {
                summary: summaryField.text ?? '',
                issuetype: {
                    id: issueTypeField.issueType?.issueTypeId ?? undefined,
                    name: issueTypeField.issueType?.name ?? undefined,
                    iconUrl: issueTypeField.issueType?.avatar?.xsmall ?? ''
                }
            }
        };
    } catch (error) {
        if (error instanceof Error && !('cause' in error)) error.cause = (0, $23d97971f71f1cd0$export$494a54d93664524d);
        if (error instanceof Error) throw new (0, $2Vsz9.FieldValueLookupError)(error.message, {
            cause: error.cause
        });
        throw error;
    }
}
function $90bf3720d66e7be7$export$ea591224dc3a0141(intervalValue) {
    if (!intervalValue) return null;
    return {
        id: intervalValue.value.toString(),
        key: intervalValue.key
    };
}

});
parcelRegister("lPQPn", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $66f7283bb625ccc7$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $66f7283bb625ccc7$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $66f7283bb625ccc7$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $66f7283bb625ccc7$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $66f7283bb625ccc7$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $66f7283bb625ccc7$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $66f7283bb625ccc7$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $66f7283bb625ccc7$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $66f7283bb625ccc7$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $66f7283bb625ccc7$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $66f7283bb625ccc7$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $66f7283bb625ccc7$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $66f7283bb625ccc7$export$e4369cabd7e84cd9);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $aXGkF = parcelRequire("aXGkF");

var $tgbCK = parcelRequire("tgbCK");

var $hNY9X = parcelRequire("hNY9X");

var $opsFH = parcelRequire("opsFH");
const $66f7283bb625ccc7$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $opsFH.Colors).PURPLE;
    if (color in (0, $opsFH.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $opsFH.Colors).PURPLE;
};
const $66f7283bb625ccc7$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $opsFH.ServerColors).SERVER_PURPLE;
    if (color in (0, $opsFH.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $opsFH.ServerColors).SERVER_PURPLE;
};
const $66f7283bb625ccc7$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $tgbCK.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $opsFH.Colors)));
    return extendedColors.reduce((obj, color)=>({
            ...obj,
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $66f7283bb625ccc7$export$a00423580059ae28 = (color)=>(0, $tgbCK.MAP_COLORS_TO_VALUE)[color] || (0, $tgbCK.MAP_COLORS_TO_VALUE)[0, $opsFH.PURPLE];
const $66f7283bb625ccc7$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))((0, $tgbCK.MAP_COLORS_TO_VALUE))[value] || (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$47af25386a01de1 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $66f7283bb625ccc7$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$28fb68bb1de025d5 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $66f7283bb625ccc7$var$paletteColorValues = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $66f7283bb625ccc7$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $hNY9X.default).purpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).blueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).tealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).yellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).orangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREY]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkPurpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkBlueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkTealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkYellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkOrangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREY]
        }
    ];
const $66f7283bb625ccc7$export$9b822862d986dfdf = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $66f7283bb625ccc7$export$949dc67535a8ff2 = (color = (0, $tgbCK.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $66f7283bb625ccc7$export$9b822862d986dfdf[color] ?? $66f7283bb625ccc7$export$9b822862d986dfdf[0, $tgbCK.DEFAULT_EPIC_COLOR];
const $66f7283bb625ccc7$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $opsFH.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("aXGkF", function(module, exports) {

var $CAsD5 = parcelRequire("CAsD5");

var $eQ67w = parcelRequire("eQ67w");

var $3QMTK = parcelRequire("3QMTK");
/** Used for built-in method references. */ var $7fb0405f6a745d75$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7fb0405f6a745d75$var$nativeObjectToString = $7fb0405f6a745d75$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $7fb0405f6a745d75$var$invert = $eQ67w(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $7fb0405f6a745d75$var$nativeObjectToString.call(value);
    result[value] = key;
}, $CAsD5($3QMTK));
module.exports = $7fb0405f6a745d75$var$invert;

});
parcelRegister("eQ67w", function(module, exports) {

var $im19c = parcelRequire("im19c");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $acdaab61bed7cb96$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $im19c(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $acdaab61bed7cb96$var$createInverter;

});
parcelRegister("im19c", function(module, exports) {

var $piimr = parcelRequire("piimr");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $d5cb2bea9036f464$var$baseInverter(object, setter, iteratee, accumulator) {
    $piimr(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $d5cb2bea9036f464$var$baseInverter;

});



parcelRegister("tgbCK", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3e0c3a8718e9d782$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3e0c3a8718e9d782$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3e0c3a8718e9d782$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3e0c3a8718e9d782$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3e0c3a8718e9d782$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3e0c3a8718e9d782$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3e0c3a8718e9d782$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3e0c3a8718e9d782$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", () => $3e0c3a8718e9d782$export$1fdd5a248b5f697c);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$82fc3b0b98905453);
$parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$703aca53c431bb88);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3e0c3a8718e9d782$export$92b6aebfb522f0d9);

var $aXGkF = parcelRequire("aXGkF");

var $PdmhA = parcelRequire("PdmhA");

var $opsFH = parcelRequire("opsFH");
const $3e0c3a8718e9d782$export$c2357bec51c5cf5b = 'PURPLE';
const $3e0c3a8718e9d782$export$db33d74b098e3da9 = {
    [(0, $opsFH.PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
    [(0, $opsFH.BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
    [(0, $opsFH.GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
    [(0, $opsFH.TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
    [(0, $opsFH.YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
    [(0, $opsFH.ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
    [(0, $opsFH.GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
    [(0, $opsFH.DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
    [(0, $opsFH.DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
    [(0, $opsFH.DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
    [(0, $opsFH.DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
    [(0, $opsFH.DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
    [(0, $opsFH.DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
    [(0, $opsFH.DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`
};
const $3e0c3a8718e9d782$export$fc5fe4213a5703f1 = {
    [(0, $PdmhA).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
    [(0, $PdmhA).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
    [(0, $PdmhA).G200]: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
    [(0, $PdmhA).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
    [(0, $PdmhA).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
    [(0, $PdmhA).R200]: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
    [(0, $PdmhA).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
    [(0, $PdmhA).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
    [(0, $PdmhA).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
    [(0, $PdmhA).G400]: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
    [(0, $PdmhA).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
    [(0, $PdmhA).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
    [(0, $PdmhA).R400]: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
    [(0, $PdmhA).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`
};
const $3e0c3a8718e9d782$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$db33d74b098e3da9);
const $3e0c3a8718e9d782$export$43264b0781f10167 = {
    [(0, $opsFH.SERVER_PURPLE)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.SERVER_DARK_PURPLE)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.SERVER_BLUE)]: (0, $opsFH.BLUE),
    [(0, $opsFH.SERVER_DARK_BLUE)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.SERVER_GREEN)]: (0, $opsFH.GREEN),
    [(0, $opsFH.SERVER_DARK_GREEN)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.SERVER_TEAL)]: (0, $opsFH.TEAL),
    [(0, $opsFH.SERVER_DARK_TEAL)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.SERVER_YELLOW)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.SERVER_DARK_YELLOW)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.SERVER_ORANGE)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.SERVER_DARK_ORANGE)]: (0, $opsFH.DARK_ORANGE),
    [(0, $opsFH.SERVER_GREY)]: (0, $opsFH.GREY),
    [(0, $opsFH.SERVER_DARK_GREY)]: (0, $opsFH.DARK_GREY)
};
const $3e0c3a8718e9d782$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$43264b0781f10167);
const $3e0c3a8718e9d782$export$fb5d051fe1b2bccc = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
const $3e0c3a8718e9d782$export$994d3ffa39be04fd = {
    [(0, $opsFH.AGILE_COLOR_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.AGILE_COLOR_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.AGILE_COLOR_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.AGILE_COLOR_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.AGILE_COLOR_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.AGILE_COLOR_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.AGILE_COLOR_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.AGILE_COLOR_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.AGILE_COLOR_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.AGILE_COLOR_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.AGILE_COLOR_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.AGILE_COLOR_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.AGILE_COLOR_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.AGILE_COLOR_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$994d3ffa39be04fd);
const $3e0c3a8718e9d782$export$1fdd5a248b5f697c = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.AGILE_COLOR_1),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.AGILE_COLOR_2),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.AGILE_COLOR_3),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.AGILE_COLOR_4),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.AGILE_COLOR_5),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.AGILE_COLOR_6),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.AGILE_COLOR_7),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.AGILE_COLOR_8),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.AGILE_COLOR_9),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.AGILE_COLOR_10),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.AGILE_COLOR_11),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.AGILE_COLOR_12),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.AGILE_COLOR_13),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.AGILE_COLOR_14)
};
const $3e0c3a8718e9d782$export$82fc3b0b98905453 = {
    [(0, $opsFH.DARK_GREY)]: 'grey',
    [(0, $opsFH.DARK_YELLOW)]: 'yellow',
    [(0, $opsFH.YELLOW)]: 'yellowLight',
    [(0, $opsFH.DARK_BLUE)]: 'blue',
    [(0, $opsFH.DARK_TEAL)]: 'teal',
    [(0, $opsFH.GREEN)]: 'greenLight',
    [(0, $opsFH.PURPLE)]: 'purpleLight',
    [(0, $opsFH.DARK_PURPLE)]: 'purple',
    [(0, $opsFH.ORANGE)]: 'redLight',
    [(0, $opsFH.BLUE)]: 'blueLight',
    [(0, $opsFH.TEAL)]: 'tealLight',
    [(0, $opsFH.GREY)]: 'greyLight',
    [(0, $opsFH.DARK_GREEN)]: 'green',
    [(0, $opsFH.DARK_ORANGE)]: 'red'
};
const $3e0c3a8718e9d782$export$703aca53c431bb88 = {
    [(0, $opsFH.AGILE_COLOR_1)]: 'grey',
    [(0, $opsFH.AGILE_COLOR_2)]: 'yellow',
    [(0, $opsFH.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $opsFH.AGILE_COLOR_4)]: 'blue',
    [(0, $opsFH.AGILE_COLOR_5)]: 'teal',
    [(0, $opsFH.AGILE_COLOR_6)]: 'greenLight',
    [(0, $opsFH.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $opsFH.AGILE_COLOR_8)]: 'purple',
    [(0, $opsFH.AGILE_COLOR_9)]: 'redLight',
    [(0, $opsFH.AGILE_COLOR_10)]: 'blueLight',
    [(0, $opsFH.AGILE_COLOR_11)]: 'tealLight',
    [(0, $opsFH.AGILE_COLOR_12)]: 'greyLight',
    [(0, $opsFH.AGILE_COLOR_13)]: 'green',
    [(0, $opsFH.AGILE_COLOR_14)]: 'red'
};
const $3e0c3a8718e9d782$export$92b6aebfb522f0d9 = {
    [(0, $opsFH.PURPLE)]: {
        primary: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
        secondary: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P500})`,
        text: `var(--ds-text-accent-purple, ${(0, $PdmhA).P500})`,
        textBackground: `var(--ds-background-accent-purple-subtler, ${(0, $PdmhA).P50})`,
        border: `var(--ds-border-accent-purple, ${(0, $PdmhA).P400})`,
        line: `var(--ds-border-accent-purple, ${(0, $PdmhA).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $PdmhA).P75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.BLUE)]: {
        primary: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
        secondary: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B500})`,
        text: `var(--ds-text-accent-blue, ${(0, $PdmhA).B500})`,
        textBackground: `var(--ds-background-accent-blue-subtler, ${(0, $PdmhA).B50})`,
        border: `var(--ds-border-accent-blue, ${(0, $PdmhA).B400})`,
        line: `var(--ds-border-accent-blue, ${(0, $PdmhA).B300})`,
        primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $PdmhA).B75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREEN)]: {
        primary: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        secondary: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G500})`,
        text: `var(--ds-text-accent-green, ${(0, $PdmhA).G500})`,
        textBackground: `var(--ds-background-accent-green-subtler, ${(0, $PdmhA).G50})`,
        border: `var(--ds-border-accent-green, ${(0, $PdmhA).G400})`,
        line: `var(--ds-border-accent-green, ${(0, $PdmhA).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $PdmhA).G75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.TEAL)]: {
        primary: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
        secondary: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T500})`,
        text: `var(--ds-text-accent-teal, ${(0, $PdmhA).T500})`,
        textBackground: `var(--ds-background-accent-teal-subtler, ${(0, $PdmhA).T50})`,
        border: `var(--ds-border-accent-teal, ${(0, $PdmhA).T400})`,
        line: `var(--ds-border-accent-teal, ${(0, $PdmhA).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $PdmhA).T75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.YELLOW)]: {
        primary: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
        secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $PdmhA).Y500})`,
        text: `var(--ds-text-accent-yellow, ${(0, $PdmhA).Y500})`,
        textBackground: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA).Y50})`,
        border: `var(--ds-border-accent-yellow, ${(0, $PdmhA).Y400})`,
        line: `var(--ds-border-accent-yellow, ${(0, $PdmhA).Y300})`,
        primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA).Y75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.ORANGE)]: {
        primary: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
        secondary: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R500})`,
        text: `var(--ds-text-accent-red, ${(0, $PdmhA).R500})`,
        textBackground: `var(--ds-background-accent-red-subtler, ${(0, $PdmhA).R50})`,
        border: `var(--ds-border-accent-red, ${(0, $PdmhA).R400})`,
        line: `var(--ds-border-accent-red, ${(0, $PdmhA).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $PdmhA).R75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREY)]: {
        primary: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
        secondary: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N500})`,
        text: `var(--ds-text-accent-gray, ${(0, $PdmhA).N500})`,
        textBackground: `var(--ds-background-accent-gray-subtler, ${(0, $PdmhA).N30})`,
        border: `var(--ds-border-accent-gray, ${(0, $PdmhA).N700})`,
        line: `var(--ds-border-accent-gray, ${(0, $PdmhA).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $PdmhA).N50})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.DARK_PURPLE)]: {
        primary: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
        secondary: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
        border: `var(--ds-border-accent-purple, ${(0, $PdmhA).P100})`,
        line: `var(--ds-border-accent-purple, ${(0, $PdmhA).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_BLUE)]: {
        primary: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
        secondary: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
        border: `var(--ds-border-accent-blue, ${(0, $PdmhA).B200})`,
        line: `var(--ds-border-accent-blue, ${(0, $PdmhA).B100})`,
        primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREEN)]: {
        primary: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
        secondary: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
        border: `var(--ds-border-accent-green, ${(0, $PdmhA).G200})`,
        line: `var(--ds-border-accent-green, ${(0, $PdmhA).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_TEAL)]: {
        primary: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
        secondary: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
        border: `var(--ds-border-accent-teal, ${(0, $PdmhA).T200})`,
        line: `var(--ds-border-accent-teal, ${(0, $PdmhA).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_YELLOW)]: {
        primary: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
        secondary: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
        border: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y200})`,
        line: `var(--ds-border-accent-orange, ${(0, $PdmhA).Y300})`,
        primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_ORANGE)]: {
        primary: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
        secondary: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
        border: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R100})`,
        line: `var(--ds-border-accent-red, ${(0, $PdmhA).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREY)]: {
        primary: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`,
        secondary: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N300})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N500})`,
        border: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N100})`,
        line: `var(--ds-border-accent-gray, ${(0, $PdmhA).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N100})`,
        hasContrastSecondaryGradient: false
    }
};

});
parcelRegister("opsFH", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $e6c2c5f41d0c328b$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $e6c2c5f41d0c328b$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $e6c2c5f41d0c328b$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $e6c2c5f41d0c328b$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $e6c2c5f41d0c328b$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $e6c2c5f41d0c328b$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $e6c2c5f41d0c328b$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $e6c2c5f41d0c328b$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $e6c2c5f41d0c328b$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $e6c2c5f41d0c328b$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $e6c2c5f41d0c328b$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $e6c2c5f41d0c328b$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $e6c2c5f41d0c328b$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $e6c2c5f41d0c328b$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $e6c2c5f41d0c328b$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $e6c2c5f41d0c328b$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $e6c2c5f41d0c328b$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $e6c2c5f41d0c328b$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $e6c2c5f41d0c328b$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $e6c2c5f41d0c328b$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $e6c2c5f41d0c328b$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $e6c2c5f41d0c328b$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $e6c2c5f41d0c328b$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $e6c2c5f41d0c328b$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $e6c2c5f41d0c328b$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $e6c2c5f41d0c328b$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $e6c2c5f41d0c328b$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $e6c2c5f41d0c328b$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $e6c2c5f41d0c328b$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $e6c2c5f41d0c328b$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $e6c2c5f41d0c328b$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $e6c2c5f41d0c328b$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $e6c2c5f41d0c328b$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $e6c2c5f41d0c328b$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $e6c2c5f41d0c328b$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $e6c2c5f41d0c328b$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $e6c2c5f41d0c328b$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $e6c2c5f41d0c328b$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $e6c2c5f41d0c328b$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $e6c2c5f41d0c328b$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $e6c2c5f41d0c328b$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $e6c2c5f41d0c328b$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $e6c2c5f41d0c328b$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $e6c2c5f41d0c328b$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $e6c2c5f41d0c328b$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $e6c2c5f41d0c328b$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $e6c2c5f41d0c328b$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $e6c2c5f41d0c328b$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $e6c2c5f41d0c328b$export$4b7407b8700035bd);
/**
 * Color constants
 */ const $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2 = 'PURPLE';
const $e6c2c5f41d0c328b$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $e6c2c5f41d0c328b$export$738c3b9a44c87ecc = 'BLUE';
const $e6c2c5f41d0c328b$export$1225f83626261b80 = 'DARK_BLUE';
const $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b = 'GREEN';
const $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $e6c2c5f41d0c328b$export$d0446fe88325854e = 'TEAL';
const $e6c2c5f41d0c328b$export$bb848c92687e69dc = 'DARK_TEAL';
const $e6c2c5f41d0c328b$export$aab610c505c06a8f = 'YELLOW';
const $e6c2c5f41d0c328b$export$466af87757d343a2 = 'DARK_YELLOW';
const $e6c2c5f41d0c328b$export$3de5e29ed1757f9b = 'ORANGE';
const $e6c2c5f41d0c328b$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $e6c2c5f41d0c328b$export$7d278ca694634874 = 'GREY';
const $e6c2c5f41d0c328b$export$26453300bfc61cb8 = 'DARK_GREY';
const $e6c2c5f41d0c328b$export$56d196d2844d1ca1 = [
    $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    $e6c2c5f41d0c328b$export$1225f83626261b80,
    $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    $e6c2c5f41d0c328b$export$d0446fe88325854e,
    $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    $e6c2c5f41d0c328b$export$466af87757d343a2,
    $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    $e6c2c5f41d0c328b$export$7d278ca694634874,
    $e6c2c5f41d0c328b$export$26453300bfc61cb8
];
const $e6c2c5f41d0c328b$export$792af22a0198af8d = 'purple';
const $e6c2c5f41d0c328b$export$588af712afdcb006 = 'dark_purple';
const $e6c2c5f41d0c328b$export$84c4918645391802 = 'blue';
const $e6c2c5f41d0c328b$export$b8f1f5838352a33a = 'dark_blue';
const $e6c2c5f41d0c328b$export$9384b7e350ee6542 = 'green';
const $e6c2c5f41d0c328b$export$87d3fb8d8656d38b = 'dark_green';
const $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae = 'teal';
const $e6c2c5f41d0c328b$export$a89b77a449bd223e = 'dark_teal';
const $e6c2c5f41d0c328b$export$9a33b5e3cde94885 = 'yellow';
const $e6c2c5f41d0c328b$export$33253d7862bceb8a = 'dark_yellow';
const $e6c2c5f41d0c328b$export$6609c2b23fc42f39 = 'orange';
const $e6c2c5f41d0c328b$export$cd994662b5911917 = 'dark_orange';
const $e6c2c5f41d0c328b$export$1793d43e13e078c5 = 'grey';
const $e6c2c5f41d0c328b$export$487a6e9145526564 = 'dark_grey';
const $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $e6c2c5f41d0c328b$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $e6c2c5f41d0c328b$export$94ac87c81ed074a7 = 'ghx-label-3';
const $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $e6c2c5f41d0c328b$export$610a2c132b6fcf96 = 'ghx-label-5';
const $e6c2c5f41d0c328b$export$8e4997dba71f1c40 = 'ghx-label-6';
const $e6c2c5f41d0c328b$export$18a545b4e69b27b4 = 'ghx-label-7';
const $e6c2c5f41d0c328b$export$27fff1a0d295292a = 'ghx-label-8';
const $e6c2c5f41d0c328b$export$e57aa662a56724e1 = 'ghx-label-9';
const $e6c2c5f41d0c328b$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $e6c2c5f41d0c328b$export$457ecb9560f2bf83 = 'ghx-label-11';
const $e6c2c5f41d0c328b$export$a866db37165a696c = 'ghx-label-12';
const $e6c2c5f41d0c328b$export$9b18447c1168a1b6 = 'ghx-label-13';
const $e6c2c5f41d0c328b$export$93b9ad4020e271b7 = 'ghx-label-14';
const $e6c2c5f41d0c328b$export$5cd2af17b34de3e3 = 'color_1';
const $e6c2c5f41d0c328b$export$987671fa69482a7b = 'color_2';
const $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446 = 'color_3';
const $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36 = 'color_4';
const $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256 = 'color_5';
const $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78 = 'color_6';
const $e6c2c5f41d0c328b$export$9dc62d5d151cb355 = 'color_7';
const $e6c2c5f41d0c328b$export$1ed15b30f5663f92 = 'color_8';
const $e6c2c5f41d0c328b$export$5d23a84d55ac1644 = 'color_9';
const $e6c2c5f41d0c328b$export$bf08c9a6ed42e349 = 'color_10';
const $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c = 'color_11';
const $e6c2c5f41d0c328b$export$da30755a37c3a597 = 'color_12';
const $e6c2c5f41d0c328b$export$721cf84faff6bf19 = 'color_13';
const $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd = 'color_14';
const $e6c2c5f41d0c328b$export$c537fa0d021d010b = {
    PURPLE: $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    BLUE: $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    DARK_BLUE: $e6c2c5f41d0c328b$export$1225f83626261b80,
    GREEN: $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    TEAL: $e6c2c5f41d0c328b$export$d0446fe88325854e,
    DARK_TEAL: $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    YELLOW: $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    DARK_YELLOW: $e6c2c5f41d0c328b$export$466af87757d343a2,
    ORANGE: $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    DARK_ORANGE: $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    GREY: $e6c2c5f41d0c328b$export$7d278ca694634874,
    DARK_GREY: $e6c2c5f41d0c328b$export$26453300bfc61cb8
};
const $e6c2c5f41d0c328b$export$d33d39828a18210a = {
    SERVER_PURPLE: $e6c2c5f41d0c328b$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $e6c2c5f41d0c328b$export$588af712afdcb006,
    SERVER_BLUE: $e6c2c5f41d0c328b$export$84c4918645391802,
    SERVER_DARK_BLUE: $e6c2c5f41d0c328b$export$b8f1f5838352a33a,
    SERVER_GREEN: $e6c2c5f41d0c328b$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $e6c2c5f41d0c328b$export$87d3fb8d8656d38b,
    SERVER_TEAL: $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $e6c2c5f41d0c328b$export$a89b77a449bd223e,
    SERVER_YELLOW: $e6c2c5f41d0c328b$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $e6c2c5f41d0c328b$export$33253d7862bceb8a,
    SERVER_ORANGE: $e6c2c5f41d0c328b$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $e6c2c5f41d0c328b$export$cd994662b5911917,
    SERVER_GREY: $e6c2c5f41d0c328b$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $e6c2c5f41d0c328b$export$487a6e9145526564
};
const $e6c2c5f41d0c328b$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $e6c2c5f41d0c328b$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $e6c2c5f41d0c328b$export$94ac87c81ed074a7,
    GHX_LABEL_4: $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $e6c2c5f41d0c328b$export$610a2c132b6fcf96,
    GHX_LABEL_6: $e6c2c5f41d0c328b$export$8e4997dba71f1c40,
    GHX_LABEL_7: $e6c2c5f41d0c328b$export$18a545b4e69b27b4,
    GHX_LABEL_8: $e6c2c5f41d0c328b$export$27fff1a0d295292a,
    GHX_LABEL_9: $e6c2c5f41d0c328b$export$e57aa662a56724e1,
    GHX_LABEL_10: $e6c2c5f41d0c328b$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $e6c2c5f41d0c328b$export$457ecb9560f2bf83,
    GHX_LABEL_12: $e6c2c5f41d0c328b$export$a866db37165a696c,
    GHX_LABEL_13: $e6c2c5f41d0c328b$export$9b18447c1168a1b6,
    GHX_LABEL_14: $e6c2c5f41d0c328b$export$93b9ad4020e271b7
};
const $e6c2c5f41d0c328b$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $e6c2c5f41d0c328b$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $e6c2c5f41d0c328b$export$987671fa69482a7b,
    AGILE_COLOR_3: $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $e6c2c5f41d0c328b$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $e6c2c5f41d0c328b$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $e6c2c5f41d0c328b$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $e6c2c5f41d0c328b$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $e6c2c5f41d0c328b$export$da30755a37c3a597,
    AGILE_COLOR_13: $e6c2c5f41d0c328b$export$721cf84faff6bf19,
    AGILE_COLOR_14: $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd
};

});


parcelRegister("hNY9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d8f225d60e32dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a7d8f225d60e32dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});


const $23d97971f71f1cd0$export$4a4db137834138dd = 'FETCH_PARENT_FIELD_NOT_FOUND';
const $23d97971f71f1cd0$export$aa7d91b2fd1ba261 = 'FETCH_PARENT_FIELD_DETAILS_MISSING_DATA';
const $23d97971f71f1cd0$export$494a54d93664524d = 'FETCH_PARENT_FIELD_UNKNOWN_ERROR';
const $23d97971f71f1cd0$export$db8af5ee2c36776e = 'FETCH_PARENT_FIELD_DETAILS_REQUEST_FAILED';

parcelRegister("5Xfbd", function(module, exports) {

$parcel$export(module.exports, "isJiraIssueTypeFieldNode", () => $6f64b4b9dfeef6b5$export$57eda1f5ad7133c3);
$parcel$export(module.exports, "isJiraSingleLineTextFieldNode", () => $6f64b4b9dfeef6b5$export$ea2b75e2537cbccf);
$parcel$export(module.exports, "isJiraStatusFieldNode", () => $6f64b4b9dfeef6b5$export$1a148ec51054fc5a);
$parcel$export(module.exports, "fetchParentIssueDetails", () => $6f64b4b9dfeef6b5$export$ef5c4d73a6136d96);
$parcel$export(module.exports, "checkParentIssueIsDone", () => $6f64b4b9dfeef6b5$export$2b30e3fdda29f6);

var $2Shq0 = parcelRequire("2Shq0");

var $8Qd0L = parcelRequire("8Qd0L");

var $kXzsJ = parcelRequire("kXzsJ");

var $cEBFL = parcelRequire("cEBFL");

const $6f64b4b9dfeef6b5$export$57eda1f5ad7133c3 = (node)=>node?.__typename === 'JiraIssueTypeField';
const $6f64b4b9dfeef6b5$export$ea2b75e2537cbccf = (node)=>node?.__typename === 'JiraSingleLineTextField';
const $6f64b4b9dfeef6b5$export$1a148ec51054fc5a = (node)=>node?.__typename === 'JiraStatusField';
const $6f64b4b9dfeef6b5$export$6ba84cffc20b9772 = (0, $cEBFL.gqlTagGira)`
  query ParentIssueDetailsQuery($ari: ID!) {
    jira {
      issueById(id: $ari) {
        issueId
        key
        issueColorField {
          color {
            colorKey
          }
        }
        fieldsById(ids: ["summary", "issuetype", "status"]) {
          edges {
            node {
              __typename
              ... on JiraIssueTypeField {
                fieldId
                issueType {
                  issueTypeId
                  name
                  avatar {
                    xsmall
                  }
                }
              }
              ... on JiraSingleLineTextField {
                fieldId
                text
              }
              ... on JiraStatusField {
                fieldId
                status {
                  statusCategory {
                    statusCategoryId
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
async function $6f64b4b9dfeef6b5$export$ef5c4d73a6136d96(siteId, issueId) {
    try {
        const variables = {
            ari: (0, $2Shq0.JiraIssueAri).create({
                siteId: siteId,
                issueId: issueId
            }).toString()
        };
        const { data: data } = await (0, $kXzsJ.getClient)('').query({
            query: $6f64b4b9dfeef6b5$export$6ba84cffc20b9772,
            variables: variables,
            operationName: 'ParentIssueDetailsQuery'
        });
        return data;
    } catch (error) {
        throw new Error(`Error fetching data for parent issue with issueId "${issueId}"`, {
            cause: (0, $23d97971f71f1cd0$export$db8af5ee2c36776e)
        });
    }
}
const $6f64b4b9dfeef6b5$export$2b30e3fdda29f6 = (node)=>{
    const doneStatusCategoryId = (0, $8Qd0L).StatusCategoryIds[(0, $8Qd0L).StatusCategoryTypes.DONE];
    return doneStatusCategoryId && String(doneStatusCategoryId) === node.status?.statusCategory?.statusCategoryId;
};

});
parcelRegister("2Shq0", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAri", () => $f33aa2105af1c8a3$export$1da6808e89ee03e);

var $dD8N7 = parcelRequire("dD8N7");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/issue/manifest.ts
var $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $dD8N7.JiraIssueAriResourceOwner),
    resourceType: (0, $dD8N7.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $f33aa2105af1c8a3$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("dD8N7", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $5b32aaefd8525674$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $5b32aaefd8525674$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $5b32aaefd8525674$export$665a39f1b4e29e0a = "jira", $5b32aaefd8525674$export$76beb4d0da177ad4 = "issue";

});




parcelRegister("3sHes", function(module, exports) {

$parcel$export(module.exports, "peopleSetValueValidator", () => $a62d6b8303db47a8$export$b553dcd60e54b2da);
$parcel$export(module.exports, "peopleSetValueTransformer", () => $a62d6b8303db47a8$export$6262031046230bac);
$parcel$export(module.exports, "peopleGetValueTransformer", () => $a62d6b8303db47a8$export$34e69b3ea0fd6308);

var $2Vsz9 = parcelRequire("2Vsz9");

var $jgrDo = parcelRequire("jgrDo");

var $fBuJM = parcelRequire("fBuJM");

var $8xPow = parcelRequire("8xPow");

var $eF9ai = parcelRequire("eF9ai");
const $a62d6b8303db47a8$export$b553dcd60e54b2da = (value)=>Array.isArray(value) && // We should omit automatic id special value so it won't be picked up by this field
    // It is only applicable to the assignee field
    value.every((userId)=>(0, $8xPow.isNotEmptyString)(userId) && (0, $fBuJM.isNotAutomaticId)(userId));
const $a62d6b8303db47a8$export$6262031046230bac = (value, lookupValues)=>{
    if (!value.length) return [];
    const filteredLookupValues = (0, $eF9ai.multiValueLookup)(value, lookupValues, 'accountId');
    if (value.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(value, filteredLookupValues, 'accountId');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ accountId: id, name: name, picture: avatarUrl })=>({
            id: id,
            name: name,
            avatarUrl: avatarUrl
        }));
};
const $a62d6b8303db47a8$export$34e69b3ea0fd6308 = (value)=>{
    if (!value) return [];
    // can be an object in case of people field with isMulti: false
    const valueArray = Array.isArray(value) ? value : [
        value
    ];
    return valueArray.map(({ id: accountId })=>({
            accountId: accountId
        }));
};

});

parcelRegister("1Wx7H", function(module, exports) {

$parcel$export(module.exports, "transformPrioritySetOptionsVisibility", () => $7f0fc53b7ffe5d8e$export$722da4484009d687);
$parcel$export(module.exports, "transformPriorityGetOptionsVisibility", () => $7f0fc53b7ffe5d8e$export$3cc1c0d9b27ad517);
$parcel$export(module.exports, "prioritySetValueTransformer", () => $7f0fc53b7ffe5d8e$export$c6ef424ead917b72);
$parcel$export(module.exports, "transformPriorityGetValue", () => $7f0fc53b7ffe5d8e$export$95a791a89befdf91);

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $j55UJ = parcelRequire("j55UJ");

var $9DCyM = parcelRequire("9DCyM");
const $7f0fc53b7ffe5d8e$export$722da4484009d687 = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $7f0fc53b7ffe5d8e$export$3cc1c0d9b27ad517 = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $7f0fc53b7ffe5d8e$export$c6ef424ead917b72 = (value, lookupValues)=>{
    const lookupValue = (0, $9DCyM.singleValueLookup)(value, lookupValues, 'id');
    if (!lookupValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        label: lookupValue.name,
        value: lookupValue.id,
        iconUrl: lookupValue.iconUrl
    };
};
const $7f0fc53b7ffe5d8e$export$95a791a89befdf91 = (priority)=>{
    if (!priority) return null;
    const { label: label, value: value, iconUrl: iconUrl } = priority;
    return {
        name: label,
        id: value,
        iconUrl: iconUrl
    };
};

});

parcelRegister("9dJRK", function(module, exports) {

$parcel$export(module.exports, "transformRadioButtonsSetOptionsVisibility", () => $70872c7d75e7f159$export$825e2dc660c855a0);
$parcel$export(module.exports, "transformRadioButtonsGetOptionsVisibility", () => $70872c7d75e7f159$export$149e6a6e5e31219);
$parcel$export(module.exports, "radioButtonsSetValueTransformer", () => $70872c7d75e7f159$export$d23713245ea192a9);
$parcel$export(module.exports, "radioButtonsGetValueTransformer", () => $70872c7d75e7f159$export$624bfe758f4ad3c6);

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $j55UJ = parcelRequire("j55UJ");

var $9DCyM = parcelRequire("9DCyM");
const $70872c7d75e7f159$export$825e2dc660c855a0 = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $70872c7d75e7f159$export$149e6a6e5e31219 = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $70872c7d75e7f159$export$d23713245ea192a9 = (value, allowedValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, allowedValues, 'id');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        value: foundValue.id,
        label: foundValue.value
    };
};
const $70872c7d75e7f159$export$624bfe758f4ad3c6 = (value)=>{
    if (!value) return null;
    const { label: label, value: id } = value;
    return {
        id: id,
        value: label
    };
};

});

parcelRegister("dxSfw", function(module, exports) {

$parcel$export(module.exports, "reporterSetValueTransformer", () => $ada9cb53cbf81785$export$610accc7edd3f281);
$parcel$export(module.exports, "reporterGetValueTransformer", () => $ada9cb53cbf81785$export$2c1706dd36f54bb3);

var $2Vsz9 = parcelRequire("2Vsz9");

var $9DCyM = parcelRequire("9DCyM");
const $ada9cb53cbf81785$export$610accc7edd3f281 = (value, lookupValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, lookupValues, 'accountId');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        id: foundValue.accountId,
        name: foundValue.name,
        avatarUrl: foundValue.picture
    };
};
const $ada9cb53cbf81785$export$2c1706dd36f54bb3 = (value)=>{
    if (!value) return null;
    const { id: accountId } = value;
    return {
        accountId: accountId
    };
};

});

parcelRegister("bxDqf", function(module, exports) {

$parcel$export(module.exports, "transformSelectSetOptionsVisibility", () => $51efb35da251dc6a$export$81990085f8ab114b);
$parcel$export(module.exports, "transformSelectGetOptionsVisibility", () => $51efb35da251dc6a$export$7c7ca81813eb0f65);
$parcel$export(module.exports, "selectSetValueTransformer", () => $51efb35da251dc6a$export$136c42b919fdec83);
$parcel$export(module.exports, "selectGetValueTransformer", () => $51efb35da251dc6a$export$fd4db924c90bd0e2);

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $j55UJ = parcelRequire("j55UJ");

var $9DCyM = parcelRequire("9DCyM");
const $51efb35da251dc6a$export$81990085f8ab114b = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $51efb35da251dc6a$export$7c7ca81813eb0f65 = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $51efb35da251dc6a$export$136c42b919fdec83 = (value, allowedValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, allowedValues, 'id');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        value: foundValue.id,
        label: foundValue.value
    };
};
const $51efb35da251dc6a$export$fd4db924c90bd0e2 = (value)=>{
    if (!value) return null;
    const { label: label, value: id } = value;
    return {
        id: id,
        value: label
    };
};

});

parcelRegister("6fCXk", function(module, exports) {

$parcel$export(module.exports, "singleLineTextFieldSetValueValidator", () => $ea1d2f3392f4e0a9$export$e0269944af4481cc);
$parcel$export(module.exports, "singleLineTextFieldGetValueTransformer", () => $ea1d2f3392f4e0a9$export$161c77b6b09fc494);
const $ea1d2f3392f4e0a9$export$e0269944af4481cc = (value)=>typeof value === 'string';
const $ea1d2f3392f4e0a9$export$161c77b6b09fc494 = (internalValue)=>internalValue !== undefined ? internalValue : '';

});

parcelRegister("eRMH7", function(module, exports) {

$parcel$export(module.exports, "userPickerSetValueTransformer", () => $479a996075356cdb$export$890d33cc39835486);
$parcel$export(module.exports, "userPickerGetValueTransformer", () => $479a996075356cdb$export$e87b0f36be178543);

var $2Vsz9 = parcelRequire("2Vsz9");

var $9DCyM = parcelRequire("9DCyM");
const $479a996075356cdb$export$890d33cc39835486 = (value, lookupValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, lookupValues, 'accountId');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        id: foundValue.accountId,
        name: foundValue.name,
        avatarUrl: foundValue.picture
    };
};
const $479a996075356cdb$export$e87b0f36be178543 = (value)=>{
    if (!value) return null;
    const { id: accountId } = value;
    return {
        accountId: accountId
    };
};

});

parcelRegister("459V5", function(module, exports) {

$parcel$export(module.exports, "default", () => $959b01ec75bb8054$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $959b01ec75bb8054$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    obligatoryUimGicConsentMessage: {
        "id": "ui-modifications-fields-configuration.common.utils.views.gic.obligatory-uim-gic-consent-message",
        "defaultMessage": "You must allow \"{appTitle}\" to access your Atlassian products to create this issue."
    }
});

});


parcelRegister("ke9hW", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionViewConfiguration", () => $b34720468cbf828a$export$970307e8f6cfcea1);

var $3QMTK = parcelRequire("3QMTK");

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");


var $lO4Or = parcelRequire("lO4Or");

var $fy5vB = parcelRequire("fy5vB");


var $8QLPP = parcelRequire("8QLPP");

var $axvW5 = parcelRequire("axvW5");

var $9aEJT = parcelRequire("9aEJT");

var $e8h5r = parcelRequire("e8h5r");

var $e793N = parcelRequire("e793N");

var $incV3 = parcelRequire("incV3");

var $eMv4r = parcelRequire("eMv4r");

var $ifv0j = parcelRequire("ifv0j");

var $1zzzr = parcelRequire("1zzzr");

var $htzHC = parcelRequire("htzHC");

var $7AbVk = parcelRequire("7AbVk");

var $gLagZ = parcelRequire("gLagZ");

var $hFkmH = parcelRequire("hFkmH");

var $9Zo5b = parcelRequire("9Zo5b");

var $1h6vN = parcelRequire("1h6vN");

var $2xymT = parcelRequire("2xymT");

var $b50wi = parcelRequire("b50wi");

var $dBUTs = parcelRequire("dBUTs");

var $lKEcA = parcelRequire("lKEcA");

var $cHN5s = parcelRequire("cHN5s");

var $3g1BX = parcelRequire("3g1BX");

var $2oXjw = parcelRequire("2oXjw");

var $1TPgc = parcelRequire("1TPgc");

var $48Oaa = parcelRequire("48Oaa");

var $kt4Dk = parcelRequire("kt4Dk");

var $k8Z2Y = parcelRequire("k8Z2Y");

var $8IcPP = parcelRequire("8IcPP");

var $ioiX9 = parcelRequire("ioiX9");

var $3nLyZ = parcelRequire("3nLyZ");

var $js9Si = parcelRequire("js9Si");

var $ivCUc = parcelRequire("ivCUc");

var $6Hfnl = parcelRequire("6Hfnl");

var $fD0E1 = parcelRequire("fD0E1");
class $b34720468cbf828a$export$970307e8f6cfcea1 {
    getSupportedFieldsConfiguration() {
        const commonFieldValidators = (0, $2xymT.getCommonFieldValidators)();
        return {
            [(0, $lO4Or.TEXT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $9Zo5b.validateSingleLineTextValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $9Zo5b.transformSingleLineTextToPublicValue)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $ivCUc.selectSetValueValidator),
                    optionsVisibility: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $b50wi.validateSetOptionsVisibility) : (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $ivCUc.selectSetValueTransformer) : (0, $ivCUc.selectSetValueTransformerOld),
                    optionsVisibility: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $b50wi.transformSetOptionsVisibilityAri) : (0, $ivCUc.transformSelectSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $ivCUc.selectGetValueTransformer) : (0, $ivCUc.selectGetValueTransformerOld),
                    optionsVisibility: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))) : (0, $ivCUc.transformSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                ...(0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? {} : {
                    lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901)
                },
                propertyMapping: {
                    optionsVisibility: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? 'fieldOptionsFilter' : 'allowedValues'
                }
            },
            [(0, $lO4Or.URL_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $9Zo5b.validateSingleLineTextValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $9Zo5b.transformSingleLineTextToPublicValue)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $eMv4r.validateMultiCheckboxSetValue),
                    optionsVisibility: (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $2oXjw.multiCheckboxSetValueTransformer) : (0, $2oXjw.oldMultiCheckboxSetValueTransformer),
                    optionsVisibility: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $2oXjw.transformMultiCheckboxSetOptionsVisibility) : (0, $2oXjw.oldTransformMultiCheckboxSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $2oXjw.multiCheckboxGetValueTransformer) : (0, $2oXjw.oldMultiCheckboxGetValueTransformer),
                    optionsVisibility: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))) : (0, $2oXjw.transformMultiCheckboxGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $hFkmH.radioButtonsSetValueValidator),
                    optionsVisibility: (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $ioiX9.transformRadioButtonsSetValue) : (0, $ioiX9.radioButtonsSetValueTransformerOld),
                    optionsVisibility: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $ioiX9.transformRadioButtonsSetOptionsVisibility) : (0, $ioiX9.transformRadioButtonsSetOptionsVisibilityOld)
                },
                internalToPublicTransformers: {
                    value: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $ioiX9.transformRadioButtonsGetValue) : (0, $ioiX9.radioButtonsGetValueTransformerOld),
                    optionsVisibility: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))) : (0, $ioiX9.transformRadioButtonsGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $kt4Dk.paragraphSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $kt4Dk.paragraphSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $kt4Dk.paragraphGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.DESCRIPTION_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $kt4Dk.paragraphSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $kt4Dk.paragraphSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $kt4Dk.paragraphGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $ifv0j.validateMultiSelectSetValue),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $1TPgc.multiSelectSetValueTransformer),
                    optionsVisibility: (0, $b50wi.transformSetOptionsVisibilityAri)
                },
                internalToPublicTransformers: {
                    value: (0, $1TPgc.multiSelectGetValueTransformer),
                    /**
					 * Note: `transformFieldToIframe()` uses `FieldMapFromIframe` as input of optionsVisibility transformer,
					 * we're using `identity()` to return that same value and override `formData` (containing the private shape), before we sent it back to the iframe.
					 *
					 * Check "src/packages/issue-adjustments/issue-adjustments/src/controllers/issue-adjustments/main.tsx" for details.
					 */ optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
                },
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.ASSIGNEE_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $8QLPP.assigneeSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-5_gg7wo') ? (0, $dBUTs.transformAssigneeSetValue) : (0, $8QLPP.assigneeSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $8QLPP.assigneeGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            },
            [(0, $lO4Or.USER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $1h6vN.userPickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $6Hfnl.transformUserPickerSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $6Hfnl.transformUserPickerGetValue)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            },
            [(0, $lO4Or.REPORTER_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $1h6vN.userPickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $6Hfnl.transformUserPickerSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $6Hfnl.transformUserPickerGetValue)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            },
            [(0, $lO4Or.RESOLUTION_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $js9Si.resolutionSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $js9Si.resolutionSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $js9Si.resolutionGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.LABELS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $3g1BX.validateLabelsSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $incV3.labelsSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $incV3.labelsGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.DATE_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $9aEJT.datePickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $9aEJT.datePickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $9aEJT.datePickerGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.DATETIME_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $e8h5r.validateDateTimePickerSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $e8h5r.transformDateTimePickerSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $e8h5r.transformDateTimePickerGetValue)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.PRIORITY_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $gLagZ.validatePrioritySetValue),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $8IcPP.prioritySetValueTransformer),
                    optionsVisibility: (0, $8IcPP.transformSetOptionsVisibilityAriPriority)
                },
                internalToPublicTransformers: {
                    value: (0, $8IcPP.priorityGetValueTransformer),
                    optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
                },
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.ISSUE_TYPE)]: {
                publicShapeValidators: {
                    value: (0, $e793N.issueTypeSetValueValidator),
                    optionsVisibility: (0, $cHN5s.validateSetOptionsVisibilityIssueType)
                },
                publicToInternalTransformers: {
                    value: (0, $cHN5s.issueTypeSetValueTransformer),
                    optionsVisibility: (0, $cHN5s.transformIssueTypeSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $cHN5s.issueTypeGetValueTransformer),
                    optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
                },
                emitChangeOn: 'change',
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                }
            },
            [(0, $lO4Or.NUMBER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $htzHC.validateNumberValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {},
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.PARENT_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $7AbVk.parentSetValueValidator),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $k8Z2Y.transformParentSetValue),
                    optionsVisibility: (0, $k8Z2Y.transformParentSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $k8Z2Y.transformParentGetValue),
                    optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
                },
                emitChangeOn: 'change',
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                }
            },
            [(0, $lO4Or.FIX_VERSIONS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $3nLyZ.validateReleaseVersionValue),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $3nLyZ.transformReleaseVersionsSetValue),
                    optionsVisibility: (0, $3nLyZ.transformReleaseVersionsSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $3nLyZ.transformReleaseVersionsGetValue),
                    optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $3nLyZ.releaseVersionsRequiredScopes),
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                }
            },
            [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $3nLyZ.validateReleaseVersionValue),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $3nLyZ.transformReleaseVersionsSetValue),
                    optionsVisibility: (0, $3nLyZ.transformReleaseVersionsSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $3nLyZ.transformReleaseVersionsGetValue),
                    optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $3nLyZ.releaseVersionsRequiredScopes),
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                }
            },
            [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $axvW5.validateCascadingSelectSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $lKEcA.transformSetValueCascadingSelect)
                },
                internalToPublicTransformers: {
                    value: (0, $lKEcA.transformGetValueCascadingSelect)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.MULTI_USER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $1zzzr.validateMultiUserPickerSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $48Oaa.transformMultiUserPickerSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $48Oaa.transformMultiUserPickerGetValue)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            }
        };
    }
    getSupportedFieldTypes() {
        const supportedFieldTypes = [
            (0, $lO4Or.TEXT_CF_TYPE),
            (0, $lO4Or.SELECT_CF_TYPE),
            (0, $lO4Or.URL_CF_TYPE),
            (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
            (0, $lO4Or.RADIO_BUTTONS_CF_TYPE),
            (0, $lO4Or.TEXT_AREA_CF_TYPE),
            (0, $lO4Or.MULTI_SELECT_CF_TYPE),
            (0, $lO4Or.ASSIGNEE_TYPE),
            (0, $lO4Or.RESOLUTION_TYPE),
            (0, $lO4Or.DATE_CF_TYPE),
            (0, $lO4Or.DATETIME_CF_TYPE),
            (0, $lO4Or.LABELS_TYPE),
            (0, $lO4Or.PRIORITY_TYPE),
            (0, $lO4Or.ISSUE_TYPE),
            (0, $lO4Or.NUMBER_CF_TYPE),
            (0, $lO4Or.USER_CF_TYPE),
            (0, $lO4Or.FIX_VERSIONS_TYPE),
            (0, $lO4Or.AFFECTS_VERSIONS_TYPE),
            (0, $lO4Or.REPORTER_TYPE),
            (0, $lO4Or.CASCADING_SELECT_CF_TYPE),
            (0, $lO4Or.PARENT_TYPE),
            (0, $lO4Or.DESCRIPTION_TYPE),
            (0, $lO4Or.MULTI_USER_CF_TYPE)
        ];
        return supportedFieldTypes;
    }
    getSupportedProjectTypes() {
        return [
            (0, $7ZZxN.SOFTWARE_PROJECT)
        ];
    }
    getConsentMessage() {
        return (0, $fD0E1.default).uimTransitionViewConsentMessage;
    }
    getAnalytics() {
        return this.analytics;
    }
    getSupportedTriggerPointsConfiguration() {
        if ((0, $1ybV0.ff)('ui-modifications-on-issue-transition-view_7z1g0')) return new Set([
            (0, $fa834bef164496cf$export$ef94a84e2990361c),
            (0, $fa834bef164496cf$export$de11f84a7d32933b),
            (0, $fa834bef164496cf$export$6c46e4003e7b7e9c),
            (0, $fa834bef164496cf$export$4edf4c3eee5081f6),
            (0, $fa834bef164496cf$export$27b74e685c26e665),
            (0, $fa834bef164496cf$export$290710ac08f770c0),
            (0, $fa834bef164496cf$export$ddade13ad1b89bf0)
        ]);
        return new Set([]);
    }
    constructor(){
        this.analytics = {
            stopTTI: $fy5vB.stopTTI,
            cancelTTI: $fy5vB.cancelTTI,
            markIframeLoad: $fy5vB.markIframeLoad,
            markFieldsRegistered: $fy5vB.markFieldsRegistered,
            markOnInitResolved: $fy5vB.markOnInitResolved
        };
        this.isScreenTabsSupportEnabled = ()=>false;
    }
}

});
const $fa834bef164496cf$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $fa834bef164496cf$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $fa834bef164496cf$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $fa834bef164496cf$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $fa834bef164496cf$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $fa834bef164496cf$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $fa834bef164496cf$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $fa834bef164496cf$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $fa834bef164496cf$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $fa834bef164496cf$export$2bf0e335b815a90b = 'comment';
const $fa834bef164496cf$export$1b8cc53b37a62399 = 'worklog';
const $fa834bef164496cf$export$d624b8367eb730df = 'issuelinks';

parcelRegister("fy5vB", function(module, exports) {

$parcel$export(module.exports, "startUimTTI", () => $cdecbdc0cabe0dc7$export$ae34c17d9cd2c876);
$parcel$export(module.exports, "markIssueTransitionLoaded", () => $cdecbdc0cabe0dc7$export$7cc1bb35860c7c25);
$parcel$export(module.exports, "stopTTI", () => $cdecbdc0cabe0dc7$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $cdecbdc0cabe0dc7$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $cdecbdc0cabe0dc7$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $cdecbdc0cabe0dc7$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $cdecbdc0cabe0dc7$export$d86f4868694f2aa7);

var $lEpcX = parcelRequire("lEpcX");

var $gGRYc = parcelRequire("gGRYc");
const $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI = (0, $lEpcX.metrics).interaction({
    key: 'ui-modifications-in-issue-transition',
    timings: [
        {
            key: 'issue-transition-tti-delta',
            startMark: 'issue-transition-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $cdecbdc0cabe0dc7$export$ae34c17d9cd2c876 = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.start();
};
const $cdecbdc0cabe0dc7$export$7cc1bb35860c7c25 = ()=>$cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('issue-transition-tti');
const $cdecbdc0cabe0dc7$export$30ca4c461fab486c = (customData)=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.stop({
        customData: customData
    });
};
const $cdecbdc0cabe0dc7$export$27f2445288b528c = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.cancel();
};
const $cdecbdc0cabe0dc7$export$7a2709fc1e33401a = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('iframe-load');
};
const $cdecbdc0cabe0dc7$export$cf3893335c93e33b = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('fields-registered');
};
const $cdecbdc0cabe0dc7$export$d86f4868694f2aa7 = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('oninit-resolved');
};

});

parcelRegister("eMv4r", function(module, exports) {

$parcel$export(module.exports, "validateMultiCheckboxSetValue", () => $1b4aa32c8b85acdf$export$56639f1c650d9ba5);


var $8xPow = parcelRequire("8xPow");
const $1b4aa32c8b85acdf$export$56639f1c650d9ba5 = (value)=>Array.isArray(value) && value.length <= (0, $6b8c146c2dd688bb$export$106087dcfd4fb129) && value.every((0, $8xPow.isNotEmptyString));

});

parcelRegister("ifv0j", function(module, exports) {

$parcel$export(module.exports, "validateMultiSelectSetValue", () => $0a46a3adc5b74859$export$7002ea8d8a6dd444);
$parcel$export(module.exports, "multiSelectScopes", () => $0a46a3adc5b74859$export$314882a3f1f403d6);


var $4XB9o = parcelRequire("4XB9o");

var $8xPow = parcelRequire("8xPow");
const $0a46a3adc5b74859$export$7002ea8d8a6dd444 = (value)=>Array.isArray(value) && value.length <= (0, $6b8c146c2dd688bb$export$106087dcfd4fb129) && value.every((0, $8xPow.isNotEmptyString));
const $0a46a3adc5b74859$export$314882a3f1f403d6 = (0, $4XB9o.baseScopesRequiredPerField);

});

parcelRegister("1zzzr", function(module, exports) {

$parcel$export(module.exports, "validateMultiUserPickerSetValue", () => $1202a9c5b84d7884$export$57a9bf0fd9eba591);


var $fBuJM = parcelRequire("fBuJM");

var $8xPow = parcelRequire("8xPow");
const $1202a9c5b84d7884$export$57a9bf0fd9eba591 = (value)=>Array.isArray(value) && value.length <= (0, $6b8c146c2dd688bb$export$106087dcfd4fb129) && // We should omit automatic id special value so it won't be picked up by this field
    // It is only applicable to the assignee field
    value.every((option)=>(0, $8xPow.isNotEmptyString)(option) && (0, $fBuJM.isNotAutomaticId)(option));

});

parcelRegister("9Zo5b", function(module, exports) {

$parcel$export(module.exports, "validateSingleLineTextValue", () => $266811df11a6043f$export$88db43fe998a9953);
$parcel$export(module.exports, "transformSingleLineTextToPublicValue", () => $266811df11a6043f$export$7c3fcefca458407b);
$parcel$export(module.exports, "singleLineTextScopes", () => $266811df11a6043f$export$60f08a79db8505dc);

var $4XB9o = parcelRequire("4XB9o");
const $266811df11a6043f$export$88db43fe998a9953 = (value)=>typeof value === 'string';
const $266811df11a6043f$export$7c3fcefca458407b = (internalValue)=>internalValue || '';
const $266811df11a6043f$export$60f08a79db8505dc = (0, $4XB9o.baseScopesRequiredPerField);

});

parcelRegister("b50wi", function(module, exports) {

$parcel$export(module.exports, "transformSelectSetOptionsVisibility", () => $ced00c0766dbb63f$export$81990085f8ab114b);
$parcel$export(module.exports, "transformOptionIdsToARI", () => $ced00c0766dbb63f$export$aaa1909c16b4bd2c);
$parcel$export(module.exports, "transformSetOptionsVisibilityAri", () => $ced00c0766dbb63f$export$a68e1c2d1192287c);
$parcel$export(module.exports, "transformSelectGetOptionsVisibility", () => $ced00c0766dbb63f$export$7c7ca81813eb0f65);
$parcel$export(module.exports, "optionsVisibilityContainNoMoreThan100Items", () => $ced00c0766dbb63f$export$914c7f5212c4c649);
$parcel$export(module.exports, "validateSetOptionsVisibility", () => $ced00c0766dbb63f$export$973aead813665e25);

var $huI7r = parcelRequire("huI7r");

var $2xymT = parcelRequire("2xymT");
const $ced00c0766dbb63f$export$81990085f8ab114b = ({ isVisible: isVisible, options: options })=>({
        operation: isVisible ? 'ALLOW' : 'EXCLUDE',
        ids: options
    });
const $ced00c0766dbb63f$export$aaa1909c16b4bd2c = (optionIds, { tenantContext: tenantContext, fieldContext: fieldContext })=>optionIds.map((optionId)=>{
        const resourceId = `${fieldContext.fieldId}/${optionId}`;
        return (0, $huI7r.createAri)({
            resourceOwner: 'jira',
            cloudId: tenantContext.cloudId,
            resourceType: 'issue-field-option',
            activationId: tenantContext.activationId,
            resourceId: resourceId
        });
    });
const $ced00c0766dbb63f$export$a68e1c2d1192287c = ({ isVisible: isVisible, options: options }, _lookupValues, context)=>({
        operation: isVisible ? 'ALLOW' : 'EXCLUDE',
        optionIds: $ced00c0766dbb63f$export$aaa1909c16b4bd2c(options, context)
    });
const $ced00c0766dbb63f$export$7c7ca81813eb0f65 = ({ isVisible: isVisible, options: options })=>({
        isVisible: isVisible,
        options: options
    });
const $ced00c0766dbb63f$export$914c7f5212c4c649 = (optionsVisibility)=>optionsVisibility.options.length <= 100;
const $ced00c0766dbb63f$export$973aead813665e25 = (optionsVisibility)=>(0, $2xymT.validateSetOptionsVisibilityRule)(optionsVisibility) && $ced00c0766dbb63f$export$914c7f5212c4c649(optionsVisibility);

});

parcelRegister("dBUTs", function(module, exports) {

$parcel$export(module.exports, "transformAssigneeSetValue", () => $e2b90bba5e8591a9$export$8de5b8bd1490307a);


var $2Vsz9 = parcelRequire("2Vsz9");

var $9DCyM = parcelRequire("9DCyM");
const $e2b90bba5e8591a9$export$8de5b8bd1490307a = (value, lookupValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, lookupValues, 'accountId');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    if (foundValue.accountId === (0, $19ac13c3509f8eeb$export$203481fb42374407)) return {
        ...foundValue,
        id: (0, $19ac13c3509f8eeb$export$f5d5f6bb902f1027),
        accountStatus: 'active'
    };
    return foundValue;
};

});
const $19ac13c3509f8eeb$export$3619ebc524504344 = 'assignee';
const $19ac13c3509f8eeb$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $19ac13c3509f8eeb$export$f5d5f6bb902f1027 = 'ari:cloud:identity::user/-1';
const $19ac13c3509f8eeb$export$203481fb42374407 = '-1';


parcelRegister("lKEcA", function(module, exports) {

$parcel$export(module.exports, "transformSetValueCascadingSelect", () => $ba8b57f84711c945$export$905a8d55c641a71e);
$parcel$export(module.exports, "transformGetValueCascadingSelect", () => $ba8b57f84711c945$export$47e9770ed0d1c344);

var $3l1bi = parcelRequire("3l1bi");

var $2rn3r = parcelRequire("2rn3r");

var $2Vsz9 = parcelRequire("2Vsz9");

var $cc5IR = parcelRequire("cc5IR");

var $39bQi = parcelRequire("39bQi");
const $ba8b57f84711c945$export$2cb19dacff9881ed = (0, $3l1bi.default);
const $ba8b57f84711c945$export$905a8d55c641a71e = async (inputValue, _lookupValues, { tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext })=>{
    if (inputValue === null) return null;
    let childAri = null;
    const parentAri = (0, $2rn3r.JiraIssueFieldOptionAri).create({
        siteId: tenantContext.cloudId,
        activationId: tenantContext.activationId,
        fieldId: fieldContext.fieldId,
        optionId: inputValue.parentId
    }).toString();
    if (inputValue?.childId) childAri = (0, $2rn3r.JiraIssueFieldOptionAri).create({
        siteId: tenantContext.cloudId,
        activationId: tenantContext.activationId,
        fieldId: fieldContext.fieldId,
        optionId: inputValue.childId
    }).toString();
    const response = await (0, $cc5IR.fetchFieldOptions)({
        tenantContext: tenantContext,
        viewContext: viewContext,
        environment: environment,
        fieldContext: fieldContext,
        optionARIs: [
            parentAri
        ],
        nodePropertyName: 'parentOptions',
        queryName: 'FETCH_CASCADING_SELECT',
        query: $ba8b57f84711c945$export$2cb19dacff9881ed,
        extraQueryVariables: {
            filterByIdChild: {
                optionIds: childAri ? [
                    childAri
                ] : [],
                operation: 'ALLOW'
            }
        }
    });
    const parentOption = response?.edges?.[0]?.node;
    const childOption = response?.edges?.[0]?.node?.childOptions?.edges?.[0]?.node;
    if (parentOption?.id !== parentAri || inputValue?.childId && childOption?.id !== childAri) throw new (0, $2Vsz9.FieldValueLookupError)(JSON.stringify(inputValue));
    return {
        parentOptionValue: {
            id: parentOption.id,
            value: parentOption?.value ?? ''
        },
        childOptionValue: inputValue?.childId && childOption ? {
            id: childOption.id,
            value: childOption?.value ?? ''
        } : null
    };
};
const $ba8b57f84711c945$export$47e9770ed0d1c344 = (inputValue)=>{
    if (!inputValue) return null;
    const parent = {
        id: (0, $39bQi.getResourceIdfromAri)(inputValue.parentOptionValue.id),
        value: inputValue.parentOptionValue.value
    };
    const child = inputValue.childOptionValue ? {
        id: (0, $39bQi.getResourceIdfromAri)(inputValue.childOptionValue.id),
        value: inputValue.childOptionValue.value
    } : null;
    return {
        parent: parent,
        child: child
    };
};

});
parcelRegister("3l1bi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba182a4c1395dba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fd73fd915e48c4a426112bc260bf0f05>>
 * @relayHash 897e785dd82d688a8b92757085b3206d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 59653e087b319c6c1799a443fab7349acbf7cc3fb9daf3db605b9a9f1d3ae86a
const $1ba182a4c1395dba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterByIdChild"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "ari"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "filterById",
                        "variableName": "filterById"
                    }
                ],
                "concreteType": "JiraParentOptionConnection",
                "kind": "LinkedField",
                "name": "parentOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraParentOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraParentOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v2 /*: any*/ ,
                                    v3 /*: any*/ ,
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "filterById",
                                                "variableName": "filterByIdChild"
                                            }
                                        ],
                                        "concreteType": "JiraOptionConnection",
                                        "kind": "LinkedField",
                                        "name": "childOptions",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraOptionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraOption",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v2 /*: any*/ ,
                                                            v3 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCascadingSelectField"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cascadingSelectIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cascadingSelectIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v4 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "59653e087b319c6c1799a443fab7349acbf7cc3fb9daf3db605b9a9f1d3ae86a",
            "metadata": {},
            "name": "cascadingSelectIssueTransitionIssueAdjustmentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1ba182a4c1395dba$var$node.hash = "05c858c87aebae163faf43d2a0d580f3";
var $1ba182a4c1395dba$export$2e2bcd8739ae039 = $1ba182a4c1395dba$var$node;

});

parcelRegister("cc5IR", function(module, exports) {

$parcel$export(module.exports, "fetchFieldOptions", () => $1d228c83c3afa0b0$export$89b4c8a7d912358b);

var $iWLL0 = parcelRequire("iWLL0");

var $huI7r = parcelRequire("huI7r");
const $1d228c83c3afa0b0$export$89b4c8a7d912358b = async ({ tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext, optionARIs: optionARIs, nodePropertyName: nodePropertyName, queryName: queryName, query: query, extraQueryVariables: extraQueryVariables = {} })=>{
    let response;
    try {
        response = await (0, $iWLL0.fetchQuery)(environment, query, {
            ari: (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'issuefieldvalue',
                resourceId: `${viewContext.issueId}/${fieldContext.fieldId}`
            }),
            filterById: {
                optionIds: optionARIs,
                operation: 'ALLOW'
            },
            ...extraQueryVariables
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        if (!response || !response.node || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        !response.node[nodePropertyName]) throw new Error(`[${queryName}]: Property ${nodePropertyName} does not exist.`, {
            cause: `${queryName}_MISSING_FIELD_OPTIONS_PROPERTY`
        });
    } catch (err) {
        const error = err instanceof Error ? err : new Error();
        if (!error.cause) error.cause = `${queryName}_FIELD_OPTION_REQUEST_FAILED`;
        throw error;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return response.node[nodePropertyName];
};

});

parcelRegister("39bQi", function(module, exports) {

$parcel$export(module.exports, "getResourceIdfromAri", () => $f901710551638b10$export$8977d55db9d1c1bb);

var $huI7r = parcelRequire("huI7r");
const $f901710551638b10$export$8977d55db9d1c1bb = (value)=>(0, $huI7r.parseAri)(value)?.resourceId ?? '';

});


parcelRegister("cHN5s", function(module, exports) {

$parcel$export(module.exports, "issueTypeGetValueTransformer", () => $415c5119f8f8eb21$export$391657d4e7f81237);
$parcel$export(module.exports, "issueTypeSetValueTransformer", () => $415c5119f8f8eb21$export$93e4fd33c48f4977);
$parcel$export(module.exports, "validateSetOptionsVisibilityIssueType", () => $415c5119f8f8eb21$export$aa313386b5aded3f);
$parcel$export(module.exports, "transformIssueTypeSetOptionsVisibility", () => $415c5119f8f8eb21$export$db493bcecec5fb56);

var $a5LdW = parcelRequire("a5LdW");

var $lSeXP = parcelRequire("lSeXP");

var $2Vsz9 = parcelRequire("2Vsz9");

var $cc5IR = parcelRequire("cc5IR");

var $2xymT = parcelRequire("2xymT");

var $39bQi = parcelRequire("39bQi");

var $b50wi = parcelRequire("b50wi");
const $415c5119f8f8eb21$export$391657d4e7f81237 = (value)=>{
    if (!value) return null;
    return {
        id: (0, $39bQi.getResourceIdfromAri)(value.value),
        name: value.label
    };
};
const $415c5119f8f8eb21$export$5c18f9ce93e4df2d = (0, $a5LdW.default);
const $415c5119f8f8eb21$export$93e4fd33c48f4977 = async (inputValue, _lookupValues, { tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext })=>{
    const issueTypeARI = (0, $lSeXP.JiraIssueTypeAri).create({
        siteId: tenantContext.cloudId,
        issueTypeId: inputValue
    }).toString();
    // it depends on jira-issue-type-field-options-filtering FF (add as dependency)
    const response = await (0, $cc5IR.fetchFieldOptions)({
        tenantContext: tenantContext,
        viewContext: viewContext,
        environment: environment,
        fieldContext: fieldContext,
        optionARIs: [
            issueTypeARI
        ],
        nodePropertyName: 'issueTypesForTransition',
        queryName: 'FETCH_ISSUE_TYPE',
        query: $415c5119f8f8eb21$export$5c18f9ce93e4df2d
    });
    const issueType = response?.edges?.[0]?.node;
    if (issueType?.value !== issueTypeARI) throw new (0, $2Vsz9.FieldValueLookupError)(inputValue);
    return {
        value: issueType.value,
        label: issueType.label ?? '',
        avatar: {
            small: issueType?.avatar?.small ?? ''
        }
    };
};
const $415c5119f8f8eb21$export$aa313386b5aded3f = (optionsVisibility)=>(0, $2xymT.validateSetOptionsVisibilityRule)(optionsVisibility) && (0, $b50wi.optionsVisibilityContainNoMoreThan100Items)(optionsVisibility);
const $415c5119f8f8eb21$export$db493bcecec5fb56 = (optionsVisibility, _lookupValues, { tenantContext: tenantContext })=>({
        optionIds: optionsVisibility.options.map((optionId)=>(0, $lSeXP.JiraIssueTypeAri).create({
                siteId: tenantContext.cloudId,
                issueTypeId: optionId
            }).toString()),
        operation: optionsVisibility.isVisible ? 'ALLOW' : 'EXCLUDE'
    });

});
parcelRegister("a5LdW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0af8b7513c73091$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<929230ceb9941390a54f78d0fcd40f06>>
 * @relayHash 62034951ad478b9310149b860e0e5d76
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dc489ea573805d3058b4220a278b462df520be5380ad0c5861fb89ed6d98d79d
const $b0af8b7513c73091$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "ari"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "filterById",
            "variableName": "filterById"
        }
    ], v3 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "issueTypeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypesForTransition",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraIssueTypeField"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "issueTypeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypesForTransition",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraIssueTypeField"
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "dc489ea573805d3058b4220a278b462df520be5380ad0c5861fb89ed6d98d79d",
            "metadata": {},
            "name": "issueTypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b0af8b7513c73091$var$node.hash = "fffc08bf530de123da55bbae6d5a77bb";
var $b0af8b7513c73091$export$2e2bcd8739ae039 = $b0af8b7513c73091$var$node;

});

parcelRegister("lSeXP", function(module, exports) {

$parcel$export(module.exports, "JiraIssueTypeAri", () => $5565f3a77cc61dd8$export$931e4419330c3862);

var $ivR3E = parcelRequire("ivR3E");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/issue-type/manifest.ts
var $5565f3a77cc61dd8$var$jiraIssueTypeAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $ivR3E.JiraIssueTypeAriResourceOwner),
    resourceType: (0, $ivR3E.JiraIssueTypeAriResourceType),
    resourceIdSlug: "{issueTypeId}",
    resourceIdSegmentFormats: {
        issueTypeId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/issue-type/index.ts
var $5565f3a77cc61dd8$export$931e4419330c3862 = class _JiraIssueTypeAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueTypeId = opts.resourceIdSegmentValues.issueTypeId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueTypeId() {
        return this._issueTypeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $5565f3a77cc61dd8$var$jiraIssueTypeAriStaticOpts.qualifier,
            platformQualifier: $5565f3a77cc61dd8$var$jiraIssueTypeAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $5565f3a77cc61dd8$var$jiraIssueTypeAriStaticOpts.resourceOwner,
            resourceType: $5565f3a77cc61dd8$var$jiraIssueTypeAriStaticOpts.resourceType,
            resourceId: `${opts.issueTypeId}`,
            resourceIdSegmentValues: {
                issueTypeId: opts.issueTypeId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $5565f3a77cc61dd8$var$jiraIssueTypeAriStaticOpts);
        return new _JiraIssueTypeAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $5565f3a77cc61dd8$var$jiraIssueTypeAriStaticOpts);
        return new _JiraIssueTypeAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueTypeId: this.issueTypeId
        };
    }
};

});
parcelRegister("ivR3E", function(module, exports) {

$parcel$export(module.exports, "JiraIssueTypeAriResourceOwner", () => $1571d0ff007c6aa8$export$a40271de8e7c8a70);
$parcel$export(module.exports, "JiraIssueTypeAriResourceType", () => $1571d0ff007c6aa8$export$70e5e6fc47f1a2cc);
// src/jira/issue-type/types.ts
var $1571d0ff007c6aa8$export$a40271de8e7c8a70 = "jira", $1571d0ff007c6aa8$export$70e5e6fc47f1a2cc = "issue-type";

});



parcelRegister("3g1BX", function(module, exports) {

$parcel$export(module.exports, "validateLabelsSetValue", () => $24cd4c9564078af1$export$6130bc1755ce872a);


var $8xPow = parcelRequire("8xPow");
const $24cd4c9564078af1$export$6130bc1755ce872a = (value)=>Array.isArray(value) && value.length <= (0, $6b8c146c2dd688bb$export$106087dcfd4fb129) && value.every((0, $8xPow.isNotEmptyString));

});

parcelRegister("2oXjw", function(module, exports) {

$parcel$export(module.exports, "oldTransformMultiCheckboxSetOptionsVisibility", () => $eac593fbe3f09bca$export$d54e26a70b9eded2);
$parcel$export(module.exports, "transformMultiCheckboxSetOptionsVisibility", () => $eac593fbe3f09bca$export$115a0b8c81087c2c);
$parcel$export(module.exports, "transformMultiCheckboxGetOptionsVisibility", () => $eac593fbe3f09bca$export$4471ab017a7abd7);
$parcel$export(module.exports, "oldMultiCheckboxSetValueTransformer", () => $eac593fbe3f09bca$export$60d0ede531dc3889);
$parcel$export(module.exports, "multiCheckboxSetValueTransformer", () => $eac593fbe3f09bca$export$9ba1ee83cc9456ba);
$parcel$export(module.exports, "oldMultiCheckboxGetValueTransformer", () => $eac593fbe3f09bca$export$c4727c29a2e818d6);
$parcel$export(module.exports, "multiCheckboxGetValueTransformer", () => $eac593fbe3f09bca$export$6d15ce1cc0bdffe7);

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $j55UJ = parcelRequire("j55UJ");

var $39bQi = parcelRequire("39bQi");

var $jgrDo = parcelRequire("jgrDo");

var $eF9ai = parcelRequire("eF9ai");

var $b50wi = parcelRequire("b50wi");
const $eac593fbe3f09bca$export$d54e26a70b9eded2 = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');
const $eac593fbe3f09bca$export$115a0b8c81087c2c = ({ options: options, isVisible: isVisible }, lookupValues, context)=>{
    const aris = (0, $b50wi.transformOptionIdsToARI)(options, context);
    return (0, $240Nk.applyOptionsVisibilityRule)({
        options: aris,
        isVisible: isVisible
    }, lookupValues, 'value');
};
const $eac593fbe3f09bca$export$4471ab017a7abd7 = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');
const $eac593fbe3f09bca$export$60d0ede531dc3889 = (publicValue, allowedValues)=>{
    if (!publicValue.length) return [];
    const foundValue = (0, $eF9ai.multiValueLookup)(publicValue, allowedValues, 'value');
    if (foundValue.length !== publicValue.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(publicValue, foundValue, 'value');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return foundValue;
};
const $eac593fbe3f09bca$export$9ba1ee83cc9456ba = (publicValue, allowedValues, context)=>{
    if (!publicValue.length) return [];
    const foundValue = (0, $eF9ai.multiValueLookup)((0, $b50wi.transformOptionIdsToARI)(publicValue, context), allowedValues, 'value');
    if (foundValue.length !== publicValue.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(publicValue, foundValue, 'value');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return foundValue;
};
const $eac593fbe3f09bca$export$c4727c29a2e818d6 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: value,
            value: label
        }));
};
const $eac593fbe3f09bca$export$6d15ce1cc0bdffe7 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: (0, $39bQi.getResourceIdfromAri)(value),
            value: label
        }));
};

});

parcelRegister("1TPgc", function(module, exports) {

$parcel$export(module.exports, "multiSelectSetValueTransformer", () => $3741151681c21924$export$87ccfa5280a3288f);
$parcel$export(module.exports, "multiSelectGetValueTransformer", () => $3741151681c21924$export$9992ce1903b64c5);

var $4i5CZ = parcelRequire("4i5CZ");

var $huI7r = parcelRequire("huI7r");

var $2Vsz9 = parcelRequire("2Vsz9");

var $cc5IR = parcelRequire("cc5IR");

var $39bQi = parcelRequire("39bQi");

var $jgrDo = parcelRequire("jgrDo");
const $3741151681c21924$export$5cc625f595670ece = (0, $4i5CZ.default);
const $3741151681c21924$export$87ccfa5280a3288f = async (values, _lookupValues, { tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext })=>{
    if (!values.length) return [];
    const optionARIs = values.map((optionId)=>{
        const resourceId = `${fieldContext.fieldId}/${optionId}`;
        return (0, $huI7r.createAri)({
            resourceOwner: 'jira',
            cloudId: tenantContext.cloudId,
            resourceType: 'issue-field-option',
            activationId: tenantContext.activationId,
            resourceId: resourceId
        });
    });
    const response = await (0, $cc5IR.fetchFieldOptions)({
        tenantContext: tenantContext,
        viewContext: viewContext,
        environment: environment,
        fieldContext: fieldContext,
        optionARIs: optionARIs,
        nodePropertyName: 'fieldOptions',
        queryName: 'FETCH_MULTI_SELECT',
        query: $3741151681c21924$export$5cc625f595670ece
    });
    const fieldOptions = response?.edges?.map((edge)=>edge?.node).filter(Boolean).filter(({ value: value })=>optionARIs.includes(value)).map(({ label: label, value: optionValue })=>({
            label: label ?? '',
            value: optionValue
        })) ?? [];
    if (fieldOptions.length !== values.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(optionARIs, fieldOptions, 'value');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.map((value)=>(0, $39bQi.getResourceIdfromAri)(value)).join());
    }
    return fieldOptions;
};
const $3741151681c21924$export$9992ce1903b64c5 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: (0, $39bQi.getResourceIdfromAri)(value),
            value: label
        }));
};

});
parcelRegister("4i5CZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f72891612662e94$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8973fc32f41005ada60f03db2f35714c>>
 * @relayHash f16f2688fb82395dbff9cc53b5991a29
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 40f8ccf331ee2738de878621a8d5a7851e1740ff1ae9bd7f56cecb8ae82c0c08
const $9f72891612662e94$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "ari"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "filterById",
            "variableName": "filterById"
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        }
    ], v3 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "value"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiSelectQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraMultipleSelectField"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiSelectQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraMultipleSelectField"
                        },
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "40f8ccf331ee2738de878621a8d5a7851e1740ff1ae9bd7f56cecb8ae82c0c08",
            "metadata": {},
            "name": "multiSelectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9f72891612662e94$var$node.hash = "85f2a0ca2abb954e2213378539f66106";
var $9f72891612662e94$export$2e2bcd8739ae039 = $9f72891612662e94$var$node;

});


parcelRegister("48Oaa", function(module, exports) {

$parcel$export(module.exports, "transformMultiUserPickerSetValue", () => $cadc20aae57cd42c$export$5b3066e9c91b4b70);
$parcel$export(module.exports, "transformMultiUserPickerGetValue", () => $cadc20aae57cd42c$export$14f50c5c8c51bfdc);

var $2Vsz9 = parcelRequire("2Vsz9");

var $jgrDo = parcelRequire("jgrDo");

var $eF9ai = parcelRequire("eF9ai");
const $cadc20aae57cd42c$export$5b3066e9c91b4b70 = (values, lookupValues)=>{
    if (!values.length) return [];
    const filteredLookupValues = (0, $eF9ai.multiValueLookup)(values, lookupValues, 'accountId');
    if (values.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(values, filteredLookupValues, 'accountId');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ id: id, accountId: accountId, accountStatus: accountStatus, name: name, picture: picture })=>({
            id: id,
            accountId: accountId,
            accountStatus: accountStatus,
            name: name,
            picture: picture
        }));
};
const $cadc20aae57cd42c$export$14f50c5c8c51bfdc = (value)=>{
    if (!value) return [];
    return value.map(({ accountId: accountId })=>({
            accountId: accountId
        }));
};

});

parcelRegister("kt4Dk", function(module, exports) {

$parcel$export(module.exports, "paragraphSetValueValidator", () => $94b0b3a34e7f86b6$export$374879bc6474221d);
$parcel$export(module.exports, "paragraphSetValueTransformer", () => $94b0b3a34e7f86b6$export$4f3e7aa88a08b7db);
$parcel$export(module.exports, "paragraphGetValueTransformer", () => $94b0b3a34e7f86b6$export$88b493c87579f4ea);

var $kFGm5 = parcelRequire("kFGm5");

var $9tBd5 = parcelRequire("9tBd5");


var $cw2gk = parcelRequire("cw2gk");
const $94b0b3a34e7f86b6$var$rendererValidators = {
    [(0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c)]: (value, { currentField: currentField, viewType: viewType })=>(0, $cw2gk.isValidADF)({
            newValue: value,
            currentValue: currentField?.value,
            viewType: viewType
        }),
    [(0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)]: (value)=>Promise.resolve(typeof value === 'string')
};
const $94b0b3a34e7f86b6$var$getRenderer = (renderer)=>{
    if (renderer === (0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c) || renderer === (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)) return renderer;
    throw new Error(`Invalid renderer: ${renderer}`);
};
const $94b0b3a34e7f86b6$export$374879bc6474221d = (value, { fieldRenderer: fieldRenderer }, _createAnalyticsEvent, extra)=>{
    try {
        const renderer = $94b0b3a34e7f86b6$var$getRenderer(fieldRenderer);
        return $94b0b3a34e7f86b6$var$rendererValidators[renderer](value, extra);
    } catch (e) {
        return Promise.resolve(false);
    }
};
const $94b0b3a34e7f86b6$export$4f3e7aa88a08b7db = (value)=>typeof value === 'string' ? value : {
        ...value,
        overrideRequired: true
    };
const $94b0b3a34e7f86b6$export$88b493c87579f4ea = (value, fieldRenderer)=>{
    if (value === undefined) // The `convertTextToAdf` call will give us an "empty ADF object":
    // {
    //   "type": "doc",
    //   "version": 1,
    //   "content": [
    //     {
    //       "type": "paragraph",
    //       "content": []
    //     }
    //   ]
    // }
    return fieldRenderer === (0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c) ? (0, $9tBd5.convertTextToAdf)('') : '';
    if (typeof value === 'string') return value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(value, 'overrideRequired');
};

});

parcelRegister("k8Z2Y", function(module, exports) {

$parcel$export(module.exports, "transformParentSetValue", () => $82a3aa21642067b8$export$2c2fa789efcce745);
$parcel$export(module.exports, "transformParentGetValue", () => $82a3aa21642067b8$export$98caacb992dbef18);
$parcel$export(module.exports, "transformParentSetOptionsVisibility", () => $82a3aa21642067b8$export$63fbd35228742042);

var $3lDIQ = parcelRequire("3lDIQ");

var $2Shq0 = parcelRequire("2Shq0");

var $4UIXh = parcelRequire("4UIXh");

var $2Vsz9 = parcelRequire("2Vsz9");

var $cc5IR = parcelRequire("cc5IR");

var $39bQi = parcelRequire("39bQi");
const $82a3aa21642067b8$export$9687b4a4fc9632b9 = (0, $3lDIQ.default);
const $82a3aa21642067b8$export$2c2fa789efcce745 = async (inputValue, _lookupValues, { tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext })=>{
    if (!inputValue) return null;
    const optionAri = (0, $2Shq0.JiraIssueAri).create({
        siteId: tenantContext.cloudId,
        issueId: inputValue
    }).toString();
    const response = await (0, $cc5IR.fetchFieldOptions)({
        tenantContext: tenantContext,
        viewContext: viewContext,
        environment: environment,
        fieldContext: fieldContext,
        optionARIs: [
            optionAri
        ],
        nodePropertyName: 'parentCandidatesForExistingIssue',
        queryName: 'FETCH_PARENT',
        query: $82a3aa21642067b8$export$9687b4a4fc9632b9
    });
    const parentValue = (0, $4UIXh.transformParentNode)(response?.edges?.[0]?.node);
    if (parentValue?.value !== optionAri) throw new (0, $2Vsz9.FieldValueLookupError)(inputValue);
    return parentValue;
};
const $82a3aa21642067b8$export$98caacb992dbef18 = (intervalValue)=>{
    if (!intervalValue) return null;
    return {
        id: (0, $39bQi.getResourceIdfromAri)(intervalValue?.id?.toString() || ''),
        key: intervalValue.key
    };
};
const $82a3aa21642067b8$export$63fbd35228742042 = (optionsVisibility, _lookupValues, { tenantContext: tenantContext })=>({
        optionIds: optionsVisibility.options.map((optionId)=>(0, $2Shq0.JiraIssueAri).create({
                siteId: tenantContext.cloudId,
                issueId: optionId
            }).toString()),
        operation: optionsVisibility.isVisible ? 'ALLOW' : 'EXCLUDE'
    });

});
parcelRegister("3lDIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $91fc2eaceef21d96$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<690118cf7a65320e213a3256c2e353e5>>
 * @relayHash 9254794c81eab73d38a4fcd183545b44
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e7eaadf0b4bc99fcf00cfa29d947f83ace3effa8dc03c1cd6d9d8e435d7881a6
const $91fc2eaceef21d96$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "ari"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "excludeDone",
            "value": false
        },
        {
            "kind": "Variable",
            "name": "filterById",
            "variableName": "filterById"
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "colorKey"
    }, v6 = [
        {
            "kind": "Literal",
            "name": "ids",
            "value": [
                "summary",
                "issuetype",
                "status"
            ]
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "text"
            }
        ],
        "type": "JiraSingleLineTextField"
    }, v9 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v12 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "parentIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "parentCandidatesForExistingIssue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraColorField",
                                                            "kind": "LinkedField",
                                                            "name": "issueColorField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraColor",
                                                                    "kind": "LinkedField",
                                                                    "name": "color",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "args": v6 /*: any*/ ,
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v9 /*: any*/ ,
                                                                                                v10 /*: any*/ ,
                                                                                                v11 /*: any*/ ,
                                                                                                v12 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraParentIssueField"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "parentIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "parentCandidatesForExistingIssue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraColorField",
                                                            "kind": "LinkedField",
                                                            "name": "issueColorField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraColor",
                                                                    "kind": "LinkedField",
                                                                    "name": "color",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                },
                                                                v2 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v6 /*: any*/ ,
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v14 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v9 /*: any*/ ,
                                                                                                v10 /*: any*/ ,
                                                                                                v11 /*: any*/ ,
                                                                                                v12 /*: any*/ ,
                                                                                                v2 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        v2 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v2 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                v2 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraParentIssueField"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e7eaadf0b4bc99fcf00cfa29d947f83ace3effa8dc03c1cd6d9d8e435d7881a6",
            "metadata": {},
            "name": "parentIssueTransitionIssueAdjustmentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$91fc2eaceef21d96$var$node.hash = "80f30b7afe9a71b36db44f64eef395cf";
var $91fc2eaceef21d96$export$2e2bcd8739ae039 = $91fc2eaceef21d96$var$node;

});

parcelRegister("4UIXh", function(module, exports) {

$parcel$export(module.exports, "transformParentNode", () => $1a121e8634edf34d$export$1b622b80a5cf731f);
$parcel$export(module.exports, "transformToSuggestions", () => $1a121e8634edf34d$export$6cffaaeb4c7c0c18);

var $8Qd0L = parcelRequire("8Qd0L");

var $tgbCK = parcelRequire("tgbCK");
const $1a121e8634edf34d$export$1b622b80a5cf731f = (edgeNode)=>{
    const fieldsEdges = edgeNode?.fieldsById?.edges || [];
    const summaryField = fieldsEdges.find((field)=>field?.node?.fieldId === 'summary');
    const issueTypeField = fieldsEdges.find((field)=>field?.node?.fieldId === 'issuetype');
    const statusField = fieldsEdges.find((field)=>field?.node?.fieldId === 'status');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKey = edgeNode?.issueColorField?.color?.colorKey;
    const checkParentIssueIsDone = (statusCategoryId)=>{
        const doneStatusCategoryId = (0, $8Qd0L).StatusCategoryIds[(0, $8Qd0L).StatusCategoryTypes.DONE];
        return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
    };
    const isDone = checkParentIssueIsDone(statusField?.node?.status?.statusCategory?.statusCategoryId || '');
    return {
        id: edgeNode?.id || '',
        key: edgeNode?.key || '',
        fields: {
            issuetype: {
                id: issueTypeField?.node?.issueType?.issueTypeId || '',
                name: issueTypeField?.node?.issueType?.name || '',
                iconUrl: issueTypeField?.node?.issueType?.avatar?.xsmall || ''
            },
            summary: summaryField?.node?.text || ''
        },
        color: colorKey in (0, $tgbCK.MAP_FROM_SERVER_COLOR) ? (0, $tgbCK.MAP_FROM_SERVER_COLOR)[colorKey] : undefined,
        value: edgeNode?.id || '',
        label: `${edgeNode?.key || ''} ${summaryField?.node?.text || ''}`,
        isDone: isDone
    };
};
const $1a121e8634edf34d$export$6cffaaeb4c7c0c18 = (fieldOptionsData)=>(fieldOptionsData?.edges || [])?.filter((edge)=>edge?.node).map((edge)=>$1a121e8634edf34d$export$1b622b80a5cf731f(edge?.node));

});


parcelRegister("8IcPP", function(module, exports) {

$parcel$export(module.exports, "priorityGetValueTransformer", () => $5cbf08b8a0823fbb$export$a3dcdeebcccb44cd);
$parcel$export(module.exports, "prioritySetValueTransformer", () => $5cbf08b8a0823fbb$export$c6ef424ead917b72);
$parcel$export(module.exports, "transformSetOptionsVisibilityAriPriority", () => $5cbf08b8a0823fbb$export$113005d17f05d2e1);

var $t6UBb = parcelRequire("t6UBb");

var $XGPnQ = parcelRequire("XGPnQ");

var $2Vsz9 = parcelRequire("2Vsz9");

var $cc5IR = parcelRequire("cc5IR");
const $5cbf08b8a0823fbb$export$a3dcdeebcccb44cd = ({ label: label, priorityId: priorityId, iconUrl: iconUrl })=>({
        name: label,
        id: priorityId,
        iconUrl: iconUrl
    });
const $5cbf08b8a0823fbb$export$8efeac1ccffb6a1d = (0, $t6UBb.default);
const $5cbf08b8a0823fbb$export$c6ef424ead917b72 = async (inputValue, _lookupValues, { tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext })=>{
    if (!inputValue) return null;
    const optionAri = (0, $XGPnQ.JiraPriorityAri).create({
        priorityId: inputValue,
        siteId: tenantContext.cloudId,
        activationId: tenantContext.activationId
    }).toString();
    const response = await (0, $cc5IR.fetchFieldOptions)({
        tenantContext: tenantContext,
        viewContext: viewContext,
        environment: environment,
        fieldContext: fieldContext,
        optionARIs: [
            optionAri
        ],
        nodePropertyName: 'priorities',
        queryName: 'FETCH_PRIORITY',
        query: $5cbf08b8a0823fbb$export$8efeac1ccffb6a1d
    });
    const priority = response?.edges?.[0]?.node;
    if (priority?.value !== optionAri) throw new (0, $2Vsz9.FieldValueLookupError)(inputValue);
    return {
        value: priority.value,
        label: priority.label ?? '',
        iconUrl: priority.iconUrl ?? '',
        priorityId: priority.priorityId
    };
};
const $5cbf08b8a0823fbb$export$113005d17f05d2e1 = ({ isVisible: isVisible, options: options }, _lookupValues, { tenantContext: tenantContext })=>({
        operation: isVisible ? 'ALLOW' : 'EXCLUDE',
        optionIds: options.map((optionId)=>(0, $XGPnQ.JiraPriorityAri).create({
                priorityId: optionId,
                siteId: tenantContext.cloudId,
                activationId: tenantContext.activationId
            }).toString())
    });

});
parcelRegister("t6UBb", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a63da77ff1882a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<66436dd0ab537848d4cbb2a0bdbf6985>>
 * @relayHash f6a30ee6ee1e3e60e7ac3366d295bd46
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5da9c5aa8b3c6f6d93f01d05e399d0b1abce793bce7cc920b4ad912ceecc37af
const $96a63da77ff1882a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "ari"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "filterById",
            "variableName": "filterById"
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        }
    ], v4 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "priorityIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraPriorityConnection",
                                    "kind": "LinkedField",
                                    "name": "priorities",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPriorityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPriority",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraPriorityField"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "priorityIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraPriorityConnection",
                                    "kind": "LinkedField",
                                    "name": "priorities",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPriorityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPriority",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraPriorityField"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5da9c5aa8b3c6f6d93f01d05e399d0b1abce793bce7cc920b4ad912ceecc37af",
            "metadata": {},
            "name": "priorityIssueTransitionIssueAdjustmentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$96a63da77ff1882a$var$node.hash = "5e7c742934e2b174f578c445449fb8d9";
var $96a63da77ff1882a$export$2e2bcd8739ae039 = $96a63da77ff1882a$var$node;

});

parcelRegister("XGPnQ", function(module, exports) {

$parcel$export(module.exports, "JiraPriorityAri", () => $2eb998dfbb67cb97$export$5f41709ebd395cb1);

var $kVIiT = parcelRequire("kVIiT");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/priority/manifest.ts
var $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $kVIiT.JiraPriorityAriResourceOwner),
    resourceType: (0, $kVIiT.JiraPriorityAriResourceType),
    resourceIdSlug: "activation/{activationId}/{priorityId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        priorityId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/priority/index.ts
var $2eb998dfbb67cb97$export$5f41709ebd395cb1 = class _JiraPriorityAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._priorityId = opts.resourceIdSegmentValues.priorityId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get priorityId() {
        return this._priorityId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts.qualifier,
            platformQualifier: $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts.resourceOwner,
            resourceType: $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.priorityId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                priorityId: opts.priorityId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts);
        return new _JiraPriorityAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts);
        return new _JiraPriorityAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            priorityId: this.priorityId
        };
    }
};

});
parcelRegister("kVIiT", function(module, exports) {

$parcel$export(module.exports, "JiraPriorityAriResourceOwner", () => $87edd756771a8842$export$a154bdc743e3d7f4);
$parcel$export(module.exports, "JiraPriorityAriResourceType", () => $87edd756771a8842$export$f5f5f4d1fc71ee3e);
// src/jira/priority/types.ts
var $87edd756771a8842$export$a154bdc743e3d7f4 = "jira", $87edd756771a8842$export$f5f5f4d1fc71ee3e = "priority";

});



parcelRegister("ioiX9", function(module, exports) {

$parcel$export(module.exports, "radioButtonsSetValueTransformerOld", () => $0695ded3a78e2796$export$afac3b5895a63445);
$parcel$export(module.exports, "transformRadioButtonsSetValue", () => $0695ded3a78e2796$export$59a14d3ac9af6334);
$parcel$export(module.exports, "radioButtonsGetValueTransformerOld", () => $0695ded3a78e2796$export$f0b186fd5b1146a5);
$parcel$export(module.exports, "transformRadioButtonsGetValue", () => $0695ded3a78e2796$export$878c780f038a370d);
$parcel$export(module.exports, "transformRadioButtonsSetOptionsVisibility", () => $0695ded3a78e2796$export$825e2dc660c855a0);
$parcel$export(module.exports, "transformRadioButtonsSetOptionsVisibilityOld", () => $0695ded3a78e2796$export$130c22d60f3ea0b1);
$parcel$export(module.exports, "transformRadioButtonsGetOptionsVisibility", () => $0695ded3a78e2796$export$149e6a6e5e31219);

var $2rn3r = parcelRequire("2rn3r");

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $j55UJ = parcelRequire("j55UJ");

var $39bQi = parcelRequire("39bQi");

var $b50wi = parcelRequire("b50wi");

var $9DCyM = parcelRequire("9DCyM");
const $0695ded3a78e2796$export$afac3b5895a63445 = (value, allowedValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, allowedValues, 'id');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        value: foundValue.id,
        label: foundValue.value
    };
};
const $0695ded3a78e2796$export$59a14d3ac9af6334 = (value, allowedValues, context)=>{
    if (value === null) return null;
    const optionAri = (0, $2rn3r.JiraIssueFieldOptionAri).create({
        optionId: value,
        siteId: context.tenantContext.cloudId,
        activationId: context.tenantContext.activationId,
        fieldId: context.fieldContext.fieldId
    }).toString();
    const foundValue = (0, $9DCyM.singleValueLookup)(optionAri, allowedValues, 'value');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return foundValue;
};
const $0695ded3a78e2796$export$f0b186fd5b1146a5 = (value)=>{
    if (!value) return null;
    const { label: label, value: id } = value;
    return {
        id: id,
        value: label
    };
};
const $0695ded3a78e2796$export$878c780f038a370d = (internalValue)=>{
    if (!internalValue) return null;
    return {
        id: (0, $39bQi.getResourceIdfromAri)(internalValue.value),
        value: internalValue.label
    };
};
const $0695ded3a78e2796$export$825e2dc660c855a0 = ({ options: options, isVisible: isVisible }, lookupValues, context)=>{
    const aris = (0, $b50wi.transformOptionIdsToARI)(options, context);
    return (0, $240Nk.applyOptionsVisibilityRule)({
        options: aris,
        isVisible: isVisible
    }, lookupValues, 'value');
};
const $0695ded3a78e2796$export$130c22d60f3ea0b1 = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $0695ded3a78e2796$export$149e6a6e5e31219 = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');

});

parcelRegister("3nLyZ", function(module, exports) {

$parcel$export(module.exports, "validateReleaseVersionValue", () => $e751e6e20c22efe4$export$31de952981b2edff);
$parcel$export(module.exports, "transformReleaseVersionsSetValue", () => $e751e6e20c22efe4$export$203f864eb08f43ec);
$parcel$export(module.exports, "transformReleaseVersionsGetValue", () => $e751e6e20c22efe4$export$8a2e9c6f89b699e4);
$parcel$export(module.exports, "transformReleaseVersionsSetOptionsVisibility", () => $e751e6e20c22efe4$export$390339514db83786);
$parcel$export(module.exports, "releaseVersionsRequiredScopes", () => $e751e6e20c22efe4$export$25e903bcd4f7a783);

var $hDPRM = parcelRequire("hDPRM");

var $glDap = parcelRequire("glDap");


var $2Vsz9 = parcelRequire("2Vsz9");

var $1NIGg = parcelRequire("1NIGg");

var $cc5IR = parcelRequire("cc5IR");

var $39bQi = parcelRequire("39bQi");

var $jgrDo = parcelRequire("jgrDo");

var $8xPow = parcelRequire("8xPow");
const $e751e6e20c22efe4$export$31de952981b2edff = (value)=>Array.isArray(value) && value.every((0, $8xPow.isNotEmptyString)) && value.length <= (0, $6b8c146c2dd688bb$export$106087dcfd4fb129);
const $e751e6e20c22efe4$export$1b26e14167ad7414 = (0, $hDPRM.default);
const $e751e6e20c22efe4$export$203f864eb08f43ec = async (inputValues, _lookupValues, { tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext })=>{
    if (!inputValues.length) return [];
    const optionARIs = inputValues.map((optionId)=>(0, $glDap.JiraVersionAri).create({
            siteId: tenantContext.cloudId,
            activationId: tenantContext.activationId,
            versionId: optionId
        }).toString());
    const response = await (0, $cc5IR.fetchFieldOptions)({
        tenantContext: tenantContext,
        viewContext: viewContext,
        environment: environment,
        fieldContext: fieldContext,
        optionARIs: optionARIs,
        nodePropertyName: 'selectableValueOptions',
        queryName: 'FETCH_RELEASE_VERSIONS',
        query: $e751e6e20c22efe4$export$1b26e14167ad7414
    });
    const fieldOptions = response?.edges?.map((edge)=>edge?.node).filter(Boolean).filter(({ id: id })=>optionARIs.includes(id)).map(({ selectableLabel: selectableLabel, id: id, selectableGroupKey: selectableGroupKey, selectableIconUrl: selectableIconUrl })=>({
            id: id,
            selectableLabel: selectableLabel ?? '',
            selectableGroupKey: selectableGroupKey ?? null,
            selectableIconUrl: selectableIconUrl ?? null
        })) ?? [];
    if (fieldOptions.length !== inputValues.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(optionARIs, fieldOptions, 'id');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.map((value)=>(0, $39bQi.getResourceIdfromAri)(value)).join());
    }
    return fieldOptions;
};
const $e751e6e20c22efe4$export$8a2e9c6f89b699e4 = (internalValues)=>{
    if (!internalValues) return [];
    return internalValues.map((value)=>({
            id: (0, $39bQi.getResourceIdfromAri)(value.id),
            name: value.selectableLabel
        }));
};
const $e751e6e20c22efe4$export$390339514db83786 = (optionsVisibility, _lookupValues, { tenantContext: tenantContext })=>({
        optionIds: optionsVisibility.options.map((optionId)=>(0, $glDap.JiraVersionAri).create({
                siteId: tenantContext.cloudId,
                activationId: tenantContext.activationId,
                versionId: optionId
            }).toString()),
        operation: optionsVisibility.isVisible ? 'ALLOW' : 'EXCLUDE'
    });
const $e751e6e20c22efe4$export$25e903bcd4f7a783 = {
    ...(0, $1NIGg.versionsRequiredScopes),
    granular: [
        ...(0, $1NIGg.versionsRequiredScopes).granular,
        'write:field.default-value:jira'
    ]
};

});
parcelRegister("hDPRM", function(module, exports) {

$parcel$export(module.exports, "default", () => $deaccdd0bc70a249$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3f670764c69c84a0d91e4768de892708>>
 * @relayHash ee1bd6cb49e1854165e09b99130a59b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 377af4db65b49ba114cb6c2e54913086afe4021507f42ca6cc6702fc2b30f465
const $deaccdd0bc70a249$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "ari"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "filterById",
            "variableName": "filterById"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "selectableLabel"
    }, v5 = {
        "kind": "ScalarField",
        "name": "selectableGroupKey"
    }, v6 = {
        "kind": "ScalarField",
        "name": "selectableIconUrl"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "releaseVersionsIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraSelectableValueConnection",
                                    "kind": "LinkedField",
                                    "name": "selectableValueOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSelectableValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraMultipleVersionPickerField"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "releaseVersionsIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraSelectableValueConnection",
                                    "kind": "LinkedField",
                                    "name": "selectableValueOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSelectableValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraMultipleVersionPickerField"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "377af4db65b49ba114cb6c2e54913086afe4021507f42ca6cc6702fc2b30f465",
            "metadata": {},
            "name": "releaseVersionsIssueTransitionIssueAdjustmentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$deaccdd0bc70a249$var$node.hash = "4f26dbdc495633bc3ca79baddd923221";
var $deaccdd0bc70a249$export$2e2bcd8739ae039 = $deaccdd0bc70a249$var$node;

});

parcelRegister("glDap", function(module, exports) {

$parcel$export(module.exports, "JiraVersionAri", () => $45797df1d60c11a2$export$eff0d18d9de27263);

var $lbxdl = parcelRequire("lbxdl");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/version/manifest.ts
var $45797df1d60c11a2$var$jiraVersionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $lbxdl.JiraVersionAriResourceOwner),
    resourceType: (0, $lbxdl.JiraVersionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{versionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        versionId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/version/index.ts
var $45797df1d60c11a2$export$eff0d18d9de27263 = class _JiraVersionAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._versionId = opts.resourceIdSegmentValues.versionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get versionId() {
        return this._versionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $45797df1d60c11a2$var$jiraVersionAriStaticOpts.qualifier,
            platformQualifier: $45797df1d60c11a2$var$jiraVersionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $45797df1d60c11a2$var$jiraVersionAriStaticOpts.resourceOwner,
            resourceType: $45797df1d60c11a2$var$jiraVersionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.versionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                versionId: opts.versionId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $45797df1d60c11a2$var$jiraVersionAriStaticOpts);
        return new _JiraVersionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $45797df1d60c11a2$var$jiraVersionAriStaticOpts);
        return new _JiraVersionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            versionId: this.versionId
        };
    }
};

});
parcelRegister("lbxdl", function(module, exports) {

$parcel$export(module.exports, "JiraVersionAriResourceOwner", () => $b2b1f653fdb26674$export$1b35360c29caced0);
$parcel$export(module.exports, "JiraVersionAriResourceType", () => $b2b1f653fdb26674$export$680940c40f68f72d);
// src/jira/version/types.ts
var $b2b1f653fdb26674$export$1b35360c29caced0 = "jira", $b2b1f653fdb26674$export$680940c40f68f72d = "version";

});



parcelRegister("js9Si", function(module, exports) {

$parcel$export(module.exports, "resolutionSetValueValidator", () => $a3f5461c0ceecf14$export$f8430b44b42c3ba0);
$parcel$export(module.exports, "resolutionGetValueTransformer", () => $a3f5461c0ceecf14$export$5bc2a5ee6e251e7b);
$parcel$export(module.exports, "resolutionSetValueTransformer", () => $a3f5461c0ceecf14$export$297cfd5e8642246b);

var $8UC0T = parcelRequire("8UC0T");

var $huI7r = parcelRequire("huI7r");

var $2Vsz9 = parcelRequire("2Vsz9");

var $cc5IR = parcelRequire("cc5IR");

var $39bQi = parcelRequire("39bQi");

var $8xPow = parcelRequire("8xPow");
const $a3f5461c0ceecf14$export$f8430b44b42c3ba0 = (value)=>value === null || (0, $8xPow.isNotEmptyString)(value);
const $a3f5461c0ceecf14$export$5bc2a5ee6e251e7b = (internalValue)=>{
    if (!internalValue) return null;
    const { label: label, value: value } = internalValue;
    return {
        id: (0, $39bQi.getResourceIdfromAri)(value),
        value: label
    };
};
const $a3f5461c0ceecf14$export$99a1b7b417122c1 = (0, $8UC0T.default);
const $a3f5461c0ceecf14$export$297cfd5e8642246b = async (inputValue, _lookupValues, { tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext })=>{
    if (!inputValue) return null;
    const resolutionARI = (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: tenantContext.cloudId,
        resourceType: 'resolution',
        activationId: tenantContext.activationId,
        resourceId: inputValue
    });
    const response = await (0, $cc5IR.fetchFieldOptions)({
        tenantContext: tenantContext,
        viewContext: viewContext,
        environment: environment,
        fieldContext: fieldContext,
        optionARIs: [
            resolutionARI
        ],
        nodePropertyName: 'resolutions',
        queryName: 'FETCH_RESOLUTION',
        query: $a3f5461c0ceecf14$export$99a1b7b417122c1
    });
    const resolution = response?.edges?.[0]?.node;
    if (resolution?.value !== resolutionARI) throw new (0, $2Vsz9.FieldValueLookupError)(inputValue);
    return {
        value: resolution.value,
        label: resolution.label ?? ''
    };
};

});
parcelRegister("8UC0T", function(module, exports) {

$parcel$export(module.exports, "default", () => $243f6f27bfc1ccbc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b8756058071c6e2aa033e004385b8fe9>>
 * @relayHash 587c7ad278e718587d1eac4df14771a6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 65386b5cc439dde8aa9d8aad5346237b5ab00088b7ae11ef655f90fe865a542a
const $243f6f27bfc1ccbc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "ari"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "filterById",
            "variableName": "filterById"
        }
    ], v3 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "resolutionQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraResolutionConnection",
                                    "kind": "LinkedField",
                                    "name": "resolutions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraResolutionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraResolution",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraResolutionField"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "resolutionQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraResolutionConnection",
                                    "kind": "LinkedField",
                                    "name": "resolutions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraResolutionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraResolution",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraResolutionField"
                        },
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "65386b5cc439dde8aa9d8aad5346237b5ab00088b7ae11ef655f90fe865a542a",
            "metadata": {},
            "name": "resolutionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$243f6f27bfc1ccbc$var$node.hash = "e47e170049dc135e17b0bba21ecce5ac";
var $243f6f27bfc1ccbc$export$2e2bcd8739ae039 = $243f6f27bfc1ccbc$var$node;

});


parcelRegister("ivCUc", function(module, exports) {

$parcel$export(module.exports, "transformSelectSetOptionsVisibility", () => $025f732ecd584dd6$export$81990085f8ab114b);
$parcel$export(module.exports, "transformSelectGetOptionsVisibility", () => $025f732ecd584dd6$export$7c7ca81813eb0f65);
$parcel$export(module.exports, "selectSetValueValidator", () => $025f732ecd584dd6$export$c02b1c2a574ca4c7);
$parcel$export(module.exports, "selectSetValueTransformerOld", () => $025f732ecd584dd6$export$27d13b94ef7f7717);
$parcel$export(module.exports, "selectSetValueTransformer", () => $025f732ecd584dd6$export$136c42b919fdec83);
$parcel$export(module.exports, "selectGetValueTransformerOld", () => $025f732ecd584dd6$export$f971e17a9dc0cf5a);
$parcel$export(module.exports, "selectGetValueTransformer", () => $025f732ecd584dd6$export$fd4db924c90bd0e2);

var $30vmZ = parcelRequire("30vmZ");

var $2rn3r = parcelRequire("2rn3r");

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $cc5IR = parcelRequire("cc5IR");

var $j55UJ = parcelRequire("j55UJ");

var $39bQi = parcelRequire("39bQi");

var $8xPow = parcelRequire("8xPow");

var $9DCyM = parcelRequire("9DCyM");
const $025f732ecd584dd6$export$81990085f8ab114b = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');
const $025f732ecd584dd6$export$7c7ca81813eb0f65 = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');
const $025f732ecd584dd6$export$c02b1c2a574ca4c7 = (value)=>value === null || (0, $8xPow.isNotEmptyString)(value);
const $025f732ecd584dd6$export$27d13b94ef7f7717 = (value, allowedValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, allowedValues, 'value');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        value: foundValue.value,
        label: foundValue.label
    };
};
const $025f732ecd584dd6$export$8a2c723186a4de94 = (0, $30vmZ.default);
const $025f732ecd584dd6$export$136c42b919fdec83 = async (inputValue, _lookupValues, { tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext })=>{
    if (inputValue === null) return null;
    const optionAri = (0, $2rn3r.JiraIssueFieldOptionAri).create({
        siteId: tenantContext.cloudId,
        activationId: tenantContext.activationId,
        fieldId: fieldContext.fieldId,
        optionId: inputValue
    }).toString();
    const response = await (0, $cc5IR.fetchFieldOptions)({
        tenantContext: tenantContext,
        viewContext: viewContext,
        environment: environment,
        fieldContext: fieldContext,
        optionARIs: [
            optionAri
        ],
        nodePropertyName: 'fieldOptions',
        queryName: 'FETCH_SELECT',
        query: $025f732ecd584dd6$export$8a2c723186a4de94
    });
    const option = response?.edges?.[0]?.node;
    if (option?.value !== optionAri) throw new (0, $2Vsz9.FieldValueLookupError)(inputValue);
    return {
        value: option.value,
        label: option.label ?? ''
    };
};
const $025f732ecd584dd6$export$f971e17a9dc0cf5a = (value)=>{
    if (!value || value.value === undefined) return null;
    const { label: label, value: id } = value;
    return {
        id: id,
        value: label
    };
};
const $025f732ecd584dd6$export$fd4db924c90bd0e2 = (internalValue)=>{
    if (!internalValue || internalValue.value === undefined) return null;
    return {
        id: (0, $39bQi.getResourceIdfromAri)(internalValue.value),
        value: internalValue.label
    };
};

});
parcelRegister("30vmZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $97d9b830c9f010ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<61ed5af44d6ff650f3ceb55ec9530e67>>
 * @relayHash dc0ee3a00570c8a4476b76e947391702
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e1d1eb200ab0fee3f493fb7fc558a2c0a806551d56073089018f3e539686bf5e
const $97d9b830c9f010ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "ari"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "filterById",
            "variableName": "filterById"
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        }
    ], v4 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "value"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "selectIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraSingleSelectField"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "selectIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraSingleSelectField"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e1d1eb200ab0fee3f493fb7fc558a2c0a806551d56073089018f3e539686bf5e",
            "metadata": {},
            "name": "selectIssueTransitionIssueAdjustmentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$97d9b830c9f010ea$var$node.hash = "d491ce6e025f96ae1790f91d97c73cf5";
var $97d9b830c9f010ea$export$2e2bcd8739ae039 = $97d9b830c9f010ea$var$node;

});


parcelRegister("6Hfnl", function(module, exports) {

$parcel$export(module.exports, "transformUserPickerSetValue", () => $09a8997d337a729d$export$ea418154f9f68685);
$parcel$export(module.exports, "transformUserPickerGetValue", () => $09a8997d337a729d$export$79b25b13f5798aa6);

var $2Vsz9 = parcelRequire("2Vsz9");

var $9DCyM = parcelRequire("9DCyM");
const $09a8997d337a729d$export$ea418154f9f68685 = (value, lookupValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, lookupValues, 'accountId');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return foundValue;
};
const $09a8997d337a729d$export$79b25b13f5798aa6 = (value)=>value ? {
        accountId: value.accountId
    } : null;

});

parcelRegister("fD0E1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c71a4af93ef685ad$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c71a4af93ef685ad$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    uimTransitionViewConsentMessage: {
        "id": "ui-modifications-fields-configuration.common.utils.views.issue-transition.uim-transition-view-consent-message",
        "defaultMessage": "Allow \u201C{appTitle}\u201D to access your Atlassian products to get the full issue experience."
    }
});

});


parcelRegister("5ZW9L", function(module, exports) {

$parcel$export(module.exports, "IssueViewViewConfiguration", () => $9954d8ff285c460a$export$c80c11394a2e44ab);

var $7ZZxN = parcelRequire("7ZZxN");


var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $iTvzN = parcelRequire("iTvzN");


var $8QLPP = parcelRequire("8QLPP");

var $axvW5 = parcelRequire("axvW5");

var $hBOxC = parcelRequire("hBOxC");

var $9aEJT = parcelRequire("9aEJT");

var $e8h5r = parcelRequire("e8h5r");

var $eMv4r = parcelRequire("eMv4r");

var $ifv0j = parcelRequire("ifv0j");

var $1zzzr = parcelRequire("1zzzr");

var $htzHC = parcelRequire("htzHC");

var $7AbVk = parcelRequire("7AbVk");

var $gLagZ = parcelRequire("gLagZ");

var $hFkmH = parcelRequire("hFkmH");

var $feRPz = parcelRequire("feRPz");

var $9Ek5r = parcelRequire("9Ek5r");

var $9Zo5b = parcelRequire("9Zo5b");

var $1h6vN = parcelRequire("1h6vN");

var $1NIGg = parcelRequire("1NIGg");

var $2xymT = parcelRequire("2xymT");

var $b50wi = parcelRequire("b50wi");

var $elWuT = parcelRequire("elWuT");

var $bvi64 = parcelRequire("bvi64");

var $3qPEc = parcelRequire("3qPEc");

var $aCDyF = parcelRequire("aCDyF");

var $fguRM = parcelRequire("fguRM");

var $8lh20 = parcelRequire("8lh20");

var $2hY4o = parcelRequire("2hY4o");

var $1mUM4 = parcelRequire("1mUM4");

var $aXs6e = parcelRequire("aXs6e");

var $90qH7 = parcelRequire("90qH7");

var $7Vf73 = parcelRequire("7Vf73");

var $44460 = parcelRequire("44460");

var $4yViI = parcelRequire("4yViI");

var $1f831 = parcelRequire("1f831");

var $4tIE7 = parcelRequire("4tIE7");

var $c6jWy = parcelRequire("c6jWy");

var $aXpSX = parcelRequire("aXpSX");

var $hF72b = parcelRequire("hF72b");

var $hBvZU = parcelRequire("hBvZU");

var $dHKLL = parcelRequire("dHKLL");

var $hMqzl = parcelRequire("hMqzl");
class $9954d8ff285c460a$export$c80c11394a2e44ab {
    getSupportedFieldsConfiguration() {
        const commonFieldValidators = (0, $2xymT.getCommonFieldValidators)();
        return {
            [(0, $lO4Or.SUMMARY_TYPE)]: {
                publicShapeValidators: {
                    isReadOnly: commonFieldValidators.isReadOnly,
                    value: (0, $9Zo5b.validateSingleLineTextValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $9Zo5b.transformSingleLineTextToPublicValue)
                },
                /**
				 * On the Issue View cannot differentiate between change and blur since only change is being observed.
				 * 'change' on the Issue View means e.g. that user "blurs" from a text field or change the selection in a select field.
				 */ emitChangeOn: 'change',
                requiredScopes: (0, $hF72b.summaryIssueViewScopes)
            },
            [(0, $lO4Or.DESCRIPTION_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $8lh20.validateRichText)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $8lh20.transformRichTextToPublicValue)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $8lh20.descriptionIssueViewScopes)
            },
            [(0, $lO4Or.ASSIGNEE_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $8QLPP.assigneeSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $8QLPP.assigneeSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $8QLPP.assigneeGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2),
                requiredScopes: (0, $elWuT.assigneeIssueViewScopes)
            },
            [(0, $lO4Or.PRIORITY_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $gLagZ.validatePrioritySetValue),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $1f831.transformPrioritySetValue),
                    optionsVisibility: (0, $b50wi.transformSelectSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $1f831.transformPriorityGetValue),
                    optionsVisibility: (0, $b50wi.transformSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $1f831.priorityIssueViewScopes),
                propertyMapping: {
                    optionsVisibility: 'allowedValuesOverrides'
                }
            },
            [(0, $lO4Or.TEXT_CF_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $9Zo5b.validateSingleLineTextValue),
                    description: commonFieldValidators.description
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $9Zo5b.transformSingleLineTextToPublicValue)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $aXpSX.singleLineTextIssueViewScopes)
            },
            [(0, $lO4Or.URL_CF_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $9Zo5b.validateSingleLineTextValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $9Zo5b.transformSingleLineTextToPublicValue)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $hBvZU.urlIssueViewScopes)
            },
            [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $44460.validateParagraphSetValue),
                    description: commonFieldValidators.description
                },
                publicToInternalTransformers: {
                    value: (0, $44460.paragraphSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $44460.paragraphGetValueTransformer)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $8lh20.descriptionIssueViewScopes)
            },
            [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $ifv0j.validateMultiSelectSetValue),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $aXs6e.transformMultiSelectSetValue),
                    optionsVisibility: (0, $b50wi.transformSetOptionsVisibilityAri)
                },
                internalToPublicTransformers: {
                    value: (0, $aXs6e.transformMultiSelectGetValue),
                    optionsVisibility: (0, $b50wi.transformSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $aXs6e.multiSelectScopes),
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                }
            },
            [(0, $lO4Or.SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $1ybV0.ff)('forge-ui-modifications-issue-view-ari-validation_772h3') ? (0, $9Ek5r.selectWithAriSetValueValidator) : (0, $9Ek5r.selectSetValueValidator),
                    description: commonFieldValidators.description,
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $c6jWy.selectSetValueTransformer),
                    optionsVisibility: (0, $b50wi.transformSetOptionsVisibilityAri)
                },
                internalToPublicTransformers: {
                    value: (0, $c6jWy.selectGetValueTransformer),
                    optionsVisibility: (0, $b50wi.transformSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $c6jWy.selectIssueViewScopes),
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                }
            },
            [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $eMv4r.validateMultiCheckboxSetValue),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $1mUM4.multiCheckboxSetValueTransformer),
                    optionsVisibility: (0, $b50wi.transformSelectSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $1mUM4.multiCheckboxGetValueTransformer),
                    optionsVisibility: (0, $b50wi.transformSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $1mUM4.multiCheckboxScopes),
                propertyMapping: {
                    optionsVisibility: 'allowedValuesOverrides'
                }
            },
            [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    description: commonFieldValidators.description,
                    value: (0, $hFkmH.radioButtonsSetValueValidator),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $4tIE7.radioButtonsSetValueTransformer),
                    optionsVisibility: (0, $b50wi.transformSelectSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $4tIE7.radioButtonsGetValueTransformer),
                    optionsVisibility: (0, $b50wi.transformSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $4tIE7.radioButtonsIssueViewScopes),
                propertyMapping: {
                    optionsVisibility: 'allowedValuesOverrides'
                }
            },
            [(0, $lO4Or.FIX_VERSIONS_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    description: commonFieldValidators.description,
                    value: (0, $1NIGg.validateVersionValue)
                },
                publicToInternalTransformers: {
                    value: (0, $dHKLL.transformVersionToInternalValue)
                },
                internalToPublicTransformers: {
                    value: (0, $dHKLL.transformVersionToPublicValue)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $dHKLL.versionsRequiredScopes)
            },
            [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    description: commonFieldValidators.description,
                    value: (0, $1NIGg.validateVersionValue)
                },
                publicToInternalTransformers: {
                    value: (0, $dHKLL.transformVersionToInternalValue)
                },
                internalToPublicTransformers: {
                    value: (0, $dHKLL.transformVersionToPublicValue)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $dHKLL.versionsRequiredScopes)
            },
            [(0, $lO4Or.NUMBER_CF_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $htzHC.validateNumberValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {},
                emitChangeOn: 'change',
                requiredScopes: (0, $7Vf73.numberIssueViewScopes)
            },
            [(0, $lO4Or.LABELS_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $2hY4o.validateLabelsSetValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {},
                emitChangeOn: 'change',
                requiredScopes: (0, $2hY4o.labelsRequiredScopes)
            },
            [(0, $lO4Or.DATE_CF_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $9aEJT.datePickerSetValueValidator)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $9aEJT.datePickerGetValueTransformer)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $aCDyF.datePickerIssueViewScopes)
            },
            [(0, $lO4Or.DATETIME_CF_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $e8h5r.validateDateTimePickerSetValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $e8h5r.transformDateTimePickerGetValue)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $fguRM.dateTimePickerIssueViewScopes)
            },
            [(0, $lO4Or.USER_CF_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $1h6vN.userPickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $8QLPP.assigneeSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $8QLPP.assigneeGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2),
                requiredScopes: (0, $elWuT.assigneeIssueViewScopes)
            },
            [(0, $lO4Or.REPORTER_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $feRPz.reporterSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $8QLPP.assigneeSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $8QLPP.assigneeGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2),
                requiredScopes: (0, $elWuT.assigneeIssueViewScopes)
            },
            [(0, $lO4Or.MULTI_USER_CF_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $1zzzr.validateMultiUserPickerSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $90qH7.transformMultiUserPickerSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $90qH7.transformMultiUserPickerGetValue)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2),
                requiredScopes: (0, $elWuT.assigneeIssueViewScopes)
            },
            [(0, $lO4Or.COMPONENTS_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $hBOxC.validateComponentsSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $3qPEc.transformComponentsSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $3qPEc.transformComponentsGetValue)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $3qPEc.componentsIssueViewScopes)
            },
            [(0, $lO4Or.PARENT_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    description: commonFieldValidators.description,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $7AbVk.parentSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $4yViI.transformParentSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $4yViI.transformParentGetValue)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $4yViI.parentIssueViewScopes)
            },
            [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $axvW5.validateCascadingSelectSetValue),
                    description: commonFieldValidators.description
                },
                publicToInternalTransformers: {
                    value: (0, $bvi64.transformSetValueCascadingSelect)
                },
                internalToPublicTransformers: {
                    value: (0, $bvi64.transformGetValueCascadingSelect)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $bvi64.cascadingSelectIssueViewScopes)
            }
        };
    }
    getSupportedFieldTypes() {
        const supportedFieldTypes = [
            (0, $lO4Or.SUMMARY_TYPE),
            (0, $lO4Or.DESCRIPTION_TYPE),
            (0, $lO4Or.ASSIGNEE_TYPE),
            (0, $lO4Or.PRIORITY_TYPE),
            (0, $lO4Or.URL_CF_TYPE),
            (0, $lO4Or.TEXT_CF_TYPE),
            (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
            (0, $lO4Or.TEXT_AREA_CF_TYPE),
            (0, $lO4Or.SELECT_CF_TYPE),
            (0, $lO4Or.MULTI_SELECT_CF_TYPE),
            (0, $lO4Or.RADIO_BUTTONS_CF_TYPE),
            (0, $lO4Or.FIX_VERSIONS_TYPE),
            (0, $lO4Or.NUMBER_CF_TYPE),
            (0, $lO4Or.DATE_CF_TYPE),
            (0, $lO4Or.DATETIME_CF_TYPE),
            (0, $lO4Or.LABELS_TYPE),
            (0, $lO4Or.USER_CF_TYPE),
            (0, $lO4Or.REPORTER_TYPE),
            (0, $lO4Or.COMPONENTS_TYPE),
            (0, $lO4Or.MULTI_USER_CF_TYPE),
            (0, $lO4Or.PARENT_TYPE)
        ];
        if ((0, $1ybV0.ff)('ui-modifications-cascading-select-field-support-_bjjiv')) supportedFieldTypes.push((0, $lO4Or.CASCADING_SELECT_CF_TYPE));
        if ((0, $1ybV0.ff)('forge-ui-modifications-affects-versions-field-support-iv_ff6mj')) supportedFieldTypes.push((0, $lO4Or.AFFECTS_VERSIONS_TYPE));
        return supportedFieldTypes;
    }
    getSupportedProjectTypes() {
        return [
            (0, $7ZZxN.SOFTWARE_PROJECT)
        ];
    }
    getConsentMessage() {
        return (0, $hMqzl.default).uimIssueViewConsentMessage;
    }
    getAnalytics() {
        return this.analytics;
    }
    getSupportedTriggerPointsConfiguration() {
        return new Set([
            (0, $0100842672acae20$export$b19f949fb9713614),
            (0, $0100842672acae20$export$9c5d81b901471b27),
            (0, $0100842672acae20$export$f72626bf0d75dfad),
            (0, $0100842672acae20$export$cd16d39c55c569d0),
            (0, $0100842672acae20$export$53d41ff2666118e1),
            (0, $0100842672acae20$export$710114090a811b37),
            (0, $0100842672acae20$export$14a8072f422804fd),
            (0, $0100842672acae20$export$7ca28938a07e0c33)
        ]);
    }
    constructor(){
        this.analytics = {
            stopTTI: $iTvzN.stopTTI,
            cancelTTI: $iTvzN.cancelTTI,
            markIframeLoad: $iTvzN.markIframeLoad,
            markFieldsRegistered: $iTvzN.markFieldsRegistered,
            markOnInitResolved: $iTvzN.markOnInitResolved
        };
        this.isScreenTabsSupportEnabled = ()=>false;
    }
}

});
parcelRegister("elWuT", function(module, exports) {

$parcel$export(module.exports, "assigneeIssueViewScopes", () => $ed8290f82948f280$export$37dd073552da1a40);

var $8QLPP = parcelRequire("8QLPP");

var $2re4M = parcelRequire("2re4M");
const $ed8290f82948f280$export$37dd073552da1a40 = {
    ...(0, $8QLPP.assigneeScopes),
    granular: [
        ...(0, $8QLPP.assigneeScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});
parcelRegister("2re4M", function(module, exports) {

$parcel$export(module.exports, "commonIssueViewGranularScopes", () => $7aa07c0f3ab1502e$export$c6286247dcbeb3df);
const $7aa07c0f3ab1502e$export$c6286247dcbeb3df = [
    'write:issue:jira',
    'read:issue-field-values:jira'
];

});


parcelRegister("bvi64", function(module, exports) {

$parcel$export(module.exports, "transformSetValueCascadingSelect", () => $6fcfcb43819b052a$export$905a8d55c641a71e);
$parcel$export(module.exports, "transformGetValueCascadingSelect", () => $6fcfcb43819b052a$export$47e9770ed0d1c344);
$parcel$export(module.exports, "cascadingSelectIssueViewScopes", () => $6fcfcb43819b052a$export$a0edee15316177cb);

var $2rn3r = parcelRequire("2rn3r");

var $9Ek5r = parcelRequire("9Ek5r");

var $2re4M = parcelRequire("2re4M");
const $6fcfcb43819b052a$export$905a8d55c641a71e = (value, _lookupValues, { tenantContext: tenantContext, fieldContext: fieldContext })=>{
    if (value === null) return null;
    let childAri = null;
    const parentAri = (0, $2rn3r.JiraIssueFieldOptionAri).create({
        siteId: tenantContext.cloudId,
        activationId: tenantContext.activationId,
        fieldId: fieldContext.fieldId,
        optionId: value.parentId
    }).toString();
    if (value?.childId) childAri = (0, $2rn3r.JiraIssueFieldOptionAri).create({
        siteId: tenantContext.cloudId,
        activationId: tenantContext.activationId,
        fieldId: fieldContext.fieldId,
        optionId: value.childId
    }).toString();
    return {
        parentId: parentAri,
        childId: childAri
    };
};
const $6fcfcb43819b052a$export$47e9770ed0d1c344 = (value)=>{
    if (!value) return null;
    const parent = {
        id: value.id,
        value: value.value
    };
    const child = value.child ? {
        id: value.child.id,
        value: value.child.value
    } : null;
    return {
        parent: parent,
        child: child
    };
};
const $6fcfcb43819b052a$export$a0edee15316177cb = {
    ...(0, $9Ek5r.selectScopes),
    granular: [
        ...(0, $9Ek5r.selectScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("3qPEc", function(module, exports) {

$parcel$export(module.exports, "componentsIssueViewScopes", () => $84a07567d70530ac$export$2d77b34c4c3f5fd0);
$parcel$export(module.exports, "transformComponentsGetValue", () => $84a07567d70530ac$export$5bb582851410c3c3);
$parcel$export(module.exports, "transformComponentsSetValue", () => $84a07567d70530ac$export$11da965a72270337);

var $hBOxC = parcelRequire("hBOxC");

var $2re4M = parcelRequire("2re4M");
const $84a07567d70530ac$export$2d77b34c4c3f5fd0 = {
    ...(0, $hBOxC.componentsRequiredScopes),
    granular: [
        ...(0, $hBOxC.componentsRequiredScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};
const $84a07567d70530ac$export$5bb582851410c3c3 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ id: id, name: name })=>({
            id: id,
            name: name
        }));
};
const $84a07567d70530ac$export$11da965a72270337 = (publicValues)=>{
    if (!publicValues) return [];
    return publicValues.map((id)=>({
            id: id
        }));
};

});

parcelRegister("aCDyF", function(module, exports) {

$parcel$export(module.exports, "datePickerIssueViewScopes", () => $ab81124e008d3519$export$7936cbcb39b1d176);

var $4XB9o = parcelRequire("4XB9o");

var $2re4M = parcelRequire("2re4M");
const $ab81124e008d3519$export$7936cbcb39b1d176 = {
    ...(0, $4XB9o.baseScopesRequiredPerField),
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("fguRM", function(module, exports) {

$parcel$export(module.exports, "dateTimePickerIssueViewScopes", () => $e48d6f07d007070c$export$a7d3367976f70795);

var $4XB9o = parcelRequire("4XB9o");

var $2re4M = parcelRequire("2re4M");
const $e48d6f07d007070c$export$a7d3367976f70795 = {
    ...(0, $4XB9o.baseScopesRequiredPerField),
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("8lh20", function(module, exports) {

$parcel$export(module.exports, "validateRichText", () => $ed8b97216cbe9959$export$98157eaee5d4eeca);
$parcel$export(module.exports, "transformRichTextToPublicValue", () => $ed8b97216cbe9959$export$41b11897967c0fca);
$parcel$export(module.exports, "descriptionIssueViewScopes", () => $ed8b97216cbe9959$export$9f764201bd3a6b52);

var $9tBd5 = parcelRequire("9tBd5");

var $4XB9o = parcelRequire("4XB9o");

var $cw2gk = parcelRequire("cw2gk");

var $2re4M = parcelRequire("2re4M");
const $ed8b97216cbe9959$export$98157eaee5d4eeca = (value, _metadata, _createAnalyticsEvent, extra)=>(0, $cw2gk.isValidADF)({
        newValue: value,
        currentValue: extra.currentField?.value,
        viewType: extra.viewType
    });
const $ed8b97216cbe9959$export$41b11897967c0fca = (value)=>{
    if (value === undefined) // The `convertTextToAdf` call will give us an "empty ADF object":
    // {
    //   "type": "doc",
    //   "version": 1,
    //   "content": [
    //     {
    //       "type": "paragraph",
    //       "content": []
    //     }
    //   ]
    // }
    return (0, $9tBd5.convertTextToAdf)('');
    return value;
};
const $ed8b97216cbe9959$export$9f764201bd3a6b52 = {
    ...(0, $4XB9o.baseScopesRequiredPerField),
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("2hY4o", function(module, exports) {

$parcel$export(module.exports, "validateLabelsSetValue", () => $b0ed2f79ced2bbe2$export$6130bc1755ce872a);
$parcel$export(module.exports, "labelsRequiredScopes", () => $b0ed2f79ced2bbe2$export$5397fc4189b6d690);


var $incV3 = parcelRequire("incV3");

var $8xPow = parcelRequire("8xPow");

var $2re4M = parcelRequire("2re4M");
const $b0ed2f79ced2bbe2$export$6130bc1755ce872a = (value)=>Array.isArray(value) && value.length <= (0, $6b8c146c2dd688bb$export$106087dcfd4fb129) && value.every((0, $8xPow.isNotEmptyString));
const $b0ed2f79ced2bbe2$export$5397fc4189b6d690 = {
    ...(0, $incV3.labelsRequiredScopes),
    granular: [
        ...(0, $incV3.labelsRequiredScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("1mUM4", function(module, exports) {

$parcel$export(module.exports, "multiCheckboxSetValueTransformer", () => $5dec8e4211293f94$export$9ba1ee83cc9456ba);
$parcel$export(module.exports, "multiCheckboxGetValueTransformer", () => $5dec8e4211293f94$export$6d15ce1cc0bdffe7);
$parcel$export(module.exports, "multiCheckboxScopes", () => $5dec8e4211293f94$export$488c2db81cb83823);

var $4XB9o = parcelRequire("4XB9o");

var $2re4M = parcelRequire("2re4M");
const $5dec8e4211293f94$export$9ba1ee83cc9456ba = (values)=>values.map((id)=>({
            id: id
        }));
const $5dec8e4211293f94$export$6d15ce1cc0bdffe7 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ id: id, value: value })=>({
            id: id,
            value: value
        }));
};
const $5dec8e4211293f94$export$488c2db81cb83823 = {
    ...(0, $4XB9o.baseScopesRequiredPerField),
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("aXs6e", function(module, exports) {

$parcel$export(module.exports, "transformMultiSelectSetValue", () => $98e2ed2a05bc16c5$export$efdfe34b5fc174ce);
$parcel$export(module.exports, "transformMultiSelectGetValue", () => $98e2ed2a05bc16c5$export$7ad37bc37002060f);
$parcel$export(module.exports, "multiSelectScopes", () => $98e2ed2a05bc16c5$export$314882a3f1f403d6);

var $ifv0j = parcelRequire("ifv0j");

var $2re4M = parcelRequire("2re4M");
const $98e2ed2a05bc16c5$export$efdfe34b5fc174ce = (values)=>values.map((id)=>({
            id: id
        }));
const $98e2ed2a05bc16c5$export$7ad37bc37002060f = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ id: id, value: value })=>({
            id: id,
            value: value
        }));
};
const $98e2ed2a05bc16c5$export$314882a3f1f403d6 = {
    ...(0, $ifv0j.multiSelectScopes),
    granular: [
        ...(0, $ifv0j.multiSelectScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("90qH7", function(module, exports) {

$parcel$export(module.exports, "transformMultiUserPickerSetValue", () => $42c048be67171248$export$5b3066e9c91b4b70);
$parcel$export(module.exports, "transformMultiUserPickerGetValue", () => $42c048be67171248$export$14f50c5c8c51bfdc);

var $2Vsz9 = parcelRequire("2Vsz9");

var $jgrDo = parcelRequire("jgrDo");

var $eF9ai = parcelRequire("eF9ai");
const $42c048be67171248$export$5b3066e9c91b4b70 = (values, lookupValues)=>{
    if (!values.length) return [];
    const filteredLookupValues = (0, $eF9ai.multiValueLookup)(values, lookupValues, 'accountId');
    if (values.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(values, filteredLookupValues, 'accountId');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ accountId: accountId, name: name, picture: picture })=>({
            accountId: accountId,
            displayName: name,
            avatarUrls: {
                '24x24': picture
            }
        }));
};
const $42c048be67171248$export$14f50c5c8c51bfdc = (value)=>{
    if (!value) return [];
    return value.map(({ accountId: accountId })=>({
            accountId: accountId
        }));
};

});

parcelRegister("7Vf73", function(module, exports) {

$parcel$export(module.exports, "numberIssueViewScopes", () => $8f6be24ae7bd02a4$export$d0704215d52fd2fd);

var $htzHC = parcelRequire("htzHC");

var $2re4M = parcelRequire("2re4M");
const $8f6be24ae7bd02a4$export$d0704215d52fd2fd = {
    ...(0, $htzHC.numberScopes),
    granular: [
        ...(0, $htzHC.numberScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("44460", function(module, exports) {

$parcel$export(module.exports, "validateParagraphSetValue", () => $fadba7e7b05c2d33$export$7efb2358ba381826);
$parcel$export(module.exports, "paragraphSetValueTransformer", () => $fadba7e7b05c2d33$export$4f3e7aa88a08b7db);
$parcel$export(module.exports, "paragraphGetValueTransformer", () => $fadba7e7b05c2d33$export$88b493c87579f4ea);

var $9tBd5 = parcelRequire("9tBd5");


var $cw2gk = parcelRequire("cw2gk");
const $fadba7e7b05c2d33$export$7efb2358ba381826 = (value, { fieldRenderer: fieldRenderer }, _createAnalyticsEvent, extra)=>{
    switch(fieldRenderer){
        case 0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c:
            return (0, $cw2gk.isValidADF)({
                newValue: value,
                currentValue: extra.currentField?.value,
                viewType: extra.viewType
            });
        case 0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f:
            return Promise.resolve(typeof value === 'string');
        default:
            return Promise.resolve(false);
    }
};
const $fadba7e7b05c2d33$export$4f3e7aa88a08b7db = (value)=>{
    if (typeof value === 'string') return value;
    return {
        ...value
    };
};
const $fadba7e7b05c2d33$export$88b493c87579f4ea = (value, fieldRenderer)=>{
    if (value === undefined || value === null) // The `convertTextToAdf` call will give us an "empty ADF object":
    // {
    //   "type": "doc",
    //   "version": 1,
    //   "content": [
    //     {
    //       "type": "paragraph",
    //       "content": []
    //     }
    //   ]
    // }
    return fieldRenderer === (0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c) ? (0, $9tBd5.convertTextToAdf)('') : '';
    if (typeof value === 'string') return value;
    return value;
};

});

parcelRegister("4yViI", function(module, exports) {

$parcel$export(module.exports, "transformParentSetValue", () => $748ec28ce44dd6e2$export$2c2fa789efcce745);
$parcel$export(module.exports, "transformParentGetValue", () => $748ec28ce44dd6e2$export$98caacb992dbef18);
$parcel$export(module.exports, "parentIssueViewScopes", () => $748ec28ce44dd6e2$export$4512997696e69403);

var $7AbVk = parcelRequire("7AbVk");

var $2re4M = parcelRequire("2re4M");
function $748ec28ce44dd6e2$export$2c2fa789efcce745(value) {
    if (value === null) return null;
    return {
        id: value
    };
}
function $748ec28ce44dd6e2$export$98caacb992dbef18(internalValue) {
    if (!internalValue) return null;
    return {
        id: internalValue.id,
        key: internalValue.key
    };
}
const $748ec28ce44dd6e2$export$4512997696e69403 = {
    ...(0, $7AbVk.parentScopes),
    granular: [
        ...(0, $7AbVk.parentScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("1f831", function(module, exports) {

$parcel$export(module.exports, "transformPrioritySetValue", () => $31d58dbbdb2d0809$export$fc571ad244cfa429);
$parcel$export(module.exports, "transformPriorityGetValue", () => $31d58dbbdb2d0809$export$95a791a89befdf91);
$parcel$export(module.exports, "priorityIssueViewScopes", () => $31d58dbbdb2d0809$export$73887a9e9ca89122);

var $gLagZ = parcelRequire("gLagZ");

var $2re4M = parcelRequire("2re4M");
const $31d58dbbdb2d0809$export$fc571ad244cfa429 = (value)=>({
        id: value
    });
const $31d58dbbdb2d0809$export$95a791a89befdf91 = (priority)=>{
    if (!priority) return null;
    const { id: id, name: name, iconUrl: iconUrl } = priority;
    return {
        id: id,
        name: name,
        iconUrl: iconUrl
    };
};
const $31d58dbbdb2d0809$export$73887a9e9ca89122 = {
    ...(0, $gLagZ.priorityScopes),
    granular: [
        ...(0, $gLagZ.priorityScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("4tIE7", function(module, exports) {

$parcel$export(module.exports, "radioButtonsSetValueTransformer", () => $2219b0493254e016$export$d23713245ea192a9);
$parcel$export(module.exports, "radioButtonsGetValueTransformer", () => $2219b0493254e016$export$624bfe758f4ad3c6);
$parcel$export(module.exports, "radioButtonsIssueViewScopes", () => $2219b0493254e016$export$44f58b3fbc54e404);

var $hFkmH = parcelRequire("hFkmH");

var $2re4M = parcelRequire("2re4M");
const $2219b0493254e016$export$d23713245ea192a9 = (value)=>{
    if (value === null) return null;
    return {
        id: value
    };
};
const $2219b0493254e016$export$624bfe758f4ad3c6 = (value)=>{
    if (!value) return null;
    return {
        id: value.id,
        value: value.value
    };
};
const $2219b0493254e016$export$44f58b3fbc54e404 = {
    ...(0, $hFkmH.radioButtonsScopes),
    granular: [
        ...(0, $hFkmH.radioButtonsScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("c6jWy", function(module, exports) {

$parcel$export(module.exports, "selectSetValueTransformer", () => $c937724d4654ecc5$export$136c42b919fdec83);
$parcel$export(module.exports, "selectGetValueTransformer", () => $c937724d4654ecc5$export$fd4db924c90bd0e2);
$parcel$export(module.exports, "selectIssueViewScopes", () => $c937724d4654ecc5$export$c606e83ffca8af68);

var $2rn3r = parcelRequire("2rn3r");

var $9Ek5r = parcelRequire("9Ek5r");

var $2re4M = parcelRequire("2re4M");
const $c937724d4654ecc5$export$136c42b919fdec83 = (value, _lookupValues, { tenantContext: tenantContext, fieldContext: fieldContext })=>{
    if (value === null) return null;
    const ari = (0, $2rn3r.JiraIssueFieldOptionAri).create({
        siteId: tenantContext.cloudId,
        activationId: tenantContext.activationId,
        fieldId: fieldContext.fieldId,
        optionId: value
    }).toString();
    return {
        ari: ari
    };
};
const $c937724d4654ecc5$export$fd4db924c90bd0e2 = (value)=>{
    if (!value) return null;
    return {
        id: value.id,
        value: value.value
    };
};
const $c937724d4654ecc5$export$c606e83ffca8af68 = {
    ...(0, $9Ek5r.selectScopes),
    granular: [
        ...(0, $9Ek5r.selectScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("aXpSX", function(module, exports) {

$parcel$export(module.exports, "singleLineTextIssueViewScopes", () => $3bb3814a07671186$export$6ece4ba5721790a0);

var $9Zo5b = parcelRequire("9Zo5b");

var $2re4M = parcelRequire("2re4M");
const $3bb3814a07671186$export$6ece4ba5721790a0 = {
    ...(0, $9Zo5b.singleLineTextScopes),
    granular: [
        ...(0, $9Zo5b.singleLineTextScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("hF72b", function(module, exports) {

$parcel$export(module.exports, "summaryIssueViewScopes", () => $f1d94cf8f7167e02$export$98513697beab9507);

var $9Zo5b = parcelRequire("9Zo5b");

var $2re4M = parcelRequire("2re4M");
const $f1d94cf8f7167e02$export$98513697beab9507 = {
    ...(0, $9Zo5b.singleLineTextScopes),
    granular: [
        ...(0, $9Zo5b.singleLineTextScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("hBvZU", function(module, exports) {

$parcel$export(module.exports, "urlIssueViewScopes", () => $a11136df0fd75d48$export$c6b3963a694ffc47);

var $4XB9o = parcelRequire("4XB9o");

var $2re4M = parcelRequire("2re4M");
const $a11136df0fd75d48$export$c6b3963a694ffc47 = {
    ...(0, $4XB9o.baseScopesRequiredPerField),
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("dHKLL", function(module, exports) {

$parcel$export(module.exports, "transformVersionToInternalValue", () => $b5f230f1f80751f7$export$1fb4429d51b6df1d);
$parcel$export(module.exports, "transformVersionToPublicValue", () => $b5f230f1f80751f7$export$e019532c54e8b675);
$parcel$export(module.exports, "versionsRequiredScopes", () => $b5f230f1f80751f7$export$60db61c485973ad9);

var $1NIGg = parcelRequire("1NIGg");

var $2re4M = parcelRequire("2re4M");
const $b5f230f1f80751f7$export$1fb4429d51b6df1d = (internalValue)=>{
    if (!internalValue.length) return [];
    return internalValue.map((id)=>({
            id: id
        }));
};
const $b5f230f1f80751f7$export$e019532c54e8b675 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ id: id, name: name })=>({
            id: id,
            name: name
        }));
};
const $b5f230f1f80751f7$export$60db61c485973ad9 = {
    ...(0, $1NIGg.versionsRequiredScopes),
    granular: [
        ...(0, $1NIGg.versionsRequiredScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("hMqzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f459b4ccd463f1f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1f459b4ccd463f1f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    uimIssueViewConsentMessage: {
        "id": "ui-modifications-fields-configuration.common.utils.views.issue-view.uim-issue-view-consent-message",
        "defaultMessage": "Allow \u201C{appTitle}\u201D to access your Atlassian products to get the full issue experience."
    }
});

});





parcelRegister("lB1pd", function(module, exports) {

$parcel$export(module.exports, "validateFieldFromIframe", () => $d133bdec274d1c3f$export$122cf3be62c22ae);
$parcel$export(module.exports, "transformFieldToIframe", () => $d133bdec274d1c3f$export$aa453854f74fab);
$parcel$export(module.exports, "transformFieldFromIframe", () => $d133bdec274d1c3f$export$81af8a29516da6ea);

var $h1jSL = parcelRequire("h1jSL");

var $2Vsz9 = parcelRequire("2Vsz9");
var $8ibkc = parcelRequire("8ibkc");

var $jLFd4 = parcelRequire("jLFd4");
const $d133bdec274d1c3f$export$122cf3be62c22ae = async ({ fieldType: fieldType, fieldId: fieldId, currentField: currentField, fieldFromIframe: fieldFromIframe, fieldMetadata: fieldMetadata, viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
    const fieldConfiguration = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldValidators) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.entries(fieldValidators);
    await Promise.all(validatorsArray.map(async ([propertyName, validate])=>{
        if (Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) {
            const propertyValue = fieldFromIframe[propertyName];
            if (await validate(propertyValue, fieldMetadata, createAnalyticsEvent, {
                currentField: currentField,
                viewType: viewType
            }) === false) throw new (0, $jLFd4.IssueAdjustmentFieldPropertyError)(`UIM tried to set an invalid value for "${propertyName}" property on a field (fieldId: "${fieldId}", fieldType: "${fieldType}")`, {
                fieldId: fieldId,
                fieldType: fieldType
            });
        }
    }));
};
const $d133bdec274d1c3f$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $h1jSL.fireIAErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $h1jSL.fireIAErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};
const $d133bdec274d1c3f$export$81af8a29516da6ea = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, viewContext: viewContext, environment: environment })=>{
    const fieldConfiguration = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    return validatorsArray.reduce(async (acc, propertyName)=>{
        if (Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) {
            const propertyValue = fieldFromIframe[propertyName];
            const transformer = fieldTransformers[propertyName];
            const fieldContext = {
                fieldId: fieldId
            };
            // We need to catch lookup values discrepancies and react accordingly
            // to how we react to validation errors - throw an error
            // if the set value wasn't found in the array of lookupValues
            try {
                (await acc)[propertyName] = transformer ? await transformer(propertyValue, lookupValues, {
                    tenantContext: tenantContext,
                    viewContext: viewContext,
                    environment: environment,
                    fieldContext: fieldContext
                }) : propertyValue;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                // FieldValueLookupError will be thrown from the transformer
                // when the lookup value wasn't found
                if (err instanceof (0, $2Vsz9.FieldValueLookupError)) {
                    // For single value fields its straightforward to just pass the faulty propertyValue
                    // into IssueAdjustmentFieldPropertyError error message
                    // but for multi value fields we should find out the faulty values from the array
                    // thats why we should propagate the faulty values as a comma separated string
                    // by using the error's message
                    const faultyValue = err.message || propertyValue;
                    throw new (0, $jLFd4.IssueAdjustmentFieldPropertyError)(`Field with ID "${fieldId}" has invalid values set in "${propertyName}": ${faultyValue}`, {
                        fieldId: fieldId,
                        fieldType: fieldType
                    });
                }
                throw err;
            }
        }
        return acc;
    }, Promise.resolve({}));
};

});
parcelRegister("jLFd4", function(module, exports) {

$parcel$export(module.exports, "IssueAdjustmentFieldPropertyError", () => $ef4492dc31349567$export$9fe1302e0f517f4d);
// To remove with `forge-ui-modifications-validation-errors-returned-to-app_hdzmw` FF clean up
class $ef4492dc31349567$export$9fe1302e0f517f4d extends Error {
    constructor(message, attributes, cause){
        super();
        this.message = message;
        this.attributes = attributes;
        this.cause = cause;
    }
}

});


parcelRegister("fUNS1", function(module, exports) {

$parcel$export(module.exports, "prepareErrorsArray", () => $ef7370b518a4155c$export$e1fce51bc5be90b7);
const $ef7370b518a4155c$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("7CbIv", function(module, exports) {

$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $0921c7ca821fb6e8$export$d14f85c01e334a1);

var $8blac = parcelRequire("8blac");

var $2Vsz9 = parcelRequire("2Vsz9");
var $8ibkc = parcelRequire("8ibkc");

var $fsCiP = parcelRequire("fsCiP");

var $WO73Y = parcelRequire("WO73Y");

var $KAPjp = parcelRequire("KAPjp");

var $fW80u = parcelRequire("fW80u");
const $0921c7ca821fb6e8$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, viewContext: viewContext, environment: environment })=>{
    const fieldConfiguration = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $KAPjp.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $KAPjp.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                viewContext: viewContext,
                environment: environment,
                fieldContext: fieldContext
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $2Vsz9.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass the faulty propertyValue
                // into IssueAdjustmentFieldPropertyError error message
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $fsCiP.FIELD_VALIDATION_ERROR),
                        method: (0, $WO73Y.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $fW80u.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $fW80u.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("WO73Y", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $f0920af4bdd7ca41$export$e1cc7da28a1c4bb7);
const $f0920af4bdd7ca41$var$SET_NAME_METHOD = 'setName';
const $f0920af4bdd7ca41$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $f0920af4bdd7ca41$var$SET_VISIBLE_METHOD = 'setVisible';
const $f0920af4bdd7ca41$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $f0920af4bdd7ca41$var$SET_VALUE_METHOD = 'setValue';
const $f0920af4bdd7ca41$var$SET_REQUIRED_METHOD = 'setRequired';
const $f0920af4bdd7ca41$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $f0920af4bdd7ca41$export$8325709d137b2606 = {
    fieldName: $f0920af4bdd7ca41$var$SET_NAME_METHOD,
    description: $f0920af4bdd7ca41$var$SET_DESCRIPTION_METHOD,
    isVisible: $f0920af4bdd7ca41$var$SET_VISIBLE_METHOD,
    isReadOnly: $f0920af4bdd7ca41$var$SET_READ_ONLY_METHOD,
    value: $f0920af4bdd7ca41$var$SET_VALUE_METHOD,
    isRequired: $f0920af4bdd7ca41$var$SET_REQUIRED_METHOD,
    optionsVisibility: $f0920af4bdd7ca41$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $f0920af4bdd7ca41$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $f0920af4bdd7ca41$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

parcelRegister("KAPjp", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $31d75f6b66e8195c$export$ee79e3ab53b8db79);
const $31d75f6b66e8195c$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("fW80u", function(module, exports) {

$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $130c7c4675a36fa8$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $130c7c4675a36fa8$export$ddd005554aecd409);
const $130c7c4675a36fa8$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $130c7c4675a36fa8$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("9V8vn", function(module, exports) {

$parcel$export(module.exports, "clearBufferForChangeId", () => $0a575b9006a54548$export$bb8a68817bbdbd56);
$parcel$export(module.exports, "clearAllBufferTimeouts", () => $0a575b9006a54548$export$35bf721435968774);

var $kFGm5 = parcelRequire("kFGm5");
const $0a575b9006a54548$export$bb8a68817bbdbd56 = ({ changeId: changeId })=>({ setState: setState, getState: getState })=>{
        const { buffer: buffer, bufferTimeouts: bufferTimeouts } = getState();
        setState({
            buffer: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(buffer, changeId),
            bufferTimeouts: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(bufferTimeouts, changeId)
        });
    };
const $0a575b9006a54548$export$35bf721435968774 = ()=>({ getState: getState })=>{
        const { bufferTimeouts: bufferTimeouts } = getState();
        Object.values(bufferTimeouts).forEach((timeoutId)=>{
            clearTimeout(timeoutId);
        });
    };

});

parcelRegister("lpNv8", function(module, exports) {

$parcel$export(module.exports, "addBufferError", () => $cda1f7d272061b98$export$a2e535b38f56de3f);
$parcel$export(module.exports, "resetBufferErrors", () => $cda1f7d272061b98$export$e86d86ae2de90434);
const $cda1f7d272061b98$export$a2e535b38f56de3f = (errorCode)=>({ setState: setState, getState: getState })=>{
        const bufferErrors = getState().bufferErrors || [];
        setState({
            bufferErrors: [
                ...bufferErrors,
                errorCode
            ]
        });
    };
const $cda1f7d272061b98$export$e86d86ae2de90434 = ()=>({ setState: setState })=>{
        setState({
            bufferErrors: null
        });
    };

});

parcelRegister("b2p8u", function(module, exports) {

$parcel$export(module.exports, "sendBufferFinalMetrics", () => $ac05157e5ea7642e$export$4c03c99761d30a8);
$parcel$export(module.exports, "sendBufferConflictMetrics", () => $ac05157e5ea7642e$export$c0be261e8ef555b0);

var $2bv99 = parcelRequire("2bv99");

var $8ibkc = parcelRequire("8ibkc");

var $3Oj61 = parcelRequire("3Oj61");
const $ac05157e5ea7642e$export$4c03c99761d30a8 = (changeId, bufferForChangeId)=>({ getState: getState }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { bufferErrors: bufferErrors, analyticsData: { issueAdjustmentModulesCount: issueAdjustmentModulesCount, configuredAppsCount: configuredAppsCount, adjustmentsAPILatency: adjustmentsAPILatency } } = getState();
        const appIds = Object.keys(bufferForChangeId).join();
        if (bufferErrors === null) (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'bufferApplication success', viewType, {
            changeId: changeId,
            appIds: appIds
        });
        (0, $8ibkc.getAnalytics)(viewType).stopTTI({
            issueAdjustmentModulesCount: issueAdjustmentModulesCount,
            adjustmentsAPILatency: adjustmentsAPILatency,
            configuredAppsCount: configuredAppsCount,
            completionStatus: (0, $3Oj61.findAppsWhichDidNotSendChangesBeforeTimeout)(bufferForChangeId).length > 0 ? 'buffering_timeout' : 'success',
            viewType: viewType,
            appIds: appIds
        });
    };
const $ac05157e5ea7642e$export$c0be261e8ef555b0 = (changeId, bufferForChangeId)=>async ({ getState: getState }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { analyticsData: { issueAdjustmentModulesCount: issueAdjustmentModulesCount, configuredAppsCount: configuredAppsCount, adjustmentsAPILatency: adjustmentsAPILatency } } = getState();
        const appIds = Object.keys(bufferForChangeId).join();
        (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'multipleApps conflict', viewType, {
            changeId: changeId,
            appIds: appIds
        });
        (0, $8ibkc.getAnalytics)(viewType).stopTTI({
            issueAdjustmentModulesCount: issueAdjustmentModulesCount,
            adjustmentsAPILatency: adjustmentsAPILatency,
            configuredAppsCount: configuredAppsCount,
            completionStatus: 'buffering_conflict',
            viewType: viewType,
            appIds: appIds
        });
    };

});
parcelRegister("3Oj61", function(module, exports) {

$parcel$export(module.exports, "doBufferedChangesHaveAConflict", () => $7d0aaeca5ed35059$export$36c9ecc6b80bc6cc);
$parcel$export(module.exports, "findAppsWhichDidNotSendChangesBeforeTimeout", () => $7d0aaeca5ed35059$export$dce8d41dc6e2b824);
const $7d0aaeca5ed35059$export$36c9ecc6b80bc6cc = ({ bufferForChangeId: bufferForChangeId })=>{
    const changes = Object.values(bufferForChangeId).flatMap((fieldsChanges)=>fieldsChanges !== null ? Object.entries(fieldsChanges) : []).flatMap(([fieldId, properties])=>Object.keys(properties).map((property)=>`${fieldId}_${property}`));
    return changes.length !== new Set(changes).size;
};
const $7d0aaeca5ed35059$export$dce8d41dc6e2b824 = (bufferForChangeId)=>Object.entries(bufferForChangeId).filter(([_, fieldsChanges])=>fieldsChanges === null).map(([appId])=>appId);

});



parcelRegister("ke5CN", function(module, exports) {

$parcel$export(module.exports, "changesReadyToApply", () => $714ec2685b8970cc$export$b1a7d72d393d2d4b);
const $714ec2685b8970cc$export$b1a7d72d393d2d4b = (bufferForChangeId)=>{
    const appsReady = Object.values(bufferForChangeId).filter((fieldsChanges)=>fieldsChanges !== null);
    return appsReady.length === Object.keys(bufferForChangeId).length;
};

});

parcelRegister("fxgW1", function(module, exports) {

$parcel$export(module.exports, "handleBufferAllAppsError", () => $d5c00fb5ba986881$export$8b3b1eb4f3cdfb5f);

var $h1jSL = parcelRequire("h1jSL");

var $8ibkc = parcelRequire("8ibkc");

var $7mVyC = parcelRequire("7mVyC");

var $4QLO7 = parcelRequire("4QLO7");

var $9V8vn = parcelRequire("9V8vn");

var $lpNv8 = parcelRequire("lpNv8");
const $d5c00fb5ba986881$export$8b3b1eb4f3cdfb5f = ({ err: err, changeId: changeId, bufferForChangeId: bufferForChangeId })=>({ getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { analyticsData: { issueAdjustmentModulesCount: issueAdjustmentModulesCount, configuredAppsCount: configuredAppsCount, adjustmentsAPILatency: adjustmentsAPILatency } } = getState();
        const appIds = Object.keys(bufferForChangeId);
        dispatch((0, $7mVyC.setError)({
            errorCode: 'APPLY_BUFFER_CHANGES_ERROR'
        }));
        dispatch((0, $4QLO7.unregisterAllFieldsOfChangeId)(changeId));
        dispatch((0, $9V8vn.clearBufferForChangeId)({
            changeId: changeId
        }));
        dispatch((0, $lpNv8.resetBufferErrors)());
        (0, $8ibkc.getAnalytics)(viewType).stopTTI({
            issueAdjustmentModulesCount: issueAdjustmentModulesCount,
            adjustmentsAPILatency: adjustmentsAPILatency,
            configuredAppsCount: configuredAppsCount,
            completionStatus: 'error',
            viewType: viewType,
            appIds: appIds.join()
        });
        (0, $h1jSL.fireUIMErrorAnalytics)({
            error: err,
            id: 'bufferChanges',
            viewType: viewType,
            attributes: {
                errorCause: err?.cause
            },
            event: createAnalyticsEvent({})
        });
    };

});


parcelRegister("5hhPg", function(module, exports) {

$parcel$export(module.exports, "initializeField", () => $4a4217001e2b8280$export$6b51e123e61a9615);

var $2brTl = parcelRequire("2brTl");
const $4a4217001e2b8280$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $2brTl.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };

});
parcelRegister("2brTl", function(module, exports) {

$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $d67d5ad1d534dc24$export$50806045b617d116);

var $h1jSL = parcelRequire("h1jSL");

var $8ibkc = parcelRequire("8ibkc");
const $d67d5ad1d534dc24$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $h1jSL.fireIAErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});


parcelRegister("4BYh6", function(module, exports) {

$parcel$export(module.exports, "initializeScreenTabs", () => $ffd70689a2678058$export$7f7be235f64f029b);
const $ffd70689a2678058$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ setState: setState })=>{
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("5v1Sk", function(module, exports) {

$parcel$export(module.exports, "processChange", () => $c7e1595f1029ad04$export$352dfcce04d66748);

var $d2gyF = parcelRequire("d2gyF");

var $1ybV0 = parcelRequire("1ybV0");

var $8ibkc = parcelRequire("8ibkc");

var $4XxH1 = parcelRequire("4XxH1");
const $c7e1595f1029ad04$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType, fieldType: fieldType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        const emitChangeOn = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const nextFormData = (0, $4XxH1.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw') ? (0, (/*@__PURE__*/$parcel$interopDefault($d2gyF)))() : undefined;
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("d2gyF", function(module, exports) {

var $1uqnh = parcelRequire("1uqnh");
/** Used to generate unique IDs. */ var $97d84e6072626d2c$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $97d84e6072626d2c$var$uniqueId(prefix) {
    var id = ++$97d84e6072626d2c$var$idCounter;
    return $1uqnh(prefix) + id;
}
module.exports = $97d84e6072626d2c$var$uniqueId;

});

parcelRegister("4XxH1", function(module, exports) {

$parcel$export(module.exports, "calculateNextFormValue", () => $895b39e97d23f926$export$25441a03bb8f1cb0);

var $hTLlD = parcelRequire("hTLlD");

var $2brTl = parcelRequire("2brTl");
const $895b39e97d23f926$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    const newPublicValue = (0, $2brTl.mapFieldValueFromInternalToPublic)({
        fieldMetadata: internalFormMetadata[fieldId],
        internalFieldValue: fieldValue,
        fieldType: fieldType,
        viewType: viewType
    });
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("doolD", function(module, exports) {

$parcel$export(module.exports, "processIframeChanges", () => $3cc3399376f38c1e$export$35909bac5672434b);

var $h1jSL = parcelRequire("h1jSL");
var $2bv99 = parcelRequire("2bv99");

var $8ibkc = parcelRequire("8ibkc");

var $gIAmp = parcelRequire("gIAmp");

var $fsCiP = parcelRequire("fsCiP");

var $3P2qm = parcelRequire("3P2qm");
parcelRequire("B0Z3S");
var $lpNv8 = parcelRequire("lpNv8");
var $B0Z3S = parcelRequire("B0Z3S");

var $7mVyC = parcelRequire("7mVyC");

var $4QLO7 = parcelRequire("4QLO7");

var $2ugNi = parcelRequire("2ugNi");
const $3cc3399376f38c1e$export$35909bac5672434b = ({ changeId: changeId, fieldsChangesUnnormalized: fieldsChangesUnnormalized, appId: appId, context: context })=>async ({ getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { buffer: buffer, analyticsData: analyticsData } = getState();
        const { cloudId: cloudId, activationId: activationId, issueId: issueId, environment: environment, getAsyncLookupData: getAsyncLookupData, getFilteredFieldChangesBasedOnScope: getFilteredFieldChangesBasedOnScope, getValidatedFieldsChanges: getValidatedFieldsChanges } = context;
        const { issueAdjustmentModulesCount: issueAdjustmentModulesCount, configuredAppsCount: configuredAppsCount, adjustmentsAPILatency: adjustmentsAPILatency } = analyticsData;
        const bufferForChangeId = buffer[changeId] || {};
        const shouldBufferChanges = Object.prototype.hasOwnProperty.call(bufferForChangeId, appId);
        try {
            const fieldsChanges = getFilteredFieldChangesBasedOnScope(fieldsChangesUnnormalized);
            const validatedFieldsChanges = await getValidatedFieldsChanges(fieldsChanges);
            if (shouldBufferChanges) {
                await dispatch((0, $B0Z3S.bufferChanges)({
                    changeId: changeId,
                    appId: appId,
                    fieldsChanges: fieldsChanges,
                    context: context
                }));
                return;
            }
            const lookupDataFromApi = await getAsyncLookupData(validatedFieldsChanges);
            await dispatch((0, $2ugNi.updateFields)({
                changeId: changeId,
                fieldsChanges: fieldsChanges,
                lookupDataFromApi: lookupDataFromApi,
                tenantContext: {
                    cloudId: cloudId,
                    activationId: activationId
                },
                viewContext: {
                    issueId: issueId
                },
                environment: environment,
                appId: appId
            }));
            (0, $8ibkc.getAnalytics)(viewType).stopTTI({
                issueAdjustmentModulesCount: issueAdjustmentModulesCount,
                adjustmentsAPILatency: adjustmentsAPILatency,
                configuredAppsCount: configuredAppsCount,
                completionStatus: 'success',
                viewType: viewType,
                appIds: appId
            });
            (0, $gIAmp.fireIATrackAnalytics)(createAnalyticsEvent({}), 'jiraUiModificationsUseSubmit success', viewType, {
                issueAdjustmentModulesCount: issueAdjustmentModulesCount,
                configuredAppsCount: configuredAppsCount
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            dispatch((0, $7mVyC.setError)({
                errorCode: 'USE_SUBMIT_ERROR_CODE'
            }));
            if (shouldBufferChanges) {
                dispatch((0, $lpNv8.addBufferError)('USE_SUBMIT_ERROR_CODE'));
                dispatch((0, $4QLO7.unregisterFields)({
                    changeId: changeId,
                    appId: appId
                }));
            }
            (0, $8ibkc.getAnalytics)(viewType).stopTTI({
                issueAdjustmentModulesCount: issueAdjustmentModulesCount,
                adjustmentsAPILatency: adjustmentsAPILatency,
                configuredAppsCount: configuredAppsCount,
                completionStatus: 'error',
                viewType: viewType,
                appIds: appId
            });
            if (err instanceof (0, $fsCiP.UiModificationsFieldsValidationError)) {
                (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'fieldsChangesValidation failed', viewType, {
                    ...err.attributes
                });
                // Setting app errors from validators to pass them to the onErrorCallback
                dispatch((0, $3P2qm.setAppErrors)({
                    errors: err.attributes.errors,
                    appId: appId
                }));
                return;
            }
            (0, $h1jSL.fireIAErrorAnalytics)({
                error: err,
                id: 'useSubmit',
                viewType: viewType,
                attributes: {
                    errorCause: err?.cause
                },
                event: createAnalyticsEvent({})
            });
        } finally{
            // in case of successful addition of changes to the buffer, we don't want to remove loading state on fields yet
            if (!shouldBufferChanges) dispatch((0, $4QLO7.unregisterFields)({
                changeId: changeId,
                appId: appId
            }));
        }
    };

});
parcelRegister("gIAmp", function(module, exports) {

$parcel$export(module.exports, "fireIATrackAnalytics", () => $af484da6b5020068$export$5014f9ce18c21b09);

var $jMP2a = parcelRequire("jMP2a");

var $7vcoF = parcelRequire("7vcoF");
const $af484da6b5020068$export$5014f9ce18c21b09 = (event, id, viewType, attributes = {})=>{
    const prefix = (0, $7vcoF.supportedViews)[viewType] ? viewType : '';
    (0, $jMP2a.fireTrackAnalytics)(event, `${prefix}${id}`, attributes);
};

});


parcelRegister("gwHjs", function(module, exports) {

$parcel$export(module.exports, "setFieldValue", () => $e9fd5dd289ce7424$export$6556d46d2662453c);

var $4XxH1 = parcelRequire("4XxH1");
const $e9fd5dd289ce7424$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $4XxH1.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("juRVB", function(module, exports) {

$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $ef2c7adb6b78931a$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $ef2c7adb6b78931a$export$cf768a695e83eefa);

var $1ybV0 = parcelRequire("1ybV0");

var $2bv99 = parcelRequire("2bv99");

var $3UFcS = parcelRequire("3UFcS");

var $7mVyC = parcelRequire("7mVyC");
const $ef2c7adb6b78931a$var$getTimeout = ()=>(0, $1ybV0.getFeatureFlagValue)('forge-ui-modifications-fields-initialization-timeout', 15000);
const $ef2c7adb6b78931a$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $ef2c7adb6b78931a$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $ef2c7adb6b78931a$export$2c0f020b89dfa30b = ()=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($ef2c7adb6b78931a$export$8ce83a9201590a5e()), $ef2c7adb6b78931a$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $ef2c7adb6b78931a$export$8ce83a9201590a5e = ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($ef2c7adb6b78931a$var$isFieldInitialisationComplete(status) || ((0, $1ybV0.ff)('forge-ui-modifications-screentabs_qoa33') ? (0, $3UFcS.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null : (0, $3UFcS.selectReadyFieldsOld)(getState(), undefined) !== null)) return;
        dispatch((0, $7mVyC.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'fieldsInitialization timedOut', viewType, {
            previousStatus: status,
            configuredTimeout: $ef2c7adb6b78931a$var$getTimeout(),
            fieldsInitializationTime: $ef2c7adb6b78931a$var$getFieldsInitializationTime(startTime),
            initalizedFieldsCount: Object.keys(formData ?? {}).length,
            experienceDataIsLoading: experienceDataIsLoading,
            supportedFieldsCount: numberOfSupportedFields
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $ef2c7adb6b78931a$export$cf768a695e83eefa = ()=>({ getState: getState, setState: setState }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { status: status } = getState().fieldsInitialization;
        if ($ef2c7adb6b78931a$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'fieldsInitialization success', viewType, {
            previousStatus: status,
            fieldsInitializationTime: $ef2c7adb6b78931a$var$getFieldsInitializationTime(startTime),
            initalizedFieldsCount: numberOfSupportedFields
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("3UFcS", function(module, exports) {

$parcel$export(module.exports, "selectReadyFieldsOld", () => $c53e858e46a423f2$export$8f4fb114be4d807);
$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $c53e858e46a423f2$export$4cadeedb8c3f31f7);

var $bj4JM = parcelRequire("bj4JM");

var $8ibkc = parcelRequire("8ibkc");
const $c53e858e46a423f2$export$8f4fb114be4d807 = (0, $bj4JM.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, experienceDataIsLoading)=>{
    if (formData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return formData;
    return null;
});
const $c53e858e46a423f2$export$4cadeedb8c3f31f7 = (0, $bj4JM.createSelector)((_, props)=>props.viewType, (state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (viewType, formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && !(0, $8ibkc.isScreenTabsSupportEnabled)(viewType) && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: []
    };
    if (formData !== null && screenTabsData !== null && (0, $8ibkc.isScreenTabsSupportEnabled)(viewType) && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("cQ3jb", function(module, exports) {

$parcel$export(module.exports, "updateActiveScreenTab", () => $ca2372258451375d$export$21363496760d39cd);
const $ca2372258451375d$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("51sNT", function(module, exports) {

$parcel$export(module.exports, "updateScreenTabs", () => $1b694249b98b7d22$export$131c67fd312b8a11);

var $2bv99 = parcelRequire("2bv99");

var $250Jk = parcelRequire("250Jk");

var $hHma7 = parcelRequire("hHma7");

var $3P2qm = parcelRequire("3P2qm");
const $1b694249b98b7d22$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { screenTabs: internalScreenTabs } = getState();
        try {
            if (screenTabsFromIframe && internalScreenTabs && (0, $250Jk.screenTabsPublicToInternalValidator)(screenTabsFromIframe, internalScreenTabs)) setState({
                screenTabs: (0, $250Jk.screenTabsPublicToInternalTransformer)(screenTabsFromIframe, internalScreenTabs)
            });
            else throw new (0, $hHma7.UiModificationsScreenTabsValidationError)('Transformation failed', {
                errors: [
                    {
                        type: (0, $hHma7.SCREENTAB_VALIDATION_ERROR),
                        message: 'Transformation failed'
                    }
                ]
            });
        } catch (err) {
            if (err instanceof (0, $hHma7.UiModificationsScreenTabsValidationError)) {
                (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'screenTabsChangesValidation failed', viewType, {
                    ...err.attributes
                });
                // Setting app errors from validators to pass them to the onErrorCallback
                dispatch((0, $3P2qm.setAppErrors)({
                    errors: err.attributes.errors,
                    appId: appId
                }));
            }
        }
    };

});
parcelRegister("250Jk", function(module, exports) {

$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $84a538ddabf922c3$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $84a538ddabf922c3$export$e7a91e7e430e691a);

var $8xPow = parcelRequire("8xPow");
const $84a538ddabf922c3$var$isValidScreenTabId = (id, internalScreenTabs)=>(0, $8xPow.isNotEmptyString)(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $84a538ddabf922c3$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $84a538ddabf922c3$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $84a538ddabf922c3$export$9ca9b35e7b6a8bbc = (screenTabsFromApp, screenTabsInternal)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = screenTabsInternal.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = screenTabsInternal.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first.
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $84a538ddabf922c3$export$e7a91e7e430e691a = (screenTabsFromApp, screenTabsInternal)=>{
    let numberOfActiveScreenTabs = 0;
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter(({ id: id, isVisible: isVisible, isActive: isActive })=>{
        const isValidScreenTab = $84a538ddabf922c3$var$isValidScreenTabId(id, screenTabsInternal) && $84a538ddabf922c3$var$isValidScreenTabIsVisible(isVisible) && $84a538ddabf922c3$var$isValidScreenTabIsActive(isActive);
        numberOfActiveScreenTabs += isActive ? 1 : 0;
        return isValidScreenTab;
    });
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length;
};

});

parcelRegister("hHma7", function(module, exports) {

$parcel$export(module.exports, "SCREENTAB_VALIDATION_ERROR", () => $3824179c819605a1$export$7905b8899a324e90);
$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $3824179c819605a1$export$faf1f1824ee0a136);
const $3824179c819605a1$export$7905b8899a324e90 = 'SCREENTAB_VALIDATION_FAILED';
class $3824179c819605a1$export$faf1f1824ee0a136 extends Error {
    constructor(message, attributes, cause){
        super(message, cause);
        this.attributes = attributes;
    }
}

});





parcelRegister("i4Rdz", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainersStore", () => $0f5d3276225e8f95$export$5c4a1f63cea7b5b3);
$parcel$export(module.exports, "useIssueLayoutGlanceStore", () => $0f5d3276225e8f95$export$769bbe2bda9a43ce);
$parcel$export(module.exports, "useIssueLayoutContextPanelStore", () => $0f5d3276225e8f95$export$3aa9017e11451546);
$parcel$export(module.exports, "useIssueLayoutActionsStore", () => $0f5d3276225e8f95$export$5513f3c310d101f5);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $5draI = parcelRequire("5draI");
const $0f5d3276225e8f95$var$getIssueViewLayoutContainers = (state, issueKey)=>state[String(issueKey)]?.containers || [];
const $0f5d3276225e8f95$var$getIssueViewLayoutGlance = (state, issueKey)=>state[String(issueKey)]?.glance;
const $0f5d3276225e8f95$var$getIssueViewLayoutContextPanel = (state, issueKey)=>state[String(issueKey)]?.contextPanel;
const $0f5d3276225e8f95$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-view-layout-service',
    initialState: {},
    actions: $5draI
});
const $0f5d3276225e8f95$export$5c4a1f63cea7b5b3 = (0, $ggKAj.createHook)($0f5d3276225e8f95$export$6f57813fe9f31bf9, {
    selector: $0f5d3276225e8f95$var$getIssueViewLayoutContainers
});
const $0f5d3276225e8f95$export$769bbe2bda9a43ce = (0, $ggKAj.createHook)($0f5d3276225e8f95$export$6f57813fe9f31bf9, {
    selector: $0f5d3276225e8f95$var$getIssueViewLayoutGlance
});
const $0f5d3276225e8f95$export$3aa9017e11451546 = (0, $ggKAj.createHook)($0f5d3276225e8f95$export$6f57813fe9f31bf9, {
    selector: $0f5d3276225e8f95$var$getIssueViewLayoutContextPanel
});
const $0f5d3276225e8f95$export$5513f3c310d101f5 = (0, $ggKAj.createHook)($0f5d3276225e8f95$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("5draI", function(module, exports) {

$parcel$export(module.exports, "setIssueViewContainersLayout", () => $5f6c6dc9fe0f04f9$export$e956c64a7167b73a);
$parcel$export(module.exports, "setIssueViewLayoutGlance", () => $5f6c6dc9fe0f04f9$export$6a9b24c2efe66bb7);
$parcel$export(module.exports, "setIssueViewLayoutContextPanel", () => $5f6c6dc9fe0f04f9$export$9a04e4b958ebc410);
const $5f6c6dc9fe0f04f9$export$e956c64a7167b73a = (issueKey, containersByType)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                containers: containersByType?.containers || []
            }
        });
    };
const $5f6c6dc9fe0f04f9$export$6a9b24c2efe66bb7 = (issueKey, glance)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                glance: glance
            }
        });
    };
const $5f6c6dc9fe0f04f9$export$9a04e4b958ebc410 = (issueKey, contextPanel)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                contextPanel: contextPanel
            }
        });
    };

});



parcelRegister("6bhHe", function(module, exports) {

$parcel$export(module.exports, "useTimeTrackingConfiguration", () => $3f1d18787644dd25$export$57b83fc8c963078f);
$parcel$export(module.exports, "useJiraSettingsActions", () => $3f1d18787644dd25$export$6f294bed8b806bfb);

var $eUqFw = parcelRequire("eUqFw");

var $3poNT = parcelRequire("3poNT");
const $3f1d18787644dd25$export$57b83fc8c963078f = ()=>{
    const [timeTrackingConfiguration] = (0, $3poNT.useJiraSettingStoreTimeTracking)();
    return [
        timeTrackingConfiguration
    ];
};
const $3f1d18787644dd25$export$a0b7933d1ba1359a = ()=>{
    const [subTaskConfiguration] = (0, $3poNT.useJiraSettingStoreSubtaskConfiguration)();
    return [
        subTaskConfiguration
    ];
};
const $3f1d18787644dd25$export$e8c8fa84fe64255f = ()=>{
    const [issueLinkTypes] = (0, $3poNT.useJiraSettingStoreIssueLinkType)();
    return [
        issueLinkTypes
    ];
};
const $3f1d18787644dd25$export$311fcda1c9d987e1 = ()=>{
    const [newIssueViewTransitionSetting] = (0, $3poNT.useJiraSettingStoreNewIssueViewTransition)();
    return [
        newIssueViewTransitionSetting
    ];
};
const $3f1d18787644dd25$export$6f294bed8b806bfb = ()=>{
    const [, { setJiraSettings: setJiraSettings }] = (0, $3poNT.useSettingsActions)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setJiraSettings: setJiraSettings
        }), [
        setJiraSettings
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("3poNT", function(module, exports) {

$parcel$export(module.exports, "useJiraSettingStoreTimeTracking", () => $0979f93719382ebd$export$a02b4a407a2f26d4);
$parcel$export(module.exports, "useJiraSettingStoreNewIssueViewTransition", () => $0979f93719382ebd$export$ef5d1a1edee065c3);
$parcel$export(module.exports, "useJiraSettingStoreSubtaskConfiguration", () => $0979f93719382ebd$export$fb7d68c140cb341f);
$parcel$export(module.exports, "useJiraSettingStoreIssueLinkType", () => $0979f93719382ebd$export$b0a0062863e9885a);
$parcel$export(module.exports, "useSettingsActions", () => $0979f93719382ebd$export$346f2dc8b103b21d);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $h9cCP = parcelRequire("h9cCP");

var $2YHa8 = parcelRequire("2YHa8");
const $0979f93719382ebd$export$d4c72bab9d6cc13a = {
    newIssueViewTransitionSettings: {
        newIssueViewTransitionLockingStatus: (0, $h9cCP.DEFAULT_TO_NEW_ISSUE_VIEW),
        shouldDelayChangeboarding: false
    },
    issueLinkTypes: [],
    subtasksConfiguration: {
        enabled: true
    },
    timeTrackingConfiguration: {
        isTimeTrackingEnabled: false,
        daysPerWeek: 0,
        hoursPerDay: 0,
        // Possible values for defaultUnit can be: minute, hour, day, and week.
        defaultUnit: (0, $h9cCP.MINUTE)
    }
};
const $0979f93719382ebd$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'jiraSettings',
    initialState: $0979f93719382ebd$export$d4c72bab9d6cc13a,
    actions: $2YHa8
});
// remove undefined when we remove ff issue.details.admin-options-phase-2
const $0979f93719382ebd$var$getTimeTracking = (state)=>state.timeTrackingConfiguration;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $0979f93719382ebd$var$getNewIssueViewTransition = (state)=>state.newIssueViewTransitionSettings || undefined;
const $0979f93719382ebd$var$getSubtaskConfiguration = (state)=>state.subtasksConfiguration;
const $0979f93719382ebd$var$getIssueLinkType = (state)=>state.issueLinkTypes;
const $0979f93719382ebd$export$a02b4a407a2f26d4 = (0, $ggKAj.createHook)($0979f93719382ebd$export$6f57813fe9f31bf9, {
    selector: $0979f93719382ebd$var$getTimeTracking
});
const $0979f93719382ebd$export$ef5d1a1edee065c3 = (0, $ggKAj.createHook)($0979f93719382ebd$export$6f57813fe9f31bf9, {
    selector: $0979f93719382ebd$var$getNewIssueViewTransition
});
const $0979f93719382ebd$export$fb7d68c140cb341f = (0, $ggKAj.createHook)($0979f93719382ebd$export$6f57813fe9f31bf9, {
    selector: $0979f93719382ebd$var$getSubtaskConfiguration
});
const $0979f93719382ebd$export$b0a0062863e9885a = (0, $ggKAj.createHook)($0979f93719382ebd$export$6f57813fe9f31bf9, {
    selector: $0979f93719382ebd$var$getIssueLinkType
});
const $0979f93719382ebd$export$346f2dc8b103b21d = (0, $ggKAj.createHook)($0979f93719382ebd$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("h9cCP", function(module, exports) {

$parcel$export(module.exports, "MINUTE", () => $335f9886067ef898$export$f4aba04677f37907);
$parcel$export(module.exports, "HOUR", () => $335f9886067ef898$export$1bf939ebcf31ef0e);
$parcel$export(module.exports, "DAY", () => $335f9886067ef898$export$1a58b8d7f494dd72);
$parcel$export(module.exports, "WEEK", () => $335f9886067ef898$export$3241045aa1844a20);
$parcel$export(module.exports, "DAYS", () => $335f9886067ef898$export$b387b66963374517);
$parcel$export(module.exports, "HOURS", () => $335f9886067ef898$export$f25ebc73c10ad2c);
$parcel$export(module.exports, "PRETTY", () => $335f9886067ef898$export$d39e6ebabedff673);
$parcel$export(module.exports, "defaultTimeTrackingConfiguration", () => $335f9886067ef898$export$e17ebf14f4144ede);
$parcel$export(module.exports, "DEFAULT_TO_NEW_ISSUE_VIEW", () => $335f9886067ef898$export$83f9ac2d887bd06a);
const $335f9886067ef898$export$f4aba04677f37907 = 'minute';
const $335f9886067ef898$export$1bf939ebcf31ef0e = 'hour';
const $335f9886067ef898$export$1a58b8d7f494dd72 = 'day';
const $335f9886067ef898$export$3241045aa1844a20 = 'week';
const $335f9886067ef898$export$b387b66963374517 = 'days';
const $335f9886067ef898$export$f25ebc73c10ad2c = 'hours';
const $335f9886067ef898$export$d39e6ebabedff673 = 'pretty';
const $335f9886067ef898$export$e17ebf14f4144ede = {
    isTimeTrackingEnabled: false,
    daysPerWeek: 5,
    hoursPerDay: 8,
    defaultUnit: $335f9886067ef898$export$f4aba04677f37907,
    format: $335f9886067ef898$export$d39e6ebabedff673
};
const $335f9886067ef898$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $335f9886067ef898$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $335f9886067ef898$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';

});

parcelRegister("2YHa8", function(module, exports) {

$parcel$export(module.exports, "setJiraSettings", () => $2ee1115fea197613$export$aa595a6ada3acbb8);
const $2ee1115fea197613$export$aa595a6ada3acbb8 = (jiraSettings)=>({ setState: setState })=>{
        setState(jiraSettings);
    };

});







parcelRegister("gTJ9x", function(module, exports) {

$parcel$export(module.exports, "renderFeedback", () => $aed8fe16633857d2$export$60a3f1368234b4d0);

var $eUqFw = parcelRequire("eUqFw");

var $lqalZ = parcelRequire("lqalZ");

var $5JqpU = parcelRequire("5JqpU");

var $6vrw7 = parcelRequire("6vrw7");

var $c8DNr = parcelRequire("c8DNr");
const $aed8fe16633857d2$var$Feedback = (0, $lqalZ.connect)((state)=>({
        baseUrl: (0, $6vrw7.toBaseUrl)((0, $5JqpU.baseUrlSelector)(state)),
        locale: (0, $5JqpU.localeSelector)(state),
        applicationKey: (0, $5JqpU.applicationKeySelector)(state)
    }), {})((0, $c8DNr.default));
var $aed8fe16633857d2$export$2e2bcd8739ae039 = $aed8fe16633857d2$var$Feedback;
const $aed8fe16633857d2$export$60a3f1368234b4d0 = (applicationKeys, isCompact = true)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aed8fe16633857d2$var$Feedback, {
        isCompact: isCompact
    });

});
parcelRegister("c8DNr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6aae3db439d5402$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8sN8t = parcelRequire("8sN8t");

var $eMxRI = parcelRequire("eMxRI");

var $gQFew = parcelRequire("gQFew");

var $1M88x = parcelRequire("1M88x");
const $e6aae3db439d5402$export$43a3e1c8843b22af = (applicationKey)=>Boolean((0, $1M88x.feedbackComponentsProps)[applicationKey]);
const $e6aae3db439d5402$var$Feedback = ({ applicationKey: applicationKey, isCompact: isCompact = false })=>{
    if (applicationKey == null || !$e6aae3db439d5402$export$43a3e1c8843b22af(applicationKey)) return null;
    const feedbackProps = (0, $1M88x.feedbackComponentsProps)[applicationKey];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
        name: (0, $eMxRI.GIVE_FEEDBACK)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQFew.default), {
        ...feedbackProps,
        isCompact: isCompact
    }));
};
var $e6aae3db439d5402$export$2e2bcd8739ae039 = $e6aae3db439d5402$var$Feedback;

});
parcelRegister("gQFew", function(module, exports) {

$parcel$export(module.exports, "default", () => $00bbf670da930622$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cA8OV = parcelRequire("cA8OV");

var $eJYCK = parcelRequire("eJYCK");

var $5wV0u = parcelRequire("5wV0u");
const $00bbf670da930622$var$FeedbackButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJYCK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cA8OV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wV0u.default), props)));
var $00bbf670da930622$export$2e2bcd8739ae039 = $00bbf670da930622$var$FeedbackButton;

});
parcelRegister("cA8OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0809371ccd3c77a9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0809371ccd3c77a9$export$2e2bcd8739ae039 = (0, $kwce8.default).div.withConfig({
    componentId: "h5xpn2-0"
})({
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $c9TLT.fontSize)}px`,
    height: 'inherit',
    letterSpacing: 'normal'
});

});

parcelRegister("eJYCK", function(module, exports) {

$parcel$export(module.exports, "default", () => $786ff9760165f7c1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5BRby = parcelRequire("5BRby");

var $lqalZ = parcelRequire("lqalZ");
const $786ff9760165f7c1$var$AppBase = ({ children: children, store: store, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), props, store ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lqalZ.Provider), {
        store: store
    }, children) : children);
var $786ff9760165f7c1$export$2e2bcd8739ae039 = $786ff9760165f7c1$var$AppBase;

});

parcelRegister("5wV0u", function(module, exports) {

$parcel$export(module.exports, "default", () => $d17cf208b1e0ce88$export$2e2bcd8739ae039);

var $cKqH1 = parcelRequire("cKqH1");
var $d17cf208b1e0ce88$export$2e2bcd8739ae039 = (0, $cKqH1.default);

});
parcelRegister("cKqH1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3f11b5193d33333$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
const $f3f11b5193d33333$var$LazyLoadFeedback = (0, $7rh0R.lazy)(()=>(parcelRequire("g9Im0")), {
    moduleId: "./src/packages/issue/feedback-button/src/view/feedback.tsx"
});
const $f3f11b5193d33333$var$FeedbackButtonRenderer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue.issue-view.feedback-button",
        packageName: "issue",
        render: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "feedback-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3f11b5193d33333$var$LazyLoadFeedback, props)));
var $f3f11b5193d33333$export$2e2bcd8739ae039 = $f3f11b5193d33333$var$FeedbackButtonRenderer;

});
parcelRegister("g9Im0", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('8eOYa')
        ]);
        const value = parcelRequire('9Vvvk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("8eOYa")
    ]).then(()=>parcelRequire('9Vvvk'));
}

});




parcelRegister("1M88x", function(module, exports) {

$parcel$export(module.exports, "feedbackComponentsProps", () => $c17b6d62e4f4bb23$export$be7d793c2a69ea30);

var $2wUFy = parcelRequire("2wUFy");
const $c17b6d62e4f4bb23$export$be7d793c2a69ea30 = {
    [(0, $2wUFy.default).SOFTWARE_ISSUE]: {
        feedbackGroupId: 'jira-software-full-issueview',
        collectorId: '12f21050'
    },
    [(0, $2wUFy.default).CORE_ISSUE]: {
        feedbackGroupId: 'jira-core-full-issueview',
        collectorId: 'f7ac9eb0'
    },
    [(0, $2wUFy.default).SERVICE_DESK]: {
        feedbackGroupId: 'jira-service-desk-full-issueview',
        collectorId: '3311e016'
    },
    [(0, $2wUFy.default).BITBUCKET_ISSUE]: {
        feedbackGroupId: 'bitbucket-jira-issueview',
        collectorId: 'e7fdb917'
    }
};

});



parcelRegister("03M3s", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea407f66ed3b35dc$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $gZWxz = parcelRequire("gZWxz");

var $j0h3Y = parcelRequire("j0h3Y");

var $6gFlc = parcelRequire("6gFlc");

var $ly1CP = parcelRequire("ly1CP");

var $htnxe = parcelRequire("htnxe");
var $ea407f66ed3b35dc$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $gZWxz.WithDataProvider), (0, $6gFlc.default)(), (0, $j0h3Y.default))((0, $ly1CP.default));

});
parcelRegister("gZWxz", function(module, exports) {

$parcel$export(module.exports, "WithDataProvider", () => $e2e6d5fa5786b434$export$b0017632f1661e1);

var $eUqFw = parcelRequire("eUqFw");

var $6J3mH = parcelRequire("6J3mH");
const $e2e6d5fa5786b434$export$b0017632f1661e1 = (WrappedComponent)=>// @ts-expect-error - TS2322 - Type '(props: TProps) => JSX.Element' is not assignable to type 'AbstractComponent<TProps, any>'.
    (props)=>{
        const { dataProvider: dataProvider, ...otherProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6J3mH.DataProviderContext).Consumer, null, (contextDataProvider)=>// @ts-expect-error - TS2322 - Type 'Omit<TProps, "dataProvider"> & { dataProvider: DataProvider; }' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<TProps & OwnProps> & RefAttributes<any> & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...otherProps,
                dataProvider: dataProvider || contextDataProvider()
            }));
    };

});
parcelRegister("6J3mH", function(module, exports) {

$parcel$export(module.exports, "DataProviderContext", () => $4a77777697c6cfb8$export$5bce75db3a3f66c4);

var $eUqFw = parcelRequire("eUqFw");

var $7JlQ7 = parcelRequire("7JlQ7");
const $4a77777697c6cfb8$export$5bce75db3a3f66c4 = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $7JlQ7.getDataProvider));

});
parcelRegister("7JlQ7", function(module, exports) {

$parcel$export(module.exports, "getDataProvider", () => $b647076092cf3969$export$add6bf8e4261fead);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");

var $e91YZ = parcelRequire("e91YZ");

var $6vrw7 = parcelRequire("6vrw7");

var $aVkxW = parcelRequire("aVkxW");
const $b647076092cf3969$var$DEFAULT_EXPIRY_THRESHOLD_SECONDS = 3600;
const $b647076092cf3969$var$DEFAULT_MAX_SIZE = 100;
const $b647076092cf3969$var$getTenantBaseUrl = ()=>{
    try {
        return (0, $6vrw7.toBaseUrl)((0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)().baseUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return (0, $6vrw7.toBaseUrl)('');
    }
};
const $b647076092cf3969$var$createConfig = (config = {})=>{
    const defaultConfig = {
        expiryThresholdSeconds: $b647076092cf3969$var$DEFAULT_EXPIRY_THRESHOLD_SECONDS,
        maxSize: $b647076092cf3969$var$DEFAULT_MAX_SIZE,
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        baseUrl: Object.prototype.hasOwnProperty.call(config, 'baseUrl') ? config.baseUrl : $b647076092cf3969$var$getTenantBaseUrl(),
        ssrCachedIssue: null
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return Object.assign({}, defaultConfig, config);
};
const $b647076092cf3969$export$33c5e0ba77bb7d8 = (options = {})=>{
    const config = $b647076092cf3969$var$createConfig(options);
    const baseUrl = (0, $6vrw7.toBaseUrl)(config.baseUrl);
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const clearCache = ()=>{};
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const insertSerializedIssue = ()=>{};
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const loadIssues = ()=>{};
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const loadIssuesById = ()=>{};
    // @ts-expect-error - TS2355 - A function whose declared type is neither 'void' nor 'any' must return a value.
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const getIssue = ()=>{};
    const loadIssue$ = ()=>(0, $3JafE.Observable).empty();
    const getIssue$ = ()=>(0, $3JafE.Observable).empty();
    const refreshIssue$ = ()=>loadIssue$();
    const getIssueRemoteData$ = (issueKey, cloudId, isIssueViewWhiteboardsStandaloneEnabled)=>isIssueViewWhiteboardsStandaloneEnabled ? (0, $aVkxW.fetchIssueRemoteDataWithWhiteboards$)((0, $6vrw7.toIssueKey)(issueKey), (0, $6vrw7.toCloudId)(cloudId)) : (0, $aVkxW.fetchIssueRemoteData$)(baseUrl, (0, $6vrw7.toIssueKey)(issueKey));
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const updateIssue = ()=>{};
    const getMetrics = ()=>({
            cacheSize: 0,
            cacheStaleCount: 0,
            cacheAvailableCapacity: 0,
            cacheHit: false,
            staleCacheHit: false
        });
    return {
        clearCache: clearCache,
        loadIssues: loadIssues,
        loadIssuesById: loadIssuesById,
        getIssue: getIssue,
        getIssue$: getIssue$,
        getIssueRemoteData$: getIssueRemoteData$,
        refreshIssue$: refreshIssue$,
        updateIssue: updateIssue,
        getMetrics: getMetrics,
        insertSerializedIssue: insertSerializedIssue
    };
};
// store it as a singleton
let $b647076092cf3969$var$dataProvider;
const $b647076092cf3969$export$add6bf8e4261fead = ()=>{
    if ($b647076092cf3969$var$dataProvider == null) $b647076092cf3969$var$dataProvider = $b647076092cf3969$export$33c5e0ba77bb7d8();
    return $b647076092cf3969$var$dataProvider;
};

});
parcelRegister("aVkxW", function(module, exports) {

$parcel$export(module.exports, "fetchIssueRemoteData$", () => $b6c369d51634b049$export$83220ed1a595568a);
$parcel$export(module.exports, "fetchIssueRemoteDataWithWhiteboards$", () => $b6c369d51634b049$export$3aec720cf88c26cd);

var $3JafE = parcelRequire("3JafE");
parcelRequire("flmol");
parcelRequire("8OtG5");
parcelRequire("1Lcr1");
parcelRequire("8jBvP");

var $cwK3t = parcelRequire("cwK3t");

var $df9H8 = parcelRequire("df9H8");

var $dXapj = parcelRequire("dXapj");

var $aynDk = parcelRequire("aynDk");

var $6yPEx = parcelRequire("6yPEx");

var $3ElT9 = parcelRequire("3ElT9");

var $3A3OQ = parcelRequire("3A3OQ");

var $6vrw7 = parcelRequire("6vrw7");

var $l0eyw = parcelRequire("l0eyw");

var $gNavb = parcelRequire("gNavb");

const $b6c369d51634b049$var$LOG_LOCATION = 'issue.data-provider.source.issue-express';
const $b6c369d51634b049$var$getIssueKeyFromResponse = (response)=>{
    // @ts-expect-error - TS2339 - Property 'fields' does not exist on type 'ViewIssue | ViewIssueRemoteData'.
    const fields = response.fields || [];
    const issueKeyField = fields.find(// @ts-expect-error - TS7006 - Parameter 'field' implicitly has an 'any' type.
    (field)=>field.__typename === $330b0f1977bf0938$export$40bed7a29c3b629);
    if (!issueKeyField) throw new Error('Issue key field missing in graphql response');
    return (0, $6vrw7.toIssueKey)(issueKeyField.stringValue);
};
const $b6c369d51634b049$var$transformGraphQlIssueRemoteData = (response, issueKey)=>{
    if (!response) return null;
    const key = issueKey || $b6c369d51634b049$var$getIssueKeyFromResponse(response);
    const now = new Date();
    const { issueId: issueId, remoteLinks: remoteLinks } = response;
    return (0, $l0eyw.createIssue)({
        key: key
    }).withMeta({
        newIssueViewLockedIn: response.meta ? response.meta.newIssueViewLockedIn : false,
        dataSource: 'issueExpress',
        fetchTime: now
    }).withId(issueId).withRemoteLinks(remoteLinks).build();
};
const $b6c369d51634b049$var$transformConfluenceWhiteboardData = (response)=>{
    const issueToWhiteboard = response?.graphStore?.issueToWhiteboard ?? {};
    const whiteboards = issueToWhiteboard.edges?.map(({ node: node })=>({
            whiteboardId: node.whiteboardId,
            author: {
                ...node.author
            },
            href: `${node.links?.base}${node.links?.webUi}`,
            type: (0, $3ElT9.CONFLUENCE_WHITEBOARD),
            id: node.id,
            title: node.title
        }));
    return {
        confluenceWhiteboards: {
            linkedWhiteboards: {
                whiteboardCount: issueToWhiteboard.totalCount,
                whiteboards: whiteboards
            }
        }
    };
};
const $b6c369d51634b049$export$83220ed1a595568a = (baseUrl, issueKey)=>// @ts-expect-error - TS2322 - Type 'Observable<IssueRemoteData | null>' is not assignable to type 'Observable<IssueRemoteData>'.
    (0, $gNavb.fetchIssueRemoteData)(baseUrl, issueKey).map((graphQlIssue)=>$b6c369d51634b049$var$transformGraphQlIssueRemoteData(graphQlIssue, issueKey)).filter(Boolean).catch((err)=>{
        (0, $3A3OQ.trackOrLogClientError)($b6c369d51634b049$var$LOG_LOCATION, 'fetchIssueRemoteData: Failed to fetch issue remote data from gira', err);
        return (0, $3JafE.Observable).empty();
    });
const $b6c369d51634b049$export$3aec720cf88c26cd = (issueKey, cloudId)=>// @ts-expect-error - TS2322 - Type 'Observable<IssueRemoteData | null>' is not assignable to type 'Observable<IssueRemoteData>'.
    (0, $gNavb.fetchIssueRemoteData)('', issueKey).pipe((0, $6yPEx.switchMap)((remoteDataResponse)=>(0, $gNavb.fetchIssueConfluenceWhiteboardData)(remoteDataResponse.issueId, cloudId).pipe((0, $aynDk.map)((confluenceWhiteboardDataResponse)=>{
            const confluenceWhiteboards = $b6c369d51634b049$var$transformConfluenceWhiteboardData(confluenceWhiteboardDataResponse);
            const combinedRemoteData = {
                ...remoteDataResponse,
                remoteLinks: {
                    ...remoteDataResponse.remoteLinks,
                    ...confluenceWhiteboards
                }
            };
            return combinedRemoteData;
        }), (0, $aynDk.map)((graphQlIssue)=>$b6c369d51634b049$var$transformGraphQlIssueRemoteData(graphQlIssue, issueKey)), (0, $dXapj.filter)(Boolean), (0, $df9H8.catchError)((err)=>{
            (0, $3A3OQ.trackOrLogClientError)($b6c369d51634b049$var$LOG_LOCATION, 'fetchIssueConfluenceWhiteboardData: Failed to fetch confluence whiteboards from AGG', err);
            return (0, $cwK3t.of)($b6c369d51634b049$var$transformGraphQlIssueRemoteData(remoteDataResponse, issueKey));
        }))), (0, $df9H8.catchError)((err)=>{
        (0, $3A3OQ.trackOrLogClientError)($b6c369d51634b049$var$LOG_LOCATION, 'fetchIssueRemoteData: Failed to fetch issue remote data from gira', err);
        return (0, $3JafE.Observable).empty();
    }));

});
parcelRegister("3ElT9", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_BLOGPOST", () => $5a00b441e09ec27d$export$b0807d3d613e535);
$parcel$export(module.exports, "CONFLUENCE_WHITEBOARD", () => $5a00b441e09ec27d$export$489cb2e515fef0c4);
$parcel$export(module.exports, "toConfluencePageType", () => $5a00b441e09ec27d$export$a7ae1ae0a3d7d205);
const $5a00b441e09ec27d$export$b0807d3d613e535 = 'blogpost';
const $5a00b441e09ec27d$export$353109fb558251b1 = 'page';
const $5a00b441e09ec27d$export$489cb2e515fef0c4 = 'whiteboard';
const $5a00b441e09ec27d$export$a7ae1ae0a3d7d205 = (type)=>type === $5a00b441e09ec27d$export$b0807d3d613e535 ? $5a00b441e09ec27d$export$b0807d3d613e535 : $5a00b441e09ec27d$export$353109fb558251b1;

});

parcelRegister("3A3OQ", function(module, exports) {

$parcel$export(module.exports, "trackOrLogClientError", () => $abf996733b47dc5f$export$2fc29872103bf255);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");
const $abf996733b47dc5f$export$c392d6295c0a29c7 = (location, message, error)=>{
    (0, $guiFP.default)({
        error: error,
        attributes: {
            message: message
        },
        meta: {
            id: location,
            packageName: 'jiraIssueViewCommonUtils'
        }
    });
};
const $abf996733b47dc5f$export$2fc29872103bf255 = (location, message, error)=>{
    if (error instanceof TypeError && (0, $JRB5w.isClientFetchError)(error)) $abf996733b47dc5f$export$c392d6295c0a29c7(location, message, error);
    else (0, $gUUjF.default).safeErrorWithoutCustomerData(location, message, error);
};

});

parcelRegister("l0eyw", function(module, exports) {

$parcel$export(module.exports, "createIssue", () => $97e912da463a0056$export$b61347e00e271b8e);
class $97e912da463a0056$var$IssueBuilder {
    constructor({ key: key }){
        this.key = key;
        this.fields = new Map();
    }
    withMeta(meta) {
        this.meta = meta;
        return this;
    }
    // go/jfe-eslint
    withId(id) {
        this.id = id;
        return this;
    }
    // go/jfe-eslint
    withFields(fields) {
        fields.forEach(this.withField, this);
        return this;
    }
    // go/jfe-eslint
    withField(field) {
        if (field) this.fields.set(String(field.key), field);
        return this;
    }
    // go/jfe-eslint
    withRemoteLinks(remoteLinks) {
        this.remoteLinks = remoteLinks;
        return this;
    }
    // go/jfe-eslint
    withPreferences(myPreferences) {
        this.myPreferences = myPreferences;
        return this;
    }
    // go/jfe-eslint
    withComments(commentsData) {
        this.commentsData = commentsData;
        return this;
    }
    // go/jfe-eslint
    withWorkflow(workflow) {
        this.workflow = workflow;
        return this;
    }
    // go/jfe-eslint
    withActivitySortOrder(activitySortOrder) {
        this.activitySortOrder = activitySortOrder;
        return this;
    }
    build() {
        const meta = this.meta !== null && this.meta !== undefined ? this.meta : {
            dataSource: 'unknown',
            newIssueViewLockedIn: false,
            fetchTime: new Date()
        };
        const remoteLinks = this.remoteLinks !== null && this.remoteLinks !== undefined ? this.remoteLinks : {
            confluencePages: {
                linkedPages: {
                    pageCount: 0
                },
                mentionedPages: {
                    pageCount: 0
                }
            },
            confluenceWhiteboards: {
                linkedWhiteboards: {
                    whiteboardCount: 0
                }
            },
            webLinks: {
                linkCount: 0
            },
            remoteLinkedIssues: []
        };
        const myPreferences = this.myPreferences !== null && this.myPreferences !== undefined ? this.myPreferences : {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let users = {};
        let comments = {
            totalCount: 0,
            startIndex: 0,
            comments: {}
        };
        if (this.commentsData !== null && this.commentsData !== undefined) {
            comments = {
                totalCount: this.commentsData.totalCount,
                // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
                startIndex: this.commentsData.startIndex,
                comments: this.commentsData.comments
            };
            users = this.commentsData.users;
        }
        const workflow = this.workflow !== null && this.workflow !== undefined ? this.workflow : undefined;
        const activitySortOrder = this.activitySortOrder;
        const issue = {
            key: this.key,
            fields: this.fields,
            meta: meta,
            remoteLinks: remoteLinks,
            myPreferences: myPreferences,
            comments: comments,
            users: users,
            workflow: workflow,
            activitySortOrder: activitySortOrder,
            ...this.id !== null && this.id !== undefined ? {
                id: this.id
            } : undefined
        };
        return issue;
    }
}
const $97e912da463a0056$export$b61347e00e271b8e = ({ key: key })=>new $97e912da463a0056$var$IssueBuilder({
        key: key
    });

});

parcelRegister("gNavb", function(module, exports) {

$parcel$export(module.exports, "fetchIssueRemoteData", () => $c265b6b62f0ef502$export$619c3be06a997564);
$parcel$export(module.exports, "fetchIssueConfluenceWhiteboardData", () => $c265b6b62f0ef502$export$886e1cd5d478fbe5);
parcelRequire("jyKN9");
parcelRequire("bI4RP");
parcelRequire("flmol");
parcelRequire("iects");

var $1ybV0 = parcelRequire("1ybV0");

var $aiRd8 = parcelRequire("aiRd8");
parcelRequire("9s86T");
var $6VKiL = parcelRequire("6VKiL");
var $9s86T = parcelRequire("9s86T");

var $5WNEZ = parcelRequire("5WNEZ");

var $fwqh1 = parcelRequire("fwqh1");

var $11LM5 = parcelRequire("11LM5");
const $c265b6b62f0ef502$var$NUM_INITIAL_COMMENTS_TO_LOAD = 5;
const $c265b6b62f0ef502$var$CREATED_ORDER_DESCENDING = '-created';
const $c265b6b62f0ef502$export$94df0e59ebebf4a7 = (baseUrl)=>`${baseUrl}/rest/gira/1/`;
const $c265b6b62f0ef502$var$commentParameter = ()=>{
    const { hasPermalink: hasPermalink, permalinkId: permalinkId } = (0, $9s86T.getPermalinkStatus)((0, $6VKiL.COMMENTS));
    return hasPermalink ? `, commentId: ${permalinkId}` : '';
};
const $c265b6b62f0ef502$var$LOG_LOCATION = 'issue.data-provider.source.issue-express.graphql';
const $c265b6b62f0ef502$var$VIEW_ISSUE_ALIAS = 'bentoViewIssue';
const $c265b6b62f0ef502$var$addQueryForRemoteLinks = ()=>`remoteLinks {
       isLinkingEnabled
       confluencePages {
         linkedPages {
            pageCount
         }
         mentionedPages {
            pageCount
         }
       }
     }`;
const $c265b6b62f0ef502$var$getCommentsQuery = ()=>{
    const commentAmountParameter = `, commentAmount: ${Math.floor($c265b6b62f0ef502$var$NUM_INITIAL_COMMENTS_TO_LOAD / 2)}`;
    const orderByParameter = `, orderBy: "${$c265b6b62f0ef502$var$CREATED_ORDER_DESCENDING}"`;
    const jsdAuthorCanSeeRequest = (0, $1ybV0.ff)('display-outsider-comment-field_4x7u7') ? 'jsdAuthorCanSeeRequest' : '';
    const query = `comments (first: 0, maxResults: ${$c265b6b62f0ef502$var$NUM_INITIAL_COMMENTS_TO_LOAD}${orderByParameter}, isPreview: true ${$c265b6b62f0ef502$var$commentParameter()}${commentAmountParameter}) {
            nodes{
              id
              author {
                  accountId
                  displayName
                  avatarUrl
              }
              updateAuthor {
                  accountId
                  displayName
                  avatarUrl
              }
              visibility {
                  type
                  value
              }
              created
              updated
              jsdPublic
              bodyAdf
              ${jsdAuthorCanSeeRequest}
            }
            totalCount
            startIndex
          }
        `;
    return query;
};
const $c265b6b62f0ef502$export$895cf5b64d42d88d = ()=>`
        issueId
        fields {
            __typename

            ... on ProjectField {
                fieldKey
                type
                simplified
                name
            }

            ... on TextField {
                fieldKey
                title
                isEditable
                textValue
                adf
                renderer
            }

            ... on IssueTypeField {
              fieldKey
              id
              iconUrl
              name
            }

            ... on StatusField {
              fieldKey
              name
              statusCategoryId
            }

            ... on IssueKeyField {
              fieldKey
              stringValue
            }

            ... on PriorityField {
              fieldKey
              title
              isEditable
              iconUrl
              name
              id
            }

            ... on UserField {
              fieldKey
              title
              isEditable
              userValue {
                displayName
                avatarUrl
                accountId
              }
            }

            ... on VersionsField {
              fieldKey
              title
              isEditable
              versions {
                id
                name
              }
            }

            ... on LabelsField {
              fieldKey
              title
              isEditable
              labels
            }

            ... on ProjectComponentsField {
              fieldKey
              title
              isEditable
              componentValues {
                id
                name
              }
            }

            ... on TimeTrackingField {
              fieldKey
              title
              isEditable
              originalEstimate {
                estimateSeconds
              }
              remainingEstimate {
                estimateSeconds
              }
              timeSpent {
                estimateSeconds
              }
            }

            ... on StoryPointsField {
              fieldKey
              title
              isEditable
              floatValue
            }

            ... on EpicLinkField {
              fieldKey
              title
              isEditable
              epic {
                id
                key
                name
                summary
                colorKey
                done
              }
            }

            ... on EpicNameField {
              fieldKey
              stringValue
              title
              isEditable
            }

            ... on EpicStatusField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
              }
            }

            ... on SprintCustomField {
              fieldKey
              title
              isEditable
              values {
                id
                name
                goal
                state
                boardId
                startDate
                endDate
                completeDate
              }
            }

            ... on SelectCustomField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
              }
            }

            ... on CascadingSelectCustomField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
                  child {
                    optionId
                    value
                  }
              }
            }

            ... on UserPickerCustomField {
              fieldKey
              title
              isEditable
              selectedUser {
                displayName
                avatarUrl
              }
            }

            ... on TextAreaCustomField {
              fieldKey
              title
              isEditable
              wiki
              adf
              renderer
              textValue
            }

            ... on FloatCustomField {
              fieldKey
              title
              isEditable
              floatValue
            }

            ... on DatePickerCustomField {
              fieldKey
              title
              isEditable
              stringValue
            }

            ... on DateTimeCustomField {
              fieldKey
              title
              isEditable
              dateTime
            }

            ... on TextFieldCustomField {
              fieldKey
              title
              isEditable
              wiki
            }

            ... on MultiSelectCustomField {
              fieldKey
              title
              isEditable
              selectedValues {
                  optionId
                  value
              }
            }

            ... on LabelsCustomField {
              fieldKey
              title
              isEditable
              labels
            }

            ... on MultiUserPickerCustomField {
              fieldKey
              title
              isEditable
              selectedUsers {
                accountId
                displayName
                avatarUrl
              }
            }

            ... on UrlCustomField {
              fieldKey
              title
              isEditable
              url
            }

            ... on VersionCustomField {
              fieldKey
              title
              isEditable
              version {
                  id
                  name
              }
            }

            ... on GroupPickerCustomField {
              fieldKey
              title
              isEditable
              group
            }

            ... on MultiVersionCustomField {
              fieldKey
              title
              isEditable
              versions {
                  id
                  name
              }
            }

            ... on MultiGroupPickerCustomField {
              fieldKey
              title
              isEditable
              groups
            }

            ... on DateField {
              fieldKey
              stringValue
              isEditable
              title
            }

            ... on CheckBoxesCustomField {
                fieldKey
                isEditable
                title
                selectedValues {
                    optionId
                    value
                }
            }

            ... on RadioButtonsCustomField {
                fieldKey
                isEditable
                title
                selectedValue {
                    optionId
                    value
                }
            }

            ... on ColorField {
                fieldKey
                isEditable
                title
                stringValue
            }

            ... on EpicColorField {
                fieldKey
                isEditable
                title
                stringValue
            }

            ... on ResolutionField {
                id
                fieldKey
                name
            }

            ... on FlaggedCustomField {
                fieldKey
                title
                isFlagged
                isEditable
                selectedValues {
                    optionId
                    value
                }
            }

            ... on ProjectCustomField {
              fieldKey
              key
              name
              title
              avatarUrl
              isEditable
            }
        }
        ${$c265b6b62f0ef502$var$addQueryForRemoteLinks()}
        ${$c265b6b62f0ef502$var$getCommentsQuery()}
    `;
const $c265b6b62f0ef502$var$getQueryPrefix = ()=>'_all';
const $c265b6b62f0ef502$var$getFieldPinningPreference = (projectKey)=>projectKey != null ? `"jira.user.issue.details.pinned-fields.${projectKey}",` : '';
const $c265b6b62f0ef502$var$getQueryForMyPreferences = (projectKey)=>`
    myPreferences(keys: [
        "jira.user.issue.changeboarding.lastinteracted",
        "jira.user.issue.clickthrough-banner.lastinteracted",
        "jira.user.issue.pinned-fields-banner.lastinteracted",
        ${$c265b6b62f0ef502$var$getFieldPinningPreference(projectKey)}
    ])`;
const $c265b6b62f0ef502$var$getProjectQueryFragment = (projectKey)=>`
    project(projectKey: "${projectKey}") {
        newIssueViewLockedIn
    }
`;
const $c265b6b62f0ef502$export$71eec30d9db46a56 = (projectKey)=>`query issueViewQuery($issueKey: String!) {
    ${$c265b6b62f0ef502$var$getQueryForMyPreferences(projectKey)}
    ${projectKey !== undefined ? $c265b6b62f0ef502$var$getProjectQueryFragment(projectKey) : ''}
    ${$c265b6b62f0ef502$var$VIEW_ISSUE_ALIAS}${$c265b6b62f0ef502$var$getQueryPrefix()}: viewIssue(issueKey: $issueKey) {
        ${$c265b6b62f0ef502$export$895cf5b64d42d88d()}
    }
    activitySortOrder
}
`;
const $c265b6b62f0ef502$var$getFieldDataOptions = (query, variables)=>({
        method: 'POST',
        body: JSON.stringify({
            query: query,
            variables: variables
        }),
        perf: (0, $5WNEZ.fetchIssueExpressPerf)
    });
const $c265b6b62f0ef502$export$619c3be06a997564 = (baseUrl, issueKey)=>(0, $aiRd8.default)($c265b6b62f0ef502$export$94df0e59ebebf4a7(baseUrl), $c265b6b62f0ef502$var$getFieldDataOptions((0, $fwqh1.getIssueRemoteDataQuery)(), {
        issueKey: issueKey
    }))// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GraphqlResponse<ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>'.
    .map((response)=>(0, $11LM5.getGraphQlData)($c265b6b62f0ef502$var$LOG_LOCATION, response))// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '`bentoViewIssue${string}`' can't be used to index type 'ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse'.
    .map((value)=>value[`${$c265b6b62f0ef502$var$VIEW_ISSUE_ALIAS}${(0, $fwqh1.getRemoteDataQueryPrefix)()}`]);
const $c265b6b62f0ef502$export$886e1cd5d478fbe5 = (issueId, cloudId)=>(0, $aiRd8.default)('/gateway/api/graphql?operation=issueViewRemoteConfluenceWhiteboardQuery', $c265b6b62f0ef502$var$getFieldDataOptions((0, $fwqh1.getIssueRemoteConfluenceWhiteboardQuery)(), {
        id: `ari:cloud:jira:${cloudId}:issue/${issueId}`
    })).map((response)=>(0, $11LM5.getGraphQlData)($c265b6b62f0ef502$var$LOG_LOCATION, response));

});
parcelRegister("aiRd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6464cf3e92eca984$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("8OtG5");
parcelRequire("flmol");
parcelRequire("iects");

var $fVqUX = parcelRequire("fVqUX");

var $6iz4v = parcelRequire("6iz4v");

var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $etaBp = parcelRequire("etaBp");
const $6464cf3e92eca984$var$noContentStatus = 204;
const $6464cf3e92eca984$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $6464cf3e92eca984$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$6464cf3e92eca984$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $6iz4v.setMark)(`BEGIN_${key}`);
    }
    return (0, $3JafE.Observable).of(url).mergeMap(()=>fetch(url, (0, $6HC1D.merge)((0, $6HC1D.merge)((0, $fVqUX.default), opts), (0, $etaBp.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $6iz4v.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, str, traceId);
                else throw new (0, $7byHA.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $6464cf3e92eca984$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $3JafE.Observable).of(null);
        return response.json();
    });
}
var $6464cf3e92eca984$export$2e2bcd8739ae039 = $6464cf3e92eca984$var$fetchJson$;

});

parcelRegister("5WNEZ", function(module, exports) {

$parcel$export(module.exports, "fetchIssueExpressPerf", () => $9e9290dca99e7c55$export$9040f8aef1f66451);
const $9e9290dca99e7c55$var$ISSUE_DETAILS_ANALYTICS_PREFIX = 'ISSUE_DETAILS';
const $9e9290dca99e7c55$var$FETCH_ISSUE_EXPRESS_REQUEST = 'FETCH_ISSUE_EXPRESS';
const $9e9290dca99e7c55$export$9040f8aef1f66451 = {
    key: $9e9290dca99e7c55$var$FETCH_ISSUE_EXPRESS_REQUEST,
    prefix: $9e9290dca99e7c55$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};

});

parcelRegister("fwqh1", function(module, exports) {

$parcel$export(module.exports, "getRemoteDataQueryPrefix", () => $2acde4462d7c1f98$export$1a164444721ce2fb);
$parcel$export(module.exports, "getIssueRemoteDataQuery", () => $2acde4462d7c1f98$export$65f9808f978ee25);
$parcel$export(module.exports, "getIssueRemoteConfluenceWhiteboardQuery", () => $2acde4462d7c1f98$export$8ec691b48e552cf4);
const $2acde4462d7c1f98$var$VIEW_ISSUE_ALIAS = 'bentoViewIssue';
const $2acde4462d7c1f98$var$getUserQueryFragment = ()=>`
    user {
        key
        accountId
        emailAddress
        avatarUrl
        displayName
        active
    }
`;
const $2acde4462d7c1f98$var$getConfluencePagesQueryFragment = ()=>`
    pages {
        ... on ConfluencePage {
            id
            globalId
            href
            title
            type
            lastUpdatedContext {
                ${$2acde4462d7c1f98$var$getUserQueryFragment()}
            }
        }
        ... on FailedRemoteLink {
            id
            error
            link {
                id
                globalId
                href
            }
            repairLink { href }
        }
    }
`;
const $2acde4462d7c1f98$var$getConfluencePageGroupQueryFragment = ()=>`
    pageCount
    ${$2acde4462d7c1f98$var$getConfluencePagesQueryFragment()}
`;
const $2acde4462d7c1f98$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
const $2acde4462d7c1f98$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
const $2acde4462d7c1f98$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$2acde4462d7c1f98$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
const $2acde4462d7c1f98$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$2acde4462d7c1f98$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$2acde4462d7c1f98$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
const $2acde4462d7c1f98$export$761fd517f0dda983 = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
const $2acde4462d7c1f98$var$getRemoteDataQueryFragment = ()=>`
    issueId
    remoteLinks {
       isLinkingEnabled
       confluencePages {
            linkedPages {
                ${$2acde4462d7c1f98$var$getConfluencePageGroupQueryFragment()}
            }
            mentionedPages {
                ${$2acde4462d7c1f98$var$getConfluencePageGroupQueryFragment()}
            }
        }
        ${$2acde4462d7c1f98$export$761fd517f0dda983()}
        ${$2acde4462d7c1f98$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $2acde4462d7c1f98$export$1a164444721ce2fb = ()=>'_remote_data';
const $2acde4462d7c1f98$export$65f9808f978ee25 = ()=>`
    query issueViewRemoteDataQuery($issueKey: String!) {
        ${$2acde4462d7c1f98$var$VIEW_ISSUE_ALIAS}${$2acde4462d7c1f98$export$1a164444721ce2fb()}: viewIssue(issueKey: $issueKey) {
            ${$2acde4462d7c1f98$var$getRemoteDataQueryFragment()}
        }
    }
`;
const $2acde4462d7c1f98$export$8ec691b48e552cf4 = ()=>`
    query issueViewRemoteConfluenceWhiteboardQuery($id: ID!) {
        graphStore @optIn(to: "GraphStore") {
            issueToWhiteboard (id: $id first: 900) @optIn(to: "GraphStoreIssueToWhiteboard") {
                edges {
                    node {
                        ... on ConfluenceWhiteboard {
                            id
                            links {
                                base
                                webUi
                            }
                            author {
                                user {
                                accountId
                                accountStatus
                                name
                                picture
                                }
                            }
                            title
                            whiteboardId
                        }
                    }
                }
                totalCount
            }
        }
    }
`;

});

parcelRegister("11LM5", function(module, exports) {

$parcel$export(module.exports, "getGraphQlData", () => $c6aa0580bc22e808$export$b30cdd26702abb9d);
$parcel$export(module.exports, "checkEmptyResponse", () => $c6aa0580bc22e808$export$a0603b0ff181c30a);

var $gUUjF = parcelRequire("gUUjF");

var $7byHA = parcelRequire("7byHA");

var $l3WD8 = parcelRequire("l3WD8");
const $c6aa0580bc22e808$export$b30cdd26702abb9d = (logLocation, graphQlResponse)=>{
    if (graphQlResponse.errors) {
        const firstError = graphQlResponse.errors[0];
        const validationError = new (0, $7byHA.ValidationError)(firstError.message);
        (0, $gUUjF.default).safeErrorWithoutCustomerData(logLocation, 'getGraphQlData: Error present in GraphQL response', validationError);
        throw validationError;
    }
    return graphQlResponse.data;
};
const $c6aa0580bc22e808$var$emptyResponseText = 'Response is either not present or has no data.';
const $c6aa0580bc22e808$export$a0603b0ff181c30a = (response)=>{
    if (!response || !Object.prototype.hasOwnProperty.call(response, 'data')) throw new (0, $l3WD8.NoDataError)($c6aa0580bc22e808$var$emptyResponseText);
    if (response.data === null) throw new (0, $l3WD8.NoDataError)($c6aa0580bc22e808$var$emptyResponseText);
    return response;
};

});
parcelRegister("l3WD8", function(module, exports) {

$parcel$export(module.exports, "NoDataError", () => $001694e1095e542c$export$5faf0a0592e30f56);
class $001694e1095e542c$export$5faf0a0592e30f56 extends Error {
}

});



const $330b0f1977bf0938$export$40bed7a29c3b629 = 'IssueKeyField';





parcelRegister("j0h3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fc0033709cd49a3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $78d1w = parcelRequire("78d1w");
function $1fc0033709cd49a3$export$2e2bcd8739ae039(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78d1w.default), null, (spaTransitionsState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                isInitialRender: spaTransitionsState.isInitialRender
            }));
}

});
parcelRegister("78d1w", function(module, exports) {

$parcel$export(module.exports, "useSpaStateTransition", () => $7f5c686fb18f00a1$export$4d1974344641a2c9);
$parcel$export(module.exports, "default", () => $7f5c686fb18f00a1$export$2e2bcd8739ae039);

var $ggKAj = parcelRequire("ggKAj");
var $dYfll = parcelRequire("dYfll");

var $8uNQc = parcelRequire("8uNQc");

var $cfLkw = parcelRequire("cfLkw");
const $7f5c686fb18f00a1$var$getNavigationStart = ()=>{
    // @ts-expect-error - TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'. | TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    const timestamp = (0, $8uNQc.default) && (0, $8uNQc.default).timing && (0, $8uNQc.default).timing.navigationStart;
    return timestamp ? new Date(timestamp).toISOString() : undefined;
};
const $7f5c686fb18f00a1$var$getLastTransition = (currentPage, visitedPages)=>{
    if (visitedPages.length === 0) return undefined;
    const collectAppNames = (page)=>Object.keys(page.apps || {}).sort();
    const appNamesToStr = (appNames)=>appNames.join('+') || '?';
    const prevPage = appNamesToStr(collectAppNames(visitedPages.slice(-1)[0]));
    const currPage = appNamesToStr(collectAppNames(currentPage));
    return `${prevPage} > ${currPage}`;
};
const $7f5c686fb18f00a1$var$getLastTransitionStartTime = (currentPage, visitedPages)=>{
    // If there are no previously visited pages the transition didn't have a place
    if (visitedPages.length === 0) return undefined;
    return currentPage.startTime;
};
const $7f5c686fb18f00a1$export$aea217a45095ce11 = ({ visitedPages: visitedPages, currentPage: currentPage })=>({
        isInitialRender: visitedPages.length === 0,
        transitionsCount: visitedPages.length,
        lastTransition: $7f5c686fb18f00a1$var$getLastTransition(currentPage, visitedPages),
        lastTransitionStartTime: $7f5c686fb18f00a1$var$getLastTransitionStartTime(currentPage, visitedPages),
        navigationStart: $7f5c686fb18f00a1$var$getNavigationStart(),
        currentPageId: currentPage.uuid
    });
// @ts-expect-error - TS2322 - Type 'SubscriberComponent<TransitionState, BoundActions<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/controllers/spa-state/src/actions/index")>, Record<...>>' is not assignable to type 'Subscriber'.
const $7f5c686fb18f00a1$var$SpaStateTransitionStateSubscriber = (0, $dYfll.createSubscriber)((0, $cfLkw.default), {
    displayName: 'SpaStateTransitionStateSubscriber',
    selector: $7f5c686fb18f00a1$export$aea217a45095ce11
});
const $7f5c686fb18f00a1$export$4d1974344641a2c9 = (0, $ggKAj.createHook)((0, $cfLkw.default), {
    selector: $7f5c686fb18f00a1$export$aea217a45095ce11
});
var $7f5c686fb18f00a1$export$2e2bcd8739ae039 = $7f5c686fb18f00a1$var$SpaStateTransitionStateSubscriber;

});


parcelRegister("6gFlc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2039930b7628717$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $izgHs = parcelRequire("izgHs");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$b2039930b7628717$export$2e2bcd8739ae039 = ()=>(WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any
        class WithMetricsProvider extends (0, $eUqFw.Component) {
            static{
                this.displayName = `WithMetricsProvider(${WrappedComponent.displayName || WrappedComponent.name})`;
            }
            render() {
                const { MetricsContext: MetricsContext } = this;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MetricsContext.Provider, {
                    value: (0, $izgHs.createMetrics)(this.props.metrics)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, this.props));
            }
            constructor(...args){
                super(...args);
                this.MetricsContext = (0, $izgHs.createMetricsContext)(this.props.metrics);
            }
        };

});
parcelRegister("izgHs", function(module, exports) {

$parcel$export(module.exports, "createMetrics", () => $94e34d4749024c08$export$28fffb59f4e08b9c);
$parcel$export(module.exports, "createMetricsContext", () => $94e34d4749024c08$export$2618688901defbd2);
$parcel$export(module.exports, "getMetricsContext", () => $94e34d4749024c08$export$1afed3d5e71957fb);

var $eUqFw = parcelRequire("eUqFw");

var $jc4kK = parcelRequire("jc4kK");
const $94e34d4749024c08$var$createOnPreviewRendered = (metrics)=>(args)=>{
        if (metrics && metrics.onReadyForUser) metrics.onReadyForUser();
        const { isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime } = args;
        if (isInitialRender) (0, $jc4kK.setIsInitialRender)(true);
        (0, $jc4kK.markIssuePreviewRendered)({
            isInitialRender: isInitialRender,
            lastTransitionStartTime: lastTransitionStartTime
        });
    };
const $94e34d4749024c08$var$createOnInteractive = (metrics)=>(args)=>{
        if (metrics && metrics.onInteractive) metrics.onInteractive();
        (0, $jc4kK.markIssueInteractive)(args);
    };
const $94e34d4749024c08$var$createOnPageLoadEvent = (metrics)=>()=>{
        if (metrics && metrics.onMarkIssueOnPageLoadEvent) metrics.onMarkIssueOnPageLoadEvent();
        (0, $jc4kK.markIssueOnPageLoadEvent)();
    };
const $94e34d4749024c08$export$28fffb59f4e08b9c = (metrics)=>({
        onPreviewRendered: $94e34d4749024c08$var$createOnPreviewRendered(metrics),
        onInteractive: $94e34d4749024c08$var$createOnInteractive(metrics),
        onMarkIssueOnPageLoadEvent: $94e34d4749024c08$var$createOnPageLoadEvent(metrics)
    });
/**
 * The Atlaskit modal dialog component (as of version 3.x) renders into a
 * custom portal implementation and does not pass the React context to the
 * header/footer/children.
 *
 * Until the component moves to using React native portals, we are waiting
 * to create the metrics context until we are given the MetricsCallbacks
 * object, and storing it as the contexts default value.
 *
 * In future we should be able to replace the create/get context methods
 * below with {export const MetricsContext = createContext();}.
 *
 * See: https://jdog.jira-dev.com/browse/BENTO-1069
 */ let $94e34d4749024c08$var$MetricsContext;
const $94e34d4749024c08$export$2618688901defbd2 = (metrics)=>{
    $94e34d4749024c08$var$MetricsContext = /*#__PURE__*/ (0, $eUqFw.createContext)($94e34d4749024c08$export$28fffb59f4e08b9c(metrics));
    return $94e34d4749024c08$var$MetricsContext;
};
const $94e34d4749024c08$export$1afed3d5e71957fb = ()=>$94e34d4749024c08$var$MetricsContext || /*#__PURE__*/ (0, $eUqFw.createContext)($94e34d4749024c08$export$28fffb59f4e08b9c());

});


parcelRegister("ly1CP", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd8a489ec3cebdf4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgWZr = parcelRequire("lgWZr");

var $8xcmb = parcelRequire("8xcmb");

var $4B7EY = parcelRequire("4B7EY");

var $plbOU = parcelRequire("plbOU");

var $1ybV0 = parcelRequire("1ybV0");

var $kUI0A = parcelRequire("kUI0A");

var $hJ992 = parcelRequire("hJ992");

var $k9hJ7 = parcelRequire("k9hJ7");
var $8411R = parcelRequire("8411R");
var $kmr29 = parcelRequire("kmr29");

var $K1Vl8 = parcelRequire("K1Vl8");

var $dMD2I = parcelRequire("dMD2I");

var $6D0iK = parcelRequire("6D0iK");

var $gd8Po = parcelRequire("gd8Po");

var $eyYNo = parcelRequire("eyYNo");

var $4c7sd = parcelRequire("4c7sd");

var $i9pAn = parcelRequire("i9pAn");

var $eJYCK = parcelRequire("eJYCK");

var $6nYhF = parcelRequire("6nYhF");

var $2V7AK = parcelRequire("2V7AK");

var $8p8vy = parcelRequire("8p8vy");

var $2Sajo = parcelRequire("2Sajo");

var $lhz9J = parcelRequire("lhz9J");

var $fCyzk = parcelRequire("fCyzk");

var $lqalZ = parcelRequire("lqalZ");

var $l1qlm = parcelRequire("l1qlm");

var $hHnBv = parcelRequire("hHnBv");

var $ePSh2 = parcelRequire("ePSh2");

var $l129t = parcelRequire("l129t");

var $fYteL = parcelRequire("fYteL");

var $jZDJX = parcelRequire("jZDJX");

var $1DnzP = parcelRequire("1DnzP");
var $iibQj = parcelRequire("iibQj");

var $10fdS = parcelRequire("10fdS");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");

var $7JlQ7 = parcelRequire("7JlQ7");

var $ln3W8 = parcelRequire("ln3W8");

var $jD3pk = parcelRequire("jD3pk");

var $6bhHe = parcelRequire("6bhHe");

var $dWlsy = parcelRequire("dWlsy");

var $gd0Sp = parcelRequire("gd0Sp");

var $8rc7e = parcelRequire("8rc7e");

var $linOi = parcelRequire("linOi");

var $jc4kK = parcelRequire("jc4kK");

var $hT6LY = parcelRequire("hT6LY");

var $6aweD = parcelRequire("6aweD");

var $lgxUt = parcelRequire("lgxUt");

var $lyLlZ = parcelRequire("lyLlZ");

var $OTMDz = parcelRequire("OTMDz");
const $dd8a489ec3cebdf4$var$ConditionalCrossFlowProvider = ({ children: children, isModal: isModal })=>!isModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $plbOU.CrossFlowProvider), null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
// used to feature flag sweet-state containers
const $dd8a489ec3cebdf4$var$EmptyContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
// TODO Cleanup with JIV-14818
const $dd8a489ec3cebdf4$var$ReduxErrorListenerInnerContent = (props)=>{
    const { error: error, errorMessage: errorMessage } = props;
    if (error) {
        const errorWithMetadata = new Error(error);
        errorWithMetadata.errorAttributes = errorMessage;
        throw errorWithMetadata;
    }
    return null;
};
const $dd8a489ec3cebdf4$var$ReduxErrorListener = (0, $lqalZ.connect)((state)=>({
        error: (0, $jZDJX.errorSelector)(state),
        errorMessage: (0, $jZDJX.errorMessageSelector)(state)
    }), {})($dd8a489ec3cebdf4$var$ReduxErrorListenerInnerContent);
const $dd8a489ec3cebdf4$var$AppProvider = (props)=>{
    const { analyticsSource: analyticsSource, backButtonUrl: backButtonUrl, boardId: boardId, boardType: boardType, dispatchExternalActionRef: dispatchExternalActionRef, estimationStatistic: estimationStatistic, isLoadedWithPage: isLoadedWithPage, isModal: isModal, issueKey: issueKey, isSpaEnabled: isSpaEnabled, loginRedirectUrl: loginRedirectUrl, rapidViewId: rapidViewId, rapidViewMap: rapidViewMap, viewMode: viewMode, children: children, onIssueKeyChange: onIssueKeyChange } = props;
    const { prefetchedResourceManager: prefetchedResourceManager, issueAggQueryData: issueAggQueryData } = props;
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const dataProvider = (0, $7JlQ7.getDataProvider)();
    const route = (0, $10fdS.useCurrentRoute)();
    const subProduct = (0, $dWlsy.useSubProduct)();
    const [, recentIssuesActions] = (0, $l1qlm.useRecentIssueActions)();
    const [, fieldsConfigActions] = (0, $8411R.useFieldConfigActions)();
    const [, issueRefreshServiceActions] = (0, $eyYNo.useIssueRefreshServiceActions)();
    const [, fieldsValueActions] = (0, $kmr29.useFieldsValuesActions)();
    const issueRefreshLoadingActionsRef = (0, $OTMDz.useScopedStoreActions)((0, $k9hJ7.useIssueRefreshLoadingActions));
    const [, issueViewNonCriticalDataActions] = (0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? (0, $6D0iK.default)(issueKey, prefetchedResourceManager) : [
        {},
        undefined
    ];
    const [, userPreferenceActions] = (0, $i9pAn.useUserPreferencesActions)();
    const [, attachmentActions] = (0, $kUI0A.useIssueAttachmentsActions)();
    const [, issueScrollActions] = (0, $4c7sd.useIssueScrollActions)();
    const [, permissionActions] = (0, $5YYzL.useProjectPermissionsActions)();
    const [, mediaContextActions] = (0, $dMD2I.useMediaContextActions)();
    const [, issueContextActions] = (0, $hJ992.useIssueContextActions)();
    const [, issueViewLayoutActions] = (0, $fCyzk.useIssueLayoutActions)();
    const [, forgeActions] = (0, $2Sajo.useForgeActions)();
    const [, ecosystemActions] = (0, $2V7AK.useEcosystemActions)();
    const [, jiraSettingsActions] = (0, $6bhHe.useJiraSettingsActions)();
    const [, projectContextActions] = (0, $guDlK.useProjectContextActions)();
    const [, workflowTransitionsActions] = (0, $1DnzP.useWorkflowTransitionsActions)();
    const associatedIssuesContextActions = (0, $lgWZr.useAssociatedIssuesContextActions)();
    const [, issueViewFieldUpdateActions] = (0, $8p8vy.useIssueViewFieldUpdateEvents)();
    const { registerEventHandler: registerEventHandler } = issueViewFieldUpdateActions;
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    (0, $eUqFw.useEffect)(()=>{
        const unregister = registerEventHandler('onChange', props.onChange);
        return ()=>unregister();
    }, [
        props.onChange,
        registerEventHandler
    ]);
    const store = (0, $eUqFw.useMemo)(()=>(0, $OTMDz.getStore)(props, tenantContext, subProduct, dataProvider, recentIssuesActions, issueRefreshServiceActions, fieldsValueActions, fieldsConfigActions, issueViewLayoutActions, issueViewFieldUpdateActions, forgeActions, ecosystemActions, userPreferenceActions, prefetchedResourceManager, attachmentActions, issueScrollActions, permissionActions, jiraSettingsActions, projectContextActions, issueContextActions, workflowTransitionsActions, orgId, mediaContextActions, issueRefreshLoadingActionsRef, associatedIssuesContextActions, issueViewNonCriticalDataActions), // We only need to create the store once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $OTMDz.useSweetStateToReduxSynchronization)(store);
    const { setStore: setStore } = (0, $6nYhF.useStoreActionsForIssueViewShortcutActions_DO_NOT_USE)();
    (0, $eUqFw.useEffect)(()=>{
        setStore(store);
        return ()=>{
            setStore(null);
        };
    }, [
        store,
        setStore
    ]);
    const dispatchExternalAction = (0, $eUqFw.useCallback)((action)=>{
        const triggeredAction = (0, $l129t.transformExternalAction)(action);
        store.dispatch(triggeredAction);
    }, [
        store
    ]);
    (0, $eUqFw.useMemo)(()=>{
        (0, $OTMDz.setup)(props, tenantContext, dataProvider, store, recentIssuesActions, fieldsValueActions, fieldsConfigActions, userPreferenceActions, prefetchedResourceManager, dispatchExternalAction, attachmentActions, issueContextActions, permissionActions, route, issueViewLayoutActions, forgeActions, ecosystemActions, jiraSettingsActions, projectContextActions, orgId, associatedIssuesContextActions);
    // Equivalent to the constructor
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>()=>{
            // clear UI store state
            store.dispatch((0, $hHnBv.resetQuickAddClickedCount)());
            const state = store.getState();
            if (state.ui.loadingStage === 'COMPLETE') recentIssuesActions.setRecentIssue(issueKey, state);
        }, [
        issueKey,
        recentIssuesActions,
        store
    ]);
    const isFirstRun = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>{
        if (!isFirstRun.current) {
            store.dispatch((0, $ePSh2.setContext)((0, $OTMDz.getContext)(props, tenantContext, orgId)));
            issueContextActions.setIssueContext((0, $OTMDz.getIssueContext)(props));
        }
    // There is no need of setting the context on the first run
    // We are explicitly listing which props should cause setContext to be re-dispatched
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        backButtonUrl,
        issueKey,
        loginRedirectUrl,
        rapidViewId,
        boardType,
        boardId,
        isLoadedWithPage,
        isModal,
        rapidViewMap,
        estimationStatistic,
        analyticsSource,
        viewMode,
        orgId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Refresh the issue in the background for recent issues
        if (!isFirstRun.current) {
            const recentIssue = recentIssuesActions.getRecentIssue(props.issueKey);
            if (recentIssue) store.dispatch((0, $fYteL.refreshIssueRequest)());
        }
        isFirstRun.current = false;
        return ()=>{
            // When switching issueKeys, cancel any prior refreshRequests.
            // Previously, switchMap handled race conditions by cancelling the last observable.
            // However, with the introduction of throttleTime, this behavior has changed.
            // Therefore, we must manually cancel observables scheduled on the previous issue view.
            store.dispatch((0, $fYteL.cancelRefreshIssueRequest)());
        };
    }, [
        props.issueKey,
        recentIssuesActions,
        store
    ]);
    (0, $eUqFw.useEffect)(// componentWillUnmount
    ()=>()=>{
            if (isSpaEnabled === false || isSpaEnabled === null || isSpaEnabled === undefined) // we put a setTimeout here as it allows any other unmount actions
            // to be called and to take effect to cleanup after themselves
            setTimeout(()=>store.dispatch((0, $4B7EY.DISPOSE_ACTION)));
            if (dispatchExternalActionRef) dispatchExternalActionRef(null);
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $lgxUt.useIssueKeyMismatchListener)({
        issueKeyFromProps: issueKey,
        issueKeyFromData: issueAggQueryData?.jira?.issueByKey?.key,
        onIssueKeyChange: onIssueKeyChange
    });
    (0, $jc4kK.markIssueStartRendering)();
    const childrenOrCallChildrenFunction = typeof children === 'function' ? children(issueAggQueryData?.jira?.issueByKey ?? null) : children;
    const core = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd8Po.OnboardingTourContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lyLlZ.CombineStateContainers), {
        scope: issueKey,
        containers: [
            (0, $linOi.WorklogTimeTrackingContainer),
            (0, $8rc7e.UiModificationsContainer),
            (0, $K1Vl8.IssueFieldEditingContextProvider)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd8a489ec3cebdf4$var$ConditionalCrossFlowProvider, {
        isModal: isModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJYCK.default), {
        store: store,
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6aweD.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hT6LY.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd8a489ec3cebdf4$var$ReduxErrorListener, null), childrenOrCallChildrenFunction)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lhz9J.IssueKeyboardShortcutsContainer), null, core);
};
const $dd8a489ec3cebdf4$var$ScopedAppProvider = (props)=>{
    // In order to override the relay environment in storybook
    // we need to make it injectable.
    // We probably should use the useEnvironment() hook instead.
    // Not doing it now as it would be a change to production code that would
    // likely need a feature flag.
    // https://jdog.jira-dev.com/browse/BENTO-11548
    // TODO: apply isolation when impact known https://jplat.atlassian.net/browse/JIV-14663
    // const MaybeStateContainer = IssueStateContainers()
    const MaybeStateContainer = $dd8a489ec3cebdf4$var$EmptyContainer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iibQj.WorkflowTransitionsStoreContainer), {
        scope: props.issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ln3W8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8xcmb.ClipboardContextBoundaryContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k9hJ7.IssueRefreshLoadingContainer), {
        scope: props.issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MaybeStateContainer, {
        scope: props.issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd8a489ec3cebdf4$var$AppProvider, props))))));
};
var $dd8a489ec3cebdf4$export$2e2bcd8739ae039 = $dd8a489ec3cebdf4$var$ScopedAppProvider;

});
parcelRegister("lgWZr", function(module, exports) {

$parcel$export(module.exports, "useLocalAssociatedIssuesContext", () => $fa88c3dcfefe442d$export$68bec1a7ed8a03bf);
$parcel$export(module.exports, "useRemoteAssociatedIssuesContext", () => $fa88c3dcfefe442d$export$5d96b267f76c8163);
$parcel$export(module.exports, "AssociatedIssuesContextContainer", () => $fa88c3dcfefe442d$export$d2018738efa1fe03);
$parcel$export(module.exports, "useAssociatedIssuesContextActions", () => $fa88c3dcfefe442d$export$dd949b6ba73065f3);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $GNh62 = parcelRequire("GNh62");
const $fa88c3dcfefe442d$export$d4c72bab9d6cc13a = {
    localIssues: {},
    remoteIssues: {}
};
const $fa88c3dcfefe442d$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'associated-issues-context-service',
    initialState: $fa88c3dcfefe442d$export$d4c72bab9d6cc13a,
    actions: $GNh62.actions
});
const $fa88c3dcfefe442d$var$getLocalAssociatedIssuesContext = (state)=>state.localIssues;
const $fa88c3dcfefe442d$var$getRemoteAssociatedIssuesContext = (state)=>state.remoteIssues;
const $fa88c3dcfefe442d$export$68bec1a7ed8a03bf = (0, $ggKAj.createHook)($fa88c3dcfefe442d$export$6f57813fe9f31bf9, {
    selector: $fa88c3dcfefe442d$var$getLocalAssociatedIssuesContext
});
const $fa88c3dcfefe442d$export$5d96b267f76c8163 = (0, $ggKAj.createHook)($fa88c3dcfefe442d$export$6f57813fe9f31bf9, {
    selector: $fa88c3dcfefe442d$var$getRemoteAssociatedIssuesContext
});
const $fa88c3dcfefe442d$export$d2018738efa1fe03 = (0, $heB5U.createContainer)($fa88c3dcfefe442d$export$6f57813fe9f31bf9);
const $fa88c3dcfefe442d$export$dd949b6ba73065f3 = (0, $ggKAj.createActionsHook)($fa88c3dcfefe442d$export$6f57813fe9f31bf9);

});
parcelRegister("GNh62", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5c54ddce71d3f525$export$e324594224ef24da);
const $5c54ddce71d3f525$export$791b1899bbec2e5b = (associatedIssuesContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            localIssues: {
                ...currentState.localIssues,
                ...associatedIssuesContext
            }
        });
    };
const $5c54ddce71d3f525$export$89a3e5333d9c9406 = (associatedIssuesContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            remoteIssues: {
                ...currentState.remoteIssues,
                ...associatedIssuesContext
            }
        });
    };
const $5c54ddce71d3f525$export$36d8fef378c35f57 = (issueKey, associatedIssueContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            localIssues: {
                ...currentState.localIssues,
                [issueKey]: {
                    ...currentState?.localIssues?.[issueKey],
                    ...associatedIssueContext
                }
            }
        });
    };
const $5c54ddce71d3f525$export$af15f23ea674ffd1 = (issueKey, associatedIssueContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            remoteIssues: {
                ...currentState.remoteIssues,
                [issueKey]: {
                    ...currentState?.remoteIssues?.[issueKey],
                    ...associatedIssueContext
                }
            }
        });
    };
const $5c54ddce71d3f525$export$e324594224ef24da = {
    mergeLocalAssociatedIssuesContext: $5c54ddce71d3f525$export$791b1899bbec2e5b,
    mergeRemoteAssociatedIssuesContext: $5c54ddce71d3f525$export$89a3e5333d9c9406,
    mergeSingleLocalAssociatedIssueContext: $5c54ddce71d3f525$export$36d8fef378c35f57,
    mergeSingleRemoteAssociatedIssueContext: $5c54ddce71d3f525$export$af15f23ea674ffd1
};

});


parcelRegister("8xcmb", function(module, exports) {

$parcel$export(module.exports, "ClipboardContextBoundaryContainer", () => $aa4cd8d0d241df51$export$fd0a7836bfa6a893);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7wp7z = parcelRequire("7wp7z");
const $aa4cd8d0d241df51$var$invisibleDivStyles = null;
const $aa4cd8d0d241df51$var$ClipboardContextBoundaryProvider = ({ children: children })=>{
    const { setClipBoardContext: setClipBoardContext } = (0, $7wp7z.useClipboardContextActions)();
    const setRef = (0, $eUqFw.useCallback)((node)=>{
        setClipBoardContext(node);
    }, [
        setClipBoardContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: setRef,
        "data-testid": "clipboard.controllers.boundary.clipboard-boundary",
        className: (0, $7JEyt.default)([
            "_1e0c1bgi _4t3i1kw7 _1bsb1kw7"
        ])
    }, children);
};
const $aa4cd8d0d241df51$export$fd0a7836bfa6a893 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7wp7z.ClipboardStoreContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa4cd8d0d241df51$var$ClipboardContextBoundaryProvider, null, children));
const $aa4cd8d0d241df51$var$ClipboardContainerSetEffector = ({ container: container })=>{
    const { setClipBoardContext: setClipBoardContext } = (0, $7wp7z.useClipboardContextActions)();
    (0, $eUqFw.useEffect)(()=>setClipBoardContext(container), [
        setClipBoardContext,
        container
    ]);
    return null;
};
const $aa4cd8d0d241df51$export$99c5c2d165547316 = ({ children: children, container: container, intent: intent })=>{
    const currentContainer = (0, $7wp7z.useClipboardContextBoundary)();
    if (!container || currentContainer && intent === 'support') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7wp7z.ClipboardStoreContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa4cd8d0d241df51$var$ClipboardContainerSetEffector, {
        container: container
    }), children);
};

});
parcelRegister("7wp7z", function(module, exports) {

$parcel$export(module.exports, "ClipboardStoreContainer", () => $5ea82582ff996af1$export$c4bc9440a978eec1);
$parcel$export(module.exports, "useClipboardContextActions", () => $5ea82582ff996af1$export$a3e41c5b3d4c30b7);
$parcel$export(module.exports, "useClipboardContextBoundary", () => $5ea82582ff996af1$export$37046969a30ae0a0);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");
const $5ea82582ff996af1$var$ClipboardStore = (0, $a61MH.createStore)({
    name: 'clipboard-store',
    // using containedBy will break all "unscoped" locations. We dont want it for now
    // containedBy: ClipboardStoreContainer,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    initialState: {
        boundary: null
    },
    actions: {
        setClipBoardContext: (boundary)=>({ setState: setState })=>{
                setState({
                    boundary: boundary
                });
            }
    }
});
const $5ea82582ff996af1$export$c4bc9440a978eec1 = (0, $heB5U.createContainer)($5ea82582ff996af1$var$ClipboardStore);
const $5ea82582ff996af1$export$a3e41c5b3d4c30b7 = (0, $ggKAj.createActionsHook)($5ea82582ff996af1$var$ClipboardStore);
const $5ea82582ff996af1$var$useClipboardContextBoundarySelector = (0, $ggKAj.createHook)($5ea82582ff996af1$var$ClipboardStore, {
    selector: (state)=>state.boundary
});
const $5ea82582ff996af1$export$37046969a30ae0a0 = ()=>$5ea82582ff996af1$var$useClipboardContextBoundarySelector()[0];

});


parcelRegister("4B7EY", function(module, exports) {

$parcel$export(module.exports, "DISPOSE_ACTION", () => $fcece09efe01c906$export$78be82e7e063a3fb);


var $bQQi1 = parcelRequire("bQQi1");

const $fcece09efe01c906$export$78be82e7e063a3fb = {
    type: (0, $4f32d292c46e5882$export$58387e80544dbf03)
};

});
const $4f32d292c46e5882$export$58387e80544dbf03 = 'COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION';

parcelRegister("bQQi1", function(module, exports) {

$parcel$export(module.exports, "disposableEpic", () => $669b2126028ef686$export$e6b812e492b046b8);
parcelRequire("5hZYM");

const $669b2126028ef686$export$e6b812e492b046b8 = (rootEpic)=>(action$, store, dependencies)=>rootEpic(action$, store, dependencies).takeUntil(action$.ofType((0, $4f32d292c46e5882$export$58387e80544dbf03)));

});


parcelRegister("plbOU", function(module, exports) {

$parcel$export(module.exports, "CrossFlowProvider", () => $cd07cb8d277928e5$export$d900e4062895cd7c);

var $eUqFw = parcelRequire("eUqFw");

var $h63PX = parcelRequire("h63PX");

var $3FyZ4 = parcelRequire("3FyZ4");

var $gd0Sp = parcelRequire("gd0Sp");

var $4Vji8 = parcelRequire("4Vji8");
var $iPzab = parcelRequire("iPzab");
// DELOR-412 Remove explicit mock once we make analytics a no-op in SSR
const $cd07cb8d277928e5$var$getAnalyticsInstance = ()=>(0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
const $cd07cb8d277928e5$export$d900e4062895cd7c = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: { cloudId: cloudId, locale: locale } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h63PX.default), {
            cloudId: cloudId,
            // @ts-expect-error - TS2322 - Type 'Promise<typeof AnalyticsWebClient> | Promise<{ sendUIEvent: () => void; sendOperationalEvent: () => void; sendTrackEvent: () => void; sendScreenEvent: () => void; }>' is not assignable to type 'MaybePromise<AnalyticsWebClientInterface>'.
            analyticsClient: $cd07cb8d277928e5$var$getAnalyticsInstance(),
            locale: locale,
            plugins: [
                (0, $4Vji8.getContainersPlugin),
                (0, $iPzab.getUsersPlugin)
            ]
        }, children));

});
parcelRegister("h63PX", function(module, exports) {

$parcel$export(module.exports, "default", () => $c725f92daa18077d$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $hhohl = parcelRequire("hhohl");

var $NYVfB = parcelRequire("NYVfB");
const $c725f92daa18077d$var$JiraProvider = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hhohl.CrossFlowProvider), (0, $kU09D.default)({}, props, {
        originProduct: "jira"
    }));
};
var $c725f92daa18077d$export$2e2bcd8739ae039 = $c725f92daa18077d$var$JiraProvider;

});
parcelRegister("hhohl", function(module, exports) {

$parcel$export(module.exports, "CrossFlowProvider", () => $c946db76b547b4e1$export$d900e4062895cd7c);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $hXPzA = parcelRequire("hXPzA");

var $juktg = parcelRequire("juktg");

var $f82eB = parcelRequire("f82eB");

var $7Wakq = parcelRequire("7Wakq");

var $5ss06 = parcelRequire("5ss06");

var $iLT5z = parcelRequire("iLT5z");

var $cPgiU = parcelRequire("cPgiU");

var $70wam = parcelRequire("70wam");

var $lBRdm = parcelRequire("lBRdm");

var $2SNCQ = parcelRequire("2SNCQ");

const $c946db76b547b4e1$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("k0xPf")));
const $c946db76b547b4e1$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
        var _requestOptions$zInde;
        const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
        // TBLZ-852: Product Store - Personal Use Case
        // go/trailblazerexperiments
        const tblz852ExperimentCohort = (0, $f82eB.default).getExperimentValue('product_store_personal_use_case', 'cohort', 'not-enrolled', {
            fireExperimentExposure: false
        });
        const isInTblz852ExperimentCohort = tblz852ExperimentCohort === 'variation';
        // TBLZ-852
        const onCloseResolver = (0, $eUqFw.useRef)();
        const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $eUqFw.useState)(false);
        const fireEvent = (0, $eUqFw.useMemo)(()=>(0, $7Wakq.analyticsWrapper)(analyticsClient), [
            analyticsClient
        ]);
        const [requestOptions, setRequestOptions] = (0, $eUqFw.useState)();
        const onAnalyticsEvent = (0, $eUqFw.useCallback)((payload)=>{
            const gasV3Event = (0, $5ss06.transformEvent)(payload);
            if (gasV3Event) {
                const enrichedEvent = (0, $lBRdm.enrichWithRequestOptions)((0, $70wam.enrichWithPackageDetails)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        const onHandShake = (0, $eUqFw.useCallback)((appName)=>{
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
                        action: (0, $2SNCQ.uiInitialized),
                        actionSubject: (0, $2SNCQ.crossFlowActionSubject),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: $2SNCQ.source
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        const onOpen = (0, $eUqFw.useCallback)((options)=>{
            /**
     * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
     * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
     */ setFirstHandshakeReceived(false);
            const analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $lBRdm.enrichWithRequestOptions)({
                    eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
                    action: (0, $2SNCQ.openInvoked),
                    actionSubject: (0, $2SNCQ.crossFlowActionSubject)
                }, options),
                context: [
                    {
                        source: $2SNCQ.source
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $hXPzA.Journeys).GET_STARTED && redirectToWac) {
                (0, $iLT5z.setProductSignUpLocation)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                const completionStatus = {};
                return Promise.resolve(completionStatus);
            }
            const updatedExperimentalOptions = {
                ...globalExperimentalOptions || {},
                // "globalExperimentalOptions" will be injected to EVERY crossFlow invoke
                ...options.experimentalOptions || {} // "options.experimentalOptions" takes care of passing experimentalOptions to ONE specific crossFlow invoke
            };
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise((resolve)=>{
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        const onClose = (0, $eUqFw.useCallback)((completionStatus)=>{
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        const { colorMode: colorMode } = (0, $juktg.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hXPzA.BaseCrossFlowApiProvider), {
            onOpen: onOpen
        }, children, requestOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cPgiU.ErrorBoundary), {
            onAnalyticsEvent: onAnalyticsEvent,
            onError: onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IntegrationView, (0, $kU09D.default)({}, baseProviderProps, requestOptions, {
            onAnalyticsEvent: onAnalyticsEvent,
            originProduct: originProduct,
            theme: colorMode,
            onClose: onClose,
            onHandShake: onHandShake,
            plugins: plugins,
            env: env,
            redirectToWac: redirectToWac,
            isInTblz852ExperimentCohort: isInTblz852ExperimentCohort,
            zIndex: (_requestOptions$zInde = requestOptions.zIndex) !== null && _requestOptions$zInde !== void 0 ? _requestOptions$zInde : 1000
        })))));
    };
const $c946db76b547b4e1$export$d900e4062895cd7c = $c946db76b547b4e1$export$79d79d8dd8574306($c946db76b547b4e1$var$IntegrationView);

});
parcelRegister("f82eB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b039561637bb3b82$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FeatureGateEnvironment", () => (parcelRequire("7enG0")).FeatureGateEnvironment);

var $5zQU9 = parcelRequire("5zQU9");

var $avKkz = parcelRequire("avKkz");

var $9kqbP = parcelRequire("9kqbP");

var $7enG0 = parcelRequire("7enG0");

const $b039561637bb3b82$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// the default event logging api is the Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $b039561637bb3b82$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/';
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $b039561637bb3b82$var$FeatureGates {
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ static async initialize(clientOptions, identifiers, customAttributes) {
        if ($b039561637bb3b82$var$FeatureGates.initPromise) {
            if (!$b039561637bb3b82$var$FeatureGates.shallowEquals(clientOptions, $b039561637bb3b82$var$FeatureGates.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return $b039561637bb3b82$var$FeatureGates.initPromise;
        }
        const startTime = performance.now();
        $b039561637bb3b82$var$FeatureGates.initOptions = clientOptions;
        $b039561637bb3b82$var$FeatureGates.initPromise = $b039561637bb3b82$var$FeatureGates.init(clientOptions, identifiers, customAttributes).then(()=>{
            $b039561637bb3b82$var$FeatureGates.initCompleted = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            $b039561637bb3b82$var$FeatureGates.fireClientEvent(startTime, totalTime, 'initialize', $b039561637bb3b82$var$FeatureGates.initCompleted, clientOptions.apiKey);
        });
        return $b039561637bb3b82$var$FeatureGates.initPromise;
    }
    static fireClientEvent(startTime, totalTime, action, success, apiKey) {
        var _FeatureGates$initOpt;
        (_FeatureGates$initOpt = $b039561637bb3b82$var$FeatureGates.initOptions.analyticsWebClient) === null || _FeatureGates$initOpt === void 0 || _FeatureGates$initOpt.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: $b039561637bb3b82$var$FeatureGates.initOptions.targetApp,
                clientVersion: (0, $68e488ad5a7210e5$export$a59f8d67326bd1cb),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if ($b039561637bb3b82$var$FeatureGates.initOptions.environment !== (0, $7enG0.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    static async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        if ($b039561637bb3b82$var$FeatureGates.initPromise) {
            if (!$b039561637bb3b82$var$FeatureGates.shallowEquals(clientOptions, $b039561637bb3b82$var$FeatureGates.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return $b039561637bb3b82$var$FeatureGates.initPromise;
        }
        const startTime = performance.now();
        $b039561637bb3b82$var$FeatureGates.initOptions = clientOptions;
        $b039561637bb3b82$var$FeatureGates.initPromise = $b039561637bb3b82$var$FeatureGates.initFromValues(clientOptions, identifiers, customAttributes, initializeValues).then(()=>{
            $b039561637bb3b82$var$FeatureGates.initCompleted = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            $b039561637bb3b82$var$FeatureGates.fireClientEvent(startTime, totalTime, 'initializeFromValues', $b039561637bb3b82$var$FeatureGates.initCompleted);
        });
        return $b039561637bb3b82$var$FeatureGates.initPromise;
    }
    /**
   * This method updates the user using a network call to fetch the new set of values.
   * @param fetchOptions {FetcherOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ static async updateUser(fetchOptions, identifiers, customAttributes) {
        const initializeValuesProducer = ()=>(0, $9kqbP.default).fetchExperimentValues(fetchOptions, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await $b039561637bb3b82$var$FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
   * This method updates the user given a new set of bootstrap values obtained from one of the server-side SDKs.
   *
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @param initializeValues {Record<string,unknown>}
   */ static async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await $b039561637bb3b82$var$FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    static initializeCalled() {
        return $b039561637bb3b82$var$FeatureGates.initPromise != null;
    }
    static initializeCompleted() {
        return $b039561637bb3b82$var$FeatureGates.initCompleted;
    }
    /**
   * Returns the value for a feature gate. Returns false if there are errors.
   * @param {string} gateName - The name of the feature gate.
   * @param {Object} options
   * @param {boolean} options.fireGateExposure
   *        Whether or not to fire the exposure event for the gate. Defaults to true.
   *        To log an exposure event manually at a later time, use {@link FeatureGates.manuallyLogGateExposure}
   *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   */ static checkGate(gateName, options = {}) {
        try {
            const { fireGateExposure: fireGateExposure = true } = options;
            const evalMethod = fireGateExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).checkGate.bind((0, (/*@__PURE__*/$parcel$interopDefault($avKkz)))) : (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).checkGateWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($avKkz))));
            return evalMethod(gateName);
        } catch (error) {
            // Log the first occurrence of the error
            if (!$b039561637bb3b82$var$FeatureGates.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                $b039561637bb3b82$var$FeatureGates.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    /**
   * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a gate earlier via {@link FeatureGates.checkGate} where <code>options.fireGateExposure</code> is false.
   * @param gateName
   */ static manuallyLogGateExposure(gateName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).manuallyLogGateExposure(gateName);
    }
    /**
   * Returns the entire config for a given experiment.
   *
   * @param {string} experimentName - The name of the experiment
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event for the experiment. Defaults to true. To log an exposure event manually at a later time, use {@link FeatureGates.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns The config for an experiment
   * @example
   * ```ts
   * const experimentConfig = FeatureGates.getExperiment('example-experiment-name');
   * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
   * ```
   */ static getExperiment(experimentName, options = {}) {
        try {
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            const evalMethod = fireExperimentExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).getExperiment.bind((0, (/*@__PURE__*/$parcel$interopDefault($avKkz)))) : (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).getExperimentWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($avKkz))));
            return evalMethod(experimentName);
        } catch (error) {
            // Log the first occurrence of the error
            if (!$b039561637bb3b82$var$FeatureGates.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                $b039561637bb3b82$var$FeatureGates.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $avKkz.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $avKkz.EvaluationReason).Error
            });
        }
    }
    /**
   * Returns the value of a given parameter in an experiment config.
   *
   * @template T
   * @param {string} experimentName - The name of the experiment
   * @param {string} parameterName - The name of the parameter to fetch from the experiment config
   * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or if the returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event for the experiment. Defaults to true. To log an exposure event manually at a later time, use {@link FeatureGates.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
   * @returns The value of the parameter if the experiment and parameter both exist, otherwise the default value.
   * @example
   ``` ts
   type ValidColor = 'blue' | 'red' | 'yellow';
   type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
    const isValidColor: ValidColorTypeCheck =
      (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
    const buttonColor: ValidColor = FeatureGates.getExperimentValue(
      'example-experiment-name',
      'backgroundColor',
      'yellow',
      {
          typeGuard: isValidColor
      }
   );
   ```
  */ static getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = $b039561637bb3b82$var$FeatureGates.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!$b039561637bb3b82$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                $b039561637bb3b82$var$FeatureGates.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
   * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated an experiment earlier via {@link FeatureGates.getExperimentValue} or
   * {@link FeatureGates.getExperiment} where <code>options.fireExperimentExposure</code> is false.
   * @param experimentName
   */ static manuallyLogExperimentExposure(experimentName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).manuallyLogExperimentExposure(experimentName);
    }
    static shutdownStatsig() {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).shutdown();
    }
    /**
   * Adds a new override for the given gate.
   *
   * This method is additive, meaning you can call it multiple times with different gate names to build
   * your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_JS_LITE_LOCAL_OVERRIDES` key in localStorage, so they will
   * continue to affect every client that is initialized on the same domain after this method is called.
   * If you are using this API for testing purposes, you should call ${@link FeatureGates.clearGateOverride} after
   * your tests are completed to remove this localStorage entry.
   *
   * @param {string} gateName
   * @param {boolean} value
   */ static overrideGate(gateName, value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).overrideGate(gateName, value);
    }
    /**
   * Removes any overrides that have been set for the given gate.
   * @param {string} gateName
   */ static clearGateOverride(gateName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).overrideGate(gateName, null);
    }
    /**
   * Adds a new override for the given config (or experiment).
   *
   * This method is additive, meaning you can call it multiple times with different experiment names to build
   * your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_JS_LITE_LOCAL_OVERRIDES` key in localStorage, so they will
   * continue to affect every client that is initialized on the same domain after this method is called.
   * If you are using this API for testing purposes, you should call ${@link FeatureGates.clearConfigOverride} after
   * your tests are completed to remove this localStorage entry.
   *
   * @param {string} experimentName
   * @param {object} values
   */ static overrideConfig(experimentName, values) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).overrideConfig(experimentName, values);
    }
    /**
   * Removes any overrides that have been set for the given experiment.
   * @param {string} experimentName
   */ static clearConfigOverride(experimentName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).overrideConfig(experimentName, null);
    }
    /**
   * Set overrides for gates, experiments and layers in batch.
   *
   * Note that these overrides are **not** additive and will completely replace any that have been added
   * via prior calls to {@link FeatureGates.overrideConfig} or {@link FeatureGates.overrideGate}.
   *
   * Overrides are persisted to the `STATSIG_JS_LITE_LOCAL_OVERRIDES` key in localStorage, so they will
   * continue to affect every client that is initialized on the same domain after this method is called.
   * If you are using this API for testing purposes, you should call ${@link FeatureGates.clearAllOverrides} after
   * your tests are completed to remove this localStorage entry.
   *
   * @param {object} overrides
   */ static setOverrides(overrides) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).setOverrides({
            gates: {},
            configs: {},
            layers: {},
            ...overrides
        });
    }
    /**
   * @returns The current overrides for gates, configs (including experiments) and layers.
   */ static getOverrides() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).getOverrides();
    }
    /**
   * Clears overrides for all gates, configs (including experiments) and layers.
   */ static clearAllOverrides() {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).setOverrides(null);
    }
    /**
   * Returns whether the given identifiers and customAttributes align with the current
   * set that is being used by the client.
   *
   * If this method returns false, then the {@link FeatureGates.updateUser} or {@link FeatureGates.updateUserWithValues}
   * methods can be used to re-align these values.
   *
   * @param identifiers
   * @param customAttributes
   * @returns a flag indicating whether the clients current configuration aligns with the given values
   */ static isCurrentUser(identifiers, customAttributes) {
        return $b039561637bb3b82$var$FeatureGates.shallowEquals($b039561637bb3b82$var$FeatureGates.currentIdentifiers, identifiers) && $b039561637bb3b82$var$FeatureGates.shallowEquals($b039561637bb3b82$var$FeatureGates.currentAttributes, customAttributes);
    }
    /**
   * This method initializes the client using a network call to fetch the bootstrap values for the given user.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @private
   */ static async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for the experiment
            // values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $9kqbP.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $9kqbP.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client with experiment
            // values if both requests are successful. Else an error would be thrown and handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await $b039561637bb3b82$var$FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        await this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
   * This method initializes the client using a set of boostrap values obtained from one of the server-side SDKs.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @param initializeValues
   * @private
   */ static async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const user = this.toStatsigUser(identifiers, customAttributes);
        $b039561637bb3b82$var$FeatureGates.currentIdentifiers = identifiers;
        $b039561637bb3b82$var$FeatureGates.currentAttributes = customAttributes;
        if (!clientOptions.sdkKey) clientOptions.sdkKey = $b039561637bb3b82$var$DEFAULT_CLIENT_KEY;
        if (!clientOptions.eventLoggingApi) clientOptions.eventLoggingApi = $b039561637bb3b82$var$DEFAULT_EVENT_LOGGING_API;
        if (clientOptions.perimeter === (0, $7enG0.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        clientOptions.disableAllLogging = true;
        const { sdkKey: sdkKey } = clientOptions;
        const statsigOptions = this.toStatsigOptions(clientOptions, initializeValues);
        try {
            await (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).initialize(sdkKey, user, statsigOptions);
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            await (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).initialize($b039561637bb3b82$var$DEFAULT_CLIENT_KEY, user, {
                ...statsigOptions,
                initializeValues: {}
            });
            throw error;
        }
    }
    /**
   * This method creates an instance of StatsigUser from the given set of identifiers and attributes.
   *
   * @param identifiers
   * @param customAttributes
   * @private
   */ static toStatsigUser(identifiers, customAttributes) {
        const user = {
            customIDs: identifiers,
            custom: customAttributes
        };
        if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
        return user;
    }
    /**
   * This method updates the user for this client with the bootstrap values returned from a given Promise.
   * It uses the customAttributes from fetching experiment values to update the Statsig user but
   * uses the customAttributes from given input to check if the user has changed.
   *
   * @param {Identifiers} identifiers
   * @param {CustomAttributes} customAttributes
   * @param {Promise<InitializeValues>} getInitializeValues
   * @private
   */ static async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        if (!$b039561637bb3b82$var$FeatureGates.initPromise) throw new Error('The FeatureGates client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if ($b039561637bb3b82$var$FeatureGates.isCurrentUser(identifiers, customAttributes)) return $b039561637bb3b82$var$FeatureGates.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = $b039561637bb3b82$var$FeatureGates.initPromise;
        try {
            await $b039561637bb3b82$var$FeatureGates.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = $b039561637bb3b82$var$FeatureGates.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this point.
        // Any subsequent calls to await FeatureGates.initialize() or FeatureGates.updateUser() will now also await this user update.
        $b039561637bb3b82$var$FeatureGates.initPromise = updateUserPromise.catch(()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            $b039561637bb3b82$var$FeatureGates.initPromise = originalInitPromise;
        });
        return updateUserPromise;
    }
    /**
   * This method updates the user on the nested Statsig client
   *
   * @param identifiers
   * @param customAttributes
   * @param initializeValuesPromise
   * @private
   */ static async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            user = $b039561637bb3b82$var$FeatureGates.toStatsigUser(identifiers, initializeValues.customAttributesFromFetch);
        } catch (err) {
            var _FeatureGates$initOpt2, _FeatureGates$initOpt3;
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            (_FeatureGates$initOpt2 = (_FeatureGates$initOpt3 = $b039561637bb3b82$var$FeatureGates.initOptions).updateUserCompletionCallback) === null || _FeatureGates$initOpt2 === void 0 || _FeatureGates$initOpt2.call(_FeatureGates$initOpt3, false, errMsg);
            throw err;
        }
        const success = (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).updateUserWithValues(user, initializeValues.experimentValues);
        if (success) {
            $b039561637bb3b82$var$FeatureGates.currentIdentifiers = identifiers;
            $b039561637bb3b82$var$FeatureGates.currentAttributes = customAttributes;
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
   * This method transforms the options given by the user into the format accepted by the Statsig client.
   *
   * @param options
   * @param {Record<string, unknown>} initializeValues
   * @private
   */ static toStatsigOptions(options, initializeValues) {
        const { sdkKey: // De-structured to remove from restClientOptions
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        sdkKey, updateUserCompletionCallback: // De-structured to remove from restClientOptions
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        updateUserCompletionCallback, perimeter: // De-structured to remove from restClientOptions
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        perimeter, ...restClientOptions } = options;
        return {
            ...restClientOptions,
            initializeValues: initializeValues,
            environment: {
                tier: options.environment
            },
            disableCurrentPageLogging: true,
            ...options.updateUserCompletionCallback && {
                updateUserCompletionCallback: $b039561637bb3b82$var$FeatureGates.toStatsigUpdateUserCompletionCallback(options.updateUserCompletionCallback)
            }
        };
    }
    /**
   * This method transforms an UpdateUserCompletionCallback in our own format into the format accepted by the Statsig client.
   *
   * @param callback
   * @private
   */ static toStatsigUpdateUserCompletionCallback(callback) {
        /**
     * The duration passed to the callback indicates how long the update took, but it is deceptive since it only times the
     * Statsig code and doesn't account for all of the extra custom work we do to obtain the bootstrap values.
     * As a result, we just suppress this parameter in our own callback rather than trying to keep it accurate.
     */ return (_duration, success, message)=>{
            callback(success, message);
        };
    }
    static shallowEquals(objectA, objectB) {
        if (!objectA && !objectB) return true;
        if (!objectA || !objectB) return false;
        const aEntries = Object.entries(objectA);
        const bEntries = Object.entries(objectB);
        if (aEntries.length !== bEntries.length) return false;
        const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
        aEntries.sort(ascendingKeyOrder);
        bEntries.sort(ascendingKeyOrder);
        for(let i = 0; i < aEntries.length; i++){
            const [, aValue] = aEntries[i];
            const [, bValue] = bEntries[i];
            if (aValue !== bValue) return false;
        }
        return true;
    }
    /**
   * @returns string version of the current package in semver style.
   */ static getPackageVersion() {
        return 0, $68e488ad5a7210e5$export$a59f8d67326bd1cb;
    }
}
(0, $5zQU9.default)($b039561637bb3b82$var$FeatureGates, "initPromise", null);
(0, $5zQU9.default)($b039561637bb3b82$var$FeatureGates, "initCompleted", false);
(0, $5zQU9.default)($b039561637bb3b82$var$FeatureGates, "hasGetExperimentErrorOccurred", false);
(0, $5zQU9.default)($b039561637bb3b82$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $5zQU9.default)($b039561637bb3b82$var$FeatureGates, "hasCheckGateErrorOccurred", false);
let $b039561637bb3b82$var$boundFGJS = $b039561637bb3b82$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cyprus tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $b039561637bb3b82$var$FeatureGates;
    else {
        var $b039561637bb3b82$var$_boundFGJS, $b039561637bb3b82$var$_boundFGJS$getPackage;
        $b039561637bb3b82$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = (($b039561637bb3b82$var$_boundFGJS = $b039561637bb3b82$var$boundFGJS) === null || $b039561637bb3b82$var$_boundFGJS === void 0 ? void 0 : ($b039561637bb3b82$var$_boundFGJS$getPackage = $b039561637bb3b82$var$_boundFGJS.getPackageVersion) === null || $b039561637bb3b82$var$_boundFGJS$getPackage === void 0 ? void 0 : $b039561637bb3b82$var$_boundFGJS$getPackage.call($b039561637bb3b82$var$_boundFGJS)) || '4.10.0 or earlier';
        if (boundVersion !== (0, $68e488ad5a7210e5$export$a59f8d67326bd1cb)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $68e488ad5a7210e5$export$a59f8d67326bd1cb)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $b039561637bb3b82$export$2e2bcd8739ae039 = $b039561637bb3b82$var$boundFGJS;

});
parcelRegister("9kqbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6caa4c0b35d34d1e$export$2e2bcd8739ae039);

var $7enG0 = parcelRequire("7enG0");


var $eLB4Y = parcelRequire("eLB4Y");
const $6caa4c0b35d34d1e$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $6caa4c0b35d34d1e$var$PROD_BASE_URL = 'https://api.atlassian.com/flags';
const $6caa4c0b35d34d1e$var$STAGING_BASE_URL = 'https://api.stg.atlassian.com/flags';
const $6caa4c0b35d34d1e$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $6caa4c0b35d34d1e$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $6caa4c0b35d34d1e$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $6caa4c0b35d34d1e$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $6caa4c0b35d34d1e$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $eLB4Y.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $eLB4Y.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter = (0, $7enG0.PerimeterType).COMMERCIAL) {
        if (useGatewayUrl) return $6caa4c0b35d34d1e$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $7enG0.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $7enG0.FeatureGateEnvironment).Production:
                return $6caa4c0b35d34d1e$export$18c93900db9358a4;
            case (0, $7enG0.FeatureGateEnvironment).Staging:
                return $6caa4c0b35d34d1e$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $7enG0.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $7enG0.FeatureGateEnvironment).Development:
                return $6caa4c0b35d34d1e$export$f058dbf75c3bc647;
            case (0, $7enG0.FeatureGateEnvironment).Staging:
                return $6caa4c0b35d34d1e$var$STAGING_BASE_URL;
            default:
                return $6caa4c0b35d34d1e$var$PROD_BASE_URL;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $6caa4c0b35d34d1e$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $6caa4c0b35d34d1e$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $68e488ad5a7210e5$export$a59f8d67326bd1cb),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
}

});
parcelRegister("7enG0", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", () => $543c34dfe882cd9a$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $543c34dfe882cd9a$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options.
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ let $543c34dfe882cd9a$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
let $543c34dfe882cd9a$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});

});

const $68e488ad5a7210e5$export$a59f8d67326bd1cb = "4.17.2";

parcelRegister("eLB4Y", function(module, exports) {

$parcel$export(module.exports, "ResponseError", () => $ac02379df451e1fb$export$286baf652d0b1206);
class $ac02379df451e1fb$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});



parcelRegister("7Wakq", function(module, exports) {

$parcel$export(module.exports, "analyticsWrapper", () => $5c75f638226df175$export$91b4dd3bfc301325);

const $5c75f638226df175$export$91b4dd3bfc301325 = (analyticsClient)=>{
    return (event)=>{
        return Promise.resolve(analyticsClient).then((client)=>{
            switch(event.eventType){
                case 0, $662e33bb7444ae33$export$a1562d08625f5d7e:
                    client.sendUIEvent(event);
                    break;
                case 0, $662e33bb7444ae33$export$947dac6c72b26f81:
                    client.sendTrackEvent(event);
                    break;
                case 0, $662e33bb7444ae33$export$12346a674644c156:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $662e33bb7444ae33$export$f1d537d508d2945a:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $662e33bb7444ae33$export$a1562d08625f5d7e = 'ui';
const $662e33bb7444ae33$export$947dac6c72b26f81 = 'track';
const $662e33bb7444ae33$export$f1d537d508d2945a = 'screen';
const $662e33bb7444ae33$export$12346a674644c156 = 'operational';
const $662e33bb7444ae33$export$b055de0e665cb20c = 'unknown';


parcelRegister("5ss06", function(module, exports) {

$parcel$export(module.exports, "transformEvent", () => $3f954998c8b693a3$export$3f40e8c44448be30);
// Copied from xflow-ui. We post raw analytics events (context and payload only) from xflow-ui to consumer (CFE), transform on consumer and post to gasv3.

const $3f954998c8b693a3$var$GROWTH_TAG = 'growth';
const $3f954998c8b693a3$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $3f954998c8b693a3$var$getSources = (context)=>$3f954998c8b693a3$var$extractFromEventContext([
        'source'
    ], context);
const $3f954998c8b693a3$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
        const newAttributes = {
            ...ans,
            ...contextProps
        };
        return attributes ? {
            ...newAttributes,
            ...attributes
        } : newAttributes;
    }, {});
const $3f954998c8b693a3$var$getPackageInfo = (context)=>context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $3f954998c8b693a3$var$last = (values)=>values[values.length - 1];
const $3f954998c8b693a3$export$3f40e8c44448be30 = (event)=>{
    const { context: context, payload: payload } = event;
    if (!payload) return null;
    const sources = $3f954998c8b693a3$var$getSources(context);
    const source = $3f954998c8b693a3$var$last(sources) || (0, $662e33bb7444ae33$export$b055de0e665cb20c);
    const extraAttributes = $3f954998c8b693a3$var$getExtraAttributes(context);
    const { packageName: packageName, packageVersion: packageVersion } = $3f954998c8b693a3$var$last($3f954998c8b693a3$var$getPackageInfo(context)) || {};
    const { eventType: eventType = (0, $662e33bb7444ae33$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
    const attributes = {
        packageName: packageName,
        packageVersion: packageVersion,
        ...extraAttributes,
        ...payloadAttributes
    };
    const tags = payload.tags || [];
    tags.push($3f954998c8b693a3$var$GROWTH_TAG);
    switch(eventType){
        case 0, $662e33bb7444ae33$export$a1562d08625f5d7e:
        case 0, $662e33bb7444ae33$export$12346a674644c156:
        case 0, $662e33bb7444ae33$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $662e33bb7444ae33$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};

});

parcelRegister("iLT5z", function(module, exports) {

$parcel$export(module.exports, "setProductSignUpLocation", () => $daa759445e89c920$export$2827e2473cb9a346);

var $8a0ZO = parcelRequire("8a0ZO");


var $jKI77 = parcelRequire("jKI77");
const $daa759445e89c920$var$utmCampaignMap = {
    'atlassian-switcher': (0, $jKI77.UtmCampaign)['atlassian-switcher']
};
const $daa759445e89c920$var$isBundledProduct = (productKey)=>{
    return [
        (0, $8a0ZO.Targets).JIRA_SOFTWARE,
        (0, $8a0ZO.Targets).JIRA_SERVICE_DESK,
        (0, $8a0ZO.Targets).JIRA_CORE,
        (0, $8a0ZO.Targets).CONFLUENCE
    ].includes(productKey);
};
const $daa759445e89c920$var$getBundleSignUpParams = (productKey)=>{
    const bundles = {
        [(0, $8a0ZO.Targets).JIRA_SOFTWARE]: 'jira-software',
        [(0, $8a0ZO.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
        [(0, $8a0ZO.Targets).JIRA_CORE]: 'jira-core',
        [(0, $8a0ZO.Targets).CONFLUENCE]: 'confluence'
    };
    // Bundles default to free
    return `bundle=${bundles[productKey]}&edition=free`;
};
const $daa759445e89c920$var$isProductWithCustomSignUpPath = (productKey)=>{
    return [
        (0, $8a0ZO.Targets).OPSGENIE
    ].includes(productKey);
};
const $daa759445e89c920$var$getProductCustomSignUpPath = (productKey)=>{
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    const links = {
        [(0, $8a0ZO.Targets).OPSGENIE]: (0, $602d18a363cab9c6$export$fb1e43fdafe12e9b)
    };
    return links[productKey];
};
const $daa759445e89c920$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
    return Boolean($daa759445e89c920$var$utmCampaignMap[sourceComponent]);
};
const $daa759445e89c920$var$getUtmParams = (sourceComponent, sourceContext)=>{
    let utmParams = '';
    if (sourceComponent && $daa759445e89c920$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + `utm_campaign=${$daa759445e89c920$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
        if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
    }
    return utmParams;
};
const $daa759445e89c920$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
    const wacUrl = env === 'staging' ? (0, $602d18a363cab9c6$export$c37558e5c67d2b01) : (0, $602d18a363cab9c6$export$f199baf8dfc7621e);
    const utmParams = $daa759445e89c920$var$getUtmParams(sourceComponent, sourceContext);
    let queryParams = '';
    let bundleParams = '';
    let path = (0, $602d18a363cab9c6$export$2a45a00073911255);
    if ($daa759445e89c920$var$isBundledProduct(productKey)) {
        path = (0, $602d18a363cab9c6$export$e6c04a1dd86d1c14);
        bundleParams = $daa759445e89c920$var$getBundleSignUpParams(productKey);
    } else if ($daa759445e89c920$var$isProductWithCustomSignUpPath(productKey)) path = $daa759445e89c920$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
    return wacUrl + path + queryParams;
};
const $daa759445e89c920$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
    const url = $daa759445e89c920$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, '_blank');
};

});
const $602d18a363cab9c6$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $602d18a363cab9c6$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $602d18a363cab9c6$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $602d18a363cab9c6$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $602d18a363cab9c6$export$2a45a00073911255 = '/software';

parcelRegister("jKI77", function(module, exports) {

$parcel$export(module.exports, "UtmCampaign", () => $e61488454ade475a$export$fc604aa353a97e10);
let $e61488454ade475a$export$fc604aa353a97e10 = /*#__PURE__*/ function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    return UtmCampaign;
}({});

});


parcelRegister("cPgiU", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $9566e51aff35b371$export$e926676385687eaf);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $2SNCQ = parcelRequire("2SNCQ");
const $9566e51aff35b371$var$name = "@atlassiansox/cross-flow-support";
const $9566e51aff35b371$var$version = "3.12.0";
const $9566e51aff35b371$var$payload = {
    eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
    action: (0, $2SNCQ.errorBoundaryAction),
    actionSubject: (0, $2SNCQ.errorBoundaryActionSubject)
};
const $9566e51aff35b371$var$context = [
    {
        source: $2SNCQ.source
    },
    {
        packageName: $9566e51aff35b371$var$name,
        packageVersion: $9566e51aff35b371$var$version
    }
];
class $9566e51aff35b371$export$e926676385687eaf extends (0, $eUqFw.Component) {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            hasError: false
        });
    }
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        this.props.onAnalyticsEvent({
            payload: $9566e51aff35b371$var$payload,
            context: $9566e51aff35b371$var$context
        });
        if (this.props.onError) this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
}

});
parcelRegister("2SNCQ", function(module, exports) {

$parcel$export(module.exports, "source", () => $21971e7e7eac2e19$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "errorBoundaryAction", () => $21971e7e7eac2e19$export$9d8252a268f4fa72);
$parcel$export(module.exports, "errorBoundaryActionSubject", () => $21971e7e7eac2e19$export$1045419caf49b395);
$parcel$export(module.exports, "crossFlowActionSubject", () => $21971e7e7eac2e19$export$d54c183f56e39aa5);
$parcel$export(module.exports, "uiInitialized", () => $21971e7e7eac2e19$export$e5c2c058fa8068a6);
$parcel$export(module.exports, "openInvoked", () => $21971e7e7eac2e19$export$e67cdcb8867a3bd0);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $662e33bb7444ae33$export$12346a674644c156);

const $21971e7e7eac2e19$export$b4d5da5f34fb77ad = 'crossFlowProvider';
const $21971e7e7eac2e19$export$9d8252a268f4fa72 = 'errorCaught';
const $21971e7e7eac2e19$export$1045419caf49b395 = 'errorBoundary';
const $21971e7e7eac2e19$export$d54c183f56e39aa5 = 'crossFlowSupport';
const $21971e7e7eac2e19$export$e5c2c058fa8068a6 = 'uiInitialized';
const $21971e7e7eac2e19$export$e67cdcb8867a3bd0 = 'openInvoked';

});


parcelRegister("70wam", function(module, exports) {

$parcel$export(module.exports, "enrichWithPackageDetails", () => $51a17bfef640fc78$export$59518efab336a8b5);
const $51a17bfef640fc78$var$version = "3.12.0";
const $51a17bfef640fc78$export$84f9cf7ef89d4c26 = {
    version: $51a17bfef640fc78$var$version
};
const $51a17bfef640fc78$export$59518efab336a8b5 = (event)=>{
    const attributes = {
        ...event.attributes || {},
        crossFlowSupport: $51a17bfef640fc78$export$84f9cf7ef89d4c26
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("lBRdm", function(module, exports) {

$parcel$export(module.exports, "enrichWithRequestOptions", () => $fbb654f6d0c2deec$export$a5a156dc5df42f0);
const $fbb654f6d0c2deec$export$a5a156dc5df42f0 = (event, requestOptions)=>{
    if (!requestOptions) return event;
    const attributes = {
        // Spread the extra analytics attributes first, because we don't want consumers to override any event attributes below
        ...requestOptions.extraAnalyticsAttributes || {},
        ...event.attributes || {},
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("k0xPf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('5watl')
        ]);
        const value = parcelRequire('O7f4T');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("5watl")
    ]).then(()=>parcelRequire('O7f4T'));
}

});



parcelRegister("4Vji8", function(module, exports) {

$parcel$export(module.exports, "getContainersPlugin", () => $d5a247609f17a49b$export$81d1d40061d190bc);
parcelRequire("fYNkJ");
var $lJsOu = parcelRequire("lJsOu");
var $fYNkJ = parcelRequire("fYNkJ");

var $e91YZ = parcelRequire("e91YZ");
const $d5a247609f17a49b$var$getCloudId = async ()=>{
    const { cloudName: cloudName, cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const containers = [
        {
            id: cloudId,
            displayName: cloudName,
            type: (0, $lJsOu.ContainerTypes).ATLASSIAN_CLOUD_ID
        }
    ];
    return {
        type: (0, $lJsOu.ContainerTypes).ATLASSIAN_CLOUD_ID,
        containers: containers
    };
};
const $d5a247609f17a49b$export$81d1d40061d190bc = (0, $fYNkJ.createGetContainersPlugin)($d5a247609f17a49b$var$getCloudId);

});
parcelRegister("fYNkJ", function(module, exports) {

$parcel$export(module.exports, "createGetContainersPlugin", () => $edac63653776ab1d$export$76378b0f825c024c);
$parcel$export(module.exports, "createGetUsersPlugin", () => $edac63653776ab1d$export$8feb7eae83cf8cd5);
$parcel$export(module.exports, "ContainerTypes", () => (parcelRequire("lJsOu")).ContainerTypes);
$parcel$export(module.exports, "UserIdTypes", () => (parcelRequire("lJsOu")).UserIdTypes);

var $lJsOu = parcelRequire("lJsOu");
const $edac63653776ab1d$export$76378b0f825c024c = (fetch)=>{
    return [
        (0, $lJsOu.PluginTypes).GetContainers,
        fetch
    ];
};
const $edac63653776ab1d$export$8feb7eae83cf8cd5 = (fetch)=>{
    return [
        (0, $lJsOu.PluginTypes).GetUsers,
        fetch
    ];
};
const $edac63653776ab1d$export$21d120847be2aff4 = (fetch)=>{
    return [
        (0, $lJsOu.PluginTypes).GetSuggestedSiteNames,
        fetch
    ];
};
const $edac63653776ab1d$export$d7c1699c6a2ca18a = (fetch)=>{
    return [
        (0, $lJsOu.PluginTypes).GetAvailableSites,
        fetch
    ];
};

});
parcelRegister("lJsOu", function(module, exports) {

$parcel$export(module.exports, "PluginTypes", () => $5cc146ce6a3f537d$export$a235a73f7b906dce);
$parcel$export(module.exports, "ContainerTypes", () => $5cc146ce6a3f537d$export$6e383182a26455ff);
$parcel$export(module.exports, "UserIdTypes", () => $5cc146ce6a3f537d$export$e391bab95adb8396);
// Data Plugin definition and utility types
const $5cc146ce6a3f537d$export$a235a73f7b906dce = {
    GetContainers: 'GetContainers',
    GetUsers: 'GetUsers',
    GetSuggestedSiteNames: 'GetSuggestedSiteNames',
    GetAvailableSites: 'GetAvailableSites'
};
const $5cc146ce6a3f537d$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: 'bitbucket-workspace',
    ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
    JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
};
const $5cc146ce6a3f537d$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
    TRELLO_ID: 'TRELLO_ID'
};
const $5cc146ce6a3f537d$export$4f378ba35c571906 = {
    JIRA_BUSINESS: 'JIRA_BUSINESS',
    JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
    JIRA_SOFTWARE: 'JIRA_SOFTWARE',
    CONFLUENCE: 'CONFLUENCE',
    OPSGENIE: 'OPSGENIE',
    BITBUCKET: 'BITBUCKET',
    STATUSPAGE: 'STATUSPAGE',
    TRELLO: 'TRELLO',
    COMPASS: 'COMPASS'
};

});



parcelRegister("iPzab", function(module, exports) {

$parcel$export(module.exports, "getUsersPlugin", () => $f595b9c40464a5a8$export$7c44908d2777db01);

var $fYNkJ = parcelRequire("fYNkJ");
var $lJsOu = parcelRequire("lJsOu");
const $f595b9c40464a5a8$var$getUsers = async (containerId)=>{
    const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
    try {
        const response = await fetch(getUsersUrl, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const data = await response.json();
            return data.map((value)=>({
                    id: value.id,
                    idType: (0, $lJsOu.UserIdTypes).ATLASSIAN_ACCOUNT_ID,
                    displayName: value.displayName
                }));
        }
        throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
    }
};
const $f595b9c40464a5a8$export$7c44908d2777db01 = (0, $fYNkJ.createGetUsersPlugin)($f595b9c40464a5a8$var$getUsers);

});


parcelRegister("kUI0A", function(module, exports) {

$parcel$export(module.exports, "useIssueAttachmentsActions", () => $0fb49cdf1e90b3c1$export$bc73f19bf33ad0c8);
$parcel$export(module.exports, "useIssueAttachments", () => $0fb49cdf1e90b3c1$export$10c553d8e483e523);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $fAnID = parcelRequire("fAnID");

var $5Cq9A = parcelRequire("5Cq9A");
const $0fb49cdf1e90b3c1$export$bc73f19bf33ad0c8 = ()=>{
    const [, actions] = (0, $5Cq9A.useAttachmentStoreActions)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { setOrderDirection: setOrderDirection, setOrderField: setOrderField, setTotalCount: setTotalCount, setDeletableCount: setDeletableCount, setVisibleAttachments: setVisibleAttachments, addNewAttachments: addNewAttachments, deleteAttachment: storeDeleteAttachment, getAttachments: getAttachments, getAttachmentsCount: getAttachmentsCount, refreshAttachments: refreshAttachments } = actions;
    const deleteAttachment = (0, $eUqFw.useCallback)(async (issueAttachmentKey, deletingAttachmentId, fetchOptions)=>{
        try {
            await storeDeleteAttachment(issueAttachmentKey, deletingAttachmentId, fetchOptions);
        } catch  {
            showFlag({
                type: 'error',
                title: (0, $fAnID.default).deleteFailedTitle,
                description: (0, $fAnID.default).deleteFailedDescription
            });
        }
    }, [
        storeDeleteAttachment,
        showFlag
    ]);
    return [
        null,
        {
            setOrderDirection: setOrderDirection,
            setOrderField: setOrderField,
            setTotalCount: setTotalCount,
            setDeletableCount: setDeletableCount,
            setVisibleAttachments: setVisibleAttachments,
            addNewAttachments: addNewAttachments,
            getAttachments: getAttachments,
            getAttachmentsCount: getAttachmentsCount,
            deleteAttachment: deleteAttachment,
            refreshAttachments: refreshAttachments
        }
    ];
};
const $0fb49cdf1e90b3c1$export$10c553d8e483e523 = (issueKey, options)=>{
    const [, actions] = $0fb49cdf1e90b3c1$export$bc73f19bf33ad0c8();
    const [isFetching] = (0, $5Cq9A.useAttachmentStoreIsFetching)(issueKey);
    const [error] = (0, $5Cq9A.useAttachmentStoreError)(issueKey);
    const [orderDirection] = (0, $5Cq9A.useAttachmentStoreOrderDirection)();
    const [orderField] = (0, $5Cq9A.useAttachmentStoreOrderField)();
    const [startAt] = (0, $5Cq9A.useAttachmentStoreStartAt)();
    const [totalCount] = (0, $5Cq9A.useAttachmentStoreTotalCount)(issueKey);
    const [deletableCount] = (0, $5Cq9A.useAttachmentStoreDeletableCount)(issueKey);
    const [visibleAttachments] = (0, $5Cq9A.useAttachmentStoreVisibleAttachments)(issueKey);
    const { getAttachments: getAttachments } = actions;
    (0, $eUqFw.useEffect)(()=>{
        if (totalCount === undefined && !isFetching && !error) getAttachments(issueKey, options);
    }, [
        error,
        getAttachments,
        issueKey,
        isFetching,
        options,
        totalCount
    ]);
    const meta = {
        orderDirection: orderDirection,
        orderField: orderField,
        startAt: startAt
    };
    const value = {
        attachments: visibleAttachments,
        totalCount: totalCount || 0,
        deletableCount: deletableCount || 0
    };
    return [
        {
            error: error,
            meta: meta,
            value: value,
            loading: isFetching
        },
        actions
    ];
};

});
parcelRegister("fAnID", function(module, exports) {

$parcel$export(module.exports, "default", () => $ece1c5ab527e7b6d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ece1c5ab527e7b6d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    gotIt: {
        "id": "issue-attachments-base.services.got-it",
        "defaultMessage": "Got it"
    },
    tryAgain: {
        "id": "issue-attachments-base.services.try-again",
        "defaultMessage": "Try again"
    },
    downloadStartTitle: {
        "id": "issue-attachments-base.services.download-start-title",
        "defaultMessage": "Downloading attachments"
    },
    downloadStartDescription: {
        "id": "issue-attachments-base.services.download-start-description",
        "defaultMessage": "This might take a while. When we\u2019re done, your attachments will be in a zip file on your device."
    },
    downloadFailedTitle: {
        "id": "issue-attachments-base.services.download-failed-title",
        "defaultMessage": "We couldn\u2019t download your attachments"
    },
    downloadFailedDescription: {
        "id": "issue-attachments-base.services.download-failed-description",
        "defaultMessage": "We didn\u2019t finish downloading your attachments for {issueKey}. Check your connection and then try again."
    },
    downloadFailedExceedFileSizeDescription: {
        "id": "issue-attachments-base.services.download-failed-exceed-file-size-description",
        "defaultMessage": "The total size of {issueKey}'s attachments is too large to download. Try downloading each attachment individually."
    },
    deleteFailedTitle: {
        "id": "issue-attachments-base.services.delete-failed-title",
        "defaultMessage": "Attachment could not be deleted"
    },
    deleteFailedDescription: {
        "id": "issue-attachments-base.services.delete-failed-description",
        "defaultMessage": "There was a connection problem and the attachment was not successfully deleted. Try checking your network connection."
    }
});

});

parcelRegister("5Cq9A", function(module, exports) {

$parcel$export(module.exports, "useAttachmentStoreIsFetching", () => $01cc6b29646080ba$export$8d8ddf1ded2abe06);
$parcel$export(module.exports, "useAttachmentStoreError", () => $01cc6b29646080ba$export$54eb9f4a95926909);
$parcel$export(module.exports, "useAttachmentStoreOrderDirection", () => $01cc6b29646080ba$export$bb091cd0dae17d3b);
$parcel$export(module.exports, "useAttachmentStoreOrderField", () => $01cc6b29646080ba$export$2a9e7650d0508f23);
$parcel$export(module.exports, "useAttachmentStoreTotalCount", () => $01cc6b29646080ba$export$197197a1bd69c0db);
$parcel$export(module.exports, "useAttachmentStoreDeletableCount", () => $01cc6b29646080ba$export$5c5679d3922a31be);
$parcel$export(module.exports, "useAttachmentStoreStartAt", () => $01cc6b29646080ba$export$f127d1c515abe7f8);
$parcel$export(module.exports, "useAttachmentStoreVisibleAttachments", () => $01cc6b29646080ba$export$fb649c11ec6fc0c);
$parcel$export(module.exports, "useAttachmentStoreActions", () => $01cc6b29646080ba$export$e1ff1a92931d8142);

var $ggKAj = parcelRequire("ggKAj");

var $grFmB = parcelRequire("grFmB");

var $6tkcD = parcelRequire("6tkcD");
const $01cc6b29646080ba$var$getIssueAttachment = (state, issueKey)=>state.issueAttachments[issueKey] || (0, $grFmB.initialAttachmentState);
const $01cc6b29646080ba$var$getIsFetching = (state, issueKey)=>$01cc6b29646080ba$var$getIssueAttachment(state, issueKey).isFetching;
const $01cc6b29646080ba$var$getError = (state, issueKey)=>$01cc6b29646080ba$var$getIssueAttachment(state, issueKey).error;
const $01cc6b29646080ba$var$getOrderDirection = (state)=>state.meta.orderDirection;
const $01cc6b29646080ba$var$getOrderField = (state)=>state.meta.orderField;
const $01cc6b29646080ba$var$getTotalCount = (state, issueKey)=>$01cc6b29646080ba$var$getIssueAttachment(state, issueKey).totalCount;
const $01cc6b29646080ba$var$getDeletableCount = (state, issueKey)=>$01cc6b29646080ba$var$getIssueAttachment(state, issueKey).deletableCount;
const $01cc6b29646080ba$var$getStartAt = (state)=>state.meta.startAt;
const $01cc6b29646080ba$var$getVisibleAttachments = (state, issueKey)=>$01cc6b29646080ba$var$getIssueAttachment(state, issueKey).visibleAttachments;
const $01cc6b29646080ba$export$8d8ddf1ded2abe06 = (0, $ggKAj.createHook)((0, $6tkcD.store), {
    selector: $01cc6b29646080ba$var$getIsFetching
});
const $01cc6b29646080ba$export$54eb9f4a95926909 = (0, $ggKAj.createHook)((0, $6tkcD.store), {
    selector: $01cc6b29646080ba$var$getError
});
const $01cc6b29646080ba$export$bb091cd0dae17d3b = (0, $ggKAj.createHook)((0, $6tkcD.store), {
    selector: $01cc6b29646080ba$var$getOrderDirection
});
const $01cc6b29646080ba$export$2a9e7650d0508f23 = (0, $ggKAj.createHook)((0, $6tkcD.store), {
    selector: $01cc6b29646080ba$var$getOrderField
});
const $01cc6b29646080ba$export$197197a1bd69c0db = (0, $ggKAj.createHook)((0, $6tkcD.store), {
    selector: $01cc6b29646080ba$var$getTotalCount
});
const $01cc6b29646080ba$export$5c5679d3922a31be = (0, $ggKAj.createHook)((0, $6tkcD.store), {
    selector: $01cc6b29646080ba$var$getDeletableCount
});
const $01cc6b29646080ba$export$f127d1c515abe7f8 = (0, $ggKAj.createHook)((0, $6tkcD.store), {
    selector: $01cc6b29646080ba$var$getStartAt
});
const $01cc6b29646080ba$export$fb649c11ec6fc0c = (0, $ggKAj.createHook)((0, $6tkcD.store), {
    selector: $01cc6b29646080ba$var$getVisibleAttachments
});
const $01cc6b29646080ba$export$e1ff1a92931d8142 = (0, $ggKAj.createHook)((0, $6tkcD.store), {
    selector: null
});

});
parcelRegister("grFmB", function(module, exports) {

$parcel$export(module.exports, "initialAttachmentState", () => $7fb2d44c3b5d01c0$export$37ce094bd1de2f47);
$parcel$export(module.exports, "fetchAttachmentsRequest", () => $7fb2d44c3b5d01c0$export$6ebe08bd8927977d);
$parcel$export(module.exports, "deleteAttachmentRequest", () => $7fb2d44c3b5d01c0$export$a88777ed766766b8);

var $lRmyA = parcelRequire("lRmyA");

var $7gm9F = parcelRequire("7gm9F");
const $7fb2d44c3b5d01c0$export$37ce094bd1de2f47 = {
    isDownloading: false,
    isFetching: false,
    error: null,
    totalCount: undefined,
    deletableCount: undefined,
    visibleAttachments: []
};
const $7fb2d44c3b5d01c0$export$ae813837080f6e99 = ()=>`
  query attachmentsQuery($issueKey: String, $startAt: Long, $maxResults: Long, $orderField: AttachmentsOrderField, $orderDirection: OrderDirection) {
    viewIssue(issueKey: $issueKey) {
        attachments(startAt: $startAt, maxResults: $maxResults, orderField: $orderField, orderDirection: $orderDirection) {
            nodes {
                id
                filename
                mimetype
                mediaApiFileId
                createdDate
                filesize
                parentName
                parentId
                author {
                    accountId
                }
                hasRestrictedParent
            }
            totalCount
            deletableCount
        }
    }
  }`;
const $7fb2d44c3b5d01c0$var$defaultOptions = {
    startAt: 0,
    maxResults: 12,
    orderField: (0, $7gm9F.DEFAULT_ORDER_FIELD),
    orderDirection: (0, $7gm9F.DEFAULT_ORDER_DIRECTION)
};
const $7fb2d44c3b5d01c0$export$6ebe08bd8927977d = async (issueKey, options)=>{
    const mergedOptions = {
        ...$7fb2d44c3b5d01c0$var$defaultOptions,
        ...options
    };
    const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $7fb2d44c3b5d01c0$export$ae813837080f6e99(),
            variables: {
                issueKey: issueKey,
                ...mergedOptions
            }
        })
    });
    const attachmentsResponse = response?.data?.viewIssue?.attachments;
    if (attachmentsResponse && attachmentsResponse.nodes && attachmentsResponse.totalCount !== undefined) return response.data.viewIssue.attachments;
    return null;
};
const $7fb2d44c3b5d01c0$export$a88777ed766766b8 = async (attachmentId)=>(0, $lRmyA.performDeleteRequest)(`/rest/api/2/attachment/${attachmentId}`);

});
parcelRegister("7gm9F", function(module, exports) {

$parcel$export(module.exports, "ATTACHMENT_PARENT_ISSUE", () => $0374a8f344cf3250$export$1e9b2d39f8d14358);
$parcel$export(module.exports, "ATTACHMENT_PARENT", () => $0374a8f344cf3250$export$16fdebc4a148194);
$parcel$export(module.exports, "DEFAULT_ORDER_DIRECTION", () => $0374a8f344cf3250$export$ee3d5199d493da09);
$parcel$export(module.exports, "ORDER_FIELD", () => $0374a8f344cf3250$export$55c82710eb02082c);
$parcel$export(module.exports, "DEFAULT_ORDER_FIELD", () => $0374a8f344cf3250$export$393cb330f31d305c);
const $0374a8f344cf3250$export$1e9b2d39f8d14358 = 'issue';
const $0374a8f344cf3250$export$16fdebc4a148194 = {
    comment: 'comment',
    worklog: 'worklog',
    description: 'description',
    environment: 'environment',
    customfield: 'customfield',
    issue: $0374a8f344cf3250$export$1e9b2d39f8d14358,
    form: 'form'
};
const $0374a8f344cf3250$export$543711d9afc9aac1 = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $0374a8f344cf3250$export$ee3d5199d493da09 = $0374a8f344cf3250$export$543711d9afc9aac1.DESC;
const $0374a8f344cf3250$export$55c82710eb02082c = {
    FILENAME: 'FILENAME',
    CREATED: 'CREATED',
    FILESIZE: 'FILESIZE',
    MIMETYPE: 'MIMETYPE'
};
const $0374a8f344cf3250$export$393cb330f31d305c = $0374a8f344cf3250$export$55c82710eb02082c.CREATED;

});


parcelRegister("6tkcD", function(module, exports) {

$parcel$export(module.exports, "store", () => $b9189163daa43ab6$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "IssueAttachmentStoreContainer", () => $b9189163daa43ab6$export$aa34553c4a37367d);

var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $7gm9F = parcelRequire("7gm9F");

var $5hHDV = parcelRequire("5hHDV");
const $b9189163daa43ab6$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-attachments',
    initialState: {
        issueAttachments: {},
        meta: {
            orderDirection: (0, $7gm9F.DEFAULT_ORDER_DIRECTION),
            orderField: (0, $7gm9F.DEFAULT_ORDER_FIELD),
            startAt: 0,
            isDeleteAllDialogOpen: false
        }
    },
    actions: $5hHDV
});
const $b9189163daa43ab6$export$aa34553c4a37367d = (0, $heB5U.createContainer)($b9189163daa43ab6$export$6f57813fe9f31bf9);

});
parcelRegister("5hHDV", function(module, exports) {

$parcel$export(module.exports, "setIsDownloading", () => (parcelRequire("7x7QM")).setIsDownloading);
$parcel$export(module.exports, "setDeleteAllDialogOpen", () => (parcelRequire("fiMfG")).setDialogOpen);
$parcel$export(module.exports, "setIsFetching", () => (parcelRequire("hGSfj")).setIsFetching);
$parcel$export(module.exports, "setOrderDirection", () => (parcelRequire("hGSfj")).setOrderDirection);
$parcel$export(module.exports, "setOrderField", () => (parcelRequire("hGSfj")).setOrderField);
$parcel$export(module.exports, "setStartAt", () => (parcelRequire("hGSfj")).setStartAt);
$parcel$export(module.exports, "setTotalCount", () => (parcelRequire("hGSfj")).setTotalCount);
$parcel$export(module.exports, "setDeletableCount", () => (parcelRequire("hGSfj")).setDeletableCount);
$parcel$export(module.exports, "setVisibleAttachments", () => (parcelRequire("hGSfj")).setVisibleAttachments);
$parcel$export(module.exports, "addNewAttachments", () => (parcelRequire("hGSfj")).addNewAttachments);
$parcel$export(module.exports, "getAttachments", () => (parcelRequire("hGSfj")).getAttachments);
$parcel$export(module.exports, "getAttachmentsCount", () => (parcelRequire("hGSfj")).getAttachmentsCount);
$parcel$export(module.exports, "deleteAttachment", () => (parcelRequire("hGSfj")).deleteAttachment);
$parcel$export(module.exports, "refreshAttachments", () => (parcelRequire("hGSfj")).refreshAttachments);

var $hGSfj = parcelRequire("hGSfj");

var $fiMfG = parcelRequire("fiMfG");

var $7x7QM = parcelRequire("7x7QM");

});
parcelRegister("hGSfj", function(module, exports) {

$parcel$export(module.exports, "setIsFetching", () => $ae4f71dd22af3ec2$export$712649e6ba36ec70);
$parcel$export(module.exports, "setOrderDirection", () => $ae4f71dd22af3ec2$export$b596730931a09703);
$parcel$export(module.exports, "setOrderField", () => $ae4f71dd22af3ec2$export$248e21b8f4d18845);
$parcel$export(module.exports, "setTotalCount", () => $ae4f71dd22af3ec2$export$866518ec27d5a0a);
$parcel$export(module.exports, "setDeletableCount", () => $ae4f71dd22af3ec2$export$a63dc681d27de55d);
$parcel$export(module.exports, "setStartAt", () => $ae4f71dd22af3ec2$export$36e08dafecee97aa);
$parcel$export(module.exports, "setVisibleAttachments", () => $ae4f71dd22af3ec2$export$afed74160244aad2);
$parcel$export(module.exports, "addNewAttachments", () => $ae4f71dd22af3ec2$export$7af998b3fcbb94fd);
$parcel$export(module.exports, "getAttachmentsCount", () => $ae4f71dd22af3ec2$export$bc7b2493f56ac814);
$parcel$export(module.exports, "getAttachments", () => $ae4f71dd22af3ec2$export$bfec162b6d117444);
$parcel$export(module.exports, "deleteAttachment", () => $ae4f71dd22af3ec2$export$9ed76097473092d5);
$parcel$export(module.exports, "refreshAttachments", () => $ae4f71dd22af3ec2$export$b7036ab8fd409005);

var $gUUjF = parcelRequire("gUUjF");

var $7gm9F = parcelRequire("7gm9F");

var $grFmB = parcelRequire("grFmB");
const $ae4f71dd22af3ec2$export$712649e6ba36ec70 = (issueKey, isFetching)=>({ setState: setState, getState: getState })=>{
        const oldState = getState();
        setState({
            issueAttachments: {
                ...oldState.issueAttachments,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [issueKey]: {
                    ...oldState.issueAttachments[issueKey] || (0, $grFmB.initialAttachmentState),
                    isFetching: isFetching
                }
            }
        });
    };
const $ae4f71dd22af3ec2$export$b8d0bb2aa0adefe5 = (issueKey, error)=>({ setState: setState, getState: getState })=>{
        const oldState = getState();
        setState({
            issueAttachments: {
                ...oldState.issueAttachments,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [issueKey]: {
                    ...oldState.issueAttachments[issueKey] || (0, $grFmB.initialAttachmentState),
                    error: error
                }
            }
        });
    };
const $ae4f71dd22af3ec2$export$b596730931a09703 = (orderDirection)=>({ getState: getState, setState: setState })=>{
        const { meta: currentMeta } = getState();
        setState({
            meta: {
                ...currentMeta,
                orderDirection: orderDirection
            }
        });
    };
const $ae4f71dd22af3ec2$export$248e21b8f4d18845 = (orderField)=>({ getState: getState, setState: setState })=>{
        const { meta: currentMeta } = getState();
        setState({
            meta: {
                ...currentMeta,
                orderField: orderField
            }
        });
    };
const $ae4f71dd22af3ec2$export$866518ec27d5a0a = (issueKey, totalCount)=>({ setState: setState, getState: getState })=>{
        const oldState = getState();
        setState({
            issueAttachments: {
                ...oldState.issueAttachments,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [issueKey]: {
                    ...oldState.issueAttachments[issueKey] || (0, $grFmB.initialAttachmentState),
                    totalCount: totalCount
                }
            }
        });
    };
const $ae4f71dd22af3ec2$export$a63dc681d27de55d = (issueKey, deletableCount)=>({ setState: setState, getState: getState })=>{
        const oldState = getState();
        setState({
            issueAttachments: {
                ...oldState.issueAttachments,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [issueKey]: {
                    ...oldState.issueAttachments[issueKey] || (0, $grFmB.initialAttachmentState),
                    deletableCount: deletableCount
                }
            }
        });
    };
const $ae4f71dd22af3ec2$export$36e08dafecee97aa = (startAt)=>({ getState: getState, setState: setState })=>{
        const { meta: currentMeta } = getState();
        setState({
            meta: {
                ...currentMeta,
                startAt: startAt
            }
        });
    };
const $ae4f71dd22af3ec2$export$afed74160244aad2 = (issueKey, visibleAttachments)=>({ setState: setState, getState: getState })=>{
        const oldState = getState();
        setState({
            issueAttachments: {
                ...oldState.issueAttachments,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [issueKey]: {
                    ...oldState.issueAttachments[issueKey] || (0, $grFmB.initialAttachmentState),
                    visibleAttachments: visibleAttachments
                }
            }
        });
    };
const $ae4f71dd22af3ec2$export$7af998b3fcbb94fd = (issueKey, newAttachments)=>({ setState: setState, getState: getState })=>{
        const oldState = getState();
        const oldAttachments = oldState.issueAttachments[issueKey] ? oldState.issueAttachments[issueKey].visibleAttachments : [];
        const oldTotalCount = oldState.issueAttachments[issueKey] ? oldState.issueAttachments[issueKey].totalCount || 0 : 0;
        const allAttachments = newAttachments.concat(oldAttachments);
        const totalCount = oldTotalCount + newAttachments.length;
        setState({
            issueAttachments: {
                ...oldState.issueAttachments,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [issueKey]: {
                    ...oldState.issueAttachments[issueKey] || (0, $grFmB.initialAttachmentState),
                    visibleAttachments: allAttachments,
                    totalCount: totalCount
                }
            }
        });
    };
const $ae4f71dd22af3ec2$export$bc7b2493f56ac814 = (issueKey)=>({ getState: getState })=>{
        const currentState = getState();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return currentState.issueAttachments[issueKey]?.totalCount ?? 0;
    };
const $ae4f71dd22af3ec2$export$bfec162b6d117444 = (issueKey, fetchOptions)=>async ({ dispatch: dispatch })=>{
        dispatch($ae4f71dd22af3ec2$export$712649e6ba36ec70(issueKey, true));
        dispatch($ae4f71dd22af3ec2$export$b8d0bb2aa0adefe5(issueKey, null));
        try {
            const response = await (0, $grFmB.fetchAttachmentsRequest)(issueKey, fetchOptions);
            if (response) {
                dispatch($ae4f71dd22af3ec2$export$866518ec27d5a0a(issueKey, response.totalCount));
                typeof response.deletableCount === 'number' && dispatch($ae4f71dd22af3ec2$export$a63dc681d27de55d(issueKey, response.deletableCount));
                dispatch($ae4f71dd22af3ec2$export$afed74160244aad2(issueKey, response.nodes));
                // Set or reset pagination/sorting
                dispatch($ae4f71dd22af3ec2$export$b596730931a09703(fetchOptions?.orderDirection || (0, $7gm9F.DEFAULT_ORDER_DIRECTION)));
                dispatch($ae4f71dd22af3ec2$export$248e21b8f4d18845(fetchOptions?.orderField || (0, $7gm9F.DEFAULT_ORDER_FIELD)));
                dispatch($ae4f71dd22af3ec2$export$36e08dafecee97aa(fetchOptions?.startAt || 0));
            } else {
                const errorString = 'Failed to fetch issue attachments';
                dispatch($ae4f71dd22af3ec2$export$b8d0bb2aa0adefe5(issueKey, new Error(errorString)));
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.attachments.fetch-attachments', errorString);
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            dispatch($ae4f71dd22af3ec2$export$b8d0bb2aa0adefe5(issueKey, e));
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.attachments.fetch-attachments', e.toString());
        }
        dispatch($ae4f71dd22af3ec2$export$712649e6ba36ec70(issueKey, false));
    };
const $ae4f71dd22af3ec2$export$9ed76097473092d5 = (issueKey, deletingAttachmentId, fetchOptions)=>async ({ dispatch: dispatch, getState: getState })=>{
        const state = getState();
        const issueAttachments = state.issueAttachments[issueKey];
        if (!issueAttachments) return;
        const { totalCount: totalCount, visibleAttachments: visibleAttachments } = issueAttachments;
        if (totalCount !== undefined) {
            dispatch($ae4f71dd22af3ec2$export$afed74160244aad2(issueKey, visibleAttachments.filter((attachment)=>attachment.id !== deletingAttachmentId)));
            dispatch($ae4f71dd22af3ec2$export$866518ec27d5a0a(issueKey, totalCount - 1));
            try {
                await (0, $grFmB.deleteAttachmentRequest)(deletingAttachmentId);
                dispatch($ae4f71dd22af3ec2$export$bfec162b6d117444(issueKey, fetchOptions));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                dispatch($ae4f71dd22af3ec2$export$bfec162b6d117444(issueKey, fetchOptions));
                throw error;
            }
        }
    };
const $ae4f71dd22af3ec2$export$b7036ab8fd409005 = (issueKey, fetchOptions)=>({ dispatch: dispatch, getState: getState })=>{
        const state = getState();
        const issueAttachments = state.issueAttachments[issueKey];
        if (!issueAttachments) return;
        const { startAt: startAt } = state.meta;
        const { isFetching: isFetching } = issueAttachments;
        if (!isFetching || fetchOptions && fetchOptions.startAt !== startAt) dispatch($ae4f71dd22af3ec2$export$bfec162b6d117444(issueKey, fetchOptions));
    };

});

parcelRegister("fiMfG", function(module, exports) {

$parcel$export(module.exports, "setDialogOpen", () => $039c084aa6bdefc5$export$a0c49ac87c8d6d09);
const $039c084aa6bdefc5$export$a0c49ac87c8d6d09 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const { meta: currentMeta } = getState();
        setState({
            meta: {
                ...currentMeta,
                isDeleteAllDialogOpen: isOpen
            }
        });
    };

});

parcelRegister("7x7QM", function(module, exports) {

$parcel$export(module.exports, "setIsDownloading", () => $99b058ff41f7a89a$export$2eb384adb510de4a);
const $99b058ff41f7a89a$export$2eb384adb510de4a = (issueKey, isDownloading)=>({ setState: setState, getState: getState })=>{
        const oldState = getState();
        setState({
            // @ts-expect-error - TS2322 - Type '{ [x: string]: { isDownloading: boolean; isFetching: boolean; error: Error | null; totalCount: number | undefined; deletableCount: number | undefined; visibleAttachments: Attachment[]; } | { ...; } | undefined; }' is not assignable to type 'Partial<Record<string, { isDownloading: boolean; isFetching: boolean; error: Error | null; totalCount: number | undefined; deletableCount: number | undefined; visibleAttachments: Attachment[]; } | undefined>>'.
            issueAttachments: {
                ...oldState.issueAttachments,
                [issueKey]: {
                    ...oldState.issueAttachments[issueKey],
                    isDownloading: isDownloading
                }
            }
        });
    };

});





parcelRegister("k9hJ7", function(module, exports) {

$parcel$export(module.exports, "useIssueRefreshLoadingActions", () => $dc0783436e95d0db$export$9368d108daf4f0e4);
$parcel$export(module.exports, "IssueRefreshLoadingContainer", () => $dc0783436e95d0db$export$67fd075af217226a);
$parcel$export(module.exports, "useBackgroundRefreshLoading", () => $dc0783436e95d0db$export$b515284e9232d0cd);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");
const $dc0783436e95d0db$var$initialState = {
    backgroundRefreshStatus: 'UNKNOWN',
    realTimeRefreshStatus: 'UNKNOWN'
};
const $dc0783436e95d0db$var$actions = {
    setBackgroundRefreshLoadingStatus: (status)=>({ setState: setState })=>{
            setState({
                backgroundRefreshStatus: status
            });
        },
    setRealTimeRefreshLoadingStatus: (status)=>({ setState: setState })=>{
            setState({
                realTimeRefreshStatus: status
            });
        }
};
const $dc0783436e95d0db$var$store = (0, $a61MH.createStore)({
    name: 'issue-view.issue-actions.issue-refresh-loading',
    initialState: $dc0783436e95d0db$var$initialState,
    actions: $dc0783436e95d0db$var$actions
});
const $dc0783436e95d0db$export$9368d108daf4f0e4 = (0, $ggKAj.createActionsHook)($dc0783436e95d0db$var$store);
const $dc0783436e95d0db$export$67fd075af217226a = (0, $heB5U.createContainer)($dc0783436e95d0db$var$store);
const $dc0783436e95d0db$var$selectBackgroundRefreshLoadingStatus = (state)=>state.backgroundRefreshStatus;
const $dc0783436e95d0db$var$selectRealTimeRefreshLoadingStatus = (state)=>state.realTimeRefreshStatus;
const $dc0783436e95d0db$export$b515284e9232d0cd = (0, $ggKAj.createStateHook)($dc0783436e95d0db$var$store, {
    selector: $dc0783436e95d0db$var$selectBackgroundRefreshLoadingStatus
});
const $dc0783436e95d0db$export$b2bfb615e7f29d62 = (0, $ggKAj.createStateHook)($dc0783436e95d0db$var$store, {
    selector: $dc0783436e95d0db$var$selectRealTimeRefreshLoadingStatus
});

});

parcelRegister("K1Vl8", function(module, exports) {

$parcel$export(module.exports, "IssueFieldEditingContextProvider", () => $0020916cdd1ca709$export$4bdcf555c5e0921f);
$parcel$export(module.exports, "useOptionallyControlledEditingState", () => $0020916cdd1ca709$export$db1e18c2e86e1a50);

var $eUqFw = parcelRequire("eUqFw");

var $a7bke = parcelRequire("a7bke");
const $0020916cdd1ca709$export$c436e295255cfd98 = /*#__PURE__*/ (0, $eUqFw.createContext)('localStateMode');
const $0020916cdd1ca709$export$4bdcf555c5e0921f = ({ children: children, scope: scope })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0020916cdd1ca709$export$c436e295255cfd98.Provider, {
        value: "sharedStateMode"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a7bke.FieldEditingContainer), {
        scope: scope
    }, children));
const $0020916cdd1ca709$export$db1e18c2e86e1a50 = (initialState, fieldId, onChangeMethods)=>{
    const editingContext = (0, $eUqFw.useContext)($0020916cdd1ca709$export$c436e295255cfd98);
    const isLocalStateMode = editingContext !== 'sharedStateMode';
    const [sharedState, { setFieldEditingState: setFieldEditingState }] = (0, $a7bke.useFieldIsEditing)(fieldId);
    const [localState, setLocalState] = (0, $eUqFw.useState)(isLocalStateMode ? initialState : sharedState);
    const unifiedOnChange = (0, $eUqFw.useCallback)((newValue)=>{
        onChangeMethods?.onLocalChange?.(newValue, localState);
        onChangeMethods?.onChange?.(newValue, localState);
        setLocalState(newValue);
        if (!isLocalStateMode) setFieldEditingState(fieldId, newValue);
    }, [
        fieldId,
        isLocalStateMode,
        onChangeMethods,
        setFieldEditingState,
        localState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // If sharedState updates to a value that is different from localState, it's a shared state update.
        // Otherwise, it's just the shared state following a locally triggered state update
        if (!isLocalStateMode && sharedState !== localState) {
            onChangeMethods?.onSharedChange?.(sharedState, !sharedState);
            onChangeMethods?.onChange?.(sharedState, !sharedState);
            setLocalState(sharedState);
        }
    // We want to ensure this useEffect is only called when the sharedState changes, not when any other dependencies change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sharedState
    ]);
    const resultState = isLocalStateMode ? localState : sharedState;
    return [
        resultState,
        unifiedOnChange
    ];
};

});
parcelRegister("a7bke", function(module, exports) {

$parcel$export(module.exports, "useFieldIsEditing", () => $9e81d13d24b072fc$export$3734a1b20e979e6e);
$parcel$export(module.exports, "useFieldIsEditingActions", () => $9e81d13d24b072fc$export$a4850d650526df2e);
$parcel$export(module.exports, "FieldEditingContainer", () => $9e81d13d24b072fc$export$4301025b8d3e0255);

var $czx3b = parcelRequire("czx3b");

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");
const $9e81d13d24b072fc$var$Store = (0, $a61MH.createStore)({
    initialState: {},
    actions: {
        setFieldEditingState: (fieldId, isEditing)=>({ setState: setState })=>{
                setState({
                    [fieldId]: isEditing
                });
            },
        toggleFieldEditingState: (fieldId)=>({ setState: setState, getState: getState })=>{
                if (getState()[fieldId] == null) return undefined;
                const toggledValue = !getState()[fieldId];
                setState({
                    [fieldId]: toggledValue
                });
                return toggledValue;
            },
        getFieldEditingState: (fieldId)=>({ getState: getState })=>getState()[fieldId],
        resetFieldEditingStateStore: ()=>({ setState: setState, getState: getState })=>{
                setState((0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(getState(), ()=>false));
            }
    },
    name: 'FieldEditingState'
});
const $9e81d13d24b072fc$export$3734a1b20e979e6e = (0, $ggKAj.createHook)($9e81d13d24b072fc$var$Store, {
    selector: (state, arg)=>state[arg] != null ? state[arg] : false
});
const $9e81d13d24b072fc$export$a4850d650526df2e = (0, $ggKAj.createActionsHook)($9e81d13d24b072fc$var$Store);
const $9e81d13d24b072fc$export$4301025b8d3e0255 = (0, $heB5U.createContainer)($9e81d13d24b072fc$var$Store);

});


parcelRegister("dMD2I", function(module, exports) {

$parcel$export(module.exports, "useMediaContextUnsafe", () => $1fd63552dcb8a721$export$803413e8e9ad4fcd);
$parcel$export(module.exports, "useMediaContext", () => $1fd63552dcb8a721$export$2d636d13f24b27df);
$parcel$export(module.exports, "useMediaContextActions", () => $1fd63552dcb8a721$export$172587b1623c4b83);

var $eUqFw = parcelRequire("eUqFw");

var $yQthz = parcelRequire("yQthz");
const $1fd63552dcb8a721$export$803413e8e9ad4fcd = (issueKey)=>{
    const [mediaContext] = (0, $yQthz.useMediaContextStore)(issueKey);
    return mediaContext;
};
const $1fd63552dcb8a721$export$2d636d13f24b27df = (issueKey)=>{
    const [mediaContext] = (0, $yQthz.useMediaContextStore)(issueKey);
    return mediaContext;
};
const $1fd63552dcb8a721$export$172587b1623c4b83 = ()=>{
    const [, { setViewContext: setViewContext, setUploadContext: setUploadContext, setUserAuthContext: setUserAuthContext }] = (0, $yQthz.useMediaContextStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setViewContext: setViewContext,
            setUploadContext: setUploadContext,
            setUserAuthContext: setUserAuthContext
        }), [
        setViewContext,
        setUploadContext,
        setUserAuthContext
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("yQthz", function(module, exports) {

$parcel$export(module.exports, "useMediaContextStore", () => $53f80cc4e878d72c$export$46c137231247a5a5);
$parcel$export(module.exports, "useMediaContextStoreActions", () => $53f80cc4e878d72c$export$248f9c7f818f5e44);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $i6W8g = parcelRequire("i6W8g");
const $53f80cc4e878d72c$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'media-context',
    initialState: {},
    actions: $i6W8g
});
const $53f80cc4e878d72c$var$getMediaSelector = (state, issueKey)=>state[issueKey];
const $53f80cc4e878d72c$export$46c137231247a5a5 = (0, $ggKAj.createHook)($53f80cc4e878d72c$export$6f57813fe9f31bf9, {
    selector: $53f80cc4e878d72c$var$getMediaSelector
});
const $53f80cc4e878d72c$export$248f9c7f818f5e44 = (0, $ggKAj.createHook)($53f80cc4e878d72c$export$6f57813fe9f31bf9);

});
parcelRegister("i6W8g", function(module, exports) {

$parcel$export(module.exports, "setViewContext", () => $7f54df5f0f990734$export$8dad3433bf08f4d);
$parcel$export(module.exports, "setUploadContext", () => $7f54df5f0f990734$export$d50b6be00915c5d);
$parcel$export(module.exports, "setUserAuthContext", () => $7f54df5f0f990734$export$2b9ceccff2ce0ffc);
const $7f54df5f0f990734$export$8dad3433bf08f4d = (issueKey, viewContext)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                viewContext: viewContext
            }
        });
    };
const $7f54df5f0f990734$export$d50b6be00915c5d = (issueKey, uploadContext)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                uploadContext: uploadContext
            }
        });
    };
const $7f54df5f0f990734$export$2b9ceccff2ce0ffc = (issueKey, userAuth)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                userAuth: userAuth
            }
        });
    };

});



parcelRegister("6D0iK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce140bdc8caa94c6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $6JJU8 = parcelRequire("6JJU8");
const $ce140bdc8caa94c6$var$useIssueViewNonCriticalData = (issueKey, prefetchedResourceManager)=>{
    const [allData, { fetch: fetch }] = (0, $6JJU8.useAllIssueViewAsyncData)();
    const data = allData[issueKey] ?? {};
    const { isFetching: isFetching = false, isReady: isReady = false } = data;
    const fetchNonCriticalData = (0, $eUqFw.useCallback)((key)=>fetch(key, prefetchedResourceManager), [
        fetch,
        prefetchedResourceManager
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!!issueKey && !isFetching && !isReady) // Trigger the data to be fetched and updated when the issue key changes.
        // In practice this should always come through the prefetchedResourceManager
        // as the fetch should always be kicked off by either the early script, or the
        // useLazyLoadingResourceManager at render time.
        fetchNonCriticalData(issueKey);
    }, [
        issueKey,
        isFetching,
        isReady,
        fetchNonCriticalData
    ]);
    return [
        data,
        {
            fetchNonCriticalData: fetchNonCriticalData
        }
    ];
};
const $ce140bdc8caa94c6$export$1a01ae0705bafd37 = [
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {},
    {
        fetchNonCriticalData: ()=>Promise.resolve()
    }
];
var $ce140bdc8caa94c6$export$2e2bcd8739ae039 = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w'), $ce140bdc8caa94c6$var$useIssueViewNonCriticalData, ()=>$ce140bdc8caa94c6$export$1a01ae0705bafd37);

});
parcelRegister("6JJU8", function(module, exports) {

$parcel$export(module.exports, "useAllIssueViewAsyncData", () => $e6fdafb36ffc0bdd$export$d2f0025474fdf06d);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $gUUjF = parcelRequire("gUUjF");

var $8yjUM = parcelRequire("8yjUM");
const $e6fdafb36ffc0bdd$var$initialState = {};
const $e6fdafb36ffc0bdd$var$fetch = (issueKey, prefetchedResourceManager)=>async ({ setState: setState, getState: getState })=>{
        if (getState()?.[issueKey]?.isFetching) return;
        setState({
            [issueKey]: {
                ...getState()[issueKey],
                isFetching: true
            }
        });
        try {
            const data = await (0, $8yjUM.fetchNonCriticalGiraDataWithRetries)(issueKey, prefetchedResourceManager);
            setState({
                [issueKey]: {
                    value: data,
                    isFetching: false,
                    isReady: true
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fetch.gira-non-critical', 'Failed to fetch non-critical Gira data', error);
            setState({
                [issueKey]: {
                    ...getState()[issueKey],
                    isFetching: false,
                    isReady: true
                }
            });
        }
    };
const $e6fdafb36ffc0bdd$export$e324594224ef24da = {
    fetch: $e6fdafb36ffc0bdd$var$fetch
};
const $e6fdafb36ffc0bdd$var$Store = (0, $a61MH.createStore)({
    initialState: $e6fdafb36ffc0bdd$var$initialState,
    actions: $e6fdafb36ffc0bdd$export$e324594224ef24da,
    name: 'IssueViewNonCriticalData'
});
const $e6fdafb36ffc0bdd$export$d2f0025474fdf06d = (0, $ggKAj.createHook)($e6fdafb36ffc0bdd$var$Store);

});
parcelRegister("8yjUM", function(module, exports) {

$parcel$export(module.exports, "fetchNonCriticalGiraDataWithRetries", () => $5c5e2ab49a5cda18$export$28362dba0b388477);

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $3lpdA = parcelRequire("3lpdA");

var $lwu0A = parcelRequire("lwu0A");

var $dgVEl = parcelRequire("dgVEl");

var $c0n1R = parcelRequire("c0n1R");
const $5c5e2ab49a5cda18$var$isNonCriticalGiraQueryExperienceTrackingEnabled = ()=>(0, $1ybV0.ff)('issue.details.non-critical-gira-query-experience-tracking', false);
const $5c5e2ab49a5cda18$var$consumePrefetchedData = async (prefetchedResourceManager)=>{
    const prefetchedDataPromise = prefetchedResourceManager.issueGiraNonCriticalData;
    prefetchedResourceManager.clearGiraNonCriticalData();
    const response = await prefetchedDataPromise;
    return response;
};
const $5c5e2ab49a5cda18$var$fetchData = async (issueKey)=>{
    const response = await (0, $lwu0A.fetchIssueGiraNonCriticalData)(issueKey);
    return response;
};
const $5c5e2ab49a5cda18$var$transformData = (viewIssue)=>{
    const result = {
        operations: (0, $c0n1R.transformEcosystemOperations)(viewIssue.ecosystem?.operations),
        ...(0, $1ybV0.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on') ? {
            backgroundScripts: (0, $c0n1R.transformEcosystemBackgroundScripts)(viewIssue.ecosystem?.backgroundScripts)
        } : {},
        ...(0, $1ybV0.ff)('issue.details.gira-agg-migration-attachments_ecebe') ? {
            deletableAttachmentsCount: viewIssue.deletableAttachmentsCount || 0
        } : {},
        ...(0, $1ybV0.ff)('issue-view-remove-activitypanels-from-critical-fetch_43ozj') ? {
            activityPanels: (0, $c0n1R.transformEcosystemActivityPanels)(viewIssue.ecosystem?.activityPanels)
        } : {}
    };
    return result;
};
const $5c5e2ab49a5cda18$export$28362dba0b388477 = async (issueKey, prefetchedResourceManager)=>{
    const hasPrefetchPromise = prefetchedResourceManager?.issueKey === issueKey && !!prefetchedResourceManager?.issueGiraNonCriticalData;
    const getData = ()=>hasPrefetchPromise ? $5c5e2ab49a5cda18$var$consumePrefetchedData(prefetchedResourceManager) : $5c5e2ab49a5cda18$var$fetchData(issueKey);
    const doFetch = ()=>$5c5e2ab49a5cda18$var$fetchData(issueKey);
    const response = await (0, $3lpdA.retryOnError)(getData, {
        retryFunc: doFetch
    });
    const { errors: errors } = response || {};
    if (!response?.data?.viewIssue) {
        // If the response is completely missing the data, throw an error
        const message = errors ? JSON.stringify((0, $dgVEl.makeErrorObject)(errors)) : 'No data returned for non-critical Gira query';
        throw new Error(message);
    } else if (errors?.length) // Log an error for partial failure and try to continue
    (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fetch.gira-non-critical.partial', 'Partial failure when fetching non-critical Gira data', (0, $dgVEl.makeErrorObject)(errors));
    try {
        const transformedData = $5c5e2ab49a5cda18$var$transformData(response.data.viewIssue);
        if ($5c5e2ab49a5cda18$var$isNonCriticalGiraQueryExperienceTrackingEnabled() && hasPrefetchPromise) (0, $lwu0A.nonCriticalGiraQueryExperienceTracking)({
            wasExperienceSuccessful: true,
            isEarlyFetch: true
        });
        return transformedData;
    } catch (error) {
        throw new Error(`Failed to transform non-critical Gira data: ${error}`);
    }
};

});
parcelRegister("dgVEl", function(module, exports) {

$parcel$export(module.exports, "makeErrorObject", () => $d601c4c221b32f81$export$1906517f4e57a97c);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
const $d601c4c221b32f81$export$1906517f4e57a97c = (errors, _eventNameSuffix = (0, $f69c8ee53374c3a2$export$c8c19c4d8951a3c9))=>{
    let errorCounter = 0;
    const getErrorKey = (val)=>{
        // @ts-expect-error - TS2339 - Property 'path' does not exist on type 'PayloadError | GraphQlError'. | TS2339 - Property 'path' does not exist on type 'PayloadError | GraphQlError'.
        if (val.path !== null && Array.isArray(val.path)) // @ts-expect-error - TS2339 - Property 'path' does not exist on type 'PayloadError | GraphQlError'.
        return val.path.join('.');
        if (val.locations) return val.locations.map((loc)=>`line ${loc.line}, column ${loc.column}`).join('&');
        errorCounter += 1;
        return `error without path or location: ${errorCounter}`;
    };
    const error = errors.reduce((acc, val)=>({
            ...acc,
            [getErrorKey(val)]: val.message
        }), {});
    return error;
};

});
const $f69c8ee53374c3a2$export$7f813a48aabc0c5 = 'GlancesField';
const $f69c8ee53374c3a2$export$2c73285ae9390cec = 'TextField';
const $f69c8ee53374c3a2$export$c8c19c4d8951a3c9 = 'issue.error.gira';


parcelRegister("c0n1R", function(module, exports) {

$parcel$export(module.exports, "transformEcosystemOperations", () => $439d0dba105dabfd$export$d164a9603e733cd9);
$parcel$export(module.exports, "transformEcosystemBackgroundScripts", () => $439d0dba105dabfd$export$e03215365be0c2c8);
$parcel$export(module.exports, "transformEcosystemActivityPanels", () => $439d0dba105dabfd$export$b85605f2c34fe69e);

const $439d0dba105dabfd$export$92b010dbb91b5a57 = (serverOptions)=>typeof serverOptions === 'string' ? JSON.parse(serverOptions) : serverOptions;
const $439d0dba105dabfd$export$d164a9603e733cd9 = (operations)=>{
    if (!operations) return [];
    return operations.map(({ name: name, url: url, tooltip: tooltip, styleClass: styleClass })=>({
            name: name ?? '',
            url: url ?? '',
            tooltip: tooltip ?? undefined,
            styleClass: styleClass ?? undefined
        }));
};
const $439d0dba105dabfd$export$e03215365be0c2c8 = (backgroundScripts)=>{
    if (!backgroundScripts) return [];
    return backgroundScripts.map(({ iframe: iframe, shouldReloadOnRefresh: shouldReloadOnRefresh })=>({
            appKey: iframe?.addonKey ?? '',
            moduleKey: iframe?.moduleKey ?? '',
            options: $439d0dba105dabfd$export$92b010dbb91b5a57(iframe?.options),
            shouldReloadOnRefresh: shouldReloadOnRefresh
        }));
};
const $439d0dba105dabfd$export$b85605f2c34fe69e = (activityPanels)=>{
    if (!activityPanels) return [];
    return activityPanels.map(({ name: name, iframe: iframe })=>({
            name: name,
            appKey: iframe?.addonKey ?? '',
            moduleKey: iframe?.moduleKey ?? '',
            options: $439d0dba105dabfd$export$92b010dbb91b5a57(iframe?.options),
            type: (0, $a236b3f85afb3e5c$export$1b2059a011c9174d)
        }))// backend return for `activityPanels` is ordered by `weight` decsending
    // need to reverse() to get correct ascending activity order
    .reverse();
};

});
const $a236b3f85afb3e5c$export$1b2059a011c9174d = 'CONNECT_ENTITY_TYPE';
const $a236b3f85afb3e5c$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';





parcelRegister("gd8Po", function(module, exports) {

$parcel$export(module.exports, "useOnboardingTourStore", () => $3652f29db8c9a842$export$3660a206dc2411f);
$parcel$export(module.exports, "OnboardingTourContainer", () => $3652f29db8c9a842$export$4b466b5e7601c55c);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $fRkUS = parcelRequire("fRkUS");
const $3652f29db8c9a842$export$d4c72bab9d6cc13a = {
    isTourActive: false
};
const $3652f29db8c9a842$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'new-issue-view-onboarding',
    initialState: $3652f29db8c9a842$export$d4c72bab9d6cc13a,
    actions: $fRkUS
});
const $3652f29db8c9a842$var$getNewIssueViewOnboarding = (state)=>state;
const $3652f29db8c9a842$export$3660a206dc2411f = (0, $ggKAj.createHook)($3652f29db8c9a842$export$6f57813fe9f31bf9, {
    selector: $3652f29db8c9a842$var$getNewIssueViewOnboarding
});
const $3652f29db8c9a842$export$4b466b5e7601c55c = (0, $heB5U.createContainer)($3652f29db8c9a842$export$6f57813fe9f31bf9);

});
parcelRegister("fRkUS", function(module, exports) {

$parcel$export(module.exports, "setTourIsActive", () => $1bd4576dd9e0ba5b$export$3f9a7a7e4a785157);
$parcel$export(module.exports, "setTourIsInactive", () => $1bd4576dd9e0ba5b$export$cf5891e9a7d7040f);
const $1bd4576dd9e0ba5b$export$3f9a7a7e4a785157 = ()=>({ setState: setState })=>{
        setState({
            isTourActive: true
        });
    };
const $1bd4576dd9e0ba5b$export$cf5891e9a7d7040f = ()=>({ setState: setState })=>{
        setState({
            isTourActive: false
        });
    };

});


parcelRegister("eyYNo", function(module, exports) {

$parcel$export(module.exports, "useIssueRefreshServiceActions", () => $ea165bf3b98191e7$export$1d4ae986a28c6475);
$parcel$export(module.exports, "useIssueRefreshData", () => $ea165bf3b98191e7$export$df80cc571c0df8e1);
$parcel$export(module.exports, "useOnDemandIssueRefreshTime", () => $ea165bf3b98191e7$export$8fbec4e20425478e);

var $b3GF8 = parcelRequire("b3GF8");
const $ea165bf3b98191e7$export$1d4ae986a28c6475 = ()=>{
    const [, { setEvent: setEvent, setEventAsReported: setEventAsReported }] = (0, $b3GF8.useIssueRefreshServiceStore)();
    return [
        undefined,
        {
            setEvent: setEvent,
            setEventAsReported: setEventAsReported
        }
    ];
};
const $ea165bf3b98191e7$export$df80cc571c0df8e1 = ()=>{
    const [{ events: { REALTIME: REALTIME } }] = (0, $b3GF8.useIssueRefreshServiceStore)();
    return {
        REALTIME: REALTIME
    };
};
const $ea165bf3b98191e7$export$8fbec4e20425478e = ()=>{
    const [{ events: { ON_DEMAND: ON_DEMAND } }] = (0, $b3GF8.useIssueRefreshServiceStore)();
    return ON_DEMAND?.timestamp || 0;
};

});
parcelRegister("b3GF8", function(module, exports) {

$parcel$export(module.exports, "IssueRefreshServiceStoreContainer", () => $75a35c3cf18d5a24$export$fedd9d9016e9d8f);
$parcel$export(module.exports, "useIssueRefreshServiceStore", () => $75a35c3cf18d5a24$export$a5a0a45de2c4b94e);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $6wxs5 = parcelRequire("6wxs5");
const $75a35c3cf18d5a24$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-view-realtime-service',
    initialState: {
        events: {}
    },
    actions: $6wxs5
});
const $75a35c3cf18d5a24$export$fedd9d9016e9d8f = (0, $heB5U.createContainer)($75a35c3cf18d5a24$export$6f57813fe9f31bf9);
const $75a35c3cf18d5a24$export$a5a0a45de2c4b94e = (0, $ggKAj.createHook)($75a35c3cf18d5a24$export$6f57813fe9f31bf9);

});
parcelRegister("6wxs5", function(module, exports) {

$parcel$export(module.exports, "setEvent", () => $735bdb5c7b931553$export$9c04d8fd885bb013);
$parcel$export(module.exports, "setEventAsReported", () => $735bdb5c7b931553$export$ac0ddf6f44317073);

var $7eDnP = parcelRequire("7eDnP");
const $735bdb5c7b931553$export$9c04d8fd885bb013 = (payload)=>({ setState: setState, getState: getState })=>{
        const timestamp = Date.now();
        const { reason: reason, refreshed: refreshed } = payload;
        const reported = false;
        let event;
        switch(reason){
            case (0, $7eDnP.Reason).Realtime:
                {
                    const { details: details } = payload;
                    event = {
                        [reason]: {
                            timestamp: timestamp,
                            details: details,
                            refreshed: refreshed,
                            reported: reported
                        }
                    };
                    break;
                }
            case (0, $7eDnP.Reason).SoftRefresh:
                event = {
                    [reason]: {
                        timestamp: timestamp,
                        refreshed: refreshed,
                        reported: reported
                    }
                };
                break;
            case (0, $7eDnP.Reason).OnDemand:
            default:
                event = {
                    [(0, $7eDnP.Reason).OnDemand]: {
                        timestamp: timestamp,
                        refreshed: refreshed,
                        reported: reported
                    }
                };
                break;
        }
        setState({
            events: {
                ...getState().events,
                ...event
            }
        });
    };
const $735bdb5c7b931553$export$ac0ddf6f44317073 = (eventReason)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const event = state.events[eventReason];
        if (!event) return;
        setState({
            events: {
                ...state.events,
                [eventReason]: {
                    ...event,
                    reported: true
                }
            }
        });
    };

});



parcelRegister("4c7sd", function(module, exports) {

$parcel$export(module.exports, "useIssueScroll", () => $95ee6d688d6d8ab4$export$9b8215d6360077ce);
$parcel$export(module.exports, "useIssueScrollActions", () => $95ee6d688d6d8ab4$export$6d0148cd0d1ef3f0);

var $2Wgls = parcelRequire("2Wgls");
const $95ee6d688d6d8ab4$export$9b8215d6360077ce = ()=>{
    const [scrollTarget, { setScrollTarget: setScrollTarget, getScrollTargetId: getScrollTargetId }] = (0, $2Wgls.useScrollStoreScrollTarget)();
    return [
        {
            scrollTarget: scrollTarget
        },
        {
            setScrollTarget: setScrollTarget,
            getScrollTargetId: getScrollTargetId
        }
    ];
};
const $95ee6d688d6d8ab4$export$6d0148cd0d1ef3f0 = ()=>{
    const [, { setScrollTarget: setScrollTarget, getScrollTargetId: getScrollTargetId }] = (0, $2Wgls.useScrollStoreScrollTargetActions)();
    return [
        undefined,
        {
            setScrollTarget: setScrollTarget,
            getScrollTargetId: getScrollTargetId
        }
    ];
};

});
parcelRegister("2Wgls", function(module, exports) {

$parcel$export(module.exports, "useScrollStoreScrollTarget", () => $b49d7d8578f7dfd9$export$bee935f9618f7d1f);
$parcel$export(module.exports, "useScrollStoreScrollTargetActions", () => $b49d7d8578f7dfd9$export$80a04581afa7e5b0);

var $ggKAj = parcelRequire("ggKAj");

var $2z6ly = parcelRequire("2z6ly");
const $b49d7d8578f7dfd9$var$getScrollTarget = (state)=>state.scrollTarget;
const $b49d7d8578f7dfd9$export$bee935f9618f7d1f = (0, $ggKAj.createHook)((0, $2z6ly.store), {
    selector: $b49d7d8578f7dfd9$var$getScrollTarget
});
const $b49d7d8578f7dfd9$export$80a04581afa7e5b0 = (0, $ggKAj.createHook)((0, $2z6ly.store), {
    selector: null
});

});
parcelRegister("2z6ly", function(module, exports) {

$parcel$export(module.exports, "store", () => $1e067933eb4c06cb$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "IssueScrollContainer", () => $1e067933eb4c06cb$export$c57d5661b1317518);

var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $fvZND = parcelRequire("fvZND");
const $1e067933eb4c06cb$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-scroll',
    initialState: {
        scrollTarget: null
    },
    actions: $fvZND
});
const $1e067933eb4c06cb$export$c57d5661b1317518 = (0, $heB5U.createContainer)($1e067933eb4c06cb$export$6f57813fe9f31bf9);

});
parcelRegister("fvZND", function(module, exports) {

$parcel$export(module.exports, "setScrollTarget", () => $834fb7f6a99d3c49$export$76a3b7c747962e63);
$parcel$export(module.exports, "getScrollTargetId", () => $834fb7f6a99d3c49$export$2540d7e468da6a9c);
const $834fb7f6a99d3c49$export$76a3b7c747962e63 = (scrollTarget)=>({ setState: setState })=>{
        setState({
            scrollTarget: scrollTarget
        });
    };
const $834fb7f6a99d3c49$export$2540d7e468da6a9c = (targetType)=>({ getState: getState })=>{
        const state = getState();
        return state.scrollTarget && state.scrollTarget.type === targetType && state.scrollTarget.id || null;
    };

});




parcelRegister("6nYhF", function(module, exports) {

$parcel$export(module.exports, "useStoreActionsForIssueViewShortcutActions_DO_NOT_USE", () => $bcd146fdd72298f1$export$259b5ebd0ea224f2);
$parcel$export(module.exports, "StoreForIssueViewContainer", () => $bcd146fdd72298f1$export$614db759cc171b10);
$parcel$export(module.exports, "withStoreForIssueViewShortcutActions_DO_NOT_USE", () => $bcd146fdd72298f1$export$7389bf27788a0376);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $lqalZ = parcelRequire("lqalZ");
const $bcd146fdd72298f1$var$actions = {
    setStore: (store)=>({ setState: setState })=>{
            setState({
                store: store
            });
        }
};
const $bcd146fdd72298f1$var$Store = (0, $a61MH.createStore)({
    initialState: {
        store: null
    },
    actions: $bcd146fdd72298f1$var$actions,
    name: 'issue-view-store'
});
// eslint-disable-next-line camelcase
const $bcd146fdd72298f1$var$useStore_DO_NOT_USE = (0, $ggKAj.createHook)($bcd146fdd72298f1$var$Store);
const $bcd146fdd72298f1$export$259b5ebd0ea224f2 = (0, $ggKAj.createActionsHook)($bcd146fdd72298f1$var$Store);
const $bcd146fdd72298f1$export$614db759cc171b10 = (0, $heB5U.createContainer)($bcd146fdd72298f1$var$Store);
const $bcd146fdd72298f1$export$7389bf27788a0376 = (WrappedComponent)=>// @ts-expect-error - TS2322 - Type '(props: Props) => JSX.Element | null' is not assignable to type '(props: Props) => ReactElement<any, string | JSXElementConstructor<any>>'.
    (props)=>{
        const [{ store: store }] = $bcd146fdd72298f1$var$useStore_DO_NOT_USE();
        return store !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lqalZ.Provider), {
            store: store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props)) : null;
    };

});

parcelRegister("l1qlm", function(module, exports) {

$parcel$export(module.exports, "useRecentIssueActions", () => $0bdac20a96fefc4d$export$6159607953aeb5e9);

var $eUqFw = parcelRequire("eUqFw");

var $9Dc8m = parcelRequire("9Dc8m");
const $0bdac20a96fefc4d$export$6159607953aeb5e9 = ()=>{
    const [, recentIssuesStoreActions] = (0, $9Dc8m.useRecentIssuesStore)();
    const getRecentIssue = (0, $eUqFw.useCallback)((issueKey)=>recentIssuesStoreActions.getRecentIssue(issueKey), [
        recentIssuesStoreActions
    ]);
    const setRecentIssue = (0, $eUqFw.useCallback)((issueKey, issueState)=>recentIssuesStoreActions.setRecentIssue(issueKey, issueState), [
        recentIssuesStoreActions
    ]);
    const getRecentIssuesCount = (0, $eUqFw.useCallback)(()=>recentIssuesStoreActions.getRecentIssuesCount(), [
        recentIssuesStoreActions
    ]);
    const recentIssuesActions = (0, $eUqFw.useMemo)(()=>({
            setRecentIssue: setRecentIssue,
            getRecentIssue: getRecentIssue,
            getRecentIssuesCount: getRecentIssuesCount
        }), [
        getRecentIssue,
        setRecentIssue,
        getRecentIssuesCount
    ]);
    return [
        null,
        recentIssuesActions
    ];
};

});
parcelRegister("9Dc8m", function(module, exports) {

$parcel$export(module.exports, "useRecentIssuesStore", () => $ef098bf7b533063c$export$c1944dc1cb7c6601);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $bqlPI = parcelRequire("bqlPI");
const $ef098bf7b533063c$var$deleteStaleIssues = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.entries(state).forEach(([issueKey, issueData])=>{
            if (!(0, $bqlPI.isValidIssueData)(issueData)) setState({
                [issueKey]: undefined
            });
        });
    };
const $ef098bf7b533063c$export$61c09e5bfb6bb45c = (issueKey, issueState)=>({ setState: setState, dispatch: dispatch })=>{
        dispatch($ef098bf7b533063c$var$deleteStaleIssues());
        setState({
            [String(issueKey)]: {
                issueState: issueState,
                savedAt: Date.now()
            }
        });
    };
const $ef098bf7b533063c$export$2e9ed2123ffc758f = (issueKey)=>({ getState: getState, dispatch: dispatch })=>{
        dispatch($ef098bf7b533063c$var$deleteStaleIssues());
        const state = getState();
        const issueData = state[issueKey];
        return (0, $bqlPI.isValidIssueData)(issueData) ? issueData?.issueState : undefined;
    };
const $ef098bf7b533063c$export$80b2d4688eb0197e = ()=>({ getState: getState })=>{
        const state = getState();
        const recentIssuesCount = Object.values(state).filter(Boolean).length;
        return recentIssuesCount;
    };
const $ef098bf7b533063c$var$actions = {
    setRecentIssue: $ef098bf7b533063c$export$61c09e5bfb6bb45c,
    getRecentIssue: $ef098bf7b533063c$export$2e9ed2123ffc758f,
    getRecentIssuesCount: $ef098bf7b533063c$export$80b2d4688eb0197e
};
const $ef098bf7b533063c$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'recent-issues',
    initialState: {},
    actions: $ef098bf7b533063c$var$actions
});
const $ef098bf7b533063c$export$c1944dc1cb7c6601 = (0, $ggKAj.createHook)($ef098bf7b533063c$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("bqlPI", function(module, exports) {

$parcel$export(module.exports, "isValidIssueData", () => $30fc10060de0667c$export$ef6c5db54aaaa531);
const $30fc10060de0667c$export$10b96f30bdf919bd = 3600000; // 60 minutes
const $30fc10060de0667c$export$ef6c5db54aaaa531 = (issueData)=>!!(issueData && issueData.savedAt > Date.now() - $30fc10060de0667c$export$10b96f30bdf919bd);

});



parcelRegister("hHnBv", function(module, exports) {

$parcel$export(module.exports, "SUBTASK_QUICK_ADD_CLICKED", () => $c87f490ba0323810$export$f74830f4d037b1d7);
$parcel$export(module.exports, "subtaskQuickAddClicked", () => $c87f490ba0323810$export$79a747b7b1cb71f0);
$parcel$export(module.exports, "ISSUE_IN_EPIC_QUICK_ADD_CLICKED", () => $c87f490ba0323810$export$320ab1525563e4b);
$parcel$export(module.exports, "issueInEpicQuickAddClicked", () => $c87f490ba0323810$export$80b8f01b5fcec321);
$parcel$export(module.exports, "CHILD_ISSUE_QUICK_ADD_CLICKED", () => $c87f490ba0323810$export$8f0c87d672929dee);
$parcel$export(module.exports, "childIssueQuickAddClicked", () => $c87f490ba0323810$export$ca0e8a5b2c1dd576);
$parcel$export(module.exports, "RESET_QUICK_ADD_CLICKED_COUNT", () => $c87f490ba0323810$export$fe0bb75662ab3e6c);
$parcel$export(module.exports, "resetQuickAddClickedCount", () => $c87f490ba0323810$export$3d8bd4d445a29742);
$parcel$export(module.exports, "CHILD_ISSUE_ADD_SUCCESS", () => $c87f490ba0323810$export$460b740921647405);
$parcel$export(module.exports, "childIssueAddSuccess", () => $c87f490ba0323810$export$f5d9d5be1c58ffec);
$parcel$export(module.exports, "SUBTASK_ADD_SUCCESS", () => $c87f490ba0323810$export$78a045f46496271c);
$parcel$export(module.exports, "subtaskAddSuccess", () => $c87f490ba0323810$export$ea9f4f4e10c4ed68);
$parcel$export(module.exports, "ISSUE_CHILDREN_ORDER_CHANGE_SUCCESS", () => $c87f490ba0323810$export$eb4b74a316713f08);
$parcel$export(module.exports, "CHILD_ISSUE_FIELD_UPDATED", () => $c87f490ba0323810$export$50f52ef54c38bf96);
$parcel$export(module.exports, "childIssueFieldUpdate", () => $c87f490ba0323810$export$53998c726d28c95);
$parcel$export(module.exports, "issueChildrenOrderChangeSuccess", () => $c87f490ba0323810$export$bb7a342cda8c114b);
$parcel$export(module.exports, "CHILD_ISSUE_PANEL_ADD_CLICKED", () => $c87f490ba0323810$export$8203dabb3e21d016);
$parcel$export(module.exports, "childIssuePanelAddClick", () => $c87f490ba0323810$export$b594f879e59c7209);
// Note these actions are needed for Bento app to talk to the child-panel apps
const $c87f490ba0323810$export$f74830f4d037b1d7 = 'SUBTASK_QUICK_ADD_CLICKED';
const $c87f490ba0323810$export$79a747b7b1cb71f0 = ()=>({
        type: $c87f490ba0323810$export$f74830f4d037b1d7
    });
const $c87f490ba0323810$export$320ab1525563e4b = 'ISSUE_IN_EPIC_QUICK_ADD_CLICKED';
const $c87f490ba0323810$export$80b8f01b5fcec321 = ()=>({
        type: $c87f490ba0323810$export$320ab1525563e4b
    });
const $c87f490ba0323810$export$8f0c87d672929dee = 'CHILD_ISSUE_QUICK_ADD_CLICKED';
const $c87f490ba0323810$export$ca0e8a5b2c1dd576 = ()=>({
        type: $c87f490ba0323810$export$8f0c87d672929dee
    });
const $c87f490ba0323810$export$fe0bb75662ab3e6c = 'RESET_QUICK_ADD_CLICKED_COUNT';
const $c87f490ba0323810$export$3d8bd4d445a29742 = ()=>({
        type: $c87f490ba0323810$export$fe0bb75662ab3e6c
    });
const $c87f490ba0323810$export$460b740921647405 = 'CHILD_ISSUE_ADD_SUCCESS';
const $c87f490ba0323810$export$f5d9d5be1c58ffec = (childIssue, fieldsData)=>({
        type: $c87f490ba0323810$export$460b740921647405,
        payload: {
            childIssue: childIssue,
            fieldsData: fieldsData
        }
    });
const $c87f490ba0323810$export$78a045f46496271c = 'SUBTASK_ADD_SUCCESS';
const $c87f490ba0323810$export$ea9f4f4e10c4ed68 = (subtask, fieldsData)=>({
        type: $c87f490ba0323810$export$78a045f46496271c,
        payload: {
            childIssue: subtask,
            fieldsData: fieldsData
        }
    });
const $c87f490ba0323810$export$eb4b74a316713f08 = 'ISSUE_CHILDREN_ORDER_CHANGE_SUCCESS';
const $c87f490ba0323810$export$50f52ef54c38bf96 = 'CHILD_ISSUE_FIELD_UPDATED';
const $c87f490ba0323810$export$53998c726d28c95 = (childIssueId)=>({
        type: $c87f490ba0323810$export$50f52ef54c38bf96,
        payload: {
            childIssueId: childIssueId
        }
    });
const $c87f490ba0323810$export$bb7a342cda8c114b = ({ issueIds: issueIds, rankId: rankId, isRankAfter: isRankAfter })=>({
        type: $c87f490ba0323810$export$eb4b74a316713f08,
        payload: {
            issueIds: issueIds,
            rankId: rankId,
            isRankAfter: isRankAfter
        }
    });
const $c87f490ba0323810$export$8203dabb3e21d016 = 'CHILD_ISSUE_PANEL_ADD_CLICKED';
const $c87f490ba0323810$export$b594f879e59c7209 = ()=>({
        type: $c87f490ba0323810$export$8203dabb3e21d016
    });

});

parcelRegister("ePSh2", function(module, exports) {

$parcel$export(module.exports, "SET_CONTEXT", () => $5e278c907a2dd2f7$export$4bc4e62e7d72b94b);
$parcel$export(module.exports, "setContext", () => $5e278c907a2dd2f7$export$2f04de43fe27971a);
const $5e278c907a2dd2f7$export$4bc4e62e7d72b94b = 'SET_CONTEXT';
const $5e278c907a2dd2f7$export$2f04de43fe27971a = (context)=>({
        type: $5e278c907a2dd2f7$export$4bc4e62e7d72b94b,
        payload: context
    });

});

parcelRegister("l129t", function(module, exports) {

$parcel$export(module.exports, "externalEditFieldAction", () => $646de4c164a6d485$export$5d020593666779fc);
$parcel$export(module.exports, "externalAddCommentAction", () => $646de4c164a6d485$export$c70036fd42f0ed99);
$parcel$export(module.exports, "SCROLL_TO_COMMENT", () => $646de4c164a6d485$export$3b373f0f7354e781);
$parcel$export(module.exports, "externalAssignToMeAction", () => $646de4c164a6d485$export$8f1d4f64b4b74146);
$parcel$export(module.exports, "FIELD_EDIT_REQUEST_EXTERNAL", () => $646de4c164a6d485$export$c72c6bc149df5e02);
$parcel$export(module.exports, "ASSIGN_TO_ME_EXTERNAL", () => $646de4c164a6d485$export$c60815f29b5cfb6d);
$parcel$export(module.exports, "transformExternalAction", () => $646de4c164a6d485$export$78aa3108fdac0ac3);

var $fYteL = parcelRequire("fYteL");

var $lkPj1 = parcelRequire("lkPj1");
const $646de4c164a6d485$export$5834f946a995a2ca = 'REFRESH_ISSUE';
const $646de4c164a6d485$export$316a97ea1161ac5a = (type)=>({
        type: $646de4c164a6d485$export$5834f946a995a2ca,
        payload: {
            type: type
        }
    });
const $646de4c164a6d485$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $646de4c164a6d485$export$5d020593666779fc = (fieldId)=>({
        type: $646de4c164a6d485$export$256eddbefbf4b2ce,
        payload: {
            fieldId: fieldId
        }
    });
const $646de4c164a6d485$export$35aff3ed3a26081d = 'ADD_COMMENT';
const $646de4c164a6d485$export$c70036fd42f0ed99 = ()=>({
        type: $646de4c164a6d485$export$35aff3ed3a26081d
    });
const $646de4c164a6d485$export$3b373f0f7354e781 = 'SCROLL_TO_COMMENT';
const $646de4c164a6d485$export$db9eae89818590a4 = (commentId)=>({
        type: $646de4c164a6d485$export$3b373f0f7354e781,
        payload: {
            commentId: commentId
        }
    });
const $646de4c164a6d485$export$ae8a4274289f40bb = 'ASSIGN_TO_ME';
const $646de4c164a6d485$export$8f1d4f64b4b74146 = ()=>({
        type: $646de4c164a6d485$export$ae8a4274289f40bb
    });
const $646de4c164a6d485$export$c72c6bc149df5e02 = 'FIELD_EDIT_REQUEST_EXTERNAL';
const $646de4c164a6d485$export$c3ca6bc94e6e6b5c = (fieldId)=>({
        type: $646de4c164a6d485$export$c72c6bc149df5e02,
        payload: {
            fieldId: fieldId
        }
    });
const $646de4c164a6d485$export$c60815f29b5cfb6d = 'ASSIGN_TO_ME_EXTERNAL';
const $646de4c164a6d485$export$e3035a7e8a739325 = ()=>({
        type: $646de4c164a6d485$export$c60815f29b5cfb6d
    });
const $646de4c164a6d485$export$78aa3108fdac0ac3 = (action)=>{
    switch(action.type){
        case $646de4c164a6d485$export$35aff3ed3a26081d:
            return (0, $lkPj1.addCommentFormExpand)();
        case $646de4c164a6d485$export$3b373f0f7354e781:
            return $646de4c164a6d485$export$db9eae89818590a4(action.payload.commentId);
        case $646de4c164a6d485$export$ae8a4274289f40bb:
            return $646de4c164a6d485$export$e3035a7e8a739325();
        case $646de4c164a6d485$export$256eddbefbf4b2ce:
            return $646de4c164a6d485$export$c3ca6bc94e6e6b5c(action.payload.fieldId);
        case $646de4c164a6d485$export$5834f946a995a2ca:
            return (0, $fYteL.refreshIssueRequest)({
                // todo: swap between soft reload and hard (aka on-demand)
                reason: 'ON_DEMAND'
            });
        default:
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            throw new Error(`Unhandled external action type: ${action.type}`);
    }
};

});
parcelRegister("lkPj1", function(module, exports) {

$parcel$export(module.exports, "ADD_COMMENT_FORM_EXPAND", () => $2d085d7bc32475e5$export$71d398107e783d48);
$parcel$export(module.exports, "addCommentFormExpand", () => $2d085d7bc32475e5$export$2b19aad250b973d);
$parcel$export(module.exports, "ADD_COMMENT_FORM_COLLAPSE", () => $2d085d7bc32475e5$export$85ff14da4a33157b);
$parcel$export(module.exports, "addCommentFormCollapse", () => $2d085d7bc32475e5$export$835c1049633b19d4);
$parcel$export(module.exports, "ADD_COMMENT_FORM_CANCEL", () => $2d085d7bc32475e5$export$2a743018e170b1c5);
$parcel$export(module.exports, "addCommentFormCancel", () => $2d085d7bc32475e5$export$cbb43c6e2782f713);
$parcel$export(module.exports, "SAVE_COMMENT_RETRY", () => $2d085d7bc32475e5$export$f1da94dd8f2d20f8);
$parcel$export(module.exports, "saveCommentRetry", () => $2d085d7bc32475e5$export$8fe4d7a3b02197cb);
$parcel$export(module.exports, "SAVE_COMMENT_EDIT", () => $2d085d7bc32475e5$export$81e9c11b794a58cd);
$parcel$export(module.exports, "saveCommentEdit", () => $2d085d7bc32475e5$export$854252150d2da91c);
$parcel$export(module.exports, "saveCommentSuccessWithPastedContent", () => $2d085d7bc32475e5$export$74f24e144289c0bf);
$parcel$export(module.exports, "SAVE_COMMENT_REQUEST", () => $2d085d7bc32475e5$export$18d19e9df123c7d4);
$parcel$export(module.exports, "saveCommentRequest", () => $2d085d7bc32475e5$export$180890d02f5569ee);
$parcel$export(module.exports, "SAVE_COMMENT_SUCCESS", () => $2d085d7bc32475e5$export$68a9d3a587260864);
$parcel$export(module.exports, "saveCommentSuccess", () => $2d085d7bc32475e5$export$e25b399b9ba134a2);
$parcel$export(module.exports, "SAVE_COMMENT_FAILURE", () => $2d085d7bc32475e5$export$181640cafd83e422);
$parcel$export(module.exports, "saveCommentFailure", () => $2d085d7bc32475e5$export$c9acef2c154290a0);
$parcel$export(module.exports, "SAVE_COMMENT_CANCEL", () => $2d085d7bc32475e5$export$9188109a1be76d1a);
$parcel$export(module.exports, "saveCommentCancel", () => $2d085d7bc32475e5$export$6971a9cf19e7bff0);
$parcel$export(module.exports, "FETCH_OLDER_COMMENTS_REQUEST", () => $2d085d7bc32475e5$export$8759655e9c2c6d63);
$parcel$export(module.exports, "FETCH_NEWER_COMMENTS_REQUEST", () => $2d085d7bc32475e5$export$d55056f931f514de);
$parcel$export(module.exports, "fetchOlderCommentsRequest", () => $2d085d7bc32475e5$export$89824d2d0989262b);
$parcel$export(module.exports, "fetchNewerCommentsRequest", () => $2d085d7bc32475e5$export$ccf1730684d88fc7);
$parcel$export(module.exports, "FETCH_MORE_COMMENTS_SUCCESS", () => $2d085d7bc32475e5$export$1c31d581a6bc6013);
$parcel$export(module.exports, "fetchMoreCommentsSuccess", () => $2d085d7bc32475e5$export$a06e5ade6af52efd);
$parcel$export(module.exports, "FETCH_MORE_COMMENTS_FAILURE", () => $2d085d7bc32475e5$export$b0ac6cc6abb21a3c);
$parcel$export(module.exports, "fetchMoreCommentsFailure", () => $2d085d7bc32475e5$export$c3ffb947d06519d4);
$parcel$export(module.exports, "FETCH_SORTED_COMMENTS_REQUEST", () => $2d085d7bc32475e5$export$47acda4b8d2cc300);
$parcel$export(module.exports, "fetchSortedCommentsRequest", () => $2d085d7bc32475e5$export$4805c80809193e58);
$parcel$export(module.exports, "FETCH_SORTED_COMMENTS_SUCCESS", () => $2d085d7bc32475e5$export$f72e87877cdff1d3);
$parcel$export(module.exports, "fetchSortedCommentsSuccess", () => $2d085d7bc32475e5$export$248225c0816f92b1);
$parcel$export(module.exports, "fetchSortedCommentsFailure", () => $2d085d7bc32475e5$export$2f204bc36c94722d);
$parcel$export(module.exports, "CHANGE_COMMENT_VISIBILITY", () => $2d085d7bc32475e5$export$27e53ffab4bb4105);
$parcel$export(module.exports, "changeCommentVisibility", () => $2d085d7bc32475e5$export$bdd605e26cb557a);
$parcel$export(module.exports, "EDIT_COMMENT_BEGIN", () => $2d085d7bc32475e5$export$52ec13a9878fb210);
$parcel$export(module.exports, "editCommentBegin", () => $2d085d7bc32475e5$export$b59e3ef618f3f5a4);
$parcel$export(module.exports, "EDIT_COMMENT_COLLAPSE", () => $2d085d7bc32475e5$export$ee24a9af79550b9a);
$parcel$export(module.exports, "editCommentCollapse", () => $2d085d7bc32475e5$export$76f4fdc85b3c4983);
$parcel$export(module.exports, "EDIT_COMMENT_CANCEL", () => $2d085d7bc32475e5$export$34cbc41a86b4aebb);
$parcel$export(module.exports, "editCommentCancel", () => $2d085d7bc32475e5$export$b42a5c3d327fad1a);
$parcel$export(module.exports, "EDIT_COMMENT_UPDATE", () => $2d085d7bc32475e5$export$eae8689994a83d11);
$parcel$export(module.exports, "editCommentUpdate", () => $2d085d7bc32475e5$export$ccfcbe3e4607ec26);
$parcel$export(module.exports, "EDIT_COMMENT_VISIBILITY", () => $2d085d7bc32475e5$export$9a3bec84654d3d8b);
$parcel$export(module.exports, "editCommentVisibility", () => $2d085d7bc32475e5$export$2cbe8c5e21dff6d6);
$parcel$export(module.exports, "EDIT_COMMENT_EVENT_OCCURRED_AT", () => $2d085d7bc32475e5$export$f84d12595d214d0e);
$parcel$export(module.exports, "editCommentEventOccurredAt", () => $2d085d7bc32475e5$export$6b71370b88eec9f);
$parcel$export(module.exports, "DELETE_COMMENT_REQUEST", () => $2d085d7bc32475e5$export$32f9b2d50e470721);
$parcel$export(module.exports, "deleteCommentRequest", () => $2d085d7bc32475e5$export$ed74b3a5f1c036c2);
$parcel$export(module.exports, "DELETE_COMMENT_SUCCESS", () => $2d085d7bc32475e5$export$ad9d0372e68e413d);
$parcel$export(module.exports, "deleteCommentSuccess", () => $2d085d7bc32475e5$export$88e6cb2a45e9c67b);
$parcel$export(module.exports, "DELETE_COMMENT_FAILURE", () => $2d085d7bc32475e5$export$17bfad3338f45e82);
$parcel$export(module.exports, "deleteCommentFailure", () => $2d085d7bc32475e5$export$f1282c6c2bcc0a44);
$parcel$export(module.exports, "SHOW_DELETE_COMMENT_MODAL", () => $2d085d7bc32475e5$export$14760731f36c8fa5);
$parcel$export(module.exports, "showDeleteCommentModal", () => $2d085d7bc32475e5$export$a4e27b77e5b2e1cb);
$parcel$export(module.exports, "DELETE_COMMENT_CANCEL", () => $2d085d7bc32475e5$export$3a3e11677c5cf402);
$parcel$export(module.exports, "deleteCommentCancel", () => $2d085d7bc32475e5$export$bc41e76605cf3270);
$parcel$export(module.exports, "PASTED_INTO_COMMENT_FORM", () => $2d085d7bc32475e5$export$7ef9a590ab69319e);
$parcel$export(module.exports, "pastedIntoCommentForm", () => $2d085d7bc32475e5$export$8ac8e8de3bb0d3);
$parcel$export(module.exports, "SET_COMMENT_ATTACHMENT_IN_PROGRESS", () => $2d085d7bc32475e5$export$ec38bcd617424c64);
$parcel$export(module.exports, "setCommentAttachmentInProgress", () => $2d085d7bc32475e5$export$d7ed3c847a4656f7);
$parcel$export(module.exports, "SET_COMMENT_SCROLL_STATUS", () => $2d085d7bc32475e5$export$f7592333993e8ac2);
$parcel$export(module.exports, "setCommentScrollStatus", () => $2d085d7bc32475e5$export$1dda1a9962bdad5f);

var $f9RL0 = parcelRequire("f9RL0");

var $gIyTt = parcelRequire("gIyTt");
const $2d085d7bc32475e5$export$71d398107e783d48 = 'ADD_COMMENT_FORM_EXPAND';
const $2d085d7bc32475e5$export$2b19aad250b973d = ()=>({
        type: $2d085d7bc32475e5$export$71d398107e783d48
    });
const $2d085d7bc32475e5$export$85ff14da4a33157b = 'ADD_COMMENT_FORM_COLLAPSE';
const $2d085d7bc32475e5$export$835c1049633b19d4 = ()=>({
        type: $2d085d7bc32475e5$export$85ff14da4a33157b
    });
const $2d085d7bc32475e5$export$2a743018e170b1c5 = 'ADD_COMMENT_FORM_CANCEL';
const $2d085d7bc32475e5$export$cbb43c6e2782f713 = ()=>({
        type: $2d085d7bc32475e5$export$2a743018e170b1c5
    });
const $2d085d7bc32475e5$export$f1da94dd8f2d20f8 = 'SAVE_COMMENT_RETRY';
const $2d085d7bc32475e5$export$8fe4d7a3b02197cb = (optimisticId, createdDate, isNewComment)=>({
        type: $2d085d7bc32475e5$export$f1da94dd8f2d20f8,
        payload: {
            optimisticId: optimisticId,
            createdDate: createdDate,
            isNewComment: isNewComment
        }
    });
const $2d085d7bc32475e5$export$81e9c11b794a58cd = 'SAVE_COMMENT_EDIT';
const $2d085d7bc32475e5$export$854252150d2da91c = (optimisticId)=>({
        type: $2d085d7bc32475e5$export$81e9c11b794a58cd,
        payload: {
            optimisticId: optimisticId
        }
    });
const $2d085d7bc32475e5$export$eca5dde908b0cf94 = 'SAVE_COMMENT_SUCCESS_WITH_PASTED_CONTENT';
const $2d085d7bc32475e5$export$74f24e144289c0bf = (comment, pastedContent)=>({
        type: $2d085d7bc32475e5$export$eca5dde908b0cf94,
        payload: {
            comment: comment,
            pastedContent: pastedContent
        }
    });
const $2d085d7bc32475e5$export$18d19e9df123c7d4 = 'SAVE_COMMENT_REQUEST';
const $2d085d7bc32475e5$export$180890d02f5569ee = (comment, analyticsEvent)=>({
        type: $2d085d7bc32475e5$export$18d19e9df123c7d4,
        payload: {
            comment: comment,
            analyticsEvent: analyticsEvent,
            updatedField: (0, $f9RL0.COMMENT)
        }
    });
const $2d085d7bc32475e5$export$68a9d3a587260864 = 'SAVE_COMMENT_SUCCESS';
const $2d085d7bc32475e5$export$e25b399b9ba134a2 = (comment, optimisticId, isNewComment, analyticsEvent, meta, eventOccurredAt, jsdIncidentActivityViewHidden, fullIssueUrl, triggerIncidentSaveCommentFlag)=>({
        type: $2d085d7bc32475e5$export$68a9d3a587260864,
        payload: {
            fieldId: (0, $f9RL0.COMMENT),
            comment: comment,
            optimisticId: optimisticId,
            isNewComment: isNewComment,
            analyticsEvent: analyticsEvent,
            ...(0, $gIyTt.isJsmTimelineEnabled)() ? {
                eventOccurredAt: eventOccurredAt
            } : {},
            ...(0, $gIyTt.isJsmTimelineEnabled)() ? {
                jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden
            } : {},
            ...(0, $gIyTt.isJsmTimelineEnabled)() && fullIssueUrl ? {
                fullIssueUrl: fullIssueUrl
            } : {},
            ...(0, $gIyTt.isJsmTimelineEnabled)() ? {
                triggerIncidentSaveCommentFlag: triggerIncidentSaveCommentFlag
            } : {}
        },
        meta: meta
    });
const $2d085d7bc32475e5$export$181640cafd83e422 = 'SAVE_COMMENT_FAILURE';
const $2d085d7bc32475e5$export$c9acef2c154290a0 = (payload)=>({
        type: $2d085d7bc32475e5$export$181640cafd83e422,
        payload: payload
    });
const $2d085d7bc32475e5$export$9188109a1be76d1a = 'SAVE_COMMENT_CANCEL';
const $2d085d7bc32475e5$export$6971a9cf19e7bff0 = (optimisticId)=>({
        type: $2d085d7bc32475e5$export$9188109a1be76d1a,
        payload: {
            optimisticId: optimisticId
        }
    });
const $2d085d7bc32475e5$export$8759655e9c2c6d63 = 'FETCH_OLDER_COMMENTS_REQUEST';
const $2d085d7bc32475e5$export$d55056f931f514de = 'FETCH_NEWER_COMMENTS_REQUEST';
const $2d085d7bc32475e5$export$89824d2d0989262b = ()=>({
        type: $2d085d7bc32475e5$export$8759655e9c2c6d63
    });
const $2d085d7bc32475e5$export$ccf1730684d88fc7 = ()=>({
        type: $2d085d7bc32475e5$export$d55056f931f514de
    });
const $2d085d7bc32475e5$export$1c31d581a6bc6013 = 'FETCH_MORE_COMMENTS_SUCCESS';
const $2d085d7bc32475e5$export$a06e5ade6af52efd = (loadedComments)=>({
        type: $2d085d7bc32475e5$export$1c31d581a6bc6013,
        payload: loadedComments
    });
const $2d085d7bc32475e5$export$b0ac6cc6abb21a3c = 'FETCH_MORE_COMMENTS_FAILURE';
const $2d085d7bc32475e5$export$c3ffb947d06519d4 = ()=>({
        type: $2d085d7bc32475e5$export$b0ac6cc6abb21a3c
    });
const $2d085d7bc32475e5$export$47acda4b8d2cc300 = 'FETCH_SORTED_COMMENTS_REQUEST';
const $2d085d7bc32475e5$export$4805c80809193e58 = (commentId)=>({
        type: $2d085d7bc32475e5$export$47acda4b8d2cc300,
        payload: commentId
    });
const $2d085d7bc32475e5$export$f72e87877cdff1d3 = 'FETCH_SORTED_COMMENTS_SUCCESS';
const $2d085d7bc32475e5$export$248225c0816f92b1 = (loadedComments)=>({
        type: $2d085d7bc32475e5$export$f72e87877cdff1d3,
        payload: loadedComments
    });
const $2d085d7bc32475e5$export$5ae0e03aaca20486 = 'FETCH_SORTED_COMMENTS_FAILURE';
const $2d085d7bc32475e5$export$2f204bc36c94722d = ()=>({
        type: $2d085d7bc32475e5$export$5ae0e03aaca20486
    });
const $2d085d7bc32475e5$export$27e53ffab4bb4105 = 'CHANGE_COMMENT_VISIBILITY';
const $2d085d7bc32475e5$export$bdd605e26cb557a = (id, isInternal)=>({
        type: $2d085d7bc32475e5$export$27e53ffab4bb4105,
        payload: {
            id: id,
            isInternal: isInternal
        }
    });
const $2d085d7bc32475e5$export$52ec13a9878fb210 = 'EDIT_COMMENT_BEGIN';
const $2d085d7bc32475e5$export$b59e3ef618f3f5a4 = (id, isInternal)=>({
        type: $2d085d7bc32475e5$export$52ec13a9878fb210,
        payload: {
            id: id,
            isInternal: isInternal
        }
    });
const $2d085d7bc32475e5$export$ee24a9af79550b9a = 'EDIT_COMMENT_COLLAPSE';
const $2d085d7bc32475e5$export$76f4fdc85b3c4983 = (id)=>({
        type: $2d085d7bc32475e5$export$ee24a9af79550b9a,
        payload: {
            id: id,
            fieldId: (0, $f9RL0.COMMENT)
        }
    });
const $2d085d7bc32475e5$export$34cbc41a86b4aebb = 'EDIT_COMMENT_CANCEL';
const $2d085d7bc32475e5$export$b42a5c3d327fad1a = (id)=>({
        type: $2d085d7bc32475e5$export$34cbc41a86b4aebb,
        payload: {
            id: id,
            fieldId: (0, $f9RL0.COMMENT)
        }
    });
const $2d085d7bc32475e5$export$eae8689994a83d11 = 'EDIT_COMMENT_UPDATE';
const $2d085d7bc32475e5$export$ccfcbe3e4607ec26 = (id, value)=>({
        type: $2d085d7bc32475e5$export$eae8689994a83d11,
        payload: {
            id: id,
            value: value,
            fieldId: (0, $f9RL0.COMMENT)
        }
    });
const $2d085d7bc32475e5$export$9a3bec84654d3d8b = 'EDIT_COMMENT_VISIBILITY';
const $2d085d7bc32475e5$export$2cbe8c5e21dff6d6 = (id, visibility)=>({
        type: $2d085d7bc32475e5$export$9a3bec84654d3d8b,
        payload: {
            id: id,
            visibility: visibility
        }
    });
const $2d085d7bc32475e5$export$f84d12595d214d0e = 'EDIT_COMMENT_EVENT_OCCURRED_AT';
const $2d085d7bc32475e5$export$6b71370b88eec9f = (id, eventOccurredAt)=>({
        type: $2d085d7bc32475e5$export$f84d12595d214d0e,
        payload: {
            id: id,
            eventOccurredAt: eventOccurredAt
        }
    });
const $2d085d7bc32475e5$export$32f9b2d50e470721 = 'DELETE_COMMENT_REQUEST';
const $2d085d7bc32475e5$export$ed74b3a5f1c036c2 = (id, analyticsEvent)=>({
        type: $2d085d7bc32475e5$export$32f9b2d50e470721,
        payload: {
            id: id,
            analyticsEvent: analyticsEvent,
            updatedField: (0, $f9RL0.COMMENT)
        }
    });
const $2d085d7bc32475e5$export$ad9d0372e68e413d = 'DELETE_COMMENT_SUCCESS';
const $2d085d7bc32475e5$export$88e6cb2a45e9c67b = (id)=>({
        type: $2d085d7bc32475e5$export$ad9d0372e68e413d,
        payload: {
            id: id,
            fieldId: (0, $f9RL0.COMMENT)
        }
    });
const $2d085d7bc32475e5$export$17bfad3338f45e82 = 'DELETE_COMMENT_FAILURE';
const $2d085d7bc32475e5$export$f1282c6c2bcc0a44 = (id)=>({
        type: $2d085d7bc32475e5$export$17bfad3338f45e82,
        payload: id
    });
const $2d085d7bc32475e5$export$14760731f36c8fa5 = 'SHOW_DELETE_COMMENT_MODAL';
const $2d085d7bc32475e5$export$a4e27b77e5b2e1cb = (id)=>({
        type: $2d085d7bc32475e5$export$14760731f36c8fa5,
        payload: id
    });
const $2d085d7bc32475e5$export$3a3e11677c5cf402 = 'DELETE_COMMENT_CANCEL';
const $2d085d7bc32475e5$export$bc41e76605cf3270 = ()=>({
        type: $2d085d7bc32475e5$export$3a3e11677c5cf402
    });
const $2d085d7bc32475e5$export$7ef9a590ab69319e = 'PASTED_INTO_COMMENT_FORM';
const $2d085d7bc32475e5$export$8ac8e8de3bb0d3 = (id, pastedContent)=>({
        type: $2d085d7bc32475e5$export$7ef9a590ab69319e,
        payload: {
            id: id,
            pastedContent: pastedContent
        }
    });
const $2d085d7bc32475e5$export$ec38bcd617424c64 = 'SET_COMMENT_ATTACHMENT_IN_PROGRESS';
const $2d085d7bc32475e5$export$d7ed3c847a4656f7 = (isInProgress)=>({
        type: $2d085d7bc32475e5$export$ec38bcd617424c64,
        payload: {
            isInProgress: isInProgress
        }
    });
const $2d085d7bc32475e5$export$f7592333993e8ac2 = 'SET_COMMENT_SCROLL_STATUS';
const $2d085d7bc32475e5$export$1dda1a9962bdad5f = (status)=>({
        type: $2d085d7bc32475e5$export$f7592333993e8ac2,
        payload: {
            status: status
        }
    });

});


parcelRegister("1DnzP", function(module, exports) {

$parcel$export(module.exports, "useWorkflowTransitionsValue", () => $953fbd765e932223$export$435cba24c8d1ddf6);
$parcel$export(module.exports, "useWorkflowTransitionsTransitionInProgress", () => $953fbd765e932223$export$9b35656991b0ecda);
$parcel$export(module.exports, "useWorkflowTransitionsActions", () => $953fbd765e932223$export$d5245ade1619037b);

var $eUqFw = parcelRequire("eUqFw");

var $iibQj = parcelRequire("iibQj");
const $953fbd765e932223$export$435cba24c8d1ddf6 = ()=>{
    const [value, { setState: setState }] = (0, $iibQj.useWorkflowTransitionsStoreValue)();
    return [
        value,
        setState
    ];
};
const $953fbd765e932223$export$9b35656991b0ecda = ()=>{
    const [value] = (0, $iibQj.useWorkflowTransitionsStoreTransitionInProgress)();
    return value;
};
const $953fbd765e932223$export$d5245ade1619037b = ()=>{
    const [, actions] = (0, $iibQj.useWorkflowTransitionsStoreActions)();
    const workflowActions = (0, $eUqFw.useMemo)(()=>{
        // @ts-expect-error - TS7006 - Parameter 'partialState' implicitly has an 'any' type.
        const setState = (partialState)=>{
            actions.setState(partialState);
        };
        const setTransitionInProgress = (isLoading)=>{
            actions.setTransitionInProgress(isLoading);
        };
        return {
            setState: setState,
            setTransitionInProgress: setTransitionInProgress
        };
    }, [
        actions
    ]);
    return [
        null,
        workflowActions
    ];
};

});
parcelRegister("iibQj", function(module, exports) {

$parcel$export(module.exports, "useWorkflowTransitionsStoreValue", () => $d9a50e4d0db95c46$export$435e780321f76edc);
$parcel$export(module.exports, "useWorkflowTransitionsStoreTransitionInProgress", () => $d9a50e4d0db95c46$export$35c153667c57d035);
$parcel$export(module.exports, "useWorkflowTransitionsStoreActions", () => $d9a50e4d0db95c46$export$370707f36c1f66df);
$parcel$export(module.exports, "WorkflowTransitionsStoreContainer", () => $d9a50e4d0db95c46$export$1e23e2bdfc599859);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $7dGoC = parcelRequire("7dGoC");
const $d9a50e4d0db95c46$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'workflow-transitions',
    initialState: {
        data: null,
        loading: false,
        error: null,
        ui: {
            transitionInProgress: false
        }
    },
    actions: $7dGoC.actions
});
const $d9a50e4d0db95c46$export$435e780321f76edc = (0, $ggKAj.createHook)($d9a50e4d0db95c46$export$6f57813fe9f31bf9, {
    selector: (state)=>state
});
const $d9a50e4d0db95c46$export$35c153667c57d035 = (0, $ggKAj.createHook)($d9a50e4d0db95c46$export$6f57813fe9f31bf9, {
    selector: (state)=>state.ui.transitionInProgress
});
const $d9a50e4d0db95c46$export$370707f36c1f66df = (0, $ggKAj.createHook)($d9a50e4d0db95c46$export$6f57813fe9f31bf9, {
    selector: null
});
const $d9a50e4d0db95c46$export$1e23e2bdfc599859 = (0, $heB5U.createContainer)($d9a50e4d0db95c46$export$6f57813fe9f31bf9);

});
parcelRegister("7dGoC", function(module, exports) {

$parcel$export(module.exports, "actions", () => $aeab576021c944d5$export$e324594224ef24da);
const $aeab576021c944d5$var$setState = (state = {})=>({ setState: setSweetState, getState: getState })=>{
        const newState = {
            ...getState(),
            ...state
        };
        setSweetState(newState);
    };
const $aeab576021c944d5$export$c4d3076bd1999d92 = (transitionInProgress)=>({ setState: setSweetState, getState: getState })=>{
        setSweetState({
            ui: {
                ...getState().ui,
                transitionInProgress: transitionInProgress
            }
        });
    };
const $aeab576021c944d5$export$e324594224ef24da = {
    setState: $aeab576021c944d5$var$setState,
    setTransitionInProgress: $aeab576021c944d5$export$c4d3076bd1999d92
};

});



parcelRegister("dWlsy", function(module, exports) {

$parcel$export(module.exports, "useSubProduct", () => $04e11956b03ab7c2$export$16aa2ad52cd8992a);

var $SEaoU = parcelRequire("SEaoU");

var $6QL9v = parcelRequire("6QL9v");
const $04e11956b03ab7c2$export$16aa2ad52cd8992a = ()=>{
    const [{ data: data }] = (0, $SEaoU.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data?.project) return null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    return (0, $6QL9v.subProductFromProjectType)(data.project.type);
};

});

parcelRegister("8rc7e", function(module, exports) {

$parcel$export(module.exports, "UiModificationsContainer", () => $dc3a06e9fd9eeeae$export$1834060b93715de7);

var $eUqFw = parcelRequire("eUqFw");

var $5JgCW = parcelRequire("5JgCW");

var $bKI0B = parcelRequire("bKI0B");
const $dc3a06e9fd9eeeae$export$1834060b93715de7 = ({ children: children, scope: scope })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5JgCW.BaseUiModificationsContainer), {
        scope: `${(0, $bKI0B.ISSUE_VIEW_VIEW_TYPE)}-${scope}`,
        viewType: (0, $bKI0B.ISSUE_VIEW_VIEW_TYPE)
    }, children);

});
parcelRegister("5JgCW", function(module, exports) {

$parcel$export(module.exports, "BaseUiModificationsContainer", () => $63c993e842f182d8$export$8b7a045f60eb9797);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $ig7wC = parcelRequire("ig7wC");

var $aCsSk = parcelRequire("aCsSk");
const $63c993e842f182d8$export$8b7a045f60eb9797 = ({ children: children, scope: scope, viewType: viewType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aCsSk.LoadedUiModificationsContainer), {
        scope: scope,
        viewType: viewType,
        createAnalyticsEvent: createAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ig7wC.UiModificationContextContainer), {
        scope: scope
    }, children));
};

});
parcelRegister("aCsSk", function(module, exports) {

$parcel$export(module.exports, "LoadedUiModificationsContainer", () => $dc8f196226ca6983$export$b087a12fbb84e8ac);

var $heB5U = parcelRequire("heB5U");

var $fcNlw = parcelRequire("fcNlw");
const $dc8f196226ca6983$export$b087a12fbb84e8ac = (0, $heB5U.createContainer)((0, $fcNlw.store), {
    displayName: 'LoadedUiModificationsContainer',
    onInit: ()=>({ setState: setState }, { viewType: viewType })=>{
            setState({
                viewType: viewType
            });
        }
});

});



parcelRegister("linOi", function(module, exports) {

$parcel$export(module.exports, "store", () => $e424b2024a0a0181$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "WorklogTimeTrackingContainer", () => $e424b2024a0a0181$export$b9fda8cbf63a1706);

var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $2xbn7 = parcelRequire("2xbn7");
const $e424b2024a0a0181$export$d4c72bab9d6cc13a = {
    isRollingUp: true
};
const $e424b2024a0a0181$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'worklog-time-tracking',
    initialState: $e424b2024a0a0181$export$d4c72bab9d6cc13a,
    actions: $2xbn7
});
const $e424b2024a0a0181$export$b9fda8cbf63a1706 = (0, $heB5U.createContainer)($e424b2024a0a0181$export$6f57813fe9f31bf9);

});
parcelRegister("2xbn7", function(module, exports) {

$parcel$export(module.exports, "markRollingUpData", () => (parcelRequire("b2JgZ")).markRollingUpData);
$parcel$export(module.exports, "unmarkRollingUpData", () => (parcelRequire("b2JgZ")).unmarkRollingUpData);

var $b2JgZ = parcelRequire("b2JgZ");

});
parcelRegister("b2JgZ", function(module, exports) {

$parcel$export(module.exports, "markRollingUpData", () => $63ade4993fe2c72d$export$4019e482d7709907);
$parcel$export(module.exports, "unmarkRollingUpData", () => $63ade4993fe2c72d$export$a87f3a58ac504efb);
const $63ade4993fe2c72d$export$4019e482d7709907 = ()=>({ setState: setState })=>{
        setState({
            isRollingUp: true
        });
    };
const $63ade4993fe2c72d$export$a87f3a58ac504efb = ()=>({ setState: setState })=>{
        setState({
            isRollingUp: false
        });
    };

});



parcelRegister("hT6LY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6bfcc5b08b83e93$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lqalZ = parcelRequire("lqalZ");

var $9RIuy = parcelRequire("9RIuy");

var $jZDJX = parcelRequire("jZDJX");
const $d6bfcc5b08b83e93$var$FetchScreenIdService = (props)=>{
    const { fetchScreenIdRequest: fetchScreenIdRequest, isSimplifiedProject: isSimplifiedProject } = props;
    (0, $eUqFw.useEffect)(()=>{
        if (!isSimplifiedProject) fetchScreenIdRequest();
    }, [
        fetchScreenIdRequest,
        isSimplifiedProject
    ]);
    return null;
};
var $d6bfcc5b08b83e93$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state)=>({
        isSimplifiedProject: (0, $jZDJX.isSimplifiedProjectSelector)(state)
    }), {
    fetchScreenIdRequest: (0, $9RIuy.fetchScreenIdRequest)
})($d6bfcc5b08b83e93$var$FetchScreenIdService);

});
parcelRegister("9RIuy", function(module, exports) {

$parcel$export(module.exports, "FETCH_SCREENID_REQUEST", () => $9904a7596135f6e6$export$4e35fbc0ebf8a4fc);
$parcel$export(module.exports, "fetchScreenIdRequest", () => $9904a7596135f6e6$export$834b1000f56e019e);
$parcel$export(module.exports, "FETCH_SCREENID_SUCCESS", () => $9904a7596135f6e6$export$f9362008cf73501);
$parcel$export(module.exports, "fetchScreenIdSuccess", () => $9904a7596135f6e6$export$1506e418152222b6);
$parcel$export(module.exports, "fetchScreenIdFailure", () => $9904a7596135f6e6$export$15325f06ea3c348a);
const $9904a7596135f6e6$export$4e35fbc0ebf8a4fc = 'FETCH_SCREENID_REQUEST';
const $9904a7596135f6e6$export$834b1000f56e019e = ()=>({
        type: $9904a7596135f6e6$export$4e35fbc0ebf8a4fc
    });
const $9904a7596135f6e6$export$f9362008cf73501 = 'FETCH_SCREENID_SUCCESS';
const $9904a7596135f6e6$export$1506e418152222b6 = (screenIdData)=>({
        type: $9904a7596135f6e6$export$f9362008cf73501,
        payload: screenIdData && screenIdData.data
    });
const $9904a7596135f6e6$export$c862d64a71f9a6c0 = 'FETCH_SCREENID_FAILURE';
const $9904a7596135f6e6$export$15325f06ea3c348a = (failureDescription)=>({
        type: $9904a7596135f6e6$export$c862d64a71f9a6c0,
        payload: failureDescription
    });

});


parcelRegister("6aweD", function(module, exports) {

$parcel$export(module.exports, "default", () => $306d08e4a443d43b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5iWql = parcelRequire("5iWql");

var $anFLA = parcelRequire("anFLA");

var $lqalZ = parcelRequire("lqalZ");

var $hoyvu = parcelRequire("hoyvu");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $bO7l3 = parcelRequire("bO7l3");

var $1TrR5 = parcelRequire("1TrR5");

var $kUiXU = parcelRequire("kUiXU");

var $6vrw7 = parcelRequire("6vrw7");
const $306d08e4a443d43b$var$IssueRealtimeSupport = ({ cloudId: cloudId, projectId: projectId, ...otherProps })=>cloudId && projectId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUiXU.default), {
        appId: "issue-view",
        ...otherProps
    }) : null;
const $306d08e4a443d43b$var$mapStateToProps = (state)=>({
        channels: (0, $bO7l3.realtimeChannelsSelector)(state),
        cloudId: (0, $5JqpU.cloudIdSelector)(state),
        projectId: (0, $jZDJX.projectIdSelector)(state),
        issueId: (0, $5JqpU.issueIdSelector)(state)
    });
const $306d08e4a443d43b$var$mapDispatchToProps = {
    realtimeUpdateCurrentIssue: $hoyvu.realtimeUpdateCurrentIssue
};
const $306d08e4a443d43b$var$mergePropsOld = (stateProps, dispatchProps)=>({
        channels: stateProps.channels,
        events: (0, $anFLA.EVENTS_TO_LISTEN),
        cloudId: stateProps.cloudId,
        projectId: stateProps.projectId,
        onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onReceive: (event, analyticEvent)=>{
            if (event && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $anFLA.EVENTS_TO_LISTEN).includes(event.type) && 'issueId' in event.payload && event.payload.issueId === Number(stateProps.issueId)) {
                // TypeScript still does not understand that the `event`
                // is of the IssueViewRealtimeEvent type at this point so it is force casted
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const issueViewEvent = event;
                dispatchProps.realtimeUpdateCurrentIssue({
                    atlassianId: (0, $6vrw7.toAccountId)(issueViewEvent.payload.atlassianId),
                    projectId: (0, $6vrw7.toProjectId)(String(issueViewEvent.payload.projectId)),
                    issueId: (0, $6vrw7.toIssueId)(String(issueViewEvent.payload.issueId)),
                    updateType: issueViewEvent.type
                }, {
                    analyticsEvent: analyticEvent
                });
            }
        },
        onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    });
const $306d08e4a443d43b$var$onReceiveFactory = (0, $5iWql.default)((issueId, dispatchPropsRealtimeUpdateCurrentIssue)=>(event, analyticEvent)=>{
        if (event && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        (0, $anFLA.EVENTS_TO_LISTEN).includes(event.type) && 'issueId' in event.payload && event.payload.issueId === Number(issueId)) {
            // TypeScript still does not understand that the `event`
            // is of the IssueViewRealtimeEvent type at this point so it is force casted
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const issueViewEvent = event;
            dispatchPropsRealtimeUpdateCurrentIssue({
                atlassianId: (0, $6vrw7.toAccountId)(issueViewEvent.payload.atlassianId),
                projectId: (0, $6vrw7.toProjectId)(String(issueViewEvent.payload.projectId)),
                issueId: (0, $6vrw7.toIssueId)(String(issueViewEvent.payload.issueId)),
                updateType: issueViewEvent.type
            }, {
                analyticsEvent: analyticEvent
            });
        }
    });
const $306d08e4a443d43b$var$mergePropsNew = (stateProps, dispatchProps)=>({
        channels: stateProps.channels,
        events: (0, $anFLA.EVENTS_TO_LISTEN),
        cloudId: stateProps.cloudId,
        projectId: stateProps.projectId,
        onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onReceive: $306d08e4a443d43b$var$onReceiveFactory(stateProps.issueId, dispatchProps.realtimeUpdateCurrentIssue),
        onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    });
var $306d08e4a443d43b$export$2e2bcd8739ae039 = (0, $lqalZ.connect)($306d08e4a443d43b$var$mapStateToProps, $306d08e4a443d43b$var$mapDispatchToProps, (0, $1TrR5.functionWithFFRedux)($306d08e4a443d43b$var$mergePropsNew, $306d08e4a443d43b$var$mergePropsOld))($306d08e4a443d43b$var$IssueRealtimeSupport);

});
parcelRegister("hoyvu", function(module, exports) {

$parcel$export(module.exports, "REALTIME_UPDATE_CURRENT_ISSUE", () => $f486512a2edbbedc$export$7161a856bcc06403);
$parcel$export(module.exports, "realtimeUpdateCurrentIssue", () => $f486512a2edbbedc$export$bcc0d964cf46d12c);
const $f486512a2edbbedc$export$7161a856bcc06403 = 'REALTIME_UPDATE_CURRENT_ISSUE';
const $f486512a2edbbedc$export$bcc0d964cf46d12c = (payload, meta)=>({
        type: $f486512a2edbbedc$export$7161a856bcc06403,
        payload: payload,
        meta: meta
    });

});

parcelRegister("bO7l3", function(module, exports) {

$parcel$export(module.exports, "realtimeChannelsSelector", () => $d477efbeea624502$export$3d8a5aabe9d41ff7);

var $df4Sl = parcelRequire("df4Sl");

var $giZl9 = parcelRequire("giZl9");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");
const $d477efbeea624502$export$3d8a5aabe9d41ff7 = (0, $df4Sl.createSelector)((0, $5JqpU.cloudIdSelector), (0, $jZDJX.projectIdSelector), // @ts-expect-error - TS2345 - Argument of type 'number | null' is not assignable to parameter of type 'string | number'.
(cloudId, projectId)=>[
        (0, $giZl9.buildChannelString)(cloudId, projectId)
    ]);

});
parcelRegister("giZl9", function(module, exports) {

$parcel$export(module.exports, "getDefaultPubSubHost", () => $5615d21da29bd94b$export$f795b2d9ba365882);
$parcel$export(module.exports, "buildChannelString", () => $5615d21da29bd94b$export$354e43de513ff5);

var $6rW04 = parcelRequire("6rW04");

const $5615d21da29bd94b$export$f795b2d9ba365882 = ()=>(0, $6rW04.default)('ajs-fabric-realtime-url') || (0, $b0799f8f855a2fe4$export$92ffb25149c24a33);
const $5615d21da29bd94b$export$354e43de513ff5 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;

});
const $b0799f8f855a2fe4$export$92ffb25149c24a33 = '/gateway/api/pubsub';
const $b0799f8f855a2fe4$export$13ac40d1a5475532 = 'JIRA';



parcelRegister("kUiXU", function(module, exports) {

$parcel$export(module.exports, "default", () => $762b47cb6f205076$export$2e2bcd8739ae039);

var $6heO3 = parcelRequire("6heO3");

var $fLHAD = parcelRequire("fLHAD");

var $2W6nG = parcelRequire("2W6nG");


var $giZl9 = parcelRequire("giZl9");
var $762b47cb6f205076$export$2e2bcd8739ae039 = (0, $6heO3.default);

});
parcelRegister("6heO3", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb89aa8c6039d680$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $fLHAD = parcelRequire("fLHAD");

var $2W6nG = parcelRequire("2W6nG");
class $eb89aa8c6039d680$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onReceive: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    render() {
        const { appId: appId, events: events, onJoin: onJoin, onLeave: onLeave, channels: channels } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2W6nG.RealtimeProvider), {
            appId: appId,
            onJoin: onJoin,
            onLeave: onLeave,
            channels: channels
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fLHAD.RealtimeClient), {
            events: events,
            onReceive: this.onEventReceive
        }));
    }
    constructor(...args){
        super(...args);
        this.onEventReceive = (eventType, payload, analyticEvent)=>{
            const event = {
                type: eventType,
                payload: payload
            };
            this.props.onReceive(event, analyticEvent);
        };
    }
}

});
parcelRegister("fLHAD", function(module, exports) {

$parcel$export(module.exports, "RealtimeClient", () => $42b77c4aa56216fa$export$e680ceb7b9fcc184);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $g8JvH = parcelRequire("g8JvH");

var $efKIh = parcelRequire("efKIh");

var $6yVT4 = parcelRequire("6yVT4");
// eslint-disable-next-line jira/react/no-class-components
class $42b77c4aa56216fa$var$RealtimeClientView extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            children: null
        };
    }
    componentDidMount() {
        this.subscribeToPropEvents();
    }
    componentDidUpdate(prevProps) {
        if (this.props.client !== prevProps.client || this.props.events !== prevProps.events) {
            const removedEvents = prevProps.events.filter((prevEvent)=>!this.props.events.includes(prevEvent));
            removedEvents.forEach(this.unSubscribeToEvent);
            this.subscribeToPropEvents();
        }
    }
    componentWillUnmount() {
        this.unsubscribeToPropEvents();
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.onReceiveEvent = (event, payload)=>{
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            this.props.onReceive(event, payload);
        };
        this.subscribeToEvent = (eventName)=>{
            this.props.client?.on(eventName, this.onReceiveEvent);
        };
        this.unSubscribeToEvent = (eventName)=>{
            this.props.client?.off(eventName, this.onReceiveEvent);
        };
        this.subscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.subscribeToEvent);
        };
        this.unsubscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.unSubscribeToEvent);
        };
    }
}
const $42b77c4aa56216fa$var$withAnalytics = (0, $g8JvH.AnalyticsEventToProps)('realtimeClient', {
    onReceive: 'eventReceived'
});
const $42b77c4aa56216fa$export$e680ceb7b9fcc184 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))($42b77c4aa56216fa$var$withAnalytics, (0, $6yVT4.withPubSubClient), (0, $efKIh.asClientOnly))($42b77c4aa56216fa$var$RealtimeClientView);
var $42b77c4aa56216fa$export$2e2bcd8739ae039 = $42b77c4aa56216fa$export$e680ceb7b9fcc184;

});
parcelRegister("efKIh", function(module, exports) {

$parcel$export(module.exports, "asClientOnly", () => $4874a35f2e3af873$export$95cd02374de3431);

var $eUqFw = parcelRequire("eUqFw");
function $4874a35f2e3af873$export$95cd02374de3431(WrappedComponent) {
    return (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props);
    };
}
var $4874a35f2e3af873$export$2e2bcd8739ae039 = $4874a35f2e3af873$export$95cd02374de3431;

});

parcelRegister("6yVT4", function(module, exports) {

$parcel$export(module.exports, "withPubSubClient", () => $4857e418d88b13dd$export$32d968d4900ae3cd);

var $eUqFw = parcelRequire("eUqFw");

var $e97Bh = parcelRequire("e97Bh");
function $4857e418d88b13dd$export$32d968d4900ae3cd(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e97Bh.Consumer), null, ({ client: client })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                client: client
            }));
}
var $4857e418d88b13dd$export$2e2bcd8739ae039 = $4857e418d88b13dd$export$32d968d4900ae3cd;

});
parcelRegister("e97Bh", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $4f1fb1ba24fc84ec$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $4f1fb1ba24fc84ec$export$b3bffd4bb7da6b8f);

var $eUqFw = parcelRequire("eUqFw");
const $4f1fb1ba24fc84ec$var$defaultContext = {
    client: null
};
const { Provider: $4f1fb1ba24fc84ec$export$2881499e37b75b9a, Consumer: $4f1fb1ba24fc84ec$export$b3bffd4bb7da6b8f } = /*#__PURE__*/ (0, $eUqFw.createContext)($4f1fb1ba24fc84ec$var$defaultContext);

});



parcelRegister("2W6nG", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $ba1d3670c80098a4$export$64d242981d970821);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $jG2Eu = parcelRequire("jG2Eu");

var $gUUjF = parcelRequire("gUUjF");

var $g8JvH = parcelRequire("g8JvH");

var $3FyZ4 = parcelRequire("3FyZ4");


var $e97Bh = parcelRequire("e97Bh");

var $eBLah = parcelRequire("eBLah");

var $eDbRL = parcelRequire("eDbRL");

const $ba1d3670c80098a4$var$createPubSubClient = (host, analyticsClient)=>(parcelRequire("gewAB")).then((module)=>{
        const Client = module.default;
        return new Client({
            product: (0, $b0799f8f855a2fe4$export$13ac40d1a5475532),
            url: `${host}`,
            apsProtocol: {
                enabled: true
            },
            analyticsClient: analyticsClient
        });
    });
const $ba1d3670c80098a4$export$c127c26e30518ed5 = (appId, client, channels, onHandler)=>client.join(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $gUUjF.default).safeErrorWithoutCustomerData('realtime.channel.join.failure', `Failed to join channel @ ${appId}`, error);
    });
const $ba1d3670c80098a4$export$e6c41c8aa28ddeb9 = (appId, client, channels, onHandler)=>client.leave(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $gUUjF.default).safeErrorWithoutCustomerData('realtime.channel.leave.failure', `Failed to left channel @ ${appId}`, error);
    });
// eslint-disable-next-line jira/react/no-class-components
class $ba1d3670c80098a4$var$RealtimeProviderView extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            host: (0, $b0799f8f855a2fe4$export$92ffb25149c24a33),
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    componentDidMount() {
        const { appId: appId, host: host, channels: channels } = this.props;
        this.isComponentMounted = true;
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((analyticsClient)=>$ba1d3670c80098a4$var$createPubSubClient(host, analyticsClient.getInstance())).then((pubSubClient)=>$ba1d3670c80098a4$export$c127c26e30518ed5(appId, pubSubClient, channels, this.onJoinChannel).then(()=>{
                if (this.isComponentMounted) this.setState({
                    client: pubSubClient
                });
            }));
    }
    componentDidUpdate({ channels: prevChannels }) {
        const { appId: appId, channels: newChannels } = this.props;
        const { client: client } = this.state;
        if (client && newChannels !== prevChannels) {
            const removedChannels = prevChannels.filter((channel)=>!newChannels.includes(channel));
            $ba1d3670c80098a4$export$e6c41c8aa28ddeb9(appId, client, removedChannels, this.onLeaveChannel);
            $ba1d3670c80098a4$export$c127c26e30518ed5(appId, client, newChannels, this.onJoinChannel);
        }
    }
    componentWillUnmount() {
        const { appId: appId, channels: channels } = this.props;
        const { client: client } = this.state;
        this.isComponentMounted = false;
        if (client) $ba1d3670c80098a4$export$e6c41c8aa28ddeb9(appId, client, channels, this.onLeaveChannel);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e97Bh.Provider), {
            value: {
                client: this.state.client
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            client: null
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onJoinChannel = (result)=>{
            const { onJoin: onJoin } = this.props;
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onJoin(Array.from(result.currentChannels));
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onLeaveChannel = (result)=>{
            const { onLeave: onLeave } = this.props;
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onLeave(Array.from(result.currentChannels));
        };
        this.isComponentMounted = false;
    }
}
const $ba1d3670c80098a4$var$withAnalytics = (0, $g8JvH.AnalyticsEventToProps)('realtimeProvider', {
    onJoin: 'joinedChannel',
    onLeave: 'leftChannel'
});
const $ba1d3670c80098a4$export$64d242981d970821 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))($ba1d3670c80098a4$var$withAnalytics, (0, $eBLah.withHost), (0, $eDbRL.withRuntimeProvider))($ba1d3670c80098a4$var$RealtimeProviderView);
var $ba1d3670c80098a4$export$2e2bcd8739ae039 = $ba1d3670c80098a4$export$64d242981d970821;

});
parcelRegister("eBLah", function(module, exports) {

$parcel$export(module.exports, "withHost", () => $bd78fcaaefe05a83$export$b2d89aaea1461cd9);

var $eUqFw = parcelRequire("eUqFw");

var $giZl9 = parcelRequire("giZl9");
function $bd78fcaaefe05a83$export$b2d89aaea1461cd9(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            host: (0, $giZl9.getDefaultPubSubHost)()
        });
}
var $bd78fcaaefe05a83$export$2e2bcd8739ae039 = $bd78fcaaefe05a83$export$b2d89aaea1461cd9;

});

parcelRegister("eDbRL", function(module, exports) {

$parcel$export(module.exports, "withRuntimeProvider", () => $e49daff82a9a2253$export$4b38d0b01368c3f4);

var $eUqFw = parcelRequire("eUqFw");
function $e49daff82a9a2253$export$4b38d0b01368c3f4(WrappedComponent) {
    return (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props);
    };
}
var $e49daff82a9a2253$export$2e2bcd8739ae039 = $e49daff82a9a2253$export$4b38d0b01368c3f4;

});

parcelRegister("gewAB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('acEmi');
        const value = parcelRequire('3S62s');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("acEmi").then(()=>parcelRequire('3S62s'));
}

});





parcelRegister("lgxUt", function(module, exports) {

$parcel$export(module.exports, "useIssueKeyMismatchListener", () => $36a664b25e4db6e2$export$f35b99320d7997c3);

var $eUqFw = parcelRequire("eUqFw");

var $hzcvF = parcelRequire("hzcvF");
const $36a664b25e4db6e2$var$useIsUpdated = (value)=>{
    const newValue = (0, $hzcvF.usePreviousWithInitial)(value);
    return newValue !== value;
};
const $36a664b25e4db6e2$export$f35b99320d7997c3 = ({ issueKeyFromProps: issueKeyFromProps, issueKeyFromData: issueKeyFromData, onIssueKeyChange: onIssueKeyChange })=>{
    const isIssueKeyFromDataUpdated = $36a664b25e4db6e2$var$useIsUpdated(issueKeyFromData);
    const isFirstMountRef = (0, $eUqFw.useRef)(true);
    const isBothIssueKeysDefined = issueKeyFromData != null && issueKeyFromProps != null;
    const isIssueKeyFromDataDifferentToProps = issueKeyFromData !== issueKeyFromProps;
    if (// Check for when the data updates to a value that is not nullish
    (isIssueKeyFromDataUpdated || isFirstMountRef.current) && isBothIssueKeysDefined && // Then guard against the case where updates to the props are what triggered the update to data
    isIssueKeyFromDataDifferentToProps) onIssueKeyChange?.({
        fromIssueKey: issueKeyFromProps,
        toIssueKey: issueKeyFromData,
        meta: {
            location: 'issuekey-mismatch-listener'
        }
    });
    isFirstMountRef.current = false;
};

});

parcelRegister("lyLlZ", function(module, exports) {

$parcel$export(module.exports, "CombineStateContainers", () => $28b76361ed2b3e2a$export$6418f3a449fab78d);
$parcel$export(module.exports, "IssueStateContainers", () => $28b76361ed2b3e2a$export$4c68a9a4ff98d0b8);

var $eUqFw = parcelRequire("eUqFw");

var $lgWZr = parcelRequire("lgWZr");

var $6tkcD = parcelRequire("6tkcD");

var $hWdjG = parcelRequire("hWdjG");

var $6J9Jw = parcelRequire("6J9Jw");

var $k9hJ7 = parcelRequire("k9hJ7");

var $K1Vl8 = parcelRequire("K1Vl8");

var $b3GF8 = parcelRequire("b3GF8");

var $2z6ly = parcelRequire("2z6ly");

var $b3pJg = parcelRequire("b3pJg");

var $6nYhF = parcelRequire("6nYhF");

var $2GHKf = parcelRequire("2GHKf");

var $8p8vy = parcelRequire("8p8vy");

var $2W5Mi = parcelRequire("2W5Mi");

var $loLFB = parcelRequire("loLFB");

var $hSjJg = parcelRequire("hSjJg");

var $gL8eB = parcelRequire("gL8eB");

var $8rc7e = parcelRequire("8rc7e");

var $linOi = parcelRequire("linOi");
const $28b76361ed2b3e2a$var$composeContainers = (containers, scope, children)=>containers.reduceRight((acc, Container)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Container, {
            scope: scope
        }, acc), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children));
// issue-view "contains" a set of sweet-state stores inside it preventing global pollution
// information from them will not leak outside issue view
const $28b76361ed2b3e2a$var$NON_GLOBAL_ISSUE_STORE_CONTAINERS = [
    (0, $2W5Mi.ForceStoreContainer),
    (0, $6nYhF.StoreForIssueViewContainer),
    (0, $6J9Jw.DesignPanelContainer),
    (0, $2GHKf.EcosystemStoreContainer),
    (0, $b3GF8.IssueRefreshServiceStoreContainer),
    (0, $loLFB.FindFieldDialogContainer),
    (0, $6tkcD.IssueAttachmentStoreContainer),
    (0, $2z6ly.IssueScrollContainer),
    (0, $hSjJg.IssueLayoutContainer),
    (0, $8p8vy.IssueViewFieldUpdateEventContainer),
    (0, $gL8eB.FormInIssueStatusContainer),
    (0, $6tkcD.IssueAttachmentStoreContainer),
    // is expected to contain current issue information and should be scoped
    // but due to JIV-14202 we do not actually scope on it
    (0, $hWdjG.IssueContextContainer),
    (0, $K1Vl8.IssueFieldEditingContextProvider),
    (0, $lgWZr.AssociatedIssuesContextContainer)
];
// a subset of containers above expected to be hard-scoped to a given issue
// their content should be reset on issue change
// JIV-14202: the following containers are not passed into redux and free from glitching problem
const $28b76361ed2b3e2a$var$SCOPED_ISSUE_CONTAINERS = [
    // are expected to be "reset" on issue update and are not used by Redux
    (0, $loLFB.FindFieldDialogContainer),
    (0, $gL8eB.FormInIssueStatusContainer),
    (0, $linOi.WorklogTimeTrackingContainer),
    (0, $k9hJ7.IssueRefreshLoadingContainer),
    (0, $8rc7e.UiModificationsContainer),
    (0, $b3pJg.TriggerIssueTransitionModalContainer)
];
// just ensure those sets do not intersect
const $28b76361ed2b3e2a$var$unscopedIssueContainers = $28b76361ed2b3e2a$var$NON_GLOBAL_ISSUE_STORE_CONTAINERS.filter((container)=>!$28b76361ed2b3e2a$var$SCOPED_ISSUE_CONTAINERS.includes(container));
const $28b76361ed2b3e2a$export$6418f3a449fab78d = ({ scope: scope, containers: containers, children: children })=>$28b76361ed2b3e2a$var$composeContainers(containers, scope, children);
const $28b76361ed2b3e2a$export$4c68a9a4ff98d0b8 = ({ children: children, scope: scope })=>$28b76361ed2b3e2a$var$composeContainers($28b76361ed2b3e2a$var$unscopedIssueContainers, undefined, $28b76361ed2b3e2a$var$composeContainers($28b76361ed2b3e2a$var$SCOPED_ISSUE_CONTAINERS, scope, children));

});
parcelRegister("6J9Jw", function(module, exports) {

$parcel$export(module.exports, "useDesignPanelStore", () => $a908573f791176c6$export$8fafa2392808b318);
$parcel$export(module.exports, "DesignPanelContainer", () => $a908573f791176c6$export$53d7309d2c8ba57e);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $a908573f791176c6$export$a464887a2e69fd49 = (shouldShow)=>({ setState: setState })=>{
        setState({
            shouldShowAddDesignForm: shouldShow,
            wasAddDesignButtonJustClicked: shouldShow
        });
    };
const $a908573f791176c6$export$f6ff21b36780d14a = ()=>({ setState: setState })=>{
        setState({
            shouldShowAddDesignForm: false
        });
    };
const $a908573f791176c6$var$resetWasAddDesignButtonJustClicked = ()=>({ setState: setState })=>{
        setState({
            wasAddDesignButtonJustClicked: false
        });
    };
const $a908573f791176c6$export$e324594224ef24da = {
    setShouldShowAddDesignForm: $a908573f791176c6$export$a464887a2e69fd49,
    resetShouldShowAddDesignForm: $a908573f791176c6$export$f6ff21b36780d14a,
    resetWasAddDesignButtonJustClicked: $a908573f791176c6$var$resetWasAddDesignButtonJustClicked
};
const $a908573f791176c6$export$d4c72bab9d6cc13a = {
    shouldShowAddDesignForm: false,
    wasAddDesignButtonJustClicked: false
};
const $a908573f791176c6$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    name: 'designPanelStore',
    initialState: $a908573f791176c6$export$d4c72bab9d6cc13a,
    actions: $a908573f791176c6$export$e324594224ef24da
});
const $a908573f791176c6$export$8fafa2392808b318 = (0, $ggKAj.createHook)($a908573f791176c6$export$390f32400eaf98c9);
const $a908573f791176c6$export$53d7309d2c8ba57e = (0, $heB5U.createContainer)($a908573f791176c6$export$390f32400eaf98c9);

});

parcelRegister("b3pJg", function(module, exports) {

$parcel$export(module.exports, "TriggerIssueTransitionModalContainer", () => $04b7e125a8f2ae4a$export$8ad65e459a406a8a);
$parcel$export(module.exports, "useTriggerIssueTransitionModalActions", () => $04b7e125a8f2ae4a$export$68de001c738e4145);
$parcel$export(module.exports, "useTriggerIssueTransitionModalState", () => $04b7e125a8f2ae4a$export$d3aceeec551eaab5);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $7iqKZ = parcelRequire("7iqKZ");

var $gtFcb = parcelRequire("gtFcb");
const $04b7e125a8f2ae4a$var$store = (0, $a61MH.createStore)({
    name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
    initialState: $7iqKZ.initialState,
    actions: $gtFcb
});
const $04b7e125a8f2ae4a$export$8ad65e459a406a8a = (0, $heB5U.createContainer)($04b7e125a8f2ae4a$var$store);
const $04b7e125a8f2ae4a$export$68de001c738e4145 = (0, $ggKAj.createActionsHook)($04b7e125a8f2ae4a$var$store);
const $04b7e125a8f2ae4a$export$d3aceeec551eaab5 = (0, $ggKAj.createStateHook)($04b7e125a8f2ae4a$var$store);

});
parcelRegister("7iqKZ", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $ab6f76333cdb27e5$export$d4c72bab9d6cc13a);

var $hompL = parcelRequire("hompL");

const $ab6f76333cdb27e5$export$d4c72bab9d6cc13a = {
    inProgressTransitionID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
    isModalOpen: false,
    isSubsequentLoad: false,
    payload: {
        issueId: '',
        issueKey: '',
        transitionId: ''
    },
    id: 'issue-transition-dialog',
    title: null,
    fetchedIssueId: '',
    triggerPointKey: (0, $fa834bef164496cf$export$8d987f6e80b74000),
    onDialogSuccess: null,
    onDialogCancel: null,
    onDialogError: null
};

});

parcelRegister("gtFcb", function(module, exports) {

$parcel$export(module.exports, "closeIssueTransitionModal", () => (parcelRequire("bh2xU")).default);
$parcel$export(module.exports, "openIssueTransitionModal", () => (parcelRequire("kO8vo")).default);
$parcel$export(module.exports, "restoreState", () => (parcelRequire("krvVA")).default);
$parcel$export(module.exports, "setFetchedIssueId", () => (parcelRequire("cqFa9")).default);

var $bh2xU = parcelRequire("bh2xU");

var $kO8vo = parcelRequire("kO8vo");

var $krvVA = parcelRequire("krvVA");

var $cqFa9 = parcelRequire("cqFa9");

});
parcelRegister("bh2xU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8733dbfae9aa86f$export$2e2bcd8739ae039);

var $7iqKZ = parcelRequire("7iqKZ");
const $c8733dbfae9aa86f$var$closeIssueTransitionModal = ()=>({ setState: setState })=>{
        setState({
            ...(0, $7iqKZ.initialState),
            isModalOpen: false,
            isSubsequentLoad: true
        });
    };
var $c8733dbfae9aa86f$export$2e2bcd8739ae039 = $c8733dbfae9aa86f$var$closeIssueTransitionModal;

});

parcelRegister("kO8vo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f64237f09f9bb7e0$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $fzLv5 = parcelRequire("fzLv5");

var $hvjqG = parcelRequire("hvjqG");

var $guiFP = parcelRequire("guiFP");

var $jRlXU = parcelRequire("jRlXU");

var $7ST5U = parcelRequire("7ST5U");
const $f64237f09f9bb7e0$var$openIssueTransitionModal = (nextState, preferNewIssueTransitionScreen = true)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $7ST5U.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                transitionModalVersion = 'NEW';
                (0, $jRlXU.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $hvjqG.timeToRenderTransitionModal).start();
                new (0, $fzLv5.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $f64237f09f9bb7e0$export$2e2bcd8739ae039 = $f64237f09f9bb7e0$var$openIssueTransitionModal;

});
parcelRegister("fzLv5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f25a951ff2b0812$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $2BvS3 = parcelRequire("2BvS3");

var $5zSUY = parcelRequire("5zSUY");

var $hvjqG = parcelRequire("hvjqG");
class $0f25a951ff2b0812$export$2e2bcd8739ae039 {
    constructor({ issueId: issueId, transitionId: transitionId, issueKey: issueKey, issueKeys: issueKeys }){
        this.onDialogSuccessCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.onDialogErrorCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.onDialogCancelCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.issueId = issueId;
        this.transitionId = transitionId;
        this.issueKey = issueKey;
        this.issueKeys = issueKeys;
    }
    static{
        this.onDialogContentReady = ()=>{
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                (0, $hvjqG.timeToRenderTransitionModal).stop();
            });
        };
    }
    onDialogSuccess(onDialogSuccessCallback) {
        this.onDialogSuccessCallback = onDialogSuccessCallback;
        return this;
    }
    onDialogError(onDialogErrorCallback) {
        this.onDialogErrorCallback = onDialogErrorCallback;
        return this;
    }
    onDialogCancel(onDialogCancelCallback) {
        this.onDialogCancelCallback = onDialogCancelCallback;
        return this;
    }
    getIssueParam() {
        if (this.issueId != null) return `id=${this.issueId}`;
        if (this.issueKey != null) return `key=${this.issueKey}`;
        return '';
    }
    getUrl() {
        const { issueKeys: issueKeys } = this;
        if (issueKeys != null) // key= is needed to be sent together with keys= because of legacy API
        return `/secure/BulkTransitionIssue!default.jspa?keys=${issueKeys.join(',')}&key=${issueKeys[0]}&action=${this.transitionId}&atl_token=${(0, $5zSUY.default)() || ''}&decorator=dialog&inline=true&returnUrl=`;
        return `/secure/WorkflowUIDispatcher.jspa?${this.getIssueParam()}&action=${this.transitionId}&atl_token=${(0, $5zSUY.default)() || ''}&returnUrl=`;
    }
    async show() {
        document.addEventListener('legacyJiraDialogContentReady', $0f25a951ff2b0812$export$2e2bcd8739ae039.onDialogContentReady);
        // eslint-disable-next-line jira/wrm/no-load-bridge
        const FormDialog = await (0, $2BvS3.loadBridge)({
            name: 'jira/dialog/form-dialog',
            wrmKeys: 'wrc!jira.webresources:dialogs'
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const dialog = new FormDialog({
            id: 'edit-issue-dialog',
            ajaxOptions: {
                url: this.getUrl(),
                dataType: 'json'
            },
            autoClose: true,
            widthClass: 'large',
            onDialogFinished: this.onDialogSuccessCallback,
            onUnSuccessfulSubmit: this.onDialogErrorCallback,
            shouldLoadHeritageFormDialogContext: true
        });
        const cancelNativeHandler = (event)=>{
            if (!(event instanceof CustomEvent)) return;
            const dialogElement = event.detail.popup;
            const { reason: reason } = event.detail;
            if (dialogElement.is(dialog.get$popup())) {
                if (reason === 'cancel' || reason === 'esc') this.onDialogCancelCallback(event, dialogElement, reason);
                document.removeEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
                document.removeEventListener('legacyJiraDialogContentReady', $0f25a951ff2b0812$export$2e2bcd8739ae039.onDialogContentReady);
            }
        };
        document.addEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
        dialog.show();
    }
}

});
parcelRegister("hvjqG", function(module, exports) {

$parcel$export(module.exports, "timeToRenderTransitionModal", () => $5364d9ea59150bac$export$9d20a86383e90d09);

var $lEpcX = parcelRequire("lEpcX");
const $5364d9ea59150bac$export$9d20a86383e90d09 = (0, $lEpcX.metrics).interaction({
    key: 'issue.time-to.render-issue-transition-screen',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_2500_4000_7000_10000'
    }
});

});


parcelRegister("jRlXU", function(module, exports) {

$parcel$export(module.exports, "startIssueTransitionMetrics", () => $bd86a98ef7e8a43a$export$3fc439100e136a52);

var $1ybV0 = parcelRequire("1ybV0");

var $3gb01 = parcelRequire("3gb01");
var $67xHO = parcelRequire("67xHO");

var $fy5vB = parcelRequire("fy5vB");

var $duQ8C = parcelRequire("duQ8C");
const $bd86a98ef7e8a43a$export$3fc439100e136a52 = (isSubsequentLoad)=>{
    (0, $3gb01.IssueTransitionLoadUFOExperience).start();
    const issueTransitionModalLoadMetric = isSubsequentLoad ? (0, $67xHO.issueTransittionModalLoadSubsequent) : (0, $67xHO.issueTransitionModalLoad);
    if (isSubsequentLoad) (0, $duQ8C.default)('issue-transition.transition-modal-subsequent');
    else (0, $duQ8C.default)('issue-transition.transition-modal');
    issueTransitionModalLoadMetric.start();
    if ((0, $1ybV0.ff)('ui-modifications-on-issue-transition-view_7z1g0')) (0, $fy5vB.startUimTTI)();
};

});
parcelRegister("3gb01", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionLoadUFOExperience", () => $dda1b5d926efd158$export$8fb308d8abecd81a);
$parcel$export(module.exports, "IssueTransitionSubmitUFOExpereince", () => $dda1b5d926efd158$export$bd3bf8b90a131c50);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $dda1b5d926efd158$export$8fb308d8abecd81a = new (0, $kDfSL.UFOExperience)('issue-transition-screen.transition-load', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-load'
});
const $dda1b5d926efd158$export$bd3bf8b90a131c50 = new (0, $kDfSL.UFOExperience)('issue-transition-screen.transition-submit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-sumbit'
});

});

parcelRegister("67xHO", function(module, exports) {

$parcel$export(module.exports, "issueTransitionModalLoad", () => $cdba3bd366b58958$export$772fb4a8bd181fd6);
$parcel$export(module.exports, "issueTransittionModalLoadSubsequent", () => $cdba3bd366b58958$export$afa89f024c56a00a);

var $lEpcX = parcelRequire("lEpcX");
const $cdba3bd366b58958$export$772fb4a8bd181fd6 = (0, $lEpcX.metrics).interaction({
    key: 'issue-transition-modal'
});
const $cdba3bd366b58958$export$afa89f024c56a00a = (0, $lEpcX.metrics).interaction({
    key: 'issue-transition-modal-subsequent'
});

});


parcelRegister("7ST5U", function(module, exports) {

$parcel$export(module.exports, "isNewTransitionScreenEnabled", () => $23d7c4603c0324df$export$1f5b72e7dbe0548d);

var $1ybV0 = parcelRequire("1ybV0");
const $23d7c4603c0324df$export$3e9c47f2b27760a = (triggerPointKey)=>{
    const triggerPointsFlags = {
        'issue-transition-issue-view': (0, $1ybV0.ff)('issue-transition-issue-view_yq5a8'),
        'issue-transition-issue-view-shortcut-dialog': (0, $1ybV0.ff)('issue-transition-issue-view-shortcut_lv9l3'),
        'issue-transition-board-card-transition': (0, $1ybV0.ff)('issue-transition-board-card-transition_ciq82'),
        'issue-transition-advanced-roadmaps-jira-transition': (0, $1ybV0.ff)('issue-transition-advanced-roadmaps-jira-transition_b1gmi'),
        'issue-transition-command-palette-status-field-transition': (0, $1ybV0.ff)('issue-transition-command-palette-status-field-transition_ddmcl'),
        'issue-transition-issue-results-shortcut-transition': (0, $1ybV0.ff)('issue-transition-issue-results-shortcut-transition_9jznw'),
        'issue-transition-backlog-inline-transition': (0, $1ybV0.ff)('issue-transition-backlog-inline-transition_2mpzc'),
        'issue-transition-status-field-trigger': (0, $1ybV0.ff)('issue-transition-status-field-trigger_ygzr6'),
        'trigger-point-key-not-defined': (0, $1ybV0.ff)('trigger-point-key-not-defined_cixw0')
    };
    return triggerPointsFlags[triggerPointKey];
};
const $23d7c4603c0324df$export$1f5b72e7dbe0548d = (preferNewIssueTransitionScreen, triggerPointKey)=>{
    if (!(0, $1ybV0.ff)('render-modern-issue-transition_cxt0z')) return false;
    /* DEFAULT VALUE IS FALSE FOR ANY TRIGGER POINT NOT AVAILABLE IN THE MAP ABOVE
	 *  If trigger key is not present, then by default overall ITS will be false.
	 *  For any new trigger point, it must be necessary to list the trigger point in the map above.
	 *  When we cleanup FF for trigger points, then this should be also removed.
	 */ if (!triggerPointKey || !$23d7c4603c0324df$export$3e9c47f2b27760a(triggerPointKey)) return false;
    return preferNewIssueTransitionScreen || (0, $1ybV0.ff)('issue-transition-customisation-for-srb_0eyvc');
};

});


parcelRegister("krvVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e2db18eed05b7b$export$2e2bcd8739ae039);
const $a3e2db18eed05b7b$var$restoreState = (stateToRestore)=>({ setState: setState })=>{
        setState(stateToRestore);
    };
var $a3e2db18eed05b7b$export$2e2bcd8739ae039 = $a3e2db18eed05b7b$var$restoreState;

});

parcelRegister("cqFa9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e14702d6ab11f2a$export$2e2bcd8739ae039);
/**
 *
 * @deprecated since we should not be using this in the log run
 * we should not call this method any where and should clean this up as soon as GIC-JIS migration is done
 * @param issueId
 * @returns
 */ const $3e14702d6ab11f2a$var$setFetchedIssueId = (issueId)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { fetchedIssueId: fetchedIssueId } = currentState;
        if (issueId !== fetchedIssueId) setState({
            ...currentState,
            fetchedIssueId: issueId
        });
    };
var $3e14702d6ab11f2a$export$2e2bcd8739ae039 = $3e14702d6ab11f2a$var$setFetchedIssueId;

});



parcelRegister("loLFB", function(module, exports) {

$parcel$export(module.exports, "useFindFieldDialog", () => $6c1874dc5867b8e3$export$27645018744f0979);
$parcel$export(module.exports, "FindFieldDialogContainer", () => $6c1874dc5867b8e3$export$e12aee95614395f1);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $6c1874dc5867b8e3$export$d4c72bab9d6cc13a = {
    isOpen: false
};
const $6c1874dc5867b8e3$export$e324594224ef24da = {
    openFindFieldDialog: ()=>({ setState: setState })=>{
            setState({
                isOpen: true
            });
        },
    closeFindFieldDialog: ()=>({ setState: setState })=>{
            setState({
                isOpen: false
            });
        }
};
const $6c1874dc5867b8e3$var$store = (0, $a61MH.createStore)({
    name: 'issue-view.issue-actions.find-field',
    initialState: $6c1874dc5867b8e3$export$d4c72bab9d6cc13a,
    actions: $6c1874dc5867b8e3$export$e324594224ef24da
});
const $6c1874dc5867b8e3$export$27645018744f0979 = (0, $ggKAj.createHook)($6c1874dc5867b8e3$var$store);
const $6c1874dc5867b8e3$export$e12aee95614395f1 = (0, $heB5U.createContainer)($6c1874dc5867b8e3$var$store);

});

parcelRegister("hSjJg", function(module, exports) {

$parcel$export(module.exports, "MIN_EDITOR_SIDEBAR_CONTAINER_WIDTH", () => $46de8ed43dc087d9$export$9bba69f505cc82c8);
$parcel$export(module.exports, "IssueLayoutSubscriber", () => $46de8ed43dc087d9$export$70d3c017caf6ad6f);
$parcel$export(module.exports, "useIssueLayout", () => $46de8ed43dc087d9$export$7ca572d7925170e9);
$parcel$export(module.exports, "IssueLayoutContainer", () => $46de8ed43dc087d9$export$160ec6be23db4f40);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
const $46de8ed43dc087d9$export$9bba69f505cc82c8 = 360;
const $46de8ed43dc087d9$export$f3eec97113958bf5 = 255;
const $46de8ed43dc087d9$var$initialState = {
    sidebarMinWidth: $46de8ed43dc087d9$export$f3eec97113958bf5
};
const $46de8ed43dc087d9$var$actions = {
    updateSidebarMinWidth: (sidebarMinWidth)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                sidebarMinWidth: sidebarMinWidth
            });
        },
    resetSidebarMinWidth: ()=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                sidebarMinWidth: $46de8ed43dc087d9$export$f3eec97113958bf5
            });
        }
};
const $46de8ed43dc087d9$var$Store = (0, $a61MH.createStore)({
    initialState: $46de8ed43dc087d9$var$initialState,
    actions: $46de8ed43dc087d9$var$actions,
    name: 'issue-layout'
});
const $46de8ed43dc087d9$export$70d3c017caf6ad6f = (0, $dYfll.createSubscriber)($46de8ed43dc087d9$var$Store);
const $46de8ed43dc087d9$export$7ca572d7925170e9 = (0, $ggKAj.createHook)($46de8ed43dc087d9$var$Store);
const $46de8ed43dc087d9$export$160ec6be23db4f40 = (0, $heB5U.createContainer)($46de8ed43dc087d9$var$Store);

});

parcelRegister("gL8eB", function(module, exports) {

$parcel$export(module.exports, "useFormsInIssueStatus", () => $e46171fbf1315aa8$export$f86a00cbba3b85eb);
$parcel$export(module.exports, "FormInIssueStatusContainer", () => $e46171fbf1315aa8$export$20a71f904bac32b4);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $ebMyD = parcelRequire("ebMyD");
const $e46171fbf1315aa8$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-forms',
    initialState: {
        issueViewAddFormButtonClickedCount: 0
    },
    actions: $ebMyD
});
const $e46171fbf1315aa8$export$f86a00cbba3b85eb = (0, $ggKAj.createHook)($e46171fbf1315aa8$export$6f57813fe9f31bf9, {
    selector: (state)=>state.issueViewAddFormButtonClickedCount
});
const $e46171fbf1315aa8$export$20a71f904bac32b4 = (0, $heB5U.createContainer)($e46171fbf1315aa8$export$6f57813fe9f31bf9);

});
parcelRegister("ebMyD", function(module, exports) {

$parcel$export(module.exports, "onClickAddFormButton", () => $b10dad7575bf1b9e$export$fd16710709adbbd8);
$parcel$export(module.exports, "resetAddFormButtonCount", () => $b10dad7575bf1b9e$export$b7d7e4ff7beaa01c);
const $b10dad7575bf1b9e$export$fd16710709adbbd8 = ()=>({ setState: setState, getState: getState })=>{
        const currentCount = getState().issueViewAddFormButtonClickedCount;
        setState({
            issueViewAddFormButtonClickedCount: currentCount + 1
        });
    };
const $b10dad7575bf1b9e$export$b7d7e4ff7beaa01c = ()=>({ setState: setState })=>{
        setState({
            issueViewAddFormButtonClickedCount: 0
        });
    };

});



parcelRegister("OTMDz", function(module, exports) {

$parcel$export(module.exports, "getContext", () => $0dc58d2c3c039193$export$31553aaa555c1514);
$parcel$export(module.exports, "getIssueContext", () => $0dc58d2c3c039193$export$5f888d0c3506f813);
$parcel$export(module.exports, "getStore", () => $0dc58d2c3c039193$export$6fec604aa7293d0c);
$parcel$export(module.exports, "setup", () => $0dc58d2c3c039193$export$de27182ff8187d6c);
$parcel$export(module.exports, "useSweetStateToReduxSynchronization", () => $0dc58d2c3c039193$export$db47552623acf49b);
$parcel$export(module.exports, "useScopedStoreActions", () => $0dc58d2c3c039193$export$da5289b3ebf1ae74);

var $eUqFw = parcelRequire("eUqFw");

var $7XfGu = parcelRequire("7XfGu");
parcelRequire("hxkaY");

var $8Qd0L = parcelRequire("8Qd0L");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $hCNRu = parcelRequire("hCNRu");

var $btjMs = parcelRequire("btjMs");

var $47oY8 = parcelRequire("47oY8");

var $3uwfp = parcelRequire("3uwfp");

var $k3tie = parcelRequire("k3tie");
var $8p8vy = parcelRequire("8p8vy");

var $ePSh2 = parcelRequire("ePSh2");

var $5nezI = parcelRequire("5nezI");

var $a0Zgz = parcelRequire("a0Zgz");

var $fYteL = parcelRequire("fYteL");

var $fVCj0 = parcelRequire("fVCj0");

var $lO4Or = parcelRequire("lO4Or");

var $6vrw7 = parcelRequire("6vrw7");

var $jc4kK = parcelRequire("jc4kK");

var $fwyCm = parcelRequire("fwyCm");

var $jeWxl = parcelRequire("jeWxl");
const $0dc58d2c3c039193$export$31553aaa555c1514 = (props, tenantContext, orgId)=>{
    const { baseUrl: baseUrl, activationId: activationId, cloudId: cloudId, licensedProducts: licensedProducts, locale: locale, atlassianAccountId: atlassianAccountId, productCrossSellConfig: productCrossSellConfig, siteAdminStatus: siteAdminStatus, isAnonymous: isAnonymous, appEditions: appEditions, appPermissions: appPermissions, licenseStates: licenseStates, firstActivationDateMs: firstActivationDateMs } = tenantContext;
    return {
        analyticsSource: props.analyticsSource,
        analyticsMetadata: props.analyticsMetadata,
        appEditions: appEditions,
        appPermissions: appPermissions,
        atlassianAccountId: atlassianAccountId,
        baseUrl: baseUrl,
        backButtonUrl: props.backButtonUrl,
        boardId: props.boardId,
        boardType: props.boardType,
        cloudId: cloudId,
        activationId: activationId,
        orgId: orgId,
        estimationStatistic: props.estimationStatistic,
        firstActivationDateMs: firstActivationDateMs,
        isAnonymous: isAnonymous,
        isLoadedWithPage: props.isLoadedWithPage,
        isLoading: false,
        isModal: props.isModal,
        isSpaEnabled: props.isSpaEnabled,
        issueKey: props.issueKey,
        issueNavigatorData: props.issueNavigatorData,
        licensedProducts: licensedProducts,
        licenseStates: licenseStates,
        locale: locale,
        loginRedirectUrl: props.loginRedirectUrl,
        maxTokenLength: (0, $hCNRu.getMaxTokenLength)(),
        onIssueKeyChange: props.onIssueKeyChange,
        productCrossSellConfig: productCrossSellConfig,
        rapidViewId: props.rapidViewId,
        rapidViewMap: props.rapidViewMap,
        siteAdminStatus: siteAdminStatus,
        viewMode: props.viewMode
    };
};
const $0dc58d2c3c039193$export$5f888d0c3506f813 = (props)=>{
    const context = {
        analyticsSource: props.analyticsSource,
        backButtonUrl: props.backButtonUrl,
        boardId: props.boardId,
        boardType: props.boardType,
        estimationStatistic: props.estimationStatistic,
        isLoadedWithPage: props.isLoadedWithPage,
        isLoading: false,
        isModal: props.isModal,
        isSpaEnabled: props.isSpaEnabled,
        issueKey: props.issueKey,
        issueNavigatorData: props.issueNavigatorData,
        loginRedirectUrl: props.loginRedirectUrl,
        maxTokenLength: (0, $hCNRu.getMaxTokenLength)(),
        onIssueKeyChange: props.onIssueKeyChange,
        rapidViewId: props.rapidViewId,
        rapidViewMap: props.rapidViewMap?.map((arr)=>arr.map((key)=>(0, $6vrw7.toIssueKey)(key))),
        viewMode: props.viewMode
    };
    return context;
};
const $0dc58d2c3c039193$export$df2b736a06860be7 = (transition)=>({
        id: transition.id,
        name: transition.name,
        hasScreen: transition.hasScreen,
        isGlobal: transition.isGlobal,
        isInitial: transition.isInitial,
        isConditional: transition.isConditional,
        isLooped: transition.isLooped,
        to: {
            id: transition.to.id,
            name: transition.to.name,
            description: transition.to.description ?? '',
            statusCategory: {
                id: (0, $8Qd0L.categoryIdForStatusCategory)((0, $8Qd0L.statusCategoryForId)(transition.to.statusCategory?.id))
            }
        },
        from: transition.from
    });
const $0dc58d2c3c039193$export$6fec604aa7293d0c = (props, tenantContext, subProduct, dataProvider, recentIssuesActions, issueRefreshServiceActions, fieldsValueActions, fieldsConfigActions, issueViewLayoutActions, issueViewFieldUpdateActions, forgeActions, ecosystemActions, userPreferenceActions, prefetchedResourceManager, attachmentActions, issueScrollActions, permissionActions, jiraSettingsActions, projectContextActions, issueContextActions, workflowTransitionsActions, orgId, mediaContextActions, issueRefreshLoadingActionsRef, associatedIssuesContextActions, issueViewNonCriticalDataActions)=>{
    const recentIssue = recentIssuesActions.getRecentIssue(props.issueKey);
    const initialState = recentIssue ? {
        ...recentIssue,
        // Some props for the same issue might have changed - e.g. analyticsSource
        context: {
            ...recentIssue.context,
            ...$0dc58d2c3c039193$export$31553aaa555c1514(props, tenantContext, orgId)
        }
    } : undefined;
    return (0, $fwyCm.default)({
        attachmentActions: attachmentActions,
        onChange: props.onChange,
        onError: props.onError,
        dataProvider: dataProvider,
        history: props.history || (0, $7XfGu.default)(),
        initialState: initialState,
        issueKey: props.issueKey,
        subProduct: subProduct,
        issueRefreshServiceActions: issueRefreshServiceActions,
        fieldsValueActions: fieldsValueActions,
        fieldsConfigActions: fieldsConfigActions,
        issueViewLayoutActions: issueViewLayoutActions,
        issueViewFieldUpdateActions: issueViewFieldUpdateActions,
        forgeActions: forgeActions,
        ecosystemActions: ecosystemActions,
        prefetchedResourceManager: prefetchedResourceManager,
        recentIssuesActions: recentIssuesActions,
        userPreferenceActions: userPreferenceActions,
        issueScrollActions: issueScrollActions,
        permissionActions: permissionActions,
        jiraSettingsActions: jiraSettingsActions,
        projectContextActions: projectContextActions,
        issueContextActions: issueContextActions,
        workflowTransitionsActions: workflowTransitionsActions,
        mediaContextActions: mediaContextActions,
        associatedIssuesContextActions: associatedIssuesContextActions,
        issueRefreshLoadingActionsRef: issueRefreshLoadingActionsRef,
        issueViewNonCriticalDataActions: issueViewNonCriticalDataActions
    });
};
const $0dc58d2c3c039193$export$de27182ff8187d6c = (props, tenantContext, dataProvider, store, recentIssuesActions, fieldsValueActions, fieldsConfigActions, userPreferenceActions, prefetchedResourceManager, dispatchExternalAction, attachmentActions, issueContextActions, permissionActions, route, issueViewLayoutActions, forgeActions, ecosystemActions, jiraSettingsActions, projectContextActions, orgId, associatedIssuesContextActions)=>{
    const recentIssue = recentIssuesActions.getRecentIssue(props.issueKey);
    const recentIssuesCount = recentIssuesActions.getRecentIssuesCount();
    const startRenderingOptions = {
        analyticsSource: props.analyticsSource,
        issueContextActions: issueContextActions,
        isLoadedWithPage: props.isLoadedWithPage || false,
        isSPA: !props.isInitialRender,
        isRecentIssue: !!recentIssue,
        recentIssuesCount: recentIssuesCount,
        dataProvider: dataProvider,
        store: store,
        route: route
    };
    (0, $jc4kK.initialiseMetrics)(startRenderingOptions);
    // Calling set context for recent issues is necessary because our context-epic currently expects
    // a setContext to be fired for every issue viewed for bento-to-bento transitions to work.
    // The data will not change since we have already merged the context in the initial state
    store.dispatch((0, $ePSh2.setContext)($0dc58d2c3c039193$export$31553aaa555c1514(props, tenantContext, orgId)));
    issueContextActions.setIssueContext($0dc58d2c3c039193$export$5f888d0c3506f813(props));
    if (props.dispatchExternalActionRef) props.dispatchExternalActionRef(dispatchExternalAction);
    if (recentIssue) store.dispatch((0, $fYteL.refreshIssueRequest)());
    else {
        const prefetchDataConsumed = prefetchedResourceManager && (0, $jeWxl.consumePrefetchedDataIfAble)({
            resourceManager: prefetchedResourceManager,
            savePreferences: (preferences)=>userPreferenceActions.setUserPreferences(preferences),
            storeFieldsWithContext: (data, project)=>(0, $47oY8.storeFields)(data, fieldsValueActions, fieldsConfigActions, props.issueKey, project),
            storeIssueContainersLayoutData: (issueContainers)=>{
                issueViewLayoutActions.setIssueViewContainersLayout(props.issueKey, issueContainers);
            },
            storeEcosystemData: (ecosystem, issueKey)=>{
                ecosystemActions.setEcosystem(ecosystem, issueKey);
            },
            saveProjectContext: (projectKey, projectContext)=>{
                projectContextActions.setProjectContext(projectKey, projectContext);
            },
            permissionActions: permissionActions,
            attachmentActions: attachmentActions,
            jiraSettingsActions: jiraSettingsActions,
            store: store,
            baseUrl: tenantContext.baseUrl,
            issueContextActions: issueContextActions,
            issueKey: props.issueKey,
            associatedIssuesContextActions: associatedIssuesContextActions
        });
        if (prefetchDataConsumed) {
            // Data is readily available and has been fed into the storeRef on creation
            // We only need to fire the forge fetch
            store.dispatch((0, $fYteL.fetchForgeRequest)());
            prefetchedResourceManager.clearAll();
        } else // this "else" could mean any of:
        // - prefetched-data is still loading
        // - data returned with errors - we'll kickoff redux fetching in this case for its retry handling of transient errors
        store.dispatch((0, $fYteL.fetchIssueRequest)());
        store.dispatch((0, $a0Zgz.fetchLoggedInUserRequest)());
    }
    store.dispatch((0, $5nezI.fetchIssueRemoteDataRequest)(props.issueKey));
};
const $0dc58d2c3c039193$export$d9236993deb0d7ea = (event, fieldOptions = {
    isRichTextField: false
})=>(0, $fVCj0.fieldSaveSuccess)(event.meta.fieldId, {
        ...(0, $3uwfp.defaultConnectFieldConfig),
        ...fieldOptions
    }, event.meta.fieldValue, {
        updatedFieldValue: event.meta.fieldValue
    });
const $0dc58d2c3c039193$export$db47552623acf49b = (store)=>{
    const [, { registerEventHandler: registerEventHandler }] = (0, $8p8vy.useIssueViewFieldUpdateEvents)();
    const issueId = (0, $hJ992.useIssueId)();
    (0, $eUqFw.useEffect)(()=>{
        const unregister = registerEventHandler('onChange', (event)=>{
            if (event.type !== (0, $k3tie.ChangeEventTypes).FIELD_CHANGED || event.issueId !== issueId) return;
            const field = store.getState()?.fields[event.fieldId];
            const fieldType = (0, $btjMs.getFieldType)(field);
            switch(fieldType){
                case 0, $lO4Or.TEXT_AREA_CF_TYPE:
                    store.dispatch($0dc58d2c3c039193$export$d9236993deb0d7ea(event, {
                        isRichTextField: (0, $btjMs.isRichTextSupported)(field)
                    }));
                    break;
                case 0, $lO4Or.DESCRIPTION_TYPE:
                    store.dispatch($0dc58d2c3c039193$export$d9236993deb0d7ea(event, {
                        isRichTextField: true
                    }));
                    break;
                case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
                case 0, $lO4Or.SELECT_CF_TYPE:
                case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
                case 0, $lO4Or.TEXT_CF_TYPE:
                case 0, $lO4Or.URL_CF_TYPE:
                case 0, $lO4Or.RADIO_BUTTONS_CF_TYPE:
                case 0, $lO4Or.FIX_VERSIONS_TYPE:
                case 0, $lO4Or.USER_CF_TYPE:
                case 0, $lO4Or.REPORTER_TYPE:
                case 0, $lO4Or.COMPONENTS_TYPE:
                case 0, $lO4Or.MULTI_USER_CF_TYPE:
                    store.dispatch($0dc58d2c3c039193$export$d9236993deb0d7ea(event));
                    break;
                case 0, $lO4Or.AFFECTS_VERSIONS_TYPE:
                    if ((0, $1ybV0.ff)('forge-ui-modifications-affects-versions-field-support-iv_ff6mj')) store.dispatch($0dc58d2c3c039193$export$d9236993deb0d7ea(event));
                    break;
                default:
                    break;
            }
        });
        return unregister;
    }, [
        registerEventHandler,
        store,
        issueId
    ]);
    return null;
};
const $0dc58d2c3c039193$export$da5289b3ebf1ae74 = (hook, ...args)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = hook(...args);
    const actions = Array.isArray(result) ? result[1] : result;
    const actionsRef = (0, $eUqFw.useRef)(actions);
    actionsRef.current = actions;
    return actionsRef;
};

});
parcelRegister("7XfGu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5caa35aa03e15ac4$export$2e2bcd8739ae039, (v) => $5caa35aa03e15ac4$export$2e2bcd8739ae039 = v);
var $5caa35aa03e15ac4$export$1e511d4a378977f5;
var $5caa35aa03e15ac4$export$2e2bcd8739ae039;
'use strict';
$5caa35aa03e15ac4$export$1e511d4a378977f5 = true;
var $5caa35aa03e15ac4$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $5caa35aa03e15ac4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jx0f8 = parcelRequire("jx0f8");
var $5caa35aa03e15ac4$var$_warning2 = $5caa35aa03e15ac4$var$_interopRequireDefault($jx0f8);

var $h8TzT = parcelRequire("h8TzT");
var $5caa35aa03e15ac4$var$_invariant2 = $5caa35aa03e15ac4$var$_interopRequireDefault($h8TzT);

var $gjUif = parcelRequire("gjUif");

var $1n0H8 = parcelRequire("1n0H8");

var $8UuK6 = parcelRequire("8UuK6");
var $5caa35aa03e15ac4$var$_createTransitionManager2 = $5caa35aa03e15ac4$var$_interopRequireDefault($8UuK6);

var $ePyKG = parcelRequire("ePyKG");
function $5caa35aa03e15ac4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5caa35aa03e15ac4$var$PopStateEvent = 'popstate';
var $5caa35aa03e15ac4$var$HashChangeEvent = 'hashchange';
var $5caa35aa03e15ac4$var$getHistoryState = function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
};
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ var $5caa35aa03e15ac4$var$createBrowserHistory = function createBrowserHistory() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, $5caa35aa03e15ac4$var$_invariant2.default)($ePyKG.canUseDOM, 'Browser history needs a DOM');
    var globalHistory = window.history;
    var canUseHistory = (0, $ePyKG.supportsHistory)();
    var needsHashChangeListener = !(0, $ePyKG.supportsPopStateOnHashChange)();
    var _props$forceRefresh = props.forceRefresh, forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh, _props$getUserConfirm = props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === undefined ? $ePyKG.getConfirmation : _props$getUserConfirm, _props$keyLength = props.keyLength, keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
    var basename = props.basename ? (0, $1n0H8.stripTrailingSlash)((0, $1n0H8.addLeadingSlash)(props.basename)) : '';
    var getDOMLocation = function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        (0, $5caa35aa03e15ac4$var$_warning2.default)(!basename || (0, $1n0H8.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
        if (basename) path = (0, $1n0H8.stripBasename)(path, basename);
        return (0, $gjUif.createLocation)(path, state, key);
    };
    var createKey = function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    };
    var transitionManager = (0, $5caa35aa03e15ac4$var$_createTransitionManager2.default)();
    var setState = function setState(nextState) {
        $5caa35aa03e15ac4$var$_extends(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    };
    var handlePopState = function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ((0, $ePyKG.isExtraneousPopstateEvent)(event)) return;
        handlePop(getDOMLocation(event.state));
    };
    var handleHashChange = function handleHashChange() {
        handlePop(getDOMLocation($5caa35aa03e15ac4$var$getHistoryState()));
    };
    var forceNextPop = false;
    var handlePop = function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    };
    var revertPop = function revertPop(fromLocation) {
        var toLocation = history.location;
        // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    };
    var initialLocation = getDOMLocation($5caa35aa03e15ac4$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ];
    // Public interface
    var createHref = function createHref(location) {
        return basename + (0, $1n0H8.createPath)(location);
    };
    var push = function push(path, state) {
        (0, $5caa35aa03e15ac4$var$_warning2.default)(!((typeof path === 'undefined' ? 'undefined' : $5caa35aa03e15ac4$var$_typeof(path)) === 'object' && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to push when the 1st argument is a location-like object that already has state; it is ignored");
        var action = 'PUSH';
        var location = (0, $gjUif.createLocation)(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else {
                (0, $5caa35aa03e15ac4$var$_warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
                window.location.href = href;
            }
        });
    };
    var replace = function replace(path, state) {
        (0, $5caa35aa03e15ac4$var$_warning2.default)(!((typeof path === 'undefined' ? 'undefined' : $5caa35aa03e15ac4$var$_typeof(path)) === 'object' && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to replace when the 1st argument is a location-like object that already has state; it is ignored");
        var action = 'REPLACE';
        var location = (0, $gjUif.createLocation)(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else {
                (0, $5caa35aa03e15ac4$var$_warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
                window.location.replace(href);
            }
        });
    };
    var go = function go(n) {
        globalHistory.go(n);
    };
    var goBack = function goBack() {
        return go(-1);
    };
    var goForward = function goForward() {
        return go(1);
    };
    var listenerCount = 0;
    var checkDOMListeners = function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1) {
            (0, $ePyKG.addEventListener)(window, $5caa35aa03e15ac4$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) (0, $ePyKG.addEventListener)(window, $5caa35aa03e15ac4$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            (0, $ePyKG.removeEventListener)(window, $5caa35aa03e15ac4$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) (0, $ePyKG.removeEventListener)(window, $5caa35aa03e15ac4$var$HashChangeEvent, handleHashChange);
        }
    };
    var isBlocked = false;
    var block = function block() {
        var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    };
    var listen = function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    };
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
};
$5caa35aa03e15ac4$export$2e2bcd8739ae039 = $5caa35aa03e15ac4$var$createBrowserHistory;

});
parcelRegister("gjUif", function(module, exports) {

$parcel$export(module.exports, "createLocation", () => $be1a1658cd90878f$export$90c043f1c57770b8, (v) => $be1a1658cd90878f$export$90c043f1c57770b8 = v);
var $be1a1658cd90878f$export$1e511d4a378977f5;
var $be1a1658cd90878f$export$c3e8bb440bd55b18;
var $be1a1658cd90878f$export$90c043f1c57770b8;
'use strict';
$be1a1658cd90878f$export$1e511d4a378977f5 = true;
$be1a1658cd90878f$export$c3e8bb440bd55b18 = $be1a1658cd90878f$export$90c043f1c57770b8 = undefined;
var $be1a1658cd90878f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $91HYZ = parcelRequire("91HYZ");
var $be1a1658cd90878f$var$_resolvePathname2 = $be1a1658cd90878f$var$_interopRequireDefault($91HYZ);

var $36u6N = parcelRequire("36u6N");
var $be1a1658cd90878f$var$_valueEqual2 = $be1a1658cd90878f$var$_interopRequireDefault($36u6N);

var $1n0H8 = parcelRequire("1n0H8");
function $be1a1658cd90878f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $be1a1658cd90878f$var$createLocation = $be1a1658cd90878f$export$90c043f1c57770b8 = function createLocation(path, state, key, currentLocation) {
    var location = void 0;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = (0, $1n0H8.parsePath)(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = $be1a1658cd90878f$var$_extends({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $be1a1658cd90878f$var$_resolvePathname2.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
};
var $be1a1658cd90878f$var$locationsAreEqual = $be1a1658cd90878f$export$c3e8bb440bd55b18 = function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $be1a1658cd90878f$var$_valueEqual2.default)(a.state, b.state);
};

});
parcelRegister("1n0H8", function(module, exports) {

$parcel$export(module.exports, "addLeadingSlash", () => $0ff87a68793148e2$export$5b4913142e03bca8, (v) => $0ff87a68793148e2$export$5b4913142e03bca8 = v);
$parcel$export(module.exports, "hasBasename", () => $0ff87a68793148e2$export$10497c7ce66fcb84, (v) => $0ff87a68793148e2$export$10497c7ce66fcb84 = v);
$parcel$export(module.exports, "stripBasename", () => $0ff87a68793148e2$export$b69e3301ce081aa3, (v) => $0ff87a68793148e2$export$b69e3301ce081aa3 = v);
$parcel$export(module.exports, "stripTrailingSlash", () => $0ff87a68793148e2$export$d95b4586d238a081, (v) => $0ff87a68793148e2$export$d95b4586d238a081 = v);
$parcel$export(module.exports, "parsePath", () => $0ff87a68793148e2$export$8ccf933b0513f8d0, (v) => $0ff87a68793148e2$export$8ccf933b0513f8d0 = v);
$parcel$export(module.exports, "createPath", () => $0ff87a68793148e2$export$fe53371bee54353d, (v) => $0ff87a68793148e2$export$fe53371bee54353d = v);
var $0ff87a68793148e2$export$1e511d4a378977f5;
var $0ff87a68793148e2$export$5b4913142e03bca8;
var $0ff87a68793148e2$export$79c5b1569e3be9e6;
var $0ff87a68793148e2$export$10497c7ce66fcb84;
var $0ff87a68793148e2$export$b69e3301ce081aa3;
var $0ff87a68793148e2$export$d95b4586d238a081;
var $0ff87a68793148e2$export$8ccf933b0513f8d0;
var $0ff87a68793148e2$export$fe53371bee54353d;
'use strict';
$0ff87a68793148e2$export$1e511d4a378977f5 = true;
var $0ff87a68793148e2$var$addLeadingSlash = $0ff87a68793148e2$export$5b4913142e03bca8 = function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
};
var $0ff87a68793148e2$var$stripLeadingSlash = $0ff87a68793148e2$export$79c5b1569e3be9e6 = function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
};
var $0ff87a68793148e2$var$hasBasename = $0ff87a68793148e2$export$10497c7ce66fcb84 = function hasBasename(path, prefix) {
    return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};
var $0ff87a68793148e2$var$stripBasename = $0ff87a68793148e2$export$b69e3301ce081aa3 = function stripBasename(path, prefix) {
    return $0ff87a68793148e2$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};
var $0ff87a68793148e2$var$stripTrailingSlash = $0ff87a68793148e2$export$d95b4586d238a081 = function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};
var $0ff87a68793148e2$var$parsePath = $0ff87a68793148e2$export$8ccf933b0513f8d0 = function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
};
var $0ff87a68793148e2$var$createPath = $0ff87a68793148e2$export$fe53371bee54353d = function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
    return path;
};

});


parcelRegister("8UuK6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $67cb6681ef9bd83a$export$1e511d4a378977f5, (v) => $67cb6681ef9bd83a$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $67cb6681ef9bd83a$export$2e2bcd8739ae039, (v) => $67cb6681ef9bd83a$export$2e2bcd8739ae039 = v);
var $67cb6681ef9bd83a$export$1e511d4a378977f5;
var $67cb6681ef9bd83a$export$2e2bcd8739ae039;
'use strict';
$67cb6681ef9bd83a$export$1e511d4a378977f5 = true;

var $jx0f8 = parcelRequire("jx0f8");
var $67cb6681ef9bd83a$var$_warning2 = $67cb6681ef9bd83a$var$_interopRequireDefault($jx0f8);
function $67cb6681ef9bd83a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $67cb6681ef9bd83a$var$createTransitionManager = function createTransitionManager() {
    var prompt = null;
    var setPrompt = function setPrompt(nextPrompt) {
        (0, $67cb6681ef9bd83a$var$_warning2.default)(prompt == null, 'A history supports only one prompt at a time');
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    };
    var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else {
                    (0, $67cb6681ef9bd83a$var$_warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
                    callback(true);
                }
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    };
    var listeners = [];
    var appendListener = function appendListener(fn) {
        var isActive = true;
        var listener = function listener() {
            if (isActive) fn.apply(undefined, arguments);
        };
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    };
    var notifyListeners = function notifyListeners() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(undefined, args);
        });
    };
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
};
$67cb6681ef9bd83a$export$2e2bcd8739ae039 = $67cb6681ef9bd83a$var$createTransitionManager;

});

parcelRegister("ePyKG", function(module, exports) {

$parcel$export(module.exports, "canUseDOM", () => $acc0c919c306f036$export$71594e8a50f746f4, (v) => $acc0c919c306f036$export$71594e8a50f746f4 = v);
$parcel$export(module.exports, "addEventListener", () => $acc0c919c306f036$export$3f65cefe8380dbea, (v) => $acc0c919c306f036$export$3f65cefe8380dbea = v);
$parcel$export(module.exports, "removeEventListener", () => $acc0c919c306f036$export$8ff9f68337b520c0, (v) => $acc0c919c306f036$export$8ff9f68337b520c0 = v);
$parcel$export(module.exports, "getConfirmation", () => $acc0c919c306f036$export$ef38efb4b47d01db, (v) => $acc0c919c306f036$export$ef38efb4b47d01db = v);
$parcel$export(module.exports, "supportsHistory", () => $acc0c919c306f036$export$67fc34576016d6ec, (v) => $acc0c919c306f036$export$67fc34576016d6ec = v);
$parcel$export(module.exports, "supportsPopStateOnHashChange", () => $acc0c919c306f036$export$bd919e6f5f49fb48, (v) => $acc0c919c306f036$export$bd919e6f5f49fb48 = v);
$parcel$export(module.exports, "isExtraneousPopstateEvent", () => $acc0c919c306f036$export$aa3c5b1dd6fed00, (v) => $acc0c919c306f036$export$aa3c5b1dd6fed00 = v);
var $acc0c919c306f036$export$1e511d4a378977f5;
var $acc0c919c306f036$export$71594e8a50f746f4;
var $acc0c919c306f036$export$3f65cefe8380dbea;
var $acc0c919c306f036$export$8ff9f68337b520c0;
var $acc0c919c306f036$export$ef38efb4b47d01db;
var $acc0c919c306f036$export$67fc34576016d6ec;
var $acc0c919c306f036$export$bd919e6f5f49fb48;
var $acc0c919c306f036$export$9a5b29ff20eb48f9;
var $acc0c919c306f036$export$aa3c5b1dd6fed00;
'use strict';
$acc0c919c306f036$export$1e511d4a378977f5 = true;
var $acc0c919c306f036$var$canUseDOM = $acc0c919c306f036$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $acc0c919c306f036$var$addEventListener = $acc0c919c306f036$export$3f65cefe8380dbea = function addEventListener(node, event, listener) {
    return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};
var $acc0c919c306f036$var$removeEventListener = $acc0c919c306f036$export$8ff9f68337b520c0 = function removeEventListener(node, event, listener) {
    return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};
var $acc0c919c306f036$var$getConfirmation = $acc0c919c306f036$export$ef38efb4b47d01db = function getConfirmation(message, callback) {
    return callback(window.confirm(message));
}; // eslint-disable-line no-alert
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ var $acc0c919c306f036$var$supportsHistory = $acc0c919c306f036$export$67fc34576016d6ec = function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
};
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ var $acc0c919c306f036$var$supportsPopStateOnHashChange = $acc0c919c306f036$export$bd919e6f5f49fb48 = function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
};
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ var $acc0c919c306f036$var$supportsGoWithoutReloadUsingHash = $acc0c919c306f036$export$9a5b29ff20eb48f9 = function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
};
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ var $acc0c919c306f036$var$isExtraneousPopstateEvent = $acc0c919c306f036$export$aa3c5b1dd6fed00 = function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

});


parcelRegister("hxkaY", function(module, exports) {
var $cc452b4363c00bca$export$1e511d4a378977f5;
var $cc452b4363c00bca$export$2e2bcd8739ae039;
'use strict';
$cc452b4363c00bca$export$1e511d4a378977f5 = true;
var $cc452b4363c00bca$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $cc452b4363c00bca$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jx0f8 = parcelRequire("jx0f8");
var $cc452b4363c00bca$var$_warning2 = $cc452b4363c00bca$var$_interopRequireDefault($jx0f8);

var $1n0H8 = parcelRequire("1n0H8");

var $gjUif = parcelRequire("gjUif");

var $8UuK6 = parcelRequire("8UuK6");
var $cc452b4363c00bca$var$_createTransitionManager2 = $cc452b4363c00bca$var$_interopRequireDefault($8UuK6);
function $cc452b4363c00bca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cc452b4363c00bca$var$clamp = function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
};
/**
 * Creates a history object that stores locations in memory.
 */ var $cc452b4363c00bca$var$createMemoryHistory = function createMemoryHistory() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var getUserConfirmation = props.getUserConfirmation, _props$initialEntries = props.initialEntries, initialEntries = _props$initialEntries === undefined ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = props.initialIndex, initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex, _props$keyLength = props.keyLength, keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
    var transitionManager = (0, $cc452b4363c00bca$var$_createTransitionManager2.default)();
    var setState = function setState(nextState) {
        $cc452b4363c00bca$var$_extends(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    };
    var createKey = function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    };
    var index = $cc452b4363c00bca$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? (0, $gjUif.createLocation)(entry, undefined, createKey()) : (0, $gjUif.createLocation)(entry, undefined, entry.key || createKey());
    });
    // Public interface
    var createHref = $1n0H8.createPath;
    var push = function push(path, state) {
        (0, $cc452b4363c00bca$var$_warning2.default)(!((typeof path === 'undefined' ? 'undefined' : $cc452b4363c00bca$var$_typeof(path)) === 'object' && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to push when the 1st argument is a location-like object that already has state; it is ignored");
        var action = 'PUSH';
        var location = (0, $gjUif.createLocation)(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    };
    var replace = function replace(path, state) {
        (0, $cc452b4363c00bca$var$_warning2.default)(!((typeof path === 'undefined' ? 'undefined' : $cc452b4363c00bca$var$_typeof(path)) === 'object' && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to replace when the 1st argument is a location-like object that already has state; it is ignored");
        var action = 'REPLACE';
        var location = (0, $gjUif.createLocation)(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    };
    var go = function go(n) {
        var nextIndex = $cc452b4363c00bca$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    };
    var goBack = function goBack() {
        return go(-1);
    };
    var goForward = function goForward() {
        return go(1);
    };
    var canGo = function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    };
    var block = function block() {
        var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        return transitionManager.setPrompt(prompt);
    };
    var listen = function listen(listener) {
        return transitionManager.appendListener(listener);
    };
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
};
$cc452b4363c00bca$export$2e2bcd8739ae039 = $cc452b4363c00bca$var$createMemoryHistory;

});

parcelRegister("47oY8", function(module, exports) {

$parcel$export(module.exports, "storeFields", () => $ea0a4b73b58432d1$export$f55270c8f0a4bc82);

var $7ZZxN = parcelRequire("7ZZxN");

var $f9RL0 = parcelRequire("f9RL0");

var $lO4Or = parcelRequire("lO4Or");

var $bvCGh = parcelRequire("bvCGh");
const $ea0a4b73b58432d1$export$f55270c8f0a4bc82 = (fields, fieldValueActions, fieldConfigActions, issueKey, project = null, allowMergeFieldConfig = false)=>{
    const { setIssue: setIssue, mergeIssues: mergeIssues, mergeIssue: mergeIssue, getFieldValue: getFieldValue } = fieldValueActions;
    const { setIssueConfig: setIssueConfig, mergeIssueConfig: mergeIssueConfig } = fieldConfigActions;
    const { fieldValues: fieldValues, fieldConfigs: fieldConfigs } = (0, $bvCGh.extractFromObject)(fields);
    const childrenIssues = fieldValues[0, $f9RL0.CHILDREN_ISSUES] || [];
    const epicIssues = fieldValues[0, $f9RL0.EPIC_ISSUES] || [];
    const subtaskIssues = fieldValues[0, $f9RL0.SUBTASKS] || [];
    const portfolioChildIssues = fieldValues[0, $f9RL0.PORTFOLIO_CHILD_ISSUES] || [];
    const hierarchyLevelAboveFieldInState = getFieldValue(issueKey, (0, $lO4Or.HIERARCHY_LEVEL_ABOVE));
    const hasChildrenIssuesField = fieldValues[0, $f9RL0.CHILDREN_ISSUES];
    const hasEpicIssuesField = fieldValues[0, $f9RL0.EPIC_ISSUES];
    const hasSubtasksIssuesField = fieldValues[0, $f9RL0.SUBTASKS];
    const hasPortfolioIssuesField = fieldValues[0, $f9RL0.PORTFOLIO_CHILD_ISSUES];
    const { issuesFieldsValues: childrenIssueFieldsValues, childrenKeyList: modifiedChildrenList } = (0, $bvCGh.extractChildrenIssues)(childrenIssues);
    const { issuesFieldsValues: epicIssueFieldValues, childrenKeyList: modifiedEpicChildrenList } = (0, $bvCGh.extractChildrenIssues)(epicIssues);
    const { issuesFieldsValues: subtaskFieldValues, childrenKeyList: modifiedSubtaskChildrenList } = (0, $bvCGh.extractSubtasksOrPortfolioChildrenIssues)(subtaskIssues);
    const { issuesFieldsValues: portfolioFieldValues, childrenKeyList: modifiedPortfolioChildrenList } = (0, $bvCGh.extractSubtasksOrPortfolioChildrenIssues)(portfolioChildIssues);
    // Modify the field values of (children-issue, epic-children) to use list with issue key to prevent
    // consumers from using children field values from parent key
    const modifiedFieldValues = {
        ...fieldValues,
        ...hasChildrenIssuesField && {
            [(0, $f9RL0.CHILDREN_ISSUES)]: modifiedChildrenList
        },
        ...hasEpicIssuesField && {
            [(0, $f9RL0.EPIC_ISSUES)]: modifiedEpicChildrenList
        },
        ...hasSubtasksIssuesField && {
            [(0, $f9RL0.SUBTASKS)]: modifiedSubtaskChildrenList
        },
        ...hasPortfolioIssuesField && {
            [(0, $f9RL0.PORTFOLIO_CHILD_ISSUES)]: modifiedPortfolioChildrenList
        }
    };
    // This check is necessary for UIF CMP project to work correctly with cards displaying epic lozenges.
    // It's a temporary solution and it's aiming to unblock UIF rollout.
    // We should eventually clean this up in favour of finding a proper fix to an existing problem explained in here:
    // https://hello.atlassian.net/browse/FEBA-471
    if (!project?.isSimplified && project?.projectType === (0, $7ZZxN.SOFTWARE_PROJECT) && hierarchyLevelAboveFieldInState) mergeIssue(issueKey, modifiedFieldValues);
    else setIssue(issueKey, modifiedFieldValues);
    if (allowMergeFieldConfig) mergeIssueConfig(issueKey, fieldConfigs);
    else setIssueConfig(issueKey, fieldConfigs);
    // As epic children issues, subtasks, portfolio children currently do not provide us all fields,
    // unlike children-issues, we do mergeIssues
    // This is to solve the edge cases where if we first land on an epic children issue which contains all field values
    // and then navigate to its parent. This will still allow us to keep all the field values for the child issue instead
    // of overwriting it with the uncompleted fields.
    mergeIssues(epicIssueFieldValues);
    mergeIssues(subtaskFieldValues);
    mergeIssues(portfolioFieldValues);
    mergeIssues(childrenIssueFieldsValues);
};

});
parcelRegister("bvCGh", function(module, exports) {

$parcel$export(module.exports, "extractFromObject", () => $b4530ee7adc6455c$export$2b57c8930b67b22b);
$parcel$export(module.exports, "extractSubtasksOrPortfolioChildrenIssues", () => $b4530ee7adc6455c$export$c71895ba1b3f08cd);
$parcel$export(module.exports, "extractChildrenIssues", () => $b4530ee7adc6455c$export$d4199d8d54d21673);


var $f9RL0 = parcelRequire("f9RL0");

var $lO4Or = parcelRequire("lO4Or");

var $krxpD = parcelRequire("krxpD");

var $btjMs = parcelRequire("btjMs");
const $b4530ee7adc6455c$export$2b57c8930b67b22b = (fields)=>{
    const extractedFieldsData = {
        fieldValues: {},
        fieldConfigs: {}
    };
    Object.entries(fields).forEach(([key, field])=>{
        if ((0, $krxpD.isHideEpicLinkFromIssueViewForEpicRenamingBetaEnabled)() && field?.schema?.custom === (0, $f9RL0.specialFields)()[0, $f9RL0.EPIC] || (0, $krxpD.isRemoveParentLinkFromIssueViewEnabled)() && field?.schema?.custom === (0, $f9RL0.specialFields)()[0, $f9RL0.PARENT]) return;
        const isRichTextField = field.schema.type === (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE) && field.schema.renderer === (0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c) || (0, $btjMs.getFieldType)(field) === (0, $lO4Or.DESCRIPTION_TYPE);
        extractedFieldsData.fieldValues[key] = isRichTextField ? field.adfValue || field.value : field.value;
        extractedFieldsData.fieldConfigs[key] = {
            autoCompleteUrl: field.autoCompleteUrl,
            allowedValues: field.allowedValues,
            isEditable: field.editable,
            isRequired: field.required,
            schema: field.schema,
            title: field.title,
            configuration: field.configuration,
            description: field.description ?? undefined
        };
    });
    return extractedFieldsData;
};
const $b4530ee7adc6455c$export$f6ed1dae921a8132 = (fields)=>{
    const extractedFieldsData = {
        fieldValues: {},
        fieldConfigs: {}
    };
    fields.forEach((field)=>{
        extractedFieldsData.fieldValues[field.key] = field.value !== undefined ? field.value : null;
        extractedFieldsData.fieldConfigs[field.key] = {
            autoCompleteUrl: field.autoCompleteUrl,
            allowedValues: field.allowedValues,
            isEditable: field.editable,
            isRequired: field.required,
            schema: field.schema,
            title: field.title
        };
    });
    return extractedFieldsData;
};
const $b4530ee7adc6455c$export$c71895ba1b3f08cd = (childIssues)=>{
    const issuesFieldsValues = [];
    // @ts-expect-error - TS2345 - Argument of type '(childIssue: ChildIssue) => { id: string; key: string; }' is not assignable to parameter of type '(value: IssueFields, index: number, array: IssueFields[]) => { id: string; key: string; }'.
    const childrenKeyList = childIssues.map((childIssue)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const fieldValue = {};
        const { fields: fields = [], key: childIssueKey, id: childId } = childIssue;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.entries(fields).forEach(([key, value])=>{
            fieldValue[key] = value;
        });
        issuesFieldsValues.push({
            [childIssueKey]: fieldValue
        });
        return {
            id: childId,
            key: childIssueKey
        };
    });
    return {
        issuesFieldsValues: issuesFieldsValues,
        childrenKeyList: childrenKeyList
    };
};
const $b4530ee7adc6455c$export$d4199d8d54d21673 = (childrenIssues)=>{
    const issuesFieldsValues = [];
    const issueFieldsConfigurations = [];
    const childrenKeyList = childrenIssues.map((child)=>{
        const { fieldValues: values, fieldConfigs: configs } = $b4530ee7adc6455c$export$f6ed1dae921a8132(child.fields);
        issuesFieldsValues.push({
            [child.key]: values
        });
        issueFieldsConfigurations.push({
            [child.key]: configs
        });
        return {
            id: child.id,
            key: child.key
        };
    });
    return {
        issuesFieldsValues: issuesFieldsValues,
        issueFieldsConfigurations: issueFieldsConfigurations,
        childrenKeyList: childrenKeyList
    };
};

});
parcelRegister("krxpD", function(module, exports) {

$parcel$export(module.exports, "isRemoveParentLinkFromIssueViewEnabled", () => $cfd73479262e3546$export$6e06c78fd874f07f);
$parcel$export(module.exports, "isHideEpicLinkFromIssueViewForEpicRenamingBetaEnabled", () => $cfd73479262e3546$export$73957227bab0d3f7);
$parcel$export(module.exports, "isJsmTimelineEnabled", () => $cfd73479262e3546$export$575e1bf822db15b5);

var $1ybV0 = parcelRequire("1ybV0");
const $cfd73479262e3546$export$6e06c78fd874f07f = ()=>(0, $1ybV0.ff)('remove-parent-link-from-issue-view_4t7dy', false);
const $cfd73479262e3546$export$73957227bab0d3f7 = ()=>(0, $1ybV0.ff)('hide-epic-link-from-issue-view-for-epic-renaming-beta_r1g77', false);
const $cfd73479262e3546$export$575e1bf822db15b5 = ()=>(0, $1ybV0.ff)('jsm-timelines-phase-2_70gja', false);

});



parcelRegister("3uwfp", function(module, exports) {

$parcel$export(module.exports, "defaultConnectFieldConfig", () => $6a6bd1bdd2cd0a2d$export$42de5ad4c75b437a);
$parcel$export(module.exports, "default", () => $6a6bd1bdd2cd0a2d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $hompL = parcelRequire("hompL");

var $bFzGY = parcelRequire("bFzGY");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $90IgZ = parcelRequire("90IgZ");
var $4ksts = parcelRequire("4ksts");

var $bYYP0 = parcelRequire("bYYP0");

var $6rkLV = parcelRequire("6rkLV");


var $4QRaC = parcelRequire("4QRaC");

var $lqalZ = parcelRequire("lqalZ");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $gZSrt = parcelRequire("gZSrt");

var $6KjC3 = parcelRequire("6KjC3");

var $8WuJm = parcelRequire("8WuJm");

var $1TrR5 = parcelRequire("1TrR5");
const $6a6bd1bdd2cd0a2d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    defaultFallbackInvalidMessage: {
        "id": "issue-view-common-views.connect-field.connect-field.default-fallback-invalid-message",
        "defaultMessage": "The value could not be saved"
    }
});
const $6a6bd1bdd2cd0a2d$export$42de5ad4c75b437a = {
    // Transform from our state (jira's) representation of the value, to the component's value prop.
    // Also provides i18n if any translated strings are required as part of this transformation.
    transformFromStateValue: (stateValue, _transformerContext, _intl)=>stateValue,
    // Transform to our state (jira's) representation of the value, from the component's value prop.
    transformToStateValue: (componentValue)=>componentValue,
    // The message to show when a validation error cannot be extracted from a save failure.
    fallbackInvalidMessage: (intl)=>intl.formatMessage($6a6bd1bdd2cd0a2d$export$defe85febe8b728c.defaultFallbackInvalidMessage),
    // Map state and intl to any additional props required by the component.
    additionalProps: (_state, _intl, _fieldOptions)=>({}),
    // Map dispatch to any additional callback props required by the component.
    additionalCallbacks: (_dispatch)=>({}),
    // Whether the field's value/renderedValue will update optimistically after a save,
    // or wait for a refresh of the issue data.
    isOptimistic: true,
    // Should be set to true if editing the field can result in new Media Services
    // files being attached to the issue. Causes a new media view-token to be fetched,
    // which will include the necessary permissions for the new files to be displayed.
    canContainMediaContent: false,
    // Should be set to true if the particular field should have a draft of itself saved
    // in local storage. This is likely not apply to many fields which have the default
    // behaviour of actually saving when being clicked out of anyway - as this property
    // is targeted at fields like description that would otherwise lose changes if the field
    // loses focus or Bento is closed, the tab is closed, the browser crashes/etc.
    shouldSaveDraft: false,
    // How to save the field's value. By default, save by PUT-ing the new value
    // to the issue endpoint.
    saveField: ({ baseUrl: baseUrl, issueKey: issueKey, fieldMetaKey: fieldMetaKey, value: value, fieldEditSessionId: fieldEditSessionId // eslint-disable-next-line @typescript-eslint/no-explicit-any
     })=>{
        const url = fieldEditSessionId ? `${baseUrl}/rest/api/2/issue/${issueKey}?fieldEditSessionId=${fieldEditSessionId}` : `${baseUrl}/rest/api/2/issue/${issueKey}`;
        return (0, $lRmyA.performPutRequest)(url, {
            body: JSON.stringify({
                fields: {
                    [fieldMetaKey]: value
                }
            })
        });
    },
    // Controls whether a save failure will set the saved value back to the editingValue.
    // Usually this is desirable for an inline-editable component, but for a component
    // like a toggle button (watches), we just want to discard the value that failed to
    // save.
    shouldDiscardChangeOnFailure: false,
    // Set which flag message will display if the field fails to save with an error.
    // The flag message types are found in 'flag-constants'
    onSaveFailureFlagType: null,
    // Set which flag message will display if the field is saved successfully.
    // The flag message types are found in 'flag-constants'
    onSaveSuccessFlagType: null,
    // Needed by flow so we can have the defaults match the ConnectFieldConfig type.
    fieldId: ''
};
const $6a6bd1bdd2cd0a2d$var$createTransformerContext = (baseUrl, projectKey, projectType, issueKey, fieldId)=>({
        baseUrl: baseUrl,
        projectKey: projectKey,
        ...projectType === null ? {} : {
            projectType: projectType
        },
        issueKey: issueKey,
        fieldId: fieldId
    });
const $6a6bd1bdd2cd0a2d$var$callbacksFactory = (0, $5iWql.default)((dispatchProps, stateProps)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(dispatchProps).reduce((acc, key)=>{
        acc[key] = dispatchProps[key](stateProps);
        return acc;
    }, {}));
const $6a6bd1bdd2cd0a2d$var$getReduxConnectParams = (mapStateToConfig)=>({
        mapStateToProps: (stateOnMount, ownPropsOnMount)=>{
            // Get the partial config, by calling the provided function
            // with our state and passed in props
            const providedConnectFieldConfig = mapStateToConfig(stateOnMount, ownPropsOnMount);
            const connectFieldConfig = {
                ...$6a6bd1bdd2cd0a2d$export$42de5ad4c75b437a,
                ...providedConnectFieldConfig
            };
            const { fieldId: fieldId, transformFromStateValue: transformFromStateValue, transformToStateValue: transformToStateValue, fallbackInvalidMessage: fallbackInvalidMessage, additionalProps: additionalProps, additionalCallbacks: additionalCallbacks, isOptimistic: isOptimistic, canContainMediaContent: canContainMediaContent, saveField: saveField, shouldDiscardChangeOnFailure: shouldDiscardChangeOnFailure, shouldSaveDraft: shouldSaveDraft, onSaveFailureFlagType: onSaveFailureFlagType, onSaveSuccessFlagType: onSaveSuccessFlagType } = connectFieldConfig;
            // This data is passed into every action creator so that it can be used by reducers/epics to
            // 'configure' the editing and saving flow.
            const fieldOptions = {
                isRichTextField: (0, $fokFV.isRichTextFieldSelector)(fieldId)(stateOnMount),
                isOptimistic: isOptimistic,
                canContainMediaContent: canContainMediaContent,
                saveField: saveField,
                shouldDiscardChangeOnFailure: shouldDiscardChangeOnFailure,
                shouldSaveDraft: shouldSaveDraft,
                onSaveFailureFlagType: onSaveFailureFlagType,
                onSaveSuccessFlagType: onSaveSuccessFlagType
            };
            const memoizedTransformerContext = (0, $5iWql.default)($6a6bd1bdd2cd0a2d$var$createTransformerContext);
            const memoizedTransformToStateValue = (0, $5iWql.default)(transformToStateValue);
            const memoizedTransformFromStateValue = (0, $5iWql.default)(transformFromStateValue);
            const fieldSchemaConfigurationStateSelector = (0, $fokFV.fieldSchemaConfigurationSelector)(fieldId);
            return (state, ownProps)=>({
                    fieldId: // Needed for mergeStateAndDispatchProps.
                    fieldId,
                    fieldOptions: fieldOptions,
                    memoizedTransformToStateValue: memoizedTransformToStateValue,
                    additionalCallbacks: additionalCallbacks,
                    fieldType: (0, $fokFV.fieldTypeSelector)(fieldId)(state),
                    // Passed through.
                    intl: ownProps.intl,
                    label: (0, $fokFV.fieldNameSelector)(fieldId)(state),
                    issueKey: (0, $5JqpU.issueKeySelector)(state),
                    isEditable: (0, $fokFV.isFieldEditableSelector)(fieldId)(state) && (0, $jZDJX.loadingStageSelector)(state) !== (0, $d6ff0428d6ad71a2$export$1b56cc494043d9bf),
                    isEditing: (0, $fokFV.isFieldEditingSelector)(fieldId)(state),
                    fieldEditSessionId: (0, $fokFV.fieldEditSessionIdSelector)(fieldId)(state),
                    invalidMessage: (0, $fokFV.fieldInvalidMessageSelector)(fieldId, fallbackInvalidMessage(ownProps.intl))(state),
                    customFieldConfig: fieldSchemaConfigurationStateSelector(state),
                    value: memoizedTransformFromStateValue((0, $fokFV.fieldEditingValueSelector)(fieldId)(state), memoizedTransformerContext((0, $5JqpU.baseUrlSelector)(state), (0, $5JqpU.projectKeySelector)(state), (0, $jZDJX.projectTypeSelector)(state), (0, $5JqpU.issueKeySelector)(state), fieldId), ownProps.intl),
                    isWaiting: isOptimistic ? false : (0, $fokFV.isFieldWaitingSelector)(fieldId)(state),
                    isMobile: (0, $5JqpU.isMobileSelector)(state),
                    ...additionalProps(state, ownProps.intl, fieldOptions, ownProps.extraOwnProps)
                });
        },
        mapDispatchToProps: (dispatch)=>({
                initFieldOptions: // @ts-expect-error - TS7031 - Binding element 'fieldId' implicitly has an 'any' type. | TS7031 - Binding element 'fieldOptions' implicitly has an 'any' type.
                ({ fieldId: fieldId, fieldOptions: fieldOptions })=>()=>dispatch((0, $6KjC3.fieldInitOptions)(fieldId, fieldOptions)),
                onEditRequest: // @ts-expect-error - TS7031 - Binding element 'fieldId' implicitly has an 'any' type. | TS7031 - Binding element 'fieldOptions' implicitly has an 'any' type.
                ({ fieldId: fieldId, fieldOptions: fieldOptions })=>// @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
                    (...args)=>{
                        const analyticsEvent = args.length ? args[args.length - 1] : undefined;
                        dispatch((0, $6KjC3.fieldEditBegin)(fieldId, fieldOptions, (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(), analyticsEvent));
                    },
                onChange: // @ts-expect-error - TS7031 - Binding element 'fieldId' implicitly has an 'any' type. | TS7031 - Binding element 'fieldOptions' implicitly has an 'any' type. | TS7031 - Binding element 'memoizedTransformToStateValue' implicitly has an 'any' type.
                ({ fieldId: fieldId, fieldOptions: fieldOptions, memoizedTransformToStateValue: memoizedTransformToStateValue })=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (value)=>dispatch((0, $6KjC3.fieldEditUpdate)(fieldId, memoizedTransformToStateValue(value), fieldOptions)),
                onConfirm: // @ts-expect-error - TS7031 - Binding element 'fieldId' implicitly has an 'any' type. | TS7031 - Binding element 'fieldOptions' implicitly has an 'any' type. | TS7031 - Binding element 'analyticsAttributeIdRetriever' implicitly has an 'any' type.
                ({ fieldId: fieldId, fieldOptions: fieldOptions, analyticsAttributeIdRetriever: analyticsAttributeIdRetriever })=>// @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
                    (...args)=>{
                        // withAnalyticsEvents adds the analyticsEvent as the last
                        // argument to the handler. The saveFieldData is optional
                        // and considered present if onConfirm is invoked with more
                        // than one argument.
                        const saveFieldData = args.length > 1 ? args[0] : undefined;
                        const analyticsEvent = args.length ? args[args.length - 1] : undefined;
                        // 'analyticsAttributeIdRetriever' is an optional function which allows each issue field to define what they
                        // want to use as 'newValId' and 'oldValId' in 'issueField updated' event attribute. If this function is not
                        // provided, 'id' property of the field value will be used, in the case there is no id. Event will be fired without
                        // 'newValId' and 'oldValId'
                        return dispatch((0, $6KjC3.fieldEditConfirm)(fieldId, fieldOptions, saveFieldData, analyticsEvent, analyticsAttributeIdRetriever));
                    },
                onBlur: // @ts-expect-error - TS7031 - Binding element 'fieldId' implicitly has an 'any' type. | TS7031 - Binding element 'fieldOptions' implicitly has an 'any' type.
                ({ fieldId: fieldId, fieldOptions: fieldOptions })=>()=>dispatch((0, $6KjC3.fieldEditCancel)(fieldId, fieldOptions)),
                onCancel: // @ts-expect-error - TS7031 - Binding element 'fieldId' implicitly has an 'any' type. | TS7031 - Binding element 'fieldOptions' implicitly has an 'any' type.
                ({ fieldId: fieldId, fieldOptions: fieldOptions })=>()=>{
                        dispatch((0, $6KjC3.fieldEditCancel)(fieldId, fieldOptions));
                        dispatch((0, $gZSrt.deleteDraftRequest)({
                            fieldId: fieldId
                        }));
                        // BENTO-12481 new inline-edit version keeps the focus on the field if it was navigated to vis keyboard,
                        // as a result - preventing the whole issue view modal from being closed by `esc` keypress.
                        // This will make sure that pressing `esc` on the field with remove the focus on it
                        // and will allow futher `esc` keypress to close issue view modal
                        const activeElement = window.document?.activeElement;
                        if (activeElement instanceof HTMLElement) activeElement.blur();
                    },
                onPaste: // @ts-expect-error - TS7031 - Binding element 'fieldId' implicitly has an 'any' type. | TS7031 - Binding element 'fieldOptions' implicitly has an 'any' type.
                ({ fieldId: fieldId, fieldOptions: fieldOptions })=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (pastedContent)=>dispatch((0, $6KjC3.fieldPaste)(fieldId, fieldOptions, pastedContent)),
                // @ts-expect-error - TS7031 - Binding element 'additionalCallbacks' implicitly has an 'any' type.
                getAdditionalCallbacks: ({ additionalCallbacks: additionalCallbacks })=>additionalCallbacks(dispatch)
            }),
        mergeStateAndDispatchProps: (0, $1TrR5.functionWithFFRedux)(// @ts-expect-error - TS7006 - Parameter 'stateProps' implicitly has an 'any' type. | TS7006 - Parameter 'dispatchProps' implicitly has an 'any' type.
        (stateProps, dispatchProps)=>{
            // Curry the stateProps into the functions returned by mapDispatchToProps
            // to create the wired-up action creators.
            const callbacks = $6a6bd1bdd2cd0a2d$var$callbacksFactory(dispatchProps, stateProps);
            // Wire up the additional callbacks provided by the consumer.
            const additionalCallbacks = dispatchProps.getAdditionalCallbacks(stateProps);
            // Create the final props that will be passed to the WrappedComponent
            return {
                ...stateProps,
                ...callbacks,
                ...additionalCallbacks
            };
        }, (stateProps, dispatchProps)=>{
            // Curry the stateProps into the functions returned by mapDispatchToProps
            // to create the wired-up action creators.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const callbacks = Object.keys(dispatchProps).reduce((acc, key)=>{
                acc[key] = dispatchProps[key](stateProps);
                return acc;
            }, {});
            // Wire up the additional callbacks provided by the consumer.
            const additionalCallbacks = dispatchProps.getAdditionalCallbacks(stateProps);
            // Create the final props that will be passed to the WrappedComponent
            return {
                ...stateProps,
                ...callbacks,
                ...additionalCallbacks
            };
        })
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6a6bd1bdd2cd0a2d$var$getDisplayName = (Component)=>Component.displayName || Component.name || 'Component';
const $6a6bd1bdd2cd0a2d$var$getDisplayNamePrefix = (FallbackField)=>{
    if (FallbackField) return 'WithFallback';
    return '';
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6a6bd1bdd2cd0a2d$var$getFallbackComponent = (FallbackField)=>(props)=>{
        if (!FallbackField) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
            prefixOverride: "issue",
            id: `Fallback(${$6a6bd1bdd2cd0a2d$var$getDisplayName(FallbackField)})`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FallbackField, props));
    };
const $6a6bd1bdd2cd0a2d$var$getComponentWithAnalytics = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(WrappedComponent, mergedProps)=>(props)=>{
        const { onConfirm: onConfirm, onEditRequest: onEditRequest, fieldId: fieldId, fieldType: fieldType } = props;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
        const handleOnConfirm = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
        (...args)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'updated'
            });
            args.push(analyticsEvent);
            onConfirm(...args);
        }, [
            onConfirm,
            createAnalyticsEvent
        ]);
        const handleOnEditRequest = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
        (...args)=>{
            if ((0, $1ybV0.ff)('issue-update-analytics-events-on-issue-view')) (0, $bYYP0.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart(fieldId, {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    fieldType: fieldType
                }
            });
            const analyticsEvent = createAnalyticsEvent({
                action: 'updateStarted'
            });
            args.push(analyticsEvent);
            onEditRequest(...args);
        }, [
            createAnalyticsEvent,
            onEditRequest,
            fieldId,
            fieldType
        ]);
        const overrides = (0, $6rkLV.useFieldOverridesStoreWithLabel)({
            issueKey: props.issueKey,
            fieldKey: props.fieldId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4QRaC.WithViewExperienceTrackerWrapper), {
            fieldType: props.fieldType
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            ...overrides,
            onConfirm: handleOnConfirm,
            onEditRequest: handleOnEditRequest
        }));
    };
const $6a6bd1bdd2cd0a2d$var$connectField = (analyticsSubject)=>(mapStateToConfig, FallbackField)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (WrappedComponent)=>{
            const reduxConnectParams = $6a6bd1bdd2cd0a2d$var$getReduxConnectParams(mapStateToConfig);
            const analyticsData = {
                componentName: 'issueFields',
                actionSubject: analyticsSubject
            };
            const componentName = $6a6bd1bdd2cd0a2d$var$getDisplayName(WrappedComponent);
            const ComponentWithAnalytics = $6a6bd1bdd2cd0a2d$var$getComponentWithAnalytics(WrappedComponent, reduxConnectParams.mergeStateAndDispatchProps);
            // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type '(props: any) => Element'.
            ComponentWithAnalytics.displayName = `${componentName}WithAnalytics`;
            const ComponentWithStore = (0, $lqalZ.connect)(reduxConnectParams.mapStateToProps, reduxConnectParams.mapDispatchToProps, reduxConnectParams.mergeStateAndDispatchProps)(ComponentWithAnalytics);
            ComponentWithStore.displayName = `${componentName}WithStore`;
            const FallbackComponent = $6a6bd1bdd2cd0a2d$var$getFallbackComponent(FallbackField);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const ConnectedComponent = (props)=>{
                const intl = (0, $4ksts.useIntlV2)();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
                    prefixOverride: "issue",
                    id: `${$6a6bd1bdd2cd0a2d$var$getDisplayNamePrefix(FallbackField)}(${componentName})`,
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FallbackComponent, props)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), analyticsData, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentWithStore, {
                    ...props,
                    intl: intl
                })));
            };
            ConnectedComponent.displayName = componentName;
            return ConnectedComponent;
        };
var $6a6bd1bdd2cd0a2d$export$2e2bcd8739ae039 = $6a6bd1bdd2cd0a2d$var$connectField('issueFields');

});
parcelRegister("bYYP0", function(module, exports) {

$parcel$export(module.exports, "getUpdateAnalyticsFlowHelper", () => $f85145fdcc3946b0$export$f3b2b77402b2631f);

var $hompL = parcelRequire("hompL");

var $gUUjF = parcelRequire("gUUjF");

var $jMP2a = parcelRequire("jMP2a");

var $7Ap9H = parcelRequire("7Ap9H");
/**
 * A singlenton class to provide a sessionId to track update of fields
 */ class $f85145fdcc3946b0$var$EventFlowManager {
    reset() {
        this.ids.clear();
        this.extraAttributes.clear();
    }
    push(key) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        this.ids.set(key, id);
        return id;
    }
    pull(key, shouldDelete = true) {
        const value = this.ids.get(key);
        if (shouldDelete) this.ids.delete(key);
        return value;
    }
    constructor(){
        this.ids = new Map();
        this.extraAttributes = new Map();
    }
}
const $f85145fdcc3946b0$export$87846400a9b428fc = new $f85145fdcc3946b0$var$EventFlowManager();
/**
 * Concatenates updateSessionId, default atrributes and the attributes sent through
 *  the event and/or setAttributes
 */ const $f85145fdcc3946b0$var$concatAtrributes = (fieldKey, updateSessionId, attributes)=>{
    const { fieldType: fieldTypeValue } = attributes;
    const extraAttributes = $f85145fdcc3946b0$export$87846400a9b428fc.extraAttributes.get(fieldKey);
    const fieldType = fieldTypeValue && (0, $7Ap9H.FIELD_TYPE_MAP)[fieldTypeValue] ? (0, $7Ap9H.FIELD_TYPE_MAP)[fieldTypeValue] : fieldTypeValue;
    return {
        updateSessionId: updateSessionId,
        ...(0, $7Ap9H.DEFAULT_ATTRIBUTES),
        ...attributes,
        ...extraAttributes,
        fieldKey: fieldKey,
        fieldType: fieldType
    };
};
/**
 * Provides three events START {@link fireAnalyticsStart},
 * END {@link fireAnalyticsEnd} to track the user flow when updating
 * a field and setAttributes{@link setAttributes} to set specific
 * fields attributes
 */ const $f85145fdcc3946b0$var$updateAnalyticsFlowHelper = {
    fireAnalyticsStart (fieldKey, params) {
        try {
            const sessionid = $f85145fdcc3946b0$export$87846400a9b428fc.push(fieldKey);
            const attributes = $f85145fdcc3946b0$var$concatAtrributes(fieldKey, sessionid, params.attributes);
            (0, $jMP2a.fireUIAnalytics)(params.analytics, `${(0, $7Ap9H.START_ACTION_SUBJECT)} ${(0, $7Ap9H.START_ACTION)}`, (0, $7Ap9H.START_ACTION_SUBJECT_ID), attributes);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsStart', e.toString());
        }
    },
    fireAnalyticsEnd (fieldKey, params, isEndOfSession = true) {
        try {
            const sessionid = $f85145fdcc3946b0$export$87846400a9b428fc.pull(fieldKey, isEndOfSession);
            const attributes = $f85145fdcc3946b0$var$concatAtrributes(fieldKey, sessionid, params.attributes);
            if (isEndOfSession) $f85145fdcc3946b0$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
            (0, $jMP2a.fireTrackAnalytics)(params.analytics, `${(0, $7Ap9H.END_ACTION_SUBJECT)} ${(0, $7Ap9H.END_ACTION)}`, (0, $7Ap9H.END_ACTION_SUBJECT_ID), attributes);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsEnd', e.toString());
        }
    },
    setAttributes (fieldKey, attributes) {
        $f85145fdcc3946b0$export$87846400a9b428fc.extraAttributes.set(fieldKey, attributes);
    },
    reset () {
        $f85145fdcc3946b0$export$87846400a9b428fc.reset();
    }
};
const $f85145fdcc3946b0$export$f3b2b77402b2631f = ()=>$f85145fdcc3946b0$var$updateAnalyticsFlowHelper;

});
parcelRegister("7Ap9H", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ATTRIBUTES", () => $f06f4a869451c640$export$69665899d8392309);
$parcel$export(module.exports, "START_ACTION", () => $f06f4a869451c640$export$c0a4673e0c78e972);
$parcel$export(module.exports, "START_ACTION_SUBJECT", () => $f06f4a869451c640$export$34a5ae354a38cc7e);
$parcel$export(module.exports, "START_ACTION_SUBJECT_ID", () => $f06f4a869451c640$export$bc373f59492dc6e2);
$parcel$export(module.exports, "END_ACTION", () => $f06f4a869451c640$export$b19686c1fe99f85a);
$parcel$export(module.exports, "END_ACTION_SUBJECT", () => $f06f4a869451c640$export$4ce67e80878d47ed);
$parcel$export(module.exports, "END_ACTION_SUBJECT_ID", () => $f06f4a869451c640$export$e3d957ccc2d46469);
$parcel$export(module.exports, "FIELD_TYPE_MAP", () => $f06f4a869451c640$export$d8ccf495ccc97a69);

var $lO4Or = parcelRequire("lO4Or");
const $f06f4a869451c640$export$69665899d8392309 = {
    isInlineEditing: false,
    isCommandPaletteEditing: false,
    isDragEditing: false
};
const $f06f4a869451c640$export$c0a4673e0c78e972 = 'clicked';
const $f06f4a869451c640$export$34a5ae354a38cc7e = 'item';
const $f06f4a869451c640$export$bc373f59492dc6e2 = 'issue';
const $f06f4a869451c640$export$b19686c1fe99f85a = 'update';
const $f06f4a869451c640$export$4ce67e80878d47ed = 'issue';
const $f06f4a869451c640$export$e3d957ccc2d46469 = 'ended';
const $f06f4a869451c640$export$d8ccf495ccc97a69 = {
    [(0, $lO4Or.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: 'versions',
    [(0, $lO4Or.VERSION_CF_TYPE)]: 'versions',
    [(0, $lO4Or.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $lO4Or.SPRINT_TYPE)]: 'link',
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $lO4Or.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $lO4Or.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $lO4Or.USER_CF_TYPE)]: 'singleUser',
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $lO4Or.URL_CF_TYPE)]: 'url',
    [(0, $lO4Or.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: 'multiGroup'
};

});


parcelRegister("gZSrt", function(module, exports) {

$parcel$export(module.exports, "DELETE_DRAFT_NEWER_CONTENT_FOUND", () => $0d11bf17b164e25a$export$a7a91e9b39c204bf);
$parcel$export(module.exports, "SAVE_DRAFT_REQUEST", () => $0d11bf17b164e25a$export$c0740937a8e06ab9);
$parcel$export(module.exports, "saveDraftRequest", () => $0d11bf17b164e25a$export$1e0971ed0980a684);
$parcel$export(module.exports, "saveDraftSuccess", () => $0d11bf17b164e25a$export$d2890acf756edc3d);
$parcel$export(module.exports, "saveDraftError", () => $0d11bf17b164e25a$export$1b3b55664e7f9434);
$parcel$export(module.exports, "LOAD_DRAFT_REQUEST", () => $0d11bf17b164e25a$export$57fb8bebfdbff662);
$parcel$export(module.exports, "loadDraftRequest", () => $0d11bf17b164e25a$export$1b95fd1e801cae3e);
$parcel$export(module.exports, "LOAD_DRAFT_SUCCESS", () => $0d11bf17b164e25a$export$cba36ec5bda51ff8);
$parcel$export(module.exports, "loadDraftSuccess", () => $0d11bf17b164e25a$export$51086f6ca77c5e0f);
$parcel$export(module.exports, "LOAD_DRAFT_FAILURE", () => $0d11bf17b164e25a$export$e056de47154a9a05);
$parcel$export(module.exports, "loadDraftFailure", () => $0d11bf17b164e25a$export$214a94482ffdd4c3);
$parcel$export(module.exports, "DELETE_DRAFT_REQUEST", () => $0d11bf17b164e25a$export$75f4f60ec3864bc2);
$parcel$export(module.exports, "deleteDraftRequest", () => $0d11bf17b164e25a$export$460bdad3dd898fb5);
$parcel$export(module.exports, "DELETE_DRAFT_SUCCESS", () => $0d11bf17b164e25a$export$92fd16b0d2619f4f);
$parcel$export(module.exports, "deleteDraftSuccess", () => $0d11bf17b164e25a$export$da621faaf1f6387b);
$parcel$export(module.exports, "DELETE_DRAFT_FAILURE", () => $0d11bf17b164e25a$export$1aec6b89e4f832ef);
$parcel$export(module.exports, "deleteDraftError", () => $0d11bf17b164e25a$export$4ab2471b7cf1d8c0);
const $0d11bf17b164e25a$export$a7a91e9b39c204bf = 'DELETE_DRAFT_NEWER_CONTENT_FOUND';
const $0d11bf17b164e25a$export$ac61759d5c36ea00 = (fieldId)=>({
        type: $0d11bf17b164e25a$export$a7a91e9b39c204bf,
        payload: {
            fieldId: fieldId
        }
    });
const $0d11bf17b164e25a$export$c0740937a8e06ab9 = 'SAVE_DRAFT_REQUEST';
const $0d11bf17b164e25a$export$1e0971ed0980a684 = (fieldId, value, serverValue)=>({
        type: $0d11bf17b164e25a$export$c0740937a8e06ab9,
        payload: {
            fieldId: fieldId,
            value: value,
            serverValue: serverValue
        }
    });
const $0d11bf17b164e25a$export$82c9d7b20b637bb6 = 'SAVE_DRAFT_SUCCESS';
const $0d11bf17b164e25a$export$d2890acf756edc3d = (draftKey, value)=>({
        type: $0d11bf17b164e25a$export$82c9d7b20b637bb6,
        payload: {
            draftKey: draftKey,
            value: value
        }
    });
const $0d11bf17b164e25a$export$83c0408cf78d6708 = 'SAVE_DRAFT_FAILURE';
const $0d11bf17b164e25a$export$1b3b55664e7f9434 = (error)=>({
        type: $0d11bf17b164e25a$export$83c0408cf78d6708,
        payload: error
    });
const $0d11bf17b164e25a$export$57fb8bebfdbff662 = 'LOAD_DRAFT_REQUEST';
const $0d11bf17b164e25a$export$1b95fd1e801cae3e = (fieldId, draftKey, /*
	 * draftHandler should have type `EditCommentUpdateAction | FieldEditUpdate` but results in a
	 * cyclical dependency.
	 * Ticket to track fixing this - https://jdog.jira-dev.com/browse/BENTO-3191
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
draftHandler, serverValue)=>({
        type: $0d11bf17b164e25a$export$57fb8bebfdbff662,
        payload: {
            fieldId: fieldId,
            draftKey: draftKey,
            draftHandler: draftHandler,
            serverValue: serverValue
        }
    });
const $0d11bf17b164e25a$export$cba36ec5bda51ff8 = 'LOAD_DRAFT_SUCCESS';
const $0d11bf17b164e25a$export$51086f6ca77c5e0f = (fieldId, value)=>({
        type: $0d11bf17b164e25a$export$cba36ec5bda51ff8,
        payload: {
            fieldId: fieldId,
            value: value
        }
    });
const $0d11bf17b164e25a$export$e056de47154a9a05 = 'LOAD_DRAFT_FAILURE';
const $0d11bf17b164e25a$export$214a94482ffdd4c3 = (fieldId, error)=>({
        type: $0d11bf17b164e25a$export$e056de47154a9a05,
        payload: {
            fieldId: fieldId,
            error: error
        }
    });
const $0d11bf17b164e25a$export$75f4f60ec3864bc2 = 'DELETE_DRAFT_REQUEST';
const $0d11bf17b164e25a$export$460bdad3dd898fb5 = ({ fieldId: fieldId, draftKey: draftKey })=>({
        type: $0d11bf17b164e25a$export$75f4f60ec3864bc2,
        payload: {
            fieldId: fieldId,
            draftKey: draftKey
        }
    });
const $0d11bf17b164e25a$export$92fd16b0d2619f4f = 'DELETE_DRAFT_SUCCESS';
const $0d11bf17b164e25a$export$da621faaf1f6387b = (fieldId)=>({
        type: $0d11bf17b164e25a$export$92fd16b0d2619f4f,
        payload: {
            fieldId: fieldId
        }
    });
const $0d11bf17b164e25a$export$1aec6b89e4f832ef = 'DELETE_DRAFT_FAILURE';
const $0d11bf17b164e25a$export$4ab2471b7cf1d8c0 = (fieldId, error)=>({
        type: $0d11bf17b164e25a$export$1aec6b89e4f832ef,
        payload: {
            fieldId: fieldId,
            error: error
        }
    });

});

parcelRegister("6KjC3", function(module, exports) {

$parcel$export(module.exports, "FIELD_INIT_OPTIONS", () => $e6f6a5f1bfc98557$export$1103a9c5c20be9f0);
$parcel$export(module.exports, "fieldInitOptions", () => $e6f6a5f1bfc98557$export$773b0961e035c96a);
$parcel$export(module.exports, "FIELD_EDIT_BEGIN", () => $e6f6a5f1bfc98557$export$9572136709601671);
$parcel$export(module.exports, "fieldEditBegin", () => $e6f6a5f1bfc98557$export$7c4cc7ee430a6d3);
$parcel$export(module.exports, "FIELD_EDIT_UPDATE", () => $e6f6a5f1bfc98557$export$78121a49a308d9a9);
$parcel$export(module.exports, "fieldEditUpdate", () => $e6f6a5f1bfc98557$export$2099b2d0ff05390a);
$parcel$export(module.exports, "FIELD_EDIT_CONFIRM", () => $e6f6a5f1bfc98557$export$a37dbebba9bbea46);
$parcel$export(module.exports, "fieldEditConfirm", () => $e6f6a5f1bfc98557$export$fea77283e1082ae6);
$parcel$export(module.exports, "FIELD_EDIT_CANCEL", () => $e6f6a5f1bfc98557$export$fc9682bae6336d55);
$parcel$export(module.exports, "fieldEditCancel", () => $e6f6a5f1bfc98557$export$8a8795a06a2283b4);
$parcel$export(module.exports, "FIELD_PASTE", () => $e6f6a5f1bfc98557$export$3ff0fee86bcad857);
$parcel$export(module.exports, "fieldPaste", () => $e6f6a5f1bfc98557$export$e4d6d3a9589fc7dd);
$parcel$export(module.exports, "FIELD_ADD_ALLOWED_VALUES", () => $e6f6a5f1bfc98557$export$7a046179dd749198);
$parcel$export(module.exports, "fieldAddAllowedValues", () => $e6f6a5f1bfc98557$export$e81116803434608);
const $e6f6a5f1bfc98557$export$1103a9c5c20be9f0 = 'FIELD_INIT_OPTIONS';
const $e6f6a5f1bfc98557$export$773b0961e035c96a = (fieldId, fieldOptions)=>({
        type: $e6f6a5f1bfc98557$export$1103a9c5c20be9f0,
        payload: {
            fieldId: fieldId,
            fieldOptions: fieldOptions
        }
    });
const $e6f6a5f1bfc98557$export$9572136709601671 = 'FIELD_EDIT_BEGIN';
const $e6f6a5f1bfc98557$export$7c4cc7ee430a6d3 = (fieldId, fieldOptions, fieldEditSessionId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
analyticsEvent)=>({
        type: $e6f6a5f1bfc98557$export$9572136709601671,
        payload: {
            analyticsEvent: analyticsEvent,
            fieldId: fieldId,
            fieldOptions: fieldOptions,
            fieldEditSessionId: // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | undefined'.
            fieldEditSessionId
        }
    });
const $e6f6a5f1bfc98557$export$78121a49a308d9a9 = 'FIELD_EDIT_UPDATE';
const $e6f6a5f1bfc98557$export$2099b2d0ff05390a = (fieldId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
value, fieldOptions)=>({
        type: $e6f6a5f1bfc98557$export$78121a49a308d9a9,
        payload: {
            fieldId: fieldId,
            value: value,
            fieldOptions: fieldOptions
        }
    });
const $e6f6a5f1bfc98557$export$a37dbebba9bbea46 = 'FIELD_EDIT_CONFIRM';
const $e6f6a5f1bfc98557$export$fea77283e1082ae6 = (fieldId, fieldOptions, saveFieldData, // eslint-disable-next-line @typescript-eslint/no-explicit-any
analyticsEvent, // eslint-disable-next-line @typescript-eslint/no-explicit-any
analyticsAttributeIdRetriever)=>({
        type: $e6f6a5f1bfc98557$export$a37dbebba9bbea46,
        payload: {
            analyticsEvent: analyticsEvent,
            fieldId: fieldId,
            fieldOptions: fieldOptions,
            saveFieldData: // @ts-expect-error - TS2322 - Type 'T | null | undefined' is not assignable to type 'T | undefined'.
            saveFieldData,
            analyticsAttributeIdRetriever: analyticsAttributeIdRetriever
        }
    });
const $e6f6a5f1bfc98557$export$fc9682bae6336d55 = 'FIELD_EDIT_CANCEL';
const $e6f6a5f1bfc98557$export$8a8795a06a2283b4 = (fieldId, fieldOptions)=>({
        type: $e6f6a5f1bfc98557$export$fc9682bae6336d55,
        payload: {
            fieldId: fieldId,
            fieldOptions: fieldOptions
        }
    });
const $e6f6a5f1bfc98557$export$3ff0fee86bcad857 = 'FIELD_PASTE';
const $e6f6a5f1bfc98557$export$e4d6d3a9589fc7dd = (fieldId, fieldOptions, pastedContent)=>({
        type: $e6f6a5f1bfc98557$export$3ff0fee86bcad857,
        payload: {
            fieldId: fieldId,
            fieldOptions: fieldOptions,
            pastedContent: pastedContent
        }
    });
const $e6f6a5f1bfc98557$export$7a046179dd749198 = 'FIELD_ADD_ALLOWED_VALUES';
const $e6f6a5f1bfc98557$export$e81116803434608 = (fieldId, allowedValues)=>({
        type: $e6f6a5f1bfc98557$export$7a046179dd749198,
        payload: {
            fieldId: fieldId,
            allowedValues: allowedValues
        }
    });

});


parcelRegister("a0Zgz", function(module, exports) {

$parcel$export(module.exports, "FETCH_LOGGED_IN_USER_REQUEST", () => $00e54648258e7b38$export$1be883a8209bc83f);
$parcel$export(module.exports, "fetchLoggedInUserRequest", () => $00e54648258e7b38$export$c7ec81fac1f54e2d);
$parcel$export(module.exports, "FETCH_LOGGED_IN_USER_SUCCESS", () => $00e54648258e7b38$export$ea4f6815da66a10b);
$parcel$export(module.exports, "fetchLoggedInUserSuccess", () => $00e54648258e7b38$export$6570171a8a28ee4b);
$parcel$export(module.exports, "fetchLoggedInUserFailure", () => $00e54648258e7b38$export$9c124baa62451b3a);
const $00e54648258e7b38$export$1be883a8209bc83f = 'FETCH_LOGGED_IN_USER_REQUEST';
const $00e54648258e7b38$export$c7ec81fac1f54e2d = ()=>({
        type: $00e54648258e7b38$export$1be883a8209bc83f
    });
const $00e54648258e7b38$export$ea4f6815da66a10b = 'FETCH_LOGGED_IN_USER_SUCCESS';
const $00e54648258e7b38$export$6570171a8a28ee4b = (user)=>({
        type: $00e54648258e7b38$export$ea4f6815da66a10b,
        payload: {
            user: user
        }
    });
const $00e54648258e7b38$export$5f81529e8e6ac93f = 'FETCH_LOGGED_IN_USER_FAILURE';
const $00e54648258e7b38$export$9c124baa62451b3a = ()=>({
        type: $00e54648258e7b38$export$5f81529e8e6ac93f
    });

});

parcelRegister("fwyCm", function(module, exports) {

$parcel$export(module.exports, "default", () => $44fa6f4d77641054$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $MYW4e = parcelRequire("MYW4e");

var $bd1K7 = parcelRequire("bd1K7");

var $jG2Eu = parcelRequire("jG2Eu");

var $bQQi1 = parcelRequire("bQQi1");

var $czGdf = parcelRequire("czGdf");

var $fvrQL = parcelRequire("fvrQL");

var $jGONJ = parcelRequire("jGONJ");

var $6vrw7 = parcelRequire("6vrw7");

var $5TEKS = parcelRequire("5TEKS");
const $44fa6f4d77641054$var$createMiddleware = (onChange, onError, dataProvider, history, subProduct, issueRefreshServiceActions, fieldsValueActions, fieldsConfigActions, issueViewLayoutActions, issueViewFieldUpdateActions, forgeActions, ecosystemActions, attachmentActions, recentIssuesActions, prefetchedResourceManager, userPreferenceActions, issueScrollActions, permissionActions, jiraSettingsActions, projectContextActions, issueContextActions, workflowTransitionsActions, mediaContextActions, issueRefreshLoadingActionsRef, associatedIssuesContextActions, issueViewNonCriticalDataActions)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rootEpic = (0, $bQQi1.disposableEpic)((0, $5TEKS.default)(onChange, onError, dataProvider, history, subProduct, issueRefreshServiceActions, fieldsValueActions, fieldsConfigActions, issueViewLayoutActions, issueViewFieldUpdateActions, forgeActions, ecosystemActions, attachmentActions, recentIssuesActions, userPreferenceActions, prefetchedResourceManager, issueScrollActions, permissionActions, jiraSettingsActions, projectContextActions, issueContextActions, workflowTransitionsActions, mediaContextActions, issueRefreshLoadingActionsRef, associatedIssuesContextActions, issueViewNonCriticalDataActions));
    const epicMiddleware = (0, $bd1K7.createEpicMiddleware)(rootEpic);
    return [
        (0, $fvrQL.errorLoggingMiddleware),
        epicMiddleware
    ];
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$44fa6f4d77641054$export$2e2bcd8739ae039 = ({ initialState: initialState, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onError: onError = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), dataProvider: dataProvider, history: history, issueKey: issueKey = (0, $6vrw7.toIssueKey)(''), subProduct: subProduct, issueRefreshServiceActions: issueRefreshServiceActions, fieldsValueActions: fieldsValueActions, fieldsConfigActions: fieldsConfigActions, issueViewLayoutActions: issueViewLayoutActions, issueViewFieldUpdateActions: issueViewFieldUpdateActions, forgeActions: forgeActions, ecosystemActions: ecosystemActions, attachmentActions: attachmentActions, recentIssuesActions: recentIssuesActions, prefetchedResourceManager: prefetchedResourceManager, userPreferenceActions: userPreferenceActions, issueScrollActions: issueScrollActions, permissionActions: permissionActions, jiraSettingsActions: jiraSettingsActions, projectContextActions: projectContextActions, issueContextActions: issueContextActions, workflowTransitionsActions: workflowTransitionsActions, mediaContextActions: mediaContextActions, associatedIssuesContextActions: associatedIssuesContextActions, issueRefreshLoadingActionsRef: issueRefreshLoadingActionsRef, issueViewNonCriticalDataActions: issueViewNonCriticalDataActions })=>(0, $huRi7.createStore)((0, $MYW4e.enableBatching)((0, $jGONJ.default)), initialState, (0, $czGdf.default)({
        name: `issue-${issueKey}`
    })((0, $huRi7.applyMiddleware)(// @ts-expect-error - TS2345 - Argument of type '() => (next: (arg1: Action) => Action) => (action: Action) => any' is not assignable to parameter of type 'Middleware'.
    ...$44fa6f4d77641054$var$createMiddleware(onChange, onError, dataProvider, history, subProduct, issueRefreshServiceActions, fieldsValueActions, fieldsConfigActions, issueViewLayoutActions, issueViewFieldUpdateActions, forgeActions, ecosystemActions, attachmentActions, recentIssuesActions, prefetchedResourceManager, userPreferenceActions, issueScrollActions, permissionActions, jiraSettingsActions, projectContextActions, issueContextActions, workflowTransitionsActions, mediaContextActions, issueRefreshLoadingActionsRef, associatedIssuesContextActions, issueViewNonCriticalDataActions))));

});
parcelRegister("fvrQL", function(module, exports) {

$parcel$export(module.exports, "errorLoggingMiddleware", () => $3946eb29e2c5975c$export$1bdcf9202c001d3c);

var $gUUjF = parcelRequire("gUUjF");
const $3946eb29e2c5975c$var$LOG_LOCATION = 'issue.middleware.error-logger';
const $3946eb29e2c5975c$export$1bdcf9202c001d3c = ()=>(next)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (action)=>{
            try {
                next(action);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData($3946eb29e2c5975c$var$LOG_LOCATION, `Unhandled error in ${action.type}`);
                throw error;
            }
        };

});

parcelRegister("jGONJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $816917af8dacf2ce$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $ePSh2 = parcelRequire("ePSh2");

var $1OJS4 = parcelRequire("1OJS4");

var $a0Zgz = parcelRequire("a0Zgz");

var $lIxm3 = parcelRequire("lIxm3");

var $fYteL = parcelRequire("fYteL");

var $dFgyg = parcelRequire("dFgyg");

var $7ih5c = parcelRequire("7ih5c");

var $hIGVK = parcelRequire("hIGVK");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $cR3Tm = parcelRequire("cR3Tm");

var $dB5A8 = parcelRequire("dB5A8");

var $3krPY = parcelRequire("3krPY");

var $3bzc5 = parcelRequire("3bzc5");

var $fSMu9 = parcelRequire("fSMu9");

var $1hjmS = parcelRequire("1hjmS");

var $2PrDF = parcelRequire("2PrDF");

var $7IaMP = parcelRequire("7IaMP");

var $cvbsw = parcelRequire("cvbsw");

var $eGxZq = parcelRequire("eGxZq");

var $ji4ic = parcelRequire("ji4ic");

var $2M6VW = parcelRequire("2M6VW");

var $4nslA = parcelRequire("4nslA");

var $5j668 = parcelRequire("5j668");

var $eGZog = parcelRequire("eGZog");

var $k0Cxn = parcelRequire("k0Cxn");

var $Il408 = parcelRequire("Il408");

var $jdLBA = parcelRequire("jdLBA");

var $eT8Vs = parcelRequire("eT8Vs");

var $5QWjK = parcelRequire("5QWjK");

var $6A6O1 = parcelRequire("6A6O1");

var $9Q7Wl = parcelRequire("9Q7Wl");

var $9g9EG = parcelRequire("9g9EG");

var $lHg9A = parcelRequire("lHg9A");

var $2RFvT = parcelRequire("2RFvT");

var $dswL2 = parcelRequire("dswL2");

var $e1hy4 = parcelRequire("e1hy4");

var $dRuBI = parcelRequire("dRuBI");
const $816917af8dacf2ce$var$initialState = {
    agile: undefined,
    context: undefined,
    entities: undefined,
    fields: undefined,
    mediaContext: {
        viewContext: null,
        uploadContext: null,
        userAuth: null
    },
    shareAsComment: undefined,
    timing: undefined,
    ui: undefined,
    validators: undefined
};
const $816917af8dacf2ce$var$featureFlaggedUiReducers = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flaggedReducers = {};
    flaggedReducers.issueType = (0, $6A6O1.default);
    // This is safe to be switched on even without checking `useIsRelayEnabled` because:
    // We have no access to other data for performing this check,
    // so we must check for `useIsRelayEnabled` when requesting this piece of redux state
    flaggedReducers.doNotUseIsLoadingPromise = (0, $5QWjK.issueLoadingStagePromiseReducer);
    flaggedReducers.proforma = (0, $9Q7Wl.default);
    return flaggedReducers;
};
// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
const $816917af8dacf2ce$var$appReducer = (state, action)=>(0, $huRi7.combineReducers)({
        agile: (0, $3krPY.default),
        context: (0, $eGxZq.default),
        entities: (0, $4nslA.default),
        fields: (0, $cR3Tm.default),
        mediaContext: (0, $huRi7.combineReducers)({
            uploadContext: (0, $dFgyg.default),
            userAuth: (0, $7ih5c.default),
            viewContext: (0, $hIGVK.default)
        }),
        shareAsComment: (0, $2RFvT.default),
        timing: (0, $lIxm3.default),
        // @ts-expect-error - No overload matches this call.
        ui: (0, $huRi7.combineReducers)({
            attachments: (0, $huRi7.combineReducers)({
                picker: (0, $fSMu9.default)
            }),
            activityFeed: (0, $dB5A8.default),
            assignIssueParentModal: (0, $3bzc5.default),
            comments: (0, $cvbsw.default),
            changeboarding: (0, $1hjmS.default),
            childPanel: (0, $2PrDF.default),
            cloneModal: (0, $7IaMP.default),
            drafts: (0, $ji4ic.default),
            ecosystem: (0, $huRi7.combineReducers)({
                glance: (0, $2M6VW.default)
            }),
            error: (0, $eGZog.default),
            fetchIssueTypesStatus: (0, $k0Cxn.default),
            flags: (0, $Il408.default),
            issueDeletion: (0, $eT8Vs.default),
            loadingStage: (0, $5QWjK.default),
            recentlyVisitedConfluencePages: (0, $lHg9A.default),
            uiConfig: (0, $dswL2.default),
            viewMountStatus: (0, $e1hy4.default),
            worklog: (0, $dRuBI.default),
            investigateIncident: (0, $jdLBA.default),
            errorMessage: (0, $5j668.default),
            ...$816917af8dacf2ce$var$featureFlaggedUiReducers()
        }),
        validators: (0, $9g9EG.default)
    })(state, action);
/*
 TODO: Ideally we shouldn't use "InitialState" here in root reducer because it will be huge and its default values will override the default values in child reducers.
  Once that's done we should use "State" type instead of "any".
*/ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $816917af8dacf2ce$var$rootReducer = (state = $816917af8dacf2ce$var$initialState, action)=>{
    if (action.type === (0, $1OJS4.LOAD_NEW_ISSUE)) {
        // reset the state here to only keep context and some specific preferences, so the epic
        // will use the new issue key to fetch the new issue. this would not be needed if our state
        // was linked to issue-key rather than 'global'
        const withContext = $816917af8dacf2ce$var$appReducer({
            // @ts-expect-error - TS2740 - Type '{ changeboarding: any; uiConfig: any; }' is missing the following properties from type 'Readonly<{ activityFeed: ActivityFeedUiState; assignIssueParentModal: AssignIssueParentModalUiState; attachments: AttachmentsUiState; ... 19 more ...; shortcutDialog: ShortcutDialogUiState; }>': activityFeed, assignIssueParentModal, attachments, childPanel, and 17 more.
            ui: {
                changeboarding: state.ui.changeboarding,
                uiConfig: state.ui.uiConfig
            }
        }, (0, $ePSh2.setContext)((0, $5JqpU.contextSelector)(state)));
        const updatedContext = $816917af8dacf2ce$var$appReducer(withContext, action);
        const currentLoggedInUser = (0, $jZDJX.loggedInUserDetailsSelector)(state);
        if (currentLoggedInUser) return $816917af8dacf2ce$var$appReducer(updatedContext, (0, $a0Zgz.fetchLoggedInUserSuccess)(currentLoggedInUser));
        return updatedContext;
    }
    if (action.type === (0, $1OJS4.LOAD_RECENT_ISSUE)) {
        const currentContext = (0, $5JqpU.contextSelector)(state);
        const { issueState: issueState } = action.payload;
        return $816917af8dacf2ce$var$appReducer({
            ...issueState,
            // The context for same issue might have changed - e.g. analyticsSource
            context: {
                ...issueState.context,
                ...currentContext,
                // Overwrite properties below - newContext might contain stale data for these properties =============================
                issueId: issueState.context.issueId
            }
        }, (0, $fYteL.refreshIssueRequest)());
    }
    return $816917af8dacf2ce$var$appReducer(state, action);
};
var $816917af8dacf2ce$export$2e2bcd8739ae039 = $816917af8dacf2ce$var$rootReducer;

});
parcelRegister("lIxm3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6c0797b1dcddd7e$export$2e2bcd8739ae039);

var $7yNiv = parcelRequire("7yNiv");
const $e6c0797b1dcddd7e$var$initialState = {
    server: {}
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e6c0797b1dcddd7e$export$2e2bcd8739ae039 = (state = $e6c0797b1dcddd7e$var$initialState, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $7yNiv.SAVE_SERVER_TIME:
            if (payload.serverTime) return {
                ...state,
                server: {
                    ...state.server,
                    [payload.key]: payload.serverTime
                }
            };
            return state;
        default:
            return state;
    }
};

});
parcelRegister("7yNiv", function(module, exports) {

$parcel$export(module.exports, "SAVE_SERVER_TIME", () => $ae980f8b9d5592f7$export$7f944d2bd035867d);
$parcel$export(module.exports, "reportServerTimeViaState", () => $ae980f8b9d5592f7$export$9569383c0ded09a8);
const $ae980f8b9d5592f7$export$7f944d2bd035867d = 'SAVE_SERVER_TIME';
const $ae980f8b9d5592f7$var$saveServerTime = (key, serverTime)=>({
        type: $ae980f8b9d5592f7$export$7f944d2bd035867d,
        payload: {
            key: key,
            serverTime: serverTime
        }
    });
const $ae980f8b9d5592f7$export$9569383c0ded09a8 = (store)=>(key)=>(headers)=>{
            // @ts-expect-error - Argument of type '{ type: "SAVE_SERVER_TIME"; payload: { key: string; serverTime: number; }; }' is not assignable to parameter of type 'Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: MyPreferences | undefined; }>; ... 5 more ...; validators: Validators; }>'.
            store.dispatch($ae980f8b9d5592f7$var$saveServerTime(key, Number(headers.get('atl-vtm-backend-time'))));
        };

});


parcelRegister("dFgyg", function(module, exports) {

$parcel$export(module.exports, "default", () => $820d606143edca99$export$2e2bcd8739ae039);

var $20th5 = parcelRequire("20th5");
const $820d606143edca99$export$d4c72bab9d6cc13a = null;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$820d606143edca99$export$2e2bcd8739ae039 = (state = $820d606143edca99$export$d4c72bab9d6cc13a, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $20th5.FETCH_UPLOAD_CONTEXT_SUCCESS:
            return payload;
        case 0, $20th5.FETCH_UPLOAD_CONTEXT_FAILURE:
            return $820d606143edca99$export$d4c72bab9d6cc13a;
        default:
            return state;
    }
};

});
parcelRegister("20th5", function(module, exports) {

$parcel$export(module.exports, "FETCH_UPLOAD_CONTEXT_REQUEST", () => $327fd8ef30ceec60$export$90793cb8b13cfe);
$parcel$export(module.exports, "fetchUploadContextRequest", () => $327fd8ef30ceec60$export$c8e71fca5ce00163);
$parcel$export(module.exports, "FETCH_UPLOAD_CONTEXT_SUCCESS", () => $327fd8ef30ceec60$export$7b48f401861090b4);
$parcel$export(module.exports, "fetchUploadContextSuccess", () => $327fd8ef30ceec60$export$72705c84ba0d282b);
$parcel$export(module.exports, "FETCH_UPLOAD_CONTEXT_FAILURE", () => $327fd8ef30ceec60$export$8667d3c681f2d381);
$parcel$export(module.exports, "fetchUploadContextFailure", () => $327fd8ef30ceec60$export$304bcf5c8265c78a);
$parcel$export(module.exports, "CHECK_UPLOAD_CONTEXT", () => $327fd8ef30ceec60$export$663e243a326e43b);
$parcel$export(module.exports, "checkUploadContext", () => $327fd8ef30ceec60$export$52080d05778c94bb);
const $327fd8ef30ceec60$export$90793cb8b13cfe = 'FETCH_UPLOAD_CONTEXT_REQUEST';
const $327fd8ef30ceec60$export$c8e71fca5ce00163 = ()=>({
        type: $327fd8ef30ceec60$export$90793cb8b13cfe
    });
const $327fd8ef30ceec60$export$7b48f401861090b4 = 'FETCH_UPLOAD_CONTEXT_SUCCESS';
const $327fd8ef30ceec60$export$72705c84ba0d282b = (payload)=>({
        type: $327fd8ef30ceec60$export$7b48f401861090b4,
        payload: payload
    });
const $327fd8ef30ceec60$export$8667d3c681f2d381 = 'FETCH_UPLOAD_CONTEXT_FAILURE';
const $327fd8ef30ceec60$export$304bcf5c8265c78a = (error)=>({
        type: $327fd8ef30ceec60$export$8667d3c681f2d381,
        payload: {
            error: error
        }
    });
const $327fd8ef30ceec60$export$663e243a326e43b = 'CHECK_UPLOAD_CONTEXT';
const $327fd8ef30ceec60$export$52080d05778c94bb = ()=>({
        type: $327fd8ef30ceec60$export$663e243a326e43b
    });

});


parcelRegister("7ih5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5236650d83fa9f6$export$2e2bcd8739ae039);

var $jsDaf = parcelRequire("jsDaf");
const $a5236650d83fa9f6$export$d4c72bab9d6cc13a = null;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a5236650d83fa9f6$export$2e2bcd8739ae039 = (state = $a5236650d83fa9f6$export$d4c72bab9d6cc13a, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $jsDaf.FETCH_USER_AUTH_SUCCESS:
            return payload;
        case 0, $jsDaf.FETCH_USER_AUTH_FAILURE:
            return $a5236650d83fa9f6$export$d4c72bab9d6cc13a;
        default:
            return state;
    }
};

});
parcelRegister("jsDaf", function(module, exports) {

$parcel$export(module.exports, "FETCH_USER_AUTH_REQUEST", () => $3319ed1222a4d310$export$d2a3001be31ebb92);
$parcel$export(module.exports, "fetchUserAuthRequest", () => $3319ed1222a4d310$export$7167f7b20be50e7b);
$parcel$export(module.exports, "FETCH_USER_AUTH_SUCCESS", () => $3319ed1222a4d310$export$74b9d3a163e58e32);
$parcel$export(module.exports, "fetchUserAuthSuccess", () => $3319ed1222a4d310$export$1e2a2ace3f16a89e);
$parcel$export(module.exports, "FETCH_USER_AUTH_FAILURE", () => $3319ed1222a4d310$export$2c271fdd62250e74);
$parcel$export(module.exports, "fetchUserAuthFailure", () => $3319ed1222a4d310$export$9acc2651bfb2ad90);
$parcel$export(module.exports, "CHECK_USER_AUTH", () => $3319ed1222a4d310$export$3c927300e50300b5);
$parcel$export(module.exports, "checkUserAuth", () => $3319ed1222a4d310$export$d25b28154554327d);
const $3319ed1222a4d310$export$d2a3001be31ebb92 = 'FETCH_USER_AUTH_REQUEST';
const $3319ed1222a4d310$export$7167f7b20be50e7b = ()=>({
        type: $3319ed1222a4d310$export$d2a3001be31ebb92
    });
const $3319ed1222a4d310$export$74b9d3a163e58e32 = 'FETCH_USER_AUTH_SUCCESS';
const $3319ed1222a4d310$export$1e2a2ace3f16a89e = (payload)=>({
        type: $3319ed1222a4d310$export$74b9d3a163e58e32,
        payload: payload
    });
const $3319ed1222a4d310$export$2c271fdd62250e74 = 'FETCH_USER_AUTH_FAILURE';
const $3319ed1222a4d310$export$9acc2651bfb2ad90 = (statusCode)=>({
        type: $3319ed1222a4d310$export$2c271fdd62250e74,
        payload: {
            statusCode: statusCode
        }
    });
const $3319ed1222a4d310$export$3c927300e50300b5 = 'CHECK_USER_AUTH';
const $3319ed1222a4d310$export$d25b28154554327d = ()=>({
        type: $3319ed1222a4d310$export$3c927300e50300b5
    });

});


parcelRegister("hIGVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ac4b28a024df269$export$2e2bcd8739ae039);

var $hlJEN = parcelRequire("hlJEN");
const $8ac4b28a024df269$var$initialState = null;
const $8ac4b28a024df269$var$FETCH_ERROR = 'FETCH_ERROR'; // Invalid token to be sent to the media service in case of fetch error
const $8ac4b28a024df269$var$fetchErrorState = {
    clientId: $8ac4b28a024df269$var$FETCH_ERROR,
    serviceHost: $8ac4b28a024df269$var$FETCH_ERROR,
    tokenLifespanInMs: 0,
    tokenIssueTimestamp: 0,
    token: null,
    areTokenPermissionsUpToDate: false,
    collection: null
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$8ac4b28a024df269$export$2e2bcd8739ae039 = (state = $8ac4b28a024df269$var$initialState, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $hlJEN.FETCH_VIEW_CONTEXT_FAILURE:
            return $8ac4b28a024df269$var$fetchErrorState;
        case 0, $hlJEN.FETCH_VIEW_CONTEXT_SUCCESS:
            return payload;
        case 0, $hlJEN.MARK_TOKEN_AS_OUTDATED:
            return {
                ...state,
                areTokenPermissionsUpToDate: false
            };
        case 0, $hlJEN.MARK_TOKEN_AS_UP_TO_DATE:
            return {
                ...state,
                areTokenPermissionsUpToDate: true
            };
        default:
            return state;
    }
};

});
parcelRegister("hlJEN", function(module, exports) {

$parcel$export(module.exports, "FETCH_VIEW_CONTEXT_REQUEST", () => $b420f2109b9c9d10$export$d274bad4c9d8ef41);
$parcel$export(module.exports, "fetchViewContextRequest", () => $b420f2109b9c9d10$export$82205ba0acb83cc2);
$parcel$export(module.exports, "FETCH_VIEW_CONTEXT_SUCCESS", () => $b420f2109b9c9d10$export$658605aa2cbb8b21);
$parcel$export(module.exports, "fetchViewContextSuccess", () => $b420f2109b9c9d10$export$ca1a1860124a689e);
$parcel$export(module.exports, "FETCH_VIEW_CONTEXT_FAILURE", () => $b420f2109b9c9d10$export$46a9a691e85f306c);
$parcel$export(module.exports, "fetchViewContextFailure", () => $b420f2109b9c9d10$export$c12a0a24a65ac0da);
$parcel$export(module.exports, "CHECK_VIEW_CONTEXT", () => $b420f2109b9c9d10$export$ee8c3f9df5ed6daa);
$parcel$export(module.exports, "checkViewContext", () => $b420f2109b9c9d10$export$48232ad6259b9971);
$parcel$export(module.exports, "MARK_TOKEN_AS_OUTDATED", () => $b420f2109b9c9d10$export$8cf783cbfaa6a1d0);
$parcel$export(module.exports, "markTokenAsOutdated", () => $b420f2109b9c9d10$export$24aba8301f0b2827);
$parcel$export(module.exports, "MARK_TOKEN_AS_UP_TO_DATE", () => $b420f2109b9c9d10$export$8887f8dc03035e07);
$parcel$export(module.exports, "markTokenAsUpToDate", () => $b420f2109b9c9d10$export$b07c83b4f44125f9);
const $b420f2109b9c9d10$export$d274bad4c9d8ef41 = 'FETCH_VIEW_CONTEXT_REQUEST';
const $b420f2109b9c9d10$export$82205ba0acb83cc2 = ()=>({
        type: $b420f2109b9c9d10$export$d274bad4c9d8ef41
    });
const $b420f2109b9c9d10$export$658605aa2cbb8b21 = 'FETCH_VIEW_CONTEXT_SUCCESS';
const $b420f2109b9c9d10$export$ca1a1860124a689e = (viewContext)=>({
        type: $b420f2109b9c9d10$export$658605aa2cbb8b21,
        payload: viewContext
    });
const $b420f2109b9c9d10$export$46a9a691e85f306c = 'FETCH_VIEW_CONTEXT_FAILURE';
const $b420f2109b9c9d10$export$c12a0a24a65ac0da = (error)=>({
        type: $b420f2109b9c9d10$export$46a9a691e85f306c,
        payload: {
            error: error
        }
    });
const $b420f2109b9c9d10$export$ee8c3f9df5ed6daa = 'CHECK_VIEW_CONTEXT';
const $b420f2109b9c9d10$export$48232ad6259b9971 = ()=>({
        type: $b420f2109b9c9d10$export$ee8c3f9df5ed6daa
    });
const $b420f2109b9c9d10$export$8cf783cbfaa6a1d0 = 'MARK_TOKEN_AS_OUTDATED';
const $b420f2109b9c9d10$export$24aba8301f0b2827 = ()=>({
        type: $b420f2109b9c9d10$export$8cf783cbfaa6a1d0
    });
const $b420f2109b9c9d10$export$8887f8dc03035e07 = 'MARK_TOKEN_AS_UP_TO_DATE';
const $b420f2109b9c9d10$export$b07c83b4f44125f9 = ()=>({
        type: $b420f2109b9c9d10$export$8887f8dc03035e07
    });

});


parcelRegister("cR3Tm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bc04f972ead4e7b$export$2e2bcd8739ae039);

var $czx3b = parcelRequire("czx3b");

var $f9RL0 = parcelRequire("f9RL0");

var $iW1Wx = parcelRequire("iW1Wx");

var $fYteL = parcelRequire("fYteL");

var $lfcmL = parcelRequire("lfcmL");

var $9Y7ra = parcelRequire("9Y7ra");

var $9BmVu = parcelRequire("9BmVu");

var $6KjC3 = parcelRequire("6KjC3");

var $fVCj0 = parcelRequire("fVCj0");
const $4bc04f972ead4e7b$var$initialState = {};
const $4bc04f972ead4e7b$var$changeField = (state, fieldId, propertiesToSet, propertiesToDelete = [])=>{
    const newState = {
        ...state,
        [fieldId]: {
            ...state[fieldId],
            ...propertiesToSet
        }
    };
    propertiesToDelete.forEach((propertyKey)=>{
        delete newState[fieldId][propertyKey];
    });
    return newState;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4bc04f972ead4e7b$export$2e2bcd8739ae039 = (state = $4bc04f972ead4e7b$var$initialState, action)=>{
    switch(action.type){
        case 0, $fYteL.REFRESH_ISSUE_SUCCESS:
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
            {
                const { fields: fields } = action.payload.issue;
                return (0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(fields, (field)=>({
                        ...field,
                        editingValue: state[field.key] && state[field.key].editingValue,
                        pendingValue: state[field.key] && state[field.key].pendingValue
                    }));
            }
        case 0, $6KjC3.FIELD_EDIT_BEGIN:
            {
                const { fieldId: fieldId, fieldOptions: { isRichTextField: isRichTextField }, fieldEditSessionId: fieldEditSessionId } = action.payload;
                if (!state[fieldId]) return state;
                const valueToCopy = isRichTextField ? (0, $9BmVu.getEditingAdfValue)(state[fieldId]) : (0, $9BmVu.default)(state[fieldId]);
                return $4bc04f972ead4e7b$var$changeField(state, fieldId, {
                    editingValue: valueToCopy,
                    ...fieldEditSessionId ? {
                        fieldEditSessionId: fieldEditSessionId
                    } : null
                }, [
                    'invalidMessage',
                    'isInvalid'
                ]);
            }
        case 0, $lfcmL.MULTILINE_FIELD_EDIT_BEGIN:
            {
                const { multilineFieldIdsToClose: multilineFieldIdsToClose } = action.payload;
                if (multilineFieldIdsToClose != null) {
                    const newMultilineFieldsToBeClosed = multilineFieldIdsToClose.reduce((accu, fieldId)=>({
                            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                            ...accu,
                            [fieldId]: {
                                ...state[fieldId],
                                editingValue: undefined
                            }
                        }), {});
                    return {
                        ...state,
                        ...newMultilineFieldsToBeClosed
                    };
                }
                return state;
            }
        case 0, $6KjC3.FIELD_EDIT_UPDATE:
            {
                const { fieldId: fieldId, value: value } = action.payload;
                return $4bc04f972ead4e7b$var$changeField(state, fieldId, {
                    editingValue: value
                }, [
                    'invalidMessage',
                    'isInvalid'
                ]);
            }
        case 0, $fVCj0.FIELD_SAVE_REQUEST:
            {
                const { fieldId: fieldId, value: value } = action.payload;
                return $4bc04f972ead4e7b$var$changeField(state, fieldId, {
                    pendingValue: value
                }, [
                    'editingValue'
                ]);
            }
        case 0, $6KjC3.FIELD_EDIT_CANCEL:
            {
                const { fieldId: fieldId } = action.payload;
                return $4bc04f972ead4e7b$var$changeField(state, fieldId, {}, [
                    'editingValue',
                    'invalidMessage',
                    'isInvalid',
                    'fieldEditSessionId'
                ]);
            }
        case 0, $fVCj0.FIELD_SAVE_SUCCESS:
            {
                const { fieldId: fieldId, fieldOptions: fieldOptions, saveFieldResult: saveFieldResult } = action.payload;
                if (!(fieldId in state)) return state;
                // clear the pendingValue
                const { pendingValue: pendingValue } = state[fieldId];
                const isPendingValueInState = Object.prototype.hasOwnProperty.call(state[fieldId], 'pendingValue');
                let newState = $4bc04f972ead4e7b$var$changeField(state, fieldId, {}, [
                    'pendingValue',
                    'fieldEditSessionId'
                ]);
                // Do we have a usable new value for this field from the response when saving the value?
                const hasUpdatedFieldValueFromSaveResult = // @ts-expect-error - TS2339 - Property 'updatedFieldValue' does not exist on type 'unknown'.
                saveFieldResult?.updatedFieldValue !== undefined;
                // if not, can we use the `pendingValue` in state (only usable if this was an optimistically saving field)
                const shouldUseOptimisticPendingValueAsFallback = fieldOptions.isOptimistic && isPendingValueInState;
                // Combine these conditions, if neither pass we probably shouldn't update the field's value at all
                const shouldUpdateValue = hasUpdatedFieldValueFromSaveResult || shouldUseOptimisticPendingValueAsFallback;
                if (shouldUpdateValue) {
                    const value = hasUpdatedFieldValueFromSaveResult ? saveFieldResult?.updatedFieldValue : pendingValue;
                    const key = fieldOptions.isRichTextField ? 'adfValue' : 'value';
                    newState = $4bc04f972ead4e7b$var$changeField(newState, fieldId, {
                        [key]: value
                    });
                }
                return newState;
            }
        case 0, $fVCj0.FIELD_UPDATE:
            {
                const { fieldId: fieldId, fieldValue: fieldValue } = action.payload;
                if (!Object.prototype.hasOwnProperty.call(state, fieldId)) return state;
                return $4bc04f972ead4e7b$var$changeField(state, fieldId, {
                    value: fieldValue
                }, [
                    'pendingValue',
                    'editingValue',
                    'fieldEditSessionId'
                ]);
            }
        case 0, $fVCj0.SWEET_STATE_FIELD_SAVE_FAILURE:
        case 0, $fVCj0.FIELD_SAVE_FAILURE:
            {
                const { fieldId: fieldId, invalidMessage: invalidMessage, fieldOptions: fieldOptions } = action.payload;
                const fieldValue = state[fieldId];
                if (!fieldValue) return state;
                const { pendingValue: pendingValue } = fieldValue;
                const additionalPropertiesToDelete = fieldOptions.shouldDiscardChangeOnFailure ? [
                    'editingValue'
                ] : [];
                return $4bc04f972ead4e7b$var$changeField(state, fieldId, {
                    editingValue: pendingValue,
                    isInvalid: true,
                    invalidMessage: invalidMessage
                }, // @ts-expect-error - TS2322 - Type 'string' is not assignable to type '"name" | "value" | "isInvalid" | "renderedValue" | "invalidMessage" | keyof BaseField | "adfValue" | "editingValue" | "pendingValue" | "fieldEditSessionId"'.
                [
                    'pendingValue',
                    'fieldEditSessionId',
                    ...additionalPropertiesToDelete
                ]);
            }
        case 0, $6KjC3.FIELD_ADD_ALLOWED_VALUES:
            {
                const { allowedValues: allowedValues, fieldId: fieldId } = action.payload;
                const oldAllowedValues = state[fieldId] && state[fieldId].allowedValues || [];
                return $4bc04f972ead4e7b$var$changeField(state, fieldId, {
                    allowedValues: [
                        ...oldAllowedValues,
                        ...allowedValues
                    ]
                });
            }
        case 0, $9Y7ra.UPDATE_TIME_REMAINING_SUCCESS:
            {
                const { timeRemaining: remainingEstimateSeconds } = action.payload;
                return {
                    ...state,
                    [(0, $f9RL0.TIME_TRACKING)]: {
                        ...state[0, $f9RL0.TIME_TRACKING],
                        value: {
                            ...state[0, $f9RL0.TIME_TRACKING].value,
                            remainingEstimateSeconds: remainingEstimateSeconds
                        }
                    }
                };
            }
        case 0, $9Y7ra.ADD_WORKLOG_SUCCESS:
            {
                const { timeTracking: value } = action.payload;
                return $4bc04f972ead4e7b$var$changeField(state, (0, $f9RL0.TIME_TRACKING), {
                    value: value
                });
            }
        case 0, $9Y7ra.EDIT_WORKLOG_SUCCESS:
        case 0, $9Y7ra.DELETE_WORKLOG_SUCCESS:
            {
                const { timeSpentSecondsDelta: timeSpentSecondsDelta, newRemainingEstimateSeconds: newRemainingEstimateSeconds } = action.payload.timeTrackingDeltas;
                const timeTrackingValue = state[0, $f9RL0.TIME_TRACKING].value;
                const newTimeTrackingValue = {
                    ...timeTrackingValue,
                    timeSpentSeconds: (timeTrackingValue.timeSpentSeconds || 0) + timeSpentSecondsDelta
                };
                if (newRemainingEstimateSeconds !== null) newTimeTrackingValue.remainingEstimateSeconds = newRemainingEstimateSeconds;
                return $4bc04f972ead4e7b$var$changeField(state, (0, $f9RL0.TIME_TRACKING), {
                    value: newTimeTrackingValue
                });
            }
        case 0, $iW1Wx.UPDATE_APPROVAL_LINKED_USER_PICKER_FIELD:
            {
                const { linkedUserPickerFieldId: linkedUserPickerFieldId, newApproverList: newApproverList } = action.payload;
                if (linkedUserPickerFieldId && state[linkedUserPickerFieldId]) return $4bc04f972ead4e7b$var$changeField(state, linkedUserPickerFieldId, {
                    value: newApproverList
                });
                return state;
            }
        default:
            return state;
    }
};

});
parcelRegister("iW1Wx", function(module, exports) {

$parcel$export(module.exports, "UPDATE_APPROVAL_LINKED_USER_PICKER_FIELD", () => $b129d9ee3bf8936f$export$f71f0472d6c94e1d);
$parcel$export(module.exports, "updateApprovalLinkedUserPickerField", () => $b129d9ee3bf8936f$export$af775a431344f5b9);
$parcel$export(module.exports, "ZERO_APPROVAL_REQUIRED", () => $b129d9ee3bf8936f$export$a4686c79ff8c7167);

var $0NycV = parcelRequire("0NycV");
const $b129d9ee3bf8936f$export$f71f0472d6c94e1d = 'UPDATE_APPROVAL_LINKED_USER_PICKER_FIELD';
const $b129d9ee3bf8936f$export$af775a431344f5b9 = (linkedUserPickerFieldId, newApproverList)=>({
        type: $b129d9ee3bf8936f$export$f71f0472d6c94e1d,
        payload: {
            linkedUserPickerFieldId: linkedUserPickerFieldId,
            newApproverList: newApproverList
        }
    });
const $b129d9ee3bf8936f$export$bb64ccb3d822b351 = ()=>({
        type: (0, $0NycV.SAVE_APPROVAL_ANSWER_ERROR)
    });
const $b129d9ee3bf8936f$export$6f7b99b952bc2097 = ()=>({
        type: (0, $0NycV.SAVE_APPROVAL_ANSWER_SUCCESS)
    });
const $b129d9ee3bf8936f$export$a4686c79ff8c7167 = 'ZERO_APPROVAL_REQUIRED';
const $b129d9ee3bf8936f$export$2620c7e56dc68d0 = ()=>({
        type: $b129d9ee3bf8936f$export$a4686c79ff8c7167
    });

});

parcelRegister("lfcmL", function(module, exports) {

$parcel$export(module.exports, "MULTILINE_FIELD_EDIT_BEGIN", () => $4d66e249a31ccc63$export$d4d3496a0fcc2680);
$parcel$export(module.exports, "multilineFieldEditBegin", () => $4d66e249a31ccc63$export$57bd1a06d60920ee);
// MULTILINE_FIELD_EDIT_BEGIN
const $4d66e249a31ccc63$export$d4d3496a0fcc2680 = 'MULTILINE_FIELD_EDIT_BEGIN';
const $4d66e249a31ccc63$export$57bd1a06d60920ee = (multilineFieldIdsToClose, commentIdsToClose, shouldCloseAddCommentForm)=>({
        type: $4d66e249a31ccc63$export$d4d3496a0fcc2680,
        payload: {
            multilineFieldIdsToClose: multilineFieldIdsToClose,
            commentIdsToClose: commentIdsToClose,
            shouldCloseAddCommentForm: shouldCloseAddCommentForm
        }
    });

});

parcelRegister("9Y7ra", function(module, exports) {

$parcel$export(module.exports, "FETCH_WORKLOGS_REQUEST", () => $b90c49fa0f40a9f9$export$18eed9f2cce47053);
$parcel$export(module.exports, "FETCH_WORKLOGS_REQUEST_INITIAL", () => $b90c49fa0f40a9f9$export$af914717293c4630);
$parcel$export(module.exports, "fetchWorklogsRequestInitial", () => $b90c49fa0f40a9f9$export$665ab5e3114627f1);
$parcel$export(module.exports, "FETCH_WORKLOGS_SUCCESS", () => $b90c49fa0f40a9f9$export$85fd50d4a144da1d);
$parcel$export(module.exports, "fetchWorklogsSuccess", () => $b90c49fa0f40a9f9$export$464ef9e5933255ed);
$parcel$export(module.exports, "FETCH_WORKLOGS_FAILURE", () => $b90c49fa0f40a9f9$export$cf971c0fc13c43c);
$parcel$export(module.exports, "fetchWorklogsFailure", () => $b90c49fa0f40a9f9$export$a65948e850d5dfcc);
$parcel$export(module.exports, "ADD_WORKLOG_REQUEST", () => $b90c49fa0f40a9f9$export$a58126b63dee173);
$parcel$export(module.exports, "addWorklogRequest", () => $b90c49fa0f40a9f9$export$eb18e6bcc0f28911);
$parcel$export(module.exports, "ADD_WORKLOG_SUCCESS", () => $b90c49fa0f40a9f9$export$2519b72aefd62ee3);
$parcel$export(module.exports, "addWorklogSuccess", () => $b90c49fa0f40a9f9$export$7aa7b5bfd7febab3);
$parcel$export(module.exports, "FETCH_SURROUNDING_WORKLOGS_BY_ID", () => $b90c49fa0f40a9f9$export$54c371ea68c4342e);
$parcel$export(module.exports, "fetchSurroundingWorklogsById", () => $b90c49fa0f40a9f9$export$e81ffbc0bb4a7a95);
$parcel$export(module.exports, "FETCH_WORKLOGS_BY_ID_SUCCESS", () => $b90c49fa0f40a9f9$export$2585085c4029e8df);
$parcel$export(module.exports, "fetchWorklogsByIdSuccess", () => $b90c49fa0f40a9f9$export$a4731780fa4b7f69);
$parcel$export(module.exports, "FETCH_WORKLOGS_BY_ID_FAILURE", () => $b90c49fa0f40a9f9$export$2c433bf860375bc);
$parcel$export(module.exports, "fetchWorklogsByIdFailure", () => $b90c49fa0f40a9f9$export$56c81a87f33d3756);
$parcel$export(module.exports, "ADD_WORKLOG_FAILURE", () => $b90c49fa0f40a9f9$export$190e4e4a6ee2a0a2);
$parcel$export(module.exports, "addWorklogFailure", () => $b90c49fa0f40a9f9$export$8cf94cc29140537);
$parcel$export(module.exports, "UPDATE_TIME_REMAINING_REQUEST", () => $b90c49fa0f40a9f9$export$8e818a42fd2abb69);
$parcel$export(module.exports, "updateTimeRemainingRequest", () => $b90c49fa0f40a9f9$export$e269e81d4bfc4bfd);
$parcel$export(module.exports, "UPDATE_TIME_REMAINING_SUCCESS", () => $b90c49fa0f40a9f9$export$2357f9add92f1c9b);
$parcel$export(module.exports, "updateTimeRemainingSuccess", () => $b90c49fa0f40a9f9$export$f53f85c1848db205);
$parcel$export(module.exports, "UPDATE_TIME_REMAINING_FAILURE", () => $b90c49fa0f40a9f9$export$bde55584c7518e8d);
$parcel$export(module.exports, "updateTimeRemainingFailure", () => $b90c49fa0f40a9f9$export$d3a6908b5672ee1d);
$parcel$export(module.exports, "OPEN_MODAL", () => $b90c49fa0f40a9f9$export$d1956215992c54b);
$parcel$export(module.exports, "openModal", () => $b90c49fa0f40a9f9$export$a7f6cffb6b8ba11c);
$parcel$export(module.exports, "CLOSE_MODAL", () => $b90c49fa0f40a9f9$export$d984830de9a39518);
$parcel$export(module.exports, "closeModal", () => $b90c49fa0f40a9f9$export$3f6fecd573f3fa48);
$parcel$export(module.exports, "EDIT_WORKLOG_REQUEST", () => $b90c49fa0f40a9f9$export$78dae999f00cd879);
$parcel$export(module.exports, "editWorklogRequest", () => $b90c49fa0f40a9f9$export$e5f3a53513eabe33);
$parcel$export(module.exports, "EDIT_WORKLOG_SUCCESS", () => $b90c49fa0f40a9f9$export$cf8d549e537c67d3);
$parcel$export(module.exports, "editWorklogSuccess", () => $b90c49fa0f40a9f9$export$a388a2aaaeac92ed);
$parcel$export(module.exports, "EDIT_WORKLOG_FAILURE", () => $b90c49fa0f40a9f9$export$2d33e591258e36a8);
$parcel$export(module.exports, "editWorklogFailure", () => $b90c49fa0f40a9f9$export$3bfc8c1d8c109ea);
$parcel$export(module.exports, "DELETE_WORKLOG_REQUEST", () => $b90c49fa0f40a9f9$export$5a7a155982cca7d);
$parcel$export(module.exports, "deleteWorklogRequest", () => $b90c49fa0f40a9f9$export$c06e38a51e1c1c25);
$parcel$export(module.exports, "DELETE_WORKLOG_SUCCESS", () => $b90c49fa0f40a9f9$export$b595535e9bb1a2a2);
$parcel$export(module.exports, "deleteWorklogSuccess", () => $b90c49fa0f40a9f9$export$6bcd4ceb464d24aa);
$parcel$export(module.exports, "DELETE_WORKLOG_FAILURE", () => $b90c49fa0f40a9f9$export$c3739a68f63b7e09);
$parcel$export(module.exports, "deleteWorklogFailure", () => $b90c49fa0f40a9f9$export$5bc6432701c39f6e);
$parcel$export(module.exports, "DISPOSE_WORKLOG_APP", () => $b90c49fa0f40a9f9$export$5514f838099cce3b);
$parcel$export(module.exports, "disposeWorklogApp", () => $b90c49fa0f40a9f9$export$20c9039447a1cc82);
$parcel$export(module.exports, "SET_WORKLOG_SCROLL_STATUS", () => $b90c49fa0f40a9f9$export$7e31e0e7145b2f89);
$parcel$export(module.exports, "setWorklogScrollStatus", () => $b90c49fa0f40a9f9$export$9f14881591d34d70);
$parcel$export(module.exports, "FETCH_SORTED_WORKLOGS_REQUEST", () => $b90c49fa0f40a9f9$export$eee24b12562372f7);
$parcel$export(module.exports, "fetchSortedWorklogsRequest", () => $b90c49fa0f40a9f9$export$82665a9383fa0c1f);
$parcel$export(module.exports, "FETCH_SORTED_WORKLOGS_SUCCESS", () => $b90c49fa0f40a9f9$export$62df579b2a551f33);
$parcel$export(module.exports, "fetchSortedWorklogsSuccess", () => $b90c49fa0f40a9f9$export$50f2b7536cfac070);
$parcel$export(module.exports, "FETCH_SORTED_WORKLOGS_FAILURE", () => $b90c49fa0f40a9f9$export$63650b7cf4c43e80);
$parcel$export(module.exports, "fetchSortedWorklogsFailure", () => $b90c49fa0f40a9f9$export$fc0cc0241b023f50);
$parcel$export(module.exports, "FETCH_NEWER_SORTED_WORKLOGS_REQUEST", () => $b90c49fa0f40a9f9$export$fa1d5d772481c0f5);
$parcel$export(module.exports, "fetchNewerSortedWorklogsRequest", () => $b90c49fa0f40a9f9$export$478908486774ecb8);
$parcel$export(module.exports, "FETCH_NEWER_SORTED_WORKLOGS_SUCCESS", () => $b90c49fa0f40a9f9$export$f722477ef135a251);
$parcel$export(module.exports, "fetchNewerSortedWorklogsSuccess", () => $b90c49fa0f40a9f9$export$aa06cee91febf116);
$parcel$export(module.exports, "FETCH_OLDER_SORTED_WORKLOGS_REQUEST", () => $b90c49fa0f40a9f9$export$30148404aeab9dd9);
$parcel$export(module.exports, "fetchOlderSortedWorklogsRequest", () => $b90c49fa0f40a9f9$export$a0634ff858267228);
$parcel$export(module.exports, "FETCH_OLDER_SORTED_WORKLOGS_SUCCESS", () => $b90c49fa0f40a9f9$export$aaf7e532e5eb97dc);
$parcel$export(module.exports, "fetchOlderSortedWorklogsSuccess", () => $b90c49fa0f40a9f9$export$1748794ac39f851);
$parcel$export(module.exports, "FETCH_SORTED_WORKLOGS_RETRY", () => $b90c49fa0f40a9f9$export$d1cce6442e9d78a1);
$parcel$export(module.exports, "fetchSortedWorklogsRetry", () => $b90c49fa0f40a9f9$export$998f85a817e7706e);
const $b90c49fa0f40a9f9$export$18eed9f2cce47053 = 'state.FETCH_WORKLOGS_REQUEST';
const $b90c49fa0f40a9f9$export$3d0b8d72bd963fe5 = (baseUrl, issueKey, analyticsEvent)=>({
        type: $b90c49fa0f40a9f9$export$18eed9f2cce47053,
        payload: {
            baseUrl: baseUrl,
            issueKey: issueKey
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $b90c49fa0f40a9f9$export$af914717293c4630 = 'state.FETCH_WORKLOGS_REQUEST_INITIAL';
const $b90c49fa0f40a9f9$export$665ab5e3114627f1 = (baseUrl, issueKey, analyticsEvent)=>({
        type: $b90c49fa0f40a9f9$export$af914717293c4630,
        payload: {
            baseUrl: baseUrl,
            issueKey: issueKey
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $b90c49fa0f40a9f9$export$85fd50d4a144da1d = 'state.FETCH_WORKLOGS_SUCCESS';
const $b90c49fa0f40a9f9$export$464ef9e5933255ed = (sortedWorklogIds, worklogs, totalWorklogs)=>({
        type: $b90c49fa0f40a9f9$export$85fd50d4a144da1d,
        payload: {
            sortedWorklogIds: sortedWorklogIds,
            worklogs: worklogs,
            totalWorklogs: totalWorklogs
        }
    });
const $b90c49fa0f40a9f9$export$cf971c0fc13c43c = 'state.FETCH_WORKLOGS_FAILURE';
const $b90c49fa0f40a9f9$export$a65948e850d5dfcc = ()=>({
        type: $b90c49fa0f40a9f9$export$cf971c0fc13c43c
    });
const $b90c49fa0f40a9f9$export$a58126b63dee173 = 'state.ADD_WORKLOG_REQUEST';
const $b90c49fa0f40a9f9$export$eb18e6bcc0f28911 = (values, analyticsEvent)=>({
        type: $b90c49fa0f40a9f9$export$a58126b63dee173,
        payload: {
            values: values
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $b90c49fa0f40a9f9$export$2519b72aefd62ee3 = 'state.ADD_WORKLOG_SUCCESS';
const $b90c49fa0f40a9f9$export$7aa7b5bfd7febab3 = (worklogId, timeTracking, meta, issueKey)=>({
        type: $b90c49fa0f40a9f9$export$2519b72aefd62ee3,
        payload: {
            worklogId: worklogId,
            timeTracking: timeTracking,
            issueKey: issueKey
        },
        meta: meta
    });
const $b90c49fa0f40a9f9$export$54c371ea68c4342e = 'state.FETCH_SURROUNDING_WORKLOGS_BY_ID';
const $b90c49fa0f40a9f9$export$e81ffbc0bb4a7a95 = (worklogId)=>({
        type: $b90c49fa0f40a9f9$export$54c371ea68c4342e,
        payload: {
            worklogId: worklogId
        }
    });
const $b90c49fa0f40a9f9$export$2585085c4029e8df = 'state.FETCH_WORKLOGS_BY_ID_SUCCESS';
const $b90c49fa0f40a9f9$export$a4731780fa4b7f69 = (sortedWorklogIds, worklogs, startIndex, totalWorklogs)=>({
        type: $b90c49fa0f40a9f9$export$2585085c4029e8df,
        payload: {
            sortedWorklogIds: sortedWorklogIds,
            worklogs: worklogs,
            startIndex: startIndex,
            totalWorklogs: totalWorklogs
        }
    });
const $b90c49fa0f40a9f9$export$2c433bf860375bc = 'state.FETCH_WORKLOGS_BY_ID_FAILURE';
const $b90c49fa0f40a9f9$export$56c81a87f33d3756 = ()=>({
        type: $b90c49fa0f40a9f9$export$2c433bf860375bc
    });
const $b90c49fa0f40a9f9$export$190e4e4a6ee2a0a2 = 'state.ADD_WORKLOG_FAILURE';
const $b90c49fa0f40a9f9$export$8cf94cc29140537 = ({ invalidMessage: invalidMessage } = {})=>({
        type: $b90c49fa0f40a9f9$export$190e4e4a6ee2a0a2,
        payload: {
            invalidMessage: invalidMessage
        }
    });
const $b90c49fa0f40a9f9$export$8e818a42fd2abb69 = 'state.UPDATE_TIME_REMAINING_REQUEST';
const $b90c49fa0f40a9f9$export$e269e81d4bfc4bfd = (timeRemaining, analyticsEvent)=>({
        type: $b90c49fa0f40a9f9$export$8e818a42fd2abb69,
        payload: {
            timeRemaining: timeRemaining
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $b90c49fa0f40a9f9$export$2357f9add92f1c9b = 'state.UPDATE_TIME_REMAINING_SUCCESS';
const $b90c49fa0f40a9f9$export$f53f85c1848db205 = (timeRemaining)=>({
        type: $b90c49fa0f40a9f9$export$2357f9add92f1c9b,
        payload: {
            timeRemaining: timeRemaining
        }
    });
const $b90c49fa0f40a9f9$export$bde55584c7518e8d = 'state.UPDATE_TIME_REMAINING_FAILURE';
const $b90c49fa0f40a9f9$export$d3a6908b5672ee1d = ()=>({
        type: $b90c49fa0f40a9f9$export$bde55584c7518e8d
    });
const $b90c49fa0f40a9f9$export$d1956215992c54b = 'state.OPEN_MODAL';
const $b90c49fa0f40a9f9$export$a7f6cffb6b8ba11c = (modalType, worklogId)=>({
        type: $b90c49fa0f40a9f9$export$d1956215992c54b,
        payload: {
            modalType: modalType,
            worklogId: worklogId
        }
    });
const $b90c49fa0f40a9f9$export$d984830de9a39518 = 'state.CLOSE_MODAL';
const $b90c49fa0f40a9f9$export$3f6fecd573f3fa48 = ()=>({
        type: $b90c49fa0f40a9f9$export$d984830de9a39518
    });
const $b90c49fa0f40a9f9$export$78dae999f00cd879 = 'state.EDIT_WORKLOG_REQUEST';
const $b90c49fa0f40a9f9$export$e5f3a53513eabe33 = (worklogId, values, analyticsEvent)=>({
        type: $b90c49fa0f40a9f9$export$78dae999f00cd879,
        payload: {
            worklogId: worklogId,
            values: values
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $b90c49fa0f40a9f9$export$cf8d549e537c67d3 = 'state.EDIT_WORKLOG_SUCCESS';
const $b90c49fa0f40a9f9$export$a388a2aaaeac92ed = (worklogs, worklogId, timeTrackingDeltas, meta)=>({
        type: $b90c49fa0f40a9f9$export$cf8d549e537c67d3,
        payload: {
            worklogs: worklogs,
            worklogId: worklogId,
            timeTrackingDeltas: timeTrackingDeltas
        },
        meta: meta
    });
const $b90c49fa0f40a9f9$export$2d33e591258e36a8 = 'state.EDIT_WORKLOG_FAILURE';
const $b90c49fa0f40a9f9$export$3bfc8c1d8c109ea = ()=>({
        type: $b90c49fa0f40a9f9$export$2d33e591258e36a8
    });
const $b90c49fa0f40a9f9$export$5a7a155982cca7d = 'state.DELETE_WORKLOG_REQUEST';
const $b90c49fa0f40a9f9$export$c06e38a51e1c1c25 = (worklogId, timeRemaining, isAdjustTimeRemainingChecked, analyticsEvent)=>({
        type: $b90c49fa0f40a9f9$export$5a7a155982cca7d,
        payload: {
            worklogId: worklogId,
            timeRemaining: timeRemaining,
            isAdjustTimeRemainingChecked: isAdjustTimeRemainingChecked
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $b90c49fa0f40a9f9$export$b595535e9bb1a2a2 = 'state.DELETE_WORKLOG_SUCCESS';
const $b90c49fa0f40a9f9$export$6bcd4ceb464d24aa = (worklogId, timeTrackingDeltas)=>({
        type: $b90c49fa0f40a9f9$export$b595535e9bb1a2a2,
        payload: {
            worklogId: worklogId,
            timeTrackingDeltas: timeTrackingDeltas
        }
    });
const $b90c49fa0f40a9f9$export$c3739a68f63b7e09 = 'state.DELETE_WORKLOG_FAILURE';
const $b90c49fa0f40a9f9$export$5bc6432701c39f6e = ()=>({
        type: $b90c49fa0f40a9f9$export$c3739a68f63b7e09
    });
const $b90c49fa0f40a9f9$export$5514f838099cce3b = 'state.DISPOSE_WORKLOG_APP';
const $b90c49fa0f40a9f9$export$20c9039447a1cc82 = ()=>({
        type: $b90c49fa0f40a9f9$export$5514f838099cce3b
    });
const $b90c49fa0f40a9f9$export$7e31e0e7145b2f89 = 'SET_WORKLOG_SCROLL_STATUS';
const $b90c49fa0f40a9f9$export$9f14881591d34d70 = (status)=>({
        type: $b90c49fa0f40a9f9$export$7e31e0e7145b2f89,
        payload: {
            status: status
        }
    });
const $b90c49fa0f40a9f9$export$eee24b12562372f7 = 'state.FETCH_SORTED_WORKLOGS_REQUEST';
const $b90c49fa0f40a9f9$export$82665a9383fa0c1f = ()=>({
        type: $b90c49fa0f40a9f9$export$eee24b12562372f7
    });
const $b90c49fa0f40a9f9$export$62df579b2a551f33 = 'state.FETCH_SORTED_WORKLOGS_SUCCESS';
const $b90c49fa0f40a9f9$export$50f2b7536cfac070 = (payload)=>({
        payload: payload,
        type: $b90c49fa0f40a9f9$export$62df579b2a551f33
    });
const $b90c49fa0f40a9f9$export$63650b7cf4c43e80 = 'state.FETCH_SORTED_WORKLOGS_FAILURE';
const $b90c49fa0f40a9f9$export$fc0cc0241b023f50 = ()=>({
        type: $b90c49fa0f40a9f9$export$63650b7cf4c43e80
    });
const $b90c49fa0f40a9f9$export$fa1d5d772481c0f5 = 'state.FETCH_NEWER_SORTED_WORKLOGS_REQUEST';
const $b90c49fa0f40a9f9$export$478908486774ecb8 = ()=>({
        type: $b90c49fa0f40a9f9$export$fa1d5d772481c0f5
    });
const $b90c49fa0f40a9f9$export$f722477ef135a251 = 'state.FETCH_NEWER_SORTED_WORKLOGS_SUCCESS';
const $b90c49fa0f40a9f9$export$aa06cee91febf116 = (payload)=>({
        type: $b90c49fa0f40a9f9$export$f722477ef135a251,
        payload: payload
    });
const $b90c49fa0f40a9f9$export$30148404aeab9dd9 = 'state.FETCH_OLDER_SORTED_WORKLOGS_REQUEST';
const $b90c49fa0f40a9f9$export$a0634ff858267228 = ()=>({
        type: $b90c49fa0f40a9f9$export$30148404aeab9dd9
    });
const $b90c49fa0f40a9f9$export$aaf7e532e5eb97dc = 'state.FETCH_OLDER_SORTED_WORKLOGS_SUCCESS';
const $b90c49fa0f40a9f9$export$1748794ac39f851 = (payload)=>({
        type: $b90c49fa0f40a9f9$export$aaf7e532e5eb97dc,
        payload: payload
    });
const $b90c49fa0f40a9f9$export$d1cce6442e9d78a1 = 'state.FETCH_SORTED_WORKLOGS_RETRY';
const $b90c49fa0f40a9f9$export$998f85a817e7706e = ()=>({
        type: $b90c49fa0f40a9f9$export$d1cce6442e9d78a1
    });

});


parcelRegister("dB5A8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f95050090f50f67f$export$2e2bcd8739ae039);


var $277q1 = parcelRequire("277q1");

var $fYteL = parcelRequire("fYteL");
const $f95050090f50f67f$var$initialState = {
    selectedActivityItem: null,
    selectedActivitySortOrder: (0, $25476979aca7c7e0$export$eda5fe8da1abb04c)
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f95050090f50f67f$export$2e2bcd8739ae039 = (state = $f95050090f50f67f$var$initialState, action)=>{
    switch(action.type){
        case 0, $277q1.SELECT_INITIAL_ACTIVITY_ITEM:
        case 0, $277q1.SELECT_ACTIVITY_ITEM:
            return {
                ...state,
                selectedActivityItem: action.payload
            };
        case 0, $277q1.SELECT_ACTIVITY_SORT_ORDER:
            return {
                ...state,
                selectedActivitySortOrder: action.payload
            };
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
            return {
                ...state,
                selectedActivitySortOrder: action.payload.activitySortOrder
            };
        default:
            return state;
    }
};

});
parcelRegister("277q1", function(module, exports) {

$parcel$export(module.exports, "SELECT_ACTIVITY_ITEM", () => $a59ce926a60a23f0$export$b99068f214ae3ef);
$parcel$export(module.exports, "setSelectedActivityItem", () => $a59ce926a60a23f0$export$429a642b03ab6b3a);
$parcel$export(module.exports, "SELECT_INITIAL_ACTIVITY_ITEM", () => $a59ce926a60a23f0$export$7a2ed51ac2fce676);
$parcel$export(module.exports, "setInitialSelectedActivityItem", () => $a59ce926a60a23f0$export$ea8629259f3a4f0c);
$parcel$export(module.exports, "SELECT_ACTIVITY_SORT_ORDER", () => $a59ce926a60a23f0$export$a9f660c363dff2e6);
$parcel$export(module.exports, "setSelectedActivitySortOrder", () => $a59ce926a60a23f0$export$84c2cde4c7eb83ba);
$parcel$export(module.exports, "UPDATE_ACTIVITY_SORT_ORDER_REQUEST", () => $a59ce926a60a23f0$export$7f792f56679698c8);
$parcel$export(module.exports, "updateActivitySortOrderRequest", () => $a59ce926a60a23f0$export$d0abf9d950b14778);
const $a59ce926a60a23f0$export$b99068f214ae3ef = 'SELECT_ACTIVITY_ITEM';
const $a59ce926a60a23f0$export$429a642b03ab6b3a = (activityItem)=>({
        type: $a59ce926a60a23f0$export$b99068f214ae3ef,
        payload: activityItem
    });
const $a59ce926a60a23f0$export$7a2ed51ac2fce676 = 'SELECT_INITIAL_ACTIVITY_ITEM';
const $a59ce926a60a23f0$export$ea8629259f3a4f0c = (activityItem)=>({
        type: $a59ce926a60a23f0$export$7a2ed51ac2fce676,
        payload: activityItem
    });
const $a59ce926a60a23f0$export$a9f660c363dff2e6 = 'SELECT_ACTIVITY_SORT_ORDER';
const $a59ce926a60a23f0$export$84c2cde4c7eb83ba = (activitySortOrder)=>({
        type: $a59ce926a60a23f0$export$a9f660c363dff2e6,
        payload: activitySortOrder
    });
const $a59ce926a60a23f0$export$7f792f56679698c8 = 'UPDATE_ACTIVITY_SORT_ORDER_REQUEST';
const $a59ce926a60a23f0$export$d0abf9d950b14778 = (sort)=>({
        type: $a59ce926a60a23f0$export$7f792f56679698c8,
        payload: sort
    });

});


parcelRegister("3krPY", function(module, exports) {

$parcel$export(module.exports, "default", () => $eca183bceb49ed9b$export$2e2bcd8739ae039);

var $fYteL = parcelRequire("fYteL");
const $eca183bceb49ed9b$var$initialState = {
    epic: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eca183bceb49ed9b$export$2e2bcd8739ae039 = (state = $eca183bceb49ed9b$var$initialState, action)=>{
    switch(action.type){
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
            return {
                ...action.payload.issue.agile
            };
        default:
            return state;
    }
};

});

parcelRegister("3bzc5", function(module, exports) {

$parcel$export(module.exports, "default", () => $16840086a10c24fe$export$2e2bcd8739ae039);

var $2W4Cf = parcelRequire("2W4Cf");
const $16840086a10c24fe$var$initialState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$16840086a10c24fe$export$2e2bcd8739ae039 = (state = $16840086a10c24fe$var$initialState, action)=>{
    switch(action.type){
        case 0, $2W4Cf.SHOW_ASSIGN_ISSUE_PARENT_MODAL:
            return {
                ...state,
                isOpen: true
            };
        case 0, $2W4Cf.HIDE_ASSIGN_ISSUE_PARENT_MODAL:
            return {
                ...state,
                isOpen: false
            };
        default:
            return state;
    }
};

});

parcelRegister("fSMu9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0be54f8bc9f75a99$export$2e2bcd8739ae039);

var $h5RMf = parcelRequire("h5RMf");

var $b2g4Y = parcelRequire("b2g4Y");

var $1v6Su = parcelRequire("1v6Su");
const $0be54f8bc9f75a99$var$initialState = {
    isPopupOpen: false,
    attachments: {},
    placeholderAttachmentCount: 0
};
const $0be54f8bc9f75a99$var$isValidAttachment = (attachment)=>Boolean(attachment?.id && attachment?.mediaApiFileId);
const $0be54f8bc9f75a99$var$removeAttachmentFromStore = (state, attachment)=>{
    if (!$0be54f8bc9f75a99$var$isValidAttachment(attachment)) return state;
    const { id: id, mediaApiFileId: mediaApiFileId } = attachment;
    const identifiersToRemove = [
        id,
        mediaApiFileId
    ];
    const attachments = Object.keys(state.attachments).filter((key)=>!identifiersToRemove.includes(key)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((obj, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...obj,
            [key]: state.attachments[key]
        }), {});
    return {
        ...state,
        attachments: attachments
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0be54f8bc9f75a99$export$2e2bcd8739ae039 = (state = $0be54f8bc9f75a99$var$initialState, action)=>{
    switch(action.type){
        case 0, $b2g4Y.ATTACHMENT_MEDIA_SERVICES_UPLOAD_BEGIN:
            {
                const attachment = action.payload;
                return {
                    ...state,
                    attachments: {
                        ...state.attachments,
                        [attachment.id]: attachment
                    }
                };
            }
        case 0, $b2g4Y.ATTACHMENT_MEDIA_SERVICES_UPLOAD_END:
            return state;
        case 0, $b2g4Y.ATTACHMENT_MEDIA_SERVICES_UPLOAD_ERROR:
            {
                const { fileId: fileId } = action.payload;
                if (fileId === null || fileId === undefined) return state;
                const attachments = Object.keys(state.attachments).filter((key)=>key !== fileId) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .reduce((obj, key)=>({
                        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                        ...obj,
                        attachments: {
                            ...obj.attachments,
                            [key]: state.attachments[key]
                        }
                    }), {});
                return {
                    ...state,
                    attachments: attachments
                };
            }
        // Since we are doing the API call when it's a success,
        // remove the old id is required to avoid the same id twice in the page
        case 0, $b2g4Y.ATTACHMENT_JIRA_CREATE_SUCCESS:
            return $0be54f8bc9f75a99$var$removeAttachmentFromStore(state, action.payload);
        // When it's an error, we should remove the pending state removing the id from the list added in our redux store
        case 0, $b2g4Y.ATTACHMENT_JIRA_CREATE_FAILURE:
            return $0be54f8bc9f75a99$var$removeAttachmentFromStore(state, action.payload.attachment);
        case 0, $1v6Su.ATTACHMENT_PICKER_POPUP_OPEN_SUCCESS:
            return {
                ...state,
                isPopupOpen: true
            };
        case 0, $1v6Su.ATTACHMENT_PICKER_POPUP_CLOSE_SUCCESS:
            return {
                ...state,
                isPopupOpen: false
            };
        case 0, $h5RMf.ATTACHMENT_PANEL_DRAG_ENTER:
            return {
                ...state,
                placeholderAttachmentCount: action.payload
            };
        case 0, $h5RMf.ATTACHMENT_PANEL_DRAG_LEAVE:
        case 0, $h5RMf.ATTACHMENT_PANEL_DROP:
            return {
                ...state,
                placeholderAttachmentCount: 0
            };
        default:
            return state;
    }
};

});
parcelRegister("h5RMf", function(module, exports) {

$parcel$export(module.exports, "ATTACHMENT_PANEL_DRAG_ENTER", () => $8b7e1856c5f7e6db$export$d1fcb93a93a0a9dc);
$parcel$export(module.exports, "ATTACHMENT_PANEL_DRAG_LEAVE", () => $8b7e1856c5f7e6db$export$5d480ec68e661f15);
$parcel$export(module.exports, "ATTACHMENT_PANEL_DROP", () => $8b7e1856c5f7e6db$export$6b2ea961ec93b10);
// ATTACHMENT_PANEL_DRAG_ENTER
const $8b7e1856c5f7e6db$export$d1fcb93a93a0a9dc = 'ATTACHMENT_PANEL_DRAG_ENTER';
const $8b7e1856c5f7e6db$export$ea8ef5272d3ae382 = (numAttachments)=>({
        type: $8b7e1856c5f7e6db$export$d1fcb93a93a0a9dc,
        payload: numAttachments
    });
const $8b7e1856c5f7e6db$export$5d480ec68e661f15 = 'ATTACHMENT_PANEL_DRAG_LEAVE';
const $8b7e1856c5f7e6db$export$71340e80459c3209 = ()=>({
        type: $8b7e1856c5f7e6db$export$5d480ec68e661f15
    });
const $8b7e1856c5f7e6db$export$6b2ea961ec93b10 = 'ATTACHMENT_PANEL_DROP';
const $8b7e1856c5f7e6db$export$fc27b7143127110 = ()=>({
        type: $8b7e1856c5f7e6db$export$6b2ea961ec93b10
    });

});

parcelRegister("b2g4Y", function(module, exports) {

$parcel$export(module.exports, "ATTACHMENT_MEDIA_SERVICES_UPLOAD_BEGIN", () => $530a0e1bdab22e84$export$d73a2406d426d66f);
$parcel$export(module.exports, "attachmentUploadBegin", () => $530a0e1bdab22e84$export$3cf427e769ef4885);
$parcel$export(module.exports, "ATTACHMENT_MEDIA_SERVICES_UPLOAD_END", () => $530a0e1bdab22e84$export$c022d182f260bd1b);
$parcel$export(module.exports, "attachmentUploadEnd", () => $530a0e1bdab22e84$export$dd6c6c4c8bac4e1);
$parcel$export(module.exports, "ATTACHMENT_MEDIA_SERVICES_UPLOAD_ERROR", () => $530a0e1bdab22e84$export$534f76f08529628);
$parcel$export(module.exports, "attachmentUploadError", () => $530a0e1bdab22e84$export$fd049f8c97915df3);
$parcel$export(module.exports, "ATTACHMENT_JIRA_CREATE_SUCCESS", () => $530a0e1bdab22e84$export$18672b92265587fb);
$parcel$export(module.exports, "attachmentJiraCreateSuccess", () => $530a0e1bdab22e84$export$913f8dd20cb66369);
$parcel$export(module.exports, "ATTACHMENT_JIRA_CREATE_END", () => $530a0e1bdab22e84$export$5b274a771c3b9aa6);
$parcel$export(module.exports, "attachmentJiraCreateEnd", () => $530a0e1bdab22e84$export$9d0c0b63c17188a1);
$parcel$export(module.exports, "ATTACHMENT_JIRA_CREATE_FAILURE", () => $530a0e1bdab22e84$export$8beb7fd0cebb476f);
$parcel$export(module.exports, "attachmentJiraCreateFailure", () => $530a0e1bdab22e84$export$1ebc803a69246da7);
$parcel$export(module.exports, "MEDIA_PICKER_ERROR", () => $530a0e1bdab22e84$export$befd79cc8de1f09);
$parcel$export(module.exports, "mediaPickerError", () => $530a0e1bdab22e84$export$18528d0d637ce5fc);
const $530a0e1bdab22e84$export$d73a2406d426d66f = 'ATTACHMENT_MEDIA_SERVICES_UPLOAD_BEGIN';
const $530a0e1bdab22e84$export$3cf427e769ef4885 = (attachment)=>({
        type: $530a0e1bdab22e84$export$d73a2406d426d66f,
        payload: attachment
    });
const $530a0e1bdab22e84$export$c022d182f260bd1b = 'ATTACHMENT_MEDIA_SERVICES_UPLOAD_END';
const $530a0e1bdab22e84$export$dd6c6c4c8bac4e1 = (attachment)=>({
        type: $530a0e1bdab22e84$export$c022d182f260bd1b,
        payload: attachment
    });
const $530a0e1bdab22e84$export$534f76f08529628 = 'ATTACHMENT_MEDIA_SERVICES_UPLOAD_ERROR';
const $530a0e1bdab22e84$export$fd049f8c97915df3 = (error)=>({
        type: $530a0e1bdab22e84$export$534f76f08529628,
        payload: error
    });
const $530a0e1bdab22e84$export$18672b92265587fb = 'ATTACHMENT_JIRA_CREATE_SUCCESS';
const $530a0e1bdab22e84$export$913f8dd20cb66369 = (attachment)=>({
        type: $530a0e1bdab22e84$export$18672b92265587fb,
        payload: attachment
    });
const $530a0e1bdab22e84$export$5b274a771c3b9aa6 = 'ATTACHMENT_JIRA_CREATE_END';
const $530a0e1bdab22e84$export$9d0c0b63c17188a1 = (issueKey, numCreated, numFailed)=>({
        type: $530a0e1bdab22e84$export$5b274a771c3b9aa6,
        payload: {
            issueKey: issueKey,
            numCreated: numCreated,
            numFailed: numFailed
        }
    });
const $530a0e1bdab22e84$export$8beb7fd0cebb476f = 'ATTACHMENT_JIRA_CREATE_FAILURE';
const $530a0e1bdab22e84$export$1ebc803a69246da7 = (attachment, statusCode, exceedFileSizeLimit)=>({
        type: $530a0e1bdab22e84$export$8beb7fd0cebb476f,
        payload: {
            attachment: attachment,
            statusCode: statusCode,
            exceedFileSizeLimit: exceedFileSizeLimit
        }
    });
const $530a0e1bdab22e84$export$befd79cc8de1f09 = 'MEDIA_PICKER_ERROR';
const $530a0e1bdab22e84$export$18528d0d637ce5fc = (error)=>({
        type: $530a0e1bdab22e84$export$befd79cc8de1f09,
        payload: error
    });

});

parcelRegister("1v6Su", function(module, exports) {

$parcel$export(module.exports, "ATTACHMENT_PICKER_POPUP_OPEN_SUCCESS", () => $d48c69e9bfa4a1d3$export$e6bd2bd441ecbbcb);
$parcel$export(module.exports, "attachmentPickerPopupOpenSuccess", () => $d48c69e9bfa4a1d3$export$d90558f0ec023776);
$parcel$export(module.exports, "ATTACHMENT_PICKER_POPUP_CLOSE_SUCCESS", () => $d48c69e9bfa4a1d3$export$bfe9de244651b88b);
$parcel$export(module.exports, "attachmentPickerPopupCloseSuccess", () => $d48c69e9bfa4a1d3$export$8d7b887ad76bf1d0);
// ATTACHMENT_PICKER_POPUP_OPEN_SUCCESS
const $d48c69e9bfa4a1d3$export$e6bd2bd441ecbbcb = 'ATTACHMENT_PICKER_POPUP_OPEN_SUCCESS';
const $d48c69e9bfa4a1d3$export$d90558f0ec023776 = ()=>({
        type: $d48c69e9bfa4a1d3$export$e6bd2bd441ecbbcb
    });
const $d48c69e9bfa4a1d3$export$bfe9de244651b88b = 'ATTACHMENT_PICKER_POPUP_CLOSE_SUCCESS';
const $d48c69e9bfa4a1d3$export$8d7b887ad76bf1d0 = ()=>({
        type: $d48c69e9bfa4a1d3$export$bfe9de244651b88b
    });

});


parcelRegister("1hjmS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6dffdf5d7a41ecc$export$2e2bcd8739ae039);


var $lB6Xt = parcelRequire("lB6Xt");

var $fYteL = parcelRequire("fYteL");

var $fgekC = parcelRequire("fgekC");
const $c6dffdf5d7a41ecc$var$initialState = {
    isBannerVisible: false,
    isBannerDismissed: false,
    isTourActive: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c6dffdf5d7a41ecc$export$2e2bcd8739ae039 = (state = $c6dffdf5d7a41ecc$var$initialState, action)=>{
    switch(action.type){
        case 0, $fgekC.PREVIEW_DATA_FETCHED:
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
            {
                const prefs = action.payload.myPreferences && action.payload.myPreferences[0, $e4af19d777b54ab6$export$8c6b5c30f78ab338];
                if (prefs !== undefined) return {
                    ...state,
                    isBannerVisible: prefs === null
                };
                return state;
            }
        case 0, $lB6Xt.CHANGEBOARDING_BANNER_DISMISS:
            return {
                ...state,
                isBannerVisible: false,
                isBannerDismissed: true
            };
        case 0, $lB6Xt.CHANGEBOARDING_TOUR_BEGIN:
            return {
                ...state,
                isBannerVisible: false,
                isTourActive: true
            };
        case 0, $lB6Xt.CHANGEBOARDING_TOUR_END:
            return {
                ...state,
                isTourActive: false
            };
        default:
            return state;
    }
};

});
const $e4af19d777b54ab6$export$a763454c55d057f2 = 'jira.user.issue.clickthrough-banner.lastinteracted';
const $e4af19d777b54ab6$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $e4af19d777b54ab6$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $e4af19d777b54ab6$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $e4af19d777b54ab6$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';

parcelRegister("lB6Xt", function(module, exports) {

$parcel$export(module.exports, "CHANGEBOARDING_TOUR_BEGIN", () => $9da872a66700c73a$export$9707f0318d53e555);
$parcel$export(module.exports, "CHANGEBOARDING_TOUR_END", () => $9da872a66700c73a$export$5bdb0e83c2d0dd01);
$parcel$export(module.exports, "CHANGEBOARDING_BANNER_DISMISS", () => $9da872a66700c73a$export$ccf0e764ed539095);
const $9da872a66700c73a$export$9707f0318d53e555 = 'CHANGEBOARDING_TOUR_BEGIN';
const $9da872a66700c73a$export$43557c60e20a427 = (timestamp)=>({
        type: $9da872a66700c73a$export$9707f0318d53e555,
        payload: timestamp
    });
const $9da872a66700c73a$export$5bdb0e83c2d0dd01 = 'CHANGEBOARDING_TOUR_END';
const $9da872a66700c73a$export$3ed7ba491fbcaa7b = ()=>({
        type: $9da872a66700c73a$export$5bdb0e83c2d0dd01
    });
const $9da872a66700c73a$export$ccf0e764ed539095 = 'CHANGEBOARDING_BANNER_DISMISS';
const $9da872a66700c73a$export$56fffa5537ad53a5 = (timestamp)=>({
        type: $9da872a66700c73a$export$ccf0e764ed539095,
        payload: timestamp
    });
const $9da872a66700c73a$export$dce7f243e1a2a2c3 = 'CHANGEBOARDING_BANNER_SEEN';
const $9da872a66700c73a$export$bbb11495a0c36e50 = (currentSeenTimes, firstSeenTimestamp)=>({
        type: $9da872a66700c73a$export$dce7f243e1a2a2c3,
        payload: {
            currentSeenTimes: currentSeenTimes,
            firstSeenTimestamp: firstSeenTimestamp
        }
    });
const $9da872a66700c73a$export$86c2e3d38faeaaae = 'OPT_OUT_REQUEST';
const $9da872a66700c73a$export$56d9154f52cf8167 = (payload)=>({
        type: $9da872a66700c73a$export$86c2e3d38faeaaae,
        payload: payload
    });

});

parcelRegister("fgekC", function(module, exports) {

$parcel$export(module.exports, "PREVIEW_DATA_FETCHED", () => $22c9118292e5acf5$export$dadaa8fa4ef50ec4);
const $22c9118292e5acf5$export$dadaa8fa4ef50ec4 = 'PREVIEW_DATA_FETCHED';
const $22c9118292e5acf5$export$707af3eef818ec27 = (issue)=>({
        type: $22c9118292e5acf5$export$dadaa8fa4ef50ec4,
        payload: issue
    });

});


parcelRegister("2PrDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6425011c3da24906$export$2e2bcd8739ae039);

var $hHnBv = parcelRequire("hHnBv");
const $6425011c3da24906$var$initialState = {
    subtaskQuickAddClickCount: 0,
    issueInEpicQuickAddClickCount: 0,
    childIssueQuickAddClickCount: 0
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6425011c3da24906$export$2e2bcd8739ae039 = (state = $6425011c3da24906$var$initialState, action)=>{
    switch(action.type){
        case 0, $hHnBv.SUBTASK_QUICK_ADD_CLICKED:
            return {
                ...state,
                subtaskQuickAddClickCount: state.subtaskQuickAddClickCount + 1
            };
        case 0, $hHnBv.ISSUE_IN_EPIC_QUICK_ADD_CLICKED:
            return {
                ...state,
                issueInEpicQuickAddClickCount: state.issueInEpicQuickAddClickCount + 1
            };
        case 0, $hHnBv.CHILD_ISSUE_QUICK_ADD_CLICKED:
            return {
                ...state,
                childIssueQuickAddClickCount: state.childIssueQuickAddClickCount + 1
            };
        case 0, $hHnBv.RESET_QUICK_ADD_CLICKED_COUNT:
            return {
                ...$6425011c3da24906$var$initialState
            };
        default:
            return state;
    }
};

});

parcelRegister("7IaMP", function(module, exports) {

$parcel$export(module.exports, "default", () => $13ec3eb4626fa0fd$export$2e2bcd8739ae039);

var $10phJ = parcelRequire("10phJ");
const $13ec3eb4626fa0fd$var$initialState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$13ec3eb4626fa0fd$export$2e2bcd8739ae039 = (state = $13ec3eb4626fa0fd$var$initialState, action)=>{
    const { type: type } = action;
    switch(type){
        case 0, $10phJ.SHOW_CLONE_MODAL:
            return {
                isOpen: true
            };
        case 0, $10phJ.HIDE_CLONE_MODAL:
            return {
                isOpen: false
            };
        default:
            return state;
    }
};

});
parcelRegister("10phJ", function(module, exports) {

$parcel$export(module.exports, "SHOW_CLONE_MODAL", () => $2a214ae018a4b96c$export$6e8c161339aab10c);
$parcel$export(module.exports, "showCloneModal", () => $2a214ae018a4b96c$export$ec6b22c8703b243c);
$parcel$export(module.exports, "HIDE_CLONE_MODAL", () => $2a214ae018a4b96c$export$fe2d4060eac00eb9);
$parcel$export(module.exports, "hideCloneModal", () => $2a214ae018a4b96c$export$ec91a654eeed7730);
// SHOW_CLONE_MODAL
const $2a214ae018a4b96c$export$6e8c161339aab10c = 'SHOW_CLONE_MODAL';
const $2a214ae018a4b96c$export$ec6b22c8703b243c = ()=>({
        type: $2a214ae018a4b96c$export$6e8c161339aab10c
    });
const $2a214ae018a4b96c$export$fe2d4060eac00eb9 = 'HIDE_CLONE_MODAL';
const $2a214ae018a4b96c$export$ec91a654eeed7730 = ()=>({
        type: $2a214ae018a4b96c$export$fe2d4060eac00eb9
    });

});


parcelRegister("cvbsw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b13ba796cc28ddc5$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $illlw = parcelRequire("illlw");

var $1dO2y = parcelRequire("1dO2y");

var $f6MOn = parcelRequire("f6MOn");

var $lkPj1 = parcelRequire("lkPj1");

var $fYteL = parcelRequire("fYteL");

var $lfcmL = parcelRequire("lfcmL");

var $gIyTt = parcelRequire("gIyTt");

var $fgekC = parcelRequire("fgekC");

const $b13ba796cc28ddc5$var$initialState = (0, $6HC1D.freeze)({
    pendingSavedValues: {},
    pendingDeletedIds: [],
    deleteModalCommentId: null,
    isLoadingMoreComments: false,
    commentEditors: {},
    isCommentAttachmentInProgress: false,
    hasScrolledPermalinkComment: false,
    loadingStage: (0, $f6MOn.LOADING)
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b13ba796cc28ddc5$export$2e2bcd8739ae039 = (state = $b13ba796cc28ddc5$var$initialState, action)=>{
    const isEditExistingComment = (commentId)=>!!(0, $6HC1D.getIn)(state, [
            'commentEditors',
            commentId
        ]);
    const removeDeletedComment = (id)=>(0, $6HC1D.updateIn)(state, [
            'pendingDeletedIds'
        ], (ids)=>// @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'pendingId' implicitly has an 'any' type.
            ids.filter((pendingId)=>pendingId !== id));
    switch(action.type){
        case 0, $fgekC.PREVIEW_DATA_FETCHED:
            return (0, $6HC1D.set)(state, 'loadingStage', (0, $f6MOn.COMPLETE));
        case 0, $lkPj1.SAVE_COMMENT_REQUEST:
            {
                const { isNewComment: isNewComment, id: id, createdDate: createdDate, authorId: authorId, bodyHtml: bodyHtml, bodyAdf: bodyAdf, visibility: visibility, eventOccurredAt: eventOccurredAt, jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden, fullIssueUrl: fullIssueUrl, triggerIncidentSaveCommentFlag: triggerIncidentSaveCommentFlag } = action.payload.comment;
                let changedState = state;
                if (isNewComment) {
                    const newComment = state.commentEditors[0, $b10b5cb385fb5d46$export$c4134c813c47beb0];
                    if (newComment !== undefined) {
                        const tempState = (0, $1dO2y.default)(state, [
                            'commentEditors',
                            (0, $b10b5cb385fb5d46$export$c4134c813c47beb0)
                        ]);
                        changedState = (0, $6HC1D.setIn)(tempState, [
                            'commentEditors',
                            id
                        ], newComment);
                    }
                }
                const isInternal = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(changedState, // When adding a new comment, at this point, `id` is no longer equal to `NEW_OPTIMISTIC_COMMENT`,
                // it already became an optimistic id (which is `OPTIMISTIC_COMMENT_<timestamp>`).
                [
                    'commentEditors',
                    id,
                    'isInternal'
                ], true);
                const additionalOptimisticCommentProperties = (0, $gIyTt.isJsmTimelineEnabled)() ? {
                    eventOccurredAt: eventOccurredAt,
                    jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden,
                    fullIssueUrl: fullIssueUrl,
                    triggerIncidentSaveCommentFlag: triggerIncidentSaveCommentFlag
                } : {};
                const optimisticComment = {
                    id: id,
                    createdDate: createdDate,
                    authorId: authorId,
                    bodyHtml: bodyHtml,
                    bodyAdf: bodyAdf,
                    isInternal: isInternal,
                    visibility: visibility,
                    ...additionalOptimisticCommentProperties
                };
                changedState = isNewComment ? (0, $6HC1D.setIn)(changedState, [
                    'loadingStage'
                ], (0, $f6MOn.SAVE_COMMENT_LOADING)) : changedState;
                return (0, $6HC1D.chain)(changedState).setIn([
                    'pendingSavedValues',
                    id
                ], optimisticComment).setIn([
                    'commentEditors',
                    id,
                    'isEditing'
                ], false).value();
            }
        case 0, $lkPj1.FETCH_OLDER_COMMENTS_REQUEST:
        case 0, $lkPj1.FETCH_NEWER_COMMENTS_REQUEST:
            return (0, $6HC1D.set)(state, 'isLoadingMoreComments', true);
        case 0, $lkPj1.FETCH_MORE_COMMENTS_SUCCESS:
        case 0, $lkPj1.FETCH_MORE_COMMENTS_FAILURE:
            return (0, $6HC1D.set)(state, 'isLoadingMoreComments', false);
        case 0, $lkPj1.SAVE_COMMENT_RETRY:
            {
                const { payload: payload } = action;
                const changedState = (0, $1dO2y.default)(state, [
                    'pendingSavedValues',
                    payload.optimisticId,
                    'hasSaveFailed'
                ]);
                if (isEditExistingComment(payload.optimisticId)) return changedState;
                // need to update created date when saving a new comment (retry)
                return (0, $6HC1D.setIn)(changedState, [
                    'pendingSavedValues',
                    payload.optimisticId,
                    'createdDate'
                ], payload.createdDate);
            }
        case 0, $lkPj1.SAVE_COMMENT_EDIT:
            return (0, $6HC1D.setIn)(state, [
                'commentEditors',
                action.payload.optimisticId,
                'isEditing'
            ], true);
        case 0, $lkPj1.SAVE_COMMENT_SUCCESS:
        case 0, $lkPj1.SAVE_COMMENT_CANCEL:
            return (0, $1dO2y.default)((0, $1dO2y.default)(state, [
                'commentEditors',
                action.payload.optimisticId
            ]), [
                'pendingSavedValues',
                action.payload.optimisticId
            ]);
        case 0, $lkPj1.FETCH_SORTED_COMMENTS_REQUEST:
            return (0, $6HC1D.set)(state, 'loadingStage', (0, $f6MOn.LOADING));
        case 0, $lkPj1.FETCH_SORTED_COMMENTS_SUCCESS:
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
            return (0, $6HC1D.set)(state, 'loadingStage', (0, $f6MOn.COMPLETE));
        case 0, $lkPj1.SAVE_COMMENT_FAILURE:
            return (0, $6HC1D.setIn)(state, [
                'pendingSavedValues',
                action.payload.optimisticId,
                'hasSaveFailed'
            ], true);
        case 0, $lkPj1.DELETE_COMMENT_REQUEST:
            {
                const { payload: payload } = action;
                return (0, $6HC1D.chain)(state)// @ts-expect-error - TS2488 - Type 'unknown' must have a '[Symbol.iterator]()' method that returns an iterator.
                .updateIn([
                    'pendingDeletedIds'
                ], (ids)=>[
                        ...ids,
                        payload.id
                    ]).set('deleteModalCommentId', null).value();
            }
        case 0, $lkPj1.DELETE_COMMENT_SUCCESS:
            return removeDeletedComment(action.payload.id);
        case 0, $lkPj1.DELETE_COMMENT_FAILURE:
            return removeDeletedComment(action.payload);
        case 0, $lkPj1.SHOW_DELETE_COMMENT_MODAL:
            return (0, $6HC1D.set)(state, 'deleteModalCommentId', action.payload);
        case 0, $lkPj1.DELETE_COMMENT_CANCEL:
            return (0, $6HC1D.set)(state, 'deleteModalCommentId', null);
        case 0, $lkPj1.EDIT_COMMENT_BEGIN:
            return (0, $6HC1D.setIn)(state, [
                'commentEditors',
                action.payload.id
            ], {
                isEditing: true,
                isInternal: action.payload.isInternal
            });
        case 0, $lkPj1.EDIT_COMMENT_UPDATE:
            return (0, $6HC1D.setIn)(state, [
                'commentEditors',
                action.payload.id
            ], {
                isEditing: true,
                isInternal: (0, $6HC1D.getIn)(state, [
                    'commentEditors',
                    action.payload.id,
                    'isInternal'
                ]),
                editingValue: action.payload.value,
                visibility: (0, $6HC1D.getIn)(state, [
                    'commentEditors',
                    action.payload.id,
                    'visibility'
                ]),
                eventOccurredAt: (0, $6HC1D.getIn)(state, [
                    'commentEditors',
                    action.payload.id,
                    'eventOccurredAt'
                ])
            });
        case 0, $lkPj1.EDIT_COMMENT_VISIBILITY:
            return (0, $6HC1D.setIn)(state, [
                'commentEditors',
                action.payload.id,
                'visibility'
            ], action.payload.visibility);
        case 0, $lkPj1.EDIT_COMMENT_COLLAPSE:
        case 0, $lkPj1.EDIT_COMMENT_CANCEL:
            return (0, $1dO2y.default)(state, [
                'commentEditors',
                action.payload.id
            ]);
        case 0, $lkPj1.ADD_COMMENT_FORM_CANCEL:
        case 0, $lkPj1.ADD_COMMENT_FORM_COLLAPSE:
            {
                const updatedState = (0, $6HC1D.unset)(state, 'addCommentEditorExpand');
                return (0, $1dO2y.default)(updatedState, [
                    'commentEditors',
                    (0, $b10b5cb385fb5d46$export$c4134c813c47beb0)
                ]);
            }
        case 0, $lkPj1.ADD_COMMENT_FORM_EXPAND:
            return (0, $6HC1D.chain)(state).set('addCommentEditorExpand', true).set('addCommentEditorForceFocus', (state.addCommentEditorForceFocus || 0) + 1).value();
        case 0, $lkPj1.CHANGE_COMMENT_VISIBILITY:
            {
                const { id: commentId, isInternal: isInternal } = action.payload;
                return (0, $6HC1D.setIn)(state, [
                    'commentEditors',
                    commentId,
                    'isInternal'
                ], isInternal);
            }
        case 0, $lkPj1.EDIT_COMMENT_EVENT_OCCURRED_AT:
            return (0, $6HC1D.setIn)(state, [
                'commentEditors',
                action.payload.id,
                'eventOccurredAt'
            ], action.payload.eventOccurredAt);
        case 0, $lkPj1.SET_COMMENT_ATTACHMENT_IN_PROGRESS:
            return (0, $6HC1D.set)(state, 'isCommentAttachmentInProgress', action.payload.isInProgress);
        case 0, $lkPj1.SET_COMMENT_SCROLL_STATUS:
            return (0, $6HC1D.set)(state, 'hasScrolledPermalinkComment', action.payload.status);
        case 0, $lfcmL.MULTILINE_FIELD_EDIT_BEGIN:
            {
                const { commentIdsToClose: commentIdsToClose, shouldCloseAddCommentForm: shouldCloseAddCommentForm } = action.payload;
                if (commentIdsToClose != null) {
                    const commentIdsToBeClosed = shouldCloseAddCommentForm ? commentIdsToClose.concat((0, $b10b5cb385fb5d46$export$c4134c813c47beb0)) : commentIdsToClose;
                    const commentEditorsToBeClosed = commentIdsToBeClosed.reduce((accu, commentId)=>({
                            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                            ...accu,
                            [commentId]: {
                                ...state.commentEditors[commentId],
                                editingValue: undefined,
                                visibility: undefined,
                                isEditing: false
                            }
                        }), {});
                    return {
                        ...state,
                        commentEditors: {
                            ...state.commentEditors,
                            ...commentEditorsToBeClosed
                        },
                        addCommentEditorExpand: shouldCloseAddCommentForm ? false : state.addCommentEditorExpand
                    };
                }
                return state;
            }
        default:
            return state;
    }
};

});
parcelRegister("1dO2y", function(module, exports) {

$parcel$export(module.exports, "default", () => $427325626a31a3d6$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $427325626a31a3d6$var$unsetInSingle = (state, pathToParent, key)=>{
    if (pathToParent.length === 0) return (0, $6HC1D.unset)(state, key);
    const ret = (0, $6HC1D.updateIn)(state, pathToParent, (parent)=>parent ? (0, $6HC1D.unset)(parent, key) : undefined);
    return ret;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $427325626a31a3d6$var$unsetInMulti = (state, pathToParent, keys)=>// @ts-expect-error - TS7006 - Parameter 'folded' implicitly has an 'any' type. | TS7006 - Parameter 'subkey' implicitly has an 'any' type.
    keys.reduce((folded, subkey)=>$427325626a31a3d6$var$unsetInSingle(folded, pathToParent, subkey), state);
var //   ['a', 'b', 'c'] - removes values at 'a/b/c'
//   ['a', ['b', 'c']] - removes values at 'a/b' and 'a/c'
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$427325626a31a3d6$export$2e2bcd8739ae039 = (state, path)=>{
    if (path.length === 0) return state;
    const pathToParent = path.slice(0, path.length - 1);
    const lastPathItem = path.slice(-1)[0];
    if (Array.isArray(lastPathItem)) return $427325626a31a3d6$var$unsetInMulti(state, pathToParent, lastPathItem);
    return $427325626a31a3d6$var$unsetInSingle(state, pathToParent, lastPathItem);
};

});

const $b10b5cb385fb5d46$export$c4134c813c47beb0 = 'NEW_OPTIMISTIC_COMMENT';


parcelRegister("eGxZq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4879c8539a0d2065$export$2e2bcd8739ae039);

var $ao0hp = parcelRequire("ao0hp");

var $f9RL0 = parcelRequire("f9RL0");

var $6WXNs = parcelRequire("6WXNs");
var $7HKaW = parcelRequire("7HKaW");
var $38OPi = parcelRequire("38OPi");
var $6vrw7 = parcelRequire("6vrw7");

var $ePSh2 = parcelRequire("ePSh2");

var $1OJS4 = parcelRequire("1OJS4");

var $g2ZFU = parcelRequire("g2ZFU");

var $fYteL = parcelRequire("fYteL");

var $fgekC = parcelRequire("fgekC");
const $4879c8539a0d2065$var$getInitialState = ()=>({
        applicationKey: '',
        issueActions: [],
        atlassianAccountId: null,
        baseUrl: (0, $6vrw7.toBaseUrl)(''),
        isAnonymous: false,
        issueKey: (0, $6vrw7.toIssueKey)(''),
        isModal: false,
        cloudId: null,
        activationId: null,
        locale: (0, $ao0hp.defaultLocale),
        maxTokenLength: 0,
        ecosystemEnabled: null,
        isLoadedWithPage: null,
        rapidViewMap: null,
        estimationStatistic: null,
        licensedProducts: {},
        appPermissions: (0, $38OPi.populateApplicationPermissions)(),
        appEditions: (0, $6WXNs.populateApplicationEditions)(),
        licenseStates: (0, $7HKaW.populateApplicationLicenseStates)(),
        siteAdminStatus: 'unknown',
        productCrossSellConfig: 'unknown',
        isLoading: false,
        viewMode: null,
        firstActivationDateMs: null,
        viewScreenId: undefined
    });
const $4879c8539a0d2065$var$getConfiguration = ({ state: state, projectConfig: projectConfig, issueId: issueId })=>{
    const config = (0, $f9RL0.getIssueConfiguration)(projectConfig);
    const issueConfiguration = {
        ...state,
        issueId: issueId,
        applicationKey: config.applicationKey,
        issueActions: config.issueActions,
        ecosystemEnabled: config.ecosystemEnabled
    };
    return issueConfiguration;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4879c8539a0d2065$export$2e2bcd8739ae039 = (state = $4879c8539a0d2065$var$getInitialState(), action)=>{
    // noinspection JSUnreachableSwitchBranches
    switch(action.type){
        case 0, $ePSh2.SET_CONTEXT:
            {
                const { payload: context } = action;
                return {
                    ...state,
                    ...context
                };
            }
        case 0, $1OJS4.LOAD_NEW_ISSUE:
            return {
                ...state,
                issueKey: action.payload.issueKey
            };
        case 0, $g2ZFU.LOGIN_SUCCESSFUL:
            return {
                ...state,
                // @ts-expect-error - TS2339 - Property 'accountId' does not exist on type '{ issueKey: string; } | { username?: string | undefined; accountId: string; }'.
                atlassianAccountId: action.payload.accountId
            };
        case 0, $fgekC.PREVIEW_DATA_FETCHED:
            {
                const { payload: issue } = action;
                // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Issue | { issueKey: string; }'. | TS2339 - Property 'fields' does not exist on type 'Issue | { issueKey: string; }'.
                if (issue && issue.id && issue.fields.has('project')) {
                    // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Issue | { issueKey: string; }'.
                    const { id: issueId } = issue;
                    // @ts-expect-error - TS2339 - Property 'fields' does not exist on type 'Issue | { issueKey: string; }'.
                    const projectConfig = issue.fields.get('project').value;
                    return $4879c8539a0d2065$var$getConfiguration({
                        state: state,
                        projectConfig: projectConfig,
                        issueId: (0, $6vrw7.toIssueId)(issueId)
                    });
                }
                return state;
            }
        case 0, $fYteL.REFRESH_ISSUE_SUCCESS:
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
            {
                // @ts-expect-error - TS2339 - Property 'project' does not exist on type '{ issueKey: string; }'.
                const projectConfig = action.payload.project;
                // @ts-expect-error - TS2339 - Property 'issue' does not exist on type '{ issueKey: string; }'.
                const issueId = action.payload.issue.id;
                return $4879c8539a0d2065$var$getConfiguration({
                    state: state,
                    projectConfig: projectConfig,
                    issueId: issueId
                });
            }
        default:
            return state;
    }
};

});
parcelRegister("g2ZFU", function(module, exports) {

$parcel$export(module.exports, "LOGIN", () => $f8e74f05a7b44b36$export$eed606b4351295d7);
$parcel$export(module.exports, "login", () => $f8e74f05a7b44b36$export$596d806903d1f59e);
$parcel$export(module.exports, "LOGIN_SUCCESSFUL", () => $f8e74f05a7b44b36$export$5437c9435f8861f0);
$parcel$export(module.exports, "loginSuccessful", () => $f8e74f05a7b44b36$export$288796bcd1d64e5);
const $f8e74f05a7b44b36$export$eed606b4351295d7 = 'LOGIN';
const $f8e74f05a7b44b36$export$596d806903d1f59e = ()=>({
        type: $f8e74f05a7b44b36$export$eed606b4351295d7
    });
const $f8e74f05a7b44b36$export$5437c9435f8861f0 = 'LOGIN_SUCCESSFUL';
const $f8e74f05a7b44b36$export$288796bcd1d64e5 = (payload)=>({
        type: $f8e74f05a7b44b36$export$5437c9435f8861f0,
        payload: payload
    });

});


parcelRegister("ji4ic", function(module, exports) {

$parcel$export(module.exports, "default", () => $43c0bb6cd74d104b$export$2e2bcd8739ae039);

var $7Vbpp = parcelRequire("7Vbpp");

var $gZSrt = parcelRequire("gZSrt");
const $43c0bb6cd74d104b$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$43c0bb6cd74d104b$export$2e2bcd8739ae039 = (state = $43c0bb6cd74d104b$var$initialState, action)=>{
    switch(action.type){
        case 0, $gZSrt.LOAD_DRAFT_SUCCESS:
            return {
                ...state,
                [action.payload.fieldId]: true
            };
        case 0, $gZSrt.SAVE_DRAFT_REQUEST:
            return {
                ...state,
                [action.payload.fieldId]: !(0, $7Vbpp.isOnlyWhitespaceAdf)(action.payload.value)
            };
        case 0, $gZSrt.DELETE_DRAFT_SUCCESS:
            return {
                ...state,
                [action.payload.fieldId]: false
            };
        default:
            return state;
    }
};

});
parcelRegister("7Vbpp", function(module, exports) {

$parcel$export(module.exports, "emptyAdfObject", () => $e11eab7652408d68$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $e11eab7652408d68$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $e11eab7652408d68$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $e11eab7652408d68$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $e11eab7652408d68$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $e11eab7652408d68$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $e11eab7652408d68$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasMediaFileNodes", () => $e11eab7652408d68$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $e11eab7652408d68$export$80a6e90c7b29d88c);

var $12nnS = parcelRequire("12nnS");
var $fkCu1 = parcelRequire("fkCu1");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");
const $e11eab7652408d68$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $e11eab7652408d68$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if ((0, $1ybV0.ff)('issue.details.media-inline') && adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($e11eab7652408d68$export$9e9311e676291037)
    };
    return adf;
};
const $e11eab7652408d68$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $e11eab7652408d68$export$9e9311e676291037(JSON.parse(adf));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $e11eab7652408d68$export$9e9311e676291037(adf);
};
const $e11eab7652408d68$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $e11eab7652408d68$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $e11eab7652408d68$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $e11eab7652408d68$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $e11eab7652408d68$export$def86d25f0c7f0bc = (adf)=>$e11eab7652408d68$export$cf4bde415465976c(adf) ? $e11eab7652408d68$export$202742e99f678c60 : adf;
const $e11eab7652408d68$export$9a632b58fb9b287c = (doc)=>{
    if ((0, $1ybV0.ff)('issue.details.media-inline')) {
        const mediaNodes = new Map();
        (0, $fkCu1.traverse)(doc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                mediaNodes.set(mediaNode.attrs.id, node);
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                mediaNodes.set(mediaInlineNode.attrs.id, node);
            }
        });
        return mediaNodes.size > 0;
    }
    const mediaNodes = new Map();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $fkCu1.traverse)(doc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            mediaNodes.set(node.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $e11eab7652408d68$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    if ((0, $1ybV0.ff)('issue.details.media-inline')) {
        const currentMediaNodes = new Set();
        const newMediaNodes = new Set();
        const updatedMediaNodes = new Set();
        if (newDoc) (0, $fkCu1.traverse)(newDoc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                newMediaNodes.add(mediaNode.attrs.id);
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                newMediaNodes.add(mediaInlineNode.attrs.id);
            }
        });
        if (currentDoc) (0, $fkCu1.traverse)(currentDoc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                currentMediaNodes.add(mediaNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
                }
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                currentMediaNodes.add(mediaInlineNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
                }
            }
        });
        return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
    }
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $fkCu1.traverse)(newDoc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            newMediaNodes.add(node.attrs.id);
        }
    });
    if (currentDoc) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $fkCu1.traverse)(currentDoc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            currentMediaNodes.add(node.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(node.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(node.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $e11eab7652408d68$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $12nnS.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $e11eab7652408d68$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await Promise.resolve((parcelRequire("9wcjJ")));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await (parcelRequire("3Scyi"));
    const { JSONTransformer: JSONTransformer } = await Promise.resolve((parcelRequire("8450v")));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("12nnS", function(module, exports) {

$parcel$export(module.exports, "filter", () => $0c181df1ea52b965$export$3dea766d36a8935f);

var $fkCu1 = parcelRequire("fkCu1");
function $0c181df1ea52b965$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $fkCu1.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});



parcelRegister("2M6VW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a88372eebb04647$export$2e2bcd8739ae039);

var $3e5wZ = parcelRequire("3e5wZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5a88372eebb04647$export$2e2bcd8739ae039 = (state = null, action)=>{
    switch(action.type){
        case 0, $3e5wZ.ECOSYSTEM_SHOW_GLANCE:
            return action.payload;
        default:
            return state;
    }
};

});
parcelRegister("3e5wZ", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_SHOW_GLANCE", () => $00ba079a81b6accc$export$900dbd3f5e66e17);
$parcel$export(module.exports, "ecosystemShowGlance", () => $00ba079a81b6accc$export$712e68a879bb453a);
// ECOSYSTEM_SHOW_GLANCE
const $00ba079a81b6accc$export$900dbd3f5e66e17 = 'ECOSYSTEM_SHOW_GLANCE';
const $00ba079a81b6accc$export$712e68a879bb453a = (appKey, moduleKey)=>({
        type: $00ba079a81b6accc$export$900dbd3f5e66e17,
        payload: {
            appKey: appKey,
            moduleKey: moduleKey
        }
    });

});


parcelRegister("4nslA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f05543c2353f6c73$export$2e2bcd8739ae039);

var $8s4GF = parcelRequire("8s4GF");
var $f05543c2353f6c73$export$2e2bcd8739ae039 = (0, $8s4GF.default);

});
parcelRegister("8s4GF", function(module, exports) {

$parcel$export(module.exports, "default", () => $43b2622cf1376bec$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $kFGm5 = parcelRequire("kFGm5");

var $h9cCP = parcelRequire("h9cCP");

var $1dO2y = parcelRequire("1dO2y");

var $hU5kA = parcelRequire("hU5kA");

var $2W4Cf = parcelRequire("2W4Cf");

var $ltjPP = parcelRequire("ltjPP");

var $hHnBv = parcelRequire("hHnBv");

var $lkPj1 = parcelRequire("lkPj1");

var $j8N3l = parcelRequire("j8N3l");

var $a0Zgz = parcelRequire("a0Zgz");

var $fYteL = parcelRequire("fYteL");

var $9RIuy = parcelRequire("9RIuy");

var $esi6T = parcelRequire("esi6T");

var $fxkZI = parcelRequire("fxkZI");

var $kyzGa = parcelRequire("kyzGa");

var $9KzUz = parcelRequire("9KzUz");

var $af7kH = parcelRequire("af7kH");

var $kPUWr = parcelRequire("kPUWr");

var $k8iGR = parcelRequire("k8iGR");

var $ajYsJ = parcelRequire("ajYsJ");

var $7JIbn = parcelRequire("7JIbn");

var $liv2Q = parcelRequire("liv2Q");

var $bdkx5 = parcelRequire("bdkx5");

var $kEMXz = parcelRequire("kEMXz");

var $cEXKk = parcelRequire("cEXKk");

var $c8oPZ = parcelRequire("c8oPZ");

var $eu3hL = parcelRequire("eu3hL");
const $43b2622cf1376bec$export$d4c72bab9d6cc13a = (0, $6HC1D.freeze)({
    users: {},
    ecosystem: (0, $kPUWr.initialStateOld),
    forge: (0, $k8iGR.initialState),
    issueLinks: (0, $7JIbn.initialState),
    issueTypes: (0, $bdkx5.initialState),
    issueContentPanels: (0, $ajYsJ.initialState),
    issueRemoteData: (0, $liv2Q.initialState),
    permissions: (0, $hU5kA.noPermissions),
    comments: (0, $fxkZI.initialState),
    totalComments: 0,
    commentsStartIndex: 0,
    loadedComments: 0,
    confluencePages: (0, $9KzUz.initialState),
    confluenceWhiteboards: (0, $af7kH.initialState),
    webLinks: (0, $c8oPZ.initialState),
    subtasks: [],
    cardCover: (0, $esi6T.initialState),
    childrenIssues: [],
    parentIssue: null,
    parentLevelIssues: [],
    refreshedOn: 0,
    requestPanelMetadata: {
        channel: undefined,
        requestUrl: ''
    },
    worklog: (0, $eu3hL.initialState),
    confluenceAppLinks: (0, $kyzGa.initialState),
    remoteIssueLinks: (0, $cEXKk.initialState),
    jiraAppLinks: (0, $kEMXz.initialState),
    issue: null,
    jiraSettings: {
        subtasksConfiguration: {
            enabled: true
        },
        issueLinkTypes: [],
        timeTrackingConfiguration: {
            isTimeTrackingEnabled: false,
            daysPerWeek: 0,
            hoursPerDay: 0,
            // Possible values for defaultUnit can be: minute, hour, day, and week.
            defaultUnit: (0, $h9cCP.MINUTE)
        }
    }
});
const $43b2622cf1376bec$var$omitFieldsHandledByChildReducers = (payload, extraFieldsToOmit = [])=>// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(payload, [
        ...extraFieldsToOmit,
        'forgeIssueProperties'
    ]);
const $43b2622cf1376bec$var$reducerHelper = (state, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
            {
                const mergedState = (0, $6HC1D.merge)(state, $43b2622cf1376bec$var$omitFieldsHandledByChildReducers(payload, [
                    'issueContentPanels',
                    'issueTypes'
                ]));
                return (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(mergedState, // @ts-expect-error TS2769: No overload matches this call.
                [
                    // These keys should not appear inside the entities state, but exist inside the action payload
                    [
                        'issue',
                        'fields'
                    ],
                    [
                        'issue',
                        'contextItemsCategories'
                    ],
                    [
                        'issue',
                        'contentItemsCategories'
                    ],
                    'changeboardingLastInteracted',
                    'licensedProducts',
                    'licenseStates'
                ]);
            }
        case 0, $9RIuy.FETCH_SCREENID_SUCCESS:
            return (0, $6HC1D.merge)(state, payload);
        case 0, $lkPj1.FETCH_MORE_COMMENTS_SUCCESS:
            return (0, $6HC1D.merge)(state, payload);
        case 0, $lkPj1.FETCH_SORTED_COMMENTS_SUCCESS:
            {
                const { comments: comments, commentsStartIndex: commentsStartIndex, loadedComments: loadedComments, totalComments: totalComments } = payload;
                let newState = (0, $6HC1D.chain)(state).setIn([
                    'comments'
                ], comments).setIn([
                    'commentsStartIndex'
                ], commentsStartIndex).setIn([
                    'loadedComments'
                ], loadedComments).setIn([
                    'totalComments'
                ], totalComments).value();
                if (payload.users) newState = (0, $6HC1D.set)(newState, 'users', (0, $6HC1D.merge)(state.users, payload.users));
                return newState;
            }
        case 0, $fYteL.REFRESH_ISSUE_SUCCESS:
            {
                const actionPayload = $43b2622cf1376bec$var$omitFieldsHandledByChildReducers(payload);
                const refreshedState = Object.keys(actionPayload).reduce((updatedState, key)=>{
                    // HOT-85509 users in payload should not overwrite the existing users.
                    if (key === 'users') // merge users from payload into state.users
                    return (0, $6HC1D.set)(updatedState, 'users', (0, $6HC1D.merge)(state.users, actionPayload.users));
                    if (key === 'issueTypes') return updatedState;
                    // We do nothing when it comes to the following keys, because they should be handled by their own reducer.
                    if (key === 'issueLinks' || key === 'issueContentPanels') return updatedState;
                    return (0, $6HC1D.set)(updatedState, key, actionPayload[key]);
                }, state);
                return (0, $6HC1D.setIn)(refreshedState, [
                    'refreshedOn'
                ], Date.now());
            }
        case 0, $a0Zgz.FETCH_LOGGED_IN_USER_SUCCESS:
            {
                const { user: user } = payload;
                const userKey = user.id;
                const users = {
                    ...state.users
                };
                if (userKey && user.id && !users[user.id]) users[user.id] = user;
                return {
                    ...state,
                    users: users
                };
            }
        case 0, $lkPj1.SAVE_COMMENT_SUCCESS:
            if (!payload.isNewComment) return state;
            return (0, $6HC1D.chain)(state).setIn([
                'loadedComments'
            ], state.loadedComments + 1).setIn([
                'totalComments'
            ], state.totalComments + 1).value();
        case 0, $lkPj1.DELETE_COMMENT_SUCCESS:
            return (0, $6HC1D.chain)(state).setIn([
                'loadedComments'
            ], state.loadedComments - 1).setIn([
                'totalComments'
            ], state.totalComments - 1).value();
        case 0, $j8N3l.REQUEST_PANEL_METADATA_FETCH_SUCCESS:
            {
                const newState = (0, $1dO2y.default)(state, [
                    'requestPanelMetadata'
                ]);
                return (0, $6HC1D.setIn)(newState, [
                    'requestPanelMetadata'
                ], payload);
            }
        case 0, $ltjPP.PROJECT_ISSUE_TYPES_REQUEST_SUCCESS:
            return (0, $6HC1D.setIn)(state, [
                'project',
                'issueTypes'
            ], payload);
        case 0, $2W4Cf.FETCH_ISSUE_PARENTS_SUCCESS:
            return (0, $6HC1D.setIn)(state, [
                'parentLevelIssues'
            ], payload);
        case 0, $2W4Cf.FETCH_ISSUE_PARENTS_WITH_INFO_SUCCESS:
            return (0, $6HC1D.setIn)(state, [
                'parentLevelIssues'
            ], payload.candidates);
        case 0, $2W4Cf.SET_PARENT_SUCCESS:
            {
                const { issueType: issueType, ...rest } = action.payload.parentIssue;
                const { name: name, iconUrl: iconUrl } = issueType || {};
                const parentIssue = {
                    ...rest,
                    issueTypeName: name || '',
                    issueTypeIconUrl: iconUrl || ''
                };
                return (0, $6HC1D.setIn)(state, [
                    'parentIssue'
                ], parentIssue);
            }
        case 0, $2W4Cf.UNSET_PARENT_SUCCESS:
            return (0, $6HC1D.setIn)(state, [
                'parentIssue'
            ], null);
        case 0, $hHnBv.CHILD_ISSUE_ADD_SUCCESS:
            {
                const { payload: { childIssue: childIssue } } = action;
                // The inner store manages loading states
                childIssue.isLoading = undefined;
                const newChildren = JSON.parse(JSON.stringify(state.childrenIssues));
                newChildren.push(childIssue);
                return (0, $6HC1D.setIn)(state, [
                    'childrenIssues'
                ], newChildren);
            }
        case 0, $hHnBv.SUBTASK_ADD_SUCCESS:
            {
                const { payload: { childIssue: childIssue } } = action;
                const newSubtasks = JSON.parse(JSON.stringify(state.subtasks));
                newSubtasks.push(childIssue);
                return (0, $6HC1D.setIn)(state, [
                    'subtasks'
                ], newSubtasks);
            }
        default:
            return state;
    }
};
const $43b2622cf1376bec$var$getFeatureFlaggedState = (state)=>{
    // if we have state the reducer has already initialised the state
    if (state) return state;
    // each feature flagged state should populate this state object
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const featureFlaggedState = {};
    // use the initial state from the issue types reducer
    Object.assign(featureFlaggedState, {
        issueTypes: (0, $bdkx5.initialState)
    });
    return {
        ...$43b2622cf1376bec$export$d4c72bab9d6cc13a,
        ...featureFlaggedState
    };
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$43b2622cf1376bec$export$2e2bcd8739ae039 = (stateFromParams, action)=>{
    const state = $43b2622cf1376bec$var$getFeatureFlaggedState(stateFromParams);
    // This is done to prevent the reducer logic from getting any more bloated
    // with switch cases. An eng-health task to refactor this file exists at BENTO-987.
    let newState = (0, $6HC1D.chain)(state).set('cardCover', (0, $esi6T.default)(state.cardCover, action)).set('comments', (0, $fxkZI.default)(state.comments, action)).set('confluencePages', (0, $9KzUz.default)(state.confluencePages, action)).set('confluenceWhiteboards', (0, $af7kH.default)(state.confluenceWhiteboards, action)).set('issueLinks', (0, $7JIbn.default)(state.issueLinks, action)).set('ecosystem', (0, $kPUWr.default)(state.ecosystem, action)).set('forge', (0, $k8iGR.default)(state.forge, action)).set('confluenceAppLinks', (0, $kyzGa.default)(state.confluenceAppLinks, action)).set('issueContentPanels', (0, $ajYsJ.default)(state.issueContentPanels, action)).set('issueTypes', (0, $bdkx5.default)(state.issueTypes, action)).set('webLinks', (0, $c8oPZ.default)(state.webLinks, action)).value();
    newState = (0, $6HC1D.set)(newState, 'remoteIssueLinks', (0, $cEXKk.default)(state.remoteIssueLinks, action));
    newState = (0, $6HC1D.set)(newState, 'jiraAppLinks', (0, $kEMXz.default)(state.jiraAppLinks, action));
    newState = (0, $6HC1D.set)(newState, 'worklog', (0, $eu3hL.default)(state.worklog, action));
    newState = (0, $6HC1D.set)(newState, 'issueRemoteData', (0, $liv2Q.default)(state.issueRemoteData, action));
    // TODO: use combineReducers once each segment of state has been decomposed.
    return $43b2622cf1376bec$var$reducerHelper(newState, action);
};

});
parcelRegister("j8N3l", function(module, exports) {

$parcel$export(module.exports, "FETCH_REQUEST_PANEL_METADATA", () => $855c63ba85e00cd4$export$ed89e5d28e185443);
$parcel$export(module.exports, "REQUEST_PANEL_METADATA_FETCH_SUCCESS", () => $855c63ba85e00cd4$export$b6629329729cb2e9);
$parcel$export(module.exports, "requestPanelMetadataFetchSuccess", () => $855c63ba85e00cd4$export$b2354c40098f8e6e);
$parcel$export(module.exports, "requestPanelMetadataFetchFailure", () => $855c63ba85e00cd4$export$6608297b4bce0453);

const $855c63ba85e00cd4$export$ed89e5d28e185443 = 'FETCH_REQUEST_PANEL_METADATA';
const $855c63ba85e00cd4$export$7efb2e5c38223b6c = ()=>({
        type: $855c63ba85e00cd4$export$ed89e5d28e185443
    });
const $855c63ba85e00cd4$export$b6629329729cb2e9 = 'REQUEST_PANEL_METADATA_FETCH_SUCCESS';
const $855c63ba85e00cd4$var$getRequestChannelType = (channelType)=>{
    switch(channelType){
        case 'portal':
            return 0, $1550833b430494ec$export$84bc97b21fdd244a;
        case 'email':
            return 0, $1550833b430494ec$export$4585842137473138;
        case 'api':
            return 0, $1550833b430494ec$export$4221b5488b9ec9e2;
        case 'jira':
            return 0, $1550833b430494ec$export$5703a142d9933f80;
        case 'deployment':
            return 0, $1550833b430494ec$export$a0e03e5ac5da1a54;
        case 'anonymousportal':
            return 0, $1550833b430494ec$export$c476c51e0e2873a1;
        default:
            return 0, $1550833b430494ec$export$f514fbacb1abd1bc;
    }
};
const $855c63ba85e00cd4$export$b2354c40098f8e6e = (metadata)=>({
        type: $855c63ba85e00cd4$export$b6629329729cb2e9,
        payload: {
            channel: $855c63ba85e00cd4$var$getRequestChannelType(metadata.channel),
            requestUrl: metadata.requestUrl,
            csatComment: metadata.csatComment
        }
    });
const $855c63ba85e00cd4$export$b06f209ca637dd05 = 'REQUEST_PANEL_METADATA_FETCH_FAILURE';
const $855c63ba85e00cd4$export$6608297b4bce0453 = ()=>({
        type: $855c63ba85e00cd4$export$b06f209ca637dd05
    });

});
const $1550833b430494ec$export$84bc97b21fdd244a = 'portal';
const $1550833b430494ec$export$4585842137473138 = 'email';
const $1550833b430494ec$export$4221b5488b9ec9e2 = 'api';
const $1550833b430494ec$export$5703a142d9933f80 = 'jira';
const $1550833b430494ec$export$a0e03e5ac5da1a54 = 'deployment';
const $1550833b430494ec$export$c476c51e0e2873a1 = 'anonymousportal';
const $1550833b430494ec$export$f514fbacb1abd1bc = 'unknown';


parcelRegister("esi6T", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $946ebd8e1418aa5a$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $946ebd8e1418aa5a$export$2e2bcd8739ae039);

var $lSVfs = parcelRequire("lSVfs");
const $946ebd8e1418aa5a$export$d4c72bab9d6cc13a = {
    isEnabled: false,
    attachmentId: null,
    availableAttachmentIds: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$946ebd8e1418aa5a$export$2e2bcd8739ae039 = (state = $946ebd8e1418aa5a$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $lSVfs.CARD_COVER_FETCH_SUCCESS:
            return action.payload.cardCover;
        case 0, $lSVfs.CARD_COVER_UPDATE_REQUEST:
        case 0, $lSVfs.CARD_COVER_UPDATE_FAILURE:
            return {
                ...state,
                attachmentId: action.payload.attachmentId
            };
        default:
            return state;
    }
};

});
parcelRegister("lSVfs", function(module, exports) {

$parcel$export(module.exports, "CARD_COVER_FETCH_SUCCESS", () => $c4e7a45bc9c23035$export$1a8ffb2064e20d95);
$parcel$export(module.exports, "cardCoverFetchSuccess", () => $c4e7a45bc9c23035$export$a850781df5380552);
$parcel$export(module.exports, "cardCoverFetchFailure", () => $c4e7a45bc9c23035$export$f6f140fd655f0d7d);
$parcel$export(module.exports, "CARD_COVER_UPDATE_REQUEST", () => $c4e7a45bc9c23035$export$4f5709d75390f17d);
$parcel$export(module.exports, "cardCoverUpdateRequest", () => $c4e7a45bc9c23035$export$f73c1ba4e6d1e736);
$parcel$export(module.exports, "cardCoverUpdateSuccess", () => $c4e7a45bc9c23035$export$f4db3b07ccb99907);
$parcel$export(module.exports, "CARD_COVER_UPDATE_FAILURE", () => $c4e7a45bc9c23035$export$98088e2265cbf87e);
$parcel$export(module.exports, "cardCoverUpdateFailure", () => $c4e7a45bc9c23035$export$52f78556422042dd);
const $c4e7a45bc9c23035$export$1a8ffb2064e20d95 = 'CARD_COVER_FETCH_SUCCESS';
const $c4e7a45bc9c23035$export$a850781df5380552 = (cardCover)=>({
        type: $c4e7a45bc9c23035$export$1a8ffb2064e20d95,
        payload: {
            cardCover: cardCover
        }
    });
const $c4e7a45bc9c23035$export$90930f03b510259a = 'CARD_COVER_FETCH_FAILURE';
const $c4e7a45bc9c23035$export$f6f140fd655f0d7d = ()=>({
        type: $c4e7a45bc9c23035$export$90930f03b510259a
    });
const $c4e7a45bc9c23035$export$4f5709d75390f17d = 'CARD_COVER_UPDATE_REQUEST';
const $c4e7a45bc9c23035$export$f73c1ba4e6d1e736 = (currentAttachmentId, attachmentId)=>({
        type: $c4e7a45bc9c23035$export$4f5709d75390f17d,
        payload: {
            currentAttachmentId: currentAttachmentId,
            attachmentId: attachmentId
        }
    });
const $c4e7a45bc9c23035$export$16ef8ec7168403da = 'CARD_COVER_UPDATE_SUCCESS';
const $c4e7a45bc9c23035$export$f4db3b07ccb99907 = ()=>({
        type: $c4e7a45bc9c23035$export$16ef8ec7168403da
    });
const $c4e7a45bc9c23035$export$98088e2265cbf87e = 'CARD_COVER_UPDATE_FAILURE';
const $c4e7a45bc9c23035$export$52f78556422042dd = (attachmentId)=>({
        type: $c4e7a45bc9c23035$export$98088e2265cbf87e,
        payload: {
            attachmentId: attachmentId
        }
    });

});


parcelRegister("fxkZI", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $2fea0734705c90da$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $2fea0734705c90da$export$2e2bcd8739ae039);

var $lkPj1 = parcelRequire("lkPj1");
const $2fea0734705c90da$export$d4c72bab9d6cc13a = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2fea0734705c90da$export$2e2bcd8739ae039 = (state = $2fea0734705c90da$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $lkPj1.SAVE_COMMENT_SUCCESS:
            {
                const { comment: comment } = action.payload;
                // @ts-expect-error - TS2322 - Type '{ [x: string]: Comment | undefined; }' is not assignable to type 'Partial<Record<string, PersistedComment>>'.
                return {
                    ...state,
                    [comment.id]: comment
                };
            }
        case 0, $lkPj1.DELETE_COMMENT_SUCCESS:
            {
                const nextState = {
                    ...state
                };
                delete nextState[action.payload.id];
                return nextState;
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("kyzGa", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $8203367d16c3ccb6$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $8203367d16c3ccb6$export$2e2bcd8739ae039);

var $f62OU = parcelRequire("f62OU");
const $8203367d16c3ccb6$export$d4c72bab9d6cc13a = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8203367d16c3ccb6$export$2e2bcd8739ae039 = (state = $8203367d16c3ccb6$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $f62OU.FETCH_CONFLUENCE_APP_LINKS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};

});
parcelRegister("f62OU", function(module, exports) {

$parcel$export(module.exports, "FETCH_CONFLUENCE_APP_LINKS_REQUEST", () => $fa02e5135e83943b$export$e530df45935c778c);
$parcel$export(module.exports, "fetchConfluenceAppLinks", () => $fa02e5135e83943b$export$411bec8e101d37ea);
$parcel$export(module.exports, "FETCH_CONFLUENCE_APP_LINKS_SUCCESS", () => $fa02e5135e83943b$export$ca6a901d6e743b37);
$parcel$export(module.exports, "fetchConfluenceAppLinksSuccess", () => $fa02e5135e83943b$export$c66a55d7442efcdf);
$parcel$export(module.exports, "fetchConfluenceAppLinksFailed", () => $fa02e5135e83943b$export$e4d0b5bab9e77fcc);
// FETCH_CONFLUENCE_APP_LINKS_REQUEST
const $fa02e5135e83943b$export$e530df45935c778c = 'FETCH_CONFLUENCE_APP_LINKS_REQUEST';
const $fa02e5135e83943b$export$411bec8e101d37ea = ()=>({
        type: $fa02e5135e83943b$export$e530df45935c778c
    });
const $fa02e5135e83943b$export$ca6a901d6e743b37 = 'FETCH_CONFLUENCE_APP_LINKS_SUCCESS';
const $fa02e5135e83943b$export$c66a55d7442efcdf = (response)=>({
        type: $fa02e5135e83943b$export$ca6a901d6e743b37,
        payload: response.applicationLinks
    });
const $fa02e5135e83943b$export$600975ac1685b720 = 'FETCH_CONFLUENCE_APP_LINKS_FAILED';
const $fa02e5135e83943b$export$e4d0b5bab9e77fcc = ()=>({
        type: $fa02e5135e83943b$export$600975ac1685b720
    });

});


parcelRegister("9KzUz", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $9ccd7a4157587a2c$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $9ccd7a4157587a2c$export$2e2bcd8739ae039);

var $ezsJz = parcelRequire("ezsJz");

var $8dloj = parcelRequire("8dloj");

var $6ySNE = parcelRequire("6ySNE");

var $5nezI = parcelRequire("5nezI");

var $fgekC = parcelRequire("fgekC");
const $9ccd7a4157587a2c$export$d4c72bab9d6cc13a = {
    isLinkingEnabled: true,
    createLinkedPage: {
        clickedCount: 0,
        isLoading: false,
        isInvalid: false,
        errorMessage: '',
        repairLink: undefined
    },
    linkedPages: {
        pages: [],
        pageCount: 0
    },
    mentionedPages: {
        pages: [],
        pageCount: 0
    }
};
const $9ccd7a4157587a2c$var$PAGE_KEYS = [
    'linkedPages',
    'mentionedPages'
];
const $9ccd7a4157587a2c$var$removePageFromConfluencePages = (state, idToRemove)=>$9ccd7a4157587a2c$var$PAGE_KEYS.reduce((pagesMap, key)=>{
        const { pages: pages } = pagesMap[key];
        const filteredPages = (0, (/*@__PURE__*/$parcel$interopDefault($ezsJz)))(pages, (page)=>{
            // @ts-expect-error - TS2339 - Property 'link' does not exist on type 'FailedRemoteLink | ConfluencePage'. | TS2339 - Property 'link' does not exist on type 'FailedRemoteLink | ConfluencePage'. | TS2339 - Property 'globalId' does not exist on type 'FailedRemoteLink | ConfluencePage'.
            const globalId = page.link ? page.link.globalId : page.globalId;
            return globalId !== idToRemove;
        });
        return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...pagesMap,
            [key]: {
                pageCount: filteredPages.length,
                pages: filteredPages
            }
        };
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(state, $9ccd7a4157587a2c$var$PAGE_KEYS));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9ccd7a4157587a2c$export$2e2bcd8739ae039 = (state = $9ccd7a4157587a2c$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $5nezI.FETCH_ISSUE_REMOTE_DATA_SUCCESS:
            {
                const { remoteLinks: remoteLinks } = action.payload;
                const pages = (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(remoteLinks.confluencePages, $9ccd7a4157587a2c$var$PAGE_KEYS);
                const nextState = {
                    ...state,
                    ...pages,
                    createLinkedPage: {
                        ...state.createLinkedPage,
                        isLoading: false,
                        isInvalid: false,
                        errorMessage: '',
                        repairLink: undefined
                    }
                };
                return {
                    ...nextState,
                    isLinkingEnabled: !!remoteLinks.isLinkingEnabled
                };
            }
        case 0, $fgekC.PREVIEW_DATA_FETCHED:
            {
                const { remoteLinks: remoteLinks } = action.payload;
                if (remoteLinks && remoteLinks.confluencePages) {
                    const { linkedPages: linkedPages, mentionedPages: mentionedPages } = remoteLinks.confluencePages;
                    return {
                        ...state,
                        linkedPages: {
                            ...state.linkedPages,
                            pageCount: linkedPages.pageCount
                        },
                        mentionedPages: {
                            ...state.mentionedPages,
                            pageCount: mentionedPages.pageCount
                        }
                    };
                }
                return state;
            }
        case 0, $6ySNE.DELETE_CONFLUENCE_PAGE_LINK_REQUEST:
            {
                const { globalId: globalId } = action.payload;
                const pages = $9ccd7a4157587a2c$var$removePageFromConfluencePages(state, globalId);
                return {
                    ...state,
                    ...pages
                };
            }
        case 0, $6ySNE.CREATE_CONFLUENCE_PAGE_LINK_REQUEST:
            return {
                ...state,
                createLinkedPage: {
                    ...state.createLinkedPage,
                    isLoading: true
                }
            };
        case 0, $6ySNE.CREATE_CONFLUENCE_PAGE_LINK_FAILED:
            {
                const { errorMessage: errorMessage } = action.payload;
                return {
                    ...state,
                    createLinkedPage: {
                        ...state.createLinkedPage,
                        errorMessage: errorMessage,
                        isLoading: false,
                        isInvalid: true,
                        ...typeof action.payload.repairLink === 'string' ? {
                            repairLink: action.payload.repairLink
                        } : undefined
                    }
                };
            }
        case 0, $6ySNE.CREATE_CONFLUENCE_PAGE_LINK_MODIFIED:
            return {
                ...state,
                createLinkedPage: {
                    ...state.createLinkedPage,
                    errorMessage: '',
                    isInvalid: false
                }
            };
        case 0, $6ySNE.LINK_CONFLUENCE_PAGE_CLOSED:
            return {
                ...state,
                createLinkedPage: $9ccd7a4157587a2c$export$d4c72bab9d6cc13a.createLinkedPage
            };
        case 0, $6ySNE.CREATE_CONFLUENCE_PAGE_LINK_SUCCESS:
            {
                const pages = state.linkedPages.pages || [];
                return {
                    ...state,
                    linkedPages: {
                        ...state.linkedPages,
                        pages: [
                            ...pages,
                            action.payload.confluencePageLink
                        ],
                        pageCount: state.linkedPages.pageCount + 1
                    },
                    createLinkedPage: {
                        ...state.createLinkedPage,
                        isLoading: false,
                        isInvalid: false,
                        errorMessage: '',
                        repairLink: undefined
                    }
                };
            }
        case 0, $6ySNE.LINK_CONFLUENCE_PAGE_CLICKED:
            return {
                ...state,
                createLinkedPage: {
                    ...state.createLinkedPage,
                    clickedCount: state.createLinkedPage.clickedCount + 1
                }
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("ezsJz", function(module, exports) {

var $904yO = parcelRequire("904yO");

var $9vvKC = parcelRequire("9vvKC");

var $7qARj = parcelRequire("7qARj");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $a9ba9f860705508e$var$filter(collection, predicate) {
    var func = $1c8hB(collection) ? $904yO : $9vvKC;
    return func(collection, $7qARj(predicate, 3));
}
module.exports = $a9ba9f860705508e$var$filter;

});
parcelRegister("9vvKC", function(module, exports) {

var $awetI = parcelRequire("awetI");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6ebfa35ee06f887f$var$baseFilter(collection, predicate) {
    var result = [];
    $awetI(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $6ebfa35ee06f887f$var$baseFilter;

});


parcelRegister("8dloj", function(module, exports) {

var $7Smv0 = parcelRequire("7Smv0");

var $224h2 = parcelRequire("224h2");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $5fb02174d73b0468$var$pick = $224h2(function(object, paths) {
    return object == null ? {} : $7Smv0(object, paths);
});
module.exports = $5fb02174d73b0468$var$pick;

});
parcelRegister("7Smv0", function(module, exports) {

var $h5G5y = parcelRequire("h5G5y");

var $cj1vT = parcelRequire("cj1vT");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $5bbf076b50457091$var$basePick(object, paths) {
    return $h5G5y(object, paths, function(value, path) {
        return $cj1vT(object, path);
    });
}
module.exports = $5bbf076b50457091$var$basePick;

});


parcelRegister("6ySNE", function(module, exports) {

$parcel$export(module.exports, "LINK_CONFLUENCE_PAGE_CLICKED", () => $a6509e226d0e01fa$export$15b8c418d79e088e);
$parcel$export(module.exports, "linkConfluencePageClicked", () => $a6509e226d0e01fa$export$8bf3d9b58a8ddd14);
$parcel$export(module.exports, "LINK_CONFLUENCE_PAGE_CLOSED", () => $a6509e226d0e01fa$export$efb1fc1e77edf42);
$parcel$export(module.exports, "linkConfluencePageClosed", () => $a6509e226d0e01fa$export$577f350ada8745d0);
$parcel$export(module.exports, "CREATE_CONFLUENCE_PAGE_LINK_MODIFIED", () => $a6509e226d0e01fa$export$4cda0004c076ee1a);
$parcel$export(module.exports, "createConfluencePageLinkModified", () => $a6509e226d0e01fa$export$260a283b46ed91e7);
$parcel$export(module.exports, "CREATE_CONFLUENCE_PAGE_LINK_REQUEST", () => $a6509e226d0e01fa$export$ded07df562c3ff8);
$parcel$export(module.exports, "createConfluencePageLinkRequest", () => $a6509e226d0e01fa$export$fb259ee5299f0823);
$parcel$export(module.exports, "CREATE_CONFLUENCE_PAGE_LINK_SUCCESS", () => $a6509e226d0e01fa$export$55d985d0353178b3);
$parcel$export(module.exports, "createConfluencePageLinkSuccess", () => $a6509e226d0e01fa$export$5736a64268e4330f);
$parcel$export(module.exports, "CREATE_CONFLUENCE_PAGE_LINK_FAILED", () => $a6509e226d0e01fa$export$2391012838d997b5);
$parcel$export(module.exports, "createConfluencePageLinkFailed", () => $a6509e226d0e01fa$export$e556566a2071225d);
$parcel$export(module.exports, "DELETE_CONFLUENCE_PAGE_LINK_REQUEST", () => $a6509e226d0e01fa$export$8b43afc09c8e27bc);
$parcel$export(module.exports, "deleteConfluencePageLinkRequest", () => $a6509e226d0e01fa$export$b869568022108b27);
$parcel$export(module.exports, "DELETE_CONFLUENCE_PAGE_LINK_SUCCESS", () => $a6509e226d0e01fa$export$6a70d03f932b3354);
$parcel$export(module.exports, "deleteConfluencePageLinkSuccess", () => $a6509e226d0e01fa$export$ca4aa79a84f78464);
$parcel$export(module.exports, "DELETE_CONFLUENCE_PAGE_LINK_FAILED", () => $a6509e226d0e01fa$export$67566c205c72838a);
$parcel$export(module.exports, "deleteConfluencePageLinkFailed", () => $a6509e226d0e01fa$export$4254406805946ea9);
const $a6509e226d0e01fa$export$15b8c418d79e088e = 'LINK_CONFLUENCE_PAGE_CLICKED';
const $a6509e226d0e01fa$export$8bf3d9b58a8ddd14 = ()=>({
        type: $a6509e226d0e01fa$export$15b8c418d79e088e
    });
const $a6509e226d0e01fa$export$efb1fc1e77edf42 = 'LINK_CONFLUENCE_PAGE_CLOSED';
const $a6509e226d0e01fa$export$577f350ada8745d0 = ()=>({
        type: $a6509e226d0e01fa$export$efb1fc1e77edf42
    });
const $a6509e226d0e01fa$export$4cda0004c076ee1a = 'CREATE_CONFLUENCE_PAGE_LINK_MODIFIED';
const $a6509e226d0e01fa$export$260a283b46ed91e7 = ()=>({
        type: $a6509e226d0e01fa$export$4cda0004c076ee1a
    });
const $a6509e226d0e01fa$export$ded07df562c3ff8 = 'CREATE_CONFLUENCE_PAGE_LINK_REQUEST';
const $a6509e226d0e01fa$export$fb259ee5299f0823 = (pageHref, analyticsEvent, triggerInviteExperiment)=>({
        type: $a6509e226d0e01fa$export$ded07df562c3ff8,
        payload: {
            pageHref: pageHref,
            triggerInviteExperiment: triggerInviteExperiment
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $a6509e226d0e01fa$export$55d985d0353178b3 = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $a6509e226d0e01fa$export$5736a64268e4330f = (confluencePageLink)=>({
        type: $a6509e226d0e01fa$export$55d985d0353178b3,
        payload: {
            confluencePageLink: confluencePageLink
        }
    });
const $a6509e226d0e01fa$export$2391012838d997b5 = 'CREATE_CONFLUENCE_PAGE_LINK_FAILED';
const $a6509e226d0e01fa$export$e556566a2071225d = (errorMessage, repairLink)=>({
        type: $a6509e226d0e01fa$export$2391012838d997b5,
        payload: {
            errorMessage: errorMessage,
            repairLink: repairLink
        }
    });
const $a6509e226d0e01fa$export$8b43afc09c8e27bc = 'DELETE_CONFLUENCE_PAGE_LINK_REQUEST';
const $a6509e226d0e01fa$export$b869568022108b27 = (globalId)=>({
        type: $a6509e226d0e01fa$export$8b43afc09c8e27bc,
        payload: {
            globalId: globalId
        }
    });
const $a6509e226d0e01fa$export$6a70d03f932b3354 = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $a6509e226d0e01fa$export$ca4aa79a84f78464 = ()=>({
        type: $a6509e226d0e01fa$export$6a70d03f932b3354
    });
const $a6509e226d0e01fa$export$67566c205c72838a = 'DELETE_CONFLUENCE_PAGE_LINK_FAILED';
const $a6509e226d0e01fa$export$4254406805946ea9 = ()=>({
        type: $a6509e226d0e01fa$export$67566c205c72838a
    });

});


parcelRegister("af7kH", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $c97a8bea8c2dc3c4$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $c97a8bea8c2dc3c4$export$2e2bcd8739ae039);

var $aMhhi = parcelRequire("aMhhi");

var $5nezI = parcelRequire("5nezI");
const $c97a8bea8c2dc3c4$export$d4c72bab9d6cc13a = {
    linkedWhiteboards: {
        whiteboards: [],
        whiteboardCount: 0
    },
    createLinkedWhiteboard: {
        isLoading: false
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c97a8bea8c2dc3c4$export$2e2bcd8739ae039 = (state = $c97a8bea8c2dc3c4$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $5nezI.FETCH_ISSUE_REMOTE_DATA_SUCCESS:
            {
                const { remoteLinks: remoteLinks } = action.payload;
                return {
                    ...state,
                    ...remoteLinks.confluenceWhiteboards
                };
            }
        case 0, $aMhhi.DELETE_CONFLUENCE_WHITEBOARD_LINK_SUCCESS:
            {
                const { id: id } = action.payload;
                const filteredWhiteboards = state.linkedWhiteboards.whiteboards?.filter((whiteboard)=>whiteboard.id !== id) ?? [];
                return {
                    ...state,
                    linkedWhiteboards: {
                        whiteboardCount: filteredWhiteboards.length,
                        whiteboards: filteredWhiteboards
                    }
                };
            }
        case 0, $aMhhi.FETCH_CONFLUENCE_WHITEBOARD_SUCCESS:
            {
                const { whiteboard: whiteboard } = action.payload;
                const newWhiteboardsArray = [
                    ...state.linkedWhiteboards?.whiteboards || [],
                    whiteboard
                ];
                return {
                    ...state,
                    linkedWhiteboards: {
                        whiteboardCount: newWhiteboardsArray.length,
                        whiteboards: newWhiteboardsArray
                    },
                    createLinkedWhiteboard: {
                        ...state.createLinkedWhiteboard,
                        isLoading: false
                    }
                };
            }
        case 0, $aMhhi.CONFLUENCE_WHITEBOARD_LINK_REQUEST:
            return {
                ...state,
                createLinkedWhiteboard: {
                    ...state.createLinkedWhiteboard,
                    isLoading: true
                }
            };
        case 0, $aMhhi.CONFLUENCE_WHITEBOARD_LINK_REQUEST_FAILED:
            return {
                ...state,
                createLinkedWhiteboard: {
                    ...state.createLinkedWhiteboard,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};

});
parcelRegister("aMhhi", function(module, exports) {

$parcel$export(module.exports, "DELETE_CONFLUENCE_WHITEBOARD_LINK_SUCCESS", () => $449e9573a7bf4109$export$3775781c31b5b8e2);
$parcel$export(module.exports, "deleteConfluenceWhiteboardLinkSuccess", () => $449e9573a7bf4109$export$37b0b9c57288f9a9);
$parcel$export(module.exports, "FETCH_CONFLUENCE_WHITEBOARD_SUCCESS", () => $449e9573a7bf4109$export$9241844b1f66ebd3);
$parcel$export(module.exports, "fetchConfluenceWhiteboardSuccess", () => $449e9573a7bf4109$export$c578f3dec0090572);
$parcel$export(module.exports, "CONFLUENCE_WHITEBOARD_LINK_REQUEST", () => $449e9573a7bf4109$export$ad6184468e2dbb59);
$parcel$export(module.exports, "confluenceWhiteboardLinkRequest", () => $449e9573a7bf4109$export$f6cd5eea8aec0132);
$parcel$export(module.exports, "CONFLUENCE_WHITEBOARD_LINK_REQUEST_FAILED", () => $449e9573a7bf4109$export$25901b5e45b540ec);
$parcel$export(module.exports, "confluenceWhiteboardLinkRequestFailed", () => $449e9573a7bf4109$export$97a59b18aa918d3c);
const $449e9573a7bf4109$export$3775781c31b5b8e2 = 'DELETE_CONFLUENCE_WHITEBOARD_LINK_SUCCESS';
const $449e9573a7bf4109$export$37b0b9c57288f9a9 = (id)=>({
        type: $449e9573a7bf4109$export$3775781c31b5b8e2,
        payload: {
            id: id
        }
    });
const $449e9573a7bf4109$export$9241844b1f66ebd3 = 'FETCH_CONFLUENCE_WHITEBOARD_SUCCESS';
const $449e9573a7bf4109$export$c578f3dec0090572 = (whiteboard)=>({
        type: $449e9573a7bf4109$export$9241844b1f66ebd3,
        payload: {
            whiteboard: whiteboard
        }
    });
const $449e9573a7bf4109$export$ad6184468e2dbb59 = 'CONFLUENCE_WHITEBOARD_LINK_REQUEST';
const $449e9573a7bf4109$export$f6cd5eea8aec0132 = ()=>({
        type: $449e9573a7bf4109$export$ad6184468e2dbb59
    });
const $449e9573a7bf4109$export$25901b5e45b540ec = 'CONFLUENCE_WHITEBOARD_LINK_REQUEST_FAILED';
const $449e9573a7bf4109$export$97a59b18aa918d3c = ()=>({
        type: $449e9573a7bf4109$export$25901b5e45b540ec
    });

});


parcelRegister("kPUWr", function(module, exports) {

$parcel$export(module.exports, "initialStateOld", () => $93794ece8834ba25$export$bdc645500b3eb162);
$parcel$export(module.exports, "default", () => $93794ece8834ba25$export$2e2bcd8739ae039);

var $bCaZl = parcelRequire("bCaZl");

var $fYteL = parcelRequire("fYteL");
const $93794ece8834ba25$export$d4c72bab9d6cc13a = {
    activityPanels: {},
    canInstallAddons: false,
    contentPanels: {},
    contextPanels: {},
    backgroundScripts: [],
    ecosystemOnDate: 0,
    glances: {}
};
const $93794ece8834ba25$export$bdc645500b3eb162 = {
    ...$93794ece8834ba25$export$d4c72bab9d6cc13a,
    operations: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$93794ece8834ba25$export$2e2bcd8739ae039 = (state = $93794ece8834ba25$export$bdc645500b3eb162, action)=>{
    switch(action.type){
        case 0, $bCaZl.CONTENT_PANEL_SELECTED:
            return {
                ...state,
                selectedContentPanel: action.payload
            };
        case 0, $bCaZl.CONTENT_PANEL_UNSELECT:
            return {
                ...state,
                selectedContentPanel: undefined
            };
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
            return {
                ...state,
                ...action.payload.ecosystem
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("bCaZl", function(module, exports) {

$parcel$export(module.exports, "ADD_CONTENT_PANEL_REQUEST", () => $3cfaa2ddc55e26c3$export$f863fd647ecdd44d);
$parcel$export(module.exports, "addContentPanelRequest", () => $3cfaa2ddc55e26c3$export$1c8fb49d7ba91388);
$parcel$export(module.exports, "ADD_CONTENT_PANEL_SUCCESS", () => $3cfaa2ddc55e26c3$export$103b3b44b517d5ae);
$parcel$export(module.exports, "addContentPanelSuccess", () => $3cfaa2ddc55e26c3$export$1841eb8183fb8b23);
$parcel$export(module.exports, "addContentPanelFailure", () => $3cfaa2ddc55e26c3$export$763a9da4b40ee278);
$parcel$export(module.exports, "REMOVE_CONTENT_PANEL_REQUEST", () => $3cfaa2ddc55e26c3$export$258e59a54657abdd);
$parcel$export(module.exports, "removeContentPanelRequest", () => $3cfaa2ddc55e26c3$export$c4900788239d3ecc);
$parcel$export(module.exports, "REMOVE_CONTENT_PANEL_SUCCESS", () => $3cfaa2ddc55e26c3$export$45c2883b58efeaa5);
$parcel$export(module.exports, "removeContentPanelSuccess", () => $3cfaa2ddc55e26c3$export$c137ef157cc9f69);
$parcel$export(module.exports, "removeContentPanelFailure", () => $3cfaa2ddc55e26c3$export$658d3eb6adb7cb58);
$parcel$export(module.exports, "CONTENT_PANEL_SELECTED", () => $3cfaa2ddc55e26c3$export$c4d0b07a1dfefccd);
$parcel$export(module.exports, "contentPanelSelected", () => $3cfaa2ddc55e26c3$export$ee81bb6e783c4e7a);
$parcel$export(module.exports, "CONTENT_PANEL_UNSELECT", () => $3cfaa2ddc55e26c3$export$1ea94ecbd83bcf0c);
$parcel$export(module.exports, "contentPanelUnselect", () => $3cfaa2ddc55e26c3$export$d29a5a284739e75b);
$parcel$export(module.exports, "CONTENT_PANELS_CUSTOMISED_REQUEST", () => $3cfaa2ddc55e26c3$export$f42e664ab66dcd36);
$parcel$export(module.exports, "CONTENT_PANELS_CUSTOMISED_SUCCESS", () => $3cfaa2ddc55e26c3$export$730645506f987898);
$parcel$export(module.exports, "contentPanelsCustomisedSuccess", () => $3cfaa2ddc55e26c3$export$2b9eec69435ccf30);
// ADD_CONTENT_PANEL_REQUEST
const $3cfaa2ddc55e26c3$export$f863fd647ecdd44d = 'ADD_CONTENT_PANEL_REQUEST';
const $3cfaa2ddc55e26c3$export$1c8fb49d7ba91388 = (addonModuleKey)=>({
        type: $3cfaa2ddc55e26c3$export$f863fd647ecdd44d,
        payload: addonModuleKey
    });
const $3cfaa2ddc55e26c3$export$103b3b44b517d5ae = 'ADD_CONTENT_PANEL_SUCCESS';
const $3cfaa2ddc55e26c3$export$1841eb8183fb8b23 = (addonModuleKey)=>({
        type: $3cfaa2ddc55e26c3$export$103b3b44b517d5ae,
        payload: addonModuleKey
    });
const $3cfaa2ddc55e26c3$export$6a439b558d6d775a = 'ADD_CONTENT_PANEL_FAILURE';
const $3cfaa2ddc55e26c3$export$763a9da4b40ee278 = (message)=>({
        type: $3cfaa2ddc55e26c3$export$6a439b558d6d775a,
        payload: message
    });
const $3cfaa2ddc55e26c3$export$258e59a54657abdd = 'REMOVE_CONTENT_PANEL_REQUEST';
const $3cfaa2ddc55e26c3$export$c4900788239d3ecc = (addonModuleKey)=>({
        type: $3cfaa2ddc55e26c3$export$258e59a54657abdd,
        payload: addonModuleKey
    });
const $3cfaa2ddc55e26c3$export$45c2883b58efeaa5 = 'REMOVE_CONTENT_PANEL_SUCCESS';
const $3cfaa2ddc55e26c3$export$c137ef157cc9f69 = (addonModuleKey)=>({
        type: $3cfaa2ddc55e26c3$export$45c2883b58efeaa5,
        payload: addonModuleKey
    });
const $3cfaa2ddc55e26c3$export$bdace0895a57e750 = 'REMOVE_CONTENT_PANEL_FAILURE';
const $3cfaa2ddc55e26c3$export$658d3eb6adb7cb58 = (message)=>({
        type: $3cfaa2ddc55e26c3$export$bdace0895a57e750,
        payload: message
    });
const $3cfaa2ddc55e26c3$export$c4d0b07a1dfefccd = 'CONTENT_PANEL_SELECTED';
const $3cfaa2ddc55e26c3$export$ee81bb6e783c4e7a = (addonModuleKey)=>({
        type: $3cfaa2ddc55e26c3$export$c4d0b07a1dfefccd,
        payload: addonModuleKey
    });
const $3cfaa2ddc55e26c3$export$1ea94ecbd83bcf0c = 'CONTENT_PANEL_UNSELECT';
const $3cfaa2ddc55e26c3$export$d29a5a284739e75b = (addonModuleKey)=>({
        type: $3cfaa2ddc55e26c3$export$1ea94ecbd83bcf0c,
        payload: addonModuleKey
    });
const $3cfaa2ddc55e26c3$export$f42e664ab66dcd36 = 'CONTENT_PANELS_CUSTOMISED_REQUEST';
const $3cfaa2ddc55e26c3$export$2c302ec752564fe0 = ()=>({
        type: $3cfaa2ddc55e26c3$export$f42e664ab66dcd36
    });
const $3cfaa2ddc55e26c3$export$730645506f987898 = 'CONTENT_PANELS_CUSTOMISED_SUCCESS';
const $3cfaa2ddc55e26c3$export$2b9eec69435ccf30 = ()=>({
        type: $3cfaa2ddc55e26c3$export$730645506f987898
    });

});


parcelRegister("ajYsJ", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $c135b29d0ac0a34c$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $c135b29d0ac0a34c$export$2e2bcd8739ae039);

var $bCaZl = parcelRequire("bCaZl");

var $fYteL = parcelRequire("fYteL");

const $c135b29d0ac0a34c$export$d4c72bab9d6cc13a = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c135b29d0ac0a34c$export$2e2bcd8739ae039 = (state = $c135b29d0ac0a34c$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
        case 0, $fYteL.REFRESH_ISSUE_SUCCESS:
            return action.payload.issueContentPanels || state;
        case 0, $bCaZl.ADD_CONTENT_PANEL_SUCCESS:
            return [
                ...state,
                action.payload
            ];
        case 0, $bCaZl.REMOVE_CONTENT_PANEL_SUCCESS:
            {
                const { payload: payload } = action;
                return state.filter((id)=>id !== payload);
            }
        case 0, $bCaZl.CONTENT_PANELS_CUSTOMISED_SUCCESS:
            return state.includes((0, $6c91ecd17276581e$export$bdafa6b589be8b30)) ? state : [
                ...state,
                (0, $6c91ecd17276581e$export$bdafa6b589be8b30)
            ];
        default:
            return state;
    }
};

});

parcelRegister("7JIbn", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $7b7d916f71c9b132$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $7b7d916f71c9b132$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $fUTZC = parcelRequire("fUTZC");

var $1dO2y = parcelRequire("1dO2y");

var $49xWy = parcelRequire("49xWy");

var $fYteL = parcelRequire("fYteL");
const $7b7d916f71c9b132$export$d4c72bab9d6cc13a = {
    issueLinks: {},
    linkedIssues: {},
    linkedIssueKeys: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7b7d916f71c9b132$export$2e2bcd8739ae039 = (state = $7b7d916f71c9b132$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $49xWy.FETCH_LINKED_ISSUES_SUCCESS:
            return (0, $6HC1D.merge)(state, {
                linkedIssues: action.payload
            });
        case 0, $49xWy.FETCH_LINKED_ISSUES_DATA_SUCCESS:
            {
                const { linkedIssues: linkedIssues, issueLinks: issueLinks, optimisticIds: optimisticIds } = action.payload;
                const newState = (0, $1dO2y.default)(state, [
                    'issueLinks',
                    optimisticIds
                ]);
                return (0, $6HC1D.chain)(newState).merge({
                    linkedIssues: linkedIssues
                }).merge(issueLinks).value();
            }
        case 0, $49xWy.SAVE_LINKED_ISSUE_REQUEST:
        case 0, $49xWy.SAVE_LINKED_ISSUE_REQUEST_WITHOUT_FETCH:
            {
                const { newIssueLinks: newIssueLinks } = action.payload;
                return (0, $6HC1D.chain)(state).merge(newIssueLinks.issueLinks).setIn([
                    'issueLinks',
                    newIssueLinks.optimisticId,
                    'isOptimistic'
                ], true).setIn([
                    'issueLinks',
                    newIssueLinks.optimisticId,
                    'isLoading'
                ], true).setIn([
                    'issueLinks',
                    newIssueLinks.optimisticId,
                    'hasError'
                ], false).setIn([
                    'issueLinks',
                    newIssueLinks.optimisticId,
                    'isSaved'
                ], false).value();
            }
        case 0, $49xWy.SAVE_LINKED_ISSUE_FAILURE:
            return (0, $6HC1D.chain)(state).setIn([
                'issueLinks',
                action.payload.optimisticId,
                'isLoading'
            ], false).setIn([
                'issueLinks',
                action.payload.optimisticId,
                'hasError'
            ], true).setIn([
                'issueLinks',
                action.payload.optimisticId,
                'error'
            ], action.payload.error).value();
        case 0, $49xWy.SAVE_LINKED_ISSUE_SUCCESS:
            return (0, $6HC1D.chain)(state).setIn([
                'issueLinks',
                action.payload.optimisticId,
                'isLoading'
            ], false).setIn([
                'issueLinks',
                action.payload.optimisticId,
                'isSaved'
            ], true).value();
        case 0, $49xWy.FETCH_LINKED_ISSUES_DATA_FAILURE:
            {
                let newState = state;
                action.payload.optimisticIds.forEach((optimisticId)=>{
                    newState = (0, $6HC1D.setIn)(newState, [
                        'issueLinks',
                        optimisticId,
                        'isLoading'
                    ], false);
                });
                return newState;
            }
        case 0, $49xWy.SAVE_LINKED_ISSUE_RETRY:
            return (0, $6HC1D.chain)(state).setIn([
                'issueLinks',
                action.payload.optimisticId,
                'isLoading'
            ], true).setIn([
                'issueLinks',
                action.payload.optimisticId,
                'hasError'
            ], false).value();
        case 0, $49xWy.DELETE_LINKED_ISSUE_REQUEST:
        case 0, $49xWy.DELETE_LINKED_ISSUE_REQUEST_WITHOUT_FETCH:
            {
                const newState = (0, $6HC1D.setIn)(state, [
                    'issueLinks',
                    action.payload.linkedIssueId,
                    'isDeleted'
                ], true);
                return (0, $1dO2y.default)(newState, [
                    'deleteModalLinkId'
                ]);
            }
        case 0, $49xWy.DELETE_LINKED_ISSUE_FAILURE:
            return (0, $6HC1D.setIn)(state, [
                'issueLinks',
                action.payload,
                'isDeleted'
            ], false);
        case 0, $49xWy.DELETE_LINKED_ISSUE_SUCCESS:
        case 0, $49xWy.SAVE_LINKED_ISSUE_CANCEL:
            return (0, $1dO2y.default)(state, [
                'issueLinks',
                action.payload
            ]);
        case 0, $49xWy.ADD_ISSUE_LINK_CLICKED:
            return (0, $6HC1D.chain)(state).setIn([
                'quickAddClicked'
            ], ((state || {}).quickAddClicked || 0) + 1).setIn([
                'quickAddClickedIssue'
            ], action.payload?.linkedIssue).setIn([
                'isOpenedFromJsmSimilarIssues'
            ], !!action.payload?.isOpenedFromJsmSimilarIssues).value();
        case 0, $49xWy.CLEAR_RELATED_ISSUE_LINK:
            return (0, $1dO2y.default)(state, [
                'quickAddClickedIssue'
            ]);
        case 0, $49xWy.ADD_ISSUE_LINK_CLOSED:
            return (0, $6HC1D.setIn)(state, [
                'quickAddClicked'
            ], 0);
        case 0, $49xWy.SET_CREATE_LINKED_ISSUE_PERMISSION:
            return (0, $6HC1D.setIn)(state, [
                'canCreateLinkedIssue'
            ], action.payload.canCreateLinkedIssue);
        case 0, $fYteL.REFRESH_ISSUE_SUCCESS:
            if (action.payload.issueLinks) {
                const refreshedState = action.payload.issueLinks;
                return (0, $6HC1D.chain)(refreshedState)// The refreshed state won't have the `canCreateLinkedIssue` permission available. We need to get it
                // from the current state.
                // TODO: Ideally, `canCreateLinkedIssue` should be returned from Graphql/1, so we also get it when issue
                //  is refreshed (https://jdog.jira-dev.com/browse/SHIELD-4307)
                .setIn([
                    'canCreateLinkedIssue'
                ], state.canCreateLinkedIssue)//  The refreshed state won't have the `quickAddClicked` property as it is UI state.
                //  Here we are ensuring that it is maintained through `REFRESH_ISSUE_SUCCESS`
                //  otherwise, the add issue link form will close, preventing the user from linking an issue.
                .setIn([
                    'quickAddClicked'
                ], state.quickAddClicked).value();
            }
            return state;
        case 0, $49xWy.CREATE_LINKED_ISSUE_SUCCESS:
            {
                const { newIssueLinks: newIssueLinks } = action.payload;
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(newIssueLinks.issueLinks, (issueLink, issueLinkId)=>{
                    newIssueLinks.issueLinks[issueLinkId] = {
                        ...issueLink,
                        isOptimistic: false,
                        isLoading: true,
                        hasError: false,
                        isSaved: true
                    };
                });
                return (0, $6HC1D.merge)(state, newIssueLinks);
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("49xWy", function(module, exports) {

$parcel$export(module.exports, "FETCH_LINKED_ISSUES_SUCCESS", () => $f9b844a1f2ab9c88$export$8e5e5fdada47dc31);
$parcel$export(module.exports, "DELETE_LINKED_ISSUE_REQUEST", () => $f9b844a1f2ab9c88$export$53c6db68e011a790);
$parcel$export(module.exports, "DELETE_LINKED_ISSUE_REQUEST_WITHOUT_FETCH", () => $f9b844a1f2ab9c88$export$6986d5dcae00ee92);
$parcel$export(module.exports, "deleteLinkedIssueRequest", () => $f9b844a1f2ab9c88$export$f2ecdaccdb123c3);
$parcel$export(module.exports, "deleteLinkedIssueRequestWithoutFetch", () => $f9b844a1f2ab9c88$export$4725f5dfba5784cd);
$parcel$export(module.exports, "DELETE_LINKED_ISSUE_SUCCESS", () => $f9b844a1f2ab9c88$export$6939ca0cc6c39b33);
$parcel$export(module.exports, "deleteLinkedIssueSuccess", () => $f9b844a1f2ab9c88$export$8513ed5bfa8d63e2);
$parcel$export(module.exports, "DELETE_LINKED_ISSUE_FAILURE", () => $f9b844a1f2ab9c88$export$b7d1926e3ccf1cb5);
$parcel$export(module.exports, "deleteLinkedIssueFailure", () => $f9b844a1f2ab9c88$export$e047270fdcf31071);
$parcel$export(module.exports, "SAVE_LINKED_ISSUE_REQUEST", () => $f9b844a1f2ab9c88$export$e103906345119520);
$parcel$export(module.exports, "SAVE_LINKED_ISSUE_REQUEST_WITHOUT_FETCH", () => $f9b844a1f2ab9c88$export$327f8ea834904352);
$parcel$export(module.exports, "saveLinkedIssueRequest", () => $f9b844a1f2ab9c88$export$3e4ac465366e2253);
$parcel$export(module.exports, "saveLinkedIssueRequestWithoutFetch", () => $f9b844a1f2ab9c88$export$7fd55a1d5410ff99);
$parcel$export(module.exports, "SAVE_LINKED_ISSUE_SUCCESS", () => $f9b844a1f2ab9c88$export$63e06c2aaf593626);
$parcel$export(module.exports, "saveLinkedIssueSuccess", () => $f9b844a1f2ab9c88$export$9a4d9d52ee9b52c0);
$parcel$export(module.exports, "SAVE_LINKED_ISSUE_FAILURE", () => $f9b844a1f2ab9c88$export$684fea2e445dbc1b);
$parcel$export(module.exports, "saveLinkedIssueFailure", () => $f9b844a1f2ab9c88$export$50e0f846f9468830);
$parcel$export(module.exports, "SAVE_LINKED_ISSUE_RETRY", () => $f9b844a1f2ab9c88$export$fcf64fc14546ab3c);
$parcel$export(module.exports, "saveLinkedIssueRetry", () => $f9b844a1f2ab9c88$export$e2ade582dbb670f6);
$parcel$export(module.exports, "SAVE_LINKED_ISSUE_CANCEL", () => $f9b844a1f2ab9c88$export$a2eac66d7b3caa0a);
$parcel$export(module.exports, "saveLinkedIssueCancel", () => $f9b844a1f2ab9c88$export$9073e3ad4005a03b);
$parcel$export(module.exports, "FETCH_LINKED_ISSUES_DATA_SUCCESS", () => $f9b844a1f2ab9c88$export$8c99c75e11779b87);
$parcel$export(module.exports, "fetchLinkedIssuesDataSuccess", () => $f9b844a1f2ab9c88$export$a8a1d8894a4a327b);
$parcel$export(module.exports, "FETCH_LINKED_ISSUES_DATA_FAILURE", () => $f9b844a1f2ab9c88$export$8520b8f4f4ce7240);
$parcel$export(module.exports, "fetchLinkedIssuesDataFailure", () => $f9b844a1f2ab9c88$export$73e6534c8a34957d);
$parcel$export(module.exports, "ADD_ISSUE_LINK_CLICKED", () => $f9b844a1f2ab9c88$export$fcbc02f8622dd63c);
$parcel$export(module.exports, "addIssueLinkClick", () => $f9b844a1f2ab9c88$export$f4d39d58eb0b465);
$parcel$export(module.exports, "CLEAR_RELATED_ISSUE_LINK", () => $f9b844a1f2ab9c88$export$9d23f0e182dedc24);
$parcel$export(module.exports, "clearRelatedIssueLink", () => $f9b844a1f2ab9c88$export$a4f30a8025a18e42);
$parcel$export(module.exports, "ADD_ISSUE_LINK_CLOSED", () => $f9b844a1f2ab9c88$export$da0a93fba4181a71);
$parcel$export(module.exports, "closeAddIssueLink", () => $f9b844a1f2ab9c88$export$b69a813cb9ebf089);
$parcel$export(module.exports, "FETCH_CREATE_LINKED_ISSUE_PERMISSION_REQUEST", () => $f9b844a1f2ab9c88$export$7dc0ab7cb194441a);
$parcel$export(module.exports, "fetchCreateLinkedIssuePermissionRequest", () => $f9b844a1f2ab9c88$export$e787f4557442456c);
$parcel$export(module.exports, "SET_CREATE_LINKED_ISSUE_PERMISSION", () => $f9b844a1f2ab9c88$export$6d2fc892d590496c);
$parcel$export(module.exports, "setCreateLinkedIssuePermission", () => $f9b844a1f2ab9c88$export$2eaa5e5041e52c8d);
$parcel$export(module.exports, "CREATE_LINKED_ISSUE_SUCCESS", () => $f9b844a1f2ab9c88$export$b22eb59a35fb870e);
$parcel$export(module.exports, "createLinkedIssueSuccess", () => $f9b844a1f2ab9c88$export$6792c0d11c8e4dba);

var $1ybV0 = parcelRequire("1ybV0");
const $f9b844a1f2ab9c88$export$8e5e5fdada47dc31 = 'FETCH_LINKED_ISSUES_SUCCESS';
const $f9b844a1f2ab9c88$export$dee2f3bc8d677833 = (issuesMap)=>({
        type: $f9b844a1f2ab9c88$export$8e5e5fdada47dc31,
        payload: issuesMap
    });
const $f9b844a1f2ab9c88$export$3d5ef22a1511f25d = 'FETCH_LINKED_ISSUES_FAILURE';
const $f9b844a1f2ab9c88$export$1574e418cdf5c249 = (err)=>({
        type: $f9b844a1f2ab9c88$export$3d5ef22a1511f25d,
        payload: err
    });
const $f9b844a1f2ab9c88$export$53c6db68e011a790 = 'DELETE_LINKED_ISSUE_REQUEST';
const $f9b844a1f2ab9c88$export$6986d5dcae00ee92 = 'DELETE_LINKED_ISSUE_REQUEST_WITHOUT_FETCH';
const $f9b844a1f2ab9c88$export$f2ecdaccdb123c3 = (linkedIssueId, application, edition, analyticsEvent)=>({
        type: $f9b844a1f2ab9c88$export$53c6db68e011a790,
        payload: {
            linkedIssueId: linkedIssueId,
            analyticsEvent: analyticsEvent,
            application: application,
            edition: edition
        }
    });
const $f9b844a1f2ab9c88$export$4725f5dfba5784cd = (linkedIssueId, application, edition, analyticsEvent)=>({
        type: $f9b844a1f2ab9c88$export$6986d5dcae00ee92,
        payload: {
            linkedIssueId: linkedIssueId,
            analyticsEvent: analyticsEvent,
            application: application,
            edition: edition
        }
    });
const $f9b844a1f2ab9c88$export$6939ca0cc6c39b33 = 'DELETE_LINKED_ISSUE_SUCCESS';
const $f9b844a1f2ab9c88$export$8513ed5bfa8d63e2 = (linkedIssueId, meta)=>({
        type: $f9b844a1f2ab9c88$export$6939ca0cc6c39b33,
        payload: linkedIssueId,
        meta: meta
    });
const $f9b844a1f2ab9c88$export$b7d1926e3ccf1cb5 = 'DELETE_LINKED_ISSUE_FAILURE';
const $f9b844a1f2ab9c88$export$e047270fdcf31071 = (linkedIssueId)=>({
        type: $f9b844a1f2ab9c88$export$b7d1926e3ccf1cb5,
        payload: linkedIssueId
    });
const $f9b844a1f2ab9c88$export$e103906345119520 = 'SAVE_LINKED_ISSUE_REQUEST';
const $f9b844a1f2ab9c88$export$327f8ea834904352 = 'SAVE_LINKED_ISSUE_REQUEST_WITHOUT_FETCH';
const $f9b844a1f2ab9c88$export$3e4ac465366e2253 = (newIssueLinks, requestAnalyticsEvent, analyticsEvent, onSuccess, onError, postAnalyticsEvent)=>({
        type: $f9b844a1f2ab9c88$export$e103906345119520,
        payload: (0, $1ybV0.ff)('analytics_event_for_deletion_of_linked_issue_1ufi8') ? {
            newIssueLinks: newIssueLinks,
            analyticsEvent: analyticsEvent,
            requestAnalyticsEvent: requestAnalyticsEvent,
            postAnalyticsEvent: postAnalyticsEvent,
            onSuccess: onSuccess,
            onError: onError
        } : {
            newIssueLinks: newIssueLinks,
            analyticsEvent: analyticsEvent,
            requestAnalyticsEvent: requestAnalyticsEvent,
            postAnalyticsEvent: postAnalyticsEvent
        }
    });
const $f9b844a1f2ab9c88$export$7fd55a1d5410ff99 = (newIssueLinks)=>({
        type: $f9b844a1f2ab9c88$export$327f8ea834904352,
        payload: {
            newIssueLinks: newIssueLinks
        }
    });
const $f9b844a1f2ab9c88$export$63e06c2aaf593626 = 'SAVE_LINKED_ISSUE_SUCCESS';
const $f9b844a1f2ab9c88$export$9a4d9d52ee9b52c0 = (optimisticId, analyticsEvent, issueKey, postAnalyticsEvent)=>({
        type: $f9b844a1f2ab9c88$export$63e06c2aaf593626,
        payload: {
            optimisticId: optimisticId,
            issueKey: issueKey,
            analyticsEvent: analyticsEvent,
            postAnalyticsEvent: postAnalyticsEvent
        }
    });
const $f9b844a1f2ab9c88$export$684fea2e445dbc1b = 'SAVE_LINKED_ISSUE_FAILURE';
const $f9b844a1f2ab9c88$export$50e0f846f9468830 = (optimisticId, error, analyticsEvent)=>({
        type: $f9b844a1f2ab9c88$export$684fea2e445dbc1b,
        payload: {
            optimisticId: optimisticId,
            error: error,
            analyticsEvent: analyticsEvent
        }
    });
const $f9b844a1f2ab9c88$export$fcf64fc14546ab3c = 'SAVE_LINKED_ISSUE_RETRY';
const $f9b844a1f2ab9c88$export$e2ade582dbb670f6 = (optimisticId, requestAnalyticsEvent, analyticsEvent, onSuccess, onError, postAnalyticsEvent)=>({
        type: $f9b844a1f2ab9c88$export$fcf64fc14546ab3c,
        payload: (0, $1ybV0.ff)('analytics_event_for_deletion_of_linked_issue_1ufi8') ? {
            optimisticId: optimisticId,
            analyticsEvent: analyticsEvent,
            requestAnalyticsEvent: requestAnalyticsEvent,
            postAnalyticsEvent: postAnalyticsEvent,
            onSuccess: onSuccess,
            onError: onError
        } : {
            optimisticId: optimisticId,
            analyticsEvent: analyticsEvent,
            requestAnalyticsEvent: requestAnalyticsEvent,
            postAnalyticsEvent: postAnalyticsEvent
        }
    });
const $f9b844a1f2ab9c88$export$66b3b462b7798026 = (optimisticId)=>({
        type: $f9b844a1f2ab9c88$export$fcf64fc14546ab3c,
        payload: {
            optimisticId: optimisticId
        }
    });
const $f9b844a1f2ab9c88$export$a2eac66d7b3caa0a = 'SAVE_LINKED_ISSUE_CANCEL';
const $f9b844a1f2ab9c88$export$9073e3ad4005a03b = (optimisticId)=>({
        type: $f9b844a1f2ab9c88$export$a2eac66d7b3caa0a,
        payload: optimisticId
    });
const $f9b844a1f2ab9c88$export$8c99c75e11779b87 = 'FETCH_LINKED_ISSUES_DATA_SUCCESS';
const $f9b844a1f2ab9c88$export$a8a1d8894a4a327b = (issueLinks, linkedIssues, optimisticIds, optimisticLinks)=>({
        type: $f9b844a1f2ab9c88$export$8c99c75e11779b87,
        payload: {
            issueLinks: issueLinks,
            linkedIssues: linkedIssues,
            optimisticIds: optimisticIds,
            optimisticLinks: optimisticLinks
        }
    });
const $f9b844a1f2ab9c88$export$8520b8f4f4ce7240 = 'FETCH_LINKED_ISSUES_DATA_FAILURE';
const $f9b844a1f2ab9c88$export$73e6534c8a34957d = (optimisticIds, error)=>({
        type: $f9b844a1f2ab9c88$export$8520b8f4f4ce7240,
        payload: {
            optimisticIds: optimisticIds,
            error: error
        }
    });
const $f9b844a1f2ab9c88$export$fcbc02f8622dd63c = 'ADD_ISSUE_LINK_CLICKED';
const $f9b844a1f2ab9c88$export$f4d39d58eb0b465 = (linkedIssue)=>({
        type: $f9b844a1f2ab9c88$export$fcbc02f8622dd63c,
        payload: {
            linkedIssue: linkedIssue,
            isOpenedFromJsmSimilarIssues: !!linkedIssue
        }
    });
const $f9b844a1f2ab9c88$export$9d23f0e182dedc24 = 'CLEAR_RELATED_ISSUE_LINK';
const $f9b844a1f2ab9c88$export$a4f30a8025a18e42 = ()=>({
        type: $f9b844a1f2ab9c88$export$9d23f0e182dedc24
    });
const $f9b844a1f2ab9c88$export$da0a93fba4181a71 = 'ADD_ISSUE_LINK_CLOSED';
const $f9b844a1f2ab9c88$export$b69a813cb9ebf089 = ()=>({
        type: $f9b844a1f2ab9c88$export$da0a93fba4181a71
    });
const $f9b844a1f2ab9c88$export$7dc0ab7cb194441a = 'FETCH_CREATE_LINKED_ISSUE_PERMISSION_REQUEST';
const $f9b844a1f2ab9c88$export$e787f4557442456c = ()=>({
        type: $f9b844a1f2ab9c88$export$7dc0ab7cb194441a
    });
const $f9b844a1f2ab9c88$export$6d2fc892d590496c = 'SET_CREATE_LINKED_ISSUE_PERMISSION';
const $f9b844a1f2ab9c88$export$2eaa5e5041e52c8d = (canCreateLinkedIssue)=>({
        type: $f9b844a1f2ab9c88$export$6d2fc892d590496c,
        payload: {
            canCreateLinkedIssue: canCreateLinkedIssue
        }
    });
const $f9b844a1f2ab9c88$export$b22eb59a35fb870e = 'CREATE_LINKED_ISSUE_SUCCESS';
const $f9b844a1f2ab9c88$export$6792c0d11c8e4dba = (newIssueLinks)=>({
        type: $f9b844a1f2ab9c88$export$b22eb59a35fb870e,
        payload: {
            newIssueLinks: newIssueLinks
        }
    });

});


parcelRegister("liv2Q", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $80ba018071ccc532$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $80ba018071ccc532$export$2e2bcd8739ae039);

var $5nezI = parcelRequire("5nezI");
const $80ba018071ccc532$export$d4c72bab9d6cc13a = {
    isLoadingComplete: false
};
var // reducer that contains information for issue-remote-data (web-links and confluence page links)
// eslint-disable-next-line jira/import/no-anonymous-default-export
$80ba018071ccc532$export$2e2bcd8739ae039 = (state = $80ba018071ccc532$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $5nezI.FETCH_ISSUE_REMOTE_DATA_SUCCESS:
        case 0, $5nezI.FETCH_ISSUE_REMOTE_DATA_FAILURE:
            return {
                ...state,
                isLoadingComplete: true
            };
        default:
            return state;
    }
};

});

parcelRegister("bdkx5", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $c3691b46ed8d9574$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $c3691b46ed8d9574$export$2e2bcd8739ae039);

var $eOkgG = parcelRequire("eOkgG");

var $fYteL = parcelRequire("fYteL");
const $c3691b46ed8d9574$export$d4c72bab9d6cc13a = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c3691b46ed8d9574$export$2e2bcd8739ae039 = (state = $c3691b46ed8d9574$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
            return action.payload.issueTypes || state || $c3691b46ed8d9574$export$d4c72bab9d6cc13a; // || in case of nulls
        case 0, $eOkgG.SET_ISSUE_TYPES:
            return action.payload.map((issueType)=>{
                const { id: id, name: name, subtask: subtask, iconUrl: iconUrl, fields: fields } = issueType;
                return {
                    id: id,
                    name: name,
                    subtask: subtask,
                    iconUrl: iconUrl,
                    fields: fields
                };
            });
        default:
            // prettier-ignore
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            action.type;
            return state;
    }
};

});
parcelRegister("eOkgG", function(module, exports) {

$parcel$export(module.exports, "SET_ISSUE_TYPES", () => $8c1a50e851c73367$export$11af98d2365c1146);
$parcel$export(module.exports, "setIssueTypes", () => $8c1a50e851c73367$export$8efd0e86f2117556);
$parcel$export(module.exports, "FETCHING_ISSUE_TYPES", () => $8c1a50e851c73367$export$7068ddfbac31ac28);
$parcel$export(module.exports, "fetchingIssueTypes", () => $8c1a50e851c73367$export$f13da6e0960171c8);
$parcel$export(module.exports, "FETCH_ISSUE_TYPES_FAILED", () => $8c1a50e851c73367$export$d4ae6546729f0aec);
$parcel$export(module.exports, "fetchIssueTypesFailed", () => $8c1a50e851c73367$export$bb8791ee02998d1c);
// import type { ServerIssueType } from '../common/service/issue/subtask-types-server';
// JIV-15410: type duplication
const $8c1a50e851c73367$export$11af98d2365c1146 = 'SET_ISSUE_TYPES';
const $8c1a50e851c73367$export$8efd0e86f2117556 = (issueTypes)=>({
        type: $8c1a50e851c73367$export$11af98d2365c1146,
        payload: issueTypes
    });
const $8c1a50e851c73367$export$7068ddfbac31ac28 = 'FETCHING_ISSUE_TYPES';
const $8c1a50e851c73367$export$f13da6e0960171c8 = ()=>({
        type: $8c1a50e851c73367$export$7068ddfbac31ac28
    });
const $8c1a50e851c73367$export$d4ae6546729f0aec = 'FETCH_ISSUE_TYPES_FAILED';
const $8c1a50e851c73367$export$bb8791ee02998d1c = ()=>({
        type: $8c1a50e851c73367$export$d4ae6546729f0aec
    });

});


parcelRegister("kEMXz", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $4387019f59c4bd21$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $4387019f59c4bd21$export$2e2bcd8739ae039);

var $6vrw7 = parcelRequire("6vrw7");

var $a0kZP = parcelRequire("a0kZP");

var $fp55Q = parcelRequire("fp55Q");
const $4387019f59c4bd21$export$d4c72bab9d6cc13a = {
    status: 'NOT_LOADED',
    remoteLinks: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4387019f59c4bd21$export$2e2bcd8739ae039 = (state = $4387019f59c4bd21$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $fp55Q.FETCH_JIRA_APP_LINKS_SUCCESS:
            {
                // @ts-expect-error - TS2339 - Property 'payload' does not exist on type '{ type: string; } | { type: string; payload: JiraAppLinksResponse; } | { type: string; }'. | TS7006 - Parameter 'appLink' implicitly has an 'any' type.
                const appLinks = action.payload.map((appLink)=>({
                        id: appLink.id,
                        name: appLink.name,
                        baseUrl: (0, $6vrw7.toBaseUrl)(appLink.url),
                        authUrl: (0, $6vrw7.toHref)(appLink.authUrl),
                        requireCredentials: appLink.requireCredentials
                    }));
                return {
                    status: 'LOADED',
                    remoteLinks: appLinks
                };
            }
        case 0, $fp55Q.FETCH_JIRA_APP_LINKS_FAILED:
            return {
                status: 'ERROR',
                remoteLinks: state.remoteLinks
            };
        case 0, $fp55Q.FETCH_JIRA_APP_LINKS_REQUEST:
            return {
                status: 'LOADING',
                remoteLinks: state.remoteLinks
            };
        case 0, $a0kZP.APPLINK_AUTHENTICATION_SUCCESS:
            return {
                status: 'NOT_LOADED',
                remoteLinks: state.remoteLinks
            };
        default:
            return state;
    }
};

});
parcelRegister("a0kZP", function(module, exports) {

$parcel$export(module.exports, "APPLINK_AUTHENTICATION_REQUEST", () => $4c6cb257333a4236$export$bcba898e9660f6ac);
$parcel$export(module.exports, "applinkAuthenticationRequest", () => $4c6cb257333a4236$export$5bd36a395747d01);
$parcel$export(module.exports, "APPLINK_AUTHENTICATION_SUCCESS", () => $4c6cb257333a4236$export$98ee0834c69b8a04);
$parcel$export(module.exports, "applinkAuthenticationSuccess", () => $4c6cb257333a4236$export$9ff1ff2b6cfb6893);
const $4c6cb257333a4236$export$bcba898e9660f6ac = 'APPLINK_AUTHENTICATION_REQUEST';
const $4c6cb257333a4236$export$5bd36a395747d01 = (href, analyticsEvent)=>({
        type: $4c6cb257333a4236$export$bcba898e9660f6ac,
        payload: href,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $4c6cb257333a4236$export$98ee0834c69b8a04 = 'APPLINK_AUTHENTICATION_SUCCESS';
const $4c6cb257333a4236$export$9ff1ff2b6cfb6893 = ()=>({
        type: $4c6cb257333a4236$export$98ee0834c69b8a04
    });

});

parcelRegister("fp55Q", function(module, exports) {

$parcel$export(module.exports, "FETCH_JIRA_APP_LINKS_REQUEST", () => $c39d2d9f95c4aa2e$export$3198119ab695bec1);
$parcel$export(module.exports, "fetchJiraAppLinks", () => $c39d2d9f95c4aa2e$export$8a9d8c7d054f8378);
$parcel$export(module.exports, "FETCH_JIRA_APP_LINKS_SUCCESS", () => $c39d2d9f95c4aa2e$export$e3d678e9ceeb01b1);
$parcel$export(module.exports, "fetchJiraAppLinksSuccess", () => $c39d2d9f95c4aa2e$export$1d6c2d230f5d0c84);
$parcel$export(module.exports, "FETCH_JIRA_APP_LINKS_FAILED", () => $c39d2d9f95c4aa2e$export$6a1b5a0ba24e6ec);
$parcel$export(module.exports, "fetchJiraAppLinksFailed", () => $c39d2d9f95c4aa2e$export$fd0f2c14718bd176);
// FETCH_JIRA_APP_LINKS_REQUEST
const $c39d2d9f95c4aa2e$export$3198119ab695bec1 = 'FETCH_JIRA_APP_LINKS_REQUEST';
const $c39d2d9f95c4aa2e$export$8a9d8c7d054f8378 = ()=>({
        type: $c39d2d9f95c4aa2e$export$3198119ab695bec1
    });
const $c39d2d9f95c4aa2e$export$e3d678e9ceeb01b1 = 'FETCH_JIRA_APP_LINKS_SUCCESS';
const $c39d2d9f95c4aa2e$export$1d6c2d230f5d0c84 = (response)=>({
        type: $c39d2d9f95c4aa2e$export$e3d678e9ceeb01b1,
        payload: response
    });
const $c39d2d9f95c4aa2e$export$6a1b5a0ba24e6ec = 'FETCH_JIRA_APP_LINKS_FAILED';
const $c39d2d9f95c4aa2e$export$fd0f2c14718bd176 = ()=>({
        type: $c39d2d9f95c4aa2e$export$6a1b5a0ba24e6ec
    });

});


parcelRegister("cEXKk", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $df8c4e4d98900938$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $df8c4e4d98900938$export$2e2bcd8739ae039);

var $hTLlD = parcelRequire("hTLlD");

var $6vrw7 = parcelRequire("6vrw7");

var $5nezI = parcelRequire("5nezI");

var $02hYD = parcelRequire("02hYD");

var $fYteL = parcelRequire("fYteL");

var $cyUky = parcelRequire("cyUky");
const $df8c4e4d98900938$export$d4c72bab9d6cc13a = {
    remoteIssueCount: 0,
    remoteIssues: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$df8c4e4d98900938$export$2e2bcd8739ae039 = (state = $df8c4e4d98900938$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
            {
                const { remoteLinks: remoteLinks = {} } = action.payload;
                const { remoteLinkedIssues: remoteLinkedIssues = [] } = remoteLinks;
                const issueCount = remoteLinkedIssues.length;
                // FETCH_ISSUE_SUCCESS and FETCH_ISSUE_REMOTE_DATA_SUCCESS come asynchronically, where race condition is possible
                // FETCH_ISSUE_SUCCESS is ONLY used for TTI preview, which should _not_ update store if full details are already fetched from FETCH_ISSUE_REMOTE_DATA_SUCCESS
                if (state.remoteIssueCount) return state;
                const nextState = {
                    ...state,
                    remoteIssueCount: issueCount,
                    remoteIssues: (0, $cyUky.transformServerRemoteIssueLinks)(remoteLinkedIssues)
                };
                return {
                    ...nextState
                };
            }
        case 0, $5nezI.FETCH_ISSUE_REMOTE_DATA_SUCCESS:
            {
                const { remoteLinks: remoteLinks = {} } = action.payload;
                const { remoteLinkedIssues: remoteLinkedIssues = [] } = remoteLinks;
                const issueCount = remoteLinkedIssues.length;
                const nextState = {
                    ...state,
                    remoteIssueCount: issueCount,
                    remoteIssues: (0, $cyUky.transformServerRemoteIssueLinks)(remoteLinkedIssues)
                };
                return (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(nextState, state) ? state : {
                    ...nextState
                };
            }
        case 0, $02hYD.DELETE_REMOTE_LINKED_ISSUE_REQUEST:
            {
                const { globalId: globalIdtoDelete } = action.payload;
                return {
                    ...state,
                    remoteIssues: state.remoteIssues.map((issue)=>{
                        if (issue.globalId === globalIdtoDelete) return {
                            ...issue,
                            isDeleted: true
                        };
                        return issue;
                    })
                };
            }
        case 0, $02hYD.DELETE_REMOTE_LINKED_ISSUE_SUCCESS:
            {
                const deletedGlobalId = action.payload;
                return {
                    ...state,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    remoteIssues: state.remoteIssues.reduce((newIssues, issue)=>{
                        if (issue.globalId !== deletedGlobalId) newIssues.push(issue);
                        return newIssues;
                    }, [])
                };
            }
        case 0, $02hYD.DELETE_REMOTE_LINKED_ISSUE_FAILURE:
            {
                const globalId = action.payload;
                return {
                    ...state,
                    remoteIssues: state.remoteIssues.map((issue)=>{
                        if (issue.globalId === globalId) return {
                            ...issue,
                            isDeleted: false
                        };
                        return issue;
                    })
                };
            }
        case 0, $02hYD.SAVE_REMOTE_LINKED_ISSUE_REQUEST:
            {
                const { saveRemoteIssueLinkPayload: saveRemoteIssueLinkPayload } = action.payload;
                return {
                    ...state,
                    remoteIssues: state.remoteIssues.concat((0, $cyUky.transformOptimisticRemoteIssueLink)(saveRemoteIssueLinkPayload))
                };
            }
        case 0, $02hYD.SAVE_REMOTE_LINKED_ISSUE_SUCCESS:
            {
                const { optimisticId: optimisticId, saveRemoteLinkResponse: { id: id, issueId: issueId, globalId: globalId } } = action.payload;
                // TODO NIMBUS-243: improve response payload
                return {
                    ...state,
                    remoteIssues: state.remoteIssues.map((link)=>link.id === optimisticId ? {
                            ...link,
                            id: id.toString(),
                            globalId: (0, $6vrw7.toRemoteLinkGlobalId)(globalId),
                            remoteIssueId: issueId !== undefined ? (0, $6vrw7.toIssueId)(issueId.toString()) : link.remoteIssueId,
                            isOptimistic: false,
                            isSaved: true
                        } : link)
                };
            }
        case 0, $02hYD.SAVE_REMOTE_LINKED_ISSUE_FAILURE:
            {
                const { optimisticId: optimisticId, error: error } = action.payload;
                if (error.statusCode === 400) return {
                    ...state,
                    remoteIssues: state.remoteIssues.filter((link)=>link.id !== optimisticId)
                };
                return {
                    ...state,
                    remoteIssues: state.remoteIssues.map((link)=>link.id === optimisticId ? {
                            ...link,
                            isLoading: false,
                            hasError: true
                        } : link)
                };
            }
        case 0, $02hYD.SAVE_REMOTE_LINKED_ISSUE_RETRY:
            {
                const { optimisticId: optimisticId } = action.payload;
                return {
                    ...state,
                    remoteIssues: state.remoteIssues.map((link)=>link.id === optimisticId ? {
                            ...link,
                            isLoading: true,
                            hasError: false
                        } : link)
                };
            }
        case 0, $02hYD.SAVE_REMOTE_LINKED_ISSUE_CANCEL:
            {
                const optimisticId = action.payload;
                return {
                    ...state,
                    remoteIssues: state.remoteIssues.filter((link)=>link.id !== optimisticId)
                };
            }
        default:
            return state;
    }
};

});
parcelRegister("02hYD", function(module, exports) {

$parcel$export(module.exports, "DELETE_REMOTE_LINKED_ISSUE_REQUEST", () => $d8fcc5fcb049ee8a$export$d8fd6f9c5cc73895);
$parcel$export(module.exports, "deleteRemoteLinkedIssueRequest", () => $d8fcc5fcb049ee8a$export$97ce0f9400e910b7);
$parcel$export(module.exports, "DELETE_REMOTE_LINKED_ISSUE_SUCCESS", () => $d8fcc5fcb049ee8a$export$48a0f91b823be1b);
$parcel$export(module.exports, "deleteRemoteLinkedIssueSuccess", () => $d8fcc5fcb049ee8a$export$b50171dbeff129a7);
$parcel$export(module.exports, "DELETE_REMOTE_LINKED_ISSUE_FAILURE", () => $d8fcc5fcb049ee8a$export$167cc53290368c35);
$parcel$export(module.exports, "deleteRemoteLinkedIssueFailure", () => $d8fcc5fcb049ee8a$export$f79793c7164b9087);
$parcel$export(module.exports, "SAVE_REMOTE_LINKED_ISSUE_REQUEST", () => $d8fcc5fcb049ee8a$export$9b256c93b6f99809);
$parcel$export(module.exports, "saveRemoteLinkedIssueRequest", () => $d8fcc5fcb049ee8a$export$f16091cb07050f49);
$parcel$export(module.exports, "SAVE_REMOTE_LINKED_ISSUE_SUCCESS", () => $d8fcc5fcb049ee8a$export$ede2fb803cc85087);
$parcel$export(module.exports, "saveRemoteLinkedIssueSuccess", () => $d8fcc5fcb049ee8a$export$67581f5f048906e2);
$parcel$export(module.exports, "SAVE_REMOTE_LINKED_ISSUE_FAILURE", () => $d8fcc5fcb049ee8a$export$997590d5805a1382);
$parcel$export(module.exports, "saveRemoteLinkedIssueFailure", () => $d8fcc5fcb049ee8a$export$d8df0cdffead5e8c);
$parcel$export(module.exports, "SAVE_REMOTE_LINKED_ISSUE_RETRY", () => $d8fcc5fcb049ee8a$export$8d95efd6c827efb7);
$parcel$export(module.exports, "saveRemoteLinkedIssueRetry", () => $d8fcc5fcb049ee8a$export$debbd551791db6a2);
$parcel$export(module.exports, "SAVE_REMOTE_LINKED_ISSUE_CANCEL", () => $d8fcc5fcb049ee8a$export$635f18f214ada604);
$parcel$export(module.exports, "saveRemoteLinkedIssueCancel", () => $d8fcc5fcb049ee8a$export$6178dded36706ded);

var $1ybV0 = parcelRequire("1ybV0");
const $d8fcc5fcb049ee8a$export$d8fd6f9c5cc73895 = 'DELETE_REMOTE_LINKED_ISSUE_REQUEST';
const $d8fcc5fcb049ee8a$export$97ce0f9400e910b7 = (globalId, application, edition, analyticsEvent)=>({
        type: $d8fcc5fcb049ee8a$export$d8fd6f9c5cc73895,
        payload: {
            globalId: globalId,
            analyticsEvent: analyticsEvent,
            application: application,
            edition: edition
        }
    });
const $d8fcc5fcb049ee8a$export$48a0f91b823be1b = 'DELETE_REMOTE_LINKED_ISSUE_SUCCESS';
const $d8fcc5fcb049ee8a$export$b50171dbeff129a7 = (globalId)=>({
        type: $d8fcc5fcb049ee8a$export$48a0f91b823be1b,
        payload: globalId
    });
const $d8fcc5fcb049ee8a$export$167cc53290368c35 = 'DELETE_REMOTE_LINKED_ISSUE_FAILURE';
const $d8fcc5fcb049ee8a$export$f79793c7164b9087 = (globalId)=>({
        type: $d8fcc5fcb049ee8a$export$167cc53290368c35,
        payload: globalId
    });
const $d8fcc5fcb049ee8a$export$9b256c93b6f99809 = 'SAVE_REMOTE_LINKED_ISSUE_REQUEST';
const $d8fcc5fcb049ee8a$export$f16091cb07050f49 = (saveRemoteIssueLinkPayload, requestAnalyticsEvent, analyticsEvent, onSuccess, onError)=>({
        type: $d8fcc5fcb049ee8a$export$9b256c93b6f99809,
        payload: (0, $1ybV0.ff)('analytics_event_for_deletion_of_linked_issue_1ufi8') ? {
            saveRemoteIssueLinkPayload: saveRemoteIssueLinkPayload,
            requestAnalyticsEvent: requestAnalyticsEvent,
            analyticsEvent: analyticsEvent,
            onSuccess: onSuccess,
            onError: onError
        } : {
            saveRemoteIssueLinkPayload: saveRemoteIssueLinkPayload,
            requestAnalyticsEvent: requestAnalyticsEvent,
            analyticsEvent: analyticsEvent
        }
    });
const $d8fcc5fcb049ee8a$export$ede2fb803cc85087 = 'SAVE_REMOTE_LINKED_ISSUE_SUCCESS';
const $d8fcc5fcb049ee8a$export$67581f5f048906e2 = (optimisticId, saveRemoteLinkResponse, analyticsEvent)=>({
        type: $d8fcc5fcb049ee8a$export$ede2fb803cc85087,
        payload: {
            optimisticId: optimisticId,
            saveRemoteLinkResponse: saveRemoteLinkResponse,
            analyticsEvent: analyticsEvent
        }
    });
const $d8fcc5fcb049ee8a$export$997590d5805a1382 = 'SAVE_REMOTE_LINKED_ISSUE_FAILURE';
const $d8fcc5fcb049ee8a$export$d8df0cdffead5e8c = (optimisticId, remoteIssueKey, error, analyticsEvent)=>({
        type: $d8fcc5fcb049ee8a$export$997590d5805a1382,
        payload: {
            optimisticId: optimisticId,
            error: error,
            analyticsEvent: analyticsEvent,
            remoteIssueKey: remoteIssueKey
        }
    });
const $d8fcc5fcb049ee8a$export$8d95efd6c827efb7 = 'SAVE_REMOTE_LINKED_ISSUE_RETRY';
const $d8fcc5fcb049ee8a$export$debbd551791db6a2 = (optimisticId, requestAnalyticsEvent, analyticsEvent, onSuccess, onError)=>({
        type: $d8fcc5fcb049ee8a$export$8d95efd6c827efb7,
        payload: (0, $1ybV0.ff)('analytics_event_for_deletion_of_linked_issue_1ufi8') ? {
            optimisticId: optimisticId,
            requestAnalyticsEvent: requestAnalyticsEvent,
            analyticsEvent: analyticsEvent,
            onSuccess: onSuccess,
            onError: onError
        } : {
            optimisticId: optimisticId,
            requestAnalyticsEvent: requestAnalyticsEvent,
            analyticsEvent: analyticsEvent
        }
    });
const $d8fcc5fcb049ee8a$export$635f18f214ada604 = 'SAVE_REMOTE_LINKED_ISSUE_CANCEL';
const $d8fcc5fcb049ee8a$export$6178dded36706ded = (optimisticId)=>({
        type: $d8fcc5fcb049ee8a$export$635f18f214ada604,
        payload: optimisticId
    });

});

parcelRegister("cyUky", function(module, exports) {

$parcel$export(module.exports, "transformServerRemoteIssueLinks", () => $31d197d86fcd27e5$export$3ea15ef14cfe1473);
$parcel$export(module.exports, "transformOptimisticRemoteIssueLink", () => $31d197d86fcd27e5$export$d6158447f48fd4f6);

var $8Qd0L = parcelRequire("8Qd0L");


var $6vrw7 = parcelRequire("6vrw7");
const $31d197d86fcd27e5$var$initialUIState = {
    isLoading: false,
    hasError: false,
    isSaved: false,
    isDeleted: false,
    isOptimistic: false
};
const $31d197d86fcd27e5$var$transformAssociatedIssue = (associatedIssue, issueLink)=>({
        id: associatedIssue.issueId.toString(),
        issueKey: associatedIssue.issueKey.stringValue,
        issueSummary: associatedIssue.summary.textValue,
        statusCategoryId: associatedIssue.status?.statusCategoryId,
        statusCategory: (0, $8Qd0L.statusCategoryForId)(associatedIssue.status?.statusCategoryId),
        issueLink: (0, $6vrw7.toHref)(issueLink),
        statusName: associatedIssue.status?.name,
        statusId: associatedIssue.status?.statusId,
        issuePriorityUrl: associatedIssue.priority && (0, $6vrw7.toHref)(associatedIssue.priority.iconUrl),
        issuePriorityName: associatedIssue.priority?.name ?? null,
        issuePrioritySequence: associatedIssue.priority?.sequence ?? undefined,
        issueTypeIconUrl: (0, $6vrw7.toHref)(associatedIssue.issueType.iconUrl),
        issueTypeName: associatedIssue.issueType.name,
        assigneeDisplayName: associatedIssue.assignee?.userValue?.displayName,
        assigneeUrl: associatedIssue.assignee?.userValue ? (0, $6vrw7.toHref)(associatedIssue.assignee.userValue.avatarUrl) : null
    });
const $31d197d86fcd27e5$export$3ea15ef14cfe1473 = (serverRemoteIssues)=>// @ts-expect-error - TS2322 - Type '{ isLoading: boolean; hasError?: boolean | undefined; isSaved?: boolean | undefined; isDeleted?: boolean | undefined; isOptimistic?: boolean | undefined; id: string; globalId: string | undefined; ... 5 more ...; remoteIssueId: string; }[]' is not assignable to type 'RemoteIssueLink[]'.
    serverRemoteIssues.map((issue)=>{
        const { preview: preview, details: details } = issue;
        const isLoading = !details;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let flattenedDetails = {};
        if (!details) flattenedDetails = {
            issueDetails: null,
            remoteIssueLinkError: null
        };
        else if (!details.error) flattenedDetails = {
            // @ts-expect-error - TS2339 - Property 'associatedIssue' does not exist on type 'ServerRemoteIssueLinkDetails'.
            issueDetails: $31d197d86fcd27e5$var$transformAssociatedIssue(details.associatedIssue, preview.href),
            remoteIssueLinkError: null
        };
        else flattenedDetails = {
            issueDetails: null,
            remoteIssueLinkError: details
        };
        return {
            // from preview
            id: preview.id.toString(),
            globalId: preview.globalId === undefined ? undefined : (0, $6vrw7.toRemoteLinkGlobalId)(preview.globalId),
            applicationType: preview.applicationType,
            applicationName: preview.applicationName,
            issueLinkUrl: (0, $6vrw7.toHref)(preview.href),
            relationship: preview.relationship,
            issueKey: (0, $6vrw7.toIssueKey)(preview.title),
            remoteIssueId: (0, $6vrw7.toIssueId)(preview.issueId.toString()),
            // from details
            ...flattenedDetails,
            // UI state
            ...$31d197d86fcd27e5$var$initialUIState,
            isLoading: isLoading
        };
    });
const $31d197d86fcd27e5$export$d6158447f48fd4f6 = (saveRemoteIssueLinkPayload)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let remoteIssueLinkPreview = {};
    if (saveRemoteIssueLinkPayload.payloadType === (0, $70e59ad1dd71402d$export$df68a44a73b1d288)) {
        const { payloadType: payloadType, ...rest } = saveRemoteIssueLinkPayload;
        remoteIssueLinkPreview = rest;
    } else {
        const { payloadType: payloadType, ...rest } = saveRemoteIssueLinkPayload;
        remoteIssueLinkPreview = {
            ...rest,
            remoteIssueId: (0, $6vrw7.toIssueId)(`OPTIMISTIC_ISSUE_ID_${Date.now()}`)
        };
    }
    const optimisticUIState = {
        ...$31d197d86fcd27e5$var$initialUIState,
        isLoading: true,
        isOptimistic: true
    };
    // @ts-expect-error - TS2322 - Type '{ isLoading: boolean; isOptimistic: boolean; hasError?: boolean | undefined; isSaved?: boolean | undefined; isDeleted?: boolean | undefined; issueDetails: null; remoteIssueLinkError: null; }' is not assignable to type 'RemoteIssueLink'.
    return {
        ...remoteIssueLinkPreview,
        issueDetails: null,
        remoteIssueLinkError: null,
        ...optimisticUIState
    };
};

});
const $70e59ad1dd71402d$export$df68a44a73b1d288 = 'WITH_ISSUE_ID';
const $70e59ad1dd71402d$export$301a5c7f9b4c13e1 = 'WITHOUT_ISSUE_ID';
const $70e59ad1dd71402d$export$8c3104c763ff334 = 'CREATED';
const $70e59ad1dd71402d$export$3e616f31ca1183bc = 'SERVER_ERROR';
const $70e59ad1dd71402d$export$5e220557f845ffbe = 'VALIDATION_ERROR';



parcelRegister("c8oPZ", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $ef3e9c88dc9b0e7a$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $ef3e9c88dc9b0e7a$export$2e2bcd8739ae039);

var $5nezI = parcelRequire("5nezI");

var $hficN = parcelRequire("hficN");
const $ef3e9c88dc9b0e7a$export$d4c72bab9d6cc13a = {
    isLinkingEnabled: true,
    linkCount: 0,
    links: [],
    createClickCount: 0
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ef3e9c88dc9b0e7a$export$2e2bcd8739ae039 = (state = $ef3e9c88dc9b0e7a$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $5nezI.FETCH_ISSUE_REMOTE_DATA_SUCCESS:
            {
                const { remoteLinks: remoteLinks = {} } = action.payload;
                const { webLinks: webLinks } = remoteLinks;
                const { linkCount: linkCount = 0, links: links = [] } = webLinks || {};
                return {
                    ...state,
                    isLinkingEnabled: !!remoteLinks.isLinkingEnabled,
                    linkCount: linkCount,
                    links: links
                };
            }
        case 0, $hficN.SHOW_CREATE_WEB_LINK_FORM:
            return {
                ...state,
                createClickCount: state.createClickCount + 1
            };
        case 0, $hficN.HIDE_CREATE_WEB_LINK_FORM:
            return {
                ...state,
                createClickCount: $ef3e9c88dc9b0e7a$export$d4c72bab9d6cc13a.createClickCount
            };
        case 0, $hficN.DELETE_WEB_LINK_REQUEST:
            {
                const { id: id } = action.payload;
                const links = state.links.map((link)=>link.id === id ? {
                        ...link,
                        isDeleting: true,
                        deleteFailed: false
                    } : link);
                return {
                    ...state,
                    links: links
                };
            }
        case 0, $hficN.DELETE_OPTIMISTIC_WEB_LINK:
        case 0, $hficN.DELETE_WEB_LINK_SUCCESS:
            {
                const { id: id } = action.payload;
                if (id && state.links) {
                    const links = state.links.filter((link)=>link.id !== id);
                    const linkCount = links.length;
                    return {
                        ...state,
                        linkCount: linkCount,
                        links: links
                    };
                }
                return state;
            }
        case 0, $hficN.DELETE_WEB_LINK_FAILED:
            {
                const { id: id } = action.payload;
                const links = state.links.map((link)=>link.id === id ? {
                        ...link,
                        isDeleting: false,
                        deleteFailed: true
                    } : link);
                return {
                    ...state,
                    links: links
                };
            }
        case 0, $hficN.CANCEL_FAILED_WEB_LINK_DELETION:
            {
                const { id: id } = action.payload;
                const links = state.links.map((link)=>{
                    if (link.id !== id) return link;
                    const updatedLink = {
                        id: link.id,
                        href: link.href,
                        linkText: link.linkText,
                        iconUrl: link.iconUrl,
                        resolved: null,
                        relationship: null,
                        applicationName: null,
                        applicationType: null
                    };
                    return updatedLink;
                });
                return {
                    ...state,
                    links: links
                };
            }
        case 0, $hficN.CREATE_WEB_LINK_REQUEST:
            {
                const { optimisticId: optimisticId, href: href, linkText: linkText, iconUrl: iconUrl } = action.payload;
                // Note: Add the optimistic link to the TOP of the list, in the same order we fetch the web links in
                return {
                    ...state,
                    linkCount: state.linkCount + 1,
                    links: [
                        {
                            id: optimisticId,
                            smartLinkId: optimisticId,
                            href: href,
                            linkText: linkText,
                            iconUrl: iconUrl,
                            isCreating: false,
                            isCreateFailed: false,
                            resolved: null,
                            relationship: null,
                            applicationName: null,
                            applicationType: null
                        },
                        ...state.links
                    ]
                };
            }
        case 0, $hficN.CREATE_WEB_LINK_SUCCESS:
            {
                const { optimisticId: optimisticId, webLink: webLink } = action.payload;
                const links = state.links.map((link)=>{
                    if (link.id === optimisticId) {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        webLink.smartLinkId = link.smartLinkId;
                        return webLink;
                    }
                    return link;
                });
                return {
                    ...state,
                    links: links
                };
            }
        case 0, $hficN.CREATE_WEB_LINK_LIMIT_EXCEEDED:
            {
                const { optimisticId: optimisticId } = action.payload;
                const links = state.links.map((link)=>link.id === optimisticId ? {
                        ...link,
                        isCreateFailedLimitExceeded: true
                    } : link);
                return {
                    ...state,
                    links: links
                };
            }
        case 0, $hficN.CREATE_WEB_LINK_FAILED:
            {
                const { optimisticId: optimisticId } = action.payload;
                const links = state.links.map((link)=>link.id === optimisticId ? {
                        ...link,
                        isCreating: false,
                        isCreateFailed: true
                    } : link);
                return {
                    ...state,
                    links: links
                };
            }
        case 0, $hficN.CREATE_WEB_LINK_RETRY:
            {
                const { optimisticId: optimisticId } = action.payload;
                const links = state.links.map((link)=>link.id === optimisticId ? {
                        ...link,
                        isCreating: true,
                        isCreateFailed: false
                    } : link);
                return {
                    ...state,
                    links: links
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("hficN", function(module, exports) {

$parcel$export(module.exports, "SHOW_CREATE_WEB_LINK_FORM", () => $a5655a52658499c0$export$d6cd3d37b42e515);
$parcel$export(module.exports, "showCreateWebLinkForm", () => $a5655a52658499c0$export$d61e39579683f3e5);
$parcel$export(module.exports, "HIDE_CREATE_WEB_LINK_FORM", () => $a5655a52658499c0$export$50d0b867ce462e44);
$parcel$export(module.exports, "hideCreateWebLinkForm", () => $a5655a52658499c0$export$ae6e8dc59b9dc019);
$parcel$export(module.exports, "CREATE_WEB_LINK_REQUEST", () => $a5655a52658499c0$export$105e1de507baf5eb);
$parcel$export(module.exports, "createWebLinkRequest", () => $a5655a52658499c0$export$42593ebfaa6f0598);
$parcel$export(module.exports, "CREATE_WEB_LINK_SUCCESS", () => $a5655a52658499c0$export$75888b4c4493c23b);
$parcel$export(module.exports, "createWebLinkSuccess", () => $a5655a52658499c0$export$5a0528512f48224f);
$parcel$export(module.exports, "CREATE_WEB_LINK_FAILED", () => $a5655a52658499c0$export$fdb543c1e10bf2ea);
$parcel$export(module.exports, "CREATE_WEB_LINK_LIMIT_EXCEEDED", () => $a5655a52658499c0$export$393ec33d16c5b6fb);
$parcel$export(module.exports, "createWebLinkFailed", () => $a5655a52658499c0$export$d3acf391c0f9319b);
$parcel$export(module.exports, "CREATE_WEB_LINK_RETRY", () => $a5655a52658499c0$export$477a74750d6eb837);
$parcel$export(module.exports, "createWebLinkRetry", () => $a5655a52658499c0$export$16ad5167a58e7f9e);
$parcel$export(module.exports, "DELETE_WEB_LINK_REQUEST", () => $a5655a52658499c0$export$3c923766b10f27a4);
$parcel$export(module.exports, "deleteWebLinkRequest", () => $a5655a52658499c0$export$7a439ee4fcd4d848);
$parcel$export(module.exports, "DELETE_WEB_LINK_SUCCESS", () => $a5655a52658499c0$export$5005d3ec48a0c19c);
$parcel$export(module.exports, "deleteWebLinkSuccess", () => $a5655a52658499c0$export$dec9fb66f58592ae);
$parcel$export(module.exports, "DELETE_WEB_LINK_FAILED", () => $a5655a52658499c0$export$e3245a362f751a4a);
$parcel$export(module.exports, "deleteWebLinkFailed", () => $a5655a52658499c0$export$66b5eeba3cf14bb7);
$parcel$export(module.exports, "CANCEL_FAILED_WEB_LINK_DELETION", () => $a5655a52658499c0$export$5cf8947b19a9b59e);
$parcel$export(module.exports, "cancelFailedWebLinkDeletion", () => $a5655a52658499c0$export$b99c311fd9458ab4);
$parcel$export(module.exports, "DELETE_OPTIMISTIC_WEB_LINK", () => $a5655a52658499c0$export$fb7701f1b50de6a);
$parcel$export(module.exports, "deleteOptimisticWebLink", () => $a5655a52658499c0$export$b9e9bc693b6fe6c3);


var $1ybV0 = parcelRequire("1ybV0");

var $6vrw7 = parcelRequire("6vrw7");
const $a5655a52658499c0$export$d6cd3d37b42e515 = 'SHOW_CREATE_WEB_LINK_FORM';
const $a5655a52658499c0$export$d61e39579683f3e5 = ()=>({
        type: $a5655a52658499c0$export$d6cd3d37b42e515
    });
const $a5655a52658499c0$export$50d0b867ce462e44 = 'HIDE_CREATE_WEB_LINK_FORM';
const $a5655a52658499c0$export$ae6e8dc59b9dc019 = ()=>({
        type: $a5655a52658499c0$export$50d0b867ce462e44
    });
const $a5655a52658499c0$export$105e1de507baf5eb = 'CREATE_WEB_LINK_REQUEST';
const $a5655a52658499c0$export$42593ebfaa6f0598 = (href, linkText, iconUrl)=>({
        type: $a5655a52658499c0$export$105e1de507baf5eb,
        payload: {
            optimisticId: (0, $6vrw7.toWebLinkId)(`optimistic-web-link-${Date.now()}`),
            href: href,
            linkText: linkText,
            iconUrl: iconUrl
        }
    });
const $a5655a52658499c0$export$75888b4c4493c23b = 'CREATE_WEB_LINK_SUCCESS';
const $a5655a52658499c0$export$5a0528512f48224f = (optimisticId, webLink)=>({
        type: $a5655a52658499c0$export$75888b4c4493c23b,
        payload: {
            optimisticId: optimisticId,
            webLink: webLink
        }
    });
const $a5655a52658499c0$export$fdb543c1e10bf2ea = 'CREATE_WEB_LINK_FAILED';
const $a5655a52658499c0$export$393ec33d16c5b6fb = 'CREATE_WEB_LINK_LIMIT_EXCEEDED';
const $a5655a52658499c0$export$d3acf391c0f9319b = (optimisticId, error)=>{
    if ((0, $1ybV0.ff)('issue.details.hard-limits.issue-weblinks-limit') && error.statusCode === (0, $1c3fbb431a173cc6$export$f90ac1df0b60853d)) return {
        type: $a5655a52658499c0$export$393ec33d16c5b6fb,
        payload: {
            optimisticId: optimisticId
        }
    };
    return {
        type: $a5655a52658499c0$export$fdb543c1e10bf2ea,
        payload: {
            optimisticId: optimisticId
        }
    };
};
const $a5655a52658499c0$export$477a74750d6eb837 = 'CREATE_WEB_LINK_RETRY';
const $a5655a52658499c0$export$16ad5167a58e7f9e = (optimisticId)=>({
        type: $a5655a52658499c0$export$477a74750d6eb837,
        payload: {
            optimisticId: optimisticId
        }
    });
const $a5655a52658499c0$export$3c923766b10f27a4 = 'DELETE_WEB_LINK_REQUEST';
const $a5655a52658499c0$export$7a439ee4fcd4d848 = (id)=>({
        type: $a5655a52658499c0$export$3c923766b10f27a4,
        payload: {
            id: id
        }
    });
const $a5655a52658499c0$export$5005d3ec48a0c19c = 'DELETE_WEB_LINK_SUCCESS';
const $a5655a52658499c0$export$dec9fb66f58592ae = (id)=>({
        type: $a5655a52658499c0$export$5005d3ec48a0c19c,
        payload: {
            id: id
        }
    });
const $a5655a52658499c0$export$e3245a362f751a4a = 'DELETE_WEB_LINK_FAILED';
const $a5655a52658499c0$export$66b5eeba3cf14bb7 = (id)=>({
        type: $a5655a52658499c0$export$e3245a362f751a4a,
        payload: {
            id: id
        }
    });
const $a5655a52658499c0$export$5cf8947b19a9b59e = 'CANCEL_FAILED_WEB_LINK_DELETION';
const $a5655a52658499c0$export$b99c311fd9458ab4 = (id)=>({
        type: $a5655a52658499c0$export$5cf8947b19a9b59e,
        payload: {
            id: id
        }
    });
const $a5655a52658499c0$export$fb7701f1b50de6a = 'DELETE_OPTIMISTIC_WEB_LINK';
const $a5655a52658499c0$export$b9e9bc693b6fe6c3 = (id)=>({
        type: $a5655a52658499c0$export$fb7701f1b50de6a,
        payload: {
            id: id
        }
    });

});


parcelRegister("eu3hL", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $f95d5124df5e9a63$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $f95d5124df5e9a63$export$2e2bcd8739ae039);

var $kFGm5 = parcelRequire("kFGm5");


var $fYteL = parcelRequire("fYteL");

var $9Y7ra = parcelRequire("9Y7ra");
const $f95d5124df5e9a63$export$d4c72bab9d6cc13a = {
    sortedWorklogIds: [],
    worklogs: {},
    totalWorklogs: 0,
    worklogsStartIndex: 0
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f95d5124df5e9a63$export$2e2bcd8739ae039 = (state = $f95d5124df5e9a63$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $9Y7ra.FETCH_WORKLOGS_BY_ID_SUCCESS:
            {
                const { sortedWorklogIds: sortedWorklogIds, worklogs: worklogs, startIndex: worklogsStartIndex, totalWorklogs: totalWorklogs } = action.payload;
                return {
                    ...state,
                    sortedWorklogIds: sortedWorklogIds,
                    worklogs: worklogs,
                    worklogsStartIndex: worklogsStartIndex,
                    totalWorklogs: totalWorklogs
                };
            }
        case 0, $9Y7ra.FETCH_WORKLOGS_BY_ID_FAILURE:
            return {
                ...$f95d5124df5e9a63$export$d4c72bab9d6cc13a
            };
        case 0, $9Y7ra.EDIT_WORKLOG_SUCCESS:
            {
                const { worklogs: worklogs } = action.payload;
                return {
                    ...state,
                    worklogs: worklogs
                };
            }
        // This action contains the original logic to fetch data
        // And not be used now since we get data from gira and use FETCH_INITIAL_WORKLOGS_SUCCESS
        case 0, $9Y7ra.FETCH_WORKLOGS_SUCCESS:
            {
                const { sortedWorklogIds: sortedWorklogIds, worklogs: worklogs, totalWorklogs: totalWorklogs } = action.payload;
                const { worklogsStartIndex: worklogsStartIndex } = state;
                // add fetched data to existing data
                const newSortedWorklogIds = sortedWorklogIds.slice().reverse().concat(state.sortedWorklogIds);
                const newWorklogs = {
                    ...state.worklogs,
                    ...worklogs
                };
                return {
                    sortedWorklogIds: newSortedWorklogIds,
                    worklogs: newWorklogs,
                    totalWorklogs: totalWorklogs,
                    worklogsStartIndex: worklogsStartIndex
                };
            }
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
            {
                const { payload: payload } = action;
                const { sortedWorklogIds: sortedWorklogIds, worklogs: worklogs, totalWorklogs: totalWorklogs, worklogsStartIndex: worklogsStartIndex } = payload;
                return {
                    sortedWorklogIds: sortedWorklogIds,
                    worklogs: worklogs,
                    totalWorklogs: totalWorklogs,
                    worklogsStartIndex: worklogsStartIndex
                };
            }
        case 0, $9Y7ra.DELETE_WORKLOG_SUCCESS:
            {
                const { worklogId: worklogId } = action.payload;
                const { totalWorklogs: totalWorklogs, worklogsStartIndex: worklogsStartIndex } = state;
                const sortedWorklogIds = state.sortedWorklogIds.filter((id)=>id !== worklogId);
                const worklogs = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(state.worklogs, worklogId);
                return {
                    sortedWorklogIds: sortedWorklogIds,
                    worklogs: worklogs,
                    totalWorklogs: totalWorklogs - 1,
                    worklogsStartIndex: worklogsStartIndex
                };
            }
        case 0, $9Y7ra.FETCH_SORTED_WORKLOGS_SUCCESS:
            {
                const { worklogs: worklogs, totalWorklogs: totalWorklogs, startIndex: startIndex, sortedWorklogIds: sortedWorklogIds } = action.payload;
                return {
                    sortedWorklogIds: sortedWorklogIds,
                    worklogs: worklogs,
                    totalWorklogs: totalWorklogs,
                    worklogsStartIndex: startIndex
                };
            }
        case 0, $9Y7ra.FETCH_NEWER_SORTED_WORKLOGS_SUCCESS:
            {
                const { worklogs: worklogs, totalWorklogs: totalWorklogs, startIndex: startIndex, sortedWorklogIds: sortedWorklogIds, selectedSortOrder: selectedSortOrder } = action.payload;
                const newSortedWorklogIds = selectedSortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) ? [
                    ...sortedWorklogIds,
                    ...state.sortedWorklogIds
                ] : [
                    ...state.sortedWorklogIds,
                    ...sortedWorklogIds
                ];
                return {
                    ...state,
                    worklogs: {
                        ...state.worklogs,
                        ...worklogs
                    },
                    sortedWorklogIds: newSortedWorklogIds,
                    totalWorklogs: totalWorklogs,
                    worklogsStartIndex: startIndex
                };
            }
        case 0, $9Y7ra.FETCH_OLDER_SORTED_WORKLOGS_SUCCESS:
            {
                const { worklogs: worklogs, totalWorklogs: totalWorklogs, startIndex: startIndex, sortedWorklogIds: sortedWorklogIds, selectedSortOrder: selectedSortOrder } = action.payload;
                const newSortedWorklogIds = selectedSortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) ? [
                    ...state.sortedWorklogIds,
                    ...sortedWorklogIds
                ] : [
                    ...sortedWorklogIds,
                    ...state.sortedWorklogIds
                ];
                return {
                    ...state,
                    worklogs: {
                        ...state.worklogs,
                        ...worklogs
                    },
                    sortedWorklogIds: newSortedWorklogIds,
                    totalWorklogs: totalWorklogs,
                    worklogsStartIndex: startIndex
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});



parcelRegister("5j668", function(module, exports) {

$parcel$export(module.exports, "default", () => $3495119ed673b6d9$export$2e2bcd8739ae039);

var $fYteL = parcelRequire("fYteL");
const $3495119ed673b6d9$var$initialState = null;
// @ts-expect-error - TS2304 - Cannot find name 'FetchIssueFailureDescription'.
const $3495119ed673b6d9$var$fetchIssueFailerHelper = (payload)=>{
    const { traceId: traceId, errorMessage: errorMessage, endpoint: endpoint, statusCode: statusCode } = payload;
    const returnObj = {};
    if (traceId !== null) returnObj.traceId = traceId;
    if (errorMessage !== null) returnObj.errorMessage = errorMessage;
    if (endpoint !== null) returnObj.endpoint = endpoint;
    if (statusCode !== null) returnObj.statusCode = statusCode;
    return returnObj;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3495119ed673b6d9$export$2e2bcd8739ae039 = (state = $3495119ed673b6d9$var$initialState, action)=>{
    switch(action.type){
        case 0, $fYteL.FETCH_ISSUE_FAILURE:
            return $3495119ed673b6d9$var$fetchIssueFailerHelper(action.payload);
        default:
            return state;
    }
};

});

parcelRegister("eGZog", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b3fc0d3bcdb0d20$export$2e2bcd8739ae039);

var $g2ZFU = parcelRequire("g2ZFU");

var $fYteL = parcelRequire("fYteL");
const $0b3fc0d3bcdb0d20$var$initialState = null;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0b3fc0d3bcdb0d20$export$2e2bcd8739ae039 = (state = $0b3fc0d3bcdb0d20$var$initialState, action)=>{
    switch(action.type){
        case 0, $fYteL.FETCH_ISSUE_FAILURE:
            return action.payload.error;
        case 0, $g2ZFU.LOGIN_SUCCESSFUL:
            return null;
        default:
            return state;
    }
};

});

parcelRegister("k0Cxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $6421bbc8d3e4daaa$export$2e2bcd8739ae039);


var $eOkgG = parcelRequire("eOkgG");
const $6421bbc8d3e4daaa$export$d4c72bab9d6cc13a = (0, $79689153693cd31b$export$e0428a74c92c3e81);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6421bbc8d3e4daaa$export$2e2bcd8739ae039 = (state = $6421bbc8d3e4daaa$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $eOkgG.FETCHING_ISSUE_TYPES:
            return 0, $79689153693cd31b$export$a2494662262ff756;
        case 0, $eOkgG.SET_ISSUE_TYPES:
            return 0, $79689153693cd31b$export$1e006e11f4ec3452;
        case 0, $eOkgG.FETCH_ISSUE_TYPES_FAILED:
            return 0, $79689153693cd31b$export$47b522ce8df73846;
        default:
            // prettier-ignore
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            action.type;
            return state;
    }
};

});
const $79689153693cd31b$export$e0428a74c92c3e81 = 'NONE';
const $79689153693cd31b$export$a2494662262ff756 = 'PENDING';
const $79689153693cd31b$export$1e006e11f4ec3452 = 'COMPLETE';
const $79689153693cd31b$export$47b522ce8df73846 = 'FAILED';


parcelRegister("Il408", function(module, exports) {

$parcel$export(module.exports, "default", () => $65e59f44c3838aa3$export$2e2bcd8739ae039);


var $1ybV0 = parcelRequire("1ybV0");

var $0NycV = parcelRequire("0NycV");
var $cd8TS = parcelRequire("cd8TS");

var $lvfTJ = parcelRequire("lvfTJ");

var $b2g4Y = parcelRequire("b2g4Y");

var $ltjPP = parcelRequire("ltjPP");

var $lkPj1 = parcelRequire("lkPj1");

var $6ySNE = parcelRequire("6ySNE");

var $hG9XE = parcelRequire("hG9XE");

var $fp55Q = parcelRequire("fp55Q");

var $osX9J = parcelRequire("osX9J");

var $lXPVG = parcelRequire("lXPVG");

var $49xWy = parcelRequire("49xWy");

var $02hYD = parcelRequire("02hYD");

var $hficN = parcelRequire("hficN");

var $9Y7ra = parcelRequire("9Y7ra");

var $fVCj0 = parcelRequire("fVCj0");
const $65e59f44c3838aa3$var$getNextFlagId = (flags)=>flags.length > 0 ? flags[0].id + 1 : 1;
const $65e59f44c3838aa3$var$CONTENT_LIMIT_EXCEEDED = 'CONTENT_LIMIT_EXCEEDED';
const $65e59f44c3838aa3$export$d4c72bab9d6cc13a = [];
/**
 * NOTE: Prefer to use <FlagServiceSubscriber> for new code
 */ const $65e59f44c3838aa3$var$flagsReducer = (state = $65e59f44c3838aa3$export$d4c72bab9d6cc13a, action)=>{
    // When there are multiple flags in the state, the first item
    // in the array will be the most recent flag, so as we get more
    // flags appearing, we prepend them to the state array.
    switch(action.type){
        case 0, $lkPj1.SAVE_COMMENT_FAILURE:
            if (action.payload.invalidMessage && action.payload.invalidMessage.includes("It looks like you've selected a future time for this activity. Send this activity to the current time or a past time instead.")) return [
                {
                    type: (0, $0NycV.COMMENT_FUTURE_TIME_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                }
            ];
            if (action.payload.invalidMessage && action.payload.invalidMessage.includes($65e59f44c3838aa3$var$CONTENT_LIMIT_EXCEEDED)) return [
                {
                    type: (0, $0NycV.COMMENT_CONTENT_EXCEEDED_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
            if ((0, $1ybV0.ff)('comment-limit-exceed-warning-flag_3rx53') && action.payload.invalidMessage && (0, $0NycV.COMMENTS_LIMIT_EXCEEDED_FIELDS_LIST).some((limitExceededMessage)=>limitExceededMessage === action.payload.invalidMessage)) {
                const limitFlagType = (0, $0NycV.COMMENTS_LIMIT_EXCEEDED_FIELDS_LIST).find((limitExceededMesssage)=>limitExceededMesssage === action.payload.invalidMessage);
                return [
                    {
                        type: limitFlagType,
                        id: $65e59f44c3838aa3$var$getNextFlagId(state)
                    },
                    ...state
                ];
            }
            return [
                {
                    type: action.payload.isServerValidationError ? (0, $0NycV.COMMENT_ADD_ERROR_INVALID) : (0, $0NycV.COMMENT_ADD_ERROR_GENERIC),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $lkPj1.SAVE_COMMENT_SUCCESS:
            return action.payload && action.payload.triggerIncidentSaveCommentFlag ? [
                {
                    type: (0, $0NycV.SAVE_COMMENT_SUCCESS_FLAG_MESSAGE),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state),
                    fullIssueUrl: action.payload.fullIssueUrl,
                    commentId: action.payload.comment.id
                }
            ] : state;
        case 0, $lkPj1.DELETE_COMMENT_FAILURE:
            return [
                {
                    type: (0, $0NycV.COMMENT_DELETE_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $b2g4Y.ATTACHMENT_MEDIA_SERVICES_UPLOAD_ERROR:
            return [
                {
                    type: (0, $0NycV.ATTACHMENT_ADD_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $b2g4Y.ATTACHMENT_JIRA_CREATE_FAILURE:
            if (action.payload.exceedFileSizeLimit) return [
                {
                    type: (0, $0NycV.ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
            if ((0, $1ybV0.ff)('issue.details.hard-limits.issue-attachments-limit') && action.payload.statusCode === (0, $1c3fbb431a173cc6$export$f90ac1df0b60853d)) return [
                {
                    type: (0, $0NycV.ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
            return [
                {
                    type: (0, $0NycV.ATTACHMENT_ADD_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $b2g4Y.ATTACHMENT_JIRA_CREATE_END:
            {
                const { issueKey: issueKey, numFailed: numFailed, numCreated: numCreated } = action.payload;
                if (numFailed > 0 || numCreated <= 0) return state;
                return [
                    {
                        type: (0, $0NycV.ATTACHMENT_ADD_SUCCESS),
                        id: $65e59f44c3838aa3$var$getNextFlagId(state),
                        descriptionI18nValues: {
                            issueKey: issueKey,
                            numCreated: numCreated
                        }
                    },
                    ...state
                ];
            }
        case 0, $hG9XE.EDITOR_CHANGE_FAILURE:
        case 0, $hG9XE.EDITOR_EXPANDED_FAILURE:
        case 0, $hG9XE.EDITOR_SAVE_FAILURE:
            return [
                {
                    type: (0, $0NycV.EDITOR_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        // @ts-expect-error - TS2678 - Type '"RICH_CONTENT_FIELD_CONFIRM_ERROR"' is not comparable to type '"ATTACHMENT_MEDIA_SERVICES_UPLOAD_ERROR" | "ATTACHMENT_JIRA_CREATE_FAILURE" | "EDITOR_CHANGE_FAILURE" | "EDITOR_EXPANDED_FAILURE" | "EDITOR_SAVE_FAILURE" | "DELETE_LINKED_ISSUE_FAILURE" | ... 21 more ... | "DELETE_COMMENT_FAILURE"'.
        case 0, $0NycV.RICH_CONTENT_FIELD_CONFIRM_ERROR:
            return [
                {
                    type: (0, $0NycV.RICH_CONTENT_FIELD_CONFIRM_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $49xWy.DELETE_LINKED_ISSUE_FAILURE:
            return [
                {
                    type: (0, $0NycV.DELETE_LINKED_ISSUE_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $02hYD.DELETE_REMOTE_LINKED_ISSUE_FAILURE:
            return [
                {
                    type: (0, $0NycV.DELETE_LINKED_ISSUE_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $02hYD.SAVE_REMOTE_LINKED_ISSUE_FAILURE:
            {
                const { error: error, remoteIssueKey: remoteIssueKey } = action.payload;
                if ((0, $1ybV0.ff)('issue.details.hard-limits.issue-remote-link') && error.statusCode === (0, $1c3fbb431a173cc6$export$f90ac1df0b60853d)) return [
                    {
                        type: (0, $0NycV.ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED),
                        id: $65e59f44c3838aa3$var$getNextFlagId(state)
                    },
                    ...state
                ];
                if (error.statusCode === 400) {
                    const i18nServerErrorMessage = (0, $lvfTJ.extractErrorCollectionMessages)(error.message);
                    return [
                        {
                            type: (0, $0NycV.REMOTE_LINK_VALIDATION_ERROR),
                            id: $65e59f44c3838aa3$var$getNextFlagId(state),
                            titleI18nValues: {
                                remoteIssueKey: remoteIssueKey
                            },
                            descriptionI18nValues: {
                                i18nServerErrorMessage: i18nServerErrorMessage
                            }
                        },
                        ...state
                    ];
                }
                return state;
            }
        case 0, $fVCj0.SWEET_STATE_FIELD_SAVE_FAILURE:
        case 0, $fVCj0.FIELD_SAVE_FAILURE:
            {
                const { fieldOptions: fieldOptions } = action.payload;
                const { onSaveFailureFlagType: onSaveFailureFlagType } = fieldOptions;
                if (fieldOptions.isRichTextField && action.payload.invalidMessage) {
                    if (action.payload.invalidMessage.includes($65e59f44c3838aa3$var$CONTENT_LIMIT_EXCEEDED)) return [
                        {
                            type: (0, $0NycV.RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR),
                            id: $65e59f44c3838aa3$var$getNextFlagId(state)
                        },
                        ...state
                    ];
                    if ((0, $1ybV0.ff)('issue.details.hard-limits.issue-attachments-limit') && action.payload.invalidMessage && action.payload.invalidMessage.includes((0, $cd8TS.ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE))) return [
                        {
                            type: (0, $0NycV.ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED),
                            id: $65e59f44c3838aa3$var$getNextFlagId(state)
                        },
                        ...state
                    ];
                    if (action.payload.invalidMessage && action.payload.invalidMessage.includes('is required')) return [
                        {
                            type: (0, $0NycV.RICH_CONTENT_FIELD_REQUIRED_ERROR),
                            id: $65e59f44c3838aa3$var$getNextFlagId(state)
                        },
                        ...state
                    ];
                }
                if (onSaveFailureFlagType) return [
                    {
                        type: onSaveFailureFlagType,
                        id: $65e59f44c3838aa3$var$getNextFlagId(state)
                    },
                    ...state
                ];
                return state;
            }
        case 0, $fVCj0.FIELD_SAVE_SUCCESS:
            {
                const { onSaveSuccessFlagType: onSaveSuccessFlagType } = action.payload.fieldOptions;
                if (onSaveSuccessFlagType) return [
                    {
                        type: onSaveSuccessFlagType,
                        id: $65e59f44c3838aa3$var$getNextFlagId(state),
                        descriptionI18nValues: {
                            issueKey: action.meta && action.meta.issueKey
                        }
                    },
                    ...state
                ];
                return state;
            }
        case 0, $osX9J.DISMISS_FLAG:
            return state.filter((flag)=>flag.id !== action.payload);
        case 0, $lXPVG.DELETE_ISSUE_FAILURE:
            return [
                {
                    type: (0, $0NycV.DELETE_ISSUE_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state),
                    titleI18nValues: {
                        issueKey: action.payload.issueKey
                    }
                },
                ...state
            ];
        case 0, $ltjPP.SIMPLE_CHANGE_ISSUE_TYPE_REQUEST_SUCCESS:
            return [
                {
                    type: (0, $0NycV.CHANGE_ISSUE_TYPE_SUCCESS),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state),
                    titleI18nValues: {
                        destType: action.payload.targetTypeName
                    }
                },
                ...state
            ];
        case 0, $ltjPP.SIMPLE_CHANGE_ISSUE_TYPE_REQUEST_FAILURE:
            return [
                {
                    type: (0, $0NycV.CHANGE_ISSUE_TYPE_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $0NycV.TOGGLE_WATCHING_ERROR:
            return [
                {
                    type: (0, $0NycV.WATCH_TOGGLE_UPDATE_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $0NycV.FETCH_WATCHERS_ERROR:
            return [
                {
                    type: (0, $0NycV.FETCH_WATCHERS_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $0NycV.START_WATCHING_SUCCESS:
            return [
                {
                    type: (0, $0NycV.START_WATCHING_SUCCESS),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $0NycV.STOP_WATCHING_SUCCESS:
            return [
                {
                    type: (0, $0NycV.STOP_WATCHING_SUCCESS),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $0NycV.REMOVE_WATCHER_ERROR:
            return [
                {
                    type: (0, $0NycV.REMOVE_WATCHER_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $0NycV.ADD_WATCHER_ERROR:
            return [
                {
                    type: (0, $0NycV.ADD_WATCHER_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $9Y7ra.ADD_WORKLOG_FAILURE:
            if ((0, $1ybV0.ff)('worklog-limit-exceed-warning-flag_hh86h') && action.payload && action.payload.invalidMessage) return [
                {
                    type: action.payload.invalidMessage,
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
            return [
                {
                    type: (0, $0NycV.ADD_WORKLOG_FAILURE),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $9Y7ra.ADD_WORKLOG_SUCCESS:
            return [
                {
                    type: (0, $0NycV.ADD_WORKLOG_SUCCESS),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state),
                    descriptionI18nValues: {
                        issueKey: action.payload.issueKey
                    }
                },
                ...state
            ];
        case 0, $9Y7ra.UPDATE_TIME_REMAINING_FAILURE:
            return [
                {
                    type: (0, $0NycV.UPDATE_TIME_REMAINING_FAILURE),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $9Y7ra.EDIT_WORKLOG_SUCCESS:
            return [
                {
                    type: (0, $0NycV.EDIT_WORKLOG_SUCCESS),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $9Y7ra.EDIT_WORKLOG_FAILURE:
            return [
                {
                    type: (0, $0NycV.EDIT_WORKLOG_FAILURE),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $9Y7ra.DELETE_WORKLOG_SUCCESS:
            return [
                {
                    type: (0, $0NycV.DELETE_WORKLOG_SUCCESS),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $9Y7ra.DELETE_WORKLOG_FAILURE:
            return [
                {
                    type: (0, $0NycV.DELETE_WORKLOG_FAILURE),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $6ySNE.DELETE_CONFLUENCE_PAGE_LINK_FAILED:
            return [
                {
                    type: (0, $0NycV.DELETE_CONFLUENCE_PAGE_LINK_FAILED),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $6ySNE.CREATE_CONFLUENCE_PAGE_LINK_FAILED:
            if ((0, $1ybV0.ff)('confluence-link-limit-exceed-warning-flag_1ycku') && action?.payload?.errorMessage === (0, $0NycV.ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED)) return [
                {
                    type: (0, $0NycV.CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
            return state;
        case 0, $hficN.DELETE_WEB_LINK_FAILED:
            return state;
        case 0, $0NycV.SAVE_APPROVAL_ANSWER_ERROR:
            return [
                {
                    type: (0, $0NycV.SAVE_APPROVAL_ANSWER_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $0NycV.SAVE_APPROVAL_ANSWER_SUCCESS:
            return [
                {
                    type: (0, $0NycV.SAVE_APPROVAL_ANSWER_SUCCESS),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $fp55Q.FETCH_JIRA_APP_LINKS_FAILED:
            return [
                {
                    type: (0, $0NycV.FETCH_JIRA_APP_LINKS_ERROR),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
        case 0, $49xWy.SAVE_LINKED_ISSUE_FAILURE:
            if ((0, $1ybV0.ff)('issue.details.issue-link-limit-exceed-warning-flag') && action.payload.error && action.payload.error.includes((0, $0NycV.ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED))) return [
                {
                    type: (0, $0NycV.ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED),
                    id: $65e59f44c3838aa3$var$getNextFlagId(state)
                },
                ...state
            ];
            return state;
        default:
            return state;
    }
};
var $65e59f44c3838aa3$export$2e2bcd8739ae039 = $65e59f44c3838aa3$var$flagsReducer;

});
parcelRegister("lvfTJ", function(module, exports) {

$parcel$export(module.exports, "extractErrorCollectionMessages", () => $45eaa3b8c4bbc93e$export$23b58e95e0276ec2);
const $45eaa3b8c4bbc93e$export$23b58e95e0276ec2 = (message)=>{
    try {
        const errorCollection = JSON.parse(message);
        const fieldErrors = Object.values(errorCollection.errors || {});
        const errorMessages = errorCollection.errorMessages || [];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return [
            ...errorMessages,
            ...fieldErrors
        ].join(' ');
    } catch  {
        return message;
    }
};

});

parcelRegister("hG9XE", function(module, exports) {

$parcel$export(module.exports, "EDITOR_CHANGE_FAILURE", () => $fc6cb5a40f67511c$export$6a8010963ef0fe36);
$parcel$export(module.exports, "editorChangeFailure", () => $fc6cb5a40f67511c$export$2da15f14313adb6d);
$parcel$export(module.exports, "EDITOR_EXPANDED_FAILURE", () => $fc6cb5a40f67511c$export$4db507f1d010f31b);
$parcel$export(module.exports, "editorExpandedFailure", () => $fc6cb5a40f67511c$export$aea271c2aa192535);
$parcel$export(module.exports, "EDITOR_SAVE_FAILURE", () => $fc6cb5a40f67511c$export$63e2b5cd99e5076e);
$parcel$export(module.exports, "editorSaveFailure", () => $fc6cb5a40f67511c$export$463cc08e296ebd6);
// EDITOR_CHANGE_FAILURE
const $fc6cb5a40f67511c$export$6a8010963ef0fe36 = 'EDITOR_CHANGE_FAILURE';
const $fc6cb5a40f67511c$export$2da15f14313adb6d = ()=>({
        type: $fc6cb5a40f67511c$export$6a8010963ef0fe36
    });
const $fc6cb5a40f67511c$export$4db507f1d010f31b = 'EDITOR_EXPANDED_FAILURE';
const $fc6cb5a40f67511c$export$aea271c2aa192535 = ()=>({
        type: $fc6cb5a40f67511c$export$4db507f1d010f31b
    });
const $fc6cb5a40f67511c$export$63e2b5cd99e5076e = 'EDITOR_SAVE_FAILURE';
const $fc6cb5a40f67511c$export$463cc08e296ebd6 = ()=>({
        type: $fc6cb5a40f67511c$export$63e2b5cd99e5076e
    });

});

parcelRegister("osX9J", function(module, exports) {

$parcel$export(module.exports, "DISMISS_FLAG", () => $0141d51fab861781$export$1eb56620df104bf);
$parcel$export(module.exports, "dismissFlag", () => $0141d51fab861781$export$900a08a292ad23cd);
// DISMISS_FLAG
const $0141d51fab861781$export$1eb56620df104bf = 'DISMISS_FLAG';
const $0141d51fab861781$export$900a08a292ad23cd = (id)=>({
        type: $0141d51fab861781$export$1eb56620df104bf,
        payload: id
    });

});

parcelRegister("lXPVG", function(module, exports) {

$parcel$export(module.exports, "OPEN_DELETE_ISSUE_MODAL", () => $e1881454ed158fe6$export$59274e3bd748288f);
$parcel$export(module.exports, "openDeleteIssueModal", () => $e1881454ed158fe6$export$67daf05a25acfe90);
$parcel$export(module.exports, "CLOSE_DELETE_ISSUE_MODAL", () => $e1881454ed158fe6$export$b7d3efb807f6acc5);
$parcel$export(module.exports, "closeDeleteIssueModal", () => $e1881454ed158fe6$export$28ce12224c42a471);
$parcel$export(module.exports, "DELETE_ISSUE_REQUEST", () => $e1881454ed158fe6$export$b5aece93e6508bdd);
$parcel$export(module.exports, "deleteIssueRequest", () => $e1881454ed158fe6$export$c5e735dba3ae5f63);
$parcel$export(module.exports, "DELETE_ISSUE_SUCCESS", () => $e1881454ed158fe6$export$ae1b1fa3c34f599c);
$parcel$export(module.exports, "deleteIssueSuccess", () => $e1881454ed158fe6$export$fa9725aa09ec4a27);
$parcel$export(module.exports, "DELETE_ISSUE_FAILURE", () => $e1881454ed158fe6$export$325324eac0e350bd);
$parcel$export(module.exports, "deleteIssueFailure", () => $e1881454ed158fe6$export$48f726509527e524);
const $e1881454ed158fe6$export$59274e3bd748288f = 'OPEN_DELETE_ISSUE_MODAL';
const $e1881454ed158fe6$export$67daf05a25acfe90 = ()=>({
        type: $e1881454ed158fe6$export$59274e3bd748288f
    });
const $e1881454ed158fe6$export$b7d3efb807f6acc5 = 'CLOSE_DELETE_ISSUE_MODAL';
const $e1881454ed158fe6$export$28ce12224c42a471 = ()=>({
        type: $e1881454ed158fe6$export$b7d3efb807f6acc5
    });
const $e1881454ed158fe6$export$b5aece93e6508bdd = 'DELETE_ISSUE_REQUEST';
const $e1881454ed158fe6$export$c5e735dba3ae5f63 = (issueKey, analyticsEvent, application, edition)=>({
        type: $e1881454ed158fe6$export$b5aece93e6508bdd,
        payload: {
            issueKey: issueKey,
            analyticsEvent: analyticsEvent,
            application: application,
            edition: edition
        }
    });
const $e1881454ed158fe6$export$ae1b1fa3c34f599c = 'DELETE_ISSUE_SUCCESS';
const $e1881454ed158fe6$export$fa9725aa09ec4a27 = (issueKey)=>({
        type: $e1881454ed158fe6$export$ae1b1fa3c34f599c,
        payload: issueKey
    });
const $e1881454ed158fe6$export$325324eac0e350bd = 'DELETE_ISSUE_FAILURE';
const $e1881454ed158fe6$export$48f726509527e524 = (issueKey, error)=>({
        type: $e1881454ed158fe6$export$325324eac0e350bd,
        payload: {
            issueKey: issueKey,
            error: error
        }
    });

});


parcelRegister("jdLBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $864b5edd13174e18$export$2e2bcd8739ae039);

var $cn1uL = parcelRequire("cn1uL");
const $864b5edd13174e18$export$d4c72bab9d6cc13a = {
    showInvestigateIncidentModal: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$864b5edd13174e18$export$2e2bcd8739ae039 = (state = $864b5edd13174e18$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $cn1uL.INVESTIGATE_INCIDENT_CLICKED:
            return {
                ...state,
                showInvestigateIncidentModal: true
            };
        case 0, $cn1uL.INVESTIGATE_INCIDENT_MODAL_CLOSED:
            return {
                ...state,
                showInvestigateIncidentModal: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("cn1uL", function(module, exports) {

$parcel$export(module.exports, "INVESTIGATE_INCIDENT_CLICKED", () => $db897f3d5269149a$export$a4de440518748da2);
$parcel$export(module.exports, "investigateIncidentClicked", () => $db897f3d5269149a$export$2ad9a53053d1b56e);
$parcel$export(module.exports, "INVESTIGATE_INCIDENT_MODAL_CLOSED", () => $db897f3d5269149a$export$b0849f31fb02f273);
$parcel$export(module.exports, "investigateIncidentModalClosed", () => $db897f3d5269149a$export$9af591c5d089270a);
// INVESTIGATE_INCIDENT_CLICKED
const $db897f3d5269149a$export$a4de440518748da2 = 'INVESTIGATE_INCIDENT_CLICKED';
const $db897f3d5269149a$export$2ad9a53053d1b56e = ()=>({
        type: $db897f3d5269149a$export$a4de440518748da2
    });
const $db897f3d5269149a$export$b0849f31fb02f273 = 'INVESTIGATE_INCIDENT_MODAL_CLOSED';
const $db897f3d5269149a$export$9af591c5d089270a = ()=>({
        type: $db897f3d5269149a$export$b0849f31fb02f273
    });

});


parcelRegister("eT8Vs", function(module, exports) {

$parcel$export(module.exports, "default", () => $65d935b25584dab4$export$2e2bcd8739ae039);

var $lXPVG = parcelRequire("lXPVG");
const $65d935b25584dab4$var$defaultIssueDeleteUIState = {
    isDeleteIssueModalOpen: false,
    isDeletingIssue: false,
    didIssueDeleteFail: false,
    issueKey: null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$65d935b25584dab4$export$2e2bcd8739ae039 = (state = $65d935b25584dab4$var$defaultIssueDeleteUIState, action)=>{
    switch(action.type){
        case 0, $lXPVG.OPEN_DELETE_ISSUE_MODAL:
            return {
                ...state,
                isDeleteIssueModalOpen: true
            };
        case 0, $lXPVG.CLOSE_DELETE_ISSUE_MODAL:
            return {
                ...state,
                isDeleteIssueModalOpen: false
            };
        case 0, $lXPVG.DELETE_ISSUE_REQUEST:
            return {
                ...state,
                isDeletingIssue: true,
                didIssueDeleteFail: false,
                issueKey: action.payload.issueKey,
                application: action.payload.application,
                edition: action.payload.edition
            };
        case 0, $lXPVG.DELETE_ISSUE_SUCCESS:
            return {
                ...state,
                isDeletingIssue: false,
                didIssueDeleteFail: false,
                issueKey: action.payload
            };
        case 0, $lXPVG.DELETE_ISSUE_FAILURE:
            return {
                ...state,
                isDeletingIssue: false,
                didIssueDeleteFail: true,
                issueKey: action.payload.issueKey
            };
        default:
            return state;
    }
};

});

parcelRegister("5QWjK", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbee9d38165ae356$export$2e2bcd8739ae039);
$parcel$export(module.exports, "issueLoadingStagePromiseReducer", () => $cbee9d38165ae356$export$3cb67080d5c68c4a);


var $1OJS4 = parcelRequire("1OJS4");

var $g2ZFU = parcelRequire("g2ZFU");

var $fYteL = parcelRequire("fYteL");

var $fgekC = parcelRequire("fgekC");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cbee9d38165ae356$export$2e2bcd8739ae039 = (state = (0, $d6ff0428d6ad71a2$export$26d55645375ca9a), action)=>{
    const { type: type } = action;
    switch(type){
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
        case 0, $fYteL.REFRESH_ISSUE_SUCCESS:
        case 0, $fYteL.FETCH_ISSUE_FAILURE:
            return 0, $d6ff0428d6ad71a2$export$1660a2d7c2fff354;
        case 0, $fgekC.PREVIEW_DATA_FETCHED:
            if (state === (0, $d6ff0428d6ad71a2$export$26d55645375ca9a)) return 0, $d6ff0428d6ad71a2$export$1b56cc494043d9bf;
            return state;
        case 0, $g2ZFU.LOGIN_SUCCESSFUL:
        case 0, $1OJS4.LOAD_NEW_ISSUE:
            return 0, $d6ff0428d6ad71a2$export$26d55645375ca9a;
        default:
            return state;
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $cbee9d38165ae356$var$resolve;
const $cbee9d38165ae356$var$promiseFunction = ()=>new Promise((res)=>{
        $cbee9d38165ae356$var$resolve = res;
    });
const $cbee9d38165ae356$export$3cb67080d5c68c4a = (state = $cbee9d38165ae356$var$promiseFunction(), action)=>{
    const { type: type } = action;
    switch(type){
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
        case 0, $fYteL.REFRESH_ISSUE_SUCCESS:
        case 0, $fYteL.FETCH_ISSUE_FAILURE:
            $cbee9d38165ae356$var$resolve?.();
            return null;
        case 0, $1OJS4.LOAD_NEW_ISSUE:
            return $cbee9d38165ae356$var$promiseFunction();
        default:
            return state;
    }
};

});

parcelRegister("6A6O1", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bbb9ac574550d53$export$2e2bcd8739ae039);

var $ltjPP = parcelRequire("ltjPP");
const $3bbb9ac574550d53$export$d4c72bab9d6cc13a = {
    shouldShowIssueTypeList: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3bbb9ac574550d53$export$2e2bcd8739ae039 = (state = $3bbb9ac574550d53$export$d4c72bab9d6cc13a, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $ltjPP.SHOW_ISSUE_TYPE_LIST:
            return {
                ...state,
                shouldShowIssueTypeList: payload
            };
        default:
            return state;
    }
};

});

parcelRegister("9Q7Wl", function(module, exports) {

$parcel$export(module.exports, "default", () => $54271f18cd85ee0d$export$2e2bcd8739ae039);

var $44RpM = parcelRequire("44RpM");
const $54271f18cd85ee0d$var$initialState = {
    isProformaFormInEditMode: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$54271f18cd85ee0d$export$2e2bcd8739ae039 = (state = $54271f18cd85ee0d$var$initialState, action)=>{
    switch(action.type){
        case 0, $44RpM.PROFORMA_FORM_EDIT_MODE_CHANGE:
            {
                const isProformaFormInEditMode = !!action.payload;
                return {
                    ...state,
                    isProformaFormInEditMode: isProformaFormInEditMode
                };
            }
        default:
            return state;
    }
};

});
parcelRegister("44RpM", function(module, exports) {

$parcel$export(module.exports, "PROFORMA_FORM_EDIT_MODE_CHANGE", () => $7923cb6c569982cb$export$52c06ba5cbabc8e7);
$parcel$export(module.exports, "proformaFormEditModeChange", () => $7923cb6c569982cb$export$d6c51616b4535713);
// PROFORMA_FORM_EDIT_MODE_CHANGE
const $7923cb6c569982cb$export$52c06ba5cbabc8e7 = 'PROFORMA_FORM_EDIT_MODE_CHANGE';
const $7923cb6c569982cb$export$d6c51616b4535713 = (isProformaFormInEditMode)=>({
        type: $7923cb6c569982cb$export$52c06ba5cbabc8e7,
        payload: isProformaFormInEditMode
    });

});


parcelRegister("9g9EG", function(module, exports) {

$parcel$export(module.exports, "default", () => $39b16c25d8b824c8$export$2e2bcd8739ae039);


var $ePSh2 = parcelRequire("ePSh2");

var $i89MO = parcelRequire("i89MO");
const $39b16c25d8b824c8$var$initialState = {
    projectHasSubtaskValidators: {
        status: (0, $97086cfe7b0ec751$export$26d55645375ca9a)
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$39b16c25d8b824c8$export$2e2bcd8739ae039 = (state = $39b16c25d8b824c8$var$initialState, action)=>{
    switch(action.type){
        case 0, $ePSh2.SET_CONTEXT:
            return state;
        case 0, $i89MO.FETCH_PROJECT_HAS_SUBTASK_VALIDATORS:
            return {
                ...state,
                projectHasSubtaskValidators: {
                    status: (0, $97086cfe7b0ec751$export$26d55645375ca9a)
                }
            };
        case 0, $i89MO.FETCH_PROJECT_HAS_SUBTASK_VALIDATORS_SUCCESS:
            return {
                ...state,
                projectHasSubtaskValidators: {
                    status: (0, $97086cfe7b0ec751$export$4c02edeb1b5e410a),
                    value: action.payload
                }
            };
        case 0, $i89MO.FETCH_PROJECT_HAS_SUBTASK_VALIDATORS_FAILURE:
            return {
                ...state,
                projectHasSubtaskValidators: {
                    status: (0, $97086cfe7b0ec751$export$d71930f7f5807a72)
                }
            };
        default:
            return state;
    }
};

});
parcelRegister("i89MO", function(module, exports) {

$parcel$export(module.exports, "FETCH_PROJECT_HAS_SUBTASK_VALIDATORS", () => $3ede28c9c16690e2$export$d61875efa24fd368);
$parcel$export(module.exports, "FETCH_PROJECT_HAS_SUBTASK_VALIDATORS_SUCCESS", () => $3ede28c9c16690e2$export$a5bc5e259160322c);
$parcel$export(module.exports, "fetchProjectHasSubtaskValidatorsSuccessAction", () => $3ede28c9c16690e2$export$707e13448d3dcb4e);
$parcel$export(module.exports, "FETCH_PROJECT_HAS_SUBTASK_VALIDATORS_FAILURE", () => $3ede28c9c16690e2$export$7c0fb06daf3a9cf2);
$parcel$export(module.exports, "fetchProjectHasSubtaskValidatorsFailureAction", () => $3ede28c9c16690e2$export$a3d875c24936733d);
// FETCH_PROJECT_HAS_SUBTASK_VALIDATORS
const $3ede28c9c16690e2$export$d61875efa24fd368 = 'FETCH_PROJECT_HAS_SUBTASK_VALIDATORS';
const $3ede28c9c16690e2$export$5742086f3c19c1fa = ()=>({
        type: $3ede28c9c16690e2$export$d61875efa24fd368
    });
const $3ede28c9c16690e2$export$a5bc5e259160322c = 'FETCH_PROJECT_HAS_SUBTASK_VALIDATORS_SUCCESS';
const $3ede28c9c16690e2$export$707e13448d3dcb4e = (projectHasSubtaskValidators)=>({
        type: $3ede28c9c16690e2$export$a5bc5e259160322c,
        payload: projectHasSubtaskValidators
    });
const $3ede28c9c16690e2$export$7c0fb06daf3a9cf2 = 'FETCH_PROJECT_HAS_SUBTASK_VALIDATORS_FAILURE';
const $3ede28c9c16690e2$export$a3d875c24936733d = ()=>({
        type: $3ede28c9c16690e2$export$7c0fb06daf3a9cf2
    });

});


parcelRegister("lHg9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $db056af6296fb58e$export$2e2bcd8739ae039);

var $gbvII = parcelRequire("gbvII");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$db056af6296fb58e$export$2e2bcd8739ae039 = (state = [], action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $gbvII.FETCH_RECENTLY_VISITED_CONFLUENCE_PAGES_SUCCESS:
            return payload;
        default:
            return state;
    }
};

});
parcelRegister("gbvII", function(module, exports) {

$parcel$export(module.exports, "FETCH_RECENTLY_VISITED_CONFLUENCE_PAGES_REQUEST", () => $46797b6c576caec6$export$b478ab40e4cbc419);
$parcel$export(module.exports, "fetchRecentlyVisitedConfluencePagesRequest", () => $46797b6c576caec6$export$540468d55e233677);
$parcel$export(module.exports, "FETCH_RECENTLY_VISITED_CONFLUENCE_PAGES_SUCCESS", () => $46797b6c576caec6$export$5f044a4ca958cba2);
$parcel$export(module.exports, "fetchRecentlyVisitedConfluencePagesSuccess", () => $46797b6c576caec6$export$a041a00cf3a31772);
$parcel$export(module.exports, "fetchRecentlyVisitedConfluencePagesFailed", () => $46797b6c576caec6$export$1f3c34b168962f7f);
const $46797b6c576caec6$export$b478ab40e4cbc419 = 'FETCH_RECENTLY_VISITED_CONFLUENCE_PAGES_REQUEST';
const $46797b6c576caec6$export$540468d55e233677 = ()=>({
        type: $46797b6c576caec6$export$b478ab40e4cbc419
    });
const $46797b6c576caec6$export$5f044a4ca958cba2 = 'FETCH_RECENTLY_VISITED_CONFLUENCE_PAGES_SUCCESS';
const $46797b6c576caec6$export$a041a00cf3a31772 = (response)=>({
        type: $46797b6c576caec6$export$5f044a4ca958cba2,
        payload: response
    });
const $46797b6c576caec6$export$349ea3911bd31842 = 'FETCH_RECENTLY_VISITED_CONFLUENCE_PAGES_FAILED';
const $46797b6c576caec6$export$1f3c34b168962f7f = ()=>({
        type: $46797b6c576caec6$export$349ea3911bd31842
    });

});


parcelRegister("2RFvT", function(module, exports) {

$parcel$export(module.exports, "default", () => $41cda153cfe8c967$export$2e2bcd8739ae039);

var $1GZlZ = parcelRequire("1GZlZ");
const $41cda153cfe8c967$var$initialState = {
    timestamp: 0,
    value: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$41cda153cfe8c967$export$2e2bcd8739ae039 = (state = $41cda153cfe8c967$var$initialState, action)=>{
    switch(action.type){
        case 0, $1GZlZ.SHARE_AS_COMMENT:
            return {
                timestamp: Date.now(),
                value: action.payload.value
            };
        case 0, $1GZlZ.CLEAR_SHARED_AS_COMMENT_VALUES:
            return {
                timestamp: Date.now()
            };
        default:
            return state;
    }
};

});
parcelRegister("1GZlZ", function(module, exports) {

$parcel$export(module.exports, "SHARE_AS_COMMENT", () => $53afd3588021faf0$export$35688ac63d9f4cbb);
$parcel$export(module.exports, "shareAsComment", () => $53afd3588021faf0$export$750d84fc9bdf92b1);
$parcel$export(module.exports, "CLEAR_SHARED_AS_COMMENT_VALUES", () => $53afd3588021faf0$export$ef6a5544f50b3e58);
$parcel$export(module.exports, "clearSharedAsCommentValues", () => $53afd3588021faf0$export$c14e639210a1c4a2);
const $53afd3588021faf0$export$35688ac63d9f4cbb = 'SHARE_AS_COMMENT';
const $53afd3588021faf0$export$750d84fc9bdf92b1 = (value)=>({
        type: $53afd3588021faf0$export$35688ac63d9f4cbb,
        payload: {
            value: value
        }
    });
const $53afd3588021faf0$export$ef6a5544f50b3e58 = 'CLEAR_SHARED_AS_COMMENT_VALUES';
const $53afd3588021faf0$export$c14e639210a1c4a2 = ()=>({
        type: $53afd3588021faf0$export$ef6a5544f50b3e58
    });

});


parcelRegister("dswL2", function(module, exports) {

$parcel$export(module.exports, "default", () => $74335ea734975ef3$export$2e2bcd8739ae039);

var $fYteL = parcelRequire("fYteL");

var $fgekC = parcelRequire("fgekC");
const $74335ea734975ef3$var$initialState = {
    newIssueViewLockedIn: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$74335ea734975ef3$export$2e2bcd8739ae039 = (state = $74335ea734975ef3$var$initialState, action)=>{
    switch(action.type){
        case 0, $fgekC.PREVIEW_DATA_FETCHED:
            {
                const newIssueViewLockedIn = action.payload.meta && action.payload.meta.newIssueViewLockedIn;
                if (newIssueViewLockedIn !== undefined) return {
                    ...state,
                    newIssueViewLockedIn: newIssueViewLockedIn
                };
                return state;
            }
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
            {
                const { newIssueViewLockedIn: newIssueViewLockedIn } = action.payload;
                if (newIssueViewLockedIn !== undefined) return {
                    ...state,
                    newIssueViewLockedIn: newIssueViewLockedIn
                };
                return state;
            }
        default:
            return state;
    }
};

});

parcelRegister("e1hy4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8911cc03d03d922e$export$2e2bcd8739ae039);

var $2txAX = parcelRequire("2txAX");
const $8911cc03d03d922e$var$initialState = {
    hasIssueViewMounted: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8911cc03d03d922e$export$2e2bcd8739ae039 = (state = $8911cc03d03d922e$var$initialState, action)=>{
    switch(action.type){
        case 0, $2txAX.ISSUE_VIEW_MOUNTED:
            return {
                ...state,
                hasIssueViewMounted: true
            };
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            action.type;
            return state;
    }
};

});
parcelRegister("2txAX", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_MOUNTED", () => $b4f0d380365d3118$export$7ce2b979be918963);
$parcel$export(module.exports, "issueViewMounted", () => $b4f0d380365d3118$export$42b3b8a7a76771f9);
// ISSUE_VIEW_MOUNTED
const $b4f0d380365d3118$export$7ce2b979be918963 = 'ISSUE_VIEW_MOUNTED';
const $b4f0d380365d3118$export$42b3b8a7a76771f9 = ()=>({
        type: $b4f0d380365d3118$export$7ce2b979be918963
    });

});


parcelRegister("dRuBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf775d9e95866a3e$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $i2pne = parcelRequire("i2pne");

var $3f02b = parcelRequire("3f02b");

var $d8jDg = parcelRequire("d8jDg");

var $l0tPB = parcelRequire("l0tPB");
const $cf775d9e95866a3e$export$441eff7786c9dc69 = {
    loadingStage: (0, $3f02b.initialLoadingStage),
    modal: (0, $d8jDg.initialModalState),
    highlightedWorklogId: (0, $i2pne.initialHighlightedWorklogId),
    permalinkStatus: (0, $l0tPB.initialPermalinkStatusState)
};
var $cf775d9e95866a3e$export$2e2bcd8739ae039 = (0, $huRi7.combineReducers)({
    loadingStage: (0, $3f02b.default),
    modal: (0, $d8jDg.default),
    highlightedWorklogId: (0, $i2pne.default),
    permalinkStatus: (0, $l0tPB.default)
});

});
parcelRegister("i2pne", function(module, exports) {

$parcel$export(module.exports, "initialHighlightedWorklogId", () => $4e86f785a73b5669$export$6f29d28fcfb3cb9a);
$parcel$export(module.exports, "default", () => $4e86f785a73b5669$export$2e2bcd8739ae039);

var $9Y7ra = parcelRequire("9Y7ra");
const $4e86f785a73b5669$export$6f29d28fcfb3cb9a = null;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4e86f785a73b5669$export$2e2bcd8739ae039 = (state = $4e86f785a73b5669$export$6f29d28fcfb3cb9a, action)=>{
    switch(action.type){
        case 0, $9Y7ra.ADD_WORKLOG_SUCCESS:
        case 0, $9Y7ra.EDIT_WORKLOG_SUCCESS:
            return action.payload.worklogId;
        case 0, $9Y7ra.DISPOSE_WORKLOG_APP:
            return null;
        case 0, $9Y7ra.OPEN_MODAL:
            return state;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("3f02b", function(module, exports) {

$parcel$export(module.exports, "initialLoadingStage", () => $a1b459fc7741c796$export$39b31cedc8e2537);
$parcel$export(module.exports, "default", () => $a1b459fc7741c796$export$2e2bcd8739ae039);


var $fYteL = parcelRequire("fYteL");

var $9Y7ra = parcelRequire("9Y7ra");
const $a1b459fc7741c796$export$39b31cedc8e2537 = (0, $0577deea918816be$export$26d55645375ca9a);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a1b459fc7741c796$export$2e2bcd8739ae039 = (state = $a1b459fc7741c796$export$39b31cedc8e2537, action)=>{
    switch(action.type){
        // Using ADD_WORKLOG_SUCCESS instead of ADD_WORKLOG_REQUEST as ADD_WORKLOG_REQUEST action is sent when we press
        // the SAVE button on the worklog form.
        case 0, $9Y7ra.FETCH_WORKLOGS_REQUEST_INITIAL:
        case 0, $9Y7ra.ADD_WORKLOG_SUCCESS:
        case 0, $9Y7ra.FETCH_SURROUNDING_WORKLOGS_BY_ID:
        case 0, $9Y7ra.FETCH_SORTED_WORKLOGS_REQUEST:
        case 0, $9Y7ra.FETCH_SORTED_WORKLOGS_RETRY:
            return 0, $0577deea918816be$export$26d55645375ca9a;
        case 0, $9Y7ra.FETCH_NEWER_SORTED_WORKLOGS_REQUEST:
            return 0, $0577deea918816be$export$de72bd5fd1574283;
        case 0, $9Y7ra.FETCH_OLDER_SORTED_WORKLOGS_REQUEST:
            return 0, $0577deea918816be$export$325a1eb163eebea4;
        case 0, $9Y7ra.FETCH_WORKLOGS_SUCCESS:
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
        case 0, $9Y7ra.FETCH_WORKLOGS_BY_ID_SUCCESS:
        case 0, $9Y7ra.FETCH_SORTED_WORKLOGS_SUCCESS:
        case 0, $9Y7ra.FETCH_OLDER_SORTED_WORKLOGS_SUCCESS:
        case 0, $9Y7ra.FETCH_NEWER_SORTED_WORKLOGS_SUCCESS:
            return 0, $0577deea918816be$export$1660a2d7c2fff354;
        case 0, $9Y7ra.FETCH_WORKLOGS_FAILURE:
        case 0, $9Y7ra.FETCH_SORTED_WORKLOGS_FAILURE:
            return state === (0, $0577deea918816be$export$26d55645375ca9a) ? (0, $0577deea918816be$export$103bedf43ba882db) : (0, $0577deea918816be$export$ee205fad4cd84376);
        case 0, $9Y7ra.FETCH_WORKLOGS_BY_ID_FAILURE:
            return 0, $0577deea918816be$export$103bedf43ba882db;
        default:
            {
                // prettier-ignore
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
const $0577deea918816be$export$26d55645375ca9a = 'LOADING';
const $0577deea918816be$export$de72bd5fd1574283 = 'LOADING_NEWER_WORKLOGS';
const $0577deea918816be$export$325a1eb163eebea4 = 'LOADING_OLDER_WORKLOGS';
const $0577deea918816be$export$103bedf43ba882db = 'ERROR';
const $0577deea918816be$export$ee205fad4cd84376 = 'ERROR_ADDITIONAL';
const $0577deea918816be$export$1660a2d7c2fff354 = 'COMPLETE';
const $0577deea918816be$export$1642b795d90ca875 = 'NO_MODAL';
const $0577deea918816be$export$b4c759f3741816e = 'ADD_MODAL';
const $0577deea918816be$export$46c4589329d924e6 = 'EDIT_MODAL';
const $0577deea918816be$export$1b027f122346ba5b = 'DELETE_MODAL';


parcelRegister("d8jDg", function(module, exports) {

$parcel$export(module.exports, "initialModalState", () => $cca160dc5f90a0c5$export$9a321cb20afd554b);
$parcel$export(module.exports, "default", () => $cca160dc5f90a0c5$export$2e2bcd8739ae039);


var $9Y7ra = parcelRequire("9Y7ra");
const $cca160dc5f90a0c5$export$9a321cb20afd554b = {
    openModal: (0, $0577deea918816be$export$1642b795d90ca875),
    isSaving: false,
    activeWorklogId: null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cca160dc5f90a0c5$export$2e2bcd8739ae039 = (state = $cca160dc5f90a0c5$export$9a321cb20afd554b, action)=>{
    switch(action.type){
        case 0, $9Y7ra.OPEN_MODAL:
            return {
                openModal: action.payload.modalType,
                isSaving: false,
                activeWorklogId: action.payload.worklogId
            };
        case 0, $9Y7ra.UPDATE_TIME_REMAINING_REQUEST:
        case 0, $9Y7ra.ADD_WORKLOG_REQUEST:
        case 0, $9Y7ra.EDIT_WORKLOG_REQUEST:
        case 0, $9Y7ra.DELETE_WORKLOG_REQUEST:
            return {
                ...state,
                isSaving: true
            };
        case 0, $9Y7ra.UPDATE_TIME_REMAINING_FAILURE:
        case 0, $9Y7ra.ADD_WORKLOG_FAILURE:
        case 0, $9Y7ra.EDIT_WORKLOG_FAILURE:
        case 0, $9Y7ra.DELETE_WORKLOG_FAILURE:
            return {
                ...state,
                isSaving: false
            };
        case 0, $9Y7ra.CLOSE_MODAL:
        case 0, $9Y7ra.ADD_WORKLOG_SUCCESS:
        case 0, $9Y7ra.UPDATE_TIME_REMAINING_SUCCESS:
        case 0, $9Y7ra.EDIT_WORKLOG_SUCCESS:
        case 0, $9Y7ra.DELETE_WORKLOG_SUCCESS:
            return {
                openModal: (0, $0577deea918816be$export$1642b795d90ca875),
                isSaving: false,
                activeWorklogId: null
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("l0tPB", function(module, exports) {

$parcel$export(module.exports, "initialPermalinkStatusState", () => $7e88ed6296c412c8$export$267f3ccfe4674f2d);
$parcel$export(module.exports, "default", () => $7e88ed6296c412c8$export$2e2bcd8739ae039);

var $9Y7ra = parcelRequire("9Y7ra");
const $7e88ed6296c412c8$export$6f29d28fcfb3cb9a = null;
const $7e88ed6296c412c8$export$267f3ccfe4674f2d = {
    hasScrolledPermalink: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7e88ed6296c412c8$export$2e2bcd8739ae039 = (state = $7e88ed6296c412c8$export$267f3ccfe4674f2d, action)=>{
    switch(action.type){
        case 0, $9Y7ra.SET_WORKLOG_SCROLL_STATUS:
            return {
                ...state,
                hasScrolledPermalink: action.payload.status
            };
        case 0, $9Y7ra.ADD_WORKLOG_SUCCESS:
        case 0, $9Y7ra.EDIT_WORKLOG_SUCCESS:
            return {
                ...state,
                hasScrolledPermalink: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});



parcelRegister("5TEKS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f77f4a37e16b2043$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $1WPAi = parcelRequire("1WPAi");

var $kJCwZ = parcelRequire("kJCwZ");

var $5JqpU = parcelRequire("5JqpU");

var $3ayx8 = parcelRequire("3ayx8");

var $fc4cY = parcelRequire("fc4cY");

var $20awf = parcelRequire("20awf");

var $caTc0 = parcelRequire("caTc0");

var $hwD0f = parcelRequire("hwD0f");

var $exdBZ = parcelRequire("exdBZ");

var $1MPDQ = parcelRequire("1MPDQ");

var $dIQug = parcelRequire("dIQug");

var $hQNnv = parcelRequire("hQNnv");

var $eU40m = parcelRequire("eU40m");

var $2kAsn = parcelRequire("2kAsn");

var $4cNpB = parcelRequire("4cNpB");

var $8VBxz = parcelRequire("8VBxz");

var $k6Xst = parcelRequire("k6Xst");

var $7jRSF = parcelRequire("7jRSF");

var $49kA9 = parcelRequire("49kA9");

var $6gGgy = parcelRequire("6gGgy");

var $biesR = parcelRequire("biesR");

var $lLyah = parcelRequire("lLyah");

var $eG1fU = parcelRequire("eG1fU");

var $8qtAC = parcelRequire("8qtAC");

var $b20cO = parcelRequire("b20cO");

var $k5z3G = parcelRequire("k5z3G");

var $9WSr2 = parcelRequire("9WSr2");

var $jNALT = parcelRequire("jNALT");

var $8ap8T = parcelRequire("8ap8T");

var $l5DHx = parcelRequire("l5DHx");

var $j6tFs = parcelRequire("j6tFs");

var $lfCZ1 = parcelRequire("lfCZ1");

var $bsmrP = parcelRequire("bsmrP");

var $aIBJR = parcelRequire("aIBJR");

var $aiQii = parcelRequire("aiQii");

var $3qg0I = parcelRequire("3qg0I");

var $b3oBM = parcelRequire("b3oBM");

var $kkFK3 = parcelRequire("kkFK3");

var $6kT4X = parcelRequire("6kT4X");

var $1OLof = parcelRequire("1OLof");

var $50X7n = parcelRequire("50X7n");

var $lF7gq = parcelRequire("lF7gq");

var $deTaf = parcelRequire("deTaf");

var $ckvM2 = parcelRequire("ckvM2");

var $73Nvh = parcelRequire("73Nvh");

var $5yYRf = parcelRequire("5yYRf");

var $4Gbsn = parcelRequire("4Gbsn");

var $8WUeJ = parcelRequire("8WUeJ");

var $jdymI = parcelRequire("jdymI");

var $lbVDg = parcelRequire("lbVDg");

var $qPeq9 = parcelRequire("qPeq9");

var $bSPT2 = parcelRequire("bSPT2");

var $3bf75 = parcelRequire("3bf75");

var $5imTx = parcelRequire("5imTx");

var $aawsi = parcelRequire("aawsi");

var $dtfqO = parcelRequire("dtfqO");

var $dtzZN = parcelRequire("dtzZN");

var $fl09I = parcelRequire("fl09I");

var $7uqwk = parcelRequire("7uqwk");

var $5FKM5 = parcelRequire("5FKM5");

var $hGVvs = parcelRequire("hGVvs");

var $9noVu = parcelRequire("9noVu");

var $4KEfA = parcelRequire("4KEfA");

var $3H7HO = parcelRequire("3H7HO");

var $i5SMN = parcelRequire("i5SMN");

var $jRlvC = parcelRequire("jRlvC");

var $f0ygf = parcelRequire("f0ygf");

var $2LE7w = parcelRequire("2LE7w");

var $XhALM = parcelRequire("XhALM");

var $5GD9a = parcelRequire("5GD9a");

var $it42o = parcelRequire("it42o");
const $f77f4a37e16b2043$var$getDraftEpics = ()=>[
        (0, $3ayx8.default),
        (0, $20awf.default),
        (0, $fc4cY.default),
        (0, $XhALM.default),
        (0, $3H7HO.default),
        (0, $f0ygf.default),
        (0, $i5SMN.default),
        (0, $7jRSF.default),
        (0, $biesR.default),
        (0, $eG1fU.default)
    ];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f77f4a37e16b2043$var$getEpicsSSR = ()=>[
        (0, $jNALT.default)
    ];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $f77f4a37e16b2043$var$getEpics = $f77f4a37e16b2043$var$getEpicsSSR;
$f77f4a37e16b2043$var$getEpics = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
onChange, // eslint-disable-next-line @typescript-eslint/no-explicit-any
onError, // eslint-disable-next-line @typescript-eslint/no-explicit-any
dataProvider, // eslint-disable-next-line @typescript-eslint/no-explicit-any
history, // eslint-disable-next-line @typescript-eslint/no-explicit-any
subProduct, // eslint-disable-next-line @typescript-eslint/no-explicit-any
issueRefreshServiceActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
fieldValueActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
fieldConfigActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
issueViewLayoutActions, issueViewFieldUpdateActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
forgeActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
ecosystemActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
attachmentActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
recentIssuesActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
userPreferenceActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
prefetchedResourceManager, // eslint-disable-next-line @typescript-eslint/no-explicit-any
issueScrollActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
permissionActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
jiraSettingsActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
projectContextActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
issueContextActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
workflowTransitionsActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mediaContextActions, issueRefreshLoadingActionsRef, associatedIssuesContextActions, issueViewNonCriticalDataActions)=>[
        (0, $jNALT.default),
        (0, $hwD0f.default),
        (0, $1OLof.default)({
            fieldValueActions: fieldValueActions,
            fieldConfigActions: fieldConfigActions,
            issueViewLayoutActions: issueViewLayoutActions,
            ecosystemActions: ecosystemActions,
            userPreferenceActions: userPreferenceActions,
            permissionActions: permissionActions,
            attachmentActions: attachmentActions,
            prefetchedResourceManager: prefetchedResourceManager,
            jiraSettingsActions: jiraSettingsActions,
            projectContextActions: projectContextActions,
            issueContextActions: issueContextActions,
            associatedIssuesContextActions: associatedIssuesContextActions,
            issueRefreshServiceActions: issueRefreshServiceActions
        }),
        (0, $73Nvh.default)({
            issueRefreshServiceActions: issueRefreshServiceActions,
            fieldValueActions: fieldValueActions,
            fieldConfigActions: fieldConfigActions,
            issueViewLayoutActions: issueViewLayoutActions,
            userPreferenceActions: userPreferenceActions,
            permissionActions: permissionActions,
            attachmentActions: attachmentActions,
            projectContextActions: projectContextActions,
            issueContextActions: issueContextActions,
            ecosystemActions: ecosystemActions,
            associatedIssuesContextActions: associatedIssuesContextActions,
            prefetchedResourceManager: prefetchedResourceManager,
            issueRefreshLoadingActionsRef: issueRefreshLoadingActionsRef,
            issueViewNonCriticalDataActions: issueViewNonCriticalDataActions
        }),
        (0, $b3oBM.default)(prefetchedResourceManager, forgeActions),
        (0, $dIQug.default),
        (0, $5FKM5.default),
        (0, $5GD9a.default)(fieldValueActions, fieldConfigActions, workflowTransitionsActions, associatedIssuesContextActions, issueContextActions, issueViewNonCriticalDataActions),
        (0, $jdymI.default),
        (0, $8qtAC.default),
        (0, $49kA9.default)(attachmentActions),
        (0, $6gGgy.fetchCommentsRequest),
        (0, $6gGgy.fetchSortedCommentsRequest),
        (0, $exdBZ.default),
        (0, $6gGgy.fetchAttachmentCommentRequest)(issueScrollActions),
        (0, $7uqwk.default),
        (0, $hQNnv.default)(fieldValueActions),
        (0, $kJCwZ.default)((0, $5JqpU.baseUrlSelector), (0, $5JqpU.issueKeySelector), subProduct, attachmentActions, issueContextActions, mediaContextActions),
        (0, $2kAsn.default),
        (0, $lLyah.default),
        (0, $2LE7w.default),
        (0, $8ap8T.default),
        (0, $lF7gq.default),
        (0, $50X7n.default),
        (0, $aiQii.default),
        (0, $eU40m.default)(attachmentActions),
        ...$f77f4a37e16b2043$var$getDraftEpics(),
        (0, $4KEfA.default)(onChange, issueViewFieldUpdateActions),
        (0, $qPeq9.default),
        (0, $j6tFs.default),
        ...(0, $caTc0.isInMentionsIndicatorExperimentCohort)() ? [
            (0, $fl09I.scrollToCommentEpic)(issueScrollActions, history)
        ] : [],
        (0, $4cNpB.default),
        (0, $8VBxz.default),
        (0, $deTaf.issueNavigationEpic)(history, dataProvider, recentIssuesActions, issueContextActions),
        (0, $deTaf.projectNavigationEpic),
        (0, $deTaf.sprintNavigationEpic),
        (0, $kkFK3.default)(dataProvider, associatedIssuesContextActions),
        (0, $6kT4X.default),
        (0, $jRlvC.default),
        (0, $lfCZ1.default)(onError),
        (0, $b20cO.default),
        (0, $it42o.default),
        (0, $5imTx.default),
        (0, $aawsi.default),
        (0, $3bf75.default)(projectContextActions),
        (0, $k6Xst.default),
        (0, $dtzZN.default),
        (0, $8WUeJ.default),
        (0, $k5z3G.default),
        (0, $9WSr2.default),
        (0, $ckvM2.default)(issueRefreshServiceActions),
        (0, $1WPAi.worklogsEpic)(attachmentActions, issueScrollActions),
        (0, $9noVu.default),
        (0, $bsmrP.default),
        (0, $lbVDg.default),
        (0, $4Gbsn.default),
        (0, $5yYRf.default),
        (0, $hGVvs.deleteWebLink),
        (0, $hGVvs.createWebLink),
        (0, $hGVvs.createWebLinkRetry),
        (0, $bSPT2.default),
        (0, $l5DHx.deleteRemoteLinkedIssuesEpic),
        (0, $dtfqO.saveRemoteLinkedIssueRequestEpic),
        (0, $dtfqO.saveRemoteLinkedIssueRetryEpic),
        (0, $1MPDQ.default),
        (0, $aIBJR.default)(associatedIssuesContextActions),
        (0, $3qg0I.default)(associatedIssuesContextActions)
    ];
const $f77f4a37e16b2043$var$getEpicsWrapper = (onChange, onError, dataProvider, history, subProduct, issueRefreshServiceActions, fieldValueActions, fieldConfigActions, issueViewLayoutActions, issueViewFieldUpdateActions, forgeActions, ecosystemActions, attachmentActions, recentIssuesActions, userPreferenceActions, prefetchedResourceManager, issueScrollActions, permissionActions, jiraSettingsActions, projectContextActions, issueContextActions, workflowTransitionsActions, mediaContextActions, issueRefreshLoadingActionsRef, associatedIssuesContextActions, issueViewNonCriticalDataActions)=>{
    return $f77f4a37e16b2043$var$getEpics(onChange, onError, dataProvider, history, subProduct, issueRefreshServiceActions, fieldValueActions, fieldConfigActions, issueViewLayoutActions, issueViewFieldUpdateActions, forgeActions, ecosystemActions, attachmentActions, recentIssuesActions, userPreferenceActions, prefetchedResourceManager, issueScrollActions, permissionActions, jiraSettingsActions, projectContextActions, issueContextActions, workflowTransitionsActions, mediaContextActions, issueRefreshLoadingActionsRef, associatedIssuesContextActions, issueViewNonCriticalDataActions);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f77f4a37e16b2043$export$2e2bcd8739ae039 = (onChange, onError, dataProvider, history, subProduct, issueRefreshServiceActions, fieldValueActions, fieldConfigActions, issueViewLayoutActions, issueViewFieldUpdateActions, forgeActions, ecosystemActions, attachmentActions, recentIssuesActions, userPreferenceActions, prefetchedResourceManager, issueScrollActions, permissionActions, jiraSettingsActions, projectContextActions, issueContextActions, workflowTransitionsActions, mediaContextActions, issueRefreshLoadingActionsRef, associatedIssuesContextActions, issueViewNonCriticalDataActions)=>(0, $bd1K7.combineEpics)(...$f77f4a37e16b2043$var$getEpicsWrapper(onChange, onError, dataProvider, history, subProduct, issueRefreshServiceActions, fieldValueActions, fieldConfigActions, issueViewLayoutActions, issueViewFieldUpdateActions, forgeActions, ecosystemActions, attachmentActions, recentIssuesActions, userPreferenceActions, prefetchedResourceManager, issueScrollActions, permissionActions, jiraSettingsActions, projectContextActions, issueContextActions, workflowTransitionsActions, mediaContextActions, issueRefreshLoadingActionsRef, associatedIssuesContextActions, issueViewNonCriticalDataActions));

});
parcelRegister("1WPAi", function(module, exports) {

$parcel$export(module.exports, "worklogsEpic", () => $7c2a0de86c677607$export$4718836c54096570);

var $bd1K7 = parcelRequire("bd1K7");

var $kvdqJ = parcelRequire("kvdqJ");

var $a2fsc = parcelRequire("a2fsc");

var $ijnfJ = parcelRequire("ijnfJ");

var $3ydt3 = parcelRequire("3ydt3");

var $gDwbT = parcelRequire("gDwbT");

var $gZCaw = parcelRequire("gZCaw");

var $jXhYd = parcelRequire("jXhYd");
const $7c2a0de86c677607$export$d5e192d2fcb24dbc = (attachmentActions, issueScrollActions)=>// @ts-expect-error - TS2769 - No overload matches this call.
    (0, $bd1K7.combineEpics)((0, $kvdqJ.combinedEpics), (0, $gZCaw.fetchWorklogsRequest), (0, $gZCaw.fetchWorklogsRequestInitial), (0, $gDwbT.fetchSurroundingWorklogsByIdEpic), (0, $gDwbT.fetchSurroundingWorklogsAttachmentScroll)(issueScrollActions), (0, $ijnfJ.default), (0, $a2fsc.default)(attachmentActions), (0, $jXhYd.fetchSortedWorklogsRequest), (0, $3ydt3.fetchNewerSortedWorklogsEpic), (0, $3ydt3.fetchOlderSortedWorklogsEpic));
const $7c2a0de86c677607$export$4718836c54096570 = (attachmentActions, issueScrollActions)=>$7c2a0de86c677607$export$d5e192d2fcb24dbc(attachmentActions, issueScrollActions);

});
parcelRegister("kvdqJ", function(module, exports) {

$parcel$export(module.exports, "combinedEpics", () => $b6e585fe0f1d9af8$export$ec464c9427390dad);
parcelRequire("8OtG5");
parcelRequire("jyKN9");
parcelRequire("9u6v2");
parcelRequire("l5lul");
parcelRequire("flmol");
parcelRequire("iects");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $jUhyG = parcelRequire("jUhyG");


var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $bPG0x = parcelRequire("bPG0x");

var $eDEru = parcelRequire("eDEru");


var $eH7pq = parcelRequire("eH7pq");

var $cxdSy = parcelRequire("cxdSy");

var $l129t = parcelRequire("l129t");

var $9Y7ra = parcelRequire("9Y7ra");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $dUqHv = parcelRequire("dUqHv");

var $lO4Or = parcelRequire("lO4Or");

var $7Vbpp = parcelRequire("7Vbpp");

var $6vrw7 = parcelRequire("6vrw7");

var $4AP4i = parcelRequire("4AP4i");
var $hsc5W = parcelRequire("hsc5W");
var $4NX2u = parcelRequire("4NX2u");

var $5XLtf = parcelRequire("5XLtf");

var $iA24H = parcelRequire("iA24H");

var $9Y7ra = parcelRequire("9Y7ra");
const $b6e585fe0f1d9af8$export$26c67be885e743f6 = (action$, store)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    action$.ofType((0, $9Y7ra.ADD_WORKLOG_REQUEST)).switchMap((action)=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueKey = (0, $6vrw7.toIssueKey)((0, $5JqpU.issueKeySelector)(state));
        const projectType = (0, $jZDJX.projectTypeSelector)(state);
        const config = (0, $dUqHv.timeTrackingConfigurationSelector)(state);
        const timeTracking = (0, $dUqHv.timeTrackingSelector)(state);
        const parseTime = (0, $eH7pq.default)(config.daysPerWeek, config.hoursPerDay);
        const { payload: { values: values }, meta: { analyticsEvent: analyticsEvent } } = action;
        const { timeRemaining: timeRemaining, workDescription: workDescription } = values || {};
        const shouldFetchViewContext = (0, $4AP4i.isNotEmptyComment)(workDescription) ? (0, $7Vbpp.hasMediaFileNodes)(workDescription) : false;
        return (0, $3JafE.Observable).from((0, $5XLtf.default)(baseUrl, issueKey, values)).mergeMap((newWorklog)=>{
            const transformedWorklog = (0, $hsc5W.transformWorklog)(newWorklog);
            const withComment = (0, $4AP4i.default)(transformedWorklog);
            (0, $jUhyG.fireTrackAnalytics)(analyticsEvent, {
                action: 'added',
                actionSubjectId: transformedWorklog.id,
                attributes: {
                    withComment: withComment
                }
            });
            const timeSpentSeconds = (timeTracking.timeSpentSeconds || 0) + newWorklog.timeSpentSeconds;
            (0, $bPG0x.sendExperienceAnalytics)({
                getExperienceDescription: ()=>(0, $4NX2u.worklogExperienceDescription)({
                        wasSuccessful: true,
                        action: 'ADD',
                        analyticsSource: 'addWorklogEpic',
                        projectType: projectType
                    })
            });
            // we need to ensure the value that is set into redux
            // is the same value that was sent to the backend
            const remainingEstimateSeconds = typeof values.timeRemainingSeconds === 'number' ? parseTime((0, $eDEru.secondsToWholeMinuteTimeString)(values.timeRemainingSeconds)) : null;
            // conditionally override remainingEstimateSeconds
            const newTimeTracking = remainingEstimateSeconds !== null ? {
                ...timeTracking,
                timeSpentSeconds: timeSpentSeconds,
                remainingEstimateSeconds: remainingEstimateSeconds
            } : {
                ...timeTracking,
                timeSpentSeconds: timeSpentSeconds
            };
            return (0, $3JafE.Observable).of((0, $9Y7ra.addWorklogSuccess)(newWorklog.id, newTimeTracking, {
                shouldFetchViewContext: shouldFetchViewContext
            }, issueKey), // @ts-expect-error - TS2769 - No overload matches this call.
            (0, $9Y7ra.fetchSurroundingWorklogsById)(newWorklog.id));
        }).catch((error)=>{
            let invalidMessage;
            if (error.statusCode === (0, $1c3fbb431a173cc6$export$f90ac1df0b60853d)) {
                if ((0, $1ybV0.ff)('worklog-limit-exceed-warning-flag_hh86h') || (0, $1ybV0.ff)('issue.details.hard-limits.issue-attachments-limit')) invalidMessage = (0, $cxdSy.getIssueLimitErrorField)(error);
            }
            // BENTO-3387 - Log the length of the time logged/time remaining input values to
            // verify whether errors are being caused by users entering large values
            const { timeLogged: timeLogged } = values;
            const logTimeLength = timeLogged && timeLogged.length;
            const remainingTimeLength = timeRemaining && timeRemaining.length;
            const lengths = {
                logTimeLength: logTimeLength,
                remainingTimeLength: remainingTimeLength
            };
            (0, $bPG0x.sendExperienceAnalytics)({
                getExperienceDescription: ({ wasSuccessful: wasSuccessful, statusCode: statusCode })=>{
                    if (!wasSuccessful) (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.activity.worklog.add-worklog', `Failed to save new worklog with input lengths: ${JSON.stringify(lengths)}`, error);
                    return (0, $4NX2u.worklogExperienceDescription)({
                        wasSuccessful: wasSuccessful,
                        action: 'ADD',
                        analyticsSource: 'addWorklogEpic',
                        projectType: projectType,
                        errorMessage: wasSuccessful ? undefined : error.message,
                        ...(0, $1ybV0.ff)('worklog-limit-exceed-warning-flag_hh86h') ? {
                            statusCode: statusCode
                        } : {}
                    });
                },
                error: error
            });
            return (0, $3JafE.Observable).of((0, $9Y7ra.addWorklogFailure)({
                invalidMessage: invalidMessage
            }));
        });
    });
const $b6e585fe0f1d9af8$export$b241a13f5eb6165 = (action$, store)=>action$.ofType((0, $9Y7ra.UPDATE_TIME_REMAINING_REQUEST)) // eslint-disable-line @typescript-eslint/consistent-type-assertions
    .switchMap((action)=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueId = (0, $jZDJX.idSelector)(state);
        const projectType = (0, $jZDJX.projectTypeSelector)(state);
        const config = (0, $dUqHv.timeTrackingConfigurationSelector)(state);
        const parseTime = (0, $eH7pq.default)(config.daysPerWeek, config.hoursPerDay);
        const { payload: { timeRemaining: payloadTimeRemaining }, meta: { analyticsEvent: analyticsEvent } } = action;
        // Convert the timeRemaining from time-string to minutes because the
        // backend doesn't support weeks/days/hours with decimal places other than
        // 0.25, 0.5 or 0.75
        // we have to convert the final value to a whole number as passing decimal
        // values in minutes errors.
        const timeRemaining = (0, $eDEru.secondsToWholeMinuteTimeString)(parseTime(payloadTimeRemaining) || 0);
        return (0, $3JafE.Observable).from((0, $iA24H.default)(baseUrl, issueId, timeRemaining)).do(()=>{
            (0, $bPG0x.sendExperienceAnalytics)({
                getExperienceDescription: ()=>(0, $4NX2u.worklogExperienceDescription)({
                        wasSuccessful: true,
                        action: 'ADD',
                        analyticsSource: 'updateTimeRemainingEpic',
                        projectType: projectType
                    })
            });
            (0, $jUhyG.fireTrackAnalytics)(analyticsEvent, {
                action: 'time-remaining-updated'
            });
        }).map(()=>(0, $9Y7ra.updateTimeRemainingSuccess)(parseTime(timeRemaining))).catch((error)=>{
            // BENTO-3387 - Log the length of the time remaining input value to
            // verify whether errors are being caused by users entering large values
            const remainingTimeLength = timeRemaining && timeRemaining.length;
            (0, $bPG0x.sendExperienceAnalytics)({
                getExperienceDescription: ({ wasSuccessful: wasSuccessful, statusCode: statusCode })=>{
                    if (!wasSuccessful) (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.activity.worklog.update-time-remaining', `Failed to update time remaining with input length: ${remainingTimeLength}`, error);
                    return (0, $4NX2u.worklogExperienceDescription)({
                        wasSuccessful: wasSuccessful,
                        action: 'ADD',
                        analyticsSource: 'updateTimeRemainingEpic',
                        projectType: projectType,
                        errorMessage: wasSuccessful ? undefined : error.message,
                        ...(0, $1ybV0.ff)('worklog-limit-exceed-warning-flag_hh86h') ? {
                            statusCode: statusCode
                        } : {}
                    });
                },
                error: error
            });
            return (0, $3JafE.Observable).of((0, $9Y7ra.updateTimeRemainingFailure)());
        });
    });
const $b6e585fe0f1d9af8$export$bf874169c9dc4624 = (action$, store)=>action$.ofType((0, $l129t.FIELD_EDIT_REQUEST_EXTERNAL))// @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'Action'.
    .filter((action)=>action.payload?.fieldId === (0, $lO4Or.TIME_TRACKING_TYPE)).filter(()=>(0, $dUqHv.canLogTimeSelector)(store.getState())).map(()=>(0, $9Y7ra.openModal)((0, $0577deea918816be$export$b4c759f3741816e), null));
const $b6e585fe0f1d9af8$export$ec464c9427390dad = (0, $bd1K7.combineEpics)(// @ts-expect-error - Action mismatch
$b6e585fe0f1d9af8$export$26c67be885e743f6, $b6e585fe0f1d9af8$export$b241a13f5eb6165, $b6e585fe0f1d9af8$export$bf874169c9dc4624);

});
parcelRegister("jUhyG", function(module, exports) {

$parcel$export(module.exports, "fireTrackAnalytics", () => $5b05bd1f53288b4a$export$13990ad4625571ed);

var $3LiTJ = parcelRequire("3LiTJ");

var $etqm0 = parcelRequire("etqm0");

var $klunD = parcelRequire("klunD");
const $5b05bd1f53288b4a$var$isNotUndefined = (a)=>a !== undefined;
const $5b05bd1f53288b4a$var$mapPayload = (payload)=>{
    const context = (0, $klunD.default)(payload);
    const { action: action, actionSubjectId: actionSubjectId } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        action: action,
        actionSubjectId: actionSubjectId
    }, $5b05bd1f53288b4a$var$isNotUndefined);
};
const $5b05bd1f53288b4a$export$13990ad4625571ed = (event, payload)=>{
    event.update({
        ...$5b05bd1f53288b4a$var$mapPayload(payload),
        analyticsType: (0, $etqm0.TRACK_EVENT_TYPE)
    }).fire();
};

});

parcelRegister("bPG0x", function(module, exports) {

$parcel$export(module.exports, "sendExperienceAnalytics", () => $a32ae583d0db97bd$export$4a95ada1b8228562);



var $JRB5w = parcelRequire("JRB5w");

var $4ceCM = parcelRequire("4ceCM");
const $a32ae583d0db97bd$var$successfulErrorStatusCodes = [
    (0, $1c3fbb431a173cc6$export$9de493bcd9b1d977),
    (0, $1c3fbb431a173cc6$export$67d19e9a991baa07),
    (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef)
];
const $a32ae583d0db97bd$var$abortableStatusCodes = [
    (0, $1c3fbb431a173cc6$export$6763168a631449a2)
];
const $a32ae583d0db97bd$var$classificationPayload = {
    ANALYTICS_SUCCESS: {
        wasSuccessful: true,
        action: (0, $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a)
    },
    ANALYTICS_ABORT: {
        wasSuccessful: true,
        action: (0, $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8)
    },
    ANALYTICS_FAIL: {
        wasSuccessful: false,
        action: (0, $99e7a4e4cbcb5db0$export$b48b3d1872522384)
    }
};
const $a32ae583d0db97bd$var$isErrorOmitted = (error)=>error === null;
const $a32ae583d0db97bd$var$isStatusCodeConsideredSuccessful = (error)=>// @ts-expect-error - TS2345 - Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
    $a32ae583d0db97bd$var$successfulErrorStatusCodes.includes(error?.statusCode);
const $a32ae583d0db97bd$var$isStatusCodeAbortable = (error)=>// @ts-expect-error - TS2345 - Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
    $a32ae583d0db97bd$var$abortableStatusCodes.includes(error?.statusCode);
const $a32ae583d0db97bd$var$reduceClassification = (error)=>{
    if ($a32ae583d0db97bd$var$isErrorOmitted(error) || $a32ae583d0db97bd$var$isStatusCodeConsideredSuccessful(error)) return 'ANALYTICS_SUCCESS';
    if ($a32ae583d0db97bd$var$isStatusCodeAbortable(error)) return 'ANALYTICS_ABORT';
    return 'ANALYTICS_FAIL';
};
const $a32ae583d0db97bd$export$4a95ada1b8228562 = ({ getExperienceDescription: getExperienceDescription, error: error = null })=>{
    // We intentionally do not capture analytics during a client a fetch error. However, we do
    // return the successful state so external flows can record logs
    if (!$a32ae583d0db97bd$var$isErrorOmitted(error) && (0, $JRB5w.isClientFetchError)(error)) {
        getExperienceDescription({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            wasSuccessful: $a32ae583d0db97bd$var$isErrorOmitted(error),
            statusCode: error?.statusCode
        });
        return;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const classification = $a32ae583d0db97bd$var$reduceClassification(error);
    const { action: action, wasSuccessful: wasSuccessful } = $a32ae583d0db97bd$var$classificationPayload[classification];
    (0, $4ceCM.sendExperienceAnalytics)({
        ...getExperienceDescription({
            wasSuccessful: wasSuccessful,
            statusCode: error?.statusCode
        }),
        action: action
    });
};

});

parcelRegister("eDEru", function(module, exports) {

$parcel$export(module.exports, "secondsToWholeMinuteTimeString", () => $e60ef9ff18ec9e8a$export$e090c313e2cb7081);
const $e60ef9ff18ec9e8a$var$SECONDS_PER_MINUTE = 60;
const $e60ef9ff18ec9e8a$export$e090c313e2cb7081 = (seconds)=>`${Math.round(seconds / $e60ef9ff18ec9e8a$var$SECONDS_PER_MINUTE)}m`;
var $e60ef9ff18ec9e8a$export$2e2bcd8739ae039 = $e60ef9ff18ec9e8a$export$e090c313e2cb7081;

});

parcelRegister("eH7pq", function(module, exports) {

$parcel$export(module.exports, "default", () => $283b92ae394aef5a$export$2e2bcd8739ae039);
const $283b92ae394aef5a$var$MINUTES_PER_HOUR = 60;
const $283b92ae394aef5a$var$SECONDS_PER_MINUTE = 60;
const $283b92ae394aef5a$var$UNIT_STRING_PATTERN = /^(\d+(?:\.\d+)?)([wdhm])$/;
const $283b92ae394aef5a$var$convertToUnitQuantity = (rawString)=>{
    const matches = $283b92ae394aef5a$var$UNIT_STRING_PATTERN.exec(rawString);
    if (!matches) return null;
    return {
        quantity: parseFloat(matches[1]),
        unit: matches[2]
    };
};
const $283b92ae394aef5a$var$timeStringToSeconds = (daysPerWeek, hoursPerDay)=>{
    const unitDefinitions = [
        {
            unit: 'w',
            seconds: daysPerWeek * hoursPerDay * $283b92ae394aef5a$var$MINUTES_PER_HOUR * $283b92ae394aef5a$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'd',
            seconds: hoursPerDay * $283b92ae394aef5a$var$MINUTES_PER_HOUR * $283b92ae394aef5a$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'h',
            seconds: $283b92ae394aef5a$var$MINUTES_PER_HOUR * $283b92ae394aef5a$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'm',
            seconds: $283b92ae394aef5a$var$SECONDS_PER_MINUTE
        }
    ];
    return (timeString)=>{
        // Split up the time string, and parse it into an array of UnitQuantities.
        const unitQuantities = timeString.split(' ').map($283b92ae394aef5a$var$convertToUnitQuantity);
        let quantitiesConsumed = 0;
        let seconds = 0;
        for(let i = 0; i < unitDefinitions.length; i += 1){
            // If we have consumed all the quantity-unit pairs in the string
            // we are done.
            if (quantitiesConsumed === unitQuantities.length) break;
            const unitDefinition = unitDefinitions[i];
            const unitQuantity = unitQuantities[quantitiesConsumed];
            if (!unitQuantity) return null;
            // If the quantity-unit pair matches the unit definition we are up to, consume it.
            if (unitQuantity.unit === unitDefinition.unit) {
                seconds += unitQuantity.quantity * unitDefinition.seconds;
                quantitiesConsumed += 1;
            }
        }
        // We have made it through all the unit definitions, but there is still some left-over input
        if (quantitiesConsumed < unitQuantities.length) return null;
        return Math.floor(seconds);
    };
};
var $283b92ae394aef5a$export$2e2bcd8739ae039 = $283b92ae394aef5a$var$timeStringToSeconds;

});

parcelRegister("dUqHv", function(module, exports) {

$parcel$export(module.exports, "timeTrackingConfigurationSelector", () => $19e8daae96f3fb3a$export$7736678592f9894f);
$parcel$export(module.exports, "timeTrackingSelector", () => $19e8daae96f3fb3a$export$9641adea2fb165a5);
$parcel$export(module.exports, "isNativeJiraTimeTrackingEnabledSelector", () => $19e8daae96f3fb3a$export$393ba36370acb359);
$parcel$export(module.exports, "canLogTimeSelector", () => $19e8daae96f3fb3a$export$7fce678c5492d390);
$parcel$export(module.exports, "worklogLoadingStageSelector", () => $19e8daae96f3fb3a$export$19e0b8b93bf29f24);
$parcel$export(module.exports, "shouldDisplayRollUpDataControlSelector", () => $19e8daae96f3fb3a$export$d07adbd6fcb1649b);
$parcel$export(module.exports, "timeTrackingWithSubtasksOrChildrenRollupSelector", () => $19e8daae96f3fb3a$export$9c9932e056c0e818);
$parcel$export(module.exports, "openModalSelector", () => $19e8daae96f3fb3a$export$88c9b23c79900aaf);
$parcel$export(module.exports, "modalIsSavingSelector", () => $19e8daae96f3fb3a$export$a98a586066aec6ec);
$parcel$export(module.exports, "worklogsSelector", () => $19e8daae96f3fb3a$export$daafdb692849423a);
$parcel$export(module.exports, "activeWorklogSelector", () => $19e8daae96f3fb3a$export$a59b316c5487070c);
$parcel$export(module.exports, "sortedWorklogsSelector", () => $19e8daae96f3fb3a$export$cac06797b22541fc);
$parcel$export(module.exports, "totalWorklogsSelector", () => $19e8daae96f3fb3a$export$53e31443c2badd6b);
$parcel$export(module.exports, "worklogsStartIndexSelector", () => $19e8daae96f3fb3a$export$4e75bc36a7a5dc79);

var $df4Sl = parcelRequire("df4Sl");

var $lzTt0 = parcelRequire("lzTt0");

var $3l6tm = parcelRequire("3l6tm");

var $f9RL0 = parcelRequire("f9RL0");

var $1b2Vj = parcelRequire("1b2Vj");

var $75LXB = parcelRequire("75LXB");

var $dv9do = parcelRequire("dv9do");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");
const $19e8daae96f3fb3a$export$7736678592f9894f = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.jiraSettings.timeTrackingConfiguration);
const $19e8daae96f3fb3a$export$9641adea2fb165a5 = (0, $fokFV.fieldPersistedValueSelector)((0, $f9RL0.TIME_TRACKING));
const $19e8daae96f3fb3a$export$aafac6da48dc3724 = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$export$7736678592f9894f, (timeTrackingConfiguration)=>timeTrackingConfiguration.isTimeTrackingEnabled);
const $19e8daae96f3fb3a$export$393ba36370acb359 = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$export$aafac6da48dc3724, (0, $fokFV.availableFieldIdsSelector), (isTimeTrackingEnabled, availableFields)=>isTimeTrackingEnabled && availableFields.includes((0, $f9RL0.TIME_TRACKING)));
const $19e8daae96f3fb3a$export$7fce678c5492d390 = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$export$393ba36370acb359, (0, $9F6MO.permissionsSelector), (0, $5JqpU.isMobileSelector), (isNativeJiraTimeTrackingEnabled, permissions, isMobile)=>isNativeJiraTimeTrackingEnabled && permissions.canLogWork && !isMobile);
const $19e8daae96f3fb3a$var$worklogUiSelector = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.worklog);
const $19e8daae96f3fb3a$var$modalSelector = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$var$worklogUiSelector, (uiState)=>uiState.modal);
const $19e8daae96f3fb3a$export$19e0b8b93bf29f24 = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$var$worklogUiSelector, (uiState)=>uiState.loadingStage);
const $19e8daae96f3fb3a$export$587bf1a48c8fe6f7 = (0, $df4Sl.createSelector)((0, $fokFV.fieldPersistedValueSelector)((0, $f9RL0.SUBTASKS)), (0, $fokFV.fieldPersistedValueSelector)((0, $f9RL0.CHILDREN_ISSUES)), (0, $1b2Vj.hierarchyLevelSelector), (subtasks, childIssues, newIssueHierarchyLevel)=>childIssues?.length && (0, $3l6tm.isBaseHierarchyLevel)(newIssueHierarchyLevel) ? childIssues : subtasks);
const $19e8daae96f3fb3a$export$b3764c489e8d015b = (0, $df4Sl.createSelector)((0, $75LXB.persistedChildrenIssuesSelector), (0, $dv9do.hasSubtasksSelector), (0, $1b2Vj.hierarchyLevelSelector), (0, $fokFV.childIssuesLimitUrlSelector), (childIssues, hasSubtasks, newIssueHierarchyLevel, getChildIssuesLimitUrl)=>hasSubtasks || (Boolean(childIssues?.length) || Boolean(getChildIssuesLimitUrl((0, $f9RL0.EPIC_ISSUES)) || getChildIssuesLimitUrl((0, $f9RL0.CHILDREN_ISSUES)))) && (0, $3l6tm.isBaseHierarchyLevel)(newIssueHierarchyLevel));
const $19e8daae96f3fb3a$var$addTimeTrackingValues = (originalValue, newValue)=>(0, (/*@__PURE__*/$parcel$interopDefault($lzTt0)))(originalValue) || (0, (/*@__PURE__*/$parcel$interopDefault($lzTt0)))(newValue) ? (originalValue || 0) + (newValue || 0) : originalValue;
// @ts-expect-error - TS7006 - Parameter 'fields' implicitly has an 'any' type.
const $19e8daae96f3fb3a$var$getSubFieldByName = (fields, fieldName)=>Array.isArray(fields) ? fields.find((field)=>field.key === fieldName)?.value : fields && fields[fieldName];
const $19e8daae96f3fb3a$export$135345e9de5fc488 = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$export$587bf1a48c8fe6f7, (0, $jZDJX.isClassicProjectSelector), (0, $fokFV.childIssuesLimitUrlSelector), (childIssues, isClassicProject, getChildIssuesLimitUrl)=>{
    // Time tracking data is always available on classic subtasks even if the Time tracking field isn't configured
    if (isClassicProject) return true;
    if (getChildIssuesLimitUrl((0, $f9RL0.CHILDREN_ISSUES)) || getChildIssuesLimitUrl((0, $f9RL0.EPIC_ISSUES))) return true;
    if (!childIssues || childIssues.length === 0) return false;
    const childIssuesTimeTrackingValues = childIssues.map((subIssue)=>// if Time tracking fields aren't configured, undefined is returned
        $19e8daae96f3fb3a$var$getSubFieldByName(subIssue.fields, (0, $f9RL0.TIME_TRACKING))).filter(Boolean);
    return childIssuesTimeTrackingValues.length > 0;
});
const $19e8daae96f3fb3a$export$d07adbd6fcb1649b = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$export$b3764c489e8d015b, $19e8daae96f3fb3a$export$135345e9de5fc488, (hasSubtasksOrBaseLevelChildren, doSubtasksOrBaseLevelChildrenHaveTimeTrackingConfigured)=>hasSubtasksOrBaseLevelChildren && doSubtasksOrBaseLevelChildrenHaveTimeTrackingConfigured);
const $19e8daae96f3fb3a$export$9c9932e056c0e818 = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$export$9641adea2fb165a5, $19e8daae96f3fb3a$export$587bf1a48c8fe6f7, (currentIssueTimeTrackingData, subtasksOrChildIssues)=>(isRollingUpData)=>{
        // base case: we return just the current issue's time tracking data whenever the issue
        // has no subtasks or the respective UI option is unchecked
        if (!subtasksOrChildIssues || subtasksOrChildIssues.length === 0 || !isRollingUpData) return currentIssueTimeTrackingData || {};
        return subtasksOrChildIssues.map((subIssue)=>$19e8daae96f3fb3a$var$getSubFieldByName(subIssue.fields, (0, $f9RL0.TIME_TRACKING))).filter(Boolean).reduce((accumulator, current)=>({
                originalEstimateSeconds: $19e8daae96f3fb3a$var$addTimeTrackingValues(accumulator.originalEstimateSeconds, current.originalEstimateSeconds),
                timeSpentSeconds: $19e8daae96f3fb3a$var$addTimeTrackingValues(accumulator.timeSpentSeconds, current.timeSpentSeconds),
                remainingEstimateSeconds: $19e8daae96f3fb3a$var$addTimeTrackingValues(accumulator.remainingEstimateSeconds, current.remainingEstimateSeconds)
            }), currentIssueTimeTrackingData || {});
    });
const $19e8daae96f3fb3a$export$88c9b23c79900aaf = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$var$modalSelector, (modalState)=>modalState.openModal);
const $19e8daae96f3fb3a$export$a98a586066aec6ec = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$var$modalSelector, (modalState)=>modalState.isSaving);
const $19e8daae96f3fb3a$var$activeWorklogIdSelector = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$var$modalSelector, (modalState)=>modalState.activeWorklogId);
const $19e8daae96f3fb3a$var$worklogEntitiesSelector = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.worklog);
const $19e8daae96f3fb3a$export$daafdb692849423a = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$var$worklogEntitiesSelector, (entitiesState)=>entitiesState.worklogs);
const $19e8daae96f3fb3a$export$a59b316c5487070c = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$var$activeWorklogIdSelector, $19e8daae96f3fb3a$export$daafdb692849423a, (activeWorklogId, worklogs)=>activeWorklogId && worklogs[activeWorklogId] || null);
const $19e8daae96f3fb3a$var$sortedWorklogIdsSelector = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$var$worklogEntitiesSelector, (entitiesState)=>entitiesState.sortedWorklogIds);
const $19e8daae96f3fb3a$export$cac06797b22541fc = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$export$daafdb692849423a, $19e8daae96f3fb3a$var$sortedWorklogIdsSelector, (worklogs, sortedWorklogIds)=>{
    const worklogIds = Array.isArray(sortedWorklogIds) ? sortedWorklogIds : Object.keys(worklogs); // Since there's no sort, just return the worklogs
    return worklogIds.map((worklogId)=>worklogs[worklogId]);
});
const $19e8daae96f3fb3a$export$53e31443c2badd6b = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$var$worklogEntitiesSelector, (entities)=>entities.totalWorklogs);
const $19e8daae96f3fb3a$export$4e75bc36a7a5dc79 = (0, $df4Sl.createSelector)($19e8daae96f3fb3a$var$worklogEntitiesSelector, (entities)=>entities.worklogsStartIndex || 0);

});
parcelRegister("lzTt0", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $fb57e46e5749abd1$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $fb57e46e5749abd1$var$isNumber(value) {
    return typeof value == 'number' || $hYEMs(value) && $2OY5s(value) == $fb57e46e5749abd1$var$numberTag;
}
module.exports = $fb57e46e5749abd1$var$isNumber;

});

parcelRegister("75LXB", function(module, exports) {

$parcel$export(module.exports, "persistedChildrenIssuesSelector", () => $16e0713b60d6ae21$export$e4b1249129a38a60);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $16e0713b60d6ae21$export$e4b1249129a38a60 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.childrenIssues);

});


parcelRegister("4AP4i", function(module, exports) {

$parcel$export(module.exports, "isNotEmptyComment", () => $ceea70c8ad754c34$export$1011606e0ce13844);
$parcel$export(module.exports, "default", () => $ceea70c8ad754c34$export$2e2bcd8739ae039);

var $7Vbpp = parcelRequire("7Vbpp");
const $ceea70c8ad754c34$export$1011606e0ce13844 = (comment)=>typeof comment === 'string' ? comment.trim() !== '' : !(0, $7Vbpp.isOnlyWhitespaceAdf)(comment);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ceea70c8ad754c34$export$2e2bcd8739ae039 = (worklog)=>{
    const { comment: comment } = worklog;
    if (!comment) return false;
    return typeof comment === 'string' ? comment.trim() !== '' : !(0, $7Vbpp.isOnlyWhitespaceAdf)(comment);
};

});

parcelRegister("hsc5W", function(module, exports) {

$parcel$export(module.exports, "transformWorklog", () => $62ec263126a9d543$export$f068946f240d264e);
$parcel$export(module.exports, "transformResponse", () => $62ec263126a9d543$export$3361e9be8093ddcc);

var $f9KE2 = parcelRequire("f9KE2");

var $7Vbpp = parcelRequire("7Vbpp");
const $62ec263126a9d543$var$transformUser = (user)=>{
    const { accountId: accountId, displayName: displayName = null, avatarUrls: avatarUrls = null } = user;
    return {
        accountId: accountId,
        displayName: displayName,
        avatarUrl: avatarUrls && avatarUrls['48x48']
    };
};
const $62ec263126a9d543$export$f068946f240d264e = (worklog)=>{
    const { id: id, author: author = null, updateAuthor: updateAuthor = null, timeSpent: timeSpent, started: started, created: created, updated: updated, comment: comment = null } = worklog;
    const wasUpdated = updated !== created;
    return {
        id: id,
        author: author && $62ec263126a9d543$var$transformUser(author),
        timeSpent: timeSpent,
        started: (0, $f9KE2.default)(new Date(started)),
        updated: wasUpdated ? (0, $f9KE2.default)(new Date(updated)) : null,
        updateAuthor: wasUpdated && updateAuthor ? $62ec263126a9d543$var$transformUser(updateAuthor) : null,
        comment: (0, $7Vbpp.removeCollectionFromAdf)(comment)
    };
};
const $62ec263126a9d543$export$40593abfa7a06b67 = (worklogs)=>worklogs.map($62ec263126a9d543$export$f068946f240d264e);
const $62ec263126a9d543$export$3361e9be8093ddcc = (response)=>({
        totalWorklogs: response.total,
        worklogs: $62ec263126a9d543$export$40593abfa7a06b67(response.worklogs)
    });

});

parcelRegister("4NX2u", function(module, exports) {

$parcel$export(module.exports, "worklogExperienceDescription", () => $591248bf778bee5e$export$558f97342b80aab3);

var $e91YZ = parcelRequire("e91YZ");

var $1ybV0 = parcelRequire("1ybV0");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");
const $591248bf778bee5e$var$worklogFetchActionSet = new Set([
    'FETCH',
    'FETCH_MORE',
    'FETCH_SORTED',
    'FETCH_SURROUNDING'
]);
const $591248bf778bee5e$export$558f97342b80aab3 = ({ wasSuccessful: wasSuccessful, action: action, analyticsSource: analyticsSource, projectType: projectType, errorMessage: errorMessage, statusCode: statusCode })=>{
    let application = null;
    let edition = null;
    let statusCodeProp = {};
    if ((0, $1ybV0.ff)('worklog-limit-exceed-warning-flag_hh86h')) statusCodeProp = typeof statusCode !== 'undefined' ? {
        statusCode: statusCode
    } : {
        statusCode: 0
    };
    if (projectType !== null) try {
        const { appEditions: appEditions } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
        application = (0, $eIp1n.getApplicationForProject)(projectType);
        edition = (0, $6WXNs.getEdition)(application, appEditions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // application and edition already default to null.
    }
    const experience = $591248bf778bee5e$var$worklogFetchActionSet.has(action) ? 'worklogFetch' : 'worklogUpdate';
    return {
        experience: experience,
        wasExperienceSuccesful: wasSuccessful,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: {
            action: action,
            ...statusCodeProp,
            ...errorMessage !== undefined && errorMessage !== null ? {
                errorMessage: errorMessage
            } : {}
        }
    };
};

});

parcelRegister("5XLtf", function(module, exports) {

$parcel$export(module.exports, "default", () => $27de9911c6cd9638$export$2e2bcd8739ae039);

var $i7Fym = parcelRequire("i7Fym");

var $EN9B6 = parcelRequire("EN9B6");
var $3xcI8 = parcelRequire("3xcI8");

var $53ciZ = parcelRequire("53ciZ");

var $lRmyA = parcelRequire("lRmyA");

var $eDEru = parcelRequire("eDEru");

var $deUTx = parcelRequire("deUTx");
const $27de9911c6cd9638$var$isEmpty = (s)=>!s;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$27de9911c6cd9638$export$2e2bcd8739ae039 = (baseUrl, issueKey, values)=>{
    const { timeLoggedSeconds: timeLoggedSeconds, workDescription: workDescription, timeRemaining: timeRemaining, timeRemainingSeconds: timeRemainingSeconds, dateStarted: dateStarted } = values || {};
    // Convert from seconds to minutes because the
    // backend doesn't support weeks/days/hours with decimal places other than
    // 0.25, 0.5 or 0.75
    // we have to convert the final value to a whole number as passing decimal
    // values in minutes errors.
    const timeSpent = (0, $eDEru.secondsToWholeMinuteTimeString)(timeLoggedSeconds || 0);
    const newEstimate = timeRemaining ? (0, $eDEru.secondsToWholeMinuteTimeString)(timeRemainingSeconds || 0) : timeRemaining;
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
        adjustEstimate: !newEstimate ? 'auto' : 'new',
        newEstimate: newEstimate
    }, $27de9911c6cd9638$var$isEmpty);
    const url = `${(0, $deUTx.getWorklogUrl)(baseUrl, issueKey)}?${(0, $53ciZ.stringify)(params)}`;
    return (0, $lRmyA.performPostRequest)(url, {
        body: JSON.stringify({
            timeSpent: timeSpent,
            comment: workDescription,
            started: dateStarted ? (0, $EN9B6.default)((0, $3xcI8.default)(dateStarted), "yyyy-MM-dd'T'HH:mm:ss.SSSxx") : undefined
        })
    });
};

});
parcelRegister("deUTx", function(module, exports) {

$parcel$export(module.exports, "getWorklogUrl", () => $35621b33a06dccae$export$28282cd35e6f0ffd);
$parcel$export(module.exports, "getSortedWorklogsGiraQuery", () => $35621b33a06dccae$export$f06d8fd166a51d30);
const $35621b33a06dccae$export$28282cd35e6f0ffd = (baseUrl, issueKey)=>`${baseUrl}/rest/internal/3/issue/${issueKey}/worklog`;
const $35621b33a06dccae$export$f06d8fd166a51d30 = ({ startAt: startAt = 0, orderBy: orderBy, worklogId: worklogId, maxResults: maxResults, issueKey: issueKey, worklogAmount: worklogAmount })=>{
    const startAtParameter = `startAt: ${startAt}`;
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const worklogParameter = worklogId !== null && worklogId !== undefined ? `, worklogId: "${worklogId}"` : '';
    const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
    const maxResultsParameter = worklogParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    return `query sortedWorklogsQuery {
        viewIssue(issueKey: "${issueKey}") {
            worklogs (${startAtParameter}${maxResultsParameter}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
                nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                timeSpent
                started
                updated
                created
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                comment
            }
            totalCount
            startIndex
            }
        }
    }`;
};

});


parcelRegister("iA24H", function(module, exports) {

$parcel$export(module.exports, "default", () => $256c2606f6b6f468$export$2e2bcd8739ae039);

var $53ciZ = parcelRequire("53ciZ");

var $lRmyA = parcelRequire("lRmyA");

var $5zSUY = parcelRequire("5zSUY");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$256c2606f6b6f468$export$2e2bcd8739ae039 = (baseUrl, // eslint-disable-next-line @typescript-eslint/no-explicit-any
issueId, remainingEstimate)=>(0, $lRmyA.performPostRequest)(`${baseUrl}/secure/AjaxIssueAction.jspa?decorator=none`, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: (0, $53ciZ.stringify)({
            issueId: issueId,
            timetracking_remainingestimate: remainingEstimate,
            timetracking_targetsubfield: 'timetracking_remainingestimate',
            fieldsToForcePresent: 'timetracking',
            singleFieldEdit: true,
            skipScreenCheck: true,
            atl_token: (0, $5zSUY.default)()
        })
    });

});


parcelRegister("a2fsc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc7795bd4d659ba0$export$2e2bcd8739ae039);
parcelRequire("9u6v2");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("flmol");
parcelRequire("l5lul");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $jUhyG = parcelRequire("jUhyG");

var $gUUjF = parcelRequire("gUUjF");

var $bPG0x = parcelRequire("bPG0x");

var $eDEru = parcelRequire("eDEru");


var $eH7pq = parcelRequire("eH7pq");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $dUqHv = parcelRequire("dUqHv");

var $gzLYm = parcelRequire("gzLYm");

var $7Vbpp = parcelRequire("7Vbpp");

var $6vrw7 = parcelRequire("6vrw7");

var $4NX2u = parcelRequire("4NX2u");

var $83L1i = parcelRequire("83L1i");

var $9Y7ra = parcelRequire("9Y7ra");
const $fc7795bd4d659ba0$export$681aba8828869885 = (state, deletedWorklog, timeRemaining)=>{
    const config = (0, $dUqHv.timeTrackingConfigurationSelector)(state);
    const timeStringToSeconds = (0, $eH7pq.default)(config.daysPerWeek, config.hoursPerDay);
    return {
        timeSpentSecondsDelta: -(timeStringToSeconds(deletedWorklog.timeSpent) || 0),
        newRemainingEstimateSeconds: timeStringToSeconds(timeRemaining)
    };
};
const $fc7795bd4d659ba0$export$4e4f6e343df9b4b9 = (action$, store)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    action$.ofType((0, $9Y7ra.DELETE_WORKLOG_SUCCESS)).switchMap(// @ts-expect-error - Types of property 'type' are incompatible.
    ()=>{
        const state = store.getState();
        const loadedWorklogs = (0, $dUqHv.sortedWorklogsSelector)(state).length;
        if (loadedWorklogs > 0) return (0, $3JafE.Observable).empty();
        const startIndex = (0, $dUqHv.worklogsStartIndexSelector)(state);
        const totalWorklogs = (0, $dUqHv.totalWorklogsSelector)(state);
        const selectedSortOrder = (0, $gzLYm.getSelectedActivitySortOrder)(state);
        const hasWorklogsAboveToLoad = startIndex > 0;
        if (hasWorklogsAboveToLoad) return selectedSortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) ? (0, $3JafE.Observable).of((0, $9Y7ra.fetchNewerSortedWorklogsRequest)()) : (0, $3JafE.Observable).of((0, $9Y7ra.fetchOlderSortedWorklogsRequest)());
        const hasWorklogsBelowToLoad = totalWorklogs > startIndex;
        if (hasWorklogsBelowToLoad) return selectedSortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) ? (0, $3JafE.Observable).of((0, $9Y7ra.fetchOlderSortedWorklogsRequest)()) : (0, $3JafE.Observable).of((0, $9Y7ra.fetchNewerSortedWorklogsRequest)());
        return (0, $3JafE.Observable).empty();
    });
const $fc7795bd4d659ba0$export$66e3e6fba1197509 = (attachmentActions)=>(action$, store)=>action$.ofType((0, $9Y7ra.DELETE_WORKLOG_REQUEST)) // eslint-disable-line @typescript-eslint/consistent-type-assertions
        .switchMap(({ payload: { worklogId: worklogId, timeRemaining: timeRemaining, isAdjustTimeRemainingChecked: isAdjustTimeRemainingChecked }, meta: { analyticsEvent: analyticsEvent } })=>{
            const state = store.getState();
            const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
            const issueKey = (0, $6vrw7.toIssueKey)((0, $5JqpU.issueKeySelector)(state));
            const projectType = (0, $jZDJX.projectTypeSelector)(state);
            const worklog = (0, $dUqHv.worklogsSelector)(state)[worklogId];
            const bodyAdf = worklog && worklog.comment;
            const shouldRefetchAttachment = bodyAdf !== null && (0, $7Vbpp.hasMediaFileNodes)(bodyAdf);
            const { daysPerWeek: daysPerWeek, hoursPerDay: hoursPerDay } = (0, $dUqHv.timeTrackingConfigurationSelector)(state);
            const parseTime = (0, $eH7pq.default)(daysPerWeek, hoursPerDay);
            // Convert the timeRemaining from time-string to minutes because the
            // backend doesn't support weeks/days/hours with decimal places other than
            // 0.25, 0.5 or 0.75
            // we have to convert the final value to a whole number as passing decimal
            // values in minutes errors.
            const newTimeRemaining = (0, $eDEru.secondsToWholeMinuteTimeString)(parseTime(timeRemaining) || 0);
            return (0, $3JafE.Observable).from((0, $83L1i.default)(baseUrl, issueKey, worklogId, newTimeRemaining, isAdjustTimeRemainingChecked)).map(()=>{
                const worklogs = (0, $dUqHv.worklogsSelector)(state);
                const deletedWorklog = worklogs[worklogId];
                shouldRefetchAttachment && attachmentActions.refreshAttachments((0, $6vrw7.toIssueKey)(issueKey));
                return (0, $9Y7ra.deleteWorklogSuccess)(worklogId, $fc7795bd4d659ba0$export$681aba8828869885(state, deletedWorklog, newTimeRemaining));
            }).do(()=>{
                (0, $bPG0x.sendExperienceAnalytics)({
                    getExperienceDescription: ()=>(0, $4NX2u.worklogExperienceDescription)({
                            wasSuccessful: true,
                            action: 'DELETE',
                            analyticsSource: 'deleteWorklogEpic',
                            projectType: projectType
                        })
                });
                (0, $jUhyG.fireTrackAnalytics)(analyticsEvent, {
                    action: 'deleted',
                    actionSubjectId: worklogId,
                    attributes: {
                        timeAdjusted: isAdjustTimeRemainingChecked
                    }
                });
            }).catch((error)=>{
                (0, $bPG0x.sendExperienceAnalytics)({
                    getExperienceDescription: ({ wasSuccessful: wasSuccessful })=>{
                        if (!wasSuccessful) (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.activity.worklog.delete-worklog', `Could not delete worklog '${worklogId}'`, error);
                        return (0, $4NX2u.worklogExperienceDescription)({
                            wasSuccessful: wasSuccessful,
                            action: 'DELETE',
                            analyticsSource: 'deleteWorklogEpic',
                            projectType: projectType,
                            errorMessage: wasSuccessful ? undefined : error.message
                        });
                    },
                    error: error
                });
                return (0, $3JafE.Observable).of((0, $9Y7ra.deleteWorklogFailure)());
            });
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fc7795bd4d659ba0$export$2e2bcd8739ae039 = (attachmentActions)=>(0, $bd1K7.combineEpics)($fc7795bd4d659ba0$export$66e3e6fba1197509(attachmentActions), $fc7795bd4d659ba0$export$4e4f6e343df9b4b9);

});
parcelRegister("83L1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dc70a7284bb6f1c$export$2e2bcd8739ae039);

var $bQ8Zi = parcelRequire("bQ8Zi");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1dc70a7284bb6f1c$export$2e2bcd8739ae039 = (baseUrl, issueKey, worklogId, timeRemaining, isAdjustTimeRemainingChecked)=>(0, $bQ8Zi.default)(baseUrl, issueKey, worklogId, timeRemaining, isAdjustTimeRemainingChecked);

});
parcelRegister("bQ8Zi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f9740c66606b94a$export$2e2bcd8739ae039);

var $lRmyA = parcelRequire("lRmyA");

var $deUTx = parcelRequire("deUTx");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0f9740c66606b94a$export$2e2bcd8739ae039 = (baseUrl, issueKey, worklogId, timeRemaining, isAdjustTimeRemainingChecked)=>(0, $lRmyA.performDeleteRequest)(`${(0, $deUTx.getWorklogUrl)(baseUrl, issueKey)}/${worklogId}?adjustEstimate=${isAdjustTimeRemainingChecked ? `new&newEstimate=${timeRemaining}` : 'leave'}`);

});



parcelRegister("ijnfJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7369044994efd782$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("9u6v2");
parcelRequire("l5lul");
parcelRequire("iects");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $jUhyG = parcelRequire("jUhyG");


var $gUUjF = parcelRequire("gUUjF");

var $bPG0x = parcelRequire("bPG0x");

var $eDEru = parcelRequire("eDEru");

var $eH7pq = parcelRequire("eH7pq");

var $hlJEN = parcelRequire("hlJEN");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $dUqHv = parcelRequire("dUqHv");

var $7Vbpp = parcelRequire("7Vbpp");

var $6vrw7 = parcelRequire("6vrw7");

var $4AP4i = parcelRequire("4AP4i");
var $4NX2u = parcelRequire("4NX2u");

var $jbgr2 = parcelRequire("jbgr2");

var $9Y7ra = parcelRequire("9Y7ra");
const $7369044994efd782$export$681aba8828869885 = (state, editedWorklog, timeRemaining)=>{
    const config = (0, $dUqHv.timeTrackingConfigurationSelector)(state);
    const timeStringToSeconds = (0, $eH7pq.default)(config.daysPerWeek, config.hoursPerDay);
    const worklogs = (0, $dUqHv.worklogsSelector)(state);
    const oldWorklog = worklogs[editedWorklog.id];
    if (!oldWorklog) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.activity.worklog.edit-worklog', 'Could not find existing worklog with matching ID when editing a worklog and calculating time tracking deltas.');
        return {
            timeSpentSecondsDelta: 0,
            newRemainingEstimateSeconds: timeStringToSeconds(timeRemaining)
        };
    }
    const oldTimeSpentSeconds = timeStringToSeconds(oldWorklog.timeSpent) || 0;
    const newTimeSpentSeconds = timeStringToSeconds(editedWorklog.timeSpent) || 0;
    const timeSpentSecondsDelta = newTimeSpentSeconds - oldTimeSpentSeconds;
    let newRemainingEstimateSeconds = timeStringToSeconds(timeRemaining);
    if (typeof newRemainingEstimateSeconds === 'number') newRemainingEstimateSeconds = timeStringToSeconds((0, $eDEru.secondsToWholeMinuteTimeString)(newRemainingEstimateSeconds));
    return {
        timeSpentSecondsDelta: timeSpentSecondsDelta,
        newRemainingEstimateSeconds: newRemainingEstimateSeconds
    };
};
const $7369044994efd782$export$e12890f812f4157b = [
    (0, $1c3fbb431a173cc6$export$9de493bcd9b1d977),
    (0, $1c3fbb431a173cc6$export$67d19e9a991baa07),
    (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef)
];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7369044994efd782$export$2e2bcd8739ae039 = (action$, store)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    action$.ofType((0, $9Y7ra.EDIT_WORKLOG_REQUEST)).switchMap((action)=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueKey = (0, $6vrw7.toIssueKey)((0, $5JqpU.issueKeySelector)(state));
        const projectType = (0, $jZDJX.projectTypeSelector)(state);
        const worklogsMap = (0, $dUqHv.worklogsSelector)(state);
        const { payload: { worklogId: worklogId, values: values }, meta: { analyticsEvent: analyticsEvent } } = action;
        let shouldFetchViewContext = false;
        if ((0, $4AP4i.isNotEmptyComment)(values.workDescription)) {
            shouldFetchViewContext = (0, $7Vbpp.hasMediaFileNodesUpdated)(worklogsMap[worklogId].comment, values.workDescription);
            if (shouldFetchViewContext) // @ts-expect-error - Argument of type '{ type: "MARK_TOKEN_AS_OUTDATED"; }' is not assignable to parameter of type 'Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: MyPreferences | undefined; }>; ... 5 more ...; validators: Validators; }>'.
            store.dispatch((0, $hlJEN.markTokenAsOutdated)());
        }
        return (0, $3JafE.Observable).from((0, $jbgr2.default)(baseUrl, issueKey, worklogId, values)).do((editedWorklog)=>{
            const withComment = (0, $4AP4i.default)(editedWorklog);
            (0, $bPG0x.sendExperienceAnalytics)({
                getExperienceDescription: ()=>(0, $4NX2u.worklogExperienceDescription)({
                        wasSuccessful: true,
                        action: 'EDIT',
                        analyticsSource: 'editWorklogEpic',
                        projectType: projectType
                    })
            });
            (0, $jUhyG.fireTrackAnalytics)(analyticsEvent, {
                action: 'edited',
                actionSubjectId: worklogId,
                attributes: {
                    withComment: withComment
                }
            });
        }).mergeMap((editedWorklog)=>{
            const updatedWorklogMap = {
                ...worklogsMap,
                [worklogId]: editedWorklog
            };
            const editWorklogSuccessAction = (0, $9Y7ra.editWorklogSuccess)(updatedWorklogMap, editedWorklog.id, $7369044994efd782$export$681aba8828869885(state, editedWorklog, values.timeRemaining), {
                shouldFetchViewContext: shouldFetchViewContext
            });
            if (editedWorklog.started !== worklogsMap[worklogId].started) return (0, $3JafE.Observable).of(editWorklogSuccessAction, // @ts-expect-error - TS2769 - No overload matches this call.
            (0, $9Y7ra.fetchSurroundingWorklogsById)(worklogId));
            return (0, $3JafE.Observable).of(editWorklogSuccessAction);
        }).catch((error)=>{
            (0, $bPG0x.sendExperienceAnalytics)({
                getExperienceDescription: ({ wasSuccessful: wasSuccessful })=>{
                    if (!wasSuccessful) (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.activity.worklog.edit-worklog', 'Failed to save edited worklog:', error);
                    return (0, $4NX2u.worklogExperienceDescription)({
                        wasSuccessful: wasSuccessful,
                        action: 'EDIT',
                        analyticsSource: 'editWorklogEpic',
                        projectType: projectType,
                        errorMessage: wasSuccessful ? undefined : error.message
                    });
                },
                error: error
            });
            return (0, $3JafE.Observable).of((0, $9Y7ra.editWorklogFailure)());
        });
    });

});
parcelRegister("jbgr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d23d53ff0177c14a$export$2e2bcd8739ae039);

var $hsc5W = parcelRequire("hsc5W");

var $2RKp9 = parcelRequire("2RKp9");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d23d53ff0177c14a$export$2e2bcd8739ae039 = (baseUrl, issueKey, worklogId, values)=>(0, $2RKp9.default)(baseUrl, issueKey, worklogId, values).then((worklog)=>(0, $hsc5W.transformWorklog)(worklog));

});
parcelRegister("2RKp9", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d1b3b02f486c14$export$2e2bcd8739ae039);

var $kkgbD = parcelRequire("kkgbD");

var $i7Fym = parcelRequire("i7Fym");

var $EN9B6 = parcelRequire("EN9B6");
var $3xcI8 = parcelRequire("3xcI8");

var $lRmyA = parcelRequire("lRmyA");

var $eDEru = parcelRequire("eDEru");

var $deUTx = parcelRequire("deUTx");
const $82d1b3b02f486c14$var$getRequestPayload = (values)=>{
    // Convert from seconds to minutes because the
    // backend doesn't support weeks/days/hours with decimal places other than
    // 0.25, 0.5 or 0.75
    // we have to convert the final value to a whole number as passing decimal
    // values in minutes errors.
    const timeSpent = (0, $eDEru.secondsToWholeMinuteTimeString)(values.timeLoggedSeconds || 0);
    return {
        body: JSON.stringify((0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
            timeSpent: timeSpent,
            started: values.dateStarted ? (0, $EN9B6.default)((0, $3xcI8.default)(values.dateStarted), "yyyy-MM-dd'T'HH:mm:ss.SSSxx") : undefined,
            comment: values.workDescription
        }, (0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))))
    };
};
const $82d1b3b02f486c14$var$getUrl = (baseUrl, issueKey, worklogId, values)=>{
    // Convert from seconds to minutes because the
    // backend doesn't support weeks/days/hours with decimal places other than
    // 0.25, 0.5 or 0.75
    // we have to convert the final value to a whole number as passing decimal
    // values in minutes errors.
    const timeRemainingTimeString = values.timeRemaining ? (0, $eDEru.secondsToWholeMinuteTimeString)(values.timeRemainingSeconds || 0) : values.timeRemaining;
    const queryString = timeRemainingTimeString ? `?adjustEstimate=new&newEstimate=${timeRemainingTimeString}` : '?adjustEstimate=leave';
    return `${(0, $deUTx.getWorklogUrl)(baseUrl, issueKey)}/${worklogId}${queryString}`;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$82d1b3b02f486c14$export$2e2bcd8739ae039 = (baseUrl, issueKey, worklogId, values)=>(0, $lRmyA.performPutRequest)($82d1b3b02f486c14$var$getUrl(baseUrl, issueKey, worklogId, values), $82d1b3b02f486c14$var$getRequestPayload(values));

});



parcelRegister("3ydt3", function(module, exports) {

$parcel$export(module.exports, "fetchOlderSortedWorklogsEpic", () => $25b0d48144c1d54c$export$19be7d2766cf3bb8);
$parcel$export(module.exports, "fetchNewerSortedWorklogsEpic", () => $25b0d48144c1d54c$export$964b17acdcaffd6a);
parcelRequire("flmol");
parcelRequire("jyKN9");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $bPG0x = parcelRequire("bPG0x");


var $eTy9x = parcelRequire("eTy9x");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $dUqHv = parcelRequire("dUqHv");

var $gzLYm = parcelRequire("gzLYm");

var $4NX2u = parcelRequire("4NX2u");

var $883hP = parcelRequire("883hP");

var $9Y7ra = parcelRequire("9Y7ra");
const $25b0d48144c1d54c$export$f669eb914773fea6 = (type, itemsStartIndex, totalItems, loadedItems, selectedSortOrder)=>{
    let maxResults = 0;
    let startFetchingFrom = 0;
    if (type === (0, $9Y7ra.FETCH_OLDER_SORTED_WORKLOGS_REQUEST)) {
        startFetchingFrom = selectedSortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) ? itemsStartIndex + loadedItems : Math.max(itemsStartIndex - (0, $eTy9x.NUM_PAGED_ITEMS_TO_LOAD), 0);
        return {
            maxResults: selectedSortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) ? Math.min(totalItems - startFetchingFrom, (0, $eTy9x.NUM_PAGED_ITEMS_TO_LOAD)) : itemsStartIndex - startFetchingFrom,
            startAt: startFetchingFrom
        };
    }
    startFetchingFrom = selectedSortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) ? Math.max(0, itemsStartIndex - (0, $eTy9x.NUM_PAGED_ITEMS_TO_LOAD)) : itemsStartIndex + loadedItems;
    maxResults = selectedSortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) ? itemsStartIndex - startFetchingFrom : Math.min(totalItems - startFetchingFrom, (0, $eTy9x.NUM_PAGED_ITEMS_TO_LOAD));
    return {
        maxResults: maxResults,
        startAt: startFetchingFrom
    };
};
const $25b0d48144c1d54c$export$19be7d2766cf3bb8 = (action$, store)=>/* eslint-disable @typescript-eslint/consistent-type-assertions */ action$.ofType((0, $9Y7ra.FETCH_OLDER_SORTED_WORKLOGS_REQUEST))/* eslint-enable @typescript-eslint/consistent-type-assertions */ .switchMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueKey = (0, $5JqpU.issueKeySelector)(state);
        const projectType = (0, $jZDJX.projectTypeSelector)(state);
        const selectedSortOrder = (0, $gzLYm.getSelectedActivitySortOrder)(state);
        const startIndex = (0, $dUqHv.worklogsStartIndexSelector)(state);
        const totalWorklogsNum = (0, $dUqHv.totalWorklogsSelector)(state);
        const loadedWorklogsNum = (0, $dUqHv.sortedWorklogsSelector)(state).length;
        const { maxResults: maxResults, startAt: startAt } = $25b0d48144c1d54c$export$f669eb914773fea6((0, $9Y7ra.FETCH_OLDER_SORTED_WORKLOGS_REQUEST), startIndex, totalWorklogsNum, loadedWorklogsNum, selectedSortOrder);
        return (0, $883hP.default)(baseUrl, issueKey, maxResults, selectedSortOrder, startAt, (0, $9Y7ra.FETCH_OLDER_SORTED_WORKLOGS_REQUEST), startIndex).map(({ worklogs: worklogs, totalWorklogs: totalWorklogs, sortedWorklogIds: sortedWorklogIds, startIndex: newStartIndex })=>{
            (0, $bPG0x.sendExperienceAnalytics)({
                getExperienceDescription: ()=>(0, $4NX2u.worklogExperienceDescription)({
                        wasSuccessful: true,
                        action: 'FETCH_MORE',
                        analyticsSource: 'fetchOlderSortedWorklogsEpic',
                        projectType: projectType
                    })
            });
            return (0, $9Y7ra.fetchOlderSortedWorklogsSuccess)({
                worklogs: worklogs,
                totalWorklogs: totalWorklogs,
                startIndex: newStartIndex,
                sortedWorklogIds: sortedWorklogIds,
                selectedSortOrder: selectedSortOrder
            });
        }).catch((error)=>{
            (0, $bPG0x.sendExperienceAnalytics)({
                getExperienceDescription: ()=>(0, $4NX2u.worklogExperienceDescription)({
                        wasSuccessful: false,
                        action: 'FETCH_MORE',
                        analyticsSource: 'fetchOlderSortedWorklogsEpic',
                        projectType: projectType,
                        errorMessage: error.message
                    }),
                error: error
            });
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.activity.worklog.fetch-more-sorted-worklogs', 'Could not fetch more sorted worklogs:', error);
            return (0, $3JafE.Observable).of((0, $9Y7ra.fetchSortedWorklogsFailure)());
        });
    });
const $25b0d48144c1d54c$export$964b17acdcaffd6a = (action$, store)=>/* eslint-disable @typescript-eslint/consistent-type-assertions */ action$.ofType((0, $9Y7ra.FETCH_NEWER_SORTED_WORKLOGS_REQUEST))/* eslint-enable @typescript-eslint/consistent-type-assertions */ .switchMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueKey = (0, $5JqpU.issueKeySelector)(state);
        const projectType = (0, $jZDJX.projectTypeSelector)(state);
        const selectedSortOrder = (0, $gzLYm.getSelectedActivitySortOrder)(state);
        const startIndex = (0, $dUqHv.worklogsStartIndexSelector)(state);
        const totalWorklogsNum = (0, $dUqHv.totalWorklogsSelector)(state);
        const loadedWorklogsNum = (0, $dUqHv.sortedWorklogsSelector)(state).length;
        const { maxResults: maxResults, startAt: startAt } = $25b0d48144c1d54c$export$f669eb914773fea6((0, $9Y7ra.FETCH_NEWER_SORTED_WORKLOGS_REQUEST), startIndex, totalWorklogsNum, loadedWorklogsNum, selectedSortOrder);
        return (0, $883hP.default)(baseUrl, issueKey, maxResults, selectedSortOrder, startAt, (0, $9Y7ra.FETCH_NEWER_SORTED_WORKLOGS_REQUEST), startIndex).map(({ worklogs: worklogs, totalWorklogs: totalWorklogs, sortedWorklogIds: sortedWorklogIds, startIndex: newStartIndex })=>{
            (0, $bPG0x.sendExperienceAnalytics)({
                getExperienceDescription: ()=>(0, $4NX2u.worklogExperienceDescription)({
                        wasSuccessful: true,
                        action: 'FETCH_MORE',
                        analyticsSource: 'fetchNewerSortedWorklogsEpic',
                        projectType: projectType
                    })
            });
            return (0, $9Y7ra.fetchNewerSortedWorklogsSuccess)({
                worklogs: worklogs,
                totalWorklogs: totalWorklogs,
                startIndex: newStartIndex,
                sortedWorklogIds: sortedWorklogIds,
                selectedSortOrder: selectedSortOrder
            });
        }).catch((error)=>{
            (0, $bPG0x.sendExperienceAnalytics)({
                getExperienceDescription: ()=>(0, $4NX2u.worklogExperienceDescription)({
                        wasSuccessful: false,
                        action: 'FETCH_MORE',
                        analyticsSource: 'fetchNewerSortedWorklogsEpic',
                        projectType: projectType,
                        errorMessage: error.message
                    }),
                error: error
            });
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.activity.worklog.fetch-more-sorted-worklogs', 'Could not fetch more sorted worklogs:', error);
            return (0, $3JafE.Observable).of((0, $9Y7ra.fetchSortedWorklogsFailure)());
        });
    });

});
parcelRegister("883hP", function(module, exports) {

$parcel$export(module.exports, "default", () => $340e8d0ad3c2ff19$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");


var $11LM5 = parcelRequire("11LM5");
parcelRequire("flmol");

var $gTPgd = parcelRequire("gTPgd");

var $9Y7ra = parcelRequire("9Y7ra");

var $2FBOD = parcelRequire("2FBOD");
const $340e8d0ad3c2ff19$var$LOG_LOCATION = 'issue.worklogs.fetch.epic.gira';
const $340e8d0ad3c2ff19$export$9222d88397120c02 = (worklog, type, sortOrder, worklogsStartIndex)=>{
    let newStartIndex;
    if (type === (0, $9Y7ra.FETCH_NEWER_SORTED_WORKLOGS_REQUEST)) newStartIndex = Math.max(sortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) ? worklogsStartIndex - worklog.sortedWorklogIds.length : worklogsStartIndex, 0);
    else newStartIndex = Math.max(sortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) ? worklogsStartIndex : worklogsStartIndex - worklog.sortedWorklogIds.length, 0);
    return {
        ...worklog,
        startIndex: newStartIndex
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$340e8d0ad3c2ff19$export$2e2bcd8739ae039 = (baseUrl, issueKey, maxResults, sort, startFetchingAtIndex, type, worklogsStartIndex)=>// @ts-expect-error - TS2684 - The 'this' context of type 'Observable<ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>' is not assignable to method's 'this' of type 'Observable<FetchWorklogsData>'.
    (0, $gTPgd.default)({
        baseUrl: baseUrl,
        issueKey: issueKey,
        maxResults: maxResults,
        orderBy: (0, $1ybV0.ff)('issue-view-worklog-timestamp-fix_8d0dt') ? (0, $2FBOD.sortToOrderByCreatedMap)[sort] : (0, $2FBOD.sortToOrderByMap)[sort],
        startAt: startFetchingAtIndex
    })// @ts-expect-error - TS2345 - Argument of type '<T extends ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>(response: GraphqlResponse<T>) => {    data: T;    errors: unknown;}' is not assignable to parameter of type '(value: unknown, index: number) => { data: ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse; errors: unknown; }'.
    .map((0, $11LM5.checkEmptyResponse))// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GraphqlResponse<ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>'.
    .map((response)=>(0, $11LM5.getGraphQlData)($340e8d0ad3c2ff19$var$LOG_LOCATION, response)).map((0, $2FBOD.transformData)).map((worklog)=>$340e8d0ad3c2ff19$export$9222d88397120c02(worklog, type, sort, worklogsStartIndex));

});
parcelRegister("gTPgd", function(module, exports) {

$parcel$export(module.exports, "default", () => $333b65d36828a7cc$export$2e2bcd8739ae039);

var $aiRd8 = parcelRequire("aiRd8");

var $deUTx = parcelRequire("deUTx");
const $333b65d36828a7cc$var$fetchMoreSortedWorklogsFromGira = ({ startAt: startAt, orderBy: orderBy, baseUrl: baseUrl, issueKey: issueKey, maxResults: maxResults })=>(0, $aiRd8.default)(`${baseUrl}/rest/gira/1/`, {
        method: 'POST',
        body: JSON.stringify({
            query: (0, $deUTx.getSortedWorklogsGiraQuery)({
                startAt: startAt,
                orderBy: orderBy,
                maxResults: maxResults,
                issueKey: issueKey
            })
        })
    });
var $333b65d36828a7cc$export$2e2bcd8739ae039 = $333b65d36828a7cc$var$fetchMoreSortedWorklogsFromGira;

});

parcelRegister("2FBOD", function(module, exports) {

$parcel$export(module.exports, "sortToOrderByMap", () => $085050fc645dc527$export$438f5d76296c1ab9);
$parcel$export(module.exports, "sortToOrderByCreatedMap", () => $085050fc645dc527$export$98f21cb83a24e449);
$parcel$export(module.exports, "transformData", () => $085050fc645dc527$export$3ceb62baab058c6b);

var $1ybV0 = parcelRequire("1ybV0");


var $7Vbpp = parcelRequire("7Vbpp");
const $085050fc645dc527$export$438f5d76296c1ab9 = {
    [(0, $25476979aca7c7e0$export$eda5fe8da1abb04c)]: '-started',
    [(0, $25476979aca7c7e0$export$e86669f498228fff)]: 'started'
};
const $085050fc645dc527$export$98f21cb83a24e449 = {
    [(0, $25476979aca7c7e0$export$eda5fe8da1abb04c)]: '-created',
    [(0, $25476979aca7c7e0$export$e86669f498228fff)]: 'created'
};
const $085050fc645dc527$export$3ceb62baab058c6b = (data)=>{
    const { totalCount: totalCount, nodes: nodes, startIndex: startIndex } = data.viewIssue.worklogs;
    const worklogs = nodes.map(({ updateAuthor: updateAuthor = null, updated: updated, comment: comment, created: created, ...rest })=>{
        const wasUpdated = updated !== created;
        return {
            ...rest,
            ...(0, $1ybV0.ff)('issue-view-worklog-timestamp-fix_8d0dt') ? {
                created: created
            } : {},
            updated: wasUpdated ? updated : null,
            updateAuthor: wasUpdated && updateAuthor ? updateAuthor : null,
            comment: (0, $7Vbpp.convertAdfStringToObject)(comment)
        };
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const worklogsMap = worklogs.reduce((acc, worklog)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...acc,
            [worklog.id]: worklog
        }), {});
    const sortedWorklogIds = worklogs.map((worklog)=>worklog.id);
    return {
        sortedWorklogIds: sortedWorklogIds,
        totalWorklogs: totalCount,
        worklogs: worklogsMap,
        startIndex: startIndex || 0
    };
};

});



parcelRegister("gDwbT", function(module, exports) {

$parcel$export(module.exports, "fetchSurroundingWorklogsByIdEpic", () => $a27437e001f64193$export$4a46ee29dc114c72);
$parcel$export(module.exports, "fetchSurroundingWorklogsAttachmentScroll", () => $a27437e001f64193$export$20c1f9168afe56c4);
parcelRequire("flmol");
parcelRequire("jyKN9");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $k8Qyf = parcelRequire("k8Qyf");

var $bPG0x = parcelRequire("bPG0x");

var $9WtAE = parcelRequire("9WtAE");

var $hc60A = parcelRequire("hc60A");

var $eTy9x = parcelRequire("eTy9x");

var $gZ3nQ = parcelRequire("gZ3nQ");

var $277q1 = parcelRequire("277q1");

var $khpWz = parcelRequire("khpWz");

var $9Y7ra = parcelRequire("9Y7ra");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $gzLYm = parcelRequire("gzLYm");

var $9s86T = parcelRequire("9s86T");
var $6VKiL = parcelRequire("6VKiL");

var $6vrw7 = parcelRequire("6vrw7");

var $4NX2u = parcelRequire("4NX2u");

var $l0ca0 = parcelRequire("l0ca0");

var $9Y7ra = parcelRequire("9Y7ra");

var $cLNC5 = parcelRequire("cLNC5");
const $a27437e001f64193$var$fetchObservable = (state, worklogId)=>{
    const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
    const issueKey = (0, $6vrw7.toIssueKey)((0, $5JqpU.issueKeySelector)(state));
    const selectedSortOrder = (0, $gzLYm.getSelectedActivitySortOrder)(state);
    return (0, $l0ca0.default)(baseUrl, issueKey, Math.floor((0, $eTy9x.NUM_INITIAL_ITEMS_TO_LOAD)), selectedSortOrder, worklogId);
};
const $a27437e001f64193$export$4a46ee29dc114c72 = (action$, store)=>/* eslint-disable @typescript-eslint/consistent-type-assertions */ action$.ofType((0, $9Y7ra.FETCH_SURROUNDING_WORKLOGS_BY_ID))/* eslint-enable @typescript-eslint/consistent-type-assertions */ .switchMap((action)=>{
        const state = store.getState();
        const projectType = (0, $jZDJX.projectTypeSelector)(state);
        const { payload: payload } = action;
        return $a27437e001f64193$var$fetchObservable(state, payload.worklogId).map(({ totalWorklogs: totalWorklogs, worklogs: worklogs, sortedWorklogIds: sortedWorklogIds, startIndex: startIndex })=>{
            (0, $bPG0x.sendExperienceAnalytics)({
                getExperienceDescription: ()=>(0, $4NX2u.worklogExperienceDescription)({
                        wasSuccessful: true,
                        action: 'FETCH_SURROUNDING',
                        analyticsSource: 'fetchSurroundingWorklogsByIdEpic',
                        projectType: projectType
                    })
            });
            return (0, $9Y7ra.fetchWorklogsByIdSuccess)(sortedWorklogIds, worklogs, startIndex || 0, totalWorklogs);
        }).catch((error)=>{
            (0, $bPG0x.sendExperienceAnalytics)({
                getExperienceDescription: ()=>(0, $4NX2u.worklogExperienceDescription)({
                        wasSuccessful: false,
                        action: 'FETCH_SURROUNDING',
                        analyticsSource: 'fetchSurroundingWorklogsByIdEpic',
                        projectType: projectType,
                        errorMessage: error.message
                    }),
                error: error
            });
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.activity.worklog.fetch-worklog-by-id', 'Failed to load worklog list after adding new worklog', error);
            return (0, $3JafE.Observable).of((0, $9Y7ra.fetchWorklogsByIdFailure)());
        });
    });
const $a27437e001f64193$export$20c1f9168afe56c4 = (issueScrollAction)=>(action$, store)=>action$.ofType((0, $khpWz.SCROLL_TO_ATTACHMENT_WORKLOG)).switchMap(()=>{
            const state = store.getState();
            const projectType = (0, $jZDJX.projectTypeSelector)(state);
            const worklogId = issueScrollAction.getScrollTargetId((0, $9WtAE.SCROLL_TARGET_TYPES).WORKLOG);
            // the store does not contain the right scroll target. Abort fetch call to backend
            if (worklogId === null) return (0, $3JafE.Observable).of();
            return $a27437e001f64193$var$fetchObservable(state, worklogId).flatMap(({ totalWorklogs: totalWorklogs, worklogs: worklogs, sortedWorklogIds: sortedWorklogIds, startIndex: startIndex })=>{
                const worklogActivityItem = {
                    key: (0, $hc60A.WORKLOG),
                    type: (0, $hc60A.WORKLOG),
                    name: (0, $cLNC5.messages).worklog.defaultMessage
                };
                // modify the url, so that specific worklogId can scroll within worklog-item-view.js
                window.history.replaceState({}, // @ts-expect-error - TS2345 - Argument of type 'null' is not assignable to parameter of type 'string'.
                null, (0, $9s86T.getUrlPermalinkParameter)(worklogId, (0, $6VKiL.PermalinkType).WORKLOG));
                issueScrollAction.setScrollTarget(null);
                (0, $bPG0x.sendExperienceAnalytics)({
                    getExperienceDescription: ()=>(0, $4NX2u.worklogExperienceDescription)({
                            wasSuccessful: true,
                            action: 'FETCH_SURROUNDING',
                            analyticsSource: 'fetchSurroundingWorklogsAttachmentScroll',
                            projectType: projectType
                        })
                });
                return (0, $3JafE.Observable).of((0, $9Y7ra.fetchWorklogsByIdSuccess)(sortedWorklogIds, worklogs, startIndex || 0, totalWorklogs), // @ts-expect-error - TS2769 - No overload matches this call. | TS2345 - Argument of type '{ key: "Worklog"; type: "Worklog"; name: string | undefined; }' is not assignable to parameter of type 'ActivityItem'.
                (0, $277q1.setInitialSelectedActivityItem)(worklogActivityItem), (0, $9Y7ra.setWorklogScrollStatus)(false));
            }).catch((error)=>{
                (0, $bPG0x.sendExperienceAnalytics)({
                    getExperienceDescription: ()=>(0, $4NX2u.worklogExperienceDescription)({
                            wasSuccessful: false,
                            action: 'FETCH_SURROUNDING',
                            analyticsSource: 'fetchSurroundingWorklogsAttachmentScroll',
                            projectType: projectType,
                            errorMessage: error.message
                        }),
                    error: error
                });
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.activity.worklog.fetch-worklog-by-id', 'Failed to load worklog list after attempting worklog attachment fetch', error);
                const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
                const field = 'worklog';
                showFlag({
                    type: 'error',
                    title: [
                        (0, $gZ3nQ.default).commentWorklogAttachmentFetchFailedTitle,
                        {
                            field: field
                        }
                    ],
                    description: (0, $gZ3nQ.default).commentWorklogAttachmentFetchFailedDescription,
                    isAutoDismiss: true
                });
                return (0, $3JafE.Observable).of((0, $9Y7ra.fetchWorklogsByIdFailure)());
            });
        });

});
parcelRegister("9WtAE", function(module, exports) {

$parcel$export(module.exports, "SCROLL_TARGET_TYPES", () => $31025ac124a30565$export$9c23d95db9552e9b);
const $31025ac124a30565$export$9c23d95db9552e9b = Object.freeze({
    COMMENT: 'COMMENT',
    WORKLOG: 'WORKLOG'
});

});

parcelRegister("gZ3nQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $85ad5eaaa3eea15e$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $85ad5eaaa3eea15e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    commentWorklogAttachmentFetchFailedTitle: {
        "id": "issue.comment-worklog-attachment-fetch-failed-title",
        "defaultMessage": "We couldn't find the {field}"
    },
    commentWorklogAttachmentFetchFailedDescription: {
        "id": "issue.comment-worklog-attachment-fetch-failed-description",
        "defaultMessage": "Reload the issue, then give it another try."
    }
});

});

parcelRegister("khpWz", function(module, exports) {

$parcel$export(module.exports, "SCROLL_TO_ATTACHMENT_COMMENT", () => $f8ada55761314a47$export$cfbde677eb9a0221);
$parcel$export(module.exports, "scrollToAttachmentComment", () => $f8ada55761314a47$export$a6562f3c64a5c827);
$parcel$export(module.exports, "SCROLL_TO_ATTACHMENT_WORKLOG", () => $f8ada55761314a47$export$1e01128d615e4184);
$parcel$export(module.exports, "scrollToAttachmentWorklog", () => $f8ada55761314a47$export$c5e2af4267d78a76);
const $f8ada55761314a47$export$cfbde677eb9a0221 = 'SCROLL_TO_ATTACHMENT_COMMENT';
const $f8ada55761314a47$export$a6562f3c64a5c827 = ()=>({
        type: $f8ada55761314a47$export$cfbde677eb9a0221
    });
const $f8ada55761314a47$export$1e01128d615e4184 = 'SCROLL_TO_ATTACHMENT_WORKLOG';
const $f8ada55761314a47$export$c5e2af4267d78a76 = ()=>({
        type: $f8ada55761314a47$export$1e01128d615e4184
    });

});

parcelRegister("l0ca0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d78f09643c76087$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");

var $11LM5 = parcelRequire("11LM5");
parcelRequire("flmol");

var $2vhSu = parcelRequire("2vhSu");

var $2FBOD = parcelRequire("2FBOD");
const $1d78f09643c76087$var$LOG_LOCATION = 'issue.worklogs.fetch.epic.gira';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1d78f09643c76087$export$2e2bcd8739ae039 = (baseUrl, issueKey, worklogAmount, sort, worklogId)=>// @ts-expect-error - TS2684 - The 'this' context of type 'Observable<ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>' is not assignable to method's 'this' of type 'Observable<FetchWorklogsData>'.
    (0, $2vhSu.default)({
        baseUrl: baseUrl,
        issueKey: issueKey,
        worklogAmount: worklogAmount,
        orderBy: (0, $1ybV0.ff)('issue-view-worklog-timestamp-fix_8d0dt') ? (0, $2FBOD.sortToOrderByCreatedMap)[sort] : (0, $2FBOD.sortToOrderByMap)[sort],
        worklogId: worklogId
    })// @ts-expect-error - TS2345 - Argument of type '<T extends ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>(response: GraphqlResponse<T>) => {    data: T;    errors: unknown;}' is not assignable to parameter of type '(value: unknown, index: number) => { data: ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse; errors: unknown; }'.
    .map((0, $11LM5.checkEmptyResponse))// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GraphqlResponse<ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>'.
    .map((response)=>(0, $11LM5.getGraphQlData)($1d78f09643c76087$var$LOG_LOCATION, response)).map((0, $2FBOD.transformData));

});
parcelRegister("2vhSu", function(module, exports) {

$parcel$export(module.exports, "default", () => $01c13c081c6c60f9$export$2e2bcd8739ae039);

var $aiRd8 = parcelRequire("aiRd8");

var $deUTx = parcelRequire("deUTx");
const $01c13c081c6c60f9$var$fetchSurroundingSortedWorklogsFromGira = ({ orderBy: orderBy, baseUrl: baseUrl, issueKey: issueKey, worklogAmount: worklogAmount, worklogId: worklogId })=>(0, $aiRd8.default)(`${baseUrl}/rest/gira/1/`, {
        method: 'POST',
        body: JSON.stringify({
            query: (0, $deUTx.getSortedWorklogsGiraQuery)({
                orderBy: orderBy,
                worklogAmount: worklogAmount,
                issueKey: issueKey,
                worklogId: worklogId
            })
        })
    });
var $01c13c081c6c60f9$export$2e2bcd8739ae039 = $01c13c081c6c60f9$var$fetchSurroundingSortedWorklogsFromGira;

});


parcelRegister("cLNC5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f17871fef4c4bfe6$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $f17871fef4c4bfe6$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    allActivity: {
        "id": "issue-activity-feed.all-activity",
        "defaultMessage": "All"
    },
    comments: {
        "id": "issue-activity-feed.comments",
        "defaultMessage": "Comments"
    },
    history: {
        "id": "issue-activity-feed.history",
        "defaultMessage": "History"
    },
    worklog: {
        "id": "issue-activity-feed.worklog",
        "defaultMessage": "Work log"
    },
    activity: {
        "id": "issue-activity-feed.activity",
        "defaultMessage": "Activity"
    },
    approvals: {
        "id": "issue-activity-feed.approvals",
        "defaultMessage": "Approvals"
    },
    filterBy: {
        "id": "issue-activity-feed.filter-by",
        "defaultMessage": "Show:"
    }
});

});


parcelRegister("gZCaw", function(module, exports) {

$parcel$export(module.exports, "fetchWorklogsRequest", () => $d06d461ae7dd1cb2$export$3d0b8d72bd963fe5);
$parcel$export(module.exports, "fetchWorklogsRequestInitial", () => $d06d461ae7dd1cb2$export$665ab5e3114627f1);
parcelRequire("jyKN9");
parcelRequire("9u6v2");
parcelRequire("3wBUP");
parcelRequire("l5lul");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $2Enn0 = parcelRequire("2Enn0");

var $gUUjF = parcelRequire("gUUjF");

var $JRB5w = parcelRequire("JRB5w");

var $4ceCM = parcelRequire("4ceCM");

var $eTy9x = parcelRequire("eTy9x");

var $jZDJX = parcelRequire("jZDJX");

var $dUqHv = parcelRequire("dUqHv");

var $4NX2u = parcelRequire("4NX2u");

var $kKk6E = parcelRequire("kKk6E");

var $9Y7ra = parcelRequire("9Y7ra");
const $d06d461ae7dd1cb2$var$fetchAndTransformWorklogs = (baseUrl, issueKey, projectType, analyticsEvent, startAt, maxResults)=>(0, $3JafE.Observable).from((0, $kKk6E.default)(baseUrl, issueKey, startAt, maxResults, true)).do((worklogsData)=>(0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                worklogItemCount: worklogsData.worklogs.length
            }
        })).map(({ totalWorklogs: totalWorklogs, worklogs: worklogs })=>{
        const sortedWorklogIds = worklogs.map((worklog)=>worklog.id);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const allWorklogsMap = worklogs.reduce((worklogMap, worklog)=>({
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...worklogMap,
                [worklog.id]: worklog
            }), {});
        (0, $4ceCM.sendExperienceAnalytics)((0, $4NX2u.worklogExperienceDescription)({
            wasSuccessful: true,
            action: 'FETCH',
            analyticsSource: 'fetchAndTransformWorklogs',
            projectType: projectType
        }));
        return (0, $9Y7ra.fetchWorklogsSuccess)(sortedWorklogIds, allWorklogsMap, totalWorklogs);
    }).catch((error)=>{
        !(0, $JRB5w.isClientFetchError)(error) && (0, $4ceCM.sendExperienceAnalytics)((0, $4NX2u.worklogExperienceDescription)({
            wasSuccessful: false,
            action: 'FETCH',
            analyticsSource: 'fetchAndTransformWorklogs',
            projectType: projectType,
            errorMessage: error.message
        }));
        (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.activity.worklog.fetch-worklogs', 'Could not fetch worklogs:', error);
        return (0, $3JafE.Observable).of((0, $9Y7ra.fetchWorklogsFailure)());
    });
const $d06d461ae7dd1cb2$export$3d0b8d72bd963fe5 = (action$, store)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    action$.ofType((0, $9Y7ra.FETCH_WORKLOGS_REQUEST)).switchMap(({ payload: { baseUrl: baseUrl, issueKey: issueKey }, meta: { analyticsEvent: analyticsEvent } })=>{
        const state = store.getState();
        const loadedWorklogs = (0, $dUqHv.sortedWorklogsSelector)(state).length;
        const startAt = loadedWorklogs;
        const projectType = (0, $jZDJX.projectTypeSelector)(state);
        return $d06d461ae7dd1cb2$var$fetchAndTransformWorklogs(baseUrl, issueKey, projectType, analyticsEvent, startAt, (0, $eTy9x.NUM_PAGED_ITEMS_TO_LOAD_OLD));
    });
const $d06d461ae7dd1cb2$export$665ab5e3114627f1 = (action$, store)=>/* eslint-disable @typescript-eslint/consistent-type-assertions */ action$.ofType((0, $9Y7ra.FETCH_WORKLOGS_REQUEST_INITIAL))/* eslint-enable @typescript-eslint/consistent-type-assertions */ .switchMap(({ payload: { baseUrl: baseUrl, issueKey: issueKey }, meta: { analyticsEvent: analyticsEvent } })=>{
        const state = store.getState();
        const projectType = (0, $jZDJX.projectTypeSelector)(state);
        return $d06d461ae7dd1cb2$var$fetchAndTransformWorklogs(baseUrl, issueKey, projectType, analyticsEvent, 0, (0, $eTy9x.NUM_INITIAL_ITEMS_TO_LOAD));
    });

});
parcelRegister("2Enn0", function(module, exports) {

$parcel$export(module.exports, "fireOperationalAnalytics", () => $3ee3ca60c3a36803$export$79f423cc3fd39762);

var $3LiTJ = parcelRequire("3LiTJ");

var $guiFP = parcelRequire("guiFP");

var $etqm0 = parcelRequire("etqm0");

var $klunD = parcelRequire("klunD");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $3ee3ca60c3a36803$var$isNotUndefined = (a)=>a !== undefined;
const $3ee3ca60c3a36803$var$mapPayload = (payload)=>{
    const context = (0, $klunD.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $3ee3ca60c3a36803$var$isNotUndefined);
};
const $3ee3ca60c3a36803$export$79f423cc3fd39762 = (event, payload)=>{
    // Causes issues with mounting the src/packages/confluence/project-pages/src/view/examples.js component in storybook tests.
    // This is due to node_modules/@atlassiansox/analytics-web-client/dist/analytics-web-client.with-deps.js producing a reference error with the normalize function
    // This is possibly due to some scope hoisting issue with jest that is not present in the browser
    try {
        event.update({
            ...$3ee3ca60c3a36803$var$mapPayload(payload),
            analyticsType: (0, $etqm0.OPERATIONAL_EVENT_TYPE)
        }).fire();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $guiFP.default)({
            event: event,
            error: e,
            meta: {
                id: 'fireOperationalAnalytics',
                packageName: 'jiraAnalyticsWebReact',
                teamName: 'legacy-jfp-team-do-not-use'
            }
        });
    }
};

});

parcelRegister("kKk6E", function(module, exports) {

$parcel$export(module.exports, "default", () => $14333b4e474fa9ac$export$2e2bcd8739ae039);

var $hsc5W = parcelRequire("hsc5W");

var $69v7R = parcelRequire("69v7R");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$14333b4e474fa9ac$export$2e2bcd8739ae039 = (baseUrl, issueKey, startAt, maxResults, reverseSort)=>(0, $69v7R.default)(baseUrl, issueKey, startAt, maxResults, reverseSort).then((result)=>(0, $hsc5W.transformResponse)(result));

});
parcelRegister("69v7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d467bfd7d1a3ef6$export$2e2bcd8739ae039);

var $lRmyA = parcelRequire("lRmyA");

var $deUTx = parcelRequire("deUTx");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5d467bfd7d1a3ef6$export$2e2bcd8739ae039 = (baseUrl, issueKey, startAt, maxResults, reverseSort)=>(0, $lRmyA.performGetRequest)(`${(0, $deUTx.getWorklogUrl)(baseUrl, issueKey)}?startAt=${startAt}&reverseSortOrder=${reverseSort ? 'true' : 'false'}${maxResults ? `&maxResults=${maxResults}` : ''}`);

});



parcelRegister("jXhYd", function(module, exports) {

$parcel$export(module.exports, "fetchSortedWorklogsRequest", () => $6e5b7e8bec95b86d$export$82665a9383fa0c1f);
parcelRequire("flmol");
parcelRequire("jyKN9");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $bPG0x = parcelRequire("bPG0x");

var $eTy9x = parcelRequire("eTy9x");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $gzLYm = parcelRequire("gzLYm");

var $4NX2u = parcelRequire("4NX2u");

var $ck0BO = parcelRequire("ck0BO");

var $9Y7ra = parcelRequire("9Y7ra");
const $6e5b7e8bec95b86d$export$82665a9383fa0c1f = (action$, store)=>action$.ofType((0, $9Y7ra.FETCH_SORTED_WORKLOGS_REQUEST), (0, $9Y7ra.FETCH_SORTED_WORKLOGS_RETRY)).switchMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueKey = (0, $5JqpU.issueKeySelector)(state);
        const selectedSortOrder = (0, $gzLYm.getSelectedActivitySortOrder)(state);
        const projectType = (0, $jZDJX.projectTypeSelector)(state);
        return (0, $ck0BO.default)(baseUrl, issueKey, (0, $eTy9x.NUM_INITIAL_ITEMS_TO_LOAD_FOR_POST_LOAD_ACTIONS), selectedSortOrder).map(({ worklogs: worklogs, totalWorklogs: totalWorklogs, startIndex: startIndex, sortedWorklogIds: sortedWorklogIds })=>{
            (0, $bPG0x.sendExperienceAnalytics)({
                getExperienceDescription: ()=>(0, $4NX2u.worklogExperienceDescription)({
                        wasSuccessful: true,
                        action: 'FETCH_SORTED',
                        analyticsSource: 'fetchSortedWorklogsRequest',
                        projectType: projectType
                    })
            });
            return (0, $9Y7ra.fetchSortedWorklogsSuccess)({
                worklogs: worklogs,
                totalWorklogs: totalWorklogs,
                startIndex: startIndex,
                sortedWorklogIds: sortedWorklogIds
            });
        }).catch((error)=>{
            (0, $bPG0x.sendExperienceAnalytics)({
                getExperienceDescription: ()=>(0, $4NX2u.worklogExperienceDescription)({
                        wasSuccessful: false,
                        action: 'FETCH_SORTED',
                        analyticsSource: 'fetchSortedWorklogsRequest',
                        projectType: projectType,
                        errorMessage: error.message
                    }),
                error: error
            });
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.activity.worklog.fetch-sorted-worklogs', 'Could not fetch sorted worklogs:', error);
            return (0, $3JafE.Observable).of((0, $9Y7ra.fetchSortedWorklogsFailure)());
        });
    });

});
parcelRegister("ck0BO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a919f4441a6227b1$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");

var $11LM5 = parcelRequire("11LM5");
parcelRequire("flmol");

var $itkiJ = parcelRequire("itkiJ");

var $2FBOD = parcelRequire("2FBOD");
const $a919f4441a6227b1$var$LOG_LOCATION = 'issue.worklogs.fetch.epic.gira';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a919f4441a6227b1$export$2e2bcd8739ae039 = (baseUrl, issueKey, maxResults, sort)=>// @ts-expect-error - TS2684 - The 'this' context of type 'Observable<ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>' is not assignable to method's 'this' of type 'Observable<FetchWorklogsData>'.
    (0, $itkiJ.default)({
        baseUrl: baseUrl,
        issueKey: issueKey,
        maxResults: maxResults,
        orderBy: (0, $1ybV0.ff)('issue-view-worklog-timestamp-fix_8d0dt') ? (0, $2FBOD.sortToOrderByCreatedMap)[sort] : (0, $2FBOD.sortToOrderByMap)[sort]
    })// @ts-expect-error - TS2345 - Argument of type '<T extends ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>(response: GraphqlResponse<T>) => {    data: T;    errors: unknown;}' is not assignable to parameter of type '(value: unknown, index: number) => { data: ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse; errors: unknown; }'.
    .map((0, $11LM5.checkEmptyResponse))// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GraphqlResponse<ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>'.
    .map((response)=>(0, $11LM5.getGraphQlData)($a919f4441a6227b1$var$LOG_LOCATION, response)).map((0, $2FBOD.transformData));

});
parcelRegister("itkiJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6f064cc28be67df$export$2e2bcd8739ae039);

var $aiRd8 = parcelRequire("aiRd8");

var $deUTx = parcelRequire("deUTx");
const $d6f064cc28be67df$var$fetchSortedWorklogsFromGira = ({ baseUrl: baseUrl, issueKey: issueKey, maxResults: maxResults, orderBy: orderBy })=>(0, $aiRd8.default)(`${baseUrl}/rest/gira/1/`, {
        method: 'POST',
        body: JSON.stringify({
            query: (0, $deUTx.getSortedWorklogsGiraQuery)({
                maxResults: maxResults,
                issueKey: issueKey,
                orderBy: orderBy
            })
        })
    });
var $d6f064cc28be67df$export$2e2bcd8739ae039 = $d6f064cc28be67df$var$fetchSortedWorklogsFromGira;

});




parcelRegister("kJCwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $013fea534d304851$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $c4dHe = parcelRequire("c4dHe");

var $gW0e1 = parcelRequire("gW0e1");

var $7hH7F = parcelRequire("7hH7F");
const $013fea534d304851$export$42b3fb926604751b = (getBaseUrl, getIssueKey, attachmentActions, issueContextActions, mediaContextActions)=>(0, $bd1K7.combineEpics)((0, $c4dHe.uploadContextEpicDeprecated)(getBaseUrl, getIssueKey, mediaContextActions), // @ts-expect-error - TS2345: Type 'UserAuthAction | ViewContextAction | UploadContextAction | BatchAction' is not assignable to type 'ViewContextAction | BatchAction'.
    (0, $7hH7F.viewContextEpicDeprecated)(getBaseUrl, getIssueKey, attachmentActions, issueContextActions, mediaContextActions), (0, $gW0e1.userAuthEpic)(getBaseUrl, getIssueKey, mediaContextActions));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$013fea534d304851$export$2e2bcd8739ae039 = (getBaseUrl, getIssueKey, subProduct, attachmentActions, issueContextActions, mediaContextActions)=>(0, $bd1K7.combineEpics)((0, $c4dHe.uploadContextEpic)(getBaseUrl, getIssueKey, subProduct, mediaContextActions), // @ts-expect-error - TS2345: Type 'UserAuthAction | ViewContextAction | UploadContextAction | BatchAction' is not assignable to type 'ViewContextAction | BatchAction'.
    (0, $7hH7F.viewContextEpic)(getBaseUrl, getIssueKey, subProduct, attachmentActions, issueContextActions, mediaContextActions), (0, $gW0e1.userAuthEpic)(getBaseUrl, getIssueKey, mediaContextActions));

});
parcelRegister("c4dHe", function(module, exports) {

$parcel$export(module.exports, "uploadContextEpicDeprecated", () => $2cd957a8b5a83109$export$7868bfd76c55cd1a);
$parcel$export(module.exports, "uploadContextEpic", () => $2cd957a8b5a83109$export$1378674a69aa97b);

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $6yPEx = parcelRequire("6yPEx");
parcelRequire("fRdoC");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("7Rus6");
parcelRequire("5dKXv");
parcelRequire("8SBcT");
parcelRequire("8OtG5");
parcelRequire("fiQ2m");
parcelRequire("3wBUP");
parcelRequire("l5lul");
parcelRequire("flmol");
parcelRequire("buH2V");
parcelRequire("1Lcr1");


var $fEYK5 = parcelRequire("fEYK5");

var $aVHDy = parcelRequire("aVHDy");

var $5s36j = parcelRequire("5s36j");
var $gA9Fk = parcelRequire("gA9Fk");
var $3A3OQ = parcelRequire("3A3OQ");

var $7EzIJ = parcelRequire("7EzIJ");

var $20th5 = parcelRequire("20th5");

var $gS8e9 = parcelRequire("gS8e9");

var $6vrw7 = parcelRequire("6vrw7");

var $cgReU = parcelRequire("cgReU");

var $5rovi = parcelRequire("5rovi");

var $cqZkv = parcelRequire("cqZkv");
const $2cd957a8b5a83109$var$MINIMUM_FOCUS_TIME_MS = 1000;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2cd957a8b5a83109$var$createFailureStream = (error)=>(0, $3JafE.Observable).of((0, $20th5.fetchUploadContextFailure)(error));
const $2cd957a8b5a83109$export$6f97ab46e48fd2cc = (baseUrl, issueKey, prefetchedMediaUploadPermissions)=>(0, $7EzIJ.fallbackOnMissingOrError$)(prefetchedMediaUploadPermissions, ()=>(0, $aVHDy.fetchMediaUploadPermission$)(baseUrl, issueKey)).map((0, $cqZkv.default)).map((0, $20th5.fetchUploadContextSuccess)).catch((error)=>{
        if (error.statusCode === (0, $1c3fbb431a173cc6$export$a3269a3914b007e3)) return $2cd957a8b5a83109$var$createFailureStream(error);
        throw error;
    }).retryWhen((0, $5s36j.genericRetryStrategy)).catch($2cd957a8b5a83109$var$createFailureStream);
const $2cd957a8b5a83109$export$792a4fe4871df2f6 = (baseUrl, issueKey, isServiceDesk, prefetchedMediaUploadPermissions)=>(0, $7EzIJ.fallbackOnMissingOrError$)(prefetchedMediaUploadPermissions, ()=>{
        if (isServiceDesk) (0, $cgReU.attachmentsUploadCredentialsExperience).start();
        return (0, $aVHDy.fetchMediaUploadPermission$)(baseUrl, issueKey);
    }).map((0, $cqZkv.default)).map((0, $20th5.fetchUploadContextSuccess)).catch((error)=>{
        if (error.statusCode === (0, $1c3fbb431a173cc6$export$a3269a3914b007e3)) return $2cd957a8b5a83109$var$createFailureStream(error);
        throw error;
    }).retryWhen((0, $5s36j.genericRetryStrategy)).do(()=>{
        if (isServiceDesk) (0, $cgReU.attachmentsUploadCredentialsExperience).success();
    }).catch((error)=>{
        if (isServiceDesk) (0, $cgReU.attachmentsUploadCredentialsExperience).failure();
        return $2cd957a8b5a83109$var$createFailureStream(error);
    });
const $2cd957a8b5a83109$export$7868bfd76c55cd1a = (getBaseUrl, getIssueKey, mediaContextActions)=>{
    const fetchUploadContextEpic = (// @ts-expect-error - TS2304 - Cannot find name 'ActionsObservable'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action$, // @ts-expect-error - TS2304 - Cannot find name 'MiddlewareAPI'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    store)=>action$.ofType((0, $20th5.FETCH_UPLOAD_CONTEXT_REQUEST)).switchMap(()=>{
            const state = store.getState();
            const baseUrl = getBaseUrl(state);
            const issueKey = getIssueKey(state);
            return $2cd957a8b5a83109$export$6f97ab46e48fd2cc(baseUrl, issueKey);
        });
    // @ts-expect-error - TS2304 - Cannot find name 'ActionsObservable'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const failureLoggingEpic = (action$)=>action$.ofType((0, $20th5.FETCH_UPLOAD_CONTEXT_FAILURE))// @ts-expect-error - TS7031 - Binding element 'payload' implicitly has an 'any' type.
        .filter(({ payload: payload })=>payload.error.statusCode !== (0, $1c3fbb431a173cc6$export$a3269a3914b007e3))// @ts-expect-error - TS7031 - Binding element 'payload' implicitly has an 'any' type.
        .do(({ payload: payload })=>{
            const { error: error } = payload;
            (0, $3A3OQ.trackOrLogClientError)('issue.media.fetch-upload-context-error', 'Error when fetching media upload context', error);
        }).ignoreElements();
    // Whenever the upload context is fetched, we need to schedule a subsequent fetch
    // to occur just before the current token is due to expire. This is implemented as
    // an infinite loop - "fetch success/failure" actions result in a new (delayed)
    // "fetch request" being scheduled.
    const refreshBeforeTokenExpiryEpic = (// @ts-expect-error - TS2304 - Cannot find name 'ActionsObservable'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action$, // @ts-expect-error - TS2304 - Cannot find name 'MiddlewareAPI'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    store)=>action$.pipe((0, $gA9Fk.ofTypeOrBatchType)((0, $20th5.FETCH_UPLOAD_CONTEXT_SUCCESS), (0, $20th5.CHECK_UPLOAD_CONTEXT)), (0, $6yPEx.switchMap)(()=>{
            const state = store.getState();
            const issueKey = getIssueKey(state);
            const uploadContext = (0, $gS8e9.uploadContextSelector)(state);
            if (uploadContext == null || !(0, $fEYK5.isPageVisible)()) return (0, $3JafE.Observable).empty();
            mediaContextActions.setUploadContext((0, $6vrw7.toIssueKey)(issueKey), uploadContext);
            const { tokenIssueTimestamp: tokenIssueTimestamp, tokenLifespanInMs: tokenLifespanInMs } = uploadContext;
            const wantsRefreshAt = tokenIssueTimestamp + tokenLifespanInMs;
            const timeUntilRefresh = Math.max(1, wantsRefreshAt - Date.now());
            return (0, $3JafE.Observable).of((0, $20th5.fetchUploadContextRequest)()).delay(timeUntilRefresh);
        }));
    // When a user returns to a tab (either from moving around in their browser, or a wake from
    // device sleep) we want to check their media upload token and refresh it if necessary. If a
    // refresh is needed, the switchMap in refreshBeforeTokenExpiryEpic will ensure we don't end
    // up with multiple timed refreshes, only the latest one.
    //
    // The combination of debounce and isPageVisible check means we only fire the event if the user
    // has stayed on the page for at least the debounce time, so as not to spam events.
    const focusChangeEpic = ()=>(0, $3JafE.Observable).fromEvent(window, 'focus').startWith(null).debounceTime($2cd957a8b5a83109$var$MINIMUM_FOCUS_TIME_MS).switchMap(()=>(0, $fEYK5.isPageVisible)() ? (0, $3JafE.Observable).of((0, $20th5.checkUploadContext)()) : (0, $3JafE.Observable).empty());
    return (0, $bd1K7.combineEpics)(fetchUploadContextEpic, refreshBeforeTokenExpiryEpic, failureLoggingEpic, focusChangeEpic);
};
const $2cd957a8b5a83109$export$1378674a69aa97b = (getBaseUrl, getIssueKey, subProduct, mediaContextActions)=>{
    const fetchUploadContextEpic = (// @ts-expect-error - TS2304 - Cannot find name 'ActionsObservable'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action$, // @ts-expect-error - TS2304 - Cannot find name 'MiddlewareAPI'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    store)=>action$.ofType((0, $20th5.FETCH_UPLOAD_CONTEXT_REQUEST)).switchMap(()=>{
            const state = store.getState();
            const baseUrl = getBaseUrl(state);
            const issueKey = getIssueKey(state);
            const isServiceDesk = (0, $5rovi.isServiceDesk)(subProduct);
            return $2cd957a8b5a83109$export$792a4fe4871df2f6(baseUrl, issueKey, isServiceDesk);
        });
    // @ts-expect-error - TS2304 - Cannot find name 'ActionsObservable'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const failureLoggingEpic = (action$)=>action$.ofType((0, $20th5.FETCH_UPLOAD_CONTEXT_FAILURE))// @ts-expect-error - TS7031 - Binding element 'payload' implicitly has an 'any' type.
        .filter(({ payload: payload })=>payload.error.statusCode !== (0, $1c3fbb431a173cc6$export$a3269a3914b007e3))// @ts-expect-error - TS7031 - Binding element 'payload' implicitly has an 'any' type.
        .do(({ payload: payload })=>{
            const { error: error } = payload;
            (0, $3A3OQ.trackOrLogClientError)('issue.media.fetch-upload-context-error', 'Error when fetching media upload context', error);
        }).ignoreElements();
    // Whenever the upload context is fetched, we need to schedule a subsequent fetch
    // to occur just before the current token is due to expire. This is implemented as
    // an infinite loop - "fetch success/failure" actions result in a new (delayed)
    // "fetch request" being scheduled.
    const refreshBeforeTokenExpiryEpic = (// @ts-expect-error - TS2304 - Cannot find name 'ActionsObservable'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action$, // @ts-expect-error - TS2304 - Cannot find name 'MiddlewareAPI'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    store)=>action$.pipe((0, $gA9Fk.ofTypeOrBatchType)((0, $20th5.FETCH_UPLOAD_CONTEXT_SUCCESS), (0, $20th5.CHECK_UPLOAD_CONTEXT)), (0, $6yPEx.switchMap)(()=>{
            const state = store.getState();
            const issueKey = getIssueKey(state);
            const uploadContext = (0, $gS8e9.uploadContextSelector)(state);
            if (uploadContext == null || !(0, $fEYK5.isPageVisible)()) return (0, $3JafE.Observable).empty();
            mediaContextActions.setUploadContext((0, $6vrw7.toIssueKey)(issueKey), uploadContext);
            const { tokenIssueTimestamp: tokenIssueTimestamp, tokenLifespanInMs: tokenLifespanInMs } = uploadContext;
            const wantsRefreshAt = tokenIssueTimestamp + tokenLifespanInMs;
            const timeUntilRefresh = Math.max(1, wantsRefreshAt - Date.now());
            return (0, $3JafE.Observable).of((0, $20th5.fetchUploadContextRequest)()).delay(timeUntilRefresh);
        }));
    // When a user returns to a tab (either from moving around in their browser, or a wake from
    // device sleep) we want to check their media upload token and refresh it if necessary. If a
    // refresh is needed, the switchMap in refreshBeforeTokenExpiryEpic will ensure we don't end
    // up with multiple timed refreshes, only the latest one.
    //
    // The combination of debounce and isPageVisible check means we only fire the event if the user
    // has stayed on the page for at least the debounce time, so as not to spam events.
    const focusChangeEpic = ()=>(0, $3JafE.Observable).fromEvent(window, 'focus').startWith(null).debounceTime($2cd957a8b5a83109$var$MINIMUM_FOCUS_TIME_MS).switchMap(()=>(0, $fEYK5.isPageVisible)() ? (0, $3JafE.Observable).of((0, $20th5.checkUploadContext)()) : (0, $3JafE.Observable).empty());
    return (0, $bd1K7.combineEpics)(fetchUploadContextEpic, refreshBeforeTokenExpiryEpic, failureLoggingEpic, focusChangeEpic);
};

});
parcelRegister("fEYK5", function(module, exports) {

$parcel$export(module.exports, "supportedVisiblityEvent", () => $72bec4f04bbd1d44$export$f7132cb36c80dad);
$parcel$export(module.exports, "isPageVisible", () => $72bec4f04bbd1d44$export$ae4f9b990bc70f70);
const $72bec4f04bbd1d44$var$visibilityMap = {
    // document property: event name
    hidden: 'visibilitychange',
    mozHidden: 'mozvisibilitychange',
    msHidden: 'msvisibilitychange',
    webkitHidden: 'webkitvisibilitychange'
};
const $72bec4f04bbd1d44$var$supportedHiddenKey = Object.keys($72bec4f04bbd1d44$var$visibilityMap).find(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Document'.
(key)=>typeof document !== 'undefined' && typeof document[key] !== 'undefined');
const $72bec4f04bbd1d44$export$f7132cb36c80dad = $72bec4f04bbd1d44$var$visibilityMap[$72bec4f04bbd1d44$var$supportedHiddenKey];
const $72bec4f04bbd1d44$export$ae4f9b990bc70f70 = ()=>typeof document !== 'undefined' && !document[$72bec4f04bbd1d44$var$supportedHiddenKey];

});

parcelRegister("aVHDy", function(module, exports) {

$parcel$export(module.exports, "fetchMediaUploadPermission$", () => $3a52522760e9ab9c$export$4862237f1b422788);
$parcel$export(module.exports, "fetchMediaUploadPermission", () => $3a52522760e9ab9c$export$a82dd485e12b42fc);
parcelRequire("1Lcr1");

var $2OdyW = parcelRequire("2OdyW");
var $aiRd8 = parcelRequire("aiRd8");

var $eIzT9 = parcelRequire("eIzT9");

var $7PTrm = parcelRequire("7PTrm");
const $3a52522760e9ab9c$export$4862237f1b422788 = (baseUrl, issueKey)=>(0, $aiRd8.default)((0, $eIzT9.getMediaUploadPermissionUrl)(baseUrl, issueKey)).catch((error)=>{
        throw new (0, $7PTrm.IssueViewFetchError)(error, (0, $eIzT9.getMediaUploadPermissionUrl)('{baseUrl}', '{issueKey}'));
    });
const $3a52522760e9ab9c$export$a82dd485e12b42fc = (baseUrl, issueKey)=>(0, $2OdyW.default)((0, $eIzT9.getMediaUploadPermissionUrl)(baseUrl, issueKey));

});
parcelRegister("eIzT9", function(module, exports) {

$parcel$export(module.exports, "getMediaUploadPermissionUrl", () => $2b74925d614f66fa$export$9f4e6a02a32c7984);
const $2b74925d614f66fa$export$9f4e6a02a32c7984 = (baseUrl, issueKey)=>`${baseUrl}/rest/api/2/attachment/upload/issue/${issueKey}/credentials`;

});


parcelRegister("5s36j", function(module, exports) {

$parcel$export(module.exports, "genericRetryStrategy", () => $515a274fac3f8824$export$581f0905dc196c0b);

var $3JafE = parcelRequire("3JafE");
parcelRequire("bI4RP");
parcelRequire("iects");
parcelRequire("8SBcT");
parcelRequire("jnCPY");
parcelRequire("cK7Id");
const $515a274fac3f8824$var$DEFAULT_RETRY_DELAY = 5000;
const $515a274fac3f8824$var$DEFAULT_RETRY_ATTEMPTS = 3;
const $515a274fac3f8824$export$55c14216677ba151 = (observable, options, // @ts-expect-error - TS2304 - Cannot find name 'rxjs$SchedulerClass'.
scheduler)=>observable.delay(options.delay, scheduler || undefined).take(options.take).concat(observable.flatMap((error)=>(0, $3JafE.Observable).throw(error)));
const $515a274fac3f8824$export$581f0905dc196c0b = (observable)=>$515a274fac3f8824$export$55c14216677ba151(observable, {
        delay: $515a274fac3f8824$var$DEFAULT_RETRY_DELAY,
        take: $515a274fac3f8824$var$DEFAULT_RETRY_ATTEMPTS
    });

});

parcelRegister("gA9Fk", function(module, exports) {

$parcel$export(module.exports, "ofTypeOrBatchType", () => $30f4a4440bebe3d1$export$74698910d51f5129);
parcelRequire("jyKN9");
parcelRequire("9u6v2");

var $cleLA = parcelRequire("cleLA");

var $3JafE = parcelRequire("3JafE");

var $dXapj = parcelRequire("dXapj");

var $b1qLQ = parcelRequire("b1qLQ");
// @ts-expect-error - TS2741 - Property 'batch' is missing in type '{}' but required in type 'BatchedActionMeta'.
const $30f4a4440bebe3d1$var$isBatch = ({ meta: { batch: batch } = {} })=>batch === true;
const $30f4a4440bebe3d1$var$includesType = (0, (/*@__PURE__*/$parcel$interopDefault($cleLA)))((types, { type: type })=>types.includes(type));
const $30f4a4440bebe3d1$export$74698910d51f5129 = (...types)=>(source)=>source.pipe((0, $dXapj.filter)((action)=>$30f4a4440bebe3d1$var$isBatch(action) ? action.payload.some($30f4a4440bebe3d1$var$includesType(types)) : types.includes(action.type)), (0, $b1qLQ.mergeMap)((action)=>$30f4a4440bebe3d1$var$isBatch(action) ? (0, $3JafE.Observable).from(action.payload.filter($30f4a4440bebe3d1$var$includesType(types))) : (0, $3JafE.Observable).of(action)));

});
parcelRegister("cleLA", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");
/** Used to compose bitmasks for function metadata. */ var $8fc2e687045586ce$var$WRAP_CURRY_FLAG = 8;
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function $8fc2e687045586ce$var$curry(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = $xQ3hV(func, $8fc2e687045586ce$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = $8fc2e687045586ce$var$curry.placeholder;
    return result;
}
// Assign default placeholders.
$8fc2e687045586ce$var$curry.placeholder = {};
module.exports = $8fc2e687045586ce$var$curry;

});
parcelRegister("xQ3hV", function(module, exports) {

var $2n5KA = parcelRequire("2n5KA");

var $ajgvA = parcelRequire("ajgvA");

var $4sFI9 = parcelRequire("4sFI9");

var $dJxZV = parcelRequire("dJxZV");

var $3slGh = parcelRequire("3slGh");

var $6bTTb = parcelRequire("6bTTb");

var $fHM5F = parcelRequire("fHM5F");

var $bV9co = parcelRequire("bV9co");

var $3mXyn = parcelRequire("3mXyn");

var $hNahz = parcelRequire("hNahz");
/** Error message constants. */ var $065b75a1a2ef24b3$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $065b75a1a2ef24b3$var$WRAP_BIND_FLAG = 1, $065b75a1a2ef24b3$var$WRAP_BIND_KEY_FLAG = 2, $065b75a1a2ef24b3$var$WRAP_CURRY_FLAG = 8, $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG = 16, $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG = 32, $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $065b75a1a2ef24b3$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $065b75a1a2ef24b3$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $065b75a1a2ef24b3$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError($065b75a1a2ef24b3$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG | $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $065b75a1a2ef24b3$var$nativeMax($hNahz(ary), 0);
    arity = arity === undefined ? arity : $hNahz(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $6bTTb(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $fHM5F(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $065b75a1a2ef24b3$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($065b75a1a2ef24b3$var$WRAP_CURRY_FLAG | $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($065b75a1a2ef24b3$var$WRAP_CURRY_FLAG | $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $065b75a1a2ef24b3$var$WRAP_BIND_FLAG) var result = $ajgvA(func, bitmask, thisArg);
    else if (bitmask == $065b75a1a2ef24b3$var$WRAP_CURRY_FLAG || bitmask == $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG) result = $4sFI9(func, bitmask, arity);
    else if ((bitmask == $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG || bitmask == ($065b75a1a2ef24b3$var$WRAP_BIND_FLAG | $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $3slGh(func, bitmask, thisArg, partials);
    else result = $dJxZV.apply(undefined, newData);
    var setter = data ? $2n5KA : $bV9co;
    return $3mXyn(setter(result, newData), func, bitmask);
}
module.exports = $065b75a1a2ef24b3$var$createWrap;

});
parcelRegister("2n5KA", function(module, exports) {

var $3QMTK = parcelRequire("3QMTK");

var $beYtW = parcelRequire("beYtW");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $1ba230a38b363991$var$baseSetData = !$beYtW ? $3QMTK : function(func, data) {
    $beYtW.set(func, data);
    return func;
};
module.exports = $1ba230a38b363991$var$baseSetData;

});

parcelRegister("ajgvA", function(module, exports) {

var $4ptXN = parcelRequire("4ptXN");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $78187bf3ce07aa33$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $78187bf3ce07aa33$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $78187bf3ce07aa33$var$WRAP_BIND_FLAG, Ctor = $4ptXN(func);
    function wrapper() {
        var fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $78187bf3ce07aa33$var$createBind;

});
parcelRegister("4ptXN", function(module, exports) {

var $9F9XB = parcelRequire("9F9XB");

var $feGjZ = parcelRequire("feGjZ");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $3360bd57e2c33b86$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $9F9XB(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $feGjZ(result) ? result : thisBinding;
    };
}
module.exports = $3360bd57e2c33b86$var$createCtor;

});


parcelRegister("4sFI9", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $4ptXN = parcelRequire("4ptXN");

var $dJxZV = parcelRequire("dJxZV");

var $lOKcz = parcelRequire("lOKcz");

var $9xQzO = parcelRequire("9xQzO");

var $kBgrU = parcelRequire("kBgrU");

var $c1MCs = parcelRequire("c1MCs");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $33fa21eee8bcca6f$var$createCurry(func, bitmask, arity) {
    var Ctor = $4ptXN(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $9xQzO(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $kBgrU(args, placeholder);
        length -= holders.length;
        if (length < arity) return $lOKcz(func, bitmask, $dJxZV, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        return $5VdlS(fn, this, args);
    }
    return wrapper;
}
module.exports = $33fa21eee8bcca6f$var$createCurry;

});
parcelRegister("dJxZV", function(module, exports) {

var $98OfC = parcelRequire("98OfC");

var $aoNSM = parcelRequire("aoNSM");

var $24kQN = parcelRequire("24kQN");

var $4ptXN = parcelRequire("4ptXN");

var $lOKcz = parcelRequire("lOKcz");

var $9xQzO = parcelRequire("9xQzO");

var $jtjhF = parcelRequire("jtjhF");

var $kBgrU = parcelRequire("kBgrU");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $9ff9d999ee3e5b26$var$WRAP_BIND_FLAG = 1, $9ff9d999ee3e5b26$var$WRAP_BIND_KEY_FLAG = 2, $9ff9d999ee3e5b26$var$WRAP_CURRY_FLAG = 8, $9ff9d999ee3e5b26$var$WRAP_CURRY_RIGHT_FLAG = 16, $9ff9d999ee3e5b26$var$WRAP_ARY_FLAG = 128, $9ff9d999ee3e5b26$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $9ff9d999ee3e5b26$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $9ff9d999ee3e5b26$var$WRAP_ARY_FLAG, isBind = bitmask & $9ff9d999ee3e5b26$var$WRAP_BIND_FLAG, isBindKey = bitmask & $9ff9d999ee3e5b26$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($9ff9d999ee3e5b26$var$WRAP_CURRY_FLAG | $9ff9d999ee3e5b26$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $9ff9d999ee3e5b26$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $4ptXN(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $9xQzO(wrapper), holdersCount = $24kQN(args, placeholder);
        if (partials) args = $98OfC(args, partials, holders, isCurried);
        if (partialsRight) args = $aoNSM(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $kBgrU(args, placeholder);
            return $lOKcz(func, bitmask, $9ff9d999ee3e5b26$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $jtjhF(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $c1MCs && this instanceof wrapper) fn = Ctor || $4ptXN(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $9ff9d999ee3e5b26$var$createHybrid;

});
parcelRegister("98OfC", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6a7bd72e71453dbc$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $6a7bd72e71453dbc$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $6a7bd72e71453dbc$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $6a7bd72e71453dbc$var$composeArgs;

});

parcelRegister("aoNSM", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7922d6e81726c41f$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $7922d6e81726c41f$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $7922d6e81726c41f$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $7922d6e81726c41f$var$composeArgsRight;

});

parcelRegister("24kQN", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $181c20ffe0a73f5e$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $181c20ffe0a73f5e$var$countHolders;

});

parcelRegister("lOKcz", function(module, exports) {

var $cp9gS = parcelRequire("cp9gS");

var $bV9co = parcelRequire("bV9co");

var $3mXyn = parcelRequire("3mXyn");
/** Used to compose bitmasks for function metadata. */ var $fe221b32db6745a2$var$WRAP_BIND_FLAG = 1, $fe221b32db6745a2$var$WRAP_BIND_KEY_FLAG = 2, $fe221b32db6745a2$var$WRAP_CURRY_BOUND_FLAG = 4, $fe221b32db6745a2$var$WRAP_CURRY_FLAG = 8, $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG = 32, $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $fe221b32db6745a2$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $fe221b32db6745a2$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG : $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG : $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $fe221b32db6745a2$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($fe221b32db6745a2$var$WRAP_BIND_FLAG | $fe221b32db6745a2$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($cp9gS(func)) $bV9co(result, newData);
    result.placeholder = placeholder;
    return $3mXyn(result, func, bitmask);
}
module.exports = $fe221b32db6745a2$var$createRecurry;

});
parcelRegister("bV9co", function(module, exports) {

var $2n5KA = parcelRequire("2n5KA");

var $d1V3m = parcelRequire("d1V3m");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $8adc2746a2aa5eeb$var$setData = $d1V3m($2n5KA);
module.exports = $8adc2746a2aa5eeb$var$setData;

});

parcelRegister("3mXyn", function(module, exports) {

var $4pgZb = parcelRequire("4pgZb");

var $1k0ou = parcelRequire("1k0ou");

var $ly0Gc = parcelRequire("ly0Gc");

var $7YePn = parcelRequire("7YePn");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $27419f3ed4dc5d4c$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return $ly0Gc(wrapper, $1k0ou(source, $7YePn($4pgZb(source), bitmask)));
}
module.exports = $27419f3ed4dc5d4c$var$setWrapToString;

});
parcelRegister("4pgZb", function(module, exports) {
/** Used to match wrap detail comments. */ var $3356ac43c54e635f$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $3356ac43c54e635f$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $3356ac43c54e635f$var$getWrapDetails(source) {
    var match = source.match($3356ac43c54e635f$var$reWrapDetails);
    return match ? match[1].split($3356ac43c54e635f$var$reSplitDetails) : [];
}
module.exports = $3356ac43c54e635f$var$getWrapDetails;

});

parcelRegister("1k0ou", function(module, exports) {
/** Used to match wrap detail comments. */ var $0f67f6f702bebdca$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $0f67f6f702bebdca$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace($0f67f6f702bebdca$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
module.exports = $0f67f6f702bebdca$var$insertWrapDetails;

});

parcelRegister("7YePn", function(module, exports) {

var $9Kzih = parcelRequire("9Kzih");

var $lqZWH = parcelRequire("lqZWH");
/** Used to compose bitmasks for function metadata. */ var $5cd9a37742eb8774$var$WRAP_BIND_FLAG = 1, $5cd9a37742eb8774$var$WRAP_BIND_KEY_FLAG = 2, $5cd9a37742eb8774$var$WRAP_CURRY_FLAG = 8, $5cd9a37742eb8774$var$WRAP_CURRY_RIGHT_FLAG = 16, $5cd9a37742eb8774$var$WRAP_PARTIAL_FLAG = 32, $5cd9a37742eb8774$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $5cd9a37742eb8774$var$WRAP_ARY_FLAG = 128, $5cd9a37742eb8774$var$WRAP_REARG_FLAG = 256, $5cd9a37742eb8774$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $5cd9a37742eb8774$var$wrapFlags = [
    [
        'ary',
        $5cd9a37742eb8774$var$WRAP_ARY_FLAG
    ],
    [
        'bind',
        $5cd9a37742eb8774$var$WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        $5cd9a37742eb8774$var$WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        $5cd9a37742eb8774$var$WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        $5cd9a37742eb8774$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        $5cd9a37742eb8774$var$WRAP_FLIP_FLAG
    ],
    [
        'partial',
        $5cd9a37742eb8774$var$WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        $5cd9a37742eb8774$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        $5cd9a37742eb8774$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $5cd9a37742eb8774$var$updateWrapDetails(details, bitmask) {
    $9Kzih($5cd9a37742eb8774$var$wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !$lqZWH(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $5cd9a37742eb8774$var$updateWrapDetails;

});



parcelRegister("9xQzO", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $6f2ffabf17208972$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $6f2ffabf17208972$var$getHolder;

});

parcelRegister("jtjhF", function(module, exports) {

var $b69Sx = parcelRequire("b69Sx");

var $3hFfZ = parcelRequire("3hFfZ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e2cfaf2379d6eef4$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $e2cfaf2379d6eef4$var$reorder(array, indexes) {
    var arrLength = array.length, length = $e2cfaf2379d6eef4$var$nativeMin(indexes.length, arrLength), oldArray = $b69Sx(array);
    while(length--){
        var index = indexes[length];
        array[length] = $3hFfZ(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $e2cfaf2379d6eef4$var$reorder;

});

parcelRegister("kBgrU", function(module, exports) {
/** Used as the internal argument placeholder. */ var $eff405cccdf3a041$var$PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $eff405cccdf3a041$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $eff405cccdf3a041$var$PLACEHOLDER) {
            array[index] = $eff405cccdf3a041$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $eff405cccdf3a041$var$replaceHolders;

});



parcelRegister("3slGh", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $4ptXN = parcelRequire("4ptXN");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $2844ce06b6725f7d$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $2844ce06b6725f7d$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $2844ce06b6725f7d$var$WRAP_BIND_FLAG, Ctor = $4ptXN(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $5VdlS(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $2844ce06b6725f7d$var$createPartial;

});

parcelRegister("fHM5F", function(module, exports) {

var $98OfC = parcelRequire("98OfC");

var $aoNSM = parcelRequire("aoNSM");

var $kBgrU = parcelRequire("kBgrU");
/** Used as the internal argument placeholder. */ var $b6f02cf0a655a19e$var$PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var $b6f02cf0a655a19e$var$WRAP_BIND_FLAG = 1, $b6f02cf0a655a19e$var$WRAP_BIND_KEY_FLAG = 2, $b6f02cf0a655a19e$var$WRAP_CURRY_BOUND_FLAG = 4, $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG = 8, $b6f02cf0a655a19e$var$WRAP_ARY_FLAG = 128, $b6f02cf0a655a19e$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b6f02cf0a655a19e$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $b6f02cf0a655a19e$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($b6f02cf0a655a19e$var$WRAP_BIND_FLAG | $b6f02cf0a655a19e$var$WRAP_BIND_KEY_FLAG | $b6f02cf0a655a19e$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $b6f02cf0a655a19e$var$WRAP_ARY_FLAG && bitmask == $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG || srcBitmask == $b6f02cf0a655a19e$var$WRAP_ARY_FLAG && bitmask == $b6f02cf0a655a19e$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($b6f02cf0a655a19e$var$WRAP_ARY_FLAG | $b6f02cf0a655a19e$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $b6f02cf0a655a19e$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $b6f02cf0a655a19e$var$WRAP_BIND_FLAG ? 0 : $b6f02cf0a655a19e$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $98OfC(partials, value, source[4]) : value;
        data[4] = partials ? $kBgrU(data[3], $b6f02cf0a655a19e$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $aoNSM(partials, value, source[6]) : value;
        data[6] = partials ? $kBgrU(data[5], $b6f02cf0a655a19e$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $b6f02cf0a655a19e$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $b6f02cf0a655a19e$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $b6f02cf0a655a19e$var$mergeData;

});




parcelRegister("7EzIJ", function(module, exports) {

$parcel$export(module.exports, "fallbackOnMissingOrError$", () => $7309cf83975b49ac$export$45cee4e5d1130510);

var $3JafE = parcelRequire("3JafE");
parcelRequire("cpH8E");
parcelRequire("1Lcr1");
const $7309cf83975b49ac$export$45cee4e5d1130510 = (primary, fallback)=>{
    if (primary) return (0, $3JafE.Observable).fromPromise(primary).catch(fallback);
    return fallback();
};

});

parcelRegister("gS8e9", function(module, exports) {

$parcel$export(module.exports, "mediaContextSelector", () => $e5e666869e3607c6$export$4d7b3304a6a85070);
$parcel$export(module.exports, "userAuthSelector", () => $e5e666869e3607c6$export$f9402070b385f35b);
$parcel$export(module.exports, "viewContextSelector", () => $e5e666869e3607c6$export$946186e6642433d5);
$parcel$export(module.exports, "uploadContextSelector", () => $e5e666869e3607c6$export$810db129b66854a6);

var $df4Sl = parcelRequire("df4Sl");
const $e5e666869e3607c6$export$4d7b3304a6a85070 = (state)=>state.mediaContext;
const $e5e666869e3607c6$export$f9402070b385f35b = (0, $df4Sl.createSelector)($e5e666869e3607c6$export$4d7b3304a6a85070, (mediaContext)=>mediaContext && mediaContext.userAuth || null);
const $e5e666869e3607c6$export$946186e6642433d5 = (0, $df4Sl.createSelector)($e5e666869e3607c6$export$4d7b3304a6a85070, (mediaContext)=>mediaContext && mediaContext.viewContext || null);
const $e5e666869e3607c6$export$810db129b66854a6 = (0, $df4Sl.createSelector)($e5e666869e3607c6$export$4d7b3304a6a85070, (mediaContext)=>mediaContext && mediaContext.uploadContext || null);

});

parcelRegister("cgReU", function(module, exports) {

$parcel$export(module.exports, "attachmentsUploadCredentialsExperience", () => $5b1116225a189f4a$export$81dc27009475be16);
$parcel$export(module.exports, "attachmentsReadCredentialsExperience", () => $5b1116225a189f4a$export$adee91c4259f250d);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $5b1116225a189f4a$export$81dc27009475be16 = new (0, $kDfSL.UFOExperience)('jsm-issue-view-attachments-upload-credentials', {
    type: (0, $12kyE.ExperienceTypes).Operation,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom
});
const $5b1116225a189f4a$export$adee91c4259f250d = new (0, $kDfSL.UFOExperience)('jsm-issue-view-attachments-read-credentials', {
    type: (0, $12kyE.ExperienceTypes).Operation,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom
});

});

parcelRegister("5rovi", function(module, exports) {

$parcel$export(module.exports, "isServiceDesk", () => $71484f9b0be7a412$export$717d57f576daf5c8);

var $7ZZxN = parcelRequire("7ZZxN");
const $71484f9b0be7a412$export$717d57f576daf5c8 = (subProduct)=>subProduct === (0, $7ZZxN.SERVICE_DESK_PROJECT_ANALYTICS);

});

parcelRegister("cqZkv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c905aef027b99ac$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8c905aef027b99ac$export$2e2bcd8739ae039 = (uploadResponse)=>({
        clientId: uploadResponse.clientId,
        serviceHost: uploadResponse.endpointUrl,
        token: uploadResponse.token,
        tokenLifespanInMs: uploadResponse.tokenDurationInMins * 60000,
        collection: uploadResponse.targetCollection,
        tokenIssueTimestamp: Date.now() - 10000
    });

});


parcelRegister("gW0e1", function(module, exports) {

$parcel$export(module.exports, "userAuthEpic", () => $b88188cfc2e93c16$export$79576b597697667d);

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $6yPEx = parcelRequire("6yPEx");
parcelRequire("fRdoC");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("7Rus6");
parcelRequire("5dKXv");
parcelRequire("8SBcT");
parcelRequire("8OtG5");
parcelRequire("l5lul");
parcelRequire("fiQ2m");
parcelRequire("3wBUP");


var $fEYK5 = parcelRequire("fEYK5");

var $gA9Fk = parcelRequire("gA9Fk");
var $3A3OQ = parcelRequire("3A3OQ");

var $jsDaf = parcelRequire("jsDaf");

var $gS8e9 = parcelRequire("gS8e9");

var $6vrw7 = parcelRequire("6vrw7");

var $4oDHx = parcelRequire("4oDHx");
const $b88188cfc2e93c16$var$MINIMUM_FOCUS_TIME_MS = 1000;
const $b88188cfc2e93c16$export$79576b597697667d = (getBaseUrl, getIssueKey, mediaContextActions)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'ActionsObservable'. | TS2304 - Cannot find name 'MiddlewareAPI'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fetchUserAuthEpic = (action$, store)=>action$.ofType((0, $jsDaf.FETCH_USER_AUTH_REQUEST)).switchMap(()=>{
            const state = store.getState();
            const baseUrl = getBaseUrl(state);
            return (0, $4oDHx.fetchUserAuth)(baseUrl);
        });
    // @ts-expect-error - TS2304 - Cannot find name 'ActionsObservable'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const failureLoggingEpic = (action$)=>action$.ofType((0, $jsDaf.FETCH_USER_AUTH_FAILURE))// @ts-expect-error - TS7031 - Binding element 'payload' implicitly has an 'any' type.
        .filter(({ payload: payload })=>payload.statusCode !== (0, $1c3fbb431a173cc6$export$a3269a3914b007e3))// @ts-expect-error - TS7031 - Binding element 'payload' implicitly has an 'any' type.
        .do(({ payload: payload })=>{
            (0, $3A3OQ.trackOrLogClientError)('issue.media.fetch-user-auth-error', 'Error when fetching media user auth', payload);
        }).ignoreElements();
    // Whenever the user auth token is fetched, we need to schedule a subsequent fetch
    // to occur just before the current token is due to expire. This is implemented as
    // an infinite loop - "fetch success/failure" actions result in a new (delayed)
    // "fetch request" being scheduled.
    const refreshBeforeTokenExpiryEpic = (// @ts-expect-error - TS2304 - Cannot find name 'ActionsObservable'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action$, // @ts-expect-error - TS2304 - Cannot find name 'MiddlewareAPI'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    store)=>action$.pipe((0, $gA9Fk.ofTypeOrBatchType)((0, $jsDaf.FETCH_USER_AUTH_SUCCESS), (0, $jsDaf.CHECK_USER_AUTH)), (0, $6yPEx.switchMap)(()=>{
            const state = store.getState();
            const issueKey = getIssueKey(state);
            const userAuth = (0, $gS8e9.userAuthSelector)(state);
            mediaContextActions.setUserAuthContext((0, $6vrw7.toIssueKey)(issueKey), userAuth);
            if (userAuth == null || !(0, $fEYK5.isPageVisible)()) return (0, $3JafE.Observable).empty();
            const { tokenIssueTimestamp: tokenIssueTimestamp, tokenLifespanInMs: tokenLifespanInMs } = userAuth;
            const wantsRefreshAt = tokenIssueTimestamp + tokenLifespanInMs;
            const timeUntilRefresh = Math.max(1, wantsRefreshAt - Date.now());
            return (0, $3JafE.Observable).of((0, $jsDaf.fetchUserAuthRequest)()).delay(timeUntilRefresh);
        }));
    // When a user returns to a tab (either from moving around in their browser, or a wake
    // from device sleep) we want to check their auth token and refresh it if necessary. If a
    // refresh is needed, the switchMap in refreshBeforeTokenExpiryEpic will ensure we don't end
    // up with multiple timed refreshes, only the latest one.
    //
    // The combination of debounce and isPageVisible check means we only fire the event if the user
    // has stayed on the page for at least the debounce time, so as not to spam events.
    const focusChangeEpic = ()=>(0, $3JafE.Observable).fromEvent(window, 'focus').startWith(null).debounceTime($b88188cfc2e93c16$var$MINIMUM_FOCUS_TIME_MS).switchMap(()=>(0, $fEYK5.isPageVisible)() ? (0, $3JafE.Observable).of((0, $jsDaf.checkUserAuth)()) : (0, $3JafE.Observable).empty());
    return (0, $bd1K7.combineEpics)(fetchUserAuthEpic, refreshBeforeTokenExpiryEpic, failureLoggingEpic, focusChangeEpic);
};

});
parcelRegister("4oDHx", function(module, exports) {

$parcel$export(module.exports, "fetchUserAuth", () => $a3d9887679d25d83$export$d5f188f626110f69);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("buH2V");
parcelRequire("1Lcr1");
parcelRequire("flmol");


var $i9YXt = parcelRequire("i9YXt");

var $veOiz = parcelRequire("veOiz");

var $5s36j = parcelRequire("5s36j");

var $7EzIJ = parcelRequire("7EzIJ");

var $jsDaf = parcelRequire("jsDaf");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a3d9887679d25d83$var$createFailureStream = (error)=>(0, $3JafE.Observable).of((0, $jsDaf.fetchUserAuthFailure)(error.statusCode));
const $a3d9887679d25d83$export$d5f188f626110f69 = (baseUrl, prefetchedUserAuth)=>{
    // @ts-expect-error - TS2684 - The 'this' context of type 'Observable<unknown>' is not assignable to method's 'this' of type 'Observable<UserAuthResponse>'.
    const fetchUserAuthObservable = (0, $7EzIJ.fallbackOnMissingOrError$)(prefetchedUserAuth, ()=>(0, $i9YXt.fetchUserAuth$)(baseUrl)).map((0, $veOiz.userAuthTransformer)).map((0, $jsDaf.fetchUserAuthSuccess));
    return fetchUserAuthObservable.catch((error)=>{
        if (error.statusCode === (0, $1c3fbb431a173cc6$export$a3269a3914b007e3)) return $a3d9887679d25d83$var$createFailureStream(error);
        throw error;
    }).retryWhen((0, $5s36j.genericRetryStrategy)).catch($a3d9887679d25d83$var$createFailureStream);
};

});
parcelRegister("i9YXt", function(module, exports) {

$parcel$export(module.exports, "fetchUserAuth$", () => $dd1d23240c6d13da$export$bfce9003c4920816);

var $2OdyW = parcelRequire("2OdyW");
var $aiRd8 = parcelRequire("aiRd8");

var $3zLsg = parcelRequire("3zLsg");

var $7PTrm = parcelRequire("7PTrm");
const $dd1d23240c6d13da$export$bfce9003c4920816 = (baseUrl)=>(0, $aiRd8.default)((0, $3zLsg.getUserAuthUrl)(baseUrl)).catch((error)=>{
        throw new (0, $7PTrm.IssueViewFetchError)(error, (0, $3zLsg.getUserAuthUrl)('{baseUrl}'));
    });
const $dd1d23240c6d13da$export$d5f188f626110f69 = (baseUrl)=>(0, $2OdyW.default)((0, $3zLsg.getUserAuthUrl)(baseUrl));

});
parcelRegister("3zLsg", function(module, exports) {

$parcel$export(module.exports, "getUserAuthUrl", () => $2487c9f5dbfae247$export$439bb536ef71889a);
const $2487c9f5dbfae247$export$439bb536ef71889a = (baseUrl)=>`${baseUrl}/rest/internal/2/media/user/credentials`;

});


parcelRegister("veOiz", function(module, exports) {

$parcel$export(module.exports, "userAuthTransformer", () => $72fb19ce5aae0c7d$export$6b3d4b609d3b34b0);
const $72fb19ce5aae0c7d$export$6b3d4b609d3b34b0 = (response)=>({
        clientId: response.id,
        token: response.token,
        tokenLifespanInMs: response.tokenDurationInMins * 60000,
        tokenIssueTimestamp: Date.now() - 10000
    });

});



parcelRegister("7hH7F", function(module, exports) {

$parcel$export(module.exports, "fetchViewContextWithErrorHandling", () => $9fbcf91c96d8a076$export$444da5c02120ce5b);
$parcel$export(module.exports, "viewContextEpicDeprecated", () => $9fbcf91c96d8a076$export$ad028d85562ff376);
$parcel$export(module.exports, "viewContextEpic", () => $9fbcf91c96d8a076$export$6907e8f39191e400);
parcelRequire("fRdoC");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("7Rus6");
parcelRequire("5dKXv");
parcelRequire("8SBcT");
parcelRequire("fiQ2m");
parcelRequire("3wBUP");
parcelRequire("l5lul");
parcelRequire("buH2V");
parcelRequire("1Lcr1");
parcelRequire("flmol");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $6yPEx = parcelRequire("6yPEx");


var $fEYK5 = parcelRequire("fEYK5");

var $eU1AE = parcelRequire("eU1AE");

var $hEEI6 = parcelRequire("hEEI6");

var $5s36j = parcelRequire("5s36j");
var $gA9Fk = parcelRequire("gA9Fk");
var $3A3OQ = parcelRequire("3A3OQ");

var $7EzIJ = parcelRequire("7EzIJ");

var $hlJEN = parcelRequire("hlJEN");

var $gS8e9 = parcelRequire("gS8e9");

var $6vrw7 = parcelRequire("6vrw7");

var $cgReU = parcelRequire("cgReU");

var $5rovi = parcelRequire("5rovi");
const $9fbcf91c96d8a076$var$MINIMUM_FOCUS_TIME_MS = 1000;
const $9fbcf91c96d8a076$var$createFailureStream = (error)=>(0, $3JafE.Observable).of((0, $hlJEN.fetchViewContextFailure)(error));
const $9fbcf91c96d8a076$var$fetchViewContextDeprecated = (baseUrl, issueKey, maxTokenLength, headersProcessor, prefetchedMediaReadPermissions)=>(0, $7EzIJ.fallbackOnMissingOrError$)(prefetchedMediaReadPermissions, ()=>(0, $eU1AE.fetchIssueMediaReadPermission$)(baseUrl, issueKey, maxTokenLength, headersProcessor)).map((0, $hEEI6.viewContextTransformer)).map((0, $hlJEN.fetchViewContextSuccess));
const $9fbcf91c96d8a076$var$fetchViewContext = (baseUrl, issueKey, maxTokenLength, isServiceDesk, headersProcessor, prefetchedMediaReadPermissions)=>(0, $7EzIJ.fallbackOnMissingOrError$)(prefetchedMediaReadPermissions, ()=>{
        if (isServiceDesk) (0, $cgReU.attachmentsReadCredentialsExperience).start();
        return (0, $eU1AE.fetchIssueMediaReadPermission$)(baseUrl, issueKey, maxTokenLength, headersProcessor);
    }).map((0, $hEEI6.viewContextTransformer)).map((0, $hlJEN.fetchViewContextSuccess));
const $9fbcf91c96d8a076$export$e6b76cdf666003ab = (baseUrl, issueKey, maxTokenLength, headersProcessor, prefetchedMediaReadPermissions)=>$9fbcf91c96d8a076$var$fetchViewContextDeprecated(baseUrl, issueKey, maxTokenLength, headersProcessor, prefetchedMediaReadPermissions).catch((error)=>{
        if (error.statusCode === (0, $1c3fbb431a173cc6$export$a3269a3914b007e3)) return $9fbcf91c96d8a076$var$createFailureStream(error);
        throw error;
    }).retryWhen((0, $5s36j.genericRetryStrategy)).catch($9fbcf91c96d8a076$var$createFailureStream);
const $9fbcf91c96d8a076$export$9a275ff8d8dda31b = (baseUrl, issueKey, maxTokenLength, isServiceDesk, headersProcessor, prefetchedMediaReadPermissions)=>$9fbcf91c96d8a076$var$fetchViewContext(baseUrl, issueKey, maxTokenLength, isServiceDesk, headersProcessor, prefetchedMediaReadPermissions).catch((error)=>{
        if (error.statusCode === (0, $1c3fbb431a173cc6$export$a3269a3914b007e3)) return $9fbcf91c96d8a076$var$createFailureStream(error);
        throw error;
    }).retryWhen((0, $5s36j.genericRetryStrategy)).do(()=>{
        if (isServiceDesk) (0, $cgReU.attachmentsReadCredentialsExperience).success();
    }).catch((error)=>{
        if (isServiceDesk) (0, $cgReU.attachmentsReadCredentialsExperience).failure();
        return $9fbcf91c96d8a076$var$createFailureStream(error);
    });
const $9fbcf91c96d8a076$export$444da5c02120ce5b = (baseUrl, issueKey, maxTokenLength, isServiceDesk, headersProcessor, prefetchedMediaReadPermissions)=>$9fbcf91c96d8a076$export$9a275ff8d8dda31b(baseUrl, issueKey, maxTokenLength, isServiceDesk, headersProcessor, prefetchedMediaReadPermissions);
const $9fbcf91c96d8a076$export$ad028d85562ff376 = (getBaseUrl, getIssueKey, attachmentActions, issueContextActions, mediaContextActions)=>{
    const fetchViewContextEpic = (action$, store)=>action$.ofType((0, $hlJEN.FETCH_VIEW_CONTEXT_REQUEST)).switchMap(()=>{
            const state = store.getState();
            const baseUrl = getBaseUrl(state);
            const issueKey = getIssueKey(state);
            const maxTokenLength = issueContextActions.getMaxTokenLength();
            attachmentActions.refreshAttachments((0, $6vrw7.toIssueKey)(issueKey));
            return $9fbcf91c96d8a076$export$e6b76cdf666003ab(baseUrl, issueKey, maxTokenLength);
        });
    const failureLoggingEpic = (action$)=>action$.ofType((0, $hlJEN.FETCH_VIEW_CONTEXT_FAILURE)).do(({ payload: payload })=>{
            const { error: error } = payload;
            (0, $3A3OQ.trackOrLogClientError)('issue.media.fetch-view-context-error', 'Error when fetching media view context', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error);
        }).ignoreElements();
    // Whenever the view context is fetched, we need to schedule a subsequent fetch
    // to occur just before the current token is due to expire. This is implemented as
    // an infinite loop - "fetch success/failure" actions result in a new (delayed)
    // "fetch request" being scheduled.
    const refreshBeforeTokenExpiryEpic = (action$, store)=>action$.pipe((0, $gA9Fk.ofTypeOrBatchType)((0, $hlJEN.FETCH_VIEW_CONTEXT_SUCCESS), (0, $hlJEN.CHECK_VIEW_CONTEXT)), (0, $6yPEx.switchMap)(()=>{
            const state = store.getState();
            const issueKey = getIssueKey(state);
            const viewContext = (0, $gS8e9.viewContextSelector)(state);
            if (viewContext == null || !(0, $fEYK5.isPageVisible)()) return (0, $3JafE.Observable).empty();
            mediaContextActions.setViewContext((0, $6vrw7.toIssueKey)(issueKey), viewContext);
            const { tokenIssueTimestamp: tokenIssueTimestamp, tokenLifespanInMs: tokenLifespanInMs } = viewContext;
            const wantsRefreshAt = tokenIssueTimestamp + tokenLifespanInMs;
            const timeUntilRefresh = Math.max(1, wantsRefreshAt - Date.now());
            return (0, $3JafE.Observable).of((0, $hlJEN.fetchViewContextRequest)()).delay(timeUntilRefresh);
        }));
    // When a user returns to a tab (either from moving around in their browser, or a wake from
    // device sleep) we want to check their media view token and refresh it if necessary. If a
    // refresh is needed, the switchMap in refreshBeforeTokenExpiryEpic will ensure we don't end
    // up with multiple timed refreshes, only the latest one.
    //
    // The combination of debounce and isPageVisible check means we only fire the event if the user
    // has stayed on the page for at least the debounce time, so as not to spam events.
    const focusChangeEpic = ()=>(0, $3JafE.Observable).fromEvent(window, 'focus').startWith(null).debounceTime($9fbcf91c96d8a076$var$MINIMUM_FOCUS_TIME_MS).switchMap(()=>(0, $fEYK5.isPageVisible)() ? (0, $3JafE.Observable).of((0, $hlJEN.checkViewContext)()) : (0, $3JafE.Observable).empty());
    return (0, $bd1K7.combineEpics)(fetchViewContextEpic, refreshBeforeTokenExpiryEpic, failureLoggingEpic, focusChangeEpic);
};
const $9fbcf91c96d8a076$export$6907e8f39191e400 = (getBaseUrl, getIssueKey, subProduct, attachmentActions, issueContextActions, mediaContextActions)=>{
    const fetchViewContextEpic = (action$, store)=>action$.ofType((0, $hlJEN.FETCH_VIEW_CONTEXT_REQUEST)).switchMap(()=>{
            const state = store.getState();
            const baseUrl = getBaseUrl(state);
            const issueKey = getIssueKey(state);
            const isServiceDesk = (0, $5rovi.isServiceDesk)(subProduct);
            const maxTokenLength = issueContextActions.getMaxTokenLength();
            attachmentActions.refreshAttachments((0, $6vrw7.toIssueKey)(issueKey));
            return $9fbcf91c96d8a076$export$9a275ff8d8dda31b(baseUrl, issueKey, maxTokenLength, isServiceDesk);
        });
    const failureLoggingEpic = (action$)=>action$.ofType((0, $hlJEN.FETCH_VIEW_CONTEXT_FAILURE)).do(({ payload: payload })=>{
            const { error: error } = payload;
            (0, $3A3OQ.trackOrLogClientError)('issue.media.fetch-view-context-error', 'Error when fetching media view context', error);
        }).ignoreElements();
    // Whenever the view context is fetched, we need to schedule a subsequent fetch
    // to occur just before the current token is due to expire. This is implemented as
    // an infinite loop - "fetch success/failure" actions result in a new (delayed)
    // "fetch request" being scheduled.
    const refreshBeforeTokenExpiryEpic = (action$, store)=>action$.pipe((0, $gA9Fk.ofTypeOrBatchType)((0, $hlJEN.FETCH_VIEW_CONTEXT_SUCCESS), (0, $hlJEN.CHECK_VIEW_CONTEXT)), (0, $6yPEx.switchMap)(()=>{
            const state = store.getState();
            const issueKey = getIssueKey(state);
            const viewContext = (0, $gS8e9.viewContextSelector)(state);
            mediaContextActions.setViewContext((0, $6vrw7.toIssueKey)(issueKey), viewContext);
            if (viewContext == null || !(0, $fEYK5.isPageVisible)()) return (0, $3JafE.Observable).empty();
            const { tokenIssueTimestamp: tokenIssueTimestamp, tokenLifespanInMs: tokenLifespanInMs } = viewContext;
            const wantsRefreshAt = tokenIssueTimestamp + tokenLifespanInMs;
            const timeUntilRefresh = Math.max(1, wantsRefreshAt - Date.now());
            return (0, $3JafE.Observable).of((0, $hlJEN.fetchViewContextRequest)()).delay(timeUntilRefresh);
        }));
    // When a user returns to a tab (either from moving around in their browser, or a wake from
    // device sleep) we want to check their media view token and refresh it if necessary. If a
    // refresh is needed, the switchMap in refreshBeforeTokenExpiryEpic will ensure we don't end
    // up with multiple timed refreshes, only the latest one.
    //
    // The combination of debounce and isPageVisible check means we only fire the event if the user
    // has stayed on the page for at least the debounce time, so as not to spam events.
    const focusChangeEpic = ()=>(0, $3JafE.Observable).fromEvent(window, 'focus').startWith(null).debounceTime($9fbcf91c96d8a076$var$MINIMUM_FOCUS_TIME_MS).switchMap(()=>(0, $fEYK5.isPageVisible)() ? (0, $3JafE.Observable).of((0, $hlJEN.checkViewContext)()) : (0, $3JafE.Observable).empty());
    return (0, $bd1K7.combineEpics)(fetchViewContextEpic, refreshBeforeTokenExpiryEpic, failureLoggingEpic, focusChangeEpic);
};

});
parcelRegister("eU1AE", function(module, exports) {

$parcel$export(module.exports, "fetchIssueMediaReadPermission$", () => $762f6dda7406d156$export$bd8b8cab48ee0127);
$parcel$export(module.exports, "fetchIssueMediaReadPermission", () => $762f6dda7406d156$export$766b91f9f60d1317);
parcelRequire("1Lcr1");

var $2OdyW = parcelRequire("2OdyW");
var $aiRd8 = parcelRequire("aiRd8");

var $d6jSm = parcelRequire("d6jSm");

var $cUHte = parcelRequire("cUHte");

var $7PTrm = parcelRequire("7PTrm");
const $762f6dda7406d156$export$bd8b8cab48ee0127 = (baseUrl, issueKey, maxTokenLength, headersProcessor)=>(0, $aiRd8.default)((0, $d6jSm.getMediaReadPermissionUrl)(issueKey, maxTokenLength), {
        perf: (0, $cUHte.fetchViewContextPerf),
        headersProcessor: headersProcessor && headersProcessor((0, $cUHte.fetchViewContextPerf).key)
    }).catch((error)=>{
        throw new (0, $7PTrm.IssueViewFetchError)(error, (0, $d6jSm.getMediaReadPermissionUrl)('{issueKey}', '{maxTokenLength}'));
    });
const $762f6dda7406d156$export$766b91f9f60d1317 = (baseUrl, issueKey, maxTokenLength, headersProcessor)=>(0, $2OdyW.default)((0, $d6jSm.getMediaReadPermissionUrl)(issueKey, maxTokenLength), {
        // @ts-expect-error - TS2345 - Argument of type '{ perf: { readonly key: "FETCH_VIEW_CONTEXT"; readonly prefix: "ISSUE_DETAILS"; }; headersProcessor: ((headers: Headers) => void) | undefined; }' is not assignable to parameter of type 'RequestInit'.
        perf: (0, $cUHte.fetchViewContextPerf),
        headersProcessor: headersProcessor && headersProcessor((0, $cUHte.fetchViewContextPerf).key)
    });

});
parcelRegister("d6jSm", function(module, exports) {

$parcel$export(module.exports, "getMediaReadPermissionUrl", () => $1cbd49096c48dd01$export$e4e22bde4889113e);
const $1cbd49096c48dd01$export$e4e22bde4889113e = (issueKey, maxTokenLength)=>`/rest/api/2/attachment/read/issue/${issueKey}/credentials?maxTokenLength=${maxTokenLength}`;

});


parcelRegister("hEEI6", function(module, exports) {

$parcel$export(module.exports, "getTokenDeltaProps", () => $dfbf60249e3650d6$export$4d271852dd07ca26);
$parcel$export(module.exports, "isTokenValid", () => $dfbf60249e3650d6$export$d1a8c8b605234fe8);
$parcel$export(module.exports, "viewContextTransformer", () => $dfbf60249e3650d6$export$5fb65caa7eb9e932);
// This has TS defs, so when we move to TS let's enable them again
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'jwt-decode'. '/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/jwt-decode/lib/index.js' implicitly has an 'any' type.

var $8IlFs = parcelRequire("8IlFs");
const $dfbf60249e3650d6$var$TOKEN_NETWORK_BUFFER = 10000;
const $dfbf60249e3650d6$export$e9df841c4c486a60 = (startTimestamp)=>startTimestamp ? startTimestamp - Date.now() + 0 : undefined;
const $dfbf60249e3650d6$export$4d271852dd07ca26 = (token)=>{
    let decodedToken;
    try {
        decodedToken = (0, (/*@__PURE__*/$parcel$interopDefault($8IlFs)))(token);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // why would this be the case
        return {
            tokenDecodeError: typeof error.message === 'string' ? error.message : undefined,
            localTimeDelta: undefined,
            tokenExpiryTime: undefined
        };
    }
    // In my testing, sometimes issued at was missing
    const startTimestamp = decodedToken.iat || decodedToken.nbf;
    return {
        tokenDecodeError: undefined,
        localTimeDelta: $dfbf60249e3650d6$export$e9df841c4c486a60(startTimestamp * 1000),
        tokenExpiryTime: decodedToken.exp * 1000
    };
};
function $dfbf60249e3650d6$export$d1a8c8b605234fe8({ token: token, tokenExpiryTime: tokenExpiryTime, localTimeDelta: localTimeDelta }) {
    if (typeof token !== 'string' || token.length === 0) return false;
    if (typeof tokenExpiryTime !== 'number' || typeof localTimeDelta !== 'number') return false;
    const actualExpiryTime = tokenExpiryTime + localTimeDelta - $dfbf60249e3650d6$var$TOKEN_NETWORK_BUFFER;
    const timeUntilExpiry = actualExpiryTime - Date.now();
    const isValid = timeUntilExpiry >= 0;
    return isValid;
}
const $dfbf60249e3650d6$export$5fb65caa7eb9e932 = (viewResponse)=>{
    const token = viewResponse.tokensWithFiles[0]?.token || null;
    const tokenProps = typeof token === 'string' ? $dfbf60249e3650d6$export$4d271852dd07ca26(token) : {};
    return {
        clientId: viewResponse.clientId,
        serviceHost: viewResponse.endpointUrl,
        token: token,
        areTokenPermissionsUpToDate: true,
        tokenLifespanInMs: viewResponse.tokenLifespanInSeconds * 1000,
        collection: viewResponse.collection !== undefined && viewResponse.collection !== '' ? viewResponse.collection : null,
        tokenIssueTimestamp: Date.now() - $dfbf60249e3650d6$var$TOKEN_NETWORK_BUFFER,
        tokenDecodeError: tokenProps.tokenDecodeError,
        localTimeDelta: tokenProps.localTimeDelta,
        tokenExpiryTime: tokenProps.tokenExpiryTime
    };
};

});
parcelRegister("8IlFs", function(module, exports) {
'use strict';

var $77JYr = parcelRequire("77JYr");
function $65833d8892c613cc$var$InvalidTokenError(message) {
    this.message = message;
}
$65833d8892c613cc$var$InvalidTokenError.prototype = new Error();
$65833d8892c613cc$var$InvalidTokenError.prototype.name = 'InvalidTokenError';
module.exports = function(token, options) {
    if (typeof token !== 'string') throw new $65833d8892c613cc$var$InvalidTokenError('Invalid token specified');
    options = options || {};
    var pos = options.header === true ? 0 : 1;
    try {
        return JSON.parse($77JYr(token.split('.')[pos]));
    } catch (e) {
        throw new $65833d8892c613cc$var$InvalidTokenError('Invalid token specified: ' + e.message);
    }
};
module.exports.InvalidTokenError = $65833d8892c613cc$var$InvalidTokenError;

});
parcelRegister("77JYr", function(module, exports) {

var $aN7NA = parcelRequire("aN7NA");
function $52fcd9515ac6a039$var$b64DecodeUnicode(str) {
    return decodeURIComponent($aN7NA(str).replace(/(.)/g, function(m, p) {
        var code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = '0' + code;
        return '%' + code;
    }));
}
module.exports = function(str) {
    var output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return $52fcd9515ac6a039$var$b64DecodeUnicode(output);
    } catch (err) {
        return $aN7NA(output);
    }
};

});
parcelRegister("aN7NA", function(module, exports) {
/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */ var $7db487a49562b8dc$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
function $7db487a49562b8dc$var$InvalidCharacterError(message) {
    this.message = message;
}
$7db487a49562b8dc$var$InvalidCharacterError.prototype = new Error();
$7db487a49562b8dc$var$InvalidCharacterError.prototype.name = 'InvalidCharacterError';
function $7db487a49562b8dc$var$polyfill(input) {
    var str = String(input).replace(/=+$/, '');
    if (str.length % 4 == 1) throw new $7db487a49562b8dc$var$InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
    for(// initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = ''; // get next character
    buffer = str.charAt(idx++); // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, // and if not first of each 4 characters,
    // convert the first 8 bits to one ascii character
    bc++ % 4) && (output += String.fromCharCode(255 & bs >> (-2 * bc & 6))))// try to find character in table (0-63, not found => -1)
    buffer = $7db487a49562b8dc$var$chars.indexOf(buffer);
    return output;
}
module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || $7db487a49562b8dc$var$polyfill;

});






parcelRegister("3ayx8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b15b91638b687f5$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $aZaPn = parcelRequire("aZaPn");

var $3A3OQ = parcelRequire("3A3OQ");

var $5JqpU = parcelRequire("5JqpU");

var $gZSrt = parcelRequire("gZSrt");

var $eW7lD = parcelRequire("eW7lD");
let $9b15b91638b687f5$var$localStorage;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9b15b91638b687f5$var$deleteDraftAndHashUsingFieldId = (state, fieldId)=>{
    const issueKey = (0, $5JqpU.issueKeySelector)(state);
    const loggedInAccountId = (0, $5JqpU.accountIdloggedInUserSelector)(state);
    const draftKey = (0, $eW7lD.getDraftKey)(loggedInAccountId, issueKey, fieldId);
    const hashKey = (0, $eW7lD.createHashKey)(draftKey);
    $9b15b91638b687f5$var$localStorage.remove(draftKey);
    $9b15b91638b687f5$var$localStorage.remove(hashKey);
    return (0, $3JafE.Observable).of((0, $gZSrt.deleteDraftSuccess)(fieldId));
};
const $9b15b91638b687f5$var$deleteDraftAndHashUsingDraftKey = (draftKey)=>{
    const hashKey = (0, $eW7lD.createHashKey)(draftKey);
    $9b15b91638b687f5$var$localStorage.remove(draftKey);
    $9b15b91638b687f5$var$localStorage.remove(hashKey);
    return (0, $3JafE.Observable).of((0, $gZSrt.deleteDraftSuccess)(draftKey));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9b15b91638b687f5$var$deleteDraft = (action, state)=>{
    const { payload: { fieldId: fieldId, draftKey: draftKey } } = action;
    if (fieldId) return $9b15b91638b687f5$var$deleteDraftAndHashUsingFieldId(state, fieldId);
    const fieldName = (0, $eW7lD.getFieldNameFromKey)(draftKey);
    if (draftKey) return $9b15b91638b687f5$var$deleteDraftAndHashUsingDraftKey(fieldName).catch((error)=>{
        (0, $3A3OQ.trackOrLogClientError)('issue.draft.delete', 'Failed to delete a draft.', error);
        return (0, $3JafE.Observable).of((0, $gZSrt.deleteDraftError)(fieldName, error));
    });
    return (0, $3JafE.Observable).empty();
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9b15b91638b687f5$var$errorHandler = (error)=>(0, $3JafE.Observable).of((0, $gZSrt.deleteDraftError)(null, error));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9b15b91638b687f5$export$2e2bcd8739ae039 = (action$, store)=>{
    $9b15b91638b687f5$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('issue-drafts');
    return action$.ofType((0, $gZSrt.DELETE_DRAFT_REQUEST)).mergeMap((action)=>$9b15b91638b687f5$var$deleteDraft(action, store.getState())).catch((error)=>$9b15b91638b687f5$var$errorHandler(error));
};

});
parcelRegister("eW7lD", function(module, exports) {

$parcel$export(module.exports, "getDraftKey", () => $9a9d27dad5b435c6$export$53536c2ff0d5fb3b);
$parcel$export(module.exports, "getFieldNameFromKey", () => $9a9d27dad5b435c6$export$c357c0c800ae448e);
$parcel$export(module.exports, "createHashKey", () => $9a9d27dad5b435c6$export$a2b7936fd03903ac);
$parcel$export(module.exports, "createCommentDraftKey", () => $9a9d27dad5b435c6$export$41174b2245477cc4);

var $f9RL0 = parcelRequire("f9RL0");
const $9a9d27dad5b435c6$export$53536c2ff0d5fb3b = (loggedInAccountId, issueKey, id)=>`${String(loggedInAccountId)}.${issueKey}.${id}`;
const $9a9d27dad5b435c6$export$c357c0c800ae448e = (key)=>key.split('.')[2];
const $9a9d27dad5b435c6$export$a2b7936fd03903ac = (draftKey)=>`${draftKey}-previous-hash`;
const $9a9d27dad5b435c6$export$41174b2245477cc4 = (commentId)=>`${0, $f9RL0.COMMENT}_${commentId}`;

});


parcelRegister("fc4cY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2afe9d64f5eb2711$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("dM0Xt");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $aZaPn = parcelRequire("aZaPn");

var $3A3OQ = parcelRequire("3A3OQ");

var $7Vbpp = parcelRequire("7Vbpp");

var $gZSrt = parcelRequire("gZSrt");

var $eW7lD = parcelRequire("eW7lD");
let $2afe9d64f5eb2711$var$localStorage;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2afe9d64f5eb2711$var$loadDraft = (action)=>{
    const { payload: { fieldId: fieldId, draftKey: draftKey, draftHandler: draftHandler } } = action;
    const fieldName = (0, $eW7lD.getFieldNameFromKey)(draftKey);
    const fieldDraft = $2afe9d64f5eb2711$var$localStorage.get(draftKey);
    if (fieldDraft) {
        if ((0, $7Vbpp.isOnlyWhitespaceAdf)(fieldDraft)) return (0, $3JafE.Observable).empty();
        const loadDraftObservable = draftHandler ? (0, $3JafE.Observable).of(draftHandler(fieldId, fieldDraft)) : (0, $3JafE.Observable).empty();
        const loadedSuccessObservable = (0, $3JafE.Observable).of((0, $gZSrt.loadDraftSuccess)(fieldName, fieldDraft));
        const loadDraftAndSuccess$ = (0, $3JafE.Observable).concat(loadDraftObservable, loadedSuccessObservable);
        return loadDraftAndSuccess$.catch((error)=>{
            (0, $3A3OQ.trackOrLogClientError)('issue.draft.fetch', 'Failed to fetch issue draft', error);
            return (0, $3JafE.Observable).of((0, $gZSrt.loadDraftFailure)(fieldName, error));
        });
    }
    return (0, $3JafE.Observable).empty();
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2afe9d64f5eb2711$var$errorHandler = (error)=>(0, $3JafE.Observable).of((0, $gZSrt.loadDraftFailure)(null, error));
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$2afe9d64f5eb2711$export$2e2bcd8739ae039 = (action$)=>{
    $2afe9d64f5eb2711$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('issue-drafts');
    return action$.ofType((0, $gZSrt.LOAD_DRAFT_REQUEST)).mergeMap((action)=>$2afe9d64f5eb2711$var$loadDraft(action)).catch((error)=>$2afe9d64f5eb2711$var$errorHandler(error));
};

});

parcelRegister("20awf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c08916a57602ead7$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("b48pz");
parcelRequire("3wBUP");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $jAy5L = parcelRequire("jAy5L");

var $aZaPn = parcelRequire("aZaPn");

var $3A3OQ = parcelRequire("3A3OQ");

var $5JqpU = parcelRequire("5JqpU");

var $gZSrt = parcelRequire("gZSrt");

var $eW7lD = parcelRequire("eW7lD");
const $c08916a57602ead7$var$saveDraftDelay = 1000;
let $c08916a57602ead7$var$localStorage;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c08916a57602ead7$var$saveDraft = (action, state)=>{
    const { payload: { fieldId: fieldId, value: value } } = action;
    const issueKey = (0, $5JqpU.issueKeySelector)(state);
    const loggedInAccountId = (0, $5JqpU.accountIdloggedInUserSelector)(state);
    const draftKey = (0, $eW7lD.getDraftKey)(loggedInAccountId, issueKey, fieldId);
    $c08916a57602ead7$var$localStorage.set(draftKey, value);
    return (0, $3JafE.Observable).of((0, $gZSrt.saveDraftSuccess)(draftKey, value));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c08916a57602ead7$var$errorHandler = (error)=>{
    (0, $3A3OQ.trackOrLogClientError)('issue.save-draft', 'Failed to save draft', error);
    return (0, $3JafE.Observable).of((0, $gZSrt.saveDraftError)(error));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c08916a57602ead7$export$2e2bcd8739ae039 = (action$, store)=>{
    $c08916a57602ead7$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('issue-drafts');
    return action$.ofType((0, $gZSrt.SAVE_DRAFT_REQUEST), (0, $gZSrt.DELETE_DRAFT_SUCCESS)).throttleTime($c08916a57602ead7$var$saveDraftDelay, (0, $jAy5L.async), {
        leading: true,
        trailing: true
    }).switchMap((action)=>{
        if (action.type === (0, $gZSrt.SAVE_DRAFT_REQUEST)) return $c08916a57602ead7$var$saveDraft(action, store.getState());
        return (0, $3JafE.Observable).empty();
    }).catch((error)=>$c08916a57602ead7$var$errorHandler(error));
};

});

parcelRegister("hwD0f", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b4de6383b85ffe9$export$2e2bcd8739ae039);

var $dXapj = parcelRequire("dXapj");

var $7o5pq = parcelRequire("7o5pq");

var $aynDk = parcelRequire("aynDk");

var $dBQte = parcelRequire("dBQte");

var $jUhyG = parcelRequire("jUhyG");

var $gUUjF = parcelRequire("gUUjF");

var $gA9Fk = parcelRequire("gA9Fk");

var $79Zzr = parcelRequire("79Zzr");

var $lESkT = parcelRequire("lESkT");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8b4de6383b85ffe9$var$getAnalyticsForAction = (state, action)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'ObjMap<ActionsByKey, AnalyticsGetterType>'.
    (0, $79Zzr.default)[action.type] && {
        analyticsEvent: action.payload && action.payload.analyticsEvent,
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'ObjMap<ActionsByKey, AnalyticsGetterType>'.
        ...(0, $79Zzr.default)[action.type](state, action)
    };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8b4de6383b85ffe9$var$getFlattenedEventData = (eventData)=>{
    if (eventData && eventData.attributes) {
        const { attributes: attributes, ...rest } = eventData;
        return {
            ...attributes,
            ...rest
        };
    }
    return eventData;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8b4de6383b85ffe9$var$getAmplitudeShapeEventData = (eventData, analyticsEvent)=>{
    const action = analyticsEvent.payload && analyticsEvent.payload.action || 'updated';
    const { actionSubjectId: actionSubjectId, name: name, tags: tags, containerType: containerType, containerId: containerId, objectType: objectType, objectId: objectId, ...attributes } = eventData;
    return {
        action: action,
        actionSubjectId: actionSubjectId,
        name: name,
        tags: tags,
        containerType: containerType,
        containerId: containerId,
        objectType: objectType,
        objectId: objectId,
        attributes: attributes
    };
};
const $8b4de6383b85ffe9$var$triggerAnalyticsForAction = ({ eventNameSuffix: eventNameSuffix, eventData: eventData, analyticsEvent: analyticsEvent })=>{
    if (analyticsEvent) try {
        const formattedEventData = $8b4de6383b85ffe9$var$getAmplitudeShapeEventData(eventData, analyticsEvent);
        (0, $jUhyG.fireTrackAnalytics)(analyticsEvent, formattedEventData);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.instrumentation.trigger-analytics-action', 'Failed to send action track event', error);
    }
    const flattenedEventData = $8b4de6383b85ffe9$var$getFlattenedEventData(eventData);
    (0, $lESkT.default)(eventNameSuffix, flattenedEventData);
};
const $8b4de6383b85ffe9$var$expectedActions = Object.keys((0, $79Zzr.default));
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$8b4de6383b85ffe9$export$2e2bcd8739ae039 = (action$, store)=>action$.pipe((0, $gA9Fk.ofTypeOrBatchType)(...$8b4de6383b85ffe9$var$expectedActions), (0, $aynDk.map)((action)=>$8b4de6383b85ffe9$var$getAnalyticsForAction(store.getState(), action)), (0, $dXapj.filter)((event)=>!!event), (0, $dBQte.tap)($8b4de6383b85ffe9$var$triggerAnalyticsForAction), (0, $7o5pq.ignoreElements)());

});
parcelRegister("79Zzr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dde942f4e1fa428$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $h7bH5 = parcelRequire("h7bH5");


var $gha52 = parcelRequire("gha52");

var $f9RL0 = parcelRequire("f9RL0");

var $lkPj1 = parcelRequire("lkPj1");

var $49xWy = parcelRequire("49xWy");

var $6CO09 = parcelRequire("6CO09");

var $1OJS4 = parcelRequire("1OJS4");

var $g2ZFU = parcelRequire("g2ZFU");

var $02hYD = parcelRequire("02hYD");

var $fYteL = parcelRequire("fYteL");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $gZSrt = parcelRequire("gZSrt");

var $6KjC3 = parcelRequire("6KjC3");

var $fVCj0 = parcelRequire("fVCj0");

var $1b2Vj = parcelRequire("1b2Vj");

var $jqIs9 = parcelRequire("jqIs9");


var $dmojD = parcelRequire("dmojD");

var $cFY86 = parcelRequire("cFY86");
const $1dde942f4e1fa428$export$cbd37c7b3c07087d = [
    (0, $f9RL0.COMMENT),
    (0, $f9RL0.DESCRIPTION)
];
// We've renamed these error strings in code to better reflect their meaning,
// however in order not to disrupt metrics we map the new strings to the older
// equivalents before sending analytics
const $1dde942f4e1fa428$var$mapToLegacyErrorStrings = (error)=>{
    switch(error){
        case 0, $12cc22d0c60f7bfc$export$99405616af30f11f:
            return 'AUTHENTICATION';
        case 0, $12cc22d0c60f7bfc$export$4e094d34a5cb1872:
            return 'PERMISSION';
        case 0, $12cc22d0c60f7bfc$export$f10b32dfda12e96e:
        case 0, $12cc22d0c60f7bfc$export$683dbe11f74cd161:
        default:
            return 'GENERIC';
    }
};
const $1dde942f4e1fa428$var$issueProjectData = (eventNameSuffix)=>(state)=>({
            eventData: (0, $jqIs9.analyticsPayloadSelector)(state),
            eventNameSuffix: eventNameSuffix
        });
const $1dde942f4e1fa428$var$stripCommentIdIfComment = (fieldId)=>fieldId.startsWith((0, $f9RL0.COMMENT)) ? (0, $f9RL0.COMMENT) : fieldId;
const $1dde942f4e1fa428$var$deleteDraftAnalytics = (eventNameSuffix)=>(state, action)=>{
        const { payload: { fieldId: fieldId } } = action;
        const processedFieldId = fieldId !== null && $1dde942f4e1fa428$var$stripCommentIdIfComment(fieldId);
        return {
            eventNameSuffix: eventNameSuffix,
            eventData: {
                type: processedFieldId
            }
        };
    };
const $1dde942f4e1fa428$var$loadDraftAnalytics = (eventNameSuffix)=>(state, action)=>{
        const { payload: { fieldId: fieldId } } = action;
        const processedFieldId = fieldId != null ? $1dde942f4e1fa428$var$stripCommentIdIfComment(fieldId) : fieldId;
        return {
            eventNameSuffix: eventNameSuffix,
            eventData: {
                type: processedFieldId
            }
        };
    };
const $1dde942f4e1fa428$var$getAnalyticsProps = (updatedValues)=>{
    const props = [
        'updatedField',
        'oldValId',
        'newValId',
        'oldValName',
        'newValName'
    ];
    return props.filter((key)=>updatedValues && Object.hasOwnProperty.call(updatedValues, key)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, next)=>{
        const currentAnalyticsProp = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SaveCommentPayload | DeleteCommentPayload | FieldAnalyticsPayload'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SaveCommentPayload | DeleteCommentPayload | FieldAnalyticsPayload'.
        updatedValues && updatedValues[next] ? {
            [next]: updatedValues[next]
        } : {};
        return {
            ...acc,
            ...currentAnalyticsProp
        }; // eslint-disable-line jira/js/no-reduce-accumulator-spread
    }, {});
};
const $1dde942f4e1fa428$var$fetchIssueSuccessEventData = (state)=>({
        eventData: {
            commentCount: (0, $dmojD.totalCommentsSelector)(state)
        }
    });
const $1dde942f4e1fa428$var$addIssueLinkTypeData = (state, action)=>{
    const { payload: { newIssueLinks: { issueLinkType: issueLinkType, issueLinks: issueLinks, isOpenedFromJsmSimilarIssues: isOpenedFromJsmSimilarIssues } } } = action;
    const issueIds = issueLinks !== null && issueLinks !== undefined && issueLinks.linkedIssues !== null && issueLinks.linkedIssues !== undefined && Object.keys(issueLinks.linkedIssues).length > 0 ? Object.keys(issueLinks.linkedIssues).map((key)=>issueLinks.linkedIssues[key].issueId) : [
        ''
    ];
    const issueId = issueIds[0];
    return {
        eventData: {
            issueLinkTypeId: issueLinkType.id,
            issueLinkTypeName: (0, $h7bH5.safeLinkTypeName)(issueLinkType.label),
            issueLinkLinkedIssueId: issueId,
            isOpenedFromJsmSimilarIssues: isOpenedFromJsmSimilarIssues
        }
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1dde942f4e1fa428$var$deleteIssueLinkTypeData = (linkedIssue)=>({
        eventData: {
            issueLinkTypeId: linkedIssue.typeId,
            issueLinkTypeName: (0, $h7bH5.safeLinkTypeName)(linkedIssue.typeName)
        }
    });
const $1dde942f4e1fa428$var$getAdfBody = (bodyAdf)=>bodyAdf ? JSON.stringify(bodyAdf).length : 0;
const $1dde942f4e1fa428$var$getAnalyticsDataForSavedComment = (comment)=>{
    const charactersInCommentCount = $1dde942f4e1fa428$var$getAdfBody(comment.bodyAdf);
    return {
        isInternal: comment.isInternal,
        charactersInCommentCount: charactersInCommentCount
    };
};
const $1dde942f4e1fa428$var$actionsMap = {
    [(0, $49xWy.SAVE_LINKED_ISSUE_REQUEST)]: (state, action)=>(0, $6HC1D.merge)($1dde942f4e1fa428$var$issueProjectData('issue-links.save.request'), $1dde942f4e1fa428$var$addIssueLinkTypeData(state, action)),
    [(0, $02hYD.SAVE_REMOTE_LINKED_ISSUE_REQUEST)]: $1dde942f4e1fa428$var$issueProjectData('issue-links.save.request'),
    [(0, $49xWy.DELETE_LINKED_ISSUE_REQUEST)]: (state, action)=>(0, $6HC1D.merge)($1dde942f4e1fa428$var$issueProjectData('issue-links.delete.request'), $1dde942f4e1fa428$var$deleteIssueLinkTypeData((0, $cFY86.issueLinkSelector)(action.payload.linkedIssueId)(state))),
    [(0, $49xWy.SAVE_LINKED_ISSUE_SUCCESS)]: $1dde942f4e1fa428$var$issueProjectData('issue-links.save.success'),
    [(0, $49xWy.SAVE_LINKED_ISSUE_FAILURE)]: $1dde942f4e1fa428$var$issueProjectData('issue-links.save.failure'),
    [(0, $02hYD.SAVE_REMOTE_LINKED_ISSUE_SUCCESS)]: $1dde942f4e1fa428$var$issueProjectData('issue-links.save.success'),
    [(0, $02hYD.SAVE_REMOTE_LINKED_ISSUE_FAILURE)]: $1dde942f4e1fa428$var$issueProjectData('issue-links.save.failure'),
    [(0, $49xWy.SAVE_LINKED_ISSUE_RETRY)]: $1dde942f4e1fa428$var$issueProjectData('issue-links.save.retry'),
    [(0, $02hYD.SAVE_REMOTE_LINKED_ISSUE_RETRY)]: $1dde942f4e1fa428$var$issueProjectData('issue-links.save.retry'),
    [(0, $49xWy.SAVE_LINKED_ISSUE_CANCEL)]: $1dde942f4e1fa428$var$issueProjectData('issue-links.save.cancel'),
    [(0, $lkPj1.SHOW_DELETE_COMMENT_MODAL)]: $1dde942f4e1fa428$var$issueProjectData('comment.delete.linkclicked'),
    [(0, $lkPj1.FETCH_OLDER_COMMENTS_REQUEST)]: $1dde942f4e1fa428$var$issueProjectData('comment.fetcholder.click'),
    [(0, $lkPj1.FETCH_NEWER_COMMENTS_REQUEST)]: $1dde942f4e1fa428$var$issueProjectData('comment.fetchnewer.click'),
    [(0, $lkPj1.EDIT_COMMENT_BEGIN)]: (state)=>$1dde942f4e1fa428$var$issueProjectData('comment.edit.linkclicked')(state),
    [(0, $lkPj1.SAVE_COMMENT_SUCCESS)]: (state, action)=>(0, $6HC1D.merge)($1dde942f4e1fa428$var$issueProjectData('comment.save.success')(state), {
            eventData: {
                ...$1dde942f4e1fa428$var$getAnalyticsProps(action.payload),
                actionSubjectId: action.payload.comment.id,
                actionSubjectOptimisticId: action.payload.optimisticId,
                ...$1dde942f4e1fa428$var$getAnalyticsDataForSavedComment(action.payload.comment)
            }
        }),
    [(0, $lkPj1.DELETE_COMMENT_REQUEST)]: (state, action)=>(0, $6HC1D.merge)($1dde942f4e1fa428$var$issueProjectData('comment.delete.modal.confirm')(state), {
            eventData: {
                ...$1dde942f4e1fa428$var$getAnalyticsProps(action.payload),
                actionSubjectId: action.payload.id
            }
        }),
    [(0, $lkPj1.PASTED_INTO_COMMENT_FORM)]: (state, action)=>(0, $6HC1D.merge)($1dde942f4e1fa428$var$issueProjectData('comment.paste')(state), {
            eventData: {
                isNewComment: action.payload.id === (0, $b10b5cb385fb5d46$export$c4134c813c47beb0),
                pastedContentLength: (action.payload.pastedContent || '').length,
                containsEmailAddress: (0, $gha52.default)(action.payload.pastedContent)
            }
        }),
    [(0, $fYteL.FETCH_ISSUE_SUCCESS)]: (state)=>(0, $6HC1D.merge)($1dde942f4e1fa428$var$issueProjectData('fetchissue.succeeded')(state), $1dde942f4e1fa428$var$fetchIssueSuccessEventData(state)),
    [(0, $fYteL.REFRESH_ISSUE_SUCCESS)]: (state)=>(0, $6HC1D.merge)($1dde942f4e1fa428$var$issueProjectData('refreshissue.succeeded')(state), $1dde942f4e1fa428$var$fetchIssueSuccessEventData(state)),
    [(0, $fYteL.REFRESH_ISSUE_REQUEST)]: $1dde942f4e1fa428$var$issueProjectData('refreshissue.request'),
    [(0, $fYteL.FETCH_ISSUE_REQUEST)]: $1dde942f4e1fa428$var$issueProjectData('fetchissue.request'),
    [(0, $1OJS4.LOAD_NEW_ISSUE)]: $1dde942f4e1fa428$var$issueProjectData('load-new-issue'),
    [(0, $fYteL.FETCH_ISSUE_FAILURE)]: (state, action)=>({
            eventNameSuffix: 'fetchissue.failed',
            eventData: {
                error: $1dde942f4e1fa428$var$mapToLegacyErrorStrings((0, $jZDJX.errorSelector)(state)),
                statusCode: action.payload.statusCode,
                analyticsSource: (0, $5JqpU.analyticsSourceSelector)(state)
            }
        }),
    [(0, $gZSrt.DELETE_DRAFT_REQUEST)]: $1dde942f4e1fa428$var$deleteDraftAnalytics('issue.delete-draft.request'),
    [(0, $gZSrt.DELETE_DRAFT_SUCCESS)]: $1dde942f4e1fa428$var$deleteDraftAnalytics('issue.delete-draft.success'),
    [(0, $gZSrt.DELETE_DRAFT_FAILURE)]: $1dde942f4e1fa428$var$deleteDraftAnalytics('issue.delete-draft.failure'),
    [(0, $gZSrt.DELETE_DRAFT_NEWER_CONTENT_FOUND)]: $1dde942f4e1fa428$var$deleteDraftAnalytics('issue.delete-draft.replaced-by-new-content'),
    // LOAD_DRAFT_REQUEST not logged as this is triggered every time BENTO opens
    [(0, $gZSrt.LOAD_DRAFT_SUCCESS)]: $1dde942f4e1fa428$var$loadDraftAnalytics('issue.load-draft.success'),
    [(0, $gZSrt.LOAD_DRAFT_FAILURE)]: $1dde942f4e1fa428$var$loadDraftAnalytics('issue.load-draft.failure'),
    [(0, $g2ZFU.LOGIN_SUCCESSFUL)]: (state)=>({
            eventNameSuffix: 'login.succeeded',
            eventData: {
                analyticsSource: (0, $5JqpU.analyticsSourceSelector)(state)
            }
        }),
    // New re-usable fields analytics events
    [(0, $6KjC3.FIELD_EDIT_BEGIN)]: (state, action)=>(0, $6HC1D.merge)($1dde942f4e1fa428$var$issueProjectData('field.edit')(state), {
            eventData: {
                fieldType: (0, $fokFV.fieldTypeSelector)(action.payload.fieldId)(state),
                // uuid should be safe
                fieldEditSessionId: action.payload.fieldEditSessionId,
                isReusableField: true
            }
        }),
    [(0, $fVCj0.FIELD_SAVE_REQUEST)]: (state, action)=>(0, $6HC1D.merge)($1dde942f4e1fa428$var$issueProjectData('field.save')(state), {
            eventData: {
                ...$1dde942f4e1fa428$var$getAnalyticsProps(action.payload.eventData || null),
                fieldType: (0, $fokFV.fieldTypeSelector)(action.payload.fieldId)(state),
                fieldEditSessionId: (0, $fokFV.fieldEditSessionIdSelector)(action.payload.fieldId)(state),
                isReusableField: true,
                issueHierarchyLevel: (0, $1b2Vj.hierarchyLevelSelector)(state)
            }
        }),
    [(0, $6KjC3.FIELD_EDIT_CANCEL)]: (state, action)=>(0, $6HC1D.merge)($1dde942f4e1fa428$var$issueProjectData('field.cancel')(state), {
            eventData: {
                fieldType: (0, $fokFV.fieldTypeSelector)(action.payload.fieldId)(state),
                fieldEditSessionId: (0, $fokFV.fieldEditSessionIdSelector)(action.payload.fieldId)(state),
                isReusableField: true
            }
        }),
    [(0, $6KjC3.FIELD_PASTE)]: (state, action)=>(0, $6HC1D.merge)($1dde942f4e1fa428$var$issueProjectData('field.paste')(state), {
            eventData: {
                fieldType: (0, $fokFV.fieldTypeSelector)(action.payload.fieldId)(state),
                isReusableField: true,
                pastedContentLength: action.payload.pastedContent.length,
                containsEmailAddress: (0, $gha52.default)(action.payload.pastedContent)
            }
        }),
    [(0, $6CO09.LINKED_ISSUE_PROJECT_ANALYTICS_SUCCESS)]: $1dde942f4e1fa428$var$issueProjectData('issue-links.analytics')
};
var $1dde942f4e1fa428$export$2e2bcd8739ae039 = $1dde942f4e1fa428$var$actionsMap;

});
parcelRegister("h7bH5", function(module, exports) {

$parcel$export(module.exports, "safeLinkTypeName", () => $e459022803c3d3ed$export$3562d6fc9209c3a9);
const $e459022803c3d3ed$var$LINK_IS_BLOCKED_BY = 'is blocked by';
const $e459022803c3d3ed$var$LINK_IS_DUPLICATED_BY = 'is duplicated by';
const $e459022803c3d3ed$var$LINK_BLOCKS = 'BLOCKS';
const $e459022803c3d3ed$var$LINK_IS_CLONED_BY = 'is cloned by';
const $e459022803c3d3ed$var$LINK_CLONES = 'clones';
const $e459022803c3d3ed$var$LINK_IS_CAUSED_BY = 'is caused by';
const $e459022803c3d3ed$var$LINK_CAUSES = 'causes';
const $e459022803c3d3ed$var$LINK_RELATES_TO = 'relates to';
const $e459022803c3d3ed$var$LINK_DUPLICATES = 'duplicates';
// use LINK_CUSTOM for all custom type name
const $e459022803c3d3ed$var$LINK_CUSTOM = 'custom';
const $e459022803c3d3ed$var$LINK_ISSUE_TYPE = [
    $e459022803c3d3ed$var$LINK_IS_BLOCKED_BY,
    $e459022803c3d3ed$var$LINK_IS_DUPLICATED_BY,
    $e459022803c3d3ed$var$LINK_BLOCKS,
    $e459022803c3d3ed$var$LINK_IS_CLONED_BY,
    $e459022803c3d3ed$var$LINK_CLONES,
    $e459022803c3d3ed$var$LINK_IS_CAUSED_BY,
    $e459022803c3d3ed$var$LINK_CAUSES,
    $e459022803c3d3ed$var$LINK_RELATES_TO,
    $e459022803c3d3ed$var$LINK_DUPLICATES
];
const $e459022803c3d3ed$export$3562d6fc9209c3a9 = (value)=>// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'LinkIssueType'.
    $e459022803c3d3ed$var$LINK_ISSUE_TYPE.includes(value) ? value : $e459022803c3d3ed$var$LINK_CUSTOM;

});

parcelRegister("gha52", function(module, exports) {

$parcel$export(module.exports, "default", () => $727e92987309ca16$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $727e92987309ca16$export$2e2bcd8739ae039 = (value)=>/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i.test(value);

});

parcelRegister("6CO09", function(module, exports) {

$parcel$export(module.exports, "LINKED_ISSUE_PROJECT_ANALYTICS_SUCCESS", () => $fc5dd9a97438368d$export$f8954309510d23cb);
$parcel$export(module.exports, "linkedIssueProjectAnalyticsSuccess", () => $fc5dd9a97438368d$export$5674c1dfbb0ef47a);
$parcel$export(module.exports, "linkedIssueProjectAnalyticsFailure", () => $fc5dd9a97438368d$export$abc879d5818b3dbd);
const $fc5dd9a97438368d$export$f8954309510d23cb = 'LINKED_ISSUE_PROJECT_ANALYTICS_SUCCESS';
const $fc5dd9a97438368d$export$5674c1dfbb0ef47a = (analyticsEvent)=>({
        type: $fc5dd9a97438368d$export$f8954309510d23cb,
        payload: {
            analyticsEvent: analyticsEvent
        }
    });
const $fc5dd9a97438368d$export$87dd8f5131676909 = 'LINKED_ISSUE_FAILURE';
const $fc5dd9a97438368d$export$abc879d5818b3dbd = (error)=>({
        type: $fc5dd9a97438368d$export$87dd8f5131676909,
        payload: {
            error: error
        }
    });

});

parcelRegister("jqIs9", function(module, exports) {

$parcel$export(module.exports, "analyticsPayloadSelector", () => $2e83588d5847fe2c$export$1b5a9006dc987e11);

var $df4Sl = parcelRequire("df4Sl");

var $jh2R9 = parcelRequire("jh2R9");

var $89bO2 = parcelRequire("89bO2");

var $7ZZxN = parcelRequire("7ZZxN");

var $8Qd0L = parcelRequire("8Qd0L");

var $cGCxH = parcelRequire("cGCxH");
var $3qF4w = parcelRequire("3qF4w");

var $1ybV0 = parcelRequire("1ybV0");

var $fkvsU = parcelRequire("fkvsU");

var $f9RL0 = parcelRequire("f9RL0");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $8CSFK = parcelRequire("8CSFK");

var $9D3Vo = parcelRequire("9D3Vo");

var $dmojD = parcelRequire("dmojD");

var $0492z = parcelRequire("0492z");

var $bYZxt = parcelRequire("bYZxt");

var $hIdxh = parcelRequire("hIdxh");
const $2e83588d5847fe2c$var$assigneeIdSelector = (0, $df4Sl.createSelector)((0, $fokFV.fieldSelector)((0, $f9RL0.ASSIGNEE)), (assignee)=>assignee && assignee.value ? assignee.value.accountId : null);
const $2e83588d5847fe2c$export$1b5a9006dc987e11 = (0, $df4Sl.createSelector)((0, $5JqpU.analyticsSourceSelector), (0, $jZDJX.idSelector), (0, $jZDJX.projectIdSelector), (0, $jZDJX.projectTypeSelector), (0, $jZDJX.isSimplifiedProjectSelector), (0, $9D3Vo.issueTypeIdSelector), (0, $hIdxh.statusCategorySelector), (0, $5JqpU.boardTypeSelector), (0, $5JqpU.boardIdSelector), (0, $jZDJX.projectIdSelector), (0, $5JqpU.issueIdSelector), $2e83588d5847fe2c$var$assigneeIdSelector, (0, $bYZxt.practicesSelector), // @ts-expect-error - TS2554 - Expected 2-13 arguments, but got 16.
(0, $8CSFK.ecosystemGlancesSelector), (0, $9D3Vo.issueTypeSelector), (0, $5JqpU.accountIdloggedInUserSelector), (0, $0492z.mentionsInDescriptionSelector), (0, $0492z.mentionsInCommentsSelector), (0, $5JqpU.analyticsMetadataSelector), (0, $dmojD.totalCommentsSelector), (// @ts-expect-error - TS7006 - Parameter 'analyticsSource' implicitly has an 'any' type.
analyticsSource, // @ts-expect-error - TS7006 - Parameter 'issueId' implicitly has an 'any' type.
issueId, // @ts-expect-error - TS7006 - Parameter 'projectId' implicitly has an 'any' type.
projectId, // @ts-expect-error - TS7006 - Parameter 'projectType' implicitly has an 'any' type.
projectType, // @ts-expect-error - TS7006 - Parameter 'isSimplifiedProject' implicitly has an 'any' type.
isSimplifiedProject, // @ts-expect-error - TS7006 - Parameter 'issueTypeId' implicitly has an 'any' type.
issueTypeId, // @ts-expect-error - TS7006 - Parameter 'statusCategory' implicitly has an 'any' type.
statusCategory, // @ts-expect-error - TS7006 - Parameter 'boardType' implicitly has an 'any' type.
boardType, // @ts-expect-error - TS7006 - Parameter 'boardId' implicitly has an 'any' type.
boardId, // @ts-expect-error - TS7006 - Parameter 'containerId' implicitly has an 'any' type.
containerId, // @ts-expect-error - TS7006 - Parameter 'objectId' implicitly has an 'any' type.
objectId, // @ts-expect-error - TS7006 - Parameter 'assigneeId' implicitly has an 'any' type.
assigneeId, // @ts-expect-error - TS7006 - Parameter 'practice' implicitly has an 'any' type.
practice, // @ts-expect-error - TS7006 - Parameter 'ecosystemGlances' implicitly has an 'any' type.
ecosystemGlances, // @ts-expect-error - TS7006 - Parameter 'issueType' implicitly has an 'any' type.
issueType, // @ts-expect-error - TS7006 - Parameter 'currentUserId' implicitly has an 'any' type.
currentUserId, // @ts-expect-error - TS7006 - Parameter 'mentionsInDescription' implicitly has an 'any' type.
mentionsInDescription, // @ts-expect-error - TS7006 - Parameter 'mentionsInComments' implicitly has an 'any' type.
mentionsInComments, // @ts-expect-error - TS7006 - Parameter 'analyticsMetadata' implicitly has an 'any' type.
analyticsMetadata, totalComments)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let conditionalAttributes = {};
    if (analyticsSource) conditionalAttributes.analyticsSource = analyticsSource;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(projectType) === (0, $7ZZxN.SERVICE_DESK_PROJECT_ANALYTICS) && practice) conditionalAttributes.itsmPractice = practice;
    if ((0, $1ybV0.ff)('sea-2350-analytics-for-mentions-in-board-and-backlog_2gkji')) {
        const currentUserMentionedInDescription = ()=>{
            if (mentionsInDescription && mentionsInDescription.length > 0) return mentionsInDescription.some((mention)=>mention.attrs.id === currentUserId);
            return false;
        };
        const currentUserMentionedInComments = ()=>{
            if (mentionsInComments && mentionsInComments.length > 0) return mentionsInComments.some((mention)=>mention.attrs.id === currentUserId);
            return false;
        };
        conditionalAttributes.mentionIndicator = false;
        conditionalAttributes.userMentionedInDescription = currentUserMentionedInDescription();
        conditionalAttributes.userMentionedInComment = currentUserMentionedInComments();
        conditionalAttributes = {
            ...conditionalAttributes,
            ...analyticsMetadata
        };
    }
    if ((0, $1ybV0.ff)('confluence-admin-product-controls')) {
        const confluenceControlsStorage = (0, $89bO2.createSessionStorageProvider)((0, $cGCxH.CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY));
        const confluenceControlsCache = (0, $3qF4w.getSessionStorageData)((0, $cGCxH.CONFLUENCE_CONTROLS_STORAGE_KEY), confluenceControlsStorage);
        const confluencePermissionsStorage = (0, $89bO2.createSessionStorageProvider)((0, $cGCxH.CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY));
        const confluencePermissionsCache = (0, $3qF4w.getSessionStorageData)((0, $cGCxH.CONFLUENCE_ACCESS_STORAGE_KEY), confluencePermissionsStorage);
        conditionalAttributes.confluenceIntegrations = {
            quickActionContentMenuShown: confluenceControlsCache ? confluenceControlsCache[(0, $cGCxH.ConfluenceFeatureKeys).CREATE_MENU_TOP_ACTIONS]?.value : undefined,
            createLinkContentMenuShown: confluenceControlsCache ? confluenceControlsCache[(0, $cGCxH.ConfluenceFeatureKeys).CREATE_MENU_CONFLUENCE_CONTENT]?.value : undefined,
            useHasConfluenceSeat: confluencePermissionsCache ? confluencePermissionsCache.permitted : undefined
        };
    }
    let glancePanelAnalytics;
    if (ecosystemGlances) glancePanelAnalytics = {
        glancePanel: ecosystemGlances// Forge panels are only available sometimes because of a race condition.
        // Find these analytics on `viewed jiraForgeUi.issueGlanceTriggerScreen` instead
        // @ts-expect-error - TS7006 - Parameter 'glancePanel' implicitly has an 'any' type.
        .filter((glancePanel)=>glancePanel.glanceType !== (0, $fkvsU.FORGE_ENTITY_TYPE))// @ts-expect-error - TS7006 - Parameter 'glancePanel' implicitly has an 'any' type.
        .map((glancePanel)=>glancePanel.appKey)
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        containerType: 'project',
        containerId: containerId,
        objectType: 'issue',
        objectId: objectId,
        attributes: {
            ...conditionalAttributes,
            designVersion: 'v2-bento',
            projectId: projectId,
            issueId: issueId,
            projectConfig: isSimplifiedProject ? (0, $7ZZxN.ProjectStyle).NEXT_GEN : (0, $7ZZxN.ProjectStyle).CLASSIC,
            projectType: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(projectType),
            nextGenProject: Boolean(isSimplifiedProject),
            statusCategory: statusCategory,
            statusCategoryId: statusCategory ? (0, $8Qd0L.categoryIdForStatusCategory)(statusCategory) : null,
            issueTypeId: issueTypeId,
            boardType: boardType,
            boardId: boardId,
            assigneeId: assigneeId,
            issueType: [
                'bug',
                'story',
                'epic',
                'task',
                'subtask'
            ].includes(issueType?.name?.toLowerCase()) ? issueType.name.toLowerCase() : 'other',
            ...glancePanelAnalytics,
            totalComments: totalComments
        }
    };
});

});
parcelRegister("89bO2", function(module, exports) {

$parcel$export(module.exports, "createSessionStorageProvider", () => $eaaf8012779da3f6$export$a922b987e648d2fa);
$parcel$export(module.exports, "createSessionExpirableStorageProvider", () => $eaaf8012779da3f6$export$e0a2e9a062c6a695);

var $jqvCZ = parcelRequire("jqvCZ");

var $avHyR = parcelRequire("avHyR");

var $8zsxt = parcelRequire("8zsxt");
const $eaaf8012779da3f6$export$a922b987e648d2fa = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>(0, $avHyR.createStorageProvider)(appPrefix, (0, $8zsxt.makeSessionStore)()));
const $eaaf8012779da3f6$export$e0a2e9a062c6a695 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const store = (0, $8zsxt.makeSessionExpirableStore)();
    return store.namespace(appPrefix);
});

});
parcelRegister("8zsxt", function(module, exports) {

$parcel$export(module.exports, "makeSessionStore", () => $dffa4c0ba19d0eb7$export$fb690882d627b3b5);
$parcel$export(module.exports, "makeSessionExpirableStore", () => $dffa4c0ba19d0eb7$export$a8f626c8ded9a06c);

var $2y3XF = parcelRequire("2y3XF");

var $gleLd = parcelRequire("gleLd");

var $ZGlKn = parcelRequire("ZGlKn");

var $gpWeB = parcelRequire("gpWeB");

var $lyUHD = parcelRequire("lyUHD");

var $avHyR = parcelRequire("avHyR");
const $dffa4c0ba19d0eb7$export$fb690882d627b3b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($lyUHD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], (0, $avHyR.plugins));
const $dffa4c0ba19d0eb7$export$a8f626c8ded9a06c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($lyUHD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gleLd)))
    ]);

});


parcelRegister("cGCxH", function(module, exports) {

$parcel$export(module.exports, "ConfluenceFeatureKeys", () => $8c4704bc755a9560$export$746d4746bf07dd70);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_KEY", () => $8c4704bc755a9560$export$6247c7e19b71f4e);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_KEY", () => $8c4704bc755a9560$export$e34c4c923d934e7a);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY", () => $8c4704bc755a9560$export$ffe60197eb59ca73);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY", () => $8c4704bc755a9560$export$8d0c4a26241944b8);
const $8c4704bc755a9560$export$746d4746bf07dd70 = {
    ENABLE_CONFLUENCE_SIGNUP: 'jira.admin.confluence.enable-integrations',
    SPRINT_RETRO: 'jira.admin.confluence.enable-sprint-retros',
    CREATE_MENU_TOP_ACTIONS: 'jira.admin.confluence.enable-content-creation-issue-top-actions',
    CREATE_MENU_CONFLUENCE_CONTENT: 'jira.admin.confluence.enable-content-creation-issue-confluence-content'
};
const $8c4704bc755a9560$export$6247c7e19b71f4e = 'confluence-integration-controls';
const $8c4704bc755a9560$export$e34c4c923d934e7a = 'user-confluence-access';
const $8c4704bc755a9560$export$ffe60197eb59ca73 = 'confluence-integration-controls-session-storage';
const $8c4704bc755a9560$export$8d0c4a26241944b8 = 'confluence-permissions-session-storage';

});

parcelRegister("3qF4w", function(module, exports) {

$parcel$export(module.exports, "getSessionStorageData", () => $9b853a0c5a3b3d2d$export$af84d82ff1eea56d);
$parcel$export(module.exports, "setSessionStorageData", () => $9b853a0c5a3b3d2d$export$be8cb7c8f1a1db6b);
$parcel$export(module.exports, "isStorageKeyExpired", () => $9b853a0c5a3b3d2d$export$59dd918a314efec0);
$parcel$export(module.exports, "clearSessionStorageData", () => $9b853a0c5a3b3d2d$export$47001de47bd4a961);
const $9b853a0c5a3b3d2d$var$createTTLTimestamp = (ttl)=>Date.now() + ttl;
const $9b853a0c5a3b3d2d$export$af84d82ff1eea56d = (key, storage)=>storage.get(key);
const $9b853a0c5a3b3d2d$export$be8cb7c8f1a1db6b = ({ key: key, value: value, ttl: ttl, storage: storage })=>{
    const expiresAt = $9b853a0c5a3b3d2d$var$createTTLTimestamp(ttl);
    storage.set(key, {
        ...value,
        expiresAt: expiresAt
    });
};
const $9b853a0c5a3b3d2d$export$59dd918a314efec0 = (key, storage)=>{
    if (!$9b853a0c5a3b3d2d$export$af84d82ff1eea56d(key, storage)) return true;
    const expiresAt = $9b853a0c5a3b3d2d$export$af84d82ff1eea56d(key, storage)?.expiresAt;
    return expiresAt ? new Date().getTime() >= expiresAt : true;
};
const $9b853a0c5a3b3d2d$export$47001de47bd4a961 = (key, storage)=>storage.remove(key);

});

parcelRegister("0492z", function(module, exports) {

$parcel$export(module.exports, "mentionsInDescriptionSelector", () => $01de92e571345b81$export$8b5d41095967485f);
$parcel$export(module.exports, "mentionsInCommentsSelector", () => $01de92e571345b81$export$ee7651ae59ebd9fb);

var $df4Sl = parcelRequire("df4Sl");

var $1ybV0 = parcelRequire("1ybV0");

var $bm1XB = parcelRequire("bm1XB");

var $f9RL0 = parcelRequire("f9RL0");

var $fokFV = parcelRequire("fokFV");

var $dmojD = parcelRequire("dmojD");
const $01de92e571345b81$export$8b5d41095967485f = (0, $df4Sl.createSelector)((0, $fokFV.fieldSelector)((0, $f9RL0.DESCRIPTION)), (description)=>{
    if ((0, $1ybV0.ff)('sea-2350-analytics-for-mentions-in-board-and-backlog_2gkji') && description?.adfValue?.content) return (0, $bm1XB.findMentionsInAdfContent)(description.adfValue.content);
    return [];
});
const $01de92e571345b81$export$ee7651ae59ebd9fb = (0, $df4Sl.createSelector)((0, $dmojD.entitiesCommentsSelector), (comments)=>{
    if ((0, $1ybV0.ff)('sea-2350-analytics-for-mentions-in-board-and-backlog_2gkji')) {
        if (comments && Object.values(comments) && Object.values(comments).length > 0) {
            const content = Object.values(comments).flatMap((item)=>item?.bodyAdf?.content);
            return content ? (0, $bm1XB.findMentionsInAdfContent)(content) : [];
        }
        return [];
    }
    return [];
});

});
parcelRegister("bm1XB", function(module, exports) {

$parcel$export(module.exports, "findMentionsInAdfContent", () => $480b84f51fed2351$export$d300fdcf6968c7ca);

var $5Yqat = parcelRequire("5Yqat");

var $h0sZe = parcelRequire("h0sZe");
const $480b84f51fed2351$export$d300fdcf6968c7ca = (elements)=>{
    if (!elements) return [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($5Yqat)))((0, (/*@__PURE__*/$parcel$interopDefault($h0sZe)))(elements, (element)=>{
        if (element?.type && element.type === 'mention') return element;
        if (element?.content) return $480b84f51fed2351$export$d300fdcf6968c7ca(element.content);
        return null;
    }));
};

});
parcelRegister("5Yqat", function(module, exports) {
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */ function $4596dac18914dac8$var$compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value) result[resIndex++] = value;
    }
    return result;
}
module.exports = $4596dac18914dac8$var$compact;

});

parcelRegister("h0sZe", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");

var $eo8NR = parcelRequire("eo8NR");
/** Used as references for various `Number` constants. */ var $c618ebe283af6d5e$var$INFINITY = 1 / 0;
/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDeep([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $c618ebe283af6d5e$var$flatMapDeep(collection, iteratee) {
    return $hKE3p($eo8NR(collection, iteratee), $c618ebe283af6d5e$var$INFINITY);
}
module.exports = $c618ebe283af6d5e$var$flatMapDeep;

});
parcelRegister("eo8NR", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $7qARj = parcelRequire("7qARj");

var $iA1h1 = parcelRequire("iA1h1");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $a79a22b5b4895d6c$var$map(collection, iteratee) {
    var func = $1c8hB(collection) ? $kJvGp : $iA1h1;
    return func(collection, $7qARj(iteratee, 3));
}
module.exports = $a79a22b5b4895d6c$var$map;

});




parcelRegister("bYZxt", function(module, exports) {

$parcel$export(module.exports, "practicesSelector", () => $ec1c8c88d05ffdfa$export$ebf68235db0b75ac);

var $df4Sl = parcelRequire("df4Sl");

var $lO4Or = parcelRequire("lO4Or");

var $fokFV = parcelRequire("fokFV");
const $ec1c8c88d05ffdfa$export$ebf68235db0b75ac = (0, $df4Sl.createSelector)((0, $fokFV.fieldSelector)((0, $lO4Or.SERVICEDESK_PRACTICES_TYPE)), (practices)=>{
    // Practices will always be an array of only one practice
    if (practices && practices.value && practices.value.length > 0) return practices.value[0];
    return undefined;
});

});

parcelRegister("hIdxh", function(module, exports) {

$parcel$export(module.exports, "statusCategorySelector", () => $baf523e988efb9c6$export$5781b97f9cf014e9);

var $df4Sl = parcelRequire("df4Sl");

var $8Qd0L = parcelRequire("8Qd0L");

var $f9RL0 = parcelRequire("f9RL0");

var $fokFV = parcelRequire("fokFV");
const $baf523e988efb9c6$export$5781b97f9cf014e9 = (0, $df4Sl.createSelector)((0, $fokFV.fieldPersistedValueSelector)((0, $f9RL0.STATUS)), (status)=>{
    if (!status) return null;
    return (0, $8Qd0L.statusCategoryForId)(status.statusCategory.id);
});

});



parcelRegister("lESkT", function(module, exports) {

$parcel$export(module.exports, "default", () => $232d3f75bcc9123f$export$2e2bcd8739ae039);
const $232d3f75bcc9123f$var$triggerAnalyticsForApp = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
var /**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ $232d3f75bcc9123f$export$2e2bcd8739ae039 = $232d3f75bcc9123f$var$triggerAnalyticsForApp('issue');

});


parcelRegister("exdBZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $534c0b62f1918df8$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $ieRGA = parcelRequire("ieRGA");

var $9Y7ra = parcelRequire("9Y7ra");

var $hc60A = parcelRequire("hc60A");

var $277q1 = parcelRequire("277q1");

var $lkPj1 = parcelRequire("lkPj1");

var $gzLYm = parcelRequire("gzLYm");
const $534c0b62f1918df8$var$activityFeedHandler = (action$, store)=>// @ts-expect-error - TS2345: Property 'payload' is missing in type '{ type: "state.FETCH_SORTED_WORKLOGS_REQUEST"; }' but required in type 'FetchSortedCommentsRequestAction'.
    action$.ofType((0, $277q1.SELECT_ACTIVITY_SORT_ORDER), (0, $277q1.SELECT_ACTIVITY_ITEM)).switchMap(({ type: type })=>{
        const state = store.getState();
        const selectedActivityItem = (0, $gzLYm.getSelectedActivityItem)(state);
        const queryParamsToStrip = type === (0, $277q1.SELECT_ACTIVITY_SORT_ORDER) ? [
            'focusedWorklogId'
        ] : [
            'focusedCommentId',
            'focusedWorklogId'
        ];
        // @ts-expect-error - TS2345 - Argument of type 'null' is not assignable to parameter of type 'string'.
        window.history.replaceState({}, null, (0, $ieRGA.default)(queryParamsToStrip));
        if (selectedActivityItem === null) return (0, $3JafE.Observable).empty();
        if (type === (0, $277q1.SELECT_ACTIVITY_ITEM) && selectedActivityItem.type === (0, $hc60A.COMMENTS)) return (0, $3JafE.Observable).of((0, $lkPj1.fetchSortedCommentsRequest)());
        if (selectedActivityItem.type === (0, $hc60A.WORKLOG)) return (0, $3JafE.Observable).of((0, $9Y7ra.fetchSortedWorklogsRequest)());
        return (0, $3JafE.Observable).empty();
    });
var $534c0b62f1918df8$export$2e2bcd8739ae039 = $534c0b62f1918df8$var$activityFeedHandler;

});
parcelRegister("ieRGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $209cb7ee89940e6b$export$2e2bcd8739ae039);

var $78Ywx = parcelRequire("78Ywx");

var $kFGm5 = parcelRequire("kFGm5");
var /**
 * Use to remove query params from url without reload or change history
 * One use case is to remove any tracking id from the url to avoid problems in copy & paste urls or sharing links between users
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$209cb7ee89940e6b$export$2e2bcd8739ae039 = (paramsToStrip)=>{
    try {
        const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($78Ywx))).parse(window.location.href, true);
        const strippedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(parsedUrl.query || {}, paramsToStrip);
        let strippedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($78Ywx))).format({
            ...parsedUrl,
            search: undefined,
            query: strippedQuery
        });
        // we don't want to encode : to %3A in connect project pages
        const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(window.location.search);
        if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
        window.history.replaceState({}, '', strippedUrl);
    } catch (e) {
    /* uri might be malformed */ }
};

});


parcelRegister("1MPDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd747029eb5aaf98$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("fiQ2m");
parcelRequire("3wBUP");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $3A3OQ = parcelRequire("3A3OQ");

var $hVtHw = parcelRequire("hVtHw");

var $277q1 = parcelRequire("277q1");

var $5JqpU = parcelRequire("5JqpU");
const $bd747029eb5aaf98$var$LOG_LOCATION = 'issue.activity-feed.sort.save.epic';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bd747029eb5aaf98$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $277q1.UPDATE_ACTIVITY_SORT_ORDER_REQUEST)).switchMap((action)=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        return (0, $hVtHw.updateActivitySortOrder)(baseUrl, action.payload).ignoreElements();
    }).catch((error)=>{
        (0, $3A3OQ.trackOrLogClientError)($bd747029eb5aaf98$var$LOG_LOCATION, 'Could not save sort order in jira issue view', error);
        return (0, $3JafE.Observable).empty();
    });

});
parcelRegister("hVtHw", function(module, exports) {

$parcel$export(module.exports, "updateActivitySortOrder", () => $03ef7a4a5613550d$export$da12d2a5f155fd9a);
parcelRequire("flmol");

var $gUUjF = parcelRequire("gUUjF");

var $aiRd8 = parcelRequire("aiRd8");

var $11LM5 = parcelRequire("11LM5");
const $03ef7a4a5613550d$var$saveActivitySortQuery = (sortOrder)=>`
    mutation jira_activity_setActivitySortOrder {
        setActivitySortOrder(orderBy: ${sortOrder}) {
            success
            errors {
                message
            }
        }
    }
`;
const $03ef7a4a5613550d$var$LOG_LOCATION = 'issue.activity-feed.sort.save.gira';
const $03ef7a4a5613550d$var$fieldDataOptionsGira = (sortOrder)=>({
        method: 'POST',
        body: JSON.stringify({
            query: $03ef7a4a5613550d$var$saveActivitySortQuery(sortOrder)
        })
    });
const $03ef7a4a5613550d$var$transform = (data)=>{
    const { errors: errors } = data.setActivitySortOrder;
    if (errors && errors.length > 0) {
        const error = new Error(errors[0].message);
        (0, $gUUjF.default).safeErrorWithoutCustomerData($03ef7a4a5613550d$var$LOG_LOCATION, 'Error present in gira response when calling to update setActivitySortOrder', error);
    }
    return data.setActivitySortOrder;
};
const $03ef7a4a5613550d$export$da12d2a5f155fd9a = (baseUrl, sortOrder)=>// @ts-expect-error - TS2684 - The 'this' context of type 'Observable<ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>' is not assignable to method's 'this' of type 'Observable<GiraResponseData>'.
    (0, $aiRd8.default)(`${baseUrl}/rest/gira/1/`, $03ef7a4a5613550d$var$fieldDataOptionsGira(sortOrder))// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GraphqlResponse<ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>'.
    .map((response)=>(0, $11LM5.getGraphQlData)($03ef7a4a5613550d$var$LOG_LOCATION, response)).map($03ef7a4a5613550d$var$transform);

});


parcelRegister("dIQug", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d9af89f9d13223d$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("cpH8E");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $iJRQu = parcelRequire("iJRQu");

var $3A3OQ = parcelRequire("3A3OQ");

var $a0kZP = parcelRequire("a0kZP");

var $5JqpU = parcelRequire("5JqpU");

var $jMP2a = parcelRequire("jMP2a");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$2d9af89f9d13223d$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $a0kZP.APPLINK_AUTHENTICATION_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const href = action.payload;
        const { analyticsEvent: analyticsEvent } = action.meta;
        const promise = (0, $iJRQu.default)(`${baseUrl}${href}`);
        if (analyticsEvent) (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'applink authenticate', {
            authStatus: 'start'
        });
        if (promise) return (0, $3JafE.Observable).fromPromise(promise).map(()=>{
            if (analyticsEvent) (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'applink authenticate', {
                authStatus: 'success'
            });
            return (0, $a0kZP.applinkAuthenticationSuccess)();
        }).catch((error)=>{
            (0, $3A3OQ.trackOrLogClientError)('issue-applink-authentication-epic', 'Failed to authenticate with applinks', error);
            return (0, $3JafE.Observable).empty();
        });
        return (0, $3JafE.Observable).empty();
    });

});
parcelRegister("iJRQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $36706ec39a943fd8$export$2e2bcd8739ae039);
/**
    This function is in order to encapsulate the behavior of the AppLinksUtils functionality

    AppLinksUtils is an Atlassian Plugin.

    AppLinks repository: https://bitbucket.org/atlassian/application-links
 */ /**
    The following function implements the same interface as the [OAuthCallback object](https://bitbucket.org/atlassian/application-links/src/02de9b212e57ff72a3a44744ed6cabc5ff359874/applinks-plugin/src/main/resources/applinks/internal/feature/oauth/oauth-callback.js?at=master)

    It creates the object, assigns the object to a global variable in window and calls the plugin in a new window

    Once the Authentication dance is perform, the opened window will call success or failure callbacks from the window.opener.oauthCallback (https://bitbucket.org/atlassian/application-links/src/02de9b212e57ff72a3a44744ed6cabc5ff359874/applinks-oauth-plugin/src/main/resources/com/atlassian/applinks/oauth/auth/oauth-dance.js?at=master)
 */ const $36706ec39a943fd8$var$authenticateUsingAppLinks = (url)=>{
    if (window.oauthCallback) // preventing opening more than one authentication at the time.
    return null;
    const result = new Promise((resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reject)=>{
        let oauthWindow;
        let timer;
        let isPending = true;
        const oauthCallback = {
            success: ()=>{
                clearInterval(timer);
                // @ts-expect-error - TS2794 - Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?
                resolve();
                isPending = false;
                delete window.oauthCallback;
                oauthWindow && oauthWindow.close();
            },
            failure: ()=>{
                clearInterval(timer);
                reject(Error('Failed to authenticate with applinks'));
                isPending = false;
                delete window.oauthCallback;
                oauthWindow && oauthWindow.close();
            }
        };
        window.oauthCallback = oauthCallback;
        oauthWindow = window.open(url, 'com_atlassian_applinks_authentication');
        timer = setInterval(()=>{
            if (oauthWindow && oauthWindow.closed && isPending) {
                delete window.oauthCallback;
                reject(Error('Failed to authenticate with applinks'));
                clearInterval(timer);
            }
        }, 500);
    });
    return result;
};
var $36706ec39a943fd8$export$2e2bcd8739ae039 = $36706ec39a943fd8$var$authenticateUsingAppLinks;

});


parcelRegister("hQNnv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cdcc306d1611717$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("cpH8E");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $bd1K7 = parcelRequire("bd1K7");

var $illlw = parcelRequire("illlw");

var $3JafE = parcelRequire("3JafE");

var $2qprj = parcelRequire("2qprj");
var $b961A = parcelRequire("b961A");
var $ksJPv = parcelRequire("ksJPv");
var $1KO5o = parcelRequire("1KO5o");
var $aAKuc = parcelRequire("aAKuc");

var $3A3OQ = parcelRequire("3A3OQ");

var $9k8SP = parcelRequire("9k8SP");

var $2W4Cf = parcelRequire("2W4Cf");

var $3b6FJ = parcelRequire("3b6FJ");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $6vrw7 = parcelRequire("6vrw7");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8cdcc306d1611717$var$fetchParentRequest = (action$, store)=>action$.ofType((0, $2W4Cf.FETCH_ISSUE_PARENTS_REQUEST)).mergeMap(()=>{
        const state = store.getState();
        const issueKey = (0, $5JqpU.issueKeySelector)(state);
        const cloudId = (0, $5JqpU.cloudIdSelector)(state);
        return (0, $ksJPv.fetchParentCandidatesForExistingIssueOld)(cloudId, issueKey, '', true);
    }).map((0, $2W4Cf.fetchIssueParentsSuccess))// @ts-expect-error - TS2345 - Argument of type '(error: any) => FetchIssueParentsFailure' is not assignable to parameter of type '(err: any, caught: Observable<FetchIssueParentsSuccess>) => ObservableInput<unknown>'.
    .catch((error)=>{
        (0, $3A3OQ.trackOrLogClientError)('issue.fetch-parent.failure', '', error);
        return (0, $2W4Cf.fetchIssueParentsFailure)();
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8cdcc306d1611717$var$fetchParentWithInfoRequest = (action$, store)=>action$.ofType((0, $2W4Cf.FETCH_ISSUE_PARENTS_WITH_INFO_REQUEST)).mergeMap(()=>{
        const state = store.getState();
        const issueKey = (0, $5JqpU.issueKeySelector)(state);
        const cloudId = (0, $5JqpU.cloudIdSelector)(state);
        return (0, $ksJPv.fetchParentCandidatesForExistingIssue)(cloudId, issueKey, '', true);
    }).map((0, $2W4Cf.fetchIssueParentsWithInfoSuccess))// @ts-expect-error - TS2345 - Argument of type '(error: any) => FetchIssueParentsFailure' is not assignable to parameter of type '(err: any, caught: Observable<FetchIssueParentsSuccess>) => ObservableInput<unknown>'.
    .catch((error)=>{
        (0, $3A3OQ.trackOrLogClientError)('issue.fetch-parent.failure', '', error);
        return (0, $2W4Cf.fetchIssueParentsFailure)();
    });
const $8cdcc306d1611717$var$getSetParentAction = (state, action, projectId, changedIssueIds)=>{
    const isSimplified = (0, $jZDJX.isSimplifiedProjectSelector)(state);
    if (action.type === (0, $2W4Cf.SET_PARENT_OPTIMISTIC)) return (0, $3JafE.Observable).fromPromise(action.payload.requestPromise);
    if (isSimplified) return (0, $aAKuc.setIssueParentsTMP)(projectId, action.payload.parentId, {
        issueIds: changedIssueIds
    });
    return (0, $1KO5o.setIssueParentCMP)(action.payload.parentId, {
        issueId: changedIssueIds[0]
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8cdcc306d1611717$var$setParentRequest = (action$, store)=>action$.ofType((0, $2W4Cf.SET_PARENT_REQUEST), (0, $2W4Cf.SET_PARENT_OPTIMISTIC)).mergeMap((action)=>{
        const state = store.getState();
        const { payload: { issues: issues } } = action;
        const parentId = action.type === (0, $2W4Cf.SET_PARENT_OPTIMISTIC) ? action.payload.parentIssue && action.payload.parentIssue.id : action.payload.parentId;
        const parentIssues = (0, $jZDJX.parentLevelIssuesSelector)(state);
        const parentIssue = action.type === (0, $2W4Cf.SET_PARENT_OPTIMISTIC) ? action.payload.parentIssue : parentIssues.find((issue)=>issue.id === parentId);
        const changedIssueIds = issues.filter((issue)=>issue.parentId !== parentId && issue.id).map((issue)=>(0, $6vrw7.toIssueId)(issue.id || ''));
        const oldParentIdsByIssueIds = (0, $9k8SP.mapParentIdByIssueId)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        issues.filter((issue)=>changedIssueIds.includes(issue.id)));
        if (!changedIssueIds.length) return (0, $3JafE.Observable).empty();
        const projectId = (0, $jZDJX.projectIdSelector)(state);
        // @ts-expect-error - TS2345 - Argument of type 'number | null' is not assignable to parameter of type 'number'.
        const setParentAction = $8cdcc306d1611717$var$getSetParentAction(state, action, projectId, changedIssueIds);
        return setParentAction// @ts-expect-error - TS2345 - Argument of type '() => Observable<{ type: "SET_PARENT_SUCCESS"; payload: { parentIssue: IssueParent; oldParentIdsByIssueIds: { [key: string]: string | null; }; }; }> | Observable<{ type: "UNSET_PARENT_SUCCESS"; payload: { ...; }; }>' is not assignable to parameter of type '(value: unknown, index: number) => ObservableInput<{ type: "SET_PARENT_SUCCESS"; payload: { parentIssue: IssueParent; oldParentIdsByIssueIds: { [key: string]: string | null; }; }; }>'.
        .flatMap(()=>{
            if (parentIssue) return (0, $3JafE.Observable).of((0, $2W4Cf.setParentSuccess)(parentIssue, oldParentIdsByIssueIds));
            return (0, $3JafE.Observable).of((0, $2W4Cf.unsetParentSuccess)(oldParentIdsByIssueIds));
        }).catch((error)=>{
            (0, $3A3OQ.trackOrLogClientError)('issue.set-parent.failure', '', error);
            return (0, $3JafE.Observable).empty();
        });
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8cdcc306d1611717$var$unsetParentRequest = (action$, store)=>action$.ofType((0, $2W4Cf.UNSET_PARENT_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const { payload: { issues: issues } } = action;
        const changedIssueIds = issues.filter((issue)=>issue.parentId && issue.id).map((issue)=>(0, $6vrw7.toIssueId)(issue.id || ''));
        const oldParentIdsByIssueIds = (0, $9k8SP.mapParentIdByIssueId)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        issues.filter((issue)=>changedIssueIds.includes(issue.id)));
        if (changedIssueIds.length === 0) return (0, $3JafE.Observable).empty();
        const projectId = (0, $jZDJX.projectIdSelector)(state);
        const isSimplified = (0, $jZDJX.isSimplifiedProjectSelector)(state);
        const deleteIssueParentResult = ()=>{
            if (isSimplified) // @ts-expect-error - TS2345 - Argument of type 'number | null' is not assignable to parameter of type 'number'.
            return (0, $b961A.deleteIssueParentsTMP)(projectId, {
                issueIds: changedIssueIds
            });
            return (0, $2qprj.deleteIssueParentCMP)({
                issueId: changedIssueIds[0]
            });
        };
        return deleteIssueParentResult().flatMap(()=>(0, $3JafE.Observable).of((0, $2W4Cf.unsetParentSuccess)(oldParentIdsByIssueIds))).catch((error)=>{
            (0, $3A3OQ.trackOrLogClientError)('issue.unset-parent.failure', '', error);
            return (0, $3JafE.Observable).empty();
        });
    });
const $8cdcc306d1611717$var$changeParentSuccess = (fieldValueActions)=>(action$, store)=>action$.ofType((0, $2W4Cf.SET_PARENT_SUCCESS), (0, $2W4Cf.UNSET_PARENT_SUCCESS)).map((action)=>{
            const fieldId = 'parent';
            const state = store.getState();
            const issueKey = (0, $5JqpU.issueKeySelector)(state);
            if (action.type === (0, $2W4Cf.SET_PARENT_SUCCESS)) {
                const parentIssue = action?.payload.parentIssue || null;
                parentIssue && fieldValueActions.setFieldValue(issueKey, fieldId, {
                    id: parentIssue.id,
                    key: parentIssue.key,
                    fields: {
                        summary: parentIssue.summary,
                        issuetype: parentIssue.issueType
                    },
                    color: parentIssue.color
                });
            } else if (action.type === (0, $2W4Cf.UNSET_PARENT_SUCCESS)) fieldValueActions.setFieldValue(issueKey, fieldId, null);
            return (0, $3b6FJ.issueRelationshipUpdateSuccess)((0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(action, 'payload.oldParentIdsByIssueIds'), (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(action, 'payload.parentIssue.id', null));
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8cdcc306d1611717$export$2e2bcd8739ae039 = (fieldValueActions)=>(0, $bd1K7.combineEpics)($8cdcc306d1611717$var$fetchParentRequest, $8cdcc306d1611717$var$fetchParentWithInfoRequest, $8cdcc306d1611717$var$setParentRequest, $8cdcc306d1611717$var$unsetParentRequest, $8cdcc306d1611717$var$changeParentSuccess(fieldValueActions));

});
parcelRegister("2qprj", function(module, exports) {

$parcel$export(module.exports, "deleteIssueParentCMP", () => $d806fbcb674afa17$export$bf06917d17ff395d);

var $aiRd8 = parcelRequire("aiRd8");
const $d806fbcb674afa17$export$6abd71c7b03f94f4 = (issueId)=>`/rest/api/3/issue/${issueId}`;
const $d806fbcb674afa17$export$bf06917d17ff395d = (payload)=>(0, $aiRd8.default)($d806fbcb674afa17$export$6abd71c7b03f94f4(payload.issueId), {
        method: 'PUT',
        body: JSON.stringify({
            fields: {
                parent: {
                    id: null
                }
            }
        })
    });

});

parcelRegister("b961A", function(module, exports) {

$parcel$export(module.exports, "deleteIssueParentsTMP", () => $0debbd4196f4ab0c$export$e359bcf177ca071a);

var $aiRd8 = parcelRequire("aiRd8");
const $0debbd4196f4ab0c$export$94dc9fffd9ae871d = (projectId)=>`/rest/internal/simplified/1.0/projects/${projectId}/issues/delete-parents`;
const $0debbd4196f4ab0c$export$e359bcf177ca071a = (projectId, payload)=>(0, $aiRd8.default)($0debbd4196f4ab0c$export$94dc9fffd9ae871d(projectId), {
        method: 'POST',
        body: JSON.stringify(payload)
    });

});

parcelRegister("ksJPv", function(module, exports) {

$parcel$export(module.exports, "fetchParentCandidatesForExistingIssue", () => $30bdd1b75406f614$export$59a0f41a1d5dcee0);
$parcel$export(module.exports, "fetchParentCandidatesForExistingIssueOld", () => $30bdd1b75406f614$export$92f4caffcf9b3ea5);


var $7EhAs = parcelRequire("7EhAs");

var $4NW4H = parcelRequire("4NW4H");

var $gSE5U = parcelRequire("gSE5U");

var $gbHOB = parcelRequire("gbHOB");

var $hKxcm = parcelRequire("hKxcm");
// clean up on 'com.atlassian.jira.customhierarchy.parent.candidates.with.info.endpoints.enabled' flag removal
function $30bdd1b75406f614$var$isNewType(giraData) {
    return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    giraData.parentCandidatesWithInfoForExistingIssue !== undefined);
}
function $30bdd1b75406f614$var$isOldType(giraData) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return giraData.parentCandidatesForExistingIssue !== undefined;
}
const $30bdd1b75406f614$export$59a0f41a1d5dcee0 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
    const response = (0, $4NW4H.default)(cloudId, issueKey, searchTerm, excludeDone);
    const { data: data, errors: errors } = await response;
    if (!data || errors) {
        const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
        throw new (0, $gbHOB.default)(new Error(message), (0, $gSE5U.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
    }
    if ($30bdd1b75406f614$var$isNewType(data.jira) && !data.jira?.parentCandidatesWithInfoForExistingIssue) {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify(errors);
            // if `parentCandidatesForExistingIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $gbHOB.default)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, $gSE5U.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $gbHOB.default)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, $gSE5U.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
    }
    const candidates = $30bdd1b75406f614$var$isNewType(data.jira) ? (0, $hKxcm.transformData)(data.jira.parentCandidatesWithInfoForExistingIssue.parentCandidates.edges) : [];
    return {
        candidates: candidates,
        message: $30bdd1b75406f614$var$isNewType(data.jira) ? data.jira.parentCandidatesWithInfoForExistingIssue.message : undefined
    };
};
const $30bdd1b75406f614$export$92f4caffcf9b3ea5 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
    const response = (0, $4NW4H.default)(cloudId, issueKey, searchTerm, excludeDone);
    const { data: data, errors: errors } = await response;
    if (!data || errors) {
        const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
        throw new (0, $gbHOB.default)(new Error(message), (0, $gSE5U.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY));
    }
    if ($30bdd1b75406f614$var$isOldType(data.jira) && !data.jira?.parentCandidatesForExistingIssue) {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify(errors);
            // if `parentCandidatesForExistingIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $gbHOB.default)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, $gSE5U.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $gbHOB.default)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, $gSE5U.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY));
    }
    return $30bdd1b75406f614$var$isOldType(data.jira) ? (0, $hKxcm.transformData)(data.jira.parentCandidatesForExistingIssue.edges) : [];
};

});
parcelRegister("4NW4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b4ab2a034cf0653$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");

var $gSE5U = parcelRequire("gSE5U");

var $kXzsJ = parcelRequire("kXzsJ");
const $5b4ab2a034cf0653$export$83bff8b82e36a9e9 = 20;
const $5b4ab2a034cf0653$var$isParentCandidatesWithInfoEndpointsEnabled = ()=>(0, $1ybV0.ff)('com.atlassian.jira.customhierarchy.parent.candidates.with.info.endpoints.enabled');
var /**
 * Returns parent candidates for an existing issue
 *
 * @param cloudId - The cloud ID of the instance
 * @param issueKey - The key of the issue to find parents for e.g SCRUM-1000
 * @param searchTerm - A search string for the parent, on either full key match or partial summary match
 * @param excludeDone - Whether to exclude done issues from the list of parent candidate results
 * @returns A list of possible parent issues for the specified issue
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$5b4ab2a034cf0653$export$2e2bcd8739ae039 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
    const variables = {
        cloudId: cloudId,
        issueKey: issueKey,
        searchTerm: searchTerm,
        excludeDone: excludeDone,
        first: $5b4ab2a034cf0653$export$83bff8b82e36a9e9
    };
    const response = await (0, $kXzsJ.getClient)('').query({
        query: $5b4ab2a034cf0653$var$isParentCandidatesWithInfoEndpointsEnabled() ? (0, $gSE5U.buildParentCandidatesForExistingIssueQuery)() : (0, $gSE5U.buildParentCandidatesForExistingIssueQueryOld)(),
        variables: variables
    });
    return response;
};

});
parcelRegister("gSE5U", function(module, exports) {

$parcel$export(module.exports, "PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY", () => $e9da6eadea09a233$export$8e85d4c99e6be8c3);
$parcel$export(module.exports, "PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO", () => $e9da6eadea09a233$export$c7c7f21787854c5b);
$parcel$export(module.exports, "buildParentCandidatesForExistingIssueQuery", () => $e9da6eadea09a233$export$b64c34b6ba3d6bf5);
$parcel$export(module.exports, "buildParentCandidatesForExistingIssueQueryOld", () => $e9da6eadea09a233$export$32bc33c9f0ffdef3);

var $8OLx5 = parcelRequire("8OLx5");
const $e9da6eadea09a233$export$8e85d4c99e6be8c3 = 'issueParentCandidatesForExistingIssuesQuery';
const $e9da6eadea09a233$export$c7c7f21787854c5b = 'issueParentCandidatesForExistingIssuesQueryWithInfo';
const $e9da6eadea09a233$export$b64c34b6ba3d6bf5 = ()=>`
    query jira_parenting_${$e9da6eadea09a233$export$c7c7f21787854c5b}($issueKey: String!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, $8OLx5.parentCandidatesForExistingIssueQuery)()}
    }
`;
const $e9da6eadea09a233$export$32bc33c9f0ffdef3 = ()=>`
    query jira_parenting_${$e9da6eadea09a233$export$8e85d4c99e6be8c3}($issueKey: String!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, $8OLx5.parentCandidatesForExistingIssueQueryOld)()}
    }
`;

});
parcelRegister("8OLx5", function(module, exports) {

$parcel$export(module.exports, "parentCandidatesForExistingIssueQuery", () => $3bad3c743a64005c$export$f63a6e3151b9dd82);
$parcel$export(module.exports, "parentCandidatesForExistingIssueQueryOld", () => $3bad3c743a64005c$export$4b5fb5d99c715f5);

var $bKxX9 = parcelRequire("bKxX9");
const $3bad3c743a64005c$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
const $3bad3c743a64005c$var$summary = ()=>` 
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
const $3bad3c743a64005c$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
const $3bad3c743a64005c$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
const $3bad3c743a64005c$var$fieldsByIdOld = ()=>`fieldsById(ids:["summary", "issuetype"]){
  edges{
    node{
      ${$3bad3c743a64005c$var$issueType()}
      ${$3bad3c743a64005c$var$summary()}
    }
  }
}`;
const $3bad3c743a64005c$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$3bad3c743a64005c$var$issueType()}
      ${$3bad3c743a64005c$var$summary()}
      ${$3bad3c743a64005c$var$status()}
    }
  }
}`;
const $3bad3c743a64005c$export$f63a6e3151b9dd82 = ()=>`
    jira {
      parentCandidatesWithInfoForExistingIssue(key: $issueKey, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
        parentCandidates {
          edges {
            node {
              issueId
              key
              ${$3bad3c743a64005c$var$color()}
              ${(0, $bKxX9.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') ? $3bad3c743a64005c$var$fieldsById() : $3bad3c743a64005c$var$fieldsByIdOld()}
            }
          }
        }
        message
      }
    }
`;
const $3bad3c743a64005c$export$4b5fb5d99c715f5 = ()=>`
    jira {
        parentCandidatesForExistingIssue(key: $issueKey, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
          edges {
            node {
              issueId
              key
              ${$3bad3c743a64005c$var$color()}
              ${(0, $bKxX9.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') ? $3bad3c743a64005c$var$fieldsById() : $3bad3c743a64005c$var$fieldsByIdOld()}
            }
          }
        }
      }`;

});



parcelRegister("gbHOB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c796f884883538e4$export$2e2bcd8739ae039);

var $7byHA = parcelRequire("7byHA");
class $c796f884883538e4$export$2e2bcd8739ae039 extends Error {
    constructor(error, endpoint){
        if (error instanceof $c796f884883538e4$export$2e2bcd8739ae039) return error;
        super(error.message);
        this.error = error;
        this.message = error.message;
        if (error instanceof (0, $7byHA.default)) {
            if (error.traceId != null) this.traceId = error.traceId;
            this.statusCode = error.statusCode;
        }
        this.endpoint = endpoint;
    }
}

});

parcelRegister("hKxcm", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $eafcb23fdcdaf55d$export$3ceb62baab058c6b);

var $8Qd0L = parcelRequire("8Qd0L");


var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $tgbCK = parcelRequire("tgbCK");
const $eafcb23fdcdaf55d$export$3ceb62baab058c6b = (edges)=>edges.map((edge)=>{
        const edgeNode = edge.node;
        const fieldsEdges = edgeNode.fieldsById.edges;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const summaryField = fieldsEdges.find((field)=>field.node.fieldId === 'summary');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const issueTypeField = fieldsEdges.find((field)=>field.node.fieldId === 'issuetype');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const statusField = fieldsEdges.find((field)=>field.node.fieldId === 'status');
        const colorField = edgeNode.issueColorField;
        if (summaryField === undefined) throw new (0, $7byHA.ValidationError)('Validation Error', [
            {
                field: 'summary',
                error: 'Call to gira for parent candidates returned without summary data'
            }
        ], (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef));
        if (issueTypeField === undefined) throw new (0, $7byHA.ValidationError)('Validation Error', [
            {
                field: 'issueType',
                error: 'Call to gira for parent candidates returned without issue type data'
            }
        ], (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef));
        if ((0, $1ybV0.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') && statusField === undefined) throw new (0, $7byHA.ValidationError)('Validation Error', [
            {
                field: 'status',
                error: 'Call to gira for parent candidates returned without status data'
            }
        ], (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef));
        if (// only issues at level 1 are expected to have a hierarchy level (i.e Epics)
        issueTypeField.node.issueType?.hierarchy?.level === 1 && colorField === undefined) throw new (0, $7byHA.ValidationError)('Validation Error', [
            {
                field: 'Issue Color',
                error: 'Call to gira for parent candidates returned without color data'
            }
        ], (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef));
        const summaryFieldNode = summaryField.node;
        const issueTypeFieldNode = issueTypeField.node;
        const checkParentIssueIsDone = (statusCategoryId)=>{
            const doneStatusCategoryId = (0, $8Qd0L).StatusCategoryIds[(0, $8Qd0L).StatusCategoryTypes.DONE];
            return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
        };
        const isDone = (0, $1ybV0.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') ? checkParentIssueIsDone(statusField.node.status.statusCategory.statusCategoryId) : undefined;
        const statusCategoryId = (0, $1ybV0.ff)('compal-issue-actions-parent-statuscategoryid_s2esc') ? statusField?.node.status.statusCategory.statusCategoryId : undefined;
        const parent = {
            id: edgeNode.issueId,
            key: edgeNode.key,
            summary: summaryFieldNode.text,
            issueType: {
                id: String(issueTypeFieldNode.issueType.issueTypeId),
                name: issueTypeFieldNode.issueType.name,
                iconUrl: issueTypeFieldNode.issueType.avatar.xsmall
            },
            isDone: isDone,
            statusCategoryId: statusCategoryId
        };
        // todo: write a test for issueColor undefined
        return {
            ...parent,
            color: colorField?.color?.colorKey ? (0, $tgbCK.MAP_FROM_SERVER_COLOR)[colorField.color.colorKey] : undefined
        };
    });

});


parcelRegister("1KO5o", function(module, exports) {

$parcel$export(module.exports, "setIssueParentCMP", () => $6bdf0eb4c6b37bb7$export$ef6fceca94e2d07b);

var $aiRd8 = parcelRequire("aiRd8");
const $6bdf0eb4c6b37bb7$export$6abd71c7b03f94f4 = (issueId)=>`/rest/api/3/issue/${issueId}`;
const $6bdf0eb4c6b37bb7$export$ef6fceca94e2d07b = (parentId, payload)=>(0, $aiRd8.default)($6bdf0eb4c6b37bb7$export$6abd71c7b03f94f4(payload.issueId), {
        method: 'PUT',
        body: JSON.stringify({
            fields: {
                parent: {
                    id: String(parentId)
                }
            }
        })
    });

});

parcelRegister("aAKuc", function(module, exports) {

$parcel$export(module.exports, "setIssueParentsTMP", () => $c284fb6ba03b720f$export$75252a716fad3d5);

var $aiRd8 = parcelRequire("aiRd8");
const $c284fb6ba03b720f$var$getIssueSetParentUrlTMP = (projectId, parentId)=>`/rest/internal/simplified/1.0/projects/${projectId}/issues/${parentId}/children`;
const $c284fb6ba03b720f$export$75252a716fad3d5 = (projectId, parentId, payload)=>(0, $aiRd8.default)($c284fb6ba03b720f$var$getIssueSetParentUrlTMP(projectId, parentId), {
        method: 'POST',
        body: JSON.stringify(payload)
    });

});

parcelRegister("9k8SP", function(module, exports) {

$parcel$export(module.exports, "mapParentIdByIssueId", () => $eb48123fa755370e$export$b262150e2eaf1b78);
// DEPRECATED - use jira-issue-parent-services package

var $3JafE = parcelRequire("3JafE");
parcelRequire("bI4RP");

var $aiRd8 = parcelRequire("aiRd8");
const $eb48123fa755370e$export$b262150e2eaf1b78 = (issues)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    issues.reduce((mapping, issue)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...mapping,
            // @ts-expect-error - TS2464 - A computed property name must be of type 'string', 'number', 'symbol', or 'any'.
            [issue.id]: issue.parentId
        }), {});
const $eb48123fa755370e$var$getIssueSetParentUrl = (baseUrl, projectId, parentId)=>`${baseUrl}/rest/internal/simplified/1.0/projects/${projectId}/issues/${parentId}/children`;
const $eb48123fa755370e$var$getIssueDeleteParentUrl = (baseUrl, projectId)=>`${baseUrl}/rest/internal/simplified/1.0/projects/${projectId}/issues/delete-parents`;
const $eb48123fa755370e$export$6bdf52f105cc4319 = (baseUrl, projectId, parentId, payload)=>projectId ? (0, $aiRd8.default)($eb48123fa755370e$var$getIssueSetParentUrl(baseUrl, projectId, parentId), {
        method: 'POST',
        body: JSON.stringify(payload)
    }) : (0, $3JafE.Observable).throw('Missing Project Id');
const $eb48123fa755370e$export$26a2138ee3954494 = (baseUrl, projectId, payload)=>projectId ? (0, $aiRd8.default)($eb48123fa755370e$var$getIssueDeleteParentUrl(baseUrl, projectId), {
        method: 'POST',
        body: JSON.stringify(payload)
    }) : (0, $3JafE.Observable).throw('Missing Project Id');

});

parcelRegister("3b6FJ", function(module, exports) {

$parcel$export(module.exports, "ISSUE_RELATIONSHIP_UPDATE_SUCCESS", () => $6ebd9ebc9e1eddca$export$90aca8edb7fd670c);
$parcel$export(module.exports, "issueRelationshipUpdateSuccess", () => $6ebd9ebc9e1eddca$export$615f4f5ba729b41d);
const $6ebd9ebc9e1eddca$export$90aca8edb7fd670c = 'ISSUE_RELATIONSHIP_UPDATE_SUCCESS';
const $6ebd9ebc9e1eddca$export$615f4f5ba729b41d = (oldParentIdsByIssueIds, parentIssueId = null)=>({
        type: $6ebd9ebc9e1eddca$export$90aca8edb7fd670c,
        payload: {
            oldParentIdsByIssueIds: oldParentIdsByIssueIds,
            parentIssueId: parentIssueId
        }
    });

});


parcelRegister("eU40m", function(module, exports) {

$parcel$export(module.exports, "default", () => $41225955640086e4$export$2e2bcd8739ae039);

var $2u30U = parcelRequire("2u30U");
var $41225955640086e4$export$2e2bcd8739ae039 = (0, $2u30U.default);

});
parcelRegister("2u30U", function(module, exports) {

$parcel$export(module.exports, "default", () => $012c0c2eaa97518c$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("l5lul");
parcelRequire("fiQ2m");
parcelRequire("dpYY5");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("iects");
parcelRequire("ldiu7");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $k8Qyf = parcelRequire("k8Qyf");

var $eRitJ = parcelRequire("eRitJ");

var $il04y = parcelRequire("il04y");

var $3A3OQ = parcelRequire("3A3OQ");

var $b2g4Y = parcelRequire("b2g4Y");

var $5JqpU = parcelRequire("5JqpU");

var $jDl0t = parcelRequire("jDl0t");

var $l2tj3 = parcelRequire("l2tj3");
const $012c0c2eaa97518c$var$RETRY_ATTEMPTS = 3;
const $012c0c2eaa97518c$var$EXCEED_SIZE_LIMIT_MESSAGE = 'exceedes max allowed size';
const $012c0c2eaa97518c$export$ccbd739d4c726750 = (action$, store)=>action$.ofType((0, $b2g4Y.ATTACHMENT_MEDIA_SERVICES_UPLOAD_END)).mergeMap((action)=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueKey = (0, $5JqpU.issueKeySelector)(state);
        const loggedInAccountId = (0, $5JqpU.accountIdloggedInUserSelector)(state);
        const attachment = (0, $jDl0t.uploadedAttachmentSelector)(action.payload.id)(state);
        if (attachment === undefined) {
            // https://jdog.jira-dev.com/browse/BENTO-10220
            // Try to understand why attachment is undefined, It could be the action.payload is undefined
            (0, $3A3OQ.trackOrLogClientError)('issue.attachment.jira-create-error', 'Failed to upload attachment', action.payload?.id);
            return (0, $3JafE.Observable).of((0, $b2g4Y.attachmentJiraCreateFailure)(attachment, 200));
        }
        return (0, $l2tj3.createAttachmentInJira)(attachment, baseUrl, issueKey, loggedInAccountId).retry($012c0c2eaa97518c$var$RETRY_ATTEMPTS).map((0, $b2g4Y.attachmentJiraCreateSuccess)).catch((error)=>{
            (0, $3A3OQ.trackOrLogClientError)('issue.attachment.jira-create-error', 'Could not create attachment in Jira', error);
            const exceedFileSizeLimit = error.message?.includes($012c0c2eaa97518c$var$EXCEED_SIZE_LIMIT_MESSAGE);
            return (0, $3JafE.Observable).of((0, $b2g4Y.attachmentJiraCreateFailure)(attachment, error.statusCode, exceedFileSizeLimit));
        });
    });
const $012c0c2eaa97518c$var$attachmentJiraCreationEndEpicFn = ()=>{
    let numCreated = 0;
    let numFailed = 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (action$, store)=>action$.ofType((0, $b2g4Y.ATTACHMENT_JIRA_CREATE_FAILURE), (0, $b2g4Y.ATTACHMENT_JIRA_CREATE_SUCCESS)).do(({ type: type })=>{
            if (type === (0, $b2g4Y.ATTACHMENT_JIRA_CREATE_SUCCESS)) numCreated += 1;
            else if (type === (0, $b2g4Y.ATTACHMENT_JIRA_CREATE_FAILURE)) numFailed += 1;
        }).filter(()=>{
            const attachments = (0, $jDl0t.uploadedAttachmentsByIdSelector)(store.getState());
            const numAttachmentsInProgress = Object.keys(attachments).length;
            return numAttachmentsInProgress === 0;
        }).map(()=>{
            const issueKey = (0, $5JqpU.issueKeySelector)(store.getState());
            const action = (0, $b2g4Y.attachmentJiraCreateEnd)(issueKey, numCreated, numFailed);
            numCreated = 0;
            numFailed = 0;
            return action;
        });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $012c0c2eaa97518c$var$logJiraAttachmentCreationFailureEpic = (action$)=>action$.ofType((0, $b2g4Y.ATTACHMENT_JIRA_CREATE_FAILURE)).do((action)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.attachment.jira-create-error', 'Could not create attachment in Jira', {
            statusCode: action.payload.statusCode
        });
    }).ignoreElements();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $012c0c2eaa97518c$var$logMediaServicesUploadErrorEpic = (action$)=>action$.ofType((0, $b2g4Y.MEDIA_PICKER_ERROR), (0, $b2g4Y.ATTACHMENT_MEDIA_SERVICES_UPLOAD_ERROR)).do((action)=>{
        const { description: description, name: name, fileId: fileId } = action.payload;
        (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.attachment.media-services-upload-error', 'Could not upload attachment to Media Services', {
            description: description,
            name: name,
            fileId: fileId
        });
    }).ignoreElements();
const $012c0c2eaa97518c$export$4d279cfeef9d1313 = (attachmentActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (action$, store)=>action$.ofType((0, $b2g4Y.ATTACHMENT_JIRA_CREATE_SUCCESS)).map(()=>{
            const state = store.getState();
            const issueKey = (0, $5JqpU.issueKeySelector)(state);
            return attachmentActions.getAttachmentsCount(issueKey);
        }).distinct().do((totalCount)=>{
            const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
            const flagOptions = {
                isAutoDismiss: true,
                actions: [
                    {
                        content: (0, $il04y.default).issueAttachmentLimitLink,
                        href: (0, $eRitJ.ATTACHMENTS_LEARN_ABOUT_LINK),
                        target: '_blank'
                    }
                ]
            };
            if (totalCount === (0, $eRitJ.ATTACHMENT_NUMBER_EXCEEDED_LIMIT)) {
                showFlag({
                    type: 'warning',
                    title: (0, $il04y.default).issueAttachmentOverLimitFlagHeading,
                    description: (0, $il04y.default).issueAttachmentOverLimitFlagBody,
                    ...flagOptions
                });
                return;
            }
            if ((0, $eRitJ.isAttachmentNumberApproachLimit)(totalCount) && !(0, $eRitJ.isAttachmentNumberOverLimit)(totalCount)) showFlag({
                type: 'warning',
                title: (0, $il04y.default).issueAttachmentReachingLimitFlagHeading,
                description: (0, $il04y.default).issueAttachmentReachingLimitFlagBody,
                ...flagOptions
            });
        }).ignoreElements();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$012c0c2eaa97518c$export$2e2bcd8739ae039 = (attachmentActions)=>(0, $bd1K7.combineEpics)($012c0c2eaa97518c$export$ccbd739d4c726750, $012c0c2eaa97518c$var$attachmentJiraCreationEndEpicFn(), $012c0c2eaa97518c$var$logJiraAttachmentCreationFailureEpic, $012c0c2eaa97518c$var$logMediaServicesUploadErrorEpic, $012c0c2eaa97518c$export$4d279cfeef9d1313(attachmentActions));

});
parcelRegister("ldiu7", function(module, exports) {
"use strict";

var $3JafE = parcelRequire("3JafE");

var $7f9p6 = parcelRequire("7f9p6");
$3JafE.Observable.prototype.distinct = $7f9p6.distinct;

});
parcelRegister("7f9p6", function(module, exports) {

$parcel$export(module.exports, "distinct", () => $54613a89c2e8e4fb$export$983a3b5fb2f7202e, (v) => $54613a89c2e8e4fb$export$983a3b5fb2f7202e = v);
var $54613a89c2e8e4fb$export$983a3b5fb2f7202e;
"use strict";

var $ktZdP = parcelRequire("ktZdP");
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */ function $54613a89c2e8e4fb$var$distinct(keySelector, flushes) {
    return $ktZdP.distinct(keySelector, flushes)(this);
}
$54613a89c2e8e4fb$export$983a3b5fb2f7202e = $54613a89c2e8e4fb$var$distinct;

});
parcelRegister("ktZdP", function(module, exports) {
"use strict";
var $ee96017fcd44b195$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");

var $4O2Rl = parcelRequire("4O2Rl");
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */ function $ee96017fcd44b195$var$distinct(keySelector, flushes) {
    return function(source) {
        return source.lift(new $ee96017fcd44b195$var$DistinctOperator(keySelector, flushes));
    };
}
module.exports.distinct = $ee96017fcd44b195$var$distinct;
var $ee96017fcd44b195$var$DistinctOperator = function() {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ee96017fcd44b195$var$DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ee96017fcd44b195$var$DistinctSubscriber = function(_super) {
    $ee96017fcd44b195$var$__extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.values = new $4O2Rl.Set();
        if (flushes) this.add($87MtM.subscribeToResult(this, flushes));
    }
    DistinctSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function(value) {
        if (this.keySelector) this._useKeySelector(value);
        else this._finalizeNext(value, value);
    };
    DistinctSubscriber.prototype._useKeySelector = function(value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        } catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function(key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}($6UnJS.OuterSubscriber);
module.exports.DistinctSubscriber = $ee96017fcd44b195$var$DistinctSubscriber;

});
parcelRegister("4O2Rl", function(module, exports) {

$parcel$export(module.exports, "Set", () => $37fe0cc18a040ad7$export$bdf4ff5a442cbbc5, (v) => $37fe0cc18a040ad7$export$bdf4ff5a442cbbc5 = v);
var $37fe0cc18a040ad7$export$ac57f2e66ff143c0;
var $37fe0cc18a040ad7$export$bdf4ff5a442cbbc5;
"use strict";

var $kt6O7 = parcelRequire("kt6O7");
function $37fe0cc18a040ad7$var$minimalSetImpl() {
    // THIS IS NOT a full impl of Set, this is just the minimum
    // bits of functionality we need for this library.
    return function() {
        function MinimalSet() {
            this._values = [];
        }
        MinimalSet.prototype.add = function(value) {
            if (!this.has(value)) this._values.push(value);
        };
        MinimalSet.prototype.has = function(value) {
            return this._values.indexOf(value) !== -1;
        };
        Object.defineProperty(MinimalSet.prototype, "size", {
            get: function() {
                return this._values.length;
            },
            enumerable: true,
            configurable: true
        });
        MinimalSet.prototype.clear = function() {
            this._values.length = 0;
        };
        return MinimalSet;
    }();
}
$37fe0cc18a040ad7$export$ac57f2e66ff143c0 = $37fe0cc18a040ad7$var$minimalSetImpl;
$37fe0cc18a040ad7$export$bdf4ff5a442cbbc5 = $kt6O7.root.Set || $37fe0cc18a040ad7$var$minimalSetImpl();

});




parcelRegister("eRitJ", function(module, exports) {

$parcel$export(module.exports, "ATTACHMENT_NUMBER_EXCEEDED_LIMIT", () => $61b633cf8f78dcb4$export$9b8ccec301f30199);
$parcel$export(module.exports, "ATTACHMENTS_LEARN_ABOUT_LINK", () => $61b633cf8f78dcb4$export$5677e4e8b2908598);
$parcel$export(module.exports, "isAttachmentNumberApproachLimit", () => $61b633cf8f78dcb4$export$8d87ddca8cdc67e6);
$parcel$export(module.exports, "isAttachmentNumberExceedLimit", () => $61b633cf8f78dcb4$export$b408b9c9d483e8db);
$parcel$export(module.exports, "isAttachmentNumberOverLimit", () => $61b633cf8f78dcb4$export$bf8ff876dbfb7a34);
const $61b633cf8f78dcb4$export$5c690f91356504d4 = 145;
const $61b633cf8f78dcb4$export$afac7297361ac4ed = 150;
const $61b633cf8f78dcb4$export$9b8ccec301f30199 = $61b633cf8f78dcb4$export$afac7297361ac4ed + 1;
const $61b633cf8f78dcb4$export$5677e4e8b2908598 = 'https://support.atlassian.com/jira-software-cloud/docs/add-an-attachment-to-an-issue/';
const $61b633cf8f78dcb4$export$8d87ddca8cdc67e6 = (totalNumber)=>totalNumber > $61b633cf8f78dcb4$export$5c690f91356504d4;
const $61b633cf8f78dcb4$export$b408b9c9d483e8db = (totalNumber)=>totalNumber > $61b633cf8f78dcb4$export$afac7297361ac4ed;
const $61b633cf8f78dcb4$export$bf8ff876dbfb7a34 = (totalNumber)=>totalNumber > $61b633cf8f78dcb4$export$9b8ccec301f30199;

});

parcelRegister("il04y", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcc6ce175f3fa788$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dcc6ce175f3fa788$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueAttachmentReachingLimitFlagHeading: {
        "id": "issue-attachments-limit.issue-attachment-reaching-limit-flag-heading",
        "defaultMessage": "This issue has a lot of attachments"
    },
    issueAttachmentReachingLimitFlagBody: {
        "id": "issue-attachments-limit.issue-attachment-reaching-limit-flag-body",
        "defaultMessage": "When an issue has over 150 attachments, it may not display previews and thumbnails."
    },
    issueAttachmentOverLimitFlagHeading: {
        "id": "issue-attachments-limit.issue-attachment-over-limit-flag-heading",
        "defaultMessage": "Too many attachments on this issue"
    },
    issueAttachmentOverLimitFlagBody: {
        "id": "issue-attachments-limit.issue-attachment-over-limit-flag-body",
        "defaultMessage": "Thumbnails and preview can't load. Remove some attachments to enable thumbnails and previews."
    },
    issueAttachmentLimitLink: {
        "id": "issue-attachments-limit.issue-attachment-limit-link",
        "defaultMessage": "Learn about attachments"
    }
});

});

parcelRegister("jDl0t", function(module, exports) {

$parcel$export(module.exports, "uploadedAttachmentsByIdSelector", () => $0d0318aec2bb3368$export$8fc2ce9b867f0ee1);
$parcel$export(module.exports, "isAttachmentPickerPopupOpenSelector", () => $0d0318aec2bb3368$export$c2dc2919e7fc01cd);
$parcel$export(module.exports, "uploadedAttachmentSelector", () => $0d0318aec2bb3368$export$7a3bf3db9e23a897);

var $df4Sl = parcelRequire("df4Sl");

var $7SLq9 = parcelRequire("7SLq9");
const $0d0318aec2bb3368$var$attachmentPickerSelector = (0, $df4Sl.createSelector)((0, $7SLq9.attachmentsSelector), (attachments)=>attachments.picker);
const $0d0318aec2bb3368$export$8fc2ce9b867f0ee1 = (0, $df4Sl.createSelector)($0d0318aec2bb3368$var$attachmentPickerSelector, // @ts-expect-error - TS2339 - Property 'uploadedAttachments' does not exist on type 'AttachmentPickerState'.
(attachmentPicker)=>attachmentPicker.attachments || attachmentPicker.uploadedAttachments);
const $0d0318aec2bb3368$export$c2dc2919e7fc01cd = (0, $df4Sl.createSelector)($0d0318aec2bb3368$var$attachmentPickerSelector, (attachmentPicker)=>attachmentPicker.isPopupOpen);
const $0d0318aec2bb3368$export$7a3bf3db9e23a897 = (attachmentId)=>(0, $df4Sl.createSelector)($0d0318aec2bb3368$export$8fc2ce9b867f0ee1, (attachments)=>attachments[attachmentId]);

});
parcelRegister("7SLq9", function(module, exports) {

$parcel$export(module.exports, "canCreateAttachmentsSelector", () => $64e99e074e2bbd9e$export$1eeb6fbf29a890e0);
$parcel$export(module.exports, "attachmentsSelector", () => $64e99e074e2bbd9e$export$4fdc5aee86ce2a7b);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");
const $64e99e074e2bbd9e$export$1eeb6fbf29a890e0 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canCreateAttachments);
const $64e99e074e2bbd9e$export$4fdc5aee86ce2a7b = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.attachments);

});


parcelRegister("l2tj3", function(module, exports) {

$parcel$export(module.exports, "createAttachmentInJira", () => $dba5d06a47c4af69$export$8d015683aaaa37d0);
parcelRequire("flmol");

var $aiRd8 = parcelRequire("aiRd8");
const $dba5d06a47c4af69$export$5dccdb2f39e35345 = (baseUrl, issueKey)=>`${baseUrl}/rest/api/2/attachment/upload/issue/${issueKey}`;
const $dba5d06a47c4af69$var$getCreateAttachmentOptions = (attachment)=>({
        method: 'POST',
        body: JSON.stringify({
            fileId: attachment.id
        })
    });
const $dba5d06a47c4af69$var$transformAttachment = (createResponse, pendingAttachment, loggedInAccountId)=>({
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        id: `${createResponse.attachmentId}`,
        mediaApiFileId: pendingAttachment.id,
        createdDate: pendingAttachment.createdDate,
        author: loggedInAccountId,
        mimetype: pendingAttachment.mimetype,
        filename: pendingAttachment.filename
    });
const $dba5d06a47c4af69$export$8d015683aaaa37d0 = (pendingAttachment, baseUrl, issueKey, loggedInAccountId)=>{
    const createAttachmentUrl = $dba5d06a47c4af69$export$5dccdb2f39e35345(baseUrl, issueKey);
    const createAttachmentOptions = $dba5d06a47c4af69$var$getCreateAttachmentOptions(pendingAttachment);
    return (0, $aiRd8.default)(createAttachmentUrl, createAttachmentOptions).map((createResponse)=>$dba5d06a47c4af69$var$transformAttachment(createResponse, pendingAttachment, loggedInAccountId));
};

});



parcelRegister("2kAsn", function(module, exports) {

$parcel$export(module.exports, "default", () => $95b430c7778cb050$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");
parcelRequire("dfsI8");

var $b2g4Y = parcelRequire("b2g4Y");

var $hlJEN = parcelRequire("hlJEN");
// @ts-expect-error - TS2304 - Cannot find name 'ActionsObservable'.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $95b430c7778cb050$var$markTokenAsOutdatedOnAttachmentUploadEnd = (action$)=>action$.ofType((0, $b2g4Y.ATTACHMENT_MEDIA_SERVICES_UPLOAD_END)).mapTo((0, $hlJEN.markTokenAsOutdated)());
// @ts-expect-error - TS2304 - Cannot find name 'ActionsObservable'.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $95b430c7778cb050$var$markTokenAsUpToDateOnAttachmentCreateFailure = (action$)=>action$.ofType((0, $b2g4Y.ATTACHMENT_JIRA_CREATE_FAILURE)).mapTo((0, $hlJEN.markTokenAsUpToDate)());
// @ts-expect-error - TS2304 - Cannot find name 'ActionsObservable'.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $95b430c7778cb050$var$fetchViewContextOnAttachmentCreateSuccess = (action$)=>action$.ofType((0, $b2g4Y.ATTACHMENT_JIRA_CREATE_SUCCESS)).mapTo((0, $hlJEN.fetchViewContextRequest)());
var $95b430c7778cb050$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)($95b430c7778cb050$var$markTokenAsOutdatedOnAttachmentUploadEnd, $95b430c7778cb050$var$markTokenAsUpToDateOnAttachmentCreateFailure, $95b430c7778cb050$var$fetchViewContextOnAttachmentCreateSuccess);

});

parcelRegister("4cNpB", function(module, exports) {

$parcel$export(module.exports, "default", () => $43c82adef265fefd$export$2e2bcd8739ae039);
parcelRequire("jAXdN");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $illlw = parcelRequire("illlw");

var $3JafE = parcelRequire("3JafE");

var $dXapj = parcelRequire("dXapj");

var $b1qLQ = parcelRequire("b1qLQ");

var $aiRd8 = parcelRequire("aiRd8");

var $gA9Fk = parcelRequire("gA9Fk");
var $3A3OQ = parcelRequire("3A3OQ");

var $b2g4Y = parcelRequire("b2g4Y");

var $lSVfs = parcelRequire("lSVfs");

var $fYteL = parcelRequire("fYteL");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $4Fgnj = parcelRequire("4Fgnj");
const $43c82adef265fefd$var$getIssueMediaUrl = (issueId)=>`/rest/greenhopper/1.0/xboard/work/media?issueIds=${issueId}`;
const $43c82adef265fefd$var$getAdditionalBoardDataUrl = (rapidViewId)=>`/rest/greenhopper/1.0/xboard/work/additionalBoardData?rapidViewId=${rapidViewId}`;
const $43c82adef265fefd$var$fetchIssueMedia = (state, issueId)=>(0, $aiRd8.default)($43c82adef265fefd$var$getIssueMediaUrl(issueId), {
        method: 'GET'
    });
const $43c82adef265fefd$var$fetchAdditionalBoardData = (state, rapidViewId)=>(0, $aiRd8.default)($43c82adef265fefd$var$getAdditionalBoardDataUrl(rapidViewId), {
        method: 'GET'
    });
const $43c82adef265fefd$var$handleSuccess = (issueMedia, additionalBoardData)=>{
    const isEnabled = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(additionalBoardData, 'isMediaOnCardsEnabled', false);
    const attachmentId = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(issueMedia, 'cardMedia[0].attachmentId', null);
    const availableAttachmentIds = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(issueMedia, 'cardMedia[0].availableAttachmentIds', []);
    return (0, $3JafE.Observable).of((0, $lSVfs.cardCoverFetchSuccess)({
        isEnabled: isEnabled,
        attachmentId: attachmentId,
        availableAttachmentIds: availableAttachmentIds
    }));
};
const $43c82adef265fefd$var$handleFailure = (error)=>{
    (0, $3A3OQ.trackOrLogClientError)('issue.card-cover.fetch', error.message, error);
    return (0, $3JafE.Observable).of((0, $lSVfs.cardCoverFetchFailure)());
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$43c82adef265fefd$export$2e2bcd8739ae039 = (action$, store)=>action$.pipe((0, $gA9Fk.ofTypeOrBatchType)((0, $fYteL.FETCH_ISSUE_SUCCESS), (0, $b2g4Y.ATTACHMENT_JIRA_CREATE_SUCCESS)), (0, $dXapj.filter)(()=>(0, $4Fgnj.isCardCoverActionsEnabledSelector)(store.getState())), (0, $b1qLQ.mergeMap)(()=>{
        const state = store.getState();
        const rapidViewId = (0, $5JqpU.rapidViewIdSelector)(state);
        const issueId = (0, $jZDJX.idSelector)(state);
        if (rapidViewId === null || rapidViewId === undefined || issueId === null || issueId === undefined) return (0, $3JafE.Observable).empty();
        return (0, $3JafE.Observable).zip($43c82adef265fefd$var$fetchIssueMedia(state, issueId), $43c82adef265fefd$var$fetchAdditionalBoardData(state, rapidViewId)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .flatMap(([issueMedia, additionalBoardData])=>$43c82adef265fefd$var$handleSuccess(issueMedia, additionalBoardData)).catch((error)=>$43c82adef265fefd$var$handleFailure(error));
    }));

});
parcelRegister("4Fgnj", function(module, exports) {

$parcel$export(module.exports, "cardCoverSelector", () => $7dc31ea8cec12176$export$3cfd6848e07c3572);
$parcel$export(module.exports, "isCardCoverEnabledSelector", () => $7dc31ea8cec12176$export$6ebdb005136f7892);
$parcel$export(module.exports, "isCardCoverActionsEnabledSelector", () => $7dc31ea8cec12176$export$3c8184db9dac46b3);

var $df4Sl = parcelRequire("df4Sl");

var $8blac = parcelRequire("8blac");

var $ldoFd = parcelRequire("ldoFd");

var $f9RL0 = parcelRequire("f9RL0");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");
const $7dc31ea8cec12176$export$3cfd6848e07c3572 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.cardCover);
const $7dc31ea8cec12176$export$6ebdb005136f7892 = (0, $df4Sl.createSelector)($7dc31ea8cec12176$export$3cfd6848e07c3572, (cardCover)=>cardCover && cardCover.isEnabled);
const $7dc31ea8cec12176$export$85552af9f8d4fcd9 = (0, $df4Sl.createSelector)($7dc31ea8cec12176$export$3cfd6848e07c3572, (cardCover)=>cardCover && (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(cardCover.attachmentId) || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(cardCover.availableAttachmentIds)));
const $7dc31ea8cec12176$export$3c8184db9dac46b3 = (0, $df4Sl.createSelector)((0, $5JqpU.issueActionsSelector), (issueActions)=>!!issueActions && issueActions.includes((0, $f9RL0.CARD_COVER_ACTIONS)));

});


parcelRegister("8VBxz", function(module, exports) {

$parcel$export(module.exports, "default", () => $84b705e83c785bca$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("8jBvP");

var $gUUjF = parcelRequire("gUUjF");

var $aiRd8 = parcelRequire("aiRd8");

var $lSVfs = parcelRequire("lSVfs");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");
const $84b705e83c785bca$export$2f984fd41024447a = (baseUrl, issueId, attachmentId)=>{
    const cardCoverUrl = `${baseUrl}/rest/greenhopper/1.0/xboard/work/media/${issueId}`;
    return attachmentId ? `${cardCoverUrl}?attachmentId=${attachmentId}` : cardCoverUrl;
};
const $84b705e83c785bca$var$updateMediaCover = (state, action)=>{
    const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
    const issueId = (0, $jZDJX.idSelector)(state);
    const { attachmentId: attachmentId } = action.payload;
    if (issueId === null || issueId === undefined) return (0, $3JafE.Observable).empty();
    const fetchOptions = {
        method: attachmentId ? 'PUT' : 'DELETE'
    };
    return (0, $aiRd8.default)($84b705e83c785bca$export$2f984fd41024447a(baseUrl, issueId, attachmentId), fetchOptions);
};
const $84b705e83c785bca$var$handleSuccess = ()=>(0, $3JafE.Observable).of((0, $lSVfs.cardCoverUpdateSuccess)());
const $84b705e83c785bca$var$handleFailure = (error, action)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.card-cover.update', error, new Error(error));
    return (0, $3JafE.Observable).of((0, $lSVfs.cardCoverUpdateFailure)(action.payload.currentAttachmentId));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$84b705e83c785bca$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $lSVfs.CARD_COVER_UPDATE_REQUEST)).flatMap((action)=>$84b705e83c785bca$var$updateMediaCover(store.getState(), action).flatMap(()=>$84b705e83c785bca$var$handleSuccess()).catch((error)=>$84b705e83c785bca$var$handleFailure(error, action)));

});

parcelRegister("k6Xst", function(module, exports) {

$parcel$export(module.exports, "default", () => $10a3e58888e02458$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("l5lul");
parcelRequire("fiQ2m");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $jUhyG = parcelRequire("jUhyG");

var $8HuAw = parcelRequire("8HuAw");

var $gUUjF = parcelRequire("gUUjF");

var $6TtLT = parcelRequire("6TtLT");

var $ltjPP = parcelRequire("ltjPP");

var $fYteL = parcelRequire("fYteL");

var $5JqpU = parcelRequire("5JqpU");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $10a3e58888e02458$var$createAnalyticsPayload = (action, actionSubjectId, attributes)=>({
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
const $10a3e58888e02458$var$fireAnalytics = (event, action, actionSubjectId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
attributes)=>{
    const payload = $10a3e58888e02458$var$createAnalyticsPayload(action, actionSubjectId, attributes);
    (0, $jUhyG.fireTrackAnalytics)(event, payload);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $10a3e58888e02458$var$simpleChangeIssueType = (action$, store)=>action$.ofType((0, $ltjPP.SIMPLE_CHANGE_ISSUE_TYPE_REQUEST)).switchMap((action)=>{
        const baseUrl = (0, $5JqpU.baseUrlSelector)(store.getState());
        const { issueKey: issueKey, targetType: targetType, issueId: issueId, analyticsEvent: analyticsEvent, currentType: currentType } = action.payload;
        if (!currentType.subtask && targetType.subtask) {
            $10a3e58888e02458$var$fireAnalytics(analyticsEvent, 'updated', 'simpleChangeIssueTypeRedirect', {
                subTask: targetType.subtask
            });
            return (0, $3JafE.Observable).of((0, $ltjPP.simpleChangeIssueTypeNotAllowed)(issueId, currentType, targetType));
        }
        return (0, $6TtLT.attemptSimpleIssueTypechange)(baseUrl, issueKey, targetType.id).map((success)=>{
            if (success) {
                $10a3e58888e02458$var$fireAnalytics(analyticsEvent, 'updated', 'simpleChangeIssueTypeSuccess');
                return (0, $ltjPP.simpleChangeIssueTypeSuccess)(issueKey, targetType.name);
            }
            $10a3e58888e02458$var$fireAnalytics(analyticsEvent, 'updated', 'simpleChangeIssueTypeRedirect', {
                subTask: targetType.subtask
            });
            return (0, $ltjPP.simpleChangeIssueTypeNotAllowed)(issueId, currentType, targetType);
        }).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('change.issue.type.simplechange', error.message, error);
            return (0, $3JafE.Observable).of((0, $ltjPP.simpleChangeIssueTypeFailure)(error));
        });
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $10a3e58888e02458$var$simpleChangeIssueTypeSuccessHandler = (action$)=>action$.ofType((0, $ltjPP.SIMPLE_CHANGE_ISSUE_TYPE_REQUEST_SUCCESS)).switchMap(()=>(0, $3JafE.Observable).of((0, $fYteL.refreshIssueRequest)()));
const $10a3e58888e02458$var$changeIssueTypeRedirectToMoveIssueHandler = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
action$, store)=>action$.ofType((0, $ltjPP.SIMPLE_CHANGE_ISSUE_TYPE_NOT_ALLOWED)).do((action)=>{
        const baseUrl = (0, $5JqpU.baseUrlSelector)(store.getState());
        const { issueId: issueId, currentType: currentType, targetType: targetType } = action.payload;
        if (currentType.subtask && targetType.subtask) (0, $8HuAw.default)(`${baseUrl}/secure/MoveSubTaskChooseOperation!default.jspa?id=${issueId}`, false);
        else if (!currentType.subtask && targetType.subtask) (0, $8HuAw.default)(`${baseUrl}/secure/ConvertIssue.jspa?id=${issueId}`, false);
        else (0, $8HuAw.default)(`${baseUrl}/secure/MoveIssue!default.jspa?id=${issueId}`, false);
    }).ignoreElements();
var $10a3e58888e02458$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)($10a3e58888e02458$var$simpleChangeIssueType, $10a3e58888e02458$var$simpleChangeIssueTypeSuccessHandler, $10a3e58888e02458$var$changeIssueTypeRedirectToMoveIssueHandler);

});
parcelRegister("8HuAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4e730b933f14d2c$export$2e2bcd8739ae039);
parcelRequire("jG2Eu");

var $k4nIh = parcelRequire("k4nIh");

var $i56g0 = parcelRequire("i56g0");
const $f4e730b933f14d2c$export$fcafaed25582edab = (win)=>win.origin || win.location && (win.location.origin || `${win.location.protocol}//${win.location.hostname}${win.location.port ? `:${win.location.port}` : ''}`);
const $f4e730b933f14d2c$export$d614758658023fd = (url)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url);
    const { pathname: pathname, query: query, hash: hash } = parsedUrl;
    return `${pathname}${query}${hash}`;
};
const $f4e730b933f14d2c$export$61577d33a499836a = (url, win)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url);
    return parsedUrl.origin === $f4e730b933f14d2c$export$fcafaed25582edab(win);
};
const $f4e730b933f14d2c$export$11a1d61aacb7b25b = (win = window)=>(url, shouldOpenInNewTab, pushAction)=>{
        const isUrlSameOrigin = $f4e730b933f14d2c$export$61577d33a499836a(url, win);
        // Component is in an iframe
        if (win.parent !== win) {
            let isComponentInJira;
            // If parent win is not jira then accessing win.parent will throw a cross origin error
            try {
                isComponentInJira = win.parent.jira || win.parent.JIRA;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                isComponentInJira = false;
            }
            if (!isComponentInJira || shouldOpenInNewTab) win.open(url, '_blank');
            else (0, $i56g0.default)(win).location.assign(url);
        } else if (shouldOpenInNewTab) win.open(url, '_blank');
        else if (pushAction && isUrlSameOrigin) pushAction($f4e730b933f14d2c$export$d614758658023fd(url));
        else win.location.assign(url);
    };
var $f4e730b933f14d2c$export$2e2bcd8739ae039 = $f4e730b933f14d2c$export$11a1d61aacb7b25b(window);

});
parcelRegister("i56g0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b56d41a0a820784$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6b56d41a0a820784$export$2e2bcd8739ae039 = (win)=>{
    const satisfiesSameOrigin = (w)=>{
        try {
            // Accessing location.href from a window on another origin will throw an exception.
            if (w.location.href == null) return false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            return false;
        }
        return true;
    };
    const isTopMostWindow = (w)=>w === w.parent;
    let topWindow = win;
    while(!isTopMostWindow(topWindow) && satisfiesSameOrigin(topWindow.parent))topWindow = topWindow.parent;
    return topWindow;
};

});


parcelRegister("6TtLT", function(module, exports) {

$parcel$export(module.exports, "getProjectIssueTypes", () => $a4e0e175a8ad603e$export$3fdf4c5c6ee04f6a);
$parcel$export(module.exports, "attemptSimpleIssueTypechange", () => $a4e0e175a8ad603e$export$7f94c46e5e4a3c05);
parcelRequire("flmol");

var $aiRd8 = parcelRequire("aiRd8");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a4e0e175a8ad603e$var$transformIssueTypesFromProjectResponse = (projectResponse)=>projectResponse.issueTypes;
const $a4e0e175a8ad603e$export$3fdf4c5c6ee04f6a = (baseUrl, projectKey)=>{
    const url = `${baseUrl}/rest/api/3/project/${projectKey}`;
    return (0, $aiRd8.default)(url).map($a4e0e175a8ad603e$var$transformIssueTypesFromProjectResponse);
};
const $a4e0e175a8ad603e$var$attemptChangeIssueType = (baseUrl, issueKey, targetIssueType)=>(0, $aiRd8.default)(`${baseUrl}/rest/internal/2/issue/${issueKey}/changeissuetype`, {
        method: 'post',
        body: JSON.stringify({
            targetIssueTypeId: targetIssueType
        })
    });
const $a4e0e175a8ad603e$export$7f94c46e5e4a3c05 = (baseUrl, issueKey, targetTypeId)=>$a4e0e175a8ad603e$var$attemptChangeIssueType(baseUrl, issueKey, targetTypeId).map(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
    (response)=>response.changeSuccessful);

});


parcelRegister("7jRSF", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbebc6d76483d950$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $gUUjF = parcelRequire("gUUjF");

var $lkPj1 = parcelRequire("lkPj1");

var $gZSrt = parcelRequire("gZSrt");

var $eW7lD = parcelRequire("eW7lD");

const $bbebc6d76483d950$var$deleteDraftActions = [
    (0, $lkPj1.ADD_COMMENT_FORM_CANCEL),
    (0, $lkPj1.EDIT_COMMENT_CANCEL),
    (0, $lkPj1.SAVE_COMMENT_SUCCESS),
    (0, $lkPj1.DELETE_COMMENT_SUCCESS)
];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bbebc6d76483d950$var$getCommentIdFromPayload = (payload)=>{
    const commentId = (payload.id || payload.optimisticId).toString();
    if (commentId.indexOf((0, $b10b5cb385fb5d46$export$c4134c813c47beb0)) !== -1) return 0, $b10b5cb385fb5d46$export$c4134c813c47beb0;
    return commentId;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bbebc6d76483d950$var$sendDeleteDraftRequest = (action)=>{
    if (action.type === (0, $lkPj1.ADD_COMMENT_FORM_CANCEL) || action.payload.isNewComment) return (0, $3JafE.Observable).of((0, $gZSrt.deleteDraftRequest)({
        fieldId: (0, $eW7lD.createCommentDraftKey)((0, $b10b5cb385fb5d46$export$c4134c813c47beb0))
    }));
    const commentId = $bbebc6d76483d950$var$getCommentIdFromPayload(action.payload);
    const id = (0, $eW7lD.createCommentDraftKey)(commentId);
    return (0, $3JafE.Observable).of((0, $gZSrt.deleteDraftRequest)({
        fieldId: id
    }));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bbebc6d76483d950$var$errorHandler = (error)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.comment-delete-draft', error.message, error);
    return (0, $3JafE.Observable).empty();
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bbebc6d76483d950$export$2e2bcd8739ae039 = (action$)=>action$.ofType(...$bbebc6d76483d950$var$deleteDraftActions).mergeMap((action)=>$bbebc6d76483d950$var$sendDeleteDraftRequest(action)).catch((error)=>$bbebc6d76483d950$var$errorHandler(error));

});

parcelRegister("49kA9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d1e726658e8e0b6$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");


var $aiRd8 = parcelRequire("aiRd8");

var $bPG0x = parcelRequire("bPG0x");

var $3A3OQ = parcelRequire("3A3OQ");

var $4VjGY = parcelRequire("4VjGY");

var $8Bhia = parcelRequire("8Bhia");

var $lkPj1 = parcelRequire("lkPj1");

var $5JqpU = parcelRequire("5JqpU");

var $dmojD = parcelRequire("dmojD");

var $7Vbpp = parcelRequire("7Vbpp");

var $6vrw7 = parcelRequire("6vrw7");
const $3d1e726658e8e0b6$var$deleteOptions = {
    method: 'DELETE'
};
// @ts-expect-error - TS2304 - Cannot find name 'BaseUrl'. | TS2304 - Cannot find name 'IssueKey'.
const $3d1e726658e8e0b6$var$getDeletionUrl = (baseUrl, issueKey, commentId)=>`${baseUrl}/rest/api/2/issue/${issueKey}/comment/${commentId}`;
// We interpret NOT_FOUND as a successful deletion. This allows for
// parallel deletion of a comment without either user receiving an error.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3d1e726658e8e0b6$var$handleDeleteCommentError = (error, id)=>{
    (0, $3A3OQ.trackOrLogClientError)('issue.comment.delete', 'Could not delete a comment', error);
    return (0, $3JafE.Observable).of(error.statusCode === (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef) ? (0, $lkPj1.deleteCommentSuccess)(id) : (0, $lkPj1.deleteCommentFailure)(id));
};
const $3d1e726658e8e0b6$export$2e6e3ad634e3776 = (state, id, attachmentActions)=>{
    const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
    const issueKey = (0, $6vrw7.toIssueKey)((0, $5JqpU.issueKeySelector)(state));
    const deleteUrl = $3d1e726658e8e0b6$var$getDeletionUrl(baseUrl, issueKey, id);
    const { bodyAdf: bodyAdf, eventOccurredAt: eventOccurredAt, jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden } = (0, $dmojD.entitiesCommentsSelector)(state)[id];
    const shouldRefetchAttachment = bodyAdf ? (0, $7Vbpp.hasMediaFileNodes)(bodyAdf) : false;
    return (0, $aiRd8.default)(deleteUrl, $3d1e726658e8e0b6$var$deleteOptions).map(()=>{
        (0, $bPG0x.sendExperienceAnalytics)({
            getExperienceDescription: ()=>(0, $4VjGY.commentExperienceDescription)({
                    wasSuccessful: true,
                    action: 'DELETE',
                    analyticsSource: 'commentDeleteEpic',
                    projectType: state.entities.project?.projectType,
                    ...(0, $8Bhia.isJsmTimelineEnabled)() ? {
                        isEventOccurredAtSelected: Boolean(eventOccurredAt),
                        isJsdIncidentActivityViewHidden: Boolean(jsdIncidentActivityViewHidden)
                    } : {}
                })
        });
        shouldRefetchAttachment && attachmentActions.refreshAttachments(issueKey);
        return (0, $lkPj1.deleteCommentSuccess)(id);
    }).catch((error)=>{
        (0, $bPG0x.sendExperienceAnalytics)({
            getExperienceDescription: ({ wasSuccessful: wasSuccessful, statusCode: statusCode })=>(0, $4VjGY.commentExperienceDescription)({
                    wasSuccessful: wasSuccessful,
                    action: 'DELETE',
                    analyticsSource: 'commentDeleteEpic',
                    projectType: state.entities.project?.projectType,
                    errorMessage: wasSuccessful ? undefined : error.message,
                    statusCode: statusCode,
                    ...(0, $8Bhia.isJsmTimelineEnabled)() ? {
                        isEventOccurredAtSelected: Boolean(eventOccurredAt),
                        isJsdIncidentActivityViewHidden: Boolean(jsdIncidentActivityViewHidden)
                    } : {}
                }),
            error: error
        });
        return $3d1e726658e8e0b6$var$handleDeleteCommentError(error, id);
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3d1e726658e8e0b6$export$2e2bcd8739ae039 = (attachmentActions)=>(action$, store)=>action$.ofType((0, $lkPj1.DELETE_COMMENT_REQUEST)).mergeMap((action)=>{
            const state = store.getState();
            const commentId = action.payload.id;
            return $3d1e726658e8e0b6$export$2e6e3ad634e3776(state, commentId, attachmentActions);
        });

});
parcelRegister("4VjGY", function(module, exports) {

$parcel$export(module.exports, "commentExperienceDescription", () => $c3187b323866cf66$export$b7c51efc02921c40);
$parcel$export(module.exports, "commentAttachmentExperienceDescription", () => $c3187b323866cf66$export$ae56ee8a8694909c);

var $e91YZ = parcelRequire("e91YZ");

var $1ybV0 = parcelRequire("1ybV0");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");

var $krxpD = parcelRequire("krxpD");
const $c3187b323866cf66$var$commentActionSet = new Set([
    'FETCH_MORE',
    'FETCH_SORTED',
    'FETCH_SURROUNDING'
]);
const $c3187b323866cf66$export$b80ef1f910664ac4 = ({ experience: experience, wasSuccessful: wasSuccessful, action: action, analyticsSource: analyticsSource, projectType: projectType, errorMessage: errorMessage, statusCode: statusCode, isEventOccurredAtSelected: isEventOccurredAtSelected })=>{
    let application = null;
    let edition = null;
    if (projectType !== undefined) try {
        const { appEditions: appEditions } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
        application = (0, $eIp1n.getApplicationForProject)(projectType);
        edition = (0, $6WXNs.getEdition)(application, appEditions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // application and edition already default to null.
    }
    let finalexperience = experience;
    if ((0, $1ybV0.ff)('issue-comment-fetch_9eeal')) finalexperience = $c3187b323866cf66$var$commentActionSet.has(action) ? 'issueCommentFetch' : experience;
    return {
        experience: finalexperience,
        wasExperienceSuccesful: wasSuccessful,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: {
            action: action,
            statusCode: typeof statusCode !== 'undefined' ? statusCode : 0,
            ...errorMessage !== undefined ? {
                errorMessage: errorMessage
            } : null,
            ...(0, $krxpD.isJsmTimelineEnabled)() ? {
                isEventOccurredAtSelected: isEventOccurredAtSelected
            } : null
        }
    };
};
const $c3187b323866cf66$export$b7c51efc02921c40 = (props)=>$c3187b323866cf66$export$b80ef1f910664ac4({
        ...props,
        experience: 'issueComment'
    });
const $c3187b323866cf66$export$ae56ee8a8694909c = (props)=>$c3187b323866cf66$export$b80ef1f910664ac4({
        ...props,
        experience: 'issueCommentAttachment'
    });

});


parcelRegister("6gGgy", function(module, exports) {

$parcel$export(module.exports, "fetchCommentsRequest", () => $b6b4a70f847d6920$export$3ec88f1755444526);
$parcel$export(module.exports, "fetchSortedCommentsRequest", () => $b6b4a70f847d6920$export$4805c80809193e58);
$parcel$export(module.exports, "fetchAttachmentCommentRequest", () => $b6b4a70f847d6920$export$ec1b82984457ac09);
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("3wBUP");
parcelRequire("flmol");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");
var $JRB5w = parcelRequire("JRB5w");

var $k8Qyf = parcelRequire("k8Qyf");

var $8iMV3 = parcelRequire("8iMV3");

var $9WtAE = parcelRequire("9WtAE");

var $4ceCM = parcelRequire("4ceCM");

var $eTy9x = parcelRequire("eTy9x");

var $3A3OQ = parcelRequire("3A3OQ");

var $4VjGY = parcelRequire("4VjGY");

var $gZ3nQ = parcelRequire("gZ3nQ");

var $2QYUh = parcelRequire("2QYUh");

var $277q1 = parcelRequire("277q1");

var $lkPj1 = parcelRequire("lkPj1");

var $khpWz = parcelRequire("khpWz");

var $5JqpU = parcelRequire("5JqpU");

var $dmojD = parcelRequire("dmojD");

var $9s86T = parcelRequire("9s86T");
var $6VKiL = parcelRequire("6VKiL");
const $b6b4a70f847d6920$var$LOG_LOCATION = 'issue.comment.fetch.epic';
const $b6b4a70f847d6920$var$LOG_MESSAGE = 'Failed to fetch comments';
const $b6b4a70f847d6920$var$filter4xxError = (error)=>!((0, $1ybV0.ff)('ken-429-restrict-4xx-error_vi8v7') && error instanceof (0, $7byHA.default) && (0, $JRB5w.isHttpClientErrorResponse)(error));
const $b6b4a70f847d6920$export$1b2d1b88e9280bb4 = (type, commentsStartIndex, totalComments, loadedComments)=>{
    let maxResults = 0;
    let startFetchingFrom = 0;
    if (type === (0, $lkPj1.FETCH_OLDER_COMMENTS_REQUEST)) {
        startFetchingFrom = commentsStartIndex + loadedComments;
        return {
            maxResults: Math.min(totalComments - startFetchingFrom, (0, $eTy9x.NUM_PAGED_ITEMS_TO_LOAD)),
            startAt: startFetchingFrom
        };
    }
    startFetchingFrom = Math.max(0, commentsStartIndex - (0, $eTy9x.NUM_PAGED_ITEMS_TO_LOAD));
    maxResults = commentsStartIndex - startFetchingFrom;
    return {
        maxResults: maxResults,
        startAt: startFetchingFrom
    };
};
const $b6b4a70f847d6920$export$3ec88f1755444526 = (action$, store)=>action$.ofType((0, $lkPj1.FETCH_OLDER_COMMENTS_REQUEST), (0, $lkPj1.FETCH_NEWER_COMMENTS_REQUEST)).switchMap(({ type: type })=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueKey = (0, $5JqpU.issueKeySelector)(state);
        const totalComments = (0, $dmojD.totalCommentsSelector)(state);
        const loadedComments = (0, $dmojD.loadedCommentsSelector)(state);
        const commentsStartIndex = (0, $dmojD.startIndexCommentsSelector)(state);
        const { startAt: startAt, maxResults: maxResults } = $b6b4a70f847d6920$export$1b2d1b88e9280bb4(type, commentsStartIndex, totalComments, loadedComments);
        return (0, $2QYUh.fetchMoreCommentsFromGira)({
            baseUrl: baseUrl,
            issueKey: issueKey,
            maxResults: maxResults,
            startAt: startAt,
            loadedComments: loadedComments,
            commentsStartIndex: commentsStartIndex,
            type: type
        }).map((comments)=>(0, $lkPj1.fetchMoreCommentsSuccess)(comments)).do(()=>{
            if ((0, $1ybV0.ff)('issue-comment-fetch_9eeal')) (0, $4ceCM.sendExperienceAnalytics)((0, $4VjGY.commentExperienceDescription)({
                wasSuccessful: true,
                action: 'FETCH_MORE',
                analyticsSource: 'commentFetchEpic',
                projectType: state.entities.project?.projectType
            }));
        }).catch((error)=>{
            (0, $3A3OQ.trackOrLogClientError)($b6b4a70f847d6920$var$LOG_LOCATION, $b6b4a70f847d6920$var$LOG_MESSAGE, error);
            (0, $gUUjF.default).safeWarnWithoutCustomerData($b6b4a70f847d6920$var$LOG_LOCATION, $b6b4a70f847d6920$var$LOG_MESSAGE);
            if ((0, $1ybV0.ff)('issue-comment-fetch_9eeal')) {
                if ($b6b4a70f847d6920$var$filter4xxError(error)) (0, $4ceCM.sendExperienceAnalytics)((0, $4VjGY.commentExperienceDescription)({
                    wasSuccessful: false,
                    action: 'FETCH_MORE',
                    analyticsSource: 'commentFetchEpic',
                    projectType: state.entities.project?.projectType
                }));
            }
            return (0, $3JafE.Observable).of((0, $lkPj1.fetchMoreCommentsFailure)());
        });
    });
const $b6b4a70f847d6920$export$4805c80809193e58 = (action$, store)=>/* eslint-disable @typescript-eslint/consistent-type-assertions */ action$.ofType((0, $lkPj1.FETCH_SORTED_COMMENTS_REQUEST))/* eslint-enable @typescript-eslint/consistent-type-assertions */ .switchMap(({ payload: commentId })=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueKey = (0, $5JqpU.issueKeySelector)(state);
        if (commentId !== undefined) return (0, $2QYUh.fetchFocusedCommentFromGira)({
            baseUrl: baseUrl,
            issueKey: issueKey,
            commentAmount: Math.floor((0, $eTy9x.NUM_INITIAL_ITEMS_TO_LOAD)),
            commentId: commentId
        }).map((comments)=>(0, $lkPj1.fetchSortedCommentsSuccess)(comments)).do(()=>{
            if ((0, $1ybV0.ff)('issue-comment-fetch_9eeal')) (0, $4ceCM.sendExperienceAnalytics)((0, $4VjGY.commentExperienceDescription)({
                wasSuccessful: true,
                action: 'FETCH_SORTED',
                analyticsSource: 'commentFetchEpic',
                projectType: state.entities.project?.projectType
            }));
        }).catch((error)=>{
            (0, $3A3OQ.trackOrLogClientError)($b6b4a70f847d6920$var$LOG_LOCATION, $b6b4a70f847d6920$var$LOG_MESSAGE, error);
            (0, $gUUjF.default).safeWarnWithoutCustomerData($b6b4a70f847d6920$var$LOG_LOCATION, $b6b4a70f847d6920$var$LOG_MESSAGE);
            if ((0, $1ybV0.ff)('issue-comment-fetch_9eeal')) {
                if ($b6b4a70f847d6920$var$filter4xxError(error)) (0, $4ceCM.sendExperienceAnalytics)((0, $4VjGY.commentExperienceDescription)({
                    wasSuccessful: false,
                    action: 'FETCH_SORTED',
                    analyticsSource: 'commentFetchEpic',
                    projectType: state.entities.project?.projectType
                }));
            }
            return (0, $3JafE.Observable).of((0, $lkPj1.fetchSortedCommentsFailure)());
        });
        return (0, $2QYUh.fetchSortedCommentsFromGira)({
            baseUrl: baseUrl,
            issueKey: issueKey,
            maxResults: (0, $eTy9x.NUM_INITIAL_ITEMS_TO_LOAD)
        }).map((comments)=>(0, $lkPj1.fetchSortedCommentsSuccess)(comments)).do(()=>{
            if ((0, $1ybV0.ff)('issue-comment-fetch_9eeal')) (0, $4ceCM.sendExperienceAnalytics)((0, $4VjGY.commentExperienceDescription)({
                wasSuccessful: true,
                action: 'FETCH_SORTED',
                analyticsSource: 'commentFetchEpic',
                projectType: state.entities.project?.projectType
            }));
        }).catch((error)=>{
            (0, $3A3OQ.trackOrLogClientError)($b6b4a70f847d6920$var$LOG_LOCATION, $b6b4a70f847d6920$var$LOG_MESSAGE, error);
            (0, $gUUjF.default).safeWarnWithoutCustomerData($b6b4a70f847d6920$var$LOG_LOCATION, $b6b4a70f847d6920$var$LOG_MESSAGE);
            if ((0, $1ybV0.ff)('issue-comment-fetch_9eeal')) {
                if ($b6b4a70f847d6920$var$filter4xxError(error)) (0, $4ceCM.sendExperienceAnalytics)((0, $4VjGY.commentExperienceDescription)({
                    wasSuccessful: false,
                    action: 'FETCH_SORTED',
                    analyticsSource: 'commentFetchEpic',
                    projectType: state.entities.project?.projectType
                }));
            }
            return (0, $3JafE.Observable).of((0, $lkPj1.fetchSortedCommentsFailure)());
        });
    });
const $b6b4a70f847d6920$export$ec1b82984457ac09 = (issueScrollAction)=>(action$, store)=>action$.ofType((0, $khpWz.SCROLL_TO_ATTACHMENT_COMMENT)).switchMap(()=>{
            const state = store.getState();
            const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
            const issueKey = (0, $5JqpU.issueKeySelector)(state);
            const commentId = issueScrollAction.getScrollTargetId((0, $9WtAE.SCROLL_TARGET_TYPES).COMMENT);
            // the store does not contain the right scroll target. Abort fetch call to backend
            if (commentId === null) return (0, $3JafE.Observable).of();
            return (0, $2QYUh.fetchFocusedCommentFromGira)({
                baseUrl: baseUrl,
                issueKey: issueKey,
                commentAmount: Math.floor((0, $eTy9x.NUM_INITIAL_ITEMS_TO_LOAD)),
                commentId: commentId
            }).flatMap((comments)=>{
                // modify the url, so that specific commentId can scroll within comment-view.js
                window.history.replaceState({}, // @ts-expect-error - TS2345 - Argument of type 'null' is not assignable to parameter of type 'string'.
                null, (0, $9s86T.getUrlPermalinkParameter)(commentId, (0, $6VKiL.PermalinkType).COMMENTS));
                issueScrollAction.setScrollTarget(null);
                if ((0, $1ybV0.ff)('issue-comment-fetch_9eeal')) (0, $4ceCM.sendExperienceAnalytics)((0, $4VjGY.commentExperienceDescription)({
                    wasSuccessful: true,
                    action: 'FETCH_SURROUNDING',
                    analyticsSource: 'commentFetchEpic',
                    projectType: state.entities.project?.projectType
                }));
                return (0, $3JafE.Observable).of((0, $lkPj1.fetchSortedCommentsSuccess)(comments), // @ts-expect-error - TS2769 - No overload matches this call.
                (0, $277q1.setInitialSelectedActivityItem)((0, $8iMV3.commentActivityItem)), (0, $lkPj1.setCommentScrollStatus)(false));
            }).catch((error)=>{
                (0, $3A3OQ.trackOrLogClientError)($b6b4a70f847d6920$var$LOG_LOCATION, $b6b4a70f847d6920$var$LOG_MESSAGE, error);
                (0, $gUUjF.default).safeWarnWithoutCustomerData($b6b4a70f847d6920$var$LOG_LOCATION, $b6b4a70f847d6920$var$LOG_MESSAGE);
                const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
                const field = 'comment';
                showFlag({
                    type: 'error',
                    title: [
                        (0, $gZ3nQ.default).commentWorklogAttachmentFetchFailedTitle,
                        {
                            field: field
                        }
                    ],
                    description: (0, $gZ3nQ.default).commentWorklogAttachmentFetchFailedDescription,
                    isAutoDismiss: true
                });
                if ((0, $1ybV0.ff)('issue-comment-fetch_9eeal')) {
                    if ($b6b4a70f847d6920$var$filter4xxError(error)) (0, $4ceCM.sendExperienceAnalytics)((0, $4VjGY.commentExperienceDescription)({
                        wasSuccessful: false,
                        action: 'FETCH_SURROUNDING',
                        analyticsSource: 'commentFetchEpic',
                        projectType: state.entities.project?.projectType
                    }));
                }
                return (0, $3JafE.Observable).of();
            });
        });

});
parcelRegister("8iMV3", function(module, exports) {

$parcel$export(module.exports, "commentActivityItem", () => $e3de6249a6569508$export$24b4418eb80deeff);

var $hc60A = parcelRequire("hc60A");

var $cboe8 = parcelRequire("cboe8");
const $e3de6249a6569508$export$24b4418eb80deeff = {
    key: (0, $hc60A.COMMENTS),
    type: (0, $hc60A.COMMENTS),
    name: (0, $cboe8.messages).comments.defaultMessage
};

});
parcelRegister("cboe8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ed8daaa8313003cb$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ed8daaa8313003cb$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    allActivity: {
        "id": "issue-activity-feed.all-activity",
        "defaultMessage": "All"
    },
    comments: {
        "id": "issue-activity-feed.comments",
        "defaultMessage": "Comments"
    },
    history: {
        "id": "issue-activity-feed.history",
        "defaultMessage": "History"
    },
    worklog: {
        "id": "issue-activity-feed.worklog",
        "defaultMessage": "Work log"
    },
    activity: {
        "id": "issue-activity-feed.activity",
        "defaultMessage": "Activity"
    },
    approvals: {
        "id": "issue-activity-feed.approvals",
        "defaultMessage": "Approvals"
    },
    filterBy: {
        "id": "issue-activity-feed.filter-by",
        "defaultMessage": "Show:"
    }
});

});


parcelRegister("2QYUh", function(module, exports) {

$parcel$export(module.exports, "fetchMoreCommentsFromGira", () => $d1df87ff1842a3f7$export$650d1a025206fa00);
$parcel$export(module.exports, "fetchSortedCommentsFromGira", () => $d1df87ff1842a3f7$export$4fd4ede8a56452fc);
$parcel$export(module.exports, "fetchFocusedCommentFromGira", () => $d1df87ff1842a3f7$export$d64209e4ed419069);
parcelRequire("flmol");

var $aiRd8 = parcelRequire("aiRd8");

var $11LM5 = parcelRequire("11LM5");

var $4z02k = parcelRequire("4z02k");

var $bNnKs = parcelRequire("bNnKs");

var $dH8ya = parcelRequire("dH8ya");
const $d1df87ff1842a3f7$var$LOG_LOCATION = 'issue.comment.fetch.epic.graphql';
const $d1df87ff1842a3f7$var$CREATED_ORDER_DESCENDING = '-created';
const $d1df87ff1842a3f7$export$e0844d6c7dd24dee = ({ startAt: startAt, maxResults: maxResults, orderBy: orderBy, commentId: commentId, commentAmount: commentAmount })=>{
    const firstParameter = `first: ${startAt}`;
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const commentIdParameter = commentId !== null && commentId !== undefined ? `, commentId: "${commentId}"` : '';
    const commentAmountParameter = commentIdParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
    const maxResultsParameter = commentIdParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    return `query issueViewCommentPageLoadQuery($issueKey: String!) {
       viewIssue(issueKey: $issueKey) {
           comments (${firstParameter}${maxResultsParameter}${commentAmountParameter}${orderByParameter}${commentIdParameter}) {
               nodes {
                   id
                   author {
                       accountId
                       displayName
                       avatarUrl
                   }
                   updateAuthor {
                       accountId
                       displayName
                       avatarUrl
                   }
                    ${0, $dH8ya.jiraCommentVisibility}
                   created
                   updated
                   jsdPublic
                   bodyAdf
                   ${(0, $4z02k.isOutsiderCommentFFEnabled)() ? 'jsdAuthorCanSeeRequest' : ''}
                   ${(0, $4z02k.isJsmTimelineEnabled)() ? 'eventOccurredAt' : ''} 
                   ${(0, $4z02k.isJsmTimelineEnabled)() ? 'jsdIncidentActivityViewHidden' : ''}
               }
               startIndex
               totalCount
           }
       }
     }
   `;
};
const $d1df87ff1842a3f7$export$df165fd4da821303 = ({ issueKey: issueKey, maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentId: commentId, commentAmount: commentAmount })=>({
        method: 'POST',
        body: JSON.stringify({
            query: $d1df87ff1842a3f7$export$e0844d6c7dd24dee({
                maxResults: maxResults,
                startAt: startAt,
                orderBy: orderBy,
                commentId: commentId,
                commentAmount: commentAmount
            }),
            variables: {
                issueKey: issueKey
            }
        })
    });
const $d1df87ff1842a3f7$export$650d1a025206fa00 = ({ baseUrl: baseUrl, issueKey: issueKey, maxResults: maxResults, startAt: startAt = 0, loadedComments: loadedComments = 0, commentsStartIndex: commentsStartIndex = 0, commentId: commentId, type: type })=>(0, $aiRd8.default)(`${baseUrl}/rest/gira/1/`, $d1df87ff1842a3f7$export$df165fd4da821303({
        issueKey: issueKey,
        maxResults: maxResults,
        startAt: startAt,
        orderBy: $d1df87ff1842a3f7$var$CREATED_ORDER_DESCENDING,
        commentId: commentId
    }))// @ts-expect-error - TS2345 - Argument of type '<T extends ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>(response: GraphqlResponse<T>) => {    data: T;    errors: unknown;}' is not assignable to parameter of type '(value: unknown, index: number) => { data: ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse; errors: unknown; }'.
    .map((0, $11LM5.checkEmptyResponse))// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GraphqlResponse<ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>'.
    .map((response)=>(0, $11LM5.getGraphQlData)($d1df87ff1842a3f7$var$LOG_LOCATION, response)).map((data)=>(0, $bNnKs.transformGiraData)(// @ts-expect-error - TS2339 - Property 'viewIssue' does not exist on type 'ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse'.
        data.viewIssue, loadedComments, commentsStartIndex, type, $d1df87ff1842a3f7$var$CREATED_ORDER_DESCENDING));
const $d1df87ff1842a3f7$export$4fd4ede8a56452fc = ({ baseUrl: baseUrl, issueKey: issueKey, maxResults: maxResults })=>(0, $aiRd8.default)(`${baseUrl}/rest/gira/1/`, $d1df87ff1842a3f7$export$df165fd4da821303({
        issueKey: issueKey,
        maxResults: maxResults,
        startAt: 0,
        orderBy: $d1df87ff1842a3f7$var$CREATED_ORDER_DESCENDING,
        commentId: undefined
    }))// @ts-expect-error - TS2345 - Argument of type '<T extends ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>(response: GraphqlResponse<T>) => {    data: T;    errors: unknown;}' is not assignable to parameter of type '(value: unknown, index: number) => { data: ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse; errors: unknown; }'.
    .map((0, $11LM5.checkEmptyResponse))// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GraphqlResponse<ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>'.
    .map((response)=>(0, $11LM5.getGraphQlData)($d1df87ff1842a3f7$var$LOG_LOCATION, response)).map((data)=>// @ts-expect-error - TS2339 - Property 'viewIssue' does not exist on type 'ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse'.
        (0, $bNnKs.transformGiraData)(data.viewIssue, 0, 0, undefined, $d1df87ff1842a3f7$var$CREATED_ORDER_DESCENDING));
const $d1df87ff1842a3f7$export$d64209e4ed419069 = ({ baseUrl: baseUrl, issueKey: issueKey, commentId: commentId, commentAmount: commentAmount })=>(0, $aiRd8.default)(`${baseUrl}/rest/gira/1/`, $d1df87ff1842a3f7$export$df165fd4da821303({
        issueKey: issueKey,
        commentAmount: commentAmount,
        startAt: 0,
        orderBy: $d1df87ff1842a3f7$var$CREATED_ORDER_DESCENDING,
        commentId: commentId
    }))// @ts-expect-error - TS2345 - Argument of type '<T extends ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>(response: GraphqlResponse<T>) => {    data: T;    errors: unknown;}' is not assignable to parameter of type '(value: unknown, index: number) => { data: ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse; errors: unknown; }'.
    .map((0, $11LM5.checkEmptyResponse))// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GraphqlResponse<ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>'.
    .map((response)=>(0, $11LM5.getGraphQlData)($d1df87ff1842a3f7$var$LOG_LOCATION, response))// @ts-expect-error - TS2339 - Property 'viewIssue' does not exist on type 'ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse'.
    .map((data)=>(0, $bNnKs.transformData)(data.viewIssue));

});
parcelRegister("4z02k", function(module, exports) {

$parcel$export(module.exports, "isOutsiderCommentFFEnabled", () => $0dd9221a0dbba6d3$export$9b34ffa85a930ecd);
$parcel$export(module.exports, "isJsmTimelineEnabled", () => $0dd9221a0dbba6d3$export$575e1bf822db15b5);
$parcel$export(module.exports, "isGiraAGGConsistencyCheckEnabled", () => $0dd9221a0dbba6d3$export$3c97eb4b6ff2fec1);
$parcel$export(module.exports, "isIssueExportControlEnabled", () => $0dd9221a0dbba6d3$export$e92cc7310d059d3e);

var $1ybV0 = parcelRequire("1ybV0");
const $0dd9221a0dbba6d3$export$9b34ffa85a930ecd = ()=>(0, $1ybV0.ff)('display-outsider-comment-field_4x7u7', false);
const $0dd9221a0dbba6d3$export$575e1bf822db15b5 = ()=>(0, $1ybV0.ff)('jsm-timelines-phase-2_70gja', false);
const $0dd9221a0dbba6d3$export$3c97eb4b6ff2fec1 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('issue.details.gira-agg-consistency-check-master-flag', 'OLD', [
        'OLD',
        'NEW',
        'CHECK',
        'CHECK_RETURN_NEW'
    ]) === 'CHECK';
const $0dd9221a0dbba6d3$export$e92cc7310d059d3e = ()=>(0, $1ybV0.ff)('dlp-gordian-enabled', false);

});

parcelRegister("bNnKs", function(module, exports) {

$parcel$export(module.exports, "getQuery", () => $4de24b11136f028f$export$71eec30d9db46a56);
$parcel$export(module.exports, "transformData", () => $4de24b11136f028f$export$3ceb62baab058c6b);
$parcel$export(module.exports, "transformGiraData", () => $4de24b11136f028f$export$11fa85c12b8a8727);

var $1ybV0 = parcelRequire("1ybV0");

var $eTy9x = parcelRequire("eTy9x");

var $4z02k = parcelRequire("4z02k");

var $hhPjP = parcelRequire("hhPjP");

var $dH8ya = parcelRequire("dH8ya");
const $4de24b11136f028f$var$CREATED_ORDER_DESCENDING = '-created';
const $4de24b11136f028f$export$71eec30d9db46a56 = ()=>(0, $dH8ya.getCommentsQuery)((0, $eTy9x.NUM_INITIAL_ITEMS_TO_LOAD), 0, $4de24b11136f028f$var$CREATED_ORDER_DESCENDING, (0, $4z02k.isOutsiderCommentFFEnabled)());
const $4de24b11136f028f$export$3ceb62baab058c6b = (issue)=>{
    const { comments: comments } = issue;
    if (!comments) return {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        users: {},
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        comments: {},
        totalComments: 0,
        commentsStartIndex: 0,
        loadedComments: 0
    };
    const { totalCount: totalComments, startIndex: commentsStartIndex } = comments;
    const response = {
        data: {
            issueComments: comments
        }
    };
    return {
        ...(0, $hhPjP.normalizeComments)((0, $hhPjP.transformComments)(response), 0, commentsStartIndex),
        totalComments: totalComments,
        commentsStartIndex: commentsStartIndex
    };
};
const $4de24b11136f028f$export$11fa85c12b8a8727 = (issue, loadedComments, commentsStartIndex, type, orderBy)=>{
    const emptyComments = {
        users: {},
        comments: {},
        totalComments: 0,
        commentsStartIndex: 0,
        loadedComments: 0
    };
    if ((0, $1ybV0.ff)('catch-issue-comments-empty-response-errors_o2gkc') && issue?.comments == null) return emptyComments;
    // TODO: Remove below lines when cleaning up catch-issue-comments-empty-response-errors_o2gkc FF as above condition covers both cases
    // @ts-expect-error - Property 'comments' does not exist on type 'ViewIssueData | null'
    const { comments: comments } = issue;
    if (!comments) return emptyComments;
    const { totalCount: totalComments } = comments;
    const response = {
        data: {
            issueComments: comments
        }
    };
    return {
        ...(0, $hhPjP.normalizeGiraComments)((0, $hhPjP.transformComments)(response), loadedComments, commentsStartIndex, type, orderBy),
        totalComments: totalComments
    };
};

});
parcelRegister("hhPjP", function(module, exports) {

$parcel$export(module.exports, "transformComment", () => $9de50237bfd6dbbb$export$f6e85761e2e2b7d7);
$parcel$export(module.exports, "transformJiraCommentVisibility", () => $9de50237bfd6dbbb$export$d6420884ced7f774);
$parcel$export(module.exports, "transformComments", () => $9de50237bfd6dbbb$export$bcf31797782cb093);
$parcel$export(module.exports, "normalizeComment", () => $9de50237bfd6dbbb$export$3ae47ac75ea0ca01);
$parcel$export(module.exports, "normalizeComments", () => $9de50237bfd6dbbb$export$5b6423f1622a7d75);
$parcel$export(module.exports, "normalizeGiraComments", () => $9de50237bfd6dbbb$export$f4485204d0ed4471);

var $hlEc1 = parcelRequire("hlEc1");

var $gUUjF = parcelRequire("gUUjF");


var $f6MOn = parcelRequire("f6MOn");

var $lkPj1 = parcelRequire("lkPj1");

var $7Vbpp = parcelRequire("7Vbpp");

var $4z02k = parcelRequire("4z02k");

var $1OM81 = parcelRequire("1OM81");

var $blHvU = parcelRequire("blHvU");
const $9de50237bfd6dbbb$var$LOG_LOCATION = 'issue.transform.comment';
const $9de50237bfd6dbbb$var$CREATED_ORDER_DESCENDING = '-created';
const $9de50237bfd6dbbb$export$1473b79d5dab5134 = ({ type: type, value: value, identifier: identifier })=>{
    switch(type){
        case 0, $b9bd3ab49fd3c4c9$export$537a061b2f9c8800:
            return {
                value: value,
                type: type,
                groupId: identifier
            };
        case 0, $b9bd3ab49fd3c4c9$export$28a8bb936dce2def:
            return {
                value: value,
                type: type
            };
        default:
            {
                const message = `transformCommentVisibility: unknown comment visibility type received '${type}'`;
                (0, $gUUjF.default).safeErrorWithoutCustomerData($9de50237bfd6dbbb$var$LOG_LOCATION, message, new Error(message));
                return {
                    value: value,
                    type: (0, $b9bd3ab49fd3c4c9$export$28a8bb936dce2def)
                };
            }
    }
};
const $9de50237bfd6dbbb$export$f6e85761e2e2b7d7 = (comment)=>({
        id: comment.id,
        author: comment.author ? (0, $blHvU.transformUser)(comment.author) : null,
        updateAuthor: comment.updateAuthor ? (0, $blHvU.transformUser)(comment.updateAuthor) : null,
        bodyAdf: comment.body,
        bodyHtml: undefined,
        visibility: comment.visibility ? $9de50237bfd6dbbb$export$1473b79d5dab5134(comment.visibility) : null,
        createdDate: (0, $hlEc1.default)(comment.created),
        updatedDate: comment.updated ? (0, $hlEc1.default)(comment.updated) : null,
        edited: !!comment.updated && comment.updated !== comment.created,
        isInternal: !comment.jsdPublic,
        outsideComment: comment.outsideComment ?? false,
        ...(0, $4z02k.isJsmTimelineEnabled)() ? {
            eventOccurredAt: comment.eventTime,
            jsdIncidentActivityViewHidden: comment.hidden
        } : {}
    });
const $9de50237bfd6dbbb$export$d6420884ced7f774 = (node)=>{
    switch(node.__typename){
        case 0, $bfa3e4436702f51f$export$5a7c166ea3706e65:
            return {
                type: (0, $b9bd3ab49fd3c4c9$export$537a061b2f9c8800),
                groupId: node.group.groupId,
                value: node.group.name
            };
        case 0, $bfa3e4436702f51f$export$5c1bc3a6c47faaf9:
            return {
                type: (0, $b9bd3ab49fd3c4c9$export$28a8bb936dce2def),
                value: node.name
            };
        default:
            {
                const message = `transformJiraCommentVisibility: unknown comment visibility type received '${node.__typename}'`;
                (0, $gUUjF.default).safeErrorWithoutCustomerData($9de50237bfd6dbbb$var$LOG_LOCATION, message, new Error(message));
                return {
                    type: (0, $b9bd3ab49fd3c4c9$export$28a8bb936dce2def),
                    value: node.name
                };
            }
    }
};
const $9de50237bfd6dbbb$export$3bfb0e64ca7b89d8 = ({ id: id, author: author, updateAuthor: updateAuthor, jiraCommentVisibility: jiraCommentVisibility, created: created, updated: updated, bodyAdf: bodyAdf, renderedBody: renderedBody, jsdPublic: jsdPublic, jsdAuthorCanSeeRequest: jsdAuthorCanSeeRequest, eventOccurredAt: eventOccurredAt, jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden })=>({
        id: id,
        author: author ? (0, $blHvU.transformGraphQlUser)(author) : null,
        updateAuthor: updateAuthor ? (0, $blHvU.transformGraphQlUser)(updateAuthor) : null,
        visibility: jiraCommentVisibility ? $9de50237bfd6dbbb$export$d6420884ced7f774(jiraCommentVisibility) : null,
        createdDate: (0, $hlEc1.default)(created),
        updatedDate: updated ? (0, $hlEc1.default)(updated) : null,
        edited: !!updated && updated !== created,
        bodyAdf: (0, $7Vbpp.convertAdfStringToObject)(bodyAdf),
        bodyHtml: renderedBody,
        isInternal: !jsdPublic,
        jsdAuthorCanSeeRequest: jsdAuthorCanSeeRequest,
        ...(0, $4z02k.isJsmTimelineEnabled)() ? {
            eventOccurredAt: eventOccurredAt
        } : {},
        ...(0, $4z02k.isJsmTimelineEnabled)() ? {
            jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden
        } : {}
    });
const $9de50237bfd6dbbb$export$bcf31797782cb093 = (responseData)=>{
    const comments = responseData.data.issueComments.nodes;
    return {
        comments: comments.map((comment)=>$9de50237bfd6dbbb$export$3bfb0e64ca7b89d8(comment)),
        totalComments: responseData.data.issueComments.totalCount
    };
};
const $9de50237bfd6dbbb$export$3ae47ac75ea0ca01 = (comment)=>{
    const authorId = comment.author ? comment.author.id : null;
    const updateAuthorId = comment.updateAuthor ? comment.updateAuthor.id : null;
    const commentJsmTimelineProps = (0, $4z02k.isJsmTimelineEnabled)() ? {
        eventOccurredAt: comment.eventOccurredAt,
        jsdIncidentActivityViewHidden: comment.jsdIncidentActivityViewHidden
    } : {};
    const getCommentVisibility = ()=>comment.visibility ?? (0, $f6MOn.COMMENT_VISIBILITY_PUBLIC);
    return {
        id: comment.id,
        authorId: authorId,
        updateAuthorId: updateAuthorId,
        bodyAdf: comment.bodyAdf,
        bodyHtml: comment.bodyHtml,
        createdDate: comment.createdDate,
        updatedDate: comment.updatedDate,
        edited: comment.edited,
        visibility: getCommentVisibility(),
        isInternal: comment.isInternal,
        jsdAuthorCanSeeRequest: comment.jsdAuthorCanSeeRequest,
        ...commentJsmTimelineProps
    };
};
const $9de50237bfd6dbbb$export$cbcdba95478e8fd6 = (comments)=>{
    const users = comments.filter((comment)=>comment.updateAuthor || comment.author).reduce((accumulator, { author: author, updateAuthor: updateAuthor })=>{
        if (author) accumulator.push(author);
        if (updateAuthor) accumulator.push(updateAuthor);
        return accumulator;
    }, []);
    const normalizedUsers = (0, $1OM81.normalizeItemArray)(users, 'id');
    return normalizedUsers;
};
const $9de50237bfd6dbbb$export$5b6423f1622a7d75 = (rawComments, loadedComments, commentsStartIndex, type)=>{
    const { comments: comments } = rawComments;
    const normalizedUsers = $9de50237bfd6dbbb$export$cbcdba95478e8fd6(comments);
    const newStartIndex = Math.max(type === (0, $lkPj1.FETCH_NEWER_COMMENTS_REQUEST) ? commentsStartIndex - comments.length : commentsStartIndex, 0);
    return {
        users: normalizedUsers,
        comments: (0, $1OM81.normalizeItemArray)(comments.map($9de50237bfd6dbbb$export$3ae47ac75ea0ca01), 'id'),
        loadedComments: loadedComments + comments.length,
        commentsStartIndex: newStartIndex,
        totalComments: rawComments.totalComments
    };
};
const $9de50237bfd6dbbb$export$f4485204d0ed4471 = (rawComments, loadedComments, commentsStartIndex, type, orderBy)=>{
    const { comments: comments } = rawComments;
    let newStartIndex;
    if (type === (0, $lkPj1.FETCH_NEWER_COMMENTS_REQUEST)) newStartIndex = Math.max(orderBy === $9de50237bfd6dbbb$var$CREATED_ORDER_DESCENDING ? commentsStartIndex - comments.length : commentsStartIndex, 0);
    else newStartIndex = Math.max(orderBy === $9de50237bfd6dbbb$var$CREATED_ORDER_DESCENDING ? commentsStartIndex : commentsStartIndex - comments.length, 0);
    const normalizedUsers = $9de50237bfd6dbbb$export$cbcdba95478e8fd6(comments);
    return {
        users: normalizedUsers,
        comments: (0, $1OM81.normalizeItemArray)(comments.map($9de50237bfd6dbbb$export$3ae47ac75ea0ca01), 'id'),
        loadedComments: loadedComments + comments.length,
        commentsStartIndex: newStartIndex,
        totalComments: rawComments.totalComments
    };
};

});
parcelRegister("hlEc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1784e41866c4789$export$2e2bcd8739ae039);

var $3xcI8 = parcelRequire("3xcI8");

var $kyEKc = parcelRequire("kyEKc");
var // IE 11 and Safari can't recognize date format '2013-04-19T18:26:46.396+0000' provided by JIRA
// so we convert it to format '2013-05-03T08:36:14.787Z'
// eslint-disable-next-line jira/import/no-anonymous-default-export
$f1784e41866c4789$export$2e2bcd8739ae039 = (dateString)=>{
    if (dateString === null) return dateString;
    const parsedDate = typeof dateString === 'string' ? (0, $3xcI8.default)(dateString) : (0, $kyEKc.default)(dateString);
    return parsedDate.toISOString();
};

});

const $bfa3e4436702f51f$export$5a7c166ea3706e65 = 'JiraGroupVisibility';
const $bfa3e4436702f51f$export$5c1bc3a6c47faaf9 = 'JiraRoleVisibility';

parcelRegister("1OM81", function(module, exports) {

$parcel$export(module.exports, "normalizeItemArray", () => $7ef623ea717e50bc$export$5bd0cd6e0fd0812c);
const $7ef623ea717e50bc$export$511d6032b747bf81 = (fields, typename)=>fields.find((f)=>f.__typename === typename);
const $7ef623ea717e50bc$export$5bd0cd6e0fd0812c = (items, key)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const normalizedItems = {};
    items.forEach((item)=>{
        normalizedItems[item[key]] = item;
    });
    return normalizedItems;
};

});

parcelRegister("blHvU", function(module, exports) {

$parcel$export(module.exports, "transformUser", () => $3260d4c678444afb$export$88dcd5c1adae8021);
$parcel$export(module.exports, "transformGraphQlUser", () => $3260d4c678444afb$export$197fbb5d2f8387eb);
$parcel$export(module.exports, "validateUser", () => $3260d4c678444afb$export$b524a674cf218100);

var $2KlF4 = parcelRequire("2KlF4");

var $6G5mG = parcelRequire("6G5mG");

var $gXRLI = parcelRequire("gXRLI");

var $6vrw7 = parcelRequire("6vrw7");
const $3260d4c678444afb$var$requiredKeys = [
    'accountId',
    'displayName',
    'avatarUrls',
    'timeZone'
];
const $3260d4c678444afb$export$88dcd5c1adae8021 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, timeZone: timeZone })=>({
        displayName: displayName,
        id: (0, $6vrw7.toAccountId)(accountId),
        avatarUrl: avatarUrls['48x48'],
        timeZone: timeZone
    });
const $3260d4c678444afb$export$197fbb5d2f8387eb = (user)=>{
    const { accountId: accountId, displayName: displayName, avatarUrl: avatarUrl, timeZone: timeZone } = user;
    return {
        avatarUrl: avatarUrl,
        displayName: displayName,
        id: accountId,
        ...timeZone ? {
            timeZone: timeZone
        } : {}
    };
};
const $3260d4c678444afb$export$b524a674cf218100 = (nullableResponse)=>{
    if (!nullableResponse) throw new Error('User is null or undefined');
    const hasExpectedKeys = nullableResponse && (0, (/*@__PURE__*/$parcel$interopDefault($2KlF4)))($3260d4c678444afb$var$requiredKeys, (0, (/*@__PURE__*/$parcel$interopDefault($gXRLI)))((0, (/*@__PURE__*/$parcel$interopDefault($6G5mG))), nullableResponse));
    if (!hasExpectedKeys) throw new Error(`User object is not expected shape, keys present: ${Object.keys(nullableResponse).toString()}`);
    return nullableResponse;
};

});
parcelRegister("2KlF4", function(module, exports) {

var $fuUNm = parcelRequire("fuUNm");

var $l2K2N = parcelRequire("l2K2N");

var $7qARj = parcelRequire("7qARj");

var $1c8hB = parcelRequire("1c8hB");

var $3P7i5 = parcelRequire("3P7i5");
/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $2000ae291c2bb480$var$every(collection, predicate, guard) {
    var func = $1c8hB(collection) ? $fuUNm : $l2K2N;
    if (guard && $3P7i5(collection, predicate, guard)) predicate = undefined;
    return func(collection, $7qARj(predicate, 3));
}
module.exports = $2000ae291c2bb480$var$every;

});
parcelRegister("fuUNm", function(module, exports) {
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $b485b6aabeb272f0$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
module.exports = $b485b6aabeb272f0$var$arrayEvery;

});

parcelRegister("l2K2N", function(module, exports) {

var $awetI = parcelRequire("awetI");
/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $f51d8043a179edd0$var$baseEvery(collection, predicate) {
    var result = true;
    $awetI(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
module.exports = $f51d8043a179edd0$var$baseEvery;

});


parcelRegister("gXRLI", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $xQ3hV = parcelRequire("xQ3hV");

var $9xQzO = parcelRequire("9xQzO");

var $kBgrU = parcelRequire("kBgrU");
/** Used to compose bitmasks for function metadata. */ var $c59bdd58073a6964$var$WRAP_PARTIAL_FLAG = 32;
/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */ var $c59bdd58073a6964$var$partial = $9eFtX(function(func, partials) {
    var holders = $kBgrU(partials, $9xQzO($c59bdd58073a6964$var$partial));
    return $xQ3hV(func, $c59bdd58073a6964$var$WRAP_PARTIAL_FLAG, undefined, partials, holders);
});
// Assign default placeholders.
$c59bdd58073a6964$var$partial.placeholder = {};
module.exports = $c59bdd58073a6964$var$partial;

});



parcelRegister("dH8ya", function(module, exports) {

$parcel$export(module.exports, "jiraCommentVisibility", () => $80bb55482a0539f3$export$6c5bfd6f86c70c22);
$parcel$export(module.exports, "getCommentsQuery", () => $80bb55482a0539f3$export$f97b33aeea757b6e);
$parcel$export(module.exports, "commentVisibilitiesQuery", () => $80bb55482a0539f3$export$21eb8040ac826961);
parcelRequire("9s86T");
var $6VKiL = parcelRequire("6VKiL");
var $9s86T = parcelRequire("9s86T");
const $80bb55482a0539f3$var$commentParameter = ()=>{
    const { hasPermalink: hasPermalink, permalinkId: permalinkId } = (0, $9s86T.getPermalinkStatus)((0, $6VKiL.COMMENTS));
    return hasPermalink ? `commentId: ${permalinkId}` : '';
};
const $80bb55482a0539f3$export$6c5bfd6f86c70c22 = ` jiraCommentVisibility {
  __typename
  ...on JiraRoleVisibility {
    name
  }
  ...on JiraGroupVisibility {
    group {
      groupId
      name
    }
  }
}`;
const $80bb55482a0539f3$export$f97b33aeea757b6e = (maxResults, startAt, orderBy, isOutsiderCommentEnabled)=>`
    comments (first: ${startAt}, maxResults: ${maxResults}, orderBy: "${orderBy}",${$80bb55482a0539f3$var$commentParameter()}) {
        nodes {
            id
            author {
                accountId
                displayName
                avatarUrl
            }
            updateAuthor {
                accountId
                displayName
                avatarUrl
            }
            ${$80bb55482a0539f3$export$6c5bfd6f86c70c22}
            created
            updated
            renderedBody
            jsdPublic
            bodyAdf
            ${isOutsiderCommentEnabled ? 'jsdAuthorCanSeeRequest' : ''}
        }
        totalCount
        startIndex
    }
`;
const $80bb55482a0539f3$var$jiraCommentVisibilities = `
jiraCommentVisibilities {
    edges {
      node {
        __typename
        ...on JiraRoleVisibility {
          name
        }
        ...on JiraGroupVisibility {
          group {
            groupId
            name
          }
        }
      }
    }
  }
`;
const $80bb55482a0539f3$export$21eb8040ac826961 = `
query CommentVisibilitiesQuery($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        ${$80bb55482a0539f3$var$jiraCommentVisibilities}
    }
}
`;

});




parcelRegister("biesR", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd30e85fa11eb234$export$2e2bcd8739ae039);
parcelRequire("YLEHo");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $df9H8 = parcelRequire("df9H8");

var $b1qLQ = parcelRequire("b1qLQ");

var $gA9Fk = parcelRequire("gA9Fk");
var $3A3OQ = parcelRequire("3A3OQ");

var $lkPj1 = parcelRequire("lkPj1");

var $fYteL = parcelRequire("fYteL");

var $5JqpU = parcelRequire("5JqpU");

var $gZSrt = parcelRequire("gZSrt");

var $eW7lD = parcelRequire("eW7lD");

var $dmojD = parcelRequire("dmojD");
// @ts-expect-error - TS2304 - Cannot find name 'CommentId'.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cd30e85fa11eb234$var$getDraftHandler = (useDraftHandler, commentId, action)=>useDraftHandler && commentId === action.payload.id ? (0, $lkPj1.editCommentUpdate) : null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cd30e85fa11eb234$var$loadCommentDrafts = (action, state, useDraftHandler)=>{
    const loggedInAccountId = (0, $5JqpU.accountIdloggedInUserSelector)(state);
    const issueKey = (0, $5JqpU.issueKeySelector)(state);
    const commentIds = (0, $dmojD.commentIdsSelector)(state);
    return commentIds.map((commentId)=>{
        const id = (0, $eW7lD.createCommentDraftKey)(commentId);
        const draftKey = (0, $eW7lD.getDraftKey)(loggedInAccountId, issueKey, id);
        const commentContent = (0, $dmojD.commentBodyHtmlSelector)(commentId)(state);
        const commentContentNotNull = commentContent != null ? commentContent : undefined;
        return (0, $3JafE.Observable).of((0, $gZSrt.loadDraftRequest)(commentId, draftKey, $cd30e85fa11eb234$var$getDraftHandler(useDraftHandler, commentId, action), commentContentNotNull));
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cd30e85fa11eb234$var$errorHandler = (error)=>{
    (0, $3A3OQ.trackOrLogClientError)('issue.comment-load-draft', error.message, error);
    return (0, $3JafE.Observable).empty();
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cd30e85fa11eb234$var$commentEpicWithDraftHander = (action$, store)=>action$.ofType((0, $lkPj1.EDIT_COMMENT_BEGIN)).mergeMap((action)=>(0, $3JafE.Observable).merge(...$cd30e85fa11eb234$var$loadCommentDrafts(action, store.getState(), true))).catch((error)=>$cd30e85fa11eb234$var$errorHandler(error));
const $cd30e85fa11eb234$var$commentEpicWithoutDraftHandler = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
action$, store)=>action$.pipe((0, $gA9Fk.ofTypeOrBatchType)((0, $fYteL.FETCH_ISSUE_SUCCESS), (0, $fYteL.REFRESH_ISSUE_SUCCESS), (0, $lkPj1.FETCH_MORE_COMMENTS_SUCCESS)), (0, $b1qLQ.mergeMap)((action)=>// @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2339 - Property 'comments' does not exist on type 'Record<any, any> | Record<any, any>[]'.
        !action.payload.comments ? (0, $3JafE.Observable).empty() : (0, $3JafE.Observable).merge(...$cd30e85fa11eb234$var$loadCommentDrafts(action, store.getState(), false))), (0, $df9H8.catchError)((error)=>$cd30e85fa11eb234$var$errorHandler(error)));
var $cd30e85fa11eb234$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)($cd30e85fa11eb234$var$commentEpicWithDraftHander, $cd30e85fa11eb234$var$commentEpicWithoutDraftHandler);

});

parcelRegister("lLyah", function(module, exports) {

$parcel$export(module.exports, "default", () => $caa65e9953b5dafe$export$2e2bcd8739ae039);
parcelRequire("8OtG5");
parcelRequire("dfsI8");

var $lkPj1 = parcelRequire("lkPj1");

var $hlJEN = parcelRequire("hlJEN");
const $caa65e9953b5dafe$var$fetchViewContextOnSaveCommentSuccess = (action$)=>action$.ofType((0, $lkPj1.SAVE_COMMENT_SUCCESS))// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    .filter((action)=>action.meta.shouldFetchViewContext).mapTo((0, $hlJEN.fetchViewContextRequest)());
var $caa65e9953b5dafe$export$2e2bcd8739ae039 = $caa65e9953b5dafe$var$fetchViewContextOnSaveCommentSuccess;

});

parcelRegister("eG1fU", function(module, exports) {

$parcel$export(module.exports, "default", () => $10b2204c25842beb$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("3wBUP");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $3A3OQ = parcelRequire("3A3OQ");

var $lkPj1 = parcelRequire("lkPj1");

var $gZSrt = parcelRequire("gZSrt");

var $eW7lD = parcelRequire("eW7lD");

var $dmojD = parcelRequire("dmojD");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $10b2204c25842beb$var$processEditForSaving = (action, state)=>{
    const { payload: { id: id, value: value } } = action;
    const commentContent = (0, $dmojD.commentBodyHtmlSelector)(id)(state);
    // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
    const commentContentNotNull = commentContent;
    return (0, $3JafE.Observable).of((0, $gZSrt.saveDraftRequest)((0, $eW7lD.createCommentDraftKey)(id), value, commentContentNotNull));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $10b2204c25842beb$var$errorHandler = (error)=>{
    (0, $3A3OQ.trackOrLogClientError)('issue.comment-save-draft', error.message, error);
    return (0, $3JafE.Observable).empty();
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$10b2204c25842beb$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $lkPj1.EDIT_COMMENT_UPDATE)).switchMap((action)=>$10b2204c25842beb$var$processEditForSaving(action, store.getState())).catch((error)=>$10b2204c25842beb$var$errorHandler(error));

});

parcelRegister("8qtAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2af628f775b1fe25$export$2e2bcd8739ae039);
parcelRequire("9u6v2");
parcelRequire("jAXdN");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("3GQRI");
parcelRequire("6WUHA");
parcelRequire("iects");
parcelRequire("1Lcr1");
parcelRequire("flmol");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");


var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");
var $aiRd8 = parcelRequire("aiRd8");

var $bPG0x = parcelRequire("bPG0x");
parcelRequire("f6MOn");

var $3A3OQ = parcelRequire("3A3OQ");

var $kiT8o = parcelRequire("kiT8o");

var $4VjGY = parcelRequire("4VjGY");

var $cxdSy = parcelRequire("cxdSy");

var $8Bhia = parcelRequire("8Bhia");

var $hhPjP = parcelRequire("hhPjP");

var $chq8S = parcelRequire("chq8S");

var $lkPj1 = parcelRequire("lkPj1");

var $hlJEN = parcelRequire("hlJEN");

var $5JqpU = parcelRequire("5JqpU");

var $dmojD = parcelRequire("dmojD");

var $7Vbpp = parcelRequire("7Vbpp");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2af628f775b1fe25$var$retrySaveComment = (action$, store)=>action$.ofType((0, $lkPj1.SAVE_COMMENT_RETRY)).map((action)=>{
        const state = store.getState();
        const { optimisticId: optimisticId, isNewComment: isNewComment } = action.payload;
        // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
        return (0, $lkPj1.saveCommentRequest)({
            ...(0, $dmojD.pendingCommentSelector)(optimisticId)(state),
            isNewComment: isNewComment
        });
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2af628f775b1fe25$var$getSaveUrl = (store, commentId, isNewComment)=>{
    const state = store.getState();
    const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
    const issueKey = (0, $5JqpU.issueKeySelector)(state);
    return (0, $chq8S.getSaveAdfCommentUrl)({
        baseUrl: baseUrl,
        issueKey: issueKey,
        id: commentId,
        isNewComment: isNewComment
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2af628f775b1fe25$var$getServiceDeskCommentProperties = (store, commentId)=>{
    const state = store.getState();
    if ((0, $5JqpU.isServiceDeskSelector)(state)) {
        const isInternal = (0, $dmojD.isEditingInternalCommentSelector)(commentId)(state);
        return {
            properties: [
                {
                    key: 'sd.public.comment',
                    value: {
                        internal: isInternal
                    }
                }
            ]
        };
    }
    return {};
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2af628f775b1fe25$var$getVisibilityOption = (store, visibility)=>{
    if ((0, $dmojD.isCommentVisibilityRestrictionSupportedSelector)(store.getState())) /**
		 * Refer to https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-issue-comments#api-rest-api-3-issue-issueidorkey-comment-post
		 * for using identifier instead of value
		 */ switch(visibility.type){
        case 0, $b9bd3ab49fd3c4c9$export$28a8bb936dce2def:
            // Role name is an acceptable identifier
            return {
                visibility: {
                    identifier: visibility.value,
                    type: visibility.type
                }
            };
        case 0, $b9bd3ab49fd3c4c9$export$537a061b2f9c8800:
            return {
                visibility: {
                    identifier: visibility.groupId,
                    type: visibility.type
                }
            };
        case 0, $b9bd3ab49fd3c4c9$export$a3863626f98a38c2:
        default:
            return {
                visibility: null
            };
    }
    return {};
};
const $2af628f775b1fe25$var$getFetchOptions = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
store, commentId, bodyAdf, isNewComment, visibility, eventOccurredAt, jsdIncidentActivityViewHidden)=>{
    const commentProperties = $2af628f775b1fe25$var$getServiceDeskCommentProperties(store, commentId);
    const visibilityOption = $2af628f775b1fe25$var$getVisibilityOption(store, visibility);
    return {
        method: isNewComment ? 'POST' : 'PUT',
        body: JSON.stringify({
            body: bodyAdf,
            ...commentProperties,
            ...visibilityOption,
            ...(0, $8Bhia.isJsmTimelineEnabled)() ? {
                eventTime: eventOccurredAt
            } : {},
            ...(0, $8Bhia.isJsmTimelineEnabled)() ? {
                hidden: jsdIncidentActivityViewHidden
            } : {}
        })
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2af628f775b1fe25$var$extractFetchErrorMessage = (error)=>{
    if (error.statusCode === (0, $1c3fbb431a173cc6$export$f90ac1df0b60853d)) {
        if ((0, $1ybV0.ff)('comment-limit-exceed-warning-flag_3rx53') || (0, $1ybV0.ff)('issue.details.hard-limits.issue-attachments-limit')) return (0, $cxdSy.getIssueLimitErrorField)(error);
    }
    if (error instanceof (0, $7byHA.default) && error.message) try {
        const json = JSON.parse(error.message);
        if ((0, $8Bhia.isJsmTimelineEnabled)() && json.errorMessages.length === 0 && json.errors && json.errors.comment) return json.errors.comment;
        return json.errorMessages ? json.errorMessages.join('; ') : undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $3A3OQ.trackOrLogClientError)('issue.save.comment', 'Failed to parse FetchError', e);
        return undefined;
    }
    return undefined;
};
const $2af628f775b1fe25$var$saveComment = (store, { id: id, bodyAdf: bodyAdf, isNewComment: isNewComment, analyticsEvent: analyticsEvent, visibility: visibility, jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden, eventOccurredAt: eventOccurredAt, fullIssueUrl: fullIssueUrl, triggerIncidentSaveCommentFlag: triggerIncidentSaveCommentFlag }, // @ts-expect-error - TS7031 - Binding element 'shouldFetchViewContext' implicitly has an 'any' type.
{ shouldFetchViewContext: shouldFetchViewContext })=>(0, $aiRd8.default)($2af628f775b1fe25$var$getSaveUrl(store, id, isNewComment), $2af628f775b1fe25$var$getFetchOptions(store, id, bodyAdf, isNewComment, visibility, eventOccurredAt, jsdIncidentActivityViewHidden)).map((0, $hhPjP.transformComment)).map((0, $hhPjP.normalizeComment)).map((comment)=>{
        (0, $bPG0x.sendExperienceAnalytics)({
            getExperienceDescription: ()=>(0, $4VjGY.commentExperienceDescription)({
                    wasSuccessful: true,
                    action: isNewComment ? 'ADD' : 'EDIT',
                    analyticsSource: 'commentSaveEpic',
                    projectType: store.getState().entities.project?.projectType,
                    ...(0, $8Bhia.isJsmTimelineEnabled)() ? {
                        isEventOccurredAtSelected: Boolean(eventOccurredAt),
                        isJsdIncidentActivityViewHidden: Boolean(jsdIncidentActivityViewHidden)
                    } : {}
                })
        });
        return (0, $lkPj1.saveCommentSuccess)(comment, id, isNewComment, analyticsEvent, {
            shouldFetchViewContext: shouldFetchViewContext
        }, (0, $8Bhia.isJsmTimelineEnabled)() ? eventOccurredAt : undefined, (0, $8Bhia.isJsmTimelineEnabled)() ? jsdIncidentActivityViewHidden : undefined, (0, $8Bhia.isJsmTimelineEnabled)() ? fullIssueUrl : undefined, (0, $8Bhia.isJsmTimelineEnabled)() ? triggerIncidentSaveCommentFlag : undefined);
    }).catch((error)=>{
        (0, $bPG0x.sendExperienceAnalytics)({
            getExperienceDescription: ({ wasSuccessful: wasSuccessful, statusCode: statusCode })=>{
                if (!wasSuccessful) (0, $3A3OQ.trackOrLogClientError)('issue.save.comment', 'Failed to save a comment', error);
                return (0, $4VjGY.commentExperienceDescription)({
                    wasSuccessful: wasSuccessful,
                    action: isNewComment ? 'ADD' : 'EDIT',
                    analyticsSource: 'commentSaveEpic',
                    projectType: store.getState().entities.project?.projectType,
                    statusCode: statusCode,
                    ...(0, $8Bhia.isJsmTimelineEnabled)() ? {
                        isEventOccurredAtSelected: Boolean(eventOccurredAt),
                        isJsdIncidentActivityViewHidden: Boolean(jsdIncidentActivityViewHidden)
                    } : {}
                });
            },
            error: error
        });
        return (0, $3JafE.Observable).of((0, $lkPj1.saveCommentFailure)({
            optimisticId: id,
            isServerValidationError: error ? error.statusCode === (0, $1c3fbb431a173cc6$export$9de493bcd9b1d977) : false,
            invalidMessage: $2af628f775b1fe25$var$extractFetchErrorMessage(error)
        }));
    });
const $2af628f775b1fe25$var$saveCommentAndUpdateIsCommentSupportedEpic = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
action$, store)=>action$.ofType((0, $lkPj1.SAVE_COMMENT_REQUEST)).groupBy((action)=>action.payload.comment.id).mergeMap((saveCommentRequest$)=>saveCommentRequest$.concatMap((saveCommentRequestAction)=>{
            const { id: id, bodyAdf: bodyAdf, isNewComment: isNewComment, visibility: visibility, eventOccurredAt: eventOccurredAt, jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden, fullIssueUrl: fullIssueUrl, triggerIncidentSaveCommentFlag: triggerIncidentSaveCommentFlag } = saveCommentRequestAction.payload.comment;
            const { analyticsEvent: analyticsEvent } = saveCommentRequestAction.payload;
            if (!bodyAdf || (0, $7Vbpp.isOnlyWhitespaceAdf)(bodyAdf)) return (0, $3JafE.Observable).empty();
            let shouldFetchViewContext = false;
            if (isNewComment) shouldFetchViewContext = (0, $7Vbpp.hasMediaFileNodes)(bodyAdf);
            else {
                const comment = (0, $dmojD.entitiesCommentsSelector)(store.getState());
                shouldFetchViewContext = (0, $7Vbpp.hasMediaFileNodesUpdated)(comment[id].bodyAdf, bodyAdf);
            }
            if (shouldFetchViewContext) // @ts-expect-error - Argument of type '{ type: "MARK_TOKEN_AS_OUTDATED"; }' is not assignable to parameter of type 'Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: MyPreferences | undefined; }>; ... 5 more ...; validators: Validators; }>'.
            store.dispatch((0, $hlJEN.markTokenAsOutdated)());
            const jsmTimelineComponents = (0, $8Bhia.isJsmTimelineEnabled)() ? {
                eventOccurredAt: eventOccurredAt,
                jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden,
                fullIssueUrl: fullIssueUrl,
                triggerIncidentSaveCommentFlag: triggerIncidentSaveCommentFlag
            } : {};
            return $2af628f775b1fe25$var$saveComment(store, {
                id: id,
                bodyAdf: bodyAdf,
                isNewComment: isNewComment,
                analyticsEvent: analyticsEvent,
                visibility: visibility,
                ...jsmTimelineComponents
            }, {
                shouldFetchViewContext: shouldFetchViewContext
            }).mergeMap((saveCommentResultAction)=>{
                if (saveCommentResultAction.type === (0, $lkPj1.SAVE_COMMENT_FAILURE)) return (0, $3JafE.Observable).of(saveCommentResultAction);
                if (isNewComment) {
                    const state = store.getState();
                    const totalComments = (0, $dmojD.totalCommentsSelector)(state);
                    const loadedComments = (0, $dmojD.loadedCommentsSelector)(state);
                    const commentsStartIndex = (0, $dmojD.startIndexCommentsSelector)(state);
                    const { numPrevCommentsToLoad: numPrevCommentsToLoad } = (0, $kiT8o.calculateNumberOfCommentsToLoad)(totalComments, loadedComments, commentsStartIndex);
                    const shouldFetchSavedComment = numPrevCommentsToLoad > 0;
                    return shouldFetchSavedComment ? (0, $3JafE.Observable).zip((0, $3JafE.Observable).of(saveCommentResultAction), (0, $3JafE.Observable).of((0, $lkPj1.fetchSortedCommentsRequest)(saveCommentResultAction.payload.comment.id))).mergeMap((result)=>(0, $3JafE.Observable).from(result)) : (0, $3JafE.Observable).zip((0, $3JafE.Observable).of(saveCommentResultAction)).mergeMap((result)=>(0, $3JafE.Observable).from(result));
                }
                return (0, $3JafE.Observable).zip((0, $3JafE.Observable).of(saveCommentResultAction)).mergeMap((result)=>(0, $3JafE.Observable).from(result));
            });
        }));
var $2af628f775b1fe25$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)($2af628f775b1fe25$var$retrySaveComment, $2af628f775b1fe25$var$saveCommentAndUpdateIsCommentSupportedEpic);

});
parcelRegister("kiT8o", function(module, exports) {

$parcel$export(module.exports, "calculateNumberOfCommentsToLoad", () => $6a8b34dcfe8bd576$export$6aba46b8cdcf6cc4);

var $eTy9x = parcelRequire("eTy9x");
const $6a8b34dcfe8bd576$export$6aba46b8cdcf6cc4 = (totalComments, loadedComments, startIndex)=>{
    let numPrevCommentsToLoad = 0;
    const numPagedItemsToLoad = (0, $eTy9x.NUM_PAGED_ITEMS_TO_LOAD);
    const endIndex = loadedComments + startIndex;
    const numNextCommentsToLoad = totalComments - endIndex;
    if (startIndex > 0) numPrevCommentsToLoad = startIndex > numPagedItemsToLoad ? numPagedItemsToLoad : startIndex;
    return {
        numNextCommentsToLoad: numNextCommentsToLoad > numPagedItemsToLoad ? numPagedItemsToLoad : numNextCommentsToLoad,
        numPrevCommentsToLoad: numPrevCommentsToLoad
    };
};

});

parcelRegister("chq8S", function(module, exports) {

$parcel$export(module.exports, "getSaveAdfCommentUrl", () => $5ebc649cf36786e6$export$e7511d9157fc9f51);
const $5ebc649cf36786e6$export$e7511d9157fc9f51 = ({ baseUrl: baseUrl, issueKey: issueKey, id: id = '', isNewComment: isNewComment = false })=>{
    const commentIdPlaceholder = isNewComment ? '' : `/${id}`;
    return `${baseUrl}/rest/api/3/issue/${issueKey}/comment${commentIdPlaceholder}`;
};

});


parcelRegister("b20cO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6d6823121e44fdc$export$2e2bcd8739ae039);
parcelRequire("4M8ru");
parcelRequire("flmol");
parcelRequire("6WUHA");
parcelRequire("8OtG5");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("g2Yef");
parcelRequire("iects");
parcelRequire("6zblu");
parcelRequire("5hZYM");
parcelRequire("b8V1i");

var $lkPj1 = parcelRequire("lkPj1");

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c6d6823121e44fdc$export$2e2bcd8739ae039 = (action$)=>// @ts-expect-error - TS2769 - No overload matches this call. | TS2684 - The 'this' context of type 'Observable<GroupedObservable<string | null, FilteredAction>>' is not assignable to method's 'this' of type 'Observable<ActionsObservable<FilteredAction>>'.
    action$.ofType((0, $lkPj1.ADD_COMMENT_FORM_EXPAND), (0, $lkPj1.EDIT_COMMENT_BEGIN), (0, $lkPj1.PASTED_INTO_COMMENT_FORM), (0, $lkPj1.SAVE_COMMENT_SUCCESS)).groupBy((action)=>{
        switch(action.type){
            case 0, $lkPj1.ADD_COMMENT_FORM_EXPAND:
                return 0, $b10b5cb385fb5d46$export$c4134c813c47beb0;
            case 0, $lkPj1.EDIT_COMMENT_BEGIN:
                return action.payload.id;
            case 0, $lkPj1.PASTED_INTO_COMMENT_FORM:
                return action.payload.id;
            case 0, $lkPj1.SAVE_COMMENT_SUCCESS:
                return action.payload.optimisticId.startsWith((0, $b10b5cb385fb5d46$export$c4134c813c47beb0)) ? (0, $b10b5cb385fb5d46$export$c4134c813c47beb0) : action.payload.optimisticId;
            default:
                return null;
        }
    }).map((groupedStream$)=>{
        // @ts-expect-error - TS2741 - Property 'ofType' is missing in type 'Observable<FilteredAction>' but required in type 'ActionsObservable<EditorOpenedAction>'.
        const newEditorSession$ = groupedStream$.filter(({ type: type })=>type === (0, $lkPj1.ADD_COMMENT_FORM_EXPAND) || type === (0, $lkPj1.EDIT_COMMENT_BEGIN));
        // @ts-expect-error - TS2684 - The 'this' context of type 'Observable<Observable<FilteredAction>>' is not assignable to method's 'this' of type 'Observable<ActionsObservable<TargetEditorAction>>'.
        return groupedStream$.window(newEditorSession$).map((sessionStream$)=>{
            // @ts-expect-error - TS2741 - Property 'ofType' is missing in type 'Observable<TargetEditorAction>' but required in type 'ActionsObservable<SaveCommentSuccessAction>'.
            const sessionSaveSuccess$ = sessionStream$.filter(({ type: type })=>type === (0, $lkPj1.SAVE_COMMENT_SUCCESS));
            // @ts-expect-error - TS2741 - Property 'ofType' is missing in type 'Observable<TargetEditorAction>' but required in type 'ActionsObservable<PastedIntoCommentFormAction>'.
            const sessionPastes$ = sessionStream$.filter(({ type: type })=>type === (0, $lkPj1.PASTED_INTO_COMMENT_FORM)).takeUntil(sessionSaveSuccess$);
            // @ts-expect-error - TS2741 - Property 'ofType' is missing in type 'Observable<any[]>' but required in type 'ActionsObservable<PasteAggregation>'.
            const pasteAggregator$ = // @ts-expect-error - TS2769 - No overload matches this call.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            sessionPastes$.reduce((acc, curr)=>[
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...acc,
                    curr.payload.pastedContent
                ], []);
            // @ts-expect-error - TS2741 - Property 'ofType' is missing in type 'Observable<SaveCommentSuccessWithPastedContentAction | null>' but required in type 'ActionsObservable<SaveCommentSuccessWithPastedContentAction>'.
            return sessionSaveSuccess$.withLatestFrom(pasteAggregator$).mergeMap(([saveSuccessAction, pastedContent])=>{
                const { comment: comment } = saveSuccessAction.payload;
                return pastedContent.length === 0 ? (0, $3JafE.Observable).empty() : (0, $3JafE.Observable).of((0, $lkPj1.saveCommentSuccessWithPastedContent)(comment, pastedContent));
            });
        }).mergeAll();
    }).mergeAll();

});

parcelRegister("k5z3G", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9113568e6b8dbad$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $3A3OQ = parcelRequire("3A3OQ");

var $a0kZP = parcelRequire("a0kZP");

var $f62OU = parcelRequire("f62OU");

var $5JqpU = parcelRequire("5JqpU");

var $Q8sKP = parcelRequire("Q8sKP");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$c9113568e6b8dbad$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $f62OU.FETCH_CONFLUENCE_APP_LINKS_REQUEST), (0, $a0kZP.APPLINK_AUTHENTICATION_SUCCESS)).switchMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        // @ts-expect-error - TS2684 - The 'this' context of type 'Observable<unknown>' is not assignable to method's 'this' of type 'Observable<ConfluenceAppLinksResponse>'.
        return (0, $Q8sKP.default)(baseUrl).map((0, $f62OU.fetchConfluenceAppLinksSuccess)).catch((error)=>{
            (0, $3A3OQ.trackOrLogClientError)('issue.fetch.confluence-app-links-epic', 'FETCH_CONFLUENCE_APP_LINKS_REQUEST: Failed to fetch confluence app links data', error);
            return (0, $3JafE.Observable).of((0, $f62OU.fetchConfluenceAppLinksFailed)());
        });
    });

});
parcelRegister("Q8sKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a99d63ca62aa0c1$export$2e2bcd8739ae039);

var $aiRd8 = parcelRequire("aiRd8");

var $lV5H0 = parcelRequire("lV5H0");
const $4a99d63ca62aa0c1$export$411bec8e101d37ea = (baseUrl)=>(0, $aiRd8.default)((0, $lV5H0.getConfluenceAppLinksUrl)(baseUrl));
var $4a99d63ca62aa0c1$export$2e2bcd8739ae039 = $4a99d63ca62aa0c1$export$411bec8e101d37ea;

});


parcelRegister("9WSr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $961b28bd7bf07f02$export$2e2bcd8739ae039);
parcelRequire("cpH8E");
parcelRequire("9u6v2");
parcelRequire("jyKN9");
parcelRequire("l5lul");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $bd1K7 = parcelRequire("bd1K7");

var $illlw = parcelRequire("illlw");

var $3JafE = parcelRequire("3JafE");

var $jUhyG = parcelRequire("jUhyG");

var $gUUjF = parcelRequire("gUUjF");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $3A3OQ = parcelRequire("3A3OQ");

var $cxdSy = parcelRequire("cxdSy");

var $6ySNE = parcelRequire("6ySNE");

var $5JqpU = parcelRequire("5JqpU");

var $6vrw7 = parcelRequire("6vrw7");

var $i44MM = parcelRequire("i44MM");

var $kaymS = parcelRequire("kaymS");
const $961b28bd7bf07f02$var$LOG_LOCATION = 'issue.fetch.confluence-pages-epic';
const $961b28bd7bf07f02$var$ERROR_ISSUE_ID = 'addconfluencelink.error.issueId.invalid';
const $961b28bd7bf07f02$var$createConfluencePageLink = (action$, store)=>action$.ofType((0, $6ySNE.CREATE_CONFLUENCE_PAGE_LINK_REQUEST)).switchMap((action)=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueId = (0, $5JqpU.issueIdSelector)(state);
        const { pageHref: pageHref, triggerInviteExperiment: triggerInviteExperiment } = action.payload;
        const { analyticsEvent: analyticsEvent } = action.meta;
        const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('invite_prompt_on_link_insert_v2');
        const cohort = expConfig.get('cohort', 'not-enrolled');
        if (!issueId) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData($961b28bd7bf07f02$var$LOG_LOCATION, (0, $6ySNE.CREATE_CONFLUENCE_PAGE_LINK_REQUEST), new Error($961b28bd7bf07f02$var$ERROR_ISSUE_ID));
            return (0, $3JafE.Observable).of((0, $6ySNE.createConfluencePageLinkFailed)($961b28bd7bf07f02$var$ERROR_ISSUE_ID));
        }
        return (0, $3JafE.Observable).from((0, $i44MM.createConfluencePageLinkRequest)({
            baseUrl: baseUrl,
            pageHref: pageHref,
            issueId: (0, $6vrw7.toIssueId)(issueId.toString())
        })).do((confluencePageLink)=>{
            (0, $jUhyG.fireTrackAnalytics)(analyticsEvent, {
                action: 'created',
                actionSubjectId: confluencePageLink.id,
                attributes: {
                    createdWithError: !!(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(confluencePageLink, 'error'),
                    needsAuthorization: !!(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(confluencePageLink, 'repairLink.href')
                }
            });
        }).map((confluencePageLink)=>{
            if (cohort !== 'not-enrolled') triggerInviteExperiment?.();
            return (0, $6ySNE.createConfluencePageLinkSuccess)(confluencePageLink);
        }).catch((error)=>{
            let invalidMessage;
            if ((0, $1ybV0.ff)('confluence-link-limit-exceed-warning-flag_1ycku') && error.statusCode === 413) invalidMessage = (0, $cxdSy.getIssueLimitErrorField)(error);
            (0, $3A3OQ.trackOrLogClientError)($961b28bd7bf07f02$var$LOG_LOCATION, (0, $6ySNE.CREATE_CONFLUENCE_PAGE_LINK_REQUEST), error);
            const { error: authLinkValue, field: field } = error.errors?.[0] || {};
            const authLink = field === 'APPLINK_REQ_AUTH' ? authLinkValue : undefined;
            return (0, $3JafE.Observable).of((0, $6ySNE.createConfluencePageLinkFailed)(invalidMessage ?? error.message, authLink));
        });
    });
const $961b28bd7bf07f02$var$deleteConfluencePageLink = (action$, store)=>action$.ofType((0, $6ySNE.DELETE_CONFLUENCE_PAGE_LINK_REQUEST)).switchMap((action)=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueKey = (0, $5JqpU.issueKeySelector)(state);
        const { globalId: globalId } = action.payload;
        return (0, $3JafE.Observable).fromPromise((0, $i44MM.getDeleteRequest)(baseUrl, issueKey, globalId)).map((0, $6ySNE.deleteConfluencePageLinkSuccess)).catch((error)=>{
            (0, $3A3OQ.trackOrLogClientError)($961b28bd7bf07f02$var$LOG_LOCATION, 'DELETE_CONFLUENCE_PAGE_LINK_REQUEST: Failed to delete confluence page link', error);
            return (0, $3JafE.Observable).of((0, $6ySNE.deleteConfluencePageLinkFailed)());
        });
    });
// @ts-expect-error - TS2769 - No overload matches this call.
const $961b28bd7bf07f02$var$confluencePagesEpic = (0, $bd1K7.combineEpics)($961b28bd7bf07f02$var$createConfluencePageLink, $961b28bd7bf07f02$var$deleteConfluencePageLink, (0, $kaymS.default));
var $961b28bd7bf07f02$export$2e2bcd8739ae039 = $961b28bd7bf07f02$var$confluencePagesEpic;

});
parcelRegister("i44MM", function(module, exports) {

$parcel$export(module.exports, "createConfluencePageLinkRequest", () => $82f2f7d6a3b78e1c$export$fb259ee5299f0823);
$parcel$export(module.exports, "getDeleteRequest", () => $82f2f7d6a3b78e1c$export$c860b17e11bc1d12);

var $lRmyA = parcelRequire("lRmyA");

var $3ElT9 = parcelRequire("3ElT9");


var $6vrw7 = parcelRequire("6vrw7");
const $82f2f7d6a3b78e1c$var$transformConfluencePage = (response)=>{
    if (response.object.status.resolved) {
        const confluencePage = {
            id: (0, $6vrw7.toConfluencePageId)(response.id),
            globalId: (0, $6vrw7.toRemoteLinkGlobalId)(response.globalId),
            href: (0, $6vrw7.toHref)(response.object.url),
            title: response.object.title,
            type: (0, $3ElT9.toConfluencePageType)(response.object.icon.title),
            lastUpdatedContext: {
                user: {
                    displayName: (0, $6vrw7.toDisplayName)(response.object.status.icon.title),
                    avatarUrl: (0, $6vrw7.toHref)(response.object.status.icon.url16x16)
                }
            }
        };
        return confluencePage;
    }
    const failedRemoteLink = {
        id: (0, $6vrw7.toFailedRemoteLinkId)(response.id),
        error: response.object.status.icon.url16x16 ? (0, $b7817a5fa36c8dd6$export$d1fe0e8f550fe68d) : (0, $b7817a5fa36c8dd6$export$a6054426471fb4c4),
        link: {
            id: (0, $6vrw7.toFailedRemoteLinkId)(response.id),
            globalId: (0, $6vrw7.toRemoteLinkGlobalId)(response.globalId),
            href: (0, $6vrw7.toHref)(response.object.url)
        },
        repairLink: {
            href: (0, $6vrw7.toHref)(response.object.status.icon.url16x16)
        }
    };
    return failedRemoteLink;
};
const $82f2f7d6a3b78e1c$var$createConfluencePageLinkUrl = (baseUrl)=>`${baseUrl}/rest/confluenceIssueLink/1/confluence`;
const $82f2f7d6a3b78e1c$var$createConfluencePageLinkQueryParams = (issueId, pageHref)=>`?issueId=${issueId}&pageUrl=${pageHref}`;
const $82f2f7d6a3b78e1c$export$fb259ee5299f0823 = ({ baseUrl: baseUrl, issueId: issueId, pageHref: pageHref })=>(0, $lRmyA.performPostRequest)(`${$82f2f7d6a3b78e1c$var$createConfluencePageLinkUrl(baseUrl)}${$82f2f7d6a3b78e1c$var$createConfluencePageLinkQueryParams(issueId, pageHref)}`, {
        body: JSON.stringify({})
    }).then($82f2f7d6a3b78e1c$var$transformConfluencePage);
const $82f2f7d6a3b78e1c$export$c860b17e11bc1d12 = (baseUrl, issueKey, globalId)=>(0, $lRmyA.performDeleteRequest)(`${baseUrl}/rest/api/2/issue/${issueKey}/remotelink?globalId=${encodeURIComponent(globalId)}`);

});

parcelRegister("kaymS", function(module, exports) {

$parcel$export(module.exports, "default", () => $16a6f36b01998a97$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $gbvII = parcelRequire("gbvII");

var $5JqpU = parcelRequire("5JqpU");

var $dOXkm = parcelRequire("dOXkm");

var $hfuAD = parcelRequire("hfuAD");

var $g13yj = parcelRequire("g13yj");
const $16a6f36b01998a97$var$LOG_LOCATION = 'issue.fetch.confluence-recently-viewed-epic';
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$16a6f36b01998a97$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $gbvII.FETCH_RECENTLY_VISITED_CONFLUENCE_PAGES_REQUEST)).switchMap(()=>{
        const state = store.getState();
        let response;
        if ((0, $1ybV0.ff)('jira-issue-view-confluence-recently-viewed-stargate')) {
            // NOTE: The way things are wired here forces this call to be against the current instance cloudId.
            //       The impact here is that any recentlyViewedConfluencePages are always against the current instance.
            //       We could wire up which confluence appLink is currently selected through state, but we would still not
            //       have the cloudId to make the correct stargate call. This should probably be moved to the backend, or get
            //       the backend to return the cloudId with confluence appLinks. If this is kept in the FE, the following call
            //       should return the currently selected confluenceAppLink.
            const systemConfluenceAppLink = (0, $dOXkm.systemConfluenceAppLinkSelector)(state);
            // If there is no systemConfluenceAppLink, it's save to pass empty baseUrl so that links are completed with the
            // current site base url.
            const systemConfluenceBaseUrl = systemConfluenceAppLink?.baseUrl || '';
            const cloudId = (0, $5JqpU.cloudIdSelector)(state);
            response = (0, $g13yj.default)(systemConfluenceBaseUrl, cloudId);
        } else {
            const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
            response = (0, $hfuAD.default)(baseUrl);
        }
        return response.map((0, $gbvII.fetchRecentlyVisitedConfluencePagesSuccess)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData($16a6f36b01998a97$var$LOG_LOCATION, 'FETCH_RECENTLY_VISITED_CONFLUENCE_PAGES_REQUEST: Failed to fetch recently viewed confluence pages', error);
            return (0, $3JafE.Observable).of((0, $gbvII.fetchRecentlyVisitedConfluencePagesFailed)());
        });
    });

});
parcelRegister("dOXkm", function(module, exports) {

$parcel$export(module.exports, "confluenceAppLinksSelector", () => $e48e1897fd0ad263$export$a658ba1dd282a6f9);
$parcel$export(module.exports, "systemConfluenceAppLinkSelector", () => $e48e1897fd0ad263$export$852e1e65126d7a70);
$parcel$export(module.exports, "hasConfluenceAppLinks", () => $e48e1897fd0ad263$export$5e4432221ccf8f44);
$parcel$export(module.exports, "canLinkConfluencePageSelector", () => $e48e1897fd0ad263$export$1d1a1a6979d8a786);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");

var $iyeap = parcelRequire("iyeap");

var $7FqHc = parcelRequire("7FqHc");
const $e48e1897fd0ad263$export$a658ba1dd282a6f9 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.confluenceAppLinks || []);
const $e48e1897fd0ad263$export$852e1e65126d7a70 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities?.confluenceAppLinks.find((link)=>link.name === 'System Confluence'));
const $e48e1897fd0ad263$export$5e4432221ccf8f44 = (0, $df4Sl.createSelector)($e48e1897fd0ad263$export$a658ba1dd282a6f9, (links)=>links && links.length > 0);
const $e48e1897fd0ad263$export$1d1a1a6979d8a786 = (0, $df4Sl.createSelector)($e48e1897fd0ad263$export$5e4432221ccf8f44, (0, $iyeap.isConfluencePageLinksEnabledSelector), (0, $7FqHc.canLinkIssuesSelector), (hasConfluenceAppLinksInTenant, isConfluenceLinksEnabled, canLinkIssues)=>hasConfluenceAppLinksInTenant && isConfluenceLinksEnabled && canLinkIssues);

});
parcelRegister("iyeap", function(module, exports) {

$parcel$export(module.exports, "createLinkedPageErrorMessageSelector", () => $2a9fe1a24d616452$export$43e4bf84789423a);
$parcel$export(module.exports, "createLinkedPageRepairLinkSelector", () => $2a9fe1a24d616452$export$fa47665a2578130e);
$parcel$export(module.exports, "isCreateLinkedPageInvalidSelector", () => $2a9fe1a24d616452$export$98409bf6a432fedc);
$parcel$export(module.exports, "isCreateLinkedPageLoadingSelector", () => $2a9fe1a24d616452$export$6a2b586e944ae6c3);
$parcel$export(module.exports, "isCreateLinkedPageOpenedSelector", () => $2a9fe1a24d616452$export$9bf829ada2f5f9f9);
$parcel$export(module.exports, "createLinkedPageClickedCountSelector", () => $2a9fe1a24d616452$export$c6cb919d49b47503);
$parcel$export(module.exports, "isConfluencePageLinksEnabledSelector", () => $2a9fe1a24d616452$export$436d9814afb798d7);
$parcel$export(module.exports, "linkedConfluencePagesPagesSelector", () => $2a9fe1a24d616452$export$2b1a39b040f26a0c);
$parcel$export(module.exports, "linkedConfluenceWhiteboardsWhiteboardsSelector", () => $2a9fe1a24d616452$export$22687708224fa418);
$parcel$export(module.exports, "mentionedConfluencePagesPagesSelector", () => $2a9fe1a24d616452$export$ed76d4b060fe1d3b);
$parcel$export(module.exports, "linkedConfluencePagesCountSelector", () => $2a9fe1a24d616452$export$7da489a0184df0b4);
$parcel$export(module.exports, "linkedConfluenceWhiteboardsCountSelector", () => $2a9fe1a24d616452$export$841f40ba702f90d9);
$parcel$export(module.exports, "isCreateLinkedWhiteboardLoadingSelector", () => $2a9fe1a24d616452$export$742d0b6fbd713e2d);
$parcel$export(module.exports, "mentionedConfluencePagesCountSelector", () => $2a9fe1a24d616452$export$4a65ae28d14d9d41);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $2a9fe1a24d616452$var$confluencePagesSelector = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.confluencePages);
const $2a9fe1a24d616452$var$confluenceWhiteboardsSelector = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.confluenceWhiteboards);
const $2a9fe1a24d616452$var$createLinkedPageSelector = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$confluencePagesSelector, (confluencePages)=>confluencePages.createLinkedPage);
const $2a9fe1a24d616452$var$createLinkedWhiteboardSelector = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$confluenceWhiteboardsSelector, (confluenceWhiteboards)=>confluenceWhiteboards.createLinkedWhiteboard);
const $2a9fe1a24d616452$export$43e4bf84789423a = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$createLinkedPageSelector, (createLinkedPage)=>createLinkedPage.errorMessage);
const $2a9fe1a24d616452$export$fa47665a2578130e = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$createLinkedPageSelector, (createLinkedPage)=>createLinkedPage.repairLink);
const $2a9fe1a24d616452$export$98409bf6a432fedc = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$createLinkedPageSelector, (createLinkedPage)=>createLinkedPage.isInvalid);
const $2a9fe1a24d616452$export$6a2b586e944ae6c3 = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$createLinkedPageSelector, (createLinkedPage)=>createLinkedPage.isLoading);
const $2a9fe1a24d616452$export$9bf829ada2f5f9f9 = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$createLinkedPageSelector, (createLinkedPage)=>createLinkedPage.clickedCount > 0);
const $2a9fe1a24d616452$export$c6cb919d49b47503 = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$createLinkedPageSelector, (createLinkedPage)=>createLinkedPage.clickedCount);
const $2a9fe1a24d616452$var$linkedConfluencePagesSelector = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$confluencePagesSelector, (confluencePages)=>confluencePages && confluencePages.linkedPages);
const $2a9fe1a24d616452$var$linkedConfluenceWhiteboardsSelector = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$confluenceWhiteboardsSelector, (confluenceWhiteboards)=>confluenceWhiteboards?.linkedWhiteboards);
const $2a9fe1a24d616452$var$mentionedConfluencePagesSelector = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$confluencePagesSelector, (confluencePages)=>confluencePages && confluencePages.mentionedPages);
const $2a9fe1a24d616452$export$436d9814afb798d7 = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$confluencePagesSelector, (confluencePages)=>!!(confluencePages && confluencePages.isLinkingEnabled));
const $2a9fe1a24d616452$export$2b1a39b040f26a0c = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$linkedConfluencePagesSelector, (linkedConfluencePages)=>linkedConfluencePages && linkedConfluencePages.pages);
const $2a9fe1a24d616452$export$22687708224fa418 = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$linkedConfluenceWhiteboardsSelector, (linkedConfluenceWhiteboards)=>linkedConfluenceWhiteboards?.whiteboards);
const $2a9fe1a24d616452$export$ed76d4b060fe1d3b = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$mentionedConfluencePagesSelector, (mentionedConfluencePages)=>mentionedConfluencePages && mentionedConfluencePages.pages);
const $2a9fe1a24d616452$export$7da489a0184df0b4 = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$linkedConfluencePagesSelector, (linkedConfluencePages)=>linkedConfluencePages && linkedConfluencePages.pageCount);
const $2a9fe1a24d616452$export$841f40ba702f90d9 = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$linkedConfluenceWhiteboardsSelector, (linkedConfluenceWhiteboards)=>linkedConfluenceWhiteboards?.whiteboardCount);
const $2a9fe1a24d616452$export$742d0b6fbd713e2d = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$createLinkedWhiteboardSelector, (createLinkedWhiteboard)=>createLinkedWhiteboard?.isLoading);
const $2a9fe1a24d616452$export$4a65ae28d14d9d41 = (0, $df4Sl.createSelector)($2a9fe1a24d616452$var$mentionedConfluencePagesSelector, (mentionedConfluencePages)=>mentionedConfluencePages && mentionedConfluencePages.pageCount);

});


parcelRegister("hfuAD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3421470a98e0830$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $aiRd8 = parcelRequire("aiRd8");

var $3ElT9 = parcelRequire("3ElT9");

var $6vrw7 = parcelRequire("6vrw7");
const $a3421470a98e0830$var$LIMIT = 20;
const $a3421470a98e0830$var$SUPPORTED_CONTENT_TYPES = [
    'blogpost',
    'page'
];
const $a3421470a98e0830$var$createRecentlyVisitedConfluencePagesUrl = (baseUrl)=>`${baseUrl}/wiki/rest/recentlyviewed/1.0/recent?limit=${$a3421470a98e0830$var$LIMIT}`;
const $a3421470a98e0830$var$fetch = (baseUrl)=>(0, $aiRd8.default)($a3421470a98e0830$var$createRecentlyVisitedConfluencePagesUrl(baseUrl));
const $a3421470a98e0830$var$prefixUrlWithHost = (url)=>{
    if (!url.includes('http')) {
        if (window && window.location) return `${window.location.protocol}//${window.location.host}${url}`;
    }
    return url;
};
const $a3421470a98e0830$var$transform = (response, baseUrl)=>response.map((pages)=>pages.filter((page)=>$a3421470a98e0830$var$SUPPORTED_CONTENT_TYPES.includes(page.type)).map((page)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ({
                id: (0, $6vrw7.toConfluencePageId)(page.id.toString()),
                globalId: (0, $6vrw7.toRemoteLinkGlobalId)(''),
                href: (0, $6vrw7.toHref)($a3421470a98e0830$var$prefixUrlWithHost(`${baseUrl}/wiki${page.url}`)),
                title: page.title,
                type: (0, $3ElT9.toConfluencePageType)(page.contentType),
                space: page.space,
                spaceKey: page.spaceKey || ''
            })));
const $a3421470a98e0830$var$fetchRecentlyVisitedConfluencePages = (baseUrl)=>// @ts-expect-error - TS2345 - Argument of type 'Observable<unknown>' is not assignable to parameter of type 'Observable<RecentlyVisitedConfluencePageFromServer[]>'.
    $a3421470a98e0830$var$transform($a3421470a98e0830$var$fetch(baseUrl), baseUrl);
var $a3421470a98e0830$export$2e2bcd8739ae039 = $a3421470a98e0830$var$fetchRecentlyVisitedConfluencePages;

});

parcelRegister("g13yj", function(module, exports) {

$parcel$export(module.exports, "default", () => $24b6c4687a1a26c7$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $aiRd8 = parcelRequire("aiRd8");

var $3ElT9 = parcelRequire("3ElT9");

var $6vrw7 = parcelRequire("6vrw7");
const $24b6c4687a1a26c7$var$LIMIT = 20;
const $24b6c4687a1a26c7$var$SUPPORTED_CONTENT_TYPES = [
    'blogpost',
    'page'
];
// if a cloudId is provided, load from stargate
const $24b6c4687a1a26c7$var$createRecentlyVisitedConfluencePagesUrl = (cloudId)=>`/gateway/api/ex/confluence/${cloudId}/wiki/rest/recentlyviewed/1.0/recent?limit=${$24b6c4687a1a26c7$var$LIMIT}`;
const $24b6c4687a1a26c7$var$fetch = (cloudId)=>(0, $aiRd8.default)($24b6c4687a1a26c7$var$createRecentlyVisitedConfluencePagesUrl(cloudId));
const $24b6c4687a1a26c7$var$prefixUrlWithHost = (url)=>{
    if (!url.includes('http')) {
        if (window && window.location) return `${window.location.protocol}//${window.location.host}${url}`;
    }
    return url;
};
const $24b6c4687a1a26c7$var$transform = (response, baseUrl)=>response.map((pages)=>pages.filter((page)=>$24b6c4687a1a26c7$var$SUPPORTED_CONTENT_TYPES.includes(page.type)).map((page)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ({
                id: (0, $6vrw7.toConfluencePageId)(page.id.toString()),
                globalId: (0, $6vrw7.toRemoteLinkGlobalId)(''),
                href: (0, $6vrw7.toHref)($24b6c4687a1a26c7$var$prefixUrlWithHost(`${baseUrl}/wiki${page.url}`)),
                title: page.title,
                type: (0, $3ElT9.toConfluencePageType)(page.contentType),
                space: page.space,
                spaceKey: page.spaceKey || ''
            })));
const $24b6c4687a1a26c7$var$fetchRecentlyVisitedConfluencePages = (baseUrl, cloudId)=>// @ts-expect-error - TS2345 - Argument of type 'Observable<unknown>' is not assignable to parameter of type 'Observable<RecentlyVisitedConfluencePageFromServer[]>'.
    $24b6c4687a1a26c7$var$transform($24b6c4687a1a26c7$var$fetch(cloudId), baseUrl);
var $24b6c4687a1a26c7$export$2e2bcd8739ae039 = $24b6c4687a1a26c7$var$fetchRecentlyVisitedConfluencePages;

});



parcelRegister("jNALT", function(module, exports) {

$parcel$export(module.exports, "default", () => $625f02cf6ddb8e2e$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("3X5NT");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $ePSh2 = parcelRequire("ePSh2");

var $1OJS4 = parcelRequire("1OJS4");

var $5JqpU = parcelRequire("5JqpU");
const $625f02cf6ddb8e2e$var$navigateToNewIssueIfNecessary = (fromIssueKey, toIssueKey)=>fromIssueKey !== toIssueKey ? (0, $3JafE.Observable).of((0, $1OJS4.navigateToNewIssue)({
        fromIssueKey: fromIssueKey,
        toIssueKey: toIssueKey
    })) : (0, $3JafE.Observable).empty();
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$625f02cf6ddb8e2e$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $ePSh2.SET_CONTEXT)).map(()=>(0, $5JqpU.contextSelector)(store.getState())).pairwise() // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .mergeMap(([prevContext, currentContext])=>$625f02cf6ddb8e2e$var$navigateToNewIssueIfNecessary(prevContext.issueKey, currentContext.issueKey));

});

parcelRegister("8ap8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $b38c6b12a286153a$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("iects");
parcelRequire("l5lul");

var $3JafE = parcelRequire("3JafE");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");
var $aiRd8 = parcelRequire("aiRd8");
var $JRB5w = parcelRequire("JRB5w");

var $4ceCM = parcelRequire("4ceCM");

var $3A3OQ = parcelRequire("3A3OQ");

var $49xWy = parcelRequire("49xWy");

var $5JqpU = parcelRequire("5JqpU");

var $cFY86 = parcelRequire("cFY86");

var $l7DhQ = parcelRequire("l7DhQ");
const $b38c6b12a286153a$var$deleteOptions = {
    method: 'DELETE'
};
const $b38c6b12a286153a$export$96dbe530404dec04 = (baseUrl, linkId)=>`${baseUrl}/rest/api/2/issueLink/${linkId}`;
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$b38c6b12a286153a$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $49xWy.DELETE_LINKED_ISSUE_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const { application: application, edition: edition } = action.payload;
        /**
		 * BENTO-3469 wording here is confusing, because linkedIssueId
		 * is actually link id
		 */ const linkId = action.payload.linkedIssueId;
        const deleteUrl = $b38c6b12a286153a$export$96dbe530404dec04(baseUrl, linkId);
        const link = (0, $cFY86.issueLinkSelector)(linkId)(state);
        const linkedIssue = (0, $cFY86.linkedIssueSelector)(link.linkedIssueKey)(state);
        return (0, $aiRd8.default)(deleteUrl, $b38c6b12a286153a$var$deleteOptions).map(()=>(0, $49xWy.deleteLinkedIssueSuccess)(linkId, {
                issueId: linkedIssue.id,
                direction: link.direction
            })).do(()=>{
            if ((0, $1ybV0.ff)('analytics_event_for_deletion_of_linked_issue_1ufi8')) (0, $4ceCM.sendExperienceAnalytics)({
                experience: (0, $l7DhQ.EXPERIENCE_DELETE_ISSUE_LINK_SUCCEEDED),
                wasExperienceSuccesful: true,
                analyticsSource: (0, $l7DhQ.SOURCE_JIRA_LINKED_ISSUES),
                application: application ?? null,
                edition: edition ?? null
            });
        }).catch((error)=>{
            if ((0, $1ybV0.ff)('analytics_event_for_deletion_of_linked_issue_1ufi8')) {
                if (!((0, $1ybV0.ff)('ken-429-restrict-4xx-error_vi8v7') && error instanceof (0, $7byHA.default) && (0, $JRB5w.isHttpClientErrorResponse)(error))) (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'issue.issue-links.delete-issue-link-error',
                        teamName: 'bento'
                    },
                    attributes: {
                        experience: (0, $l7DhQ.EXPERIENCE_DELETE_ISSUE_LINK_FAILED),
                        analyticsSource: (0, $l7DhQ.SOURCE_JIRA_LINKED_ISSUES),
                        application: application ?? null,
                        edition: edition ?? null
                    }
                });
            }
            (0, $3A3OQ.trackOrLogClientError)('issue.issue-links.delete-issue-link-error', 'Error when removing issue link', error);
            return (0, $3JafE.Observable).of((0, $49xWy.deleteLinkedIssueFailure)(linkId));
        });
    });

});
parcelRegister("l7DhQ", function(module, exports) {

$parcel$export(module.exports, "throttleIssueRefresh", () => $5d057dcd590cfc1b$export$c8f2235a77e19a22);
$parcel$export(module.exports, "EXPERIENCE_DELETE_ISSUE_LINK_SUCCEEDED", () => $5d057dcd590cfc1b$export$d6e73ae83b511b05);
$parcel$export(module.exports, "EXPERIENCE_DELETE_ISSUE_LINK_FAILED", () => $5d057dcd590cfc1b$export$bea5b1f5f6f213e3);
$parcel$export(module.exports, "SOURCE_JIRA_LINKED_ISSUES", () => $5d057dcd590cfc1b$export$e06d08d22ae9127b);

var $7xwx0 = parcelRequire("7xwx0");

var $jAy5L = parcelRequire("jAy5L");
const $5d057dcd590cfc1b$export$c8f2235a77e19a22 = ()=>(0, $7xwx0.throttleTime)(5000, (0, $jAy5L.async), {
        leading: true,
        trailing: true
    });
const $5d057dcd590cfc1b$export$d6e73ae83b511b05 = 'deleteIssueLinkSucceeded';
const $5d057dcd590cfc1b$export$bea5b1f5f6f213e3 = 'deleteIssueLinkFailed';
const $5d057dcd590cfc1b$export$e06d08d22ae9127b = 'jiraLinkedIssues';

});
parcelRegister("7xwx0", function(module, exports) {

$parcel$export(module.exports, "catchError", () => $57d4d9855b7856ca$export$3dede90624df3ba9, (v) => $57d4d9855b7856ca$export$3dede90624df3ba9 = v);
$parcel$export(module.exports, "map", () => $57d4d9855b7856ca$export$871de8747c9eaa88, (v) => $57d4d9855b7856ca$export$871de8747c9eaa88 = v);
$parcel$export(module.exports, "mergeMap", () => $57d4d9855b7856ca$export$6b9f6c0d32c093f9, (v) => $57d4d9855b7856ca$export$6b9f6c0d32c093f9 = v);
$parcel$export(module.exports, "switchMap", () => $57d4d9855b7856ca$export$9f6ea8e48bc26eab, (v) => $57d4d9855b7856ca$export$9f6ea8e48bc26eab = v);
$parcel$export(module.exports, "throttleTime", () => $57d4d9855b7856ca$export$4efe28f192921dd4, (v) => $57d4d9855b7856ca$export$4efe28f192921dd4 = v);
var $57d4d9855b7856ca$export$d779b02e6b68c3e8;
var $57d4d9855b7856ca$export$719c70722b10e5ff;
var $57d4d9855b7856ca$export$ab1029bcae9ddb4a;
var $57d4d9855b7856ca$export$8916d2c8119541bb;
var $57d4d9855b7856ca$export$d6b40c95035461c7;
var $57d4d9855b7856ca$export$91115bdd8709945f;
var $57d4d9855b7856ca$export$9e55760d3282e08c;
var $57d4d9855b7856ca$export$3dede90624df3ba9;
var $57d4d9855b7856ca$export$29ae691b7de52fe3;
var $57d4d9855b7856ca$export$77fa7d86f5204e8a;
var $57d4d9855b7856ca$export$ee1b3e54f0441b22;
var $57d4d9855b7856ca$export$b314777ae20abca9;
var $57d4d9855b7856ca$export$c28c8388be0ab31a;
var $57d4d9855b7856ca$export$82fbd7a2841d2484;
var $57d4d9855b7856ca$export$85b9a36db797e02b;
var $57d4d9855b7856ca$export$61fc7d43ac8f84b0;
var $57d4d9855b7856ca$export$7843a4469d64c07e;
var $57d4d9855b7856ca$export$e4ca6d7b7a6dcf9b;
var $57d4d9855b7856ca$export$1391212d75b2ee65;
var $57d4d9855b7856ca$export$286ca829307725c9;
var $57d4d9855b7856ca$export$ab9a5985b741fa7a;
var $57d4d9855b7856ca$export$983a3b5fb2f7202e;
var $57d4d9855b7856ca$export$779c5fb865a0172e;
var $57d4d9855b7856ca$export$571da16e28367bde;
var $57d4d9855b7856ca$export$91d69c7761a17bbc;
var $57d4d9855b7856ca$export$7ecc1a3b11b57dab;
var $57d4d9855b7856ca$export$31039f1fbd797b9c;
var $57d4d9855b7856ca$export$d70d492cd31004c0;
var $57d4d9855b7856ca$export$9f77e0932fb78f72;
var $57d4d9855b7856ca$export$3dea766d36a8935f;
var $57d4d9855b7856ca$export$578723aef62d92f5;
var $57d4d9855b7856ca$export$71aa6c912b956294;
var $57d4d9855b7856ca$export$de3a4d4a0d731119;
var $57d4d9855b7856ca$export$43128fadae87b74a;
var $57d4d9855b7856ca$export$3f063810d7bf01bd;
var $57d4d9855b7856ca$export$6953b97c7d866605;
var $57d4d9855b7856ca$export$dd1bc94b04021eeb;
var $57d4d9855b7856ca$export$4c7897fafd92b108;
var $57d4d9855b7856ca$export$871de8747c9eaa88;
var $57d4d9855b7856ca$export$e0eaf3a86c03b2ad;
var $57d4d9855b7856ca$export$76dbd6ffd832405d;
var $57d4d9855b7856ca$export$8960430cfd85939f;
var $57d4d9855b7856ca$export$4950aa0f605343fb;
var $57d4d9855b7856ca$export$18aef43295bbe906;
var $57d4d9855b7856ca$export$6b9f6c0d32c093f9;
var $57d4d9855b7856ca$export$5b8affa63fc6df16;
var $57d4d9855b7856ca$export$bd7cfc9a42b8a412;
var $57d4d9855b7856ca$export$c1fc905202bced53;
var $57d4d9855b7856ca$export$96ec731ed4dcb222;
var $57d4d9855b7856ca$export$1364843af8d5a963;
var $57d4d9855b7856ca$export$9007f49c319d1ac7;
var $57d4d9855b7856ca$export$5fba66d61591f42;
var $57d4d9855b7856ca$export$8f9d79d42bff1aac;
var $57d4d9855b7856ca$export$b29f828819edca8d;
var $57d4d9855b7856ca$export$c44985b87d605eff;
var $57d4d9855b7856ca$export$89b472e03be495df;
var $57d4d9855b7856ca$export$16ae46fda9567053;
var $57d4d9855b7856ca$export$42d9b6b38c68d989;
var $57d4d9855b7856ca$export$1f3342bf81d92d52;
var $57d4d9855b7856ca$export$236c05de452bec2;
var $57d4d9855b7856ca$export$533b26079ad0b4b;
var $57d4d9855b7856ca$export$76d90c956114f2c2;
var $57d4d9855b7856ca$export$b39ac5b4ffd1415a;
var $57d4d9855b7856ca$export$9369b12211e1fce4;
var $57d4d9855b7856ca$export$1281551253cfee02;
var $57d4d9855b7856ca$export$18d0766d894cba0c;
var $57d4d9855b7856ca$export$4812e460280c6ef2;
var $57d4d9855b7856ca$export$fe33c7b2002d97b0;
var $57d4d9855b7856ca$export$c87d910e63d22ed6;
var $57d4d9855b7856ca$export$d0a07e60ae428313;
var $57d4d9855b7856ca$export$ed80d9de1d9df928;
var $57d4d9855b7856ca$export$db61d692014e534e;
var $57d4d9855b7856ca$export$863d7ca51b416cee;
var $57d4d9855b7856ca$export$955fc4a6c4be454d;
var $57d4d9855b7856ca$export$635f6273df29ea1c;
var $57d4d9855b7856ca$export$facc584867c26fde;
var $57d4d9855b7856ca$export$175dedd748069215;
var $57d4d9855b7856ca$export$a4fe86229b0e9bdd;
var $57d4d9855b7856ca$export$6a45284a4b0bf33a;
var $57d4d9855b7856ca$export$9f6ea8e48bc26eab;
var $57d4d9855b7856ca$export$a439dc30c845238;
var $57d4d9855b7856ca$export$b7df5d561049483a;
var $57d4d9855b7856ca$export$1b47ad771ce5af5e;
var $57d4d9855b7856ca$export$ac8dfd3a7ad06e80;
var $57d4d9855b7856ca$export$9384c7afe4015e42;
var $57d4d9855b7856ca$export$3f23594af5f37336;
var $57d4d9855b7856ca$export$de363e709c412c8a;
var $57d4d9855b7856ca$export$4efe28f192921dd4;
var $57d4d9855b7856ca$export$1a539c8b2950ab40;
var $57d4d9855b7856ca$export$83e74882c5df8fe1;
var $57d4d9855b7856ca$export$86fe999fba7953f2;
var $57d4d9855b7856ca$export$fc00ee57782020aa;
var $57d4d9855b7856ca$export$45b10814cc054894;
var $57d4d9855b7856ca$export$8291e5b88f90ce4;
var $57d4d9855b7856ca$export$f3a19e933f377396;
var $57d4d9855b7856ca$export$1284415effa79ee0;
var $57d4d9855b7856ca$export$3182be990e0eeaad;
var $57d4d9855b7856ca$export$6a5dea797879f644;
var $57d4d9855b7856ca$export$d449030e5c10edf7;
var $57d4d9855b7856ca$export$8901015135f2fb22;
var $57d4d9855b7856ca$export$adddb6a2fa3864e9;
"use strict";

var $6EsY3 = parcelRequire("6EsY3");
$57d4d9855b7856ca$export$d779b02e6b68c3e8 = $6EsY3.audit;

var $8Rio7 = parcelRequire("8Rio7");
$57d4d9855b7856ca$export$719c70722b10e5ff = $8Rio7.auditTime;

var $i9UF9 = parcelRequire("i9UF9");
$57d4d9855b7856ca$export$ab1029bcae9ddb4a = $i9UF9.buffer;

var $4ZLqF = parcelRequire("4ZLqF");
$57d4d9855b7856ca$export$8916d2c8119541bb = $4ZLqF.bufferCount;

var $hl24P = parcelRequire("hl24P");
$57d4d9855b7856ca$export$d6b40c95035461c7 = $hl24P.bufferTime;

var $l9hdJ = parcelRequire("l9hdJ");
$57d4d9855b7856ca$export$91115bdd8709945f = $l9hdJ.bufferToggle;

var $5SOVP = parcelRequire("5SOVP");
$57d4d9855b7856ca$export$9e55760d3282e08c = $5SOVP.bufferWhen;

var $df9H8 = parcelRequire("df9H8");
$57d4d9855b7856ca$export$3dede90624df3ba9 = $df9H8.catchError;

var $lQxTf = parcelRequire("lQxTf");
$57d4d9855b7856ca$export$29ae691b7de52fe3 = $lQxTf.combineAll;

var $fEMiR = parcelRequire("fEMiR");
$57d4d9855b7856ca$export$77fa7d86f5204e8a = $fEMiR.combineLatest;

var $bfqZP = parcelRequire("bfqZP");
$57d4d9855b7856ca$export$ee1b3e54f0441b22 = $bfqZP.concat;

var $3joCo = parcelRequire("3joCo");
$57d4d9855b7856ca$export$b314777ae20abca9 = $3joCo.concatAll;

var $eGPtZ = parcelRequire("eGPtZ");
$57d4d9855b7856ca$export$c28c8388be0ab31a = $eGPtZ.concatMap;

var $cmPKV = parcelRequire("cmPKV");
$57d4d9855b7856ca$export$82fbd7a2841d2484 = $cmPKV.concatMapTo;

var $9INaL = parcelRequire("9INaL");
$57d4d9855b7856ca$export$85b9a36db797e02b = $9INaL.count;

var $9PQtY = parcelRequire("9PQtY");
$57d4d9855b7856ca$export$61fc7d43ac8f84b0 = $9PQtY.debounce;

var $lzvfM = parcelRequire("lzvfM");
$57d4d9855b7856ca$export$7843a4469d64c07e = $lzvfM.debounceTime;

var $kyjNq = parcelRequire("kyjNq");
$57d4d9855b7856ca$export$e4ca6d7b7a6dcf9b = $kyjNq.defaultIfEmpty;

var $kW6gr = parcelRequire("kW6gr");
$57d4d9855b7856ca$export$1391212d75b2ee65 = $kW6gr.delay;

var $jrplL = parcelRequire("jrplL");
$57d4d9855b7856ca$export$286ca829307725c9 = $jrplL.delayWhen;

var $GQ41u = parcelRequire("GQ41u");
$57d4d9855b7856ca$export$ab9a5985b741fa7a = $GQ41u.dematerialize;

var $ktZdP = parcelRequire("ktZdP");
$57d4d9855b7856ca$export$983a3b5fb2f7202e = $ktZdP.distinct;

var $8xAAu = parcelRequire("8xAAu");
$57d4d9855b7856ca$export$779c5fb865a0172e = $8xAAu.distinctUntilChanged;

var $aS1Fs = parcelRequire("aS1Fs");
$57d4d9855b7856ca$export$571da16e28367bde = $aS1Fs.distinctUntilKeyChanged;

var $8WPKc = parcelRequire("8WPKc");
$57d4d9855b7856ca$export$91d69c7761a17bbc = $8WPKc.elementAt;

var $7OVJ1 = parcelRequire("7OVJ1");
$57d4d9855b7856ca$export$7ecc1a3b11b57dab = $7OVJ1.every;

var $3VDHE = parcelRequire("3VDHE");
$57d4d9855b7856ca$export$31039f1fbd797b9c = $3VDHE.exhaust;

var $dBdHa = parcelRequire("dBdHa");
$57d4d9855b7856ca$export$d70d492cd31004c0 = $dBdHa.exhaustMap;

var $3MmTN = parcelRequire("3MmTN");
$57d4d9855b7856ca$export$9f77e0932fb78f72 = $3MmTN.expand;

var $dXapj = parcelRequire("dXapj");
$57d4d9855b7856ca$export$3dea766d36a8935f = $dXapj.filter;

var $cyrKF = parcelRequire("cyrKF");
$57d4d9855b7856ca$export$578723aef62d92f5 = $cyrKF.finalize;

var $lHxIn = parcelRequire("lHxIn");
$57d4d9855b7856ca$export$71aa6c912b956294 = $lHxIn.find;

var $1as0c = parcelRequire("1as0c");
$57d4d9855b7856ca$export$de3a4d4a0d731119 = $1as0c.findIndex;

var $iZQrg = parcelRequire("iZQrg");
$57d4d9855b7856ca$export$43128fadae87b74a = $iZQrg.first;

var $896Ie = parcelRequire("896Ie");
$57d4d9855b7856ca$export$3f063810d7bf01bd = $896Ie.groupBy;

var $7o5pq = parcelRequire("7o5pq");
$57d4d9855b7856ca$export$6953b97c7d866605 = $7o5pq.ignoreElements;

var $b095i = parcelRequire("b095i");
$57d4d9855b7856ca$export$dd1bc94b04021eeb = $b095i.isEmpty;

var $bQ3wM = parcelRequire("bQ3wM");
$57d4d9855b7856ca$export$4c7897fafd92b108 = $bQ3wM.last;

var $aynDk = parcelRequire("aynDk");
$57d4d9855b7856ca$export$871de8747c9eaa88 = $aynDk.map;

var $bRS1V = parcelRequire("bRS1V");
$57d4d9855b7856ca$export$e0eaf3a86c03b2ad = $bRS1V.mapTo;

var $iH3rg = parcelRequire("iH3rg");
$57d4d9855b7856ca$export$76dbd6ffd832405d = $iH3rg.materialize;

var $k4LFb = parcelRequire("k4LFb");
$57d4d9855b7856ca$export$8960430cfd85939f = $k4LFb.max;

var $eyE5b = parcelRequire("eyE5b");
$57d4d9855b7856ca$export$4950aa0f605343fb = $eyE5b.merge;

var $3Ut6O = parcelRequire("3Ut6O");
$57d4d9855b7856ca$export$18aef43295bbe906 = $3Ut6O.mergeAll;

var $b1qLQ = parcelRequire("b1qLQ");
$57d4d9855b7856ca$export$6b9f6c0d32c093f9 = $b1qLQ.mergeMap;

var $b1qLQ = parcelRequire("b1qLQ");
$57d4d9855b7856ca$export$5b8affa63fc6df16 = $b1qLQ.mergeMap;

var $g0vpX = parcelRequire("g0vpX");
$57d4d9855b7856ca$export$bd7cfc9a42b8a412 = $g0vpX.mergeMapTo;

var $6zXYF = parcelRequire("6zXYF");
$57d4d9855b7856ca$export$c1fc905202bced53 = $6zXYF.mergeScan;

var $jwlZG = parcelRequire("jwlZG");
$57d4d9855b7856ca$export$96ec731ed4dcb222 = $jwlZG.min;

var $lCBlc = parcelRequire("lCBlc");
$57d4d9855b7856ca$export$1364843af8d5a963 = $lCBlc.multicast;

var $9s3uu = parcelRequire("9s3uu");
$57d4d9855b7856ca$export$9007f49c319d1ac7 = $9s3uu.observeOn;

var $6wVip = parcelRequire("6wVip");
$57d4d9855b7856ca$export$5fba66d61591f42 = $6wVip.onErrorResumeNext;

var $vO84Z = parcelRequire("vO84Z");
$57d4d9855b7856ca$export$8f9d79d42bff1aac = $vO84Z.pairwise;

var $kZNgW = parcelRequire("kZNgW");
$57d4d9855b7856ca$export$b29f828819edca8d = $kZNgW.partition;

var $aOc77 = parcelRequire("aOc77");
$57d4d9855b7856ca$export$c44985b87d605eff = $aOc77.pluck;

var $3hbzh = parcelRequire("3hbzh");
$57d4d9855b7856ca$export$89b472e03be495df = $3hbzh.publish;

var $a9dHZ = parcelRequire("a9dHZ");
$57d4d9855b7856ca$export$16ae46fda9567053 = $a9dHZ.publishBehavior;

var $4ZbWy = parcelRequire("4ZbWy");
$57d4d9855b7856ca$export$42d9b6b38c68d989 = $4ZbWy.publishLast;

var $4g0k7 = parcelRequire("4g0k7");
$57d4d9855b7856ca$export$1f3342bf81d92d52 = $4g0k7.publishReplay;

var $6BYfk = parcelRequire("6BYfk");
$57d4d9855b7856ca$export$236c05de452bec2 = $6BYfk.race;

var $2N4j1 = parcelRequire("2N4j1");
$57d4d9855b7856ca$export$533b26079ad0b4b = $2N4j1.reduce;

var $8npYd = parcelRequire("8npYd");
$57d4d9855b7856ca$export$76d90c956114f2c2 = $8npYd.repeat;

var $4m82s = parcelRequire("4m82s");
$57d4d9855b7856ca$export$b39ac5b4ffd1415a = $4m82s.repeatWhen;

var $jbDDn = parcelRequire("jbDDn");
$57d4d9855b7856ca$export$9369b12211e1fce4 = $jbDDn.retry;

var $7O6Ck = parcelRequire("7O6Ck");
$57d4d9855b7856ca$export$1281551253cfee02 = $7O6Ck.retryWhen;

var $34NII = parcelRequire("34NII");
$57d4d9855b7856ca$export$18d0766d894cba0c = $34NII.refCount;

var $9hUXl = parcelRequire("9hUXl");
$57d4d9855b7856ca$export$4812e460280c6ef2 = $9hUXl.sample;

var $kPJ0i = parcelRequire("kPJ0i");
$57d4d9855b7856ca$export$fe33c7b2002d97b0 = $kPJ0i.sampleTime;

var $haxv1 = parcelRequire("haxv1");
$57d4d9855b7856ca$export$c87d910e63d22ed6 = $haxv1.scan;

var $iwZAW = parcelRequire("iwZAW");
$57d4d9855b7856ca$export$d0a07e60ae428313 = $iwZAW.sequenceEqual;

var $9TIZU = parcelRequire("9TIZU");
$57d4d9855b7856ca$export$ed80d9de1d9df928 = $9TIZU.share;

var $2n4lI = parcelRequire("2n4lI");
$57d4d9855b7856ca$export$db61d692014e534e = $2n4lI.shareReplay;

var $9Pl3U = parcelRequire("9Pl3U");
$57d4d9855b7856ca$export$863d7ca51b416cee = $9Pl3U.single;

var $l8un2 = parcelRequire("l8un2");
$57d4d9855b7856ca$export$955fc4a6c4be454d = $l8un2.skip;

var $b3Afl = parcelRequire("b3Afl");
$57d4d9855b7856ca$export$635f6273df29ea1c = $b3Afl.skipLast;

var $dMiA4 = parcelRequire("dMiA4");
$57d4d9855b7856ca$export$facc584867c26fde = $dMiA4.skipUntil;

var $3MURy = parcelRequire("3MURy");
$57d4d9855b7856ca$export$175dedd748069215 = $3MURy.skipWhile;

var $lwfFQ = parcelRequire("lwfFQ");
$57d4d9855b7856ca$export$a4fe86229b0e9bdd = $lwfFQ.startWith;

var $1csk5 = parcelRequire("1csk5");
$57d4d9855b7856ca$export$6a45284a4b0bf33a = $1csk5.switchAll;

var $6yPEx = parcelRequire("6yPEx");
$57d4d9855b7856ca$export$9f6ea8e48bc26eab = $6yPEx.switchMap;

var $aa4RZ = parcelRequire("aa4RZ");
$57d4d9855b7856ca$export$a439dc30c845238 = $aa4RZ.switchMapTo;

var $8TnD2 = parcelRequire("8TnD2");
$57d4d9855b7856ca$export$b7df5d561049483a = $8TnD2.take;

var $2eZlT = parcelRequire("2eZlT");
$57d4d9855b7856ca$export$1b47ad771ce5af5e = $2eZlT.takeLast;

var $itrTE = parcelRequire("itrTE");
$57d4d9855b7856ca$export$ac8dfd3a7ad06e80 = $itrTE.takeUntil;

var $29RSJ = parcelRequire("29RSJ");
$57d4d9855b7856ca$export$9384c7afe4015e42 = $29RSJ.takeWhile;

var $dBQte = parcelRequire("dBQte");
$57d4d9855b7856ca$export$3f23594af5f37336 = $dBQte.tap;

var $7Vtdp = parcelRequire("7Vtdp");
$57d4d9855b7856ca$export$de363e709c412c8a = $7Vtdp.throttle;

var $1NTdO = parcelRequire("1NTdO");
$57d4d9855b7856ca$export$4efe28f192921dd4 = $1NTdO.throttleTime;

var $kfhNV = parcelRequire("kfhNV");
$57d4d9855b7856ca$export$1a539c8b2950ab40 = $kfhNV.timeInterval;

var $6bEgU = parcelRequire("6bEgU");
$57d4d9855b7856ca$export$83e74882c5df8fe1 = $6bEgU.timeout;

var $7JnJx = parcelRequire("7JnJx");
$57d4d9855b7856ca$export$86fe999fba7953f2 = $7JnJx.timeoutWith;

var $coloa = parcelRequire("coloa");
$57d4d9855b7856ca$export$fc00ee57782020aa = $coloa.timestamp;

var $2arAN = parcelRequire("2arAN");
$57d4d9855b7856ca$export$45b10814cc054894 = $2arAN.toArray;

var $2QlNT = parcelRequire("2QlNT");
$57d4d9855b7856ca$export$8291e5b88f90ce4 = $2QlNT.window;

var $bkg2F = parcelRequire("bkg2F");
$57d4d9855b7856ca$export$f3a19e933f377396 = $bkg2F.windowCount;

var $3SRp7 = parcelRequire("3SRp7");
$57d4d9855b7856ca$export$1284415effa79ee0 = $3SRp7.windowTime;

var $aR6Rt = parcelRequire("aR6Rt");
$57d4d9855b7856ca$export$3182be990e0eeaad = $aR6Rt.windowToggle;

var $hiGV8 = parcelRequire("hiGV8");
$57d4d9855b7856ca$export$6a5dea797879f644 = $hiGV8.windowWhen;

var $hDran = parcelRequire("hDran");
$57d4d9855b7856ca$export$d449030e5c10edf7 = $hDran.withLatestFrom;

var $5f7nL = parcelRequire("5f7nL");
$57d4d9855b7856ca$export$8901015135f2fb22 = $5f7nL.zip;

var $u6syz = parcelRequire("u6syz");
$57d4d9855b7856ca$export$adddb6a2fa3864e9 = $u6syz.zipAll;

});
parcelRegister("6EsY3", function(module, exports) {
"use strict";
var $4d7cf2e00e09dbe1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jJdW6 = parcelRequire("jJdW6");

var $4b4q3 = parcelRequire("4b4q3");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */ function $4d7cf2e00e09dbe1$var$audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new $4d7cf2e00e09dbe1$var$AuditOperator(durationSelector));
    };
}
module.exports.audit = $4d7cf2e00e09dbe1$var$audit;
var $4d7cf2e00e09dbe1$var$AuditOperator = function() {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $4d7cf2e00e09dbe1$var$AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4d7cf2e00e09dbe1$var$AuditSubscriber = function(_super) {
    $4d7cf2e00e09dbe1$var$__extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
    }
    AuditSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = $jJdW6.tryCatch(this.durationSelector)(value);
            if (duration === $4b4q3.errorObject) this.destination.error($4b4q3.errorObject.e);
            else {
                var innerSubscription = $87MtM.subscribeToResult(this, duration);
                if (innerSubscription.closed) this.clearThrottle();
                else this.add(this.throttled = innerSubscription);
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function() {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function() {
        this.clearThrottle();
    };
    return AuditSubscriber;
}($6UnJS.OuterSubscriber);

});

parcelRegister("8Rio7", function(module, exports) {

$parcel$export(module.exports, "auditTime", () => $6731897458e7c8c2$export$719c70722b10e5ff, (v) => $6731897458e7c8c2$export$719c70722b10e5ff = v);
var $6731897458e7c8c2$export$719c70722b10e5ff;
"use strict";

var $jAy5L = parcelRequire("jAy5L");

var $6EsY3 = parcelRequire("6EsY3");

var $29oaj = parcelRequire("29oaj");
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */ function $6731897458e7c8c2$var$auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = $jAy5L.async;
    return $6EsY3.audit(function() {
        return $29oaj.timer(duration, scheduler);
    });
}
$6731897458e7c8c2$export$719c70722b10e5ff = $6731897458e7c8c2$var$auditTime;

});

parcelRegister("lQxTf", function(module, exports) {

$parcel$export(module.exports, "combineAll", () => $fe78be27543b4238$export$29ae691b7de52fe3, (v) => $fe78be27543b4238$export$29ae691b7de52fe3 = v);
var $fe78be27543b4238$export$29ae691b7de52fe3;
"use strict";

var $fEMiR = parcelRequire("fEMiR");
function $fe78be27543b4238$var$combineAll(project) {
    return function(source) {
        return source.lift(new $fEMiR.CombineLatestOperator(project));
    };
}
$fe78be27543b4238$export$29ae691b7de52fe3 = $fe78be27543b4238$var$combineAll;

});

parcelRegister("cmPKV", function(module, exports) {

$parcel$export(module.exports, "concatMapTo", () => $900fafbfb298cbe8$export$82fbd7a2841d2484, (v) => $900fafbfb298cbe8$export$82fbd7a2841d2484 = v);
var $900fafbfb298cbe8$export$82fbd7a2841d2484;
"use strict";

var $eGPtZ = parcelRequire("eGPtZ");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */ function $900fafbfb298cbe8$var$concatMapTo(innerObservable, resultSelector) {
    return $eGPtZ.concatMap(function() {
        return innerObservable;
    }, resultSelector);
}
$900fafbfb298cbe8$export$82fbd7a2841d2484 = $900fafbfb298cbe8$var$concatMapTo;

});

parcelRegister("9INaL", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function count(predicate) {
    return function(source) {
        return source.lift(new CountOperator(predicate, source));
    };
}
exports.count = count;
var CountOperator = function() {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var CountSubscriber = function(_super) {
    __extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function(value) {
        if (this.predicate) this._tryPredicate(value);
        else this.count++;
    };
    CountSubscriber.prototype._tryPredicate = function(value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.count++;
    };
    CountSubscriber.prototype._complete = function() {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("jrplL", function(module, exports) {
"use strict";
var $e27433ea0c9c0240$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $3JafE = parcelRequire("3JafE");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $e27433ea0c9c0240$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return new $e27433ea0c9c0240$var$SubscriptionDelayObservable(source, subscriptionDelay).lift(new $e27433ea0c9c0240$var$DelayWhenOperator(delayDurationSelector));
    };
    return function(source) {
        return source.lift(new $e27433ea0c9c0240$var$DelayWhenOperator(delayDurationSelector));
    };
}
module.exports.delayWhen = $e27433ea0c9c0240$var$delayWhen;
var $e27433ea0c9c0240$var$DelayWhenOperator = function() {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $e27433ea0c9c0240$var$DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e27433ea0c9c0240$var$DelayWhenSubscriber = function(_super) {
    $e27433ea0c9c0240$var$__extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) this.destination.next(value);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function(value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) this.tryDelay(delayNotifier, value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function() {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function(subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function(delayNotifier, value) {
        var notifierSubscription = $87MtM.subscribeToResult(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function() {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) this.destination.complete();
    };
    return DelayWhenSubscriber;
}($6UnJS.OuterSubscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e27433ea0c9c0240$var$SubscriptionDelayObservable = function(_super) {
    $e27433ea0c9c0240$var$__extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(/** @deprecated internal use only */ source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    /** @deprecated internal use only */ SubscriptionDelayObservable.prototype._subscribe = function(subscriber) {
        this.subscriptionDelay.subscribe(new $e27433ea0c9c0240$var$SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}($3JafE.Observable);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e27433ea0c9c0240$var$SubscriptionDelaySubscriber = function(_super) {
    $e27433ea0c9c0240$var$__extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function(unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function(err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function() {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function() {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("GQ41u", function(module, exports) {
"use strict";
var $080c4f298d24b623$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */ function $080c4f298d24b623$var$dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new $080c4f298d24b623$var$DeMaterializeOperator());
    };
}
module.exports.dematerialize = $080c4f298d24b623$var$dematerialize;
var $080c4f298d24b623$var$DeMaterializeOperator = function() {
    function DeMaterializeOperator() {}
    DeMaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $080c4f298d24b623$var$DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $080c4f298d24b623$var$DeMaterializeSubscriber = function(_super) {
    $080c4f298d24b623$var$__extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    DeMaterializeSubscriber.prototype._next = function(value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("aS1Fs", function(module, exports) {

$parcel$export(module.exports, "distinctUntilKeyChanged", () => $7ea03dad1c484c95$export$571da16e28367bde, (v) => $7ea03dad1c484c95$export$571da16e28367bde = v);
var $7ea03dad1c484c95$export$571da16e28367bde;
"use strict";

var $8xAAu = parcelRequire("8xAAu");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */ function $7ea03dad1c484c95$var$distinctUntilKeyChanged(key, compare) {
    return $8xAAu.distinctUntilChanged(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}
$7ea03dad1c484c95$export$571da16e28367bde = $7ea03dad1c484c95$var$distinctUntilKeyChanged;

});

parcelRegister("8WPKc", function(module, exports) {
"use strict";
var $683be0cdb6a2fde9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $2l9IB = parcelRequire("2l9IB");
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */ function $683be0cdb6a2fde9$var$elementAt(index, defaultValue) {
    return function(source) {
        return source.lift(new $683be0cdb6a2fde9$var$ElementAtOperator(index, defaultValue));
    };
}
module.exports.elementAt = $683be0cdb6a2fde9$var$elementAt;
var $683be0cdb6a2fde9$var$ElementAtOperator = function() {
    function ElementAtOperator(index, defaultValue) {
        this.index = index;
        this.defaultValue = defaultValue;
        if (index < 0) throw new $2l9IB.ArgumentOutOfRangeError;
    }
    ElementAtOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $683be0cdb6a2fde9$var$ElementAtSubscriber(subscriber, this.index, this.defaultValue));
    };
    return ElementAtOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $683be0cdb6a2fde9$var$ElementAtSubscriber = function(_super) {
    $683be0cdb6a2fde9$var$__extends(ElementAtSubscriber, _super);
    function ElementAtSubscriber(destination, index, defaultValue) {
        _super.call(this, destination);
        this.index = index;
        this.defaultValue = defaultValue;
    }
    ElementAtSubscriber.prototype._next = function(x) {
        if (this.index-- === 0) {
            this.destination.next(x);
            this.destination.complete();
        }
    };
    ElementAtSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index >= 0) {
            if (typeof this.defaultValue !== 'undefined') destination.next(this.defaultValue);
            else destination.error(new $2l9IB.ArgumentOutOfRangeError);
        }
        destination.complete();
    };
    return ElementAtSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("7OVJ1", function(module, exports) {
"use strict";
var $5b19faf2e2b0f1a6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */ function $5b19faf2e2b0f1a6$var$every(predicate, thisArg) {
    return function(source) {
        return source.lift(new $5b19faf2e2b0f1a6$var$EveryOperator(predicate, thisArg, source));
    };
}
module.exports.every = $5b19faf2e2b0f1a6$var$every;
var $5b19faf2e2b0f1a6$var$EveryOperator = function() {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $5b19faf2e2b0f1a6$var$EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5b19faf2e2b0f1a6$var$EverySubscriber = function(_super) {
    $5b19faf2e2b0f1a6$var$__extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
        this.index = 0;
        this.thisArg = thisArg || this;
    }
    EverySubscriber.prototype.notifyComplete = function(everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function(value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) this.notifyComplete(false);
    };
    EverySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("3VDHE", function(module, exports) {
"use strict";
var $2dc57e30ccabf3fd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */ function $2dc57e30ccabf3fd$var$exhaust() {
    return function(source) {
        return source.lift(new $2dc57e30ccabf3fd$var$SwitchFirstOperator());
    };
}
module.exports.exhaust = $2dc57e30ccabf3fd$var$exhaust;
var $2dc57e30ccabf3fd$var$SwitchFirstOperator = function() {
    function SwitchFirstOperator() {}
    SwitchFirstOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2dc57e30ccabf3fd$var$SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2dc57e30ccabf3fd$var$SwitchFirstSubscriber = function(_super) {
    $2dc57e30ccabf3fd$var$__extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        _super.call(this, destination);
        this.hasCompleted = false;
        this.hasSubscription = false;
    }
    SwitchFirstSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add($87MtM.subscribeToResult(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstSubscriber;
}($6UnJS.OuterSubscriber);

});

parcelRegister("3MmTN", function(module, exports) {
"use strict";
var $2c079e0ae269a818$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jJdW6 = parcelRequire("jJdW6");

var $4b4q3 = parcelRequire("4b4q3");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/* tslint:enable:max-line-length */ /**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */ function $2c079e0ae269a818$var$expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (scheduler === void 0) scheduler = undefined;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function(source) {
        return source.lift(new $2c079e0ae269a818$var$ExpandOperator(project, concurrent, scheduler));
    };
}
module.exports.expand = $2c079e0ae269a818$var$expand;
var $2c079e0ae269a818$var$ExpandOperator = function() {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2c079e0ae269a818$var$ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}();
module.exports.ExpandOperator = $2c079e0ae269a818$var$ExpandOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2c079e0ae269a818$var$ExpandSubscriber = function(_super) {
    $2c079e0ae269a818$var$__extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        _super.call(this, destination);
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
        this.index = 0;
        this.active = 0;
        this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) this.buffer = [];
    }
    ExpandSubscriber.dispatch = function(arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            var result = $jJdW6.tryCatch(this.project)(value, index);
            if (result === $4b4q3.errorObject) destination.error($4b4q3.errorObject.e);
            else if (!this.scheduler) this.subscribeToProjection(result, value, index);
            else {
                var state = {
                    subscriber: this,
                    result: result,
                    value: value,
                    index: index
                };
                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
            }
        } else this.buffer.push(value);
    };
    ExpandSubscriber.prototype.subscribeToProjection = function(result, value, index) {
        this.active++;
        this.add($87MtM.subscribeToResult(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    ExpandSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) this._next(buffer.shift());
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    return ExpandSubscriber;
}($6UnJS.OuterSubscriber);
module.exports.ExpandSubscriber = $2c079e0ae269a818$var$ExpandSubscriber;

});

parcelRegister("lHxIn", function(module, exports) {
"use strict";
var $fcc7c427fea3323e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");
/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */ function $fcc7c427fea3323e$var$find(predicate, thisArg) {
    if (typeof predicate !== 'function') throw new TypeError('predicate is not a function');
    return function(source) {
        return source.lift(new $fcc7c427fea3323e$var$FindValueOperator(predicate, source, false, thisArg));
    };
}
module.exports.find = $fcc7c427fea3323e$var$find;
var $fcc7c427fea3323e$var$FindValueOperator = function() {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $fcc7c427fea3323e$var$FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}();
module.exports.FindValueOperator = $fcc7c427fea3323e$var$FindValueOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fcc7c427fea3323e$var$FindValueSubscriber = function(_super) {
    $fcc7c427fea3323e$var$__extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
        this.index = 0;
    }
    FindValueSubscriber.prototype.notifyComplete = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    FindValueSubscriber.prototype._next = function(value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) this.notifyComplete(this.yieldIndex ? index : value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function() {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}($a7QRR.Subscriber);
module.exports.FindValueSubscriber = $fcc7c427fea3323e$var$FindValueSubscriber;

});

parcelRegister("1as0c", function(module, exports) {

$parcel$export(module.exports, "findIndex", () => $0d9c7244067d9f71$export$de3a4d4a0d731119, (v) => $0d9c7244067d9f71$export$de3a4d4a0d731119 = v);
var $0d9c7244067d9f71$export$de3a4d4a0d731119;
"use strict";

var $lHxIn = parcelRequire("lHxIn");
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */ function $0d9c7244067d9f71$var$findIndex(predicate, thisArg) {
    return function(source) {
        return source.lift(new $lHxIn.FindValueOperator(predicate, source, true, thisArg));
    };
}
$0d9c7244067d9f71$export$de3a4d4a0d731119 = $0d9c7244067d9f71$var$findIndex;

});

parcelRegister("b095i", function(module, exports) {
"use strict";
var $8026bdc5b52f9431$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");
function $8026bdc5b52f9431$var$isEmpty() {
    return function(source) {
        return source.lift(new $8026bdc5b52f9431$var$IsEmptyOperator());
    };
}
module.exports.isEmpty = $8026bdc5b52f9431$var$isEmpty;
var $8026bdc5b52f9431$var$IsEmptyOperator = function() {
    function IsEmptyOperator() {}
    IsEmptyOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $8026bdc5b52f9431$var$IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8026bdc5b52f9431$var$IsEmptySubscriber = function(_super) {
    $8026bdc5b52f9431$var$__extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        _super.call(this, destination);
    }
    IsEmptySubscriber.prototype.notifyComplete = function(isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function(value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("iH3rg", function(module, exports) {
"use strict";
var $d9bee9014899c317$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $8CxxK = parcelRequire("8CxxK");
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */ function $d9bee9014899c317$var$materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new $d9bee9014899c317$var$MaterializeOperator());
    };
}
module.exports.materialize = $d9bee9014899c317$var$materialize;
var $d9bee9014899c317$var$MaterializeOperator = function() {
    function MaterializeOperator() {}
    MaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d9bee9014899c317$var$MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d9bee9014899c317$var$MaterializeSubscriber = function(_super) {
    $d9bee9014899c317$var$__extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    MaterializeSubscriber.prototype._next = function(value) {
        this.destination.next($8CxxK.Notification.createNext(value));
    };
    MaterializeSubscriber.prototype._error = function(err) {
        var destination = this.destination;
        destination.next($8CxxK.Notification.createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function() {
        var destination = this.destination;
        destination.next($8CxxK.Notification.createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("k4LFb", function(module, exports) {

$parcel$export(module.exports, "max", () => $e9d92748a5a915ec$export$8960430cfd85939f, (v) => $e9d92748a5a915ec$export$8960430cfd85939f = v);
var $e9d92748a5a915ec$export$8960430cfd85939f;
"use strict";

var $2N4j1 = parcelRequire("2N4j1");
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */ function $e9d92748a5a915ec$var$max(comparer) {
    var max = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    };
    return $2N4j1.reduce(max);
}
$e9d92748a5a915ec$export$8960430cfd85939f = $e9d92748a5a915ec$var$max;

});

parcelRegister("g0vpX", function(module, exports) {
"use strict";
var $ba7504565beee60f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */ function $ba7504565beee60f$var$mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return function(source) {
        return source.lift(new $ba7504565beee60f$var$MergeMapToOperator(innerObservable, resultSelector, concurrent));
    };
}
module.exports.mergeMapTo = $ba7504565beee60f$var$mergeMapTo;
// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
var $ba7504565beee60f$var$MergeMapToOperator = function() {
    function MergeMapToOperator(ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapToOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $ba7504565beee60f$var$MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
    };
    return MergeMapToOperator;
}();
module.exports.MergeMapToOperator = $ba7504565beee60f$var$MergeMapToOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ba7504565beee60f$var$MergeMapToSubscriber = function(_super) {
    $ba7504565beee60f$var$__extends(MergeMapToSubscriber, _super);
    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapToSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var resultSelector = this.resultSelector;
            var index = this.index++;
            var ish = this.ish;
            var destination = this.destination;
            this.active++;
            this._innerSub(ish, destination, resultSelector, value, index);
        } else this.buffer.push(value);
    };
    MergeMapToSubscriber.prototype._innerSub = function(ish, destination, resultSelector, value, index) {
        this.add($87MtM.subscribeToResult(this, ish, value, index));
    };
    MergeMapToSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapToSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    MergeMapToSubscriber.prototype.trySelectResult = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    MergeMapToSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    MergeMapToSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapToSubscriber;
}($6UnJS.OuterSubscriber);
module.exports.MergeMapToSubscriber = $ba7504565beee60f$var$MergeMapToSubscriber;

});

parcelRegister("6zXYF", function(module, exports) {
"use strict";
var $4ca48939de6a2f0b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jJdW6 = parcelRequire("jJdW6");

var $4b4q3 = parcelRequire("4b4q3");

var $87MtM = parcelRequire("87MtM");

var $6UnJS = parcelRequire("6UnJS");
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */ function $4ca48939de6a2f0b$var$mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function(source) {
        return source.lift(new $4ca48939de6a2f0b$var$MergeScanOperator(accumulator, seed, concurrent));
    };
}
module.exports.mergeScan = $4ca48939de6a2f0b$var$mergeScan;
var $4ca48939de6a2f0b$var$MergeScanOperator = function() {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $4ca48939de6a2f0b$var$MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}();
module.exports.MergeScanOperator = $4ca48939de6a2f0b$var$MergeScanOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4ca48939de6a2f0b$var$MergeScanSubscriber = function(_super) {
    $4ca48939de6a2f0b$var$__extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this.acc = acc;
        this.concurrent = concurrent;
        this.hasValue = false;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeScanSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var ish = $jJdW6.tryCatch(this.accumulator)(this.acc, value);
            var destination = this.destination;
            if (ish === $4b4q3.errorObject) destination.error($4b4q3.errorObject.e);
            else {
                this.active++;
                this._innerSub(ish, value, index);
            }
        } else this.buffer.push(value);
    };
    MergeScanSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($87MtM.subscribeToResult(this, ish, value, index));
    };
    MergeScanSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    MergeScanSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}($6UnJS.OuterSubscriber);
module.exports.MergeScanSubscriber = $4ca48939de6a2f0b$var$MergeScanSubscriber;

});

parcelRegister("jwlZG", function(module, exports) {

$parcel$export(module.exports, "min", () => $e362110636412513$export$96ec731ed4dcb222, (v) => $e362110636412513$export$96ec731ed4dcb222 = v);
var $e362110636412513$export$96ec731ed4dcb222;
"use strict";

var $2N4j1 = parcelRequire("2N4j1");
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */ function $e362110636412513$var$min(comparer) {
    var min = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    };
    return $2N4j1.reduce(min);
}
$e362110636412513$export$96ec731ed4dcb222 = $e362110636412513$var$min;

});

parcelRegister("6wVip", function(module, exports) {
"use strict";
var $4c122d03b789c956$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3Th2Y = parcelRequire("3Th2Y");

var $3DoUz = parcelRequire("3DoUz");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/* tslint:enable:max-line-length */ /**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */ function $4c122d03b789c956$var$onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    if (nextSources.length === 1 && $3DoUz.isArray(nextSources[0])) nextSources = nextSources[0];
    return function(source) {
        return source.lift(new $4c122d03b789c956$var$OnErrorResumeNextOperator(nextSources));
    };
}
module.exports.onErrorResumeNext = $4c122d03b789c956$var$onErrorResumeNext;
/* tslint:enable:max-line-length */ function $4c122d03b789c956$var$onErrorResumeNextStatic() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    var source = null;
    if (nextSources.length === 1 && $3DoUz.isArray(nextSources[0])) nextSources = nextSources[0];
    source = nextSources.shift();
    return new $3Th2Y.FromObservable(source, null).lift(new $4c122d03b789c956$var$OnErrorResumeNextOperator(nextSources));
}
module.exports.onErrorResumeNextStatic = $4c122d03b789c956$var$onErrorResumeNextStatic;
var $4c122d03b789c956$var$OnErrorResumeNextOperator = function() {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $4c122d03b789c956$var$OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}();
var $4c122d03b789c956$var$OnErrorResumeNextSubscriber = function(_super) {
    $4c122d03b789c956$var$__extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        _super.call(this, destination);
        this.destination = destination;
        this.nextSources = nextSources;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function(error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function(innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function(err) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function() {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function() {
        var next = this.nextSources.shift();
        if (next) this.add($87MtM.subscribeToResult(this, next));
        else this.destination.complete();
    };
    return OnErrorResumeNextSubscriber;
}($6UnJS.OuterSubscriber);

});

parcelRegister("kZNgW", function(module, exports) {

$parcel$export(module.exports, "partition", () => $f48fb99ec61c7ca1$export$b29f828819edca8d, (v) => $f48fb99ec61c7ca1$export$b29f828819edca8d = v);
var $f48fb99ec61c7ca1$export$b29f828819edca8d;
"use strict";

var $7sUoU = parcelRequire("7sUoU");

var $dXapj = parcelRequire("dXapj");
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $f48fb99ec61c7ca1$var$partition(predicate, thisArg) {
    return function(source) {
        return [
            $dXapj.filter(predicate, thisArg)(source),
            $dXapj.filter($7sUoU.not(predicate, thisArg))(source)
        ];
    };
}
$f48fb99ec61c7ca1$export$b29f828819edca8d = $f48fb99ec61c7ca1$var$partition;

});
parcelRegister("7sUoU", function(module, exports) {

$parcel$export(module.exports, "not", () => $56f6e5f714cd778e$export$6003a5f097c73977, (v) => $56f6e5f714cd778e$export$6003a5f097c73977 = v);
var $56f6e5f714cd778e$export$6003a5f097c73977;
"use strict";
function $56f6e5f714cd778e$var$not(pred, thisArg) {
    function notPred() {
        return !notPred.pred.apply(notPred.thisArg, arguments);
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
$56f6e5f714cd778e$export$6003a5f097c73977 = $56f6e5f714cd778e$var$not;

});


parcelRegister("3hbzh", function(module, exports) {

$parcel$export(module.exports, "publish", () => $262beece1799de9f$export$89b472e03be495df, (v) => $262beece1799de9f$export$89b472e03be495df = v);
var $262beece1799de9f$export$89b472e03be495df;
"use strict";

var $70s4u = parcelRequire("70s4u");

var $lCBlc = parcelRequire("lCBlc");
/* tslint:enable:max-line-length */ /**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */ function $262beece1799de9f$var$publish(selector) {
    return selector ? $lCBlc.multicast(function() {
        return new $70s4u.Subject();
    }, selector) : $lCBlc.multicast(new $70s4u.Subject());
}
$262beece1799de9f$export$89b472e03be495df = $262beece1799de9f$var$publish;

});

parcelRegister("a9dHZ", function(module, exports) {

$parcel$export(module.exports, "publishBehavior", () => $763560d986e95ab6$export$16ae46fda9567053, (v) => $763560d986e95ab6$export$16ae46fda9567053 = v);
var $763560d986e95ab6$export$16ae46fda9567053;
"use strict";

var $1JMwO = parcelRequire("1JMwO");

var $lCBlc = parcelRequire("lCBlc");
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */ function $763560d986e95ab6$var$publishBehavior(value) {
    return function(source) {
        return $lCBlc.multicast(new $1JMwO.BehaviorSubject(value))(source);
    };
}
$763560d986e95ab6$export$16ae46fda9567053 = $763560d986e95ab6$var$publishBehavior;

});

parcelRegister("4ZbWy", function(module, exports) {

$parcel$export(module.exports, "publishLast", () => $3a161fa9cd4a2fb6$export$42d9b6b38c68d989, (v) => $3a161fa9cd4a2fb6$export$42d9b6b38c68d989 = v);
var $3a161fa9cd4a2fb6$export$42d9b6b38c68d989;
"use strict";

var $gfQga = parcelRequire("gfQga");

var $lCBlc = parcelRequire("lCBlc");
function $3a161fa9cd4a2fb6$var$publishLast() {
    return function(source) {
        return $lCBlc.multicast(new $gfQga.AsyncSubject())(source);
    };
}
$3a161fa9cd4a2fb6$export$42d9b6b38c68d989 = $3a161fa9cd4a2fb6$var$publishLast;

});
parcelRegister("gfQga", function(module, exports) {
"use strict";
var $bd5695c1c03985b5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $70s4u = parcelRequire("70s4u");

var $hIoOm = parcelRequire("hIoOm");
/**
 * @class AsyncSubject<T>
 */ var $bd5695c1c03985b5$var$AsyncSubject = function(_super) {
    $bd5695c1c03985b5$var$__extends(AsyncSubject, _super);
    function AsyncSubject() {
        _super.apply(this, arguments);
        this.value = null;
        this.hasNext = false;
        this.hasCompleted = false;
    }
    /** @deprecated internal use only */ AsyncSubject.prototype._subscribe = function(subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return $hIoOm.Subscription.EMPTY;
        } else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return $hIoOm.Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function(error) {
        if (!this.hasCompleted) _super.prototype.error.call(this, error);
    };
    AsyncSubject.prototype.complete = function() {
        this.hasCompleted = true;
        if (this.hasNext) _super.prototype.next.call(this, this.value);
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}($70s4u.Subject);
module.exports.AsyncSubject = $bd5695c1c03985b5$var$AsyncSubject;

});


parcelRegister("4g0k7", function(module, exports) {

$parcel$export(module.exports, "publishReplay", () => $3198e846e9f97c74$export$1f3342bf81d92d52, (v) => $3198e846e9f97c74$export$1f3342bf81d92d52 = v);
var $3198e846e9f97c74$export$1f3342bf81d92d52;
"use strict";

var $lXGL9 = parcelRequire("lXGL9");

var $lCBlc = parcelRequire("lCBlc");
/* tslint:enable:max-line-length */ function $3198e846e9f97c74$var$publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') scheduler = selectorOrScheduler;
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new $lXGL9.ReplaySubject(bufferSize, windowTime, scheduler);
    return function(source) {
        return $lCBlc.multicast(function() {
            return subject;
        }, selector)(source);
    };
}
$3198e846e9f97c74$export$1f3342bf81d92d52 = $3198e846e9f97c74$var$publishReplay;

});

parcelRegister("6BYfk", function(module, exports) {

$parcel$export(module.exports, "race", () => $4d04ee7226c72b3f$export$236c05de452bec2, (v) => $4d04ee7226c72b3f$export$236c05de452bec2 = v);
var $4d04ee7226c72b3f$export$236c05de452bec2;
"use strict";

var $3DoUz = parcelRequire("3DoUz");

var $hoEqm = parcelRequire("hoEqm");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */ function $4d04ee7226c72b3f$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function raceOperatorFunction(source) {
        // if the only argument is an array, it was most likely called with
        // `pair([obs1, obs2, ...])`
        if (observables.length === 1 && $3DoUz.isArray(observables[0])) observables = observables[0];
        return source.lift.call($hoEqm.race.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$4d04ee7226c72b3f$export$236c05de452bec2 = $4d04ee7226c72b3f$var$race;

});
parcelRegister("hoEqm", function(module, exports) {
"use strict";
var $0344b5d27faa5477$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3DoUz = parcelRequire("3DoUz");

var $1Lh1X = parcelRequire("1Lh1X");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
function $0344b5d27faa5477$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    // if the only argument is an array, it was most likely called with
    // `race([obs1, obs2, ...])`
    if (observables.length === 1) {
        if ($3DoUz.isArray(observables[0])) observables = observables[0];
        else return observables[0];
    }
    return new $1Lh1X.ArrayObservable(observables).lift(new $0344b5d27faa5477$var$RaceOperator());
}
module.exports.race = $0344b5d27faa5477$var$race;
var $0344b5d27faa5477$var$RaceOperator = function() {
    function RaceOperator() {}
    RaceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0344b5d27faa5477$var$RaceSubscriber(subscriber));
    };
    return RaceOperator;
}();
module.exports.RaceOperator = $0344b5d27faa5477$var$RaceOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0344b5d27faa5477$var$RaceSubscriber = function(_super) {
    $0344b5d27faa5477$var$__extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        _super.call(this, destination);
        this.hasFirst = false;
        this.observables = [];
        this.subscriptions = [];
    }
    RaceSubscriber.prototype._next = function(observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            for(var i = 0; i < len && !this.hasFirst; i++){
                var observable = observables[i];
                var subscription = $87MtM.subscribeToResult(this, observable, observable, i);
                if (this.subscriptions) this.subscriptions.push(subscription);
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for(var i = 0; i < this.subscriptions.length; i++)if (i !== outerIndex) {
                var subscription = this.subscriptions[i];
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}($6UnJS.OuterSubscriber);
module.exports.RaceSubscriber = $0344b5d27faa5477$var$RaceSubscriber;

});


parcelRegister("8npYd", function(module, exports) {
"use strict";
var $61949ddbcd71a424$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $9x82Y = parcelRequire("9x82Y");
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */ function $61949ddbcd71a424$var$repeat(count) {
    if (count === void 0) count = -1;
    return function(source) {
        if (count === 0) return new $9x82Y.EmptyObservable();
        else if (count < 0) return source.lift(new $61949ddbcd71a424$var$RepeatOperator(-1, source));
        else return source.lift(new $61949ddbcd71a424$var$RepeatOperator(count - 1, source));
    };
}
module.exports.repeat = $61949ddbcd71a424$var$repeat;
var $61949ddbcd71a424$var$RepeatOperator = function() {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $61949ddbcd71a424$var$RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $61949ddbcd71a424$var$RepeatSubscriber = function(_super) {
    $61949ddbcd71a424$var$__extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RepeatSubscriber.prototype.complete = function() {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.complete.call(this);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("4m82s", function(module, exports) {
"use strict";
var $32bf73d21277d821$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $70s4u = parcelRequire("70s4u");

var $jJdW6 = parcelRequire("jJdW6");

var $4b4q3 = parcelRequire("4b4q3");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */ function $32bf73d21277d821$var$repeatWhen(notifier) {
    return function(source) {
        return source.lift(new $32bf73d21277d821$var$RepeatWhenOperator(notifier));
    };
}
module.exports.repeatWhen = $32bf73d21277d821$var$repeatWhen;
var $32bf73d21277d821$var$RepeatWhenOperator = function() {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $32bf73d21277d821$var$RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $32bf73d21277d821$var$RepeatWhenSubscriber = function(_super) {
    $32bf73d21277d821$var$__extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
        this.sourceIsBeingSubscribedTo = true;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) return _super.prototype.complete.call(this);
    };
    RepeatWhenSubscriber.prototype.complete = function() {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) this.subscribeToRetries();
            if (!this.retriesSubscription || this.retriesSubscription.closed) return _super.prototype.complete.call(this);
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.notifications = null;
        this.retries = null;
        this.retriesSubscription = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this.notifications = notifications;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function() {
        this.notifications = new $70s4u.Subject();
        var retries = $jJdW6.tryCatch(this.notifier)(this.notifications);
        if (retries === $4b4q3.errorObject) return _super.prototype.complete.call(this);
        this.retries = retries;
        this.retriesSubscription = $87MtM.subscribeToResult(this, retries);
    };
    return RepeatWhenSubscriber;
}($6UnJS.OuterSubscriber);

});

parcelRegister("kPJ0i", function(module, exports) {
"use strict";
var $f2ab7ae0b6fb5baa$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $jAy5L = parcelRequire("jAy5L");
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */ function $f2ab7ae0b6fb5baa$var$sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = $jAy5L.async;
    return function(source) {
        return source.lift(new $f2ab7ae0b6fb5baa$var$SampleTimeOperator(period, scheduler));
    };
}
module.exports.sampleTime = $f2ab7ae0b6fb5baa$var$sampleTime;
var $f2ab7ae0b6fb5baa$var$SampleTimeOperator = function() {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $f2ab7ae0b6fb5baa$var$SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f2ab7ae0b6fb5baa$var$SampleTimeSubscriber = function(_super) {
    $f2ab7ae0b6fb5baa$var$__extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        _super.call(this, destination);
        this.period = period;
        this.scheduler = scheduler;
        this.hasValue = false;
        this.add(scheduler.schedule($f2ab7ae0b6fb5baa$var$dispatchNotification, period, {
            subscriber: this,
            period: period
        }));
    }
    SampleTimeSubscriber.prototype._next = function(value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}($a7QRR.Subscriber);
function $f2ab7ae0b6fb5baa$var$dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}

});

parcelRegister("iwZAW", function(module, exports) {
"use strict";
var $d7dafe9cc0eb1117$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $jJdW6 = parcelRequire("jJdW6");

var $4b4q3 = parcelRequire("4b4q3");
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */ function $d7dafe9cc0eb1117$var$sequenceEqual(compareTo, comparor) {
    return function(source) {
        return source.lift(new $d7dafe9cc0eb1117$var$SequenceEqualOperator(compareTo, comparor));
    };
}
module.exports.sequenceEqual = $d7dafe9cc0eb1117$var$sequenceEqual;
var $d7dafe9cc0eb1117$var$SequenceEqualOperator = function() {
    function SequenceEqualOperator(compareTo, comparor) {
        this.compareTo = compareTo;
        this.comparor = comparor;
    }
    SequenceEqualOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d7dafe9cc0eb1117$var$SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
    };
    return SequenceEqualOperator;
}();
module.exports.SequenceEqualOperator = $d7dafe9cc0eb1117$var$SequenceEqualOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d7dafe9cc0eb1117$var$SequenceEqualSubscriber = function(_super) {
    $d7dafe9cc0eb1117$var$__extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparor) {
        _super.call(this, destination);
        this.compareTo = compareTo;
        this.comparor = comparor;
        this._a = [];
        this._b = [];
        this._oneComplete = false;
        this.add(compareTo.subscribe(new $d7dafe9cc0eb1117$var$SequenceEqualCompareToSubscriber(destination, this)));
    }
    SequenceEqualSubscriber.prototype._next = function(value) {
        if (this._oneComplete && this._b.length === 0) this.emit(false);
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function() {
        if (this._oneComplete) this.emit(this._a.length === 0 && this._b.length === 0);
        else this._oneComplete = true;
    };
    SequenceEqualSubscriber.prototype.checkValues = function() {
        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
        while(_a.length > 0 && _b.length > 0){
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            if (comparor) {
                areEqual = $jJdW6.tryCatch(comparor)(a, b);
                if (areEqual === $4b4q3.errorObject) this.destination.error($4b4q3.errorObject.e);
            } else areEqual = a === b;
            if (!areEqual) this.emit(false);
        }
    };
    SequenceEqualSubscriber.prototype.emit = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function(value) {
        if (this._oneComplete && this._a.length === 0) this.emit(false);
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    return SequenceEqualSubscriber;
}($a7QRR.Subscriber);
module.exports.SequenceEqualSubscriber = $d7dafe9cc0eb1117$var$SequenceEqualSubscriber;
var $d7dafe9cc0eb1117$var$SequenceEqualCompareToSubscriber = function(_super) {
    $d7dafe9cc0eb1117$var$__extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        _super.call(this, destination);
        this.parent = parent;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function(value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function(err) {
        this.parent.error(err);
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function() {
        this.parent._complete();
    };
    return SequenceEqualCompareToSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("2n4lI", function(module, exports) {

$parcel$export(module.exports, "shareReplay", () => $1ba11a7226d88d0a$export$db61d692014e534e, (v) => $1ba11a7226d88d0a$export$db61d692014e534e = v);
var $1ba11a7226d88d0a$export$db61d692014e534e;
"use strict";

var $lXGL9 = parcelRequire("lXGL9");
/**
 * @method shareReplay
 * @owner Observable
 */ function $1ba11a7226d88d0a$var$shareReplay(bufferSize, windowTime, scheduler) {
    return function(source) {
        return source.lift($1ba11a7226d88d0a$var$shareReplayOperator(bufferSize, windowTime, scheduler));
    };
}
$1ba11a7226d88d0a$export$db61d692014e534e = $1ba11a7226d88d0a$var$shareReplay;
function $1ba11a7226d88d0a$var$shareReplayOperator(bufferSize, windowTime, scheduler) {
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        if (!subject || hasError) {
            hasError = false;
            subject = new $lXGL9.ReplaySubject(bufferSize, windowTime, scheduler);
            subscription = source.subscribe({
                next: function(value) {
                    subject.next(value);
                },
                error: function(err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function() {
                    isComplete = true;
                    subject.complete();
                }
            });
        }
        var innerSub = subject.subscribe(this);
        return function() {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && refCount === 0 && isComplete) subscription.unsubscribe();
        };
    };
}

});

parcelRegister("9Pl3U", function(module, exports) {
"use strict";
var $727936f8f067a9de$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $iJ8IY = parcelRequire("iJ8IY");
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */ function $727936f8f067a9de$var$single(predicate) {
    return function(source) {
        return source.lift(new $727936f8f067a9de$var$SingleOperator(predicate, source));
    };
}
module.exports.single = $727936f8f067a9de$var$single;
var $727936f8f067a9de$var$SingleOperator = function() {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $727936f8f067a9de$var$SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $727936f8f067a9de$var$SingleSubscriber = function(_super) {
    $727936f8f067a9de$var$__extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.seenValue = false;
        this.index = 0;
    }
    SingleSubscriber.prototype.applySingleValue = function(value) {
        if (this.seenValue) this.destination.error('Sequence contains more than one element');
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this.tryNext(value, index);
        else this.applySingleValue(value);
    };
    SingleSubscriber.prototype.tryNext = function(value, index) {
        try {
            if (this.predicate(value, index, this.source)) this.applySingleValue(value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        } else destination.error(new $iJ8IY.EmptyError);
    };
    return SingleSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("l8un2", function(module, exports) {
"use strict";
var $f631e74d5bdf6cd6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $f631e74d5bdf6cd6$var$skip(count) {
    return function(source) {
        return source.lift(new $f631e74d5bdf6cd6$var$SkipOperator(count));
    };
}
module.exports.skip = $f631e74d5bdf6cd6$var$skip;
var $f631e74d5bdf6cd6$var$SkipOperator = function() {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $f631e74d5bdf6cd6$var$SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f631e74d5bdf6cd6$var$SkipSubscriber = function(_super) {
    $f631e74d5bdf6cd6$var$__extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    SkipSubscriber.prototype._next = function(x) {
        if (++this.count > this.total) this.destination.next(x);
    };
    return SkipSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("b3Afl", function(module, exports) {
"use strict";
var $80cc1753d77dac56$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $2l9IB = parcelRequire("2l9IB");
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */ function $80cc1753d77dac56$var$skipLast(count) {
    return function(source) {
        return source.lift(new $80cc1753d77dac56$var$SkipLastOperator(count));
    };
}
module.exports.skipLast = $80cc1753d77dac56$var$skipLast;
var $80cc1753d77dac56$var$SkipLastOperator = function() {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) throw new $2l9IB.ArgumentOutOfRangeError;
    }
    SkipLastOperator.prototype.call = function(subscriber, source) {
        if (this._skipCount === 0) // If we don't want to skip any values then just subscribe
        // to Subscriber without any further logic.
        return source.subscribe(new $a7QRR.Subscriber(subscriber));
        else return source.subscribe(new $80cc1753d77dac56$var$SkipLastSubscriber(subscriber, this._skipCount));
    };
    return SkipLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $80cc1753d77dac56$var$SkipLastSubscriber = function(_super) {
    $80cc1753d77dac56$var$__extends(SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        _super.call(this, destination);
        this._skipCount = _skipCount;
        this._count = 0;
        this._ring = new Array(_skipCount);
    }
    SkipLastSubscriber.prototype._next = function(value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) this._ring[count] = value;
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("dMiA4", function(module, exports) {
"use strict";
var $a07e2bd4db1f8075$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */ function $a07e2bd4db1f8075$var$skipUntil(notifier) {
    return function(source) {
        return source.lift(new $a07e2bd4db1f8075$var$SkipUntilOperator(notifier));
    };
}
module.exports.skipUntil = $a07e2bd4db1f8075$var$skipUntil;
var $a07e2bd4db1f8075$var$SkipUntilOperator = function() {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a07e2bd4db1f8075$var$SkipUntilSubscriber(subscriber, this.notifier));
    };
    return SkipUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a07e2bd4db1f8075$var$SkipUntilSubscriber = function(_super) {
    $a07e2bd4db1f8075$var$__extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.hasValue = false;
        this.isInnerStopped = false;
        this.add($87MtM.subscribeToResult(this, notifier));
    }
    SkipUntilSubscriber.prototype._next = function(value) {
        if (this.hasValue) _super.prototype._next.call(this, value);
    };
    SkipUntilSubscriber.prototype._complete = function() {
        if (this.isInnerStopped) _super.prototype._complete.call(this);
        else this.unsubscribe();
    };
    SkipUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
    };
    SkipUntilSubscriber.prototype.notifyComplete = function() {
        this.isInnerStopped = true;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    return SkipUntilSubscriber;
}($6UnJS.OuterSubscriber);

});

parcelRegister("3MURy", function(module, exports) {
"use strict";
var $2c21f68bea52c4bd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $2c21f68bea52c4bd$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $2c21f68bea52c4bd$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $2c21f68bea52c4bd$var$skipWhile;
var $2c21f68bea52c4bd$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2c21f68bea52c4bd$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2c21f68bea52c4bd$var$SkipWhileSubscriber = function(_super) {
    $2c21f68bea52c4bd$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("1csk5", function(module, exports) {

$parcel$export(module.exports, "switchAll", () => $0dfce1cc6a041396$export$6a45284a4b0bf33a, (v) => $0dfce1cc6a041396$export$6a45284a4b0bf33a = v);
var $0dfce1cc6a041396$export$6a45284a4b0bf33a;
"use strict";

var $6yPEx = parcelRequire("6yPEx");

var $g5M3H = parcelRequire("g5M3H");
function $0dfce1cc6a041396$var$switchAll() {
    return $6yPEx.switchMap($g5M3H.identity);
}
$0dfce1cc6a041396$export$6a45284a4b0bf33a = $0dfce1cc6a041396$var$switchAll;

});

parcelRegister("kfhNV", function(module, exports) {
"use strict";
var $ebd304e5af9707dc$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $jAy5L = parcelRequire("jAy5L");
function $ebd304e5af9707dc$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $jAy5L.async;
    return function(source) {
        return source.lift(new $ebd304e5af9707dc$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $ebd304e5af9707dc$var$timeInterval;
var $ebd304e5af9707dc$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $ebd304e5af9707dc$var$TimeInterval;
var $ebd304e5af9707dc$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $ebd304e5af9707dc$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ebd304e5af9707dc$var$TimeIntervalSubscriber = function(_super) {
    $ebd304e5af9707dc$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $ebd304e5af9707dc$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("6bEgU", function(module, exports) {
"use strict";
var $48130245044e6901$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jAy5L = parcelRequire("jAy5L");

var $lmVpl = parcelRequire("lmVpl");

var $a7QRR = parcelRequire("a7QRR");

var $04KXD = parcelRequire("04KXD");
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $48130245044e6901$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $jAy5L.async;
    var absoluteTimeout = $lmVpl.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $48130245044e6901$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $04KXD.TimeoutError()));
    };
}
module.exports.timeout = $48130245044e6901$var$timeout;
var $48130245044e6901$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $48130245044e6901$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $48130245044e6901$var$TimeoutSubscriber = function(_super) {
    $48130245044e6901$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($a7QRR.Subscriber);

});
parcelRegister("04KXD", function(module, exports) {
"use strict";
var $00e4cd47ebde33ae$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $00e4cd47ebde33ae$var$TimeoutError = function(_super) {
    $00e4cd47ebde33ae$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $00e4cd47ebde33ae$var$TimeoutError;

});


parcelRegister("7JnJx", function(module, exports) {
"use strict";
var $5a0f25567b9174cd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jAy5L = parcelRequire("jAy5L");

var $lmVpl = parcelRequire("lmVpl");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/* tslint:enable:max-line-length */ /**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */ function $5a0f25567b9174cd$var$timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = $jAy5L.async;
    return function(source) {
        var absoluteTimeout = $lmVpl.isDate(due);
        var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
        return source.lift(new $5a0f25567b9174cd$var$TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
module.exports.timeoutWith = $5a0f25567b9174cd$var$timeoutWith;
var $5a0f25567b9174cd$var$TimeoutWithOperator = function() {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $5a0f25567b9174cd$var$TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5a0f25567b9174cd$var$TimeoutWithSubscriber = function(_super) {
    $5a0f25567b9174cd$var$__extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutWithSubscriber.dispatchTimeout = function(subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add($87MtM.subscribeToResult(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutWithSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutWithSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}($6UnJS.OuterSubscriber);

});

parcelRegister("coloa", function(module, exports) {
"use strict";

var $jAy5L = parcelRequire("jAy5L");

var $aynDk = parcelRequire("aynDk");
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */ function timestamp(scheduler) {
    if (scheduler === void 0) scheduler = $jAy5L.async;
    return $aynDk.map(function(value) {
        return new Timestamp(value, scheduler.now());
    });
// return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
}
exports.timestamp = timestamp;
var Timestamp = function() {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}();
exports.Timestamp = Timestamp;

});

parcelRegister("bkg2F", function(module, exports) {
"use strict";
var $83ee019273a581fe$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $70s4u = parcelRequire("70s4u");
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */ function $83ee019273a581fe$var$windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return function windowCountOperatorFunction(source) {
        return source.lift(new $83ee019273a581fe$var$WindowCountOperator(windowSize, startWindowEvery));
    };
}
module.exports.windowCount = $83ee019273a581fe$var$windowCount;
var $83ee019273a581fe$var$WindowCountOperator = function() {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $83ee019273a581fe$var$WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $83ee019273a581fe$var$WindowCountSubscriber = function(_super) {
    $83ee019273a581fe$var$__extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
        this.windows = [
            new $70s4u.Subject()
        ];
        this.count = 0;
        destination.next(this.windows[0]);
    }
    WindowCountSubscriber.prototype._next = function(value) {
        var startWindowEvery = this.startWindowEvery > 0 ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len && !this.closed; i++)windows[i].next(value);
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) windows.shift().complete();
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new $70s4u.Subject();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function() {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowCountSubscriber.prototype._unsubscribe = function() {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("3SRp7", function(module, exports) {
"use strict";
var $2d3fd72de49b1523$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $70s4u = parcelRequire("70s4u");

var $jAy5L = parcelRequire("jAy5L");

var $a7QRR = parcelRequire("a7QRR");

var $aziyh = parcelRequire("aziyh");

var $pfY9o = parcelRequire("pfY9o");
function $2d3fd72de49b1523$var$windowTime(windowTimeSpan) {
    var scheduler = $jAy5L.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ($pfY9o.isScheduler(arguments[3])) scheduler = arguments[3];
    if ($pfY9o.isScheduler(arguments[2])) scheduler = arguments[2];
    else if ($aziyh.isNumeric(arguments[2])) maxWindowSize = arguments[2];
    if ($pfY9o.isScheduler(arguments[1])) scheduler = arguments[1];
    else if ($aziyh.isNumeric(arguments[1])) windowCreationInterval = arguments[1];
    return function windowTimeOperatorFunction(source) {
        return source.lift(new $2d3fd72de49b1523$var$WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
module.exports.windowTime = $2d3fd72de49b1523$var$windowTime;
var $2d3fd72de49b1523$var$WindowTimeOperator = function() {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2d3fd72de49b1523$var$WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}();
var $2d3fd72de49b1523$var$CountedSubject = function(_super) {
    $2d3fd72de49b1523$var$__extends(CountedSubject, _super);
    function CountedSubject() {
        _super.apply(this, arguments);
        this._numberOfNextedValues = 0;
    }
    CountedSubject.prototype.next = function(value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function() {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}($70s4u.Subject);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2d3fd72de49b1523$var$WindowTimeSubscriber = function(_super) {
    $2d3fd72de49b1523$var$__extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
        this.windows = [];
        var window = this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = {
                subscriber: this,
                window: window,
                context: null
            };
            var creationState = {
                windowTimeSpan: windowTimeSpan,
                windowCreationInterval: windowCreationInterval,
                subscriber: this,
                scheduler: scheduler
            };
            this.add(scheduler.schedule($2d3fd72de49b1523$var$dispatchWindowClose, windowTimeSpan, closeState));
            this.add(scheduler.schedule($2d3fd72de49b1523$var$dispatchWindowCreation, windowCreationInterval, creationState));
        } else {
            var timeSpanOnlyState = {
                subscriber: this,
                window: window,
                windowTimeSpan: windowTimeSpan
            };
            this.add(scheduler.schedule($2d3fd72de49b1523$var$dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
    }
    WindowTimeSubscriber.prototype._next = function(value) {
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len; i++){
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) this.closeWindow(window_1);
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        while(windows.length > 0)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function() {
        var windows = this.windows;
        while(windows.length > 0){
            var window_2 = windows.shift();
            if (!window_2.closed) window_2.complete();
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function() {
        var window = new $2d3fd72de49b1523$var$CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function(window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}($a7QRR.Subscriber);
function $2d3fd72de49b1523$var$dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) subscriber.closeWindow(window);
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function $2d3fd72de49b1523$var$dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = {
        action: action,
        subscription: null
    };
    var timeSpanState = {
        subscriber: subscriber,
        window: window,
        context: context
    };
    context.subscription = scheduler.schedule($2d3fd72de49b1523$var$dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function $2d3fd72de49b1523$var$dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) context.action.remove(context.subscription);
    subscriber.closeWindow(window);
}

});

parcelRegister("aR6Rt", function(module, exports) {
"use strict";
var $7e742d2b90f0d0d7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $70s4u = parcelRequire("70s4u");

var $hIoOm = parcelRequire("hIoOm");

var $jJdW6 = parcelRequire("jJdW6");

var $4b4q3 = parcelRequire("4b4q3");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */ function $7e742d2b90f0d0d7$var$windowToggle(openings, closingSelector) {
    return function(source) {
        return source.lift(new $7e742d2b90f0d0d7$var$WindowToggleOperator(openings, closingSelector));
    };
}
module.exports.windowToggle = $7e742d2b90f0d0d7$var$windowToggle;
var $7e742d2b90f0d0d7$var$WindowToggleOperator = function() {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7e742d2b90f0d0d7$var$WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7e742d2b90f0d0d7$var$WindowToggleSubscriber = function(_super) {
    $7e742d2b90f0d0d7$var$__extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(this.openSubscription = $87MtM.subscribeToResult(this, openings, openings));
    }
    WindowToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for(var i = 0; i < len; i++)contexts[i].window.next(value);
        }
    };
    WindowToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.error(err);
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.complete();
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ WindowToggleSubscriber.prototype._unsubscribe = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.unsubscribe();
                context.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingSelector = this.closingSelector;
            var closingNotifier = $jJdW6.tryCatch(closingSelector)(innerValue);
            if (closingNotifier === $4b4q3.errorObject) return this.error($4b4q3.errorObject.e);
            else {
                var window_1 = new $70s4u.Subject();
                var subscription = new $hIoOm.Subscription();
                var context = {
                    window: window_1,
                    subscription: subscription
                };
                this.contexts.push(context);
                var innerSubscription = $87MtM.subscribeToResult(this, closingNotifier, context);
                if (innerSubscription.closed) this.closeWindow(this.contexts.length - 1);
                else {
                    innerSubscription.context = context;
                    subscription.add(innerSubscription);
                }
                this.destination.next(window_1);
            }
        } else this.closeWindow(this.contexts.indexOf(outerValue));
    };
    WindowToggleSubscriber.prototype.notifyError = function(err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function(inner) {
        if (inner !== this.openSubscription) this.closeWindow(this.contexts.indexOf(inner.context));
    };
    WindowToggleSubscriber.prototype.closeWindow = function(index) {
        if (index === -1) return;
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}($6UnJS.OuterSubscriber);

});

parcelRegister("hiGV8", function(module, exports) {
"use strict";
var $c9856937ce418dc8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $70s4u = parcelRequire("70s4u");

var $jJdW6 = parcelRequire("jJdW6");

var $4b4q3 = parcelRequire("4b4q3");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */ function $c9856937ce418dc8$var$windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new $c9856937ce418dc8$var$WindowOperator(closingSelector));
    };
}
module.exports.windowWhen = $c9856937ce418dc8$var$windowWhen;
var $c9856937ce418dc8$var$WindowOperator = function() {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c9856937ce418dc8$var$WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c9856937ce418dc8$var$WindowSubscriber = function(_super) {
    $c9856937ce418dc8$var$__extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.destination = destination;
        this.closingSelector = closingSelector;
        this.openWindow();
    }
    WindowSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function() {
        if (this.closingNotification) this.closingNotification.unsubscribe();
    };
    WindowSubscriber.prototype.openWindow = function(innerSub) {
        if (innerSub === void 0) innerSub = null;
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var window = this.window = new $70s4u.Subject();
        this.destination.next(window);
        var closingNotifier = $jJdW6.tryCatch(this.closingSelector)();
        if (closingNotifier === $4b4q3.errorObject) {
            var err = $4b4q3.errorObject.e;
            this.destination.error(err);
            this.window.error(err);
        } else this.add(this.closingNotification = $87MtM.subscribeToResult(this, closingNotifier));
    };
    return WindowSubscriber;
}($6UnJS.OuterSubscriber);

});

parcelRegister("u6syz", function(module, exports) {

$parcel$export(module.exports, "zipAll", () => $05a7d032497b53ba$export$adddb6a2fa3864e9, (v) => $05a7d032497b53ba$export$adddb6a2fa3864e9 = v);
var $05a7d032497b53ba$export$adddb6a2fa3864e9;
"use strict";

var $5f7nL = parcelRequire("5f7nL");
function $05a7d032497b53ba$var$zipAll(project) {
    return function(source) {
        return source.lift(new $5f7nL.ZipOperator(project));
    };
}
$05a7d032497b53ba$export$adddb6a2fa3864e9 = $05a7d032497b53ba$var$zipAll;

});




parcelRegister("l5DHx", function(module, exports) {

$parcel$export(module.exports, "deleteRemoteLinkedIssuesEpic", () => $21c9f84d92dd9908$export$9af21bc1b51ef1f9);
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");
var $JRB5w = parcelRequire("JRB5w");

var $4ceCM = parcelRequire("4ceCM");

var $3A3OQ = parcelRequire("3A3OQ");

var $4Pc4B = parcelRequire("4Pc4B");

var $02hYD = parcelRequire("02hYD");

var $5JqpU = parcelRequire("5JqpU");

var $jMP2a = parcelRequire("jMP2a");

var $l7DhQ = parcelRequire("l7DhQ");
const $21c9f84d92dd9908$export$9af21bc1b51ef1f9 = (action$, store)=>action$.ofType((0, $02hYD.DELETE_REMOTE_LINKED_ISSUE_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueKey = (0, $5JqpU.issueKeySelector)(state);
        const { globalId: globalId, analyticsEvent: analyticsEvent } = action.payload;
        const { application: application, edition: edition } = action.payload;
        return (0, $4Pc4B.deleteRemoteIssueLink)(baseUrl, issueKey, globalId).map(()=>{
            analyticsEvent && (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'remoteLinkedIssue deleted');
            return (0, $02hYD.deleteRemoteLinkedIssueSuccess)(globalId);
        }).do(()=>{
            if ((0, $1ybV0.ff)('analytics_event_for_deletion_of_linked_issue_1ufi8')) (0, $4ceCM.sendExperienceAnalytics)({
                experience: (0, $l7DhQ.EXPERIENCE_DELETE_ISSUE_LINK_SUCCEEDED),
                wasExperienceSuccesful: true,
                analyticsSource: (0, $l7DhQ.SOURCE_JIRA_LINKED_ISSUES),
                application: application ?? null,
                edition: edition ?? null
            });
        }).catch((error)=>{
            if ((0, $1ybV0.ff)('analytics_event_for_deletion_of_linked_issue_1ufi8')) {
                if (!((0, $1ybV0.ff)('ken-429-restrict-4xx-error_vi8v7') && error instanceof (0, $7byHA.default) && (0, $JRB5w.isHttpClientErrorResponse)(error))) (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'issue.issue-links.delete-issue-link-error',
                        teamName: 'bento'
                    },
                    attributes: {
                        experience: (0, $l7DhQ.EXPERIENCE_DELETE_ISSUE_LINK_FAILED),
                        analyticsSource: (0, $l7DhQ.SOURCE_JIRA_LINKED_ISSUES),
                        application: application ?? null,
                        edition: edition ?? null
                    }
                });
            }
            analyticsEvent && (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'remoteLinkedIssue deleteFailed');
            (0, $3A3OQ.trackOrLogClientError)('issue.issue-links.delete-issue-link-error', 'remote', error);
            return (0, $3JafE.Observable).of((0, $02hYD.deleteRemoteLinkedIssueFailure)(globalId));
        });
    });

});
parcelRegister("4Pc4B", function(module, exports) {

$parcel$export(module.exports, "deleteRemoteIssueLink", () => $f63a9dac1134a56a$export$c9e526bc849cbeb1);

var $aiRd8 = parcelRequire("aiRd8");
const $f63a9dac1134a56a$var$deleteOptions = {
    method: 'DELETE'
};
const $f63a9dac1134a56a$var$getDeletionUrl = (baseUrl, issueKey, globalId)=>`${baseUrl}/rest/api/3/issue/${issueKey}/remotelink?globalId=${encodeURIComponent(globalId)}`;
const $f63a9dac1134a56a$export$c9e526bc849cbeb1 = (baseUrl, issueKey, globalId)=>(0, $aiRd8.default)($f63a9dac1134a56a$var$getDeletionUrl(baseUrl, issueKey, globalId), $f63a9dac1134a56a$var$deleteOptions);

});


parcelRegister("j6tFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b062778677f4801f$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("YLEHo");
parcelRequire("jyKN9");
parcelRequire("3wBUP");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $hompL = parcelRequire("hompL");

var $gUUjF = parcelRequire("gUUjF");

var $k8Qyf = parcelRequire("k8Qyf");

var $gdPSX = parcelRequire("gdPSX");

var $7C4za = parcelRequire("7C4za");

var $54Nrf = parcelRequire("54Nrf");

var $eOOTj = parcelRequire("eOOTj");
var $kCKKc = parcelRequire("kCKKc");

var $duMa0 = parcelRequire("duMa0");

var $bCaZl = parcelRequire("bCaZl");

var $i7QJO = parcelRequire("i7QJO");

var $5JqpU = parcelRequire("5JqpU");

var $4jSLd = parcelRequire("4jSLd");

var $8CSFK = parcelRequire("8CSFK");

var $dI19O = parcelRequire("dI19O");

var $8QKSg = parcelRequire("8QKSg");
const $b062778677f4801f$var$LOG_LOCATION = 'issue.ecosystem.ecosystem-content-panel-epic';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b062778677f4801f$var$parseState = (state, payload)=>({
        addonModuleKey: payload,
        baseUrl: (0, $5JqpU.baseUrlSelector)(state),
        parentIssueKey: (0, $5JqpU.issueKeySelector)(state)
    });
const $b062778677f4801f$var$getPanelName = (state, forgePanelKey)=>{
    const requestedPanel = (0, $8QKSg.getForgeIssuePanel)(forgePanelKey)(state);
    if (requestedPanel) return requestedPanel.name;
    return undefined;
};
const $b062778677f4801f$var$saveContentPanelToIssue = (baseUrl, issueKey, addonModuleKey)=>{
    const keyWithoutDigits = (0, $duMa0.removeTimestamp)(addonModuleKey, 10);
    return (0, $4jSLd.saveExtensionToIssue)(baseUrl, issueKey, keyWithoutDigits).map(()=>(0, $bCaZl.addContentPanelSuccess)(keyWithoutDigits)).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData($b062778677f4801f$var$LOG_LOCATION, `saveExtensionToIssue failed: ${error}`, error);
        return (0, $3JafE.Observable).of((0, $bCaZl.addContentPanelFailure)(error));
    });
};
const $b062778677f4801f$var$saveForgePanelToIssue = (// @ts-expect-error - TS2304 - Cannot find name 'BaseUrl'.
baseUrl, // @ts-expect-error - TS2304 - Cannot find name 'IssueKey'.
issueKey, // eslint-disable-next-line @typescript-eslint/no-explicit-any
extensionId, allowMultiple, analyticsSource)=>{
    const suggestedDate = Date.now();
    const panelInstanceId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4().substring(0, 8);
    return (0, $dI19O.saveExtensionToIssue)(baseUrl, issueKey, extensionId, suggestedDate, allowMultiple, panelInstanceId).mergeMap((panels)=>{
        const panel = panels[panels.length - 1];
        const panelKey = (0, $7C4za.toForgeKeyFromExtensionId)(extensionId, panelInstanceId, panel.added);
        const observable = (0, $3JafE.Observable).of((0, $i7QJO.forgeIssuePanelAdded)(panelKey), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $bCaZl.addContentPanelSuccess)(panelKey));
        (0, $gdPSX.fireTrackSavedEvent)(analyticsSource);
        return observable;
    });
};
const $b062778677f4801f$export$dae1a56e4ef1c296 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
action$, store)=>action$.ofType((0, $bCaZl.ADD_CONTENT_PANEL_REQUEST)).flatMap((action)=>{
        const { addonModuleKey: addonModuleKey, baseUrl: baseUrl, parentIssueKey: parentIssueKey } = $b062778677f4801f$var$parseState(store.getState(), action.payload);
        const state = store.getState();
        const issueContentPanels = (0, $8CSFK.issueContentPanelsSelector)(state);
        const forgePanels = (0, $8QKSg.forgePanelsSelector)(state);
        const visibleContentPanels = (0, $8CSFK.ecosystemAddedContentPanelsSelector)(state);
        const isCustomised = (0, $8CSFK.isIssueContentPanelCustomisedSelector)(state);
        const isIssueCreatedBeforeEcosystemOn = !(0, $8CSFK.isIssueCreatedAfterEcosystemOnSelector)(state);
        const analyticsSource = (0, $5JqpU.analyticsSourceSelector)(state);
        if ((0, $7C4za.isForgeExtension)(action.payload)) {
            const panelToBeAdded = forgePanels.find((panel)=>(0, $7C4za.toForgeKey)(panel.appKey, panel.moduleKey) === action.payload);
            const panelName = panelToBeAdded ? panelToBeAdded.name : undefined;
            const allowMultiple = !!panelToBeAdded?.allowMultiple;
            return $b062778677f4801f$var$saveForgePanelToIssue(baseUrl, parentIssueKey, addonModuleKey, allowMultiple, analyticsSource).catch((error)=>{
                (0, $gdPSX.fireOperationalSaveFailedEvent)(analyticsSource, {
                    error: error
                });
                const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
                if (error instanceof (0, $54Nrf.LimitError)) showFlag((0, $eOOTj.default)(panelName));
                else showFlag((0, $kCKKc.default)(panelName));
                return (0, $3JafE.Observable).of((0, $bCaZl.addContentPanelFailure)(error));
            });
        }
        // issue has never been customised for content panel.  So we need to add all currently visible panels to issue
        // And set it is customised.
        if (!isCustomised && isIssueCreatedBeforeEcosystemOn) return (0, $3JafE.Observable).merge(...visibleContentPanels.map((panel)=>`${panel.appKey}_${panel.moduleKey}`).filter((key)=>!issueContentPanels.includes(key)).map((key)=>$b062778677f4801f$var$saveContentPanelToIssue(baseUrl, parentIssueKey, key)));
        return $b062778677f4801f$var$saveContentPanelToIssue(baseUrl, parentIssueKey, addonModuleKey);
    });
const $b062778677f4801f$var$removeForgePanelFromIssue = (// @ts-expect-error - TS2304 - Cannot find name 'BaseUrl'.
baseUrl, // @ts-expect-error - TS2304 - Cannot find name 'IssueKey'.
issueKey, // eslint-disable-next-line @typescript-eslint/no-explicit-any
panelKey, analyticsSource)=>{
    const panelProperties = (0, $duMa0.parseForgeIssuePanel)(panelKey);
    if (panelProperties == null) {
        (0, $gdPSX.fireOperationalRemoveFailedEvent)(analyticsSource, {
            error: Error(`Panel key doesn't match regexp: ${panelKey}`)
        });
        return (0, $3JafE.Observable).of((0, $bCaZl.removeContentPanelFailure)());
    }
    const { extensionId: extensionId } = panelProperties;
    const { id: id } = panelProperties;
    const date = panelProperties.added;
    return (0, $dI19O.removeExtensionFromIssue)(baseUrl, issueKey, extensionId, date, id).mergeMap(()=>{
        (0, $gdPSX.fireTrackRemovedEvent)(analyticsSource);
        // @ts-expect-error - TS2769 - No overload matches this call.
        return (0, $3JafE.Observable).of((0, $bCaZl.removeContentPanelSuccess)(panelKey), (0, $i7QJO.forgeIssuePanelRemoved)(panelKey));
    });
};
const $b062778677f4801f$export$1c1b968a0179d239 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
action$, store)=>action$.ofType((0, $bCaZl.REMOVE_CONTENT_PANEL_REQUEST)).flatMap((action)=>{
        const { addonModuleKey: addonModuleKey, baseUrl: baseUrl, parentIssueKey: parentIssueKey } = $b062778677f4801f$var$parseState(store.getState(), action.payload);
        const staticAddonModuleKey = (0, $duMa0.removeTimestamp)(addonModuleKey, 10);
        const state = store.getState();
        const issueContentPanels = (0, $8CSFK.issueContentPanelsSelector)(state);
        const analyticsSource = (0, $5JqpU.analyticsSourceSelector)(state);
        if ((0, $7C4za.isForgeExtension)(addonModuleKey)) {
            const panelName = $b062778677f4801f$var$getPanelName(state, action.payload);
            return $b062778677f4801f$var$removeForgePanelFromIssue(baseUrl, parentIssueKey, addonModuleKey, analyticsSource).catch((error)=>{
                (0, $gdPSX.fireOperationalRemoveFailedEvent)(analyticsSource, {
                    error: error
                });
                const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
                showFlag((0, $kCKKc.default)(panelName));
                return (0, $3JafE.Observable).of((0, $bCaZl.removeContentPanelFailure)(error));
            });
        }
        // If we are removing a legacy panel, we need to add other panels so they won't disappear with the current deleting one.
        if (!issueContentPanels.includes(addonModuleKey) && !issueContentPanels.includes(staticAddonModuleKey)) {
            const availableAddons = (0, $8CSFK.ecosystemAllPanelsSelector)(state);
            return (0, $3JafE.Observable).merge(...availableAddons.map((panel)=>`${panel.appKey}_${panel.moduleKey}`).filter((panelKey)=>panelKey !== addonModuleKey).map((panelKey)=>$b062778677f4801f$var$saveContentPanelToIssue(baseUrl, parentIssueKey, panelKey)));
        }
        // find the issueContentPanels key used to remembered selection as the key for delete
        const rememberedKey = issueContentPanels.includes(addonModuleKey) ? addonModuleKey : staticAddonModuleKey;
        return (0, $4jSLd.removeExtensionFromIssue)(baseUrl, parentIssueKey, rememberedKey).map(()=>(0, $bCaZl.removeContentPanelSuccess)(rememberedKey)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData($b062778677f4801f$var$LOG_LOCATION, `removeExtensionFromIssue failed: ${error}`, error);
            return (0, $3JafE.Observable).of((0, $bCaZl.removeContentPanelFailure)(error));
        });
    });
const $b062778677f4801f$export$e8d4954312dfd506 = (action$)=>action$.ofType((0, $bCaZl.ADD_CONTENT_PANEL_SUCCESS)).switchMap((action)=>{
        const addonModuleKey = action.payload;
        return (0, $3JafE.Observable).of((0, $bCaZl.contentPanelSelected)(addonModuleKey));
    });
const $b062778677f4801f$export$203e7fac4ca7cfaf = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
action$, store)=>action$.ofType((0, $bCaZl.ADD_CONTENT_PANEL_SUCCESS), (0, $bCaZl.CONTENT_PANELS_CUSTOMISED_REQUEST)).flatMap((action)=>{
        const { baseUrl: baseUrl, parentIssueKey: parentIssueKey } = $b062778677f4801f$var$parseState(store.getState(), action.payload);
        const customised = (0, $8CSFK.isIssueContentPanelCustomisedSelector)(store.getState());
        if (customised) return (0, $3JafE.Observable).empty();
        return (0, $4jSLd.saveContentPanelsCustomisedOnIssue)(baseUrl, parentIssueKey).map(()=>(0, $bCaZl.contentPanelsCustomisedSuccess)()).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData($b062778677f4801f$var$LOG_LOCATION, `saveIssueCustomised failed: ${error}`, error);
            return (0, $3JafE.Observable).empty();
        });
    });
const $b062778677f4801f$export$86909c49781d8da7 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
action$, store)=>action$.ofType((0, $i7QJO.FORGE_ISSUE_PANEL_UPDATE_REQUEST)).flatMap((action)=>{
        const baseUrl = (0, $5JqpU.baseUrlSelector)(store.getState());
        const analyticsSource = (0, $5JqpU.analyticsSourceSelector)(store.getState());
        const { issueKey: issueKey, panelKey: panelKey, collapsed: collapsed } = action.payload;
        const panelProperties = (0, $duMa0.parseForgeIssuePanel)(panelKey);
        if (panelProperties == null) {
            (0, $gdPSX.fireOperationalUpdateFailedEvent)(analyticsSource, {
                error: Error(`Panel key doesn't match regexp: ${panelKey}`)
            });
            return (0, $3JafE.Observable).empty();
        }
        const issueParams = {
            ...panelProperties,
            issueKey: issueKey
        };
        return (0, $dI19O.updateExtensionInIssue)(baseUrl, issueParams, collapsed).map(()=>{
            (0, $gdPSX.fireTrackUpdateSucceedEvent)(analyticsSource);
            return (0, $i7QJO.forgeIssuePanelUpdated)({
                panelKey: panelKey,
                collapsed: collapsed
            });
        }).catch((error)=>{
            (0, $gdPSX.fireOperationalUpdateFailedEvent)(analyticsSource, {
                error: error
            });
            const state = store.getState();
            const panelName = $b062778677f4801f$var$getPanelName(state, panelKey);
            const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
            showFlag((0, $kCKKc.default)(panelName));
            return (0, $3JafE.Observable).empty();
        });
    });
var $b062778677f4801f$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)($b062778677f4801f$export$dae1a56e4ef1c296, $b062778677f4801f$export$e8d4954312dfd506, $b062778677f4801f$export$1c1b968a0179d239, $b062778677f4801f$export$203e7fac4ca7cfaf, $b062778677f4801f$export$86909c49781d8da7);

});
parcelRegister("54Nrf", function(module, exports) {

$parcel$export(module.exports, "LimitError", () => $4e769bd71e236545$export$5534c66c345bf482);
const $4e769bd71e236545$export$69fe0bd0169b8de = 'LimitError';
class $4e769bd71e236545$export$5534c66c345bf482 {
    constructor(message, errors = []){
        this.name = $4e769bd71e236545$export$69fe0bd0169b8de;
        this.message = message;
        this.errors = errors;
    }
}

});

parcelRegister("eOOTj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a1155532ca52079$export$2e2bcd8739ae039);

var $2Rqjr = parcelRequire("2Rqjr");

var $90IgZ = parcelRequire("90IgZ");
const $9a1155532ca52079$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.issue-panel.operation-action.limit-failed.title",
        "defaultMessage": "Panel cannot be added"
    },
    titleWithName: {
        "id": "forge-ui.common.flags.issue-panel.operation-action.limit-failed.title-with-name",
        "defaultMessage": "{issuePanelName} cannot be added"
    },
    description: {
        "id": "forge-ui.common.flags.issue-panel.operation-action.limit-failed.description",
        "defaultMessage": "There is a limit of {limit} {limit, plural, one {panel} other {panels}}."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9a1155532ca52079$export$2e2bcd8739ae039 = (issuePanelName)=>({
        type: 'error',
        title: issuePanelName === undefined ? $9a1155532ca52079$export$defe85febe8b728c.title : [
            $9a1155532ca52079$export$defe85febe8b728c.titleWithName,
            {
                issuePanelName: issuePanelName
            }
        ],
        description: [
            $9a1155532ca52079$export$defe85febe8b728c.description,
            {
                limit: (0, $2Rqjr.ISSUE_PANEL_MULTIPLE_LIMIT)
            }
        ],
        isAutoDismiss: false
    });

});

parcelRegister("kCKKc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f306a8b1aa553d9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $9f306a8b1aa553d9$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.issue-panel.operation-action.generic-error.title",
        "defaultMessage": "We couldn\u2019t complete the action"
    },
    descriptionWithPanelName: {
        "id": "forge-ui.common.flags.issue-panel.operation-action.generic-error.description-with-panel-name",
        "defaultMessage": "We couldn\u2019t perform the action on {issuePanelName}. Try again later"
    },
    genericDescription: {
        "id": "forge-ui.common.flags.issue-panel.operation-action.generic-error.generic-description",
        "defaultMessage": "We couldn\u2019t perform the action on issue panel. Try again later."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9f306a8b1aa553d9$export$2e2bcd8739ae039 = (issuePanelName)=>({
        type: 'error',
        title: $9f306a8b1aa553d9$export$defe85febe8b728c.title,
        description: issuePanelName === undefined ? $9f306a8b1aa553d9$export$defe85febe8b728c.genericDescription : [
            $9f306a8b1aa553d9$export$defe85febe8b728c.descriptionWithPanelName,
            {
                issuePanelName: issuePanelName
            }
        ],
        isAutoDismiss: false
    });

});

parcelRegister("4jSLd", function(module, exports) {

$parcel$export(module.exports, "saveExtensionToIssue", () => $928790bb6553b423$export$26bc3676378df620);
$parcel$export(module.exports, "removeExtensionFromIssue", () => $928790bb6553b423$export$71bff84ed8e5f318);
$parcel$export(module.exports, "saveContentPanelsCustomisedOnIssue", () => $928790bb6553b423$export$d173e1c1abc736a4);

var $3JafE = parcelRequire("3JafE");
parcelRequire("cpH8E");

var $lRmyA = parcelRequire("lRmyA");

const $928790bb6553b423$var$getURL = (baseUrl, issueKey, addonModuleKey)=>`${baseUrl}/rest/api/2/issue/${issueKey}/properties/${addonModuleKey}`;
const $928790bb6553b423$export$26bc3676378df620 = (baseUrl, issueKey, addonModuleKey)=>{
    const url = $928790bb6553b423$var$getURL(baseUrl, issueKey, addonModuleKey);
    return (0, $3JafE.Observable).fromPromise((0, $lRmyA.performPutRequest)(url, {
        body: JSON.stringify({
            added: addonModuleKey
        })
    }));
};
const $928790bb6553b423$export$71bff84ed8e5f318 = (baseUrl, issueKey, addonModuleKey)=>{
    const url = $928790bb6553b423$var$getURL(baseUrl, issueKey, addonModuleKey);
    return (0, $3JafE.Observable).fromPromise((0, $lRmyA.performDeleteRequest)(url));
};
const $928790bb6553b423$export$d173e1c1abc736a4 = (baseUrl, issueKey)=>{
    const url = $928790bb6553b423$var$getURL(baseUrl, issueKey, (0, $6c91ecd17276581e$export$bdafa6b589be8b30));
    return (0, $3JafE.Observable).fromPromise((0, $lRmyA.performPutRequest)(url, {
        body: JSON.stringify({
            createdOn: new Date()
        })
    }));
};

});

parcelRegister("dI19O", function(module, exports) {

$parcel$export(module.exports, "updateExtensionInIssue", () => $9059eb4499a6ffdb$export$aa79bafae29bff2e);
$parcel$export(module.exports, "saveExtensionToIssue", () => $9059eb4499a6ffdb$export$26bc3676378df620);
$parcel$export(module.exports, "removeExtensionFromIssue", () => $9059eb4499a6ffdb$export$71bff84ed8e5f318);

var $bbUhj = parcelRequire("bbUhj");

var $7PHyj = parcelRequire("7PHyj");

var $lzTt0 = parcelRequire("lzTt0");

var $4ZYEI = parcelRequire("4ZYEI");

var $8riMk = parcelRequire("8riMk");

var $lRmyA = parcelRequire("lRmyA");

var $2Rqjr = parcelRequire("2Rqjr");

var $54Nrf = parcelRequire("54Nrf");
const $9059eb4499a6ffdb$var$createUrl = (baseUrl, issueKey, extensionId)=>`${baseUrl}/rest/api/2/issue/${issueKey}/properties/${extensionId}`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9059eb4499a6ffdb$var$createOnError = (okFn)=>(e)=>{
        // If the entity prop doesn't exist we expect 404
        if (e.statusCode === 404) return okFn();
        throw e;
    };
const $9059eb4499a6ffdb$export$c0fda13faf06a95c = (panel, added, id = 'none')=>panel.added === added && (id !== (0, $2Rqjr.NONE_PANEL_INSTANCE_ID) ? panel.id === id : true);
const $9059eb4499a6ffdb$var$deletePanels = (endpoint)=>(0, $lRmyA.performDeleteRequest)(endpoint).then(()=>[]).catch($9059eb4499a6ffdb$var$createOnError(()=>[]));
const $9059eb4499a6ffdb$var$updatePanels = (endpoint, panels)=>(0, $lRmyA.performPutRequest)(endpoint, {
        body: JSON.stringify(panels)
    }).then(()=>panels);
const $9059eb4499a6ffdb$var$getPanels = (endpoint)=>(0, $lRmyA.performGetRequest)(endpoint).then(({ value: value })=>(Array.isArray(value) ? value : []).map(({ added: added, id: id, collapsed: collapsed })=>({
                added: added,
                id: id,
                collapsed: collapsed
            })).filter(({ added: added, id: id, collapsed: collapsed })=>(0, (/*@__PURE__*/$parcel$interopDefault($lzTt0)))(added) && (id != null ? (0, (/*@__PURE__*/$parcel$interopDefault($4ZYEI)))(id) : true) && (collapsed != null ? (0, (/*@__PURE__*/$parcel$interopDefault($7PHyj)))(collapsed) : true))).catch($9059eb4499a6ffdb$var$createOnError(()=>[]));
const $9059eb4499a6ffdb$var$createPanelsService = (baseUrl, issueKey, extensionId)=>{
    const endpoint = $9059eb4499a6ffdb$var$createUrl(baseUrl, issueKey, extensionId);
    return {
        get: ()=>$9059eb4499a6ffdb$var$getPanels(endpoint),
        update: (panels)=>$9059eb4499a6ffdb$var$updatePanels(endpoint, panels),
        deleteEntry: ()=>$9059eb4499a6ffdb$var$deletePanels(endpoint)
    };
};
const $9059eb4499a6ffdb$export$aa79bafae29bff2e = (0, (/*@__PURE__*/$parcel$interopDefault($bbUhj)))([
    async (baseUrl, { issueKey: issueKey, extensionId: extensionId, added: added, id: id }, collapsed)=>{
        const { get: get, update: update } = $9059eb4499a6ffdb$var$createPanelsService(baseUrl, issueKey, extensionId);
        const panels = await get();
        if (panels.length === 0) return [];
        const updatedPanels = panels.map((panel)=>({
                ...panel,
                collapsed: $9059eb4499a6ffdb$export$c0fda13faf06a95c(panel, added, id) ? collapsed : panel.collapsed
            }));
        return update(updatedPanels).then(()=>updatedPanels);
    },
    (0, $8riMk.fromPromise)
]);
const $9059eb4499a6ffdb$export$26bc3676378df620 = (0, (/*@__PURE__*/$parcel$interopDefault($bbUhj)))([
    async (baseUrl, issueKey, extensionId, date, allowMultiple, panelInstanceId)=>{
        const { get: get, update: update } = $9059eb4499a6ffdb$var$createPanelsService(baseUrl, issueKey, extensionId);
        const panels = await get();
        const newPanel = {
            added: date,
            id: panelInstanceId,
            collapsed: false
        };
        if (panels.length === 0) return update([
            newPanel
        ]).then(()=>[
                newPanel
            ]);
        if (allowMultiple) {
            if (panels.length >= (0, $2Rqjr.ISSUE_PANEL_MULTIPLE_LIMIT)) throw new (0, $54Nrf.LimitError)('Multiple issue panel installation limit reached.');
            return update([
                ...panels,
                newPanel
            ]).then(()=>[
                    ...panels,
                    newPanel
                ]);
        }
        return [
            panels[0]
        ];
    },
    (0, $8riMk.fromPromise)
]);
const $9059eb4499a6ffdb$export$71bff84ed8e5f318 = (0, (/*@__PURE__*/$parcel$interopDefault($bbUhj)))([
    async (baseUrl, issueKey, extensionId, added, id)=>{
        const { get: get, update: update, deleteEntry: deleteEntry } = $9059eb4499a6ffdb$var$createPanelsService(baseUrl, issueKey, extensionId);
        const panels = await get();
        if (panels.length === 0) return [];
        const filteredPanels = panels.filter((panel)=>!$9059eb4499a6ffdb$export$c0fda13faf06a95c(panel, added, id));
        return filteredPanels.length === 0 ? deleteEntry() : update(filteredPanels);
    },
    (0, $8riMk.fromPromise)
]);

});
parcelRegister("bbUhj", function(module, exports) {

module.exports = (parcelRequire("3omiX"));

});
parcelRegister("3omiX", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $2784ea3ef613cf7e$var$func = $jFIrw('flow', (parcelRequire("c8Guq")));

$2784ea3ef613cf7e$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $2784ea3ef613cf7e$var$func;

});
parcelRegister("jFIrw", function(module, exports) {

var $imppR = parcelRequire("imppR");

var $a02m0 = parcelRequire("a02m0");
/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $e524521dc9be9d0c$var$convert(name, func, options) {
    return $imppR($a02m0, name, func, options);
}
module.exports = $e524521dc9be9d0c$var$convert;

});
parcelRegister("imppR", function(module, exports) {

var $89eBv = parcelRequire("89eBv");

var $l6Yg9 = parcelRequire("l6Yg9");
/** Built-in value reference. */ var $d5ddff315914c7cb$var$push = Array.prototype.push;
/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$baseArity(func, n) {
    return n == 2 ? function(a, b) {
        return func.apply(undefined, arguments);
    } : function(a) {
        return func.apply(undefined, arguments);
    };
}
/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$baseAry(func, n) {
    return n == 2 ? function(a, b) {
        return func(a, b);
    } : function(a) {
        return func(a);
    };
}
/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function $d5ddff315914c7cb$var$cloneArray(array) {
    var length = array ? array.length : 0, result = Array(length);
    while(length--)result[length] = array[length];
    return result;
}
/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function $d5ddff315914c7cb$var$createCloner(func) {
    return function(object) {
        return func({}, object);
    };
}
/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$flatSpread(func, start) {
    return function() {
        var length = arguments.length, lastIndex = length - 1, args = Array(length);
        while(length--)args[length] = arguments[length];
        var array = args[start], otherArgs = args.slice(0, start);
        if (array) $d5ddff315914c7cb$var$push.apply(otherArgs, array);
        if (start != lastIndex) $d5ddff315914c7cb$var$push.apply(otherArgs, args.slice(start + 1));
        return func.apply(this, otherArgs);
    };
}
/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function $d5ddff315914c7cb$var$wrapImmutable(func, cloner) {
    return function() {
        var length = arguments.length;
        if (!length) return;
        var args = Array(length);
        while(length--)args[length] = arguments[length];
        var result = args[0] = cloner.apply(undefined, args);
        func.apply(undefined, args);
        return result;
    };
}
/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $d5ddff315914c7cb$var$baseConvert(util, name, func, options) {
    var isLib = typeof name == 'function', isObj = name === Object(name);
    if (isObj) {
        options = func;
        func = name;
        name = undefined;
    }
    if (func == null) throw new TypeError;
    options || (options = {});
    var config = {
        'cap': 'cap' in options ? options.cap : true,
        'curry': 'curry' in options ? options.curry : true,
        'fixed': 'fixed' in options ? options.fixed : true,
        'immutable': 'immutable' in options ? options.immutable : true,
        'rearg': 'rearg' in options ? options.rearg : true
    };
    var defaultHolder = isLib ? func : $l6Yg9, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
    var helpers = isLib ? func : {
        'ary': util.ary,
        'assign': util.assign,
        'clone': util.clone,
        'curry': util.curry,
        'forEach': util.forEach,
        'isArray': util.isArray,
        'isError': util.isError,
        'isFunction': util.isFunction,
        'isWeakMap': util.isWeakMap,
        'iteratee': util.iteratee,
        'keys': util.keys,
        'rearg': util.rearg,
        'toInteger': util.toInteger,
        'toPath': util.toPath
    };
    var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
    var aryMethodKeys = keys($89eBv.aryMethod);
    var wrappers = {
        'castArray': function(castArray) {
            return function() {
                var value = arguments[0];
                return isArray(value) ? castArray($d5ddff315914c7cb$var$cloneArray(value)) : castArray.apply(undefined, arguments);
            };
        },
        'iteratee': function(iteratee) {
            return function() {
                var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                if (config.cap && typeof arity == 'number') {
                    arity = arity > 2 ? arity - 2 : 1;
                    return length && length <= arity ? result : $d5ddff315914c7cb$var$baseAry(result, arity);
                }
                return result;
            };
        },
        'mixin': function(mixin) {
            return function(source) {
                var func = this;
                if (!isFunction(func)) return mixin(func, Object(source));
                var pairs = [];
                each(keys(source), function(key) {
                    if (isFunction(source[key])) pairs.push([
                        key,
                        func.prototype[key]
                    ]);
                });
                mixin(func, Object(source));
                each(pairs, function(pair) {
                    var value = pair[1];
                    if (isFunction(value)) func.prototype[pair[0]] = value;
                    else delete func.prototype[pair[0]];
                });
                return func;
            };
        },
        'nthArg': function(nthArg) {
            return function(n) {
                var arity = n < 0 ? 1 : toInteger(n) + 1;
                return curry(nthArg(n), arity);
            };
        },
        'rearg': function(rearg) {
            return function(func, indexes) {
                var arity = indexes ? indexes.length : 0;
                return curry(rearg(func, indexes), arity);
            };
        },
        'runInContext': function(runInContext) {
            return function(context) {
                return $d5ddff315914c7cb$var$baseConvert(util, runInContext(context), options);
            };
        }
    };
    /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
        if (config.cap) {
            var indexes = $89eBv.iterateeRearg[name];
            if (indexes) return iterateeRearg(func, indexes);
            var n = !isLib && $89eBv.iterateeAry[name];
            if (n) return iterateeAry(func, n);
        }
        return func;
    }
    /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
        return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
    }
    /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
        if (config.fixed && (forceFixed || !$89eBv.skipFixed[name])) {
            var data = $89eBv.methodSpread[name], start = data && data.start;
            return start === undefined ? ary(func, n) : $d5ddff315914c7cb$var$flatSpread(func, start);
        }
        return func;
    }
    /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
        return config.rearg && n > 1 && (forceRearg || !$89eBv.skipRearg[name]) ? rearg(func, $89eBv.methodRearg[name] || $89eBv.aryRearg[n]) : func;
    }
    /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
        path = toPath(path);
        var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
        while(nested != null && ++index < length){
            var key = path[index], value = nested[key];
            if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
            nested = nested[key];
        }
        return result;
    }
    /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
        return _.runInContext.convert(options)(undefined);
    }
    /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
        var realName = $89eBv.aliasToReal[name] || name, methodName = $89eBv.remap[realName] || realName, oldOptions = options;
        return function(options) {
            var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
            return $d5ddff315914c7cb$var$baseConvert(newUtil, realName, newFunc, newOptions);
        };
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
        return overArg(func, function(func) {
            return typeof func == 'function' ? $d5ddff315914c7cb$var$baseAry(func, n) : func;
        });
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
        return overArg(func, function(func) {
            var n = indexes.length;
            return $d5ddff315914c7cb$var$baseArity(rearg($d5ddff315914c7cb$var$baseAry(func, n), indexes), n);
        });
    }
    /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function() {
            var length = arguments.length;
            if (!length) return func();
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var index = config.rearg ? 0 : length - 1;
            args[index] = transform(args[index]);
            return func.apply(undefined, args);
        };
    }
    /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
        var result, realName = $89eBv.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
        if (wrapper) wrapped = wrapper(func);
        else if (config.immutable) {
            if ($89eBv.mutate.array[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, $d5ddff315914c7cb$var$cloneArray);
            else if ($89eBv.mutate.object[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, $d5ddff315914c7cb$var$createCloner(func));
            else if ($89eBv.mutate.set[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, cloneByPath);
        }
        each(aryMethodKeys, function(aryKey) {
            each($89eBv.aryMethod[aryKey], function(otherName) {
                if (realName == otherName) {
                    var data = $89eBv.methodSpread[realName], afterRearg = data && data.afterRearg;
                    result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                    result = castCap(realName, result);
                    result = castCurry(realName, result, aryKey);
                    return false;
                }
            });
            return !result;
        });
        result || (result = wrapped);
        if (result == func) result = forceCurry ? curry(result, 1) : function() {
            return func.apply(this, arguments);
        };
        result.convert = createConverter(realName, func);
        result.placeholder = func.placeholder = placeholder;
        return result;
    }
    /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
    var _ = func;
    // Convert methods by ary cap.
    var pairs = [];
    each(aryMethodKeys, function(aryKey) {
        each($89eBv.aryMethod[aryKey], function(key) {
            var func = _[$89eBv.remap[key] || key];
            if (func) pairs.push([
                key,
                wrap(key, func, _)
            ]);
        });
    });
    // Convert remaining methods.
    each(keys(_), function(key) {
        var func = _[key];
        if (typeof func == 'function') {
            var length = pairs.length;
            while(length--){
                if (pairs[length][0] == key) return;
            }
            func.convert = createConverter(key, func);
            pairs.push([
                key,
                func
            ]);
        }
    });
    // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
    each(pairs, function(pair) {
        _[pair[0]] = pair[1];
    });
    _.convert = convertLib;
    _.placeholder = _;
    // Assign aliases.
    each(keys(_), function(key) {
        each($89eBv.realToAlias[key] || [], function(alias) {
            _[alias] = _[key];
        });
    });
    return _;
}
module.exports = $d5ddff315914c7cb$var$baseConvert;

});
parcelRegister("89eBv", function(module, exports) {

$parcel$export(module.exports, "aliasToReal", () => $5eea7e08a1db1590$export$bd0f5e6e44efa6b4, (v) => $5eea7e08a1db1590$export$bd0f5e6e44efa6b4 = v);
$parcel$export(module.exports, "aryMethod", () => $5eea7e08a1db1590$export$85c665b4d7da9cb4, (v) => $5eea7e08a1db1590$export$85c665b4d7da9cb4 = v);
$parcel$export(module.exports, "aryRearg", () => $5eea7e08a1db1590$export$42564e045b285e32, (v) => $5eea7e08a1db1590$export$42564e045b285e32 = v);
$parcel$export(module.exports, "iterateeAry", () => $5eea7e08a1db1590$export$81e17196e6a22b07, (v) => $5eea7e08a1db1590$export$81e17196e6a22b07 = v);
$parcel$export(module.exports, "iterateeRearg", () => $5eea7e08a1db1590$export$30975ceb42167ebd, (v) => $5eea7e08a1db1590$export$30975ceb42167ebd = v);
$parcel$export(module.exports, "methodRearg", () => $5eea7e08a1db1590$export$8ceb0ad7e94d3801, (v) => $5eea7e08a1db1590$export$8ceb0ad7e94d3801 = v);
$parcel$export(module.exports, "methodSpread", () => $5eea7e08a1db1590$export$fbaeb3f87df3cf26, (v) => $5eea7e08a1db1590$export$fbaeb3f87df3cf26 = v);
$parcel$export(module.exports, "mutate", () => $5eea7e08a1db1590$export$57e795267c26e600, (v) => $5eea7e08a1db1590$export$57e795267c26e600 = v);
$parcel$export(module.exports, "realToAlias", () => $5eea7e08a1db1590$export$1eb71a7e27943e71, (v) => $5eea7e08a1db1590$export$1eb71a7e27943e71 = v);
$parcel$export(module.exports, "remap", () => $5eea7e08a1db1590$export$aee1dbae5de2db9d, (v) => $5eea7e08a1db1590$export$aee1dbae5de2db9d = v);
$parcel$export(module.exports, "skipFixed", () => $5eea7e08a1db1590$export$87ffbe4821a5d5e0, (v) => $5eea7e08a1db1590$export$87ffbe4821a5d5e0 = v);
$parcel$export(module.exports, "skipRearg", () => $5eea7e08a1db1590$export$b4d07413ce528c90, (v) => $5eea7e08a1db1590$export$b4d07413ce528c90 = v);
/** Used to map aliases to their real names. */ var $5eea7e08a1db1590$export$bd0f5e6e44efa6b4;
/** Used to map ary to method names. */ var $5eea7e08a1db1590$export$85c665b4d7da9cb4;
/** Used to map ary to rearg configs. */ var $5eea7e08a1db1590$export$42564e045b285e32;
/** Used to map method names to their iteratee ary. */ var $5eea7e08a1db1590$export$81e17196e6a22b07;
/** Used to map method names to iteratee rearg configs. */ var $5eea7e08a1db1590$export$30975ceb42167ebd;
/** Used to map method names to rearg configs. */ var $5eea7e08a1db1590$export$8ceb0ad7e94d3801;
/** Used to map method names to spread configs. */ var $5eea7e08a1db1590$export$fbaeb3f87df3cf26;
/** Used to identify methods which mutate arrays or objects. */ var $5eea7e08a1db1590$export$57e795267c26e600;
/** Used to map real names to their aliases. */ var $5eea7e08a1db1590$export$1eb71a7e27943e71;
/** Used to map method names to other names. */ var $5eea7e08a1db1590$export$aee1dbae5de2db9d;
/** Used to track methods that skip fixing their arity. */ var $5eea7e08a1db1590$export$87ffbe4821a5d5e0;
/** Used to track methods that skip rearranging arguments. */ var $5eea7e08a1db1590$export$b4d07413ce528c90;
$5eea7e08a1db1590$export$bd0f5e6e44efa6b4 = {
    // Lodash aliases.
    'each': 'forEach',
    'eachRight': 'forEachRight',
    'entries': 'toPairs',
    'entriesIn': 'toPairsIn',
    'extend': 'assignIn',
    'extendAll': 'assignInAll',
    'extendAllWith': 'assignInAllWith',
    'extendWith': 'assignInWith',
    'first': 'head',
    // Methods that are curried variants of others.
    'conforms': 'conformsTo',
    'matches': 'isMatch',
    'property': 'get',
    // Ramda aliases.
    '__': 'placeholder',
    'F': 'stubFalse',
    'T': 'stubTrue',
    'all': 'every',
    'allPass': 'overEvery',
    'always': 'constant',
    'any': 'some',
    'anyPass': 'overSome',
    'apply': 'spread',
    'assoc': 'set',
    'assocPath': 'set',
    'complement': 'negate',
    'compose': 'flowRight',
    'contains': 'includes',
    'dissoc': 'unset',
    'dissocPath': 'unset',
    'dropLast': 'dropRight',
    'dropLastWhile': 'dropRightWhile',
    'equals': 'isEqual',
    'identical': 'eq',
    'indexBy': 'keyBy',
    'init': 'initial',
    'invertObj': 'invert',
    'juxt': 'over',
    'omitAll': 'omit',
    'nAry': 'ary',
    'path': 'get',
    'pathEq': 'matchesProperty',
    'pathOr': 'getOr',
    'paths': 'at',
    'pickAll': 'pick',
    'pipe': 'flow',
    'pluck': 'map',
    'prop': 'get',
    'propEq': 'matchesProperty',
    'propOr': 'getOr',
    'props': 'at',
    'symmetricDifference': 'xor',
    'symmetricDifferenceBy': 'xorBy',
    'symmetricDifferenceWith': 'xorWith',
    'takeLast': 'takeRight',
    'takeLastWhile': 'takeRightWhile',
    'unapply': 'rest',
    'unnest': 'flatten',
    'useWith': 'overArgs',
    'where': 'conformsTo',
    'whereEq': 'isMatch',
    'zipObj': 'zipObject'
};
$5eea7e08a1db1590$export$85c665b4d7da9cb4 = {
    '1': [
        'assignAll',
        'assignInAll',
        'attempt',
        'castArray',
        'ceil',
        'create',
        'curry',
        'curryRight',
        'defaultsAll',
        'defaultsDeepAll',
        'floor',
        'flow',
        'flowRight',
        'fromPairs',
        'invert',
        'iteratee',
        'memoize',
        'method',
        'mergeAll',
        'methodOf',
        'mixin',
        'nthArg',
        'over',
        'overEvery',
        'overSome',
        'rest',
        'reverse',
        'round',
        'runInContext',
        'spread',
        'template',
        'trim',
        'trimEnd',
        'trimStart',
        'uniqueId',
        'words',
        'zipAll'
    ],
    '2': [
        'add',
        'after',
        'ary',
        'assign',
        'assignAllWith',
        'assignIn',
        'assignInAllWith',
        'at',
        'before',
        'bind',
        'bindAll',
        'bindKey',
        'chunk',
        'cloneDeepWith',
        'cloneWith',
        'concat',
        'conformsTo',
        'countBy',
        'curryN',
        'curryRightN',
        'debounce',
        'defaults',
        'defaultsDeep',
        'defaultTo',
        'delay',
        'difference',
        'divide',
        'drop',
        'dropRight',
        'dropRightWhile',
        'dropWhile',
        'endsWith',
        'eq',
        'every',
        'filter',
        'find',
        'findIndex',
        'findKey',
        'findLast',
        'findLastIndex',
        'findLastKey',
        'flatMap',
        'flatMapDeep',
        'flattenDepth',
        'forEach',
        'forEachRight',
        'forIn',
        'forInRight',
        'forOwn',
        'forOwnRight',
        'get',
        'groupBy',
        'gt',
        'gte',
        'has',
        'hasIn',
        'includes',
        'indexOf',
        'intersection',
        'invertBy',
        'invoke',
        'invokeMap',
        'isEqual',
        'isMatch',
        'join',
        'keyBy',
        'lastIndexOf',
        'lt',
        'lte',
        'map',
        'mapKeys',
        'mapValues',
        'matchesProperty',
        'maxBy',
        'meanBy',
        'merge',
        'mergeAllWith',
        'minBy',
        'multiply',
        'nth',
        'omit',
        'omitBy',
        'overArgs',
        'pad',
        'padEnd',
        'padStart',
        'parseInt',
        'partial',
        'partialRight',
        'partition',
        'pick',
        'pickBy',
        'propertyOf',
        'pull',
        'pullAll',
        'pullAt',
        'random',
        'range',
        'rangeRight',
        'rearg',
        'reject',
        'remove',
        'repeat',
        'restFrom',
        'result',
        'sampleSize',
        'some',
        'sortBy',
        'sortedIndex',
        'sortedIndexOf',
        'sortedLastIndex',
        'sortedLastIndexOf',
        'sortedUniqBy',
        'split',
        'spreadFrom',
        'startsWith',
        'subtract',
        'sumBy',
        'take',
        'takeRight',
        'takeRightWhile',
        'takeWhile',
        'tap',
        'throttle',
        'thru',
        'times',
        'trimChars',
        'trimCharsEnd',
        'trimCharsStart',
        'truncate',
        'union',
        'uniqBy',
        'uniqWith',
        'unset',
        'unzipWith',
        'without',
        'wrap',
        'xor',
        'zip',
        'zipObject',
        'zipObjectDeep'
    ],
    '3': [
        'assignInWith',
        'assignWith',
        'clamp',
        'differenceBy',
        'differenceWith',
        'findFrom',
        'findIndexFrom',
        'findLastFrom',
        'findLastIndexFrom',
        'getOr',
        'includesFrom',
        'indexOfFrom',
        'inRange',
        'intersectionBy',
        'intersectionWith',
        'invokeArgs',
        'invokeArgsMap',
        'isEqualWith',
        'isMatchWith',
        'flatMapDepth',
        'lastIndexOfFrom',
        'mergeWith',
        'orderBy',
        'padChars',
        'padCharsEnd',
        'padCharsStart',
        'pullAllBy',
        'pullAllWith',
        'rangeStep',
        'rangeStepRight',
        'reduce',
        'reduceRight',
        'replace',
        'set',
        'slice',
        'sortedIndexBy',
        'sortedLastIndexBy',
        'transform',
        'unionBy',
        'unionWith',
        'update',
        'xorBy',
        'xorWith',
        'zipWith'
    ],
    '4': [
        'fill',
        'setWith',
        'updateWith'
    ]
};
$5eea7e08a1db1590$export$42564e045b285e32 = {
    '2': [
        1,
        0
    ],
    '3': [
        2,
        0,
        1
    ],
    '4': [
        3,
        2,
        0,
        1
    ]
};
$5eea7e08a1db1590$export$81e17196e6a22b07 = {
    'dropRightWhile': 1,
    'dropWhile': 1,
    'every': 1,
    'filter': 1,
    'find': 1,
    'findFrom': 1,
    'findIndex': 1,
    'findIndexFrom': 1,
    'findKey': 1,
    'findLast': 1,
    'findLastFrom': 1,
    'findLastIndex': 1,
    'findLastIndexFrom': 1,
    'findLastKey': 1,
    'flatMap': 1,
    'flatMapDeep': 1,
    'flatMapDepth': 1,
    'forEach': 1,
    'forEachRight': 1,
    'forIn': 1,
    'forInRight': 1,
    'forOwn': 1,
    'forOwnRight': 1,
    'map': 1,
    'mapKeys': 1,
    'mapValues': 1,
    'partition': 1,
    'reduce': 2,
    'reduceRight': 2,
    'reject': 1,
    'remove': 1,
    'some': 1,
    'takeRightWhile': 1,
    'takeWhile': 1,
    'times': 1,
    'transform': 2
};
$5eea7e08a1db1590$export$30975ceb42167ebd = {
    'mapKeys': [
        1
    ],
    'reduceRight': [
        1,
        0
    ]
};
$5eea7e08a1db1590$export$8ceb0ad7e94d3801 = {
    'assignInAllWith': [
        1,
        0
    ],
    'assignInWith': [
        1,
        2,
        0
    ],
    'assignAllWith': [
        1,
        0
    ],
    'assignWith': [
        1,
        2,
        0
    ],
    'differenceBy': [
        1,
        2,
        0
    ],
    'differenceWith': [
        1,
        2,
        0
    ],
    'getOr': [
        2,
        1,
        0
    ],
    'intersectionBy': [
        1,
        2,
        0
    ],
    'intersectionWith': [
        1,
        2,
        0
    ],
    'isEqualWith': [
        1,
        2,
        0
    ],
    'isMatchWith': [
        2,
        1,
        0
    ],
    'mergeAllWith': [
        1,
        0
    ],
    'mergeWith': [
        1,
        2,
        0
    ],
    'padChars': [
        2,
        1,
        0
    ],
    'padCharsEnd': [
        2,
        1,
        0
    ],
    'padCharsStart': [
        2,
        1,
        0
    ],
    'pullAllBy': [
        2,
        1,
        0
    ],
    'pullAllWith': [
        2,
        1,
        0
    ],
    'rangeStep': [
        1,
        2,
        0
    ],
    'rangeStepRight': [
        1,
        2,
        0
    ],
    'setWith': [
        3,
        1,
        2,
        0
    ],
    'sortedIndexBy': [
        2,
        1,
        0
    ],
    'sortedLastIndexBy': [
        2,
        1,
        0
    ],
    'unionBy': [
        1,
        2,
        0
    ],
    'unionWith': [
        1,
        2,
        0
    ],
    'updateWith': [
        3,
        1,
        2,
        0
    ],
    'xorBy': [
        1,
        2,
        0
    ],
    'xorWith': [
        1,
        2,
        0
    ],
    'zipWith': [
        1,
        2,
        0
    ]
};
$5eea7e08a1db1590$export$fbaeb3f87df3cf26 = {
    'assignAll': {
        'start': 0
    },
    'assignAllWith': {
        'start': 0
    },
    'assignInAll': {
        'start': 0
    },
    'assignInAllWith': {
        'start': 0
    },
    'defaultsAll': {
        'start': 0
    },
    'defaultsDeepAll': {
        'start': 0
    },
    'invokeArgs': {
        'start': 2
    },
    'invokeArgsMap': {
        'start': 2
    },
    'mergeAll': {
        'start': 0
    },
    'mergeAllWith': {
        'start': 0
    },
    'partial': {
        'start': 1
    },
    'partialRight': {
        'start': 1
    },
    'without': {
        'start': 1
    },
    'zipAll': {
        'start': 0
    }
};
$5eea7e08a1db1590$export$57e795267c26e600 = {
    'array': {
        'fill': true,
        'pull': true,
        'pullAll': true,
        'pullAllBy': true,
        'pullAllWith': true,
        'pullAt': true,
        'remove': true,
        'reverse': true
    },
    'object': {
        'assign': true,
        'assignAll': true,
        'assignAllWith': true,
        'assignIn': true,
        'assignInAll': true,
        'assignInAllWith': true,
        'assignInWith': true,
        'assignWith': true,
        'defaults': true,
        'defaultsAll': true,
        'defaultsDeep': true,
        'defaultsDeepAll': true,
        'merge': true,
        'mergeAll': true,
        'mergeAllWith': true,
        'mergeWith': true
    },
    'set': {
        'set': true,
        'setWith': true,
        'unset': true,
        'update': true,
        'updateWith': true
    }
};
$5eea7e08a1db1590$export$1eb71a7e27943e71 = function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty, object = $5eea7e08a1db1590$export$bd0f5e6e44efa6b4, result = {};
    for(var key in object){
        var value = object[key];
        if (hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }
    return result;
}();
$5eea7e08a1db1590$export$aee1dbae5de2db9d = {
    'assignAll': 'assign',
    'assignAllWith': 'assignWith',
    'assignInAll': 'assignIn',
    'assignInAllWith': 'assignInWith',
    'curryN': 'curry',
    'curryRightN': 'curryRight',
    'defaultsAll': 'defaults',
    'defaultsDeepAll': 'defaultsDeep',
    'findFrom': 'find',
    'findIndexFrom': 'findIndex',
    'findLastFrom': 'findLast',
    'findLastIndexFrom': 'findLastIndex',
    'getOr': 'get',
    'includesFrom': 'includes',
    'indexOfFrom': 'indexOf',
    'invokeArgs': 'invoke',
    'invokeArgsMap': 'invokeMap',
    'lastIndexOfFrom': 'lastIndexOf',
    'mergeAll': 'merge',
    'mergeAllWith': 'mergeWith',
    'padChars': 'pad',
    'padCharsEnd': 'padEnd',
    'padCharsStart': 'padStart',
    'propertyOf': 'get',
    'rangeStep': 'range',
    'rangeStepRight': 'rangeRight',
    'restFrom': 'rest',
    'spreadFrom': 'spread',
    'trimChars': 'trim',
    'trimCharsEnd': 'trimEnd',
    'trimCharsStart': 'trimStart',
    'zipAll': 'zip'
};
$5eea7e08a1db1590$export$87ffbe4821a5d5e0 = {
    'castArray': true,
    'flow': true,
    'flowRight': true,
    'iteratee': true,
    'mixin': true,
    'rearg': true,
    'runInContext': true
};
$5eea7e08a1db1590$export$b4d07413ce528c90 = {
    'add': true,
    'assign': true,
    'assignIn': true,
    'bind': true,
    'bindKey': true,
    'concat': true,
    'difference': true,
    'divide': true,
    'eq': true,
    'gt': true,
    'gte': true,
    'isEqual': true,
    'lt': true,
    'lte': true,
    'matchesProperty': true,
    'merge': true,
    'multiply': true,
    'overArgs': true,
    'partial': true,
    'partialRight': true,
    'propertyOf': true,
    'random': true,
    'range': true,
    'rangeRight': true,
    'subtract': true,
    'zip': true,
    'zipObject': true,
    'zipObjectDeep': true
};

});

parcelRegister("l6Yg9", function(module, exports) {
/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module.exports = {};

});


parcelRegister("a02m0", function(module, exports) {














module.exports = {
    'ary': (parcelRequire("iX5mF")),
    'assign': (parcelRequire("k1JQY")),
    'clone': (parcelRequire("E0NNP")),
    'curry': (parcelRequire("cleLA")),
    'forEach': (parcelRequire("9Kzih")),
    'isArray': (parcelRequire("1c8hB")),
    'isError': (parcelRequire("dbogu")),
    'isFunction': (parcelRequire("eoCgY")),
    'isWeakMap': (parcelRequire("a1CHL")),
    'iteratee': (parcelRequire("akHxB")),
    'keys': (parcelRequire("fCpZe")),
    'rearg': (parcelRequire("k5dRT")),
    'toInteger': (parcelRequire("hNahz")),
    'toPath': (parcelRequire("d0KBl"))
};

});
parcelRegister("iX5mF", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");
/** Used to compose bitmasks for function metadata. */ var $dcc1e600da485164$var$WRAP_ARY_FLAG = 128;
/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */ function $dcc1e600da485164$var$ary(func, n, guard) {
    n = guard ? undefined : n;
    n = func && n == null ? func.length : n;
    return $xQ3hV(func, $dcc1e600da485164$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}
module.exports = $dcc1e600da485164$var$ary;

});

parcelRegister("E0NNP", function(module, exports) {

var $ee7Ev = parcelRequire("ee7Ev");
/** Used to compose bitmasks for cloning. */ var $07845bdb18fff27f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $07845bdb18fff27f$var$clone(value) {
    return $ee7Ev(value, $07845bdb18fff27f$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $07845bdb18fff27f$var$clone;

});

parcelRegister("dbogu", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $hYEMs = parcelRequire("hYEMs");

var $jtsd5 = parcelRequire("jtsd5");
/** `Object#toString` result references. */ var $998f1ff604abccc1$var$domExcTag = '[object DOMException]', $998f1ff604abccc1$var$errorTag = '[object Error]';
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function $998f1ff604abccc1$var$isError(value) {
    if (!$hYEMs(value)) return false;
    var tag = $2OY5s(value);
    return tag == $998f1ff604abccc1$var$errorTag || tag == $998f1ff604abccc1$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$jtsd5(value);
}
module.exports = $998f1ff604abccc1$var$isError;

});

parcelRegister("a1CHL", function(module, exports) {

var $fjnSB = parcelRequire("fjnSB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $74c80559f18c75f2$var$weakMapTag = '[object WeakMap]';
/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */ function $74c80559f18c75f2$var$isWeakMap(value) {
    return $hYEMs(value) && $fjnSB(value) == $74c80559f18c75f2$var$weakMapTag;
}
module.exports = $74c80559f18c75f2$var$isWeakMap;

});

parcelRegister("akHxB", function(module, exports) {

var $ee7Ev = parcelRequire("ee7Ev");

var $7qARj = parcelRequire("7qARj");
/** Used to compose bitmasks for cloning. */ var $785d8bf9eb54b1a7$var$CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */ function $785d8bf9eb54b1a7$var$iteratee(func) {
    return $7qARj(typeof func == 'function' ? func : $ee7Ev(func, $785d8bf9eb54b1a7$var$CLONE_DEEP_FLAG));
}
module.exports = $785d8bf9eb54b1a7$var$iteratee;

});

parcelRegister("k5dRT", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");

var $224h2 = parcelRequire("224h2");
/** Used to compose bitmasks for function metadata. */ var $e9ef0836fe6d24f1$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */ var $e9ef0836fe6d24f1$var$rearg = $224h2(function(func, indexes) {
    return $xQ3hV(func, $e9ef0836fe6d24f1$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});
module.exports = $e9ef0836fe6d24f1$var$rearg;

});

parcelRegister("d0KBl", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $b69Sx = parcelRequire("b69Sx");

var $1c8hB = parcelRequire("1c8hB");

var $8aco7 = parcelRequire("8aco7");

var $1xzs7 = parcelRequire("1xzs7");

var $cNyDu = parcelRequire("cNyDu");

var $1uqnh = parcelRequire("1uqnh");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $978f6c7ba8ca5ebf$var$toPath(value) {
    if ($1c8hB(value)) return $kJvGp(value, $cNyDu);
    return $8aco7(value) ? [
        value
    ] : $b69Sx($1xzs7($1uqnh(value)));
}
module.exports = $978f6c7ba8ca5ebf$var$toPath;

});







parcelRegister("lfCZ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9f89b132fae2d75$export$2e2bcd8739ae039);
parcelRequire("l5lul");
parcelRequire("fiQ2m");

var $fYteL = parcelRequire("fYteL");
var // Notifies consumers of fatal errors. This is required so that consumers can
// react when we are unable to display the requested issue for some reason.
//
// For example, in the Project Issue Navigator (PIN), when the user does not
// have permission to view the requested issue they will instead show a
// different issue which the user does have access to.
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$e9f89b132fae2d75$export$2e2bcd8739ae039 = (onError)=>(action$)=>action$.ofType((0, $fYteL.FETCH_ISSUE_FAILURE)).do((action)=>onError && onError(action.payload.error)).ignoreElements();

});

parcelRegister("bsmrP", function(module, exports) {

$parcel$export(module.exports, "default", () => $040ebdff9485b5ec$export$2e2bcd8739ae039);
parcelRequire("8OtG5");
parcelRequire("l5lul");
parcelRequire("fiQ2m");

var $bd1K7 = parcelRequire("bd1K7");

var $JRB5w = parcelRequire("JRB5w");

var $4ceCM = parcelRequire("4ceCM");

var $f9RL0 = parcelRequire("f9RL0");

var $YU8aw = parcelRequire("YU8aw");

var $gbger = parcelRequire("gbger");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $6KjC3 = parcelRequire("6KjC3");

var $fVCj0 = parcelRequire("fVCj0");
/**
 * We should not track the 'status' field in this epic.
 * Status edits are called transitions and are tracked by the Transition Issue Experience SLA.
 */ const $040ebdff9485b5ec$var$fieldsToTrack = [
    (0, $f9RL0.ISSUE_SUMMARY),
    (0, $f9RL0.DESCRIPTION),
    (0, $f9RL0.ASSIGNEE)
];
// @ts-expect-error - TS7031 - Binding element 'payload' implicitly has an 'any' type.
const $040ebdff9485b5ec$var$shouldTrackField = ({ payload: payload })=>$040ebdff9485b5ec$var$fieldsToTrack.includes(payload.fieldId);
const $040ebdff9485b5ec$var$getAnalyticsSource = (state)=>(0, $5JqpU.analyticsSourceSelector)(state) || 'unknown';
const $040ebdff9485b5ec$var$getEditEventPayload = ({ state: state, hasSuccess: hasSuccess, fieldId: fieldId, hasEdit: hasEdit, errorMessage: errorMessage, traceId: traceId })=>{
    // Flow sadly cannot do multiple spreads in one object
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const additionalAttributes = {};
    if (errorMessage != null) additionalAttributes.errorMessage = errorMessage;
    if (traceId != null) additionalAttributes.traceId = traceId;
    return {
        experience: 'editIssue',
        analyticsSource: $040ebdff9485b5ec$var$getAnalyticsSource(state),
        application: (0, $gbger.applicationSelector)(state),
        edition: (0, $gbger.applicationEditionSelector)(state),
        wasExperienceSuccesful: hasSuccess,
        field: fieldId,
        hasEdit: hasEdit,
        additionalAttributes: additionalAttributes
    };
};
// @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type. | TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
const $040ebdff9485b5ec$var$sendEditExperienceEvent = (...args)=>(0, $4ceCM.sendExperienceAnalytics)($040ebdff9485b5ec$var$getEditEventPayload(...args));
const $040ebdff9485b5ec$var$onFieldEditCancel = (action$, store)=>action$.ofType((0, $6KjC3.FIELD_EDIT_CANCEL)).filter($040ebdff9485b5ec$var$shouldTrackField).filter(({ payload: payload })=>{
        // This filters any "field cancel" actions that occured while the field is in a waiting state
        // which would indicate that it is being saved rather than cancelled.
        const state = store.getState();
        const isWaiting = (0, $fokFV.isFieldWaitingSelector)(payload.fieldId)(state);
        return !isWaiting;
    }).do((action)=>{
        const state = store.getState();
        const { fieldId: fieldId } = action.payload;
        return $040ebdff9485b5ec$var$sendEditExperienceEvent({
            state: state,
            hasSuccess: true,
            fieldId: fieldId,
            hasEdit: false
        });
    }).ignoreElements();
const $040ebdff9485b5ec$var$onFieldSaveSuccess = (action$, store)=>action$.ofType((0, $fVCj0.FIELD_UPDATED), (0, $fVCj0.SWEET_STATE_FIELD_UPDATED)).filter($040ebdff9485b5ec$var$shouldTrackField).do((action)=>{
        const state = store.getState();
        const { fieldId: fieldId } = action.payload;
        return $040ebdff9485b5ec$var$sendEditExperienceEvent({
            state: state,
            hasSuccess: true,
            fieldId: fieldId,
            hasEdit: true
        });
    }).ignoreElements();
const $040ebdff9485b5ec$var$onFieldSaveFailure = (action$, store)=>action$.ofType((0, $fVCj0.FIELD_SAVE_FAILURE), (0, $fVCj0.SWEET_STATE_FIELD_SAVE_FAILURE)).filter($040ebdff9485b5ec$var$shouldTrackField).filter(({ payload: payload })=>// This filters for any errors that are related to network connectivity
        // We don't care to send any success/failure event should this happen.
        !(0, $JRB5w.isClientFetchError)(payload.error)).do((action)=>{
        const state = store.getState();
        const { fieldId: fieldId, error: error } = action.payload;
        const errorType = (0, $YU8aw.default)(error);
        return $040ebdff9485b5ec$var$sendEditExperienceEvent({
            state: state,
            hasSuccess: errorType !== (0, $YU8aw.SERVER_ERROR),
            fieldId: fieldId,
            hasEdit: true,
            errorMessage: `${error.statusCode || errorType} - ${error.message}`,
            traceId: error.traceId
        });
    }).ignoreElements();
var $040ebdff9485b5ec$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)($040ebdff9485b5ec$var$onFieldEditCancel, $040ebdff9485b5ec$var$onFieldSaveSuccess, $040ebdff9485b5ec$var$onFieldSaveFailure);

});
parcelRegister("YU8aw", function(module, exports) {

$parcel$export(module.exports, "SERVER_ERROR", () => $2bc2632a1ad564e1$export$125ebd30471ac25c);
$parcel$export(module.exports, "default", () => $2bc2632a1ad564e1$export$2e2bcd8739ae039);

var $7byHA = parcelRequire("7byHA");
const $2bc2632a1ad564e1$export$125ebd30471ac25c = 'SERVER_ERROR';
const $2bc2632a1ad564e1$export$558b92200f9a795 = 'VALIDATION_ERROR';
const $2bc2632a1ad564e1$export$683dbe11f74cd161 = 'CONNECTIVITY_ERROR';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2bc2632a1ad564e1$export$2e2bcd8739ae039 = (error)=>{
    if (error instanceof (0, $7byHA.ValidationError)) return $2bc2632a1ad564e1$export$558b92200f9a795;
    if (!(error instanceof (0, $7byHA.default))) return $2bc2632a1ad564e1$export$683dbe11f74cd161;
    if (error.statusCode >= 400 && error.statusCode < 500) return $2bc2632a1ad564e1$export$558b92200f9a795;
    return $2bc2632a1ad564e1$export$125ebd30471ac25c;
};

});


parcelRegister("aIBJR", function(module, exports) {

$parcel$export(module.exports, "default", () => $dca1d7cf2cad454f$export$2e2bcd8739ae039);
parcelRequire("l5lul");
parcelRequire("fiQ2m");

var $gqQv5 = parcelRequire("gqQv5");

var $3A3OQ = parcelRequire("3A3OQ");

var $3rr33 = parcelRequire("3rr33");

var $5JqpU = parcelRequire("5JqpU");

var $amu7D = parcelRequire("amu7D");
const $dca1d7cf2cad454f$export$25a759e49d5049db = 'issue.associated-issues.fetch-associated-issue-epic';
const $dca1d7cf2cad454f$export$3f27bc10068ef877 = 'Error while fetching associated issue';
const $dca1d7cf2cad454f$export$1ff2a6774b1f3389 = 'Issue key is not defined';
const $dca1d7cf2cad454f$export$c1895e088e9bd73a = 'Failed to get isResolved value for issue';
const $dca1d7cf2cad454f$var$transformAssociatedIssueData = (associatedIssueData)=>{
    const isResolved = associatedIssueData.data?.jira?.issueByKey?.isResolved;
    if (typeof isResolved !== 'boolean') throw new Error($dca1d7cf2cad454f$export$c1895e088e9bd73a);
    return {
        isResolved: isResolved
    };
};
/**
 * Fetch associated issue data from AGG for a linked and child issue
 */ const $dca1d7cf2cad454f$var$fetchAssociatedIssueRequestEpic = (associatedIssuesContextActions)=>(action$, store)=>action$.ofType((0, $3rr33.UPDATE_ASSOCIATED_ISSUE_REQUEST)).do(async (action)=>{
            try {
                const { issueKey: issueKey } = action.payload;
                if (!issueKey) throw new Error($dca1d7cf2cad454f$export$1ff2a6774b1f3389);
                const state = store.getState();
                const cloudId = (0, $5JqpU.cloudIdSelector)(state);
                const associatedIssueData = await (0, $gqQv5.default)(issueKey, cloudId, (0, $amu7D.default));
                if (associatedIssuesContextActions) associatedIssuesContextActions.mergeSingleLocalAssociatedIssueContext(issueKey, $dca1d7cf2cad454f$var$transformAssociatedIssueData(associatedIssueData));
            } catch (error) {
                if (error instanceof Error || error instanceof TypeError) (0, $3A3OQ.trackOrLogClientError)($dca1d7cf2cad454f$export$25a759e49d5049db, $dca1d7cf2cad454f$export$3f27bc10068ef877, error);
            }
        }).ignoreElements();
var $dca1d7cf2cad454f$export$2e2bcd8739ae039 = $dca1d7cf2cad454f$var$fetchAssociatedIssueRequestEpic;

});
parcelRegister("gqQv5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2454448499b7bed0$export$2e2bcd8739ae039);

var $26Djv = parcelRequire("26Djv");

var $iWLL0 = parcelRequire("iWLL0");

var $lEpcX = parcelRequire("lEpcX");

var $a60Hj = parcelRequire("a60Hj");

var $15ZJO = parcelRequire("15ZJO");

var $26Djv = parcelRequire("26Djv");
const $2454448499b7bed0$export$8134b31d48b0c969 = (0, $26Djv.default).params.name;
const $2454448499b7bed0$export$bc0e4fee51b9fd32 = (0, $26Djv.default);
const $2454448499b7bed0$var$ASSOCIATED_ISSUE_DATA = 'associated-issue-data';
const $2454448499b7bed0$export$c654e4ea3724383d = (0, $lEpcX.metrics).custom({
    key: $2454448499b7bed0$var$ASSOCIATED_ISSUE_DATA
});
const $2454448499b7bed0$export$fa9f856ee3665118 = (key)=>{
    const errors = (0, $15ZJO.stopCaptureGraphQlErrors)(key).filter((errorWrapper)=>errorWrapper.meta.operationName === $2454448499b7bed0$export$8134b31d48b0c969).flatMap((errorWrapper)=>errorWrapper.errors);
    return errors;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2454448499b7bed0$export$2e2bcd8739ae039 = async (issueKey, cloudId, environment)=>{
    if ((0, $a60Hj.isInSample)()) $2454448499b7bed0$export$c654e4ea3724383d.start();
    const id = (0, $15ZJO.startCaptureGraphQlErrors)();
    const data = await (0, $iWLL0.fetchQuery)(environment, $2454448499b7bed0$export$bc0e4fee51b9fd32, {
        cloudId: cloudId,
        issueKey: issueKey
    }).toPromise().catch((error)=>{
        // Cancel the metric and re-throw the error
        $2454448499b7bed0$export$c654e4ea3724383d?.cancel();
        throw error;
    });
    const errors = $2454448499b7bed0$export$fa9f856ee3665118(id);
    // Best-effort attempt to provide `issueId` and is not guaranteed
    const issueId = data?.jira.issueByKey?.issueId;
    $2454448499b7bed0$export$c654e4ea3724383d.stop({
        customData: issueId ? {
            issueId: issueId
        } : null
    });
    return {
        data: data,
        errors: errors
    };
};

});
parcelRegister("26Djv", function(module, exports) {

$parcel$export(module.exports, "default", () => $209c2e6ccaf3814f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<169007f7f0e0808b187c74850e4e1732>>
 * @relayHash c107bdc62965b31df5c7d6d353741a4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dae8102c203cb926d69e76db3b036e014467e7cf0acc5e2789f3cabb781da68e
const $209c2e6ccaf3814f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isResolved"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "associatedIssueDataQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issueByKey",
                                "plural": false,
                                "selections": [
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "associatedIssueDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dae8102c203cb926d69e76db3b036e014467e7cf0acc5e2789f3cabb781da68e",
            "metadata": {},
            "name": "associatedIssueDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$209c2e6ccaf3814f$var$node.hash = "7c72a81538e7ab5c77fc802667b9df45";
var $209c2e6ccaf3814f$export$2e2bcd8739ae039 = $209c2e6ccaf3814f$var$node;

});


parcelRegister("3rr33", function(module, exports) {

$parcel$export(module.exports, "UPDATE_ASSOCIATED_ISSUE_REQUEST", () => $18d622b3d1562972$export$ec6f61a8ca2ac523);
$parcel$export(module.exports, "updateAssociatedIssueRequest", () => $18d622b3d1562972$export$14e80595cf7af21f);
const $18d622b3d1562972$export$ec6f61a8ca2ac523 = 'UPDATE_ASSOCIATED_ISSUE_REQUEST';
const $18d622b3d1562972$export$14e80595cf7af21f = (issueKey)=>({
        type: $18d622b3d1562972$export$ec6f61a8ca2ac523,
        payload: {
            issueKey: issueKey
        }
    });

});


parcelRegister("aiQii", function(module, exports) {

$parcel$export(module.exports, "default", () => $49458e4feca3d7b2$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $7ZZxN = parcelRequire("7ZZxN");

var $49xWy = parcelRequire("49xWy");

var $jZDJX = parcelRequire("jZDJX");

var $ddnuS = parcelRequire("ddnuS");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$49458e4feca3d7b2$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $49xWy.FETCH_CREATE_LINKED_ISSUE_PERMISSION_REQUEST)).switchMap(()=>{
        // Required permissions to see the Create linked issue button:
        //  - Source issue is a CORE or Service Desk issue or Software issue.
        //  - Source issue is not a next-gen issue.
        //  - Issue linking feature is not deactivated.
        //  - User has LINK_ISSUES permission in the current project.
        const state = store.getState();
        const projectType = (0, $jZDJX.projectTypeSelector)(state);
        const canAddIssueLinks = (0, $ddnuS.canAddIssueLinksSelector)(state);
        const isProjectPermissionEnabled = projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
        if (canAddIssueLinks && isProjectPermissionEnabled) return (0, $3JafE.Observable).of((0, $49xWy.setCreateLinkedIssuePermission)(true));
        return (0, $3JafE.Observable).of((0, $49xWy.setCreateLinkedIssuePermission)(false));
    });

});
parcelRegister("ddnuS", function(module, exports) {

$parcel$export(module.exports, "issueLinkTypesSelector", () => $5b0a31e9bdc964a2$export$ed89d9644fe1b22e);
$parcel$export(module.exports, "canAddIssueLinksSelector", () => $5b0a31e9bdc964a2$export$423d121c43cca452);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $cFY86 = parcelRequire("cFY86");
const $5b0a31e9bdc964a2$export$ed89d9644fe1b22e = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.jiraSettings.issueLinkTypes);
const $5b0a31e9bdc964a2$export$423d121c43cca452 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (0, $cFY86.isIssueLinksEnabledSelector), $5b0a31e9bdc964a2$export$ed89d9644fe1b22e, ({ canLinkIssues: canLinkIssues }, issueLinksEnabled, types)=>!!(canLinkIssues && issueLinksEnabled && types && types.length));

});


parcelRegister("3qg0I", function(module, exports) {

$parcel$export(module.exports, "default", () => $d60db21c92265fb5$export$2e2bcd8739ae039);
parcelRequire("jAXdN");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");
parcelRequire("flmol");

var $MdoH4 = parcelRequire("MdoH4");

var $3JafE = parcelRequire("3JafE");

var $3A3OQ = parcelRequire("3A3OQ");

var $3b0Pa = parcelRequire("3b0Pa");

var $blHvU = parcelRequire("blHvU");

var $49xWy = parcelRequire("49xWy");

var $5JqpU = parcelRequire("5JqpU");

var $cFY86 = parcelRequire("cFY86");
const $d60db21c92265fb5$export$68f5654771b4762c = [
    'assignee',
    'project'
];
const $d60db21c92265fb5$export$5482800bd6f28740 = [
    'assignee',
    'project',
    'resolution'
];
const $d60db21c92265fb5$export$25a759e49d5049db = 'issue.issuelinks.fetch.linked.issues.epic';
// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'key' implicitly has an 'any' type. | TS7031 - Binding element 'fields' implicitly has an 'any' type.
const $d60db21c92265fb5$var$transformIssueAsyncFields = ({ id: id, key: key, fields: fields })=>({
        id: id,
        assigneeUrl: fields.assignee && (0, $blHvU.transformUser)(fields.assignee).avatarUrl,
        assigneeDisplayName: fields.assignee && (0, $blHvU.transformUser)(fields.assignee).displayName,
        projectType: fields.project && fields.project.projectTypeKey,
        issueKey: key,
        isResolved: !!fields.resolution
    });
const $d60db21c92265fb5$var$fetchLinkedIssues = (baseUrl, issueKeys, fields)=>(0, $3b0Pa.fetchBulkIssues)(baseUrl, issueKeys, fields).map((issues)=>issues.map($d60db21c92265fb5$var$transformIssueAsyncFields).reduce((issuesMap, issue)=>Object.assign(issuesMap, {
                [issue.issueKey]: issue
            }), {}));
const $d60db21c92265fb5$var$saveLinkedIssueSuccessEpic = (associatedIssuesContextActions)=>(action$, store)=>action$.ofType((0, $49xWy.SAVE_LINKED_ISSUE_SUCCESS)).switchMap(()=>{
            const state = store.getState();
            const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
            const issueKey = (0, $5JqpU.issueKeySelector)(state);
            const optimisticLinks = (0, $cFY86.optimisticLinksDataSelector)(state);
            const uniqueLinkedIssueKeys = (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(Object.values(optimisticLinks).map((link)=>link.linkedIssueKey));
            const savedOptimisticIds = Object.values(optimisticLinks).filter((link)=>link.isSaved).map((link)=>link.id);
            return (0, $3JafE.Observable).zip(/**
				 * fetchIssueLinks returns:
				 * - issueLinks: The actual link itself (link type, direction, etc)
				 * - linkedIssues: The issue which is linked (issue id/key, field info etc)
				 */ (0, $3b0Pa.fetchIssueLinks)(baseUrl, issueKey), /**
				 * fetchLinkedIssues returns, for each newly linked (optimistic) issue:
				 * - id
				 * - assigneeUrl
				 * - assigneeDisplayName
				 * - projectType
				 * - issueKey
				 * - isResolved
				 */ $d60db21c92265fb5$var$fetchLinkedIssues(baseUrl, uniqueLinkedIssueKeys, $d60db21c92265fb5$export$5482800bd6f28740), (issueLinks, linkedIssues)=>{
                // Update the associated issue context store with the isResolved state of the new linked issues
                const newLinkedIssuesContext = {};
                Object.entries(linkedIssues).forEach(([key, newLinkedIssue])=>{
                    newLinkedIssuesContext[key] = {
                        isResolved: !!newLinkedIssue.isResolved
                    };
                });
                associatedIssuesContextActions?.mergeLocalAssociatedIssuesContext(newLinkedIssuesContext);
                return (0, $49xWy.fetchLinkedIssuesDataSuccess)(issueLinks, linkedIssues, savedOptimisticIds, optimisticLinks);
            }).catch((error)=>{
                (0, $3A3OQ.trackOrLogClientError)($d60db21c92265fb5$export$25a759e49d5049db, 'Error while fetching new issue links and their details', error);
                return (0, $3JafE.Observable).of((0, $49xWy.fetchLinkedIssuesDataFailure)(savedOptimisticIds, error));
            });
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d60db21c92265fb5$export$2e2bcd8739ae039 = (associatedIssuesContextActions)=>$d60db21c92265fb5$var$saveLinkedIssueSuccessEpic(associatedIssuesContextActions);

});
parcelRegister("3b0Pa", function(module, exports) {

$parcel$export(module.exports, "fetchDynamicAppDataWithRetries", () => $97f2ad9f1aee633a$export$7831fbb834fafd77);
$parcel$export(module.exports, "fetchAllAppDataWithRetries", () => $97f2ad9f1aee633a$export$6da58c9613829525);
$parcel$export(module.exports, "fetchBulkIssues", () => $97f2ad9f1aee633a$export$a2c6c774713b6c8);
$parcel$export(module.exports, "fetchIssueLinks", () => $97f2ad9f1aee633a$export$62edc09d9dd31072);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $kd0cS = parcelRequire("kd0cS");

var $3JafE = parcelRequire("3JafE");
parcelRequire("kO85v");
parcelRequire("9u6v2");
parcelRequire("cpH8E");
parcelRequire("jAXdN");
parcelRequire("4ffW3");
parcelRequire("iects");
parcelRequire("8SBcT");
parcelRequire("6zblu");
parcelRequire("buH2V");
parcelRequire("flmol");
parcelRequire("l5lul");
parcelRequire("1Lcr1");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $aiRd8 = parcelRequire("aiRd8");

var $4lk5F = parcelRequire("4lk5F");

var $gIOVj = parcelRequire("gIOVj");

var $eECgD = parcelRequire("eECgD");

var $7PTrm = parcelRequire("7PTrm");

var $5JqpU = parcelRequire("5JqpU");

var $4z02k = parcelRequire("4z02k");

var $elwy3 = parcelRequire("elwy3");

var $2aapS = parcelRequire("2aapS");

var $6NBhC = parcelRequire("6NBhC");

var $iVHfZ = parcelRequire("iVHfZ");

var $6zsYX = parcelRequire("6zsYX");

var $lV5H0 = parcelRequire("lV5H0");
const $97f2ad9f1aee633a$export$7831fbb834fafd77 = (state, dynamicIssueQueueParams)=>{
    const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
    const issueKey = (0, $5JqpU.issueKeySelector)(state);
    const cloudId = (0, $5JqpU.cloudIdSelector)(state);
    // withRetries2 is not working here properly since we are not passing a function ref to the retry but rather a converted promise
    // more details here: https://github.com/ReactiveX/rxjs/issues/1596
    // this code will be obsoleted with release of relay so we won't attempt o fix this
    return (0, $3JafE.Observable).zip(...(0, $eECgD.withRetries2)((0, $3JafE.Observable).fromPromise((0, $2aapS.fetchDynamicGiraData)(baseUrl, issueKey, dynamicIssueQueueParams)), (0, $3JafE.Observable).fromPromise((0, $elwy3.fetchAggData)(issueKey, cloudId))), (giraData, aggData)=>{
        const aggLegacyGraphqlData = (0, $4lk5F.transformAggResponseToLegacyGraphql)(aggData);
        if (!aggLegacyGraphqlData) {
            // The transformers did not return anything - this happens if the data is missing for some reason
            // We should never fall into this case but its here for type checking
            const message = 'Failed to transform issue data from AGG, transformers returned empty value';
            throw new Error(message);
        }
        return {
            ...giraData,
            ...aggLegacyGraphqlData
        };
    });
};
/**
 * Get a promise out of the given {@param prefetchedResourceManager} and clear it from the resourceManager.
 * It's necessary to do a destructive read in a retryable scenario, to prevent re-using a failed response and instead kick off a fresh fetch
 */ const $97f2ad9f1aee633a$var$getAndResetPrefetchedPromise = (prefetchedResourceManager, promiseKey)=>{
    const prefetchedResource = prefetchedResourceManager?.[promiseKey];
    // eslint-disable-next-line no-param-reassign
    prefetchedResourceManager && (prefetchedResourceManager[promiseKey] = null);
    return prefetchedResource;
};
const $97f2ad9f1aee633a$var$getStatusCodeFromErrorIfPresent = (error)=>error && 'statusCode' in error && error.statusCode && error.statusCode;
/**
 * To be used in an {@code Observable.retryWhen}
 * Will check if the error is retryable with the given {@param isErrorRetryable} and if so, will retry up to the given {@param retryLimit} times (defaults to 1)
 */ const $97f2ad9f1aee633a$var$retryRequestIf = (isErrorRetryable, codes, onFailure, timeout = [
    100,
    1000
], retryLimit = 1)=>{
    let retries = 0;
    return (errors)=>errors.mergeMap((error)=>{
            codes.push($97f2ad9f1aee633a$var$getStatusCodeFromErrorIfPresent(error) || 418 /* not a teapot */ );
            if (isErrorRetryable(error) && retries < retryLimit) {
                retries += 1;
                if ((0, $1ybV0.ff)('issue-view-fetchallappdatawithretries-timeout_ad77o')) return (0, $3JafE.Observable).of(retries).delay(// use a random delay to reduce pressure on the network and prevent concurrent requests
                // the top boundary is set to 1s and should be decreased once our understanding on retry-ability improves
                timeout[0] + Math.random() * (timeout[1] - timeout[0]));
                return (0, $3JafE.Observable).of(retries);
            }
            onFailure(codes);
            return (0, $3JafE.Observable).throw(error);
        });
};
/**
 * Returns a boolean if the statuscode is one that indicates a retry might be helpful
 */ const $97f2ad9f1aee633a$var$isStatusCodeTransientError = (statusCode)=>{
    if (statusCode === 429 || statusCode >= 500) // jira is too busy, or server error
    return true;
    return false;
};
const $97f2ad9f1aee633a$var$isIssueViewFetchErrorRetryable = (error)=>!!(error && 'statusCode' in error && error.statusCode && $97f2ad9f1aee633a$var$isStatusCodeTransientError(error.statusCode));
const $97f2ad9f1aee633a$var$onFail = (type)=>(codes)=>{
        // is any error was isIssueViewFetchErrorRetryable
        if (codes.length >= 2) (0, $gUUjF.default).safeInfoWithoutCustomerData(`jira-issue-view-services.fetchAllAppDataWithRetries:${type}`, codes[0] !== codes[1] ? 'retryRequestIf: failed with different codes' : 'retryRequestIf: failed with 2 retries', {
            code1: codes[0],
            code2: codes[1]
        });
    };
const $97f2ad9f1aee633a$var$checkRetryCodes = (type, codes)=>{
    // if code present, then retry DID HELP mitigating the problem
    if (codes.length > 0) (0, $gUUjF.default).safeInfoWithoutCustomerData(`jira-issue-view-services.fetchAllAppDataWithRetries:${type}`, 'retryRequestIf: passed after failure', {
        code1: codes[0]
    });
};
const $97f2ad9f1aee633a$export$6da58c9613829525 = (state, prefetchResourceManager, issueContextActions)=>{
    const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
    const issueKey = (0, $5JqpU.issueKeySelector)(state);
    const projectKey = (0, $5JqpU.projectKeySelector)(state);
    const giraData$ = (0, $3JafE.Observable).defer(()=>(0, $2aapS.fetchAllGiraData)(baseUrl, issueKey, $97f2ad9f1aee633a$var$getAndResetPrefetchedPromise(prefetchResourceManager, 'issueGiraData'), (0, $4z02k.isGiraAGGConsistencyCheckEnabled)() ? issueContextActions : undefined)).catch((error)=>{
        throw new (0, $7PTrm.IssueViewFetchError)(error, (0, $gIOVj.ISSUE_VIEW_INTERACTIVE_QUERY));
    }); // This will go away once all data has been migrated from gira
    const cloudId = (0, $5JqpU.cloudIdSelector)(state);
    const aggData$ = (0, $3JafE.Observable).defer(()=>(0, $elwy3.fetchAggData)(issueKey, cloudId, $97f2ad9f1aee633a$var$getAndResetPrefetchedPromise(prefetchResourceManager, 'issueAggData')));
    const giraCodes = [];
    const aggCodes = [];
    const dataObservablesWithRetries = [
        giraData$.retryWhen($97f2ad9f1aee633a$var$retryRequestIf($97f2ad9f1aee633a$var$isIssueViewFetchErrorRetryable, giraCodes, $97f2ad9f1aee633a$var$onFail('gira'))),
        aggData$.retryWhen($97f2ad9f1aee633a$var$retryRequestIf($97f2ad9f1aee633a$var$isIssueViewFetchErrorRetryable, aggCodes, $97f2ad9f1aee633a$var$onFail('agg')))
    ];
    return (0, $3JafE.Observable).zip(...dataObservablesWithRetries, (giraData, aggData)=>{
        $97f2ad9f1aee633a$var$checkRetryCodes('gira', giraCodes);
        $97f2ad9f1aee633a$var$checkRetryCodes('agg', aggCodes);
        const aggLegacyGraphqlData = (0, $4lk5F.transformAggResponseToLegacyGraphql)(aggData);
        const aggLegacyGiraData = (0, $4lk5F.transformAggResponseToLegacyGira)(aggData, projectKey);
        if (!aggLegacyGraphqlData) {
            // The transformers did not return anything - this happens if the data is missing for some reason
            // We should never fall into this case but its here for type checking
            const message = 'Failed to transform issue data from AGG, transformers returned empty value';
            throw new Error(message);
        }
        if ((0, $4z02k.isGiraAGGConsistencyCheckEnabled)()) issueContextActions?.mergeIssueContext({
            aggResponse: (0, (/*@__PURE__*/$parcel$interopDefault($kd0cS)))(aggData)
        });
        return (0, $6NBhC.combineResponseData)(aggLegacyGraphqlData, aggLegacyGiraData, giraData);
    });
};
const $97f2ad9f1aee633a$var$search = (baseUrl, jql, fields)=>(0, $aiRd8.default)((0, $lV5H0.getSearchUrl)(baseUrl), {
        method: 'POST',
        body: JSON.stringify({
            jql: jql,
            fields: fields
        })
    }).map((0, $6zsYX.searchResultTransformer));
// Maximum page size returned by search.
const $97f2ad9f1aee633a$var$JQL_PAGE_SIZE = 50;
const $97f2ad9f1aee633a$export$a2c6c774713b6c8 = (baseUrl, issueKeys, fields)=>// @ts-expect-error - TS2769 - No overload matches this call.
    (0, $3JafE.Observable).from(issueKeys).bufferCount($97f2ad9f1aee633a$var$JQL_PAGE_SIZE).flatMap((keys)=>$97f2ad9f1aee633a$var$search(baseUrl, `key in (${keys.join(',')})`, fields)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((issues, currentBufferedIssues)=>[
            ...issues,
            ...currentBufferedIssues
        ], []);
const $97f2ad9f1aee633a$export$62edc09d9dd31072 = (baseUrl, issueKey)=>(0, $aiRd8.default)((0, $lV5H0.getIssueLinksUrl)(baseUrl, issueKey)).map((response)=>// @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS2571 - Object is of type 'unknown'.
        response.fields.issuelinks && (0, $iVHfZ.transformIssueLinks)(baseUrl, response.fields.issuelinks));
const $97f2ad9f1aee633a$export$8ff8a960661ec8de = (issueKeys)=>$97f2ad9f1aee633a$export$a2c6c774713b6c8('', issueKeys, [
        'project'
    ]).map((response)=>response.map(({ fields: fields })=>fields?.project?.projectTypeKey)).toPromise();

});
parcelRegister("4lk5F", function(module, exports) {

$parcel$export(module.exports, "transformAggResponseToLegacyGraphql", () => $c33d53fe3ff26765$export$514b3a134b0bfbb4);
$parcel$export(module.exports, "transformAggResponseToLegacyGira", () => $c33d53fe3ff26765$export$66c67225b174bb37);

var $lEpcX = parcelRequire("lEpcX");

var $1ybV0 = parcelRequire("1ybV0");

var $a60Hj = parcelRequire("a60Hj");

var $4lee3 = parcelRequire("4lee3");

var $8zTcQ = parcelRequire("8zTcQ");
var $iQrgs = parcelRequire("iQrgs");
var $9ax61 = parcelRequire("9ax61");
var $3mPa1 = parcelRequire("3mPa1");
var $in2oj = parcelRequire("in2oj");
var $eM65p = parcelRequire("eM65p");
var $ijtj3 = parcelRequire("ijtj3");
var $91Rk4 = parcelRequire("91Rk4");
var $loX5s = parcelRequire("loX5s");
var $lyWeh = parcelRequire("lyWeh");
var $8QoGX = parcelRequire("8QoGX");
var $bei0E = parcelRequire("bei0E");
var $lvsGR = parcelRequire("lvsGR");
var $hG5lo = parcelRequire("hG5lo");
const $c33d53fe3ff26765$var$GIRA_AGG_MIGRATION_ISARCHIVED_FLAG = 'issue.details.gira-agg-migration-isarchived';
const $c33d53fe3ff26765$var$TIME_TO_TRANSFORM_AGG = 'issue-agg-field-transformers';
const $c33d53fe3ff26765$var$timeToTransformAgg = (0, $lEpcX.metrics).custom({
    key: $c33d53fe3ff26765$var$TIME_TO_TRANSFORM_AGG
});
const $c33d53fe3ff26765$export$e381e7592f4a9b1 = 'Issue fields are not available';
const $c33d53fe3ff26765$var$transformAgile = (data)=>{
    // epicLinkFieldId is a temporary solution until GIC supports the unified parent creation.
    const epicKey = data.jira?.epicLinkFieldKey || '';
    return {
        epic: {
            key: epicKey
        }
    };
};
const $c33d53fe3ff26765$export$8f678cf0c141c51 = (data)=>{
    const issue = data.jira.issueByKey;
    if (!issue?.fields) throw new Error($c33d53fe3ff26765$export$e381e7592f4a9b1);
    const fieldsEdges = issue?.fields?.edges;
    const project = (0, $ijtj3.transformAggProjectToProjectContext)(fieldsEdges);
    const isNextGenProject = project.isSimplified === true;
    const hierarchyLevelFields = (0, $eM65p.transformAggIssueToHierarchyLegacyFields)(issue);
    const fields = (0, $9ax61.transformAggFieldsToLegacyFields)(fieldsEdges);
    const parentFields = (0, $3mPa1.transformAggFieldsToLegacyParentFields)(fieldsEdges);
    const { fieldsState: childrenIssueFields, childIssueMeta: childIssueMeta } = (0, $8QoGX.transformAggResponseToLegacyChildIssues)(data, {
        issueHierarchyLevel: fields.issuetype?.value.hierarchyLevel ?? 0,
        isNextGenProject: isNextGenProject
    });
    const { childrenIssues: childrenIssues, subtasks: subtasks } = (0, $8QoGX.transformServerChildIssueFieldsToAssociatedIssues)(childrenIssueFields, {
        isTeamManagedProject: isNextGenProject,
        childIssueMeta: childIssueMeta
    });
    const agile = $c33d53fe3ff26765$var$transformAgile(data);
    const issueId = issue?.issueId || '';
    const viewScreenId = issue?.screenId;
    const viewScreen = viewScreenId === null ? null : {
        viewScreenId: viewScreenId
    };
    return {
        childIssuesLimit: data.jira.childIssuesLimit,
        project: project,
        issue: {
            fields: {
                ...fields,
                ...childrenIssueFields,
                ...hierarchyLevelFields,
                ...parentFields
            },
            id: issueId,
            agile: agile,
            tabs: {},
            ...viewScreen
        },
        createdDate: fields.created?.value || null,
        updatedDate: fields.updated?.value || null,
        statuses: (0, $8zTcQ.getStatusesDeprecatedValue)(fields),
        issueLinks: (0, $loX5s.transformAggResponseToIssueLinks)(data),
        subtasks: subtasks,
        childrenIssues: childrenIssues,
        parentIssue: (0, $3mPa1.transformServerParentFieldsToParentIssue)(parentFields)
    };
};
const $c33d53fe3ff26765$export$514b3a134b0bfbb4 = (data)=>{
    if (data === undefined || data === null) return null;
    try {
        if ((0, $a60Hj.isInSample)()) $c33d53fe3ff26765$var$timeToTransformAgg.start();
        const legacyGraphqlFields = $c33d53fe3ff26765$export$8f678cf0c141c51(data);
        $c33d53fe3ff26765$var$timeToTransformAgg.stop();
        return legacyGraphqlFields;
    } catch (error) {
        $c33d53fe3ff26765$var$timeToTransformAgg.cancel();
        throw error;
    }
};
const $c33d53fe3ff26765$var$transformAggJiraSettingsToLegacyGira = (aggData)=>({
        subtasksConfiguration: (0, $91Rk4.transformAggResponseSubtasksConfig)(aggData),
        timeTrackingConfiguration: (0, $bei0E.transformAggResponseToTimeTrackingConfig)(aggData),
        issueLinkTypes: (0, $lyWeh.transformAggResponseToIssueLinkTypes)(aggData)
    });
const $c33d53fe3ff26765$var$TIME_TO_TRANSFORM_AGG_TO_GIRA = 'issue-agg-to-gira-transform';
const $c33d53fe3ff26765$var$timeToTransformAggToLegacyGira = (0, $lEpcX.metrics).custom({
    key: $c33d53fe3ff26765$var$TIME_TO_TRANSFORM_AGG_TO_GIRA
});
const $c33d53fe3ff26765$export$66c67225b174bb37 = (aggData, projectKey, isConsistencyCheck = false)=>{
    // If this transform is for the consistency check, we include slices if they have vaue 'CHECK' or 'CHECK_RETURN_NEW'
    // If this transform is for the issue view, we include slices if they have vaue 'NEW' or 'CHECK_RETURN_NEW'
    const shouldIncludeSlice = isConsistencyCheck ? (0, $4lee3.getIsConsistencyCheckEnabled) : (0, $4lee3.getIsNewValueReturned);
    const isNewValueIsArchived = shouldIncludeSlice($c33d53fe3ff26765$var$GIRA_AGG_MIGRATION_ISARCHIVED_FLAG);
    try {
        if ((0, $a60Hj.isInSample)()) $c33d53fe3ff26765$var$timeToTransformAggToLegacyGira.start();
        const transformedData = {
            jiraSettings: $c33d53fe3ff26765$var$transformAggJiraSettingsToLegacyGira(aggData),
            ...isNewValueIsArchived ? {
                isArchived: (0, $in2oj.transformAggIsArchivedToLegacyGira)(aggData)
            } : {},
            myPreferences: (0, $lvsGR.transformAggUserPreferencesToLegacyGira)(aggData, projectKey),
            activitySortOrder: (0, $hG5lo.transformAggUserPreferencesToLegacyGiraActivityFeedSortOrder)(aggData),
            ...(0, $1ybV0.ff)('issue.details.gira-agg-migration-attachments_ecebe') ? {
                attachments: (0, $iQrgs.transformAggAttachmentsToLegacyGira)(aggData)
            } : {}
        };
        const issueId = aggData?.jira.issueByKey?.issueId;
        $c33d53fe3ff26765$var$timeToTransformAggToLegacyGira.stop({
            customData: {
                issueId: issueId || '',
                [$c33d53fe3ff26765$var$GIRA_AGG_MIGRATION_ISARCHIVED_FLAG]: isNewValueIsArchived
            }
        });
        return transformedData;
    } catch (error) {
        $c33d53fe3ff26765$var$timeToTransformAgg.cancel();
        throw error;
    }
};

});
parcelRegister("4lee3", function(module, exports) {

$parcel$export(module.exports, "getIsNewValueReturned", () => $2b4c552abc7622c1$export$948fffd91c834735);
$parcel$export(module.exports, "getIsConsistencyCheckEnabled", () => $2b4c552abc7622c1$export$aebe03c55632defe);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");
const $2b4c552abc7622c1$export$ce9bf88ea9de580b = (flag)=>(0, $eUqFw.useMemo)(()=>({
            featureFlagName: flag,
            // eslint-disable-next-line jira/ff/static-feature-flags
            value: (0, $1ybV0.getMultivariateFeatureFlag)(flag, 'OLD', [
                'NEW',
                'CHECK_RETURN_NEW',
                'CHECK',
                'OLD'
            ])
        }), [
        flag
    ]);
const $2b4c552abc7622c1$export$948fffd91c834735 = (flag)=>{
    // eslint-disable-next-line jira/ff/static-feature-flags
    const featureFlagValue = (0, $1ybV0.getMultivariateFeatureFlag)(flag, 'OLD', [
        'NEW',
        'CHECK_RETURN_NEW',
        'CHECK',
        'OLD'
    ]);
    return featureFlagValue === 'NEW' || featureFlagValue === 'CHECK_RETURN_NEW';
};
const $2b4c552abc7622c1$export$aebe03c55632defe = (flag)=>{
    // eslint-disable-next-line jira/ff/static-feature-flags
    const featureFlagValue = (0, $1ybV0.getMultivariateFeatureFlag)(flag, 'OLD', [
        'NEW',
        'CHECK_RETURN_NEW',
        'CHECK',
        'OLD'
    ]);
    return featureFlagValue === 'CHECK' || featureFlagValue === 'CHECK_RETURN_NEW';
};
const $2b4c552abc7622c1$export$7cdf481ce732d27f = (flag)=>{
    // eslint-disable-next-line jira/ff/static-feature-flags
    const featureFlagValue = (0, $1ybV0.getMultivariateFeatureFlag)(flag, 'OLD', [
        'NEW',
        'CHECK_RETURN_NEW',
        'CHECK',
        'OLD'
    ]);
    return featureFlagValue === 'NEW' || featureFlagValue === 'CHECK_RETURN_NEW' || featureFlagValue === 'CHECK';
};
const $2b4c552abc7622c1$export$117d07493a3c1dce = (flag)=>{
    // eslint-disable-next-line jira/ff/static-feature-flags
    const featureFlagValue = (0, $1ybV0.getMultivariateFeatureFlag)(flag, 'OLD', [
        'NEW',
        'CHECK_RETURN_NEW',
        'CHECK',
        'OLD'
    ]);
    return featureFlagValue === 'OLD' || featureFlagValue === 'CHECK_RETURN_NEW' || featureFlagValue === 'CHECK';
};

});

parcelRegister("8zTcQ", function(module, exports) {

$parcel$export(module.exports, "getStatusesDeprecatedValue", () => $23ba42f503d38228$export$b80ec59d806c2f94);
$parcel$export(module.exports, "transformAggStatusToLegacyField", () => $23ba42f503d38228$export$c80e5acb1c882c48);

var $8Qd0L = parcelRequire("8Qd0L");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $23ba42f503d38228$export$b80ec59d806c2f94 = (fields)=>{
    const { status: status } = fields;
    if (!status || status.value == null) return {};
    const { value: value } = status;
    return {
        [value.id]: {
            id: value.id,
            name: value.name,
            statusCategory: (0, $8Qd0L.statusCategoryForId)(value.statusCategory?.id)
        }
    };
};
const $23ba42f503d38228$var$transformJiraStatusToLegacyStatus = (status)=>{
    if (status == null) return null;
    const { statusCategory: statusCategory } = status;
    return {
        id: status.statusId,
        name: status.name || '',
        statusCategory: {
            id: Number(statusCategory.statusCategoryId)
        }
    };
};
const $23ba42f503d38228$export$c80e5acb1c882c48 = (node)=>{
    if (node.type !== (0, $lO4Or.STATUS_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $23ba42f503d38228$var$transformJiraStatusToLegacyStatus(node.status),
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $lO4Or.STATUS_TYPE),
            custom: null,
            system: (0, $lO4Or.STATUS_TYPE)
        }
    };
};

});
parcelRegister("f4e7j", function(module, exports) {

$parcel$export(module.exports, "transformAggNodeToLegacyField", () => $e263c15d21d94d7e$export$e7ea61856a169c36);
$parcel$export(module.exports, "transformAggConnection", () => $e263c15d21d94d7e$export$daf92cda81d86cdc);
$parcel$export(module.exports, "toLegacyConnectOption", () => $e263c15d21d94d7e$export$b5de5f3d2de73afc);
const $e263c15d21d94d7e$export$e7ea61856a169c36 = (node)=>({
        ari: 'id' in node ? node.id : undefined,
        key: 'fieldId' in node && !!node.fieldId ? node.fieldId : '',
        title: 'name' in node ? node.name : '',
        editable: Boolean('isEditableInIssueView' in node ? node.isEditableInIssueView : 'fieldConfig' in node && node.fieldConfig != null && 'isEditable' in node.fieldConfig && node.fieldConfig.isEditable),
        required: Boolean('fieldConfig' in node && node.fieldConfig != null && 'isRequired' in node.fieldConfig && node.fieldConfig.isRequired),
        autoCompleteUrl: 'searchUrl' in node ? node.searchUrl : null,
        allowedValues: [],
        value: null,
        schema: {
            type: 'type' in node ? node.type : '',
            custom: null,
            system: null
        },
        description: 'description' in node && node.description ? node.description : undefined
    });
const $e263c15d21d94d7e$export$daf92cda81d86cdc = (connection, transformCallback)=>{
    const edges = connection?.edges ?? [];
    if (transformCallback) return edges.map((edge)=>edge?.node != null ? transformCallback(edge.node) : null).filter(Boolean);
    return edges.map((edge)=>edge?.node).filter(Boolean);
};
const $e263c15d21d94d7e$export$b5de5f3d2de73afc = (node)=>{
    if (!node) return null;
    return {
        value: node.value ?? null,
        id: parseInt(node.optionId, 10)
    };
};

});


parcelRegister("iQrgs", function(module, exports) {

$parcel$export(module.exports, "transformAggAttachmentsToLegacyGira", () => $b2ea53f5f47335ea$export$7d46eafd514854a0);

var $gUUjF = parcelRequire("gUUjF");

var $gKvpM = parcelRequire("gKvpM");
const $b2ea53f5f47335ea$var$logError = (msg)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('issue.agg-transformers.attachments', msg);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b2ea53f5f47335ea$var$isValidParent = (value)=>value in (0, $gKvpM.ATTACHMENT_PARENT);
const $b2ea53f5f47335ea$export$7d46eafd514854a0 = (data)=>{
    const edges = data.jira.issueByKey?.attachments?.edges;
    if (!edges) return [];
    const attachments = edges.reduce((acc, edge)=>{
        const { node: node } = edge ?? {};
        if (!node) {
            $b2ea53f5f47335ea$var$logError('Attachment was null or undefined');
            return acc;
        }
        if (node.__typename !== 'JiraPlatformAttachment') {
            $b2ea53f5f47335ea$var$logError(`Invalid Attachment type ${node.__typename}`);
            return acc;
        }
        if (!$b2ea53f5f47335ea$var$isValidParent(node.parentName)) {
            $b2ea53f5f47335ea$var$logError(`Invalid parent name ${node.parentName} for attachment ${node.attachmentId}`);
            return acc;
        }
        if (!node.fileName || !node.mediaApiFileId || !node.fileSize || !node.parentId) {
            $b2ea53f5f47335ea$var$logError(`Attachment property was null or undefined for attachment ${node.attachmentId}`);
            return acc;
        }
        const attachment = {
            id: node.attachmentId,
            filename: node.fileName,
            mimetype: node.mimeType || undefined,
            mediaApiFileId: node.mediaApiFileId,
            createdDate: Math.floor(new Date(node.created).getTime() / 1000),
            filesize: node.fileSize,
            parentName: node.parentName,
            parentId: node.parentId,
            author: node.author ? {
                accountId: node.author.accountId
            } : null,
            hasRestrictedParent: node.hasRestrictedParent || false,
            isParentCommentJsdInternal: node.hasRestrictedParent || false
        };
        acc.push(attachment);
        return acc;
    }, []);
    return attachments;
};

});
parcelRegister("gKvpM", function(module, exports) {

$parcel$export(module.exports, "ATTACHMENT_PARENT", () => $423d06693f873e15$export$16fdebc4a148194);
const $423d06693f873e15$export$16fdebc4a148194 = {
    comment: 'comment',
    worklog: 'worklog',
    description: 'description',
    environment: 'environment',
    customfield: 'customfield',
    issue: 'issue',
    form: 'form'
};

});


parcelRegister("9ax61", function(module, exports) {

$parcel$export(module.exports, "transformAggFieldToLegacyField", () => $85127a55c87acb28$export$586ba15cbf3d3031);
$parcel$export(module.exports, "transformAggFieldsToLegacyFields", () => $85127a55c87acb28$export$ba106ff8c087e6b1);

var $5iWql = parcelRequire("5iWql");

var $lO4Or = parcelRequire("lO4Or");

var $kBgu2 = parcelRequire("kBgu2");

var $blEoo = parcelRequire("blEoo");

var $6Ux91 = parcelRequire("6Ux91");

var $5sNJN = parcelRequire("5sNJN");

var $2wvLE = parcelRequire("2wvLE");

var $8d1m1 = parcelRequire("8d1m1");

var $5CYGa = parcelRequire("5CYGa");

var $9wKha = parcelRequire("9wKha");

var $6PKzm = parcelRequire("6PKzm");

var $jyP56 = parcelRequire("jyP56");

var $epJqO = parcelRequire("epJqO");

var $Pxexr = parcelRequire("Pxexr");

var $beuR4 = parcelRequire("beuR4");

var $d9IUw = parcelRequire("d9IUw");

var $xnQ91 = parcelRequire("xnQ91");

var $jsTfy = parcelRequire("jsTfy");

var $55kng = parcelRequire("55kng");

var $7BRej = parcelRequire("7BRej");

var $04Gbh = parcelRequire("04Gbh");

var $3ZJZc = parcelRequire("3ZJZc");

var $bw8ws = parcelRequire("bw8ws");

var $9vCKL = parcelRequire("9vCKL");

var $i5dch = parcelRequire("i5dch");

var $iJcxE = parcelRequire("iJcxE");

var $djkJh = parcelRequire("djkJh");

var $kbDa2 = parcelRequire("kbDa2");

var $4gy8O = parcelRequire("4gy8O");

var $9w928 = parcelRequire("9w928");

var $3khS7 = parcelRequire("3khS7");

var $c52Z6 = parcelRequire("c52Z6");

var $6IjGS = parcelRequire("6IjGS");

var $eOsdu = parcelRequire("eOsdu");

var $6MxWX = parcelRequire("6MxWX");

var $9myMG = parcelRequire("9myMG");

var $gM34d = parcelRequire("gM34d");

var $16kx8 = parcelRequire("16kx8");

var $4IQ8F = parcelRequire("4IQ8F");

var $lcInz = parcelRequire("lcInz");

var $4PFnn = parcelRequire("4PFnn");

var $alpM1 = parcelRequire("alpM1");

var $gHd8e = parcelRequire("gHd8e");

var $dUrU1 = parcelRequire("dUrU1");

var $hQM7C = parcelRequire("hQM7C");

var $QjWSM = parcelRequire("QjWSM");

var $4CGp4 = parcelRequire("4CGp4");

var $lWE99 = parcelRequire("lWE99");

var $4eNqf = parcelRequire("4eNqf");

var $fkHM1 = parcelRequire("fkHM1");

var $fkaQR = parcelRequire("fkaQR");

var $ijtj3 = parcelRequire("ijtj3");

var $gyvos = parcelRequire("gyvos");

var $3w75b = parcelRequire("3w75b");

var $lQr58 = parcelRequire("lQr58");

var $8oO4q = parcelRequire("8oO4q");

var $5Ne6t = parcelRequire("5Ne6t");

var $2ETkN = parcelRequire("2ETkN");

var $fz8Wc = parcelRequire("fz8Wc");

var $jBiXV = parcelRequire("jBiXV");

var $1XUHd = parcelRequire("1XUHd");

var $c6LKM = parcelRequire("c6LKM");

var $8zTcQ = parcelRequire("8zTcQ");

var $5W75j = parcelRequire("5W75j");

var $7iFVU = parcelRequire("7iFVU");

var $kyZt3 = parcelRequire("kyZt3");

var $dX2ot = parcelRequire("dX2ot");

var $jhiYN = parcelRequire("jhiYN");

var $1BsAz = parcelRequire("1BsAz");
// We're memoising this just in case we FF another field
const $85127a55c87acb28$var$getTransformersNonMemoised = ()=>({
        [(0, $lO4Or.AFFECTED_SERVICES_GQL_FIELD)]: (0, $kBgu2.transformAggAffectedServicesToLegacyField),
        [(0, $lO4Or.BOOLEAN_GQL_FIELD)]: (0, $6Ux91.transformAggBooleanToLegacyField),
        [(0, $lO4Or.CASCADING_SELECT_GQL_FIELD)]: (0, $5sNJN.transformAggCascadingSelectToLegacyField),
        [(0, $lO4Or.CHECKBOX_GQL_FIELD)]: (0, $2wvLE.transformAggCheckboxToLegacyField),
        [(0, $lO4Or.CMDB_GQL_FIELD)]: (0, $8d1m1.transformAggCMDBToLegacyField),
        [(0, $lO4Or.MULTI_SELECT_GQL_FIELD)]: (0, $hQM7C.transformAggMultipleSelectToLegacyField),
        [(0, $lO4Or.COMPONENTS_GQL_FIELD)]: (0, $9wKha.transformAggComponentsToLegacyField),
        [(0, $lO4Or.CONNECT_DATE_TIME_GQL_FIELD)]: (0, $6PKzm.transformAggConnectDateTimeToLegacyField),
        [(0, $lO4Or.CONNECT_MULTI_SELECT_GQL_FIELD)]: (0, $jyP56.transformAggConnectMultipleSelectToLegacyField),
        [(0, $lO4Or.CONNECT_NUMBER_GQL_FIELD)]: (0, $epJqO.transformAggConnectNumberToLegacyField),
        [(0, $lO4Or.CONNECT_RICH_TEXT_GQL_FIELD)]: (0, $Pxexr.transformAggConnectRichTextToLegacyField),
        [(0, $lO4Or.CONNECT_SINGLE_SELECT_GQL_FIELD)]: (0, $beuR4.transformAggConnectSingleSelectToLegacyField),
        [(0, $lO4Or.CONNECT_TEXT_GQL_FIELD)]: (0, $d9IUw.transformAggConnectTextToLegacyField),
        [(0, $lO4Or.COLOR_GQL_FIELD)]: (0, $5CYGa.transformAggColorToLegacyField),
        [(0, $lO4Or.DATE_PICKER_GQL_FIELD)]: (0, $jsTfy.transformAggDatePickerToLegacyField),
        [(0, $lO4Or.DATE_TIME_GQL_FIELD)]: (0, $55kng.transformAggDateTimePickerToLegacyField),
        [(0, $lO4Or.EPIC_LINK_GQL_FIELD)]: (0, $7BRej.transformAggEpicLinkToLegacyField),
        [(0, $lO4Or.FLAG_GQL_FIELD)]: (0, $04Gbh.transformAggFlagToLegacyField),
        [(0, $lO4Or.FORGE_DATETIME_GQL_FIELD)]: (0, $bw8ws.transformAggForgeDateTimeToLegacyField),
        [(0, $lO4Or.FORGE_DATE_GQL_FIELD)]: (0, $3ZJZc.transformAggForgeDateToLegacyField),
        [(0, $lO4Or.FORGE_GROUP_GQL_FIELD)]: (0, $9vCKL.transformAggForgeGroupToLegacyField),
        [(0, $lO4Or.FORGE_GROUPS_GQL_FIELD)]: (0, $i5dch.transformAggForgeGroupsToLegacyField),
        [(0, $lO4Or.FORGE_NUMBER_GQL_FIELD)]: (0, $iJcxE.transformAggForgeNumberToLegacyField),
        [(0, $lO4Or.FORGE_OBJECT_GQL_FIELD)]: (0, $djkJh.transformAggForgeObjectToLegacyField),
        [(0, $lO4Or.FORGE_STRING_GQL_FIELD)]: (0, $kbDa2.transformAggForgeStringToLegacyField),
        [(0, $lO4Or.FORGE_STRINGS_GQL_FIELD)]: (0, $4gy8O.transformAggForgeStringsToLegacyField),
        [(0, $lO4Or.FORGE_USER_GQL_FIELD)]: (0, $9w928.transformAggForgeUserToLegacyField),
        [(0, $lO4Or.FORGE_USERS_GQL_FIELD)]: (0, $3khS7.transformAggForgeUsersToLegacyField),
        [(0, $lO4Or.ISSUE_RESTRICTION_GQL_FIELD)]: (0, $6IjGS.transformAggIssueRestrictionToLegacyField),
        [(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)]: (0, $eOsdu.transformAggIssueTypeToLegacyField),
        [(0, $lO4Or.JSM_APPROVAL_GQL_FIELD)]: (0, $6MxWX.transformAggJSMApprovalsToLegacyField),
        [(0, $lO4Or.JSM_ASSETS_GQL_FIELD)]: (0, $blEoo.transformAggAssetToLegacyField),
        [(0, $lO4Or.JSM_MAJOR_INCIDENT_FIELD)]: (0, $gM34d.transformAggJSMMajorIncidentToLegacyField),
        [(0, $lO4Or.JSM_ORGANIZATION_GQL_FIELD)]: (0, $16kx8.transformAggJSMOrganizationToLegacyField),
        [(0, $lO4Or.JSM_ENTITLEMENTS_GQL_FIELD)]: (0, $9myMG.transformAggJSMEntitlementsToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $lO4Or.JSM_PEOPLE_GQL_FIELD)]: (0, $QjWSM.transformAggMultipleUserPickerToLegacyField),
        [(0, $lO4Or.JSM_REQUEST_FEEDBACK_GQL_FIELD)]: (0, $4IQ8F.transformAggJSMRequestFeedbackToLegacyField),
        [(0, $lO4Or.JSM_REQUEST_LANGUAGE_GQL_FIELD)]: (0, $lcInz.transformAggJSMRequestLanguageToLegacyField),
        [(0, $lO4Or.JSM_REQUEST_TYPE_GQL_FIELD)]: (0, $4PFnn.transformAggJSMRequestTypeToLegacyField),
        [(0, $lO4Or.JSM_RESPONDERS_GQL_FIELD)]: (0, $alpM1.transformAggJSMRespondersToLegacyField),
        [(0, $lO4Or.LABEL_GQL_FIELD)]: (0, $gHd8e.transformAggLabelsNodeToLegacyField),
        [(0, $lO4Or.PRIORITY_GQL_FIELD)]: (0, $fkHM1.transformAggPriorityToLegacyField),
        [(0, $lO4Or.MULTI_GROUP_PICKER_GQL_FIELD)]: (0, $dUrU1.transformAggMultiGroupPickerToLegacyField),
        [(0, $lO4Or.MULTI_USER_PICKER_GQL_FIELD)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $QjWSM.transformAggMultipleUserPickerToLegacyField),
        [(0, $lO4Or.NUMBER_GQL_FIELD)]: (0, $lWE99.transformAggNumberToLegacyField),
        [(0, $lO4Or.ORIGINAL_ESTIMATE_GQL_FIELD)]: (0, $4eNqf.transformAggOriginalEstimateToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $lO4Or.PEOPLE_GQL_FIELD)]: (0, $QjWSM.transformAggMultipleUserPickerToLegacyField),
        [(0, $lO4Or.PROFORMA_FORMS_GQL_FIELD)]: (0, $fkaQR.transformAggProformaFormsToLegacyField),
        [(0, $lO4Or.PROJECT_GQL_FIELD)]: (0, $ijtj3.transformAggProjectToLegacyField),
        [(0, $lO4Or.MULTI_VERSION_GQL_FIELD)]: (0, $4CGp4.transformAggMultipleVersionPickerToLegacyField),
        [(0, $lO4Or.RADIO_GQL_FIELD)]: (0, $gyvos.transformAggRadioSelectToLegacyField),
        [(0, $lO4Or.RICH_TEXT_GQL_FIELD)]: (0, $lQr58.transformAggRichTextToLegacyField),
        [(0, $lO4Or.RESOLUTION_GQL_FIELD)]: (0, $3w75b.transformAggResolutionToLegacyField),
        [(0, $lO4Or.SECURITY_GQL_FIELD)]: (0, $8oO4q.transformAggSecurityLevelToLegacyField),
        [(0, $lO4Or.SPRINT_GQL_FIELD)]: (0, $c6LKM.transformAggSprintToLegacyField),
        [(0, $lO4Or.STATUS_GQL_FIELD)]: (0, $8zTcQ.transformAggStatusToLegacyField),
        [(0, $lO4Or.SINGLE_GROUP_PICKER_GQL_FIELD)]: (0, $5Ne6t.transformAggSingleGroupPickerToLegacyField),
        [(0, $lO4Or.SINGLE_SELECT_GQL_FIELD)]: (0, $fz8Wc.transformAggSingleSelectToLegacyField),
        [(0, $lO4Or.TEAM_GQL_FIELD)]: (0, $5W75j.transformAggTeamToLegacyField),
        [(0, $lO4Or.TEAM_VIEW_GQL_FIELD)]: (0, $7iFVU.transformAggTeamViewToLegacyField),
        [(0, $lO4Or.TEXT_GQL_FIELD)]: (0, $2ETkN.transformAggSingleLineTextToLegacyField),
        [(0, $lO4Or.TIME_TRACKING_GQL_FIELD)]: (0, $kyZt3.transformAggTimeTrackingToLegacyField),
        [(0, $lO4Or.USER_PICKER_GQL_FIELD)]: (0, $jBiXV.transformAggSingleSelectUserPickerToLegacyField),
        [(0, $lO4Or.URL_GQL_FIELD)]: (0, $dX2ot.transformAggUrlToLegacyField),
        [(0, $lO4Or.VERSION_GQL_FIELD)]: (0, $1XUHd.transformAggSingleVersionPickerToLegacyField),
        [(0, $lO4Or.VOTES_GQL_FIELD)]: (0, $jhiYN.transformAggVotesToLegacyField),
        [(0, $lO4Or.WATCHES_GQL_FIELD)]: (0, $1BsAz.transformAggWatchesToLegacyField),
        [(0, $lO4Or.DATA_CLASSIFICATION_FIELD)]: (0, $xnQ91.transformAggDataClassificationToLegacyField),
        [(0, $lO4Or.GOALS_GQL_FIELD)]: (0, $c52Z6.transformAggGoalsToLegacyField)
    });
const $85127a55c87acb28$var$getTransformers = (0, $5iWql.default)($85127a55c87acb28$var$getTransformersNonMemoised);
const $85127a55c87acb28$export$586ba15cbf3d3031 = (node, context)=>{
    const typename = node.__typename;
    const transformer = $85127a55c87acb28$var$getTransformers()[typename];
    return transformer ? transformer(node, context) : undefined;
};
const $85127a55c87acb28$export$ba106ff8c087e6b1 = (fields)=>{
    if (fields == null) return {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields.reduce((fieldsState, fieldEdge)=>{
        if (fieldEdge?.node != null) {
            const transformedField = $85127a55c87acb28$export$586ba15cbf3d3031(fieldEdge.node, fields);
            if (transformedField != null) {
                const fieldData = 'key' in transformedField ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    [transformedField.key]: transformedField
                } : transformedField;
                Object.assign(fieldsState, fieldData);
            }
        }
        return fieldsState;
    }, {});
};

});
parcelRegister("kBgu2", function(module, exports) {

$parcel$export(module.exports, "transformAggAffectedServicesToLegacyField", () => $347ea3dcad361eb5$export$231e0419515441d4);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $347ea3dcad361eb5$var$transformJiraServicesToLegacyServices = ({ serviceId: serviceId, name: name })=>({
        id: serviceId,
        name: name ?? undefined
    });
const $347ea3dcad361eb5$export$231e0419515441d4 = (node)=>{
    if (node.type !== (0, $lO4Or.SERVICE_ENTITY_CF_TYPE)) return undefined;
    const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
    const value = hasValue ? (0, $f4e7j.transformAggConnection)(node.selectedAffectedServicesConnection, $347ea3dcad361eb5$var$transformJiraServicesToLegacyServices) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: value,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.SERVICE_ENTITY_CF_TYPE),
            items: 'service-entity-field',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("blEoo", function(module, exports) {

$parcel$export(module.exports, "transformAggAssetToLegacyField", () => $894bbc4a3f1bdf98$export$2136dcd78a2ef18f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $894bbc4a3f1bdf98$export$2136dcd78a2ef18f = (node)=>{
    switch(node.type){
        case 0, $lO4Or.ASSETS_CF_TYPE:
            {
                const hasValue = Boolean(node.selectedAssetsConnection?.edges?.length);
                const assetValue = hasValue ? (0, $f4e7j.transformAggConnection)(node.selectedAssetsConnection, ({ appKey: appKey, originId: originId, serializedOrigin: serializedOrigin, value: value })=>({
                        appKey: appKey,
                        originId: originId,
                        serializedOrigin: serializedOrigin,
                        value: value
                    })) : null;
                return {
                    ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                    autoCompleteUrl: node.searchUrl,
                    value: assetValue,
                    schema: {
                        custom: node.type,
                        system: null,
                        items: 'sd-asset',
                        type: 'array',
                        renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("6Ux91", function(module, exports) {

$parcel$export(module.exports, "transformAggBooleanToLegacyField", () => $0e4e588f42a69494$export$4bd89b95f0d10de9);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $0e4e588f42a69494$export$4bd89b95f0d10de9 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: {
                    alertLinking: {
                        enabled: node.value
                    }
                },
                schema: {
                    configuration: null,
                    items: null,
                    renderer: null,
                    custom: null,
                    system: (0, $lO4Or.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
                    type: (0, $lO4Or.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("5sNJN", function(module, exports) {

$parcel$export(module.exports, "transformAggCascadingSelectToLegacyField", () => $8a9ad29dba216e4b$export$a8778af5ceb1017c);

var $1ybV0 = parcelRequire("1ybV0");


var $f4e7j = parcelRequire("f4e7j");
const $8a9ad29dba216e4b$export$a8778af5ceb1017c = (node)=>{
    let value = null;
    if (node.cascadingOption) {
        const { childOptionValue: childOptionValue, parentOptionValue: parentOptionValue } = node.cascadingOption;
        const child = childOptionValue ? {
            child: {
                id: childOptionValue.optionId,
                value: childOptionValue.value
            }
        } : {};
        value = {
            // assigned in the statement above
            id: parentOptionValue?.optionId,
            value: parentOptionValue?.value,
            ...child
        };
    }
    const allowedValues = (0, $1ybV0.ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration') ? [] : (0, $f4e7j.transformAggConnection)(node.cascadingOptions, (cascadingOption)=>{
        if (!cascadingOption.parentOptionValue) return null;
        const { parentOptionValue: parentOptionValue, childOptionValues: childOptionValues } = cascadingOption;
        const childrenObj = childOptionValues?.length ? {
            children: childOptionValues.filter(Boolean).map((option)=>({
                    id: option.optionId,
                    value: option.value ?? null,
                    ari: option.id
                }))
        } : {};
        return {
            value: parentOptionValue.value,
            id: parentOptionValue.optionId,
            ...childrenObj
        };
    });
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: 'option-with-child',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2wvLE", function(module, exports) {

$parcel$export(module.exports, "transformAggCheckboxToLegacyField", () => $de1faea4cf000ccb$export$baa5afdbd8fd12d3);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $de1faea4cf000ccb$export$baa5afdbd8fd12d3 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
            {
                // We're inlining the transformers per field here so it'll be easy to remove them once we make the allowedValues async
                const value = (0, $f4e7j.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                const allowedValues = (0, $f4e7j.transformAggConnection)(node.checkboxesFieldOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: allowedValues,
                    schema: {
                        type: 'array',
                        renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("8d1m1", function(module, exports) {

$parcel$export(module.exports, "transformAggCMDBToLegacyField", () => $65b0c941ec21e177$export$93506453d9bb56ae);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $65b0c941ec21e177$var$transformObjectTypeToLegacy = (attribute, workspaceId)=>({
        workspaceId: workspaceId,
        id: `${workspaceId}:${attribute.objectTypeId}`,
        name: attribute.name,
        objectSchemaId: attribute.objectSchemaId,
        objectTypeId: attribute.objectTypeId,
        // `icon` is unused
        icon: {
            id: attribute.icon.id,
            name: attribute.icon.name,
            url16: attribute.icon.url16,
            url48: attribute.icon.url48
        }
    });
const $65b0c941ec21e177$var$transformCMDBConfigurationToLegacyConfiguration = (node)=>{
    if (!node.cmdbFieldConfig) return node.isInsightAvailable === false ? {
        isInsightAvailable: node.isInsightAvailable
    } : {};
    return {
        cmdbFieldConfig: {
            multiple: node.cmdbFieldConfig.multiple,
            objectSchemaId: node.cmdbFieldConfig.objectSchemaId.split('/')[2],
            attributesDisplayedOnIssue: (0, $f4e7j.transformAggConnection)(node.cmdbFieldConfig?.attributesDisplayedOnIssue),
            attributesIncludedInAutoCompleteSearch: (0, $f4e7j.transformAggConnection)(node.cmdbFieldConfig?.attributesIncludedInAutoCompleteSearch)
        },
        isInsightAvailable: node.isInsightAvailable,
        wasInsightRequestSuccessful: node.wasInsightRequestSuccessful
    };
};
const $65b0c941ec21e177$var$transformObjectTypeAttributeToLegacy = (type)=>{
    switch(type){
        case 'REFERENCED_OBJECT':
            return 1;
        case 'USER':
            return 2;
        case 'GROUP':
            return 4;
        case 'PROJECT':
            return 6;
        case 'STATUS':
            return 7;
        case 'BITBUCKET_REPO':
            return 8;
        case 'OPSGENIE_TEAM':
            return 9;
        case 'DEFAULT':
            return 0;
        default:
            // eslint-disable-next-line no-console
            console.error(new Error(`Unknown attribute type found in transformObjectTypeAttributeToLegacy: ${type}. Mapping type to '-1'`));
            return -1;
    }
};
const $65b0c941ec21e177$var$transformReferencedObject = (node)=>({
        id: node.objectGlobalId,
        workspaceId: node.workspaceId,
        objectKey: node.objectKey,
        label: node.label,
        avatar: node.avatar,
        objectId: node.objectId
    });
const $65b0c941ec21e177$var$transformCmdbUser = (node)=>({
        avatarUrl: node.picture,
        displayName: node.name,
        name: node.name,
        key: node.accountId
    });
const $65b0c941ec21e177$var$transformCmdbGroup = (node)=>({
        name: node.name
    });
const $65b0c941ec21e177$var$transformCmdbProject = (node)=>({
        avatarUrl: node.avatar?.large,
        id: Number(node.id),
        key: node.key,
        name: node.name
    });
const $65b0c941ec21e177$var$transformCmdbBitbucketRepo = (node)=>({
        uuid: node.uuid,
        name: node.name,
        url: node.url,
        avatarUrl: node.avatarUrl
    });
const $65b0c941ec21e177$var$transformCmdbOpsgenieTeam = (node)=>({
        id: node.id,
        name: node.name,
        url: node.url
    });
const $65b0c941ec21e177$var$transformCmdbStatus = (node)=>({
        id: node.id,
        name: node.name,
        category: node.category
    });
const $65b0c941ec21e177$var$transformObjectAttributeValuesToLegacy = (node)=>{
    if (!node) return null;
    const defaultObjectValue = {
        displayValue: node.displayValue,
        searchValue: node.searchValue,
        ...node.value != null ? {
            value: node.value
        } : {}
    };
    if (node.referencedObject) return {
        ...defaultObjectValue,
        referencedObject: $65b0c941ec21e177$var$transformReferencedObject(node.referencedObject)
    };
    if (node.user) return {
        ...defaultObjectValue,
        user: $65b0c941ec21e177$var$transformCmdbUser(node.user)
    };
    if (node.group) return {
        ...defaultObjectValue,
        group: $65b0c941ec21e177$var$transformCmdbGroup(node.group)
    };
    if (node.project) return {
        ...defaultObjectValue,
        project: $65b0c941ec21e177$var$transformCmdbProject(node.project)
    };
    if (node.bitbucketRepo) return {
        ...defaultObjectValue,
        bitbucketRepo: $65b0c941ec21e177$var$transformCmdbBitbucketRepo(node.bitbucketRepo)
    };
    if (node.opsgenieTeam) return {
        ...defaultObjectValue,
        opsgenieTeam: $65b0c941ec21e177$var$transformCmdbOpsgenieTeam(node.opsgenieTeam)
    };
    if (node.status) return {
        ...defaultObjectValue,
        status: $65b0c941ec21e177$var$transformCmdbStatus(node.status)
    };
    return defaultObjectValue;
};
const $65b0c941ec21e177$var$transformObjectAttributesToLegacyObjectAttributes = (node, workspaceId)=>{
    if (!node) return null;
    const { attributeId: attributeId, objectTypeAttributeId: objectTypeAttributeId, objectTypeAttribute: objectTypeAttribute } = node;
    return {
        objectTypeAttributeId: objectTypeAttributeId,
        id: attributeId,
        workspaceId: workspaceId,
        objectAttributeValues: (0, $f4e7j.transformAggConnection)(node.objectAttributeValues, $65b0c941ec21e177$var$transformObjectAttributeValuesToLegacy),
        objectTypeAttribute: {
            id: objectTypeAttributeId,
            label: objectTypeAttribute.label,
            name: objectTypeAttribute.name,
            workspaceId: workspaceId,
            type: $65b0c941ec21e177$var$transformObjectTypeAttributeToLegacy(objectTypeAttribute.type),
            ...objectTypeAttribute.defaultType ? {
                defaultType: {
                    id: objectTypeAttribute.defaultType.id,
                    name: objectTypeAttribute.defaultType.name
                }
            } : {}
        }
    };
};
const $65b0c941ec21e177$var$transformJiraCMDBToLegacyCMDB = (node)=>{
    if (!node) return null;
    const { label: label, objectGlobalId: objectGlobalId, objectId: objectId, objectKey: objectKey, workspaceId: workspaceId, webUrl: webUrl, avatar: avatar } = node;
    return {
        attributes: (0, $f4e7j.transformAggConnection)(node.attributes, (nodeAttribute)=>$65b0c941ec21e177$var$transformObjectAttributesToLegacyObjectAttributes(nodeAttribute, workspaceId)),
        avatar: avatar,
        label: label,
        id: objectGlobalId,
        objectId: objectId,
        objectKey: objectKey,
        workspaceId: workspaceId,
        links: {
            self: webUrl
        },
        objectType: $65b0c941ec21e177$var$transformObjectTypeToLegacy(node.objectType, workspaceId)
    };
};
const $65b0c941ec21e177$export$93506453d9bb56ae = (node)=>{
    if (node.type !== (0, $lO4Or.CMDB_OBJECT_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?` : null,
        configuration: $65b0c941ec21e177$var$transformCMDBConfigurationToLegacyConfiguration(node),
        value: (0, $f4e7j.transformAggConnection)(node.selectedCmdbObjectsConnection, $65b0c941ec21e177$var$transformJiraCMDBToLegacyCMDB),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.CMDB_OBJECT_CF_TYPE),
            items: 'cmdb-object-field',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("5CYGa", function(module, exports) {

$parcel$export(module.exports, "transformAggColorToLegacyField", () => $9050c04462f98fea$export$587c178f1b45e5e9);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $9050c04462f98fea$export$587c178f1b45e5e9 = (node)=>{
    const value = node.color?.colorKey ?? null;
    switch(node.type){
        case 0, $lO4Or.EPIC_COLOR_TYPE:
        case 0, $lO4Or.COLOR_CF_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: value,
                schema: {
                    configuration: null,
                    type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    custom: node.type,
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("9wKha", function(module, exports) {

$parcel$export(module.exports, "transformAggComponentsToLegacyField", () => $786c86fdf4d26692$export$97a9275777684b77);

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
// @DoNotExport Flow is deriving component's type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $786c86fdf4d26692$var$transformJiraComponentToLegacyComponent = (component)=>{
    if (component == null) return null;
    return {
        id: component.componentId,
        name: component.name,
        ...(0, $1ybV0.ff)('compass-components-in-jira-components_xw42u', false) ? {
            ari: component.ari,
            metadata: component.metadata
        } : {}
    };
};
const $786c86fdf4d26692$export$97a9275777684b77 = (node)=>{
    if (node.type !== (0, $lO4Or.COMPONENTS_TYPE)) return undefined;
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.components, $786c86fdf4d26692$var$transformJiraComponentToLegacyComponent);
    const value = (0, $f4e7j.transformAggConnection)(node.selectedComponentsConnection, $786c86fdf4d26692$var$transformJiraComponentToLegacyComponent);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: 'component',
            renderer: (0, $c7e7b1d3600a0c0f$export$840ed33fa94f7693),
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            custom: null,
            system: (0, $lO4Or.COMPONENTS_TYPE)
        }
    };
};

});

parcelRegister("6PKzm", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectDateTimeToLegacyField", () => $37a64e51f4c4445c$export$e6d015aa746cbdaf);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $37a64e51f4c4445c$export$e6d015aa746cbdaf = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.dateTime ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    });

});

parcelRegister("jyP56", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectMultipleSelectToLegacyField", () => $060cb99a84a6f8a5$export$edf5c98d20696686);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $060cb99a84a6f8a5$export$edf5c98d20696686 = (node)=>{
    const value = (0, $f4e7j.transformAggConnection)(node.selectedOptions, (0, $f4e7j.toLegacyConnectOption));
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.connectMultiSelectFieldOptions, (0, $f4e7j.toLegacyConnectOption));
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value.length ? value : null,
        allowedValues: allowedValues,
        schema: {
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: (0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
            configuration: null
        }
    };
};

});

parcelRegister("epJqO", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectNumberToLegacyField", () => $c342681984a0fce1$export$4638a5dd3285d8f2);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $c342681984a0fce1$export$4638a5dd3285d8f2 = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.number ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    });

});

parcelRegister("Pxexr", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectRichTextToLegacyField", () => $6d21cc1975a64a13$export$11063e1f9210f191);

var $eZmml = parcelRequire("eZmml");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $6d21cc1975a64a13$var$emptyAdfObject = (0, $eZmml.getEmptyADF)();
const $6d21cc1975a64a13$var$getPlainTextValue = (node)=>{
    if (!node.richText) return null;
    if (node.richText.plainText == null) return '';
    return node.richText.plainText;
};
const $6d21cc1975a64a13$export$11063e1f9210f191 = (node)=>{
    const { renderer: renderer } = node;
    if ((0, $2qVcp.default)(node)) return undefined;
    const isPlainTextRenderer = renderer === (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f);
    const values = isPlainTextRenderer ? {
        value: $6d21cc1975a64a13$var$getPlainTextValue(node)
    } : {
        adfValue: node.richText?.adfValue?.json || $6d21cc1975a64a13$var$emptyAdfObject
    };
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        ...values,
        schema: {
            custom: (0, $lO4Or.TEXT_AREA_CF_TYPE),
            renderer: renderer,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            configuration: null,
            items: null
        }
    };
};

});
parcelRegister("2qVcp", function(module, exports) {

$parcel$export(module.exports, "default", () => $08fb6c9e1b8a0092$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");
const $08fb6c9e1b8a0092$export$c63f561360bafed1 = 'issue.agg-field-transformers.missing-renderer';
// If the renderer is missing, log an error and return true.
// This was added as part of https://jplat.atlassian.net/browse/JIV-14881 to help identify why
// fields are sometimes missing the renderer.
const $08fb6c9e1b8a0092$var$isFieldMissingRenderer = (field)=>{
    try {
        // Narrow the type of field to fields with a renderer
        if (!('renderer' in field)) return false;
        if (field?.renderer) return false;
        (0, $gUUjF.default).safeErrorWithoutCustomerData($08fb6c9e1b8a0092$export$c63f561360bafed1, `Field ${field.fieldId} of type ${field.__typename} has missing renderer: ${field.renderer}`);
        return true;
    } catch  {
        return false;
    }
};
var $08fb6c9e1b8a0092$export$2e2bcd8739ae039 = $08fb6c9e1b8a0092$var$isFieldMissingRenderer;

});


parcelRegister("beuR4", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectSingleSelectToLegacyField", () => $b2ab3564d5e0e945$export$e44db7cf61369a28);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $b2ab3564d5e0e945$export$e44db7cf61369a28 = (node)=>{
    let value = null;
    if (node.fieldOption != null) value = {
        id: parseInt(node.fieldOption?.optionId, 10),
        value: node.fieldOption?.value
    };
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: (0, $f4e7j.transformAggConnection)(node.connectSingleSelectFieldOptions, (0, $f4e7j.toLegacyConnectOption)),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("d9IUw", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectTextToLegacyField", () => $a23506d3b78ec681$export$dd05277f5aa90657);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $a23506d3b78ec681$export$dd05277f5aa90657 = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("xnQ91", function(module, exports) {

$parcel$export(module.exports, "transformAggDataClassificationToLegacyField", () => $104546bf95896cb2$export$b5edfdc89a7a2932);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $104546bf95896cb2$export$b5edfdc89a7a2932 = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        key: (0, $lO4Or.DATA_CLASSIFICATION_TYPE),
        value: node,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            custom: null,
            system: null,
            type: (0, $lO4Or.DATA_CLASSIFICATION_TYPE)
        }
    });

});

parcelRegister("jsTfy", function(module, exports) {

$parcel$export(module.exports, "transformAggDatePickerToLegacyField", () => $cbf69a6b68f1ac34$export$3d6e51d37c0454a9);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $cbf69a6b68f1ac34$export$3d6e51d37c0454a9 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.DUE_DATE_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $lO4Or.ISSUE_FIELD_DATE_CF_TYPE),
                    configuration: null,
                    system: node.type,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    custom: null,
                    items: null
                }
            };
        case 0, $lO4Or.DATE_CF_TYPE:
        case 0, $lO4Or.BASELINE_START_CF_TYPE:
        case 0, $lO4Or.BASELINE_END_CF_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $lO4Or.ISSUE_FIELD_DATE_CF_TYPE),
                    custom: node.type,
                    configuration: null,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("55kng", function(module, exports) {

$parcel$export(module.exports, "transformAggDateTimePickerToLegacyField", () => $d108194053a9b0cf$export$3de22f1277f0c239);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $d108194053a9b0cf$var$defaultSchema = {
    type: (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE),
    custom: null,
    system: null,
    configuration: null,
    items: null,
    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)
};
const $d108194053a9b0cf$export$3de22f1277f0c239 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.CREATED:
        case 0, $lO4Or.UPDATED:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: node.dateTime || '',
                schema: {
                    ...$d108194053a9b0cf$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $lO4Or.RESOLUTION_DATE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$d108194053a9b0cf$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $lO4Or.DATETIME_CF_TYPE:
        case 0, $lO4Or.FIRST_RESPONSE_DATE_CF_TYPE:
        case 0, $lO4Or.REQUEST_FEEDBACK_DATE_CF_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$d108194053a9b0cf$var$defaultSchema,
                    custom: node.type
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("7BRej", function(module, exports) {

$parcel$export(module.exports, "transformAggEpicLinkToLegacyField", () => $3731013de9f5c7b2$export$1311f30c94840aa2);

var $opsFH = parcelRequire("opsFH");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $3731013de9f5c7b2$var$transformJiraEpicToLegacyEpicLink = (epic)=>{
    if (epic == null) return null;
    return {
        id: Number(epic.issueId),
        key: epic.key || '',
        done: !!epic.done,
        name: epic.name || '',
        summary: epic.summary || '',
        color: {
            key: epic.color ?? (0, $opsFH.AgileColors).AGILE_COLOR_1
        },
        // This can only be set from cache handlers
        fromCache: false
    };
};
const $3731013de9f5c7b2$export$1311f30c94840aa2 = (node)=>{
    if (node.type !== (0, $lO4Or.EPIC_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: $3731013de9f5c7b2$var$transformJiraEpicToLegacyEpicLink(node.epic),
        schema: {
            configuration: null,
            items: null,
            renderer: 'jira-text-renderer',
            type: 'any',
            custom: (0, $lO4Or.EPIC_TYPE),
            system: null
        }
    };
};

});

parcelRegister("04Gbh", function(module, exports) {

$parcel$export(module.exports, "transformAggFlagToLegacyField", () => $c8b2d8c7cabddb24$export$31555b6ea19f4c2);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $c8b2d8c7cabddb24$var$transformJiraFlagToLegacyFlag = (flag)=>{
    if (flag == null || flag.isFlagged == null) return null;
    return [
        {
            value: flag.isFlagged
        }
    ];
};
const $c8b2d8c7cabddb24$export$31555b6ea19f4c2 = (node)=>{
    // Agg flag field comes back as multichecbox CF type instead of current graphql flagged CF type
    if (node.type !== (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $c8b2d8c7cabddb24$var$transformJiraFlagToLegacyFlag(node.flag),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.FLAGGED_CF_TYPE),
            items: 'option',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("3ZJZc", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateToLegacyField", () => $c763da6a17e08623$export$30fccfce22948120);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $c763da6a17e08623$export$30fccfce22948120 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.date,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_DATE_CF_TYPE)
        }
    };
};

});

parcelRegister("bw8ws", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateTimeToLegacyField", () => $4c0a1710d24fba77$export$61b1f0cbd04c7b9c);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $4c0a1710d24fba77$export$61b1f0cbd04c7b9c = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.dateTime,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    };
};

});

parcelRegister("9vCKL", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupToLegacyField", () => $c9b907ff4adf2ba8$export$60b03d63015cbb9f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $c9b907ff4adf2ba8$export$60b03d63015cbb9f = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.selectedGroup ? {
            name: node.selectedGroup.name
        } : null,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE)
        }
    };
};

});

parcelRegister("i5dch", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupsToLegacyField", () => $a11ed3e141cd8632$export$2dfa4944fba5d1f5);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $a11ed3e141cd8632$export$2dfa4944fba5d1f5 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    const value = node.selectedGroupsConnection?.edges?.length ? (0, $f4e7j.transformAggConnection)(node.selectedGroupsConnection, ({ name: name })=>({
            name: name
        })) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $lO4Or.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("iJcxE", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeNumberToLegacyField", () => $0d8b7166bd07a2e4$export$5dab8986dc45db07);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $0d8b7166bd07a2e4$export$5dab8986dc45db07 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.number,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    };
};

});

parcelRegister("djkJh", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeObjectToLegacyField", () => $d8b2a1a28c816219$export$fbdabdbae2a203b9);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $d8b2a1a28c816219$export$fbdabdbae2a203b9 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    const value = (()=>{
        if (node.object == null) return null;
        try {
            return JSON.parse(node.object);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            throw new Error('Failed to transform forge object field: node.object was invalid JSON object');
        }
    })();
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_OBJECT_CF_TYPE)
        }
    };
};

});

parcelRegister("kbDa2", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringToLegacyField", () => $c3ecb4f8814d5007$export$3a581fb4b3e578bd);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $c3ecb4f8814d5007$export$3a581fb4b3e578bd = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("4gy8O", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringsToLegacyField", () => $e5fb5863b3ffc3de$export$418a06cb5dc6aba5);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $e5fb5863b3ffc3de$export$418a06cb5dc6aba5 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    const hasValue = Boolean(node.selectedLabelsConnection?.edges?.length);
    const value = hasValue ? (0, $f4e7j.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("9w928", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUserToLegacyField", () => $bdc773687305de8f$export$bc73c7a747f907e5);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");

var $g5TY0 = parcelRequire("g5TY0");
const $bdc773687305de8f$export$bc73c7a747f907e5 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $g5TY0.transformJiraUserToLegacyServerUser)(node.user) : null,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE)
        }
    };
};

});
parcelRegister("g5TY0", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToLegacyServerUser", () => $c92150b2c9939d9c$export$d7b231260a016eaf);

const $c92150b2c9939d9c$var$getAccountType = (objectType)=>{
    switch(objectType){
        case 'AtlassianAccountUser':
            return 0, $0f8390fc7463ac8c$export$981400c14dd99bc0;
        case 'CustomerUser':
            return 0, $0f8390fc7463ac8c$export$2823897fb92cd040;
        case 'AppUser':
            return 0, $0f8390fc7463ac8c$export$1973ca62b6c5abfe;
        default:
            return 0, $0f8390fc7463ac8c$export$d1f5101c0939e3fe;
    }
};
const $c92150b2c9939d9c$var$generateAvatarUrls = (url)=>({
        '16x16': url,
        '24x24': url,
        '32x32': url,
        '48x48': url
    });
const $c92150b2c9939d9c$export$d7b231260a016eaf = (user)=>{
    if (!user) return null;
    const userOptionalKeysMap = {
        emailAddress: 'email',
        locale: 'locale',
        timeZone: 'zoneinfo'
    };
    const optionalValues = {};
    Object.entries(userOptionalKeysMap).forEach(([key, aggKey])=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const aggValue = user[aggKey];
        if (aggValue !== undefined && aggValue !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        optionalValues[key] = aggValue;
    });
    const avatars = user.picture != null ? {
        avatarUrl: user.picture,
        avatarUrls: $c92150b2c9939d9c$var$generateAvatarUrls(user.picture)
    } : {};
    return {
        ...avatars,
        ...optionalValues,
        accountId: user.accountId,
        accountType: $c92150b2c9939d9c$var$getAccountType(user.__typename),
        active: user.accountStatus === 'active',
        displayName: user.name
    };
};

});
const $0f8390fc7463ac8c$export$981400c14dd99bc0 = 'atlassian';
const $0f8390fc7463ac8c$export$2823897fb92cd040 = 'customer';
const $0f8390fc7463ac8c$export$1973ca62b6c5abfe = 'app';
const $0f8390fc7463ac8c$export$d1f5101c0939e3fe = 'unknown';



parcelRegister("3khS7", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUsersToLegacyField", () => $04695e9464f736dc$export$bbfea2e2f2c853b8);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");

var $g5TY0 = parcelRequire("g5TY0");
const $04695e9464f736dc$export$bbfea2e2f2c853b8 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    const value = node.selectedUsersConnection?.edges?.length ? (0, $f4e7j.transformAggConnection)(node.selectedUsersConnection, (0, $g5TY0.transformJiraUserToLegacyServerUser)) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("c52Z6", function(module, exports) {

$parcel$export(module.exports, "transformAggGoalsToLegacyField", () => $967e7c1cc9b41f1e$export$158301a02ae4cbe7);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $967e7c1cc9b41f1e$export$158301a02ae4cbe7 = (node)=>{
    if (node.type !== (0, $lO4Or.GOALS_CF_TYPE)) return undefined;
    const value = node.selectedGoals ? {
        goals: node.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                id: edge?.node?.id || '',
                name: edge?.node?.name || '',
                status: edge?.node?.status || null
            })) || [],
        goalCount: node.selectedGoals?.totalCount || 0
    } : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.GOALS_CF_TYPE),
            items: null,
            renderer: null,
            system: null,
            type: (0, $lO4Or.GOALS_CF_TYPE)
        }
    };
};

});

parcelRegister("6IjGS", function(module, exports) {

$parcel$export(module.exports, "transformAggIssueRestrictionToLegacyField", () => $656ee40cfd5a4289$export$62db794d5816e28e);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $ijtj3 = parcelRequire("ijtj3");
const $656ee40cfd5a4289$var$transformJiraRoleToRestriction = (role)=>{
    if (role == null) return null;
    return {
        restrictionValue: role.roleId
    };
};
const $656ee40cfd5a4289$export$62db794d5816e28e = (node, context)=>{
    if (node.type !== (0, $lO4Or.ISSUE_RESTRICTION_TYPE)) return undefined;
    const roles = (0, $f4e7j.transformAggConnection)(node.selectedRolesConnection, $656ee40cfd5a4289$var$transformJiraRoleToRestriction);
    const restrictions = roles.length > 0 ? {
        projectrole: roles
    } : {};
    const project = (0, $ijtj3.getSystemAggJiraProject)(context);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: {
            shouldDisplay: project.canSetIssueRestriction === true,
            issuerestrictions: restrictions
        },
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            type: (0, $lO4Or.ISSUE_RESTRICTION_TYPE),
            custom: null,
            system: node.type
        }
    };
};

});
parcelRegister("ijtj3", function(module, exports) {

$parcel$export(module.exports, "getProjectType", () => $b7b19c470c7e1e1a$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getSystemAggJiraProject", () => $b7b19c470c7e1e1a$export$d100105d56da4a0a);
$parcel$export(module.exports, "transformAggProjectToProjectContext", () => $b7b19c470c7e1e1a$export$275f121d4e6f5165);
$parcel$export(module.exports, "transformAggProjectToLegacyField", () => $b7b19c470c7e1e1a$export$30c14b802399f417);

var $7ZZxN = parcelRequire("7ZZxN");


var $6vrw7 = parcelRequire("6vrw7");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $b7b19c470c7e1e1a$var$getProjectStatus = (status)=>{
    switch(status){
        case 'ACTIVE':
            return 0, $5bd9e96e4d7e8aee$export$62113557945f790a;
        case 'ARCHIVED':
            return 0, $5bd9e96e4d7e8aee$export$4ccc35479ba9ad1;
        case 'DELETED':
            return 0, $5bd9e96e4d7e8aee$export$a95d71e582b8bc0;
        default:
            // Based on `getProjectStatus` from src/packages/issue/issue-view/src/common/service/issue/issue-transformer.js
            return 0, $5bd9e96e4d7e8aee$export$62113557945f790a;
    }
};
const $b7b19c470c7e1e1a$export$3dd0da95519c1a33 = (projectType)=>{
    switch(projectType){
        case 'SERVICE_DESK':
            return 0, $7ZZxN.SERVICE_DESK_PROJECT;
        case 'BUSINESS':
            return 0, $7ZZxN.CORE_PROJECT;
        case 'SOFTWARE':
            return 0, $7ZZxN.SOFTWARE_PROJECT;
        case 'PRODUCT_DISCOVERY':
            return 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $b7b19c470c7e1e1a$export$d100105d56da4a0a = (fields)=>{
    /**
	 * We only want the system `PROJECT_TYPE` field.
	 * For custom fields, e.g., project picker, see `transformAggProjectToLegacyField`
	 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const projectField = fields?.find((edge)=>edge?.node?.__typename === (0, $lO4Or.PROJECT_GQL_FIELD) && edge?.node?.type != null && edge.node.type === (0, $lO4Or.PROJECT_TYPE))?.node;
    // Needs the `PROJECT_GQL_FIELD` refinement so we can return as `AggJiraProject`
    if (projectField == null || projectField.__typename !== (0, $lO4Or.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $lO4Or.PROJECT_GQL_FIELD)} with ${(0, $lO4Or.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $lO4Or.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    return projectField.project;
};
const $b7b19c470c7e1e1a$export$f7d5cb97957d02e3 = (project)=>project.projectStyle === 'TEAM_MANAGED_PROJECT';
const $b7b19c470c7e1e1a$var$transformAggProjectToServerProjectOption = (project)=>{
    if (project == null) return null;
    const { projectId: projectId, key: key, name: name, avatar: avatar } = project;
    return {
        name: name,
        id: projectId ?? undefined,
        key: (0, $6vrw7.toProjectKey)(key),
        avatarUrls: {
            '48x48': avatar.large
        }
    };
};
const $b7b19c470c7e1e1a$export$275f121d4e6f5165 = (fields)=>{
    const project = $b7b19c470c7e1e1a$export$d100105d56da4a0a(fields);
    const { projectId: projectId, name: name, key: key, avatar: avatar, status: status, projectType: type } = project;
    const projectType = $b7b19c470c7e1e1a$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform system project: projectType ${String(type)} was invalid`);
    return {
        projectId: projectId,
        projectType: projectType,
        projectName: name,
        projectKey: key,
        projectStatus: $b7b19c470c7e1e1a$var$getProjectStatus(status),
        avatarUrl: avatar.medium,
        isSimplified: $b7b19c470c7e1e1a$export$f7d5cb97957d02e3(project)
    };
};
const $b7b19c470c7e1e1a$var$transformAggProjectToLegacyProjectPickerField = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: $b7b19c470c7e1e1a$var$transformAggProjectToServerProjectOption(node.project),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            type: (0, $lO4Or.PROJECT_TYPE),
            custom: (0, $lO4Or.PROJECT_PICKER_CF_TYPE),
            system: null
        }
    });
const $b7b19c470c7e1e1a$var$transformAggProjectToLegacySimilarIssuesField = (node)=>{
    // Similar issues field only exist in JSM projects
    if ($b7b19c470c7e1e1a$export$3dd0da95519c1a33(node.project?.projectType) !== (0, $7ZZxN.SERVICE_DESK_PROJECT)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        key: (0, $lO4Or.SIMILAR_ISSUES_TYPE),
        title: (0, $lO4Or.SIMILAR_ISSUES_TYPE),
        value: node.project?.similarIssues?.featureEnabled === true,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $lO4Or.SIMILAR_ISSUES_TYPE),
            custom: null,
            system: (0, $lO4Or.SIMILAR_ISSUES_TYPE)
        }
    };
};
const $b7b19c470c7e1e1a$export$30c14b802399f417 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.PROJECT_PICKER_CF_TYPE:
            return $b7b19c470c7e1e1a$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $lO4Or.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $b7b19c470c7e1e1a$var$transformAggProjectToLegacySimilarIssuesField(node);
        default:
            return undefined;
    }
};

});


parcelRegister("eOsdu", function(module, exports) {

$parcel$export(module.exports, "getSystemAggJiraIssueType", () => $fddff707046980f2$export$b4644a0cc2f2935e);
$parcel$export(module.exports, "transformJiraIssueTypeToLegacyIssueType", () => $fddff707046980f2$export$2356062173546155);
$parcel$export(module.exports, "transformAggIssueTypeToLegacyField", () => $fddff707046980f2$export$de2eb3b47c7c887b);

var $lO4Or = parcelRequire("lO4Or");
var $edkGa = parcelRequire("edkGa");

var $f4e7j = parcelRequire("f4e7j");
const $fddff707046980f2$export$d95e76b2d065f98d = {
    avatarId: 0,
    self: ''
};
const $fddff707046980f2$export$b4644a0cc2f2935e = (fields)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = fields?.find((edge)=>edge?.node != null && edge.node.__typename === (0, $lO4Or.ISSUE_TYPE_GQL_FIELD) && edge.node.type === (0, $lO4Or.ISSUE_TYPE))?.node;
    if (issueTypeField == null || issueTypeField.__typename !== (0, $lO4Or.ISSUE_TYPE_GQL_FIELD) || issueTypeField.type !== (0, $lO4Or.ISSUE_TYPE)) throw new Error(`Failed to get system issue type: ${(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)} with ${(0, $lO4Or.ISSUE_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (issueTypeField.issueType == null) throw new Error(`Failed to get system issue type: ${(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)}.issueType is missing [${JSON.stringify(issueTypeField)}]`);
    return issueTypeField.issueType;
};
const $fddff707046980f2$export$2356062173546155 = (issueType)=>({
        ...$fddff707046980f2$export$d95e76b2d065f98d,
        id: issueType.issueTypeId,
        iconUrl: issueType.avatar?.medium ?? '',
        name: issueType.name,
        description: 'description' in issueType && issueType.description != null ? issueType.description : '',
        hierarchyLevel: issueType.hierarchy.level,
        subtask: issueType.hierarchy.level === (0, $edkGa.ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL
    });
const $fddff707046980f2$export$de2eb3b47c7c887b = (node)=>{
    if (node.type !== (0, $lO4Or.ISSUE_TYPE) || node.issueType == null) throw new Error(`Failed to transform ${(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)}: type is not ${(0, $lO4Or.ISSUE_TYPE)} or 'issueType' is empty [${JSON.stringify(node)}]`);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $fddff707046980f2$export$2356062173546155(node.issueType),
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: (0, $lO4Or.ISSUE_TYPE),
            type: (0, $lO4Or.ISSUE_TYPE)
        }
    };
};

});
parcelRegister("edkGa", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE_HIERARCHY_LEVEL", () => $b500da57c36bb99b$export$2fe6880f0073407c);

var $3l6tm = parcelRequire("3l6tm");
const $b500da57c36bb99b$export$2fe6880f0073407c = {
    SUBTASK_LEVEL: (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_SUBTASK),
    BASE_LEVEL: (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_BASE),
    LEVEL_ONE: (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_EPIC),
    LEVEL_TWO: 2
};

});


parcelRegister("6MxWX", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMApprovalsToLegacyField", () => $3d843a7647f78c65$export$b14d30f2a9e4c343);

var $23qRX = parcelRequire("23qRX");

var $6vrw7 = parcelRequire("6vrw7");

var $23qRX = parcelRequire("23qRX");
var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $g5TY0 = parcelRequire("g5TY0");
const $3d843a7647f78c65$var$transformApproverPrincipalsToLegacy = (approverPrincipal)=>{
    if (!approverPrincipal) return undefined;
    switch(approverPrincipal.__typename){
        case 0, $lO4Or.JSM_USER_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $6vrw7.toAccountId)(approverPrincipal.user.accountId),
                name: approverPrincipal.user.name,
                meta: {
                    jiraRest: approverPrincipal.jiraRest
                },
                type: 'user',
                avatarUrl: approverPrincipal.user.picture
            };
        case 0, $lO4Or.JSM_GROUP_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $23qRX.toGroupId)(approverPrincipal.groupId),
                meta: {
                    memberCount: approverPrincipal.memberCount,
                    approvedCount: approverPrincipal.approvedCount
                },
                name: approverPrincipal.name,
                type: 'group'
            };
        default:
            return undefined;
    }
};
const $3d843a7647f78c65$var$getApproverDecision = (decision)=>{
    switch(decision){
        case 0, $23qRX.APPROVER_APPROVED:
            return 0, $23qRX.APPROVER_APPROVED;
        case 0, $23qRX.APPROVER_DECLINED:
            return 0, $23qRX.APPROVER_DECLINED;
        case 0, $23qRX.APPROVER_PENDING:
        default:
            return 0, $23qRX.APPROVER_PENDING;
    }
};
const $3d843a7647f78c65$var$transformApproverToLegacy = (approvalNode)=>{
    if (!approvalNode) return undefined;
    const approver = (0, $g5TY0.transformJiraUserToLegacyServerUser)(approvalNode.approver);
    if (!approver) return undefined;
    return {
        approverDecision: $3d843a7647f78c65$var$getApproverDecision(approvalNode.approverDecision),
        approver: approver
    };
};
const $3d843a7647f78c65$var$transformConfigurationToLegacy = (configurations)=>{
    // This function contains a lot of null checks and default empty values to satisfy flow because
    // the AGG type coming back is in the shape of [JiraServiceManagementApprovalConfiguration]
    // Which means technically it can be an empty array. Even though we will always only ever
    // get 1 object back.
    const { approversConfigurations: approversConfigurations = [], condition: condition } = configurations?.[0] || {};
    const approverConfiguration = approversConfigurations[0];
    return {
        approvers: {
            type: approverConfiguration?.type ?? '',
            customFieldName: approverConfiguration?.fieldName ?? '',
            customFieldId: approverConfiguration?.fieldId ?? ''
        },
        condition: {
            type: condition?.type ?? '',
            value: condition?.value ?? ''
        }
    };
};
const $3d843a7647f78c65$var$transformDateToLegacy = (date)=>({
        epochMillis: new Date(date).valueOf()
    });
const $3d843a7647f78c65$var$transformStatusToLegacy = (status)=>({
        name: status.name || '',
        category: Number(status.categoryId)
    });
const $3d843a7647f78c65$var$transformActiveApprovalToLegacy = (activeApproval)=>{
    const { id: id, configurations: configurations, status: status, createdDate: createdDate, canAnswerApproval: canAnswerApproval, pendingApprovalCount: pendingApprovalCount, name: name, finalDecision: finalDecision, approvalState: approvalState, approvedStatus: approvedStatus } = activeApproval;
    return {
        id: id,
        approvalState: approvalState,
        approvedStatus: approvedStatus,
        finalDecision: $3d843a7647f78c65$var$getApproverDecision(finalDecision),
        name: name,
        pendingApprovalCount: pendingApprovalCount,
        canAnswerApproval: canAnswerApproval,
        approverPrincipals: (0, $f4e7j.transformAggConnection)(activeApproval.approverPrincipals, $3d843a7647f78c65$var$transformApproverPrincipalsToLegacy),
        approvers: (0, $f4e7j.transformAggConnection)(activeApproval.approvers, $3d843a7647f78c65$var$transformApproverToLegacy),
        configuration: $3d843a7647f78c65$var$transformConfigurationToLegacy(configurations),
        createdDate: $3d843a7647f78c65$var$transformDateToLegacy(createdDate ?? ''),
        decisions: (0, $f4e7j.transformAggConnection)(activeApproval.decisions, $3d843a7647f78c65$var$transformApproverToLegacy),
        excludedApprovers: (0, $f4e7j.transformAggConnection)(activeApproval.excludedApprovers, (0, $g5TY0.transformJiraUserToLegacyServerUser)),
        status: status ? $3d843a7647f78c65$var$transformStatusToLegacy(status) : null
    };
};
const $3d843a7647f78c65$var$transformCompletedApprovalToLegacy = (completedApproval)=>{
    if (!completedApproval) return undefined;
    const { id: id, name: name, finalDecision: finalDecision, createdDate: createdDate, completedDate: completedDate, status: status } = completedApproval;
    return {
        id: id,
        name: name,
        finalDecision: $3d843a7647f78c65$var$getApproverDecision(finalDecision),
        createdDate: $3d843a7647f78c65$var$transformDateToLegacy(createdDate ?? ''),
        completedDate: $3d843a7647f78c65$var$transformDateToLegacy(completedDate),
        status: status ? $3d843a7647f78c65$var$transformStatusToLegacy(status) : null,
        approvers: (0, $f4e7j.transformAggConnection)(completedApproval.approvers, $3d843a7647f78c65$var$transformApproverToLegacy)
    };
};
const $3d843a7647f78c65$export$b14d30f2a9e4c343 = (node)=>{
    if (node.type !== (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE)) return undefined;
    const activeApproval = node.activeApproval ? {
        activeApproval: $3d843a7647f78c65$var$transformActiveApprovalToLegacy(node.activeApproval)
    } : {};
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: {
            ...activeApproval,
            completedApprovals: (0, $f4e7j.transformAggConnection)(node.completedApprovalsConnection, $3d843a7647f78c65$var$transformCompletedApprovalToLegacy)
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE),
            type: (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE)
        }
    };
};

});
parcelRegister("23qRX", function(module, exports) {

$parcel$export(module.exports, "toGroupId", () => $f236b06d6aabb595$export$779c261480444a4d);
$parcel$export(module.exports, "APPROVER_PENDING", () => $f236b06d6aabb595$export$3b59c4db06f5829b);
$parcel$export(module.exports, "APPROVER_APPROVED", () => $f236b06d6aabb595$export$e17ae8ca1010e2a4);
$parcel$export(module.exports, "APPROVER_DECLINED", () => $f236b06d6aabb595$export$b5a0d270c9cd7435);
$parcel$export(module.exports, "APPROVAL_OK", () => $f236b06d6aabb595$export$2e6187b6a4348938);
const $f236b06d6aabb595$export$779c261480444a4d = (x)=>x;
const $f236b06d6aabb595$export$3b59c4db06f5829b = 'pending';
const $f236b06d6aabb595$export$e17ae8ca1010e2a4 = 'approved';
const $f236b06d6aabb595$export$b5a0d270c9cd7435 = 'declined';
const $f236b06d6aabb595$export$2e6187b6a4348938 = 'OK';
const $f236b06d6aabb595$export$b5d660d719b8009 = 'INSUFFICIENT_APPROVERS';

});


parcelRegister("9myMG", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMEntitlementsToLegacyField", () => $d0d645fec4d38846$export$850fadda8a5e6f27);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $d0d645fec4d38846$export$850fadda8a5e6f27 = (node)=>{
    if (node.type !== (0, $lO4Or.ENTITLEMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.selectedEntitlement,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.ENTITLEMENT_CF_TYPE),
            items: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("gM34d", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMMajorIncidentToLegacyField", () => $07db702730ef03b7$export$d4e0b2288fb31144);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $07db702730ef03b7$export$d4e0b2288fb31144 = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.majorIncident,
        renderedValue: null,
        configuration: {},
        schema: {
            configuration: null,
            custom: (0, $lO4Or.MAJOR_INCIDENT_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("16kx8", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMOrganizationToLegacyField", () => $cedd80ccbf21d473$export$7bd14951253a7c5f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $cedd80ccbf21d473$export$7bd14951253a7c5f = (node)=>{
    if (node.type !== (0, $lO4Or.ORGANIZATIONS_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: (0, $f4e7j.transformAggConnection)(node.selectedOrganizationsConnection, (selectedNode)=>({
                id: selectedNode.organizationId,
                name: selectedNode.organizationName
            })),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.ORGANIZATIONS_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("4IQ8F", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestFeedbackToLegacyField", () => $2d53157bbab9736d$export$c52c6988b335096);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $2d53157bbab9736d$export$c52c6988b335096 = (node)=>{
    if (node.type !== (0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.feedback,
        schema: {
            type: 'sd-feedback',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: (0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("lcInz", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestLanguageToLegacyField", () => $32361ac554652aa8$export$6a53240e225f742);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $32361ac554652aa8$export$6a53240e225f742 = (node)=>{
    if (node.type !== (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.language,
        allowedValues: [
            ...node.languages ?? []
        ],
        schema: {
            type: 'sd-request-lang',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("4PFnn", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestTypeToLegacyField", () => $97b247bfb6fb2bf8$export$5ffaab1383177efa);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $97b247bfb6fb2bf8$var$transformRequestTypeToLegacy = (requestType)=>{
    if (!requestType) return null;
    return {
        requestType: {
            id: parseInt(requestType.requestTypeId, 10),
            issueTypeId: requestType.issueType?.issueTypeId || '',
            name: requestType.name || '',
            icon: {
                _links: {
                    iconUrls: {
                        '48x48': requestType.avatar?.large || ''
                    }
                }
            }
        }
    };
};
const $97b247bfb6fb2bf8$export$5ffaab1383177efa = (node)=>{
    if (node.type !== (0, $lO4Or.REQUEST_TYPE_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...' is not assignable to parameter of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...'.
        value: $97b247bfb6fb2bf8$var$transformRequestTypeToLegacy(node.requestType),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.REQUEST_TYPE_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'sd-customerrequesttype'
        }
    };
};

});

parcelRegister("alpM1", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRespondersToLegacyField", () => $e4d9f726b0420c01$export$5171c4d1ae5bcde5);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $e4d9f726b0420c01$var$transformJiraResponderToLegacyResponder = (responder)=>{
    if (responder == null) return undefined;
    switch(responder.__typename){
        case 0, $lO4Or.JSM_USER_RESPONDER_GQL_FIELD:
            if (responder.user === null) return undefined;
            return {
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                ari: responder.user.canonicalAccountId,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                avatarUrl: responder.user.picture,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                name: responder.user.name,
                type: 'user'
            };
        case 0, $lO4Or.JSM_TEAM_RESPONDER_FIELD:
            return {
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                ari: responder.teamId,
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                name: responder.teamName,
                type: 'team'
            };
        default:
            return undefined;
    }
};
const $e4d9f726b0420c01$export$5171c4d1ae5bcde5 = (node)=>{
    if (node.type !== (0, $lO4Or.RESPONDERS_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: (0, $f4e7j.transformAggConnection)(node.respondersConnection, $e4d9f726b0420c01$var$transformJiraResponderToLegacyResponder),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.RESPONDERS_CF_TYPE),
            items: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("gHd8e", function(module, exports) {

$parcel$export(module.exports, "transformAggLabelsNodeToLegacyField", () => $e9d06b1cdd22d77f$export$98e4f56e2e6c44fe);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $e9d06b1cdd22d77f$var$defaultSchema = {
    configuration: null,
    items: 'string',
    type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)
};
const $e9d06b1cdd22d77f$export$98e4f56e2e6c44fe = (node)=>{
    const selectedLabels = (0, $f4e7j.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name);
    switch(node.type){
        case 0, $lO4Or.LABELS_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: selectedLabels,
                schema: {
                    ...$e9d06b1cdd22d77f$var$defaultSchema,
                    custom: null,
                    system: node.type
                }
            };
        case 0, $lO4Or.LABELS_CF_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                // empty value for custom labels field is null while system labels field is `[]`
                value: selectedLabels.length === 0 ? null : selectedLabels,
                schema: {
                    ...$e9d06b1cdd22d77f$var$defaultSchema,
                    custom: node.type,
                    system: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("dUrU1", function(module, exports) {

$parcel$export(module.exports, "transformAggMultiGroupPickerToLegacyField", () => $bf00e02f796ca76f$export$f968da580693597d);


var $f4e7j = parcelRequire("f4e7j");
const $bf00e02f796ca76f$export$f968da580693597d = (node)=>{
    const value = (0, $f4e7j.transformAggConnection)(node.selectedGroupsConnection, (groupNode)=>({
            groupId: groupNode.groupId,
            name: groupNode.name
        }));
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            type: 'array',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: 'group',
            configuration: null
        }
    };
};

});

parcelRegister("hQM7C", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleSelectToLegacyField", () => $b77f8634d7271da6$export$869fb8fbcb97e0ee);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $b77f8634d7271da6$export$869fb8fbcb97e0ee = (node)=>{
    switch(node.type){
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
            {
                const value = (0, $f4e7j.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: [],
                    schema: {
                        type: 'array',
                        renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("QjWSM", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleUserPickerToLegacyField", () => $c7caa94b89e539e2$export$cdd9991119eb040e);

var $7ZZxN = parcelRequire("7ZZxN");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $ijtj3 = parcelRequire("ijtj3");

var $g5TY0 = parcelRequire("g5TY0");
const $c7caa94b89e539e2$export$cdd9991119eb040e = (node, context)=>{
    const value = (0, $f4e7j.transformAggConnection)(node.selectedUsersConnection, (0, $g5TY0.transformJiraUserToLegacyServerUser));
    const legacyFieldValues = {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            configuration: null,
            custom: node.type,
            items: 'user',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
    switch(node.type){
        case 0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE:
            {
                const project = (0, $ijtj3.getSystemAggJiraProject)(context);
                if ((0, $ijtj3.getProjectType)(project.projectType) !== (0, $7ZZxN.SERVICE_DESK_PROJECT)) return undefined;
                // Empty array is the expected value when there are no request
                // participants.
                return {
                    ...legacyFieldValues,
                    value: value
                };
            }
        case 0, $lO4Or.PARTICIPANTS_CF_TYPE:
        case 0, $lO4Or.MULTI_USER_CF_TYPE:
            return legacyFieldValues;
        case 0, $lO4Or.APPROVERS_LIST_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            {
                const schemaConfig = 'isMulti' in node && node.isMulti != null ? [
                    {
                        key: 'isMulti',
                        value: String(node.isMulti)
                    }
                ] : null;
                return {
                    ...legacyFieldValues,
                    autoCompleteUrl: node.searchUrl,
                    schema: {
                        ...legacyFieldValues.schema,
                        configuration: schemaConfig
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("4CGp4", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleVersionPickerToLegacyField", () => $3d2f68ea759270b4$export$6207ea60703068d8);

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $hd35n = parcelRequire("hd35n");
const $3d2f68ea759270b4$var$defaultSchema = {
    configuration: null,
    custom: null,
    items: 'version',
    renderer: (0, $c7e7b1d3600a0c0f$export$840ed33fa94f7693),
    system: null,
    type: 'array'
};
const $3d2f68ea759270b4$export$6207ea60703068d8 = (node)=>{
    if (node.type !== (0, $lO4Or.MULTI_VERSION_CF_TYPE) && node.type !== (0, $lO4Or.AFFECTS_VERSIONS_TYPE) && node.type !== (0, $lO4Or.FIX_VERSIONS_TYPE)) return undefined;
    const legacyFieldValues = {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        allowedValues: (0, $f4e7j.transformAggConnection)(node.multiPickerVersions, (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $hd35n.transformAggVersionToLegacyVersion) : (0, $hd35n.transformAggVersionToLegacyVersionOld)),
        value: (0, $f4e7j.transformAggConnection)(node.selectedVersionsConnection, (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $hd35n.transformAggVersionToLegacyVersion) : (0, $hd35n.transformAggVersionToLegacyVersionOld))
    };
    switch(node.type){
        case 0, $lO4Or.MULTI_VERSION_CF_TYPE:
            return {
                ...legacyFieldValues,
                value: legacyFieldValues.value.length === 0 ? null : legacyFieldValues.value,
                schema: {
                    ...$3d2f68ea759270b4$var$defaultSchema,
                    custom: (0, $lO4Or.MULTI_VERSION_CF_TYPE)
                }
            };
        case 0, $lO4Or.AFFECTS_VERSIONS_TYPE:
        case 0, $lO4Or.FIX_VERSIONS_TYPE:
            return {
                ...legacyFieldValues,
                allowedValues: legacyFieldValues.allowedValues.filter((v)=>!v.archived),
                schema: {
                    ...$3d2f68ea759270b4$var$defaultSchema,
                    system: node.type
                }
            };
        default:
            return undefined;
    }
};

});
parcelRegister("hd35n", function(module, exports) {

$parcel$export(module.exports, "transformAggVersionToLegacyVersionOld", () => $41957f3e8e88f6a1$export$5427f5949bb0492d);
$parcel$export(module.exports, "transformAggVersionToLegacyVersion", () => $41957f3e8e88f6a1$export$becef8d087e8b62b);

var $exWH1 = parcelRequire("exWH1");
const $41957f3e8e88f6a1$export$5427f5949bb0492d = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $exWH1.VersionStatus).ARCHIVED,
        released: version.status === (0, $exWH1.VersionStatus).RELEASED
    });
const $41957f3e8e88f6a1$export$becef8d087e8b62b = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $exWH1.VersionStatus).ARCHIVED,
        released: version.status === (0, $exWH1.VersionStatus).RELEASED,
        ari: version.id
    });

});
parcelRegister("exWH1", function(module, exports) {

$parcel$export(module.exports, "VersionStatus", () => $4c4bb928a168d525$export$8c6e0f93bfb5c6a4);

var $23qRX = parcelRequire("23qRX");
var $03XEB = parcelRequire("03XEB");
var $edkGa = parcelRequire("edkGa");

var $lO4Or = parcelRequire("lO4Or");

const $4c4bb928a168d525$export$8c6e0f93bfb5c6a4 = {
    ARCHIVED: 'ARCHIVED',
    RELEASED: 'RELEASED',
    UNRELEASED: 'UNRELEASED'
};

});



parcelRegister("lWE99", function(module, exports) {

$parcel$export(module.exports, "transformAggNumberToLegacyField", () => $1ea236981671650b$export$d754a24ed0096d2f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $1ea236981671650b$export$d754a24ed0096d2f = (node)=>{
    const fieldType = node.isStoryPointField === true ? (0, $lO4Or.STORY_POINTS_TYPE) : node.type;
    switch(fieldType){
        case 0, $lO4Or.NUMBER_CF_TYPE:
        case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $lO4Or.STORY_POINTS_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: node.number ?? null,
                schema: {
                    configuration: null,
                    items: null,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    custom: fieldType,
                    system: null,
                    type: (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("4eNqf", function(module, exports) {

$parcel$export(module.exports, "transformAggOriginalEstimateToLegacyField", () => $50d87f174d910a4b$export$f08d02fdc74f920e);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $50d87f174d910a4b$export$f08d02fdc74f920e = (node)=>{
    if (node.type !== (0, $lO4Or.TIME_ESTIMATE_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.originalEstimate?.timeInSeconds ?? null,
        schema: {
            configuration: null,
            custom: null,
            system: node.type,
            items: null,
            type: (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE),
            renderer: null
        }
    };
};

});

parcelRegister("fkHM1", function(module, exports) {

$parcel$export(module.exports, "transformAggPriorityToLegacyField", () => $ccf6d66eff5dbc1f$export$9e966ce605f800d2);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $ccf6d66eff5dbc1f$var$transformJiraPriorityToLegacyPriority = (priority)=>{
    if (priority == null) return null;
    return {
        id: priority.priorityId,
        iconUrl: String(priority.iconUrl || ''),
        name: priority.name || '',
        sequence: priority.sequence || undefined
    };
};
const $ccf6d66eff5dbc1f$export$9e966ce605f800d2 = (node)=>{
    if (node.type !== (0, $lO4Or.PRIORITY_TYPE)) return undefined;
    const allowedValues = (0, $f4e7j.transformAggConnection)('priorities' in node ? node.priorities : null, $ccf6d66eff5dbc1f$var$transformJiraPriorityToLegacyPriority);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        // @ts-expect-error - Argument of type '{ readonly color: string | null | undefined; readonly iconUrl: string | null | undefined; readonly name: string | null | undefined; readonly priorityId: string; } | { readonly iconUrl: string | ... 1 more ... | undefined; readonly name: string | ... 1 more ... | undefined; readonly priorityId: string; } | { ...; } |...' is not assignable to parameter of type 'AggJiraPriority | null'.
        value: $ccf6d66eff5dbc1f$var$transformJiraPriorityToLegacyPriority(node.priority),
        schema: {
            type: (0, $lO4Or.PRIORITY_TYPE),
            custom: null,
            system: (0, $lO4Or.PRIORITY_TYPE),
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)
        }
    };
};

});

parcelRegister("fkaQR", function(module, exports) {

$parcel$export(module.exports, "transformAggProformaFormsToLegacyField", () => $b1792cecaa8dedc0$export$fdcdbf17b0d4e36f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $b1792cecaa8dedc0$export$fdcdbf17b0d4e36f = (node)=>{
    if (node.type !== (0, $lO4Or.PROFORMA_FORMS)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.proformaForms,
        schema: {
            configuration: null,
            items: null,
            system: (0, $lO4Or.PROFORMA_FORMS),
            custom: null,
            renderer: null,
            type: (0, $lO4Or.PROFORMA_FORMS)
        }
    };
};

});

parcelRegister("gyvos", function(module, exports) {

$parcel$export(module.exports, "transformAggRadioSelectToLegacyField", () => $f7afb2486834699b$export$f147f1eb3a15ccfc);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $f7afb2486834699b$export$f147f1eb3a15ccfc = (node)=>{
    if (node.type !== (0, $lO4Or.RADIO_BUTTONS_CF_TYPE)) return undefined;
    const value = node.selectedOption ? {
        id: node.selectedOption?.optionId,
        value: node.selectedOption?.value,
        isDisabled: node.selectedOption?.isDisabled
    } : null;
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.radioSelectFieldOptions, (option)=>({
            id: option.optionId,
            value: option.value ?? null,
            ari: option.id
        }));
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: 'option',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("3w75b", function(module, exports) {

$parcel$export(module.exports, "transformAggResolutionToLegacyField", () => $5302369645b034cd$export$179f600c7e1d0230);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $5302369645b034cd$var$resolutionTransformer = (resolution)=>{
    if (resolution == null) return null;
    return {
        id: resolution.resolutionId,
        name: resolution.name || ''
    };
};
const $5302369645b034cd$export$179f600c7e1d0230 = (node)=>{
    if (node.type !== (0, $lO4Or.RESOLUTION_TYPE)) return undefined;
    const value = $5302369645b034cd$var$resolutionTransformer(node.resolution);
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.resolutions, $5302369645b034cd$var$resolutionTransformer);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: (0, $lO4Or.RESOLUTION_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $lO4Or.RESOLUTION_TYPE),
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("lQr58", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextToLegacyField", () => $63df895e1ecc6044$export$e65ff2ce94be106e);

var $eZmml = parcelRequire("eZmml");

var $7Vbpp = parcelRequire("7Vbpp");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $63df895e1ecc6044$var$emptyAdfObject = (0, $eZmml.getEmptyADF)();
const $63df895e1ecc6044$var$getSchema = (aggType, renderer)=>{
    switch(aggType){
        case 0, $lO4Or.TEXT_AREA_CF_TYPE:
            return {
                custom: aggType,
                renderer: renderer,
                type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                configuration: null,
                items: null
            };
        case 0, $lO4Or.DESCRIPTION_TYPE:
        case 0, $lO4Or.ENVIRONMENT_TYPE:
        default:
            return {
                system: aggType,
                renderer: renderer,
                type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
                custom: null,
                configuration: null,
                items: null
            };
    }
};
// Exactly match the legacy /graphql value, handling the case where the field is empty and has never been edited
// There's no functional difference between `null` or empty string when rendering the field in the issue view.
const $63df895e1ecc6044$var$getPlainTextValue = (node)=>{
    // When the field is empty and a value has never been set
    if (!node.richText) return null;
    // When the field has been set to a value, and then set back to empty
    if (node.richText?.plainText == null) return '';
    return node.richText?.plainText;
};
const $63df895e1ecc6044$export$e65ff2ce94be106e = (node)=>{
    // Description field always renders with ADF
    const { renderer: renderer } = node;
    if ((0, $2qVcp.default)(node)) return undefined;
    const isPlainTextRenderer = node.type !== (0, $lO4Or.DESCRIPTION_TYPE) && renderer === (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f);
    if (isPlainTextRenderer) return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $63df895e1ecc6044$var$getPlainTextValue(node),
        schema: $63df895e1ecc6044$var$getSchema(node.type, renderer)
    };
    const adfValueJson = node.richText?.adfValue?.json ?? null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        // The usages of the collection is deprecated.
        adfValue: adfValueJson ? (0, $7Vbpp.removeCollectionFromAdf)(adfValueJson) : $63df895e1ecc6044$var$emptyAdfObject,
        value: null,
        schema: $63df895e1ecc6044$var$getSchema(node.type, renderer)
    };
};

});

parcelRegister("8oO4q", function(module, exports) {

$parcel$export(module.exports, "transformAggSecurityLevelToLegacyField", () => $28a96bf619a924f9$export$45e25e2a6750ea5a);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $28a96bf619a924f9$var$transformJiraSecurityLevel = (securityLevel)=>{
    if (securityLevel == null) return null;
    return {
        id: securityLevel.securityId,
        description: securityLevel.description || '',
        name: securityLevel.name || ''
    };
};
const $28a96bf619a924f9$export$45e25e2a6750ea5a = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $28a96bf619a924f9$var$transformJiraSecurityLevel(node.securityLevel),
        allowedValues: (0, $f4e7j.transformAggConnection)(node.securityLevels, $28a96bf619a924f9$var$transformJiraSecurityLevel),
        schema: {
            configuration: null,
            type: (0, $lO4Or.SECURITY_LEVEL_TYPE_OVERRIDE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $lO4Or.SECURITY_LEVEL_TYPE),
            items: null
        }
    });

});

parcelRegister("5Ne6t", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleGroupPickerToLegacyField", () => $1b8c5a144aba3441$export$e6697ec5bdac9ec0);


var $f4e7j = parcelRequire("f4e7j");
const $1b8c5a144aba3441$export$e6697ec5bdac9ec0 = (node)=>{
    const value = node.selectedGroup != null ? {
        groupId: node.selectedGroup.groupId,
        name: node.selectedGroup.name
    } : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'group',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2ETkN", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleLineTextToLegacyField", () => $84dcb0c130bea779$export$31f32b3fd9e5ab6);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $84dcb0c130bea779$var$defaultSchema = {
    configuration: null,
    items: null,
    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)
};
const $84dcb0c130bea779$export$31f32b3fd9e5ab6 = (node)=>{
    const defaultTransformedField = {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.text
    };
    switch(node.type){
        case 0, $lO4Or.EPIC_NAME_TYPE:
        case 0, $lO4Or.MESSAGE_EDIT_CF_TYPE:
        case 0, $lO4Or.MESSAGE_VIEW_CF_TYPE:
        case 0, $lO4Or.READ_ONLY_CF_TYPE:
        case 0, $lO4Or.TEXT_CF_TYPE:
        case 0, $lO4Or.USER_PROPERTY_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$84dcb0c130bea779$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
                }
            };
        case 0, $lO4Or.RANK_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$84dcb0c130bea779$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $lO4Or.ISSUE_FIELD_ANY_CF_TYPE)
                }
            };
        case 0, $lO4Or.SUMMARY_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$84dcb0c130bea779$var$defaultSchema,
                    type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
                    custom: null,
                    system: node.type
                }
            };
        case 0, $lO4Or.SERVICEDESK_PRACTICES_TYPE:
            // Transform field only if the practice has a value
            return node.text != null ? {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: [
                    node.text
                ],
                schema: {
                    ...$84dcb0c130bea779$var$defaultSchema,
                    renderer: null,
                    custom: null,
                    system: node.type,
                    type: (0, $lO4Or.SERVICEDESK_PRACTICES_TYPE)
                }
            } : undefined;
        default:
            return undefined;
    }
};

});

parcelRegister("fz8Wc", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectToLegacyField", () => $6eb6c9de60f230bb$export$4e113f935e09d226);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $6eb6c9de60f230bb$var$getField = (node, customType)=>{
    const value = node.fieldOption != null ? {
        ari: node.fieldOption.id,
        id: node.fieldOption.optionId,
        value: node.fieldOption.value
    } : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'option',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: customType || node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};
const $6eb6c9de60f230bb$export$4e113f935e09d226 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.EPIC_STATUS_TYPE:
        case 0, $lO4Or.SELECT_CF_TYPE:
            return $6eb6c9de60f230bb$var$getField(node);
        case 0, $lO4Or.CATEGORY_TYPE:
            return $6eb6c9de60f230bb$var$getField(node, (0, $lO4Or.SELECT_CF_TYPE));
        default:
            return undefined;
    }
};

});

parcelRegister("jBiXV", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectUserPickerToLegacyField", () => $13d89b5e83359a47$export$7bf73fc06c6d71be);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $g5TY0 = parcelRequire("g5TY0");
const $13d89b5e83359a47$export$7bf73fc06c6d71be = (node)=>{
    const legacyField = {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $g5TY0.transformJiraUserToLegacyServerUser)(node.user) : null
    };
    switch(node.type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE),
                    custom: null,
                    system: node.type,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.LAST_UPDATER_OR_COMMENTER_CF_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE),
                    custom: node.type,
                    system: null,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("1XUHd", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleVersionPickerToLegacyField", () => $c650b563dc539b29$export$d03f622577260442);

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $hd35n = parcelRequire("hd35n");
const $c650b563dc539b29$export$d03f622577260442 = (node)=>{
    if (node.type !== (0, $lO4Or.VERSION_CF_TYPE)) return undefined;
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.singlePickerVersions, (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $hd35n.transformAggVersionToLegacyVersion) : (0, $hd35n.transformAggVersionToLegacyVersionOld));
    const transformVersion = (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $hd35n.transformAggVersionToLegacyVersion) : (0, $hd35n.transformAggVersionToLegacyVersionOld);
    const value = node.version ? transformVersion(node.version) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            type: (0, $lO4Or.ISSUE_FIELD_VERSION_CF_TYPE),
            custom: (0, $lO4Or.VERSION_CF_TYPE),
            system: null
        }
    };
};

});

parcelRegister("c6LKM", function(module, exports) {

$parcel$export(module.exports, "transformAggSprintToLegacyField", () => $c11b803b5a137e84$export$9b5bb05d50970021);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $c11b803b5a137e84$var$SprintOptionalKeyMap = {
    goal: 'goal',
    completeDate: 'completionDate',
    startDate: 'startDate',
    endDate: 'endDate'
};
const $c11b803b5a137e84$var$transformAggSprintToLegacySprint = (sprint)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const optionalValues = {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys($c11b803b5a137e84$var$SprintOptionalKeyMap).forEach((key)=>{
        const aggKey = $c11b803b5a137e84$var$SprintOptionalKeyMap[key];
        const aggValue = sprint[aggKey];
        if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
    });
    return {
        id: Number(sprint.sprintId),
        name: sprint.name,
        state: sprint.state?.toLowerCase(),
        boardId: Number(sprint.boardName) || 0,
        ...optionalValues
    };
};
const $c11b803b5a137e84$export$9b5bb05d50970021 = (node)=>{
    if (node.type !== (0, $lO4Or.SPRINT_TYPE)) return undefined;
    const sprints = (0, $f4e7j.transformAggConnection)(node.selectedSprintsConnection, $c11b803b5a137e84$var$transformAggSprintToLegacySprint);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: sprints,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.SPRINT_TYPE),
            items: 'json',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("5W75j", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamToLegacyField", () => $97428b249585cac2$export$fb1b80497e96456f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $97428b249585cac2$export$fb1b80497e96456f = (node)=>{
    if (node.type !== (0, $lO4Or.TEAM_CF_TYPE)) return undefined;
    const value = node.selectedTeam ? {
        id: node.selectedTeam.teamId,
        title: node.selectedTeam.name,
        isShared: node.selectedTeam.isShared,
        avatarUrl: node.selectedTeam.avatar?.medium
    } : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.TEAM_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: (0, $lO4Or.ISSUE_FIELD_ANY_CF_TYPE)
        }
    };
};

});

parcelRegister("7iFVU", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamViewToLegacyField", () => $bb4542beb2315e32$export$6f6aaafb49bd4769);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $bb4542beb2315e32$var$transformAggTeamViewToLegacyTeam = (team)=>{
    if (team == null) return null;
    return {
        id: team.jiraSuppliedTeamId,
        name: team.jiraSuppliedName || '',
        isVisible: team.jiraSuppliedVisibility || false,
        avatarUrl: team.jiraSuppliedAvatar?.xsmall || ''
    };
};
const $bb4542beb2315e32$export$6f6aaafb49bd4769 = (node)=>{
    if (node.type !== (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...' is not assignable to parameter of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...'.
        value: $bb4542beb2315e32$var$transformAggTeamViewToLegacyTeam(node.selectedTeam),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'team'
        }
    };
};

});

parcelRegister("kyZt3", function(module, exports) {

$parcel$export(module.exports, "transformAggTimeTrackingToLegacyField", () => $3404d836fe97323f$export$874d9bd14269ec6f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $3404d836fe97323f$var$getEstimateValues = (estimate, key)=>{
    if (estimate) return {
        [key]: estimate.timeInSeconds || 0
    };
    return {};
};
const $3404d836fe97323f$export$874d9bd14269ec6f = (node)=>{
    if (node.type !== (0, $lO4Or.TIME_TRACKING_TYPE)) return undefined;
    const originalEstimate = $3404d836fe97323f$var$getEstimateValues(node.originalEstimate || null, 'originalEstimateSeconds');
    const remainingEstimate = $3404d836fe97323f$var$getEstimateValues(node.remainingEstimate || null, 'remainingEstimateSeconds');
    const timeSpent = $3404d836fe97323f$var$getEstimateValues(node.timeSpent || null, 'timeSpentSeconds');
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: {
            ...originalEstimate,
            ...remainingEstimate,
            ...timeSpent
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: (0, $lO4Or.TIME_TRACKING_TYPE),
            type: (0, $lO4Or.TIME_TRACKING_TYPE)
        }
    };
};

});

parcelRegister("dX2ot", function(module, exports) {

$parcel$export(module.exports, "transformAggUrlToLegacyField", () => $65722746bbedc61a$export$6e950e0ec9801f6c);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $65722746bbedc61a$export$6e950e0ec9801f6c = (node)=>{
    if (node.type !== (0, $lO4Or.URL_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.uri ?? null,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.URL_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("jhiYN", function(module, exports) {

$parcel$export(module.exports, "transformAggVotesToLegacyField", () => $471f4de3dfdc045c$export$8966614b8594736);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $471f4de3dfdc045c$var$transformAggVoteToLegacyVote = (vote)=>({
        votes: vote.count != null ? Number(vote.count) : 0,
        hasVoted: vote.hasVoted ?? false
    });
const $471f4de3dfdc045c$export$8966614b8594736 = (node)=>{
    if (node.type !== (0, $lO4Or.VOTES_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.vote ? $471f4de3dfdc045c$var$transformAggVoteToLegacyVote(node.vote) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $lO4Or.VOTES_TYPE),
            type: (0, $lO4Or.VOTES_TYPE)
        }
    };
};

});

parcelRegister("1BsAz", function(module, exports) {

$parcel$export(module.exports, "transformAggWatchesToLegacyField", () => $47cca6eb8a2344d9$export$6730cb17d10d6156);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $47cca6eb8a2344d9$var$transformAggWatchesToLegacyWatches = (watch)=>({
        watchCount: watch.count != null ? Number(watch.count) : 0,
        isWatching: watch.isWatching ?? false
    });
const $47cca6eb8a2344d9$export$6730cb17d10d6156 = (node)=>{
    if (node.type !== (0, $lO4Or.WATCHES_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.watch ? $47cca6eb8a2344d9$var$transformAggWatchesToLegacyWatches(node.watch) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $lO4Or.WATCHES_TYPE),
            type: (0, $lO4Or.WATCHES_TYPE)
        }
    };
};

});


parcelRegister("3mPa1", function(module, exports) {

$parcel$export(module.exports, "transformAggFieldsToLegacyParentFields", () => $f7a9f1cb67bbed9b$export$bfe7c3aed8dd84e2);
$parcel$export(module.exports, "transformServerParentFieldsToParentIssue", () => $f7a9f1cb67bbed9b$export$625e0785d942b6bd);

var $tgbCK = parcelRequire("tgbCK");

var $6vrw7 = parcelRequire("6vrw7");

var $laBqX = parcelRequire("laBqX");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $9ax61 = parcelRequire("9ax61");

var $ijtj3 = parcelRequire("ijtj3");
const $f7a9f1cb67bbed9b$var$getIssueTypeFieldValue = (parentIssue, fields)=>{
    const issueType = fields.issuetype?.value;
    if (issueType == null) throw new Error(`Failed to transform parent issue: ${(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)} field not found [${JSON.stringify(parentIssue)}]`);
    return issueType;
};
const $f7a9f1cb67bbed9b$var$getSummaryFieldValue = (parentIssue, fields)=>{
    const summary = fields.summary?.value;
    if (summary == null) throw new Error(`Failed to transform parent issue: ${(0, $lO4Or.TEXT_GQL_FIELD)} field not found [${JSON.stringify(parentIssue)}]`);
    return summary;
};
const $f7a9f1cb67bbed9b$var$transformAggParentIssueToServerParentIssue = (parentIssue, fields)=>{
    if (parentIssue == null) return null;
    if (!(0, $laBqX.isParentInIssueViewEnabled)()) return {
        id: parentIssue.issueId,
        key: (0, $6vrw7.toIssueKey)(parentIssue.key),
        self: parentIssue.webUrl ?? '',
        fields: {
            issuetype: $f7a9f1cb67bbed9b$var$getIssueTypeFieldValue(parentIssue, fields),
            summary: $f7a9f1cb67bbed9b$var$getSummaryFieldValue(parentIssue, fields)
        }
    };
    const colorMapped = !parentIssue.issueColorField?.color?.colorKey || parentIssue.issueColorField?.color?.colorKey === '' ? undefined : (0, $tgbCK.MAP_FROM_SERVER_COLOR)[parentIssue.issueColorField?.color?.colorKey];
    return {
        id: parentIssue.issueId,
        key: (0, $6vrw7.toIssueKey)(parentIssue.key),
        self: parentIssue.webUrl ?? '',
        fields: {
            issuetype: $f7a9f1cb67bbed9b$var$getIssueTypeFieldValue(parentIssue, fields),
            summary: $f7a9f1cb67bbed9b$var$getSummaryFieldValue(parentIssue, fields)
        },
        color: colorMapped
    };
};
const $f7a9f1cb67bbed9b$var$transformAggParentIssueToServerParentLink = (parentIssue, fields, project, parentVisibility)=>{
    const parentLinkVisibilityValue = {
        hasEpicLinkFieldDependency: parentVisibility?.hasEpicLinkFieldDependency ?? false,
        showField: parentVisibility?.canUseParentLinkField ?? false
    };
    if (parentIssue == null || project == null) return parentLinkVisibilityValue;
    const issueType = $f7a9f1cb67bbed9b$var$getIssueTypeFieldValue(parentIssue, fields);
    return {
        ...parentLinkVisibilityValue,
        data: {
            id: Number(parentIssue.issueId),
            key: parentIssue.key,
            projectId: Number(project.projectId),
            summary: $f7a9f1cb67bbed9b$var$getSummaryFieldValue(parentIssue, fields),
            issueType: {
                id: Number(issueType.id),
                iconUrl: issueType.iconUrl
            }
        }
    };
};
const $f7a9f1cb67bbed9b$var$transformAggParentIssueToParentLinkField = (field, parentIssue, parentIssueFields, project, parentVisibility)=>({
        [field.key]: {
            ...field,
            value: $f7a9f1cb67bbed9b$var$transformAggParentIssueToServerParentLink(parentIssue, parentIssueFields, project, parentVisibility),
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                type: (0, $lO4Or.ISSUE_FIELD_ANY_CF_TYPE),
                custom: (0, $lO4Or.PARENT_CF_TYPE),
                system: null
            }
        }
    });
const $f7a9f1cb67bbed9b$var$transformAggParentIssueToParentField = (field, parentIssue, parentIssueFields)=>({
        [(0, $lO4Or.PARENT_TYPE)]: {
            ...field,
            key: (0, $lO4Or.PARENT_TYPE),
            title: field.title,
            value: $f7a9f1cb67bbed9b$var$transformAggParentIssueToServerParentIssue(parentIssue, parentIssueFields),
            schema: {
                configuration: null,
                items: (0, $lO4Or.ISSUE_LINKS_TYPE),
                renderer: null,
                type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
                custom: null,
                system: (0, $lO4Or.PARENT_TYPE)
            }
        }
    });
const $f7a9f1cb67bbed9b$export$6899254d05dcf933 = (node)=>{
    const parentIssue = node.parentIssue ?? null;
    const parentIssueFields = parentIssue?.fieldsById?.edges ?? null;
    const fieldsState = (0, $9ax61.transformAggFieldsToLegacyFields)(parentIssueFields);
    const projectContext = parentIssueFields ? (0, $ijtj3.transformAggProjectToProjectContext)(parentIssueFields) : null;
    const field = (0, $f4e7j.transformAggNodeToLegacyField)(node);
    // This field is present in all parent issue types, and will be solely used after the hierarchy unification.
    const unifiedParentField = $f7a9f1cb67bbed9b$var$transformAggParentIssueToParentField(field, parentIssue, fieldsState);
    switch(node.type){
        // Parent link for portfolio child issues (epics)
        case 0, $lO4Or.PARENT_CF_TYPE:
            return {
                ...unifiedParentField,
                ...$f7a9f1cb67bbed9b$var$transformAggParentIssueToParentLinkField(field, parentIssue, fieldsState, projectContext, node.parentVisibility)
            };
        case 0, $lO4Or.PARENT_TYPE:
        default:
            return unifiedParentField;
    }
};
const $f7a9f1cb67bbed9b$export$bfe7c3aed8dd84e2 = (fields)=>{
    const parentFields = {};
    if (fields != null) // There can be multiple parent link fields, but they all use the same parent value
    fields.forEach((field)=>{
        const node = field?.node;
        if (node != null && node.__typename === (0, $lO4Or.PARENT_GQL_FIELD)) Object.assign(parentFields, $f7a9f1cb67bbed9b$export$6899254d05dcf933(node));
    });
    return parentFields;
};
const $f7a9f1cb67bbed9b$export$625e0785d942b6bd = (fields)=>{
    const parentIssue = fields[0, $lO4Or.PARENT_TYPE]?.value;
    if (parentIssue == null) return null;
    return {
        id: (0, $6vrw7.toIssueId)(parentIssue.id),
        key: (0, $6vrw7.toIssueKey)(parentIssue.key),
        summary: parentIssue.fields.summary,
        issueTypeName: parentIssue.fields.issuetype?.name ?? '',
        issueTypeIconUrl: parentIssue.fields.issuetype?.iconUrl ?? ''
    };
};

});
parcelRegister("laBqX", function(module, exports) {

$parcel$export(module.exports, "isParentInIssueViewEnabled", () => $99e1f9f9d21b8f5c$export$9c7fa56ed1fa2e15);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $1ybV0 = parcelRequire("1ybV0");
const $99e1f9f9d21b8f5c$export$9c7fa56ed1fa2e15 = ()=>(0, $1ybV0.ff)('parent-field-in-issue-view_x4zn4', false);

});


parcelRegister("in2oj", function(module, exports) {

$parcel$export(module.exports, "transformAggIsArchivedToLegacyGira", () => $c473180085bfcf16$export$4ad35dba6d4f61c6);
const $c473180085bfcf16$export$4ad35dba6d4f61c6 = (data)=>data.jira.issueByKey?.isArchived || false;

});

parcelRegister("eM65p", function(module, exports) {

$parcel$export(module.exports, "transformAggIssueToHierarchyLegacyFields", () => $ec974c006f7b1273$export$a5b7b2d30e0d3ea);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $eOsdu = parcelRequire("eOsdu");
const $ec974c006f7b1273$var$getHierarchyLevelFieldTitle = (key)=>{
    switch(key){
        case 0, $lO4Or.HIERARCHY_LEVEL_ABOVE:
            return 'graphql.hierarchy.level.above';
        case 0, $lO4Or.HIERARCHY_LEVEL_BELOW:
            return 'graphql.hierarchy.level.below';
        case 0, $lO4Or.HIERARCHY_LEVEL_SAME_LEVEL:
            return 'graphql.hierarchy.level.same';
        default:
            return '';
    }
};
const $ec974c006f7b1273$var$transformAggHierarchyLevelToLegacyField = (key, type, hierarchyLevel, issueTypesForHierarchyLevel)=>{
    const transformedIssueTypes = (0, $f4e7j.transformAggConnection)(issueTypesForHierarchyLevel, (0, $eOsdu.transformJiraIssueTypeToLegacyIssueType));
    if (transformedIssueTypes.length === 0) return {};
    // Check `hierarchyLevelAbove`, `hierarchyLevelBelow`, or `JiraIssueTypeField.issueType.hierarchy`
    if (hierarchyLevel == null) throw new Error(`Failed to transform hierarchy level fields: top-level hierarchy info for ${type} is missing.`);
    const issueTypeIds = transformedIssueTypes.map((issueType)=>Number(issueType.id));
    return {
        [key]: {
            key: key,
            title: $ec974c006f7b1273$var$getHierarchyLevelFieldTitle(key),
            editable: false,
            required: false,
            autoCompleteUrl: null,
            allowedValues: [],
            value: {
                ...hierarchyLevel,
                issueTypeIds: issueTypeIds,
                issueTypes: transformedIssueTypes
            },
            schema: {
                configuration: null,
                items: null,
                renderer: null,
                type: key,
                system: null,
                custom: type
            }
        }
    };
};
const $ec974c006f7b1273$export$a5b7b2d30e0d3ea = (issue)=>{
    // Hierarchy level info for `HIERARCHY_LEVEL_SAME_LEVEL` lives in `JiraIssueTypeField`
    const issueType = (0, $eOsdu.getSystemAggJiraIssueType)(issue?.fields?.edges);
    return {
        ...$ec974c006f7b1273$var$transformAggHierarchyLevelToLegacyField((0, $lO4Or.HIERARCHY_LEVEL_ABOVE), (0, $lO4Or.GRAPHQL_HIERARCHY_LEVEL_ABOVE), issue?.hierarchyLevelAbove, issue?.issueTypesForHierarchyAbove),
        ...$ec974c006f7b1273$var$transformAggHierarchyLevelToLegacyField((0, $lO4Or.HIERARCHY_LEVEL_BELOW), (0, $lO4Or.GRAPHQL_HIERARCHY_LEVEL_BELOW), issue?.hierarchyLevelBelow, issue?.issueTypesForHierarchyBelow),
        ...$ec974c006f7b1273$var$transformAggHierarchyLevelToLegacyField((0, $lO4Or.HIERARCHY_LEVEL_SAME_LEVEL), (0, $lO4Or.GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL), issueType.hierarchy, issue?.issueTypesForHierarchySame)
    };
};

});

parcelRegister("91Rk4", function(module, exports) {

$parcel$export(module.exports, "transformAggResponseSubtasksConfig", () => $60f75622fd0f2a25$export$2cbfa462c5e65cbe);
const $60f75622fd0f2a25$export$2cbfa462c5e65cbe = (data)=>({
        enabled: data.jira.isSubtasksEnabled || false
    });

});

parcelRegister("loX5s", function(module, exports) {

$parcel$export(module.exports, "transformAggResponseToIssueLinks", () => $c4d877d70f96d9fb$export$c5f2c1f8ebbf7cdf);

var $6vrw7 = parcelRequire("6vrw7");

var $03XEB = parcelRequire("03XEB");

var $aSsby = parcelRequire("aSsby");
// For type safety, since `LinkedIssue` requires `issueKey`
const $c4d877d70f96d9fb$var$transformAggAssociatedIssueToLinkedIssue = (issue)=>({
        ...(0, $aSsby.transformAggAssociatedIssueToAssociatedIssue)(issue),
        issueKey: issue.key
    });
// Throw an error if someone adds a new direction on the server and we receive it
const $c4d877d70f96d9fb$var$transformAggIssueLinkDirectionToIssueLinkDirection = (direction)=>{
    switch(direction){
        case 0, $03XEB.INWARD_LINK_DIRECTION:
            return 0, $03XEB.INWARD_LINK_DIRECTION;
        case 0, $03XEB.OUTWARD_LINK_DIRECTION:
            return 0, $03XEB.OUTWARD_LINK_DIRECTION;
        default:
            throw new Error('Invalid issue link direction.');
    }
};
const $c4d877d70f96d9fb$var$transformAggIssueLinkToIssueLink = (issueLink)=>({
        id: (0, $6vrw7.toIssueId)(issueLink.issueLinkId),
        direction: $c4d877d70f96d9fb$var$transformAggIssueLinkDirectionToIssueLinkDirection(issueLink.direction),
        linkedIssueKey: issueLink.issue?.key || '',
        typeId: issueLink.type.linkTypeId,
        typeName: issueLink.relationName
    });
const $c4d877d70f96d9fb$export$c5f2c1f8ebbf7cdf = (data)=>{
    /**
	 * If the issue links are disabled, the `issueLinks` returned by AGG will be null. This happens in the following cases:
	 * - Issue links are deactivated globally
	 * - Issue link field is hidden in the global field configuration AND project type is CMP
	 */ const serverIssueLinksRoot = data.jira.issueByKey?.issueLinks;
    if (serverIssueLinksRoot == null) return undefined;
    /**
	 * Map of links containing the current issue's relation to the linked issue.
	 * Keyed with the issue link ID instead of the linked issue's ID since
	 * an individual issue can be linked multiple times. See `linkedIssueKeys`.
	 */ const issueLinks = {};
    const linkedIssueMetas = [];
    /**
	 * Map of the issues linked to the current issue; keyed with the linked issueKey.
	 * The linked issue data is transformed in a way that's usable for Bento.
	 * See `transformAggAssociatedIssueToLinkedIssue()`.
	 */ const linkedIssues = {};
    // Make sure we get unique keys only
    // `issueLinks` can have duplicate issues from different `relationName`s
    const linkedIssueKeys = new Set();
    const serverIssueLinks = serverIssueLinksRoot?.edges;
    if (serverIssueLinks != null) serverIssueLinks.forEach((edge)=>{
        if (edge?.node == null) return;
        const { node: node } = edge;
        const { issue: issue, issueLinkId: issueLinkId, relationName: relationName } = node;
        if (relationName && issue != null) {
            issueLinks[issueLinkId] = $c4d877d70f96d9fb$var$transformAggIssueLinkToIssueLink(node);
            linkedIssues[issue.key] = $c4d877d70f96d9fb$var$transformAggAssociatedIssueToLinkedIssue(issue);
            linkedIssueKeys.add((0, $6vrw7.toIssueKey)(issue.key));
            linkedIssueMetas.push({
                isResolved: issue.isResolved ?? false,
                issueKey: issue.key
            });
        }
    });
    return {
        issueLinks: issueLinks,
        linkedIssues: linkedIssues,
        linkedIssueKeys: [
            ...linkedIssueKeys
        ],
        linkedIssueMetas: linkedIssueMetas
    };
};

});
parcelRegister("aSsby", function(module, exports) {

$parcel$export(module.exports, "transformAggAssociatedIssueToAssociatedIssue", () => $2753d839c8fbc393$export$5a66ae5c0d3cd8dd);

var $8Qd0L = parcelRequire("8Qd0L");

var $9ax61 = parcelRequire("9ax61");
const $2753d839c8fbc393$export$5a66ae5c0d3cd8dd = (issue)=>{
    const fields = (0, $9ax61.transformAggFieldsToLegacyFields)(issue.fieldsById?.edges);
    const assignee = fields.assignee?.value;
    const issueType = fields.issuetype?.value;
    const priority = fields.priority?.value;
    const summary = fields.summary?.value;
    const status = fields.status?.value;
    return {
        id: issue.issueId,
        issueKey: issue.key,
        issueLink: issue.webUrl ?? '',
        issueSummary: summary || '',
        statusCategory: (0, $8Qd0L.statusCategoryForId)(status?.statusCategory?.id),
        statusCategoryId: status?.statusCategory?.id,
        statusName: status?.name,
        statusId: status?.id,
        issuePriorityUrl: priority?.iconUrl ?? null,
        issuePriorityName: priority?.name ?? null,
        issuePrioritySequence: priority?.sequence ?? null,
        issueTypeIconUrl: issueType?.iconUrl ?? null,
        issueTypeName: issueType?.name ?? null,
        assigneeDisplayName: assignee?.displayName || null,
        assigneeUrl: assignee?.avatarUrl || null
    };
};

});


parcelRegister("lyWeh", function(module, exports) {

$parcel$export(module.exports, "transformAggResponseToIssueLinkTypes", () => $49116321a7a8a008$export$98032ffcea31a034);

var $03XEB = parcelRequire("03XEB");
const $49116321a7a8a008$export$98032ffcea31a034 = (data)=>{
    const edges = data.jira.issueLinkTypes?.edges ?? [];
    return edges.reduce((issueLinkTypes, edge)=>{
        if (!edge?.node || !edge.node) return issueLinkTypes;
        const { linkTypeId: linkTypeId, inwards: inwards, outwards: outwards } = edge.node;
        if (inwards && inwards === outwards) issueLinkTypes.push({
            id: linkTypeId || '',
            label: inwards,
            direction: (0, $03XEB.BOTH_LINK_DIRECTION)
        });
        else {
            issueLinkTypes.push({
                id: linkTypeId || '',
                label: inwards || '',
                direction: (0, $03XEB.INWARD_LINK_DIRECTION)
            });
            issueLinkTypes.push({
                id: linkTypeId || '',
                label: outwards || '',
                direction: (0, $03XEB.OUTWARD_LINK_DIRECTION)
            });
        }
        return issueLinkTypes;
    }, []);
};

});

parcelRegister("8QoGX", function(module, exports) {

$parcel$export(module.exports, "transformAggResponseToLegacyChildIssues", () => $5e5477c8056995fa$export$844ce75db4ca7265);
$parcel$export(module.exports, "transformServerChildIssueFieldsToAssociatedIssues", () => $5e5477c8056995fa$export$61944e84696a1250);

var $1ybV0 = parcelRequire("1ybV0");

var $6vrw7 = parcelRequire("6vrw7");

var $lO4Or = parcelRequire("lO4Or");
var $edkGa = parcelRequire("edkGa");

var $9ax61 = parcelRequire("9ax61");

var $lWE99 = parcelRequire("lWE99");

var $4yflu = parcelRequire("4yflu");

var $s7Vui = parcelRequire("s7Vui");
const $5e5477c8056995fa$var$defaultChildrenIssueField = {
    value: [],
    renderedValue: null,
    editable: false,
    required: false,
    autoCompleteUrl: null,
    allowedValues: [],
    schema: {
        type: '',
        custom: null,
        system: null,
        configuration: null,
        items: null,
        renderer: null
    }
};
// The field title is hardcoded because we don't have a way to get it from the response and we don't use it in the UI.
const $5e5477c8056995fa$var$childIssueFieldDictOld = {
    [(0, $lO4Or.SUBTASKS_TYPE)]: {
        ...$5e5477c8056995fa$var$defaultChildrenIssueField,
        key: (0, $lO4Or.SUBTASKS_TYPE),
        title: 'Sub-tasks',
        schema: {
            ...$5e5477c8056995fa$var$defaultChildrenIssueField.schema,
            system: (0, $lO4Or.SUBTASKS_TYPE),
            items: 'issuelinks',
            type: 'array'
        }
    },
    [(0, $lO4Or.EPIC_ISSUES)]: {
        ...$5e5477c8056995fa$var$defaultChildrenIssueField,
        key: (0, $lO4Or.EPIC_ISSUES),
        title: 'Epic Issues',
        schema: {
            ...$5e5477c8056995fa$var$defaultChildrenIssueField.schema,
            custom: (0, $lO4Or.EPIC_ISSUES_CF_TYPE),
            type: 'issue-list'
        }
    },
    [(0, $lO4Or.CHILDREN_ISSUES)]: {
        ...$5e5477c8056995fa$var$defaultChildrenIssueField,
        key: (0, $lO4Or.CHILDREN_ISSUES),
        title: 'Children Issues',
        schema: {
            ...$5e5477c8056995fa$var$defaultChildrenIssueField.schema,
            custom: (0, $lO4Or.CHILDREN_ISSUES_CF_TYPE),
            type: (0, $lO4Or.CHILDREN_ISSUES)
        }
    },
    [(0, $lO4Or.PORTFOLIO_CHILD_ISSUES)]: {
        ...$5e5477c8056995fa$var$defaultChildrenIssueField,
        key: (0, $lO4Or.PORTFOLIO_CHILD_ISSUES),
        title: 'Child Issues',
        schema: {
            ...$5e5477c8056995fa$var$defaultChildrenIssueField.schema,
            custom: (0, $lO4Or.PORTFOLIO_ISSUES_CF_TYPE),
            type: (0, $lO4Or.PORTFOLIO_CHILD_ISSUES)
        }
    }
};
const $5e5477c8056995fa$var$childIssueFieldDictNew = {
    [(0, $lO4Or.SUBTASKS_TYPE)]: {
        ...$5e5477c8056995fa$var$defaultChildrenIssueField,
        key: (0, $lO4Or.SUBTASKS_TYPE),
        title: 'Sub-tasks',
        schema: {
            ...$5e5477c8056995fa$var$defaultChildrenIssueField.schema,
            system: (0, $lO4Or.SUBTASKS_TYPE),
            items: 'issuelinks',
            type: 'array'
        }
    },
    [(0, $lO4Or.CHILDREN_ISSUES)]: {
        ...$5e5477c8056995fa$var$defaultChildrenIssueField,
        key: (0, $lO4Or.CHILDREN_ISSUES),
        title: 'Children Issues',
        schema: {
            ...$5e5477c8056995fa$var$defaultChildrenIssueField.schema,
            custom: (0, $lO4Or.CHILDREN_ISSUES_CF_TYPE),
            type: (0, $lO4Or.CHILDREN_ISSUES)
        }
    }
};
const $5e5477c8056995fa$var$generateChildIssueFieldState = (// Change type to the New one (which should be renamed back not needing new) when cleaning up
// jira-issue-view_child-issue-panel-standardisation_76s8e
keys, mapper)=>{
    const childrenFieldState = {};
    const childIssueFieldDict = (0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e') ? $5e5477c8056995fa$var$childIssueFieldDictNew : $5e5477c8056995fa$var$childIssueFieldDictOld;
    keys.forEach((key)=>{
        childrenFieldState[key] = mapper ? mapper(childIssueFieldDict[key]) : childIssueFieldDict[key];
    });
    return childrenFieldState;
};
const $5e5477c8056995fa$export$844ce75db4ca7265 = (data, { issueHierarchyLevel: issueHierarchyLevel, isNextGenProject: isNextGenProject })=>{
    // Change type to the New one (which should be renamed back not needing new) when cleaning up
    // jira-issue-view_child-issue-panel-standardisation_76s8e
    // Determines which legacy children issues fields will be generated
    let childrenFieldStateKeys = [];
    const childIssueMeta = {};
    if ((0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e')) {
        if (isNextGenProject) childrenFieldStateKeys = [
            (0, $lO4Or.CHILDREN_ISSUES)
        ];
        else if (issueHierarchyLevel === (0, $edkGa.ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL) childrenFieldStateKeys = [];
        else if (issueHierarchyLevel === (0, $edkGa.ISSUE_TYPE_HIERARCHY_LEVEL).BASE_LEVEL) childrenFieldStateKeys = [
            (0, $lO4Or.SUBTASKS_TYPE)
        ];
        else childrenFieldStateKeys = [
            (0, $lO4Or.CHILDREN_ISSUES),
            (0, $lO4Or.SUBTASKS_TYPE)
        ];
    } else if (isNextGenProject) childrenFieldStateKeys = [
        (0, $lO4Or.CHILDREN_ISSUES)
    ];
    else {
        if (issueHierarchyLevel === (0, $edkGa.ISSUE_TYPE_HIERARCHY_LEVEL).BASE_LEVEL) childrenFieldStateKeys = [
            (0, $lO4Or.SUBTASKS_TYPE)
        ];
        if (issueHierarchyLevel === (0, $edkGa.ISSUE_TYPE_HIERARCHY_LEVEL).LEVEL_ONE) childrenFieldStateKeys = [
            (0, $lO4Or.SUBTASKS_TYPE),
            (0, $lO4Or.EPIC_ISSUES)
        ];
        // A custom hierarchy level issue type, which includes the classic portfolio issue type.
        if (issueHierarchyLevel > (0, $edkGa.ISSUE_TYPE_HIERARCHY_LEVEL).LEVEL_ONE) childrenFieldStateKeys = [
            (0, $lO4Or.SUBTASKS_TYPE)
        ];
    }
    const childrenIssuesResponse = data.jira.issueByKey?.childIssues;
    // If the childIssues response is null, issue does not have any children issues,
    // and we still need to return the children issue field with an empty value.
    if (!childrenIssuesResponse) return {
        fieldsState: $5e5477c8056995fa$var$generateChildIssueFieldState(childrenFieldStateKeys),
        childIssueMeta: childIssueMeta
    };
    if (childrenIssuesResponse.__typename === (0, $lO4Or.CHILDREN_EXCEEDING_LIMIT_GQL_FIELD)) {
        if ((0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e')) {
            if (isNextGenProject || issueHierarchyLevel > (0, $edkGa.ISSUE_TYPE_HIERARCHY_LEVEL).BASE_LEVEL) childrenFieldStateKeys = [
                (0, $lO4Or.CHILDREN_ISSUES)
            ];
            else if (issueHierarchyLevel === (0, $edkGa.ISSUE_TYPE_HIERARCHY_LEVEL).BASE_LEVEL) childrenFieldStateKeys = [
                (0, $lO4Or.SUBTASKS_TYPE)
            ];
        // Remove the subtasks field if the classic epic issue has too many children issues.
        } else if (!isNextGenProject && issueHierarchyLevel === (0, $edkGa.ISSUE_TYPE_HIERARCHY_LEVEL).LEVEL_ONE) childrenFieldStateKeys = [
            (0, $lO4Or.EPIC_ISSUES)
        ];
        return {
            fieldsState: $5e5477c8056995fa$var$generateChildIssueFieldState(childrenFieldStateKeys, (field)=>({
                    ...field,
                    issueLimitUrl: childrenIssuesResponse.search ?? ''
                })),
            childIssueMeta: childIssueMeta
        };
    }
    const subtasksValue = [];
    const childrenIssuesValue = [];
    const portfolioIssueValue = [];
    if (childrenIssuesResponse.__typename === (0, $lO4Or.CHILDREN_WITHIN_LIMIT_GQL_FIELD) && childrenIssuesResponse.issues?.edges != null) /**
		 * The child issue type conditional is inside the `forEach` call
		 * because it's possible for an issue to have different child issue types:
		 *   - CMP Portfolio issues can have portfolio child issues (epics) and subtasks
		 *   - CMP Epics can have epic child issues (base-level issues) and subtasks
		 */ childrenIssuesResponse.issues.edges.forEach((edge)=>{
        const issue = edge?.node;
        if (issue == null || issue.fieldsById?.edges == null) return;
        childIssueMeta[issue.key] = {
            isResolved: issue.isResolved ?? false
        };
        // Fields shape used by CMP subtasks and portfolio child issues
        const fieldsValueMap = {};
        // Fields shape used by TMP issues and CMP base-level issues
        const fields = [];
        issue.fieldsById.edges.forEach((fieldEdge)=>{
            const transformedField = fieldEdge?.node != null ? (0, $9ax61.transformAggFieldToLegacyField)(fieldEdge.node) : undefined;
            // It's cheaper to just consider both cases than to loop through the fields twice
            if (transformedField) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                fieldsValueMap[transformedField.key] = transformedField.value;
                fields.push(transformedField);
            }
        });
        const fieldValue = {
            id: issue.issueId,
            key: (0, $6vrw7.toIssueKey)(issue.key),
            self: issue.webUrl ?? ''
        };
        const childIssueHierarchyLevel = fieldsValueMap[0, $lO4Or.ISSUE_TYPE]?.hierarchyLevel;
        if (!isNextGenProject && childIssueHierarchyLevel === (0, $edkGa.ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL) // Child issue is a CMP subtask
        subtasksValue.push({
            ...fieldValue,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            fields: fieldsValueMap
        });
        else if (!(0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e') && !isNextGenProject && issueHierarchyLevel > (0, $edkGa.ISSUE_TYPE_HIERARCHY_LEVEL).LEVEL_ONE) portfolioIssueValue.push({
            ...fieldValue,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            fields: fieldsValueMap
        });
        else {
            let storyPointsField;
            // Child issue is a TMP issue
            if (isNextGenProject) storyPointsField = issue.storyPointEstimateField && (0, $lWE99.transformAggNumberToLegacyField)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issue.storyPointEstimateField);
            else // CMP base-level issue
            storyPointsField = issue.storyPointsField && (0, $lWE99.transformAggNumberToLegacyField)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issue.storyPointsField);
            if (storyPointsField != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            fields.push(storyPointsField);
            childrenIssuesValue.push({
                ...fieldValue,
                fields: fields,
                /**
					 * Hard-code these values because
					 *   - AGG does not return them
					 *   - Child issues UI does not use them anyway
					 */ agile: {},
                customFields: {
                    textareaAdf: []
                },
                systemFields: {}
            });
        }
    });
    // If there's a child issue with hierarchy LEVEL_ONE, generate a PORTFOLIO_CHILD_ISSUES field
    if (!(0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e') && portfolioIssueValue.length >= 1) childrenFieldStateKeys.push((0, $lO4Or.PORTFOLIO_CHILD_ISSUES));
    const fieldsState = $5e5477c8056995fa$var$generateChildIssueFieldState(childrenFieldStateKeys, (field)=>{
        if (field.key === (0, $lO4Or.SUBTASKS_TYPE)) return {
            ...field,
            value: subtasksValue
        };
        if (!(0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e') && field.key === (0, $lO4Or.PORTFOLIO_CHILD_ISSUES)) return {
            ...field,
            value: portfolioIssueValue
        };
        return {
            ...field,
            value: childrenIssuesValue
        };
    });
    return {
        fieldsState: fieldsState,
        childIssueMeta: childIssueMeta
    };
};
const $5e5477c8056995fa$export$61944e84696a1250 = (fields, { isTeamManagedProject: isTeamManagedProject, childIssueMeta: childIssueMeta })=>{
    // There can only be one of these children issue fields
    const childrenIssueField = (0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e') ? fields[0, $lO4Or.CHILDREN_ISSUES] : fields[0, $lO4Or.CHILDREN_ISSUES] ?? // CMP epic child issues -- base-level issues
    fields[0, $lO4Or.EPIC_ISSUES] ?? // CMP portfolio child issues -- epics
    fields[0, $lO4Or.PORTFOLIO_CHILD_ISSUES];
    const childrenIssueFieldKey = childrenIssueField?.key ?? '';
    const childrenIssueFieldValue = childrenIssueField?.value ?? [];
    let childrenIssues = [];
    if ((0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e')) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    childrenIssues = childrenIssueFieldValue.map((childIssue)=>(0, $s7Vui.toTopLevelChildrenIssues)(childIssue, childIssueMeta[childIssue.key]?.isResolved ?? false, isTeamManagedProject));
    else if (childrenIssueFieldKey === (0, $lO4Or.CHILDREN_ISSUES) || childrenIssueFieldKey === (0, $lO4Or.EPIC_ISSUES)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    childrenIssues = childrenIssueFieldValue.map((childIssue)=>(0, $s7Vui.toTopLevelChildrenIssues)(childIssue, childIssueMeta[childIssue.key]?.isResolved ?? false, isTeamManagedProject));
    else if (childrenIssueFieldKey === (0, $lO4Or.PORTFOLIO_CHILD_ISSUES)) childrenIssues = childrenIssueFieldValue.map((childIssue)=>(0, $4yflu.toTopLevelAssociatedIssue)(childIssue, childIssueMeta[childIssue.key]?.isResolved ?? false));
    // There can be a separate `subtasks` field in addition to `childrenIssues`
    const subtasks = (fields[0, $lO4Or.SUBTASKS_TYPE]?.value ?? []).map((childIssue)=>(0, $4yflu.toTopLevelAssociatedIssue)(childIssue, childIssueMeta[childIssue.key]?.isResolved ?? false));
    return {
        childrenIssues: childrenIssues,
        subtasks: subtasks
    };
};

});
parcelRegister("4yflu", function(module, exports) {

$parcel$export(module.exports, "toTopLevelAssociatedIssue", () => $59dd9f06e509bb7f$export$ef6063bef822b84f);

var $8Qd0L = parcelRequire("8Qd0L");
const $59dd9f06e509bb7f$export$ef6063bef822b84f = (subtask, isResolved)=>({
        id: subtask.id,
        issueLink: subtask.self,
        issueTypeIconUrl: subtask.fields.issuetype?.iconUrl,
        issueTypeName: subtask.fields.issuetype?.name,
        issuePriorityUrl: subtask.fields.priority?.iconUrl ?? undefined,
        issuePrioritySequence: subtask.fields.priority?.sequence ?? undefined,
        issuePriorityName: subtask.fields.priority?.name ?? undefined,
        issueKey: subtask.key,
        issueSummary: subtask.fields.summary,
        statusCategory: (0, $8Qd0L.statusCategoryForId)(subtask.fields.status?.statusCategory?.id),
        statusCategoryId: subtask.fields.status?.statusCategory?.id,
        statusId: subtask.fields.status?.id,
        statusName: subtask.fields.status?.name,
        isLoading: false,
        hasError: false,
        assigneeUrl: subtask.fields.assignee?.avatarUrls['48x48'] ?? null,
        assigneeDisplayName: subtask.fields.assignee?.displayName ?? null,
        issueTimeTracking: subtask.fields.timetracking,
        isResolved: isResolved
    });

});

parcelRegister("s7Vui", function(module, exports) {

$parcel$export(module.exports, "toTopLevelChildrenIssues", () => $91ca4b40342d3d1d$export$ffac25833a1d6836);

var $8Qd0L = parcelRequire("8Qd0L");

var $lO4Or = parcelRequire("lO4Or");
const $91ca4b40342d3d1d$export$ffac25833a1d6836 = (childrenIssues, isResolved, isSimplifiedProject)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const systemFields = {};
    const storyPointsType = isSimplifiedProject ? (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE) : (0, $lO4Or.STORY_POINTS_TYPE);
    let storyPointsField;
    childrenIssues.fields.forEach((field)=>{
        if (field.schema.system !== null) systemFields[field.schema.system] = field.value;
        if (field.schema.custom === storyPointsType) storyPointsField = field;
    });
    return {
        id: childrenIssues.id,
        issueLink: childrenIssues.self,
        issueTypeIconUrl: systemFields.issuetype?.iconUrl,
        issueTypeName: systemFields.issuetype?.name,
        issuePriorityUrl: systemFields.priority?.iconUrl ?? undefined,
        issuePriorityName: systemFields.priority?.name ?? undefined,
        issuePrioritySequence: systemFields.priority?.sequence ?? undefined,
        issueKey: childrenIssues.key,
        issueSummary: systemFields.summary,
        statusCategory: (0, $8Qd0L.statusCategoryForId)(systemFields.status?.statusCategory?.id),
        statusCategoryId: systemFields.status?.statusCategory?.id,
        statusId: systemFields.status?.id,
        statusName: systemFields.status?.name,
        isLoading: false,
        hasError: false,
        assigneeUrl: systemFields.assignee?.avatarUrls['48x48'] ?? null,
        assigneeDisplayName: systemFields.assignee?.displayName ?? null,
        issueTimeTracking: systemFields.timetracking,
        estimateFieldId: storyPointsField?.key ?? undefined,
        estimateValue: storyPointsField?.value ?? undefined,
        isResolved: isResolved,
        ...systemFields.created && {
            created: new Date(systemFields.created)
        },
        ...systemFields.updated && {
            updated: new Date(systemFields.updated)
        }
    };
};

});


parcelRegister("bei0E", function(module, exports) {

$parcel$export(module.exports, "transformAggResponseToTimeTrackingConfig", () => $9582fac63e52d5b9$export$df324310dbdd82aa);

var $h9cCP = parcelRequire("h9cCP");
const $9582fac63e52d5b9$export$df324310dbdd82aa = (data)=>{
    const timeTrackingAGG = data.jira.globalTimeTrackingSettings;
    if (!timeTrackingAGG) return 0, $h9cCP.defaultTimeTrackingConfiguration;
    const { isJiraConfiguredTimeTrackingEnabled: isJiraConfiguredTimeTrackingEnabled, workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: defaultFormat, defaultUnit: defaultUnit } = timeTrackingAGG;
    return {
        isTimeTrackingEnabled: isJiraConfiguredTimeTrackingEnabled || (0, $h9cCP.defaultTimeTrackingConfiguration).isTimeTrackingEnabled,
        hoursPerDay: workingHoursPerDay || (0, $h9cCP.defaultTimeTrackingConfiguration).hoursPerDay,
        daysPerWeek: workingDaysPerWeek || (0, $h9cCP.defaultTimeTrackingConfiguration).daysPerWeek,
        format: defaultFormat ? defaultFormat.toLowerCase() : (0, $h9cCP.defaultTimeTrackingConfiguration).format,
        defaultUnit: defaultUnit ? defaultUnit.toLowerCase() : (0, $h9cCP.defaultTimeTrackingConfiguration).defaultUnit
    };
};

});

parcelRegister("lvsGR", function(module, exports) {

$parcel$export(module.exports, "transformAggUserPreferencesToLegacyGira", () => $eb9b617bb68ee1f3$export$2e21c214d7fefeee);

var $gUUjF = parcelRequire("gUUjF");
/**
 * The logic for the following transformations is based on the AGG data fetchers that can be found in this directory:
 * https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-plugins/jira-graphql/issue-view-data-fetchers/core/src/main/java/com/atlassian/jira/graphql/gira/userpreferences
 */ const $eb9b617bb68ee1f3$var$logError = (msg)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('issue.agg-field-transformers.my-preferences', msg);
const $eb9b617bb68ee1f3$var$toDismissedOrNull = (aggValue)=>aggValue ? 'dismissed' : null;
const $eb9b617bb68ee1f3$var$toBoolStrOrNull = (aggValue)=>{
    switch(aggValue){
        case true:
            return 'true';
        case false:
            return 'false';
        default:
            return null;
    }
};
// Returns null if input is not a valid timestamp
const $eb9b617bb68ee1f3$var$tryParseTimestamp = (timestampStr)=>{
    const parsed = Date.parse(timestampStr);
    return Number.isNaN(parsed) ? null : parsed.toString();
};
const $eb9b617bb68ee1f3$var$toLegacyPinnedFieldsBannerLastInteracted = (aggIsDismissed, aggLastInteracted)=>{
    if (aggIsDismissed === null && aggLastInteracted === null) return null;
    if (aggIsDismissed === true) return 'jira.user.issue.pinned-fields-banner.user_hidden_action';
    if (aggLastInteracted) {
        const timestampOrNull = $eb9b617bb68ee1f3$var$tryParseTimestamp(aggLastInteracted);
        timestampOrNull || $eb9b617bb68ee1f3$var$logError(`Couldn't parse timestamp string for pinned fields banner last interacted: '${aggLastInteracted}'`);
        return timestampOrNull;
    }
    $eb9b617bb68ee1f3$var$logError('Expected aggLastInteracted to be a non-empty string');
    return null;
};
const $eb9b617bb68ee1f3$var$toLegacyAttachmentViewMode = (aggValue)=>{
    switch(aggValue){
        case 'LIST_VIEW':
            return 'list-view';
        case 'STRIP_VIEW':
            return 'strip-view';
        default:
            return null;
    }
};
const $eb9b617bb68ee1f3$var$toLegacyTimestampDisplayMode = (aggValue)=>{
    switch(aggValue){
        case 'ABSOLUTE':
        case 'RELATIVE':
            return aggValue;
        default:
            return null;
    }
};
const $eb9b617bb68ee1f3$export$2e21c214d7fefeee = (aggResponse, projectKey)=>{
    const aggUserPrefs = aggResponse.jira.userPreferences;
    if (!aggUserPrefs) return undefined;
    // @ts-expect-error - Type '{ [x: string]: string | null | undefined; 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed': "dismissed" | null; ... 4 more ...; 'jira.user.issue.details.timestamp-display-setting': "RELATIVE" | ... 1 more ... | null; }' is not assignable to type 'MyPreferences'.
    return {
        'jira.user.issue.child-issues-limit.best-practice-flag.dismissed': $eb9b617bb68ee1f3$var$toDismissedOrNull(// @ts-expect-error - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean | null'.
        aggUserPrefs.isIssueViewChildIssuesLimitBestPracticeFlagDismissed),
        'jira.user.issue.filter.hide-done-subtasks': $eb9b617bb68ee1f3$var$toBoolStrOrNull(// @ts-expect-error - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean | null'.
        aggUserPrefs.isIssueViewHideDoneChildIssuesFilterEnabled),
        'jira.user.issue.pinned-fields-banner.lastinteracted': $eb9b617bb68ee1f3$var$toLegacyPinnedFieldsBannerLastInteracted(// @ts-expect-error - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean | null'.
        aggUserPrefs.isIssueViewPinnedFieldsBannerDismissed, aggUserPrefs.issueViewPinnedFieldsBannerLastInteracted),
        'jira.user.issue.attachment.view': $eb9b617bb68ee1f3$var$toLegacyAttachmentViewMode(// @ts-expect-error - Argument of type 'JiraIssueViewAttachmentPanelViewMode | null | undefined' is not assignable to parameter of type 'JiraIssueViewAttachmentPanelViewMode | null'.
        aggUserPrefs.issueViewAttachmentPanelViewMode),
        [`jira.user.issue.details.pinned-fields.${projectKey}`]: aggUserPrefs.issueViewPinnedFields,
        'jira.user.issue.sidebar.resize-ratio': aggUserPrefs.issueViewSidebarResizeRatio,
        'jira.user.issue.details.timestamp-display-setting': $eb9b617bb68ee1f3$var$toLegacyTimestampDisplayMode(// @ts-expect-error - Argument of type 'JiraIssueViewTimestampDisplayMode | null | undefined' is not assignable to parameter of type 'JiraIssueViewTimestampDisplayMode | null'.
        aggUserPrefs.issueViewTimestampDisplayMode)
    };
};

});

parcelRegister("hG5lo", function(module, exports) {

$parcel$export(module.exports, "transformAggUserPreferencesToLegacyGiraActivityFeedSortOrder", () => $3f6ca82211b5753b$export$81b38806ea980dc);

var $gUUjF = parcelRequire("gUUjF");
const $3f6ca82211b5753b$export$81b38806ea980dc = (aggResponse)=>{
    const aggValue = aggResponse.jira.userPreferences?.issueViewActivityFeedSortOrder;
    switch(aggValue){
        case 'NEWEST_FIRST':
        case 'OLDEST_FIRST':
            return aggValue;
        default:
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.agg-field-transformers.activity-sort-order', `Unsupported activity sort order: ${aggValue}`);
            return 'NEWEST_FIRST';
    }
};

});


parcelRegister("eECgD", function(module, exports) {

$parcel$export(module.exports, "withRetries2", () => $d80c5895679adf67$export$1417ddefb1281391);
parcelRequire("dpYY5");
/*
 * Warning - pushing this to 3 seems to fail the bitbucket tests
 * in the 'when the user does not have a valid Jira session' block -
 * it causes the issue to be rendered and the expected behaviour of
 * showing 'Log In' not to happen
 */ const $d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS = 2;
const $d80c5895679adf67$export$1417ddefb1281391 = (o0, o1)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o0.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o1.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS)
    ];
const $d80c5895679adf67$export$24aa3883e56840ae = (o0, o1, o2)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o0.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o1.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o2.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS)
    ];
const $d80c5895679adf67$export$b00bddafdf4c470f = (o0, o1, o2, o3)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o0.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o1.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o2.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o3.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS)
    ];
const $d80c5895679adf67$export$4ab259186ff3a585 = (o0, o1, o2, o3, o4, o5)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o0.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o1.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o2.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o3.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o4.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o5.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS)
    ];
const $d80c5895679adf67$export$adc94963d31f2b36 = (o0, o1, o2, o3, o4, o5, o6, o7, o8)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o0.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o1.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o2.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o3.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o4.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o5.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o6.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o7.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o8.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS)
    ];
const $d80c5895679adf67$export$a8e3b6cd128984c2 = (o0, o1, o2, o3, o4, o5, o6, o7, o8, o9, o10)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o0.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o1.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o2.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o3.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o4.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o5.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o6.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o7.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o8.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o9.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o10.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS)
    ];
const $d80c5895679adf67$export$6e750cd61cdd6490 = (o0, o1, o2, o3, o4, o5, o6, o7, o8, o9, o10, o11, o12, o13)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o0.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o1.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o2.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o3.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o4.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o5.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o6.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o7.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o8.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o9.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o10.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o11.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o12.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        o13.retry($d80c5895679adf67$var$DEFAULT_RETRY_ATTEMPTS)
    ];

});

parcelRegister("elwy3", function(module, exports) {

$parcel$export(module.exports, "fetchAggData", () => $25a8cb800d463cd0$export$b44a1d3535ec02f2);
parcelRequire("9u6v2");

var $3JafE = parcelRequire("3JafE");


var $gUUjF = parcelRequire("gUUjF");

var $7EhAs = parcelRequire("7EhAs");

var $1Shgg = parcelRequire("1Shgg");

var $9CSL7 = parcelRequire("9CSL7");

var $cSEXi = parcelRequire("cSEXi");

var $7EzIJ = parcelRequire("7EzIJ");

var $7PTrm = parcelRequire("7PTrm");

var $amu7D = parcelRequire("amu7D");

var $dgVEl = parcelRequire("dgVEl");

const $25a8cb800d463cd0$var$getErrorMessage = (defaultMessage, errors)=>errors ? JSON.stringify((0, $dgVEl.makeErrorObject)(errors, (0, $cSEXi.AGG_ISSUE_ERROR_ANALYTICS))) : defaultMessage;
const $25a8cb800d463cd0$export$958208cfd7e3e324 = (event)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fetch.agg', 'Something went wrong when fetching data from AGG', event);
const $25a8cb800d463cd0$export$b44a1d3535ec02f2 = async (issueKey, cloudId, prefetchedResource)=>{
    const response = (0, $7EzIJ.fallbackOnMissingOrError$)(prefetchedResource, ()=>(0, $3JafE.Observable).from((0, $1Shgg.default)(issueKey, cloudId, (0, $amu7D.default)))).toPromise();
    const { data: data, errors: errors, traceId: traceId } = await response;
    if (!data?.jira) {
        // We didn't get any data in the response at all - this is very bad
        const message = $25a8cb800d463cd0$var$getErrorMessage((0, $34523b01fc9ff8cb$export$86f3279fb6dcf675), errors);
        throw new (0, $7PTrm.IssueViewFetchError)(new Error(message), (0, $9CSL7.ISSUE_AGG_OPERATION_NAME), traceId);
    }
    if (!data.jira.issueByKey) {
        const message = $25a8cb800d463cd0$var$getErrorMessage((0, $34523b01fc9ff8cb$export$7254e709e6a23602), errors);
        const dataFetchException = errors?.find((error)=>error?.extensions?.classification === 'DataFetchingException');
        const error = dataFetchException?.extensions ? new (0, $7EhAs.default)(dataFetchException.extensions.statusCode, message) : new Error(message);
        throw new (0, $7PTrm.IssueViewFetchError)(error, (0, $9CSL7.ISSUE_AGG_OPERATION_NAME), traceId);
    }
    if (data.jira.issueByKey?.errorRetrievingData === true) {
        const message = $25a8cb800d463cd0$var$getErrorMessage((0, $34523b01fc9ff8cb$export$7fc8281e50ec77bd), errors);
        throw new (0, $7PTrm.IssueViewFetchError)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$e813cd7045fcc98d), message), (0, $9CSL7.ISSUE_AGG_OPERATION_NAME), traceId);
    }
    if (data && errors && errors.length > 0) $25a8cb800d463cd0$export$958208cfd7e3e324((0, $dgVEl.makeErrorObject)(errors, (0, $cSEXi.AGG_ISSUE_ERROR_ANALYTICS)));
    return data;
};

});
const $34523b01fc9ff8cb$export$86f3279fb6dcf675 = 'Failed to fetch issue data from AGG, got empty data';
const $34523b01fc9ff8cb$export$7254e709e6a23602 = 'Failed to fetch issue data from AGG, got empty issue value';
const $34523b01fc9ff8cb$export$7fc8281e50ec77bd = 'Failed to fetch issue data from AGG, got errorRetrievingData equals true';


parcelRegister("2aapS", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $7a3c9e71b2f174e5$export$3ceb62baab058c6b);
$parcel$export(module.exports, "fetchAllGiraData", () => $7a3c9e71b2f174e5$export$4b07a70f940c167a);
$parcel$export(module.exports, "fetchDynamicGiraData", () => $7a3c9e71b2f174e5$export$58c1632eb78527d8);

var $kd0cS = parcelRequire("kd0cS");

var $3JafE = parcelRequire("3JafE");
parcelRequire("cpH8E");


var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $7EhAs = parcelRequire("7EhAs");

var $gIOVj = parcelRequire("gIOVj");

var $3l0Oz = parcelRequire("3l0Oz");
var $kXzsJ = parcelRequire("kXzsJ");

var $7EzIJ = parcelRequire("7EzIJ");

var $7PTrm = parcelRequire("7PTrm");

var $4lee3 = parcelRequire("4lee3");

var $4z02k = parcelRequire("4z02k");

var $dgVEl = parcelRequire("dgVEl");

var $cFK3w = parcelRequire("cFK3w");

var $haB9x = parcelRequire("haB9x");

var $bNnKs = parcelRequire("bNnKs");

var $5Q5XX = parcelRequire("5Q5XX");

var $joqQr = parcelRequire("joqQr");

var $31HOS = parcelRequire("31HOS");

var $gHr1k = parcelRequire("gHr1k");

var $hAAuM = parcelRequire("hAAuM");

var $b7ISA = parcelRequire("b7ISA");

var $15355 = parcelRequire("15355");

var $aPZET = parcelRequire("aPZET");

var $cwRsr = parcelRequire("cwRsr");
const $7a3c9e71b2f174e5$var$GIRA_AGG_MIGRATION_ISARCHIVED_FLAG = 'issue.details.gira-agg-migration-isarchived';
// forcing type to stop exponential inference with 2 unions
const $7a3c9e71b2f174e5$var$transformMediaTokens = (mediaContext)=>// @ts-expect-error - TS2322 - Type 'MediaContext | {}' is not assignable to type 'MediaContext'.
    mediaContext ? (0, $hAAuM.transformData)(mediaContext) : {};
const $7a3c9e71b2f174e5$var$getIsOldValueReturned = (flagKey)=>!(0, $4lee3.getIsNewValueReturned)(flagKey);
const $7a3c9e71b2f174e5$export$3ceb62baab058c6b = (data, isConsistencyCheck = false)=>{
    const { viewIssue: viewIssue, jira: jira, jiraSettings: jiraSettings, permissions: permissions, mediaContext: mediaContext, project: project } = data;
    // If this transform is for the consistency check, we include slices if they have vaue 'CHECK' or 'CHECK_RETURN_NEW'
    // If this transform is for the issue view, we include slices if they have vaue 'OLD' or 'CHECK'
    const shouldIncludeSlice = isConsistencyCheck ? (0, $4lee3.getIsConsistencyCheckEnabled) : $7a3c9e71b2f174e5$var$getIsOldValueReturned;
    return {
        /*
		 *  Do not add feature-flagged spread at the top
		 *  It would break flow check
		 */ ...(0, $1ybV0.ff)('issue.details.gira-agg-migration-attachments_ecebe') ? {} : (0, $haB9x.transformData)(viewIssue),
        ...(0, $bNnKs.transformData)(viewIssue),
        ...(0, $cwRsr.transformData)(viewIssue),
        ...(0, $5Q5XX.transformData)(jira, viewIssue),
        ...(0, $31HOS.transformData)(jiraSettings),
        ...(0, $b7ISA.transformData)(permissions, viewIssue, jira),
        ...(0, $15355.transformData)(project),
        ...shouldIncludeSlice($7a3c9e71b2f174e5$var$GIRA_AGG_MIGRATION_ISARCHIVED_FLAG) ? {
            isArchived: (0, $gHr1k.getIsArchived)(viewIssue)
        } : {},
        ...$7a3c9e71b2f174e5$var$transformMediaTokens(mediaContext),
        ...(0, $aPZET.transformData)(viewIssue),
        containersByType: viewIssue.containersByType,
        ...(0, $1ybV0.ff)('issue.details.gira-agg-migration-attachments_ecebe') ? (0, $cFK3w.transformData)(viewIssue) : {}
    };
};
const $7a3c9e71b2f174e5$var$transformDynamicData = (data)=>{
    const { viewIssue: viewIssue, jira: jira, jiraSettings: jiraSettings, activitySortOrder: activitySortOrder } = data;
    return {
        ...viewIssue && viewIssue.comments && (0, $bNnKs.transformData)(viewIssue),
        ...viewIssue && (0, $5Q5XX.transformData)(jira, viewIssue),
        ...(0, $31HOS.transformTimeTrackingData)(jiraSettings),
        activitySortOrder: activitySortOrder
    };
};
const $7a3c9e71b2f174e5$export$4b07a70f940c167a = async (baseUrl, issueKey, prefetchedResource, issueContextActions)=>{
    const response = (0, $7EzIJ.fallbackOnMissingOrError$)(prefetchedResource, ()=>(0, $3JafE.Observable).fromPromise((0, $3l0Oz.default)(baseUrl, issueKey))).toPromise();
    const { data: data, errors: errors } = await response;
    if (!data) {
        // No data at all, not good
        const message = errors ? JSON.stringify((0, $dgVEl.makeErrorObject)(errors)) : 'No data returned from graphql call';
        throw new (0, $7PTrm.IssueViewFetchError)(new Error(message), (0, $gIOVj.ISSUE_VIEW_INTERACTIVE_QUERY));
    }
    if (data && errors) // log errors for partial data
    (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fetch.gira', 'Failed to fetch some data from gira', (0, $dgVEl.makeErrorObject)(errors));
    if (!data.viewIssue) {
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify((0, $dgVEl.makeErrorObject)(errors));
            // if `viewIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $7PTrm.IssueViewFetchError)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$e813cd7045fcc98d), `Call to gira returned empty viewIssue with errors: ${errorMessage}`), (0, $gIOVj.ISSUE_VIEW_INTERACTIVE_QUERY));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $7PTrm.IssueViewFetchError)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$8bca792d963eb0ef), 'Call to gira returned empty viewIssue'), (0, $gIOVj.ISSUE_VIEW_INTERACTIVE_QUERY));
    }
    if ((0, $4z02k.isGiraAGGConsistencyCheckEnabled)()) issueContextActions?.mergeIssueContext({
        legacyGiraResponse: (0, (/*@__PURE__*/$parcel$interopDefault($kd0cS)))(data)
    });
    return $7a3c9e71b2f174e5$export$3ceb62baab058c6b(data);
};
const $7a3c9e71b2f174e5$export$58c1632eb78527d8 = async (baseUrl, issueKey, dynamicIssueQueryParams)=>{
    const response = await (0, $kXzsJ.getClient)(baseUrl).query({
        query: (0, $joqQr.buildDynamicIssueQuery)(dynamicIssueQueryParams),
        variables: {
            issueKey: issueKey
        }
    });
    const { data: data, errors: errors } = response;
    if (!data) {
        // No data at all, not good
        const message = errors ? JSON.stringify((0, $dgVEl.makeErrorObject)(errors)) : 'No data returned from graphql call for dynamic data';
        throw new Error(message);
    }
    if (data && errors) // log errors for partial data
    (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fetch.gira.dynamic', 'Failed to fetch some data from gira for dynamic data fetch', (0, $dgVEl.makeErrorObject)(errors));
    // @ts-expect-error - TS2345 - Argument of type 'DynamicGraphQlData' is not assignable to parameter of type 'GraphQlData'.
    return $7a3c9e71b2f174e5$var$transformDynamicData(data);
};

});
parcelRegister("cFK3w", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $69568279e33a7fbd$export$3ceb62baab058c6b);
const $69568279e33a7fbd$export$3ceb62baab058c6b = (issue)=>({
        totalAttachmentsCount: issue.totalAttachmentsCount || 0
    });

});

parcelRegister("haB9x", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $d6c314f2992f3aae$export$3ceb62baab058c6b);
const $d6c314f2992f3aae$export$3ceb62baab058c6b = (issue)=>({
        attachments: issue.attachments
    });

});

parcelRegister("5Q5XX", function(module, exports) {

$parcel$export(module.exports, "getGlancesQuery", () => $522b77638b95d1f8$export$ca7e7bf9f1b931a2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $522b77638b95d1f8$export$92c9a3dc7076af51);
$parcel$export(module.exports, "transformData", () => $522b77638b95d1f8$export$3ceb62baab058c6b);

var $6ZDS2 = parcelRequire("6ZDS2");

var $lzTt0 = parcelRequire("lzTt0");

var $1ybV0 = parcelRequire("1ybV0");

var $7C4za = parcelRequire("7C4za");
parcelRequire("gIOVj");
var $gIud4 = parcelRequire("gIud4");

var $duMa0 = parcelRequire("duMa0");

var $axK6P = parcelRequire("axK6P");

const $522b77638b95d1f8$export$ca7e7bf9f1b931a2 = ()=>(0, $e2450e7ea7ab7e1e$export$533eabbfe4c17c3a);
const $522b77638b95d1f8$export$92c9a3dc7076af51 = ()=>(0, $e2450e7ea7ab7e1e$export$368355c015cbda00);
const $522b77638b95d1f8$export$71eec30d9db46a56 = ()=>(0, $gIud4.getEcosystemQuery)();
const $522b77638b95d1f8$export$bdafa6b589be8b30 = 'issue.content.panel.customised.flag';
const $522b77638b95d1f8$var$transformForgePanels = (ecosystem)=>{
    const forgePanels = ecosystem.forge ? (0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))((ecosystem.forge.panels || []).map((props)=>{
        const { id: id, instances: instances } = props;
        return (Array.isArray(instances) ? instances : []).filter(({ added: added })=>(0, (/*@__PURE__*/$parcel$interopDefault($lzTt0)))(added)).map(({ added: added, id: panelInstanceId, collapsed: collapsed })=>({
                key: (0, $7C4za.toForgeKeyFromExtensionId)(id, panelInstanceId, added),
                collapsed: collapsed || false
            }));
    })) : [];
    return {
        forgeCollapsedPanels: forgePanels.filter(({ collapsed: collapsed })=>collapsed).map(({ key: key })=>key),
        forgePanelsKeys: forgePanels.map(({ key: key })=>key)
    };
};
const $522b77638b95d1f8$export$6c1633f0f997ae7f = {
    ecosystem: {},
    issueContentPanels: undefined,
    forgeIssueProperties: {
        collapsedPanels: undefined
    }
};
const $522b77638b95d1f8$export$3ceb62baab058c6b = (jira, issue)=>{
    if (!issue?.ecosystem) return $522b77638b95d1f8$export$6c1633f0f997ae7f;
    const { ecosystem: ecosystem, glancesField: glancesField, legacyRightWebPanels: legacyRightWebPanels } = issue;
    const glances = glancesField ? glancesField.value.map((glance)=>({
            ...glance,
            status: glance.status ? JSON.parse(glance.status) : null
        })) : [];
    const contextPanels = ecosystem.contextPanels ? ecosystem.contextPanels.map((contextPanel)=>({
            ...contextPanel,
            status: contextPanel.status ? JSON.parse(contextPanel.status) : null
        })) : [];
    const { forgeCollapsedPanels: forgeCollapsedPanels, forgePanelsKeys: forgePanelsKeys } = $522b77638b95d1f8$var$transformForgePanels(ecosystem);
    const contentPanelsCustomisedFlag = issue.hasCustomisedContentPanels ? [
        $522b77638b95d1f8$export$bdafa6b589be8b30
    ] : [];
    const safeContentPanels = {
        contentPanels: issue.contentPanels ?? {
            edges: []
        },
        legacyContentPanels: issue.legacyContentPanels ?? {
            edges: []
        }
    };
    // Convert the nullable ecosystem type received from '/gira' into a non-nullable type expected by the transformer
    const safeEcosystem = {
        ...safeContentPanels,
        ...!(0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? {
            operations: ecosystem.operations ?? []
        } : null,
        ...!(0, $1ybV0.ff)('issue-view-remove-activitypanels-from-critical-fetch_43ozj') ? {
            activityPanels: ecosystem.activityPanels ?? []
        } : null,
        ...!(0, $1ybV0.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on') ? {
            backgroundScripts: ecosystem.backgroundScripts ?? []
        } : null,
        // ecoSystemOnDate can only ever be returned as `null` when the server errors out. In that scenario, we assign
        // the value of this field to 0. As a result, contentPanels won't be displayed by default for fields that
        // were created pre-Bento. It's not the best user experience, but at least they won't get an error.
        ecoSystemOnDate: jira?.ecosystemFirstSeenOnIssueView ? new Date(jira.ecosystemFirstSeenOnIssueView).getTime() : 0,
        contentPanelsCustomised: issue.hasCustomisedContentPanels ?? false
    };
    const manuallyAddedToIssuePanelKeys = [];
    const addManuallyAddedPanelKeyToList = (edge, _index, _array)=>{
        if (edge?.node?.wasManuallyAddedToIssue) manuallyAddedToIssuePanelKeys.push(`${edge.node.addonKey}_${(0, $duMa0.removeTimestamp)(edge.node.moduleKey || '')}`);
    };
    safeEcosystem.contentPanels.edges?.forEach(addManuallyAddedPanelKeyToList);
    safeEcosystem.legacyContentPanels.edges?.forEach(addManuallyAddedPanelKeyToList);
    return {
        ecosystem: (0, $axK6P.transformEcosystemExtensions)({
            ...safeEcosystem,
            glances: glances,
            legacyRightWebPanels: legacyRightWebPanels,
            contextPanels: contextPanels,
            canInstallAddons: false
        }),
        issueContentPanels: [
            ...forgePanelsKeys,
            ...manuallyAddedToIssuePanelKeys,
            ...contentPanelsCustomisedFlag
        ],
        forgeIssueProperties: {
            collapsedPanels: forgeCollapsedPanels
        }
    };
};

});
parcelRegister("axK6P", function(module, exports) {

$parcel$export(module.exports, "convertIconUrlToAbsolute", () => $e5fe18c0543825a4$export$143755e8fd978b9a);
$parcel$export(module.exports, "transformEcosystemExtensions", () => $e5fe18c0543825a4$export$6c01ea8a90a2c903);

var $1ybV0 = parcelRequire("1ybV0");
const $e5fe18c0543825a4$export$143755e8fd978b9a = (addonBaseUrl, iconUrl)=>!iconUrl.includes('http') ? addonBaseUrl + iconUrl : iconUrl;
/**
 * Attempts to convert the status icon url to an absolute url icon. It has a lot of guarding as the GlanceStatus
 * comes from jira entity properties, and they have no validated object so anything is possible.
 *
 * @param addonBaseUrl The addon base url of the app
 * @param status the status of the app, comes from jira entity properties and is updated by the app
 */ const $e5fe18c0543825a4$var$convertStatusIconUrlToAbsolute = (addonBaseUrl, status)=>{
    if (status && status.type === 'icon' && status.value && status.value.label) {
        const convertedStatus = {
            ...status
        };
        if (convertedStatus.value !== undefined) convertedStatus.value.label = $e5fe18c0543825a4$export$143755e8fd978b9a(addonBaseUrl, status.value.label);
        return convertedStatus;
    }
    return status;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e5fe18c0543825a4$var$arrayToTreeReducer = (extensions, currentValue)=>{
    const addonKey = Object.keys(currentValue)[0];
    const aggregated = {
        ...extensions,
        [addonKey]: {
            ...currentValue[addonKey],
            ...extensions[addonKey]
        }
    };
    return aggregated;
};
const $e5fe18c0543825a4$export$92b010dbb91b5a57 = (serverOptions)=>typeof serverOptions === 'string' ? JSON.parse(serverOptions) : serverOptions;
const $e5fe18c0543825a4$var$transformGlances = (serverGlances = [])=>serverGlances.filter((serverGlance)=>(0, $1ybV0.ff)('issue-view-unlink-glancefield-from-ui_8a5yg') ? serverGlance.type === 'WEB_PANEL' // FF on - take only Web Panels
         : true).map((serverGlance)=>({
            [serverGlance.iframe.addonKey]: {
                [serverGlance.iframe.moduleKey]: {
                    name: serverGlance.name,
                    appKey: serverGlance.iframe.addonKey,
                    moduleKey: serverGlance.iframe.moduleKey,
                    options: $e5fe18c0543825a4$export$92b010dbb91b5a57(serverGlance.iframe.options),
                    icon: serverGlance.icon && {
                        url: serverGlance.icon.url
                    },
                    label: {
                        type: 'text',
                        value: serverGlance.content || serverGlance.name
                    },
                    status: $e5fe18c0543825a4$var$convertStatusIconUrlToAbsolute($e5fe18c0543825a4$export$92b010dbb91b5a57(serverGlance.iframe.options).origin, serverGlance.status),
                    type: serverGlance.type
                }
            }
        })) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce($e5fe18c0543825a4$var$arrayToTreeReducer, {});
const $e5fe18c0543825a4$var$transformLegacyRightWebPanelsAsGlances = (serverLegacyRightWebPanels = {
    edges: []
})=>(serverLegacyRightWebPanels.edges ?? []).map((edge)=>{
        if (!edge?.node?.addonKey || !edge?.node?.moduleKey) return {};
        return {
            [edge.node.addonKey]: {
                [edge.node.moduleKey]: {
                    name: edge?.node?.name,
                    appKey: edge.node.addonKey,
                    moduleKey: edge.node.moduleKey,
                    options: $e5fe18c0543825a4$export$92b010dbb91b5a57(edge?.node?.options),
                    icon: edge?.node?.iconUrl && {
                        url: edge?.node?.iconUrl
                    },
                    label: {
                        type: 'text',
                        value: edge?.node?.content || edge?.node?.name
                    },
                    status: $e5fe18c0543825a4$var$convertStatusIconUrlToAbsolute($e5fe18c0543825a4$export$92b010dbb91b5a57(edge?.node?.options).origin, edge.node.status ? JSON.parse(edge.node.status) : null),
                    type: 'WEB_PANEL'
                }
            }
        };
    }).reduce($e5fe18c0543825a4$var$arrayToTreeReducer, {});
const $e5fe18c0543825a4$var$transformContextPanels = (serverContextPanels = [])=>serverContextPanels.map((serverContextPanel)=>({
            [serverContextPanel.iframe.addonKey]: {
                [serverContextPanel.iframe.moduleKey]: {
                    name: serverContextPanel.name,
                    appKey: serverContextPanel.iframe.addonKey,
                    moduleKey: serverContextPanel.iframe.moduleKey,
                    options: $e5fe18c0543825a4$export$92b010dbb91b5a57(serverContextPanel.iframe.options),
                    icon: serverContextPanel.icon && {
                        url: serverContextPanel.icon.url
                    },
                    label: serverContextPanel.content || serverContextPanel.name,
                    status: $e5fe18c0543825a4$var$convertStatusIconUrlToAbsolute($e5fe18c0543825a4$export$92b010dbb91b5a57(serverContextPanel.iframe.options).origin, serverContextPanel.status),
                    type: serverContextPanel.type
                }
            }
        })).reduce($e5fe18c0543825a4$var$arrayToTreeReducer, {});
const $e5fe18c0543825a4$var$transformContentPanels = (contentPanels, legacyContentPanels)=>{
    const moduleByModuleKeyByAddonKey = {};
    const add = (edge)=>{
        if (!edge?.node?.addonKey || !edge?.node?.moduleKey) return;
        if (!moduleByModuleKeyByAddonKey[edge.node.addonKey]) moduleByModuleKeyByAddonKey[edge.node.addonKey] = {};
        moduleByModuleKeyByAddonKey[edge.node.addonKey][edge.node.moduleKey] = {
            name: edge.node.name ?? '',
            appKey: edge.node.addonKey,
            moduleKey: edge.node.moduleKey,
            options: $e5fe18c0543825a4$export$92b010dbb91b5a57(edge.node.options),
            iconUrl: edge.node.iconUrl ?? undefined,
            tooltip: edge.node.tooltip ?? undefined,
            type: edge.node.type ?? 'ISSUE_MODULE',
            showByDefault: edge.node.isShownByDefault ?? false
        };
    };
    contentPanels?.edges?.forEach(add);
    legacyContentPanels?.edges?.forEach(add);
    return moduleByModuleKeyByAddonKey;
};
// JIV-15751: Remove when cleaning up issue-view-remove-backgroundscripts-from-critical-fetch_6f6on
const $e5fe18c0543825a4$var$transformBackgroundScripts = (backgroundScripts = [])=>backgroundScripts.map(({ iframe: iframe, shouldReloadOnRefresh: shouldReloadOnRefresh })=>({
            appKey: iframe.addonKey,
            moduleKey: iframe.moduleKey,
            options: $e5fe18c0543825a4$export$92b010dbb91b5a57(iframe.options),
            shouldReloadOnRefresh: shouldReloadOnRefresh
        }));
// JIV-15846 Remove when cleaning up issue-view-remove-activitypanels-from-critical-fetch_43ozj
const $e5fe18c0543825a4$var$transformActivityPanels = (activityPanels = [])=>activityPanels.map((panel)=>({
            [panel.iframe.addonKey]: {
                [panel.iframe.moduleKey]: {
                    name: panel.name,
                    appKey: panel.iframe.addonKey,
                    moduleKey: panel.iframe.moduleKey,
                    options: $e5fe18c0543825a4$export$92b010dbb91b5a57(panel.iframe.options)
                }
            }
        })) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce($e5fe18c0543825a4$var$arrayToTreeReducer, {});
// JIV-16397: Remove when cleaning up issue-view-remove-connect-operations-from-critical-fetch_vtk4w
const $e5fe18c0543825a4$var$transformOperations = (serverOperations = [])=>serverOperations.map((serverOperation)=>({
            name: serverOperation.name,
            url: serverOperation.url,
            tooltip: serverOperation.tooltip ?? undefined,
            styleClass: serverOperation.styleClass ?? undefined
        }));
const $e5fe18c0543825a4$export$6c01ea8a90a2c903 = (serverResponse)=>({
        glances: (0, $1ybV0.ff)('issue-view-remove-glancesfield-from-query_fyj0g') ? $e5fe18c0543825a4$var$transformLegacyRightWebPanelsAsGlances(serverResponse.legacyRightWebPanels) : $e5fe18c0543825a4$var$transformGlances(serverResponse.glances),
        contextPanels: $e5fe18c0543825a4$var$transformContextPanels(serverResponse.contextPanels),
        contentPanels: $e5fe18c0543825a4$var$transformContentPanels(serverResponse.contentPanels, serverResponse.legacyContentPanels),
        ...!(0, $1ybV0.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on') ? {
            backgroundScripts: $e5fe18c0543825a4$var$transformBackgroundScripts(serverResponse.backgroundScripts)
        } : null,
        ...!(0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? {
            operations: $e5fe18c0543825a4$var$transformOperations(serverResponse.operations)
        } : null,
        ...!(0, $1ybV0.ff)('issue-view-remove-activitypanels-from-critical-fetch_43ozj') ? {
            activityPanels: $e5fe18c0543825a4$var$transformActivityPanels(serverResponse.activityPanels)
        } : null,
        ecosystemOnDate: serverResponse.ecoSystemOnDate,
        canInstallAddons: serverResponse.canInstallAddons || false
    });

});

const $e2450e7ea7ab7e1e$export$533eabbfe4c17c3a = `
        glancesField {
          fieldKey
          value {
            name
            status
            iframe {
              addonKey
              moduleKey
              options
            }
            icon {
              url
            }
            content
            type
          }
        }
      `;
const $e2450e7ea7ab7e1e$export$368355c015cbda00 = `
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;


parcelRegister("joqQr", function(module, exports) {

$parcel$export(module.exports, "buildDynamicIssueQuery", () => $612a5e946de13751$export$89050c9d48db1103);

var $1ybV0 = parcelRequire("1ybV0");
parcelRequire("gIOVj");
var $7IE2L = parcelRequire("7IE2L");
var $gIud4 = parcelRequire("gIud4");
var $gIOVj = parcelRequire("gIOVj");

var $bNnKs = parcelRequire("bNnKs");

var $5Q5XX = parcelRequire("5Q5XX");

var $2T55z = parcelRequire("2T55z");
const $612a5e946de13751$export$89050c9d48db1103 = ({ shouldRefreshComments: shouldRefreshComments } = {})=>`query issueViewDynamicQuery($issueKey: String!) {
        ${(0, $gIOVj.getJiraQueryEcosystemFirstSeenOnIssueView)()}
        viewIssue(issueKey: $issueKey) {
            ${shouldRefreshComments === true ? (0, $bNnKs.getQuery)() : ''}  
            ${(0, $gIud4.getEcosystemQuery)()}
            ${(0, $1ybV0.ff)('issue-view-remove-glancesfield-from-query_fyj0g') ? (0, $5Q5XX.getLegacyRightWebPanelsQuery)() : (0, $5Q5XX.getGlancesQuery)()}
            ${// only fetch dead glancesField if it's already removed (using legacyRightWebPanels)
    (0, $1ybV0.ff)('issue-view-remove-glancesfield-from-query_fyj0g') && (0, $1ybV0.ff)('implement-dead-glancesfield-query_f71sc') ? (0, $5Q5XX.getGlancesQuery)() : ''}
            ${(0, $7IE2L.getContentPanelsQuery)()}
        }
        ${(0, $2T55z.getQuery)()}
        activitySortOrder
    }`;

});
parcelRegister("2T55z", function(module, exports) {

$parcel$export(module.exports, "getQuery", () => $14173fc49012e655$export$71eec30d9db46a56);
const $14173fc49012e655$export$e302502f14e3f203 = ()=>`
      timeTracking {
        isTimeTrackingEnabled
        hoursPerDay
        daysPerWeek
        defaultUnit
      }
`;
const $14173fc49012e655$export$74a29cba034a2242 = ()=>`
    jiraSettings {
      ${$14173fc49012e655$export$e302502f14e3f203()}
    }
`;
const $14173fc49012e655$export$71eec30d9db46a56 = ()=>`
    jiraSettings {
      ${$14173fc49012e655$export$e302502f14e3f203()}
      issueLinkTypes {
        id
        name
        inward
        outward
      }
    }
`;

});


parcelRegister("31HOS", function(module, exports) {

$parcel$export(module.exports, "transformTimeTrackingData", () => $e23fe8bea8bf65cd$export$1ce390e88fa17bbc);
$parcel$export(module.exports, "transformData", () => $e23fe8bea8bf65cd$export$3ceb62baab058c6b);

var $h9cCP = parcelRequire("h9cCP");

var $2T55z = parcelRequire("2T55z");
const $e23fe8bea8bf65cd$export$1ce390e88fa17bbc = (jiraSettings)=>({
        timeTrackingConfiguration: jiraSettings.timeTracking || (0, $h9cCP.defaultTimeTrackingConfiguration)
    });
const $e23fe8bea8bf65cd$export$b829656c3d6b4cf5 = (jiraSettings)=>({
        subtasksConfiguration: jiraSettings.subtasks
    });
const $e23fe8bea8bf65cd$export$65d0113ea5ff55de = (jiraSettings)=>({
        newIssueViewTransitionSettings: jiraSettings.newIssueViewTransitionSettings
    });
const $e23fe8bea8bf65cd$export$3ceb62baab058c6b = (jiraSettings)=>{
    const newIssueViewTransitionSettings = $e23fe8bea8bf65cd$export$65d0113ea5ff55de(jiraSettings);
    return {
        jiraSettings: {
            ...newIssueViewTransitionSettings
        }
    };
};

});

parcelRegister("gHr1k", function(module, exports) {

$parcel$export(module.exports, "getIsArchived", () => $eb000c0409f17cd0$export$b41341ac6c74ca6);
const $eb000c0409f17cd0$export$b41341ac6c74ca6 = (issue)=>issue?.isArchived ?? false;

});

parcelRegister("hAAuM", function(module, exports) {

$parcel$export(module.exports, "transformReadAttachmentsToken", () => $7ba48418759fd067$export$12a604fa4698eff2);
$parcel$export(module.exports, "transformUserContext", () => $7ba48418759fd067$export$21d8668471cc8994);
$parcel$export(module.exports, "transformData", () => $7ba48418759fd067$export$3ceb62baab058c6b);

var $hEEI6 = parcelRequire("hEEI6");
const $7ba48418759fd067$var$getFirstTokenIfAvailable = (tokensWithFiles)=>tokensWithFiles.length > 0 ? tokensWithFiles[0].token : null;
const $7ba48418759fd067$export$12a604fa4698eff2 = (readAttachmentsToken)=>{
    const token = $7ba48418759fd067$var$getFirstTokenIfAvailable(readAttachmentsToken.tokensWithFiles);
    const tokenProps = typeof token === 'string' ? (0, $hEEI6.getTokenDeltaProps)(token) : {};
    return {
        clientId: readAttachmentsToken.clientId,
        serviceHost: readAttachmentsToken.endpointUrl,
        token: token,
        areTokenPermissionsUpToDate: true,
        tokenLifespanInMs: readAttachmentsToken.tokenLifespanInSeconds * 1000,
        tokenIssueTimestamp: Date.now() - 10000,
        collection: null,
        tokenDecodeError: tokenProps.tokenDecodeError,
        localTimeDelta: tokenProps.localTimeDelta,
        tokenExpiryTime: tokenProps.tokenExpiryTime
    };
};
const $7ba48418759fd067$export$e094e7a8aa55f6c7 = (uploadToken)=>{
    if (// @ts-expect-error - TS2339 - Property 'clientId' does not exist on type 'UploadTokenUnion'.
    uploadToken.clientId != null && // @ts-expect-error - TS2339 - Property 'endpointUrl' does not exist on type 'UploadTokenUnion'.
    uploadToken.endpointUrl != null && // @ts-expect-error - TS2339 - Property 'token' does not exist on type 'UploadTokenUnion'.
    uploadToken.token != null && // @ts-expect-error - TS2339 - Property 'tokenDurationInMins' does not exist on type 'UploadTokenUnion'.
    uploadToken.tokenDurationInMins != null && // @ts-expect-error - TS2339 - Property 'targetCollection' does not exist on type 'UploadTokenUnion'.
    uploadToken.targetCollection != null) return {
        // @ts-expect-error - TS2339 - Property 'clientId' does not exist on type 'UploadTokenUnion'.
        clientId: uploadToken.clientId,
        // @ts-expect-error - TS2339 - Property 'endpointUrl' does not exist on type 'UploadTokenUnion'.
        serviceHost: uploadToken.endpointUrl,
        // @ts-expect-error - TS2339 - Property 'token' does not exist on type 'UploadTokenUnion'.
        token: uploadToken.token,
        // @ts-expect-error - TS2339 - Property 'tokenDurationInMins' does not exist on type 'UploadTokenUnion'.
        tokenLifespanInMs: uploadToken.tokenDurationInMins * 60000,
        // @ts-expect-error - TS2339 - Property 'targetCollection' does not exist on type 'UploadTokenUnion'.
        collection: uploadToken.targetCollection,
        tokenIssueTimestamp: Date.now() - 10000
    };
    // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'UploadTokenUnion'.
    if (uploadToken.error != null) // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'UploadTokenUnion'.
    return {
        error: uploadToken.error
    };
    return null;
};
const $7ba48418759fd067$export$21d8668471cc8994 = (userToken)=>({
        clientId: userToken.id,
        token: userToken.token,
        tokenLifespanInMs: Number(userToken.tokenDurationInMins) * 60000,
        tokenIssueTimestamp: Date.now() - 10000
    });
const $7ba48418759fd067$export$3ceb62baab058c6b = ({ readToken: readToken, uploadToken: uploadToken, userToken: userToken })=>({
        viewContext: readToken ? $7ba48418759fd067$export$12a604fa4698eff2(readToken) : null,
        uploadContext: uploadToken ? $7ba48418759fd067$export$e094e7a8aa55f6c7(uploadToken) : null,
        userAuth: userToken ? $7ba48418759fd067$export$21d8668471cc8994(userToken) : null
    });

});

parcelRegister("b7ISA", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $0ea02192f98bbdd2$export$3ceb62baab058c6b);

var $anOKD = parcelRequire("anOKD");

var $4z02k = parcelRequire("4z02k");

var $6zsYX = parcelRequire("6zsYX");

const $0ea02192f98bbdd2$export$f604efbb2e3afcf0 = (data)=>{
    if (!data || data.length === 0) return {
        permissions: {
            ...(0, $anOKD.defaultPermissions)
        }
    };
    const permissions = data.reduce((acc, permission)=>{
        acc[permission.key] = permission;
        return acc;
    }, {});
    return (0, $6zsYX.transformPermissions)({
        permissions: // @ts-expect-error - TS2740 - Type 'Record<string, any>' is missing the following properties from type 'ServerPermissionValues': ADMINISTER, ADMINISTER_PROJECTS, ASSIGN_ISSUES, EDIT_ISSUES, and 28 more.
        permissions
    });
};
const $0ea02192f98bbdd2$export$3ceb62baab058c6b = (data, viewIssue, jira)=>{
    const transformedPermissionsData = $0ea02192f98bbdd2$export$f604efbb2e3afcf0(data);
    transformedPermissionsData.permissions.canCreateSubtask = viewIssue?.canCreateSubTask ? viewIssue?.canCreateSubTask : (0, $anOKD.defaultPermissions).canCreateSubtask;
    transformedPermissionsData.permissions.canAdministerJira = jira?.hasAdministerPermission ? jira?.hasAdministerPermission : (0, $anOKD.defaultPermissions).canAdministerJira;
    transformedPermissionsData.permissions.canBrowseUsers = jira?.hasUserPickerPermission ? jira?.hasUserPickerPermission : (0, $anOKD.defaultPermissions).canBrowseUsers;
    if ((0, $4z02k.isIssueExportControlEnabled)()) transformedPermissionsData.permissions.canExportIssue = viewIssue?.canExportIssue ?? (0, $anOKD.defaultPermissions).canExportIssue;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return transformedPermissionsData;
};

});
parcelRegister("6zsYX", function(module, exports) {

$parcel$export(module.exports, "transformPermissions", () => $13dcf93c1b55697c$export$7fe0bfa353103198);
$parcel$export(module.exports, "getGraphQlFields", () => $13dcf93c1b55697c$export$7c5ecebab0b8a1c9);
$parcel$export(module.exports, "searchResultTransformer", () => $13dcf93c1b55697c$export$a189e7d85bc3828b);

var $3aUuh = parcelRequire("3aUuh");

var $8Qd0L = parcelRequire("8Qd0L");


var $f9RL0 = parcelRequire("f9RL0");


var $7Vbpp = parcelRequire("7Vbpp");

var $6vrw7 = parcelRequire("6vrw7");

var $91KGQ = parcelRequire("91KGQ");

var $lAi7F = parcelRequire("lAi7F");

var $iVHfZ = parcelRequire("iVHfZ");

var $v9iAl = parcelRequire("v9iAl");
const $13dcf93c1b55697c$var$transformParentIssue = (parentIssue)=>parentIssue ? {
        id: (0, $6vrw7.toIssueId)(parentIssue.id),
        key: (0, $6vrw7.toIssueKey)(parentIssue.key),
        summary: parentIssue.fields.summary,
        issueTypeName: parentIssue.fields.issuetype ? parentIssue.fields.issuetype.name : '',
        issueTypeIconUrl: parentIssue.fields.issuetype ? parentIssue.fields.issuetype.iconUrl : ''
    } : null;
const $13dcf93c1b55697c$var$getProjectStatus = (project)=>{
    if (project.archived) return 0, $5bd9e96e4d7e8aee$export$4ccc35479ba9ad1;
    if (project.deleted) return 0, $5bd9e96e4d7e8aee$export$a95d71e582b8bc0;
    return 0, $5bd9e96e4d7e8aee$export$62113557945f790a;
};
const $13dcf93c1b55697c$export$2d1bde06ef9e2dcc = (graphQLResponse)=>{
    const { issue: issue, project: project } = graphQLResponse;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const issueFields = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(issue.fields, 'key');
    const subTasks = issueFields.subtasks?.content;
    const parentIssue = issueFields.parent?.content;
    const nextGenChildrenIssues = issueFields['children-issues']?.content;
    const classicEpicChildrenIssues = issueFields['epic-issues']?.content;
    const portfolioChildrenIssues = issueFields['portfolio-child-issues']?.content;
    const isSimplifiedProject = project.simplified;
    let childrenIssues = [];
    if (nextGenChildrenIssues) childrenIssues = (0, $lAi7F.transformChildrenNew)(nextGenChildrenIssues, isSimplifiedProject);
    else if (classicEpicChildrenIssues) childrenIssues = (0, $lAi7F.transformChildrenNew)(classicEpicChildrenIssues, isSimplifiedProject);
    else if (portfolioChildrenIssues) childrenIssues = (0, $91KGQ.transformChildren)(portfolioChildrenIssues, (0, $6vrw7.toBaseUrl)(''));
    const avatarUrl = project.avatarUrls?.find(({ key: key })=>key === '32x32')?.value;
    return {
        // The `childIssuesLimit` field has been added to satisfy types.
        // This feature only works for the AGG migration phase 1 on case.
        // This value is not consumed.
        childIssuesLimit: undefined,
        project: {
            projectId: project.id,
            projectName: project.name,
            projectKey: project.key,
            projectType: project.projectTypeKey,
            isSimplified: isSimplifiedProject,
            avatarUrl: avatarUrl,
            projectStatus: $13dcf93c1b55697c$var$getProjectStatus(project)
        },
        createdDate: issueFields.created?.content || null,
        updatedDate: issueFields.updated?.content || null,
        statuses: {
            [issueFields.status.content.id]: {
                id: issueFields.status.content.id,
                name: issueFields.status.content.name,
                statusCategory: (0, $8Qd0L.statusCategoryForId)(issueFields.status.content.statusCategory.id)
            }
        },
        issueLinks: issueFields.issuelinks && (0, $iVHfZ.transformIssueLinks)((0, $6vrw7.toBaseUrl)(''), issueFields.issuelinks.content),
        subtasks: (0, $v9iAl.transformSubtasks)(subTasks, (0, $6vrw7.toBaseUrl)('')),
        parentIssue: $13dcf93c1b55697c$var$transformParentIssue(parentIssue),
        childrenIssues: childrenIssues
    };
};
const $13dcf93c1b55697c$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER',
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'USER_PICKER',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CREATE_SUBTASK',
        'CLONE_ISSUE'
    ];
const $13dcf93c1b55697c$export$7fe0bfa353103198 = (responseData)=>{
    const { permissions: { ADMINISTER_PROJECTS: ADMINISTER_PROJECTS, ASSIGN_ISSUES: ASSIGN_ISSUES, EDIT_ISSUES: EDIT_ISSUES, SCHEDULE_ISSUES: SCHEDULE_ISSUES, ADD_COMMENTS: ADD_COMMENTS, DELETE_ALL_COMMENTS: DELETE_ALL_COMMENTS, DELETE_OWN_COMMENTS: DELETE_OWN_COMMENTS, EDIT_ALL_COMMENTS: EDIT_ALL_COMMENTS, EDIT_OWN_COMMENTS: EDIT_OWN_COMMENTS, CREATE_ISSUES: CREATE_ISSUES, CLONE_ISSUE: CLONE_ISSUE, DELETE_ISSUES: DELETE_ISSUES, MOVE_ISSUES: MOVE_ISSUES, MODIFY_REPORTER: MODIFY_REPORTER, CREATE_ATTACHMENTS: CREATE_ATTACHMENTS, DELETE_ALL_ATTACHMENTS: DELETE_ALL_ATTACHMENTS, DELETE_OWN_ATTACHMENTS: DELETE_OWN_ATTACHMENTS, WORK_ON_ISSUES: WORK_ON_ISSUES, ASSIGNABLE_USER: ASSIGNABLE_USER, LINK_ISSUES: LINK_ISSUES, VIEW_VOTERS_AND_WATCHERS: VIEW_VOTERS_AND_WATCHERS, MANAGE_WATCHERS: MANAGE_WATCHERS, EDIT_ALL_WORKLOGS: EDIT_ALL_WORKLOGS, EDIT_OWN_WORKLOGS: EDIT_OWN_WORKLOGS, DELETE_ALL_WORKLOGS: DELETE_ALL_WORKLOGS, DELETE_OWN_WORKLOGS: DELETE_OWN_WORKLOGS, VIEW_DEV_TOOLS: VIEW_DEV_TOOLS, SERVICEDESK_AGENT: SERVICEDESK_AGENT, RESOLVE_ISSUES: RESOLVE_ISSUES } } = responseData;
    return {
        permissions: {
            canAddComments: ADD_COMMENTS.havePermission,
            canAdministerProject: ADMINISTER_PROJECTS.havePermission,
            canAssignIssues: ASSIGN_ISSUES.havePermission,
            canBeAssignedToIssues: ASSIGNABLE_USER.havePermission,
            canCloneIssue: CLONE_ISSUE.havePermission,
            canCreateAttachments: CREATE_ATTACHMENTS.havePermission,
            canCreateChildren: CREATE_ISSUES.havePermission,
            canCreateIssuesInClassicProjectEpic: CREATE_ISSUES.havePermission,
            canDeleteAllAttachments: DELETE_ALL_ATTACHMENTS.havePermission,
            canDeleteOwnAttachments: DELETE_OWN_ATTACHMENTS.havePermission,
            canDeleteAllComments: DELETE_ALL_COMMENTS.havePermission,
            canDeleteOwnComments: DELETE_OWN_COMMENTS.havePermission,
            canDeleteIssue: DELETE_ISSUES.havePermission,
            canEditAllComments: EDIT_ALL_COMMENTS.havePermission,
            canEditOwnComments: EDIT_OWN_COMMENTS.havePermission,
            canEditIssues: EDIT_ISSUES.havePermission,
            canLinkIssues: LINK_ISSUES.havePermission,
            canLogWork: WORK_ON_ISSUES.havePermission,
            canManageWatchers: MANAGE_WATCHERS.havePermission,
            canMoveIssue: MOVE_ISSUES.havePermission,
            canModifyReporter: MODIFY_REPORTER.havePermission,
            canScheduleIssues: SCHEDULE_ISSUES.havePermission,
            canViewWatchers: VIEW_VOTERS_AND_WATCHERS.havePermission,
            canViewVoters: VIEW_VOTERS_AND_WATCHERS.havePermission,
            canEditAllWorklogs: EDIT_ALL_WORKLOGS.havePermission,
            canEditOwnWorklogs: EDIT_OWN_WORKLOGS.havePermission,
            canDeleteAllWorklogs: DELETE_ALL_WORKLOGS.havePermission,
            canDeleteOwnWorklogs: DELETE_OWN_WORKLOGS.havePermission,
            canViewDevTools: !!(VIEW_DEV_TOOLS && VIEW_DEV_TOOLS.havePermission),
            canUseServiceDeskAgentFeatures: !!(SERVICEDESK_AGENT && SERVICEDESK_AGENT.havePermission),
            canResolveIssues: RESOLVE_ISSUES.havePermission
        }
    };
};
const $13dcf93c1b55697c$export$7c1350f375476212 = (field)=>{
    const { content: content, renderedContent: renderedContent, configuration: configuration, ...rest } = field;
    const shouldHaveContentFields = content !== undefined || renderedContent !== undefined;
    // @ts-expect-error - TS2322 - Type '{ key: string; title: string; editable: boolean; required: boolean; autoCompleteUrl?: string | null | undefined; description?: string | null | undefined; allowedValues: any[]; schema: FieldSchema; ... 5 more ...; value?: any; }' is not assignable to type 'Field'.
    return {
        ...shouldHaveContentFields ? {
            value: content
        } : null,
        ...shouldHaveContentFields ? {
            renderedValue: renderedContent
        } : null,
        ...configuration && {
            configuration: configuration
        },
        ...rest
    };
};
const $13dcf93c1b55697c$var$findGraphQlAdfField = (graphQlData, fieldId)=>{
    const systemField = graphQlData.issue.systemFields[`${fieldId}Adf`];
    const customTextareaField = graphQlData.issue.customFields.textareaAdf.find((multilineField)=>multilineField.key === fieldId);
    return systemField || customTextareaField || null;
};
const $13dcf93c1b55697c$var$getAdfValue = (graphQlData, fieldId)=>{
    const graphQlAdfField = $13dcf93c1b55697c$var$findGraphQlAdfField(graphQlData, fieldId);
    let adfField;
    if (graphQlAdfField && graphQlAdfField.value) adfField = {
        value: graphQlAdfField.value
    };
    else // A null ADF value and null WikiMarkup value means that the field has never had a value
    // set in it.
    adfField = {
        value: (0, $7Vbpp.emptyAdfObject)
    };
    // GraphQL is currently returning this as a JSON string, though ideally
    // we want it as JSON object
    // Can remove the check/JSON.parse when the below ticket is complete:
    //    https://product-fabric.atlassian.net/browse/EX-203
    const adfValue = typeof adfField.value === 'string' ? JSON.parse(adfField.value) : adfField.value;
    return (0, $7Vbpp.removeCollectionFromAdf)(adfValue);
};
const $13dcf93c1b55697c$export$7c5ecebab0b8a1c9 = (graphQlData)=>{
    const fieldKeysWithRichRenderer = new Set(graphQlData.issue.fields.filter((field)=>field.schema.renderer === (0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c)).map((field)=>field.key));
    const customMultilineFieldKeys = graphQlData.issue.customFields.textareaAdf.map((field)=>field.key);
    const customMultilineFieldKeysWithRichRenderer = customMultilineFieldKeys.filter((key)=>fieldKeysWithRichRenderer.has(key));
    const systemMultilineFieldsWithRichRenderer = [
        (0, $f9RL0.DESCRIPTION),
        (0, $f9RL0.ENVIRONMENT)
    ].filter((key)=>fieldKeysWithRichRenderer.has(key) || key === (0, $f9RL0.DESCRIPTION));
    const adfKeys = [
        ...systemMultilineFieldsWithRichRenderer,
        ...customMultilineFieldKeysWithRichRenderer
    ];
    const adfFields = adfKeys.map((field)=>({
            key: field,
            value: $13dcf93c1b55697c$var$getAdfValue(graphQlData, field)
        }));
    return graphQlData.issue.fields.map((field)=>{
        const adfTransformationField = adfFields.find((adfField)=>adfField.key === field.key && adfField.value !== null);
        if (adfTransformationField) return {
            [adfTransformationField.key]: {
                ...$13dcf93c1b55697c$export$7c1350f375476212(field),
                adfValue: adfTransformationField.value
            }
        };
        return {
            [field.key]: $13dcf93c1b55697c$export$7c1350f375476212(field)
        };
    }).reduce((acc, currentValue)=>Object.assign(acc, currentValue));
};
const $13dcf93c1b55697c$var$getTabs = (tabs)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    tabs?.reduce((acc, { id: id, name: name, items: items })=>{
        acc[id] = {
            id: id,
            name: name,
            items: items
        };
        return acc;
    }, {});
const $13dcf93c1b55697c$export$aa5b1ce37de59943 = (graphQlData)=>{
    const oldTransformedFields = $13dcf93c1b55697c$export$2d1bde06ef9e2dcc(graphQlData);
    const graphQlTransformedFields = {
        issue: {
            id: graphQlData.issue.id,
            agile: graphQlData.issue.agile,
            fields: $13dcf93c1b55697c$export$7c5ecebab0b8a1c9(graphQlData),
            tabs: $13dcf93c1b55697c$var$getTabs(graphQlData.issue.tabs),
            ...graphQlData.issue.viewScreenId ? {
                viewScreenId: graphQlData.issue.viewScreenId
            } : null
        }
    };
    return {
        ...graphQlTransformedFields,
        ...oldTransformedFields
    };
};
const $13dcf93c1b55697c$export$a189e7d85bc3828b = ({ issues: issues = [] } = {})=>issues;

});
parcelRegister("3aUuh", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $f2sQe = parcelRequire("f2sQe");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $24fe1f7ac78dbb37$var$keyBy = $f2sQe(function(result, value, key) {
    $3pSMu(result, key, value);
});
module.exports = $24fe1f7ac78dbb37$var$keyBy;

});

parcelRegister("91KGQ", function(module, exports) {

$parcel$export(module.exports, "transformChildren", () => $057cb515f6314498$export$6a0f063cd77f1995);

var $8Qd0L = parcelRequire("8Qd0L");

var $lV5H0 = parcelRequire("lV5H0");

var $blHvU = parcelRequire("blHvU");
const $057cb515f6314498$var$getAssigneeFields = (assignee)=>{
    if (assignee != null) {
        const { avatarUrl: avatarUrl, displayName: displayName } = (0, $blHvU.transformUser)(assignee);
        return {
            assigneeUrl: avatarUrl,
            assigneeDisplayName: displayName
        };
    }
    return {
        assigneeUrl: null,
        assigneeDisplayName: null
    };
};
const $057cb515f6314498$export$c66ac1a53266e423 = (child, baseUrl)=>{
    const { fields: fields } = child;
    return {
        id: child.id,
        issueLink: (0, $lV5H0.getIssueHtmlUrl)(baseUrl, child.key),
        issueTypeIconUrl: fields.issuetype.iconUrl,
        issueTypeName: fields.issuetype.name,
        issuePriorityUrl: fields.priority && fields.priority.iconUrl || undefined,
        issuePriorityName: fields.priority && fields.priority.name || undefined,
        issueKey: child.key,
        issueSummary: fields.summary,
        statusCategory: (0, $8Qd0L.statusCategoryForId)(fields.status.statusCategory.id),
        statusCategoryId: fields.status.statusCategory.id,
        statusName: fields.status.name,
        statusId: fields.status.id,
        ...$057cb515f6314498$var$getAssigneeFields(fields.assignee),
        isLoading: false
    };
};
const $057cb515f6314498$export$6a0f063cd77f1995 = (children = [], baseUrl)=>!children ? [] : children.map((child)=>$057cb515f6314498$export$c66ac1a53266e423(child, baseUrl));

});

parcelRegister("lAi7F", function(module, exports) {

$parcel$export(module.exports, "transformChild", () => $312d25411a1b8bc8$export$c66ac1a53266e423);
$parcel$export(module.exports, "transformChildrenNew", () => $312d25411a1b8bc8$export$f81c9d8b1547df05);

var $3aUuh = parcelRequire("3aUuh");

var $8Qd0L = parcelRequire("8Qd0L");

var $lO4Or = parcelRequire("lO4Or");

var $6vrw7 = parcelRequire("6vrw7");

var $lV5H0 = parcelRequire("lV5H0");

var $blHvU = parcelRequire("blHvU");
// we need to define a type here for default because of flow ambiguous error
// does not really matter because epicIssue type and nextgen issue type is same
const $312d25411a1b8bc8$var$defaultChildrenIssues = [];
const $312d25411a1b8bc8$var$getAssigneeFields = (assignee)=>{
    if (assignee != null) {
        const { avatarUrl: avatarUrl, displayName: displayName } = (0, $blHvU.transformUser)(assignee);
        return {
            assigneeUrl: avatarUrl,
            assigneeDisplayName: displayName
        };
    }
    return {
        assigneeUrl: null,
        assigneeDisplayName: null
    };
};
const $312d25411a1b8bc8$export$c66ac1a53266e423 = (child, isSimplifiedProject = true)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const systemFields = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(child.fields, (field)=>field.schema.system);
    const issueType = systemFields[0, $lO4Or.ISSUE_TYPE];
    const priority = systemFields[0, $lO4Or.PRIORITY_TYPE];
    const summary = systemFields[0, $lO4Or.SUMMARY_TYPE];
    const status = systemFields[0, $lO4Or.STATUS_TYPE];
    const assignee = systemFields[0, $lO4Or.ASSIGNEE_TYPE];
    const estimateField = child.fields.find((field)=>isSimplifiedProject ? field.schema.custom === (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE) : field.schema.custom === (0, $lO4Or.STORY_POINTS_TYPE));
    const timeTrackingField = systemFields[0, $lO4Or.TIME_TRACKING_TYPE];
    const created = systemFields[0, $lO4Or.CREATED];
    const updated = systemFields[0, $lO4Or.UPDATED];
    const resolution = systemFields[0, $lO4Or.RESOLUTION_TYPE];
    const assigneeFields = assignee ? $312d25411a1b8bc8$var$getAssigneeFields(assignee.value) : {};
    return {
        id: child.id,
        issueLink: (0, $lV5H0.getIssueHtmlUrl)((0, $6vrw7.toBaseUrl)(''), child.key),
        issueTypeIconUrl: issueType?.value.iconUrl,
        issueTypeName: issueType?.value.name,
        issuePriorityUrl: priority?.value?.iconUrl ?? undefined,
        issuePriorityName: priority?.value?.name ?? undefined,
        issueKey: child.key,
        issueSummary: summary?.value,
        statusCategory: status?.value && (0, $8Qd0L.statusCategoryForId)(status.value.statusCategory.id),
        statusCategoryId: status?.value?.statusCategory.id,
        statusName: status?.value?.name ?? undefined,
        statusId: status?.value?.id ?? undefined,
        estimateFieldId: estimateField?.key ?? undefined,
        estimateValue: estimateField?.value ?? undefined,
        // @ts-expect-error - TS2339 - Property 'assigneeDisplayName' does not exist on type '{}'.
        assigneeDisplayName: assigneeFields.assigneeDisplayName,
        // @ts-expect-error - TS2339 - Property 'assigneeUrl' does not exist on type '{}'.
        assigneeUrl: assigneeFields.assigneeUrl,
        isLoading: false,
        issueTimeTracking: timeTrackingField?.value ?? undefined,
        ...created?.value && {
            created: new Date(created.value)
        },
        ...updated?.value && {
            updated: new Date(updated.value)
        },
        isResolved: !!resolution?.value
    };
};
const $312d25411a1b8bc8$export$f81c9d8b1547df05 = (children = $312d25411a1b8bc8$var$defaultChildrenIssues, isSimplifiedProject)=>!children ? [] : children.map((child)=>$312d25411a1b8bc8$export$c66ac1a53266e423(child, isSimplifiedProject));

});

parcelRegister("iVHfZ", function(module, exports) {

$parcel$export(module.exports, "transformIssueLinks", () => $d23ddce71f0cf1f7$export$f279b7ca74d54fba);

var $8Qd0L = parcelRequire("8Qd0L");

var $03XEB = parcelRequire("03XEB");

var $6vrw7 = parcelRequire("6vrw7");

var $lV5H0 = parcelRequire("lV5H0");

var $blHvU = parcelRequire("blHvU");
const { statusCategoryForId: $d23ddce71f0cf1f7$var$statusCategoryForId } = (0, $8Qd0L);
const $d23ddce71f0cf1f7$export$2b82c49573cf1158 = (linkedIssue, baseUrl)=>{
    const { id: id, key: key, fields: fields } = linkedIssue;
    return {
        id: id,
        issueKey: key,
        issueLink: (0, $lV5H0.getIssueHtmlUrl)(baseUrl, key),
        issueSummary: fields.summary,
        statusCategory: $d23ddce71f0cf1f7$var$statusCategoryForId(fields.status?.statusCategory?.id),
        statusCategoryId: fields.status?.statusCategory?.id,
        statusName: fields.status && fields.status.name,
        statusId: fields.status && fields.status.id,
        issuePriorityUrl: fields.priority?.iconUrl ?? null,
        issuePriorityName: fields.priority?.name ?? null,
        issueTypeIconUrl: fields.issuetype?.iconUrl ?? null,
        issueTypeName: fields.issuetype?.name ?? null,
        assigneeDisplayName: fields.assignee ? (0, $blHvU.transformUser)(fields.assignee).displayName : null,
        assigneeUrl: fields.assignee ? (0, $blHvU.transformUser)(fields.assignee).avatarUrl : null
    };
};
const $d23ddce71f0cf1f7$export$f279b7ca74d54fba = (baseUrl, issueLinksServer = [])=>{
    const issueLinks = {};
    const linkedIssues = {};
    issueLinksServer && issueLinksServer.filter(Boolean).forEach(({ id: id, inwardIssue: inwardIssue, outwardIssue: outwardIssue, type: type })=>{
        let typeName = null;
        let linkedIssue;
        let direction;
        if (inwardIssue) {
            direction = (0, $03XEB.INWARD_LINK_DIRECTION);
            typeName = type.inward;
            linkedIssue = inwardIssue;
        } else if (outwardIssue) {
            direction = (0, $03XEB.OUTWARD_LINK_DIRECTION);
            typeName = type.outward;
            linkedIssue = outwardIssue;
        }
        // @ts-expect-error - TS2454 - Variable 'linkedIssue' is used before being assigned.
        if (typeName && linkedIssue != null) {
            const newIssueLink = {
                id: (0, $6vrw7.toIssueId)(id),
                linkedIssueKey: linkedIssue.key,
                direction: // @ts-expect-error - TS2454 - Variable 'direction' is used before being assigned.
                direction,
                typeName: typeName,
                typeId: type.id
            };
            issueLinks[id] = newIssueLink;
            const newLinkedIssue = $d23ddce71f0cf1f7$export$2b82c49573cf1158(linkedIssue, (0, $6vrw7.toBaseUrl)(''));
            linkedIssues[newLinkedIssue.issueKey] = newLinkedIssue;
        }
    });
    const linkedIssueKeys = issueLinks ? Object.values(issueLinks).map(({ linkedIssueKey: linkedIssueKey })=>(0, $6vrw7.toIssueKey)(linkedIssueKey)) : [];
    return {
        issueLinks: issueLinks,
        linkedIssueKeys: linkedIssueKeys,
        linkedIssues: linkedIssues
    };
};

});

parcelRegister("v9iAl", function(module, exports) {

$parcel$export(module.exports, "transformSubtasks", () => $9e3dafd495e90e10$export$64c38caf710da25d);

var $8Qd0L = parcelRequire("8Qd0L");

var $lV5H0 = parcelRequire("lV5H0");

var $blHvU = parcelRequire("blHvU");
const $9e3dafd495e90e10$var$transformSubtask = (subtask, baseUrl)=>({
        id: subtask.id,
        issueLink: (0, $lV5H0.getIssueHtmlUrl)(baseUrl, subtask.key),
        issueTypeIconUrl: subtask.fields.issuetype.iconUrl,
        issueTypeName: subtask.fields.issuetype.name,
        issuePriorityUrl: subtask.fields.priority && subtask.fields.priority.iconUrl || undefined,
        issuePriorityName: subtask.fields.priority && subtask.fields.priority.name || undefined,
        issueKey: subtask.key,
        issueSummary: subtask.fields.summary,
        statusCategory: (0, $8Qd0L.statusCategoryForId)(subtask.fields.status.statusCategory.id),
        statusCategoryId: subtask.fields.status.statusCategory.id,
        statusId: subtask.fields.status.id,
        statusName: subtask.fields.status.name,
        isLoading: false,
        hasError: false,
        assigneeUrl: subtask.fields.assignee ? (0, $blHvU.transformUser)(subtask.fields.assignee).avatarUrl : null,
        assigneeDisplayName: subtask.fields.assignee ? (0, $blHvU.transformUser)(subtask.fields.assignee).displayName : null,
        issueTimeTracking: subtask.fields.timetracking
    });
const $9e3dafd495e90e10$export$64c38caf710da25d = (subtasks = [], baseUrl)=>subtasks === null ? [] : subtasks.map((subtask)=>$9e3dafd495e90e10$var$transformSubtask(subtask, baseUrl));

});



parcelRegister("15355", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $9518adfdbd1aa741$export$3ceb62baab058c6b);

const $9518adfdbd1aa741$export$3ceb62baab058c6b = (project)=>({
        issueTypes: project ? project.issueTypes : [],
        newIssueViewLockedIn: Boolean(project && project.newIssueViewLockedIn)
    });

});

parcelRegister("aPZET", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $6c93726311c31cf6$export$3ceb62baab058c6b);
const $6c93726311c31cf6$export$3ceb62baab058c6b = (issue)=>{
    const { remoteLinks: remoteLinks } = issue;
    if (!remoteLinks) // TODO: Proper error handling in NIMBUS-210
    // as "{remoteLinks: null}" indicates there is a error when fetching remoteLinks
    // we'd like to log the error and show user a flag
    return {
        remoteLinks: {
            isLinkingEnabled: false,
            remoteLinkedIssues: []
        }
    };
    return {
        remoteLinks: remoteLinks
    };
};

});

parcelRegister("cwRsr", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $d3819ad5b2201842$export$3ceb62baab058c6b);

var $lIYvG = parcelRequire("lIYvG");

var $8uV8a = parcelRequire("8uV8a");
const $d3819ad5b2201842$var$NUM_INITIAL_WORKLOG_TO_LOAD = 5;
const $d3819ad5b2201842$var$CREATED_ORDER_DESCENDING = '-started';
const $d3819ad5b2201842$export$71eec30d9db46a56 = ()=>(0, $8uV8a.getWorklogsQuery)($d3819ad5b2201842$var$NUM_INITIAL_WORKLOG_TO_LOAD, 0, $d3819ad5b2201842$var$CREATED_ORDER_DESCENDING);
const $d3819ad5b2201842$export$3ceb62baab058c6b = (issue)=>{
    const { worklogs: rawWorklogs } = issue;
    if (!rawWorklogs) return {
        worklogs: {},
        sortedWorklogIds: [],
        totalWorklogs: 0,
        worklogsStartIndex: 0
    };
    const { totalCount: totalCount, startIndex: startIndex, nodes: nodes } = rawWorklogs;
    const { worklogs: worklogs } = (0, $lIYvG.normalizeWorklogs)(nodes);
    const sortedWorklogIds = nodes.map((worklog)=>worklog.id);
    return {
        worklogs: worklogs,
        sortedWorklogIds: sortedWorklogIds,
        totalWorklogs: totalCount,
        worklogsStartIndex: startIndex
    };
};

});
parcelRegister("lIYvG", function(module, exports) {

$parcel$export(module.exports, "normalizeWorklogs", () => $c753cc5c2182631d$export$6aeecd2cf08593fc);

var $7Vbpp = parcelRequire("7Vbpp");

var $1OM81 = parcelRequire("1OM81");
// Worklog has its own User type meaning we can't reuse user-transformer here
// https://jdog.jira-dev.com/browse/BENTO-6233 aims to have a single user object
const $c753cc5c2182631d$var$transformUser = (user)=>{
    const { accountId: accountId, displayName: displayName = null, avatarUrl: avatarUrl = null } = user;
    return {
        accountId: accountId,
        displayName: displayName,
        avatarUrl: avatarUrl
    };
};
const $c753cc5c2182631d$export$ff10a173fcd21d1b = (worklog)=>{
    const { id: id, author: author, updateAuthor: updateAuthor, created: created, updated: updated, started: started, comment: comment, timeSpent: timeSpent } = worklog;
    const wasUpdated = updated !== created;
    return {
        id: id,
        author: author ? $c753cc5c2182631d$var$transformUser(author) : null,
        updateAuthor: wasUpdated && updateAuthor ? $c753cc5c2182631d$var$transformUser(updateAuthor) : null,
        updated: wasUpdated ? updated : null,
        started: started,
        timeSpent: timeSpent,
        comment: (0, $7Vbpp.convertAdfStringToObject)(comment)
    };
};
const $c753cc5c2182631d$export$6aeecd2cf08593fc = (worklogs)=>{
    const transformedWorklogs = worklogs.map((worklog)=>$c753cc5c2182631d$export$ff10a173fcd21d1b(worklog));
    return {
        worklogs: (0, $1OM81.normalizeItemArray)(transformedWorklogs, 'id')
    };
};

});

parcelRegister("8uV8a", function(module, exports) {

$parcel$export(module.exports, "getWorklogsQuery", () => $f305cef680ce8d2b$export$c48794b59f51f0fe);

var $hc60A = parcelRequire("hc60A");

var $9s86T = parcelRequire("9s86T");
const $f305cef680ce8d2b$var$worklogParameter = ()=>{
    const { hasPermalink: hasPermalink, permalinkId: permalinkId } = (0, $9s86T.getPermalinkStatus)((0, $hc60A.WORKLOG));
    return hasPermalink ? `worklogId: ${permalinkId}` : '';
};
const $f305cef680ce8d2b$export$c48794b59f51f0fe = (maxResults, startAt, orderBy)=>`
    worklogs (startAt: ${startAt}, maxResults: ${maxResults}, orderBy: "${orderBy}", ${$f305cef680ce8d2b$var$worklogParameter()}) {
        nodes {
            id
            author {
                accountId
                displayName
                avatarUrl
            }
            updateAuthor {
                accountId
                displayName
                avatarUrl
            }
            created
            started
            updated
            comment
            timeSpent
            timeSpentSeconds
        }
        totalCount
        startIndex
    }
`;

});



parcelRegister("6NBhC", function(module, exports) {

$parcel$export(module.exports, "combineResponseData", () => $b0930a652d18bc6d$export$46cf4d87d8093620);

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");


var $3FyZ4 = parcelRequire("3FyZ4");
const $b0930a652d18bc6d$var$projectDefaults = {
    projectId: '',
    projectName: '',
    projectKey: '',
    projectStatus: (0, $5bd9e96e4d7e8aee$export$62113557945f790a),
    projectType: (0, $7ZZxN.SOFTWARE_PROJECT),
    isSimplified: false
};
const $b0930a652d18bc6d$export$46cf4d87d8093620 = (aggLegacyGraphqlData, aggLegacyGiraData, giraData)=>{
    if (!aggLegacyGraphqlData || !aggLegacyGiraData) {
        // The transformers did not return anything - this happens if the data is missing for some reason
        // We should never fall into this case but its here for type checking
        const message = 'Failed to transform issue data from AGG, transformers returned empty value';
        throw new Error(message);
    }
    const jiraSettings = {
        jiraSettings: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...aggLegacyGiraData.jiraSettings,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            newIssueViewTransitionSettings: giraData.jiraSettings?.newIssueViewTransitionSettings
        }
    };
    const attachments = (0, $1ybV0.ff)('issue.details.gira-agg-migration-attachments_ecebe') ? {
        attachments: {
            totalCount: giraData.totalAttachmentsCount || 0,
            nodes: aggLegacyGiraData.attachments || [],
            deletableCount: 0
        }
    } : {
        attachments: giraData.attachments
    };
    if ((0, $1ybV0.ff)('ken-432-missing-project-key-log_hr7zv') && aggLegacyGraphqlData?.project && !aggLegacyGraphqlData?.project?.projectType) (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.getInstance().sendTrackEvent({
            action: 'project-type-investigation',
            attributes: {
                message: 'projectType missing in project data'
            },
            actionSubject: 'project-context',
            source: 'issue-view'
        });
    });
    return {
        ...giraData,
        ...aggLegacyGraphqlData,
        ...aggLegacyGiraData,
        ...jiraSettings,
        ...attachments,
        project: {
            ...$b0930a652d18bc6d$var$projectDefaults,
            ...aggLegacyGraphqlData?.project,
            issueTypes: giraData.issueTypes
        }
    };
};

});



parcelRegister("b3oBM", function(module, exports) {

$parcel$export(module.exports, "default", () => $35688c197c904e81$export$2e2bcd8739ae039);
parcelRequire("cpH8E");
parcelRequire("1NUMQ");
parcelRequire("8jBvP");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $7xwx0 = parcelRequire("7xwx0");


var $eTZsp = parcelRequire("eTZsp");

var $hRcYT = parcelRequire("hRcYT");

var $ibWQr = parcelRequire("ibWQr");

var $2NB1f = parcelRequire("2NB1f");

var $aK1Xv = parcelRequire("aK1Xv");

var $2kF0Y = parcelRequire("2kF0Y");

var $i7QJO = parcelRequire("i7QJO");

var $1OJS4 = parcelRequire("1OJS4");

var $fYteL = parcelRequire("fYteL");

var $5JqpU = parcelRequire("5JqpU");

var $l7DhQ = parcelRequire("l7DhQ");
const $35688c197c904e81$var$throttledActionsTypeMap = {
    [(0, $fYteL.REFRESH_ISSUE_REQUEST)]: 'refresh'
};
const $35688c197c904e81$var$unthtrottledActionsTypeMap = {
    [(0, $fYteL.FETCH_ISSUE_REQUEST)]: 'fetch',
    [(0, $1OJS4.LOAD_NEW_ISSUE)]: 'load-new',
    [(0, $fYteL.FETCH_FORGE_REQUEST)]: 'fetch-forge'
};
const $35688c197c904e81$export$c7c066c19031e48c = {
    ...$35688c197c904e81$var$throttledActionsTypeMap,
    ...$35688c197c904e81$var$unthtrottledActionsTypeMap
};
const $35688c197c904e81$export$e324594224ef24da = Object.keys($35688c197c904e81$export$c7c066c19031e48c);
const $35688c197c904e81$var$unthtrottledActions = Object.keys($35688c197c904e81$var$unthtrottledActionsTypeMap);
const $35688c197c904e81$var$throttledActions = Object.keys($35688c197c904e81$var$throttledActionsTypeMap);
const $35688c197c904e81$var$actionCallback = (action, forgeActions, store, prefetchedResourceManager)=>{
    if (forgeActions.isForgeRateLimited()) return (0, $3JafE.Observable).empty();
    const source = (0, $5JqpU.analyticsSourceSelector)(store.getState());
    // Just in case something goes very much wrong we don't want to call the XIS
    if (!(0, $2NB1f.canFetchForgeModules)()) {
        forgeActions.setForgeLoadingFailed();
        return (0, $3JafE.Observable).empty();
    }
    // These might be set any minute, so don't use them
    let isPrefetchResolved = false;
    let prefetchData;
    // These are set once and contain the correct data
    let isPrefetchedDataResolved = false;
    let isPrefetchedDataValid;
    const actionType = $35688c197c904e81$export$c7c066c19031e48c[action.type];
    const issueForgeData = prefetchedResourceManager?.issueForgeData;
    const isPrefetched = !!issueForgeData;
    const getAttributes = (error)=>{
        const attributes = {
            actionType: actionType,
            isPrefetched: isPrefetched
        };
        if (isPrefetched) {
            attributes.isPrefetchedDataResolved = isPrefetchedDataResolved;
            attributes.isPrefetchedDataValid = isPrefetchedDataValid;
        }
        if (error) {
            attributes.errorType = (0, $eTZsp.getErrorType)(error);
            attributes.error = error;
        }
        return attributes;
    };
    // If the promise is resolved on the next tick we will get the info about it
    issueForgeData?.then((data)=>{
        isPrefetchResolved = true;
        prefetchData = data;
    });
    return (0, $3JafE.Observable).fromPromise(// Simulate the next tick so we can depend on the data from the promise resolution above
    Promise.resolve().then(()=>{
        // This data is set once (right now) and it gets send on success or error
        isPrefetchedDataResolved = isPrefetchResolved;
        isPrefetchResolved && (isPrefetchedDataValid = !!prefetchData);
        // Use prefetched data only when:
        // 1. The promise is still pending
        // 2. The promise is already resolved with a valid data
        if (isPrefetched && (isPrefetchedDataValid || !isPrefetchedDataResolved)) return (0, $2kF0Y.fetchAllForgeDataPromise)(store.getState(), issueForgeData);
        // Otherwise request a fresh data
        return (0, $2kF0Y.fetchAllForgeDataPromise)(store.getState());
    })).map((payload)=>{
        forgeActions.setFailedEventsCount(0);
        if (Math.random() * 100 < (0, $hRcYT.FORGE_SAMPLING_RATE)) (0, $ibWQr.fireInitializationIssueViewFinishedEvent)(source, getAttributes());
        forgeActions.setForge({
            ...payload,
            isForgeDataComplete: true,
            isForgeLoadingFailed: false
        });
        return (0, $i7QJO.fetchForgeSuccess)(payload);
    }).catch((error)=>{
        if (error instanceof (0, $aK1Xv.ForgeFetchError) && error.statusCodes?.includes((0, $1c3fbb431a173cc6$export$6763168a631449a2))) forgeActions.setFailedEventsCount((previousFailedEventsCount)=>previousFailedEventsCount + 1);
        forgeActions.setForgeLoadingFailed();
        (0, $ibWQr.fireInitializationIssueViewFailedEvent)(source, getAttributes(error));
        return (0, $3JafE.Observable).empty();
    });
};
const $35688c197c904e81$var$throttledActionsEpic = (prefetchedResourceManager, forgeActions)=>(action$, store)=>action$.ofType(...$35688c197c904e81$var$throttledActions).pipe((0, $l7DhQ.throttleIssueRefresh)(), (0, $7xwx0.mergeMap)((action)=>$35688c197c904e81$var$actionCallback(action, forgeActions, store, prefetchedResourceManager)));
const $35688c197c904e81$var$unthtrottledActionsEpic = (prefetchedResourceManager, forgeActions)=>(action$, store)=>action$.ofType(...$35688c197c904e81$var$unthtrottledActions).pipe((0, $7xwx0.mergeMap)((action)=>$35688c197c904e81$var$actionCallback(action, forgeActions, store, prefetchedResourceManager)));
const $35688c197c904e81$var$forgeFetchEpic = (prefetchedResourceManager, forgeActions)=>(0, $bd1K7.combineEpics)($35688c197c904e81$var$throttledActionsEpic(prefetchedResourceManager, forgeActions), $35688c197c904e81$var$unthtrottledActionsEpic(prefetchedResourceManager, forgeActions));
var $35688c197c904e81$export$2e2bcd8739ae039 = $35688c197c904e81$var$forgeFetchEpic;

});
parcelRegister("ibWQr", function(module, exports) {

$parcel$export(module.exports, "fireInitializationFetchFinishedEvent", () => $2c36a22053951caa$export$132ca822850e455f);
$parcel$export(module.exports, "fireInitializationFetchFailedEvent", () => $2c36a22053951caa$export$b5ca88b1053f1ad0);
$parcel$export(module.exports, "fireInitializationIssueViewFinishedEvent", () => $2c36a22053951caa$export$e914f7df1e4ad79b);
$parcel$export(module.exports, "fireInitializationIssueViewFailedEvent", () => $2c36a22053951caa$export$b274c658390b491b);

var $TrUS5 = parcelRequire("TrUS5");

var $cYWDh = parcelRequire("cYWDh");
const $2c36a22053951caa$var$INITIALIZATION_ACTIONS = {
    STARTED: 'started',
    FINISHED: 'finished',
    FAILED: 'failed'
};
const $2c36a22053951caa$export$917d0643b0111a02 = (0, $TrUS5.toEventId)('issueViewInitialization');
const $2c36a22053951caa$export$43e875fd63e64525 = (0, $TrUS5.toEventId)('fetchModulesInitialization');
const $2c36a22053951caa$export$132ca822850e455f = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $2c36a22053951caa$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $2c36a22053951caa$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $2c36a22053951caa$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $2c36a22053951caa$export$e914f7df1e4ad79b = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $2c36a22053951caa$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });
const $2c36a22053951caa$export$b274c658390b491b = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $2c36a22053951caa$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });

});

parcelRegister("2NB1f", function(module, exports) {

$parcel$export(module.exports, "canFetchForgeModules", () => $54017b90132e06f5$export$bb3a4a3b8e654c08);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-legacy

var $e91YZ = parcelRequire("e91YZ");
const $54017b90132e06f5$export$bb3a4a3b8e654c08 = ()=>{
    const { isAnonymous: isAnonymous, cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    /**
	 * SMT-1142
	 * A tenant named `bob` is most likely a local/ci instance started with `./jmake run ci`.
	 * It wasn't possible to find the hostname in a reasonable timeframe so this is the most feasible solution.
	 * In case more tenants like this spawn in the future we'd need to mark these instances instead and block here.
	 */ if (String(cloudId) === 'bob') return false;
    // There is no anonymous access for now
    return !isAnonymous;
};

});

parcelRegister("aK1Xv", function(module, exports) {

$parcel$export(module.exports, "ForgeFetchError", () => $15fba2ae14b689a6$export$2e3b53e53bafa);
class $15fba2ae14b689a6$export$2e3b53e53bafa extends Error {
    constructor(message, traceId, errors){
        super(message);
        this.name = $15fba2ae14b689a6$export$2e3b53e53bafa.name;
        this.traceId = traceId;
        this.statusCodes = errors?.map((graphQLError)=>graphQLError?.extensions?.statusCode).filter((x)=>x != null);
        if (Error.captureStackTrace) Error.captureStackTrace(this, $15fba2ae14b689a6$export$2e3b53e53bafa);
    }
}

});

parcelRegister("2kF0Y", function(module, exports) {

$parcel$export(module.exports, "fetchAllForgeDataPromise", () => $dc16bd33dab00e9c$export$7290823e673b3c1b);

var $3JafE = parcelRequire("3JafE");
parcelRequire("cpH8E");

var $5JqpU = parcelRequire("5JqpU");

var $1KrFd = parcelRequire("1KrFd");
const $dc16bd33dab00e9c$export$7290823e673b3c1b = (state, issueForgeData)=>(0, $1KrFd.fetchAllForgeData)((0, $5JqpU.cloudIdSelector)(state), (0, $5JqpU.issueKeySelector)(state), (0, $5JqpU.activationIdSelector)(state), issueForgeData);
const $dc16bd33dab00e9c$export$ed659d00cd64b581 = (state, prefetchResourceManager)=>{
    const cloudId = (0, $5JqpU.cloudIdSelector)(state);
    const issueKey = (0, $5JqpU.issueKeySelector)(state);
    const activationId = (0, $5JqpU.activationIdSelector)(state);
    return (0, $3JafE.Observable).fromPromise((0, $1KrFd.fetchAllForgeData)(cloudId, issueKey, activationId, prefetchResourceManager && prefetchResourceManager.issueForgeData));
};

});
parcelRegister("1KrFd", function(module, exports) {

$parcel$export(module.exports, "fetchAllForgeData", () => $14641713f91aefd5$export$ed659d00cd64b581);

var $27Eo5 = parcelRequire("27Eo5");
const $14641713f91aefd5$export$ed659d00cd64b581 = async (cloudId, issueKey, activationId, prefetchedResource)=>prefetchedResource || (0, $27Eo5.fetchIssueForgeData)(cloudId, issueKey, activationId);

});
parcelRegister("27Eo5", function(module, exports) {

$parcel$export(module.exports, "fetchIssueForgeData", () => $28f36679da26750f$export$44da8345d9ceca61);

var $1ybV0 = parcelRequire("1ybV0");

var $2Rqjr = parcelRequire("2Rqjr");

var $arKaN = parcelRequire("arKaN");

var $cqw2K = parcelRequire("cqw2K");
const $28f36679da26750f$export$7c6ea4184129ef74 = (result, type)=>result.find((extensions)=>extensions.some((extension)=>extension.type === type)) || [];
const $28f36679da26750f$export$44da8345d9ceca61 = async (cloudId, issueKey, activationId)=>{
    const modulesToFetch = [
        (0, $2Rqjr.ISSUE_ACTION_MODULE),
        (0, $2Rqjr.ISSUE_GLANCE_MODULE),
        (0, $2Rqjr.ISSUE_CONTEXT_MODULE),
        (0, $2Rqjr.ISSUE_PANEL_MODULE),
        (0, $2Rqjr.ISSUE_ACTIVITY_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE),
        (0, $2Rqjr.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
        (0, $2Rqjr.UI_MODIFICATIONS_MODULE)
    ];
    const contextIds = (0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x') ? [
        `ari:cloud:jira:${cloudId}:workspace/${activationId}`
    ] : undefined;
    const result = await (0, $arKaN.default)(cloudId, modulesToFetch, {
        issueKey: issueKey
    }, {
        include: {
            scopes: true
        }
    }, (0, $2Rqjr.SOURCE_ISSUE_VIEW), contextIds);
    const { extensions: extensions, accessNarrowedExtensions: accessNarrowedExtensions } = result;
    const mappedResult = {
        issueAction: extensions.jiraIssueAction || [],
        issueGlance: extensions.jiraIssueGlance || [],
        issueContext: extensions.jiraIssueContext || [],
        issuePanel: extensions.jiraIssuePanel || [],
        issueActivity: extensions.jiraIssueActivity || [],
        customField: extensions.jiraCustomField || [],
        customFieldType: extensions.jiraCustomFieldType || [],
        issueViewBackgroundScript: extensions.jiraIssueViewBackgroundScript || [],
        uiModifications: extensions.jiraUiModifications || [],
        blockedExtensions: {
            issueAction: accessNarrowedExtensions.jiraIssueAction || [],
            issueGlance: accessNarrowedExtensions.jiraIssueGlance || [],
            issueContext: accessNarrowedExtensions.jiraIssueContext || [],
            issuePanel: accessNarrowedExtensions.jiraIssuePanel || [],
            issueActivity: accessNarrowedExtensions.jiraIssueActivity || [],
            customField: accessNarrowedExtensions.jiraCustomField || [],
            customFieldType: accessNarrowedExtensions.jiraCustomFieldType || [],
            issueViewBackgroundScript: accessNarrowedExtensions.jiraIssueViewBackgroundScript || [],
            uiModifications: accessNarrowedExtensions.jiraUiModifications || []
        }
    };
    return (0, $cqw2K.dedupeContextAndGlance)(mappedResult);
};

});
parcelRegister("arKaN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cf6fc741e8eb3f0$export$2e2bcd8739ae039);

var $jh2R9 = parcelRequire("jh2R9");

var $fcWBJ = parcelRequire("fcWBJ");

var $cnRoI = parcelRequire("cnRoI");

var $2vzCR = parcelRequire("2vzCR");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $eTZsp = parcelRequire("eTZsp");

var $eTZsp = parcelRequire("eTZsp");

var $cHWHh = parcelRequire("cHWHh");

var $hRcYT = parcelRequire("hRcYT");

var $ibWQr = parcelRequire("ibWQr");

var $2Rqjr = parcelRequire("2Rqjr");

var $2NB1f = parcelRequire("2NB1f");

var $02sMi = parcelRequire("02sMi");

var $lcqkg = parcelRequire("lcqkg");

var $aK1Xv = parcelRequire("aK1Xv");

var $h4b1Y = parcelRequire("h4b1Y");

var $dHbiB = parcelRequire("dHbiB");
const $3cf6fc741e8eb3f0$var$moduleToVariableKey = (module)=>(0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(module);
const $3cf6fc741e8eb3f0$export$3361e9be8093ddcc = (extensions)=>{
    const groupedExtensions = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(extensions, 'type');
    const groupedExtensionsWithMappedKeys = (0, (/*@__PURE__*/$parcel$interopDefault($cnRoI)))(groupedExtensions, (_, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        $3cf6fc741e8eb3f0$var$moduleToVariableKey(key));
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(groupedExtensionsWithMappedKeys, (0, $2Rqjr.getEmptyExtensionsObject)());
};
const $3cf6fc741e8eb3f0$export$44097e02a91cd11a = (extensions)=>{
    const groupedExtensions = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(extensions, 'type');
    const groupedExtensionsWithMappedKeys = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, (/*@__PURE__*/$parcel$interopDefault($cnRoI)))(groupedExtensions, (_, key)=>$3cf6fc741e8eb3f0$var$moduleToVariableKey(key)), (0, $2Rqjr.getEmptyExtensionsObject)());
    const filteredOutDuplicatedExtensions = (0, $02sMi.filterOutDuplicatedExtensions)(groupedExtensionsWithMappedKeys);
    const allowedExtensions = (0, $2Rqjr.getEmptyExtensionsObject)();
    const accessNarrowedExtensions = (0, $2Rqjr.getEmptyExtensionsObject)();
    Object.entries(filteredOutDuplicatedExtensions).forEach(([key, module])=>{
        const allowedExtensionsMap = new Map();
        const accessNarrowedExtensionsMap = new Map();
        module.forEach((moduleItem)=>{
            if (moduleItem?.dataClassificationPolicyDecision?.status === 'BLOCKED') accessNarrowedExtensionsMap.set(moduleItem.id, moduleItem);
            else allowedExtensionsMap.set(moduleItem.id, moduleItem);
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        allowedExtensions[key] = [
            ...allowedExtensionsMap.values()
        ];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        accessNarrowedExtensions[key] = [
            ...accessNarrowedExtensionsMap.values()
        ];
    });
    return {
        extensions: allowedExtensions,
        accessNarrowedExtensions: accessNarrowedExtensions
    };
};
const $3cf6fc741e8eb3f0$var$EXCLUDED_ERROR_TYPES = [
    (0, $eTZsp.FAILED_TO_FETCH),
    (0, $eTZsp.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
    (0, $eTZsp.DATA_CLASSIFICATION_NO_ACCESS)
];
const $3cf6fc741e8eb3f0$var$fetchModulesWithTraceId = async (cloudId, modules, dataClassification, extras, contextIds, source)=>{
    if (modules.length === 0) throw new Error('No modules to fetch provided');
    const dataClassificationTags = await (0, $lcqkg.getDataClassification)(dataClassification, source);
    const includeConfig = extras?.include || {};
    const query = (0, $dHbiB.buildForgeQuery)(includeConfig);
    const variables = {
        contextIds: contextIds || [
            `ari:cloud:jira::site/${cloudId}`
        ],
        extensionsFilter: [
            {
                type: 'EXTENSION_TYPE',
                value: modules
            }
        ],
        dataClassificationTags: dataClassificationTags.map((id)=>`ari:cloud:platform::classification-tag/${id}`)
    };
    const { data: data, errors: errors, extensions: extensions } = await (0, $cHWHh.measureExecutionTimeMetrics)((0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME, ()=>(0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: variables
            }),
            method: 'POST'
        }));
    const traceId = (0, $h4b1Y.getTraceIdFromExtensions)({
        extensions: extensions
    });
    if (errors) {
        if ((0, $1ybV0.ff)('forge-graphql-errors-analytics_3tm4m')) throw new (0, $aK1Xv.ForgeFetchError)(`Response ended with an error message: ${errors // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .map((error)=>error.message).join('. ')}`, traceId, errors);
        throw new (0, $aK1Xv.ForgeFetchError)(`Response ended with an error message: ${errors[0].message}`, traceId, errors);
    }
    if (!data) throw new (0, $aK1Xv.ForgeFetchError)('No data returned', traceId, errors);
    if (data.extensionContexts.length < 1) throw new (0, $aK1Xv.ForgeFetchError)('No extensionContext returned', traceId, errors);
    return {
        data: data,
        traceId: traceId
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3cf6fc741e8eb3f0$export$2e2bcd8739ae039 = async (cloudId, modules, dataClassification, extras, source = (0, $2Rqjr.SOURCE_UNKNOWN), contextIds)=>{
    try {
        // Just in case something goes very much wrong we don't want to call the XIS
        if (!(0, $2NB1f.canFetchForgeModules)()) return {
            extensions: (0, $2Rqjr.getEmptyExtensionsObject)(),
            accessNarrowedExtensions: (0, $2Rqjr.getEmptyExtensionsObject)()
        };
        const { data: data, traceId: traceId } = await $3cf6fc741e8eb3f0$var$fetchModulesWithTraceId(cloudId, modules, dataClassification, extras, contextIds, source);
        if (Math.random() * 100 < (0, $hRcYT.FORGE_SAMPLING_RATE)) (0, $ibWQr.fireInitializationFetchFinishedEvent)(source, {
            traceId: traceId
        });
        return $3cf6fc741e8eb3f0$export$44097e02a91cd11a(data.extensionContexts[0].extensions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const errorType = (0, $eTZsp.getErrorType)(error);
        const traceId = (0, $h4b1Y.getTraceIdFromError)(error);
        (0, $ibWQr.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error,
            traceId: traceId
        });
        if ($3cf6fc741e8eb3f0$var$EXCLUDED_ERROR_TYPES.includes(errorType)) return {
            extensions: (0, $2Rqjr.getEmptyExtensionsObject)(),
            accessNarrowedExtensions: (0, $2Rqjr.getEmptyExtensionsObject)()
        };
        throw error;
    }
};

});
parcelRegister("cHWHh", function(module, exports) {

$parcel$export(module.exports, "measureExecutionTimeMetrics", () => $69ad25e8e60753eb$export$a859f6866f4653e0);

var $1ybV0 = parcelRequire("1ybV0");

var $hRcYT = parcelRequire("hRcYT");

var $d6g7g = parcelRequire("d6g7g");
const $69ad25e8e60753eb$export$a859f6866f4653e0 = async (key, action)=>{
    const shouldSendTimeMetric = !(0, $1ybV0.ff)('fetch-forge-modules-sampling_1e415') || Math.random() * 100 < (0, $hRcYT.FORGE_SAMPLING_RATE);
    try {
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesFetchTime).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesFetchTime).stop({
            stopTime: performance.now()
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesFetchTime).cancel();
        throw error;
    }
};

});

parcelRegister("02sMi", function(module, exports) {

$parcel$export(module.exports, "filterOutDuplicatedExtensions", () => $e5793a48e1add67f$export$e0393e97f15a28a5);

var $fUTZC = parcelRequire("fUTZC");

var $2Rqjr = parcelRequire("2Rqjr");
const $e5793a48e1add67f$export$e0393e97f15a28a5 = (modules)=>{
    const filteredModules = (0, $2Rqjr.getEmptyExtensionsObject)();
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(modules, (module, propName)=>{
        const moduleExtensions = new Map();
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(module, (moduleItem)=>{
            const moduleExtension = moduleExtensions.get(moduleItem.id);
            const appVersion = moduleItem?.appVersion || '0.0.0';
            const moduleAppVersion = moduleExtension?.appVersion || '0.0.0';
            if (!moduleExtension || moduleExtension && appVersion >= moduleAppVersion) moduleExtensions.set(moduleItem.id, moduleItem);
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        filteredModules[propName] = [
            ...moduleExtensions.values()
        ];
    });
    return filteredModules;
};

});

parcelRegister("lcqkg", function(module, exports) {

$parcel$export(module.exports, "getDataClassification", () => $7179ddf7ab2ecdfc$export$1635afa94064952c);

var $lRmyA = parcelRequire("lRmyA");

var $eTZsp = parcelRequire("eTZsp");

var $eTZsp = parcelRequire("eTZsp");

var $ibWQr = parcelRequire("ibWQr");

var $7i1xd = parcelRequire("7i1xd");

var $bNd3G = parcelRequire("bNd3G");
const $7179ddf7ab2ecdfc$var$handleError = (err, source)=>{
    const errorMessage = err instanceof Error ? err.message : String(err);
    const error = Error(`Data classification request failed: ${errorMessage}`);
    const errorType = (0, $eTZsp.getErrorType)(error);
    // prevent fetching extensions in case of no access
    if (errorType === (0, $eTZsp.DATA_CLASSIFICATION_NO_ACCESS)) throw error;
    (0, $ibWQr.fireInitializationFetchFailedEvent)(source, {
        isSSR: false,
        errorType: errorType,
        error: error
    });
    // otherwise, optimistically fetch the extensions
    return [];
};
async function $7179ddf7ab2ecdfc$var$getDataClassificationIssue(props, source) {
    try {
        const now = Date.now();
        const cachedResult = (0, $bNd3G.DataClassificationTagsCache).get(`${(0, $bNd3G.issueKeyPrefix)}-${props.issueKey}`);
        const isCacheResultTimePassed = Boolean(cachedResult && (0, $bNd3G.TTL) < now - cachedResult.timestamp);
        if (isCacheResultTimePassed || !cachedResult) {
            const data = await (0, $lRmyA.performGetRequest)(`/rest/internal/3/data-classification/resource/issue/${props.issueKey}`);
            (0, $bNd3G.DataClassificationTagsCache).set(`${(0, $bNd3G.issueKeyPrefix)}-${props.issueKey}`, {
                tags: data.tags,
                timestamp: now
            });
            return data.tags;
        }
        return cachedResult.tags;
    } catch (err) {
        return $7179ddf7ab2ecdfc$var$handleError(err, source);
    }
}
async function $7179ddf7ab2ecdfc$var$getDataClassificationProject(props, source) {
    try {
        const now = Date.now();
        const cachedResult = (0, $bNd3G.DataClassificationTagsCache).get(`${(0, $bNd3G.projectKeyPrefix)}-${props.projectIdOrKey}`);
        const isCacheResultTimePassed = Boolean(cachedResult && (0, $bNd3G.TTL) < now - cachedResult.timestamp);
        if (isCacheResultTimePassed || !cachedResult) {
            const data = await (0, $lRmyA.performGetRequest)(`/rest/internal/3/data-classification/resource/container/${props.projectIdOrKey}`);
            (0, $bNd3G.DataClassificationTagsCache).set(`${(0, $bNd3G.projectKeyPrefix)}-${props.projectIdOrKey}`, {
                tags: data.tags,
                timestamp: now
            });
            return data.tags;
        }
        return cachedResult.tags;
    } catch (err) {
        return $7179ddf7ab2ecdfc$var$handleError(err, source);
    }
}
const $7179ddf7ab2ecdfc$export$1635afa94064952c = async (props, source)=>{
    if (props !== null) {
        if ((0, $7i1xd.hasPrefetchedData)(props)) return props.tags;
        if ((0, $7i1xd.hasProjectIdOrKey)(props)) {
            const tags = await $7179ddf7ab2ecdfc$var$getDataClassificationProject(props, source);
            return tags;
        }
        if ((0, $7i1xd.hasIssueKey)(props)) {
            const tags = await $7179ddf7ab2ecdfc$var$getDataClassificationIssue(props, source);
            return tags;
        }
    }
    return [];
};

});
parcelRegister("7i1xd", function(module, exports) {

$parcel$export(module.exports, "hasPrefetchedData", () => $f4d16f0e4c0cff8e$export$c19d255b92c7c2da);
$parcel$export(module.exports, "hasProjectIdOrKey", () => $f4d16f0e4c0cff8e$export$494434246e5dea0d);
$parcel$export(module.exports, "hasIssueKey", () => $f4d16f0e4c0cff8e$export$b1490cfc7a90c75b);

var $1c8hB = parcelRequire("1c8hB");
const $f4d16f0e4c0cff8e$export$c19d255b92c7c2da = (props)=>props !== null && 'tags' in props && (0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(props.tags);
const $f4d16f0e4c0cff8e$export$494434246e5dea0d = (props)=>props !== null && 'projectIdOrKey' in props;
const $f4d16f0e4c0cff8e$export$b1490cfc7a90c75b = (props)=>props !== null && 'issueKey' in props;

});

parcelRegister("bNd3G", function(module, exports) {

$parcel$export(module.exports, "TTL", () => $eb16233a4e558eb3$export$6ebb1381174e92a7);
$parcel$export(module.exports, "issueKeyPrefix", () => $eb16233a4e558eb3$export$a040db2850f159b0);
$parcel$export(module.exports, "projectKeyPrefix", () => $eb16233a4e558eb3$export$df256a06d24ff906);
$parcel$export(module.exports, "DataClassificationTagsCache", () => $eb16233a4e558eb3$export$b7adc37405b5ff0d);
const $eb16233a4e558eb3$export$6ebb1381174e92a7 = 60000;
const $eb16233a4e558eb3$export$a040db2850f159b0 = 'issue';
const $eb16233a4e558eb3$export$df256a06d24ff906 = 'project';
const $eb16233a4e558eb3$export$b7adc37405b5ff0d = new Map();

});


parcelRegister("h4b1Y", function(module, exports) {

$parcel$export(module.exports, "getTraceIdFromExtensions", () => $7f43992f867249de$export$eefb7f54c3b07211);
$parcel$export(module.exports, "getTraceIdFromError", () => $7f43992f867249de$export$9955d05ba83067ba);

var $7byHA = parcelRequire("7byHA");

var $aK1Xv = parcelRequire("aK1Xv");
const $7f43992f867249de$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    const traceId = extensions?.gateway?.request_id;
    if (traceId && typeof traceId === 'string') return traceId;
    return undefined;
};
const $7f43992f867249de$export$9955d05ba83067ba = (error)=>{
    if (error instanceof (0, $aK1Xv.ForgeFetchError) || error instanceof (0, $7byHA.default)) return error.traceId;
    return undefined;
};

});

parcelRegister("dHbiB", function(module, exports) {

$parcel$export(module.exports, "buildForgeQuery", () => $adcc945170c9b90f$export$497b2dc04db7bd76);
const $adcc945170c9b90f$export$497b2dc04db7bd76 = (include)=>{
    const consentFields = `
    consentUrl
    currentUserConsent {
        user {
            aaid
        }
        appEnvironmentVersion {
            id
        }
        consentedAt
    }
    requiresUserConsent`;
    const scopesField = include.scopes === true ? 'scopes' : '';
    const licenseFields = `
    license {
        active
        type
        supportEntitlementNumber
        trialEndDate
        subscriptionEndDate
        isEvaluation
        billingPeriod
        ccpEntitlementId
        ccpEntitlementSlug
    }`;
    return `query jira_forge_frontendModules($contextIds: [ID!]! $extensionsFilter: [ExtensionContextsFilter!]! $dataClassificationTags: [ID!]!) {
        extensionContexts(contextIds: $contextIds) @optIn(to: "Access-Narrowing") {
            extensions(filter: $extensionsFilter) {
                id
                appVersion
                installationId
                environmentId
                environmentType
                environmentKey
                properties
                ${licenseFields}
                ${scopesField}
                type
                __typename
                ${consentFields}
                egress {
                    type
                    addresses
                }
                dataClassificationPolicyDecision(input: {
                    dataClassificationTags: $dataClassificationTags
                }) {
                    status
                }   
            }
        }
    }`;
};

});


parcelRegister("cqw2K", function(module, exports) {

$parcel$export(module.exports, "dedupeContextAndGlance", () => $d64b2f99c2b8c70a$export$17503ba1adfac304);
const $d64b2f99c2b8c70a$export$17503ba1adfac304 = (forgeData)=>{
    const contextInstallationIds = new Set(forgeData.issueContext?.map(({ installationId: installationId })=>installationId));
    const newGlanceItems = forgeData.issueGlance.filter(({ installationId: installationId })=>!contextInstallationIds.has(installationId));
    return {
        ...forgeData,
        issueGlance: newGlanceItems
    };
};

});





parcelRegister("kkFK3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c5a34059d71b31$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("3wBUP");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $8Bhia = parcelRequire("8Bhia");

var $a0kZP = parcelRequire("a0kZP");

var $5nezI = parcelRequire("5nezI");

var $02hYD = parcelRequire("02hYD");

var $5JqpU = parcelRequire("5JqpU");
const $d9c5a34059d71b31$export$7ab1033f726bb463 = (issue, associatedIssuesContextActions)=>{
    if (!associatedIssuesContextActions) return;
    // Update the associated issue context store with the isResolved state of the new linked issues
    const remoteLinkedIssues = issue.remoteLinks?.remoteLinkedIssues || [];
    const newLinkedIssuesContext = {};
    remoteLinkedIssues.forEach((remoteLinkedIssue)=>{
        if (!!remoteLinkedIssue.details && 'associatedIssue' in remoteLinkedIssue.details) {
            const remoteLinkedIssueGlobalId = remoteLinkedIssue.preview.globalId;
            if (remoteLinkedIssueGlobalId) Object.assign(newLinkedIssuesContext, {
                [remoteLinkedIssueGlobalId]: {
                    isResolved: remoteLinkedIssue.details.associatedIssue.isResolved ?? false
                }
            });
        }
    });
    associatedIssuesContextActions.mergeRemoteAssociatedIssuesContext(newLinkedIssuesContext);
};
const $d9c5a34059d71b31$export$2f1cf9345b43b55 = (dataProvider, associatedIssuesContextActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (action$, store)=>// @ts-expect-error - TS2345 - Argument of type '(action: any) => Observable<{ type: "FETCH_ISSUE_REMOTE_DATA_SUCCESS"; payload: any; }> | Observable<{ type: "FETCH_ISSUE_REMOTE_DATA_FAILURE"; }>' is not assignable to parameter of type '(value: any, index: number) => ObservableInput<{ type: "FETCH_ISSUE_REMOTE_DATA_SUCCESS"; payload: any; }>'.
        action$.ofType((0, $5nezI.FETCH_ISSUE_REMOTE_DATA_REQUEST)).switchMap((action)=>{
            if (action.payload) {
                const issueKey = action.payload;
                const state = store.getState();
                const cloudId = (0, $5JqpU.cloudIdSelector)(state);
                return dataProvider.getIssueRemoteData$(issueKey, cloudId, (0, $8Bhia.isIssueViewWhiteboardsStandaloneEnabled)()).filter(()=>issueKey === (0, $5JqpU.issueKeySelector)(store.getState())).do((issue)=>{
                    $d9c5a34059d71b31$export$7ab1033f726bb463(issue, associatedIssuesContextActions);
                }).flatMap((issue)=>(0, $3JafE.Observable).of((0, $5nezI.fetchIssueRemoteDataSuccess)(issue)));
            }
            // if we don't get payload back from backend, still need to trigger action telling remote data has been loaded
            // so we can still smooth scroll.
            return (0, $3JafE.Observable).of((0, $5nezI.fetchIssueRemoteDataFailure)());
        });
const $d9c5a34059d71b31$export$bceaafba568c208c = (dataProvider, associatedIssuesContextActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (action$, store)=>action$.ofType((0, $a0kZP.APPLINK_AUTHENTICATION_SUCCESS), (0, $02hYD.SAVE_REMOTE_LINKED_ISSUE_SUCCESS)).switchMap(()=>{
            const state = store.getState();
            const issueKey = (0, $5JqpU.issueKeySelector)(state);
            const cloudId = (0, $5JqpU.cloudIdSelector)(state);
            return issueKey ? dataProvider.getIssueRemoteData$(issueKey, cloudId, (0, $8Bhia.isIssueViewWhiteboardsStandaloneEnabled)()).filter(()=>issueKey === (0, $5JqpU.issueKeySelector)(store.getState())).do((issue)=>{
                $d9c5a34059d71b31$export$7ab1033f726bb463(issue, associatedIssuesContextActions);
            }).flatMap((issue)=>(0, $3JafE.Observable).of((0, $5nezI.fetchIssueRemoteDataSuccess)(issue))) : (0, $3JafE.Observable).empty();
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d9c5a34059d71b31$export$2e2bcd8739ae039 = (dataProvider, associatedIssuesContextActions)=>(0, $bd1K7.combineEpics)($d9c5a34059d71b31$export$2f1cf9345b43b55(dataProvider, associatedIssuesContextActions), $d9c5a34059d71b31$export$bceaafba568c208c(dataProvider, associatedIssuesContextActions));

});

parcelRegister("6kT4X", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e0fc53627129a0b$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $jUhyG = parcelRequire("jUhyG");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");

var $4ceCM = parcelRequire("4ceCM");

var $5frVT = parcelRequire("5frVT");

var $lXPVG = parcelRequire("lXPVG");

var $5JqpU = parcelRequire("5JqpU");

var $jMP2a = parcelRequire("jMP2a");
const $3e0fc53627129a0b$var$LOG_LOCATION = 'issue.delete.issue-delete-epic';
const $3e0fc53627129a0b$var$fireAnalytics = (event, action, actionSubjectId, error)=>{
    if (error) (0, $jMP2a.fireOperationalAnalytics)(event, action, actionSubjectId);
    else (0, $jUhyG.fireTrackAnalytics)(event, {
        action: action,
        actionSubjectId: actionSubjectId
    });
};
const $3e0fc53627129a0b$var$getMessageFromError = (error)=>{
    try {
        return JSON.parse(error.message).errorMessages[0];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return 'Failed to delete issue';
    }
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$3e0fc53627129a0b$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $lXPVG.DELETE_ISSUE_REQUEST)).mergeMap(({ payload: payload })=>{
        const { issueKey: issueKey, analyticsEvent: analyticsEvent, application: application, edition: edition } = payload;
        const baseUrl = (0, $5JqpU.baseUrlSelector)(store.getState());
        return (0, $5frVT.deleteIssue)(baseUrl, issueKey).map(()=>{
            // @ts-expect-error - TS2554 - Expected 4 arguments, but got 3.
            $3e0fc53627129a0b$var$fireAnalytics(analyticsEvent, 'deleted', 'issueDeleted');
            return (0, $lXPVG.deleteIssueSuccess)(issueKey);
        }).do(()=>{
            if ((0, $1ybV0.ff)('metric_for_issue_delete_for_slo_o418h')) (0, $4ceCM.sendExperienceAnalytics)({
                experience: 'deleteIssueSucceeded',
                wasExperienceSuccesful: true,
                analyticsSource: 'issueDeleted',
                application: application ?? null,
                edition: edition ?? null
            });
        }).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData($3e0fc53627129a0b$var$LOG_LOCATION, 'Failed to delete issue', error);
            $3e0fc53627129a0b$var$fireAnalytics(analyticsEvent, 'delete failed', 'issueDeletedError', error);
            if ((0, $1ybV0.ff)('metric_for_issue_delete_for_slo_o418h')) {
                if (!((0, $1ybV0.ff)('ken-429-restrict-4xx-error_vi8v7') && (0, $JRB5w.isHttpClientErrorResponse)(error))) (0, $4ceCM.sendExperienceAnalytics)({
                    experience: 'deleteIssueFailed',
                    wasExperienceSuccesful: false,
                    analyticsSource: 'issueDeleted',
                    application: application ?? null,
                    edition: edition ?? null
                });
            }
            return (0, $3JafE.Observable).of((0, $lXPVG.deleteIssueFailure)(issueKey, $3e0fc53627129a0b$var$getMessageFromError(error)));
        });
    });

});
parcelRegister("5frVT", function(module, exports) {

$parcel$export(module.exports, "deleteIssue", () => $48a0ddb6976e6404$export$b84ab2a9dce1e21a);

var $aiRd8 = parcelRequire("aiRd8");
const $48a0ddb6976e6404$var$getDeletionUrl = (baseUrl, issueKey)=>`${baseUrl}/rest/api/3/issue/${issueKey}?deleteSubtasks=true`;
const $48a0ddb6976e6404$export$b84ab2a9dce1e21a = (baseUrl, issueKey)=>{
    const deleteIssueUrl = $48a0ddb6976e6404$var$getDeletionUrl(baseUrl, issueKey);
    return (0, $aiRd8.default)(deleteIssueUrl, {
        method: 'DELETE'
    });
};

});


parcelRegister("1OLof", function(module, exports) {

$parcel$export(module.exports, "default", () => $55eb14474ca4d59a$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("5hZYM");
parcelRequire("flmol");
parcelRequire("8OtG5");
parcelRequire("l5lul");
parcelRequire("iects");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");


var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $7eDnP = parcelRequire("7eDnP");



var $7hH7F = parcelRequire("7hH7F");

var $RvFPW = parcelRequire("RvFPW");
var $3A3OQ = parcelRequire("3A3OQ");

var $47oY8 = parcelRequire("47oY8");

var $58ToG = parcelRequire("58ToG");

var $f9RL0 = parcelRequire("f9RL0");

var $7PTrm = parcelRequire("7PTrm");
var $cxdSy = parcelRequire("cxdSy");

var $8Bhia = parcelRequire("8Bhia");

var $3b0Pa = parcelRequire("3b0Pa");

var $1OJS4 = parcelRequire("1OJS4");

var $fYteL = parcelRequire("fYteL");

var $20th5 = parcelRequire("20th5");

var $jsDaf = parcelRequire("jsDaf");

var $hlJEN = parcelRequire("hlJEN");

var $7yNiv = parcelRequire("7yNiv");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $6vrw7 = parcelRequire("6vrw7");

var $9OxOE = parcelRequire("9OxOE");
const $55eb14474ca4d59a$export$78c6267359db7e73 = (rawError, accountId)=>{
    let error = (0, $12cc22d0c60f7bfc$export$f10b32dfda12e96e);
    // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | IssueViewFetchError'.
    if (rawError.statusCode === (0, $1c3fbb431a173cc6$export$67d19e9a991baa07)) error = (0, $12cc22d0c60f7bfc$export$99405616af30f11f);
    else if (rawError.statusCode === (0, $1c3fbb431a173cc6$export$a3269a3914b007e3)) error = (0, $12cc22d0c60f7bfc$export$4e094d34a5cb1872);
    else if (rawError.statusCode === (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef)) error = (0, $12cc22d0c60f7bfc$export$4e094d34a5cb1872);
    else if (// @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | IssueViewFetchError'.
    !rawError.statusCode || // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | IssueViewFetchError'.
    (0, $cxdSy.statusCodesNotImpactingReliability).includes(rawError.statusCode)) error = (0, $12cc22d0c60f7bfc$export$683dbe11f74cd161);
    else if (!accountId) error = (0, $12cc22d0c60f7bfc$export$99405616af30f11f);
    if (rawError instanceof (0, $7PTrm.IssueViewFetchError)) {
        const rawIssueViewFetchError = rawError;
        const { endpoint: endpoint, traceId: traceId, statusCode: statusCode, message: message } = rawIssueViewFetchError;
        return {
            errorMessage: statusCode ? `${message}, endpoint: ${endpoint}, status code: ${statusCode}` : `${message}, endpoint: ${endpoint}`,
            endpoint: endpoint,
            traceId: traceId,
            statusCode: statusCode,
            error: error
        };
    }
    if (rawError instanceof (0, $7byHA.default)) {
        const rawFetchError = rawError;
        const { message: message, statusCode: statusCode, traceId: traceId } = rawFetchError;
        return {
            error: error,
            statusCode: statusCode,
            errorMessage: `${message}, status code: ${statusCode}`,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...traceId ? {
                traceId: traceId
            } : {}
        };
    }
    return {
        error: error,
        statusCode: undefined
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$55eb14474ca4d59a$export$2e2bcd8739ae039 = ({ fieldValueActions: fieldValueActions, fieldConfigActions: fieldConfigActions, issueViewLayoutActions: issueViewLayoutActions, ecosystemActions: ecosystemActions, userPreferenceActions: userPreferenceActions, permissionActions: permissionActions, attachmentActions: attachmentActions, projectContextActions: projectContextActions, prefetchedResourceManager: prefetchedResourceManager, jiraSettingsActions: jiraSettingsActions, issueContextActions: issueContextActions, associatedIssuesContextActions: associatedIssuesContextActions, issueRefreshServiceActions: issueRefreshServiceActions })=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (action$, store)=>action$.ofType((0, $fYteL.FETCH_ISSUE_REQUEST), (0, $1OJS4.LOAD_NEW_ISSUE)).switchMap(()=>{
            (0, $RvFPW.clearFetchIssueNetworkTimes)();
            const state = store.getState();
            const loggedInAccountId = (0, $5JqpU.accountIdloggedInUserSelector)(state);
            const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
            const maxTokenLength = issueContextActions.getMaxTokenLength();
            const isServiceDesk = (0, $jZDJX.isServiceDeskSelector)(state);
            // Since fetch services used in here depend on the Redux store data, we need to extract issue key from there as well,
            // otherwise we might end up with an out of the sync state where we fetch details for an issue from the Redux store
            // but merge it with totally different issue key from the React sweet state.
            const issueKey = (0, $5JqpU.issueKeySelector)(state);
            issueContextActions.mergeIssueContext({
                isArchived: false
            });
            if ((0, $1ybV0.ff)('issue-view-classification-level-editability_88zal')) issueContextActions.mergeIssueContext({
                isClassifyEditEnabled: false
            });
            // if we're about to kick off a request for gira data with redux, we're ready for it to arrive
            (0, $9OxOE.blockedOnBackendEntryLog).markStartBackendBlockingTimestamp((0, $848ef1328a091c81$export$1ea0ab50283b82a8));
            const fetchAllAppDataWithRetries$ = (0, $3b0Pa.fetchAllAppDataWithRetries)(state, prefetchedResourceManager);
            const fetchAllAppDataWithRetriesCancellable$ = fetchAllAppDataWithRetries$.takeUntil(action$.ofType((0, $fYteL.CANCEL_REFRESH_ISSUE_REQUEST)));
            if ((0, $8Bhia.isIssueFetchEpicPrefetchedAGGQueryLoggingEnabled)() && prefetchedResourceManager?.issueAggData == null) /**
				 * For https://jplat.atlassian.net/browse/JIV-15378
				 *
				 * We're collecting cases where `issue-fetch-epic` has to execute `mainIssueAggQuery` (where it was not done by prefetch or by IssueViewCriticalQueryPreloader earlier)
				 *
				 * This will allow us to determine whether to remove the execution of `mainIssueAggQuery` in `issue-fetch-epic`.
				 */ (0, $gUUjF.default).safeInfoWithoutCustomerData('issue.issue-view.epics.issue-fetch-epic', 'Missing prefetched `mainIssueAggQuery` from resource manager');
            return fetchAllAppDataWithRetriesCancellable$.filter(()=>{
                // This filter step prevents edge case of users navigating between issues during preview mode
                // and seeing the other issues data instead of own issue data.
                const transitionedIssueKey = (0, $5JqpU.issueKeySelector)(state);
                return transitionedIssueKey === issueKey;
            }).do(({ childIssuesLimit: childIssuesLimit, issue: { fields: fields, id: id, viewScreenId: viewScreenId }, myPreferences: myPreferences, permissions: permissions, attachments: attachments, jiraSettings: jiraSettings, project: project, isArchived: isArchived, containersByType: containersByType, childrenIssues: childrenIssues, subtasks: subtasks, issueLinks: issueLinks })=>{
                (0, $47oY8.storeFields)(fields, fieldValueActions, fieldConfigActions, issueKey, project);
                // At this point React sweet state may contain an info about the previous issue.
                // We are updating issue key as the first thing here and later on merge other issue details.
                issueContextActions.mergeIssueContext({
                    issueKey: issueKey
                });
                issueViewLayoutActions.setIssueViewContainersLayout(issueKey, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                containersByType);
                userPreferenceActions.setUserPreferences(myPreferences);
                permissions && project && permissionActions.setProjectPermissions(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                (0, $6vrw7.toProjectKey)(project.projectKey), permissions);
                if (attachments !== undefined) {
                    attachmentActions.setTotalCount(issueKey, attachments.totalCount);
                    typeof attachments.deletableCount === 'number' && attachmentActions.setDeletableCount(issueKey, attachments.deletableCount);
                    attachmentActions.setVisibleAttachments(issueKey, attachments.nodes);
                }
                jiraSettings && jiraSettingsActions.setJiraSettings(jiraSettings);
                project && projectContextActions.setProjectContext(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                (0, $6vrw7.toProjectKey)(project.projectKey), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                project);
                id && issueContextActions.mergeIssueContext({
                    issueId: (0, $6vrw7.toIssueId)(String(id))
                });
                if (associatedIssuesContextActions) associatedIssuesContextActions.mergeLocalAssociatedIssuesContext((0, $58ToG.getAssociatedIssuesContext)([
                    ...childrenIssues,
                    ...subtasks,
                    ...issueLinks?.linkedIssueMetas || []
                ]));
                issueContextActions.mergeIssueContext({
                    childIssuesLimit: childIssuesLimit,
                    childIssuesIssueLimitUrls: {
                        [(0, $f9RL0.SUBTASKS)]: fields[0, $f9RL0.SUBTASKS]?.issueLimitUrl,
                        [(0, $f9RL0.CHILDREN_ISSUES)]: fields[0, $f9RL0.CHILDREN_ISSUES]?.issueLimitUrl,
                        [(0, $f9RL0.EPIC_ISSUES)]: fields[0, $f9RL0.EPIC_ISSUES]?.issueLimitUrl,
                        [(0, $f9RL0.PORTFOLIO_CHILD_ISSUES)]: fields[0, $f9RL0.PORTFOLIO_CHILD_ISSUES]?.issueLimitUrl
                    },
                    viewScreenId: viewScreenId
                });
                issueContextActions.mergeIssueContext({
                    isArchived: isArchived
                });
                if ((0, $1ybV0.ff)('issue-view-classification-level-editability_88zal')) {
                    const dataClassifcationFieldValue = fields[0, $f9RL0.DATA_CLASSIFICATION_FIELD]?.value || null;
                    const isClassifyEditEnabled = !!dataClassifcationFieldValue?.fieldConfig?.isEditable;
                    issueContextActions.mergeIssueContext({
                        isClassifyEditEnabled: isClassifyEditEnabled
                    });
                }
                issueRefreshServiceActions.setEvent({
                    refreshed: true,
                    reason: (0, $7eDnP.Reason).OnDemand
                });
            }).mergeMap((gqlData)=>{
                const { viewContext: viewContext, uploadContext: uploadContext, userAuth: userAuth, ...rest } = gqlData;
                const view$ = viewContext ? (0, $3JafE.Observable).of((0, $hlJEN.fetchViewContextSuccess)(viewContext)) : (0, $7hH7F.fetchViewContextWithErrorHandling)(baseUrl, issueKey, maxTokenLength, isServiceDesk, (0, $7yNiv.reportServerTimeViaState)(store), prefetchedResourceManager?.issueMediaReadPermission);
                let uploadContextAction;
                if (uploadContext) {
                    // typescript needs to use in operator for union type check
                    if ('error' in uploadContext && uploadContext.error != null) uploadContextAction = (0, $20th5.fetchUploadContextFailure)(new Error(uploadContext.error));
                    else if (// typescript needs to use in operator for union type check
                    'clientId' in uploadContext && uploadContext.clientId != null && uploadContext.serviceHost != null && uploadContext.token != null && uploadContext.tokenLifespanInMs != null && uploadContext.collection != null && uploadContext.tokenIssueTimestamp != null) uploadContextAction = (0, $20th5.fetchUploadContextSuccess)({
                        clientId: uploadContext.clientId,
                        serviceHost: uploadContext.serviceHost,
                        token: uploadContext.token,
                        tokenLifespanInMs: uploadContext.tokenLifespanInMs,
                        collection: uploadContext.collection,
                        tokenIssueTimestamp: uploadContext.tokenIssueTimestamp
                    });
                } else uploadContextAction = (0, $20th5.fetchUploadContextRequest)();
                return view$.map((viewContextAction)=>{
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    ecosystemActions.setEcosystem(rest.ecosystem, issueKey);
                    return [
                        viewContextAction,
                        uploadContextAction,
                        userAuth ? (0, $jsDaf.fetchUserAuthSuccess)(userAuth) : (0, $jsDaf.fetchUserAuthRequest)(),
                        (0, $fYteL.fetchIssueSuccess)(rest)
                    ];
                });
            }).flatMap((actions)=>{
                (0, $9OxOE.blockedOnBackendEntryLog).markEndBackendBlockingTimestamp((0, $848ef1328a091c81$export$1ea0ab50283b82a8));
                if (prefetchedResourceManager) prefetchedResourceManager.clearAll();
                // @ts-expect-error - TS2345 - Argument of type 'readonly [{ type: "FETCH_VIEW_CONTEXT_SUCCESS"; payload: ViewContext; } | { type: "FETCH_VIEW_CONTEXT_FAILURE"; payload: { error: Error | { statusCode: number; }; }; }, any, FetchUserAuthRequestAction | FetchUserAuthSuccessAction, { ...; }]' is not assignable to parameter of type 'Action[]'.
                return (0, $3JafE.Observable).of((0, $MYW4e.batchActions)(actions));
            }).catch((error)=>{
                const logMessage = 'FETCH_ISSUE_REQUEST: Failed to fetch issue data';
                const transformedError = $55eb14474ca4d59a$export$78c6267359db7e73(error, loggedInAccountId);
                if (transformedError.error === (0, $12cc22d0c60f7bfc$export$4e094d34a5cb1872)) ;
                else (0, $3A3OQ.trackOrLogClientError)('issue.fetch.issue-fetch-epic', logMessage, error);
                return (0, $3JafE.Observable).of((0, $fYteL.fetchIssueFailure)(transformedError));
            });
        });

});
parcelRegister("58ToG", function(module, exports) {

$parcel$export(module.exports, "getAssociatedIssuesContext", () => $5147194e94354f6b$export$2824ea2d48a06228);
const $5147194e94354f6b$export$2824ea2d48a06228 = (associatedIssues)=>associatedIssues.reduce((accumulator, associatedIssue)=>{
        if (!associatedIssue.issueKey) return accumulator;
        accumulator[associatedIssue.issueKey] = {
            isResolved: associatedIssue.isResolved ?? false
        };
        if ('estimateFieldId' in associatedIssue) accumulator[associatedIssue.issueKey].estimateFieldId = associatedIssue.estimateFieldId;
        return accumulator;
    }, {});

});


parcelRegister("50X7n", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e371620e423550$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("dpYY5");
parcelRequire("cpH8E");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $49xWy = parcelRequire("49xWy");

var $6CO09 = parcelRequire("6CO09");

var $5JqpU = parcelRequire("5JqpU");
const $a3e371620e423550$export$7271276960377470 = 'issue.issue-view.get-create-linked-issue-permission.epic';
const $a3e371620e423550$var$projectKeyToTypeMap = {};
const $a3e371620e423550$var$getProject = (state, projectKey, requestAnalyticsEvent)=>{
    const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
    if (requestAnalyticsEvent == null) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData($a3e371620e423550$export$7271276960377470, 'No analytics event provided');
        return (0, $3JafE.Observable).of((0, $6CO09.linkedIssueProjectAnalyticsFailure)('No analytics event provided'));
    }
    if ($a3e371620e423550$var$projectKeyToTypeMap[projectKey] === undefined) $a3e371620e423550$var$projectKeyToTypeMap[projectKey] = (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/api/2/project/${projectKey}`, {
        method: 'GET'
    }) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .then((body)=>body.projectTypeKey);
    return (0, $3JafE.Observable).fromPromise($a3e371620e423550$var$projectKeyToTypeMap[projectKey].then((projectType)=>{
        if (projectType) {
            requestAnalyticsEvent.update({
                linkedProjectType: projectType
            });
            return (0, $6CO09.linkedIssueProjectAnalyticsSuccess)(requestAnalyticsEvent);
        }
        (0, $gUUjF.default).safeErrorWithoutCustomerData($a3e371620e423550$export$7271276960377470, 'Issue linked did not contain any project type key');
        return (0, $6CO09.linkedIssueProjectAnalyticsFailure)('Issue linked did not contain any project type key');
    }).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData($a3e371620e423550$export$7271276960377470, error.message);
        return (0, $6CO09.linkedIssueProjectAnalyticsFailure)(error.message);
    }));
};
const $a3e371620e423550$var$asyncIssueLinkAnalyticsEpic = (action$, store)=>action$.ofType((0, $49xWy.SAVE_LINKED_ISSUE_SUCCESS)).mergeMap((action)=>{
        if ((0, $1ybV0.ff)('corex-operandi-issue-view-additional-logging_l6hj8')) {
            const state = store.getState();
            const { issueKey: issueKey, postAnalyticsEvent: postAnalyticsEvent } = action.payload;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const projectKey = issueKey.split('-')[0];
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return $a3e371620e423550$var$getProject(state, projectKey, postAnalyticsEvent);
        }
        return (0, $3JafE.Observable).of({});
    });
var $a3e371620e423550$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)($a3e371620e423550$var$asyncIssueLinkAnalyticsEpic);

});

parcelRegister("lF7gq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b928ea910a6618cc$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");


var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");
var $JRB5w = parcelRequire("JRB5w");

var $0NycV = parcelRequire("0NycV");

var $49xWy = parcelRequire("49xWy");

var $5JqpU = parcelRequire("5JqpU");

var $cFY86 = parcelRequire("cFY86");

var $47BN7 = parcelRequire("47BN7");
const $b928ea910a6618cc$var$LOG_LOCATION = 'issue.issuelinks.save.linked.issues.epic';
const $b928ea910a6618cc$var$saveLinkedIssue = (state, optimisticId, linkedIssueKey, issueLinkType, requestAnalyticsEvent, onSuccess, onError, postAnalyticsEvent)=>{
    const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
    const thisIssueKey = (0, $5JqpU.issueKeySelector)(state);
    return (0, $47BN7.saveIssueLink)(baseUrl, issueLinkType, thisIssueKey, linkedIssueKey).map(()=>{
        if ((0, $1ybV0.ff)('corex-operandi-issue-view-additional-logging_l6hj8')) return (0, $49xWy.saveLinkedIssueSuccess)(optimisticId, requestAnalyticsEvent.update({
            action: 'succeeded'
        }), linkedIssueKey, postAnalyticsEvent);
        return (0, $49xWy.saveLinkedIssueSuccess)(optimisticId, requestAnalyticsEvent.update({
            action: 'succeeded'
        }));
    }).do(()=>{
        if ((0, $1ybV0.ff)('analytics_event_for_deletion_of_linked_issue_1ufi8')) onSuccess?.();
    }).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData($b928ea910a6618cc$var$LOG_LOCATION, 'Error while adding linked issues', error);
        let issueLinkError = error;
        if ((0, $1ybV0.ff)('issue.details.issue-link-limit-exceed-warning-flag')) {
            if (error instanceof (0, $7byHA.default) && error.statusCode === (0, $1c3fbb431a173cc6$export$f90ac1df0b60853d)) issueLinkError = (0, $0NycV.ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED);
            else issueLinkError = error.message;
        }
        if ((0, $1ybV0.ff)('analytics_event_for_deletion_of_linked_issue_1ufi8')) {
            if (!((0, $1ybV0.ff)('ken-429-restrict-4xx-error_vi8v7') && error instanceof (0, $7byHA.default) && (0, $JRB5w.isHttpClientErrorResponse)(error))) onError?.();
        }
        return (0, $3JafE.Observable).of((0, $49xWy.saveLinkedIssueFailure)(optimisticId, issueLinkError, requestAnalyticsEvent?.update({
            action: 'failed'
        })));
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b928ea910a6618cc$var$saveLinkedIssueRequestEpic = (action$, store)=>action$.ofType((0, $49xWy.SAVE_LINKED_ISSUE_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const { optimisticId: optimisticId, linkedIssueKey: linkedIssueKey, issueLinkType: issueLinkType } = action.payload.newIssueLinks;
        const { requestAnalyticsEvent: requestAnalyticsEvent, postAnalyticsEvent: postAnalyticsEvent, onSuccess: onSuccess, onError: onError } = action.payload;
        if ((0, $1ybV0.ff)('corex-operandi-issue-view-additional-logging_l6hj8')) return $b928ea910a6618cc$var$saveLinkedIssue(state, optimisticId, linkedIssueKey, issueLinkType, requestAnalyticsEvent, onSuccess, onError, postAnalyticsEvent);
        return $b928ea910a6618cc$var$saveLinkedIssue(state, optimisticId, linkedIssueKey, issueLinkType, requestAnalyticsEvent, onSuccess, onError);
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b928ea910a6618cc$var$saveLinkedIssueRetryEpic = (action$, store)=>action$.ofType((0, $49xWy.SAVE_LINKED_ISSUE_RETRY)).mergeMap((action)=>{
        const state = store.getState();
        const { optimisticId: optimisticId, requestAnalyticsEvent: requestAnalyticsEvent, postAnalyticsEvent: postAnalyticsEvent, onSuccess: onSuccess, onError: onError } = action.payload;
        const issueLink = (0, $cFY86.issueLinkSelector)(optimisticId)(state);
        const linkedIssueKey = issueLink && issueLink.linkedIssueKey;
        const issueLinkType = issueLink && {
            direction: issueLink.direction,
            id: issueLink.typeId
        };
        if ((0, $1ybV0.ff)('corex-operandi-issue-view-additional-logging_l6hj8')) return $b928ea910a6618cc$var$saveLinkedIssue(state, optimisticId, linkedIssueKey, issueLinkType, requestAnalyticsEvent, onSuccess, onError, postAnalyticsEvent);
        return $b928ea910a6618cc$var$saveLinkedIssue(state, optimisticId, linkedIssueKey, issueLinkType, requestAnalyticsEvent, onSuccess, onError);
    });
var $b928ea910a6618cc$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)($b928ea910a6618cc$var$saveLinkedIssueRetryEpic, $b928ea910a6618cc$var$saveLinkedIssueRequestEpic);

});
parcelRegister("47BN7", function(module, exports) {

$parcel$export(module.exports, "saveIssueLink", () => $d78302b3300421e2$export$3a55516189afdd4b);

var $3JafE = parcelRequire("3JafE");
parcelRequire("cpH8E");

var $fVqUX = parcelRequire("fVqUX");


var $7EhAs = parcelRequire("7EhAs");

var $03XEB = parcelRequire("03XEB");

var $lV5H0 = parcelRequire("lV5H0");
const $d78302b3300421e2$var$postOptions = {
    ...(0, $fVqUX.default),
    method: 'POST'
};
const $d78302b3300421e2$var$toIssueLinkObj = (issueLinkType, thisIssueKey, linkedIssueKey)=>{
    if (issueLinkType.direction === (0, $03XEB.OUTWARD_LINK_DIRECTION)) return {
        type: {
            id: issueLinkType.id
        },
        inwardIssue: {
            key: thisIssueKey
        },
        outwardIssue: {
            key: linkedIssueKey
        }
    };
    return {
        type: {
            id: issueLinkType.id
        },
        inwardIssue: {
            key: linkedIssueKey
        },
        outwardIssue: {
            key: thisIssueKey
        }
    };
};
const $d78302b3300421e2$var$processResponse = (response)=>{
    if (response.status === (0, $1c3fbb431a173cc6$export$ff39ebd4bb12b718)) return Promise.resolve(null);
    return Promise.reject(new (0, $7EhAs.default)(response.status, `Error server response: ${response.status}`));
};
const $d78302b3300421e2$var$post = (// @ts-expect-error - TS2304 - Cannot find name 'Href'.
url, options)=>fetch(url, {
        ...$d78302b3300421e2$var$postOptions,
        ...options
    }).then($d78302b3300421e2$var$processResponse);
const $d78302b3300421e2$export$3a55516189afdd4b = (baseUrl, issueLinkType, thisIssueKey, linkedIssueKey)=>(0, $3JafE.Observable).fromPromise($d78302b3300421e2$var$post((0, $lV5H0.getSaveIssueLinksUrl)(baseUrl), {
        body: JSON.stringify($d78302b3300421e2$var$toIssueLinkObj(issueLinkType, thisIssueKey, linkedIssueKey))
    }));

});


parcelRegister("deTaf", function(module, exports) {

$parcel$export(module.exports, "issueNavigationEpic", () => $4cb8a65820af6c75$export$5ec0a77f363cd2c6);
$parcel$export(module.exports, "projectNavigationEpic", () => $4cb8a65820af6c75$export$f1bcea2dcddf32ec);
$parcel$export(module.exports, "sprintNavigationEpic", () => $4cb8a65820af6c75$export$b02aec3cd806d49c);
parcelRequire("jyKN9");
parcelRequire("YLEHo");
parcelRequire("8jBvP");
parcelRequire("fiQ2m");
parcelRequire("kmH19");
parcelRequire("l8Y8n");
parcelRequire("iects");
parcelRequire("5hZYM");
parcelRequire("1Lcr1");
parcelRequire("flmol");
parcelRequire("8OtG5");
parcelRequire("17XOk");
parcelRequire("l5lul");

var $3QMTK = parcelRequire("3QMTK");

var $hTLlD = parcelRequire("hTLlD");

var $3JafE = parcelRequire("3JafE");

var $8HuAw = parcelRequire("8HuAw");

var $gUUjF = parcelRequire("gUUjF");

var $RvFPW = parcelRequire("RvFPW");

var $6wTCJ = parcelRequire("6wTCJ");

var $1OJS4 = parcelRequire("1OJS4");

var $5nezI = parcelRequire("5nezI");

var $5JqpU = parcelRequire("5JqpU");

var $6vrw7 = parcelRequire("6vrw7");

var $jc4kK = parcelRequire("jc4kK");
const $4cb8a65820af6c75$var$LOG_LOCATION = 'issue.issue-navigation-epic';
// @ts-expect-error - TS7031 - Binding element 'pathname' implicitly has an 'any' type. | TS7031 - Binding element 'search' implicitly has an 'any' type.
const $4cb8a65820af6c75$var$toUrl = ({ pathname: pathname, search: search })=>pathname + search;
const $4cb8a65820af6c75$export$ce1190dc44a1d756 = (url, fromIssueKey, toIssueKey)=>{
    const regex = new RegExp(`${fromIssueKey}(?![\\d])`, 'g');
    const matches = url.match(regex);
    if (matches === null || matches.length !== 1) return null;
    if (toIssueKey.endsWith(fromIssueKey)) return url;
    return url.replace(fromIssueKey, toIssueKey);
};
const $4cb8a65820af6c75$export$5ec0a77f363cd2c6 = (history, dataProvider, recentIssuesActions, issueContextActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (action$, store)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const urlIssueKeyMap = {};
        const navigateToNewIssue$ = action$.ofType((0, $1OJS4.NAVIGATE_TO_NEW_ISSUE)) // eslint-disable-next-line @atlassian/eng-health/code-evolution/ts-migration-4.9-5.4
        .pluck('payload') // @ts-expect-error([Part of upgrade 4.9-5.4]) - No overload matches this call.
        .do(({ toIssueKey: toIssueKey })=>{
            issueContextActions.mergeIssueContext({
                issueKey: (0, $6vrw7.toIssueKey)(toIssueKey)
            });
        }) // @ts-expect-error([Part of upgrade 4.9-5.4]) - No overload matches this call.
        .do(({ toIssueKey: toIssueKey })=>{
            const state = store.getState();
            const analyticsSource = (0, $5JqpU.analyticsSourceSelector)(state);
            const isLoadedWithPage = issueContextActions.getIsLoadedWithPage();
            const recentIssuesCount = recentIssuesActions.getRecentIssuesCount();
            const recentIssue = recentIssuesActions.getRecentIssue(toIssueKey);
            (0, $jc4kK.initialiseMetrics)({
                // @ts-expect-error - Type 'string' is not assignable to type 'AnalyticsSource'.
                analyticsSource: String(analyticsSource),
                issueContextActions: issueContextActions,
                isLoadedWithPage: isLoadedWithPage,
                isRecentIssue: !!recentIssue,
                recentIssuesCount: recentIssuesCount,
                isSPA: true,
                store: store,
                dataProvider: dataProvider
            });
            (0, $jc4kK.markIssueStartRendering)();
        }) // @ts-expect-error([Part of upgrade 4.9-5.4]) - No overload matches this call.
        .do(({ fromIssueKey: fromIssueKey, toIssueKey: toIssueKey })=>{
            if (history) {
                urlIssueKeyMap[$4cb8a65820af6c75$var$toUrl(window.location)] = fromIssueKey;
                const url = $4cb8a65820af6c75$export$ce1190dc44a1d756($4cb8a65820af6c75$var$toUrl(window.location), fromIssueKey, toIssueKey);
                if (url) {
                    urlIssueKeyMap[url] = toIssueKey;
                    history.push(url);
                }
            }
        });
        const historyChange$ = !history ? (0, $3JafE.Observable).empty() : (0, $3JafE.Observable).create((observer)=>history.listen((location, action)=>{
                observer.next({
                    location: location,
                    action: action
                });
            }))// @ts-expect-error - TS7031 - Binding element 'action' implicitly has an 'any' type.
        .filter(({ action: action })=>action === 'POP').filter(()=>{
            const isSpaEnabled = issueContextActions.getIsSpaEnabled();
            return !isSpaEnabled;
        })// @ts-expect-error - TS7031 - Binding element 'location' implicitly has an 'any' type.
        .map(({ location: location })=>urlIssueKeyMap[$4cb8a65820af6c75$var$toUrl(location)]).filter((0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))).map((toIssueKey)=>({
                fromIssueKey: (0, $5JqpU.issueKeySelector)(store.getState()),
                toIssueKey: toIssueKey
            }))// @ts-expect-error - TS7031 - Binding element 'fromIssueKey' implicitly has an 'any' type. | TS7031 - Binding element 'toIssueKey' implicitly has an 'any' type.
        .filter(({ fromIssueKey: fromIssueKey, toIssueKey: toIssueKey })=>fromIssueKey !== toIssueKey);
        return(// @ts-expect-error - TS2684 - The 'this' context of type 'Observable<unknown>' is not assignable to method's 'this' of type 'Observable<{ toIssueKey: any; }>'.
        (0, $3JafE.Observable).merge(navigateToNewIssue$, historyChange$).distinctUntilChanged((fromIssueKey, toIssueKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(fromIssueKey, toIssueKey)).flatMap(({ toIssueKey: toIssueKey })=>{
            (0, $RvFPW.clearFetchIssueNetworkTimes)();
            const recentIssue = recentIssuesActions.getRecentIssue(toIssueKey);
            if (recentIssue) return (0, $3JafE.Observable).of((0, $1OJS4.loadRecentIssue)(toIssueKey, recentIssue));
            return (0, $3JafE.Observable).of((0, $1OJS4.loadNewIssue)(toIssueKey), // @ts-expect-error - TS2769 - No overload matches this call.
            (0, $5nezI.fetchIssueRemoteDataRequest)(toIssueKey));
        })// This ensures the stream ends when action$ ends. This is
        // basically just to ensure the tests run properly.
        .takeUntil(action$.last().catch(()=>(0, $3JafE.Observable).of(true))).catch((error)=>// @ts-expect-error - TS2322 - Type 'void' is not assignable to type 'ObservableInput<unknown>'.
            (0, $gUUjF.default).safeErrorWithoutCustomerData($4cb8a65820af6c75$var$LOG_LOCATION, 'Unexpected error in issue-navigation-epic', error)));
    };
const $4cb8a65820af6c75$export$f1bcea2dcddf32ec = (action$)=>action$.ofType((0, $1OJS4.NAVIGATE_TO_PROJECT)).do((action)=>{
        (0, $8HuAw.default)(action.payload.projectUrl, false, action.payload.pushAction);
    }).ignoreElements();
const $4cb8a65820af6c75$export$b02aec3cd806d49c = (action$)=>action$.ofType((0, $1OJS4.NAVIGATE_TO_SPRINT)).do((action)=>{
        (0, $6wTCJ.default).refreshSprintOnBoard(action.payload.sprintId);
        (0, $6wTCJ.default).hideIssueView();
    }).ignoreElements();

});
parcelRegister("6wTCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d54e79288ae17b1$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");
const $3d54e79288ae17b1$var$emitEventToLegacyApp = (event, data)=>{
    const container = document.getElementById('ghx-issue-fragment');
    if (window.AJS && container) window.AJS.$(container).trigger(event, data);
    else (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.rapid-board', 'Could not find container to send event for rapid board');
};
const $3d54e79288ae17b1$var$BOARD_EVENT = {
    REFRESH_SPRINT_ON_BOARD: 'refresh-sprints-on-board',
    HIDE: 'hide',
    VIEW_ISSUE_MODAL: 'issue.details.view.switch-to-modal',
    VIEW_ISSUE_SIDEBAR: 'issue.details.view.switch-to-sidebar',
    SET_IS_GLOBAL_ISSUE_CREATE_OPEN: 'issue.details.view.set-is-global-issue-create-open'
};
const $3d54e79288ae17b1$var$refreshSprintOnBoard = (sprintId)=>$3d54e79288ae17b1$var$emitEventToLegacyApp($3d54e79288ae17b1$var$BOARD_EVENT.REFRESH_SPRINT_ON_BOARD, {
        sprintIds: [
            sprintId
        ]
    });
const $3d54e79288ae17b1$var$hideIssueView = ()=>$3d54e79288ae17b1$var$emitEventToLegacyApp($3d54e79288ae17b1$var$BOARD_EVENT.HIDE);
// Handling for view mode switching resides in the Legacy JS code
// We are currently supporting view mode switching from Bento
// See https://extranet.atlassian.com/display/JPLAT/Bento+Sidebar+on+Boards
const $3d54e79288ae17b1$var$switchIssueViewToModal = ()=>$3d54e79288ae17b1$var$emitEventToLegacyApp($3d54e79288ae17b1$var$BOARD_EVENT.VIEW_ISSUE_MODAL);
const $3d54e79288ae17b1$var$switchIssueViewToSidebar = ()=>$3d54e79288ae17b1$var$emitEventToLegacyApp($3d54e79288ae17b1$var$BOARD_EVENT.VIEW_ISSUE_SIDEBAR);
const $3d54e79288ae17b1$var$setIsGlobalIssueCreateOpen = (newValue)=>$3d54e79288ae17b1$var$emitEventToLegacyApp($3d54e79288ae17b1$var$BOARD_EVENT.SET_IS_GLOBAL_ISSUE_CREATE_OPEN, newValue);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3d54e79288ae17b1$export$2e2bcd8739ae039 = {
    refreshSprintOnBoard: $3d54e79288ae17b1$var$refreshSprintOnBoard,
    hideIssueView: $3d54e79288ae17b1$var$hideIssueView,
    switchIssueViewToModal: $3d54e79288ae17b1$var$switchIssueViewToModal,
    switchIssueViewToSidebar: $3d54e79288ae17b1$var$switchIssueViewToSidebar,
    setIsGlobalIssueCreateOpen: $3d54e79288ae17b1$var$setIsGlobalIssueCreateOpen
};

});


parcelRegister("ckvM2", function(module, exports) {

$parcel$export(module.exports, "default", () => $76a9b594179a950c$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("gkYO0");
parcelRequire("8OtG5");
parcelRequire("3wBUP");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $fEYK5 = parcelRequire("fEYK5");

var $5LWdq = parcelRequire("5LWdq");

var $7eDnP = parcelRequire("7eDnP");

var $a60Hj = parcelRequire("a60Hj");

var $anFLA = parcelRequire("anFLA");

var $hoyvu = parcelRequire("hoyvu");

var $fYteL = parcelRequire("fYteL");

var $jZDJX = parcelRequire("jZDJX");

var $jMP2a = parcelRequire("jMP2a");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $76a9b594179a950c$var$isFromTheSameUser = (action, store)=>{
    const state = store.getState();
    const { atlassianId: atlassianId } = action.payload;
    const loggedInUserDetails = (0, $jZDJX.loggedInUserDetailsSelector)(state);
    return !!loggedInUserDetails && atlassianId === loggedInUserDetails.id;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $76a9b594179a950c$var$shouldRefresh = (action, store)=>{
    const state = store.getState();
    const { atlassianId: atlassianId } = action.payload;
    const loggedInUserDetails = (0, $jZDJX.loggedInUserDetailsSelector)(state);
    const isFromAnotherUser = !!loggedInUserDetails && atlassianId !== loggedInUserDetails.id;
    return isFromAnotherUser;
};
const $76a9b594179a950c$export$6b520693a0ebee68 = (issueRefreshServiceActions)=>(action$, store)=>action$.ofType((0, $hoyvu.REALTIME_UPDATE_CURRENT_ISSUE)).filter(()=>(0, $fEYK5.isPageVisible)()).switchMap((action)=>{
            if ($76a9b594179a950c$var$shouldRefresh(action, store)) return (0, $3JafE.Observable).of((0, $fYteL.refreshIssueRequest)({
                reason: (0, $7eDnP.Reason).Realtime,
                details: action.payload
            }, action.meta));
            if ($76a9b594179a950c$var$isFromTheSameUser(action, store)) {
                const analyticsEvent = action.meta?.analyticsEvent;
                (0, $a60Hj.isInSample)((0, $anFLA.REALTIME_EVENTS_ANALYTICS_SAMPLE_RATE)) && analyticsEvent && (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'issueRealtimeEvent handled', {
                    issueRefreshed: false
                });
                issueRefreshServiceActions.setEvent({
                    refreshed: false,
                    reason: (0, $7eDnP.Reason).Realtime,
                    details: action.payload
                });
            }
            return (0, $3JafE.Observable).empty();
        });
const $76a9b594179a950c$export$2bd8d9738023e82b = ()=>(action$, store)=>{
        const visibility$ = (0, $5LWdq.default)();
        return action$.ofType((0, $hoyvu.REALTIME_UPDATE_CURRENT_ISSUE)).bufferToggle(visibility$.filter((isVisible)=>!isVisible), ()=>visibility$.filter((isVisible)=>Boolean(isVisible))).switchMap((actionsArray)=>{
            /**
				 * When the tab gets in the focus and issue details update, we want to refresh the UI in two cases:
				 * 1. The update was made by another user (same logic that we apply for the "active" tab)
				 * 2. The update was made by the same user but from another tab, so when they are back to this tab, they see the latest data
				 */ const matchedAction = actionsArray.find((action)=>$76a9b594179a950c$var$shouldRefresh(action, store) || $76a9b594179a950c$var$isFromTheSameUser(action, store));
            if (matchedAction) return (0, $3JafE.Observable).of((0, $fYteL.refreshIssueRequest)({
                reason: (0, $7eDnP.Reason).Realtime,
                details: matchedAction.payload
            }, matchedAction.meta));
            return (0, $3JafE.Observable).empty();
        });
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$76a9b594179a950c$export$2e2bcd8739ae039 = (issueRefreshServiceActions)=>(0, $bd1K7.combineEpics)(// @ts-expect-error - TS2345: Property 'payload' is missing in type '{ type: "REFRESH_ISSUE_REQUEST"; }' but required in type '{ type: "REALTIME_UPDATE_CURRENT_ISSUE"; payload: RealtimeUpdateCurrentIssueActionPayload; }'.
    $76a9b594179a950c$export$6b520693a0ebee68(issueRefreshServiceActions), $76a9b594179a950c$export$2bd8d9738023e82b());

});
parcelRegister("5LWdq", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc20929970eebc75$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("7Rus6");
parcelRequire("flmol");

var $fEYK5 = parcelRequire("fEYK5");
/**
 * Returns a stream of the current page visibility state whenever it changes.
 * Emits 'true' when the page is visible and 'false' when the page is hidden.
 *
 * Will emit `null` if document is not defined.
 *
 * This Observable WILL EMIT a value at the start of the load. If you're using
 * it to trigger refreshes, you should skip 1 value.
 */ const $fc20929970eebc75$var$getVisibility$ = ()=>// @ts-expect-error - TS2322 - Type 'Observable<unknown>' is not assignable to type 'Observable<boolean | null>'.
    typeof document !== 'undefined' ? (0, $3JafE.Observable).fromEvent(document, (0, $fEYK5.supportedVisiblityEvent))// We want to send the current visibility on a new subscription.
    // If we use `.startWith(isPageVisible())` then new subscribers
    // will get the initial visibility at load and not the current
    // visibility as the initial value.
    .startWith(null).map((0, $fEYK5.isPageVisible)) : new (0, $70s4u.Subject)().startWith(null);
var $fc20929970eebc75$export$2e2bcd8739ae039 = $fc20929970eebc75$var$getVisibility$;

});


parcelRegister("73Nvh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d901460aab51f2a9$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("jAXdN");
parcelRequire("l5lul");
parcelRequire("b48pz");
parcelRequire("flmol");
parcelRequire("iects");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");
parcelRequire("5hZYM");

var $3JafE = parcelRequire("3JafE");

var $7xwx0 = parcelRequire("7xwx0");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $7eDnP = parcelRequire("7eDnP");

var $a60Hj = parcelRequire("a60Hj");

var $anFLA = parcelRequire("anFLA");

var $7hH7F = parcelRequire("7hH7F");

var $47oY8 = parcelRequire("47oY8");

var $58ToG = parcelRequire("58ToG");

var $f9RL0 = parcelRequire("f9RL0");

var $3b0Pa = parcelRequire("3b0Pa");

var $fYteL = parcelRequire("fYteL");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $jMP2a = parcelRequire("jMP2a");

var $6vrw7 = parcelRequire("6vrw7");

var $l7DhQ = parcelRequire("l7DhQ");
const $d901460aab51f2a9$var$LOG_LOCATION = 'issue.fetch.issue-refresh-epic';
const $d901460aab51f2a9$var$issueRefreshEpic = ({ issueRefreshServiceActions: issueRefreshServiceActions, fieldValueActions: fieldValueActions, fieldConfigActions: fieldConfigActions, issueViewLayoutActions: issueViewLayoutActions, userPreferenceActions: userPreferenceActions, attachmentActions: attachmentActions, permissionActions: permissionActions, projectContextActions: projectContextActions, issueContextActions: issueContextActions, ecosystemActions: ecosystemActions, associatedIssuesContextActions: associatedIssuesContextActions, prefetchedResourceManager: prefetchedResourceManager, issueRefreshLoadingActionsRef: issueRefreshLoadingActionsRef, issueViewNonCriticalDataActions: issueViewNonCriticalDataActions })=>(action$, store)=>{
        const observable$ = action$.ofType((0, $fYteL.REFRESH_ISSUE_REQUEST));
        return observable$.pipe((0, $l7DhQ.throttleIssueRefresh)(), (0, $7xwx0.switchMap)(({ payload: payload, meta: meta })=>{
            const state = store.getState();
            const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
            const issueKey = (0, $5JqpU.issueKeySelector)(state);
            const maxTokenLength = issueContextActions.getMaxTokenLength();
            const isServiceDesk = (0, $jZDJX.isServiceDeskSelector)(state);
            const issueRefreshLoadingActions = issueRefreshLoadingActionsRef.current;
            if (payload?.reason === (0, $7eDnP.Reason).Realtime) issueRefreshLoadingActions?.setRealTimeRefreshLoadingStatus('LOADING');
            else issueRefreshLoadingActions?.setBackgroundRefreshLoadingStatus('LOADING');
            const fetchAllAppDataWithRetries$ = (0, $3b0Pa.fetchAllAppDataWithRetries)(state, prefetchedResourceManager);
            const fetchAllAppDataWithRetriesCancellable$ = fetchAllAppDataWithRetries$.takeUntil(action$.ofType((0, $fYteL.CANCEL_REFRESH_ISSUE_REQUEST)));
            (0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') && issueViewNonCriticalDataActions?.fetchNonCriticalData(issueKey);
            return (0, $3JafE.Observable).zip((0, $7hH7F.fetchViewContextWithErrorHandling)(baseUrl, issueKey, maxTokenLength, isServiceDesk), fetchAllAppDataWithRetriesCancellable$.do(({ childIssuesLimit: childIssuesLimit, issue: { fields: fields, id: id, viewScreenId: viewScreenId }, myPreferences: myPreferences, attachments: attachments, permissions: permissions, containersByType: containersByType, project: project, isArchived: isArchived, ecosystem: ecosystem, childrenIssues: childrenIssues, subtasks: subtasks, issueLinks: issueLinks })=>{
                (0, $47oY8.storeFields)(fields, fieldValueActions, fieldConfigActions, issueKey, project, true);
                issueViewLayoutActions.setIssueViewContainersLayout(issueKey, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                containersByType);
                userPreferenceActions.setUserPreferences(myPreferences);
                ecosystemActions && ecosystemActions.setEcosystem(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ecosystem, issueKey);
                permissions && project && permissionActions.setProjectPermissions(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                (0, $6vrw7.toProjectKey)(project.projectKey), permissions);
                attachments && attachmentActions.setTotalCount(issueKey, attachments.totalCount);
                attachments && typeof attachments.deletableCount === 'number' && attachmentActions.setDeletableCount(issueKey, attachments.deletableCount);
                attachments && attachmentActions.setVisibleAttachments(issueKey, attachments.nodes);
                project && projectContextActions.setProjectContext(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                (0, $6vrw7.toProjectKey)(project.projectKey), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                project);
                id && issueContextActions.mergeIssueContext({
                    issueId: (0, $6vrw7.toIssueId)(String(id))
                });
                issueContextActions.mergeIssueContext({
                    isArchived: isArchived
                });
                if (associatedIssuesContextActions) associatedIssuesContextActions.mergeLocalAssociatedIssuesContext((0, $58ToG.getAssociatedIssuesContext)([
                    ...childrenIssues,
                    ...subtasks,
                    ...issueLinks?.linkedIssueMetas || []
                ]));
                issueContextActions.mergeIssueContext({
                    childIssuesLimit: childIssuesLimit,
                    childIssuesIssueLimitUrls: {
                        [(0, $f9RL0.SUBTASKS)]: fields[0, $f9RL0.SUBTASKS]?.issueLimitUrl,
                        [(0, $f9RL0.CHILDREN_ISSUES)]: fields[0, $f9RL0.CHILDREN_ISSUES]?.issueLimitUrl,
                        [(0, $f9RL0.EPIC_ISSUES)]: fields[0, $f9RL0.EPIC_ISSUES]?.issueLimitUrl,
                        [(0, $f9RL0.PORTFOLIO_CHILD_ISSUES)]: fields[0, $f9RL0.PORTFOLIO_CHILD_ISSUES]?.issueLimitUrl
                    },
                    viewScreenId: viewScreenId
                });
                if ((0, $1ybV0.ff)('issue-view-classification-level-editability_88zal')) {
                    const dataClassifcationFieldValue = fields[0, $f9RL0.DATA_CLASSIFICATION_FIELD]?.value || {};
                    const isClassifyEditEnabled = !!dataClassifcationFieldValue?.fieldConfig?.isEditable;
                    issueContextActions.mergeIssueContext({
                        isClassifyEditEnabled: isClassifyEditEnabled
                    });
                }
                if (payload?.reason === (0, $7eDnP.Reason).Realtime) {
                    const { analyticsEvent: analyticsEvent } = meta || {};
                    analyticsEvent && (0, $a60Hj.isInSample)((0, $anFLA.REALTIME_EVENTS_ANALYTICS_SAMPLE_RATE)) && (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'issueRealtimeEvent handled', {
                        issueRefreshed: true
                    });
                    issueRefreshServiceActions.setEvent({
                        refreshed: true,
                        reason: payload.reason,
                        details: payload.details
                    });
                    issueRefreshLoadingActions?.setRealTimeRefreshLoadingStatus('LOADED');
                } else if (payload?.reason === (0, $7eDnP.Reason).SoftRefresh) {
                    issueRefreshServiceActions.setEvent({
                        refreshed: true,
                        reason: payload.reason
                    });
                    issueRefreshLoadingActions?.setBackgroundRefreshLoadingStatus('LOADED');
                } else {
                    issueRefreshServiceActions.setEvent({
                        refreshed: true,
                        reason: (0, $7eDnP.Reason).OnDemand
                    });
                    issueRefreshLoadingActions?.setBackgroundRefreshLoadingStatus('LOADED');
                }
            }).map((0, $fYteL.refreshIssueSuccess))).mergeMap((actions)=>(0, $3JafE.Observable).from(actions)).catch((error)=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData($d901460aab51f2a9$var$LOG_LOCATION, 'REFRESH_ISSUE_REQUEST: Failed to refresh issue data', error);
                return (0, $3JafE.Observable).empty();
            });
        }));
    };
var $d901460aab51f2a9$export$2e2bcd8739ae039 = $d901460aab51f2a9$var$issueRefreshEpic;

});

parcelRegister("5yYRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b15fbde8dede1c99$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");


var $kubmk = parcelRequire("kubmk");


var $3A3OQ = parcelRequire("3A3OQ");

var $9RIuy = parcelRequire("9RIuy");

var $5JqpU = parcelRequire("5JqpU");
// @ts-expect-error - TS2304 - Cannot find name 'AccountId'.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b15fbde8dede1c99$var$transformError = (statusCode, accountId)=>{
    let error = (0, $12cc22d0c60f7bfc$export$f10b32dfda12e96e);
    if (statusCode === (0, $1c3fbb431a173cc6$export$67d19e9a991baa07)) // @ts-expect-error - TS2322 - Type '"AUTHENTICATION_ERROR"' is not assignable to type '"UNKNOWN_ERROR"'.
    error = (0, $12cc22d0c60f7bfc$export$99405616af30f11f);
    else if (statusCode === (0, $1c3fbb431a173cc6$export$a3269a3914b007e3)) // @ts-expect-error - TS2322 - Type '"NOT_FOUND_OR_NO_PERMISSION_ERROR"' is not assignable to type '"UNKNOWN_ERROR"'.
    error = (0, $12cc22d0c60f7bfc$export$4e094d34a5cb1872);
    else if (statusCode === (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef)) // @ts-expect-error - TS2322 - Type '"NOT_FOUND_OR_NO_PERMISSION_ERROR"' is not assignable to type '"UNKNOWN_ERROR"'.
    error = (0, $12cc22d0c60f7bfc$export$4e094d34a5cb1872);
    else if (!statusCode) // @ts-expect-error - TS2322 - Type '"CONNECTIVITY_ERROR"' is not assignable to type '"UNKNOWN_ERROR"'.
    error = (0, $12cc22d0c60f7bfc$export$683dbe11f74cd161);
    else if (!accountId) // @ts-expect-error - TS2322 - Type '"AUTHENTICATION_ERROR"' is not assignable to type '"UNKNOWN_ERROR"'.
    error = (0, $12cc22d0c60f7bfc$export$99405616af30f11f);
    return {
        error: error,
        statusCode: statusCode
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b15fbde8dede1c99$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $9RIuy.FETCH_SCREENID_REQUEST)).switchMap(()=>{
        const state = store.getState();
        const loggedInAccountId = (0, $5JqpU.accountIdloggedInUserSelector)(state);
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueKey = (0, $5JqpU.issueKeySelector)(state);
        return(// @ts-expect-error - TS2684 - The 'this' context of type 'Observable<unknown>' is not assignable to method's 'this' of type 'Observable<ScreenIdData>'.
        (0, $kubmk.fetchIssueViewScreenId)(baseUrl, issueKey)/*
            Cannot call `fetchIssueViewScreenId(...).map` with `fetchScreenIdSuccess` bound to `f` because inexact  mixed [1] is incompatible with exact  `ScreenIdData` [2] in the first argument.Flow(InferError)
            as-json-stream.js(31, 78): [1] mixed
            issue-screenid-actions.js(25, 52): [2] `ScreenIdData`
        */ .map((0, $9RIuy.fetchScreenIdSuccess)).catch((error)=>{
            const logMessage = 'FETCH_ISSUE_REQUEST: Failed to fetch issue data';
            const transformedError = $b15fbde8dede1c99$var$transformError(error.statusCode, loggedInAccountId);
            // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"UNKNOWN_ERROR"' and '"NOT_FOUND_OR_NO_PERMISSION_ERROR"' have no overlap.
            if (transformedError.error === (0, $12cc22d0c60f7bfc$export$4e094d34a5cb1872)) ;
            else (0, $3A3OQ.trackOrLogClientError)('issue.fetch.issue-screenid-epic', logMessage, error);
            return (0, $3JafE.Observable).of((0, $9RIuy.fetchScreenIdFailure)(transformedError));
        }));
    });

});
parcelRegister("kubmk", function(module, exports) {

$parcel$export(module.exports, "fetchIssueViewScreenId", () => $d1b3320fc8b323f2$export$9601196da8f09f4f);

var $ejLgE = parcelRequire("ejLgE");

var $aiRd8 = parcelRequire("aiRd8");

var $frutl = parcelRequire("frutl");
const $d1b3320fc8b323f2$export$ef91c5b41b3e831b = (issueKey)=>(0, $ejLgE.gqlTagRest)`query viewScreenIdQuery {
            issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
                id
                viewScreenId
            }
        }`;
const $d1b3320fc8b323f2$var$getFieldDataOptions = (issueKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: $d1b3320fc8b323f2$export$ef91c5b41b3e831b(issueKey)
        })
    });
const $d1b3320fc8b323f2$export$9601196da8f09f4f = (baseUrl, issueKey)=>(0, $aiRd8.default)((0, $frutl.getGraphQlUrl)(baseUrl), $d1b3320fc8b323f2$var$getFieldDataOptions(issueKey));

});
parcelRegister("ejLgE", function(module, exports) {

$parcel$export(module.exports, "gqlTagRest", () => $8d34ae4c307c0700$export$ecc155df19ba52ff);
/**
 * This file is to define tags for GraphQL queries to be identified
 * by https://github.com/apollographql/eslint-plugin-graphql
 * It returns the full query string for template literals
 */ const $8d34ae4c307c0700$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});

parcelRegister("frutl", function(module, exports) {

$parcel$export(module.exports, "getGraphQlUrl", () => $e051ddb495831fac$export$5647e6bbf2b3526f);
const $e051ddb495831fac$export$5647e6bbf2b3526f = (baseUrl)=>`${baseUrl}/rest/graphql/1/`;

});



parcelRegister("4Gbsn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa833cf90f7ebdd5$export$2e2bcd8739ae039);
parcelRequire("dM0Xt");
parcelRequire("jyKN9");
parcelRequire("iects");

var $gKA5o = parcelRequire("gKA5o");

var $3JafE = parcelRequire("3JafE");

var $cEA7U = parcelRequire("cEA7U");

var $hHnBv = parcelRequire("hHnBv");

var $eOkgG = parcelRequire("eOkgG");

var $7yNiv = parcelRequire("7yNiv");

var $5JqpU = parcelRequire("5JqpU");
const $fa833cf90f7ebdd5$var$cacheTTL = 1800000; // 30min
const $fa833cf90f7ebdd5$var$requestIssueTypesCache = new Map();
const $fa833cf90f7ebdd5$export$179b81598c08d13a = ()=>$fa833cf90f7ebdd5$var$requestIssueTypesCache.clear();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fa833cf90f7ebdd5$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $hHnBv.SUBTASK_QUICK_ADD_CLICKED), (0, $hHnBv.ISSUE_IN_EPIC_QUICK_ADD_CLICKED), (0, $hHnBv.CHILD_ISSUE_QUICK_ADD_CLICKED), (0, $hHnBv.CHILD_ISSUE_PANEL_ADD_CLICKED)).mergeMap(()=>{
        const state = store.getState();
        const projectKey = (0, $5JqpU.projectKeySelector)(state);
        // we have/already requested
        const cacheItem = $fa833cf90f7ebdd5$var$requestIssueTypesCache.get(projectKey) || {
            time: new Date()
        };
        // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        if (cacheItem && cacheItem.data && new Date() - cacheItem.time < $fa833cf90f7ebdd5$var$cacheTTL) return (0, $3JafE.Observable).of((0, $eOkgG.setIssueTypes)(cacheItem.data));
        // add or touch cache
        $fa833cf90f7ebdd5$var$requestIssueTypesCache.set(projectKey, cacheItem);
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const headerProcessors = (0, $7yNiv.reportServerTimeViaState)(store);
        return (0, $3JafE.Observable).concat((0, $3JafE.Observable).of((0, $eOkgG.fetchingIssueTypes)()), // @ts-expect-error - TS2345 - Argument of type '(result: IssueAndSubtaskType) => Observable<{ type: "SET_ISSUE_TYPES"; payload: ServerIssueType[]; }> | Observable<{ type: "FETCH_ISSUE_TYPES_FAILED"; }>' is not assignable to parameter of type '(value: IssueAndSubtaskType, index: number) => ObservableInput<{ type: "SET_ISSUE_TYPES"; payload: ServerIssueType[]; }>'.
        (0, $cEA7U.fetchSubtaskTypes)(baseUrl, projectKey, headerProcessors).mergeMap((result)=>{
            const issueTypes = result && result.issueTypes;
            // if the fetch call fails we receive empty arrays so let's clear the cache
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gKA5o)))(issueTypes)) {
                $fa833cf90f7ebdd5$var$requestIssueTypesCache.delete(projectKey);
                return (0, $3JafE.Observable).of((0, $eOkgG.fetchIssueTypesFailed)());
            }
            // set the cache data
            $fa833cf90f7ebdd5$var$requestIssueTypesCache.set(projectKey, {
                ...cacheItem,
                data: issueTypes
            });
            return (0, $3JafE.Observable).of((0, $eOkgG.setIssueTypes)(issueTypes));
        }));
    });

});
parcelRegister("gKA5o", function(module, exports) {

var $fCpZe = parcelRequire("fCpZe");

var $fjnSB = parcelRequire("fjnSB");

var $jxg5X = parcelRequire("jxg5X");

var $4ZYEI = parcelRequire("4ZYEI");

var $eQiJU = parcelRequire("eQiJU");
/** `Object#toString` result references. */ var $c31cef206f882b8b$var$mapTag = '[object Map]', $c31cef206f882b8b$var$setTag = '[object Set]';
/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */ function $c31cef206f882b8b$var$size(collection) {
    if (collection == null) return 0;
    if ($jxg5X(collection)) return $4ZYEI(collection) ? $eQiJU(collection) : collection.length;
    var tag = $fjnSB(collection);
    if (tag == $c31cef206f882b8b$var$mapTag || tag == $c31cef206f882b8b$var$setTag) return collection.size;
    return $fCpZe(collection).length;
}
module.exports = $c31cef206f882b8b$var$size;

});
parcelRegister("eQiJU", function(module, exports) {

var $3K42x = parcelRequire("3K42x");

var $fFFC0 = parcelRequire("fFFC0");

var $CYLq5 = parcelRequire("CYLq5");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $ace4754dece6a484$var$stringSize(string) {
    return $fFFC0(string) ? $CYLq5(string) : $3K42x(string);
}
module.exports = $ace4754dece6a484$var$stringSize;

});
parcelRegister("3K42x", function(module, exports) {

var $pRnxj = parcelRequire("pRnxj");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $2b98cd398295eed4$var$asciiSize = $pRnxj('length');
module.exports = $2b98cd398295eed4$var$asciiSize;

});

parcelRegister("CYLq5", function(module, exports) {
/** Used to compose unicode character classes. */ var $0752af280e68c649$var$rsAstralRange = '\\ud800-\\udfff', $0752af280e68c649$var$rsComboMarksRange = '\\u0300-\\u036f', $0752af280e68c649$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $0752af280e68c649$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $0752af280e68c649$var$rsComboRange = $0752af280e68c649$var$rsComboMarksRange + $0752af280e68c649$var$reComboHalfMarksRange + $0752af280e68c649$var$rsComboSymbolsRange, $0752af280e68c649$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $0752af280e68c649$var$rsAstral = '[' + $0752af280e68c649$var$rsAstralRange + ']', $0752af280e68c649$var$rsCombo = '[' + $0752af280e68c649$var$rsComboRange + ']', $0752af280e68c649$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $0752af280e68c649$var$rsModifier = '(?:' + $0752af280e68c649$var$rsCombo + '|' + $0752af280e68c649$var$rsFitz + ')', $0752af280e68c649$var$rsNonAstral = '[^' + $0752af280e68c649$var$rsAstralRange + ']', $0752af280e68c649$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $0752af280e68c649$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $0752af280e68c649$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $0752af280e68c649$var$reOptMod = $0752af280e68c649$var$rsModifier + '?', $0752af280e68c649$var$rsOptVar = '[' + $0752af280e68c649$var$rsVarRange + ']?', $0752af280e68c649$var$rsOptJoin = '(?:' + $0752af280e68c649$var$rsZWJ + '(?:' + [
    $0752af280e68c649$var$rsNonAstral,
    $0752af280e68c649$var$rsRegional,
    $0752af280e68c649$var$rsSurrPair
].join('|') + ')' + $0752af280e68c649$var$rsOptVar + $0752af280e68c649$var$reOptMod + ')*', $0752af280e68c649$var$rsSeq = $0752af280e68c649$var$rsOptVar + $0752af280e68c649$var$reOptMod + $0752af280e68c649$var$rsOptJoin, $0752af280e68c649$var$rsSymbol = '(?:' + [
    $0752af280e68c649$var$rsNonAstral + $0752af280e68c649$var$rsCombo + '?',
    $0752af280e68c649$var$rsCombo,
    $0752af280e68c649$var$rsRegional,
    $0752af280e68c649$var$rsSurrPair,
    $0752af280e68c649$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $0752af280e68c649$var$reUnicode = RegExp($0752af280e68c649$var$rsFitz + '(?=' + $0752af280e68c649$var$rsFitz + ')|' + $0752af280e68c649$var$rsSymbol + $0752af280e68c649$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $0752af280e68c649$var$unicodeSize(string) {
    var result = $0752af280e68c649$var$reUnicode.lastIndex = 0;
    while($0752af280e68c649$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $0752af280e68c649$var$unicodeSize;

});



parcelRegister("cEA7U", function(module, exports) {

$parcel$export(module.exports, "fetchSubtaskTypes", () => $53d0761e76195f56$export$e497d1b13a31fc0);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $aiRd8 = parcelRequire("aiRd8");

var $cUHte = parcelRequire("cUHte");

var $3A3OQ = parcelRequire("3A3OQ");

var $lV5H0 = parcelRequire("lV5H0");
const $53d0761e76195f56$var$transformProjectSubtaskTypes = (result)=>{
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    if (result.projects[0]) return {
        // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'issuetype' implicitly has an 'any' type.
        subtaskTypes: result.projects[0].issuetypes.filter((issuetype)=>issuetype.subtask),
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        issueTypes: result.projects[0].issuetypes
    };
    return {
        subtaskTypes: [],
        issueTypes: []
    };
};
const $53d0761e76195f56$var$fetchSubtaskTypesFromServer = (projectCreateMetaUrl, headersProcessor)=>(0, $aiRd8.default)(projectCreateMetaUrl, {
        perf: (0, $cUHte.fetchSubtaskTypesPerf),
        headersProcessor: headersProcessor && headersProcessor((0, $cUHte.fetchSubtaskTypesPerf).key)
    }).map($53d0761e76195f56$var$transformProjectSubtaskTypes).catch((error)=>{
        (0, $3A3OQ.trackOrLogClientError)('issue.issue-base.content.subtasks.type.subtasks-types-epic', 'Failed to fetch subtask types.', error);
        return (0, $3JafE.Observable).of({
            subtaskTypes: [],
            issueTypes: []
        });
    });
const $53d0761e76195f56$export$e497d1b13a31fc0 = (baseUrl, projectKey, headersProcessor)=>{
    const projectCreateMetaUrl = (0, $lV5H0.getProjectCreateMetaUrl)(baseUrl, projectKey);
    return $53d0761e76195f56$var$fetchSubtaskTypesFromServer(projectCreateMetaUrl, headersProcessor);
};

});


parcelRegister("8WUeJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b378060840bd1cd$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $3A3OQ = parcelRequire("3A3OQ");

var $a0kZP = parcelRequire("a0kZP");

var $fp55Q = parcelRequire("fp55Q");

var $5JqpU = parcelRequire("5JqpU");

var $fmexX = parcelRequire("fmexX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0b378060840bd1cd$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $fp55Q.FETCH_JIRA_APP_LINKS_REQUEST), (0, $a0kZP.APPLINK_AUTHENTICATION_SUCCESS)).switchMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueKey = (0, $5JqpU.issueKeySelector)(state);
        // @ts-expect-error - TS2684 - The 'this' context of type 'Observable<unknown>' is not assignable to method's 'this' of type 'Observable<JiraAppLinksResponse>'.
        return (0, $fmexX.default)(baseUrl, issueKey).map((0, $fp55Q.fetchJiraAppLinksSuccess)).catch((error)=>{
            (0, $3A3OQ.trackOrLogClientError)('issue.fetch.jira-app-links-epic', 'FETCH_JIRA_APP_LINKS_REQUEST: Failed to fetch jira app links data', error);
            return (0, $3JafE.Observable).of((0, $fp55Q.fetchJiraAppLinksFailed)());
        });
    });

});
parcelRegister("fmexX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b429c3b1b0ec10df$export$2e2bcd8739ae039);

var $aiRd8 = parcelRequire("aiRd8");

var $lV5H0 = parcelRequire("lV5H0");
const $b429c3b1b0ec10df$export$8ccd5f30e00fe6ab = (baseUrl, issueKey)=>(0, $aiRd8.default)((0, $lV5H0.getJiraAppLinksUrl)(baseUrl, issueKey));
var $b429c3b1b0ec10df$export$2e2bcd8739ae039 = $b429c3b1b0ec10df$export$8ccd5f30e00fe6ab;

});


parcelRegister("jdymI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6249f01906299cd8$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("fRdoC");
parcelRequire("8OtG5");
parcelRequire("l5lul");
parcelRequire("iects");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $g2ZFU = parcelRequire("g2ZFU");

var $fYteL = parcelRequire("fYteL");

var $5JqpU = parcelRequire("5JqpU");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$6249f01906299cd8$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $g2ZFU.LOGIN)).switchMap(()=>{
        const redirectUrl = (0, $5JqpU.loginRedirectUrlSelector)(store.getState());
        if (redirectUrl) {
            const baseUrl = (0, $5JqpU.baseUrlSelector)(store.getState());
            const encodedRedirectUrl = encodeURIComponent(redirectUrl);
            const logInUrl = `${baseUrl}/login.jsp?os_destination=${encodedRedirectUrl}`;
            const logInWindow = window.open(logInUrl, '_blank');
            /*
			 * Wait for the login window to post an event back to the app of the shape:
			 * {
			 *      accountId: accountid,
			 *      status: 'log-in-successful'
			 * }
			 * If the login was successful and there was a logged in user,
			 * request the issue data again now that we are authenticated.
			 */ return (0, $3JafE.Observable).fromEvent(window, 'message')// @ts-expect-error - TS2571 - Object is of type 'unknown'.
            .filter((e)=>e.origin === window.location.origin)// @ts-expect-error - TS2571 - Object is of type 'unknown'.
            .filter((e)=>e.source === logInWindow).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (e)=>e.data && e.data.status === 'log-in-successful' && e.data.accountId)// @ts-expect-error - TS2571 - Object is of type 'unknown'.
            .do((e)=>e.source.close()).mergeMap((e)=>(0, $3JafE.Observable).of((0, $g2ZFU.loginSuccessful)({
                    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                    accountId: e.data.accountId
                }), // @ts-expect-error - TS2769 - No overload matches this call.
                (0, $fYteL.fetchIssueRequest)()));
        }
        return (0, $3JafE.Observable).empty();
    });

});

parcelRegister("lbVDg", function(module, exports) {

$parcel$export(module.exports, "default", () => $242bab5486b49c10$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $lkPj1 = parcelRequire("lkPj1");

var $lfcmL = parcelRequire("lfcmL");

var $fokFV = parcelRequire("fokFV");

var $6KjC3 = parcelRequire("6KjC3");

var $dmojD = parcelRequire("dmojD");
const $242bab5486b49c10$var$getMultilineFieldEditBeginAction = (state, { fieldId: fieldId, commentId: commentId }, isAddCommentEditorExpandAction = false)=>{
    const multilineFieldIdsToClose = (0, $fokFV.getEditingMultilineFieldIdsSelector)(state).filter((id)=>id !== fieldId);
    const commentIdsToClose = (0, $dmojD.getEditingCommentIdsSelector)(state).filter((id)=>id !== commentId);
    const shouldCloseAddCommentForm = !isAddCommentEditorExpandAction && (0, $dmojD.isAddCommentEditorExpandedSelector)(state);
    return multilineFieldIdsToClose.length > 0 || commentIdsToClose.length > 0 || shouldCloseAddCommentForm ? (0, $lfcmL.multilineFieldEditBegin)(multilineFieldIdsToClose, commentIdsToClose, shouldCloseAddCommentForm) : null;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $242bab5486b49c10$var$editFieldEpic = (action$, store)=>action$.ofType((0, $6KjC3.FIELD_EDIT_BEGIN)).filter((action)=>(0, $fokFV.isMultilineFieldSelector)(action.payload.fieldId)(store.getState())).map((action)=>$242bab5486b49c10$var$getMultilineFieldEditBeginAction(store.getState(), {
            fieldId: action.payload.fieldId
        })).filter(Boolean);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $242bab5486b49c10$var$editCommentEpic = (action$, store)=>action$.ofType((0, $lkPj1.EDIT_COMMENT_BEGIN)).map((action)=>$242bab5486b49c10$var$getMultilineFieldEditBeginAction(store.getState(), {
            commentId: action.payload.id
        })).filter(Boolean);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $242bab5486b49c10$var$addCommentEpic = (action$, store)=>{
    const action = action$.ofType((0, $lkPj1.ADD_COMMENT_FORM_EXPAND)).map(()=>$242bab5486b49c10$var$getMultilineFieldEditBeginAction(store.getState(), {}, true)).filter(Boolean);
    const EVENT_HORIZON_DELAY = 100;
    // FIXME this is a mitigation for issue (JRACLOUD-82570) for the period of time before fix in DST (DSP-15719)
    // execute "expand" event in timeout to give focus/blur events time to save data
    // as they will be destroyed MULTILINE_FIELD_EDIT_BEGIN action
    // we are using timeout "greater than anything" to hard separate comment focus and collapse of other fields
    return action.delay(EVENT_HORIZON_DELAY);
};
var $242bab5486b49c10$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)($242bab5486b49c10$var$editFieldEpic, $242bab5486b49c10$var$editCommentEpic, $242bab5486b49c10$var$addCommentEpic);

});

parcelRegister("qPeq9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a64d69fdb99a248e$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $lkPj1 = parcelRequire("lkPj1");

var $ePSh2 = parcelRequire("ePSh2");

var $5JqpU = parcelRequire("5JqpU");

var $gZSrt = parcelRequire("gZSrt");

var $eW7lD = parcelRequire("eW7lD");

const $a64d69fdb99a248e$var$loadNewCommentDraft = (state, useDraftHandler)=>{
    const commentId = (0, $b10b5cb385fb5d46$export$c4134c813c47beb0);
    const loggedInAccountId = (0, $5JqpU.accountIdloggedInUserSelector)(state);
    const issueKey = (0, $5JqpU.issueKeySelector)(state);
    const id = (0, $eW7lD.createCommentDraftKey)(commentId);
    const draftKey = (0, $eW7lD.getDraftKey)(loggedInAccountId, issueKey, id);
    return (0, $3JafE.Observable).of((0, $gZSrt.loadDraftRequest)(commentId, draftKey, !useDraftHandler ? null : (0, $lkPj1.editCommentUpdate)));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a64d69fdb99a248e$var$errorHandler = (error)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.new-comment-load-draft', error.message, error);
    return (0, $3JafE.Observable).empty();
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a64d69fdb99a248e$var$setContextEpic = (action$, store)=>action$.ofType((0, $ePSh2.SET_CONTEXT)).mergeMap(()=>$a64d69fdb99a248e$var$loadNewCommentDraft(store.getState(), false)).catch((error)=>$a64d69fdb99a248e$var$errorHandler(error));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a64d69fdb99a248e$var$addCommentFormExpandEpic = (action$, store)=>action$.ofType((0, $lkPj1.ADD_COMMENT_FORM_EXPAND)).mergeMap(()=>$a64d69fdb99a248e$var$loadNewCommentDraft(store.getState(), true)).catch((error)=>$a64d69fdb99a248e$var$errorHandler(error));
var $a64d69fdb99a248e$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)($a64d69fdb99a248e$var$setContextEpic, $a64d69fdb99a248e$var$addCommentFormExpandEpic);

});

parcelRegister("bSPT2", function(module, exports) {

$parcel$export(module.exports, "default", () => $170415468a21764d$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("l5lul");
parcelRequire("3wBUP");
parcelRequire("eDJGt");

var $MdoH4 = parcelRequire("MdoH4");

var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");

var $6ueJ6 = parcelRequire("6ueJ6");

var $7JlQ7 = parcelRequire("7JlQ7");
const $170415468a21764d$var$bufferTimeMs = 1000;
const $170415468a21764d$var$bufferMaxSize = 50;
const $170415468a21764d$var$key$ = new (0, $70s4u.Subject)();
$170415468a21764d$var$key$.bufferTime($170415468a21764d$var$bufferTimeMs, $170415468a21764d$var$bufferTimeMs, $170415468a21764d$var$bufferMaxSize).subscribe((keysArr)=>{
    (0, $7JlQ7.getDataProvider)().loadIssues((0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(keysArr));
});
const $170415468a21764d$var$id$ = new (0, $70s4u.Subject)();
$170415468a21764d$var$id$.bufferTime($170415468a21764d$var$bufferTimeMs, $170415468a21764d$var$bufferTimeMs, $170415468a21764d$var$bufferMaxSize).subscribe((idArr)=>(0, $7JlQ7.getDataProvider)().loadIssuesById((0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(idArr)));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$170415468a21764d$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $6ueJ6.PREFETCH_ISSUES)).do((action)=>{
        const { issueKeys: issueKeys, issueIds: issueIds } = action.payload;
        issueKeys.forEach((key)=>$170415468a21764d$var$key$.next(key));
        issueIds.forEach((id)=>$170415468a21764d$var$id$.next(id));
    }).switchMap(()=>(0, $3JafE.Observable).empty());

});
parcelRegister("6ueJ6", function(module, exports) {

$parcel$export(module.exports, "PREFETCH_ISSUES", () => $9a7ec5cd796ff766$export$3f159e507b3db601);
const $9a7ec5cd796ff766$export$3f159e507b3db601 = 'PREFETCH_ISSUES';
const $9a7ec5cd796ff766$export$c9ea35b74a16b64f = ({ issueKeys: issueKeys, issueIds: issueIds })=>({
        type: $9a7ec5cd796ff766$export$3f159e507b3db601,
        payload: {
            issueKeys: issueKeys || [],
            issueIds: issueIds || []
        }
    });

});


parcelRegister("3bf75", function(module, exports) {

$parcel$export(module.exports, "default", () => $63143627a3434a83$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("l5lul");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $6TtLT = parcelRequire("6TtLT");

var $ltjPP = parcelRequire("ltjPP");

var $5JqpU = parcelRequire("5JqpU");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$63143627a3434a83$export$2e2bcd8739ae039 = (projectContextActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (action$, store)=>action$.ofType((0, $ltjPP.PROJECT_ISSUE_TYPES_REQUEST)).mergeMap((action)=>{
            const baseUrl = (0, $5JqpU.baseUrlSelector)(store.getState());
            const projectKey = action.payload;
            return (0, $6TtLT.getProjectIssueTypes)(baseUrl, projectKey).do((issueTypes)=>projectContextActions.mergeProjectProperty(projectKey, {
                    issueTypes: issueTypes
                })).map((issueTypes)=>(0, $ltjPP.projectIssueTypeSuccess)(issueTypes)).catch((error)=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData('change.issue.type.fetchtypes', error.message, error);
                return (0, $3JafE.Observable).of((0, $ltjPP.projectIssueTypeFailure)(error));
            });
        });

});

parcelRegister("5imTx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3144c08d8f6293f9$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("l5lul");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $i89MO = parcelRequire("i89MO");

var $5JqpU = parcelRequire("5JqpU");

var $a2FsU = parcelRequire("a2FsU");
const $3144c08d8f6293f9$var$fetchProjectHasSubtaskValidators = (action$, store)=>action$.ofType((0, $i89MO.FETCH_PROJECT_HAS_SUBTASK_VALIDATORS)).switchMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const projectKey = (0, $5JqpU.projectKeySelector)(state);
        return (0, $a2FsU.fetchProjectHasSubtaskValidators)(baseUrl, projectKey)// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'boolean'.
        .map((response)=>(0, $i89MO.fetchProjectHasSubtaskValidatorsSuccessAction)(response)).catch(()=>(0, $3JafE.Observable).of((0, $i89MO.fetchProjectHasSubtaskValidatorsFailureAction)()));
    });
var $3144c08d8f6293f9$export$2e2bcd8739ae039 = $3144c08d8f6293f9$var$fetchProjectHasSubtaskValidators;

});
parcelRegister("a2FsU", function(module, exports) {

$parcel$export(module.exports, "fetchProjectHasSubtaskValidators", () => $8e739a26fc5810e7$export$71562c3a52bc0df0);

var $aiRd8 = parcelRequire("aiRd8");
const $8e739a26fc5810e7$var$createProjectHasSubtaskValidatorsUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/internal/2/project/${projectKey}/hasValidatorsOnSubtasks`;
const $8e739a26fc5810e7$export$71562c3a52bc0df0 = (baseUrl, projectKey)=>(0, $aiRd8.default)($8e739a26fc5810e7$var$createProjectHasSubtaskValidatorsUrl(baseUrl, projectKey));

});


parcelRegister("aawsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a54df09d20dd93$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("1Lcr1");
parcelRequire("fiQ2m");
parcelRequire("fWv6o");
parcelRequire("8OtG5");
parcelRequire("flmol");
parcelRequire("8SBcT");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $aiRd8 = parcelRequire("aiRd8");

var $3A3OQ = parcelRequire("3A3OQ");

var $ePSh2 = parcelRequire("ePSh2");

var $5JqpU = parcelRequire("5JqpU");
const $e1a54df09d20dd93$var$LOG_LOCATION = 'issue.recently-viewed-issue-epic';
/*
 * Checks for actual error message in response as well to guard against potential
 * (if unlikely) change in API that results in a different 404 with a different root cause
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e1a54df09d20dd93$var$isInaccessibleIssue = (error)=>error.statusCode === 404;
var // Whenever the issue key is changed (including when the issue app is initialized)
// then we add the issue to the user's history
// eslint-disable-next-line jira/import/no-anonymous-default-export
$e1a54df09d20dd93$export$2e2bcd8739ae039 = (actions$, store)=>// @ts-expect-error - TS2322 - Type 'Observable<unknown>' is not assignable to type 'Observable<{ type: "SET_CONTEXT"; payload: Partial<ContextState>; }>'.
    actions$.ofType((0, $ePSh2.SET_CONTEXT)).scan(// @ts-expect-error - TS2769 - No overload matches this call.
    ({ issueKey: issueKey }, action)=>({
            issueKey: action.payload.issueKey,
            loggedInAccountId: action.payload.atlassianAccountId,
            previousIssueKey: issueKey
        }), {
        issueKey: null,
        previousIssueKey: null,
        loggedInAccountId: null
    })// @ts-expect-error - TS2339 - Property 'loggedInAccountId' does not exist on type '{ type: "SET_CONTEXT"; payload: Partial<ContextState>; }'.
    .filter(({ loggedInAccountId: loggedInAccountId })=>loggedInAccountId !== null)// @ts-expect-error - TS2339 - Property 'issueKey' does not exist on type '{ type: "SET_CONTEXT"; payload: Partial<ContextState>; }'. | TS2339 - Property 'previousIssueKey' does not exist on type '{ type: "SET_CONTEXT"; payload: Partial<ContextState>; }'.
    .filter(({ issueKey: issueKey, previousIssueKey: previousIssueKey })=>issueKey !== previousIssueKey)// @ts-expect-error - TS2339 - Property 'issueKey' does not exist on type '{ type: "SET_CONTEXT"; payload: Partial<ContextState>; }'.
    .map(({ issueKey: issueKey })=>issueKey).delay(3000).switchMap((issueKey)=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const url = `${baseUrl}/rest/internal/2/issue/${issueKey}/history`;
        const options = {
            method: 'POST'
        };
        return (0, $aiRd8.default)(url, options).catch((error)=>{
            if (!$e1a54df09d20dd93$var$isInaccessibleIssue(error)) (0, $3A3OQ.trackOrLogClientError)($e1a54df09d20dd93$var$LOG_LOCATION, // TODO: "Failed to update user's issue history" for non-fetch
            'Client network error occurred when fetching user issue history', error);
            return (0, $3JafE.Observable).empty();
        }).ignoreElements();
    });

});

parcelRegister("dtfqO", function(module, exports) {

$parcel$export(module.exports, "saveRemoteLinkedIssueRequestEpic", () => $525b11e97cb7a854$export$92a8419900a0cf3a);
$parcel$export(module.exports, "saveRemoteLinkedIssueRetryEpic", () => $525b11e97cb7a854$export$4c257cc1a5b28d9a);
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");
var $JRB5w = parcelRequire("JRB5w");


var $au0tx = parcelRequire("au0tx");

var $02hYD = parcelRequire("02hYD");

var $5JqpU = parcelRequire("5JqpU");

var $cFY86 = parcelRequire("cFY86");
const $525b11e97cb7a854$var$saveRemoteLinkedIssue = (state, saveRemoteIssueLinkPayload, requestAnalyticsEvent, onSuccess, onError)=>{
    const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
    const thisIssueKey = (0, $5JqpU.issueKeySelector)(state);
    // @ts-expect-error - TS2684 - The 'this' context of type 'Observable<unknown>' is not assignable to method's 'this' of type 'Observable<SaveRemoteIssueLinkResponse>'.
    return (0, $au0tx.saveRemoteIssueLink)(baseUrl, thisIssueKey, saveRemoteIssueLinkPayload).map((response)=>(0, $02hYD.saveRemoteLinkedIssueSuccess)(saveRemoteIssueLinkPayload.id, response, requestAnalyticsEvent.update({
            action: 'succeeded',
            isReciprocalLinkCreated: response.reciprocalLink?.status === (0, $70e59ad1dd71402d$export$8c3104c763ff334)
        }))).do(()=>{
        if ((0, $1ybV0.ff)('analytics_event_for_deletion_of_linked_issue_1ufi8')) onSuccess?.();
    }).catch((error)=>{
        if ((0, $1ybV0.ff)('analytics_event_for_deletion_of_linked_issue_1ufi8')) {
            if (!((0, $1ybV0.ff)('ken-429-restrict-4xx-error_vi8v7') && error instanceof (0, $7byHA.default) && (0, $JRB5w.isHttpClientErrorResponse)(error))) onError?.();
        }
        return (0, $3JafE.Observable).of((0, $02hYD.saveRemoteLinkedIssueFailure)(saveRemoteIssueLinkPayload.id, saveRemoteIssueLinkPayload.issueKey, error, requestAnalyticsEvent.update({
            action: 'failed',
            isReciprocalLinkCreated: false
        })));
    });
};
const $525b11e97cb7a854$export$92a8419900a0cf3a = (action$, store)=>action$.ofType((0, $02hYD.SAVE_REMOTE_LINKED_ISSUE_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const { saveRemoteIssueLinkPayload: saveRemoteIssueLinkPayload, requestAnalyticsEvent: requestAnalyticsEvent, onSuccess: onSuccess, onError: onError } = action.payload;
        return $525b11e97cb7a854$var$saveRemoteLinkedIssue(state, saveRemoteIssueLinkPayload, requestAnalyticsEvent, onSuccess, onError);
    });
const $525b11e97cb7a854$var$getAndValidateSaveRemoteIssueLinkPayload = (state, optimisticId)=>{
    const optimisticRemoteIssueLink = (0, $cFY86.remoteIssuesSelector)(state).find((link)=>link.id === optimisticId);
    if (!optimisticRemoteIssueLink || optimisticRemoteIssueLink.applicationName === undefined || optimisticRemoteIssueLink.applicationType === undefined || optimisticRemoteIssueLink.iconUrl === undefined || optimisticRemoteIssueLink.relationship === undefined || optimisticRemoteIssueLink.summary === undefined) return undefined;
    const partialPayload = {
        id: optimisticRemoteIssueLink.id,
        applicationType: optimisticRemoteIssueLink.applicationType,
        applicationName: optimisticRemoteIssueLink.applicationName,
        issueLinkUrl: optimisticRemoteIssueLink.issueLinkUrl,
        relationship: optimisticRemoteIssueLink.relationship,
        summary: optimisticRemoteIssueLink.summary,
        iconUrl: optimisticRemoteIssueLink.iconUrl,
        issueKey: optimisticRemoteIssueLink.issueKey,
        createReciprocalLink: Boolean(optimisticRemoteIssueLink.createReciprocalLink)
    };
    if (optimisticRemoteIssueLink.globalId === undefined) {
        if (optimisticRemoteIssueLink.appLinkId === undefined) return undefined;
        return {
            ...partialPayload,
            // @ts-expect-error - TS2322 - Type '{ appLinkId: string; payloadType: "WITHOUT_ISSUE_ID"; id: string; applicationType: string; applicationName: string; issueLinkUrl: string; relationship: string; summary: string; iconUrl: string; issueKey: string; createReciprocalLink: boolean; }' is not assignable to type 'RemoteIssueLinkPayloadWithIssueId'.
            appLinkId: optimisticRemoteIssueLink.appLinkId,
            payloadType: (0, $70e59ad1dd71402d$export$301a5c7f9b4c13e1)
        };
    }
    return {
        ...partialPayload,
        globalId: optimisticRemoteIssueLink.globalId,
        remoteIssueId: optimisticRemoteIssueLink.remoteIssueId,
        payloadType: (0, $70e59ad1dd71402d$export$df68a44a73b1d288)
    };
};
const $525b11e97cb7a854$export$4c257cc1a5b28d9a = (action$, store)=>action$.ofType((0, $02hYD.SAVE_REMOTE_LINKED_ISSUE_RETRY)).mergeMap((action)=>{
        const state = store.getState();
        const { optimisticId: optimisticId, requestAnalyticsEvent: requestAnalyticsEvent, onSuccess: onSuccess, onError: onError } = action.payload;
        // optimistic remoteIssueLink is always supposed to be a "valid SaveRemoteIssueLinkPayload"
        // getAndValidateSaveRemoteIssueLinkPayload() is used for flow type conversion
        const saveRemoteIssueLinkPayload = $525b11e97cb7a854$var$getAndValidateSaveRemoteIssueLinkPayload(state, optimisticId);
        if (saveRemoteIssueLinkPayload) return $525b11e97cb7a854$var$saveRemoteLinkedIssue(state, saveRemoteIssueLinkPayload, requestAnalyticsEvent.update({
            withReciprocalLink: Boolean(saveRemoteIssueLinkPayload.createReciprocalLink)
        }), onSuccess, onError);
        return (0, $3JafE.Observable).empty();
    });

});
parcelRegister("au0tx", function(module, exports) {

$parcel$export(module.exports, "saveRemoteIssueLink", () => $99756e4d0c97a9e2$export$9d8ec7f5b496297d);

var $fVqUX = parcelRequire("fVqUX");

var $aiRd8 = parcelRequire("aiRd8");


var $lV5H0 = parcelRequire("lV5H0");
const $99756e4d0c97a9e2$export$88edd3c7eace54f = (remoteLink)=>{
    const { applicationType: applicationType, applicationName: applicationName, issueLinkUrl: issueLinkUrl, relationship: relationship, summary: summary, iconUrl: iconUrl, issueKey: issueKey, createReciprocalLink: createReciprocalLink } = remoteLink;
    const extraField = remoteLink.payloadType === (0, $70e59ad1dd71402d$export$df68a44a73b1d288) ? {
        globalId: remoteLink.globalId
    } : {
        // @ts-expect-error - TS2339 - Property 'appLinkId' does not exist on type 'RemoteIssueLinkPayloadWithIssueId'.
        appLinkId: remoteLink.appLinkId
    };
    return {
        application: {
            name: applicationName,
            type: applicationType
        },
        relationship: relationship,
        object: {
            summary: summary,
            icon: {
                url16x16: iconUrl
            },
            title: issueKey,
            url: issueLinkUrl
        },
        createReciprocalLink: createReciprocalLink,
        ...extraField
    };
};
const $99756e4d0c97a9e2$var$postOptions = {
    ...(0, $fVqUX.default),
    method: 'POST'
};
const $99756e4d0c97a9e2$export$9d8ec7f5b496297d = (baseUrl, thisIssueKey, remoteLink)=>(0, $aiRd8.default)((0, $lV5H0.getSaveRemoteIssueLinksUrl)(baseUrl, thisIssueKey), {
        ...$99756e4d0c97a9e2$var$postOptions,
        body: JSON.stringify($99756e4d0c97a9e2$export$88edd3c7eace54f(remoteLink))
    });

});


parcelRegister("dtzZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $22e80e7b5cbeb3ac$export$2e2bcd8739ae039);
parcelRequire("1Lcr1");
parcelRequire("jyKN9");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $aiRd8 = parcelRequire("aiRd8");

var $j8N3l = parcelRequire("j8N3l");

var $5JqpU = parcelRequire("5JqpU");
const $22e80e7b5cbeb3ac$export$94df0e59ebebf4a7 = (baseUrl, issueKey)=>`${baseUrl}/rest/servicedesk/1/servicedesk/request/${issueKey}/request-panel-metadata`;
const $22e80e7b5cbeb3ac$var$fetchRequestPanelMetadata = (state)=>(0, $aiRd8.default)($22e80e7b5cbeb3ac$export$94df0e59ebebf4a7((0, $5JqpU.baseUrlSelector)(state), (0, $5JqpU.issueKeySelector)(state)));
const $22e80e7b5cbeb3ac$var$handleSuccess = (result)=>(0, $3JafE.Observable).of((0, $j8N3l.requestPanelMetadataFetchSuccess)(result));
const $22e80e7b5cbeb3ac$var$handleFailure = (error)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.request-panel-metadata.fetch', error.message, error);
    return (0, $3JafE.Observable).of((0, $j8N3l.requestPanelMetadataFetchFailure)());
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$22e80e7b5cbeb3ac$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $j8N3l.FETCH_REQUEST_PANEL_METADATA)).flatMap(()=>$22e80e7b5cbeb3ac$var$fetchRequestPanelMetadata(store.getState())// @ts-expect-error - TS2345 - Argument of type '(result: unknown) => Observable<{ type: "REQUEST_PANEL_METADATA_FETCH_SUCCESS"; payload: { channel: "unknown" | "jira" | "email" | "api" | "deployment" | "portal" | "anonymousportal"; requestUrl: string | undefined; csatComment: string | undefined; }; }> | Observable<...>' is not assignable to parameter of type '(value: unknown, index: number) => ObservableInput<{ type: "REQUEST_PANEL_METADATA_FETCH_SUCCESS"; payload: { channel: "unknown" | "jira" | "email" | "api" | "deployment" | "portal" | "anonymousportal"; requestUrl: string | undefined; csatComment: string | undefined; }; }>'.
        .flatMap((result)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            if (result.errors) // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'Error'.
            return $22e80e7b5cbeb3ac$var$handleFailure(result);
            // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'RequestPanelMetadata'.
            return $22e80e7b5cbeb3ac$var$handleSuccess(result);
        }).catch((error)=>$22e80e7b5cbeb3ac$var$handleFailure(error)));

});

parcelRegister("fl09I", function(module, exports) {

$parcel$export(module.exports, "scrollToCommentEpic", () => $da5fc44e4fa0ce90$export$16e9f6189d4d61bc);

var $3JafE = parcelRequire("3JafE");

var $l129t = parcelRequire("l129t");

var $9s86T = parcelRequire("9s86T");
var $6VKiL = parcelRequire("6VKiL");
parcelRequire("iects");
parcelRequire("8jBvP");
const $da5fc44e4fa0ce90$export$16e9f6189d4d61bc = (issueScrollAction, history)=>(action$)=>action$.ofType((0, $l129t.SCROLL_TO_COMMENT)).mergeMap((action)=>{
            history.push((0, $9s86T.getUrlPermalinkParameter)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            action.payload.commentId, (0, $6VKiL.PermalinkType).COMMENTS));
            issueScrollAction.setScrollTarget(null);
            return (0, $3JafE.Observable).empty();
        });

});

parcelRegister("7uqwk", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bc7d161e0944681$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $lkPj1 = parcelRequire("lkPj1");

var $1GZlZ = parcelRequire("1GZlZ");


var $dmojD = parcelRequire("dmojD");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0bc7d161e0944681$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $1GZlZ.SHARE_AS_COMMENT)).switchMap(()=>{
        const state = store.getState();
        const isEditorOpen = (0, $dmojD.isAddCommentEditorExpandedSelector)(state);
        if (!isEditorOpen) return (0, $3JafE.Observable).of((0, $lkPj1.addCommentFormExpand)(), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $lkPj1.changeCommentVisibility)((0, $b10b5cb385fb5d46$export$c4134c813c47beb0), false));
        return (0, $3JafE.Observable).empty();
    });

});

parcelRegister("5FKM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $49a6f955a55eeab0$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $aiRd8 = parcelRequire("aiRd8");

var $3A3OQ = parcelRequire("3A3OQ");

var $blHvU = parcelRequire("blHvU");

var $a0Zgz = parcelRequire("a0Zgz");

var $5JqpU = parcelRequire("5JqpU");

var $8WoTv = parcelRequire("8WoTv");
const $49a6f955a55eeab0$export$25a759e49d5049db = 'issue.fetch.user-fetch-epic';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$49a6f955a55eeab0$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $a0Zgz.FETCH_LOGGED_IN_USER_REQUEST)).switchMap(()=>{
        const state = store.getState();
        const loggedInAccountId = (0, $5JqpU.accountIdloggedInUserSelector)(state);
        if (!loggedInAccountId) return (0, $3JafE.Observable).empty();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const url = (0, $8WoTv.getUserUrl)(baseUrl, loggedInAccountId);
        return (0, $aiRd8.default)(url).map((0, $blHvU.validateUser)).map((serverUser)=>{
            const loggedInUserSuccessAction = (0, $blHvU.transformUser)(serverUser);
            return (0, $a0Zgz.fetchLoggedInUserSuccess)(loggedInUserSuccessAction);
        }).catch((error)=>{
            (0, $3A3OQ.trackOrLogClientError)($49a6f955a55eeab0$export$25a759e49d5049db, 'FETCH_LOGGED_IN_USER_REQUEST: Failed to fetch logged in user details', error);
            return (0, $3JafE.Observable).of((0, $a0Zgz.fetchLoggedInUserFailure)());
        });
    });

});
parcelRegister("8WoTv", function(module, exports) {

$parcel$export(module.exports, "getUserUrl", () => $bbaa745cc2dc7173$export$33924819675dff21);
const $bbaa745cc2dc7173$export$33924819675dff21 = (baseUrl, accountId)=>{
    const userQuery = `accountId=${encodeURIComponent(accountId)}`;
    return `${baseUrl}/rest/api/2/user?${userQuery}`;
};

});


parcelRegister("hGVvs", function(module, exports) {

$parcel$export(module.exports, "deleteWebLink", () => $a534aafa123f704b$export$2ae2b9d5e3eaeedb);
$parcel$export(module.exports, "createWebLink", () => $a534aafa123f704b$export$965d46b33fc064f9);
$parcel$export(module.exports, "createWebLinkRetry", () => $a534aafa123f704b$export$16ad5167a58e7f9e);
parcelRequire("cpH8E");
parcelRequire("jyKN9");
parcelRequire("9u6v2");
parcelRequire("8jBvP");
parcelRequire("3wBUP");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $3A3OQ = parcelRequire("3A3OQ");

var $hficN = parcelRequire("hficN");

var $5JqpU = parcelRequire("5JqpU");

var $6gpYd = parcelRequire("6gpYd");

var $6vrw7 = parcelRequire("6vrw7");

var $gzLYZ = parcelRequire("gzLYZ");
const $a534aafa123f704b$var$LOG_LOCATION = 'issue.fetch.web-links-epic';
const $a534aafa123f704b$var$logError = (error, logMessage, logLocation)=>{
    (0, $3A3OQ.trackOrLogClientError)(logLocation, logMessage, error);
};
const $a534aafa123f704b$export$c94e3968c2098568 = (action, baseUrl, issueId, optimisticWebLink, actionType)=>{
    if (issueId === undefined || optimisticWebLink === undefined) {
        const errorMessage = issueId === undefined ? 'No issueId when creating weblink' : 'Broken weblink state when creating weblink';
        (0, $gUUjF.default).safeErrorWithoutCustomerData($a534aafa123f704b$var$LOG_LOCATION, actionType, new Error(errorMessage));
        return (0, $3JafE.Observable).empty();
    }
    // @ts-expect-error - TS2339 - Property 'href' does not exist on type 'WebLink | null'. | TS2339 - Property 'linkText' does not exist on type 'WebLink | null'. | TS2339 - Property 'iconUrl' does not exist on type 'WebLink | null'.
    const { href: href, linkText: linkText, iconUrl: iconUrl } = optimisticWebLink;
    const iconUrlHref = iconUrl === null || iconUrl === undefined ? '' : iconUrl;
    return (0, $3JafE.Observable).from((0, $gzLYZ.createWebLinkRequest)({
        baseUrl: baseUrl,
        href: href,
        // TODO: Need to understand & update logic code to fix this issue, e.g. checking null and return a default value
        // @ts-expect-error - TS2531 - Object is possibly 'null'.
        issueId: (0, $6vrw7.toIssueId)(issueId.toString()),
        linkText: linkText == null ? href : linkText,
        iconUrl: (0, $6vrw7.toHref)(iconUrlHref)
    }))// @ts-expect-error - TS2531 - Object is possibly 'null'.
    .map((webLink)=>(0, $hficN.createWebLinkSuccess)(optimisticWebLink.id, webLink)).catch((error)=>{
        const logMessage = `${actionType}: Failed to create web link`;
        $a534aafa123f704b$var$logError(error, logMessage, $a534aafa123f704b$var$LOG_LOCATION);
        // @ts-expect-error - TS2531 - Object is possibly 'null'.
        return (0, $3JafE.Observable).of((0, $hficN.createWebLinkFailed)(optimisticWebLink.id, error));
    });
};
const $a534aafa123f704b$export$2ae2b9d5e3eaeedb = (action$, store)=>action$.ofType((0, $hficN.DELETE_WEB_LINK_REQUEST)).switchMap((action)=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueKey = (0, $5JqpU.issueKeySelector)(state);
        const { id: id } = action.payload;
        return (0, $3JafE.Observable).fromPromise((0, $gzLYZ.getDeleteRequest)(baseUrl, issueKey, id)).map(()=>(0, $hficN.deleteWebLinkSuccess)(id)).catch((error)=>{
            const logMessage = `${(0, $hficN.DELETE_WEB_LINK_REQUEST)}: Failed to delete web link`;
            $a534aafa123f704b$var$logError(error, logMessage, $a534aafa123f704b$var$LOG_LOCATION);
            return (0, $3JafE.Observable).of((0, $hficN.deleteWebLinkFailed)(id));
        });
    });
const $a534aafa123f704b$export$965d46b33fc064f9 = (action$, store)=>action$.ofType((0, $hficN.CREATE_WEB_LINK_REQUEST)).switchMap((action)=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueId = (0, $5JqpU.issueIdSelector)(state);
        const { optimisticId: optimisticId } = action.payload;
        const optimisticWebLink = (0, $6gpYd.webLinkSelector)(optimisticId)(state);
        return $a534aafa123f704b$export$c94e3968c2098568(action, baseUrl, issueId, optimisticWebLink, (0, $hficN.CREATE_WEB_LINK_REQUEST));
    });
const $a534aafa123f704b$export$16ad5167a58e7f9e = (action$, store)=>action$.ofType((0, $hficN.CREATE_WEB_LINK_RETRY)).switchMap((action)=>{
        const state = store.getState();
        const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
        const issueId = (0, $5JqpU.issueIdSelector)(state);
        const { optimisticId: optimisticId } = action.payload;
        const optimisticWebLink = (0, $6gpYd.webLinkSelector)(optimisticId)(state);
        return $a534aafa123f704b$export$c94e3968c2098568(action, baseUrl, issueId, optimisticWebLink, (0, $hficN.CREATE_WEB_LINK_RETRY));
    });

});
parcelRegister("6gpYd", function(module, exports) {

$parcel$export(module.exports, "webLinksSelector", () => $61dbdc34d05753bb$export$d3b38151edc098d5);
$parcel$export(module.exports, "webLinksWithApplicationIdSelector", () => $61dbdc34d05753bb$export$c1f6dd50de32a93);
$parcel$export(module.exports, "additionalWebLinksSectionsSelector", () => $61dbdc34d05753bb$export$9845af8037a2729e);
$parcel$export(module.exports, "webLinkSelector", () => $61dbdc34d05753bb$export$335eb170253f4684);
$parcel$export(module.exports, "canAddWebLinksSelector", () => $61dbdc34d05753bb$export$df2ce4e2736b1e9b);
$parcel$export(module.exports, "webLinksCountSelector", () => $61dbdc34d05753bb$export$65a056b7822ce250);
$parcel$export(module.exports, "createWebLinkClickedCountSelector", () => $61dbdc34d05753bb$export$4ce574f877ede096);
$parcel$export(module.exports, "isCreateWebLinkOpenedSelector", () => $61dbdc34d05753bb$export$353d4f2790a2f3b7);

var $df4Sl = parcelRequire("df4Sl");

var $jqvCZ = parcelRequire("jqvCZ");

var $lyOYo = parcelRequire("lyOYo");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");
const $61dbdc34d05753bb$export$237ec6cc639eb1a0 = Symbol('GENERIC');
const $61dbdc34d05753bb$export$15b6debedb64e24c = (applicationName, applicationType)=>`${applicationName}${typeof applicationType === 'string' ? applicationType : ''}`;
const $61dbdc34d05753bb$var$webLinksRootSelector = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.webLinks);
const $61dbdc34d05753bb$export$d3b38151edc098d5 = (0, $df4Sl.createSelector)($61dbdc34d05753bb$var$webLinksRootSelector, (webLinks)=>webLinks.links.filter(// @ts-expect-error - TS2339 - Property 'isDeleting' does not exist on type 'WebLink'. | TS2339 - Property 'isDeleting' does not exist on type 'WebLink'.
    (link)=>link.isDeleting === undefined || link.isDeleting !== true));
const $61dbdc34d05753bb$export$c1f6dd50de32a93 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (_, applicationId)=>applicationId, (()=>{
    let previousWebLinks = null;
    const memoizedWebLinksWithApplicationId = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((entities, applicationId)=>entities.webLinks.links.filter((link)=>{
            const isLinkDeleted = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            link.isDeleting !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            link.isDeleting === true;
            if (isLinkDeleted) return false;
            // Filter for generic web links
            if (applicationId === undefined) return typeof link.applicationName !== 'string' || link.applicationName.trim() === '';
            // Filter for web links by id
            return typeof link.applicationName === 'string' && link.applicationName.trim() !== '' && applicationId === $61dbdc34d05753bb$export$15b6debedb64e24c(link.applicationName, link.applicationType);
        })// Sort from old to new
        .reverse(), ({ webLinks: webLinks }, appId)=>{
        if (previousWebLinks !== null && previousWebLinks !== webLinks) // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
        memoizedWebLinksWithApplicationId.cache.clear();
        previousWebLinks = webLinks;
        return appId !== undefined ? appId : $61dbdc34d05753bb$export$237ec6cc639eb1a0;
    });
    return memoizedWebLinksWithApplicationId;
})());
const $61dbdc34d05753bb$export$9845af8037a2729e = (0, $df4Sl.createSelector)($61dbdc34d05753bb$export$d3b38151edc098d5, (allWebLinks)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const linksWithId = allWebLinks.reduce((links, currentLink)=>{
        const { applicationName: applicationName, applicationType: applicationType } = currentLink;
        if (typeof applicationName !== 'string' || applicationName.trim() === '') return links;
        return [
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...links,
            {
                applicationName: applicationName,
                applicationId: $61dbdc34d05753bb$export$15b6debedb64e24c(applicationName, applicationType)
            }
        ];
    }, []);
    const uniqLinkSections = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(linksWithId, 'applicationId');
    // Sort the sections in alphabetical order
    uniqLinkSections.sort((a, b)=>a.applicationId.localeCompare(b.applicationId));
    return uniqLinkSections;
});
const $61dbdc34d05753bb$export$335eb170253f4684 = (webLinkId)=>(0, $df4Sl.createSelector)($61dbdc34d05753bb$export$d3b38151edc098d5, (webLinks)=>webLinks.find((webLink)=>webLink.id === webLinkId));
const $61dbdc34d05753bb$export$df2ce4e2736b1e9b = (0, $df4Sl.createSelector)($61dbdc34d05753bb$var$webLinksRootSelector, (0, $9F6MO.permissionsSelector), (webLinks, permissions)=>webLinks.isLinkingEnabled === true && permissions.canLinkIssues);
const $61dbdc34d05753bb$export$65a056b7822ce250 = (0, $df4Sl.createSelector)($61dbdc34d05753bb$var$webLinksRootSelector, (webLinks)=>webLinks.linkCount);
const $61dbdc34d05753bb$export$4ce574f877ede096 = (0, $df4Sl.createSelector)($61dbdc34d05753bb$var$webLinksRootSelector, (webLinks)=>webLinks.createClickCount);
const $61dbdc34d05753bb$export$353d4f2790a2f3b7 = (0, $df4Sl.createSelector)($61dbdc34d05753bb$export$4ce574f877ede096, (createWebLinkClickedCount)=>createWebLinkClickedCount > 0);

});

parcelRegister("gzLYZ", function(module, exports) {

$parcel$export(module.exports, "getDeleteRequest", () => $3dcf0a44dee579ac$export$c860b17e11bc1d12);
$parcel$export(module.exports, "createWebLinkRequest", () => $3dcf0a44dee579ac$export$42593ebfaa6f0598);

var $lRmyA = parcelRequire("lRmyA");

var $6vrw7 = parcelRequire("6vrw7");
const $3dcf0a44dee579ac$var$createWebLinkUrl = (baseUrl, issueId)=>`${baseUrl}/rest/api/3/issue/${issueId}/remotelink`;
const $3dcf0a44dee579ac$var$createWebLinkPostBody = (linkText, href, iconUrl)=>({
        object: {
            icon: {
                url16x16: iconUrl
            },
            title: linkText,
            url: href
        }
    });
const $3dcf0a44dee579ac$var$transformCreatedWebLink = (response, href, linkText, iconUrl)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ({
        id: (0, $6vrw7.toWebLinkId)(response.id),
        href: href,
        linkText: linkText,
        iconUrl: iconUrl,
        resolved: null,
        relationship: null,
        applicationName: null,
        applicationType: null
    });
const $3dcf0a44dee579ac$export$c860b17e11bc1d12 = (baseUrl, issueKey, id)=>(0, $lRmyA.performDeleteRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/remotelink/${id}`);
const $3dcf0a44dee579ac$export$42593ebfaa6f0598 = ({ baseUrl: baseUrl, issueId: issueId, href: href, linkText: linkText, iconUrl: iconUrl })=>(0, $lRmyA.performPostRequest)(`${$3dcf0a44dee579ac$var$createWebLinkUrl(baseUrl, issueId)}`, {
        body: JSON.stringify($3dcf0a44dee579ac$var$createWebLinkPostBody(linkText, href, iconUrl))
    }).then((response)=>$3dcf0a44dee579ac$var$transformCreatedWebLink(response, href, linkText, iconUrl));

});


parcelRegister("9noVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a52cc403c919c1e6$export$2e2bcd8739ae039);
parcelRequire("8OtG5");
parcelRequire("dfsI8");

var $9Y7ra = parcelRequire("9Y7ra");

var $hlJEN = parcelRequire("hlJEN");
const $a52cc403c919c1e6$var$fetchViewContextOnWorklogSuccess = (action$)=>action$.ofType((0, $9Y7ra.EDIT_WORKLOG_SUCCESS), (0, $9Y7ra.ADD_WORKLOG_SUCCESS)).filter((action)=>action.meta.shouldFetchViewContext).mapTo((0, $hlJEN.fetchViewContextRequest)());
var $a52cc403c919c1e6$export$2e2bcd8739ae039 = $a52cc403c919c1e6$var$fetchViewContextOnWorklogSuccess;

});

parcelRegister("4KEfA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8b1796d5aad8214$export$2e2bcd8739ae039);
parcelRequire("l5lul");
parcelRequire("fiQ2m");

var $gUUjF = parcelRequire("gUUjF");

var $2rJdp = parcelRequire("2rJdp");

var $fE3Ua = parcelRequire("fE3Ua");

var $ltjPP = parcelRequire("ltjPP");

var $hHnBv = parcelRequire("hHnBv");

var $6ySNE = parcelRequire("6ySNE");

var $49xWy = parcelRequire("49xWy");

var $3b6FJ = parcelRequire("3b6FJ");

var $5JqpU = parcelRequire("5JqpU");

var $fVCj0 = parcelRequire("fVCj0");

var $6vrw7 = parcelRequire("6vrw7");

var $9RIZX = parcelRequire("9RIZX");
const $e8b1796d5aad8214$var$actions = [
    (0, $fVCj0.FIELD_SAVE_SUCCESS),
    (0, $ltjPP.SIMPLE_CHANGE_ISSUE_TYPE_REQUEST_SUCCESS),
    (0, $3b6FJ.ISSUE_RELATIONSHIP_UPDATE_SUCCESS),
    (0, $fVCj0.FIELD_SAVE_REQUEST),
    (0, $fVCj0.FIELD_SAVE_FAILURE),
    (0, $fVCj0.FIELD_UPDATED),
    (0, $fVCj0.FIELD_CONFIRM_NEW_FIELD),
    (0, $fVCj0.FIELD_CONFIRM_FAILURE_NEW_FIELD),
    // action is fired after a new link is created
    (0, $49xWy.FETCH_LINKED_ISSUES_DATA_SUCCESS),
    (0, $49xWy.DELETE_LINKED_ISSUE_SUCCESS),
    (0, $hHnBv.CHILD_ISSUE_ADD_SUCCESS),
    (0, $hHnBv.SUBTASK_ADD_SUCCESS),
    (0, $hHnBv.ISSUE_CHILDREN_ORDER_CHANGE_SUCCESS),
    (0, $hHnBv.CHILD_ISSUE_FIELD_UPDATED),
    (0, $6ySNE.CREATE_CONFLUENCE_PAGE_LINK_SUCCESS),
    (0, $6ySNE.DELETE_CONFLUENCE_PAGE_LINK_SUCCESS)
];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e8b1796d5aad8214$export$2e2bcd8739ae039 = (onChange, issueViewFieldUpdateActions)=>(action$, store)=>action$.ofType(...$e8b1796d5aad8214$var$actions).do((action)=>{
            if (!onChange) return;
            try {
                const issueId = (0, $6vrw7.toIssueId)(String((0, $5JqpU.issueIdSelector)(store.getState())));
                switch(action.type){
                    case 0, $ltjPP.SIMPLE_CHANGE_ISSUE_TYPE_REQUEST_SUCCESS:
                        {
                            const { payload: { fieldId: fieldId, targetTypeName: targetTypeName } } = action;
                            onChange({
                                issueId: issueId,
                                type: (0, $fE3Ua.ChangeEventTypes).ISSUE_TYPE_CHANGED,
                                fieldId: fieldId,
                                meta: {
                                    typeName: targetTypeName
                                }
                            });
                            break;
                        }
                    case 0, $fVCj0.FIELD_UPDATED:
                        {
                            const { payload: { fieldId: fieldId, fieldValue: fieldValue } } = action;
                            issueViewFieldUpdateActions?.fieldChanged(issueId, fieldId, fieldValue);
                            break;
                        }
                    case 0, $3b6FJ.ISSUE_RELATIONSHIP_UPDATE_SUCCESS:
                        {
                            const { payload: { oldParentIdsByIssueIds: oldParentIdsByIssueIds, parentIssueId: newParentIssueId } } = action;
                            onChange({
                                issueId: issueId,
                                type: (0, $fE3Ua.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED,
                                meta: {
                                    newParentIssueId: newParentIssueId,
                                    oldParentIssueId: oldParentIdsByIssueIds[issueId] || null
                                }
                            });
                            break;
                        }
                    case 0, $49xWy.FETCH_LINKED_ISSUES_DATA_SUCCESS:
                        {
                            const links = (0, $9RIZX.getNewLinksFromAction)(issueId, action);
                            if (links.length) onChange({
                                issueId: issueId,
                                type: (0, $fE3Ua.ChangeEventTypes).ISSUE_LINKS_CREATED,
                                meta: {
                                    links: links
                                }
                            });
                            break;
                        }
                    case 0, $49xWy.DELETE_LINKED_ISSUE_SUCCESS:
                        {
                            const { meta: { issueId: linkedIssueId, direction: direction } } = action;
                            onChange({
                                issueId: issueId,
                                type: (0, $fE3Ua.ChangeEventTypes).ISSUE_LINK_DELETED,
                                meta: {
                                    linkedIssueId: linkedIssueId,
                                    /**
									 * BENTO-3476
									 * Model for server link types does not exists yet
									 * This temporary function used to convert direction into proper format
									 * Eventually all values must be replaced with transformed data
									 */ direction: (0, $2rJdp.toLinkDirection)(direction)
                                }
                            });
                            break;
                        }
                    case 0, $hHnBv.CHILD_ISSUE_ADD_SUCCESS:
                        {
                            const { issueKey: issueKey, issueLink: issueLink, issueSummary: issueSummary, issueTypeIconUrl: issueTypeIconUrl, issueTypeName: issueTypeName } = action.payload.childIssue;
                            onChange({
                                issueId: issueId,
                                type: (0, $fE3Ua.ChangeEventTypes).CHILD_ISSUE_ADDED,
                                meta: {
                                    childIssue: {
                                        id: (0, $6vrw7.toIssueId)(action.payload.childIssue.id),
                                        issueKey: issueKey,
                                        issueLink: issueLink,
                                        issueSummary: issueSummary,
                                        issueTypeIconUrl: issueTypeIconUrl || undefined,
                                        issueTypeName: issueTypeName || undefined
                                    }
                                }
                            });
                            break;
                        }
                    case 0, $hHnBv.SUBTASK_ADD_SUCCESS:
                        {
                            const { issueKey: issueKey, issueLink: issueLink, issueSummary: issueSummary, issueTypeIconUrl: issueTypeIconUrl, issueTypeName: issueTypeName } = action.payload.childIssue;
                            onChange({
                                issueId: issueId,
                                type: (0, $fE3Ua.ChangeEventTypes).SUBTASK_ADDED,
                                meta: {
                                    childIssue: {
                                        id: (0, $6vrw7.toIssueId)(action.payload.childIssue.id),
                                        issueKey: issueKey,
                                        issueLink: issueLink,
                                        issueSummary: issueSummary,
                                        issueTypeIconUrl: issueTypeIconUrl || undefined,
                                        issueTypeName: issueTypeName || undefined
                                    }
                                }
                            });
                            break;
                        }
                    case 0, $hHnBv.ISSUE_CHILDREN_ORDER_CHANGE_SUCCESS:
                        onChange({
                            issueId: issueId,
                            type: (0, $fE3Ua.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED,
                            meta: action.payload
                        });
                        break;
                    case 0, $fVCj0.FIELD_SAVE_REQUEST:
                        {
                            const { payload: { fieldId: fieldId, value: value } } = action;
                            issueViewFieldUpdateActions?.fieldChangeRequested(issueId, fieldId, value);
                            break;
                        }
                    case 0, $fVCj0.FIELD_SAVE_FAILURE:
                        {
                            const { payload: { fieldId: fieldId } } = action;
                            issueViewFieldUpdateActions?.fieldChangeFailed(issueId, fieldId);
                            break;
                        }
                    case 0, $fVCj0.FIELD_CONFIRM_NEW_FIELD:
                        {
                            const { payload: { fieldId: fieldId, fieldValue: fieldValue } } = action;
                            onChange({
                                issueId: issueId,
                                type: (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGE_REQUESTED,
                                meta: {
                                    fieldId: fieldId,
                                    fieldValue: fieldValue
                                }
                            });
                            break;
                        }
                    case 0, $6ySNE.CREATE_CONFLUENCE_PAGE_LINK_SUCCESS:
                        onChange({
                            issueId: issueId,
                            type: (0, $fE3Ua.ChangeEventTypes).CREATE_CONFLUENCE_PAGE_LINK_SUCCESS
                        });
                        break;
                    case 0, $6ySNE.DELETE_CONFLUENCE_PAGE_LINK_SUCCESS:
                        onChange({
                            issueId: issueId,
                            type: (0, $fE3Ua.ChangeEventTypes).DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
                        });
                        break;
                    case 0, $fVCj0.FIELD_CONFIRM_FAILURE_NEW_FIELD:
                        {
                            const { payload: { fieldId: fieldId } } = action;
                            onChange({
                                issueId: issueId,
                                type: (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGE_FAILED,
                                meta: {
                                    fieldId: fieldId
                                }
                            });
                            break;
                        }
                    case 0, $hHnBv.CHILD_ISSUE_FIELD_UPDATED:
                        {
                            const { payload: { childIssueId: childIssueId } } = action;
                            onChange({
                                issueId: issueId,
                                type: (0, $fE3Ua.ChangeEventTypes).CHILD_ISSUE_FIELD_UPDATED,
                                meta: {
                                    childIssueId: childIssueId
                                }
                            });
                            break;
                        }
                    default:
                        break;
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.issue-field.ops.change-notification', 'Failed to call onChange callback', error);
            }
        }).ignoreElements();

});
parcelRegister("2rJdp", function(module, exports) {

$parcel$export(module.exports, "toLinkDirection", () => $ac8750231a7314c4$export$718a473ef443949c);

var $03XEB = parcelRequire("03XEB");
const $ac8750231a7314c4$export$718a473ef443949c = (directionStr)=>{
    const direction = directionStr.toUpperCase();
    switch(direction){
        case 0, $03XEB.INWARD_LINK_DIRECTION:
            return 0, $03XEB.INWARD_LINK_DIRECTION;
        case 0, $03XEB.OUTWARD_LINK_DIRECTION:
            return 0, $03XEB.OUTWARD_LINK_DIRECTION;
        case 0, $03XEB.BOTH_LINK_DIRECTION:
            return 0, $03XEB.BOTH_LINK_DIRECTION;
        default:
            return 0, $03XEB.BOTH_LINK_DIRECTION;
    }
};

});

parcelRegister("fE3Ua", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $407ab16d43881e85$export$8db21fc94823e1cc);
const $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $407ab16d43881e85$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $407ab16d43881e85$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $407ab16d43881e85$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $407ab16d43881e85$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $407ab16d43881e85$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $407ab16d43881e85$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $407ab16d43881e85$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$export$8db21fc94823e1cc = {
    [$407ab16d43881e85$var$FIELD_CHANGE_REQUESTED]: $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED,
    [$407ab16d43881e85$var$FIELD_CHANGE_FAILED]: $407ab16d43881e85$var$FIELD_CHANGE_FAILED,
    [$407ab16d43881e85$var$FIELD_CHANGED]: $407ab16d43881e85$var$FIELD_CHANGED,
    [$407ab16d43881e85$var$ISSUE_TYPE_CHANGED]: $407ab16d43881e85$var$ISSUE_TYPE_CHANGED,
    [$407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED]: $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED,
    [$407ab16d43881e85$var$ISSUE_LINKS_CREATED]: $407ab16d43881e85$var$ISSUE_LINKS_CREATED,
    [$407ab16d43881e85$var$ISSUE_LINK_DELETED]: $407ab16d43881e85$var$ISSUE_LINK_DELETED,
    [$407ab16d43881e85$var$CHILD_ISSUE_ADDED]: $407ab16d43881e85$var$CHILD_ISSUE_ADDED,
    [$407ab16d43881e85$var$SUBTASK_ADDED]: $407ab16d43881e85$var$SUBTASK_ADDED,
    [$407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED]: $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED]: $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED,
    [$407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("9RIZX", function(module, exports) {

$parcel$export(module.exports, "getNewLinksFromAction", () => $93f9e2566cfbc3bc$export$ee4865b555bc1d4d);

var $fUTZC = parcelRequire("fUTZC");

var $6vrw7 = parcelRequire("6vrw7");
const $93f9e2566cfbc3bc$export$ee4865b555bc1d4d = (issueId, action)=>{
    const { payload: { optimisticLinks: optimisticLinks, issueLinks: issueLinks } } = action;
    const links = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(optimisticLinks, (optimisticLink)=>{
        const linkedIssue = issueLinks.linkedIssues[optimisticLink.linkedIssueKey];
        if (linkedIssue) links.push({
            linkedIssueId: (0, $6vrw7.toIssueId)(linkedIssue.id),
            direction: optimisticLink.direction
        });
    });
    return links;
};

});


parcelRegister("3H7HO", function(module, exports) {

$parcel$export(module.exports, "default", () => $38db1e4427a64bdb$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $3A3OQ = parcelRequire("3A3OQ");

var $gZSrt = parcelRequire("gZSrt");

var $2e1Cy = parcelRequire("2e1Cy");

var $fVCj0 = parcelRequire("fVCj0");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $38db1e4427a64bdb$var$sendDeleteDraftRequest = (action)=>{
    const { payload: { fieldId: fieldId } } = action;
    return (0, $3JafE.Observable).of((0, $gZSrt.deleteDraftRequest)({
        fieldId: fieldId
    }));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $38db1e4427a64bdb$var$errorHandler = (error)=>{
    (0, $3A3OQ.trackOrLogClientError)('issue.delete-draft-request', 'Could not send request to delete field draft from local storage', error);
    return (0, $3JafE.Observable).of((0, $2e1Cy.fieldDeleteDraftError)(error));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$38db1e4427a64bdb$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $fVCj0.FIELD_SAVE_SUCCESS)).mergeMap((action)=>$38db1e4427a64bdb$var$sendDeleteDraftRequest(action)).catch((error)=>$38db1e4427a64bdb$var$errorHandler(error));

});
parcelRegister("2e1Cy", function(module, exports) {

$parcel$export(module.exports, "fieldDeleteDraftError", () => $288d854327e47b43$export$c75d3fae92b7fb93);
$parcel$export(module.exports, "fieldLoadDraftError", () => $288d854327e47b43$export$3d109645284cccb2);
$parcel$export(module.exports, "fieldSaveDraftError", () => $288d854327e47b43$export$fd39bf1f70f43acc);
// FIELD_DELETE_DRAFT_FAILURE
const $288d854327e47b43$export$9b5c6bcc5c1243b8 = 'FIELD_DELETE_DRAFT_FAILURE';
const $288d854327e47b43$export$c75d3fae92b7fb93 = (error)=>({
        type: $288d854327e47b43$export$9b5c6bcc5c1243b8,
        payload: error
    });
const $288d854327e47b43$export$face6adc3299d0a = 'FIELD_LOAD_DRAFT_FAILURE';
const $288d854327e47b43$export$3d109645284cccb2 = (error)=>({
        type: $288d854327e47b43$export$face6adc3299d0a,
        payload: error
    });
const $288d854327e47b43$export$b730f97f46a824c3 = 'FIELD_SAVE_DRAFT_FAILURE';
const $288d854327e47b43$export$fd39bf1f70f43acc = (error)=>({
        type: $288d854327e47b43$export$b730f97f46a824c3,
        payload: error
    });

});


parcelRegister("i5SMN", function(module, exports) {

$parcel$export(module.exports, "default", () => $131038a835b21ae1$export$2e2bcd8739ae039);
parcelRequire("YLEHo");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $3A3OQ = parcelRequire("3A3OQ");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $gZSrt = parcelRequire("gZSrt");

var $eW7lD = parcelRequire("eW7lD");

var $6KjC3 = parcelRequire("6KjC3");

var $2e1Cy = parcelRequire("2e1Cy");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $131038a835b21ae1$var$loadFieldDraftRequests = (action, state)=>{
    const richTextFieldIds = (0, $fokFV.richTextFieldIdsSelector)(state);
    if (richTextFieldIds.indexOf(action.payload.fieldId) !== -1) {
        const loggedInAccountId = (0, $5JqpU.accountIdloggedInUserSelector)(state);
        const issueKey = (0, $5JqpU.issueKeySelector)(state);
        return richTextFieldIds.map((fieldId)=>{
            const currentFieldValue = (0, $fokFV.fieldPersistedValueSelector)(fieldId)(state);
            const draftKey = (0, $eW7lD.getDraftKey)(loggedInAccountId, issueKey, fieldId);
            return (0, $3JafE.Observable).of((0, $gZSrt.loadDraftRequest)(fieldId, draftKey, fieldId !== action.payload.fieldId ? null : (0, $6KjC3.fieldEditUpdate), currentFieldValue));
        });
    }
    return [];
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $131038a835b21ae1$var$errorHandler = (error)=>{
    (0, $3A3OQ.trackOrLogClientError)('issue.load-field-draft', 'Failed to send request to load field draft from local storage ', error);
    return (0, $3JafE.Observable).of((0, $2e1Cy.fieldLoadDraftError)(error));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$131038a835b21ae1$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $6KjC3.FIELD_EDIT_BEGIN)).mergeMap((action)=>(0, $3JafE.Observable).merge(...$131038a835b21ae1$var$loadFieldDraftRequests(action, store.getState()))).catch((error)=>$131038a835b21ae1$var$errorHandler(error));

});

parcelRegister("jRlvC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9f867eace828c43$export$2e2bcd8739ae039);
/*
 * These epics allow external sources to make modifications to fields.
 *
 * With connected-fields, fields contain within themselves information that
 * control how they behave when modified.
 *
 * FIELD_INIT_OPTIONS is dispatched by the field when it mounts to make this
 * information accessible by external requests to modify the field.
 */ 
var $bd1K7 = parcelRequire("bd1K7");

var $njPD5 = parcelRequire("njPD5");

var $7nWL9 = parcelRequire("7nWL9");
var // @ts-expect-error - TS2769 - No overload matches this call.
$b9f867eace828c43$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $njPD5.default), (0, $7nWL9.default));

});
parcelRegister("njPD5", function(module, exports) {

$parcel$export(module.exports, "default", () => $48822820039d58db$export$2e2bcd8739ae039);
parcelRequire("jnCPY");
parcelRequire("8OtG5");

var $fgPvC = parcelRequire("fgPvC");
parcelRequire("flmol");
parcelRequire("g2Yef");
parcelRequire("3X5NT");
parcelRequire("5hZYM");
parcelRequire("8v8wT");
parcelRequire("6WUHA");
parcelRequire("iects");

var $l129t = parcelRequire("l129t");

var $6KjC3 = parcelRequire("6KjC3");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $48822820039d58db$var$editRequestFromExternalSource = (action$)=>action$.ofType((0, $6KjC3.FIELD_INIT_OPTIONS), (0, $l129t.FIELD_EDIT_REQUEST_EXTERNAL)).groupBy((action)=>action.payload.fieldId).mergeMap((actionsForField$)=>{
        const editActions$ = actionsForField$.filter((action)=>action.type === (0, $l129t.FIELD_EDIT_REQUEST_EXTERNAL));
        const fieldOptions$ = actionsForField$.filter((action)=>action.type === (0, $6KjC3.FIELD_INIT_OPTIONS));
        const earlyEditAction$ = editActions$.takeUntil(fieldOptions$).takeLast(1);
        const actionsBeforeFieldVisible = (0, $fgPvC.merge)(earlyEditAction$, fieldOptions$.take(1)).pairwise();
        const actionsAfterFieldVisible = editActions$.withLatestFrom(fieldOptions$);
        return (0, $fgPvC.merge)(actionsBeforeFieldVisible, actionsAfterFieldVisible).map(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([_editAction, fieldData])=>{
            const { fieldId: fieldId, fieldOptions: fieldOptions } = fieldData.payload;
            // @ts-expect-error - TS2554 - Expected 4 arguments, but got 2.
            return (0, $6KjC3.fieldEditBegin)(fieldId, fieldOptions);
        });
    });
var $48822820039d58db$export$2e2bcd8739ae039 = $48822820039d58db$var$editRequestFromExternalSource;

});

parcelRegister("7nWL9", function(module, exports) {

$parcel$export(module.exports, "default", () => $702855ee642f42be$export$2e2bcd8739ae039);
parcelRequire("g2Yef");
parcelRequire("8OtG5");

var $0NycV = parcelRequire("0NycV");

var $l129t = parcelRequire("l129t");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $6KjC3 = parcelRequire("6KjC3");

var $fVCj0 = parcelRequire("fVCj0");

var $lO4Or = parcelRequire("lO4Or");
const $702855ee642f42be$var$transform = ({ avatarUrl: avatarUrl, displayName: displayName, id: id })=>({
        avatarUrls: {
            '48x48': avatarUrl
        },
        displayName: displayName,
        accountId: id
    });
const $702855ee642f42be$var$assignToMeFromExternalSource = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
action$, store)=>{
    const assignToMe$ = action$.ofType((0, $l129t.ASSIGN_TO_ME_EXTERNAL));
    const fieldOptions$ = action$.ofType((0, $6KjC3.FIELD_INIT_OPTIONS)).filter((action)=>action.payload.fieldId === (0, $lO4Or.ASSIGNEE_TYPE));
    return assignToMe$// @ts-expect-error - TS2769 - No overload matches this call.
    .filter(()=>{
        const state = store.getState();
        return (0, $jZDJX.loggedInUserDetailsSelector)(state) && (0, $9F6MO.canBeAssignedToIssuesPermissionsSelector)(state);
    }).withLatestFrom(fieldOptions$, (_, { payload: { fieldId: fieldId, fieldOptions: fieldOptions } })=>{
        const state = store.getState();
        const loggedInUser = (0, $jZDJX.loggedInUserDetailsSelector)(state);
        if (loggedInUser) {
            const assignee = (0, $fokFV.fieldSelector)(fieldId)(state);
            const value = assignee?.value?.accountId === loggedInUser.id ? null : $702855ee642f42be$var$transform(loggedInUser);
            const message = !value ? (0, $0NycV.REMOVE_FROM_ME_SUCCESS) : (0, $0NycV.ASSIGN_TO_ME_SUCCESS);
            // @ts-expect-error - TS2554 - Expected 6-7 arguments, but got 3.
            return (0, $fVCj0.fieldSaveRequest)((0, $lO4Or.ASSIGNEE_TYPE), value, {
                ...fieldOptions,
                onSaveSuccessFlagType: message
            });
        }
        return null;
    });
};
var $702855ee642f42be$export$2e2bcd8739ae039 = $702855ee642f42be$var$assignToMeFromExternalSource;

});


parcelRegister("f0ygf", function(module, exports) {

$parcel$export(module.exports, "default", () => $07a50137fc9a1b52$export$2e2bcd8739ae039);
parcelRequire("YLEHo");
parcelRequire("jyKN9");

var $3JafE = parcelRequire("3JafE");

var $df9H8 = parcelRequire("df9H8");

var $b1qLQ = parcelRequire("b1qLQ");

var $gA9Fk = parcelRequire("gA9Fk");
var $3A3OQ = parcelRequire("3A3OQ");

var $fYteL = parcelRequire("fYteL");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $gZSrt = parcelRequire("gZSrt");

var $eW7lD = parcelRequire("eW7lD");

var $2e1Cy = parcelRequire("2e1Cy");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $07a50137fc9a1b52$var$loadFieldDraftRequests = (action, state)=>{
    const loggedInAccountId = (0, $5JqpU.accountIdloggedInUserSelector)(state);
    const issueKey = (0, $5JqpU.issueKeySelector)(state);
    const richTextFieldIds = (0, $fokFV.richTextFieldIdsSelector)(state);
    return richTextFieldIds.map((fieldId)=>{
        const currentFieldValue = (0, $fokFV.fieldEditingValueSelector)(fieldId)(state);
        const draftKey = (0, $eW7lD.getDraftKey)(loggedInAccountId, issueKey, fieldId);
        return (0, $3JafE.Observable).of((0, $gZSrt.loadDraftRequest)(fieldId, draftKey, null, currentFieldValue));
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $07a50137fc9a1b52$var$errorHandler = (error)=>{
    (0, $3A3OQ.trackOrLogClientError)('issue.load-field-draft', 'Failed to send request to load field draft from local storage ', error);
    return (0, $3JafE.Observable).of((0, $2e1Cy.fieldLoadDraftError)(error));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07a50137fc9a1b52$export$2e2bcd8739ae039 = (action$, store)=>action$.pipe((0, $gA9Fk.ofTypeOrBatchType)((0, $fYteL.FETCH_ISSUE_SUCCESS)), (0, $b1qLQ.mergeMap)((action)=>(0, $3JafE.Observable).merge(...$07a50137fc9a1b52$var$loadFieldDraftRequests(action, store.getState()))), (0, $df9H8.catchError)((error)=>$07a50137fc9a1b52$var$errorHandler(error)));

});

parcelRegister("2LE7w", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d6ac264d33d1072$export$2e2bcd8739ae039);
parcelRequire("8OtG5");
parcelRequire("dfsI8");

var $hlJEN = parcelRequire("hlJEN");

var $fVCj0 = parcelRequire("fVCj0");
const $5d6ac264d33d1072$var$fetchViewContextOnFieldSaveSuccess = (action$)=>action$.ofType((0, $fVCj0.FIELD_SAVE_SUCCESS)).filter((action)=>action.payload.fieldOptions.canContainMediaContent && // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        action.meta.shouldFetchViewContext).mapTo((0, $hlJEN.fetchViewContextRequest)());
var $5d6ac264d33d1072$export$2e2bcd8739ae039 = $5d6ac264d33d1072$var$fetchViewContextOnFieldSaveSuccess;

});

parcelRegister("XhALM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ff40aef41df3f72$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $3A3OQ = parcelRequire("3A3OQ");

var $fokFV = parcelRequire("fokFV");

var $gZSrt = parcelRequire("gZSrt");

var $6KjC3 = parcelRequire("6KjC3");

var $2e1Cy = parcelRequire("2e1Cy");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8ff40aef41df3f72$var$processEditForSaving = (action, state)=>{
    const { payload: { fieldId: fieldId, fieldOptions: fieldOptions, value: value } } = action;
    const shouldSaveDraft = fieldOptions ? fieldOptions.shouldSaveDraft : false;
    if (!shouldSaveDraft) return (0, $3JafE.Observable).empty();
    const currentFieldValue = (0, $fokFV.fieldPendingValueSelector)(fieldId)(state);
    return (0, $3JafE.Observable).of((0, $gZSrt.saveDraftRequest)(fieldId, value, currentFieldValue));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8ff40aef41df3f72$var$errorHandler = (error)=>{
    (0, $3A3OQ.trackOrLogClientError)('issue.save-draft', 'Could not send request to save field draft to local storage', error);
    return (0, $3JafE.Observable).of((0, $2e1Cy.fieldSaveDraftError)(error));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8ff40aef41df3f72$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $6KjC3.FIELD_EDIT_UPDATE)).mergeMap((action)=>$8ff40aef41df3f72$var$processEditForSaving(action, store.getState())).catch((error)=>$8ff40aef41df3f72$var$errorHandler(error));

});

parcelRegister("5GD9a", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cf65acb4e245659$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");
parcelRequire("cpH8E");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("8OtG5");
parcelRequire("6WUHA");
parcelRequire("flmol");
parcelRequire("iects");
parcelRequire("3wBUP");

var $hTLlD = parcelRequire("hTLlD");

var $3LiTJ = parcelRequire("3LiTJ");

var $3JafE = parcelRequire("3JafE");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $bYYP0 = parcelRequire("bYYP0");

var $0NycV = parcelRequire("0NycV");

var $4faf8 = parcelRequire("4faf8");

var $f9RL0 = parcelRequire("f9RL0");

var $3b0Pa = parcelRequire("3b0Pa");

var $iW1Wx = parcelRequire("iW1Wx");

var $fYteL = parcelRequire("fYteL");

var $hlJEN = parcelRequire("hlJEN");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $gZSrt = parcelRequire("gZSrt");

var $6KjC3 = parcelRequire("6KjC3");

var $fVCj0 = parcelRequire("fVCj0");

var $lO4Or = parcelRequire("lO4Or");

var $7Vbpp = parcelRequire("7Vbpp");

var $kd5yW = parcelRequire("kd5yW");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8cf65acb4e245659$var$defaultIdRetriever = (value)=>value && value.id;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8cf65acb4e245659$var$extractValidationErrorMessage = (exception)=>{
    if (exception instanceof (0, $7byHA.ValidationError)) {
        if (exception.errors && exception.errors.length > 0) return exception.errors[0].error;
        return exception.message;
    }
    return null;
};
const $8cf65acb4e245659$var$fetchNonCriticalData = (state, issueViewNonCriticalDataActions)=>{
    const issueKey = (0, $5JqpU.issueKeySelector)(state);
    issueViewNonCriticalDataActions?.fetchNonCriticalData(issueKey);
};
const $8cf65acb4e245659$var$getRefreshedAppData = (state, dynamicIssueQueryParams, issueViewNonCriticalDataActions)=>{
    (0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') && $8cf65acb4e245659$var$fetchNonCriticalData(state, issueViewNonCriticalDataActions);
    return (0, $3b0Pa.fetchDynamicAppDataWithRetries)(state, dynamicIssueQueryParams).map((0, $fYteL.refreshIssueSuccess));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8cf65acb4e245659$var$getFieldValue = (fieldType, value)=>{
    // BENTO-2977 For ecosystem issue fields we only save id into jira.
    switch(fieldType){
        case 0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE:
            // Return null if value is nullish to clear
            return value?.id ?? null;
        case 0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE:
            // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type.
            return value.map((v)=>v.id);
        default:
            return value;
    }
};
const $8cf65acb4e245659$var$saveFieldWithSuccess = (state, // eslint-disable-next-line @typescript-eslint/no-explicit-any
fieldId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
value, // eslint-disable-next-line @typescript-eslint/no-explicit-any
fieldOptions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
saveFieldData, fieldValueActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
shouldFetchViewContext)=>{
    const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
    const issueKey = (0, $5JqpU.issueKeySelector)(state);
    const fieldMetaKey = (0, $fokFV.fieldMetaKeySelector)(fieldId)(state);
    const fieldType = (0, $fokFV.fieldTypeSelector)(fieldId)(state);
    const fieldEditSessionId = (0, $fokFV.fieldEditSessionIdSelector)(fieldId)(state);
    const field = (0, $fokFV.fieldSelector)(fieldId)(state);
    const fieldValue = (0, $4faf8.isForgeField)(field) ? value : $8cf65acb4e245659$var$getFieldValue(fieldType, value);
    fieldValueActions.setFieldValue(issueKey, fieldId, fieldValue);
    const saveField$ = (0, $3JafE.Observable).fromPromise(fieldOptions.saveField({
        baseUrl: baseUrl,
        issueKey: issueKey,
        fieldId: fieldId,
        fieldMetaKey: fieldMetaKey,
        value: fieldValue,
        saveFieldData: saveFieldData,
        ...fieldEditSessionId ? {
            fieldEditSessionId: fieldEditSessionId
        } : null
    }, state));
    return saveField$.flatMap((saveFieldResult)=>{
        // @ts-expect-error - TS2339 - Property 'updatedFieldValue' does not exist on type 'unknown'.
        const { updatedFieldValue: updatedFieldValue } = saveFieldResult || {};
        let updatedValue = fieldValue;
        if (saveFieldResult && updatedFieldValue !== undefined) {
            fieldValueActions.setFieldValue(issueKey, fieldId, updatedFieldValue);
            updatedValue = updatedFieldValue;
        }
        return [
            (0, $fVCj0.fieldSaveSuccess)(fieldId, fieldOptions, updatedValue, saveFieldResult, {
                issueKey: issueKey,
                shouldFetchViewContext: shouldFetchViewContext
            }),
            (0, $fVCj0.fieldUpdated)(fieldId, updatedValue)
        ];
    });
};
const $8cf65acb4e245659$var$saveFieldAndWaitForAppDataRefresh = (state, // eslint-disable-next-line @typescript-eslint/no-explicit-any
fieldId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
value, // eslint-disable-next-line @typescript-eslint/no-explicit-any
fieldOptions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
saveFieldData, fieldValueActions, // eslint-disable-next-line @typescript-eslint/no-explicit-any
shouldFetchViewContext, issueViewNonCriticalDataActions)=>$8cf65acb4e245659$var$saveFieldWithSuccess(state, fieldId, value, fieldOptions, saveFieldData, fieldValueActions, shouldFetchViewContext).mergeMap((saveFieldSuccessAction)=>$8cf65acb4e245659$var$getRefreshedAppData(state, undefined, issueViewNonCriticalDataActions).mergeMap((fetchIssueSuccessAction)=>// Emit the fetch success first so the reducer will update the value based on the issue fetch result.
            // @ts-expect-error - TS2769 - No overload matches this call.
            (0, $3JafE.Observable).of(fetchIssueSuccessAction, saveFieldSuccessAction)));
const $8cf65acb4e245659$var$saveRequestOnEditConfirm = (fieldValueActions)=>(action$, store)=>action$.ofType((0, $6KjC3.FIELD_EDIT_CONFIRM)).map((action)=>{
            const state = store.getState();
            const { fieldId: fieldId, fieldOptions: fieldOptions, saveFieldData: saveFieldData, analyticsEvent: analyticsEvent, analyticsAttributeIdRetriever: analyticsAttributeIdRetriever = $8cf65acb4e245659$var$defaultIdRetriever } = action.payload;
            const issueKey = (0, $5JqpU.issueKeySelector)(state);
            const valueToSave = (0, $fokFV.fieldEditingValueSelector)(fieldId)(state);
            const existingValue = fieldValueActions.getFieldValue(issueKey, fieldId);
            // cancel the edit if the value has not changed
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(valueToSave, existingValue)) {
                store.dispatch((0, $6KjC3.fieldEditCancel)(fieldId, fieldOptions));
                return (0, $gZSrt.deleteDraftRequest)({
                    fieldId: fieldId
                });
            }
            if ((0, $1ybV0.ff)('issue-update-analytics-events-on-issue-view')) {
                const fieldType = (0, $fokFV.fieldTypeSelector)(fieldId)(state);
                (0, $bYYP0.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd(fieldId, {
                    analytics: analyticsEvent,
                    attributes: {
                        fieldType: fieldType
                    }
                });
            }
            let shouldFetchViewContext = false;
            if (fieldOptions.isRichTextField && fieldOptions.canContainMediaContent) {
                const field = (0, $fokFV.fieldSelector)(fieldId)(state);
                const currentAdfValue = field && field.adfValue;
                shouldFetchViewContext = (0, $7Vbpp.hasMediaFileNodesUpdated)(currentAdfValue, valueToSave);
                if (shouldFetchViewContext) store.dispatch((0, $hlJEN.markTokenAsOutdated)());
            }
            const fieldAnalyticsData = (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))({
                updatedField: fieldId,
                oldValId: analyticsAttributeIdRetriever(existingValue),
                newValId: analyticsAttributeIdRetriever(valueToSave)
            }, (value)=>value != null);
            return (0, $fVCj0.fieldSaveRequest)(fieldId, valueToSave, fieldOptions, saveFieldData, analyticsEvent, // @ts-expect-error - TS2345 - Argument of type 'Dictionary<any>' is not assignable to parameter of type 'FieldAnalyticsPayload'.
            fieldAnalyticsData, shouldFetchViewContext);
        });
const $8cf65acb4e245659$var$saveFieldWithoutRequest = (issueViewNonCriticalDataActions)=>(action$, store)=>action$.ofType((0, $fVCj0.FIELD_UPDATE)).groupBy((action)=>action.payload.fieldId).mergeMap((fieldSaveWithoutRequest$)=>fieldSaveWithoutRequest$.switchMap((action)=>{
                const state = store.getState();
                const { fieldId: fieldId, fieldValue: fieldValue, fieldOptions: fieldOptions } = action.payload;
                /* If this is an optimistic save - do nothing and immediately dispatch a save success action.
                   If it's not optimistic - wait for an issue refresh, then dispatch the fetch issue success action. */ const saveField$ = fieldOptions.isOptimistic ? (0, $3JafE.Observable).of((0, $fVCj0.fieldUpdated)(fieldId, fieldValue)) : $8cf65acb4e245659$var$getRefreshedAppData(state, undefined, issueViewNonCriticalDataActions).mergeMap((fetchIssueSuccessAction)=>// Emit the fetch success first so the reducer will update the value based on the issue fetch result.
                    (0, $3JafE.Observable).of(fetchIssueSuccessAction, // @ts-expect-error - TS2769 - No overload matches this call.
                    (0, $fVCj0.fieldUpdated)(fieldId, fieldValue)));
                // @ts-expect-error - TS2684 - The 'this' context of type 'Observable<{ type: "REFRESH_ISSUE_SUCCESS"; payload: any; }> | Observable<FieldUpdatedReturnType<any>>' is not assignable to method's 'this' of type 'Observable<{ type: "REFRESH_ISSUE_SUCCESS"; payload: any; }>'.
                return saveField$.catch((exception)=>{
                    /* Extract the server error if we can, otherwise just use null.
                       Passing a null into the fieldSaveFailure will result on
                       isInvalid being set to true, but with no invalidMessage,
                       which components can use to determine a fallback message. */ const invalidMessage = $8cf65acb4e245659$var$extractValidationErrorMessage(exception);
                    // Revert the previous persisted value in case of error
                    return (0, $3JafE.Observable).of((0, $fVCj0.fieldSaveFailure)(fieldId, invalidMessage, exception, fieldOptions));
                });
            }));
const $8cf65acb4e245659$var$saveFieldOnRequest = (fieldValueActions, issueViewNonCriticalDataActions)=>(action$, store)=>action$.ofType((0, $fVCj0.FIELD_SAVE_REQUEST)).groupBy((action)=>action.payload.fieldId).mergeMap((fieldSaveRequest$)=>fieldSaveRequest$.switchMap((action)=>{
                const state = store.getState();
                const issueKey = (0, $5JqpU.issueKeySelector)(state);
                const { fieldId: fieldId, value: value, fieldOptions: fieldOptions, saveFieldData: saveFieldData, shouldFetchViewContext: shouldFetchViewContext } = action.payload;
                /* If this is an optimistic save - save and immediately dispatch a save success action.
                   If it's not optimistic - wait for an issue refresh, then dispatch both the save success action and the fetch issue success action. */ const saveField$ = fieldOptions.isOptimistic ? $8cf65acb4e245659$var$saveFieldWithSuccess(state, fieldId, value, fieldOptions, saveFieldData, fieldValueActions, shouldFetchViewContext) : $8cf65acb4e245659$var$saveFieldAndWaitForAppDataRefresh(state, fieldId, value, fieldOptions, saveFieldData, fieldValueActions, shouldFetchViewContext, issueViewNonCriticalDataActions);
                const prevValue = (0, $fokFV.fieldPersistedValueSelector)(fieldId)(state);
                // @ts-expect-error - TS2684 - The 'this' context of type 'Observable<{ type: "REFRESH_ISSUE_SUCCESS"; payload: any; }> | Observable<FieldSaveSuccessReturnType<unknown> | FieldUpdatedReturnType<any>>' is not assignable to method's 'this' of type 'Observable<{ type: "REFRESH_ISSUE_SUCCESS"; payload: any; }>'.
                return saveField$.catch((exception)=>{
                    /* Extract the server error if we can, otherwise just use null.
                       Passing a null into the fieldSaveFailure will result on
                       isInvalid being set to true, but with no invalidMessage,
                       which components can use to determine a fallback message. */ const invalidMessage = $8cf65acb4e245659$var$extractValidationErrorMessage(exception);
                    // Revert the previous persisted value in case of error
                    fieldValueActions.setFieldValue(issueKey, fieldId, prevValue);
                    return (0, $3JafE.Observable).of((0, $fVCj0.fieldSaveFailure)(fieldId, invalidMessage, exception, fieldOptions));
                });
            }));
const $8cf65acb4e245659$var$getDynamicIssueQueryParams = (action)=>{
    const { fieldId: fieldId, extraParams: extraParams } = action.payload;
    if (fieldId === (0, $f9RL0.STATUS)) return {
        shouldRefreshComments: extraParams && extraParams.viaDialog
    };
    return undefined;
};
/* Some modern fields are handled externally and never trigger a FIELD_SAVE_REQUEST action inside Bento,
   therefore we'll never refresh the issue data. This epic refreshes the data manually for those fields. */ const $8cf65acb4e245659$var$externallyHandledFields = [
    (0, $f9RL0.STATUS)
];
const $8cf65acb4e245659$var$externallyHandledFieldsWithTimeEstimate = [
    ...$8cf65acb4e245659$var$externallyHandledFields,
    (0, $f9RL0.TIME_ESTIMATE)
];
const $8cf65acb4e245659$var$conditionallyRefreshIssueAfterFieldSaveSuccess = (fieldValueActions, fieldsConfigActions, workflowTransitionsActions, associatedIssuesContextActions, issueContextActions, issueViewNonCriticalDataActions)=>(action$, store)=>action$.ofType((0, $fVCj0.FIELD_UPDATED), (0, $fVCj0.SWEET_STATE_FIELD_UPDATED)).filter((action)=>$8cf65acb4e245659$var$externallyHandledFieldsWithTimeEstimate.includes(action.payload.fieldId)).switchMap((action)=>(0, $kd5yW.default)(store.getState(), $8cf65acb4e245659$var$getDynamicIssueQueryParams(action), fieldValueActions, fieldsConfigActions, workflowTransitionsActions, associatedIssuesContextActions, issueContextActions, issueViewNonCriticalDataActions));
const $8cf65acb4e245659$var$conditionallyRefreshIssueForApprovalsOld = (action$, store)=>action$.ofType((0, $0NycV.SAVE_APPROVAL_ANSWER_SUCCESS), (0, $iW1Wx.ZERO_APPROVAL_REQUIRED))// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
    .switchMap(()=>$8cf65acb4e245659$var$getRefreshedAppData(store.getState()));
const $8cf65acb4e245659$var$conditionallyRefreshIssueForApprovals = (issueViewNonCriticalDataActions)=>(action$, store)=>action$.ofType((0, $0NycV.SAVE_APPROVAL_ANSWER_SUCCESS), (0, $iW1Wx.ZERO_APPROVAL_REQUIRED)).switchMap(()=>$8cf65acb4e245659$var$getRefreshedAppData(store.getState(), undefined, issueViewNonCriticalDataActions));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8cf65acb4e245659$export$2e2bcd8739ae039 = (fieldValueActions, fieldsConfigActions, workflowTransitionsActions, associatedIssuesContextActions, issueContextActions, issueViewNonCriticalDataActions)=>(0, $bd1K7.combineEpics)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $8cf65acb4e245659$var$saveRequestOnEditConfirm(fieldValueActions), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $8cf65acb4e245659$var$saveFieldOnRequest(fieldValueActions, issueViewNonCriticalDataActions), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $8cf65acb4e245659$var$saveFieldWithoutRequest(issueViewNonCriticalDataActions), $8cf65acb4e245659$var$conditionallyRefreshIssueAfterFieldSaveSuccess(fieldValueActions, fieldsConfigActions, workflowTransitionsActions, associatedIssuesContextActions, issueContextActions, issueViewNonCriticalDataActions), (0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? $8cf65acb4e245659$var$conditionallyRefreshIssueForApprovals(issueViewNonCriticalDataActions) : $8cf65acb4e245659$var$conditionallyRefreshIssueForApprovalsOld);

});
parcelRegister("kd5yW", function(module, exports) {

$parcel$export(module.exports, "default", () => $23a779659a6e25ed$export$2e2bcd8739ae039);
parcelRequire("l5lul");
parcelRequire("flmol");

var $1ybV0 = parcelRequire("1ybV0");

var $47oY8 = parcelRequire("47oY8");

var $58ToG = parcelRequire("58ToG");

var $f9RL0 = parcelRequire("f9RL0");

var $3b0Pa = parcelRequire("3b0Pa");

var $fYteL = parcelRequire("fYteL");

var $5JqpU = parcelRequire("5JqpU");
const $23a779659a6e25ed$var$getRefreshedAppDataAndStoreFields = (state, dynamicIssueQueryParams, fieldValueActions, fieldsConfigActions, workflowTransitionsActions, associatedIssuesContextActions, issueContextActions, issueViewNonCriticalDataActions)=>{
    const issueKey = (0, $5JqpU.issueKeySelector)(state);
    (0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') && issueViewNonCriticalDataActions?.fetchNonCriticalData(issueKey);
    // @ts-expect-error - TS2345 - Argument of type 'DynamicIssueQueryParams | null | undefined' is not assignable to parameter of type 'DynamicIssueQueryParams | undefined'.
    return (0, $3b0Pa.fetchDynamicAppDataWithRetries)(state, dynamicIssueQueryParams).do((data)=>{
        const { childIssuesLimit: childIssuesLimit } = data;
        const { fields: fields } = data.issue;
        (0, $47oY8.storeFields)(fields, fieldValueActions, fieldsConfigActions, issueKey, data.project);
        workflowTransitionsActions.setTransitionInProgress(false);
        if (associatedIssuesContextActions) {
            const { childrenIssues: childrenIssues, subtasks: subtasks, issueLinks: issueLinks } = data;
            associatedIssuesContextActions.mergeLocalAssociatedIssuesContext((0, $58ToG.getAssociatedIssuesContext)([
                ...childrenIssues,
                ...subtasks,
                ...issueLinks?.linkedIssueMetas || []
            ]));
        }
        if (issueContextActions) issueContextActions.mergeIssueContext({
            childIssuesLimit: childIssuesLimit,
            childIssuesIssueLimitUrls: {
                [(0, $f9RL0.SUBTASKS)]: fields[0, $f9RL0.SUBTASKS]?.issueLimitUrl,
                [(0, $f9RL0.CHILDREN_ISSUES)]: fields[0, $f9RL0.CHILDREN_ISSUES]?.issueLimitUrl,
                [(0, $f9RL0.EPIC_ISSUES)]: fields[0, $f9RL0.EPIC_ISSUES]?.issueLimitUrl,
                [(0, $f9RL0.PORTFOLIO_CHILD_ISSUES)]: fields[0, $f9RL0.PORTFOLIO_CHILD_ISSUES]?.issueLimitUrl
            }
        });
        return data;
    }).map((0, $fYteL.refreshIssueSuccess));
};
var $23a779659a6e25ed$export$2e2bcd8739ae039 = $23a779659a6e25ed$var$getRefreshedAppDataAndStoreFields;

});


parcelRegister("it42o", function(module, exports) {

$parcel$export(module.exports, "default", () => $6baf598735c019e4$export$2e2bcd8739ae039);
parcelRequire("4M8ru");
parcelRequire("flmol");
parcelRequire("6WUHA");
parcelRequire("8OtG5");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("g2Yef");
parcelRequire("iects");
parcelRequire("5hZYM");
parcelRequire("b8V1i");

var $3JafE = parcelRequire("3JafE");

var $fokFV = parcelRequire("fokFV");

var $6KjC3 = parcelRequire("6KjC3");

var $fVCj0 = parcelRequire("fVCj0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6baf598735c019e4$export$2e2bcd8739ae039 = (action$, store)=>// @ts-expect-error - TS2684 - The 'this' context of type 'Observable<GroupedObservable<string, Action>>' is not assignable to method's 'this' of type 'Observable<ActionsObservable<FilteredAction>>'.
    action$.ofType((0, $6KjC3.FIELD_EDIT_BEGIN), (0, $6KjC3.FIELD_PASTE), (0, $fVCj0.FIELD_SAVE_SUCCESS)).groupBy((action)=>action.payload.fieldId).map((groupedStream$)=>{
        // @ts-expect-error - TS2741 - Property 'ofType' is missing in type 'Observable<FilteredAction>' but required in type 'ActionsObservable<any>'. | TS2315 - Type 'FieldEditBeginAction' is not generic.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newEditorSession$ = groupedStream$.filter(({ type: type })=>type === (0, $6KjC3.FIELD_EDIT_BEGIN));
        // @ts-expect-error - TS2684 - The 'this' context of type 'Observable<Observable<FilteredAction>>' is not assignable to method's 'this' of type 'Observable<ActionsObservable<TargetEditorAction>>'.
        return groupedStream$.window(newEditorSession$).map((sessionStream$)=>{
            // @ts-expect-error - TS2741 - Property 'ofType' is missing in type 'Observable<TargetEditorAction>' but required in type 'ActionsObservable<FieldSaveSuccessReturnType<unknown>>'.
            const sessionSaveSuccess$ = sessionStream$.filter(({ type: type })=>type === (0, $fVCj0.FIELD_SAVE_SUCCESS));
            // @ts-expect-error - TS2741 - Property 'ofType' is missing in type 'Observable<TargetEditorAction>' but required in type 'ActionsObservable<{ payload: { fieldId: string; fieldOptions: FieldOptions<unknown>; pastedContent: string; }; type: "FIELD_PASTE"; }>'.
            const sessionPastes$ = sessionStream$.filter(({ type: type })=>type === (0, $6KjC3.FIELD_PASTE)).takeUntil(sessionSaveSuccess$);
            // @ts-expect-error - TS2741 - Property 'ofType' is missing in type 'Observable<any[]>' but required in type 'ActionsObservable<PasteAggregation>'.
            const pasteAggregator$ = // @ts-expect-error - TS2769 - No overload matches this call.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            sessionPastes$.reduce((acc, curr)=>[
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...acc,
                    curr.payload.pastedContent
                ], []);
            // @ts-expect-error - TS2741 - Property 'ofType' is missing in type 'Observable<FieldSaveSuccessWithPastedContentReturnType<unknown> | null>' but required in type 'ActionsObservable<any>'.
            return sessionSaveSuccess$.withLatestFrom(pasteAggregator$).mergeMap(([saveSuccessAction, pastedContent])=>{
                const { fieldId: fieldId, fieldOptions: fieldOptions } = saveSuccessAction.payload;
                const value = (0, $fokFV.fieldPersistedValueSelector)(fieldId)(store.getState());
                return pastedContent.length === 0 ? (0, $3JafE.Observable).empty() : (0, $3JafE.Observable).of((0, $fVCj0.fieldSaveSuccessWithPastedContent)(fieldId, fieldOptions, value, pastedContent));
            });
        }).mergeAll();
    }).mergeAll();

});



parcelRegister("jeWxl", function(module, exports) {

$parcel$export(module.exports, "consumePrefetchedDataIfAble", () => $bf29029575d57fe8$export$ec216e076a2aa2b);

var $kd0cS = parcelRequire("kd0cS");


var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $4lk5F = parcelRequire("4lk5F");

var $jBy23 = parcelRequire("jBy23");


var $cSEXi = parcelRequire("cSEXi");

var $cqZkv = parcelRequire("cqZkv");

var $3A3OQ = parcelRequire("3A3OQ");

var $58ToG = parcelRequire("58ToG");

var $f9RL0 = parcelRequire("f9RL0");

var $8Bhia = parcelRequire("8Bhia");

var $dgVEl = parcelRequire("dgVEl");

var $2aapS = parcelRequire("2aapS");

var $6NBhC = parcelRequire("6NBhC");

var $hAAuM = parcelRequire("hAAuM");

var $fYteL = parcelRequire("fYteL");

var $20th5 = parcelRequire("20th5");

var $jsDaf = parcelRequire("jsDaf");

var $hlJEN = parcelRequire("hlJEN");

var $6vrw7 = parcelRequire("6vrw7");

var $k0dE4 = parcelRequire("k0dE4");
const $bf29029575d57fe8$var$isValidViewScreenId = (viewScreenId)=>!!viewScreenId;
const $bf29029575d57fe8$var$checkPrefetchedData = (resourceManager)=>{
    const giraResponse = resourceManager.getGiraData();
    const aggResponse = resourceManager.getAggData();
    const aggResponseErrors = resourceManager.getAggErrors();
    if (giraResponse && !giraResponse.viewIssue) return false;
    if (aggResponse) {
        const issueByKeyData = aggResponse.jira?.issueByKey;
        if (!issueByKeyData) return false;
        if (issueByKeyData.errorRetrievingData === true) return false;
    }
    if (aggResponseErrors?.length) (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.prefetch.agg', 'Something went wrong when pre-fetching data from AGG', (0, $dgVEl.makeErrorObject)(aggResponseErrors, (0, $cSEXi.AGG_ISSUE_ERROR_ANALYTICS)));
    return true;
};
const $bf29029575d57fe8$export$ec216e076a2aa2b = ({ resourceManager: resourceManager, savePreferences: savePreferences, saveProjectContext: saveProjectContext, storeFieldsWithContext: storeFieldsWithContext, storeIssueContainersLayoutData: storeIssueContainersLayoutData, storeEcosystemData: storeEcosystemData, attachmentActions: attachmentActions, permissionActions: permissionActions, jiraSettingsActions: jiraSettingsActions, store: store, issueContextActions: issueContextActions, issueKey: issueKey, associatedIssuesContextActions: associatedIssuesContextActions })=>{
    try {
        const giraResponse = resourceManager.getGiraData();
        const aggResponse = resourceManager.getAggData();
        if (giraResponse && !giraResponse.permissions) return false;
        if (!$bf29029575d57fe8$var$checkPrefetchedData(resourceManager)) return false;
        if (giraResponse && giraResponse.viewIssue && aggResponse) {
            const { readToken: readToken, uploadToken: uploadToken, userToken: userToken } = giraResponse.mediaContext || {};
            // note existence check in enclosing if
            if (readToken) {
                const viewContext = (0, $hAAuM.transformReadAttachmentsToken)(readToken);
                store.dispatch((0, $hlJEN.fetchViewContextSuccess)(viewContext));
            } else store.dispatch((0, $hlJEN.fetchViewContextRequest)());
            if (uploadToken) {
                if ('error' in uploadToken) store.dispatch((0, $20th5.fetchUploadContextFailure)(new Error(uploadToken.error)));
                else if (uploadToken.clientId != null && uploadToken.endpointUrl != null && uploadToken.targetCollection != null && uploadToken.token != null && uploadToken.tokenDurationInMins != null) {
                    const uploadContext = (0, $cqZkv.default)({
                        clientId: uploadToken.clientId,
                        endpointUrl: uploadToken.endpointUrl,
                        targetCollection: uploadToken.targetCollection,
                        token: uploadToken.token,
                        tokenDurationInMins: uploadToken.tokenDurationInMins
                    });
                    store.dispatch((0, $20th5.fetchUploadContextSuccess)(uploadContext));
                } else store.dispatch((0, $20th5.fetchUploadContextFailure)({
                    statusCode: (0, $1c3fbb431a173cc6$export$e813cd7045fcc98d)
                }));
            } else store.dispatch((0, $20th5.fetchUploadContextRequest)());
            if (userToken) {
                const userAuth = (0, $hAAuM.transformUserContext)(userToken);
                store.dispatch((0, $jsDaf.fetchUserAuthSuccess)(userAuth));
            }
            const projectKeyFromIssueKey = (0, $jBy23.extractProjectKey)(issueKey);
            const giraData = (0, $2aapS.transformData)(giraResponse); // This line will go away when all gira data has been migrated
            const aggLegacyGraphqlData = (0, $4lk5F.transformAggResponseToLegacyGraphql)(aggResponse);
            const aggLegacyGiraData = (0, $4lk5F.transformAggResponseToLegacyGira)(aggResponse, projectKeyFromIssueKey);
            if (!aggLegacyGraphqlData) return false;
            if ((0, $8Bhia.isGiraAGGConsistencyCheckEnabled)()) issueContextActions?.mergeIssueContext({
                aggResponse: (0, (/*@__PURE__*/$parcel$interopDefault($kd0cS)))(aggResponse),
                legacyGiraResponse: (0, (/*@__PURE__*/$parcel$interopDefault($kd0cS)))(giraResponse)
            });
            const combinedData = (0, $6NBhC.combineResponseData)(aggLegacyGraphqlData, aggLegacyGiraData, giraData);
            const { project: project } = combinedData;
            if (project) {
                const issueTypes = combinedData.issueTypes.map((0, $k0dE4.transformIssueType));
                saveProjectContext((0, $6vrw7.toProjectKey)(project.projectKey), {
                    ...project,
                    issueTypes: issueTypes
                });
            }
            if (issueContextActions) issueContextActions.mergeIssueContext({
                childIssuesLimit: combinedData.childIssuesLimit,
                childIssuesIssueLimitUrls: {
                    [(0, $f9RL0.SUBTASKS)]: combinedData.issue.fields[0, $f9RL0.SUBTASKS]?.issueLimitUrl,
                    [(0, $f9RL0.CHILDREN_ISSUES)]: combinedData.issue.fields[0, $f9RL0.CHILDREN_ISSUES]?.issueLimitUrl,
                    [(0, $f9RL0.EPIC_ISSUES)]: combinedData.issue.fields[0, $f9RL0.EPIC_ISSUES]?.issueLimitUrl,
                    [(0, $f9RL0.PORTFOLIO_CHILD_ISSUES)]: combinedData.issue.fields[0, $f9RL0.PORTFOLIO_CHILD_ISSUES]?.issueLimitUrl
                }
            });
            storeFieldsWithContext(combinedData.issue.fields, project);
            storeIssueContainersLayoutData(combinedData.containersByType);
            savePreferences(combinedData.myPreferences);
            // @ts-expect-error - TS2345 - Argument of type 'Partial<EcosystemExtensions>' is not assignable to parameter of type 'State'.
            storeEcosystemData(combinedData.ecosystem, issueKey);
            store.dispatch((0, $fYteL.fetchIssueSuccess)(combinedData));
            combinedData.attachments && attachmentActions.setVisibleAttachments(issueKey, combinedData.attachments.nodes);
            combinedData.attachments && attachmentActions.setTotalCount(issueKey, combinedData.attachments.totalCount);
            combinedData.attachments && typeof combinedData.attachments.deletableCount === 'number' && attachmentActions.setDeletableCount(issueKey, combinedData.attachments.deletableCount);
            combinedData.permissions && project && permissionActions.setProjectPermissions((0, $6vrw7.toProjectKey)(project.projectKey), combinedData.permissions);
            combinedData.jiraSettings && jiraSettingsActions.setJiraSettings(combinedData.jiraSettings);
            $bf29029575d57fe8$var$isValidViewScreenId(combinedData.issue.viewScreenId) && issueContextActions && issueContextActions.mergeIssueContext({
                viewScreenId: combinedData.issue.viewScreenId
            });
            if (associatedIssuesContextActions) associatedIssuesContextActions.mergeLocalAssociatedIssuesContext((0, $58ToG.getAssociatedIssuesContext)([
                ...combinedData.childrenIssues,
                ...combinedData.subtasks,
                ...combinedData.issueLinks?.linkedIssueMetas || []
            ]));
            if (issueContextActions) issueContextActions.mergeIssueContext({
                isArchived: combinedData.isArchived
            });
            if ((0, $1ybV0.ff)('issue-view-classification-level-editability_88zal') && issueContextActions) {
                const dataClassifcationFieldValue = combinedData.issue.fields[0, $f9RL0.DATA_CLASSIFICATION_FIELD]?.value || {};
                const isClassifyEditEnabled = !!dataClassifcationFieldValue?.fieldConfig?.isEditable;
                issueContextActions.mergeIssueContext({
                    isClassifyEditEnabled: isClassifyEditEnabled
                });
            }
            // This is safe to be switched on even without checking `useIsRelayEnabled` because:
            // populating the issue-id in context from route-resource data at this point is expected regardless of relay's state
            if (issueContextActions && combinedData.issue.id) issueContextActions.mergeIssueContext({
                issueId: (0, $6vrw7.toIssueId)(String(combinedData.issue.id))
            });
            return true;
        }
        return false;
    } catch (error) {
        if (error instanceof Error || error instanceof TypeError) {
            const logMessage = 'Failed to fetch from issue prefetched data.';
            (0, $3A3OQ.trackOrLogClientError)('issue.fetch.consume-prefetched-data', logMessage, error);
            store.dispatch((0, $fYteL.fetchIssueFailure)({
                error: (0, $12cc22d0c60f7bfc$export$f10b32dfda12e96e),
                statusCode: null,
                errorMessage: `${logMessage} ${error.message}`
            }));
        }
        return false;
    }
};

});
parcelRegister("k0dE4", function(module, exports) {

$parcel$export(module.exports, "transformIssueType", () => $7f1cc061e0d52d21$export$96520244689f81c1);
const $7f1cc061e0d52d21$export$96520244689f81c1 = (issueType)=>({
        id: Number(issueType.id),
        name: issueType.name,
        subtask: issueType.subtask,
        iconUrl: issueType.iconUrl
    });

});




parcelRegister("htnxe", function(module, exports) {

$parcel$export(module.exports, "IssueViewCriticalQueryPreloader", () => $e316ffe333782900$export$98ae7d52868164fd);
$parcel$export(module.exports, "IssueViewRouteResourceConsumer", () => $e316ffe333782900$export$1676a62e16fd3dee);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $7EhAs = parcelRequire("7EhAs");

var $jBy23 = parcelRequire("jBy23");
var $2mP8r = parcelRequire("2mP8r");
var $9CSL7 = parcelRequire("9CSL7");
var $lT4yi = parcelRequire("lT4yi");


var $4aNa2 = parcelRequire("4aNa2");

var $7PTrm = parcelRequire("7PTrm");

var $ln3W8 = parcelRequire("ln3W8");

var $dWLk9 = parcelRequire("dWLk9");

var $5udmX = parcelRequire("5udmX");

var $9OxOE = parcelRequire("9OxOE");

var $6xHVX = parcelRequire("6xHVX");
const $e316ffe333782900$var$extractFirstErrorFromRelayError = (error)=>{
    if (!('source' in error)) return null;
    const errorSource = error.source;
    const errors = typeof errorSource === 'object' && errorSource != null && 'errors' in errorSource && errorSource.errors;
    const firstError = Array.isArray(errors) ? errors[0] : null;
    const statusCode = firstError?.extensions?.statusCode;
    const message = firstError?.message;
    return statusCode ? {
        statusCode: statusCode,
        message: message
    } : null;
};
/**
 * Handler for errors caught when using a Relay hook
 * @throws original error with an added traceId
 * @param err the caught error
 */ const $e316ffe333782900$var$updateAndRethrowRelayQueryError = (err)=>{
    if (!(err instanceof Error)) return;
    const issueAggQueryTraceIds = (0, $5udmX.getTraceIds)((0, $9CSL7.ISSUE_AGG_OPERATION_NAME));
    const lastTraceIdIndex = issueAggQueryTraceIds.length - 1;
    const traceId = issueAggQueryTraceIds[lastTraceIdIndex];
    const error = $e316ffe333782900$var$extractFirstErrorFromRelayError(err);
    if (error) throw new (0, $7PTrm.IssueViewFetchError)(new (0, $7EhAs.default)(error.statusCode, error.message), '', traceId, true);
    else throw new (0, $7PTrm.IssueViewFetchError)(err, 'RelayErrorWithoutStatusCode', traceId, true);
};
/**
 * See {@link IssueViewCriticalQueryPreloader}
 */ const $e316ffe333782900$var$IssueViewCriticalQueryPreloaderInner = ({ issueKey: issueKey, children: children })=>{
    (0, $9OxOE.blockedOnBackendEntryLog).initialiseBlockedOnBackendStateForUpdatedKey(issueKey);
    (0, $9OxOE.blockedOnBackendEntryLog).markStartBackendBlockingTimestamp((0, $848ef1328a091c81$export$a98a3196940af8fa));
    const cloudId = (0, $dWLk9.useCloudId)();
    const projectKey = (0, $jBy23.extractProjectKey)(issueKey);
    let issueAggQueryData;
    let prefetchedResourceManager;
    try {
        // This will internally kick off a relay fetch in the render phase (alongside a call to gira)
        prefetchedResourceManager = (0, $4aNa2.useLazyLoadingResourceManager)(issueKey);
        // We expect Relay to internally dedupe AGG fetches from useLazyLoadingResourceManager with this useLazyLoadQuery
        // This will then suspend on the AGG response
        issueAggQueryData = (0, $iWLL0.useLazyLoadQuery)((0, $lT4yi.default), {
            cloudId: cloudId,
            issueKey: issueKey,
            projectKey: projectKey,
            ...(0, $2mP8r.getMainIssueViewAggQueryFeatureFlagVariables)()
        }, {
            fetchPolicy: 'store-and-network'
        });
    } catch (err) {
        if ((0, $1ybV0.ff)('issue.view-add-traceids-to-issue-view-relay-errors_vm8h2')) $e316ffe333782900$var$updateAndRethrowRelayQueryError(err);
        throw err;
    }
    (0, $9OxOE.blockedOnBackendEntryLog).markEndBackendBlockingTimestamp((0, $848ef1328a091c81$export$a98a3196940af8fa));
    return children({
        issueAggQueryData: issueAggQueryData,
        prefetchedResourceManager: prefetchedResourceManager
    });
};
const $e316ffe333782900$export$98ae7d52868164fd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ln3W8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e316ffe333782900$var$IssueViewCriticalQueryPreloaderInner, props));
const $e316ffe333782900$export$1676a62e16fd3dee = ({ issueKey: issueKey, preloadedQuery: preloadedQuery, children: children })=>{
    (0, $9OxOE.blockedOnBackendEntryLog).initialiseBlockedOnBackendStateForUpdatedKey(issueKey);
    (0, $9OxOE.blockedOnBackendEntryLog).markStartBackendBlockingTimestamp((0, $848ef1328a091c81$export$a98a3196940af8fa));
    let issueAggQueryData;
    try {
        // This will trigger suspense if the data has not yet arrived.
        issueAggQueryData = (0, $iWLL0.usePreloadedQuery)((0, $lT4yi.default), preloadedQuery);
    } catch (err) {
        if ((0, $1ybV0.ff)('issue.view-add-traceids-to-issue-view-relay-errors_vm8h2')) $e316ffe333782900$var$updateAndRethrowRelayQueryError(err);
        throw err;
    }
    (0, $9OxOE.blockedOnBackendEntryLog).markEndBackendBlockingTimestamp((0, $848ef1328a091c81$export$a98a3196940af8fa));
    const prefetchedResourceManager = (0, $6xHVX.useIssueRouteResourceManager)({
        issueKey: issueKey,
        preloadedQuery: preloadedQuery
    });
    return children({
        issueAggQueryData: issueAggQueryData,
        prefetchedResourceManager: prefetchedResourceManager
    });
};

});
parcelRegister("6xHVX", function(module, exports) {

$parcel$export(module.exports, "useIssueRouteResourceManager", () => $c8f63a3131736cc4$export$2434ae900a49ace8);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $f4Jgp = parcelRequire("f4Jgp");

var $3HCkE = parcelRequire("3HCkE");

var $5kTYh = parcelRequire("5kTYh");
var $iudJZ = parcelRequire("iudJZ");
var $kSgnh = parcelRequire("kSgnh");
function $c8f63a3131736cc4$var$useForgeRouteResourceInResourceManager(resourceManager) {
    const { promise: issueForgePromise } = (0, $3HCkE.useResource)((0, $5kTYh.issueForgeDataResource));
    (0, $eUqFw.useMemo)(()=>{
        if (issueForgePromise) resourceManager.setForgePromise(issueForgePromise);
    }, [
        issueForgePromise,
        resourceManager
    ]);
}
function $c8f63a3131736cc4$var$useGiraRouteResourceInResourceManager(resourceManager) {
    const resourceManagerToUpdate = resourceManager;
    const { data: issueGiraData, promise: issueGiraDataPromise } = (0, $3HCkE.useResource)((0, $iudJZ.issueGiraDataResource));
    (0, $eUqFw.useMemo)(()=>{
        if (issueGiraDataPromise) {
            resourceManagerToUpdate.setGiraPromise(issueGiraDataPromise);
            resourceManagerToUpdate.allData.issueGiraData = issueGiraData;
        }
    }, [
        issueGiraData,
        issueGiraDataPromise,
        resourceManagerToUpdate
    ]);
}
function $c8f63a3131736cc4$var$useGiraNonCriticalRouteResourceInResourceManager(resourceManager) {
    const resourceManagerToUpdate = resourceManager;
    const { promise: issueGiraNonCriticalDataPromise } = (0, $3HCkE.useResource)((0, $kSgnh.issueGiraNonCriticalDataResource));
    (0, $eUqFw.useMemo)(()=>{
        if (issueGiraNonCriticalDataPromise) resourceManagerToUpdate.setGiraNonCriticalPromise(issueGiraNonCriticalDataPromise);
    }, [
        issueGiraNonCriticalDataPromise,
        resourceManagerToUpdate
    ]);
}
const $c8f63a3131736cc4$var$useRelayPreloadedQueryInResourceManager = ({ resourceManager: resourceManager, preloadedQuery: preloadedQuery })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const preloadedQueryPromise = (0, $eUqFw.useMemo)(()=>preloadedQuery?.source?.toPromise(), [
        preloadedQuery?.source
    ]);
    (0, $eUqFw.useMemo)(()=>{
        if (preloadedQueryPromise) resourceManager.setAggPromise(preloadedQueryPromise);
    }, [
        preloadedQueryPromise,
        resourceManager
    ]);
    // Make sure that we keep prefetchedResourceManager up to date with the results of any query kicked off by preloadedQuery
    // This allows AppProvider to use prefetched-data-consumption
    (0, $eUqFw.useEffect)(()=>{
        const subscription = preloadedQuery?.source?.subscribe({
            next: (response)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                resourceManager.setAggData(response);
            }
        });
        return ()=>subscription?.unsubscribe(); // Make sure to unsubscribe from stale in-progress fetches
    }, [
        resourceManager,
        preloadedQuery?.source
    ]);
};
const $c8f63a3131736cc4$export$2434ae900a49ace8 = ({ issueKey: issueKey, preloadedQuery: preloadedQuery })=>{
    const resourceManager = (0, $f4Jgp.useSelfClearingPrefetchedResourceManager)(issueKey);
    $c8f63a3131736cc4$var$useForgeRouteResourceInResourceManager(resourceManager);
    $c8f63a3131736cc4$var$useGiraRouteResourceInResourceManager(resourceManager);
    $c8f63a3131736cc4$var$useRelayPreloadedQueryInResourceManager({
        resourceManager: resourceManager,
        preloadedQuery: preloadedQuery
    });
    if ((0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w')) // eslint-disable-next-line react-hooks/rules-of-hooks
    $c8f63a3131736cc4$var$useGiraNonCriticalRouteResourceInResourceManager(resourceManager);
    return resourceManager;
};

});
parcelRegister("5kTYh", function(module, exports) {

$parcel$export(module.exports, "issueForgeDataResource", () => $f710e109102bd3b2$export$e28b79684fb81535);

var $3HCkE = parcelRequire("3HCkE");

var $9PXNH = parcelRequire("9PXNH");

var $b8iE0 = parcelRequire("b8iE0");
const $f710e109102bd3b2$export$e28b79684fb81535 = (0, $3HCkE.createResource)({
    type: 'ISSUE_FORGE_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $b8iE0.default)(...args),
    isBrowserOnly: true
});

});
parcelRegister("b8iE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bacedebb064d06c$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $27Eo5 = parcelRequire("27Eo5");

var $1aPBP = parcelRequire("1aPBP");
var $9PXNH = parcelRequire("9PXNH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3bacedebb064d06c$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const issueKey = (0, $9PXNH.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const data = await (0, $27Eo5.fetchIssueForgeData)(cloudId, issueKey, activationId);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $1aPBP.createResourceError)({
            component: 'spa.view.routes.issue-view.forge.getData',
            message: 'An error was thrown while prefetching issue Forge data',
            name: 'ResourceError'
        }, error);
    }
};

});


parcelRegister("kSgnh", function(module, exports) {

$parcel$export(module.exports, "issueGiraNonCriticalDataResource", () => $d12a144daa5dfc13$export$2d81f7bddf10f49e);

var $3HCkE = parcelRequire("3HCkE");

var $9PXNH = parcelRequire("9PXNH");

var $2skem = parcelRequire("2skem");

var $tPTRS = parcelRequire("tPTRS");
const $d12a144daa5dfc13$export$2d81f7bddf10f49e = (0, $3HCkE.createResource)((0, $2skem.withResourceEarlyData)({
    type: 'ISSUE_GIRA_NON_CRITICAL_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $tPTRS.default)(...args),
    isBrowserOnly: true
}));

});
parcelRegister("tPTRS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e93b0b54749e5eeb$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $lwu0A = parcelRequire("lwu0A");

var $1aPBP = parcelRequire("1aPBP");
var $9PXNH = parcelRequire("9PXNH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e93b0b54749e5eeb$export$2e2bcd8739ae039 = async ({ match: match }, _)=>{
    const issueKey = (0, $9PXNH.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const data = await (0, $lwu0A.fetchIssueGiraNonCriticalData)(issueKey);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $1aPBP.createResourceError)({
            component: 'spa.view.routes.issue-view.gira-non-critical.getData',
            message: 'An error was thrown while prefetching issue gira non critical data',
            name: 'ResourceError'
        }, error);
    }
};

});





parcelRegister("6Zcji", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b37890ac1e1eff9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $0cdA8 = parcelRequire("0cdA8");

var $lqalZ = parcelRequire("lqalZ");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $bNe1g = parcelRequire("bNe1g");

var $IsF0v = parcelRequire("IsF0v");

var $9Y2K4 = parcelRequire("9Y2K4");

var $6vrw7 = parcelRequire("6vrw7");
const $8b37890ac1e1eff9$export$b9e679128cfbb66a = ({ isServiceDeskAgent: isServiceDeskAgent, projectType: projectType, projectId: projectId, ...otherProps })=>{
    const { data: isItsmProject } = (0, $IsF0v.useIsItsmTemplateProject)();
    if (projectId === null || isItsmProject !== true || isServiceDeskAgent !== true) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "changeManagementTourIssue",
        packageName: "jiraServicedeskChangeManagementTourIssue",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, ({ data: data })=>// @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
        data && data.isProjectAdmin === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Y2K4.AsyncChangeManagementTourIssue), {
            projectId: (0, $6vrw7.toProjectId)(projectId.toString()),
            ...otherProps
        }) : null));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8b37890ac1e1eff9$var$mapStateToProps = (state)=>({
        fields: (0, $fokFV.fieldsSelector)(state),
        projectId: (0, $jZDJX.projectIdSelector)(state),
        projectType: (0, $jZDJX.projectTypeSelector)(state),
        isServiceDeskAgent: (0, $9F6MO.canUseServiceDeskAgentFeaturesSelector)(state)
    });
var $8b37890ac1e1eff9$export$2e2bcd8739ae039 = (0, $lqalZ.connect)($8b37890ac1e1eff9$var$mapStateToProps, {})((props)=>props.projectType !== (0, $7ZZxN.SERVICE_DESK_PROJECT) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8b37890ac1e1eff9$export$b9e679128cfbb66a, props));

});
parcelRegister("IsF0v", function(module, exports) {

$parcel$export(module.exports, "useIsItsmTemplateProject", () => $07a4c10d5645b4e2$export$7bb46948fb84f164);

var $eUqFw = parcelRequire("eUqFw");

var $3HCkE = parcelRequire("3HCkE");

var $8hg3R = parcelRequire("8hg3R");


const $07a4c10d5645b4e2$var$getDataLoader = ()=>(parcelRequire("4s5wr"));
const $07a4c10d5645b4e2$var$ONE_DAY_IN_MILLIS = 86400000;
const $07a4c10d5645b4e2$export$920308cef4e291b1 = (0, $3HCkE.createResource)({
    type: (0, $f57291778ecbd978$export$543a8644640f4092),
    getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
    getDataLoader: $07a4c10d5645b4e2$var$getDataLoader,
    maxAge: $07a4c10d5645b4e2$var$ONE_DAY_IN_MILLIS
});
const $07a4c10d5645b4e2$export$7bb46948fb84f164 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $3HCkE.useResource)($07a4c10d5645b4e2$export$920308cef4e291b1);
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if ((data === null || data === undefined) && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("8hg3R", function(module, exports) {

$parcel$export(module.exports, "getProjectKeyOrId", () => $07950346cbbaf790$export$43cde151f667c69e);
$parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", () => $07950346cbbaf790$export$b87af5b274141bd6);

var $9zYls = parcelRequire("9zYls");
const $07950346cbbaf790$export$43cde151f667c69e = (match)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, match.query);
    return projectKey || projectId || '';
};
const $07950346cbbaf790$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};

});

const $f57291778ecbd978$export$543a8644640f4092 = 'SERVICEDESK_IS_ITSM_PROJECT';

parcelRegister("4s5wr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iNHzY');
        const value = parcelRequire('hQH0C');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iNHzY").then(()=>parcelRequire('hQH0C'));
}

});


parcelRegister("9Y2K4", function(module, exports) {

$parcel$export(module.exports, "AsyncChangeManagementTourIssue", () => $33484f5159f17867$export$1ed01ce8c1ac7746);
$parcel$export(module.exports, "AsyncChangeManagementTourQueues", () => $33484f5159f17867$export$fb9c9876407ca830);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $c5Upq = parcelRequire("c5Upq");

const $33484f5159f17867$var$ChangeManagementTourIssueComponent = ()=>(parcelRequire("dNobK"));

const $33484f5159f17867$var$ChangeManagementTourQueuesComponent = ()=>(parcelRequire("dcNAR"));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $33484f5159f17867$var$ChangeManagementTourIssue = (0, $7rh0R.lazy)(()=>$33484f5159f17867$var$ChangeManagementTourIssueComponent(), {});
const $33484f5159f17867$export$1ed8a177940b97cb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "change-management-tour-issue",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33484f5159f17867$var$ChangeManagementTourIssue, props));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $33484f5159f17867$var$ChangeManagementTourQueues = (0, $7rh0R.lazy)(()=>$33484f5159f17867$var$ChangeManagementTourQueuesComponent(), {});
const $33484f5159f17867$export$2e6a672121096a76 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "change-management-tour-queues",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33484f5159f17867$var$ChangeManagementTourQueues, props));
const $33484f5159f17867$export$1ed01ce8c1ac7746 = (0, $c5Upq.withShouldRenderWithinItsmSampleProject)($33484f5159f17867$export$1ed8a177940b97cb, false);
const $33484f5159f17867$export$fb9c9876407ca830 = (0, $c5Upq.withShouldRenderWithinItsmSampleProject)($33484f5159f17867$export$2e6a672121096a76, false);

});
parcelRegister("c5Upq", function(module, exports) {

$parcel$export(module.exports, "withShouldRenderWithinItsmSampleProject", () => $287404fd76a9d51f$export$226e9fc1ef19c2cf);

var $eUqFw = parcelRequire("eUqFw");

var $gEZA0 = parcelRequire("gEZA0");
const $287404fd76a9d51f$export$226e9fc1ef19c2cf = (WrappedComponent, shouldRenderWithinItsmSampleProject)=>{
    const WithShouldRenderWithinItsmSampleProject = (props)=>{
        const { data: isItsmSampleProject } = (0, $gEZA0.useIsItsmSampleProject)();
        const shouldRender = shouldRenderWithinItsmSampleProject === isItsmSampleProject;
        // @ts-expect-error - TS2322 - Type 'Props' is not assignable to type 'IntrinsicAttributes & LibraryManagedAttributes<Component, PropsWithChildren<PropsWithoutRef<Props> & RefAttributes<any>>>'.
        return shouldRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props);
    };
    WithShouldRenderWithinItsmSampleProject.displayName = `WithShouldRenderWithinItsmSampleProject(${WrappedComponent.displayName ?? WrappedComponent.name ?? 'Component'})`;
    // @ts-expect-error - TS2322 - Type '{ (props: Props): false | JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<Props, any>'.
    return WithShouldRenderWithinItsmSampleProject;
};

});
parcelRegister("gEZA0", function(module, exports) {

$parcel$export(module.exports, "useIsItsmSampleProject", () => $d550131522ea0515$export$b8afdaba4bd6f483);

var $ldoFd = parcelRequire("ldoFd");

var $IsF0v = parcelRequire("IsF0v");

var $f7V0E = parcelRequire("f7V0E");
const $d550131522ea0515$export$b8afdaba4bd6f483 = ()=>{
    const { data: isDemoProject, loading: loadingIsDemoProject, error: errorIsDemoProject } = (0, $f7V0E.useIsDemoProject)();
    const { data: isItsmProject, loading: loadingIsItsmProject, error: errorIsItsmProject } = (0, $IsF0v.useIsItsmTemplateProject)();
    return {
        data: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isDemoProject) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isItsmProject) ? isDemoProject === true && isItsmProject === true : null,
        loading: loadingIsDemoProject || loadingIsItsmProject,
        error: errorIsDemoProject || errorIsItsmProject
    };
};

});
parcelRegister("f7V0E", function(module, exports) {

$parcel$export(module.exports, "useIsDemoProject", () => $8aa166fc00256124$export$9b4078600f2ad4d2);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $SEaoU = parcelRequire("SEaoU");

var $6vrw7 = parcelRequire("6vrw7");

var $7kN7I = parcelRequire("7kN7I");

var $au7K4 = parcelRequire("au7K4");
const $8aa166fc00256124$export$d4c72bab9d6cc13a = {};
const $8aa166fc00256124$export$bf108b10a3a0ab90 = (0, $a61MH.createStore)({
    name: 'IsDemoProject',
    initialState: $8aa166fc00256124$export$d4c72bab9d6cc13a,
    actions: (0, $7kN7I.actions)
});
const $8aa166fc00256124$var$useIsDemoProjectStore = (0, $ggKAj.createHook)($8aa166fc00256124$export$bf108b10a3a0ab90);
// @ts-expect-error - TS7031 - Binding element 'data' implicitly has an 'any' type. | TS7031 - Binding element 'loading' implicitly has an 'any' type. | TS7031 - Binding element 'error' implicitly has an 'any' type.
const $8aa166fc00256124$var$useStateMemo = ({ data: data, loading: loading, error: error })=>(0, $eUqFw.useMemo)(()=>({
            data: data,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
const $8aa166fc00256124$export$9b4078600f2ad4d2 = ()=>{
    const [{ data: contextData }] = (0, $SEaoU.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'. | TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const numProjectId = contextData && contextData.project && contextData.project.id;
    const projectId = (0, $6vrw7.toProjectId)(String(numProjectId));
    const baseUrl = (0, $6vrw7.toBaseUrl)('');
    const [state, { fetchIsDemoProject: fetchIsDemoProject }] = $8aa166fc00256124$var$useIsDemoProjectStore();
    const memoizedState = $8aa166fc00256124$var$useStateMemo({
        ...state[projectId] ?? (0, $au7K4.initialIsDemoProjectState)
    });
    const { data: data } = memoizedState;
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(numProjectId) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(data)) // @ts-expect-error - TS2349 - This expression is not callable.
        fetchIsDemoProject({
            baseUrl: baseUrl,
            projectId: projectId
        })();
    }, [
        fetchIsDemoProject,
        baseUrl,
        numProjectId,
        projectId,
        data
    ]);
    return memoizedState;
};

});
parcelRegister("7kN7I", function(module, exports) {

$parcel$export(module.exports, "actions", () => $284bc3e2d216ef40$export$e324594224ef24da);

var $eQBT8 = parcelRequire("eQBT8");
const $284bc3e2d216ef40$export$e324594224ef24da = {
    fetchIsDemoProject: $eQBT8.fetchIsDemoProject
};

});
parcelRegister("eQBT8", function(module, exports) {

$parcel$export(module.exports, "fetchIsDemoProject", () => $5aa4af5bc33ec272$export$feaee63a215b34da);

var $ldoFd = parcelRequire("ldoFd");

var $iUq1J = parcelRequire("iUq1J");

var $au7K4 = parcelRequire("au7K4");
const $5aa4af5bc33ec272$export$feaee63a215b34da = ({ baseUrl: baseUrl, projectId: projectId })=>// @ts-expect-error - TS2322 - Type '({ getState, setState }: StoreActionApi<Partial<Record<string, DataState<boolean>>>>) => () => Promise<void>' is not assignable to type 'Action<Partial<Record<string, DataState<boolean>>>, void, void | Promise<void>>'.
    ({ getState: getState, setState: setState })=>async ()=>{
            const projectState = getState()[projectId] ?? (0, $au7K4.initialIsDemoProjectState);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectState.data) || projectState.loading) return;
            setState({
                ...getState(),
                [String(projectId)]: {
                    ...projectState,
                    loading: true
                }
            });
            try {
                const isDemo = await (0, $iUq1J.isDemoProject)({
                    baseUrl: baseUrl,
                    projectId: projectId
                });
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        data: isDemo,
                        error: null,
                        loading: false
                    }
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        error: error,
                        loading: false
                    }
                });
                throw error;
            }
        };

});
parcelRegister("iUq1J", function(module, exports) {

$parcel$export(module.exports, "isDemoProject", () => $e1be306bebb9e883$export$cf7813449d38d4ac);
$parcel$export(module.exports, "getItsmSampleProject", () => $e1be306bebb9e883$export$c498e29d716efe7a);

var $lRmyA = parcelRequire("lRmyA");
const $e1be306bebb9e883$export$cf7813449d38d4ac = async ({ baseUrl: baseUrl, projectId: projectId })=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/api/3/project/${projectId}/properties/isDemo`);
        return !!response && !!response.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) /**
			 * Expected when project property is not found.
			 * Demo project has project property "isDemo = true",
			 * otherwise property does not exist
			 * and response status will be 404
			 */ return false;
        throw error;
    }
};
const $e1be306bebb9e883$export$c498e29d716efe7a = async ({ baseUrl: baseUrl })=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/servicedesk/onboarding/1/itsm/sample-project`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) return undefined;
        throw error;
    }
};

});

parcelRegister("au7K4", function(module, exports) {

$parcel$export(module.exports, "initialIsDemoProjectState", () => $099e9baa7e7daa22$export$f6365b0f25aeae62);
const $099e9baa7e7daa22$export$f6365b0f25aeae62 = {
    data: null,
    loading: false,
    error: null
};

});






parcelRegister("dNobK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('bf9ps'),
            load('kWrFZ'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('eKQOd')
        ]);
        const value = parcelRequire('dEONe');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("bf9ps"),
        load("kWrFZ"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("eKQOd")
    ]).then(()=>parcelRequire('dEONe'));
}

});

parcelRegister("dcNAR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('8K9ld')
        ]);
        const value = parcelRequire('a6Pli');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("8K9ld")
    ]).then(()=>parcelRequire('a6Pli'));
}

});



parcelRegister("cMPNN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eb2c0fa152a3228$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $0cdA8 = parcelRequire("0cdA8");

var $lqalZ = parcelRequire("lqalZ");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $bNe1g = parcelRequire("bNe1g");

var $IsF0v = parcelRequire("IsF0v");

var $2zgGr = parcelRequire("2zgGr");

var $6vrw7 = parcelRequire("6vrw7");
const $9eb2c0fa152a3228$export$f345c7b8b33c1ee8 = ({ isServiceDeskAgent: isServiceDeskAgent, projectId: projectId, projectType: projectType, ...otherProps })=>{
    const { data: isItsmProject } = (0, $IsF0v.useIsItsmTemplateProject)();
    if (projectId === null || isItsmProject !== true || isServiceDeskAgent !== true) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "incidentManagementTourIssues",
        packageName: "jiraServicedeskIncidentManagementTour",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, ({ data: data })=>// @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
        data && data.isProjectAdmin === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2zgGr.AsyncIncidentManagementTourIssue), {
            projectId: (0, $6vrw7.toProjectId)(projectId.toString()),
            ...otherProps
        }) : null));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9eb2c0fa152a3228$var$mapStateToProps = (state)=>({
        fields: (0, $fokFV.fieldsSelector)(state),
        projectId: (0, $jZDJX.projectIdSelector)(state),
        projectType: (0, $jZDJX.projectTypeSelector)(state),
        isServiceDeskAgent: (0, $9F6MO.canUseServiceDeskAgentFeaturesSelector)(state)
    });
var $9eb2c0fa152a3228$export$2e2bcd8739ae039 = (0, $lqalZ.connect)($9eb2c0fa152a3228$var$mapStateToProps, {})((props)=>props.projectType !== (0, $7ZZxN.SERVICE_DESK_PROJECT) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9eb2c0fa152a3228$export$f345c7b8b33c1ee8, props));

});
parcelRegister("2zgGr", function(module, exports) {

$parcel$export(module.exports, "AsyncIncidentManagementTourIssue", () => $0fb06167a9630899$export$2dc985b4b00b6eec);
$parcel$export(module.exports, "AsyncIncidentManagementTourQueues", () => $0fb06167a9630899$export$a33c87c292735e8b);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $c5Upq = parcelRequire("c5Upq");

const $0fb06167a9630899$var$IncidentManagementTourIssueComponent = ()=>(parcelRequire("6xBjU"));

const $0fb06167a9630899$var$IncidentManagementTourQueuesComponent = ()=>(parcelRequire("ktjKT"));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0fb06167a9630899$var$IncidentManagementTourIssueNew = (0, $7rh0R.lazy)(()=>$0fb06167a9630899$var$IncidentManagementTourIssueComponent(), {});
const $0fb06167a9630899$var$AsyncIncidentManagementTourIssueNew = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "incident-management-tour-issue",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0fb06167a9630899$var$IncidentManagementTourIssueNew, props));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0fb06167a9630899$var$IncidentManagementTourQueuesNew = (0, $7rh0R.lazy)(()=>$0fb06167a9630899$var$IncidentManagementTourQueuesComponent(), {});
const $0fb06167a9630899$var$AsyncIncidentManagementTourQueuesNew = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "incident-management-tour-queues",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0fb06167a9630899$var$IncidentManagementTourQueuesNew, props));
const $0fb06167a9630899$export$2dc985b4b00b6eec = (0, $c5Upq.withShouldRenderWithinItsmSampleProject)($0fb06167a9630899$var$AsyncIncidentManagementTourIssueNew, false);
const $0fb06167a9630899$export$a33c87c292735e8b = (0, $c5Upq.withShouldRenderWithinItsmSampleProject)($0fb06167a9630899$var$AsyncIncidentManagementTourQueuesNew, false);

});
parcelRegister("6xBjU", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('8kPnV')
        ]);
        const value = parcelRequire('hMeFY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("8kPnV")
    ]).then(()=>parcelRequire('hMeFY'));
}

});

parcelRegister("ktjKT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('bCkYG')
        ]);
        const value = parcelRequire('i4ouu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("bCkYG")
    ]).then(()=>parcelRequire('i4ouu'));
}

});



parcelRegister("1No38", function(module, exports) {

$parcel$export(module.exports, "issueViewSidePadding", () => $172b8c314939a9f5$export$c0d9129445645273);
$parcel$export(module.exports, "SingleColumnSectionWrapper", () => $172b8c314939a9f5$export$a2073590ad3377ce);
$parcel$export(module.exports, "SingleColumnSectionWrapperInner", () => $172b8c314939a9f5$export$916c0462dcc84bf9);
/* issue-app.styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");
const $172b8c314939a9f5$export$c0d9129445645273 = 4 * (0, $c9TLT.gridSize);
// DACI explaining thinking behind these calculations: https://hello.atlassian.net/wiki/spaces/JIE/pages/654624200/DACI+Have+all+issue+page+area+scrollable+while+maintaining+horizontal+centering+of+page+content
const $172b8c314939a9f5$var$getScrollContainerPaddingSide = (issueMaxWidth)=>`calc((100% - ${issueMaxWidth}px) / 2)`;
const $172b8c314939a9f5$export$7d42737db4c30bd = (propName, issueMaxWidth)=>`
        ${propName}: ${$172b8c314939a9f5$var$getScrollContainerPaddingSide(issueMaxWidth)}; /* for browsers which do not support max(); negative padding is ignored by browsers */
        ${propName}: max(${$172b8c314939a9f5$var$getScrollContainerPaddingSide(issueMaxWidth)}, 0px); /* for browsers which support max() */
        
        .msie-11 & { /* IE11 is the only browser which does not ignore negative padding */
            ${propName}: 0;
        }
    `;
const $172b8c314939a9f5$export$a2073590ad3377ce = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { issueMaxWidth: issueMaxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8gjczv": (0, $9t7rW.default)(__cmplp.issueMaxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf",
            __cmplp.issueMaxWidth !== undefined && "_19bvq81h",
            __cmplp.issueMaxWidth !== undefined && "_u5f3q81h",
            __cmplp.className
        ])
    });
});
const $172b8c314939a9f5$export$916c0462dcc84bf9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4fkly",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2u9YV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Issue", () => $9ddb4da7cc3dfe59$export$c175600e334513b4);
$parcel$export(module.exports, "IssueViewReadyTracker", () => $9ddb4da7cc3dfe59$export$ffe55621ded4cef8);
$parcel$export(module.exports, "default", () => $9ddb4da7cc3dfe59$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $2jDha = parcelRequire("2jDha");

var $6rCaY = parcelRequire("6rCaY");
var $jPfP5 = parcelRequire("jPfP5");

var $5oStv = parcelRequire("5oStv");

var $41ICj = parcelRequire("41ICj");

var $1ybV0 = parcelRequire("1ybV0");

var $8SJ75 = parcelRequire("8SJ75");

var $ap1Il = parcelRequire("ap1Il");


var $7qzlj = parcelRequire("7qzlj");

var $le3fi = parcelRequire("le3fi");

var $knDik = parcelRequire("knDik");

var $guDY0 = parcelRequire("guDY0");
var $1qDwL = parcelRequire("1qDwL");
var $jllyX = parcelRequire("jllyX");
var $8JLUS = parcelRequire("8JLUS");
var $6xmPx = parcelRequire("6xmPx");
var $lJygS = parcelRequire("lJygS");

var $Qe471 = parcelRequire("Qe471");


var $5G3JL = parcelRequire("5G3JL");
var $aMswy = parcelRequire("aMswy");

var $brT9q = parcelRequire("brT9q");

var $3PPRL = parcelRequire("3PPRL");

var $jyFd9 = parcelRequire("jyFd9");

var $2EJOy = parcelRequire("2EJOy");

var $dE4GY = parcelRequire("dE4GY");

var $chFXd = parcelRequire("chFXd");

var $l2nPa = parcelRequire("l2nPa");

var $iH6jq = parcelRequire("iH6jq");
var $cavjE = parcelRequire("cavjE");

var $kwMhr = parcelRequire("kwMhr");parcelRequire("4QRaC");
var $kwMhr = parcelRequire("kwMhr");

var $8Bhia = parcelRequire("8Bhia");

var $2Sajo = parcelRequire("2Sajo");

var $jdza9 = parcelRequire("jdza9");

var $lqalZ = parcelRequire("lqalZ");

var $fWPOH = parcelRequire("fWPOH");

var $2txAX = parcelRequire("2txAX");

var $fYteL = parcelRequire("fYteL");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $l4XSJ = parcelRequire("l4XSJ");

var $dUqHv = parcelRequire("dUqHv");

var $8QKSg = parcelRequire("8QKSg");

var $1b2Vj = parcelRequire("1b2Vj");

var $4OMUb = parcelRequire("4OMUb");

var $jqIs9 = parcelRequire("jqIs9");

var $jK1pm = parcelRequire("jK1pm");

var $3BmTe = parcelRequire("3BmTe");

var $rRCmN = parcelRequire("rRCmN");

var $iV3wA = parcelRequire("iV3wA");

var $3rnJv = parcelRequire("3rnJv");

var $csTLI = parcelRequire("csTLI");

var $cFgLp = parcelRequire("cFgLp");

var $2nMTq = parcelRequire("2nMTq");

var $dfmdn = parcelRequire("dfmdn");

var $5ZJ3z = parcelRequire("5ZJ3z");

var $kkcIQ = parcelRequire("kkcIQ");

var $dH6nC = parcelRequire("dH6nC");

var $iJSW3 = parcelRequire("iJSW3");

var $4HWIa = parcelRequire("4HWIa");

var $4v4ZA = parcelRequire("4v4ZA");
class $9ddb4da7cc3dfe59$export$c175600e334513b4 extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'Issue';
    }
    static{
        this.defaultProps = {
            projectType: null,
            onIssueViewDataLoaded: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onMount: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    componentDidMount() {
        const { onRefresh: onRefresh, onMount: onMount } = this.props;
        onMount();
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $5oStv.default).addRefreshIssueListener(onRefresh);
    }
    shouldComponentUpdate(nextProps) {
        const { error: error, isLoading: isLoading } = this.props;
        const issueStillLoading = isLoading && nextProps.isLoading;
        const errorChanged = nextProps.error !== error;
        return errorChanged || !issueStillLoading;
    }
    componentDidUpdate() {
        const { error: error } = this.props;
        if (error !== undefined && error !== null) this.hasErrored = true;
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $5oStv.default).removeRefreshIssueListener(this.props.onRefresh);
        this.props.clearRecommendation && this.props.clearRecommendation();
    }
    renderWorklogModal() {
        switch(this.props.worklogModal){
            case 0, $0577deea918816be$export$b4c759f3741816e:
                // @ts-expect-error - Property 'activityProvider' is missing in type '{ externalId: string; }' but required in type '{ key?: Key | null | undefined; analyticsContext?: Record<string, any> | undefined; activityProvider: any; externalId: string; context?: Context<ReactReduxContextValue<any, AnyAction>> | undefined; store?: Store<...> | undefined; }'.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qzlj.default), {
                    externalId: ""
                });
            case 0, $0577deea918816be$export$46c4589329d924e6:
                // @ts-expect-error - Type '{}' is not assignable to type 'IntrinsicAttributes & ({ key?: Key | null | undefined; forwardedRef?: Ref<any> | undefined; analyticsContext?: Record<string, any> | undefined; activityProvider: any; externalId: string; context?: Context<...> | undefined; store?: Store<...> | undefined; } | { ...; })'.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $knDik.default), null);
            case 0, $0577deea918816be$export$1b027f122346ba5b:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $le3fi.default), null);
            case 0, $0577deea918816be$export$1642b795d90ca875:
            default:
                return null;
        }
    }
    renderAiOptInFetchService() {
        return (0, $8Bhia.isJiraIssueViewEditorAIEnabled)() && this.props.isComplete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fWPOH.AiOptInService), null);
    }
    renderMainContent() {
        const { isCompact: isCompact, issueMaxWidth: issueMaxWidth, shouldShowCloseButton: shouldShowCloseButton, onClose: onClose, isModal: isModal } = this.props;
        const layoutStyle = (0, $kkcIQ.getLayoutStyle)(isModal, issueMaxWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dH6nC.IssueBodyContainer), {
            ref: this.setIssueBodyContainerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dH6nC.IssueBodyContainerDropzone), {
            attachmentHover: this.state.attachmentHover
        }), this.state.attachmentHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brT9q.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ZJ3z.default), {
            layoutStyle: layoutStyle,
            renderFeedback: this.props.renderFeedback,
            issueDeleteCallbacks: this.props.issueDeleteCallbacks,
            viewModeOptions: this.props.viewModeOptions,
            isStickyHeaderOffset: this.props.isStickyHeaderOffset,
            issueViewRelayFragment: this.props.issueViewRelayFragment,
            onClose: onClose,
            // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
            isCompact: isCompact,
            issueMaxWidth: issueMaxWidth,
            shouldSetInitialFocus: this.props.shouldSetInitialFocus,
            shouldShowProjectLevelBreadcrumb: this.props.shouldShowProjectLevelBreadcrumb,
            shouldShowRootProjectsBreadcrumb: this.props.shouldShowProjectLevelBreadcrumb,
            shouldShowCloseButton: shouldShowCloseButton,
            isScrollingHotkeysDisabled: this.props.isScrollingHotkeysDisabled,
            uiModificationsModules: this.props.uiModificationsModules
        }), this.renderWorklogModal(), this.renderAttachmentPickers(), this.props.isServiceDesk && this.props.isComplete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dfmdn.IncidentManagementChangeboarding), null), !(0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2EJOy.default), {
            externalId: "issue.ecosystem"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $chFXd.EcosystemRealtimeUpdatesView), null), this.props.isComplete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dE4GY.default), null), this.props.issueViewRelayFragment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJSW3.MaybePrefetchFieldSuggestions), {
            issueViewRelayFragment: this.props.issueViewRelayFragment
        }), this.props.isComplete ? // using the key prop to force component's state reset
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SJ75.default), {
            key: this.props.issueKey
        }) : null);
    }
    render() {
        /**
		 * We throw a promise here so that we can trigger the suspense boundary above that will load the
		 * issueViewSkeleton above in modal-issue-app and issue-app
		 * The Suspense boundary will then be the fallback for both the AGG query and gira.
		 * The reason we want to trigger the suspense boundary and not directly return the
		 * <IssueViewSkeleton/> here is that we want to keep the skeletons in one consistent
		 * place where they cannot be showing differently from any div's in between and will
		 * not remount causing the skeleton animation to change and cause small visual differences
		 * for customers.
		 * We are storing this promise in redux so that we can resolve it when the loading has finished.
		 */ if (this.props.doNotUseIsLoadingPromise != null) throw this.props.doNotUseIsLoadingPromise;
        const renderViewTracker = this.props.isComplete && this.props.isForgeDataComplete;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "issue-view-details"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $rRCmN.BentoMetricsWithSpaTimingInfo), {
            isLoading: this.props.isLoading,
            isPreview: this.props.isPreview,
            isComplete: this.props.isComplete,
            error: this.props.error,
            metrics: this.props.metrics,
            issueKey: this.props.issueKey
        }), renderViewTracker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPfP5.default), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $csTLI.default), {
            externalId: "issue.flags"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jdza9.default), null), this.renderMainContent(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4v4ZA.default), {
            onClose: this.props.onClose,
            onIssueDeleteSuccess: this.props.issueDeleteCallbacks?.onIssueDeleteSuccess
        }), (0, $1ybV0.ff)('compal-issue-actions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cFgLp.CommandPaletteIssueActions), {
            issueKey: this.props.issueKey
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2nMTq.CommandPaletteSubscriber), null)) : null, (0, $1ybV0.ff)('hard-limits-modal-admin_wo9xn') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ap1Il.AsyncLimitExceedContactAdminModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4HWIa.RenderCommandPaletteHeader), {
            issueKey: this.props.issueKey
        }), this.renderAiOptInFetchService()));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isIssueContainerReady: false,
            attachmentHover: false
        };
        this.setIssueBodyContainerRef = (ref)=>{
            if (ref) {
                this.issueBodyContainerRef = ref;
                this.setState({
                    isIssueContainerReady: true
                });
            }
        };
        this.setAttachmentHover = (value)=>{
            this.setState({
                attachmentHover: value
            });
        };
        this.setAttachmentHoverFalse = ()=>{
            this.setState({
                attachmentHover: false
            });
        };
        this.setAttachmentHoverTrue = ()=>{
            this.setState({
                attachmentHover: true
            });
        };
        this.hasErrored = false;
        this.renderError = (error, errorContext)=>{
            /**
    From an experience tracking perspective, permission/auth errors are
    considered *successes* (as they are *expected* error scenarios). Failure
    in this context is limited only to bugs or downtime on our end (which
    should fall into the "unknown error") case.

     We also only want to track on isComplete and ignore preview mode
    so we only wrap the error components with the experience trackers when isComplete
    */ const { isComplete: isComplete } = this.props;
            const errorObj = {
                ...errorContext
            };
            switch(error){
                case 0, $12cc22d0c60f7bfc$export$99405616af30f11f:
                    return isComplete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
                        location: "auth-error"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l2nPa.default), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l2nPa.default), null);
                case 0, $12cc22d0c60f7bfc$export$4e094d34a5cb1872:
                    return isComplete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
                        location: "not-found-or-no-permission-error"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iH6jq.PermissionErrorView), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iH6jq.PermissionErrorView), null);
                case 0, $12cc22d0c60f7bfc$export$f10b32dfda12e96e:
                case 0, $12cc22d0c60f7bfc$export$683dbe11f74cd161:
                default:
                    return isComplete && error !== (0, $12cc22d0c60f7bfc$export$683dbe11f74cd161) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
                        location: "unknown-error",
                        failureEventAttributes: errorObj
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cavjE.UnknownErrorView), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cavjE.UnknownErrorView), null);
            }
        };
        this.renderAttachmentPickers = ()=>{
            const { isServiceDesk: isServiceDesk, isComplete: isComplete, projectType: projectType } = this.props;
            if (isComplete) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Qe471.default), {
                experience: "renderAttachmentPickers",
                analyticsSource: isServiceDesk ? 'issue-view-jsd' : 'issue-view-non-jsd',
                projectType: projectType,
                isReady: this.state.isIssueContainerReady && !!this.issueBodyContainerRef
            }, isServiceDesk ? // Service desk has its own attachment pickers, which will add attachments
            // directly to a new comment editor.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lJygS.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8JLUS.default), null), // The media picker is only initialised once, so we want to wait until
            // we have the container before rendering the dropzone picker.
            this.state.isIssueContainerReady && this.issueBodyContainerRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xmPx.default), {
                container: this.issueBodyContainerRef,
                onDragEnter: this.setAttachmentHoverTrue,
                onDragLeave: this.setAttachmentHoverFalse,
                onDrop: this.setAttachmentHoverFalse
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jllyX.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $guDY0.default), null), // The media picker is only initialised once, so we want to wait until
            // we have the container before rendering the dropzone picker.
            this.state.isIssueContainerReady && this.issueBodyContainerRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1qDwL.default), {
                container: this.issueBodyContainerRef,
                onDragEnter: this.setAttachmentHoverTrue,
                onDragLeave: this.setAttachmentHoverFalse,
                onDrop: this.setAttachmentHoverFalse
            })));
            return null;
        };
    }
}
const $9ddb4da7cc3dfe59$export$ffe55621ded4cef8 = (props)=>{
    const [hadError, setHadError] = (0, $eUqFw.useState)(false);
    const { error: error, isComplete: isComplete, onIssueViewDataLoaded: onIssueViewDataLoaded, isForgeDataComplete: isForgeDataComplete } = props;
    (0, $eUqFw.useEffect)(()=>{
        if (error) setHadError(true);
    }, [
        error
    ]);
    // FIXME: reading useForgeDataComplete here causes "too early" update
    // we need to let ReduxAnalyticsData to run first
    // double check behavior after 'platform.analytics-next-use-modern-context_fqgbx' rollout
    // const [isForgeDataComplete] = useForgeDataComplete();
    const analyticsIsReady = isComplete && isForgeDataComplete;
    (0, $eUqFw.useEffect)(()=>{
        // note - for unknown reason we are not recording views that "had error"
        // probably to track only "good views"
        if (analyticsIsReady && !hadError) onIssueViewDataLoaded();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        analyticsIsReady /* explicitly ignoring hadError. Event should be sent strictly once no matter what */ 
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9ddb4da7cc3dfe59$export$c175600e334513b4, props);
};
// FIXME: JIV-17455 should be fully typed
const $9ddb4da7cc3dfe59$var$IssueViewClassComponent = (0, $5G3JL.flowWithSafeComponent)(// @ts-expect-error - Argument of type '<Props extends WithAnalyticsEventsProps, Component>(WrappedComponent: ComponentType<Props> & Component) => ForwardRefExoticComponent<PropsWithoutRef<LibraryManagedAttributes<Component, Omit<...>>> & RefAttributes<...>>' is not assignable to parameter of type 'FlowStep<ComponentType<Props> & Component, ComponentType<Matching<{ onIssueViewDataLoaded: (analyticsEvent: UIAnalyticsEvent) => void; }, PropsWithoutRef<LibraryManagedAttributes<...>> & RefAttributes<...>>>>'.
(0, $2jDha.default)({
    onIssueViewDataLoaded: {
        action: 'loaded'
    }
}), (0, $lqalZ.connect)(null, (dispatch, ownProps)=>({
        onIssueViewDataLoaded: (analyticsEvent)=>{
            const ratio = (0, $kkcIQ.getSidebarRatio)((0, $kkcIQ.getLayoutStyle)(ownProps.isModal, ownProps.issueMaxWidth), ownProps.sidebarRatios);
            (0, $aMswy.trackLoadedIssueView)(analyticsEvent, ratio);
        }
    })), (0, $lqalZ.connect)((state)=>({
        isLoading: (0, $jZDJX.isLoadingSelector)(state),
        doNotUseIsLoadingPromise: (0, $jZDJX.doNotUseIsLoadingPromiseSelector)(state),
        isPreview: (0, $jZDJX.isPreviewSelector)(state),
        // note: altering isComplete has to be reflected at jira/src/packages/issue/issue-view-ecosystem/src/ecosystem-background-scripts-view.tsx:PreventUnstableRender
        isComplete: (0, $jZDJX.isCompletedLoadingSelector)(state),
        isModal: (0, $5JqpU.isModalSelector)(state),
        error: (0, $jZDJX.errorSelector)(state),
        errorMessage: (0, $jZDJX.errorMessageSelector)(state),
        issueKey: (0, $5JqpU.issueKeySelector)(state),
        isServiceDesk: (0, $5JqpU.isServiceDeskSelector)(state),
        projectType: (0, $jZDJX.projectTypeSelector)(state),
        worklogModal: (0, $dUqHv.openModalSelector)(state),
        sidebarRatios: (0, $l4XSJ.issueSidebarRatiosSelector)(state),
        projectKey: (0, $5JqpU.projectKeySelector)(state),
        isSimplifiedProject: (0, $jZDJX.isSimplifiedProjectSelector)(state),
        uiModificationsModules: (0, $8QKSg.forgeUiModificationsSelector)(state)
    }), (dispatch)=>({
        onRefresh: (event)=>{
            if (event) {
                const [_, payload] = event.detail ?? [];
                dispatch((0, $fYteL.refreshIssueRequest)({
                    ...payload
                }));
            } else dispatch((0, $fYteL.refreshIssueRequest)());
        },
        onMount: ()=>{
            dispatch((0, $2txAX.issueViewMounted)());
        }
    })), (0, $iV3wA.default)(), (0, $6rCaY.default)((state, { analyticsAttributesFactory: analyticsAttributesFactory })=>{
    const analyticsData = (0, $jqIs9.analyticsPayloadSelector)(state);
    const analyticsAttributes = analyticsAttributesFactory?.() ?? {};
    // We need this data in the issue view analytics event because
    // it will be used to decide whether to display EP onboarding
    // for users with edit security level permissions.
    const issueSecurityData = (0, $4OMUb.analyticsSelector)(state);
    const attributes = {
        ...analyticsData.attributes,
        ...analyticsAttributes,
        ...issueSecurityData,
        issueHierarchyLevel: (0, $1b2Vj.hierarchyLevelSelector)(state),
        synthetic: (0, $3rnJv.isSynthetic)()
    };
    return {
        ...analyticsData,
        attributes: attributes
    };
}), (0, $3BmTe.withAnalyticsAttributes)())((0, $jyFd9.default)($9ddb4da7cc3dfe59$export$ffe55621ded4cef8));
const $9ddb4da7cc3dfe59$var$IssueViewWithHooks = (props)=>{
    const [isForgeDataComplete] = (0, $2Sajo.useForgeDataComplete)();
    const [, actions] = (0, $41ICj.useDevOpsAppRecommendationsStore)();
    const clearRecommendationAndOptOutPanel = ()=>{
        actions.clearRecommendation();
        actions.clearOptOutPanel();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9ddb4da7cc3dfe59$var$IssueViewClassComponent, {
        ...props,
        isForgeDataComplete: isForgeDataComplete,
        clearRecommendation: (0, $3PPRL.isDevOpsAppRecommenderEnabled)() ? clearRecommendationAndOptOutPanel : null
    });
};
var $9ddb4da7cc3dfe59$export$2e2bcd8739ae039 = $9ddb4da7cc3dfe59$var$IssueViewWithHooks;

});
parcelRegister("jPfP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $87fa35216d96bc0f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $etqm0 = parcelRequire("etqm0");
// eslint-disable-next-line jira/react/no-class-components
class $87fa35216d96bc0f$var$ViewTracker extends (0, $eUqFw.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $87fa35216d96bc0f$var$ViewTrackerWithAnalytics = (0, $1ngde.default)({
    componentName: 'view-tracker'
})((0, $2jDha.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $etqm0.PAGE_EVENT_ACTION)
        }).fire()
})($87fa35216d96bc0f$var$ViewTracker));
var // without onMount={noop} it won't work, defaultProps won't help
// @ts-expect-error - TS2322 - Type '{ onMount: (...args: any[]) => void; }' is not assignable to type 'IntrinsicAttributes & Pick<Pick<WithAnalyticsEventsProps, never> & RefAttributes<any> & WithContextProps, "key" | "analyticsContext"> & RefAttributes<...>'.
// eslint-disable-next-line jira/import/no-anonymous-default-export
$87fa35216d96bc0f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($87fa35216d96bc0f$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    });

});

parcelRegister("41ICj", function(module, exports) {

$parcel$export(module.exports, "hasOptedOutFromAllRecommendations", () => $e826d0d8b7e9fb37$export$b6e6794cfccd0197);
$parcel$export(module.exports, "useDevOpsAppRecommendationsStore", () => $e826d0d8b7e9fb37$export$d7c199869a8e353c);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $aZaPn = parcelRequire("aZaPn");

var $3E0Uv = parcelRequire("3E0Uv");

var $3Daqu = parcelRequire("3Daqu");
const $e826d0d8b7e9fb37$export$d4c72bab9d6cc13a = {
    clearedRecommendation: {
        isCleared: false,
        clearedRecommendationName: null
    },
    showRecommendation: false,
    recommendationDetails: null,
    installedProviders: undefined
};
const $e826d0d8b7e9fb37$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('dev-ops-app-recommendations');
const $e826d0d8b7e9fb37$var$OPTED_OUT_APPS = 'opted-out-app-categories-from-link-paste';
const $e826d0d8b7e9fb37$var$shouldReplaceExistingRecommendation = (newLink, currentLink)=>{
    // Check the priority if there is a recommendationDetail is set
    if (currentLink) return newLink && newLink.priority < currentLink.priority;
    return true;
};
const $e826d0d8b7e9fb37$export$270fc342c0a53d63 = (link)=>({ getState: getState, setState: setState })=>{
        const newLink = (0, $3Daqu.extractLinkDetails)(link);
        const currentLink = getState().recommendationDetails;
        const isShowingRecommendation = getState().showRecommendation;
        if (newLink && !$e826d0d8b7e9fb37$var$hasOptedOut(newLink.optedOutAppIdentifiers) && !isShowingRecommendation && $e826d0d8b7e9fb37$var$shouldReplaceExistingRecommendation(newLink, currentLink)) setState({
            ...getState(),
            recommendationDetails: newLink
        });
    };
const $e826d0d8b7e9fb37$export$2e9d6912a425c9b1 = (installedProviders)=>({ getState: getState, setState: setState })=>setState({
            ...getState(),
            installedProviders: installedProviders
        });
const $e826d0d8b7e9fb37$export$bb948a8376580a87 = (showRecommendationState)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            showRecommendation: showRecommendationState
        });
    };
const $e826d0d8b7e9fb37$export$446793e87165c290 = ()=>({ setState: setState })=>{
        setState({
            showRecommendation: false,
            recommendationDetails: null
        });
    };
const $e826d0d8b7e9fb37$export$6a03e3172a0a11d4 = (appId)=>({ getState: getState, setState: setState })=>{
        (0, $3Daqu.optOut)($e826d0d8b7e9fb37$var$localStorage, $e826d0d8b7e9fb37$var$OPTED_OUT_APPS, appId);
        const recommendationName = getState().recommendationDetails?.name;
        setState({
            clearedRecommendation: {
                isCleared: true,
                clearedRecommendationName: recommendationName
            },
            showRecommendation: false,
            recommendationDetails: null
        });
    };
const $e826d0d8b7e9fb37$export$8f8e182b1e59c1a9 = ()=>({ setState: setState })=>{
        setState({
            clearedRecommendation: {
                isCleared: false,
                clearedRecommendationName: null
            },
            showRecommendation: false,
            recommendationDetails: null
        });
    };
const $e826d0d8b7e9fb37$export$c5c5e2401404290d = ()=>({ setState: setState })=>{
        (0, $3Daqu.optOutFromAll)($e826d0d8b7e9fb37$var$localStorage, $e826d0d8b7e9fb37$var$OPTED_OUT_APPS);
        setState({
            clearedRecommendation: {
                isCleared: false,
                clearedRecommendationName: null
            },
            showRecommendation: false,
            recommendationDetails: null
        });
    };
const $e826d0d8b7e9fb37$var$hasOptedOut = (optOutIdentifiers)=>(0, $3Daqu.isOptedOut)($e826d0d8b7e9fb37$var$localStorage, $e826d0d8b7e9fb37$var$OPTED_OUT_APPS, optOutIdentifiers);
const $e826d0d8b7e9fb37$export$b6e6794cfccd0197 = ()=>(0, $3Daqu.isOptedOut)($e826d0d8b7e9fb37$var$localStorage, $e826d0d8b7e9fb37$var$OPTED_OUT_APPS, [
        (0, $3E0Uv.OPTED_OUT_FROM_ALL_IDENTIFIER)
    ]);
const $e826d0d8b7e9fb37$export$e324594224ef24da = {
    setPastedLinkDetails: $e826d0d8b7e9fb37$export$270fc342c0a53d63,
    setInstalledProviders: $e826d0d8b7e9fb37$export$2e9d6912a425c9b1,
    setShowRecommendation: $e826d0d8b7e9fb37$export$bb948a8376580a87,
    clearRecommendation: $e826d0d8b7e9fb37$export$446793e87165c290,
    optOutFromRecommendation: $e826d0d8b7e9fb37$export$6a03e3172a0a11d4,
    clearOptOutPanel: $e826d0d8b7e9fb37$export$8f8e182b1e59c1a9,
    optOutFromAllRecommendations: $e826d0d8b7e9fb37$export$c5c5e2401404290d
};
const $e826d0d8b7e9fb37$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    name: 'linkPasteRecommendations',
    initialState: $e826d0d8b7e9fb37$export$d4c72bab9d6cc13a,
    actions: $e826d0d8b7e9fb37$export$e324594224ef24da
});
const $e826d0d8b7e9fb37$export$d7c199869a8e353c = (0, $ggKAj.createHook)($e826d0d8b7e9fb37$export$390f32400eaf98c9);

});
parcelRegister("3E0Uv", function(module, exports) {

$parcel$export(module.exports, "figmaProviderDetails", () => $d47c3ac1fb2cd40d$export$a73f9178e2275481);
$parcel$export(module.exports, "azureDevOpsProviderDetails", () => $d47c3ac1fb2cd40d$export$3982f7a388cf5a7a);
$parcel$export(module.exports, "gitLabProviderDetails", () => $d47c3ac1fb2cd40d$export$efd382b215b94f4d);
$parcel$export(module.exports, "snykProviderDetails", () => $d47c3ac1fb2cd40d$export$236f0d50ad6afadd);
$parcel$export(module.exports, "ALL_DOMAINS", () => $d47c3ac1fb2cd40d$export$ca1603d2318473a8);
$parcel$export(module.exports, "OPTED_OUT_FROM_ALL_IDENTIFIER", () => $d47c3ac1fb2cd40d$export$7a34ef7db6c0bd4d);
const $d47c3ac1fb2cd40d$export$a73f9178e2275481 = {
    id: 'com.figma.jira-add-on',
    priority: 1,
    domain: 'figma.com',
    name: 'Figma',
    optedOutAppIdentifiers: [
        'com.figma.jira-add-on',
        'design'
    ]
};
const $d47c3ac1fb2cd40d$export$3982f7a388cf5a7a = {
    id: 'azure-devops-for-jira',
    priority: 2,
    domain: 'dev.azure.com',
    name: 'Azure',
    optedOutAppIdentifiers: [
        'azure-devops-for-jira'
    ]
};
const $d47c3ac1fb2cd40d$export$efd382b215b94f4d = {
    id: 'gitlab-jira-connect-gitlab.com',
    priority: 3,
    domain: 'gitlab.com',
    name: 'GitLab',
    optedOutAppIdentifiers: [
        'gitlab-jira-connect-gitlab.com'
    ]
};
const $d47c3ac1fb2cd40d$export$236f0d50ad6afadd = {
    id: 'snyk.in.jira',
    priority: 4,
    domain: 'snyk.io',
    name: 'Snyk',
    optedOutAppIdentifiers: [
        'snyk.in.jira'
    ]
};
const $d47c3ac1fb2cd40d$export$ca1603d2318473a8 = [
    $d47c3ac1fb2cd40d$export$a73f9178e2275481,
    $d47c3ac1fb2cd40d$export$3982f7a388cf5a7a,
    $d47c3ac1fb2cd40d$export$efd382b215b94f4d,
    $d47c3ac1fb2cd40d$export$236f0d50ad6afadd
];
const $d47c3ac1fb2cd40d$export$7a34ef7db6c0bd4d = 'all-apps';

});

parcelRegister("3Daqu", function(module, exports) {

$parcel$export(module.exports, "extractLinkDetails", () => $9da586a2a46ab6f6$export$43d76dda9a4baf70);
$parcel$export(module.exports, "isOptedOut", () => $9da586a2a46ab6f6$export$7cfe992014b20608);
$parcel$export(module.exports, "optOut", () => $9da586a2a46ab6f6$export$7c7d338baab9289b);
$parcel$export(module.exports, "optOutFromAll", () => $9da586a2a46ab6f6$export$fa4e1eb0da1f9fad);

var $3E0Uv = parcelRequire("3E0Uv");
const $9da586a2a46ab6f6$export$43d76dda9a4baf70 = (link)=>(0, $3E0Uv.ALL_DOMAINS).find(({ domain: domain })=>link.includes(domain));
const $9da586a2a46ab6f6$export$5e4f4d274561c51a = (localStorageName, optedOutAppName)=>{
    try {
        const optedOutApps = localStorageName.get(optedOutAppName);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return JSON.parse(optedOutApps);
    } catch (e) {
        return [];
    }
};
const $9da586a2a46ab6f6$export$7cfe992014b20608 = (localStorageName, optedOutAppName, optedOutAppIdentifiers)=>{
    const optedOutApps = localStorageName.get(optedOutAppName);
    if (optedOutApps) {
        const parsedOptedOutApps = $9da586a2a46ab6f6$export$5e4f4d274561c51a(localStorageName, optedOutAppName);
        /**
		 * If `parsedOptedOutApps` is an empty array, then it indicates that there was an issue parsing the value from localStorage
		 * In such case, we are simply not gonna show the recommendation panel, so returning true here
		 */ return parsedOptedOutApps.length > 0 ? Boolean(parsedOptedOutApps.find((appId)=>optedOutAppIdentifiers.includes(appId.toLowerCase()))) : true;
    }
    return false;
};
const $9da586a2a46ab6f6$export$7c7d338baab9289b = (localStorageName, optedOutAppName, appId)=>{
    const optedOutApps = localStorageName.get(optedOutAppName);
    let updatedApps = [];
    if (optedOutApps) {
        const parsedOptedOutApps = $9da586a2a46ab6f6$export$5e4f4d274561c51a(localStorageName, optedOutAppName);
        updatedApps = [
            ...parsedOptedOutApps,
            appId.toLowerCase()
        ];
    } else updatedApps = [
        appId.toLowerCase()
    ];
    localStorageName.set(optedOutAppName, JSON.stringify(updatedApps));
};
const $9da586a2a46ab6f6$export$fa4e1eb0da1f9fad = (localStorageName, optedOutAppName)=>localStorageName.set(optedOutAppName, JSON.stringify([
        (0, $3E0Uv.OPTED_OUT_FROM_ALL_IDENTIFIER)
    ]));

});


parcelRegister("8SJ75", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa56112c41d02fa3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $fa56112c41d02fa3$var$LazyFieldDescriptionService = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("ecv17")), {
    ssr: false,
    moduleId: "./src/packages/issue/fields/field-description/src/ui/services/main.tsx"
});
const $fa56112c41d02fa3$var$AsyncFieldDescriptionService = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "jira-issue-field-description",
        packageName: "jiraIssueFieldDescription"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-field-description-service",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa56112c41d02fa3$var$LazyFieldDescriptionService, null)));
var $fa56112c41d02fa3$export$2e2bcd8739ae039 = $fa56112c41d02fa3$var$AsyncFieldDescriptionService;

});
parcelRegister("ecv17", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hm0yr');
        const value = parcelRequire('128JL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hm0yr").then(()=>parcelRequire('128JL'));
}

});


parcelRegister("ap1Il", function(module, exports) {

$parcel$export(module.exports, "AsyncLimitExceedContactAdminModal", () => $3a52a0f15f051c9e$export$ea4e3c377e532419);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $guiFP = parcelRequire("guiFP");

var $ggm5u = parcelRequire("ggm5u");

const $3a52a0f15f051c9e$var$AsyncLimitExceed = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("9qDWX")), {
    moduleId: "./src/packages/issue/hard-limit-exceed-modal/src/ui/index.tsx"
});
const $3a52a0f15f051c9e$export$ea4e3c377e532419 = ()=>{
    const wasEverOpen = (0, $eUqFw.useRef)(false);
    const [{ isModalOpen: isModalOpen }] = (0, $ggm5u.useHardLimitsContactAdminModal)();
    wasEverOpen.current = wasEverOpen.current || isModalOpen;
    const onError = (location, error)=>{
        const errorPayload = {
            error: error,
            meta: {
                id: 'limitExceedAdminModalError',
                packageName: 'jiraIssueView',
                teamName: 'bento'
            },
            sendToPrivacyUnsafeSplunk: true
        };
        return (0, $guiFP.default)(errorPayload);
    };
    // Make sure we lazy load the modal only if it was ever open
    if (!wasEverOpen.current) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "hard-limit-exceed-modal",
        packageName: "jiraHardLimitExceedModal",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3a52a0f15f051c9e$var$AsyncLimitExceed, null)));
};

});
parcelRegister("ggm5u", function(module, exports) {

$parcel$export(module.exports, "Store", () => $0818f297f463df67$export$390f32400eaf98c9);
$parcel$export(module.exports, "useHardLimitsContactAdminModal", () => $0818f297f463df67$export$da0f40e943b3c363);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $0818f297f463df67$var$actions = {
    openModal: ()=>({ setState: setState })=>{
            setState({
                isModalOpen: true
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                isModalOpen: false
            });
        },
    setFieldType: (fieldType)=>({ setState: setState })=>{
            setState({
                fieldType: fieldType
            });
        }
};
const $0818f297f463df67$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    initialState: {
        isModalOpen: false,
        fieldType: undefined
    },
    actions: $0818f297f463df67$var$actions,
    name: 'hard-limit-exceed-modal-store'
});
const $0818f297f463df67$export$da0f40e943b3c363 = (0, $ggKAj.createHook)($0818f297f463df67$export$390f32400eaf98c9);

});

parcelRegister("9qDWX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lOq1H');
        const value = parcelRequire('cwa6R');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lOq1H").then(()=>parcelRequire('cwa6R'));
}

});


parcelRegister("7qzlj", function(module, exports) {

$parcel$export(module.exports, "default", () => $36afaa13041bfd42$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $df4Sl = parcelRequire("df4Sl");

var $hFmdR = parcelRequire("hFmdR");
var $8un0w = parcelRequire("8un0w");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lqalZ = parcelRequire("lqalZ");

var $cp79T = parcelRequire("cp79T");

var $9Y7ra = parcelRequire("9Y7ra");

var $jZDJX = parcelRequire("jZDJX");

var $gS8e9 = parcelRequire("gS8e9");

var $dUqHv = parcelRequire("dUqHv");

var $hIdxh = parcelRequire("hIdxh");

var $1TrR5 = parcelRequire("1TrR5");

var $67G0Q = parcelRequire("67G0Q");

var $9Y7ra = parcelRequire("9Y7ra");

var $aWQFV = parcelRequire("aWQFV");
const $36afaa13041bfd42$var$WrappedWorklogModal = (props)=>{
    const intl = (0, $5JgJ2.default)();
    const { timeTrackingValue: timeTrackingValue, rolledUpTimeTrackingValue: rolledUpTimeTrackingValue, ...viewProps } = props;
    const [isRollingUpData, { markRollingUpData: markRollingUpData, unmarkRollingUpData: unmarkRollingUpData }] = (0, $67G0Q.useWorklogRollingUpData)();
    const onToggleRollingUpData = (0, $eUqFw.useCallback)((includeChildIssues)=>{
        includeChildIssues ? markRollingUpData() : unmarkRollingUpData();
    }, [
        markRollingUpData,
        unmarkRollingUpData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aWQFV.default), {
        ...viewProps,
        intl: intl,
        timeTracking: timeTrackingValue,
        rolledUpTimeTracking: rolledUpTimeTrackingValue,
        isRollingUpData: isRollingUpData,
        onToggleRollingUpData: onToggleRollingUpData
    });
};
const $36afaa13041bfd42$var$AddModalWithAnalyticsAndIntl = (0, $8un0w.default)({
    onSubmit: 'submitAddWorklog',
    onCancel: 'cancelAddWorklog'
})((0, $hFmdR.AnalyticsSubject)('worklog')($36afaa13041bfd42$var$WrappedWorklogModal));
const $36afaa13041bfd42$var$mapStateToProps = (state)=>({
        timeTrackingConfiguration: (0, $dUqHv.timeTrackingConfigurationSelector)(state),
        rolledUpTimeTrackingValue: (0, $dUqHv.timeTrackingWithSubtasksOrChildrenRollupSelector)(state)(true),
        timeTrackingValue: (0, $dUqHv.timeTrackingSelector)(state),
        timeZone: (0, $jZDJX.loggedInUserTimeZoneSelector)(state),
        isDone: (0, $hIdxh.statusCategorySelector)(state) === (0, $8Qd0L.DONE),
        isSaving: (0, $dUqHv.modalIsSavingSelector)(state),
        mediaContext: (0, $gS8e9.mediaContextSelector)(state),
        mentionProvider: (0, $cp79T.mentionProviderSelector)(state),
        shouldDisplayRollUpDataControl: (0, $dUqHv.shouldDisplayRollUpDataControlSelector)(state),
        isClassicProject: (0, $jZDJX.isClassicProjectSelector)(state)
    });
const $36afaa13041bfd42$var$rolledUpTimeTrackingValueMemoized = ()=>(0, $df4Sl.createSelector)((state)=>(0, $dUqHv.timeTrackingWithSubtasksOrChildrenRollupSelector)(state)(true), (res)=>res);
const $36afaa13041bfd42$var$mapStateToPropsFactory = ()=>{
    const rolledUpTimeTrackingValueInstance = $36afaa13041bfd42$var$rolledUpTimeTrackingValueMemoized();
    return (state)=>({
            timeTrackingConfiguration: (0, $dUqHv.timeTrackingConfigurationSelector)(state),
            rolledUpTimeTrackingValue: rolledUpTimeTrackingValueInstance(state),
            timeTrackingValue: (0, $dUqHv.timeTrackingSelector)(state),
            timeZone: (0, $jZDJX.loggedInUserTimeZoneSelector)(state),
            isDone: (0, $hIdxh.statusCategorySelector)(state) === (0, $8Qd0L.DONE),
            isSaving: (0, $dUqHv.modalIsSavingSelector)(state),
            mediaContext: (0, $gS8e9.mediaContextSelector)(state),
            mentionProvider: (0, $cp79T.mentionProviderSelector)(state),
            shouldDisplayRollUpDataControl: (0, $dUqHv.shouldDisplayRollUpDataControlSelector)(state),
            isClassicProject: (0, $jZDJX.isClassicProjectSelector)(state)
        });
};
var $36afaa13041bfd42$export$2e2bcd8739ae039 = (0, $lqalZ.connect)(// @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 1 or more, but got 0.
(0, $1TrR5.functionWithFFRedux)($36afaa13041bfd42$var$mapStateToPropsFactory, $36afaa13041bfd42$var$mapStateToProps), (dispatch)=>({
        onSubmit: (values, analyticsEvent)=>{
            const { timeLogged: timeLogged, timeRemaining: timeRemaining } = values || {};
            if (!timeLogged && timeRemaining) dispatch((0, $9Y7ra.updateTimeRemainingRequest)(timeRemaining, analyticsEvent));
            else dispatch((0, $9Y7ra.addWorklogRequest)(values, analyticsEvent));
        },
        onCancel: ()=>{
            dispatch((0, $9Y7ra.closeModal)());
        }
    }))($36afaa13041bfd42$var$AddModalWithAnalyticsAndIntl);

});
parcelRegister("cp79T", function(module, exports) {

$parcel$export(module.exports, "mentionProviderSelector", () => $07e03376aeea08ce$export$a2676822aec5ed2e);

var $df4Sl = parcelRequire("df4Sl");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $jGxmR = parcelRequire("jGxmR");
const $07e03376aeea08ce$export$a2676822aec5ed2e = (0, $df4Sl.createSelector)((0, $5JqpU.baseUrlSelector), (0, $5JqpU.issueKeySelector), (0, $5JqpU.accountIdloggedInUserSelector), (0, $jZDJX.projectTypeSelector), (0, $5JqpU.orgIdSelector), (baseUrl, issueKey, loggedInAccountId, projectType, orgId)=>new (0, $jGxmR.default)(baseUrl, issueKey, loggedInAccountId, `${baseUrl}/jira/people/search#createTeam`, projectType, orgId));

});
parcelRegister("jGxmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ff7167ddb6a2f60$export$2e2bcd8739ae039);

var $53ciZ = parcelRequire("53ciZ");
parcelRequire("iects");
parcelRequire("6zblu");
parcelRequire("flmol");

var $aiRd8 = parcelRequire("aiRd8");

var $b2ABo = parcelRequire("b2ABo");

var $6vrw7 = parcelRequire("6vrw7");
const $8ff7167ddb6a2f60$var$ACCESS_LEVEL = 'CONTAINER';
const $8ff7167ddb6a2f60$var$USER_TYPE = 'TEAM';
const $8ff7167ddb6a2f60$var$getTeamUrl = (teamId)=>{
    if (teamId == null || teamId === '') return '';
    return `${window.location.origin}/jira/people/team/${teamId}?ref=jira$&src=issue`;
};
const $8ff7167ddb6a2f60$var$transformTeamMember = ({ accountId: accountId, name: name })=>({
        id: accountId,
        name: name
    });
const $8ff7167ddb6a2f60$export$a28710816ab6ffe6 = ({ accountId: accountId, teamId: teamId, name: name, avatarUrl: avatarUrl, members: members, memberCount: memberCount, includesYou: includesYou })=>members ? {
        id: (0, $6vrw7.toAccountId)(teamId || ''),
        name: name,
        accessLevel: $8ff7167ddb6a2f60$var$ACCESS_LEVEL,
        userType: $8ff7167ddb6a2f60$var$USER_TYPE,
        avatarUrl: avatarUrl,
        context: {
            members: members.map((member)=>$8ff7167ddb6a2f60$var$transformTeamMember(member)),
            memberCount: memberCount || 0,
            includesYou: includesYou || false,
            teamLink: $8ff7167ddb6a2f60$var$getTeamUrl(teamId)
        }
    } : {
        name: name,
        mentionName: name,
        nickname: name,
        id: (0, $6vrw7.toAccountId)(accountId || ''),
        avatarUrl: avatarUrl
    };
class $8ff7167ddb6a2f60$export$2e2bcd8739ae039 extends (0, $b2ABo.UserMentionProvider) {
    constructor(baseUrl, issueKey, loggedInAccountId, createTeamPath, projectType, orgId){
        super(baseUrl, issueKey, loggedInAccountId, projectType);
        this.mentionTypeaheadHighlightEnabled = ()=>true;
        this.mentionTypeaheadCreateTeamPath = ()=>this.createTeamPath;
        this.getQueryString = (query, contextIdentifier)=>(0, $53ciZ.stringify)({
                query: query || '',
                issueKey: this.issueKey,
                organizationId: this.orgId,
                maxResults: 20,
                ...contextIdentifier
            });
        this.getUrl = (queryString)=>`${this.baseUrl}/rest/internal/2/userteam/mention/search?${queryString}`;
        this.createTeamPath = createTeamPath;
        this.orgId = orgId || '';
    }
    search(query, context) {
        const queryString = this.getQueryString(query, context);
        const url = this.getUrl(queryString);
        this.activeSearches.add(query || '');
        return(// @ts-expect-error - TS2769 - No overload matches this call.
        (0, $aiRd8.default)(url)// @ts-expect-error - TS2571 - Object is of type 'unknown'.
        .mergeMap((users)=>users.map($8ff7167ddb6a2f60$export$a28710816ab6ffe6))// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/js/no-reduce-accumulator-spread
        .reduce((mentions, mention)=>[
                ...mentions,
                mention
            ], []).map((mentions)=>({
                query: query || '',
                mentions: mentions
            })).toPromise());
    }
}

});
parcelRegister("b2ABo", function(module, exports) {

$parcel$export(module.exports, "UserMentionProvider", () => $0368aad1e6c85086$export$5dd888a6445ed862);

var $53ciZ = parcelRequire("53ciZ");

var $5Apwp = parcelRequire("5Apwp");
class $0368aad1e6c85086$export$5dd888a6445ed862 extends (0, $5Apwp.AbstractMentionProvider) {
    constructor(baseUrl, issueKey, loggedInAccountId, projectType, createAnalyticsEvent){
        super(baseUrl, projectType, createAnalyticsEvent);
        this.getQueryString = (query, contextIdentifier)=>(0, $53ciZ.stringify)({
                query: query,
                issueKey: this.issueKey,
                maxResults: 10,
                ...contextIdentifier
            });
        this.getUrl = (queryString)=>`${this.baseUrl}/rest/internal/2/user/mention/search?${queryString}`;
        this.shouldHighlightMention = (mention)=>mention.id === this.loggedInAccountId;
        this.issueKey = issueKey;
        this.loggedInAccountId = loggedInAccountId;
    }
}

});
parcelRegister("5Apwp", function(module, exports) {

$parcel$export(module.exports, "AbstractMentionProvider", () => $dbb32da3cbeebe5d$export$1503942bd70a06a4);

var $dxIU5 = parcelRequire("dxIU5");

var $ldoFd = parcelRequire("ldoFd");

var $44HQw = parcelRequire("44HQw");

var $e91YZ = parcelRequire("e91YZ");

var $2OdyW = parcelRequire("2OdyW");

var $hiBi9 = parcelRequire("hiBi9");

var $1jQHs = parcelRequire("1jQHs");
const $dbb32da3cbeebe5d$var$MENTION_DEBOUNCE_MS = 150;
class $dbb32da3cbeebe5d$export$1503942bd70a06a4 extends (0, $44HQw.AbstractMentionResource) {
    constructor(baseUrl, projectType, createAnalyticsEvent){
        super();
        this.debouncedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((query, contextIdentifier)=>{
            const currentSearchTime = Date.now();
            // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
            return this.search(query, contextIdentifier).then((mentionResult)=>{
                // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                this.activeSearches.delete(query);
                // discard the response from previous requests
                if (currentSearchTime > this.lastSearchTime) {
                    this.lastSearchTime = currentSearchTime;
                    this._notifyListeners(mentionResult, {
                        duration: Date.now() - currentSearchTime
                    });
                }
                this._notifyAllResultsListeners(mentionResult);
            }).catch((e)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(query) && query.length > 0) this.activeSearches.delete(query);
                this._notifyErrorListeners(e);
            });
        }, $dbb32da3cbeebe5d$var$MENTION_DEBOUNCE_MS);
        this.baseUrl = baseUrl;
        this.lastSearchTime = 0;
        this.activeSearches = new Set();
        this.productName = (0, $1jQHs.subProductFromProjectType)(projectType);
        this.userRole = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)().isAdmin ? 'admin' : 'basic';
        this.onInviteItemClick = ()=>{
            (0, $hiBi9.triggerOpenDrawer)(createAnalyticsEvent ?? null, {
                inviteFlow: 'mention'
            });
        };
        this.shouldEnableInvite = true;
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    filter(query, contextIdentifier) {
        return this.debouncedFilter(query, contextIdentifier);
    }
    search(query, context) {
        const queryString = this.getQueryString(query, context);
        const url = this.getUrl(queryString);
        this.activeSearches.add(query);
        return this.fetchMentions(url).then((users)=>users.map((user)=>({
                    name: user.displayName,
                    mentionName: user.displayName,
                    nickname: user.displayName,
                    id: user.accountId,
                    avatarUrl: user.avatarUrls['48x48']
                }))).then((mentions)=>({
                query: query,
                mentions: mentions
            }));
    }
    // Allow concrete subclasses to override this method so fetch calls can be instrumented
    fetchMentions(url) {
        return (0, $2OdyW.default)(url);
    }
}

});
parcelRegister("44HQw", function(module, exports) {

$parcel$export(module.exports, "AbstractMentionResource", () => $5bd1ab4d6b90a67d$export$8576ba1ed2760927);
$parcel$export(module.exports, "isResolvingMentionProvider", () => $5bd1ab4d6b90a67d$export$ae1fce5f69858ef3);
$parcel$export(module.exports, "default", () => $5bd1ab4d6b90a67d$export$2e2bcd8739ae039);

var $16UJG = parcelRequire("16UJG");

var $hWvv0 = parcelRequire("hWvv0");

var $2In19 = parcelRequire("2In19");

var $4lC4o = parcelRequire("4lC4o");

var $dxIU5 = parcelRequire("dxIU5");
const $5bd1ab4d6b90a67d$var$MAX_QUERY_ITEMS = 100;
const $5bd1ab4d6b90a67d$var$MAX_NOTIFIED_ITEMS = 20;
const $5bd1ab4d6b90a67d$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $5bd1ab4d6b90a67d$export$4529f10aed0950d4 {
    constructor(){
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
}
class $5bd1ab4d6b90a67d$export$8576ba1ed2760927 extends $5bd1ab4d6b90a67d$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $2In19.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $5bd1ab4d6b90a67d$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $2In19.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $2In19.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $5bd1ab4d6b90a67d$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $2In19.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $2In19.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $2In19.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $2In19.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $5bd1ab4d6b90a67d$export$5a4331e3e1c43553 extends $5bd1ab4d6b90a67d$export$8576ba1ed2760927 {
    constructor(config){
        super();
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(this.filter, this.config.debounceTime);
    }
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $2In19.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    recordMentionSelection(mention, contextIdentifier) {
        return this.recordSelection(mention, contextIdentifier).then(()=>{}, (error)=>(0, $2In19.default)(`error recording mention selection: ${error}`, error));
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $hWvv0.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $5bd1ab4d6b90a67d$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
	 * Clear a context object to generate query params by removing empty
	 * strings, `undefined` and empty values.
	 *
	 * @param contextIdentifier the current context identifier
	 * @returns a safe context for query encoding
	 */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
	 * Returns the initial mention display list before a search is performed for the specified
	 * container.
	 *
	 * @param contextIdentifier
	 * @returns Promise
	 */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $16UJG.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), (0, $4lC4o.SliNames).INITIAL_STATE, (0, $4lC4o.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), (0, $4lC4o.SliNames).INITIAL_STATE, (0, $4lC4o.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $5bd1ab4d6b90a67d$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $16UJG.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), (0, $4lC4o.SliNames).SEARCH, (0, $4lC4o.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), (0, $4lC4o.SliNames).SEARCH, (0, $4lC4o.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $hWvv0.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $hWvv0.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    async recordSelection(mention, contextIdentifier) {
        const options = {
            path: 'record',
            queryParams: {
                selectedUserId: mention.id,
                ...this.getQueryParams(contextIdentifier)
            },
            requestInit: {
                method: 'POST'
            }
        };
        const sliName = (0, $hWvv0.isTeamMention)(mention) ? (0, $4lC4o.SliNames).SELECT_TEAM : (0, $4lC4o.SliNames).SELECT;
        try {
            const result = await (0, $16UJG.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), sliName, (0, $4lC4o.Actions).SUCCEEDED);
            return result;
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), sliName, (0, $4lC4o.Actions).FAILED);
            throw error;
        }
    }
}
class $5bd1ab4d6b90a67d$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $5bd1ab4d6b90a67d$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $5bd1ab4d6b90a67d$export$2e2bcd8739ae039 = $5bd1ab4d6b90a67d$export$5a4331e3e1c43553;

});
parcelRegister("16UJG", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => (parcelRequire("gdgmj")).AbstractResource);

$parcel$export(module.exports, "utils", () => $30e3ff12b332d773$export$eab97d15b1788b8d);
parcelRequire("1GW5Z");
parcelRequire("gdgmj");

var $eG8mk = parcelRequire("eG8mk");
const $30e3ff12b332d773$export$eab97d15b1788b8d = $eG8mk;

});
parcelRegister("1GW5Z", function(module, exports) {

$parcel$export(module.exports, "buildCredentials", () => $b0494a54f1853cda$export$2ac26f1ab7eda637);
const $b0494a54f1853cda$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});

parcelRegister("gdgmj", function(module, exports) {

$parcel$export(module.exports, "AbstractResource", () => $f733c180c466e71c$export$4529f10aed0950d4);
class $f733c180c466e71c$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("eG8mk", function(module, exports) {

$parcel$export(module.exports, "requestService", () => $55e0d7df395d2852$export$97bfde5a702aaeca);

var $1GW5Z = parcelRequire("1GW5Z");
const $55e0d7df395d2852$var$defaultRequestServiceOptions = {};
const $55e0d7df395d2852$var$buildUrl = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
const $55e0d7df395d2852$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $55e0d7df395d2852$var$buildHeaders = (secOptions, extraHeaders)=>{
    const headers = {};
    $55e0d7df395d2852$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $55e0d7df395d2852$var$addToHeaders(headers, secOptions.headers);
    return headers;
};
const $55e0d7df395d2852$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || $55e0d7df395d2852$var$defaultRequestServiceOptions;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = $55e0d7df395d2852$var$buildUrl(url, path, queryParams, secOptions);
    const headers = $55e0d7df395d2852$var$buildHeaders(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $1GW5Z.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    const requestOptions = {
        ...requestInit,
        headers: headers,
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $55e0d7df395d2852$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});


parcelRegister("hWvv0", function(module, exports) {

$parcel$export(module.exports, "MentionType", () => $0e3c071eb6987c64$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $0e3c071eb6987c64$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $0e3c071eb6987c64$export$8436e53e45ffe15b);
$parcel$export(module.exports, "MentionNameStatus", () => $0e3c071eb6987c64$export$b8fa67dc54502853);
$parcel$export(module.exports, "isRestricted", () => $0e3c071eb6987c64$export$dbaa15dc1820b89a);
$parcel$export(module.exports, "isSpecialMention", () => $0e3c071eb6987c64$export$37b8dcac6198c514);
$parcel$export(module.exports, "isAppMention", () => $0e3c071eb6987c64$export$eb590c844d13454c);
$parcel$export(module.exports, "isTeamMention", () => $0e3c071eb6987c64$export$803b1379348dbfd5);
$parcel$export(module.exports, "isSpecialMentionText", () => $0e3c071eb6987c64$export$d13d4f976b36a397);
$parcel$export(module.exports, "isPromise", () => $0e3c071eb6987c64$export$4369c812aac99591);
var $0e3c071eb6987c64$export$2102863a3c660c6b;
(function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
})($0e3c071eb6987c64$export$2102863a3c660c6b || ($0e3c071eb6987c64$export$2102863a3c660c6b = {}));
var $0e3c071eb6987c64$export$81124e6148ca5db0;
(function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
})($0e3c071eb6987c64$export$81124e6148ca5db0 || ($0e3c071eb6987c64$export$81124e6148ca5db0 = {}));
var $0e3c071eb6987c64$export$8436e53e45ffe15b;
(function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
})($0e3c071eb6987c64$export$8436e53e45ffe15b || ($0e3c071eb6987c64$export$8436e53e45ffe15b = {}));
var $0e3c071eb6987c64$export$b8fa67dc54502853;
(function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
})($0e3c071eb6987c64$export$b8fa67dc54502853 || ($0e3c071eb6987c64$export$b8fa67dc54502853 = {}));
function $0e3c071eb6987c64$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $0e3c071eb6987c64$export$81124e6148ca5db0[0];
}
function $0e3c071eb6987c64$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $0e3c071eb6987c64$export$8436e53e45ffe15b[1];
}
function $0e3c071eb6987c64$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $0e3c071eb6987c64$export$8436e53e45ffe15b[2];
}
function $0e3c071eb6987c64$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $0e3c071eb6987c64$export$8436e53e45ffe15b[3];
}
function $0e3c071eb6987c64$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $0e3c071eb6987c64$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("2In19", function(module, exports) {

$parcel$export(module.exports, "default", () => $6aafc073576331d2$export$2e2bcd8739ae039);
let $6aafc073576331d2$var$debugEnabled = false;
let $6aafc073576331d2$var$stacktracesEnabled = false;
function $6aafc073576331d2$export$748ada60eaf985cc(enable) {
    $6aafc073576331d2$var$debugEnabled = enable;
}
function $6aafc073576331d2$export$4f7017086af31c25(enable) {
    $6aafc073576331d2$var$stacktracesEnabled = enable;
}
function $6aafc073576331d2$export$2a858f450a2f66d() {
    if ($6aafc073576331d2$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $6aafc073576331d2$export$2e2bcd8739ae039(msg, ...args) {
    if ($6aafc073576331d2$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("4lC4o", function(module, exports) {

$parcel$export(module.exports, "SLI_EVENT_TYPE", () => $dfdfb81b6234304f$export$245097525aef1262);
$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $dfdfb81b6234304f$export$c724588856bbfbcf);
$parcel$export(module.exports, "SliNames", () => $dfdfb81b6234304f$export$7afb0727c7d7e8af);
$parcel$export(module.exports, "Actions", () => $dfdfb81b6234304f$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "fireAnalyticsMentionEvent", () => $dfdfb81b6234304f$export$44902bc7b3f0b09f);
$parcel$export(module.exports, "buildSliPayload", () => $dfdfb81b6234304f$export$c357a2872628de7c);



var $hWvv0 = parcelRequire("hWvv0");
const $dfdfb81b6234304f$var$packageName = undefined;
const $dfdfb81b6234304f$var$packageVersion = undefined;
const $dfdfb81b6234304f$export$245097525aef1262 = 'sli';
const $dfdfb81b6234304f$export$c724588856bbfbcf = 'smart';
var $dfdfb81b6234304f$export$7afb0727c7d7e8af;
(function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
})($dfdfb81b6234304f$export$7afb0727c7d7e8af || ($dfdfb81b6234304f$export$7afb0727c7d7e8af = {}));
var $dfdfb81b6234304f$export$5c42d9dea6d035c1;
(function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
})($dfdfb81b6234304f$export$5c42d9dea6d035c1 || ($dfdfb81b6234304f$export$5c42d9dea6d035c1 = {}));
var $dfdfb81b6234304f$export$b52183d5cfb26dc9;
(function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
})($dfdfb81b6234304f$export$b52183d5cfb26dc9 || ($dfdfb81b6234304f$export$b52183d5cfb26dc9 = {}));
const $dfdfb81b6234304f$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: "mentionTypeahead",
                attributes: {
                    packageName: $dfdfb81b6234304f$var$packageName,
                    packageVersion: $dfdfb81b6234304f$var$packageVersion,
                    componentName: "mention",
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $662e33bb7444ae33$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
        }
    };
const $dfdfb81b6234304f$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $662e33bb7444ae33$export$a1562d08625f5d7e),
            attributes: {
                packageName: $dfdfb81b6234304f$var$packageName,
                packageVersion: $dfdfb81b6234304f$var$packageVersion,
                componentName: "mention",
                accessLevel: accessLevel,
                isSpecial: (0, $hWvv0.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
        return event;
    };
const $dfdfb81b6234304f$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $dfdfb81b6234304f$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
        }
    };
const $dfdfb81b6234304f$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        attributes: {
            packageName: $dfdfb81b6234304f$var$packageName,
            packageVersion: $dfdfb81b6234304f$var$packageVersion,
            componentName: "mention",
            ...attributes
        }
    };
    return eventPayload;
};
const $dfdfb81b6234304f$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: "mention",
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $dfdfb81b6234304f$var$packageName,
                    packageVersion: $dfdfb81b6234304f$var$packageVersion,
                    componentName: "mention",
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $662e33bb7444ae33$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
        }
    };
// OLD Analytics
const $dfdfb81b6234304f$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $dfdfb81b6234304f$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$dfdfb81b6234304f$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $hWvv0.isSpecialMentionText)(text)
        });
    };

});
const $ff610ba30633db9d$export$d821aa4c8afb384e = 'fabric-elements';



parcelRegister("hiBi9", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayModal", () => $df085b8c8c8c9e63$export$32eec1126fb86cc9);
$parcel$export(module.exports, "useInvitePeopleDrawer", () => $df085b8c8c8c9e63$export$48fb2d80745c5e67);
$parcel$export(module.exports, "triggerOpenDrawer", () => $df085b8c8c8c9e63$export$b7dab610045052db);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
var $gasA1 = parcelRequire("gasA1");

var $1Iui1 = parcelRequire("1Iui1");

var $cQrkf = parcelRequire("cQrkf");
const $df085b8c8c8c9e63$var$CONTROLLER_NAME = 'invite-people-drawer';
const $df085b8c8c8c9e63$var$initialState = {
    isOpen: false,
    inviteFlow: 'unknown',
    continueUrl: undefined
};
const $df085b8c8c8c9e63$export$1dbc37ce23aead84 = ({ inviteFromAssignModalCohort: inviteFromAssignModalCohort })=>{
    let resolvedCohort = {
        cohort: '',
        ineligibilityReasons: [
            ''
        ]
    };
    if (inviteFromAssignModalCohort === (0, $1Iui1.NOT_ENROLLED)) resolvedCohort = {
        cohort: (0, $1Iui1.NOT_ENROLLED),
        ineligibilityReasons: []
    };
    if (inviteFromAssignModalCohort === (0, $1Iui1.CONTROL)) resolvedCohort = {
        cohort: (0, $1Iui1.CONTROL),
        ineligibilityReasons: []
    };
    if (inviteFromAssignModalCohort === (0, $1Iui1.VARIATION)) resolvedCohort = {
        cohort: (0, $1Iui1.VARIATION),
        ineligibilityReasons: []
    };
    return resolvedCohort;
};
const $df085b8c8c8c9e63$export$32eec1126fb86cc9 = (inviteAssignModelContext)=>{
    if ($df085b8c8c8c9e63$export$1dbc37ce23aead84(inviteAssignModelContext).cohort === (0, $1Iui1.VARIATION)) return true;
    return false;
};
const $df085b8c8c8c9e63$var$Store = (0, $a61MH.createStore)({
    name: $df085b8c8c8c9e63$var$CONTROLLER_NAME,
    initialState: $df085b8c8c8c9e63$var$initialState,
    actions: {
        openDrawer: (createAnalyticsEvent, { inviteFlow: inviteFlow, analyticsSource: analyticsSource, continueUrl: continueUrl }, inviteAssignModelContext, invitePromptOnLinkInsertContext)=>({ setState: setState })=>{
                const displayModal = inviteAssignModelContext && $df085b8c8c8c9e63$export$32eec1126fb86cc9(inviteAssignModelContext);
                let processedInviteAssignModalContext;
                if (inviteAssignModelContext) {
                    processedInviteAssignModalContext = {
                        ...inviteAssignModelContext
                    };
                    const { cohort: resultCohort, ineligibilityReasons: ineligibilityReasons } = $df085b8c8c8c9e63$export$1dbc37ce23aead84(inviteAssignModelContext);
                    (0, $cQrkf.fireAddTeammatetoJiraAnalytics)(createAnalyticsEvent, resultCohort, analyticsSource);
                    (0, $cQrkf.fireInviteFromAssignModalExposedAnalytics)(createAnalyticsEvent, inviteAssignModelContext.inviteFromAssignModalCohort, resultCohort, ineligibilityReasons, analyticsSource);
                    processedInviteAssignModalContext.inviteFromAssignModalCohort = resultCohort;
                }
                if (displayModal) (0, $cQrkf.fireModalTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, inviteAssignModelContext, analyticsSource);
                else (0, $cQrkf.fireDrawerTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, analyticsSource);
                setState({
                    isOpen: true,
                    inviteFlow: inviteFlow,
                    continueUrl: continueUrl,
                    inviteAssignModelContext: processedInviteAssignModalContext,
                    invitePromptOnLinkInsertContext: invitePromptOnLinkInsertContext
                });
            },
        closeDrawer: ()=>({ setState: setState })=>setState($df085b8c8c8c9e63$var$initialState)
    }
});
const $df085b8c8c8c9e63$export$48fb2d80745c5e67 = (0, $ggKAj.createHook)($df085b8c8c8c9e63$var$Store);
const $df085b8c8c8c9e63$export$ac7fed664b4735b5 = (0, $heB5U.createContainer)($df085b8c8c8c9e63$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen })=>{
            setState({
                isOpen: isOpen
            });
        }
});
const $df085b8c8c8c9e63$export$4358742cbaf4a6d4 = (0, $dYfll.createSubscriber)($df085b8c8c8c9e63$var$Store, {
    displayName: 'InvitePeopleDrawerSubscriber',
    selector: (state)=>state.isOpen
});
const $df085b8c8c8c9e63$export$b7dab610045052db = (createAnalyticsEvent, contextConfig, inviteAssignModelContext)=>{
    (0, $gasA1.defaultRegistry).getStore($df085b8c8c8c9e63$var$Store).actions.openDrawer(createAnalyticsEvent, contextConfig, inviteAssignModelContext);
};

});
parcelRegister("cQrkf", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $de9a0e3d07ee4b39$export$1b581a2ec13e37f1);
$parcel$export(module.exports, "fireDrawerTriggeredAnalytics", () => $de9a0e3d07ee4b39$export$2e49c23c45194e1a);
$parcel$export(module.exports, "fireModalTriggeredAnalytics", () => $de9a0e3d07ee4b39$export$6815765da918b983);
$parcel$export(module.exports, "fireInviteFromAssignModalExposedAnalytics", () => $de9a0e3d07ee4b39$export$9a32ecb3d5c4df6b);
$parcel$export(module.exports, "fireAddTeammatetoJiraAnalytics", () => $de9a0e3d07ee4b39$export$21b810258e82d438);

var $eUqFw = parcelRequire("eUqFw");

var $jYVKV = parcelRequire("jYVKV");

var $1Iui1 = parcelRequire("1Iui1");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $iKlrz = parcelRequire("iKlrz");

var $3FyZ4 = parcelRequire("3FyZ4");

var $9QFxq = parcelRequire("9QFxq");
const $de9a0e3d07ee4b39$var$getInviteFromAssignCohort = ()=>(0, $1ybV0.getFeatureFlagValue)('invite.from.assign', (0, $1Iui1.NOT_ENROLLED));
const $de9a0e3d07ee4b39$var$useAnalyticsClient = ()=>{
    const analyticsWebClientRef = (0, $eUqFw.useRef)((0, $3FyZ4.getAnalyticsWebClientPromise)());
    return {
        sendEvent: (analyticsEvent)=>{
            analyticsWebClientRef.current.then((webClient)=>webClient.sendEvent((0, $iKlrz.getEvent)(analyticsEvent)));
        }
    };
};
const $de9a0e3d07ee4b39$export$1b581a2ec13e37f1 = ({ children: children })=>{
    const { sendEvent: sendEvent } = $de9a0e3d07ee4b39$var$useAnalyticsClient();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
        channel: "peopleAndTeams",
        onEvent: sendEvent
    }, children);
};
const $de9a0e3d07ee4b39$var$sendAnalyticsClientUIEvent = async (createAnalyticsEvent, analyticsPayload)=>{
    if (createAnalyticsEvent) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), // @ts-expect-error Argument of type '[string, string, Attributes | undefined]' is not assignable to parameter of type 'RestArguments'.
    `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload?.actionSubjectId || '', analyticsPayload.attributes);
    else {
        const webAnalyticsClient = await (0, $3FyZ4.getAnalyticsWebClientPromise)();
        const analyticsClient = webAnalyticsClient.getInstance();
        // SSR doesn't have an analytics client
        if (analyticsClient) analyticsClient.sendUIEvent(analyticsPayload);
    }
};
const $de9a0e3d07ee4b39$export$2e49c23c45194e1a = async (createAnalyticsEvent, inviteFlow, source)=>{
    const analyticsPayload = {
        action: 'triggered',
        actionSubject: 'drawer',
        actionSubjectId: 'invitePeopleDrawer',
        attributes: {
            source: (0, $9QFxq.getSourceByInviteFlow)(inviteFlow),
            inviteFromAssignCohort: $de9a0e3d07ee4b39$var$getInviteFromAssignCohort()
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $de9a0e3d07ee4b39$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};
const $de9a0e3d07ee4b39$export$6815765da918b983 = async (createAnalyticsEvent, inviteFlow, inviteAssignModelContext, source)=>{
    const analyticsPayload = {
        action: 'triggered',
        actionSubject: 'modal',
        actionSubjectId: 'invitePeopleModal',
        attributes: {
            source: (0, $9QFxq.getSourceByInviteFlow)(inviteFlow),
            inviteFromAssignCohort: $de9a0e3d07ee4b39$var$getInviteFromAssignCohort(),
            inviteFromAssignModalCohort: inviteAssignModelContext.inviteFromAssignModalCohort
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $de9a0e3d07ee4b39$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};
const $de9a0e3d07ee4b39$export$9a32ecb3d5c4df6b = async (createAnalyticsEvent, inviteFromAssignModalCohort, resultCohort, ineligibilityReasons, source)=>{
    const analyticsPayload = {
        action: 'exposed',
        actionSubject: 'feature',
        product: 'jira',
        attributes: {
            flagKey: 'invite.from.assign.modal',
            value: inviteFromAssignModalCohort,
            cohort: resultCohort,
            growthInitiative: 'virality',
            ineligibilityReasons: ineligibilityReasons
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    if (createAnalyticsEvent) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload.attributes);
    else {
        const webAnalyticsClient = await (0, $3FyZ4.getAnalyticsWebClientPromise)();
        const analyticsClient = webAnalyticsClient.getInstance();
        // SSR doesn't have an analytics client
        if (analyticsClient) analyticsClient.sendTrackEvent(analyticsPayload);
    }
};
const $de9a0e3d07ee4b39$export$21b810258e82d438 = async (createAnalyticsEvent, resultCohort, source)=>{
    const analyticsPayload = {
        action: 'clicked',
        actionSubject: 'addTeammatetoJira',
        product: 'jira',
        attributes: {
            inviteFromAssignModalCohort: resultCohort
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $de9a0e3d07ee4b39$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};

});
parcelRegister("9QFxq", function(module, exports) {

$parcel$export(module.exports, "getSourceByInviteFlow", () => $2b0bde6b83f84248$export$c35cd18e9d0123e3);
$parcel$export(module.exports, "isInviteOnLinkInsertV3Enabled", () => $2b0bde6b83f84248$export$bbac70b4535f5e90);

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");
const $2b0bde6b83f84248$export$c35cd18e9d0123e3 = (inviteFlow)=>{
    let source = inviteFlow;
    if (inviteFlow === 'mention') source = 'mentionInEditor';
    else if (inviteFlow === 'assignee') source = 'assigneeField';
    return source;
};
const $2b0bde6b83f84248$export$bbac70b4535f5e90 = ()=>{
    if (!(0, $1ybV0.ff)('statsig-guard-invite-prompt-on-link-insert-v-3', false)) return false;
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('invite_prompt_on_link_insert_v3');
    return expConfig.get('cohort', 'not-enrolled') === 'variation';
};

});



parcelRegister("1jQHs", function(module, exports) {

$parcel$export(module.exports, "subProductFromProjectType", () => $3fcd30c3ff37f410$export$246e1e2a5c86a633);

var $7ZZxN = parcelRequire("7ZZxN");
const $3fcd30c3ff37f410$var$SERVICEDESK_APPLICATION_ROLE = 'jira-servicedesk';
const $3fcd30c3ff37f410$var$SOFTWARE_APPLICATION_ROLE = 'jira-software';
const $3fcd30c3ff37f410$var$CORE_APPLICATION_ROLE = 'jira-core';
const $3fcd30c3ff37f410$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 'Jira Service Management';
        default:
            return 'Jira';
    }
};

});





parcelRegister("67G0Q", function(module, exports) {

$parcel$export(module.exports, "useWorklogRollingUpData", () => $1e46928b5bccf349$export$9e10540a1eeeeca6);

var $ggKAj = parcelRequire("ggKAj");

var $linOi = parcelRequire("linOi");
const $1e46928b5bccf349$export$f08fb83cc7d89074 = (state)=>state.isRollingUp;
const $1e46928b5bccf349$export$9e10540a1eeeeca6 = (0, $ggKAj.createHook)((0, $linOi.store), {
    selector: $1e46928b5bccf349$export$f08fb83cc7d89074
});

});

parcelRegister("aWQFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1404d2f0ac088f02$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $hFmdR = parcelRequire("hFmdR");
var $jPfP5 = parcelRequire("jPfP5");

var $h9cCP = parcelRequire("h9cCP");

var $j8PT9 = parcelRequire("j8PT9");

var $kBu7F = parcelRequire("kBu7F");


var $7Vbpp = parcelRequire("7Vbpp");

var $7v0hO = parcelRequire("7v0hO");

var $a81Gq = parcelRequire("a81Gq");
const $1404d2f0ac088f02$export$956325f45c5d174a = ({ timeLogged: timeLogged, timeRemaining: timeRemaining, dateStarted: dateStarted })=>{
    const hasTimeLoggedOrTimeRemaining = !!timeLogged || !!timeRemaining;
    return hasTimeLoggedOrTimeRemaining && ((0, $j8PT9.default)(timeLogged) || timeLogged === '0') && (0, $j8PT9.default)(timeRemaining) && !!dateStarted;
};
function $1404d2f0ac088f02$var$AddModal(props) {
    const { timeTracking: timeTrackingState, rolledUpTimeTracking: rolledUpTimeTracking, timeTrackingConfiguration: timeTrackingConfiguration, intl: intl } = props;
    const { timeSpentSeconds: timeSpentSeconds, remainingEstimateSeconds: remainingEstimateSeconds, originalEstimateSeconds: originalEstimateSeconds } = timeTrackingState;
    let timeRemaining = '';
    if (typeof remainingEstimateSeconds === 'number') {
        // At this time we need to force the value into an english formatted
        // time string eg: `1w 1d 1h 1m` as that is the only format supported
        // on entry, future changes will support localised values.
        const intlForTimeTrackingInput = {
            ...intl,
            formatMessage: ({ defaultMessage: defaultMessage })=>defaultMessage || ''
        };
        timeRemaining = (0, $7v0hO.timeTrackingFormatter)(remainingEstimateSeconds, {
            workingHoursPerDay: timeTrackingConfiguration.hoursPerDay,
            workingDaysPerWeek: timeTrackingConfiguration.daysPerWeek,
            timeFormat: timeTrackingConfiguration.format || (0, $h9cCP.PRETTY),
            defaultUnit: timeTrackingConfiguration.defaultUnit
        }, intlForTimeTrackingInput);
    }
    const initialValue = {
        timeLogged: '',
        timeRemaining: timeRemaining,
        timeRemainingSeconds: remainingEstimateSeconds,
        workDescription: (0, $7Vbpp.emptyAdfObject),
        dateStarted: null
    };
    const timeTracking = {
        loggedTime: timeSpentSeconds,
        remainingTime: remainingEstimateSeconds
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kBu7F.default), {
        initialValue: initialValue,
        timeTracking: timeTracking,
        rolledUpTimeTracking: {
            loggedTime: rolledUpTimeTracking.timeSpentSeconds,
            remainingTime: rolledUpTimeTracking.remainingEstimateSeconds
        },
        estimatedTime: originalEstimateSeconds,
        rolledUpEstimatedTime: rolledUpTimeTracking.originalEstimateSeconds,
        config: timeTrackingConfiguration,
        header: intl.formatMessage((0, $a81Gq.default).title),
        timeZone: props.timeZone,
        isCollapsible: true,
        isDone: props.isDone,
        isWaiting: props.isSaving,
        shouldUpdateDate: true,
        validator: $1404d2f0ac088f02$export$956325f45c5d174a,
        onSubmit: props.onSubmit,
        onCancel: props.onCancel,
        onWorkDescriptionChangeFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        mediaContext: props.mediaContext,
        mentionProvider: props.mentionProvider || {},
        mentionEncoder: props.mentionEncoder,
        activityProvider: props.activityProvider,
        externalId: props.externalId,
        shouldDisplayRollUpDataControl: props.shouldDisplayRollUpDataControl,
        isRollingUpData: props.isRollingUpData,
        onToggleRollingUpData: props.onToggleRollingUpData,
        isClassicProject: props.isClassicProject
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPfP5.default), null));
}
var $1404d2f0ac088f02$export$2e2bcd8739ae039 = (0, $hFmdR.AnalyticsSource)('addWorklog', (0, $41ea3621645e2acc$export$1171103ea9083ffa))($1404d2f0ac088f02$var$AddModal);

});
parcelRegister("j8PT9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b825a9875a23f107$export$2e2bcd8739ae039);

var $ie5Ph = parcelRequire("ie5Ph");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b825a9875a23f107$export$2e2bcd8739ae039 = (timeString)=>timeString.trim() === '' || (0, $ie5Ph.default)(timeString);

});
parcelRegister("ie5Ph", function(module, exports) {

$parcel$export(module.exports, "default", () => $77051c53846fa8c6$export$2e2bcd8739ae039);

var $3fphB = parcelRequire("3fphB");

var $eH7pq = parcelRequire("eH7pq");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$77051c53846fa8c6$export$2e2bcd8739ae039 = (timeString)=>{
    // We don't care about daysPerWeek or hoursPerDay - we only need to test that the value can be parsed.
    const result = (0, $eH7pq.default)(1, 1)(timeString);
    return result !== null && (0, (/*@__PURE__*/$parcel$interopDefault($3fphB)))(result);
};

});
parcelRegister("3fphB", function(module, exports) {

var $c1MCs = parcelRequire("c1MCs");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $25d6627b2429993c$var$nativeIsFinite = $c1MCs.isFinite;
/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */ function $25d6627b2429993c$var$isFinite(value) {
    return typeof value == 'number' && $25d6627b2429993c$var$nativeIsFinite(value);
}
module.exports = $25d6627b2429993c$var$isFinite;

});



parcelRegister("kBu7F", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e9a01dfb3b593f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hFmdR = parcelRequire("hFmdR");
var $8un0w = parcelRequire("8un0w");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $aR8n6 = parcelRequire("aR8n6");

var $3z55G = parcelRequire("3z55G");
const $3e9a01dfb3b593f6$var$WrappedModal = (0, $8un0w.default)({
    onSubmit: 'clicked',
    onCancel: 'clicked',
    onToggleRollingUpData: 'toggleRollingUpData'
})((0, $hFmdR.AnalyticsSubject)('worklogModal')((0, $3z55G.default)));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3e9a01dfb3b593f6$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue.issue-view.common.worklog-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "common.worklog-dialog",
        packageName: "jiraIssueViewCommon",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e9a01dfb3b593f6$var$WrappedModal, props)));

});
parcelRegister("3z55G", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce89e537607bf0cf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $h9cCP = parcelRequire("h9cCP");

var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("7Ymv3");
var $lQaym = parcelRequire("lQaym");

var $dVIX2 = parcelRequire("dVIX2");
var $j8PT9 = parcelRequire("j8PT9");
var $eH7pq = parcelRequire("eH7pq");

var $7Vbpp = parcelRequire("7Vbpp");

var $7v0hO = parcelRequire("7v0hO");

var $lqqjK = parcelRequire("lqqjK");
const $ce89e537607bf0cf$export$2ab51c2ed4c33417 = ({ isCollapsible: isCollapsible = false, isDone: isDone = false, isWaiting: isWaiting = false, shouldUpdateDate: shouldUpdateDate = false, isRollingUpData: isRollingUpData, isClassicProject: isClassicProject, shouldDisplayRollUpDataControl: shouldDisplayRollUpDataControl, initialValue: initialValue, timeTracking: timeTracking, rolledUpTimeTracking: rolledUpTimeTracking, estimatedTime: estimatedTime, rolledUpEstimatedTime: rolledUpEstimatedTime, config: config, header: header, timeZone: timeZone, validator: validator, mediaContext: mediaContext, mentionProvider: mentionProvider, mentionEncoder: mentionEncoder, activityProvider: activityProvider, externalId: externalId, onSubmit: onSubmit, onCancel: onCancel, onWorkDescriptionChangeFailure: onWorkDescriptionChangeFailure, onToggleRollingUpData: onToggleRollingUpData })=>{
    const intl = (0, $5JgJ2.default)();
    const [state, setState] = (0, $eUqFw.useState)(()=>({
            // We save the original value so that any changes to the passed in value do not affect
            // the rendering of the progress tracker.
            value: initialValue,
            // Until the user sets a date manually, we use this defaultDateStarted value to
            // calculate the form value when the user updates the logged time.
            defaultDateStarted: Date.now(),
            isTimeLoggedValid: true,
            isTimeRemainingValid: true,
            hasUserInteracted: false
        }));
    const getTimeStringToSeconds = (0, $eUqFw.useCallback)((timeString)=>{
        const { daysPerWeek: daysPerWeek, hoursPerDay: hoursPerDay } = config;
        return (0, $eH7pq.default)(daysPerWeek, hoursPerDay)(timeString);
    }, [
        config
    ]);
    const secondsToTimeString = (0, $eUqFw.useCallback)((seconds)=>{
        // At this time we need to force the value into an english formatted
        // time string eg: `1w 1d 1h 1m` as that is the only format supported
        // on entry, future changes will support localised values.
        const intlForTimeTrackingInput = {
            ...intl,
            formatMessage: ({ defaultMessage: defaultMessage })=>defaultMessage || ''
        };
        return (0, $7v0hO.timeTrackingFormatter)(seconds, {
            workingHoursPerDay: config.hoursPerDay,
            workingDaysPerWeek: config.daysPerWeek,
            timeFormat: config.format || (0, $h9cCP.PRETTY),
            defaultUnit: config.defaultUnit
        }, intlForTimeTrackingInput);
    }, [
        config.daysPerWeek,
        config.defaultUnit,
        config.format,
        config.hoursPerDay,
        intl
    ]);
    const applyDefaultTimeFormat = (0, $eUqFw.useCallback)((value, onValueChange)=>{
        let newValue = value.trim();
        // If user doesn't type the valid format (m, h, d, or w), use default unit format set in the configuration.
        if ((0, $dVIX2.isNumeric)(newValue)) {
            const { defaultUnit: defaultUnit } = config;
            newValue = `${newValue}${(0, $lQaym.getDefaultTimeTrackingUnit)(defaultUnit)}`;
        }
        if (newValue !== value) onValueChange(newValue);
    }, [
        config
    ]);
    const onTimeLoggedChange = (0, $eUqFw.useCallback)((timeLogged)=>{
        const isTimeLoggedValidNew = (0, $j8PT9.default)(timeLogged);
        const timeLoggedSeconds = getTimeStringToSeconds(timeLogged) || 0;
        setState(({ value: value, ...oldState })=>{
            let newState = {
                ...oldState,
                value: {
                    ...value,
                    timeLogged: timeLogged,
                    timeLoggedSeconds: timeLoggedSeconds
                },
                hasUserInteracted: true,
                isTimeLoggedValid: isTimeLoggedValidNew
            };
            // Update the remaining time if the time logged is valid and there was an initial
            // remaining time value. We skip this if the time logged input is invalid, or there
            // is no initial time remaining value to compare to.
            if (isTimeLoggedValidNew && initialValue.timeRemaining) {
                const originalTimeLoggedSeconds = getTimeStringToSeconds(initialValue.timeLogged) || 0;
                const originalTimeRemaining = initialValue.timeRemainingSeconds || 0;
                const timeRemainingSecondsDelta = originalTimeLoggedSeconds + originalTimeRemaining - timeLoggedSeconds;
                const timeRemainingSeconds = timeRemainingSecondsDelta > 0 ? timeRemainingSecondsDelta : 0;
                const timeRemaining = secondsToTimeString(timeRemainingSeconds);
                newState = {
                    ...newState,
                    value: {
                        ...newState.value,
                        timeRemaining: timeRemaining,
                        timeRemainingSeconds: timeRemainingSeconds
                    },
                    isTimeRemainingValid: true
                };
            }
            return newState;
        });
    }, [
        getTimeStringToSeconds,
        initialValue.timeLogged,
        initialValue.timeRemaining,
        initialValue.timeRemainingSeconds,
        secondsToTimeString
    ]);
    const onTimeRemainingChange = (0, $eUqFw.useCallback)((timeRemaining)=>{
        const timeRemainingSeconds = getTimeStringToSeconds(timeRemaining) || 0;
        setState(({ value: value, ...oldState })=>({
                ...oldState,
                value: {
                    ...value,
                    timeRemaining: timeRemaining,
                    timeRemainingSeconds: timeRemainingSeconds
                },
                hasUserInteracted: true,
                isTimeRemainingValid: (0, $j8PT9.default)(timeRemaining)
            }));
    }, [
        getTimeStringToSeconds
    ]);
    const onTimeLoggedBlur = (0, $eUqFw.useCallback)(()=>{
        applyDefaultTimeFormat(state.value.timeLogged, onTimeLoggedChange);
    }, [
        applyDefaultTimeFormat,
        onTimeLoggedChange,
        state
    ]);
    const onTimeRemainingBlur = (0, $eUqFw.useCallback)(()=>{
        applyDefaultTimeFormat(state.value.timeRemaining, onTimeRemainingChange);
    }, [
        applyDefaultTimeFormat,
        onTimeRemainingChange,
        state.value.timeRemaining
    ]);
    const onDateStartedChange = (0, $eUqFw.useCallback)((dateStarted)=>{
        // @ts-expect-error - TS2345 - Argument of type '({ value, ...oldState }: { value: FormValues; defaultDateStarted: number; isTimeLoggedValid: boolean; isTimeRemainingValid: boolean; hasUserInteracted: boolean; }) => { value: { dateStarted: string | null; ... 4 more ...; workDescription: DocNode; }; defaultDateStarted: null; hasUserInteracted: true; isTimeLoggedVal...' is not assignable to parameter of type 'SetStateAction<{ value: FormValues; defaultDateStarted: number; isTimeLoggedValid: boolean; isTimeRemainingValid: boolean; hasUserInteracted: boolean; }>'.
        setState(({ value: value, ...oldState })=>({
                ...oldState,
                value: {
                    ...value,
                    dateStarted: dateStarted
                },
                defaultDateStarted: null,
                hasUserInteracted: true
            }));
    }, []);
    const onWorkDescriptionChange = (0, $eUqFw.useCallback)((workDescription)=>{
        setState(({ value: value, ...oldState })=>({
                ...oldState,
                value: {
                    ...value,
                    workDescription: workDescription
                },
                hasUserInteracted: true
            }));
    }, []);
    const getDateStarted = (0, $eUqFw.useCallback)(()=>{
        const { value: { dateStarted: dateStarted, timeLogged: timeLogged }, defaultDateStarted: defaultDateStarted } = state;
        if (!shouldUpdateDate || dateStarted) return dateStarted;
        if (!defaultDateStarted) return null;
        // If the user has not manually set a date, then calculate the date value by subtracting
        // the time logged from the current timestamp.
        const timeLoggedSeconds = getTimeStringToSeconds(timeLogged) || 0;
        // Handle the case where timeLoggedSeconds is too large and causes Date.toISOString to
        //  throw an error.
        try {
            return new Date(defaultDateStarted - timeLoggedSeconds * 1000).toISOString();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return new Date(defaultDateStarted).toISOString();
        }
    }, [
        getTimeStringToSeconds,
        shouldUpdateDate,
        state
    ]);
    const getValue = (0, $eUqFw.useCallback)(()=>({
            ...state.value,
            dateStarted: getDateStarted()
        }), [
        getDateStarted,
        state.value
    ]);
    const handleSubmit = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        const { workDescription: workDescription } = state.value;
        const modifiedAdf = typeof workDescription !== 'string' ? (0, $7Vbpp.removeNewLineCharactersFromAdf)(workDescription) : workDescription;
        const modifiedForm = {
            ...getValue(),
            workDescription: modifiedAdf
        };
        onSubmit(modifiedForm, analyticsEvent);
    }, [
        getValue,
        onSubmit,
        state.value
    ]);
    const getIsCollapsed = (0, $eUqFw.useCallback)(()=>isCollapsible && !state.value.timeLogged, [
        isCollapsible,
        state.value.timeLogged
    ]);
    const getFormState = (0, $eUqFw.useCallback)(()=>{
        if (isWaiting) return 'submitting';
        if (!state.hasUserInteracted) return 'invalid';
        if (validator(getValue())) return 'valid';
        return 'invalid';
    }, [
        getValue,
        isWaiting,
        state.hasUserInteracted,
        validator
    ]);
    const getProgressTrackerValue = (0, $eUqFw.useCallback)(()=>{
        const { timeLogged: timeLogged, timeRemaining: timeRemaining } = state.value;
        const timeTrackingNew = isRollingUpData ? rolledUpTimeTracking : timeTracking;
        // If there is a valid value in the time logged field, calculate the delta between the
        // initial value and the user input value in seconds, and add that to the existing
        // timeTracking value.
        // Otherwise, fall back to the existing timeTracking value.
        const timeLoggedSeconds = getTimeStringToSeconds(timeLogged) || 0;
        const originalTimeLoggedSeconds = getTimeStringToSeconds(initialValue.timeLogged) || 0;
        const timeLoggedDelta = timeLoggedSeconds - originalTimeLoggedSeconds;
        const loggedTime = timeLoggedDelta || timeTrackingNew.loggedTime ? (timeLoggedDelta || 0) + (timeTrackingNew.loggedTime || 0) : undefined;
        // If there is a valid value in the time remaining field, we want to use that value:
        // However in rolling up estimates we calculate the difference and then use it as the
        // delta for the new value, when not rolling up we just whatever value the user has provided.
        // For any non-valid value provided by the uyser, fall back to the existing `timeTracking` value
        const timeRemainingSeconds = getTimeStringToSeconds(timeRemaining);
        const originalTimeRemainingSeconds = getTimeStringToSeconds(initialValue.timeRemaining) || 0;
        const timeRemainingDelta = (timeRemainingSeconds || 0) - originalTimeRemainingSeconds;
        const isTimeRemainingValidNew = typeof timeRemainingSeconds === 'number';
        let { remainingTime: remainingTime } = timeTrackingNew;
        if (isTimeRemainingValidNew) remainingTime = isRollingUpData ? (timeTrackingNew.remainingTime || 0) + timeRemainingDelta : timeRemainingSeconds || 0;
        return {
            loggedTime: loggedTime,
            remainingTime: remainingTime
        };
    }, [
        getTimeStringToSeconds,
        initialValue.timeLogged,
        initialValue.timeRemaining,
        isRollingUpData,
        rolledUpTimeTracking,
        state.value,
        timeTracking
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lqqjK.default), {
        value: getValue(),
        progressTrackerValue: getProgressTrackerValue(),
        estimatedTime: estimatedTime,
        rolledUpEstimatedTime: rolledUpEstimatedTime,
        config: config,
        header: header,
        formState: getFormState(),
        timeZone: timeZone,
        isCollapsed: getIsCollapsed(),
        isDone: isDone,
        isTimeLoggedValid: state.isTimeLoggedValid,
        isTimeRemainingValid: state.isTimeRemainingValid,
        onSubmit: handleSubmit,
        onCancel: onCancel,
        onTimeLoggedChange: onTimeLoggedChange,
        onTimeLoggedBlur: onTimeLoggedBlur,
        onTimeRemainingChange: onTimeRemainingChange,
        onTimeRemainingBlur: onTimeRemainingBlur,
        onDateStartedChange: onDateStartedChange,
        onWorkDescriptionChange: onWorkDescriptionChange,
        onWorkDescriptionChangeFailure: onWorkDescriptionChangeFailure,
        mediaContext: mediaContext,
        mentionProvider: mentionProvider,
        mentionEncoder: mentionEncoder,
        activityProvider: activityProvider,
        externalId: externalId,
        shouldDisplayRollUpDataControl: shouldDisplayRollUpDataControl,
        isRollingUpData: isRollingUpData,
        onToggleRollingUpData: onToggleRollingUpData,
        isClassicProject: isClassicProject
    });
};
var $ce89e537607bf0cf$export$2e2bcd8739ae039 = $ce89e537607bf0cf$export$2ab51c2ed4c33417;

});
parcelRegister("7Ymv3", function(module, exports) {

$parcel$export(module.exports, "formatTimeString", () => $344ebf6d57e1d18f$export$2de90790c3ad23b1);
$parcel$export(module.exports, "isValidTimeString", () => $344ebf6d57e1d18f$export$669626963db3b187);
$parcel$export(module.exports, "parseTimeString", () => $344ebf6d57e1d18f$export$53148bfa4e677363);
$parcel$export(module.exports, "secondsToTimeString", () => (parcelRequire("734NL")).default);
$parcel$export(module.exports, "timeStringToSeconds", () => (parcelRequire("eH7pq")).default);
$parcel$export(module.exports, "getDefaultTimeTrackingUnit", () => (parcelRequire("lQaym")).getDefaultTimeTrackingUnit);

var $dVIX2 = parcelRequire("dVIX2");
var $ie5Ph = parcelRequire("ie5Ph");
var $734NL = parcelRequire("734NL");
var $eH7pq = parcelRequire("eH7pq");

var $lQaym = parcelRequire("lQaym");

var $eDEru = parcelRequire("eDEru");
const $344ebf6d57e1d18f$export$2de90790c3ad23b1 = (config)=>(timeValue)=>(0, $734NL.default)(config.daysPerWeek, config.hoursPerDay)(timeValue || 0);
const $344ebf6d57e1d18f$export$5eb9d332712102eb = (config)=>(value)=>{
        let trimmedValue = value.trim();
        // If user doesn't type the valid format (m, h, d, or w), use default unit format set in the configuration.
        if ((0, $dVIX2.isNumeric)(trimmedValue)) {
            const { defaultUnit: defaultUnit } = config;
            trimmedValue = `${trimmedValue}${(0, $lQaym.getDefaultTimeTrackingUnit)(defaultUnit)}`;
        }
        return trimmedValue;
    };
const $344ebf6d57e1d18f$export$669626963db3b187 = (config)=>(value)=>{
        const timeString = $344ebf6d57e1d18f$export$5eb9d332712102eb(config)(value);
        return timeString === '' || (0, $ie5Ph.default)(timeString);
    };
const $344ebf6d57e1d18f$export$53148bfa4e677363 = (config)=>(value)=>{
        const timeString = $344ebf6d57e1d18f$export$5eb9d332712102eb(config)(value);
        if (!$344ebf6d57e1d18f$export$669626963db3b187(config)(timeString)) return 0;
        return (0, $eH7pq.default)(config.daysPerWeek, config.hoursPerDay)(timeString);
    };

});
parcelRegister("dVIX2", function(module, exports) {

$parcel$export(module.exports, "isNumeric", () => $067bfbcbce038d78$export$e90fb89750dba83f);
const $067bfbcbce038d78$export$e90fb89750dba83f = (num)=>num.length > 0 && !Number.isNaN(Number(num));

});

parcelRegister("734NL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f60e814852ba3602$export$2e2bcd8739ae039);
const $f60e814852ba3602$var$MINUTES_PER_HOUR = 60;
const $f60e814852ba3602$var$SECONDS_PER_MINUTE = 60;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f60e814852ba3602$export$2e2bcd8739ae039 = (daysPerWeek, hoursPerDay)=>{
    const units = [
        {
            suffix: 'w',
            seconds: daysPerWeek * hoursPerDay * $f60e814852ba3602$var$MINUTES_PER_HOUR * $f60e814852ba3602$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'd',
            seconds: hoursPerDay * $f60e814852ba3602$var$MINUTES_PER_HOUR * $f60e814852ba3602$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'h',
            seconds: $f60e814852ba3602$var$MINUTES_PER_HOUR * $f60e814852ba3602$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'm',
            seconds: $f60e814852ba3602$var$SECONDS_PER_MINUTE
        }
    ];
    return (seconds)=>{
        const initial = {
            secondsRemaining: seconds,
            timeString: ''
        };
        const result = units.reduce((acc, unit)=>{
            // Skip this unit if it doesn't have a valid number of seconds
            if (unit.seconds <= 0) return acc;
            const numUnits = Math.floor(acc.secondsRemaining / unit.seconds);
            const updatedSecondsRemaining = numUnits >= 1 ? acc.secondsRemaining % unit.seconds : acc.secondsRemaining;
            const updatedTimeString = numUnits >= 1 ? `${acc.timeString} ${numUnits}${unit.suffix}` : acc.timeString;
            return {
                secondsRemaining: updatedSecondsRemaining,
                timeString: updatedTimeString
            };
        }, initial);
        return result.timeString.trim() || '0m';
    };
};

});

parcelRegister("lQaym", function(module, exports) {

$parcel$export(module.exports, "getDefaultTimeTrackingUnit", () => $1a98cbfbb1c11444$export$2b38dfc7401492ba);
// This is required to map the default time-tracking unit coming from the server (gira endpoint BENTO: 3334) to client
const $1a98cbfbb1c11444$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT = {
    minute: 'm',
    hour: 'h',
    day: 'd',
    week: 'w'
};
const $1a98cbfbb1c11444$export$2b38dfc7401492ba = (serverDefaultUnit)=>$1a98cbfbb1c11444$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT[serverDefaultUnit] || $1a98cbfbb1c11444$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT.minute;

});


parcelRegister("7v0hO", function(module, exports) {

$parcel$export(module.exports, "timeTrackingFormatter", () => $84936c9163886c98$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $84936c9163886c98$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $84936c9163886c98$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $84936c9163886c98$export$8516173ab945b52f);

var $4m36T = parcelRequire("4m36T");

var $eyAhE = parcelRequire("eyAhE");
// Format time to be 2 decimal places without trailing zeros
const $84936c9163886c98$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $84936c9163886c98$var$timePrettyFormatter = (timeInSeconds, units)=>{
    const timeForZero = `0${units[3].suffix}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${unit.suffix}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$var$timePrettyFormatterLongForm = (timeInSeconds, units)=>{
    const timeForZero = `0${units[7].suffix}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (unit?.isSingular) {
            if (currentTimeValue === 1) return {
                secondsRemaining: timeObj.secondsRemaining % unit.seconds,
                time: `${timeObj.time} ${currentTimeValue}${unit.suffix}`
            };
            return timeObj;
        }
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue}${unit.suffix}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $4m36T.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const units = [
        {
            suffix: formatMessage((0, $eyAhE.default).timeUnitWeek),
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: formatMessage((0, $eyAhE.default).timeUnitDay),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: formatMessage((0, $eyAhE.default).timeUnitHour),
            seconds: (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: formatMessage((0, $eyAhE.default).timeUnitMinute),
            seconds: (0, $4m36T.SECONDS_PER_MINUTE)
        }
    ];
    switch(timeFormat){
        case (0, $4m36T.TimeFormats).DAYS:
            return $84936c9163886c98$var$timeFormatter(isTimeInDaysValid ? timeInSeconds / units[1].seconds : 0, units[1].suffix);
        case (0, $4m36T.TimeFormats).HOURS:
            return $84936c9163886c98$var$timeFormatter(isTimeValid ? timeInSeconds / units[2].seconds : 0, units[2].suffix);
        case (0, $4m36T.TimeFormats).PRETTY:
        default:
            return $84936c9163886c98$var$timePrettyFormatter(timeInSeconds, units);
    }
};
const $84936c9163886c98$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $4m36T.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $4m36T.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $4m36T.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $4m36T.defaultTimeTrackingOptions).defaultUnit
    };
    return $84936c9163886c98$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $84936c9163886c98$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $4m36T.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const units = [
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongWeekSingular)}`,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR),
            isSingular: true
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongWeekPlural)}`,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongDaySingular)}`,
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR),
            isSingular: true
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongDayPlural)}`,
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongHourSingular)}`,
            seconds: (0, $4m36T.SECONDS_PER_HOUR),
            isSingular: true
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongHourPlural)}`,
            seconds: (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongMinuteSingular)}`,
            seconds: (0, $4m36T.SECONDS_PER_MINUTE),
            isSingular: true
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongMinutePlural)}`,
            seconds: (0, $4m36T.SECONDS_PER_MINUTE)
        }
    ];
    switch(timeFormat){
        case (0, $4m36T.TimeFormats).DAYS:
            if (timeInSeconds === (0, $4m36T.SECONDS_PER_HOUR) * workingHoursPerDay) return $84936c9163886c98$var$timeFormatter(isTimeInDaysValid ? timeInSeconds / units[2].seconds : 0, units[2].suffix);
            return $84936c9163886c98$var$timeFormatter(isTimeInDaysValid ? timeInSeconds / units[3].seconds : 0, units[3].suffix);
        case (0, $4m36T.TimeFormats).HOURS:
            if (timeInSeconds === (0, $4m36T.SECONDS_PER_HOUR)) return $84936c9163886c98$var$timeFormatter(isTimeValid ? timeInSeconds / units[4].seconds : 0, units[4].suffix);
            return $84936c9163886c98$var$timeFormatter(isTimeValid ? timeInSeconds / units[5].seconds : 0, units[5].suffix);
        case (0, $4m36T.TimeFormats).PRETTY:
        default:
            return $84936c9163886c98$var$timePrettyFormatterLongForm(timeInSeconds, units);
    }
};
const $84936c9163886c98$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $4m36T.TimeFormats).DAYS:
            return (0, $4m36T.TimeFormats).DAYS;
        case (0, $4m36T.TimeFormats).HOURS:
            return (0, $4m36T.TimeFormats).HOURS;
        case (0, $4m36T.TimeFormats).PRETTY:
            return (0, $4m36T.TimeFormats).PRETTY;
        default:
            return (0, $4m36T.TimeFormats).DAYS;
    }
};
const $84936c9163886c98$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $4m36T.TimeUnits).DAY:
            return (0, $4m36T.TimeUnits).DAY;
        case (0, $4m36T.TimeUnits).HOUR:
            return (0, $4m36T.TimeUnits).HOUR;
        case (0, $4m36T.TimeUnits).MINUTE:
            return (0, $4m36T.TimeUnits).MINUTE;
        case (0, $4m36T.TimeUnits).WEEK:
            return (0, $4m36T.TimeUnits).WEEK;
        default:
            return (0, $4m36T.TimeUnits).DAY;
    }
};

});
parcelRegister("4m36T", function(module, exports) {

$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $8d43f29047a2cbec$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $8d43f29047a2cbec$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $8d43f29047a2cbec$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $8d43f29047a2cbec$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $8d43f29047a2cbec$export$f8d48c1fed813e90);
const $8d43f29047a2cbec$export$544c576050746347 = 60;
const $8d43f29047a2cbec$export$a4982fdb1458274 = 60;
const $8d43f29047a2cbec$export$3cc7ae4b390f50a = $8d43f29047a2cbec$export$a4982fdb1458274 * $8d43f29047a2cbec$export$544c576050746347;
const $8d43f29047a2cbec$var$TIME_FORMAT_PRETTY = 'pretty';
const $8d43f29047a2cbec$var$TIME_FORMAT_DAYS = 'days';
const $8d43f29047a2cbec$var$TIME_FORMAT_HOURS = 'hours';
const $8d43f29047a2cbec$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $8d43f29047a2cbec$var$TIME_FORMAT_PRETTY,
    DAYS: $8d43f29047a2cbec$var$TIME_FORMAT_DAYS,
    HOURS: $8d43f29047a2cbec$var$TIME_FORMAT_HOURS
});
const $8d43f29047a2cbec$var$TIME_UNIT_WEEK = 'week';
const $8d43f29047a2cbec$var$TIME_UNIT_DAY = 'day';
const $8d43f29047a2cbec$var$TIME_UNIT_HOUR = 'hour';
const $8d43f29047a2cbec$var$TIME_UNIT_MINUTE = 'minute';
const $8d43f29047a2cbec$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $8d43f29047a2cbec$var$TIME_UNIT_WEEK,
    DAY: $8d43f29047a2cbec$var$TIME_UNIT_DAY,
    HOUR: $8d43f29047a2cbec$var$TIME_UNIT_HOUR,
    MINUTE: $8d43f29047a2cbec$var$TIME_UNIT_MINUTE
});
const $8d43f29047a2cbec$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $8d43f29047a2cbec$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $8d43f29047a2cbec$export$5d7753c8ad881494.MINUTE
};

});

parcelRegister("eyAhE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93ae5507f3c0ae3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a93ae5507f3c0ae3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeekPlural: {
        "id": "time-tracking-formatter.time-unit-long-week-plural",
        "defaultMessage": "weeks"
    },
    timeUnitLongDayPlural: {
        "id": "time-tracking-formatter.time-unit-long-day-plural",
        "defaultMessage": "days"
    },
    timeUnitLongHourPlural: {
        "id": "time-tracking-formatter.time-unit-long-hour-plural",
        "defaultMessage": "hours"
    },
    timeUnitLongMinutePlural: {
        "id": "time-tracking-formatter.time-unit-long-minute-plural",
        "defaultMessage": "minutes"
    },
    timeUnitLongWeekSingular: {
        "id": "time-tracking-formatter.time-unit-long-week-singular",
        "defaultMessage": "week"
    },
    timeUnitLongDaySingular: {
        "id": "time-tracking-formatter.time-unit-long-day-singular",
        "defaultMessage": "day"
    },
    timeUnitLongHourSingular: {
        "id": "time-tracking-formatter.time-unit-long-hour-singular",
        "defaultMessage": "hour"
    },
    timeUnitLongMinuteSingular: {
        "id": "time-tracking-formatter.time-unit-long-minute-singular",
        "defaultMessage": "minute"
    }
});

});


parcelRegister("lqqjK", function(module, exports) {

$parcel$export(module.exports, "default", () => $56da7e47f1fc6614$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $kGQen = parcelRequire("kGQen");

var $734NL = parcelRequire("734NL");
var $eH7pq = parcelRequire("eH7pq");

var $k3YqD = parcelRequire("k3YqD");

var $6DjyZ = parcelRequire("6DjyZ");

var $hw7ga = parcelRequire("hw7ga");

var $k8sYV = parcelRequire("k8sYV");
class $56da7e47f1fc6614$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isDone: false,
            progressTrackerValue: {},
            estimatedTime: undefined
        };
    }
    secondsToTimeString(seconds) {
        const { daysPerWeek: daysPerWeek, hoursPerDay: hoursPerDay } = this.props.config;
        return (0, $734NL.default)(daysPerWeek, hoursPerDay)(seconds);
    }
    timeStringToSeconds(timeString) {
        const { daysPerWeek: daysPerWeek, hoursPerDay: hoursPerDay } = this.props.config;
        return (0, $eH7pq.default)(daysPerWeek, hoursPerDay)(timeString);
    }
    renderProgressTracker() {
        const { progressTrackerValue: progressTrackerValue, progressTrackerValue: { loggedTime: loggedTime, remainingTime: remainingTime }, estimatedTime: estimatedTime, rolledUpEstimatedTime: rolledUpEstimatedTime, config: config, isDone: isDone, shouldDisplayRollUpDataControl: shouldDisplayRollUpDataControl, isRollingUpData: isRollingUpData, onToggleRollingUpData: onToggleRollingUpData, isClassicProject: isClassicProject } = this.props;
        if (loggedTime === undefined && remainingTime === undefined && estimatedTime === undefined && shouldDisplayRollUpDataControl === false) // Do not render the progress tracker at all if all values are empty.
        return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8sYV.default), {
            config: config,
            value: progressTrackerValue,
            estimatedTime: isRollingUpData ? rolledUpEstimatedTime : estimatedTime,
            isDone: isDone,
            shouldDisplayRollUpDataControl: shouldDisplayRollUpDataControl,
            isRollingUpData: isRollingUpData,
            onToggleRollingUpData: onToggleRollingUpData,
            isClassicProject: isClassicProject
        });
    }
    renderForm() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hw7ga.default), {
            value: this.props.value,
            isCollapsed: this.props.isCollapsed,
            isDisabled: this.props.formState === 'submitting',
            isTimeLoggedValid: this.props.isTimeLoggedValid,
            onTimeLoggedBlur: this.props.onTimeLoggedBlur,
            isTimeRemainingValid: this.props.isTimeRemainingValid,
            onTimeRemainingBlur: this.props.onTimeRemainingBlur,
            timeZone: this.props.timeZone,
            portalElement: this.state.containerRef,
            onTimeLoggedChange: this.props.onTimeLoggedChange,
            onTimeRemainingChange: this.props.onTimeRemainingChange,
            onDateStartedChange: this.props.onDateStartedChange,
            onWorkDescriptionChange: this.props.onWorkDescriptionChange,
            onWorkDescriptionChangeFailure: this.props.onWorkDescriptionChangeFailure,
            mediaContext: this.props.mediaContext,
            mentionEncoder: this.props.mentionEncoder,
            mentionProvider: this.props.mentionProvider,
            activityProvider: this.props.activityProvider,
            externalId: this.props.externalId
        });
    }
    renderChildren() {
        /* we need to use the EnterEscapeHandler instead of just onDialogDismissed on the modal
        because we only want to close the top-level modal if there are multiple */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.setContainerRef,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "issue.issue-view.common.log-time-modal-dialog.contents"
        }, this.renderProgressTracker(), this.renderForm());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k3YqD.ModalDialog), {
            width: "small",
            onClose: this.props.onCancel /* so that it closes on overlay click */ ,
            shouldCloseOnEscapePress: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, this.props.header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, this.renderChildren()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6DjyZ.default), {
            formState: this.props.formState,
            onConfirm: this.props.onSubmit,
            onCancel: this.props.onCancel
        }))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            containerRef: undefined
        };
        this.setContainerRef = (ref)=>{
            if (!this.state.containerRef) this.setState({
                containerRef: ref
            });
        };
        this.renderHeader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h3", null, this.props.header);
        this.renderFooter = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6DjyZ.default), {
                formState: this.props.formState,
                onConfirm: this.props.onSubmit,
                onCancel: this.props.onCancel
            });
    }
}

});
parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("bFXjh", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $49axs = parcelRequire("49axs");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $880187c06210b759$var$pull = $9eFtX($49axs);
module.exports = $880187c06210b759$var$pull;

});
parcelRegister("49axs", function(module, exports) {

var $3cvRc = parcelRequire("3cvRc");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $30502d761f1085cf$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $3cvRc(array, values) : array;
}
module.exports = $30502d761f1085cf$var$pullAll;

});
parcelRegister("3cvRc", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $jkhuN = parcelRequire("jkhuN");

var $2Rm6I = parcelRequire("2Rm6I");

var $74vSq = parcelRequire("74vSq");

var $b69Sx = parcelRequire("b69Sx");
/** Used for built-in method references. */ var $254b343f3ff82813$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $254b343f3ff82813$var$splice = $254b343f3ff82813$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $254b343f3ff82813$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $2Rm6I : $jkhuN, index = -1, length = values.length, seen = array;
    if (array === values) values = $b69Sx(values);
    if (iteratee) seen = $kJvGp(array, $74vSq(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $254b343f3ff82813$var$splice.call(seen, fromIndex, 1);
            $254b343f3ff82813$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $254b343f3ff82813$var$basePullAll;

});
parcelRegister("2Rm6I", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2151ae143791d52b$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $2151ae143791d52b$var$baseIndexOfWith;

});




parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("k3YqD", function(module, exports) {

$parcel$export(module.exports, "ModalDialog", () => $d51f615726d59b7b$export$1fa217be60c2f188);

var $eUqFw = parcelRequire("eUqFw");

var $aOw1G = parcelRequire("aOw1G");

var $iVF7F = parcelRequire("iVF7F");
const $d51f615726d59b7b$export$1fa217be60c2f188 = ({ onCloseComplete: onCloseComplete, ...rest })=>{
    const returnFocusTarget = (0, $iVF7F.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $iVF7F.useModalDialogActions)();
    const handleCloseComplete = (0, $eUqFw.useCallback)((element)=>{
        onCloseComplete && onCloseComplete(element);
    }, [
        onCloseComplete
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            if (returnFocusTarget?.current) {
                returnFocusTarget.current.focus();
                setReturnFocusTo(null);
            }
        }, [
        returnFocusTarget,
        setReturnFocusTo
    ]);
    /**
	 * - If there's no returnFocusTarget, let ModalDialog
	 *   handle passing focus back on close when necessary
	 * - If returnFocusTarget is defined, we'll handle
	 *   passing focus back to this element
	 */ const shouldReturnFocus = !returnFocusTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        shouldReturnFocus: shouldReturnFocus,
        onCloseComplete: handleCloseComplete,
        ...rest
    });
};

});

parcelRegister("6DjyZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b3467d910a3ee06$export$2e2bcd8739ae039);

var $9ZgZk = parcelRequire("9ZgZk");
var $4b3467d910a3ee06$export$2e2bcd8739ae039 = (0, $9ZgZk.LogTimeModalFooter);

});
parcelRegister("9ZgZk", function(module, exports) {

$parcel$export(module.exports, "LogTimeModalFooter", () => $8e3c489e5a381033$export$4c7bef49d2c2ab55);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $4Bees = parcelRequire("4Bees");

var $4ksts = parcelRequire("4ksts");

var $25vUW = parcelRequire("25vUW");
const $8e3c489e5a381033$var$renderSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8e3c489e5a381033$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        interactionName: "issue-worklog-log-time-modal-spinner",
        size: "small"
    }));
const $8e3c489e5a381033$export$4c7bef49d2c2ab55 = (props)=>{
    const intl = (0, $4ksts.useIntlV2)();
    const { formState: formState, onConfirm: onConfirm, onCancel: onCancel } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8e3c489e5a381033$var$RightAligned, {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.common.component.log-time-modal.modal.footer"
    }, formState === 'submitting' ? $8e3c489e5a381033$var$renderSpinner() : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        interactionName: "issue-worklog",
        appearance: "primary",
        onClick: onConfirm,
        isDisabled: formState === 'invalid' || formState === 'submitting',
        testId: "issue.common.component.log-time-modal.modal.footer.save-button"
    }, intl.formatMessage((0, $25vUW.default).save)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onCancel,
        isDisabled: formState === 'submitting',
        interactionName: "auto-generated.jira-issue-view-common.component.log-time-modal.modal.footer.button"
    }, intl.formatMessage((0, $25vUW.default).cancel)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e3c489e5a381033$var$RightAligned = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1bahesu3 _4cvr1h6o _1bsb1osq _1dud1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e3c489e5a381033$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _3rss1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("25vUW", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d477a69b697bf28$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $3d477a69b697bf28$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    save: {
        "id": "issue.log-time.modal.log-time-action.save",
        "defaultMessage": "Save"
    },
    cancel: {
        "id": "issue.log-time.modal.log-time-action.cancel",
        "defaultMessage": "Cancel"
    }
});

});



parcelRegister("hw7ga", function(module, exports) {

$parcel$export(module.exports, "default", () => $774637fcab36a689$export$2e2bcd8739ae039);

var $4a20I = parcelRequire("4a20I");
var $774637fcab36a689$export$2e2bcd8739ae039 = (0, $4a20I.LogTimeModalForm);

});
parcelRegister("4a20I", function(module, exports) {

$parcel$export(module.exports, "LogTimeModalForm", () => $bfaff7e7a20fe432$export$f6449ffbfc2d90a1);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4LhB6 = parcelRequire("4LhB6");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4ksts = parcelRequire("4ksts");

var $9ndNs = parcelRequire("9ndNs");

var $8K9kM = parcelRequire("8K9kM");

var $4xHig = parcelRequire("4xHig");

var $8WZNN = parcelRequire("8WZNN");

var $ijSQY = parcelRequire("ijSQY");

var $eYjMq = parcelRequire("eYjMq");

var $5acJO = parcelRequire("5acJO");

var $f1Nss = parcelRequire("f1Nss");

var $cYqJB = parcelRequire("cYqJB");
const $bfaff7e7a20fe432$export$f6449ffbfc2d90a1 = ({ portalElement: portalElement, isCollapsed: isCollapsed, isDisabled: isDisabled, isTimeLoggedValid: isTimeLoggedValid, isTimeRemainingValid: isTimeRemainingValid, value: { timeLogged: timeLogged, timeRemaining: timeRemaining, dateStarted: dateStarted, workDescription: workDescription }, timeZone: timeZone, mediaContext: mediaContext, mentionEncoder: mentionEncoder, mentionProvider: mentionProvider, activityProvider: activityProvider, externalId: externalId, onTimeLoggedChange: onTimeLoggedChange, onTimeLoggedBlur: onTimeLoggedBlur, onTimeRemainingChange: onTimeRemainingChange, onTimeRemainingBlur: onTimeRemainingBlur, onDateStartedChange: onDateStartedChange, onWorkDescriptionChange: onWorkDescriptionChange, onWorkDescriptionChangeFailure: onWorkDescriptionChangeFailure })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const locale = (0, $4xHig.useLocale)();
    const weekStartDay = (0, $8K9kM.getLocale)(locale)?.options?.weekStartsOn;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bfaff7e7a20fe432$var$TimeFieldsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bfaff7e7a20fe432$var$TimeFieldContainer, {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "issue.common.component.log-time-modal.modal.form.time-spent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5acJO.default), {
        value: timeLogged,
        isDisabled: isDisabled,
        isValid: isTimeLoggedValid,
        onChange: onTimeLoggedChange,
        onBlur: onTimeLoggedBlur
    }), ' '), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bfaff7e7a20fe432$var$TimeFieldContainer // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-testid": "issue.common.component.log-time-modal.modal.form.time-remaining"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f1Nss.default), {
        value: timeRemaining,
        isDisabled: isDisabled,
        isValid: isTimeRemainingValid,
        onChange: onTimeRemainingChange,
        onBlur: onTimeRemainingBlur
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cYqJB.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bfaff7e7a20fe432$var$WorklogDetailsContainer, {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.common.component.log-time-modal.modal.form.worklog-details-container",
        isCollapsed: isCollapsed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $bfaff7e7a20fe432$var$dateStartedContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: "date-started",
        label: intl.formatMessage((0, $eYjMq.default).dateStarted),
        isRequired: true
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WZNN.default), {
            value: dateStarted || null,
            timeZone: timeZone,
            parseValue: (0, $9ndNs.parseDateTimeValue),
            onChange: onDateStartedChange,
            isDisabled: isDisabled,
            weekStartDay: weekStartDay,
            locale: locale
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijSQY.default), {
        defaultValue: workDescription,
        isDisabled: isDisabled,
        portalElement: portalElement,
        onChange: onWorkDescriptionChange,
        onChangeFailure: onWorkDescriptionChangeFailure,
        externalId: externalId,
        mediaContext: mediaContext,
        mentionProvider: mentionProvider,
        mentionEncoder: mentionEncoder,
        activityProvider: activityProvider
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bfaff7e7a20fe432$var$TimeFieldsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1y6m _1e0c1txw _2lx2vrvc _r1twu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bfaff7e7a20fe432$var$TimeFieldContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ssb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bfaff7e7a20fe432$var$WorklogDetailsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCollapsed: isCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isCollapsed ? "_1e0cglyw" : "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $bfaff7e7a20fe432$var$dateStartedContainerStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});

});
parcelRegister("4LhB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde75f35762e3dcb$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $gaA9C = parcelRequire("gaA9C");

var $lzLxZ = parcelRequire("lzLxZ");

var $6ROLN = parcelRequire("6ROLN");

var $jeetE = parcelRequire("jeetE");

var $2fFJv = parcelRequire("2fFJv");
function $dde75f35762e3dcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dde75f35762e3dcb$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $dde75f35762e3dcb$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $dde75f35762e3dcb$var$isFunction(x) {
    return typeof x === 'function';
}
function $dde75f35762e3dcb$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $dde75f35762e3dcb$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $dde75f35762e3dcb$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $lzLxZ.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $lzLxZ.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $dde75f35762e3dcb$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $dde75f35762e3dcb$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$dde75f35762e3dcb$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $dde75f35762e3dcb$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $dde75f35762e3dcb$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($dde75f35762e3dcb$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $dde75f35762e3dcb$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $jeetE.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});

parcelRegister("lzLxZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $35270e9129320e50$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $35270e9129320e50$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $35270e9129320e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $35270e9129320e50$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $35270e9129320e50$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $35270e9129320e50$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("6ROLN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7dbb02f7c217159b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $7dbb02f7c217159b$export$ed247974535929c7);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");
function $7dbb02f7c217159b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dbb02f7c217159b$var$fieldsetLabelStyles = {
    name: "1v8a0r4",
    styles: "display:inline-block;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $7dbb02f7c217159b$var$oldFieldsetLabelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N200)})`,
    fontWeight: "var(--ds-font-weight-semibold, 600)"
});
const $7dbb02f7c217159b$var$newFieldsetLabelStyles = {
    name: "1btbeoi",
    styles: "color:var(--ds-text-subtle, #44546F);font-weight:var(--ds-font-weight-bold, 700)"
};
const $7dbb02f7c217159b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: [
            $7dbb02f7c217159b$var$fieldsetLabelStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.form-label-typography-updates') ? $7dbb02f7c217159b$var$newFieldsetLabelStyles : $7dbb02f7c217159b$var$oldFieldsetLabelStyles
        ],
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $7dbb02f7c217159b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: [
            $7dbb02f7c217159b$var$fieldsetLabelStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.form-label-typography-updates') ? $7dbb02f7c217159b$var$newFieldsetLabelStyles : $7dbb02f7c217159b$var$oldFieldsetLabelStyles
        ]
    }, children);
};
var $7dbb02f7c217159b$export$2e2bcd8739ae039 = $7dbb02f7c217159b$export$b04be29aa201d4f5;

});

parcelRegister("jeetE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43a5e2537ba41ea$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $d43a5e2537ba41ea$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $PdmhA.R400)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d43a5e2537ba41ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d43a5e2537ba41ea$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("9ndNs", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeValue", () => $8eb80f465974f24a$export$30dbc3f5fc81f24a);

var $f9KE2 = parcelRequire("f9KE2");
var $7ueqz = parcelRequire("7ueqz");

var $4p54N = parcelRequire("4p54N");
var $bbmZl = parcelRequire("bbmZl");
const $8eb80f465974f24a$export$833d886b17f40fec = (intl, dateTime, timeZone)=>{
    if (!dateTime) return null;
    const dateFormat = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    };
    const options = timeZone ? {
        ...dateFormat,
        timeZone: timeZone
    } : {
        ...dateFormat
    };
    const unixTime = (0, $f9KE2.default)(new Date(dateTime));
    return intl.formatDate(unixTime, options);
};
const $8eb80f465974f24a$export$30dbc3f5fc81f24a = (dateTimeValue, fallbackDate, fallbackTime, timeZone)=>{
    const parsed = dateTimeValue !== null && dateTimeValue !== '' && timeZone && (0, $7ueqz.default)(new Date(dateTimeValue)) ? (0, $bbmZl.default)(dateTimeValue, timeZone) : null;
    return parsed !== null && timeZone && (0, $7ueqz.default)(parsed) ? {
        dateValue: (0, $4p54N.default)(parsed, 'yyyy-MM-dd', {
            timeZone: timeZone
        }),
        timeValue: (0, $4p54N.default)(parsed, 'HH:mm', {
            timeZone: timeZone
        }),
        zoneValue: (0, $4p54N.default)(parsed, 'XX', {
            timeZone: timeZone
        })
    } : {
        dateValue: fallbackDate,
        timeValue: fallbackTime,
        zoneValue: timeZone ? (0, $4p54N.default)(new Date(), 'XX', {
            timeZone: timeZone
        }) : null
    };
};

});

parcelRegister("4xHig", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $d8981c42d4d07028$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $d8981c42d4d07028$export$31652d9c30d7d3f3);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $ao0hp = parcelRequire("ao0hp");

var $gd0Sp = parcelRequire("gd0Sp");
const $d8981c42d4d07028$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $ao0hp.defaultLocale);
};
const $d8981c42d4d07028$export$31652d9c30d7d3f3 = ()=>{
    const locale = $d8981c42d4d07028$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $eUqFw.useMemo)(()=>(0, $ao0hp.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

parcelRegister("8WZNN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e2925c8a8a126dc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $21l2t = parcelRequire("21l2t");

var $ldoFd = parcelRequire("ldoFd");

var $3dY0o = parcelRequire("3dY0o");

var $iPvRp = parcelRequire("iPvRp");

var $gTWD6 = parcelRequire("gTWD6");

var $4fDms = parcelRequire("4fDms");

var $5JgJ2 = parcelRequire("5JgJ2");
const $3e2925c8a8a126dc$export$b0858ed42673b192 = ({ isDisabled: isDisabled = false, value: value, autoFocus: autoFocus = false, timeZone: timeZone, parseValue: parseValue, onChange: onChange, weekStartDay: weekStartDay, locale: locale = 'en-US' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onValChange = (0, $eUqFw.useCallback)((iso)=>{
        const convertedIso = (0, $4fDms.convertISODateFormat)(iso);
        onChange((0, (/*@__PURE__*/$parcel$interopDefault($21l2t)))(Date.parse(convertedIso)) ? null : convertedIso);
    }, [
        onChange
    ]);
    const parseValueWithTimeZone = (0, $eUqFw.useCallback)((val, date, time)=>parseValue(val, date, time, timeZone), [
        parseValue,
        timeZone
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dY0o.default), {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.common.component.legacy-date-time.date-time-picker",
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        value: value || '',
        onChange: onValChange,
        timeIsEditable: true,
        // @ts-expect-error - TS2322 - Type '((val: string | null, date: string | null, time: string | null) => { dateValue: string | null; timeValue: string | null; zoneValue: string | null; }) | undefined' is not assignable to type '((dateTimeValue: string, date: string, time: string, timezone: string) => { dateValue: string; timeValue: string; zoneValue: string; }) | undefined'.
        parseValue: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(timeZone) && timeZone !== '' ? parseValueWithTimeZone : undefined,
        datePickerSelectProps: {
            placeholder: formatMessage((0, $gTWD6.default).placeholderDate)
        },
        datePickerProps: {
            weekStartDay: weekStartDay
        },
        timePickerSelectProps: {
            formatCreateLabel: (val)=>val,
            // Want to show the dropdown option if the user input
            // matches the value (22:30) or the label (10:30pm)
            filterOption: (option, val)=>!val || option.value === val || option.label === val
        },
        times: (0, $iPvRp.default),
        /* only pass locale if feature flag is enabled */ locale: locale
    });
};
var $3e2925c8a8a126dc$export$2e2bcd8739ae039 = $3e2925c8a8a126dc$export$b0858ed42673b192;

});
parcelRegister("21l2t", function(module, exports) {

var $lzTt0 = parcelRequire("lzTt0");
/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $178bfea3ddcf2651$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $lzTt0(value) && value != +value;
}
module.exports = $178bfea3ddcf2651$var$isNaN;

});

parcelRegister("3dY0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $259121cb088f908b$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $EN9B6 = parcelRequire("EN9B6");
var $7ueqz = parcelRequire("7ueqz");
var $3xcI8 = parcelRequire("3xcI8");

var $8dloj = parcelRequire("8dloj");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $hUbUe = parcelRequire("hUbUe");

var $cEc3i = parcelRequire("cEc3i");

var $PdmhA = parcelRequire("PdmhA");

var $8ffDj = parcelRequire("8ffDj");

var $gIlSd = parcelRequire("gIlSd");

var $lwwPJ = parcelRequire("lwwPJ");

var $1iSiO = parcelRequire("1iSiO");

var $hzTQd = parcelRequire("hzTQd");
const $259121cb088f908b$var$packageName = "@atlaskit/datetime-picker";
const $259121cb088f908b$var$packageVersion = "13.5.2";
// Make DatePicker 50% the width of DateTimePicker
// If rendering an icon container, shrink the TimePicker
const $259121cb088f908b$var$datePickerContainerStyles = (0, $byn9U.css)({
    flexBasis: '50%',
    flexGrow: 1,
    flexShrink: 0
});
const $259121cb088f908b$var$timePickerContainerStyles = (0, $byn9U.css)({
    flexBasis: '50%',
    flexGrow: 1
});
const $259121cb088f908b$var$iconContainerStyles = (0, $byn9U.css)({
    display: 'flex',
    alignItems: 'center',
    flexBasis: 'inherit',
    backgroundColor: 'inherit',
    border: 'none',
    color: `var(--ds-text-subtlest, ${(0, $PdmhA.N70)})`,
    paddingBlockEnd: "var(--ds-space-075, 6px)",
    paddingBlockStart: "var(--ds-space-075, 6px)",
    paddingInlineEnd: "var(--ds-space-100, 8px)",
    paddingInlineStart: "var(--ds-space-050, 4px)",
    transition: `color 150ms`,
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`
    }
});
// react-select overrides (via @atlaskit/select).
const $259121cb088f908b$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $259121cb088f908b$var$dateTimePickerDefaultProps = {
    appearance: 'default',
    autoFocus: false,
    isDisabled: false,
    name: '',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{},
    /* eslint-enable @repo/internal/react/use-noop */ innerProps: {},
    id: '',
    defaultValue: '',
    timeIsEditable: false,
    isInvalid: false,
    datePickerProps: {},
    timePickerProps: {},
    datePickerSelectProps: {},
    timePickerSelectProps: {},
    times: (0, $8ffDj.defaultTimes),
    spacing: 'default',
    locale: 'en-US'
};
const $259121cb088f908b$export$3b559a1219cb3c27 = 'Date';
const $259121cb088f908b$export$d82cc7e53d68a428 = 'Time';
class $259121cb088f908b$export$732a1726f0a3523b extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            dateValue: '',
            isFocused: false,
            timeValue: '',
            value: this.props.defaultValue,
            zoneValue: ''
        });
        // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        (0, $5zQU9.default)(this, "getSafeState", ()=>{
            const mappedState = {
                ...this.state,
                ...(0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(this.props, [
                    'value'
                ])
            };
            return {
                ...mappedState,
                ...this.parseValue(mappedState.value, mappedState.dateValue, mappedState.timeValue, mappedState.zoneValue)
            };
        });
        (0, $5zQU9.default)(this, "onBlur", (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur(event);
        });
        (0, $5zQU9.default)(this, "onFocus", (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus(event);
        });
        (0, $5zQU9.default)(this, "onDateChange", (dateValue)=>{
            this.onValueChange({
                ...this.getSafeState(),
                dateValue: dateValue
            });
        });
        (0, $5zQU9.default)(this, "onTimeChange", (timeValue)=>{
            this.onValueChange({
                ...this.getSafeState(),
                timeValue: timeValue
            });
        });
        (0, $5zQU9.default)(this, "onClear", ()=>{
            this.onValueChange({
                ...this.getSafeState(),
                timeValue: '',
                dateValue: ''
            });
        });
    }
    parseValue(value, dateValue, timeValue, zoneValue) {
        if (this.props.parseValue) return this.props.parseValue(value, dateValue, timeValue, zoneValue);
        const parsed = (0, $3xcI8.default)(value);
        return (0, $7ueqz.default)(parsed) ? {
            dateValue: (0, $EN9B6.default)(parsed, (0, $lwwPJ.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $EN9B6.default)(parsed, (0, $lwwPJ.convertTokens)('HH:mm')),
            zoneValue: (0, $EN9B6.default)(parsed, (0, $lwwPJ.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }
    onValueChange({ dateValue: dateValue, timeValue: timeValue, zoneValue: zoneValue }) {
        this.setState({
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        });
        if (dateValue && timeValue) {
            const value = (0, $8ffDj.formatDateTimeZoneIntoIso)(dateValue, timeValue, zoneValue);
            const { zoneValue: parsedZone } = this.parseValue(value, dateValue, timeValue, zoneValue);
            const valueWithValidZone = (0, $8ffDj.formatDateTimeZoneIntoIso)(dateValue, timeValue, parsedZone);
            this.setState({
                value: valueWithValidZone
            });
            this.props.onChange(valueWithValidZone);
        // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (this.getSafeState().value) {
            this.setState({
                value: ''
            });
            this.props.onChange('');
        }
    }
    render() {
        const { autoFocus: autoFocus, id: id, innerProps: innerProps, isDisabled: isDisabled, name: name, timeIsEditable: timeIsEditable, dateFormat: dateFormat, datePickerProps: datePickerProps, datePickerSelectProps: datePickerSelectProps, timePickerProps: timePickerProps, timePickerSelectProps: timePickerSelectProps, times: times, timeFormat: timeFormat, locale: locale, testId: testId } = this.props;
        const { isFocused: isFocused, value: value, dateValue: dateValue, timeValue: timeValue } = this.getSafeState();
        const bothProps = {
            isDisabled: isDisabled,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            isInvalid: this.props.isInvalid,
            appearance: this.props.appearance,
            spacing: this.props.spacing
        };
        const { styles: datePickerStyles = {} } = datePickerSelectProps;
        const { styles: timePickerStyles = {} } = timePickerSelectProps;
        const mergedDatePickerSelectProps = {
            ...datePickerSelectProps,
            'aria-label': datePickerProps['label'] || datePickerSelectProps['aria-label'] || $259121cb088f908b$export$3b559a1219cb3c27,
            styles: (0, $cEc3i.m)($259121cb088f908b$var$styles, datePickerStyles)
        };
        const mergedTimePickerSelectProps = {
            ...timePickerSelectProps,
            'aria-label': timePickerProps['label'] || timePickerSelectProps['aria-label'] || $259121cb088f908b$export$d82cc7e53d68a428,
            styles: (0, $cEc3i.m)($259121cb088f908b$var$styles, timePickerStyles)
        };
        // Render DateTimePicker's IconContainer when a value has been filled
        // Don't use Date or TimePicker's because they can't be customised
        const isClearable = Boolean(dateValue || timeValue);
        return (0, $byn9U.jsx)((0, $gIlSd.DateTimePickerContainer), {
            appearance: bothProps.appearance,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isInvalid: bothProps.isInvalid,
            testId: testId,
            innerProps: innerProps
        }, (0, $byn9U.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), (0, $byn9U.jsx)("div", {
            css: $259121cb088f908b$var$datePickerContainerStyles
        }, (0, $byn9U.jsx)((0, $1iSiO.default), (0, $kU09D.default)({}, bothProps, {
            autoFocus: autoFocus,
            dateFormat: dateFormat,
            hideIcon: true,
            id: id,
            onChange: this.onDateChange,
            selectProps: mergedDatePickerSelectProps,
            value: dateValue,
            locale: locale,
            testId: testId && `${testId}--datepicker`
        }, datePickerProps))), (0, $byn9U.jsx)("div", {
            css: $259121cb088f908b$var$timePickerContainerStyles
        }, (0, $byn9U.jsx)((0, $hzTQd.default), (0, $kU09D.default)({}, bothProps, {
            hideIcon: true,
            onChange: this.onTimeChange,
            selectProps: mergedTimePickerSelectProps,
            value: timeValue,
            timeIsEditable: timeIsEditable,
            times: times,
            timeFormat: timeFormat,
            locale: locale,
            testId: testId && `${testId}--timepicker`
        }, timePickerProps))), isClearable && !isDisabled ? (0, $byn9U.jsx)("button", {
            css: $259121cb088f908b$var$iconContainerStyles,
            onClick: this.onClear,
            "data-testid": testId && `${testId}--icon--container`,
            tabIndex: -1,
            type: "button"
        }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
            size: "small",
            primaryColor: "inherit",
            label: "clear"
        })) : null);
    }
}
(0, $5zQU9.default)($259121cb088f908b$export$732a1726f0a3523b, "defaultProps", $259121cb088f908b$var$dateTimePickerDefaultProps);
var $259121cb088f908b$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'dateTimePicker',
    packageName: $259121cb088f908b$var$packageName,
    packageVersion: $259121cb088f908b$var$packageVersion
})((0, $2jDha.default)({
    onChange: (0, $hM7RE.default)('atlaskit')({
        action: 'changed',
        actionSubject: 'dateTimePicker',
        attributes: {
            componentName: 'dateTimePicker',
            packageName: $259121cb088f908b$var$packageName,
            packageVersion: $259121cb088f908b$var$packageVersion
        }
    })
})($259121cb088f908b$export$732a1726f0a3523b));

});
parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d090e6e9cc89e346$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="9"/><path d="M16.155 14.493a1.174 1.174 0 11-1.662 1.663L12 13.662l-2.494 2.494a1.172 1.172 0 01-1.662 0 1.176 1.176 0 010-1.663L10.337 12 7.844 9.507a1.176 1.176 0 011.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 111.662 1.662L13.662 12l2.493 2.493z" fill="inherit"/></g></svg>`
    }, props));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = $d090e6e9cc89e346$var$SelectClearIcon;
module.exports.default = $d090e6e9cc89e346$var$_default;

});

parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $aM0Ke.default)(descriptor.key), descriptor);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $fcfd452a83bb612a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fcfd452a83bb612a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $c2pQl.default)(subClass, superClass);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $8c5pC.default)();
    return function _createSuperInternal() {
        var Super = (0, $i3rTN.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $i3rTN.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $4mIeV.default)(this, result);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(o) {
    $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039(o);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $5sKOb.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(self);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(arr) {
    return (0, $b7OIr.default)(arr) || (0, $2B3l3.default)(arr) || (0, $e5SQy.default)(arr) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $aLrjs.default)(arr);
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $aLrjs.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $aLrjs.default)(o, minLen);
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(arr, i) {
    return (0, $kcDiK.default)(arr) || (0, $61Jn4.default)(arr, i) || (0, $e5SQy.default)(arr, i) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});



parcelRegister("8ffDj", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $600bd9d2d78eacf5$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $600bd9d2d78eacf5$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $600bd9d2d78eacf5$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $600bd9d2d78eacf5$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $600bd9d2d78eacf5$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $600bd9d2d78eacf5$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $600bd9d2d78eacf5$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $600bd9d2d78eacf5$export$5e30e9a24d6c1203 = ()=>null;
const $600bd9d2d78eacf5$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $600bd9d2d78eacf5$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $600bd9d2d78eacf5$export$9e6d8fcf62256b85 = 'h:mma';
const $600bd9d2d78eacf5$export$75032c84f56650eb = 'YYYY/MM/DD';
function $600bd9d2d78eacf5$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $600bd9d2d78eacf5$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("gIlSd", function(module, exports) {

$parcel$export(module.exports, "DateTimePickerContainer", () => $c2b1b90147531968$export$83034b1f07ab0b20);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $c2b1b90147531968$var$isInvalidBorderStyles = (0, $byn9U.css)({
    borderColor: `var(--ds-border-danger, ${(0, $PdmhA.R400)})`
});
const $c2b1b90147531968$var$isFocusedBorderStyles = (0, $byn9U.css)({
    borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B100)})`
});
const $c2b1b90147531968$var$isFocusedStyles = (0, $byn9U.css)({
    backgroundColor: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`
});
const $c2b1b90147531968$var$subtleBgStyles = (0, $byn9U.css)({
    backgroundColor: 'transparent',
    borderColor: 'transparent'
});
const $c2b1b90147531968$var$subtleFocusedBgStyles = (0, $byn9U.css)({
    backgroundColor: "var(--ds-background-input-pressed, transparent)",
    borderColor: 'transparent'
});
const $c2b1b90147531968$var$noBgStyles = (0, $byn9U.css)({
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    '&:hover': {
        backgroundColor: 'transparent',
        borderColor: 'transparent'
    }
});
const $c2b1b90147531968$var$hoverStyles = (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
        borderColor: `var(--ds-border-input, ${(0, $PdmhA.N100)})`
    }
});
const $c2b1b90147531968$var$isInvalidHoverStyles = (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-input-hovered, ${(0, $PdmhA.N0)})`,
        borderColor: `var(--ds-border-danger, ${(0, $PdmhA.R400)})`
    }
});
const $c2b1b90147531968$var$isDisabledStyles = (0, $byn9U.css)({
    '&:hover': {
        cursor: 'default'
    }
});
const $c2b1b90147531968$var$newBorderStyles = (0, $byn9U.css)({
    border: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-input, ${(0, $PdmhA.N100)})`}`
});
const $c2b1b90147531968$var$baseContainerStyles = (0, $byn9U.css)({
    display: 'flex',
    backgroundColor: `var(--ds-background-input, ${(0, $PdmhA.N20)})`,
    border: `2px solid ${`var(--ds-border-input, ${(0, $PdmhA.N20)})`}`,
    borderRadius: "var(--ds-border-radius, 3px)",
    transition: 'background-color 200ms ease-in-out, border-color 200ms ease-in-out',
    '&:hover': {
        cursor: 'pointer'
    }
});
const $c2b1b90147531968$export$83034b1f07ab0b20 = ({ isDisabled: isDisabled, isFocused: isFocused, appearance: appearance, isInvalid: isInvalid, innerProps: innerProps, testId: testId, children: children })=>{
    const notFocusedOrIsDisabled = !(isFocused || isDisabled);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        css: [
            $c2b1b90147531968$var$baseContainerStyles,
            $c2b1b90147531968$var$newBorderStyles,
            isDisabled && $c2b1b90147531968$var$isDisabledStyles,
            isFocused && $c2b1b90147531968$var$isFocusedStyles,
            appearance === 'subtle' && (isFocused ? $c2b1b90147531968$var$subtleFocusedBgStyles : $c2b1b90147531968$var$subtleBgStyles),
            isFocused && $c2b1b90147531968$var$isFocusedBorderStyles,
            isInvalid && $c2b1b90147531968$var$isInvalidBorderStyles,
            notFocusedOrIsDisabled && (isInvalid ? $c2b1b90147531968$var$isInvalidHoverStyles : $c2b1b90147531968$var$hoverStyles),
            appearance === 'none' && $c2b1b90147531968$var$noBgStyles
        ]
    }, innerProps, {
        "data-testid": testId
    }), children);
};

});

parcelRegister("lwwPJ", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $fab60e2a6619ae46$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $fab60e2a6619ae46$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $fab60e2a6619ae46$var$v1tokens = Object.keys($fab60e2a6619ae46$var$tokensMap).sort().reverse();
const $fab60e2a6619ae46$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$fab60e2a6619ae46$var$v1tokens.join('|') + '|.)', 'g');
function $fab60e2a6619ae46$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($fab60e2a6619ae46$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $fab60e2a6619ae46$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});

parcelRegister("1iSiO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f319839eb9c9f11$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $EN9B6 = parcelRequire("EN9B6");
var $7ueqz = parcelRequire("7ueqz");
var $eztWc = parcelRequire("eztWc");
var $3xcI8 = parcelRequire("3xcI8");

var $8dloj = parcelRequire("8dloj");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $kMHOY = parcelRequire("kMHOY");

var $1YVlj = parcelRequire("1YVlj");

var $XHGTv = parcelRequire("XHGTv");

var $4zgIJ = parcelRequire("4zgIJ");
var $cEc3i = parcelRequire("cEc3i");

var $8ffDj = parcelRequire("8ffDj");

var $41fcw = parcelRequire("41fcw");

var $8upjz = parcelRequire("8upjz");

var $lwwPJ = parcelRequire("lwwPJ");

var $45taO = parcelRequire("45taO");
const $0f319839eb9c9f11$var$packageName = "@atlaskit/datetime-picker";
const $0f319839eb9c9f11$var$packageVersion = "13.5.2";
const $0f319839eb9c9f11$var$datePickerDefaultProps = {
    appearance: 'default',
    autoFocus: false,
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    hideIcon: false,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))),
    id: '',
    innerProps: {},
    isDisabled: false,
    isInvalid: false,
    label: '',
    name: '',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{},
    /* eslint-enable @repo/internal/react/use-noop */ selectProps: {},
    spacing: 'default',
    locale: 'en-US'
};
class $0f319839eb9c9f11$export$df43d21f5faca9f7 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        (0, $5zQU9.default)(this, "calendarRef", null);
        (0, $5zQU9.default)(this, "containerRef", null);
        // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        (0, $5zQU9.default)(this, "getSafeState", ()=>{
            return {
                ...this.state,
                ...(0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(this.props, [
                    'value',
                    'isOpen'
                ]),
                ...(0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(this.props.selectProps, [
                    'inputValue'
                ])
            };
        });
        (0, $5zQU9.default)(this, "isDateDisabled", (date)=>{
            return this.props.disabled.indexOf(date) > -1;
        });
        (0, $5zQU9.default)(this, "onCalendarChange", ({ iso: iso })=>{
            const [year, month, date] = iso.split('-');
            let newIso = iso;
            const parsedDate = parseInt(date, 10);
            const parsedMonth = parseInt(month, 10);
            const parsedYear = parseInt(year, 10);
            const lastDayInMonth = (0, $eztWc.default)(new Date(parsedYear, parsedMonth - 1) // This needs to be -1, because the Date constructor expects an index of the given month
            ).getDate();
            if (lastDayInMonth < parsedDate) newIso = `${year}-${(0, $8ffDj.padToTwo)(parsedMonth)}-${(0, $8ffDj.padToTwo)(lastDayInMonth)}`;
            else newIso = `${year}-${(0, $8ffDj.padToTwo)(parsedMonth)}-${(0, $8ffDj.padToTwo)(parsedDate)}`;
            this.setState({
                calendarValue: newIso
            });
        });
        (0, $5zQU9.default)(this, "onCalendarSelect", ({ iso: iso })=>{
            var _this$containerRef;
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso
            });
            this.props.onChange(iso);
            // Not ideal, and the alternative is to place a ref on the inner input of the Select
            // but that would require a lot of extra work on the Select component just for this
            // focus functionality. While that would be the 'right react' way to do it, it doesnt
            // post any other benefits; performance wise, we are only searching within the
            // container, making it quick.
            const innerCombobox = (_this$containerRef = this.containerRef) === null || _this$containerRef === void 0 ? void 0 : _this$containerRef.querySelector('[role="combobox"]');
            innerCombobox === null || innerCombobox === void 0 || innerCombobox.focus();
            this.setState({
                isOpen: false
            });
        });
        (0, $5zQU9.default)(this, "onInputClick", ()=>{
            if (!this.props.isDisabled && !this.getSafeState().isOpen) this.setState({
                isOpen: true
            });
        });
        (0, $5zQU9.default)(this, "onContainerBlur", (event)=>{
            var _this$containerRef2;
            const newlyFocusedElement = event.relatedTarget;
            if (!((_this$containerRef2 = this.containerRef) !== null && _this$containerRef2 !== void 0 && _this$containerRef2.contains(newlyFocusedElement))) {
                this.setState({
                    isOpen: false
                });
                this.props.onBlur(event);
            }
        });
        (0, $5zQU9.default)(this, "onSelectBlur", (event)=>{
            var _this$containerRef3;
            const newlyFocusedElement = event.relatedTarget;
            if (this.getSafeState().clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!((_this$containerRef3 = this.containerRef) !== null && _this$containerRef3 !== void 0 && _this$containerRef3.contains(newlyFocusedElement))) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false
            });
        });
        (0, $5zQU9.default)(this, "onSelectFocus", (event)=>{
            const { clearingFromIcon: clearingFromIcon, value: value } = this.getSafeState();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                isOpen: true,
                calendarValue: value,
                isFocused: true
            });
            this.props.onFocus(event);
        });
        (0, $5zQU9.default)(this, "onTextInput", (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = this.parseDate(inputValue);
                // Only try to set the date if we have month & day
                if (parsed && (0, $7ueqz.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $8upjz.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true
            });
        });
        (0, $5zQU9.default)(this, "onInputKeyDown", (event)=>{
            var _this$containerRef4;
            const { value: value, calendarValue: calendarValue } = this.getSafeState();
            const keyPressed = event.key.toLowerCase();
            // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    const innerCombobox = (_this$containerRef4 = this.containerRef) === null || _this$containerRef4 === void 0 ? void 0 : _this$containerRef4.querySelector('[role="combobox"]');
                    innerCombobox === null || innerCombobox === void 0 || innerCombobox.focus();
                    this.setState({
                        isOpen: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = (0, $XHGTv.getBooleanFF)('platform.design-system-team.date-picker-input-a11y-fix_cbbxs') ? 1 : 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                    // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!this.isDateDisabled(calendarValue)) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $8upjz.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                default:
                    break;
            }
        });
        (0, $5zQU9.default)(this, "onClear", ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $8upjz.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        });
        (0, $5zQU9.default)(this, "onSelectChange", (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        });
        (0, $5zQU9.default)(this, "refCalendar", (ref)=>{
            this.calendarRef = ref;
        });
        (0, $5zQU9.default)(this, "handleSelectInputChange", (selectInputValue, actionMeta)=>{
            const { onInputChange: onInputChange } = this.props.selectProps;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        });
        (0, $5zQU9.default)(this, "getContainerRef", (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref;
            // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        });
        /**
     * There are two props that can change how the date is parsed.
     * The priority of props used is:
     *   1. `parseInputValue`
     *   2. `locale`
     */ (0, $5zQU9.default)(this, "parseDate", (date)=>{
            const { parseInputValue: parseInputValue, dateFormat: dateFormat } = this.props;
            if (parseInputValue) return parseInputValue(date, dateFormat || (0, $8ffDj.defaultDateFormat));
            const { l10n: l10n } = this.getSafeState();
            return l10n.parseDate(date);
        });
        /**
     * There are multiple props that can change how the date is formatted.
     * The priority of props used is:
     *   1. `formatDisplayLabel`
     *   2. `dateFormat`
     *   3. `locale`
     */ (0, $5zQU9.default)(this, "formatDate", (value)=>{
            const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat } = this.props;
            const { l10n: l10n } = this.getSafeState();
            if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $8ffDj.defaultDateFormat));
            const date = (0, $3xcI8.default)(value);
            return dateFormat ? (0, $EN9B6.default)(date, (0, $lwwPJ.convertTokens)(dateFormat)) : l10n.formatDate(date);
        });
        (0, $5zQU9.default)(this, "getPlaceholder", ()=>{
            const { placeholder: placeholder } = this.props;
            if (placeholder) return placeholder;
            const { l10n: l10n } = this.getSafeState();
            return l10n.formatDate((0, $8ffDj.placeholderDatetime));
        });
        this.state = {
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $8upjz.getShortISOString)(new Date()),
            l10n: (0, $1YVlj.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $1YVlj.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance, autoFocus: autoFocus, disabled: disabled, hideIcon: hideIcon, icon: icon, id: id, innerProps: innerProps, isDisabled: isDisabled, disabledDateFilter: disabledDateFilter, maxDate: maxDate, minDate: minDate, isInvalid: isInvalid, label: label, name: name, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps, spacing: spacing, locale: locale, testId: testId, weekStartDay: weekStartDay } = this.props;
        const { value: value, calendarValue: calendarValue, isOpen: isOpen, selectInputValue: selectInputValue } = this.getSafeState();
        let actualSelectInputValue;
        if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.date-picker-input-a11y-fix_cbbxs')) actualSelectInputValue = selectInputValue || (value ? this.formatDate(value) : undefined);
        else actualSelectInputValue = selectInputValue;
        const menuIsOpen = isOpen && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : icon;
        const SingleValue = (0, $45taO.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: dropDownIcon,
            Menu: $41fcw.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $8ffDj.EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarRef: this.refCalendar,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarValue: value && (0, $8upjz.getShortISOString)((0, $3xcI8.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            nextMonthLabel: nextMonthLabel,
            previousMonthLabel: previousMonthLabel
        };
        return(// These event handlers must be on this element because the events come
        // from different child elements.
        (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, innerProps, {
            role: "presentation",
            onBlur: this.onContainerBlur,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`
        }), (0, $byn9U.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), (0, $byn9U.jsx)((0, $4zgIJ.default), (0, $kU09D.default)({
            "aria-label": label || undefined,
            appearance: this.props.appearance,
            enableAnimation: false,
            menuIsOpen: menuIsOpen,
            closeMenuOnSelect: true,
            autoFocus: autoFocus,
            inputId: id,
            isDisabled: isDisabled,
            onBlur: this.onSelectBlur,
            onFocus: this.onSelectFocus,
            inputValue: actualSelectInputValue,
            onInputChange: this.handleSelectInputChange,
            components: selectComponents,
            onChange: this.onSelectChange,
            styles: (0, $cEc3i.m)(selectStyles, {
                control: (base)=>({
                        ...base,
                        ...disabledStyle
                    }),
                indicatorsContainer: (base)=>({
                        ...base,
                        paddingLeft: "var(--ds-space-025, 2px)",
                        // ICON_PADDING = 2
                        paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                    })
            }),
            placeholder: this.getPlaceholder(),
            value: value && {
                label: this.formatDate(value),
                value: value
            }
        }, selectProps, calendarProps, {
            isClearable: true,
            spacing: spacing,
            isInvalid: isInvalid,
            testId: testId
        }))));
    }
}
(0, $5zQU9.default)($0f319839eb9c9f11$export$df43d21f5faca9f7, "defaultProps", $0f319839eb9c9f11$var$datePickerDefaultProps);
var $0f319839eb9c9f11$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'datePicker',
    packageName: $0f319839eb9c9f11$var$packageName,
    packageVersion: $0f319839eb9c9f11$var$packageVersion
})((0, $2jDha.default)({
    onChange: (0, $hM7RE.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $0f319839eb9c9f11$var$packageName,
            packageVersion: $0f319839eb9c9f11$var$packageVersion
        }
    })
})($0f319839eb9c9f11$export$df43d21f5faca9f7));

});
parcelRegister("kMHOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f21a4850a620a60b$var$_react = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $f21a4850a620a60b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $f21a4850a620a60b$var$CalendarIcon = (props)=>/*#__PURE__*/ $f21a4850a620a60b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0119.005 21H4.995A1.995 1.995 0 013 19.006V6.994C3 5.893 3.892 5 4.995 5zM5 9v9a1 1 0 001 1h12a1 1 0 001-1V9H5zm1-5a1 1 0 012 0v1H6V4zm10 0a1 1 0 012 0v1h-2V4zm-9 9v-2.001h2V13H7zm8 0v-2.001h2V13h-2zm-4 0v-2.001h2.001V13H11zm-4 4v-2h2v2H7zm4 0v-2h2.001v2H11zm4 0v-2h2v2h-2z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$f21a4850a620a60b$var$CalendarIcon.displayName = 'CalendarIcon';
var $f21a4850a620a60b$var$_default = $f21a4850a620a60b$var$CalendarIcon;
module.exports.default = $f21a4850a620a60b$var$_default;

});

parcelRegister("1YVlj", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $1717e01c46c2b2f2$export$ea56ca58f08ffa52);

var $kbg6b = parcelRequire("kbg6b");

var $2Jl3T = parcelRequire("2Jl3T");

var $4twMe = parcelRequire("4twMe");
const $1717e01c46c2b2f2$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $kbg6b.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date)=>(0, $2Jl3T.createDateParser)(normalizedLocale)(date);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $4twMe.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $4twMe.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("kbg6b", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $eb11529d294fa9b6$export$dca0327c9b9c6498);
const $eb11529d294fa9b6$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("2Jl3T", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $1fd01f2ebb18e640$export$cfa2ef2687faeda2);

var $54DsY = parcelRequire("54DsY");

var $kbg6b = parcelRequire("kbg6b");
const $1fd01f2ebb18e640$var$INVALID_DATE = new Date(NaN);
const $1fd01f2ebb18e640$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $1fd01f2ebb18e640$var$INVARIANT_DATE = (0, $54DsY.toDate)($1fd01f2ebb18e640$var$INVARIANT);
const $1fd01f2ebb18e640$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $1fd01f2ebb18e640$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $1fd01f2ebb18e640$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $1fd01f2ebb18e640$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $1fd01f2ebb18e640$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $kbg6b.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($1fd01f2ebb18e640$var$INVARIANT_DATE);
    const shortDate = $1fd01f2ebb18e640$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($1fd01f2ebb18e640$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $1fd01f2ebb18e640$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($1fd01f2ebb18e640$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($1fd01f2ebb18e640$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($1fd01f2ebb18e640$var$INVARIANT.day);
    return (date)=>{
        const dateMatch = $1fd01f2ebb18e640$var$stripExtras(date).match($1fd01f2ebb18e640$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $1fd01f2ebb18e640$var$INVALID_DATE;
        const dateParts = $1fd01f2ebb18e640$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $54DsY.normalizeDate)(extractedDate);
        if (!(0, $54DsY.isValid)(normalizedDate)) return $1fd01f2ebb18e640$var$INVALID_DATE;
        return (0, $54DsY.toDate)(normalizedDate);
    };
};

});
parcelRegister("54DsY", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $3b1bf0ac5bd26705$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $3b1bf0ac5bd26705$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $3b1bf0ac5bd26705$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $3b1bf0ac5bd26705$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $3b1bf0ac5bd26705$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $3b1bf0ac5bd26705$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $3b1bf0ac5bd26705$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $3b1bf0ac5bd26705$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $3b1bf0ac5bd26705$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $3b1bf0ac5bd26705$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $3b1bf0ac5bd26705$export$fcc71269590ba0a8 = (date)=>{
    const now = $3b1bf0ac5bd26705$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("4twMe", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $34234baa644c70d6$export$9b7ca29af37c192);
/**
 * Converts the output of Intl.DateTimeFormat.formatToParts of type
 * `[ { type: 'day', value: '17' }, { type: 'month', value: '3' }, ... ]`
 * into an indexed object of type
 * `{ day: '17', month: '3', ... }`
 */ const $34234baa644c70d6$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("4zgIJ", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $353766a5f3567da9$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $353766a5f3567da9$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $bSpUS = parcelRequire("bSpUS");
const $353766a5f3567da9$var$packageName = "@atlaskit/select";
const $353766a5f3567da9$var$packageVersion = "17.10.3";
const $353766a5f3567da9$export$d1de3b251ccaa8a3 = (0, $bSpUS.default)((0, $hOLnS.default));
const $353766a5f3567da9$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $353766a5f3567da9$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $353766a5f3567da9$var$packageName,
    packageVersion: $353766a5f3567da9$var$packageVersion
})((0, $2jDha.default)({
    onChange: $353766a5f3567da9$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $353766a5f3567da9$var$packageName,
            packageVersion: $353766a5f3567da9$var$packageVersion
        }
    })
})($353766a5f3567da9$export$d1de3b251ccaa8a3));
var $353766a5f3567da9$export$2e2bcd8739ae039 = $353766a5f3567da9$var$Select;

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});
parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});


parcelRegister("bSpUS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a58d753f95a2c37$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $7x3Wj = parcelRequire("7x3Wj");

var $aJeUU = parcelRequire("aJeUU");

var $aFMcT = parcelRequire("aFMcT");
var $eJRxm = parcelRequire("eJRxm");

var $9zvxA = parcelRequire("9zvxA");

var $14QBq = parcelRequire("14QBq");
function $8a58d753f95a2c37$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: // TODO: set to true when cleaning up validationState prop so it has a default value
        onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $aFMcT.ClearIndicator,
                DropdownIndicator: $aFMcT.DropdownIndicator,
                LoadingIndicator: $aFMcT.LoadingIndicator,
                MultiValueRemove: $eJRxm.MultiValueRemove,
                IndicatorSeparator: $eJRxm.IndicatorSeparator,
                Input: $7x3Wj.Input,
                NoOptionsMessage: $aJeUU.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                var _internalSelectRef$cu;
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.inputRef;
                const ariaDescribedby = input === null || input === void 0 ? void 0 : input.getAttribute('aria-describedby');
                if (!(ariaDescribedby !== null && ariaDescribedby !== void 0 && ariaDescribedby.includes(descriptionId))) input === null || input === void 0 || input.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>{
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.focus();
                },
                blur: ()=>{
                    var _internalSelectRef$cu3;
                    return (_internalSelectRef$cu3 = internalSelectRef.current) === null || _internalSelectRef$cu3 === void 0 ? void 0 : _internalSelectRef$cu3.blur();
                }
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, (0, $kU09D.default)({
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $14QBq.isOptionsGrouped)(props.options) ? {
                onFocus: $14QBq.onFocus,
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault
        }, restProps, {
            components: components,
            styles: (0, $cEc3i.m)((0, $9zvxA.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        }));
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("7x3Wj", function(module, exports) {

$parcel$export(module.exports, "Input", () => $57beabc53b2d76c7$export$f5b8910cec6cf069);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $57beabc53b2d76c7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, (0, $kU09D.default)({}, props, {
        "aria-describedby": ariaDescribedByAttribute
    }));
}

});

parcelRegister("aJeUU", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $7cf9ad8f3c8c40dc$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
const $7cf9ad8f3c8c40dc$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, props.children || `No options`));
};

});

parcelRegister("aFMcT", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $7c53209aa704d850$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $7c53209aa704d850$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $7c53209aa704d850$export$7c20be4c1d342248);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $hUbUe = parcelRequire("hUbUe");

var $86Ndv = parcelRequire("86Ndv");
const $7c53209aa704d850$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center'
});
const $7c53209aa704d850$export$ecf9cf59142dd54a = (props)=>(0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, (0, $kU09D.default)({}, props, {
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }), (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $7c53209aa704d850$var$iconContainerStyles,
        tabIndex: -1
    }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
        size: "small",
        label: "clear"
    })));
const $7c53209aa704d850$export$ec98719d3db7f2e4 = (props)=>(0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: "open"
    }));
const $7c53209aa704d850$export$7c20be4c1d342248 = (props)=>{
    const loadingStyles = (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        css: loadingStyles
    }, props.innerProps), (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});

parcelRegister("eJRxm", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $abaecc0021fde121$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $abaecc0021fde121$export$bd638c2ba7915668);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $hUbUe = parcelRequire("hUbUe");

var $jQxSL = parcelRequire("jQxSL");

var $aFMcT = parcelRequire("aFMcT");
const $abaecc0021fde121$var$disabledStyles = (0, $byn9U.css)({
    display: 'none'
});
const $abaecc0021fde121$var$enabledStyles = (0, $byn9U.css)({
    display: 'inherit'
});
const $abaecc0021fde121$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    return (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, (0, $byn9U.jsx)("div", {
        css: isDisabled ? $abaecc0021fde121$var$disabledStyles : $abaecc0021fde121$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
        label: "Clear",
        size: "small",
        primaryColor: "transparent",
        secondaryColor: "inherit"
    })));
};
const $abaecc0021fde121$export$bd638c2ba7915668 = null;

});

parcelRegister("9zvxA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f7fd9434fadab88$export$2e2bcd8739ae039);

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");
function $6f7fd9434fadab88$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') ? {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                } : {
                    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                },
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : `var(--ds-border-input, ${0, $PdmhA.N100})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input, ${0, $PdmhA.N20})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $PdmhA.N20})`;
                borderColor = `var(--ds-background-disabled, ${0, $PdmhA.N20})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $PdmhA.R400})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $PdmhA.G400})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : `var(--ds-border-input, ${0, $PdmhA.N100})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $PdmhA.R400})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $PdmhA.G400})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $PdmhA.N0})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $PdmhA.N70})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $PdmhA.N500})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $PdmhA.N200})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $PdmhA.N800)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $PdmhA.B400})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $PdmhA.B50})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $PdmhA.B50})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N20})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $PdmhA.B400})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $PdmhA.N20})` : `var(--ds-background-neutral-subtle-pressed, ${0, $PdmhA.N30})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N300})` : `var(--ds-text-subtlest, ${0, $PdmhA.N200})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N70})` : `var(--ds-text, ${0, $PdmhA.N800})`,
                ...!(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') && {
                    lineHeight: '1rem'
                }
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $PdmhA.N40})`;
                color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $PdmhA.N40})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = `var(--ds-background-neutral, ${0, $PdmhA.N40})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N70})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)"
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $PdmhA.R75})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $PdmhA.R75})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $PdmhA.R75})`,
                    fill: "var(--ds-text-danger, #000)"
                }
            }),
        groupHeading: (css)=>({
                ...css,
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                },
                color: `var(--ds-text-subtle, ${0, $PdmhA.N200})`
            })
    };
}

});

parcelRegister("14QBq", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $0c8ef7f89b1c748a$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $0c8ef7f89b1c748a$export$d2756249f53f9f8);
// Used for overwriting ariaLiveMessages builtin onFocus method.
// Returns custom built string while focusing each group option. This string is used for screen reader announcement.
function $0c8ef7f89b1c748a$export$ecf9bf35ad97eb74(props) {
    var _groupData$options$fi;
    const { focused: focused, options: options } = props;
    const isOptionFocused = (option)=>{
        return option === focused;
    };
    const groupData = options === null || options === void 0 ? void 0 : options.find((option)=>{
        var _option$options;
        return (_option$options = option.options) === null || _option$options === void 0 ? void 0 : _option$options.some(isOptionFocused);
    });
    const groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
    return `Option ${focused.label}, ${groupData === null || groupData === void 0 ? void 0 : groupData.label} group, item ${groupOptionIndex + 1} out of ${groupData === null || groupData === void 0 ? void 0 : groupData.options.length}. All in all `;
}
const $0c8ef7f89b1c748a$export$d2756249f53f9f8 = (arr)=>{
    return arr === null || arr === void 0 ? void 0 : arr.every((obj)=>obj.hasOwnProperty('options'));
};

});



parcelRegister("41fcw", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $2ed30c03c0d65b16$export$d9b273488cd8ce6f);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $7ueqz = parcelRequire("7ueqz");
var $3xcI8 = parcelRequire("3xcI8");

var $jeicu = parcelRequire("jeicu");

var $etCs9 = parcelRequire("etCs9");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $cZF0W = parcelRequire("cZF0W");
function $2ed30c03c0d65b16$var$getValidDate(iso) {
    const date = (0, $3xcI8.default)(iso);
    return (0, $7ueqz.default)(date) ? {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    } : {};
}
const $2ed30c03c0d65b16$var$menuStyles = (0, $byn9U.css)({
    zIndex: (0, $lcnyw.layers).dialog(),
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`,
    overflow: 'hidden'
});
const $2ed30c03c0d65b16$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>(0, $byn9U.jsx)((0, $etCs9.UNSAFE_LAYERING), {
        isDisabled: (0, $XHGTv.getBooleanFF)('platform.design-system-team.layering_qmiw3') ? false : true
    }, (0, $byn9U.jsx)((0, $cZF0W.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.calendarContainerRef,
        content: (0, $byn9U.jsx)("div", (0, $kU09D.default)({
            css: $2ed30c03c0d65b16$var$menuStyles
        }, innerProps), (0, $byn9U.jsx)((0, $jeicu.default), (0, $kU09D.default)({}, $2ed30c03c0d65b16$var$getValidDate(selectProps.calendarValue), $2ed30c03c0d65b16$var$getValidDate(selectProps.calendarView), {
            disabled: selectProps.calendarDisabled,
            disabledDateFilter: selectProps.calendarDisabledDateFilter,
            minDate: selectProps.calendarMinDate,
            maxDate: selectProps.calendarMaxDate,
            nextMonthLabel: selectProps.nextMonthLabel,
            onChange: selectProps.onCalendarChange,
            onSelect: selectProps.onCalendarSelect,
            previousMonthLabel: selectProps.previousMonthLabel,
            calendarRef: selectProps.calendarRef,
            selected: [
                selectProps.calendarValue
            ],
            locale: selectProps.calendarLocale,
            testId: selectProps.testId && `${selectProps.testId}--calendar`,
            weekStartDay: selectProps.calendarWeekStartDay
        }))),
        testId: selectProps.testId
    }));

});
parcelRegister("jeicu", function(module, exports) {

$parcel$export(module.exports, "default", () => $dffd715f033d8cee$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $bzQ1M = parcelRequire("bzQ1M");

var $dGk8h = parcelRequire("dGk8h");

var $3MsT7 = parcelRequire("3MsT7");

var $kvezr = parcelRequire("kvezr");

var $dzwUo = parcelRequire("dzwUo");

var $gS7RT = parcelRequire("gS7RT");

var $jTPbp = parcelRequire("jTPbp");

var $glQu8 = parcelRequire("glQu8");

var $ewAFV = parcelRequire("ewAFV");

var $2gDa3 = parcelRequire("2gDa3");

var $6Z8Du = parcelRequire("6Z8Du");

var $cijHs = parcelRequire("cijHs");
const $dffd715f033d8cee$var$boxStyles = (0, $1ZAYh.xcss)({
    display: 'inline-block',
    userSelect: 'none'
});
const $dffd715f033d8cee$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "@atlaskit/calendar",
    packageVersion: "14.2.2"
};
const $dffd715f033d8cee$var$InnerCalendar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $kvezr.blankStringArray), defaultSelected: defaultSelected = (0, $kvezr.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $5Q9wj.default), onChange: onChange = (0, $5Q9wj.default), onFocus: onFocus = (0, $5Q9wj.default), onSelect: onSelect = (0, $5Q9wj.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, calendarRef: calendarRef, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $gS7RT.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $eUqFw.useState)(false);
    const onChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$dffd715f033d8cee$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, $ewAFV.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$dffd715f033d8cee$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $2gDa3.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $jTPbp.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    (0, $dzwUo.default)(calendarRef, {
        navigate: navigate
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $6Z8Du.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $glQu8.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getPreviousHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const headerId = (0, $cijHs.default)('month-year-header');
    return (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref
    }, (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $dffd715f033d8cee$var$boxStyles,
        padding: "space.200",
        "aria-label": "calendar",
        testId: testId && `${testId}--calendar`
    }, (0, $byn9U.jsx)((0, $1zbEq.default), {
        space: "space.150"
    }, (0, $byn9U.jsx)((0, $bzQ1M.default), {
        monthLongTitle: monthsLong[monthValue - 1],
        year: yearValue,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        nextHeading: getNextHeading(),
        previousHeading: getPreviousHeading(),
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev,
        headerId: headerId,
        tabIndex: tabIndex,
        testId: testId
    }), (0, $byn9U.jsx)((0, $b5IAe.default), {
        role: "grid",
        onKeyDown: handleContainerKeyDown,
        "aria-labelledby": headerId,
        testId: testId && `${testId}--calendar-dates`
    }, (0, $byn9U.jsx)((0, $3MsT7.default), {
        daysShort: daysShort,
        testId: testId
    }), (0, $byn9U.jsx)((0, $dGk8h.default), {
        weeks: weeks,
        handleClickDay: handleClickDay,
        monthsLong: monthsLong,
        shouldSetFocus: shouldSetFocus,
        tabIndex: tabIndex,
        testId: testId
    })))));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $dffd715f033d8cee$var$Calendar = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Calendar(props, ref) {
    return (0, $byn9U.jsx)($dffd715f033d8cee$var$InnerCalendar, (0, $kU09D.default)({}, props, {
        ref: ref
    }));
}));
$dffd715f033d8cee$var$Calendar.displayName = 'Calendar';
var $dffd715f033d8cee$export$2e2bcd8739ae039 = $dffd715f033d8cee$var$Calendar;

});
parcelRegister("bzQ1M", function(module, exports) {

$parcel$export(module.exports, "default", () => $86db52355146a6bb$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $j9fWg = parcelRequire("j9fWg");

var $hI5oG = parcelRequire("hI5oG");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");

var $cijHs = parcelRequire("cijHs");
const $86db52355146a6bb$var$Header = /*#__PURE__*/ (0, $eUqFw.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $cijHs.default)('month-year-announce');
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $eUqFw.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickPrev(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickNext(e);
    };
    return (0, $byn9U.jsx)((0, $b5IAe.default), {
        paddingInline: "space.100"
    }, (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "center",
        spread: "space-between"
    }, (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dXKde))),
        label: `${previousMonthLabel}, ${previousHeading}`
    }), (0, $byn9U.jsx)((0, $b5IAe.default), {
        "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
        id: announceId,
        testId: testId && `${testId}--current-month-year--container`
    }, (0, $byn9U.jsx)((0, $hI5oG.default), {
        size: "xsmall",
        as: "h2",
        id: headerId,
        testId: testId && `${testId}--current-month-year`
    }, `${monthLongTitle} ${year}`)), (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))),
        label: `${nextMonthLabel}, ${nextHeading}`
    })));
});
$86db52355146a6bb$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$86db52355146a6bb$export$2e2bcd8739ae039 = $86db52355146a6bb$var$Header;

});
parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9d7d0ffff46f5f00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 010 1.414l-4.593 4.593a.99.99 0 01-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 011.4-1.4l4.593 4.593z"/></svg>`
    }, props));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;
module.exports.default = $9d7d0ffff46f5f00$var$_default;

});

parcelRegister("cijHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f36727c3147c999$export$2e2bcd8739ae039);

var $jFtVs = parcelRequire("jFtVs");
function $8f36727c3147c999$export$2e2bcd8739ae039(prefix) {
    const seed = (0, $jFtVs.useUIDSeed)();
    return `${prefix}-${seed(prefix)}`;
}

});


parcelRegister("dGk8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f5ed087c2b4d71e$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");

var $d1dFa = parcelRequire("d1dFa");

var $4Ldj7 = parcelRequire("4Ldj7");
const $9f5ed087c2b4d71e$var$WeekDays = /*#__PURE__*/ (0, $eUqFw.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return (0, $byn9U.jsx)((0, $b5IAe.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`
    }, weeks.map((week, i)=>(0, $byn9U.jsx)((0, $4Ldj7.default), {
            key: i,
            testId: testId && `${testId}--week`
        }, week.values.map((weekDay)=>(0, $byn9U.jsx)((0, $d1dFa.default), {
                key: `${week.id}-${weekDay.id}`,
                isDisabled: weekDay.isDisabled,
                isFocused: weekDay.isFocused,
                isToday: weekDay.isToday,
                dayLong: weekDay.weekDayName,
                month: weekDay.month,
                monthLong: monthsLong[weekDay.month - 1],
                onClick: handleClickDay,
                isPreviouslySelected: weekDay.isPreviouslySelected,
                isSelected: weekDay.isSelected,
                isSibling: weekDay.isSiblingMonth,
                year: weekDay.year,
                shouldSetFocus: shouldSetFocus,
                tabIndex: tabIndex,
                testId: testId
            }, weekDay.day)))));
});
$9f5ed087c2b4d71e$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9f5ed087c2b4d71e$export$2e2bcd8739ae039 = $9f5ed087c2b4d71e$var$WeekDays;

});
parcelRegister("d1dFa", function(module, exports) {

$parcel$export(module.exports, "default", () => $97a5f7866b144b75$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5Q9wj = parcelRequire("5Q9wj");

var $27KYr = parcelRequire("27KYr");

var $jRRjL = parcelRequire("jRRjL");
const $97a5f7866b144b75$var$Date = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $5Q9wj.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $eUqFw.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    const dateCellStyles = (0, $byn9U.css)((0, $jRRjL.dateCellStyles)());
    return (0, $byn9U.jsx)((0, $27KYr.default), {
        role: "gridcell",
        alignItems: "center"
    }, (0, $byn9U.jsx)("button", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: dateCellStyles,
        "aria-current": isToday ? 'date' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
        "aria-pressed": isSelected ? 'true' : 'false',
        tabIndex: isFocused ? tabIndex : -1,
        type: "button",
        onClick: handleClick,
        ref: focusRef,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-prev-selected": isPreviouslySelected || undefined,
        "data-selected": isSelected || undefined,
        "data-sibling": isSibling || undefined,
        "data-today": isToday || undefined,
        "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
    }, day));
}));
$97a5f7866b144b75$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$97a5f7866b144b75$export$2e2bcd8739ae039 = $97a5f7866b144b75$var$Date;

});
parcelRegister("jRRjL", function(module, exports) {

$parcel$export(module.exports, "dateCellStyles", () => $e76c535b95999d29$export$f62807af68630d86);

var $PdmhA = parcelRequire("PdmhA");
const $e76c535b95999d29$export$f62807af68630d86 = ()=>({
        all: 'unset',
        display: 'block',
        padding: `${"var(--ds-space-050, 4px)"} 9px`,
        position: 'relative',
        backgroundColor: 'transparent',
        border: '2px solid transparent',
        borderRadius: 3,
        color: `var(--ds-text, ${0, $PdmhA.N900})`,
        cursor: 'pointer',
        flexGrow: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        textAlign: 'center',
        '&[data-sibling]': {
            color: `var(--ds-text-subtlest, ${0, $PdmhA.N200})`
        },
        '&[data-today]': {
            color: `var(--ds-text-selected, ${0, $PdmhA.B400})`,
            fontWeight: "var(--ds-font-weight-bold, bold)",
            '&::after': {
                display: 'block',
                height: 2,
                position: 'absolute',
                right: "var(--ds-space-025, 2px)",
                bottom: "var(--ds-space-025, 2px)",
                left: "var(--ds-space-025, 2px)",
                backgroundColor: 'currentColor',
                content: '""'
            }
        },
        '&[data-prev-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $PdmhA.B50})`,
            color: `var(--ds-text-subtle, ${0, $PdmhA.N600})`
        },
        '&[data-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $PdmhA.N500})`,
            color: `var(--ds-text-selected, ${0, $PdmhA.N0})`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $PdmhA.N40})`,
            cursor: 'not-allowed'
        },
        '&:focus-visible': {
            border: `2px solid ${`var(--ds-border-focused, ${0, $PdmhA.B200})`}`
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N30})`,
            color: `var(--ds-text, ${0, $PdmhA.N900})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $PdmhA.B50})`,
            color: `var(--ds-text, ${0, $PdmhA.N900})`
        },
        '&[data-selected]:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${0, $PdmhA.B50})`,
            color: `var(--ds-text-selected, ${0, $PdmhA.N600})`
        },
        '&[data-prev-selected]:hover': {
            color: `var(--ds-text-subtle, ${0, $PdmhA.N600})`
        },
        '&[data-sibling]:hover': {
            color: `var(--ds-text-subtlest, ${0, $PdmhA.N200})`
        },
        '&[data-disabled]:hover': {
            backgroundColor: 'transparent',
            color: `var(--ds-text-disabled, ${0, $PdmhA.N40})`
        }
    });

});


parcelRegister("4Ldj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3775dfc69d499ca0$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $27KYr = parcelRequire("27KYr");
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $3775dfc69d499ca0$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = (0, $byn9U.jsx)((0, $27KYr.default), {
        testId: testId,
        templateColumns: "repeat(7, minmax(max-content, 1fr))",
        role: "row"
    }, children);
    return isHidden ? (0, $byn9U.jsx)("div", {
        "aria-hidden": "true"
    }, row) : row;
};
var $3775dfc69d499ca0$export$2e2bcd8739ae039 = $3775dfc69d499ca0$var$WeekDayGrid;

});


parcelRegister("3MsT7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c0c43598fd4f766$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Ldj7 = parcelRequire("4Ldj7");
const $2c0c43598fd4f766$var$columnHeaderStyles = (0, $1ZAYh.xcss)({
    minWidth: 'size.400',
    // Account for languages with short week day names
    whiteSpace: 'nowrap',
    // Account for languages with long week day names
    display: 'flex',
    justifyContent: 'center'
});
const $2c0c43598fd4f766$var$WeekHeader = /*#__PURE__*/ (0, $eUqFw.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return (0, $byn9U.jsx)((0, $4Ldj7.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`
    }, daysShort.map((shortDay)=>(0, $byn9U.jsx)((0, $b5IAe.default), {
            padding: "space.100",
            xcss: $2c0c43598fd4f766$var$columnHeaderStyles,
            key: shortDay,
            role: "columnheader",
            testId: testId && `${testId}--column-header`
        }, (0, $byn9U.jsx)((0, $1Yimi.default), {
            weight: "bold",
            size: "UNSAFE_small",
            align: "center",
            color: "color.text.subtle"
        }, shortDay))));
});
$2c0c43598fd4f766$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2c0c43598fd4f766$export$2e2bcd8739ae039 = $2c0c43598fd4f766$var$WeekHeader;

});

parcelRegister("kvezr", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $eed2014d3aac97b7$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $eed2014d3aac97b7$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $eed2014d3aac97b7$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $eed2014d3aac97b7$export$8fa20d70624f8b9d);
const $eed2014d3aac97b7$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $eed2014d3aac97b7$export$3ae905d9742bef55 = 7;
const $eed2014d3aac97b7$export$c9b7c010035d60c6 = 12;
const $eed2014d3aac97b7$export$8fa20d70624f8b9d = [];

});

parcelRegister("dzwUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e1812353b74e1fa$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $9e1812353b74e1fa$export$2e2bcd8739ae039(calendarRef, { navigate: navigate }) {
    (0, $eUqFw.useImperativeHandle)(calendarRef, ()=>({
            navigate: navigate
        }), [
        navigate
    ]);
}

});

parcelRegister("gS7RT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c487caef53c11500$export$2e2bcd8739ae039);

var $2WwAS = parcelRequire("2WwAS");

var $9pgGL = parcelRequire("9pgGL");

var $amm5z = parcelRequire("amm5z");
function $c487caef53c11500$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $9pgGL.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $2WwAS.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $2WwAS.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $2WwAS.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $2WwAS.default)(today, ()=>today || `${thisYear}-${(0, $amm5z.default)(thisMonth)}-${(0, $amm5z.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $2WwAS.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $2WwAS.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("amm5z", function(module, exports) {

$parcel$export(module.exports, "default", () => $78ad17d34851c843$export$2e2bcd8739ae039);
function $78ad17d34851c843$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("jTPbp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7cadb44c548b71c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $e7cadb44c548b71c$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $eUqFw.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $eUqFw.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("glQu8", function(module, exports) {

$parcel$export(module.exports, "default", () => $be7751f0ac09e53b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3xcI8 = parcelRequire("3xcI8");

var $kvezr = parcelRequire("kvezr");

var $hv2LY = parcelRequire("hv2LY");

var $1qC31 = parcelRequire("1qC31");
function $be7751f0ac09e53b$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $eUqFw.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $kvezr.daysPerWeek) : 0;
            return (0, $1qC31.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $kvezr.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $be7751f0ac09e53b$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $eUqFw.useMemo)(()=>(0, $1qC31.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $be7751f0ac09e53b$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $3xcI8.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $3xcI8.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $eUqFw.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $hv2LY.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $3xcI8.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("hv2LY", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd77b8e36d2ec3e$export$2e2bcd8739ae039);

var $amm5z = parcelRequire("amm5z");
function $cbd77b8e36d2ec3e$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $amm5z.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $amm5z.default)(date.day)}`;
}

});

parcelRegister("1qC31", function(module, exports) {

$parcel$export(module.exports, "default", () => $10a5bba983949ba4$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $kvezr = parcelRequire("kvezr");

var $lKtiU = parcelRequire("lKtiU");
function $10a5bba983949ba4$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $kvezr.daysPerWeek) - weekStartDay + firstDay) % (0, $kvezr.daysPerWeek));
    const lastDate = (0, $lKtiU.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $kvezr.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $lKtiU.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $kvezr.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $kvezr.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $kvezr.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $kvezr.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $kvezr.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("lKtiU", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd54a0044c0ef1b5$export$2e2bcd8739ae039);
function $fd54a0044c0ef1b5$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("ewAFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93080c53d7e91a6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kvezr = parcelRequire("kvezr");

var $hv2LY = parcelRequire("hv2LY");

var $lKtiU = parcelRequire("lKtiU");
const $a93080c53d7e91a6$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $kvezr.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $a93080c53d7e91a6$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $kvezr.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $a93080c53d7e91a6$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $eUqFw.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $hv2LY.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $eUqFw.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $kvezr.daysPerWeek);
            const daysInMonth = (0, $lKtiU.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $a93080c53d7e91a6$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $a93080c53d7e91a6$var$getPrevMonth(month, year);
                const prevDay = (0, $lKtiU.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $lKtiU.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $a93080c53d7e91a6$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $kvezr.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $a93080c53d7e91a6$var$getPrevMonth(month, year);
                const prevDay = (0, $lKtiU.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNext = (0, $eUqFw.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$a93080c53d7e91a6$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'next'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrev = (0, $eUqFw.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$a93080c53d7e91a6$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prev'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev
    };
}

});

parcelRegister("2gDa3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a6b73f87f932780$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kvezr = parcelRequire("kvezr");

var $hv2LY = parcelRequire("hv2LY");
function $1a6b73f87f932780$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $eUqFw.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $hv2LY.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $eUqFw.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $kvezr.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("6Z8Du", function(module, exports) {

$parcel$export(module.exports, "default", () => $515f2379f0e46d0b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1YVlj = parcelRequire("1YVlj");
function $515f2379f0e46d0b$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $eUqFw.useMemo)(()=>(0, $1YVlj.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $eUqFw.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $eUqFw.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $eUqFw.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("cZF0W", function(module, exports) {

$parcel$export(module.exports, "default", () => $975aff1b1287192c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $8MHxr = parcelRequire("8MHxr");

var $5Q9wj = parcelRequire("5Q9wj");

var $cAX3Z = parcelRequire("cAX3Z");

var $XHGTv = parcelRequire("XHGTv");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $lcnyw = parcelRequire("lcnyw");
class $975aff1b1287192c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "update", (0, $5Q9wj.default));
    }
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null);
        const divStyles = {
            background: 'transparent',
            position: 'absolute',
            top: 0,
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $cAX3Z.sizes).small.slice(0, -2)) - (0, $lcnyw.gridSize)(),
            ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.date-picker-input-a11y-fix_cbbxs') && {
                pointerEvents: 'none'
            }
        };
        return(/*#__PURE__*/ /* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8MHxr))), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                "data-layer-child": true,
                style: divStyles
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), null, ({ ref: ref, style: style, update: update })=>{
            this.update = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                style: {
                    ...style,
                    zIndex: (0, $lcnyw.layers).dialog()
                },
                "data-testid": testId && `${testId}--popper--container`
            }, content);
        })));
    }
}

});


parcelRegister("8upjz", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $62e4c30a61764100$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $62e4c30a61764100$export$ff525416014fb67d);

var $EN9B6 = parcelRequire("EN9B6");

var $lwwPJ = parcelRequire("lwwPJ");
function $62e4c30a61764100$export$77d5bc49fed7ef14(date) {
    return (0, $EN9B6.default)(date, (0, $lwwPJ.convertTokens)('YYYY-MM-DD'));
}
function $62e4c30a61764100$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $62e4c30a61764100$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("45taO", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $2f9e4245a3b1c558$export$6e30bf8cb1347b56);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
const $2f9e4245a3b1c558$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, ...props })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).SingleValue, (0, $kU09D.default)({}, props, {
            innerProps: {
                lang: lang
            }
        }), children);
    };

});


parcelRegister("hzTQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc10572edc80ea2$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $EN9B6 = parcelRequire("EN9B6");
var $7ueqz = parcelRequire("7ueqz");

var $8dloj = parcelRequire("8dloj");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $1YVlj = parcelRequire("1YVlj");

var $1EOkb = parcelRequire("1EOkb");
var $4zgIJ = parcelRequire("4zgIJ");
var $cEc3i = parcelRequire("cEc3i");

var $lcnyw = parcelRequire("lcnyw");

var $8ffDj = parcelRequire("8ffDj");

var $kNlCg = parcelRequire("kNlCg");

var $ceaxY = parcelRequire("ceaxY");

var $lwwPJ = parcelRequire("lwwPJ");

var $45taO = parcelRequire("45taO");
const $ccc10572edc80ea2$var$packageName = "@atlaskit/datetime-picker";
const $ccc10572edc80ea2$var$packageVersion = "13.5.2";
const $ccc10572edc80ea2$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $ccc10572edc80ea2$var$timePickerDefaultProps = {
    appearance: 'default',
    autoFocus: false,
    defaultIsOpen: false,
    defaultValue: '',
    hideIcon: false,
    id: '',
    innerProps: {},
    isDisabled: false,
    isInvalid: false,
    label: '',
    name: '',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{},
    /* eslint-enable @repo/internal/react/use-noop */ parseInputValue: (time, _timeFormat)=>(0, $ceaxY.default)(time),
    selectProps: {},
    spacing: 'default',
    times: (0, $8ffDj.defaultTimes),
    timeIsEditable: false,
    locale: 'en-US'
};
class $ccc10572edc80ea2$export$8cc1aba0d1f32313 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "containerRef", null);
        (0, $5zQU9.default)(this, "state", {
            isOpen: this.props.defaultIsOpen,
            clearingFromIcon: false,
            value: this.props.defaultValue,
            isFocused: false
        });
        // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        (0, $5zQU9.default)(this, "getSafeState", ()=>{
            return {
                ...this.state,
                ...(0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(this.props, [
                    'value',
                    'isOpen'
                ])
            };
        });
        (0, $5zQU9.default)(this, "onChange", (newValue, action)=>{
            const rawValue = newValue ? newValue.value || newValue : '';
            const value = rawValue.toString();
            let changedState = {
                value: value
            };
            if (action && action.action === 'clear') changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange(value);
        });
        /**
     * Only allow custom times if timeIsEditable prop is true
     */ (0, $5zQU9.default)(this, "onCreateOption", (inputValue)=>{
            if (this.props.timeIsEditable) {
                const { parseInputValue: parseInputValue, timeFormat: timeFormat } = this.props;
                let sanitizedInput;
                try {
                    sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $8ffDj.defaultTimeFormat));
                } catch (e) {
                    return; // do nothing, the main validation should happen in the form
                }
                const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
                const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
                const formattedValue = (0, $EN9B6.default)(sanitizedInput, formatFormat) || '';
                this.setState({
                    value: formattedValue
                });
                this.props.onChange(formattedValue);
            } else this.onChange(inputValue);
        });
        (0, $5zQU9.default)(this, "onMenuOpen", ()=>{
            // Don't open menu after the user has clicked clear
            if (this.getSafeState().clearingFromIcon) this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                isOpen: true
            });
        });
        (0, $5zQU9.default)(this, "onMenuClose", ()=>{
            // Don't close menu after the user has clicked clear
            if (this.getSafeState().clearingFromIcon) this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                isOpen: false
            });
        });
        (0, $5zQU9.default)(this, "setContainerRef", (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref;
            // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        });
        (0, $5zQU9.default)(this, "onBlur", (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur(event);
        });
        (0, $5zQU9.default)(this, "onFocus", (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus(event);
        });
        (0, $5zQU9.default)(this, "onSelectKeyDown", (event)=>{
            const { key: key } = event;
            const keyPressed = key.toLowerCase();
            if (this.getSafeState().clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
            this.setState({
                clearingFromIcon: false
            });
        });
    }
    render() {
        const { appearance: appearance, autoFocus: autoFocus, formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon, id: id, innerProps: innerProps, isDisabled: isDisabled, label: label, locale: locale, name: name, placeholder: placeholder, selectProps: selectProps, spacing: spacing, testId: testId, isInvalid: isInvalid, timeIsEditable: timeIsEditable, timeFormat: timeFormat, times: times } = this.props;
        const ICON_PADDING = 2;
        const l10n = (0, $1YVlj.createLocalizationProvider)(locale);
        const { value: value = '', isOpen: isOpen } = this.getSafeState();
        const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
        const SelectComponent = timeIsEditable ? (0, $1EOkb.default) : (0, $4zgIJ.default);
        /**
     * There are multiple props that can change how the time is formatted.
     * The priority of props used is:
     *   1. formatDisplayLabel
     *   2. timeFormat
     *   3. locale
     */ const formatTime = (time)=>{
            if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $8ffDj.defaultTimeFormat));
            const date = (0, $ceaxY.default)(time);
            if (!(date instanceof Date)) return '';
            if (!(0, $7ueqz.default)(date)) return time;
            if (timeFormat) return (0, $EN9B6.default)(date, (0, $lwwPJ.convertTokens)(timeFormat));
            return l10n.formatTime(date);
        };
        const options = times.map((time)=>{
            return {
                label: formatTime(time),
                value: time
            };
        });
        const labelAndValue = value && {
            label: formatTime(value),
            value: value
        };
        const SingleValue = (0, $45taO.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: (0, $8ffDj.EmptyComponent),
            Menu: (0, $kNlCg.FixedLayerMenu),
            SingleValue: SingleValue,
            ...hideIcon && {
                ClearIndicator: (0, $8ffDj.EmptyComponent)
            }
        };
        const renderIconContainer = Boolean(!hideIcon && value);
        const mergedStyles = (0, $cEc3i.m)(selectStyles, {
            control: (base)=>({
                    ...base
                }),
            menu: (base)=>({
                    ...base,
                    ...$ccc10572edc80ea2$var$menuStyles,
                    // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                    // menu width to the width of our container
                    width: this.containerRef ? this.containerRef.getBoundingClientRect().width : 'auto'
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                    paddingRight: renderIconContainer ? (0, $lcnyw.gridSize)() - ICON_PADDING : 0
                })
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", (0, $kU09D.default)({}, innerProps, {
            ref: this.setContainerRef,
            "data-testid": testId && `${testId}--container`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`,
            onKeyDown: this.onSelectKeyDown
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectComponent, (0, $kU09D.default)({
            "aria-label": label || undefined,
            appearance: appearance,
            autoFocus: autoFocus,
            components: selectComponents,
            inputId: id,
            isClearable: true,
            isDisabled: isDisabled,
            menuIsOpen: isOpen && !isDisabled,
            menuPlacement: "auto",
            openMenuOnFocus: true,
            onBlur: this.onBlur,
            onCreateOption: this.onCreateOption,
            onChange: this.onChange,
            options: options,
            onFocus: this.onFocus,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            placeholder: placeholder || l10n.formatTime((0, $8ffDj.placeholderDatetime)),
            styles: mergedStyles,
            value: labelAndValue,
            spacing: spacing,
            fixedLayerRef: this.containerRef,
            isInvalid: isInvalid,
            testId: testId
        }, otherSelectProps)));
    }
}
(0, $5zQU9.default)($ccc10572edc80ea2$export$8cc1aba0d1f32313, "defaultProps", $ccc10572edc80ea2$var$timePickerDefaultProps);
var $ccc10572edc80ea2$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'timePicker',
    packageName: $ccc10572edc80ea2$var$packageName,
    packageVersion: $ccc10572edc80ea2$var$packageVersion
})((0, $2jDha.default)({
    onChange: (0, $hM7RE.default)('atlaskit')({
        action: 'selectedTime',
        actionSubject: 'timePicker',
        attributes: {
            componentName: 'timePicker',
            packageName: $ccc10572edc80ea2$var$packageName,
            packageVersion: $ccc10572edc80ea2$var$packageVersion
        }
    })
})($ccc10572edc80ea2$export$8cc1aba0d1f32313));

});
parcelRegister("1EOkb", function(module, exports) {

$parcel$export(module.exports, "default", () => $135090411de90a60$export$2e2bcd8739ae039);

var $lOwgQ = parcelRequire("lOwgQ");

var $bSpUS = parcelRequire("bSpUS");
var $135090411de90a60$export$2e2bcd8739ae039 = (0, $bSpUS.default)((0, $lOwgQ.default));

});
parcelRegister("lOwgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe174cca2c039728$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("6xNN4")).u);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $7IqRg = parcelRequire("7IqRg");

var $6xNN4 = parcelRequire("6xNN4");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $fe174cca2c039728$var$CreatableSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var creatableProps = (0, $7IqRg.u)(props);
    var selectProps = (0, $6xNN4.u)(creatableProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $fe174cca2c039728$export$2e2bcd8739ae039 = $fe174cca2c039728$var$CreatableSelect;

});
parcelRegister("6xNN4", function(module, exports) {

$parcel$export(module.exports, "u", () => $4c3c7280e822f6fb$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $fVK4C = parcelRequire("fVK4C");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $cEc3i = parcelRequire("cEc3i");
var $4c3c7280e822f6fb$var$_excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var $4c3c7280e822f6fb$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $4c3c7280e822f6fb$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return $4c3c7280e822f6fb$var$compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return $4c3c7280e822f6fb$var$compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function $4c3c7280e822f6fb$export$3b14a55fb2447963(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? $4c3c7280e822f6fb$var$builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? $4c3c7280e822f6fb$var$builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? $4c3c7280e822f6fb$var$builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, $bwPfh.default)(_ref, $4c3c7280e822f6fb$var$_excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, $cEc3i.g) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, $cEc3i.b) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, $eUqFw.useMemo)(function() {
        return isValidNewOption(inputValue, (0, $jQxSL.I)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, $eUqFw.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption
        ].concat((0, $fVK4C.default)(propsOptions)) : [].concat((0, $fVK4C.default)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $jQxSL.D)(isMulti, [].concat((0, $fVK4C.default)((0, $jQxSL.I)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}

});



parcelRegister("kNlCg", function(module, exports) {

$parcel$export(module.exports, "FixedLayerMenu", () => $f23926c4d9140843$export$982ad994195b4356);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $cZF0W = parcelRequire("cZF0W");
const $f23926c4d9140843$export$982ad994195b4356 = ({ selectProps: selectProps, ...rest })=>(0, $byn9U.jsx)((0, $cZF0W.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.fixedLayerRef,
        content: (0, $byn9U.jsx)((0, $jQxSL.c).Menu, (0, $kU09D.default)({}, rest, {
            menuShouldScrollIntoView: false
        })),
        testId: selectProps.testId
    });

});

parcelRegister("ceaxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e6ef93aab0e15ae$export$2e2bcd8739ae039);
const $8e6ef93aab0e15ae$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $8e6ef93aab0e15ae$export$1ea939691cdc45b8(timeString) {
    /**
   * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
   */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
   * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
   */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
   * Convert `2:34:56 pm` down to `23456`
   */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $8e6ef93aab0e15ae$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $8e6ef93aab0e15ae$export$c38a243baf9c6083(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $8e6ef93aab0e15ae$export$ed20539f7181c701(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $8e6ef93aab0e15ae$var$map24[hour];
    return hour;
}
function $8e6ef93aab0e15ae$export$4077529dfc44a251(value) {
    if (value > '59') return null;
    return value;
}
function $8e6ef93aab0e15ae$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $8e6ef93aab0e15ae$export$c38a243baf9c6083(timeArray[0].trim());
    const hour = $8e6ef93aab0e15ae$export$ed20539f7181c701(semi24.substring(0, 2), meridiem);
    const minute = $8e6ef93aab0e15ae$export$4077529dfc44a251(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $8e6ef93aab0e15ae$export$4077529dfc44a251(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $8e6ef93aab0e15ae$export$865db99128311580(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $8e6ef93aab0e15ae$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$8e6ef93aab0e15ae$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $8e6ef93aab0e15ae$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $8e6ef93aab0e15ae$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $8e6ef93aab0e15ae$export$865db99128311580(time2);
}

});



parcelRegister("iPvRp", function(module, exports) {

$parcel$export(module.exports, "default", () => $602440b5c7905892$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $602440b5c7905892$export$2e2bcd8739ae039 = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];

});

parcelRegister("gTWD6", function(module, exports) {

$parcel$export(module.exports, "default", () => $bba19be2166d93a9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bba19be2166d93a9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholderDate: {
        "id": "common-date.utils.date-messages.placeholder-date",
        "defaultMessage": "e.g. 2018/12/31"
    }
});

});

parcelRegister("4fDms", function(module, exports) {

$parcel$export(module.exports, "convertISODateFormat", () => $069207a6d7234680$export$6ac2be7021dd8e44);
// Safari and Internet Explorer cannot parse dates (invalid date error) of a specific type of
// ISO formatting (RFC 822) that does no have timezone part (HHmm) separated by a colon (:)
// not working example: new Date('2018-02-06T20:00:00+1100')
// working example:     new Date('2018-02-06T20:00:00+11:00')
const $069207a6d7234680$export$6ac2be7021dd8e44 = (date)=>date.replace(/([+-][0-9]{2})([0-9]{2})$/, '$1:$2');

});


parcelRegister("ijSQY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5f47e7c05129e53$export$2e2bcd8739ae039);

var $iRHiq = parcelRequire("iRHiq");
var $f5f47e7c05129e53$export$2e2bcd8739ae039 = (0, $iRHiq.WorkDescription);

});
parcelRegister("iRHiq", function(module, exports) {

$parcel$export(module.exports, "WorkDescription", () => $7287d62bf001269c$export$792a24a47543a833);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $4LhB6 = parcelRequire("4LhB6");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7GSu6 = parcelRequire("7GSu6");

var $4jpQt = parcelRequire("4jpQt");

var $hlK0s = parcelRequire("hlK0s");

const $7287d62bf001269c$export$b6c2380c03bebc2b = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("3lwIp")), {
    moduleId: "./src/packages/issue/issue-view-common/src/component/editor/index.tsx"
});
const $7287d62bf001269c$export$792a24a47543a833 = ({ portalElement: portalElement, isDisabled: isDisabled, externalId: externalId, defaultValue: defaultValue, mediaContext: mediaContext, mentionProvider: mentionProvider, mentionEncoder: mentionEncoder, activityProvider: activityProvider, onChange: onChange, onChangeFailure: onChangeFailure })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const fallback = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4jpQt.IssueEditorReadonly), {
            mediaContext: mediaContext,
            defaultValue: defaultValue
        }), [
        defaultValue,
        mediaContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: "work-description",
        label: formatMessage((0, $hlK0s.default).label)
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4jpQt.IssueEditorBoundary), {
            packageName: "issue",
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GSu6.StickyHeaderTrackerContainer), {
            scope: "work-description"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7287d62bf001269c$export$b6c2380c03bebc2b, {
            isExpanded: true,
            externalId: externalId,
            isDisabled: isDisabled,
            defaultValue: defaultValue,
            portalElement: portalElement,
            onChange: onChange,
            onChangeFailure: onChangeFailure,
            mediaContext: mediaContext,
            // @ts-expect-error - TS2740 - Type 'Record<any, any>' is missing the following properties from type 'MentionProvider': filter, recordMentionSelection, shouldHighlightMention, isFiltering, and 2 more.
            mentionProvider: mentionProvider,
            mentionEncoder: mentionEncoder,
            activityProvider: activityProvider,
            useStickyToolbar: true
        }))));
};

});
parcelRegister("4jpQt", function(module, exports) {

$parcel$export(module.exports, "IssueEditorReadonly", () => $b11e7135688b37d7$export$3315baac29d9ad76);
$parcel$export(module.exports, "IssueEditorBoundary", () => $b11e7135688b37d7$export$a82eb0964879c3f9);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $Jptg5 = parcelRequire("Jptg5");

var $gGtKh = parcelRequire("gGtKh");
const $b11e7135688b37d7$export$3315baac29d9ad76 = ({ defaultValue: defaultValue, mediaContext: mediaContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Jptg5.default), {
        mediaContext: mediaContext,
        adf: defaultValue
    });
const $b11e7135688b37d7$export$a82eb0964879c3f9 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-editor",
        packageName: packageName,
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallback)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-editor-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("Jptg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3eef2863c3690a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $5iWql = parcelRequire("5iWql");

var $aml13 = parcelRequire("aml13");

var $tHNWK = parcelRequire("tHNWK");

var $1ybV0 = parcelRequire("1ybV0");

var $2gfkg = parcelRequire("2gfkg");

var $9XfZZ = parcelRequire("9XfZZ");

var $68Zel = parcelRequire("68Zel");

var $dxcfv = parcelRequire("dxcfv");
var $dWLk9 = parcelRequire("dWLk9");

var $fbdfB = parcelRequire("fbdfB");

var $bIw2X = parcelRequire("bIw2X");
const $d3eef2863c3690a2$var$getSmartCardProviderFeatureFlags = (0, $5iWql.default)(()=>({
        enableFlexibleBlockCard: (0, $fbdfB.getEnableFlexibleBlockCardInIssueEditor)()
    }));
const $d3eef2863c3690a2$var$WrappedRendererView = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $2gfkg.default), (0, $tHNWK.default))((0, $bIw2X.default));
const $d3eef2863c3690a2$var$Renderer = (props)=>{
    const loggedInUserAccountId = (0, $dxcfv.useAccountId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const profileCardProvider = (0, $68Zel.useProfileCardProvider)();
    const smartCardProviderFF = $d3eef2863c3690a2$var$getSmartCardProviderFeatureFlags();
    const smartCardProviderProduct = (0, $9XfZZ.useSmartCardProductType)();
    const isAIFeatureEnabled = (0, $9XfZZ.useSmartCardIsAIEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), {
        featureFlags: smartCardProviderFF,
        ...(0, $1ybV0.ff)('platform.linking-platform.smart-card.hover-card-ai-summaries') && {
            product: smartCardProviderProduct,
            isAdminHubAIEnabled: isAIFeatureEnabled
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3eef2863c3690a2$var$WrappedRendererView, {
        ...props,
        cloudId: cloudId,
        loggedInUserAccountId: loggedInUserAccountId,
        profileCardProvider: profileCardProvider
    }));
};
var $d3eef2863c3690a2$export$2e2bcd8739ae039 = $d3eef2863c3690a2$var$Renderer;

});
parcelRegister("aml13", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $ddfb038c93ff29bc$export$497ecb0280204df4);

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");

var $cGAGh = parcelRequire("cGAGh");

var $fQDHB = parcelRequire("fQDHB");

var $aatVr = parcelRequire("aatVr");

var $gqldc = parcelRequire("gqldc");

var $1Hojg = parcelRequire("1Hojg");
function $ddfb038c93ff29bc$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
    const parentContext = (0, $eUqFw.useContext)((0, $gqldc.SmartCardContext));
    const defaultInitialState = (0, $eUqFw.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $eUqFw.useMemo)(()=>{
        return (0, $huRi7.createStore)((0, $aatVr.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $eUqFw.useMemo)(()=>{
        const client = customClient || new (0, $1Hojg.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, platform)=>{
            const cardState = (0, $cGAGh.getUrl)(store, url);
            return cardState.details ? (0, $fQDHB.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            featureFlags: featureFlags,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product
        };
    }, [
        customClient,
        customAuthFlow,
        isAdminHubAIEnabled,
        product,
        renderers,
        featureFlags,
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gqldc.SmartCardContext).Provider, {
        value: parentContext || providerValue
    }, children);
}
var $ddfb038c93ff29bc$export$2e2bcd8739ae039 = $ddfb038c93ff29bc$export$497ecb0280204df4;

});
parcelRegister("cGAGh", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $6b31d06902eb0186$export$94df0e59ebebf4a7);
const $6b31d06902eb0186$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("fQDHB", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $060df7d9b738514e$export$4b0d98b1b7f6d115);

var $5amkT = parcelRequire("5amkT");

var $9W7HP = parcelRequire("9W7HP");
const $060df7d9b738514e$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $5amkT.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("5amkT", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $8b80b7bf7b97ac24$export$3e8ad908070b68b2);
const $8b80b7bf7b97ac24$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});

parcelRegister("9W7HP", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65);
const $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("aatVr", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $f4cdd08462296438$export$3c7c3113a97b6492);

var $6EHO5 = parcelRequire("6EHO5");
var $4hPjC = parcelRequire("4hPjC");
const $f4cdd08462296438$var$isCardAction = (action)=>{
    return [
        (0, $6EHO5.ACTION_PENDING),
        (0, $6EHO5.ACTION_RESOLVING),
        (0, $6EHO5.ACTION_RESOLVED),
        (0, $6EHO5.ACTION_RELOADING),
        (0, $6EHO5.ACTION_ERROR),
        (0, $6EHO5.ACTION_ERROR_FALLBACK),
        (0, $6EHO5.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $f4cdd08462296438$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $4hPjC.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $f4cdd08462296438$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $6EHO5.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVED:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $6EHO5.ACTION_RELOADING:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $6EHO5.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $6EHO5.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $6EHO5.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $f4cdd08462296438$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$f4cdd08462296438$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $f4cdd08462296438$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("6EHO5", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $48f17d480117024d$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $48f17d480117024d$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $48f17d480117024d$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $48f17d480117024d$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $48f17d480117024d$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $48f17d480117024d$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $48f17d480117024d$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $48f17d480117024d$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $48f17d480117024d$export$6e470aad5ba8952e = 'pending';
const $48f17d480117024d$export$9a6a932a0a39498e = 'resolving';
const $48f17d480117024d$export$63ec8bc7a8a75482 = 'resolved';
const $48f17d480117024d$export$b8cfaa842c9ab487 = 'reloading';
const $48f17d480117024d$export$6d8ed3f9433dd372 = 'errored';
const $48f17d480117024d$export$cfbbb7126bc8a0c6 = 'fallback';
const $48f17d480117024d$export$76b5c1aca20759c6 = 'preload';
const $48f17d480117024d$export$2c5edb971b673330 = 'metadata';
const $48f17d480117024d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("4hPjC", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $6a6a7fcdba3f3a7c$export$b70265791d2079d4);
const $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $6a6a7fcdba3f3a7c$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});


parcelRegister("gqldc", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $ee9cd29169baa49b$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $ee9cd29169baa49b$export$e1d190b530cf0ee9);

var $eUqFw = parcelRequire("eUqFw");

const $ee9cd29169baa49b$export$156b523e63b4f63a = (0, $eUqFw.createContext)(undefined);
function $ee9cd29169baa49b$export$e1d190b530cf0ee9() {
    const context = (0, $eUqFw.useContext)($ee9cd29169baa49b$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
var $ee9cd29169baa49b$export$2e2bcd8739ae039 = $ee9cd29169baa49b$export$156b523e63b4f63a;

});

parcelRegister("1Hojg", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d12fbaea01fc74$export$2e2bcd8739ae039);
// import setimmediate to temporary fix dataloader 2.0.0 bug
// @see https://github.com/graphql/dataloader/issues/249
parcelRequire("inzmU");

var $5pr8w = parcelRequire("5pr8w");

var $aTD8J = parcelRequire("aTD8J");

var $bsIpz = parcelRequire("bsIpz");

var $f9yXU = parcelRequire("f9yXU");
var $dUrSu = parcelRequire("dUrSu");
var $4hPjC = parcelRequire("4hPjC");
var $5LW2w = parcelRequire("5LW2w");

var $gbc85 = parcelRequire("gbc85");

var $6roQF = parcelRequire("6roQF");

var $XHGTv = parcelRequire("XHGTv");
const $22d12fbaea01fc74$var$MAX_BATCH_SIZE = 50;
const $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE = 100;
const $22d12fbaea01fc74$export$d6a66073b5d79eb3 = new (0, $6roQF.LRUMap)($22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE);
class $22d12fbaea01fc74$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.batchResolve = async (urls)=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            const deDuplicatedUrls = [
                ...new Set(urls)
            ];
            let resolvedUrls = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ ...(0, $XHGTv.getBooleanFF)('platform.linking-platform.datasource.add-timezone-header') ? {
                    'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
                } : {},
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                resolvedUrls = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedUrls.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url
                resolvedUrls = urls.map(()=>{
                    // @ts-ignore
                    const status = (0, $gbc85.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs in the same order they were given.
            for(let i = 0; i < deDuplicatedUrls.length; ++i){
                const url = deDuplicatedUrls[i];
                const data = resolvedUrls[i];
                map[url] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return urls.map((originalUrl)=>map[originalUrl]);
        };
        this.resolverUrl = (0, $dUrSu.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($bsIpz)))({
            limit: 1,
            interval: $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($5pr8w)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $22d12fbaea01fc74$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $22d12fbaea01fc74$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $gbc85.isSuccessfulResponse)(response) || (0, $4hPjC.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $gbc85.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $gbc85.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $gbc85.isErrorResponse)(response) && response.error.status === 429;
    }
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $gbc85.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $gbc85.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $5LW2w.NetworkError)) return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                    return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                    return new (0, $f9yXU.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                    return new (0, $f9yXU.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                    return new (0, $f9yXU.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $f9yXU.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("inzmU", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
(function(global1, undefined) {
    "use strict";
    if (global1.setImmediate) return;
    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global1.document;
    var registerImmediate;
    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") callback = new Function("" + callback);
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i + 1];
        // Store and register the task
        var task = {
            callback: callback,
            args: args
        };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }
    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }
    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch(args.length){
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }
    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
        // "too much recursion" error.
        setTimeout(runIfPresent, 0, handle);
        else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally{
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }
    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            $2fFJv.nextTick(function() {
                runIfPresent(handle);
            });
        };
    }
    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global1.postMessage && !global1.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global1.onmessage;
            global1.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global1.postMessage("", "*");
            global1.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }
    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global1 && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) runIfPresent(+event.data.slice(messagePrefix.length));
        };
        if (global1.addEventListener) global1.addEventListener("message", onGlobalMessage, false);
        else global1.attachEvent("onmessage", onGlobalMessage);
        registerImmediate = function(handle) {
            global1.postMessage(messagePrefix + handle, "*");
        };
    }
    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };
        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }
    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function() {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }
    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }
    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global1);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global1;
    // Don't get fooled by e.g. browserify environments.
    if (({}).toString.call(global1.process) === "[object process]") // For Node.js before 0.9
    installNextTickImplementation();
    else if (canUsePostMessage()) // For non-IE10 modern browsers
    installPostMessageImplementation();
    else if (global1.MessageChannel) // For web workers, where supported
    installMessageChannelImplementation();
    else if (doc && "onreadystatechange" in doc.createElement("script")) // For IE 6–8
    installReadyStateChangeImplementation();
    else // For older browsers
    installSetTimeoutImplementation();
    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof $parcel$global === "undefined" ? module.exports : $parcel$global : self);

});

parcelRegister("5pr8w", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $3f0456472e399d24$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $3f0456472e399d24$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $3f0456472e399d24$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $3f0456472e399d24$var$getValidCacheKeyFn(options);
        this._cacheMap = $3f0456472e399d24$var$getValidCacheMap(options);
        this._batch = null;
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value,' + ("but got: " + String(key) + "."));
        var batch = $3f0456472e399d24$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        return resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$3f0456472e399d24$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $3f0456472e399d24$var$enqueuePostPromiseJob = typeof $2fFJv === 'object' && typeof $2fFJv.nextTick === 'function' ? function(fn) {
    if (!$3f0456472e399d24$var$resolvedPromise) $3f0456472e399d24$var$resolvedPromise = Promise.resolve();
    $3f0456472e399d24$var$resolvedPromise.then(function() {
        return $2fFJv.nextTick(fn);
    });
} : setImmediate || setTimeout; // Private: cached resolved Promise instance
var $3f0456472e399d24$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $3f0456472e399d24$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize && (!existingBatch.cacheHits || existingBatch.cacheHits.length < loader._maxBatchSize)) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        return $3f0456472e399d24$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $3f0456472e399d24$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $3f0456472e399d24$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise = loader._batchLoadFn(batch.keys); // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $3f0456472e399d24$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$3f0456472e399d24$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $3f0456472e399d24$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        return $3f0456472e399d24$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $3f0456472e399d24$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $3f0456472e399d24$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $3f0456472e399d24$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $3f0456472e399d24$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $3f0456472e399d24$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $3f0456472e399d24$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $3f0456472e399d24$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $3f0456472e399d24$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
} // Private
function $3f0456472e399d24$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $3f0456472e399d24$var$DataLoader;

});

parcelRegister("aTD8J", function(module, exports) {
// Packages

var $kiPA0 = parcelRequire("kiPA0");
function $7eed66c63d4af541$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        var op = $kiPA0.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $7eed66c63d4af541$var$retry;

});
parcelRegister("kiPA0", function(module, exports) {

module.exports = (parcelRequire("2aMUW"));

});
parcelRegister("2aMUW", function(module, exports) {

var $6ZiEJ = parcelRequire("6ZiEJ");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $6ZiEJ(timeouts, {
        forever: options && options.forever,
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("6ZiEJ", function(module, exports) {
function $5166e949108ea881$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $5166e949108ea881$var$RetryOperation;
$5166e949108ea881$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts;
};
$5166e949108ea881$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$5166e949108ea881$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(this._errors.length - 1, this._errors.length);
            this._timeouts = this._cachedTimeouts.slice(0);
            timeout = this._timeouts.shift();
        } else return false;
    }
    var self = this;
    var timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) timer.unref();
    return true;
};
$5166e949108ea881$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$5166e949108ea881$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = $5166e949108ea881$var$RetryOperation.prototype.try;
$5166e949108ea881$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$5166e949108ea881$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$5166e949108ea881$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("bsIpz", function(module, exports) {
'use strict';
class $8584c26edaaf8f93$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $8584c26edaaf8f93$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $8584c26edaaf8f93$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $8584c26edaaf8f93$var$pThrottle;
module.exports.AbortError = $8584c26edaaf8f93$var$AbortError;

});

parcelRegister("f9yXU", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $eab65a9e311d10e1$export$3e5b797e39668f84);
class $eab65a9e311d10e1$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`);
        this.kind = kind;
        this.hostname = hostname;
        this.message = message;
        this.type = type;
        this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("dUrSu", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $67d3f38f231759a2$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $67d3f38f231759a2$export$dc37652c1696f231);
const $67d3f38f231759a2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $67d3f38f231759a2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $67d3f38f231759a2$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $67d3f38f231759a2$export$e2b040f052407032 = {
    dev: $67d3f38f231759a2$var$devBaseUrl,
    development: $67d3f38f231759a2$var$devBaseUrl,
    stg: $67d3f38f231759a2$var$stgBaseUrl,
    staging: $67d3f38f231759a2$var$stgBaseUrl,
    prd: $67d3f38f231759a2$var$prodBaseUrl,
    prod: $67d3f38f231759a2$var$prodBaseUrl,
    production: $67d3f38f231759a2$var$prodBaseUrl
};
const $67d3f38f231759a2$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $67d3f38f231759a2$export$e2b040f052407032 ? $67d3f38f231759a2$export$e2b040f052407032[envKey] : $67d3f38f231759a2$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $67d3f38f231759a2$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $67d3f38f231759a2$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $67d3f38f231759a2$export$2e2bcd8739ae039 = $67d3f38f231759a2$export$e2b040f052407032;

});

parcelRegister("5LW2w", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $182a4c691eac998e$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $182a4c691eac998e$export$b5fe3f66a567bec0);
const $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $182a4c691eac998e$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $182a4c691eac998e$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $182a4c691eac998e$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("gbc85", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $fe0c9814ae7f11c7$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $fe0c9814ae7f11c7$export$bea7bee8a87e7c52);
const $fe0c9814ae7f11c7$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $fe0c9814ae7f11c7$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});



parcelRegister("tHNWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $db265079fb49f286$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $knPb9 = parcelRequire("knPb9");

var $kJlBc = parcelRequire("kJlBc");
var // eslint-disable-next-line jira/import/no-anonymous-default-export, @typescript-eslint/no-unnecessary-type-constraint
$db265079fb49f286$export$2e2bcd8739ae039 = (WrappedComponent)=>{
    const WithLinkActions = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.RouterActions), null, (linkActions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                linkActions: linkActions,
                ...props
            }));
    WithLinkActions.displayName = `withLinkActions(${(0, $knPb9.getDisplayName)(WrappedComponent)})`;
    // @ts-expect-error - TS2322 - Type '{ (props: Config): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<Config, any>'.
    return WithLinkActions;
};

});
parcelRegister("knPb9", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", () => $e1b771d5f606c17c$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $e1b771d5f606c17c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $e1b771d5f606c17c$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $e1b771d5f606c17c$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$e1b771d5f606c17c$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $e1b771d5f606c17c$export$2e2bcd8739ae039 = $e1b771d5f606c17c$var$withInjectedProps;

});


parcelRegister("2gfkg", function(module, exports) {

$parcel$export(module.exports, "default", () => $929b183610ddd87e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lHf0X = parcelRequire("lHf0X");

var $hyzq3 = parcelRequire("hyzq3");

var $iPhjO = parcelRequire("iPhjO");
/**
 * HOC to add a mediaProvider:promise prop for use in Atlaskit components.
 * Funky promise logic waits until the viewContext is available before resolving
 * @see https://atlaskit.atlassian.com/packages/media/media-picker#auth-provider
 * @see also ../token-provider which we consume here, and works in much the same way
 */ const $929b183610ddd87e$var$withMediaProvider = (WrappedComponent)=>(props)=>{
        const mediaProviderPromise = (0, $eUqFw.useRef)(new (0, $lHf0X.PromiseProvider)());
        const { mediaContext: mediaContext, onViewRefresh: onViewRefresh, onUploadRefresh: onUploadRefresh, ...otherProps } = props;
        const tokenProvider = (0, $iPhjO.useTokenProvider)(mediaContext, onViewRefresh, onUploadRefresh);
        (0, $eUqFw.useEffect)(()=>{
            if (mediaProviderPromise.current.status !== 'resolved' && mediaContext.viewContext) {
                const mediaProvider = (0, $hyzq3.default)(mediaContext, tokenProvider, props.baseUrl);
                mediaProviderPromise.current.resolve(mediaProvider);
            }
        }, [
            mediaContext,
            props.baseUrl,
            tokenProvider
        ]);
        const mediaProvider = mediaProviderPromise.current.get();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...otherProps,
            mediaProvider: mediaProvider
        });
    };
var $929b183610ddd87e$export$2e2bcd8739ae039 = $929b183610ddd87e$var$withMediaProvider;

});
parcelRegister("lHf0X", function(module, exports) {

$parcel$export(module.exports, "PromiseProvider", () => $0fe60fcd8e4ff962$export$63491cd71a5483a1);
class $0fe60fcd8e4ff962$export$63491cd71a5483a1 {
    /**
	 * Defining properties with exclamation mark via constructor
	 * invoke reset()
	 */ constructor(){
        this.reset();
    }
    get() {
        return this.promise;
    }
    resolve(value) {
        this.resetIfSettled();
        this.resolvePromise(value);
        this.status = 'resolved';
    }
    reject() {
        this.resetIfSettled();
        this.rejectPromise();
        this.status = 'rejected';
    }
    resetIfSettled() {
        const isSettled = this.status !== 'pending';
        if (isSettled) this.reset();
    }
    reset() {
        this.promise = new Promise((resolve, reject)=>{
            this.resolvePromise = resolve;
            this.rejectPromise = reject;
        });
        this.status = 'pending';
    }
}

});

parcelRegister("hyzq3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f51e7a70cf92aa67$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $1ybV0 = parcelRequire("1ybV0");

var $eU1AE = parcelRequire("eU1AE");

var $eUPCT = parcelRequire("eUPCT");

var $hEEI6 = parcelRequire("hEEI6");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f51e7a70cf92aa67$export$2e2bcd8739ae039 = (mediaContext, tokenProvider, baseUrl)=>{
    const { viewContext: viewContext, uploadContext: uploadContext } = mediaContext;
    // In practice this shouldn't happen, but our types don't accurately
    // reflect our assumptions. We should migrate to use the MediaAuth sub-apps
    // to manage this: https://jdog.jira-dev.com/browse/BENTO-1997
    if (!viewContext) throw new TypeError('mediaContext.viewContext was null. Check that the server response has been processed.');
    const viewMediaClientConfig = {
        authProvider: (0, $eUPCT.createAuthProvider)(tokenProvider, viewContext.clientId, viewContext.serviceHost),
        ...(0, $1ybV0.ff)('issue.details.update-media-config-to-sha256') ? {
            useSha256ForUploads: true
        } : {}
    };
    let mediaProvider = {
        viewMediaClientConfig: viewMediaClientConfig
    };
    if (uploadContext) mediaProvider = {
        ...mediaProvider,
        uploadParams: {
            collection: uploadContext.collection
        },
        uploadMediaClientConfig: {
            authProvider: (0, $eUPCT.createAuthProvider)(tokenProvider, uploadContext.clientId, uploadContext.serviceHost),
            ...(0, $1ybV0.ff)('issue.details.update-media-config-to-sha256') ? {
                useSha256ForUploads: true
            } : {},
            /**
				 * contextId === origin issue id (from where the file was copied)
				 * In this provider we return a view token for the origin file
				 */ getAuthFromContext: async (contextId)=>{
                const maxTokenLength = 65536;
                const authContext = await (0, $eU1AE.fetchIssueMediaReadPermission$)(baseUrl, contextId, maxTokenLength).map((0, $hEEI6.viewContextTransformer)).toPromise();
                return {
                    baseUrl: authContext.serviceHost,
                    clientId: authContext.clientId,
                    token: authContext.token || ''
                };
            }
        }
    };
    return mediaProvider;
};

});
parcelRegister("eUPCT", function(module, exports) {

$parcel$export(module.exports, "createAuthProvider", () => $628148f40aa8a6d1$export$6176af039388fdbf);
const $628148f40aa8a6d1$export$6176af039388fdbf = (tokenProvider, clientId, baseUrl)=>async (context)=>({
            clientId: clientId,
            token: await tokenProvider(context ? context.collectionName : undefined),
            baseUrl: baseUrl
        });

});


parcelRegister("iPhjO", function(module, exports) {

$parcel$export(module.exports, "useTokenProvider", () => $6dd298eb1ecab35b$export$3a1401e33545f0b0);

var $eUqFw = parcelRequire("eUqFw");

var $lHf0X = parcelRequire("lHf0X");

var $hEEI6 = parcelRequire("hEEI6");
const $6dd298eb1ecab35b$export$1b94063a8d31d769 = (mediaContext)=>{
    const { viewContext: viewContext } = mediaContext;
    if (!viewContext) return null;
    if (!viewContext.areTokenPermissionsUpToDate) return null;
    if (typeof viewContext.token !== 'string' || viewContext.token === '') return null;
    return viewContext.token;
};
function $6dd298eb1ecab35b$export$e7101f6bb26ef7f2(tokenPromiseProvider, tokenContext) {
    if (tokenPromiseProvider.status !== 'resolved') return false;
    if (tokenContext === null) return false;
    if ((0, $hEEI6.isTokenValid)(tokenContext)) return false;
    return true;
}
function $6dd298eb1ecab35b$export$3a1401e33545f0b0(mediaContext, onViewRefresh, onUploadRefresh) {
    const viewTokenPromiseProvider = (0, $eUqFw.useRef)(new (0, $lHf0X.PromiseProvider)());
    const uploadTokenPromiseProvider = (0, $eUqFw.useRef)(new (0, $lHf0X.PromiseProvider)());
    /**
	 * @param collection - Truthy when requesting an upload token. Falsy on view.
	 */ const tokenProvider = (0, $eUqFw.useCallback)(async (collection)=>{
        const shouldReturnReadToken = !collection;
        // READ TOKEN
        if (shouldReturnReadToken) {
            const shouldRefresh = !!onViewRefresh && $6dd298eb1ecab35b$export$e7101f6bb26ef7f2({
                status: viewTokenPromiseProvider.current.status
            }, mediaContext.viewContext);
            if (shouldRefresh) {
                // reset our promise & force a token refresh
                viewTokenPromiseProvider.current.resetIfSettled();
                onViewRefresh();
            }
            // if token exists, resolve it. Otherwise wait for aforementioned refresh.
            return viewTokenPromiseProvider.current.get();
        }
        // UPLOAD TOKEN
        // TODO BENTO-12541: this doesn't yet check for token validity like the upload token does.
        const uploadToken = mediaContext.uploadContext?.token;
        if (!uploadToken) {
            if (onUploadRefresh) onUploadRefresh();
            throw new Error('Upload token not available');
        }
        return uploadTokenPromiseProvider.current.get();
    }, [
        mediaContext.uploadContext?.token,
        mediaContext.viewContext,
        onUploadRefresh,
        onViewRefresh
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const readToken = $6dd298eb1ecab35b$export$1b94063a8d31d769(mediaContext);
        if (readToken === null) viewTokenPromiseProvider.current.resetIfSettled();
        else viewTokenPromiseProvider.current.resolve(readToken);
        const uploadToken = mediaContext.uploadContext?.token;
        if (uploadToken) uploadTokenPromiseProvider.current.resolve(uploadToken);
        else uploadTokenPromiseProvider.current.resetIfSettled();
    }, [
        mediaContext
    ]);
    return tokenProvider;
}

});


parcelRegister("9XfZZ", function(module, exports) {

$parcel$export(module.exports, "isExternalLink", () => $037fcbfba11ab4d5$export$b98882f166bb7ce2);
$parcel$export(module.exports, "onLinkClick", () => $037fcbfba11ab4d5$export$dccc97e4cadc9724);
$parcel$export(module.exports, "smartLinksDefault", () => $037fcbfba11ab4d5$export$4f1b881d7a962ce6);
$parcel$export(module.exports, "useSmartCardProductType", () => $037fcbfba11ab4d5$export$3f864e37674c79e7);
$parcel$export(module.exports, "useSmartCardIsAIEnabled", () => $037fcbfba11ab4d5$export$af081b1242bfa300);
$parcel$export(module.exports, "SmartCardProviderWithAIHooks", () => $037fcbfba11ab4d5$export$ca9fa6647337e334);

var $eUqFw = parcelRequire("eUqFw");

var $aml13 = parcelRequire("aml13");

var $cua7B = parcelRequire("cua7B");

var $7ZZxN = parcelRequire("7ZZxN");

var $hJ992 = parcelRequire("hJ992");

var $4zUUC = parcelRequire("4zUUC");

var $guDlK = parcelRequire("guDlK");
const $037fcbfba11ab4d5$var$isLeftClick = (event)=>event.button === 0;
const $037fcbfba11ab4d5$var$isMiddleClick = (event)=>event.button === 1;
const $037fcbfba11ab4d5$var$isCmdOrCtrlClick = (event)=>$037fcbfba11ab4d5$var$isLeftClick(event) && (event.metaKey || event.ctrlKey);
const $037fcbfba11ab4d5$export$b98882f166bb7ce2 = (url)=>{
    const { hostname: hostname, pathname: pathname } = new URL(url);
    return hostname !== window.location.hostname || ![
        '/jira',
        '/browse'
    ].some((includedPath)=>pathname.startsWith(includedPath));
};
const $037fcbfba11ab4d5$export$dccc97e4cadc9724 = (event, url)=>{
    if (!url) return;
    if ($037fcbfba11ab4d5$export$b98882f166bb7ce2(url)) {
        event.preventDefault();
        window.open(url, '_blank', 'noopener,noreferrer');
        return;
    }
    if (event.defaultPrevented) {
        // The default has already been prevented meaning that we need to open links in one
        // way or another to ensure we do eventually open the link
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const mouseEvent = event;
        $037fcbfba11ab4d5$var$isCmdOrCtrlClick(mouseEvent) || $037fcbfba11ab4d5$var$isMiddleClick(mouseEvent) ? window.open(url, '_blank', 'noopener,noreferrer') : window.location.assign(url);
    }
};
const $037fcbfba11ab4d5$export$4f1b881d7a962ce6 = {
    actionOptions: {
        hide: false,
        exclude: [
            (0, $cua7B.CardAction).ChangeStatusAction
        ]
    }
};
const $037fcbfba11ab4d5$export$4761115a9e18aa47 = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.CORE_PROJECT:
            return 'JWM';
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return 'JPD';
        default:
            return undefined;
    }
};
const $037fcbfba11ab4d5$export$3f864e37674c79e7 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const product = (0, $eUqFw.useMemo)(()=>// Arbitarily default to Jira Software if not specified
        $037fcbfba11ab4d5$export$4761115a9e18aa47(projectType) ?? 'JSW', [
        projectType
    ]);
    return product;
};
const $037fcbfba11ab4d5$export$af081b1242bfa300 = ()=>{
    const isAiOptInEnabled = (0, $hJ992.useIsAiOptInEnabled)();
    const isPremium = (0, $4zUUC.useIsPremium)();
    const isAIFeatureEnabled = (0, $eUqFw.useMemo)(()=>isAiOptInEnabled && isPremium, [
        isAiOptInEnabled,
        isPremium
    ]);
    return isAIFeatureEnabled;
};
const $037fcbfba11ab4d5$export$ca9fa6647337e334 = (props)=>{
    const product = $037fcbfba11ab4d5$export$3f864e37674c79e7();
    const isAIEnabled = $037fcbfba11ab4d5$export$af081b1242bfa300();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), {
        product: product,
        isAdminHubAIEnabled: isAIEnabled,
        ...props
    }, props.children);
};

});
parcelRegister("cua7B", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $91702356cf7549fe$export$f40b7e0b762b928b);
let $91702356cf7549fe$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});

parcelRegister("4zUUC", function(module, exports) {

$parcel$export(module.exports, "useIsPremium", () => $800159a3fd254246$export$1bb5840a003dc643);
$parcel$export(module.exports, "useCanOptIn", () => $800159a3fd254246$export$bd66bcf1f00b19d2);
$parcel$export(module.exports, "useAIOptIn", () => $800159a3fd254246$export$49e57b9044cda91c);

var $eUqFw = parcelRequire("eUqFw");

var $9dp5m = parcelRequire("9dp5m");

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $guDlK = parcelRequire("guDlK");

var $jD3pk = parcelRequire("jD3pk");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");
var $1R3n5 = parcelRequire("1R3n5");

var $6dejM = parcelRequire("6dejM");

var $feY12 = parcelRequire("feY12");
const $800159a3fd254246$export$1bb5840a003dc643 = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    if (!appEditions) return false;
    switch(projectType){
        case 0, $7ZZxN.CORE_PROJECT:
            return appEditions.core === (0, $6WXNs.PREMIUM_EDITION);
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return appEditions.software === (0, $6WXNs.PREMIUM_EDITION);
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $6WXNs.PREMIUM_EDITION);
        default:
            return false;
    }
};
const $800159a3fd254246$export$10e0dafdd792475b = ()=>{
    // upsell us for standard but not free subscription admins
    const appEditions = (0, $ab6rA.useAppEditions)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    if (!appEditions) return false;
    switch(projectType){
        case 0, $7ZZxN.CORE_PROJECT:
            return appEditions.core === (0, $6WXNs.STANDARD_EDITION);
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return appEditions.software === (0, $6WXNs.STANDARD_EDITION);
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $6WXNs.STANDARD_EDITION);
        default:
            return false;
    }
};
const $800159a3fd254246$export$bd66bcf1f00b19d2 = ()=>{
    const isOrgAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isPremium = $800159a3fd254246$export$1bb5840a003dc643();
    return isOrgAdmin && isPremium;
};
const $800159a3fd254246$export$1276193c77ae88bf = ()=>{
    const isOrgAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isStandard = $800159a3fd254246$export$10e0dafdd792475b();
    return (0, $1ybV0.ff)('jsw-premium-edition-eval-admin-ai-upsell_djht5') && isOrgAdmin && isStandard;
};
const $800159a3fd254246$export$5e56b08674e48311 = (isAIOptedIn, product)=>{
    const canOptIn = $800159a3fd254246$export$bd66bcf1f00b19d2();
    const canStartPremiumTrial = $800159a3fd254246$export$1276193c77ae88bf();
    const isValidForGlobalOptIn = [
        product !== 'JPD',
        canOptIn
    ].every((condition)=>condition === true);
    const isValidForPremiumTrial = canStartPremiumTrial && product !== 'JPD';
    const globalOptInEnabled = isValidForGlobalOptIn || isValidForPremiumTrial ? 'disabled-opt-in' : 'disabled';
    return isAIOptedIn ? 'enabled' : globalOptInEnabled;
};
const $800159a3fd254246$export$49e57b9044cda91c = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
    const { isAiOptInEnabled: isAiOptInEnabled, product: product } = editorPluginAIConfig || {};
    const optInStatus = $800159a3fd254246$export$5e56b08674e48311(isAiOptInEnabled, product);
    const isOrgAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const [showOptInModal, setShowOptInModal] = (0, $eUqFw.useState)(false);
    const [showPremiumTrialModal, setShowPremiumTrialModal] = (0, $eUqFw.useState)(false);
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const canStartTrial = $800159a3fd254246$export$1276193c77ae88bf();
    // Callback that will be called when AI buttons are clicked and opt in status is disabled-op-in
    const triggerOptInFlow = (0, $eUqFw.useCallback)(()=>{
        setShowOptInModal(true);
    }, [
        setShowOptInModal
    ]);
    // alt callback for standard admins to trigger a premium upsell in order to opt in
    const triggerUpsellFlow = (0, $eUqFw.useCallback)(()=>{
        setShowPremiumTrialModal(true);
    }, [
        setShowPremiumTrialModal
    ]);
    const aiOptInModal = (0, $eUqFw.useMemo)(()=>{
        const onCloseModal = ()=>setShowOptInModal(false);
        const adminLink = `${(0, $9dp5m.getATLContextUrl)('admin')}/o/${orgId}/atlassian-intelligence`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6dejM.OptInModal), {
            showOptInModal: showOptInModal,
            isOrgAdmin: isOrgAdmin,
            onCloseModal: onCloseModal,
            adminLink: adminLink
        });
    }, [
        orgId,
        isOrgAdmin,
        showOptInModal
    ]);
    const aiUpsellModal = (0, $eUqFw.useMemo)(()=>{
        const onCloseModal = ()=>setShowPremiumTrialModal(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $feY12.AIUpsellPremiumTrialEntryPointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6dejM.OptInUpsellModal), {
            "data-testid": "platform-react-hooks-use-ai-opt-in.upsell-modal",
            showPremiumTrialModal: showPremiumTrialModal,
            onCloseModal: onCloseModal
        }));
    }, [
        showPremiumTrialModal
    ]);
    if (optInStatus === 'disabled' || optInStatus === 'enabled') return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: null
    };
    if (canStartTrial && optInStatus === 'disabled-opt-in') return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerUpsellFlow,
        AIOptInModal: aiUpsellModal
    };
    return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: aiOptInModal
    };
};

});
parcelRegister("1R3n5", function(module, exports) {

$parcel$export(module.exports, "useIsSiteAdmin", () => $ae5c0c470cafb895$export$f9f8a5cdb0c565ef);

var $gd0Sp = parcelRequire("gd0Sp");
const $ae5c0c470cafb895$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("6dejM", function(module, exports) {

$parcel$export(module.exports, "OptInModal", () => $8791f6e76183d407$export$1697f043758ae8d2);
$parcel$export(module.exports, "OptInUpsellModal", () => $8791f6e76183d407$export$bbf8d259a508a485);

var $eUqFw = parcelRequire("eUqFw");

var $aOw1G = parcelRequire("aOw1G");
var $dxopF = parcelRequire("dxopF");

var $9vHw1 = parcelRequire("9vHw1");

var $1HzcR = parcelRequire("1HzcR");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3RDyu = parcelRequire("3RDyu");

var $feY12 = parcelRequire("feY12");
const $8791f6e76183d407$export$1697f043758ae8d2 = ({ showOptInModal: showOptInModal, onCloseModal: onCloseModal, isOrgAdmin: isOrgAdmin, adminLink: adminLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, showOptInModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9vHw1.default), {
        source: "jira-editor",
        product: "jira",
        isOrgAdmin: isOrgAdmin,
        onAdminClose: onCloseModal,
        adminLink: adminLink
    })));
const $8791f6e76183d407$export$bbf8d259a508a485 = ({ showPremiumTrialModal: showPremiumTrialModal, onCloseModal: onCloseModal })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $eUqFw.useContext)((0, $feY12.AIUpsellPremiumTrialEntryPointContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            onClose: ()=>{
                entryPointActions.unload();
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'button',
                    action: 'clicked'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'closePremiumTrialModalFromIssueAiUpsell');
            }
        }), [
        entryPointActions,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, showPremiumTrialModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3RDyu.AIOptInPremiumUpsell), {
        onClose: onCloseModal
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-entry-point-container",
        packageName: "platform-react-hooks-use-ai-opt-in",
        runtimeProps: runtimeProps
    }));
};

});
parcelRegister("9vHw1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec8c392cec73ed0$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $6jXP0 = parcelRequire("6jXP0");

var $7sAaO = parcelRequire("7sAaO");

var $1wBYZ = parcelRequire("1wBYZ");

var $jcokr = parcelRequire("jcokr");
const $6ec8c392cec73ed0$var$DEFAULT_GAS_CHANNEL = 'fabric-elements';
const $6ec8c392cec73ed0$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const defaultHeader = formatMessage((0, $1wBYZ.messages).aiOptInDialogHeaderText);
    const header = headerText !== null && headerText !== void 0 ? headerText : defaultHeader;
    const body = bodyText !== null && bodyText !== void 0 ? bodyText : formatMessage((0, $1wBYZ.messages).aiOptInDialogBodyText);
    const orgAdminBody = formatMessage((0, $1wBYZ.messages).aiOptInDialogAdminBodyText);
    const orgAdminHeader = adminHeaderText !== null && adminHeaderText !== void 0 ? adminHeaderText : defaultHeader;
    const WAC_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
    const ADMIN_LINK = 'http://admin.atlassian.com/';
    (0, $eUqFw.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($7sAaO)))
        ]);
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiGlobalOptInDialog',
                attributes: {
                    source: source,
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                }
            }
        }).fire($6ec8c392cec73ed0$var$DEFAULT_GAS_CHANNEL);
    }, [
        createAnalyticsEvent,
        source,
        product,
        isOrgAdmin
    ]);
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                attributes: {
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                }
            }
        }).fire($6ec8c392cec73ed0$var$DEFAULT_GAS_CHANNEL);
    };
    const onCloseClicked = (e)=>{
        e.stopPropagation();
        onAdminClose === null || onAdminClose === void 0 || onAdminClose();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                attributes: {
                    product: product
                }
            }
        }).fire($6ec8c392cec73ed0$var$DEFAULT_GAS_CHANNEL);
    };
    const onCTAClicked = (e)=>{
        e.stopPropagation();
        onAdminCTA === null || onAdminCTA === void 0 || onAdminCTA();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                attributes: {
                    product: product
                }
            }
        }).fire($6ec8c392cec73ed0$var$DEFAULT_GAS_CHANNEL);
    };
    const getAdminBody = ()=>{
        return adminBodyText !== null && adminBodyText !== void 0 ? adminBodyText : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, orgAdminBody, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jcokr.OrgAdminDefaultBodyWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $1wBYZ.messages).aiOptInDialogAdminTurnOnText, {
            values: {
                a: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                        href: WAC_LINK,
                        target: "_blank",
                        onClick: onLearnMoreClicked
                    }, s)
            }
        }))));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jcokr.OptInBackgroundBorder), {
        width: width,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jcokr.OptInContainer), null, image ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jcokr.ImageWrapper), null, image) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jcokr.ImageWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7sAaO))),
        height: "96px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jcokr.ContentContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jcokr.HeaderWrapper), null, isOrgAdmin ? orgAdminHeader : header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jcokr.BodyWrapper), null, isOrgAdmin ? getAdminBody() : body), !isOrgAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6jXP0.default), {
        appearance: "link",
        spacing: "none",
        href: WAC_LINK,
        target: "_blank",
        onClick: onLearnMoreClicked
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jcokr.LearnMoreWrapper), null, formatMessage((0, $1wBYZ.messages).aiOptInDialogLearnMoreLinkText))), isOrgAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jcokr.ButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6jXP0.default), {
        appearance: "subtle",
        onClick: onCloseClicked,
        testId: "admin-close-button"
    }, adminCloseCTAText !== null && adminCloseCTAText !== void 0 ? adminCloseCTAText : formatMessage((0, $1wBYZ.messages).aiOptInDialogAdminCloseButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6jXP0.default), {
        appearance: "primary",
        onClick: onCTAClicked,
        href: adminLink !== null && adminLink !== void 0 ? adminLink : ADMIN_LINK,
        target: "_blank",
        testId: "admin-cta-button"
    }, adminCTAText !== null && adminCTAText !== void 0 ? adminCTAText : formatMessage((0, $1wBYZ.messages).aiOptInDialogAdminLetsGoButtonText))))));
};
var $6ec8c392cec73ed0$export$2e2bcd8739ae039 = $6ec8c392cec73ed0$var$AiOptIn;

});
parcelRegister("6jXP0", function(module, exports) {

$parcel$export(module.exports, "default", () => $49a2ebc5382ea128$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $6rmE5 = parcelRequire("6rmE5");

var $2WaGV = parcelRequire("2WaGV");

var $caui1 = parcelRequire("caui1");

var $8SqSE = parcelRequire("8SqSE");
const $49a2ebc5382ea128$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $49a2ebc5382ea128$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $5Q9wj.default), onMouseUp: providedOnMouseUp = (0, $5Q9wj.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const { mode: mode } = (0, $6rmE5.useGlobalTheme)();
    const isOnlySingleIcon = (0, $8SqSE.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $eUqFw.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($49a2ebc5382ea128$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $eUqFw.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($49a2ebc5382ea128$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $eUqFw.useMemo)(()=>(0, $caui1.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2WaGV.default), (0, $kU09D.default)({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$49a2ebc5382ea128$var$Button.displayName = 'Button';
var $49a2ebc5382ea128$export$2e2bcd8739ae039 = $49a2ebc5382ea128$var$Button;

});
parcelRegister("2WaGV", function(module, exports) {

$parcel$export(module.exports, "default", () => $22394a9dc4c285e7$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $hhlqA = parcelRequire("hhlqA");

var $51sCz = parcelRequire("51sCz");

var $jsCXU = parcelRequire("jsCXU");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $PDNvX = parcelRequire("PDNvX");

var $caui1 = parcelRequire("caui1");

var $21qhm = parcelRequire("21qhm");
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $22394a9dc4c285e7$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
const $22394a9dc4c285e7$var$iconBeforeSpacingFixStyle = (0, $byn9U.css)({
    marginLeft: "var(--ds-space-negative-025, -2px)"
});
const $22394a9dc4c285e7$var$iconAfterSpacingFixStyle = (0, $byn9U.css)({
    marginRight: "var(--ds-space-negative-025, -2px)"
});
const $22394a9dc4c285e7$var$getSpacingFix = (children, spacingStyles)=>{
    if (!(0, $XHGTv.getBooleanFF)('platform.design-system-team.icon-button-spacing-fix_o1zc5') || !children || (0, $21qhm.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $22394a9dc4c285e7$var$getChildren = (children, childrenStyles)=>{
    if ((0, $21qhm.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $byn9U.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $22394a9dc4c285e7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $5Q9wj.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $5Q9wj.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $eUqFw.useRef)();
    const setRef = (0, $eUqFw.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $hhlqA.default)(ourRef, autoFocus);
    const interactionContext = (0, $eUqFw.useContext)((0, $jsCXU.default));
    const handleClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "16.18.1",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $eUqFw.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    const fadeStyles = (0, $byn9U.css)((0, $caui1.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? `var(--ds-icon-subtle, ${0, $PdmhA.N500})` : `var(--ds-icon-warning-inverse, ${0, $PdmhA.N500})`} !important`
        }
    };
    return (0, $byn9U.jsx)((0, $51sCz.default), null, (0, $byn9U.jsx)(Component, (0, $kU09D.default)({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $22394a9dc4c285e7$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $PDNvX.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $byn9U.jsx)("span", {
        css: [
            fadeStyles,
            (0, $caui1.getIconStyle)({
                spacing: spacing
            }),
            $22394a9dc4c285e7$var$getSpacingFix(children, $22394a9dc4c285e7$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, !(0, $XHGTv.getBooleanFF)('platform.design-system-team.icon-button-spacing-fix_o1zc5') && children ? (0, $byn9U.jsx)("span", {
        css: [
            fadeStyles,
            (0, $caui1.getContentStyle)({
                spacing: spacing
            })
        ]
    }, children) : null, (0, $XHGTv.getBooleanFF)('platform.design-system-team.icon-button-spacing-fix_o1zc5') && $22394a9dc4c285e7$var$getChildren(children, [
        fadeStyles,
        (0, $caui1.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $byn9U.jsx)("span", {
        css: [
            fadeStyles,
            (0, $caui1.getIconStyle)({
                spacing: spacing
            }),
            $22394a9dc4c285e7$var$getSpacingFix(children, $22394a9dc4c285e7$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $byn9U.jsx)("span", {
        css: [
            (0, $caui1.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});

});
parcelRegister("PDNvX", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b3a283805995e9$export$2e2bcd8739ae039);
function $09b3a283805995e9$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $09b3a283805995e9$var$tabKeyCode = 9;
function $09b3a283805995e9$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $09b3a283805995e9$var$tabKeyCode) return;
    $09b3a283805995e9$var$abort(event);
}
const $09b3a283805995e9$var$block = {
    onMouseDownCapture: $09b3a283805995e9$var$abort,
    onMouseUpCapture: $09b3a283805995e9$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $09b3a283805995e9$var$onKey,
    onKeyUpCapture: $09b3a283805995e9$var$onKey,
    onTouchStartCapture: $09b3a283805995e9$var$abort,
    onTouchEndCapture: $09b3a283805995e9$var$abort,
    onPointerDownCapture: $09b3a283805995e9$var$abort,
    onPointerUpCapture: $09b3a283805995e9$var$abort,
    onClickCapture: $09b3a283805995e9$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $09b3a283805995e9$var$abort
};
const $09b3a283805995e9$var$doNotBlock = {};
function $09b3a283805995e9$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $09b3a283805995e9$var$doNotBlock : $09b3a283805995e9$var$block;
}

});

parcelRegister("caui1", function(module, exports) {

$parcel$export(module.exports, "getCss", () => $8dbdea2107a4c7dc$export$955358618f994a11);
$parcel$export(module.exports, "getIconStyle", () => $8dbdea2107a4c7dc$export$864eea3f4ec3368f);
$parcel$export(module.exports, "getContentStyle", () => $8dbdea2107a4c7dc$export$7ad0316cc0dd65a);
$parcel$export(module.exports, "getFadingCss", () => $8dbdea2107a4c7dc$export$1b5827d324e945b1);
$parcel$export(module.exports, "overlayCss", () => $8dbdea2107a4c7dc$export$1a9fe1b84c876bb5);

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");

var $i1S1i = parcelRequire("i1S1i");
const $8dbdea2107a4c7dc$var$gridSize = (0, $lcnyw.gridSize)();
const $8dbdea2107a4c7dc$var$fontSize = (0, $lcnyw.fontSize)();
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
const $8dbdea2107a4c7dc$var$heights = {
    default: `${$8dbdea2107a4c7dc$var$gridSize * 4 / $8dbdea2107a4c7dc$var$fontSize}em`,
    // 32px
    compact: `${$8dbdea2107a4c7dc$var$gridSize * 3 / $8dbdea2107a4c7dc$var$fontSize}em`,
    none: 'auto'
};
const $8dbdea2107a4c7dc$var$lineHeights = {
    default: $8dbdea2107a4c7dc$var$heights.default,
    compact: $8dbdea2107a4c7dc$var$heights.compact,
    none: 'inherit'
};
const $8dbdea2107a4c7dc$var$padding = {
    // 10px gutter
    default: `0 ${$8dbdea2107a4c7dc$var$gridSize + $8dbdea2107a4c7dc$var$gridSize / 4}px`,
    compact: `0 ${$8dbdea2107a4c7dc$var$gridSize + $8dbdea2107a4c7dc$var$gridSize / 4}px`,
    none: '0'
};
const $8dbdea2107a4c7dc$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$8dbdea2107a4c7dc$var$gridSize / 4}px`,
    default: `0 ${$8dbdea2107a4c7dc$var$gridSize / 4}px`,
    none: '0'
};
const $8dbdea2107a4c7dc$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $8dbdea2107a4c7dc$var$innerMargin = {
    content: `0 ${$8dbdea2107a4c7dc$var$gridSize / 4}px`,
    icon: `0 ${$8dbdea2107a4c7dc$var$gridSize / 4}px`
};
function $8dbdea2107a4c7dc$var$getColor({ group: group, key: key, mode: mode }) {
    const rule = group[key] || group.default;
    return rule[mode];
}
function $8dbdea2107a4c7dc$var$getColors({ appearance: appearance, key: key, mode: mode }) {
    return {
        background: $8dbdea2107a4c7dc$var$getColor({
            group: (0, $i1S1i.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: `${$8dbdea2107a4c7dc$var$getColor({
            group: (0, $i1S1i.default).color[appearance],
            key: key,
            mode: mode
        })} !important`
    };
}
function $8dbdea2107a4c7dc$export$955358618f994a11({ appearance: appearance, spacing: spacing, mode: mode, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    const baseColors = $8dbdea2107a4c7dc$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        // dynamic styles
        ...baseColors,
        cursor: 'pointer',
        height: $8dbdea2107a4c7dc$var$heights[spacing],
        lineHeight: $8dbdea2107a4c7dc$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $8dbdea2107a4c7dc$var$singleIconPadding[spacing] : $8dbdea2107a4c7dc$var$padding[spacing],
        verticalAlign: $8dbdea2107a4c7dc$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        // Disabling visited styles (just using the base colors)
        '&:visited': {
            ...baseColors
        },
        '&:hover': {
            ...$8dbdea2107a4c7dc$var$getColors({
                appearance: appearance,
                key: isSelected ? 'selected' : 'hover',
                mode: mode
            }),
            textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
            // background, box-shadow
            transitionDuration: '0s, 0.15s'
        },
        // giving active styles preference by listing them after focus
        '&:active': {
            ...$8dbdea2107a4c7dc$var$getColors({
                appearance: appearance,
                key: isSelected ? 'selected' : 'active',
                mode: mode
            }),
            // background, box-shadow
            transitionDuration: '0s, 0s'
        },
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': {
            ...$8dbdea2107a4c7dc$var$getColors({
                appearance: appearance,
                key: isSelected ? 'selected' : 'active',
                mode: mode
            }),
            // background, box-shadow
            transitionDuration: '0s, 0s'
        },
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        '&[disabled]': {
            // always using 'disabled' even when selected
            ...$8dbdea2107a4c7dc$var$getColors({
                appearance: appearance,
                key: 'disabled',
                mode: mode
            }),
            cursor: 'not-allowed',
            textDecoration: 'none'
        },
        '&[data-has-overlay="true"]': {
            cursor: 'default',
            textDecoration: 'none'
        },
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': {
            ...$8dbdea2107a4c7dc$var$getColors({
                appearance: appearance,
                key: isSelected ? 'selected' : 'default',
                mode: mode
            })
        },
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}
function $8dbdea2107a4c7dc$export$864eea3f4ec3368f({ spacing: spacing }) {
    return (0, $byn9U.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === 'none' ? 0 : $8dbdea2107a4c7dc$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        fontSize: 0,
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $8dbdea2107a4c7dc$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === 'none' ? 0 : $8dbdea2107a4c7dc$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $8dbdea2107a4c7dc$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return (0, $byn9U.css)({
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
const $8dbdea2107a4c7dc$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});
parcelRegister("i1S1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2023939bde06ec4$export$2e2bcd8739ae039);

var $PdmhA = parcelRequire("PdmhA");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
const $d2023939bde06ec4$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
const $d2023939bde06ec4$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: `var(--ds-background-neutral, ${$PdmhA.N20A})`,
                dark: `var(--ds-background-neutral, ${$PdmhA.DN70})`
            },
            hover: {
                light: `var(--ds-background-neutral-hovered, ${$PdmhA.N30A})`,
                dark: `var(--ds-background-neutral-hovered, ${$PdmhA.DN60})`
            },
            active: {
                light: `var(--ds-background-neutral-pressed, ${$d2023939bde06ec4$var$fadedB75})`,
                dark: `var(--ds-background-neutral-pressed, ${$PdmhA.B75})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$PdmhA.N20A})`,
                dark: `var(--ds-background-disabled, ${$PdmhA.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.DN0})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.DN0})`
            }
        },
        primary: {
            default: {
                light: `var(--ds-background-brand-bold, ${$PdmhA.B400})`,
                dark: `var(--ds-background-brand-bold, ${$PdmhA.B100})`
            },
            hover: {
                light: `var(--ds-background-brand-bold-hovered, ${$PdmhA.B300})`,
                dark: `var(--ds-background-brand-bold-hovered, ${$PdmhA.B75})`
            },
            active: {
                light: `var(--ds-background-brand-bold-pressed, ${$PdmhA.B500})`,
                dark: `var(--ds-background-brand-bold-pressed, ${$PdmhA.B200})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$PdmhA.N20A})`,
                dark: `var(--ds-background-disabled, ${$PdmhA.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.DN0})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.DN0})`
            }
        },
        warning: {
            default: {
                light: `var(--ds-background-warning-bold, ${$PdmhA.Y300})`,
                dark: `var(--ds-background-warning-bold, ${$PdmhA.Y300})`
            },
            hover: {
                light: `var(--ds-background-warning-bold-hovered, ${$PdmhA.Y200})`,
                dark: `var(--ds-background-warning-bold-hovered, ${$PdmhA.Y200})`
            },
            active: {
                light: `var(--ds-background-warning-bold-pressed, ${$PdmhA.Y400})`,
                dark: `var(--ds-background-warning-bold-pressed, ${$PdmhA.Y400})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$PdmhA.N20A})`,
                dark: `var(--ds-background-disabled, ${$PdmhA.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$PdmhA.Y400})`,
                dark: `var(--ds-background-selected, ${$PdmhA.Y400})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$PdmhA.Y400})`,
                dark: `var(--ds-background-selected, ${$PdmhA.Y400})`
            }
        },
        danger: {
            default: {
                light: `var(--ds-background-danger-bold, ${$PdmhA.R400})`,
                dark: `var(--ds-background-danger-bold, ${$PdmhA.R400})`
            },
            hover: {
                light: `var(--ds-background-danger-bold-hovered, ${$PdmhA.R300})`,
                dark: `var(--ds-background-danger-bold-hovered, ${$PdmhA.R300})`
            },
            active: {
                light: `var(--ds-background-danger-bold-pressed, ${$PdmhA.R500})`,
                dark: `var(--ds-background-danger-bold-pressed, ${$PdmhA.R500})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$PdmhA.N20A})`,
                dark: `var(--ds-background-disabled, ${$PdmhA.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$PdmhA.R500})`,
                dark: `var(--ds-background-selected, ${$PdmhA.R500})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$PdmhA.R500})`,
                dark: `var(--ds-background-selected, ${$PdmhA.R500})`
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.N20})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.N20})`
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: `var(--ds-background-neutral-subtle-hovered, ${$PdmhA.N30A})`,
                dark: `var(--ds-background-neutral-subtle-hovered, ${$PdmhA.DN60})`
            },
            active: {
                light: `var(--ds-background-neutral-subtle-pressed, ${$d2023939bde06ec4$var$fadedB75})`,
                dark: `var(--ds-background-neutral-subtle-pressed, ${$PdmhA.B75})`
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.DN0})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.DN0})`
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.N20})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$PdmhA.N700})`,
                dark: `var(--ds-background-selected, ${$PdmhA.N20})`
            }
        }
    },
    color: {
        default: {
            default: {
                light: `var(--ds-text, ${$PdmhA.N500})`,
                dark: `var(--ds-text, ${$PdmhA.DN400})`
            },
            active: {
                light: `var(--ds-text, ${$PdmhA.B400})`,
                dark: `var(--ds-text, ${$PdmhA.B400})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$PdmhA.N70})`,
                dark: `var(--ds-text-disabled, ${$PdmhA.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.DN400})`
            }
        },
        primary: {
            default: {
                light: `var(--ds-text-inverse, ${$PdmhA.N0})`,
                dark: `var(--ds-text-inverse, ${$PdmhA.DN30})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$PdmhA.N70})`,
                dark: `var(--ds-text-disabled, ${$PdmhA.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.DN400})`
            }
        },
        warning: {
            default: {
                light: `var(--ds-text-warning-inverse, ${$PdmhA.N800})`,
                dark: `var(--ds-text-warning-inverse, ${$PdmhA.N800})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$PdmhA.N70})`,
                dark: `var(--ds-text-disabled, ${$PdmhA.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$PdmhA.N800})`,
                dark: `var(--ds-text-selected, ${$PdmhA.N800})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$PdmhA.N800})`,
                dark: `var(--ds-text-selected, ${$PdmhA.N800})`
            }
        },
        danger: {
            default: {
                light: `var(--ds-text-inverse, ${$PdmhA.N0})`,
                dark: `var(--ds-text-inverse, ${$PdmhA.N0})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$PdmhA.N70})`,
                dark: `var(--ds-text-disabled, ${$PdmhA.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$PdmhA.N0})`,
                dark: `var(--ds-text-selected, ${$PdmhA.N0})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$PdmhA.N0})`,
                dark: `var(--ds-text-selected, ${$PdmhA.N0})`
            }
        },
        link: {
            default: {
                light: `var(--ds-link, ${$PdmhA.B400})`,
                dark: `var(--ds-link, ${$PdmhA.B100})`
            },
            hover: {
                light: `var(--ds-link, ${$PdmhA.B300})`,
                dark: `var(--ds-link, ${$PdmhA.B75})`
            },
            active: {
                light: `var(--ds-link-pressed, ${$PdmhA.B500})`,
                dark: `var(--ds-link-pressed, ${$PdmhA.B200})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$PdmhA.N70})`,
                dark: `var(--ds-text-disabled, ${$PdmhA.DN100})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.N700})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.N700})`
            }
        },
        subtle: {
            default: {
                light: `var(--ds-text, ${$PdmhA.N500})`,
                dark: `var(--ds-text, ${$PdmhA.DN400})`
            },
            active: {
                light: `var(--ds-text, ${$PdmhA.B400})`,
                dark: `var(--ds-text, ${$PdmhA.B400})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$PdmhA.N70})`,
                dark: `var(--ds-text-disabled, ${$PdmhA.DN100})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.DN400})`
            }
        },
        'subtle-link': {
            default: {
                light: `var(--ds-text-subtle, ${$PdmhA.N200})`,
                dark: `var(--ds-text-subtle, ${$PdmhA.DN400})`
            },
            hover: {
                light: `var(--ds-text-subtle, ${$PdmhA.N90})`,
                dark: `var(--ds-text-subtle, ${$PdmhA.B50})`
            },
            active: {
                light: `var(--ds-text, ${$PdmhA.N400})`,
                dark: `var(--ds-text, ${$PdmhA.DN300})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$PdmhA.N70})`,
                dark: `var(--ds-text-disabled, ${$PdmhA.DN100})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$PdmhA.N20})`,
                dark: `var(--ds-text-selected, ${$PdmhA.DN400})`
            }
        }
    }
};
var $d2023939bde06ec4$export$2e2bcd8739ae039 = $d2023939bde06ec4$var$values;

});


parcelRegister("21qhm", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $17900f40449ff256$export$20bbd2efb0d734c4);

var $eUqFw = parcelRequire("eUqFw");

var $lkPEe = parcelRequire("lkPEe");
const $17900f40449ff256$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $eUqFw.isValidElement)(children) && children.type === (0, $lkPEe.default);
};

});


parcelRegister("8SqSE", function(module, exports) {

$parcel$export(module.exports, "default", () => $676837c1393ce9df$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $21qhm = parcelRequire("21qhm");
function $676837c1393ce9df$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.icon-button-spacing-fix_o1zc5') && (0, $21qhm.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("7sAaO", function(module, exports) {
module.exports = new URL("global-opt-in-default-image-banner.8c1c680b.svg", import.meta.url).toString();

});

parcelRegister("1wBYZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $11c63e2be6f4e650$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $11c63e2be6f4e650$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    /**
   * Messages for the AI Global Opt-in component
   */ aiOptInDialogHeaderText: {
        id: 'ai-opt-in.dialog.header.text',
        defaultMessage: 'Work smarter, not harder',
        description: 'Header text for AI Opt In Dialog'
    },
    aiOptInDialogBodyText: {
        id: 'ai-opt-in.dialog.body.text',
        defaultMessage: 'Get up to speed and consume information with ease, thanks to your virtual teammate. Share interest with your admin so they know to opt-in to Atlassian Intelligence.',
        description: 'Body text for AI Opt In Dialog'
    },
    aiOptInDialogLearnMoreLinkText: {
        id: 'ai-opt-in.dialog.learn-more.link.text',
        defaultMessage: 'Learn more about Atlassian Intelligence',
        description: 'Learn more link text for AI Opt In Dialog'
    },
    aiOptInDialogAdminBodyText: {
        id: 'ai-opt-in.dialog.admin.body.text',
        defaultMessage: 'Get everyone up to speed quickly and consume information with ease, thanks to your virtual teammate.',
        description: 'Body text for Admin version of AI Opt In Dialog'
    },
    aiOptInDialogAdminTurnOnText: {
        id: 'ai-opt-in.dialog.admin.turn-on.part-one.text',
        defaultMessage: 'Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration.',
        description: 'Turn on AI text'
    },
    aiOptInDialogAdminCloseButtonText: {
        id: 'ai-opt-in.dialog.admin.close.button.text',
        defaultMessage: 'Close',
        description: 'Admin close button text'
    },
    aiOptInDialogAdminLetsGoButtonText: {
        id: 'ai-opt-in.dialog.admin.lets-go.button.text',
        defaultMessage: "Let's go!",
        description: 'Admin Lets go button text'
    }
});

});

parcelRegister("jcokr", function(module, exports) {

$parcel$export(module.exports, "OptInBackgroundBorder", () => $dfa2027c42b63f97$export$24c280970213bb11);
$parcel$export(module.exports, "OptInContainer", () => $dfa2027c42b63f97$export$a0fab83bea8ccf2e);
$parcel$export(module.exports, "ImageWrapper", () => $dfa2027c42b63f97$export$75f07c36086c2c81);
$parcel$export(module.exports, "ContentContainer", () => $dfa2027c42b63f97$export$9d2b4227a95687cc);
$parcel$export(module.exports, "HeaderWrapper", () => $dfa2027c42b63f97$export$960a49cc3d27a090);
$parcel$export(module.exports, "BodyWrapper", () => $dfa2027c42b63f97$export$14966827497f4695);
$parcel$export(module.exports, "LearnMoreWrapper", () => $dfa2027c42b63f97$export$28d1deadd9d49afe);
$parcel$export(module.exports, "ButtonContainer", () => $dfa2027c42b63f97$export$eddf54ea3db8d0f0);
$parcel$export(module.exports, "OrgAdminDefaultBodyWrapper", () => $dfa2027c42b63f97$export$bf3fe1b48da36969);
/* styled.tsx generated by @compiled/babel-plugin v0.24.0 */ 
var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

const $dfa2027c42b63f97$export$24c280970213bb11 = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $9t7rW.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _16qsreen _2rko14y2 _1yt4v77o _kqswh2mm _11q7z742",
            __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
            __cmplp.className
        ])
    }));
});
const $dfa2027c42b63f97$export$a0fab83bea8ccf2e = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    }));
});
const $dfa2027c42b63f97$export$75f07c36086c2c81 = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1k7a _1e0c1txw _1jpx1dfr _mezj1osq _1biu1k7a",
            __cmplp.className
        ])
    }));
});
const $dfa2027c42b63f97$export$9d2b4227a95687cc = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt41ejb _2lx21bp4 _1wpz1fhb _zulpu2gc _4cvr1y6m",
            __cmplp.className
        ])
    }));
});
const $dfa2027c42b63f97$export$960a49cc3d27a090 = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l _1wyb7vkz _vwz4gktf",
            __cmplp.className
        ])
    }));
});
const $dfa2027c42b63f97$export$14966827497f4695 = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybdlk8 _vwz4gktf",
            __cmplp.className
        ])
    }));
});
const $dfa2027c42b63f97$export$28d1deadd9d49afe = (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1nn1",
            __cmplp.className
        ])
    }));
});
const $dfa2027c42b63f97$export$eddf54ea3db8d0f0 = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _19pku2gc _1bahesu3 _zulp1b66",
            __cmplp.className
        ])
    }));
});
const $dfa2027c42b63f97$export$bf3fe1b48da36969 = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    }));
});

});


parcelRegister("1HzcR", function(module, exports) {

$parcel$export(module.exports, "JiraEntryPointContainer", () => $48716810ae87e4eb$export$ee1e46af8fa2fb93);

var $eUqFw = parcelRequire("eUqFw");

var $P6D7Q = parcelRequire("P6D7Q");

var $ioLN0 = parcelRequire("ioLN0");
const $48716810ae87e4eb$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $P6D7Q.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ioLN0.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $48716810ae87e4eb$export$54db9e88249c9162 = (0, $ioLN0.InternalEntryPointContainer);

});
parcelRegister("P6D7Q", function(module, exports) {

$parcel$export(module.exports, "useEntryPointSubscription", () => $f27db5d96682fc65$export$3cd1c81e13390c49);

var $eUqFw = parcelRequire("eUqFw");
const $f27db5d96682fc65$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $eUqFw.useState)(subject.getValue);
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    return entryPointReference;
};

});

parcelRegister("ioLN0", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $d11d0c1bfdfee8c0$export$5d4dc37edd8a3adb);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");
const $d11d0c1bfdfee8c0$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});
parcelRegister("jK1pm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f009785aaee067$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $5iuyH = parcelRequire("5iuyH");

var $fVaJL = parcelRequire("fVaJL");

var $232mI = parcelRequire("232mI");
/** A portion of the page we apply measurement to */ function $f6f009785aaee067$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $5iuyH.useInteractionContext)();
    const relayProfilerContext = (0, $eUqFw.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $eUqFw.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    this.getInteractionContext().addPreload((0, $fVaJL.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $fVaJL.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children));
}
function $f6f009785aaee067$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $232mI.default), {
        name: segmentName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6f009785aaee067$var$JiraUFOSegmentWrapper, null, children));
}

});



parcelRegister("3RDyu", function(module, exports) {

$parcel$export(module.exports, "AIOptInPremiumUpsell", () => $70fc8b4331cd3e90$export$54e4ba490d2c6bb5);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $hI5oG = parcelRequire("hI5oG");

var $je5kZ = parcelRequire("je5kZ");

var $cnPHV = parcelRequire("cnPHV");
var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $iFqEI = parcelRequire("iFqEI");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jXPnZ = parcelRequire("jXPnZ");

var $HJoC3 = parcelRequire("HJoC3");
const $70fc8b4331cd3e90$export$54e4ba490d2c6bb5 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'screen',
            action: 'viewed'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'IssueAiUpsellDialog');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $70fc8b4331cd3e90$var$containerBorderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        alignBlock: "stretch",
        xcss: $70fc8b4331cd3e90$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignInline: "end",
        grow: "fill",
        xcss: $70fc8b4331cd3e90$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        onClick: onClose,
        label: formatMessage((0, $jXPnZ.messages).closeModal),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($je5kZ)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cnPHV.default), {
        all: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFqEI.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        alignInline: "stretch",
        space: "space.200",
        xcss: $70fc8b4331cd3e90$var$textContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium",
        as: "h2"
    }, formatMessage((0, $jXPnZ.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, formatMessage((0, $jXPnZ.messages).body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $HJoC3.StartPremiumTrialButton), {
        onCloseParent: onClose
    })))));
};
const $70fc8b4331cd3e90$var$containerBorderStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'border.radius',
    width: '438px',
    position: 'relative',
    padding: 'space.025',
    background: `linear-gradient(
      112.4deg,
      ${`var(--ds-background-accent-blue-subtle, ${(0, $PdmhA.B400)})`} 0%,
      ${`var(--ds-background-accent-purple-subtle, ${(0, $PdmhA.P400)})`} 100%
    )`
});
const $70fc8b4331cd3e90$var$containerStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface.overlay',
    overflow: 'hidden'
});
const $70fc8b4331cd3e90$var$headerStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    padding: 'space.075',
    right: 'space.025'
});
const $70fc8b4331cd3e90$var$textContainerStyles = (0, $1ZAYh.xcss)({
    padding: 'space.300'
});

});
parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $dff3771012ed2785$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M15.185 7.4l-3.184 3.185-3.186-3.186a.507.507 0 00-.712.003l-.7.701a.496.496 0 00-.004.712l3.185 3.184L7.4 15.185a.507.507 0 00.004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 00.712-.004l.701-.7a.496.496 0 00.003-.712l-3.186-3.186 3.186-3.184a.507.507 0 00-.003-.712l-.7-.7a.508.508 0 00-.36-.153.5.5 0 00-.353.15z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = $dff3771012ed2785$var$EditorCloseIcon;
module.exports.default = $dff3771012ed2785$var$_default;

});

parcelRegister("iFqEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $701c171f732e62a2$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $6W3m3 = parcelRequire("6W3m3");

var $58c3C = parcelRequire("58c3C");
const $701c171f732e62a2$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($58c3C)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6W3m3))
});
var $701c171f732e62a2$export$2e2bcd8739ae039 = $701c171f732e62a2$var$Illustration;
// for advanced use only
const $701c171f732e62a2$export$a179c88182cb9d56 = [
    0,
    0,
    438,
    96
];

});
parcelRegister("9TZf5", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $a7efac7c92ef32a3$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $a7efac7c92ef32a3$export$4d00e7be716a0093);

var $eUqFw = parcelRequire("eUqFw");

var $evtC7 = parcelRequire("evtC7");
function $a7efac7c92ef32a3$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $evtC7.AsImg), props);
}
function $a7efac7c92ef32a3$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7efac7c92ef32a3$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("evtC7", function(module, exports) {

$parcel$export(module.exports, "AsImg", () => $e7036c28dfac32f8$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");
// suggested defaults, the consumer is free to override
const $e7036c28dfac32f8$var$defaultStyles = null;
const $e7036c28dfac32f8$var$fillStyles = null;
const $e7036c28dfac32f8$var$autoDarkModeStyles = null;
function $e7036c28dfac32f8$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_kqswstnw _1r04idpf _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}

});


parcelRegister("6W3m3", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted-darkmode.f2ea2011.svg", import.meta.url).toString();

});

parcelRegister("58c3C", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted.9a9a0213.svg", import.meta.url).toString();

});


parcelRegister("jXPnZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $97776fe612de153a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $97776fe612de153a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.title",
        "defaultMessage": "Write better, work faster with Atlassian Intelligence"
    },
    body: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.body",
        "defaultMessage": "Use AI to brainstorm, summarize, change tone, edit and more, with Jira Premium."
    },
    closeModal: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.close-modal",
        "defaultMessage": "Close Modal"
    },
    tryItFreeButton: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.try-it-free-button",
        "defaultMessage": "Try it free"
    }
});

});

parcelRegister("HJoC3", function(module, exports) {

$parcel$export(module.exports, "StartPremiumTrialButton", () => $fe79884346a2c282$export$a2651a739f515dd4);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");

var $1n6uL = parcelRequire("1n6uL");

var $PdmhA = parcelRequire("PdmhA");

var $l3Qg0 = parcelRequire("l3Qg0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $feY12 = parcelRequire("feY12");

var $jXPnZ = parcelRequire("jXPnZ");
const $fe79884346a2c282$export$a2651a739f515dd4 = ({ onCloseParent: onCloseParent })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { entryPointActions: entryPointActions } = (0, $eUqFw.useContext)((0, $feY12.AIUpsellPremiumTrialEntryPointContext));
    const triggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClickAnalytics = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'openPremiumTrialModalFromIssueAiUpsell');
    }, [
        createAnalyticsEvent
    ]);
    const onClick = ()=>{
        // Nb. premium trial modal open is handled by entry point via ref
        onCloseParent && onCloseParent();
        onClickAnalytics();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        onClick: onClick,
        ref: triggerRef,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1n6uL))), {
            size: "small",
            label: "",
            primaryColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`
        }),
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    fontSize: '14px',
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }, formatMessage((0, $jXPnZ.messages).tryItFreeButton));
};

});
parcelRegister("l3Qg0", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $c6e813dbc513f02a$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $c6e813dbc513f02a$export$5f13515bd3a35325);

var $eUqFw = parcelRequire("eUqFw");

var $a9frS = parcelRequire("a9frS");
const $c6e813dbc513f02a$export$25d2524a63315ed = (actions, isActive = true, eventMap = $c6e813dbc513f02a$export$5f13515bd3a35325(actions))=>{
    const removePreviousListeners = (0, $eUqFw.useRef)(null);
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $eUqFw.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        if (element && isActive) {
            (0, $a9frS.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: eventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $a9frS.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: eventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        eventMap,
        isActive
    ]);
};
const $c6e813dbc513f02a$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("a9frS", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $592b51d0c18fde03$export$15257a36a7e3f9d6);
function $592b51d0c18fde03$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("feY12", function(module, exports) {

$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContext", () => $f717b66909f6070e$export$77aa5ca661b0742c);
$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContextProvider", () => $f717b66909f6070e$export$dd0a751f23b19473);

var $eUqFw = parcelRequire("eUqFw");

var $gRxol = parcelRequire("gRxol");
var $6j4bv = parcelRequire("6j4bv");

var $6PHwo = parcelRequire("6PHwo");
const $f717b66909f6070e$export$77aa5ca661b0742c = (0, $gRxol.createUseEntryPointContext)();
const $f717b66909f6070e$export$dd0a751f23b19473 = ({ children: children })=>{
    const entryPointParams = {};
    const entryPointResult = (0, $6j4bv.useEntryPoint)((0, $6PHwo.entryPointPremiumUpgradeModal), entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f717b66909f6070e$export$77aa5ca661b0742c.Provider, {
        value: entryPointResult
    }, children);
};

});
parcelRegister("gRxol", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $1835b430d1386e11$export$41bce2223126846b);

var $eUqFw = parcelRequire("eUqFw");
const $1835b430d1386e11$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $eUqFw.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});

parcelRegister("6j4bv", function(module, exports) {

$parcel$export(module.exports, "useEntryPoint", () => $82c08dfbbf99b106$export$338256068bc140fb);

var $eUqFw = parcelRequire("eUqFw");

var $hRw7O = parcelRequire("hRw7O");

var $80LCQ = parcelRequire("80LCQ");

var $fn8UB = parcelRequire("fn8UB");

var $VvIn5 = parcelRequire("VvIn5");
const $82c08dfbbf99b106$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $hRw7O.DEFAULT_OPTIONS))=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $fn8UB.useEntryPointLoadManager)(entryPoint, entryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $VvIn5.useMetricLogger)(metric);
    const entryPointActions = (0, $80LCQ.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $eUqFw.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("hRw7O", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $8aa020919bcd63f9$export$93ca5d3f8675ae4c);
const $8aa020919bcd63f9$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("80LCQ", function(module, exports) {

$parcel$export(module.exports, "useEntryPointActions", () => $5764a513c11cf0da$export$90681c8c3a56f09a);

var $eUqFw = parcelRequire("eUqFw");

var $gZ48R = parcelRequire("gZ48R");

var $hRw7O = parcelRequire("hRw7O");
const $5764a513c11cf0da$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $5764a513c11cf0da$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $hRw7O.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $hRw7O.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $eUqFw.useRef)();
    const preloadMaxAgeTimeout = (0, $eUqFw.useRef)();
    const preloadLastRequested = (0, $eUqFw.useRef)(0);
    const cancelPreload = (0, $eUqFw.useCallback)(()=>{
        if (!(0, $gZ48R.default)($5764a513c11cf0da$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $eUqFw.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $eUqFw.useCallback)(()=>{
        if ((0, $gZ48R.default)($5764a513c11cf0da$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $eUqFw.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("fn8UB", function(module, exports) {

$parcel$export(module.exports, "useEntryPointLoadManager", () => $9075a0262fd7a4a5$export$bfae318f9651db2f);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $ln3W8 = parcelRequire("ln3W8");

var $boTUp = parcelRequire("boTUp");
const $9075a0262fd7a4a5$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $ln3W8.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $eUqFw.useRef)(true);
    const timer = (0, $eUqFw.useRef)();
    const entryPointReferenceQueue = (0, $eUqFw.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $boTUp.useEntryPointReferenceSubject)();
    const setNextUpdate = (0, $eUqFw.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        timer.current = setTimeout(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $boTUp.removeAll)(currentQueue) : (0, $boTUp.removeInactiveLoads)(currentQueue);
        }, 0);
    }, [
        setEntryPointReference
    ]);
    const load = (0, $eUqFw.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $iWLL0.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $boTUp.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $eUqFw.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $eUqFw.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            clearTimeout(timer.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $boTUp.removeAll)(entryPointReferenceQueue.current);
        }, []);
    return {
        entryPointReferenceSubject: (0, $eUqFw.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};

});
parcelRegister("boTUp", function(module, exports) {

$parcel$export(module.exports, "removeRedundantPreloads", () => $f334fadd26cc659d$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $f334fadd26cc659d$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $f334fadd26cc659d$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $f334fadd26cc659d$export$322c8997d351da6a);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");
const $f334fadd26cc659d$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $f334fadd26cc659d$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $f334fadd26cc659d$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $f334fadd26cc659d$export$322c8997d351da6a = ()=>{
    const value = (0, $eUqFw.useRef)(null);
    const subscribers = (0, $eUqFw.useRef)();
    const subscribe = (0, $eUqFw.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $eUqFw.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        (0, $lEfVV.unstable_batchedUpdates)(()=>{
            if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                subscriber(entryPointReference);
            });
        });
    }, []);
    const getValue = (0, $eUqFw.useCallback)(()=>value.current, []);
    (0, $eUqFw.useEffect)(()=>()=>{
            subscribers.current?.clear();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};

});


parcelRegister("VvIn5", function(module, exports) {

$parcel$export(module.exports, "useMetricLogger", () => $df836dfb6cf1aa5a$export$f291ec7cea728e1);

var $eUqFw = parcelRequire("eUqFw");
const $df836dfb6cf1aa5a$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $eUqFw.useRef)(0);
    const loadStartTime = (0, $eUqFw.useRef)(0);
    const startMetric = (0, $eUqFw.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $eUqFw.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("6PHwo", function(module, exports) {

$parcel$export(module.exports, "entryPointPremiumUpgradeModal", () => $4cf7dc0dcae42bfd$export$7116d5b1a93db8d6);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $4cf7dc0dcae42bfd$export$7116d5b1a93db8d6 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("avuqx")).then((module)=>module.PremiumUpgradeModalEntryPoint), {
        moduleId: "1102b440"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("avuqx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('896rB')
        ]);
        const value = parcelRequire('6l8MW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("896rB")
    ]).then(()=>parcelRequire('6l8MW'));
}

});








parcelRegister("68Zel", function(module, exports) {

$parcel$export(module.exports, "useProfileCardProvider", () => $44f99cfbace9ba3f$export$160c0313bd165356);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $4ksts = parcelRequire("4ksts");

var $5lWRu = parcelRequire("5lWRu");
var $bv8gI = parcelRequire("bv8gI");

var $kJlBc = parcelRequire("kJlBc");

var $dWLk9 = parcelRequire("dWLk9");
var $euZiO = parcelRequire("euZiO");
var $d9epm = parcelRequire("d9epm");

const $44f99cfbace9ba3f$var$defaultActions = [
    (0, $2f37035f7aaf1787$export$23cedd3261bd8015)
];
// TODO: Remove once profilecard-next's usage of baseUrl is also removed
const $44f99cfbace9ba3f$var$baseUrl = '';
const $44f99cfbace9ba3f$export$160c0313bd165356 = (props = {})=>{
    const { onLoadError: providedOnLoadError, actions: actions = $44f99cfbace9ba3f$var$defaultActions } = props;
    const cloudId = (0, $dWLk9.useCloudId)();
    const fabricPfDirUrl = (0, $euZiO.useFabricProfileDirectoryUrl)();
    const teamCentralUrl = (0, $d9epm.useTeamCentralUrl)();
    const teamCentralBaseUrl = (0, $d9epm.useTeamCentralBaseUrl)();
    const intl = (0, $4ksts.useIntlV2)();
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const onLoadError = (0, $eUqFw.useCallback)((error, analyticsEvent)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'loadProfileCardClient',
                packageName: 'jiraProfilecardProvider',
                teamName: 'bento'
            },
            error: error,
            // Skipping sentry since there is no follow-up action for these errors.
            skipSentry: true
        });
        providedOnLoadError && providedOnLoadError(error, analyticsEvent);
    }, [
        providedOnLoadError
    ]);
    const profileClient = (0, $eUqFw.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $5lWRu.createUserProfileCardClient)(fabricPfDirUrl || (0, $34853cfce6b1c899$export$7c8e7812b81467ad), $44f99cfbace9ba3f$var$baseUrl, onLoadError, teamCentralUrl, teamCentralBaseUrl, (0, $34853cfce6b1c899$export$4b61157fa784d22e), cloudId), [
        fabricPfDirUrl,
        onLoadError,
        teamCentralUrl,
        teamCentralBaseUrl,
        cloudId
    ]);
    const getActions = (0, $eUqFw.useCallback)(// @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'Actions[]'.
    (id)=>(0, $bv8gI.getSpaActions)(id, $44f99cfbace9ba3f$var$baseUrl, intl, push, actions), [
        actions,
        intl,
        push
    ]);
    const provider = (0, $eUqFw.useMemo)(()=>Promise.resolve({
            cloudId: cloudId,
            getActions: getActions,
            resourceClient: profileClient
        }), [
        cloudId,
        getActions,
        profileClient
    ]);
    return provider;
};

});
parcelRegister("5lWRu", function(module, exports) {

$parcel$export(module.exports, "createUserProfileCardClient", () => $d57808c9e3ca761c$export$c4393c51e6d104c3);
$parcel$export(module.exports, "ProfileClientSubscriber", () => $d57808c9e3ca761c$export$10cad281024d43c8);
$parcel$export(module.exports, "useProfileClient", () => $d57808c9e3ca761c$export$d43dc22a8337ee9f);
$parcel$export(module.exports, "ProfileClientContainer", () => $d57808c9e3ca761c$export$d816ba2709570028);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $irl2T = parcelRequire("irl2T");

var $2vQty = parcelRequire("2vQty");
const $d57808c9e3ca761c$var$GATEWAY_GRAPHQL_URL = '/gateway/api/graphql';
const $d57808c9e3ca761c$export$c4393c51e6d104c3 = (fabricPfDirUrl, baseUrl, onLoadError, teamCentralUrl, teamCentralBaseUrl, gatewayGraphqlUrl, cloudId)=>{
    const userClient = new (0, $2vQty.CustomProfileClient)(fabricPfDirUrl, baseUrl, onLoadError);
    // From upward version 14 of `@atlaskit/profilecard`, `ProfileClient` class accepts `userClient` and `teamClient` in the 2nd argument.
    return new (0, $irl2T.default)({
        cacheMaxAge: 180000,
        cacheSize: 20,
        url: fabricPfDirUrl,
        teamCentralUrl: teamCentralUrl,
        teamCentralBaseUrl: teamCentralBaseUrl,
        productIdentifier: 'jira',
        gatewayGraphqlUrl: gatewayGraphqlUrl,
        cloudId: cloudId
    }, {
        userClient: userClient
    });
};
const $d57808c9e3ca761c$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { fabricPfDirUrl: fabricPfDirUrl, baseUrl: baseUrl, profileClient: profileClient, onLoadError: onLoadError, teamCentralUrl: teamCentralUrl, teamCentralBaseUrl: teamCentralBaseUrl, cloudId: cloudId })=>{
        const finalProfileClient = profileClient || $d57808c9e3ca761c$export$c4393c51e6d104c3(fabricPfDirUrl, baseUrl, onLoadError, teamCentralUrl, teamCentralBaseUrl, $d57808c9e3ca761c$var$GATEWAY_GRAPHQL_URL, cloudId);
        setState({
            profileClient: finalProfileClient
        });
    };
const $d57808c9e3ca761c$export$e324594224ef24da = {
    bootstrap: $d57808c9e3ca761c$export$36aff1fbb4f5dfc6
};
const $d57808c9e3ca761c$export$d4c72bab9d6cc13a = {
    profileClient: null
};
const $d57808c9e3ca761c$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    initialState: $d57808c9e3ca761c$export$d4c72bab9d6cc13a,
    actions: $d57808c9e3ca761c$export$e324594224ef24da
});
const $d57808c9e3ca761c$export$10cad281024d43c8 = (0, $dYfll.createSubscriber)($d57808c9e3ca761c$export$6f57813fe9f31bf9);
const $d57808c9e3ca761c$export$d43dc22a8337ee9f = (0, $ggKAj.createHook)($d57808c9e3ca761c$export$6f57813fe9f31bf9);
const $d57808c9e3ca761c$export$d816ba2709570028 = (0, $heB5U.createContainer)($d57808c9e3ca761c$export$6f57813fe9f31bf9, {
    onInit: ()=>({ dispatch: dispatch })=>dispatch($d57808c9e3ca761c$export$e324594224ef24da.bootstrap())
});

});
parcelRegister("irl2T", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6cb12d638cca59a$export$2e2bcd8739ae039);

var $fgzzf = parcelRequire("fgzzf");

var $XHGTv = parcelRequire("XHGTv");

var $aJ5Mi = parcelRequire("aJ5Mi");

var $eZj07 = parcelRequire("eZj07");

var $5qBgz = parcelRequire("5qBgz");
class $d6cb12d638cca59a$var$ProfileCardClient {
    constructor(config, clients){
        this.userClient = (clients === null || clients === void 0 ? void 0 : clients.userClient) || new (0, $5qBgz.default)(config);
        this.teamClient = (clients === null || clients === void 0 ? void 0 : clients.teamClient) || new (0, $eZj07.default)(config);
        this.tcClient = $d6cb12d638cca59a$var$maybeCreateTeamCentralClient(config, clients);
    }
    flushCache() {
        var _this$tcClient;
        this.userClient.flushCache();
        this.teamClient.flushCache();
        (_this$tcClient = this.tcClient) === null || _this$tcClient === void 0 || _this$tcClient.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        var _this$tcClient2;
        return ((_this$tcClient2 = this.tcClient) === null || _this$tcClient2 === void 0 ? void 0 : _this$tcClient2.getReportingLines(userId)) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    getTeamCentralBaseUrl() {
        var _this$tcClient3;
        return (_this$tcClient3 = this.tcClient) === null || _this$tcClient3 === void 0 ? void 0 : _this$tcClient3.options.teamCentralBaseUrl;
    }
    shouldShowGiveKudos() {
        if (!this.tcClient || !this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
}
function $d6cb12d638cca59a$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $XHGTv.getBooleanFF)('platform.profilecard-disable-team-central-client-in-fedramp_ilnm7')) {
        if ((0, $fgzzf.isFedRamp)()) return undefined;
    }
    if (clients !== null && clients !== void 0 && clients.teamCentralClient) return clients.teamCentralClient;
    const teamCentralUrl = config.teamCentralUrl;
    return teamCentralUrl ? new (0, $aJ5Mi.default)({
        ...config,
        teamCentralUrl: teamCentralUrl
    }) : undefined;
}
var $d6cb12d638cca59a$export$2e2bcd8739ae039 = $d6cb12d638cca59a$var$ProfileCardClient;

});
parcelRegister("fgzzf", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $b1d3f097f18f841e$export$64d6499adf9b2e51);

function $b1d3f097f18f841e$export$64d6499adf9b2e51() {
    var _globalThis$location, _globalThis$location$;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = globalThis.MICROS_PERIMETER || globalThis.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $6ba11a2ff4435ae3$export$ce553301d55c2fd8);
    const matches = (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : (_globalThis$location$ = _globalThis$location.hostname) === null || _globalThis$location$ === void 0 ? void 0 : _globalThis$location$.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
const $6ba11a2ff4435ae3$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $6ba11a2ff4435ae3$export$f005e2e9f707cb5f = 'commercial';
const $6ba11a2ff4435ae3$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $6ba11a2ff4435ae3$export$a739cd5aac835909 = 'stg';
const $6ba11a2ff4435ae3$export$42dd0cdd351a4a9 = 'prod';
const $6ba11a2ff4435ae3$export$404582bc18fe4d9e = 'dev';


parcelRegister("aJ5Mi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cf296b665c03df7$export$2e2bcd8739ae039);

var $dt4Lk = parcelRequire("dt4Lk");

var $jfUul = parcelRequire("jfUul");
const $7cf296b665c03df7$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $7cf296b665c03df7$export$f8c05b360e45cd0 = (featureKey, context)=>({
        query: `
    query isFeatureKeyEnabled($featureKey: String!, $context: [IsFeatureEnabledContextInput]) {
      isFeatureEnabled(featureKey: $featureKey, context: $context) {
        enabled
      }
    }
  `,
        variables: {
            featureKey: featureKey,
            context: context || []
        }
    });
function $7cf296b665c03df7$var$hasTCWorkspace(config) {
    return config.cloudId ? fetch(`/gateway/api/watermelon/organization/containsAnyWorkspace?cloudId=${config.cloudId}`).then((res)=>{
        return !res || res && res.ok;
    }) : Promise.resolve(false);
}
let $7cf296b665c03df7$var$isTCReadyPromiseMap = new Map();
class $7cf296b665c03df7$var$TeamCentralCardClient extends (0, $dt4Lk.default) {
    /**
   * Simple circuit breaker to avoid making unnecessary calls to Team Central on auth failures
   * This is to handle the case where products may have provided teamCentralUrl, but the site itself
   * doesn't actually have any TC product.
   *
   * There's currently no way to reset this circuit breaker, but that's fine. This is meant to
   * catch a pretty specific edge case.
   */ constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.featureFlagKeys = new Map();
        this.isTCReadyPromise = this.createTcReadyPromise(options);
    }
    createTcReadyPromise(config) {
        if (config.cloudId) {
            let promise = $7cf296b665c03df7$var$isTCReadyPromiseMap.get(config.cloudId);
            if (!promise) {
                promise = $7cf296b665c03df7$var$hasTCWorkspace(config);
                $7cf296b665c03df7$var$isTCReadyPromiseMap.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    async makeFeatureFlagCheckRequest(featureKey, context) {
        if (!this.options.teamCentralUrl) throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
        const query = $7cf296b665c03df7$export$f8c05b360e45cd0(featureKey, context);
        const response = await (0, $jfUul.directoryGraphqlQuery)(`${this.options.teamCentralUrl}?operationName=isFeatureKeyEnabled`, query);
        return response.isFeatureEnabled.enabled;
    }
    async makeRequest(userId) {
        if (!this.options.teamCentralUrl) throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
        const query = $7cf296b665c03df7$export$1862ef0c3880ca8d(userId);
        const response = await (0, $jfUul.directoryGraphqlQuery)(`${this.options.teamCentralUrl}?operationName=ReportingLines`, query);
        return response.reportingLines;
    }
    getReportingLines(userId) {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data === null || data === void 0 ? void 0 : data.managers),
                            reports: this.filterReportingLinesUser(data === null || data === void 0 ? void 0 : data.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if ((error === null || error === void 0 ? void 0 : error.status) === 401 || (error === null || error === void 0 ? void 0 : error.status) === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
             * Reporting lines aren't part of the critical path of profile card.
             * Just resolve with empty values instead of bubbling up the error.
             */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    getFlagEnabled(featureKey, productIdentifier) {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) {
                if (!featureKey) return Promise.reject(new Error('featureKey missing'));
                if (this.featureFlagKeys.has(featureKey)) return Promise.resolve(this.featureFlagKeys.get(featureKey));
                if (this.bypassOnFailure) return Promise.resolve(false);
                const context = [
                    {
                        key: 'productIdentifier',
                        value: productIdentifier || 'unset'
                    }
                ];
                return new Promise((resolve)=>{
                    this.makeFeatureFlagCheckRequest(featureKey, context).then((enabled)=>{
                        this.featureFlagKeys.set(featureKey, enabled);
                        resolve(enabled);
                    }).catch((error)=>{
                        if ((error === null || error === void 0 ? void 0 : error.status) === 401 || (error === null || error === void 0 ? void 0 : error.status) === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        resolve(false);
                    });
                });
            }
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    checkWorkspaceExists() {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $7cf296b665c03df7$export$2e2bcd8739ae039 = $7cf296b665c03df7$var$TeamCentralCardClient;

});
parcelRegister("dt4Lk", function(module, exports) {

$parcel$export(module.exports, "default", () => $0287c4dce8311e91$export$2e2bcd8739ae039);

var $6roQF = parcelRequire("6roQF");
class $0287c4dce8311e91$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $6roQF.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});

parcelRegister("jfUul", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $e04b3c74a1193591$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $e04b3c74a1193591$export$a14afb5f82fe705);

var $6ma28 = parcelRequire("6ma28");

var $72Wsh = parcelRequire("72Wsh");
const $e04b3c74a1193591$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $e04b3c74a1193591$var$id = (headers)=>headers;
async function $e04b3c74a1193591$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $e04b3c74a1193591$var$id) {
    return $e04b3c74a1193591$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $72Wsh.handleDirectoryGraphQLErrors));
}
async function $e04b3c74a1193591$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $e04b3c74a1193591$var$id) {
    return $e04b3c74a1193591$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $72Wsh.handleAGGErrors));
}
async function $e04b3c74a1193591$var$graphQLQuery(serviceUrl, query, processHeaders = $e04b3c74a1193591$var$id, handleErrors) {
    var _response$headers;
    const headers = processHeaders($e04b3c74a1193591$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response === null || response === void 0 ? void 0 : (_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.get('atl-traceid');
    if (!response.ok) throw new (0, $6ma28.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) {
        var _json$extensions$gate, _json$extensions, _json$extensions$gate2;
        handleErrors(json.errors, (_json$extensions$gate = (_json$extensions = json.extensions) === null || _json$extensions === void 0 ? void 0 : (_json$extensions$gate2 = _json$extensions.gateway) === null || _json$extensions$gate2 === void 0 ? void 0 : _json$extensions$gate2.request_id) !== null && _json$extensions$gate !== void 0 ? _json$extensions$gate : traceIdFromHeaders);
    }
    return json.data;
}

});
parcelRegister("6ma28", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $4a0c9491b319f7ab$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $4a0c9491b319f7ab$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $4a0c9491b319f7ab$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $4a0c9491b319f7ab$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $4a0c9491b319f7ab$export$60d8267243755b9c);
class $4a0c9491b319f7ab$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $4a0c9491b319f7ab$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $4a0c9491b319f7ab$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $4a0c9491b319f7ab$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $4a0c9491b319f7ab$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path === null || path === void 0 ? void 0 : path.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $4a0c9491b319f7ab$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $4a0c9491b319f7ab$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});

parcelRegister("72Wsh", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $5216104174f39fad$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $5216104174f39fad$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $5216104174f39fad$export$d9ad65d422ee3f8c);

var $6ma28 = parcelRequire("6ma28");
const $5216104174f39fad$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $5216104174f39fad$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $5216104174f39fad$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $5216104174f39fad$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $6ma28.DirectoryGraphQLError)) return !!error && $5216104174f39fad$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $6ma28.AGGError)) return !!error.errorType && $5216104174f39fad$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $5216104174f39fad$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $5216104174f39fad$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $6ma28.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($5216104174f39fad$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($5216104174f39fad$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $6ma28.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$5216104174f39fad$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $6ma28.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($5216104174f39fad$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($5216104174f39fad$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $6ma28.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$5216104174f39fad$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $6ma28.DirectoryGraphQLErrors) || causeError instanceof (0, $6ma28.AGGErrors)) return $5216104174f39fad$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $5216104174f39fad$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $6ma28.DirectoryGraphQLErrors)(errors, traceId);
};
const $5216104174f39fad$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $6ma28.AGGErrors)(errors, traceId);
};

});



parcelRegister("eZj07", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae958060350fc06b$export$2e2bcd8739ae039);

var $eyGVr = parcelRequire("eyGVr");

var $5ImIt = parcelRequire("5ImIt");

var $dt4Lk = parcelRequire("dt4Lk");

var $72Wsh = parcelRequire("72Wsh");

var $iiZqO = parcelRequire("iiZqO");
class $ae958060350fc06b$export$2e2bcd8739ae039 extends (0, $dt4Lk.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $iiZqO.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $5ImIt.getPageTime)();
            if (analytics) analytics((0, $eyGVr.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $eyGVr.teamRequestAnalytics)('succeeded', {
                    duration: (0, $5ImIt.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $eyGVr.teamRequestAnalytics)('failed', {
                    duration: (0, $5ImIt.getPageTime)() - startTime,
                    ...(0, $72Wsh.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("eyGVr", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $a99589c177ce3191$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $a99589c177ce3191$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $a99589c177ce3191$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $a99589c177ce3191$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $a99589c177ce3191$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $a99589c177ce3191$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $a99589c177ce3191$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $a99589c177ce3191$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $a99589c177ce3191$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $a99589c177ce3191$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $a99589c177ce3191$export$c86679da702d560e);

var $5ImIt = parcelRequire("5ImIt");
/** Below lines are copied from teams common analytics */ const $a99589c177ce3191$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $a99589c177ce3191$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $a99589c177ce3191$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $a99589c177ce3191$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($a99589c177ce3191$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $a99589c177ce3191$var$TEAM_SUBJECT = 'teamProfileCard';
const $a99589c177ce3191$var$USER_SUBJECT = 'profilecard';
const $a99589c177ce3191$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "@atlaskit/profilecard",
            packageVersion: "19.14.1",
            ...attributes,
            firedAt: Math.round((0, $5ImIt.getPageTime)())
        }
    });
const $a99589c177ce3191$export$d50ab8a3b6975c = (type, method)=>$a99589c177ce3191$var$createEvent('ui', 'triggered', type === 'user' ? $a99589c177ce3191$var$USER_SUBJECT : $a99589c177ce3191$var$TEAM_SUBJECT, undefined, {
        method: method
    });
const $a99589c177ce3191$export$c9b0e37b229a297b = (action, attributes)=>$a99589c177ce3191$var$createEvent('operational', action, $a99589c177ce3191$var$TEAM_SUBJECT, 'request', attributes);
const $a99589c177ce3191$export$12dae48763368ac9 = (action, attributes)=>$a99589c177ce3191$var$createEvent('operational', action, $a99589c177ce3191$var$USER_SUBJECT, 'request', attributes);
const $a99589c177ce3191$export$41816a317479160b = (type, actionSubjectId, attributes)=>$a99589c177ce3191$var$createEvent('ui', 'rendered', type === 'user' ? $a99589c177ce3191$var$USER_SUBJECT : $a99589c177ce3191$var$TEAM_SUBJECT, actionSubjectId, attributes);
const $a99589c177ce3191$export$fdcd134fbeb1f921 = (type, attributes)=>$a99589c177ce3191$var$createEvent('ui', 'clicked', type === 'user' ? $a99589c177ce3191$var$USER_SUBJECT : $a99589c177ce3191$var$TEAM_SUBJECT, 'action', attributes);
const $a99589c177ce3191$export$93260987012593be = (attributes)=>$a99589c177ce3191$var$createEvent('ui', 'clicked', $a99589c177ce3191$var$USER_SUBJECT, 'reportingLines', attributes);
const $a99589c177ce3191$export$79befd155063a6a7 = (type, attributes)=>$a99589c177ce3191$var$createEvent('ui', 'clicked', type === 'user' ? $a99589c177ce3191$var$USER_SUBJECT : $a99589c177ce3191$var$TEAM_SUBJECT, 'moreActions', attributes);
const $a99589c177ce3191$export$2703289b35687fde = (attributes)=>$a99589c177ce3191$var$createEvent('ui', 'clicked', $a99589c177ce3191$var$TEAM_SUBJECT, 'avatar', attributes);
const $a99589c177ce3191$export$b4411a7661cf2d3f = (attributes)=>$a99589c177ce3191$var$createEvent('ui', 'clicked', $a99589c177ce3191$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $a99589c177ce3191$export$c86679da702d560e = (attributes)=>$a99589c177ce3191$var$createEvent('ui', 'clicked', $a99589c177ce3191$var$TEAM_SUBJECT, 'errorRetry', attributes);

});
parcelRegister("5ImIt", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $4292aeca45a62e9e$export$e9faea7c41053334);
const $4292aeca45a62e9e$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $4292aeca45a62e9e$var$performanceAvailable = $4292aeca45a62e9e$var$isPerformanceAvailable();
const $4292aeca45a62e9e$var$initialPageTime = Date.now();
const $4292aeca45a62e9e$export$e9faea7c41053334 = ()=>{
    if ($4292aeca45a62e9e$var$performanceAvailable) return performance.now();
    return Date.now() - $4292aeca45a62e9e$var$initialPageTime;
};

});


parcelRegister("iiZqO", function(module, exports) {

$parcel$export(module.exports, "getTeamFromAGG", () => $d5398f7115071f47$export$26a8aad0c7182dd6);

var $jfUul = parcelRequire("jfUul");
const $d5398f7115071f47$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $d5398f7115071f47$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $d5398f7115071f47$export$fce1abb40bf8db94 = (result)=>{
    var _team$members;
    const { team: team } = result;
    return {
        ...team,
        id: $d5398f7115071f47$export$5816a09dbb711691(team.id),
        members: (_team$members = team.members) === null || _team$members === void 0 ? void 0 : _team$members.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $d5398f7115071f47$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $d5398f7115071f47$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$d5398f7115071f47$var$TEAM_FRAGMENT}
    }
  }
}`;
const $d5398f7115071f47$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $d5398f7115071f47$export$4968f4e0119a5d9c,
        variables: {
            teamId: $d5398f7115071f47$export$681597d03c8a0fd2(teamId),
            siteId: siteId || 'None'
        }
    });
const $d5398f7115071f47$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "@atlaskit/profilecard");
    headers.append('atl-client-version', "19.14.1");
    return headers;
};
async function $d5398f7115071f47$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $d5398f7115071f47$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $jfUul.AGGQuery)(url, query, $d5398f7115071f47$export$1229c72526c01df2);
    return $d5398f7115071f47$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("5qBgz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f3c49c5b2dfdc95$export$2e2bcd8739ae039);

var $eyGVr = parcelRequire("eyGVr");

var $5ImIt = parcelRequire("5ImIt");

var $dt4Lk = parcelRequire("dt4Lk");

var $72Wsh = parcelRequire("72Wsh");

var $jfUul = parcelRequire("jfUul");
const $3f3c49c5b2dfdc95$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $3f3c49c5b2dfdc95$export$bfbf383663068c37 = (cloudId, userId)=>({
        query: `query User($userId: String!, $cloudId: String!) {
    User: CloudUser(userId: $userId, cloudId: $cloudId) {
      id
      isCurrentUser
      status
      statusModifiedDate
      isBot
      isNotMentionable
      fullName
      nickname
      email
      meta: title
      location
      companyName
      avatarUrl(size: 192)
      remoteWeekdayIndex: localTime(format: "d")
      remoteWeekdayString: localTime(format: "ddd")
      remoteTimeString: localTime(format: "h:mma")
    }
  }`,
        variables: {
            cloudId: cloudId,
            userId: userId
        }
    });
class $3f3c49c5b2dfdc95$export$2e2bcd8739ae039 extends (0, $dt4Lk.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        if (!this.options.url) throw new Error('options.url is a required parameter');
        const query = $3f3c49c5b2dfdc95$export$bfbf383663068c37(cloudId, userId);
        const response = await (0, $jfUul.directoryGraphqlQuery)(this.options.url, query);
        return $3f3c49c5b2dfdc95$export$b26b7f9bcf400835(response);
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $5ImIt.getPageTime)();
            if (analytics) analytics((0, $eyGVr.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $eyGVr.userRequestAnalytics)('succeeded', {
                    duration: (0, $5ImIt.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $eyGVr.userRequestAnalytics)('failed', {
                    duration: (0, $5ImIt.getPageTime)() - startTime,
                    ...(0, $72Wsh.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});


parcelRegister("2vQty", function(module, exports) {

$parcel$export(module.exports, "CustomProfileClient", () => $1299391c5e75a14e$export$aa8db43941b8d3a7);

var $5qBgz = parcelRequire("5qBgz");

var $2OdyW = parcelRequire("2OdyW");

var $bv8gI = parcelRequire("bv8gI");
class $1299391c5e75a14e$export$aa8db43941b8d3a7 extends (0, $5qBgz.default) {
    constructor(fabricPfDirUrl, baseUrl, onLoadError){
        super({
            url: fabricPfDirUrl,
            cacheSize: 20,
            cacheMaxAge: 180000
        });
        this.makeRequest = async (cloudId, userId)=>{
            // call old profilerestendpoint
            try {
                if ((0, $bv8gI.isCustomerAccount)(userId)) {
                    const response = await (0, $2OdyW.default)(`${this.baseUrl}/rest/api/3/user?accountId=${userId}`);
                    return (0, $bv8gI.restResponseToUserData)(response);
                }
                return await this.parentMakeRequest(cloudId, userId);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const error = new Error(`Unable to fetch user: ${err.message}`, {
                    cause: err
                });
                this.onLoadError?.(err);
                throw error;
            }
        };
        this.baseUrl = baseUrl;
        this.onLoadError = onLoadError;
        this.parentMakeRequest = super.makeRequest;
    }
}

});
parcelRegister("bv8gI", function(module, exports) {

$parcel$export(module.exports, "restResponseToUserData", () => $cd9a986ac0e3329e$export$66691b1affeb3bc5);
$parcel$export(module.exports, "isCustomerAccount", () => $cd9a986ac0e3329e$export$67a41405362363f0);
$parcel$export(module.exports, "getSpaActions", () => $cd9a986ac0e3329e$export$518f47d656cb4e1a);


var $bncoh = parcelRequire("bncoh");
const $cd9a986ac0e3329e$export$66691b1affeb3bc5 = (userData)=>({
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        avatarUrl: userData.avatarUrls['48x48'],
        email: userData.emailAddress,
        fullName: userData.displayName,
        isBot: false,
        isCurrentUser: false,
        status: userData.active ? 'active' : 'inactive',
        accountType: userData.accountType
    });
const $cd9a986ac0e3329e$export$67a41405362363f0 = (accountId)=>accountId ? accountId.lastIndexOf('qm:', 0) === 0 : false;
const $cd9a986ac0e3329e$var$getSpaViewProfileAction = (// @ts-expect-error - TS7006 - Parameter 'intl' implicitly has an 'any' type.
intl, baseUrl, accountId, onPushAction, onActionCleanup)=>({
        label: intl && intl.formatMessage((0, $bncoh.profileCardMessages).viewProfile),
        id: 'view-profile',
        callback: ()=>{
            onPushAction(`${baseUrl}/jira/people/${accountId}`);
            onActionCleanup && onActionCleanup();
        },
        link: `${baseUrl}/jira/people/${accountId}`,
        shouldRender: (data)=>/*
   * Those without @atlassian.com accounts do not have viewable profiles
   */ data?.accountType !== 'customer'
    });
// @ts-expect-error - TS7006 - Parameter 'intl' implicitly has an 'any' type.
const $cd9a986ac0e3329e$var$getAssignedIssuesAction = (intl, baseUrl, accountId)=>({
        label: intl && intl.formatMessage((0, $bncoh.profileCardMessages).assignedIssues),
        id: 'assigned-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`assignee="${accountId || ''}" AND resolution is empty`);
            const url = `${baseUrl}/issues/?jql=${jql}`;
            window.open(url, '_blank');
        }
    });
// @ts-expect-error - TS7006 - Parameter 'intl' implicitly has an 'any' type.
const $cd9a986ac0e3329e$var$getReportedIssuesAction = (intl, baseUrl, accountId)=>({
        label: intl && intl.formatMessage((0, $bncoh.profileCardMessages).reportedIssues),
        id: 'reported-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`reporter="${accountId || ''}" order by created DESC`);
            const url = `${baseUrl}/issues/?jql=${jql}`;
            window.open(url, '_blank');
        }
    });
// @ts-expect-error - TS7006 - Parameter 'intl' implicitly has an 'any' type.
const $cd9a986ac0e3329e$var$getViewFiltersAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $bncoh.profileCardMessages).viewFilters),
        id: 'view-filters',
        callback: ()=>{
            const url = `/jira/filters?owner=${encodeURIComponent(accountId)}`;
            window.open(url, '_blank');
        }
    });
const $cd9a986ac0e3329e$export$518f47d656cb4e1a = (accountId, baseUrl, intl, onPushAction, actions, onActionCleanup)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $2f37035f7aaf1787$export$23cedd3261bd8015:
                return $cd9a986ac0e3329e$var$getSpaViewProfileAction(intl, baseUrl, accountId, onPushAction, onActionCleanup);
            case 0, $2f37035f7aaf1787$export$6bef782d14a92db8:
                return $cd9a986ac0e3329e$var$getAssignedIssuesAction(intl, baseUrl, accountId);
            case 0, $2f37035f7aaf1787$export$6b36f20db7a18a86:
                return $cd9a986ac0e3329e$var$getReportedIssuesAction(intl, baseUrl, accountId);
            case 0, $2f37035f7aaf1787$export$56da0dd0b0aa67b9:
                return $cd9a986ac0e3329e$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $cd9a986ac0e3329e$var$getSpaViewProfileAction(intl, baseUrl, accountId, onPushAction, onActionCleanup)
    ];
};

});
// values which are passed into the tracking callback by atlaskit
const $2f37035f7aaf1787$export$febebefae5a09065 = 'profile-card.loaded';
const $2f37035f7aaf1787$export$3ca1936ee743bd18 = 'profile-card.view';
const $2f37035f7aaf1787$export$25bd35f2cd9ae0ea = 'profile-card.reload';
const $2f37035f7aaf1787$export$86aa8b9c379ebbbd = 'profile-card.error';
const $2f37035f7aaf1787$export$4442e31da6ba4127 = 'profile-card.click';
const $2f37035f7aaf1787$export$7ecd9c56ca354ac0 = 'profileCardNext';
const $2f37035f7aaf1787$export$81319ffa9c0d18d7 = 'profileCardNext';
const $2f37035f7aaf1787$export$3145fc6c544ad7bf = 'profileCardNextLegacy';
const $2f37035f7aaf1787$export$50632e21ea714398 = 'profileCardNextLegacy';
const $2f37035f7aaf1787$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $2f37035f7aaf1787$export$2549357601611c61 = 'loadError';
const $2f37035f7aaf1787$export$23cedd3261bd8015 = 'viewProfile';
const $2f37035f7aaf1787$export$6bef782d14a92db8 = 'assignedIssues';
const $2f37035f7aaf1787$export$6b36f20db7a18a86 = 'reportedIssues';
const $2f37035f7aaf1787$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("bncoh", function(module, exports) {

$parcel$export(module.exports, "profileCardMessages", () => $daa0299e513e1d61$export$49f2d2ccb123fddf);

var $90IgZ = parcelRequire("90IgZ");
const $daa0299e513e1d61$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    view: {
        "id": "profilecard-next",
        "defaultMessage": "View profile"
    }
});
const $daa0299e513e1d61$export$49f2d2ccb123fddf = (0, $90IgZ.defineMessages)({
    assignedIssues: {
        "id": "profilecard-next.assigned-issues",
        "defaultMessage": "Assigned issues"
    },
    viewProfile: {
        "id": "profilecard-next.view-profile",
        "defaultMessage": "View profile"
    },
    reportedIssues: {
        "id": "profilecard-next.reported-issues",
        "defaultMessage": "Reported issues"
    },
    viewFilters: {
        "id": "profilecard-next.view-filters",
        "defaultMessage": "View filters"
    }
});

});




parcelRegister("euZiO", function(module, exports) {

$parcel$export(module.exports, "useFabricProfileDirectoryUrl", () => $6d262f3841283f3f$export$cb9379d435214a54);

var $gd0Sp = parcelRequire("gd0Sp");
const $6d262f3841283f3f$export$cb9379d435214a54 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.fabricPfDirUrl || '';
};

});

parcelRegister("d9epm", function(module, exports) {

$parcel$export(module.exports, "useTeamCentralUrl", () => $27fe3a2e52ea675c$export$12bf0987a96bab08);
$parcel$export(module.exports, "useTeamCentralBaseUrl", () => $27fe3a2e52ea675c$export$b49e0105c58cb761);

var $3e9vj = parcelRequire("3e9vj");
const $27fe3a2e52ea675c$export$12bf0987a96bab08 = ()=>'/gateway/api/watermelon/graphql';
const $27fe3a2e52ea675c$export$b49e0105c58cb761 = ()=>{
    const env = (0, $3e9vj.useEnvironment)();
    if (env === 'staging' || env === 'dev' || env === 'local') return 'https://team.stg.atlassian.com';
    return 'https://team.atlassian.com';
};

});
parcelRegister("3e9vj", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $f75608ebab912e29$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $f75608ebab912e29$export$b0d8f74f433a09c9);

var $gd0Sp = parcelRequire("gd0Sp");
const $f75608ebab912e29$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $f75608ebab912e29$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext?.environment || $f75608ebab912e29$var$ENVIRONMENT.PROD;
};
const $f75608ebab912e29$export$b0d8f74f433a09c9 = ()=>{
    const env = $f75608ebab912e29$export$ea7ed2425832167d();
    return env === $f75608ebab912e29$var$ENVIRONMENT.STAGING || env === $f75608ebab912e29$var$ENVIRONMENT.DEV || env === $f75608ebab912e29$var$ENVIRONMENT.LOCAL;
};

});


// Based on Confluence's usage of the AK ProfileClient
// See: https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend
const $34853cfce6b1c899$export$7c8e7812b81467ad = '/gateway/api/directory/graphql';
const $34853cfce6b1c899$export$4b61157fa784d22e = '/gateway/api/graphql';


parcelRegister("fbdfB", function(module, exports) {

$parcel$export(module.exports, "getEnableFlexibleBlockCardInIssueEditor", () => $010cc58518dc8f01$export$408491224a0c915b);
$parcel$export(module.exports, "getTTRSeverityTrackingConfiguration", () => $010cc58518dc8f01$export$6fb6e5d98b15585b);
$parcel$export(module.exports, "getUnsupportedContentLevelsTrackingConfiguration", () => $010cc58518dc8f01$export$eccecfefbd48225b);
$parcel$export(module.exports, "isSpecBasedValidatorEnabled", () => $010cc58518dc8f01$export$ef24e9eecc594777);
$parcel$export(module.exports, "isRendererTtiTrackingEnabled", () => $010cc58518dc8f01$export$b236d4b6aec7c4c3);
$parcel$export(module.exports, "isAltTextOnImagesEnabled", () => $010cc58518dc8f01$export$9591540fa082da5a);
$parcel$export(module.exports, "isMediaInlineEnabled", () => $010cc58518dc8f01$export$a3e5d5dfe1ed90ed);

var $1ybV0 = parcelRequire("1ybV0");
const $010cc58518dc8f01$export$408491224a0c915b = ()=>(0, $1ybV0.ff)('issue.details.editor.enable-flexible-block-card');
const $010cc58518dc8f01$export$6fb6e5d98b15585b = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $1ybV0.getFeatureFlagValue)('issue.details.renderer.ttr-severity-tracking', {});
const $010cc58518dc8f01$export$eccecfefbd48225b = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $1ybV0.getFeatureFlagValue)('issue.details.renderer.unsupported-content-levels-tracking', {});
const $010cc58518dc8f01$export$ef24e9eecc594777 = ()=>(0, $1ybV0.ff)('issue.details.renderer.spec-based-validator');
const $010cc58518dc8f01$export$b236d4b6aec7c4c3 = ()=>(0, $1ybV0.ff)('issue.details.renderer.tti-tracking', false);
const $010cc58518dc8f01$export$9591540fa082da5a = ()=>(0, $1ybV0.ff)('editor.renderer-alt-text-on-images', false);
const $010cc58518dc8f01$export$a3e5d5dfe1ed90ed = ()=>(0, $1ybV0.ff)('issue.details.media-inline', false);

});

parcelRegister("bIw2X", function(module, exports) {

$parcel$export(module.exports, "default", () => $d329dadd99ead36b$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $9wcjJ = parcelRequire("9wcjJ");

var $avvqL = parcelRequire("avvqL");

var $2hniO = parcelRequire("2hniO");

var $95Rby = parcelRequire("95Rby");

var $3ZL8o = parcelRequire("3ZL8o");

var $8HuAw = parcelRequire("8HuAw");

var $1ybV0 = parcelRequire("1ybV0");

var $4xwq2 = parcelRequire("4xwq2");

var $5gJbo = parcelRequire("5gJbo");

var $9XfZZ = parcelRequire("9XfZZ");

var $7Vbpp = parcelRequire("7Vbpp");

var $fbdfB = parcelRequire("fbdfB");

var $kWNk2 = parcelRequire("kWNk2");
class $d329dadd99ead36b$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.displayName = 'Renderer';
    }
    static{
        this.defaultProps = {
            adf: undefined,
            placeholder: undefined
        };
    }
    constructor(props){
        super(props);
        this.onInlineCardClicked = (e, url)=>{
            const { linkActions: linkActions } = this.props;
            const event = e || window.event;
            event.preventDefault();
            if ((0, $9XfZZ.isExternalLink)(url)) {
                window.open(url, '_blank', 'noopener,noreferrer');
                return;
            }
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const mouseEvent = event;
            const shouldOpenInNewTab = (0, $5gJbo.isCmdOrCtrlClick)(mouseEvent) || (0, $5gJbo.isMiddleClick)(mouseEvent);
            (0, $8HuAw.default)(url, shouldOpenInNewTab, linkActions.push);
        };
        this.onContentSelected = (e)=>{
            if (!(e.target instanceof window.Element) || (0, $3ZL8o.default)(e.target, e.currentTarget) || this.checkForMedia(e.target, e.currentTarget)) // This is to avoid entering edit mode when clicking on a link or a video.
            e.stopPropagation();
        };
        this.checkForMedia = (currentElement, topElement)=>{
            // If we reach the original div, we didn't find a video.
            if (!currentElement || currentElement === topElement) return false;
            // TODO: These checks are unsafe. Use the method outlined in
            // https://jdog.jira-dev.com/browse/BENTO-6367
            if (currentElement.className.includes?.('rich-media-item') || currentElement.className.includes?.('media-file-card-view') || currentElement.className.includes?.('media-viewer-popup')) return true;
            // Continue walking up the DOM tree looking for a video.
            return this.checkForMedia(currentElement.parentElement, topElement);
        };
        this.isEmpty = ()=>this.isAdfValueEmpty();
        this.isAdfValueEmpty = ()=>{
            const { adf: adf } = this.props;
            // We should change this to an empty ADF object after this ticket is done: https://product-fabric.atlassian.net/browse/CS-235
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return !adf || (0, $7Vbpp.isOnlyWhitespaceAdf)(adf);
        };
        this.setNodeRef = (element)=>{
            this.node = element;
        };
        const { contextIdentifier: contextIdentifier, mediaProvider: mediaProvider, mentionProvider: mentionProvider, profileCardProvider: profileCardProvider } = this.props;
        this.node = null;
        this.dataProviders = new (0, $avvqL.default)();
        this.dataProviders.setProvider('mediaProvider', mediaProvider);
        this.dataProviders.setProvider('mentionProvider', Promise.resolve(mentionProvider));
        this.dataProviders.setProvider('emojiProvider', (0, $95Rby.getEmojiProviderWithCustomEmoji)(this.props.cloudId, this.props.loggedInUserAccountId));
        if (contextIdentifier) this.dataProviders.setProvider('contextIdentifierProvider', Promise.resolve(contextIdentifier));
        this.dataProviders.setProvider('profilecardProvider', profileCardProvider);
        this.eventHandlers = {
            smartCard: {
                onClick: this.onInlineCardClicked
            },
            link: {
                onClick: this.onInlineCardClicked
            }
        };
    }
    render() {
        const { adf: adf, placeholder: placeholder } = this.props;
        if (this.isEmpty()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), null, placeholder);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            role: "presentation",
            onClick: this.onContentSelected,
            onKeyPress: this.onContentSelected,
            ref: this.setNodeRef
        }, (0, $fbdfB.isAltTextOnImagesEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2hniO.default), {
            appearance: "comment",
            schema: (0, $9wcjJ.defaultSchema),
            document: (0, $7Vbpp.removeCollectionFromAdf)(adf),
            dataProviders: this.dataProviders,
            eventHandlers: this.eventHandlers,
            allowAltTextOnImages: true,
            allowWrapCodeBlock: true,
            allowCopyToClipboard: true,
            media: {
                allowLinking: true,
                featureFlags: (0, $kWNk2.mediaFeatureFlags)()
            },
            portal: this.node,
            disableHeadingIDs: true,
            analyticsEventSeverityTracking: (0, $fbdfB.getTTRSeverityTrackingConfiguration)(),
            unsupportedContentLevelsTracking: (0, $fbdfB.getUnsupportedContentLevelsTrackingConfiguration)(),
            useSpecBasedValidator: (0, $fbdfB.isSpecBasedValidatorEnabled)(),
            featureFlags: {
                codeBidiWarnings: true,
                'code-bidi-warnings': true,
                'renderer-tti-tracking': (0, $fbdfB.isRendererTtiTrackingEnabled)(),
                'allow-windowed-code-block': true
            },
            smartLinks: {
                showAuthTooltip: true,
                ...(0, $1ybV0.ff)('platform.linking-platform.jira-renderer-use-default-smartlinks-value') ? (0, $9XfZZ.smartLinksDefault) : {}
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2hniO.default), {
            appearance: "comment",
            schema: (0, $9wcjJ.defaultSchema),
            document: (0, $7Vbpp.removeCollectionFromAdf)(adf),
            dataProviders: this.dataProviders,
            eventHandlers: this.eventHandlers,
            allowAltTextOnImages: true,
            allowWrapCodeBlock: true,
            allowCopyToClipboard: true,
            media: {
                allowLinking: true,
                featureFlags: (0, $kWNk2.mediaFeatureFlags)()
            },
            portal: this.node,
            disableHeadingIDs: true,
            analyticsEventSeverityTracking: (0, $fbdfB.getTTRSeverityTrackingConfiguration)(),
            unsupportedContentLevelsTracking: (0, $fbdfB.getUnsupportedContentLevelsTrackingConfiguration)(),
            useSpecBasedValidator: (0, $fbdfB.isSpecBasedValidatorEnabled)(),
            featureFlags: {
                codeBidiWarnings: true,
                'code-bidi-warnings': true,
                'renderer-tti-tracking': (0, $fbdfB.isRendererTtiTrackingEnabled)(),
                'allow-windowed-code-block': true
            },
            smartLinks: {
                showAuthTooltip: true,
                ...(0, $1ybV0.ff)('platform.linking-platform.jira-renderer-use-default-smartlinks-value') ? (0, $9XfZZ.smartLinksDefault) : {}
            }
        }));
    }
}

});
parcelRegister("9wcjJ", function(module, exports) {

$parcel$export(module.exports, "defaultSchemaConfig", () => $6ee0a826b7e77e55$export$e4e3ac1fa64862db);
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $6ee0a826b7e77e55$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $6ee0a826b7e77e55$export$1db618b7b2275ea1);

var $5iWql = parcelRequire("5iWql");

var $lUaLf = parcelRequire("lUaLf");
var $jTnho = parcelRequire("jTnho");
var $byxO6 = parcelRequire("byxO6");

var $khrXf = parcelRequire("khrXf");
const $6ee0a826b7e77e55$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $6ee0a826b7e77e55$export$e4e3ac1fa64862db = $6ee0a826b7e77e55$var$getDefaultSchemaConfig();
const $6ee0a826b7e77e55$export$fd147e7d448dea03 = (0, $5iWql.default)((stage = 'final')=>{
    const defaultSchemaConfig = $6ee0a826b7e77e55$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $jTnho.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $lUaLf.multiBodiedExtension),
        extensionFrame: (0, $lUaLf.extensionFrame),
        table: (0, $byxO6.tableStage0)
    };
    return (0, $khrXf.createSchema)(defaultSchemaConfig);
});
const $6ee0a826b7e77e55$export$1db618b7b2275ea1 = $6ee0a826b7e77e55$export$fd147e7d448dea03();

});
parcelRegister("lUaLf", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", () => $ff272cde3452ccae$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $ff272cde3452ccae$export$c3c04d555a8b9013);

var $eUEbq = parcelRequire("eUEbq");
const $ff272cde3452ccae$export$4fdcae991fd743e7 = {
    type: 'extensionFrame',
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    isolating: true,
    marks: 'dataConsumer fragment',
    definingAsContext: false,
    definingForContent: true,
    selectable: false,
    attrs: {},
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
/**
 * @stage 0
 * @name multiBodiedExtension_node
 * @description Wraps multiple extensionFrame objects.
 */ /**
 * @returns NodeSpec for MultiBodiedExtensionDefinition
 */ const $ff272cde3452ccae$var$createMultiBodiedExtensionNodeSpec = ()=>{
    const nodeSpec = {
        inline: false,
        group: 'blockRootOnly',
        content: 'extensionFrame+',
        block: true,
        definingAsContext: true,
        selectable: true,
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        parseDOM: [
            {
                context: 'multiBodiedExtension//',
                tag: '[data-node-type="multi-bodied-extension"]',
                skip: true
            },
            {
                tag: '[data-node-type="multi-bodied-extension"]',
                getAttrs: (domNode)=>(0, $eUEbq.getExtensionAttrs)(domNode)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'multi-bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    };
    return nodeSpec;
};
const $ff272cde3452ccae$export$c3c04d555a8b9013 = $ff272cde3452ccae$var$createMultiBodiedExtensionNodeSpec();

});
parcelRegister("eUEbq", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", () => $adb577300eb72d12$export$1765e2758fc47004);
const $adb577300eb72d12$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $adb577300eb72d12$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $adb577300eb72d12$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("jTnho", function(module, exports) {

$parcel$export(module.exports, "layoutSection", () => $e7b53637cb7eb2d7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $e7b53637cb7eb2d7$export$4f9d8f623ff17117);
/**
 * @name layoutSection_node
 */ /**
 * Need duplicate `type` and `marks` to make both validator and json-schema satisfied
 */ /**
 * @name layoutSection_full_node
 */ /**
 * @stage 0
 * @name layoutSection_with_single_column_node
 */ const $e7b53637cb7eb2d7$export$b3b6a70a7fa4a5be = {
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock* | unsupportedBlock+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true,
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $e7b53637cb7eb2d7$export$4f9d8f623ff17117 = {
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock* | unsupportedBlock+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true,
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};

});

parcelRegister("byxO6", function(module, exports) {

$parcel$export(module.exports, "tablePrefixSelector", () => $869d1810285fb07e$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $869d1810285fb07e$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $869d1810285fb07e$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $869d1810285fb07e$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $869d1810285fb07e$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $869d1810285fb07e$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $869d1810285fb07e$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $869d1810285fb07e$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $869d1810285fb07e$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $869d1810285fb07e$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $869d1810285fb07e$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $869d1810285fb07e$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $869d1810285fb07e$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $869d1810285fb07e$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $869d1810285fb07e$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $869d1810285fb07e$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $869d1810285fb07e$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $869d1810285fb07e$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $869d1810285fb07e$export$2af48797a1010bb1);

var $a3bbC = parcelRequire("a3bbC");

var $jR93G = parcelRequire("jR93G");

var $lUXsh = parcelRequire("lUXsh");

var $as9OS = parcelRequire("as9OS");
const $869d1810285fb07e$export$9cfceb893b24742a = 'pm-table';
const $869d1810285fb07e$export$69cb4c3f80383763 = `${$869d1810285fb07e$export$9cfceb893b24742a}-cell-content-wrap`;
const $869d1810285fb07e$export$7b07d37d879c957f = `${$869d1810285fb07e$export$9cfceb893b24742a}-header-content-wrap`;
const $869d1810285fb07e$export$8dd42a84cd52da07 = `${$869d1810285fb07e$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $869d1810285fb07e$export$5e26a5c19f0865d8 = `${$869d1810285fb07e$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $869d1810285fb07e$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $jR93G.N20).toLocaleLowerCase();
const $869d1810285fb07e$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $jR93G.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $jR93G.isRgb)(backgroundColor)) {
        const result = (0, $jR93G.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
let $869d1810285fb07e$var$testGlobalTheme;
const $869d1810285fb07e$export$fd7e0dd2b74807f7 = (theme)=>{
    $869d1810285fb07e$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $869d1810285fb07e$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($869d1810285fb07e$var$testGlobalTheme) return {
        colorMode: $869d1810285fb07e$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $869d1810285fb07e$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $869d1810285fb07e$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $869d1810285fb07e$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $jR93G.isRgb)(background) && (0, $jR93G.rgbToHex)(background) ? (0, $jR93G.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $a3bbC.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($869d1810285fb07e$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $as9OS.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            attrs.colorname = $869d1810285fb07e$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $869d1810285fb07e$export$7b07d37d879c957f;
    else attrs.class = $869d1810285fb07e$export$69cb4c3f80383763;
    return attrs;
};
const $869d1810285fb07e$export$219b7f492ad209f8 = new Map();
const $869d1810285fb07e$export$95e9c925fbf01d1c = (0, $jR93G.hexToRgba)((0, $jR93G.N800), 0.12) || (0, $jR93G.N0);
const $869d1810285fb07e$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $jR93G.N0),
        'White'
    ],
    [
        (0, $jR93G.B50),
        'Light blue'
    ],
    [
        (0, $jR93G.T50),
        'Light teal'
    ],
    [
        (0, $jR93G.G50),
        'Light green'
    ],
    [
        (0, $jR93G.Y50),
        'Light yellow'
    ],
    [
        (0, $jR93G.R50),
        'Light red'
    ],
    [
        (0, $jR93G.P50),
        'Light purple'
    ],
    [
        (0, $jR93G.N20),
        'Light gray'
    ],
    [
        (0, $jR93G.B75),
        'Blue'
    ],
    [
        (0, $jR93G.T75),
        'Teal'
    ],
    [
        (0, $jR93G.G75),
        'Green'
    ],
    [
        (0, $jR93G.Y75),
        'Yellow'
    ],
    [
        (0, $jR93G.R75),
        'Red'
    ],
    [
        (0, $jR93G.P75),
        'Purple'
    ],
    [
        (0, $jR93G.N60),
        'Gray'
    ],
    [
        (0, $jR93G.B100),
        'Dark blue'
    ],
    [
        (0, $jR93G.T100),
        'Dark teal'
    ],
    [
        (0, $jR93G.G200),
        'Dark green'
    ],
    [
        (0, $jR93G.Y200),
        'Dark yellow'
    ],
    [
        (0, $jR93G.R100),
        'Dark red'
    ],
    [
        (0, $jR93G.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $869d1810285fb07e$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $869d1810285fb07e$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // TODO: Fix any, potential issue. ED-5048
const $869d1810285fb07e$var$createTableSpec = (allowPreserveTableWidth = false)=>{
    const attrs = {
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        __autoSize: {
            default: false
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        }
    };
    const finalAttrs = allowPreserveTableWidth ? {
        ...attrs,
        displayMode: {
            default: null
        }
    } : attrs;
    const tableNodeSpec = {
        content: 'tableRow+',
        attrs: finalAttrs,
        marks: 'unsupportedMark unsupportedNodeAttribute',
        tableRole: 'table',
        isolating: true,
        selectable: true,
        group: 'block',
        parseDOM: [
            {
                tag: 'table',
                getAttrs: (node)=>{
                    var _dom$parentElement;
                    const dom = node;
                    const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                    return {
                        isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                        layout: // copying from editor
                        dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                        __autoSize: dom.getAttribute('data-autosize') === 'true',
                        localId: dom.getAttribute('data-table-local-id') || (0, $lUXsh.uuid).generate(),
                        width: Number(dom.getAttribute('data-table-width')) || null,
                        displayMode: dom.getAttribute('data-table-display-mode') || null
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-number-column': node.attrs.isNumberColumnEnabled,
                'data-layout': node.attrs.layout,
                'data-autosize': node.attrs.__autoSize,
                'data-table-local-id': node.attrs.localId,
                'data-table-width': node.attrs.width,
                'data-table-display-mode': node.attrs.displayMode
            };
            return [
                'table',
                attrs,
                [
                    'tbody',
                    0
                ]
            ];
        }
    };
    return tableNodeSpec;
};
const $869d1810285fb07e$export$9852986a3ec5f6a0 = $869d1810285fb07e$var$createTableSpec();
const $869d1810285fb07e$export$90e634fbace1f0c4 = $869d1810285fb07e$var$createTableSpec();
const $869d1810285fb07e$export$3862de5c8c9098cf = $869d1810285fb07e$var$createTableSpec(true);
const $869d1810285fb07e$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $869d1810285fb07e$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$869d1810285fb07e$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $869d1810285fb07e$export$ce666bf02318c957 = {
    selectable: false,
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    tableRole: 'row',
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $869d1810285fb07e$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
const $869d1810285fb07e$export$e1e720e5f4603e6a = {
    selectable: false,
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle |  mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    attrs: $869d1810285fb07e$var$cellAttrs,
    tableRole: 'cell',
    marks: 'alignment dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    isolating: true,
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: (dom)=>$869d1810285fb07e$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $869d1810285fb07e$export$363c8dda799bfe9c(node),
            0
        ]
};
const $869d1810285fb07e$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($869d1810285fb07e$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $869d1810285fb07e$export$48884d2a5190dc73 = {
    selectable: false,
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle |  mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    attrs: $869d1810285fb07e$var$cellAttrs,
    tableRole: 'header_cell',
    isolating: true,
    marks: 'alignment dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$869d1810285fb07e$export$43977bde391e007(dom, {
                    background: $869d1810285fb07e$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $869d1810285fb07e$export$363c8dda799bfe9c(node),
            0
        ]
};
const $869d1810285fb07e$export$2af48797a1010bb1 = $869d1810285fb07e$export$2ac34c099660f1a8;

});
parcelRegister("a3bbC", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $7512dc9a41818c00$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $7512dc9a41818c00$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $7512dc9a41818c00$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $7512dc9a41818c00$export$a270511a0e7fd61a);
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $7512dc9a41818c00$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return $7512dc9a41818c00$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $7512dc9a41818c00$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $7512dc9a41818c00$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return $7512dc9a41818c00$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $7512dc9a41818c00$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $7512dc9a41818c00$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return $7512dc9a41818c00$export$12a518ff137dd389[hexColor.toUpperCase()];
}
const $7512dc9a41818c00$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $7512dc9a41818c00$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = $7512dc9a41818c00$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $7512dc9a41818c00$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("jR93G", function(module, exports) {

$parcel$export(module.exports, "R50", () => $e749fe592a330097$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $e749fe592a330097$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $e749fe592a330097$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $e749fe592a330097$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $e749fe592a330097$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $e749fe592a330097$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $e749fe592a330097$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $e749fe592a330097$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $e749fe592a330097$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y400", () => $e749fe592a330097$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $e749fe592a330097$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $e749fe592a330097$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $e749fe592a330097$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $e749fe592a330097$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $e749fe592a330097$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $e749fe592a330097$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $e749fe592a330097$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $e749fe592a330097$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $e749fe592a330097$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $e749fe592a330097$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $e749fe592a330097$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $e749fe592a330097$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $e749fe592a330097$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $e749fe592a330097$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $e749fe592a330097$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N60", () => $e749fe592a330097$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $e749fe592a330097$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N300", () => $e749fe592a330097$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $e749fe592a330097$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $e749fe592a330097$export$13609db0e6812ab8);
$parcel$export(module.exports, "N600", () => $e749fe592a330097$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $e749fe592a330097$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $e749fe592a330097$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $e749fe592a330097$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $e749fe592a330097$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $e749fe592a330097$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $e749fe592a330097$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $e749fe592a330097$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $e749fe592a330097$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $e749fe592a330097$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $e749fe592a330097$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $e749fe592a330097$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $e749fe592a330097$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $e749fe592a330097$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $e749fe592a330097$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $e749fe592a330097$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $e749fe592a330097$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $e749fe592a330097$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $e749fe592a330097$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $e749fe592a330097$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $e749fe592a330097$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $e749fe592a330097$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $e749fe592a330097$export$9665a07d9187b414);

var $dDX7B = parcelRequire("dDX7B");
const $e749fe592a330097$export$4b84fd0e2c617bd = '#FFEBE6';
const $e749fe592a330097$export$b34b069eff244586 = '#FFBDAD';
const $e749fe592a330097$export$be802dd0d8b57f35 = '#FF8F73';
const $e749fe592a330097$export$4a7404f376229999 = '#FF5630';
const $e749fe592a330097$export$2010d0fb4295b346 = '#DE350B';
const $e749fe592a330097$export$2837b5a1a71d5c02 = '#BF2600';
const $e749fe592a330097$export$8d9596b529bbb9cf = '#FFFAE6';
const $e749fe592a330097$export$41060a744ab0b7ae = '#FFF0B3';
const $e749fe592a330097$export$5aae31392d72caaa = '#FFC400';
const $e749fe592a330097$export$59619663aa6500fb = '#FF991F';
const $e749fe592a330097$export$874739ea9e379ab6 = '#FF8B00';
const $e749fe592a330097$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $e749fe592a330097$export$69a3bf21b9686c2b = '#ABF5D1';
const $e749fe592a330097$export$747d86715d4175de = '#57D9A3';
const $e749fe592a330097$export$940e1f69e873f202 = '#36B37E';
const $e749fe592a330097$export$a49394138f7b8e85 = '#00875A';
const $e749fe592a330097$export$6fa04827ac68a4fb = '#006644';
const $e749fe592a330097$export$226de0355ed012f8 = '#DEEBFF';
const $e749fe592a330097$export$8c13c2ee36917869 = '#B3D4FF';
const $e749fe592a330097$export$ecfc1dff386a3e7a = '#4C9AFF';
const $e749fe592a330097$export$b3de0ae08da2ce64 = '#0052CC';
const $e749fe592a330097$export$a6ee3d71bc067634 = '#0747A6';
const $e749fe592a330097$export$f72948ef771f6f15 = '#D3F1A7';
const $e749fe592a330097$export$29a4f05edc054374 = '#FFFFFF';
const $e749fe592a330097$export$9fdfb749e33cdf97 = '#F4F5F7';
const $e749fe592a330097$export$3e51e8f1440314ba = '#EBECF0';
const $e749fe592a330097$export$1ce2d1575d444ceb = '#DFE1E6';
const $e749fe592a330097$export$8754fc7e6d8b3000 = '#C1C7D0';
const $e749fe592a330097$export$c2e91cbeada39b8b = '#B3BAC5';
const $e749fe592a330097$export$eaa8c8a70ac22806 = '#97A0AF';
const $e749fe592a330097$export$7c87d337fb91a97d = '#8993A4';
const $e749fe592a330097$export$f563ee71e9ee74cd = '#6B778C';
const $e749fe592a330097$export$e2ef2124cf4024b1 = '#5E6C84';
const $e749fe592a330097$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $e749fe592a330097$export$13609db0e6812ab8 = '#091E4224';
const $e749fe592a330097$export$c39c0fe0f26207ae = '#42526E';
const $e749fe592a330097$export$7090862dc3038a9f = '#758195';
const $e749fe592a330097$export$7d61b15e0da132af = '#172B4D';
const $e749fe592a330097$export$f78789c8b01753cd = '#172B4D';
const $e749fe592a330097$export$a19f0c33186f7767 = '#FDD0EC';
const $e749fe592a330097$export$51716a84e62e022c = '#FEDEC8';
const $e749fe592a330097$export$363e4475840015bb = '#EAE6FF';
const $e749fe592a330097$export$4b0a4417ed59760f = '#C0B6F2';
const $e749fe592a330097$export$6011520a64d9a187 = '#998DD9';
const $e749fe592a330097$export$a7175d4e9206bc80 = '#DFD8FD';
const $e749fe592a330097$export$b48405b95304b5a1 = '#6554C0';
const $e749fe592a330097$export$c71e4279dd54a18d = '#5243AA';
const $e749fe592a330097$export$147899de772240ec = '#403294';
const $e749fe592a330097$export$2cf711fe14c66f06 = '#E6FCFF';
const $e749fe592a330097$export$7a8f4d33f6f9772c = '#B3F5FF';
const $e749fe592a330097$export$776c9c497ef08533 = '#79E2F2';
const $e749fe592a330097$export$69cb3ca10c1e330e = '#C6EDFB';
const $e749fe592a330097$export$9dc1ef0f3f48059b = '#00B8D9';
const $e749fe592a330097$export$6036577f95c3877e = '#008DA6';
function $e749fe592a330097$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($e749fe592a330097$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($e749fe592a330097$export$e698776ec826343(color)) return $e749fe592a330097$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($dDX7B.default && $dDX7B.default[color]) color = $dDX7B.default[color];
        else if ($dDX7B && $dDX7B[color]) color = $dDX7B[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $e749fe592a330097$export$5a544e13ad4e1fa5(color) {
    if (!$e749fe592a330097$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $e749fe592a330097$export$9665a07d9187b414(rawColor, alpha) {
    const color = $e749fe592a330097$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $e749fe592a330097$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $e749fe592a330097$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $e749fe592a330097$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("dDX7B", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("lUXsh", function(module, exports) {

$parcel$export(module.exports, "generateUuid", () => $ff4cf27d021d1199$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $ff4cf27d021d1199$export$31b40729666a4ae0);
/* eslint-disable no-bitwise */ const $ff4cf27d021d1199$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $ff4cf27d021d1199$var$staticValue = false;
const $ff4cf27d021d1199$export$31b40729666a4ae0 = {
    setStatic (value) {
        $ff4cf27d021d1199$var$staticValue = value;
    },
    generate () {
        return $ff4cf27d021d1199$var$staticValue || $ff4cf27d021d1199$export$1c3aefb711c3a4cc();
    }
};

});

parcelRegister("as9OS", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", () => $79c422e1aade6ff8$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
const $79c422e1aade6ff8$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $79c422e1aade6ff8$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $79c422e1aade6ff8$var$rgbFromHex = (input)=>{
    const fullHex = $79c422e1aade6ff8$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $79c422e1aade6ff8$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $79c422e1aade6ff8$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $79c422e1aade6ff8$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $79c422e1aade6ff8$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $79c422e1aade6ff8$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $79c422e1aade6ff8$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $79c422e1aade6ff8$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $79c422e1aade6ff8$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $79c422e1aade6ff8$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $79c422e1aade6ff8$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $79c422e1aade6ff8$var$rgbToLch = (rgb)=>$79c422e1aade6ff8$var$labToLch($79c422e1aade6ff8$var$xyzToLab($79c422e1aade6ff8$var$rgbToXyz(rgb)));
const $79c422e1aade6ff8$var$lchToRgb = (lch)=>$79c422e1aade6ff8$var$xyzToRgb($79c422e1aade6ff8$var$labToXyz($79c422e1aade6ff8$var$lchToLab(lch)));
const $79c422e1aade6ff8$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $79c422e1aade6ff8$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $79c422e1aade6ff8$var$rgbToLch(rgb);
    lch.l = $79c422e1aade6ff8$var$clamp(newPercent, 0, 100);
    return $79c422e1aade6ff8$var$rgbToHex($79c422e1aade6ff8$var$lchToRgb(lch));
};
const $79c422e1aade6ff8$var$getLightness = (color)=>{
    const rgb = $79c422e1aade6ff8$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $79c422e1aade6ff8$var$rgbToLch(rgb);
    return lch.l;
};
const $79c422e1aade6ff8$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $79c422e1aade6ff8$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $79c422e1aade6ff8$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("khrXf", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $ec3b1467be5518b9$export$5f4ce795563f4211);
$parcel$export(module.exports, "sanitizeNodes", () => $ec3b1467be5518b9$export$daf54fed04c8fb77);

var $7dkLM = parcelRequire("7dkLM");


var $dkRpY = parcelRequire("dkRpY");
var $ht6w1 = parcelRequire("ht6w1");
var $wOKi6 = parcelRequire("wOKi6");
var $dx7fV = parcelRequire("dx7fV");
var $5He3U = parcelRequire("5He3U");
var $4ohT6 = parcelRequire("4ohT6");
var $de8p2 = parcelRequire("de8p2");
var $8nj7b = parcelRequire("8nj7b");
var $79k1z = parcelRequire("79k1z");
var $9iaXL = parcelRequire("9iaXL");
var $l9pLr = parcelRequire("l9pLr");
var $3SpHb = parcelRequire("3SpHb");
var $4w9F8 = parcelRequire("4w9F8");
var $hkdIQ = parcelRequire("hkdIQ");
var $gIVi2 = parcelRequire("gIVi2");
var $6USfM = parcelRequire("6USfM");
var $2ce3x = parcelRequire("2ce3x");
var $7LHzX = parcelRequire("7LHzX");
var $gLNTn = parcelRequire("gLNTn");
var $8osWo = parcelRequire("8osWo");

var $heoPx = parcelRequire("heoPx");
var $jDF31 = parcelRequire("jDF31");
var $eStcf = parcelRequire("eStcf");
var $568Ob = parcelRequire("568Ob");
var $d99SJ = parcelRequire("d99SJ");
var $hgVop = parcelRequire("hgVop");
var $eTtDn = parcelRequire("eTtDn");
var $1Ud4U = parcelRequire("1Ud4U");
var $56qNL = parcelRequire("56qNL");
var $8CDqw = parcelRequire("8CDqw");
var $47B7q = parcelRequire("47B7q");
var $dPUL6 = parcelRequire("dPUL6");
var $1HZv5 = parcelRequire("1HZv5");
var $7XTsD = parcelRequire("7XTsD");
var $5JhXr = parcelRequire("5JhXr");
var $lKuoe = parcelRequire("lKuoe");
var $dj4Ew = parcelRequire("dj4Ew");
var $izui5 = parcelRequire("izui5");
var $7y7sZ = parcelRequire("7y7sZ");
var $lUaLf = parcelRequire("lUaLf");
var $7SlQD = parcelRequire("7SlQD");
var $iWGOh = parcelRequire("iWGOh");
var $iOeir = parcelRequire("iOeir");
var $8mC62 = parcelRequire("8mC62");
var $7xvQK = parcelRequire("7xvQK");
var $1O3jv = parcelRequire("1O3jv");
var $jTnho = parcelRequire("jTnho");
var $3eVto = parcelRequire("3eVto");
var $gN3fl = parcelRequire("gN3fl");
var $1KDvn = parcelRequire("1KDvn");
var $hXvCf = parcelRequire("hXvCf");
var $cvCFq = parcelRequire("cvCFq");
var $fkqTY = parcelRequire("fkqTY");
var $8lnnz = parcelRequire("8lnnz");
var $5bGpU = parcelRequire("5bGpU");
var $dDs5p = parcelRequire("dDs5p");
var $7wZ4m = parcelRequire("7wZ4m");
var $cvo5z = parcelRequire("cvo5z");
var $byxO6 = parcelRequire("byxO6");
var $ie5d6 = parcelRequire("ie5d6");
var $7QozA = parcelRequire("7QozA");
var $ltJuR = parcelRequire("ltJuR");
var $4ne8H = parcelRequire("4ne8H");
var $7p32Z = parcelRequire("7p32Z");
var $8cuPa = parcelRequire("8cuPa");
function $ec3b1467be5518b9$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $ec3b1467be5518b9$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $ec3b1467be5518b9$var$markGroupDeclarations = [
    $ec3b1467be5518b9$var$groupDeclaration((0, $a82948bb4071f608$export$9b982809044276a6)),
    $ec3b1467be5518b9$var$groupDeclaration((0, $a82948bb4071f608$export$4498a6080fed604c)),
    $ec3b1467be5518b9$var$groupDeclaration((0, $a82948bb4071f608$export$f8e8a5f34f6ea725)),
    $ec3b1467be5518b9$var$groupDeclaration((0, $a82948bb4071f608$export$b395009ca7f092c7))
];
const $ec3b1467be5518b9$var$markGroupDeclarationsNames = $ec3b1467be5518b9$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $ec3b1467be5518b9$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $1HZv5.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $5bGpU.paragraph)
    },
    {
        name: 'text',
        spec: (0, $ltJuR.text)
    },
    {
        name: 'bulletList',
        spec: (0, $568Ob.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $8lnnz.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $3eVto.listItemWithTask)
    },
    {
        name: 'heading',
        spec: (0, $iWGOh.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $jDF31.blockquoteWithList)
    },
    {
        name: 'codeBlock',
        spec: (0, $hgVop.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $izui5.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $7wZ4m.rule)
    },
    {
        name: 'image',
        spec: (0, $iOeir.image)
    },
    {
        name: 'mention',
        spec: (0, $fkqTY.mention)
    },
    {
        name: 'caption',
        spec: (0, $d99SJ.caption)
    },
    {
        name: 'media',
        spec: (0, $gN3fl.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $1KDvn.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $cvCFq.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $hXvCf.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $dDs5p.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $jTnho.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $1O3jv.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $7SlQD.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $5JhXr.emoji)
    },
    {
        name: 'table',
        spec: (0, $byxO6.table)
    },
    {
        name: 'tableCell',
        spec: (0, $byxO6.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $byxO6.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $byxO6.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $eTtDn.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $56qNL.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $1Ud4U.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $dPUL6.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $47B7q.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $7QozA.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $ie5d6.taskItem)
    },
    {
        name: 'date',
        spec: (0, $8CDqw.date)
    },
    {
        name: 'status',
        spec: (0, $cvo5z.status)
    },
    {
        name: 'expand',
        spec: (0, $lKuoe.expand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $dj4Ew.extendedNestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $7y7sZ.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $7xvQK.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $eStcf.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $lUaLf.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $lUaLf.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $8mC62.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $heoPx.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $7XTsD.embedCard)
    },
    {
        name: 'unknownBlock',
        spec: (0, $4ne8H.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $7p32Z.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $8cuPa.unsupportedInline)
    }
];
const $ec3b1467be5518b9$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $3SpHb.link)
    },
    {
        name: 'em',
        spec: (0, $79k1z.em)
    },
    {
        name: 'strong',
        spec: (0, $hkdIQ.strong)
    },
    {
        name: 'textColor',
        spec: (0, $6USfM.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $wOKi6.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $4w9F8.strike)
    },
    {
        name: 'subsup',
        spec: (0, $gIVi2.subsup)
    },
    {
        name: 'underline',
        spec: (0, $7LHzX.underline)
    },
    {
        name: 'code',
        spec: (0, $4ohT6.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $2ce3x.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $dkRpY.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $ht6w1.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $de8p2.confluenceInlineComment)
    },
    ...$ec3b1467be5518b9$var$markGroupDeclarations,
    {
        name: 'breakout',
        spec: (0, $5He3U.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $8nj7b.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $9iaXL.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $l9pLr.indentation)
    },
    {
        name: 'border',
        spec: (0, $dx7fV.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $gLNTn.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $8osWo.unsupportedNodeAttribute)
    }
];
function $ec3b1467be5518b9$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($ec3b1467be5518b9$var$markGroupDeclarationsNames);
    let nodes = $ec3b1467be5518b9$var$addItems($ec3b1467be5518b9$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $ec3b1467be5518b9$var$addItems($ec3b1467be5518b9$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = $ec3b1467be5518b9$export$daf54fed04c8fb77(nodes, marks);
    return new (0, $7dkLM.Schema)({
        nodes: nodes,
        marks: marks
    });
}
function $ec3b1467be5518b9$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $ec3b1467be5518b9$export$9cb535b0ed27c9c(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $ec3b1467be5518b9$export$9cb535b0ed27c9c(nodes, rawContent) {
    const content = rawContent.replace(/\W/g, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$ec3b1467be5518b9$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$ec3b1467be5518b9$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $ec3b1467be5518b9$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent})|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $ec3b1467be5518b9$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes){
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}
const $ec3b1467be5518b9$export$c77b6d30da5276a1 = true;

});
parcelRegister("7dkLM", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5409dbb98ebf29ba$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $5409dbb98ebf29ba$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $5409dbb98ebf29ba$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $5409dbb98ebf29ba$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $5409dbb98ebf29ba$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $5409dbb98ebf29ba$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $5409dbb98ebf29ba$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $5409dbb98ebf29ba$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $5409dbb98ebf29ba$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $5409dbb98ebf29ba$export$3476b78f8f5a8b72);

var $cPnfS = parcelRequire("cPnfS");
function $5409dbb98ebf29ba$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $5409dbb98ebf29ba$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $5409dbb98ebf29ba$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $5409dbb98ebf29ba$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $5409dbb98ebf29ba$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    @internal
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $5409dbb98ebf29ba$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $5409dbb98ebf29ba$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. (Not public.)
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $5409dbb98ebf29ba$var$retIndex(0, pos);
        if (pos == this.size) return $5409dbb98ebf29ba$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $5409dbb98ebf29ba$var$retIndex(i + 1, end);
                return $5409dbb98ebf29ba$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        if (nodes instanceof $5409dbb98ebf29ba$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $5409dbb98ebf29ba$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $5409dbb98ebf29ba$export$ffb0004e005737fa.empty = new $5409dbb98ebf29ba$export$ffb0004e005737fa([], 0);
const $5409dbb98ebf29ba$var$found = {
    index: 0,
    offset: 0
};
function $5409dbb98ebf29ba$var$retIndex(index, offset) {
    $5409dbb98ebf29ba$var$found.index = index;
    $5409dbb98ebf29ba$var$found.offset = offset;
    return $5409dbb98ebf29ba$var$found;
}
function $5409dbb98ebf29ba$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$5409dbb98ebf29ba$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$5409dbb98ebf29ba$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $5409dbb98ebf29ba$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $5409dbb98ebf29ba$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        return type.create(json.attrs);
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        if (marks instanceof $5409dbb98ebf29ba$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $5409dbb98ebf29ba$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $5409dbb98ebf29ba$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e($5409dbb98ebf29ba$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e($5409dbb98ebf29ba$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.empty = new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e($5409dbb98ebf29ba$export$ffb0004e005737fa.empty, 0, 0);
function $5409dbb98ebf29ba$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($5409dbb98ebf29ba$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $5409dbb98ebf29ba$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $5409dbb98ebf29ba$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $5409dbb98ebf29ba$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $5409dbb98ebf29ba$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $5409dbb98ebf29ba$export$6de0e778727af3f2("Inconsistent open depths");
    return $5409dbb98ebf29ba$var$replaceOuter($from, $to, slice, 0);
}
function $5409dbb98ebf29ba$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $5409dbb98ebf29ba$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $5409dbb98ebf29ba$var$close(node, $5409dbb98ebf29ba$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $5409dbb98ebf29ba$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $5409dbb98ebf29ba$var$prepareSliceForReplace(slice, $from);
        return $5409dbb98ebf29ba$var$close(node, $5409dbb98ebf29ba$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $5409dbb98ebf29ba$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $5409dbb98ebf29ba$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $5409dbb98ebf29ba$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $5409dbb98ebf29ba$var$checkJoin(node, $after.node(depth));
    return node;
}
function $5409dbb98ebf29ba$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $5409dbb98ebf29ba$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $5409dbb98ebf29ba$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$5409dbb98ebf29ba$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $5409dbb98ebf29ba$var$addNode($end.nodeBefore, target);
}
function $5409dbb98ebf29ba$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $5409dbb98ebf29ba$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $5409dbb98ebf29ba$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $5409dbb98ebf29ba$var$joinable($end, $to, depth + 1);
    let content = [];
    $5409dbb98ebf29ba$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $5409dbb98ebf29ba$var$checkJoin(openStart, openEnd);
        $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(openStart, $5409dbb98ebf29ba$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(openStart, $5409dbb98ebf29ba$var$replaceTwoWay($from, $start, depth + 1)), content);
        $5409dbb98ebf29ba$var$addRange($start, $end, depth, content);
        if (openEnd) $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(openEnd, $5409dbb98ebf29ba$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $5409dbb98ebf29ba$var$addRange($to, null, depth, content);
    return new $5409dbb98ebf29ba$export$ffb0004e005737fa(content);
}
function $5409dbb98ebf29ba$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $5409dbb98ebf29ba$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $5409dbb98ebf29ba$var$joinable($from, $to, depth + 1);
        $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(type, $5409dbb98ebf29ba$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $5409dbb98ebf29ba$var$addRange($to, null, depth, content);
    return new $5409dbb98ebf29ba$export$ffb0004e005737fa(content);
}
function $5409dbb98ebf29ba$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($5409dbb98ebf29ba$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $5409dbb98ebf29ba$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $5409dbb98ebf29ba$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $5409dbb98ebf29ba$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        for(let i = 0; i < $5409dbb98ebf29ba$var$resolveCache.length; i++){
            let cached = $5409dbb98ebf29ba$var$resolveCache[i];
            if (cached.pos == pos && cached.doc == doc) return cached;
        }
        let result = $5409dbb98ebf29ba$var$resolveCache[$5409dbb98ebf29ba$var$resolveCachePos] = $5409dbb98ebf29ba$export$b2a42f82e59e4b19.resolve(doc, pos);
        $5409dbb98ebf29ba$var$resolveCachePos = ($5409dbb98ebf29ba$var$resolveCachePos + 1) % $5409dbb98ebf29ba$var$resolveCacheSize;
        return result;
    }
}
let $5409dbb98ebf29ba$var$resolveCache = [], $5409dbb98ebf29ba$var$resolveCachePos = 0, $5409dbb98ebf29ba$var$resolveCacheSize = 12;
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $5409dbb98ebf29ba$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $5409dbb98ebf29ba$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $5409dbb98ebf29ba$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $5409dbb98ebf29ba$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $5409dbb98ebf29ba$var$emptyAttrs) && $5409dbb98ebf29ba$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $5409dbb98ebf29ba$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $5409dbb98ebf29ba$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $5409dbb98ebf29ba$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $5409dbb98ebf29ba$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $5409dbb98ebf29ba$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $5409dbb98ebf29ba$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise error when they do not.
    */ check() {
        this.type.checkContent(this.content);
        let copy = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++)copy = this.marks[i].addToSet(copy);
        if (!$5409dbb98ebf29ba$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = null;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $5409dbb98ebf29ba$export$ffb0004e005737fa.fromJSON(schema, json.content);
        return schema.nodeType(json.type).create(json.attrs, content, marks);
    }
}
$5409dbb98ebf29ba$export$85c928794f8d04d4.prototype.text = undefined;
class $5409dbb98ebf29ba$var$TextNode extends $5409dbb98ebf29ba$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $5409dbb98ebf29ba$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $5409dbb98ebf29ba$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $5409dbb98ebf29ba$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $5409dbb98ebf29ba$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $5409dbb98ebf29ba$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $5409dbb98ebf29ba$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $5409dbb98ebf29ba$export$364ed450558d7ec4.empty;
        let expr = $5409dbb98ebf29ba$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $5409dbb98ebf29ba$var$dfa($5409dbb98ebf29ba$var$nfa(expr));
        $5409dbb98ebf29ba$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $5409dbb98ebf29ba$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $5409dbb98ebf29ba$export$364ed450558d7ec4.empty = new $5409dbb98ebf29ba$export$364ed450558d7ec4(true);
class $5409dbb98ebf29ba$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $5409dbb98ebf29ba$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($5409dbb98ebf29ba$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $5409dbb98ebf29ba$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($5409dbb98ebf29ba$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $5409dbb98ebf29ba$var$parseExprSubscript(stream) {
    let expr = $5409dbb98ebf29ba$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $5409dbb98ebf29ba$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $5409dbb98ebf29ba$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $5409dbb98ebf29ba$var$parseExprRange(stream, expr) {
    let min = $5409dbb98ebf29ba$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $5409dbb98ebf29ba$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $5409dbb98ebf29ba$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.groups.indexOf(name) > -1) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $5409dbb98ebf29ba$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $5409dbb98ebf29ba$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $5409dbb98ebf29ba$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
/**
Construct an NFA from an expression as returned by the parser. The
NFA is represented as an array of states, which are themselves
arrays of edges, which are `{term, to}` objects. The first state is
the entry state and the last node is the success state.

Note that unlike typical NFAs, the edge ordering in this one is
significant, in that it is used to contruct filler content when
necessary.
*/ function $5409dbb98ebf29ba$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $5409dbb98ebf29ba$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $5409dbb98ebf29ba$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($5409dbb98ebf29ba$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $5409dbb98ebf29ba$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($5409dbb98ebf29ba$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $5409dbb98ebf29ba$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $5409dbb98ebf29ba$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($5409dbb98ebf29ba$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $5409dbb98ebf29ba$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $5409dbb98ebf29ba$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $5409dbb98ebf29ba$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $5409dbb98ebf29ba$var$initAttrs(attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $5409dbb98ebf29ba$var$Attribute(attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $5409dbb98ebf29ba$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $5409dbb98ebf29ba$var$initAttrs(spec.attrs);
        this.defaultAttrs = $5409dbb98ebf29ba$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $5409dbb98ebf29ba$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $5409dbb98ebf29ba$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $5409dbb98ebf29ba$export$ffb0004e005737fa.from(content), $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $5409dbb98ebf29ba$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $5409dbb98ebf29ba$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($5409dbb98ebf29ba$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this, attrs, content.append(after), $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type with the given attributes.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $5409dbb98ebf29ba$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
// Attribute descriptors
class $5409dbb98ebf29ba$var$Attribute {
    constructor(options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $5409dbb98ebf29ba$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $5409dbb98ebf29ba$var$initAttrs(spec.attrs);
        this.excluded = null;
        let defaults = $5409dbb98ebf29ba$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $5409dbb98ebf29ba$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $5409dbb98ebf29ba$export$c9d15bcfc6d42044(this, $5409dbb98ebf29ba$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $5409dbb98ebf29ba$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $5409dbb98ebf29ba$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $cPnfS.default).from(spec.nodes), instanceSpec.marks = (0, $cPnfS.default).from(spec.marks || {}), this.nodes = $5409dbb98ebf29ba$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $5409dbb98ebf29ba$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $5409dbb98ebf29ba$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            type.markSet = markExpr == "_" ? null : markExpr ? $5409dbb98ebf29ba$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $5409dbb98ebf29ba$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $5409dbb98ebf29ba$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $5409dbb98ebf29ba$var$TextNode(type, type.defaultAttrs, text, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $5409dbb98ebf29ba$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $5409dbb98ebf29ba$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $5409dbb98ebf29ba$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $5409dbb98ebf29ba$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        rules.forEach((rule)=>{
            if (rule.tag) this.tags.push(rule);
            else if (rule.style) this.styles.push(rule);
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $5409dbb98ebf29ba$var$ParseContext(this, options, false);
        context.addAll(dom, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $5409dbb98ebf29ba$var$ParseContext(this, options, true);
        context.addAll(dom, options.from, options.to);
        return $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($5409dbb98ebf29ba$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $5409dbb98ebf29ba$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $5409dbb98ebf29ba$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $5409dbb98ebf29ba$export$1059c6e7d2ce5669(schema, $5409dbb98ebf29ba$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $5409dbb98ebf29ba$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $5409dbb98ebf29ba$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $5409dbb98ebf29ba$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $5409dbb98ebf29ba$var$OPT_PRESERVE_WS = 1, $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL = 2, $5409dbb98ebf29ba$var$OPT_OPEN_LEFT = 4;
function $5409dbb98ebf29ba$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $5409dbb98ebf29ba$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $5409dbb98ebf29ba$var$OPT_PRESERVE_WS | $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL : base & ~$5409dbb98ebf29ba$var$OPT_OPEN_LEFT;
}
class $5409dbb98ebf29ba$var$NodeContext {
    constructor(type, attrs, // Marks applied to this node itself
    marks, // Marks that can't apply here, but will be used in children if possible
    pendingMarks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.pendingMarks = pendingMarks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        // Nested Marks with same type
        this.stashMarks = [];
        this.match = match || (options & $5409dbb98ebf29ba$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($5409dbb98ebf29ba$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $5409dbb98ebf29ba$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($5409dbb98ebf29ba$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    popFromStashMark(mark) {
        for(let i = this.stashMarks.length - 1; i >= 0; i--)if (mark.eq(this.stashMarks[i])) return this.stashMarks.splice(i, 1)[0];
    }
    applyPending(nextType) {
        for(let i = 0, pending = this.pendingMarks; i < pending.length; i++){
            let mark = pending[i];
            if ((this.type ? this.type.allowsMarkType(mark.type) : $5409dbb98ebf29ba$var$markMayApply(mark.type, nextType)) && !mark.isInSet(this.activeMarks)) {
                this.activeMarks = mark.addToSet(this.activeMarks);
                this.pendingMarks = mark.removeFromSet(this.pendingMarks);
            }
        }
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$5409dbb98ebf29ba$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $5409dbb98ebf29ba$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        let topNode = options.topNode, topContext;
        let topOptions = $5409dbb98ebf29ba$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $5409dbb98ebf29ba$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $5409dbb98ebf29ba$var$NodeContext(topNode.type, topNode.attrs, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $5409dbb98ebf29ba$var$NodeContext(null, null, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $5409dbb98ebf29ba$var$NodeContext(parser.schema.topNodeType, null, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom) {
        if (dom.nodeType == 3) this.addTextNode(dom);
        else if (dom.nodeType == 1) this.addElement(dom);
    }
    withStyleRules(dom, f) {
        let style = dom.getAttribute("style");
        if (!style) return f();
        let marks = this.readStyles($5409dbb98ebf29ba$var$parseStyles(style));
        if (!marks) return; // A style with ignore: true
        let [addMarks, removeMarks] = marks, top = this.top;
        for(let i = 0; i < removeMarks.length; i++)this.removePendingMark(removeMarks[i], top);
        for(let i = 0; i < addMarks.length; i++)this.addPendingMark(addMarks[i]);
        f();
        for(let i = 0; i < addMarks.length; i++)this.removePendingMark(addMarks[i], top);
        for(let i = 0; i < removeMarks.length; i++)this.addPendingMark(removeMarks[i]);
    }
    addTextNode(dom) {
        let value = dom.nodeValue;
        let top = this.top;
        if (top.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!(top.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS)) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (!(top.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL)) value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value));
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, matchAfter) {
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($5409dbb98ebf29ba$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $5409dbb98ebf29ba$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        if (rule ? rule.ignore : $5409dbb98ebf29ba$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, top = this.top, oldNeedsBlock = this.needsBlock;
            if ($5409dbb98ebf29ba$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom);
                return;
            }
            if (rule && rule.skip) this.addAll(dom);
            else this.withStyleRules(dom, ()=>this.addAll(dom));
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else this.withStyleRules(dom, ()=>{
            this.addElementByRule(dom, rule, rule.consuming === false ? ruleID : undefined);
        });
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"));
    }
    // Called for ignored nodes
    ignoreFallback(dom) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"));
    }
    // Run any style parser associated with the node's styles. Either
    // return an array of marks, or null to indicate some of the styles
    // had a rule with `ignore` set.
    readStyles(styles) {
        let add = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, remove = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < styles.length; i += 2)for(let after = undefined;;){
            let rule = this.parser.matchStyle(styles[i], styles[i + 1], this, after);
            if (!rule) break;
            if (rule.ignore) return null;
            if (rule.clearMark) this.top.pendingMarks.concat(this.top.activeMarks).forEach((m)=>{
                if (rule.clearMark(m)) remove = m.addToSet(remove);
            });
            else add = this.parser.schema.marks[rule.mark].create(rule.attrs).addToSet(add);
            if (rule.consuming === false) after = rule;
            else break;
        }
        return [
            add,
            remove
        ];
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, continueAfter) {
        let sync, nodeType, mark;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) sync = this.enter(nodeType, rule.attrs || null, rule.preserveWhitespace);
            else if (!this.insertNode(nodeType.create(rule.attrs))) this.leafFallback(dom);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            mark = markType.create(rule.attrs);
            this.addPendingMark(mark);
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM);
        }
        if (sync && this.sync(startIn)) this.open--;
        if (mark) this.removePendingMark(mark, startIn);
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return false;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)this.enterInner(route[i], null, false);
        return true;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) this.enterInner(block);
        }
        if (this.findPlace(node)) {
            this.closeExtra();
            let top = this.top;
            top.applyPending(node.type);
            if (top.match) top.match = top.match.matchType(node.type);
            let marks = top.activeMarks;
            for(let i = 0; i < node.marks.length; i++)if (!top.type || top.type.allowsMarkType(node.marks[i].type)) marks = node.marks[i].addToSet(marks);
            top.content.push(node.mark(marks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, preserveWS) {
        let ok = this.findPlace(type.create(attrs));
        if (ok) this.enterInner(type, attrs, true, preserveWS);
        return ok;
    }
    // Open a node of the given type
    enterInner(type, attrs = null, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.applyPending(type);
        top.match = top.match && top.match.matchType(type);
        let options = $5409dbb98ebf29ba$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $5409dbb98ebf29ba$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $5409dbb98ebf29ba$var$OPT_OPEN_LEFT;
        this.nodes.push(new $5409dbb98ebf29ba$var$NodeContext(type, attrs, top.activeMarks, top.pendingMarks, solid, null, options));
        this.open++;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(this.isOpen || this.options.topOpen);
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--)if (this.nodes[i] == to) {
            this.open = i;
            return true;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && next.groups.indexOf(part) == -1) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    addPendingMark(mark) {
        let found = $5409dbb98ebf29ba$var$findSameMarkInSet(mark, this.top.pendingMarks);
        if (found) this.top.stashMarks.push(found);
        this.top.pendingMarks = mark.addToSet(this.top.pendingMarks);
    }
    removePendingMark(mark, upto) {
        for(let depth = this.open; depth >= 0; depth--){
            let level = this.nodes[depth];
            let found = level.pendingMarks.lastIndexOf(mark);
            if (found > -1) level.pendingMarks = mark.removeFromSet(level.pendingMarks);
            else {
                level.activeMarks = mark.removeFromSet(level.activeMarks);
                let stashMark = level.popFromStashMark(mark);
                if (stashMark && level.type && level.type.allowsMarkType(stashMark.type)) level.activeMarks = stashMark.addToSet(level.activeMarks);
            }
            if (level == upto) break;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $5409dbb98ebf29ba$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $5409dbb98ebf29ba$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $5409dbb98ebf29ba$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
// Tokenize a style attribute into property/value pairs.
function $5409dbb98ebf29ba$var$parseStyles(style) {
    let re = /\s*([\w-]+)\s*:\s*([^;]+)/g, m, result = [];
    while(m = re.exec(style))result.push(m[1], m[2].trim());
    return result;
}
function $5409dbb98ebf29ba$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $5409dbb98ebf29ba$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
function $5409dbb98ebf29ba$var$findSameMarkInSet(mark, set) {
    for(let i = 0; i < set.length; i++){
        if (mark.eq(set[i])) return set[i];
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $5409dbb98ebf29ba$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $5409dbb98ebf29ba$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $5409dbb98ebf29ba$export$3476b78f8f5a8b72.renderSpec($5409dbb98ebf29ba$var$doc(options), this.nodes[node.type.name](node));
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $5409dbb98ebf29ba$export$3476b78f8f5a8b72.renderSpec($5409dbb98ebf29ba$var$doc(options), toDOM(mark, inline));
    }
    /**
    Render an [output spec](https://prosemirror.net/docs/ref/#model.DOMOutputSpec) to a DOM node. If
    the spec has a hole (zero) in it, `contentDOM` will point at the
    node with the hole.
    */ static renderSpec(doc, structure, xmlNS = null) {
        if (typeof structure == "string") return {
            dom: doc.createTextNode(structure)
        };
        if (structure.nodeType != null) return {
            dom: structure
        };
        if (structure.dom && structure.dom.nodeType != null) return structure;
        let tagName = structure[0], space = tagName.indexOf(" ");
        if (space > 0) {
            xmlNS = tagName.slice(0, space);
            tagName = tagName.slice(space + 1);
        }
        let contentDOM;
        let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
        let attrs = structure[1], start = 1;
        if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
            start = 2;
            for(let name in attrs)if (attrs[name] != null) {
                let space = name.indexOf(" ");
                if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
                else dom.setAttribute(name, attrs[name]);
            }
        }
        for(let i = start; i < structure.length; i++){
            let child = structure[i];
            if (child === 0) {
                if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
                return {
                    dom: dom,
                    contentDOM: dom
                };
            } else {
                let { dom: inner, contentDOM: innerContent } = $5409dbb98ebf29ba$export$3476b78f8f5a8b72.renderSpec(doc, child, xmlNS);
                dom.appendChild(inner);
                if (innerContent) {
                    if (contentDOM) throw new RangeError("Multiple content holes");
                    contentDOM = innerContent;
                }
            }
        }
        return {
            dom: dom,
            contentDOM: contentDOM
        };
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $5409dbb98ebf29ba$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $5409dbb98ebf29ba$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $5409dbb98ebf29ba$var$gatherToDOM(schema.marks);
    }
}
function $5409dbb98ebf29ba$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $5409dbb98ebf29ba$var$doc(options) {
    return options.document || window.document;
}

});
parcelRegister("cPnfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $956c496b6231a8e7$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $956c496b6231a8e7$var$OrderedMap(content) {
    this.content = content;
}
$956c496b6231a8e7$var$OrderedMap.prototype = {
    constructor: $956c496b6231a8e7$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $956c496b6231a8e7$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $956c496b6231a8e7$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $956c496b6231a8e7$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $956c496b6231a8e7$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $956c496b6231a8e7$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $956c496b6231a8e7$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$956c496b6231a8e7$var$OrderedMap.from = function(value) {
    if (value instanceof $956c496b6231a8e7$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $956c496b6231a8e7$var$OrderedMap(content);
};
var $956c496b6231a8e7$export$2e2bcd8739ae039 = $956c496b6231a8e7$var$OrderedMap;

});


// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $a82948bb4071f608$export$4498a6080fed604c = 'fontStyle';
const $a82948bb4071f608$export$f8e8a5f34f6ea725 = 'searchQuery';
const $a82948bb4071f608$export$b395009ca7f092c7 = 'link';
const $a82948bb4071f608$export$9b982809044276a6 = 'color';
const $a82948bb4071f608$export$470d0905851e47a1 = 'alignment';
const $a82948bb4071f608$export$bacb7f4b06a06b22 = 'indentation';

parcelRegister("dkRpY", function(module, exports) {

$parcel$export(module.exports, "alignmentPositionMap", () => $9b569454df3a2499$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $9b569454df3a2499$export$8e53000a4ec837);

const $9b569454df3a2499$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $9b569454df3a2499$export$8e53000a4ec837 = {
    excludes: `alignment ${(0, $a82948bb4071f608$export$bacb7f4b06a06b22)}`,
    group: (0, $a82948bb4071f608$export$470d0905851e47a1),
    attrs: {
        align: {}
    },
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
};

});

parcelRegister("ht6w1", function(module, exports) {

$parcel$export(module.exports, "AnnotationTypes", () => $cb7a32ece9a7eb7b$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $cb7a32ece9a7eb7b$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $cb7a32ece9a7eb7b$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $cb7a32ece9a7eb7b$export$8512c9afa7b24c3b);
/**
 * @name annotation_mark
 */ let $cb7a32ece9a7eb7b$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
let $cb7a32ece9a7eb7b$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $cb7a32ece9a7eb7b$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $cb7a32ece9a7eb7b$export$8512c9afa7b24c3b = {
    inclusive: true,
    group: 'annotation',
    excludes: '',
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: $cb7a32ece9a7eb7b$export$94aa2fc69ad33d19.INLINE_COMMENT
        }
    },
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$cb7a32ece9a7eb7b$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
};

});

parcelRegister("wOKi6", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", () => $062a5a4c71a35221$export$8c5a050822fd698c);

var $a3bbC = parcelRequire("a3bbC");


var $jR93G = parcelRequire("jR93G");

var $6USfM = parcelRequire("6USfM");

var $as9OS = parcelRequire("as9OS");
/**
 * @name backgroundColor_mark
 */ const $062a5a4c71a35221$var$colorArrayPalette = [
    [
        (0, $jR93G.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $jR93G.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $jR93G.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $jR93G.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $jR93G.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $jR93G.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $062a5a4c71a35221$export$14ec3f21a268e497 = new Map();
$062a5a4c71a35221$var$colorArrayPalette.forEach(([color, label])=>$062a5a4c71a35221$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $062a5a4c71a35221$export$8c5a050822fd698c = {
    attrs: {
        color: {}
    },
    inclusive: true,
    group: (0, $a82948bb4071f608$export$9b982809044276a6),
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $jR93G.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $062a5a4c71a35221$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $062a5a4c71a35221$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $a3bbC.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $6USfM.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $as9OS.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
};

});
parcelRegister("6USfM", function(module, exports) {

$parcel$export(module.exports, "colorPalette", () => $50920eab1d33a737$export$569885e57444f84a);
$parcel$export(module.exports, "getGlobalTheme", () => $50920eab1d33a737$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $50920eab1d33a737$export$32f78bffcd82ff28);

var $a3bbC = parcelRequire("a3bbC");


var $jR93G = parcelRequire("jR93G");

var $as9OS = parcelRequire("as9OS");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
const $50920eab1d33a737$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $jR93G.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $jR93G.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $jR93G.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $jR93G.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $jR93G.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $jR93G.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $jR93G.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $jR93G.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $jR93G.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $jR93G.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $jR93G.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $jR93G.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $jR93G.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $jR93G.N0),
        'White'
    ],
    [
        (0, $jR93G.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $jR93G.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $jR93G.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $jR93G.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $jR93G.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $jR93G.P50),
        'Light purple'
    ] // Lavender secret
];
const $50920eab1d33a737$export$569885e57444f84a = new Map();
const $50920eab1d33a737$export$81e5ed9e84fe2e28 = $50920eab1d33a737$export$569885e57444f84a;
$50920eab1d33a737$var$colorArrayPalette.forEach(([color, label])=>$50920eab1d33a737$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $50920eab1d33a737$var$testGlobalTheme;
const $50920eab1d33a737$export$fd7e0dd2b74807f7 = (theme)=>{
    $50920eab1d33a737$var$testGlobalTheme = theme;
};
const $50920eab1d33a737$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($50920eab1d33a737$var$testGlobalTheme) return {
        colorMode: $50920eab1d33a737$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $50920eab1d33a737$export$32f78bffcd82ff28 = {
    attrs: {
        color: {}
    },
    inclusive: true,
    group: (0, $a82948bb4071f608$export$9b982809044276a6),
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $jR93G.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $50920eab1d33a737$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $50920eab1d33a737$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $a3bbC.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($50920eab1d33a737$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $as9OS.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
};

});


parcelRegister("dx7fV", function(module, exports) {

$parcel$export(module.exports, "borderColorPalette", () => $9da3fc4a55f49543$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $9da3fc4a55f49543$export$1edee58a52776cd9);

var $a3bbC = parcelRequire("a3bbC");

var $jR93G = parcelRequire("jR93G");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ const $9da3fc4a55f49543$var$borderColorArrayPalette = [
    [
        (0, $jR93G.N300A),
        'Subtle gray'
    ],
    [
        (0, $jR93G.N600),
        'Gray'
    ],
    [
        (0, $jR93G.N1000),
        'Bold gray'
    ]
];
const $9da3fc4a55f49543$export$e4e044c989c86ca7 = new Map();
$9da3fc4a55f49543$var$borderColorArrayPalette.forEach(([color, label])=>$9da3fc4a55f49543$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $9da3fc4a55f49543$export$1edee58a52776cd9 = {
    inclusive: false,
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                var _dom$getAttribute, _dom$getAttribute2;
                const dom = domNode;
                const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $9da3fc4a55f49543$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    attrs: {
        color: {},
        size: {}
    },
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $a3bbC.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
};

});

parcelRegister("5He3U", function(module, exports) {

$parcel$export(module.exports, "breakout", () => $425be04f82df9f96$export$89015c65f1c75e3f);
const $425be04f82df9f96$var$allowedTypes = [
    'wide',
    'full-width'
];
const $425be04f82df9f96$export$89015c65f1c75e3f = {
    spanning: false,
    inclusive: false,
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                const mode = dom.getAttribute('data-mode');
                return {
                    mode: $425be04f82df9f96$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode
                };
            }
        }
    ],
    attrs: {
        mode: {
            default: 'wide'
        }
    },
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode
            },
            0
        ];
    }
};

});

parcelRegister("4ohT6", function(module, exports) {

$parcel$export(module.exports, "code", () => $33274773c4b5166a$export$6565f9f03506010b);

const $33274773c4b5166a$export$6565f9f03506010b = {
    excludes: `${(0, $a82948bb4071f608$export$4498a6080fed604c)} ${(0, $a82948bb4071f608$export$b395009ca7f092c7)} ${(0, $a82948bb4071f608$export$f8e8a5f34f6ea725)} ${(0, $a82948bb4071f608$export$9b982809044276a6)}`,
    inclusive: true,
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
};

});

parcelRegister("de8p2", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", () => $9a1319ce36df48fa$export$f3b72f8fc4684ecd);
/**
 * @name inline_comment_marker
 * @description This temporary mark represents a Confluence-backed inline comment that wraps a piece of text. It will be replaced with a cross-product inline comment solution at later date.
 */ const $9a1319ce36df48fa$export$f3b72f8fc4684ecd = {
    inclusive: false,
    excludes: '',
    attrs: {
        reference: {
            default: ''
        }
    },
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
};

});

parcelRegister("8nj7b", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", () => $618f4c86e0c34ede$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $618f4c86e0c34ede$export$54fd2c36b5cc6731);

var $1pjCh = parcelRequire("1pjCh");
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ const $618f4c86e0c34ede$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $1pjCh.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $618f4c86e0c34ede$export$3024f02c495408d6 = {
    attrs: {
        sources: {
            default: []
        }
    },
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$618f4c86e0c34ede$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
};
const $618f4c86e0c34ede$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("1pjCh", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", () => $106757a7f274372d$export$c296e2d4365c37a5);
const $106757a7f274372d$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("79k1z", function(module, exports) {

$parcel$export(module.exports, "em", () => $5348e8113a21cfa8$export$c63c6f932822f543);

/**
 * @name em_mark
 */ const $5348e8113a21cfa8$var$emDOM = [
    'em'
];
const $5348e8113a21cfa8$export$c63c6f932822f543 = {
    inclusive: true,
    group: (0, $a82948bb4071f608$export$4498a6080fed604c),
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $5348e8113a21cfa8$var$emDOM;
    }
};

});

parcelRegister("9iaXL", function(module, exports) {

$parcel$export(module.exports, "fragment", () => $6c3e4c85b88bb30a$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $6c3e4c85b88bb30a$export$54fd2c36b5cc6731);

var $1pjCh = parcelRequire("1pjCh");
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ const $6c3e4c85b88bb30a$var$parseFragment = (maybeValue)=>{
    var _maybeValue$getAttrib;
    if (!(0, $1pjCh.isDOMElement)(maybeValue)) return false;
    const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $6c3e4c85b88bb30a$export$f00aeb236b6f05af = {
    inclusive: false,
    excludes: '',
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$6c3e4c85b88bb30a$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
};
const $6c3e4c85b88bb30a$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("l9pLr", function(module, exports) {

$parcel$export(module.exports, "indentation", () => $f65e6c756517ff64$export$480c699bd4ec0d86);

const $f65e6c756517ff64$export$480c699bd4ec0d86 = {
    excludes: `indentation ${(0, $a82948bb4071f608$export$470d0905851e47a1)}`,
    group: (0, $a82948bb4071f608$export$bacb7f4b06a06b22),
    attrs: {
        level: {}
    },
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
};

});

parcelRegister("3SpHb", function(module, exports) {

$parcel$export(module.exports, "link", () => $2d2a58d971c4790c$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $2d2a58d971c4790c$export$54fd2c36b5cc6731);


var $4N6cH = parcelRequire("4N6cH");
/**
 * @name link_mark
 */ const $2d2a58d971c4790c$var$getLinkAttrs = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $4N6cH.isSafeUrl)(href)) return false;
        if ((0, $4N6cH.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $4N6cH.normalizeUrl)(href);
        return attrs;
    };
const $2d2a58d971c4790c$export$9c30223ca0a664fb = {
    excludes: `${(0, $a82948bb4071f608$export$b395009ca7f092c7)}`,
    // ED-5844 No multiple links in media node
    group: (0, $a82948bb4071f608$export$b395009ca7f092c7),
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $2d2a58d971c4790c$var$getLinkAttrs('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $2d2a58d971c4790c$var$getLinkAttrs('href')
        }
    ],
    toDOM (node, isInline) {
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $4N6cH.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
};
const $2d2a58d971c4790c$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $2d2a58d971c4790c$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($2d2a58d971c4790c$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});
parcelRegister("4N6cH", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $37d08cfa1c7b561a$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $37d08cfa1c7b561a$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $37d08cfa1c7b561a$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $37d08cfa1c7b561a$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $37d08cfa1c7b561a$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $37d08cfa1c7b561a$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $izjsg = parcelRequire("izjsg");
const $37d08cfa1c7b561a$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $37d08cfa1c7b561a$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $37d08cfa1c7b561a$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $37d08cfa1c7b561a$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($izjsg)))();
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $37d08cfa1c7b561a$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('tel:', $37d08cfa1c7b561a$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('file:', $37d08cfa1c7b561a$var$urlWithoutSpacesValidator);
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $37d08cfa1c7b561a$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $37d08cfa1c7b561a$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$37d08cfa1c7b561a$var$tlds.push($37d08cfa1c7b561a$var$tlds2Char);
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.tlds($37d08cfa1c7b561a$var$tlds, false);
const $37d08cfa1c7b561a$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $37d08cfa1c7b561a$export$6f7d7761b97f967 = (text)=>{
    if (!$37d08cfa1c7b561a$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($37d08cfa1c7b561a$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($37d08cfa1c7b561a$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $37d08cfa1c7b561a$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $37d08cfa1c7b561a$export$6f7d7761b97f967(str);
    if (!match.length) match = $37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $37d08cfa1c7b561a$export$6535eb414fa2c8b6(url) {
    const match = $37d08cfa1c7b561a$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $37d08cfa1c7b561a$export$23579274a7a24f7b(url) {
    return url.startsWith('/');
}

});
parcelRegister("izjsg", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d84a96391edf6631$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d84a96391edf6631$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d84a96391edf6631$var$isString(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object String]';
}
function $d84a96391edf6631$var$isObject(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object Object]';
}
function $d84a96391edf6631$var$isRegExp(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object RegExp]';
}
function $d84a96391edf6631$var$isFunction(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object Function]';
}
function $d84a96391edf6631$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d84a96391edf6631$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d84a96391edf6631$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d84a96391edf6631$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d84a96391edf6631$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d84a96391edf6631$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d84a96391edf6631$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d84a96391edf6631$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d84a96391edf6631$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d84a96391edf6631$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d84a96391edf6631$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("bUlLc"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d84a96391edf6631$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d84a96391edf6631$var$isObject(val)) {
            if ($d84a96391edf6631$var$isRegExp(val.validate)) compiled.validate = $d84a96391edf6631$var$createValidator(val.validate);
            else if ($d84a96391edf6631$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d84a96391edf6631$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d84a96391edf6631$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d84a96391edf6631$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d84a96391edf6631$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d84a96391edf6631$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $d84a96391edf6631$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d84a96391edf6631$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d84a96391edf6631$var$createMatch(self, shift) {
    var match = new $d84a96391edf6631$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d84a96391edf6631$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d84a96391edf6631$var$LinkifyIt)) return new $d84a96391edf6631$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d84a96391edf6631$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d84a96391edf6631$var$assign({}, $d84a96391edf6631$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d84a96391edf6631$var$assign({}, $d84a96391edf6631$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d84a96391edf6631$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d84a96391edf6631$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d84a96391edf6631$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d84a96391edf6631$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d84a96391edf6631$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d84a96391edf6631$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d84a96391edf6631$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d84a96391edf6631$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $d84a96391edf6631$var$LinkifyIt;

});
parcelRegister("bUlLc", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("4NOMA")).source;
    re.src_Cc = (parcelRequire("jvFHg")).source;
    re.src_Z = (parcelRequire("8UCq2")).source;
    re.src_P = (parcelRequire("aUAJj")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("4NOMA", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("jvFHg", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("8UCq2", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("aUAJj", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});





parcelRegister("4w9F8", function(module, exports) {

$parcel$export(module.exports, "strike", () => $34a1a559eec97f76$export$4899a95d70ec5056);

const $34a1a559eec97f76$export$4899a95d70ec5056 = {
    inclusive: true,
    group: (0, $a82948bb4071f608$export$4498a6080fed604c),
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
};

});

parcelRegister("hkdIQ", function(module, exports) {

$parcel$export(module.exports, "strong", () => $c9cef2e2919bbc38$export$59ae2c325a998f89);

/**
 * @name strong_mark
 */ const $c9cef2e2919bbc38$var$strongDOM = [
    'strong'
];
const $c9cef2e2919bbc38$export$59ae2c325a998f89 = {
    inclusive: true,
    group: (0, $a82948bb4071f608$export$4498a6080fed604c),
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $c9cef2e2919bbc38$var$strongDOM;
    }
};

});

parcelRegister("gIVi2", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $c2cd32026e6eb3a5$export$b3401ee80eb31041);

/**
 * @name subsup_mark
 */ function $c2cd32026e6eb3a5$var$getAttrFromVerticalAlign(node) {
    if (node.style.verticalAlign) {
        const type = node.style.verticalAlign.slice(0, 3);
        if (type === 'sub' || type === 'sup') return {
            type: type
        };
    }
    return false;
}
const $c2cd32026e6eb3a5$export$b3401ee80eb31041 = {
    inclusive: true,
    group: (0, $a82948bb4071f608$export$4498a6080fed604c),
    attrs: {
        type: {
            default: 'sub'
        }
    },
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            tag: 'span',
            style: 'vertical-align=super',
            getAttrs: (node)=>$c2cd32026e6eb3a5$var$getAttrFromVerticalAlign(node)
        },
        {
            tag: 'span',
            style: 'vertical-align=sub',
            getAttrs: (node)=>$c2cd32026e6eb3a5$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
};

});

parcelRegister("2ce3x", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", () => $19979afb697512ce$export$20af3dabbb5538df);


var $jR93G = parcelRequire("jR93G");
const $19979afb697512ce$export$20af3dabbb5538df = {
    inclusive: true,
    group: (0, $a82948bb4071f608$export$f8e8a5f34f6ea725),
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $jR93G.B400)}`
            }
        ];
    },
    attrs: {
        trigger: {
            default: ''
        }
    }
};

});

parcelRegister("7LHzX", function(module, exports) {

$parcel$export(module.exports, "underline", () => $5a7eba10acd79c46$export$425327af25286e5e);

const $5a7eba10acd79c46$export$425327af25286e5e = {
    inclusive: true,
    group: (0, $a82948bb4071f608$export$4498a6080fed604c),
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
};

});

parcelRegister("gLNTn", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", () => $c357bcad799cb7a9$export$30d78d5eb6719bb8);
const $c357bcad799cb7a9$export$30d78d5eb6719bb8 = {
    toDOM () {
        return [
            'span'
        ];
    },
    excludes: '',
    attrs: {
        originalValue: {}
    }
};

});

parcelRegister("8osWo", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", () => $61c703adc490c2ac$export$a316dc07ff5182a2);
const $61c703adc490c2ac$export$a316dc07ff5182a2 = {
    toDOM () {
        return [
            'span'
        ];
    },
    attrs: {
        type: {},
        unsupported: {}
    }
};

});

parcelRegister("heoPx", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $c8b70143c7895a82$export$c4c2f833baaebdb8);
/**
 * @name blockCard_node
 */ const $c8b70143c7895a82$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || 'center' : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $c8b70143c7895a82$export$c4c2f833baaebdb8 = {
    inline: false,
    group: 'block',
    draggable: true,
    selectable: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$c8b70143c7895a82$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$c8b70143c7895a82$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
};

});

parcelRegister("jDF31", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $e4c18015cb0b91e7$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteWithList", () => $e4c18015cb0b91e7$export$9b4686c4b9672643);
/**
 * @name blockquote_node
 */ const $e4c18015cb0b91e7$var$createBlockquoteSpec = (allowList)=>{
    const blockquoteSpec = {
        group: 'block',
        defining: true,
        selectable: false,
        parseDOM: [
            {
                tag: 'blockquote'
            }
        ],
        toDOM () {
            return [
                'blockquote',
                0
            ];
        }
    };
    if (allowList) blockquoteSpec.content = '(paragraph | orderedList | bulletList | unsupportedBlock)+';
    else blockquoteSpec.content = '(paragraph | unsupportedBlock)+';
    return blockquoteSpec;
};
const $e4c18015cb0b91e7$export$67dc04e652a298ca = $e4c18015cb0b91e7$var$createBlockquoteSpec(false);
const $e4c18015cb0b91e7$export$9b4686c4b9672643 = $e4c18015cb0b91e7$var$createBlockquoteSpec(true);

});

parcelRegister("eStcf", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", () => $ad4cc1abe1dded2c$export$27903d543b563e39);

var $eUEbq = parcelRequire("eUEbq");
/**
 * @name bodiedExtension_node
 */ /**
 * @name bodiedExtension_with_marks_node
 */ const $ad4cc1abe1dded2c$var$createBodiedExtensionNodeSpec = ()=>{
    const nodeSpec = {
        inline: false,
        group: 'block',
        marks: 'dataConsumer fragment',
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | extension | unsupportedBlock | embedCard)+',
        defining: true,
        selectable: true,
        isolating: true,
        attrs: {
            extensionType: {
                default: ''
            },
            extensionKey: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        parseDOM: [
            {
                context: 'bodiedExtension//',
                tag: '[data-node-type="bodied-extension"]',
                skip: true
            },
            {
                tag: '[data-node-type="bodied-extension"]',
                getAttrs: (domNode)=>(0, $eUEbq.getExtensionAttrs)(domNode)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    };
    return nodeSpec;
};
const $ad4cc1abe1dded2c$export$27903d543b563e39 = $ad4cc1abe1dded2c$var$createBodiedExtensionNodeSpec();

});

parcelRegister("568Ob", function(module, exports) {

$parcel$export(module.exports, "bulletListSelector", () => $3b645877cad760fc$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $3b645877cad760fc$export$a140c94e5ea26bee);
const $3b645877cad760fc$export$5f25a39efab3b58b = '.ak-ul';
const $3b645877cad760fc$export$a140c94e5ea26bee = {
    group: 'block',
    content: 'listItem+',
    selectable: false,
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    marks: 'unsupportedMark unsupportedNodeAttribute',
    toDOM () {
        const attrs = {
            class: $3b645877cad760fc$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
};

});

parcelRegister("d99SJ", function(module, exports) {

$parcel$export(module.exports, "caption", () => $9923c7ec34bc61e9$export$8e3c2dfdc4f0453d);
/**
 * @name caption_node
 */ const $9923c7ec34bc61e9$export$8e3c2dfdc4f0453d = {
    content: '(text|hardBreak|mention|emoji|date|placeholder|inlineCard|status|unsupportedInline)*',
    isolating: true,
    marks: '_',
    selectable: false,
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
};

});

parcelRegister("hgVop", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $c930734c642b0af7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $c930734c642b0af7$export$54fd2c36b5cc6731);

var $7dkLM = parcelRequire("7dkLM");
/**
 * @name codeBlock_node
 */ /**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_with_marks_node
 */ const $c930734c642b0af7$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $c930734c642b0af7$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $c930734c642b0af7$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $c930734c642b0af7$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $c930734c642b0af7$var$extractLanguageFromClass = (className)=>{
    const languageRegex = /(?:^|\s)language-([^\s]+)/;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $c930734c642b0af7$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
const $c930734c642b0af7$export$7bb0d5c671655cc4 = {
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    code: true,
    defining: true,
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $c930734c642b0af7$var$getLanguageFromBitbucketStyle(dom.parentElement) || $c930734c642b0af7$var$getLanguageFromEditorStyle(dom.parentElement) || $c930734c642b0af7$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $c930734c642b0af7$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            // @see ED-5682
            getContent: (domNode, schema)=>{
                const dom = domNode;
                const code = Array.from(dom.children).map((child)=>child.textContent).filter((x)=>x !== undefined).join('\n');
                return code ? (0, $7dkLM.Fragment).from(schema.text(code)) : (0, $7dkLM.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
};
const $c930734c642b0af7$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });

});

parcelRegister("eTtDn", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", () => $ad7d306f65d843cf$export$daf889beb5092f95);
const $ad7d306f65d843cf$var$name = 'confluenceJiraIssue';
const $ad7d306f65d843cf$export$daf889beb5092f95 = {
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: `span[data-node-type="${$ad7d306f65d843cf$var$name}"]`,
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $ad7d306f65d843cf$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
};

});

parcelRegister("1Ud4U", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $16352a752ab9df2e$export$e6e4878f43c27cab);
const $16352a752ab9df2e$var$name = 'confluenceUnsupportedBlock';
const $16352a752ab9df2e$export$e6e4878f43c27cab = {
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    },
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $16352a752ab9df2e$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$16352a752ab9df2e$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
};

});

parcelRegister("56qNL", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", () => $3b724d8f09621cf0$export$3e6d667072febc87);
const $3b724d8f09621cf0$var$name = 'confluenceUnsupportedInline';
const $3b724d8f09621cf0$export$3e6d667072febc87 = {
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    },
    toDOM (node) {
        const attrs = {
            'data-node-type': $3b724d8f09621cf0$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$3b724d8f09621cf0$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
};

});

parcelRegister("8CDqw", function(module, exports) {

$parcel$export(module.exports, "date", () => $647074b218f86851$export$324d90190a8b822a);
/**
 * @name date_node
 */ const $647074b218f86851$export$324d90190a8b822a = {
    inline: true,
    group: 'inline',
    selectable: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
};

});

parcelRegister("47B7q", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $30049be2ce3504a7$export$6959e16eeff859b4);

var $lUXsh = parcelRequire("lUXsh");
const $30049be2ce3504a7$export$6959e16eeff859b4 = {
    content: 'inline*',
    defining: true,
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $lUXsh.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
};

});

parcelRegister("dPUL6", function(module, exports) {

$parcel$export(module.exports, "decisionListSelector", () => $a12c10e7c25a057a$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $a12c10e7c25a057a$export$62d45a65fb43d95e);

var $lUXsh = parcelRequire("lUXsh");
/**
 * @name decisionList_node
 */ const $a12c10e7c25a057a$var$name = 'decisionList';
const $a12c10e7c25a057a$export$a5393ce68c2ff601 = `[data-node-type="${$a12c10e7c25a057a$var$name}"]`;
const $a12c10e7c25a057a$export$62d45a65fb43d95e = {
    group: 'block',
    defining: true,
    content: '(decisionItem|unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    attrs: {
        localId: {
            default: ''
        }
    },
    parseDOM: [
        {
            tag: `ol${$a12c10e7c25a057a$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $lUXsh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $a12c10e7c25a057a$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
};

});

parcelRegister("1HZv5", function(module, exports) {

$parcel$export(module.exports, "doc", () => $13e9834b2c1b91e1$export$2a111da947c407d2);
/**
 * @name doc_node
 */ const $13e9834b2c1b91e1$export$2a111da947c407d2 = {
    content: '(block|layoutSection|blockRootOnly)+',
    marks: 'alignment breakout dataConsumer fragment indentation unsupportedMark unsupportedNodeAttribute'
};

});

parcelRegister("7XTsD", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $5cc9107583ccf967$export$be4283d9a1cb1ff6);
/**
 * @name embedCard_node
 */ const $5cc9107583ccf967$export$be4283d9a1cb1ff6 = {
    inline: false,
    group: 'block',
    selectable: true,
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalWidth: {
            default: null
        },
        originalHeight: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
};

});

parcelRegister("5JhXr", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $42bf15c2cb81cca3$export$a19185d1233fc4b2);

var $7RIfh = parcelRequire("7RIfh");
const $42bf15c2cb81cca3$export$a19185d1233fc4b2 = {
    inline: true,
    group: 'inline',
    selectable: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>(0, $7RIfh.acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>(0, $7RIfh.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
};

});
parcelRegister("7RIfh", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", () => $5b9fcdd9b42caf92$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $5b9fcdd9b42caf92$export$441f8b58f5790a68);
$parcel$export(module.exports, "getEmojiAcName", () => $5b9fcdd9b42caf92$export$880a2465992fbbe);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $5b9fcdd9b42caf92$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $5b9fcdd9b42caf92$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $5b9fcdd9b42caf92$export$f61e93bda2a8b420(acName) {
    const emojiData = $5b9fcdd9b42caf92$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $5b9fcdd9b42caf92$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$5b9fcdd9b42caf92$var$acNameToEmojiMap[acName] ? $5b9fcdd9b42caf92$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($5b9fcdd9b42caf92$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $5b9fcdd9b42caf92$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$5b9fcdd9b42caf92$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $5b9fcdd9b42caf92$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $5b9fcdd9b42caf92$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $5b9fcdd9b42caf92$var$getAcNameFromShortName(shortName);
        if (possibleName in $5b9fcdd9b42caf92$var$acNameToEmojiMap) return possibleName;
    }
    return $5b9fcdd9b42caf92$export$bc94e44ec0e7bd82(id) || $5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("lKuoe", function(module, exports) {

$parcel$export(module.exports, "expand", () => $fd5577a23a87630d$export$9f77e0932fb78f72);
$parcel$export(module.exports, "toJSON", () => $fd5577a23a87630d$export$54fd2c36b5cc6731);
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_with_breakout_mark_node
 */ function $fd5577a23a87630d$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $fd5577a23a87630d$export$9f77e0932fb78f72 = {
    inline: false,
    group: 'block',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    isolating: true,
    selectable: true,
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $fd5577a23a87630d$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            skip: true
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            skip: true
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $fd5577a23a87630d$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $fd5577a23a87630d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("dj4Ew", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", () => $9b00a8a2bcf49bd5$export$63cadbf5f4296627);
$parcel$export(module.exports, "extendedNestedExpand", () => $9b00a8a2bcf49bd5$export$c5c48db08bdf69bd);
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ const $9b00a8a2bcf49bd5$var$createNestedExpandSpec = (isExtended)=>{
    const nestedExpandSpec = {
        inline: false,
        marks: 'unsupportedMark unsupportedNodeAttribute',
        isolating: true,
        selectable: true,
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        parseDOM: [
            {
                context: 'nestedExpand//',
                tag: '[data-node-type="nestedExpand"]',
                skip: true
            },
            {
                tag: '[data-node-type="nestedExpand"] button',
                ignore: true
            },
            {
                tag: '[data-node-type="expand"] button',
                ignore: true
            },
            {
                tag: 'div[data-node-type="nestedExpand"]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        title: dom.getAttribute('data-title'),
                        __expanded: true
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'nestedExpand',
                'data-title': node.attrs.title,
                'data-expanded': node.attrs.__expanded
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    };
    if (isExtended) nestedExpandSpec.content = '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+';
    else nestedExpandSpec.content = '(paragraph | heading | mediaSingle | mediaGroup | unsupportedBlock)+';
    return nestedExpandSpec;
};
const $9b00a8a2bcf49bd5$export$63cadbf5f4296627 = $9b00a8a2bcf49bd5$var$createNestedExpandSpec(false);
const $9b00a8a2bcf49bd5$export$c5c48db08bdf69bd = $9b00a8a2bcf49bd5$var$createNestedExpandSpec(true);

});

parcelRegister("izui5", function(module, exports) {

$parcel$export(module.exports, "PanelType", () => $d852fdfb5507437d$export$969277cf61e5a7aa);
$parcel$export(module.exports, "panel", () => $d852fdfb5507437d$export$21f42ab9b6679f44);
$parcel$export(module.exports, "extendedPanel", () => $d852fdfb5507437d$export$ce20b13564211141);
let $d852fdfb5507437d$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ const $d852fdfb5507437d$var$getDefaultAttrs = ()=>{
    const attrs = {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    };
    return attrs;
};
const $d852fdfb5507437d$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor
    };
    return attrs;
};
const $d852fdfb5507437d$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
    let parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $d852fdfb5507437d$export$969277cf61e5a7aa.CUSTOM ? $d852fdfb5507437d$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $d852fdfb5507437d$export$21f42ab9b6679f44 = (allowCustomPanel)=>{
    const panelNodeSpec = {
        group: 'block',
        content: '(paragraph | heading | bulletList | orderedList | blockCard | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        attrs: $d852fdfb5507437d$var$getDefaultAttrs(),
        selectable: true,
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$d852fdfb5507437d$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $d852fdfb5507437d$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    };
    return panelNodeSpec;
};
const $d852fdfb5507437d$export$ce20b13564211141 = (allowCustomPanel)=>{
    const panelNodeSpec = {
        group: 'block',
        content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        attrs: $d852fdfb5507437d$var$getDefaultAttrs(),
        selectable: true,
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$d852fdfb5507437d$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $d852fdfb5507437d$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    };
    return panelNodeSpec;
};

});

parcelRegister("7y7sZ", function(module, exports) {

$parcel$export(module.exports, "extension", () => $57f1801b48030dd3$export$1b45514b112dd749);

var $eUEbq = parcelRequire("eUEbq");
/**
 * @name extension_node
 */ /**
 * @name extension_with_marks_node
 */ const $57f1801b48030dd3$var$createExtensionNodeSpec = ()=>{
    const nodeSpec = {
        inline: false,
        group: 'block',
        atom: true,
        selectable: true,
        attrs: {
            extensionType: {
                default: ''
            },
            extensionKey: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        parseDOM: [
            {
                tag: '[data-node-type="extension"]',
                getAttrs: (domNode)=>(0, $eUEbq.getExtensionAttrs)(domNode)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId
            };
            return [
                'div',
                attrs
            ];
        }
    };
    return nodeSpec;
};
const $57f1801b48030dd3$export$1b45514b112dd749 = $57f1801b48030dd3$var$createExtensionNodeSpec();

});

parcelRegister("7SlQD", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $5bbe86148e97ac9f$export$371da9dd35aba193);
/**
 * @name hardBreak_node
 */ const $5bbe86148e97ac9f$export$371da9dd35aba193 = {
    inline: true,
    group: 'inline',
    selectable: false,
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
};

});

parcelRegister("iWGOh", function(module, exports) {

$parcel$export(module.exports, "heading", () => $dcaed9f1743d53de$export$46e4a324ac90507f);
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ const $dcaed9f1743d53de$var$getAttrs = (level, domNode)=>({
        level: level,
        localId: domNode.getAttribute('data-local-id') || $dcaed9f1743d53de$export$46e4a324ac90507f.attrs.localId.default
    });
const $dcaed9f1743d53de$export$46e4a324ac90507f = {
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    content: `inline*`,
    group: 'block',
    defining: true,
    selectable: false,
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: (domNode)=>$dcaed9f1743d53de$var$getAttrs(1, domNode)
        },
        {
            tag: 'h2',
            getAttrs: (domNode)=>$dcaed9f1743d53de$var$getAttrs(2, domNode)
        },
        {
            tag: 'h3',
            getAttrs: (domNode)=>$dcaed9f1743d53de$var$getAttrs(3, domNode)
        },
        {
            tag: 'h4',
            getAttrs: (domNode)=>$dcaed9f1743d53de$var$getAttrs(4, domNode)
        },
        {
            tag: 'h5',
            getAttrs: (domNode)=>$dcaed9f1743d53de$var$getAttrs(5, domNode)
        },
        {
            tag: 'h6',
            getAttrs: (domNode)=>$dcaed9f1743d53de$var$getAttrs(6, domNode)
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = localId !== undefined ? {
            'data-local-id': localId
        } : undefined;
        return [
            'h' + node.attrs['level'],
            attrs,
            0
        ];
    }
};

});

parcelRegister("iOeir", function(module, exports) {

$parcel$export(module.exports, "image", () => $db17fc75bafe5b63$export$5c452ff88e35e47d);
const $db17fc75bafe5b63$export$5c452ff88e35e47d = {
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true,
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
};

});

parcelRegister("8mC62", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $616dedf2d343125f$export$cbf8224b64e0d942);
/**
 * @name inlineCard_node
 */ const $616dedf2d343125f$export$cbf8224b64e0d942 = {
    inline: true,
    group: 'inline',
    selectable: true,
    draggable: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
};

});

parcelRegister("7xvQK", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", () => $57d4522b818e953c$export$16b353b2649bd8d9);

var $eUEbq = parcelRequire("eUEbq");
/**
 * @name inlineExtension_node
 */ /**
 * @name inlineExtension_with_marks_node
 */ const $57d4522b818e953c$var$createInlineExtensionNodeSpec = ()=>{
    const nodeSpec = {
        inline: true,
        group: 'inline',
        selectable: true,
        attrs: {
            extensionType: {
                default: ''
            },
            extensionKey: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            localId: {
                default: null
            }
        },
        parseDOM: [
            {
                tag: 'span[data-extension-type]',
                getAttrs: (domNode)=>(0, $eUEbq.getExtensionAttrs)(domNode, true)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-local-id:': node.attrs.localId,
                contenteditable: 'false'
            };
            return [
                'span',
                attrs
            ];
        }
    };
    return nodeSpec;
};
const $57d4522b818e953c$export$16b353b2649bd8d9 = $57d4522b818e953c$var$createInlineExtensionNodeSpec();

});

parcelRegister("1O3jv", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", () => $150d07f918689e82$export$ab76e7c03cd6f650);
/**
 * @name layoutColumn_node
 */ const $150d07f918689e82$export$ab76e7c03cd6f650 = {
    content: '(block|unsupportedBlock)+',
    isolating: true,
    marks: 'alignment indentation dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    attrs: {
        width: {
            default: undefined
        }
    },
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = width;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
};

});

parcelRegister("3eVto", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $25bf42da33411467$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithTask", () => $25bf42da33411467$export$58dca2f0678302a4);
const $25bf42da33411467$export$76c7e83ecc9cdf05 = {
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    defining: true,
    selectable: false,
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
};
const $25bf42da33411467$export$58dca2f0678302a4 = {
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    defining: true,
    selectable: false,
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
};

});

parcelRegister("gN3fl", function(module, exports) {

$parcel$export(module.exports, "defaultAttrs", () => $c393bda0a4dc410d$export$bb3fe706be61f640);
$parcel$export(module.exports, "createMediaSpec", () => $c393bda0a4dc410d$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "copyPrivateAttributes", () => $c393bda0a4dc410d$export$111130fa8968d741);
$parcel$export(module.exports, "media", () => $c393bda0a4dc410d$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $c393bda0a4dc410d$export$54fd2c36b5cc6731);

var $jR93G = parcelRequire("jR93G");
const $c393bda0a4dc410d$export$bb3fe706be61f640 = {
    id: {
        default: ''
    },
    type: {
        default: 'file'
    },
    collection: {
        default: ''
    },
    occurrenceKey: {
        default: null
    },
    alt: {
        default: ''
    },
    width: {
        default: null
    },
    height: {
        default: null
    },
    url: {
        default: null
    },
    __fileName: {
        default: null
    },
    __fileSize: {
        default: null
    },
    __fileMimeType: {
        default: null
    },
    __displayType: {
        default: null
    },
    __contextId: {
        default: null
    },
    __mediaTraceId: {
        default: null
    },
    __external: {
        default: false
    }
};
const $c393bda0a4dc410d$export$35bdbf5bc8caa677 = (attributes, inline = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    const key = $c393bda0a4dc410d$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    // media-inline.ts uses this same function to generate the nodespec
    // this ensures that we don't make a media inline out of a copied image
    // https://product-fabric.atlassian.net/browse/EDM-2996
    if (!inline) parseDOM.push({
        tag: 'img:not(.smart-link-icon)',
        getAttrs: (dom)=>{
            return {
                type: 'external',
                url: dom.getAttribute('src') || '',
                alt: dom.getAttribute('alt') || ''
            };
        }
    });
    return {
        selectable: true,
        inline: inline,
        group: inline ? 'inline' : undefined,
        attrs: attributes,
        parseDOM: parseDOM,
        toDOM (node) {
            const attrs = {
                'data-id': node.attrs.id,
                'data-node-type': `${nodeName}`,
                'data-type': node.attrs.type,
                'data-collection': node.attrs.collection,
                'data-occurrence-key': node.attrs.occurrenceKey,
                'data-width': node.attrs.width,
                'data-height': node.attrs.height,
                'data-url': node.attrs.url,
                'data-alt': node.attrs.alt,
                // toDOM is used for static rendering as well as editor rendering. This comes into play for
                // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
                // node view being used for editing).
                title: 'Attachment',
                // Manually kept in sync with the style of media cards. The goal is to render a plain gray
                // rectangle that provides an affordance for media.
                style: `display: inline-block; border-radius: 3px; background: ${(0, $jR93G.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
            };
            $c393bda0a4dc410d$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$c393bda0a4dc410d$export$f84fdfb973c05bd8(key.slice(2))}`);
            return [
                `${domNodeType}`,
                attrs
            ];
        }
    };
};
const $c393bda0a4dc410d$export$987d49ffe1b0900f = $c393bda0a4dc410d$export$35bdbf5bc8caa677($c393bda0a4dc410d$export$bb3fe706be61f640);
const $c393bda0a4dc410d$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $c393bda0a4dc410d$export$111130fa8968d741 = (from, to, map)=>{
    if ($c393bda0a4dc410d$export$987d49ffe1b0900f.attrs) Object.keys($c393bda0a4dc410d$export$987d49ffe1b0900f.attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $c393bda0a4dc410d$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt'
];
const $c393bda0a4dc410d$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt'
];
const $c393bda0a4dc410d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $c393bda0a4dc410d$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($c393bda0a4dc410d$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("1KDvn", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $1468bb36b31049a8$export$2855e964765eac9);
/**
 * @name mediaGroup_node
 */ // Temporary due to an existing issue in validator below:
// https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-1429
// TODO: Remove border and link marks from white list
const $1468bb36b31049a8$export$2855e964765eac9 = {
    inline: false,
    group: 'block',
    content: '(media|unsupportedBlock)+',
    attrs: {},
    marks: 'unsupportedMark unsupportedNodeAttribute annotation border link',
    selectable: false,
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
};

});

parcelRegister("hXvCf", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $d130789d4554ffe4$export$38bab695e3f720f1);

var $gN3fl = parcelRequire("gN3fl");
const $d130789d4554ffe4$export$38bab695e3f720f1 = (0, $gN3fl.createMediaSpec)((0, $gN3fl.defaultAttrs), true);

});

parcelRegister("cvCFq", function(module, exports) {

$parcel$export(module.exports, "mediaSingleSpec", () => $91b65fc731134d1d$export$5a1e124099b60c6b);
$parcel$export(module.exports, "mediaSingle", () => $91b65fc731134d1d$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $91b65fc731134d1d$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $91b65fc731134d1d$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $91b65fc731134d1d$export$7e767666f2ce108a);
$parcel$export(module.exports, "toJSON", () => $91b65fc731134d1d$export$54fd2c36b5cc6731);

var $H6cl0 = parcelRequire("H6cl0");

var $1pjCh = parcelRequire("1pjCh");
const $91b65fc731134d1d$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $91b65fc731134d1d$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false })=>{
    const content = withCaption ? 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*' : 'media|unsupportedBlock+|media unsupportedBlock+';
    const atom = !withCaption;
    const getAttrs = (dom)=>{
        if (!(0, $1pjCh.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $H6cl0.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $H6cl0.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    return {
        inline: false,
        group: 'block',
        selectable: true,
        atom: atom,
        content: content,
        attrs: withExtendedWidthTypes ? {
            ...$91b65fc731134d1d$export$bb3fe706be61f640,
            widthType: {
                default: null
            }
        } : $91b65fc731134d1d$export$bb3fe706be61f640,
        marks: 'unsupportedMark unsupportedNodeAttribute annotation border link',
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    };
};
const $91b65fc731134d1d$export$969fe3781ca15058 = $91b65fc731134d1d$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $91b65fc731134d1d$export$d35e6c006d4abdfb = $91b65fc731134d1d$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $91b65fc731134d1d$export$9c58e19811ce4cf5 = $91b65fc731134d1d$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $91b65fc731134d1d$export$7e767666f2ce108a = $91b65fc731134d1d$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $91b65fc731134d1d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("H6cl0", function(module, exports) {

$parcel$export(module.exports, "WidthType", () => $0818d30f6134b029$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ let $0818d30f6134b029$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("fkqTY", function(module, exports) {

$parcel$export(module.exports, "mention", () => $b28d976c62a93439$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $b28d976c62a93439$export$54fd2c36b5cc6731);
let $b28d976c62a93439$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $b28d976c62a93439$export$db83999c14438df4 = {
    inline: true,
    group: 'inline',
    selectable: true,
    attrs: {
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        },
        localId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-mention-id') || $b28d976c62a93439$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $b28d976c62a93439$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $b28d976c62a93439$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: dom.getAttribute('data-local-id') || $b28d976c62a93439$export$db83999c14438df4.attrs.localId.default
                };
                const userType = dom.getAttribute('data-user-type');
                if ($b28d976c62a93439$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
};
const $b28d976c62a93439$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $b28d976c62a93439$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($b28d976c62a93439$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("8lnnz", function(module, exports) {

$parcel$export(module.exports, "orderedListSelector", () => $61326b7f5996ad33$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $61326b7f5996ad33$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithOrder", () => $61326b7f5996ad33$export$b9ab759e8298198f);
const $61326b7f5996ad33$export$4e7125c7ff595be5 = '.ak-ol';
const $61326b7f5996ad33$export$a5dc81035676e7a = {
    group: 'block',
    attrs: {
        order: {
            default: 1
        }
    },
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $61326b7f5996ad33$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
};
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
const $61326b7f5996ad33$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $61326b7f5996ad33$export$b9ab759e8298198f = {
    ...$61326b7f5996ad33$export$a5dc81035676e7a,
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $61326b7f5996ad33$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const start = $61326b7f5996ad33$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $61326b7f5996ad33$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
};

});

parcelRegister("5bGpU", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $3c6ee1ed25404369$export$9c206ddddb32a9b);
/**
 * @name paragraph_node
 */ /**
 * @name paragraph_with_no_marks_node
 */ /**
 * NOTE: Need this because TS is too smart and inline everything.
 * So we need to give them separate identity.
 * Probably there's a way to solve it but that will need time and exploration.
 * // http://bit.ly/2raXFX5
 * type T1 = X | Y
 * type T2 = A | T1 | B // T2 = A | X | Y | B
 */ /**
 * @name paragraph_with_alignment_node
 */ /**
 * @name paragraph_with_indentation_node
 */ const $3c6ee1ed25404369$export$9c206ddddb32a9b = {
    selectable: false,
    content: 'inline*',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    marks: 'strong code em link border strike subsup textColor backgroundColor typeAheadQuery underline confluenceInlineComment action annotation unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || $3c6ee1ed25404369$export$9c206ddddb32a9b.attrs.localId.default
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = localId !== undefined ? {
            'data-local-id': localId
        } : undefined;
        return [
            'p',
            attrs,
            0
        ];
    }
};

});

parcelRegister("dDs5p", function(module, exports) {

$parcel$export(module.exports, "placeholder", () => $028fd15bd9efda92$export$c7187bbd1a7a9244);
/**
 * @name placeholder_node
 */ const $028fd15bd9efda92$export$c7187bbd1a7a9244 = {
    inline: true,
    group: 'inline',
    selectable: false,
    marks: '',
    attrs: {
        text: {
            default: ''
        }
    },
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $028fd15bd9efda92$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
};

});

parcelRegister("7wZ4m", function(module, exports) {

$parcel$export(module.exports, "rule", () => $57bae4a7ab6a77ec$export$fbeb3a3956e8a3c7);
/**
 * @name rule_node
 */ const $57bae4a7ab6a77ec$var$hrDOM = [
    'hr'
];
const $57bae4a7ab6a77ec$export$fbeb3a3956e8a3c7 = {
    group: 'block',
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $57bae4a7ab6a77ec$var$hrDOM;
    }
};

});

parcelRegister("cvo5z", function(module, exports) {

$parcel$export(module.exports, "status", () => $91ab10d6717106ff$export$471f7ae5c4103ae1);

var $lUXsh = parcelRequire("lUXsh");
const $91ab10d6717106ff$export$471f7ae5c4103ae1 = {
    inline: true,
    group: 'inline',
    selectable: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: (0, $lUXsh.uuid).generate()
        },
        style: {
            default: ''
        }
    },
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $lUXsh.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
};

});

parcelRegister("ie5d6", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $d44d9373b8f163aa$export$6d8b0ef52e2e6390);

var $lUXsh = parcelRequire("lUXsh");
const $d44d9373b8f163aa$export$6d8b0ef52e2e6390 = {
    content: 'inline*',
    defining: true,
    selectable: false,
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $lUXsh.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};

});

parcelRegister("7QozA", function(module, exports) {

$parcel$export(module.exports, "taskListSelector", () => $5b607363bfbaed7e$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $5b607363bfbaed7e$export$375b6afcc5f4d291);

var $lUXsh = parcelRequire("lUXsh");
/**
 * @name taskList_node
 */ const $5b607363bfbaed7e$var$name = 'actionList';
const $5b607363bfbaed7e$export$c0ec71adb7a18fb2 = `[data-node-type="${$5b607363bfbaed7e$var$name}"]`;
const $5b607363bfbaed7e$export$375b6afcc5f4d291 = {
    group: 'block',
    defining: true,
    selectable: false,
    content: '(taskItem|unsupportedBlock)+ (taskItem|taskList|unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: ''
        }
    },
    parseDOM: [
        {
            tag: `div${$5b607363bfbaed7e$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $lUXsh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $5b607363bfbaed7e$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};

});

parcelRegister("ltJuR", function(module, exports) {

$parcel$export(module.exports, "text", () => $fa2f9921fdf8b722$export$6f093cfa640b7166);
/**
 * @name text_node
 */ const $fa2f9921fdf8b722$export$6f093cfa640b7166 = {
    group: 'inline',
    toDebugString: ()=>'text_node'
};

});

parcelRegister("4ne8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f4472c0028f4d7$export$2e2bcd8739ae039);
const $32f4472c0028f4d7$var$name = 'unknownBlock';
var $32f4472c0028f4d7$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $32f4472c0028f4d7$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$32f4472c0028f4d7$var$name}"]`
        }
    ]
};

});

parcelRegister("7p32Z", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", () => $563d3b506527dd26$export$44b79b0979d0f0f7);
const $563d3b506527dd26$export$44b79b0979d0f0f7 = {
    inline: false,
    group: 'block',
    atom: true,
    selectable: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
};

});

parcelRegister("8cuPa", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", () => $5f875acca3371d13$export$310ebe0d80122e9b);
const $5f875acca3371d13$export$310ebe0d80122e9b = {
    inline: true,
    group: 'inline',
    selectable: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
};

});



parcelRegister("avvqL", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a652e1b9ff1fe6c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $7a652e1b9ff1fe6c$var$isUndefined(x) {
    return x === undefined;
}
class $7a652e1b9ff1fe6c$export$2e2bcd8739ae039 {
    constructor(){
        (0, $5zQU9.default)(this, "providers", new Map());
        (0, $5zQU9.default)(this, "subscribers", new Map());
    }
    static create(providers) {
        const providerFactory = new $7a652e1b9ff1fe6c$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$7a652e1b9ff1fe6c$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
}

});

parcelRegister("2hniO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a8f3eabe1e0fdbc$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $9wcjJ = parcelRequire("9wcjJ");

var $8HLio = parcelRequire("8HLio");

var $avvqL = parcelRequire("avvqL");
var $jWgZK = parcelRequire("jWgZK");

var $eNUIj = parcelRequire("eNUIj");
var $1FQ7Z = parcelRequire("1FQ7Z");
var $hlBr5 = parcelRequire("hlBr5");
var $4IyMA = parcelRequire("4IyMA");
var $jxPV4 = parcelRequire("jxPV4");

var $ckjIr = parcelRequire("ckjIr");
var $d0kCm = parcelRequire("d0kCm");
var $kvS2F = parcelRequire("kvS2F");
var $4U0vH = parcelRequire("4U0vH");
var $jYFEM = parcelRequire("jYFEM");
var $7PAGx = parcelRequire("7PAGx");
var $fFkxb = parcelRequire("fFkxb");

var $XHGTv = parcelRequire("XHGTv");

var $llfM0 = parcelRequire("llfM0");

var $25FYC = parcelRequire("25FYC");

var $6PJBT = parcelRequire("6PJBT");

var $dcbVh = parcelRequire("dcbVh");

var $dFBS3 = parcelRequire("dFBS3");

var $7tDYk = parcelRequire("7tDYk");
var $8rYsT = parcelRequire("8rYsT");

var $15sgt = parcelRequire("15sgt");

var $9zF93 = parcelRequire("9zF93");

var $61wF1 = parcelRequire("61wF1");

var $1lWyd = parcelRequire("1lWyd");

var $bjJ4l = parcelRequire("bjJ4l");

var $fFNtM = parcelRequire("fFNtM");

var $9HS7I = parcelRequire("9HS7I");

var $a896o = parcelRequire("a896o");

var $hRqg3 = parcelRequire("hRqg3");

var $ifL1l = parcelRequire("ifL1l");

var $eZEEl = parcelRequire("eZEEl");

var $erA3g = parcelRequire("erA3g");

var $dTcEN = parcelRequire("dTcEN");

var $6rEO7 = parcelRequire("6rEO7");

var $5iWql = parcelRequire("5iWql");

var $4j1xD = parcelRequire("4j1xD");

var $c48h5 = parcelRequire("c48h5");

var $cQY1N = parcelRequire("cQY1N");
const $1a8f3eabe1e0fdbc$export$47b2879ca9bbf67a = 2000;
const $1a8f3eabe1e0fdbc$export$1b622068be977101 = 3000;
const $1a8f3eabe1e0fdbc$var$packageName = "@atlaskit/renderer";
const $1a8f3eabe1e0fdbc$var$packageVersion = "109.17.1";
class $1a8f3eabe1e0fdbc$export$88530751e3977073 extends (0, $eUqFw.PureComponent) {
    constructor(props){
        super(props);
        /**
     * This is used in measuring the Renderer Mount time and is then
     * deleted once that measurement occurs.
     */ (0, $5zQU9.default)(this, "renderedMeasurementDistortedDurationMonitor", (0, $kvS2F.getDistortedDurationMonitor)());
        (0, $5zQU9.default)(this, "featureFlags", (0, $5iWql.default)((featureFlags)=>{
            const normalizedFeatureFlags = (0, $llfM0.normalizeFeatureFlags)(featureFlags, {
                objectFlagKeys: [
                    'rendererRenderTracking'
                ]
            });
            return {
                featureFlags: normalizedFeatureFlags
            };
        }));
        (0, $5zQU9.default)(this, "fireAnalyticsEvent", (event)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) {
                const channel = (0, $6PJBT.FabricChannel).editor;
                createAnalyticsEvent(event).fire(channel);
            }
        });
        (0, $5zQU9.default)(this, "getSchema", (0, $5iWql.default)((schema, adfStage)=>{
            if (schema) return schema;
            return (0, $9wcjJ.getSchemaBasedOnStage)(adfStage);
        }));
        (0, $5zQU9.default)(this, "onMouseDownEditView", ()=>{
            // When the user is deselecting text on the screen by clicking, if they are clicking outside
            // the current selection, by the time the onclick handler is called the window.getSelection()
            // value will already be cleared.
            // The mousedown callback is called before the selection is cleared.
            const windowSelection = window.getSelection();
            this.mouseDownSelection = windowSelection !== null ? windowSelection.toString() : undefined;
        });
        (0, $5zQU9.default)(this, "handleMouseTripleClickInTables", (event)=>{
            var _parentElement, _parentElement2;
            if ((0, $ckjIr.default).ios || (0, $ckjIr.default).android) return;
            const badBrowser = (0, $ckjIr.default).chrome || (0, $ckjIr.default).safari;
            const tripleClick = event.detail >= 3;
            if (!(badBrowser && tripleClick)) return;
            const selection = window.getSelection();
            if (!selection) return;
            const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
            const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
            if (!rangeSelection) return;
            const target = event.target;
            const tableCell = target.closest('td,th');
            const clickedInCell = Boolean(tableCell);
            if (!clickedInCell) return;
            const anchorInCell = tableCell.contains(anchorNode);
            const focusInCell = tableCell.contains(focusNode);
            const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
            if (!selectionStartsOrEndsOutsideClickedCell) return;
            // If selection starts or ends in a different cell than the clicked cell,
            // we select the node inside the clicked cell (or if both are in a different
            // cell, we select the cell's contents instead). We want to select the nearest
            // parent block, so that a whole line of text/content is selected (rather than
            // selecting a span that would select one specific chunk of text).
            const elementToSelect = anchorInCell ? (_parentElement = anchorNode.parentElement) === null || _parentElement === void 0 ? void 0 : _parentElement.closest('div,p') : focusInCell ? (_parentElement2 = focusNode.parentElement) === null || _parentElement2 === void 0 ? void 0 : _parentElement2.closest('div,p') : tableCell;
            if (elementToSelect) selection.selectAllChildren(elementToSelect);
        });
        this.providerFactory = props.dataProviders || new (0, $avvqL.default)();
        this.serializer = new (0, $7tDYk.default)(this.deriveSerializerProps(props));
        this.editorRef = props.innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.id = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        (0, $fFkxb.startMeasure)(`Renderer Render Time: ${this.id}`);
        const _featureFlags = this.featureFlags(this.props.featureFlags).featureFlags;
        if (_featureFlags !== null && _featureFlags !== void 0 && _featureFlags.rendererTtiTracking) (0, $jYFEM.measureTTI)((tti, ttiFromInvocation, canceled)=>{
            this.fireAnalyticsEvent({
                action: (0, $61wF1.ACTION).RENDERER_TTI,
                actionSubject: (0, $61wF1.ACTION_SUBJECT).RENDERER,
                attributes: {
                    tti: tti,
                    ttiFromInvocation: ttiFromInvocation,
                    canceled: canceled
                },
                eventType: (0, $61wF1.EVENT_TYPE).OPERATIONAL
            });
        });
    }
    anchorLinkAnalytics() {
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const { disableHeadingIDs: disableHeadingIDs } = this.props;
        if (!disableHeadingIDs && hash && this.editorRef && this.editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            // We are not use this.editorRef.querySelector here, instead we have this.editorRef.contains
            // because querySelector might fail if there are special characters in hash, and CSS.escape is still experimental.
            if (anchorLinkElement && this.editorRef.current.contains(anchorLinkElement)) this.fireAnalyticsEvent({
                action: (0, $61wF1.ACTION).VIEWED,
                actionSubject: (0, $61wF1.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $1lWyd.PLATFORM).WEB,
                    mode: (0, $1lWyd.MODE).RENDERER
                },
                eventType: (0, $61wF1.EVENT_TYPE).UI
            });
        }
    }
    componentDidMount() {
        this.fireAnalyticsEvent({
            action: (0, $61wF1.ACTION).STARTED,
            actionSubject: (0, $61wF1.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $1lWyd.PLATFORM).WEB
            },
            eventType: (0, $61wF1.EVENT_TYPE).UI
        });
        this.rafID = requestAnimationFrame(()=>{
            (0, $fFkxb.stopMeasure)(`Renderer Render Time: ${this.id}`, (duration)=>{
                var _analyticsEventSeveri, _analyticsEventSeveri2, _this$props, _this$props$analytics;
                const { analyticsEventSeverityTracking: analyticsEventSeverityTracking } = this.props;
                const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $7PAGx.shouldForceTracking)();
                const severity = !!forceSeverityTracking || analyticsEventSeverityTracking !== null && analyticsEventSeverityTracking !== void 0 && analyticsEventSeverityTracking.enabled ? (0, $d0kCm.getAnalyticsEventSeverity)(duration, (_analyticsEventSeveri = analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.severityNormalThreshold) !== null && _analyticsEventSeveri !== void 0 ? _analyticsEventSeveri : $1a8f3eabe1e0fdbc$export$47b2879ca9bbf67a, (_analyticsEventSeveri2 = analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.severityDegradedThreshold) !== null && _analyticsEventSeveri2 !== void 0 ? _analyticsEventSeveri2 : $1a8f3eabe1e0fdbc$export$1b622068be977101) : undefined;
                // ED-16320: Check for explicit disable so that by default
                // it will still be enabled as it currently is. Then we can
                // progressively opt out synthetic tenants.
                const isTTRTrackingExplicitlyDisabled = ((_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$analytics = _this$props.analyticsEventSeverityTracking) === null || _this$props$analytics === void 0 ? void 0 : _this$props$analytics.enabled) === false;
                if (!isTTRTrackingExplicitlyDisabled) this.fireAnalyticsEvent({
                    action: (0, $61wF1.ACTION).RENDERED,
                    actionSubject: (0, $61wF1.ACTION_SUBJECT).RENDERER,
                    attributes: {
                        platform: (0, $1lWyd.PLATFORM).WEB,
                        duration: duration,
                        distortedDuration: this.renderedMeasurementDistortedDurationMonitor.distortedDuration,
                        ttfb: (0, $4U0vH.getResponseEndTime)(),
                        nodes: (0, $8HLio.reduce)(this.props.document, (acc, node)=>{
                            acc[node.type] = (acc[node.type] || 0) + 1;
                            return acc;
                        }, {}),
                        severity: severity
                    },
                    eventType: (0, $61wF1.EVENT_TYPE).OPERATIONAL
                });
                this.renderedMeasurementDistortedDurationMonitor.cleanup();
                delete this.renderedMeasurementDistortedDurationMonitor;
            });
            this.anchorLinkAnalytics();
        });
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const nextMedia = nextProps.media || {};
        const media = this.props.media || {};
        if (nextProps.portal !== this.props.portal || nextProps.appearance !== this.props.appearance || nextProps.stickyHeaders !== this.props.stickyHeaders || nextProps.disableActions !== this.props.disableActions || nextProps.allowCustomPanels !== this.props.allowCustomPanels || nextProps.extensionHandlers !== this.props.extensionHandlers || nextProps.allowHeadingAnchorLinks !== this.props.allowHeadingAnchorLinks || nextMedia.allowLinking !== media.allowLinking) this.serializer = new (0, $7tDYk.default)(this.deriveSerializerProps(nextProps));
    }
    deriveSerializerProps(props) {
        // if just passed a boolean, change shape into object to simplify type
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = this.featureFlags(props.featureFlags);
        return {
            providers: this.providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.document,
                schema: props.schema,
                ...props.rendererContext
            },
            appearance: props.appearance,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            // does not currently support SSR, should not be enabled in environments where Renderer is SSR-ed
            allowWindowedCodeBlock: featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.allowWindowedCodeBlock,
            isInsideOfInlineExtension: (0, $XHGTv.getBooleanFF)('platform.editor.inline_extension.extended_lcqdn') && props.isInsideOfInlineExtension,
            textHighlighter: props.UNSTABLE_textHighlighter
        };
    }
    render() {
        const { document: adfDocument, onComplete: onComplete, onError: onError, appearance: appearance, adfStage: adfStage, truncated: truncated, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, enableSsrInlineScripts: enableSsrInlineScripts, allowHeadingAnchorLinks: allowHeadingAnchorLinks, allowPlaceholderText: allowPlaceholderText, allowColumnSorting: allowColumnSorting, allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, allowCustomPanels: allowCustomPanels, media: media } = this.props;
        const featureFlags = this.featureFlags(this.props.featureFlags);
        const allowNestedHeaderLinks = (0, $eZEEl.isNestedHeaderLinksEnabled)(allowHeadingAnchorLinks);
        /**
     * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
     * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
     * renderer out for the editor).
     * @param event Click event anywhere inside renderer
     */ const handleWrapperOnClick = (event)=>{
            var _this$props$eventHand;
            const targetElement = event.target;
            // ED-14862: When a user triple clicks to select a line of content inside a
            // a table cell, but the browser incorrectly moves the selection start or end into
            // a different table cell, we manually set the selection back to within the original
            // table cell the user intended to target
            this.handleMouseTripleClickInTables(event);
            if (!((_this$props$eventHand = this.props.eventHandlers) !== null && _this$props$eventHand !== void 0 && _this$props$eventHand.onUnhandledClick)) return;
            if (!(targetElement instanceof window.Element)) return;
            const rendererWrapper = event.currentTarget;
            // Check if the click was on an interactive element
            const isInteractiveElementInTree = (0, $erA3g.findInTree)(targetElement, rendererWrapper, (0, $dTcEN.isInteractiveElement));
            if (isInteractiveElementInTree) return;
            // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
            // This logic originated in jira-frontend:
            // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
            // The selection is required to be checked in `onMouseDown` and here. If not here, a new
            // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
            // return an empty selection, which will erroneously fire onUnhandledClick.
            const windowSelection = window.getSelection();
            const selection = windowSelection !== null ? windowSelection.toString() : undefined;
            const hasSelection = selection && selection.length !== 0;
            const hasSelectionMouseDown = this.mouseDownSelection && this.mouseDownSelection.length !== 0;
            const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
            if (allowEditBasedOnSelection) this.props.eventHandlers.onUnhandledClick(event);
        };
        try {
            var _featureFlags$feature, _featureFlags$feature2, _featureFlags$feature3;
            const schema = this.getSchema(this.props.schema, this.props.adfStage);
            const { result: result, stat: stat, pmDoc: pmDoc } = (0, $8rYsT.renderDocument)(adfDocument, this.serializer, schema, adfStage, this.props.useSpecBasedValidator, this.id, this.fireAnalyticsEvent, this.props.unsupportedContentLevelsTracking, this.props.appearance);
            if (onComplete) onComplete(stat);
            const rendererOutput = (0, $byn9U.jsx)((0, $6rEO7.RendererContextProvider), {
                value: featureFlags
            }, (0, $byn9U.jsx)((0, $hRqg3.ActiveHeaderIdProvider), {
                value: (0, $eZEEl.getActiveHeadingId)(allowHeadingAnchorLinks)
            }, (0, $byn9U.jsx)((0, $bjJ4l.default).Provider, {
                value: {
                    fireAnalyticsEvent: (event)=>this.fireAnalyticsEvent(event)
                }
            }, (0, $byn9U.jsx)((0, $fFNtM.Provider), null, (0, $byn9U.jsx)((0, $jWgZK.ProviderFactoryProvider), {
                value: this.providerFactory
            }, (0, $byn9U.jsx)($1a8f3eabe1e0fdbc$var$RendererWrapper, {
                appearance: appearance,
                allowNestedHeaderLinks: allowNestedHeaderLinks,
                allowColumnSorting: allowColumnSorting,
                allowCopyToClipboard: allowCopyToClipboard,
                allowWrapCodeBlock: allowWrapCodeBlock,
                allowCustomPanels: allowCustomPanels,
                allowPlaceholderText: allowPlaceholderText,
                useBlockRenderForCodeBlock: (_featureFlags$feature = featureFlags.featureFlags.useBlockRenderForCodeBlock) !== null && _featureFlags$feature !== void 0 ? _featureFlags$feature : true,
                addTelepointer: this.props.addTelepointer,
                innerRef: this.editorRef,
                onClick: handleWrapperOnClick,
                onMouseDown: this.onMouseDownEditView,
                ssr: media === null || media === void 0 ? void 0 : media.ssr,
                isInsideOfInlineExtension: this.props.isInsideOfInlineExtension
            }, enableSsrInlineScripts ? (0, $byn9U.jsx)((0, $9HS7I.BreakoutSSRInlineScript), null) : null, (0, $byn9U.jsx)($1a8f3eabe1e0fdbc$var$RendererActionsInternalUpdater, {
                doc: pmDoc,
                schema: schema,
                onAnalyticsEvent: this.fireAnalyticsEvent
            }, result)))))));
            let rendererResult = truncated ? (0, $byn9U.jsx)((0, $9zF93.TruncatedWrapper), {
                height: maxHeight,
                fadeHeight: fadeOutHeight
            }, rendererOutput) : rendererOutput;
            const rendererRenderTracking = featureFlags === null || featureFlags === void 0 ? void 0 : (_featureFlags$feature2 = featureFlags.featureFlags) === null || _featureFlags$feature2 === void 0 ? void 0 : (_featureFlags$feature3 = _featureFlags$feature2.rendererRenderTracking) === null || _featureFlags$feature3 === void 0 ? void 0 : _featureFlags$feature3[(0, $61wF1.ACTION_SUBJECT).RENDERER];
            const reRenderTracking = (rendererRenderTracking === null || rendererRenderTracking === void 0 ? void 0 : rendererRenderTracking.enabled) && (0, $byn9U.jsx)((0, $c48h5.RenderTracking), {
                componentProps: this.props,
                action: (0, $61wF1.ACTION).RE_RENDERED,
                actionSubject: (0, $61wF1.ACTION_SUBJECT).RENDERER,
                handleAnalyticsEvent: this.fireAnalyticsEvent,
                useShallow: rendererRenderTracking.useShallow
            });
            return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, reRenderTracking, rendererResult);
        } catch (e) {
            var _featureFlags$feature4;
            if (onError) onError(e);
            return (0, $byn9U.jsx)($1a8f3eabe1e0fdbc$var$RendererWrapper, {
                appearance: appearance,
                allowCopyToClipboard: allowCopyToClipboard,
                allowWrapCodeBlock: allowWrapCodeBlock,
                allowPlaceholderText: allowPlaceholderText,
                allowColumnSorting: allowColumnSorting,
                allowNestedHeaderLinks: allowNestedHeaderLinks,
                useBlockRenderForCodeBlock: (_featureFlags$feature4 = featureFlags.featureFlags.useBlockRenderForCodeBlock) !== null && _featureFlags$feature4 !== void 0 ? _featureFlags$feature4 : true,
                addTelepointer: this.props.addTelepointer,
                onClick: handleWrapperOnClick
            }, (0, $byn9U.jsx)((0, $hlBr5.default), null));
        }
    }
    componentWillUnmount() {
        const { dataProviders: dataProviders } = this.props;
        if (this.rafID) window.cancelAnimationFrame(this.rafID);
        // if this is the ProviderFactory which was created in constructor
        // it's safe to destroy it on Renderer unmount
        if (!dataProviders) this.providerFactory.destroy();
    }
}
const $1a8f3eabe1e0fdbc$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>(0, $byn9U.jsx)((0, $dcbVh.FabricEditorAnalyticsContext), {
        data: {
            appearance: (0, $d0kCm.getAnalyticsAppearance)(props.appearance),
            packageName: $1a8f3eabe1e0fdbc$var$packageName,
            packageVersion: $1a8f3eabe1e0fdbc$var$packageVersion,
            componentName: 'renderer',
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))()
        }
    }, (0, $byn9U.jsx)((0, $jxPV4.WithCreateAnalyticsEvent), {
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return (0, $byn9U.jsx)((0, $4j1xD.ErrorBoundary), {
                component: (0, $61wF1.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, (0, $byn9U.jsx)((0, $1FQ7Z.IntlErrorBoundary), null, (0, $byn9U.jsx)($1a8f3eabe1e0fdbc$export$88530751e3977073, (0, $kU09D.default)({}, props, {
                createAnalyticsEvent: createAnalyticsEvent
            }))));
        }
    })));
const $1a8f3eabe1e0fdbc$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension } = props;
    const createTelepointer = ()=>{
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $15sgt.TELEPOINTER_ID);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef !== null && innerRef !== void 0 && innerRef.current) {
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation)=>{
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $15sgt.TELEPOINTER_ID)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $15sgt.TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    return (0, $byn9U.jsx)((0, $4IyMA.WidthProvider), {
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: (0, $XHGTv.getBooleanFF)('platform.editor.inline_extension.extended_lcqdn') && isInsideOfInlineExtension
    }, (0, $byn9U.jsx)((0, $eNUIj.BaseTheme), {
        baseFontSize: appearance && appearance !== 'comment' ? (0, $25FYC.akEditorFullPageDefaultFontSize) : undefined
    }, (0, $byn9U.jsx)((0, $cQY1N.EditorMediaClientProvider), {
        ssr: ssr
    }, (0, $byn9U.jsx)("div", {
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        css: (0, $15sgt.rendererStyles)({
            appearance: appearance,
            allowNestedHeaderLinks: allowNestedHeaderLinks,
            allowColumnSorting: !!allowColumnSorting,
            useBlockRenderForCodeBlock: useBlockRenderForCodeBlock
        })
    }, children))));
});
function $1a8f3eabe1e0fdbc$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const actions = (0, $eUqFw.useContext)((0, $a896o.RendererContext));
    const rendererRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (doc) actions._privateRegisterRenderer(rendererRef, doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        doc,
        onAnalyticsEvent
    ]);
    return children;
}
const $1a8f3eabe1e0fdbc$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    const innerRef = props.innerRef || localRef;
    if (!allowAnnotations) return (0, $byn9U.jsx)($1a8f3eabe1e0fdbc$export$af81ffb59b6ef0dd, (0, $kU09D.default)({
        innerRef: innerRef
    }, props));
    return (0, $byn9U.jsx)((0, $a896o.RendererActionsContext), null, (0, $byn9U.jsx)((0, $ifL1l.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider
    }, (0, $byn9U.jsx)($1a8f3eabe1e0fdbc$export$af81ffb59b6ef0dd, (0, $kU09D.default)({
        innerRef: innerRef
    }, props, {
        featureFlags: props.featureFlags
    }))));
};
var /* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $1a8f3eabe1e0fdbc$export$2e2bcd8739ae039 = $1a8f3eabe1e0fdbc$var$RendererWithAnnotationSelection;

});
parcelRegister("8HLio", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $656706ccb8bc895f$export$533b26079ad0b4b);

var $fkCu1 = parcelRequire("fkCu1");
function $656706ccb8bc895f$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $fkCu1.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});

parcelRegister("jWgZK", function(module, exports) {

$parcel$export(module.exports, "ProviderFactoryProvider", () => $e8409debaabc7949$export$617c134b25cc4265);
$parcel$export(module.exports, "useProvider", () => $e8409debaabc7949$export$693cdb10cec23617);

var $eUqFw = parcelRequire("eUqFw");

var $avvqL = parcelRequire("avvqL");
const $e8409debaabc7949$var$ProviderFactoryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(new (0, $avvqL.default)());
const $e8409debaabc7949$export$617c134b25cc4265 = $e8409debaabc7949$var$ProviderFactoryContext.Provider;
const $e8409debaabc7949$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($e8409debaabc7949$var$ProviderFactoryContext);
const $e8409debaabc7949$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState();
    const providerFactory = $e8409debaabc7949$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});

parcelRegister("eNUIj", function(module, exports) {

$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $ac71a27955e151dc$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $ac71a27955e151dc$export$a1a213d350ca51ca);

var $eUqFw = parcelRequire("eUqFw");

var $4WmDP = parcelRequire("4WmDP");

var $25FYC = parcelRequire("25FYC");

var $lcnyw = parcelRequire("lcnyw");

var $4IyMA = parcelRequire("4IyMA");
function $ac71a27955e151dc$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $ac71a27955e151dc$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $eUqFw.useMemo)(()=>({
            baseFontSize: baseFontSize || (0, $lcnyw.fontSize)(),
            layoutMaxWidth: (0, $25FYC.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4WmDP.a), {
        theme: memoizedTheme
    }, children);
}
function $ac71a27955e151dc$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4IyMA.WidthConsumer), null, ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac71a27955e151dc$export$3de34996b814f0f0, {
            breakpoint: breakpoint,
            baseFontSize: baseFontSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)));
}

});
parcelRegister("25FYC", function(module, exports) {

$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $823f29f46e51fd3b$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorCodeFontFamily", () => $823f29f46e51fd3b$export$9a7c520c39e1f0aa);
$parcel$export(module.exports, "akEditorSubtleAccent", () => $823f29f46e51fd3b$export$1d762aef048d30f9);
$parcel$export(module.exports, "akEditorBlockquoteBorderColor", () => $823f29f46e51fd3b$export$a7a75e50ae62d0a8);
$parcel$export(module.exports, "akEditorDeleteBackground", () => $823f29f46e51fd3b$export$ef95eb6ef0fd0a4a);
$parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", () => $823f29f46e51fd3b$export$8f7d2d784079e274);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $823f29f46e51fd3b$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorDeleteIconColor", () => $823f29f46e51fd3b$export$bf3aaa2106c119fd);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $823f29f46e51fd3b$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $823f29f46e51fd3b$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBgColor", () => $823f29f46e51fd3b$export$ef597e2e80767649);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $823f29f46e51fd3b$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $823f29f46e51fd3b$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $823f29f46e51fd3b$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $823f29f46e51fd3b$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $823f29f46e51fd3b$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $823f29f46e51fd3b$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $823f29f46e51fd3b$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $823f29f46e51fd3b$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $823f29f46e51fd3b$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $823f29f46e51fd3b$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $823f29f46e51fd3b$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $823f29f46e51fd3b$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $823f29f46e51fd3b$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $823f29f46e51fd3b$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $823f29f46e51fd3b$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableBorder", () => $823f29f46e51fd3b$export$36ba77fba4a62d5f);
$parcel$export(module.exports, "akEditorTableToolbar", () => $823f29f46e51fd3b$export$640eef769748f78f);
$parcel$export(module.exports, "akEditorTableHeaderCellBackground", () => $823f29f46e51fd3b$export$4c6f61fb4b9ae93);
$parcel$export(module.exports, "akEditorTableBorderSelected", () => $823f29f46e51fd3b$export$f7bbcec54ff5bc47);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $823f29f46e51fd3b$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $823f29f46e51fd3b$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $823f29f46e51fd3b$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $823f29f46e51fd3b$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $823f29f46e51fd3b$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $823f29f46e51fd3b$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $823f29f46e51fd3b$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $823f29f46e51fd3b$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $823f29f46e51fd3b$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $823f29f46e51fd3b$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $823f29f46e51fd3b$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $823f29f46e51fd3b$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $823f29f46e51fd3b$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $823f29f46e51fd3b$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $823f29f46e51fd3b$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $823f29f46e51fd3b$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $823f29f46e51fd3b$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $823f29f46e51fd3b$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $823f29f46e51fd3b$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorToolbarKeylineHeight", () => $823f29f46e51fd3b$export$d29cb2c31fcbb7c5);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $823f29f46e51fd3b$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorTableCellBlanketSelected", () => $823f29f46e51fd3b$export$e736f2caf3b39eb3);
$parcel$export(module.exports, "akEditorTableCellBlanketDeleted", () => $823f29f46e51fd3b$export$de3cef07cda55645);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $823f29f46e51fd3b$export$1d0d506416d457f1);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $823f29f46e51fd3b$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $823f29f46e51fd3b$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $823f29f46e51fd3b$export$214ff00e5618d86c);
$parcel$export(module.exports, "ATLASSIAN_NAVIGATION_HEIGHT", () => $823f29f46e51fd3b$export$c82675fa56f2eefd);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $823f29f46e51fd3b$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $823f29f46e51fd3b$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $823f29f46e51fd3b$export$59733a9f61449b25);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $823f29f46e51fd3b$export$9369fd010fa0ddd6);

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
const $823f29f46e51fd3b$export$fe6b0b821a0e9067 = 16;
const $823f29f46e51fd3b$export$9a7c520c39e1f0aa = (0, $lcnyw.codeFontFamily)();
const $823f29f46e51fd3b$export$e314d58809da911b = (0, $PdmhA.N500);
const $823f29f46e51fd3b$export$9a3076d23c153d92 = (0, $PdmhA.B100);
const $823f29f46e51fd3b$export$1d762aef048d30f9 = (0, $PdmhA.N40);
const $823f29f46e51fd3b$export$46f75d2f1d59b188 = (0, $PdmhA.N500);
const $823f29f46e51fd3b$export$c997cfdaffb4d6e6 = (0, $PdmhA.N0);
const $823f29f46e51fd3b$export$a7a75e50ae62d0a8 = (0, $PdmhA.N40);
const $823f29f46e51fd3b$export$e549ee8be3e2f59f = (0, $PdmhA.N900);
const $823f29f46e51fd3b$export$781884c8fda242b6 = (0, $PdmhA.N700);
const $823f29f46e51fd3b$export$a9a8b3b91667afe1 = (0, $PdmhA.B50);
const $823f29f46e51fd3b$export$5e112b63e4291515 = (0, $PdmhA.B400);
const $823f29f46e51fd3b$export$b9864494c2608629 = (0, $PdmhA.N20);
const $823f29f46e51fd3b$export$f0e953d95429ca1 = '12px';
const $823f29f46e51fd3b$export$a309dbdeca0adb1a = '2px 4px';
const $823f29f46e51fd3b$export$ef95eb6ef0fd0a4a = (0, $PdmhA.R50);
const $823f29f46e51fd3b$export$886b94e7e5d244bf = (0, $PdmhA.R50);
const $823f29f46e51fd3b$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $823f29f46e51fd3b$export$3c108a6bc41bb5f2 = (0, $PdmhA.R300);
const $823f29f46e51fd3b$export$bf3aaa2106c119fd = (0, $PdmhA.R400);
const $823f29f46e51fd3b$export$d2715266dd4a1fd1 = 20;
const $823f29f46e51fd3b$export$cf524c1b49838a49 = (0, $PdmhA.B300);
const $823f29f46e51fd3b$export$ef597e2e80767649 = (0, $PdmhA.B50);
const $823f29f46e51fd3b$export$514e6c370fbea91d = (0, $PdmhA.B75);
const $823f29f46e51fd3b$export$8dac549e32469ac4 = 1;
const $823f29f46e51fd3b$export$6e1e1996c4e8cc51 = `${$823f29f46e51fd3b$export$8dac549e32469ac4}px solid ${`var(--ds-border-selected, ${$823f29f46e51fd3b$export$cf524c1b49838a49})`}`;
const $823f29f46e51fd3b$export$b6a59ac3a19b6343 = `0 0 0 ${$823f29f46e51fd3b$export$8dac549e32469ac4}px ${`var(--ds-border-selected, ${$823f29f46e51fd3b$export$cf524c1b49838a49})`}`;
const $823f29f46e51fd3b$export$ecb17e3df162de53 = (0, $PdmhA.B400);
const $823f29f46e51fd3b$export$befaaae517e3d864 = 2;
const $823f29f46e51fd3b$export$4a007c22e25e31f6 = 0.3;
const $823f29f46e51fd3b$export$f35cc48f3398ab79 = 1;
const $823f29f46e51fd3b$export$b46cda584c619451 = 2;
const $823f29f46e51fd3b$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $823f29f46e51fd3b$export$321ddd2f049dd12 = $823f29f46e51fd3b$export$6bed85de54b5de42 + 1;
const $823f29f46e51fd3b$export$daeac9b8422ac3c2 = 1;
const $823f29f46e51fd3b$export$501d46e11ed5bf73 = (0, $lcnyw.layers).blanket();
const $823f29f46e51fd3b$export$6817b4b6a5ef78f1 = (0, $lcnyw.layers).layer();
const $823f29f46e51fd3b$export$93768eb72dec48ce = $823f29f46e51fd3b$export$501d46e11ed5bf73 + 10;
const $823f29f46e51fd3b$export$c0aec4e0896849a0 = $823f29f46e51fd3b$export$93768eb72dec48ce - 5;
const $823f29f46e51fd3b$export$5886f057e4f21fe4 = $823f29f46e51fd3b$export$6817b4b6a5ef78f1 + 5;
const $823f29f46e51fd3b$export$11965a0dc12e6cd6 = (0, $PdmhA.N100);
const $823f29f46e51fd3b$export$6e85faa46d537a3f = 11;
const $823f29f46e51fd3b$export$36ba77fba4a62d5f = (0, $PdmhA.N50);
const $823f29f46e51fd3b$export$a21078fd4649993b = (0, $PdmhA.DN70);
const $823f29f46e51fd3b$export$640eef769748f78f = (0, $PdmhA.N20);
const $823f29f46e51fd3b$export$d72825c6f006826c = (0, $PdmhA.DN50);
const $823f29f46e51fd3b$export$154c32a542db7927 = (0, $PdmhA.N20);
const $823f29f46e51fd3b$export$58aee55ecb41eac9 = (0, $PdmhA.B75);
const $823f29f46e51fd3b$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $823f29f46e51fd3b$export$95e9a0285b97474d = '#2C333A';
const $823f29f46e51fd3b$export$b098fbeedf0e901d = (0, $PdmhA.B100);
const $823f29f46e51fd3b$export$f7bbcec54ff5bc47 = (0, $PdmhA.B300);
const $823f29f46e51fd3b$export$7db8b54b38e7e92 = (0, $PdmhA.R50);
const $823f29f46e51fd3b$export$bee03689367106ff = (0, $PdmhA.R300);
const $823f29f46e51fd3b$export$f36ab9d2ae35c3cf = (0, $PdmhA.R75);
const $823f29f46e51fd3b$export$76b5e653883e5290 = '3px';
const $823f29f46e51fd3b$export$6d85fe8177a50c0c = 0.5;
const $823f29f46e51fd3b$export$fad19f16d3f953a3 = 680;
const $823f29f46e51fd3b$export$9db045950eedb49f = 760;
const $823f29f46e51fd3b$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $823f29f46e51fd3b$export$f580e3d28d0986de = 1800;
const $823f29f46e51fd3b$export$9d5488b5afad62bf = 1792;
const $823f29f46e51fd3b$export$37df10057d36a0e5 = 42;
const $823f29f46e51fd3b$export$437293c5e9fc2703 = 96;
const $823f29f46e51fd3b$export$6e0f4d52efd3d2d = 32;
const $823f29f46e51fd3b$export$f222e0c7a2dc5324 = ()=>(0, $XHGTv.getBooleanFF)('platform.editor.core.increase-full-page-guttering') ? 52 : 32;
const $823f29f46e51fd3b$export$efe8561bbd3f74d2 = 720;
const $823f29f46e51fd3b$export$e4d39a9e8607c1d3 = 48;
const $823f29f46e51fd3b$export$43946f2400ab6f1f = 128;
const $823f29f46e51fd3b$export$558438ae7fd4b8ce = 12;
const $823f29f46e51fd3b$export$6beb98d32d4ca149 = 4;
const $823f29f46e51fd3b$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $823f29f46e51fd3b$export$5edb4f38c3eacb1a = 1024;
const $823f29f46e51fd3b$export$e60820063058ed59 = 1.33;
const $823f29f46e51fd3b$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $823f29f46e51fd3b$export$fb15fade89f67217 = $823f29f46e51fd3b$export$f35cc48f3398ab79 * 99;
const $823f29f46e51fd3b$export$847030921e9d5a40 = (0, $lcnyw.gridSize)() * 1.5;
const $823f29f46e51fd3b$export$40eb41ab799f0329 = 1.714;
const $823f29f46e51fd3b$export$c36b615598bb9f62 = (0, $PdmhA.N30);
const $823f29f46e51fd3b$export$e271312fc7124aec = '1px';
const $823f29f46e51fd3b$export$d29cb2c31fcbb7c5 = 2;
const $823f29f46e51fd3b$export$688a6dc01e760755 = 320;
const $823f29f46e51fd3b$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $823f29f46e51fd3b$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $823f29f46e51fd3b$export$1d0d506416d457f1 = '0.75rem';
const $823f29f46e51fd3b$export$e683ef42725d1713 = 680;
const $823f29f46e51fd3b$export$226c784ba04bd04b = 480;
const $823f29f46e51fd3b$export$214ff00e5618d86c = 20;
const $823f29f46e51fd3b$export$c82675fa56f2eefd = '56px';
const $823f29f46e51fd3b$export$d7726a000ae2d7c = ()=>(0, $XHGTv.getBooleanFF)('platform.confluence.frontend.narrow-full-page-editor-toolbar') ? "var(--ds-space-500, 40px)" : '56px';
const $823f29f46e51fd3b$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $823f29f46e51fd3b$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : (0, $lcnyw.fontSize)();
const $823f29f46e51fd3b$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$823f29f46e51fd3b$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $823f29f46e51fd3b$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $823f29f46e51fd3b$export$96b72b7f243fa693 = {
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $823f29f46e51fd3b$export$9369fd010fa0ddd6 = 0;
const $823f29f46e51fd3b$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$823f29f46e51fd3b$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $823f29f46e51fd3b$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $823f29f46e51fd3b$export$312e1e71424c4aa1 = [
    `var(--ds-icon-accent-red, ${(0, $PdmhA.R100)})`,
    `var(--ds-background-accent-red-bolder-hovered, ${(0, $PdmhA.R300)})`,
    `var(--ds-icon-accent-magenta, ${(0, $PdmhA.R500)})`,
    `var(--ds-background-accent-magenta-bolder-hovered, ${(0, $PdmhA.Y100)})`,
    `var(--ds-icon-accent-orange, ${(0, $PdmhA.Y300)})`,
    `var(--ds-background-accent-orange-bolder-hovered, ${(0, $PdmhA.Y500)})`,
    `var(--ds-icon-accent-green, ${(0, $PdmhA.G100)})`,
    `var(--ds-background-accent-green-bolder-hovered, ${(0, $PdmhA.G300)})`,
    `var(--ds-icon-accent-blue, ${(0, $PdmhA.G500)})`,
    `var(--ds-background-accent-blue-bolder-hovered, ${(0, $PdmhA.T100)})`,
    `var(--ds-icon-accent-teal, ${(0, $PdmhA.T300)})`,
    `var(--ds-background-accent-teal-bolder-hovered, ${(0, $PdmhA.T500)})`,
    `var(--ds-icon-accent-lime, ${(0, $PdmhA.B100)})`,
    `var(--ds-background-accent-lime-bolder-hovered, ${(0, $PdmhA.B300)})`,
    `var(--ds-icon-accent-purple, ${(0, $PdmhA.B500)})`,
    `var(--ds-background-accent-purple-bolder-hovered, ${(0, $PdmhA.N70)})`,
    `var(--ds-icon-accent-gray, ${(0, $PdmhA.N200)})`,
    `var(--ds-background-accent-gray-bolder-hovered, ${(0, $PdmhA.N800)})`,
    `var(--ds-icon-accent-yellow, ${(0, $PdmhA.P100)})`,
    `var(--ds-background-accent-yellow-bolder-hovered, ${(0, $PdmhA.P300)})`,
    `var(--ds-background-accent-yellow-bolder-pressed, ${(0, $PdmhA.P500)})`
];

});

parcelRegister("4IyMA", function(module, exports) {

$parcel$export(module.exports, "getBreakpoint", () => $36f6409ea027c748$export$1eb095b00b926404);
$parcel$export(module.exports, "createWidthContext", () => $36f6409ea027c748$export$31a4966bffb9ac98);
$parcel$export(module.exports, "WidthContext", () => $36f6409ea027c748$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $36f6409ea027c748$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $36f6409ea027c748$export$7921e18173e8c666);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8yx6O = parcelRequire("8yx6O");

var $5qTKr = parcelRequire("5qTKr");
const $36f6409ea027c748$var$SCROLLBAR_WIDTH = 30;
function $36f6409ea027c748$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $36f6409ea027c748$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $36f6409ea027c748$export$1eb095b00b926404(width)
    };
}
const $36f6409ea027c748$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($36f6409ea027c748$export$31a4966bffb9ac98());
const { Provider: $36f6409ea027c748$var$Provider, Consumer: $36f6409ea027c748$export$5d8538aa831b6ebb } = $36f6409ea027c748$export$27e39f636459b9f;
const $36f6409ea027c748$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($36f6409ea027c748$export$27e39f636459b9f);
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(typeof document !== 'undefined' ? document.body.offsetWidth : 0);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>$36f6409ea027c748$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $8yx6O.default)((nextWidth)=>{
        // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
        if (Math.abs(width - nextWidth) < $36f6409ea027c748$var$SCROLLBAR_WIDTH) return;
        setWidth(nextWidth);
    });
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    return (0, $byn9U.jsx)("div", {
        css: (0, $byn9U.css)`
        position: relative;
        width: 100%;
      `,
        className: className
    }, !skipWidthDetection && (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)((0, $5qTKr.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), (0, $byn9U.jsx)($36f6409ea027c748$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});


parcelRegister("1FQ7Z", function(module, exports) {

$parcel$export(module.exports, "IntlErrorBoundary", () => $13820e43d76f158a$export$7df0749115d18d19);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
const $13820e43d76f158a$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $13820e43d76f158a$var$isMissingIntlProviderInAncestryError = (err)=>{
    var _err$toString;
    return err === null || err === void 0 ? void 0 : (_err$toString = err.toString()) === null || _err$toString === void 0 ? void 0 : _err$toString.includes('<IntlProvider> needs to exist in the component ancestry');
};
class $13820e43d76f158a$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            missingIntlProviderInAncestry: false
        });
    }
    componentDidCatch(error, errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($13820e43d76f158a$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl-next error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
            locale: "en"
        }, this.props.children);
        return this.props.children;
    }
}

});

parcelRegister("hlBr5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca116fcf054b932e$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $25FYC = parcelRequire("25FYC");

var $ioiQ7 = parcelRequire("ioiQ7");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $61wF1 = parcelRequire("61wF1");

var $lAA7z = parcelRequire("lAA7z");

var $fSlwM = parcelRequire("fSlwM");

var $g6Rdu = parcelRequire("g6Rdu");
const $ca116fcf054b932e$var$blockNodeStyle = (0, $byn9U.css)`
  background: ${`var(--ds-background-disabled, ${(0, $PdmhA.N30)})`};
  border: 1px dashed ${`var(--ds-border-disabled, ${(0, $PdmhA.N50)})`};
  border-radius: ${(0, $lcnyw.borderRadius)()}px;
  box-sizing: border-box;
  cursor: default;
  display: flex;
  font-size: ${(0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)())};
  margin: ${"var(--ds-space-100, 8px)"} 0;
  min-height: 24px;
  padding: ${"var(--ds-space-150, 12px)"};
  text-align: center;
  vertical-align: text-bottom;
  min-width: 120px;
  align-items: center;
  justify-content: center;
`;
const $ca116fcf054b932e$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $g6Rdu.getUnsupportedContent)((0, $lAA7z.unsupportedContentMessages).unsupportedBlockContent, (0, $lAA7z.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $lAA7z.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $eUqFw.useRef)({
        padding: '4px'
    });
    const originalNodeType = node === null || node === void 0 ? void 0 : node.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $eUqFw.useCallback)(()=>dispatchAnalyticsEvent && (0, $fSlwM.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $61wF1.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return (0, $byn9U.jsx)("div", {
        css: $ca116fcf054b932e$var$blockNodeStyle,
        className: "unsupported"
    }, message, (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, (0, $byn9U.jsx)("span", {
        style: style
    }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))), {
        label: "?",
        size: "small"
    }))));
};
var $ca116fcf054b932e$export$2e2bcd8739ae039 = (0, $2qhQi.default)($ca116fcf054b932e$var$UnsupportedBlockNode);

});
parcelRegister("61wF1", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $462c2bc780eb346d$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $462c2bc780eb346d$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $462c2bc780eb346d$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $462c2bc780eb346d$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $462c2bc780eb346d$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $462c2bc780eb346d$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $462c2bc780eb346d$export$9f0b2adf3cfd71b7);
let $462c2bc780eb346d$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
let $462c2bc780eb346d$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_TTI"] = "tti";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENTERED"] = "entered";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS"] = "inputPerfSamplingSingleKeypress";
    ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS_AVG"] = "inputPerfSamplingSingleKeypressAvg";
    ACTION["INPUT_PERF_SAMPLING_RENDERED"] = "inputPerfSamplingRendered";
    ACTION["INPUT_PERF_SAMPLING_RENDERED_AVG"] = "inputPerfSamplingRenderedAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_DISPATCHED"] = "transactionDispatched";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    ACTION["UPDATED_SOURCE"] = "updatedSource";
    ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["UFO_SESSION_COMPLETE"] = "ufoSessionComplete";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["RENDERER_TTI"] = "tti";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDERN"] = "getChildern";
    return ACTION;
}({});
let $462c2bc780eb346d$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    return INPUT_METHOD;
}({});
let $462c2bc780eb346d$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    return TRIGGER_METHOD;
}({});
let $462c2bc780eb346d$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    return ACTION_SUBJECT;
}({});
let $462c2bc780eb346d$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    return ACTION_SUBJECT_ID;
}({});
let $462c2bc780eb346d$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
let $462c2bc780eb346d$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("lAA7z", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentMessages", () => $fb78faae8dacd88d$export$32ec96484dd3ba39);

var $90IgZ = parcelRequire("90IgZ");
const $fb78faae8dacd88d$export$32ec96484dd3ba39 = (0, $90IgZ.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'Unsupported content'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'This editor does not support displaying this content'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'Content is not available in this editor, this will be preserved when you edit and save'
    }
});

});

parcelRegister("fSlwM", function(module, exports) {

$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $b8ec9921ca4c42b2$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $b8ec9921ca4c42b2$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $b8ec9921ca4c42b2$export$3a34598135e7219b);

var $61wF1 = parcelRequire("61wF1");
const $b8ec9921ca4c42b2$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $b8ec9921ca4c42b2$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
const $b8ec9921ca4c42b2$var$sanitizeMarks = (marks = [])=>{
    let sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $b8ec9921ca4c42b2$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $b8ec9921ca4c42b2$var$sanitizeAttributes = (attrs = {})=>{
    let sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$b8ec9921ca4c42b2$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $b8ec9921ca4c42b2$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $61wF1.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $61wF1.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $b8ec9921ca4c42b2$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $b8ec9921ca4c42b2$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $61wF1.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $b8ec9921ca4c42b2$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $61wF1.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $61wF1.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $61wF1.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $b8ec9921ca4c42b2$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$b8ec9921ca4c42b2$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $b8ec9921ca4c42b2$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $b8ec9921ca4c42b2$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $b8ec9921ca4c42b2$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $b8ec9921ca4c42b2$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $61wF1.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $61wF1.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $61wF1.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $b8ec9921ca4c42b2$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $b8ec9921ca4c42b2$var$trackUnsupportedContentTooltipActionFor((0, $61wF1.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("g6Rdu", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContent", () => $bba67c9833e883c0$export$d4ded51d0f0bd2df);
function $bba67c9833e883c0$export$d4ded51d0f0bd2df(message, prefix, node, intl) {
    let defaultLocale = 'en';
    let canTranslateToLocale = true;
    let locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("jxPV4", function(module, exports) {

$parcel$export(module.exports, "WithCreateAnalyticsEvent", () => $e3a95f80add2d6b8$export$9ac3d19711324187);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");
const $e3a95f80add2d6b8$export$9ac3d19711324187 = (0, $2jDha.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});

});

parcelRegister("ckjIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f96a574e063155f$export$2e2bcd8739ae039);
const $8f96a574e063155f$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    gecko_version: 0,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    safari_version: 0,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $8f96a574e063155f$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $8f96a574e063155f$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $8f96a574e063155f$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $8f96a574e063155f$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $8f96a574e063155f$var$result.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
    $8f96a574e063155f$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $8f96a574e063155f$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $8f96a574e063155f$var$result.android = /Android \d/.test(navigator.userAgent);
    $8f96a574e063155f$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $8f96a574e063155f$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $8f96a574e063155f$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $8f96a574e063155f$var$result.safari_version = parseInt((navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
    $8f96a574e063155f$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $8f96a574e063155f$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
var $8f96a574e063155f$export$2e2bcd8739ae039 = $8f96a574e063155f$var$result;

});

parcelRegister("d0kCm", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAppearance", () => $977b44affc950ab8$export$be87849653b93e6b);
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $977b44affc950ab8$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $977b44affc950ab8$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "SEVERITY", () => $977b44affc950ab8$export$6a6bef12562cd865);
$parcel$export(module.exports, "analyticsEventKey", () => $977b44affc950ab8$export$288273ee3e3b6132);

var $dcbVh = parcelRequire("dcbVh");

var $jvBwu = parcelRequire("jvBwu");
const $977b44affc950ab8$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $dcbVh.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $dcbVh.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $dcbVh.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $dcbVh.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $dcbVh.EDITOR_APPEARANCE_CONTEXT).MOBILE;
    }
};
const $977b44affc950ab8$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$977b44affc950ab8$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $977b44affc950ab8$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return $977b44affc950ab8$export$6a6bef12562cd865.DEGRADED;
    if (duration > degradedThreshold) return $977b44affc950ab8$export$6a6bef12562cd865.BLOCKING;
    return $977b44affc950ab8$export$6a6bef12562cd865.NORMAL;
};
let $977b44affc950ab8$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
const $977b44affc950ab8$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';

});
parcelRegister("jvBwu", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $e33e04dd5670bd26$export$484b83e0462998d);

var $fkCu1 = parcelRequire("fkCu1");
let $e33e04dd5670bd26$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
const $e33e04dd5670bd26$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $e33e04dd5670bd26$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: (customThresholds === null || customThresholds === void 0 ? void 0 : customThresholds.degraded) || $e33e04dd5670bd26$export$f9f8a29778652c3e.DEGRADED,
        blocking: (customThresholds === null || customThresholds === void 0 ? void 0 : customThresholds.blocking) || $e33e04dd5670bd26$export$f9f8a29778652c3e.BLOCKING
    };
};
const $e33e04dd5670bd26$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $fkCu1.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                var _node$attrs;
                const originalNode = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $fkCu1.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        var _parent$parent$node$t, _parent$parent, _parent$parent$node, _unsupportedNode$type, _unsupportedNodeTypeC;
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = (_parent$parent$node$t = (_parent$parent = parent.parent) === null || _parent$parent === void 0 ? void 0 : (_parent$parent$node = _parent$parent.node) === null || _parent$parent$node === void 0 ? void 0 : _parent$parent$node.type) !== null && _parent$parent$node$t !== void 0 ? _parent$parent$node$t : 'unknown';
                        const type = `${parentType}/${(_unsupportedNode$type = unsupportedNode === null || unsupportedNode === void 0 ? void 0 : unsupportedNode.type) !== null && _unsupportedNode$type !== void 0 ? _unsupportedNode$type : 'unknown'}`;
                        unsupportedNodeTypeCount[type] = ((_unsupportedNodeTypeC = unsupportedNodeTypeCount === null || unsupportedNodeTypeCount === void 0 ? void 0 : unsupportedNodeTypeCount[type]) !== null && _unsupportedNodeTypeC !== void 0 ? _unsupportedNodeTypeC : 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $e33e04dd5670bd26$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return $e33e04dd5670bd26$export$6632e71a22d31bf1.DEGRADED;
    if (thresholds.blocking <= unsupportedContentLevelPercent) return $e33e04dd5670bd26$export$6632e71a22d31bf1.BLOCKING;
    return $e33e04dd5670bd26$export$6632e71a22d31bf1.NORMAL;
};
const $e33e04dd5670bd26$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $e33e04dd5670bd26$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $e33e04dd5670bd26$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $e33e04dd5670bd26$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});


parcelRegister("kvS2F", function(module, exports) {

$parcel$export(module.exports, "getDistortedDurationMonitor", () => $eef09f83a17a7290$export$70f7d127254a90c);
$parcel$export(module.exports, "measureRender", () => $eef09f83a17a7290$export$267ed650a5d21ae6);

var $8GTuX = parcelRequire("8GTuX");
const $eef09f83a17a7290$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
     * Cleans up the document visibility event listener
     */ cleanup () {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $eef09f83a17a7290$export$267ed650a5d21ae6(/**
 * Unique name for the measurement
 *
 * Important: if multiple measureRender events are fired at the same time
 * with the same measure name -- the result will not be correct.
 */ measureName, /**
 * Call back fired when the measurement completes.
 *
 * Note: when this function is called when the Document.visibilityState is not
 * visible -- the duration is likely to be misleading/inaccurate. This is due
 * to the measurements use of the `requestAnimationFrame` api which only fires
 * when the Document.visibilityState is visible.
 */ onMeasureComplete) {
    if (!(0, $8GTuX.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    let distortedDurationMonitor = $eef09f83a17a7290$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}

});
parcelRegister("8GTuX", function(module, exports) {

$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $653d4bc69a474d4e$export$b5717a625dd4a3eb);
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => $653d4bc69a474d4e$export$48995af1e77d8643);
$parcel$export(module.exports, "isPerformanceObserverLongTaskAvailable", () => $653d4bc69a474d4e$export$4370ec0f52022f66);
let $653d4bc69a474d4e$var$hasRequiredPerformanceAPIs;
function $653d4bc69a474d4e$export$b5717a625dd4a3eb() {
    if ($653d4bc69a474d4e$var$hasRequiredPerformanceAPIs === undefined) $653d4bc69a474d4e$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $653d4bc69a474d4e$var$hasRequiredPerformanceAPIs;
}
function $653d4bc69a474d4e$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
function $653d4bc69a474d4e$export$4370ec0f52022f66() {
    return $653d4bc69a474d4e$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}

});


parcelRegister("4U0vH", function(module, exports) {

$parcel$export(module.exports, "getResponseEndTime", () => $391cc9bd514da737$export$92d097a1155bbe27);

var $8GTuX = parcelRequire("8GTuX");
function $391cc9bd514da737$export$92d097a1155bbe27() {
    if (!(0, $8GTuX.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}

});

parcelRegister("jYFEM", function(module, exports) {

$parcel$export(module.exports, "measureTTI", () => $e8b3ef156f1823e1$export$dd9846a8ce40fad7);
$parcel$export(module.exports, "getTTISeverity", () => $e8b3ef156f1823e1$export$8a681a045a8e7990);

var $d0kCm = parcelRequire("d0kCm");

var $8GTuX = parcelRequire("8GTuX");

var $kvS2F = parcelRequire("kvS2F");
function $e8b3ef156f1823e1$export$dd9846a8ce40fad7(onMeasureComplete, idleThreshold = 1000, cancelAfter = 60, // Dependency Injection for easier testing
PerfObserver) {
    if (!(0, $8GTuX.isPerformanceObserverLongTaskAvailable)()) return;
    const start = performance.now();
    // Keeping track of users moving away from the tab, which distorts the TTI measurement
    const distortedDurationMonitor = (0, $kvS2F.getDistortedDurationMonitor)();
    let prevLongTask;
    let lastLongTask = {
        startTime: start,
        duration: 0
    };
    const cancelAfterMs = cancelAfter * 1000;
    const observer = new (PerfObserver || PerformanceObserver)((list)=>{
        const entries = list.getEntries();
        if (entries.length) {
            prevLongTask = lastLongTask;
            lastLongTask = entries[entries.length - 1];
        }
    });
    observer.observe({
        entryTypes: [
            'longtask'
        ]
    });
    const checkIdle = ()=>{
        // 1. There hasn't been any long task in `idleThreshold` time: Interactive from the start.
        // 2. Only 1 long task: Interactive from the end of the only long task.
        // 3. Several long tasks:
        //    3.1 Interactive from the end of prevLongTask if `lastLongTask.start - prevLongTask.end >= idleThreshold`
        //    3.2 Interactive from the end of lastLongTask if `lastLongTask.start - prevLongTask.end < idleThreshold`
        const now = performance.now();
        const lastEnd = lastLongTask.startTime + lastLongTask.duration;
        const prevEnd = prevLongTask ? prevLongTask.startTime + prevLongTask.duration : lastEnd;
        const elapsedTimeMs = now - start;
        const canceled = elapsedTimeMs > cancelAfterMs;
        if (!prevLongTask) {
            observer.disconnect();
            distortedDurationMonitor.cleanup();
            return onMeasureComplete(prevEnd, 0, false, distortedDurationMonitor.distortedDuration);
        } else if (lastLongTask.startTime - prevEnd >= idleThreshold) {
            observer.disconnect();
            distortedDurationMonitor.cleanup();
            return onMeasureComplete(prevEnd, prevEnd - start, canceled, distortedDurationMonitor.distortedDuration);
        } else if (now - lastEnd >= idleThreshold || canceled) {
            observer.disconnect();
            distortedDurationMonitor.cleanup();
            return onMeasureComplete(lastEnd, lastEnd - start, canceled, distortedDurationMonitor.distortedDuration);
        }
        return setTimeout(checkIdle, idleThreshold);
    };
    setTimeout(checkIdle, idleThreshold);
}
const $e8b3ef156f1823e1$export$d0d10f04d3799d8b = {
    NORMAL: 40000,
    DEGRADED: 60000
};
const $e8b3ef156f1823e1$export$f801d5dbbaf41dff = {
    NORMAL: 5000,
    DEGRADED: 8000
};
function $e8b3ef156f1823e1$export$8a681a045a8e7990(tti, ttiFromInvocation, ttiSeverityNormalThreshold, ttiSeverityDegradedThreshold, ttiFromInvocationSeverityNormalThreshold, ttiFromInvocationSeverityDegradedThreshold) {
    const ttiNormalThreshold = ttiSeverityNormalThreshold || $e8b3ef156f1823e1$export$d0d10f04d3799d8b.NORMAL;
    const ttiDegradedThreshold = ttiSeverityDegradedThreshold || $e8b3ef156f1823e1$export$d0d10f04d3799d8b.DEGRADED;
    let ttiSeverity;
    if (tti >= ttiNormalThreshold && tti < ttiDegradedThreshold) ttiSeverity = (0, $d0kCm.SEVERITY).DEGRADED;
    else if (tti >= ttiDegradedThreshold) ttiSeverity = (0, $d0kCm.SEVERITY).BLOCKING;
    else ttiSeverity = (0, $d0kCm.SEVERITY).NORMAL;
    const ttiFromInvocationNormalThreshold = ttiFromInvocationSeverityNormalThreshold || $e8b3ef156f1823e1$export$f801d5dbbaf41dff.NORMAL;
    const ttiFromInvocationDegradedThreshold = ttiFromInvocationSeverityDegradedThreshold || $e8b3ef156f1823e1$export$f801d5dbbaf41dff.DEGRADED;
    let ttiFromInvocationSeverity;
    if (ttiFromInvocation >= ttiFromInvocationNormalThreshold && ttiFromInvocation < ttiFromInvocationDegradedThreshold) ttiFromInvocationSeverity = (0, $d0kCm.SEVERITY).DEGRADED;
    else if (ttiFromInvocation >= ttiFromInvocationDegradedThreshold) ttiFromInvocationSeverity = (0, $d0kCm.SEVERITY).BLOCKING;
    else ttiFromInvocationSeverity = (0, $d0kCm.SEVERITY).NORMAL;
    return {
        ttiSeverity: ttiSeverity,
        ttiFromInvocationSeverity: ttiFromInvocationSeverity
    };
}

});

parcelRegister("7PAGx", function(module, exports) {

$parcel$export(module.exports, "shouldForceTracking", () => $5b39c0ba812d5775$export$5b59d3e9e22dbdc6);
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $5b39c0ba812d5775$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260

});

parcelRegister("fFkxb", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $b67a9d0ae6502a46$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $b67a9d0ae6502a46$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $b67a9d0ae6502a46$export$6f766653554dac02);

var $8GTuX = parcelRequire("8GTuX");
const $b67a9d0ae6502a46$var$measureMap = new Map();
function $b67a9d0ae6502a46$export$b62aa2130c86b59b(measureName) {
    if (!(0, $8GTuX.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $b67a9d0ae6502a46$var$measureMap.set(measureName, performance.now());
}
function $b67a9d0ae6502a46$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $8GTuX.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $b67a9d0ae6502a46$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $b67a9d0ae6502a46$export$6f766653554dac02(measureName);
    }
}
function $b67a9d0ae6502a46$export$6f766653554dac02(measureName) {
    if (!(0, $8GTuX.isPerformanceAPIAvailable)()) return;
    $b67a9d0ae6502a46$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}

});

parcelRegister("llfM0", function(module, exports) {

$parcel$export(module.exports, "normalizeFeatureFlags", () => $f897cb694a9f7851$export$f1485fc4974593c0);
$parcel$export(module.exports, "getEnabledFeatureFlagKeys", () => $f897cb694a9f7851$export$6d018dd0f6cbebcb);

var $jh2R9 = parcelRequire("jh2R9");

var $4vTMF = parcelRequire("4vTMF");
const $f897cb694a9f7851$var$EMPTY = {};
function $f897cb694a9f7851$var$isObjectFlagKey(key, value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && (objectFlagKeys === null || objectFlagKeys === void 0 ? void 0 : objectFlagKeys.includes(key)));
}
function $f897cb694a9f7851$var$isValidJSONObject(value) {
    try {
        let result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $f897cb694a9f7851$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $f897cb694a9f7851$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($f897cb694a9f7851$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(e[0]), e[1], options === null || options === void 0 ? void 0 : options.objectFlagKeys) && $f897cb694a9f7851$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($f897cb694a9f7851$var$isObjectFlagKey(key, value, options === null || options === void 0 ? void 0 : options.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
function $f897cb694a9f7851$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}

});

parcelRegister("7tDYk", function(module, exports) {

$parcel$export(module.exports, "default", () => $571a3f7030782ba6$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $7dkLM = parcelRequire("7dkLM");

var $eZEEl = parcelRequire("eZEEl");
parcelRequire("gxwLU");
var $5hYCz = parcelRequire("5hYCz");
var $gxwLU = parcelRequire("gxwLU");

var $faoVa = parcelRequire("faoVa");

var $9TPMs = parcelRequire("9TPMs");
var $bVej2 = parcelRequire("bVej2");

var $9EROo = parcelRequire("9EROo");

var $3nPkY = parcelRequire("3nPkY");

var $erA3g = parcelRequire("erA3g");

var $2zbl1 = parcelRequire("2zbl1");

var $dnpK7 = parcelRequire("dnpK7");

var $7subh = parcelRequire("7subh");

var $lOHCn = parcelRequire("lOHCn");

var $4oBhR = parcelRequire("4oBhR");
function $571a3f7030782ba6$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $7dkLM.MarkType) && prev && prev.type instanceof (0, $7dkLM.MarkType) && Array.isArray(prev.content) && (0, $9EROo.isSameMark)(prev, markOrNode)) prev.content = $571a3f7030782ba6$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $571a3f7030782ba6$export$2e2bcd8739ae039 {
    constructor(init){
        (0, $5zQU9.default)(this, "headingIds", []);
        /**
     * The reason we have this extra array here is because we need to generate the same unique
     * heading id for 2 different nodes: headers and expands (check the implementation of
     * `getUniqueHeadingId` for more info).
     *
     * We will eventually need to refactor the current approach to generate unique ids
     * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
     */ (0, $5zQU9.default)(this, "expandHeadingIds", []);
        (0, $5zQU9.default)(this, "allowCopyToClipboard", false);
        (0, $5zQU9.default)(this, "allowWrapCodeBlock", false);
        (0, $5zQU9.default)(this, "allowPlaceholderText", true);
        (0, $5zQU9.default)(this, "allowCustomPanels", false);
        (0, $5zQU9.default)(this, "startPos", 1);
        (0, $5zQU9.default)(this, "surroundTextNodesWithTextWrapper", false);
        (0, $5zQU9.default)(this, "allowAnnotations", false);
        (0, $5zQU9.default)(this, "serializeFragmentChild", (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = node.type.name === 'taskItem' && node.attrs.state !== 'DONE';
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $gxwLU.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>{
                    var _n$type;
                    return ((_n$type = n.type) === null || _n$type === void 0 ? void 0 : _n$type.name) !== 'mediaSingle';
                }) && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $bVej2.toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        });
        (0, $5zQU9.default)(this, "withMediaMarkProps", (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            return defaultProps;
        });
        (0, $5zQU9.default)(this, "getUnsupportedContentProps", (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        });
        (0, $5zQU9.default)(this, "getAnnotationMarkProps", (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $9TPMs.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        });
        (0, $5zQU9.default)(this, "getMarkProps", (mark, marksParentPath, node)=>{
            if ((0, $9TPMs.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node === null || node === void 0 ? void 0 : node.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $7subh.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: this.appearance !== 'mobile'
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        });
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
    }
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = 1;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, props = {}, target = this.allowSelectAllTrap ? (0, $5hYCz.DocWithSelectAllTrap) : (0, $5hYCz.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, $571a3f7030782ba6$export$2e2bcd8739ae039.getChildNodes(fragment).map((node, index)=>{
            if ((0, $gxwLU.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { index: index, parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        return $571a3f7030782ba6$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $gxwLU.isTextNode)(mark)) {
            const serializeContent = (childMark, index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            return this.renderMark((0, $bVej2.toReact)(mark), this.getMarkProps(mark, parentMark.path), markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $faoVa.default), {
                key: textKey,
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks
            }, mark.text);
        }
        const segments = (0, $lOHCn.segmentText)(mark.text, this.textHighlighter);
        return (0, $4oBhR.renderTextSegments)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(NodeComponent, props, key, content) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NodeComponent, (0, $kU09D.default)({
            key: key
        }, props), content);
    }
    renderMark(MarkComponent, props, key, content) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MarkComponent, (0, $kU09D.default)({
            key: key
        }, props), content);
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        // TODO: https://product-fabric.atlassian.net/browse/CEMS-1048
        const stickyHeaders = !(0, $dnpK7.insideBreakoutLayout)(path) ? this.stickyHeaders : undefined;
        const isInsideOfBlockNode = (0, $dnpK7.insideBlockNode)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $dnpK7.insideMultiBodiedExtension)(path, node.type.schema);
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: (0, $3nPkY.calcTableColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension
        };
    }
    getDateProps(node, parentInfo) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $dnpK7.insideBlockNode)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        var _this$media;
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>{
            var _n$type2;
            return ((_n$type2 = n.type) === null || _n$type2 === void 0 ? void 0 : _n$type2.name) === 'mediaSingle';
        });
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: (_this$media = this.media) === null || _this$media === void 0 ? void 0 : _this$media.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper
        };
    }
    getEmojiProps(node) {
        return {
            ...this.getProps(node),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $dnpK7.insideBlockNode)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0
        };
    }
    getMediaGroupProps(node) {
        var _this$media2, _this$media3;
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: (_this$media2 = this.media) === null || _this$media2 === void 0 ? void 0 : _this$media2.enableDownloadButton,
            ssr: (_this$media3 = this.media) === null || _this$media3 === void 0 ? void 0 : _this$media3.ssr
        };
    }
    getMediaInlineProps(node) {
        var _this$media4;
        return {
            ...this.getProps(node),
            ssr: (_this$media4 = this.media) === null || _this$media4 === void 0 ? void 0 : _this$media4.ssr
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = this.appearance !== 'mobile';
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        return {
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            },
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $eZEEl.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, path = []) {
        if (!(0, $eZEEl.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return this.getProps(node);
        const nestedHeaderIds = (0, $2zbl1.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        const nodeContent = node.content.toJSON().reduce((acc, node)=>acc.concat((0, $erA3g.getText)(node) || ''), '').trim().replace(/\s/g, '-');
        if (!nodeContent) return;
        return this.getUniqueHeadingId(nodeContent, headingIds);
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    static getChildNodes(fragment) {
        const children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        return (0, $gxwLU.mergeTextNodes)(children);
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $9EROo.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $571a3f7030782ba6$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            }, node);
        }));
    }
    // TODO: ED-9004 Remove unused ReactSerializer.fromSchema in renderer
    // https://sourcegraph-frontend.internal.shared-prod.us-west-2.kitt-inf.net/search?q=ReactSerializer.fromSchema&patternType=literal
    static fromSchema(_, init) {
        return new $571a3f7030782ba6$export$2e2bcd8739ae039(init);
    }
}

});
parcelRegister("eZEEl", function(module, exports) {

$parcel$export(module.exports, "isNestedHeaderLinksEnabled", () => $aea64b5c6b049543$export$7aa7587d1ce9583c);
$parcel$export(module.exports, "getActiveHeadingId", () => $aea64b5c6b049543$export$acb253d79d72af92);
function $aea64b5c6b049543$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $aea64b5c6b049543$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$aea64b5c6b049543$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}

});

parcelRegister("gxwLU", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $c0a9262d8411f215$export$aff6291803939b05);
$parcel$export(module.exports, "toReact", () => $c0a9262d8411f215$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $c0a9262d8411f215$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $c0a9262d8411f215$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $c0a9262d8411f215$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("5hYCz")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("5hYCz")).DocWithSelectAllTrap);

var $bYKiA = parcelRequire("bYKiA");

var $l08pU = parcelRequire("l08pU");

var $jABqZ = parcelRequire("jABqZ");

var $aVOeM = parcelRequire("aVOeM");

var $7ryQa = parcelRequire("7ryQa");

var $ajo9N = parcelRequire("ajo9N");

var $5hYCz = parcelRequire("5hYCz");

var $6aJhQ = parcelRequire("6aJhQ");

var $fk0uQ = parcelRequire("fk0uQ");

var $5vO2o = parcelRequire("5vO2o");

var $4kl5E = parcelRequire("4kl5E");

var $iaEgN = parcelRequire("iaEgN");

var $atpzT = parcelRequire("atpzT");

var $cTtzv = parcelRequire("cTtzv");

var $4Is5N = parcelRequire("4Is5N");

var $fx8Y0 = parcelRequire("fx8Y0");

var $lQW3Z = parcelRequire("lQW3Z");

var $6KEqm = parcelRequire("6KEqm");

var $1hBRe = parcelRequire("1hBRe");

var $hP4fj = parcelRequire("hP4fj");

var $flRb7 = parcelRequire("flRb7");

var $3CD47 = parcelRequire("3CD47");

var $73BN3 = parcelRequire("73BN3");

var $hlBr5 = parcelRequire("hlBr5");
var $hGalw = parcelRequire("hGalw");

const $c0a9262d8411f215$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("6XwU1")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("jSJB7")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("8kA34")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("02RS2")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("bdpD4")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("8xSQV")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("2fWAv")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("cmzNc")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("kRyfh")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("7XOTK")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("810Ux")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("55nMP")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("7ytxa")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("268Sm")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("ddRd2")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("2KyWm")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("hH8qh")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("971Of")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c0a9262d8411f215$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("4UGD7")).then((mod)=>mod.default),
    loading: ()=>null
});
const $c0a9262d8411f215$export$3931063f6a5f290e = {
    blockquote: (0, $l08pU.default),
    bulletList: (0, $ajo9N.default),
    blockCard: $c0a9262d8411f215$export$d18ccd25c0d2c6b0,
    caption: (0, $4Is5N.default),
    date: $c0a9262d8411f215$export$6341f9a885713487,
    decisionItem: $c0a9262d8411f215$export$b6f73a2b0b0de599,
    decisionList: $c0a9262d8411f215$export$b458dfa720128865,
    doc: (0, $5hYCz.default),
    emoji: $c0a9262d8411f215$export$56cc48506ff790a,
    extension: (0, $6aJhQ.default),
    bodiedExtension: (0, $jABqZ.default),
    multiBodiedExtension: (0, $aVOeM.default),
    extensionFrame: (0, $7ryQa.default),
    hardBreak: (0, $fk0uQ.default),
    heading: (0, $5vO2o.default),
    inlineCard: $c0a9262d8411f215$export$aff6291803939b05,
    inlineExtension: (0, $4kl5E.default),
    layoutSection: (0, $iaEgN.default),
    layoutColumn: (0, $atpzT.default),
    listItem: (0, $cTtzv.default),
    media: $c0a9262d8411f215$export$7fc53215244aec38,
    mediaGroup: $c0a9262d8411f215$export$d7858be3df00d59,
    mediaInline: $c0a9262d8411f215$export$462ea7c2a1c4cb1f,
    mediaSingle: $c0a9262d8411f215$export$888d74bc001c3a5d,
    mention: $c0a9262d8411f215$export$e891316fea657d90,
    orderedList: (0, $fx8Y0.default),
    panel: $c0a9262d8411f215$export$2ddb90ad54e5f587,
    paragraph: (0, $lQW3Z.default),
    placeholder: (0, $6KEqm.default),
    rule: (0, $1hBRe.default),
    status: $c0a9262d8411f215$export$96e9906d6d93a972,
    taskItem: $c0a9262d8411f215$export$27c4189b8be1bf93,
    taskList: $c0a9262d8411f215$export$771a55a10b0a40ae,
    table: (0, $hP4fj.default),
    tableCell: (0, $flRb7.TableCell),
    tableHeader: (0, $flRb7.TableHeader),
    tableRow: (0, $3CD47.default),
    unknownBlock: (0, $73BN3.default),
    unsupportedBlock: (0, $hlBr5.default),
    unsupportedInline: (0, $hGalw.default),
    expand: $c0a9262d8411f215$export$49bd1dfb0ad29c40,
    nestedExpand: $c0a9262d8411f215$export$49bd1dfb0ad29c40,
    embedCard: $c0a9262d8411f215$export$6789d7ecdc77631b
};
const $c0a9262d8411f215$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && (flags === null || flags === void 0 ? void 0 : flags.allowSelectAllTrap) === true) return 0, $5hYCz.DocWithSelectAllTrap;
    if (node.type.name === 'codeBlock') {
        if ((flags === null || flags === void 0 ? void 0 : flags.allowWindowedCodeBlock) === true) return $c0a9262d8411f215$export$a22ee8f907eecb5f;
        return $c0a9262d8411f215$export$6c415d1fdae3dfdb;
    }
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$c0a9262d8411f215$export$3931063f6a5f290e,
        ...nodeComponents
    };
    return nodes[node.type.name];
};
const $c0a9262d8411f215$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$c0a9262d8411f215$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $c0a9262d8411f215$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $c0a9262d8411f215$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $c0a9262d8411f215$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $c0a9262d8411f215$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
const $c0a9262d8411f215$var$whitespaceRegex = /^\s*$/;
const $c0a9262d8411f215$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $c0a9262d8411f215$var$isEmojiBlock(node.content);
};
const $c0a9262d8411f215$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($c0a9262d8411f215$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("l08pU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4a0207a17719ce4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $f4a0207a17719ce4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("blockquote", null, props.children);
}

});

parcelRegister("jABqZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e42e6aca7ecd97aa$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $6aJhQ = parcelRequire("6aJhQ");

var $8agsH = parcelRequire("8agsH");
const $e42e6aca7ecd97aa$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [] } = props;
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8agsH.default), (0, $kU09D.default)({}, props, {
        type: "bodiedExtension"
    }), ({ result: result })=>{
        try {
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
            return (0, $6aJhQ.renderExtension)(result, layout, {
                isTopLevel: path.length < 1
            }, removeOverflow);
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return (0, $6aJhQ.renderExtension)(children, layout, {
            isTopLevel: path.length < 1
        }, removeOverflow);
    });
};
var $e42e6aca7ecd97aa$export$2e2bcd8739ae039 = $e42e6aca7ecd97aa$var$BodiedExtension;

});
parcelRegister("6aJhQ", function(module, exports) {

$parcel$export(module.exports, "renderExtension", () => $47e6ce4550ec31e5$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $47e6ce4550ec31e5$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8agsH = parcelRequire("8agsH");

var $kRTSM = parcelRequire("kRTSM");
var $4IyMA = parcelRequire("4IyMA");

var $khES4 = parcelRequire("khES4");

var $h1C70 = parcelRequire("h1C70");
const $47e6ce4550ec31e5$export$b7482bdc8aff85e4 = (content, layout, options = {}, removeOverflow)=>{
    const overflowContainerClass = !removeOverflow ? (0, $h1C70.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true } = options || {};
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $h1C70.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4IyMA.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: options.handleRef,
            className: `${(0, $h1C70.RendererCssClassName).EXTENSION} ${options.shadowClassNames} ${centerAlignClass}`,
            style: {
                width: isTopLevel ? (0, $khES4.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: overflowContainerClass
        }, content)));
};
const $47e6ce4550ec31e5$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [] } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8agsH.default), (0, $kU09D.default)({}, props, {
        type: "extension"
    }), ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(result)) return $47e6ce4550ec31e5$export$b7482bdc8aff85e4(result, layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames
            });
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return $47e6ce4550ec31e5$export$b7482bdc8aff85e4(text || 'extension', layout, {
            isTopLevel: path.length < 1,
            handleRef: handleRef,
            shadowClassNames: shadowClassNames
        });
    });
};
var $47e6ce4550ec31e5$export$2e2bcd8739ae039 = (0, $kRTSM.default)($47e6ce4550ec31e5$var$Extension, {
    overflowSelector: `.${(0, $h1C70.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});

});
parcelRegister("8agsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f1c06e854f0faf7$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $490tW = parcelRequire("490tW");

var $7IzOS = parcelRequire("7IzOS");

var $jdHnI = parcelRequire("jdHnI");

var $XHGTv = parcelRequire("XHGTv");
const $5f1c06e854f0faf7$var$inlineExtensionStyle = (0, $byn9U.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
class $5f1c06e854f0faf7$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            extensionProvider: null
        });
        (0, $5zQU9.default)(this, "mounted", false);
        (0, $5zQU9.default)(this, "handleProvider", (name, providerPromise)=>{
            providerPromise && providerPromise.then((provider)=>{
                if (this.mounted) this.setState({
                    [name]: provider
                });
            });
        });
        (0, $5zQU9.default)(this, "getNodeRenderer", (0, $5iWql.default)((0, $490tW.getNodeRenderer)));
        (0, $5zQU9.default)(this, "renderExtensionNode", (extensionProvider)=>{
            var _marks$find, _marks$find$attrs;
            const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions } = this.props;
            const fragmentLocalId = marks === null || marks === void 0 ? void 0 : (_marks$find = marks.find((m)=>m.type.name === 'fragment')) === null || _marks$find === void 0 ? void 0 : (_marks$find$attrs = _marks$find.attrs) === null || _marks$find$attrs === void 0 ? void 0 : _marks$find$attrs.localId;
            const node = {
                type: type,
                extensionKey: extensionKey,
                extensionType: extensionType,
                parameters: parameters,
                content: content || text,
                localId: localId,
                fragmentLocalId: fragmentLocalId
            };
            let result = null;
            try {
                if (extensionHandlers && extensionHandlers[extensionType]) {
                    const render = (0, $jdHnI.getExtensionRenderer)(extensionHandlers[extensionType]);
                    result = render(node, rendererContext.adDoc);
                }
                if (!result && extensionProvider) {
                    const NodeRenderer = this.getNodeRenderer(extensionProvider, extensionType, extensionKey);
                    if (node.type === 'multiBodiedExtension') result = (0, $byn9U.jsx)(NodeRenderer, {
                        node: node,
                        actions: actions
                    });
                    else if (node.type === 'inlineExtension') result = (0, $byn9U.jsx)($5f1c06e854f0faf7$var$InlineNodeRendererWrapper, null, (0, $byn9U.jsx)(NodeRenderer, {
                        node: node
                    }));
                    else result = (0, $byn9U.jsx)(NodeRenderer, {
                        node: node
                    });
                }
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            return this.props.children({
                result: result
            });
        });
        (0, $5zQU9.default)(this, "setupAndRenderExtensionNode", (providers)=>{
            const { extensionProvider: extensionProvider } = this.state;
            if (!extensionProvider && providers.extensionProvider) this.handleProvider('extensionProvider', providers.extensionProvider);
            return this.renderExtensionNode(extensionProvider);
        });
    }
    UNSAFE_componentWillMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { providers: providers } = this.props;
        if (!providers) return this.setupAndRenderExtensionNode({});
        return (0, $byn9U.jsx)((0, $7IzOS.WithProviders), {
            providers: [
                'extensionProvider'
            ],
            providerFactory: providers,
            renderNode: this.setupAndRenderExtensionNode
        });
    }
}
const $5f1c06e854f0faf7$var$InlineNodeRendererWrapper = ({ children: children })=>{
    if ((0, $XHGTv.getBooleanFF)('platform.editor.inline_extension.extended_lcqdn')) return (0, $byn9U.jsx)("div", {
        className: "inline-extension-renderer",
        css: $5f1c06e854f0faf7$var$inlineExtensionStyle
    }, children);
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, children);
};

});
parcelRegister("490tW", function(module, exports) {

$parcel$export(module.exports, "getExtensionModuleNode", () => $3048606866f8d52d$export$82dd45c2db936caf);
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $3048606866f8d52d$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $3048606866f8d52d$export$67a7d49db68d30a0);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $bwpTX = parcelRequire("bwpTX");
async function $3048606866f8d52d$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $bwpTX.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $3048606866f8d52d$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $3048606866f8d52d$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $3048606866f8d52d$var$ExtensionLoading(props) {
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "Error loading the extension!");
    } else return null;
}
function $3048606866f8d52d$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>{
            return $3048606866f8d52d$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey).then((node)=>(0, $bwpTX.resolveImport)(node.render()));
        },
        loading: $3048606866f8d52d$var$ExtensionLoading
    });
}

});
parcelRegister("bwpTX", function(module, exports) {

$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $8636c6651a63b7c7$export$8a49818572e1d105);
$parcel$export(module.exports, "buildAction", () => $8636c6651a63b7c7$export$bb33bcdd9a10a608);
$parcel$export(module.exports, "resolveImport", () => $8636c6651a63b7c7$export$d69c9b451c47653b);
const $8636c6651a63b7c7$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $8636c6651a63b7c7$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $8636c6651a63b7c7$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
const $8636c6651a63b7c7$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
function $8636c6651a63b7c7$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $8636c6651a63b7c7$export$33863d887d6f4bfd(action, manifest);
}
const $8636c6651a63b7c7$export$d69c9b451c47653b = async (importPromise)=>{
    const importedModule = await importPromise;
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
function $8636c6651a63b7c7$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = $8636c6651a63b7c7$export$5f3eb042babacbbd(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}

});


parcelRegister("7IzOS", function(module, exports) {

$parcel$export(module.exports, "WithProviders", () => $59e86d83783ad0c3$export$d498ee8be33e096f);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");
class $59e86d83783ad0c3$export$d498ee8be33e096f extends (0, $eUqFw.PureComponent) {
    constructor(props){
        super(props);
        (0, $5zQU9.default)(this, "handleProvider", (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        });
        const _providers = {};
        this.props.providers.forEach((name)=>{
            _providers[name] = undefined;
        });
        this.state = {
            providers: _providers
        };
    }
    UNSAFE_componentWillMount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.subscribe(name, this.handleProvider);
        });
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProvider);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
}
(0, $5zQU9.default)($59e86d83783ad0c3$export$d498ee8be33e096f, "displayName", 'WithProviders');

});

parcelRegister("jdHnI", function(module, exports) {

$parcel$export(module.exports, "getExtensionRenderer", () => $dfe0e1e7b2a1ae82$export$9214452ef07eda7);
function $dfe0e1e7b2a1ae82$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("kRTSM", function(module, exports) {

$parcel$export(module.exports, "shadowClassNames", () => $f3141b02d2dc2bd5$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $f3141b02d2dc2bd5$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $cEslD = parcelRequire("cEslD");
const $f3141b02d2dc2bd5$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $f3141b02d2dc2bd5$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        constructor(...args){
            super(...args);
            (0, $5zQU9.default)(this, "overflowContainerWidth", 0);
            (0, $5zQU9.default)(this, "state", {
                showLeftShadow: false,
                showRightShadow: false
            });
            (0, $5zQU9.default)(this, "handleScroll", (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            });
            (0, $5zQU9.default)(this, "updateShadows", ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            });
            (0, $5zQU9.default)(this, "showLeftShadow", (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            });
            (0, $5zQU9.default)(this, "calcOverflowDiff", ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            });
            (0, $5zQU9.default)(this, "calcScrollableWidth", ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    const scrollableElement = this.scrollable[i];
                    width += scrollableElement.scrollWidth;
                }
                return width;
            });
            (0, $5zQU9.default)(this, "handleContainer", (container)=>{
                if (!container || this.container) return;
                this.container = container;
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            });
        }
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $cEslD.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            let classNames = [
                showRightShadow && $f3141b02d2dc2bd5$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                showLeftShadow && $f3141b02d2dc2bd5$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $cEslD.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, (0, $kU09D.default)({
                handleRef: this.handleContainer,
                shadowClassNames: classNames
            }, this.props));
        }
    };
}

});
parcelRegister("cEslD", function(module, exports) {

$parcel$export(module.exports, "shadowObserverClassNames", () => $935f35c6a3649eac$export$1cbe0bb16052178d);
$parcel$export(module.exports, "ShadowObserver", () => $935f35c6a3649eac$export$51a5b28e4fb2dba2);

var $5zQU9 = parcelRequire("5zQU9");
let $935f35c6a3649eac$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});
const $935f35c6a3649eac$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $935f35c6a3649eac$var$requestIdleCallback = (fn)=>{
    return window.requestIdleCallback ? window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $935f35c6a3649eac$var$cancelIdleCallback = (id)=>{
    return window.cancelIdleCallback ? window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $935f35c6a3649eac$export$51a5b28e4fb2dba2 {
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        (0, $5zQU9.default)(this, "sentinels", {});
        (0, $5zQU9.default)(this, "shadowStates", {
            [$935f35c6a3649eac$export$ebeea2fe2e93862e.SHOW_LEFT_SHADOW]: false,
            [$935f35c6a3649eac$export$ebeea2fe2e93862e.SHOW_RIGHT_SHADOW]: false
        });
        (0, $5zQU9.default)(this, "init", ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add($935f35c6a3649eac$export$1cbe0bb16052178d.SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add($935f35c6a3649eac$export$1cbe0bb16052178d.SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        });
        (0, $5zQU9.default)(this, "onIntersect", (entry)=>{
            this.requestCallbackId = $935f35c6a3649eac$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains($935f35c6a3649eac$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates[$935f35c6a3649eac$export$ebeea2fe2e93862e.SHOW_LEFT_SHADOW] = !entry.isIntersecting;
                if (entry.target.classList.contains($935f35c6a3649eac$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates[$935f35c6a3649eac$export$ebeea2fe2e93862e.SHOW_RIGHT_SHADOW] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        });
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $935f35c6a3649eac$var$cancelIdleCallback(this.requestCallbackId);
        }
    }
}

});


parcelRegister("khES4", function(module, exports) {

$parcel$export(module.exports, "breakoutConsts", () => $ec45195034949b79$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $ec45195034949b79$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $ec45195034949b79$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $ec45195034949b79$export$5f4502874a28dfce);
$parcel$export(module.exports, "calculateBreakoutStyles", () => $ec45195034949b79$export$c377853ecdd53e5b);
$parcel$export(module.exports, "calcBreakoutWidthPx", () => $ec45195034949b79$export$586300c53bd298dd);
$parcel$export(module.exports, "getNextBreakoutMode", () => $ec45195034949b79$export$7eb758567e6644fd);
$parcel$export(module.exports, "getTitle", () => $ec45195034949b79$export$70d1bf7729efff40);

var $25FYC = parcelRequire("25FYC");

var $7tH17 = parcelRequire("7tH17");

var $eNUIj = parcelRequire("eNUIj");

var $4IyMA = parcelRequire("4IyMA");

var $ahtjn = parcelRequire("ahtjn");
/**
 * Variables required to construct a context for breakout ssr inline script.
 *
 * TODO: Clean this up after: https://product-fabric.atlassian.net/browse/ED-8942
 *
 */ const $ec45195034949b79$export$ead1fecec2ecf57c = {
    padding: (0, $25FYC.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $25FYC.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $25FYC.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $25FYC.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $25FYC.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $eNUIj.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $4IyMA.getBreakpoint,
    /**
   * This function can return percentage value or px value depending upon the inputs
   */ calcBreakoutWidth: (layout, containerWidth)=>{
        const effectiveFullWidth = containerWidth - $ec45195034949b79$export$ead1fecec2ecf57c.padding;
        switch(layout){
            case 'full-width':
                return `${Math.min(effectiveFullWidth, $ec45195034949b79$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
            case 'wide':
                if (effectiveFullWidth <= 0) return '100%';
                let wideWidth = $ec45195034949b79$export$ead1fecec2ecf57c.calcWideWidth(containerWidth);
                if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, $ec45195034949b79$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
                return wideWidth;
            default:
                return '100%';
        }
    },
    calcLineLength: ()=>$ec45195034949b79$export$ead1fecec2ecf57c.defaultLayoutWidth,
    calcWideWidth: (containerWidth = $ec45195034949b79$export$ead1fecec2ecf57c.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%')=>{
        const effectiveFullWidth = containerWidth - $ec45195034949b79$export$ead1fecec2ecf57c.padding;
        const layoutMaxWidth = $ec45195034949b79$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($ec45195034949b79$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
        const wideWidth = Math.min(Math.ceil(layoutMaxWidth * $ec45195034949b79$export$ead1fecec2ecf57c.wideScaleRatio), effectiveFullWidth);
        return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
    }
};
const $ec45195034949b79$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $ec45195034949b79$export$ead1fecec2ecf57c.calcBreakoutWidth(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $25FYC.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $25FYC.akEditorWideLayoutWidth;
        default:
            return $ec45195034949b79$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($ec45195034949b79$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $ec45195034949b79$export$86325001fe8f3adc = $ec45195034949b79$export$ead1fecec2ecf57c.calcWideWidth;
const $ec45195034949b79$export$5f4502874a28dfce = $ec45195034949b79$export$ead1fecec2ecf57c.calcBreakoutWidth;
function $ec45195034949b79$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $ec45195034949b79$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $ahtjn.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $25FYC.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $25FYC.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $ec45195034949b79$export$586300c53bd298dd(mode, widthStateWidth) {
    return (0, $ahtjn.parsePx)($ec45195034949b79$export$5f4502874a28dfce(mode, widthStateWidth));
}
const $ec45195034949b79$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
const $ec45195034949b79$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $7tH17.default).layoutFixedWidth;
        case 'wide':
            return (0, $7tH17.default).layoutFullWidth;
        default:
            return (0, $7tH17.default).layoutWide;
    }
};

});
parcelRegister("7tH17", function(module, exports) {

$parcel$export(module.exports, "default", () => $571c9c1b9f168d0d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");

var $gpz72 = parcelRequire("gpz72");

var $cZkrP = parcelRequire("cZkrP");

var $18od4 = parcelRequire("18od4");

var $8VFoC = parcelRequire("8VFoC");

var $4lH1I = parcelRequire("4lH1I");

var $7dsAq = parcelRequire("7dsAq");


var $f7L5C = parcelRequire("f7L5C");

var $61k7f = parcelRequire("61k7f");

var $fqvta = parcelRequire("fqvta");

var $6XOmD = parcelRequire("6XOmD");

var $iMRk5 = parcelRequire("iMRk5");

var $6ajMH = parcelRequire("6ajMH");

var $3Odey = parcelRequire("3Odey");

var $4i5ge = parcelRequire("4i5ge");

var $kKFSL = parcelRequire("kKFSL");

var $5jm2N = parcelRequire("5jm2N");

var $8oilI = parcelRequire("8oilI");

var $1UatT = parcelRequire("1UatT");

var $2EAKE = parcelRequire("2EAKE");

var $4bNzh = parcelRequire("4bNzh");

var $jaD5g = parcelRequire("jaD5g");

var $jzEox = parcelRequire("jzEox");

var $gYbUs = parcelRequire("gYbUs");

var $i8NAO = parcelRequire("i8NAO");

var $7QKsQ = parcelRequire("7QKsQ");

var $3VZtb = parcelRequire("3VZtb");

var $60orz = parcelRequire("60orz");

var $3y99E = parcelRequire("3y99E");
var $571c9c1b9f168d0d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    layoutFixedWidth: {
        id: 'fabric.editor.layoutFixedWidth',
        defaultMessage: 'Back to center',
        description: 'Display your element (image, table, extension, etc) as standard width'
    },
    layoutWide: {
        id: 'fabric.editor.layoutWide',
        defaultMessage: 'Go wide',
        description: 'Display your element (image, table, extension, etc) wider than normal'
    },
    layoutFullWidth: {
        id: 'fabric.editor.layoutFullWidth',
        defaultMessage: 'Go full width',
        description: 'Display your element (image, table, extension, etc) as full width'
    },
    alignImageRight: {
        id: 'fabric.editor.alignImageRight',
        defaultMessage: 'Align right',
        description: 'Aligns image to the right'
    },
    alignImageCenter: {
        id: 'fabric.editor.alignImageCenter',
        defaultMessage: 'Align center',
        description: 'Aligns image to the center'
    },
    alignImageLeft: {
        id: 'fabric.editor.alignImageLeft',
        defaultMessage: 'Align left',
        description: 'Aligns image to the left'
    },
    remove: {
        id: 'fabric.editor.remove',
        defaultMessage: 'Remove',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    removeEmoji: {
        id: 'fabric.editor.removeEmoji',
        defaultMessage: 'Remove emoji',
        description: 'Remove the emoji panel icon from custom panel'
    },
    visit: {
        id: 'fabric.editor.visit',
        defaultMessage: 'Open link in a new window',
        description: 'Open the link in a new window'
    },
    inviteToEditButtonTitle: {
        id: 'fabric.editor.editMode.inviteToEditButton.title',
        defaultMessage: 'Invite to edit',
        description: 'Invite another user to edit the current document'
    },
    saveButton: {
        id: 'fabric.editor.saveButton',
        defaultMessage: 'Save',
        description: 'Submit and save a comment or document'
    },
    cancelButton: {
        id: 'fabric.editor.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Discard the current comment or document'
    },
    taskList: {
        id: 'fabric.editor.tooltip.taskList',
        defaultMessage: 'an action item',
        description: 'an action item in the Editor'
    },
    bulletList: {
        id: 'fabric.editor.tooltip.bulletList',
        defaultMessage: 'a list',
        description: 'a list item in the Editor'
    },
    nestedExpand: {
        id: 'fabric.editor.tooltip.nestedExpand',
        defaultMessage: 'a nested expand',
        description: 'expand node which is nested'
    },
    decisionList: {
        id: 'fabric.editor.tooltip.decisionList',
        defaultMessage: 'a decision list',
        description: 'a list of decisions'
    },
    defaultBlockNode: {
        id: 'fabric.editor.tooltip.defaultBlockNode',
        defaultMessage: 'a block node',
        description: 'a block node element'
    },
    panel: {
        id: 'fabric.editor.tooltip.blockPanel',
        defaultMessage: 'a panel',
        description: 'Panel node in the Editor'
    },
    blockquote: {
        id: 'fabric.editor.blockquote',
        defaultMessage: 'a quote',
        description: 'a quote node'
    },
    timeUpdated: {
        id: 'fabric.editor.time.updated',
        defaultMessage: 'Updated',
        description: 'Time last updated'
    },
    timeViewed: {
        id: 'fabric.editor.time.viewed',
        defaultMessage: 'Viewed',
        description: 'Time last viewed'
    },
    timeAgo: {
        id: 'fabric.editor.time.ago',
        defaultMessage: 'ago',
        description: 'Some time ago'
    },
    copyToClipboard: {
        id: 'fabric.editor.copyToClipboard',
        defaultMessage: 'Copy',
        description: 'Copy the whole content of the element to your clipboard'
    },
    copiedToClipboard: {
        id: 'fabric.editor.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the whole content of the element to clipboard'
    }
});

});
parcelRegister("gpz72", function(module, exports) {

$parcel$export(module.exports, "alignmentMessages", () => $bf2a37c4d2d8fd8b$export$5229ffea355cfdf6);

var $90IgZ = parcelRequire("90IgZ");
const $bf2a37c4d2d8fd8b$export$5229ffea355cfdf6 = (0, $90IgZ.defineMessages)({
    alignment: {
        id: 'fabric.editor.alignment',
        defaultMessage: 'Text alignment',
        description: 'Opens drop down menu of options to configure text alignment'
    },
    alignLeft: {
        id: 'fabric.editor.alignLeft',
        defaultMessage: 'Align left',
        description: 'label stating that text is aligned left'
    },
    alignCenter: {
        id: 'fabric.editor.alignCenter',
        defaultMessage: 'Align center',
        description: 'label stating that text is aligned center'
    },
    alignRight: {
        id: 'fabric.editor.alignRight',
        defaultMessage: 'Align right',
        description: 'label stating that text is aligned right'
    }
});

});

parcelRegister("cZkrP", function(module, exports) {

$parcel$export(module.exports, "annotationMessages", () => $974b0b1460b63355$export$ff612ca71703201d);

var $90IgZ = parcelRequire("90IgZ");
const $974b0b1460b63355$export$ff612ca71703201d = (0, $90IgZ.defineMessages)({
    createComment: {
        id: 'fabric.editor.createComment',
        defaultMessage: 'Comment',
        description: 'Create/add an inline comment based on the users selection'
    },
    createCommentInvalid: {
        id: 'fabric.editor.createCommentInvalid',
        defaultMessage: 'You can only comment on text and headings',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    toolbar: {
        id: 'fabric.editor.annotationToolbar',
        defaultMessage: 'Annotation toolbar',
        description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
    }
});

});

parcelRegister("18od4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0d39515e83ec05b5$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $0d39515e83ec05b5$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    normal: {
        id: 'fabric.editor.normal',
        defaultMessage: 'Normal text',
        description: 'This is the default text style'
    },
    heading1: {
        id: 'fabric.editor.heading1',
        defaultMessage: 'Heading 1',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading1Description: {
        id: 'fabric.editor.heading1Description',
        defaultMessage: 'Use this for a top level heading',
        description: 'Description of the main heading, heading 1'
    },
    heading2: {
        id: 'fabric.editor.heading2',
        defaultMessage: 'Heading 2',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading2Description: {
        id: 'fabric.editor.heading2Description',
        defaultMessage: 'Use this for key sections',
        description: 'Description of a subtitle heading or secondary heading'
    },
    heading3: {
        id: 'fabric.editor.heading3',
        defaultMessage: 'Heading 3',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading3Description: {
        id: 'fabric.editor.heading3Description',
        defaultMessage: 'Use this for sub sections and group headings',
        description: ''
    },
    heading4: {
        id: 'fabric.editor.heading4',
        defaultMessage: 'Heading 4',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading4Description: {
        id: 'fabric.editor.heading4Description',
        defaultMessage: 'Use this for deep headings',
        description: ''
    },
    heading5: {
        id: 'fabric.editor.heading5',
        defaultMessage: 'Heading 5',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading5Description: {
        id: 'fabric.editor.heading5Description',
        defaultMessage: 'Use this for grouping list items',
        description: ''
    },
    heading6: {
        id: 'fabric.editor.heading6',
        defaultMessage: 'Heading 6',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading6Description: {
        id: 'fabric.editor.heading6Description',
        defaultMessage: 'Use this for low level headings',
        description: ''
    },
    blockquote: {
        id: 'fabric.editor.blockquote2',
        defaultMessage: 'Quote',
        description: 'Quote some text'
    },
    blockquoteDescription: {
        id: 'fabric.editor.blockquote.description',
        defaultMessage: 'Insert a quote or citation',
        description: 'Quote some text'
    },
    codeblock: {
        id: 'fabric.editor.codeblock',
        defaultMessage: 'Code snippet',
        description: 'Insert a snippet/segment of code (code block)'
    },
    codeblockDescription: {
        id: 'fabric.editor.codeblock.description',
        defaultMessage: 'Display code with syntax highlighting',
        description: 'Insert a snippet/segment of code (code block)'
    },
    infoPanel: {
        id: 'fabric.editor.infoPanel',
        defaultMessage: 'Info panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    infoPanelDescription: {
        id: 'fabric.editor.infoPanel.description',
        defaultMessage: 'Highlight information in a colored panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    notePanel: {
        id: 'fabric.editor.notePanel',
        defaultMessage: 'Note panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    notePanelDescription: {
        id: 'fabric.editor.notePanel.description',
        defaultMessage: 'Add a note in a colored panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    successPanel: {
        id: 'fabric.editor.successPanel',
        defaultMessage: 'Success panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    successPanelDescription: {
        id: 'fabric.editor.successPanel.description',
        defaultMessage: 'Add tips in a colored panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    warningPanel: {
        id: 'fabric.editor.warningPanel',
        defaultMessage: 'Warning panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    warningPanelDescription: {
        id: 'fabric.editor.warningPanel.description',
        defaultMessage: 'Add a note of caution in a colored panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    errorPanel: {
        id: 'fabric.editor.errorPanel',
        defaultMessage: 'Error panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    errorPanelDescription: {
        id: 'fabric.editor.errorPanel.description',
        defaultMessage: 'Call out errors in a colored panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    customPanel: {
        id: 'fabric.editor.customPanel',
        defaultMessage: 'Custom panel',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color'
    },
    customPanelDescription: {
        id: 'fabric.editor.customPanel.description',
        defaultMessage: 'Add a note with an emoji and colored background',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color '
    },
    other: {
        id: 'fabric.editor.other',
        defaultMessage: 'Others...',
        description: 'Other text formatting'
    }
});

});

parcelRegister("8VFoC", function(module, exports) {

$parcel$export(module.exports, "codeBidiWarningMessages", () => $6803c201c708adea$export$42bb270d1224182);

var $90IgZ = parcelRequire("90IgZ");
const $6803c201c708adea$export$42bb270d1224182 = (0, $90IgZ.defineMessages)({
    /**
   * Message taken from
   * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
   */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});

parcelRegister("4lH1I", function(module, exports) {

$parcel$export(module.exports, "linkMessages", () => $32aa7fc9d5d4b6b7$export$4ce3884394d6d9);

var $90IgZ = parcelRequire("90IgZ");
const $32aa7fc9d5d4b6b7$export$4ce3884394d6d9 = (0, $90IgZ.defineMessages)({
    openLink: {
        id: 'fabric.editor.openLink',
        defaultMessage: 'Open link in a new tab',
        description: 'Opens the link in a new tab'
    }
});

});

parcelRegister("7dsAq", function(module, exports) {

$parcel$export(module.exports, "linkToolbarMessages", () => $540fec018640abf6$export$2d7676d841c8ae9);

var $90IgZ = parcelRequire("90IgZ");
const $540fec018640abf6$export$2d7676d841c8ae9 = (0, $90IgZ.defineMessages)({
    addLink: {
        id: 'fabric.editor.mediaAddLink',
        defaultMessage: 'Add link',
        description: 'Add link'
    },
    unableToOpenLink: {
        id: 'fabric.editor.unableToOpenLink',
        defaultMessage: 'Unable to open this link',
        description: 'Unable to open this link'
    },
    unlink: {
        id: 'fabric.editor.unlink',
        defaultMessage: 'Unlink',
        description: 'Removes the hyperlink but keeps your text.'
    },
    editLink: {
        id: 'fabric.editor.editLink',
        defaultMessage: 'Edit link',
        description: 'Edit the link, update display text'
    },
    placeholder: {
        id: 'fabric.editor.hyperlinkToolbarPlaceholder',
        defaultMessage: 'Paste or search for link',
        description: 'Paste or search for link'
    },
    linkPlaceholder: {
        id: 'fabric.editor.linkPlaceholder',
        defaultMessage: 'Paste link',
        description: 'Create a new link by pasting a URL.'
    },
    linkAddress: {
        id: 'fabric.editor.linkAddress',
        defaultMessage: 'Link address',
        description: 'Insert the address of the link'
    },
    invalidLink: {
        id: 'fabric.editor.invalidLink',
        defaultMessage: 'Please enter a valid link.',
        description: 'Please enter a valid link.'
    },
    emptyLink: {
        id: 'fabric.editor.emptyLink',
        defaultMessage: 'Please enter a link.',
        description: 'Please enter a link.'
    },
    settingsLink: {
        id: 'fabric.editor.settingsLinks',
        defaultMessage: 'Go to Link Preferences',
        description: 'Go to Link Preferences'
    },
    editDatasource: {
        id: 'fabric.editor.edit.datasource',
        defaultMessage: 'Edit search query',
        description: 'Datasource toolbar edit button'
    },
    searchInput: {
        id: 'fabric.editor.edit.searchInput',
        defaultMessage: 'Add a link',
        description: 'Label for the search media input'
    }
});

});

parcelRegister("f7L5C", function(module, exports) {

$parcel$export(module.exports, "codeBlockButtonMessages", () => $b02c097e336c1b4f$export$74e304339778e94d);

var $90IgZ = parcelRequire("90IgZ");
const $b02c097e336c1b4f$export$74e304339778e94d = (0, $90IgZ.defineMessages)({
    copyCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
        defaultMessage: 'Copy as text',
        description: 'Copy the content of the code block as text to your clipboard'
    },
    copiedCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the content of the code block as text to clipboard'
    },
    wrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
        defaultMessage: 'Turn on wrap',
        description: 'Wrap the content of the code block'
    },
    unwrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
        defaultMessage: 'Turn off wrap',
        description: 'Wrap the content of the code block'
    },
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
    }
});

});

parcelRegister("61k7f", function(module, exports) {

$parcel$export(module.exports, "toolbarInsertBlockMessages", () => $462270ada24dae94$export$70c8a7203d95247);

var $90IgZ = parcelRequire("90IgZ");
const $462270ada24dae94$export$70c8a7203d95247 = (0, $90IgZ.defineMessages)({
    action: {
        id: 'fabric.editor.action',
        defaultMessage: 'Action item',
        description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
    },
    actionDescription: {
        id: 'fabric.editor.action.description',
        defaultMessage: 'Create and assign action items',
        description: ''
    },
    link: {
        id: 'fabric.editor.link',
        defaultMessage: 'Link',
        description: 'Insert a hyperlink'
    },
    linkDescription: {
        id: 'fabric.editor.link.description',
        defaultMessage: 'Insert a link',
        description: 'Insert a hyperlink'
    },
    mediaFiles: {
        id: 'fabric.editor.mediaFiles',
        defaultMessage: 'Image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    addMediaFiles: {
        id: 'fabric.editor.addMediaFiles',
        defaultMessage: 'Add image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    mediaFilesDescription: {
        id: 'fabric.editor.mediaFiles.description',
        defaultMessage: 'Add images and other files to your page',
        description: 'Insert one or more files or images'
    },
    image: {
        id: 'fabric.editor.image',
        defaultMessage: 'Image',
        description: 'Insert an image.'
    },
    mention: {
        id: 'fabric.editor.mention',
        defaultMessage: 'Mention',
        description: 'Reference another person in your document'
    },
    mentionDescription: {
        id: 'fabric.editor.mention.description',
        defaultMessage: 'Mention someone to send them a notification',
        description: 'Reference another person in your document'
    },
    emoji: {
        id: 'fabric.editor.emoji',
        defaultMessage: 'Emoji',
        description: 'Insert an emoticon or smiley :-)'
    },
    emojiDescription: {
        id: 'fabric.editor.emoji.description',
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
        description: 'Insert an emoticon or smiley :-)'
    },
    table: {
        id: 'fabric.editor.table',
        defaultMessage: 'Table',
        description: 'Inserts a table in the document'
    },
    tableDescription: {
        id: 'fabric.editor.table.description',
        defaultMessage: 'Insert a table',
        description: 'Inserts a table in the document'
    },
    tableSelector: {
        id: 'fabric.editor.tableSelector',
        defaultMessage: 'Table size',
        description: 'Opens a table selector that lets you insert a table of custom size'
    },
    tableSelectorDescription: {
        id: 'fabric.editor.tableSelector.description',
        defaultMessage: 'Add a table using popup to select a custom size',
        description: 'Opens a table selector that lets you insert a table of a custom size'
    },
    tableSizeSelectorButton: {
        id: 'fabric.editor.tableSizeSelectorButton',
        defaultMessage: '{numberOfColumns} by {numberOfRows}',
        description: 'Creates a table of custom size'
    },
    tableSizeSelectorPopup: {
        id: 'fabric.editor.tableSizeSelectorPopup',
        defaultMessage: 'Table size selector',
        description: 'Table selector popup to create table of custom size'
    },
    expand: {
        id: 'fabric.editor.expand',
        defaultMessage: 'Expand',
        description: 'Inserts an expand in the document'
    },
    expandDescription: {
        id: 'fabric.editor.expand.description',
        defaultMessage: 'Insert an expand',
        description: 'Inserts an expand in the document'
    },
    decision: {
        id: 'fabric.editor.decision',
        defaultMessage: 'Decision',
        description: "Capture a decision you\u2019ve made"
    },
    decisionDescription: {
        id: 'fabric.editor.decision.description',
        defaultMessage: "Capture decisions so they\u2019re easy to track",
        description: "Capture a decision you\u2019ve made"
    },
    feedbackDialog: {
        id: 'fabric.editor.feedbackDialog',
        defaultMessage: 'Give feedback',
        description: 'Open the feedback dialog from editor'
    },
    feedbackDialogDescription: {
        id: 'fabric.editor.feedbackDialog.description',
        defaultMessage: 'Tell us about your experience using the new editor',
        description: 'Description for feedback option under quick insert dropdown'
    },
    horizontalRule: {
        id: 'fabric.editor.horizontalRule',
        defaultMessage: 'Divider',
        description: 'A horizontal rule or divider'
    },
    horizontalRuleDescription: {
        id: 'fabric.editor.horizontalRule.description',
        defaultMessage: 'Separate content with a horizontal line',
        description: 'A horizontal rule or divider'
    },
    date: {
        id: 'fabric.editor.date',
        defaultMessage: 'Date',
        description: 'Opens a date picker that lets you select a date'
    },
    dateDescription: {
        id: 'fabric.editor.date.description',
        defaultMessage: 'Add a date using a calendar',
        description: 'Opens a date picker that lets you select a date'
    },
    placeholderText: {
        id: 'fabric.editor.placeholderText',
        defaultMessage: 'Placeholder text',
        description: 'Inserts a text placeholder into the page'
    },
    placeholderTextDescription: {
        id: 'fabric.editor.placeholderText.description',
        defaultMessage: 'Insert a text placeholder into the page',
        description: 'Inserts a text placeholder into the page'
    },
    columns: {
        id: 'fabric.editor.columns',
        defaultMessage: 'Layouts',
        description: 'Create a multi column section or layout'
    },
    columnsDescription: {
        id: 'fabric.editor.columns.description',
        defaultMessage: 'Structure your page using sections',
        description: 'Create a multi column section or layout'
    },
    status: {
        id: 'fabric.editor.status',
        defaultMessage: 'Status',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    statusDescription: {
        id: 'fabric.editor.status.description',
        defaultMessage: 'Add a custom status label',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    viewMore: {
        id: 'fabric.editor.viewMore',
        defaultMessage: 'View more',
        description: ''
    },
    insertMenu: {
        id: 'fabric.editor.insertMenu',
        defaultMessage: 'Insert elements',
        description: 'Opens a menu of additional items that can be inserted into your document.'
    },
    help: {
        id: 'fabric.editor.help',
        defaultMessage: 'Help',
        description: 'Opens up the help dialog'
    },
    helpDescription: {
        id: 'fabric.editor.help.description',
        defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
        description: 'Browse all the keyboard shortcuts and markdown options'
    },
    recordVideo: {
        id: 'fabric.editor.recordVideo',
        defaultMessage: 'Record video',
        description: 'Record video using Loom'
    },
    recordVideoDescription: {
        id: 'fabric.editor.recordVideo.description',
        defaultMessage: 'Record video using Loom',
        description: 'Record video using Loom'
    }
});

});

parcelRegister("fqvta", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $b3b1b1e4c7fff1f6$export$81b075fd34c2f0bb);

var $90IgZ = parcelRequire("90IgZ");
const $b3b1b1e4c7fff1f6$export$81b075fd34c2f0bb = (0, $90IgZ.defineMessages)({
    wrapLeft: {
        id: 'fabric.editor.wrapLeft',
        defaultMessage: 'Wrap left',
        description: 'Aligns your image to the left and wraps text around it.'
    },
    wrapRight: {
        id: 'fabric.editor.wrapRight',
        defaultMessage: 'Wrap right',
        description: 'Aligns your image to the right and wraps text around it.'
    },
    changeToMediaSingle: {
        id: 'fabric.editor.media_change_mediasingle',
        defaultMessage: 'Original size',
        description: 'In the context of a media inline image, it allows the user to convert it to media single'
    },
    changeToMediaInlineImage: {
        id: 'fabric.editor.media_change_mediainline_default',
        defaultMessage: 'Inline',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
    },
    changeToMediaInlineImageCaptionWarning: {
        id: 'fabric.editor.media_change_mediainline_caption_warn',
        defaultMessage: 'Inline (caption will be removed)',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
    }
});

});

parcelRegister("6XOmD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $511f5200df1a9d6f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $511f5200df1a9d6f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    url: {
        id: 'fabric.editor.url',
        defaultMessage: 'Display URL',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    block: {
        id: 'fabric.editor.displayBlock',
        defaultMessage: 'Display card',
        description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
    },
    inline: {
        id: 'fabric.editor.displayInline',
        defaultMessage: 'Display inline',
        description: 'Display link with the title only.'
    },
    embed: {
        id: 'fabric.editor.displayEmbed',
        defaultMessage: 'Display embed',
        description: 'Display link as an embedded object'
    },
    link: {
        id: 'fabric.editor.displayLink',
        defaultMessage: 'Display as text',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    card: {
        id: 'fabric.editor.cardFloatingControls',
        defaultMessage: 'Card options',
        description: 'Options to change card type'
    },
    blockCardUnavailable: {
        id: 'fabric.editor.blockCardUnavailable',
        defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
        description: 'Warning message to show the user that this node cannot change its view'
    },
    displayOptionUnavailableInParentNode: {
        id: 'fabric.editor.displayOptionUnavailableInParentNode',
        defaultMessage: "This display option isn't available inside {node}",
        description: 'Warning message to show the user that this node option is not available inside a parent node type'
    },
    urlTitle: {
        id: 'fabric.editor.urlTitle',
        defaultMessage: 'URL',
        description: 'Title for option to convert the card to become a regular text-based hyperlink.'
    },
    blockTitle: {
        id: 'fabric.editor.blockTitle',
        defaultMessage: 'Card',
        description: 'Title for option to display link in the card view.'
    },
    inlineTitle: {
        id: 'fabric.editor.inlineTitle',
        defaultMessage: 'Inline',
        description: 'Title for option to display link in the inline view.'
    },
    embedTitle: {
        id: 'fabric.editor.embedTitle',
        defaultMessage: 'Embed',
        description: 'Title for option to display link as an embedded object.'
    },
    urlDescription: {
        id: 'fabric.editor.urlDescription',
        defaultMessage: 'Display link as URL',
        description: 'Description for option to convert the card to become a regular text-based hyperlink.'
    },
    blockDescription: {
        id: 'fabric.editor.blockDescription',
        defaultMessage: 'Display more information about a link, including a summary and actions',
        description: 'Description for option to display link in the card view.'
    },
    inlineDescription: {
        id: 'fabric.editor.inlineDescription',
        defaultMessage: 'Display link as inline text',
        description: 'Description for option to display link in the inline view.'
    },
    embedDescription: {
        id: 'fabric.editor.ecombedDescription',
        defaultMessage: 'Display an interactive preview of a link',
        description: 'Description for option to display link as an embedded object.'
    },
    datasourceTitle: {
        id: 'fabric.editor.datasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Tooltip of button to edit a card into a datasource'
    },
    datasourceAppearanceTitle: {
        id: 'fabric.editor.datasourceAppearanceTitle',
        defaultMessage: 'List',
        description: 'Tooltip of button to change to datasource appearance'
    },
    datasourceJiraIssue: {
        id: 'fabric.editor.datasource.jiraIssue',
        defaultMessage: 'Jira Issues',
        description: 'Insert a jira datasource table'
    },
    datasourceJiraIssueDescription: {
        id: 'fabric.editor.datasource.jiraIssue.description',
        defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table'
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
        defaultMessage: 'Assets',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
    },
    datasourceAssetsObjects: {
        id: 'fabric.editor.datasource.assetsObjects',
        defaultMessage: 'Assets (Beta)',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects. This feature is currently in Beta release, so we also include messaging for that.'
    },
    datasourceAssetsObjectsDescription: {
        id: 'fabric.editor.datasource.assetsObjects.description',
        defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
    },
    inlineOverlay: {
        id: 'fabric.editor.inlineOverlay',
        defaultMessage: 'Configure',
        description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
    }
});

});

parcelRegister("iMRk5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dad6128bc0cbeeb1$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $dad6128bc0cbeeb1$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    toolbarLabel: {
        id: 'fabric.editor.toolbarLabel',
        defaultMessage: 'Editor',
        description: 'Label for the ARIA region landmark'
    },
    pageActionsLabel: {
        id: 'fabric.editor.pageActionsLabel',
        defaultMessage: 'Page actions',
        description: 'Label for the ARIA region landmark'
    },
    editableContentLabel: {
        id: 'fabric.editor.editableContentLabel',
        defaultMessage: 'Editable content',
        description: 'Label for the ARIA region landmark'
    }
});

});

parcelRegister("6ajMH", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $47d30606e9f88ac4$export$81b075fd34c2f0bb);

var $90IgZ = parcelRequire("90IgZ");
const $47d30606e9f88ac4$export$81b075fd34c2f0bb = (0, $90IgZ.defineMessages)({
    underline: {
        id: 'fabric.editor.underline',
        defaultMessage: 'Underline',
        description: 'Whether the text selection has underlined text'
    },
    strike: {
        id: 'fabric.editor.strike',
        defaultMessage: 'Strikethrough',
        description: 'Whether the text selection has crossed out text'
    },
    code: {
        id: 'fabric.editor.code',
        defaultMessage: 'Code',
        description: 'Whether the text selection has monospaced/code font'
    },
    codeOn: {
        id: 'fabric.editor.code.on',
        defaultMessage: '{textFormattingOff}, Code On',
        description: 'Reports that code formatting has been turned on'
    },
    subscript: {
        id: 'fabric.editor.subscript',
        defaultMessage: 'Subscript',
        description: 'Whether the text selection is written below the line in a slightly smaller size'
    },
    subscriptOffSuperscriptOn: {
        id: 'fabric.editor.subscript.off.superscript.on',
        defaultMessage: 'Subscript Off, Superscript On',
        description: 'Reports text formatting in case when subscript off and superscript on'
    },
    superscript: {
        id: 'fabric.editor.superscript',
        defaultMessage: 'Superscript',
        description: 'Whether the text selection is written above the line in a slightly smaller size'
    },
    superscriptOffSubscriptOn: {
        id: 'fabric.editor.superscript.off.subscript.on',
        defaultMessage: 'Superscript Off, Subscript On',
        description: 'Describe text formatting in case when Superscript Off and Subscript on'
    },
    clearFormatting: {
        id: 'fabric.editor.clearFormatting',
        defaultMessage: 'Clear formatting',
        description: 'Remove all rich text formatting from the selected text'
    },
    moreFormatting: {
        id: 'fabric.editor.moreFormatting',
        defaultMessage: 'More formatting',
        description: 'Clicking this will show a menu with additional formatting options'
    },
    textFormatting: {
        id: 'fabric.editor.textFormatting',
        defaultMessage: 'Text formatting',
        description: 'Aria label for the wrapper of text format buttons'
    },
    bold: {
        id: 'fabric.editor.bold',
        defaultMessage: 'Bold',
        description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
    },
    italic: {
        id: 'fabric.editor.italic',
        defaultMessage: 'Italic',
        description: 'This refers to italics or emphasized formatting.'
    },
    on: {
        id: 'fabric.editor.on',
        defaultMessage: '{formattingType} On',
        description: 'Reports that text formatting has been turned on'
    },
    off: {
        id: 'fabric.editor.off',
        defaultMessage: '{formattingType} Off',
        description: 'Reports that text formatting has been turned off'
    },
    textStyles: {
        id: 'fabric.editor.textStyles',
        defaultMessage: 'Text styles',
        description: 'Menu provides access to various heading styles or normal text'
    },
    textFormattingOff: {
        id: 'fabric.editor.text.formatting.off',
        defaultMessage: 'Text formatting Off',
        description: 'Reports that text formatting has been turned off'
    },
    navigateToEditorToolbar: {
        id: 'fabric.editor.navigate.toolbar.editor',
        defaultMessage: 'Navigate to editor toolbar',
        description: 'Navigate to the main editor toolbar.'
    },
    navigateToFloatingToolbar: {
        id: 'fabric.editor.navigate.toolbar.floating',
        defaultMessage: 'Navigate to floating toolbar',
        description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
    }
});

});

parcelRegister("3Odey", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2c604e9361a1519c$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2c604e9361a1519c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options'
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
        defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
        defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row'
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row'
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table'
    },
    collapseTable: {
        id: 'fabric.editor.collapseTable',
        defaultMessage: 'Collapse table',
        description: 'Wraps table in an expand'
    },
    resizeTable: {
        id: 'fabric.editor.tables.resizeTable',
        defaultMessage: 'Resize table',
        description: 'Tooltip displayed on custom table width resize hande'
    },
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column right',
        description: 'Inserts a new column to the right of selected column.'
    },
    addColumnLeft: {
        id: 'fabric.editor.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'Adds a new column to the left of selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'Adds a new column to the right of selected column.'
    },
    insertColumnDrag: {
        id: 'fabric.editor.insertColumnDrag',
        defaultMessage: 'Insert column',
        description: 'Inserts a new column to the right of selected column.'
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
        description: 'Deletes a table column.'
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row below',
        description: 'Inserts a new row below the selected row.'
    },
    addRowAbove: {
        id: 'fabric.editor.addRowAbove',
        defaultMessage: 'Add row above',
        description: 'Adds a new row above the selected row.'
    },
    addRowBelow: {
        id: 'fabric.editor.addRowBelow',
        defaultMessage: 'Add row below',
        description: 'Adds a new row below the selected row.'
    },
    moveColumnLeft: {
        id: 'fabric.editor.moveColumnLeft',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
        description: 'Moves a column or columns to the left.'
    },
    moveColumnRight: {
        id: 'fabric.editor.moveColumnRight',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
        description: 'Moves a column or columns to the right.'
    },
    moveRowUp: {
        id: 'fabric.editor.moveRowUp',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
        description: 'Moves a row or selected rows up.'
    },
    moveRowDown: {
        id: 'fabric.editor.moveDownDown',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
        description: 'Moves a row or selected rows down.'
    },
    insertRowDrag: {
        id: 'fabric.editor.insertRowDrag',
        defaultMessage: 'Insert row',
        description: 'Inserts a new row below the selected row.'
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
        description: 'Deletes a table row.'
    },
    rowNumbers: {
        id: 'fabrid.editor.rowNumbers',
        defaultMessage: 'Row numbers',
        desciption: 'Adds a number to each row except header row'
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
        defaultMessage: 'Deleting',
        description: 'prefix for confirmation dialog text'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'checkbox label text'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    adjustColumns: {
        id: 'fabric.editor.tables.adjustColumn',
        defaultMessage: 'Adjust column',
        description: 'Tooltip displayed on table column resize handle'
    },
    cornerControl: {
        id: 'fabric.editor.cornerControl',
        defaultMessage: 'Highlight table',
        description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
    },
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.'
    },
    backgroundColor: {
        id: 'fabric.editor.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Change the background color of a table cell.'
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'Merge tables cells together.'
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'Split a merged table cell.'
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
    },
    sortColumnASC: {
        id: 'fabric.editor.sortColumnASC',
        defaultMessage: "Sort column A \u2192 Z",
        description: 'Sort column in ascending order'
    },
    sortColumnDESC: {
        id: 'fabric.editor.sortColumnDESC',
        defaultMessage: "Sort column Z \u2192 A",
        description: 'Sort column in descending order'
    },
    sortColumnIncreasing: {
        id: 'fabric.editor.sortColumnIncreasing',
        defaultMessage: 'Sort increasing',
        description: 'Sort column in ascending order'
    },
    sortColumnDecreasing: {
        id: 'fabric.editor.sortColumnDecreasing',
        defaultMessage: 'Sort decreasing',
        description: 'Sort column in descending order'
    },
    canNotSortTable: {
        id: 'fabric.editor.canNotSortTable',
        defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
        description: `Split your cells to enable this feature`
    },
    distributeColumns: {
        id: 'fabric.editor.distributeColumns',
        defaultMessage: `Distribute columns`,
        description: `Distribute widths between selected columns`
    },
    rowControl: {
        id: 'fabric.editor.rowControl',
        defaultMessage: 'Highlight row',
        description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
    },
    rowDragHandle: {
        id: 'fabric.editor.rowDragHandle',
        defaultMessage: 'Row options',
        description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
    },
    columnDragHandle: {
        id: 'fabric.editor.columnDragHandle',
        defaultMessage: 'Column options',
        description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
    },
    fullWidthLabel: {
        id: 'fabric.editor.tableFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Trigger table width to full-width mode'
    },
    startedColumnResize: {
        id: 'fabric.editor.tables.startedColumnResize',
        defaultMessage: 'Started column resize',
        description: 'Screen Reader announces when the user engages the column resizer'
    },
    focusedOtherResize: {
        id: 'fabric.editor.tables.otherResize',
        defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
        description: 'Screen Reader announces when the user switches to the left or right column resizer'
    },
    changedColumnWidth: {
        id: 'fabric.editor.tables.columnWidth',
        defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
        description: 'Screen Reader announces when the user modifies the column width'
    },
    columnResizeStop: {
        id: 'fabric.editor.tables.resizeStop',
        defaultMessage: 'Stopped resize',
        description: 'Screen Reader announces when the user discontinues the resizing operation'
    },
    columnResizeOverflow: {
        id: 'fabric.editor.tables.columnResizeOverflow',
        defaultMessage: 'You can only resize this column while the table has a scroll bar.',
        description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
    },
    columnResizeLast: {
        id: 'fabric.editor.tables.columnResizeLast',
        defaultMessage: 'You can only resize this column to the left.',
        description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
    }
});

});

parcelRegister("4i5ge", function(module, exports) {

$parcel$export(module.exports, "messages", () => $31fcec8bec37227c$export$defe85febe8b728c);
// Common Translations will live here

var $90IgZ = parcelRequire("90IgZ");
const $31fcec8bec37227c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    unorderedListDescription: {
        id: 'fabric.editor.unorderedList.description',
        defaultMessage: 'Create an unordered list',
        description: ''
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
    },
    orderedListDescription: {
        id: 'fabric.editor.orderedList.description',
        defaultMessage: 'Create an ordered list',
        description: ''
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists'
    },
    listsFormat: {
        id: 'fabric.editor.listsFormat',
        defaultMessage: 'List formating',
        description: 'Aria label for the wrapper of list buttons'
    }
});

});

parcelRegister("kKFSL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f1b8977c72b43289$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $f1b8977c72b43289$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    undo: {
        id: 'fabric.editor.undo',
        defaultMessage: 'Undo',
        description: 'Undo the previously performed action.'
    },
    redo: {
        id: 'fabric.editor.redo',
        defaultMessage: 'Redo',
        description: 'Redo the previously undone action.'
    }
});

});

parcelRegister("5jm2N", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3ddfd397cad6a410$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $3ddfd397cad6a410$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    placeholder: {
        id: 'fabric.editor.statusPlaceholder',
        defaultMessage: 'Set a status',
        description: 'Placeholder description for an empty (new) status item in the editor'
    },
    editText: {
        id: 'fabric.editor.editStatusText',
        defaultMessage: 'Edit Status',
        description: 'Title for the input that changes the status text'
    },
    editColor: {
        id: 'fabric.editor.editStatusColor',
        defaultMessage: 'Edit Status Color',
        description: 'Title for the color picker that changes the status color'
    }
});

});

parcelRegister("8oilI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $61becc64589ecb57$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $61becc64589ecb57$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    editText: {
        id: 'fabric.editor.editDateText',
        defaultMessage: 'Edit Date',
        description: 'Title for the input that changes the date'
    },
    invalidDateError: {
        id: 'fabric.editor.invalidDateError',
        defaultMessage: 'Enter a valid date',
        description: 'Error message when the date typed in is invalid, requesting they inputs a new date'
    }
});

});

parcelRegister("1UatT", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $163326c4f44c07e2$export$81b075fd34c2f0bb);

var $90IgZ = parcelRequire("90IgZ");
const $163326c4f44c07e2$export$81b075fd34c2f0bb = (0, $90IgZ.defineMessages)({
    singleColumn: {
        id: 'fabric.editor.single',
        defaultMessage: 'Single column',
        description: 'Layout with one single column'
    },
    twoColumns: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: 'Two columns',
        description: 'Layout with two columns of equal width'
    },
    threeColumns: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: 'Three columns',
        description: 'Layout with three columns of equal width'
    },
    rightSidebar: {
        id: 'fabric.editor.rightSidebar',
        defaultMessage: 'Right sidebar',
        description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
    },
    leftSidebar: {
        id: 'fabric.editor.leftSidebar',
        defaultMessage: 'Left sidebar',
        description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
    },
    threeColumnsWithSidebars: {
        id: 'fabric.editor.threeColumnsWithSidebars',
        defaultMessage: 'Three columns with sidebars',
        description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
    }
});

});

parcelRegister("2EAKE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1eebd3423bb7eb6a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1eebd3423bb7eb6a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    indent: {
        id: 'fabric.editor.indent',
        defaultMessage: 'Indent',
        description: 'Indent a list item, paragraph or heading'
    },
    outdent: {
        id: 'fabric.editor.outdent',
        defaultMessage: 'Outdent',
        description: 'Outdent a list item, paragraph or heading'
    }
});

});

parcelRegister("4bNzh", function(module, exports) {

$parcel$export(module.exports, "avatarGroupMessages", () => $30cea3abf38c0116$export$8a0e7c3f8f5b8868);

var $90IgZ = parcelRequire("90IgZ");
const $30cea3abf38c0116$export$8a0e7c3f8f5b8868 = (0, $90IgZ.defineMessages)({
    editors: {
        id: 'fabric.editor.editors',
        defaultMessage: 'Editors',
        description: 'classifying the people that are currently editing the document'
    }
});

});

parcelRegister("jaD5g", function(module, exports) {

$parcel$export(module.exports, "findReplaceMessages", () => $df4d44bcf3b65ce1$export$b46a930e1a386b2e);

var $90IgZ = parcelRequire("90IgZ");
const $df4d44bcf3b65ce1$export$b46a930e1a386b2e = (0, $90IgZ.defineMessages)({
    find: {
        id: 'fabric.editor.find',
        defaultMessage: 'Find',
        description: 'The word or phrase to search for on the document'
    },
    matchCase: {
        id: 'fabric.editor.matchCase',
        defaultMessage: 'Match case',
        description: 'Toggle whether should also match case when searching for text'
    },
    findNext: {
        id: 'fabric.editor.findNext',
        defaultMessage: 'Find next',
        description: 'Locate the next occurrence of the word or phrase that was searched for'
    },
    findPrevious: {
        id: 'fabric.editor.findPrevious',
        defaultMessage: 'Find previous',
        description: 'Locate the previous occurrence of the word or phrase that was searched for'
    },
    closeFindReplaceDialog: {
        id: 'fabric.editor.closeFindReplaceDialog',
        defaultMessage: 'Close',
        description: 'Cancel search and close the "Find and Replace" dialog'
    },
    noResultsFound: {
        id: 'fabric.editor.noResultsFound',
        defaultMessage: 'No results',
        description: 'No matches were found for the word or phrase that was searched for'
    },
    resultsCount: {
        id: 'fabric.editor.resultsCount',
        description: 'Text for selected search match position and total results count',
        defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
    },
    findReplaceToolbarButton: {
        id: 'fabric.editor.findReplaceToolbarButton',
        defaultMessage: 'Find and replace',
        description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
    },
    replaceWith: {
        id: 'fabric.editor.replaceWith',
        defaultMessage: 'Replace with',
        description: 'The value that will replace the word or phrase that was searched for'
    },
    replace: {
        id: 'fabric.editor.replace',
        defaultMessage: 'Replace',
        description: 'Replace only the currently selected instance of the word or phrase'
    },
    replaceAll: {
        id: 'fabric.editor.replaceAll',
        defaultMessage: 'Replace all',
        description: 'Replace all instances of the word or phrase throughout the entire document'
    },
    replaceSuccess: {
        id: 'fabric.editor.replaceSuccess',
        defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
        description: 'Text when replacement succesfully done'
    }
});

});

parcelRegister("jzEox", function(module, exports) {

$parcel$export(module.exports, "textColorMessages", () => $e4009ec975c0bb1a$export$effb4ee8b6f74abe);

var $90IgZ = parcelRequire("90IgZ");
const $e4009ec975c0bb1a$export$effb4ee8b6f74abe = (0, $90IgZ.defineMessages)({
    textColor: {
        id: 'fabric.editor.textColor',
        defaultMessage: 'Text color',
        description: ''
    }
});

});

parcelRegister("gYbUs", function(module, exports) {

$parcel$export(module.exports, "tasksAndDecisionsMessages", () => $c5ab7ceda2b21681$export$273d864e9e6d0b1f);

var $90IgZ = parcelRequire("90IgZ");
const $c5ab7ceda2b21681$export$273d864e9e6d0b1f = (0, $90IgZ.defineMessages)({
    taskPlaceholder: {
        id: 'fabric.editor.taskPlaceholder',
        defaultMessage: "Type your action, use '@' to assign to someone.",
        description: 'Placeholder description for an empty action/task in the editor'
    },
    decisionPlaceholder: {
        id: 'fabric.editor.decisionPlaceholder',
        defaultMessage: "Add a decision\u2026",
        description: 'Placeholder description for an empty decision in the editor'
    }
});

});

parcelRegister("i8NAO", function(module, exports) {

$parcel$export(module.exports, "placeholderTextMessages", () => $d34f717566894477$export$ee8ab8a034b5a8bd);

var $90IgZ = parcelRequire("90IgZ");
const $d34f717566894477$export$ee8ab8a034b5a8bd = (0, $90IgZ.defineMessages)({
    placeholderTextPlaceholder: {
        id: 'fabric.editor.placeholderTextPlaceholder',
        defaultMessage: 'Add placeholder text',
        description: ''
    }
});

});

parcelRegister("7QKsQ", function(module, exports) {

$parcel$export(module.exports, "pasteOptionsToolbarMessages", () => $5b716e9590c98a85$export$703e803e9cb0cea4);

var $90IgZ = parcelRequire("90IgZ");
const $5b716e9590c98a85$export$703e803e9cb0cea4 = (0, $90IgZ.defineMessages)({
    pasteOptions: {
        id: 'fabric.editor.pasteOptions',
        defaultMessage: 'Paste options',
        description: 'Opens a menu with additional paste options'
    },
    plainText: {
        id: 'fabric.editor.plainText',
        defaultMessage: 'Use plain text',
        description: 'Converts pasted text into plain text'
    },
    markdown: {
        id: 'fabric.editor.useMarkdown',
        defaultMessage: 'Use Markdown',
        description: 'Converts pasted text into Markdown'
    },
    richText: {
        id: 'fabric.editor.richText',
        defaultMessage: 'Use rich text',
        description: 'Converts pasted text into Rich text'
    }
});

});

parcelRegister("3VZtb", function(module, exports) {

$parcel$export(module.exports, "panelMessages", () => $2dd6608f24fefef6$export$7bb18eb6f9170174);

var $90IgZ = parcelRequire("90IgZ");
const $2dd6608f24fefef6$export$7bb18eb6f9170174 = (0, $90IgZ.defineMessages)({
    info: {
        id: 'fabric.editor.info',
        defaultMessage: 'Info',
        description: 'Panels provide a way to highlight text. The info panel has a blue background.'
    },
    note: {
        id: 'fabric.editor.note',
        defaultMessage: 'Note',
        description: 'Panels provide a way to highlight text. The note panel has a purple background.'
    },
    success: {
        id: 'fabric.editor.success',
        defaultMessage: 'Success',
        description: 'Panels provide a way to highlight text. The success panel has a green background.'
    },
    warning: {
        id: 'fabric.editor.warning',
        defaultMessage: 'Warning',
        description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
    },
    error: {
        id: 'fabric.editor.error',
        defaultMessage: 'Error',
        description: 'Panels provide a way to highlight text. The error panel has a red background.'
    },
    emoji: {
        id: 'fabric.editor.panel.emoji',
        defaultMessage: 'Add emoji',
        description: 'Select the panel icon'
    },
    backgroundColor: {
        id: 'fabric.editor.panel.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Select the panel background color.'
    }
});

});

parcelRegister("60orz", function(module, exports) {

$parcel$export(module.exports, "mentionMessages", () => $45f5b426edcb6c60$export$33aafd5ccbbbd00a);

var $90IgZ = parcelRequire("90IgZ");
const $45f5b426edcb6c60$export$33aafd5ccbbbd00a = (0, $90IgZ.defineMessages)({
    inviteItemTitle: {
        id: 'fabric.editor.inviteItem.title',
        defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
        description: 'Title of the invite teammate item in typeahead plugin'
    },
    mentionsAddLabel: {
        id: 'fabric.editor.mentionsAddLabel',
        defaultMessage: 'add-icon',
        description: 'icon label to describe adding a new mention'
    },
    mentionsIconLabel: {
        id: 'fabric.editor.mentionsIconLabel',
        defaultMessage: 'Mention',
        description: 'icon label to describe the mention icon'
    },
    mentionsNodeLabel: {
        id: 'fabric.editor.mentionNode.label',
        defaultMessage: 'Tagged user',
        description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
    }
});

});

parcelRegister("3y99E", function(module, exports) {

$parcel$export(module.exports, "helpDialogMessages", () => $295ba603420c7b69$export$83c85447c71428ba);

var $90IgZ = parcelRequire("90IgZ");
const $295ba603420c7b69$export$83c85447c71428ba = (0, $90IgZ.defineMessages)({
    editorHelp: {
        id: 'fabric.editor.editorHelp',
        defaultMessage: 'Editor help',
        description: 'Title of editor help dialog.'
    },
    helpDialogTips: {
        id: 'fabric.editor.helpDialogTips',
        defaultMessage: 'Press {keyMap} to quickly open this dialog at any time',
        description: 'Hint about how to open a dialog quickly using a shortcut.'
    },
    keyboardShortcuts: {
        id: 'fabric.editor.keyboardShortcuts',
        defaultMessage: 'Keyboard shortcuts',
        description: ''
    },
    markdown: {
        id: 'fabric.editor.markdown',
        defaultMessage: 'Markdown',
        description: 'It is a name of popular markup language.'
    },
    pastePlainText: {
        id: 'fabric.editor.pastePlainText',
        defaultMessage: 'Paste plain text',
        description: ''
    },
    CheckUncheckActionItem: {
        id: 'fabric.editor.checkUncheckActionItem',
        defaultMessage: 'Toggle action item',
        description: 'For Check/Uncheck Action item use shortcut'
    },
    altText: {
        id: 'fabric.editor.altText',
        defaultMessage: 'Alt text',
        description: 'Alternative text for image.'
    },
    selectTableRow: {
        id: 'fabric.editor.selectTableRow',
        defaultMessage: 'Select table row',
        description: 'Hint for selecting a table row using a shortcut'
    },
    selectTableColumn: {
        id: 'fabric.editor.selectTableColumn',
        defaultMessage: 'Select table column',
        description: 'Hint for selecting a table column using a shortcut'
    },
    increaseSize: {
        id: 'fabric.editor.increaseSize',
        defaultMessage: 'Increase size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
    },
    decreaseSize: {
        id: 'fabric.editor.decreaseSize',
        defaultMessage: 'Decrease size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
    },
    focusTableResizeHandle: {
        id: 'fabric.editor.focusTableResizeHandle',
        defaultMessage: 'Focus table resize handle',
        description: 'Focus table resize handle'
    },
    closeHelpDialog: {
        id: 'fabric.editor.closeHelpDialog',
        defaultMessage: 'Close help dialog',
        description: ''
    },
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: 'fabric.editor.quickInsert',
        defaultMessage: 'Quick insert',
        description: 'Name of a feature, which let you insert items quickly.'
    }
});

});


parcelRegister("ahtjn", function(module, exports) {

$parcel$export(module.exports, "walkUpTreeUntil", () => $77c23a983010b420$export$df14aaf7a527ab0c);
$parcel$export(module.exports, "unwrap", () => $77c23a983010b420$export$debb760848ca95a);
$parcel$export(module.exports, "removeNestedEmptyEls", () => $77c23a983010b420$export$5b66dc78851adb5e);
$parcel$export(module.exports, "containsClassName", () => $77c23a983010b420$export$c8913a477cc44663);
$parcel$export(module.exports, "closest", () => $77c23a983010b420$export$ff7f7c97cdce86e);
$parcel$export(module.exports, "closestElement", () => $77c23a983010b420$export$d508bcfb7f019487);
$parcel$export(module.exports, "parsePx", () => $77c23a983010b420$export$b0eef8cd00b29d5c);
$parcel$export(module.exports, "maphElem", () => $77c23a983010b420$export$5b6ab01a6efa50e2);
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $77c23a983010b420$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
function $77c23a983010b420$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
function $77c23a983010b420$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
const $77c23a983010b420$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
function $77c23a983010b420$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $77c23a983010b420$export$d508bcfb7f019487(node, s) {
    return $77c23a983010b420$export$ff7f7c97cdce86e(node, s);
}
function $77c23a983010b420$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
function $77c23a983010b420$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $77c23a983010b420$export$5b6ab01a6efa50e2(elem, callback) {
    return $77c23a983010b420$export$b2d5d4f1aeebddf1(elem, callback);
}

});


parcelRegister("h1C70", function(module, exports) {

$parcel$export(module.exports, "RendererCssClassName", () => $c65017ec6be1fc4d$export$91f3bbbf974496e2);
const $c65017ec6be1fc4d$var$clPrefix = 'ak-renderer-';
const $c65017ec6be1fc4d$export$91f3bbbf974496e2 = {
    DOCUMENT: `${$c65017ec6be1fc4d$var$clPrefix}document`,
    EXTENSION: `${$c65017ec6be1fc4d$var$clPrefix}extension`,
    EXTENSION_CENTER_ALIGN: `${$c65017ec6be1fc4d$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$c65017ec6be1fc4d$var$clPrefix}extension-overflow-container`,
    NUMBER_COLUMN: `${$c65017ec6be1fc4d$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$c65017ec6be1fc4d$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$c65017ec6be1fc4d$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$c65017ec6be1fc4d$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_ICON: `${$c65017ec6be1fc4d$var$clPrefix}tableHeader-sorting-icon`,
    SORTABLE_COLUMN_NO_ORDER: `${$c65017ec6be1fc4d$var$clPrefix}tableHeader-sorting-icon__no-order`
};

});



parcelRegister("aVOeM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f563257de17ade5$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $eUqFw = parcelRequire("eUqFw");

var $6aJhQ = parcelRequire("6aJhQ");

var $8agsH = parcelRequire("8agsH");

var $h0yQD = parcelRequire("h0yQD");
var $4IyMA = parcelRequire("4IyMA");

var $h1C70 = parcelRequire("h1C70");

var $khES4 = parcelRequire("khES4");
const $7f563257de17ade5$var$useMultiBodiedExtensionActions = ({ updateActiveChild: updateActiveChild, children: children })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        return {
            changeActive (index) {
                return updateActiveChild(index);
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children ? children === null || children === void 0 ? void 0 : children.length : 0;
            },
            removeChild (index) {
                return false;
            },
            updateParameters (parameters) {
                return false;
            },
            getChildren () {
                return [];
            }
        };
    }, [
        updateActiveChild,
        children
    ]);
    return actions;
};
const $7f563257de17ade5$var$navigationCssExtended = (0, $byn9U.css)`
  ${(0, $h0yQD.sharedMultiBodiedExtensionStyles).mbeNavigation};
  margin-left: 0 !important;
  margin-right: 0 !important;
  .mbe-add-tab-button,
  .mbe-remove-tab {
    display: none;
  }
`;
const $7f563257de17ade5$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [] } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $eUqFw.useState)(0);
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const overflowContainerClass = !removeOverflow ? (0, $h1C70.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((index)=>{
        if (typeof index !== 'number') {
            // TODO: Make sure we log this somewhere if this happens
            setActiveChildIndex(0);
            return false;
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const actions = $7f563257de17ade5$var$useMultiBodiedExtensionActions({
        updateActiveChild: updateActiveChild,
        children: children
    });
    const containerCssExtended = (0, $byn9U.css)`
    ${(0, $h0yQD.sharedMultiBodiedExtensionStyles).mbeExtensionContainer};
    .ak-renderer-extension {
      margin-top: 0 !important;
    }

    [data-layout='full-width'],
    [data-layout='wide'] {
      .multiBodiedExtension-navigation {
        border-right: 3px solid ${`var(--ds-border, ${(0, $PdmhA.N40)})`} !important;
      }
    }

    .multiBodiedExtension--frames
      > [data-extension-frame='true']:nth-of-type(${activeChildIndex + 1}) {
      ${(0, $h0yQD.sharedMultiBodiedExtensionStyles).extensionFrameContent}
      margin-left: 0;
      margin-right: 0;
    }
  `;
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $h1C70.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    function renderMbeContent(width) {
        return (0, $byn9U.jsx)("div", {
            className: `${(0, $h1C70.RendererCssClassName).EXTENSION} ${centerAlignClass} ${overflowContainerClass}`,
            style: {
                width: isTopLevel ? (0, $khES4.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, (0, $byn9U.jsx)("nav", {
            className: "multiBodiedExtension-navigation",
            css: $7f563257de17ade5$var$navigationCssExtended,
            "data-testid": "multiBodiedExtension-navigation"
        }, (0, $byn9U.jsx)((0, $8agsH.default), (0, $kU09D.default)({}, props, {
            actions: actions,
            type: "multiBodiedExtension"
        }), ({ result: result })=>{
            try {
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                return (0, $6aJhQ.renderExtension)(result, layout, {
                    isTopLevel: path.length < 1
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return (0, $6aJhQ.renderExtension)(children, layout, {
                isTopLevel: path.length < 1
            });
        })), (0, $byn9U.jsx)("article", {
            "data-testid": "multiBodiedExtension--frames",
            className: `multiBodiedExtension--frames`
        }, children));
    }
    return (0, $byn9U.jsx)("section", {
        className: "multiBodiedExtension--container",
        css: containerCssExtended,
        "data-testid": "multiBodiedExtension--container",
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, (0, $byn9U.jsx)((0, $4IyMA.WidthConsumer), null, ({ width: width })=>renderMbeContent(width)));
};
var $7f563257de17ade5$export$2e2bcd8739ae039 = $7f563257de17ade5$var$MultiBodiedExtension;

});
parcelRegister("h0yQD", function(module, exports) {

$parcel$export(module.exports, "removeMarginsAndBorder", () => $c61d77d26932a8c2$export$8df0393dc2d5d656);
$parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", () => $c61d77d26932a8c2$export$9c7196ca47f67390);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
// Wraps the navigation bar and extensionFrames
const $c61d77d26932a8c2$var$mbeExtensionContainer = (0, $byn9U.css)({
    background: 'transparent !important',
    'padding:': {
        left: `${"var(--ds-space-100, 8px)"} !important`,
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none',
        background: "var(--ds-surface, white)"
    },
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $c61d77d26932a8c2$var$mbeNavigation = (0, $byn9U.css)({
    borderTopLeftRadius: "var(--ds-border-radius, 3px)",
    borderTopRightRadius: "var(--ds-border-radius, 3px)",
    userSelect: 'none',
    WebkitUserModify: 'read-only',
    border: `1px solid ${`var(--ds-border, ${(0, $PdmhA.N40)})`}`,
    borderBottom: 'none !important',
    background: "var(--ds-surface, white)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    '&.remove-margins': {
        marginLeft: 0,
        marginRight: 0
    },
    '&.remove-border': {
        border: 'none'
    }
});
const $c61d77d26932a8c2$var$extensionFrameContent = (0, $byn9U.css)({
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    border: `1px solid ${`var(--ds-border, ${(0, $PdmhA.N30)})`}`,
    display: 'block',
    minHeight: '100px',
    background: "var(--ds-surface, white)",
    borderBottomLeftRadius: "var(--ds-border-radius, 3px)",
    borderBottomRightRadius: "var(--ds-border-radius, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    '.pm-table-with-controls': {
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    '.bodiedExtensionView-content-wrap': {
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    '.extensionView-content-wrap': {
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $c61d77d26932a8c2$export$8df0393dc2d5d656 = (0, $byn9U.css)({
    marginLeft: 0,
    marginRight: 0,
    border: 'none'
});
const $c61d77d26932a8c2$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $c61d77d26932a8c2$var$mbeExtensionContainer,
    mbeNavigation: $c61d77d26932a8c2$var$mbeNavigation,
    extensionFrameContent: $c61d77d26932a8c2$var$extensionFrameContent
};

});


parcelRegister("7ryQa", function(module, exports) {

$parcel$export(module.exports, "default", () => $56b6149e60a387fd$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $56b6149e60a387fd$var$ExtensionFrame = (props)=>{
    const containerCSS = (0, $byn9U.css)`
    border: 1px solid ${`var(--ds-border, ${(0, $PdmhA.N30)})`};
    min-height: 100px;
  `;
    return (0, $byn9U.jsx)("div", {
        css: containerCSS,
        className: "extension-frame",
        "data-extension-frame": "true",
        style: {
            flexBasis: `100%`
        }
    }, props.children);
};
var $56b6149e60a387fd$export$2e2bcd8739ae039 = $56b6149e60a387fd$var$ExtensionFrame;

});

parcelRegister("ajo9N", function(module, exports) {

$parcel$export(module.exports, "default", () => $781e6ad29e0702ce$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $568Ob = parcelRequire("568Ob");

var $k4h8S = parcelRequire("k4h8S");
function $781e6ad29e0702ce$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", {
        className: (0, $568Ob.bulletListSelector).substr(1),
        "data-indent-level": props.path ? (0, $k4h8S.getListIndentLevel)(props.path) : 1
    }, props.children);
}

});
parcelRegister("k4h8S", function(module, exports) {

$parcel$export(module.exports, "getListIndentLevel", () => $e9c17a6f514b7f44$export$75aa84e85754623e);
function $e9c17a6f514b7f44$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("5hYCz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d9d90595f7e3426$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $3d9d90595f7e3426$export$41121a410ca2f650);

var $eUqFw = parcelRequire("eUqFw");

var $h1C70 = parcelRequire("h1C70");

var $5SvPC = parcelRequire("5SvPC");
function $3d9d90595f7e3426$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $h1C70.RendererCssClassName).DOCUMENT
    }, props.children);
}
function $3d9d90595f7e3426$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: (0, $5SvPC.useSelectAllTrap)(),
        className: (0, $h1C70.RendererCssClassName).DOCUMENT
    }, props.children);
}

});
parcelRegister("5SvPC", function(module, exports) {

$parcel$export(module.exports, "useSelectAllTrap", () => $447aaff9f75be300$export$98871b245ee25215);

var $61wF1 = parcelRequire("61wF1");

var $eUqFw = parcelRequire("eUqFw");

var $bjJ4l = parcelRequire("bjJ4l");

var $9Vzl0 = parcelRequire("9Vzl0");
const $447aaff9f75be300$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $bjJ4l.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef();
    const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((e)=>{
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $9Vzl0.ElementSelection).fromWindow();
        if (elementSelection.eq(caught.current)) {
            fireAnalyticsEvent({
                eventType: (0, $61wF1.EVENT_TYPE).TRACK,
                action: (0, $61wF1.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $61wF1.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $61wF1.EVENT_TYPE).TRACK,
                action: (0, $61wF1.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $61wF1.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((e)=>{
        var _ref$current$contains, _ref$current;
        clicked.current = (_ref$current$contains = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.contains(e.target)) !== null && _ref$current$contains !== void 0 ? _ref$current$contains : false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        window.addEventListener('keydown', onKeyDown);
        window.addEventListener('click', onClick);
        return ()=>{
            window.removeEventListener('keydown', onKeyDown);
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("bjJ4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $83d46ddaf500d316$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $83d46ddaf500d316$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $83d46ddaf500d316$export$2e2bcd8739ae039 = $83d46ddaf500d316$var$AnalyticsContext;

});

parcelRegister("9Vzl0", function(module, exports) {

$parcel$export(module.exports, "ElementSelection", () => $73a4d943a77d007c$export$6e6724d89f27411);
class $73a4d943a77d007c$export$6e6724d89f27411 {
    constructor(selection){
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            var _this$range, _this$range2;
            const startMatches = ((_this$range = this.range) === null || _this$range === void 0 ? void 0 : _this$range.compareBoundaryPoints(Range.START_TO_START, selection.range)) === 0;
            const endMatches = ((_this$range2 = this.range) === null || _this$range2 === void 0 ? void 0 : _this$range2.compareBoundaryPoints(Range.END_TO_END, selection.range)) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        var _this$range$commonAnc, _this$range3;
        return el.contains((_this$range$commonAnc = (_this$range3 = this.range) === null || _this$range3 === void 0 ? void 0 : _this$range3.commonAncestorContainer) !== null && _this$range$commonAnc !== void 0 ? _this$range$commonAnc : null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $73a4d943a77d007c$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $73a4d943a77d007c$export$6e6724d89f27411(win.getSelection());
    }
}

});



parcelRegister("fk0uQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2791bded4a82195$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $b2791bded4a82195$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null);
};
var $b2791bded4a82195$export$2e2bcd8739ae039 = $b2791bded4a82195$var$HardBreak;

});

parcelRegister("5vO2o", function(module, exports) {

$parcel$export(module.exports, "default", () => $4036a96e981e534b$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $64BVr = parcelRequire("64BVr");

var $61wF1 = parcelRequire("61wF1");

var $bjJ4l = parcelRequire("bjJ4l");

var $89mrF = parcelRequire("89mrF");
const $4036a96e981e534b$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $4036a96e981e534b$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
function $4036a96e981e534b$var$WrapChildTextInSpan(children) {
    // We wrap the text in a span so that we can apply CSS pseudo elements
    // to each text node within the heading element.
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (child)=>{
        return typeof child === 'string' && !/^\s*$/.test(child) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, child) : child;
    });
}
function $4036a96e981e534b$var$Heading(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible } = props;
    const HX = `h${props.level}`;
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $4036a96e981e534b$var$hasRightAlignmentMark(marks);
    const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    const headingIdToUse = invisible ? undefined : headingId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HX, (0, $kU09D.default)({
        id: headingIdToUse
    }, dataAttributes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, showAnchorLink && isRightAligned ? $4036a96e981e534b$var$WrapChildTextInSpan(props.children) : props.children, showAnchorLink && headingId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bjJ4l.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64BVr.default), {
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            level: props.level,
            onCopyText: ()=>{
                fireAnalyticsEvent({
                    action: (0, $61wF1.ACTION).CLICKED,
                    actionSubject: (0, $61wF1.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $61wF1.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                    eventType: (0, $61wF1.EVENT_TYPE).UI
                });
                return (0, $89mrF.copyTextToClipboard)($4036a96e981e534b$var$getCurrentUrlWithHash(headingId));
            }
        }))));
}
var $4036a96e981e534b$export$2e2bcd8739ae039 = $4036a96e981e534b$var$Heading;

});
parcelRegister("64BVr", function(module, exports) {

$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $46c0890806c08cf6$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $46c0890806c08cf6$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $hUwRB = parcelRequire("hUwRB");

var $8cU5f = parcelRequire("8cU5f");

var $2qhQi = parcelRequire("2qhQi");

var $8hj5G = parcelRequire("8hj5G");
const $46c0890806c08cf6$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $46c0890806c08cf6$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, rest, {
        className: $46c0890806c08cf6$export$3c9cedc52604835d,
        ref: ref
    }), children);
});
const $46c0890806c08cf6$var$copyAnchorButtonStyles = (0, $byn9U.css)`
  display: inline;
  outline: none;
  background-color: transparent;
  border: none;
  color: ${`var(--ds-icon, ${(0, $PdmhA.N500)})`};
  cursor: pointer;
  right: 0;
`;
class $46c0890806c08cf6$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            tooltipMessage: '',
            isClicked: false
        });
        (0, $5zQU9.default)(this, "setTooltipState", (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            });
        });
        (0, $5zQU9.default)(this, "getCopyAriaLabel", ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $8hj5G.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        });
        (0, $5zQU9.default)(this, "copyToClipboard", async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $8hj5G.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch (e) {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        });
        (0, $5zQU9.default)(this, "resetMessage", ()=>{
            this.setTooltipState((0, $8hj5G.headingAnchorLinkMessages).copyHeadingLinkToClipboard);
        });
        (0, $5zQU9.default)(this, "renderAnchorButton", ()=>{
            return (0, $byn9U.jsx)("button", {
                css: $46c0890806c08cf6$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-label": this.state.tooltipMessage,
                type: "button"
            }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
                label: this.getCopyAriaLabel(),
                size: this.props.level > 3 ? 'small' : 'medium',
                primaryColor: this.state.isClicked ? `var(--ds-icon-selected, ${0, $PdmhA.B400})` : `var(--ds-icon-subtle, ${0, $PdmhA.N200})`
            }));
        });
    }
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) // We set the key to the message to ensure it remounts when the message
        // changes, so that it correctly repositions.
        // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
        return (0, $byn9U.jsx)((0, $8cU5f.default), {
            tag: $46c0890806c08cf6$var$CopyAnchorWrapperWithRef,
            content: tooltipMessage,
            position: "top",
            delay: 0,
            key: tooltipMessage
        }, this.renderAnchorButton());
        return this.renderAnchorButton();
    }
}
var $46c0890806c08cf6$export$2e2bcd8739ae039 = (0, $2qhQi.default)($46c0890806c08cf6$var$HeadingAnchor);

});
parcelRegister("hUwRB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0a128a0d80d703a$var$_react = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d0a128a0d80d703a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d0a128a0d80d703a$var$LinkIcon = (props)=>/*#__PURE__*/ $d0a128a0d80d703a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M12.856 5.457l-.937.92a1.002 1.002 0 000 1.437 1.047 1.047 0 001.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 01.203 3.81l-2.903 2.852a2.646 2.646 0 01-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 00-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="M11.144 19.543l.937-.92a1.002 1.002 0 000-1.437 1.047 1.047 0 00-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 01-.203-3.81l2.903-2.852a2.646 2.646 0 013.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 00.357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props));
$d0a128a0d80d703a$var$LinkIcon.displayName = 'LinkIcon';
var $d0a128a0d80d703a$var$_default = $d0a128a0d80d703a$var$LinkIcon;
module.exports.default = $d0a128a0d80d703a$var$_default;

});

parcelRegister("8hj5G", function(module, exports) {

$parcel$export(module.exports, "headingAnchorLinkMessages", () => $606eb840057442d6$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $606eb840057442d6$export$c79ebc36348824d1);
$parcel$export(module.exports, "sortingIconMessages", () => $606eb840057442d6$export$458c50917513cd1a);
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $606eb840057442d6$export$f142573f51a67577);

var $90IgZ = parcelRequire("90IgZ");
const $606eb840057442d6$export$74bada844422036d = (0, $90IgZ.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Copy heading link to clipboard'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Copied heading link to clipboard'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'copy aria label for link icon'
    }
});
const $606eb840057442d6$export$c79ebc36348824d1 = (0, $90IgZ.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'this table column is not sorted'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
const $606eb840057442d6$export$458c50917513cd1a = (0, $90IgZ.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Sort the column in ascending order'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Sort the column in descending order'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'clear the sorting from this column'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
        description: 'this sort is invalid for merged cells'
    }
});
const $606eb840057442d6$export$f142573f51a67577 = (0, $90IgZ.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: `You can't sort a table with merged cells`,
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});


parcelRegister("89mrF", function(module, exports) {

$parcel$export(module.exports, "copyTextToClipboard", () => $5ef09320772447c5$export$f980440e1ab4537d);
const $5ef09320772447c5$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });

});


parcelRegister("4kl5E", function(module, exports) {

$parcel$export(module.exports, "default", () => $326963bf50560246$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8agsH = parcelRequire("8agsH");
const $326963bf50560246$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8agsH.default), (0, $kU09D.default)({}, props, {
        type: "inlineExtension"
    }), ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(result)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, result);
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, text || 'inlineExtension');
    });
};
var $326963bf50560246$export$2e2bcd8739ae039 = $326963bf50560246$var$InlineExtension;

});

parcelRegister("iaEgN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3a865e7d5c0d39d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $d3a865e7d5c0d39d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-layout-section": true
    }, props.children);
}

});

parcelRegister("atpzT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a0074119ac5e9dd$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dVPiG = parcelRequire("dVPiG");
var $4IyMA = parcelRequire("4IyMA");
const $7a0074119ac5e9dd$var$layoutColumnClearMarginTopStyles = (0, $byn9U.css)`
  ${(0, $dVPiG.clearNextSiblingMarginTopStyle)}
  ${(0, $dVPiG.clearNextSiblingBlockMarkMarginTopStyle)}
`;
function $7a0074119ac5e9dd$export$2e2bcd8739ae039(props) {
    return (0, $byn9U.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        style: {
            flexBasis: `${props.width}%`
        }
    }, (0, $byn9U.jsx)((0, $4IyMA.WidthProvider), null, (0, $byn9U.jsx)("div", {
        css: $7a0074119ac5e9dd$var$layoutColumnClearMarginTopStyles
    }), props.children));
}

});
parcelRegister("dVPiG", function(module, exports) {

$parcel$export(module.exports, "clearNextSiblingMarginTopStyle", () => $a248646ebfea8317$export$b15ec88fc1f2e843);
$parcel$export(module.exports, "clearNextSiblingBlockMarkMarginTopStyle", () => $a248646ebfea8317$export$eb3aaa9338936d44);

var $byn9U = parcelRequire("byn9U");
const $a248646ebfea8317$export$b15ec88fc1f2e843 = (0, $byn9U.css)({
    '& + *': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        marginTop: '0 !important'
    }
});
const $a248646ebfea8317$var$textElements = [
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
];
const $a248646ebfea8317$var$nextSiblingBlockMarkContentSelectors = $a248646ebfea8317$var$textElements.map((elem)=>`+ .fabric-editor-block-mark > ${elem}`).join(',');
const $a248646ebfea8317$export$eb3aaa9338936d44 = (0, $byn9U.css)({
    [`${$a248646ebfea8317$var$nextSiblingBlockMarkContentSelectors}`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        marginTop: '0 !important'
    }
});

});


parcelRegister("cTtzv", function(module, exports) {

$parcel$export(module.exports, "default", () => $96318f6ad7c277d0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $96318f6ad7c277d0$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, props.children);
}

});

parcelRegister("4Is5N", function(module, exports) {

$parcel$export(module.exports, "default", () => $36f11015834e3cbf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dOx6Z = parcelRequire("dOx6Z");
const $36f11015834e3cbf$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dOx6Z.default), {
        hasContent: true,
        dataAttributes: dataAttributes
    }, children);
};
var $36f11015834e3cbf$export$2e2bcd8739ae039 = $36f11015834e3cbf$var$RenderCaption;

});
parcelRegister("dOx6Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0e9a12d89ac7744$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $PdmhA = parcelRequire("PdmhA");

var $ar7bh = parcelRequire("ar7bh");
const $a0e9a12d89ac7744$var$captionWrapperStyle = (0, $byn9U.css)`
  margin-top: ${"var(--ds-space-100, 8px)"};
  text-align: center;
  position: relative;
  color: ${`var(--ds-text-subtle, ${(0, $PdmhA.N400)})`};
`;
const $a0e9a12d89ac7744$var$placeholderStyle = (0, $byn9U.css)`
  color: ${`var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`};
  position: absolute;
  top: 0;
  width: 100%;
`;
class $a0e9a12d89ac7744$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
            "data-media-caption": true,
            "data-testid": "media-caption"
        }, dataAttributes, {
            css: $a0e9a12d89ac7744$var$captionWrapperStyle
        }), showPlaceholder ? (0, $byn9U.jsx)("p", {
            css: $a0e9a12d89ac7744$var$placeholderStyle
        }, formatMessage((0, $ar7bh.messages).placeholder)) : null, children);
    }
}
var $a0e9a12d89ac7744$export$2e2bcd8739ae039 = (0, $2qhQi.default)($a0e9a12d89ac7744$export$f7feb87190a94c76);

});
parcelRegister("ar7bh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7991fef625c00716$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $7991fef625c00716$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("fx8Y0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4f0e4b8df14e429$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8lnnz = parcelRequire("8lnnz");

var $dEHJr = parcelRequire("dEHJr");

var $995Br = parcelRequire("995Br");

var $k4h8S = parcelRequire("k4h8S");
function $b4f0e4b8df14e429$export$2e2bcd8739ae039(props) {
    var _props$content;
    let extraProps = {};
    const itemCounterDigitsSize = (0, $995Br.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props === null || props === void 0 ? void 0 : (_props$content = props.content) === null || _props$content === void 0 ? void 0 : _props$content.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 2) extraProps.style = (0, $dEHJr.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $995Br.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ol", (0, $kU09D.default)({
        className: (0, $8lnnz.orderedListSelector).substr(1),
        "data-indent-level": props.path ? (0, $k4h8S.getListIndentLevel)(props.path) : 1,
        start: props.start
    }, extraProps), props.children);
}

});
parcelRegister("dEHJr", function(module, exports) {

$parcel$export(module.exports, "listItemCounterPadding", () => $9f10ef0ae7642dc2$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $9f10ef0ae7642dc2$export$6d31fdb1d74cee3e);
$parcel$export(module.exports, "listsSharedStyles", () => $9f10ef0ae7642dc2$export$ea95db02cc29c78f);

var $byn9U = parcelRequire("byn9U");

var $568Ob = parcelRequire("568Ob");
var $8lnnz = parcelRequire("8lnnz");

var $ckjIr = parcelRequire("ckjIr");
const $9f10ef0ae7642dc2$export$bafd6beec0797f87 = 24;
var $9f10ef0ae7642dc2$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($9f10ef0ae7642dc2$var$CSS_VAR_NAMES || {});
const $9f10ef0ae7642dc2$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 3) {
        // When there are 3 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $9f10ef0ae7642dc2$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $9f10ef0ae7642dc2$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        [$9f10ef0ae7642dc2$var$CSS_VAR_NAMES.ITEM_COUNTER_PADDING]: $9f10ef0ae7642dc2$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $9f10ef0ae7642dc2$var$stringifyStyle(style);
    return style;
}
const $9f10ef0ae7642dc2$export$ea95db02cc29c78f = (0, $byn9U.css)`
  /* =============== INDENTATION SPACING ========= */

  ul,
  ol {
    box-sizing: border-box;
    padding-left: var(
      ${$9f10ef0ae7642dc2$var$CSS_VAR_NAMES.ITEM_COUNTER_PADDING},
      ${$9f10ef0ae7642dc2$export$bafd6beec0797f87}px
    );

    /*
    Firefox does not handle empty block element inside li tag.
    If there is not block element inside li tag,
      then firefox sets inherited height to li
    However, if there is any block element and if it's empty
      (or has empty inline element) then
    firefox sets li tag height to zero.
    More details at
    https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
    */
    li p:empty,
    li p > span:empty {
      ${(0, $ckjIr.default).gecko ? 'display: inline-block;' : ''}
    }
  }

  ${(0, $8lnnz.orderedListSelector)}, ${(0, $568Ob.bulletListSelector)} {
    /*
      Ensures list item content adheres to the list's margin instead
      of filling the entire block row. This is important to allow
      clicking interactive elements which are floated next to a list.

      For some history and context on this block, see PRs related to tickets.:
      @see ED-6551 - original issue.
      @see ED-7015 - follow up issue.
      @see ED-7447 - flow-root change.

      We use 'display: table' (old clear fix / new block formatting context hack)
      for older browsers and 'flow-root' for modern browsers.

      @see https://css-tricks.com/display-flow-root/
    */
    // For older browsers the do not support flow-root.
    /* stylelint-disable declaration-block-no-duplicate-properties */
    display: table;
    display: flow-root;
    /* stylelint-enable declaration-block-no-duplicate-properties */
  }

  /* =============== INDENTATION AESTHETICS ========= */

  /**
        We support nested lists up to six levels deep.
    **/

  /* LEGACY LISTS */

  ul,
  ul ul ul ul {
    list-style-type: disc;
  }

  ul ul,
  ul ul ul ul ul {
    list-style-type: circle;
  }

  ul ul ul,
  ul ul ul ul ul ul {
    list-style-type: square;
  }

  ol,
  ol ol ol ol {
    list-style-type: decimal;
  }
  ol ol,
  ol ol ol ol ol {
    list-style-type: lower-alpha;
  }
  ol ol ol,
  ol ol ol ol ol ol {
    list-style-type: lower-roman;
  }

  /* PREDICTABLE LISTS */

  ol[data-indent-level='1'],
  ol[data-indent-level='4'] {
    list-style-type: decimal;
  }

  ol[data-indent-level='2'],
  ol[data-indent-level='5'] {
    list-style-type: lower-alpha;
  }

  ol[data-indent-level='3'],
  ol[data-indent-level='6'] {
    list-style-type: lower-roman;
  }

  ul[data-indent-level='1'],
  ul[data-indent-level='4'] {
    list-style-type: disc;
  }

  ul[data-indent-level='2'],
  ul[data-indent-level='5'] {
    list-style-type: circle;
  }

  ul[data-indent-level='3'],
  ul[data-indent-level='6'] {
    list-style-type: square;
  }
`;

});

parcelRegister("995Br", function(module, exports) {

$parcel$export(module.exports, "resolveOrder", () => $6a894cf4e370879a$export$d445360e2a3c026b);
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $6a894cf4e370879a$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $6a894cf4e370879a$export$320582fc14ba1e0f);
$parcel$export(module.exports, "isListNode", () => $6a894cf4e370879a$export$a7d7d2b9ba4d4dbb);
$parcel$export(module.exports, "isParagraphNode", () => $6a894cf4e370879a$export$35f600abfe6f0127);
$parcel$export(module.exports, "isListItemNode", () => $6a894cf4e370879a$export$2ddb0a75547407f6);
$parcel$export(module.exports, "isBulletList", () => $6a894cf4e370879a$export$35b2f400604e700);
$parcel$export(module.exports, "isOrderedList", () => $6a894cf4e370879a$export$6e4e1502c6d9e5b8);
$parcel$export(module.exports, "isOrderedListContinuous", () => $6a894cf4e370879a$export$a265e5f4220d0409);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $6a894cf4e370879a$export$8ef94ae42a3729bd = 1;
const $6a894cf4e370879a$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $6a894cf4e370879a$export$cbefb5b89ef0719f = (orderedListNode)=>{
    var _orderedListNode$attr, _resolveOrder;
    const order = orderedListNode === null || orderedListNode === void 0 ? void 0 : (_orderedListNode$attr = orderedListNode.attrs) === null || _orderedListNode$attr === void 0 ? void 0 : _orderedListNode$attr.order;
    return (_resolveOrder = $6a894cf4e370879a$export$d445360e2a3c026b(order)) !== null && _resolveOrder !== void 0 ? _resolveOrder : $6a894cf4e370879a$export$8ef94ae42a3729bd;
};
const $6a894cf4e370879a$export$320582fc14ba1e0f = (options)=>{
    var _resolveOrder2, _String, _String$split, _String$split$;
    const order = (_resolveOrder2 = $6a894cf4e370879a$export$d445360e2a3c026b(options.order)) !== null && _resolveOrder2 !== void 0 ? _resolveOrder2 : $6a894cf4e370879a$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return (_String = String(largestCounter)) === null || _String === void 0 ? void 0 : (_String$split = _String.split('.')) === null || _String$split === void 0 ? void 0 : (_String$split$ = _String$split[0]) === null || _String$split$ === void 0 ? void 0 : _String$split$.length;
};
function $6a894cf4e370879a$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $6a894cf4e370879a$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $6a894cf4e370879a$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $6a894cf4e370879a$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}
function $6a894cf4e370879a$export$6e4e1502c6d9e5b8(node) {
    return Boolean(node && node.type && 'orderedList' === node.type.name);
}
const $6a894cf4e370879a$export$a265e5f4220d0409 = (firstOrderedList, secondOrderedList)=>{
    if (!($6a894cf4e370879a$export$6e4e1502c6d9e5b8(firstOrderedList) && $6a894cf4e370879a$export$6e4e1502c6d9e5b8(secondOrderedList))) return false;
    return $6a894cf4e370879a$export$cbefb5b89ef0719f(firstOrderedList) + firstOrderedList.childCount === $6a894cf4e370879a$export$cbefb5b89ef0719f(secondOrderedList);
};

});


parcelRegister("lQW3Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe8b7e7ad389eee6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eggz1 = parcelRequire("eggz1");
function $fe8b7e7ad389eee6$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", dataAttributes, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eggz1.default), null, children));
}

});
parcelRegister("eggz1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a61f688f7b66f204$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $a61f688f7b66f204$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, "\xA0");
    return children;
}

});


parcelRegister("6KEqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ea6655ef595d480$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $4ea6655ef595d480$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-placeholder": `${props.text}`
    }, props.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null);
}

});

parcelRegister("1hBRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ef4beb5a6932562$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0ef4beb5a6932562$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("hr", null);
}

});

parcelRegister("hP4fj", function(module, exports) {

$parcel$export(module.exports, "isTableResizingEnabled", () => $cf9a7e42f6f3d414$export$eec82c0a93aa66d9);
$parcel$export(module.exports, "default", () => $cf9a7e42f6f3d414$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $fgrpX = parcelRequire("fgrpX");

var $kRTSM = parcelRequire("kRTSM");
var $4IyMA = parcelRequire("4IyMA");

var $1gsRV = parcelRequire("1gsRV");
var $3nPkY = parcelRequire("3nPkY");
var $89aCb = parcelRequire("89aCb");

var $4EQkk = parcelRequire("4EQkk");

var $25FYC = parcelRequire("25FYC");

var $XHGTv = parcelRequire("XHGTv");

var $ewmoR = parcelRequire("ewmoR");

var $15sgt = parcelRequire("15sgt");

var $flRb7 = parcelRequire("flRb7");

var $fFNtM = parcelRequire("fFNtM");

var $hJ377 = parcelRequire("hJ377");

var $ixmtj = parcelRequire("ixmtj");

var $158kB = parcelRequire("158kB");
const $cf9a7e42f6f3d414$export$eec82c0a93aa66d9 = (appearance)=>(0, $XHGTv.getBooleanFF)('platform.editor.custom-table-width') && (0, $158kB.isFullWidthOrFullPageAppearance)(appearance);
const $cf9a7e42f6f3d414$var$orderChildren = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $4EQkk.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $89aCb.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $3nPkY.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $cf9a7e42f6f3d414$var$hasRowspan = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $cf9a7e42f6f3d414$var$getRefTop = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $cf9a7e42f6f3d414$var$shouldHeaderStick = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $cf9a7e42f6f3d414$var$shouldHeaderPinBottom = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $cf9a7e42f6f3d414$var$addSortableColumn = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $cf9a7e42f6f3d414$var$isHeaderRowEnabled = (rows)=>{
    if (!rows.length) return false;
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $flRb7.TableHeader);
    return children.every((node)=>node.type === (0, $flRb7.TableHeader));
};
const $cf9a7e42f6f3d414$var$tableCanBeSticky = (node, children)=>{
    return $cf9a7e42f6f3d414$var$isHeaderRowEnabled(children) && node && node.firstChild && !$cf9a7e42f6f3d414$var$hasRowspan(node.firstChild);
};
const $cf9a7e42f6f3d414$var$canUseLinelength = (appearance)=>appearance === 'full-page' || appearance === 'mobile';
class $cf9a7e42f6f3d414$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        });
        (0, $5zQU9.default)(this, "tableRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef());
        (0, $5zQU9.default)(this, "stickyHeaderRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef());
        // used for sync scroll + copying wrapper width to sticky header
        (0, $5zQU9.default)(this, "stickyWrapperRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef());
        (0, $5zQU9.default)(this, "wrapperRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef());
        (0, $5zQU9.default)(this, "overflowParent", null);
        (0, $5zQU9.default)(this, "resizeObserver", null);
        (0, $5zQU9.default)(this, "applyResizerChange", (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        });
        (0, $5zQU9.default)(this, "componentWillUnmount", ()=>{
            if (this.overflowParent) this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
        });
        (0, $5zQU9.default)(this, "getScrollTop", ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        });
        (0, $5zQU9.default)(this, "updateSticky", ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $hJ377.tableStickyPadding);
            const tableTop = $cf9a7e42f6f3d414$var$getRefTop(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $cf9a7e42f6f3d414$var$shouldHeaderStick(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $cf9a7e42f6f3d414$var$shouldHeaderPinBottom(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        });
        (0, $5zQU9.default)(this, "onScroll", ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        });
        (0, $5zQU9.default)(this, "onWrapperScrolled", ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        });
        (0, $5zQU9.default)(this, "grabFirstRowRef", (children)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        });
    }
    componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $hJ377.OverflowParent).fromElement(this.tableRef.current);
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $hJ377.OverflowParent).fromElement(this.tableRef.current);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $fgrpX.tableMarginTop) - (0, $hJ377.tableStickyPadding);
    }
    get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                return this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
            default:
                return undefined;
        }
    }
    render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLength = (0, $25FYC.akEditorDefaultLayoutWidth);
        let tableWidth;
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const calcDefaultLayoutWidthByAppearance = (tableNode, rendererAppearance)=>{
            if (rendererAppearance === 'full-width' && !tableNode.attrs.width) return isRenderWidthValid ? Math.min((0, $25FYC.akEditorFullWidthLayoutWidth), renderWidth) : (0, $25FYC.akEditorFullWidthLayoutWidth);
            else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $ewmoR.getTableContainerWidth)(tableNode);
                return isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth;
            }
        };
        if ($cf9a7e42f6f3d414$export$eec82c0a93aa66d9(rendererAppearance) && tableNode) tableWidth = calcDefaultLayoutWidthByAppearance(tableNode, rendererAppearance);
        else tableWidth = (0, $fgrpX.calcTableWidth)(layout, renderWidth, false);
        if ($cf9a7e42f6f3d414$var$canUseLinelength(rendererAppearance) && tableWidth !== 'inherit' && tableWidth > lineLength) left = lineLength / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) && rendererAppearance === 'full-width' && layout !== 'full-width';
        const hasCustomWidth = $cf9a7e42f6f3d414$export$eec82c0a93aa66d9(rendererAppearance) && (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.width);
        if (isFullWidth) updatedLayout = 'full-width';
        else if (hasCustomWidth) updatedLayout = 'custom';
        else updatedLayout = layout;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !(0, $XHGTv.getBooleanFF)('platform.editor.custom-table-width') && stickyHeaders && $cf9a7e42f6f3d414$var$tableCanBeSticky(tableNode, children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJ377.StickyTable), {
            isNumberColumnEnabled: isNumberColumnEnabled,
            tableWidth: tableWidth,
            layout: layout,
            renderWidth: renderWidth,
            handleRef: this.props.handleRef,
            shadowClassNames: this.props.shadowClassNames,
            top: this.stickyTop,
            left: left,
            mode: stickyMode,
            innerRef: this.stickyWrapperRef,
            wrapperWidth: this.state.wrapperWidth,
            columnWidths: columnWidths,
            rowHeight: this.state.headerRowHeight,
            rendererAppearance: rendererAppearance
        }, [
            children && children[0]
        ]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: `${(0, $fgrpX.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
            "data-layout": updatedLayout,
            ref: this.props.handleRef,
            style: {
                width: tableWidth,
                left: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/ensure-design-token-usage/preview
                left
            }
        }, (0, $XHGTv.getBooleanFF)('platform.editor.custom-table-width') && stickyHeaders && $cf9a7e42f6f3d414$var$tableCanBeSticky(tableNode, children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJ377.StickyTable), {
            isNumberColumnEnabled: isNumberColumnEnabled,
            tableWidth: tableWidth,
            layout: layout,
            renderWidth: renderWidth,
            handleRef: this.props.handleRef,
            shadowClassNames: this.props.shadowClassNames,
            top: this.stickyTop,
            mode: stickyMode,
            innerRef: this.stickyWrapperRef,
            wrapperWidth: this.state.wrapperWidth,
            columnWidths: columnWidths,
            rowHeight: this.state.headerRowHeight,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance
        }, [
            children && children[0]
        ]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $fgrpX.TableSharedCssClassName).TABLE_NODE_WRAPPER,
            ref: this.wrapperRef,
            onScroll: this.props.stickyHeaders && this.onWrapperScrolled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ixmtj.Table), {
            innerRef: this.tableRef,
            columnWidths: columnWidths,
            layout: layout,
            isNumberColumnEnabled: isNumberColumnEnabled,
            renderWidth: renderWidth,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension
        }, this.grabFirstRowRef(children)))));
    }
}
class $cf9a7e42f6f3d414$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            tableOrderStatus: undefined
        });
        // adds sortable + re-orders children
        (0, $5zQU9.default)(this, "addSortableColumn", (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $cf9a7e42f6f3d414$var$isHeaderRowEnabled(childrenArray) && tableNode && !(0, $3nPkY.hasMergedCell)(tableNode)) return $cf9a7e42f6f3d414$var$addSortableColumn($cf9a7e42f6f3d414$var$orderChildren(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        });
        (0, $5zQU9.default)(this, "changeSortOrder", (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        });
        (0, $5zQU9.default)(this, "addNumberColumnIndexes", (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $cf9a7e42f6f3d414$var$isHeaderRowEnabled(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        });
    }
    render() {
        const { children: children } = this.props;
        if (!children) return null;
        let childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children);
        const orderedChildren = (0, $1gsRV.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf9a7e42f6f3d414$export$f2c3aea42b2a048f, this.props, orderedChildren);
    }
}
const $cf9a7e42f6f3d414$var$TableWithShadows = (0, $kRTSM.default)($cf9a7e42f6f3d414$export$91e0997fd3f75d56, {
    overflowSelector: `.${(0, $fgrpX.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $cf9a7e42f6f3d414$var$TableWithWidth = (props)=>/*#__PURE__*/ // Remember, `width` will be 0 during SSR
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4IyMA.WidthConsumer), null, ({ width: width })=>{
        var _props$columnWidths;
        const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $15sgt.FullPagePadding) * 2 : width;
        const colWidthsSum = ((_props$columnWidths = props.columnWidths) === null || _props$columnWidths === void 0 ? void 0 : _props$columnWidths.reduce((total, val)=>total + val, 0)) || 0;
        if (colWidthsSum || $cf9a7e42f6f3d414$export$eec82c0a93aa66d9(props.rendererAppearance)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf9a7e42f6f3d414$var$TableWithShadows, (0, $kU09D.default)({
            renderWidth: renderWidth
        }, props));
        // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf9a7e42f6f3d414$export$91e0997fd3f75d56, (0, $kU09D.default)({
            renderWidth: renderWidth
        }, props));
    });
var $cf9a7e42f6f3d414$export$2e2bcd8739ae039 = (0, $fFNtM.withSmartCardStorage)($cf9a7e42f6f3d414$var$TableWithWidth);

});
parcelRegister("fgrpX", function(module, exports) {

$parcel$export(module.exports, "tableMarginTop", () => $b1cd9e39b1c72fea$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableMarginTopWithControl", () => $b1cd9e39b1c72fea$export$910bf0d22c3d10f2);
$parcel$export(module.exports, "tableMarginSides", () => $b1cd9e39b1c72fea$export$a43e30915fab3ccf);
$parcel$export(module.exports, "tableCellMinWidth", () => $b1cd9e39b1c72fea$export$531f77930bf508de);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $b1cd9e39b1c72fea$export$c60fae4049791eae);
$parcel$export(module.exports, "tableCellBorderWidth", () => $b1cd9e39b1c72fea$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $b1cd9e39b1c72fea$export$e56b8ca552b280f6);
$parcel$export(module.exports, "TableSharedCssClassName", () => $b1cd9e39b1c72fea$export$c096bca5477eb7ad);
$parcel$export(module.exports, "tableSharedStyle", () => $b1cd9e39b1c72fea$export$c2bf8eea75aa9302);
$parcel$export(module.exports, "calcTableWidth", () => $b1cd9e39b1c72fea$export$d7ece4d8beb06815);

var $byn9U = parcelRequire("byn9U");

var $byxO6 = parcelRequire("byxO6");

var $25FYC = parcelRequire("25FYC");
var $bCCqk = parcelRequire("bCCqk");

var $ckjIr = parcelRequire("ckjIr");

var $3GCBC = parcelRequire("3GCBC");

var $liXLr = parcelRequire("liXLr");
const $b1cd9e39b1c72fea$export$808015ab1dd6897a = 24;
const $b1cd9e39b1c72fea$export$afe1899c3eea9823 = 16;
const $b1cd9e39b1c72fea$export$910bf0d22c3d10f2 = 14;
const $b1cd9e39b1c72fea$export$a43e30915fab3ccf = 8;
const $b1cd9e39b1c72fea$export$531f77930bf508de = 48;
const $b1cd9e39b1c72fea$export$c60fae4049791eae = 140;
const $b1cd9e39b1c72fea$export$72aad729077aa0fb = 1;
const $b1cd9e39b1c72fea$export$e56b8ca552b280f6 = 8;
const $b1cd9e39b1c72fea$export$bba39e724bc39451 = 6;
const $b1cd9e39b1c72fea$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $byxO6.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-wrapper`,
    TABLE_LEFT_SHADOW: `${(0, $byxO6.tablePrefixSelector)}-with-left-shadow`,
    TABLE_RIGHT_SHADOW: `${(0, $byxO6.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $byxO6.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $byxO6.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $byxO6.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $byxO6.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $byxO6.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $byxO6.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $byxO6.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $byxO6.tablePrefixSelector)}-shadow-sentinel-right`,
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $byxO6.tableCellContentDomSelector),
    TABLE_CELL_WRAPPER: (0, $byxO6.tableCellSelector),
    TABLE_HEADER_CELL_WRAPPER: (0, $byxO6.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $byxO6.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $byxO6.tablePrefixSelector)}-resizer-container`
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
const $b1cd9e39b1c72fea$export$c2bf8eea75aa9302 = ()=>(0, $byn9U.css)`
  ${(0, $liXLr.tableCellBackgroundStyleOverride)()}
  .${$b1cd9e39b1c72fea$export$c096bca5477eb7ad.TABLE_CONTAINER} {
    position: relative;
    margin: 0 auto ${"var(--ds-space-200, 16px)"};
    box-sizing: border-box;

    /**
     * Fix block top alignment inside table cells.
     */
    .decisionItemView-content-wrap:first-of-type > div {
      margin-top: 0;
    }
  }
  .${$b1cd9e39b1c72fea$export$c096bca5477eb7ad.TABLE_CONTAINER}[data-number-column='true'] {
    padding-left: ${(0, $25FYC.akEditorTableNumberColumnWidth) - 1}px;
    clear: both;
  }

  .${$b1cd9e39b1c72fea$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER} {
    will-change: width, margin-left;
  }

  .${$b1cd9e39b1c72fea$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER} table {
    will-change: width;
  }

  .${$b1cd9e39b1c72fea$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER} > table {
    margin: ${"var(--ds-space-300, 24px)"} 0 0 0;
  }

  .${$b1cd9e39b1c72fea$export$c096bca5477eb7ad.TABLE_CONTAINER} > table,
  .${$b1cd9e39b1c72fea$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER} > table {
    margin: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-100, 8px)"} 0 0;
  }

  /* avoid applying styles to nested tables (possible via extensions) */
  .${$b1cd9e39b1c72fea$export$c096bca5477eb7ad.TABLE_CONTAINER} > table,
  .${$b1cd9e39b1c72fea$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER} > table,
  .${$b1cd9e39b1c72fea$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER} > table {
    border-collapse: collapse;
    border: ${$b1cd9e39b1c72fea$export$72aad729077aa0fb}px solid
      ${`var(--ds-background-accent-gray-subtler, ${0, $25FYC.akEditorTableBorder})`};
    table-layout: fixed;
    font-size: 1em;
    width: 100%;

    &[data-autosize='true'] {
      table-layout: auto;
    }

    & {
      * {
        box-sizing: border-box;
      }
      hr {
        box-sizing: content-box;
      }

      tbody {
        border-bottom: none;
      }
      th td {
        background-color: ${"var(--ds-background-neutral-subtle, white)"};
      }
      th,
      td {
        min-width: ${$b1cd9e39b1c72fea$export$531f77930bf508de}px;
        font-weight: normal;
        vertical-align: top;
        border: 1px solid
          ${`var(--ds-background-accent-gray-subtler, ${0, $25FYC.akEditorTableBorder})`};
        border-right-width: 0;
        border-bottom-width: 0;
        padding: ${"var(--ds-space-100, 8px)"};
        /* https://stackoverflow.com/questions/7517127/borders-not-shown-in-firefox-with-border-collapse-on-table-position-relative-o */
        ${(0, $ckjIr.default).gecko || (0, $ckjIr.default).ie || (0, $ckjIr.default).mac && (0, $ckjIr.default).chrome ? 'background-clip: padding-box;' : ''}

        > :first-child:not(style),
        > style:first-child + * {
          margin-top: 0;
        }

        > .ProseMirror-gapcursor:first-child + *,
        > style:first-child + .ProseMirror-gapcursor + * {
          margin-top: 0;
        }

        > .ProseMirror-gapcursor:first-child + span + *,
        > style:first-child + .ProseMirror-gapcursor + span + * {
          margin-top: 0;
        }

        th p:not(:first-of-type),
        td p:not(:first-of-type) {
          margin-top: ${"var(--ds-space-150, 12px)"};
        }
      }
      th {
        background-color: ${`var(--ds-background-accent-gray-subtlest, ${0, $25FYC.akEditorTableToolbar})`};
        text-align: left;

        /* only apply this styling to codeblocks in default background headercells */
        /* TODO this needs to be overhauled as it relies on unsafe selectors */
        &:not([style]):not(.danger) {
          .${(0, $3GCBC.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}:not(.danger) {
            background-color: ${"var(--ds-surface-raised, rgb(235, 237, 240))"};

            :not(.${0, $25FYC.akEditorSelectedNodeClassName}) {
              box-shadow: 0px 0px 0px 1px
                ${"var(--ds-border, transparent)"};
            }

            .${(0, $3GCBC.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER} {
              background-image: ${(0, $bCCqk.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    })};

              background-color: ${"var(--ds-background-neutral, rgb(235, 237, 240))"};
            }

            .${(0, $3GCBC.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER} {
              background-color: ${"var(--ds-background-neutral, rgb(226, 229, 233))"};
            }

            /* this is only relevant to the element taken care of by renderer */
            > [data-ds--code--code-block] {
              background-image: ${(0, $bCCqk.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    })}!important;

              background-color: ${"var(--ds-background-neutral, rgb(235, 237, 240))"}!important;

              // selector lives inside @atlaskit/code
              --ds--code--line-number-bg-color: ${"var(--ds-background-neutral, rgb(226, 229, 233))"};
            }
          }
        }
      }
    }
  }
`;
const $b1cd9e39b1c72fea$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $25FYC.akEditorBreakoutPadding) : 0), (0, $25FYC.akEditorFullWidthLayoutWidth)) : (0, $25FYC.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $25FYC.akEditorBreakoutPadding) : 0), (0, $25FYC.akEditorWideLayoutWidth));
            return 0, $25FYC.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};

});
parcelRegister("bCCqk", function(module, exports) {

$parcel$export(module.exports, "overflowShadow", () => $d830dab92300d0ea$export$c5c1e4f4640336fb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $byn9U = parcelRequire("byn9U");
const $d830dab92300d0ea$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)();
};

});

parcelRegister("3GCBC", function(module, exports) {

$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $2af33da5fce7e635$export$42659c26f026f6ea);
$parcel$export(module.exports, "codeBlockSharedStyles", () => $2af33da5fce7e635$export$a4fbe21dc6fae881);
$parcel$export(module.exports, "codeBlockInListSafariFix", () => $2af33da5fce7e635$export$3aa5ee2f4c156533);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Should be safe to autofix, but ignoring for now */ 
var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
var $bCCqk = parcelRequire("bCCqk");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
const $2af33da5fce7e635$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]'
};
const $2af33da5fce7e635$export$a4fbe21dc6fae881 = ()=>(0, $byn9U.css)`
  .${$2af33da5fce7e635$export$42659c26f026f6ea.CODEBLOCK_CONTAINER} {
    position: relative;
    background-color: ${"var(--ds-surface-raised, transparent)"};
    border-radius: ${"var(--ds-border-radius, 3px)"};
    margin: ${0, $25FYC.blockNodesVerticalMargin} 0 0 0;
    font-family: ${0, $25FYC.akEditorCodeFontFamily};
    min-width: ${0, $25FYC.akEditorTableCellMinWidth}px;
    cursor: pointer;

    --ds--code--bg-color: transparent;

    /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */
    white-space: normal;

    .${$2af33da5fce7e635$export$42659c26f026f6ea.CODEBLOCK_START} {
      position: absolute;
      visibility: hidden;
      height: 1.5rem;
      top: 0px;
      left: 0px;
    }

    .${$2af33da5fce7e635$export$42659c26f026f6ea.CODEBLOCK_END} {
      position: absolute;
      visibility: hidden;
      height: 1.5rem;
      bottom: 0px;
      right: 0px;
    }

    .${$2af33da5fce7e635$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER} {
      background-color: ${`var(--ds-background-neutral, ${0, $PdmhA.N20})`};
      display: flex;
      border-radius: ${"var(--ds-border-radius, 3px)"};
      width: 100%;
      counter-reset: line;
      overflow-x: auto;

      background-image: ${(0, $bCCqk.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    })};

      background-repeat: no-repeat;
      background-attachment: local, local, local, local, scroll, scroll, scroll,
        scroll;
      background-size: ${"var(--ds-space-300, 24px)"} 100%,
        ${"var(--ds-space-300, 24px)"} 100%, ${"var(--ds-space-100, 8px)"} 100%,
        ${"var(--ds-space-100, 8px)"} 100%, ${"var(--ds-space-100, 8px)"} 100%,
        1px 100%, ${"var(--ds-space-100, 8px)"} 100%, 1px 100%;
      background-position: 0 0, 0 0, 100% 0, 100% 0, 100% 0, 100% 0, 0 0, 0 0;

      /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */
      overflow-y: hidden;
    }

    .${$2af33da5fce7e635$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER} {
      flex-shrink: 0;
      text-align: right;
      background-color: ${`var(--ds-background-neutral, ${0, $PdmhA.N30})`};
      padding: ${"var(--ds-space-100, 8px)"};
      position: relative;

      span {
        display: block;
        line-height: 0;
        font-size: 0;

        ::before {
          display: inline-block;
          content: counter(line);
          counter-increment: line;
          color: ${`var(--ds-text-subtlest, ${0, $PdmhA.N400})`};
          font-size: ${(0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)())};
          line-height: 1.5rem;
        }
      }
    }

    .${$2af33da5fce7e635$export$42659c26f026f6ea.CODEBLOCK_CONTENT} {
      display: flex;
      flex: 1;

      code {
        flex-grow: 1;
        tab-size: 4;
        cursor: text;
        color: ${`var(--ds-text, ${0, $PdmhA.N800})`};
        border-radius: ${"var(--ds-border-radius, 3px)"};
        margin: ${"var(--ds-space-100, 8px)"};
        white-space: pre;
        font-size: ${(0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)())};
        line-height: 1.5rem;
      }
    }
  }
`;
const $2af33da5fce7e635$export$3aa5ee2f4c156533 = (0, $byn9U.css)`
  ::before {
    content: ' ';
    line-height: ${(0, $25FYC.akEditorLineHeight)};
  }

  > p:first-child,
  > .code-block:first-child,
  > .ProseMirror-gapcursor:first-child + .code-block {
    margin-top: -${(0, $25FYC.akEditorLineHeight)}em !important;
  }
`;

});

parcelRegister("liXLr", function(module, exports) {

$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $f829a35451220844$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $byn9U = parcelRequire("byn9U");

var $byxO6 = parcelRequire("byxO6");

var $dapS7 = parcelRequire("dapS7");
// This is used in order to support usage of DS tokens. Table cell background-color
// is set inline in '@atlaskit/adf-schema' and the color value is stored in ADF so
// it is not possible to use tokens there without polluting ADF.
// As table cell backgrounds are set inline, this should not break mobile as
// hexToEditorBackgroundPaletteColor() outputs a css variable with fallback hex.
const $f829a35451220844$var$mapBackgroundColors = ()=>{
    let cssString = '';
    (0, $byxO6.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $dapS7.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};
const $f829a35451220844$export$677e93f0f5f9623a = ()=>(0, $byn9U.css)($f829a35451220844$var$mapBackgroundColors());

});
parcelRegister("dapS7", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $99604727f51d7f32$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $99604727f51d7f32$export$a270511a0e7fd61a);
// This import will be stripped on build

var $iX87Q = parcelRequire("iX87Q");
function $99604727f51d7f32$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $99604727f51d7f32$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.token : undefined;
}
function $99604727f51d7f32$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $99604727f51d7f32$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $99604727f51d7f32$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #57D9A3)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FFC400)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #FF8F73)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #998DD9)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)" // source for hex code was legacy token N60,
    }
};

});



parcelRegister("1gsRV", function(module, exports) {

$parcel$export(module.exports, "compose", () => $0ebdadceaeaecc47$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ /**
 * Compose 1 to n functions.
 * @param func first function
 * @param funcs additional functions
 */ function $0ebdadceaeaecc47$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}

});

parcelRegister("3nPkY", function(module, exports) {

$parcel$export(module.exports, "calcTableColumnWidths", () => $276b579c69b26e89$export$98951d3cdcfd364b);
$parcel$export(module.exports, "hasMergedCell", () => $276b579c69b26e89$export$f9d610bfbb78949b);
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $276b579c69b26e89$export$69fbfaf01f2fd534);
$parcel$export(module.exports, "isPositionNearTableRow", () => $276b579c69b26e89$export$889a8e446452be16);
function $276b579c69b26e89$export$98951d3cdcfd364b(node) {
    let tableColumnWidths = [];
    const firstRow = node.firstChild;
    if (firstRow) // Sanity validation, but it should always have a first row
    // Iterate for the cells in the first row
    firstRow.forEach((colNode)=>{
        let colwidth = colNode.attrs.colwidth || [
            0
        ];
        // If we have colwidth, we added it
        if (colwidth) tableColumnWidths = [
            ...tableColumnWidths,
            ...colwidth
        ];
    });
    return tableColumnWidths;
}
function $276b579c69b26e89$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
function $276b579c69b26e89$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
function $276b579c69b26e89$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    let doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        var _resolved$sibling;
        const siblingType = (_resolved$sibling = resolved[sibling]) === null || _resolved$sibling === void 0 ? void 0 : _resolved$sibling.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}

});

parcelRegister("89aCb", function(module, exports) {

$parcel$export(module.exports, "createCompareNodes", () => $5ee765e255617e6d$export$49215374a8bec29c);

var $4EQkk = parcelRequire("4EQkk");
let $5ee765e255617e6d$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});
function $5ee765e255617e6d$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $5ee765e255617e6d$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $5ee765e255617e6d$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!(stringNumber !== null && stringNumber !== void 0 && stringNumber.length)) return acc;
            const maybeANumber = $5ee765e255617e6d$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $5ee765e255617e6d$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $5ee765e255617e6d$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: $5ee765e255617e6d$export$e2e108cbe2e4f865.LINK,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: $5ee765e255617e6d$export$e2e108cbe2e4f865.NUMBER,
        value: normalizedText
    };
    return {
        type: $5ee765e255617e6d$export$e2e108cbe2e4f865.TEXT,
        value: normalizedText !== null && normalizedText !== void 0 ? normalizedText : text
    };
}
function $5ee765e255617e6d$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
      Get Meta value from the first child if the cell is of type
        * Heading (Any cell where the text is set to a heading type)
        * Paragraph (Normal text)
     */ case 'heading':
        case 'paragraph':
            return $5ee765e255617e6d$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: $5ee765e255617e6d$export$e2e108cbe2e4f865.LINK,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: $5ee765e255617e6d$export$e2e108cbe2e4f865.LINK,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $5ee765e255617e6d$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: $5ee765e255617e6d$export$e2e108cbe2e4f865.STATUS,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: $5ee765e255617e6d$export$e2e108cbe2e4f865.DATE,
                    value: timestamp
                };
            }
        case 'mention':
            {
                // TODO: Check what should be the fallback when mention does not have a text
                const text = firstChild.attrs.text || '';
                return {
                    type: $5ee765e255617e6d$export$e2e108cbe2e4f865.MENTION,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $5ee765e255617e6d$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $5ee765e255617e6d$export$49215374a8bec29c = (options, order = (0, $4EQkk.SortOrder).ASC)=>{
    const normalizeTextParser = $5ee765e255617e6d$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $5ee765e255617e6d$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $5ee765e255617e6d$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
      Donot switch the order (Asec or Desc) if either node is null.
      This will ensure that empty cells are always at the bottom during sorting.
    */ if (metaNodeA === null || metaNodeB === null) return $5ee765e255617e6d$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $4EQkk.SortOrder).DESC ? -1 : 1) * $5ee765e255617e6d$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $5ee765e255617e6d$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $5ee765e255617e6d$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("4EQkk", function(module, exports) {

$parcel$export(module.exports, "SortOrder", () => $36437cdc9ee822cc$export$7ae723045d45777a);

var $eUuP5 = parcelRequire("eUuP5");

var $8Z9xr = parcelRequire("8Z9xr");
let $36437cdc9ee822cc$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});

});
parcelRegister("eUuP5", function(module, exports) {

$parcel$export(module.exports, "AnnotationUpdateEvent", () => $adae346fdacab78b$export$c1c4b33b4e7b1c70);

var $5zQU9 = parcelRequire("5zQU9");

var $3sTLs = parcelRequire("3sTLs");
let $adae346fdacab78b$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $adae346fdacab78b$export$7cc60aa9ef845515 {
    constructor(){
        (0, $5zQU9.default)(this, "emitter", new (0, (/*@__PURE__*/$parcel$interopDefault($3sTLs)))());
    }
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
}

});
parcelRegister("3sTLs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $285f3e4babf0bfc8$var$R = typeof Reflect === 'object' ? Reflect : null;
var $285f3e4babf0bfc8$var$ReflectApply = $285f3e4babf0bfc8$var$R && typeof $285f3e4babf0bfc8$var$R.apply === 'function' ? $285f3e4babf0bfc8$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $285f3e4babf0bfc8$var$ReflectOwnKeys;
if ($285f3e4babf0bfc8$var$R && typeof $285f3e4babf0bfc8$var$R.ownKeys === 'function') $285f3e4babf0bfc8$var$ReflectOwnKeys = $285f3e4babf0bfc8$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $285f3e4babf0bfc8$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $285f3e4babf0bfc8$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $285f3e4babf0bfc8$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $285f3e4babf0bfc8$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $285f3e4babf0bfc8$var$EventEmitter() {
    $285f3e4babf0bfc8$var$EventEmitter.init.call(this);
}
module.exports = $285f3e4babf0bfc8$var$EventEmitter;
module.exports.once = $285f3e4babf0bfc8$var$once;
// Backwards-compat with node 0.10.x
$285f3e4babf0bfc8$var$EventEmitter.EventEmitter = $285f3e4babf0bfc8$var$EventEmitter;
$285f3e4babf0bfc8$var$EventEmitter.prototype._events = undefined;
$285f3e4babf0bfc8$var$EventEmitter.prototype._eventsCount = 0;
$285f3e4babf0bfc8$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $285f3e4babf0bfc8$var$defaultMaxListeners = 10;
function $285f3e4babf0bfc8$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($285f3e4babf0bfc8$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $285f3e4babf0bfc8$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $285f3e4babf0bfc8$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $285f3e4babf0bfc8$var$defaultMaxListeners = arg;
    }
});
$285f3e4babf0bfc8$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$285f3e4babf0bfc8$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $285f3e4babf0bfc8$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $285f3e4babf0bfc8$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $285f3e4babf0bfc8$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $285f3e4babf0bfc8$var$_getMaxListeners(this);
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $285f3e4babf0bfc8$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $285f3e4babf0bfc8$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$285f3e4babf0bfc8$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $285f3e4babf0bfc8$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $285f3e4babf0bfc8$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $285f3e4babf0bfc8$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $285f3e4babf0bfc8$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $285f3e4babf0bfc8$var$_addListener(this, type, listener, false);
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.on = $285f3e4babf0bfc8$var$EventEmitter.prototype.addListener;
$285f3e4babf0bfc8$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $285f3e4babf0bfc8$var$_addListener(this, type, listener, true);
};
function $285f3e4babf0bfc8$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $285f3e4babf0bfc8$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $285f3e4babf0bfc8$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.once = function once(type, listener) {
    $285f3e4babf0bfc8$var$checkListener(listener);
    this.on(type, $285f3e4babf0bfc8$var$_onceWrap(this, type, listener));
    return this;
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $285f3e4babf0bfc8$var$checkListener(listener);
    this.prependListener(type, $285f3e4babf0bfc8$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$285f3e4babf0bfc8$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $285f3e4babf0bfc8$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $285f3e4babf0bfc8$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.off = $285f3e4babf0bfc8$var$EventEmitter.prototype.removeListener;
$285f3e4babf0bfc8$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $285f3e4babf0bfc8$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $285f3e4babf0bfc8$var$unwrapListeners(evlistener) : $285f3e4babf0bfc8$var$arrayClone(evlistener, evlistener.length);
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $285f3e4babf0bfc8$var$_listeners(this, type, true);
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $285f3e4babf0bfc8$var$_listeners(this, type, false);
};
$285f3e4babf0bfc8$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $285f3e4babf0bfc8$var$listenerCount.call(emitter, type);
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.listenerCount = $285f3e4babf0bfc8$var$listenerCount;
function $285f3e4babf0bfc8$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $285f3e4babf0bfc8$var$ReflectOwnKeys(this._events) : [];
};
function $285f3e4babf0bfc8$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $285f3e4babf0bfc8$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $285f3e4babf0bfc8$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $285f3e4babf0bfc8$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $285f3e4babf0bfc8$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $285f3e4babf0bfc8$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $285f3e4babf0bfc8$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $285f3e4babf0bfc8$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $285f3e4babf0bfc8$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRegister("8Z9xr", function(module, exports) {

$parcel$export(module.exports, "ToolbarSize", () => $68ab6b5d78e87606$export$ed55211407a9423);
$parcel$export(module.exports, "ToolbarWidths", () => $68ab6b5d78e87606$export$423b5e8c92d477b9);
$parcel$export(module.exports, "ToolbarWidthsFullPage", () => $68ab6b5d78e87606$export$63ca43752be70b90);
let $68ab6b5d78e87606$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});
let $68ab6b5d78e87606$export$423b5e8c92d477b9 = /*#__PURE__*/ function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    return ToolbarWidths;
}({});
let $68ab6b5d78e87606$export$63ca43752be70b90 = /*#__PURE__*/ function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    return ToolbarWidthsFullPage;
}({});

});



parcelRegister("ewmoR", function(module, exports) {

$parcel$export(module.exports, "layoutToWidth", () => $a9256e0618a928fe$export$9b77d38feba5446);
$parcel$export(module.exports, "getParentNodeWidth", () => $a9256e0618a928fe$export$d76cc081ce1449a8);
$parcel$export(module.exports, "getTableContainerWidth", () => $a9256e0618a928fe$export$3930799be057b305);

var $2zbl1 = parcelRequire("2zbl1");

var $25FYC = parcelRequire("25FYC");

var $lcnyw = parcelRequire("lcnyw");

var $hqoge = parcelRequire("hqoge");

var $lz5JQ = parcelRequire("lz5JQ");

var $khES4 = parcelRequire("khES4");
const $a9256e0618a928fe$export$9b77d38feba5446 = {
    default: (0, $25FYC.akEditorDefaultLayoutWidth),
    wide: (0, $25FYC.akEditorWideLayoutWidth),
    'full-width': (0, $25FYC.akEditorFullWidthLayoutWidth)
};
const $a9256e0618a928fe$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    if (!pos) return;
    const node = $a9256e0618a928fe$var$getNestedParentNode(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    let parentWidth = $a9256e0618a928fe$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled);
    // TODO: ED-15663
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            return state['contextPanelPluginKey$'];
        }
    };
    if (node.type === schema.nodes.layoutSection) {
        var _contextPanelPluginKe, _contextPanelPluginKe2;
        parentWidth += (0, $25FYC.akLayoutGutterOffset) * 2; // extra width that gets added to layout
        // Calculate width of parent layout column when
        // Parallel layout with viewport greater than 1024px
        // OR side panel of an extension is open and change the node width to smaller than containerWidth
        if (containerWidth.width > (0, $25FYC.gridMediumMaxWidth) || ((_contextPanelPluginKe = contextPanelPluginKey.getState(state)) === null || _contextPanelPluginKe === void 0 ? void 0 : _contextPanelPluginKe.contents.length) > 0 && ((_contextPanelPluginKe2 = contextPanelPluginKey.getState(state)) === null || _contextPanelPluginKe2 === void 0 ? void 0 : _contextPanelPluginKe2.contents[0]) !== undefined) {
            parentWidth -= ((0, $lz5JQ.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1); // margin between sections
            const $pos = state.doc.resolve(pos);
            const column = (0, $2zbl1.findParentNodeOfTypeClosestToPos)($pos, [
                state.schema.nodes.layoutColumn
            ]);
            if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
            parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
        }
    }
    // account for the padding of the parent node
    switch(node.type){
        case schema.nodes.layoutSection:
            parentWidth -= (0, $lz5JQ.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $hqoge.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $hqoge.BODIED_EXT_PADDING) * 2;
            break;
        // TODO: Migrate away from gridSize
        // Recommendation: Replace gridSize with 8
        case schema.nodes.expand:
            // padding
            parentWidth -= (0, $lcnyw.gridSize)() * 2;
            // gutter offset
            parentWidth += (0, $lcnyw.gridSize)() * 3;
            // padding right
            parentWidth -= (0, $lcnyw.gridSize)();
            // padding left
            parentWidth -= (0, $lcnyw.gridSize)() * 4 - (0, $lcnyw.gridSize)() / 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $a9256e0618a928fe$var$getNestedParentNode = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $2zbl1.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand
    ]);
    return parent ? parent.node : null;
};
const $a9256e0618a928fe$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled)=>{
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $25FYC.akEditorFullWidthLayoutWidth)) : (0, $khES4.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $a9256e0618a928fe$export$3930799be057b305 = (node)=>{
    if (node.attrs.width) return node.attrs.width;
    return $a9256e0618a928fe$export$9b77d38feba5446[node.attrs.layout];
};
const $a9256e0618a928fe$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $a9256e0618a928fe$export$3930799be057b305(node) - offset;
    return $a9256e0618a928fe$export$3930799be057b305(node);
};

});
parcelRegister("2zbl1", function(module, exports) {

$parcel$export(module.exports, "removeParentNodeOfType", () => $1de7a52bc852b126$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $1de7a52bc852b126$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $1de7a52bc852b126$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $1de7a52bc852b126$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $1de7a52bc852b126$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $1de7a52bc852b126$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $1de7a52bc852b126$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $1de7a52bc852b126$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $1de7a52bc852b126$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $1de7a52bc852b126$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $1de7a52bc852b126$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $1de7a52bc852b126$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $1de7a52bc852b126$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $1de7a52bc852b126$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $1de7a52bc852b126$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $1de7a52bc852b126$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $1de7a52bc852b126$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $1de7a52bc852b126$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $1de7a52bc852b126$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $1de7a52bc852b126$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $1de7a52bc852b126$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByType", () => $1de7a52bc852b126$export$96bb9476c7c69f39);
$parcel$export(module.exports, "contains", () => $1de7a52bc852b126$export$2344b14b097df817);
// src/selection.ts

var $kpTIW = parcelRequire("kpTIW");

var $7dkLM = parcelRequire("7dkLM");
var $1de7a52bc852b126$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $1de7a52bc852b126$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $1de7a52bc852b126$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $1de7a52bc852b126$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $1de7a52bc852b126$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $1de7a52bc852b126$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $1de7a52bc852b126$export$7d6e4e6663186878 = (tr)=>{
    if ($1de7a52bc852b126$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $1de7a52bc852b126$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $1de7a52bc852b126$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($1de7a52bc852b126$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $7dkLM.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $7dkLM.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $1de7a52bc852b126$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $kpTIW.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $1de7a52bc852b126$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $kpTIW.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $1de7a52bc852b126$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $7dkLM.Node) && node.type && node.type.spec.selectable);
var $1de7a52bc852b126$var$shouldSelectNode = (node)=>$1de7a52bc852b126$var$isSelectableNode(node) && node.type.isLeaf;
var $1de7a52bc852b126$var$setSelection = (node, pos, tr)=>{
    if ($1de7a52bc852b126$var$shouldSelectNode(node)) return tr.setSelection(new (0, $kpTIW.NodeSelection)(tr.doc.resolve(pos)));
    return $1de7a52bc852b126$export$1df6d14df6b0b758(pos)(tr);
};
var $1de7a52bc852b126$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $1de7a52bc852b126$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($1de7a52bc852b126$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $1de7a52bc852b126$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($1de7a52bc852b126$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $1de7a52bc852b126$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $1de7a52bc852b126$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $1de7a52bc852b126$var$setSelection(content, pos, tr);
            }
        }
        if ($1de7a52bc852b126$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $1de7a52bc852b126$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $1de7a52bc852b126$var$cloneTr($1de7a52bc852b126$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($1de7a52bc852b126$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $1de7a52bc852b126$var$cloneTr($1de7a52bc852b126$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $1de7a52bc852b126$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $1de7a52bc852b126$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $1de7a52bc852b126$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $1de7a52bc852b126$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$1de7a52bc852b126$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $1de7a52bc852b126$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $1de7a52bc852b126$var$cloneTr(tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $1de7a52bc852b126$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $1de7a52bc852b126$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $1de7a52bc852b126$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $1de7a52bc852b126$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $kpTIW.NodeSelection);
};
var $1de7a52bc852b126$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $1de7a52bc852b126$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $1de7a52bc852b126$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($1de7a52bc852b126$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $1de7a52bc852b126$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $1de7a52bc852b126$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $1de7a52bc852b126$var$cloneTr(tr);
        }
        return tr;
    };
var $1de7a52bc852b126$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $7dkLM.Fragment) ? content : (0, $7dkLM.Fragment).from(content));
};
var $1de7a52bc852b126$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $1de7a52bc852b126$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $1de7a52bc852b126$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $7dkLM.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $7dkLM.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $1de7a52bc852b126$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $1de7a52bc852b126$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $1de7a52bc852b126$export$fe09644e3bc6166b($from, predicate);
    };
var $1de7a52bc852b126$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $1de7a52bc852b126$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $1de7a52bc852b126$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $1de7a52bc852b126$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $1de7a52bc852b126$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$1de7a52bc852b126$export$dc159056ffdb4c76(predicate)(selection);
    };
var $1de7a52bc852b126$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $1de7a52bc852b126$export$dc159056ffdb4c76((node)=>$1de7a52bc852b126$var$equalNodeType(nodeType, node))(selection);
    };
var $1de7a52bc852b126$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $1de7a52bc852b126$export$fe09644e3bc6166b($pos, (node)=>$1de7a52bc852b126$var$equalNodeType(nodeType, node));
};
var $1de7a52bc852b126$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $1de7a52bc852b126$export$178ecaf80f45fdb6((node)=>$1de7a52bc852b126$var$equalNodeType(nodeType, node))(selection);
    };
var $1de7a52bc852b126$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $1de7a52bc852b126$export$8556d79fa8189214((node)=>$1de7a52bc852b126$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $1de7a52bc852b126$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($1de7a52bc852b126$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($1de7a52bc852b126$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $1de7a52bc852b126$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $kpTIW.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $1de7a52bc852b126$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $1de7a52bc852b126$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $1de7a52bc852b126$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $1de7a52bc852b126$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $1de7a52bc852b126$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $1de7a52bc852b126$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $1de7a52bc852b126$export$ddc1620722e25671 = (node, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $1de7a52bc852b126$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $1de7a52bc852b126$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $1de7a52bc852b126$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $1de7a52bc852b126$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $1de7a52bc852b126$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$1de7a52bc852b126$export$96bb9476c7c69f39(node, nodeType).length;
};

});
parcelRegister("kpTIW", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $edd15e116d766874$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $edd15e116d766874$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $edd15e116d766874$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $edd15e116d766874$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $edd15e116d766874$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $edd15e116d766874$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $edd15e116d766874$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $edd15e116d766874$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $edd15e116d766874$export$1692d8b0e89cecc3);

var $7dkLM = parcelRequire("7dkLM");

var $d6JJW = parcelRequire("d6JJW");
const $edd15e116d766874$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $edd15e116d766874$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $edd15e116d766874$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $7dkLM.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $7dkLM.Slice).empty : content);
            if (i == 0) $edd15e116d766874$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $edd15e116d766874$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $edd15e116d766874$export$c2b25f346d19bcbb($pos) : $edd15e116d766874$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $edd15e116d766874$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $edd15e116d766874$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $edd15e116d766874$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $edd15e116d766874$var$findSelectionIn(doc, doc, 0, 0, 1) || new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $edd15e116d766874$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $edd15e116d766874$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $edd15e116d766874$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $edd15e116d766874$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $edd15e116d766874$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$edd15e116d766874$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $edd15e116d766874$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $edd15e116d766874$var$warnedAboutTextSelection = false;
function $edd15e116d766874$var$checkTextSelection($pos) {
    if (!$edd15e116d766874$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $edd15e116d766874$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $edd15e116d766874$export$c2b25f346d19bcbb extends $edd15e116d766874$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $edd15e116d766874$var$checkTextSelection($anchor);
        $edd15e116d766874$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $edd15e116d766874$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $edd15e116d766874$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $7dkLM.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $7dkLM.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $edd15e116d766874$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $edd15e116d766874$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $edd15e116d766874$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $edd15e116d766874$export$52baac22726c72bf.findFrom($head, bias, true) || $edd15e116d766874$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $edd15e116d766874$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($edd15e116d766874$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $edd15e116d766874$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $edd15e116d766874$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$edd15e116d766874$export$52baac22726c72bf.jsonID("text", $edd15e116d766874$export$c2b25f346d19bcbb);
class $edd15e116d766874$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $edd15e116d766874$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $edd15e116d766874$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $edd15e116d766874$export$e2940151ac854c0b extends $edd15e116d766874$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $edd15e116d766874$export$52baac22726c72bf.near($pos);
        return new $edd15e116d766874$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $edd15e116d766874$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $edd15e116d766874$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $edd15e116d766874$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $edd15e116d766874$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$edd15e116d766874$export$e2940151ac854c0b.prototype.visible = false;
$edd15e116d766874$export$52baac22726c72bf.jsonID("node", $edd15e116d766874$export$e2940151ac854c0b);
class $edd15e116d766874$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $edd15e116d766874$var$TextBookmark(pos, pos) : new $edd15e116d766874$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $edd15e116d766874$export$e2940151ac854c0b.isSelectable(node)) return new $edd15e116d766874$export$e2940151ac854c0b($pos);
        return $edd15e116d766874$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $edd15e116d766874$export$c15d9ba76bdbcd95 extends $edd15e116d766874$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $7dkLM.Slice).empty) {
        if (content == (0, $7dkLM.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $edd15e116d766874$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $edd15e116d766874$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $edd15e116d766874$var$AllBookmark;
    }
}
$edd15e116d766874$export$52baac22726c72bf.jsonID("all", $edd15e116d766874$export$c15d9ba76bdbcd95);
const $edd15e116d766874$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $edd15e116d766874$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $edd15e116d766874$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $edd15e116d766874$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $edd15e116d766874$export$e2940151ac854c0b.isSelectable(child)) return $edd15e116d766874$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $edd15e116d766874$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $d6JJW.ReplaceStep) || step instanceof (0, $d6JJW.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($edd15e116d766874$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $edd15e116d766874$var$UPDATED_SEL = 1, $edd15e116d766874$var$UPDATED_MARKS = 2, $edd15e116d766874$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $edd15e116d766874$export$febc5573c75cefb0 extends (0, $d6JJW.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $edd15e116d766874$var$UPDATED_SEL) & ~$edd15e116d766874$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $edd15e116d766874$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $edd15e116d766874$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $7dkLM.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $edd15e116d766874$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$edd15e116d766874$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $7dkLM.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($edd15e116d766874$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $edd15e116d766874$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $edd15e116d766874$var$UPDATED_SCROLL) > 0;
    }
}
function $edd15e116d766874$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $edd15e116d766874$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $edd15e116d766874$var$bind(desc.init, self);
        this.apply = $edd15e116d766874$var$bind(desc.apply, self);
    }
}
const $edd15e116d766874$var$baseFields = [
    new $edd15e116d766874$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $edd15e116d766874$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $edd15e116d766874$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $edd15e116d766874$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $edd15e116d766874$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $edd15e116d766874$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $edd15e116d766874$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $edd15e116d766874$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $edd15e116d766874$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $edd15e116d766874$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $edd15e116d766874$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $edd15e116d766874$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $edd15e116d766874$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $edd15e116d766874$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $edd15e116d766874$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $edd15e116d766874$var$Configuration(config.schema, config.plugins);
        let instance = new $edd15e116d766874$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $7dkLM.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $edd15e116d766874$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $edd15e116d766874$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $edd15e116d766874$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $edd15e116d766874$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $edd15e116d766874$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $edd15e116d766874$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $edd15e116d766874$var$keys = Object.create(null);
function $edd15e116d766874$var$createKey(name) {
    if (name in $edd15e116d766874$var$keys) return name + "$" + ++$edd15e116d766874$var$keys[name];
    $edd15e116d766874$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $edd15e116d766874$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $edd15e116d766874$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("d6JJW", function(module, exports) {

$parcel$export(module.exports, "StepMap", () => $98af50e5743169ae$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $98af50e5743169ae$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $98af50e5743169ae$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $98af50e5743169ae$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $98af50e5743169ae$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $98af50e5743169ae$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $98af50e5743169ae$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $98af50e5743169ae$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $98af50e5743169ae$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $98af50e5743169ae$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $98af50e5743169ae$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $98af50e5743169ae$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $98af50e5743169ae$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $98af50e5743169ae$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $98af50e5743169ae$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $98af50e5743169ae$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $98af50e5743169ae$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $98af50e5743169ae$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $98af50e5743169ae$export$626399c38172f669);
$parcel$export(module.exports, "Transform", () => $98af50e5743169ae$export$563a914cafbdc389);

var $7dkLM = parcelRequire("7dkLM");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $98af50e5743169ae$var$lower16 = 0xffff;
const $98af50e5743169ae$var$factor16 = Math.pow(2, 16);
function $98af50e5743169ae$var$makeRecover(index, offset) {
    return index + offset * $98af50e5743169ae$var$factor16;
}
function $98af50e5743169ae$var$recoverIndex(value) {
    return value & $98af50e5743169ae$var$lower16;
}
function $98af50e5743169ae$var$recoverOffset(value) {
    return (value - (value & $98af50e5743169ae$var$lower16)) / $98af50e5743169ae$var$factor16;
}
const $98af50e5743169ae$var$DEL_BEFORE = 1, $98af50e5743169ae$var$DEL_AFTER = 2, $98af50e5743169ae$var$DEL_ACROSS = 4, $98af50e5743169ae$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $98af50e5743169ae$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $98af50e5743169ae$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($98af50e5743169ae$var$DEL_BEFORE | $98af50e5743169ae$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($98af50e5743169ae$var$DEL_AFTER | $98af50e5743169ae$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $98af50e5743169ae$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $98af50e5743169ae$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $98af50e5743169ae$export$c53d01c3ab9721b3.empty) return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $98af50e5743169ae$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $98af50e5743169ae$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $98af50e5743169ae$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $98af50e5743169ae$var$DEL_AFTER : pos == end ? $98af50e5743169ae$var$DEL_BEFORE : $98af50e5743169ae$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $98af50e5743169ae$var$DEL_SIDE;
                return new $98af50e5743169ae$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $98af50e5743169ae$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $98af50e5743169ae$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $98af50e5743169ae$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $98af50e5743169ae$export$c53d01c3ab9721b3.empty : new $98af50e5743169ae$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $98af50e5743169ae$export$c53d01c3ab9721b3.empty = new $98af50e5743169ae$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $98af50e5743169ae$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $98af50e5743169ae$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $98af50e5743169ae$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $98af50e5743169ae$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $98af50e5743169ae$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $98af50e5743169ae$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $98af50e5743169ae$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $98af50e5743169ae$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $98af50e5743169ae$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $98af50e5743169ae$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $98af50e5743169ae$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $98af50e5743169ae$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $98af50e5743169ae$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $7dkLM.ReplaceError)) return $98af50e5743169ae$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $98af50e5743169ae$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($98af50e5743169ae$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $7dkLM.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $98af50e5743169ae$export$d24ba56b0e3464a9 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $7dkLM.Slice)($98af50e5743169ae$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $98af50e5743169ae$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $98af50e5743169ae$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $98af50e5743169ae$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $98af50e5743169ae$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $98af50e5743169ae$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("addMark", $98af50e5743169ae$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $98af50e5743169ae$export$94150db1311f67a9 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $7dkLM.Slice)($98af50e5743169ae$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $98af50e5743169ae$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $98af50e5743169ae$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $98af50e5743169ae$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $98af50e5743169ae$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $98af50e5743169ae$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("removeMark", $98af50e5743169ae$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $98af50e5743169ae$export$adefd16c402fee4e extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $98af50e5743169ae$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $98af50e5743169ae$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $98af50e5743169ae$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $98af50e5743169ae$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $98af50e5743169ae$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("addNodeMark", $98af50e5743169ae$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $98af50e5743169ae$export$fdf7d1dc10724da2 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $98af50e5743169ae$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $98af50e5743169ae$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $98af50e5743169ae$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("removeNodeMark", $98af50e5743169ae$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $98af50e5743169ae$export$5c860b2e74034756 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $98af50e5743169ae$var$contentBetween(doc, this.from, this.to)) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $98af50e5743169ae$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $98af50e5743169ae$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $98af50e5743169ae$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $98af50e5743169ae$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $7dkLM.Slice).empty : new (0, $7dkLM.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $98af50e5743169ae$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $7dkLM.Slice).empty : new (0, $7dkLM.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $98af50e5743169ae$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $98af50e5743169ae$export$5c860b2e74034756(json.from, json.to, (0, $7dkLM.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("replace", $98af50e5743169ae$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $98af50e5743169ae$export$444ba800d6024a98 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($98af50e5743169ae$var$contentBetween(doc, this.from, this.gapFrom) || $98af50e5743169ae$var$contentBetween(doc, this.gapTo, this.to))) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $98af50e5743169ae$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $98af50e5743169ae$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = mapping.map(this.gapFrom, -1), gapTo = mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $98af50e5743169ae$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $98af50e5743169ae$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $7dkLM.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("replaceAround", $98af50e5743169ae$export$444ba800d6024a98);
function $98af50e5743169ae$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $98af50e5743169ae$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $98af50e5743169ae$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $98af50e5743169ae$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $98af50e5743169ae$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $7dkLM.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $98af50e5743169ae$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $98af50e5743169ae$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $98af50e5743169ae$export$5c860b2e74034756(cur, end, (0, $7dkLM.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $98af50e5743169ae$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (child.isText && !parentType.spec.code) {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $98af50e5743169ae$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $7dkLM.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $7dkLM.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $98af50e5743169ae$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $98af50e5743169ae$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$98af50e5743169ae$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $98af50e5743169ae$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $7dkLM.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $7dkLM.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $7dkLM.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $7dkLM.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $98af50e5743169ae$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $7dkLM.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $98af50e5743169ae$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $98af50e5743169ae$var$findWrappingOutside(range, nodeType);
    let inner = around && $98af50e5743169ae$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($98af50e5743169ae$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($98af50e5743169ae$var$withAttrs));
}
function $98af50e5743169ae$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $98af50e5743169ae$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $98af50e5743169ae$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $98af50e5743169ae$var$wrap(tr, range, wrappers) {
    let content = (0, $7dkLM.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $7dkLM.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $98af50e5743169ae$export$444ba800d6024a98(start, end, start, end, new (0, $7dkLM.Slice)(content, 0, 0), wrappers.length, true));
}
function $98af50e5743169ae$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.isTextblock && !node.hasMarkup(type, attrs) && $98af50e5743169ae$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            // Ensure all markup that isn't allowed in the new node type is cleared
            tr.clearIncompatible(tr.mapping.slice(mapFrom).map(pos, 1), type);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $98af50e5743169ae$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(type.create(attrs, null, node.marks)), 0, 0), 1, true));
            return false;
        }
    });
}
function $98af50e5743169ae$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $98af50e5743169ae$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $98af50e5743169ae$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $98af50e5743169ae$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $98af50e5743169ae$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $7dkLM.Fragment).empty, after = (0, $7dkLM.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $7dkLM.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $7dkLM.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $98af50e5743169ae$export$5c860b2e74034756(pos, pos, new (0, $7dkLM.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $98af50e5743169ae$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $98af50e5743169ae$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $98af50e5743169ae$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && a.canAppend(b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $98af50e5743169ae$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $98af50e5743169ae$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $98af50e5743169ae$var$join(tr, pos, depth) {
    let step = new $98af50e5743169ae$export$5c860b2e74034756(pos - depth, pos + depth, (0, $7dkLM.Slice).empty, true);
    tr.step(step);
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $98af50e5743169ae$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $98af50e5743169ae$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $98af50e5743169ae$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $7dkLM.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($98af50e5743169ae$var$fitsTrivially($from, $to, slice)) return new $98af50e5743169ae$export$5c860b2e74034756(from, to, slice);
    return new $98af50e5743169ae$var$Fitter($from, $to, slice).fit();
}
function $98af50e5743169ae$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $98af50e5743169ae$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $7dkLM.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $7dkLM.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $7dkLM.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $98af50e5743169ae$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $98af50e5743169ae$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $98af50e5743169ae$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $7dkLM.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $98af50e5743169ae$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $7dkLM.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $98af50e5743169ae$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($98af50e5743169ae$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $98af50e5743169ae$var$addToFragment(this.placed, frontierDepth, (0, $7dkLM.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $7dkLM.Slice).empty : new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$98af50e5743169ae$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $98af50e5743169ae$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $98af50e5743169ae$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $98af50e5743169ae$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $98af50e5743169ae$var$addToFragment(this.placed, this.depth, (0, $7dkLM.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $7dkLM.Fragment).empty, true);
        if (add.childCount) this.placed = $98af50e5743169ae$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $98af50e5743169ae$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($98af50e5743169ae$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $98af50e5743169ae$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($98af50e5743169ae$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $98af50e5743169ae$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $98af50e5743169ae$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $98af50e5743169ae$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $7dkLM.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $98af50e5743169ae$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$98af50e5743169ae$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $98af50e5743169ae$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $98af50e5743169ae$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $98af50e5743169ae$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($98af50e5743169ae$var$fitsTrivially($from, $to, slice)) return tr.step(new $98af50e5743169ae$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $98af50e5743169ae$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $98af50e5743169ae$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $7dkLM.Slice)($98af50e5743169ae$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $98af50e5743169ae$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($98af50e5743169ae$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $7dkLM.Fragment).empty, true));
    }
    return fragment;
}
function $98af50e5743169ae$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $98af50e5743169ae$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(node), 0, 0));
}
function $98af50e5743169ae$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $98af50e5743169ae$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $98af50e5743169ae$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $98af50e5743169ae$export$626399c38172f669 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $98af50e5743169ae$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $98af50e5743169ae$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $98af50e5743169ae$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("attr", $98af50e5743169ae$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $98af50e5743169ae$export$f50707b396300ac9 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $98af50e5743169ae$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $98af50e5743169ae$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $98af50e5743169ae$export$f50707b396300ac9(json.attr, json.value);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("docAttr", $98af50e5743169ae$export$f50707b396300ac9);
/**
@internal
*/ let $98af50e5743169ae$export$88cc3a1dfce48dd3 = class extends Error {
};
$98af50e5743169ae$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$98af50e5743169ae$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$98af50e5743169ae$export$88cc3a1dfce48dd3.prototype.constructor = $98af50e5743169ae$export$88cc3a1dfce48dd3;
$98af50e5743169ae$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $98af50e5743169ae$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $98af50e5743169ae$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $98af50e5743169ae$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $7dkLM.Slice).empty) {
        let step = $98af50e5743169ae$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $7dkLM.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $98af50e5743169ae$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $98af50e5743169ae$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $98af50e5743169ae$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $98af50e5743169ae$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $98af50e5743169ae$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $98af50e5743169ae$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $98af50e5743169ae$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $98af50e5743169ae$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $98af50e5743169ae$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $98af50e5743169ae$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $98af50e5743169ae$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $7dkLM.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $98af50e5743169ae$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $98af50e5743169ae$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $98af50e5743169ae$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $98af50e5743169ae$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $98af50e5743169ae$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});



parcelRegister("hqoge", function(module, exports) {

$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $caf7af154d3789e4$export$5ac5087fe1217160);
$parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", () => $caf7af154d3789e4$export$91624ec52c59c24c);
const $caf7af154d3789e4$export$f5ecdce4c60ff98b = 8;
const $caf7af154d3789e4$export$5ac5087fe1217160 = $caf7af154d3789e4$export$f5ecdce4c60ff98b * 2;
const $caf7af154d3789e4$export$91624ec52c59c24c = 12;

});

parcelRegister("lz5JQ", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $fb315169f28e402e$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $fb315169f28e402e$export$a1bb91aa2d5fcce8);
const $fb315169f28e402e$export$cd04f19842abff0 = 8;
const $fb315169f28e402e$export$a1bb91aa2d5fcce8 = $fb315169f28e402e$export$cd04f19842abff0 * 1.5;

});


parcelRegister("15sgt", function(module, exports) {

$parcel$export(module.exports, "FullPagePadding", () => $0cac2eda9f8af1fb$export$12fd658e5eef0d79);
$parcel$export(module.exports, "TELEPOINTER_ID", () => $0cac2eda9f8af1fb$export$74b525449cc7cbd1);
$parcel$export(module.exports, "rendererStyles", () => $0cac2eda9f8af1fb$export$1c4377249312209);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");

var $juktg = parcelRequire("juktg");

var $3v247 = parcelRequire("3v247");

var $6ehX9 = parcelRequire("6ehX9");
var $6qOKj = parcelRequire("6qOKj");
var $3GCBC = parcelRequire("3GCBC");
var $4zXyh = parcelRequire("4zXyh");
var $lEH5E = parcelRequire("lEH5E");
var $e4fK9 = parcelRequire("e4fK9");
var $cUhp3 = parcelRequire("cUhp3");
var $9r3g7 = parcelRequire("9r3g7");
var $dEHJr = parcelRequire("dEHJr");
var $7Ytiu = parcelRequire("7Ytiu");
var $iL3YW = parcelRequire("iL3YW");
var $7BdzB = parcelRequire("7BdzB");
var $14KqW = parcelRequire("14KqW");
var $9WTTi = parcelRequire("9WTTi");
var $fgrpX = parcelRequire("fgrpX");
var $eddf8 = parcelRequire("eddf8");
var $dSQba = parcelRequire("dSQba");
var $8xoI5 = parcelRequire("8xoI5");

var $kRTSM = parcelRequire("kRTSM");
var $cEslD = parcelRequire("cEslD");

var $ckjIr = parcelRequire("ckjIr");

var $25FYC = parcelRequire("25FYC");

var $h1C70 = parcelRequire("h1C70");

var $64BVr = parcelRequire("64BVr");

var $c1PWl = parcelRequire("c1PWl");

var $hP4fj = parcelRequire("hP4fj");
const $0cac2eda9f8af1fb$export$12fd658e5eef0d79 = 32;
const $0cac2eda9f8af1fb$var$tableShadowWidth = 32;
const $0cac2eda9f8af1fb$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';
const $0cac2eda9f8af1fb$var$telepointerStyles = ()=>{
    const { colorMode: colorMode } = (0, $juktg.default)();
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
    return (0, $byn9U.css)`
    #${$0cac2eda9f8af1fb$export$74b525449cc7cbd1} {
      display: inline-block;
      position: relative;
      width: 1.5px;
      height: 25px;
      background: linear-gradient(
        45deg,
        ${colorMode === 'dark' ? '#f5cd47' : '#f8e6a0'} -12.02%,
        ${colorMode === 'dark' ? '#60c6d2' : '#8bdbe5'} 19.18%,
        ${colorMode === 'dark' ? '#388bff' : '#0c66e4'} 71.87%
      );
      margin-left: ${"var(--ds-space-025, 2px)"};

      &::after {
        content: 'AI';
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        font-size: 10px;
        font-weight: 700;
        width: 12.5px;
        height: 13px;
        padding-top: 1px;
        padding-left: 1.5px;
        line-height: initial;
        border-radius: 0px 2px 2px 0px;
        color: ${"var(--ds-text-inverse, white)"};
        background: linear-gradient(
          45deg,
          ${colorMode === 'dark' ? '#60c6d2' : '#8bdbe5'} -57%,
          ${colorMode === 'dark' ? '#388bff' : '#0c66e4'} 71.87%
        );
      }
    }
  `;
};
const $0cac2eda9f8af1fb$var$getLineHeight = (fontCode)=>(0, $4lTFP.headingSizes)[fontCode].lineHeight / (0, $4lTFP.headingSizes)[fontCode].size;
const $0cac2eda9f8af1fb$export$bc02e067df412c3b = {
    h1: {
        lineHeight: $0cac2eda9f8af1fb$var$getLineHeight('h700')
    },
    h2: {
        lineHeight: $0cac2eda9f8af1fb$var$getLineHeight('h600')
    },
    h3: {
        lineHeight: $0cac2eda9f8af1fb$var$getLineHeight('h500')
    },
    h4: {
        lineHeight: $0cac2eda9f8af1fb$var$getLineHeight('h400')
    },
    h5: {
        lineHeight: $0cac2eda9f8af1fb$var$getLineHeight('h300')
    },
    h6: {
        lineHeight: $0cac2eda9f8af1fb$var$getLineHeight('h100')
    }
};
const $0cac2eda9f8af1fb$var$headingAnchorStyle = (headingTag)=>// TODO Delete this comment after verifying space token -> previous value `margin-left: 6px`
    (0, $byn9U.css)`
    /**
     * The copy link button doesn't reserve space in the DOM so that
     * the text alignment isn't impacted by the button/icon's space.
     */
    .${0, $64BVr.HeadingAnchorWrapperClassName} {
      position: absolute;
      height: ${$0cac2eda9f8af1fb$export$bc02e067df412c3b[headingTag].lineHeight}em;

      margin-left: ${"var(--ds-space-075, 6px)"};

      button {
        padding-left: 0;
        padding-right: 0;
      }
    }

    /**
     * Applies hover effects to the heading anchor link button
     * to fade in when the user rolls over the heading.
     *
     * The link is persistent on mobile, so we use feature detection
     * to enable hover effects for systems that support it (desktop).
     *
     * @see https://caniuse.com/mdn-css_at-rules_media_hover
     */
    @media (hover: hover) and (pointer: fine) {
      .${0, $64BVr.HeadingAnchorWrapperClassName} {
        > button {
          opacity: 0;
          transform: translate(-8px, 0px);
          transition: opacity 0.2s ease 0s, transform 0.2s ease 0s;
        }
      }

      &:hover {
        .${0, $64BVr.HeadingAnchorWrapperClassName} > button {
          opacity: 1;
          transform: none !important;
        }
      }
    }

    /**
     * Adds the visibility of the button when in focus through keyboard navigation.
     */
    .${0, $64BVr.HeadingAnchorWrapperClassName} {
      button:focus {
        opacity: 1;
        transform: none !important;
      }
    }
  `;
const $0cac2eda9f8af1fb$var$alignedHeadingAnchorStyle = ({ allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
    if (!allowNestedHeaderLinks) return '';
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    return (0, $byn9U.css)`
    .fabric-editor-block-mark[data-align] > {
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        position: relative;
      }
    }

    /**
     * For right-alignment we flip the link to be before the heading
     * text so that the text is flush up against the edge of the editor's
     * container edge.
     */
    .fabric-editor-block-mark:not([data-align='center'])[data-align] {
      > {
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
          // Using right to left text to achieve the inverse effect
          // of where the copy link button icon sits for left/center
          // alignment.
          // Although this is unorthodox it's the only approach which
          // allows the button to sit flush against the left edge of
          // bottom line of text.
          direction: rtl;

          // By default RTL will negatively impact the layout of special
          // characters within the heading text, and potentially other
          // nested inline nodes. To prevent this we insert pseudo elements
          // containing HTML entities to retain LTR for all heading content
          // except for the copy link button.
          > *:not(.${0, $64BVr.HeadingAnchorWrapperClassName}):not(br) {
            ::before {
              // Open LTR: https://www.fileformat.info/info/unicode/char/202a/index.htm
              content: '\u202A';
            }
            ::after {
              // Close LTR: https://www.fileformat.info/info/unicode/char/202c/index.htm
              content: '\u202C';
            }
          }
        }
      }
      .${0, $64BVr.HeadingAnchorWrapperClassName} {
        margin: 0 ${"var(--ds-space-075, 6px)"} 0 0;
      }

      @media (hover: hover) and (pointer: fine) {
        .${0, $64BVr.HeadingAnchorWrapperClassName} > button {
          transform: translate(8px, 0px);
        }
      }
    }
  `;
};
const $0cac2eda9f8af1fb$var$tableSortableColumnStyle = ({ allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
    if (!allowColumnSorting) return '';
    let headingsCss = '';
    if (allowNestedHeaderLinks) headingsCss = `
      /**
       * When the sort button is enabled we want the heading's copy link button
       * to reserve space so that it can prematurely wrap to avoid the button
       * being displayed underneath the sort button (hidden or obscured).
       *
       * The two buttons fight each other since the sort button is displayed
       * on hover of the <th /> and the copy link button is displayed on hover
       * of the heading.
       *
       * Note that this can break the WYSIWYG experience in the case where
       * a heading fills the width of the table cell and the only thing which
       * wraps is the copy link button. This is hopefully a rare fringe case.
       */
      .${0, $64BVr.HeadingAnchorWrapperClassName} {
        position: unset;
      }
      > {
        h1, h2, h3, h4, h5, h6 {
          margin-right: 30px;
        }
      }
    `;
    return (0, $byn9U.css)`
    .${(0, $h1C70.RendererCssClassName).SORTABLE_COLUMN_WRAPPER} {
      padding: 0;

      .${(0, $h1C70.RendererCssClassName).SORTABLE_COLUMN} {
        width: 100%;
        height: 100%;
        padding: ${0, $fgrpX.tableCellPadding}px;
        border-width: 1.5px;
        border-style: solid;
        border-color: transparent;

        > *:first-child {
          margin-top: 0;
        }

        > .ProseMirror-gapcursor:first-child + *,
        > style:first-child + .ProseMirror-gapcursor + * {
          margin-top: 0;
        }

        > .ProseMirror-gapcursor:first-child + span + *,
        > style:first-child + .ProseMirror-gapcursor + span + * {
          margin-top: 0;
        }

        @supports selector(:focus-visible) {
          &:focus {
            outline: unset;
          }
          &:focus-visible {
            border-color: ${`var(--ds-border-focused, ${$PdmhA.B300})`};
          }
        }

        ${headingsCss}
      }

      .${(0, $h1C70.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} {
        margin: 0;
        .${(0, $h1C70.RendererCssClassName).SORTABLE_COLUMN_ICON} {
          opacity: 1;
          transition: opacity 0.2s ease-in-out;
        }
      }

      .${(0, $h1C70.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER} {
        .${(0, $h1C70.RendererCssClassName).SORTABLE_COLUMN_ICON} {
          opacity: 0;
          &:focus {
            opacity: 1;
          }
        }
      }

      &:hover {
        .${(0, $h1C70.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER} {
          .${(0, $h1C70.RendererCssClassName).SORTABLE_COLUMN_ICON} {
            opacity: 1;
          }
        }
      }
    }
  `;
};
const $0cac2eda9f8af1fb$var$fullPageStyles = ({ appearance: appearance }, { theme: theme })=>{
    if (appearance !== 'full-page' && appearance !== 'mobile') return '';
    return (0, $byn9U.css)`
    max-width: ${theme && theme.layoutMaxWidth ? `${theme.layoutMaxWidth}px` : 'none'};
    margin: 0 auto;
    padding: 0 ${appearance === 'full-page' ? $0cac2eda9f8af1fb$export$12fd658e5eef0d79 : 0}px;
  `;
};
const $0cac2eda9f8af1fb$var$fullWidthStyles = ({ appearance: appearance })=>{
    if (appearance !== 'full-width') return '';
    return (0, $byn9U.css)`
    max-width: ${0, $25FYC.akEditorFullWidthLayoutWidth}px;
    margin: 0 auto;

    .fabric-editor-breakout-mark,
    .ak-renderer-extension {
      width: 100% !important;
    }

    ${(0, $hP4fj.isTableResizingEnabled)(appearance) ? '' : `
      .pm-table-container {
        width: 100% !important;
      }
    `}
  `;
};
const $0cac2eda9f8af1fb$var$breakoutWidthStyle = ()=>{
    return (0, $byn9U.css)`
    *:not([data-mark-type='fragment'])
      .${(0, $fgrpX.TableSharedCssClassName).TABLE_CONTAINER} {
      // TODO - improve inline style logic on table container so important styles aren't required here
      width: 100% !important;
      left: 0 !important;
    }

    [data-mark-type='fragment'] * .${(0, $fgrpX.TableSharedCssClassName).TABLE_CONTAINER} {
      // TODO - improve inline style logic on table container so important styles aren't required here
      width: 100% !important;
      left: 0 !important;
    }
  `;
};
const $0cac2eda9f8af1fb$var$getShadowOverrides = ()=>{
    return (0, $byn9U.css)`
    /** Shadow overrides */
    &.${(0, $kRTSM.shadowClassNames).RIGHT_SHADOW}::after,
      &.${(0, $kRTSM.shadowClassNames).LEFT_SHADOW}::before {
      width: ${$0cac2eda9f8af1fb$var$tableShadowWidth}px;
      background: linear-gradient(
          to left,
          transparent 0,
          ${`var(--ds-shadow-overflow-spread, ${0, $PdmhA.N40A})`} 140%
        ),
        linear-gradient(
          to right,
          ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
          transparent 1px
        );
    }

    &.${(0, $kRTSM.shadowClassNames).RIGHT_SHADOW}::after {
      background: linear-gradient(
          to right,
          transparent 0,
          ${`var(--ds-shadow-overflow-spread, ${0, $PdmhA.N40A})`} 140%
        ),
        linear-gradient(
          to left,
          ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
          transparent 1px
        );
      right: 0px;
    }
  `;
};
const $0cac2eda9f8af1fb$export$1c4377249312209 = (wrapperProps)=>(theme)=>{
        // This is required to be compatible with styled-components prop structure.
        const themeProps = {
            theme: theme
        };
        const { useBlockRenderForCodeBlock: useBlockRenderForCodeBlock } = wrapperProps;
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/no-css-tagged-template-expression
        return (0, $byn9U.css)`
      font-size: ${(0, $25FYC.editorFontSize)(themeProps)}px;
      line-height: 1.5rem;
      color: ${`var(--ds-text, ${$PdmhA.N800})`};

      .${(0, $h1C70.RendererCssClassName).DOCUMENT}::after {
        // we add a clearfix after ak-renderer-document in order to
        // contain internal floats (such as media images that are "wrap-left")
        // to just the renderer (and not spill outside of it)
        content: '';
        visibility: hidden;
        display: block;
        height: 0;
        clear: both;
      }

      ${$0cac2eda9f8af1fb$var$fullPageStyles(wrapperProps, themeProps)}
      ${$0cac2eda9f8af1fb$var$fullWidthStyles(wrapperProps)}

      .${(0, $h1C70.RendererCssClassName).DOCUMENT} {
        ${0, $3v247.mediaInlineImageStyles}
      }

      & h1 {
        ${$0cac2eda9f8af1fb$var$headingAnchorStyle('h1')}
      }

      & h2 {
        ${$0cac2eda9f8af1fb$var$headingAnchorStyle('h2')}
      }

      & h3 {
        ${$0cac2eda9f8af1fb$var$headingAnchorStyle('h3')}
      }

      & h4 {
        ${$0cac2eda9f8af1fb$var$headingAnchorStyle('h4')}
      }

      & h5 {
        ${$0cac2eda9f8af1fb$var$headingAnchorStyle('h5')}
      }

      & h6 {
        ${$0cac2eda9f8af1fb$var$headingAnchorStyle('h6')}
      }

      & span.akActionMark {
        color: ${`var(--ds-link, ${$PdmhA.B400})`};
        text-decoration: none;

        &:hover {
          color: ${`var(--ds-link, ${$PdmhA.B300})`};
          text-decoration: underline;
        }

        &:active {
          color: ${`var(--ds-link-pressed, ${$PdmhA.B500})`};
        }
      }

      & span.akActionMark {
        cursor: pointer;
      }

      & span[data-placeholder] {
        color: ${`var(--ds-text-subtlest, ${$PdmhA.N200})`};
      }

      ${$0cac2eda9f8af1fb$var$telepointerStyles()}
      ${0, $8xoI5.whitespaceSharedStyles};
      ${0, $6qOKj.blockquoteSharedStyles};
      ${(0, $cUhp3.headingsSharedStyles)()};
      ${(0, $7BdzB.ruleSharedStyles)()};
      ${0, $iL3YW.paragraphSharedStyles};
      ${0, $dEHJr.listsSharedStyles};
      ${0, $9r3g7.indentationSharedStyles};
      ${0, $6ehX9.blockMarksSharedStyles};
      ${(0, $4zXyh.codeMarkSharedStyles)()};
      ${0, $14KqW.shadowSharedStyle};
      ${0, $e4fK9.dateSharedStyle};
      ${0, $dSQba.textColorStyles};
      ${0, $eddf8.tasksAndDecisionsStyles};
      ${0, $9WTTi.smartCardSharedStyles}

      & .UnknownBlock {
        font-family: ${(0, $lcnyw.fontFamily)()};
        font-size: ${(0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)())};
        font-weight: 400;
        white-space: pre-wrap;
        word-wrap: break-word;
      }

      & span.date-node {
        background: ${`var(--ds-background-neutral, ${$PdmhA.N30A})`};
        border-radius: ${"var(--ds-border-radius-100, 3px)"};
        color: ${`var(--ds-text, ${$PdmhA.N800})`};
        padding: ${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"};
        margin: 0 1px;
        transition: background 0.3s;
      }

      & span.date-node-highlighted {
        background: ${`var(--ds-background-danger, ${$PdmhA.R50})`};
        color: ${`var(--ds-text-danger, ${$PdmhA.R500})`};
      }

      & .renderer-image {
        max-width: 100%;
        display: block;
        margin: ${"var(--ds-space-300, 24px)"} 0;
      }

      .${0, $7Ytiu.richMediaClassName}.rich-media-wrapped
        + .${0, $7Ytiu.richMediaClassName}:not(.rich-media-wrapped) {
        clear: both;
      }

      & .code-block,
      & blockquote,
      & hr,
      & > div > div:not(.rich-media-wrapped),
      .${0, $7Ytiu.richMediaClassName}.rich-media-wrapped
        + .rich-media-wrapped
        + *:not(.rich-media-wrapped),
      .${0, $7Ytiu.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
      .${0, $7Ytiu.richMediaClassName}.image-align-start,
        .${0, $7Ytiu.richMediaClassName}.image-center,
        .${0, $7Ytiu.richMediaClassName}.image-align-end {
        clear: both;
      }

      & .rich-media-wrapped {
        & + h1,
        & + h2,
        & + h3,
        & + h4,
        & + h5,
        & + h6 {
          margin-top: ${"var(--ds-space-100, 8px)"};
        }
      }

      ${$0cac2eda9f8af1fb$var$alignedHeadingAnchorStyle(wrapperProps)}
      /* plugin styles */
    ${0, $7Ytiu.mediaSingleSharedStyle} &
    div[class^='image-wrap-'] + div[class^='image-wrap-'] {
        margin-left: 0;
        margin-right: 0;
      }

      /* Breakout for tables and extensions */
      .${(0, $h1C70.RendererCssClassName).DOCUMENT} > {
        ${$0cac2eda9f8af1fb$var$breakoutWidthStyle()}

        * .${(0, $h1C70.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER} {
          overflow-x: auto;
        }

        & .${(0, $h1C70.RendererCssClassName).EXTENSION}:first-child {
          margin-top: 0;
        }
      }

      .${(0, $h1C70.RendererCssClassName).DOCUMENT} {
        .${(0, $h1C70.RendererCssClassName).EXTENSION} {
          margin-top: ${0, $25FYC.blockNodesVerticalMargin};
        }

        .${(0, $h1C70.RendererCssClassName).EXTENSION_CENTER_ALIGN} {
          margin-left: 50%;
          transform: translateX(-50%);
        }

        .${(0, $fgrpX.TableSharedCssClassName).TABLE_NODE_WRAPPER} {
          overflow-x: auto;
        }

        .${(0, $cEslD.shadowObserverClassNames).SHADOW_CONTAINER}
          .${(0, $fgrpX.TableSharedCssClassName).TABLE_NODE_WRAPPER} {
          display: flex;
        }
      }

      ${(0, $fgrpX.tableSharedStyle)()}

      .${(0, $h1C70.RendererCssClassName).DOCUMENT} .${(0, $fgrpX.TableSharedCssClassName).TABLE_CONTAINER} {
        z-index: 0;
        transition: all 0.1s linear;
        display: flex; /* needed to avoid position: fixed jumpiness in Chrome */

        /** Shadow overrides */
        &.${(0, $kRTSM.shadowClassNames).RIGHT_SHADOW}::after,
          &.${(0, $kRTSM.shadowClassNames).LEFT_SHADOW}::before {
          top: ${(0, $fgrpX.tableMarginTop) - 1}px;
          height: calc(100% - ${0, $fgrpX.tableMarginTop}px);
          z-index: ${0, $25FYC.akEditorStickyHeaderZIndex};
        }

        ${$0cac2eda9f8af1fb$var$getShadowOverrides()}

        &
          .${(0, $cEslD.shadowObserverClassNames).SENTINEL_LEFT},
          &
          .${(0, $cEslD.shadowObserverClassNames).SENTINEL_RIGHT} {
          height: calc(100% - ${0, $fgrpX.tableMarginTop}px);
        }

        /**
     * A hack for making all the <th /> heights equal in case some have shorter
     * content than others.
     *
     * This is done to make sort buttons fill entire <th />.
     */
        table {
          height: 1px; /* will be ignored */
          ${$0cac2eda9f8af1fb$var$tableSortableColumnStyle(wrapperProps)};
          margin-left: 0;
          margin-right: 0;
        }

        table tr:first-of-type {
          height: 100%;

          td,
          th {
            position: relative;
          }
        }

        table[data-number-column='true'] {
          .${(0, $h1C70.RendererCssClassName).NUMBER_COLUMN} {
            background-color: ${`var(--ds-background-neutral, ${0, $25FYC.akEditorTableToolbar})`};
            border-right: 1px solid
              ${`var(--ds-background-accent-gray-subtler, ${0, $25FYC.akEditorTableBorder})`};
            width: ${0, $25FYC.akEditorTableNumberColumnWidth}px;
            text-align: center;
            color: ${`var(--ds-text-subtlest, ${$PdmhA.N200})`};
            font-size: ${(0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)())};
          }

          .fixed .${(0, $h1C70.RendererCssClassName).NUMBER_COLUMN} {
            border-right: 0px none;
          }
        }
      }

      tr[data-header-row].fixed {
        position: fixed !important;
        display: flex;
        overflow: hidden;
        z-index: ${0, $25FYC.akEditorStickyHeaderZIndex};

        border-right: 1px solid
          ${`var(--ds-background-accent-gray-subtler, ${0, $25FYC.akEditorTableBorder})`};
        border-bottom: 1px solid
          ${`var(--ds-background-accent-gray-subtler, ${0, $25FYC.akEditorTableBorder})`};

        /* this is to compensate for the table border */
        transform: translateX(-1px);
      }

      .sticky > th {
        z-index: ${0, $25FYC.akEditorStickyHeaderZIndex};
        position: sticky !important;
        top: 0;
      }

      /* Make the number column header sticky */
      .sticky > td {
        position: sticky !important;
        top: 0;
      }

      /* add border for position: sticky
     and work around background-clip: padding-box
     bug for FF causing box-shadow bug in Chrome */
      .sticky th,
      .sticky td {
        box-shadow: 0px 1px
            ${`var(--ds-background-accent-gray-subtler, ${0, $25FYC.akEditorTableBorder})`},
          0px -0.5px ${`var(--ds-background-accent-gray-subtler, ${0, $25FYC.akEditorTableBorder})`},
          inset -1px 0px ${`var(--ds-background-accent-gray-subtler, ${0, $25FYC.akEditorTableToolbar})`},
          0px -1px ${`var(--ds-background-accent-gray-subtler, ${0, $25FYC.akEditorTableToolbar})`};
      }

      /* this will remove jumpiness caused in Chrome for sticky headers */
      .fixed + tr {
        min-height: 0px;
      }

      /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */
      & .code-block {
        max-width: 100%;
        /* -ms- properties are necessary until MS supports the latest version of the grid spec */
        /* stylelint-disable value-no-vendor-prefix, declaration-block-no-duplicate-properties */
        display: block;
        /* stylelint-enable */

        position: relative;
        border-radius: ${"var(--ds-border-radius-100, 3px)"};

        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */
        word-wrap: normal;
      }

      & .MediaGroup,
      & .code-block {
        margin-top: ${0, $25FYC.blockNodesVerticalMargin};

        &:first-child {
          margin-top: 0;
        }
      }

      ${$0cac2eda9f8af1fb$var$useGridRenderForCodeBlock(useBlockRenderForCodeBlock)}

      ${(0, $c1PWl.getLightWeightCodeBlockStylesForRootRendererStyleSheet)()}

      ${0, $lEH5E.columnLayoutSharedStyle};
      & [data-layout-section] {
        margin-top: ${"var(--ds-space-250, 20px)"};
        & > div + div {
          margin-left: ${"var(--ds-space-400, 32px)"};
        }

        @media screen and (max-width: ${0, $25FYC.gridMediumMaxWidth}px) {
          & > div + div {
            margin-left: 0;
          }
        }

        & .MediaGroup,
        & .code-block {
          margin-top: ${0, $25FYC.blockNodesVerticalMargin};

          &:first-child {
            margin-top: 0;
          }
        }
      }

      & li {
        > .code-block {
          margin: ${0, $25FYC.blockNodesVerticalMargin} 0 0 0;
        }
        > .code-block:first-child {
          margin-top: 0;
        }

        > div:last-of-type.code-block {
          margin-bottom: ${0, $25FYC.blockNodesVerticalMargin};
        }
      }

      &:not([data-node-type='decisionList']) > li,
      // This prevents https://product-fabric.atlassian.net/browse/ED-20924
      &:not(.${(0, $9WTTi.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li {
        ${(0, $ckjIr.default).safari ? (0, $3GCBC.codeBlockInListSafariFix) : ''}
      }
    `;
    };
const $0cac2eda9f8af1fb$var$useGridRenderForCodeBlock = (codeBlockRenderAsBlock)=>{
    if (codeBlockRenderAsBlock) return '';
    return `& .code-block {
       /* -ms- properties are necessary until MS supports the latest version of the grid spec */
       /* stylelint-disable value-no-vendor-prefix, declaration-block-no-duplicate-properties */
       display: -ms-grid;
       display: grid;
       -ms-grid-columns: auto 1fr;
       /* stylelint-enable */

       grid-template-columns: minmax(0, 1fr);

       & > span {
         /* stylelint-disable value-no-vendor-prefix */
         -ms-grid-row: 1;
         -ms-grid-column: 2;
         /* stylelint-enable */
         grid-column: 1;
       }
     }`;
};

});
parcelRegister("3v247", function(module, exports) {

$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $28c5de7f9da53f60$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $28c5de7f9da53f60$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $28c5de7f9da53f60$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $28c5de7f9da53f60$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "mediaInlineImageStyles", () => $28c5de7f9da53f60$export$dee15762144889b7);
$parcel$export(module.exports, "wrapperStyle", () => $28c5de7f9da53f60$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $28c5de7f9da53f60$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "interactiveStyle", () => $28c5de7f9da53f60$export$ac950970e139031e);
$parcel$export(module.exports, "borderStyle", () => $28c5de7f9da53f60$export$4d0a7f76ad443516);

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $dkvza = parcelRequire("dkvza");
const $28c5de7f9da53f60$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $28c5de7f9da53f60$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $28c5de7f9da53f60$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $28c5de7f9da53f60$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $28c5de7f9da53f60$var$inlineImageHeight = (height, margin = 0)=>(0, $byn9U.css)`
  /* Editor style */
  > .mediaInlineView-content-wrap > .${$28c5de7f9da53f60$export$dd2e16f83ae6aa78},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${$28c5de7f9da53f60$export$dd2e16f83ae6aa78},
  /* Renderer style */
  > .${$28c5de7f9da53f60$export$dd2e16f83ae6aa78},
  > :is(a, span[data-mark-type='border']) .${$28c5de7f9da53f60$export$dd2e16f83ae6aa78} {
    height: ${height}px;
    transform: translateY(${margin}px);
  }
`;
const $28c5de7f9da53f60$export$dee15762144889b7 = (0, $byn9U.css)`
  // p, h3, and action items
  .${$28c5de7f9da53f60$export$dd2e16f83ae6aa78} {
    height: ${(0, $dkvza.referenceHeights)['p']}px;
    transform: translateY(-2px);
  }

  h1 {
    ${$28c5de7f9da53f60$var$inlineImageHeight((0, $dkvza.referenceHeights)['h1'], -3)}
  }

  h2 {
    ${$28c5de7f9da53f60$var$inlineImageHeight((0, $dkvza.referenceHeights)['h2'], -3)}
  }

  h3 {
    ${$28c5de7f9da53f60$var$inlineImageHeight((0, $dkvza.referenceHeights)['h3'], -2)}
  }

  h4 {
    ${$28c5de7f9da53f60$var$inlineImageHeight((0, $dkvza.referenceHeights)['h4'], -2)}
  }

  h5 {
    ${$28c5de7f9da53f60$var$inlineImageHeight((0, $dkvza.referenceHeights)['h5'], -2)}
  }

  h6 {
    ${$28c5de7f9da53f60$var$inlineImageHeight((0, $dkvza.referenceHeights)['h6'], -2)}
  }
`;
const $28c5de7f9da53f60$export$c4d4f06a25de97f = (0, $byn9U.css)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    aspectRatio: `var(${$28c5de7f9da53f60$export$7ab34e219ce6eef}, ${(0, $dkvza.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $28c5de7f9da53f60$export$a7abb1b3dc25813f = (0, $byn9U.css)({
    cursor: 'pointer',
    boxShadow: `0 0 0 1px ${`var(--ds-border-selected, ${(0, $PdmhA.B300)})`}`,
    outline: 'none'
});
const $28c5de7f9da53f60$export$ac950970e139031e = (0, $byn9U.css)({
    cursor: 'pointer'
});
const $28c5de7f9da53f60$export$4d0a7f76ad443516 = (0, $byn9U.css)({
    borderColor: `var(${$28c5de7f9da53f60$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    borderRadius: `calc(var(${$28c5de7f9da53f60$export$263a8a844c370a89}, ${(0, $dkvza.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    borderWidth: `calc(var(${$28c5de7f9da53f60$export$263a8a844c370a89}, ${(0, $dkvza.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});

});
parcelRegister("dkvza", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $9b45a0fd18c665c6$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $9b45a0fd18c665c6$export$da894f7669b4e67c);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $9b45a0fd18c665c6$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $9b45a0fd18c665c6$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $9b45a0fd18c665c6$export$c1317a9224e4d798);

var $4lTFP = parcelRequire("4lTFP");
const $9b45a0fd18c665c6$export$d722b7527b1834a8 = 250;
const $9b45a0fd18c665c6$export$da894f7669b4e67c = 200;
const $9b45a0fd18c665c6$export$286cf28b87ad4b4f = $9b45a0fd18c665c6$export$d722b7527b1834a8 / $9b45a0fd18c665c6$export$da894f7669b4e67c;
const $9b45a0fd18c665c6$export$64fe09732fb8680 = 0;
const $9b45a0fd18c665c6$export$c1317a9224e4d798 = {
    p: (0, $4lTFP.headingSizes).h600.lineHeight - 2,
    h1: (0, $4lTFP.headingSizes).h800.lineHeight + 4,
    h2: (0, $4lTFP.headingSizes).h700.lineHeight + 3,
    h3: (0, $4lTFP.headingSizes).h600.lineHeight + 1,
    h4: (0, $4lTFP.headingSizes).h500.lineHeight + 3,
    h5: (0, $4lTFP.headingSizes).h400.lineHeight + 4,
    h6: (0, $4lTFP.headingSizes).h300.lineHeight + 2
};

});


parcelRegister("6ehX9", function(module, exports) {

$parcel$export(module.exports, "blockMarksSharedStyles", () => $4891f9f5af8d0258$export$33edc553df878c50);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Perfectly safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing */ 
var $byn9U = parcelRequire("byn9U");
const $4891f9f5af8d0258$export$33edc553df878c50 = (0, $byn9U.css)`
  /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */
  *:not(.fabric-editor-block-mark) >,
  /* For nested block marks apart from those with indentation mark */
  *:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
    /* Do not remove the margin top for nodes inside indentation marks */
      :not(.fabric-editor-indentation-mark)
    /* Do not remove the margin top for nodes inside alignment marks */
      :not(.fabric-editor-alignment),
  // If first element inside a block node has alignment mark, then remove the margin-top
  .fabric-editor-alignment:first-of-type:first-child,
  // If first document element has indentation mark remove margin-top
  .ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child {
    p,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    .heading-wrapper {
      :first-child:not(style),
      style:first-child + * {
        margin-top: 0;
      }
    }
  }
`;

});

parcelRegister("6qOKj", function(module, exports) {

$parcel$export(module.exports, "blockquoteSharedStyles", () => $4aec88e6af1d1d62$export$1b5f3b43e6c4a8ee);

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $4aec88e6af1d1d62$export$1b5f3b43e6c4a8ee = (0, $byn9U.css)({
    '& blockquote': {
        boxSizing: 'border-box',
        paddingLeft: "var(--ds-space-200, 16px)",
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $25FYC.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        margin: `${(0, $25FYC.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        '& p': {
            display: 'block'
        },
        '& table, & table:last-child': {
            display: 'inline-table'
        }
    }
});

});

parcelRegister("4zXyh", function(module, exports) {

$parcel$export(module.exports, "codeMarkSharedStyles", () => $3558a01980c3d80a$export$ea799c18f699972b);

var $byn9U = parcelRequire("byn9U");
parcelRequire("dl0RD");
var $gamSa = parcelRequire("gamSa");

var $PdmhA = parcelRequire("PdmhA");
const $3558a01980c3d80a$export$ea799c18f699972b = ()=>{
    return (0, $byn9U.css)({
        '.code': {
            '--ds--code--bg-color': `var(--ds-background-neutral, ${(0, $PdmhA.N30A)})`,
            ...(0, $gamSa.getCodeStyles)()
        }
    });
};

});
parcelRegister("dl0RD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a70258a1be0ad4f6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getCodeStyles", () => (parcelRequire("gamSa")).getCodeStyles);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hve4P = parcelRequire("hve4P");

var $hyA5S = parcelRequire("hyA5S");

var $gamSa = parcelRequire("gamSa");
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $a70258a1be0ad4f6$var$Code = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const styles = /*#__PURE__*/ (0, $byn9U.css)((0, $gamSa.getCodeStyles)());
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, ...otherProps } = props;
    const decoratedChildren = codeBidiWarnings ? /*#__PURE__*/ (0, $byn9U.jsx)($a70258a1be0ad4f6$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    }, children) : children;
    return /*#__PURE__*/ (0, $byn9U.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        css: styles,
        ...otherProps
    }, decoratedChildren);
}));
function $a70258a1be0ad4f6$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $hyA5S.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hve4P.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }));
            return decorated;
        }
        if ($a70258a1be0ad4f6$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $byn9U.jsx)($a70258a1be0ad4f6$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                }, childNode.props.children)
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, replacedChildren);
}
function $a70258a1be0ad4f6$var$isReactElement(child) {
    return !!child.type;
}
$a70258a1be0ad4f6$var$Code.displayName = 'Code';
var $a70258a1be0ad4f6$export$2e2bcd8739ae039 = $a70258a1be0ad4f6$var$Code;

});
parcelRegister("hve4P", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cee3a28ff2903e3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $hqCgH = parcelRequire("hqCgH");
function $0cee3a28ff2903e3$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label,
        tag: $0cee3a28ff2903e3$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqCgH.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqCgH.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter);
}
const $0cee3a28ff2903e3$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ...rest,
        ref: ref
    }, children);
});

});
parcelRegister("hqCgH", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $bffbd99dc2ca2fb8$export$a592b67c93d52467);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $lkPEe = parcelRequire("lkPEe");
const $bffbd99dc2ca2fb8$var$decoration = /*#__PURE__*/ (0, $byn9U.css)({
    // Required as otherwise the following bidi characters cause the span
    // to not receive hover events.
    //
    // U+2066 LEFT-TO-RIGHT ISOLATE (when using pseudo element before)
    // U+202E RIGHT-TO-LEFT OVERRIDE' (when using pseudo element after)
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':before': {
        display: 'inline-flex',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        background: `var(--ds-background-warning, ${(0, $PdmhA.Y75)})`,
        color: "var(--ds-text-warning, #7F5F01)",
        content: '"<"attr(data-bidi-character-code)">"',
        fontSize: "var(--ds-font-size-100, 14px)",
        fontStyle: 'normal',
        lineHeight: '18px',
        /**
     * Ensures the decoration receives pointer events when it occurs with
     * an ancestor that disables them.
     */ pointerEvents: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover:before': {
        background: `var(--ds-background-warning-hovered, ${(0, $PdmhA.Y75)})`,
        color: "var(--ds-text-warning, #533F04)"
    }
});
function $bffbd99dc2ca2fb8$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $bffbd99dc2ca2fb8$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $bffbd99dc2ca2fb8$var$decoration,
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        // This is set to true so that the content is not read out by
        // screen readers as the content includes angle brackets for
        // visual decoration purposes.
        // We use a visually hidden `mark` element below for screen readers
        "aria-hidden": "true"
    }, children), /*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), {
        testId: testId && `${testId}--visually-hidden`
    }, /*#__PURE__*/ (0, $byn9U.jsx)("mark", null, bidiCharacterCode)));
}
function $bffbd99dc2ca2fb8$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("hyA5S", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4a6695c0dcb062d$export$2e2bcd8739ae039);
const $d4a6695c0dcb062d$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $d4a6695c0dcb062d$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($d4a6695c0dcb062d$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("gamSa", function(module, exports) {

$parcel$export(module.exports, "getCodeBlockStyles", () => $9564a2d27c68447a$export$b571c24d82780698);
$parcel$export(module.exports, "getCodeStyles", () => $9564a2d27c68447a$export$d5fcf1b7ff23707b);
$parcel$export(module.exports, "getCodeBlockTheme", () => $9564a2d27c68447a$export$57a2d4b573afd64a);

var $iUo9q = parcelRequire("iUo9q");

var $bQ0Ef = parcelRequire("bQ0Ef");
const $9564a2d27c68447a$export$cb7aec0206b595d2 = (numLines)=>{
    if (!numLines) return '1ch';
    return `${numLines.toFixed(0).length}ch`;
};
const $9564a2d27c68447a$var$lineNumberStyle = (theme)=>({
        // width of the line number gutter
        minWidth: `calc(${theme.lineNumberWidth} + ${0, $iUo9q.LINE_NUMBER_GUTTER}px) !important`,
        // this needs to be important or it gets overwritten by inline styles
        fontStyle: 'normal !important',
        // this needs to be important or it gets overwritten by inline styles
        color: `${theme.lineNumberColor} !important`,
        flexShrink: 0,
        // needed to replicate existing design spec
        boxSizing: 'border-box',
        paddingRight: `${0, $iUo9q.SPACING}px !important`,
        paddingLeft: (0, $iUo9q.SPACING),
        marginRight: (0, $iUo9q.SPACING),
        textAlign: 'right',
        userSelect: 'none',
        // this is to fix SSR spacing issue
        display: 'block',
        // This is how we are preventing line numbers being copied to clipboard.
        // (`user-select: none;` was not sufficent).
        // https://product-fabric.atlassian.net/browse/DSP-2729
        '&::after': {
            content: `attr(data-ds--line-number)`
        }
    });
// order of these keys does matter as it will affect the css precedence
const $9564a2d27c68447a$var$syntaxKeywordColors = (theme)=>({
        '.token': {
            // this specifically stops prism css cascading.
            '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                all: 'unset'
            },
            // additional specificity required to match the all: unset
            '&.key,&.keyword': {
                color: theme.keywordColor,
                fontWeight: 'bolder'
            },
            '&.attr-name': {
                color: theme.attributeColor
            },
            '&.selector': {
                color: theme.selectorTagColor
            },
            '&.comment,&.block-comment': {
                color: theme.commentColor,
                fontFamily: theme.fontFamilyItalic,
                fontStyle: 'italic'
            },
            '&.function-name': {
                color: theme.sectionColor
            },
            '&.doctype': {
                color: theme.docTagColor
            },
            '&.substr': {
                color: theme.substringColor
            },
            '&.namespace': {
                color: theme.nameColor
            },
            '&.builtin': {
                color: theme.builtInColor
            },
            '&.entity': {
                color: theme.literalColor
            },
            '&.bullet': {
                color: theme.bulletColor
            },
            '&.code': {
                color: theme.codeColor
            },
            '&.regex': {
                color: theme.regexpColor
            },
            '&.symbol': {
                color: theme.symbolColor
            },
            '&.variable': {
                color: theme.variableColor
            },
            '&.url': {
                color: theme.linkColor
            },
            '&.selector-attr': {
                color: theme.selectorAttributeColor
            },
            '&.selector-pseudo': {
                color: theme.selectorPseudoColor
            },
            '&.type': {
                color: theme.typeColor
            },
            '&.quote': {
                color: theme.quoteColor
            },
            '&.tag': {
                color: theme.templateTagColor
            },
            '&.string': {
                color: theme.stringColor
            },
            '&.class-name': {
                color: theme.sectionColor
            },
            '&.title': {
                color: theme.titleColor
            },
            '&.section': {
                color: theme.sectionColor
            },
            '&.meta-keyword': {
                color: theme.metaKeywordColor
            },
            '&.meta': {
                color: theme.metaColor
            },
            '&.italic': {
                fontStyle: 'italic'
            },
            '&.bold': {
                fontWeight: 'bolder'
            },
            '&.function': {
                color: theme.functionColor
            },
            '&.number': {
                color: theme.numberColor
            },
            '&.attr-value': {
                color: theme.attributeColor
            },
            '&.prolog': {
                color: theme.prologColor
            },
            '&.cdata': {
                color: theme.cdataColor
            },
            '&.punctuation': {
                color: theme.punctuationColor
            },
            '&.property': {
                color: theme.propertyColor
            },
            '&.constant': {
                color: theme.constantColor
            },
            '&.deleted': {
                color: theme.deletedColor
            },
            '&.boolean': {
                color: theme.booleanColor
            },
            '&.char': {
                color: theme.charColor
            },
            '&.inserted': {
                color: theme.insertedColor
            },
            '&.operator': {
                color: theme.operatorColor
            },
            '&.atrule': {
                color: theme.atruleColor
            },
            '&.important': {
                color: theme.importantColor,
                fontWeight: 'bold'
            }
        }
    });
const $9564a2d27c68447a$export$ee58a26b5d612ac1 = (theme)=>({
        fontSize: (0, $iUo9q.CODE_FONT_SIZE),
        fontFamily: theme.fontFamily,
        fontWeight: 'normal',
        backgroundColor: `var(${0, $iUo9q.VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
        color: theme.textColor,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)"
    });
const $9564a2d27c68447a$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
            // this is required to account for prismjs styles leaking into the codeblock
            'code[class*="language-"], pre[class*="language-"], code': {
                all: 'unset',
                padding: showLineNumbers ? `${0, $iUo9q.SPACING}px 0` : (0, $iUo9q.SPACING),
                tabSize: 4
            },
            display: 'flex',
            lineHeight: (0, $iUo9q.CODE_LINE_HEIGHT),
            overflowX: 'auto',
            whiteSpace: 'pre',
            direction: 'ltr',
            ...$9564a2d27c68447a$export$ee58a26b5d612ac1(theme),
            ...$9564a2d27c68447a$var$syntaxKeywordColors(theme),
            // this is to account for SSR spacing issue once loaded in browser
            '& .linenumber, .ds-sh-line-number': $9564a2d27c68447a$var$lineNumberStyle(theme),
            '& .linenumber': {
                display: 'inline-block !important',
                float: 'left'
            },
            // these styles are for line highlighting
            '& [data-ds--code--row]': {
                display: showLineNumbers ? 'flex' : 'block',
                paddingRight: `${0, $iUo9q.SPACING}px !important`,
                marginRight: `-${0, $iUo9q.SPACING}px`
            },
            '& [data-ds--code--row--highlight]': {
                background: `${theme.highlightedLineBgColor}`,
                // eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
                '&::before, &::after': {
                    clipPath: 'inset(100%)',
                    clip: 'rect(1px, 1px, 1px, 1px)',
                    height: '1px',
                    overflow: 'hidden',
                    position: 'absolute',
                    whiteSpace: 'nowrap',
                    width: '1px'
                },
                // The formatting here is an accessibility convention
                '&::before': {
                    content: `" [${highlightedStartText}] "`
                },
                '&::after': {
                    content: `" [${highlightedEndText}] "`
                }
            },
            '& [data-ds--code--row--highlight] .linenumber': {
                borderLeft: `${0, $iUo9q.HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                paddingLeft: `${(0, $iUo9q.SPACING) / 2}px !important`,
                position: 'relative'
            },
            // fill in space caused by parent border top
            '& [data-ds--code--row--highlight] .linenumber::before': {
                content: '""',
                position: 'absolute',
                width: (0, $iUo9q.HIGHLIGHT_BORDER_WIDTH),
                top: '-1px',
                left: `-${0, $iUo9q.HIGHLIGHT_BORDER_WIDTH}`,
                borderTop: `1px solid ${theme.highlightedLineBorderColor}`
            },
            '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                borderTop: '1px dashed transparent'
            },
            '[data-ds--code--row--highlight]:last-child': {
                borderBottom: '1px dashed transparent'
            },
            '& code:first-of-type': {
                paddingRight: `0px !important`,
                backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, $iUo9q.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, $iUo9q.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, $iUo9q.LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, $iUo9q.LINE_NUMBER_GUTTER}px), transparent)` : undefined
            },
            // we need to use last-of-type because when Code is SSR'd
            // 2 <code> elements are created and we don't want this style
            // applied to the first one
            '& code:last-of-type': {
                paddingRight: `${0, $iUo9q.SPACING}px !important`,
                flexBasis: 'auto',
                flexGrow: 1,
                // Needed for the highlight line to extend full-width
                flexShrink: shouldWrapLongLines ? 1 : 0,
                wordBreak: 'break-word'
            },
            // Prevents empty code blocks from vertically collapsing
            'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                content: '" "'
            }
        });
const $9564a2d27c68447a$export$d5fcf1b7ff23707b = ()=>{
    const theme = (0, $bQ0Ef.getBaseTheme)();
    const baseStyles = $9564a2d27c68447a$export$ee58a26b5d612ac1(theme);
    return {
        ...baseStyles,
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        fontSize: '0.875em',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    };
};
const $9564a2d27c68447a$export$57a2d4b573afd64a = (maxLines)=>{
    return {
        ...(0, $bQ0Ef.getBaseTheme)(),
        ...(0, $bQ0Ef.getColorPalette)(),
        lineNumberWidth: maxLines ? $9564a2d27c68447a$export$cb7aec0206b595d2(maxLines) : undefined
    };
};

});
parcelRegister("iUo9q", function(module, exports) {

$parcel$export(module.exports, "CODE_FONT_SIZE", () => $fb842dc45fcee8c3$export$431ac46d758d98c8);
$parcel$export(module.exports, "CODE_LINE_HEIGHT", () => $fb842dc45fcee8c3$export$8e3c04032121c606);
$parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", () => $fb842dc45fcee8c3$export$c8b5dc30e9f2b86e);
$parcel$export(module.exports, "SPACING", () => $fb842dc45fcee8c3$export$82ea42e772d49e5b);
$parcel$export(module.exports, "LINE_NUMBER_GUTTER", () => $fb842dc45fcee8c3$export$eeeea0ff98e06fff);
$parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", () => $fb842dc45fcee8c3$export$254015fe817dcb9e);
$parcel$export(module.exports, "VAR_CODE_BG_COLOR", () => $fb842dc45fcee8c3$export$1758fda69688282e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");
const $fb842dc45fcee8c3$export$431ac46d758d98c8 = 12;
const $fb842dc45fcee8c3$export$8e3c04032121c606 = '20px';
const $fb842dc45fcee8c3$export$c8b5dc30e9f2b86e = '4px';
const $fb842dc45fcee8c3$export$82ea42e772d49e5b = (0, $lcnyw.gridSize)();
const $fb842dc45fcee8c3$export$eeeea0ff98e06fff = $fb842dc45fcee8c3$export$82ea42e772d49e5b * 2;
const $fb842dc45fcee8c3$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
const $fb842dc45fcee8c3$export$1758fda69688282e = '--ds--code--bg-color';
const $fb842dc45fcee8c3$export$2cd00c745c539a1 = `data-ds--code--code-block`;

});

parcelRegister("bQ0Ef", function(module, exports) {

$parcel$export(module.exports, "getBaseTheme", () => $531c36e6ab7cba4e$export$4464aa303b3e4fda);
$parcel$export(module.exports, "getColorPalette", () => $531c36e6ab7cba4e$export$fe2a6478976e8b17);

var $5iWql = parcelRequire("5iWql");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
// Hardcoded values have been used due to the current color palette not having any
// accessible color options for Teal and Yellow and +20A
const $531c36e6ab7cba4e$var$T800 = '#067384';
const $531c36e6ab7cba4e$var$Y1100 = '#7A5D1A';
const $531c36e6ab7cba4e$export$4464aa303b3e4fda = ()=>({
        fontFamily: (0, $lcnyw.codeFontFamily)(),
        fontFamilyItalic: `SFMono-MediumItalic, ${(0, $lcnyw.codeFontFamily)()}`,
        backgroundColor: `var(--ds-background-neutral, ${$PdmhA.N20})`,
        textColor: `var(--ds-text, ${$PdmhA.N800})`,
        lineNumberColor: `var(--ds-text-subtlest, ${$PdmhA.N400})`,
        lineNumberBgColor: `var(--ds-background-neutral, ${$PdmhA.N30})`
    });
const $531c36e6ab7cba4e$export$7136e5d021a38178 = $531c36e6ab7cba4e$export$4464aa303b3e4fda();
const $531c36e6ab7cba4e$export$fe2a6478976e8b17 = (0, $5iWql.default)(()=>{
    return {
        highlightedLineBgColor: `var(--ds-background-neutral, ${$PdmhA.N30})`,
        highlightedLineBorderColor: `var(--ds-border-focused, ${$PdmhA.B200})`,
        substringColor: `var(--ds-text-subtlest, ${$PdmhA.N400})`,
        keywordColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        attributeColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        selectorTagColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        docTagColor: `var(--ds-text-accent-yellow, ${$531c36e6ab7cba4e$var$Y1100})`,
        nameColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        builtInColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        literalColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        bulletColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        codeColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        regexpColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        symbolColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        variableColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        templateVariableColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        linkColor: `var(--ds-text-accent-purple, ${$PdmhA.P300})`,
        selectorAttributeColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        selectorPseudoColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        typeColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        stringColor: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
        selectorIdColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        selectorClassColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        quoteColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        templateTagColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        titleColor: `var(--ds-text-accent-purple, ${$PdmhA.P300})`,
        sectionColor: `var(--ds-text-accent-purple, ${$PdmhA.P300})`,
        commentColor: `var(--ds-text-subtlest, ${$PdmhA.N400})`,
        metaKeywordColor: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
        metaColor: `var(--ds-text-subtlest, ${$PdmhA.N400})`,
        functionColor: `var(--ds-text, ${$PdmhA.N800})`,
        numberColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        prologColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        cdataColor: `var(--ds-text-subtlest, ${$PdmhA.N400})`,
        punctuationColor: `var(--ds-text, ${$PdmhA.N800})`,
        propertyColor: `var(--ds-text-accent-purple, ${$PdmhA.P300})`,
        constantColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        booleanColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        charColor: `var(--ds-text, ${$PdmhA.N800})`,
        insertedColor: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
        deletedColor: `var(--ds-text-accent-red, ${$PdmhA.R500})`,
        operatorColor: `var(--ds-text, ${$PdmhA.N800})`,
        atruleColor: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
        importantColor: `var(--ds-text-accent-yellow, ${$531c36e6ab7cba4e$var$Y1100})`
    };
});
const $531c36e6ab7cba4e$var$getTheme = ()=>({
        ...$531c36e6ab7cba4e$export$4464aa303b3e4fda(),
        ...$531c36e6ab7cba4e$export$fe2a6478976e8b17()
    });
var $531c36e6ab7cba4e$export$2e2bcd8739ae039 = $531c36e6ab7cba4e$var$getTheme;

});




parcelRegister("lEH5E", function(module, exports) {

$parcel$export(module.exports, "columnLayoutSharedStyle", () => $fc3ec23384276db4$export$6891a39948814a80);

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $fc3ec23384276db4$export$6891a39948814a80 = (0, $byn9U.css)({
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        [`@media screen and (max-width: ${0, $25FYC.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});

});

parcelRegister("e4fK9", function(module, exports) {

$parcel$export(module.exports, "DateSharedCssClassName", () => $a3dda6b616ce3836$export$99cdf122d0bb9f95);
$parcel$export(module.exports, "dateSharedStyle", () => $a3dda6b616ce3836$export$86f86bd772084bf4);

var $byn9U = parcelRequire("byn9U");
const $a3dda6b616ce3836$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $a3dda6b616ce3836$export$86f86bd772084bf4 = (0, $byn9U.css)({
    [`.${$a3dda6b616ce3836$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});

});

parcelRegister("cUhp3", function(module, exports) {

$parcel$export(module.exports, "headingsSharedStyles", () => $026cc71439a6bd12$export$9272613b68afed4b);
/* eslint-disable @atlaskit/design-system/use-tokens-space */ 
var $byn9U = parcelRequire("byn9U");

var $4lTFP = parcelRequire("4lTFP");
const $026cc71439a6bd12$export$9272613b68afed4b = ()=>(0, $byn9U.css)({
        '& h1': {
            ...(0, $4lTFP.h700)(),
            marginBottom: 0,
            marginTop: '1.667em'
        },
        '& h2': {
            ...(0, $4lTFP.h600)(),
            marginTop: '1.8em',
            marginBottom: 0
        },
        '& h3': {
            ...(0, $4lTFP.h500)(),
            marginTop: '2em',
            marginBottom: 0
        },
        '& h4': {
            ...(0, $4lTFP.h400)(),
            marginTop: '1.357em'
        },
        '& h5': {
            ...(0, $4lTFP.h300)(),
            marginTop: '1.667em',
            textTransform: 'none'
        },
        '& h6': {
            ...(0, $4lTFP.h100)(),
            marginTop: '1.455em',
            textTransform: 'none'
        }
    });

});

parcelRegister("9r3g7", function(module, exports) {

$parcel$export(module.exports, "indentationSharedStyles", () => $6de929d2adbdbac4$export$6856b92f564d3de8);
/* eslint-disable @atlaskit/design-system/use-tokens-space */ 
var $byn9U = parcelRequire("byn9U");
const $6de929d2adbdbac4$export$6856b92f564d3de8 = (0, $byn9U.css)({
    '.fabric-editor-indentation-mark': {
        "&[data-level='1']": {
            marginLeft: '30px'
        },
        "&[data-level='2']": {
            marginLeft: '60px'
        },
        "&[data-level='3']": {
            marginLeft: '90px'
        },
        "&[data-level='4']": {
            marginLeft: '120px'
        },
        "&[data-level='5']": {
            marginLeft: '150px'
        },
        "&[data-level='6']": {
            marginLeft: '180px'
        }
    }
});

});

parcelRegister("7Ytiu", function(module, exports) {

$parcel$export(module.exports, "richMediaClassName", () => $5ce4dccc751a1248$export$cfe6da7d522d87bb);
$parcel$export(module.exports, "mediaSingleSharedStyle", () => $5ce4dccc751a1248$export$d031611b96ba4cf0);

var $byn9U = parcelRequire("byn9U");
const $5ce4dccc751a1248$export$cfe6da7d522d87bb = 'rich-media-item';
const $5ce4dccc751a1248$var$wrappedMediaBreakoutPoint = 410;
const $5ce4dccc751a1248$export$d031611b96ba4cf0 = (0, $byn9U.css)({
    [`li .${$5ce4dccc751a1248$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    '&.ua-firefox': {
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    [`table .${$5ce4dccc751a1248$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        '&.image-wrap-left, &.image-wrap-right': {
            clear: 'none',
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    [`.${$5ce4dccc751a1248$export$cfe6da7d522d87bb}.image-wrap-right + .${$5ce4dccc751a1248$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    [`.${$5ce4dccc751a1248$export$cfe6da7d522d87bb}.image-wrap-left + .${$5ce4dccc751a1248$export$cfe6da7d522d87bb}.image-wrap-right, .${$5ce4dccc751a1248$export$cfe6da7d522d87bb}.image-wrap-right + .${$5ce4dccc751a1248$export$cfe6da7d522d87bb}.image-wrap-left, .${$5ce4dccc751a1248$export$cfe6da7d522d87bb}.image-wrap-left + .${$5ce4dccc751a1248$export$cfe6da7d522d87bb}.image-wrap-left, .${$5ce4dccc751a1248$export$cfe6da7d522d87bb}.image-wrap-right + .${$5ce4dccc751a1248$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    [`@media all and (max-width: ${$5ce4dccc751a1248$var$wrappedMediaBreakoutPoint}px)`]: {
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});

});

parcelRegister("iL3YW", function(module, exports) {

$parcel$export(module.exports, "paragraphSharedStyles", () => $da7fb480949f2b17$export$2f49074d75b0e29f);

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $da7fb480949f2b17$export$2f49074d75b0e29f = (0, $byn9U.css)({
    '& p': {
        fontSize: '1em',
        lineHeight: (0, $25FYC.akEditorLineHeight),
        fontWeight: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        marginTop: (0, $25FYC.blockNodesVerticalMargin),
        marginBottom: 0,
        letterSpacing: '-0.005em'
    }
});

});

parcelRegister("7BdzB", function(module, exports) {

$parcel$export(module.exports, "ruleSharedStyles", () => $5886847d9643dc44$export$329434b3a2da905e);

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");

var $PdmhA = parcelRequire("PdmhA");
const $5886847d9643dc44$export$329434b3a2da905e = ()=>(0, $byn9U.css)({
        '& hr': {
            border: 'none',
            backgroundColor: `var(--ds-border, ${(0, $PdmhA.N30A)})`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            margin: `${(0, $25FYC.akEditorLineHeight)}em 0`,
            height: '2px',
            borderRadius: '1px'
        }
    });

});

parcelRegister("14KqW", function(module, exports) {

$parcel$export(module.exports, "shadowSharedStyle", () => $0c8a2edfc3c48e5a$export$985ce3da3286f9ed);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");

var $PdmhA = parcelRequire("PdmhA");

var $kRTSM = parcelRequire("kRTSM");

var $cEslD = parcelRequire("cEslD");
const $0c8a2edfc3c48e5a$var$shadowWidth = 8;
/**
 * TODO: This is close to working and removes a tone of JS from OverflowShadow component
 *
 *  background: linear-gradient(to right, white 30%, rgba(255, 255, 255, 0)),
 *         linear-gradient(to right, rgba(255, 255, 255, 0), white 70%) 100% 0,
 *        linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)),
 *         linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.2)) 100% 0;
 *       background-repeat: no-repeat;
 *       background-color: white;
 *       background-size: 40px 100%, 40px 100%, 14px 100%, 14px 100%;
 *
 *      background-attachment: local, local, scroll, scroll;
 */ const $0c8a2edfc3c48e5a$export$985ce3da3286f9ed = (0, $byn9U.css)({
    [`& .${(0, $kRTSM.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $kRTSM.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $kRTSM.shadowClassNames).LEFT_SHADOW}::before, .${(0, $kRTSM.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        zIndex: (0, $25FYC.akEditorShadowZIndex),
        width: `${$0c8a2edfc3c48e5a$var$shadowWidth}px`,
        content: "''",
        height: 'calc(100%)'
    },
    [`& .${(0, $kRTSM.shadowClassNames).RIGHT_SHADOW}, .${(0, $kRTSM.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    [`& .${(0, $kRTSM.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${`var(--ds-shadow-overflow-spread, ${(0, $PdmhA.N40A)})`} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    [`& .${(0, $kRTSM.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${`var(--ds-shadow-overflow-spread, ${(0, $PdmhA.N40A)})`} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    [`& .${(0, $cEslD.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    [`& .${(0, $cEslD.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});

});

parcelRegister("9WTTi", function(module, exports) {

$parcel$export(module.exports, "SmartCardSharedCssClassName", () => $73e4e297fa0aec8e$export$4ccd31bf665a88f6);
$parcel$export(module.exports, "smartCardSharedStyles", () => $73e4e297fa0aec8e$export$83e107f0a431e184);

var $25FYC = parcelRequire("25FYC");
const $73e4e297fa0aec8e$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $73e4e297fa0aec8e$export$83e107f0a431e184 = `
  .${$73e4e297fa0aec8e$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${(0, $25FYC.blockNodesVerticalMargin)} 0 0;
    max-width: ${760}px;
  }
`;

});

parcelRegister("eddf8", function(module, exports) {

$parcel$export(module.exports, "TaskDecisionSharedCssClassName", () => $a58c8d60d1a273af$export$a7172b75d403a0e4);
$parcel$export(module.exports, "tasksAndDecisionsStyles", () => $a58c8d60d1a273af$export$df437277fbc8b4f5);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ 
var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $a58c8d60d1a273af$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    TASK_ITEM: 'task-item'
};
const $a58c8d60d1a273af$export$df437277fbc8b4f5 = (0, $byn9U.css)`
  .ProseMirror {
    .taskItemView-content-wrap,
    .${$a58c8d60d1a273af$export$a7172b75d403a0e4.DECISION_CONTAINER} {
      position: relative;
      min-width: ${(0, $25FYC.akEditorTableCellMinWidth)}px;
    }

    .${$a58c8d60d1a273af$export$a7172b75d403a0e4.DECISION_CONTAINER} {
      margin-top: 0;
    }

    .${$a58c8d60d1a273af$export$a7172b75d403a0e4.TASK_CONTAINER} {
      span[contenteditable='false'] {
        height: ${(0, $25FYC.akEditorLineHeight)}em;
      }
    }

    .${$a58c8d60d1a273af$export$a7172b75d403a0e4.TASK_ITEM} {
      line-height: ${(0, $25FYC.akEditorLineHeight)};
    }
  }

  div[data-task-local-id] {
    span[contenteditable='false'] {
      height: ${(0, $25FYC.akEditorLineHeight)}em;
    }
    span[contenteditable='false'] + div {
      line-height: ${(0, $25FYC.akEditorLineHeight)}em;
    }
  }

  div[data-task-list-local-id] {
    margin: ${"var(--ds-space-150, 12px)"} 0 0 0;
  }

  div[data-task-list-local-id] {
    // If task item is not first in the list then set margin top to 4px.
    div + div {
      margin-top: ${"var(--ds-space-050, 4px)"};
    }
  }

  // If task list is not first in the document then set margin top to 4px.
  div[data-task-list-local-id] div[data-task-list-local-id] {
    margin-top: ${"var(--ds-space-050, 4px)"};
    margin-left: ${"var(--ds-space-300, 24px)"};
  }

  /* When action list is inside panel */
  .ak-editor-panel__content {
    > div[data-task-list-local-id]:first-child {
      margin: 0 0 0 0 !important;
    }
  }
`;

});

parcelRegister("dSQba", function(module, exports) {

$parcel$export(module.exports, "textColorStyles", () => $a1b8cb2f229b5601$export$a518ea5d00002b38);

var $byn9U = parcelRequire("byn9U");
const $a1b8cb2f229b5601$export$a518ea5d00002b38 = (0, $byn9U.css)({
    '.fabric-text-color-mark': {
        color: 'var(--custom-palette-color, inherit)'
    },
    'a .fabric-text-color-mark': {
        color: 'unset'
    }
});

});

parcelRegister("8xoI5", function(module, exports) {

$parcel$export(module.exports, "whitespaceSharedStyles", () => $637492b9eb5d5652$export$c9ce3bfa46d7acba);

var $byn9U = parcelRequire("byn9U");
const $637492b9eb5d5652$export$c9ce3bfa46d7acba = (0, $byn9U.css)({
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap'
});

});

parcelRegister("c1PWl", function(module, exports) {

$parcel$export(module.exports, "getLightWeightCodeBlockStylesForRootRendererStyleSheet", () => $8c1dde3b6d0549ff$export$3f1ff491ca7c4c4a);
$parcel$export(module.exports, "default", () => $8c1dde3b6d0549ff$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");

var $3GCBC = parcelRequire("3GCBC");

var $9S2zl = parcelRequire("9S2zl");

var $h1C70 = parcelRequire("h1C70");
const $8c1dde3b6d0549ff$var$lightWeightCodeBlockStyles = (0, $byn9U.css)`
  .${(0, $3GCBC.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER} {
    cursor: text;
  }
`;
const $8c1dde3b6d0549ff$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $8c1dde3b6d0549ff$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    return (0, $byn9U.css)`
    .${(0, $h1C70.RendererCssClassName).DOCUMENT}
      > .${$8c1dde3b6d0549ff$export$afbde0e7339bed51.CONTAINER}
      .${(0, $3GCBC.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER} {
      margin-top: ${0, $25FYC.blockNodesVerticalMargin};
    }
  `;
};
const $8c1dde3b6d0549ff$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
    const textRows = (0, $eUqFw.useMemo)(()=>(text !== null && text !== void 0 ? text : '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $9S2zl.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $8c1dde3b6d0549ff$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    return (0, $byn9U.jsx)("div", {
        className: classNames,
        ref: ref,
        css: [
            (0, $3GCBC.codeBlockSharedStyles)(),
            $8c1dde3b6d0549ff$var$lightWeightCodeBlockStyles
        ]
    }, (0, $byn9U.jsx)("div", {
        className: (0, $3GCBC.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, (0, $byn9U.jsx)("div", {
        className: (0, $3GCBC.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, (0, $byn9U.jsx)("div", {
        className: (0, $3GCBC.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>(0, $byn9U.jsx)("span", {
            key: index
        }))), (0, $byn9U.jsx)("div", {
        className: (0, $3GCBC.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, (0, $byn9U.jsx)("code", null, renderBidiWarnings(text))))));
});
var $8c1dde3b6d0549ff$export$2e2bcd8739ae039 = $8c1dde3b6d0549ff$var$LightWeightCodeBlock;

});
parcelRegister("9S2zl", function(module, exports) {

$parcel$export(module.exports, "useBidiWarnings", () => $72fb265dd7e5b855$export$9fb9fe546a188c7b);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hve4P = parcelRequire("hve4P");

var $8VFoC = parcelRequire("8VFoC");

var $hyA5S = parcelRequire("hyA5S");
const $72fb265dd7e5b855$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $5JgJ2.default)();
    const warningLabel = intl.formatMessage((0, $8VFoC.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        return (0, $hyA5S.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hve4P.default), {
                bidiCharacter: bidiCharacter,
                key: index,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};

});



parcelRegister("flRb7", function(module, exports) {

$parcel$export(module.exports, "TableHeader", () => $b2d211492cdc8d58$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $b2d211492cdc8d58$export$1e4baea7053fc0e3);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $as9OS = parcelRequire("as9OS");
var $byxO6 = parcelRequire("byxO6");

var $4q38b = parcelRequire("4q38b");

var $4EQkk = parcelRequire("4EQkk");

var $dapS7 = parcelRequire("dapS7");

var $bR7u8 = parcelRequire("bR7u8");

var $1lWyd = parcelRequire("1lWyd");

var $61wF1 = parcelRequire("61wF1");

var $h1C70 = parcelRequire("h1C70");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8hj5G = parcelRequire("8hj5G");
const $b2d211492cdc8d58$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $b2d211492cdc8d58$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $4EQkk.SortOrder).NO_ORDER:
            return (0, $4EQkk.SortOrder).ASC;
        case (0, $4EQkk.SortOrder).ASC:
            return (0, $4EQkk.SortOrder).DESC;
        case (0, $4EQkk.SortOrder).DESC:
            return (0, $4EQkk.SortOrder).NO_ORDER;
    }
    return (0, $4EQkk.SortOrder).NO_ORDER;
};
const $b2d211492cdc8d58$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $8hj5G.tableCellMessages);
    switch(currentSortOrder){
        case (0, $4EQkk.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $4EQkk.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $4EQkk.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
const $b2d211492cdc8d58$var$getDataAttributes = (colwidth, background)=>{
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    return attrs;
};
const $b2d211492cdc8d58$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $dapS7.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $as9OS.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    return style;
};
const $b2d211492cdc8d58$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $4q38b.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const colorName = background ? (0, $byxO6.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperComponent, (0, $kU09D.default)({
            rowSpan: rowspan,
            colSpan: colspan,
            style: $b2d211492cdc8d58$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode
            }),
            colorname: colorName,
            onClick: onClick,
            className: className
        }, $b2d211492cdc8d58$var$getDataAttributes(colwidth, background), {
            "aria-sort": ariaSort
        }), children);
    };
};
const $b2d211492cdc8d58$var$TH = $b2d211492cdc8d58$var$getWithCellProps('th');
const $b2d211492cdc8d58$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $5JgJ2.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $4EQkk.SortOrder).NO_ORDER ? (0, $h1C70.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperComponent, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperComponent, (0, $kU09D.default)({}, props, {
            className: (0, $h1C70.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $b2d211492cdc8d58$var$getSortOrderLabel(intl, sortOrdered)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $h1C70.RendererCssClassName).SORTABLE_COLUMN
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("figure", {
            className: `${(0, $h1C70.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bR7u8.default), {
            isSortingAllowed: !!onSorting,
            sortOrdered: sortOrdered,
            onClick: sort,
            onKeyDown: onKeyPress
        }))));
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$b2d211492cdc8d58$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $b2d211492cdc8d58$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $61wF1.ACTION).SORT_COLUMN,
                    actionSubject: (0, $61wF1.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $1lWyd.PLATFORM).WEB,
                        mode: (0, $1lWyd.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $61wF1.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $61wF1.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $61wF1.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $1lWyd.PLATFORM).WEB,
                    mode: (0, $1lWyd.MODE).RENDERER
                },
                eventType: (0, $61wF1.EVENT_TYPE).TRACK
            });
        }
    };
};
const $b2d211492cdc8d58$export$f850895b287ef28e = $b2d211492cdc8d58$export$cfca40ca5c56a38e($b2d211492cdc8d58$var$TH);
const $b2d211492cdc8d58$var$TD = $b2d211492cdc8d58$var$getWithCellProps('td');
const $b2d211492cdc8d58$export$1e4baea7053fc0e3 = $b2d211492cdc8d58$var$TD;

});
parcelRegister("bR7u8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a1a734c6b61fd97$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $8cU5f = parcelRequire("8cU5f");

var $PdmhA = parcelRequire("PdmhA");

var $4EQkk = parcelRequire("4EQkk");

var $8hj5G = parcelRequire("8hj5G");

var $2qhQi = parcelRequire("2qhQi");

var $h1C70 = parcelRequire("h1C70");
let $8a1a734c6b61fd97$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});
const $8a1a734c6b61fd97$var$buttonStyles = (0, $byn9U.css)`
  position: absolute;
  display: flex;
  height: 28px;
  width: 28px;
  margin: ${"var(--ds-space-075, 6px)"};
  right: 0;
  top: 0;
  border: 2px solid ${"var(--ds-border, #fff)"};
  border-radius: ${"var(--ds-border-radius-100, 4px)"};
  background-color: ${`var(--ds-surface-overlay, ${(0, $PdmhA.N20)})`};
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background-color: ${`var(--ds-surface-overlay-hovered, ${(0, $PdmhA.N30)})`};
  }

  &:active {
    background-color: ${"var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6))"};
  }

  &.${(0, $h1C70.RendererCssClassName).SORTABLE_COLUMN_ICON}__not-allowed {
    cursor: not-allowed;
  }
`;
const $8a1a734c6b61fd97$var$iconWrapperStyles = (0, $byn9U.css)`
  width: 8px;
  height: 12px;
  transition: transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);
  transform-origin: 50% 50%;
  display: flex;
  justify-content: center;

  &.${$8a1a734c6b61fd97$export$c3618f310f725028.DESC} {
    transform: rotate(-180deg);
  }

  &.${(0, $h1C70.RendererCssClassName).SORTABLE_COLUMN_ICON}-inactive {
    opacity: 0.7;
  }
`;
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $8a1a734c6b61fd97$var$iconStyles = (0, $byn9U.css)`
  height: 100%;
  width: 2px;
  border-radius: 50px;
  background: ${"var(--ds-icon, #42526E)"};

  &::before,
  &::after {
    background: ${"var(--ds-icon, #42526E)"};
    content: '';
    height: 2px;
    width: 6px;
    position: absolute;
    border-radius: 50px;
  }

  &::before {
    transform: rotate(45deg) translate(3.4px, 8.5px);
  }

  &::after {
    transform: rotate(-45deg) translate(-6.3px, 5.7px);
  }
`;
const $8a1a734c6b61fd97$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $4EQkk.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $h1C70.RendererCssClassName).SORTABLE_COLUMN_ICON}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${$8a1a734c6b61fd97$export$c3618f310f725028.SORTING_NOT_ALLOWED} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $4EQkk.SortOrder).ASC:
            return `${$8a1a734c6b61fd97$export$c3618f310f725028.ASC} ${activeStatusClass}`;
        case (0, $4EQkk.SortOrder).DESC:
            return `${$8a1a734c6b61fd97$export$c3618f310f725028.DESC} ${activeStatusClass}`;
        default:
            return `${$8a1a734c6b61fd97$export$c3618f310f725028.NO_ORDER} ${activeStatusClass}`;
    }
};
const $8a1a734c6b61fd97$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $8hj5G.sortingIconMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $4EQkk.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $4EQkk.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $4EQkk.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $8a1a734c6b61fd97$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $8hj5G.sortingAriaLabelMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $4EQkk.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $4EQkk.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $4EQkk.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $8a1a734c6b61fd97$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $h1C70.RendererCssClassName).SORTABLE_COLUMN_ICON}${isSortingAllowed ? '' : ` ${(0, $h1C70.RendererCssClassName).SORTABLE_COLUMN_ICON}__not-allowed`}`;
    const content = $8a1a734c6b61fd97$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $8a1a734c6b61fd97$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return (0, $byn9U.jsx)((0, $8cU5f.default), {
        delay: 0,
        content: content,
        position: "top"
    }, (0, $byn9U.jsx)("div", {
        css: $8a1a734c6b61fd97$var$buttonStyles,
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, (0, $byn9U.jsx)("div", {
        css: $8a1a734c6b61fd97$var$iconWrapperStyles,
        className: $8a1a734c6b61fd97$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, (0, $byn9U.jsx)("div", {
        css: $8a1a734c6b61fd97$var$iconStyles
    }))));
};
var $8a1a734c6b61fd97$export$2e2bcd8739ae039 = (0, $2qhQi.default)($8a1a734c6b61fd97$var$SortingIcon);

});

parcelRegister("1lWyd", function(module, exports) {

$parcel$export(module.exports, "PLATFORM", () => $0fc52b9a233c7a0d$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $0fc52b9a233c7a0d$export$e48589d9e4824227);
let $0fc52b9a233c7a0d$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
let $0fc52b9a233c7a0d$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
let $0fc52b9a233c7a0d$export$ecd1fed429542b49 = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}({});

});


parcelRegister("fFNtM", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $b69110ed174bfcbe$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $b69110ed174bfcbe$export$65e2d5a272a382b0);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");
const $b69110ed174bfcbe$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(new Map());
const $b69110ed174bfcbe$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b69110ed174bfcbe$export$841858b892ce1f4c.Provider, {
        value: new Map()
    }, children);
};
const $b69110ed174bfcbe$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b69110ed174bfcbe$export$841858b892ce1f4c.Consumer, null, (storage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, (0, $kU09D.default)({}, this.props, {
                    smartCardStorage: storage
                })));
        }
    };
};

});

parcelRegister("hJ377", function(module, exports) {

$parcel$export(module.exports, "tableStickyPadding", () => $ce790dfe5d289e3d$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $ce790dfe5d289e3d$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $ce790dfe5d289e3d$export$e97bc6692974bd0b);

var $kU09D = parcelRequire("kU09D");
parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $fgrpX = parcelRequire("fgrpX");

var $25FYC = parcelRequire("25FYC");

var $PdmhA = parcelRequire("PdmhA");

var $ixmtj = parcelRequire("ixmtj");

var $5acL3 = parcelRequire("5acL3");

var $hP4fj = parcelRequire("hP4fj");
const $ce790dfe5d289e3d$export$3de6413b528017ca = 8;
const $ce790dfe5d289e3d$var$modeSpecficStyles = {
    none: (0, $byn9U.css)({
        display: 'none'
    }),
    stick: (0, $byn9U.css)({
        position: 'fixed'
    }),
    'pin-bottom': (0, $byn9U.css)({
        position: 'absolute'
    })
};
// TODO: Quality ticket: https://product-fabric.atlassian.net/browse/DSP-4123
const $ce790dfe5d289e3d$var$fixedTableDivStaticStyles = (top, width, rendererAppearance)=>{
    let stickyHeaderZIndex;
    if ((0, $hP4fj.isTableResizingEnabled)(rendererAppearance)) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $25FYC.akEditorStickyHeaderZIndex);
    return (0, $byn9U.css)(typeof top === 'number' && `top: ${top}px;`, {
        width: `${width}px`,
        zIndex: stickyHeaderZIndex,
        [`& .${(0, $fgrpX.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $fgrpX.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            marginTop: 0,
            marginBottom: 0,
            tr: {
                background: "var(--ds-surface, white)"
            }
        },
        borderTop: `${$ce790dfe5d289e3d$export$3de6413b528017ca}px solid ${"var(--ds-surface, white)"}`,
        background: "var(--ds-surface-overlay, white)",
        boxShadow: `0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${(0, $PdmhA.N40A)})`}`,
        "div[data-expanded='false'] &": {
            display: 'none'
        },
        [`& .${(0, $fgrpX.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $fgrpX.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
            top: '0px',
            height: '100%'
        },
        "&.fixed-table-div-custom-table-resizing[mode='stick']": {
            zIndex: stickyHeaderZIndex
        }
    });
};
const $ce790dfe5d289e3d$export$c32334a490c1bcab = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, rendererAppearance: rendererAppearance } = props;
    const fixedTableCss = [
        $ce790dfe5d289e3d$var$fixedTableDivStaticStyles(top, wrapperWidth, rendererAppearance),
        $ce790dfe5d289e3d$var$modeSpecficStyles === null || $ce790dfe5d289e3d$var$modeSpecficStyles === void 0 ? void 0 : $ce790dfe5d289e3d$var$modeSpecficStyles[mode]
    ];
    const attrs = {
        mode: mode
    };
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, attrs, {
        "data-testid": "sticky-table-fixed",
        className: (0, $hP4fj.isTableResizingEnabled)(rendererAppearance) ? 'fixed-table-div-custom-table-resizing' : '',
        css: fixedTableCss
    }), props.children);
};
const $ce790dfe5d289e3d$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if ((0, $hP4fj.isTableResizingEnabled)(rendererAppearance)) styles = (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return (0, $byn9U.jsx)("div", {
        css: styles
    }, (0, $byn9U.jsx)($ce790dfe5d289e3d$export$c32334a490c1bcab, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        rendererAppearance: rendererAppearance
    }, (0, $byn9U.jsx)("div", {
        className: `${(0, $fgrpX.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth
        }
    }, (0, $byn9U.jsx)("div", {
        ref: innerRef,
        className: `${(0, $fgrpX.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            overflow: 'hidden'
        }
    }, (0, $byn9U.jsx)((0, $ixmtj.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance
    }, /**
   * @see https://product-fabric.atlassian.net/browse/ED-10235
   * We pass prop 'invisible' to our table's children nodes meaning
   * they exist inside of the 'invisible' duplicated table component that
   * enables sticky headers.
   */ (0, $5acL3.recursivelyInjectProps)(children, {
        invisible: true
    }))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 */ function $ce790dfe5d289e3d$var$findHorizontalOverflowScrollParent(table) {
    let parent = table;
    if (!parent) return null;
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
    }
    return null;
}
class $ce790dfe5d289e3d$export$e97bc6692974bd0b {
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
    static fromElement(el) {
        return new $ce790dfe5d289e3d$export$e97bc6692974bd0b($ce790dfe5d289e3d$var$findHorizontalOverflowScrollParent(el) || window);
    }
    get isElement() {
        return this.ref instanceof HTMLElement;
    }
    get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    addEventListener(type, cb, ...args) {
        this.ref.addEventListener(type, cb, ...args);
    }
    removeEventListener(type, cb, ...args) {
        this.ref.removeEventListener(type, cb, ...args);
    }
}

});
parcelRegister("ixmtj", function(module, exports) {

$parcel$export(module.exports, "Table", () => $d7ecbd7b9f4fc650$export$54ec01a60f47d33d);

var $eUqFw = parcelRequire("eUqFw");

var $jFCQc = parcelRequire("jFCQc");

var $ewmoR = parcelRequire("ewmoR");

var $25FYC = parcelRequire("25FYC");
const $d7ecbd7b9f4fc650$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension })=>{
    const tableWidth = tableNode ? (0, $ewmoR.getTableContainerWidth)(tableNode) : (0, $25FYC.akEditorDefaultLayoutWidth);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("table", {
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        ref: innerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jFCQc.Colgroup), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        isInsideOfBlockNode: isInsideOfBlockNode,
        isinsideMultiBodiedExtension: isinsideMultiBodiedExtension
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", null, children));
});

});
parcelRegister("jFCQc", function(module, exports) {

$parcel$export(module.exports, "Colgroup", () => $03b21069dfcd519e$export$89efc2d0ceeaa030);

var $eUqFw = parcelRequire("eUqFw");

var $fgrpX = parcelRequire("fgrpX");

var $25FYC = parcelRequire("25FYC");

var $ewmoR = parcelRequire("ewmoR");

var $hP4fj = parcelRequire("hP4fj");
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $03b21069dfcd519e$var$MAX_SCALING_PERCENT = 0.3;
const $03b21069dfcd519e$var$getTableLayoutWidth = (layout)=>{
    switch(layout){
        case 'full-width':
            return 0, $25FYC.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $25FYC.akEditorWideLayoutWidth;
        default:
            return 0, $25FYC.akEditorDefaultLayoutWidth;
    }
};
const $03b21069dfcd519e$var$isTableResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $03b21069dfcd519e$var$fixColumnWidth = (columnWidth, _tableWidth, _layoutWidth, zeroWidthColumnsCount, scaleDownPercent)=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, $fgrpX.tableCellMinWidth));
    return Math.max(// We need to take tableCellBorderWidth, to avoid unnecessary overflow.
    columnWidth - (0, $fgrpX.tableCellBorderWidth), zeroWidthColumnsCount ? (0, $25FYC.akEditorTableLegacyCellMinWidth) : (0, $fgrpX.tableCellMinWidth));
};
const $03b21069dfcd519e$export$825b9ec54e6e762c = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale })=>{
    const diffPercent = 1 - renderWidth / tableWidth;
    return diffPercent < maxScale ? diffPercent : maxScale;
};
const $03b21069dfcd519e$var$renderScaleDownColgroup = (props)=>{
    let { columnWidths: columnWidths, layout: layout, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension } = props;
    if (!columnWidths) return [];
    let tableContainerWidth;
    const tableResized = $03b21069dfcd519e$var$isTableResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    if ((0, $hP4fj.isTableResizingEnabled)(rendererAppearance) && tableNode) tableContainerWidth = (0, $ewmoR.getTableContainerWidth)(tableNode);
    else tableContainerWidth = $03b21069dfcd519e$var$getTableLayoutWidth(layout);
    if ((0, $hP4fj.isTableResizingEnabled)(rendererAppearance) && !isInsideOfBlockNode && !isinsideMultiBodiedExtension && !tableResized) {
        // for tables with no column widths defined, assume that the real table width
        // is defined by node.attrs.width
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $25FYC.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableResized) return null;
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $25FYC.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $25FYC.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $25FYC.akEditorTableLegacyCellMinWidth) ? (0, $25FYC.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth) scaleDownPercent = $03b21069dfcd519e$export$825b9ec54e6e762c({
        renderWidth: renderWidth,
        tableWidth: tableWidth,
        maxScale: $03b21069dfcd519e$var$MAX_SCALING_PERCENT
    });
    return targetWidths.map((colWidth)=>{
        const width = $03b21069dfcd519e$var$fixColumnWidth(colWidth, minTableWidth, maxTableWidth, zeroWidthColumnsCount, scaleDownPercent) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $03b21069dfcd519e$export$89efc2d0ceeaa030 = (props)=>{
    let { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    if (!columnWidths) return null;
    const colStyles = $03b21069dfcd519e$var$renderScaleDownColgroup(props);
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("colgroup", null, isNumberColumnEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("col", {
        style: {
            width: (0, $25FYC.akEditorTableNumberColumnWidth)
        },
        "data-test-id": 'num'
    }), colStyles.map((style, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("col", {
            key: idx,
            style: style
        })));
};

});


parcelRegister("5acL3", function(module, exports) {

$parcel$export(module.exports, "recursivelyInjectProps", () => $3c27c85d4cbdb49c$export$40e12ce8e0a76b0c);

var $eUqFw = parcelRequire("eUqFw");
function $3c27c85d4cbdb49c$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
            children: $3c27c85d4cbdb49c$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, propsToInject);
    });
}

});


parcelRegister("158kB", function(module, exports) {

$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $0c9cb879effc6eae$export$33331a99fac775a1);
const $0c9cb879effc6eae$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $0c9cb879effc6eae$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $0c9cb879effc6eae$export$33331a99fac775a1 = (appearance)=>$0c9cb879effc6eae$export$a64737a81cde10b4(appearance) || $0c9cb879effc6eae$export$c0112b8340d4924b(appearance);

});


parcelRegister("3CD47", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a333944db5e65d3$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $1gsRV = parcelRequire("1gsRV");

var $4EQkk = parcelRequire("4EQkk");

var $h1C70 = parcelRequire("h1C70");
class $2a333944db5e65d3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            colGroupWidths: []
        });
        (0, $5zQU9.default)(this, "addSortableColumn", (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            if (allowColumnSorting) {
                const isHeaderRow = !rowIndex;
                childrenArray = childrenArray.map((child, index)=>{
                    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child)) {
                        const { tableOrderStatus: tableOrderStatus } = this.props;
                        let sortOrdered = (0, $4EQkk.SortOrder).NO_ORDER;
                        if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $4EQkk.SortOrder).NO_ORDER;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                            columnIndex: index,
                            onSorting: this.props.onSorting,
                            sortOrdered: sortOrdered,
                            isHeaderRow: isHeaderRow
                        });
                    }
                });
            }
            return childrenArray;
        });
        (0, $5zQU9.default)(this, "addColGroupWidth", (childrenArray)=>{
            if (this.state.colGroupWidths) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        });
    }
    render() {
        const { children: children, innerRef: innerRef } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
            ref: innerRef
        }, this.props.isNumberColumnEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
            className: (0, $h1C70.RendererCssClassName).NUMBER_COLUMN
        }, this.props.index), (0, $1gsRV.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray));
    }
}

});

parcelRegister("73BN3", function(module, exports) {

$parcel$export(module.exports, "default", () => $52362089d2b3dc19$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $52362089d2b3dc19$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: "UnknownBlock"
    }, props.children);
}

});

parcelRegister("hGalw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdee626bc5c2cdae$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $25FYC = parcelRequire("25FYC");

var $ioiQ7 = parcelRequire("ioiQ7");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $61wF1 = parcelRequire("61wF1");

var $lAA7z = parcelRequire("lAA7z");

var $fSlwM = parcelRequire("fSlwM");

var $g6Rdu = parcelRequire("g6Rdu");
const $cdee626bc5c2cdae$var$inlineNodeStyle = (0, $byn9U.css)({
    alignItems: 'center',
    background: `var(--ds-background-disabled, ${(0, $PdmhA.N30)})`,
    border: `1px dashed ${`var(--ds-border-disabled, ${(0, $PdmhA.N50)})`}`,
    borderRadius: `${(0, $lcnyw.borderRadius)()}px`,
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    fontSize: (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $cdee626bc5c2cdae$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $g6Rdu.getUnsupportedContent)((0, $lAA7z.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $lAA7z.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $eUqFw.useRef)({
        padding: '4px'
    });
    const originalNodeType = node === null || node === void 0 ? void 0 : node.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $eUqFw.useCallback)(()=>dispatchAnalyticsEvent && (0, $fSlwM.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $61wF1.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return (0, $byn9U.jsx)("span", {
        css: $cdee626bc5c2cdae$var$inlineNodeStyle
    }, message, (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, (0, $byn9U.jsx)("span", {
        style: style
    }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))), {
        label: "?",
        size: "small"
    }))));
};
var $cdee626bc5c2cdae$export$2e2bcd8739ae039 = (0, $2qhQi.default)($cdee626bc5c2cdae$var$UnsupportedInlineNode);

});

parcelRegister("6XwU1", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5FqUy');
        const value = parcelRequire('dM5RB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5FqUy").then(()=>parcelRequire('dM5RB'));
}

});

parcelRegister("jSJB7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jdSkd');
        const value = parcelRequire('5aYU3');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jdSkd").then(()=>parcelRequire('5aYU3'));
}

});

parcelRegister("8kA34", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dA1Mu');
        const value = parcelRequire('jr0HW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dA1Mu").then(()=>parcelRequire('jr0HW'));
}

});

parcelRegister("02RS2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('5QCFp')
        ]);
        const value = parcelRequire('h4tBH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("5QCFp")
    ]).then(()=>parcelRequire('h4tBH'));
}

});

parcelRegister("bdpD4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('UrIIt');
        const value = parcelRequire('l6ezR');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("UrIIt").then(()=>parcelRequire('l6ezR'));
}

});

parcelRegister("8xSQV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('b0Vju');
        const value = parcelRequire('8pDiI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("b0Vju").then(()=>parcelRequire('8pDiI'));
}

});

parcelRegister("2fWAv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2nX85');
        const value = parcelRequire('1Oqak');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2nX85").then(()=>parcelRequire('1Oqak'));
}

});

parcelRegister("cmzNc", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('g3iHc')
        ]);
        const value = parcelRequire('2RgEt');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("g3iHc")
    ]).then(()=>parcelRequire('2RgEt'));
}

});

parcelRegister("kRyfh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7wxUP');
        const value = parcelRequire('2Oykj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7wxUP").then(()=>parcelRequire('2Oykj'));
}

});

parcelRegister("7XOTK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('g6TD8');
        const value = parcelRequire('fSiDG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("g6TD8").then(()=>parcelRequire('fSiDG'));
}

});

parcelRegister("810Ux", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('eTNHE')
        ]);
        const value = parcelRequire('gGAYd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("eTNHE")
    ]).then(()=>parcelRequire('gGAYd'));
}

});

parcelRegister("55nMP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('gBS1f')
        ]);
        const value = parcelRequire('jlgQW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("gBS1f")
    ]).then(()=>parcelRequire('jlgQW'));
}

});

parcelRegister("7ytxa", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('4N2yO')
        ]);
        const value = parcelRequire('dQkHS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("4N2yO")
    ]).then(()=>parcelRequire('dQkHS'));
}

});

parcelRegister("268Sm", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('eIPn5');
        const value = parcelRequire('gCwPc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("eIPn5").then(()=>parcelRequire('gCwPc'));
}

});

parcelRegister("ddRd2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4XgLT');
        const value = parcelRequire('bGGDl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4XgLT").then(()=>parcelRequire('bGGDl'));
}

});

parcelRegister("2KyWm", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('03925')
        ]);
        const value = parcelRequire('6Z7xL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("03925")
    ]).then(()=>parcelRequire('6Z7xL'));
}

});

parcelRegister("hH8qh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jBHCq');
        const value = parcelRequire('5llHs');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jBHCq").then(()=>parcelRequire('5llHs'));
}

});

parcelRegister("971Of", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('84GBO')
        ]);
        const value = parcelRequire('5tWCX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("84GBO")
    ]).then(()=>parcelRequire('5tWCX'));
}

});

parcelRegister("4UGD7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('e9IcS')
        ]);
        const value = parcelRequire('aUjzP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("e9IcS")
    ]).then(()=>parcelRequire('aUjzP'));
}

});


parcelRegister("faoVa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ab1ef945cd09ce$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $38FsY = parcelRequire("38FsY");
const $b0ab1ef945cd09ce$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $38FsY.TextWithAnnotationDraft), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks
    }, children);
};
var $b0ab1ef945cd09ce$export$2e2bcd8739ae039 = $b0ab1ef945cd09ce$var$TextWrapper;

});
parcelRegister("38FsY", function(module, exports) {

$parcel$export(module.exports, "TextWithAnnotationDraft", () => $249248cb9219dd32$export$69a4e0ac39aaf9b7);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $i7Qp1 = parcelRequire("i7Qp1");

var $8nCeg = parcelRequire("8nCeg");

var $dQsDk = parcelRequire("dQsDk");

var $d7iV0 = parcelRequire("d7iV0");

var $dPmwl = parcelRequire("dPmwl");

var $9KKPa = parcelRequire("9KKPa");

var $lOHCn = parcelRequire("lOHCn");

var $4oBhR = parcelRequire("4oBhR");
const $249248cb9219dd32$var$markStyles = ()=>(0, $byn9U.css)({
        color: 'inherit',
        backgroundColor: 'unset',
        WebkitTapHighlightColor: 'transparent'
    }, (0, $9KKPa.AnnotationSharedCSSByState)().focus);
const $249248cb9219dd32$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    return (0, $byn9U.jsx)("mark", (0, $kU09D.default)({
        "data-renderer-mark": true
    }, (0, $dPmwl.dataAttributes)(draftPosition), {
        css: $249248cb9219dd32$var$markStyles
    }), children);
};
const $249248cb9219dd32$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $i7Qp1.InsertDraftPosition).START) return 0;
    if (annotationPosition === (0, $i7Qp1.InsertDraftPosition).END) return fragmentCount - 1;
    if (annotationPosition === (0, $i7Qp1.InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $249248cb9219dd32$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $249248cb9219dd32$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $lOHCn.segmentText)(value, textHighlighter);
        if (annotateIndex === index) return (0, $byn9U.jsx)($249248cb9219dd32$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $4oBhR.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from));
        return (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
            key: index
        }, (0, $4oBhR.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from));
    });
};
const $249248cb9219dd32$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const nextDraftPosition = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $8nCeg.AnnotationsDraftContext));
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $d7iV0.calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $dQsDk.findTextString)(children);
    if (!textString) return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $lOHCn.segmentText)(textString, textHighlighter);
        return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $4oBhR.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $i7Qp1.InsertDraftPosition).AROUND_TEXT) {
        const segments = (0, $lOHCn.segmentText)(textString, textHighlighter);
        return (0, $byn9U.jsx)($249248cb9219dd32$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $4oBhR.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $dQsDk.calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
    const texts = (0, $dQsDk.splitText)(textString, offsets);
    if (!texts) {
        const segments = (0, $lOHCn.segmentText)(textString, textHighlighter);
        return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $4oBhR.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $249248cb9219dd32$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, components);
};

});
parcelRegister("i7Qp1", function(module, exports) {

$parcel$export(module.exports, "InsertDraftPosition", () => $d321877f72b48f30$export$c1bd4813440b4505);
let $d321877f72b48f30$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});

});

parcelRegister("8nCeg", function(module, exports) {

$parcel$export(module.exports, "AnnotationsDraftContext", () => $619e202ec3e96ccf$export$365d1799d81a236d);
$parcel$export(module.exports, "ProvidersContext", () => $619e202ec3e96ccf$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $619e202ec3e96ccf$export$aafe46a36ef535ba);
$parcel$export(module.exports, "AnnotationsDraftContextWrapper", () => $619e202ec3e96ccf$export$153126608e00390);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");
const $619e202ec3e96ccf$export$365d1799d81a236d = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $619e202ec3e96ccf$export$6a26b015ac619737 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $619e202ec3e96ccf$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $eUqFw.createContext)({});
class $619e202ec3e96ccf$export$153126608e00390 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            position: null
        });
        (0, $5zQU9.default)(this, "applyAnnotationDraftAt", (nextPosition)=>{
            const { setDraftRange: setDraftRange } = this.props;
            // Set the draft range to preserve it downstream
            setDraftRange();
            // We need to support a new draft being made while one exists and overwrite it
            // Set the document position for the newly created draft
            this.setState({
                position: nextPosition
            });
        });
        (0, $5zQU9.default)(this, "clearAnnotationDraft", ()=>{
            const { clearDraftRange: clearDraftRange } = this.props;
            // Clear the draft range
            clearDraftRange();
            // Clear the draft position in the document
            this.setState({
                position: null
            });
        });
    }
    render() {
        const { children: children } = this.props;
        const { position: position } = this.state;
        const applyAnnotationDraftAt = this.applyAnnotationDraftAt;
        const clearAnnotationDraft = this.clearAnnotationDraft;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($619e202ec3e96ccf$export$365d1799d81a236d.Provider, {
            value: position
        }, children({
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            clearAnnotationDraft: clearAnnotationDraft
        }));
    }
}

});

parcelRegister("dQsDk", function(module, exports) {

$parcel$export(module.exports, "findTextString", () => $a14657aa885be425$export$a9795c84b22a1f06);
$parcel$export(module.exports, "splitText", () => $a14657aa885be425$export$2878cc467c8be8fe);
$parcel$export(module.exports, "calcTextSplitOffset", () => $a14657aa885be425$export$1059bfc467f4f55d);

var $eUqFw = parcelRequire("eUqFw");
const $a14657aa885be425$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($a14657aa885be425$var$isReactElement(childNode) && childNode.props.children) result = $a14657aa885be425$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $a14657aa885be425$var$isReactElement(child) {
    return !!child.type;
}
const $a14657aa885be425$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $a14657aa885be425$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};

});

parcelRegister("d7iV0", function(module, exports) {

$parcel$export(module.exports, "calcInsertDraftPositionOnText", () => $98ca9a9f67bea838$export$b1baddbd5f289877);

var $i7Qp1 = parcelRequire("i7Qp1");
const $98ca9a9f67bea838$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $i7Qp1.InsertDraftPosition).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $i7Qp1.InsertDraftPosition).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $i7Qp1.InsertDraftPosition).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $i7Qp1.InsertDraftPosition).START;
    return false;
};

});

parcelRegister("dPmwl", function(module, exports) {

$parcel$export(module.exports, "dataAttributes", () => $a11181e85a569adf$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $a11181e85a569adf$export$e14699d956e87e73);
const $a11181e85a569adf$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $a11181e85a569adf$var$buildDataAttributesQuery = (pos)=>{
    const a = $a11181e85a569adf$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $a11181e85a569adf$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($a11181e85a569adf$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});

parcelRegister("9KKPa", function(module, exports) {

$parcel$export(module.exports, "AnnotationSharedClassNames", () => $719cbb488c4372b8$export$b0aeb22a160e5b4c);
$parcel$export(module.exports, "AnnotationSharedCSSByState", () => $719cbb488c4372b8$export$261ebe180da42726);
$parcel$export(module.exports, "annotationSharedStyles", () => $719cbb488c4372b8$export$5f72fe1d39f8129b);

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $8Jkrv = parcelRequire("8Jkrv");
const $719cbb488c4372b8$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
const $719cbb488c4372b8$export$b0aeb22a160e5b4c = {
    focus: `${$719cbb488c4372b8$export$6d0ce11e3a04da25}-focus`,
    blur: `${$719cbb488c4372b8$export$6d0ce11e3a04da25}-blur`,
    draft: `${$719cbb488c4372b8$export$6d0ce11e3a04da25}-draft`
};
const $719cbb488c4372b8$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
const $719cbb488c4372b8$export$ac15f3ad21fefeac = {
    focus: `${$719cbb488c4372b8$export$3600479d19dfa7a9}-focus`,
    blur: `${$719cbb488c4372b8$export$3600479d19dfa7a9}-blur`,
    draft: `${$719cbb488c4372b8$export$3600479d19dfa7a9}-draft`
};
const $719cbb488c4372b8$var$mediaNodeDomRef = 'mediaView-content-wrap';
const $719cbb488c4372b8$var$Y75a = 'rgba(255, 240, 179, 0.5)';
const $719cbb488c4372b8$var$Y200a = 'rgba(255, 196, 0, 0.82)';
const $719cbb488c4372b8$export$261ebe180da42726 = ()=>(0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes') ? {
        focus: (0, $byn9U.css)({
            background: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA.Y75)})`,
            borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $PdmhA.Y300)})`}`,
            boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $PdmhA.N60A)}, -1px 2px 3px ${(0, $PdmhA.N60A)}`})`,
            cursor: 'pointer',
            '&:has(.card)': {
                fontSize: '1.5rem',
                lineHeight: '1.2rem',
                '& > *': {
                    fontSize: '16px'
                }
            }
        }),
        blur: (0, $byn9U.css)({
            background: `var(--ds-background-accent-yellow-subtlest, ${$719cbb488c4372b8$var$Y75a})`,
            borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${$719cbb488c4372b8$var$Y200a})`}`,
            cursor: 'pointer',
            '&:has(.card)': {
                fontSize: '1.5rem',
                lineHeight: '1.2rem',
                '& > *': {
                    fontSize: '16px'
                }
            }
        })
    } : {
        focus: (0, $byn9U.css)({
            // Background is not coming through in confluence, suspecting to be caused by some specific combination of
            // emotion and token look up
            background: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA.Y75)})`,
            borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $PdmhA.Y300)})`}`,
            // TODO: https://product-fabric.atlassian.net/browse/DSP-4147
            boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $PdmhA.N60A)}, -1px 2px 3px ${(0, $PdmhA.N60A)}`})`,
            cursor: 'pointer'
        }),
        blur: (0, $byn9U.css)({
            background: `var(--ds-background-accent-yellow-subtlest, ${$719cbb488c4372b8$var$Y75a})`,
            borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${$719cbb488c4372b8$var$Y200a})`}`,
            cursor: 'pointer'
        })
    };
const $719cbb488c4372b8$export$5f72fe1d39f8129b = ()=>(0, $byn9U.css)`
  .ProseMirror {
    .${$719cbb488c4372b8$export$b0aeb22a160e5b4c.focus} {
      ${$719cbb488c4372b8$export$261ebe180da42726().focus};
    }

    .${$719cbb488c4372b8$export$b0aeb22a160e5b4c.draft} {
      ${$719cbb488c4372b8$export$261ebe180da42726().focus};
      cursor: initial;
    }

    .${$719cbb488c4372b8$export$b0aeb22a160e5b4c.blur} {
      ${$719cbb488c4372b8$export$261ebe180da42726().blur};
    }

    // Styling for comments on media node
    .${$719cbb488c4372b8$var$mediaNodeDomRef}[class*=ak-editor-block-annotation-] {
      border-radius: 3px;
    }

    .${$719cbb488c4372b8$var$mediaNodeDomRef}.${$719cbb488c4372b8$export$ac15f3ad21fefeac.draft} {
      box-shadow: ${(0, $8Jkrv.commentStatusStyleMap)('draft')};
    }

    .${$719cbb488c4372b8$var$mediaNodeDomRef}.${$719cbb488c4372b8$export$ac15f3ad21fefeac.focus} {
      box-shadow: ${(0, $8Jkrv.commentStatusStyleMap)('focus')};
    }

    .${$719cbb488c4372b8$var$mediaNodeDomRef}.${$719cbb488c4372b8$export$ac15f3ad21fefeac.blur} {
      box-shadow: ${(0, $8Jkrv.commentStatusStyleMap)('blur')};
    }
  }
`;
const $719cbb488c4372b8$export$5944f6ee87463268 = (0, $byn9U.css)({
    boxShadow: `3px 3px ${`var(--ds-background-accent-yellow-subtler, ${$719cbb488c4372b8$var$Y75a})`}`,
    borderRadius: '3px'
});

});
parcelRegister("8Jkrv", function(module, exports) {

$parcel$export(module.exports, "commentStatusStyleMap", () => $65b2622dcdc236e3$export$97400dcc664ce49d);

var $PdmhA = parcelRequire("PdmhA");
const $65b2622dcdc236e3$var$boxShadowColorByStatus = {
    draft: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA.Y300)})`,
    focus: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA.Y300)})`,
    blur: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA.Y200)})`
};
const $65b2622dcdc236e3$export$97400dcc664ce49d = (status)=>`3px 3px 0px 0px ${$65b2622dcdc236e3$var$boxShadowColorByStatus[status]}`;

});


parcelRegister("lOHCn", function(module, exports) {

$parcel$export(module.exports, "segmentText", () => $fe201a1d7463e037$export$93301b6f1ff0b0c3);
function $fe201a1d7463e037$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text !== null && text !== void 0 ? text : ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}

});

parcelRegister("4oBhR", function(module, exports) {

$parcel$export(module.exports, "renderTextSegments", () => $333653bf0bc008ef$export$8a20fd0614851c5f);

var $eUqFw = parcelRequire("eUqFw");
function $333653bf0bc008ef$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter === null || textHighlighter === void 0 ? void 0 : textHighlighter.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-highlighted": true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            match: segment.text,
            groups: segment.groups,
            marks: marks,
            key: `${segment.text}_${startPos}_${idx}`,
            startPos: startPos + idx
        }, segment.text));
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
        key: `text-wrapper_${startPos}`
    }, segments.map(renderSegment));
}

});



parcelRegister("9TPMs", function(module, exports) {

$parcel$export(module.exports, "isAnnotationMark", () => $01dc26e1a67e6909$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $01dc26e1a67e6909$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");

var $c0YBv = parcelRequire("c0YBv");
const $01dc26e1a67e6909$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $01dc26e1a67e6909$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel })=>{
    const data = {
        ...dataAttributes,
        ...(0, $ht6w1.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0YBv.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", (0, $kU09D.default)({
        id: id
    }, data), children);
};
var $01dc26e1a67e6909$export$2e2bcd8739ae039 = $01dc26e1a67e6909$var$AnnotationComponent;

});
parcelRegister("c0YBv", function(module, exports) {

$parcel$export(module.exports, "MarkElement", () => $8bf47ecd1539d176$export$f3069f755c1eba0b);

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");

var $6aHyX = parcelRequire("6aHyX");

var $elo3y = parcelRequire("elo3y");
var $fJaFg = parcelRequire("fJaFg");
var $alL9J = parcelRequire("alL9J");

var $8nCeg = parcelRequire("8nCeg");

var $eUuP5 = parcelRequire("eUuP5");
const $8bf47ecd1539d176$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $alL9J.useInlineCommentSubscriberContext)();
    const states = (0, $eUqFw.useContext)((0, $8nCeg.InlineCommentsStateContext));
    const hasFocus = (0, $elo3y.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $eUqFw.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const onClick = (0, $eUqFw.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        updateSubscriber.emit((0, $eUuP5.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel
    ]);
    const activeParentIds = (0, $fJaFg.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $ht6w1.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6aHyX.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        state: states[id],
        useBlockLevel: useBlockLevel
    }, children);
};

});
parcelRegister("6aHyX", function(module, exports) {

$parcel$export(module.exports, "MarkComponent", () => $47e577ef4055e465$export$4f5a51511304fdd0);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $9KKPa = parcelRequire("9KKPa");

var $ht6w1 = parcelRequire("ht6w1");

var $XHGTv = parcelRequire("XHGTv");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState` is not object-safe
const $47e577ef4055e465$var$markStyles = ()=>(0, $byn9U.css)`
  color: inherit;
  background-color: unset;
  -webkit-tap-highlight-color: transparent;

  &[data-mark-annotation-state='${(0, $ht6w1.AnnotationMarkStates).ACTIVE}'] {
    ${(0, $9KKPa.AnnotationSharedCSSByState)().blur};

    &:focus,
    &[data-has-focus='true'] {
      ${(0, $9KKPa.AnnotationSharedCSSByState)().focus};
    }
  }
`;
const $47e577ef4055e465$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const annotationIds = (0, $eUqFw.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const onMarkClick = (0, $eUqFw.useCallback)((event)=>{
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $ht6w1.AnnotationMarkStates).ACTIVE) return;
        // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        if ((0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes')) event.stopPropagation();
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state
    ]);
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus
    };
    const accessibility = state !== (0, $ht6w1.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', ')
    };
    return (0, $byn9U.jsx)(useBlockLevel ? 'div' : 'mark', {
        id: id,
        [(0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: $47e577ef4055e465$var$markStyles
        }
    }, children);
};

});

parcelRegister("elo3y", function(module, exports) {

$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $a715afeeed4ca381$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $a715afeeed4ca381$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $a715afeeed4ca381$export$26cf539704e444c1);

var $eUqFw = parcelRequire("eUqFw");

var $eUuP5 = parcelRequire("eUuP5");

var $ht6w1 = parcelRequire("ht6w1");

var $61wF1 = parcelRequire("61wF1");

var $6PJBT = parcelRequire("6PJBT");
const $a715afeeed4ca381$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $eUqFw.useState)({});
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        updateSubscriber.on((0, $eUuP5.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
        return ()=>{
            updateSubscriber.off((0, $eUuP5.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
        };
    }, [
        states,
        type,
        updateSubscriber
    ]);
    return states;
};
const $a715afeeed4ca381$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
        };
        updateSubscriber.on((0, $eUuP5.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
        updateSubscriber.on((0, $eUuP5.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
        return ()=>{
            updateSubscriber.off((0, $eUuP5.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.off((0, $eUuP5.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
        };
    }, [
        id,
        updateSubscriber
    ]);
    return hasFocus;
};
const $a715afeeed4ca381$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $eUqFw.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent } = props;
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $61wF1.ACTION).VIEWED,
                actionSubject: (0, $61wF1.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $61wF1.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $61wF1.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0
                }
            }).fire((0, $6PJBT.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
        };
        updateSubscriber.on((0, $eUuP5.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
        updateSubscriber.on((0, $eUuP5.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
        return ()=>{
            updateSubscriber.off((0, $eUuP5.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.off((0, $eUuP5.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
        };
    }, [
        updateSubscriber,
        createAnalyticsEvent
    ]);
    return annotationClickEvent;
};

});

parcelRegister("fJaFg", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentsFilter", () => $b73354c0656a755a$export$8e7d47f9e38ad4f1);

var $eUqFw = parcelRequire("eUqFw");

var $8nCeg = parcelRequire("8nCeg");
const $b73354c0656a755a$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $eUqFw.useContext)((0, $8nCeg.InlineCommentsStateContext));
    return (0, $eUqFw.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("alL9J", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $789071bfb5245069$export$b46737175cffd396);

var $eUqFw = parcelRequire("eUqFw");

var $8nCeg = parcelRequire("8nCeg");
const $789071bfb5245069$export$b46737175cffd396 = ()=>{
    const providers = (0, $eUqFw.useContext)((0, $8nCeg.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};

});



parcelRegister("bVej2", function(module, exports) {

$parcel$export(module.exports, "toReact", () => $8ae01d790fac79a3$export$d4334b129116aad7);

var $7subh = parcelRequire("7subh");

var $4Hd2B = parcelRequire("4Hd2B");

var $1W380 = parcelRequire("1W380");

var $4mY3a = parcelRequire("4mY3a");

var $6nwFc = parcelRequire("6nwFc");

var $ioUOQ = parcelRequire("ioUOQ");

var $lAmvl = parcelRequire("lAmvl");

var $dfnu7 = parcelRequire("dfnu7");

var $j4Oes = parcelRequire("j4Oes");

var $1007J = parcelRequire("1007J");

var $51Xgc = parcelRequire("51Xgc");

var $c4cK6 = parcelRequire("c4cK6");

var $gPsph = parcelRequire("gPsph");

var $3jWT1 = parcelRequire("3jWT1");

var $jZ4vt = parcelRequire("jZ4vt");

var $9TPMs = parcelRequire("9TPMs");

var $bYs9t = parcelRequire("bYs9t");

var $1jBQJ = parcelRequire("1jBQJ");
const $8ae01d790fac79a3$export$c00d967a0f56fdb7 = {
    code: (0, $7subh.default),
    em: (0, $4Hd2B.default),
    link: (0, $1W380.default),
    strike: (0, $4mY3a.default),
    strong: (0, $6nwFc.default),
    subsup: (0, $ioUOQ.default),
    textColor: (0, $lAmvl.default),
    underline: (0, $dfnu7.default),
    annotation: (0, $9TPMs.default),
    border: (0, $bYs9t.default),
    // Stage0
    confluenceInlineComment: (0, $1jBQJ.default),
    breakout: (0, $j4Oes.default),
    alignment: (0, $1007J.default),
    indentation: (0, $51Xgc.default),
    unsupportedMark: (0, $c4cK6.default),
    unsupportedNodeAttribute: (0, $gPsph.default),
    dataConsumer: (0, $3jWT1.default),
    fragment: (0, $jZ4vt.default)
};
const $8ae01d790fac79a3$export$d4334b129116aad7 = (mark)=>{
    return $8ae01d790fac79a3$export$c00d967a0f56fdb7[mark.type.name];
};

});
parcelRegister("7subh", function(module, exports) {

$parcel$export(module.exports, "isCodeMark", () => $56e28f3e0c735637$export$86390c02c110ec2f);
$parcel$export(module.exports, "default", () => $56e28f3e0c735637$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $dl0RD = parcelRequire("dl0RD");

var $8VFoC = parcelRequire("8VFoC");
const $56e28f3e0c735637$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $56e28f3e0c735637$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $8VFoC.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dl0RD.default), (0, $kU09D.default)({
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled
    }, props.dataAttributes), props.children);
}
var $56e28f3e0c735637$export$2e2bcd8739ae039 = (0, $2qhQi.default)($56e28f3e0c735637$export$7cea6ffa7022e85f);

});

parcelRegister("4Hd2B", function(module, exports) {

$parcel$export(module.exports, "default", () => $36b54b37eaaad683$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $36b54b37eaaad683$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("em", props.dataAttributes, props.children);
}

});

parcelRegister("1W380", function(module, exports) {

$parcel$export(module.exports, "default", () => $168da264d45a28d6$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $erA3g = parcelRequire("erA3g");

var $1lWyd = parcelRequire("1lWyd");

var $61wF1 = parcelRequire("61wF1");

var $3BVCw = parcelRequire("3BVCw");

var $aw5Sy = parcelRequire("aw5Sy");
const $168da264d45a28d6$var$anchorStyles = (0, $byn9U.css)`
  color: ${`var(--ds-link, ${(0, $PdmhA.B400)})`};

  &:hover {
    color: ${`var(--ds-link, ${(0, $PdmhA.B300)})`};
    text-decoration: underline;
  }

  &:active {
    color: ${`var(--ds-link-pressed, ${(0, $PdmhA.B500)})`};
  }
`;
function $168da264d45a28d6$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    const anchorProps = {
        href: href,
        target: target,
        title: href
    };
    if (target === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $erA3g.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return (0, $byn9U.jsx)((0, $aw5Sy.default), {
        data: analyticsData
    }, (0, $byn9U.jsx)((0, $3BVCw.default), (0, $kU09D.default)({
        css: $168da264d45a28d6$var$anchorStyles,
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $61wF1.ACTION).VISITED,
                actionSubject: (0, $61wF1.ACTION_SUBJECT).LINK,
                eventType: (0, $61wF1.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $1lWyd.PLATFORM).WEB,
                    mode: (0, $1lWyd.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        }
    }, anchorProps, dataAttributes), props.children));
}

});
parcelRegister("erA3g", function(module, exports) {

$parcel$export(module.exports, "ADFEncoder", () => $a83f8d63fe8ae36e$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $a83f8d63fe8ae36e$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $a83f8d63fe8ae36e$export$eee20638634729b3);
$parcel$export(module.exports, "getPlatform", () => $a83f8d63fe8ae36e$export$867a782338812cb4);
$parcel$export(module.exports, "findInTree", () => $a83f8d63fe8ae36e$export$38b61ebf4950cd39);

var $9wcjJ = parcelRequire("9wcjJ");

var $8450v = parcelRequire("8450v");
function $a83f8d63fe8ae36e$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $a83f8d63fe8ae36e$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $9wcjJ.defaultSchema));
        this.encode = $a83f8d63fe8ae36e$var$createEncoder(transformer, new (0, $8450v.JSONTransformer)());
    }
}
const $a83f8d63fe8ae36e$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $a83f8d63fe8ae36e$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
const $a83f8d63fe8ae36e$export$867a782338812cb4 = (rendererAppearance)=>{
    if (rendererAppearance === 'mobile') return 'mobile';
    return 'web';
};
function $a83f8d63fe8ae36e$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $a83f8d63fe8ae36e$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});
parcelRegister("8450v", function(module, exports) {

$parcel$export(module.exports, "SchemaStage", () => $5df294ca6ea3a158$export$933e6445c497ffd5);
$parcel$export(module.exports, "JSONTransformer", () => $5df294ca6ea3a158$export$98cb1d9308d0944d);

var $hTLlD = parcelRequire("hTLlD");

var $88rqd = parcelRequire("88rqd");
var $eTCNF = parcelRequire("eTCNF");
var $hH51j = parcelRequire("hH51j");
var $1BBUE = parcelRequire("1BBUE");
var $ig4y4 = parcelRequire("ig4y4");
var $aFq96 = parcelRequire("aFq96");
var $2sd4y = parcelRequire("2sd4y");
var $T1nAs = parcelRequire("T1nAs");
var $fKLaE = parcelRequire("fKLaE");

var $atVH7 = parcelRequire("atVH7");

var $7bxxe = parcelRequire("7bxxe");

var $ja5wt = parcelRequire("ja5wt");
let $5df294ca6ea3a158$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
const $5df294ca6ea3a158$var$isType = (type)=>(node)=>node.type.name === type;
const $5df294ca6ea3a158$var$isCodeBlock = $5df294ca6ea3a158$var$isType('codeBlock');
const $5df294ca6ea3a158$var$isMediaNode = $5df294ca6ea3a158$var$isType('media');
const $5df294ca6ea3a158$var$isMediaInline = $5df294ca6ea3a158$var$isType('mediaInline');
const $5df294ca6ea3a158$var$isMediaSingleNode = $5df294ca6ea3a158$var$isType('mediaSingle');
const $5df294ca6ea3a158$var$isMentionNode = $5df294ca6ea3a158$var$isType('mention');
const $5df294ca6ea3a158$var$isParagraph = $5df294ca6ea3a158$var$isType('paragraph');
const $5df294ca6ea3a158$var$isHeading = $5df294ca6ea3a158$var$isType('heading');
const $5df294ca6ea3a158$var$isTable = $5df294ca6ea3a158$var$isType('table');
const $5df294ca6ea3a158$var$isTableCell = $5df294ca6ea3a158$var$isType('tableCell');
const $5df294ca6ea3a158$var$isTableHeader = $5df294ca6ea3a158$var$isType('tableHeader');
const $5df294ca6ea3a158$var$isLinkMark = $5df294ca6ea3a158$var$isType('link');
const $5df294ca6ea3a158$var$isUnsupportedMark = $5df294ca6ea3a158$var$isType('unsupportedMark');
const $5df294ca6ea3a158$var$isUnsupportedNodeAttributeMark = $5df294ca6ea3a158$var$isType('unsupportedNodeAttribute');
const $5df294ca6ea3a158$var$isExpand = $5df294ca6ea3a158$var$isType('expand');
const $5df294ca6ea3a158$var$isNestedExpand = $5df294ca6ea3a158$var$isType('nestedExpand');
const $5df294ca6ea3a158$var$isUnsupportedNode = (node)=>$5df294ca6ea3a158$var$isType('unsupportedBlock')(node) || $5df294ca6ea3a158$var$isType('unsupportedInline')(node);
const $5df294ca6ea3a158$var$isDataConsumer = $5df294ca6ea3a158$var$isType('dataConsumer');
const $5df294ca6ea3a158$var$isFragmentMark = $5df294ca6ea3a158$var$isType('fragment');
const $5df294ca6ea3a158$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $5df294ca6ea3a158$var$filterNull(current);
    }
    return output;
};
const $5df294ca6ea3a158$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $5df294ca6ea3a158$var$emptyDoc = $5df294ca6ea3a158$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
const $5df294ca6ea3a158$var$toJSON = (node)=>{
    const obj = {
        type: node.type.name
    };
    if ($5df294ca6ea3a158$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($5df294ca6ea3a158$var$isMediaNode(node)) obj.attrs = (0, $2sd4y.toJSON)(node).attrs;
    else if ($5df294ca6ea3a158$var$isMediaSingleNode(node)) obj.attrs = (0, $aFq96.toJSON)(node).attrs;
    else if ($5df294ca6ea3a158$var$isMediaInline(node)) obj.attrs = (0, $2sd4y.toJSON)(node).attrs;
    else if ($5df294ca6ea3a158$var$isMentionNode(node)) obj.attrs = (0, $T1nAs.toJSON)(node).attrs;
    else if ($5df294ca6ea3a158$var$isCodeBlock(node)) obj.attrs = (0, $88rqd.toJSON)(node).attrs;
    else if ($5df294ca6ea3a158$var$isTable(node)) obj.attrs = (0, $fKLaE.tableToJSON)(node).attrs;
    else if ($5df294ca6ea3a158$var$isTableCell(node)) obj.attrs = (0, $fKLaE.toJSONTableCell)(node).attrs;
    else if ($5df294ca6ea3a158$var$isTableHeader(node)) obj.attrs = (0, $fKLaE.toJSONTableHeader)(node).attrs;
    else if ($5df294ca6ea3a158$var$isExpand(node) || $5df294ca6ea3a158$var$isNestedExpand(node)) obj.attrs = (0, $hH51j.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $5df294ca6ea3a158$var$filterNull(obj.attrs);
    // Remove the attrs property if it's empty, this is currently limited to paragraph nodes.
    if ($5df294ca6ea3a158$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($5df294ca6ea3a158$var$toJSON(child));
    });
    if ($5df294ca6ea3a158$var$isParagraph(node) || $5df294ca6ea3a158$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($5df294ca6ea3a158$var$isUnsupportedMark(mark)) return $5df294ca6ea3a158$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($5df294ca6ea3a158$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($5df294ca6ea3a158$var$isLinkMark(mark)) return (0, $ig4y4.toJSON)(mark);
            else if ($5df294ca6ea3a158$var$isDataConsumer(mark)) {
                var _serialised$attrs$sou;
                const serialised = (0, $eTCNF.toJSON)(mark);
                return !serialised.attrs.sources || ((_serialised$attrs$sou = serialised.attrs.sources) === null || _serialised$attrs$sou === void 0 ? void 0 : _serialised$attrs$sou.length) === 0 ? null : serialised;
            } else if ($5df294ca6ea3a158$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $1BBUE.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = (parsedMarks === null || parsedMarks === void 0 ? void 0 : parsedMarks.length) > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($5df294ca6ea3a158$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$5df294ca6ea3a158$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $5df294ca6ea3a158$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $7bxxe.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $5df294ca6ea3a158$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $5df294ca6ea3a158$export$98cb1d9308d0944d {
    encode(node) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $ja5wt.sanitizeNode)($5df294ca6ea3a158$var$toJSON(child)));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(content, $5df294ca6ea3a158$var$emptyDoc.content)) return $5df294ca6ea3a158$var$createDocFromContent([]);
        return $5df294ca6ea3a158$var$createDocFromContent(content);
    }
    internalParse(content, stage = $5df294ca6ea3a158$export$933e6445c497ffd5.FINAL) {
        const schema = (0, $atVH7.getSchemaBasedOnStage)(stage);
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        if (!content.content || content.content.length === 0) return this.internalParse($5df294ca6ea3a158$var$emptyDoc, stage);
        return this.internalParse(content, stage);
    }
    /**
   * This method is used to encode a single node
   */ encodeNode(node) {
        return (0, $ja5wt.sanitizeNode)($5df294ca6ea3a158$var$toJSON(node));
    }
}

});
parcelRegister("88rqd", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $5ec45780f4ec46d5$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $5ec45780f4ec46d5$export$54fd2c36b5cc6731);

var $7dkLM = parcelRequire("7dkLM");
/**
 * @name codeBlock_node
 */ /**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_with_marks_node
 */ const $5ec45780f4ec46d5$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $5ec45780f4ec46d5$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $5ec45780f4ec46d5$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $5ec45780f4ec46d5$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $5ec45780f4ec46d5$var$extractLanguageFromClass = (className)=>{
    const languageRegex = /(?:^|\s)language-([^\s]+)/;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $5ec45780f4ec46d5$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
const $5ec45780f4ec46d5$export$7bb0d5c671655cc4 = {
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    code: true,
    defining: true,
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $5ec45780f4ec46d5$var$getLanguageFromBitbucketStyle(dom.parentElement) || $5ec45780f4ec46d5$var$getLanguageFromEditorStyle(dom.parentElement) || $5ec45780f4ec46d5$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $5ec45780f4ec46d5$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            // @see ED-5682
            getContent: (domNode, schema)=>{
                const dom = domNode;
                const code = Array.from(dom.children).map((child)=>child.textContent).filter((x)=>x !== undefined).join('\n');
                return code ? (0, $7dkLM.Fragment).from(schema.text(code)) : (0, $7dkLM.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
};
const $5ec45780f4ec46d5$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });

});

parcelRegister("eTCNF", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", () => $ad844c9d217bc2e2$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $ad844c9d217bc2e2$export$54fd2c36b5cc6731);

var $sm2rq = parcelRequire("sm2rq");
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ const $ad844c9d217bc2e2$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $sm2rq.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $ad844c9d217bc2e2$export$3024f02c495408d6 = {
    attrs: {
        sources: {
            default: []
        }
    },
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$ad844c9d217bc2e2$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
};
const $ad844c9d217bc2e2$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("sm2rq", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", () => $0553b6007c35e56f$export$c296e2d4365c37a5);
const $0553b6007c35e56f$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("hH51j", function(module, exports) {

$parcel$export(module.exports, "expand", () => $ce1a58bda39b233a$export$9f77e0932fb78f72);
$parcel$export(module.exports, "toJSON", () => $ce1a58bda39b233a$export$54fd2c36b5cc6731);
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_with_breakout_mark_node
 */ function $ce1a58bda39b233a$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $ce1a58bda39b233a$export$9f77e0932fb78f72 = {
    inline: false,
    group: 'block',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    isolating: true,
    selectable: true,
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $ce1a58bda39b233a$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            skip: true
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            skip: true
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $ce1a58bda39b233a$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $ce1a58bda39b233a$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("1BBUE", function(module, exports) {

$parcel$export(module.exports, "fragment", () => $12b6a7d706f1454f$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $12b6a7d706f1454f$export$54fd2c36b5cc6731);

var $sm2rq = parcelRequire("sm2rq");
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ const $12b6a7d706f1454f$var$parseFragment = (maybeValue)=>{
    var _maybeValue$getAttrib;
    if (!(0, $sm2rq.isDOMElement)(maybeValue)) return false;
    const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $12b6a7d706f1454f$export$f00aeb236b6f05af = {
    inclusive: false,
    excludes: '',
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$12b6a7d706f1454f$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
};
const $12b6a7d706f1454f$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("ig4y4", function(module, exports) {

$parcel$export(module.exports, "link", () => $d4ad3fdea2a37317$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $d4ad3fdea2a37317$export$54fd2c36b5cc6731);


var $82amI = parcelRequire("82amI");
/**
 * @name link_mark
 */ const $d4ad3fdea2a37317$var$getLinkAttrs = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $82amI.isSafeUrl)(href)) return false;
        if ((0, $82amI.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $82amI.normalizeUrl)(href);
        return attrs;
    };
const $d4ad3fdea2a37317$export$9c30223ca0a664fb = {
    excludes: `${(0, $c35df775798bc280$export$b395009ca7f092c7)}`,
    // ED-5844 No multiple links in media node
    group: (0, $c35df775798bc280$export$b395009ca7f092c7),
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $d4ad3fdea2a37317$var$getLinkAttrs('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $d4ad3fdea2a37317$var$getLinkAttrs('href')
        }
    ],
    toDOM (node, isInline) {
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $82amI.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
};
const $d4ad3fdea2a37317$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $d4ad3fdea2a37317$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($d4ad3fdea2a37317$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $c35df775798bc280$export$4498a6080fed604c = 'fontStyle';
const $c35df775798bc280$export$f8e8a5f34f6ea725 = 'searchQuery';
const $c35df775798bc280$export$b395009ca7f092c7 = 'link';
const $c35df775798bc280$export$9b982809044276a6 = 'color';
const $c35df775798bc280$export$470d0905851e47a1 = 'alignment';
const $c35df775798bc280$export$bacb7f4b06a06b22 = 'indentation';

parcelRegister("82amI", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $5d968cf7fb653cb1$export$c9f92f5469372e0f);
$parcel$export(module.exports, "normalizeUrl", () => $5d968cf7fb653cb1$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $5d968cf7fb653cb1$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $izjsg = parcelRequire("izjsg");
const $5d968cf7fb653cb1$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $5d968cf7fb653cb1$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $5d968cf7fb653cb1$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $5d968cf7fb653cb1$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($izjsg)))();
$5d968cf7fb653cb1$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$5d968cf7fb653cb1$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $5d968cf7fb653cb1$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$5d968cf7fb653cb1$export$8ccbde94d5c7f8e7.add('tel:', $5d968cf7fb653cb1$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$5d968cf7fb653cb1$export$8ccbde94d5c7f8e7.add('file:', $5d968cf7fb653cb1$var$urlWithoutSpacesValidator);
$5d968cf7fb653cb1$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $5d968cf7fb653cb1$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $5d968cf7fb653cb1$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$5d968cf7fb653cb1$var$tlds.push($5d968cf7fb653cb1$var$tlds2Char);
$5d968cf7fb653cb1$export$8ccbde94d5c7f8e7.tlds($5d968cf7fb653cb1$var$tlds, false);
const $5d968cf7fb653cb1$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $5d968cf7fb653cb1$export$6f7d7761b97f967 = (text)=>{
    if (!$5d968cf7fb653cb1$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($5d968cf7fb653cb1$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($5d968cf7fb653cb1$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $5d968cf7fb653cb1$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $5d968cf7fb653cb1$export$6f7d7761b97f967(str);
    if (!match.length) match = $5d968cf7fb653cb1$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $5d968cf7fb653cb1$export$6535eb414fa2c8b6(url) {
    const match = $5d968cf7fb653cb1$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $5d968cf7fb653cb1$export$23579274a7a24f7b(url) {
    return url.startsWith('/');
}

});


parcelRegister("aFq96", function(module, exports) {

$parcel$export(module.exports, "mediaSingleFull", () => $7c4203b7d47b06fa$export$7e767666f2ce108a);
$parcel$export(module.exports, "toJSON", () => $7c4203b7d47b06fa$export$54fd2c36b5cc6731);

var $4ggv1 = parcelRequire("4ggv1");

var $sm2rq = parcelRequire("sm2rq");
const $7c4203b7d47b06fa$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $7c4203b7d47b06fa$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false })=>{
    const content = withCaption ? 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*' : 'media|unsupportedBlock+|media unsupportedBlock+';
    const atom = !withCaption;
    const getAttrs = (dom)=>{
        if (!(0, $sm2rq.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $4ggv1.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $4ggv1.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    return {
        inline: false,
        group: 'block',
        selectable: true,
        atom: atom,
        content: content,
        attrs: withExtendedWidthTypes ? {
            ...$7c4203b7d47b06fa$export$bb3fe706be61f640,
            widthType: {
                default: null
            }
        } : $7c4203b7d47b06fa$export$bb3fe706be61f640,
        marks: 'unsupportedMark unsupportedNodeAttribute annotation border link',
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    };
};
const $7c4203b7d47b06fa$export$969fe3781ca15058 = $7c4203b7d47b06fa$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $7c4203b7d47b06fa$export$d35e6c006d4abdfb = $7c4203b7d47b06fa$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $7c4203b7d47b06fa$export$9c58e19811ce4cf5 = $7c4203b7d47b06fa$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $7c4203b7d47b06fa$export$7e767666f2ce108a = $7c4203b7d47b06fa$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $7c4203b7d47b06fa$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("4ggv1", function(module, exports) {

$parcel$export(module.exports, "WidthType", () => $31a5747fe29295f8$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ let $31a5747fe29295f8$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("2sd4y", function(module, exports) {

$parcel$export(module.exports, "defaultAttrs", () => $1c98563ce2df05a2$export$bb3fe706be61f640);
$parcel$export(module.exports, "createMediaSpec", () => $1c98563ce2df05a2$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "media", () => $1c98563ce2df05a2$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $1c98563ce2df05a2$export$54fd2c36b5cc6731);

var $XLrdp = parcelRequire("XLrdp");
const $1c98563ce2df05a2$export$bb3fe706be61f640 = {
    id: {
        default: ''
    },
    type: {
        default: 'file'
    },
    collection: {
        default: ''
    },
    occurrenceKey: {
        default: null
    },
    alt: {
        default: ''
    },
    width: {
        default: null
    },
    height: {
        default: null
    },
    url: {
        default: null
    },
    __fileName: {
        default: null
    },
    __fileSize: {
        default: null
    },
    __fileMimeType: {
        default: null
    },
    __displayType: {
        default: null
    },
    __contextId: {
        default: null
    },
    __mediaTraceId: {
        default: null
    },
    __external: {
        default: false
    }
};
const $1c98563ce2df05a2$export$35bdbf5bc8caa677 = (attributes, inline = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    const key = $1c98563ce2df05a2$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    // media-inline.ts uses this same function to generate the nodespec
    // this ensures that we don't make a media inline out of a copied image
    // https://product-fabric.atlassian.net/browse/EDM-2996
    if (!inline) parseDOM.push({
        tag: 'img:not(.smart-link-icon)',
        getAttrs: (dom)=>{
            return {
                type: 'external',
                url: dom.getAttribute('src') || '',
                alt: dom.getAttribute('alt') || ''
            };
        }
    });
    return {
        selectable: true,
        inline: inline,
        group: inline ? 'inline' : undefined,
        attrs: attributes,
        parseDOM: parseDOM,
        toDOM (node) {
            const attrs = {
                'data-id': node.attrs.id,
                'data-node-type': `${nodeName}`,
                'data-type': node.attrs.type,
                'data-collection': node.attrs.collection,
                'data-occurrence-key': node.attrs.occurrenceKey,
                'data-width': node.attrs.width,
                'data-height': node.attrs.height,
                'data-url': node.attrs.url,
                'data-alt': node.attrs.alt,
                // toDOM is used for static rendering as well as editor rendering. This comes into play for
                // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
                // node view being used for editing).
                title: 'Attachment',
                // Manually kept in sync with the style of media cards. The goal is to render a plain gray
                // rectangle that provides an affordance for media.
                style: `display: inline-block; border-radius: 3px; background: ${(0, $XLrdp.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
            };
            $1c98563ce2df05a2$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$1c98563ce2df05a2$export$f84fdfb973c05bd8(key.slice(2))}`);
            return [
                `${domNodeType}`,
                attrs
            ];
        }
    };
};
const $1c98563ce2df05a2$export$987d49ffe1b0900f = $1c98563ce2df05a2$export$35bdbf5bc8caa677($1c98563ce2df05a2$export$bb3fe706be61f640);
const $1c98563ce2df05a2$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $1c98563ce2df05a2$export$111130fa8968d741 = (from, to, map)=>{
    if ($1c98563ce2df05a2$export$987d49ffe1b0900f.attrs) Object.keys($1c98563ce2df05a2$export$987d49ffe1b0900f.attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $1c98563ce2df05a2$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt'
];
const $1c98563ce2df05a2$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt'
];
const $1c98563ce2df05a2$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $1c98563ce2df05a2$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($1c98563ce2df05a2$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("XLrdp", function(module, exports) {

$parcel$export(module.exports, "R50", () => $0b3a4efe143ed30b$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $0b3a4efe143ed30b$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $0b3a4efe143ed30b$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $0b3a4efe143ed30b$export$4a7404f376229999);
$parcel$export(module.exports, "R500", () => $0b3a4efe143ed30b$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $0b3a4efe143ed30b$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $0b3a4efe143ed30b$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $0b3a4efe143ed30b$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y400", () => $0b3a4efe143ed30b$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $0b3a4efe143ed30b$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $0b3a4efe143ed30b$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $0b3a4efe143ed30b$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $0b3a4efe143ed30b$export$940e1f69e873f202);
$parcel$export(module.exports, "G500", () => $0b3a4efe143ed30b$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $0b3a4efe143ed30b$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $0b3a4efe143ed30b$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $0b3a4efe143ed30b$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $0b3a4efe143ed30b$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $0b3a4efe143ed30b$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $0b3a4efe143ed30b$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $0b3a4efe143ed30b$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $0b3a4efe143ed30b$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $0b3a4efe143ed30b$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N60", () => $0b3a4efe143ed30b$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $0b3a4efe143ed30b$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "Neutral300", () => $0b3a4efe143ed30b$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $0b3a4efe143ed30b$export$13609db0e6812ab8);
$parcel$export(module.exports, "N600", () => $0b3a4efe143ed30b$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $0b3a4efe143ed30b$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $0b3a4efe143ed30b$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $0b3a4efe143ed30b$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $0b3a4efe143ed30b$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $0b3a4efe143ed30b$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $0b3a4efe143ed30b$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $0b3a4efe143ed30b$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $0b3a4efe143ed30b$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $0b3a4efe143ed30b$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $0b3a4efe143ed30b$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $0b3a4efe143ed30b$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $0b3a4efe143ed30b$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $0b3a4efe143ed30b$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $0b3a4efe143ed30b$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $0b3a4efe143ed30b$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $0b3a4efe143ed30b$export$6036577f95c3877e);
$parcel$export(module.exports, "isHex", () => $0b3a4efe143ed30b$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $0b3a4efe143ed30b$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $0b3a4efe143ed30b$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgba", () => $0b3a4efe143ed30b$export$9665a07d9187b414);

var $dDX7B = parcelRequire("dDX7B");
const $0b3a4efe143ed30b$export$4b84fd0e2c617bd = '#FFEBE6';
const $0b3a4efe143ed30b$export$b34b069eff244586 = '#FFBDAD';
const $0b3a4efe143ed30b$export$be802dd0d8b57f35 = '#FF8F73';
const $0b3a4efe143ed30b$export$4a7404f376229999 = '#FF5630';
const $0b3a4efe143ed30b$export$2010d0fb4295b346 = '#DE350B';
const $0b3a4efe143ed30b$export$2837b5a1a71d5c02 = '#BF2600';
const $0b3a4efe143ed30b$export$8d9596b529bbb9cf = '#FFFAE6';
const $0b3a4efe143ed30b$export$41060a744ab0b7ae = '#FFF0B3';
const $0b3a4efe143ed30b$export$5aae31392d72caaa = '#FFC400';
const $0b3a4efe143ed30b$export$59619663aa6500fb = '#FF991F';
const $0b3a4efe143ed30b$export$874739ea9e379ab6 = '#FF8B00';
const $0b3a4efe143ed30b$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $0b3a4efe143ed30b$export$69a3bf21b9686c2b = '#ABF5D1';
const $0b3a4efe143ed30b$export$747d86715d4175de = '#57D9A3';
const $0b3a4efe143ed30b$export$940e1f69e873f202 = '#36B37E';
const $0b3a4efe143ed30b$export$a49394138f7b8e85 = '#00875A';
const $0b3a4efe143ed30b$export$6fa04827ac68a4fb = '#006644';
const $0b3a4efe143ed30b$export$226de0355ed012f8 = '#DEEBFF';
const $0b3a4efe143ed30b$export$8c13c2ee36917869 = '#B3D4FF';
const $0b3a4efe143ed30b$export$ecfc1dff386a3e7a = '#4C9AFF';
const $0b3a4efe143ed30b$export$b3de0ae08da2ce64 = '#0052CC';
const $0b3a4efe143ed30b$export$a6ee3d71bc067634 = '#0747A6';
const $0b3a4efe143ed30b$export$f72948ef771f6f15 = '#D3F1A7';
const $0b3a4efe143ed30b$export$29a4f05edc054374 = '#FFFFFF';
const $0b3a4efe143ed30b$export$9fdfb749e33cdf97 = '#F4F5F7';
const $0b3a4efe143ed30b$export$3e51e8f1440314ba = '#EBECF0';
const $0b3a4efe143ed30b$export$1ce2d1575d444ceb = '#DFE1E6';
const $0b3a4efe143ed30b$export$8754fc7e6d8b3000 = '#C1C7D0';
const $0b3a4efe143ed30b$export$c2e91cbeada39b8b = '#B3BAC5';
const $0b3a4efe143ed30b$export$eaa8c8a70ac22806 = '#97A0AF';
const $0b3a4efe143ed30b$export$7c87d337fb91a97d = '#8993A4';
const $0b3a4efe143ed30b$export$f563ee71e9ee74cd = '#6B778C';
const $0b3a4efe143ed30b$export$e2ef2124cf4024b1 = '#5E6C84';
const $0b3a4efe143ed30b$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $0b3a4efe143ed30b$export$13609db0e6812ab8 = '#091E4224';
const $0b3a4efe143ed30b$export$c39c0fe0f26207ae = '#42526E';
const $0b3a4efe143ed30b$export$7090862dc3038a9f = '#758195';
const $0b3a4efe143ed30b$export$7d61b15e0da132af = '#172B4D';
const $0b3a4efe143ed30b$export$f78789c8b01753cd = '#172B4D';
const $0b3a4efe143ed30b$export$a19f0c33186f7767 = '#FDD0EC';
const $0b3a4efe143ed30b$export$51716a84e62e022c = '#FEDEC8';
const $0b3a4efe143ed30b$export$363e4475840015bb = '#EAE6FF';
const $0b3a4efe143ed30b$export$4b0a4417ed59760f = '#C0B6F2';
const $0b3a4efe143ed30b$export$6011520a64d9a187 = '#998DD9';
const $0b3a4efe143ed30b$export$a7175d4e9206bc80 = '#DFD8FD';
const $0b3a4efe143ed30b$export$b48405b95304b5a1 = '#6554C0';
const $0b3a4efe143ed30b$export$c71e4279dd54a18d = '#5243AA';
const $0b3a4efe143ed30b$export$147899de772240ec = '#403294';
const $0b3a4efe143ed30b$export$2cf711fe14c66f06 = '#E6FCFF';
const $0b3a4efe143ed30b$export$7a8f4d33f6f9772c = '#B3F5FF';
const $0b3a4efe143ed30b$export$776c9c497ef08533 = '#79E2F2';
const $0b3a4efe143ed30b$export$69cb3ca10c1e330e = '#C6EDFB';
const $0b3a4efe143ed30b$export$9dc1ef0f3f48059b = '#00B8D9';
const $0b3a4efe143ed30b$export$6036577f95c3877e = '#008DA6';
function $0b3a4efe143ed30b$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($0b3a4efe143ed30b$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($0b3a4efe143ed30b$export$e698776ec826343(color)) return $0b3a4efe143ed30b$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($dDX7B.default && $dDX7B.default[color]) color = $dDX7B.default[color];
        else if ($dDX7B && $dDX7B[color]) color = $dDX7B[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $0b3a4efe143ed30b$export$5a544e13ad4e1fa5(color) {
    if (!$0b3a4efe143ed30b$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $0b3a4efe143ed30b$export$9665a07d9187b414(rawColor, alpha) {
    const color = $0b3a4efe143ed30b$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $0b3a4efe143ed30b$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $0b3a4efe143ed30b$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $0b3a4efe143ed30b$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});


parcelRegister("T1nAs", function(module, exports) {

$parcel$export(module.exports, "mention", () => $0a56351882c049aa$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $0a56351882c049aa$export$54fd2c36b5cc6731);

var $5WDZf = parcelRequire("5WDZf");
let $0a56351882c049aa$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $0a56351882c049aa$export$db83999c14438df4 = {
    inline: true,
    group: 'inline',
    selectable: true,
    attrs: {
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        },
        localId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-mention-id') || $0a56351882c049aa$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $0a56351882c049aa$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $0a56351882c049aa$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $5WDZf.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($0a56351882c049aa$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
};
const $0a56351882c049aa$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $0a56351882c049aa$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($0a56351882c049aa$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});
parcelRegister("5WDZf", function(module, exports) {

$parcel$export(module.exports, "uuid", () => $45416312aaaf655a$export$31b40729666a4ae0);
/* eslint-disable no-bitwise */ const $45416312aaaf655a$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $45416312aaaf655a$var$staticValue = false;
const $45416312aaaf655a$export$31b40729666a4ae0 = {
    setStatic (value) {
        $45416312aaaf655a$var$staticValue = value;
    },
    generate () {
        return $45416312aaaf655a$var$staticValue || $45416312aaaf655a$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("fKLaE", function(module, exports) {

$parcel$export(module.exports, "table", () => $b77fbe05cc61b641$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableToJSON", () => $b77fbe05cc61b641$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $b77fbe05cc61b641$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $b77fbe05cc61b641$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $b77fbe05cc61b641$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $b77fbe05cc61b641$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $b77fbe05cc61b641$export$2af48797a1010bb1);

var $kpmwi = parcelRequire("kpmwi");

var $XLrdp = parcelRequire("XLrdp");

var $5WDZf = parcelRequire("5WDZf");

var $8yoRr = parcelRequire("8yoRr");
const $b77fbe05cc61b641$export$9cfceb893b24742a = 'pm-table';
const $b77fbe05cc61b641$export$69cb4c3f80383763 = `${$b77fbe05cc61b641$export$9cfceb893b24742a}-cell-content-wrap`;
const $b77fbe05cc61b641$export$7b07d37d879c957f = `${$b77fbe05cc61b641$export$9cfceb893b24742a}-header-content-wrap`;
const $b77fbe05cc61b641$export$8dd42a84cd52da07 = `${$b77fbe05cc61b641$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $b77fbe05cc61b641$export$5e26a5c19f0865d8 = `${$b77fbe05cc61b641$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $b77fbe05cc61b641$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $XLrdp.N20).toLocaleLowerCase();
const $b77fbe05cc61b641$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $XLrdp.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $XLrdp.isRgb)(backgroundColor)) {
        const result = (0, $XLrdp.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
let $b77fbe05cc61b641$var$testGlobalTheme;
const $b77fbe05cc61b641$export$fd7e0dd2b74807f7 = (theme)=>{
    $b77fbe05cc61b641$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $b77fbe05cc61b641$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($b77fbe05cc61b641$var$testGlobalTheme) return {
        colorMode: $b77fbe05cc61b641$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $b77fbe05cc61b641$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $b77fbe05cc61b641$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $b77fbe05cc61b641$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $XLrdp.isRgb)(background) && (0, $XLrdp.rgbToHex)(background) ? (0, $XLrdp.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $kpmwi.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($b77fbe05cc61b641$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $8yoRr.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            attrs.colorname = $b77fbe05cc61b641$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $b77fbe05cc61b641$export$7b07d37d879c957f;
    else attrs.class = $b77fbe05cc61b641$export$69cb4c3f80383763;
    return attrs;
};
const $b77fbe05cc61b641$export$219b7f492ad209f8 = new Map();
const $b77fbe05cc61b641$export$95e9c925fbf01d1c = (0, $XLrdp.hexToRgba)((0, $XLrdp.N800), 0.12) || (0, $XLrdp.N0);
const $b77fbe05cc61b641$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $XLrdp.N0),
        'White'
    ],
    [
        (0, $XLrdp.B50),
        'Light blue'
    ],
    [
        (0, $XLrdp.T50),
        'Light teal'
    ],
    [
        (0, $XLrdp.G50),
        'Light green'
    ],
    [
        (0, $XLrdp.Y50),
        'Light yellow'
    ],
    [
        (0, $XLrdp.R50),
        'Light red'
    ],
    [
        (0, $XLrdp.P50),
        'Light purple'
    ],
    [
        (0, $XLrdp.N20),
        'Light gray'
    ],
    [
        (0, $XLrdp.B75),
        'Blue'
    ],
    [
        (0, $XLrdp.T75),
        'Teal'
    ],
    [
        (0, $XLrdp.G75),
        'Green'
    ],
    [
        (0, $XLrdp.Y75),
        'Yellow'
    ],
    [
        (0, $XLrdp.R75),
        'Red'
    ],
    [
        (0, $XLrdp.P75),
        'Purple'
    ],
    [
        (0, $XLrdp.N60),
        'Gray'
    ],
    [
        (0, $XLrdp.B100),
        'Dark blue'
    ],
    [
        (0, $XLrdp.T100),
        'Dark teal'
    ],
    [
        (0, $XLrdp.G200),
        'Dark green'
    ],
    [
        (0, $XLrdp.Y200),
        'Dark yellow'
    ],
    [
        (0, $XLrdp.R100),
        'Dark red'
    ],
    [
        (0, $XLrdp.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $b77fbe05cc61b641$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $b77fbe05cc61b641$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // TODO: Fix any, potential issue. ED-5048
const $b77fbe05cc61b641$var$createTableSpec = ()=>{
    const attrs = {
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        __autoSize: {
            default: false
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        displayMode: {
            default: null
        }
    };
    const tableNodeSpec = {
        content: 'tableRow+',
        attrs: attrs,
        marks: 'unsupportedMark unsupportedNodeAttribute',
        tableRole: 'table',
        isolating: true,
        selectable: true,
        group: 'block',
        parseDOM: [
            {
                tag: 'table',
                getAttrs: (node)=>{
                    var _dom$parentElement;
                    const dom = node;
                    const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                    return {
                        isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                        layout: // copying from editor
                        dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                        __autoSize: dom.getAttribute('data-autosize') === 'true',
                        localId: dom.getAttribute('data-table-local-id') || (0, $5WDZf.uuid).generate(),
                        width: Number(dom.getAttribute('data-table-width')) || null,
                        displayMode: dom.getAttribute('data-table-display-mode') || null
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-number-column': node.attrs.isNumberColumnEnabled,
                'data-layout': node.attrs.layout,
                'data-autosize': node.attrs.__autoSize,
                'data-table-local-id': node.attrs.localId,
                'data-table-width': node.attrs.width,
                'data-table-display-mode': node.attrs.displayMode
            };
            return [
                'table',
                attrs,
                [
                    'tbody',
                    0
                ]
            ];
        }
    };
    return tableNodeSpec;
};
const $b77fbe05cc61b641$export$9852986a3ec5f6a0 = $b77fbe05cc61b641$var$createTableSpec();
const $b77fbe05cc61b641$export$90e634fbace1f0c4 = $b77fbe05cc61b641$var$createTableSpec();
const $b77fbe05cc61b641$export$3862de5c8c9098cf = $b77fbe05cc61b641$var$createTableSpec();
const $b77fbe05cc61b641$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $b77fbe05cc61b641$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$b77fbe05cc61b641$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $b77fbe05cc61b641$export$ce666bf02318c957 = {
    selectable: false,
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    tableRole: 'row',
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $b77fbe05cc61b641$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
const $b77fbe05cc61b641$export$e1e720e5f4603e6a = {
    selectable: false,
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle |  mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    attrs: $b77fbe05cc61b641$var$cellAttrs,
    tableRole: 'cell',
    marks: 'alignment dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    isolating: true,
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: (dom)=>$b77fbe05cc61b641$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $b77fbe05cc61b641$export$363c8dda799bfe9c(node),
            0
        ]
};
const $b77fbe05cc61b641$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($b77fbe05cc61b641$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $b77fbe05cc61b641$export$48884d2a5190dc73 = {
    selectable: false,
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle |  mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    attrs: $b77fbe05cc61b641$var$cellAttrs,
    tableRole: 'header_cell',
    isolating: true,
    marks: 'alignment dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$b77fbe05cc61b641$export$43977bde391e007(dom, {
                    background: $b77fbe05cc61b641$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $b77fbe05cc61b641$export$363c8dda799bfe9c(node),
            0
        ]
};
const $b77fbe05cc61b641$export$2af48797a1010bb1 = $b77fbe05cc61b641$export$2ac34c099660f1a8;

});
parcelRegister("kpmwi", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $edb79c6d9f903755$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $edb79c6d9f903755$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $edb79c6d9f903755$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $edb79c6d9f903755$export$a270511a0e7fd61a);
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $edb79c6d9f903755$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return $edb79c6d9f903755$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $edb79c6d9f903755$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $edb79c6d9f903755$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return $edb79c6d9f903755$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $edb79c6d9f903755$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $edb79c6d9f903755$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return $edb79c6d9f903755$export$12a518ff137dd389[hexColor.toUpperCase()];
}
const $edb79c6d9f903755$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $edb79c6d9f903755$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = $edb79c6d9f903755$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $edb79c6d9f903755$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("8yoRr", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", () => $63a4c8905791d888$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
const $63a4c8905791d888$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $63a4c8905791d888$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $63a4c8905791d888$var$rgbFromHex = (input)=>{
    const fullHex = $63a4c8905791d888$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $63a4c8905791d888$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $63a4c8905791d888$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $63a4c8905791d888$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $63a4c8905791d888$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $63a4c8905791d888$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $63a4c8905791d888$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $63a4c8905791d888$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $63a4c8905791d888$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $63a4c8905791d888$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $63a4c8905791d888$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $63a4c8905791d888$var$rgbToLch = (rgb)=>$63a4c8905791d888$var$labToLch($63a4c8905791d888$var$xyzToLab($63a4c8905791d888$var$rgbToXyz(rgb)));
const $63a4c8905791d888$var$lchToRgb = (lch)=>$63a4c8905791d888$var$xyzToRgb($63a4c8905791d888$var$labToXyz($63a4c8905791d888$var$lchToLab(lch)));
const $63a4c8905791d888$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $63a4c8905791d888$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $63a4c8905791d888$var$rgbToLch(rgb);
    lch.l = $63a4c8905791d888$var$clamp(newPercent, 0, 100);
    return $63a4c8905791d888$var$rgbToHex($63a4c8905791d888$var$lchToRgb(lch));
};
const $63a4c8905791d888$var$getLightness = (color)=>{
    const rgb = $63a4c8905791d888$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $63a4c8905791d888$var$rgbToLch(rgb);
    return lch.l;
};
const $63a4c8905791d888$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $63a4c8905791d888$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $63a4c8905791d888$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("atVH7", function(module, exports) {

$parcel$export(module.exports, "getSchemaBasedOnStage", () => $7a195dbacaf109fe$export$fd147e7d448dea03);

var $5iWql = parcelRequire("5iWql");

var $16li0 = parcelRequire("16li0");
var $3dyx8 = parcelRequire("3dyx8");
var $6ABXt = parcelRequire("6ABXt");
var $exxiU = parcelRequire("exxiU");

var $38yFE = parcelRequire("38yFE");
const $7a195dbacaf109fe$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $7a195dbacaf109fe$export$e4e3ac1fa64862db = $7a195dbacaf109fe$var$getDefaultSchemaConfig();
const $7a195dbacaf109fe$export$fd147e7d448dea03 = (0, $5iWql.default)((stage = 'final')=>{
    const defaultSchemaConfig = $7a195dbacaf109fe$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $6ABXt.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $16li0.multiBodiedExtension),
        extensionFrame: (0, $16li0.extensionFrame),
        heading: (0, $3dyx8.headingNodeSpec)('stage0'),
        paragraph: (0, $exxiU.paragraphNodeSpec)('stage0')
    };
    return (0, $38yFE.createSchema)(defaultSchemaConfig);
});
const $7a195dbacaf109fe$export$1db618b7b2275ea1 = $7a195dbacaf109fe$export$fd147e7d448dea03();

});
parcelRegister("16li0", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", () => $0cd6dd9b1f9371dc$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $0cd6dd9b1f9371dc$export$c3c04d555a8b9013);

var $8LsCj = parcelRequire("8LsCj");
const $0cd6dd9b1f9371dc$export$4fdcae991fd743e7 = {
    type: 'extensionFrame',
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    isolating: true,
    marks: 'dataConsumer fragment',
    definingAsContext: false,
    definingForContent: true,
    selectable: false,
    attrs: {},
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
/**
 * @stage 0
 * @name multiBodiedExtension_node
 * @description Wraps multiple extensionFrame objects.
 */ /**
 * @returns NodeSpec for MultiBodiedExtensionDefinition
 */ const $0cd6dd9b1f9371dc$var$createMultiBodiedExtensionNodeSpec = ()=>{
    const nodeSpec = {
        inline: false,
        group: 'blockRootOnly',
        content: 'extensionFrame+',
        block: true,
        definingAsContext: true,
        selectable: true,
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        parseDOM: [
            {
                context: 'multiBodiedExtension//',
                tag: '[data-node-type="multi-bodied-extension"]',
                skip: true
            },
            {
                tag: '[data-node-type="multi-bodied-extension"]',
                getAttrs: (domNode)=>(0, $8LsCj.getExtensionAttrs)(domNode)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'multi-bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    };
    return nodeSpec;
};
const $0cd6dd9b1f9371dc$export$c3c04d555a8b9013 = $0cd6dd9b1f9371dc$var$createMultiBodiedExtensionNodeSpec();

});
parcelRegister("8LsCj", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", () => $6618e93a94b51422$export$1765e2758fc47004);
const $6618e93a94b51422$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $6618e93a94b51422$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $6618e93a94b51422$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("3dyx8", function(module, exports) {

$parcel$export(module.exports, "headingNodeSpec", () => $257d5f9d21d85c5c$export$5bb864b24e0f216c);
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ const $257d5f9d21d85c5c$var$getAttrs = (level)=>(domNode)=>{
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $257d5f9d21d85c5c$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
const $257d5f9d21d85c5c$export$8432c9892bf462f4 = {
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    content: `inline*`,
    group: 'block',
    defining: true,
    selectable: false,
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $257d5f9d21d85c5c$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $257d5f9d21d85c5c$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $257d5f9d21d85c5c$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $257d5f9d21d85c5c$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $257d5f9d21d85c5c$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $257d5f9d21d85c5c$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
};
const $257d5f9d21d85c5c$export$46e4a324ac90507f = {
    attrs: {
        level: {
            default: 1
        }
    },
    content: `inline*`,
    group: 'block',
    defining: true,
    selectable: false,
    parseDOM: [
        {
            tag: 'h1',
            attrs: {
                level: 1
            }
        },
        {
            tag: 'h2',
            attrs: {
                level: 2
            }
        },
        {
            tag: 'h3',
            attrs: {
                level: 3
            }
        },
        {
            tag: 'h4',
            attrs: {
                level: 4
            }
        },
        {
            tag: 'h5',
            attrs: {
                level: 5
            }
        },
        {
            tag: 'h6',
            attrs: {
                level: 6
            }
        }
    ],
    toDOM (node) {
        return [
            'h' + node.attrs['level'],
            0
        ];
    }
};
const $257d5f9d21d85c5c$export$5bb864b24e0f216c = (adfStage = 'full')=>adfStage === 'stage0' ? $257d5f9d21d85c5c$export$8432c9892bf462f4 : $257d5f9d21d85c5c$export$46e4a324ac90507f;

});

parcelRegister("6ABXt", function(module, exports) {

$parcel$export(module.exports, "layoutSection", () => $4cc38c939ebaa2ea$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $4cc38c939ebaa2ea$export$4f9d8f623ff17117);
/**
 * @name layoutSection_node
 */ /**
 * Need duplicate `type` and `marks` to make both validator and json-schema satisfied
 */ /**
 * @name layoutSection_full_node
 */ /**
 * @stage 0
 * @name layoutSection_with_single_column_node
 */ const $4cc38c939ebaa2ea$export$b3b6a70a7fa4a5be = {
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock* | unsupportedBlock+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true,
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $4cc38c939ebaa2ea$export$4f9d8f623ff17117 = {
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock* | unsupportedBlock+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true,
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};

});

parcelRegister("exxiU", function(module, exports) {

$parcel$export(module.exports, "paragraphNodeSpec", () => $a95dfb4185f42a50$export$af5ae099d62a62b4);
/**
 * @name paragraph_node
 */ /**
 * @name paragraph_with_no_marks_node
 */ /**
 * NOTE: Need this because TS is too smart and inline everything.
 * So we need to give them separate identity.
 * Probably there's a way to solve it but that will need time and exploration.
 * // http://bit.ly/2raXFX5
 * type T1 = X | Y
 * type T2 = A | T1 | B // T2 = A | X | Y | B
 */ /**
 * @name paragraph_with_alignment_node
 */ /**
 * @name paragraph_with_indentation_node
 */ const $a95dfb4185f42a50$export$700cbf85d3602974 = {
    selectable: false,
    content: 'inline*',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    marks: 'strong code em link border strike subsup textColor backgroundColor typeAheadQuery underline confluenceInlineComment action annotation unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs, _paragraph$attrs$loca;
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $a95dfb4185f42a50$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
};
const $a95dfb4185f42a50$export$9c206ddddb32a9b = {
    selectable: false,
    content: 'inline*',
    group: 'block',
    marks: 'strong code em link border strike subsup textColor backgroundColor typeAheadQuery underline confluenceInlineComment action annotation unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    parseDOM: [
        {
            tag: 'p'
        }
    ],
    toDOM () {
        return [
            'p',
            0
        ];
    }
};
const $a95dfb4185f42a50$export$af5ae099d62a62b4 = (adfStage = 'full')=>adfStage === 'stage0' ? $a95dfb4185f42a50$export$700cbf85d3602974 : $a95dfb4185f42a50$export$9c206ddddb32a9b;

});

parcelRegister("38yFE", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $248d035bc4f3f76a$export$5f4ce795563f4211);

var $7dkLM = parcelRequire("7dkLM");


var $kOpOZ = parcelRequire("kOpOZ");
var $73EEr = parcelRequire("73EEr");
var $5lOu9 = parcelRequire("5lOu9");
var $9NYLP = parcelRequire("9NYLP");
var $drQqV = parcelRequire("drQqV");
var $2AISj = parcelRequire("2AISj");
var $1ZYYq = parcelRequire("1ZYYq");
var $eTCNF = parcelRequire("eTCNF");
var $jyT4N = parcelRequire("jyT4N");
var $1BBUE = parcelRequire("1BBUE");
var $gw2wS = parcelRequire("gw2wS");
var $ig4y4 = parcelRequire("ig4y4");
var $8JvWu = parcelRequire("8JvWu");
var $45bpj = parcelRequire("45bpj");
var $1TrdQ = parcelRequire("1TrdQ");
var $51IWj = parcelRequire("51IWj");
var $bU3Qj = parcelRequire("bU3Qj");
var $j5Job = parcelRequire("j5Job");
var $2ykUY = parcelRequire("2ykUY");
var $6ED3f = parcelRequire("6ED3f");

var $3LTPb = parcelRequire("3LTPb");
var $9HAGr = parcelRequire("9HAGr");
var $gLwMm = parcelRequire("gLwMm");
var $bRBMF = parcelRequire("bRBMF");
var $5SGsh = parcelRequire("5SGsh");
var $88rqd = parcelRequire("88rqd");
var $6AwX6 = parcelRequire("6AwX6");
var $fqxlM = parcelRequire("fqxlM");
var $dUENm = parcelRequire("dUENm");
var $epM2q = parcelRequire("epM2q");
var $9c1dD = parcelRequire("9c1dD");
var $dhc0B = parcelRequire("dhc0B");
var $httlJ = parcelRequire("httlJ");
var $hei24 = parcelRequire("hei24");
var $eEBLC = parcelRequire("eEBLC");
var $hH51j = parcelRequire("hH51j");
var $bPQdh = parcelRequire("bPQdh");
var $lviBN = parcelRequire("lviBN");
var $16li0 = parcelRequire("16li0");
var $9HBjh = parcelRequire("9HBjh");
var $3dyx8 = parcelRequire("3dyx8");
var $jEayN = parcelRequire("jEayN");
var $46ig3 = parcelRequire("46ig3");
var $dtnTv = parcelRequire("dtnTv");
var $lLn9w = parcelRequire("lLn9w");
var $6ABXt = parcelRequire("6ABXt");
var $fXbg9 = parcelRequire("fXbg9");
var $2sd4y = parcelRequire("2sd4y");
var $8xDb2 = parcelRequire("8xDb2");
var $9WeGj = parcelRequire("9WeGj");
var $aFq96 = parcelRequire("aFq96");
var $T1nAs = parcelRequire("T1nAs");
var $4xfHj = parcelRequire("4xfHj");
var $aSn8N = parcelRequire("aSn8N");
var $exxiU = parcelRequire("exxiU");
var $id5bq = parcelRequire("id5bq");
var $chThp = parcelRequire("chThp");
var $eAIr2 = parcelRequire("eAIr2");
var $fKLaE = parcelRequire("fKLaE");
var $7uPOw = parcelRequire("7uPOw");
var $1S2JO = parcelRequire("1S2JO");
var $0MPTW = parcelRequire("0MPTW");
var $iClK1 = parcelRequire("iClK1");
var $cfiTE = parcelRequire("cfiTE");
var $krp4v = parcelRequire("krp4v");
function $248d035bc4f3f76a$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $248d035bc4f3f76a$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $248d035bc4f3f76a$var$markGroupDeclarations = [
    $248d035bc4f3f76a$var$groupDeclaration((0, $c35df775798bc280$export$9b982809044276a6)),
    $248d035bc4f3f76a$var$groupDeclaration((0, $c35df775798bc280$export$4498a6080fed604c)),
    $248d035bc4f3f76a$var$groupDeclaration((0, $c35df775798bc280$export$f8e8a5f34f6ea725)),
    $248d035bc4f3f76a$var$groupDeclaration((0, $c35df775798bc280$export$b395009ca7f092c7))
];
const $248d035bc4f3f76a$var$markGroupDeclarationsNames = $248d035bc4f3f76a$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $248d035bc4f3f76a$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $httlJ.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $exxiU.paragraphNodeSpec)()
    },
    {
        name: 'text',
        spec: (0, $0MPTW.text)
    },
    {
        name: 'bulletList',
        spec: (0, $bRBMF.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $aSn8N.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $fXbg9.listItemWithTask)
    },
    {
        name: 'heading',
        spec: (0, $3dyx8.headingNodeSpec)()
    },
    {
        name: 'blockquote',
        spec: (0, $9HAGr.blockquoteWithList)
    },
    {
        name: 'codeBlock',
        spec: (0, $88rqd.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $bPQdh.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $chThp.rule)
    },
    {
        name: 'image',
        spec: (0, $jEayN.image)
    },
    {
        name: 'mention',
        spec: (0, $T1nAs.mention)
    },
    {
        name: 'caption',
        spec: (0, $5SGsh.caption)
    },
    {
        name: 'media',
        spec: (0, $2sd4y.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $8xDb2.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $aFq96.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $9WeGj.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $id5bq.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $6ABXt.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $lLn9w.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $9HBjh.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $eEBLC.emoji)
    },
    {
        name: 'table',
        spec: (0, $fKLaE.table)
    },
    {
        name: 'tableCell',
        spec: (0, $fKLaE.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $fKLaE.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $fKLaE.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $6AwX6.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $dUENm.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $fqxlM.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $dhc0B.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $9c1dD.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $1S2JO.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $7uPOw.taskItem)
    },
    {
        name: 'date',
        spec: (0, $epM2q.date)
    },
    {
        name: 'status',
        spec: (0, $eAIr2.status)
    },
    {
        name: 'expand',
        spec: (0, $hH51j.expand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $4xfHj.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $lviBN.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $dtnTv.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $gLwMm.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $16li0.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $16li0.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $46ig3.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $3LTPb.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $hei24.embedCard)
    },
    {
        name: 'unknownBlock',
        spec: (0, $iClK1.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $cfiTE.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $krp4v.unsupportedInline)
    }
];
const $248d035bc4f3f76a$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $ig4y4.link)
    },
    {
        name: 'em',
        spec: (0, $jyT4N.em)
    },
    {
        name: 'strong',
        spec: (0, $45bpj.strong)
    },
    {
        name: 'textColor',
        spec: (0, $51IWj.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $5lOu9.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $8JvWu.strike)
    },
    {
        name: 'subsup',
        spec: (0, $1TrdQ.subsup)
    },
    {
        name: 'underline',
        spec: (0, $j5Job.underline)
    },
    {
        name: 'code',
        spec: (0, $2AISj.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $bU3Qj.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $kOpOZ.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $73EEr.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $1ZYYq.confluenceInlineComment)
    },
    ...$248d035bc4f3f76a$var$markGroupDeclarations,
    {
        name: 'breakout',
        spec: (0, $drQqV.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $eTCNF.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $1BBUE.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $gw2wS.indentation)
    },
    {
        name: 'border',
        spec: (0, $9NYLP.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $2ykUY.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $6ED3f.unsupportedNodeAttribute)
    }
];
function $248d035bc4f3f76a$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($248d035bc4f3f76a$var$markGroupDeclarationsNames);
    let nodes = $248d035bc4f3f76a$var$addItems($248d035bc4f3f76a$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $248d035bc4f3f76a$var$addItems($248d035bc4f3f76a$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = $248d035bc4f3f76a$export$daf54fed04c8fb77(nodes, marks);
    return new (0, $7dkLM.Schema)({
        nodes: nodes,
        marks: marks
    });
}
function $248d035bc4f3f76a$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $248d035bc4f3f76a$export$9cb535b0ed27c9c(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $248d035bc4f3f76a$export$9cb535b0ed27c9c(nodes, rawContent) {
    const content = rawContent.replace(/\W/g, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$248d035bc4f3f76a$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$248d035bc4f3f76a$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $248d035bc4f3f76a$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent})|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $248d035bc4f3f76a$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes){
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}
const $248d035bc4f3f76a$export$c77b6d30da5276a1 = true;

});
parcelRegister("kOpOZ", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $f26c81bd197b528f$export$8e53000a4ec837);

const $f26c81bd197b528f$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $f26c81bd197b528f$export$8e53000a4ec837 = {
    excludes: `alignment ${(0, $c35df775798bc280$export$bacb7f4b06a06b22)}`,
    group: (0, $c35df775798bc280$export$470d0905851e47a1),
    attrs: {
        align: {}
    },
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
};

});

parcelRegister("73EEr", function(module, exports) {

$parcel$export(module.exports, "annotation", () => $523858b79ef7b156$export$8512c9afa7b24c3b);
/**
 * @name annotation_mark
 */ let $523858b79ef7b156$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
let $523858b79ef7b156$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $523858b79ef7b156$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $523858b79ef7b156$export$8512c9afa7b24c3b = {
    inclusive: true,
    group: 'annotation',
    excludes: '',
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: $523858b79ef7b156$export$94aa2fc69ad33d19.INLINE_COMMENT
        }
    },
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$523858b79ef7b156$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
};

});

parcelRegister("5lOu9", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", () => $3e56134082a4b4b5$export$8c5a050822fd698c);

var $kpmwi = parcelRequire("kpmwi");


var $XLrdp = parcelRequire("XLrdp");

var $51IWj = parcelRequire("51IWj");

var $8yoRr = parcelRequire("8yoRr");
/**
 * @name backgroundColor_mark
 */ const $3e56134082a4b4b5$var$colorArrayPalette = [
    [
        (0, $XLrdp.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $XLrdp.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $XLrdp.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $XLrdp.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $XLrdp.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $XLrdp.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $3e56134082a4b4b5$export$14ec3f21a268e497 = new Map();
$3e56134082a4b4b5$var$colorArrayPalette.forEach(([color, label])=>$3e56134082a4b4b5$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $3e56134082a4b4b5$export$8c5a050822fd698c = {
    attrs: {
        color: {}
    },
    inclusive: true,
    group: (0, $c35df775798bc280$export$9b982809044276a6),
    excludes: `${(0, $c35df775798bc280$export$9b982809044276a6)}`,
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $XLrdp.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $3e56134082a4b4b5$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $3e56134082a4b4b5$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $kpmwi.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $51IWj.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $8yoRr.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
};

});
parcelRegister("51IWj", function(module, exports) {

$parcel$export(module.exports, "getGlobalTheme", () => $3a8fe7cfaab09c69$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $3a8fe7cfaab09c69$export$32f78bffcd82ff28);

var $kpmwi = parcelRequire("kpmwi");


var $XLrdp = parcelRequire("XLrdp");

var $8yoRr = parcelRequire("8yoRr");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
const $3a8fe7cfaab09c69$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $XLrdp.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $XLrdp.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $XLrdp.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $XLrdp.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $XLrdp.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $XLrdp.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $XLrdp.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $XLrdp.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $XLrdp.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $XLrdp.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $XLrdp.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $XLrdp.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $XLrdp.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $XLrdp.N0),
        'White'
    ],
    [
        (0, $XLrdp.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $XLrdp.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $XLrdp.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $XLrdp.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $XLrdp.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $XLrdp.P50),
        'Light purple'
    ] // Lavender secret
];
const $3a8fe7cfaab09c69$export$569885e57444f84a = new Map();
const $3a8fe7cfaab09c69$export$81e5ed9e84fe2e28 = $3a8fe7cfaab09c69$export$569885e57444f84a;
$3a8fe7cfaab09c69$var$colorArrayPalette.forEach(([color, label])=>$3a8fe7cfaab09c69$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $3a8fe7cfaab09c69$var$testGlobalTheme;
const $3a8fe7cfaab09c69$export$fd7e0dd2b74807f7 = (theme)=>{
    $3a8fe7cfaab09c69$var$testGlobalTheme = theme;
};
const $3a8fe7cfaab09c69$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($3a8fe7cfaab09c69$var$testGlobalTheme) return {
        colorMode: $3a8fe7cfaab09c69$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $3a8fe7cfaab09c69$export$32f78bffcd82ff28 = {
    attrs: {
        color: {}
    },
    inclusive: true,
    group: (0, $c35df775798bc280$export$9b982809044276a6),
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $XLrdp.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $3a8fe7cfaab09c69$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $3a8fe7cfaab09c69$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $kpmwi.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($3a8fe7cfaab09c69$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $8yoRr.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
};

});


parcelRegister("9NYLP", function(module, exports) {

$parcel$export(module.exports, "border", () => $7237d4600678e21f$export$1edee58a52776cd9);

var $kpmwi = parcelRequire("kpmwi");

var $XLrdp = parcelRequire("XLrdp");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ const $7237d4600678e21f$var$borderColorArrayPalette = [
    [
        (0, $XLrdp.N300A),
        'Subtle gray'
    ],
    [
        (0, $XLrdp.N600),
        'Gray'
    ],
    [
        (0, $XLrdp.N1000),
        'Bold gray'
    ]
];
const $7237d4600678e21f$export$e4e044c989c86ca7 = new Map();
$7237d4600678e21f$var$borderColorArrayPalette.forEach(([color, label])=>$7237d4600678e21f$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $7237d4600678e21f$export$1edee58a52776cd9 = {
    inclusive: false,
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                var _dom$getAttribute, _dom$getAttribute2;
                const dom = domNode;
                const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $7237d4600678e21f$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    attrs: {
        color: {},
        size: {}
    },
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $kpmwi.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
};

});

parcelRegister("drQqV", function(module, exports) {

$parcel$export(module.exports, "breakout", () => $9ca6782534797a3d$export$89015c65f1c75e3f);
const $9ca6782534797a3d$var$allowedTypes = [
    'wide',
    'full-width'
];
const $9ca6782534797a3d$export$89015c65f1c75e3f = {
    spanning: false,
    inclusive: false,
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                const mode = dom.getAttribute('data-mode');
                return {
                    mode: $9ca6782534797a3d$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode
                };
            }
        }
    ],
    attrs: {
        mode: {
            default: 'wide'
        }
    },
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode
            },
            0
        ];
    }
};

});

parcelRegister("2AISj", function(module, exports) {

$parcel$export(module.exports, "code", () => $1e31c0c87be982aa$export$6565f9f03506010b);

const $1e31c0c87be982aa$export$6565f9f03506010b = {
    excludes: `${(0, $c35df775798bc280$export$4498a6080fed604c)} ${(0, $c35df775798bc280$export$b395009ca7f092c7)} ${(0, $c35df775798bc280$export$f8e8a5f34f6ea725)} ${(0, $c35df775798bc280$export$9b982809044276a6)}`,
    inclusive: true,
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
};

});

parcelRegister("1ZYYq", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", () => $174ac90b96434eff$export$f3b72f8fc4684ecd);
/**
 * @name inline_comment_marker
 * @description This temporary mark represents a Confluence-backed inline comment that wraps a piece of text. It will be replaced with a cross-product inline comment solution at later date.
 */ const $174ac90b96434eff$export$f3b72f8fc4684ecd = {
    inclusive: false,
    excludes: '',
    attrs: {
        reference: {
            default: ''
        }
    },
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
};

});

parcelRegister("jyT4N", function(module, exports) {

$parcel$export(module.exports, "em", () => $e3dbea56734fa61c$export$c63c6f932822f543);

/**
 * @name em_mark
 */ const $e3dbea56734fa61c$var$emDOM = [
    'em'
];
const $e3dbea56734fa61c$export$c63c6f932822f543 = {
    inclusive: true,
    group: (0, $c35df775798bc280$export$4498a6080fed604c),
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $e3dbea56734fa61c$var$emDOM;
    }
};

});

parcelRegister("gw2wS", function(module, exports) {

$parcel$export(module.exports, "indentation", () => $c06198c343a13ba4$export$480c699bd4ec0d86);

const $c06198c343a13ba4$export$480c699bd4ec0d86 = {
    excludes: `indentation ${(0, $c35df775798bc280$export$470d0905851e47a1)}`,
    group: (0, $c35df775798bc280$export$bacb7f4b06a06b22),
    attrs: {
        level: {}
    },
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
};

});

parcelRegister("8JvWu", function(module, exports) {

$parcel$export(module.exports, "strike", () => $65bb4dcc505c7dcd$export$4899a95d70ec5056);

const $65bb4dcc505c7dcd$export$4899a95d70ec5056 = {
    inclusive: true,
    group: (0, $c35df775798bc280$export$4498a6080fed604c),
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
};

});

parcelRegister("45bpj", function(module, exports) {

$parcel$export(module.exports, "strong", () => $2f907a502fbe3bc3$export$59ae2c325a998f89);

/**
 * @name strong_mark
 */ const $2f907a502fbe3bc3$var$strongDOM = [
    'strong'
];
const $2f907a502fbe3bc3$export$59ae2c325a998f89 = {
    inclusive: true,
    group: (0, $c35df775798bc280$export$4498a6080fed604c),
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $2f907a502fbe3bc3$var$strongDOM;
    }
};

});

parcelRegister("1TrdQ", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $16100b4d4acb2012$export$b3401ee80eb31041);

/**
 * @name subsup_mark
 */ function $16100b4d4acb2012$var$getAttrFromVerticalAlign(node) {
    if (node.style.verticalAlign) {
        const type = node.style.verticalAlign.slice(0, 3);
        if (type === 'sub' || type === 'sup') return {
            type: type
        };
    }
    return false;
}
const $16100b4d4acb2012$export$b3401ee80eb31041 = {
    inclusive: true,
    group: (0, $c35df775798bc280$export$4498a6080fed604c),
    attrs: {
        type: {
            default: 'sub'
        }
    },
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            tag: 'span',
            style: 'vertical-align=super',
            getAttrs: (node)=>$16100b4d4acb2012$var$getAttrFromVerticalAlign(node)
        },
        {
            tag: 'span',
            style: 'vertical-align=sub',
            getAttrs: (node)=>$16100b4d4acb2012$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
};

});

parcelRegister("bU3Qj", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", () => $8aa7e7c5d83bb64f$export$20af3dabbb5538df);


var $XLrdp = parcelRequire("XLrdp");
const $8aa7e7c5d83bb64f$export$20af3dabbb5538df = {
    inclusive: true,
    group: (0, $c35df775798bc280$export$f8e8a5f34f6ea725),
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $XLrdp.B400)}`
            }
        ];
    },
    attrs: {
        trigger: {
            default: ''
        }
    }
};

});

parcelRegister("j5Job", function(module, exports) {

$parcel$export(module.exports, "underline", () => $de61b14060854254$export$425327af25286e5e);

const $de61b14060854254$export$425327af25286e5e = {
    inclusive: true,
    group: (0, $c35df775798bc280$export$4498a6080fed604c),
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
};

});

parcelRegister("2ykUY", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", () => $1dbefba05d72ccd6$export$30d78d5eb6719bb8);
const $1dbefba05d72ccd6$export$30d78d5eb6719bb8 = {
    toDOM () {
        return [
            'span'
        ];
    },
    excludes: '',
    attrs: {
        originalValue: {}
    }
};

});

parcelRegister("6ED3f", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", () => $4d84c551f6e6b8ee$export$a316dc07ff5182a2);
const $4d84c551f6e6b8ee$export$a316dc07ff5182a2 = {
    toDOM () {
        return [
            'span'
        ];
    },
    attrs: {
        type: {},
        unsupported: {}
    }
};

});

parcelRegister("3LTPb", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $2bf110777e450705$export$c4c2f833baaebdb8);
/**
 * @name blockCard_node
 */ const $2bf110777e450705$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $2bf110777e450705$export$c4c2f833baaebdb8 = {
    inline: false,
    group: 'block',
    draggable: true,
    selectable: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$2bf110777e450705$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$2bf110777e450705$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
};

});

parcelRegister("9HAGr", function(module, exports) {

$parcel$export(module.exports, "blockquoteWithList", () => $710495cb9d778d6c$export$9b4686c4b9672643);
/**
 * @name blockquote_node
 */ const $710495cb9d778d6c$var$createBlockquoteSpec = (allowList)=>{
    const blockquoteSpec = {
        group: 'block',
        defining: true,
        selectable: false,
        parseDOM: [
            {
                tag: 'blockquote'
            }
        ],
        toDOM () {
            return [
                'blockquote',
                0
            ];
        }
    };
    if (allowList) blockquoteSpec.content = '(paragraph | orderedList | bulletList | unsupportedBlock)+';
    else blockquoteSpec.content = '(paragraph | unsupportedBlock)+';
    return blockquoteSpec;
};
const $710495cb9d778d6c$export$67dc04e652a298ca = $710495cb9d778d6c$var$createBlockquoteSpec(false);
const $710495cb9d778d6c$export$9b4686c4b9672643 = $710495cb9d778d6c$var$createBlockquoteSpec(true);

});

parcelRegister("gLwMm", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", () => $c34a7661933c45f7$export$27903d543b563e39);

var $8LsCj = parcelRequire("8LsCj");
/**
 * @name bodiedExtension_node
 */ /**
 * @name bodiedExtension_with_marks_node
 */ const $c34a7661933c45f7$var$createBodiedExtensionNodeSpec = ()=>{
    const nodeSpec = {
        inline: false,
        group: 'block',
        marks: 'dataConsumer fragment',
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | extension | unsupportedBlock | embedCard)+',
        defining: true,
        selectable: true,
        isolating: true,
        attrs: {
            extensionType: {
                default: ''
            },
            extensionKey: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        parseDOM: [
            {
                context: 'bodiedExtension//',
                tag: '[data-node-type="bodied-extension"]',
                skip: true
            },
            {
                tag: '[data-node-type="bodied-extension"]',
                getAttrs: (domNode)=>(0, $8LsCj.getExtensionAttrs)(domNode)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    };
    return nodeSpec;
};
const $c34a7661933c45f7$export$27903d543b563e39 = $c34a7661933c45f7$var$createBodiedExtensionNodeSpec();

});

parcelRegister("bRBMF", function(module, exports) {

$parcel$export(module.exports, "bulletList", () => $8a31f40bdf71591f$export$a140c94e5ea26bee);
const $8a31f40bdf71591f$export$5f25a39efab3b58b = '.ak-ul';
const $8a31f40bdf71591f$export$a140c94e5ea26bee = {
    group: 'block',
    content: 'listItem+',
    selectable: false,
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    marks: 'unsupportedMark unsupportedNodeAttribute',
    toDOM () {
        const attrs = {
            class: $8a31f40bdf71591f$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
};

});

parcelRegister("5SGsh", function(module, exports) {

$parcel$export(module.exports, "caption", () => $4482ed9fb0f0f022$export$8e3c2dfdc4f0453d);
/**
 * @name caption_node
 */ const $4482ed9fb0f0f022$export$8e3c2dfdc4f0453d = {
    content: '(text|hardBreak|mention|emoji|date|placeholder|inlineCard|status|unsupportedInline)*',
    isolating: true,
    marks: '_',
    selectable: false,
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
};

});

parcelRegister("6AwX6", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", () => $4cbfaa7baef65efe$export$daf889beb5092f95);
const $4cbfaa7baef65efe$var$name = 'confluenceJiraIssue';
const $4cbfaa7baef65efe$export$daf889beb5092f95 = {
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: `span[data-node-type="${$4cbfaa7baef65efe$var$name}"]`,
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $4cbfaa7baef65efe$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
};

});

parcelRegister("fqxlM", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $b3b3276810d46ce3$export$e6e4878f43c27cab);
const $b3b3276810d46ce3$var$name = 'confluenceUnsupportedBlock';
const $b3b3276810d46ce3$export$e6e4878f43c27cab = {
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    },
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $b3b3276810d46ce3$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$b3b3276810d46ce3$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
};

});

parcelRegister("dUENm", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", () => $a210266904fc5da5$export$3e6d667072febc87);
const $a210266904fc5da5$var$name = 'confluenceUnsupportedInline';
const $a210266904fc5da5$export$3e6d667072febc87 = {
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    },
    toDOM (node) {
        const attrs = {
            'data-node-type': $a210266904fc5da5$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$a210266904fc5da5$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
};

});

parcelRegister("epM2q", function(module, exports) {

$parcel$export(module.exports, "date", () => $a7e8a9e0ff064f73$export$324d90190a8b822a);
/**
 * @name date_node
 */ const $a7e8a9e0ff064f73$export$324d90190a8b822a = {
    inline: true,
    group: 'inline',
    selectable: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
};

});

parcelRegister("9c1dD", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $6b162e1a8c673862$export$6959e16eeff859b4);

var $5WDZf = parcelRequire("5WDZf");
const $6b162e1a8c673862$export$6959e16eeff859b4 = {
    content: 'inline*',
    defining: true,
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $5WDZf.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
};

});

parcelRegister("dhc0B", function(module, exports) {

$parcel$export(module.exports, "decisionList", () => $9aa62d8eef07e7aa$export$62d45a65fb43d95e);

var $5WDZf = parcelRequire("5WDZf");
/**
 * @name decisionList_node
 */ const $9aa62d8eef07e7aa$var$name = 'decisionList';
const $9aa62d8eef07e7aa$export$a5393ce68c2ff601 = `[data-node-type="${$9aa62d8eef07e7aa$var$name}"]`;
const $9aa62d8eef07e7aa$export$62d45a65fb43d95e = {
    group: 'block',
    defining: true,
    content: '(decisionItem|unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    attrs: {
        localId: {
            default: ''
        }
    },
    parseDOM: [
        {
            tag: `ol${$9aa62d8eef07e7aa$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $5WDZf.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $9aa62d8eef07e7aa$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
};

});

parcelRegister("httlJ", function(module, exports) {

$parcel$export(module.exports, "doc", () => $cb8be94835c34c33$export$2a111da947c407d2);
/**
 * @name doc_node
 */ const $cb8be94835c34c33$export$2a111da947c407d2 = {
    content: '(block|layoutSection|blockRootOnly)+',
    marks: 'alignment breakout dataConsumer fragment indentation unsupportedMark unsupportedNodeAttribute'
};

});

parcelRegister("hei24", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $c8b1bb559bdd0a8b$export$be4283d9a1cb1ff6);
/**
 * @name embedCard_node
 */ const $c8b1bb559bdd0a8b$export$be4283d9a1cb1ff6 = {
    inline: false,
    group: 'block',
    selectable: true,
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalWidth: {
            default: null
        },
        originalHeight: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
};

});

parcelRegister("eEBLC", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $aab218df1205dde5$export$a19185d1233fc4b2);

var $2Au6R = parcelRequire("2Au6R");
const $aab218df1205dde5$export$a19185d1233fc4b2 = {
    inline: true,
    group: 'inline',
    selectable: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $aab218df1205dde5$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $aab218df1205dde5$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $aab218df1205dde5$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>(0, $2Au6R.acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>(0, $2Au6R.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $aab218df1205dde5$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $aab218df1205dde5$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $aab218df1205dde5$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
};

});
parcelRegister("2Au6R", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", () => $1e264cbd52988252$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $1e264cbd52988252$export$441f8b58f5790a68);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $1e264cbd52988252$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $1e264cbd52988252$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $1e264cbd52988252$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $1e264cbd52988252$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $1e264cbd52988252$export$f61e93bda2a8b420(acName) {
    const emojiData = $1e264cbd52988252$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $1e264cbd52988252$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $1e264cbd52988252$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$1e264cbd52988252$var$acNameToEmojiMap[acName] ? $1e264cbd52988252$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($1e264cbd52988252$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $1e264cbd52988252$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$1e264cbd52988252$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $1e264cbd52988252$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $1e264cbd52988252$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($1e264cbd52988252$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $1e264cbd52988252$var$getAcNameFromShortName(shortName);
        if (possibleName in $1e264cbd52988252$var$acNameToEmojiMap) return possibleName;
    }
    return $1e264cbd52988252$export$bc94e44ec0e7bd82(id) || $1e264cbd52988252$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("bPQdh", function(module, exports) {

$parcel$export(module.exports, "extendedPanel", () => $89dcf595124d73b6$export$ce20b13564211141);
let $89dcf595124d73b6$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ const $89dcf595124d73b6$var$getDefaultAttrs = ()=>{
    const attrs = {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    };
    return attrs;
};
const $89dcf595124d73b6$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor
    };
    return attrs;
};
const $89dcf595124d73b6$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
    let parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $89dcf595124d73b6$export$969277cf61e5a7aa.CUSTOM ? $89dcf595124d73b6$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $89dcf595124d73b6$export$21f42ab9b6679f44 = (allowCustomPanel)=>{
    const panelNodeSpec = {
        group: 'block',
        content: '(paragraph | heading | bulletList | orderedList | blockCard | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        attrs: $89dcf595124d73b6$var$getDefaultAttrs(),
        selectable: true,
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$89dcf595124d73b6$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $89dcf595124d73b6$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    };
    return panelNodeSpec;
};
const $89dcf595124d73b6$export$ce20b13564211141 = (allowCustomPanel)=>{
    const panelNodeSpec = {
        group: 'block',
        content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        attrs: $89dcf595124d73b6$var$getDefaultAttrs(),
        selectable: true,
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$89dcf595124d73b6$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $89dcf595124d73b6$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    };
    return panelNodeSpec;
};

});

parcelRegister("lviBN", function(module, exports) {

$parcel$export(module.exports, "extension", () => $fa7aed879e662d50$export$1b45514b112dd749);

var $8LsCj = parcelRequire("8LsCj");
/**
 * @name extension_node
 */ /**
 * @name extension_with_marks_node
 */ const $fa7aed879e662d50$var$createExtensionNodeSpec = ()=>{
    const nodeSpec = {
        inline: false,
        group: 'block',
        atom: true,
        selectable: true,
        attrs: {
            extensionType: {
                default: ''
            },
            extensionKey: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        parseDOM: [
            {
                tag: '[data-node-type="extension"]',
                getAttrs: (domNode)=>(0, $8LsCj.getExtensionAttrs)(domNode)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId
            };
            return [
                'div',
                attrs
            ];
        }
    };
    return nodeSpec;
};
const $fa7aed879e662d50$export$1b45514b112dd749 = $fa7aed879e662d50$var$createExtensionNodeSpec();

});

parcelRegister("9HBjh", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $7105123579f67eca$export$371da9dd35aba193);
/**
 * @name hardBreak_node
 */ const $7105123579f67eca$export$371da9dd35aba193 = {
    inline: true,
    group: 'inline',
    selectable: false,
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
};

});

parcelRegister("jEayN", function(module, exports) {

$parcel$export(module.exports, "image", () => $e4d9f1c7e6843452$export$5c452ff88e35e47d);
const $e4d9f1c7e6843452$export$5c452ff88e35e47d = {
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true,
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
};

});

parcelRegister("46ig3", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $2fc5e2a0c5c39e3d$export$cbf8224b64e0d942);
/**
 * @name inlineCard_node
 */ const $2fc5e2a0c5c39e3d$export$cbf8224b64e0d942 = {
    inline: true,
    group: 'inline',
    selectable: true,
    draggable: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
};

});

parcelRegister("dtnTv", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", () => $9cf084b736172e4a$export$16b353b2649bd8d9);

var $8LsCj = parcelRequire("8LsCj");
/**
 * @name inlineExtension_node
 */ /**
 * @name inlineExtension_with_marks_node
 */ const $9cf084b736172e4a$var$createInlineExtensionNodeSpec = ()=>{
    const nodeSpec = {
        inline: true,
        group: 'inline',
        selectable: true,
        attrs: {
            extensionType: {
                default: ''
            },
            extensionKey: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            localId: {
                default: null
            }
        },
        parseDOM: [
            {
                tag: 'span[data-extension-type]',
                getAttrs: (domNode)=>(0, $8LsCj.getExtensionAttrs)(domNode, true)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-local-id:': node.attrs.localId,
                contenteditable: 'false'
            };
            return [
                'span',
                attrs
            ];
        }
    };
    return nodeSpec;
};
const $9cf084b736172e4a$export$16b353b2649bd8d9 = $9cf084b736172e4a$var$createInlineExtensionNodeSpec();

});

parcelRegister("lLn9w", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", () => $fd7ff264d8b1f599$export$ab76e7c03cd6f650);
/**
 * @name layoutColumn_node
 */ const $fd7ff264d8b1f599$export$ab76e7c03cd6f650 = {
    content: '(block|unsupportedBlock)+',
    isolating: true,
    marks: 'alignment indentation dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    attrs: {
        width: {
            default: undefined
        }
    },
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = width;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
};

});

parcelRegister("fXbg9", function(module, exports) {

$parcel$export(module.exports, "listItemWithTask", () => $b9d5199b34b4a55a$export$58dca2f0678302a4);
const $b9d5199b34b4a55a$export$76c7e83ecc9cdf05 = {
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    defining: true,
    selectable: false,
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
};
const $b9d5199b34b4a55a$export$58dca2f0678302a4 = {
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    defining: true,
    selectable: false,
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
};

});

parcelRegister("8xDb2", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $637fcb87a09339c0$export$2855e964765eac9);
/**
 * @name mediaGroup_node
 */ // Temporary due to an existing issue in validator below:
// https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-1429
// TODO: Remove border and link marks from white list
const $637fcb87a09339c0$export$2855e964765eac9 = {
    inline: false,
    group: 'block',
    content: '(media|unsupportedBlock)+',
    attrs: {},
    marks: 'unsupportedMark unsupportedNodeAttribute annotation border link',
    selectable: false,
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
};

});

parcelRegister("9WeGj", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $73c4eb40852b81b7$export$38bab695e3f720f1);

var $2sd4y = parcelRequire("2sd4y");
const $73c4eb40852b81b7$export$38bab695e3f720f1 = (0, $2sd4y.createMediaSpec)((0, $2sd4y.defaultAttrs), true);

});

parcelRegister("4xfHj", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", () => $34d66bb100e952f6$export$63cadbf5f4296627);
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ const $34d66bb100e952f6$var$createNestedExpandSpec = ()=>{
    const nestedExpandSpec = {
        inline: false,
        marks: 'unsupportedMark unsupportedNodeAttribute',
        isolating: true,
        selectable: true,
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        parseDOM: [
            {
                context: 'nestedExpand//',
                tag: '[data-node-type="nestedExpand"]',
                skip: true
            },
            {
                tag: '[data-node-type="nestedExpand"] button',
                ignore: true
            },
            {
                tag: '[data-node-type="expand"] button',
                ignore: true
            },
            {
                tag: 'div[data-node-type="nestedExpand"]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        title: dom.getAttribute('data-title'),
                        __expanded: true
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'nestedExpand',
                'data-title': node.attrs.title,
                'data-expanded': node.attrs.__expanded
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    };
    nestedExpandSpec.content = '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+';
    return nestedExpandSpec;
};
const $34d66bb100e952f6$export$63cadbf5f4296627 = $34d66bb100e952f6$var$createNestedExpandSpec();

});

parcelRegister("aSn8N", function(module, exports) {

$parcel$export(module.exports, "orderedListWithOrder", () => $7eb0e5cf0f92bd2e$export$b9ab759e8298198f);
const $7eb0e5cf0f92bd2e$export$4e7125c7ff595be5 = '.ak-ol';
const $7eb0e5cf0f92bd2e$export$a5dc81035676e7a = {
    group: 'block',
    attrs: {
        order: {
            default: 1
        }
    },
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $7eb0e5cf0f92bd2e$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
};
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
const $7eb0e5cf0f92bd2e$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $7eb0e5cf0f92bd2e$export$b9ab759e8298198f = {
    ...$7eb0e5cf0f92bd2e$export$a5dc81035676e7a,
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $7eb0e5cf0f92bd2e$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const start = $7eb0e5cf0f92bd2e$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $7eb0e5cf0f92bd2e$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
};

});

parcelRegister("id5bq", function(module, exports) {

$parcel$export(module.exports, "placeholder", () => $d41d762eee388045$export$c7187bbd1a7a9244);
/**
 * @name placeholder_node
 */ const $d41d762eee388045$export$c7187bbd1a7a9244 = {
    inline: true,
    group: 'inline',
    selectable: false,
    marks: '',
    attrs: {
        text: {
            default: ''
        }
    },
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $d41d762eee388045$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
};

});

parcelRegister("chThp", function(module, exports) {

$parcel$export(module.exports, "rule", () => $8f21f40119e3f645$export$fbeb3a3956e8a3c7);
/**
 * @name rule_node
 */ const $8f21f40119e3f645$var$hrDOM = [
    'hr'
];
const $8f21f40119e3f645$export$fbeb3a3956e8a3c7 = {
    group: 'block',
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $8f21f40119e3f645$var$hrDOM;
    }
};

});

parcelRegister("eAIr2", function(module, exports) {

$parcel$export(module.exports, "status", () => $a9f6e559c7e471ee$export$471f7ae5c4103ae1);

var $5WDZf = parcelRequire("5WDZf");
const $a9f6e559c7e471ee$export$471f7ae5c4103ae1 = {
    inline: true,
    group: 'inline',
    selectable: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: (0, $5WDZf.uuid).generate()
        },
        style: {
            default: ''
        }
    },
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $5WDZf.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
};

});

parcelRegister("7uPOw", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $575386e6dcb19392$export$6d8b0ef52e2e6390);

var $5WDZf = parcelRequire("5WDZf");
const $575386e6dcb19392$export$6d8b0ef52e2e6390 = {
    content: 'inline*',
    defining: true,
    selectable: false,
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $5WDZf.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};

});

parcelRegister("1S2JO", function(module, exports) {

$parcel$export(module.exports, "taskList", () => $15ccf54e3c76b79b$export$375b6afcc5f4d291);

var $5WDZf = parcelRequire("5WDZf");
/**
 * @name taskList_node
 */ const $15ccf54e3c76b79b$var$name = 'actionList';
const $15ccf54e3c76b79b$export$c0ec71adb7a18fb2 = `[data-node-type="${$15ccf54e3c76b79b$var$name}"]`;
const $15ccf54e3c76b79b$export$375b6afcc5f4d291 = {
    group: 'block',
    defining: true,
    selectable: false,
    content: '(taskItem|unsupportedBlock)+ (taskItem|taskList|unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: ''
        }
    },
    parseDOM: [
        {
            tag: `div${$15ccf54e3c76b79b$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $5WDZf.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $15ccf54e3c76b79b$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};

});

parcelRegister("0MPTW", function(module, exports) {

$parcel$export(module.exports, "text", () => $0025e209a0aa83b5$export$6f093cfa640b7166);
/**
 * @name text_node
 */ const $0025e209a0aa83b5$export$6f093cfa640b7166 = {
    group: 'inline',
    toDebugString: ()=>'text_node'
};

});

parcelRegister("iClK1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8dca3fddecffb60$export$2e2bcd8739ae039);
const $d8dca3fddecffb60$var$name = 'unknownBlock';
var $d8dca3fddecffb60$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $d8dca3fddecffb60$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$d8dca3fddecffb60$var$name}"]`
        }
    ]
};

});

parcelRegister("cfiTE", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", () => $8ea58b3e23d0b005$export$44b79b0979d0f0f7);
const $8ea58b3e23d0b005$export$44b79b0979d0f0f7 = {
    inline: false,
    group: 'block',
    atom: true,
    selectable: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
};

});

parcelRegister("krp4v", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", () => $ee19c6f9dd83a851$export$310ebe0d80122e9b);
const $ee19c6f9dd83a851$export$310ebe0d80122e9b = {
    inline: true,
    group: 'inline',
    selectable: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
};

});



parcelRegister("7bxxe", function(module, exports) {

$parcel$export(module.exports, "markOverrideRuleFor", () => $53b392d79fd130b6$export$28e4e3c024cce988);
const $53b392d79fd130b6$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $53b392d79fd130b6$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $53b392d79fd130b6$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $53b392d79fd130b6$var$defaultAllowOverrideBehaviour;
        default:
            return $53b392d79fd130b6$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("ja5wt", function(module, exports) {

$parcel$export(module.exports, "sanitizeNode", () => $df333c332c6a652e$export$48b382180baf8e88);

var $fkCu1 = parcelRequire("fkCu1");

var $1CHYe = parcelRequire("1CHYe");
function $df333c332c6a652e$export$48b382180baf8e88(json) {
    const sanitizedJSON = (0, $fkCu1.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $1CHYe.removeMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        emoji: (0, $1CHYe.removeMarks),
        mention: (0, $1CHYe.removeMarks),
        date: (0, $1CHYe.removeMarks),
        hardBreak: (0, $1CHYe.removeMarks),
        inlineCard: (0, $1CHYe.removeMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("1CHYe", function(module, exports) {

$parcel$export(module.exports, "removeMarks", () => $12eb72a7dd8973a1$export$9bf001d8ef76e497);
function $12eb72a7dd8973a1$export$9bf001d8ef76e497(node) {
    let newNode = {
        ...node
    };
    // Rolling this mark out to all nodes is expected to occur in FY24 Q4.
    // see https://team.atlassian.com/project/ATLAS-54592 for details.
    if (node.type === 'inlineCard' && node.marks) {
        newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
        return newNode;
    }
    delete newNode.marks;
    return newNode;
}

});




parcelRegister("3BVCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a11860070d692ad$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $1ngde = parcelRequire("1ngde");

var $kyzqi = parcelRequire("kyzqi");

var $3syEy = parcelRequire("3syEy");

var $gZXlg = parcelRequire("gZXlg");

var $bDgco = parcelRequire("bDgco");
const $2a11860070d692ad$var$PACKAGE_DATA = {
    packageName: "@atlaskit/smart-card",
    packageVersion: "26.73.0",
    componentName: 'linkUrl'
};
const $2a11860070d692ad$var$Link = (0, $kyzqi.withLinkClickedEvent)('a');
const $2a11860070d692ad$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', ...props })=>{
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $gZXlg.useLinkWarningModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3syEy.LinkAnalyticsContext), {
        url: href,
        display: "url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a11860070d692ad$var$Link, (0, $kU09D.default)({
        "data-testid": testId,
        href: href,
        onClick: (e)=>{
            if (!checkSafety) {
                onClick && onClick(e);
                return;
            }
            // Only call the onClick if the link is safe
            if (isLinkSafe(e, href)) onClick && onClick(e);
            else showSafetyWarningModal(e, href);
        }
    }, props), children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDgco.default), linkWarningModalProps));
};
var $2a11860070d692ad$export$2e2bcd8739ae039 = (0, $1ngde.default)($2a11860070d692ad$var$PACKAGE_DATA)($2a11860070d692ad$var$LinkUrl);

});
parcelRegister("kyzqi", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $ef7275e86addaab1$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $ef7275e86addaab1$export$263352d59c0c5966);

var $eUqFw = parcelRequire("eUqFw");

var $4LwTb = parcelRequire("4LwTb");

var $iDnwt = parcelRequire("iDnwt");

var $hnYQo = parcelRequire("hnYQo");
const $ef7275e86addaab1$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $ef7275e86addaab1$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $ef7275e86addaab1$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $ef7275e86addaab1$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $4LwTb.browser)();
    /**
   * If the link/parent is content editable then left click won't have typical effect
   */ if ($ef7275e86addaab1$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $ef7275e86addaab1$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $ef7275e86addaab1$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $ef7275e86addaab1$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $ef7275e86addaab1$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $ef7275e86addaab1$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    return $ef7275e86addaab1$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
};
const $ef7275e86addaab1$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $ef7275e86addaab1$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides === null || overrides === void 0 ? void 0 : overrides.attributes
            }
        }).fire((0, $iDnwt.ANALYTICS_CHANNEL));
    };
const $ef7275e86addaab1$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $ef7275e86addaab1$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $hnYQo.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $hnYQo.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$ef7275e86addaab1$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("4LwTb", function(module, exports) {

$parcel$export(module.exports, "browser", () => $53e1c38db50269d3$export$3f2684e5d7cb1006);
const $53e1c38db50269d3$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $53e1c38db50269d3$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $53e1c38db50269d3$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $53e1c38db50269d3$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $53e1c38db50269d3$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $53e1c38db50269d3$var$result.android = /Android \d/.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $53e1c38db50269d3$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $53e1c38db50269d3$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $53e1c38db50269d3$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $53e1c38db50269d3$export$3f2684e5d7cb1006() {
    return $53e1c38db50269d3$var$result;
}

});

parcelRegister("iDnwt", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $d90e1da46061c6c4$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $d90e1da46061c6c4$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $d90e1da46061c6c4$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $d90e1da46061c6c4$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $d90e1da46061c6c4$export$b91e0203b928470c);
$parcel$export(module.exports, "resolvedEvent", () => $d90e1da46061c6c4$export$e2e1bab8375c3115);
$parcel$export(module.exports, "unresolvedEvent", () => $d90e1da46061c6c4$export$331b399cdebbb8d4);
$parcel$export(module.exports, "invokeSucceededEvent", () => $d90e1da46061c6c4$export$237caeb1002642ba);
$parcel$export(module.exports, "invokeFailedEvent", () => $d90e1da46061c6c4$export$ac488bf3e4c7f93);
$parcel$export(module.exports, "connectSucceededEvent", () => $d90e1da46061c6c4$export$5f549b8ba38f19b1);
$parcel$export(module.exports, "connectFailedEvent", () => $d90e1da46061c6c4$export$fdfcba182edbb89a);
$parcel$export(module.exports, "trackAppAccountConnected", () => $d90e1da46061c6c4$export$27d8deca51e9575c);
$parcel$export(module.exports, "trackAppAccountAuthStarted", () => $d90e1da46061c6c4$export$48e92e116e00d94c);
$parcel$export(module.exports, "trackSmartLinkQuickActionStarted", () => $d90e1da46061c6c4$export$1c2a74fe02a8031b);
$parcel$export(module.exports, "trackSmartLinkQuickActionSuccess", () => $d90e1da46061c6c4$export$afbd6446c1c03a3e);
$parcel$export(module.exports, "trackSmartLinkQuickActionFailed", () => $d90e1da46061c6c4$export$2706827739a8c50);
$parcel$export(module.exports, "trackHoverCardResolutionStarted", () => $d90e1da46061c6c4$export$daa964b113be9527);
$parcel$export(module.exports, "uiAuthEvent", () => $d90e1da46061c6c4$export$5318734335f1d8b8);
$parcel$export(module.exports, "uiAuthAlternateAccountEvent", () => $d90e1da46061c6c4$export$14f2ce8523ccb652);
$parcel$export(module.exports, "uiCardClickedEvent", () => $d90e1da46061c6c4$export$8b5d1f55370347a1);
$parcel$export(module.exports, "uiIframeDwelledEvent", () => $d90e1da46061c6c4$export$6b045396616c2e9f);
$parcel$export(module.exports, "uiIframeFocusedEvent", () => $d90e1da46061c6c4$export$93fa3246cf9e3b52);
$parcel$export(module.exports, "uiActionClickedEvent", () => $d90e1da46061c6c4$export$e00b9d79d3367530);
$parcel$export(module.exports, "uiClosedAuthEvent", () => $d90e1da46061c6c4$export$fe5b1f066ca3365d);
$parcel$export(module.exports, "screenAuthPopupEvent", () => $d90e1da46061c6c4$export$69bb595db263d8ef);
$parcel$export(module.exports, "uiRenderSuccessEvent", () => $d90e1da46061c6c4$export$bd308326cf1076aa);
$parcel$export(module.exports, "uiRenderFailedEvent", () => $d90e1da46061c6c4$export$1543b6391f48a5e2);
$parcel$export(module.exports, "uiHoverCardViewedEvent", () => $d90e1da46061c6c4$export$e80a2f97cccab3b1);
$parcel$export(module.exports, "uiHoverCardDismissedEvent", () => $d90e1da46061c6c4$export$3d10c6f90bc461d3);
$parcel$export(module.exports, "uiHoverCardOpenLinkClickedEvent", () => $d90e1da46061c6c4$export$ad3275d7dff50d21);
$parcel$export(module.exports, "uiLearnMoreLinkClickedEvent", () => $d90e1da46061c6c4$export$925348ae8d2e0bf3);
$parcel$export(module.exports, "chunkloadFailedEvent", () => $d90e1da46061c6c4$export$2b6bbed3753f06f9);
$parcel$export(module.exports, "uiSmartLinkStatusLozengeButtonClicked", () => $d90e1da46061c6c4$export$94c3643533642ab);
$parcel$export(module.exports, "uiSmartLinkStatusListItemButtonClicked", () => $d90e1da46061c6c4$export$18dfe458db0b743d);
$parcel$export(module.exports, "uiSmartLinkStatusOpenPreviewButtonClicked", () => $d90e1da46061c6c4$export$9a352e2e15b3de89);
$parcel$export(module.exports, "uiServerActionClicked", () => $d90e1da46061c6c4$export$a66dc699502b5d28);

var $aSzRC = parcelRequire("aSzRC");

var $cCvxR = parcelRequire("cCvxR");
const $d90e1da46061c6c4$export$85183a312807388d = 'media';
const $d90e1da46061c6c4$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "@atlaskit/smart-card",
    packageVersion: "26.73.0"
};
let $d90e1da46061c6c4$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
let $d90e1da46061c6c4$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
const $d90e1da46061c6c4$export$bbd674aacb40a160 = {
    [(0, $cCvxR.SmartLinkActionType).FollowEntityAction]: 'Follow',
    [(0, $cCvxR.SmartLinkActionType).StatusUpdateAction]: 'StatusUpdate',
    [(0, $cCvxR.SmartLinkActionType).UnfollowEntityAction]: 'Unfollow'
};
const $d90e1da46061c6c4$export$baf70a532f8c6fa6 = {
    [(0, $cCvxR.SmartLinkActionType).FollowEntityAction]: 'smartLinkFollowButton',
    [(0, $cCvxR.SmartLinkActionType).UnfollowEntityAction]: 'smartLinkFollowButton'
};
const $d90e1da46061c6c4$var$uiActionSubjectIds = {
    DownloadAction: 'downloadDocument',
    PreviewAction: 'invokePreviewScreen',
    ViewAction: 'shortcutGoToLink',
    StatusAction: 'issueStatusUpdate'
};
class $d90e1da46061c6c4$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $d90e1da46061c6c4$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $d90e1da46061c6c4$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($d90e1da46061c6c4$export$85183a312807388d);
};
const $d90e1da46061c6c4$export$e2e1bab8375c3115 = (props)=>({
        action: 'resolved',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...props,
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe
        }
    });
const $d90e1da46061c6c4$export$331b399cdebbb8d4 = ({ id: id, definitionId: definitionId, extensionKey: extensionKey, resourceType: resourceType, destinationSubproduct: destinationSubproduct, destinationProduct: destinationProduct, error: error, status: status, location: location })=>({
        action: 'unresolved',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            id: id,
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            ...definitionId ? {
                definitionId: definitionId
            } : {},
            ...extensionKey ? {
                extensionKey: extensionKey
            } : {},
            ...resourceType ? {
                resourceType: resourceType
            } : {},
            ...destinationSubproduct ? {
                destinationSubproduct: destinationSubproduct
            } : {},
            ...destinationProduct ? {
                destinationProduct: destinationProduct
            } : {},
            ...location ? {
                location: location
            } : {},
            reason: status,
            error: error ? {
                message: error === null || error === void 0 ? void 0 : error.message,
                kind: error === null || error === void 0 ? void 0 : error.kind,
                type: error === null || error === void 0 ? void 0 : error.type
            } : undefined
        }
    });
const $d90e1da46061c6c4$export$237caeb1002642ba = ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
    const measure = id ? (0, $aSzRC.getMeasure)(id, 'resolved') : undefined;
    return {
        action: 'resolved',
        actionSubject: 'smartLinkAction',
        eventType: 'operational',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            id: id,
            actionType: actionType,
            display: display,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            extensionKey: extensionKey,
            duration: measure === null || measure === void 0 ? void 0 : measure.duration
        }
    };
};
const $d90e1da46061c6c4$export$ac488bf3e4c7f93 = ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
    const measure = id ? (0, $aSzRC.getMeasure)(id, 'errored') : undefined;
    return {
        action: 'unresolved',
        actionSubject: 'smartLinkAction',
        eventType: 'operational',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            id: id,
            actionType: actionType,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            duration: measure === null || measure === void 0 ? void 0 : measure.duration,
            reason: reason
        }
    };
};
const $d90e1da46061c6c4$export$5f549b8ba38f19b1 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'connectSucceeded',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $d90e1da46061c6c4$export$fdfcba182edbb89a = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, reason: reason })=>({
        action: 'connectFailed',
        actionSubject: 'smartLink',
        actionSubjectId: reason,
        eventType: 'operational',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            reason: reason,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $d90e1da46061c6c4$export$27d8deca51e9575c = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'connected',
        actionSubject: 'applicationAccount',
        eventType: 'track',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $d90e1da46061c6c4$export$48e92e116e00d94c = ({ extensionKey: extensionKey, location: location })=>({
        action: 'authStarted',
        actionSubject: 'applicationAccount',
        eventType: 'track',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            location: location
        }
    });
const $d90e1da46061c6c4$export$1c2a74fe02a8031b = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>{
    var _SmartLinkActionTypeT;
    return {
        action: 'started',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: (_SmartLinkActionTypeT = $d90e1da46061c6c4$export$bbd674aacb40a160[smartLinkActionType]) !== null && _SmartLinkActionTypeT !== void 0 ? _SmartLinkActionTypeT : smartLinkActionType
        }
    };
};
const $d90e1da46061c6c4$export$afbd6446c1c03a3e = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>{
    var _SmartLinkActionTypeT2;
    return {
        action: 'success',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: (_SmartLinkActionTypeT2 = $d90e1da46061c6c4$export$bbd674aacb40a160[smartLinkActionType]) !== null && _SmartLinkActionTypeT2 !== void 0 ? _SmartLinkActionTypeT2 : smartLinkActionType
        }
    };
};
const $d90e1da46061c6c4$export$2706827739a8c50 = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>{
    var _SmartLinkActionTypeT3;
    return {
        action: 'failed',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: (_SmartLinkActionTypeT3 = $d90e1da46061c6c4$export$bbd674aacb40a160[smartLinkActionType]) !== null && _SmartLinkActionTypeT3 !== void 0 ? _SmartLinkActionTypeT3 : smartLinkActionType
        }
    };
};
const $d90e1da46061c6c4$export$daa964b113be9527 = ({ display: display, ...attributes })=>({
        action: 'resolved',
        actionSubject: 'hoverCard',
        eventType: 'track',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            ...attributes,
            display: display
        }
    });
const $d90e1da46061c6c4$export$5318734335f1d8b8 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'connectAccount',
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $d90e1da46061c6c4$export$14f2ce8523ccb652 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
        action: 'clicked',
        actionSubject: 'smartLink',
        actionSubjectId: 'tryAnotherAccount',
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $d90e1da46061c6c4$export$8b5d1f55370347a1 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>({
        action: 'clicked',
        actionSubject: 'smartLink',
        actionSubjectId: actionSubjectId,
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            isModifierKeyPressed: isModifierKeyPressed,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct
        }
    });
const $d90e1da46061c6c4$export$6b045396616c2e9f = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, dwellTime: dwellTime, dwellPercentVisible: dwellPercentVisible })=>({
        action: 'dwelled',
        actionSubject: 'smartLinkIframe',
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            dwellTime: dwellTime,
            dwellPercentVisible: dwellPercentVisible
        }
    });
const $d90e1da46061c6c4$export$93fa3246cf9e3b52 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct })=>({
        action: 'focused',
        actionSubject: 'smartLinkIframe',
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct
        }
    });
const $d90e1da46061c6c4$export$e00b9d79d3367530 = ({ id: id, actionType: actionType, extensionKey: extensionKey, display: display, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: $d90e1da46061c6c4$var$uiActionSubjectIds[actionType],
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            id: id,
            display: display,
            actionType: actionType,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $d90e1da46061c6c4$export$fe5b1f066ca3365d = ({ display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'closed',
        actionSubject: 'consentModal',
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $d90e1da46061c6c4$export$69bb595db263d8ef = ({ extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        actionSubject: 'consentModal',
        eventType: 'screen',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $d90e1da46061c6c4$export$bd308326cf1076aa = ({ display: display, status: status, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource })=>({
        action: 'renderSuccess',
        actionSubject: 'smartLink',
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            status: status,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display,
            canBeDatasource: canBeDatasource
        }
    });
const $d90e1da46061c6c4$export$1543b6391f48a5e2 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        actionSubject: 'smartLink',
        action: 'renderFailed',
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            error: error,
            errorInfo: errorInfo,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $d90e1da46061c6c4$export$e80a2f97cccab3b1 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
        action: 'viewed',
        actionSubject: 'hoverCard',
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod,
            status: status
        }
    });
const $d90e1da46061c6c4$export$3d10c6f90bc461d3 = ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
        action: 'dismissed',
        actionSubject: 'hoverCard',
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            hoverTime: hoverTime,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod,
            status: status
        }
    });
const $d90e1da46061c6c4$export$ad3275d7dff50d21 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'shortcutGoToLink',
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod
        }
    });
const $d90e1da46061c6c4$export$925348ae8d2e0bf3 = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'learnMore',
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe
        }
    });
const $d90e1da46061c6c4$export$2b6bbed3753f06f9 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'chunkLoadFailed',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe,
            error: error,
            errorInfo: errorInfo,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $d90e1da46061c6c4$export$94c3643533642ab = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusLozenge',
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe
        }
    });
const $d90e1da46061c6c4$export$18dfe458db0b743d = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusListItem',
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe
        }
    });
const $d90e1da46061c6c4$export$9a352e2e15b3de89 = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusOpenPreview',
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe
        }
    });
const $d90e1da46061c6c4$export$a66dc699502b5d28 = ({ smartLinkActionType: smartLinkActionType })=>{
    var _SmartLinkActionTypeU;
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: (_SmartLinkActionTypeU = $d90e1da46061c6c4$export$baf70a532f8c6fa6[smartLinkActionType]) !== null && _SmartLinkActionTypeU !== void 0 ? _SmartLinkActionTypeU : smartLinkActionType,
        eventType: 'ui',
        attributes: {
            ...$d90e1da46061c6c4$export$a078c61943f9dbbe
        }
    };
};

});
parcelRegister("aSzRC", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $7ebac45b84851c7f$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $7ebac45b84851c7f$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $7ebac45b84851c7f$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $7ebac45b84851c7f$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $7ebac45b84851c7f$export$185802fd694ee1f5);
const $7ebac45b84851c7f$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $7ebac45b84851c7f$var$hasPerformanceAPIAvailable = $7ebac45b84851c7f$var$isPerformanceAPIAvailable();
const $7ebac45b84851c7f$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $7ebac45b84851c7f$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $7ebac45b84851c7f$export$1a717feb4df1a945 = (id)=>{
    if ($7ebac45b84851c7f$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $7ebac45b84851c7f$export$de42547d395c8271 = (id)=>{
    if ($7ebac45b84851c7f$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $7ebac45b84851c7f$var$getMark = (id, status)=>{
    if ($7ebac45b84851c7f$var$hasPerformanceAPIAvailable) {
        const name = $7ebac45b84851c7f$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $7ebac45b84851c7f$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($7ebac45b84851c7f$var$hasPerformanceAPIAvailable) {
        const name = $7ebac45b84851c7f$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $7ebac45b84851c7f$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($7ebac45b84851c7f$var$hasPerformanceAPIAvailable) {
        const name = $7ebac45b84851c7f$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $7ebac45b84851c7f$export$185802fd694ee1f5 = (id, status)=>{
    if ($7ebac45b84851c7f$var$hasPerformanceAPIAvailable) {
        const name = $7ebac45b84851c7f$export$984df7f61dd7928f(id, status);
        const measure = $7ebac45b84851c7f$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $7ebac45b84851c7f$var$getMark(id, 'pending');
            const endMark = $7ebac45b84851c7f$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});

parcelRegister("cCvxR", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $8c69a400a46c2e51$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $8c69a400a46c2e51$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $8c69a400a46c2e51$export$6324b7946ad663e9;
(function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
})($8c69a400a46c2e51$export$6324b7946ad663e9 || ($8c69a400a46c2e51$export$6324b7946ad663e9 = {}));
class $8c69a400a46c2e51$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});


parcelRegister("hnYQo", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $ca83c8076cf2ce1d$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $ca83c8076cf2ce1d$export$df67f318ded0283c);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $kyzqi = parcelRequire("kyzqi");
let $ca83c8076cf2ce1d$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $ca83c8076cf2ce1d$export$5993d3ca6c85f774 = (handler, predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((...args)=>{
        const [event] = args;
        handler === null || handler === void 0 || handler.apply(null, args);
        if (!predicate || predicate !== null && predicate !== void 0 && predicate(event)) (0, $kyzqi.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $ca83c8076cf2ce1d$var$isNotLeftClick = (event)=>event.button !== 0;
const $ca83c8076cf2ce1d$export$df67f318ded0283c = (onMouseDown)=>{
    return $ca83c8076cf2ce1d$export$5993d3ca6c85f774(onMouseDown, $ca83c8076cf2ce1d$var$isNotLeftClick);
};

});


parcelRegister("3syEy", function(module, exports) {

$parcel$export(module.exports, "LinkAnalyticsContext", () => $284eddff905408cd$export$9458cdec663b9ff1);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");
const $284eddff905408cd$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};

});

parcelRegister("gZXlg", function(module, exports) {

$parcel$export(module.exports, "useLinkWarningModal", () => $c6005febb8f1aa71$export$32b76c003683c2ec);

var $eUqFw = parcelRequire("eUqFw");

var $jw09O = parcelRequire("jw09O");

var $bFzGY = parcelRequire("bFzGY");

var $iDnwt = parcelRequire("iDnwt");
const $c6005febb8f1aa71$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $c6005febb8f1aa71$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $eUqFw.useState)(null);
    const [url, setUrl] = (0, $eUqFw.useState)(null);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $iDnwt.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $iDnwt.ANALYTICS_CHANNEL));
    };
    /**
   * It checks and warns if a link text is a URL and different from an actual link destination
   */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $jw09O.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $c6005febb8f1aa71$var$toUrl(href, window.location.origin);
        const linkTextUrl = $c6005febb8f1aa71$var$toUrl(normalisedUrlFromLinkText, hrefUrl === null || hrefUrl === void 0 ? void 0 : hrefUrl.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};

});
parcelRegister("jw09O", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $d3ea18b193bf4e7e$export$c9f92f5469372e0f);
$parcel$export(module.exports, "normalizeUrl", () => $d3ea18b193bf4e7e$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $dVFtG = parcelRequire("dVFtG");
const $d3ea18b193bf4e7e$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($dVFtG)))();
$d3ea18b193bf4e7e$var$linkify.add('sourcetree:', 'http:');
$d3ea18b193bf4e7e$var$linkify.add('jamfselfservice:', 'http:');
$d3ea18b193bf4e7e$var$linkify.add('notes:', 'http:');
const $d3ea18b193bf4e7e$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $d3ea18b193bf4e7e$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$d3ea18b193bf4e7e$var$tlds.push($d3ea18b193bf4e7e$var$tlds2Char);
$d3ea18b193bf4e7e$var$linkify.tlds($d3ea18b193bf4e7e$var$tlds, false);
const $d3ea18b193bf4e7e$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $d3ea18b193bf4e7e$var$normaliseLinkHref = (url)=>{
    const match = $d3ea18b193bf4e7e$var$getLinkMatch(url);
    return match && match.url || null;
};
const $d3ea18b193bf4e7e$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $d3ea18b193bf4e7e$var$linkifyMatch(str);
    if (!match.length) match = $d3ea18b193bf4e7e$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $d3ea18b193bf4e7e$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $d3ea18b193bf4e7e$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$d3ea18b193bf4e7e$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($d3ea18b193bf4e7e$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($d3ea18b193bf4e7e$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $d3ea18b193bf4e7e$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $d3ea18b193bf4e7e$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $d3ea18b193bf4e7e$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($d3ea18b193bf4e7e$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $d3ea18b193bf4e7e$var$normaliseLinkHref(urlWithoutNewlines);
}

});
parcelRegister("dVFtG", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $a240c5dab5a16a6a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $a240c5dab5a16a6a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $a240c5dab5a16a6a$var$isString(obj) {
    return $a240c5dab5a16a6a$var$_class(obj) === '[object String]';
}
function $a240c5dab5a16a6a$var$isObject(obj) {
    return $a240c5dab5a16a6a$var$_class(obj) === '[object Object]';
}
function $a240c5dab5a16a6a$var$isRegExp(obj) {
    return $a240c5dab5a16a6a$var$_class(obj) === '[object RegExp]';
}
function $a240c5dab5a16a6a$var$isFunction(obj) {
    return $a240c5dab5a16a6a$var$_class(obj) === '[object Function]';
}
function $a240c5dab5a16a6a$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $a240c5dab5a16a6a$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $a240c5dab5a16a6a$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $a240c5dab5a16a6a$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $a240c5dab5a16a6a$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $a240c5dab5a16a6a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $a240c5dab5a16a6a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $a240c5dab5a16a6a$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $a240c5dab5a16a6a$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $a240c5dab5a16a6a$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $a240c5dab5a16a6a$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("ajKi5"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($a240c5dab5a16a6a$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($a240c5dab5a16a6a$var$isObject(val)) {
            if ($a240c5dab5a16a6a$var$isRegExp(val.validate)) compiled.validate = $a240c5dab5a16a6a$var$createValidator(val.validate);
            else if ($a240c5dab5a16a6a$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($a240c5dab5a16a6a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $a240c5dab5a16a6a$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($a240c5dab5a16a6a$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $a240c5dab5a16a6a$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($a240c5dab5a16a6a$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $a240c5dab5a16a6a$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $a240c5dab5a16a6a$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $a240c5dab5a16a6a$var$createMatch(self, shift) {
    var match = new $a240c5dab5a16a6a$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $a240c5dab5a16a6a$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $a240c5dab5a16a6a$var$LinkifyIt)) return new $a240c5dab5a16a6a$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($a240c5dab5a16a6a$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $a240c5dab5a16a6a$var$assign({}, $a240c5dab5a16a6a$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $a240c5dab5a16a6a$var$assign({}, $a240c5dab5a16a6a$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $a240c5dab5a16a6a$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $a240c5dab5a16a6a$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $a240c5dab5a16a6a$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $a240c5dab5a16a6a$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($a240c5dab5a16a6a$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($a240c5dab5a16a6a$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $a240c5dab5a16a6a$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $a240c5dab5a16a6a$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $a240c5dab5a16a6a$var$LinkifyIt;

});
parcelRegister("ajKi5", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("4NOMA")).source;
    re.src_Cc = (parcelRequire("jvFHg")).source;
    re.src_Z = (parcelRequire("8UCq2")).source;
    re.src_P = (parcelRequire("aUAJj")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});




parcelRegister("bDgco", function(module, exports) {

$parcel$export(module.exports, "default", () => $877fe6fd07c46f9d$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");
parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");
var $3dpxL = parcelRequire("3dpxL");

var $jtD5J = parcelRequire("jtD5J");

var $byn9U = parcelRequire("byn9U");

var $6D8aU = parcelRequire("6D8aU");
const $877fe6fd07c46f9d$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = (0, $byn9U.jsx)((0, $dxopF.default), null, isOpen && (0, $byn9U.jsx)((0, $aOw1G.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, (0, $byn9U.jsx)((0, $kigFe.default), null, (0, $byn9U.jsx)((0, $boSVF.default), {
        appearance: "warning"
    }, (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $6D8aU.messages).check_this_link))), (0, $byn9U.jsx)((0, $lfiOu.default), null, (0, $byn9U.jsx)("div", {
        css: (0, $jtD5J.breakWordsCss)
    }, url && unsafeLinkText && (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $6D8aU.messages).link_safety_warning_message, {
        values: {
            unsafeLinkText: unsafeLinkText,
            a: ()=>(0, $byn9U.jsx)("a", {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url)
        }
    })))), (0, $byn9U.jsx)((0, $2OJfS.default), null, (0, $byn9U.jsx)((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClose
    }, (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $6D8aU.messages).go_back)), (0, $byn9U.jsx)((0, $7u4fN.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $6D8aU.messages).continue)))));
    return intl ? content : (0, $byn9U.jsx)((0, $3dpxL.default), {
        locale: "en"
    }, content);
};
var $877fe6fd07c46f9d$export$2e2bcd8739ae039 = (0, $2qhQi.default)($877fe6fd07c46f9d$var$WarningModal, {
    enforceContext: false
});

});
parcelRegister("jtD5J", function(module, exports) {

$parcel$export(module.exports, "breakWordsCss", () => $e2df0c8071d813c1$export$e4dda5b86d39ace5);

var $byn9U = parcelRequire("byn9U");
const $e2df0c8071d813c1$export$e4dda5b86d39ace5 = (0, $byn9U.css)({
    whiteSpace: 'pre-line',
    wordBreak: 'break-all'
});

});

parcelRegister("6D8aU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4d3cb9fb88638eed$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $4d3cb9fb88638eed$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules...',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related_work_items_not_found: {
        id: 'fabric.linking.related_work_items_not_found',
        defaultMessage: 'This link is not mentioned anywhere else.',
        description: 'Informs the user that there are no related resources for a given url'
    },
    last_mentioned_in: {
        id: 'fabric.linking.last_mentioned_in',
        defaultMessage: 'Last mentioned in',
        description: 'Informs the user about where the resource was last mentioned in'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title_nonfinal: {
        id: 'fabric.linking.related_links_modal_title.nonfinal',
        defaultMessage: 'Recent Links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls.nonfinal',
        defaultMessage: 'View recent links...',
        description: 'Action to view related links to the given resource'
    }
});

});




parcelRegister("4mY3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $32e7cc2ea85995e8$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");
function $32e7cc2ea85995e8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", (0, $kU09D.default)({}, props.dataAttributes, {
        style: {
            textDecoration: 'line-through'
        }
    }), props.children);
}

});

parcelRegister("6nwFc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a4e3a56d5bb7d1a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $4a4e3a56d5bb7d1a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", props.dataAttributes, props.children);
}

});

parcelRegister("ioUOQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6568afd94e5dc65$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $d6568afd94e5dc65$var$isSub = (type)=>{
    return type === 'sub';
};
function $d6568afd94e5dc65$export$2e2bcd8739ae039(props) {
    if ($d6568afd94e5dc65$var$isSub(props.type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("sub", props.dataAttributes, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("sup", props.dataAttributes, props.children);
}

});

parcelRegister("lAmvl", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb6e6ab58e738429$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $as9OS = parcelRequire("as9OS");

var $dmNxo = parcelRequire("dmNxo");

var $4q38b = parcelRequire("4q38b");
function $fb6e6ab58e738429$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $4q38b.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $dmNxo.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $dmNxo.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $as9OS.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $eUqFw.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", (0, $kU09D.default)({}, props.dataAttributes, {
        "data-text-custom-color": props.color,
        className: "fabric-text-color-mark",
        style: style
    }), props.children);
}

});
parcelRegister("dmNxo", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $9bb3c196acfa2e13$export$9c2f408d391feb93);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching text palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToTextPaletteColor('#0747A6');
 * //     ^? const cssValue: string
 * <span style={{textColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $9bb3c196acfa2e13$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $9bb3c196acfa2e13$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $9bb3c196acfa2e13$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #4C9AFF)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #0747A6)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #00B8D9)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #008DA6)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #ABF5D1)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #36B37E)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #006644)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FFC400)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #FF991F)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #FF5630)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #BF2600)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #6554C0)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #403294)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #97A0AF)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #172B4D)" // source for hex code was legacy token N800
};

});


parcelRegister("dfnu7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a4ee4ab089b1586$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $9a4ee4ab089b1586$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("u", props.dataAttributes, props.children);
}

});

parcelRegister("j4Oes", function(module, exports) {

$parcel$export(module.exports, "default", () => $de355b218d5fad37$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $4IyMA = parcelRequire("4IyMA");

var $khES4 = parcelRequire("khES4");

var $25FYC = parcelRequire("25FYC");
const $de355b218d5fad37$export$491e6397d7c1480b = (0, $byn9U.css)`
  margin: ${(0, $25FYC.blockNodesVerticalMargin)} 0;
  margin-left: 50%;
  transform: translateX(-50%);
`;
function $de355b218d5fad37$export$2e2bcd8739ae039(props) {
    return (0, $byn9U.jsx)((0, $4IyMA.WidthConsumer), null, ({ width: width })=>(0, $byn9U.jsx)("div", {
            css: $de355b218d5fad37$export$491e6397d7c1480b,
            "data-mode": props.mode,
            style: {
                width: (0, $khES4.calcBreakoutWidth)(props.mode, width)
            },
            className: "fabric-editor-breakout-mark fabric-editor-block-mark"
        }, props.children));
}

});

parcelRegister("1007J", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ba5e315eee19d8c$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");
parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dkRpY = parcelRequire("dkRpY");
const $0ba5e315eee19d8c$var$MarkWrapper = (props)=>{
    const styles = props['data-align'] ? (0, $byn9U.css)`
        text-align: ${(0, $dkRpY.alignmentPositionMap)[props['data-align']]};
      ` : '';
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        css: styles
    }, props), props.children);
};
function $0ba5e315eee19d8c$export$2e2bcd8739ae039(props) {
    return (0, $byn9U.jsx)($0ba5e315eee19d8c$var$MarkWrapper, {
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}

});

parcelRegister("51Xgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a9b0397767ca208$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $3a9b0397767ca208$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level
    }, props.children);
}

});

parcelRegister("c4cK6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c8fbe2a1a6431a3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $8c8fbe2a1a6431a3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", props.dataAttributes, props.children);
}

});

parcelRegister("gPsph", function(module, exports) {

$parcel$export(module.exports, "default", () => $c40771c1cfea800c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $c40771c1cfea800c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", props.dataAttributes, props.children);
}

});

parcelRegister("3jWT1", function(module, exports) {

$parcel$export(module.exports, "default", () => $26b0d314aba05d18$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");
function $26b0d314aba05d18$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperElement, (0, $kU09D.default)({
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer"
    }, props.dataAttributes), props.children);
}

});

parcelRegister("jZ4vt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c735c518eff643$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");
function $e8c735c518eff643$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperElement, (0, $kU09D.default)({
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment"
    }, props.dataAttributes), props.children);
}

});

parcelRegister("bYs9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b7b22a65d5127a9$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
function $8b7b22a65d5127a9$export$2e2bcd8739ae039(props) {
    var _props$color, _props$size;
    const borderColor = (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : '';
    const borderSize = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 0;
    return (0, $byn9U.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("1jBQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f54eceb5dd54b10$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
class $0f54eceb5dd54b10$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference
        }, children);
    }
}

});


parcelRegister("9EROo", function(module, exports) {

$parcel$export(module.exports, "getMarksByOrder", () => $708197625ca48cdf$export$99a33ed044c278ae);
$parcel$export(module.exports, "isSameMark", () => $708197625ca48cdf$export$b1304404bdc42b7a);
$parcel$export(module.exports, "getValidDocument", () => $708197625ca48cdf$export$fb80336a7e408cb3);
$parcel$export(module.exports, "getValidNode", () => $708197625ca48cdf$export$81b20b6c83a56bd);

var $lUXsh = parcelRequire("lUXsh");
var $2yJJ8 = parcelRequire("2yJJ8");
var $4N6cH = parcelRequire("4N6cH");
var $izui5 = parcelRequire("izui5");

var $9wcjJ = parcelRequire("9wcjJ");

var $XHGTv = parcelRequire("XHGTv");
const $708197625ca48cdf$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $708197625ca48cdf$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $708197625ca48cdf$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $708197625ca48cdf$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$708197625ca48cdf$export$62d5811a2955c1d8.indexOf(a.type.name) - $708197625ca48cdf$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $708197625ca48cdf$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $708197625ca48cdf$export$fb80336a7e408cb3 = (doc, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final')=>{
    const node = $708197625ca48cdf$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $708197625ca48cdf$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $708197625ca48cdf$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $2yJJ8.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $708197625ca48cdf$export$fafd4f799ee68da0 = (content, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$708197625ca48cdf$export$81b20b6c83a56bd(node, schema, adfStage));
};
const $708197625ca48cdf$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
const $708197625ca48cdf$var$RELATIVE_LINK = /^\//;
const $708197625ca48cdf$var$ANCHOR_LINK = /^#/;
const $708197625ca48cdf$var$flattenUnknownBlockTree = (node, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    for(let i = 0; i < node.content.length; i++){
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($708197625ca48cdf$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$708197625ca48cdf$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $708197625ca48cdf$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $4N6cH.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
   * Find leaf nodes and join them. If leaf nodes' parent node is the same node
   * join with a blank space, otherwise they are children of different branches, i.e.
   * we need to join them with a hardBreak node
   */ return {
        type: 'unknownBlock',
        content: $708197625ca48cdf$var$flattenUnknownBlockTree(node)
    };
};
const $708197625ca48cdf$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $708197625ca48cdf$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $708197625ca48cdf$export$81b20b6c83a56bd = (originalNode, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $708197625ca48cdf$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $708197625ca48cdf$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if ((0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes')) {
                let inlineCardNode = {
                    type: type
                };
                if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $4N6cH.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $4N6cH.isSafeUrl)(attrs.data.url))) inlineCardNode.attrs = {
                    ...attrs
                };
                if (marks) inlineCardNode.marks = [
                    ...marks
                ];
                return inlineCardNode;
            } else {
                if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $4N6cH.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $4N6cH.isSafeUrl)(attrs.data.url))) return {
                    type: type,
                    attrs: attrs
                };
                break;
            }
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $4N6cH.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $4N6cH.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $4N6cH.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $4N6cH.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $708197625ca48cdf$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $708197625ca48cdf$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $708197625ca48cdf$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        }
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                let { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $708197625ca48cdf$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) return marks ? {
                    type: type,
                    content: content,
                    marks: marks,
                    attrs: {
                        level: level
                    }
                } : {
                    type: type,
                    content: content,
                    attrs: {
                        level: level
                    }
                };
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $708197625ca48cdf$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $izui5.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $lUXsh.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $lUXsh.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $lUXsh.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $lUXsh.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: (attrs === null || attrs === void 0 ? void 0 : attrs.localId) || (0, $lUXsh.generateUuid)(),
                        width: (attrs === null || attrs === void 0 ? void 0 : attrs.width) || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $708197625ca48cdf$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
    }
    return $708197625ca48cdf$export$b9908ef75cad1e0e(node);
};
const $708197625ca48cdf$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$708197625ca48cdf$var$RELATIVE_LINK.test(linkHref) && !$708197625ca48cdf$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $4N6cH.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($708197625ca48cdf$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $708197625ca48cdf$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("2yJJ8", function(module, exports) {

$parcel$export(module.exports, "inlineNodes", () => $1dd23a32bc80184c$export$b1f729c6af6f2a6e);

var $4K6In = parcelRequire("4K6In");
const $1dd23a32bc80184c$var$typedNodes = $4K6In;
const $1dd23a32bc80184c$export$b1f729c6af6f2a6e = new Set(Object.keys($1dd23a32bc80184c$var$typedNodes).filter((key)=>$1dd23a32bc80184c$var$typedNodes[key] && $1dd23a32bc80184c$var$typedNodes[key].group === 'inline'));

});
parcelRegister("4K6In", function(module, exports) {

$parcel$export(module.exports, "expand", () => (parcelRequire("lKuoe")).expand);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("lKuoe")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("eTtDn")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("1Ud4U")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("56qNL")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("1HZv5")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("jDF31")).blockquote);
$parcel$export(module.exports, "blockquoteWithList", () => (parcelRequire("jDF31")).blockquoteWithList);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("568Ob")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("568Ob")).bulletListSelector);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("hgVop")).codeBlock);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("hgVop")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("7SlQD")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("iWGOh")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("7wZ4m")).rule);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("8lnnz")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("8lnnz")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("8lnnz")).orderedListWithOrder);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("5bGpU")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("5JhXr")).emoji);
$parcel$export(module.exports, "image", () => (parcelRequire("iOeir")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("fkqTY")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("fkqTY")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("3eVto")).listItem);
$parcel$export(module.exports, "listItemWithTask", () => (parcelRequire("3eVto")).listItemWithTask);
$parcel$export(module.exports, "panel", () => (parcelRequire("izui5")).panel);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("izui5")).extendedPanel);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("izui5")).PanelType);
$parcel$export(module.exports, "text", () => (parcelRequire("ltJuR")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("4ne8H")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("d99SJ")).caption);
$parcel$export(module.exports, "media", () => (parcelRequire("gN3fl")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("gN3fl")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("gN3fl")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("1KDvn")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("hXvCf")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("cvCFq")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("cvCFq")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("cvCFq")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("cvCFq")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("cvCFq")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("cvCFq")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("byxO6")).table);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("byxO6")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("byxO6")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("byxO6")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("byxO6")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("byxO6")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("byxO6")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("byxO6")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("byxO6")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("byxO6")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("byxO6")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("byxO6")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("byxO6")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("byxO6")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("byxO6")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("byxO6")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("byxO6")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("byxO6")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("byxO6")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("dPUL6")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("dPUL6")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("47B7q")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("7QozA")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("7QozA")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("ie5d6")).taskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("8CDqw")).date);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("dDs5p")).placeholder);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("jTnho")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("jTnho")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("1O3jv")).layoutColumn);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("8mC62")).inlineCard);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("heoPx")).blockCard);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("7p32Z")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("8cuPa")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("cvo5z")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("dj4Ew")).nestedExpand);
$parcel$export(module.exports, "extendedNestedExpand", () => (parcelRequire("dj4Ew")).extendedNestedExpand);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("7XTsD")).embedCard);
$parcel$export(module.exports, "extension", () => (parcelRequire("7y7sZ")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("7xvQK")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("eStcf")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("lUaLf")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("lUaLf")).multiBodiedExtension);

var $lKuoe = parcelRequire("lKuoe");

var $eTtDn = parcelRequire("eTtDn");

var $1Ud4U = parcelRequire("1Ud4U");

var $56qNL = parcelRequire("56qNL");

var $1HZv5 = parcelRequire("1HZv5");

var $jDF31 = parcelRequire("jDF31");

var $568Ob = parcelRequire("568Ob");

var $hgVop = parcelRequire("hgVop");

var $7SlQD = parcelRequire("7SlQD");

var $iWGOh = parcelRequire("iWGOh");

var $7wZ4m = parcelRequire("7wZ4m");

var $8lnnz = parcelRequire("8lnnz");

var $5bGpU = parcelRequire("5bGpU");

var $5JhXr = parcelRequire("5JhXr");

var $iOeir = parcelRequire("iOeir");

var $fkqTY = parcelRequire("fkqTY");

var $3eVto = parcelRequire("3eVto");

var $izui5 = parcelRequire("izui5");

var $ltJuR = parcelRequire("ltJuR");

var $4ne8H = parcelRequire("4ne8H");

var $d99SJ = parcelRequire("d99SJ");

var $gN3fl = parcelRequire("gN3fl");

var $1KDvn = parcelRequire("1KDvn");

var $hXvCf = parcelRequire("hXvCf");

var $cvCFq = parcelRequire("cvCFq");

var $byxO6 = parcelRequire("byxO6");

var $dPUL6 = parcelRequire("dPUL6");

var $47B7q = parcelRequire("47B7q");

var $7QozA = parcelRequire("7QozA");

var $ie5d6 = parcelRequire("ie5d6");

var $8CDqw = parcelRequire("8CDqw");

var $dDs5p = parcelRequire("dDs5p");

var $jTnho = parcelRequire("jTnho");

var $1O3jv = parcelRequire("1O3jv");

var $8mC62 = parcelRequire("8mC62");

var $heoPx = parcelRequire("heoPx");

var $7p32Z = parcelRequire("7p32Z");

var $8cuPa = parcelRequire("8cuPa");

var $cvo5z = parcelRequire("cvo5z");

var $dj4Ew = parcelRequire("dj4Ew");

var $7XTsD = parcelRequire("7XTsD");

var $7y7sZ = parcelRequire("7y7sZ");

var $7xvQK = parcelRequire("7xvQK");

var $eStcf = parcelRequire("eStcf");

var $lUaLf = parcelRequire("lUaLf");

});



parcelRegister("dnpK7", function(module, exports) {

$parcel$export(module.exports, "insideBreakoutLayout", () => $9bd16453ae501e63$export$d7bc71cca336a3b);
$parcel$export(module.exports, "insideBlockNode", () => $9bd16453ae501e63$export$42ddc573eb5a7b43);
$parcel$export(module.exports, "insideMultiBodiedExtension", () => $9bd16453ae501e63$export$9f1e9347b0411934);
const $9bd16453ae501e63$export$a6a9bc90de7cbf3d = (node)=>node.type.name === 'layoutSection';
const $9bd16453ae501e63$export$75a02f867f3d493c = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $9bd16453ae501e63$export$d7bc71cca336a3b = (path)=>path.some((item)=>$9bd16453ae501e63$export$a6a9bc90de7cbf3d(item) && $9bd16453ae501e63$export$75a02f867f3d493c(item));
const $9bd16453ae501e63$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $9bd16453ae501e63$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};

});


parcelRegister("8rYsT", function(module, exports) {

$parcel$export(module.exports, "renderDocument", () => $626fbf70c566617b$export$59a54f98b9753d5c);

var $5iWql = parcelRequire("5iWql");

var $9wcjJ = parcelRequire("9wcjJ");

var $9EROo = parcelRequire("9EROo");

var $fSlwM = parcelRequire("fSlwM");
var $gRUdA = parcelRequire("gRUdA");

var $61wF1 = parcelRequire("61wF1");

var $1lWyd = parcelRequire("1lWyd");

var $gAoAo = parcelRequire("gAoAo");

var $cVUdI = parcelRequire("cVUdI");
const $626fbf70c566617b$var$SUPPORTS_HIRES_TIMER_API = !!(window.performance && performance.now);
const $626fbf70c566617b$var$withStopwatch = (cb)=>{
    const startTime = $626fbf70c566617b$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $626fbf70c566617b$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $626fbf70c566617b$var$_validation = (doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $cVUdI.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $61wF1.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $61wF1.ACTION_SUBJECT).RENDERER,
            eventType: (0, $61wF1.EVENT_TYPE).OPERATIONAL
        });
        result = (0, $gRUdA.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent);
    } else result = (0, $9EROo.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    return result;
};
const $626fbf70c566617b$var$memoValidation = (0, $5iWql.default)($626fbf70c566617b$var$_validation, (newArgs, lastArgs)=>{
    const [newDoc, newSchema, newADFStage, newUseSpecValidator] = newArgs;
    const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator] = lastArgs;
    // we're ignoring changes to dispatchAnalyticsEvent in this check
    const result = $626fbf70c566617b$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator;
    return result;
});
const $626fbf70c566617b$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $626fbf70c566617b$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $626fbf70c566617b$var$memoSerializeFragment = (0, $5iWql.default)($626fbf70c566617b$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $626fbf70c566617b$var$areDocsEqual(newDoc, oldDoc);
});
const $626fbf70c566617b$var$_createNodeAndCheck = (schema, doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $61wF1.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $61wF1.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $1lWyd.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $61wF1.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $626fbf70c566617b$var$memoCreateNodeAndCheck = (0, $5iWql.default)($626fbf70c566617b$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $626fbf70c566617b$var$areDocsEqual(newDoc, oldDoc);
});
const $626fbf70c566617b$export$59a54f98b9753d5c = (doc, serializer, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance)=>{
    const stat = {
        sanitizeTime: 0
    };
    const { output: validDoc, time: sanitizeTime } = $626fbf70c566617b$var$withStopwatch(()=>{
        return $626fbf70c566617b$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $626fbf70c566617b$var$withStopwatch(()=>{
        return $626fbf70c566617b$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $626fbf70c566617b$var$withStopwatch(()=>{
        return $626fbf70c566617b$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $fSlwM.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking !== null && unsupportedContentLevelsTracking !== void 0 && unsupportedContentLevelsTracking.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $gAoAo.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("gRUdA", function(module, exports) {

$parcel$export(module.exports, "validateADFEntity", () => $c47d3453a61c8f9b$export$884cfad20dece33e);

var $h4nnH = parcelRequire("h4nnH");

var $61wF1 = parcelRequire("61wF1");

var $fSlwM = parcelRequire("fSlwM");
const $c47d3453a61c8f9b$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $c47d3453a61c8f9b$var$errorCallbackFor = (marks, validate, dispatchAnalyticsEvent)=>{
    return (entity, error, options)=>{
        return $c47d3453a61c8f9b$export$468b008419c9a974(entity, error, options, marks, validate, dispatchAnalyticsEvent);
    };
};
const $c47d3453a61c8f9b$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $c47d3453a61c8f9b$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $c47d3453a61c8f9b$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $c47d3453a61c8f9b$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
   * There's a inconsistency between ProseMirror and ADF.
   * `content` is actually optional in ProseMirror.
   * And, also empty `text` node is not valid.
   */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $c47d3453a61c8f9b$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $c47d3453a61c8f9b$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    if (options.allowUnsupportedBlock) return $c47d3453a61c8f9b$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $c47d3453a61c8f9b$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $c47d3453a61c8f9b$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $c47d3453a61c8f9b$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $c47d3453a61c8f9b$export$87b732fa69cdf16e(child) : validate(child, $c47d3453a61c8f9b$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        if (entity.content.length === 0) return $c47d3453a61c8f9b$export$87b732fa69cdf16e(entity);
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $c47d3453a61c8f9b$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $c47d3453a61c8f9b$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $fSlwM.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $61wF1.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $c47d3453a61c8f9b$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $h4nnH.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $c47d3453a61c8f9b$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent));
    return entity;
};
function $c47d3453a61c8f9b$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});
parcelRegister("h4nnH", function(module, exports) {

$parcel$export(module.exports, "validator", () => $c6d4f26a07058be1$export$956325f45c5d174a);

var $XHGTv = parcelRequire("XHGTv");

var $qpovn = parcelRequire("qpovn");

var $Pn7XZ = parcelRequire("Pn7XZ");

var $efhTg = parcelRequire("efhTg");

var $7T2i7 = parcelRequire("7T2i7");
function $c6d4f26a07058be1$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
           * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
           * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
           */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
const $c6d4f26a07058be1$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Normalizes the structure of files imported form './specs'.
 * We denormalised the spec to save bundle size.
 */ function $c6d4f26a07058be1$var$createSpec(nodes, marks) {
    let _specs = {
        ...$qpovn
    };
    if (!!(0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes')) _specs.inlineCard = (0, $Pn7XZ.inlineCardWithAnnotation);
    return Object.keys(_specs).reduce((newSpecs, k)=>{
        const spec = {
            ..._specs[k]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $efhTg.isString)(spec.props.content)) spec.props.content = _specs[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
           * Flatten
           *
           * Input:
           * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
           *
           * Output:
           * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
           */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $efhTg.isString)(item) ? Array.isArray(_specs[item]) ? _specs[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>Array.isArray(_specs[subItem]) ? _specs[subItem] : (0, $efhTg.isString)(subItem) ? subItem : // Now `NoMark` produces `items: []`, should be fixed in generator
                        [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                var _subItem$, _subItem$$props, _subItem$$props$conte;
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && (_subItem$ = subItem[1]) !== null && _subItem$ !== void 0 && (_subItem$$props = _subItem$.props) !== null && _subItem$$props !== void 0 && (_subItem$$props$conte = _subItem$$props.content) !== null && _subItem$$props$conte !== void 0 && _subItem$$props$conte.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
         * TODO: Probably try something like immer, but it's 3.3kb gzipped.
         * Not worth it just for this.
         */ [
                            subItem[0],
                            $c6d4f26a07058be1$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
function $c6d4f26a07058be1$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $c6d4f26a07058be1$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $c6d4f26a07058be1$export$66c739158ef99a42(spec, value) {
    if (!(0, $efhTg.isDefined)(value)) return !!spec.optional;
    if ($c6d4f26a07058be1$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $c6d4f26a07058be1$var$partitionObject(spec.props, (key, subSpec)=>$c6d4f26a07058be1$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $efhTg.isDefined)(spec.type)) // @ts-expect-error - property 'optional' does not exist on type 'never'
    // This error was introduced after upgrading to TypeScript 5
    return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $efhTg.isBoolean)(value);
        case 'number':
            return (0, $efhTg.isNumber)(value) && ((0, $efhTg.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $efhTg.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $efhTg.isInteger)(value) && ((0, $efhTg.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $efhTg.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $efhTg.isDefined)((0, $7T2i7.validatorFnMap)[rule]) && (0, $7T2i7.validatorFnMap)[rule](value);
            return (0, $efhTg.isString)(value) && ((0, $efhTg.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $efhTg.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $efhTg.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$c6d4f26a07058be1$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$c6d4f26a07058be1$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $efhTg.isString)(value) && spec.values.indexOf(value) > -1;
    }
    return false;
}
const $c6d4f26a07058be1$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $c6d4f26a07058be1$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $c6d4f26a07058be1$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $c6d4f26a07058be1$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message
    }, $c6d4f26a07058be1$var$getUnsupportedOptions(parentSpec));
};
const $c6d4f26a07058be1$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $c6d4f26a07058be1$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $c6d4f26a07058be1$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
function $c6d4f26a07058be1$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $c6d4f26a07058be1$var$createSpec(nodes, marks);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        let newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $c6d4f26a07058be1$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $c6d4f26a07058be1$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $c6d4f26a07058be1$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $c6d4f26a07058be1$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $efhTg.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.props.text) {
            if ((0, $efhTg.isDefined)(prevEntity.text) && !$c6d4f26a07058be1$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.props.content && prevEntity.content) {
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $efhTg.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $efhTg.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $efhTg.makeArray)(validatorSpec.props.attrs);
            /**
       * Attrs can be union type so try each path
       * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
       * Gotcha: It will always report the last failure.
       */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $c6d4f26a07058be1$var$partitionObject(attrOption.props, (key, spec)=>{
                    const valueToValidate = prevEntity.attrs[key];
                    return $c6d4f26a07058be1$export$66c739158ef99a42(spec, valueToValidate);
                });
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $c6d4f26a07058be1$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $c6d4f26a07058be1$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $c6d4f26a07058be1$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, attributes) {
        const message = $c6d4f26a07058be1$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        let invalidValues = {};
        for(let invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $c6d4f26a07058be1$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $c6d4f26a07058be1$var$partitionObject(prevEntity, (k)=>(0, $efhTg.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $efhTg.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        let specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $c6d4f26a07058be1$var$partitionObject(validatorSpec.props, (k, v)=>{
            var _validatorSpec$requir;
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !((_validatorSpec$requir = validatorSpec.required) !== null && _validatorSpec$requir !== void 0 && _validatorSpec$requir.includes(k)) : v.optional;
            return isOptional || (0, $efhTg.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $c6d4f26a07058be1$var$unsupportedMarkContent(mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $efhTg.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $efhTg.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $c6d4f26a07058be1$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
             * When there's multiple possible branches try all of them.
             * If all of them fails, throw the first one.
             * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
             */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $c6d4f26a07058be1$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}

});
parcelRegister("qpovn", function(module, exports) {

$parcel$export(module.exports, "em", () => (parcelRequire("5CvgR")).default);
$parcel$export(module.exports, "code", () => (parcelRequire("kvrJg")).default);
$parcel$export(module.exports, "strike", () => (parcelRequire("5V3et")).default);
$parcel$export(module.exports, "strong", () => (parcelRequire("dSVTs")).default);
$parcel$export(module.exports, "underline", () => (parcelRequire("c2Zci")).default);
$parcel$export(module.exports, "link", () => (parcelRequire("hLPpo")).default);
$parcel$export(module.exports, "subsup", () => (parcelRequire("h0J1T")).default);
$parcel$export(module.exports, "textColor", () => (parcelRequire("25t6G")).default);
$parcel$export(module.exports, "inline_comment_marker", () => (parcelRequire("6L93O")).default);
$parcel$export(module.exports, "breakout", () => (parcelRequire("6mh5o")).default);
$parcel$export(module.exports, "alignment", () => (parcelRequire("2Jedp")).default);
$parcel$export(module.exports, "indentation", () => (parcelRequire("6p4XW")).default);
$parcel$export(module.exports, "annotation", () => (parcelRequire("7YD1X")).default);
$parcel$export(module.exports, "dataConsumer", () => (parcelRequire("hQniP")).default);
$parcel$export(module.exports, "fragment", () => (parcelRequire("f37pl")).default);
$parcel$export(module.exports, "border", () => (parcelRequire("9ffxB")).default);
$parcel$export(module.exports, "backgroundColor", () => (parcelRequire("dnL2E")).default);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("hGit2")).default);
$parcel$export(module.exports, "mention", () => (parcelRequire("fQ5Xy")).default);
$parcel$export(module.exports, "emoji", () => (parcelRequire("guqzJ")).default);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("fb7mx")).default);
$parcel$export(module.exports, "inlineExtension_with_marks", () => (parcelRequire("i4ga6")).default);
$parcel$export(module.exports, "date", () => (parcelRequire("lsy8v")).default);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("fWgTn")).default);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("g8wnv")).default);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("4iKy6")).default);
$parcel$export(module.exports, "status", () => (parcelRequire("3bxMp")).default);
$parcel$export(module.exports, "text", () => (parcelRequire("4vyXM")).default);
$parcel$export(module.exports, "media", () => (parcelRequire("evfCr")).default);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("58BbH")).default);
$parcel$export(module.exports, "formatted_text_inline", () => (parcelRequire("3hPri")).default);
$parcel$export(module.exports, "link_text_inline", () => (parcelRequire("67evi")).default);
$parcel$export(module.exports, "code_inline", () => (parcelRequire("haAG9")).default);
$parcel$export(module.exports, "atomic_inline", () => (parcelRequire("cZQyT")).default);
$parcel$export(module.exports, "inline", () => (parcelRequire("1rxwJ")).default);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("gjrGO")).default);
$parcel$export(module.exports, "paragraph_with_no_marks", () => (parcelRequire("9RRqF")).default);
$parcel$export(module.exports, "paragraph_with_alignment", () => (parcelRequire("cxALc")).default);
$parcel$export(module.exports, "paragraph_with_indentation", () => (parcelRequire("hW0t6")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("372RF")).default);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("aScnO")).default);
$parcel$export(module.exports, "mediaSingle_caption", () => (parcelRequire("6hEV6")).default);
$parcel$export(module.exports, "mediaSingle_full", () => (parcelRequire("16id3")).default);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("8lfOO")).default);
$parcel$export(module.exports, "codeBlock_with_no_marks", () => (parcelRequire("a574W")).default);
$parcel$export(module.exports, "codeBlock_with_marks", () => (parcelRequire("fB8Fn")).default);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("9SJ5W")).default);
$parcel$export(module.exports, "taskList", () => (parcelRequire("9kxoO")).default);
$parcel$export(module.exports, "listItem", () => (parcelRequire("9Ow1a")).default);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("9311Z")).default);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("aGuvj")).default);
$parcel$export(module.exports, "heading", () => (parcelRequire("7WRdF")).default);
$parcel$export(module.exports, "heading_with_no_marks", () => (parcelRequire("zZmox")).default);
$parcel$export(module.exports, "heading_with_alignment", () => (parcelRequire("lxjRr")).default);
$parcel$export(module.exports, "heading_with_indentation", () => (parcelRequire("df30U")).default);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("bgH0j")).default);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("8VH9u")).default);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("dJbsz")).default);
$parcel$export(module.exports, "rule", () => (parcelRequire("7tQBm")).default);
$parcel$export(module.exports, "panel", () => (parcelRequire("lqz5H")).default);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("60AFj")).default);
$parcel$export(module.exports, "extension", () => (parcelRequire("e7oUx")).default);
$parcel$export(module.exports, "extension_with_marks", () => (parcelRequire("iKlOZ")).default);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("gItq5")).default);
$parcel$export(module.exports, "nestedExpand_content", () => (parcelRequire("hgJti")).default);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("ePE4l")).default);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => (parcelRequire("3zqyc")).default);
$parcel$export(module.exports, "table", () => (parcelRequire("hYdAv")).default);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("hxMsn")).default);
$parcel$export(module.exports, "tableCell_content", () => (parcelRequire("CFYqi")).default);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("evCLQ")).default);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("a3Y72")).default);
$parcel$export(module.exports, "non_nestable_block_content", () => (parcelRequire("7NPJ7")).default);
$parcel$export(module.exports, "expand", () => (parcelRequire("egSwn")).default);
$parcel$export(module.exports, "expand_with_no_mark", () => (parcelRequire("2OfPn")).default);
$parcel$export(module.exports, "expand_with_breakout_mark", () => (parcelRequire("7FY5U")).default);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("483OF")).default);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => (parcelRequire("91e3a")).default);
$parcel$export(module.exports, "block_content", () => (parcelRequire("1MYdT")).default);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("2mm8j")).default);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("5AdxK")).default);
$parcel$export(module.exports, "layoutSection_full", () => (parcelRequire("ereNA")).default);
$parcel$export(module.exports, "layoutSection_with_single_column", () => (parcelRequire("5XtBp")).default);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("j1zv8")).default);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("a02Mj")).default);
$parcel$export(module.exports, "doc", () => (parcelRequire("88kpF")).default);
// DO NOT MODIFY THIS FILE, USE `yarn generate:spec`

var $5CvgR = parcelRequire("5CvgR");

var $kvrJg = parcelRequire("kvrJg");

var $5V3et = parcelRequire("5V3et");

var $dSVTs = parcelRequire("dSVTs");

var $c2Zci = parcelRequire("c2Zci");

var $hLPpo = parcelRequire("hLPpo");

var $h0J1T = parcelRequire("h0J1T");

var $25t6G = parcelRequire("25t6G");

var $6L93O = parcelRequire("6L93O");

var $6mh5o = parcelRequire("6mh5o");

var $2Jedp = parcelRequire("2Jedp");

var $6p4XW = parcelRequire("6p4XW");

var $7YD1X = parcelRequire("7YD1X");

var $hQniP = parcelRequire("hQniP");

var $f37pl = parcelRequire("f37pl");

var $9ffxB = parcelRequire("9ffxB");

var $dnL2E = parcelRequire("dnL2E");

var $hGit2 = parcelRequire("hGit2");

var $fQ5Xy = parcelRequire("fQ5Xy");

var $guqzJ = parcelRequire("guqzJ");

var $fb7mx = parcelRequire("fb7mx");

var $i4ga6 = parcelRequire("i4ga6");

var $lsy8v = parcelRequire("lsy8v");

var $fWgTn = parcelRequire("fWgTn");

var $g8wnv = parcelRequire("g8wnv");

var $4iKy6 = parcelRequire("4iKy6");

var $3bxMp = parcelRequire("3bxMp");

var $4vyXM = parcelRequire("4vyXM");

var $evfCr = parcelRequire("evfCr");

var $58BbH = parcelRequire("58BbH");

var $3hPri = parcelRequire("3hPri");

var $67evi = parcelRequire("67evi");

var $haAG9 = parcelRequire("haAG9");

var $cZQyT = parcelRequire("cZQyT");

var $1rxwJ = parcelRequire("1rxwJ");

var $gjrGO = parcelRequire("gjrGO");

var $9RRqF = parcelRequire("9RRqF");

var $cxALc = parcelRequire("cxALc");

var $hW0t6 = parcelRequire("hW0t6");

var $372RF = parcelRequire("372RF");

var $aScnO = parcelRequire("aScnO");

var $6hEV6 = parcelRequire("6hEV6");

var $16id3 = parcelRequire("16id3");

var $8lfOO = parcelRequire("8lfOO");

var $a574W = parcelRequire("a574W");

var $fB8Fn = parcelRequire("fB8Fn");

var $9SJ5W = parcelRequire("9SJ5W");

var $9kxoO = parcelRequire("9kxoO");

var $9Ow1a = parcelRequire("9Ow1a");

var $9311Z = parcelRequire("9311Z");

var $aGuvj = parcelRequire("aGuvj");

var $7WRdF = parcelRequire("7WRdF");

var $zZmox = parcelRequire("zZmox");

var $lxjRr = parcelRequire("lxjRr");

var $df30U = parcelRequire("df30U");

var $bgH0j = parcelRequire("bgH0j");

var $8VH9u = parcelRequire("8VH9u");

var $dJbsz = parcelRequire("dJbsz");

var $7tQBm = parcelRequire("7tQBm");

var $lqz5H = parcelRequire("lqz5H");

var $60AFj = parcelRequire("60AFj");

var $e7oUx = parcelRequire("e7oUx");

var $iKlOZ = parcelRequire("iKlOZ");

var $gItq5 = parcelRequire("gItq5");

var $hgJti = parcelRequire("hgJti");

var $ePE4l = parcelRequire("ePE4l");

var $3zqyc = parcelRequire("3zqyc");

var $hYdAv = parcelRequire("hYdAv");

var $hxMsn = parcelRequire("hxMsn");

var $CFYqi = parcelRequire("CFYqi");

var $evCLQ = parcelRequire("evCLQ");

var $a3Y72 = parcelRequire("a3Y72");

var $7NPJ7 = parcelRequire("7NPJ7");

var $egSwn = parcelRequire("egSwn");

var $2OfPn = parcelRequire("2OfPn");

var $7FY5U = parcelRequire("7FY5U");

var $483OF = parcelRequire("483OF");

var $91e3a = parcelRequire("91e3a");

var $1MYdT = parcelRequire("1MYdT");

var $2mm8j = parcelRequire("2mm8j");

var $5AdxK = parcelRequire("5AdxK");

var $ereNA = parcelRequire("ereNA");

var $5XtBp = parcelRequire("5XtBp");

var $j1zv8 = parcelRequire("j1zv8");

var $a02Mj = parcelRequire("a02Mj");

var $88kpF = parcelRequire("88kpF");

});
parcelRegister("5CvgR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4178c21857952523$export$2e2bcd8739ae039);
var $4178c21857952523$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};

});

parcelRegister("kvrJg", function(module, exports) {

$parcel$export(module.exports, "default", () => $eedc36516d924529$export$2e2bcd8739ae039);
var $eedc36516d924529$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};

});

parcelRegister("5V3et", function(module, exports) {

$parcel$export(module.exports, "default", () => $44f4c889ede34bf9$export$2e2bcd8739ae039);
var $44f4c889ede34bf9$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};

});

parcelRegister("dSVTs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1bd39f59a0fbc6b$export$2e2bcd8739ae039);
var $a1bd39f59a0fbc6b$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};

});

parcelRegister("c2Zci", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c5524797fb10237$export$2e2bcd8739ae039);
var $8c5524797fb10237$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};

});

parcelRegister("hLPpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $cefeb41b76f0bfba$export$2e2bcd8739ae039);
var $cefeb41b76f0bfba$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};

});

parcelRegister("h0J1T", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6255db1a137a22f$export$2e2bcd8739ae039);
var $c6255db1a137a22f$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};

});

parcelRegister("25t6G", function(module, exports) {

$parcel$export(module.exports, "default", () => $1852a06b9d2276ce$export$2e2bcd8739ae039);
var $1852a06b9d2276ce$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};

});

parcelRegister("6L93O", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ebe291a159ce342$export$2e2bcd8739ae039);
var $4ebe291a159ce342$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};

});

parcelRegister("6mh5o", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a120d0cf2840173$export$2e2bcd8739ae039);
var $4a120d0cf2840173$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                }
            }
        }
    }
};

});

parcelRegister("2Jedp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fcacf92ae503fb3$export$2e2bcd8739ae039);
var $1fcacf92ae503fb3$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};

});

parcelRegister("6p4XW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a98edfb40dbd516$export$2e2bcd8739ae039);
var $4a98edfb40dbd516$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};

});

parcelRegister("7YD1X", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cec69a852eb7bf6$export$2e2bcd8739ae039);
var $5cec69a852eb7bf6$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};

});

parcelRegister("hQniP", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfd95e6cfa49dcd8$export$2e2bcd8739ae039);
var $cfd95e6cfa49dcd8$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};

});

parcelRegister("f37pl", function(module, exports) {

$parcel$export(module.exports, "default", () => $af4ce1d66dc875db$export$2e2bcd8739ae039);
var $af4ce1d66dc875db$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    minLength: 1
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};

});

parcelRegister("9ffxB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb191e19cecbe7f$export$2e2bcd8739ae039);
var $6bb191e19cecbe7f$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};

});

parcelRegister("dnL2E", function(module, exports) {

$parcel$export(module.exports, "default", () => $9be1e9d911b50c4e$export$2e2bcd8739ae039);
var $9be1e9d911b50c4e$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};

});

parcelRegister("hGit2", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdf4af21f4db026e$export$2e2bcd8739ae039);
var $cdf4af21f4db026e$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                }
            },
            optional: true
        }
    }
};

});

parcelRegister("fQ5Xy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b88055cc93baeeea$export$2e2bcd8739ae039);
var $b88055cc93baeeea$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                text: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};

});

parcelRegister("guqzJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0140ff8a921801b$export$2e2bcd8739ae039);
var $c0140ff8a921801b$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string',
                    optional: true
                },
                shortName: {
                    type: 'string'
                },
                text: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};

});

parcelRegister("fb7mx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0cd98283f1dab81$export$2e2bcd8739ae039);
var $b0cd98283f1dab81$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};

});

parcelRegister("i4ga6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2752321a99ad297$export$2e2bcd8739ae039);
var $d2752321a99ad297$export$2e2bcd8739ae039 = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true
            }
        }
    }
];

});

parcelRegister("lsy8v", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9f6b1374d1c5adb$export$2e2bcd8739ae039);
var $f9f6b1374d1c5adb$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    type: 'string',
                    minLength: 1
                }
            }
        }
    }
};

});

parcelRegister("fWgTn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9a9603e7f0ad6df$export$2e2bcd8739ae039);
var $b9a9603e7f0ad6df$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                }
            }
        }
    }
};

});

parcelRegister("g8wnv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbf68256901f0175$export$2e2bcd8739ae039);
var $bbf68256901f0175$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl',
                        optional: true
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                type: 'array',
                                items: [
                                    {
                                        props: {
                                            type: {
                                                type: 'string'
                                            },
                                            properties: {
                                                type: 'object',
                                                optional: true
                                            }
                                        }
                                    }
                                ],
                                minItems: 1
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};

});

parcelRegister("4iKy6", function(module, exports) {

$parcel$export(module.exports, "default", () => $321cf389f638aa1d$export$2e2bcd8739ae039);
var $321cf389f638aa1d$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            items: [
                'annotation'
            ],
            optional: true
        }
    },
    required: [
        'attrs'
    ]
};

});

parcelRegister("3bxMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $251c9a2110613d4b$export$2e2bcd8739ae039);
var $251c9a2110613d4b$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string',
                    minLength: 1
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};

});

parcelRegister("4vyXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $34852da1eb73199c$export$2e2bcd8739ae039);
var $34852da1eb73199c$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};

});

parcelRegister("evfCr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8f0139191219a60$export$2e2bcd8739ae039);
var $a8f0139191219a60$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    id: {
                        type: 'string',
                        minLength: 1
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        type: 'string',
                        minLength: 1,
                        optional: true
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    url: {
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ],
            optional: true
        }
    },
    required: [
        'attrs'
    ]
};

});

parcelRegister("58BbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bda8bd4ce9d5ad6$export$2e2bcd8739ae039);
var $3bda8bd4ce9d5ad6$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                data: {
                    type: 'object',
                    optional: true
                },
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                id: {
                    type: 'string',
                    minLength: 1
                },
                collection: {
                    type: 'string'
                },
                height: {
                    type: 'number',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                alt: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ],
            optional: true
        }
    }
};

});

parcelRegister("3hPri", function(module, exports) {

$parcel$export(module.exports, "default", () => $264adc600d1f92d6$export$2e2bcd8739ae039);
var $264adc600d1f92d6$export$2e2bcd8739ae039 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                items: [
                    [
                        'em',
                        'strike',
                        'strong',
                        'underline',
                        'link',
                        'subsup',
                        'textColor',
                        'annotation',
                        'backgroundColor'
                    ]
                ],
                optional: true
            }
        }
    }
];

});

parcelRegister("67evi", function(module, exports) {

$parcel$export(module.exports, "default", () => $473ea5a6d7eb668b$export$2e2bcd8739ae039);
var $473ea5a6d7eb668b$export$2e2bcd8739ae039 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                items: [
                    'link'
                ],
                optional: true
            }
        }
    }
];

});

parcelRegister("haAG9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7ffd28502322e9b$export$2e2bcd8739ae039);
var $c7ffd28502322e9b$export$2e2bcd8739ae039 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ],
                optional: true
            }
        }
    }
];

});

parcelRegister("cZQyT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9763f43231932da0$export$2e2bcd8739ae039);
var $9763f43231932da0$export$2e2bcd8739ae039 = [
    'hardBreak',
    'mention',
    'emoji',
    'inlineExtension_with_marks',
    'date',
    'placeholder',
    'inlineCard',
    'status',
    'mediaInline'
];

});

parcelRegister("1rxwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $10d251d509bcdce5$export$2e2bcd8739ae039);
var $10d251d509bcdce5$export$2e2bcd8739ae039 = [
    'hardBreak',
    'mention',
    'emoji',
    'inlineExtension_with_marks',
    'date',
    'placeholder',
    'inlineCard',
    'status',
    'mediaInline',
    'formatted_text_inline',
    'code_inline'
];

});

parcelRegister("gjrGO", function(module, exports) {

$parcel$export(module.exports, "default", () => $be03e63db7f91e78$export$2e2bcd8739ae039);
var $be03e63db7f91e78$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        content: {
            type: 'array',
            items: [
                'inline'
            ],
            allowUnsupportedInline: true,
            optional: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        },
        attrs: {
            optional: true,
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};

});

parcelRegister("9RRqF", function(module, exports) {

$parcel$export(module.exports, "default", () => $72f2822e0d43778c$export$2e2bcd8739ae039);
var $72f2822e0d43778c$export$2e2bcd8739ae039 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                items: [],
                maxItems: 0,
                optional: true
            }
        }
    }
];

});

parcelRegister("cxALc", function(module, exports) {

$parcel$export(module.exports, "default", () => $921514f235abea05$export$2e2bcd8739ae039);
var $921514f235abea05$export$2e2bcd8739ae039 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                items: [
                    'alignment'
                ],
                optional: true
            }
        }
    }
];

});

parcelRegister("hW0t6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0e8377cbe0c3d21$export$2e2bcd8739ae039);
var $d0e8377cbe0c3d21$export$2e2bcd8739ae039 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                items: [
                    'indentation'
                ],
                optional: true
            }
        }
    }
];

});

parcelRegister("372RF", function(module, exports) {

$parcel$export(module.exports, "default", () => $24443f60ff79436f$export$2e2bcd8739ae039);
var $24443f60ff79436f$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'formatted_text_inline',
                    'code_inline'
                ]
            ],
            minItems: 0,
            allowUnsupportedInline: true
        }
    }
};

});

parcelRegister("aScnO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ea88d8a08c5e8bb$export$2e2bcd8739ae039);
var $7ea88d8a08c5e8bb$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    },
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            },
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            items: [
                'link'
            ],
            optional: true
        }
    }
};

});

parcelRegister("6hEV6", function(module, exports) {

$parcel$export(module.exports, "default", () => $493412748e4d7c03$export$2e2bcd8739ae039);
var $493412748e4d7c03$export$2e2bcd8739ae039 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media',
                    'caption'
                ],
                isTupleLike: true,
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];

});

parcelRegister("16id3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cd479ff534895c7$export$2e2bcd8739ae039);
var $0cd479ff534895c7$export$2e2bcd8739ae039 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];

});

parcelRegister("8lfOO", function(module, exports) {

$parcel$export(module.exports, "default", () => $612c8e21299122f2$export$2e2bcd8739ae039);
var $612c8e21299122f2$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'text',
                    {
                        props: {
                            marks: {
                                type: 'array',
                                items: [],
                                maxItems: 0,
                                optional: true
                            }
                        }
                    }
                ]
            ],
            allowUnsupportedInline: true,
            optional: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        }
    }
};

});

parcelRegister("a574W", function(module, exports) {

$parcel$export(module.exports, "default", () => $756fdcb6e19a53f4$export$2e2bcd8739ae039);
var $756fdcb6e19a53f4$export$2e2bcd8739ae039 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                items: [],
                maxItems: 0,
                optional: true
            }
        }
    }
];

});

parcelRegister("fB8Fn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5b108b24e237dfb$export$2e2bcd8739ae039);
var $b5b108b24e237dfb$export$2e2bcd8739ae039 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                items: [
                    'breakout'
                ],
                optional: true
            }
        }
    }
];

});

parcelRegister("9SJ5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $731c231edc55cee7$export$2e2bcd8739ae039);
var $731c231edc55cee7$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        content: {
            type: 'array',
            items: [
                'inline'
            ],
            allowUnsupportedInline: true,
            optional: true
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        }
    }
};

});

parcelRegister("9kxoO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cafe3b1856fee9a$export$2e2bcd8739ae039);
var $6cafe3b1856fee9a$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        content: {
            type: 'array',
            items: [
                'taskItem',
                [
                    'taskItem',
                    'taskList'
                ]
            ],
            isTupleLike: true,
            minItems: 1,
            allowUnsupportedBlock: true
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        }
    }
};

});

parcelRegister("9Ow1a", function(module, exports) {

$parcel$export(module.exports, "default", () => $72519ea3aa9bbf24$export$2e2bcd8739ae039);
var $72519ea3aa9bbf24$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks',
                    'taskList',
                    'bulletList',
                    'orderedList'
                ]
            ],
            isTupleLike: true,
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};

});

parcelRegister("9311Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $696531a34ac95836$export$2e2bcd8739ae039);
var $696531a34ac95836$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        content: {
            type: 'array',
            items: [
                'listItem'
            ],
            minItems: 1
        }
    }
};

});

parcelRegister("aGuvj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c757d1bf88e5b14$export$2e2bcd8739ae039);
var $7c757d1bf88e5b14$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        content: {
            type: 'array',
            items: [
                'listItem'
            ],
            minItems: 1
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                }
            },
            optional: true
        }
    }
};

});

parcelRegister("7WRdF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c973b727cc58b47$export$2e2bcd8739ae039);
var $5c973b727cc58b47$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        content: {
            type: 'array',
            items: [
                'inline'
            ],
            allowUnsupportedInline: true,
            optional: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};

});

parcelRegister("zZmox", function(module, exports) {

$parcel$export(module.exports, "default", () => $06c2dddb86943970$export$2e2bcd8739ae039);
var $06c2dddb86943970$export$2e2bcd8739ae039 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                items: [],
                maxItems: 0,
                optional: true
            }
        }
    }
];

});

parcelRegister("lxjRr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fadc15ffb61794fa$export$2e2bcd8739ae039);
var $fadc15ffb61794fa$export$2e2bcd8739ae039 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                items: [
                    'alignment'
                ],
                optional: true
            }
        }
    }
];

});

parcelRegister("df30U", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a3f038153e11dd2$export$2e2bcd8739ae039);
var $9a3f038153e11dd2$export$2e2bcd8739ae039 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                items: [
                    'indentation'
                ],
                optional: true
            }
        }
    }
];

});

parcelRegister("bgH0j", function(module, exports) {

$parcel$export(module.exports, "default", () => $83428c04e6285d98$export$2e2bcd8739ae039);
var $83428c04e6285d98$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};

});

parcelRegister("8VH9u", function(module, exports) {

$parcel$export(module.exports, "default", () => $68051eb6f5a9d5e8$export$2e2bcd8739ae039);
var $68051eb6f5a9d5e8$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        content: {
            type: 'array',
            items: [
                'inline'
            ],
            allowUnsupportedInline: true,
            optional: true
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        }
    }
};

});

parcelRegister("dJbsz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fe85e031d34c9c5$export$2e2bcd8739ae039);
var $9fe85e031d34c9c5$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        }
    }
};

});

parcelRegister("7tQBm", function(module, exports) {

$parcel$export(module.exports, "default", () => $57240b6d79dbda9e$export$2e2bcd8739ae039);
var $57240b6d79dbda9e$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};

});

parcelRegister("lqz5H", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9973f0334f5d032$export$2e2bcd8739ae039);
var $f9973f0334f5d032$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'mediaGroup',
                    'decisionList',
                    'rule'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};

});

parcelRegister("60AFj", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ff2f273de97d99$export$2e2bcd8739ae039);
var $45ff2f273de97d99$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};

});

parcelRegister("e7oUx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4750ae6575312e8$export$2e2bcd8739ae039);
var $a4750ae6575312e8$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};

});

parcelRegister("iKlOZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $da5d732c80d14e18$export$2e2bcd8739ae039);
var $da5d732c80d14e18$export$2e2bcd8739ae039 = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true
            }
        }
    }
];

});

parcelRegister("gItq5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2b793920f09da7a$export$2e2bcd8739ae039);
var $c2b793920f09da7a$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                originalWidth: {
                    type: 'number',
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100,
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                }
            }
        }
    }
};

});

parcelRegister("hgJti", function(module, exports) {

$parcel$export(module.exports, "default", () => $c92733f9c3a46dcf$export$2e2bcd8739ae039);
var $c92733f9c3a46dcf$export$2e2bcd8739ae039 = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'codeBlock_with_no_marks',
            'taskList',
            'bulletList',
            'orderedList',
            'heading_with_no_marks',
            'mediaGroup',
            'decisionList',
            'rule',
            'panel',
            'blockquote'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};

});

parcelRegister("ePE4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $acc4e90004de8ac2$export$2e2bcd8739ae039);
var $acc4e90004de8ac2$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};

});

parcelRegister("3zqyc", function(module, exports) {

$parcel$export(module.exports, "default", () => $29993c5f2b56301a$export$2e2bcd8739ae039);
var $29993c5f2b56301a$export$2e2bcd8739ae039 = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                items: [],
                maxItems: 0,
                optional: true
            }
        }
    }
];

});

parcelRegister("hYdAv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d15294826e0e2e60$export$2e2bcd8739ae039);
var $d15294826e0e2e60$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            items: [
                'fragment'
            ],
            optional: true
        }
    }
};

});

parcelRegister("hxMsn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc5b1b358b1e2d16$export$2e2bcd8739ae039);
var $cc5b1b358b1e2d16$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};

});

parcelRegister("CFYqi", function(module, exports) {

$parcel$export(module.exports, "default", () => $07441bcd0387ba0f$export$2e2bcd8739ae039);
var $07441bcd0387ba0f$export$2e2bcd8739ae039 = {
    type: 'array',
    items: [
        [
            'blockCard',
            'paragraph_with_no_marks',
            'paragraph_with_alignment',
            'mediaSingle_caption',
            'mediaSingle_full',
            'codeBlock_with_no_marks',
            'taskList',
            'bulletList',
            'orderedList',
            'heading_with_no_marks',
            'heading_with_alignment',
            'heading_with_indentation',
            'mediaGroup',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks',
            'embedCard',
            'nestedExpand_with_no_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};

});

parcelRegister("evCLQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a90209037282e792$export$2e2bcd8739ae039);
var $a90209037282e792$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: 'tableCell_content'
    },
    required: [
        'content'
    ]
};

});

parcelRegister("a3Y72", function(module, exports) {

$parcel$export(module.exports, "default", () => $7538d0473ceb8615$export$2e2bcd8739ae039);
var $7538d0473ceb8615$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: 'tableCell_content'
    },
    required: [
        'content'
    ]
};

});

parcelRegister("7NPJ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae53bdbcb9f49bb$export$2e2bcd8739ae039);
var $5ae53bdbcb9f49bb$export$2e2bcd8739ae039 = [
    'blockCard',
    'paragraph_with_no_marks',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock_with_no_marks',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table'
];

});

parcelRegister("egSwn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a63cda1994de0b93$export$2e2bcd8739ae039);
var $a63cda1994de0b93$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};

});

parcelRegister("2OfPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $20bc87552ef34d29$export$2e2bcd8739ae039);
var $20bc87552ef34d29$export$2e2bcd8739ae039 = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                items: [],
                maxItems: 0,
                optional: true
            }
        }
    }
];

});

parcelRegister("7FY5U", function(module, exports) {

$parcel$export(module.exports, "default", () => $596afa33699e45e5$export$2e2bcd8739ae039);
var $596afa33699e45e5$export$2e2bcd8739ae039 = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                items: [
                    'breakout'
                ],
                optional: true
            }
        }
    }
];

});

parcelRegister("483OF", function(module, exports) {

$parcel$export(module.exports, "default", () => $301ade9b40ea5e3c$export$2e2bcd8739ae039);
var $301ade9b40ea5e3c$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};

});

parcelRegister("91e3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $690f1b1ba568aac8$export$2e2bcd8739ae039);
var $690f1b1ba568aac8$export$2e2bcd8739ae039 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true
            }
        }
    }
];

});

parcelRegister("1MYdT", function(module, exports) {

$parcel$export(module.exports, "default", () => $14d8fd2e4bb2810a$export$2e2bcd8739ae039);
var $14d8fd2e4bb2810a$export$2e2bcd8739ae039 = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock_with_no_marks',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand_with_no_mark',
    'bodiedExtension_with_marks'
];

});

parcelRegister("2mm8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b7ece08d5ddd982$export$2e2bcd8739ae039);
var $1b7ece08d5ddd982$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};

});

parcelRegister("5AdxK", function(module, exports) {

$parcel$export(module.exports, "default", () => $410ad1f2cb100e45$export$2e2bcd8739ae039);
var $410ad1f2cb100e45$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        marks: {
            type: 'array',
            items: [
                'breakout'
            ],
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ]
        }
    }
};

});

parcelRegister("ereNA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a82f110380ac4eb6$export$2e2bcd8739ae039);
var $a82f110380ac4eb6$export$2e2bcd8739ae039 = [
    'layoutSection',
    {
        props: {
            type: {
                type: 'enum',
                values: [
                    'layoutSection'
                ]
            },
            marks: {
                type: 'array',
                items: [
                    'breakout'
                ],
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            }
        }
    }
];

});

parcelRegister("5XtBp", function(module, exports) {

$parcel$export(module.exports, "default", () => $45696cd8ea432a16$export$2e2bcd8739ae039);
var $45696cd8ea432a16$export$2e2bcd8739ae039 = [
    'layoutSection',
    {
        props: {
            type: {
                type: 'enum',
                values: [
                    'layoutSection'
                ]
            },
            marks: {
                type: 'array',
                items: [
                    'breakout'
                ],
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 3,
                allowUnsupportedBlock: true
            }
        }
    }
];

});

parcelRegister("j1zv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd99a619a5eada6e$export$2e2bcd8739ae039);
var $dd99a619a5eada6e$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'bodiedExtension_with_marks'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ],
            optional: true
        }
    }
};

});

parcelRegister("a02Mj", function(module, exports) {

$parcel$export(module.exports, "default", () => $747c0f2d74172c8d$export$2e2bcd8739ae039);
var $747c0f2d74172c8d$export$2e2bcd8739ae039 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        }
    }
};

});

parcelRegister("88kpF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ebee7a9bd2e3fb2$export$2e2bcd8739ae039);
var $5ebee7a9bd2e3fb2$export$2e2bcd8739ae039 = {
    props: {
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks',
                    'codeBlock_with_marks',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand_with_no_mark',
                    'expand_with_breakout_mark',
                    'bodiedExtension_with_marks',
                    'layoutSection_full',
                    'layoutSection_with_single_column',
                    'multiBodiedExtension'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};

});


parcelRegister("Pn7XZ", function(module, exports) {

$parcel$export(module.exports, "inlineCardWithAnnotation", () => $09a6b42c69e33a0a$export$58886a4e61d53f17);
// This is a custom spec we're using for inline card till the inline comments feature is fully rolled out.
const $09a6b42c69e33a0a$export$58886a4e61d53f17 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            items: [
                'annotation'
            ],
            optional: true
        }
    },
    required: [
        'attrs'
    ]
};

});

parcelRegister("efhTg", function(module, exports) {

$parcel$export(module.exports, "isDefined", () => $02ad2ab5fc71c277$export$4e62c701997796c1);
$parcel$export(module.exports, "isNumber", () => $02ad2ab5fc71c277$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $02ad2ab5fc71c277$export$a287f47fed4544b8);
$parcel$export(module.exports, "isBoolean", () => $02ad2ab5fc71c277$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $02ad2ab5fc71c277$export$844ec244b1367d54);
$parcel$export(module.exports, "isPlainObject", () => $02ad2ab5fc71c277$export$53b83ca8eaab0383);
$parcel$export(module.exports, "copy", () => $02ad2ab5fc71c277$export$784d13d8ee351f07);
$parcel$export(module.exports, "makeArray", () => $02ad2ab5fc71c277$export$7b85fd78dd236198);
const $02ad2ab5fc71c277$export$4e62c701997796c1 = (x)=>x != null;
const $02ad2ab5fc71c277$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $02ad2ab5fc71c277$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $02ad2ab5fc71c277$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $02ad2ab5fc71c277$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $02ad2ab5fc71c277$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $02ad2ab5fc71c277$export$784d13d8ee351f07 = (source, dest, key)=>{
    dest[key] = source[key];
    return dest;
};
const $02ad2ab5fc71c277$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("7T2i7", function(module, exports) {

$parcel$export(module.exports, "validatorFnMap", () => $5bdf727142dfc446$export$d1b377ca77ac267d);

var $4N6cH = parcelRequire("4N6cH");
const $5bdf727142dfc446$export$d1b377ca77ac267d = {
    safeUrl: (0, $4N6cH.isSafeUrl)
};

});



parcelRegister("gAoAo", function(module, exports) {

$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $c13314632a3bdebf$export$a43de96edd8d0a0);

var $d0kCm = parcelRequire("d0kCm");
var $jvBwu = parcelRequire("jvBwu");

var $61wF1 = parcelRequire("61wF1");

var $1lWyd = parcelRequire("1lWyd");
let $c13314632a3bdebf$var$rendersMap = {};
const $c13314632a3bdebf$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $jvBwu.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $61wF1.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $61wF1.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $d0kCm.getAnalyticsAppearance)(item.appearance),
                platform: (0, $1lWyd.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $61wF1.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $61wF1.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $61wF1.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $1lWyd.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $61wF1.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $c13314632a3bdebf$var$schedule = (fn)=>{
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $c13314632a3bdebf$var$DEFAULT_SAMPLING_RATE = 100;
const $c13314632a3bdebf$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    var _item$appearance;
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = (_item$appearance = item.appearance) !== null && _item$appearance !== void 0 ? _item$appearance : 'unknown';
    if (!$c13314632a3bdebf$var$rendersMap[appearance]) $c13314632a3bdebf$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $c13314632a3bdebf$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $c13314632a3bdebf$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $c13314632a3bdebf$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($c13314632a3bdebf$var$rendersMap[appearance].size === 1) $c13314632a3bdebf$var$schedule(()=>$c13314632a3bdebf$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($c13314632a3bdebf$var$rendersMap[appearance].size % sampleRate === 0) $c13314632a3bdebf$var$rendersMap[appearance] = new Set();
};

});

parcelRegister("cVUdI", function(module, exports) {

$parcel$export(module.exports, "transformMediaLinkMarks", () => $96a66b0bfe687be9$export$6528700f3fa2fe2a);

var $fkCu1 = parcelRequire("fkCu1");
const $96a66b0bfe687be9$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $fkCu1.traverse)(adf, {
        mediaSingle: (node)=>{
            var _node$content$;
            if (!node.marks || !node.content || ((_node$content$ = node.content[0]) === null || _node$content$ === void 0 ? void 0 : _node$content$.type) !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    var _node$marks;
                    linkMark = mark;
                    (_node$marks = node.marks) === null || _node$marks === void 0 || _node$marks.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                var _mediaNode$marks;
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if ((_mediaNode$marks = mediaNode.marks) !== null && _mediaNode$marks !== void 0 && _mediaNode$marks.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});


parcelRegister("9zF93", function(module, exports) {

$parcel$export(module.exports, "TruncatedWrapper", () => $6f874c7f02bd7164$export$79ad592494094f07);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");
const $6f874c7f02bd7164$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>(0, $byn9U.css)`
  position: relative;
  overflow-y: hidden;
  max-height: ${maxHeight}px;
  &::after {
    content: '';
    position: absolute;
    top: ${top}px;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: linear-gradient(
      ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"},
      ${backgroundColor}
    );
  }
`;
const $6f874c7f02bd7164$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $6f874c7f02bd7164$var$fadeOutStyles(height, top, backgroundColor);
    return (0, $byn9U.jsx)("div", {
        css: styles
    }, children);
};
class $6f874c7f02bd7164$export$79ad592494094f07 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
    }
    // TODO: Quality ticket as elevation.surface will be issue when sits top of modal. https://product-fabric.atlassian.net/browse/DSP-4123
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, white)", children: children } = this.props;
        return (0, $byn9U.jsx)($6f874c7f02bd7164$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
}

});

parcelRegister("9HS7I", function(module, exports) {

$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $71121d035d3a2ecd$export$cfc1361be0de4203);

var $eUqFw = parcelRequire("eUqFw");

var $khES4 = parcelRequire("khES4");
function $71121d035d3a2ecd$export$cfc1361be0de4203() {
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) return null;
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    const context = $71121d035d3a2ecd$export$92859d13f30c883e(id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("script", {
        "data-breakout-script-id": id,
        dangerouslySetInnerHTML: {
            __html: context
        }
    });
}
function $71121d035d3a2ecd$export$92859d13f30c883e(id) {
    return `
  (function(window){
    ${$71121d035d3a2ecd$export$47813c4121c8b4b3};
    (${$71121d035d3a2ecd$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts);
  })(window);
`;
}
const $71121d035d3a2ecd$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $khES4.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $khES4.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $khES4.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $khES4.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $khES4.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $khES4.breakoutConsts).calcWideWidth.toString()};
`;
function $71121d035d3a2ecd$var$applyBreakoutAfterSSR(id, breakoutConsts) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(document.querySelector('[data-breakout-script-id="' + id + '"]'), (elem)=>{
        var _elem$parentElement;
        return !!((_elem$parentElement = elem.parentElement) !== null && _elem$parentElement !== void 0 && _elem$parentElement.classList.contains('ak-renderer-wrapper'));
    });
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode)) return;
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    const effectiveWidth = renderer.offsetWidth - breakoutConsts.padding;
                    width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                } else width = breakoutConsts.calcBreakoutWidth(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && !renderer.classList.contains('is-full-width')) {
                    const lineLength = breakoutConsts.calcLineLength();
                    const left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
       * The mutation observer is only called once per added node.
       * The above condition only deals with direct children of <div class="ak-renderer-document" />
       * When it is initially called on the direct children, not all the sub children have loaded.
       * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
       * Thus adding this conditional to deal with all media elements directly.
       */ item.target.dataset.nodeType === MEDIA_NODE_TYPE) applyMediaBreakout(item.target);
        });
    });
    const applyMediaBreakout = (card)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width && !isPixelBasedResizing) // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override for non-wide layouts
        card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
   * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
   * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
   * That's why window load is necessary.
   *
   * More info:
   * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
   * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
   * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
   */ const disconnect = ()=>{
        observer.disconnect();
        window.removeEventListener('load', disconnect);
    };
    window.addEventListener('load', disconnect);
}
const $71121d035d3a2ecd$export$2a0b3eeee3f2ea40 = (0, $khES4.breakoutConsts).calcLineLength;

});

parcelRegister("a896o", function(module, exports) {

$parcel$export(module.exports, "RendererContext", () => $7601b63d7a10fb79$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $7601b63d7a10fb79$export$66feffbad722f9d4);

var $eUqFw = parcelRequire("eUqFw");

var $bM1iq = parcelRequire("bM1iq");
const $7601b63d7a10fb79$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(new (0, $bM1iq.default)());
function $7601b63d7a10fb79$export$66feffbad722f9d4({ children: children, context: context }) {
    const actions = (0, $eUqFw.useMemo)(()=>new (0, $bM1iq.default)(true), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7601b63d7a10fb79$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(children));
}
const $7601b63d7a10fb79$export$d5fcf151601331bc = $7601b63d7a10fb79$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("bM1iq", function(module, exports) {

$parcel$export(module.exports, "default", () => $89252eca07f8fe77$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $8450v = parcelRequire("8450v");

var $2ydpv = parcelRequire("2ydpv");

var $ht6w1 = parcelRequire("ht6w1");

var $d6JJW = parcelRequire("d6JJW");

var $1ktt3 = parcelRequire("1ktt3");

var $61wF1 = parcelRequire("61wF1");

var $kkakk = parcelRequire("kkakk");
class $89252eca07f8fe77$export$2e2bcd8739ae039 {
    // Any kind of refence is allowed
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        (0, $5zQU9.default)(this, "initFromContext", false);
        this.initFromContext = initFromContext;
        this.transformer = new (0, $8450v.JSONTransformer)();
    }
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
   * Validate whether we can create an annotation between two positions
   */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) return false;
        return (0, $2ydpv.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $d6JJW.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $d6JJW.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $61wF1.ACTION).DELETED,
                actionSubject: (0, $61wF1.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $61wF1.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $61wF1.EVENT_TYPE).TRACK
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $1ktt3.getPosFromRange)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        const pos = (0, $1ktt3.getPosFromRange)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $1ktt3.getPosFromRange)(range);
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $1ktt3.getPosFromRange)(range);
        if (!pos || !this.doc) return [];
        return (0, $2ydpv.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        // If from points to a node position,
        // we need to 1 position before it for nodeAt to return the node itself
        const beforeNodePos = Math.max(from - 1, 0);
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if ((possibleNode === null || possibleNode === void 0 ? void 0 : possibleNode.type.name) === 'media') step = new (0, $d6JJW.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
            id: annotationId,
            type: annotationType
        }));
        else step = (0, $1ktt3.createAnnotationStep)(from, to, {
            annotationId: annotationId,
            annotationType: annotationType,
            schema: this.schema
        });
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) return false;
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $kkakk.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $kkakk.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
}

});
parcelRegister("2ydpv", function(module, exports) {

$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $1db928ca6e090c6e$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $1db928ca6e090c6e$export$badbcc229c848aec);
$parcel$export(module.exports, "hasAnnotationMark", () => $1db928ca6e090c6e$export$5fe1412b20386053);
$parcel$export(module.exports, "containsAnyAnnotations", () => $1db928ca6e090c6e$export$1976770b876b2728);

var $XHGTv = parcelRequire("XHGTv");
const $1db928ca6e090c6e$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    const { inlineCard: inlineCard } = schema.nodes;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes')) {
            if (node.isInline && !node.isText && node.type !== inlineCard || node.isLeaf && !node.isText && node.type !== inlineCard || node.isText && !(parent !== null && parent !== void 0 && parent.type.allowsMarkType(schema.marks.annotation))) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !(parent !== null && parent !== void 0 && parent.type.allowsMarkType(schema.marks.annotation))) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $1db928ca6e090c6e$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    let annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $1db928ca6e090c6e$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $1db928ca6e090c6e$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $1db928ca6e090c6e$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($1db928ca6e090c6e$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}

});

parcelRegister("1ktt3", function(module, exports) {

$parcel$export(module.exports, "getPosFromRange", () => $0f7e8461e04d89a9$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $0f7e8461e04d89a9$export$74899f7e5acb5cd3);

var $d6JJW = parcelRequire("d6JJW");
function $0f7e8461e04d89a9$var$getStartPos(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $0f7e8461e04d89a9$var$getNodeType = (element)=>element.dataset.nodeType;
function $0f7e8461e04d89a9$var$isPositionPointer(element) {
    return $0f7e8461e04d89a9$var$getStartPos(element) > -1;
}
function $0f7e8461e04d89a9$var$findParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $0f7e8461e04d89a9$var$isRoot(parentElement)) return null;
    if ($0f7e8461e04d89a9$var$isPositionPointer(parentElement)) return parentElement;
    return $0f7e8461e04d89a9$var$findParent(parentElement);
}
function $0f7e8461e04d89a9$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($0f7e8461e04d89a9$var$isRoot(parentElement) || !parentElement) return null;
    if ($0f7e8461e04d89a9$var$isPositionPointer(parentElement)) return element;
    return $0f7e8461e04d89a9$var$findParentBeforePointer(parentElement);
}
function $0f7e8461e04d89a9$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $0f7e8461e04d89a9$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $0f7e8461e04d89a9$var$isHighlightTextNode(node) {
    var _dataset;
    return !!(node !== null && node !== void 0 && (_dataset = node.dataset) !== null && _dataset !== void 0 && _dataset.highlighted);
}
function $0f7e8461e04d89a9$var$isNodeInlineMark(node) {
    return $0f7e8461e04d89a9$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $0f7e8461e04d89a9$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $0f7e8461e04d89a9$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if (prev && ($0f7e8461e04d89a9$var$isTextNode(prev) || $0f7e8461e04d89a9$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ($0f7e8461e04d89a9$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $0f7e8461e04d89a9$var$isRoot(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $0f7e8461e04d89a9$export$5db587db55468da7(node, offset) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if (node instanceof HTMLElement && $0f7e8461e04d89a9$var$isPositionPointer(node)) return $0f7e8461e04d89a9$var$getStartPos(node) + offset;
    const parent = $0f7e8461e04d89a9$var$findParent(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $0f7e8461e04d89a9$var$getStartPos(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $0f7e8461e04d89a9$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if (!($0f7e8461e04d89a9$var$isElementInlineMark(preParentPointer) || $0f7e8461e04d89a9$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $0f7e8461e04d89a9$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) resolvedPos += $0f7e8461e04d89a9$var$resolveNodePos(current);
        }
    } else resolvedPos += $0f7e8461e04d89a9$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $0f7e8461e04d89a9$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const parent = $0f7e8461e04d89a9$var$findParent(startContainer);
    if (parent && $0f7e8461e04d89a9$var$getNodeType(parent) === 'media') {
        const pos = $0f7e8461e04d89a9$var$getStartPos(parent);
        return {
            from: pos,
            to: pos
        };
    }
    const from = $0f7e8461e04d89a9$export$5db587db55468da7(startContainer, startOffset);
    const to = $0f7e8461e04d89a9$export$5db587db55468da7(endContainer, endOffset);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $0f7e8461e04d89a9$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $d6JJW.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("kkakk", function(module, exports) {

$parcel$export(module.exports, "getIndexMatch", () => $ecbdaf9bc89867f4$export$fb7dab895a0d310e);
// getIndexMatch finds the position of a given string within a given document, in accordance to the Confluence Annotation backend
// The document is serialised into one large string, excluding any nodes that can not have annotations (eg: emojis, media).
// Finds where the given query string is relative to the serialised partial document
function $ecbdaf9bc89867f4$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $ecbdaf9bc89867f4$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $ecbdaf9bc89867f4$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $ecbdaf9bc89867f4$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});



parcelRegister("hRqg3", function(module, exports) {

$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $d00bc1303c28b659$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $d00bc1303c28b659$export$cddc3c6ebe2d2cec);

var $eUqFw = parcelRequire("eUqFw");
const { Provider: $d00bc1303c28b659$export$20439b49fdd0d26c, Consumer: $d00bc1303c28b659$var$Consumer } = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(undefined);
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $d00bc1303c28b659$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $eUqFw.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d00bc1303c28b659$var$Consumer, null, (newActiveHeaderId)=>{
        if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
        else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
            setActiveHeaderId(newActiveHeaderId);
            onNestedHeaderIdMatch();
        }
        return null;
    });
};

});

parcelRegister("ifL1l", function(module, exports) {

$parcel$export(module.exports, "AnnotationsWrapper", () => $d49e1a08ed15f1f2$export$cef0157dd42cbb3f);

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");

var $gQ7j1 = parcelRequire("gQ7j1");

var $gLaL3 = parcelRequire("gLaL3");

var $8nCeg = parcelRequire("8nCeg");

var $cVAep = parcelRequire("cVAep");

var $elo3y = parcelRequire("elo3y");

var $bFzGY = parcelRequire("bFzGY");

var $gVdCG = parcelRequire("gVdCG");

var $38FsY = parcelRequire("38FsY");

var $c0YBv = parcelRequire("c0YBv");
const $d49e1a08ed15f1f2$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ adfDocument: adfDocument })=>{
    (0, $cVAep.useLoadAnnotations)({
        adfDocument: adfDocument
    });
    return null;
});
const $d49e1a08ed15f1f2$export$cef0157dd42cbb3f = (props)=>{
    var _annotationProvider$i, _annotationProvider$i2;
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument } = props;
    const updateSubscriber = annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $elo3y.useAnnotationStateByTypeEvent)({
        type: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nCeg.ProvidersContext).Provider, {
        value: annotationProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nCeg.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gVdCG.AnnotationRangeProvider), {
        allowCommentsOnMedia: (_annotationProvider$i = annotationProvider === null || annotationProvider === void 0 ? void 0 : (_annotationProvider$i2 = annotationProvider.inlineComment) === null || _annotationProvider$i2 === void 0 ? void 0 : _annotationProvider$i2.allowCommentsOnMedia) !== null && _annotationProvider$i !== void 0 ? _annotationProvider$i : false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLaL3.AnnotationsContextWrapper), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d49e1a08ed15f1f2$var$LoadAnnotations, {
        adfDocument: adfDocument
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQ7j1.AnnotationView), {
        createAnalyticsEvent: createAnalyticsEvent
    }), children))));
};

});
parcelRegister("gQ7j1", function(module, exports) {

$parcel$export(module.exports, "AnnotationView", () => $c4272b722586cbad$export$41cd4a02859c2806);

var $eUqFw = parcelRequire("eUqFw");

var $8nCeg = parcelRequire("8nCeg");

var $elo3y = parcelRequire("elo3y");

var $a896o = parcelRequire("a896o");
const $c4272b722586cbad$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $eUqFw.useContext)((0, $8nCeg.ProvidersContext));
    const actionContext = (0, $eUqFw.useContext)((0, $a896o.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $elo3y.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $eUqFw.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation
        });
    }
    return null;
};

});

parcelRegister("gLaL3", function(module, exports) {

$parcel$export(module.exports, "AnnotationsContextWrapper", () => $c3396173de4f303a$export$787af8a111ff3c03);

var $eUqFw = parcelRequire("eUqFw");

var $8nCeg = parcelRequire("8nCeg");

var $e3SrA = parcelRequire("e3SrA");

var $cshwc = parcelRequire("cshwc");

var $gVdCG = parcelRequire("gVdCG");
const $c3396173de4f303a$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $eUqFw.useContext)((0, $8nCeg.ProvidersContext));
    const { range: range, type: type } = (0, $gVdCG.useAnnotationRangeState)();
    const { setDraftRange: setDraftRange, clearDraftRange: clearDraftRange } = (0, $gVdCG.useAnnotationRangeDispatch)();
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    // We want to set the draft to the range the user highlighted
    const setRangeForDraft = (0, $eUqFw.useCallback)(()=>{
        setDraftRange(range, type);
    }, [
        range,
        setDraftRange,
        type
    ]);
    const clearRangeForDraft = (0, $eUqFw.useCallback)(()=>{
        clearDraftRange(type);
    }, [
        type,
        clearDraftRange
    ]);
    const render = (0, $eUqFw.useCallback)(({ applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children, !!hoverComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e3SrA.RangeValidator), {
            createAnalyticsEvent: createAnalyticsEvent,
            rendererRef: rendererRef,
            component: hoverComponent,
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            clearAnnotationDraft: clearAnnotationDraft
        }), !!selectionComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cshwc.SelectionRangeValidator), {
            createAnalyticsEvent: createAnalyticsEvent,
            rendererRef: rendererRef,
            selectionComponent: selectionComponent,
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            clearAnnotationDraft: clearAnnotationDraft
        }));
    }, [
        hoverComponent,
        selectionComponent,
        children,
        rendererRef,
        createAnalyticsEvent
    ]);
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nCeg.AnnotationsDraftContextWrapper), {
        setDraftRange: setRangeForDraft,
        clearDraftRange: clearRangeForDraft
    }, render);
};

});
parcelRegister("e3SrA", function(module, exports) {

$parcel$export(module.exports, "RangeValidator", () => $a3cb93ea381edd2c$export$6d8376a902cb8aa7);

var $eUqFw = parcelRequire("eUqFw");

var $e69P4 = parcelRequire("e69P4");

var $a896o = parcelRequire("a896o");

var $gVdCG = parcelRequire("gVdCG");
const $a3cb93ea381edd2c$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $eUqFw.useContext)((0, $a896o.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $gVdCG.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $gVdCG.useAnnotationRangeState)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e69P4.Mounter), {
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        clearAnnotationDraft: clearAnnotationDraft,
        createAnalyticsEvent: createAnalyticsEvent
    });
};

});
parcelRegister("e69P4", function(module, exports) {

$parcel$export(module.exports, "Mounter", () => $a4393ed591312efa$export$2109cd350bcf6eda);

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");

var $dPmwl = parcelRequire("dPmwl");

var $6PJBT = parcelRequire("6PJBT");

var $61wF1 = parcelRequire("61wF1");

var $a896o = parcelRequire("a896o");
const $a4393ed591312efa$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    const { component: Component, range: range, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const [draftDocumentPosition, setDraftDocumentPosition] = (0, $eUqFw.useState)();
    const actions = (0, $eUqFw.useContext)((0, $a896o.RendererContext));
    const onCreateCallback = (0, $eUqFw.useCallback)((annotationId)=>{
        if (!isAnnotationAllowed || !documentPosition || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $61wF1.ACTION).INSERTED,
            actionSubject: (0, $61wF1.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $61wF1.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $61wF1.EVENT_TYPE).TRACK
        }).fire((0, $6PJBT.FabricChannel).editor);
        return applyAnnotation(draftDocumentPosition || documentPosition, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        draftDocumentPosition,
        createAnalyticsEvent
    ]);
    const createIndexCallback = (0, $eUqFw.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $eUqFw.useCallback)((keepNativeSelection = true)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $61wF1.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $61wF1.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $61wF1.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {},
                eventType: (0, $61wF1.EVENT_TYPE).TRACK
            }).fire((0, $6PJBT.FabricChannel).editor);
            return;
        }
        setDraftDocumentPosition(documentPosition);
        applyAnnotationDraftAt(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $61wF1.ACTION).OPENED,
                actionSubject: (0, $61wF1.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $61wF1.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $61wF1.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $6PJBT.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (keepNativeSelection) (0, $dPmwl.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
    }, [
        documentPosition,
        isAnnotationAllowed,
        applyAnnotationDraftAt,
        createAnalyticsEvent,
        actions,
        range
    ]);
    const removeDraftModeCallback = (0, $eUqFw.useCallback)(()=>{
        clearAnnotationDraft();
        setDraftDocumentPosition(null);
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearAnnotationDraft
    ]);
    const onCloseCallback = (0, $eUqFw.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $61wF1.ACTION).CLOSED,
            actionSubject: (0, $61wF1.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $61wF1.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $61wF1.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $6PJBT.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        range: range,
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});

parcelRegister("gVdCG", function(module, exports) {

$parcel$export(module.exports, "AnnotationRangeProvider", () => $c51c89713e3c9e6a$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $c51c89713e3c9e6a$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $c51c89713e3c9e6a$export$708fc397e2b6f08d);

var $eUqFw = parcelRequire("eUqFw");
function $c51c89713e3c9e6a$var$reducer(state, action) {
    switch(action.type){
        case 'clear':
            if (!!state.range || !!state.type) return {
                range: null,
                draftRange: null,
                type: null
            };
            return state;
        case 'clearSelection':
            if (state.type === 'selection') return {
                ...state,
                range: null,
                type: null
            };
            return state;
        case 'clearDraftSelection':
            if (state.type === 'selection') return {
                ...state,
                draftRange: null
            };
            return state;
        case 'clearDraftHover':
            if (state.type === 'hover') return {
                ...state,
                draftRange: null
            };
            return state;
        case 'clearHover':
            if (state.type === 'hover') return {
                range: null,
                draftRange: null,
                type: null
            };
            return state;
        case 'setSelection':
            if (state.range !== action.range || state.type !== 'selection') return {
                ...state,
                range: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.range !== action.range || state.type !== 'hover') return {
                ...state,
                range: action.range,
                type: 'hover'
            };
            return state;
        case 'setDraftSelection':
            if (state.draftRange !== action.draftRange || state.type !== 'selection') return {
                range: null,
                draftRange: action.draftRange,
                type: null
            };
            return state;
        case 'setDraftHover':
            if (state.draftRange !== action.draftRange || state.type !== 'hover') return {
                ...state,
                draftRange: action.draftRange
            };
            return state;
    }
}
const $c51c89713e3c9e6a$export$145b9bb655c3d220 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    range: null,
    draftRange: null,
    type: null
});
const $c51c89713e3c9e6a$export$efb0d1c8cbaac647 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    clearRange: ()=>{},
    clearSelectionRange: ()=>{},
    clearDraftRange: ()=>{},
    clearHoverRange: ()=>{},
    setRange: ()=>{},
    setDraftRange: ()=>{}
});
const $c51c89713e3c9e6a$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ range: range, draftRange: draftRange, type: type }, dispatch] = (0, $eUqFw.useReducer)($c51c89713e3c9e6a$var$reducer, {
        range: null,
        draftRange: null,
        type: null
    });
    const clearRange = (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'clear'
        }), []);
    const clearSelectionRange = (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearDraftRange = (0, $eUqFw.useCallback)((type)=>{
        if (type === 'hover') {
            dispatch({
                type: 'clearDraftHover'
            });
            return;
        }
        dispatch({
            type: 'clearDraftSelection'
        });
    }, []);
    const clearHoverRange = (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setRange = (0, $eUqFw.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setDraftRange = (0, $eUqFw.useCallback)((range, type)=>{
        if (type === 'hover') {
            dispatch({
                type: 'setDraftHover',
                draftRange: range
            });
            return;
        }
        dispatch({
            type: 'setDraftSelection',
            draftRange: range
        });
    }, []);
    const setHoverTarget = (0, $eUqFw.useCallback)((target)=>{
        const range = document.createRange();
        range.setStartBefore(target);
        range.setEndAfter(target);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const stateData = (0, $eUqFw.useMemo)(()=>({
            range: range,
            draftRange: draftRange,
            type: type
        }), [
        range,
        draftRange,
        type
    ]);
    const dispatchData = (0, $eUqFw.useMemo)(()=>({
            clearRange: clearRange,
            clearSelectionRange: clearSelectionRange,
            clearDraftRange: clearDraftRange,
            clearHoverRange: clearHoverRange,
            setRange: setRange,
            setDraftRange: setDraftRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined
        }), [
        allowCommentsOnMedia,
        clearRange,
        clearSelectionRange,
        clearDraftRange,
        clearHoverRange,
        setRange,
        setDraftRange,
        setHoverTarget
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c51c89713e3c9e6a$export$145b9bb655c3d220.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c51c89713e3c9e6a$export$efb0d1c8cbaac647.Provider, {
        value: dispatchData
    }, children));
};
const $c51c89713e3c9e6a$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $eUqFw.useContext)($c51c89713e3c9e6a$export$145b9bb655c3d220);
};
const $c51c89713e3c9e6a$export$708fc397e2b6f08d = ()=>{
    return (0, $eUqFw.useContext)($c51c89713e3c9e6a$export$efb0d1c8cbaac647);
};

});


parcelRegister("cshwc", function(module, exports) {

$parcel$export(module.exports, "SelectionRangeValidator", () => $9115b05389f702d1$export$74435b85e23b84d9);

var $eUqFw = parcelRequire("eUqFw");

var $eC8q4 = parcelRequire("eC8q4");

var $1IrIb = parcelRequire("1IrIb");

var $a896o = parcelRequire("a896o");
const $9115b05389f702d1$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $eUqFw.useContext)((0, $a896o.RendererContext));
    const [range, draftRange, clearRange] = (0, $eC8q4.useUserSelectionRange)({
        rendererRef: rendererRef
    });
    if (!range && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1IrIb.SelectionInlineCommentMounter), {
        range: range,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        clearAnnotationDraft: clearAnnotationDraft,
        createAnalyticsEvent: createAnalyticsEvent
    });
};

});
parcelRegister("eC8q4", function(module, exports) {

$parcel$export(module.exports, "useUserSelectionRange", () => $aa3b2535fe354454$export$47201332e612f5a4);

var $eUqFw = parcelRequire("eUqFw");

var $gVdCG = parcelRequire("gVdCG");

var $kyb0F = parcelRequire("kyb0F");
const $aa3b2535fe354454$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $eUqFw.useRef)();
    const { clearRange: clearRange, setRange: setRange } = (0, $gVdCG.useAnnotationRangeDispatch)();
    const { range: range, draftRange: draftRange, type: type } = (0, $gVdCG.useAnnotationRangeState)();
    (0, $eUqFw.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        const onSelectionChange = (event)=>{
            if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
            selectionTimeoutRef.current = setTimeout(()=>{
                const sel = document.getSelection();
                if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) return;
                const _range = sel.getRangeAt(0);
                if (rendererDOM && (0, $kyb0F.isRangeInsideOfRendererContainer)(rendererDOM, _range)) setRange(_range.cloneRange());
            }, 250);
        };
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            document.removeEventListener('selectionchange', onSelectionChange);
            clearRange();
        };
    }, [
        rendererDOM,
        setRange,
        clearRange
    ]);
    return [
        type === 'selection' ? range : null,
        draftRange,
        clearRange
    ];
};

});
parcelRegister("kyb0F", function(module, exports) {

$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $ef5f85eb68191995$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ const $ef5f85eb68191995$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("1IrIb", function(module, exports) {

$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $13ff65712cc16aa1$export$ca7741472ed8ba00);

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");

var $dPmwl = parcelRequire("dPmwl");

var $6PJBT = parcelRequire("6PJBT");

var $61wF1 = parcelRequire("61wF1");

var $a896o = parcelRequire("a896o");
const $13ff65712cc16aa1$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const [draftDocumentPosition, setDraftDocumentPosition] = (0, $eUqFw.useState)();
    const actions = (0, $eUqFw.useContext)((0, $a896o.RendererContext));
    const onCreateCallback = (0, $eUqFw.useCallback)((annotationId)=>{
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        const positionToAnnotate = draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $61wF1.ACTION).INSERTED,
            actionSubject: (0, $61wF1.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $61wF1.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $61wF1.EVENT_TYPE).TRACK
        }).fire((0, $6PJBT.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        draftDocumentPosition,
        createAnalyticsEvent
    ]);
    const createIndexCallback = (0, $eUqFw.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $eUqFw.useCallback)((keepNativeSelection = true)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $61wF1.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $61wF1.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $61wF1.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {},
                eventType: (0, $61wF1.EVENT_TYPE).TRACK
            }).fire((0, $6PJBT.FabricChannel).editor);
            return;
        }
        setDraftDocumentPosition(documentPosition);
        applyAnnotationDraftAt(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $61wF1.ACTION).OPENED,
                actionSubject: (0, $61wF1.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $61wF1.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $61wF1.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $6PJBT.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (keepNativeSelection) (0, $dPmwl.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
    }, [
        documentPosition,
        isAnnotationAllowed,
        applyAnnotationDraftAt,
        createAnalyticsEvent,
        actions,
        range
    ]);
    const removeDraftModeCallback = (0, $eUqFw.useCallback)(()=>{
        clearAnnotationDraft();
        setDraftDocumentPosition(null);
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearAnnotationDraft
    ]);
    const onCloseCallback = (0, $eUqFw.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $61wF1.ACTION).CLOSED,
            actionSubject: (0, $61wF1.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $61wF1.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $61wF1.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $6PJBT.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        range: range,
        draftRange: draftRange,
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});



parcelRegister("cVAep", function(module, exports) {

$parcel$export(module.exports, "useLoadAnnotations", () => $9696e9b98ecb16dc$export$39f7c1a861a0d41c);

var $eUqFw = parcelRequire("eUqFw");

var $eUuP5 = parcelRequire("eUuP5");

var $8nCeg = parcelRequire("8nCeg");

var $a896o = parcelRequire("a896o");
const $9696e9b98ecb16dc$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument })=>{
    const actions = (0, $eUqFw.useContext)((0, $a896o.RendererContext));
    const providers = (0, $eUqFw.useContext)((0, $8nCeg.ProvidersContext));
    (0, $eUqFw.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) return;
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            updateSubscriberInlineComment.emit((0, $eUuP5.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
        };
        inlineCommentGetState(ids).then(cb);
    }, [
        actions,
        providers,
        adfDocument
    ]);
};

});


parcelRegister("dTcEN", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", () => $a1ca3ad146b9e019$export$3dee5e4542c672d9);


function $a1ca3ad146b9e019$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $9af2dfe1a711275e$export$42c8d07e41ed1e74))) return true;
    if (element.classList.contains((0, $aeb078ee76c068b6$export$7a6526d4be3b7eb3))) return true;
    return false;
}

});
const $aeb078ee76c068b6$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $aeb078ee76c068b6$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $9af2dfe1a711275e$export$42c8d07e41ed1e74 = 'media-viewer-popup';


parcelRegister("6rEO7", function(module, exports) {

$parcel$export(module.exports, "RendererContextProvider", () => $4b14eb2a4e1318fe$export$ca5df47902194781);

var $eUqFw = parcelRequire("eUqFw");
const $4b14eb2a4e1318fe$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
const $4b14eb2a4e1318fe$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($4b14eb2a4e1318fe$var$RendererContext);
const $4b14eb2a4e1318fe$export$ca5df47902194781 = $4b14eb2a4e1318fe$var$RendererContext.Provider;

});

parcelRegister("4j1xD", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $322a21dce0126aed$export$e926676385687eaf);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $61wF1 = parcelRequire("61wF1");

var $XHGTv = parcelRequire("XHGTv");

var $6PJBT = parcelRequire("6PJBT");

var $emydK = parcelRequire("emydK");

var $1lWyd = parcelRequire("1lWyd");

var $hompL = parcelRequire("hompL");
class $322a21dce0126aed$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            errorCaptured: false,
            domError: false
        });
    }
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $6PJBT.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        this.fireAnalyticsEvent({
            action: (0, $61wF1.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $61wF1.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $1lWyd.PLATFORM).WEB,
                errorMessage: error === null || error === void 0 ? void 0 : error.message,
                componentStack: errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $emydK.logException)(error, {
            location: 'renderer'
        });
        if ((0, $XHGTv.getBooleanFF)('platform.editor.renderer-error-boundary-for-dom-errors')) {
            const pattern = /Failed to execute.*on 'Node'.*/;
            const matchesPattern = pattern.test(error.message);
            if (matchesPattern) {
                this.fireAnalyticsEvent({
                    action: (0, $61wF1.ACTION).CAUGHT_DOM_ERROR,
                    actionSubject: this.props.component,
                    actionSubjectId: this.props.componentId,
                    eventType: (0, $61wF1.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        platform: (0, $1lWyd.PLATFORM).WEB,
                        errorMessage: error === null || error === void 0 ? void 0 : error.message
                    }
                });
                this.setState(()=>({
                        domError: true
                    }));
            }
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if ((0, $XHGTv.getBooleanFF)('platform.editor.renderer-error-boundary-for-dom-errors')) {
            if (this.state.domError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
                key: (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))()
            }, this.props.children);
        }
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
}

});
parcelRegister("emydK", function(module, exports) {

$parcel$export(module.exports, "logException", () => $a74daa4d9f78535d$export$f86b2a1a2ce291b3);
const $a74daa4d9f78535d$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $a74daa4d9f78535d$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $a74daa4d9f78535d$var$packageVersion = "78.24.1";
const $a74daa4d9f78535d$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $a74daa4d9f78535d$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        var _process$env$CLOUD_EN;
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await (parcelRequire("b6qtF"));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("6zRi4"));
        const sentryOptions = {
            dsn: $a74daa4d9f78535d$var$SENTRY_DSN,
            release: `${$a74daa4d9f78535d$var$packageName}@${$a74daa4d9f78535d$var$packageVersion}`,
            environment: (_process$env$CLOUD_EN = undefined, _process$env$CLOUD_EN !== void 0) ? _process$env$CLOUD_EN : 'unknown',
            ignoreErrors: [
                // Network issues
                /^network error/i,
                /^network failure/i,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                /ResizeObserver loop completed with undelivered notifications/
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $a74daa4d9f78535d$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        hub.bindClient(client);
        hub.withScope((scope)=>{
            var _buildInfo;
            scope.setTags({
                // Jira environment variables
                'jira-bundler': window.BUNDLER_VERSION,
                'jira-variant': window.BUILD_VARIANT,
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                'confluence-frontend-version': (_buildInfo = window.__buildInfo) === null || _buildInfo === void 0 ? void 0 : _buildInfo.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};

});
parcelRegister("b6qtF", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hJuQR');
        const value = parcelRequire('5ZfYW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hJuQR").then(()=>parcelRequire('5ZfYW'));
}

});

parcelRegister("6zRi4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ddOuL');
        const value = parcelRequire('4AlqO');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ddOuL").then(()=>parcelRequire('4AlqO'));
}

});



parcelRegister("c48h5", function(module, exports) {

$parcel$export(module.exports, "RenderTracking", () => $8c8c46ed0e74a7c3$export$fe16de086fea1f5f);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $uPi5U = parcelRequire("uPi5U");

var $61wF1 = parcelRequire("61wF1");
function $8c8c46ed0e74a7c3$export$fe16de086fea1f5f(props) {
    const debouncedHandleAnalyticsEvent = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(props.handleAnalyticsEvent, 500), [
        props.handleAnalyticsEvent
    ]);
    (0, $uPi5U.useComponentRenderTracking)({
        onRender: ({ renderCount: renderCount, propsDifference: propsDifference, componentId: componentId })=>{
            if (!renderCount) return;
            debouncedHandleAnalyticsEvent({
                action: props.action,
                actionSubject: props.actionSubject,
                attributes: {
                    count: renderCount,
                    propsDifference: propsDifference,
                    componentId: componentId
                },
                eventType: (0, $61wF1.EVENT_TYPE).OPERATIONAL
            });
        },
        propsDiffingOptions: {
            enabled: true,
            props: props.componentProps,
            propsToIgnore: props.propsToIgnore,
            useShallow: props.useShallow
        },
        zeroBasedCount: true
    });
    return null;
}

});
parcelRegister("uPi5U", function(module, exports) {

$parcel$export(module.exports, "useComponentRenderTracking", () => $05ca96bfedeb6a2b$export$ebce6d7d8ca67353);

var $eUqFw = parcelRequire("eUqFw");

var $lUXsh = parcelRequire("lUXsh");

var $1Ry6X = parcelRequire("1Ry6X");
function $05ca96bfedeb6a2b$export$ebce6d7d8ca67353({ onRender: onRender, propsDiffingOptions: propsDiffingOptions, zeroBasedCount: zeroBasedCount = true }) {
    const propsRef = (0, $eUqFw.useRef)();
    const renderCountRef = (0, $eUqFw.useRef)(zeroBasedCount ? 0 : 1);
    const { current: componentId } = (0, $eUqFw.useRef)((0, $lUXsh.uuid).generate());
    (0, $eUqFw.useEffect)(()=>{
        const lastProps = propsRef.current;
        const renderCount = renderCountRef.current;
        let propsDifference;
        if (propsDiffingOptions !== null && propsDiffingOptions !== void 0 && propsDiffingOptions.enabled && lastProps) propsDifference = propsDiffingOptions !== null && propsDiffingOptions !== void 0 && propsDiffingOptions.useShallow ? (0, $1Ry6X.getShallowPropsDifference)(lastProps, propsDiffingOptions.props) : (0, $1Ry6X.getPropsDifference)(lastProps, propsDiffingOptions.props, 0, 2, propsDiffingOptions === null || propsDiffingOptions === void 0 ? void 0 : propsDiffingOptions.propsToIgnore);
        const result = {
            renderCount: renderCount,
            propsDifference: propsDifference,
            componentId: componentId
        };
        onRender(result);
        if (propsDiffingOptions !== null && propsDiffingOptions !== void 0 && propsDiffingOptions.enabled) propsRef.current = propsDiffingOptions.props;
        renderCountRef.current = renderCountRef.current + 1;
    }); // No dependencies run on each render
}

});
parcelRegister("1Ry6X", function(module, exports) {

$parcel$export(module.exports, "getPropsDifference", () => $15b533732082ee84$export$d438af18e3a25d10);
$parcel$export(module.exports, "getShallowPropsDifference", () => $15b533732082ee84$export$418b0a935c0a0030);

var $eUqFw = parcelRequire("eUqFw");
const $15b533732082ee84$export$74743eda5dda3ccf = Object.keys;
const $15b533732082ee84$export$aedd1a2d18cbf42b = (object1, object2)=>{
    const oldKeys = object1 !== null ? $15b533732082ee84$export$74743eda5dda3ccf(object1) : [];
    const newKeys = object2 !== null ? $15b533732082ee84$export$74743eda5dda3ccf(object2) : [];
    const removed = oldKeys.filter((key)=>!newKeys.includes(key));
    const added = newKeys.filter((key)=>!oldKeys.includes(key));
    const common = oldKeys.filter((key)=>newKeys.includes(key));
    return {
        added: added,
        common: common,
        removed: removed
    };
};
const $15b533732082ee84$export$f4c1dafc9df1f03 = (value)=>{
    const valueType = typeof value;
    if (value === null) return 'null';
    else if (value === undefined) return 'undefined';
    else if (valueType === 'string' || valueType === 'number') return value;
    else if (valueType === 'symbol') return value.toString();
    else if (valueType === 'function') return `function:${value.name}`;
    else if (valueType === 'object') return {
        type: 'object',
        keys: Object.keys(value)
    };
};
const $15b533732082ee84$export$d438af18e3a25d10 = (object1, object2, curDepth = 0, maxDepth = 2, keysToIgnore = [])=>{
    const { added: added, common: common, removed: removed } = $15b533732082ee84$export$aedd1a2d18cbf42b(object1, object2);
    const changed = [];
    common.forEach((key)=>{
        const value1 = object1[key];
        const value2 = object2[key];
        const value1Type = typeof value1;
        const value2Type = typeof value2;
        // Do comparision only if values doesn't match (or reference to same object in memory).
        // Or if key does not exist in keys to ignore.
        if (value1 !== value2 && keysToIgnore.indexOf(key) === -1) {
            // if both key value are objects and not referencing same object in memory.
            //  then get recursive difference.
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(value1) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(value2)) changed.push({
                key: key,
                reactElementChanged: true
            });
            else if (value1Type === 'object' && value2Type === 'object') {
                if (curDepth <= maxDepth) {
                    const difference = $15b533732082ee84$export$d438af18e3a25d10(value1, value2, curDepth + 1, maxDepth);
                    changed.push({
                        key: key,
                        difference: difference
                    });
                } else changed.push({
                    key: key,
                    maxDepthReached: true
                });
            } else changed.push({
                key: key,
                oldValue: $15b533732082ee84$export$f4c1dafc9df1f03(value1),
                newValue: $15b533732082ee84$export$f4c1dafc9df1f03(value2)
            });
        }
    });
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
const $15b533732082ee84$export$418b0a935c0a0030 = (object1, object2)=>{
    const { added: added, common: common, removed: removed } = $15b533732082ee84$export$aedd1a2d18cbf42b(object1, object2);
    const changed = common.filter((key)=>object1[key] !== object2[key]);
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};

});



parcelRegister("cQY1N", function(module, exports) {

$parcel$export(module.exports, "EditorMediaClientProvider", () => $95b8e7b097c92fac$export$77218b6ff680865f);

var $eUqFw = parcelRequire("eUqFw");

var $g3pIo = parcelRequire("g3pIo");

var $jWgZK = parcelRequire("jWgZK");
const $95b8e7b097c92fac$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $eUqFw.useState)();
    const mediaProvider = (0, $jWgZK.useProvider)('mediaProvider');
    /**
   * If a mediaClientConfig is provided then we will force
   * skip the mediaClient from context
   */ const shouldSkipContext = Boolean((ssr === null || ssr === void 0 ? void 0 : ssr.config) || mediaProvider);
    const contextMediaClient = (0, $eUqFw.useContext)((0, $g3pIo.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $eUqFw.useMemo)(()=>mediaClientConfig ? (0, $g3pIo.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    (0, $eUqFw.useEffect)(()=>{
        if (ssr !== null && ssr !== void 0 && ssr.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig(provider.viewMediaClientConfig);
        });
    }, [
        mediaProvider,
        ssr
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3pIo.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient
    }, children);
};

});
parcelRegister("g3pIo", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $bb00df9bc14cdd6f$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "getMediaClient", () => $bb00df9bc14cdd6f$export$c9ecbc1b719fd417);
$parcel$export(module.exports, "MediaClientProvider", () => $bb00df9bc14cdd6f$export$5bff351c86f56d97);
$parcel$export(module.exports, "useMediaClient", () => $bb00df9bc14cdd6f$export$8b3e87ea56c3a345);

var $eUqFw = parcelRequire("eUqFw");

var $164x6 = parcelRequire("164x6");
const $bb00df9bc14cdd6f$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(undefined);
const $bb00df9bc14cdd6f$var$mediaClientsMap = new Map();
const $bb00df9bc14cdd6f$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $164x6.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $bb00df9bc14cdd6f$var$mediaClientsMap.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $164x6.MediaClient)(mediaClientConfig);
        $bb00df9bc14cdd6f$var$mediaClientsMap.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};
const $bb00df9bc14cdd6f$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $eUqFw.useMemo)(()=>$bb00df9bc14cdd6f$export$c9ecbc1b719fd417(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bb00df9bc14cdd6f$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient
    }, children);
};
const $bb00df9bc14cdd6f$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($bb00df9bc14cdd6f$export$ba5d7212f2b4619f);
    if (!mediaClient) throw new Error('No MediaClient set, use MediaClientProvider to set one');
    return mediaClient;
};

});
parcelRegister("164x6", function(module, exports) {

$parcel$export(module.exports, "MediaClient", () => $0cc9de235c425cb3$export$fba8b4ca6d386aec);

var $4FH8r = parcelRequire("4FH8r");
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");

var $kN3jh = parcelRequire("kN3jh");

var $kxO96 = parcelRequire("kxO96");

var $ghcHN = parcelRequire("ghcHN");
parcelRequire("gHZqD");
var $exlxT = parcelRequire("exlxT");

class $0cc9de235c425cb3$export$fba8b4ca6d386aec {
    // mobile upload is lazily loaded
    // Deprecated value introduced for backward compatibility with Context
    constructor(mediaClientConfig, store = (0, $exlxT.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi !== null && mediaApi !== void 0 ? mediaApi : new (0, $kN3jh.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: mediaClientConfig.useSha256ForUploads ? (0, $fmEc3.ChunkHashAlgorithm).Sha256 : (0, $fmEc3.ChunkHashAlgorithm).Sha1
        });
        this.config = mediaClientConfig;
        this.file = new (0, $kxO96.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $4FH8r.EventEmitter2)();
        this.stargate = new (0, $ghcHN.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
   * @internal
   */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("kbZvn"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("4FH8r", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $2fFJv !== 'undefined' && $2fFJv.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $2fFJv.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("2q7Xj", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => (parcelRequire("iE8r2")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("jrFS0")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("jrFS0")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("fmEc3")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $iE8r2 = parcelRequire("iE8r2");

var $jrFS0 = parcelRequire("jrFS0");

var $fmEc3 = parcelRequire("fmEc3");

});
parcelRegister("iE8r2", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => $4cdeb32efb36e469$export$8cef61637918b288);

var $4FH8r = parcelRequire("4FH8r");

var $6roQF = parcelRequire("6roQF");
const $4cdeb32efb36e469$export$8cef61637918b288 = {
    streams: new (0, $6roQF.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $4FH8r.EventEmitter2)()
};

});

parcelRegister("jrFS0", function(module, exports) {

$parcel$export(module.exports, "isClientBasedAuth", () => $a5c9edcfc78df537$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $a5c9edcfc78df537$export$17f6055767a8d96a);
function $a5c9edcfc78df537$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $a5c9edcfc78df537$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $a5c9edcfc78df537$export$17f6055767a8d96a = (auth)=>{
    if ($a5c9edcfc78df537$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("fmEc3", function(module, exports) {

$parcel$export(module.exports, "ChunkHashAlgorithm", () => $2714010903136296$export$d3e73a50cc549c2e);
var $2714010903136296$export$d3e73a50cc549c2e;
(function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha1"] = "sha1";
    ChunkHashAlgorithm["Sha256"] = "sha256";
})($2714010903136296$export$d3e73a50cc549c2e || ($2714010903136296$export$d3e73a50cc549c2e = {}));

});


parcelRegister("kN3jh", function(module, exports) {

$parcel$export(module.exports, "MediaStore", () => $f22af38d4c032a47$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $f22af38d4c032a47$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $f22af38d4c032a47$export$20f9315304dd6726);

var $5zQU9 = parcelRequire("5zQU9");

var $5Cq8b = parcelRequire("5Cq8b");

var $3LvqL = parcelRequire("3LvqL");

var $aixOm = parcelRequire("aixOm");

var $hams9 = parcelRequire("hams9");

var $ajmol = parcelRequire("ajmol");

var $eucJ1 = parcelRequire("eucJ1");
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");
const $f22af38d4c032a47$var$MEDIA_API_REGION = 'media-api-region';
const $f22af38d4c032a47$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $f22af38d4c032a47$var$extendImageParams = (params, fetchMaxRes = false)=>{
    var _params$maxAge, _params$allowAnimated, _params$mode;
    return {
        ...params,
        'max-age': (_params$maxAge = params === null || params === void 0 ? void 0 : params['max-age']) !== null && _params$maxAge !== void 0 ? _params$maxAge : (0, $3LvqL.FILE_CACHE_MAX_AGE),
        allowAnimated: (_params$allowAnimated = params === null || params === void 0 ? void 0 : params.allowAnimated) !== null && _params$allowAnimated !== void 0 ? _params$allowAnimated : true,
        mode: (_params$mode = params === null || params === void 0 ? void 0 : params.mode) !== null && _params$mode !== void 0 ? _params$mode : 'crop',
        ...fetchMaxRes ? {
            width: (0, $3LvqL.MAX_RESOLUTION),
            height: (0, $3LvqL.MAX_RESOLUTION)
        } : {}
    };
};
const $f22af38d4c032a47$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
class $f22af38d4c032a47$export$572b8a2a9fd7cbba {
    constructor(config){
        (0, $5zQU9.default)(this, "resolveAuth", (authContext)=>(0, $eucJ1.resolveAuth)(this.config.authProvider, authContext));
        (0, $5zQU9.default)(this, "resolveInitialAuth", ()=>(0, $eucJ1.resolveInitialAuth)(this.config.initialAuth));
        this.config = config;
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $fmEc3.ChunkHashAlgorithm).Sha1;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $ajmol.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $f22af38d4c032a47$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $ajmol.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $f22af38d4c032a47$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $ajmol.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $ajmol.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const options = {
            params: $f22af38d4c032a47$var$extendImageParams(params),
            auth: auth
        };
        return (0, $ajmol.createUrl)(`${auth.baseUrl}/file/${id}/image`, options);
    }
    async getFileBinary(id, collectionName, maxAge = (0, $3LvqL.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/binary'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/binary`, options).then((0, $ajmol.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $3LvqL.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        return (0, $ajmol.createUrl)(`${auth.baseUrl}/file/${id}/binary`, options);
    }
    async getArtifactURL(artifacts, artifactName, collectionName) {
        const artifactUrl = (0, $aixOm.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': (0, $3LvqL.FILE_CACHE_MAX_AGE)
            },
            auth: auth
        };
        return (0, $ajmol.createUrl)(`${auth.baseUrl}${artifactUrl}`, options);
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: $f22af38d4c032a47$var$extendImageParams(params, fetchMaxRes),
            headers: headers,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image`, options, controller).then((0, $ajmol.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $f22af38d4c032a47$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $ajmol.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $ajmol.createMapResponseToJson)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $f22af38d4c032a47$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: // Contains collection name to write to
            params,
            // Contains collection name to write to
            headers: $f22af38d4c032a47$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: // Contains collection name to read from
            traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $ajmol.createMapResponseToJson)(metadata));
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext } = options;
        const auth = await this.resolveAuth(authContext);
        const extendedTraceContext = traceContext ? {
            ...traceContext,
            spanId: (traceContext === null || traceContext === void 0 ? void 0 : traceContext.spanId) || (0, $5Cq8b.getRandomHex)(8)
        } : undefined;
        const response = await (0, $hams9.request)(`${auth.baseUrl}${path}`, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: params,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $f22af38d4c032a47$var$setKeyValueInSessionStorage($f22af38d4c032a47$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $f22af38d4c032a47$var$setKeyValueInSessionStorage($f22af38d4c032a47$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $f22af38d4c032a47$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $f22af38d4c032a47$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $f22af38d4c032a47$export$c8b741e18397852a = ()=>{
    return $f22af38d4c032a47$var$getValueFromSessionStorage($f22af38d4c032a47$var$MEDIA_API_ENVIRONMENT);
};
const $f22af38d4c032a47$export$20f9315304dd6726 = ()=>{
    return $f22af38d4c032a47$var$getValueFromSessionStorage($f22af38d4c032a47$var$MEDIA_API_REGION);
};

});
parcelRegister("5Cq8b", function(module, exports) {

$parcel$export(module.exports, "isUndefined", () => $b1f5fb9992743b46$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $b1f5fb9992743b46$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $b1f5fb9992743b46$export$456b25e3a9b4a843);
const $b1f5fb9992743b46$export$fce6876652108ab = (value)=>value === undefined;
const $b1f5fb9992743b46$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $b1f5fb9992743b46$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $b1f5fb9992743b46$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $b1f5fb9992743b46$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $b1f5fb9992743b46$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $b1f5fb9992743b46$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $b1f5fb9992743b46$var$getRandomHexValues(byte);
    }
    else randomHex = $b1f5fb9992743b46$var$getRandomHexValues(byte);
    return randomHex;
}

});

parcelRegister("3LvqL", function(module, exports) {

$parcel$export(module.exports, "RECENTS_COLLECTION", () => $2bde245f61f8ea50$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $2bde245f61f8ea50$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $2bde245f61f8ea50$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $2bde245f61f8ea50$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $2bde245f61f8ea50$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $2bde245f61f8ea50$export$f14f521f3d306044);

var $2pRaG = parcelRequire("2pRaG");
const $2bde245f61f8ea50$export$860a16125e30000b = 'recents';
const $2bde245f61f8ea50$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $2bde245f61f8ea50$export$6e70f30e392bc53f = 4096;
const $2bde245f61f8ea50$export$c1abb8bab1e615cd = 5 * (0, $2pRaG.DATA_UNIT).MB;
const $2bde245f61f8ea50$export$3d5157f0def70e54 = 1000;
const $2bde245f61f8ea50$export$f14f521f3d306044 = 2 * (0, $2pRaG.DATA_UNIT).TB;

});
parcelRegister("2pRaG", function(module, exports) {

$parcel$export(module.exports, "DATA_UNIT", () => $1c272947bb1c5799$export$76cfea4c354af843);
// Warning! You can't add new media file processing status!
// See packages/media/media-core/src/__tests__/cache-backward-compatibility.spec.ts
const $1c272947bb1c5799$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
let $1c272947bb1c5799$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("aixOm", function(module, exports) {

$parcel$export(module.exports, "getArtifactUrl", () => $77f5d00b3391d7ac$export$1cc24defa44e7f84);
const $77f5d00b3391d7ac$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    const artifact = artifacts[prop];
    if (!artifact || !artifact.url) return undefined;
    return artifact.url;
};

});

parcelRegister("hams9", function(module, exports) {

$parcel$export(module.exports, "request", () => $c7f4c98ff21d8202$export$b5fe3f66a567bec0);

var $bkhx7 = parcelRequire("bkhx7");

var $ajmol = parcelRequire("ajmol");
async function $c7f4c98ff21d8202$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $ajmol.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $ajmol.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $ajmol.createProcessFetchResponse)(metadata));
    return (0, $ajmol.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("bkhx7", function(module, exports) {

$parcel$export(module.exports, "RequestError", () => $83ef29aa1da78d56$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $83ef29aa1da78d56$export$3717b1ffef4428ea);

var $8Jhci = parcelRequire("8Jhci");
class $83ef29aa1da78d56$export$43ee7d0e4f429743 extends (0, $8Jhci.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason);
        this.reason = reason;
        this.metadata = metadata;
        this.innerError = innerError;
    }
    get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            innerError: innerError
        };
    }
}
function $83ef29aa1da78d56$export$3717b1ffef4428ea(err) {
    return err instanceof $83ef29aa1da78d56$export$43ee7d0e4f429743;
}

});
parcelRegister("8Jhci", function(module, exports) {

$parcel$export(module.exports, "BaseMediaClientError", () => $65afddbf5e631031$export$2b0aca14d61c3190);

var $bf4YN = parcelRequire("bf4YN");
class $65afddbf5e631031$export$2b0aca14d61c3190 extends Error {
    constructor(message){
        super(message);
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        this.message = message;
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}

});
parcelRegister("bf4YN", function(module, exports) {

$parcel$export(module.exports, "getMediaClientErrorReason", () => $82f4f53e235f5bc5$export$c15d72765ee2baa4);
function $82f4f53e235f5bc5$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $82f4f53e235f5bc5$export$c15d72765ee2baa4(err) {
    return $82f4f53e235f5bc5$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("ajmol", function(module, exports) {

$parcel$export(module.exports, "createUrl", () => $781d0c3cd168d18b$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $781d0c3cd168d18b$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $781d0c3cd168d18b$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $781d0c3cd168d18b$export$5cc7b0795397da86);
$parcel$export(module.exports, "fetchRetry", () => $781d0c3cd168d18b$export$782df2acbe10b22c);
$parcel$export(module.exports, "createProcessFetchResponse", () => $781d0c3cd168d18b$export$6e2e477edb7d6032);
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");

var $jQ2Zf = parcelRequire("jQ2Zf");

var $bkhx7 = parcelRequire("bkhx7");
function $781d0c3cd168d18b$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $781d0c3cd168d18b$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $781d0c3cd168d18b$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $781d0c3cd168d18b$export$bc96a6a479480590(error) {
    return !!error && (0, $bkhx7.isRequestError)(error) && error.attributes.statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $781d0c3cd168d18b$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $781d0c3cd168d18b$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$781d0c3cd168d18b$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$781d0c3cd168d18b$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $781d0c3cd168d18b$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $jrFS0.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $781d0c3cd168d18b$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url);
    const authParams = auth && (0, $jQ2Zf.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.append(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $781d0c3cd168d18b$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers !== null && headers !== void 0 ? headers : {},
        ...$781d0c3cd168d18b$export$eaf4479116d2f925(auth),
        ...$781d0c3cd168d18b$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $781d0c3cd168d18b$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $bkhx7.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$781d0c3cd168d18b$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $781d0c3cd168d18b$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $bkhx7.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$781d0c3cd168d18b$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $781d0c3cd168d18b$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    // 1 second is generally a good timeout to start
    maxAttempts: 5,
    // Current test delay is 60s, so retries should finish before if a promise takes < 1s
    factor: 2 // Good for polling, which is out main use case
};
function $781d0c3cd168d18b$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $bkhx7.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $781d0c3cd168d18b$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$781d0c3cd168d18b$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $781d0c3cd168d18b$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($781d0c3cd168d18b$export$de0b576cf7ce4a53(err)) throw new (0, $bkhx7.RequestError)('clientAbortedRequest', metadata, err);
        if (!$781d0c3cd168d18b$export$ad8c5cf7dd4c3caf(err) && !(0, $bkhx7.isRequestError)(err) || (0, $bkhx7.isRequestError)(err) && (!err.metadata || !err.metadata.statusCode || err.metadata.statusCode < 500)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $bkhx7.isRequestError)(lastError)) throw $781d0c3cd168d18b$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $bkhx7.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $781d0c3cd168d18b$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $781d0c3cd168d18b$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $781d0c3cd168d18b$export$6397609af718d008(statusCode);
    return new (0, $bkhx7.RequestError)(reason, {
        ...metadata,
        ...$781d0c3cd168d18b$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $781d0c3cd168d18b$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $781d0c3cd168d18b$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $781d0c3cd168d18b$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("jQ2Zf", function(module, exports) {

$parcel$export(module.exports, "mapAuthToQueryParameters", () => $e71530c995a66656$export$6833b130611df767);
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");
function $e71530c995a66656$export$6833b130611df767(auth) {
    if ((0, $jrFS0.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});



parcelRegister("eucJ1", function(module, exports) {

$parcel$export(module.exports, "resolveAuth", () => $a8bdbcf6a1e05ea3$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $a8bdbcf6a1e05ea3$export$5211e1371264aec3);

var $eCnS4 = parcelRequire("eCnS4");

var $beMYl = parcelRequire("beMYl");
const $a8bdbcf6a1e05ea3$export$560085fe411c0660 = 10000;
const $a8bdbcf6a1e05ea3$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $a8bdbcf6a1e05ea3$export$560085fe411c0660)=>{
    let auth;
    try {
        auth = await Promise.race([
            authProvider(authContext),
            (0, $beMYl.rejectTimeout)(authProviderTimeout, new (0, $eCnS4.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        if (err instanceof (0, $eCnS4.MediaStoreError)) throw err;
        throw new (0, $eCnS4.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $eCnS4.MediaStoreError)('emptyAuth');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $a8bdbcf6a1e05ea3$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $eCnS4.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("eCnS4", function(module, exports) {

$parcel$export(module.exports, "MediaStoreError", () => $aa472193edfb78c4$export$b78480bd311630bc);

var $8Jhci = parcelRequire("8Jhci");
class $aa472193edfb78c4$export$b78480bd311630bc extends (0, $8Jhci.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason);
        this.reason = reason;
        this.innerError = innerError;
    }
    get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $aa472193edfb78c4$export$8d2a9b675b2ce37a(err) {
    return err instanceof $aa472193edfb78c4$export$b78480bd311630bc;
}

});

parcelRegister("beMYl", function(module, exports) {

$parcel$export(module.exports, "rejectTimeout", () => $82e6fd62e397bc6d$export$cf2d2a1124beacb2);
const $82e6fd62e397bc6d$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $82e6fd62e397bc6d$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});



parcelRegister("kxO96", function(module, exports) {

$parcel$export(module.exports, "FileFetcherImpl", () => $ef4dc9a3f7e7a78d$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("a6e0K")).FileFetcherError);

var $5zQU9 = parcelRequire("5zQU9");

var $hIoOm = parcelRequire("hIoOm");

var $aynDk = parcelRequire("aynDk");

var $dFBS3 = parcelRequire("dFBS3");
parcelRequire("inzmU");
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");

var $8w4F1 = parcelRequire("8w4F1");

var $kN3jh = parcelRequire("kN3jh");

var $dTbMV = parcelRequire("dTbMV");

var $a6e0K = parcelRequire("a6e0K");

var $d3zGq = parcelRequire("d3zGq");

var $bjNda = parcelRequire("bjNda");

var $7RvwS = parcelRequire("7RvwS");

var $3LvqL = parcelRequire("3LvqL");

var $bxYYu = parcelRequire("bxYYu");

var $2XmH6 = parcelRequire("2XmH6");

var $eR2Q8 = parcelRequire("eR2Q8");

var $2crmE = parcelRequire("2crmE");

var $klQrn = parcelRequire("klQrn");

var $lbU1T = parcelRequire("lbU1T");
var $2rj8v = parcelRequire("2rj8v");

var $ly4iy = parcelRequire("ly4iy");

var $hCY6c = parcelRequire("hCY6c");

var $3izHV = parcelRequire("3izHV");
var $br8gy = parcelRequire("br8gy");

var $gMK6O = parcelRequire("gMK6O");

var $21MgI = parcelRequire("21MgI");

var $duo45 = parcelRequire("duo45");
parcelRequire("gHZqD");
var $exlxT = parcelRequire("exlxT");
class $ef4dc9a3f7e7a78d$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $exlxT.mediaStore)){
        (0, $5zQU9.default)(this, "getErrorFileState", (error, id, occurrenceKey)=>typeof error === 'string' ? {
                status: 'error',
                id: id,
                reason: error,
                occurrenceKey: occurrenceKey,
                message: error
            } : {
                status: 'error',
                id: id,
                reason: error === null || error === void 0 ? void 0 : error.reason,
                details: error === null || error === void 0 ? void 0 : error.attributes,
                occurrenceKey: occurrenceKey,
                message: error === null || error === void 0 ? void 0 : error.message
            });
        (0, $5zQU9.default)(this, "setFileState", (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        });
        // TODO: ----- ADD TICKET TO PASS TRACE ID to this.dataloader.load
        (0, $5zQU9.default)(this, "createDownloadFileStream", (id, collectionName, occurrenceKey)=>{
            const subject = (0, $hCY6c.createMediaSubject)();
            const poll = new (0, $21MgI.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName
                });
                if (!response) throw new (0, $a6e0K.FileFetcherError)('emptyItems', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                if ((0, $duo45.isEmptyFile)(response)) throw new (0, $a6e0K.FileFetcherError)('zeroVersionFile', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                const fileState = (0, $dTbMV.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        });
        (0, $5zQU9.default)(this, "getUploadingFileStateBase", (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $klQrn.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' // name property is not available in base64 image
             } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                if ((0, $br8gy.isMimeTypeSupportedByBrowser)(content.type)) preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $eR2Q8.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        });
        this.mediaApi = mediaApi;
        this.store = store;
        this.dataloader = (0, $2XmH6.createFileDataloader)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey } = options;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxYYu)))(id)) {
            const subject = (0, $hCY6c.createMediaSubject)();
            const err = new (0, $a6e0K.FileFetcherError)('invalidFileId', id, {
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = {
                status: 'error',
                id: id,
                reason: err === null || err === void 0 ? void 0 : err.reason,
                message: err === null || err === void 0 ? void 0 : err.message,
                occurrenceKey: occurrenceKey,
                details: err === null || err === void 0 ? void 0 : err.attributes
            };
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $lbU1T.fromObservable)(subject);
        }
        return (0, $lbU1T.fromObservable)((0, $bjNda.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $2rj8v.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $hCY6c.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $bjNda.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $3izHV.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            const dimensions = await (0, $ly4iy.getDimensionsFromBlob)(mediaType, blob);
            resolve({
                dimensions: dimensions,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $hCY6c.createMediaSubject)();
        (0, $bjNda.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $hIoOm.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $aynDk.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $2crmE.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $d3zGq.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller === null || controller === void 0 || controller.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $lbU1T.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $8w4F1.downloadUrl)(url, {
            name: name
        });
        (0, $7RvwS.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $3LvqL.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const mediaStore = destination.mediaStore || new (0, $kN3jh.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $jrFS0.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const cache = (0, $bjNda.getFileStreamsCache)();
        let processingSubscription;
        try {
            const { data: copiedFile } = await mediaStore.copyFileWithToken(body, params, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $3izHV.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $dTbMV.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $hCY6c.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $dTbMV.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $dTbMV.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $gMK6O.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $2crmE.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $2crmE.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $dTbMV.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $dTbMV.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $dTbMV.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $bjNda.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $hCY6c.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("8w4F1", function(module, exports) {

$parcel$export(module.exports, "downloadUrl", () => $b20aaa7fa9049904$export$8a96edb1c96563f4);
const $b20aaa7fa9049904$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("dTbMV", function(module, exports) {

$parcel$export(module.exports, "isUploadingFileState", () => $a1c98e48aa74500f$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $a1c98e48aa74500f$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $a1c98e48aa74500f$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $a1c98e48aa74500f$export$f863e1e09c8a926);
$parcel$export(module.exports, "isFinalFileState", () => $a1c98e48aa74500f$export$270b3fc27120edd0);
$parcel$export(module.exports, "isImageRepresentationReady", () => $a1c98e48aa74500f$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $a1c98e48aa74500f$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $a1c98e48aa74500f$export$ea3730792e8bebfb);
const $a1c98e48aa74500f$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $a1c98e48aa74500f$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $a1c98e48aa74500f$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $a1c98e48aa74500f$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $a1c98e48aa74500f$export$92dd692b31e42e64 = (fileState)=>!$a1c98e48aa74500f$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $a1c98e48aa74500f$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $a1c98e48aa74500f$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $a1c98e48aa74500f$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        metadataTraceContext: metadataTraceContext
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing'
            };
    }
};
const $a1c98e48aa74500f$export$ea3730792e8bebfb = (id, item)=>{
    return $a1c98e48aa74500f$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("a6e0K", function(module, exports) {

$parcel$export(module.exports, "FileFetcherError", () => $75a555406e5c0ebb$export$e3e60f0dab8641de);

var $8Jhci = parcelRequire("8Jhci");
class $75a555406e5c0ebb$export$e3e60f0dab8641de extends (0, $8Jhci.BaseMediaClientError) {
    constructor(reason, id, metadata){
        super(reason);
        this.reason = reason;
        this.id = id;
        this.metadata = metadata;
    }
    get attributes() {
        const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $75a555406e5c0ebb$export$5c3435f75ce0ce70(err) {
    return err instanceof $75a555406e5c0ebb$export$e3e60f0dab8641de;
}

});

parcelRegister("d3zGq", function(module, exports) {

$parcel$export(module.exports, "uploadFile", () => $98173c240042cd3e$export$a5575dbeeffdad98);

var $2gF4Y = parcelRequire("2gF4Y");

var $jpkPA = parcelRequire("jpkPA");

var $eGPtZ = parcelRequire("eGPtZ");

var $2PELh = parcelRequire("2PELh");

var $5yyia = parcelRequire("5yyia");

var $3LvqL = parcelRequire("3LvqL");

var $4w63l = parcelRequire("4w63l");
// TODO: Allow to pass multiple files
const $98173c240042cd3e$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $2PELh.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $98173c240042cd3e$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $98173c240042cd3e$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $98173c240042cd3e$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext);
        offset += chunks.length;
    };
};
const $98173c240042cd3e$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext);
};
const $98173c240042cd3e$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $3LvqL.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $4w63l.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $4w63l.fileSizeError)) callbacks === null || callbacks === void 0 || callbacks.onUploadFinish(new (0, $5yyia.UploaderError)(err.message, id, {
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks === null || callbacks === void 0 || callbacks.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $2gF4Y.chunkinator)(content, {
        hashingFunction: (blob)=>$98173c240042cd3e$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $98173c240042cd3e$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $3LvqL.PROCESSING_BATCH_SIZE),
        processingFunction: $98173c240042cd3e$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $jpkPA.from)(deferredUploadId).pipe((0, $eGPtZ.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $eGPtZ.concatMap)(()=>(0, $jpkPA.from)($98173c240042cd3e$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $98173c240042cd3e$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("2gF4Y", function(module, exports) {

$parcel$export(module.exports, "chunkinator", () => $926a40091d882f6c$export$9ab6bef3838698f8);

var $dBQte = parcelRequire("dBQte");

var $eGPtZ = parcelRequire("eGPtZ");

var $4ZLqF = parcelRequire("4ZLqF");

var $8riMk = parcelRequire("8riMk");

var $fZ5s6 = parcelRequire("fZ5s6");

var $66iic = parcelRequire("66iic");

var $f28UZ = parcelRequire("f28UZ");

var $iYmB8 = parcelRequire("iYmB8");

var $7zy4k = parcelRequire("7zy4k");

var $jpkPA = parcelRequire("jpkPA");
const $926a40091d882f6c$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $8riMk.fromPromise)((0, $7zy4k.fetchBlob)(file)).pipe((0, $eGPtZ.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $fZ5s6.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $66iic.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $f28UZ.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $dBQte.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $iYmB8.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $eGPtZ.concatMap)((batchedChunks)=>{
            return (0, $jpkPA.from)(batchedChunks);
        }), (0, $4ZLqF.bufferCount)(totalChunks));
    }));
const $926a40091d882f6c$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $926a40091d882f6c$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("fZ5s6", function(module, exports) {

$parcel$export(module.exports, "slicenator", () => $b09d6a25440d952b$export$5b92d769f2f57509);

var $3fnK6 = parcelRequire("3fnK6");

var $aynDk = parcelRequire("aynDk");
const $b09d6a25440d952b$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $3fnK6.range)(0, totalChunks).pipe((0, $aynDk.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});

parcelRegister("66iic", function(module, exports) {

$parcel$export(module.exports, "hashinator", () => $bba7ef0a5244bc3b$export$d5f5a550a38ec367);

var $7zy4k = parcelRequire("7zy4k");
const $bba7ef0a5244bc3b$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $bba7ef0a5244bc3b$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $7zy4k.asyncMap)($bba7ef0a5244bc3b$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("7zy4k", function(module, exports) {

$parcel$export(module.exports, "fetchBlob", () => $434114a42104e3d7$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $434114a42104e3d7$export$707ee4c4c95d39e3);

var $3JafE = parcelRequire("3JafE");

var $b1qLQ = parcelRequire("b1qLQ");
async function $434114a42104e3d7$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $434114a42104e3d7$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $434114a42104e3d7$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $3JafE.Observable)((sub)=>{
            notifiers.push($434114a42104e3d7$var$notify(project(value), sub, onReady));
        });
};
const $434114a42104e3d7$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $b1qLQ.mergeMap)($434114a42104e3d7$var$mapper(project), concurrent);

});


parcelRegister("f28UZ", function(module, exports) {

$parcel$export(module.exports, "uploadinator", () => $6a83285a61ef7586$export$94ce0f3fcf999415);

var $7zy4k = parcelRequire("7zy4k");
const $6a83285a61ef7586$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $7zy4k.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("iYmB8", function(module, exports) {

$parcel$export(module.exports, "processinator", () => $38ace8e9a7e10729$export$2f21790600302ed);

var $4ZLqF = parcelRequire("4ZLqF");

var $eGPtZ = parcelRequire("eGPtZ");
const $38ace8e9a7e10729$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $4ZLqF.bufferCount)(options.batchSize)).pipe((0, $eGPtZ.concatMap)(process));
};

});


parcelRegister("2PELh", function(module, exports) {

$parcel$export(module.exports, "createHasher", () => $20fff696f5f98786$export$14b114effbc08b6b);
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");
let $20fff696f5f98786$var$hasher = null;
let $20fff696f5f98786$var$sha256Hasher = null;
const $20fff696f5f98786$export$b7d263e6bc26b29a = ()=>$20fff696f5f98786$var$hasher = null;



const $20fff696f5f98786$export$14b114effbc08b6b = async (algorithm)=>{
    const numWorkers = 3;
    if (algorithm === (0, $fmEc3.ChunkHashAlgorithm).Sha256) {
        if (!$20fff696f5f98786$var$sha256Hasher) {
            // TODO this needs to support worker sha256 hasher as well
            const { SimpleHasher: SimpleHasher } = await (parcelRequire("fvOCP"));
            $20fff696f5f98786$var$sha256Hasher = new SimpleHasher();
        }
        return $20fff696f5f98786$var$sha256Hasher;
    } else if (!$20fff696f5f98786$var$hasher) try {
        const { WorkerHasher: WorkerHasher } = await (parcelRequire("3H3CC"));
        $20fff696f5f98786$var$hasher = new WorkerHasher(numWorkers);
    } catch (error) {
        const { SimpleHasher: SimpleHasher } = await (parcelRequire("iFNKv"));
        $20fff696f5f98786$var$hasher = new SimpleHasher();
    }
    return $20fff696f5f98786$var$hasher;
};

});
parcelRegister("fvOCP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('b2TjY');
        const value = parcelRequire('kqHDh');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("b2TjY").then(()=>parcelRequire('kqHDh'));
}

});

parcelRegister("3H3CC", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('7WxKA')
        ]);
        const value = parcelRequire('449zx');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("7WxKA")
    ]).then(()=>parcelRequire('449zx'));
}

});

parcelRegister("iFNKv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('gvOWN')
        ]);
        const value = parcelRequire('2QDnR');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("gvOWN")
    ]).then(()=>parcelRequire('2QDnR'));
}

});


parcelRegister("5yyia", function(module, exports) {

$parcel$export(module.exports, "UploaderError", () => $40baba6dc12c83c8$export$515240c3f059c807);

var $8Jhci = parcelRequire("8Jhci");
class $40baba6dc12c83c8$export$515240c3f059c807 extends (0, $8Jhci.BaseMediaClientError) {
    constructor(reason, id, metadata){
        super(reason);
        this.reason = reason;
        this.id = id;
        this.metadata = metadata;
    }
    get attributes() {
        const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $40baba6dc12c83c8$export$80ee180172bc336(err) {
    return err instanceof $40baba6dc12c83c8$export$515240c3f059c807;
}

});

parcelRegister("4w63l", function(module, exports) {

$parcel$export(module.exports, "fileSizeError", () => $349ed890b4a940b4$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $349ed890b4a940b4$export$71f452e02035c1e2);

var $2pRaG = parcelRequire("2pRaG");

var $3LvqL = parcelRequire("3LvqL");
const $349ed890b4a940b4$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $349ed890b4a940b4$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $3LvqL.MAX_UPLOAD_FILE_SIZE)) throw new Error($349ed890b4a940b4$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $2pRaG.DATA_UNIT).GB) return 5 * (0, $2pRaG.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $2pRaG.DATA_UNIT).GB && fileSize <= 50 * (0, $2pRaG.DATA_UNIT).GB) return 50 * (0, $2pRaG.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $2pRaG.DATA_UNIT).GB && fileSize <= 0.95 * (0, $2pRaG.DATA_UNIT).TB) return 100 * (0, $2pRaG.DATA_UNIT).MB;
    return 210 * (0, $2pRaG.DATA_UNIT).MB;
};

});


parcelRegister("bjNda", function(module, exports) {

$parcel$export(module.exports, "getFileStreamsCache", () => $83d7a466cce8d5be$export$f2f061938c1e6810);
class $83d7a466cce8d5be$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $83d7a466cce8d5be$var$streamCache;

const $83d7a466cce8d5be$export$f2f061938c1e6810 = ()=>{
    if (!$83d7a466cce8d5be$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("iE8r2")).mediaState;
        $83d7a466cce8d5be$var$streamCache = new $83d7a466cce8d5be$export$4293896e79732236(mediaState.streams);
    }
    return $83d7a466cce8d5be$var$streamCache;
};

});

parcelRegister("7RvwS", function(module, exports) {

$parcel$export(module.exports, "globalMediaEventEmitter", () => $5b95f0b24275ad6d$export$68d003d3105952ad);
parcelRequire("2q7Xj");
var $iE8r2 = parcelRequire("iE8r2");
const $5b95f0b24275ad6d$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $iE8r2.mediaState).eventEmitter) (0, $iE8r2.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $iE8r2.mediaState).eventEmitter) (0, $iE8r2.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $iE8r2.mediaState).eventEmitter) return (0, $iE8r2.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("bxYYu", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $aul3P = parcelRequire("aul3P");
var $8682131465584b62$require$Buffer = $aul3P.Buffer;
var $8682131465584b62$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $8682131465584b62$var$_byteToHex = [];
for(var $8682131465584b62$var$i = 0; $8682131465584b62$var$i < 256; $8682131465584b62$var$i++)$8682131465584b62$var$_byteToHex[$8682131465584b62$var$i] = ($8682131465584b62$var$i + 0x100).toString(16).substr(1);
function $8682131465584b62$var$unparse(buf, offset) {
    var i = offset || 0, bth = $8682131465584b62$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($8682131465584b62$require$Buffer.isBuffer(uuid)) parsedUuid = $8682131465584b62$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$8682131465584b62$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $8682131465584b62$var$extractVersion(parsedUuid);
    else if ($8682131465584b62$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $8682131465584b62$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("2XmH6", function(module, exports) {

$parcel$export(module.exports, "createFileDataloader", () => $2272b2124e5f7e16$export$ae188fee39529b82);
// import setimmediate to temporary fix dataloader 2.0.0 bug
// @see https://github.com/graphql/dataloader/issues/249
parcelRequire("inzmU");

var $7sFsf = parcelRequire("7sFsf");

var $5Cq8b = parcelRequire("5Cq8b");
const $2272b2124e5f7e16$export$b79d95ee17a87a = 100;
const $2272b2124e5f7e16$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $2272b2124e5f7e16$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $2272b2124e5f7e16$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $2272b2124e5f7e16$var$makeCacheKey(id, collection);
        prev[key] = $2272b2124e5f7e16$var$isBatchLoadingErrorResult(fileItem) ? fileItem.error : {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $2272b2124e5f7e16$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || null;
    });
};
function $2272b2124e5f7e16$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $5Cq8b.getRandomHex)(8),
                spanId: (0, $5Cq8b.getRandomHex)(8)
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $2272b2124e5f7e16$export$71cd2e8f8162d47b(keys, items);
    };
}
function $2272b2124e5f7e16$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($7sFsf)))($2272b2124e5f7e16$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $2272b2124e5f7e16$export$b79d95ee17a87a
    });
}

});
parcelRegister("7sFsf", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $56eb4df4b51f9a4c$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $56eb4df4b51f9a4c$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $56eb4df4b51f9a4c$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $56eb4df4b51f9a4c$var$getValidCacheKeyFn(options);
        this._cacheMap = $56eb4df4b51f9a4c$var$getValidCacheMap(options);
        this._batch = null;
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value,' + ("but got: " + String(key) + "."));
        var batch = $56eb4df4b51f9a4c$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        return resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$56eb4df4b51f9a4c$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $56eb4df4b51f9a4c$var$enqueuePostPromiseJob = typeof $2fFJv === 'object' && typeof $2fFJv.nextTick === 'function' ? function(fn) {
    if (!$56eb4df4b51f9a4c$var$resolvedPromise) $56eb4df4b51f9a4c$var$resolvedPromise = Promise.resolve();
    $56eb4df4b51f9a4c$var$resolvedPromise.then(function() {
        return $2fFJv.nextTick(fn);
    });
} : setImmediate || setTimeout; // Private: cached resolved Promise instance
var $56eb4df4b51f9a4c$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $56eb4df4b51f9a4c$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize && (!existingBatch.cacheHits || existingBatch.cacheHits.length < loader._maxBatchSize)) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        return $56eb4df4b51f9a4c$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $56eb4df4b51f9a4c$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $56eb4df4b51f9a4c$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise = loader._batchLoadFn(batch.keys); // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $56eb4df4b51f9a4c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$56eb4df4b51f9a4c$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $56eb4df4b51f9a4c$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        return $56eb4df4b51f9a4c$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $56eb4df4b51f9a4c$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $56eb4df4b51f9a4c$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $56eb4df4b51f9a4c$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $56eb4df4b51f9a4c$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $56eb4df4b51f9a4c$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $56eb4df4b51f9a4c$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $56eb4df4b51f9a4c$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $56eb4df4b51f9a4c$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
} // Private
function $56eb4df4b51f9a4c$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $56eb4df4b51f9a4c$var$DataLoader;

});


parcelRegister("eR2Q8", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $ad0837e195fefed5$export$ac3214931ffd82af);

var $3izHV = parcelRequire("3izHV");
const $ad0837e195fefed5$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $3izHV.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("3izHV", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $271e34cd6fe1cabd$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("br8gy")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("br8gy")).isVideoMimeTypeSupportedByBrowser);

var $hZoAg = parcelRequire("hZoAg");

var $br8gy = parcelRequire("br8gy");

var $5BRco = parcelRequire("5BRco");
const $271e34cd6fe1cabd$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $hZoAg.isArchive)(mimeType)) return 'archive';
    if ((0, $br8gy.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $br8gy.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $br8gy.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $br8gy.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("hZoAg", function(module, exports) {

$parcel$export(module.exports, "isArchive", () => $4c79e3ce7fc2a8d0$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $4c79e3ce7fc2a8d0$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("br8gy", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $7e5c6394ef188971$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $7e5c6394ef188971$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$55ca6cdaf6093034 = (mimeType)=>$7e5c6394ef188971$export$74325e3c843a9555(mimeType) || $7e5c6394ef188971$export$c021f2623a75015f(mimeType) || $7e5c6394ef188971$export$ff36075ea755a717(mimeType) || $7e5c6394ef188971$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("5BRco", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $85f5842a210424b1$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $85f5842a210424b1$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $85f5842a210424b1$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $85f5842a210424b1$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $85f5842a210424b1$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $85f5842a210424b1$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$548d9148a80556a3 = (mimeType)=>$85f5842a210424b1$export$e9a065a80f76311e(mimeType) || $85f5842a210424b1$export$86baad7a89d908e9(mimeType) || $85f5842a210424b1$export$8cba23825d020bbb(mimeType) || $85f5842a210424b1$export$9c2b4de5fdca2ce3(mimeType) || $85f5842a210424b1$export$94e1479e01d2af53(mimeType);

});



parcelRegister("2crmE", function(module, exports) {

$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $19a1edb967390956$export$89097c0ec1e0dee1);

var $dTbMV = parcelRequire("dTbMV");
const $19a1edb967390956$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $dTbMV.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("klQrn", function(module, exports) {

$parcel$export(module.exports, "convertBase64ToBlob", () => $ed0e7265f45dd950$export$ed17558b11b88056);
const $ed0e7265f45dd950$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("lbU1T", function(module, exports) {

$parcel$export(module.exports, "fromObservable", () => $f6d6165a8d4b4393$export$4b2432e2d8723823);

var $hCY6c = parcelRequire("hCY6c");
function $f6d6165a8d4b4393$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $f6d6165a8d4b4393$export$8659d1f07d151381(item) {
    return $f6d6165a8d4b4393$export$4b2432e2d8723823((0, $hCY6c.createMediaSubject)(item));
}

});
parcelRegister("hCY6c", function(module, exports) {

$parcel$export(module.exports, "createMediaSubject", () => $cd549aab7e190c5e$export$bc76d51553fa5e35);

var $lXGL9 = parcelRequire("lXGL9");
function $cd549aab7e190c5e$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $lXGL9.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});


parcelRegister("2rj8v", function(module, exports) {

$parcel$export(module.exports, "toPromise", () => $1c6cf275eb34adf4$export$4dbaaf6c79705e6c);

var $hIoOm = parcelRequire("hIoOm");
const $1c6cf275eb34adf4$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $hIoOm.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("ly4iy", function(module, exports) {

$parcel$export(module.exports, "getDimensionsFromBlob", () => $fb001b7963d5a9dc$export$71797c284d89a3e1);

var $1DqxV = parcelRequire("1DqxV");

var $4DC1s = parcelRequire("4DC1s");
const $fb001b7963d5a9dc$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $1DqxV.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $4DC1s.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("1DqxV", function(module, exports) {

$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $130e0678d6c63cec$export$a1c3205f28a20414);
const $130e0678d6c63cec$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("4DC1s", function(module, exports) {

$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $36084c6b3099d16c$export$62aabd5ff85d0451);
const $36084c6b3099d16c$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("gMK6O", function(module, exports) {

$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $c384e54d4c96a4fe$export$2ccdd6f9a9eba6a);

var $br8gy = parcelRequire("br8gy");
var $5BRco = parcelRequire("5BRco");

var $4DC1s = parcelRequire("4DC1s");
async function $c384e54d4c96a4fe$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $br8gy.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $5BRco.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $4DC1s.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("21MgI", function(module, exports) {

$parcel$export(module.exports, "PollingFunction", () => $17a11dee2ad229c0$export$4c54d536f8e37dc2);

var $5zQU9 = parcelRequire("5zQU9");

var $coypO = parcelRequire("coypO");
const $17a11dee2ad229c0$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $17a11dee2ad229c0$export$4c54d536f8e37dc2 {
    constructor(options){
        (0, $5zQU9.default)(this, "poll_intervalMs", 0);
        (0, $5zQU9.default)(this, "attempt", 1);
        (0, $5zQU9.default)(this, "shouldIterate", true);
        (0, $5zQU9.default)(this, "timeoutId", 0);
        this.options = {
            ...$17a11dee2ad229c0$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $coypO.PollingError)('pollingMaxAttemptsExceeded', this.attempt));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $coypO.PollingError)('pollingMaxAttemptsExceeded', this.attempt));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("coypO", function(module, exports) {

$parcel$export(module.exports, "PollingError", () => $90626c13071b7c40$export$c3748c310e92340a);

var $8Jhci = parcelRequire("8Jhci");
class $90626c13071b7c40$export$c3748c310e92340a extends (0, $8Jhci.BaseMediaClientError) {
    constructor(reason, attempts){
        super(reason);
        this.reason = reason;
        this.attempts = attempts;
    }
    get attributes() {
        const { reason: reason, attempts: attempts } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $90626c13071b7c40$export$541e3e52eea6fece(err) {
    return err instanceof $90626c13071b7c40$export$c3748c310e92340a;
}

});


parcelRegister("duo45", function(module, exports) {

$parcel$export(module.exports, "isEmptyFile", () => $9d20be83f501b2c6$export$728192ce8dd94659);
/**
 * EMPTY_FILE_HOURS_ELAPSED_TOLERANCE - how many hours since this file was
 * created until we give up on expecting metadata?
 *
 * Yes, this is not an exact science. Any value under this tolerance will
 * go undetected, however this is still suitable to catch the majority of
 * cases where empty (files which never finished upload) are being reloaded.
 *
 * Continuous bad renders of empty files will eat our card render SLIs, so until
 * there is a better response from backend we use this technique.
 *
 * Being encapsulated in this function, we can always improve the detection transparently.
 */ const $9d20be83f501b2c6$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $9d20be83f501b2c6$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $9d20be83f501b2c6$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("gHZqD", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => (parcelRequire("exlxT")).mediaStore);

var $exlxT = parcelRequire("exlxT");

});
parcelRegister("exlxT", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => $107a0f046eaf76d8$export$5785580dea19518d);

var $7dY5U = parcelRequire("7dY5U");

var $2Qvr5 = parcelRequire("2Qvr5");

var $gQVOz = parcelRequire("gQVOz");
const $107a0f046eaf76d8$var$mediaStoreWithoutDevtools = (0, $gQVOz.createStore)()((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
        files: {}
    }))));
const $107a0f046eaf76d8$var$mediaStoreWithDevtools = (0, $gQVOz.createStore)()((0, $7dY5U.devtools)((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
        files: {}
    })))));
const $107a0f046eaf76d8$export$5785580dea19518d = $107a0f046eaf76d8$var$mediaStoreWithoutDevtools;
const $107a0f046eaf76d8$export$503459913a0dc356 = (initialStore)=>{
    return (0, $gQVOz.createStore)()((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("7dY5U", function(module, exports) {

$parcel$export(module.exports, "devtools", () => $45f0a2b2efc9d9f9$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $45f0a2b2efc9d9f9$export$5c593627aef9f076);
var $45f0a2b2efc9d9f9$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $45f0a2b2efc9d9f9$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $45f0a2b2efc9d9f9$export$4feba8a1bc8e9afd = $45f0a2b2efc9d9f9$var$reduxImpl;
const $45f0a2b2efc9d9f9$var$trackedConnections = /* @__PURE__ */ new Map();
const $45f0a2b2efc9d9f9$var$getTrackedConnectionState = (name)=>{
    const api = $45f0a2b2efc9d9f9$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $45f0a2b2efc9d9f9$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $45f0a2b2efc9d9f9$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $45f0a2b2efc9d9f9$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $45f0a2b2efc9d9f9$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) {
            if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $45f0a2b2efc9d9f9$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $45f0a2b2efc9d9f9$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $45f0a2b2efc9d9f9$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $45f0a2b2efc9d9f9$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $45f0a2b2efc9d9f9$export$6922d3b3a607469e = $45f0a2b2efc9d9f9$var$devtoolsImpl;
const $45f0a2b2efc9d9f9$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $45f0a2b2efc9d9f9$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $45f0a2b2efc9d9f9$export$5c593627aef9f076 = $45f0a2b2efc9d9f9$var$subscribeWithSelectorImpl;
const $45f0a2b2efc9d9f9$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $45f0a2b2efc9d9f9$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $45f0a2b2efc9d9f9$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $45f0a2b2efc9d9f9$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $45f0a2b2efc9d9f9$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $45f0a2b2efc9d9f9$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $45f0a2b2efc9d9f9$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $45f0a2b2efc9d9f9$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $45f0a2b2efc9d9f9$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $45f0a2b2efc9d9f9$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $45f0a2b2efc9d9f9$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $45f0a2b2efc9d9f9$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $45f0a2b2efc9d9f9$var$oldImpl(config, baseOptions);
    }
    return $45f0a2b2efc9d9f9$var$newImpl(config, baseOptions);
};
const $45f0a2b2efc9d9f9$export$9a6132153fba2e0 = $45f0a2b2efc9d9f9$var$persistImpl;

});

parcelRegister("2Qvr5", function(module, exports) {

$parcel$export(module.exports, "immer", () => $a3e9bebcfca14386$export$428de7ec69ac95c);

var $lbd4c = parcelRequire("lbd4c");
const $a3e9bebcfca14386$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $lbd4c.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $a3e9bebcfca14386$export$428de7ec69ac95c = $a3e9bebcfca14386$var$immerImpl;

});
parcelRegister("lbd4c", function(module, exports) {

$parcel$export(module.exports, "produce", () => fn);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $221c0e7836ac0785$export$2e2bcd8739ae039 = fn;

});


parcelRegister("gQVOz", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $14d460da377d9036$export$f51a9068ac82ea43);
var $14d460da377d9036$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $14d460da377d9036$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($14d460da377d9036$import_meta.env ? $14d460da377d9036$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $14d460da377d9036$export$f51a9068ac82ea43 = (createState)=>createState ? $14d460da377d9036$var$createStoreImpl(createState) : $14d460da377d9036$var$createStoreImpl;
var $14d460da377d9036$export$2e2bcd8739ae039 = (createState)=>{
    if (($14d460da377d9036$import_meta.env ? $14d460da377d9036$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $14d460da377d9036$export$f51a9068ac82ea43(createState);
};

});




parcelRegister("ghcHN", function(module, exports) {

$parcel$export(module.exports, "StargateClient", () => $bd9816e682c9912e$export$c66ca190f89caaac);
class $bd9816e682c9912e$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("kbZvn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('MNjII');
        const value = parcelRequire('g2VRH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("MNjII").then(()=>parcelRequire('g2VRH'));
}

});





parcelRegister("95Rby", function(module, exports) {

$parcel$export(module.exports, "getEmojiProvider", () => $dd0833923ef463d6$export$8210f5f78c0bcf27);
$parcel$export(module.exports, "getEmojiProviderWithCustomEmoji", () => $dd0833923ef463d6$export$f9c5a1e85ff0cb72);
$parcel$export(module.exports, "getEmojiProviderWithCustomEmojiUploadDisabled", () => $dd0833923ef463d6$export$7cda0fc535c2710f);

var $025IL = parcelRequire("025IL");

var $k7z88 = parcelRequire("k7z88");
const $dd0833923ef463d6$var$baseProviders = (serviceBaseUrl)=>[
        {
            url: `${serviceBaseUrl}/emoji/standard`
        },
        {
            url: `${serviceBaseUrl}/emoji/atlassian`
        }
    ];
const $dd0833923ef463d6$export$8210f5f78c0bcf27 = ()=>(0, $k7z88.getServiceProvider)((0, $k7z88.EMOJI_SERVICEID), (serviceBaseUrl)=>{
        const emojiResource = new (0, $025IL.default)({
            providers: $dd0833923ef463d6$var$baseProviders(serviceBaseUrl)
        });
        return emojiResource.getEmojiProvider();
    });
const $dd0833923ef463d6$export$f9c5a1e85ff0cb72 = (cloudId, accountId)=>(0, $k7z88.getServiceProvider)((0, $k7z88.EMOJI_WITH_CUSTOM_SERVICEID), (serviceBaseUrl)=>{
        const providers = cloudId ? [
            ...$dd0833923ef463d6$var$baseProviders(serviceBaseUrl),
            {
                url: `${serviceBaseUrl}/emoji/${cloudId}/site`
            }
        ] : $dd0833923ef463d6$var$baseProviders(serviceBaseUrl);
        const emojiResource = new (0, $025IL.default)({
            providers: providers,
            allowUpload: true,
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            currentUser: {
                id: accountId
            }
        });
        return emojiResource.getEmojiProvider();
    });
const $dd0833923ef463d6$export$7cda0fc535c2710f = (cloudId, accountId)=>(0, $k7z88.getServiceProvider)((0, $k7z88.EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID), (serviceBaseUrl)=>{
        const providers = cloudId ? [
            ...$dd0833923ef463d6$var$baseProviders(serviceBaseUrl),
            {
                url: `${serviceBaseUrl}/emoji/${cloudId}/site`
            }
        ] : $dd0833923ef463d6$var$baseProviders(serviceBaseUrl);
        const emojiResource = new (0, $025IL.default)({
            providers: providers,
            allowUpload: false,
            // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string'.
            currentUser: {
                id: accountId
            }
        });
        return emojiResource.getEmojiProvider();
    });

});
parcelRegister("025IL", function(module, exports) {

$parcel$export(module.exports, "supportsUploadFeature", () => $0064a011bcb5b45e$export$7b697b720032fd6f);
$parcel$export(module.exports, "default", () => $0064a011bcb5b45e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
parcelRequire("16UJG");
var $gdgmj = parcelRequire("gdgmj");
var $16UJG = parcelRequire("16UJG");

var $lgmTv = parcelRequire("lgmTv");

var $lACco = parcelRequire("lACco");

var $aQtlX = parcelRequire("aQtlX");

var $8y8qh = parcelRequire("8y8qh");

var $dnGEj = parcelRequire("dnGEj");

var $gA77v = parcelRequire("gA77v");

var $2K0Jm = parcelRequire("2K0Jm");

var $hlFHe = parcelRequire("hlFHe");

var $1UFsQ = parcelRequire("1UFsQ");
const $0064a011bcb5b45e$export$7b697b720032fd6f = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
class $0064a011bcb5b45e$export$b5efafc6dd611ec5 extends (0, $gdgmj.AbstractResource) {
    constructor(config){
        super();
        (0, $5zQU9.default)(this, "activeLoaders", 0);
        (0, $5zQU9.default)(this, "initialLoaders", 0);
        (0, $5zQU9.default)(this, "retries", new Map());
        (0, $5zQU9.default)(this, "isInitialised", false);
        (0, $5zQU9.default)(this, "fetchOnDemand", false);
        (0, $5zQU9.default)(this, "getOptimisticImageURL", (emojiId)=>{
            if (this.emojiProviderConfig.optimisticImageApi) return this.emojiProviderConfig.optimisticImageApi.getUrl(emojiId);
            return;
        });
        (0, $5zQU9.default)(this, "isRepositoryAvailable", (repository)=>{
            return !!repository;
        });
        (0, $5zQU9.default)(this, "isLoaded", ()=>this.initialLoaders !== 0 && this.activeLoaders === 0);
        this.emojiProviderConfig = config;
        this.recordConfig = config.recordConfig;
        this.currentUser = config.currentUser;
        if ((0, $8y8qh.default)('localStorage')) this.selectedTone = this.loadStoredTone();
        if (config.providers.length === 0) throw new Error('No providers specified');
        this.fetchOnDemand = !!config.options && !!config.options.onlyFetchOnDemand;
        this.initialLoaders = this.emojiProviderConfig.providers.length;
        this.activeLoaders = this.emojiProviderConfig.providers.length;
        this.emojiResponses = [];
    }
    /**
   * Get the emoji provider from Emoji Resource
   * @returns Promise<EmojiProvider>
   */ async getEmojiProvider(options = {
        fetchAtStart: !this.fetchOnDemand
    }) {
        if (options.fetchAtStart) try {
            await this.fetchEmojiProvider();
        } catch (error) {
            (0, $lACco.default)(error);
            return Promise.resolve(this);
        }
        return Promise.resolve(this);
    }
    async fetchIndividualProvider(provider, index) {
        const providerType = this.getProviderType(provider);
        try {
            (0, $1UFsQ.sampledUfoEmojiResourceFetched)(providerType).start({
                samplingRate: (0, $lgmTv.SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP)
            });
            (0, $1UFsQ.sampledUfoEmojiResourceFetched)(providerType).addMetadata({
                type: providerType
            });
            const loader = new (0, $gA77v.default)(provider);
            // fetch emoji from provider url and denormalise
            const emojiResponse = await loader.loadEmoji();
            (0, $1UFsQ.sampledUfoEmojiResourceFetched)(providerType).success();
            // setup emoji repository
            this.emojiResponses[index] = emojiResponse;
            this.initEmojiRepository(this.emojiResponses);
            await this.initSiteEmojiResource(emojiResponse, provider);
            this.activeLoaders--;
            this.performRetries();
            this.refreshLastFilter();
        } catch (error) {
            this.activeLoaders--;
            this.notifyError(error);
            (0, $1UFsQ.sampledUfoEmojiResourceFetched)(providerType).failure({
                metadata: {
                    reason: error,
                    source: 'EmojiProvider',
                    providerUrl: provider.url
                }
            });
            (0, $lACco.default)(`failed to fetch emoji provider for ${provider.url}`, error);
            throw new Error(`failed to fetch emoji from ${provider.url}`);
        }
    }
    async fetchEmojiProvider(force = false) {
        // unless (re-)fetch is being forced, fetching will only
        // happen if no emojiRepository exists
        // in case this method is called and emojiRepository has already been populated
        // the method will just return the existing emojiRepository
        if (force || !this.isRepositoryAvailable(this.emojiRepository) && !this.isInitialised) {
            this.isInitialised = true;
            this.emojiResponses = [];
            // fetch emoji providers
            await Promise.all(this.emojiProviderConfig.providers.map((provider, index)=>this.fetchIndividualProvider(provider, index)));
        }
        return Promise.resolve(this.emojiRepository);
    }
    onlyFetchOnDemand() {
        return this.fetchOnDemand;
    }
    async fetchByEmojiId(emojiId, optimistic) {
        // Check if repository exists and emoji is defined.
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) {
            const emoji = await this.findByEmojiId(emojiId);
            if (emoji) return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        }
        // If optimistic is fetched
        if (this.emojiProviderConfig.singleEmojiApi && optimistic) {
            // if config has singleEmojiApi then fetch single emoji
            const provider = {
                url: this.emojiProviderConfig.singleEmojiApi.getUrl(emojiId),
                securityProvider: this.emojiProviderConfig.singleEmojiApi.securityProvider
            };
            const loader = new (0, $gA77v.default)(provider);
            try {
                const loadEmoji = await loader.loadEmoji();
                if (!loadEmoji.emojis[0]) return;
                if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(loadEmoji, provider);
                return this.getMediaEmojiDescriptionURLWithInlineToken(loadEmoji.emojis[0]);
            } catch  {
                const emoji = await this.findByEmojiId(emojiId);
                if (!emoji) return;
                return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
            }
        }
        const emoji = await this.findByEmojiId(emojiId);
        if (!emoji) return;
        return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
    }
    getProviderType(provider) {
        if (provider.url.includes('/site')) return (0, $dnGEj.ProviderTypes).SITE;
        else if (provider.url.includes('/standard')) return (0, $dnGEj.ProviderTypes).STANDARD;
        else if (provider.url.includes('/atlassian')) return (0, $dnGEj.ProviderTypes).ATLASSIAN;
        return (0, $dnGEj.ProviderTypes).UNKNOWN;
    }
    initEmojiRepository(emojiResponses) {
        let emojis = [];
        emojiResponses.forEach((emojiResponse)=>{
            emojis = emojis.concat(emojiResponse.emojis);
        });
        this.emojiRepository = new (0, $2K0Jm.default)(emojis);
    }
    initSiteEmojiResource(emojiResponse, provider) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) && emojiResponse.mediaApiToken) {
            this.siteEmojiResource = new (0, $hlFHe.default)(provider, emojiResponse.mediaApiToken);
            // Prime cache type + optimistic rendering by checking first Emoji.
            // If this is fails, it won't be primed until a good emoji is loaded later.
            const { emojis: emojis } = emojiResponse;
            if (emojis.length) {
                const done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                if ((0, $aQtlX.isPromise)(done)) return done.then(()=>{
                    (0, $lACco.default)('Primed siteEmojiResource');
                }).catch(()=>{
                    (0, $lACco.default)('Failed to prime siteEmojiResource');
                });
                else (0, $lACco.default)('Already primed siteEmojiResource');
            } else (0, $lACco.default)('No emoji to prime siteEmojiResource with');
        }
        return Promise.resolve();
    }
    performRetries() {
        const currentRetries = this.retries;
        this.retries = new Map();
        currentRetries.forEach((resolveReject, retry)=>{
            const result = retry();
            if ((0, $aQtlX.isPromise)(result)) result.then((response)=>{
                resolveReject.resolve(response);
            }).catch((reason)=>{
                resolveReject.reject(reason);
            });
            else resolveReject.resolve(result);
        });
    }
    loadStoredTone() {
        if (typeof window === 'undefined') return undefined;
        const storedToneString = window.localStorage.getItem((0, $lgmTv.selectedToneStorageKey));
        if (storedToneString) {
            const storedTone = parseInt(storedToneString, 10);
            return !isNaN(storedTone) ? storedTone : undefined;
        }
        return undefined;
    }
    refreshLastFilter() {
        if (typeof this.lastQuery !== 'undefined') {
            const { query: query, options: options } = this.lastQuery;
            this.filter(query, options);
        }
    }
    retryIfLoading(retry, defaultResponse) {
        if (!this.isLoaded()) return new Promise((resolve, reject)=>{
            this.retries.set(retry, {
                resolve: resolve,
                reject: reject
            });
        });
        return Promise.resolve(defaultResponse);
    }
    notifyResult(result) {
        if (this.lastQuery && result.query === this.lastQuery.query) super.notifyResult(result);
    }
    /**
   *  Returns the EmojiDescription with a valid media path that includes query token and client attributes to access the emoji media inline.
   */ async getMediaEmojiDescriptionURLWithInlineToken(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) {
            const { representation: representation, altRepresentation: altRepresentation } = await this.siteEmojiResource.generateTokenisedMediaURLS(emoji.representation, emoji.altRepresentation);
            return {
                ...emoji,
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
        return emoji;
    }
    loadMediaEmoji(emoji, useAlt) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) || !(0, $aQtlX.isMediaEmoji)(emoji)) return emoji;
        return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
    }
    optimisticMediaRendering(emoji, useAlt) {
        if (!(0, $aQtlX.isMediaEmoji)(emoji)) return true;
        if (!this.isRepositoryAvailable(this.siteEmojiResource)) // Shouldn't have a media emoji without a siteEmojiResouce, but anyway ;)
        return false;
        const optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
        if ((0, $aQtlX.isPromise)(optimistic)) // Not sure yet, so lets say no for now (this should normally be primed in most/all cases)
        return false;
        return optimistic;
    }
    filter(query, options) {
        (0, $1UFsQ.ufoExperiences)['emoji-searched'].start();
        (0, $1UFsQ.ufoExperiences)['emoji-searched'].addMetadata({
            queryLength: (query === null || query === void 0 ? void 0 : query.length) || 0
        });
        this.lastQuery = {
            query: query,
            options: options
        };
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            const searchResults = this.emojiRepository.search(query, options);
            this.notifyResult(searchResults);
            (0, $1UFsQ.ufoExperiences)['emoji-searched'].success({
                metadata: {
                    emojisLength: searchResults.emojis.length,
                    source: (options === null || options === void 0 ? void 0 : options.source) || 'typeahead'
                }
            });
        } else // not ready
        this.notifyNotReady();
    }
    findByShortName(shortName) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) // Wait for all emoji to load before looking by shortName (to ensure correct priority)
        return this.emojiRepository.findByShortName(shortName);
        return this.retryIfLoading(()=>this.findByShortName(shortName), undefined);
    }
    findByEmojiId(emojiId) {
        const { id: id, shortName: shortName } = emojiId;
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            if (id) {
                const emoji = this.emojiRepository.findById(id);
                if (emoji) return emoji;
                if (this.isLoaded()) {
                    // all loaded but not found by id, try server to see if
                    // this is a newly uploaded emoji
                    if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.findEmoji(emojiId).then((emoji)=>{
                        if (!emoji) // if not, fallback to searching by shortName to
                        // at least render an alternative
                        return this.findByShortName(shortName);
                        this.addUnknownEmoji(emoji);
                        return emoji;
                    });
                    // if not, fallback to searching by shortName to
                    // at least render an alternative
                    return this.findByShortName(shortName);
                }
            } else // no id fallback to shortName
            return this.findByShortName(shortName);
        }
        return this.retryIfLoading(()=>this.findByEmojiId(emojiId), undefined);
    }
    findById(id) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findById(id);
        return this.retryIfLoading(()=>this.findById(id), undefined);
    }
    findInCategory(categoryId) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
        return this.retryIfLoading(()=>this.findInCategory(categoryId), []);
    }
    getAsciiMap() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getAsciiMap());
        return this.retryIfLoading(()=>this.getAsciiMap(), new Map());
    }
    getFrequentlyUsed(options) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
        return this.retryIfLoading(()=>this.getFrequentlyUsed(options), []);
    }
    /**
   * Record the selection of an emoji to a remote service if 'recordConfig' has been supplied.
   * Regardless of the recordConfig, emoji selections will always be recorded on the EmojiRepository
   * for the purposes of tracking the frequency of use.
   *
   * @param emoji The full description of the emoji to record usage for.
   */ recordSelection(emoji) {
        const { recordConfig: recordConfig } = this;
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.used(emoji);
        if (recordConfig) {
            const queryParams = {
                emojiId: (0, $aQtlX.toEmojiId)(emoji)
            };
            const requestInit = {
                method: 'POST'
            };
            return (0, $16UJG.utils).requestService(recordConfig, {
                queryParams: queryParams,
                requestInit: requestInit
            });
        }
        return Promise.resolve();
    }
    deleteSiteEmoji(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource) && emoji.id) return this.siteEmojiResource.deleteEmoji(emoji).then((success)=>{
            if (success && this.isRepositoryAvailable(this.emojiRepository)) {
                this.emojiRepository.delete(emoji);
                return true;
            }
            return false;
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('failed to delete site emoji', err);
            return false;
        });
        return this.retryIfLoading(()=>this.deleteSiteEmoji(emoji), false);
    }
    getSelectedTone() {
        return this.selectedTone;
    }
    setSelectedTone(tone) {
        this.selectedTone = tone;
        if (typeof window === 'undefined') return;
        if ((0, $8y8qh.default)('localStorage')) try {
            window.localStorage.setItem((0, $lgmTv.selectedToneStorageKey), tone ? tone.toString() : '');
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('failed to store selected emoji skin tone', e);
        }
    }
    calculateDynamicCategories() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
        return this.retryIfLoading(()=>this.calculateDynamicCategories(), []);
    }
    getCurrentUser() {
        return this.currentUser;
    }
    addUnknownEmoji(emoji) {
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.addUnknownEmoji(emoji);
    }
}
class $0064a011bcb5b45e$export$2e2bcd8739ae039 extends $0064a011bcb5b45e$export$b5efafc6dd611ec5 {
    constructor(config){
        super(config);
        this.allowUpload = !!config.allowUpload;
    }
    isUploadSupported() {
        if (!this.allowUpload) return Promise.resolve(false);
        if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.hasUploadToken();
        return this.retryIfLoading(()=>this.isUploadSupported(), false);
    }
    uploadCustomEmoji(upload, retry = false) {
        return this.isUploadSupported().then((supported)=>{
            if (!supported || !this.isRepositoryAvailable(this.siteEmojiResource)) return Promise.reject('No media api support is configured');
            return this.siteEmojiResource.uploadEmoji(upload, retry).then((emoji)=>{
                // Use file preview blob URL to temporarily fix the graybox issue after uploading,
                // Because the media service takes time to process the image.
                // Ideally should improve CachingMediaImage by using mediaClient or mediaImage,
                // But that requires more efforts in FE & BE.
                // TODO: revist this when pick up COLLAB-2294
                emoji.representation.imagePath = upload.dataURL;
                this.addUnknownEmoji(emoji);
                this.refreshLastFilter();
                return emoji;
            });
        });
    }
    prepareForUpload() {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) this.siteEmojiResource.prepareForUpload();
        return this.retryIfLoading(()=>this.prepareForUpload(), undefined);
    }
}

});
parcelRegister("lgmTv", function(module, exports) {

$parcel$export(module.exports, "customCategory", () => $f7acd9e91e56a098$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $f7acd9e91e56a098$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $f7acd9e91e56a098$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $f7acd9e91e56a098$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $f7acd9e91e56a098$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $f7acd9e91e56a098$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $f7acd9e91e56a098$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $f7acd9e91e56a098$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $f7acd9e91e56a098$export$1a817f1886276c6d);
$parcel$export(module.exports, "defaultEmojiHeight", () => $f7acd9e91e56a098$export$3f99ac31dc0406db);
$parcel$export(module.exports, "emojiPickerWidth", () => $f7acd9e91e56a098$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $f7acd9e91e56a098$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $f7acd9e91e56a098$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerMinHeight", () => $f7acd9e91e56a098$export$94f75d625e7801d3);
$parcel$export(module.exports, "emojiPickerHeight", () => $f7acd9e91e56a098$export$7ed599d166d65aea);
$parcel$export(module.exports, "emojiPickerListHeight", () => $f7acd9e91e56a098$export$7722b8e9522021df);
$parcel$export(module.exports, "emojiPickerHeightWithPreview", () => $f7acd9e91e56a098$export$e67f617938b111f1);
$parcel$export(module.exports, "localStoragePrefix", () => $f7acd9e91e56a098$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $f7acd9e91e56a098$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "defaultCategories", () => $f7acd9e91e56a098$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $f7acd9e91e56a098$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $f7acd9e91e56a098$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $f7acd9e91e56a098$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $f7acd9e91e56a098$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $f7acd9e91e56a098$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $f7acd9e91e56a098$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $f7acd9e91e56a098$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $f7acd9e91e56a098$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $f7acd9e91e56a098$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $f7acd9e91e56a098$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $f7acd9e91e56a098$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $f7acd9e91e56a098$export$66cabad5e268b05e);
const $f7acd9e91e56a098$export$5e4e3d1c3e43156a = 'CUSTOM';
const $f7acd9e91e56a098$export$78ccdc4be403c468 = 'FREQUENT';
const $f7acd9e91e56a098$export$2c4b04c3aacdf1b3 = 'SITE';
const $f7acd9e91e56a098$export$1b0258512be88334 = 'SEARCH';
const $f7acd9e91e56a098$export$42b510423367f354 = 'USER_CUSTOM';
const $f7acd9e91e56a098$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $f7acd9e91e56a098$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $f7acd9e91e56a098$export$8ac325bfd32359b0 = 'data:';
const $f7acd9e91e56a098$export$a330961542edfe6f = 'delete-emoji';
const $f7acd9e91e56a098$export$1a817f1886276c6d = 100000;
const $f7acd9e91e56a098$export$3f99ac31dc0406db = 20;
const $f7acd9e91e56a098$export$d171dc12fee2b1da = 350;
const $f7acd9e91e56a098$export$c10ac8125a260041 = 80;
const $f7acd9e91e56a098$export$5248fb9e0cccc41f = 'medium';
const $f7acd9e91e56a098$export$94f75d625e7801d3 = 260;
const $f7acd9e91e56a098$export$7ed599d166d65aea = 295;
const $f7acd9e91e56a098$export$7722b8e9522021df = $f7acd9e91e56a098$export$7ed599d166d65aea - 58; // picker height - actions height
const $f7acd9e91e56a098$export$e218e5cb105a0e22 = 54;
const $f7acd9e91e56a098$export$e67f617938b111f1 = $f7acd9e91e56a098$export$7ed599d166d65aea + $f7acd9e91e56a098$export$e218e5cb105a0e22;
const $f7acd9e91e56a098$export$e394a0c530ae5631 = 'fabric.emoji';
const $f7acd9e91e56a098$export$79ee4ef84c545f8f = `${$f7acd9e91e56a098$export$e394a0c530ae5631}.selectedTone`;
const $f7acd9e91e56a098$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
let $f7acd9e91e56a098$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
let $f7acd9e91e56a098$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
const $f7acd9e91e56a098$export$99130b698ea188ae = [
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.ArrowRight,
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.ArrowLeft,
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.Home,
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.End
];
const $f7acd9e91e56a098$export$84b035f8d01101cc = [
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.Enter,
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.Backspace,
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.Space
];
const $f7acd9e91e56a098$export$e27d4e477c0cd4ec = [
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.Enter,
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.Tab,
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.Space
];
const $f7acd9e91e56a098$export$97027974dc06eeee = [
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.ArrowRight,
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.ArrowLeft,
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.Home,
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.End,
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.ArrowUp,
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.ArrowDown,
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.PageUp,
    $f7acd9e91e56a098$export$70f9e5bc10d7eac.PageDown
];
const $f7acd9e91e56a098$export$4f0ee90b28d6efc5 = 0;
const $f7acd9e91e56a098$export$9f7de4293d27f3aa = 50;
const $f7acd9e91e56a098$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $f7acd9e91e56a098$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $f7acd9e91e56a098$export$2829f3ec323f8ec0 = 8;
const $f7acd9e91e56a098$export$ce3a0e7d2d7d6ba2 = 5;
const $f7acd9e91e56a098$export$858e8dc100a97278 = 150;
const $f7acd9e91e56a098$export$83aab2ae64548423 = 20;
const $f7acd9e91e56a098$export$66cabad5e268b05e = 100;

});

parcelRegister("lACco", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb7a97462906d60c$export$2e2bcd8739ae039);
let $fb7a97462906d60c$var$debugEnabled = false;
let $fb7a97462906d60c$var$stacktracesEnabled = false;
function $fb7a97462906d60c$export$748ada60eaf985cc(enable) {
    $fb7a97462906d60c$var$debugEnabled = enable;
}
function $fb7a97462906d60c$export$4f7017086af31c25(enable) {
    $fb7a97462906d60c$var$stacktracesEnabled = enable;
}
function $fb7a97462906d60c$export$2a858f450a2f66d() {
    if ($fb7a97462906d60c$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $fb7a97462906d60c$export$2e2bcd8739ae039(msg, ...args) {
    if ($fb7a97462906d60c$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("aQtlX", function(module, exports) {

$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $7e55879f1adb7371$export$1c52f72b88b558e8);
$parcel$export(module.exports, "isSpriteRepresentation", () => $7e55879f1adb7371$export$a194199d673d75de);
$parcel$export(module.exports, "isImageRepresentation", () => $7e55879f1adb7371$export$90b099a26fbd8b41);
$parcel$export(module.exports, "isMediaRepresentation", () => $7e55879f1adb7371$export$979133dc1df141c6);
$parcel$export(module.exports, "isPromise", () => $7e55879f1adb7371$export$4369c812aac99591);
$parcel$export(module.exports, "isEmojiDescription", () => $7e55879f1adb7371$export$378ed2c87d03531c);
$parcel$export(module.exports, "isMediaEmoji", () => $7e55879f1adb7371$export$a7e82c67204c73a1);
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $7e55879f1adb7371$export$d25a80b2c86d7fdf);
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $7e55879f1adb7371$export$b0ed6d8df471f3cc);
$parcel$export(module.exports, "isEmojiVariationDescription", () => $7e55879f1adb7371$export$82a0350e1f6b5c0a);
$parcel$export(module.exports, "isMessagesKey", () => $7e55879f1adb7371$export$dddfba07c16c94d2);
$parcel$export(module.exports, "toEmojiId", () => $7e55879f1adb7371$export$8d7d3de6b5b305d1);
$parcel$export(module.exports, "containsEmojiId", () => $7e55879f1adb7371$export$39ed0ad389e58ef7);
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $7e55879f1adb7371$export$20a1bd1d33069ce7);
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $7e55879f1adb7371$export$f1a89a11f425faaa);
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $7e55879f1adb7371$export$a48c58c688a3131);
$parcel$export(module.exports, "getCategoryId", () => $7e55879f1adb7371$export$4bcbf61cb6832a8e);

var $ldLeQ = parcelRequire("ldLeQ");

var $lgmTv = parcelRequire("lgmTv");
const $7e55879f1adb7371$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
const $7e55879f1adb7371$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
const $7e55879f1adb7371$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
const $7e55879f1adb7371$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
const $7e55879f1adb7371$export$4369c812aac99591 = (p)=>!!(p && p.then);
const $7e55879f1adb7371$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
const $7e55879f1adb7371$export$a7e82c67204c73a1 = (emoji)=>$7e55879f1adb7371$export$979133dc1df141c6(emoji.representation);
const $7e55879f1adb7371$export$7720a4954d6f75f8 = (rep)=>$7e55879f1adb7371$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, $lgmTv.dataURLPrefix)) === 0;
const $7e55879f1adb7371$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $lgmTv.customCategory) && $7e55879f1adb7371$export$7720a4954d6f75f8(emoji.representation);
const $7e55879f1adb7371$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
const $7e55879f1adb7371$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};
const $7e55879f1adb7371$export$dddfba07c16c94d2 = (key)=>key in (0, $ldLeQ.messages);
const $7e55879f1adb7371$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });
const $7e55879f1adb7371$export$2dbfa5a5d35af350 = (emoji)=>{
    if (!emoji) return undefined;
    return $7e55879f1adb7371$export$8d7d3de6b5b305d1(emoji);
};
const $7e55879f1adb7371$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
const $7e55879f1adb7371$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
    if (!emojiId) return false;
    for(let i = 0; i < emojis.length; i++){
        if ($7e55879f1adb7371$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
    }
    return false;
};
const $7e55879f1adb7371$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });
const $7e55879f1adb7371$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });
const $7e55879f1adb7371$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!$7e55879f1adb7371$export$979133dc1df141c6(mediaRepresentation) && !$7e55879f1adb7371$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
    const representation = $7e55879f1adb7371$export$979133dc1df141c6(mediaRepresentation) ? $7e55879f1adb7371$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = $7e55879f1adb7371$export$979133dc1df141c6(mediaAltRepresentation) ? $7e55879f1adb7371$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return $7e55879f1adb7371$export$a48c58c688a3131(baseEmoji, altRepresentation);
};
const $7e55879f1adb7371$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};
const $7e55879f1adb7371$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});
parcelRegister("ldLeQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f72f7471226bd45e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $f72f7471226bd45e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder for search emoji field'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'verb - button label to search'
    },
    searchResultsStatus: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Found {count} emojis',
        description: 'search results status for screenreader to read out'
    },
    searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Productivity',
        description: 'Emoji productivity category'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Aria label for emoji picker'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});


parcelRegister("8y8qh", function(module, exports) {

$parcel$export(module.exports, "default", () => $639808521c5811a4$export$2e2bcd8739ae039);
// Copied from https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#feature-detecting_localstorage
// a brief history of local storage - https://gist.github.com/paulirish/5558557
function $639808521c5811a4$export$2e2bcd8739ae039(type) {
    if (typeof window === 'undefined') return false;
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}

});

parcelRegister("dnGEj", function(module, exports) {

$parcel$export(module.exports, "SearchSort", () => $9bde8199aeb9f604$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $9bde8199aeb9f604$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $9bde8199aeb9f604$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $9bde8199aeb9f604$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $9bde8199aeb9f604$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $9bde8199aeb9f604$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $9bde8199aeb9f604$export$482549d945a3723);
/**
 * Minimum information to defined an emoji is the shortName.
 * In order to uniquely define an emoji, the id should be included, and is
 * used in preference to shortName if provided, and has a matching emoji.
 * If not emoji can be found by id (e.g. a custom emoji has been removed),
 * fallback behaviour will be to attempt to find a matching emoji by shortName.
 */ /**
 * Sprite representation exposed from the EmojiResource.
 */ /**
 * Representation returned from a sprite service.
 */ /**
 * Describes an emoji which is a variant of some base emoji. This is used when you want to promote the
 * skinVariations in an EmojiDescriptionWithVariations to represent them along side their base representations.
 */ /**
 * An access token for emoji stored in the MediaApi
 * (indicated by urls beginning with the url of the token.)
 */ /**
 * The expected response from an Emoji service.
 */ let $9bde8199aeb9f604$export$a15e9a4340d08b2e = /*#__PURE__*/ function(SearchSort) {
    SearchSort[SearchSort["None"] = 0] = "None";
    SearchSort[SearchSort["Default"] = 1] = "Default";
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    return SearchSort;
}({});
let $9bde8199aeb9f604$export$db41220f541db607 = /*#__PURE__*/ function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    return SearchSourceTypes;
}({});
let $9bde8199aeb9f604$export$bf337c9223e5c8b = /*#__PURE__*/ function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
    return ProviderTypes;
}({});
let $9bde8199aeb9f604$export$d0d1c9cd31a11a64 = /*#__PURE__*/ function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    return UfoExperienceName;
}({});
let $9bde8199aeb9f604$export$122ce5c8fda96269 = /*#__PURE__*/ function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    return UfoComponentName;
}({});
let $9bde8199aeb9f604$export$265ee18146a6885e = /*#__PURE__*/ function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    return UfoEmojiTimingsKeys;
}({});
let $9bde8199aeb9f604$export$482549d945a3723 = /*#__PURE__*/ function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    return UfoEmojiTimings;
}({});

});

parcelRegister("gA77v", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1258802a86ee49e$export$2e2bcd8739ae039);

var $9cbEs = parcelRequire("9cbEs");
class $c1258802a86ee49e$export$2e2bcd8739ae039 {
    constructor(config){
        this.config = config;
    }
    /**
   * Returns a promise with an array of Emoji from all providers.
   */ loadEmoji() {
        const emojisPromise = (0, $9cbEs.emojiRequest)(this.config);
        return emojisPromise.then((emojiServiceResponse)=>(0, $9cbEs.denormaliseEmojiServiceResponse)(emojiServiceResponse));
    }
}

});
parcelRegister("9cbEs", function(module, exports) {

$parcel$export(module.exports, "emojiRequest", () => $6b1e45d0f5d53d8a$export$ea1accde4cc117f4);
$parcel$export(module.exports, "getAltRepresentation", () => $6b1e45d0f5d53d8a$export$4a0301d636367e1d);
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $6b1e45d0f5d53d8a$export$afaea97e40b5ca70);
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $6b1e45d0f5d53d8a$export$b7e9058f156d8d19);

var $16UJG = parcelRequire("16UJG");

var $aQtlX = parcelRequire("aQtlX");

var $lACco = parcelRequire("lACco");
const $6b1e45d0f5d53d8a$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = $6b1e45d0f5d53d8a$export$d39ce20a37bba061, ...serviceConfig } = provider;
    const scaleQueryParams = $6b1e45d0f5d53d8a$var$calculateScale(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $16UJG.utils).requestService(serviceConfig, requestOptions);
};
const $6b1e45d0f5d53d8a$var$calculateScale = (getRatio)=>{
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};
const $6b1e45d0f5d53d8a$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};
const $6b1e45d0f5d53d8a$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[$6b1e45d0f5d53d8a$var$calculateScale($6b1e45d0f5d53d8a$export$d39ce20a37bba061).altScale];
};
const $6b1e45d0f5d53d8a$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
const $6b1e45d0f5d53d8a$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $aQtlX.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $aQtlX.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ($6b1e45d0f5d53d8a$export$db05e6ae1fd416af(imagePath, meta)) return (0, $aQtlX.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $lACco.default)('failed conversion for representation', representation, meta);
    return undefined;
};
const $6b1e45d0f5d53d8a$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : $6b1e45d0f5d53d8a$export$55077db3efc820aa($6b1e45d0f5d53d8a$export$4a0301d636367e1d(altReps), meta);
};
const $6b1e45d0f5d53d8a$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: $6b1e45d0f5d53d8a$export$55077db3efc820aa(representation, meta),
            altRepresentation: $6b1e45d0f5d53d8a$export$aa9faa01267cb2e7(altRepresentations, meta),
            ...other
        };
    });
};
const $6b1e45d0f5d53d8a$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = $6b1e45d0f5d53d8a$export$55077db3efc820aa(emoji.representation, emojiData.meta);
        const altRepresentation = $6b1e45d0f5d53d8a$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = $6b1e45d0f5d53d8a$export$e3da49c88c2e54d5(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: representation, skinVariations: skinVariations, altRepresentations: altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $aQtlX.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};
const $6b1e45d0f5d53d8a$var$getHeight = (fitToHeight)=>$6b1e45d0f5d53d8a$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
const $6b1e45d0f5d53d8a$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $6b1e45d0f5d53d8a$var$getHeight(fitToHeight) > emoji.representation.height);

});


parcelRegister("2K0Jm", function(module, exports) {

$parcel$export(module.exports, "getEmojiVariation", () => $1ff071be7e19cc86$export$e55e46e1520c899d);
$parcel$export(module.exports, "default", () => $1ff071be7e19cc86$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $iluEd = parcelRequire("iluEd");

var $lgmTv = parcelRequire("lgmTv");

var $aQtlX = parcelRequire("aQtlX");

var $dnGEj = parcelRequire("dnGEj");

var $5LLHg = parcelRequire("5LLHg");

var $iFBgY = parcelRequire("iFBgY");

var $e1D8Y = parcelRequire("e1D8Y");
// FS-1097 - duplicated in mentions - extract at some point into a shared library
class $1ff071be7e19cc86$var$Tokenizer {
    tokenize(text) {
        return this.tokenizeAsTokens(text).map((token)=>token.token);
    }
    tokenizeAsTokens(text) {
        let match;
        let tokens = [];
        (0, $5LLHg.tokenizerRegex).lastIndex = 0;
        while((match = (0, $5LLHg.tokenizerRegex).exec(text)) !== null)if (match[0]) tokens.push({
            token: match[0],
            start: match.index
        });
        return tokens;
    }
}
const $1ff071be7e19cc86$var$addAllVariants = (emoji, fnKey, map)=>{
    const key = fnKey(emoji);
    if (!map.has(key)) map.set(key, []);
    const emojisForKey = map.get(key);
    // Unnecessary, but typescript thinks it is. :/
    if (emojisForKey) emojisForKey.push(emoji);
    if ((0, $aQtlX.isEmojiDescriptionWithVariations)(emoji)) {
        // map variations too
        const variations = emoji.skinVariations;
        if (variations) variations.forEach((variation)=>$1ff071be7e19cc86$var$addAllVariants(variation, fnKey, map));
    }
};
const $1ff071be7e19cc86$var$findByKey = (map, key)=>{
    const emojis = map.get(key);
    if (emojis && emojis.length) // Priority is always to source from the last emoji set (last overrides first)
    return emojis[emojis.length - 1];
    return undefined;
};
const $1ff071be7e19cc86$var$splitQuery = (query = '')=>{
    const isColonQuery = query.indexOf(':') === 0;
    if (isColonQuery) return {
        nameQuery: query.slice(1),
        asciiQuery: query
    };
    return {
        nameQuery: query,
        asciiQuery: ''
    };
};
const $1ff071be7e19cc86$export$e55e46e1520c899d = (emoji, options)=>{
    if ((0, $aQtlX.isEmojiDescriptionWithVariations)(emoji) && options) {
        const skinTone = options.skinTone;
        if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
            const skinToneEmoji = emoji.skinVariations[skinTone - 1]; // skinTone start at 1
            if (skinToneEmoji) return skinToneEmoji;
        }
    }
    return emoji;
};
const $1ff071be7e19cc86$var$findEmojiIndex = (emojis, toFind)=>{
    const findId = toFind.id;
    let match = -1;
    emojis.forEach((emoji, index)=>{
        // Match if ID is defined and are equal
        // Or both have no id and shortnames match
        if (emoji.id && emoji.id === findId || !emoji.id && !findId && emoji.shortName === toFind.shortName) {
            match = index;
            return;
        }
    });
    return match;
};
class $1ff071be7e19cc86$export$2e2bcd8739ae039 {
    // protected to allow subclasses to access (for testing and storybooks).
    constructor(emojis, usageTracker){
        this.emojis = emojis;
        this.initMembers(usageTracker);
    }
    /**
   * Returns all available (and searchable) emoji in some default order.
   */ all() {
        const options = {
            sort: (0, $dnGEj.SearchSort).None
        };
        return this.search('', options);
    }
    /**
   * Text search of emoji shortName and name field for suitable matches.
   *
   * Returns an array of all (searchable) emoji if query is empty or null, otherwise returns matching emoji.
   *
   * You can change how the results are sorted by specifying a custom EmojiComparator in the SearchOptions. If
   * you don't want any sorting you can also disable via the SearchOptions (this might be a useful optimisation).
   * If no sort is specified in SearchOptions then a default sorting it applied based on the query.
   */ search(query, options) {
        let filteredEmoji = [];
        const { nameQuery: nameQuery, asciiQuery: asciiQuery } = $1ff071be7e19cc86$var$splitQuery(query);
        if (nameQuery) {
            filteredEmoji = this.fullSearch.search(nameQuery);
            if (asciiQuery) filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
        } else filteredEmoji = this.getAllSearchableEmojis();
        filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
        return {
            emojis: filteredEmoji,
            query: query
        };
    }
    /**
   * Returns all emoji with matching shortName
   */ findAllMatchingShortName(shortName) {
        return this.shortNameMap.get(shortName) || [];
    }
    /**
   * Returns the first matching emoji matching the shortName, or null if none found.
   */ findByShortName(shortName) {
        return $1ff071be7e19cc86$var$findByKey(this.shortNameMap, shortName);
    }
    /**
   * Returns the first matching emoji matching the id, or null if none found.
   */ findById(id) {
        return $1ff071be7e19cc86$var$findByKey(this.idMap, id);
    }
    findByAsciiRepresentation(asciiEmoji) {
        return this.asciiMap.get(asciiEmoji);
    }
    findInCategory(categoryId) {
        if (categoryId === (0, $lgmTv.frequentCategory)) return this.getFrequentlyUsed();
        else return this.all().emojis.filter((emoji)=>emoji.category === categoryId);
    }
    addUnknownEmoji(emoji) {
        this.emojis = [
            ...this.emojis,
            emoji
        ];
        this.fullSearch.addDocuments([
            emoji
        ]);
        this.addToMaps(emoji);
        this.addToDynamicCategories(emoji);
    }
    getAsciiMap() {
        return this.asciiMap;
    }
    /**
   * Return the most frequently used emoji, ordered from most frequent to least frequent. Return an empty array if
   * there are none.
   *
   * @param options optional settings to be applied to the set of frequently used emoji
   */ getFrequentlyUsed(options) {
        const emojiIds = this.usageTracker.getOrder();
        let emojiResult = emojiIds.map((id)=>this.findById(id)).filter((e)=>e !== undefined);
        if (options) emojiResult = this.applySearchOptions(emojiResult, '', options);
        return emojiResult;
    }
    getDynamicCategoryList() {
        return this.dynamicCategoryList.slice();
    }
    /**
   * Call this on emoji usage to allow the EmojiRepository to track the usage of emoji (which could be useful
   * in sorting, etc).
   *
   * @param emoji the emoji that was just used
   */ used(emoji) {
        this.usageTracker.recordUsage(emoji);
        // If this is the first usage ensure that we update the dynamic categories.
        // This is done in a 'timeout' since the usageTracker call previously also happens in a timeout. This ensures that
        // the frequent category will not appear until the usage has been tracked (avoiding the possibility of an empty
        // frequent category being shown in the picker).
        if (this.dynamicCategoryList.indexOf((0, $lgmTv.frequentCategory)) === -1) {
            if (typeof window === 'undefined') return;
            window.setTimeout(()=>{
                this.dynamicCategoryList.push((0, $lgmTv.frequentCategory));
            });
        }
    }
    delete(emoji) {
        const deletedIndex = $1ff071be7e19cc86$var$findEmojiIndex(this.emojis, emoji);
        if (deletedIndex !== -1) {
            // Remove the deleted emojis from the internal list
            this.emojis.splice(deletedIndex, 1);
            // Reconstruct repository member variables
            this.initMembers(this.usageTracker);
        }
    }
    withAsciiMatch(ascii, emojis) {
        let result = emojis;
        const asciiEmoji = this.findByAsciiRepresentation(ascii);
        if (asciiEmoji) {
            // Ensures that the same emoji isn't already in the list
            // If it is, we give precedence to the ascii match
            result = emojis.filter((e)=>e.id !== asciiEmoji.id);
            result = [
                asciiEmoji,
                ...result
            ];
        }
        return result;
    }
    applySearchOptions(emojis, query, options) {
        if (!options) options = {};
        if (options.sort === undefined) options.sort = (0, $dnGEj.SearchSort).Default;
        let comparator;
        if (options.sort === (0, $dnGEj.SearchSort).Default) comparator = (0, $iFBgY.createSearchEmojiComparator)(query, this.usageTracker.getOrder());
        else if (options.sort === (0, $dnGEj.SearchSort).UsageFrequency) comparator = (0, $iFBgY.createUsageOnlyEmojiComparator)(this.usageTracker.getOrder());
        if (comparator) {
            comparator.compare = comparator.compare.bind(comparator); // TODO bind at a better place
            emojis = emojis.sort(comparator.compare);
        }
        if (options.limit && options.limit > 0) emojis = emojis.slice(0, options.limit);
        if (options.skinTone) return emojis.map((emoji)=>{
            return $1ff071be7e19cc86$export$e55e46e1520c899d(emoji, options);
        });
        return emojis;
    }
    initMembers(usageTracker) {
        this.usageTracker = usageTracker || new (0, $e1D8Y.UsageFrequencyTracker)();
        this.initRepositoryMetadata();
        this.initSearchIndex();
    }
    /**
   * Optimisation to initialise all map member variables in single loop over emojis
   */ initRepositoryMetadata() {
        this.shortNameMap = new Map();
        this.idMap = new Map();
        this.asciiMap = new Map();
        const categorySet = new Set();
        this.emojis.forEach((emoji)=>{
            categorySet.add(emoji.category);
            this.addToMaps(emoji);
        });
        if (this.usageTracker.getOrder().length) categorySet.add((0, $lgmTv.frequentCategory));
        this.dynamicCategoryList = Array.from(categorySet).filter((category)=>(0, $lgmTv.defaultCategories).indexOf(category) === -1);
    }
    initSearchIndex() {
        this.fullSearch = new (0, $iluEd.Search)('id');
        this.fullSearch.tokenizer = new $1ff071be7e19cc86$var$Tokenizer();
        this.fullSearch.searchIndex = new (0, $iluEd.UnorderedSearchIndex)();
        this.fullSearch.addIndex('name');
        this.fullSearch.addIndex('shortName');
        this.fullSearch.addDocuments(this.getAllSearchableEmojis());
    }
    getAllSearchableEmojis() {
        return this.emojis.filter((emojiDescription)=>emojiDescription.searchable);
    }
    addToMaps(emoji) {
        // Give default value and assign higher weight to Atlassian emojis for logical order when sorting
        if (typeof emoji.order === 'undefined' || emoji.order === -1) emoji.order = $1ff071be7e19cc86$export$2e2bcd8739ae039.defaultEmojiWeight;
        if (typeof emoji.id === 'undefined') emoji.id = $1ff071be7e19cc86$export$2e2bcd8739ae039.defaultEmojiWeight.toString();
        $1ff071be7e19cc86$var$addAllVariants(emoji, (e)=>e.shortName, this.shortNameMap);
        $1ff071be7e19cc86$var$addAllVariants(emoji, (e)=>e.id, this.idMap);
        if (emoji.ascii) emoji.ascii.forEach((a)=>this.asciiMap.set(a, emoji));
    }
    addToDynamicCategories(emoji) {
        const category = (0, $aQtlX.getCategoryId)(emoji);
        if ((0, $lgmTv.defaultCategories).indexOf(category) === -1 && this.dynamicCategoryList.indexOf(category) === -1) this.dynamicCategoryList.push(category);
    }
}
(0, $5zQU9.default)($1ff071be7e19cc86$export$2e2bcd8739ae039, "defaultEmojiWeight", 1000000);

});
parcelRegister("iluEd", function(module, exports) {

$parcel$export(module.exports, "UnorderedSearchIndex", () => $d5b1f6290aa92eb8$export$5e70dbef3f0d47db);
$parcel$export(module.exports, "Search", () => $d5b1f6290aa92eb8$export$4b85d3515bd863a5);
/**
 * Indexes for all substring searches (e.g. the term "cat" is indexed as "c", "ca", "cat", "a", "at", and "t").
 */ var $d5b1f6290aa92eb8$export$58ac23006833dfe0 = /*#__PURE__*/ function() {
    function AllSubstringsIndexStrategy() {}
    var _proto = AllSubstringsIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string;
        for(var i = 0, length = token.length; i < length; ++i){
            string = '';
            for(var j = i; j < length; ++j){
                string += token.charAt(j);
                expandedTokens.push(string);
            }
        }
        return expandedTokens;
    };
    return AllSubstringsIndexStrategy;
}();
/**
 * Indexes for exact word matches.
 */ var $d5b1f6290aa92eb8$export$1dcc2d6a64836c8f = /*#__PURE__*/ function() {
    function ExactWordIndexStrategy() {}
    var _proto = ExactWordIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        return token ? [
            token
        ] : [];
    };
    return ExactWordIndexStrategy;
}();
/**
 * Indexes for prefix searches (e.g. the term "cat" is indexed as "c", "ca", and "cat" allowing prefix search lookups).
 */ var $d5b1f6290aa92eb8$export$eb7fc80cfe9abfe6 = /*#__PURE__*/ function() {
    function PrefixIndexStrategy() {}
    var _proto = PrefixIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string = '';
        for(var i = 0, length = token.length; i < length; ++i){
            string += token.charAt(i);
            expandedTokens.push(string);
        }
        return expandedTokens;
    };
    return PrefixIndexStrategy;
}();
/**
 * Enforces case-sensitive text matches.
 */ var $d5b1f6290aa92eb8$export$b88ffe9b5486f99a = /*#__PURE__*/ function() {
    function CaseSensitiveSanitizer() {}
    var _proto = CaseSensitiveSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.trim() : '';
    };
    return CaseSensitiveSanitizer;
}();
/**
 * Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
 */ var $d5b1f6290aa92eb8$export$147e8ac43c84713a = /*#__PURE__*/ function() {
    function LowerCaseSanitizer() {}
    var _proto = LowerCaseSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.toLocaleLowerCase().trim() : '';
    };
    return LowerCaseSanitizer;
}();
/**
 * Find and return a nested object value.
 *
 * @param object to crawl
 * @param path Property path
 * @returns {any}
 */ function $d5b1f6290aa92eb8$var$getNestedFieldValue(object, path) {
    path = path || [];
    object = object || {};
    var value = object; // walk down the property path
    for(var i = 0; i < path.length; i++){
        value = value[path[i]];
        if (value == null) return null;
    }
    return value;
}
/**
 * Search index capable of returning results matching a set of tokens and ranked according to TF-IDF.
 */ var $d5b1f6290aa92eb8$export$a1138c79781169cc = /*#__PURE__*/ function() {
    function TfIdfSearchIndex(uidFieldName) {
        this._uidFieldName = uidFieldName;
        this._tokenToIdfCache = {};
        this._tokenMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = TfIdfSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        this._tokenToIdfCache = {}; // New index invalidates previous IDF caches
        var tokenMap = this._tokenMap;
        var tokenDatum;
        if (typeof tokenMap[token] !== 'object') tokenMap[token] = tokenDatum = {
            $numDocumentOccurrences: 0,
            $totalNumOccurrences: 1,
            $uidMap: {}
        };
        else {
            tokenDatum = tokenMap[token];
            tokenDatum.$totalNumOccurrences++;
        }
        var uidMap = tokenDatum.$uidMap;
        if (typeof uidMap[uid] !== 'object') {
            tokenDatum.$numDocumentOccurrences++;
            uidMap[uid] = {
                $document: doc,
                $numTokenOccurrences: 1
            };
        } else uidMap[uid].$numTokenOccurrences++;
    } /**
   * @inheritDocs
   */ ;
    _proto.search = function search(tokens, corpus) {
        var uidToDocumentMap = {};
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var tokenMetadata = this._tokenMap[token]; // Short circuit if no matches were found for any given token.
            if (!tokenMetadata) return [];
            if (i === 0) {
                var keys = Object.keys(tokenMetadata.$uidMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                }
            } else {
                var keys = Object.keys(uidToDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof tokenMetadata.$uidMap[uid] !== 'object') delete uidToDocumentMap[uid];
                }
            }
        }
        var documents = [];
        for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
        var calculateTfIdf = this._createCalculateTfIdf(); // Return documents sorted by TF-IDF
        return documents.sort(function(documentA, documentB) {
            return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
        });
    };
    _proto._createCalculateIdf = function _createCalculateIdf() {
        var tokenMap = this._tokenMap;
        var tokenToIdfCache = this._tokenToIdfCache;
        return function calculateIdf(token, documents) {
            if (!tokenToIdfCache[token]) {
                var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;
                tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
            }
            return tokenToIdfCache[token];
        };
    };
    _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
        var tokenMap = this._tokenMap;
        var uidFieldName = this._uidFieldName;
        var calculateIdf = this._createCalculateIdf();
        return function calculateTfIdf(tokens, document, documents) {
            var score = 0;
            for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                var token = tokens[i];
                var inverseDocumentFrequency = calculateIdf(token, documents);
                if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                var uid;
                if (uidFieldName instanceof Array) uid = document && $d5b1f6290aa92eb8$var$getNestedFieldValue(document, uidFieldName);
                else uid = document && document[uidFieldName];
                var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                score += termFrequency * inverseDocumentFrequency;
            }
            return score;
        };
    };
    return TfIdfSearchIndex;
}();
/**
 * Search index capable of returning results matching a set of tokens but without any meaningful rank or order.
 */ var $d5b1f6290aa92eb8$export$5e70dbef3f0d47db = /*#__PURE__*/ function() {
    function UnorderedSearchIndex() {
        this._tokenToUidToDocumentMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = UnorderedSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        if (typeof this._tokenToUidToDocumentMap[token] !== 'object') this._tokenToUidToDocumentMap[token] = {};
        this._tokenToUidToDocumentMap[token][uid] = doc;
    } /**
   * @inheritDocs
   */ ;
    _proto.search = function search(tokens, corpus) {
        var intersectingDocumentMap = {};
        var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var documentMap = tokenToUidToDocumentMap[token]; // Short circuit if no matches were found for any given token.
            if (!documentMap) return [];
            if (i === 0) {
                var keys = Object.keys(documentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    intersectingDocumentMap[uid] = documentMap[uid];
                }
            } else {
                var keys = Object.keys(intersectingDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof documentMap[uid] !== 'object') delete intersectingDocumentMap[uid];
                }
            }
        }
        var keys = Object.keys(intersectingDocumentMap);
        var documents = [];
        for(var i = 0, numKeys = keys.length; i < numKeys; i++){
            var uid = keys[i];
            documents.push(intersectingDocumentMap[uid]);
        }
        return documents;
    };
    return UnorderedSearchIndex;
}();
var $d5b1f6290aa92eb8$var$REGEX = /[^a-zа-яё0-9\-']+/i;
/**
 * Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
 */ var $d5b1f6290aa92eb8$export$f5ac5ec3cb556ad6 = /*#__PURE__*/ function() {
    function SimpleTokenizer() {}
    var _proto = SimpleTokenizer.prototype;
    /**
   * @inheritDocs
   */ _proto.tokenize = function tokenize(text) {
        return text.split($d5b1f6290aa92eb8$var$REGEX).filter(function(text) {
            return text;
        } // Filter empty tokens
        );
    };
    return SimpleTokenizer;
}();
/**
 * Stemming is the process of reducing search tokens to their root (or stem) so that searches for different forms of a
 * word will match. For example "search", "searching" and "searched" are all reduced to the stem "search".
 *
 * <p>This stemming tokenizer converts tokens (words) to their stem forms before returning them. It requires an
 * external stemming function to be provided; for this purpose I recommend the NPM 'porter-stemmer' library.
 *
 * <p>For more information see http : //tartarus.org/~martin/PorterStemmer/
 */ var $d5b1f6290aa92eb8$export$d2c689c98d4dcb27 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param stemmingFunction Function capable of accepting a word and returning its stem.
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
        this._stemmingFunction = stemmingFunction;
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StemmingTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).map(this._stemmingFunction);
    };
    return StemmingTokenizer;
}();
/**
 * Stop words list copied from Lunr JS.
 */ var $d5b1f6290aa92eb8$export$eeaf491a400e882a = {
    a: true,
    able: true,
    about: true,
    across: true,
    after: true,
    all: true,
    almost: true,
    also: true,
    am: true,
    among: true,
    an: true,
    and: true,
    any: true,
    are: true,
    as: true,
    at: true,
    be: true,
    because: true,
    been: true,
    but: true,
    by: true,
    can: true,
    cannot: true,
    could: true,
    dear: true,
    did: true,
    'do': true,
    does: true,
    either: true,
    'else': true,
    ever: true,
    every: true,
    'for': true,
    from: true,
    'get': true,
    got: true,
    had: true,
    has: true,
    have: true,
    he: true,
    her: true,
    hers: true,
    him: true,
    his: true,
    how: true,
    however: true,
    i: true,
    'if': true,
    'in': true,
    into: true,
    is: true,
    it: true,
    its: true,
    just: true,
    least: true,
    "let": true,
    like: true,
    likely: true,
    may: true,
    me: true,
    might: true,
    most: true,
    must: true,
    my: true,
    neither: true,
    no: true,
    nor: true,
    not: true,
    of: true,
    off: true,
    often: true,
    on: true,
    only: true,
    or: true,
    other: true,
    our: true,
    own: true,
    rather: true,
    said: true,
    say: true,
    says: true,
    she: true,
    should: true,
    since: true,
    so: true,
    some: true,
    than: true,
    that: true,
    the: true,
    their: true,
    them: true,
    then: true,
    there: true,
    these: true,
    they: true,
    'this': true,
    tis: true,
    to: true,
    too: true,
    twas: true,
    us: true,
    wants: true,
    was: true,
    we: true,
    were: true,
    what: true,
    when: true,
    where: true,
    which: true,
    'while': true,
    who: true,
    whom: true,
    why: true,
    will: true,
    'with': true,
    would: true,
    yet: true,
    you: true,
    your: true
}; // Prevent false positives for inherited properties
$d5b1f6290aa92eb8$export$eeaf491a400e882a.constructor = false;
$d5b1f6290aa92eb8$export$eeaf491a400e882a.hasOwnProperty = false;
$d5b1f6290aa92eb8$export$eeaf491a400e882a.isPrototypeOf = false;
$d5b1f6290aa92eb8$export$eeaf491a400e882a.propertyIsEnumerable = false;
$d5b1f6290aa92eb8$export$eeaf491a400e882a.toLocaleString = false;
$d5b1f6290aa92eb8$export$eeaf491a400e882a.toString = false;
$d5b1f6290aa92eb8$export$eeaf491a400e882a.valueOf = false;
/**
 * Stop words are very common (e.g. "a", "and", "the") and are often not semantically meaningful in the context of a
 * search. This tokenizer removes stop words from a set of tokens before passing the remaining tokens along for
 * indexing or searching purposes.
 */ var $d5b1f6290aa92eb8$export$59d4dfff8ed0ca89 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StopWordsTokenizer(decoratedTokenizer) {
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StopWordsTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).filter(function(token) {
            return !$d5b1f6290aa92eb8$export$eeaf491a400e882a[token];
        });
    };
    return StopWordsTokenizer;
}();
function $d5b1f6290aa92eb8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d5b1f6290aa92eb8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d5b1f6290aa92eb8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d5b1f6290aa92eb8$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Simple client-side searching within a set of documents.
 *
 * <p>Documents can be searched by any number of fields. Indexing and search strategies are highly customizable.
 */ var $d5b1f6290aa92eb8$export$4b85d3515bd863a5 = /*#__PURE__*/ function() {
    /**
   * Array containing either a property name or a path (list of property names) to a nested value
   */ /**
   * Constructor.
   * @param uidFieldName Field containing values that uniquely identify search documents; this field's values are used
   *                     to ensure that a search result set does not contain duplicate objects.
   */ function Search(uidFieldName) {
        if (!uidFieldName) throw Error('js-search requires a uid field name constructor parameter');
        this._uidFieldName = uidFieldName; // Set default/recommended strategies
        this._indexStrategy = new $d5b1f6290aa92eb8$export$eb7fc80cfe9abfe6();
        this._searchIndex = new $d5b1f6290aa92eb8$export$a1138c79781169cc(uidFieldName);
        this._sanitizer = new $d5b1f6290aa92eb8$export$147e8ac43c84713a();
        this._tokenizer = new $d5b1f6290aa92eb8$export$f5ac5ec3cb556ad6();
        this._documents = [];
        this._searchableFields = [];
    }
    /**
   * Override the default index strategy.
   * @param value Custom index strategy
   * @throws Error if documents have already been indexed by this search instance
   */ var _proto = Search.prototype;
    /**
   * Add a searchable document to the index. Document will automatically be indexed for search.
   * @param document
   */ _proto.addDocument = function addDocument(document) {
        this.addDocuments([
            document
        ]);
    } /**
   * Adds searchable documents to the index. Documents will automatically be indexed for search.
   * @param document
   */ ;
    _proto.addDocuments = function addDocuments(documents) {
        this._documents = this._documents.concat(documents);
        this.indexDocuments_(documents, this._searchableFields);
    } /**
   * Add a new searchable field to the index. Existing documents will automatically be indexed using this new field.
   *
   * @param field Searchable field or field path. Pass a string to index a top-level field and an array of strings for nested fields.
   */ ;
    _proto.addIndex = function addIndex(field) {
        this._searchableFields.push(field);
        this.indexDocuments_(this._documents, [
            field
        ]);
    } /**
   * Search all documents for ones matching the specified query text.
   * @param query
   * @returns {Array<Object>}
   */ ;
    _proto.search = function search(query) {
        var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
        return this._searchIndex.search(tokens, this._documents);
    } /**
   * @param documents
   * @param _searchableFields Array containing property names and paths (lists of property names) to nested values
   * @private
   */ ;
    _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
        this._initialized = true;
        var indexStrategy = this._indexStrategy;
        var sanitizer = this._sanitizer;
        var searchIndex = this._searchIndex;
        var tokenizer = this._tokenizer;
        var uidFieldName = this._uidFieldName;
        for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
            var doc = documents[di];
            var uid;
            if (uidFieldName instanceof Array) uid = $d5b1f6290aa92eb8$var$getNestedFieldValue(doc, uidFieldName);
            else uid = doc[uidFieldName];
            for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                var fieldValue;
                var searchableField = _searchableFields[sfi];
                if (searchableField instanceof Array) fieldValue = $d5b1f6290aa92eb8$var$getNestedFieldValue(doc, searchableField);
                else fieldValue = doc[searchableField];
                if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) fieldValue = fieldValue.toString();
                if (typeof fieldValue === 'string') {
                    var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                    for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                        var fieldToken = fieldTokens[fti];
                        var expandedTokens = indexStrategy.expandToken(fieldToken);
                        for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                            var expandedToken = expandedTokens[eti];
                            searchIndex.indexDocument(expandedToken, uid, doc);
                        }
                    }
                }
            }
        }
    };
    $d5b1f6290aa92eb8$var$_createClass(Search, [
        {
            key: "indexStrategy",
            set: function set(value) {
                if (this._initialized) throw Error('IIndexStrategy cannot be set after initialization');
                this._indexStrategy = value;
            },
            get: function get() {
                return this._indexStrategy;
            }
        },
        {
            key: "sanitizer",
            set: function set(value) {
                if (this._initialized) throw Error('ISanitizer cannot be set after initialization');
                this._sanitizer = value;
            },
            get: function get() {
                return this._sanitizer;
            }
        },
        {
            key: "searchIndex",
            set: function set(value) {
                if (this._initialized) throw Error('ISearchIndex cannot be set after initialization');
                this._searchIndex = value;
            },
            get: function get() {
                return this._searchIndex;
            }
        },
        {
            key: "tokenizer",
            set: function set(value) {
                if (this._initialized) throw Error('ITokenizer cannot be set after initialization');
                this._tokenizer = value;
            },
            get: function get() {
                return this._tokenizer;
            }
        }
    ]);
    return Search;
}();
/**
 * This utility highlights the occurrences of tokens within a string of text. It can be used to give visual indicators
 * of match criteria within searchable fields.
 *
 * <p>For performance purposes this highlighter only works with full-word or prefix token indexes.
 */ var $d5b1f6290aa92eb8$export$11e693a7f8ce1bcc = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param opt_indexStrategy Index strategy used by Search
   * @param opt_sanitizer Sanitizer used by Search
   * @param opt_wrapperTagName Optional wrapper tag name; defaults to 'mark' (e.g. <mark>)
   */ function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
        this._indexStrategy = opt_indexStrategy || new $d5b1f6290aa92eb8$export$eb7fc80cfe9abfe6();
        this._sanitizer = opt_sanitizer || new $d5b1f6290aa92eb8$export$147e8ac43c84713a();
        this._wrapperTagName = opt_wrapperTagName || 'mark';
    }
    /**
   * Highlights token occurrences within a string by wrapping them with a DOM element.
   *
   * @param text e.g. "john wayne"
   * @param tokens e.g. ["wa"]
   * @returns {string} e.g. "john <mark>wa</mark>yne"
   */ var _proto = TokenHighlighter.prototype;
    _proto.highlight = function highlight(text, tokens) {
        var tagsLength = this._wrapText('').length;
        var tokenDictionary = Object.create(null); // Create a token map for easier lookup below.
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = this._sanitizer.sanitize(tokens[i]);
            var expandedTokens = this._indexStrategy.expandToken(token);
            for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                var expandedToken = expandedTokens[j];
                if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                    token
                ];
                else tokenDictionary[expandedToken].push(token);
            }
        } // Track actualCurrentWord and sanitizedCurrentWord separately in case we encounter nested tags.
        var actualCurrentWord = '';
        var sanitizedCurrentWord = '';
        var currentWordStartIndex = 0; // Note this assumes either prefix or full word matching.
        for(var i = 0, textLength = text.length; i < textLength; i++){
            var character = text.charAt(i);
            if (character === ' ') {
                actualCurrentWord = '';
                sanitizedCurrentWord = '';
                currentWordStartIndex = i + 1;
            } else {
                actualCurrentWord += character;
                sanitizedCurrentWord += this._sanitizer.sanitize(character);
            }
            if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                actualCurrentWord = this._wrapText(actualCurrentWord);
                text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                i += tagsLength;
                textLength += tagsLength;
            }
        }
        return text;
    } /**
   * @param text to wrap
   * @returns Text wrapped by wrapper tag (e.g. "foo" becomes "<mark>foo</mark>")
   * @private
   */ ;
    _proto._wrapText = function _wrapText(text) {
        var tagName = this._wrapperTagName;
        return "<" + tagName + ">" + text + "</" + tagName + ">";
    };
    return TokenHighlighter;
}();

});

parcelRegister("5LLHg", function(module, exports) {

$parcel$export(module.exports, "tokenizerRegex", () => $4336571e8906a20c$export$6558e5d0f0e834f8);
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|[\\p{L}|\\p{N}]+[\\p{Mn}|']*\\p{L}*", 'gi');
// Note: Regex compiled to unicode charsets using xregexp-transformer, refer to it if you need to compile it again.
//       @atlaskit/xregexp-transformer (https://bitbucket.org/atlassian/xregexp-transformer)
// eslint-disable-next-line no-misleading-character-class
const $4336571e8906a20c$export$6558e5d0f0e834f8 = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');

});

parcelRegister("iFBgY", function(module, exports) {

$parcel$export(module.exports, "createSearchEmojiComparator", () => $d978f7f1ca6ee932$export$e6097b005751df7);
$parcel$export(module.exports, "createUsageOnlyEmojiComparator", () => $d978f7f1ca6ee932$export$1bd055808eeccb4e);

var $lgmTv = parcelRequire("lgmTv");

var $aQtlX = parcelRequire("aQtlX");
function $d978f7f1ca6ee932$export$e6097b005751df7(query, orderedIds) {
    const textQuery = query ? query.replace(/:/g, '').toLowerCase().trim() : undefined;
    const comparators = [];
    if (query) comparators.push(new $d978f7f1ca6ee932$export$ff92575cd1bbad0e(query));
    // Add the comparators to the 'chain'. The order of adding each comparator is important to the sort that is applied by the
    // ChainedEmojiComparator. (Which is why you may see the same 'if' a few times.)
    if (textQuery) comparators.push(new $d978f7f1ca6ee932$export$3026b08b79541139(textQuery));
    if (orderedIds && orderedIds.length) comparators.push(new $d978f7f1ca6ee932$export$55e24837a4bf653(orderedIds));
    if (textQuery) comparators.push(new $d978f7f1ca6ee932$export$587c775915dc4869(textQuery, 'shortName'), new $d978f7f1ca6ee932$export$587c775915dc4869(textQuery, 'name'));
    comparators.push($d978f7f1ca6ee932$export$165e96ceead77edd.Instance, $d978f7f1ca6ee932$export$30ce221e1adf48c1.Instance);
    const comparator = new $d978f7f1ca6ee932$export$a8052d0852821684(...comparators);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
function $d978f7f1ca6ee932$export$1bd055808eeccb4e(orderedIds) {
    const comparator = new $d978f7f1ca6ee932$export$a8052d0852821684(new $d978f7f1ca6ee932$export$55e24837a4bf653(orderedIds), new $d978f7f1ca6ee932$export$a7f7a0b04013a8a8(), $d978f7f1ca6ee932$export$165e96ceead77edd.Instance);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
class $d978f7f1ca6ee932$export$a8052d0852821684 {
    constructor(...comparators){
        this.chain = comparators;
    }
    compare(e1, e2) {
        for(let i = 0; i < this.chain.length; i++){
            const result = this.chain[i].compare(e1, e2);
            if (result !== 0) return result;
        }
        return 0;
    }
}
class $d978f7f1ca6ee932$export$ff92575cd1bbad0e {
    constructor(query){
        this.query = query;
    }
    compare(e1, e2) {
        const e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
        const e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
        if (e1HasAscii && !e2HasAscii) return -1;
        else if (!e1HasAscii && e2HasAscii) return 1;
        return 0;
    }
}
class $d978f7f1ca6ee932$export$3026b08b79541139 {
    constructor(query){
        this.colonQuery = `:${query}:`;
        this.typeComparator = new $d978f7f1ca6ee932$export$a7f7a0b04013a8a8(true);
    }
    compare(e1, e2) {
        if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) return this.typeComparator.compare(e1, e2);
        else if (e1.shortName === this.colonQuery) return -1;
        else if (e2.shortName === this.colonQuery) return 1;
        return 0;
    }
}
class $d978f7f1ca6ee932$export$a7f7a0b04013a8a8 {
    constructor(reverse){
        if (reverse) this.typeToNumber = new Map([
            [
                'SITE',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'STANDARD',
                2
            ]
        ]);
        else this.typeToNumber = new Map([
            [
                'STANDARD',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'SITE',
                2
            ]
        ]);
    }
    compare(e1, e2) {
        return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
    }
    emojiTypeToOrdinal(emoji) {
        let ordinal = this.typeToNumber.get(emoji.type);
        if (ordinal === undefined) ordinal = 10;
        return ordinal;
    }
}
class $d978f7f1ca6ee932$export$55e24837a4bf653 {
    // A Map of emoji base Id to their order in a least of most frequently used
    constructor(orderedIds){
        this.positionLookup = new Map();
        // Make ordering start from 1 to avoid having zero in the map (which is falsey)
        orderedIds.map((id, index)=>this.positionLookup.set(id, index + 1));
    }
    compare(e1, e2) {
        if (!e1.id || !e2.id) return 0; // this shouldn't occur. Leave position unchanged if there is any missing id.
        let i1 = this.getPositionInOrder(e1);
        let i2 = this.getPositionInOrder(e2);
        return i1 - i2;
    }
    /**
   * Get the ordinal representing the position of this emoji.
   *
   * @param id the id of the emoji
   */ getPositionInOrder(emoji) {
        let id = emoji.id ? emoji.id : '0';
        if ((0, $aQtlX.isEmojiVariationDescription)(emoji)) id = emoji.baseId;
        const position = this.positionLookup.get(id);
        if (position) return position;
        else return 0, $lgmTv.MAX_ORDINAL;
    }
}
class $d978f7f1ca6ee932$export$587c775915dc4869 {
    /**
   * @param query the query to match
   * @param propertyToCompare the property of EmojiDescription to check for query within
   */ constructor(query, propertyToCompare){
        this.query = query;
        if (!propertyToCompare) throw new Error('propertyToCompare is required');
        this.propertyName = propertyToCompare;
    }
    getScore(emoji) {
        // It is fine to do override the null check here because we are checking
        // it on the constructor.
        const propertyValue = emoji[this.propertyName];
        const score = propertyValue ? propertyValue.indexOf(this.query) : (0, $lgmTv.MAX_ORDINAL);
        return score === -1 ? (0, $lgmTv.MAX_ORDINAL) : score;
    }
    compare(e1, e2) {
        return this.getScore(e1) - this.getScore(e2);
    }
}
class $d978f7f1ca6ee932$export$165e96ceead77edd {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        let o1 = e1.order ? e1.order : (0, $lgmTv.MAX_ORDINAL);
        let o2 = e2.order ? e2.order : (0, $lgmTv.MAX_ORDINAL);
        return o1 - o2;
    }
}
class $d978f7f1ca6ee932$export$30ce221e1adf48c1 {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        return e1.shortName.localeCompare(e2.shortName);
    }
}

});

parcelRegister("e1D8Y", function(module, exports) {

$parcel$export(module.exports, "UsageFrequencyTracker", () => $a35f85d2833b413d$export$3f86810331c44209);

var $5zQU9 = parcelRequire("5zQU9");

var $aQtlX = parcelRequire("aQtlX");

var $lgmTv = parcelRequire("lgmTv");

var $k6iSu = parcelRequire("k6iSu");

var $is3my = parcelRequire("is3my");

var $8y8qh = parcelRequire("8y8qh");
class $a35f85d2833b413d$export$3f86810331c44209 {
    constructor(useStorageIfPossible = true){
        const options = $a35f85d2833b413d$export$3f86810331c44209.queueOptions;
        if (useStorageIfPossible && options.storage) {
            const queueOptions = {
                ...options,
                storage: options.storage
            };
            this.queue = new (0, $is3my.default)(queueOptions);
        } else this.queue = new (0, $k6iSu.default)(options);
        this.gateway = new $a35f85d2833b413d$export$a0e1fa6601cae894(10);
    }
    /**
   * Record the fact that the supplied emoji was used. You should note that usage is updated asynchronously so you can not
   * count on getOrder() reflecting this usage immediately.
   *
   * @param emoji the emoji who's usage is to be recorded. If the emoji has no id then no usage will be recorded
   */ recordUsage(emoji) {
        let emojiId = emoji.id;
        if (emojiId) {
            if ((0, $aQtlX.isEmojiVariationDescription)(emoji)) emojiId = emoji.baseId;
            this.gateway.submit(()=>{
                if (emojiId) this.queue.enqueue(emojiId);
            });
        }
    }
    /**
   * Returns an array of emoji id (without skin tone variations) sorted by most used to least used. If there
   * are no usages then an empty array will be returned.
   */ getOrder() {
        return this.queue.getItemsOrderedByDuplicateCount();
    }
    /**
   * Exposed for testing only. Clear any recorded usage.
   */ clear() {
        this.queue.clear();
    }
}
(0, $5zQU9.default)($a35f85d2833b413d$export$3f86810331c44209, "queueOptions", {
    storage: (0, $8y8qh.default)('localStorage') ? window.localStorage : undefined,
    storagePrefix: (0, $lgmTv.localStoragePrefix),
    maxDuplicates: 25,
    minUniqueItems: 5
});
class $a35f85d2833b413d$export$a0e1fa6601cae894 {
    constructor(maximumPermitted){
        if (maximumPermitted < 1) throw new RangeError('The maximumPermitted parameter must be 1 or more.');
        this.maximumPermitted = maximumPermitted;
        this.count = 0;
    }
    /**
   * Run the supplied function if the count of already submitted work allows it. Drop the work
   * if it's not allowed to run.
   *
   * Will return true if the function has been submitted or false if it was not submitted.
   */ submit(f) {
        if (this.count >= this.maximumPermitted) return false;
        this.count++;
        const wrappedFunc = ()=>{
            try {
                f();
            } finally{
                this.completed();
            }
        };
        if (typeof window !== 'undefined') window.setTimeout(wrappedFunc);
        return true;
    }
    completed() {
        this.count--;
    }
}

});
parcelRegister("k6iSu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea2302eb21288fae$export$2e2bcd8739ae039);
/**
 * The options used to configure a newly constructed queue.
 */ /**
 * A queue which will limit the number of duplicates of type T that it holds. When the duplicate limit is
 * reached the earliest inserted duplicate (the "original") is removed to make room for the new insertion.
 */ class $ea2302eb21288fae$export$2e2bcd8739ae039 {
    /**
   * An array derived from items and itemCountMap which holds each item once and is ordered by
   * how often an item is duplicated in the items array.
   */ /**
   * Construct a new DuplicateLimitedQueue.
   *
   * @param options the options for this queue.
   */ constructor(options){
        if (options.maxDuplicates < 1) throw new RangeError('The maxDuplicates option must be at least 1');
        if (options.minUniqueItems < 1) throw new RangeError('The minUniqueItems option must be at least 1');
        this.maximumSize = options.maxDuplicates * options.minUniqueItems;
        this.perItemSize = options.maxDuplicates;
        this.createEmptyState();
    }
    /**
   * @param item the item to add to the queue.
   */ enqueue(item) {
        this.enqueueWithoutOrdering(item);
        // enqueues are less time sensitive (and may happen less frequently) than queries against the queue
        // so do the ordering work on each enqueue.
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
   * Return the items in the queue, ordered by how often they are duplicated. The items with the
   * most duplicates come first in the returned Array.
   *
   * If there are no items in the queue then an empty Array will be returned.
   */ getItemsOrderedByDuplicateCount() {
        return this.itemsOrderedByFrequency;
    }
    /**
   * Exposed for storybook/testing purposes only. Clear the contents of the queue.
   */ clear() {
        this.createEmptyState();
    }
    /**
   * A more efficient mechanism for adding multiple items. Ordering is only performed once all
   * the items have been added.
   *
   * @param items the items to be enqueued, which happens in their presented order.
   */ bulkEnqueue(items) {
        items.map((item)=>this.enqueueWithoutOrdering(item));
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
   * Return the items currently stored in the queue.
   */ getItems() {
        return this.items;
    }
    createEmptyState() {
        this.items = new Array();
        this.itemCountMap = new Map();
        this.itemsOrderedByFrequency = new Array();
    }
    /**
   * Enqueue the supplied item, keeping consistency with the limits configured. However no ordering is
   * performed by this enqueuing. You must trigger that manually if required.
   *
   * @param item the item to be queued
   */ enqueueWithoutOrdering(item) {
        const count = this.itemCountMap.get(item);
        if (count && count >= this.perItemSize) // find the first item with that key in the array and remove it
        this.removeFirstOccurrence(item);
        else if (this.items.length >= this.maximumSize) this.remove();
        this.add(item);
    }
    /**
   * Get an array of items from the queue ordered by how often they are duplicated in the queue.
   */ orderItemsByFrequency() {
        const orderedEntries = Array.from(this.itemCountMap.entries()).sort((a, b)=>{
            return b[1] - a[1];
        });
        return orderedEntries.map((value)=>value[0]);
    }
    decrementCount(item) {
        let count = this.itemCountMap.get(item);
        if (count) {
            count--;
            if (count > 0) this.itemCountMap.set(item, count);
            else this.itemCountMap.delete(item);
        }
    }
    /**
   * Walk the list of items and remove the first occurrence of the matching item.
   *
   * @param item the item to be removed.
   */ removeFirstOccurrence(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
            this.decrementCount(item);
        }
    }
    /**
   * Remove the first item from the queue and update the itemCountMap accordingly.
   * @return the item add the front of the queue or undefined if the queue is empty
   */ remove() {
        const removed = this.items.shift();
        if (removed !== undefined) this.decrementCount(removed);
        return removed;
    }
    /**
   * Add the supplied item to the end of the queue and update the itemCountMap accordingly.
   * @param item the item to be added to the queue
   */ add(item) {
        this.items.push(item);
        const count = this.itemCountMap.get(item);
        if (count) this.itemCountMap.set(item, count + 1);
        else this.itemCountMap.set(item, 1);
    }
}

});

parcelRegister("is3my", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6ed7346e26608d6$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $k6iSu = parcelRequire("k6iSu");

var $lACco = parcelRequire("lACco");
class $d6ed7346e26608d6$export$2e2bcd8739ae039 extends (0, $k6iSu.default) {
    constructor(options){
        super(options);
        this.storage = options.storage;
        this.prefixedStorageKey = `${options.storagePrefix}.${$d6ed7346e26608d6$export$2e2bcd8739ae039.storageKey}`;
        this.load();
    }
    /**
   * Enqueue the supplied item and also persist the new contents of the queue to storage.
   *
   * @param item the item to be enqueued
   */ enqueue(item) {
        super.enqueue(item);
        this.save();
    }
    /**
   * Exposed for storybook/testing purposes only. Clear the contents of the queue, and localStorage.
   */ clear() {
        super.clear();
        this.storage.removeItem(this.prefixedStorageKey);
    }
    /**
   * Initialise the queue contents from the configured Storage. If there is no data found in
   * storage then the queue will have no items added. Likewise, a failure to read or parse stored
   * data will be swallowed and no items are added to the queue.
   */ load() {
        const itemsJson = this.storage.getItem(this.prefixedStorageKey);
        if (itemsJson) try {
            const items = JSON.parse(itemsJson);
            this.bulkEnqueue(items);
        } catch (e) {
            (0, $lACco.default)(`Error parsing the queue stored as ${this.prefixedStorageKey} key from storage`, e);
        }
    }
    /**
   * Save the current items in the queue, overwriting any previously stored queue.
   * Any failure in saving will be silently ignored with the likely outcome that any previous
   * saved items will remain unchanged in storage.
   */ save() {
        const itemsJson = JSON.stringify(this.getItems());
        try {
            this.storage.setItem(this.prefixedStorageKey, itemsJson);
        } catch (e) {
            (0, $lACco.default)(`Error saving the queued items as ${this.prefixedStorageKey}`, e);
        }
    }
}
(0, $5zQU9.default)($d6ed7346e26608d6$export$2e2bcd8739ae039, "storageKey", 'lastUsed');

});



parcelRegister("hlFHe", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca14bdd3ab59a04f$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $16UJG = parcelRequire("16UJG");

var $g3pIo = parcelRequire("g3pIo");

var $aQtlX = parcelRequire("aQtlX");

var $jueEQ = parcelRequire("jueEQ");

var $9cbEs = parcelRequire("9cbEs");

var $aYzhp = parcelRequire("aYzhp");

var $lACco = parcelRequire("lACco");

var $kHjbr = parcelRequire("kHjbr");
const $ca14bdd3ab59a04f$export$6f3a08dea02a7b2b = 0.95;
class $ca14bdd3ab59a04f$export$2e2bcd8739ae039 {
    // @ts-ignore: I am not being read from, should I be deleted???
    constructor(siteServiceConfig, mediaApiToken){
        (0, $5zQU9.default)(this, "postToEmojiService", (upload, fileId)=>{
            const { shortName: shortName, name: name } = upload;
            const { width: width, height: height } = upload;
            const requestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    shortName: shortName,
                    name: name,
                    width: width,
                    height: height,
                    fileId: fileId
                })
            };
            return (0, $16UJG.utils).requestService(this.siteServiceConfig, {
                requestInit: requestInit
            }).then((response)=>{
                const { emojis: emojis } = response;
                if (emojis.length) {
                    const { altRepresentations: altRepresentations, ...emoji } = emojis[0];
                    const response = {
                        ...emoji,
                        representation: (0, $aQtlX.convertImageToMediaRepresentation)(emoji.representation)
                    };
                    const altRepresentation = (0, $9cbEs.getAltRepresentation)(altRepresentations || {});
                    const imgAltRepresentation = altRepresentation ? (0, $aQtlX.convertImageToMediaRepresentation)(altRepresentation) : undefined;
                    return (0, $aQtlX.buildEmojiDescriptionWithAltRepresentation)(response, imgAltRepresentation);
                }
                throw new Error('No emoji returns from upload. Upload failed.');
            });
        });
        this.siteServiceConfig = siteServiceConfig;
        this.mediaApiToken = mediaApiToken;
        this.tokenManager = new (0, $aYzhp.default)(siteServiceConfig);
        this.tokenManager.addToken('read', mediaApiToken);
        this.mediaEmojiCache = new (0, $jueEQ.default)(this.tokenManager);
    }
    /**
   * Will generate an emoji media path that is inclusive of client and token within the query parameter for media representation and altRepresentation
   */ async generateTokenisedMediaURLS(representation, altRepresentation) {
        if (!(0, $aQtlX.isMediaRepresentation)(representation)) return {
            representation: representation,
            altRepresentation: altRepresentation
        };
        try {
            const readToken = await this.tokenManager.getToken('read');
            return Object.entries({
                representation: representation,
                altRepresentation: altRepresentation
            }).reduce((acc, [key, value])=>{
                if (value && (0, $aQtlX.isMediaRepresentation)(value)) {
                    const path = new URL(value.mediaPath);
                    const params = path.searchParams;
                    if (params.get('token') !== readToken.jwt) params.set('token', readToken.jwt);
                    if (params.get('client') !== readToken.clientId) params.set('client', readToken.clientId);
                    acc[key] = {
                        ...value,
                        mediaPath: path.toString()
                    };
                }
                return acc;
            }, {
                representation: representation,
                altRepresentation: altRepresentation
            });
        } catch (error) {
            return {
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
    }
    /**
   * Will load media emoji, returning a new EmojiDescription if, for example,
   * the URL has changed.
   */ loadMediaEmoji(emoji, useAlt) {
        if (!(0, $aQtlX.isMediaEmoji)(emoji)) throw new Error('Only supported for media emoji');
        return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(emoji, useAlt) {
        const representation = useAlt ? emoji.altRepresentation : emoji.representation;
        if (!(0, $aQtlX.isMediaRepresentation)(representation)) throw new Error('Only supported for media emoji');
        const { mediaPath: mediaPath } = representation;
        return this.mediaEmojiCache.optimisticRendering(mediaPath);
    }
    uploadEmoji(upload, retry = false, progressCallback) {
        const startTime = Date.now();
        return this.tokenManager.getToken('upload', retry).then((uploadToken)=>{
            const tokenLoadTime = Date.now() - startTime;
            (0, $lACco.default)('upload token load time', tokenLoadTime);
            return new Promise((resolve, reject)=>{
                const { url: url, clientId: clientId, collectionName: collectionName } = uploadToken;
                const mediaClient = (0, $g3pIo.getMediaClient)({
                    authProvider: ()=>Promise.resolve({
                            clientId: clientId,
                            token: uploadToken.jwt,
                            baseUrl: url
                        }),
                    useSha256ForUploads: (0, $kHjbr.isFedRamp)() // SHA256 is not supported yet in commecrial regions
                });
                const subscription = mediaClient.file.upload({
                    content: upload.dataURL,
                    name: upload.filename,
                    collection: collectionName
                }).subscribe({
                    next: (state)=>{
                        if (state.status === 'uploading' && progressCallback) progressCallback({
                            percent: state.progress * $ca14bdd3ab59a04f$export$6f3a08dea02a7b2b
                        });
                        else if (state.status === 'processing') {
                            subscription.unsubscribe();
                            const totalUploadTime = Date.now() - startTime;
                            const mediaUploadTime = totalUploadTime - tokenLoadTime;
                            (0, $lACco.default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                            this.postToEmojiService(upload, state.id).then((emoji)=>{
                                resolve(emoji);
                            }).catch((httpError)=>{
                                reject(httpError.reason || httpError);
                            });
                        }
                    },
                    error (error) {
                        reject(error);
                    }
                });
            });
        });
    }
    /**
   * Check if the MediaEmojiResource has been able to initialise an uploadToken. Retrieving an upload token
   * is asynchronous so the Promise will need to resolve before the state is known. If the token retrieval
   * completes with failure then the Promise will resolve to false.
   */ hasUploadToken() {
        const tokenPromise = this.tokenManager.getToken('upload');
        return tokenPromise.then((token)=>{
            return token !== undefined;
        }, ()=>{
            return false;
        });
    }
    prepareForUpload() {
        // make sure a token is loaded from the emoji service if we don't have one
        // as future request to uploadEmoji will use this, this to preload it, as it
        // usually takes 1-2 seconds to generate
        this.tokenManager.getToken('upload');
    }
    findEmoji(emojiId) {
        if (!emojiId.id) return Promise.reject(false);
        const path = `../${encodeURIComponent(emojiId.id)}`;
        return (0, $9cbEs.emojiRequest)(this.siteServiceConfig, {
            path: path
        }).then((serviceResponse)=>{
            const response = (0, $9cbEs.denormaliseEmojiServiceResponse)(serviceResponse);
            return response.emojis[0];
        }).catch((error)=>{
            (0, $lACco.default)('failed to load emoji', emojiId, error);
            return undefined;
        });
    }
    /**
   * Calls to site-scoped EmojiResource to delete emoji
   * @param emoji media emoji to delete
   * @returns Promise.resolve() if success and Promise.reject() for failure
   */ deleteEmoji(emoji) {
        if (!(0, $aQtlX.isMediaEmoji)(emoji) && !(0, $aQtlX.isLoadedMediaEmoji)(emoji)) return Promise.reject(false);
        if (!emoji.id) return Promise.reject(false);
        const path = `${encodeURIComponent(emoji.id)}`;
        const requestInit = {
            method: 'DELETE'
        };
        return (0, $16UJG.utils).requestService(this.siteServiceConfig, {
            path: path,
            requestInit: requestInit
        })// Successful delete on Promise.resolve
        .then(()=>true)// Unsuccessful delete on Promise.reject
        .catch(()=>false);
    }
}

});
parcelRegister("jueEQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2fc30662c45a285$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $aQtlX = parcelRequire("aQtlX");

var $fjveu = parcelRequire("fjveu");

var $lACco = parcelRequire("lACco");

var $6roQF = parcelRequire("6roQF");
const $e2fc30662c45a285$var$getRequiredRepresentation = (emoji, useAlt)=>useAlt ? emoji.altRepresentation : emoji.representation;
const $e2fc30662c45a285$var$isUnsupportedBrowser = ()=>{
    const isIE = !!document.documentMode; // Internet Explorer 6-11
    const isEdge = !isIE && !!window.StyleMedia; // Edge 20+
    return isIE || isEdge;
};
class $e2fc30662c45a285$export$3850f566ce8d817a {
    constructor(mediaImageLoader){
        (0, $5zQU9.default)(this, "cachedImageUrls", new Set());
        (0, $lACco.default)('BrowserCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
    }
    loadEmoji(emoji, useAlt) {
        const representation = $e2fc30662c45a285$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $aQtlX.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        if (this.cachedImageUrls.has(mediaPath)) // Already cached
        return emoji;
        return this.mediaImageLoader.loadMediaImage(mediaPath).then(()=>{
            // Media is loaded, can use original URL now, so just return original emoji
            this.cachedImageUrls.add(mediaPath);
            return emoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return true;
    }
    static supported(mediaPath, mediaImageLoader) {
        // IE/Edge uses memory cache strategy else images can fail to load
        // from a clean cache/if they are downloaded from the service
        // TODO: fix as a part of FS-1592
        if ($e2fc30662c45a285$var$isUnsupportedBrowser()) return Promise.resolve(false);
        return mediaImageLoader.loadMediaImage(mediaPath).then(()=>// Image should be cached in browser, if supported it should be accessible from the cache by an <img/>
            // Try to load without via image to confirm this support (this fails in Firefox)
            new Promise((resolve)=>{
                const img = new Image();
                img.addEventListener('load', ()=>{
                    resolve(true);
                });
                img.addEventListener('error', ()=>{
                    resolve(false);
                });
                img.src = mediaPath;
            })).catch(()=>false);
    }
}
const $e2fc30662c45a285$var$maxImageCached = 1000;
// Don't cache images large than this - dataUrl size in characters
const $e2fc30662c45a285$var$maxImageSize = 10000;
class $e2fc30662c45a285$export$b522858a3709f4c {
    constructor(mediaImageLoader){
        (0, $lACco.default)('MemoryCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
        this.dataURLCache = new (0, $6roQF.LRUMap)($e2fc30662c45a285$var$maxImageCached);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $e2fc30662c45a285$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $aQtlX.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const dataURL = this.dataURLCache.get(mediaPath);
        if (dataURL) // Already cached
        return (0, $aQtlX.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
        // Not cached, load
        return this.mediaImageLoader.loadMediaImage(mediaPath).then((dataURL)=>{
            const loadedEmoji = (0, $aQtlX.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
            if (dataURL.length <= $e2fc30662c45a285$var$maxImageSize) // Only cache if not large than max size
            this.dataURLCache.set(mediaPath, dataURL);
            else (0, $lACco.default)('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
            return loadedEmoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return false;
    }
}
class $e2fc30662c45a285$export$2e2bcd8739ae039 {
    constructor(tokenManager){
        (0, $5zQU9.default)(this, "waitingInitUrls", []);
        (0, $lACco.default)('MediaEmojiCache');
        this.mediaImageLoader = new (0, $fjveu.default)(tokenManager);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $e2fc30662c45a285$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $aQtlX.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const emojiCache = this.getCache(mediaPath);
        if ((0, $aQtlX.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.loadEmoji(emoji, useAlt)).catch(()=>undefined);
        return emojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(url) {
        const emojiCache = this.getCache(url);
        if ((0, $aQtlX.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.optimisticRendering()).catch(()=>false);
        return emojiCache.optimisticRendering();
    }
    getCache(url) {
        if (this.cache) return this.cache;
        this.waitingInitUrls.push(url);
        if (!this.cacheLoading) this.cacheLoading = this.initCache().then((cache)=>{
            this.cache = cache;
            this.cacheLoading = undefined;
            return cache;
        }).catch((err)=>{
            this.cacheLoading = undefined;
            throw err;
        });
        return this.cacheLoading;
    }
    initCache() {
        const url = this.waitingInitUrls.pop();
        if (!url) return Promise.reject('Unable to initialise cache based on provided url(s)');
        return $e2fc30662c45a285$export$3850f566ce8d817a.supported(url, this.mediaImageLoader).then((supported)=>{
            this.waitingInitUrls = []; // clear
            this.cacheLoading = undefined;
            if (supported) return new $e2fc30662c45a285$export$3850f566ce8d817a(this.mediaImageLoader);
            return new $e2fc30662c45a285$export$b522858a3709f4c(this.mediaImageLoader);
        }).catch(()=>{
            return this.initCache();
        });
    }
}

});
parcelRegister("fjveu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b260db8d88f96af4$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $f9qVC = parcelRequire("f9qVC");
const $b260db8d88f96af4$var$defaultConcurrentDownloadLimit = 16;
const $b260db8d88f96af4$var$backoffMaxDelayInMillis = 600;
const $b260db8d88f96af4$var$defaultMaxRetriesOnNotFound = 2;
class $b260db8d88f96af4$export$2e2bcd8739ae039 {
    constructor(tokenManager, options){
        (0, $5zQU9.default)(this, "mediaImageQueue", []);
        (0, $5zQU9.default)(this, "activeProcessing", 0);
        (0, $5zQU9.default)(this, "pendingRequests", new Map());
        this.concurrentDownloadLimit = options && options.concurrentDownloadLimit || $b260db8d88f96af4$var$defaultConcurrentDownloadLimit;
        this.tokenManager = tokenManager;
    }
    loadMediaImage(url) {
        const maybePending = this.pendingRequests.get(url);
        if (maybePending !== undefined) return maybePending;
        const pending = new Promise((resolve, reject)=>{
            this.mediaImageQueue.push({
                url: url,
                resolve: resolve,
                reject: reject
            });
            this.processFromQueue();
        }).then((result)=>{
            this.pendingRequests.delete(url);
            return result;
        }).catch((error)=>{
            this.pendingRequests.delete(url);
            throw error;
        });
        this.pendingRequests.set(url, pending);
        return pending;
    }
    getQueueSize() {
        return this.mediaImageQueue.length;
    }
    getActiveDownloads() {
        return this.activeProcessing;
    }
    processFromQueue() {
        while(this.activeProcessing < this.concurrentDownloadLimit && this.mediaImageQueue.length > 0){
            this.activeProcessing++;
            const item = this.mediaImageQueue.shift();
            const { url: url, resolve: resolve, reject: reject } = item;
            this.tokenManager.getToken('read', false).then((token)=>{
                this.requestMediaEmoji(url, token, true).then((dataURL)=>{
                    resolve(dataURL);
                    this.completedItem();
                }).catch((error)=>{
                    reject(error);
                    this.completedItem();
                });
            }).catch((error)=>{
                // Failed to load, just resolve to original emoji
                reject(error);
                this.completedItem();
            });
        }
    }
    completedItem() {
        this.activeProcessing--;
        this.processFromQueue();
    }
    delay(durationInMillis) {
        return new Promise((resolve)=>setTimeout(resolve, durationInMillis));
    }
    requestMediaEmoji(url, token, retryOnAuthError, retriesOnNotFound = $b260db8d88f96af4$var$defaultMaxRetriesOnNotFound) {
        return (0, $f9qVC.imageAcceptHeader)().then((acceptHeader)=>{
            // Media REST API: https://media-api-internal.atlassian.io/api.html#file__fileId__image_get
            const options = {
                headers: {
                    Authorization: `Bearer ${token.jwt}`,
                    'X-Client-Id': token.clientId,
                    Accept: acceptHeader
                }
            };
            return fetch(url, options).then((response)=>{
                // retry if 404
                if (response.status === 404 && retriesOnNotFound > 0) return this.delay($b260db8d88f96af4$var$backoffMaxDelayInMillis / retriesOnNotFound) // backoff strategy
                .then(()=>this.requestMediaEmoji(url, token, false, retriesOnNotFound - 1));
                else if (response.status === 403 && retryOnAuthError) // retry once if 403
                return this.tokenManager.getToken('read', true).then((newToken)=>this.requestMediaEmoji(url, newToken, false));
                else if (response.ok) return response.blob().then((blob)=>this.readBlob(blob));
                throw new Error(`Unable to load media image. Status=${response.status} ${response.statusText}`);
            });
        });
    }
    readBlob(blob) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            // TODO: [ts30] Add proper handling for null and ArrayBuffer
            reader.addEventListener('load', ()=>resolve(reader.result));
            reader.addEventListener('error', ()=>reject(reader.error));
            reader.readAsDataURL(blob);
        });
    }
}

});
parcelRegister("f9qVC", function(module, exports) {

$parcel$export(module.exports, "getNaturalImageSize", () => $b07c95ae483e24e0$export$90153ab95f408dfa);
$parcel$export(module.exports, "parseImage", () => $b07c95ae483e24e0$export$37bbb051492a18a7);
$parcel$export(module.exports, "hasFileExceededSize", () => $b07c95ae483e24e0$export$a115ddd5941792f1);
$parcel$export(module.exports, "imageAcceptHeader", () => $b07c95ae483e24e0$export$f8e7886bc155c2e6);
const $b07c95ae483e24e0$var$maxEmojiSizeInBytes = 1048576;
const $b07c95ae483e24e0$export$90153ab95f408dfa = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.addEventListener('load', ()=>{
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        });
        img.addEventListener('error', reject);
        img.src = dataURL;
    });
};
const $b07c95ae483e24e0$export$37bbb051492a18a7 = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        let img = new Image();
        img.onload = ()=>resolve({
                src: img.src
            });
        img.onerror = ()=>reject();
        img.src = dataURL;
    });
};
const $b07c95ae483e24e0$export$a115ddd5941792f1 = (file)=>{
    return file && file.size > $b07c95ae483e24e0$var$maxEmojiSizeInBytes;
};
// Duplicates https://bitbucket.org/atlassian/atlaskit/src/0e843df6df8bcd33fa7fc16cc63f11a0f6094957/packages/media-core/src/utils/checkWebpSupport.ts?at=master&fileviewer=file-view-default
// Didn't want to depend on the whole of media-core just for this util
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */ let $b07c95ae483e24e0$var$isWebpSupported;
const $b07c95ae483e24e0$export$c5a964eb84c7fca8 = ()=>{
    if ($b07c95ae483e24e0$var$isWebpSupported !== undefined) return Promise.resolve($b07c95ae483e24e0$var$isWebpSupported);
    return new Promise((resolve)=>{
        const img = new Image();
        const checkSupport = ()=>{
            $b07c95ae483e24e0$var$isWebpSupported = img.height === 2;
            resolve($b07c95ae483e24e0$var$isWebpSupported);
        };
        img.addEventListener('load', checkSupport);
        img.addEventListener('error', checkSupport);
        img.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    });
};
const $b07c95ae483e24e0$export$f8e7886bc155c2e6 = ()=>$b07c95ae483e24e0$export$c5a964eb84c7fca8().then((isWebpSupported)=>{
        // q=0.8 stands for 'quality factor' => http://stackoverflow.com/a/10496722
        const noWebpAcceptHeader = 'image/*,*/*;q=0.8';
        const webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
        return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
    });

});



parcelRegister("aYzhp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fdadfd1b1e82d6a$export$2e2bcd8739ae039);

var $16UJG = parcelRequire("16UJG");
const $7fdadfd1b1e82d6a$export$866c20c059277b6 = 30;
class $7fdadfd1b1e82d6a$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig){
        this.siteServiceConfig = siteServiceConfig;
        this.tokens = new Map();
    }
    isValidToken(mediaApiToken) {
        const nowInSeconds = Date.now() / 1000;
        const expiresAt = mediaApiToken.expiresAt - $7fdadfd1b1e82d6a$export$866c20c059277b6;
        if (nowInSeconds < expiresAt) return true;
        return false;
    }
    fetchNewToken(type) {
        return (0, $16UJG.utils).requestService(this.siteServiceConfig, {
            path: `token/${type}`
        });
    }
    addToken(type, mediaApiToken) {
        this.tokens.set(type, {
            mediaApiToken: mediaApiToken
        });
    }
    getToken(type, forceRefresh) {
        let tokenDetail = this.tokens.get(type);
        if (!tokenDetail) {
            tokenDetail = {};
            this.tokens.set(type, tokenDetail);
        }
        const { mediaApiToken: mediaApiToken, activeTokenRefresh: activeTokenRefresh } = tokenDetail;
        if (mediaApiToken) {
            if (this.isValidToken(mediaApiToken) && !forceRefresh) // still valid
            return Promise.resolve(mediaApiToken);
        }
        if (activeTokenRefresh) // refresh token promise already active, return that
        return activeTokenRefresh;
        // request a new token and track the promise for future requests until completed
        tokenDetail.activeTokenRefresh = this.fetchNewToken(type).then((token)=>{
            tokenDetail.mediaApiToken = token;
            tokenDetail.activeTokenRefresh = undefined;
            return token;
        });
        return tokenDetail.activeTokenRefresh;
    }
}

});

parcelRegister("kHjbr", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $f116b443c6fef4cf$export$64d6499adf9b2e51);
const $f116b443c6fef4cf$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $f116b443c6fef4cf$export$64d6499adf9b2e51() {
    var _globalThis$location, _globalThis$location$;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = globalThis.MICROS_PERIMETER || globalThis.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $f116b443c6fef4cf$var$FEDRAMP_MODERATE;
    const matches = (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : (_globalThis$location$ = _globalThis$location.hostname) === null || _globalThis$location$ === void 0 ? void 0 : _globalThis$location$.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});


parcelRegister("1UFsQ", function(module, exports) {

$parcel$export(module.exports, "ufoExperiences", () => $164b2f5dc9458722$export$615f888019c45765);
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $164b2f5dc9458722$export$71c8cba6f1251ea9);
$parcel$export(module.exports, "hasUfoMarked", () => $164b2f5dc9458722$export$a9be054d2a5cedc0);
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $164b2f5dc9458722$export$1466212a1606133);

var $dnGEj = parcelRequire("dnGEj");

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
var $7dDfK = parcelRequire("7dDfK");

var $fcwFl = parcelRequire("fcwFl");
const $164b2f5dc9458722$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $3yYXq.ExperienceTypes).Load,
        performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $164b2f5dc9458722$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $3yYXq.ExperienceTypes).Experience,
        performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
    };
};
const $164b2f5dc9458722$var$customEmojiTimings = [
    {
        key: (0, $dnGEj.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $dnGEj.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $dnGEj.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $dnGEj.UfoEmojiTimings).METADATA_START,
        endMark: (0, $dnGEj.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $dnGEj.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $dnGEj.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $dnGEj.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $dnGEj.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $dnGEj.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $dnGEj.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $dnGEj.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $dnGEj.UfoEmojiTimings).ONLOAD_END
    }
];
const $164b2f5dc9458722$export$615f888019c45765 = {
    'emoji-rendered': new (0, $2kFUE.ConcurrentExperience)((0, $dnGEj.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $dnGEj.UfoComponentName).EMOJI
        },
        type: (0, $3yYXq.ExperienceTypes).Operation,
        performanceType: (0, $3yYXq.ExperiencePerformanceTypes).Custom,
        timings: $164b2f5dc9458722$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $2kFUE.ConcurrentExperience)((0, $dnGEj.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $164b2f5dc9458722$var$createRenderExperience((0, $dnGEj.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $7dDfK.UFOExperience)((0, $dnGEj.UfoExperienceName).EMOJI_PICKER_OPENED, $164b2f5dc9458722$var$createRenderExperience((0, $dnGEj.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $7dDfK.UFOExperience)((0, $dnGEj.UfoExperienceName).EMOJI_SELECTION_RECORDED, $164b2f5dc9458722$var$createInlineExperience((0, $dnGEj.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $7dDfK.UFOExperience)((0, $dnGEj.UfoExperienceName).EMOJI_UPLOADED, $164b2f5dc9458722$var$createInlineExperience((0, $dnGEj.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $7dDfK.UFOExperience)((0, $dnGEj.UfoExperienceName).EMOJI_SEARCHED, $164b2f5dc9458722$var$createInlineExperience((0, $dnGEj.UfoComponentName).EMOJI_PICKER))
};
const $164b2f5dc9458722$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $fcwFl.withSampling)($164b2f5dc9458722$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
const $164b2f5dc9458722$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
const $164b2f5dc9458722$export$1466212a1606133 = (providerType)=>{
    return (0, $fcwFl.withSampling)($164b2f5dc9458722$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("2kFUE", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $a30e24b2c52cc36f$export$ac1cddfee07ba6ac);

var $f0LiU = parcelRequire("f0LiU");

var $7dDfK = parcelRequire("7dDfK");
class $a30e24b2c52cc36f$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $7dDfK.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $f0LiU.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("f0LiU", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $c2704d0c50f619e5$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $c2704d0c50f619e5$export$d53d07b6034c4560);
class $c2704d0c50f619e5$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($c2704d0c50f619e5$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($c2704d0c50f619e5$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $c2704d0c50f619e5$export$4ab84f6f04f6566d = new $c2704d0c50f619e5$var$UFOLogger();
const $c2704d0c50f619e5$export$b4958caff08a0960 = (...args)=>{
    $c2704d0c50f619e5$export$4ab84f6f04f6566d.log(...args);
};
const $c2704d0c50f619e5$export$d53d07b6034c4560 = (...args)=>{
    $c2704d0c50f619e5$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("7dDfK", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $0bfda9d094674d59$export$c00d22927c60484a);

var $4XjsX = parcelRequire("4XjsX");
class $0bfda9d094674d59$export$c00d22927c60484a extends (0, $4XjsX.UFOAbstractExperience) {
}

});
parcelRegister("4XjsX", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $b82268227d2a5ae4$export$d31c89db257648c);

var $hompL = parcelRequire("hompL");


var $6fEIi = parcelRequire("6fEIi");

var $f0LiU = parcelRequire("f0LiU");

var $1A03k = parcelRequire("1A03k");

var $5bc3G = parcelRequire("5bc3G");

var $a72vD = parcelRequire("a72vD");

var $9IyR3 = parcelRequire("9IyR3");

var $uMitL = parcelRequire("uMitL");

var $3vocg = parcelRequire("3vocg");

var $3yYXq = parcelRequire("3yYXq");
const $b82268227d2a5ae4$var$getPageVisibleState = ()=>{
    return !(0, $9IyR3.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $5bc3G.PageVisibleState).VISIBLE : (0, $5bc3G.PageVisibleState).HIDDEN;
};
const $b82268227d2a5ae4$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $a72vD.roundPerfNow)();
};
class $b82268227d2a5ae4$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $uMitL.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $5bc3G.PageVisibleState).MIXED;
            (0, $1A03k.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $b82268227d2a5ae4$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $3yYXq.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $f0LiU.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $3vocg.canTransition)(this.state, newState)) {
            (0, $f0LiU.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $uMitL.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $hompL.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.unsubscribeEvent)((0, $5bc3G.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $f0LiU.ufolog)('this.parent', this.parent);
                (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $f0LiU.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $f0LiU.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $uMitL.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $b82268227d2a5ae4$var$getPageVisibleState();
            (0, $1A03k.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $f0LiU.ufolog)('subscribed', this.id);
                (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.subscribeEvent)((0, $5bc3G.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $5bc3G.FMP_MARK) && name !== (0, $5bc3G.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $f0LiU.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $uMitL.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $5bc3G.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $5bc3G.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $f0LiU.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $1A03k.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $f0LiU.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $392a4a01cdcd9472$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $392a4a01cdcd9472$export$2295b861f318254a = '0.1.5';

parcelRegister("6fEIi", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $7118726fd593c611$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $7118726fd593c611$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $7118726fd593c611$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $7118726fd593c611$export$7c957416596ca127);

var $f0LiU = parcelRequire("f0LiU");

var $5bc3G = parcelRequire("5bc3G");
const $7118726fd593c611$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $7118726fd593c611$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $7118726fd593c611$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $7118726fd593c611$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $f0LiU.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $7118726fd593c611$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $7118726fd593c611$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $7118726fd593c611$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("5bc3G", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $6db1c4aca6f838ac$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $6db1c4aca6f838ac$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $6db1c4aca6f838ac$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $6db1c4aca6f838ac$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $6db1c4aca6f838ac$export$837e0f79a8056912);
var $6db1c4aca6f838ac$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($6db1c4aca6f838ac$export$96253c35c37cf96b || ($6db1c4aca6f838ac$export$96253c35c37cf96b = {}));
var $6db1c4aca6f838ac$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($6db1c4aca6f838ac$export$a12c67b37a306b13 || ($6db1c4aca6f838ac$export$a12c67b37a306b13 = {}));
var $6db1c4aca6f838ac$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($6db1c4aca6f838ac$export$66b33c055cbb625e || ($6db1c4aca6f838ac$export$66b33c055cbb625e = {}));
var $6db1c4aca6f838ac$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($6db1c4aca6f838ac$export$3ce489cbe02dc21b || ($6db1c4aca6f838ac$export$3ce489cbe02dc21b = {}));
var $6db1c4aca6f838ac$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($6db1c4aca6f838ac$export$341b330828bd3906 || ($6db1c4aca6f838ac$export$341b330828bd3906 = {}));
var $6db1c4aca6f838ac$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($6db1c4aca6f838ac$export$b9b20160f581e4f8 || ($6db1c4aca6f838ac$export$b9b20160f581e4f8 = {}));
const $6db1c4aca6f838ac$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $6db1c4aca6f838ac$export$9f2bf58999404c75 = 'fmp';
const $6db1c4aca6f838ac$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("1A03k", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $95f5135adf29b140$export$13e680397ec8f3eb);

var $9IyR3 = parcelRequire("9IyR3");
class $95f5135adf29b140$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $9IyR3.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $95f5135adf29b140$export$13e680397ec8f3eb = new $95f5135adf29b140$var$VisibilityChangeObserver();

});
parcelRegister("9IyR3", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $3677fb5e29ccb89d$export$15e172712955e18f);
const $3677fb5e29ccb89d$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("a72vD", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $abf5afa8ee98b73d$export$5f490af6b2b115cf);
const $abf5afa8ee98b73d$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("uMitL", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $dce4f34a405f688c$export$81b70111112841a0);
const $dce4f34a405f688c$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("3vocg", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $5c3cafcf3c197b83$export$178881f329fdb81f);

var $uMitL = parcelRequire("uMitL");
const $5c3cafcf3c197b83$var$UFOStateAvailableTransitions = {
    [(0, $uMitL.UFOExperienceState).NOT_STARTED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).STARTED.id]: [
        (0, $uMitL.UFOExperienceState).IN_PROGRESS.id,
        (0, $uMitL.UFOExperienceState).BLOCKED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $uMitL.UFOExperienceState).BLOCKED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).BLOCKED.id]: [
        (0, $uMitL.UFOExperienceState).RECOVERED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).RECOVERED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).SUCCEEDED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).FAILED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).ABORTED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ]
};
const $5c3cafcf3c197b83$export$178881f329fdb81f = (state1, state2)=>{
    return $5c3cafcf3c197b83$var$UFOStateAvailableTransitions[state1.id] && $5c3cafcf3c197b83$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("3yYXq", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $156ab33d023ea8cf$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $156ab33d023ea8cf$export$cc26007c03242fff);
var $156ab33d023ea8cf$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($156ab33d023ea8cf$export$994164cf3ae1cc9a || ($156ab33d023ea8cf$export$994164cf3ae1cc9a = {}));
var $156ab33d023ea8cf$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($156ab33d023ea8cf$export$cc26007c03242fff || ($156ab33d023ea8cf$export$cc26007c03242fff = {}));

});




parcelRegister("fcwFl", function(module, exports) {

$parcel$export(module.exports, "withSampling", () => $b11150c8685b3f6d$export$dc2f0946255b3f89);
const $b11150c8685b3f6d$export$c7c4959fece2f3ec = {};
const $b11150c8685b3f6d$export$cdff9a865136ae27 = ()=>{
    for (const prop of Object.getOwnPropertyNames($b11150c8685b3f6d$export$c7c4959fece2f3ec))delete $b11150c8685b3f6d$export$c7c4959fece2f3ec[prop];
};
const $b11150c8685b3f6d$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $b11150c8685b3f6d$var$hasSampledFromStart = (experience)=>{
    if (!$b11150c8685b3f6d$export$c7c4959fece2f3ec[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return $b11150c8685b3f6d$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
    return $b11150c8685b3f6d$export$c7c4959fece2f3ec[experience.id].sampled;
};
const $b11150c8685b3f6d$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!$b11150c8685b3f6d$export$c7c4959fece2f3ec[ufoExperience.id]) $b11150c8685b3f6d$export$c7c4959fece2f3ec[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($b11150c8685b3f6d$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || $b11150c8685b3f6d$export$1c967630b3ea2d58;
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) $b11150c8685b3f6d$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            $b11150c8685b3f6d$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            $b11150c8685b3f6d$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            $b11150c8685b3f6d$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$b11150c8685b3f6d$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$b11150c8685b3f6d$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$b11150c8685b3f6d$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$b11150c8685b3f6d$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$b11150c8685b3f6d$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$b11150c8685b3f6d$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$b11150c8685b3f6d$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});



parcelRegister("k7z88", function(module, exports) {

$parcel$export(module.exports, "EMOJI_SERVICEID", () => $457dd1ed4ad976ac$export$f3c4ed49c0fff3de);
$parcel$export(module.exports, "EMOJI_WITH_CUSTOM_SERVICEID", () => $457dd1ed4ad976ac$export$f8b39b441e3e8eb2);
$parcel$export(module.exports, "EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID", () => $457dd1ed4ad976ac$export$2cdcb9248b6d4704);
$parcel$export(module.exports, "getServiceProvider", () => $457dd1ed4ad976ac$export$a4c27db78169052e);
$parcel$export(module.exports, "default", () => $457dd1ed4ad976ac$export$2e2bcd8739ae039);

var $6rW04 = parcelRequire("6rW04");
const $457dd1ed4ad976ac$var$providersRepository = {};
const $457dd1ed4ad976ac$export$f3c4ed49c0fff3de = 'emoji';
const $457dd1ed4ad976ac$export$f8b39b441e3e8eb2 = 'emoji-with-custom';
const $457dd1ed4ad976ac$export$2cdcb9248b6d4704 = 'emoji-with-custom-upload-disabled';
const $457dd1ed4ad976ac$var$getServiceBaseUrl = (serviceId)=>{
    if (serviceId === $457dd1ed4ad976ac$export$f8b39b441e3e8eb2 || serviceId === $457dd1ed4ad976ac$export$2cdcb9248b6d4704) return (0, $6rW04.default)('ajs-fabric-emoji-url');
    return (0, $6rW04.default)(`ajs-fabric-${serviceId}-url`);
};
const $457dd1ed4ad976ac$export$a4c27db78169052e = (serviceId, serviceProviderGenerator)=>{
    try {
        let serviceProvider = $457dd1ed4ad976ac$var$providersRepository[serviceId];
        if (serviceProvider === undefined) {
            const serviceBaseUrl = $457dd1ed4ad976ac$var$getServiceBaseUrl(serviceId);
            if (serviceBaseUrl) {
                serviceProvider = Promise.resolve(serviceProviderGenerator(serviceBaseUrl));
                $457dd1ed4ad976ac$var$providersRepository[serviceId] = serviceProvider;
            }
        }
        return serviceProvider;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
};
const $457dd1ed4ad976ac$export$59790759c19337ec = ()=>{
    Object.keys($457dd1ed4ad976ac$var$providersRepository).forEach((key)=>{
        delete $457dd1ed4ad976ac$var$providersRepository[key];
    });
};
var $457dd1ed4ad976ac$export$2e2bcd8739ae039 = $457dd1ed4ad976ac$var$getServiceBaseUrl;

});


parcelRegister("3ZL8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ae4bb44b54337b7$export$2e2bcd8739ae039);
/**
 * Recursively searches for an 'href' attribute by traversing up the DOM tree from a given element until a specified top element is reached.
 * This function is useful for determining if an element is part of a larger navigable link structure.
 */ // @ts-expect-error - TS7023 - 'checkForHref' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions.
const $0ae4bb44b54337b7$var$checkForHref = (currentElement, topElement)=>{
    // if we reach the original div, we didn't find href
    if (!currentElement || currentElement === topElement) return false;
    if (currentElement.href != null) return true;
    // continue walking up the DOM tree looking for hrefs
    return $0ae4bb44b54337b7$var$checkForHref(currentElement.parentElement, topElement);
};
var $0ae4bb44b54337b7$export$2e2bcd8739ae039 = $0ae4bb44b54337b7$var$checkForHref;

});

parcelRegister("4xwq2", function(module, exports) {

$parcel$export(module.exports, "TextContentArea", () => $1d6e9d9e18ae818d$export$ec6675e932be98e4);
$parcel$export(module.exports, "ScrollableArea", () => $1d6e9d9e18ae818d$export$83c3fa3ac4f31acf);
$parcel$export(module.exports, "EmptyValue", () => $1d6e9d9e18ae818d$export$1ebe45ee63a8a144);
$parcel$export(module.exports, "Ellipsis", () => $1d6e9d9e18ae818d$export$1297970233533a7d);
/* issue-value.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $1d6e9d9e18ae818d$export$a5b94313d6908893 = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
};
const $1d6e9d9e18ae818d$var$FALLBACK_ROWS = 2;
const $1d6e9d9e18ae818d$export$afe400f595924e77 = (target)=>null;
const $1d6e9d9e18ae818d$var$getTextAreaCss = {
    fontSize: '1em',
    lineHeight: 1.714,
    fontWeight: 'normal',
    marginTop: "var(--ds-space-025, 2px)",
    marginBottom: 0,
    letterSpacing: '-0.005em',
    overflowY: 'auto',
    overflowX: 'hidden',
    width: '100%',
    height: 'auto',
    whiteSpace: 'pre-line'
};
const $1d6e9d9e18ae818d$export$ec6675e932be98e4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1x4e _vwz478tn _k48p4jg8 _19pkv77o _otyridpf _1dyzdjp5 _18m91wug _1reo15vq _1bsb1osq _4t3i1wug _o5726vc6",
            __cmplp.className
        ])
    });
});
const $1d6e9d9e18ae818d$export$83c3fa3ac4f31acf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxRows: maxRows, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_lsy6xb": (0, $9t7rW.default)(`${(__cmplp.maxRows ? __cmplp.maxRows : $1d6e9d9e18ae818d$var$FALLBACK_ROWS) * 2.5}ex`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1x4e _vwz478tn _k48p4jg8 _19pkv77o _otyridpf _1dyzdjp5 _18m91wug _1reo15vq _1bsb1osq _4t3i1wug _o5726vc6 _c71l1v1h _1ke8ftgi _1suq18uv _aaynrg55 _155a19bv",
            __cmplp.className
        ])
    });
});
const $1d6e9d9e18ae818d$export$1ebe45ee63a8a144 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1",
            __cmplp.className
        ])
    });
});
const $1d6e9d9e18ae818d$export$1297970233533a7d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kWNk2", function(module, exports) {

$parcel$export(module.exports, "mediaFeatureFlags", () => $33b71246640210ea$export$250985d9ea13242f);
/**
 * Feature flags should be defined individually in './feature-flags.js'
 * There is processing on that file to automate analytics discovery.
 * We import them here so they can be exported as one value and given to
 * Editor/Renderer/Media components.
 *
 * NOTE: The use of functions vs raw values is intentional. You must use
 * `mediaFeatureFlags()` vs `mediaFeatureFlags` due to the fact that these
 * flags won't be available immediately. This relates to SST and launchdarkly.
 * Otherwise the getters would be executed immediately and blank values
 * will be passed.
 */ 
var $fbdfB = parcelRequire("fbdfB");
const $33b71246640210ea$export$250985d9ea13242f = ()=>({
        mediaInline: (0, $fbdfB.isMediaInlineEnabled)(),
        // TODO: remove after media team clean up securedClipboard: https://product-fabric.atlassian.net/browse/CXP-2664
        securedClipboard: true
    });

});




parcelRegister("hlK0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ef4d8533d56922$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $b6ef4d8533d56922$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "issue.log-time.modal.work-description.label",
        "defaultMessage": "Work description"
    }
});

});

parcelRegister("3lwIp", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('LATQw')
        ]);
        const value = parcelRequire('6uf9Z');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("LATQw")
    ]).then(()=>parcelRequire('6uf9Z'));
}

});



parcelRegister("eYjMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef3ba0ab95a2ada7$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $ef3ba0ab95a2ada7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timeRemaining: {
        "id": "issue.log-time.modal.time-remaining",
        "defaultMessage": "Time remaining"
    },
    timeRemainingInfo: {
        "id": "issue.log-time.modal.time-remaining.time-remaining-info",
        "defaultMessage": "If time remaining isn't what you expect, manually update it here."
    },
    timeSpent: {
        "id": "issue.log-time.modal.time-spent",
        "defaultMessage": "Time spent"
    },
    dateStarted: {
        "id": "issue.log-time.modal.date-started",
        "defaultMessage": "Date started"
    },
    timeInvalidMessage: {
        "id": "issue.common.messages.time.time-invalid-message",
        "defaultMessage": "Check your entry matches the time format"
    },
    timeRemainingTriggerBtnLabel: {
        "id": "issue-view-common.component.log-time-modal.modal.time-log-text-field.time-remainin-popup-label",
        "defaultMessage": "More information about Time remaining"
    }
});

});

parcelRegister("5acJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5868324cf7fd55c0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3RoDL = parcelRequire("3RoDL");

var $b8mID = parcelRequire("b8mID");

var $eYjMq = parcelRequire("eYjMq");
const $5868324cf7fd55c0$var$ValidatedLogTimeInput = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isValid: isValid, value: value, onChange: onChange, onBlur: onBlur, isDisabled: isDisabled } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3RoDL.default), {
        isValid: isValid
    }, (shouldAppearInvalid)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b8mID.default), {
            value: value,
            isInvalid: shouldAppearInvalid,
            invalidMessage: formatMessage((0, $eYjMq.default).timeInvalidMessage),
            onChange: onChange,
            onBlur: onBlur,
            isDisabled: isDisabled,
            label: formatMessage((0, $eYjMq.default).timeSpent),
            name: (0, $eYjMq.default).timeSpent.id,
            autoFocus: true
        }));
};
var $5868324cf7fd55c0$export$2e2bcd8739ae039 = $5868324cf7fd55c0$var$ValidatedLogTimeInput;

});
parcelRegister("3RoDL", function(module, exports) {

$parcel$export(module.exports, "default", () => $22e439436cde6eb0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
class $22e439436cde6eb0$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    UNSAFE_componentWillReceiveProps(nextProps) {
        const hasBecomeValid = !this.props.isValid && nextProps.isValid;
        if (hasBecomeValid) this.setState({
            shouldAppearInvalid: false
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            onBlur: this.onBlur
        }, this.props.children(this.state.shouldAppearInvalid));
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldAppearInvalid: !this.props.isValid
        };
        this.onBlur = ()=>{
            this.setState({
                shouldAppearInvalid: !this.props.isValid
            });
        };
    }
}

});

parcelRegister("b8mID", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8b832d9ba1ac916$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $7jPhn = parcelRequire("7jPhn");

var $3MV1G = parcelRequire("3MV1G");

var $cf2Y4 = parcelRequire("cf2Y4");

var $c9TLT = parcelRequire("c9TLT");

var $15sFp = parcelRequire("15sFp");

var $64ypR = parcelRequire("64ypR");
class $c8b832d9ba1ac916$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isInvalid: false,
            isRequired: false,
            isDisabled: false,
            autoFocus: false,
            name: 'text-field',
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.CustomFieldHeadingWithBottomMargin), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, this.props.label), this.props.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
            testId: "issue.component.log-time-modal.modal.time-log-text-field.ak-popup",
            zIndex: (0, $c9TLT.layers).modal,
            onClose: ()=>{
                this.setState({
                    shouldShowDetails: false
                });
            },
            placement: "right-start",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c8b832d9ba1ac916$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, this.props.description)),
            isOpen: this.state.shouldShowDetails,
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c8b832d9ba1ac916$var$CustomTimeLogPopupButton, {
                    ...triggerProps,
                    spacing: "none",
                    appearance: "subtle",
                    isSelected: this.state.shouldShowDetails,
                    onClick: this.onToggle,
                    "aria-label": this.props.triggerBtnAriaLabel
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15sFp.default), null))
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            autoFocus: this.props.autoFocus,
            isInvalid: this.props.isInvalid,
            isDisabled: this.props.isDisabled,
            isRequired: this.props.isRequired,
            onChange: this.onChange,
            value: this.props.value,
            onBlur: this.props.onBlur
        }), this.props.isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, this.props.invalidMessage));
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldShowDetails: false
        };
        this.onToggle = ()=>this.setState({
                shouldShowDetails: !this.state.shouldShowDetails
            });
        this.onChange = (event)=>{
            this.props.onChange(event.target.value);
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c8b832d9ba1ac916$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1k99 _18u0v77o _1bsb1wug _1yt41k9v _1reo1wug _18m91wug _bfhkhp5a _16qs1e8m",
            __cmplp.className
        ])
    });
});
const $c8b832d9ba1ac916$var$CustomTimeLogPopupButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66 _11q7glyw _1nj113vh _1du2glyw _19lcglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7jPhn", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $8d7fd15aabd72279$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $8d7fd15aabd72279$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $8d7fd15aabd72279$export$5505afb209a532c8);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $lD2Nx = parcelRequire("lD2Nx");

var $96IgR = parcelRequire("96IgR");

var $PdmhA = parcelRequire("PdmhA");

var $gaA9C = parcelRequire("gaA9C");
function $8d7fd15aabd72279$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d7fd15aabd72279$var$messageStyles = {
    name: "ywqxo4",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-050, 4px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $8d7fd15aabd72279$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $8d7fd15aabd72279$var$iconWrapperStyles = {
    name: "zjik7",
    styles: "display:flex"
};
const $8d7fd15aabd72279$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8d7fd15aabd72279$var$iconWrapperStyles
    }, children);
};
const $8d7fd15aabd72279$var$messageIcons = {
    error: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
        size: "small",
        label: "success"
    })
};
const $8d7fd15aabd72279$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $8d7fd15aabd72279$var$messageIcons[appearance];
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $byn9U.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $8d7fd15aabd72279$var$messageStyles,
            $8d7fd15aabd72279$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        "aria-live": "polite"
    }, icon && /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$IconWrapper, null, icon), content);
};
const $8d7fd15aabd72279$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));

});
parcelRegister("lD2Nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbef6921e18df378$var$_react = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $fbef6921e18df378$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fbef6921e18df378$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $fbef6921e18df378$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm1.364-10.964l-2.152 4.11-1.543-1.39a1 1 0 10-1.338 1.487l2.5 2.25a1 1 0 001.555-.279l2.75-5.25a1 1 0 00-1.772-.928z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$fbef6921e18df378$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $fbef6921e18df378$var$_default = $fbef6921e18df378$var$EditorSuccessIcon;
module.exports.default = $fbef6921e18df378$var$_default;

});


parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: undefined,
    packageVersion: undefined
};
const $ecaf8c9a10cf48c9$var$TextfieldComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
$ecaf8c9a10cf48c9$var$TextfieldComponent.displayName = 'Textfield';
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.memo)($ecaf8c9a10cf48c9$var$TextfieldComponent);
var // The above generic is used to let ERTC know what props to extract.
// See: https://github.com/atlassian/extract-react-types/issues/201
$ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

var $PdmhA = parcelRequire("PdmhA");
const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    subtle: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $PdmhA.N900})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`,
                borderColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $PdmhA.R400})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $PdmhA.R400})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $PdmhA.N0})`,
            borderColor: `var(--ds-border-focused, ${0, $PdmhA.B200})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $PdmhA.B200})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-monospace, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $PdmhA.N200})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("15sFp", function(module, exports) {

$parcel$export(module.exports, "default", () => $72de40d73cc660b1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $72de40d73cc660b1$var$InfoIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "issue-field-description.ui.assets.icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12ZM6 10.6667C8.57733 10.6667 10.6667 8.57733 10.6667 6C10.6667 3.42267 8.57733 1.33333 6 1.33333C3.42267 1.33333 1.33333 3.42267 1.33333 6C1.33333 8.57733 3.42267 10.6667 6 10.6667ZM6 9.33333C5.65811 9.33333 5.37633 9.07597 5.33782 8.74441L5.33333 8.66667V6C5.33333 5.63181 5.63181 5.33333 6 5.33333C6.34189 5.33333 6.62367 5.59069 6.66218 5.92225L6.66667 6V8.66667C6.66667 9.03486 6.36819 9.33333 6 9.33333Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 2.66667C5.53976 2.66667 5.16667 3.03976 5.16667 3.5C5.16667 3.96024 5.53976 4.33333 6 4.33333C6.46024 4.33333 6.83333 3.96024 6.83333 3.5C6.83333 3.03976 6.46024 2.66667 6 2.66667Z",
        fill: "currentColor"
    }));
var $72de40d73cc660b1$export$2e2bcd8739ae039 = $72de40d73cc660b1$var$InfoIcon;

});

parcelRegister("64ypR", function(module, exports) {

$parcel$export(module.exports, "animationFadeIn", () => $b3e216f69d844fba$export$5b770964b96200c1);
$parcel$export(module.exports, "FIELD_WRAPPER_COMPONENT_SELECTOR", () => $b3e216f69d844fba$export$760fd24410df5fa0);
$parcel$export(module.exports, "FieldWrapper", () => $b3e216f69d844fba$export$6a00f65eec6002a6);
$parcel$export(module.exports, "fieldHeadingIconsCss", () => $b3e216f69d844fba$export$ddb92a8141f8005e);
$parcel$export(module.exports, "SideBySideField", () => $b3e216f69d844fba$export$e5dd22bc212e7c08);
$parcel$export(module.exports, "FieldHeadingIconsVisibility", () => $b3e216f69d844fba$export$f59c6cdc64591e40);
$parcel$export(module.exports, "FieldHeadingSideBySide", () => $b3e216f69d844fba$export$5af56773efb90dc2);
$parcel$export(module.exports, "FIELD_HEADING_TITLE_COMPONENT_SELECTOR", () => $b3e216f69d844fba$export$27dd6acbb09d64a0);
$parcel$export(module.exports, "FieldHeadingTitle", () => $b3e216f69d844fba$export$947d5e0776c984dd);
$parcel$export(module.exports, "MULTILINE_FIELD_HEADING_TITLE_COMPONENT_SELECTOR", () => $b3e216f69d844fba$export$3631a5c0b71e5fa6);
$parcel$export(module.exports, "MultilineFieldHeadingTitle", () => $b3e216f69d844fba$export$7f55a99d7dec33cb);
$parcel$export(module.exports, "MultilineFieldHeading", () => $b3e216f69d844fba$export$1a4b3736f8ddb19a);
$parcel$export(module.exports, "StyledFieldHeading", () => $b3e216f69d844fba$export$12de48230c9f63a1);
$parcel$export(module.exports, "CustomFieldHeadingWithBottomMargin", () => $b3e216f69d844fba$export$1e09f33a591b411d);
$parcel$export(module.exports, "DevPanelIconContainer", () => $b3e216f69d844fba$export$1f3e3b60331a6712);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");

var $fPfMJ = parcelRequire("fPfMJ");

var $iED9L = parcelRequire("iED9L");
const $b3e216f69d844fba$export$582300267c3b9252 = 40.0; // eslint-disable-next-line @compiled/no-exported-keyframes, @atlaskit/design-system/no-exported-keyframes, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b3e216f69d844fba$export$5b770964b96200c1 = null; // eslint-disable-next-line @compiled/no-exported-keyframes, @atlaskit/design-system/no-exported-keyframes, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b3e216f69d844fba$export$a106f18d99f19ea0 = null;
const $b3e216f69d844fba$var$fieldWrapperSelectorName = 'jira-issue-field-heading-field-wrapper';
const $b3e216f69d844fba$export$760fd24410df5fa0 = `[data-component-selector="${$b3e216f69d844fba$var$fieldWrapperSelectorName}"]`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3e216f69d844fba$var$FieldWrapperComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _otyrpxbi _1nmz1hna",
            __cmplp.className
        ])
    });
});
const $b3e216f69d844fba$export$6a00f65eec6002a6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3e216f69d844fba$var$FieldWrapperComponent, {
        "data-component-selector": $b3e216f69d844fba$var$fieldWrapperSelectorName,
        ...props
    }); /**
                                                                                                                                                                                         * @deprecated `fieldHeadingIconsCss` is consumed by other styled-components (e.g. src/packages/servicedesk/post-incident-review/src/ui/primary-incident/styled.tsx )
                                                                                                                                                                                         * TODO: Remove `fieldHeadingIconsCss` once its consumers are migrated to CompiledCSS
                                                                                                                                                                                         */ 
const $b3e216f69d844fba$export$ddb92a8141f8005e = /*#__PURE__*/ (0, $kwce8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`${0, $iED9L.FieldPinButtonControl}, ${0, $fPfMJ.FieldDescriptionWrapperControl}`]: {
        animation: `${$b3e216f69d844fba$export$a106f18d99f19ea0} 0.15s linear forwards`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`:hover ${0, $iED9L.FieldPinButtonControl}, :hover ${0, $fPfMJ.FieldDescriptionWrapperControl}, :focus-within ${0, $iED9L.FieldPinButtonControl}, :focus-within ${0, $fPfMJ.FieldDescriptionWrapperControl}`]: {
        animation: `${$b3e216f69d844fba$export$5b770964b96200c1} 0.15s linear forwards`
    }
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b3e216f69d844fba$export$e5dd22bc212e7c08 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasTooltip: hasTooltip, isEditing: isEditing, fixedHeight: fixedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_o1a0pj": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            !__cmplp.isEditing && __cmplp.fixedHeight === true ? `${(0, $c9TLT.gridSize) * 4}px` : undefined)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1bsb1nrf _vchhusvi",
            __cmplp.hasTooltip ? "_1owx1p55" : "_196m1p55",
            __cmplp.className
        ])
    });
}); // APP-649 Workaround the static evaluation error with a type assertion
const $b3e216f69d844fba$var$FIELD_DESCRIPTION_WRAPPER_COMPONENT_SELECTOR_WORKAROUND = '[data-component-selector="jira-issue-field-description-field-description-wrapper"]'; // eslint-disable-next-line jira/compiled/styled-components-usages
const $b3e216f69d844fba$var$fieldHeadingMaxWidthCss = /*#__PURE__*/ (0, $kwce8.css)({
    maxWidth: '170px'
}); // FIXME: type error in object syntax
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/design-system/no-css-tagged-template-expression
const $b3e216f69d844fba$var$fieldHeadingCompactMaxWidthCss = /*#__PURE__*/ (0, $kwce8.css)`${({ isCompact: isCompact })=>isCompact ? undefined : $b3e216f69d844fba$var$fieldHeadingMaxWidthCss}`; /**
                                                          * @deprecated `fieldHeadingSideBySideCss` is consumed by other styled-components (e.g. src/packages/development/releases-glance/src/view/styled.tsx)
                                                          * TODO: Remove `fieldHeadingSideBySideCss` once its consumers are migrated to CompiledCSS
                                                          */ 
const $b3e216f69d844fba$export$39e618e716cf7ac7 = /*#__PURE__*/ (0, $kwce8.css)`${$b3e216f69d844fba$export$ddb92a8141f8005e} position:relative;flex-grow:1;box-sizing:border-box;padding-right:${"var(--ds-space-300, 24px)"};min-width:120px;width:${$b3e216f69d844fba$export$582300267c3b9252}%;padding-top:${"var(--ds-space-100, 8px)"};line-height:1;${$b3e216f69d844fba$var$fieldHeadingCompactMaxWidthCss}`; // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b3e216f69d844fba$export$f59c6cdc64591e40 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_14nx1u4f _s1t41u4f _13pa1440 _nopz1440 _1fr61440 _uqy11440",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b3e216f69d844fba$export$5af56773efb90dc2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $b3e216f69d844fba$export$f59c6cdc64591e40, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _16jlkb7n _vchhusvi _u5f31ejb _1ul968cl _1bsbhwvj _ca0qu2gc _vwz4kb7n",
            !__cmplp.isCompact && "_p12f7l9q",
            __cmplp.isMobile && __cmplp.isCompact && "_1tkezwfg _n3td1b66",
            __cmplp.className
        ])
    });
}); /*
        Unfoiling typography.h200 as @atlaskit/heading doesn't support
        extending of className prop making it complicated to apply ellipsis
        without wrapper components
    
        https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/design-system/theme/src/typography.tsx
    */ 
const $b3e216f69d844fba$var$h200Styles = null;
const $b3e216f69d844fba$var$fieldHeadingTitleSelectorName = 'jira-issue-field-heading-field-heading-title';
const $b3e216f69d844fba$export$27dd6acbb09d64a0 = `[data-component-selector="${$b3e216f69d844fba$var$fieldHeadingTitleSelectorName}"]`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3e216f69d844fba$var$FieldHeadingTitleComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1jqr _zg8l1kw7 _vwz41clk _19pkpxbi _vchhusvi _syaz1gjq _k48pbfng",
            __cmplp.className
        ])
    });
});
const $b3e216f69d844fba$export$947d5e0776c984dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3e216f69d844fba$var$FieldHeadingTitleComponent, {
        "data-component-selector": $b3e216f69d844fba$var$fieldHeadingTitleSelectorName,
        ...props
    });
const $b3e216f69d844fba$var$multilineFieldHeadingTitleSelectorName = 'jira-issue-field-heading-multiline-field-heading-title';
const $b3e216f69d844fba$export$3631a5c0b71e5fa6 = `[data-component-selector="${$b3e216f69d844fba$var$multilineFieldHeadingTitleSelectorName}"]`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $b3e216f69d844fba$var$MultilineFieldHeadingTitleComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1jqr _zg8l1kw7 _vwz41clk _k48pni7l _19pkpxbi _o5721q9c _1reo15vq _18m915vq _1bto1l2s _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $b3e216f69d844fba$export$7f55a99d7dec33cb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3e216f69d844fba$var$MultilineFieldHeadingTitleComponent, {
        "data-component-selector": $b3e216f69d844fba$var$multilineFieldHeadingTitleSelectorName,
        ...props
    }); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b3e216f69d844fba$export$1a4b3736f8ddb19a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $b3e216f69d844fba$export$f59c6cdc64591e40, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr126e _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b3e216f69d844fba$export$12de48230c9f63a1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $b3e216f69d844fba$export$5af56773efb90dc2, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_uyzq116y _bud1116y _1x8f116y _wu7yyfq0 _ievayfq0 _c1r1yfq0 _ncc4116y _omua116y _1e29116y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b3e216f69d844fba$export$a3d12639af1fe986 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $b3e216f69d844fba$export$12de48230c9f63a1, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b3e216f69d844fba$export$1e09f33a591b411d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $b3e216f69d844fba$export$12de48230c9f63a1, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b3e216f69d844fba$export$1f3e3b60331a6712 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _18u0v77o _2hwx1i6y _19pkr5cr _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $b3e216f69d844fba$export$ba0ba2df6c06b1aa = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _2hwx19bv _4t3i1crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fPfMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $160ecd2dd453f53e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FieldDescriptionWrapper", () => $160ecd2dd453f53e$export$b58fb5c82c6114d3);
$parcel$export(module.exports, "FieldDescriptionWrapperControl", () => $160ecd2dd453f53e$export$b398d6510a2a48f3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $7u4fN = parcelRequire("7u4fN");

var $3MV1G = parcelRequire("3MV1G");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cnEv5 = parcelRequire("cnEv5");

var $eN83u = parcelRequire("eN83u");

var $2TxcX = parcelRequire("2TxcX");
const $160ecd2dd453f53e$var$containerHeight = window.innerHeight < 600 ? 150 : 400; // This is visible for testing
const $160ecd2dd453f53e$export$f48224de87d33a65 = ()=>(0, $eUqFw.useState)(false);
const $160ecd2dd453f53e$export$5e28317d40301ced = /*#__PURE__*/ (0, $eUqFw.memo)(({ children: children, adfDescription: adfDescription, label: label })=>{
    const [isOpen, setIsOpen] = $160ecd2dd453f53e$export$f48224de87d33a65();
    const [autoFocus, setAutoFocus] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onHide = ()=>setIsOpen(false);
    const onShow = ()=>setIsOpen(true);
    const { setCardHoverStatus: setCardHoverStatus, setTriggerHoverStatus: setTriggerHoverStatus } = (0, $cnEv5.useCard)({
        onHide: onHide,
        onShow: onShow
    });
    const handleMouseEnter = (0, $eUqFw.useCallback)(()=>{
        setAutoFocus(false);
        setTriggerHoverStatus(true);
    }, [
        setTriggerHoverStatus
    ]);
    const handleMouseLeave = (0, $eUqFw.useCallback)(()=>{
        setTriggerHoverStatus(false);
    }, [
        setTriggerHoverStatus
    ]);
    const onMouseEnterContent = (0, $eUqFw.useCallback)(()=>{
        setAutoFocus(false);
        setCardHoverStatus(true);
    }, [
        setCardHoverStatus
    ]);
    const onMouseLeaveContent = (0, $eUqFw.useCallback)(()=>{
        setCardHoverStatus(false);
    }, [
        setCardHoverStatus
    ]);
    const handleTriggerClick = (0, $eUqFw.useCallback)(()=>{
        setTriggerHoverStatus(true);
        setAutoFocus(true);
    }, [
        setTriggerHoverStatus
    ]);
    const onPopupClose = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
        setAutoFocus(false);
    }, [
        setIsOpen
    ]);
    // FIXME: Bento should fix that by extracting the forwarded component
    const CustomPopupContainer = (0, $eUqFw.useMemo)(()=>// eslint-disable-next-line react/no-unstable-nested-components
        /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($160ecd2dd453f53e$var$PopupCustomContainer, {
                ...props,
                ref: ref,
                containerHeight: $160ecd2dd453f53e$var$containerHeight,
                onMouseEnter: onMouseEnterContent,
                onMouseLeave: onMouseLeaveContent,
                onClick: (e)=>e.stopPropagation()
            })), [
        onMouseEnterContent,
        onMouseLeaveContent
    ]); // label might be empty as FieldDescription using outside of FieldHeading as well
    const ariaLabelProps = label ? {
        'aria-label': formatMessage((0, $eN83u.default).moreInformation, {
            label: label
        })
    } : {};
    const fieldDescriptionTriggerWrapper = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...triggerProps,
            onClick: handleTriggerClick,
            spacing: "none",
            appearance: "subtle",
            isSelected: isOpen,
            "data-component-selector": $160ecd2dd453f53e$export$c63886d4ed2643d9,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            ...ariaLabelProps,
            interactionName: "auto-generated.jira-issue-field-description.ui.popup.button"
        }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        zIndex: (0, $c9TLT.layers).modal,
        autoFocus: autoFocus,
        isOpen: isOpen,
        onClose: onPopupClose,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2TxcX.default), {
                description: adfDescription
            }),
        trigger: fieldDescriptionTriggerWrapper,
        placement: "top" // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'ComponentType<PopupComponentProps> | undefined'.
        ,
        popupComponent: CustomPopupContainer,
        boundary: "clippingParents",
        shouldFlip: true,
        testId: "issue-field-description.ui.popup.ak-popup"
    });
});
var $160ecd2dd453f53e$export$2e2bcd8739ae039 = $160ecd2dd453f53e$export$5e28317d40301ced;
const $160ecd2dd453f53e$var$fieldDescriptionWrapperSelectorName = 'jira-issue-field-description-field-description-wrapper';
const $160ecd2dd453f53e$export$f2317962f4fe5a83 = `[data-component-selector="${$160ecd2dd453f53e$var$fieldDescriptionWrapperSelectorName}"]`;
const $160ecd2dd453f53e$export$c63886d4ed2643d9 = 'jira-issue-popup-description-with-button-wrapper';
const $160ecd2dd453f53e$var$POPUP_DESCRIPTION_WITH_BUTTON_WRAPPER_COMPONENT_SELECTOR = `[data-component-selector="${$160ecd2dd453f53e$export$c63886d4ed2643d9}"]`;
const $160ecd2dd453f53e$export$b58fb5c82c6114d3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($160ecd2dd453f53e$var$FieldDescriptionWrapperComponent, {
        "data-component-selector": $160ecd2dd453f53e$var$fieldDescriptionWrapperSelectorName,
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $160ecd2dd453f53e$var$PopupCustomContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { containerHeight: containerHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gzoyxy": (0, $9t7rW.default)(`${__cmplp.containerHeight}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41k9v _c71l1p8o _1reo1wug _18m91wug _bfhkhp5a _16qs1e8m",
            __cmplp.className
        ])
    });
}); /**
     * @deprecated `FieldDescriptionWrapperControl` is used as component selector in `fieldHeadingIconsCss`
     * which is consumed by other styled-components (e.g. src/packages/servicedesk/post-incident-review/src/ui/primary-incident/styled.tsx )
     * TODO: Remove `FieldDescriptionWrapperControl` once its consumers are migrated to CompiledCSS
     */ 
const $160ecd2dd453f53e$export$b398d6510a2a48f3 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1qw4w1e-0"
})({
    color: `var(--ds-background-neutral-bold, ${(0, $PdmhA.N70)})`,
    cursor: 'pointer',
    marginLeft: "var(--ds-space-050, 4px)",
    flexShrink: 0,
    '&:hover': {
        color: `var(--ds-background-neutral-bold-hovered, ${(0, $PdmhA.N500)})`
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $160ecd2dd453f53e$var$FieldDescriptionWrapperComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazwtlf _80omtlke _18u01b66 _1o9zidpf _shwtglyw _15zeglyw _1i7w13vh _1tza13vh _16u3wtlf _sxekyh40 _wvvsglyw _30l313vh",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cnEv5", function(module, exports) {

$parcel$export(module.exports, "useCard", () => $db721501b84c68df$export$5a0763f6a9ca51f0);

var $eUqFw = parcelRequire("eUqFw");
const $db721501b84c68df$export$5a0763f6a9ca51f0 = ({ onHide: onHide, onShow: onShow, hoverDuration: hoverDuration = 800 })=>{
    const hideTimeoutId = (0, $eUqFw.useRef)(null);
    const showTimeoutId = (0, $eUqFw.useRef)(null);
    const triggerHoverStatus = (0, $eUqFw.useRef)(false);
    const cardHoverStatus = (0, $eUqFw.useRef)(false);
    const executeOnHide = ()=>{
        if (hideTimeoutId.current) // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(hideTimeoutId.current);
        hideTimeoutId.current = setTimeout(()=>{
            if (!triggerHoverStatus.current && !cardHoverStatus.current) onHide();
        }, 400);
    };
    const executeOnShow = ()=>{
        if (showTimeoutId.current) // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(showTimeoutId.current);
        showTimeoutId.current = setTimeout(()=>{
            // only able to show card when trigger is hovering after 800 milliseconds
            if (triggerHoverStatus.current) onShow();
        }, hoverDuration);
    };
    const setTriggerHoverStatus = (status)=>{
        triggerHoverStatus.current = status;
        executeOnHide();
        executeOnShow();
    };
    const setCardHoverStatus = (status)=>{
        cardHoverStatus.current = status;
        executeOnHide();
        executeOnShow();
    };
    return {
        setCardHoverStatus: setCardHoverStatus,
        setTriggerHoverStatus: setTriggerHoverStatus
    };
};

});

parcelRegister("eN83u", function(module, exports) {

$parcel$export(module.exports, "default", () => $53a8ab8f4ed5ff91$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $53a8ab8f4ed5ff91$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreInformation: {
        "id": "issue-field-description.more-information",
        "defaultMessage": "More information about {label}"
    }
});

});

parcelRegister("2TxcX", function(module, exports) {

$parcel$export(module.exports, "default", () => $69e0a99c6eda3c56$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9wcjJ = parcelRequire("9wcjJ");

var $2hniO = parcelRequire("2hniO");

var $1ybV0 = parcelRequire("1ybV0");

var $9XfZZ = parcelRequire("9XfZZ");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $iAOTv = parcelRequire("iAOTv");
const $69e0a99c6eda3c56$var$Card = /*#__PURE__*/ (0, $eUqFw.memo)(({ description: description })=>{
    const onMount = (analyticsEvent)=>(0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'CustomFieldDescription mounted');
    const rendererFFProps = (0, $1ybV0.ff)('platform.linking-platform.jira-renderer-use-default-smartlinks-value') ? {
        smartLinks: (0, $9XfZZ.smartLinksDefault)
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69e0a99c6eda3c56$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: onMount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2hniO.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        document: description,
        schema: (0, $9wcjJ.defaultSchema),
        disableHeadingIDs: true,
        eventHandlers: {
            smartCard: {
                onClick: (0, $9XfZZ.onLinkClick)
            },
            link: {
                onClick: (0, $9XfZZ.onLinkClick)
            }
        },
        featureFlags: {
            codeBidiWarnings: true,
            'code-bidi-warnings': true,
            'renderer-tti-tracking': (0, $iAOTv.isRendererTtiTrackingEnabled)()
        },
        ...rendererFFProps
    }));
});
var $69e0a99c6eda3c56$export$2e2bcd8739ae039 = $69e0a99c6eda3c56$var$Card;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $69e0a99c6eda3c56$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1k99 _1bsb1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2qZHF", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $017cfdc2fc017c3b$export$2c6963927dbc68f1);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");
// eslint-disable-next-line jira/react/no-class-components
class $017cfdc2fc017c3b$var$MountEventComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $017cfdc2fc017c3b$export$2c6963927dbc68f1 = (0, $2jDha.default)()($017cfdc2fc017c3b$var$MountEventComponent);

});

parcelRegister("iAOTv", function(module, exports) {

$parcel$export(module.exports, "isRendererTtiTrackingEnabled", () => $f1af171c977f86ce$export$b236d4b6aec7c4c3);

var $1ybV0 = parcelRequire("1ybV0");
const $f1af171c977f86ce$export$b236d4b6aec7c4c3 = ()=>(0, $1ybV0.ff)('issue.details.renderer.tti-tracking', false);

});



parcelRegister("iED9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $1495bd0d468aff22$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FieldPinButtonControl", () => $1495bd0d468aff22$export$e953606ff2a0ef71);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $7u4fN = parcelRequire("7u4fN");

var $2ziLQ = parcelRequire("2ziLQ");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4Nc0z = parcelRequire("4Nc0z");

var $lTnLX = parcelRequire("lTnLX");

var $7h6vQ = parcelRequire("7h6vQ");

var $a7Tjf = parcelRequire("a7Tjf");

var $uo395 = parcelRequire("uo395");
const $1495bd0d468aff22$var$PIN_FIELD_ID = 'issue-field-pin.field-pin';
const $1495bd0d468aff22$export$45e5ae05ceb3db0b = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { isPinned: isPinned = false, onClick: onClick, hasPinnedFields: hasPinnedFields, label: label } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const newToolTipMessage = (0, $eUqFw.useMemo)(()=>{
        if (isPinned) return formatMessage((0, $a7Tjf.default).unpinField);
        if (hasPinnedFields === undefined || hasPinnedFields) // This renders typical (messages.pinField) 'Pin to top' message
        return formatMessage((0, $a7Tjf.default).pinField);
        return formatMessage((0, $a7Tjf.default).firstPinnedField);
    }, [
        formatMessage,
        hasPinnedFields,
        isPinned
    ]);
    const oldTooltipMessage = isPinned ? formatMessage((0, $a7Tjf.default).unpinField) : formatMessage((0, $a7Tjf.default).pinField);
    const tooltipMessage = (0, $7h6vQ.isSortingPinnedFieldsEnabled)() ? newToolTipMessage : oldTooltipMessage;
    const icon = isPinned ? (0, $4Nc0z.default) : (0, $lTnLX.default);
    const IconWrapper = isPinned ? $1495bd0d468aff22$export$413ba3c829ad4fb0 : $1495bd0d468aff22$var$UnpinnedIconWrapper;
    const ariaLabel = label ? `${label} ${tooltipMessage}` : tooltipMessage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1495bd0d468aff22$var$FieldPinButton, {
        "data-testid": $1495bd0d468aff22$var$PIN_FIELD_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1495bd0d468aff22$var$FieldPinWithButtonWrapper, {
        onClick: onClick,
        "aria-pressed": isPinned,
        "aria-label": ariaLabel,
        iconBefore: // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IconWrapper, {
            className: "issue-details-pin-icon-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
            glyph: icon
        }))
    })));
});
$1495bd0d468aff22$export$45e5ae05ceb3db0b.displayName = 'FieldPin';
var $1495bd0d468aff22$export$2e2bcd8739ae039 = $1495bd0d468aff22$export$45e5ae05ceb3db0b;
const $1495bd0d468aff22$var$FieldPinWithButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "data-component-selector": (0, $uo395.fieldPinWithButtonSelectorName),
        spacing: "none",
        testId: "issue-field-pin.button",
        appearance: "subtle",
        ...props,
        interactionName: "auto-generated.issue-field-pin.button.button"
    });
const $1495bd0d468aff22$var$FieldPinButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1495bd0d468aff22$var$FieldPinButtonComponent, {
        "data-component-selector": (0, $uo395.fieldPinButtonSelectorName),
        ...props
    });
const $1495bd0d468aff22$export$413ba3c829ad4fb0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1495bd0d468aff22$var$PinnedIconWrapperComponent, {
        "data-component-selector": (0, $uo395.fieldPinButtonSelectorName),
        ...props
    });
const $1495bd0d468aff22$var$UnpinnedIconWrapper = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1495bd0d468aff22$var$UnpinnedIconWrapperComponent, {
        "data-component-selector": (0, $uo395.unpinnedIconWrapperSelectorName),
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1495bd0d468aff22$var$FieldPinWithButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $1495bd0d468aff22$var$FieldPinWithButton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q7glyw _27a8mijp _f032hwed _1du2glyw _19lcglyw",
            __cmplp.className
        ])
    });
}); /**
     * @deprecated `FieldPinButtonControl` is used as component selector in `fieldHeadingIconsCss`
     * which is consumed by other styled-components (e.g. src/packages/servicedesk/post-incident-review/src/ui/primary-incident/styled.tsx )
     * TODO: Remove `FieldPinButtonControl` once its consumers are migrated to CompiledCSS
     */ 
const $1495bd0d468aff22$export$e953606ff2a0ef71 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1771isq-0"
})`cursor:pointer;margin-left:${"var(--ds-space-050, 4px)"};flex-shrink:0;${(0, $uo395.PIN_BUTTON_WRAPPER_COMPONENT_SELECTOR)}:{':focus, :hover':{background:'none';}':focus ${(0, $uo395.FIELD_PIN_BUTTON_COMPONENT_SELECTOR)}':{color:${`var(--ds-icon-accent-yellow, ${(0, $PdmhA).Y200})`};}':focus ${(0, $uo395.UNPINNED_ICON_WRAPPER_COMPONENT_SELECTOR)}':{color:${`var(--ds-icon, ${(0, $PdmhA).N800})`};},background:'none';}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1495bd0d468aff22$var$FieldPinButtonComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80omtlke _18u01b66 _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1495bd0d468aff22$var$PinnedIconWrapperComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1a22 _30l3mijp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1495bd0d468aff22$var$UnpinnedIconWrapperComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazadx1 _30l3hwed",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

});
parcelRegister("4Nc0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $02850badb93007af$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $02850badb93007af$var$PinFilled = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "issue-field-pin-assets.pin-filled",
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "currentColor",
        d: "M5.48121736,7.00404408 L7.59617451,4.89248498 C7.83826329,4.65078605 7.83826329,4.2589269 7.59617451,4.01722797 L7.45004745,3.8713518 C7.28862892,3.71022438 7.28862892,3.44898234 7.45004745,3.28784713 L8.61890792,2.12084557 C8.78032645,1.95971814 9.04199766,1.95971814 9.20333816,2.12084557 L13.8789361,6.78886738 C14.0403546,6.94999481 14.0403546,7.21123684 13.8789361,7.37239542 L12.7100756,8.53937361 C12.5486571,8.70053219 12.2869859,8.70053219 12.1255674,8.53937361 L11.9795183,8.39348187 C11.7374295,8.15178294 11.3449227,8.15178294 11.102834,8.39348187 L8.9878534,10.5050565 C8.74576463,10.7467555 8.74576463,11.1385523 8.9878534,11.3802512 L9.57236166,11.9638182 C9.73370217,12.1248989 9.73370217,12.3861487 9.57236166,12.5473073 L8.40342317,13.7142855 C8.24208266,13.8754441 7.98041145,13.8754441 7.81899293,13.7142855 L5.48655377,11.3856258 L2.99050379,13.8776251 C2.91356278,13.9544266 2.8093702,13.9978903 2.70055118,13.9985135 L2.42647516,14 C2.20319644,14.0012397 2.01932444,13.8251258 2.0112106,13.6023547 L2.00027253,13.3019252 C1.99610639,13.187346 2.03985869,13.076272 2.12104386,12.9951864 L4.60989281,10.5103532 L2.26677303,8.17102227 C2.10538571,8.00986368 2.10538571,7.74861386 2.26677303,7.58753317 L3.43565691,6.42050825 C3.59705203,6.25938082 3.85871544,6.25938082 4.02010275,6.42050825 L4.6045486,7.00404408 C4.84663737,7.245743 5.23912858,7.245743 5.48121736,7.00404408 Z"
    }));
var $02850badb93007af$export$2e2bcd8739ae039 = $02850badb93007af$var$PinFilled;

});

parcelRegister("lTnLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $003cb4078621360c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $003cb4078621360c$export$98e16bcd4c84a74d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "issue-field-pin-assets.pin-unfilled",
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "currentColor",
        d: "M3.58176938,7.87928392 L8.11122851,12.4014141 L8.25734637,12.2555315 L8.18428744,12.1825901 C7.49835823,11.4978426 7.49835823,10.387565 8.18428744,9.70273982 L10.299184,7.5911928 C10.8579797,7.03331193 11.6995968,6.9299201 12.363196,7.28100178 L12.563933,7.08062671 L8.9111421,3.43373045 L8.71048291,3.63410553 C9.06208387,4.29665994 8.95852537,5.13692246 8.39972959,5.6948111 L6.28483307,7.80634258 C5.59890386,8.4911678 4.48684425,8.4911678 3.80093838,7.80634258 L3.72787945,7.73340123 L3.58176938,7.87928392 Z M5.48118484,7.00402665 L7.59615917,4.8924874 C7.83821064,4.65079444 7.83821064,4.25893086 7.59615917,4.01723789 L7.45004131,3.87135521 C7.28867366,3.71023174 7.28867366,3.44898677 7.45004131,3.28785554 L8.61890638,2.12084842 C8.78035183,1.95971719 9.04201017,1.95971719 9.20337782,2.12084842 L13.8789159,6.78887687 C14.0403614,6.9500081 14.0403614,7.21125308 13.8789159,7.37238431 L12.7100508,8.53940696 C12.5486832,8.70051489 12.2870249,8.70051489 12.1255794,8.53940696 L11.9794615,8.39352427 C11.7374101,8.1517847 11.3448837,8.1517847 11.1028322,8.39352427 L8.98785786,10.5050169 C8.74580639,10.7467565 8.74580639,11.1385735 8.98785786,11.380313 L9.5723293,11.9638438 C9.73369695,12.1249517 9.73369695,12.3861889 9.5723293,12.5472968 L8.40346423,13.7143583 C8.24201878,13.8754662 7.98036044,13.8754662 7.81899279,13.7143583 L5.48655339,11.3856729 L2.99050556,13.8776413 C2.91355638,13.9544666 2.80936765,13.9978896 2.70054953,13.9985111 L2.4264735,14 C2.20319639,14.0012299 2.01931974,13.8252074 2.01121246,13.6024217 L2.00027307,13.3019562 C1.99610272,13.1873785 2.03985249,13.0762963 2.12104205,12.9951986 L4.60988514,10.5103768 L2.26677088,8.17104929 C2.10537989,8.00994136 2.10537989,7.74862648 2.26677088,7.58752632 L3.4356593,6.42051921 C3.59705028,6.25938797 3.85870862,6.25938797 4.02009961,6.42051921 L4.60454771,7.00402665 C4.8466303,7.24571961 5.23912559,7.24571961 5.48118484,7.00402665 Z"
    }));
var $003cb4078621360c$export$2e2bcd8739ae039 = $003cb4078621360c$export$98e16bcd4c84a74d;

});

parcelRegister("a7Tjf", function(module, exports) {

$parcel$export(module.exports, "default", () => $4acb2ca1fa5cdcb4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4acb2ca1fa5cdcb4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    pinField: {
        "id": "issue-field-pin.pin-field",
        "defaultMessage": "Pin to top"
    },
    firstPinnedField: {
        "id": "issue-field-pin.first-pinned-field",
        "defaultMessage": "Pin to top. Only you can see pinned fields."
    },
    unpinField: {
        "id": "issue-field-pin.unpin-field",
        "defaultMessage": "Unpin"
    },
    fieldPinned: {
        "id": "issue-field-pin.field-pinned",
        "defaultMessage": "{fieldLabel} pinned to top."
    },
    errorTooManyPinnedTitle: {
        "id": "issue-field-pin.error-too-many-pinned-title",
        "defaultMessage": "Too many pinned fields"
    },
    // TODO: When cleaning up isSortingPinnedFieldsEnabled remove errorTooManyPinnedText
    errorTooManyPinnedText: {
        "id": "issue-field-pin.error-too-many-pinned-text",
        "defaultMessage": "You've reached the maximum number of fields you can pin in this project. Please unpin a field first, to pin this field to the top"
    },
    errorTooManyPinnedDescription: {
        "id": "issue-field-pin.error-too-many-pinned-description",
        "defaultMessage": "You've reached the maximum number of fields for this project. If you'd like to pin a new field, you'll need to unpin another."
    }
});

});





parcelRegister("f1Nss", function(module, exports) {

$parcel$export(module.exports, "default", () => $a85ec678abdaf3fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3RoDL = parcelRequire("3RoDL");

var $b8mID = parcelRequire("b8mID");

var $eYjMq = parcelRequire("eYjMq");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a85ec678abdaf3fd$export$2e2bcd8739ae039 = ({ isValid: isValid, value: value, onChange: onChange, onBlur: onBlur, isDisabled: isDisabled })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3RoDL.default), {
        isValid: isValid
    }, (shouldAppearInvalid)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b8mID.default), {
            value: value,
            isInvalid: shouldAppearInvalid,
            invalidMessage: formatMessage((0, $eYjMq.default).timeInvalidMessage),
            onChange: onChange,
            onBlur: onBlur,
            isDisabled: isDisabled,
            label: formatMessage((0, $eYjMq.default).timeRemaining),
            triggerBtnAriaLabel: formatMessage((0, $eYjMq.default).timeRemainingTriggerBtnLabel),
            name: (0, $eYjMq.default).timeRemaining.id,
            description: formatMessage((0, $eYjMq.default).timeRemainingInfo)
        }));
};

});

parcelRegister("cYqJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b78ed49dafdbe0f4$export$2e2bcd8739ae039);

var $5IYaC = parcelRequire("5IYaC");
var $b78ed49dafdbe0f4$export$2e2bcd8739ae039 = (0, $5IYaC.default);

});
parcelRegister("5IYaC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5261d926dcee1f09$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJjah = parcelRequire("hJjah");
const $5261d926dcee1f09$var$TimeTrackingHelperText = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5261d926dcee1f09$var$HelperContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $hJjah.default).exampleFormat, {
        formatExample: '2w 4d 6h 45m'
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5261d926dcee1f09$var$HelperList, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, formatMessage((0, $hJjah.default).weeks, {
        w: 'w'
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, formatMessage((0, $hJjah.default).days, {
        d: 'd'
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, formatMessage((0, $hJjah.default).hours, {
        h: 'h'
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, formatMessage((0, $hJjah.default).minutes, {
        m: 'm'
    }))));
};
var $5261d926dcee1f09$export$2e2bcd8739ae039 = $5261d926dcee1f09$var$TimeTrackingHelperText;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5261d926dcee1f09$var$HelperContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4xtwq _syaz76s1",
            __cmplp.className
        ])
    });
});
const $5261d926dcee1f09$var$HelperList = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_qtt81vji _19pku2gc _19bv1b66 _n3td1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hJjah", function(module, exports) {

$parcel$export(module.exports, "default", () => $84b8e545d633b5ca$export$2e2bcd8739ae039);
$parcel$export(module.exports, "timeInvalidMessage", () => $84b8e545d633b5ca$export$df20cd1a746dd7ec);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");
var $84b8e545d633b5ca$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    logWork: {
        "id": "issue-view-common.messages.time.log-work",
        "defaultMessage": "Log work"
    },
    timeInputPlaceholder: {
        "id": "issue-view-common.messages.time.time-input-placeholder",
        "defaultMessage": "e.g. 2w 4d 6h 45m"
    },
    exampleFormat: {
        "id": "issue-view-common.messages.time.example-format",
        "defaultMessage": "Use the format: {formatExample}"
    },
    weeks: {
        "id": "issue-view-common.messages.time.weeks",
        "defaultMessage": "{w} = weeks"
    },
    days: {
        "id": "issue-view-common.messages.time.days",
        "defaultMessage": "{d} = days"
    },
    hours: {
        "id": "issue-view-common.messages.time.hours",
        "defaultMessage": "{h} = hours"
    },
    minutes: {
        "id": "issue-view-common.messages.time.minutes",
        "defaultMessage": "{m} = minutes"
    }
});
const $84b8e545d633b5ca$export$df20cd1a746dd7ec = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
    id: "issue.common.messages.time.time-invalid-message",
    defaultMessage: "You need to log time in the format {timeString}.",
    values: {
        timeString: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, "2w 4d 6h 45m")
    }
});

});





parcelRegister("k8sYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $617c801fbc28d6f1$export$2e2bcd8739ae039);

var $jwm02 = parcelRequire("jwm02");
var $617c801fbc28d6f1$export$2e2bcd8739ae039 = (0, $jwm02.default);

});
parcelRegister("jwm02", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b3e9537def21d72$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $h9cCP = parcelRequire("h9cCP");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $k8NVh = parcelRequire("k8NVh");

var $7v0hO = parcelRequire("7v0hO");

var $8Islw = parcelRequire("8Islw");

var $bRjfP = parcelRequire("bRjfP");
const $4b3e9537def21d72$var$location = 'roll-up-time-tracking-toggle-from-dialog';
const $4b3e9537def21d72$var$actionSubjectId = 'toggleRollUpDataControlFromWorklogDialog'; // eslint-disable-next-line jira/import/no-anonymous-default-export
var $4b3e9537def21d72$export$2e2bcd8739ae039 = (props)=>{
    const { config: config, value: value, isDone: isDone, estimatedTime: estimatedTime, shouldDisplayRollUpDataControl: shouldDisplayRollUpDataControl, isRollingUpData: isRollingUpData, onToggleRollingUpData: onToggleRollingUpData, isClassicProject: isClassicProject } = props;
    const intl = (0, $5JgJ2.default)();
    const renderEstimatedTime = (0, $eUqFw.useCallback)((time)=>{
        const formattedEstimatedTime = (0, $7v0hO.timeTrackingFormatter)(time, {
            workingHoursPerDay: config.hoursPerDay,
            workingDaysPerWeek: config.daysPerWeek,
            timeFormat: config.format || (0, $h9cCP.PRETTY),
            defaultUnit: config.defaultUnit
        }, intl);
        const RolledUpEstimatesMessage = isClassicProject ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                id: "issue.log-time.modal.original-estimate.with-rollup-subtasks",
                defaultMessage: "The original estimate for this issue and subtasks was {time}.",
                values: {
                    time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8NVh.OriginalEstimateView), {
                        value: formattedEstimatedTime
                    })
                }
            }) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                id: "issue.log-time.modal.original-estimate.with-rollup-child-issues",
                defaultMessage: "The original estimate for this issue and child issues was {time}.",
                values: {
                    time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8NVh.OriginalEstimateView), {
                        value: formattedEstimatedTime
                    })
                }
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4b3e9537def21d72$var$StyledParagraph, null, isRollingUpData && shouldDisplayRollUpDataControl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(RolledUpEstimatesMessage, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            id: "issue.log-time.modal.original-estimate",
            defaultMessage: "The original estimate for this issue was {time}.",
            values: {
                time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8NVh.OriginalEstimateView), {
                    value: formattedEstimatedTime
                })
            }
        }));
    }, [
        config,
        intl,
        isClassicProject,
        isRollingUpData,
        shouldDisplayRollUpDataControl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Islw.default), {
        config: config,
        value: value,
        estimatedTime: estimatedTime,
        isDone: isDone,
        isCompact: false,
        isEditable: false
    }), shouldDisplayRollUpDataControl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4b3e9537def21d72$var$RollUpEstimatesWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bRjfP.RollupCheckbox), {
        isRollingUpData: isRollingUpData,
        location: $4b3e9537def21d72$var$location,
        actionSubjectId: $4b3e9537def21d72$var$actionSubjectId,
        onToggleRollingUpData: onToggleRollingUpData
    })), typeof estimatedTime === 'number' ? renderEstimatedTime(estimatedTime) : null);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4b3e9537def21d72$var$StyledParagraph = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4b3e9537def21d72$var$RollUpEstimatesWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0r5cr _ca0qu2gc _o5e61rr7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k8NVh", function(module, exports) {

$parcel$export(module.exports, "OriginalEstimateView", () => $e0db95fc6ac9eb73$export$3f2e1017102540ba);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $9nkwJ = parcelRequire("9nkwJ");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");

var $9JAdq = parcelRequire("9JAdq");
const $e0db95fc6ac9eb73$export$3f2e1017102540ba = ({ testId: testId = (0, $9JAdq.originalEstimateViewTestId), isEditable: isEditable = false, value: value })=>{
    const badge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        testId: `${testId}.badge`
    }, value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e0db95fc6ac9eb73$var$BadgeWrapper, {
        "data-testid": testId,
        "data-component-selector": (0, $9JAdq.READ_VIEW_CONTAINER_SELECTOR_NAME)
    }, isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e0db95fc6ac9eb73$var$HoverContainer, {
        "data-testid": `${testId}.hover-container`,
        "data-component-selector": (0, $9JAdq.HOVER_CONTAINER_SELECTOR_NAME)
    }, badge) : badge);
};
var $e0db95fc6ac9eb73$export$2e2bcd8739ae039 = $e0db95fc6ac9eb73$export$3f2e1017102540ba;
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e0db95fc6ac9eb73$var$HoverContainer = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "fwt3uo-0"
})({
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&:hover > span': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `${`var(--ds-text, ${(0, $PdmhA).N800})`} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `${`var(--ds-background-neutral-hovered, ${(0, $PdmhA).N90})`} !important`
    }
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
()=>// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $kwce8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: `${(0, $c9TLT.gridSize) * 2.5}px`
    }));
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e0db95fc6ac9eb73$var$BadgeWrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "fwt3uo-1"
})`display:inline-block;vertical-align:${()=>(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? 'top' // not perfectly vertically centered without this
     : undefined};position:relative;margin-top:${"var(--ds-space-negative-075, -6px)"};margin-bottom:${"var(--ds-space-negative-075, -6px)"};margin-right:${()=>(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? '-2px' : "var(--ds-space-negative-025, -2px)"};margin-left:${()=>(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? '2px' : "var(--ds-space-025, 2px)"};`;

});
parcelRegister("9nkwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d99ab26ca06411$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $aG4Mw = parcelRequire("aG4Mw");
const $00d99ab26ca06411$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content'
});
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $00d99ab26ca06411$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: testId,
        as: "span",
        backgroundColor: $00d99ab26ca06411$var$backgroundColors[appearance],
        xcss: $00d99ab26ca06411$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $00d99ab26ca06411$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
});
$00d99ab26ca06411$var$Badge.displayName = 'Badge';
var $00d99ab26ca06411$export$2e2bcd8739ae039 = $00d99ab26ca06411$var$Badge;
const $00d99ab26ca06411$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $00d99ab26ca06411$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("aG4Mw", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $a8e5bba3d913fce3$export$7c4d25c0c3217d8c);
function $a8e5bba3d913fce3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a8e5bba3d913fce3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $a8e5bba3d913fce3$var$getSafeValue(value);
    const safeMax = $a8e5bba3d913fce3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("9JAdq", function(module, exports) {

$parcel$export(module.exports, "originalEstimateBodyParams", () => $4291bf329eb7bdb7$export$25ca12ed4532196);
$parcel$export(module.exports, "originalEstimateEditTestId", () => $4291bf329eb7bdb7$export$85273aacc194bf89);
$parcel$export(module.exports, "originalEstimateViewTestId", () => $4291bf329eb7bdb7$export$97847a81d7704a9e);
$parcel$export(module.exports, "READ_VIEW_CONTAINER_SELECTOR_NAME", () => $4291bf329eb7bdb7$export$916dec1cd99a42a1);
$parcel$export(module.exports, "READ_VIEW_CONTAINER_SELECTOR", () => $4291bf329eb7bdb7$export$5c18970ef161f5b6);
$parcel$export(module.exports, "HOVER_CONTAINER_SELECTOR_NAME", () => $4291bf329eb7bdb7$export$c43a88184f234cd2);
$parcel$export(module.exports, "HOVER_CONTAINER_SELECTOR", () => $4291bf329eb7bdb7$export$366394ad8172710b);
// used to verify mock is originalEstimate
const $4291bf329eb7bdb7$export$25ca12ed4532196 = {
    fieldsToForcePresent: 'timetracking'
};
const $4291bf329eb7bdb7$export$85273aacc194bf89 = 'issue-field-original-estimate.ui.edit';
const $4291bf329eb7bdb7$export$97847a81d7704a9e = 'issue-field-original-estimate.ui.view';
const $4291bf329eb7bdb7$export$916dec1cd99a42a1 = 'jira-issue-field-inline-edit-read-view-container';
const $4291bf329eb7bdb7$export$5c18970ef161f5b6 = `[data-component-selector="${$4291bf329eb7bdb7$export$916dec1cd99a42a1}"]`;
const $4291bf329eb7bdb7$export$c43a88184f234cd2 = 'jira-issue-field-original-estimate-hover-container';
const $4291bf329eb7bdb7$export$366394ad8172710b = `[data-component-selector="${$4291bf329eb7bdb7$export$c43a88184f234cd2}"]`;

});


parcelRegister("8Islw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c1ac5dd584a36a2$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $h9cCP = parcelRequire("h9cCP");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $7v0hO = parcelRequire("7v0hO");

var $8mSXg = parcelRequire("8mSXg");
const $4c1ac5dd584a36a2$var$LoggedTime = ({ isCompact: isCompact = true, isDone: isDone = false, isEditable: isEditable, value: value, config: config, estimatedTime: estimatedTime })=>{
    const intl = (0, $5JgJ2.default)();
    const secondsToTimeString = (0, $eUqFw.useCallback)((seconds)=>(0, $7v0hO.timeTrackingFormatter)(seconds, {
            workingHoursPerDay: config.hoursPerDay,
            workingDaysPerWeek: config.daysPerWeek,
            timeFormat: config.format || (0, $h9cCP.PRETTY),
            defaultUnit: config.defaultUnit
        }, intl), [
        config.daysPerWeek,
        config.defaultUnit,
        config.format,
        config.hoursPerDay,
        intl
    ]);
    const timeLoggedText = (0, $eUqFw.useMemo)(()=>{
        if (value && value.loggedTime) {
            const loggedTimeText = secondsToTimeString(value.loggedTime);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                id: "issue.log-time.time-logged",
                defaultMessage: "{time} logged",
                values: {
                    time: // eslint-disable-next-line jira/integration/test-id-by-folder-structure
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c1ac5dd584a36a2$var$HoursLogged, {
                        "data-testid": "issue.issue-view.common.logged-time.value"
                    }, loggedTimeText)
                }
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            id: "issue.log-time.no-time-logged",
            defaultMessage: "No time logged"
        });
    }, [
        secondsToTimeString,
        value
    ]);
    const timeRemainingText = (0, $eUqFw.useMemo)(()=>{
        if (!value.remainingTime) return null;
        const timeRemaining = secondsToTimeString(value.remainingTime);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c1ac5dd584a36a2$var$RemainingText, {
            "data-testid": "issue.component.logged-time.remaining-time"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            id: "issue.log-time.remaining-time",
            defaultMessage: "{time} remaining",
            values: {
                time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c1ac5dd584a36a2$var$HoursLogged, null, timeRemaining)
            }
        }));
    }, [
        secondsToTimeString,
        value.remainingTime
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c1ac5dd584a36a2$var$LoggedTimeContainer, {
        isEditable: isEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c1ac5dd584a36a2$var$Main, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8mSXg.default), {
        value: value,
        estimatedTime: estimatedTime,
        config: config,
        isDone: isDone,
        isCompact: isCompact
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c1ac5dd584a36a2$var$TextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c1ac5dd584a36a2$var$TimeLoggedTextContainer, null, timeLoggedText), timeRemainingText)));
};
var $4c1ac5dd584a36a2$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
 = $4c1ac5dd584a36a2$var$LoggedTime;
const $4c1ac5dd584a36a2$var$LoggedTimeContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isEditable ? "_ca0qidpf _n3tdidpf _19bv12x7 _u5f3idpf _2hwx1i6y _1tke1tcg" : "_19pkr5cr _otyrr5cr _18u01i6y _2hwxu2gc _1mdjidpf _1t1kidpf _tjz9idpf _j894idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c1ac5dd584a36a2$var$Main = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _19pk1b66 _2hwxv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c1ac5dd584a36a2$var$TextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz131l _1e0c1txw _1bah1yb4 _19pkidpf _1wybdlk8 _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c1ac5dd584a36a2$var$TimeLoggedTextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c1ac5dd584a36a2$var$RemainingText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c1ac5dd584a36a2$var$HoursLogged = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p4jg8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8mSXg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d0cf411e3432b00$export$2e2bcd8739ae039);

var $bRafp = parcelRequire("bRafp");
var $7d0cf411e3432b00$export$2e2bcd8739ae039 = (0, $bRafp.ProgressTracker);

});
parcelRegister("bRafp", function(module, exports) {

$parcel$export(module.exports, "ProgressTracker", () => $4e2832422e0e0dcf$export$50a55323bc54fb79);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $h9cCP = parcelRequire("h9cCP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7v0hO = parcelRequire("7v0hO");

var $hQbY3 = parcelRequire("hQbY3");

var $hhj6b = parcelRequire("hhj6b");
var $WctLp = parcelRequire("WctLp");
const $4e2832422e0e0dcf$export$eac9490fca3c36ec = (value, estimatedTime = 0)=>{
    const { loggedTime: loggedTime = 0, remainingTime: remainingTime = 0 } = value;
    return Math.max(estimatedTime, loggedTime + remainingTime);
};
const $4e2832422e0e0dcf$export$703e6cfc3429a8a5 = (value, estimatedTime)=>{
    const { loggedTime: loggedTime, remainingTime: remainingTime } = value;
    // If there is no logged time, then we do not want to show the progress bar.
    // If we have no estimated time, then we can't calculate the value.
    if (!loggedTime || estimatedTime === undefined) return 0;
    return loggedTime + (remainingTime || 0) - estimatedTime;
};
const $4e2832422e0e0dcf$export$50a55323bc54fb79 = ({ isCompact: isCompact = true, isDone: isDone = false, shouldHighlightOnHover: shouldHighlightOnHover = false, value: value = {
    loggedTime: 0
}, config: config, estimatedTime: estimatedTime })=>{
    const intl = (0, $5JgJ2.default)();
    const secondsToTimeString = (0, $eUqFw.useCallback)((seconds)=>(0, $7v0hO.timeTrackingFormatter)(seconds, {
            workingHoursPerDay: config.hoursPerDay,
            workingDaysPerWeek: config.daysPerWeek,
            timeFormat: config.format || (0, $h9cCP.PRETTY),
            defaultUnit: config.defaultUnit
        }, intl), [
        config.daysPerWeek,
        config.defaultUnit,
        config.format,
        config.hoursPerDay,
        intl
    ]);
    const toolTip = (0, $eUqFw.useMemo)(()=>{
        const timeOverOriginalEstimate = $4e2832422e0e0dcf$export$703e6cfc3429a8a5(value, estimatedTime);
        if (timeOverOriginalEstimate === 0) return null;
        return timeOverOriginalEstimate > 0 ? intl.formatMessage((0, $hQbY3.default).overOriginalEstimate, {
            time: secondsToTimeString(timeOverOriginalEstimate)
        }) : intl.formatMessage((0, $hQbY3.default).underOriginalEstimate, {
            time: secondsToTimeString(-timeOverOriginalEstimate)
        });
    }, [
        estimatedTime,
        intl,
        secondsToTimeString,
        value
    ]);
    const { loggedTime: loggedTime = 0 } = value;
    const totalTime = $4e2832422e0e0dcf$export$eac9490fca3c36ec(value, estimatedTime);
    const timeOver = Math.max($4e2832422e0e0dcf$export$703e6cfc3429a8a5(value, estimatedTime), 0);
    const proportionCompleted = totalTime ? (loggedTime - timeOver) / totalTime : 0;
    const proportionRemain = totalTime && totalTime - loggedTime > 0 ? (totalTime - loggedTime) / totalTime : 0;
    const proportionOver = totalTime ? timeOver / totalTime : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hhj6b.default), {
        tooltip: toolTip,
        isCompact: isCompact,
        shouldHighlightOnHover: shouldHighlightOnHover
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $WctLp.default), {
        color: isDone ? `var(--ds-border-success, ${(0, $PdmhA).G300})` : `var(--ds-border-information, ${(0, $PdmhA).B200})`,
        proportion: proportionCompleted
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $WctLp.default), {
        color: `var(--ds-border-warning, ${(0, $PdmhA).Y300})`,
        proportion: proportionOver
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $WctLp.default), {
        color: `var(--ds-border, ${(0, $PdmhA).N30})`,
        proportion: proportionRemain
    }));
};

});
parcelRegister("hQbY3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc9e5d9c4df39f37$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $bc9e5d9c4df39f37$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    underOriginalEstimate: {
        "id": "issue.log-time.under-original-estimated-time-tooltip",
        "defaultMessage": "{time} under original estimate"
    },
    overOriginalEstimate: {
        "id": "issue.log-time.over-original-estimated-time-tooltip",
        "defaultMessage": "{time} over original estimate"
    }
});

});

parcelRegister("hhj6b", function(module, exports) {

$parcel$export(module.exports, "default", () => $c272d32f4e4ef6cb$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");

const $c272d32f4e4ef6cb$var$ProgressBarInner = ({ shouldHighlightOnHover: shouldHighlightOnHover, tooltip: tooltip, isCompact: isCompact = true, children: children })=>shouldHighlightOnHover ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c272d32f4e4ef6cb$var$ProgressBarContainerHover, {
        "data-testid": "issue.component.progress-tracker.progress-bar.progress-bar-container-hover",
        hasPointerCursor: !!tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c272d32f4e4ef6cb$var$ProgressBarContainer, {
        isCompact: isCompact,
        hasPointerCursor: !!tooltip
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c272d32f4e4ef6cb$var$ProgressBarContainer, {
        "data-testid": "issue.component.progress-tracker.progress-bar.progress-bar-container",
        isCompact: isCompact,
        hasPointerCursor: !!tooltip
    }, children);
const $c272d32f4e4ef6cb$var$ProgressBar = (props)=>!props.tooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c272d32f4e4ef6cb$var$ProgressBarInner, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        testId: "issue.component.progress-tracker.progress-bar.tooltip",
        content: props.tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c272d32f4e4ef6cb$var$ProgressBarInner, props));
var $c272d32f4e4ef6cb$export$2e2bcd8739ae039 = $c272d32f4e4ef6cb$var$ProgressBar;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c272d32f4e4ef6cb$var$ProgressBarContainerHover = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasPointerCursor: hasPointerCursor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41b66 _bfhk18uv _2rko1l7b _irr3zk5k",
            __cmplp.hasPointerCursor && "_80omtlke",
            __cmplp.className
        ])
    });
});
const $c272d32f4e4ef6cb$var$ProgressBarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompact: isCompact, hasPointerCursor: hasPointerCursor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1y44 _1e0c1txw _1reo15vq _18m915vq _1bsb1osq _1tkens44",
            __cmplp.isCompact ? "_4t3i1y44" : "_4t3iftgi",
            __cmplp.hasPointerCursor && "_80omtlke",
            __cmplp.className
        ])
    });
});

});

parcelRegister("WctLp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd16373bc8d33a5$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $PdmhA = parcelRequire("PdmhA");
const $9fd16373bc8d33a5$var$ProgressBarSegment = ({ color: color = `var(--ds-border-brand, ${(0, $PdmhA).B400})`, proportion: proportion = 0 })=>{
    const width = proportion > 0 ? `${proportion * 100}%` : '0';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9fd16373bc8d33a5$var$Segment, {
        "data-testid": "issue.component.progress-tracker.progress-bar.progress-bar-segment",
        color: color,
        width: width
    });
};
var $9fd16373bc8d33a5$export$2e2bcd8739ae039 = $9fd16373bc8d33a5$var$ProgressBarSegment;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9fd16373bc8d33a5$var$Segment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color),
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1cj8 _1o9zidpf _1bsb1rkg _v5641qcf _zk5aidpf _wsviv77o _1xoqidpf",
            __cmplp.className
        ])
    });
});

});




parcelRegister("bRjfP", function(module, exports) {

$parcel$export(module.exports, "RollupCheckbox", () => $384535006fa83738$export$7cb70edfc6477b7c);

var $7wWZj = parcelRequire("7wWZj");
const $384535006fa83738$export$7cb70edfc6477b7c = (0, $7wWZj.RollupCheckbox);

});
parcelRegister("7wWZj", function(module, exports) {

$parcel$export(module.exports, "RollupCheckbox", () => $70ab50d9bd44729d$export$7cb70edfc6477b7c);

var $eUqFw = parcelRequire("eUqFw");

var $bT7k5 = parcelRequire("bT7k5");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $c0wh4 = parcelRequire("c0wh4");

var $d6f6c = parcelRequire("d6f6c");

var $guDlK = parcelRequire("guDlK");

var $hxhMT = parcelRequire("hxhMT");
const $70ab50d9bd44729d$export$f528fadbfdb3c25e = 'subtasks';
const $70ab50d9bd44729d$export$4d6602982ff46bb0 = 'child issues';
const $70ab50d9bd44729d$export$7cb70edfc6477b7c = ({ isRollingUpData: isRollingUpData, onToggleRollingUpData: onToggleRollingUpData, location: location, actionSubjectId: actionSubjectId })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const isClassicProject = (0, $guDlK.useIsClassicProject)(projectKey);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const childIssuesPanelType = isClassicProject ? $70ab50d9bd44729d$export$f528fadbfdb3c25e : $70ab50d9bd44729d$export$4d6602982ff46bb0;
    const hasExceededChildIssuesLimitOnLoadOrAfter = (0, $c0wh4.useHasExceededChildIssuesLimitAnyPanelOnOrAfterLoad)();
    const childIssuesLimit = (0, $hJ992.useChildIssuesLimit)();
    const checkbox = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: hasExceededChildIssuesLimitOnLoadOrAfter ? false : isRollingUpData,
        onChange: ({ target: { checked: checked } }, analyticsEvent)=>{
            onToggleRollingUpData(checked, analyticsEvent);
        },
        label: formatMessage((0, $hxhMT.default).includeChildIssueLabel, {
            childIssuesPanelType: childIssuesPanelType
        }),
        name: location,
        isDisabled: hasExceededChildIssuesLimitOnLoadOrAfter
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, hasExceededChildIssuesLimitOnLoadOrAfter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $hxhMT.default).timetrackingRollupDisabledTooltipLabelWithLimit, {
            childIssuesPanelType: childIssuesPanelType,
            limit: childIssuesLimit
        }),
        position: "top"
    }, checkbox) : checkbox, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
        action: "exposed",
        actionSubject: "feature",
        actionSubjectId: actionSubjectId
    }));
};

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**  @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");

var $PdmhA = parcelRequire("PdmhA");

var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: undefined,
        packageVersion: undefined
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-checked": isIndeterminate ? 'mixed' : isChecked,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**  @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $PdmhA.N900)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $PdmhA.N80)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $PdmhA.B50)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--local-border-active': `var(--ds-border, ${(0, $PdmhA.B50)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $PdmhA.R300)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $PdmhA.R300)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $PdmhA.B400)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $PdmhA.N10)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $PdmhA.N70)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    paddingLeft: "var(--ds-space-025, 2px)",
    color: `var(--ds-text-danger, ${(0, $PdmhA.R500)})`
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("c0wh4", function(module, exports) {

$parcel$export(module.exports, "useHasExceededChildIssuesLimitAfterLoad", () => $84343ee31b3ffa16$export$9a4276fe2342f86a);
$parcel$export(module.exports, "useHasExceededChildIssuesLimitAnyPanelOnOrAfterLoad", () => $84343ee31b3ffa16$export$ad2ba717f25a4760);

var $hJ992 = parcelRequire("hJ992");

var $f9RL0 = parcelRequire("f9RL0");

var $emTeK = parcelRequire("emTeK");
const $84343ee31b3ffa16$export$d5fe3a073ea8826a = (fieldKey)=>{
    const issueLimitUrl = (0, $hJ992.useChildIssuesIssueLimitUrl)(fieldKey);
    return Boolean(issueLimitUrl);
};
const $84343ee31b3ffa16$export$1b188c76a036ee7c = ()=>{
    const hasExceededChildIssuesLimitSubtasks = $84343ee31b3ffa16$export$d5fe3a073ea8826a((0, $f9RL0.SUBTASKS));
    const hasExceededChildIssuesLimitChildrenIssues = $84343ee31b3ffa16$export$d5fe3a073ea8826a((0, $f9RL0.CHILDREN_ISSUES));
    const hasExceededChildIssuesLimitEpicIssues = $84343ee31b3ffa16$export$d5fe3a073ea8826a((0, $f9RL0.EPIC_ISSUES));
    const hasExceededChildIssuesLimitPortfolioChildIssues = $84343ee31b3ffa16$export$d5fe3a073ea8826a((0, $f9RL0.PORTFOLIO_CHILD_ISSUES));
    return hasExceededChildIssuesLimitSubtasks || hasExceededChildIssuesLimitChildrenIssues || hasExceededChildIssuesLimitEpicIssues || hasExceededChildIssuesLimitPortfolioChildIssues;
};
const $84343ee31b3ffa16$export$9a4276fe2342f86a = (fieldKey)=>{
    const hasExceededChildIssuesLimitOnLoad = $84343ee31b3ffa16$export$d5fe3a073ea8826a(fieldKey);
    const totalChildIssuesCount = (0, $emTeK.useTotalChildIssuesCount)();
    const childIssuesLimit = (0, $hJ992.useChildIssuesLimit)();
    if (hasExceededChildIssuesLimitOnLoad) return false;
    return totalChildIssuesCount > childIssuesLimit;
};
const $84343ee31b3ffa16$export$bcb29cfe3aabacb5 = ()=>{
    const hasExceededChildIssuesLimitOnLoad = $84343ee31b3ffa16$export$1b188c76a036ee7c();
    const totalChildIssuesCount = (0, $emTeK.useTotalChildIssuesCount)();
    const childIssuesLimit = (0, $hJ992.useChildIssuesLimit)();
    if (hasExceededChildIssuesLimitOnLoad) return false;
    return totalChildIssuesCount > childIssuesLimit;
};
const $84343ee31b3ffa16$export$ad2ba717f25a4760 = ()=>{
    const hasExceededOnLoad = $84343ee31b3ffa16$export$1b188c76a036ee7c();
    const hasExceededAfterLoad = $84343ee31b3ffa16$export$bcb29cfe3aabacb5();
    return hasExceededOnLoad || hasExceededAfterLoad;
};

});
parcelRegister("emTeK", function(module, exports) {

$parcel$export(module.exports, "useTotalChildIssuesCount", () => $627b6f5da200e367$export$9922d43b01513ef7);

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $f9RL0 = parcelRequire("f9RL0");
const $627b6f5da200e367$export$9922d43b01513ef7 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [subtasksFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $f9RL0.SUBTASKS)
    });
    const [childrenIssuesFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $f9RL0.CHILDREN_ISSUES)
    });
    const [epicIssuesFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $f9RL0.EPIC_ISSUES)
    });
    const [portfolioChildIssuesFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $f9RL0.PORTFOLIO_CHILD_ISSUES)
    });
    const subtasksCount = Array.isArray(subtasksFieldValue) ? subtasksFieldValue.length : 0;
    const childrenIssuesCount = Array.isArray(childrenIssuesFieldValue) ? childrenIssuesFieldValue.length : 0;
    const epicIssuesCount = Array.isArray(epicIssuesFieldValue) ? epicIssuesFieldValue.length : 0;
    const portfolioChildIssuesCount = Array.isArray(portfolioChildIssuesFieldValue) ? portfolioChildIssuesFieldValue.length : 0;
    return subtasksCount + childrenIssuesCount + epicIssuesCount + portfolioChildIssuesCount;
};

});


parcelRegister("d6f6c", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $6c42ad247d2b6151$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $6c42ad247d2b6151$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $6c42ad247d2b6151$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $6c42ad247d2b6151$export$2ccf161b817b43b);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");


var $jMP2a = parcelRequire("jMP2a");
// eslint-disable-next-line jira/react/no-class-components
class $6c42ad247d2b6151$var$FireComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $jMP2a.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $6c42ad247d2b6151$export$64eb47d7b94ba089 = (0, $2jDha.default)()($6c42ad247d2b6151$var$FireComponent);
const $6c42ad247d2b6151$export$5a67e7291fd4569e = (props)=>// @ts-expect-error - TS2322 - Type '{ type: "UI"; attributes?: { [key: string]: any; } | undefined; eventName?: string | undefined; componentName?: string | undefined; action?: string | undefined; actionSubject?: string | undefined; actionSubjectId?: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$a1562d08625f5d7e)
    });
const $6c42ad247d2b6151$export$5f0d7aae8dfa8b86 = (props)=>// @ts-expect-error - TS2322 - Type '{ type: "TRACK"; attributes?: { [key: string]: any; } | undefined; eventName?: string | undefined; componentName?: string | undefined; action?: string | undefined; actionSubject?: string | undefined; actionSubjectId?: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$947dac6c72b26f81)
    });
const $6c42ad247d2b6151$export$b71c3ada5d4ec5da = (props)=>// @ts-expect-error - TS2322 - Type '{ type: "OPERATIONAL"; attributes?: { [key: string]: any; } | undefined; eventName?: string | undefined; componentName?: string | undefined; action?: string | undefined; actionSubject?: string | undefined; actionSubjectId?: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$12346a674644c156)
    });
const $6c42ad247d2b6151$export$2ccf161b817b43b = (props)=>// @ts-expect-error - TS2322 - Type '{ type: "SCREEN"; eventName: string; attributes?: { [key: string]: any; } | undefined; componentName?: string | undefined; action?: string | undefined; actionSubject?: string | undefined; actionSubjectId?: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});

parcelRegister("hxhMT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7508a6d4bc1b98e$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $a7508a6d4bc1b98e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    includeChildIssueLabel: {
        "id": "issue.log-time-modal.include-child-issues-label",
        "defaultMessage": "Include {childIssuesPanelType}"
    },
    timetrackingRollupDisabledTooltipLabel: {
        "id": "issue.log-time-modal.time-tracking-disabled-tooltip.label",
        "defaultMessage": "Including {childIssuesPanelType} is not available with more than 100 child issues"
    },
    timetrackingRollupDisabledTooltipLabelWithLimit: {
        "id": "issue.log-time-modal.time-tracking-disabled-tooltip.label-with-limit",
        "defaultMessage": "Including {childIssuesPanelType} is not available with more than {limit} child issues"
    }
});

});








parcelRegister("a81Gq", function(module, exports) {

$parcel$export(module.exports, "default", () => $07e1e4a04ac7055d$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $07e1e4a04ac7055d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue.activity.worklog.add-modal.title",
        "defaultMessage": "Time tracking"
    }
});

});



parcelRegister("le3fi", function(module, exports) {

$parcel$export(module.exports, "default", () => $09a9316a9d020856$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $5iWql = parcelRequire("5iWql");

var $hFmdR = parcelRequire("hFmdR");
var $8un0w = parcelRequire("8un0w");

var $lqalZ = parcelRequire("lqalZ");

var $dUqHv = parcelRequire("dUqHv");

var $1TrR5 = parcelRequire("1TrR5");

var $9Y7ra = parcelRequire("9Y7ra");
var $lUfDy = parcelRequire("lUfDy");

var $c1P4A = parcelRequire("c1P4A");
const $09a9316a9d020856$var$onConfirmMemo = (0, $5iWql.default)((stateProps, dispatchDeleteWorklog)=>(timeRemaining, isAdjustTimeRemainingChecked, analyticsEvent)=>{
        if (stateProps.worklog) dispatchDeleteWorklog(stateProps.worklog.id, timeRemaining, isAdjustTimeRemainingChecked, analyticsEvent);
    });
var $09a9316a9d020856$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $hFmdR.AnalyticsSubject)('worklog'), (0, $8un0w.default)({
    onConfirm: 'confirmDeleteWorklog',
    onCancel: 'cancelDeleteWorklog'
}), // @ts-expect-error - Type instantiation is excessively deep and possibly infinite.
(0, $lqalZ.connect)((state)=>({
        isDeleting: (0, $dUqHv.modalIsSavingSelector)(state),
        worklog: (0, $dUqHv.activeWorklogSelector)(state),
        timeTrackingConfig: (0, $dUqHv.timeTrackingConfigurationSelector)(state),
        timeRemainingSeconds: (0, $lUfDy.timeRemainingSecondsSelector)(state)
    }), {
    dispatchDeleteWorklog: (0, $9Y7ra.deleteWorklogRequest),
    onCancel: (0, $9Y7ra.closeModal)
}, (stateProps, { dispatchDeleteWorklog: dispatchDeleteWorklog, onCancel: onCancel })=>({
        ...stateProps,
        onCancel: onCancel,
        onConfirm: (0, $1TrR5.functionWithFFRedux)($09a9316a9d020856$var$onConfirmMemo(stateProps, dispatchDeleteWorklog), (timeRemaining, isAdjustTimeRemainingChecked, analyticsEvent)=>{
            if (stateProps.worklog) dispatchDeleteWorklog(stateProps.worklog.id, timeRemaining, isAdjustTimeRemainingChecked, analyticsEvent);
        })
    })))((0, $c1P4A.default));

});
parcelRegister("lUfDy", function(module, exports) {

$parcel$export(module.exports, "timeRemainingSecondsSelector", () => $3651f86b074a52e2$export$dc8074f9d4a3b196);
$parcel$export(module.exports, "loadingStageSelector", () => $3651f86b074a52e2$export$18bc980d36bf93d);
$parcel$export(module.exports, "highlightedWorklogIdSelector", () => $3651f86b074a52e2$export$f6c780fd55b93952);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");

var $dUqHv = parcelRequire("dUqHv");
const $3651f86b074a52e2$var$worklogUiSelector = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.worklog);
const $3651f86b074a52e2$export$dc8074f9d4a3b196 = (0, $df4Sl.createSelector)((0, $dUqHv.timeTrackingSelector), (timeTracking)=>timeTracking.remainingEstimateSeconds || 0);
const $3651f86b074a52e2$export$18bc980d36bf93d = (0, $df4Sl.createSelector)($3651f86b074a52e2$var$worklogUiSelector, (uiState)=>uiState.loadingStage);
const $3651f86b074a52e2$export$f6c780fd55b93952 = (0, $df4Sl.createSelector)($3651f86b074a52e2$var$worklogUiSelector, (uiState)=>uiState.highlightedWorklogId);

});

parcelRegister("c1P4A", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa48861527a4c101$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $bT7k5 = parcelRequire("bT7k5");

var $cSu9v = parcelRequire("cSu9v");

var $5YsMl = parcelRequire("5YsMl");

var $29yDk = parcelRequire("29yDk");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $cf2Y4 = parcelRequire("cf2Y4");

var $PdmhA = parcelRequire("PdmhA");

var $hFmdR = parcelRequire("hFmdR");
var $jPfP5 = parcelRequire("jPfP5");

var $kGQen = parcelRequire("kGQen");

var $h9cCP = parcelRequire("h9cCP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ie5Ph = parcelRequire("ie5Ph");
var $eH7pq = parcelRequire("eH7pq");

var $3RoDL = parcelRequire("3RoDL");

var $hJjah = parcelRequire("hJjah");


var $7v0hO = parcelRequire("7v0hO");

var $gaoWD = parcelRequire("gaoWD");
const $fa48861527a4c101$export$73392e09138fecd6 = (0, $hFmdR.AnalyticsSource)('deleteWorklog', (0, $41ea3621645e2acc$export$1171103ea9083ffa))(({ timeTrackingConfig: timeTrackingConfig, timeRemainingSeconds: timeRemainingSeconds, worklog: worklog, onConfirm: onConfirm, onCancel: onCancel, isDeleting: isDeleting })=>{
    const intl = (0, $5JgJ2.default)(); // these methods need to be created before their use
    const secondsToTimeString = (0, $eUqFw.useCallback)((seconds)=>{
        // At this time we need to force the value into an english formatted
        // time string eg: `1w 1d 1h 1m` as that is the only format supported
        // on entry, future changes will support localised values.
        const intlForTimeTrackingInput = {
            ...intl,
            formatMessage: ({ defaultMessage: defaultMessage })=>defaultMessage || ''
        };
        return (0, $7v0hO.timeTrackingFormatter)(seconds, {
            workingHoursPerDay: timeTrackingConfig.hoursPerDay,
            workingDaysPerWeek: timeTrackingConfig.daysPerWeek,
            timeFormat: timeTrackingConfig.format || (0, $h9cCP.PRETTY),
            defaultUnit: timeTrackingConfig.defaultUnit
        }, intlForTimeTrackingInput);
    }, [
        intl,
        timeTrackingConfig.daysPerWeek,
        timeTrackingConfig.defaultUnit,
        timeTrackingConfig.format,
        timeTrackingConfig.hoursPerDay
    ]);
    const [lTimeStringToSeconds] = (0, $eUqFw.useState)(()=>(0, $eH7pq.default)(timeTrackingConfig.daysPerWeek, timeTrackingConfig.hoursPerDay));
    const [originalTimeRemainingSeconds] = (0, $eUqFw.useState)(()=>timeRemainingSeconds);
    const [isAdjustTimeRemainingChecked, setIsAdjustTimeRemainingChecked] = (0, $eUqFw.useState)(true);
    const [timeRemaining, setTimeRemaining] = (0, $eUqFw.useState)(()=>secondsToTimeString(timeRemainingSeconds + Number(lTimeStringToSeconds(worklog?.timeSpent || '0s'))));
    const isTimeRemainingValid = (0, $eUqFw.useMemo)(()=>(0, $ie5Ph.default)(timeRemaining), [
        timeRemaining
    ]);
    const onTimeRemainingChange = (0, $eUqFw.useCallback)((event)=>setTimeRemaining(event.target.value), []);
    const onCheckboxChange = (0, $eUqFw.useCallback)(()=>setIsAdjustTimeRemainingChecked(!isAdjustTimeRemainingChecked), [
        isAdjustTimeRemainingChecked
    ]);
    const handleConfirm = (0, $eUqFw.useCallback)((event, analyticsEvent)=>onConfirm(isAdjustTimeRemainingChecked ? timeRemaining : secondsToTimeString(timeRemainingSeconds), isAdjustTimeRemainingChecked, analyticsEvent), [
        isAdjustTimeRemainingChecked,
        timeRemainingSeconds,
        onConfirm,
        timeRemaining,
        secondsToTimeString
    ]);
    const timeRemainingInput = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3RoDL.default), {
            isValid: isTimeRemainingValid
        }, (shouldAppearInvalid)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa48861527a4c101$var$TimeRemainingLabelWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("label", {
                htmlFor: "time-input"
            }, intl.formatMessage((0, $gaoWD.default).adjustNewLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa48861527a4c101$var$RequiredIndicator, {
                role: "presentation"
            }, "*")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
                content: (0, $hJjah.timeInvalidMessage),
                isOpen: shouldAppearInvalid,
                placement: "right"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                name: "time-input",
                value: timeRemaining,
                testId: "issue.activity.worklog.delete-modal.textfield",
                isInvalid: shouldAppearInvalid,
                onChange: onTimeRemainingChange,
                placeholder: intl.formatMessage((0, $hJjah.default).timeInputPlaceholder),
                isDisabled: isDeleting,
                isRequired: true,
                elemAfterInput: shouldAppearInvalid === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    xcss: $fa48861527a4c101$var$warningWrapperStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
                    size: "medium",
                    primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y300)})`,
                    label: ""
                })) : null,
                id: "time-input"
            })))), [
        intl,
        isDeleting,
        isTimeRemainingValid,
        onTimeRemainingChange,
        timeRemaining
    ]);
    const content = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, intl.formatMessage((0, $gaoWD.default).deleteWarning)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa48861527a4c101$var$CheckboxContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
            isChecked: isAdjustTimeRemainingChecked,
            isDisabled: isDeleting,
            onChange: onCheckboxChange,
            label: intl.formatMessage((0, $gaoWD.default).adjustCheckboxLabel),
            name: "adjust-checkbox" // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            ,
            testId: "issue.activity.worklog.delete-modal.checkbox"
        })), isAdjustTimeRemainingChecked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa48861527a4c101$var$AdjustContainer, {
            "data-testid": "issue-view-activity.worklog.delete-modal.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa48861527a4c101$var$CurrentTimeRemainingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa48861527a4c101$var$TimeRemainingLabelWrapper, null, intl.formatMessage((0, $gaoWD.default).adjustCurrentLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa48861527a4c101$var$CurrentTimeRemainingValue, null, originalTimeRemainingSeconds)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $fa48861527a4c101$var$arrowContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa48861527a4c101$var$NewTimeRemainingContainer, null, timeRemainingInput, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa48861527a4c101$var$Subtext, null, intl.formatMessage((0, $gaoWD.default).adjustNewSubtext, {
            timeSpent: worklog?.timeSpent || '0s'
        }))))), [
        intl,
        isAdjustTimeRemainingChecked,
        isDeleting,
        onCheckboxChange,
        originalTimeRemainingSeconds,
        timeRemainingInput,
        worklog
    ]);
    const renderSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            interactionName: "issue-worklog-delete-modal-spinner",
            size: "small"
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPfP5.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "small",
        onClose: onCancel,
        shouldCloseOnEscapePress: true // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        ,
        testId: "issue.activity.worklog.delete-modal.ak-modal-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "danger"
    }, intl.formatMessage((0, $gaoWD.default).deleteHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        interactionName: "issue-worklog",
        iconAfter: isDeleting ? renderSpinner() : undefined,
        appearance: "primary",
        onClick: handleConfirm,
        isDisabled: isDeleting || isAdjustTimeRemainingChecked && !isTimeRemainingValid,
        testId: "issue.activity.worklog.delete-modal.confirm-button"
    }, intl.formatMessage((0, $gaoWD.default).delete)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onCancel,
        isDisabled: isDeleting,
        testId: "issue.activity.worklog.delete-modal.cancel-button",
        interactionName: "auto-generated.issue.activity.worklog.delete-modal.cancel-button.button"
    }, intl.formatMessage((0, $gaoWD.default).cancel))))));
});
var $fa48861527a4c101$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $fa48861527a4c101$export$73392e09138fecd6;
const $fa48861527a4c101$var$CurrentTimeRemainingContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _p12fcmky",
            __cmplp.className
        ])
    });
}); // These styles have been copied from the field-base label styles
const $fa48861527a4c101$var$TimeRemainingLabelWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _11c816g6 _ca0qv47k _n3tdv47k _19bvidpf _u5f3idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa48861527a4c101$var$CurrentTimeRemainingValue = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _1yt4utpp",
            __cmplp.className
        ])
    });
});
const $fa48861527a4c101$var$arrowContainerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.800',
    marginBottom: 'space.600',
    marginLeft: 'space.100',
    marginRight: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa48861527a4c101$var$CheckboxContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkpxbi _otyrpxbi _18u0r5cr _2hwxidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa48861527a4c101$var$NewTimeRemainingContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ssb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa48861527a4c101$var$Subtext = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb19bv _19pk1b66 _syaz1ifp",
            __cmplp.className
        ])
    });
});
const $fa48861527a4c101$var$warningWrapperStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.negative.050',
    marginRight: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa48861527a4c101$var$RequiredIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1yis _19bvv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa48861527a4c101$var$AdjustContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _19pk10v4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cSu9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9601eacac1d33448$var$_react = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9601eacac1d33448$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9601eacac1d33448$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $9601eacac1d33448$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.793 5.793a.999.999 0 000 1.414L15.586 11H6a1 1 0 000 2h9.586l-3.793 3.793a.999.999 0 000 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a.997.997 0 00.293-.679v-.057a.996.996 0 00-.293-.678l-5.499-5.5a1 1 0 00-1.415 0z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$9601eacac1d33448$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $9601eacac1d33448$var$_default = $9601eacac1d33448$var$ArrowRightIcon;
module.exports.default = $9601eacac1d33448$var$_default;

});

parcelRegister("29yDk", function(module, exports) {

$parcel$export(module.exports, "default", () => $99fb58582e83d080$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $lbDTY = parcelRequire("lbDTY");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $XHGTv = parcelRequire("XHGTv");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $1GZRB = parcelRequire("1GZRB");
const $99fb58582e83d080$var$packageName = undefined;
const $99fb58582e83d080$var$packageVersion = undefined;
const $99fb58582e83d080$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $99fb58582e83d080$var$checkIsChildOfPortal(node.parentElement);
};
const $99fb58582e83d080$export$513033cc22e3bc20 = /*#__PURE__*/ (0, $eUqFw.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $5Q9wj.default), onContentClick: onContentClick = (0, $5Q9wj.default), onContentFocus: onContentFocus = (0, $5Q9wj.default), onClose: onClose = (0, $5Q9wj.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children }) {
    const containerRef = (0, $eUqFw.useRef)(null);
    const triggerRef = (0, $eUqFw.useRef)(null);
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $eUqFw.useRef)(onClose);
    (0, $eUqFw.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    const handleCloseRequest = (0, $eUqFw.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.inline-message-layering_wfp1p')) {
            if (!isLayerDisabled()) onCloseRef.current?.({
                isOpen: false,
                event: event
            });
        } else {
            // handles the case where inline dialog opens portalled elements such as modal
            if ($99fb58582e83d080$var$checkIsChildOfPortal(target)) return;
            // call onClose if the click originated from outside the dialog
            if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
                isOpen: false,
                event: event
            });
        }
    }, [
        isLayerDisabled
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        // if feature flag is enabled we won't file the close event when clicking inside dialog
        if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.inline-message-layering_wfp1p') && containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen) return;
        const unbind = (0, $74BVL.bind)(window, {
            type: 'click',
            listener: handleClick,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isOpen,
        handleClick
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape') handleCloseRequest(event);
    }, [
        handleCloseRequest
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen) return;
        const unbind = (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isOpen,
        handleKeyDown
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $i6BC8.Popper), {
        placement: placement,
        strategy: strategy
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $1GZRB.Container), {
            onBlur: onContentBlur,
            onFocus: onContentFocus,
            onClick: onContentClick,
            ref: (node)=>{
                if (node) {
                    containerRef.current = node;
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            testId: testId
        }, content)) : null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
            innerRef: (node)=>{
                triggerRef.current = node;
                if (typeof ref === 'function') ref(node);
                else ref.current = node;
            }
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children))), popper);
});
$99fb58582e83d080$export$513033cc22e3bc20.displayName = 'InlineDialog';
const $99fb58582e83d080$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
var $99fb58582e83d080$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'inlineDialog',
    packageName: $99fb58582e83d080$var$packageName,
    packageVersion: $99fb58582e83d080$var$packageVersion
})((0, $2jDha.default)({
    onClose: $99fb58582e83d080$var$createAndFireEventOnAtlaskit({
        action: 'closed',
        actionSubject: 'inlineDialog',
        attributes: {
            componentName: 'inlineDialog',
            packageName: $99fb58582e83d080$var$packageName,
            packageVersion: $99fb58582e83d080$var$packageVersion
        }
    })
})($99fb58582e83d080$export$513033cc22e3bc20));

});
parcelRegister("1GZRB", function(module, exports) {

$parcel$export(module.exports, "Container", () => $9db71f94672a5c3a$export$42a852a2b6b56249);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
const $9db71f94672a5c3a$var$CSS_THEME_BACKGROUND = '--theme-background';
const $9db71f94672a5c3a$var$CSS_THEME_COLOR = '--theme-color';
const $9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
const $9db71f94672a5c3a$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'content-box',
    maxWidth: `${448}px`,
    maxHeight: `${448}px`,
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`,
    zIndex: (0, $lcnyw.layers).dialog(),
    background: `var(${$9db71f94672a5c3a$var$CSS_THEME_BACKGROUND})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(${$9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW})`,
    color: `var(${$9db71f94672a5c3a$var$CSS_THEME_COLOR})`,
    '&:focus': {
        outline: 'none'
    }
});
const $9db71f94672a5c3a$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return(// Unfortunately, these are used for products to pass through. Inline Dialog is being deprecated anyway
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $9db71f94672a5c3a$var$containerStyles,
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$9db71f94672a5c3a$var$CSS_THEME_BACKGROUND]: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
            [$9db71f94672a5c3a$var$CSS_THEME_COLOR]: `var(--ds-text, ${(0, $PdmhA.N900)})`,
            [$9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW]: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`,
            ...style
        }
    }, children));
});

});


parcelRegister("gaoWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c419dd263579ed2$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $6c419dd263579ed2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    delete: {
        "id": "issue.activity.worklog.delete-modal.delete",
        "defaultMessage": "Delete"
    },
    deleteHeading: {
        "id": "issue.activity.worklog.delete-modal.delete-heading",
        "defaultMessage": "Delete worklog entry?"
    },
    cancel: {
        "id": "issue.activity.worklog.delete-modal.cancel",
        "defaultMessage": "Cancel"
    },
    deleteWarning: {
        "id": "issue.activity.worklog.delete-modal.delete-warning",
        "defaultMessage": "Once you delete, it's gone for good."
    },
    adjustCheckboxLabel: {
        "id": "issue.activity.worklog.delete-modal.adjust-checkbox-label",
        "defaultMessage": "Adjust time remaining"
    },
    adjustCurrentLabel: {
        "id": "issue.activity.worklog.delete-modal.adjust-current-label",
        "defaultMessage": "Current"
    },
    adjustNewLabel: {
        "id": "issue.activity.worklog.delete-modal.adjust-new-label",
        "defaultMessage": "New time remaining"
    },
    adjustNewSubtext: {
        "id": "issue.activity.worklog.delete-modal.adjust-new-subtext",
        "defaultMessage": "By default, deleted time ({timeSpent}) is added to the time remaining."
    }
});

});



parcelRegister("knDik", function(module, exports) {

$parcel$export(module.exports, "default", () => $065930ef1a336b21$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $df4Sl = parcelRequire("df4Sl");

var $hFmdR = parcelRequire("hFmdR");
var $8un0w = parcelRequire("8un0w");

var $8Qd0L = parcelRequire("8Qd0L");

var $giAhk = parcelRequire("giAhk");

var $lqalZ = parcelRequire("lqalZ");

var $cp79T = parcelRequire("cp79T");

var $jZDJX = parcelRequire("jZDJX");

var $gS8e9 = parcelRequire("gS8e9");

var $dUqHv = parcelRequire("dUqHv");

var $hIdxh = parcelRequire("hIdxh");

var $1TrR5 = parcelRequire("1TrR5");

var $67G0Q = parcelRequire("67G0Q");

var $9Y7ra = parcelRequire("9Y7ra");

var $7ZxTf = parcelRequire("7ZxTf");
const $065930ef1a336b21$var$WrappedWorklogModal = (props)=>{
    const { timeTrackingValue: timeTrackingValue, rolledUpTimeTrackingValue: rolledUpTimeTrackingValue, ...viewProps } = props;
    const [isRollingUpData, { markRollingUpData: markRollingUpData, unmarkRollingUpData: unmarkRollingUpData }] = (0, $67G0Q.useWorklogRollingUpData)();
    const onToggleRollingUpData = (0, $eUqFw.useCallback)((includeChildIssues)=>{
        includeChildIssues ? markRollingUpData() : unmarkRollingUpData();
    }, [
        markRollingUpData,
        unmarkRollingUpData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ZxTf.default), {
        ...viewProps,
        timeTracking: timeTrackingValue,
        rolledUpTimeTracking: rolledUpTimeTrackingValue,
        isRollingUpData: isRollingUpData,
        onToggleRollingUpData: onToggleRollingUpData
    });
};
const $065930ef1a336b21$var$EditModalWithAnalyticsAndIntl = (0, $giAhk.injectIntlV2)((0, $8un0w.default)({
    onSubmit: 'submitEditWorklog',
    onCancel: 'cancelEditWorklog'
})((0, $hFmdR.AnalyticsSubject)('worklog')($065930ef1a336b21$var$WrappedWorklogModal)));
const $065930ef1a336b21$var$mapStateToProps = (state)=>({
        worklog: (0, $dUqHv.activeWorklogSelector)(state),
        timeTrackingConfiguration: (0, $dUqHv.timeTrackingConfigurationSelector)(state),
        rolledUpTimeTrackingValue: (0, $dUqHv.timeTrackingWithSubtasksOrChildrenRollupSelector)(state)(true),
        timeTrackingValue: (0, $dUqHv.timeTrackingSelector)(state),
        timeZone: (0, $jZDJX.loggedInUserTimeZoneSelector)(state),
        isDone: (0, $hIdxh.statusCategorySelector)(state) === (0, $8Qd0L.DONE),
        isSaving: (0, $dUqHv.modalIsSavingSelector)(state),
        mediaContext: (0, $gS8e9.mediaContextSelector)(state),
        mentionProvider: (0, $cp79T.mentionProviderSelector)(state),
        shouldDisplayRollUpDataControl: (0, $dUqHv.shouldDisplayRollUpDataControlSelector)(state),
        isClassicProject: (0, $jZDJX.isClassicProjectSelector)(state)
    });
const $065930ef1a336b21$var$rolledUpTimeTrackingValueMemoized = ()=>(0, $df4Sl.createSelector)((state)=>(0, $dUqHv.timeTrackingWithSubtasksOrChildrenRollupSelector)(state)(true), (res)=>res);
const $065930ef1a336b21$var$mapStateToPropsFactory = ()=>{
    const rolledUpTimeTrackingValueInstance = $065930ef1a336b21$var$rolledUpTimeTrackingValueMemoized();
    return (state)=>({
            worklog: (0, $dUqHv.activeWorklogSelector)(state),
            timeTrackingConfiguration: (0, $dUqHv.timeTrackingConfigurationSelector)(state),
            rolledUpTimeTrackingValue: rolledUpTimeTrackingValueInstance(state),
            timeTrackingValue: (0, $dUqHv.timeTrackingSelector)(state),
            timeZone: (0, $jZDJX.loggedInUserTimeZoneSelector)(state),
            isDone: (0, $hIdxh.statusCategorySelector)(state) === (0, $8Qd0L.DONE),
            isSaving: (0, $dUqHv.modalIsSavingSelector)(state),
            mediaContext: (0, $gS8e9.mediaContextSelector)(state),
            mentionProvider: (0, $cp79T.mentionProviderSelector)(state),
            shouldDisplayRollUpDataControl: (0, $dUqHv.shouldDisplayRollUpDataControlSelector)(state),
            isClassicProject: (0, $jZDJX.isClassicProjectSelector)(state)
        });
};
var $065930ef1a336b21$export$2e2bcd8739ae039 = (0, $lqalZ.connect)(// @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 1 or more, but got 0.
(0, $1TrR5.functionWithFFRedux)($065930ef1a336b21$var$mapStateToPropsFactory, $065930ef1a336b21$var$mapStateToProps), (dispatch)=>({
        onSubmit: (worklogId, values, analyticsEvent)=>{
            dispatch((0, $9Y7ra.editWorklogRequest)(worklogId, values, analyticsEvent));
        },
        onCancel: ()=>{
            dispatch((0, $9Y7ra.closeModal)());
        }
    }))($065930ef1a336b21$var$EditModalWithAnalyticsAndIntl);

});
parcelRegister("giAhk", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $208f42a3fdc9fe2c$export$440265f0ca78e98e);

var $eUqFw = parcelRequire("eUqFw");

var $lxchL = parcelRequire("lxchL");

var $2qhQi = parcelRequire("2qhQi");

var $1IqwQ = parcelRequire("1IqwQ");
const $208f42a3fdc9fe2c$var$IntlConsumer = (0, $2qhQi.Context).Consumer;
const $208f42a3fdc9fe2c$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $208f42a3fdc9fe2c$var$getDisplayName(Component) {
    if ($208f42a3fdc9fe2c$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($208f42a3fdc9fe2c$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $208f42a3fdc9fe2c$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intlRef = (0, $eUqFw.useRef)(null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($208f42a3fdc9fe2c$var$IntlConsumer, null, (intl)=>{
            if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
            if (!intlRef.current) intlRef.current = {
                // Now is deprecated since version 2: https://github.com/formatjs/formatjs/issues/1409
                now: ()=>Date.now(),
                // @ts-expect-error We force v5 messages type on v2 type
                messages: intl.messages,
                locale: intl.locale,
                formats: intl.formats,
                formatDate: intl.formatDate,
                formatMessage: intl.formatMessage,
                formatHTMLMessage: (descriptor, values)=>intl.formatMessage(descriptor, values, {
                        ignoreTag: true
                    }),
                formatNumber: intl.formatNumber,
                formatRelative: (date, opts)=>{
                    const { time: time, unit: unit } = (0, $1IqwQ.getRelativeTimeAndUnit)(date);
                    return intl.formatRelativeTime(time, unit, opts);
                },
                formatPlural: intl.formatPlural,
                formatTime: intl.formatTime
            };
            return(// @ts-expect-error - TS2322 - Type 'Diff<LibraryManagedAttributes<Component, ComponentProps<Component>>, InjectIntlVoidProps> & { ...; } & { ...; }' is not assignable to type 'IntrinsicAttributes & LibraryManagedAttributes<Component, PropsWithChildren<P>>'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                intl: intlRef.current,
                ref: withRef ? props.forwardedRef : null
            }));
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$208f42a3fdc9fe2c$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) // @ts-expect-error - TS2352 - Conversion of type 'ForwardRefExoticComponent<PropsWithoutRef<WithIntlProps<LibraryManagedAttributes<C, ComponentProps<C>>>> & RefAttributes<...>> & NonReactStatics<...>' to type 'ComponentType<WithIntlProps<LibraryManagedAttributes<C, ComponentProps<C>>>>' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(WithIntl, WrappedComponent);
};

});

parcelRegister("7ZxTf", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaab0d442f7238df$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $hFmdR = parcelRequire("hFmdR");
var $jPfP5 = parcelRequire("jPfP5");

var $h9cCP = parcelRequire("h9cCP");

var $ie5Ph = parcelRequire("ie5Ph");
var $j8PT9 = parcelRequire("j8PT9");
var $eH7pq = parcelRequire("eH7pq");

var $kBu7F = parcelRequire("kBu7F");


var $7Vbpp = parcelRequire("7Vbpp");

var $7v0hO = parcelRequire("7v0hO");

var $Tr0ux = parcelRequire("Tr0ux");
const $eaab0d442f7238df$export$be56ab521bea75bf = ()=>({ timeLogged: timeLogged, timeRemaining: timeRemaining, dateStarted: dateStarted })=>{
        const isTimeLoggedValid = (0, $ie5Ph.default)(timeLogged) || timeLogged === '0';
        return isTimeLoggedValid && (0, $j8PT9.default)(timeRemaining) && !!dateStarted;
    };
// eslint-disable-next-line jira/react/no-class-components
class $eaab0d442f7238df$var$EditModal extends (0, $eUqFw.Component) {
    render() {
        const { worklog: worklog, timeTracking: timeTrackingState, rolledUpTimeTracking: rolledUpTimeTracking, timeTrackingConfiguration: timeTrackingConfiguration, intl: intl } = this.props;
        // should never be the case as this is the "edit" view
        // but the conditional is needed so Flow understands it
        if (!worklog) return null;
        const { timeSpentSeconds: timeSpentSeconds, remainingEstimateSeconds: remainingEstimateSeconds, originalEstimateSeconds: originalEstimateSeconds } = timeTrackingState;
        const { daysPerWeek: daysPerWeek, hoursPerDay: hoursPerDay } = timeTrackingConfiguration;
        let timeRemaining = '';
        if (typeof remainingEstimateSeconds === 'number') {
            // At this time we need to force the value into an english formatted
            // time string eg: `1w 1d 1h 1m` as that is the only format supported
            // on entry, future changes will support localised values.
            const intlForTimeTrackingInput = {
                ...intl,
                formatMessage: ({ defaultMessage: defaultMessage })=>defaultMessage || ''
            };
            timeRemaining = (0, $7v0hO.timeTrackingFormatter)(remainingEstimateSeconds, {
                workingHoursPerDay: timeTrackingConfiguration.hoursPerDay,
                workingDaysPerWeek: timeTrackingConfiguration.daysPerWeek,
                timeFormat: timeTrackingConfiguration.format || (0, $h9cCP.PRETTY),
                defaultUnit: timeTrackingConfiguration.defaultUnit
            }, intlForTimeTrackingInput);
        }
        const initialValue = {
            timeLogged: worklog.timeSpent,
            timeLoggedSeconds: (0, $eH7pq.default)(daysPerWeek, hoursPerDay)(worklog.timeSpent) || 0,
            timeRemaining: timeRemaining,
            timeRemainingSeconds: remainingEstimateSeconds,
            dateStarted: new Date(worklog.started).toISOString(),
            workDescription: worklog.comment || (0, $7Vbpp.emptyAdfObject)
        };
        const timeTracking = {
            loggedTime: timeSpentSeconds,
            remainingTime: remainingEstimateSeconds
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kBu7F.default), {
            initialValue: initialValue,
            timeTracking: timeTracking,
            rolledUpTimeTracking: {
                loggedTime: rolledUpTimeTracking.timeSpentSeconds,
                remainingTime: rolledUpTimeTracking.remainingEstimateSeconds
            },
            estimatedTime: originalEstimateSeconds,
            rolledUpEstimatedTime: rolledUpTimeTracking.originalEstimateSeconds,
            config: timeTrackingConfiguration,
            header: intl.formatMessage((0, $Tr0ux.default).title),
            timeZone: this.props.timeZone,
            isCollapsible: false,
            isDone: this.props.isDone,
            isWaiting: this.props.isSaving,
            shouldUpdateDate: false,
            validator: $eaab0d442f7238df$export$be56ab521bea75bf(),
            onSubmit: this.onSubmit,
            onCancel: this.props.onCancel,
            onWorkDescriptionChangeFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            mediaContext: this.props.mediaContext,
            mentionProvider: this.props.mentionProvider || {},
            mentionEncoder: this.props.mentionEncoder,
            activityProvider: this.props.activityProvider,
            externalId: this.props.externalId,
            shouldDisplayRollUpDataControl: this.props.shouldDisplayRollUpDataControl,
            isRollingUpData: this.props.isRollingUpData,
            onToggleRollingUpData: this.props.onToggleRollingUpData,
            isClassicProject: this.props.isClassicProject
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPfP5.default), null));
    }
    constructor(...args){
        super(...args);
        this.onSubmit = (values, analyticsEvent)=>{
            const { worklog: worklog } = this.props;
            if (worklog) this.props.onSubmit(worklog.id, values, analyticsEvent);
        };
    }
}
var $eaab0d442f7238df$export$2e2bcd8739ae039 = (0, $hFmdR.AnalyticsSource)('editWorklog', (0, $41ea3621645e2acc$export$1171103ea9083ffa))($eaab0d442f7238df$var$EditModal);

});
parcelRegister("Tr0ux", function(module, exports) {

$parcel$export(module.exports, "default", () => $d05f870ca6fab47f$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $d05f870ca6fab47f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue.activity.worklog.edit-modal.title",
        "defaultMessage": "Edit work log"
    }
});

});



parcelRegister("guDY0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5ae72de5f9a78f$export$2e2bcd8739ae039);

var $lqalZ = parcelRequire("lqalZ");

var $2Ef7E = parcelRequire("2Ef7E");

var $89RSX = parcelRequire("89RSX");
var $bf5ae72de5f9a78f$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state)=>({
        isEnabled: (0, $2Ef7E.isIssueDropzoneAndClipboardUploadEnabled)(state)
    }))((0, $89RSX.CommonClipboardMediaPicker));

});
parcelRegister("2Ef7E", function(module, exports) {

$parcel$export(module.exports, "isIssueDropzoneAndClipboardUploadEnabled", () => $e2d2e99953974082$export$4b4e0346790fa6b6);

var $df4Sl = parcelRequire("df4Sl");


var $f9RL0 = parcelRequire("f9RL0");

var $fokFV = parcelRequire("fokFV");

var $dUqHv = parcelRequire("dUqHv");

var $jDl0t = parcelRequire("jDl0t");

var $dmojD = parcelRequire("dmojD");

var $dbEIL = parcelRequire("dbEIL");
const $e2d2e99953974082$var$selector = (0, $df4Sl.createSelector)((0, $fokFV.isRichTextFieldEditingSelector), (0, $dmojD.isCommentEditorOpenSelector), (0, $jDl0t.isAttachmentPickerPopupOpenSelector), (0, $dbEIL.isFormInEditModeSelector), (0, $fokFV.isFieldEditingSelector)((0, $f9RL0.TIME_TRACKING)), (0, $dUqHv.openModalSelector), (isEditingRichTextField, isEditingComment, isAttachmentPickerPopupOpen, isProformaFormInEditMode, isTimeTrackingAddModalOpen, openTimeTrackingModal)=>!isEditingRichTextField && !isEditingComment && !isAttachmentPickerPopupOpen && !isProformaFormInEditMode && !isTimeTrackingAddModalOpen && !(openTimeTrackingModal === (0, $0577deea918816be$export$46c4589329d924e6)));
const $e2d2e99953974082$export$4b4e0346790fa6b6 = (state)=>$e2d2e99953974082$var$selector(state);

});
parcelRegister("dbEIL", function(module, exports) {

$parcel$export(module.exports, "isFormInEditModeSelector", () => $0be60a40af2b5262$export$dbe9f465b6f5e038);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $0be60a40af2b5262$export$3dbde98e08318ca4 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.proforma);
const $0be60a40af2b5262$export$dbe9f465b6f5e038 = (0, $df4Sl.createSelector)($0be60a40af2b5262$export$3dbde98e08318ca4, (proforma)=>!!proforma.isProformaFormInEditMode);

});


parcelRegister("89RSX", function(module, exports) {

$parcel$export(module.exports, "CommonClipboardMediaPicker", () => $a7d68a845afd9ec5$export$f03ca57fb7076af2);

var $eUqFw = parcelRequire("eUqFw");

var $j9zyb = parcelRequire("j9zyb");

var $2aue1 = parcelRequire("2aue1");

var $627hr = parcelRequire("627hr");
const $a7d68a845afd9ec5$var$WrappedClipboard = (0, $627hr.default)((0, $j9zyb.Clipboard));
const $a7d68a845afd9ec5$export$f03ca57fb7076af2 = ({ isEnabled: isEnabled, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2aue1.default), null, (stackIndex)=>{
        const shouldRender = isEnabled && stackIndex === 0;
        if (!shouldRender) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7d68a845afd9ec5$var$WrappedClipboard, {
            ...otherProps,
            isolated: false
        });
    });

});
parcelRegister("j9zyb", function(module, exports) {

$parcel$export(module.exports, "Clipboard", () => $c7c5f3dfc37493c5$export$8b44c43c7d8f0830);

var $eUqFw = parcelRequire("eUqFw");

var $iJMkB = parcelRequire("iJMkB");

var $7wp7z = parcelRequire("7wp7z");
const $c7c5f3dfc37493c5$export$7b1ba4955557a858 = ()=>null;
const $c7c5f3dfc37493c5$export$8b44c43c7d8f0830 = ({ config: config, isolated: isolated, ...props })=>{
    const container = (0, $7wp7z.useClipboardContextBoundary)();
    const onPaste = (0, $eUqFw.useCallback)((event)=>{
        // do not propagate event above container boundary
        event.stopPropagation();
        // preventing default will disable any copy-paste
        // event.preventDefault();
        // false means "allow"
        return false;
    }, []);
    const derivedConfig = (0, $eUqFw.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        container ? {
            ...config,
            container: container,
            onPaste: onPaste
        } : config, [
        config,
        container,
        onPaste
    ]);
    if (!container && isolated !== false) // hard block clipboard if boundary is not set
    // render "marker" to ease testing
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7c5f3dfc37493c5$export$7b1ba4955557a858, null);
    // Here there is a good opportunity to report own existence to the boundary to prevent two Clipboards from being active at the same node
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJMkB.ClipboardLoader), {
        ...props,
        config: derivedConfig
    });
};

});
parcelRegister("iJMkB", function(module, exports) {

$parcel$export(module.exports, "ClipboardLoader", () => $da41eb8bdd0b4082$export$d7936799bf32b554);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");


class $da41eb8bdd0b4082$export$d7936799bf32b554 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            Clipboard: $da41eb8bdd0b4082$export$d7936799bf32b554.Clipboard
        });
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Clipboard) {
            const [mediaClient, clipboardModule] = await Promise.all([
                (parcelRequire("eSP44")),
                (parcelRequire("4XhQn"))
            ]);
            $da41eb8bdd0b4082$export$d7936799bf32b554.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
            this.setState({
                Clipboard: $da41eb8bdd0b4082$export$d7936799bf32b554.Clipboard
            });
        }
    }
    render() {
        if (!this.state.Clipboard) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(this.state.Clipboard, this.props);
    }
}
(0, $5zQU9.default)($da41eb8bdd0b4082$export$d7936799bf32b554, "displayName", 'AsyncClipboard');

});
parcelRegister("eSP44", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('c8zNP');
        const value = parcelRequire('6CCBy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("c8zNP").then(()=>parcelRequire('6CCBy'));
}

});

parcelRegister("4XhQn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1GMAG');
        const value = parcelRequire('lqfGt');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1GMAG").then(()=>parcelRequire('lqfGt'));
}

});



parcelRegister("2aue1", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cee3ee5f6377c07$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $9cee3ee5f6377c07$var$isAuiDialogEvent = (ev)=>{
    if (!(ev instanceof CustomEvent)) return false;
    const hasAuiDialogElement = ev.detail?.layerElement?.classList?.contains('aui-dialog2');
    return hasAuiDialogElement;
};
class $9cee3ee5f6377c07$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidMount() {
        document.addEventListener('legacyJiraDialogBeforeShow', this.incrementStackIndex);
        document.addEventListener('legacyJiraDialogBeforeHide', this.decrementStackIndex);
        document.addEventListener('on-before-aui-layer-show', this.incrementStackIndexWhenAuiDialog);
        document.addEventListener('on-before-aui-layer-hide', this.decrementStackIndexWhenAuiDialog);
    }
    componentWillUnmount() {
        document.removeEventListener('legacyJiraDialogBeforeShow', this.incrementStackIndex);
        document.removeEventListener('legacyJiraDialogBeforeHide', this.decrementStackIndex);
        document.removeEventListener('on-before-aui-layer-show', this.incrementStackIndexWhenAuiDialog);
        document.removeEventListener('on-before-aui-layer-hide', this.decrementStackIndexWhenAuiDialog);
    }
    render() {
        /**
		 * Currently not all event listeners are being triggered, so the stackIndex
		 * smaller then 1 is being blocked.
		 * https://hello.atlassian.net/wiki/spaces/JSDee/pages/1781258277/Bento+Modal+View+-+FocusLock+Problem
		 */ return this.props.children(this.state.stackIndex);
    }
    constructor(...args){
        super(...args);
        this.state = {
            stackIndex: 0
        };
        this.incrementStackIndex = ()=>{
            this.setState((oldState)=>({
                    stackIndex: oldState.stackIndex + 1
                }));
        };
        this.decrementStackIndex = ()=>{
            this.setState((oldState)=>({
                    stackIndex: oldState.stackIndex - 1
                }));
        };
        this.incrementStackIndexWhenAuiDialog = (ev)=>{
            if (!$9cee3ee5f6377c07$var$isAuiDialogEvent(ev)) return;
            this.incrementStackIndex();
        };
        this.decrementStackIndexWhenAuiDialog = (ev)=>{
            if (!$9cee3ee5f6377c07$var$isAuiDialogEvent(ev)) return;
            this.decrementStackIndex();
        };
    }
}

});

parcelRegister("627hr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b7576973fb077d7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $kUI0A = parcelRequire("kUI0A");

var $hJ992 = parcelRequire("hJ992");

var $lqalZ = parcelRequire("lqalZ");

var $b2g4Y = parcelRequire("b2g4Y");

var $20th5 = parcelRequire("20th5");

var $gS8e9 = parcelRequire("gS8e9");
const $3b7576973fb077d7$var$withMediaPickerPropsProvider = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(MediaPickerComponent)=>(props)=>{
        const { onUploadStart: onUploadStart, onUploadEnd: onUploadEnd, onUploadError: onUploadError, onGeneralError: onGeneralError, uploadContext: uploadContext, eventHandlers: eventHandlers, config: config, onDragEnter: onDragEnter, onDragLeave: onDragLeave, onDrop: onDrop, ...otherProps } = props;
        const uploadTokensPromisesResolvers = (0, $eUqFw.useRef)([]);
        const isTokenUpToDate = (0, $eUqFw.useCallback)(()=>{
            if (!uploadContext) return false;
            const { tokenIssueTimestamp: tokenIssueTimestamp, tokenLifespanInMs: tokenLifespanInMs } = uploadContext;
            const expirationTimestamp = tokenIssueTimestamp + tokenLifespanInMs;
            return expirationTimestamp > Date.now();
        }, [
            uploadContext
        ]);
        const resolveAuthPromise = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([resolve, reject])=>{
            if (!uploadContext || !isTokenUpToDate()) {
                reject();
                return;
            }
            const { serviceHost: serviceHost, clientId: clientId, token: token } = uploadContext;
            resolve({
                clientId: clientId,
                token: token,
                baseUrl: serviceHost
            });
        }, [
            isTokenUpToDate,
            uploadContext
        ]);
        const resolveUploadPromises = (0, $eUqFw.useCallback)(()=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            uploadTokensPromisesResolvers.current.forEach(resolveAuthPromise);
            uploadTokensPromisesResolvers.current = [];
        }, [
            resolveAuthPromise
        ]);
        const mediaClientConfig = {
            authProvider: ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                new Promise((resolve, reject)=>{
                    if (isTokenUpToDate()) resolveAuthPromise([
                        resolve,
                        reject
                    ]);
                    else {
                        props.requestUploadToken();
                        uploadTokensPromisesResolvers.current = [
                            // @ts-expect-error - TS2488 - Type 'unknown' must have a '[Symbol.iterator]()' method that returns an iterator.
                            ...uploadTokensPromisesResolvers.current,
                            [
                                resolve,
                                reject
                            ]
                        ];
                    }
                }),
            ...(0, $1ybV0.ff)('issue.details.update-media-config-to-sha256') ? {
                useSha256ForUploads: true
            } : {}
        };
        const mediaPickerConfig = {
            // @ts-expect-error - TS2783 - 'uploadParams' is specified more than once, so this usage will be overwritten.
            uploadParams: {
                collection: uploadContext?.collection
            },
            ...config,
            multiple: true
        };
        const issueKey = (0, $hJ992.useIssueKey)();
        const [, { addNewAttachments: addNewAttachments }] = (0, $kUI0A.useIssueAttachmentsActions)();
        const onUploadsStartFn = (payload)=>{
            // Use the time of upload as the file's createdDate.
            const createdDate = Math.floor(Date.now() / 1000); // use seconds to align with api
            const { files: files } = payload;
            files.forEach((file)=>{
                onUploadStart({
                    id: `${file.id}`,
                    createdDate: createdDate
                });
            });
            const newAttachments = files.map((file)=>({
                    filename: file.name,
                    filesize: file.size,
                    mimetype: file.type,
                    mediaApiFileId: file.id,
                    createdDate: createdDate
                }));
            // @ts-expect-error - TS2345 - Argument of type '{ filename: string; filesize: number; mimetype: string; mediaApiFileId: string; createdDate: number; }[]' is not assignable to parameter of type 'Attachment[]'.
            addNewAttachments(issueKey, newAttachments);
        };
        const onUploadEndFn = (payload)=>{
            const { file: file } = payload;
            onUploadEnd({
                id: `${file.id}`
            });
        };
        const onErrorFn = (payload)=>{
            const { error: error } = payload;
            if ([
                'upload_fail',
                'object_create_fail'
            ].includes(error.name)) onUploadError(error);
            else onGeneralError(error);
        };
        const onDragEnterFn = ()=>{
            onDragEnter();
        };
        const onDragLeaveFn = ()=>{
            onDragLeave();
        };
        const onDropFn = ()=>{
            onDrop();
        };
        // For next three events there is default implementation (ex. this.onError etc)
        // But it can be overridden. Rule is - if eventHandlers is present it value will be used (even if it's undefined)
        const onError = eventHandlers ? eventHandlers['upload-error'] : onErrorFn;
        const onUploadsStart = eventHandlers ? eventHandlers['uploads-start'] : onUploadsStartFn;
        const onEnd = eventHandlers && eventHandlers['upload-end'] ? eventHandlers['upload-end'] : onUploadEndFn;
        const onPreviewUpdate = eventHandlers && eventHandlers['upload-preview-update'];
        (0, $eUqFw.useEffect)(()=>{
            resolveUploadPromises();
        }, [
            resolveUploadPromises,
            uploadContext
        ]);
        if (!uploadContext) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MediaPickerComponent, {
            mediaClientConfig: mediaClientConfig,
            config: mediaPickerConfig,
            onUploadsStart: onUploadsStart,
            onError: onError,
            onEnd: onEnd,
            onPreviewUpdate: onPreviewUpdate,
            onDragEnter: onDragEnterFn,
            onDragLeave: onDragLeaveFn,
            onDrop: onDropFn,
            ...otherProps
        });
    };
// QUALITY:ON
function $3b7576973fb077d7$var$withMediaPickerProps(WrappedComponent) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $lqalZ.connect)((state)=>({
            uploadContext: (0, $gS8e9.mediaContextSelector)(state).uploadContext || undefined
        }), {
        onUploadStart: (0, $b2g4Y.attachmentUploadBegin),
        onUploadEnd: (0, $b2g4Y.attachmentUploadEnd),
        onUploadError: (0, $b2g4Y.attachmentUploadError),
        onGeneralError: (0, $b2g4Y.mediaPickerError),
        requestUploadToken: (0, $20th5.fetchUploadContextRequest)
    })($3b7576973fb077d7$var$withMediaPickerPropsProvider(WrappedComponent)); // eslint-disable-line @typescript-eslint/no-explicit-any
}
var $3b7576973fb077d7$export$2e2bcd8739ae039 = $3b7576973fb077d7$var$withMediaPickerProps;

});



parcelRegister("1qDwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c5432c323dbb964$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ak3LB = parcelRequire("ak3LB");
class $0c5432c323dbb964$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    getConfig() {
        return {
            container: this.props.container
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ak3LB.default), {
            config: this.getConfig(),
            onDragEnter: this.props.onDragEnter,
            onDragLeave: this.props.onDragLeave,
            onDrop: this.props.onDrop
        });
    }
}

});
parcelRegister("ak3LB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7de356c248c8241$export$2e2bcd8739ae039);

var $lqalZ = parcelRequire("lqalZ");

var $2Ef7E = parcelRequire("2Ef7E");

var $YTFAg = parcelRequire("YTFAg");
var $e7de356c248c8241$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state)=>({
        isEnabled: (0, $2Ef7E.isIssueDropzoneAndClipboardUploadEnabled)(state)
    }), {})((0, $YTFAg.CommonDropzoneMediaPicker));

});
parcelRegister("YTFAg", function(module, exports) {

$parcel$export(module.exports, "CommonDropzoneMediaPicker", () => $772a37dda558f2fa$export$82c9b9f8de7f79c7);

var $eUqFw = parcelRequire("eUqFw");

var $4ojlH = parcelRequire("4ojlH");

var $627hr = parcelRequire("627hr");
const $772a37dda558f2fa$var$WithMediaPickerDropzone = (0, $627hr.default)((0, $4ojlH.DropzoneLoader));
const $772a37dda558f2fa$export$82c9b9f8de7f79c7 = (props)=>{
    const { isEnabled: isEnabled, ...otherProps } = props;
    return isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($772a37dda558f2fa$var$WithMediaPickerDropzone, otherProps) : null;
};

});
parcelRegister("4ojlH", function(module, exports) {

$parcel$export(module.exports, "DropzoneLoader", () => $3328699cadf45e3b$export$66201d263cd6342);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");



class $3328699cadf45e3b$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            Dropzone: $3328699cadf45e3b$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $3328699cadf45e3b$export$66201d263cd6342.MediaPickerErrorBoundary
        });
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) try {
            const [mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule] = await Promise.all([
                (parcelRequire("eSP44")),
                (parcelRequire("3pRhH")),
                (parcelRequire("e7ea3"))
            ]);
            $3328699cadf45e3b$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $3328699cadf45e3b$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $3328699cadf45e3b$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $3328699cadf45e3b$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        } catch (error) {
        // TODO [MS-2272]: Add operational error to catch async import error
        }
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MediaPickerErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Dropzone, this.props));
    }
}
(0, $5zQU9.default)($3328699cadf45e3b$export$66201d263cd6342, "displayName", 'AsyncDropzone');

});
parcelRegister("3pRhH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1DCvF');
        const value = parcelRequire('lWI9J');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1DCvF").then(()=>parcelRequire('lWI9J'));
}

});

parcelRegister("e7ea3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('3bdxk')
        ]);
        const value = parcelRequire('abMUk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("3bdxk")
    ]).then(()=>parcelRequire('abMUk'));
}

});





parcelRegister("jllyX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d52837e8cf915dd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8UmzQ = parcelRequire("8UmzQ");
const $9d52837e8cf915dd$export$bdffe701de842ea5 = (props)=>{
    const { eventHandlers: eventHandlers } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8UmzQ.default), {
        eventHandlers: eventHandlers
    });
};
var $9d52837e8cf915dd$export$2e2bcd8739ae039 = $9d52837e8cf915dd$export$bdffe701de842ea5;

});
parcelRegister("8UmzQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ed7153a86235570$export$2e2bcd8739ae039);

var $lqalZ = parcelRequire("lqalZ");

var $1v6Su = parcelRequire("1v6Su");

var $jDl0t = parcelRequire("jDl0t");

var $jaGmy = parcelRequire("jaGmy");
var $3ed7153a86235570$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state)=>({
        isOpen: (0, $jDl0t.isAttachmentPickerPopupOpenSelector)(state)
    }), {
    onClose: (0, $1v6Su.attachmentPickerPopupCloseSuccess)
})((0, $jaGmy.default));

});
parcelRegister("jaGmy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e76b52a1597b4e07$export$2e2bcd8739ae039);

var $9kcyO = parcelRequire("9kcyO");

var $627hr = parcelRequire("627hr");
const $e76b52a1597b4e07$export$e674ac6c0a5dedae = (0, $627hr.default)((0, $9kcyO.BrowserLoader));
var $e76b52a1597b4e07$export$2e2bcd8739ae039 = $e76b52a1597b4e07$export$e674ac6c0a5dedae;

});
parcelRegister("9kcyO", function(module, exports) {

$parcel$export(module.exports, "BrowserLoader", () => $6c9fb98c03738758$export$3ce634ac4a869e2c);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");


class $6c9fb98c03738758$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "mounted", false);
        (0, $5zQU9.default)(this, "state", {
            Browser: $6c9fb98c03738758$export$3ce634ac4a869e2c.Browser
        });
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Browser) {
            const [mediaClient, browserModule] = await Promise.all([
                (parcelRequire("eSP44")),
                (parcelRequire("3lmOQ"))
            ]);
            $6c9fb98c03738758$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $6c9fb98c03738758$export$3ce634ac4a869e2c.Browser
            });
        }
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(this.state.Browser, this.props);
    }
}
(0, $5zQU9.default)($6c9fb98c03738758$export$3ce634ac4a869e2c, "displayName", 'AsyncBrowser');

});
parcelRegister("3lmOQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('i0M3k');
        const value = parcelRequire('3MYft');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("i0M3k").then(()=>parcelRequire('3MYft'));
}

});





parcelRegister("8JLUS", function(module, exports) {

$parcel$export(module.exports, "default", () => $12085098def616e5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $guDY0 = parcelRequire("guDY0");

var $aa9eq = parcelRequire("aa9eq");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$12085098def616e5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aa9eq.default), {
        render: (eventHandlers)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $guDY0.default), {
                eventHandlers: eventHandlers
            })
    });

});
parcelRegister("aa9eq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1381295ddd7c3a0$export$2e2bcd8739ae039);

var $lqalZ = parcelRequire("lqalZ");

var $lkPj1 = parcelRequire("lkPj1");

var $gS8e9 = parcelRequire("gS8e9");


var $12pWo = parcelRequire("12pWo");
var $d1381295ddd7c3a0$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state)=>({
        uploadContext: (0, $gS8e9.mediaContextSelector)(state).uploadContext,
        projectType: state.entities.project?.projectType
    }), (dispatch)=>({
        onEditCommentUpdate: (value)=>{
            // Attachments go into a new Service Desk internal comment by default
            dispatch((0, $lkPj1.changeCommentVisibility)((0, $b10b5cb385fb5d46$export$c4134c813c47beb0), true));
            dispatch((0, $lkPj1.editCommentUpdate)((0, $b10b5cb385fb5d46$export$c4134c813c47beb0), value));
        },
        setCommentAttachmentInProgress: (isInProgress)=>dispatch((0, $lkPj1.setCommentAttachmentInProgress)(isInProgress))
    }))((0, $12pWo.default));

});
parcelRegister("12pWo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dc70b698b506f8d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8i1R8 = parcelRequire("8i1R8");

var $9BtCH = parcelRequire("9BtCH");

var $a0i0f = parcelRequire("a0i0f");

var $lUFEu = parcelRequire("lUFEu");

var $8Eye5 = parcelRequire("8Eye5");
var $bk89g = parcelRequire("bk89g");
var $2JINt = parcelRequire("2JINt");
var $8gFrN = parcelRequire("8gFrN");
var $5RBN8 = parcelRequire("5RBN8");

var $gUUjF = parcelRequire("gUUjF");

var $JRB5w = parcelRequire("JRB5w");

var $4ceCM = parcelRequire("4ceCM");

var $4VjGY = parcelRequire("4VjGY");

var $8QMfM = parcelRequire("8QMfM");
const $8dc70b698b506f8d$export$7271276960377470 = 'issue.issue-base.content.attachment.picker.servicedesk';
const $8dc70b698b506f8d$var$getAndStartUFOExperience = (fileId)=>{
    const experience = (0, $8QMfM.concurrentAttachmentUploadExperience).getInstance(fileId);
    experience.start();
    return experience;
};
class $8dc70b698b506f8d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { render: render } = this.props;
        return render(this.eventHandlers);
    }
    constructor(...args){
        super(...args);
        this.onUploadsStart = ({ files: files })=>{
            this.props.setCommentAttachmentInProgress(true);
            this.commentAttachments = files.map((file)=>({
                    file: file,
                    isUploadFinished: false,
                    ufoExperience: $8dc70b698b506f8d$var$getAndStartUFOExperience(file.id)
                }));
        };
        this.onUploadFinished = ({ file: file })=>{
            this.commentAttachments?.filter((comment)=>comment.file.id === file.id).forEach((comment)=>comment.ufoExperience.success());
            this.injectAttachmentsToCommentEditor(this.commentAttachments);
            this.markAttachmentAsUploadFinished(file.id);
            (0, $4ceCM.sendExperienceAnalytics)((0, $4VjGY.commentAttachmentExperienceDescription)({
                wasSuccessful: true,
                action: 'ATTACH',
                analyticsSource: 'servicedeskAttachmentPicker',
                projectType: this.props.projectType
            }));
        };
        this.onUploadError = ({ fileId: fileId, error: error })=>{
            this.commentAttachments?.filter((comment)=>comment.file.id === fileId).forEach((comment)=>comment.ufoExperience.failure());
            (0, $gUUjF.default).safeErrorWithoutCustomerData($8dc70b698b506f8d$export$7271276960377470, 'Failed to upload an attachment.', error.rawError || new Error(error.description));
            this.markAttachmentAsUploadFinished(fileId);
            const secondaryReason = error.description;
            const wasClientFetchError = secondaryReason === 'serverUnexpectedError' && error.rawError ? (0, $JRB5w.isClientFetchError)({
                name: 'Error',
                message: error.rawError?.message
            }) : false;
            if (!wasClientFetchError) {
                const primaryReason = error.name;
                const wasSuccessful = [
                    'clientAbortedRequest',
                    'serverUnauthorized',
                    'serverForbidden',
                    'serverNotFound',
                    'serverRateLimited',
                    'serverBadGateway',
                    'failedAuthProvider',
                    'tokenExpired',
                    'invalidFileId',
                    'zeroVersionFile'
                ].includes(secondaryReason);
                (0, $4ceCM.sendExperienceAnalytics)((0, $4VjGY.commentAttachmentExperienceDescription)({
                    wasSuccessful: wasSuccessful,
                    action: 'ATTACH',
                    analyticsSource: 'servicedeskAttachmentPicker',
                    projectType: this.props.projectType,
                    errorMessage: wasSuccessful ? undefined : `${primaryReason} - ${secondaryReason}`
                }));
            }
        };
        this.getAttachmentsDocNode = (commentAttachments, collection)=>{
            const attachments = this.separateImageAndNonImageAttachments(commentAttachments);
            const imageAttachmentNodes = this.getMediaSingleNodes(attachments.images, collection);
            const nonImageAttachmentGroup = attachments.nonImages.length > 0 ? this.getMediaGroupNode(attachments.nonImages, collection) : null;
            return nonImageAttachmentGroup ? (0, $8Eye5.doc)(nonImageAttachmentGroup, ...imageAttachmentNodes, (0, $5RBN8.paragraph)()) : (0, $8Eye5.doc)(...imageAttachmentNodes, (0, $5RBN8.paragraph)());
        };
        this.getMediaSingleNodes = (commentAttachments, collection)=>commentAttachments.map((commentAttachment)=>this.getMediaSingleNode(commentAttachment, collection));
        this.getMediaSingleNode = (commentAttachment, collection)=>{
            const mediaNode = this.getMediaNode(commentAttachment, 200, 200, collection);
            return (0, $8gFrN.mediaSingle)({
                layout: 'center'
            })(mediaNode);
        };
        this.getMediaGroupNode = (commentAttachments, collection)=>(0, $2JINt.mediaGroup)(...commentAttachments.map((commentAttachment)=>this.getMediaNode(commentAttachment, null, null, collection)));
        this.getMediaNode = ({ file: file }, width, height, collection)=>(0, $bk89g.media)({
                id: file.id,
                collection: collection,
                type: 'file',
                name: file.name,
                size: file.size,
                width: // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number | undefined'.
                width,
                height: // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number | undefined'.
                height,
                __key: file.id,
                __fileName: file.name,
                __fileSize: file.size,
                __fileMimeType: file.type,
                __displayType: null
            });
        /**
	 * To prevent users from failing to save comments, we need to wait until all of the attachments have finished
	 * uploading before allowing users to save the comment. In the mean time the users will see a disabled comment
	 * editor with a spinner indicating the attachments are being uploaded.
	 *
	 * Due to the way how the `upload-end` event works, it is triggered on each attachment not all of them, we need to
	 * keep track of the status of each attachment individually.
	 */ this.markAttachmentAsUploadFinished = (fileId)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(// @ts-expect-error - TS2769 - No overload matches this call.
            (0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(this.commentAttachments, (attachment)=>attachment.file.id === fileId), 'isUploadFinished', true);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($lUFEu)))(this.commentAttachments, {
                isUploadFinished: false
            })) {
                this.props.setCommentAttachmentInProgress(false);
                this.commentAttachments = [];
            }
        };
        this.separateImageAndNonImageAttachments = (commentAttachments)=>(0, (/*@__PURE__*/$parcel$interopDefault($9BtCH)))(commentAttachments, (result, commentAttachment)=>{
                if (this.isImageAttachment(commentAttachment.file.type)) // @ts-expect-error - TS2345 - Argument of type 'CommentAttachment' is not assignable to parameter of type 'never'.
                result.images.push(commentAttachment);
                else // @ts-expect-error - TS2345 - Argument of type 'CommentAttachment' is not assignable to parameter of type 'never'.
                result.nonImages.push(commentAttachment);
                return result;
            }, {
                images: [],
                nonImages: []
            });
        this.injectAttachmentsToCommentEditor = (commentAttachments)=>{
            const { uploadContext: uploadContext } = this.props;
            if (!uploadContext) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData($8dc70b698b506f8d$export$7271276960377470, 'Failed to upload attachments. Upload context not available.', new Error('Failed to upload attachments. Upload context not available.'));
                return;
            }
            const attachmentsDocNode = this.getAttachmentsDocNode(commentAttachments, uploadContext.collection);
            this.props.onEditCommentUpdate(attachmentsDocNode);
        };
        this.isImageAttachment = (fileType)=>!!fileType && (fileType.indexOf('image/') > -1 || fileType.indexOf('video/') > -1);
        // Service Desk issue has a different way to attach files, every new attachments should go into a new comment.
        // @ts-expect-error - TS2741 - Property '['upload-preview-update']' is missing in type '{ 'uploads-start': ({ files }: UploadsStartEventPayload) => void; 'upload-end': ({ file }: UploadEndEventPayload | UploadPreviewUpdateEventPayload) => void; 'upload-error': ({ fileId, error }: UploadErrorEventPayload) => void; }' but required in type 'EventHandlers'.
        this.eventHandlers = {
            'uploads-start': this.onUploadsStart,
            'upload-end': this.onUploadFinished,
            'upload-error': this.onUploadError
        };
    }
}

});
parcelRegister("9BtCH", function(module, exports) {

var $flmMe = parcelRequire("flmMe");

var $awetI = parcelRequire("awetI");

var $7qARj = parcelRequire("7qARj");

var $jhbYY = parcelRequire("jhbYY");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $6fde8c506e131c3e$var$reduce(collection, iteratee, accumulator) {
    var func = $1c8hB(collection) ? $flmMe : $jhbYY, initAccum = arguments.length < 3;
    return func(collection, $7qARj(iteratee, 4), accumulator, initAccum, $awetI);
}
module.exports = $6fde8c506e131c3e$var$reduce;

});
parcelRegister("jhbYY", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $e088e655a3a9a31d$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $e088e655a3a9a31d$var$baseReduce;

});


parcelRegister("lUFEu", function(module, exports) {

var $jqs7R = parcelRequire("jqs7R");

var $7qARj = parcelRequire("7qARj");

var $8v3yf = parcelRequire("8v3yf");

var $1c8hB = parcelRequire("1c8hB");

var $3P7i5 = parcelRequire("3P7i5");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $ff3f232f92bb24aa$var$some(collection, predicate, guard) {
    var func = $1c8hB(collection) ? $jqs7R : $8v3yf;
    if (guard && $3P7i5(collection, predicate, guard)) predicate = undefined;
    return func(collection, $7qARj(predicate, 3));
}
module.exports = $ff3f232f92bb24aa$var$some;

});
parcelRegister("8v3yf", function(module, exports) {

var $awetI = parcelRequire("awetI");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $6303f9332a27a1b4$var$baseSome(collection, predicate) {
    var result;
    $awetI(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $6303f9332a27a1b4$var$baseSome;

});


parcelRegister("bk89g", function(module, exports) {

$parcel$export(module.exports, "media", () => $83e7e217b9d3af7b$export$987d49ffe1b0900f);
const $83e7e217b9d3af7b$export$987d49ffe1b0900f = (attrs)=>({
        type: 'media',
        attrs: attrs
    });

});

parcelRegister("2JINt", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $1fe2887676b73d45$export$2855e964765eac9);
const $1fe2887676b73d45$export$2855e964765eac9 = (...content)=>({
        type: 'mediaGroup',
        content: content
    });

});

parcelRegister("8gFrN", function(module, exports) {

$parcel$export(module.exports, "mediaSingle", () => $604ff7f390c51fc9$export$969fe3781ca15058);
const $604ff7f390c51fc9$export$969fe3781ca15058 = (attrs)=>(content)=>({
            type: 'mediaSingle',
            attrs: attrs,
            content: Array.isArray(content) ? content : [
                content
            ]
        });

});

parcelRegister("8QMfM", function(module, exports) {

$parcel$export(module.exports, "concurrentAttachmentUploadExperience", () => $15a2c07477d43056$export$b1d6ddba7f32f38e);

var $kKufC = parcelRequire("kKufC");
var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $15a2c07477d43056$export$81dc27009475be16 = new (0, $kDfSL.UFOExperience)('jsm-issue-view-attachments-upload-credentials', {
    type: (0, $12kyE.ExperienceTypes).Operation,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom
});
const $15a2c07477d43056$export$adee91c4259f250d = new (0, $kDfSL.UFOExperience)('jsm-issue-view-attachments-read-credentials', {
    type: (0, $12kyE.ExperienceTypes).Operation,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom
});
const $15a2c07477d43056$export$b1d6ddba7f32f38e = new (0, $kKufC.ConcurrentExperience)('jsm-issue-view-attachments-upload', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $15a2c07477d43056$export$6f61a7e606078a4d = new (0, $kDfSL.UFOExperience)('jsm-activity-items', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});

});
parcelRegister("kKufC", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $6f4caa03da77f42b$export$ac1cddfee07ba6ac);

var $L0eva = parcelRequire("L0eva");

var $kDfSL = parcelRequire("kDfSL");
class $6f4caa03da77f42b$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $kDfSL.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $L0eva.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});





parcelRegister("6xmPx", function(module, exports) {

$parcel$export(module.exports, "default", () => $579c26cfea0783c0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ak3LB = parcelRequire("ak3LB");

var $aa9eq = parcelRequire("aa9eq");
class $579c26cfea0783c0$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    getConfig() {
        return {
            container: this.props.container
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aa9eq.default), {
            render: (eventHandlers)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ak3LB.default), {
                    config: this.getConfig(),
                    onDragEnter: this.props.onDragEnter,
                    onDragLeave: this.props.onDragLeave,
                    onDrop: this.props.onDrop,
                    eventHandlers: eventHandlers
                })
        });
    }
}

});

parcelRegister("lJygS", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b9ef59b3672715$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jllyX = parcelRequire("jllyX");

var $aa9eq = parcelRequire("aa9eq");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$23b9ef59b3672715$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aa9eq.default), {
        render: (eventHandlers)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jllyX.default), {
                eventHandlers: eventHandlers
            })
    });

});

parcelRegister("Qe471", function(module, exports) {

$parcel$export(module.exports, "default", () => $46faed7f7228c018$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $e91YZ = parcelRequire("e91YZ");

var $4ceCM = parcelRequire("4ceCM");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");
class $46faed7f7228c018$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.didMount = false;
        this.state = {
            noErrorsAfterTimeout: false,
            caughtError: false
        };
    }
    componentDidMount() {
        // This trigger is specifically needed for the case where isReady is true on first mount.
        // Otherwise, all SLA event logic is handled by shouldComponentUpdate.
        if (this.props.isReady) setTimeout(()=>{
            this.setState({
                noErrorsAfterTimeout: true
            });
        }, 1000);
        // This will trigger on every remount to ensure that this comoponent properly rerenders once
        this.didMount = true;
    }
    /*
        This lifecycle function controls the sending of Add Attachment Frontend SLA events based
        on whether its children (some of which are media deps) render successfully. The complexity
        here is because:
        - Errors are caught asynchronously
        - We only want to send a single SLA event per "conceptual" render
        The only time we want to re-render the component is if we do catch an error, in which case
        we swap out all the children for a null so as not to break the rest of the Issue View.
     */ shouldComponentUpdate(nextProps, nextState) {
        if (nextState.caughtError) return true;
        const justMadeTimeoutWithNoErrors = !this.state.noErrorsAfterTimeout && nextState.noErrorsAfterTimeout;
        if (justMadeTimeoutWithNoErrors) {
            const { experience: experience, analyticsSource: analyticsSource } = this.props;
            const { application: application, edition: edition } = this.getApplicationAndEdition();
            (0, $4ceCM.sendExperienceAnalytics)({
                experience: experience,
                wasExperienceSuccesful: true,
                analyticsSource: analyticsSource,
                application: application,
                edition: edition
            });
            return false;
        }
        const hasJustBecomeReady = !this.props.isReady && nextProps.isReady || this.didMount;
        if (hasJustBecomeReady) {
            setTimeout(()=>{
                this.setState({
                    noErrorsAfterTimeout: true
                });
            }, 1000);
            this.didMount = false;
            return true;
        }
        return false;
    }
    componentDidCatch(error) {
        const { experience: experience, analyticsSource: analyticsSource } = this.props;
        const { application: application, edition: edition } = this.getApplicationAndEdition();
        (0, $4ceCM.sendExperienceAnalytics)({
            experience: experience,
            wasExperienceSuccesful: false,
            analyticsSource: analyticsSource,
            application: application,
            edition: edition,
            additionalAttributes: {
                errorMessage: error.message || 'unknown'
            }
        });
        this.setState({
            caughtError: true
        });
    }
    getApplicationAndEdition() {
        const { projectType: projectType } = this.props;
        if (projectType == null) return {
            application: null,
            edition: null
        };
        const application = (0, $eIp1n.getApplicationForProject)(projectType);
        const tenantContext = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE) && (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
        const appEditions = tenantContext && tenantContext.appEditions;
        const edition = appEditions ? (0, $6WXNs.getEdition)(application, appEditions) : null;
        return {
            application: application,
            edition: edition
        };
    }
    render() {
        const { caughtError: caughtError } = this.state;
        if (caughtError) return null;
        return this.props.children;
    }
}

});

parcelRegister("aMswy", function(module, exports) {

$parcel$export(module.exports, "trackLoadedIssueView", () => $0e5b413fe0804f0f$export$3508feb1eec11524);

var $jUhyG = parcelRequire("jUhyG");

var $gUUjF = parcelRequire("gUUjF");
const $0e5b413fe0804f0f$export$3508feb1eec11524 = (analyticsEvent, ratio)=>{
    const eventPayload = {
        action: 'viewed',
        attributes: {
            ...ratio === null ? {} : {
                issueDetailsSidebarRatio: ratio
            }
        }
    };
    try {
        (0, $jUhyG.fireTrackAnalytics)(analyticsEvent, eventPayload);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.viewed', error.message, error);
    }
};

});

parcelRegister("brT9q", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4e1a0d98c05c268$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lSV8Z = parcelRequire("lSV8Z");
var $2EVgw = parcelRequire("2EVgw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $e73Bj = parcelRequire("e73Bj");

var $kxLrg = parcelRequire("kxLrg");
const $d4e1a0d98c05c268$var$animationDuration = 800;
const $d4e1a0d98c05c268$var$DropzoneOverlay = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), {
        appear: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2EVgw.default), {
        enterFrom: "bottom",
        fade: "inout",
        duration: $d4e1a0d98c05c268$var$animationDuration
    }, (animateProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4e1a0d98c05c268$var$IssueBodyContainerDropzonePopup, animateProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4e1a0d98c05c268$var$Image, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($e73Bj))),
            alt: formatMessage((0, $kxLrg.messages).uploadImage)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4e1a0d98c05c268$var$TextContainer, null, formatMessage((0, $kxLrg.messages).upload)))));
};
var $d4e1a0d98c05c268$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d4e1a0d98c05c268$var$DropzoneOverlay;
const $d4e1a0d98c05c268$var$IssueBodyContainerDropzonePopup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _kqswstnw _1bsb12aa _4t3ivbgk _94n5xncg _1pbyjwwv _11q7hp5a _16qsng4a _2rko1l7b _1xi2idpf _1ltvidpf _18u01wug _2hwx1wug _1bumglyw _sedtglyw",
            __cmplp.className
        ])
    });
});
const $d4e1a0d98c05c268$var$TextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbntd2 _1wyb7vkz _k48pbfng _vwz4gktf _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d4e1a0d98c05c268$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i8ed9 _1yt4ie5z",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e73Bj", function(module, exports) {
module.exports = new URL("upload.7b4a5dd5.svg", import.meta.url).toString();

});

parcelRegister("kxLrg", function(module, exports) {

$parcel$export(module.exports, "messages", () => $48d6e1b824ef6406$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $48d6e1b824ef6406$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    upload: {
        "id": "issue.attachment-dropzone-message",
        "defaultMessage": "Drop file anywhere to upload to this issue"
    },
    uploadImage: {
        "id": "issue.attachment-dropzone-message-image",
        "defaultMessage": "Upload Attachment"
    }
});

});


parcelRegister("3PPRL", function(module, exports) {

$parcel$export(module.exports, "getPerformanceTrackingConfiguration", () => $d1652657ea613d40$export$78dd97cfaffb6fb1);
$parcel$export(module.exports, "getValidTransactionsTrackingConfiguration", () => $d1652657ea613d40$export$a801da94b6dd586b);
$parcel$export(module.exports, "isEditorUFOEnabled", () => $d1652657ea613d40$export$fd99e03c299972d3);
$parcel$export(module.exports, "getEnableFlexibleBlockCardInIssueEditor", () => $d1652657ea613d40$export$408491224a0c915b);
$parcel$export(module.exports, "isJiraIssueViewEditorAIEnabled", () => $d1652657ea613d40$export$183bff9fcee964a2);
$parcel$export(module.exports, "isMediaInlineEnabled", () => $d1652657ea613d40$export$a3e5d5dfe1ed90ed);
$parcel$export(module.exports, "INVITE_PROMPT_ON_LINK_INSERT", () => $d1652657ea613d40$export$4212fcd2a914820a);
$parcel$export(module.exports, "isInviteOnLinkInsertEnrolled", () => $d1652657ea613d40$export$14e30c25a2e3cf29);
$parcel$export(module.exports, "INVITE_PROMPT_ON_LINK_INSERT_V2", () => $d1652657ea613d40$export$6da7477ef7936f33);
$parcel$export(module.exports, "isInviteOnLinkInsertV2Enrolled", () => $d1652657ea613d40$export$9a3a87296d38a646);
$parcel$export(module.exports, "isThirdPartyNudgeEnrolled", () => $d1652657ea613d40$export$210b4c0aeb384754);
$parcel$export(module.exports, "isNewLinkPickerEnabled", () => $d1652657ea613d40$export$ae2025957f2940e4);
$parcel$export(module.exports, "isLinkCreateExtensionEnabled", () => $d1652657ea613d40$export$1b84fec141e29939);
$parcel$export(module.exports, "isDevOpsAppRecommenderEnabled", () => $d1652657ea613d40$export$882e8ff421f7744c);
$parcel$export(module.exports, "getJiraIssuesDatasourceEnabled", () => $d1652657ea613d40$export$1c607d9b866655e1);

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");
const $d1652657ea613d40$export$78dd97cfaffb6fb1 = ()=>(0, $1ybV0.getFeatureFlagValue)('issue.details.editor.performance-tracking', {});
const $d1652657ea613d40$export$a801da94b6dd586b = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const value = (0, $1ybV0.getFeatureFlagValue)('issue.details.editor.valid-transactions-tracking', {});
    // workaround as editor is interpreting an empty object as enabled: https://product-fabric.atlassian.net/browse/ED-12432
    const enabled = typeof value === 'object' && Object.keys(value).length;
    return enabled ? value : undefined;
};
const $d1652657ea613d40$export$fd99e03c299972d3 = ()=>(0, $1ybV0.ff)('issue.details.editor.ufo', false);
const $d1652657ea613d40$export$408491224a0c915b = ()=>(0, $1ybV0.ff)('issue.details.editor.enable-flexible-block-card');
const $d1652657ea613d40$export$f3b4976ced451be8 = 'issue.details.jira-issue-view-editor-ai_sozy';
const $d1652657ea613d40$export$183bff9fcee964a2 = ()=>(0, $1ybV0.ff)($d1652657ea613d40$export$f3b4976ced451be8, false);
const $d1652657ea613d40$export$a3e5d5dfe1ed90ed = ()=>(0, $1ybV0.ff)('issue.details.media-inline', false);
const $d1652657ea613d40$export$4212fcd2a914820a = 'invite_prompt_on_link_insert';
const $d1652657ea613d40$export$14e30c25a2e3cf29 = ()=>{
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('invite_prompt_on_link_insert');
    const cohort = expConfig.get('cohort', 'not-enrolled');
    return cohort !== 'not-enrolled';
};
const $d1652657ea613d40$export$6da7477ef7936f33 = 'invite_prompt_on_link_insert_v2';
const $d1652657ea613d40$export$9a3a87296d38a646 = ()=>{
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('invite_prompt_on_link_insert_v2');
    const cohort = expConfig.get('cohort', 'not-enrolled');
    return cohort !== 'not-enrolled';
};
const $d1652657ea613d40$export$f67e890ae36d7107 = 'statsig-guard-third-party-nudge';
const $d1652657ea613d40$var$isThirdPartyNudgeStatsigGuardEnabled = ()=>(0, $1ybV0.ff)($d1652657ea613d40$export$f67e890ae36d7107, false);
const $d1652657ea613d40$export$210b4c0aeb384754 = ()=>{
    const isThirdPartyNudgeExperimentEnrolled = ()=>{
        if (!(0, $eI5EY.fg)('statsig-guard-third-party-nudge')) return false;
        const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('third_party_app_nudge_on_after_jira_comment');
        const cohort = expConfig.get('cohort', 'not-enrolled');
        return [
            'cohort',
            'variation'
        ].includes(cohort);
    };
    return $d1652657ea613d40$var$isThirdPartyNudgeStatsigGuardEnabled() && isThirdPartyNudgeExperimentEnrolled();
};
const $d1652657ea613d40$export$348d41ed6d5ca7b8 = 'platform.linking-platform.link-picker_tgrho';
const $d1652657ea613d40$export$ae2025957f2940e4 = ()=>(0, $1ybV0.ff)('platform.linking-platform.link-picker_tgrho', false);
const $d1652657ea613d40$export$358eef86d1807ae2 = 'platform.linking-platform.link-create-extension_e6gj3';
const $d1652657ea613d40$export$1b84fec141e29939 = ()=>(0, $1ybV0.ff)('platform.linking-platform.link-create-extension_e6gj3', false);
const $d1652657ea613d40$export$882e8ff421f7744c = ()=>(0, $1ybV0.ff)('devops_app_recommendation_on_link_paste', false) && (0, $79xbN.expValEquals)('devops_app_recommendation_on_link_paste', 'cohort', 'variation');
const $d1652657ea613d40$export$1c607d9b866655e1 = ()=>(0, $1ybV0.ff)('platform.linking-platform.datasource-jira_issues', false);

});
parcelRegister("eI5EY", function(module, exports) {

$parcel$export(module.exports, "fg", () => $010af7f17578702e$export$b40ec24ac8275656);

var $i49pH = parcelRequire("i49pH");

var $9bn72 = parcelRequire("9bn72");

var $3WQZN = parcelRequire("3WQZN");
const $010af7f17578702e$export$b40ec24ac8275656 = (gateName)=>{
    // Handle vendorless scripts use of gates
    (0, $9bn72.UNSAFE_initIfNeeded)();
    const value = (0, $i49pH.default).checkGate(gateName);
    (0, $3WQZN.addFeatureFlagAccessed)(gateName, value);
    return value;
};

});


parcelRegister("2EJOy", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fa737dedad650c2$export$2e2bcd8739ae039);
// JIV-16397: Remove this entire file when cleaning up issue-view-remove-connect-operations-from-critical-fetch_vtk4w
// This component does nothing as of this PR:
// https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/pull-requests/65914/diff#src%2Fpackages%2Fissue%2Fissue-view%2Fsrc%2Fviews%2Fissue-base%2Fecosystem%2Fecosystem-analytics-view.js

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $jG2Eu = parcelRequire("jG2Eu");

var $wKt79 = parcelRequire("wKt79");

var $lqalZ = parcelRequire("lqalZ");

var $8CSFK = parcelRequire("8CSFK");

var $cj1Xt = parcelRequire("cj1Xt");
class $5fa737dedad650c2$export$889de165ac4c8e56 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            ecosystemLoadedAnalytics: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    componentDidMount() {
        this.fireAnalytics();
    }
    componentDidUpdate() {
        this.fireAnalytics();
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.fireAnalytics = ()=>{
            const { glances: glances, contentPanels: contentPanels, activityPanels: activityPanels, operations: operations, ecosystemCustomFieldIds: ecosystemCustomFieldIds } = this.props;
            this.props.ecosystemLoadedAnalytics?.(glances, contentPanels, activityPanels, operations, ecosystemCustomFieldIds.length);
        };
    }
}
const $5fa737dedad650c2$export$ba59f7815f093256 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $lqalZ.connect)((state)=>({
        glances: (0, $8CSFK.ecosystemGlancesSelector)(state),
        contentPanels: (0, $8CSFK.ecosystemAllPanelsSelector)(state),
        activityPanels: (0, $8CSFK.activityPanelsSelector)(state),
        operations: (0, $8CSFK.ecosystemOperationsSelector)(state),
        ecosystemCustomFieldIds: (0, $cj1Xt.ecosystemCustomFieldIdsSelector)(state)
    }), {}), (0, $wKt79.safeComponent)())($5fa737dedad650c2$export$889de165ac4c8e56);
var $5fa737dedad650c2$export$2e2bcd8739ae039 = $5fa737dedad650c2$export$ba59f7815f093256;

});

parcelRegister("dE4GY", function(module, exports) {

$parcel$export(module.exports, "default", () => $df082ce6a8659d1b$export$2e2bcd8739ae039);
/* ecosystem-background-scripts-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gUUjF = parcelRequire("gUUjF");

var $4lxPQ = parcelRequire("4lxPQ");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $hJ992 = parcelRequire("hJ992");

var $5a07k = parcelRequire("5a07k");

var $dLpFo = parcelRequire("dLpFo");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $8CSFK = parcelRequire("8CSFK");

var $haEFN = parcelRequire("haEFN");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df082ce6a8659d1b$var$BackgroundScriptsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});
class $df082ce6a8659d1b$export$84984b0510126e6d extends (0, $eUqFw.Component) {
    componentDidMount() {
        (0, $4lxPQ.withConnectHost)((connectHost)=>this.setState({
                connectHost: connectHost
            }));
    }
    render() {
        const { connectHost: connectHost } = this.state;
        const { scripts: scripts } = this.props;
        return connectHost ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df082ce6a8659d1b$var$BackgroundScriptsContainer, null, scripts.map(({ appKey: appKey, moduleKey: moduleKey, options: options, shouldReloadOnRefresh: shouldReloadOnRefresh })=>{
            const EcosystemModule = shouldReloadOnRefresh ? (0, $haEFN.default) : (0, $haEFN.EcosystemModuleWithoutRefresh);
            const key = `${appKey}-${moduleKey}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(EcosystemModule, {
                key: key,
                appKey: appKey,
                moduleKey: moduleKey,
                options: options,
                appName: key,
                location: "issueViewBackgroundScript"
            });
        })) : null;
    }
    constructor(...args){
        super(...args);
        this.state = {
            connectHost: null
        };
    }
}
const $df082ce6a8659d1b$var$ConnectBackgroundScriptsWithProps = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        scripts: (0, $8CSFK.ecosystemBackgroundScriptsSelector)(state)
    }), {}))($df082ce6a8659d1b$export$84984b0510126e6d);
const $df082ce6a8659d1b$export$c5a61bc406005613 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ value: scripts, isReady: isReady }] = (0, $dLpFo.default)(issueKey);
    const [connectHost, setConnectHost] = (0, $eUqFw.useState)((0, $4lxPQ.getConnectHost)());
    (0, $eUqFw.useEffect)(()=>{
        if (!connectHost) {
            (0, $gUUjF.default).safeInfoWithoutCustomerData('issue.ecosystem.background.scripts', 'Delayed initialization of ecosystem background scripts');
            (0, $4lxPQ.withConnectHost)((host)=>setConnectHost(host));
        }
    }, [
        connectHost
    ]);
    return connectHost && isReady ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df082ce6a8659d1b$var$BackgroundScriptsContainer, null, scripts.map(({ appKey: appKey, moduleKey: moduleKey, options: options, shouldReloadOnRefresh: shouldReloadOnRefresh })=>{
        const EcosystemModule = shouldReloadOnRefresh ? (0, $haEFN.default) : (0, $haEFN.EcosystemModuleWithoutRefresh);
        const key = `${appKey}-${moduleKey}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(EcosystemModule, {
            key: key,
            appKey: appKey,
            moduleKey: moduleKey,
            options: options,
            appName: key,
            location: "issueViewBackgroundScript"
        });
    })) : null;
};
const $df082ce6a8659d1b$var$EcosystemBackgroundScriptsViewWrapper = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on'), $df082ce6a8659d1b$export$c5a61bc406005613, $df082ce6a8659d1b$var$ConnectBackgroundScriptsWithProps);
const $df082ce6a8659d1b$var$PreventUnstableRender = ({ children: children })=>{
    // TODO: reconsider placement of this check. It might be better to move it a level above to IssueView.isComplete
    const issueId = (0, $hJ992.useIssueId)(); // note: issueKey is stable during transition, but issueId is not
    // hold rendering until issueKey is set
    return issueId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$df082ce6a8659d1b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df082ce6a8659d1b$var$PreventUnstableRender, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5a07k.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df082ce6a8659d1b$var$EcosystemBackgroundScriptsViewWrapper, null));

});
parcelRegister("4lxPQ", function(module, exports) {

$parcel$export(module.exports, "withConnectHost", () => $74a29a4beb89f78b$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $74a29a4beb89f78b$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $74a29a4beb89f78b$export$920fb4b46d4f2eec);

var $3X4Tl = parcelRequire("3X4Tl");
const $74a29a4beb89f78b$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $3X4Tl.setupConnectJs)();
    action(connectHost);
};
const $74a29a4beb89f78b$export$186d423c00af146c = ()=>window.connectHost;
const $74a29a4beb89f78b$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("3X4Tl", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $e1d87b293e6b1fa3$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");

var $8nDwh = parcelRequire("8nDwh");

const $e1d87b293e6b1fa3$var$installConnectJs = async ()=>{
    await (0, $8nDwh.waitForJQuery)();
    const loader = await (parcelRequire("ds7fh"));
    await loader.performSideEffects();
    return window.connectHost;
};
let $e1d87b293e6b1fa3$var$installConnectJsPromise = null;
const $e1d87b293e6b1fa3$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    if (window.__SPA__) {
        if ($e1d87b293e6b1fa3$var$installConnectJsPromise === null) $e1d87b293e6b1fa3$var$installConnectJsPromise = $e1d87b293e6b1fa3$var$installConnectJs();
        return $e1d87b293e6b1fa3$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $2BvS3.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    return window.connectHost;
};

});
parcelRegister("8nDwh", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $57c59c350a2284e3$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $57c59c350a2284e3$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $57c59c350a2284e3$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $57c59c350a2284e3$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $57c59c350a2284e3$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $57c59c350a2284e3$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $57c59c350a2284e3$export$d690da9bc8146677);

var $guiFP = parcelRequire("guiFP");

var $8n8Xw = parcelRequire("8n8Xw");
const $57c59c350a2284e3$export$c47913ca32a5c6f7 = (key)=>{
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $57c59c350a2284e3$export$7232a6dc780f9887 = ()=>AJS.$;
const $57c59c350a2284e3$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public atlassian-connect-js library.
    window._AP;
const $57c59c350a2284e3$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $57c59c350a2284e3$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $57c59c350a2284e3$var$FIVE_MINUTES = 300000;
const $57c59c350a2284e3$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $guiFP.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $57c59c350a2284e3$var$FIVE_MINUTES);
    });
const $57c59c350a2284e3$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $57c59c350a2284e3$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $57c59c350a2284e3$export$d690da9bc8146677 = [
    $57c59c350a2284e3$export$cb954c21735b28e4,
    $57c59c350a2284e3$export$7315c38dc71bd41f
];

});
parcelRegister("8n8Xw", function(module, exports) {

$parcel$export(module.exports, "FetchConnectError", () => $54c275f50bd3d999$export$630f7f9a7ae923d1);
$parcel$export(module.exports, "handleConnectError", () => $54c275f50bd3d999$export$a7a3f8c4788fb03d);

var $guiFP = parcelRequire("guiFP");

var $lgAsZ = parcelRequire("lgAsZ");
function $54c275f50bd3d999$var$is4xxError(statusCode) {
    return statusCode ? statusCode >= 400 && statusCode < 500 : false;
}
class $54c275f50bd3d999$export$630f7f9a7ae923d1 extends (0, $lgAsZ.default) {
    constructor(message, statusCode, cause, skipSentry){
        super(message, {
            cause: cause
        });
        // the name is copied from `KNOWN_NETWORK_ERRORS_TYPES` in `src/packages/platform/utils/fetch/src/utils/is-error.tsx`
        this.name = cause && cause.name ? cause.name : 'NetworkError';
        this.statusCode = statusCode;
        this.skipSentry = typeof skipSentry === 'boolean' ? skipSentry : $54c275f50bd3d999$var$is4xxError(statusCode);
    }
}
const $54c275f50bd3d999$export$a7a3f8c4788fb03d = (id, error, errorAttrs = {})=>{
    const options = {
        error: error,
        meta: {
            id: id,
            packageName: 'jiraConnect'
        },
        attributes: {
            skipSentry: error.skipSentry,
            statusCode: error.statusCode,
            ...errorAttrs
        },
        sendToPrivacyUnsafeSplunk: true,
        skipSentry: error.skipSentry
    };
    (0, $guiFP.default)(options);
    if (error.cause) (0, $guiFP.default)({
        ...options,
        attributes: {
            ...options.attributes,
            isInnerError: true
        },
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        error: error.cause
    });
};

});


parcelRegister("ds7fh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dJtVb');
        const value = parcelRequire('l6TcI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dJtVb").then(()=>parcelRequire('l6TcI'));
}

});



parcelRegister("5a07k", function(module, exports) {

$parcel$export(module.exports, "default", () => $578cb7a04be7f0ad$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $9zysr = parcelRequire("9zysr");

var $is86i = parcelRequire("is86i");

var $bBGpO = parcelRequire("bBGpO");

var $5syGA = parcelRequire("5syGA");

var $6YKbO = parcelRequire("6YKbO");

var $hJ992 = parcelRequire("hJ992");

var $8Bhia = parcelRequire("8Bhia");

var $lqalZ = parcelRequire("lqalZ");

var $8CSFK = parcelRequire("8CSFK");

var $bNe1g = parcelRequire("bNe1g");

var $6Zyxd = parcelRequire("6Zyxd");
const $578cb7a04be7f0ad$export$f9b3295fd9eabd95 = ({ issueViewBackgroundScripts: issueViewBackgroundScripts })=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const issueId = (0, $hJ992.useIssueId)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const extensionData = (0, $eUqFw.useMemo)(()=>({
            issue: {
                id: issueId,
                key: issueKey
            },
            project: {
                id: String(projectContext?.projectId),
                key: String(projectContext?.projectKey),
                // This situation should never happen, but we need to provide a default value
                type: projectContext?.projectType || 'software'
            }
        }), [
        issueId,
        issueKey,
        projectContext?.projectId,
        projectContext?.projectKey,
        projectContext?.projectType
    ]);
    const hasScripts = issueViewBackgroundScripts.length > 0;
    if (!issueId || !projectContext || !hasScripts) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, issueViewBackgroundScripts?.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6YKbO.ViewAnalyticsWrapper), {
            attributes: (0, $5syGA.getAnalyticsAttributesFromExtension)(extension),
            key: `${extension.id}_${extension.properties.resourceUploadId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Zyxd.ForgeBackgroundScript), {
            extensionData: extensionData,
            item: extension
        }))));
};
const $578cb7a04be7f0ad$export$7f7e88f6c97212c8 = ({ issueViewBackgroundScripts: issueViewBackgroundScripts })=>{
    const extensionData = (0, $is86i.useForgeUiIssueData)();
    const hasScripts = issueViewBackgroundScripts.length > 0;
    if (!extensionData || !hasScripts) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, issueViewBackgroundScripts?.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6YKbO.ViewAnalyticsWrapper), {
            attributes: (0, $5syGA.getAnalyticsAttributesFromExtension)(extension),
            key: `${extension.id}_${extension.properties.resourceUploadId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Zyxd.ForgeBackgroundScript), {
            extensionData: extensionData,
            item: extension
        }))));
};
const $578cb7a04be7f0ad$export$3272d86409535c78 = (0, $9zysr.componentWithCondition)((0, $8Bhia.isAnotherExtensionContextForForgeBackgroundScriptsEnabled), $578cb7a04be7f0ad$export$7f7e88f6c97212c8, $578cb7a04be7f0ad$export$f9b3295fd9eabd95);
const $578cb7a04be7f0ad$export$ac90a5534d384989 = (0, $lqalZ.connect)((state)=>({
        issueViewBackgroundScripts: (0, $8CSFK.issueViewBackgroundScriptsSelector)(state)
    }), {})($578cb7a04be7f0ad$export$3272d86409535c78);
const $578cb7a04be7f0ad$export$5a06b2ee660255d9 = ()=>{
    const getAttributes = (0, $eUqFw.useCallback)((error)=>(0, $bBGpO.createAttributes)({
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "forge-background-scripts",
        packageName: "issue",
        teamName: "bento",
        fallback: "unmount",
        attributes: getAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($578cb7a04be7f0ad$export$ac90a5534d384989, null));
};
var $578cb7a04be7f0ad$export$2e2bcd8739ae039 = $578cb7a04be7f0ad$export$5a06b2ee660255d9;

});
parcelRegister("is86i", function(module, exports) {

$parcel$export(module.exports, "useForgeUiIssueData", () => $8cc4ab946aa20cad$export$7cc1d27252aa15a2);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $lO4Or = parcelRequire("lO4Or");

var $guDlK = parcelRequire("guDlK");

var $6vrw7 = parcelRequire("6vrw7");
function $8cc4ab946aa20cad$export$7cc1d27252aa15a2() {
    const issueKey = (0, $hJ992.useIssueKey)();
    const issueId = (0, $hJ992.useIssueId)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectId = (0, $guDlK.useProjectId)(projectKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const [issueType] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.ISSUE_TYPE)
    });
    return (0, $eUqFw.useMemo)(()=>!issueId || !projectId || !projectType || !issueType.name || !issueType.id ? null : {
            issue: {
                key: issueKey,
                id: issueId,
                type: issueType.name,
                typeId: issueType.id
            },
            project: {
                id: (0, $6vrw7.toProjectId)(projectId.toString()),
                key: projectKey,
                type: projectType
            }
        }, [
        issueKey,
        issueId,
        projectKey,
        projectId,
        projectType,
        issueType
    ]);
}

});

parcelRegister("5syGA", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAttributesFromExtension", () => $05fce0f798595dcf$export$5d3b06ab08af139e);

var $2vJHJ = parcelRequire("2vJHJ");

var $70ON1 = parcelRequire("70ON1");
const $05fce0f798595dcf$export$5d3b06ab08af139e = (extension, entryPoint)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return {
        appId: appId,
        envId: envId,
        forgeType: (0, $2vJHJ.getForgeUIType)(extension, entryPoint),
        envType: extension?.environmentType
    };
};

});
parcelRegister("2vJHJ", function(module, exports) {

$parcel$export(module.exports, "getForgeUIType", () => $0071fffa92d48f40$export$aed4d8a86badbf61);
$parcel$export(module.exports, "isCustomUIExtension", () => $0071fffa92d48f40$export$edb00cfe4962b026);
$parcel$export(module.exports, "isNativeUiExtension", () => $0071fffa92d48f40$export$2ecba06e617fea0a);
$parcel$export(module.exports, "overrideExtension", () => $0071fffa92d48f40$export$42b85bc9b386c977);

var $8blac = parcelRequire("8blac");

var $1ybV0 = parcelRequire("1ybV0");
const $0071fffa92d48f40$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
    const { render: render, resource: resource } = extension.properties;
    if (!(0, $1ybV0.ff)('fix-forge-ui-type-detection_nmgpj')) {
        if (render != null && render !== 'native') return 'ui-kit';
    }
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
        extension.properties[entryPoint];
        if (entryPointResource == null) return 'ui-kit';
        if (entryPointRender === 'native') return 'native-ui';
        return 'custom-ui';
    }
    if (resource == null) return 'ui-kit';
    if (render === 'native') return 'native-ui';
    return 'custom-ui';
};
const $0071fffa92d48f40$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$0071fffa92d48f40$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
const $0071fffa92d48f40$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$0071fffa92d48f40$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
const $0071fffa92d48f40$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
    if (extension == null) return extension;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(propsToOverride)) return extension;
    const { resource: resource, requiresUserConsent: requiresUserConsent } = propsToOverride;
    // We must also spread `extension.properties` because JS doesn't deep-copy objects.
    // Only spreading `extension` will result in `resource` on the original `extension`
    // object being modified.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const extensionCopy = {
        ...extension,
        properties: {
            ...extension.properties
        },
        requiresUserConsent: requiresUserConsent
    }; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (resource != null) extensionCopy.properties.resource = resource;
    return extensionCopy;
};

});

parcelRegister("70ON1", function(module, exports) {

$parcel$export(module.exports, "parseExtensionId", () => $46692d02f47d8a1d$export$bae42cbaf7fa3e1b);
$parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", () => $46692d02f47d8a1d$export$a92b17288693d366);
const $46692d02f47d8a1d$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const [, appId, envId] = extensionId.split('/');
    return {
        appId: appId,
        envId: envId
    };
};
const $46692d02f47d8a1d$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');

});


parcelRegister("6YKbO", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $119b03a9f38e44b9$export$c794eb4124961145);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");
const $119b03a9f38e44b9$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });

});
parcelRegister("1boRu", function(module, exports) {

$parcel$export(module.exports, "ForgeScreenEvent", () => $e499aee6653ef75f$export$92d758d83665314b);
$parcel$export(module.exports, "ForgeOperationaFailedEvent", () => $e499aee6653ef75f$export$a238c3c13f29c134);
$parcel$export(module.exports, "ForgeErrorBoundary", () => $e499aee6653ef75f$export$ac7e7464cefab440);
$parcel$export(module.exports, "ForgeAnalyticsWrapper", () => $e499aee6653ef75f$export$ad2a5d9127152fb8);
$parcel$export(module.exports, "withMetrics", () => $e499aee6653ef75f$export$14e56d7f5d3f917c);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $2Rqjr = parcelRequire("2Rqjr");

var $2vJHJ = parcelRequire("2vJHJ");

var $9x02J = parcelRequire("9x02J");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");
var $2qZHF = parcelRequire("2qZHF");

var $hRcYT = parcelRequire("hRcYT");

var $8XU7c = parcelRequire("8XU7c");

var $bBGpO = parcelRequire("bBGpO");

var $9Z5wa = parcelRequire("9Z5wa");

var $5syGA = parcelRequire("5syGA");

var $d6g7g = parcelRequire("d6g7g");
const $e499aee6653ef75f$export$92d758d83665314b = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: (0, $bBGpO.createAttributes)(attributes)
    });
const $e499aee6653ef75f$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $9Z5wa.fireOperationalFailedEvent)({
        eventId: eventId,
        attributes: attributes
    });
    return null;
};
const $e499aee6653ef75f$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
    const hasForgeAccess = (0, $9x02J.useHasForgeAccess)();
    const analyticsAttributes = (0, $bBGpO.createAttributes)({
        ...attributes,
        hasForgeAccess: hasForgeAccess
    });
    const fireEvent = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, (0, $8XU7c.getEventActionName)(eventId, action), analyticsAttributes);
    }, [
        eventId,
        action,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: fireEvent
    });
};
const $e499aee6653ef75f$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.${eventId}`
    }, children);
const $e499aee6653ef75f$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
    const fallback = (0, $eUqFw.useMemo)(()=>errorFallback || 'unmount', [
        errorFallback
    ]);
    const getAttributes = (0, $eUqFw.useCallback)((error)=>(0, $bBGpO.createAttributes)({
            ...attributes,
            error: error
        }), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: eventId,
        packageName: (0, $hRcYT.PACKAGE_NAME_GASV3),
        teamName: "smite",
        fallback: fallback,
        attributes: getAttributes,
        onError: onError,
        resetCaughtError: resetCaughtError
    }, children);
};
const $e499aee6653ef75f$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, $hRcYT.MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
    const eventId = (0, $8XU7c.getEventId)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    });
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>(0, $bBGpO.createAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$f461e628d5e73fa0, {
        eventId: eventId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$ac7e7464cefab440, {
        eventId: eventId,
        attributes: analyticsAttributes,
        errorFallback: errorFallback,
        resetCaughtError: resetCaughtError
    }, shouldFireInitializedEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$4c46624a93517c10, {
        eventId: eventId,
        action: "initialized",
        attributes: analyticsAttributes
    }), children));
};
function $e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
    if ((extensionModule === (0, $2Rqjr.CUSTOM_FIELD_MODULE) || extensionModule === (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
    if (extensionModule === (0, $2Rqjr.ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
    return /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
        (0, $2Rqjr.GLOBAL_PAGE_MODULE),
        (0, $2Rqjr.ISSUE_ACTION_MODULE),
        (0, $2Rqjr.ISSUE_ACTIVITY_MODULE),
        (0, $2Rqjr.ISSUE_GLANCE_MODULE),
        (0, $2Rqjr.ISSUE_CONTEXT_MODULE),
        (0, $2Rqjr.ISSUE_PANEL_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE),
        (0, $2Rqjr.PROJECT_PAGE_MODULE),
        (0, $2Rqjr.ADMIN_PAGE_MODULE),
        (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE)
    ].includes(extensionModule);
}
const $e499aee6653ef75f$export$14e56d7f5d3f917c = (Component)=>(props)=>{
        const isCustomUI = (0, $2vJHJ.isCustomUIExtension)(props.extension, props.entryPoint);
        const [isExtensionRendered, setExtensionRendered] = (0, $eUqFw.useState)(false);
        const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
        const extensionId = props.extension?.id;
        const eventId = (0, $8XU7c.getEventId)({
            module: module,
            entryPoint: entryPoint
        });
        const browserMetricsEventId = (0, $8XU7c.getBrowserMetricsEventId)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $2vJHJ.getForgeUIType)(extension, entryPoint)
        });
        const attributes = (0, $eUqFw.useMemo)(()=>({
                ...analyticsAttributes,
                ...(0, $5syGA.getAnalyticsAttributesFromExtension)(extension, entryPoint)
            }), // because extension is an object but we only want extension.id to trigger re-render
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            analyticsAttributes,
            entryPoint,
            extension.id,
            isCustomUI
        ]);
        !$e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId && (0, $d6g7g.forgeModulesLoadTime).start({
            startTime: performance.now()
        });
        const onError = (0, $eUqFw.useCallback)(()=>{
            extensionId && (0, $d6g7g.forgeModulesLoadTime).cancel();
        }, [
            extensionId
        ]);
        const onInitialRenderUiKitWithMetrics = (0, $eUqFw.useCallback)((payload)=>{
            onInitialRender && onInitialRender(payload);
            if (payload?.error == null) {
                const stopTimeDeduction = payload?.appTime || 0;
                setExtensionRendered(true);
                extensionId && (0, $d6g7g.forgeModulesLoadTime).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            } else {
                onError();
                (0, $9Z5wa.fireOperationalFailedEvent)({
                    eventId: eventId,
                    attributes: {
                        error: new Error(payload.error),
                        ...attributes
                    }
                });
            }
        }, [
            onInitialRender,
            extensionId,
            browserMetricsEventId,
            onError,
            eventId,
            attributes
        ]);
        const onLoadCustomUiWithMetrics = (0, $eUqFw.useCallback)(()=>{
            onLoad && onLoad();
            setExtensionRendered(true);
            extensionId && (0, $d6g7g.forgeModulesLoadTime).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
        // SMT-1418
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            analyticsAttributes,
            extensionId,
            localId,
            onLoad
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$f461e628d5e73fa0, {
            eventId: eventId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            ...isCustomUI ? {
                onLoad: onLoadCustomUiWithMetrics
            } : {
                onInitialRender: onInitialRenderUiKitWithMetrics
            }
        }), isExtensionRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$92d758d83665314b, {
            attributes: attributes
        }));
    };

});
parcelRegister("9x02J", function(module, exports) {

$parcel$export(module.exports, "useHasForgeAccess", () => $c88d1eb745d9d2ce$export$fd7f94d3d2bac7f2);

var $6yplV = parcelRequire("6yplV");
const $c88d1eb745d9d2ce$export$fd7f94d3d2bac7f2 = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return !isAnonymous;
};

});
parcelRegister("6yplV", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $650b84b1a3eacbd8$export$bf7b5d502f6d6d3b);

var $gd0Sp = parcelRequire("gd0Sp");
const $650b84b1a3eacbd8$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});


parcelRegister("9Z5wa", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $2660eb080e6928fb$export$add44f896fb31ba3);

var $hRcYT = parcelRequire("hRcYT");

var $cYWDh = parcelRequire("cYWDh");
const $2660eb080e6928fb$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).FAILED, {
        id: eventId,
        attributes: attributes
    });
};

});



parcelRegister("6Zyxd", function(module, exports) {

$parcel$export(module.exports, "ForgeBackgroundScript", () => $ff07e36c32207ea9$export$670b5dd80fc3541c);

var $eUqFw = parcelRequire("eUqFw");

var $bC4Sq = parcelRequire("bC4Sq");

var $eyYNo = parcelRequire("eyYNo");
const $ff07e36c32207ea9$export$670b5dd80fc3541c = ({ item: item, extensionData: extensionData })=>{
    const { properties: { resourceUploadId: resourceUploadId, shouldReloadOnRefresh: shouldReloadOnRefresh } } = item;
    const refreshedOn = (0, $eyYNo.useOnDemandIssueRefreshTime)();
    if (!shouldReloadOnRefresh) {
        const key = `forge-iFrame-${resourceUploadId}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bC4Sq.AsyncIssueViewBackgroundScript), {
            key: key,
            testId: key,
            extension: item,
            extensionData: extensionData
        });
    }
    const key = refreshedOn ? `forge-iFrame-${resourceUploadId}-${refreshedOn}` : `forge-iFrame-${resourceUploadId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bC4Sq.AsyncIssueViewBackgroundScript), {
        key: key,
        testId: key,
        extension: item,
        extensionData: extensionData
    });
};
$ff07e36c32207ea9$export$670b5dd80fc3541c.defaultProps = {
    refreshedOn: 0
};

});
parcelRegister("bC4Sq", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueViewBackgroundScript", () => $5f8d09266b063886$export$ec25cc188a9726ac);

var $eUqFw = parcelRequire("eUqFw");

var $3AsFy = parcelRequire("3AsFy");

var $2Rqjr = parcelRequire("2Rqjr");

var $gamHX = parcelRequire("gamHX");

var $2vJHJ = parcelRequire("2vJHJ");

var $gGtKh = parcelRequire("gGtKh");

var $bL3M0 = parcelRequire("bL3M0");
const $5f8d09266b063886$export$ec25cc188a9726ac = (props)=>{
    const extensionData = (0, $eUqFw.useMemo)(()=>({
            ...props.extensionData,
            type: (0, $2Rqjr.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE)
        }), [
        props.extensionData
    ]);
    const components = (0, $eUqFw.useCallback)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            ThreeLOPrompt: (0, $3AsFy.makeModalThreeLOPromptForCustomUI)({
                // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                onClose: ()=>{},
                appName: props.extension.properties.title
            })
        }), [
        props.extension.properties.title
    ]);
    if (!(0, $2vJHJ.isCustomUIExtension)(props.extension)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bL3M0.InvisibleDiv), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-view-background-script",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gamHX.LazyIframe), {
        ...props,
        module: (0, $2Rqjr.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
        extensionData: extensionData,
        components: components,
        contextToken: (0, $2Rqjr.CONTEXT_TOKEN_TYPE_JIRA)
    })));
};

});
parcelRegister("3AsFy", function(module, exports) {

$parcel$export(module.exports, "makeModalThreeLOPrompt", () => $29caf8fe725faf0d$export$ee02671eeeecd75);
$parcel$export(module.exports, "makeModalThreeLOPromptForCustomUI", () => $29caf8fe725faf0d$export$85a504818a81117d);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $ctuEi = parcelRequire("ctuEi");

const $29caf8fe725faf0d$var$AKModalDialog = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("3jScb")));

const $29caf8fe725faf0d$var$AKModalTransition = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("3jScb")).then((module)=>({
            default: module.ModalTransition
        })));

const $29caf8fe725faf0d$var$AKModalHeader = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>Promise.resolve((parcelRequire("kigFe"))));

const $29caf8fe725faf0d$var$AKModalTitle = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>Promise.resolve((parcelRequire("boSVF"))));

const $29caf8fe725faf0d$var$AKModalBody = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>Promise.resolve((parcelRequire("lfiOu"))));

const $29caf8fe725faf0d$var$AKModalFooter = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>Promise.resolve((parcelRequire("2OJfS"))));

const $29caf8fe725faf0d$var$AKButton = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("3hHQO")));

const $29caf8fe725faf0d$var$SectionMessage = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("3LEEo")));
const $29caf8fe725faf0d$var$ModalThreeLOPrompt = ({ onClose: onClose = ()=>{}, isBlanketHidden: isBlanketHidden, ...props })=>{
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $ctuEi.useAuth)(props);
    const { authUrl: authUrl } = props;
    const isAuthUrlEmpty = !authUrl || authUrl === '';
    const intl = (0, $5JgJ2.default)();
    const { modalTitle: modalTitle, modalBody: modalBody } = isAuthUrlEmpty ? {
        modalTitle: intl.formatMessage($29caf8fe725faf0d$var$messages.modalErrorTitle),
        modalBody: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($29caf8fe725faf0d$var$SectionMessage, {
            appearance: "error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $29caf8fe725faf0d$var$messages.noAuthURLErrorMessage)))
    } : {
        modalTitle: intl.formatMessage($29caf8fe725faf0d$var$messages.modalAccessRequiredTitle),
        modalBody: promptMessage
    };
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($29caf8fe725faf0d$var$AKModalTransition, null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($29caf8fe725faf0d$var$AKModalDialog, {
        onClose: ()=>{
            setIsModalOpen(false);
            onClose();
        },
        isBlanketHidden: isBlanketHidden
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($29caf8fe725faf0d$var$AKModalHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($29caf8fe725faf0d$var$AKModalTitle, null, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($29caf8fe725faf0d$var$AKModalBody, null, modalBody), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($29caf8fe725faf0d$var$AKModalFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($29caf8fe725faf0d$var$AKButton, {
        appearance: "subtle",
        onClick: ()=>{
            setIsModalOpen(false);
            onClose();
        }
    }, "Cancel"), !isAuthUrlEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($29caf8fe725faf0d$var$AKButton, {
        appearance: "primary",
        autoFocus: true,
        isLoading: loading,
        onClick: startAuth
    }, buttonText))));
};
var $29caf8fe725faf0d$export$2e2bcd8739ae039 = $29caf8fe725faf0d$var$ModalThreeLOPrompt;
const $29caf8fe725faf0d$export$ee02671eeeecd75 = ({ onClose: onClose, appName: appName })=>{
    return function modalThreeLOPrompt({ forgeDoc: { props: props }, dispatch: dispatch }) {
        const { message: message, authUrl: authUrl, promptText: promptText } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($29caf8fe725faf0d$var$ModalThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            onSuccess: ()=>dispatch({
                    type: 'render',
                    extensionData: {}
                }),
            appName: appName,
            onClose: onClose
        });
    };
};
const $29caf8fe725faf0d$export$85a504818a81117d = ({ onClose: onClose, appName: appName, isBlanketHidden: isBlanketHidden = false })=>{
    return (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($29caf8fe725faf0d$var$ModalThreeLOPrompt, (0, $kU09D.default)({}, props, {
            appName: appName,
            onClose: onClose,
            isBlanketHidden: isBlanketHidden
        }));
    };
};
const $29caf8fe725faf0d$var$messages = (0, $90IgZ.defineMessages)({
    noAuthURLErrorMessage: {
        id: 'confluence.threeLOPrompt.modal.no.authURL.error-message',
        defaultMessage: 'Consent URL not found. Please refresh the page and try again.',
        description: 'This text is displayed when the URL that gives an app certain permissions is not present.'
    },
    modalErrorTitle: {
        id: 'confluence.threeLOPrompt.modal.error.title',
        defaultMessage: 'Error',
        description: 'This is the title assigned to a modal when there is an error with this component'
    },
    modalAccessRequiredTitle: {
        id: 'confluence.threeLOPrompt.modal.access.required.title',
        defaultMessage: 'Access required',
        description: "This is the title assigned to a modal when access to the user's account is required."
    }
});

});
parcelRegister("ctuEi", function(module, exports) {

$parcel$export(module.exports, "useAuth", () => $914ff7b2f9b5005a$export$1d39dc5b47e56ff0);

var $eUqFw = parcelRequire("eUqFw");

var $6Gu8T = parcelRequire("6Gu8T");

var $gLDAc = parcelRequire("gLDAc");

var $1Gtjf = parcelRequire("1Gtjf");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $6h1SY = parcelRequire("6h1SY");

var $5YsMl = parcelRequire("5YsMl");

var $11seU = parcelRequire("11seU");
const $914ff7b2f9b5005a$export$6f3af2d351697947 = 'initAuthFlow';
const $914ff7b2f9b5005a$export$53118f19ffa6f5ac = 'userConsent';
// TODO: We should make appName non-optional later: http://go/j/AUX-570
// appName was made optional because it isn't in already inserted apps prior to the change in http://go/j/AUX-411
const $914ff7b2f9b5005a$var$defaultPromptMessage = (intl, appName)=>{
    return intl.formatMessage($914ff7b2f9b5005a$var$messages.defaultPromptMessage, {
        appString: appName ? appName : intl.formatMessage($914ff7b2f9b5005a$var$messages.thisAppLower)
    });
};
const $914ff7b2f9b5005a$var$externalAuthPromptMessage = (intl, appName)=>{
    return intl.formatMessage($914ff7b2f9b5005a$var$messages.externalAuthPromptMessage, {
        appString: appName ? appName : intl.formatMessage($914ff7b2f9b5005a$var$messages.thisAppUpper)
    });
};
const $914ff7b2f9b5005a$export$1d39dc5b47e56ff0 = ({ message: message, promptText: promptText, appName: appName, authUrl: authUrl, onSuccess: onSuccess, metadata: metadata })=>{
    const [failedToAuthenticate, setFailedToAuthenticate] = (0, $eUqFw.useState)(false);
    const [authFailureMessage, setAuthFailureMessage] = (0, $eUqFw.useState)(false);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const { submitMetric: submitMetric, page: page } = (0, $6Gu8T.useMetrics)();
    const promptIsForExternalAuth = (0, $gLDAc.isExternalAuth)(authUrl);
    const intl = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        submitMetric({
            name: (0, $1Gtjf.catalog).userInteraction.TASK_SUCCESS,
            task: $914ff7b2f9b5005a$export$6f3af2d351697947,
            taskId: metadata === null || metadata === void 0 ? void 0 : metadata.moduleType,
            page: page
        });
    }, [
        submitMetric,
        page,
        metadata
    ]);
    const startAuth = ()=>{
        setLoading(true);
        setAuthFailureMessage(false);
        (0, $gLDAc.safeAuth)(authUrl).then(()=>{
            onSuccess().then((callbackAfterConsentFlowHasFinished)=>{
                setLoading(false);
                setFailedToAuthenticate(false);
                submitMetric({
                    name: (0, $1Gtjf.catalog).userInteraction.TASK_SUCCESS,
                    task: $914ff7b2f9b5005a$export$53118f19ffa6f5ac,
                    taskId: metadata === null || metadata === void 0 ? void 0 : metadata.moduleType,
                    page: page
                });
                if (callbackAfterConsentFlowHasFinished && typeof callbackAfterConsentFlowHasFinished === 'function') callbackAfterConsentFlowHasFinished();
            });
        }, (err)=>{
            setLoading(false);
            setFailedToAuthenticate(true);
            if ((0, $11seU.isOfTypeAuthError)(err.type)) setAuthFailureMessage(err.message);
            submitMetric({
                name: (0, $1Gtjf.catalog).userInteraction.TASK_FAILURE,
                task: $914ff7b2f9b5005a$export$53118f19ffa6f5ac,
                taskId: metadata === null || metadata === void 0 ? void 0 : metadata.moduleType,
                page: page
            });
        });
    };
    const promptMessage = failedToAuthenticate ? authFailureMessage || intl.formatMessage($914ff7b2f9b5005a$var$messages.defaultFailedToAuthMessage) : message || (promptIsForExternalAuth ? $914ff7b2f9b5005a$var$externalAuthPromptMessage(intl, appName) : $914ff7b2f9b5005a$var$defaultPromptMessage(intl, appName));
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6h1SY.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: intl.formatMessage($914ff7b2f9b5005a$var$messages.externalAuthWarning),
        primaryColor: "var(--ds-icon-warning, #FF8B00)",
        size: "medium"
    }), promptMessage);
    const externalAuthButtonText = intl.formatMessage($914ff7b2f9b5005a$var$messages.configureAccess);
    const buttonText = promptText || (promptIsForExternalAuth ? externalAuthButtonText : intl.formatMessage($914ff7b2f9b5005a$var$messages.allowAccess));
    return {
        loading: loading,
        startAuth: startAuth,
        promptMessage: content,
        buttonText: buttonText
    };
};
const $914ff7b2f9b5005a$var$messages = (0, $90IgZ.defineMessages)({
    defaultPromptMessage: {
        id: 'confluence.threeLOPrompt.use-auth.default.prompt.message',
        defaultMessage: 'For {appString} to display, you need to allow the app to access Atlassian products on your behalf.',
        description: 'A text prompt that tells a user that an app needs to be given permission before the app can be used.'
    },
    externalAuthPromptMessage: {
        id: 'confluence.threeLOPrompt.use-auth.external.auth.prompt.message',
        defaultMessage: '{appString} requires additional access to your account.',
        description: 'A text prompt indicating that an app requires additional permissions before the app can be used.'
    },
    thisAppUpper: {
        id: 'confluence.threeLOPrompt.use-auth.this.app.upper.message',
        defaultMessage: 'This app',
        description: 'a default message shown to the user when the name of an application is unknown.'
    },
    thisAppLower: {
        id: 'confluence.threeLOPrompt.use-auth.this.app.lower.message',
        defaultMessage: 'this app',
        description: 'a default message shown to the user when the name of an application is unknown.'
    },
    defaultFailedToAuthMessage: {
        id: 'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message',
        defaultMessage: 'Failed to authenticate.',
        description: 'A default text prompt to indicate than an app was unable to authenticate a user.'
    },
    externalAuthWarning: {
        id: 'confluence.threeLOPrompt.use-auth.external.auth.warning.message',
        defaultMessage: 'External Auth Warning',
        description: 'A default text prompt to indicate than an app was unable to authenticate a user.'
    },
    configureAccess: {
        id: 'confluence.threeLOPrompt.use-auth.configure.access.button.text',
        defaultMessage: 'Configure access',
        description: "Label for a button that allows a user to configure the app's access to the user's account"
    },
    allowAccess: {
        id: 'confluence.threeLOPrompt.use-auth.allow.access.button.text',
        defaultMessage: 'Allow access',
        description: 'Label for a button that would allow the user to grant access to some application.'
    }
});

});
parcelRegister("6Gu8T", function(module, exports) {

$parcel$export(module.exports, "useMetrics", () => $4dde0bf482e814e1$export$90856cc8b6bce002);

var $eUqFw = parcelRequire("eUqFw");

var $aC1i4 = parcelRequire("aC1i4");

var $fzXll = parcelRequire("fzXll");
const $4dde0bf482e814e1$var$submitMetric = (client, metric)=>{
    if (client) Promise.resolve(client).then((client)=>client.metric.submit(metric));
};
const $4dde0bf482e814e1$export$90856cc8b6bce002 = ()=>{
    const { metalClient: metalClient, page: page } = (0, $eUqFw.useContext)((0, $aC1i4.MetalClientContext));
    return {
        submitMetric: (0, $fzXll.useCallbackOne)((metric)=>$4dde0bf482e814e1$var$submitMetric(metalClient, metric), [
            metalClient
        ]),
        page: page
    };
};

});
parcelRegister("aC1i4", function(module, exports) {

$parcel$export(module.exports, "MetalClientContext", () => $7b9e743c786c7915$export$6ba466bc6cc639bf);
$parcel$export(module.exports, "MetalClientProvider", () => $7b9e743c786c7915$export$89c302b7bfd6a5);

var $eUqFw = parcelRequire("eUqFw");

var $fzXll = parcelRequire("fzXll");
parcelRequire("7N2lk");
var $dagNm = parcelRequire("dagNm");

var $aqnU3 = parcelRequire("aqnU3");
let $7b9e743c786c7915$var$metalClientSingleton;
// Track the number of createMetalClient invocations
let $7b9e743c786c7915$var$metalClientRefs = 0;


const $7b9e743c786c7915$export$7c2254c74232c194 = (env, product, module = Promise.resolve((parcelRequire("1Gtjf"))))=>{
    $7b9e743c786c7915$var$metalClientRefs++;
    if (!$7b9e743c786c7915$var$metalClientSingleton) {
        const FORGE_UI_METAL_ID = '74fe5415-a93b-4197-bb9b-294dc9439cd7';
        const partialProductInfo = {
            metalId: FORGE_UI_METAL_ID,
            // TODO: Automate the versioning of metal-client
            // https://product-fabric.atlassian.net/browse/AUX-619
            version: '0.1'
        };
        $7b9e743c786c7915$var$metalClientSingleton = new Promise(async (resolve)=>{
            const { default: MetalClient, envTypes: envTypes, PerformanceMarkPlugin: PerformanceMarkPlugin, catalog: catalog } = await module;
            const { default: SLOPlugin } = await (parcelRequire("r6TBw"));
            let metalEnv = (()=>{
                if (env === (0, $dagNm.ProductEnvironment).PRODUCTION) return envTypes.PROD;
                else if (env === (0, $dagNm.ProductEnvironment).STAGING) return envTypes.STAGING;
                return envTypes.DEV;
            })();
            const plugins = [
                new PerformanceMarkPlugin({
                    [catalog.performance.REQUEST_TIMING]: {
                        name: 'forge-ui.fe.render',
                        // In our metrics, 'page' is used to identify the extension point,
                        // but we're using the product here for the meantime as page is required
                        page: product
                    }
                }),
                new SLOPlugin({
                    [catalog.performance.COMPONENT_READY]: [
                        {
                            component: 'useExtensionList',
                            target: 2000
                        },
                        {
                            component: 'getForgeExtensionProvider',
                            target: 2000
                        }
                    ],
                    [catalog.performance.REQUEST_TIMING]: 5000
                })
            ];
            resolve(new MetalClient({
                productInfo: {
                    ...partialProductInfo,
                    env: metalEnv
                },
                // @ts-ignore broken metal-client types, required in meta metrics. See http://go/j/OBSCL-445
                settings: {
                    meta: {
                        subproduct: product
                    }
                },
                plugins: plugins
            }));
        });
    }
    return [
        $7b9e743c786c7915$var$metalClientSingleton,
        $7b9e743c786c7915$var$destroyMetalClient
    ];
};
const $7b9e743c786c7915$var$destroyMetalClient = ()=>{
    $7b9e743c786c7915$var$metalClientRefs--;
    if ($7b9e743c786c7915$var$metalClientRefs !== 0) return;
    if ($7b9e743c786c7915$var$metalClientSingleton) {
        Promise.resolve($7b9e743c786c7915$var$metalClientSingleton).then((metalClient)=>{
            metalClient.destroy();
        });
        $7b9e743c786c7915$var$metalClientSingleton = undefined;
    }
};
const $7b9e743c786c7915$export$6ba466bc6cc639bf = /*#__PURE__*/ (0, $eUqFw.createContext)({
    metalClient: undefined,
    environment: (0, $dagNm.ProductEnvironment).DEVELOPMENT,
    product: '',
    page: ''
});
const $7b9e743c786c7915$var$InnerMetalClientProvider = $7b9e743c786c7915$export$6ba466bc6cc639bf.Provider;
const $7b9e743c786c7915$export$10bd9e2af368a5b3 = $7b9e743c786c7915$export$6ba466bc6cc639bf.Consumer;
var $7b9e743c786c7915$export$2e2bcd8739ae039 = $7b9e743c786c7915$export$6ba466bc6cc639bf;
const $7b9e743c786c7915$export$89c302b7bfd6a5 = ({ value: value, children: children })=>{
    const envFromContext = (0, $eUqFw.useContext)((0, $aqnU3.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const [metalClient, destroyMetalClient] = (0, $fzXll.useMemoOne)(()=>{
        return $7b9e743c786c7915$export$7c2254c74232c194(environment || envFromContext, product);
    }, [
        envFromContext,
        environment,
        product
    ]);
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            destroyMetalClient();
        };
    }, [
        destroyMetalClient
    ]);
    const memoedValue = (0, $fzXll.useMemoOne)(()=>{
        return {
            environment: environment || envFromContext,
            product: product,
            page: page,
            metalClient: metalClient
        };
    }, [
        page,
        environment,
        envFromContext,
        product,
        metalClient
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b9e743c786c7915$var$InnerMetalClientProvider, {
        value: memoedValue
    }, children);
};

});
parcelRegister("7N2lk", function(module, exports) {

$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("dagNm")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("dagNm")).ForgeCDNEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("hELZQ")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("hELZQ")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("3bsCm")).ConfluenceExtension);
parcelRequire("hMouK");
var $3bsCm = parcelRequire("3bsCm");
var $dagNm = parcelRequire("dagNm");
var $hELZQ = parcelRequire("hELZQ");
parcelRequire("4xsPi");
var $4WaWj = parcelRequire("4WaWj");
var $7lxv9 = parcelRequire("7lxv9");
var $fQS86 = parcelRequire("fQS86");

});
parcelRegister("hMouK", function(module, exports) {

$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("hELZQ")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("hELZQ")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("dagNm")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("dagNm")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("3bsCm")).ConfluenceExtension);

var $hELZQ = parcelRequire("hELZQ");

var $dagNm = parcelRequire("dagNm");

var $KIjo9 = parcelRequire("KIjo9");

var $3bsCm = parcelRequire("3bsCm");

});
parcelRegister("hELZQ", function(module, exports) {

$parcel$export(module.exports, "MarkupRecursiveList", () => $c3c992ab9629ee21$export$3b98ab6402702476);
$parcel$export(module.exports, "MarkupList", () => $c3c992ab9629ee21$export$3ee8c58bb87b9685);
const $c3c992ab9629ee21$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $c3c992ab9629ee21$export$3ee8c58bb87b9685 = [
    ...$c3c992ab9629ee21$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("dagNm", function(module, exports) {

$parcel$export(module.exports, "ProductEnvironment", () => $cd4749aad0e145e2$export$2688cec3c24cb60b);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => $cd4749aad0e145e2$export$beaef1891b3e7ca3);
var $cd4749aad0e145e2$export$2688cec3c24cb60b;
(function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
})($cd4749aad0e145e2$export$2688cec3c24cb60b || ($cd4749aad0e145e2$export$2688cec3c24cb60b = {}));
var $cd4749aad0e145e2$export$beaef1891b3e7ca3;
(function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    ForgeCDNEnvironment["FEDRAMP_SANDBOX"] = "fex";
})($cd4749aad0e145e2$export$beaef1891b3e7ca3 || ($cd4749aad0e145e2$export$beaef1891b3e7ca3 = {}));

});

parcelRegister("KIjo9", function(module, exports) {
const $9ef3cebf2976b911$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("3bsCm", function(module, exports) {

$parcel$export(module.exports, "ConfluenceExtension", () => $494e216a61fae0c3$export$9a2372818e2520c6);
var $494e216a61fae0c3$export$6e95f5308d9156f9;
(function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
})($494e216a61fae0c3$export$6e95f5308d9156f9 || ($494e216a61fae0c3$export$6e95f5308d9156f9 = {}));
const $494e216a61fae0c3$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    TEST_MODULE: 'test:module'
};
const $494e216a61fae0c3$export$f06ffa3aa6bfec95 = {
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};

});


parcelRegister("4xsPi", function(module, exports) {

var $fQS86 = parcelRequire("fQS86");

var $7lxv9 = parcelRequire("7lxv9");

var $4WaWj = parcelRequire("4WaWj");

});
parcelRegister("fQS86", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $bcd0b3fab80fa742$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $bcd0b3fab80fa742$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $bcd0b3fab80fa742$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $bcd0b3fab80fa742$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $bcd0b3fab80fa742$export$20b9f6acb0888554(effect) {
    return $bcd0b3fab80fa742$export$7e816460364ed464(effect) || $bcd0b3fab80fa742$export$eb5bd7f371e458af(effect) || $bcd0b3fab80fa742$export$f632ad3064955f31(effect);
}

});

parcelRegister("7lxv9", function(module, exports) {
const $bcc31fdbcb920057$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bcc31fdbcb920057$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bcc31fdbcb920057$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bcc31fdbcb920057$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bcc31fdbcb920057$export$caa8cab0db5b0a61(effect) {
    return $bcc31fdbcb920057$export$65d7078e01574f24(effect) || $bcc31fdbcb920057$export$709a27a9f80556b8(effect) || $bcc31fdbcb920057$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("4WaWj", function(module, exports) {
// From forge.ts
const $82ee46b9e41bdfd4$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
const $82ee46b9e41bdfd4$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $82ee46b9e41bdfd4$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $82ee46b9e41bdfd4$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $82ee46b9e41bdfd4$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $82ee46b9e41bdfd4$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $82ee46b9e41bdfd4$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $82ee46b9e41bdfd4$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $82ee46b9e41bdfd4$export$24835b97bd9481e3;
(function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
})($82ee46b9e41bdfd4$export$24835b97bd9481e3 || ($82ee46b9e41bdfd4$export$24835b97bd9481e3 = {}));

});



parcelRegister("aqnU3", function(module, exports) {

$parcel$export(module.exports, "EnvironmentContext", () => $796edfc07856d666$export$6a671bebd9daad64);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("7N2lk");
var $dagNm = parcelRequire("dagNm");
const $796edfc07856d666$export$6a671bebd9daad64 = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $dagNm.ProductEnvironment).PRODUCTION);

});

parcelRegister("r6TBw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('agcjw');
        const value = parcelRequire('eOgvy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("agcjw").then(()=>parcelRequire('eOgvy'));
}

});



parcelRegister("gLDAc", function(module, exports) {

$parcel$export(module.exports, "safeAuth", () => $c34fbd73e68cb568$export$5a2d35665f488c3c);
$parcel$export(module.exports, "isExternalAuth", () => $c34fbd73e68cb568$export$4211976e157c7ad8);

var $5lhyG = parcelRequire("5lhyG");

var $fycpz = parcelRequire("fycpz");
const $c34fbd73e68cb568$export$6baf9fc1d877ea76 = 'atlassian-token-service-key';
const $c34fbd73e68cb568$export$5a2d35665f488c3c = async (startUrl, windowFeatures)=>{
    return (0, $5lhyG.auth)((0, $fycpz.sanitizeUrl)(startUrl), windowFeatures);
};
const $c34fbd73e68cb568$export$4211976e157c7ad8 = (startUrl)=>{
    const url = new URL(startUrl || '', window.location.href);
    const serviceKey = url.searchParams.get('serviceKey');
    return serviceKey !== $c34fbd73e68cb568$export$6baf9fc1d877ea76;
};

});
parcelRegister("5lhyG", function(module, exports) {

$parcel$export(module.exports, "auth", () => $3e3c88a248dae80e$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("e2YnL")).AuthError);

var $e2YnL = parcelRequire("e2YnL");

var $11seU = parcelRequire("11seU");
function $3e3c88a248dae80e$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $11seU.isOfTypeAuthError)(errorType)) reject(new (0, $e2YnL.AuthError)(data.message, errorType));
                    else reject(new (0, $e2YnL.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $e2YnL.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("e2YnL", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $a3a0174673f5ab23$export$145273558d58e0ac);
class $a3a0174673f5ab23$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message);
        this.message = message;
        this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("11seU", function(module, exports) {

$parcel$export(module.exports, "isOfTypeAuthError", () => $0bebca317e9a4582$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $0bebca317e9a4582$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("fycpz", function(module, exports) {

$parcel$export(module.exports, "sanitizeUrl", () => $b523a89e0afd2f90$export$300bd6d67c49dbfc);
$parcel$export(module.exports, "EmFn", () => $b523a89e0afd2f90$export$fec26b2d751c6d95);
$parcel$export(module.exports, "LinkFn", () => $b523a89e0afd2f90$export$7c70dc97eeeaf683);
$parcel$export(module.exports, "StrikeFn", () => $b523a89e0afd2f90$export$e9e7c187aef6a83a);
$parcel$export(module.exports, "StringFn", () => $b523a89e0afd2f90$export$11a9c970dcafffc0);
$parcel$export(module.exports, "StrongFn", () => $b523a89e0afd2f90$export$566c617eb72a5976);

var $eUqFw = parcelRequire("eUqFw");

const $b523a89e0afd2f90$var$AkButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("1imuF")));
// taken from https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/158006558/URI+scheme+Allow+listing
const $b523a89e0afd2f90$var$PROTOCOL_ALLOWLIST = [
    'http:',
    'https:',
    'ftp:',
    'ftps:',
    'mailto:',
    'skype:',
    'callto:',
    'facetime:',
    'git:',
    'irc:',
    'irc6:',
    'news:',
    'nntp:',
    'feed:',
    'cvs:',
    'svn:',
    'mvn:',
    'ssh:',
    'scp:',
    'sftp:',
    'itms:',
    'notes:',
    'hipchat:',
    'sourcetree:',
    'urn:',
    'tel:',
    'xmpp:',
    'telnet:',
    'vnc:',
    'rdp:',
    'whatsapp:',
    'slack:',
    'sip:',
    'sips:',
    'magnet:',
    'tds:'
];
const $b523a89e0afd2f90$export$300bd6d67c49dbfc = (urlString)=>{
    const url = new URL(urlString || '', window.location.href);
    if ($b523a89e0afd2f90$var$PROTOCOL_ALLOWLIST.includes(url.protocol)) return url.toString();
    else return 'about:blank';
};
function $b523a89e0afd2f90$export$e7bdca014c19fc5c({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("em", null, children);
}
function $b523a89e0afd2f90$export$a6c7ac8248d6e38a({ href: href, children: children, openNewTab: openNewTab, appearance: appearance }) {
    const sanitizedHref = $b523a89e0afd2f90$export$300bd6d67c49dbfc(href);
    if (appearance === 'primary-button' || appearance === 'button') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b523a89e0afd2f90$var$AkButton, {
        appearance: appearance === 'primary-button' ? 'primary' : 'default',
        href: sanitizedHref,
        rel: "noopener noreferrer",
        target: openNewTab ? '_blank' : undefined
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: sanitizedHref,
        rel: "noopener noreferrer",
        target: openNewTab ? '_blank' : undefined
    }, children);
}
function $b523a89e0afd2f90$export$97176b8d51d2058f({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("s", null, children);
}
function $b523a89e0afd2f90$export$89b8e0fa65f6a914({ text: text }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, text);
}
function $b523a89e0afd2f90$export$f301627d437cff88({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, children);
}
function $b523a89e0afd2f90$var$wrap(Component) {
    return function WrappedComponent({ Components: Components, children: children, props: propsAny, render: render, renderChildren: renderChildren, dispatch: dispatch }) {
        const props = propsAny;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props, renderChildren({
            Components: Components,
            children: children,
            render: render,
            dispatch: dispatch
        }));
    };
}
const $b523a89e0afd2f90$export$fec26b2d751c6d95 = $b523a89e0afd2f90$var$wrap($b523a89e0afd2f90$export$e7bdca014c19fc5c);
const $b523a89e0afd2f90$export$7c70dc97eeeaf683 = $b523a89e0afd2f90$var$wrap($b523a89e0afd2f90$export$a6c7ac8248d6e38a);
const $b523a89e0afd2f90$export$e9e7c187aef6a83a = $b523a89e0afd2f90$var$wrap($b523a89e0afd2f90$export$97176b8d51d2058f);
const $b523a89e0afd2f90$export$11a9c970dcafffc0 = $b523a89e0afd2f90$var$wrap($b523a89e0afd2f90$export$89b8e0fa65f6a914);
const $b523a89e0afd2f90$export$566c617eb72a5976 = $b523a89e0afd2f90$var$wrap($b523a89e0afd2f90$export$f301627d437cff88);

});
parcelRegister("1imuF", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iITQN');
        const value = parcelRequire('4St9K');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iITQN").then(()=>parcelRequire('4St9K'));
}

});



parcelRegister("6h1SY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4915cb1608d289a9$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/styles/no-exported-styles */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caLW4 = parcelRequire("caLW4");

var $1v4bv = parcelRequire("1v4bv");
const $4915cb1608d289a9$var$flexGrowMap = {
    hug: (0, $caLW4.xcss)({
        flexGrow: 0
    }),
    fill: (0, $caLW4.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $4915cb1608d289a9$var$separatorStyles = (0, $byn9U.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $4915cb1608d289a9$var$Separator = ({ children: children })=>(0, $byn9U.jsx)("span", {
        css: $4915cb1608d289a9$var$separatorStyles
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $4915cb1608d289a9$var$Inline = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? (0, $byn9U.jsx)($4915cb1608d289a9$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $eUqFw.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return (0, $byn9U.jsx)((0, $eUqFw.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $4915cb1608d289a9$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return (0, $byn9U.jsx)((0, $1v4bv.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$4915cb1608d289a9$var$Inline.displayName = 'Inline';
var $4915cb1608d289a9$export$2e2bcd8739ae039 = $4915cb1608d289a9$var$Inline;

});
parcelRegister("caLW4", function(module, exports) {

$parcel$export(module.exports, "tokensMap", () => $8dcb9a3832b74ebc$export$9a199fbafee0014e);
$parcel$export(module.exports, "parseXcss", () => $8dcb9a3832b74ebc$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $8dcb9a3832b74ebc$export$f6c783d06584602c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $byn9U = parcelRequire("byn9U");

var $fsr0b = parcelRequire("fsr0b");

var $2fFJv = parcelRequire("2fFJv");
const $8dcb9a3832b74ebc$export$9a199fbafee0014e = {
    backgroundColor: (0, $fsr0b.backgroundColorMap),
    blockSize: (0, $fsr0b.dimensionMap),
    borderBlockColor: (0, $fsr0b.borderColorMap),
    borderBlockEndColor: (0, $fsr0b.borderColorMap),
    borderBlockEndWidth: (0, $fsr0b.borderWidthMap),
    borderBlockStartColor: (0, $fsr0b.borderColorMap),
    borderBlockStartWidth: (0, $fsr0b.borderWidthMap),
    borderBlockWidth: (0, $fsr0b.borderWidthMap),
    borderBottomColor: (0, $fsr0b.borderColorMap),
    borderBottomLeftRadius: (0, $fsr0b.borderRadiusMap),
    borderBottomRightRadius: (0, $fsr0b.borderRadiusMap),
    borderBottomWidth: (0, $fsr0b.borderWidthMap),
    borderColor: (0, $fsr0b.borderColorMap),
    borderEndEndRadius: (0, $fsr0b.borderRadiusMap),
    borderEndStartRadius: (0, $fsr0b.borderRadiusMap),
    borderInlineColor: (0, $fsr0b.borderColorMap),
    borderInlineEndColor: (0, $fsr0b.borderColorMap),
    borderInlineEndWidth: (0, $fsr0b.borderWidthMap),
    borderInlineStartColor: (0, $fsr0b.borderColorMap),
    borderInlineStartWidth: (0, $fsr0b.borderWidthMap),
    borderInlineWidth: (0, $fsr0b.borderWidthMap),
    borderLeftColor: (0, $fsr0b.borderColorMap),
    borderLeftWidth: (0, $fsr0b.borderWidthMap),
    borderRadius: (0, $fsr0b.borderRadiusMap),
    borderRightColor: (0, $fsr0b.borderColorMap),
    borderRightWidth: (0, $fsr0b.borderWidthMap),
    borderStartEndRadius: (0, $fsr0b.borderRadiusMap),
    borderStartStartRadius: (0, $fsr0b.borderRadiusMap),
    borderTopColor: (0, $fsr0b.borderColorMap),
    borderTopLeftRadius: (0, $fsr0b.borderRadiusMap),
    borderTopRightRadius: (0, $fsr0b.borderRadiusMap),
    borderTopWidth: (0, $fsr0b.borderWidthMap),
    borderWidth: (0, $fsr0b.borderWidthMap),
    bottom: (0, $fsr0b.allSpaceMap),
    boxShadow: (0, $fsr0b.shadowMap),
    color: (0, $fsr0b.textColorMap),
    columnGap: (0, $fsr0b.positiveSpaceMap),
    gap: (0, $fsr0b.positiveSpaceMap),
    height: (0, $fsr0b.dimensionMap),
    inlineSize: (0, $fsr0b.dimensionMap),
    inset: (0, $fsr0b.allSpaceMap),
    insetBlock: (0, $fsr0b.allSpaceMap),
    insetBlockEnd: (0, $fsr0b.allSpaceMap),
    insetBlockStart: (0, $fsr0b.allSpaceMap),
    insetInline: (0, $fsr0b.allSpaceMap),
    insetInlineEnd: (0, $fsr0b.allSpaceMap),
    insetInlineStart: (0, $fsr0b.allSpaceMap),
    left: (0, $fsr0b.allSpaceMap),
    margin: (0, $fsr0b.allSpaceMap),
    marginBlock: (0, $fsr0b.allSpaceMap),
    marginBlockEnd: (0, $fsr0b.allSpaceMap),
    marginBlockStart: (0, $fsr0b.allSpaceMap),
    marginBottom: (0, $fsr0b.allSpaceMap),
    marginInline: (0, $fsr0b.allSpaceMap),
    marginInlineEnd: (0, $fsr0b.allSpaceMap),
    marginInlineStart: (0, $fsr0b.allSpaceMap),
    marginLeft: (0, $fsr0b.allSpaceMap),
    marginRight: (0, $fsr0b.allSpaceMap),
    marginTop: (0, $fsr0b.allSpaceMap),
    maxBlockSize: (0, $fsr0b.dimensionMap),
    maxHeight: (0, $fsr0b.dimensionMap),
    maxInlineSize: (0, $fsr0b.dimensionMap),
    maxWidth: (0, $fsr0b.dimensionMap),
    minBlockSize: (0, $fsr0b.dimensionMap),
    minHeight: (0, $fsr0b.dimensionMap),
    minInlineSize: (0, $fsr0b.dimensionMap),
    minWidth: (0, $fsr0b.dimensionMap),
    opacity: (0, $fsr0b.opacityMap),
    outlineColor: (0, $fsr0b.borderColorMap),
    outlineOffset: (0, $fsr0b.positiveSpaceMap),
    outlineWidth: (0, $fsr0b.borderWidthMap),
    padding: (0, $fsr0b.positiveSpaceMap),
    paddingBlock: (0, $fsr0b.positiveSpaceMap),
    paddingBlockEnd: (0, $fsr0b.positiveSpaceMap),
    paddingBlockStart: (0, $fsr0b.positiveSpaceMap),
    paddingBottom: (0, $fsr0b.positiveSpaceMap),
    paddingInline: (0, $fsr0b.positiveSpaceMap),
    paddingInlineEnd: (0, $fsr0b.positiveSpaceMap),
    paddingInlineStart: (0, $fsr0b.positiveSpaceMap),
    paddingLeft: (0, $fsr0b.positiveSpaceMap),
    paddingRight: (0, $fsr0b.positiveSpaceMap),
    paddingTop: (0, $fsr0b.positiveSpaceMap),
    right: (0, $fsr0b.allSpaceMap),
    rowGap: (0, $fsr0b.positiveSpaceMap),
    top: (0, $fsr0b.allSpaceMap),
    width: (0, $fsr0b.dimensionMap),
    zIndex: (0, $fsr0b.layerMap)
};
const $8dcb9a3832b74ebc$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const $8dcb9a3832b74ebc$var$isSafeEnvToThrow = ()=>typeof $2fFJv === 'object' && typeof $2fFJv.env === 'object' && false;
const $8dcb9a3832b74ebc$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $8dcb9a3832b74ebc$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $8dcb9a3832b74ebc$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($8dcb9a3832b74ebc$var$transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $8dcb9a3832b74ebc$var$safeSelectors.test(key)) {
            styleObj[key] = $8dcb9a3832b74ebc$var$transformStyles(value);
            return;
        }
        if ($8dcb9a3832b74ebc$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($8dcb9a3832b74ebc$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $8dcb9a3832b74ebc$export$9a199fbafee0014e)) return;
        const tokenValue = $8dcb9a3832b74ebc$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
const $8dcb9a3832b74ebc$var$baseXcss = (style)=>{
    const transformedStyles = $8dcb9a3832b74ebc$var$transformStyles(style);
    return {
        [$8dcb9a3832b74ebc$var$uniqueSymbol]: (0, $byn9U.css)(transformedStyles)
    };
};
const $8dcb9a3832b74ebc$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $8dcb9a3832b74ebc$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [$8dcb9a3832b74ebc$var$uniqueSymbol]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $8dcb9a3832b74ebc$export$f6c783d06584602c(style) {
    return $8dcb9a3832b74ebc$var$baseXcss(style);
}

});
parcelRegister("fsr0b", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", () => $b40e6a8c103cbc9c$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $b40e6a8c103cbc9c$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $b40e6a8c103cbc9c$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $b40e6a8c103cbc9c$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $b40e6a8c103cbc9c$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $b40e6a8c103cbc9c$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $b40e6a8c103cbc9c$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $b40e6a8c103cbc9c$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $b40e6a8c103cbc9c$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $b40e6a8c103cbc9c$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $b40e6a8c103cbc9c$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $b40e6a8c103cbc9c$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "paddingStylesMap", () => $b40e6a8c103cbc9c$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $b40e6a8c103cbc9c$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $b40e6a8c103cbc9c$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "textColorStylesMap", () => $b40e6a8c103cbc9c$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "fontWeightStylesMap", () => $b40e6a8c103cbc9c$export$45f3f4fe16f9f7d5);
$parcel$export(module.exports, "fontStylesMap", () => $b40e6a8c103cbc9c$export$128f10c238242f83);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $b40e6a8c103cbc9c$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $b40e6a8c103cbc9c$export$5e65a44e5b6ecadb);

var $byn9U = parcelRequire("byn9U");

var $kyri3 = parcelRequire("kyri3");
const $b40e6a8c103cbc9c$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $b40e6a8c103cbc9c$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $b40e6a8c103cbc9c$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $b40e6a8c103cbc9c$export$632685d741f3dbbf = {
    ...$b40e6a8c103cbc9c$export$958d0ae7f2977ae4,
    ...$b40e6a8c103cbc9c$export$d2dc61f58390201c
};
const $b40e6a8c103cbc9c$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $b40e6a8c103cbc9c$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $b40e6a8c103cbc9c$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
const $b40e6a8c103cbc9c$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
const $b40e6a8c103cbc9c$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
const $b40e6a8c103cbc9c$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $b40e6a8c103cbc9c$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
const $b40e6a8c103cbc9c$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
const $b40e6a8c103cbc9c$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $b40e6a8c103cbc9c$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
const $b40e6a8c103cbc9c$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
const $b40e6a8c103cbc9c$export$6cc560b4dedf3816 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $b40e6a8c103cbc9c$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
const $b40e6a8c103cbc9c$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
const $b40e6a8c103cbc9c$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $b40e6a8c103cbc9c$var$getSerializedStylesMap = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        emotionSpacingMap[token] = (0, $byn9U.css)({
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $b40e6a8c103cbc9c$export$e615f061ca585a6c = $b40e6a8c103cbc9c$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $b40e6a8c103cbc9c$var$getSerializedStylesMap(spacingProperty, $b40e6a8c103cbc9c$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $b40e6a8c103cbc9c$export$bf46c3f9eeafc71f = $b40e6a8c103cbc9c$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $b40e6a8c103cbc9c$var$getSerializedStylesMap(spacingProperty, $b40e6a8c103cbc9c$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $b40e6a8c103cbc9c$export$e7af83bafe7f9e63 = $b40e6a8c103cbc9c$var$getSerializedStylesMap('backgroundColor', $b40e6a8c103cbc9c$export$d1d79bf68ac056bd);
const $b40e6a8c103cbc9c$export$3a1bcba60b23d7f0 = $b40e6a8c103cbc9c$var$getSerializedStylesMap('color', $b40e6a8c103cbc9c$export$8473307aa00d6ea1);
const $b40e6a8c103cbc9c$export$45f3f4fe16f9f7d5 = $b40e6a8c103cbc9c$var$getSerializedStylesMap('fontWeight', $b40e6a8c103cbc9c$export$303e322c6b1ed114);
const $b40e6a8c103cbc9c$export$68cc305da27dbaa4 = $b40e6a8c103cbc9c$var$getSerializedStylesMap('fontFamily', $b40e6a8c103cbc9c$export$3c7e9587132614b4);
const $b40e6a8c103cbc9c$export$128f10c238242f83 = $b40e6a8c103cbc9c$var$getSerializedStylesMap('font', $b40e6a8c103cbc9c$export$6cc560b4dedf3816);
const $b40e6a8c103cbc9c$export$ff257d957d48c421 = $b40e6a8c103cbc9c$var$getSerializedStylesMap((0, $kyri3.CURRENT_SURFACE_CSS_VAR), $b40e6a8c103cbc9c$export$41a358c9c2356760);
const $b40e6a8c103cbc9c$export$5e65a44e5b6ecadb = (color)=>$b40e6a8c103cbc9c$export$41a358c9c2356760[color] !== undefined;

});


parcelRegister("1v4bv", function(module, exports) {

$parcel$export(module.exports, "default", () => $117beeabbf377f55$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $fsr0b = parcelRequire("fsr0b");

var $caLW4 = parcelRequire("caLW4");
const $117beeabbf377f55$var$justifyContentMap = {
    start: (0, $byn9U.css)({
        justifyContent: 'start'
    }),
    center: (0, $byn9U.css)({
        justifyContent: 'center'
    }),
    end: (0, $byn9U.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $byn9U.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $byn9U.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $byn9U.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $byn9U.css)({
        justifyContent: 'stretch'
    })
};
const $117beeabbf377f55$var$flexDirectionMap = {
    column: (0, $byn9U.css)({
        flexDirection: 'column'
    }),
    row: (0, $byn9U.css)({
        flexDirection: 'row'
    })
};
const $117beeabbf377f55$var$flexWrapMap = {
    wrap: (0, $byn9U.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $byn9U.css)({
        flexWrap: 'nowrap'
    })
};
const $117beeabbf377f55$var$alignItemsMap = {
    start: (0, $byn9U.css)({
        alignItems: 'start'
    }),
    center: (0, $byn9U.css)({
        alignItems: 'center'
    }),
    baseline: (0, $byn9U.css)({
        alignItems: 'baseline'
    }),
    end: (0, $byn9U.css)({
        alignItems: 'end'
    }),
    stretch: (0, $byn9U.css)({
        alignItems: 'stretch'
    })
};
const $117beeabbf377f55$var$baseStyles = (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $117beeabbf377f55$var$Flex = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    const resolvedStyles = (0, $caLW4.parseXcss)(xcss);
    return (0, $byn9U.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $117beeabbf377f55$var$baseStyles,
            gap && (0, $fsr0b.spaceStylesMap).gap[gap],
            columnGap && (0, $fsr0b.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $fsr0b.spaceStylesMap).rowGap[rowGap],
            alignItems && $117beeabbf377f55$var$alignItemsMap[alignItems],
            direction && $117beeabbf377f55$var$flexDirectionMap[direction],
            justifyContent && $117beeabbf377f55$var$justifyContentMap[justifyContent],
            wrap && $117beeabbf377f55$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$117beeabbf377f55$var$Flex.displayName = 'Flex';
var $117beeabbf377f55$export$2e2bcd8739ae039 = $117beeabbf377f55$var$Flex;

});



parcelRegister("3jScb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jf59F');
        const value = parcelRequire('dzmUA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jf59F").then(()=>parcelRequire('dzmUA'));
}

});

parcelRegister("3hHQO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('8tsx0')
        ]);
        const value = parcelRequire('3ij6j');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("8tsx0")
    ]).then(()=>parcelRequire('3ij6j'));
}

});

parcelRegister("3LEEo", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('40127')
        ]);
        const value = parcelRequire('iG5qz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("40127")
    ]).then(()=>parcelRequire('iG5qz'));
}

});


parcelRegister("gamHX", function(module, exports) {

$parcel$export(module.exports, "LazyIframe", () => $06c11067a462069c$export$808646051d5a3908);
$parcel$export(module.exports, "LazyModalIframe", () => $06c11067a462069c$export$f35ac420e260eb7);

var $7rh0R = parcelRequire("7rh0R");

var $1boRu = parcelRequire("1boRu");

const $06c11067a462069c$var$getModule = ()=>(parcelRequire("k9s7y"));
const $06c11067a462069c$export$808646051d5a3908 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$06c11067a462069c$var$getModule().then((module)=>module.IframeRenderer), {
    ssr: false
}));
const $06c11067a462069c$export$f35ac420e260eb7 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazy)(()=>$06c11067a462069c$var$getModule().then((module)=>module.ModalIframeRenderer), {}));

});
parcelRegister("k9s7y", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('8ficv')
        ]);
        const value = parcelRequire('kq5KC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("8ficv")
    ]).then(()=>parcelRequire('kq5KC'));
}

});


parcelRegister("bL3M0", function(module, exports) {

$parcel$export(module.exports, "InvisibleDiv", () => $3b2b331dada7ea6a$export$22ef238a7bbeac70);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $3b2b331dada7ea6a$export$22ef238a7bbeac70 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3b2b331dada7ea6a$var$StyledInvisibleDiv, null, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b2b331dada7ea6a$var$StyledInvisibleDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});




parcelRegister("dLpFo", function(module, exports) {

$parcel$export(module.exports, "default", () => $60fc0d10d7ca8530$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $9sKt4 = parcelRequire("9sKt4");

var $6D0iK = parcelRequire("6D0iK");
const $60fc0d10d7ca8530$export$3a851fb99ee23e6c = (issueKey)=>{
    const [issueState] = (0, $6D0iK.default)(issueKey);
    const { value: issueData = (0, $9sKt4.emptyIssueData), isReady: isReady = false } = issueState ?? {};
    const { backgroundScripts: value = [] } = issueData;
    return [
        {
            value: value,
            isReady: isReady
        }
    ];
};
const $60fc0d10d7ca8530$var$defaultValue = [
    {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: [],
        isReady: true
    }
];
var $60fc0d10d7ca8530$export$2e2bcd8739ae039 = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on'), $60fc0d10d7ca8530$export$3a851fb99ee23e6c, ()=>$60fc0d10d7ca8530$var$defaultValue);

});
parcelRegister("9sKt4", function(module, exports) {

$parcel$export(module.exports, "emptyIssueData", () => $b056aaf4a0a57412$export$1f50bc2ae8ba97cd);
const $b056aaf4a0a57412$export$1f50bc2ae8ba97cd = {
    operations: [],
    backgroundScripts: [],
    deletableAttachmentsCount: 0
};

});


parcelRegister("haEFN", function(module, exports) {

$parcel$export(module.exports, "EcosystemModuleWithoutRefresh", () => $020ea1bd58bcc471$export$3953a40e9f27c69e);
$parcel$export(module.exports, "default", () => $020ea1bd58bcc471$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jLerq = parcelRequire("jLerq");

var $eyYNo = parcelRequire("eyYNo");

var $wKt79 = parcelRequire("wKt79");
const $020ea1bd58bcc471$var$EcosystemModuleBase = (props)=>{
    const { appKey: appKey, moduleKey: moduleKey, options: options, appName: appName, refreshedOn: refreshedOn, location: location } = props;
    const key = refreshedOn ? `connect-iFrame-${appKey}-${moduleKey}-${refreshedOn}` : `connect-iFrame-${appKey}-${moduleKey}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jLerq.EcosystemModuleAsync), {
        key: key,
        appKey: appKey,
        moduleKey: moduleKey,
        options: options,
        appName: appName,
        location: location
    });
};
$020ea1bd58bcc471$var$EcosystemModuleBase.defaultProps = {
    refreshedOn: 0
};
const $020ea1bd58bcc471$var$EcosystemModuleBaseWithoutRefresh = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($020ea1bd58bcc471$var$EcosystemModuleBase, props);
const $020ea1bd58bcc471$export$3953a40e9f27c69e = (0, $wKt79.safeComponent)()($020ea1bd58bcc471$var$EcosystemModuleBaseWithoutRefresh);
const $020ea1bd58bcc471$var$EcosystemModuleWithRefresh = (props)=>{
    const refreshedOn = (0, $eyYNo.useOnDemandIssueRefreshTime)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($020ea1bd58bcc471$var$EcosystemModuleBase, {
        ...props,
        refreshedOn: refreshedOn
    });
};
var $020ea1bd58bcc471$export$2e2bcd8739ae039 = $020ea1bd58bcc471$var$EcosystemModuleWithRefresh;

});
parcelRegister("jLerq", function(module, exports) {

$parcel$export(module.exports, "EcosystemModuleAsync", () => $ec457b27842b5036$export$75ae776ec6b96bba);
$parcel$export(module.exports, "EcosystemTimeoutViewAsync", () => $ec457b27842b5036$export$c800b42cc8eabb03);
$parcel$export(module.exports, "EcosystemExpiredView", () => $ec457b27842b5036$export$de38e5e350ba616f);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $gGtKh = parcelRequire("gGtKh");

var $8dbJr = parcelRequire("8dbJr");

const $ec457b27842b5036$var$EcosystemModule = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("3c7qd")), {
    ssr: true,
    moduleId: "./src/packages/connect-utils/connect-utils-async/src/index.tsx"
});

const $ec457b27842b5036$var$EcosystemTimeoutView = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("epegH")), {
    ssr: true,
    moduleId: "./src/packages/connect-utils/connect-utils-async/src/common/ui/ecosystem-timeout-view/index.tsx"
});
const $ec457b27842b5036$export$75ae776ec6b96bba = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "ecosystem-module-async",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec457b27842b5036$var$EcosystemModule, props));
const $ec457b27842b5036$export$c800b42cc8eabb03 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "ecosystem-timeout-view-async",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec457b27842b5036$var$EcosystemTimeoutView, props));
const $ec457b27842b5036$var$runtimeProps = {};
const $ec457b27842b5036$var$entryPointParams = {};
const $ec457b27842b5036$export$de38e5e350ba616f = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $8dbJr.ecosystemExpiredViewEntryPoint), $ec457b27842b5036$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>entryPointActions.load(), [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "EcosystemExpiredViewEntrypointContainer",
        packageName: "@atlassian/jira-connect-utils-async",
        teamName: "bento",
        runtimeProps: $ec457b27842b5036$var$runtimeProps
    });
};

});
parcelRegister("8dbJr", function(module, exports) {

$parcel$export(module.exports, "ecosystemExpiredViewEntryPoint", () => $d9e78b06fa009a1b$export$1b12380e8898e42);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $d9e78b06fa009a1b$export$1b12380e8898e42 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("380ok")), {
        moduleId: "5b97ea8e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("380ok", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9OzbE');
        const value = parcelRequire('01WRQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9OzbE").then(()=>parcelRequire('01WRQ'));
}

});


parcelRegister("3c7qd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('b9Lnk');
        const value = parcelRequire('7OLHR');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("b9Lnk").then(()=>parcelRequire('7OLHR'));
}

});

parcelRegister("epegH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fJUCR');
        const value = parcelRequire('4Ep9I');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fJUCR").then(()=>parcelRequire('4Ep9I'));
}

});




parcelRegister("chFXd", function(module, exports) {

$parcel$export(module.exports, "EcosystemRealtimeUpdatesView", () => $947a57cd2fc4aea8$export$7b160d7cbcfdca58);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $0cdA8 = parcelRequire("0cdA8");

var $d6g7g = parcelRequire("d6g7g");

var $TCfaC = parcelRequire("TCfaC");

var $8IkU1 = parcelRequire("8IkU1");

var $lAnef = parcelRequire("lAnef");

var $cOlPQ = parcelRequire("cOlPQ");

var $a60Hj = parcelRequire("a60Hj");

var $anFLA = parcelRequire("anFLA");

var $jMP2a = parcelRequire("jMP2a");
const $947a57cd2fc4aea8$var$IntegrationType = {
    FORGE: 'forge',
    CONNECT: 'connect'
};
const $947a57cd2fc4aea8$var$safeInvokeWithReporting = (fn, type)=>(eventDetails, analyticsEvent)=>{
        try {
            fn(eventDetails);
            return true;
        } catch (error) {
            (0, $d6g7g.realTimeIssueEventInvokeTime).failure();
            // Unlike success events, errors ones are reported separately
            // So in case both emits fail we have two error Objects logged
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'issueRealtimeEventEmit failed', {
                type: type,
                error: error
            });
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-view.components.ecosystem.realtime-updates', `Failed to emit realtime issue event for integration: ${type}`, error instanceof Error ? error : undefined);
            return false;
        }
    };
const $947a57cd2fc4aea8$var$onEvent = (eventDetails, analyticsEvent)=>{
    const inSample = (0, $a60Hj.isInSample)((0, $anFLA.REALTIME_EVENTS_ANALYTICS_SAMPLE_RATE));
    if (inSample) (0, $d6g7g.realTimeIssueEventInvokeTime).start();
    const analyticsAttributes = {
        isSynthetic: (0, $cOlPQ.isSynthetic)(),
        [$947a57cd2fc4aea8$var$IntegrationType.CONNECT]: $947a57cd2fc4aea8$var$safeInvokeWithReporting((0, $8IkU1.emitIssueChangedEvent), $947a57cd2fc4aea8$var$IntegrationType.CONNECT)(eventDetails, analyticsEvent) === true,
        [$947a57cd2fc4aea8$var$IntegrationType.FORGE]: $947a57cd2fc4aea8$var$safeInvokeWithReporting((0, $lAnef.emitIssueChangedEvent), $947a57cd2fc4aea8$var$IntegrationType.FORGE)(eventDetails, analyticsEvent) === true
    };
    // Report only when at least a single integration emit is successful
    // We are going to send a single event to reduce amount of data stored since there will be millions of events daily
    if (!analyticsAttributes.forge && !analyticsAttributes.connect) return;
    if (inSample) {
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'issueRealtimeEventEmit success', analyticsAttributes);
        (0, $d6g7g.realTimeIssueEventInvokeTime).success();
    }
};
const $947a57cd2fc4aea8$export$7b160d7cbcfdca58 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "EcosystemRealtimeUpdates",
        /* eslint-disable-next-line jira/js/package-name-enforcer-for-error-boundary */ packageName: "jiraIssueView",
        teamName: "bento",
        fallback: "unmount",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $TCfaC.RealtimeUpdates), {
        onEvent: $947a57cd2fc4aea8$var$onEvent
    }));

});
parcelRegister("TCfaC", function(module, exports) {

$parcel$export(module.exports, "RealtimeUpdates", () => $90b7092038b21d09$export$cebdb67a13de9903);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $bFzGY = parcelRequire("bFzGY");

var $hJ992 = parcelRequire("hJ992");

var $7eDnP = parcelRequire("7eDnP");
var $eyYNo = parcelRequire("eyYNo");


var $4t9T3 = parcelRequire("4t9T3");
const $90b7092038b21d09$export$cebdb67a13de9903 = (props)=>{
    const [_, { setEventAsReported: setEventAsReported }] = (0, $eyYNo.useIssueRefreshServiceActions)();
    const { REALTIME: reportableRefreshEventData } = (0, $eyYNo.useIssueRefreshData)();
    const currentIssueId = (0, $hJ992.useIssueId)();
    const throttleInput = (0, $eUqFw.useRef)({
        issueId: currentIssueId,
        onEvent: props.onEvent,
        events: []
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({});
    // We throttle the callback execution in order to not spam apps with events.
    // In its turn apps won't spam Jira with requests.
    // This throttling works in the way that the first event is reported ASAP
    // and the following ones are batched and sent with a predefined delay (5s at the moment of writing)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttledEventHandler = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(()=>{
        const { issueId: issueId, onEvent: onEvent, events: events } = throttleInput.current;
        if (!issueId) return;
        const payload = (0, $4t9T3.transformEvents)({
            events: events,
            issueId: issueId
        });
        payload && onEvent(payload, analyticsEvent);
        // Reset events after they are reported
        events.length = 0;
    }, (0, $efa5ee34c5613603$export$a316f1e98cf3970d)), []);
    (0, $eUqFw.useEffect)(()=>{
        if (!reportableRefreshEventData || reportableRefreshEventData.reported || reportableRefreshEventData.details.issueId !== currentIssueId) return;
        throttleInput.current.events.push(reportableRefreshEventData.details);
        throttledEventHandler();
        // There are situations when the component remounts e.g. on Backlog screen, while navigating between issues.
        // To avoid reporting the same event more than once, we persist the info about it inside the event.
        setEventAsReported((0, $7eDnP.Reason).Realtime);
    }, [
        currentIssueId,
        reportableRefreshEventData,
        setEventAsReported,
        throttledEventHandler
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            throttledEventHandler.cancel();
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return null;
};

});
const $efa5ee34c5613603$export$a316f1e98cf3970d = 5000;

parcelRegister("4t9T3", function(module, exports) {

$parcel$export(module.exports, "transformEvents", () => $ac5854bc2bd025dd$export$d2d1b9058e806488);

var $lyOYo = parcelRequire("lyOYo");

const $ac5854bc2bd025dd$var$changeTypeMap = {
    [(0, $1d129cd1c8b202ad$export$b22142e61b3fdbee)]: 'updated',
    [(0, $1d129cd1c8b202ad$export$773466d9acc404c0)]: 'commented'
};
const $ac5854bc2bd025dd$var$toChangeDetails = ({ updateType: updateType, atlassianId: atlassianId })=>({
        changeType: $ac5854bc2bd025dd$var$changeTypeMap[updateType] || 'updated',
        atlassianId: atlassianId
    });
const $ac5854bc2bd025dd$var$getUniqueEvents = (events)=>(0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(events, (event)=>`aid:${event.atlassianId}__ct:${event.updateType}`);
const $ac5854bc2bd025dd$export$d2d1b9058e806488 = ({ events: events, issueId: issueId })=>{
    const eventsForIssue = events.filter((event)=>event.issueId === issueId);
    const uniqueEvents = $ac5854bc2bd025dd$var$getUniqueEvents(eventsForIssue);
    if (uniqueEvents.length) {
        const changes = uniqueEvents.map($ac5854bc2bd025dd$var$toChangeDetails);
        const { projectId: projectId } = uniqueEvents[0];
        return {
            issueId: issueId,
            projectId: projectId,
            changes: changes
        };
    }
    return null;
};

});


parcelRegister("8IkU1", function(module, exports) {

$parcel$export(module.exports, "emitIssueChangedEvent", () => $b3572933331c8968$export$bb18fe60013aacbc);

var $dnhZn = parcelRequire("dnhZn");

var $bxDaI = parcelRequire("bxDaI");
const $b3572933331c8968$export$b4b5eff8a8712c89 = 'ISSUE_CHANGED';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b3572933331c8968$var$targetSpecNoDialogs = (registration)=>registration?.extension?.options?.moduleType !== 'dialogs';
const $b3572933331c8968$export$bb18fe60013aacbc = (eventDetails)=>{
    (0, $dnhZn.default)($b3572933331c8968$export$b4b5eff8a8712c89, (0, $bxDaI.isFilterIssueChangedEvents)() ? $b3572933331c8968$var$targetSpecNoDialogs || {} : {}, eventDetails);
};

});
parcelRegister("dnhZn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fad4fd9e63464a6$export$2e2bcd8739ae039);

var $4lxPQ = parcelRequire("4lxPQ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8fad4fd9e63464a6$export$2e2bcd8739ae039 = (eventName, addonFilter, eventData)=>{
    (0, $4lxPQ.withConnectHost)((host)=>{
        host && host.broadcastEvent(eventName, addonFilter, eventData);
    });
};

});

parcelRegister("bxDaI", function(module, exports) {

$parcel$export(module.exports, "isFilterIssueChangedEvents", () => $3d059210c2607b13$export$d616286874a25f83);
$parcel$export(module.exports, "isComingFromSyntheticTest", () => $3d059210c2607b13$export$99b0e29b85c508ac);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $1ybV0 = parcelRequire("1ybV0");
const $3d059210c2607b13$export$d616286874a25f83 = ()=>(0, $1ybV0.ff)('filter-issue-changed-connect-app-events-to-non-dialogs');
const $3d059210c2607b13$export$99b0e29b85c508ac = ()=>(0, $1ybV0.ff)('issue.details.forge-ui-synthetic-check', false);

});


parcelRegister("lAnef", function(module, exports) {

$parcel$export(module.exports, "emitIssueChangedEvent", () => $a778245bccd8abbe$export$bb18fe60013aacbc);

var $eys6T = parcelRequire("eys6T");
const $a778245bccd8abbe$export$b4b5eff8a8712c89 = 'JIRA_ISSUE_CHANGED';
const $a778245bccd8abbe$export$bb18fe60013aacbc = (eventDetails)=>{
    (0, $eys6T.emit)($a778245bccd8abbe$export$b4b5eff8a8712c89, eventDetails);
};

});
parcelRegister("eys6T", function(module, exports) {

$parcel$export(module.exports, "on", () => $a98a0bc47f3535f7$export$af631764ddc44097);
$parcel$export(module.exports, "emit", () => $a98a0bc47f3535f7$export$8f35fbd5db0f3634);
const $a98a0bc47f3535f7$var$EVENT_PREFIX = 'forge.bridge.';
function $a98a0bc47f3535f7$export$af631764ddc44097(event, callback, extension) {
    const wrappedCallback = (e)=>{
        var _e$detail, _e$detail2, _e$detail2$extension, _e$detail3, _e$detail3$extension;
        if (!extension || !((_e$detail = e.detail) !== null && _e$detail !== void 0 && _e$detail.extension) || extension.id === ((_e$detail2 = e.detail) === null || _e$detail2 === void 0 ? void 0 : (_e$detail2$extension = _e$detail2.extension) === null || _e$detail2$extension === void 0 ? void 0 : _e$detail2$extension.id) && extension.installationId === ((_e$detail3 = e.detail) === null || _e$detail3 === void 0 ? void 0 : (_e$detail3$extension = _e$detail3.extension) === null || _e$detail3$extension === void 0 ? void 0 : _e$detail3$extension.installationId)) {
            var _e$detail4, _e$detail5;
            callback((_e$detail4 = e.detail) === null || _e$detail4 === void 0 ? void 0 : _e$detail4.payload, (_e$detail5 = e.detail) === null || _e$detail5 === void 0 ? void 0 : _e$detail5.extension);
        }
    };
    window.document.addEventListener(`${$a98a0bc47f3535f7$var$EVENT_PREFIX}${event}`, wrappedCallback);
    return {
        unsubscribe: ()=>window.document.removeEventListener(`${$a98a0bc47f3535f7$var$EVENT_PREFIX}${event}`, wrappedCallback)
    };
}
function $a98a0bc47f3535f7$export$8f35fbd5db0f3634(event, payload, extension) {
    const newEvent = new CustomEvent(`${$a98a0bc47f3535f7$var$EVENT_PREFIX}${event}`, {
        detail: {
            extension: extension,
            payload: payload
        }
    });
    window.document.dispatchEvent(newEvent);
}

});


parcelRegister("cOlPQ", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $c989a59f21f8986f$export$947749d756ccb0a);

var $6rW04 = parcelRequire("6rW04");

var $bxDaI = parcelRequire("bxDaI");
const $c989a59f21f8986f$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $6rW04.default)('ajs-is-synthetic') === 'true' || (0, $bxDaI.isComingFromSyntheticTest)();

});


parcelRegister("l2nPa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b25227d7ee8af6f$export$2e2bcd8739ae039);

var $2Mm86 = parcelRequire("2Mm86");

var $lqalZ = parcelRequire("lqalZ");

var $g2ZFU = parcelRequire("g2ZFU");
var $9b25227d7ee8af6f$export$2e2bcd8739ae039 = (0, $lqalZ.connect)(null, {
    login: $g2ZFU.login
})((0, $2Mm86.AuthenticationErrorViewLegacy));

});
parcelRegister("2Mm86", function(module, exports) {

$parcel$export(module.exports, "AuthenticationErrorViewLegacy", () => $13a5ec4ea8598c0a$export$c474923b7555f309);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lVx5t = parcelRequire("lVx5t");

var $gAcfY = parcelRequire("gAcfY");

var $gBlkW = parcelRequire("gBlkW");
const $13a5ec4ea8598c0a$export$c474923b7555f309 = (props)=>{
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAcfY.ErrorDisplay), {
        header: intl.formatMessage((0, $gBlkW.messages).authErrorHeader),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($13a5ec4ea8598c0a$var$Image, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($lVx5t))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default // @ts-expect-error - TS2322 - Type '{ children: string; externalId: string; appearance: "primary"; onClick: () => void; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
    ), {
        externalId: "issue.login",
        appearance: "primary",
        onClick: props.login,
        interactionName: "auto-generated.jira-issue-view-errors.ui.authentication-error-view-legacy.button"
    }, intl.formatMessage((0, $gBlkW.messages).authButton)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $13a5ec4ea8598c0a$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1lit _otyrpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gBlkW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d6093f6ab23af9b2$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $d6093f6ab23af9b2$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    authErrorHeader: {
        "id": "issue-view-errors.authentication-error-view-legacy.auth-error-header",
        "defaultMessage": "Log in to Jira to see this issue"
    },
    authButton: {
        "id": "issue-view-errors.authentication-error-view-legacy.auth-button",
        "defaultMessage": "Log in"
    }
});

});



parcelRegister("jdza9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b06a1cd84ef930c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $lqalZ = parcelRequire("lqalZ");

var $jCb4j = parcelRequire("jCb4j");

var $lhz9J = parcelRequire("lhz9J");

var $7b06a1cd84ef930c$export$2e2bcd8739ae039 = (0, $lqalZ.connect)(null, (dispatch)=>({
        dispatch: dispatch
    }))((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "keyboard-shortcuts",
        packageName: "issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jCb4j.default), props)));

});
parcelRegister("jCb4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $e70956b9a0fab14c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $axKFq = parcelRequire("axKFq");

var $hJ992 = parcelRequire("hJ992");

var $keOMr = parcelRequire("keOMr");

var $1OJS4 = parcelRequire("1OJS4");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7uVYl = parcelRequire("7uVYl");


var $g6pq8 = parcelRequire("g6pq8");
var $9ij5S = parcelRequire("9ij5S");
var $aNWF7 = parcelRequire("aNWF7");

var $lhz9J = parcelRequire("lhz9J");
// Tests for binding shortcut keys to actions are handled in the `@atlassian/jira-common-components-keyboard-shortcuts/src/shortcuts` package.
const $e70956b9a0fab14c$var$KeyboardShortcutsView = (props)=>{
    const { dispatch: dispatch } = props;
    const issueKey = (0, $hJ992.useIssueKey)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { triggerComponent: triggerComponent, triggerFocusedPanel: triggerFocusedPanel }] = (0, $lhz9J.useIssueKeyboardShortcutsActions)();
    const [, { setShortcutsDialogVisibility: setShortcutsDialogVisibility }] = (0, $7uVYl.useShortcutsActions)();
    const triggerShortcutAction = (0, $eUqFw.useCallback)((action, name, key)=>{
        setTimeout(()=>dispatch(action), 0);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'keyboardShortcut pressed', `${name}KeyboardShortcut`, {
            key: key
        });
    }, [
        createAnalyticsEvent,
        dispatch
    ]);
    const triggerDotDialogShortcutAction = (0, $eUqFw.useCallback)((name, key)=>{
        requestAnimationFrame(()=>setShortcutsDialogVisibility(true));
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'keyboardShortcut pressed', `${name}KeyboardShortcut`, {
            key: key
        });
        // open dot dialog triggers an extra event
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'keyboardShortcut pressed', 'dotDialogKeyboardShortcut', {
            key: key,
            view: 'NEW_ISSUE_VIEW'
        });
    }, [
        createAnalyticsEvent,
        setShortcutsDialogVisibility
    ]);
    const navigateToIssue = (0, $eUqFw.useCallback)((toIssueKey)=>{
        if (toIssueKey !== issueKey) dispatch((0, $1OJS4.navigateToNewIssue)({
            fromIssueKey: issueKey,
            toIssueKey: toIssueKey
        }));
    }, [
        dispatch,
        issueKey
    ]);
    const triggerShortcutComponent = (0, $eUqFw.useCallback)((component, name, key)=>{
        triggerComponent(component);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'keyboardShortcut pressed', `${name}KeyboardShortcut`, {
            key: key
        });
    }, [
        triggerComponent,
        createAnalyticsEvent
    ]);
    const triggerShortcutPanelFocus = (0, $eUqFw.useCallback)((panel, name)=>{
        if (panel === (0, $c51eac624bf70214$export$b456fa9fa3286243)) triggerFocusedPanel('RIGHT');
        else triggerFocusedPanel('LEFT');
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'keyboardShortcut pressed', `${name}KeyboardShortcut`);
    }, [
        triggerFocusedPanel,
        createAnalyticsEvent
    ]);
    const issueActionsShortcutsKeyMap = (0, $9ij5S.default)(triggerShortcutAction, triggerShortcutComponent, triggerShortcutPanelFocus);
    const menuShortcutsKeyMap = (0, $aNWF7.default)(triggerDotDialogShortcutAction);
    const boardNavigationShortcutsKeyMap = (0, $g6pq8.default)(navigateToIssue);
    const shortcutsKeyMap = (0, $eUqFw.useMemo)(()=>({
            ...issueActionsShortcutsKeyMap,
            ...boardNavigationShortcutsKeyMap,
            ...menuShortcutsKeyMap
        }), [
        boardNavigationShortcutsKeyMap,
        issueActionsShortcutsKeyMap,
        menuShortcutsKeyMap
    ]);
    if ((0, $keOMr.useIsEmbedMode)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $axKFq.CommandShortcuts), {
        keyMap: shortcutsKeyMap
    });
};
var $e70956b9a0fab14c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($e70956b9a0fab14c$var$KeyboardShortcutsView);

});
parcelRegister("axKFq", function(module, exports) {

$parcel$export(module.exports, "CommandShortcuts", () => $cc0f6b42d78d14cf$export$7ff7e4fe85a5960a);

var $eUqFw = parcelRequire("eUqFw");

var $6jiFZ = parcelRequire("6jiFZ");

var $fmmnJ = parcelRequire("fmmnJ");
var $awzwr = parcelRequire("awzwr");

var $9aFSa = parcelRequire("9aFSa");
const $cc0f6b42d78d14cf$export$7ff7e4fe85a5960a = (props)=>{
    const { keyMap: keyMap } = props;
    const mappedCommands = (0, $eUqFw.useMemo)(()=>{
        const commands = [];
        Object.entries(keyMap).forEach(([key, mapItem])=>{
            if (!mapItem.registerInCommandPalette) return;
            const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
            let shortcutPrimaryAction;
            if (primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST || primaryAction?.type === (0, $6jiFZ.CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
            else if (mapItem.callback) shortcutPrimaryAction = {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>mapItem.callback()
            };
            /**
			 * loadChildren function has the preference over the other actions
			 * followed by perform and then, if none set, the KeyMap callback
			 */ commands.push({
                id: `command-shortcut-${key}`,
                shortcut: key,
                ...command,
                primaryAction: shortcutPrimaryAction
            });
        });
        return commands;
    }, [
        keyMap
    ]);
    /**
	 * As mappedCommands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const shortcutIds = (0, $eUqFw.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
        mappedCommands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), props), !!mappedCommands.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awzwr.RegisterCommands), {
        registrationId: (0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
        commands: mappedCommands,
        deps: [
            shortcutIds
        ]
    }));
};

});
parcelRegister("6jiFZ", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $5c36304d2fa4b1a2$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $5c36304d2fa4b1a2$export$904b2a0e38a1bef3);
var $5c36304d2fa4b1a2$export$f041b1b117ab382f;
(function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
})($5c36304d2fa4b1a2$export$f041b1b117ab382f || ($5c36304d2fa4b1a2$export$f041b1b117ab382f = {}));
const $5c36304d2fa4b1a2$export$3e448fd53031e13c = Object.values($5c36304d2fa4b1a2$export$f041b1b117ab382f);
const $5c36304d2fa4b1a2$export$904b2a0e38a1bef3 = [
    "command-list"
];

});

parcelRegister("fmmnJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $2688cae36ed8d4f6$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $2688cae36ed8d4f6$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $2688cae36ed8d4f6$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $2688cae36ed8d4f6$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $2688cae36ed8d4f6$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.COPY_URL,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.DESCRIPTION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.LOG_WORK,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PARENT,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_ADD,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_SEARCH,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.SHORTCUTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STATUS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STORY_POINTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.THEME_MODE,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    }
};

});

parcelRegister("awzwr", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $42c02b036374b0c2$export$cd555833c78729f1);

var $eUqFw = parcelRequire("eUqFw");

var $7ElYg = parcelRequire("7ElYg");
const $42c02b036374b0c2$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ElYg.RegisterCommandsWithRegistry), props);

});
parcelRegister("7ElYg", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $f8fb4bce96babd2d$export$b8955a01360d2876);

var $fqCN8 = parcelRequire("fqCN8");
function $f8fb4bce96babd2d$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $fqCN8.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});
parcelRegister("fqCN8", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $f1b669646bbb8295$export$8a824ae164ff968d);

var $eUqFw = parcelRequire("eUqFw");

var $7Xm2s = parcelRequire("7Xm2s");
function $f1b669646bbb8295$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $7Xm2s.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $eUqFw.useRef)(commands);
    (0, $eUqFw.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("7Xm2s", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $ed5a0599e1840fb5$export$880fc01e31710b27);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");
function $ed5a0599e1840fb5$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $gCtL7.useActionsCommandPalette)();
    const subscribe = (0, $eUqFw.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});
parcelRegister("gCtL7", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $9139bfe8dcd2ea64$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $9139bfe8dcd2ea64$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $9139bfe8dcd2ea64$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $9139bfe8dcd2ea64$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $9139bfe8dcd2ea64$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $9139bfe8dcd2ea64$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $9139bfe8dcd2ea64$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $9139bfe8dcd2ea64$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $9139bfe8dcd2ea64$export$bbc05723eb144e03);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");

var $1ybV0 = parcelRequire("1ybV0");

var $8FbYY = parcelRequire("8FbYY");

var $li0m0 = parcelRequire("li0m0");
const $9139bfe8dcd2ea64$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $9139bfe8dcd2ea64$var$store = (0, $a61MH.createStore)({
    initialState: $9139bfe8dcd2ea64$var$initialState,
    actions: $li0m0.actions,
    name: 'commandPalette'
});
const $9139bfe8dcd2ea64$export$6b58f9610017fbb7 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36 = (0, $ggKAj.createActionsHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $9139bfe8dcd2ea64$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $9139bfe8dcd2ea64$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $8FbYY.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $8FbYY.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $8FbYY.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        ...(0, $1ybV0.ff)('compal.search-algorithm-analytics') ? {
            relevancyModel: 'v2-string-similarity'
        } : {}
    });
const $9139bfe8dcd2ea64$export$1f90c8f89f98110e = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$56f06313122d0aac
});
const $9139bfe8dcd2ea64$export$cc979be9b69236df = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$af8fd8cd4b048315 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $9139bfe8dcd2ea64$export$4372697329bd9cbe = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $9139bfe8dcd2ea64$export$7422170a403e909 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $9139bfe8dcd2ea64$export$282aa48e4a3afada = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$96819dfb22ad05d3 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $9139bfe8dcd2ea64$export$a40e8ae3e53feab0 = (0, $bj4JM.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $8FbYY.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $9139bfe8dcd2ea64$export$f893891deedab3c6 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$a40e8ae3e53feab0
});
const $9139bfe8dcd2ea64$export$bbc05723eb144e03 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("8FbYY", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $faf99007a5829b26$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $faf99007a5829b26$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $faf99007a5829b26$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $faf99007a5829b26$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $faf99007a5829b26$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $faf99007a5829b26$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $faf99007a5829b26$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $faf99007a5829b26$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $faf99007a5829b26$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $faf99007a5829b26$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $faf99007a5829b26$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $faf99007a5829b26$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $faf99007a5829b26$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $faf99007a5829b26$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $faf99007a5829b26$export$c3d20e8c1e93a572);

var $eUqFw = parcelRequire("eUqFw");

var $3IRl5 = parcelRequire("3IRl5");

var $igOBb = parcelRequire("igOBb");

var $1ybV0 = parcelRequire("1ybV0");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");
const $faf99007a5829b26$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $faf99007a5829b26$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $faf99007a5829b26$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $faf99007a5829b26$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $faf99007a5829b26$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $faf99007a5829b26$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $faf99007a5829b26$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $faf99007a5829b26$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $faf99007a5829b26$export$389b0273703d5c48(sections)
    };
};
const $faf99007a5829b26$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $faf99007a5829b26$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...(0, $1ybV0.ff)('fix-register-searchable-command-with-registryid') && $faf99007a5829b26$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands),
        ...$faf99007a5829b26$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$faf99007a5829b26$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $faf99007a5829b26$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $faf99007a5829b26$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $faf99007a5829b26$export$daa5beabdf8d9fc3 = (event)=>(0, $igOBb.isMacOs)() ? event.metaKey : event.ctrlKey;
const $faf99007a5829b26$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $faf99007a5829b26$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $faf99007a5829b26$export$fa1c95a5ffa92036 = (str)=>(0, $3IRl5.createHash)().update(str).digest('hex');
const $faf99007a5829b26$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $faf99007a5829b26$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $faf99007a5829b26$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $faf99007a5829b26$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("igOBb", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $a127768fd887ea5b$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $a127768fd887ea5b$export$fe66dae91c68619b);
const $a127768fd887ea5b$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $a127768fd887ea5b$export$fe66dae91c68619b = ()=>$a127768fd887ea5b$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("ftpwV", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $48b165edb54974f4$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $48b165edb54974f4$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $48b165edb54974f4$export$1ee9d153576afd13);
// EVENT TYPES
const $48b165edb54974f4$export$a1562d08625f5d7e = 'UI';
const $48b165edb54974f4$export$947dac6c72b26f81 = 'TRACK';
const $48b165edb54974f4$export$f1d537d508d2945a = 'SCREEN';
const $48b165edb54974f4$export$12346a674644c156 = 'OPERATIONAL';
var $48b165edb54974f4$export$1ee9d153576afd13;
(function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
})($48b165edb54974f4$export$1ee9d153576afd13 || ($48b165edb54974f4$export$1ee9d153576afd13 = {}));

});


parcelRegister("li0m0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $476b965ceb7c28b6$export$e324594224ef24da);

var $MdoH4 = parcelRequire("MdoH4");

var $hompL = parcelRequire("hompL");

var $igOBb = parcelRequire("igOBb");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $9lcOH = parcelRequire("9lcOH");

var $duQ8C = parcelRequire("duQ8C");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");

var $8FbYY = parcelRequire("8FbYY");

var $gklnd = parcelRequire("gklnd");

var $2fkzb = parcelRequire("2fkzb");
const $476b965ceb7c28b6$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $476b965ceb7c28b6$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        setState({
            commandPaletteSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $476b965ceb7c28b6$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$476b965ceb7c28b6$var$rootCommands
        });
    };
const $476b965ceb7c28b6$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4() : '',
            ...!isOpen ? $476b965ceb7c28b6$var$rootCommands : {}
        });
    };
const $476b965ceb7c28b6$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $476b965ceb7c28b6$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $476b965ceb7c28b6$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if ((0, $1ybV0.ff)('compal-refactor-analytics') && currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $ftpwV.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        else if (!(0, $1ybV0.ff)('compal-refactor-analytics') && analytics?.onAnalyticsOld && analytics?.createAnalyticsEvent) analytics.onAnalyticsOld(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $ftpwV.TRACK_EVENT_TYPE), {
            cpMenu: currentState.expandedCommand?.id || 'rootMenu',
            searchSessionId: currentState.commandPaletteSessionId,
            action: goToRoot ? 'backToRoot' : 'backToParent',
            actionCategory: 'back',
            method: analytics?.method
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $476b965ceb7c28b6$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $476b965ceb7c28b6$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $476b965ceb7c28b6$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $8FbYY.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $476b965ceb7c28b6$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $duQ8C.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $9lcOH.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $476b965ceb7c28b6$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $gklnd.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $8FbYY.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        const currentCommandAction = (0, $8FbYY.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if ((0, $1ybV0.ff)('compal-refactor-analytics') && currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        } else if (!(0, $1ybV0.ff)('compal-refactor-analytics') && analytics?.onAnalyticsOld && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            analytics.onAnalyticsOld(analyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                ...analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $8FbYY.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $6jiFZ.CommandActionType).PERFORM;
        if (shouldLoadChildren) {
            (0, $duQ8C.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $2fkzb.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if ((0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r')) {
                if (currentCommandAction.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
            }
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if ((0, $1ybV0.ff)('compal-refactor-analytics') && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                } else if (!(0, $1ybV0.ff)('compal-refactor-analytics') && analytics?.onAnalyticsOld && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    analytics.onAnalyticsOld(closeAnalyticsEvent, (0, $ftpwV.UI_EVENT_TYPE), analyticsAttributes);
                }
            }
            if ((0, $1ybV0.ff)('compal-refactor-analytics') && wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $igOBb.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            } else if (!(0, $1ybV0.ff)('compal-refactor-analytics') && wasSecondaryTriggered && analytics?.onAnalyticsOld && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                analytics.onAnalyticsOld(closeAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                    ...analyticsAttributes,
                    keyPressed: (0, $igOBb.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                    ...currentCommandAction.analyticsArgs
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $duQ8C.default)('command-palette-executed');
                currentCommandAction.perform();
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $9lcOH.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analytics?.attributes
                }
            });
        }
    };
const $476b965ceb7c28b6$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $476b965ceb7c28b6$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $476b965ceb7c28b6$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $476b965ceb7c28b6$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $476b965ceb7c28b6$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $476b965ceb7c28b6$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $476b965ceb7c28b6$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $476b965ceb7c28b6$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $476b965ceb7c28b6$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $476b965ceb7c28b6$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $476b965ceb7c28b6$export$e324594224ef24da = {
    open: $476b965ceb7c28b6$var$open,
    toggle: $476b965ceb7c28b6$var$toggle,
    close: $476b965ceb7c28b6$var$close,
    addCommands: $476b965ceb7c28b6$var$addCommands,
    removeCommands: $476b965ceb7c28b6$var$removeCommands,
    handleSearch: $476b965ceb7c28b6$var$handleSearch,
    forceFocusSearch: $476b965ceb7c28b6$var$forceFocusSearch,
    setActiveIndex: $476b965ceb7c28b6$var$setActiveIndex,
    executeCommand: $476b965ceb7c28b6$var$executeCommand,
    goBackLevel: $476b965ceb7c28b6$var$goBackLevel,
    setChildCommands: $476b965ceb7c28b6$var$setChildCommands,
    setLoadingList: $476b965ceb7c28b6$var$setLoadingList,
    setFocusInput: $476b965ceb7c28b6$var$setFocusInput,
    registerSections: $476b965ceb7c28b6$var$registerSections,
    unregisterSections: $476b965ceb7c28b6$var$unregisterSections,
    markAsLoaded: $476b965ceb7c28b6$var$markAsLoaded,
    getAnalyticsAttributes: $476b965ceb7c28b6$var$getAnalyticsAttributes,
    setIsDisabled: $476b965ceb7c28b6$var$setIsDisabled,
    setRegistry: $476b965ceb7c28b6$var$setRegistry,
    updateActiveRegistry: $476b965ceb7c28b6$var$updateActiveRegistry,
    removeCommandsById: $476b965ceb7c28b6$var$removeCommandsById,
    removeFromActiveRegistry: $476b965ceb7c28b6$var$removeFromActiveRegistry,
    performDialogCloseCommand: $476b965ceb7c28b6$var$performDialogCloseCommand,
    setAnalytics: $476b965ceb7c28b6$var$setAnalytics,
    setFallbackOverride: $476b965ceb7c28b6$var$setFallbackOverride
};

});
parcelRegister("gklnd", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b93b5138b1f374a6$export$639b7f41b0b47a01);

var $6jiFZ = parcelRequire("6jiFZ");
const $b93b5138b1f374a6$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("2fkzb", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $20c016b992336e05$export$d75616d77443fe4e);

var $6jiFZ = parcelRequire("6jiFZ");
const $20c016b992336e05$export$d75616d77443fe4e = (action)=>action?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});







parcelRegister("9aFSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $80173688b586a9b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Q1yP = parcelRequire("7Q1yP");

var $cIhGE = parcelRequire("cIhGE");

var $haeC1 = parcelRequire("haeC1");

var $fVFUy = parcelRequire("fVFUy");

var $kGQen = parcelRequire("kGQen");

var $h80SI = parcelRequire("h80SI");
let $80173688b586a9b5$var$shortcutsCount = 0;
let $80173688b586a9b5$var$subscription = null;
const $80173688b586a9b5$var$ShortcutsSubscriber = ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eUqFw.useContext)((0, $kGQen.ShortcutRegistryContext)) || (0, $fVFUy.rootRegistry);
    const addKeyMap = (0, $eUqFw.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $h80SI.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $80173688b586a9b5$var$shortcutsCount -= 1;
            if ($80173688b586a9b5$var$subscription && $80173688b586a9b5$var$shortcutsCount === 0) {
                $80173688b586a9b5$var$subscription.unsubscribe();
                $80173688b586a9b5$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$subscription = $80173688b586a9b5$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cIhGE.default)().subscribe((0, $haeC1.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80173688b586a9b5$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $7Q1yP.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80173688b586a9b5$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("7Q1yP", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e8e091cfd61e9197$export$a33a81f1fc5458ad);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");
const $e8e091cfd61e9197$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e8e091cfd61e9197$export$b62f67be35e65859 = (baseUrl, analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e8e091cfd61e9197$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $lRmyA.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    // eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e8e091cfd61e9197$var$Store = (0, $a61MH.createStore)({
    initialState: {
        isEnabled: !((0, $6rW04.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '(baseUrl: string, analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: (baseUrl: string, analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e8e091cfd61e9197$export$b62f67be35e65859
    }
});
const $e8e091cfd61e9197$export$a33a81f1fc5458ad = (0, $ggKAj.createHook)($e8e091cfd61e9197$var$Store);
const $e8e091cfd61e9197$export$a0308f0e05568f25 = (0, $dYfll.createSubscriber)($e8e091cfd61e9197$var$Store);

});

parcelRegister("cIhGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e80b5974f2eb64$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $61e80b5974f2eb64$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("5dKXv");
parcelRequire("8OtG5");
parcelRequire("fWv6o");
parcelRequire("flmol");
parcelRequire("7Rus6");
parcelRequire("azOPD");
parcelRequire("1d9Hc");

var $1YqdI = parcelRequire("1YqdI");
const $61e80b5974f2eb64$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $61e80b5974f2eb64$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$61e80b5974f2eb64$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$61e80b5974f2eb64$var$isEditable(e.target) && !$61e80b5974f2eb64$var$ignoredKeys[e.key]);
const $61e80b5974f2eb64$export$25d1b8252b4c49b7 = ()=>{
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $61e80b5974f2eb64$var$key$;
const $61e80b5974f2eb64$var$flush$ = new (0, $70s4u.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61e80b5974f2eb64$export$2e2bcd8739ae039 = ()=>{
    if (!$61e80b5974f2eb64$var$key$) {
        $61e80b5974f2eb64$var$key$ = (0, $3JafE.Observable).fromEvent(document, 'keydown').filter($61e80b5974f2eb64$var$isRelevantKeyEvent).filter($61e80b5974f2eb64$export$25d1b8252b4c49b7).map((0, $1YqdI.toKeyWithModifiers));
        const sequence$ = $61e80b5974f2eb64$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $61e80b5974f2eb64$var$key$ = $61e80b5974f2eb64$var$key$.debounceTime(1000).startWith(null).merge($61e80b5974f2eb64$var$flush$).switchMapTo(sequence$);
    }
    return $61e80b5974f2eb64$var$key$;
};
const $61e80b5974f2eb64$export$4909b86c8034bf73 = ()=>{
    $61e80b5974f2eb64$var$flush$.next();
};

});

parcelRegister("haeC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bf9c8ab51bd76c$export$2e2bcd8739ae039);

var $cIhGE = parcelRequire("cIhGE");

var $fVFUy = parcelRequire("fVFUy");
const $44bf9c8ab51bd76c$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$44bf9c8ab51bd76c$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $fVFUy.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $cIhGE.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($44bf9c8ab51bd76c$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $cIhGE.flush)();
    }
};

});

parcelRegister("h80SI", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $2297a6a3d8ab933d$export$77477772a9b904da);

var $gUUjF = parcelRequire("gUUjF");
const $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $2297a6a3d8ab933d$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});



parcelRegister("7uVYl", function(module, exports) {

$parcel$export(module.exports, "useShortcuts", () => $76686ee3e3d6a06c$export$a1ca853c6e4bb6fb);
$parcel$export(module.exports, "useShortcutsActions", () => $76686ee3e3d6a06c$export$b331ee6e87b9104c);

var $fvC6Z = parcelRequire("fvC6Z");
const $76686ee3e3d6a06c$export$a1ca853c6e4bb6fb = ()=>(0, $fvC6Z.useShortcutsStore)();
const $76686ee3e3d6a06c$export$b331ee6e87b9104c = ()=>{
    const [, actions] = (0, $fvC6Z.useShortcutsActionsStore)();
    return [
        undefined,
        actions
    ];
};

});
parcelRegister("fvC6Z", function(module, exports) {

$parcel$export(module.exports, "useShortcutsStore", () => $896347e3151ace81$export$a14646bfc7ba8d81);
$parcel$export(module.exports, "useShortcutsActionsStore", () => $896347e3151ace81$export$1a29bfef7fa09838);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $4Dsz6 = parcelRequire("4Dsz6");
const $896347e3151ace81$export$d4c72bab9d6cc13a = {
    shortcuts: {
        admin: {
            key: 'admin',
            label: 'ADMIN',
            options: [],
            isLoaded: false
        }
    },
    isShortcutsDialogVisible: false,
    isShortcutsLoading: false,
    hasError: false,
    isAdminLoading: false,
    selectedItemKey: null,
    header: null,
    title: undefined
};
const $896347e3151ace81$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'shortcuts',
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly shortcuts: { readonly admin: { readonly key: "admin"; readonly label: "ADMIN"; readonly options: readonly []; readonly isLoaded: false; }; }; readonly isShortcutsDialogVisible: false; readonly isShortcutsLoading: false; ... 4 more ...; readonly title: undefined; }' is not assignable to type 'State'.
    $896347e3151ace81$export$d4c72bab9d6cc13a,
    actions: $4Dsz6
});
const $896347e3151ace81$export$a14646bfc7ba8d81 = (0, $ggKAj.createHook)($896347e3151ace81$export$6f57813fe9f31bf9);
const $896347e3151ace81$export$1a29bfef7fa09838 = (0, $ggKAj.createHook)($896347e3151ace81$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("4Dsz6", function(module, exports) {

$parcel$export(module.exports, "registerShortcuts", () => $9eb9f475a5856f0f$export$598ec0e6047cbdca);
$parcel$export(module.exports, "setShortcutsDialogVisibility", () => $9eb9f475a5856f0f$export$80ab1e79e32c3021);
$parcel$export(module.exports, "setShortcutsLoading", () => $9eb9f475a5856f0f$export$7ed2ac8328423043);
$parcel$export(module.exports, "setHasError", () => $9eb9f475a5856f0f$export$645a7c7453685186);
$parcel$export(module.exports, "setHeader", () => $9eb9f475a5856f0f$export$604ed74fb893f0e2);
$parcel$export(module.exports, "fetchAdminSections", () => $9eb9f475a5856f0f$export$aec87c8c9bde62e6);
$parcel$export(module.exports, "setSelectedItemKey", () => $9eb9f475a5856f0f$export$249c9d5b49cd9712);
$parcel$export(module.exports, "dropShortcutsByKeys", () => $9eb9f475a5856f0f$export$9cf39adf0dec984);

var $iVIEg = parcelRequire("iVIEg");

var $6QsdI = parcelRequire("6QsdI");

var $kh3b8 = parcelRequire("kh3b8");
const $9eb9f475a5856f0f$export$598ec0e6047cbdca = (shortcuts)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const newShortcuts = shortcuts.reduce((acc, current)=>{
            acc[current.key] = current;
            return acc;
        }, {
            ...currentState.shortcuts
        });
        setState({
            ...currentState,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };
const $9eb9f475a5856f0f$export$80ab1e79e32c3021 = (isVisible)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsDialogVisible: isVisible
        });
    };
const $9eb9f475a5856f0f$export$7ed2ac8328423043 = (isLoading)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsLoading: isLoading
        });
    };
const $9eb9f475a5856f0f$export$645a7c7453685186 = (hasError)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            hasError: hasError
        });
    };
const $9eb9f475a5856f0f$export$604ed74fb893f0e2 = (header, title)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            header: header,
            title: title
        });
    };
const $9eb9f475a5856f0f$export$aec87c8c9bde62e6 = ()=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            isAdminLoading: true
        });
        const result = await (0, $6QsdI.default)();
        const shortcuts = result ? (0, $kh3b8.buildAdminSections)(result) : [];
        const newState = getState();
        setState({
            ...newState,
            shortcuts: {
                ...newState.shortcuts,
                admin: {
                    ...newState.shortcuts.admin,
                    key: 'admin',
                    options: shortcuts,
                    isLoaded: true
                }
            },
            hasError: currentState.hasError || !result,
            isAdminLoading: false
        });
    };
const $9eb9f475a5856f0f$export$249c9d5b49cd9712 = (item)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            selectedItemKey: item
        });
    };
const $9eb9f475a5856f0f$export$9cf39adf0dec984 = (keys)=>({ getState: getState, setState: setState })=>{
        if (!keys.length) return;
        const { shortcuts: shortcuts, ...rest } = getState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newShortcuts = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(Object.keys(shortcuts), keys).reduce((acc, key)=>{
            acc[key] = shortcuts[key];
            return acc;
        }, {});
        setState({
            ...rest,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };

});
parcelRegister("iVIEg", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $hKE3p = parcelRequire("hKE3p");

var $9eFtX = parcelRequire("9eFtX");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $dc802f203e524f15$var$difference = $9eFtX(function(array, values) {
    return $cRpul(array) ? $fa0Ox(array, $hKE3p(values, 1, $cRpul, true)) : [];
});
module.exports = $dc802f203e524f15$var$difference;

});

parcelRegister("6QsdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd5b36ae9a64aed1$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dd5b36ae9a64aed1$export$2e2bcd8739ae039 = async ()=>{
    try {
        return await (0, $2OdyW.default)('/rest/adminquicksearch/latest/links/default');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('shortcuts-dialog.fetch-admin-links', error.toString());
        return null;
    }
};

});

parcelRegister("kh3b8", function(module, exports) {

$parcel$export(module.exports, "buildAdminSections", () => $978ed85a7f52065b$export$5f8c94ecd4c9eb76);
const $978ed85a7f52065b$export$5f8c94ecd4c9eb76 = (parent, result = [])=>{
    if (parent.sections && parent.sections.length) parent.sections.forEach((s)=>$978ed85a7f52065b$export$5f8c94ecd4c9eb76(s, result));
    if (parent.items && parent.items.length) parent.items.forEach((i)=>result.push({
            key: i.key,
            label: i.label,
            // @ts-expect-error - TS2322 - Type '() => void' is not assignable to type '(event?: Event | undefined) => Promise<undefined> | undefined'.
            onClick: ()=>{
                window.location.href = i.linkUrl;
            }
        }));
    return result;
};

});




parcelRegister("g6pq8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cedba0651a88f71$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hJ992 = parcelRequire("hJ992");


var $3WSGi = parcelRequire("3WSGi");

var $l9WRb = parcelRequire("l9WRb");
const $7cedba0651a88f71$var$useBoardNavigationShortcuts = (navigateToIssue)=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const rapidViewMap = (0, $hJ992.useRapidViewMap)();
    // @ts-expect-error - TS2322 - Type '{ j?: undefined; k?: undefined; n?: undefined; p?: undefined; } | { j: { callback: () => void; label: Element; priority: number; }; k: { callback: () => void; label: Element; priority: number; }; n: { ...; }; p: { ...; }; }' is not assignable to type 'ActiveKeyMap'.
    return (0, $eUqFw.useMemo)(()=>{
        if (!rapidViewMap) return {};
        return {
            [(0, $c51eac624bf70214$export$b79eb5bea471245c)]: {
                callback: ()=>{
                    navigateToIssue((0, $l9WRb.findNextIssue)(rapidViewMap, issueKey));
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3WSGi.messages).nextIssue),
                priority: (0, $c51eac624bf70214$export$5a8469c8c819903a)
            },
            [(0, $c51eac624bf70214$export$e83c62092c76344b)]: {
                callback: ()=>{
                    navigateToIssue((0, $l9WRb.findPreviousIssue)(rapidViewMap, issueKey));
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3WSGi.messages).previousIssue),
                priority: (0, $c51eac624bf70214$export$5a8469c8c819903a)
            },
            [(0, $c51eac624bf70214$export$7a320fd695b170f)]: {
                callback: ()=>{
                    navigateToIssue((0, $l9WRb.findIssueOfNextActivity)(rapidViewMap, issueKey));
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3WSGi.messages).nextActivity),
                priority: (0, $c51eac624bf70214$export$5a8469c8c819903a)
            },
            [(0, $c51eac624bf70214$export$cb37104427efce2a)]: {
                callback: ()=>{
                    navigateToIssue((0, $l9WRb.findIssueOfPreviousActivity)(rapidViewMap, issueKey));
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3WSGi.messages).previousActivity),
                priority: (0, $c51eac624bf70214$export$5a8469c8c819903a)
            }
        };
    }, [
        issueKey,
        navigateToIssue,
        rapidViewMap
    ]);
};
var $7cedba0651a88f71$export$2e2bcd8739ae039 = $7cedba0651a88f71$var$useBoardNavigationShortcuts;

});
parcelRegister("3WSGi", function(module, exports) {

$parcel$export(module.exports, "messages", () => $36dde7d69df813f4$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $36dde7d69df813f4$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    nextIssue: {
        "id": "issue.shortcuts.navigatingIssues.nextIssue",
        "defaultMessage": "Next issue"
    },
    previousIssue: {
        "id": "issue.shortcuts.navigatingIssues.previousIssue",
        "defaultMessage": "Previous issue"
    },
    nextActivity: {
        "id": "issue.shortcuts.navigatingIssues.nextActivity",
        "defaultMessage": "Next activity"
    },
    previousActivity: {
        "id": "issue.shortcuts.navigatingIssues.previousActivity",
        "defaultMessage": "Previous activity"
    },
    editAssignee: {
        "id": "issue.shortcuts.editAssignee",
        "defaultMessage": "Edit assignee"
    },
    commentOnIssue: {
        "id": "issue.shortcuts.commentOnIssue",
        "defaultMessage": "Comment on issue"
    },
    editLabels: {
        "id": "issue.shortcuts.editLabels",
        "defaultMessage": "Edit labels"
    },
    assignToMe: {
        "id": "issue.shortcuts.assignToMe",
        "defaultMessage": "Assign to me"
    },
    unassignFromMe: {
        "id": "issue.shortcuts.unassign",
        "defaultMessage": "Unassign"
    },
    openShortcutDialog: {
        "id": "issue.shortcuts.openShortcutDialog",
        "defaultMessage": "Open shortcut dialog"
    },
    openWorklogModal: {
        "id": "issue.shortcuts.openWorklogModal",
        "defaultMessage": "Open work log modal"
    },
    openShareDialog: {
        "id": "issue.shortcuts.openShareDialog",
        "defaultMessage": "Open share dialog"
    },
    scrollIssueUp: {
        "id": "issue.shortcuts.scrollIssueUp",
        "defaultMessage": "Scrolls up open issue"
    },
    scrollIssueDown: {
        "id": "issue.shortcuts.scrollIssueDown",
        "defaultMessage": "Scrolls down open issue"
    },
    switchSelectedAreaLeft: {
        "id": "issue.shortcuts.switchSelectedAreaLeft",
        "defaultMessage": "Swap to left side of open issue"
    },
    switchSelectedAreaRight: {
        "id": "issue.shortcuts.switchSelectedAreaRight",
        "defaultMessage": "Swap to right side of open issue"
    },
    changeStatus: {
        "id": "issue.shortcuts.change-status",
        "defaultMessage": "Change status"
    },
    addComment: {
        "id": "issue.shortcuts.add-comment",
        "defaultMessage": "Add comment"
    }
});

});

parcelRegister("l9WRb", function(module, exports) {

$parcel$export(module.exports, "findNextIssue", () => $e7d86a3515d73211$export$d945e3a30aefd31e);
$parcel$export(module.exports, "findPreviousIssue", () => $e7d86a3515d73211$export$d660fb30476b79cb);
$parcel$export(module.exports, "findIssueOfNextActivity", () => $e7d86a3515d73211$export$f294724b8816356e);
$parcel$export(module.exports, "findIssueOfPreviousActivity", () => $e7d86a3515d73211$export$df3908d8fb03b191);
const $e7d86a3515d73211$var$findIssueFromActivity = (activities, index)=>{
    const foundActivity = activities.find((activity)=>activity.length);
    return foundActivity && (foundActivity[index] || foundActivity[foundActivity.length - 1]);
};
const $e7d86a3515d73211$var$findCurrentIssueWithActivity = (boardMap, currentIssueKey)=>{
    const currentActivity = boardMap.find((activity)=>activity.includes(currentIssueKey)) || [];
    const issueIndex = currentActivity.indexOf(currentIssueKey);
    return [
        currentActivity,
        issueIndex
    ];
};
const $e7d86a3515d73211$var$findCurrentIssueWithActivityIndex = (boardMap, currentIssueKey)=>{
    const currentActivityIndex = boardMap.findIndex((activity)=>activity.includes(currentIssueKey));
    const issueIndex = boardMap[currentActivityIndex].indexOf(currentIssueKey);
    return [
        currentActivityIndex,
        issueIndex
    ];
};
const $e7d86a3515d73211$export$d945e3a30aefd31e = (boardMap, currentIssueKey)=>{
    if (!boardMap) return currentIssueKey;
    const [currentActivity, issueIndex] = $e7d86a3515d73211$var$findCurrentIssueWithActivity(boardMap, currentIssueKey);
    return currentActivity[issueIndex + 1] || currentIssueKey;
};
const $e7d86a3515d73211$export$d660fb30476b79cb = (boardMap, currentIssueKey)=>{
    if (!boardMap) return currentIssueKey;
    const [currentActivity, issueIndex] = $e7d86a3515d73211$var$findCurrentIssueWithActivity(boardMap, currentIssueKey);
    return currentActivity[issueIndex - 1] || currentIssueKey;
};
const $e7d86a3515d73211$export$f294724b8816356e = (boardMap, currentIssueKey)=>{
    if (!boardMap) return currentIssueKey;
    const [currentActivityIndex, issueIndex] = $e7d86a3515d73211$var$findCurrentIssueWithActivityIndex(boardMap, currentIssueKey);
    const nextActivities = boardMap.slice(currentActivityIndex + 1);
    return $e7d86a3515d73211$var$findIssueFromActivity(nextActivities, issueIndex) || currentIssueKey;
};
const $e7d86a3515d73211$export$df3908d8fb03b191 = (boardMap, currentIssueKey)=>{
    if (!boardMap) return currentIssueKey;
    const [currentActivityIndex, issueIndex] = $e7d86a3515d73211$var$findCurrentIssueWithActivityIndex(boardMap, currentIssueKey);
    const previousActivities = boardMap.slice(0, currentActivityIndex).reverse();
    return $e7d86a3515d73211$var$findIssueFromActivity(previousActivities, issueIndex) || currentIssueKey;
};

});


parcelRegister("9ij5S", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f0844cef9f20888$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $d3vNK = parcelRequire("d3vNK");

var $dlEQk = parcelRequire("dlEQk");

var $46gH8 = parcelRequire("46gH8");
var $36mrL = parcelRequire("36mrL");
var $gfXKy = parcelRequire("gfXKy");
var $6BN8F = parcelRequire("6BN8F");

var $exb0h = parcelRequire("exb0h");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $a7bke = parcelRequire("a7bke");

var $l129t = parcelRequire("l129t");

var $lO4Or = parcelRequire("lO4Or");

var $10fdS = parcelRequire("10fdS");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $3WSGi = parcelRequire("3WSGi");

var $dZNy0 = parcelRequire("dZNy0");
const $1f0844cef9f20888$export$982507522a33524 = (triggerShortcutAction, triggerShortcutComponent, triggerShortcutPanelFocus)=>{
    const currentRoute = (0, $10fdS.useCurrentRoute)();
    const { setFieldEditingState: setFieldEditingState } = (0, $a7bke.useFieldIsEditingActions)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const { canAssign: canAssign, isCurrentUserAssigned: isCurrentUserAssigned, canAddComments: canAddComments } = (0, $dZNy0.useIssueActionsPermissions)();
    const isModal = (0, $hJ992.useIsModal)();
    const { keyMap: commandPaletteKeyMap } = (0, $6BN8F.useCommandPaletteShortcut)();
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useMemo)(()=>{
        const legacyGinRouteNames = [
            (0, $exb0h.ROUTE_NAMES).LEGACY_GIN,
            (0, $exb0h.ROUTE_NAMES).LEGACY_GIN_ISSUE
        ];
        const sectionId = (0, $46gH8.getCommandPaletteIssueActionsHeader)(issueKey);
        return {
            [(0, $c51eac624bf70214$export$2d6fe2e6cc62871b)]: {
                callback: ()=>{
                    const editAssignee = (0, $l129t.transformExternalAction)((0, $l129t.externalEditFieldAction)((0, $lO4Or.ASSIGNEE_TYPE)));
                    triggerShortcutAction(editAssignee, 'assignIssue', (0, $c51eac624bf70214$export$2d6fe2e6cc62871b));
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3WSGi.messages).editAssignee),
                priority: (0, $c51eac624bf70214$export$5a8469c8c819903a)
            },
            [(0, $c51eac624bf70214$export$d9f01f9198f4f46d)]: {
                callback: ()=>{
                    const assignToMe = (0, $l129t.transformExternalAction)((0, $l129t.externalAssignToMeAction)());
                    triggerShortcutAction(assignToMe, 'assignToMe', (0, $c51eac624bf70214$export$d9f01f9198f4f46d));
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'field updated', {
                        fieldKey: (0, $lO4Or.ASSIGNEE_TYPE)
                    });
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3WSGi.messages).assignToMe),
                priority: (0, $c51eac624bf70214$export$5a8469c8c819903a),
                ...canAssign ? {
                    registerInCommandPalette: {
                        id: `issue.views.issue-details.keyboard-shortcuts.${issueKey}.${isCurrentUserAssigned ? 'unassign' : 'assign'}`,
                        name: formatMessage(isCurrentUserAssigned ? (0, $3WSGi.messages).unassignFromMe : (0, $3WSGi.messages).assignToMe),
                        keywords: getKeywords('assignToMeSynonyms'),
                        priority: (0, $36mrL.getCommandPaletteIssueActionsPriority)('OLD_ISSUE_FIELDS'),
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dlEQk))), {
                                    label: formatMessage(isCurrentUserAssigned ? (0, $3WSGi.messages).unassignFromMe : (0, $3WSGi.messages).assignToMe)
                                })
                        },
                        section: sectionId,
                        analytics: {
                            action: isCurrentUserAssigned ? 'unassign' : 'assignToMe'
                        }
                    }
                } : undefined
            },
            [(0, $c51eac624bf70214$export$a3a1bc4fb02429c0)]: {
                callback: ()=>{
                    setFieldEditingState((0, $lO4Or.LABELS_TYPE), true);
                    const editLabels = (0, $l129t.transformExternalAction)((0, $l129t.externalEditFieldAction)((0, $lO4Or.LABELS_TYPE)));
                    triggerShortcutAction(editLabels, 'editLabels', (0, $c51eac624bf70214$export$a3a1bc4fb02429c0));
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3WSGi.messages).editLabels),
                priority: (0, $c51eac624bf70214$export$5a8469c8c819903a)
            },
            [(0, $c51eac624bf70214$export$cd076067c17f863b)]: {
                callback: ()=>{
                    const addComment = (0, $l129t.transformExternalAction)((0, $l129t.externalAddCommentAction)());
                    triggerShortcutAction(addComment, 'commentIssue', (0, $c51eac624bf70214$export$cd076067c17f863b));
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3WSGi.messages).commentOnIssue),
                priority: (0, $c51eac624bf70214$export$5a8469c8c819903a),
                ...canAddComments && {
                    registerInCommandPalette: {
                        id: 'issue.views.issue-details.keyboard-shortcuts.add-comment',
                        name: formatMessage((0, $3WSGi.messages).addComment),
                        keywords: getKeywords('addCommentSynonyms'),
                        priority: (0, $36mrL.getCommandPaletteIssueActionsPriority)('ADD_COMMENT'),
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
                                    label: formatMessage((0, $3WSGi.messages).addComment)
                                })
                        },
                        section: sectionId,
                        analytics: {
                            action: 'addComment'
                        }
                    }
                }
            },
            [(0, $c51eac624bf70214$export$11f922ab4c2bc975)]: {
                callback: ()=>{
                    triggerShortcutComponent?.((0, $c51eac624bf70214$export$823ced5880c3b947), 'changeStatus', (0, $c51eac624bf70214$export$11f922ab4c2bc975));
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3WSGi.messages).changeStatus),
                priority: (0, $c51eac624bf70214$export$5a8469c8c819903a)
            },
            [(0, $c51eac624bf70214$export$2a8b4d6d636c136a)]: {
                callback: ()=>{
                    const addTimeTracking = (0, $l129t.transformExternalAction)((0, $l129t.externalEditFieldAction)((0, $lO4Or.TIME_TRACKING_TYPE)));
                    triggerShortcutAction(addTimeTracking, 'timetracking', (0, $c51eac624bf70214$export$2a8b4d6d636c136a));
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3WSGi.messages).openWorklogModal),
                priority: (0, $c51eac624bf70214$export$5a8469c8c819903a)
            },
            ...currentRoute && legacyGinRouteNames && // Only register the "shift+s" shortcut if route is not global issue navigator (conflicts with the other "s" shortcut on Windows)
            // This can be removed once GIN is replaced with NIN. See https://hello.atlassian.net/browse/DEE-1224
            !legacyGinRouteNames.includes(currentRoute?.name) && {
                [(0, $c51eac624bf70214$export$8a7d6f43ad50b2bd)]: {
                    callback: ()=>{
                        // Share field is not yet defined in src/packages/platform/ui/field-config/src/index.js
                        // So no external action is fired.
                        // Guard can be removed once FF is removed and this param is mandatory.
                        if (triggerShortcutComponent) triggerShortcutComponent('shareDropdownTriggerCount', 'shareIssue', (0, $c51eac624bf70214$export$6ecc0ff22f952299));
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3WSGi.messages).openShortcutDialog),
                    priority: (0, $c51eac624bf70214$export$5a8469c8c819903a)
                }
            },
            [(0, $c51eac624bf70214$export$b8edcdd7ea916239)]: {
                callback: ()=>{
                    triggerShortcutPanelFocus((0, $c51eac624bf70214$export$b8edcdd7ea916239), 'scrollIssueLeft');
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3WSGi.messages).switchSelectedAreaLeft),
                priority: (0, $c51eac624bf70214$export$5a8469c8c819903a)
            },
            [(0, $c51eac624bf70214$export$b456fa9fa3286243)]: {
                callback: ()=>{
                    triggerShortcutPanelFocus((0, $c51eac624bf70214$export$b456fa9fa3286243), 'scrollIssueRight');
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3WSGi.messages).switchSelectedAreaRight),
                priority: (0, $c51eac624bf70214$export$5a8469c8c819903a)
            },
            ...!!isModal && commandPaletteKeyMap
        };
    }, [
        issueKey,
        canAssign,
        isCurrentUserAssigned,
        formatMessage,
        getKeywords,
        canAddComments,
        currentRoute,
        isModal,
        commandPaletteKeyMap,
        triggerShortcutAction,
        createAnalyticsEvent,
        setFieldEditingState,
        triggerShortcutComponent,
        triggerShortcutPanelFocus
    ]);
};
var $1f0844cef9f20888$export$2e2bcd8739ae039 = $1f0844cef9f20888$export$982507522a33524;

});
parcelRegister("d3vNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98143944cdbffe97$var$_react = $98143944cdbffe97$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $98143944cdbffe97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $98143944cdbffe97$var$CommentIcon = (props)=>/*#__PURE__*/ $98143944cdbffe97$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 00.164.033.515.515 0 00.474-.716z"/><rect x="7" y="9" width="10" height="2" rx="1"/><rect x="7" y="12" width="5" height="2" rx="1"/></g></svg>`
    }, props));
$98143944cdbffe97$var$CommentIcon.displayName = 'CommentIcon';
var $98143944cdbffe97$var$_default = $98143944cdbffe97$var$CommentIcon;
module.exports.default = $98143944cdbffe97$var$_default;

});

parcelRegister("dlEQk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b7ceb1f36e72568$var$_react = $9b7ceb1f36e72568$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9b7ceb1f36e72568$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9b7ceb1f36e72568$var$UserAvatarCircleIcon = (props)=>/*#__PURE__*/ $9b7ceb1f36e72568$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><circle fill="inherit" cx="12" cy="9" r="3"/><path d="M7 18.245A7.966 7.966 0 0012 20c1.892 0 3.63-.657 5-1.755V15c0-1.115-.895-2-2-2H9c-1.113 0-2 .895-2 2v3.245z" fill="inherit" fill-rule="nonzero"/></g></svg>`
    }, props));
$9b7ceb1f36e72568$var$UserAvatarCircleIcon.displayName = 'UserAvatarCircleIcon';
var $9b7ceb1f36e72568$var$_default = $9b7ceb1f36e72568$var$UserAvatarCircleIcon;
module.exports.default = $9b7ceb1f36e72568$var$_default;

});

parcelRegister("46gH8", function(module, exports) {

$parcel$export(module.exports, "getCommandPaletteIssueActionsHeader", () => $1d28d9547f2aa59c$export$cd9931655a8cfb04);

var $9zALC = parcelRequire("9zALC");

var $36mrL = parcelRequire("36mrL");

var $2NY3y = parcelRequire("2NY3y");
const $1d28d9547f2aa59c$export$cd9931655a8cfb04 = (issueKey)=>`${0, $9zALC.COMMAND_PALETTE_ISSUE_ACTIONS}-${issueKey || ''}`;

});
parcelRegister("9zALC", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $8bee8fa7684ab6e5$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $8bee8fa7684ab6e5$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $8bee8fa7684ab6e5$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $8bee8fa7684ab6e5$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $8bee8fa7684ab6e5$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $8bee8fa7684ab6e5$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $8bee8fa7684ab6e5$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $8bee8fa7684ab6e5$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $8bee8fa7684ab6e5$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $8bee8fa7684ab6e5$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $8bee8fa7684ab6e5$export$16b06d29ef8f802b;
(function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["projectNavigation"] = "project-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
})($8bee8fa7684ab6e5$export$16b06d29ef8f802b || ($8bee8fa7684ab6e5$export$16b06d29ef8f802b = {}));
const $8bee8fa7684ab6e5$export$156ebd2354e25466 = 'issueActions';
const $8bee8fa7684ab6e5$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $8bee8fa7684ab6e5$export$9f646ab88e1d2b14 = 'commandPalette';
var $8bee8fa7684ab6e5$export$abf26cc5daebd2c8;
(function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["projectNavigation"] = 2] = "projectNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
})($8bee8fa7684ab6e5$export$abf26cc5daebd2c8 || ($8bee8fa7684ab6e5$export$abf26cc5daebd2c8 = {}));
var $8bee8fa7684ab6e5$export$12514ca8899b0521;
(function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
})($8bee8fa7684ab6e5$export$12514ca8899b0521 || ($8bee8fa7684ab6e5$export$12514ca8899b0521 = {}));
var $8bee8fa7684ab6e5$export$5fa0bcf59f933c21;
(function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
})($8bee8fa7684ab6e5$export$5fa0bcf59f933c21 || ($8bee8fa7684ab6e5$export$5fa0bcf59f933c21 = {}));
var $8bee8fa7684ab6e5$export$7d9743be0b7d862f;
(function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
})($8bee8fa7684ab6e5$export$7d9743be0b7d862f || ($8bee8fa7684ab6e5$export$7d9743be0b7d862f = {}));
var $8bee8fa7684ab6e5$export$b4e1633c86db2b70;
(function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
})($8bee8fa7684ab6e5$export$b4e1633c86db2b70 || ($8bee8fa7684ab6e5$export$b4e1633c86db2b70 = {}));
var $8bee8fa7684ab6e5$export$5e5a87aac5d9771f;
(function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
})($8bee8fa7684ab6e5$export$5e5a87aac5d9771f || ($8bee8fa7684ab6e5$export$5e5a87aac5d9771f = {}));

});

parcelRegister("36mrL", function(module, exports) {

$parcel$export(module.exports, "getCommandPaletteIssueActionsPriority", () => $58e6fffac6029e83$export$5164bb42fa883371);
const $58e6fffac6029e83$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY = {
    STATUS: 10,
    SUMMARY: 20,
    PARENT: 30,
    LINK_ISSUE: 40,
    CONTENT_FIRST_TAB: 50,
    PINNED_FIELDS: 60,
    DETAILS: 70,
    CONTENT_OTHER_TABS: 80,
    MORE_FIELDS: 90,
    OLD_ISSUE_FIELDS: 95,
    ADD_COMMENT: 100,
    GQL_FIELDS: 105,
    SUB_HEADER_ITEMS: 110,
    ISSUE_HEADER_ITEMS: 120
};
const $58e6fffac6029e83$export$5164bb42fa883371 = (key)=>$58e6fffac6029e83$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY[key];

});

parcelRegister("2NY3y", function(module, exports) {

$parcel$export(module.exports, "noSortNoFilterOverride", () => $94f67465bbdaf727$export$78d30e5b661ceee3);
const $94f67465bbdaf727$export$78d30e5b661ceee3 = (_search, selectedCommands)=>selectedCommands;

});


parcelRegister("gfXKy", function(module, exports) {

$parcel$export(module.exports, "useCommandKeywords", () => $59897234799b31c8$export$4d8fe3ef6385358);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3iBHM = parcelRequire("3iBHM");
const $59897234799b31c8$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getKeywords = (0, $eUqFw.useCallback)((keywordGroup)=>(0, $3iBHM.messages)[keywordGroup] ? formatMessage((0, $3iBHM.messages)[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});
parcelRegister("3iBHM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2f74b9c3b50ad31d$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $2f74b9c3b50ad31d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    searchYourIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    changeStatusSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
        "defaultMessage": "Move through workflow  Progress Done Complete transition"
    },
    assignToMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
        "defaultMessage": "self"
    },
    assignIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
        "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
    },
    startWatchingIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
        "defaultMessage": "Follow work Track Unwatch Unfollow"
    },
    backlogSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
        "defaultMessage": "Inventory Go"
    },
    boardSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
        "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
    },
    reportsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
        "defaultMessage": "Summary Insights Burndown Go"
    },
    timelineSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
        "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
        "defaultMessage": "Search products across Atlassian Go to"
    },
    pageSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
        "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
    },
    createIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
        "defaultMessage": "work Start idea New ticket task"
    },
    switchDarkThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
        "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    matchSystemThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
        "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    copyCurrentPageUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
        "defaultMessage": "link website address"
    },
    getHelpSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
        "defaultMessage": "In-product Support Documentation Questions Answers"
    },
    viewKeyboardShortcutsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
        "defaultMessage": "Hotkeys Show See"
    },
    editDescriptionSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
        "defaultMessage": "Completion criteria Info Information Details Add Write"
    },
    addAttachmentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
        "defaultMessage": "Attach Upload Document Media"
    },
    addCommentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
        "defaultMessage": "Write Message"
    },
    logWorkSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
        "defaultMessage": "Track Record hours Time spent"
    },
    addRemoveFlagSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
        "defaultMessage": "Unflag Mark Unmark Star Unstar"
    },
    cloneIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
        "defaultMessage": "Copy Duplicate Task Idea Request"
    },
    linkConfluencePageSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
        "defaultMessage": "Relate Add Connect"
    },
    addAUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
        "defaultMessage": "Connect Weblink Link Website Domain"
    },
    goToIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
        "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
    },
    goToPersonalSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
        "defaultMessage": "Preferences Notifications Theme Jira labs"
    },
    goToAccountSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
        "defaultMessage": "Preferences Privacy Profile Your details Personal information"
    },
    viewAllIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
        "defaultMessage": "Site issues JQL View all"
    },
    viewAllProjectsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllPlansSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllBoardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllFiltersSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllDashboardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
        "defaultMessage": "List Go"
    },
    checkNotificationsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
        "defaultMessage": "window See Updates"
    },
    goToUserManagementSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
        "defaultMessage": "Permissions"
    }
});

});


parcelRegister("6BN8F", function(module, exports) {

$parcel$export(module.exports, "useCommandPaletteShortcut", () => $939f0895d88815ff$export$819c83c949ab2a6b);

var $gCtL7 = parcelRequire("gCtL7");

var $igOBb = parcelRequire("igOBb");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $duQ8C = parcelRequire("duQ8C");

var $9zALC = parcelRequire("9zALC");
const $939f0895d88815ff$export$819c83c949ab2a6b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ isLoaded: isLoaded }, { open: open }] = (0, $gCtL7.useCommandPaletteIsLoaded)();
    return {
        keyMap: {
            [`${(0, $igOBb.getShortcutModifierKey)()}+k`]: {
                callback: (ev)=>{
                    (0, $duQ8C.default)('command-palette-opened');
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent((0, $9zALC.COMMAND_PALETTE_PRESSED_ANALYTICS)), (0, $9zALC.COMMAND_PALETTE_ID), {
                        key: 'k',
                        isLoaded: isLoaded
                    });
                    ev?.preventDefault();
                    open();
                }
            }
        }
    };
};

});

parcelRegister("dZNy0", function(module, exports) {

$parcel$export(module.exports, "useIssueActionsPermissions", () => $e7f5c645e099060f$export$a6a7502221db0886);

var $hJ992 = parcelRequire("hJ992");

var $dnK1q = parcelRequire("dnK1q");

var $cWiVr = parcelRequire("cWiVr");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");
const $e7f5c645e099060f$export$a6a7502221db0886 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const [{ canBeAssignedToIssues: canBeAssignedToIssues, canAssignIssues: canAssignIssues, canAddComments: canAddComments }] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    const [{ value: assigneeField }] = (0, $dnK1q.default)({
        issueKey: issueKey
    });
    const isCurrentUserAssigned = user.accountId === assigneeField?.accountId;
    return {
        canAssign: canBeAssignedToIssues && canAssignIssues,
        canAddComments: canAddComments,
        isCurrentUserAssigned: isCurrentUserAssigned
    };
};

});
parcelRegister("dnK1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $28b7c7940962eeef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $axhXb = parcelRequire("axhXb");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
var $kmr29 = parcelRequire("kmr29");



var $aNVyA = parcelRequire("aNVyA");
const $28b7c7940962eeef$var$getCurrentAssigneeUrl = (baseUrl, issueKey)=>`${baseUrl}/rest/api/3/issue/${issueKey}?fields=assignee`;
const $28b7c7940962eeef$var$getCurrentAssignee = async (baseUrl, issueKey)=>{
    const response = await (0, $lRmyA.performGetRequest)($28b7c7940962eeef$var$getCurrentAssigneeUrl(baseUrl, issueKey), {
        ...(0, $axhXb.default)
    });
    const { assignee: assignee } = response.fields;
    return assignee;
};
const $28b7c7940962eeef$export$e3a8121b536e7353 = ({ issueKey: issueKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const fieldKey = (0, $ebc098a76317be78$export$e18419056f3d184a);
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'user');
    const [, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $ebc098a76317be78$export$e18419056f3d184a)
    });
    const baseUrl = '';
    const onSaveSuccess = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'currentAssignee' implicitly has an 'any' type.
    (currentAssignee)=>{
        if (currentAssignee && currentAssignee.accountId === (0, $7a4a7348bcf111f0$export$f5d5f6bb902f1027)) $28b7c7940962eeef$var$getCurrentAssignee(baseUrl, issueKey).then((assignee)=>{
            setFieldValue(issueKey, (0, $ebc098a76317be78$export$e18419056f3d184a), assignee);
            onSuccess?.(assignee);
        }).catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'currentAssigneeFetch',
                    packageName: 'jiraIssueFieldAssignee'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            onSuccess?.(currentAssignee); // In case api fail, better to show Automatic only
        });
        else onSuccess?.(currentAssignee);
    }, [
        baseUrl,
        issueKey,
        onSuccess,
        setFieldValue
    ]);
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSubmit: onSubmit,
        onSuccess: onSaveSuccess,
        onFailure: onFailure,
        saveField: (0, $aNVyA.saveAssigneeField)
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};
var $28b7c7940962eeef$export$2e2bcd8739ae039 = $28b7c7940962eeef$export$e3a8121b536e7353;

});
parcelRegister("axhXb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1543ae6d5c00264$export$2e2bcd8739ae039);
const $d1543ae6d5c00264$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        'x-atlassian-force-account-id': 'true',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};
var $d1543ae6d5c00264$export$2e2bcd8739ae039 = $d1543ae6d5c00264$var$defaultOptions;

});

const $7a4a7348bcf111f0$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $7a4a7348bcf111f0$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $7a4a7348bcf111f0$export$f5d5f6bb902f1027 = '-1';

parcelRegister("aNVyA", function(module, exports) {

$parcel$export(module.exports, "saveAssigneeField", () => $c524a0889f8bfdba$export$4966afe29c596da8);

var $lRmyA = parcelRequire("lRmyA");
const $c524a0889f8bfdba$export$4966afe29c596da8 = async (issueKey, fieldKey, newValue, baseUrl)=>{
    const userValue = newValue;
    return (0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/assignee`, {
        // the accountId field set to null will unassign the user from the issue as a fallback
        body: JSON.stringify({
            accountId: userValue?.accountId || null
        })
    });
};

});


parcelRegister("cWiVr", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $59f9598ada60a2a8$export$3901076af3749fa9);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $gd0Sp = parcelRequire("gd0Sp");

var $lGLse = parcelRequire("lGLse");
const $59f9598ada60a2a8$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return (0, $eUqFw.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $ao0hp.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $59f9598ada60a2a8$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $59f9598ada60a2a8$var$useCurrentUserBasic();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $lGLse.useUserSubscriber)();
    (0, $eUqFw.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $59f9598ada60a2a8$export$3901076af3749fa9 = ()=>(0, $gd0Sp.useTenantContext)().isAnonymous ? $59f9598ada60a2a8$var$useCurrentUserBasic() : $59f9598ada60a2a8$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $59f9598ada60a2a8$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $59f9598ada60a2a8$export$3901076af3749fa9();
    return children(result);
};

});



parcelRegister("aNWF7", function(module, exports) {

$parcel$export(module.exports, "default", () => $771908a93c32a03f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");


var $3WSGi = parcelRequire("3WSGi");
const $771908a93c32a03f$var$useMenuShortcuts = (triggerShortcutAction)=>(0, $eUqFw.useMemo)(()=>({
            [(0, $c51eac624bf70214$export$ea7513f4d878349f)]: {
                callback: ()=>{
                    triggerShortcutAction('triggerShortcutDialogOpen', (0, $c51eac624bf70214$export$ea7513f4d878349f));
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3WSGi.messages).openShortcutDialog),
                priority: (0, $c51eac624bf70214$export$5a8469c8c819903a)
            }
        }), [
        triggerShortcutAction
    ]);
var $771908a93c32a03f$export$2e2bcd8739ae039 = $771908a93c32a03f$var$useMenuShortcuts;

});



parcelRegister("fWPOH", function(module, exports) {

$parcel$export(module.exports, "AiOptInService", () => $247554f12de19b75$export$6a9a3a09c70c69e4);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7ZZxN = parcelRequire("7ZZxN");

var $gUUjF = parcelRequire("gUUjF");

var $hJ992 = parcelRequire("hJ992");

var $5GTmF = parcelRequire("5GTmF");

var $guDlK = parcelRequire("guDlK");

var $dWLk9 = parcelRequire("dWLk9");
const $247554f12de19b75$var$mapToJiraProjectType = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return (0, $5GTmF.JiraProjectTypeEnum).SOFTWARE;
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return (0, $5GTmF.JiraProjectTypeEnum).SERVICE_DESK;
        case 0, $7ZZxN.CORE_PROJECT:
            return (0, $5GTmF.JiraProjectTypeEnum).BUSINESS;
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return (0, $5GTmF.JiraProjectTypeEnum).PRODUCT_DISCOVERY;
        default:
            return null;
    }
};
const $247554f12de19b75$export$6a9a3a09c70c69e4 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const cloudId = (0, $dWLk9.useCloudId)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const [, { mergeIssueContext: mergeIssueContext }] = (0, $hJ992.useIssueContextActions)();
    (0, $eUqFw.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                const isAiOptInEnabled = await (0, $5GTmF.fetchAiOptInData)($247554f12de19b75$var$mapToJiraProjectType(projectType), cloudId, environment);
                mergeIssueContext({
                    isAiOptInEnabled: isAiOptInEnabled
                });
            } catch (error) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fetch.services.ai.optin.service', 'Error fetching ai opt in value', error instanceof Error ? error : undefined);
                mergeIssueContext({
                    isAiOptInEnabled: false
                });
            }
        };
        fetchData();
    }, [
        cloudId,
        environment,
        mergeIssueContext,
        projectType,
        issueKey
    ]);
    return null;
};

});
parcelRegister("5GTmF", function(module, exports) {

$parcel$export(module.exports, "JiraProjectTypeEnum", () => $1b19ad886dcb8797$export$5dea9644eb4ef00a);
$parcel$export(module.exports, "fetchAiOptInData", () => $1b19ad886dcb8797$export$fb89b1bb2a07ced0);

var $aDPiA = parcelRequire("aDPiA");

var $iWLL0 = parcelRequire("iWLL0");
const $1b19ad886dcb8797$export$5dea9644eb4ef00a = {
    SOFTWARE: 'SOFTWARE',
    SERVICE_DESK: 'SERVICE_DESK',
    BUSINESS: 'BUSINESS',
    PRODUCT_DISCOVERY: 'PRODUCT_DISCOVERY'
};
const $1b19ad886dcb8797$export$fb89b1bb2a07ced0 = async (projectType, cloudId, environment)=>{
    if (!projectType) return false;
    const data = await (0, $iWLL0.fetchQuery)(environment, (0, $aDPiA.default), {
        projectType: projectType,
        cloudId: cloudId
    }).toPromise().catch((err)=>{
        throw err;
    });
    return data?.jira?.isIssueViewEditorAiEnabled || false;
};

});
parcelRegister("aDPiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $411a8e9773e5658d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dcf0712cdb573bcf086678e735b17502>>
 * @relayHash d50033a35b08f8be170b35fac9a17cfe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6cff0bff184dc8f1a073b553a9ba32cbb75ba7299e1ab00005f3c40a5bffd4db
const $411a8e9773e5658d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v2 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "jiraProjectType",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "isIssueViewEditorAiEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiOptinDataQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiOptinDataQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "6cff0bff184dc8f1a073b553a9ba32cbb75ba7299e1ab00005f3c40a5bffd4db",
            "metadata": {},
            "name": "aiOptinDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$411a8e9773e5658d$var$node.hash = "4c56f4213bd1abff6264c36450debe12";
var $411a8e9773e5658d$export$2e2bcd8739ae039 = $411a8e9773e5658d$var$node;

});



parcelRegister("l4XSJ", function(module, exports) {

$parcel$export(module.exports, "issueSidebarRatiosSelector", () => $c05ed8113cbb7c93$export$675f6b24df185592);
/*
 * DO NOT USE *
 * To fetch preferences for new components, use useUserPreferencesValue hook instead.
 *
 * This selector was added to fetch userPreferences from redux store for existing class
 * components without needing to introduce an extra layer of wrapper or HOC.
 */ 
var $df4Sl = parcelRequire("df4Sl");


var $jZDJX = parcelRequire("jZDJX");
const $c05ed8113cbb7c93$export$5e325862c96f21e5 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities ? entities.myPreferences : null);
const $c05ed8113cbb7c93$export$675f6b24df185592 = (0, $df4Sl.createSelector)($c05ed8113cbb7c93$export$5e325862c96f21e5, (myPreferences)=>myPreferences ? myPreferences[0, $e4af19d777b54ab6$export$a274dca8eb47fc4a] : null);

});

parcelRegister("3BmTe", function(module, exports) {

$parcel$export(module.exports, "withAnalyticsAttributes", () => $0367f88868267d5f$export$2f8f4e6a400ba065);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");


var $2V7AK = parcelRequire("2V7AK");

var $kSuBQ = parcelRequire("kSuBQ");

var $4sNXH = parcelRequire("4sNXH");
var $hFoCj = parcelRequire("hFoCj");

var $guDlK = parcelRequire("guDlK");
const $0367f88868267d5f$var$toPanelAnalyticsData = (projectKey, appKey, appName, contextPanelId)=>({
        appKey: appKey,
        appName: appName,
        isPanelOpen: (0, $kSuBQ.isGroupPanelOpen)(projectKey, 'context-group', contextPanelId, (0, $ab2aafcdf11a1361$export$e1184c3be46bd7cb))
    });
const $0367f88868267d5f$var$flattenEcosystemPanels = (ecosystemContextPanels)=>{
    const contextPanels = [];
    Object.values(ecosystemContextPanels).forEach((contextPanelObject)=>{
        contextPanels.push(Object.values(contextPanelObject)[0]);
    });
    return contextPanels;
};
const $0367f88868267d5f$export$4bf12515bf99caba = ()=>{
    const projectKey = (0, $guDlK.useProjectKey)((0, $hJ992.useIssueKey)());
    const forgeContextPanels = (0, $4sNXH.useForgeContextPanelsAsLayoutItems)();
    const [ecosystemContextPanels] = (0, $2V7AK.useEcosystemContextPanels)();
    const layoutFieldsMeta = (0, $hFoCj.useLayoutFieldsMeta)();
    // we return callback as updates to localStorage used to keep panel state are not reactive
    // it's easier to recompute it every time rather refactor everything to use jira-browser-storage-providers
    return (0, $eUqFw.useCallback)(()=>({
            ...forgeContextPanels ? {
                forgeContextPanel: forgeContextPanels.map((item)=>$0367f88868267d5f$var$toPanelAnalyticsData(projectKey, item.id, item.payload.name, item.id))
            } : {},
            ...ecosystemContextPanels ? {
                connectContextPanel: $0367f88868267d5f$var$flattenEcosystemPanels(ecosystemContextPanels).map((item)=>$0367f88868267d5f$var$toPanelAnalyticsData(projectKey, item.appKey, item.name, (0, $4sNXH.generateContextPanelId)(item)))
            } : {},
            ...layoutFieldsMeta
        }), [
        ecosystemContextPanels,
        forgeContextPanels,
        projectKey,
        layoutFieldsMeta
    ]);
};
const $0367f88868267d5f$export$2f8f4e6a400ba065 = ()=>(Component)=>function WithAnalyticsAttributes(props) {
            const factory = $0367f88868267d5f$export$4bf12515bf99caba();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                ...props,
                analyticsAttributesFactory: factory
            });
        };

});
parcelRegister("hFoCj", function(module, exports) {

$parcel$export(module.exports, "useLayoutFieldsMeta", () => $44a277cc3156a54c$export$5b0af781ba0854fb);

var $eUqFw = parcelRequire("eUqFw");

var $bwbFz = parcelRequire("bwbFz");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $bLiXo = parcelRequire("bLiXo");

var $dZWHl = parcelRequire("dZWHl");
var $fCyzk = parcelRequire("fCyzk");

var $g8to1 = parcelRequire("g8to1");

var $i3F8E = parcelRequire("i3F8E");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $44a277cc3156a54c$var$filterItemsWithValue = (items, issueFieldsValues)=>items.filter((item)=>{
        const fieldValue = issueFieldsValues[(0, $dZWHl.getLayoutItemId)(item)];
        // If the field is not present in the issueFieldsValues, it means the field
        // value is loaded asynchronously. An example of this is the devSummary field.
        if (fieldValue === undefined) return false;
        if (fieldValue && typeof fieldValue === 'object') {
            // If the field is an ADF field, we need to check if it has content
            if (fieldValue.type === 'doc') return (0, $g8to1.isEmpty)(fieldValue.content);
            // If the field is an parent link field, we need to check if it has data
            if (fieldValue.hasEpicLinkFieldDependency !== undefined && fieldValue.showField !== undefined) return (0, $g8to1.isEmpty)(fieldValue.data);
        }
        return (0, $g8to1.isEmpty)(fieldValue);
    });
const $44a277cc3156a54c$var$flatteningContentItems = (contentItems)=>contentItems.flatMap((contentItem)=>{
        if (contentItem.type === (0, $bLiXo.layoutContainerItemTypes).tab) {
            const contentTabFields = $44a277cc3156a54c$var$flatteningContentItems(contentItem.items.nodes);
            return contentTabFields;
        }
        return contentItem;
    });
const $44a277cc3156a54c$export$5b0af781ba0854fb = (alwaysPrimaryFieldIds = [])=>{
    const items = (0, $i3F8E.usePrimarySecondaryItems)(alwaysPrimaryFieldIds);
    const { pinnedFields: pinnedFields, primaryItems: primaryItems, secondaryItems: secondaryItems } = items;
    const issueKey = (0, $hJ992.useIssueKey)();
    const [issueFieldsValues] = (0, $kmr29.useFieldsValues)(issueKey);
    const [contentItems] = (0, $fCyzk.useLayoutContainerByType)(issueKey, 'CONTENT');
    return (0, $eUqFw.useMemo)(()=>{
        if (!issueFieldsValues) return {};
        const [hiddenSecondaryFields = [], visibleSecondaryFields = []] = (0, (/*@__PURE__*/$parcel$interopDefault($bwbFz)))(secondaryItems, (item)=>(0, $g8to1.isEmpty)(issueFieldsValues[(0, $dZWHl.getLayoutItemId)(item)]));
        const contentFields = $44a277cc3156a54c$var$flatteningContentItems(contentItems);
        const emptyContentFields = $44a277cc3156a54c$var$filterItemsWithValue(contentFields, issueFieldsValues);
        const emptyVisibleFields = $44a277cc3156a54c$var$filterItemsWithValue(primaryItems, issueFieldsValues);
        const emptyPinnedFields = $44a277cc3156a54c$var$filterItemsWithValue(pinnedFields, issueFieldsValues);
        const numberOfVisibleFields = primaryItems.length + visibleSecondaryFields.length;
        return {
            numberOfPinnedFields: pinnedFields.length,
            numberOfEmptyPinnedFields: emptyPinnedFields.length,
            numberOfVisibleContextFields: numberOfVisibleFields,
            numberOfEmptyVisibleContextFields: emptyVisibleFields.length,
            numberOfHiddenFields: hiddenSecondaryFields.length,
            ...(0, $1ybV0.ff)('issue-view-analytics-for-configured-hidden-fields_16ssj') ? {
                numberOfConfiguredHiddenFields: secondaryItems.length
            } : {},
            numberOfContentFields: contentFields.length,
            numberOfEmptyContentFields: emptyContentFields.length
        };
    }, [
        pinnedFields,
        primaryItems,
        secondaryItems,
        contentItems,
        issueFieldsValues
    ]);
};

});


parcelRegister("rRCmN", function(module, exports) {

$parcel$export(module.exports, "BentoMetricsWithSpaTimingInfo", () => $b845b531f8d39e3c$export$31d217042ad9c141);

var $eUqFw = parcelRequire("eUqFw");

var $78d1w = parcelRequire("78d1w");

var $3IGJu = parcelRequire("3IGJu");
// lastTransitionStartTime is coming from Date.now() inside src/packages/platform/controllers/spa-state/src/actions/page-events/index.js
// so we are converting it to origin relativeMillis for consistency with times used inside browser metrics.
const $b845b531f8d39e3c$var$convertEpochMillisToOriginRelativeMillis = (lastTransitionStartTime)=>{
    if (lastTransitionStartTime != null) return lastTransitionStartTime - performance.timing.navigationStart;
    return lastTransitionStartTime;
};
const $b845b531f8d39e3c$export$31d217042ad9c141 = (props)=>{
    const [{ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime }] = (0, $78d1w.useSpaStateTransition)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3IGJu.BentoMetrics), {
        ...props,
        isInitialRender: isInitialRender,
        lastTransitionStartTime: $b845b531f8d39e3c$var$convertEpochMillisToOriginRelativeMillis(lastTransitionStartTime)
    });
};

});
parcelRegister("3IGJu", function(module, exports) {

$parcel$export(module.exports, "BentoMetrics", () => $57e0deabd52f72d4$export$6e420cf54cf4e94);

var $eUqFw = parcelRequire("eUqFw");

var $3pPAn = parcelRequire("3pPAn");

var $2Sajo = parcelRequire("2Sajo");

var $lcJyp = parcelRequire("lcJyp");

var $1QVWH = parcelRequire("1QVWH");

var $84CBi = parcelRequire("84CBi");

var $jc4kK = parcelRequire("jc4kK");
const $57e0deabd52f72d4$export$6e420cf54cf4e94 = (props)=>{
    const { isPreview: isPreview, isComplete: isComplete, issueKey: issueKey, isInitialRender: isInitialRender, error: error, metrics: metrics, lastTransitionStartTime: lastTransitionStartTime } = props;
    const [isForgeLoadedSuccessfully] = (0, $2Sajo.useForgeDataComplete)();
    const isForgeLoadingFailed = (0, $2Sajo.useForgeLoadingFailed)();
    const uimModules = (0, $2Sajo.useForgeUimModules)();
    const { isUimFinishedLoading: isUimFinishedLoading, appsCount: appsCount, uiModificationsCount: uiModificationsCount } = (0, $3pPAn.useUimAnalytics)({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        forgeFinishedLoading: isForgeLoadedSuccessfully || isForgeLoadingFailed,
        forgeModulesCount: uimModules.length
    });
    const isMountedRef = (0, $eUqFw.useRef)(false);
    const hasErroredRef = (0, $eUqFw.useRef)(false);
    const prevPropsRef = (0, $eUqFw.useRef)(props);
    let endOfCriticalPath;
    let errorOnCriticalPath;
    const isFirstLoadOfRecentIssue = (prevProps)=>issueKey !== prevProps.issueKey && isComplete;
    const didBentoMoveOutOfLoadingState = (prevProps)=>prevProps.isLoading && (isPreview || isComplete);
    const isPreviewModeAfterBentoSpaTransition = (prevProps)=>prevProps.issueKey !== issueKey && isPreview;
    const didJustMoveToComplete = (prevProps)=>isComplete && !prevProps.isComplete;
    const onEndOfCriticalPath = ()=>{
        if (endOfCriticalPath) {
            endOfCriticalPath();
            (0, $jc4kK.markSPAReadyEndOfCriticalPath)();
        }
    };
    // We need to call addUFOCustomData before UFOLoadHold will receive "false" in "hold"
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (isUimFinishedLoading) (0, $1QVWH.addUFOCustomData)({
            uiModificationsCount: uiModificationsCount,
            uimForgeModulesCount: appsCount
        });
    }, [
        isUimFinishedLoading,
        appsCount,
        uiModificationsCount
    ]);
    const { onMarkIssueOnPageLoadEvent: onMarkIssueOnPageLoadEvent } = metrics;
    (0, $eUqFw.useEffect)(()=>{
        // Add render mark and issue page load event
        (0, $jc4kK.markIssueRender)();
        window.addEventListener('load', onMarkIssueOnPageLoadEvent);
        return ()=>window.removeEventListener('load', onMarkIssueOnPageLoadEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $eUqFw.useEffect)(()=>{
        // Measure initial issue render TTI
        if (!isMountedRef.current) {
            if (!hasErroredRef.current && isInitialRender && (0, $jc4kK.isFullIssueView)()) {
                if (isComplete) {
                    metrics.onInteractive({
                        lastTransitionStartTime: lastTransitionStartTime
                    });
                    onEndOfCriticalPath();
                }
            }
            isMountedRef.current = true;
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        if (error) {
            hasErroredRef.current = true;
            if (errorOnCriticalPath) errorOnCriticalPath();
        }
        // Measure issue preview/load TTI, after initial render
        if (!hasErroredRef.current) {
            if (isPreviewModeAfterBentoSpaTransition(prevPropsRef.current) || didBentoMoveOutOfLoadingState(prevPropsRef.current)) metrics.onPreviewRendered({
                isInitialRender: isInitialRender,
                lastTransitionStartTime: lastTransitionStartTime
            });
            if (didJustMoveToComplete(prevPropsRef.current) || isFirstLoadOfRecentIssue(prevPropsRef.current)) {
                (0, $jc4kK.markIssueLegacyInteractive)();
                metrics.onInteractive({
                    lastTransitionStartTime: lastTransitionStartTime
                });
                onEndOfCriticalPath();
            }
        }
        return ()=>{
            prevPropsRef.current = props;
        };
    });
    // Replicate old class based timings
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!hasErroredRef.current) {
            if (isPreview || isComplete) metrics.onPreviewRendered({
                isInitialRender: isInitialRender,
                lastTransitionStartTime: lastTransitionStartTime
            });
            if (isComplete) {
                (0, $jc4kK.markIssueLegacyInteractive)();
                if (!isInitialRender || !(0, $jc4kK.isFullIssueView)()) {
                    metrics.onInteractive({
                        lastTransitionStartTime: lastTransitionStartTime
                    });
                    onEndOfCriticalPath();
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "forge-ui-modifications-count",
        hold: !isUimFinishedLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_spaState, { setAppReady: setAppReady, setAppErrorReady: setAppErrorReady })=>{
        endOfCriticalPath = setAppReady;
        errorOnCriticalPath = setAppErrorReady;
        return null;
    }));
};

});
parcelRegister("3pPAn", function(module, exports) {

$parcel$export(module.exports, "useUimAnalytics", () => $aad64b02f246037e$export$8f85c5a99b6bad53);

var $1ttZy = parcelRequire("1ttZy");

var $ig7wC = parcelRequire("ig7wC");

var $fcNlw = parcelRequire("fcNlw");
const $aad64b02f246037e$export$8f85c5a99b6bad53 = ({ forgeFinishedLoading: forgeFinishedLoading, forgeModulesCount: forgeModulesCount })=>{
    const [{ uiModificationsCount: uiModificationsCount, appsCount: appsCount }] = (0, $fcNlw.useAnalyticsData)();
    const hasIssueAdjustmentFinishedLoading = (0, $1ttZy.useHasFinishedLoading)();
    const adjustmentsAreEnabled = (0, $ig7wC.useAdjustmentsEnabled)();
    const isIssueAdjustmentDisabled = forgeFinishedLoading && (forgeModulesCount === 0 || hasIssueAdjustmentFinishedLoading && !adjustmentsAreEnabled);
    const isIssueAdjustmentEnabled = forgeFinishedLoading && forgeModulesCount > 0 && hasIssueAdjustmentFinishedLoading && adjustmentsAreEnabled;
    return {
        isUimFinishedLoading: isIssueAdjustmentDisabled || isIssueAdjustmentEnabled,
        appsCount: appsCount ?? 0,
        uiModificationsCount: uiModificationsCount ?? 0
    };
};

});
parcelRegister("1ttZy", function(module, exports) {

$parcel$export(module.exports, "useHasFinishedLoading", () => $cf1379fb257ebd41$export$282f17c8d715e155);
$parcel$export(module.exports, "useUiModificationsEnabledStatus", () => $cf1379fb257ebd41$export$408eb757ebd7e139);

var $ggKAj = parcelRequire("ggKAj");

var $ig7wC = parcelRequire("ig7wC");
const $cf1379fb257ebd41$export$282f17c8d715e155 = (0, $ggKAj.createStateHook)((0, $ig7wC.store), {
    selector: (state)=>state.hasFinishedLoading
});
const $cf1379fb257ebd41$export$10b49abde6eddf71 = (0, $ggKAj.createStateHook)((0, $ig7wC.store), {
    selector: (state)=>state.shouldUiModificationsLoad
});
const $cf1379fb257ebd41$export$408eb757ebd7e139 = (hasForgeFinishedLoading)=>{
    const shouldUiModificationsLoad = $cf1379fb257ebd41$export$10b49abde6eddf71();
    const hasFinishedLoading = $cf1379fb257ebd41$export$282f17c8d715e155();
    const adjustmentsAreEnabled = (0, $ig7wC.useAdjustmentsEnabled)();
    const uimIsEnabled = hasForgeFinishedLoading && shouldUiModificationsLoad === 'yes' && hasFinishedLoading && adjustmentsAreEnabled;
    const uimIsDisabled = hasForgeFinishedLoading && (shouldUiModificationsLoad === 'no' || hasFinishedLoading && !adjustmentsAreEnabled);
    if (uimIsEnabled) return 'enabled';
    if (uimIsDisabled) return 'disabled';
    return 'unknown';
};

});


parcelRegister("lcJyp", function(module, exports) {

$parcel$export(module.exports, "SpaStateSubscriber", () => $847fac6342ee5df8$export$fd52daf2a3c1ec68);
$parcel$export(module.exports, "SpaStateActionsSubscriber", () => $847fac6342ee5df8$export$3dfa91988c213fbc);
$parcel$export(module.exports, "useSpaState", () => $847fac6342ee5df8$export$a57865516f6345d1);
$parcel$export(module.exports, "useSpaStateActions", () => $847fac6342ee5df8$export$b134752525935b78);

var $ggKAj = parcelRequire("ggKAj");
var $dYfll = parcelRequire("dYfll");

var $cfLkw = parcelRequire("cfLkw");
const $847fac6342ee5df8$export$fd52daf2a3c1ec68 = (0, $dYfll.createSubscriber)((0, $cfLkw.default));
const $847fac6342ee5df8$export$3dfa91988c213fbc = (0, $dYfll.createSubscriber)((0, $cfLkw.default), {
    selector: null
});
const $847fac6342ee5df8$export$a57865516f6345d1 = (0, $ggKAj.createHook)((0, $cfLkw.default));
const $847fac6342ee5df8$export$b134752525935b78 = (0, $ggKAj.createHook)((0, $cfLkw.default), {
    selector: null
});

});



parcelRegister("iV3wA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2bea088694ddb76$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $izgHs = parcelRequire("izgHs");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$d2bea088694ddb76$export$2e2bcd8739ae039 = ()=>(WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any
        class WithMetricsConsumer extends (0, $eUqFw.Component) {
            static{
                this.displayName = `WithMetricsConsumer(${WrappedComponent.displayName || WrappedComponent.name})`;
            }
            render() {
                const { MetricsContext: MetricsContext } = this;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MetricsContext.Consumer, null, (metrics)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                        ...this.props,
                        metrics: metrics
                    }));
            }
            constructor(...args){
                super(...args);
                this.MetricsContext = (0, $izgHs.getMetricsContext)();
            }
        };

});

parcelRegister("3rnJv", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $986df0a0a476306a$export$947749d756ccb0a);

var $6rW04 = parcelRequire("6rW04");
const $986df0a0a476306a$export$947749d756ccb0a = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';

});

parcelRegister("csTLI", function(module, exports) {

$parcel$export(module.exports, "default", () => $51a60101d83a78c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $eGI9v = parcelRequire("eGI9v");

var $3viaK = parcelRequire("3viaK");

var $5omJE = parcelRequire("5omJE");

var $wKt79 = parcelRequire("wKt79");

var $lqalZ = parcelRequire("lqalZ");

var $osX9J = parcelRequire("osX9J");

var $lXPVG = parcelRequire("lXPVG");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $1Q5ep = parcelRequire("1Q5ep");
class $51a60101d83a78c4$export$1ed2dd1e7a1ac7df extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'Flags';
    }
    render() {
        const { onFlagDismissed: onFlagDismissed, flags: flags, retryIssueDelete: retryIssueDelete, deleteFailureIssueKey: deleteFailureIssueKey, FlagServiceSubscriber: FlagServiceSubscriber, openComment: openComment } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FlagServiceSubscriber, null, ({ showFlag: showFlag })=>// @ts-expect-error - TS2322 - Type 'Element[]' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
            flags.map((flag)=>{
                const flagDetails = (0, $1Q5ep.flagMessages)[flag.type];
                const title = flag.titleI18nValues ? [
                    flagDetails.messages.title,
                    flag.titleI18nValues
                ] : flagDetails.messages.title;
                const description = flag.descriptionI18nValues && flagDetails.messages.description ? [
                    flagDetails.messages.description,
                    flag.descriptionI18nValues
                ] : flagDetails.messages.description;
                const actions = (flagDetails.actions || []).map(({ messages: messages, onClick: onClick })=>({
                        content: messages.content,
                        onClick: ()=>onClick({
                                closeFlag: ()=>onFlagDismissed(flag.id),
                                retryIssueDelete: retryIssueDelete,
                                deleteFailureIssueKey: deleteFailureIssueKey,
                                openComment: ()=>openComment(flag)
                            })
                    }));
                const flagArgs = {
                    title: /*
							 * We can't provide Bento's legacy flag ids as they are strings,
							 * and the flag app expects numbers. By not providing an id, the
							 * flags app will automatically generate one and handle it for us.
							 */ title,
                    ...description && {
                        description: description
                    },
                    type: flagDetails.type,
                    actions: actions,
                    isAutoDismiss: flagDetails.shouldAutoDismiss,
                    testId: flagDetails.testId
                };
                // @ts-expect-error - TS2769 - No overload matches this call.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
                    key: flag.id,
                    args: [
                        flagArgs
                    ],
                    op: showFlag
                });
            }));
    }
    constructor(...args){
        super(...args);
        this.onFlagDismissed = (flagId)=>{
            const { onFlagDismissed: onFlagDismissed } = this.props;
            onFlagDismissed(flagId);
        };
    }
}
var $51a60101d83a78c4$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $eGI9v.default)('deleteIssueRetry', {
    retryIssueDelete: 'deleteIssueRetry'
}), (0, $lqalZ.connect)((state)=>({
        flags: (0, $jZDJX.flagsSelector)(state),
        deleteFailureIssueKey: (0, $5JqpU.issueKeySelector)(state),
        FlagServiceSubscriber: (0, $5omJE.default)
    }), (dispatch)=>({
        onFlagDismissed: (id)=>dispatch((0, $osX9J.dismissFlag)(id)),
        retryIssueDelete: (issueKey, analyticsEvent)=>{
            dispatch((0, $lXPVG.deleteIssueRequest)(issueKey, analyticsEvent, undefined, undefined));
        },
        openComment: (flag)=>{
            const url = `${flag.fullIssueUrl}?focusedCommentId=${flag.commentId}`;
            window.open(url, '_blank')?.focus();
        }
    })), (0, $wKt79.safeComponent)())($51a60101d83a78c4$export$1ed2dd1e7a1ac7df);

});
parcelRegister("5omJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e16a0c982e8c9d5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");
const $7e16a0c982e8c9d5$var$FlagServiceSubscriber = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children((0, $k8Qyf.flagService)));
var $7e16a0c982e8c9d5$export$2e2bcd8739ae039 = $7e16a0c982e8c9d5$var$FlagServiceSubscriber;

});

parcelRegister("1Q5ep", function(module, exports) {

$parcel$export(module.exports, "flagMessages", () => $7077954d27cec34d$export$53093c5ed967346e);
/* messages.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gasA1 = parcelRequire("gasA1");

var $4eMGn = parcelRequire("4eMGn");

var $lD2Nx = parcelRequire("lD2Nx");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $90IgZ = parcelRequire("90IgZ");

var $ggm5u = parcelRequire("ggm5u");

var $0NycV = parcelRequire("0NycV");
const $7077954d27cec34d$var$ColoredIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1cj8",
            __cmplp.className
        ])
    });
});
const $7077954d27cec34d$var$genericErrorIcon = // @ts-expect-error - TS2322 - Type '{ children: Element; size: string; color: "var(--ds-icon-danger)"; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<ClassAttributes<HTMLSpanElement> & HTMLAttributes<HTMLSpanElement> & { ...; }, any>, any, any>> & Readonly<...> & Readonly<...>'.
/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7077954d27cec34d$var$ColoredIcon, {
    size: "medium",
    color: `var(--ds-icon-danger, ${(0, $PdmhA).R300})`
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4eMGn))), {
    label: ""
}));
const $7077954d27cec34d$var$genericSuccessIcon = // @ts-expect-error - TS2322 - Type '{ children: Element; size: string; color: "var(--ds-icon-success)"; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<ClassAttributes<HTMLSpanElement> & HTMLAttributes<HTMLSpanElement> & { ...; }, any>, any, any>> & Readonly<...> & Readonly<...>'.
/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7077954d27cec34d$var$ColoredIcon, {
    size: "medium",
    color: `var(--ds-icon-success, ${(0, $PdmhA).G300})`
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
    label: ""
}));
const $7077954d27cec34d$export$53093c5ed967346e = {
    [(0, $0NycV.COMMENT_ADD_ERROR_GENERIC)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.generic-server-error-when-adding-comment-title",
                "defaultMessage": "Comment could not be updated"
            },
            description: {
                "id": "issue.generic-server-error-when-adding-comment-description",
                "defaultMessage": "There was a connection problem and your comment was not successfully updated. Check your network before trying to update or add another comment."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.COMMENTS_PER_ISSUE_LIMIT_EXCEEDED)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.comments-per-issue-limit-exceeded-title",
                "defaultMessage": "We couldn\u2019t add your comment"
            },
            description: {
                "id": "issue.comments-per-issue-limit-exceeded-description",
                "defaultMessage": "We can\u2019t add any more comments to this issue as the limit has been reached."
            }
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "warning",
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y300})`
        }),
        type: 'warning',
        actions: [
            {
                messages: (0, $90IgZ.defineMessages)({
                    content: {
                        "id": "issue.comments-per-issue-limit-exceeded.contact-administrator",
                        "defaultMessage": "Notify your admin"
                    }
                }),
                onClick: ()=>{
                    if ((0, $1ybV0.ff)('hard-limits-modal-admin_wo9xn')) {
                        // This is necessary since we cannot use React hooks in this file, but still need to access the actions
                        const StoreInstance = (0, $gasA1.defaultRegistry).getStore((0, $ggm5u.Store));
                        StoreInstance.actions.openModal();
                        StoreInstance.actions.setFieldType('comment');
                    } else window.open('/jira/contact-administrator');
                }
            }
        ]
    },
    [(0, $0NycV.COMMENT_ADD_ERROR_INVALID)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.server-validation-error-when-adding-comment-title",
                "defaultMessage": "We couldn't save your comment"
            },
            description: {
                "id": "issue.server-validation-error-when-adding-comment-description",
                "defaultMessage": "It might be empty or have invalid formatting. If you copy-pasted, try removing the formatting and adding it directly in the editor."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.COMMENT_FUTURE_TIME_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.comment-future-time-error-when-adding-comment-title",
                "defaultMessage": "We couldn't save your comment"
            },
            description: {
                "id": "issue.comment-future-time-error-when-adding-comment-description",
                "defaultMessage": "It looks like you've selected a future time for this activity. Send this activity to the current time or a past time instead."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.COMMENT_CONTENT_EXCEEDED_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.content-exceeded-error-when-adding-comment-title",
                "defaultMessage": "We couldn't save your comment"
            },
            description: {
                "id": "issue.content-exceeded-error-when-adding-comment-description",
                "defaultMessage": "The comment is too long. Try reducing its length, splitting it, or attaching a file to the issue."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.SAVE_COMMENT_SUCCESS_FLAG_MESSAGE)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.save-comment-success-flag-when-added-comment-title",
                "defaultMessage": "Note added to the past"
            }
        }),
        icon: $7077954d27cec34d$var$genericSuccessIcon,
        type: 'success',
        actions: [
            {
                messages: (0, $90IgZ.defineMessages)({
                    content: {
                        "id": "issue.save-comment-success-flag-when-added-comment-description",
                        "defaultMessage": "View internal note"
                    }
                }),
                onClick: (a)=>{
                    a.openComment?.();
                    a.closeFlag();
                }
            }
        ],
        shouldAutoDismiss: true
    },
    [(0, $0NycV.COMMENT_DELETE_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.server-error-when-deleting-comment-title",
                "defaultMessage": "Comment could not be deleted"
            },
            description: {
                "id": "issue.server-error-when-deleting-comment-description",
                "defaultMessage": "There was a connection problem and the comment was not successfully deleted. Try checking your network connection."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.EDITOR_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.error-when-retrieving-editor-value-title",
                "defaultMessage": "The text editor failed"
            },
            description: {
                "id": "issue.error-when-retrieving-editor-value-description",
                "defaultMessage": "Retry your last action, or refresh the page."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.RICH_CONTENT_FIELD_CONFIRM_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.error-when-confirming-rich-text-field-value-title",
                "defaultMessage": "We couldn't save your content"
            },
            description: {
                "id": "issue.error-when-confirming-rich-text-field-value-description",
                "defaultMessage": "It may contain formatting we don\u2019t recognize. Try removing the formatting before saving."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.error-when-confirming-rich-text-field-value-title",
                "defaultMessage": "We couldn't save your content"
            },
            description: {
                "id": "issue.error-when-confirming-rich-text-field-value-description-maximum-length-exceeded",
                "defaultMessage": "It's too long for the field. Try attaching a file or page to the issue, or adding part of the content as comments."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.RICH_CONTENT_FIELD_REQUIRED_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.error-when-saving-empty-required-rich-text-field-title",
                "defaultMessage": "We couldn't save your content"
            },
            description: {
                "id": "issue.error-when-saving-empty-required-rich-text-field",
                "defaultMessage": "This field is required and cannot be empty."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.ATTACHMENT_ADD_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.error-when-adding-attachment-title",
                "defaultMessage": "We couldn't save your attachment"
            },
            description: {
                "id": "issue.error-when-adding-attachment-description",
                "defaultMessage": "Reload the issue then try adding it again."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.error-when-adding-attachment-exceed-limit-title",
                "defaultMessage": "We couldn't upload the attachment as you've exceeded the attachment size limit"
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.issue.issue-attachments-per-issue-limit-exceeded.title",
                "defaultMessage": "We couldn\u2019t attach the file"
            },
            description: {
                "id": "issue.issue.issue-attachments-per-issue-limit-exceeded.description",
                "defaultMessage": "We can\u2019t add any more attachments to this issue as the limit has been reached."
            }
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "warning",
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y300})`
        }),
        type: 'warning',
        actions: [
            {
                messages: (0, $90IgZ.defineMessages)({
                    content: {
                        "id": "issue.issue.issue-attachments-per-issue-limit-exceeded.notify-admin",
                        "defaultMessage": "Notify your admin"
                    }
                }),
                onClick: ()=>{
                    if ((0, $1ybV0.ff)('hard-limits-modal-admin_wo9xn')) {
                        // This is necessary since we cannot use React hooks in this file, but still need to access the actions
                        const StoreInstance = (0, $gasA1.defaultRegistry).getStore((0, $ggm5u.Store));
                        StoreInstance.actions.openModal();
                        StoreInstance.actions.setFieldType('attachment');
                    } else window.open('/jira/contact-administrator');
                }
            }
        ],
        shouldAutoDismiss: true
    },
    [(0, $0NycV.ATTACHMENT_ADD_SUCCESS)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.attachment-jira-creation-success-title",
                "defaultMessage": "Successfully attached"
            },
            description: {
                "id": "issue.attachment-jira-creation-success-description",
                "defaultMessage": "You've added {numCreated, plural, one {an attachment} other {attachments}} to {issueKey}."
            }
        }),
        type: 'success',
        icon: $7077954d27cec34d$var$genericSuccessIcon
    },
    [(0, $0NycV.DELETE_LINKED_ISSUE_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.server-error-when-deleting-issue-link-title",
                "defaultMessage": "We couldn't remove the issue link"
            },
            description: {
                "id": "issue.server-error-when-deleting-issue-link-description",
                "defaultMessage": "Try reloading the page and removing the issue link again."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.ATTACHMENT_DELETE_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.server-error-when-deleting-attachment-title",
                "defaultMessage": "Attachment could not be deleted"
            },
            description: {
                "id": "issue.server-error-when-deleting-attachment-description",
                "defaultMessage": "There was a connection problem and the attachment was not successfully deleted. Try checking your network connection."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.WATCH_TOGGLE_UPDATE_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.server-error-when-toggle-watch-title",
                "defaultMessage": "We couldn't update your watch status"
            },
            description: {
                "id": "issue.server-error-when-toggle-watch-description",
                "defaultMessage": "Check your connection and try clicking watch again."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.FETCH_WATCHERS_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.error-when-fetching-watchers-title",
                "defaultMessage": "We couldn't load the watchers list"
            },
            description: {
                "id": "issue.error-when-fetching-watchers-description",
                "defaultMessage": "Check your connection, then give it another try."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.START_WATCHING_SUCCESS)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.start-watching-success-title",
                "defaultMessage": "You're watching this issue"
            },
            description: {
                "id": "issue.start-watching-success-description",
                "defaultMessage": "We'll notify you when there's activity on it."
            }
        }),
        icon: $7077954d27cec34d$var$genericSuccessIcon,
        type: 'success'
    },
    [(0, $0NycV.STOP_WATCHING_SUCCESS)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.stop-watching-success-title",
                "defaultMessage": "You stopped watching this issue"
            },
            description: {
                "id": "issue.stop-watching-success-description",
                "defaultMessage": "We won't notify you about activity on it."
            }
        }),
        icon: $7077954d27cec34d$var$genericSuccessIcon,
        type: 'success'
    },
    [(0, $0NycV.REMOVE_WATCHER_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.error-when-removing-watcher-title",
                "defaultMessage": "We couldn't remove that watcher"
            },
            description: {
                "id": "issue.error-when-removing-watcher-description",
                "defaultMessage": "Check your connection, then give it another try."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.ADD_WATCHER_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.error-when-adding-watcher-title",
                "defaultMessage": "We couldn't add that watcher"
            },
            description: {
                "id": "issue.error-when-adding-watcher-description",
                "defaultMessage": "Check your connection, then give it another try."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.SUBTASKS_REORDER_ERROR_GENERIC)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.error-when-reordering-subtask",
                "defaultMessage": "We couldn't reorder those subtasks"
            },
            description: {
                "id": "issue.error-when-reordering-subtask-description",
                "defaultMessage": "Wait a few moments, then give it another try."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.LOG_WORK_CONFIRM_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.server-error-when-logging-work-title",
                "defaultMessage": "We couldn't add your time spent"
            },
            description: {
                "id": "issue.server-error-when-logging-work-description",
                "defaultMessage": "Check your connection, then give it another try."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.ASSIGN_TO_ME_SUCCESS)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.assign-to-me-flag-title",
                "defaultMessage": "Successfully assigned to you"
            },
            description: {
                "id": "issue.assign-to-me-flag-description",
                "defaultMessage": "You're now the assignee for {issueKey}."
            }
        }),
        icon: $7077954d27cec34d$var$genericSuccessIcon,
        type: 'success',
        shouldAutoDismiss: true
    },
    [(0, $0NycV.REMOVE_FROM_ME_SUCCESS)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.remove-from-me-flag-title",
                "defaultMessage": "Successfully unassigned issue"
            },
            description: {
                "id": "issue.remove-from-me-flag-description",
                "defaultMessage": "You've been removed as the assignee from {issueKey}. (To reassign yourself, select 'i' again.)"
            }
        }),
        icon: $7077954d27cec34d$var$genericSuccessIcon,
        type: 'success',
        shouldAutoDismiss: true
    },
    [(0, $0NycV.CREATE_CHILD_ISSUE_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.error-when-creating-child-issue-title",
                "defaultMessage": "We couldn't create the child issue"
            },
            description: {
                "id": "issue.error-when-creating-child-issue-description",
                "defaultMessage": "Check your connection, then give it another try."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.LINK_CHILD_ISSUE_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.error-when-linking-child-issue-title",
                "defaultMessage": "We couldn't link the child issue"
            },
            description: {
                "id": "issue.error-when-linking-child-issue-description",
                "defaultMessage": "The issue was created but the linking failed. Head over to your board and try again."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.CHANGE_ISSUE_TYPE_SUCCESS)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "change.issue.type.success.title",
                "defaultMessage": "Issue type changed to {destType}"
            },
            description: {
                "id": "change.issue.type.success.description",
                "defaultMessage": "Issue type changed"
            }
        }),
        icon: $7077954d27cec34d$var$genericSuccessIcon,
        type: 'success',
        shouldAutoDismiss: false,
        testId: 'issue.views.issue-base.foundation.change-issue-type.flag.success'
    },
    [(0, $0NycV.CHANGE_ISSUE_TYPE_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "change.issue.type.error.title",
                "defaultMessage": "Error changing issue type"
            },
            description: {
                "id": "change.issue.type.error.description",
                "defaultMessage": "There was an error changing the issue type. Please try again."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error',
        shouldAutoDismiss: false,
        testId: 'issue.views.issue-base.foundation.change-issue-type.flag.error'
    },
    [(0, $0NycV.DELETE_ISSUE_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.error-when-deleting-issue-title",
                "defaultMessage": "We couldn't delete {issueKey}"
            },
            description: {
                "id": "issue.error-when-deleting-issue-description",
                "defaultMessage": "Check your connection, then give it another try."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error',
        actions: [
            {
                messages: (0, $90IgZ.defineMessages)({
                    content: {
                        "id": "issue.error-when-deleting-issue-call-to-action",
                        "defaultMessage": "Try again"
                    }
                }),
                onClick: ({ closeFlag: closeFlag, retryIssueDelete: retryIssueDelete, deleteFailureIssueKey: deleteFailureIssueKey })=>{
                    if (retryIssueDelete && deleteFailureIssueKey !== undefined && deleteFailureIssueKey !== null && deleteFailureIssueKey !== '') retryIssueDelete(deleteFailureIssueKey);
                    closeFlag();
                }
            }
        ]
    },
    [(0, $0NycV.EDIT_WORKLOG_SUCCESS)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.activity.worklog.flags.edit-success-title",
                "defaultMessage": "Work log entry updated"
            }
        }),
        icon: $7077954d27cec34d$var$genericSuccessIcon,
        type: 'success',
        shouldAutoDismiss: true
    },
    [(0, $0NycV.DELETE_WORKLOG_SUCCESS)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.activity.worklog.flags.delete-success-title",
                "defaultMessage": "Work log entry deleted"
            }
        }),
        icon: $7077954d27cec34d$var$genericSuccessIcon,
        type: 'success',
        shouldAutoDismiss: true
    },
    [(0, $0NycV.ADD_WORKLOG_FAILURE)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.activity.worklog.flags.add-failure-title",
                "defaultMessage": "We couldn't save your changes"
            },
            description: {
                "id": "issue.activity.worklog.flags.add-failure-description",
                "defaultMessage": "Check your connection, then give it another try."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.worklogs-per-issue-limit-exceeded-title",
                "defaultMessage": "We couldn\u2019t log your time"
            },
            description: {
                "id": "issue.worklogs-per-issue-limit-exceeded-description",
                "defaultMessage": "We can\u2019t log any more time on this issue as the limit as been reached."
            }
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "warning",
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y300})`
        }),
        type: 'warning',
        actions: [
            {
                messages: (0, $90IgZ.defineMessages)({
                    content: {
                        "id": "issue.worklogs-per-issue-limit-exceeded.contact-administrator",
                        "defaultMessage": "Notify your admin"
                    }
                }),
                onClick: ()=>{
                    if ((0, $1ybV0.ff)('hard-limits-modal-admin_wo9xn')) {
                        // This is necessary since we cannot use React hooks in this file, but still need to access the actions
                        const StoreInstance = (0, $gasA1.defaultRegistry).getStore((0, $ggm5u.Store));
                        StoreInstance.actions.openModal();
                        StoreInstance.actions.setFieldType('worklog');
                    } else window.open('/jira/contact-administrator');
                }
            }
        ]
    },
    [(0, $0NycV.ADD_WORKLOG_SUCCESS)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.activity.worklog.flags.add-success-title",
                "defaultMessage": "Successfully logged work"
            },
            description: {
                "id": "issue.activity.worklog.flags.add-success-description",
                "defaultMessage": "You've logged work to {issueKey}."
            }
        }),
        icon: $7077954d27cec34d$var$genericSuccessIcon,
        type: 'success',
        shouldAutoDismiss: true
    },
    [(0, $0NycV.UPDATE_TIME_REMAINING_FAILURE)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.activity.worklog.flags.update-time-remaining-failure-title",
                "defaultMessage": "We couldn't save your edit"
            },
            description: {
                "id": "issue.activity.worklog.flags.update-time-remaining-failure-description",
                "defaultMessage": "Check your connection, then give it another try."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.EDIT_WORKLOG_FAILURE)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.activity.worklog.flags.edit-failure-title",
                "defaultMessage": "We couldn't save your edit"
            },
            description: {
                "id": "issue.activity.worklog.flags.failure-description",
                "defaultMessage": "Check your connection, then give it another try."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.DELETE_WORKLOG_FAILURE)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.activity.worklog.flags.delete-failure-title",
                "defaultMessage": "We couldn't delete the work log entry"
            },
            description: {
                "id": "issue.activity.worklog.flags.failure-description",
                "defaultMessage": "Check your connection, then give it another try."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.DELETE_CONFLUENCE_PAGE_LINK_FAILED)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.confluence-pages.delete-failure-title",
                "defaultMessage": "We couldn\u2019t remove the Confluence page link"
            },
            description: {
                "id": "issue.confluence-pages.delete-failure-description",
                "defaultMessage": "Check your connection, then give it another try."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error'
    },
    [(0, $0NycV.CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.links-per-issue-limit-exceeded-title",
                "defaultMessage": "We couldn\u2019t add the link"
            },
            description: {
                "id": "issue.links-per-issue-limit-exceeded-description",
                "defaultMessage": "We can\u2019t link to any more Confluence pages in this issue as the limit of remote links has been reached."
            }
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "warning",
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y300})`
        }),
        type: 'warning',
        actions: [
            {
                messages: (0, $90IgZ.defineMessages)({
                    content: {
                        "id": "issue.links-per-issue-limit-exceeded.contact-administrator",
                        "defaultMessage": "Notify your admin"
                    }
                }),
                onClick: ()=>{
                    if ((0, $1ybV0.ff)('hard-limits-modal-admin_wo9xn')) {
                        // This is necessary since we cannot use React hooks in this file, but still need to access the actions
                        const StoreInstance = (0, $gasA1.defaultRegistry).getStore((0, $ggm5u.Store));
                        StoreInstance.actions.openModal();
                        StoreInstance.actions.setFieldType('attachment');
                    } else window.open('/jira/contact-administrator');
                }
            }
        ]
    },
    [(0, $0NycV.SAVE_APPROVAL_ANSWER_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.approval.action.save-error-title",
                "defaultMessage": "We couldn\u2019t save your approval response"
            },
            description: {
                "id": "issue.approval.action.save-error-description",
                "defaultMessage": "Give it a few seconds, then try again."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error',
        shouldAutoDismiss: true
    },
    [(0, $0NycV.SAVE_APPROVAL_ANSWER_SUCCESS)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.approval.action.save-success-title",
                "defaultMessage": "We've saved your response."
            }
        }),
        icon: $7077954d27cec34d$var$genericSuccessIcon,
        type: 'success',
        shouldAutoDismiss: true
    },
    [(0, $0NycV.EDIT_EPIC_COLOUR_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.color.action.change-color-title",
                "defaultMessage": "We couldn\u2019t change the epic color"
            },
            description: {
                "id": "issue.color.action.change-color-description",
                "defaultMessage": "Check your connection, then give it another try."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'success',
        shouldAutoDismiss: true
    },
    [(0, $0NycV.EDIT_ISSUE_COLOUR_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.color.action.change-issue-color-title",
                "defaultMessage": "We couldn\u2019t change the issue color"
            },
            description: {
                "id": "issue.color.action.change-issue-color-description",
                "defaultMessage": "Check your connection, then give it another try."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'success',
        shouldAutoDismiss: true
    },
    [(0, $0NycV.FETCH_JIRA_APP_LINKS_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.link.jira-app-link-fetch-error-title",
                "defaultMessage": "We couldn\u2019t fetch remote Jira application links"
            },
            description: {
                "id": "issue.link.jira-app-link-fetch-error-description",
                "defaultMessage": "Check your connection, then give it another try."
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error',
        shouldAutoDismiss: true
    },
    [(0, $0NycV.REMOTE_LINK_VALIDATION_ERROR)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.link.jira-remote-link-server-error-title",
                "defaultMessage": "We couldn't link the issue to {remoteIssueKey}."
            },
            description: {
                "id": "issue.link.jira-remote-link-server-error-description",
                "defaultMessage": "Reason: {i18nServerErrorMessage}"
            }
        }),
        icon: $7077954d27cec34d$var$genericErrorIcon,
        type: 'error',
        shouldAutoDismiss: true
    },
    [(0, $0NycV.ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue.issue-links-per-issue-limit-exceeded-title",
                "defaultMessage": "We couldn\u2019t link the issue"
            },
            description: {
                "id": "issue.issue-links-per-issue-limit-exceeded-description",
                "defaultMessage": "We can\u2019t link any more local issues as the limit has been reached."
            }
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "warning",
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y300})`
        }),
        type: 'warning',
        actions: [
            {
                messages: (0, $90IgZ.defineMessages)({
                    content: {
                        "id": "issue.issue-links-per-issue-limit-exceeded.contact-administrator",
                        "defaultMessage": "Notify your admin"
                    }
                }),
                onClick: ()=>{
                    if ((0, $1ybV0.ff)('hard-limits-modal-admin_wo9xn')) {
                        // This is necessary since we cannot use React hooks in this file, but still need to access the actions
                        const StoreInstance = (0, $gasA1.defaultRegistry).getStore((0, $ggm5u.Store));
                        StoreInstance.actions.openModal();
                        StoreInstance.actions.setFieldType('issuelinks');
                    } else window.open('/jira/contact-administrator');
                }
            }
        ]
    },
    [(0, $0NycV.ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED)]: {
        messages: (0, $90IgZ.defineMessages)({
            title: {
                "id": "issue-view-base.content.issue-links-limit-exceeded.title",
                "defaultMessage": "We couldn\u2019t link the issue"
            },
            description: {
                "id": "issue-view-base.content.issue-links-limit-exceeded.description",
                "defaultMessage": "We can\u2019t link any more remote issues as the limit has been reached."
            }
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "warning",
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y300})`
        }),
        type: 'warning',
        actions: [
            {
                messages: (0, $90IgZ.defineMessages)({
                    content: {
                        "id": "issue-view-base.content.issue-links.content",
                        "defaultMessage": "Notify your admin"
                    }
                }),
                onClick: ()=>{
                    if ((0, $1ybV0.ff)('hard-limits-modal-admin_wo9xn')) {
                        // This is necessary since we cannot use React hooks in this file, but still need to access the actions
                        const StoreInstance = (0, $gasA1.defaultRegistry).getStore((0, $ggm5u.Store));
                        StoreInstance.actions.openModal();
                        StoreInstance.actions.setFieldType('remoteIssueLinks');
                    } else window.open('/jira/contact-administrator');
                }
            }
        ]
    }
};

});
parcelRegister("4eMGn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $315e3b8ffdb604aa$var$_react = $315e3b8ffdb604aa$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $315e3b8ffdb604aa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $315e3b8ffdb604aa$var$EditorErrorIcon = (props)=>/*#__PURE__*/ $315e3b8ffdb604aa$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M13.485 11.929l2.122-2.121a1 1 0 00-1.415-1.415l-2.12 2.122L9.95 8.393a1 1 0 00-1.414 1.415l2.12 2.12-2.12 2.122a1 1 0 001.414 1.414l2.121-2.12 2.121 2.12a1 1 0 101.415-1.414l-2.122-2.121zM12 20a8 8 0 110-16 8 8 0 010 16z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$315e3b8ffdb604aa$var$EditorErrorIcon.displayName = 'EditorErrorIcon';
var $315e3b8ffdb604aa$var$_default = $315e3b8ffdb604aa$var$EditorErrorIcon;
module.exports.default = $315e3b8ffdb604aa$var$_default;

});



parcelRegister("cFgLp", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteIssueActions", () => $e94af45276476756$export$bb11d70ede77bdae);

var $eUqFw = parcelRequire("eUqFw");

var $avCOH = parcelRequire("avCOH");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");
const $e94af45276476756$var$STABLE_EMPTY_OBJECT = {};
const $e94af45276476756$export$bb11d70ede77bdae = ({ issueKey: issueKey })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $avCOH.asyncIssueActionsEntryPoint), $e94af45276476756$var$STABLE_EMPTY_OBJECT);
    const issueId = (0, $hJ992.useIssueId)();
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>(0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r') ? {
            issueKey: issueKey,
            issueId: issueId,
            trigger: 'issue-view'
        } : {
            issueKey: issueKey
        }, [
        issueKey,
        issueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira.issue-view.command-palette.issue-actions-core",
        packageName: "issue-view",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: runtimeProps
    });
};

});
parcelRegister("avCOH", function(module, exports) {

$parcel$export(module.exports, "asyncIssueActionsEntryPoint", () => $44ef5d5fbfd66bbe$export$e013874630754774);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $44ef5d5fbfd66bbe$export$e013874630754774 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(async ()=>(await (parcelRequire("bjX8E"))).CommandPaletteIssueActionsEntryPoint, {
        moduleId: "417164b4"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bjX8E", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('cr85J')
        ]);
        const value = parcelRequire('eJvfR');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("cr85J")
    ]).then(()=>parcelRequire('eJvfR'));
}

});



parcelRegister("2nMTq", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSubscriber", () => $409d110a179eb2e4$export$86e984cf98c12013);

var $lqalZ = parcelRequire("lqalZ");

var $49xWy = parcelRequire("49xWy");

var $2qnhn = parcelRequire("2qnhn");
const $409d110a179eb2e4$export$18c579fa058c4b7e = ({ linkIssuesRequest: linkIssuesRequest, linkIssuesSuccess: linkIssuesSuccess, linkIssuesFailure: linkIssuesFailure, unlinkIssueRequest: unlinkIssueRequest, unlinkIssueSuccess: unlinkIssueSuccess, unlinkIssueFailure: unlinkIssueFailure })=>{
    (0, $2qnhn.useLinkUnlinkIssues)({
        linkIssuesRequest: linkIssuesRequest,
        linkIssuesSuccess: linkIssuesSuccess,
        linkIssuesFailure: linkIssuesFailure,
        unlinkIssueRequest: unlinkIssueRequest,
        unlinkIssueSuccess: unlinkIssueSuccess,
        unlinkIssueFailure: unlinkIssueFailure
    });
    return null;
};
const $409d110a179eb2e4$export$86e984cf98c12013 = (0, $lqalZ.connect)(undefined, (dispatch)=>({
        linkIssuesRequest: (issueLinks)=>{
            dispatch((0, $49xWy.saveLinkedIssueRequestWithoutFetch)(issueLinks));
        },
        linkIssuesSuccess: (optimisticId, analyticsEvent, issueKey, postAnalyticsEvent)=>{
            dispatch((0, $49xWy.saveLinkedIssueSuccess)(optimisticId, analyticsEvent, issueKey, postAnalyticsEvent));
        },
        linkIssuesFailure: (optimisticId, error, analyticsEvent)=>{
            dispatch((0, $49xWy.saveLinkedIssueFailure)(optimisticId, error, analyticsEvent));
        },
        unlinkIssueRequest: (linkedIssueId, application, edition)=>{
            dispatch((0, $49xWy.deleteLinkedIssueRequestWithoutFetch)(linkedIssueId, application, edition));
        },
        unlinkIssueSuccess: (linkedIssueId, meta)=>{
            dispatch((0, $49xWy.deleteLinkedIssueSuccess)(linkedIssueId, meta));
        },
        unlinkIssueFailure: (linkedIssueId)=>{
            dispatch((0, $49xWy.deleteLinkedIssueFailure)(linkedIssueId));
        }
    }))($409d110a179eb2e4$export$18c579fa058c4b7e);

});
parcelRegister("2qnhn", function(module, exports) {

$parcel$export(module.exports, "useLinkUnlinkIssues", () => $4f82c22215346854$export$7cd9ad0c1a615999);
// Original onAdd issue link lives here: jira/src/packages/issue/issue-view-base/src/content/issue-links/add/view.tsx

var $eUqFw = parcelRequire("eUqFw");

var $iab71 = parcelRequire("iab71");

var $hJ992 = parcelRequire("hJ992");

var $7ffsx = parcelRequire("7ffsx");

var $bFzGY = parcelRequire("bFzGY");

var $guDlK = parcelRequire("guDlK");
const $4f82c22215346854$export$7cd9ad0c1a615999 = ({ linkIssuesRequest: linkIssuesRequest, linkIssuesSuccess: linkIssuesSuccess, linkIssuesFailure: linkIssuesFailure, unlinkIssueRequest: unlinkIssueRequest, unlinkIssueSuccess: unlinkIssueSuccess, unlinkIssueFailure: unlinkIssueFailure })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const application = (0, $guDlK.useApplication)(projectKey, true);
    const edition = (0, $guDlK.useEdition)(projectKey, true);
    (0, $eUqFw.useEffect)(()=>{
        const unregister = (0, $iab71.commandPaletteSubscribeEvent)('link-issues-request', (data)=>{
            if (!(data.id === 'link-issues-request')) return;
            const { optimisticId: optimisticId, newIssueLink: newIssueLink, issueLinkType: issueLinkType } = data.data;
            linkIssuesRequest({
                optimisticId: optimisticId,
                linkedIssueKey: newIssueLink.key,
                issueLinkType: issueLinkType,
                issueLinks: (0, $7ffsx.transformIssueLink)(optimisticId, issueLinkType, newIssueLink, ''),
                isOpenedFromJsmSimilarIssues: false
            });
        });
        return ()=>{
            unregister();
        };
    }, [
        linkIssuesRequest
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const unregister = (0, $iab71.commandPaletteSubscribeEvent)('link-issues-success', (data)=>{
            if (!(data.id === 'link-issues-success')) return;
            const { optimisticId: optimisticId, linkedIssueKey: linkedIssueKey } = data.data;
            linkIssuesSuccess(optimisticId, createAnalyticsEvent({
                action: 'succeeded',
                isOpenedFromJsmSimilarIssues: false
            }), linkedIssueKey, createAnalyticsEvent({
                action: 'linkedToProject'
            }));
        });
        return ()=>{
            unregister();
        };
    }, [
        createAnalyticsEvent,
        linkIssuesSuccess
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const unregister = (0, $iab71.commandPaletteSubscribeEvent)('link-issues-failure', (data)=>{
            if (!(data.id === 'link-issues-failure')) return;
            const { optimisticId: optimisticId, error: error } = data.data;
            linkIssuesFailure(optimisticId, error);
        });
        return ()=>{
            unregister();
        };
    }, [
        linkIssuesFailure
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const unregister = (0, $iab71.commandPaletteSubscribeEvent)('unlink-issue-request', (data)=>{
            if (!(data.id === 'unlink-issue-request')) return;
            const { linkedIssueId: linkedIssueId } = data.data;
            unlinkIssueRequest(linkedIssueId, application, edition);
        });
        return ()=>{
            unregister();
        };
    }, [
        unlinkIssueRequest,
        application,
        edition
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const unregister = (0, $iab71.commandPaletteSubscribeEvent)('unlink-issue-success', (data)=>{
            if (!(data.id === 'unlink-issue-success')) return;
            const { linkedIssueId: linkedIssueId, issueId: issueId, direction: direction } = data.data;
            unlinkIssueSuccess(linkedIssueId, {
                issueId: issueId,
                direction: direction
            });
        });
        return ()=>{
            unregister();
        };
    }, [
        unlinkIssueSuccess
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const unregister = (0, $iab71.commandPaletteSubscribeEvent)('unlink-issue-failure', (data)=>{
            if (!(data.id === 'unlink-issue-failure')) return;
            const { linkedIssueId: linkedIssueId } = data.data;
            unlinkIssueFailure(linkedIssueId);
        });
        return ()=>{
            unregister();
        };
    }, [
        unlinkIssueFailure
    ]);
    return null;
};

});
parcelRegister("iab71", function(module, exports) {

$parcel$export(module.exports, "commandPaletteDispatchEvent", () => $9eef1c7f96445291$export$fcf2a9d6ccd50188);
$parcel$export(module.exports, "commandPaletteSubscribeEvent", () => $9eef1c7f96445291$export$e59db271f5e00c23);

var $iglCz = parcelRequire("iglCz");
const $9eef1c7f96445291$export$fcf2a9d6ccd50188 = (data)=>{
    (0, $iglCz.commandPaletteDispatchEvent)(data);
};
const $9eef1c7f96445291$export$e59db271f5e00c23 = (eventId, callback)=>(0, $iglCz.commandPaletteSubscribeEvent)(eventId, callback);

});
parcelRegister("iglCz", function(module, exports) {

$parcel$export(module.exports, "commandPaletteDispatchEvent", () => $42cdd486988be88c$export$fcf2a9d6ccd50188);
$parcel$export(module.exports, "commandPaletteSubscribeEvent", () => $42cdd486988be88c$export$e59db271f5e00c23);

var $hqtXo = parcelRequire("hqtXo");
const $42cdd486988be88c$export$fcf2a9d6ccd50188 = (data)=>{
    document.dispatchEvent(new CustomEvent((0, $hqtXo.getCommandPaletteEvent)(data.id), {
        detail: data
    }));
};
const $42cdd486988be88c$export$e59db271f5e00c23 = (eventId, callbackFunction)=>{
    const eventListener = (event)=>{
        // Type casted to CommandPaletteEvent<EventDataType> as addEventListener does not support typed CustomEvents
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const customEvent = event;
        callbackFunction(customEvent.detail);
    };
    document.addEventListener((0, $hqtXo.getCommandPaletteEvent)(eventId), eventListener);
    return ()=>document.removeEventListener((0, $hqtXo.getCommandPaletteEvent)(eventId), eventListener);
};

});
parcelRegister("hqtXo", function(module, exports) {

$parcel$export(module.exports, "getCommandPaletteEvent", () => $9b5dbef09d7b533a$export$53e19910ad607ea5);
const $9b5dbef09d7b533a$export$53e19910ad607ea5 = (eventName)=>`command-palette-event-${eventName}`;

});



parcelRegister("7ffsx", function(module, exports) {

$parcel$export(module.exports, "transformIssueLink", () => $3119353115647477$export$4cbea0d26829e8f6);
$parcel$export(module.exports, "transformSaveRemoteIssueLinkPayload", () => $3119353115647477$export$e7b59b8685ff8cdb);


var $lV5H0 = parcelRequire("lV5H0");

var $6vrw7 = parcelRequire("6vrw7");
const $3119353115647477$export$4cbea0d26829e8f6 = (optimisticId, issueLinkType, issueLink, baseUrl)=>{
    const issueLinks = {
        [optimisticId]: {
            id: optimisticId,
            linkedIssueKey: issueLink.key,
            direction: issueLinkType.direction,
            typeName: issueLinkType.label,
            typeId: issueLinkType.id
        }
    };
    const linkedIssues = {
        [`${issueLink.key}`]: {
            id: issueLink.key,
            issueKey: issueLink.key,
            issueId: issueLink.id !== null && issueLink.id !== undefined ? issueLink.id.toString() : null,
            issueLink: (0, $lV5H0.getIssueHtmlUrl)(baseUrl, issueLink.key),
            issueSummary: issueLink.summaryText ? issueLink.summaryText : '',
            issueTypeIconUrl: issueLink.img ? issueLink.img : ''
        }
    };
    return {
        issueLinks: issueLinks,
        linkedIssues: // @ts-expect-error - TS2322 - Type '{ [x: string]: { id: string; issueKey: string; issueId: string | null; issueLink: string; issueSummary: string; issueTypeIconUrl: string; }; }' is not assignable to type 'NormalizedLinkedIssues'.
        linkedIssues
    };
};
const $3119353115647477$export$284468597ba041f2 = 'com.atlassian.jira';
const $3119353115647477$export$30ebb2e2038ab0a7 = 'jira';
// RemoteJiraGlobalIdFactoryImpl.java
const $3119353115647477$var$APP_ID_KEY = 'appId';
const $3119353115647477$var$ISSUE_ID_KEY = 'issueId';
const $3119353115647477$var$createGlobalId = (appLinkId, issueId)=>(0, $6vrw7.toRemoteLinkGlobalId)(`${$3119353115647477$var$APP_ID_KEY}=${appLinkId}&${$3119353115647477$var$ISSUE_ID_KEY}=${issueId}`);
const $3119353115647477$export$e7b59b8685ff8cdb = (index, newIssueLink, jiraAppLink, issueLinkType, createReciprocalLink)=>{
    const optimisticId = `OPTIMISTIC_LINKED_ISSUE_${Date.now()}_${index}`;
    const { fullObject: { id: id, key: key, summaryText: summaryText }, iconUrl: iconUrl } = newIssueLink;
    const { id: appLinkId, name: appLinkName, baseUrl: baseUrl } = jiraAppLink;
    const partialPayload = {
        id: optimisticId,
        applicationType: $3119353115647477$export$284468597ba041f2,
        applicationName: appLinkName,
        issueLinkUrl: (0, $lV5H0.getIssueHtmlUrl)(baseUrl, key),
        relationship: issueLinkType.label,
        summary: summaryText,
        iconUrl: (0, $6vrw7.toHref)(iconUrl),
        issueKey: key,
        createReciprocalLink: createReciprocalLink
    };
    if (!id) return {
        ...partialPayload,
        appLinkId: appLinkId,
        // @ts-expect-error - TS2322 - Type '"WITHOUT_ISSUE_ID"' is not assignable to type '"WITH_ISSUE_ID"'.
        payloadType: (0, $70e59ad1dd71402d$export$301a5c7f9b4c13e1)
    };
    const issueId = (0, $6vrw7.toIssueId)(id.toString());
    return {
        ...partialPayload,
        globalId: $3119353115647477$var$createGlobalId(appLinkId, issueId),
        remoteIssueId: issueId,
        payloadType: (0, $70e59ad1dd71402d$export$df68a44a73b1d288)
    };
};

});



parcelRegister("dfmdn", function(module, exports) {

$parcel$export(module.exports, "IncidentManagementChangeboarding", () => $9f30dfd2c6c064c1$export$571fd2fcaf56f9b4);

var $eUqFw = parcelRequire("eUqFw");

var $2wCUM = parcelRequire("2wCUM");

var $eHxC1 = parcelRequire("eHxC1");

var $lCU4q = parcelRequire("lCU4q");

var $iriuZ = parcelRequire("iriuZ");

var $alaOW = parcelRequire("alaOW");
const $9f30dfd2c6c064c1$export$571fd2fcaf56f9b4 = ()=>{
    const isJsmIncident = (0, $2wCUM.useIsIssueOfIncidentsPractice)();
    const renderJsmIncidentChangeboarding = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $alaOW.AsyncUpdateIncidentModalContainer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iriuZ.AsyncUpdateAssigneeFlagContainer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lCU4q.AsyncUpdateAffectedServicesFlagContainer), null));
    return isJsmIncident ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderJsmIncidentChangeboarding(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eHxC1.AsyncMajorIncChangeBoardingFlagContainer), null)) : null;
};

});
parcelRegister("2wCUM", function(module, exports) {

$parcel$export(module.exports, "usePracticesFieldValue", () => $7ae062e66f35ed18$export$edecf7b484763b0d);
$parcel$export(module.exports, "useIsIssueOfIncidentsPractice", () => $7ae062e66f35ed18$export$3d5b53ead0d10d84);
$parcel$export(module.exports, "useIsIssueOfPostIncidentReviewPractice", () => $7ae062e66f35ed18$export$2a245b8b8b1276b1);
$parcel$export(module.exports, "useIsIssueOfDeveloperEscalationPractice", () => $7ae062e66f35ed18$export$4f9a7f08c8bc7afb);

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $lO4Or = parcelRequire("lO4Or");

var $f1lMr = parcelRequire("f1lMr");
const $7ae062e66f35ed18$export$edecf7b484763b0d = ({ issueKey: issueKey })=>(0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.SERVICEDESK_PRACTICES_TYPE)
    });
const $7ae062e66f35ed18$export$3d5b53ead0d10d84 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [practices] = $7ae062e66f35ed18$export$edecf7b484763b0d({
        issueKey: issueKey
    });
    return Array.isArray(practices) && practices?.includes((0, $f1lMr.INCIDENTS));
};
const $7ae062e66f35ed18$export$2a245b8b8b1276b1 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [practices] = $7ae062e66f35ed18$export$edecf7b484763b0d({
        issueKey: issueKey
    });
    return Array.isArray(practices) && practices?.includes((0, $f1lMr.POST_INCIDENT_REVIEWS));
};
const $7ae062e66f35ed18$export$4f9a7f08c8bc7afb = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [practices] = $7ae062e66f35ed18$export$edecf7b484763b0d({
        issueKey: issueKey
    });
    return Array.isArray(practices) && practices?.includes((0, $f1lMr.DEVELOPER_ESCALATION));
};

});
parcelRegister("f1lMr", function(module, exports) {

$parcel$export(module.exports, "CHANGES", () => $d4363a603a2b1168$export$8598196f74460271);
$parcel$export(module.exports, "INCIDENTS", () => $d4363a603a2b1168$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "PROBLEMS", () => $d4363a603a2b1168$export$ceba70db1edb1def);
$parcel$export(module.exports, "SERVICE_REQUEST", () => $d4363a603a2b1168$export$3d1cda9bd50505e8);
$parcel$export(module.exports, "POST_INCIDENT_REVIEWS", () => $d4363a603a2b1168$export$6ebf7b6bf1c580f);
$parcel$export(module.exports, "DEVELOPER_ESCALATION", () => $d4363a603a2b1168$export$81e62964cc725098);
$parcel$export(module.exports, "NO_CATEGORY", () => $d4363a603a2b1168$export$485b1216c42d8d4);
$parcel$export(module.exports, "NO_PRACTICE", () => $d4363a603a2b1168$export$52bf3f16b7812704);
$parcel$export(module.exports, "SHORT_FORM_CHANGES", () => $d4363a603a2b1168$export$a50185c8e9fb007e);
$parcel$export(module.exports, "SHORT_FORM_INCIDENTS", () => $d4363a603a2b1168$export$a54a30a3c3cce634);
$parcel$export(module.exports, "SHORT_FORM_PROBLEMS", () => $d4363a603a2b1168$export$354f3a4c6ac0c903);
$parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", () => $d4363a603a2b1168$export$335d3ac0c367f03f);
$parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", () => $d4363a603a2b1168$export$7ffd7f2c2ae96b6f);
$parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", () => $d4363a603a2b1168$export$cb41b99ca54e6bd);
$parcel$export(module.exports, "CHANGES_JQL_NAME", () => $d4363a603a2b1168$export$6c24c440228eac9c);
$parcel$export(module.exports, "INCIDENTS_JQL_NAME", () => $d4363a603a2b1168$export$5b65d27ec2d28d18);
$parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", () => $d4363a603a2b1168$export$3f757c5e00588ffd);
$parcel$export(module.exports, "practiceKeyJqlNameMapping", () => $d4363a603a2b1168$export$b78213db77524b5b);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP", () => $d4363a603a2b1168$export$fbf0dfd01228e38d);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_NEW", () => $d4363a603a2b1168$export$91058e4cd637c2c2);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", () => $d4363a603a2b1168$export$45ba5f49e9509c4d);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE_NEW", () => $d4363a603a2b1168$export$b5fa39e9cb62e552);

var $edAb7 = parcelRequire("edAb7");
const $d4363a603a2b1168$export$8598196f74460271 = 'change-management';
const $d4363a603a2b1168$export$a50b49a533b5f7bc = 'incident-management';
const $d4363a603a2b1168$export$ceba70db1edb1def = 'problem-management';
const $d4363a603a2b1168$export$3d1cda9bd50505e8 = 'service-request';
const $d4363a603a2b1168$export$6ebf7b6bf1c580f = 'post-incident-review';
const $d4363a603a2b1168$export$81e62964cc725098 = 'developer-escalation';
const $d4363a603a2b1168$export$a613d808168c7b25 = [
    $d4363a603a2b1168$export$8598196f74460271,
    $d4363a603a2b1168$export$a50b49a533b5f7bc,
    $d4363a603a2b1168$export$ceba70db1edb1def,
    $d4363a603a2b1168$export$3d1cda9bd50505e8,
    $d4363a603a2b1168$export$6ebf7b6bf1c580f,
    $d4363a603a2b1168$export$81e62964cc725098
]; // /!\ defines WorkCategoryApiResource type
const $d4363a603a2b1168$export$a2b1f8f055150f02 = [
    $d4363a603a2b1168$export$8598196f74460271,
    $d4363a603a2b1168$export$a50b49a533b5f7bc,
    $d4363a603a2b1168$export$ceba70db1edb1def,
    $d4363a603a2b1168$export$3d1cda9bd50505e8,
    $d4363a603a2b1168$export$6ebf7b6bf1c580f
]; // /!\ defines WorkCategoryQueueSupported type
const $d4363a603a2b1168$export$485b1216c42d8d4 = 'no-category';
const $d4363a603a2b1168$export$f929a394dd190451 = 'no-category-new';
const $d4363a603a2b1168$export$52bf3f16b7812704 = 'no-practice'; // BERRY-1358 should consolidate into NO_CATEGORY
const $d4363a603a2b1168$export$a50185c8e9fb007e = 'changes';
const $d4363a603a2b1168$export$a54a30a3c3cce634 = 'incidents';
const $d4363a603a2b1168$export$354f3a4c6ac0c903 = 'problems';
const $d4363a603a2b1168$export$335d3ac0c367f03f = 'service-requests';
const $d4363a603a2b1168$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
const $d4363a603a2b1168$export$cb41b99ca54e6bd = 'developer-escalations';
const $d4363a603a2b1168$export$f1b813cd23817ade = [
    $d4363a603a2b1168$export$a50185c8e9fb007e,
    $d4363a603a2b1168$export$a54a30a3c3cce634,
    $d4363a603a2b1168$export$354f3a4c6ac0c903,
    $d4363a603a2b1168$export$335d3ac0c367f03f,
    $d4363a603a2b1168$export$7ffd7f2c2ae96b6f,
    $d4363a603a2b1168$export$cb41b99ca54e6bd
]; // /!\ defines WorkCategoryShortForm type
const $d4363a603a2b1168$export$6c24c440228eac9c = 'Changes';
const $d4363a603a2b1168$export$5b65d27ec2d28d18 = 'Incidents';
const $d4363a603a2b1168$export$51618dc8334072b = 'Problems';
const $d4363a603a2b1168$export$a34586940ac9c374 = 'Service requests';
const $d4363a603a2b1168$export$5497b62b513b7853 = 'Post-incident reviews';
const $d4363a603a2b1168$export$3f757c5e00588ffd = 'Developer escalation';
const $d4363a603a2b1168$export$b78213db77524b5b = {
    [$d4363a603a2b1168$export$8598196f74460271]: $d4363a603a2b1168$export$6c24c440228eac9c,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: $d4363a603a2b1168$export$5b65d27ec2d28d18,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: $d4363a603a2b1168$export$51618dc8334072b,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: $d4363a603a2b1168$export$a34586940ac9c374,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: $d4363a603a2b1168$export$5497b62b513b7853,
    [$d4363a603a2b1168$export$81e62964cc725098]: $d4363a603a2b1168$export$3f757c5e00588ffd
};
const $d4363a603a2b1168$export$fbf0dfd01228e38d = {
    [$d4363a603a2b1168$export$8598196f74460271]: (0, $edAb7.default).changes,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: (0, $edAb7.default).serviceRequests,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: (0, $edAb7.default).problems,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: (0, $edAb7.default).incidents,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: (0, $edAb7.default).postIncidentReviews,
    [$d4363a603a2b1168$export$485b1216c42d8d4]: (0, $edAb7.default).allTickets,
    [$d4363a603a2b1168$export$81e62964cc725098]: (0, $edAb7.default).developerEscalation,
    [$d4363a603a2b1168$export$52bf3f16b7812704]: (0, $edAb7.default).noCategory
};
const $d4363a603a2b1168$export$91058e4cd637c2c2 = {
    [$d4363a603a2b1168$export$8598196f74460271]: (0, $edAb7.default).changes,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: (0, $edAb7.default).serviceRequests,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: (0, $edAb7.default).problems,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: (0, $edAb7.default).incidents,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: (0, $edAb7.default).postIncidentReviews,
    [$d4363a603a2b1168$export$485b1216c42d8d4]: (0, $edAb7.default).queues,
    [$d4363a603a2b1168$export$81e62964cc725098]: (0, $edAb7.default).developerEscalation,
    [$d4363a603a2b1168$export$52bf3f16b7812704]: (0, $edAb7.default).noCategory
};
const $d4363a603a2b1168$export$45ba5f49e9509c4d = {
    [$d4363a603a2b1168$export$8598196f74460271]: (0, $edAb7.default).changesLower,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: (0, $edAb7.default).serviceRequestsLower,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: (0, $edAb7.default).problemsLower,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: (0, $edAb7.default).incidentsLower,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: (0, $edAb7.default).postIncidentReviewsLower,
    [$d4363a603a2b1168$export$485b1216c42d8d4]: (0, $edAb7.default).allTicketsLower,
    [$d4363a603a2b1168$export$81e62964cc725098]: (0, $edAb7.default).developerEscalationLower,
    [$d4363a603a2b1168$export$52bf3f16b7812704]: (0, $edAb7.default).noCategoryLower
};
const $d4363a603a2b1168$export$b5fa39e9cb62e552 = {
    [$d4363a603a2b1168$export$8598196f74460271]: (0, $edAb7.default).changesLower,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: (0, $edAb7.default).serviceRequestsLower,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: (0, $edAb7.default).problemsLower,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: (0, $edAb7.default).incidentsLower,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: (0, $edAb7.default).postIncidentReviewsLower,
    [$d4363a603a2b1168$export$485b1216c42d8d4]: (0, $edAb7.default).queuesLower,
    [$d4363a603a2b1168$export$81e62964cc725098]: (0, $edAb7.default).developerEscalationLower,
    [$d4363a603a2b1168$export$52bf3f16b7812704]: (0, $edAb7.default).noCategoryLower
};

});
parcelRegister("edAb7", function(module, exports) {

$parcel$export(module.exports, "default", () => $716d4f665940f429$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $716d4f665940f429$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    allTickets: {
        "id": "work-category.common.all-tickets",
        "defaultMessage": "All tickets"
    },
    queues: {
        "id": "work-category.common.queues",
        "defaultMessage": "Queues"
    },
    serviceRequests: {
        "id": "work-category.common.service-requests",
        "defaultMessage": "Service requests"
    },
    incidents: {
        "id": "work-category.common.incidents",
        "defaultMessage": "Incidents"
    },
    changes: {
        "id": "work-category.common.changes",
        "defaultMessage": "Changes"
    },
    problems: {
        "id": "work-category.common.problems",
        "defaultMessage": "Problems"
    },
    postIncidentReviews: {
        "id": "work-category.common.post-incident-reviews",
        "defaultMessage": "Post-incident reviews"
    },
    noCategory: {
        "id": "work-category.common.no-category",
        "defaultMessage": "General"
    },
    allTicketsLower: {
        "id": "work-category.common.all-tickets-lower",
        "defaultMessage": "all tickets"
    },
    queuesLower: {
        "id": "work-category.common.queues-lower",
        "defaultMessage": "queues"
    },
    serviceRequestsLower: {
        "id": "work-category.common.service-requests-lower",
        "defaultMessage": "service requests"
    },
    incidentsLower: {
        "id": "work-category.common.incidents-lower",
        "defaultMessage": "incidents"
    },
    changesLower: {
        "id": "work-category.common.changes-lower",
        "defaultMessage": "changes"
    },
    problemsLower: {
        "id": "work-category.common.problems-lower",
        "defaultMessage": "problems"
    },
    postIncidentReviewsLower: {
        "id": "work-category.common.post-incident-reviews-lower",
        "defaultMessage": "post-incident reviews"
    },
    noCategoryLower: {
        "id": "work-category.common.no-category-lower",
        "defaultMessage": "general"
    },
    developerEscalation: {
        "id": "work-category.common.developer-escalation",
        "defaultMessage": "Developer escalations"
    },
    developerEscalationLower: {
        "id": "work-category.common.developer-escalation-lower",
        "defaultMessage": "developer escalations"
    }
});

});



parcelRegister("eHxC1", function(module, exports) {

$parcel$export(module.exports, "AsyncMajorIncChangeBoardingFlagContainer", () => $f6d9b28e2cf751c1$export$44e207fb83becfaf);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5ge6s = parcelRequire("5ge6s");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f6d9b28e2cf751c1$var$NewMajorIncChangeBoardingFlagContainer = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("doJfW")).then((module)=>module.FlagContainerMajorIncident), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/incident-management/issue-view/major-incident/src/ui/major-incidents-changeboarding-flag/new-flag/index.tsx"
});
const $f6d9b28e2cf751c1$export$44e207fb83becfaf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "major-inc-new-changeboarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ge6s.default), {
        messageId: "jsm-major-incident-changeboarding-flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6d9b28e2cf751c1$var$NewMajorIncChangeBoardingFlagContainer, null)));

});
parcelRegister("5ge6s", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $67d1cec28351d2e7$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $67d1cec28351d2e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hpAuL = parcelRequire("hpAuL");
var $8Voen = parcelRequire("8Voen");

var $e91YZ = parcelRequire("e91YZ");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $jD3pk = parcelRequire("jD3pk");
const $67d1cec28351d2e7$var$isSyntheticTenant = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';
class $67d1cec28351d2e7$export$580a2294c917898c extends (0, $8Voen.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = ''){
        const coordinationOptions = {
            enableChoreographer: (0, $1ybV0.ff)('post-office_enable_jira_choreographer')
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $67d1cec28351d2e7$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $1ybV0.ff)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) await super.stop(messageId);
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId);
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId);
    }
}
function $67d1cec28351d2e7$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const client = new $67d1cec28351d2e7$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hpAuL.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children);
}

});

parcelRegister("doJfW", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hX9cQ');
        const value = parcelRequire('9gUbM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hX9cQ").then(()=>parcelRequire('9gUbM'));
}

});


parcelRegister("lCU4q", function(module, exports) {

$parcel$export(module.exports, "AsyncUpdateAffectedServicesFlagContainer", () => $75472347d1be84eb$export$c2fa60e5a2c89e13);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $75472347d1be84eb$var$UpdateAffectedServicesFlagContainer = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("eg6K0")).then((module)=>module.FlagContainer), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/incident-management/update-affected-services-flag/src/index.tsx"
});
const $75472347d1be84eb$export$c2fa60e5a2c89e13 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "update-affected-services-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75472347d1be84eb$var$UpdateAffectedServicesFlagContainer, null));

});
parcelRegister("eg6K0", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('WDEVR')
        ]);
        const value = parcelRequire('g3Hmb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("WDEVR")
    ]).then(()=>parcelRequire('g3Hmb'));
}

});


parcelRegister("iriuZ", function(module, exports) {

$parcel$export(module.exports, "AsyncUpdateAssigneeFlagContainer", () => $e2d915bc55553eb4$export$79c6b505a252e804);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e2d915bc55553eb4$var$UpdateAssigneeFlagContainer = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("3CP46")).then((module)=>module.FlagContainer), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/incident-management/update-assignee-flag/src/index.tsx"
});
const $e2d915bc55553eb4$export$79c6b505a252e804 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "update-assignee-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e2d915bc55553eb4$var$UpdateAssigneeFlagContainer, null));

});
parcelRegister("3CP46", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('lkwW6')
        ]);
        const value = parcelRequire('40a6w');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("lkwW6")
    ]).then(()=>parcelRequire('40a6w'));
}

});


parcelRegister("alaOW", function(module, exports) {

$parcel$export(module.exports, "AsyncUpdateIncidentModalContainer", () => $b0d0fe70a13f0109$export$4a41538c3daba56b);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b0d0fe70a13f0109$var$UpdateIncidentModalContainer = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5wYMc")).then((module)=>module.ModalContainer), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/incident-management/update-incident-modal/src/ui/index.tsx"
});
const $b0d0fe70a13f0109$export$4a41538c3daba56b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "update-incident-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0d0fe70a13f0109$var$UpdateIncidentModalContainer, null));

});
parcelRegister("5wYMc", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7hFH6');
        const value = parcelRequire('ZPFyF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7hFH6").then(()=>parcelRequire('ZPFyF'));
}

});



parcelRegister("5ZJ3z", function(module, exports) {

$parcel$export(module.exports, "default", () => $49827f8a348b9edf$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FullSizeModeColumnInnerControl", () => $49827f8a348b9edf$export$644508b8a364afc9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $hTLlD = parcelRequire("hTLlD");

var $i8TjS = parcelRequire("i8TjS");

var $6tahE = parcelRequire("6tahE");

var $h97Af = parcelRequire("h97Af");

var $c9TLT = parcelRequire("c9TLT");

var $asDtI = parcelRequire("asDtI");

var $ji0W8 = parcelRequire("ji0W8");

var $hJ992 = parcelRequire("hJ992");

var $hWdjG = parcelRequire("hWdjG");

var $7GSu6 = parcelRequire("7GSu6");

var $4Fgoy = parcelRequire("4Fgoy");

var $lBBEU = parcelRequire("lBBEU");

var $cSEXi = parcelRequire("cSEXi");

var $4oInG = parcelRequire("4oInG");

var $iJjlA = parcelRequire("iJjlA");

var $6i6yG = parcelRequire("6i6yG");

var $8Bhia = parcelRequire("8Bhia");

var $4CLbb = parcelRequire("4CLbb");

var $dZlbi = parcelRequire("dZlbi");

var $cjdp5 = parcelRequire("cjdp5");

var $dGpvN = parcelRequire("dGpvN");

var $3TfAL = parcelRequire("3TfAL");

var $1vsSU = parcelRequire("1vsSU");

var $lhz9J = parcelRequire("lhz9J");

var $fCyzk = parcelRequire("fCyzk");

var $10AzB = parcelRequire("10AzB");

var $lqalZ = parcelRequire("lqalZ");

var $hSjJg = parcelRequire("hSjJg");

var $fPlP8 = parcelRequire("fPlP8");

var $5JqpU = parcelRequire("5JqpU");

var $8CSFK = parcelRequire("8CSFK");

var $jK1pm = parcelRequire("jK1pm");

var $a7Nio = parcelRequire("a7Nio");

var $h46em = parcelRequire("h46em");

var $1No38 = parcelRequire("1No38");

var $9mxRp = parcelRequire("9mxRp");

var $kkcIQ = parcelRequire("kkcIQ");
// to know the components are the same when changing layout.
// This stops component level state being reset on layout change.
const $49827f8a348b9edf$var$FOUNDATION_CONTENT = 'FOUNDATION_CONTENT';
const $49827f8a348b9edf$var$FOUNDATION_CONTEXT = 'FOUNDATION_CONTEXT';
const $49827f8a348b9edf$var$QUICK_ADD_ITEMS = 'QUICK_ADD_ITEMS';
const $49827f8a348b9edf$var$CONTEXT_ITEMS = 'CONTEXT_ITEMS';
const $49827f8a348b9edf$var$CONTEXT_ITEMS_EXT_ID = 'issue.context-items';
const $49827f8a348b9edf$var$META_CONTAINER = 'META_CONTAINER';
const $49827f8a348b9edf$var$CONTENT_ITEMS = 'CONTENT_ITEMS';
const $49827f8a348b9edf$var$FOOTNOTE_WRAPPER_KEY = 'FOOTNOTE_WRAPPER_KEY';
const $49827f8a348b9edf$var$ACTIVITY_FEED = 'ACTIVITY_FEED';
const $49827f8a348b9edf$var$ACTIVITY_FEED_EXT_ID = 'issue.activity-feed';
const $49827f8a348b9edf$var$CONFIGURE_FIELDS = 'CONFIGURE_FIELDS';
const $49827f8a348b9edf$var$SPLIT_HEADER = 'SPLIT_HEADER';
class $49827f8a348b9edf$export$cd073678518bb003 extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'IssueLayout';
    }
    static{
        this.defaultProps = {
            isCompact: false,
            shouldRenderHeader: false,
            shouldSetInitialFocus: false,
            openedGlance: null,
            glances: []
        };
    }
    constructor(props){
        super(props);
        this.avoidFocusDOM = {
            current: false
        };
        this.isInitialFocusSet = {
            current: false
        };
        this.setBreadcrumbsScrollContainer = (element)=>{
            this.setState({
                breadcrumbsScrollContainer: element
            });
        };
        this.setCompactHeaderScrollContainer = (element)=>{
            this.setState({
                compactHeaderScrollContainer: element
            });
        };
        this.setHeaderActionsScrollContainer = (element)=>{
            this.setState({
                headerActionsScrollContainer: element
            });
        };
        this.setSidePanelContainer = (element)=>{
            if (!element) return;
            this.setState((prevState)=>({
                    refs: {
                        ...prevState.refs,
                        refSidePanelContainerElement: this.props.isMobile && this.props.isCompact ? document.body : element
                    }
                }));
        };
        this.setLayoutContainer = (element)=>{
            if (!element) return;
            this.setState((prevState)=>({
                    refs: {
                        ...prevState.refs,
                        refLayoutContainer: element
                    }
                }));
        };
        this.setPanelColumn = (element)=>{
            if (!element) return;
            this.setState((prevState)=>({
                    refs: {
                        ...prevState.refs,
                        refPanelColumnElement: element
                    }
                }));
        };
        this.setVisibilityContainer = (element)=>{
            if (!element) return;
            this.setState((prevState)=>({
                    refs: {
                        ...prevState.refs,
                        refVisibilityContainer: element
                    },
                    contextWidth: element.offsetWidth
                }));
        } // When a column is focused, this function is triggered to change the focusedPanel
        ;
        this.setSidePanelAndHeaderActionsContainers = (node)=>{
            this.setSidePanelContainer(node);
            this.setHeaderActionsScrollContainer(node);
        };
        this.getPassedDownRefs = ()=>this.state.refs;
        this.shouldRenderHeaderFF = ()=>this.props.shouldRenderHeader;
        this.renderFullSizeLayoutSideContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49827f8a348b9edf$var$VisibilityContainer, {
                ref: this.setVisibilityContainer,
                show: this.props.arePanelsClosed,
                key: "sideContentWrapper",
                "data-testid": "issue.views.issue-details.issue-layout.visibility-container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                metricKey: $9mxRp.ISSUE_STATUS_BEGIN_MARK_KEY
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $10AzB.FoundationContextTemplateRenderer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                metricKey: $9mxRp.ISSUE_STATUS_END_MARK_KEY
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
                name: "context-panel"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $10AzB.ContextTemplateRenderer), {
                key: $49827f8a348b9edf$var$CONTEXT_ITEMS,
                issueViewRelayFragment: this.props.issueViewRelayFragment,
                externalId: $49827f8a348b9edf$var$CONTEXT_ITEMS_EXT_ID
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                metricKey: $9mxRp.FOOTNOTE_BEGIN_MARK_KEY
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49827f8a348b9edf$var$FootnoteWrapper, {
                "data-testid": "issue.views.issue-details.issue-layout.footnote"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3TfAL.default), {
                key: $49827f8a348b9edf$var$META_CONTAINER
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4CLbb.default), {
                key: $49827f8a348b9edf$var$CONFIGURE_FIELDS
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                metricKey: $9mxRp.FOOTNOTE_END_MARK_KEY
            }));
        this.renderCompactHeader = ()=>this.shouldRenderHeaderFF() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fPlP8.default), {
                key: $49827f8a348b9edf$var$SPLIT_HEADER,
                elementId: (0, $cSEXi.ELID_ISSUE_HEADER),
                scrollContainer: this.state.compactHeaderScrollContainer || undefined
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dZlbi.default), {
                shouldShowCloseButton: Boolean(this.props.shouldShowCloseButton),
                shouldShowProjectLevelBreadcrumb: Boolean(this.props.shouldShowProjectLevelBreadcrumb),
                shouldShowRootProjectsBreadcrumb: Boolean(this.props.shouldShowRootProjectsBreadcrumb),
                issueDeleteCallbacks: this.props.issueDeleteCallbacks,
                renderFeedback: this.props.renderFeedback,
                viewModeOptions: this.props.viewModeOptions,
                onClose: this.props.onClose
            })) : null;
        this.renderHeaderBreadcrumbs = ()=>this.shouldRenderHeaderFF() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fPlP8.default), {
                elementId: (0, $cSEXi.ELID_ISSUE_HEADER),
                scrollContainer: this.state.breadcrumbsScrollContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                metricKey: $9mxRp.HEADER_BREADCRUMBS_BEGIN_MARK_KEY
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dGpvN.HeaderBreadcrumbs), {
                shouldShowProjectLevelBreadcrumb: this.props.shouldShowProjectLevelBreadcrumb,
                shouldShowRootProjectsBreadcrumb: this.props.shouldShowRootProjectsBreadcrumb,
                isCompact: this.props.isCompact
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                metricKey: $9mxRp.HEADER_BREADCRUMBS_END_MARK_KEY
            })) : null;
        this.renderHeaderActions = ()=>this.shouldRenderHeaderFF() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                metricKey: $9mxRp.HEADER_ACTIONS_BEGIN_MARK_KEY
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fPlP8.default), {
                elementId: (0, $cSEXi.ELID_ISSUE_HEADER_ACTIONS),
                scrollContainer: this.state.headerActionsScrollContainer || undefined
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cjdp5.HeaderActions), {
                renderFeedback: this.props.renderFeedback,
                issueDeleteCallbacks: this.props.issueDeleteCallbacks,
                viewModeOptions: this.props.viewModeOptions,
                onClose: this.props.onClose,
                shouldShowCloseButton: this.props.shouldShowCloseButton
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                metricKey: $9mxRp.HEADER_ACTIONS_END_MARK_KEY
            })) : null;
        this.renderResizableFullSizeLayout = ()=>{
            const Container = $49827f8a348b9edf$var$ResizableFullSizeModeColumnScrollContainer;
            const ColumnInner = $49827f8a348b9edf$var$FullSizeModeColumnInner; // This intentionally does nothing. This is to test Switcheroo exposure event processing functionality.
            // See http://go/mep-rte for more information.
            (0, $8Bhia.isSwitcherooRealtimeExposuresTestFlagEnabled)();
            const shouldHandleBrokenSafari = !!this.props.shouldHandleBrokenSafari;
            const isModalView = this.props.viewMode === (0, $935e771f19f8ea28$export$98c0ebc22792f04);
            const showChevron = !(shouldHandleBrokenSafari && isModalView); // Safari has no independent scrolling in issue modal view, so the chevron has to be ignored
            const chevronDirection = showChevron ? this.props.focusedPanel : undefined; // If adding any new items to layout please ensure they are added to the templates and not here.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJjlA.default), {
                hasMultipleScrollingColumns: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Container, {
                "data-testid": "issue.views.issue-details.issue-layout.container-left",
                issueMaxWidth: this.props.issueMaxWidth,
                sidebarMinWidth: 0,
                isLeftmost: true,
                ref: this.setBreadcrumbsScrollContainer,
                tabIndex: 0,
                onFocus: this.setFocusedPanel('LEFT')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ColumnInner, {
                issueMaxWidth: this.props.issueMaxWidth,
                "data-testid": "issue.views.issue-details.issue-layout.left-most-column"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kkcIQ.HighlightActionsWrapper), {
                scope: "issue-layout"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GSu6.StickyHeaderTrackerContainer), {
                scope: "issue-layout"
            }, this.renderHeaderBreadcrumbs(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                metricKey: $9mxRp.ISSUE_NAME_BEGIN_MARK_KEY
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $10AzB.FoundationContentTemplateRenderer), {
                issueViewRelayFragment: this.props.issueViewRelayFragment
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                metricKey: $9mxRp.ISSUE_NAME_END_MARK_KEY
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                metricKey: $9mxRp.QUICK_ADD_ITEMS_BEGIN_MARK_KEY
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1vsSU.default), {
                key: $49827f8a348b9edf$var$QUICK_ADD_ITEMS,
                externalId: "issue.quick-add"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                metricKey: $9mxRp.QUICK_ADD_ITEMS_END_MARK_KEY
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                metricKey: $9mxRp.CONTENT_ITEMS_BEGIN_MARK_KEY
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h46em.default), {
                key: $49827f8a348b9edf$var$CONTENT_ITEMS,
                isCompactMode: false,
                issueViewRelayFragment: this.props.issueViewRelayFragment
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                metricKey: $9mxRp.CONTENT_ITEMS_END_MARK_KEY
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                metricKey: $9mxRp.ACTIVITY_FEED_BEGIN_MARK_KEY
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ji0W8.default), {
                key: $49827f8a348b9edf$var$ACTIVITY_FEED,
                externalId: $49827f8a348b9edf$var$ACTIVITY_FEED_EXT_ID
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                metricKey: $9mxRp.ACTIVITY_FEED_END_MARK_KEY
            }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSjJg.IssueLayoutSubscriber), null, ({ sidebarMinWidth: sidebarMinWidth })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $asDtI.default), {
                    initialRatio: this.props.sidebarRatio,
                    defaultRatio: (0, $9mxRp.defaultRatioRightColumn),
                    onRatioChange: this.props.onSaveSidebarRatio,
                    onRatioReset: this.props.onResetSidebarRatio,
                    extraWidth: $49827f8a348b9edf$var$extraSizeRightColumn,
                    chevronDirection: chevronDirection
                }, ({ ref: resizerRef, ...resizerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Container, {
                        ...resizerProps,
                        "data-testid": "issue.views.issue-details.issue-layout.container-right",
                        issueMaxWidth: this.props.issueMaxWidth,
                        isRightmost: true,
                        sidebarMinWidth: sidebarMinWidth,
                        scrollHidden: !this.props.arePanelsClosed,
                        isMobile: this.props.isMobile,
                        ref: (0, (/*@__PURE__*/$parcel$interopDefault($i8TjS)))(resizerRef, this.setSidePanelContainer, this.setHeaderActionsScrollContainer),
                        tabIndex: 0,
                        onFocus: this.setFocusedPanel('RIGHT')
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ColumnInner, {
                        isRightmost: true,
                        ref: this.setPanelColumn,
                        issueMaxWidth: this.props.issueMaxWidth,
                        "data-testid": "issue.views.issue-details.issue-layout.right-most-column"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kkcIQ.HighlightActionsWrapper), {
                        scope: "issue-layout-right"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GSu6.StickyHeaderTrackerContainer), {
                        scope: "issue-layout-right"
                    }, this.renderHeaderActions(), this.renderFullSizeLayoutSideContent())))))));
        };
        this.renderCompactLayoutItems = ()=>[
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                    key: $9mxRp.ISSUE_NAME_BEGIN_MARK_KEY,
                    metricKey: $9mxRp.ISSUE_NAME_BEGIN_MARK_KEY
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $10AzB.FoundationContentTemplateRenderer), {
                    key: $49827f8a348b9edf$var$FOUNDATION_CONTENT,
                    issueViewRelayFragment: this.props.issueViewRelayFragment
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                    key: $9mxRp.ISSUE_NAME_END_MARK_KEY,
                    metricKey: $9mxRp.ISSUE_NAME_END_MARK_KEY
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                    key: $9mxRp.QUICK_ADD_ITEMS_BEGIN_MARK_KEY,
                    metricKey: $9mxRp.QUICK_ADD_ITEMS_BEGIN_MARK_KEY
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1vsSU.default), {
                    key: $49827f8a348b9edf$var$QUICK_ADD_ITEMS,
                    externalId: "issue.quick-add"
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                    key: $9mxRp.QUICK_ADD_ITEMS_END_MARK_KEY,
                    metricKey: $9mxRp.QUICK_ADD_ITEMS_END_MARK_KEY
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                    key: $9mxRp.ISSUE_STATUS_BEGIN_MARK_KEY,
                    metricKey: $9mxRp.ISSUE_STATUS_BEGIN_MARK_KEY
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $10AzB.FoundationContextTemplateRenderer), {
                    key: $49827f8a348b9edf$var$FOUNDATION_CONTEXT
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                    key: $9mxRp.ISSUE_STATUS_END_MARK_KEY,
                    metricKey: $9mxRp.ISSUE_STATUS_END_MARK_KEY
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                    key: $9mxRp.CONTENT_ITEMS_BEGIN_MARK_KEY,
                    metricKey: $9mxRp.CONTENT_ITEMS_BEGIN_MARK_KEY
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h46em.default), {
                    key: $49827f8a348b9edf$var$CONTENT_ITEMS,
                    isCompactMode: true,
                    issueViewRelayFragment: this.props.issueViewRelayFragment
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                    key: $9mxRp.CONTENT_ITEMS_END_MARK_KEY,
                    metricKey: $9mxRp.CONTENT_ITEMS_END_MARK_KEY
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49827f8a348b9edf$var$CompactContextItemsContainer, {
                    key: $49827f8a348b9edf$var$CONTEXT_ITEMS
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $10AzB.ContextTemplateRenderer // @ts-expect-error - TS2322 - Type '{ externalId: string; }' is not assignable to type 'IntrinsicAttributes'.
                ), {
                    externalId: $49827f8a348b9edf$var$CONTEXT_ITEMS_EXT_ID,
                    issueViewRelayFragment: this.props.issueViewRelayFragment
                })),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                    key: $9mxRp.FOOTNOTE_BEGIN_MARK_KEY,
                    metricKey: $9mxRp.FOOTNOTE_BEGIN_MARK_KEY
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49827f8a348b9edf$var$FootnoteWrapper, {
                    "data-testid": "issue.views.issue-details.issue-layout.footnote",
                    key: $49827f8a348b9edf$var$FOOTNOTE_WRAPPER_KEY
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3TfAL.default), {
                    key: $49827f8a348b9edf$var$META_CONTAINER
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4CLbb.default), {
                    key: $49827f8a348b9edf$var$CONFIGURE_FIELDS
                })),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                    key: $9mxRp.FOOTNOTE_END_MARK_KEY,
                    metricKey: $9mxRp.FOOTNOTE_END_MARK_KEY
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                    key: $9mxRp.ACTIVITY_FEED_BEGIN_MARK_KEY,
                    metricKey: $9mxRp.ACTIVITY_FEED_BEGIN_MARK_KEY
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ji0W8.default), {
                    key: $49827f8a348b9edf$var$ACTIVITY_FEED,
                    externalId: $49827f8a348b9edf$var$ACTIVITY_FEED_EXT_ID
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
                    key: $9mxRp.ACTIVITY_FEED_END_MARK_KEY,
                    metricKey: $9mxRp.ACTIVITY_FEED_END_MARK_KEY
                })
            ];
        this.renderCompactLayout = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49827f8a348b9edf$var$IssueCompactScrollContainer, {
                scrollHidden: !this.props.arePanelsClosed,
                ref: (0, (/*@__PURE__*/$parcel$interopDefault($i8TjS)))(this.setSidePanelContainer, this.setCompactHeaderScrollContainer),
                isMobile: this.props.isMobile,
                tabIndex: 0,
                "data-testid": "issue.views.issue-details.issue-layout.compact-layout",
                onFocus: this.setFocusedPanel('LEFT')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49827f8a348b9edf$var$IssueCompactColumnInner, {
                issueMaxWidth: this.props.issueMaxWidth,
                ref: this.setPanelColumn
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kkcIQ.HighlightActionsWrapper), {
                scope: "issue-layout-compact"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GSu6.StickyHeaderTrackerContainer), {
                scope: "issue-layout-compact"
            }, this.renderCompactHeader(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49827f8a348b9edf$var$VisibilityContainer, {
                ref: this.setVisibilityContainer,
                show: this.props.arePanelsClosed,
                key: "sideContentWrapper",
                "data-testid": "issue.views.issue-details.issue-layout.visibility-container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJjlA.default), {
                isCompact: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6tahE.default), null, this.renderCompactLayoutItems()))))))) // If adding any new items to layout please ensure they are added to the templates and not here.
        ;
        this.state = {
            contextWidth: 0,
            refs: {
                refVisibilityContainer: null,
                refSidePanelContainerElement: null,
                refPanelColumnElement: null,
                refLayoutContainer: null
            },
            breadcrumbsScrollContainer: undefined,
            compactHeaderScrollContainer: undefined,
            headerActionsScrollContainer: undefined
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.didPropsChange(nextProps) || this.didStateChange(nextState);
    }
    componentDidUpdate(prevProps) {
        const isScrollingHotkeysDisabled = !!this.props.isScrollingHotkeysDisabled;
        if (isScrollingHotkeysDisabled) return;
        const hasScrollHotkeyTriggered = this.props.issueScrollTriggerCount !== prevProps.issueScrollTriggerCount; // ref container will be focused if user presses any of the arrow keys
        if (hasScrollHotkeyTriggered) {
            // Right panel is selected and panel exists
            if (this.state.headerActionsScrollContainer && this.props.focusedPanel === 'RIGHT') {
                if (!this.state.headerActionsScrollContainer.contains(document.activeElement)) this.state.headerActionsScrollContainer.focus();
            } else if (this.state.breadcrumbsScrollContainer && this.props.focusedPanel === 'LEFT') {
                if (!this.state.breadcrumbsScrollContainer.contains(document.activeElement)) this.state.breadcrumbsScrollContainer.focus();
            } else if (this.state.compactHeaderScrollContainer) {
                if (!this.state.compactHeaderScrollContainer.contains(document.activeElement)) this.state.compactHeaderScrollContainer.focus();
            }
        } /**
       * When the issue modal (or side view) is open, the focus needs to change to within the issue
       * otherwise the user will still be able to scroll background elements when issue is open.
       *
       * This block should happen at mount level (componentDidMount), however, the DOM references
       * are set through `setState` (vide setBreadcrumbsScrollContainer and setCompactHeaderScrollContainer functions).
       * For this reason the focus is triggered at the componentDidUpdate level and only happens once
       */ 
        const isInitialFocusSet = !!this.isInitialFocusSet.current;
        if (!isInitialFocusSet && this.props.shouldSetInitialFocus) {
            const loaded = this.state.breadcrumbsScrollContainer || this.state.compactHeaderScrollContainer;
            if (loaded) {
                if (this.state.breadcrumbsScrollContainer) this.state.breadcrumbsScrollContainer.focus();
                else if (this.state.compactHeaderScrollContainer) this.state.compactHeaderScrollContainer.focus({
                    preventScroll: true
                });
                this.isInitialFocusSet.current = true;
            }
        }
    }
    setFocusedPanel(panel) {
        return ()=>{
            if (!this.props.triggerFocusedPanel || this.props.focusedPanel === panel) return;
            this.props.triggerFocusedPanel(panel);
        };
    }
    didStateChange(nextState) {
        const { refs: refs, ...nonPanelPositioningState } = this.state;
        const { refs: nextStateRefs, ...nonPanelPositioningNextState } = nextState; // if only panel positioning has changed but panels are closed - no need to rerender
        if (this.props.arePanelsClosed && (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(nonPanelPositioningState, nonPanelPositioningNextState)) return false;
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(this.state, nextState);
    }
    didPropsChange(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(this.props, nextProps);
    }
    renderGlancePanels() {
        return this.props.glances.map((glance)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lBBEU.default), {
                key: `connectGlanceAnimatedPanel-${glance.appKey}__${glance.moduleKey}`,
                glance: glance,
                openedGlance: this.props.openedGlance,
                refs: this.getPassedDownRefs(),
                glanceType: glance.glanceType
            }));
    }
    renderContextPanel() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Fgoy.ContextPanel), {
            key: "context-panel",
            refs: this.getPassedDownRefs()
        });
    }
    render() {
        const issueLayout = this.props.isCompact ? this.renderCompactLayout() : this.renderResizableFullSizeLayout();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49827f8a348b9edf$var$LayoutContainer, {
            ref: this.setLayoutContainer,
            "data-testid": "issue.views.issue-details.issue-layout.issue-layout"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49827f8a348b9edf$var$ResizableFullSizeModeColumnScrollContainer, {
            isLeftmost: true,
            isRightmost: true,
            issueMaxWidth: this.props.issueMaxWidth,
            sidebarMinWidth: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49827f8a348b9edf$var$UiModificationsStyleContainer, {
            isCompact: this.props.isCompact,
            issueMaxWidth: this.props.issueMaxWidth
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a7Nio.UiModificationsEntryPoint), {
            modules: this.props.uiModificationsModules
        }))), issueLayout, this.renderGlancePanels(), this.renderContextPanel());
    }
}
const $49827f8a348b9edf$export$c18533393a930f45 = (props)=>{
    const { layoutStyle: layoutStyle, isScrollingHotkeysDisabled: isScrollingHotkeysDisabled = false, ...otherProps } = props;
    const issueKey = (0, $hJ992.useIssueKey)();
    const [contextPanel] = (0, $fCyzk.useIssueLayoutContextPanel)(issueKey);
    const [glancePanel] = (0, $fCyzk.useIssueLayoutGlance)(issueKey);
    const [issueScrollTriggerCount] = (0, $lhz9J.useIssueScrollKeyboardShortcutsStore)();
    const [focusedPanel, { triggerFocusedPanel: triggerFocusedPanel }] = (0, $lhz9J.useFocusedPanelKeyboardShortcutsStore)();
    const shouldHandleBrokenSafari = (0, $4oInG.isBrokenSafari)();
    const [viewMode] = (0, $hWdjG.useIssueContextStoreViewMode)();
    const [sidebarRatio, onSaveSidebarRatio, onResetSidebarRatio] = (0, $kkcIQ.useSidebarResize)(layoutStyle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49827f8a348b9edf$export$cd073678518bb003, {
        ...otherProps,
        arePanelsClosed: contextPanel === undefined && glancePanel === undefined,
        openedGlance: glancePanel,
        sidebarRatio: sidebarRatio,
        onSaveSidebarRatio: onSaveSidebarRatio,
        onResetSidebarRatio: onResetSidebarRatio,
        issueScrollTriggerCount: !isScrollingHotkeysDisabled ? issueScrollTriggerCount : undefined,
        focusedPanel: !isScrollingHotkeysDisabled ? focusedPanel : undefined,
        shouldHandleBrokenSafari: shouldHandleBrokenSafari,
        viewMode: viewMode,
        triggerFocusedPanel: !isScrollingHotkeysDisabled ? triggerFocusedPanel : undefined,
        isScrollingHotkeysDisabled: isScrollingHotkeysDisabled
    });
};
var $49827f8a348b9edf$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state)=>({
        glances: (0, $8CSFK.ecosystemGlancesSelector)(state),
        shouldRenderHeader: (0, $5JqpU.shouldRenderHeaderSelector)(state),
        isMobile: (0, $5JqpU.isMobileSelector)(state)
    }), {})(// @ts-expect-error - Argument of type '(props: Props & {    layoutStyle: LayoutStyle;}) => JSX.Element' is not assignable to parameter of type 'ComponentType<Matching<{ glances: ({ title: string; label: string; status: IssueGlanceStatus | undefined; icon: string | undefined; extension: IssueGlance; glanceType: "FORGE_ENTITY_TYPE"; moduleKey: string; appKey: string; } | { ...; })[]; shouldRenderHeader: boolean; isMobile: boolean; } & {}, { ...; } & ... 2 mor...'.
$49827f8a348b9edf$export$c18533393a930f45);
const $49827f8a348b9edf$var$extraSizeRightColumn = 1.5 * (0, $c9TLT.gridSize);
const $49827f8a348b9edf$var$minSizeLeftColumn = 380; // pixels
const $49827f8a348b9edf$var$scrollbarSize = 15;
const $49827f8a348b9edf$var$fullSizeModeColumnInnerSelectorName = 'jira.issue-view.issue-details.full-size-mode-column';
const $49827f8a348b9edf$var$FULL_SIZE_MODE_COLUMN_INNER_COMPONENT_SELECTOR = `[data-component-selector="${$49827f8a348b9edf$var$fullSizeModeColumnInnerSelectorName}"]`; /**
                                                                                                                              * @deprecated `FullSizeModeColumnInnerControl` is consumed by other styled-components (e.g. src/entry/issue/rapid-board/backlog/styles)
                                                                                                                              * Please use `FullSizeModeColumnInner` (CompiledCSS component) when migrating the consumer to CompiledCSS
                                                                                                                              * TODO: Remove `FullSizeModeColumnInnerControl` once its consumers are migrated to CompiledCSS
                                                                                                                              */ 
const $49827f8a348b9edf$export$644508b8a364afc9 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-14mu1cb-0"
})`padding:0 ${"var(--ds-space-400, 32px)"} ${(0, $6i6yG.issueViewBottomPadding)}px;outline:none;${({ issueMaxWidth: issueMaxWidth })=>issueMaxWidth !== undefined ? `padding-top: ${0, $6i6yG.fullPageIssueWrapperMarginTop}px;` : ''} ${({ isLeftmost: isLeftmost, isRightmost: isRightmost })=>{
    if (isLeftmost) return `
                padding-left: ${0, $1No38.issueViewSidePadding}px;
                padding-right: ${3 * (0, $c9TLT.gridSize)}px;
                `;
    if (isRightmost) return `
                padding-left: ${0, $c9TLT.gridSize}px;
                padding-right: ${(0, $1No38.issueViewSidePadding) - 1.5 * (0, $c9TLT.gridSize)}px;
                `;
    return '';
}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49827f8a348b9edf$var$FullSizeModeColumnInnerComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { issueMaxWidth: issueMaxWidth, isRightmost: isRightmost, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f3utpp _n3tdxy5q _19bv1ejb _12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.issueMaxWidth !== undefined ? "_ca0qv47k" : "_ca0qze3t",
            __cmplp.isRightmost && "_19bvze3t _u5f31ejb",
            __cmplp.className
        ])
    });
});
const $49827f8a348b9edf$var$FullSizeModeColumnInner = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49827f8a348b9edf$var$FullSizeModeColumnInnerComponent, {
        "data-component-selector": $49827f8a348b9edf$var$fullSizeModeColumnInnerSelectorName,
        ref: ref,
        ...props
    })); // This component should not be rendered in Compact mode (with 1 column in issue view)
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49827f8a348b9edf$var$ResizableFullSizeModeColumnScrollContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { scrollHidden: scrollHidden, isMobile: isMobile, isLeftmost: isLeftmost, isRightmost: isRightmost, issueMaxWidth: issueMaxWidth, sidebarMinWidth: sidebarMinWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_5qq0z5": (0, $9t7rW.default)(__cmplp.isMobile ? 'visible' : 'hidden'),
            "--_bpn462": (0, $9t7rW.default)(__cmplp.isMobile ? 'visible' : 'auto'),
            "--_xhypko": (0, $9t7rW.default)(__cmplp.sidebarMinWidth, "px"),
            "--_8gjczv": (0, $9t7rW.default)(__cmplp.issueMaxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.scrollHidden ? "_1reo15vq _18m915vq _z8ie1e08" : "_1reo1e7b _18m92qvy",
            __cmplp.isLeftmost && "_16jlkb7n _1o9zidpf _i0dlidpf _1ul9xilx",
            __cmplp.isRightmost && __cmplp.issueMaxWidth === undefined && "_1ul9yc1a",
            __cmplp.isLeftmost && __cmplp.issueMaxWidth !== undefined && "_19bv18bx",
            __cmplp.isRightmost && __cmplp.issueMaxWidth !== undefined && "_u5f318bx _1ul91ll1 _v5647jka",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49827f8a348b9edf$var$CompactContextItemsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49827f8a348b9edf$var$LayoutContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49827f8a348b9edf$var$FootnoteWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _2lx2vrvc _4cvr1y6m _1bah1yb4 _ae4v1fhb _18u0x0bf _otyr1ejb _19bv19bv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49827f8a348b9edf$var$VisibilityContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.show ? "_3um0ewfl" : "_3um015vq",
            __cmplp.className
        ])
    });
}); /*
     * Apply overflow auto, unless it's mobile.
     * The overflow needs to be visible on mobile when the FF is on, otherwise the header won't be sticky.
     * On desktop, if scrollHidden is true, the overflow is overwritten to hidden.
     */ 
const $49827f8a348b9edf$var$IssueCompactScrollContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMobile: isMobile, scrollHidden: scrollHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _12ji1r31 _1qu2glyw _12y31o36",
            !__cmplp.isMobile && "_1reo1wug _18m91wug",
            __cmplp.scrollHidden && "_1reo15vq _18m915vq _1s7z1e08",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49827f8a348b9edf$var$IssueCompactColumnInner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4dlfz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49827f8a348b9edf$var$UiModificationsStyleContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompact: isCompact, issueMaxWidth: issueMaxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bvzwfg",
            __cmplp.isCompact ? "_u5f3zwfg" : "_u5f3gktf",
            __cmplp.issueMaxWidth === undefined && __cmplp.isCompact && "_19bvv47k _u5f3v47k",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i8TjS", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $j9vt0 = parcelRequire("j9vt0");
/**
 * Creates a function that invokes `iteratees` with the arguments it receives
 * and returns their results.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to invoke.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.over([Math.max, Math.min]);
 *
 * func(1, 2, 3, 4);
 * // => [4, 1]
 */ var $d353e2ae6ecb6ad9$var$over = $j9vt0($kJvGp);
module.exports = $d353e2ae6ecb6ad9$var$over;

});
parcelRegister("j9vt0", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $kJvGp = parcelRequire("kJvGp");

var $7qARj = parcelRequire("7qARj");

var $9eFtX = parcelRequire("9eFtX");

var $74vSq = parcelRequire("74vSq");

var $224h2 = parcelRequire("224h2");
/**
 * Creates a function like `_.over`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over iteratees.
 * @returns {Function} Returns the new over function.
 */ function $df174438844ec606$var$createOver(arrayFunc) {
    return $224h2(function(iteratees) {
        iteratees = $kJvGp(iteratees, $74vSq($7qARj));
        return $9eFtX(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee) {
                return $5VdlS(iteratee, thisArg, args);
            });
        });
    });
}
module.exports = $df174438844ec606$var$createOver;

});


parcelRegister("asDtI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3208d9e0423c9333$export$2e2bcd8739ae039);

var $1P2SN = parcelRequire("1P2SN");
var $3208d9e0423c9333$export$2e2bcd8739ae039 = (0, $1P2SN.default);

});
parcelRegister("1P2SN", function(module, exports) {

$parcel$export(module.exports, "default", () => $047a2e2e579bd17f$export$2e2bcd8739ae039);

var $eorKQ = parcelRequire("eorKQ");
var $047a2e2e579bd17f$export$2e2bcd8739ae039 = (0, $eorKQ.default);

});
parcelRegister("eorKQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6cc01bb809ca137$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ajVqv = parcelRequire("ajVqv");

var $fhwpI = parcelRequire("fhwpI");
var $c6cc01bb809ca137$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { children: children, ...resizerProps } = props;
    const { minRatio: minRatio = 0, maxRatio: maxRatio = 1, minWidth: minWidth, maxWidth: maxWidth, initialRatio: initialRatio, defaultRatio: defaultRatio, extraWidth: extraWidth, position: position = 'left', resizeHandleAsOverlay: resizeHandleAsOverlay } = resizerProps;
    // Ensure the ratio which is initially set to the flex-basis style is bounded between the min/max ratios
    // The css properties handles max-width and min-width
    const ratio = (0, $eUqFw.useRef)((0, $ajVqv.clampValue)({
        value: initialRatio ?? defaultRatio,
        minValue: minRatio,
        maxValue: maxRatio
    }));
    const container = (0, $eUqFw.useRef)(null);
    const renderHandle = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fhwpI.default), {
            ...resizerProps,
            ...initialRatio !== undefined ? {
                initialRatio: ratio.current,
                defaultRatio: (0, $ajVqv.clampValue)({
                    value: defaultRatio,
                    minValue: minRatio,
                    maxValue: maxRatio
                })
            } : {
                defaultRatio: ratio.current
            },
            childrenContainerRef: container
        });
    const renderResizer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, position === 'left' && renderHandle(), typeof children === 'function' ? children({
            ref: (r)=>{
                container.current = r;
            },
            style: (0, $ajVqv.getChildrenStyle)(ratio.current, minWidth, maxWidth, extraWidth)
        }) : children, position === 'right' && renderHandle());
    return resizeHandleAsOverlay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6cc01bb809ca137$export$c7990a6594835e51, {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: (0, $ajVqv.getChildrenStyle)(ratio.current, minWidth, maxWidth, extraWidth),
        ref: container,
        "data-testid": "flex-resizer.ui.resize-wrapper"
    }, renderResizer()) : renderResizer();
});
const $c6cc01bb809ca137$export$c7990a6594835e51 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _lcxv1wug _q0u0kb7n _2e98kb7n _12rof1ug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ajVqv", function(module, exports) {

$parcel$export(module.exports, "useAnimationFrameThrottle", () => $0b2c74f3e919d323$export$9d3ed311e5db6a6f);
$parcel$export(module.exports, "useDoubleClick", () => $0b2c74f3e919d323$export$b1d0a5c81935127f);
$parcel$export(module.exports, "clampValue", () => $0b2c74f3e919d323$export$31ee16100cde6ce2);
$parcel$export(module.exports, "calculateNewRatio", () => $0b2c74f3e919d323$export$58e1996e98bfba9e);
$parcel$export(module.exports, "getChildrenStyle", () => $0b2c74f3e919d323$export$f2a5e228fabed40b);

var $eUqFw = parcelRequire("eUqFw");

var $c9TLT = parcelRequire("c9TLT");
const $0b2c74f3e919d323$export$45f504201feb6ea6 = 3 * (0, $c9TLT.gridSize) + 2;
const $0b2c74f3e919d323$export$9d3ed311e5db6a6f = (callback)=>{
    const token = (0, $eUqFw.useRef)(null);
    const lastArgs = (0, $eUqFw.useRef)(null);
    const hasTriggered = (0, $eUqFw.useRef)(false);
    const handleFrame = (0, $eUqFw.useCallback)(()=>{
        lastArgs.current = null;
        hasTriggered.current = false;
    }, []);
    const throttle = (0, $eUqFw.useCallback)((...args)=>{
        lastArgs.current = args;
        if (hasTriggered.current) return;
        callback(...args);
        token.current = window.requestAnimationFrame(handleFrame);
        hasTriggered.current = true;
    }, [
        handleFrame,
        callback
    ]);
    const cancel = (0, $eUqFw.useCallback)(()=>{
        if (token.current) window.cancelAnimationFrame(token.current);
        if (!hasTriggered.current && lastArgs.current !== null) callback(...lastArgs.current);
        token.current = null;
        lastArgs.current = null;
        hasTriggered.current = false;
    }, [
        callback
    ]);
    (0, $eUqFw.useEffect)(()=>()=>cancel(), [
        callback,
        cancel
    ]);
    return [
        throttle,
        cancel
    ];
};
const $0b2c74f3e919d323$export$b1d0a5c81935127f = (callback)=>{
    const lastClickTime = (0, $eUqFw.useRef)(0);
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        const now = Date.now();
        if (now - lastClickTime.current < 500) {
            lastClickTime.current = 0;
            callback();
            return true;
        }
        lastClickTime.current = now;
        return false;
    }, [
        callback
    ]);
    return handleClick;
};
const $0b2c74f3e919d323$export$29ae71364f84a225 = (element)=>{
    const style = getComputedStyle(element);
    const paddingX = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    return paddingX;
};
const $0b2c74f3e919d323$export$31ee16100cde6ce2 = ({ value: value, minValue: minValue, maxValue: maxValue })=>Math.min(Math.max(value, minValue), maxValue);
const $0b2c74f3e919d323$export$58e1996e98bfba9e = ({ parentWidth: parentWidth, currentWidth: currentWidth, deltaX: deltaX, minWidth: minWidth, minRatio: minRatio, maxWidth: maxWidth, maxRatio: maxRatio, baseWidth: baseWidth, position: position })=>{
    const targetWidth = Math.min(Math.max(currentWidth - baseWidth + (position === 'left' ? deltaX : deltaX * -1), minWidth), maxWidth);
    return $0b2c74f3e919d323$export$31ee16100cde6ce2({
        value: targetWidth / parentWidth,
        minValue: minRatio,
        maxValue: maxRatio
    });
};
const $0b2c74f3e919d323$export$f2a5e228fabed40b = (ratio, minWidth, maxWidth, extraWidth = 0)=>({
        boxSizing: 'border-box',
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: extraWidth > 0 ? `calc(${ratio * 100}% + ${extraWidth}px)` : `${ratio * 100}%`,
        minWidth: minWidth !== undefined ? minWidth : null,
        maxWidth: maxWidth !== undefined ? maxWidth : null
    });

});

parcelRegister("fhwpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc7a0d344fd54dfc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $kPoyq = parcelRequire("kPoyq");

var $h5oNr = parcelRequire("h5oNr");
var $bc7a0d344fd54dfc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.issue.view.resizer",
        packageName: "async.issue.view.resizer",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h5oNr.ResizeHandle), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kPoyq.default), props)));

});
parcelRegister("kPoyq", function(module, exports) {

$parcel$export(module.exports, "default", () => $92a8b24235e4bca6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4GOUU = parcelRequire("4GOUU");

var $dtaN9 = parcelRequire("dtaN9");

var $hzcvF = parcelRequire("hzcvF");

var $ajVqv = parcelRequire("ajVqv");

var $h5oNr = parcelRequire("h5oNr");
const $92a8b24235e4bca6$var$Resizer = ({ childrenContainerRef: childrenContainerRef, initialRatio: initialRatio, defaultRatio: defaultRatio, minWidth: minWidth, minRatio: minRatio = 0, maxWidth: maxWidth, maxRatio: maxRatio = 1, extraWidth: extraWidth = 0, position: position = 'left', resizeHandleAsOverlay: resizeHandleAsOverlay, resizeHandleZIndex: resizeHandleZIndex, onRatioChange: onRatioChange, onRatioReset: onRatioReset, onResizeStart: onResizeStart, chevronDirection: chevronDirection })=>{
    const startX = (0, $eUqFw.useRef)(0);
    const startWidth = (0, $eUqFw.useRef)(0);
    const parentWidth = (0, $eUqFw.useRef)(0);
    const prevChevronDirection = (0, $hzcvF.usePreviousWithInitial)(chevronDirection);
    const nextRatio = (0, $eUqFw.useRef)(initialRatio ?? defaultRatio);
    const styleElement = (0, $eUqFw.useRef)(null);
    const setFlexBasisProp = (0, $eUqFw.useCallback)((ratio)=>{
        if (childrenContainerRef.current) childrenContainerRef.current.style.setProperty('flex-basis', extraWidth > 0 ? `calc(${ratio * 100}% + ${extraWidth}px)` : `${ratio * 100}%`);
    }, [
        childrenContainerRef,
        extraWidth
    ]);
    const resetDetector = (0, $ajVqv.useDoubleClick)((0, $eUqFw.useCallback)(()=>{
        const targetRatio = (0, $ajVqv.clampValue)({
            value: defaultRatio * parentWidth.current,
            minValue: Math.max(minWidth ?? 0, minRatio * parentWidth.current),
            maxValue: Math.min(maxWidth ?? Infinity, maxRatio * parentWidth.current)
        }) / parentWidth.current;
        nextRatio.current = targetRatio;
        setFlexBasisProp(targetRatio);
        onRatioReset?.(targetRatio);
    }, [
        defaultRatio,
        minWidth,
        minRatio,
        maxWidth,
        maxRatio,
        setFlexBasisProp,
        onRatioReset
    ]));
    const [onPointerMoveThrottled, cancelPointerMove] = (0, $ajVqv.useAnimationFrameThrottle)((0, $eUqFw.useCallback)((e)=>{
        const r = (0, $ajVqv.calculateNewRatio)({
            parentWidth: parentWidth.current,
            currentWidth: startWidth.current,
            deltaX: startX.current - e.pageX,
            minWidth: minWidth ?? 0,
            minRatio: minRatio,
            maxWidth: maxWidth ?? Infinity,
            maxRatio: maxRatio,
            baseWidth: extraWidth,
            position: position
        });
        nextRatio.current = r;
        setFlexBasisProp(r);
    }, [
        extraWidth,
        maxRatio,
        maxWidth,
        minRatio,
        minWidth,
        position,
        setFlexBasisProp
    ]));
    const onPointerMove = (0, $eUqFw.useCallback)((e)=>{
        e.preventDefault();
        onPointerMoveThrottled(e);
    }, [
        onPointerMoveThrottled
    ]);
    const onPointerUp = (0, $eUqFw.useCallback)(()=>{
        const r = nextRatio.current;
        const resetTriggered = resetDetector();
        if (!resetTriggered) onRatioChange?.(r);
        window.removeEventListener('pointermove', onPointerMove, {
            capture: true
        });
        window.removeEventListener('pointerup', onPointerUp, {
            capture: true
        });
        const stylesheet = styleElement.current?.sheet;
        if (stylesheet) {
            stylesheet.deleteRule(1);
            stylesheet.deleteRule(0);
        }
        cancelPointerMove();
    }, [
        cancelPointerMove,
        onPointerMove,
        onRatioChange,
        resetDetector
    ]);
    const onPointerDown = (0, $eUqFw.useCallback)((e)=>{
        window.addEventListener('pointermove', onPointerMove, {
            capture: true
        });
        window.addEventListener('pointerup', onPointerUp, {
            capture: true
        });
        const stylesheet = styleElement.current?.sheet;
        if (stylesheet) {
            // There is a chromium bug which forces all scrollbars to be visible when 'pointer-events: none' is added.
            // Chromium bug: https://bugs.chromium.org/p/chromium/issues/detail?id=1280013&q=pointer-events%20scrollbar&can=2
            // The previously implemented workarounds for this issue didn't solve all use cases, i.e., horizontal scrollbars,
            // thus, 'user-select: none' is used to prevent text-highlighting but allows hover events, unlike 'pointer-events'.
            stylesheet.insertRule('body { user-select: none; }', 0);
            // Set the dragging cursor (higher than disabled pointer events)
            stylesheet.insertRule('#jira { cursor: ew-resize; }', 1);
        }
        const currentContainer = childrenContainerRef.current;
        const parentContainer = currentContainer?.parentElement;
        if (!currentContainer || !parentContainer) return;
        startWidth.current = currentContainer.getBoundingClientRect().width;
        parentWidth.current = parentContainer.getBoundingClientRect().width ?? 0;
        onResizeStart?.();
        startX.current = e.pageX;
        e.preventDefault();
    }, [
        onPointerMove,
        onPointerUp,
        childrenContainerRef,
        onResizeStart
    ]);
    const ResizeBar = (0, $eUqFw.useCallback)(()=>{
        const directionDidChange = chevronDirection !== prevChevronDirection;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h5oNr.ResizeHandle), {
            tabIndex: 0,
            role: "separator",
            "aria-orientation": "vertical",
            "data-testid": "flex-resizer.ui.handle.resizer",
            onPointerDown: onPointerDown,
            position: position,
            resizeHandleZIndex: resizeHandleZIndex,
            resizeHandleAsOverlay: resizeHandleAsOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h5oNr.ResizeBorder), {
            triggerAnimation: directionDidChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h5oNr.ResizeIcon), {
            triggerAnimation: directionDidChange,
            "data-testid": "flex-resizer.ui.handle.resize-icon"
        }, chevronDirection === 'LEFT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GOUU))), {
            size: "medium",
            label: "",
            testId: "flex-resizer.ui.handle.chevron-left"
        }), chevronDirection === 'RIGHT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            size: "medium",
            label: "",
            testId: "flex-resizer.ui.handle.chevron-right"
        }))));
    }, [
        chevronDirection,
        prevChevronDirection,
        onPointerDown,
        position,
        resizeHandleZIndex,
        resizeHandleAsOverlay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ResizeBar, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        ref: styleElement
    }));
};
var $92a8b24235e4bca6$export$2e2bcd8739ae039 = $92a8b24235e4bca6$var$Resizer;

});
parcelRegister("4GOUU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36a294b3fe9eadec$var$_react = $36a294b3fe9eadec$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $36a294b3fe9eadec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $36a294b3fe9eadec$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $36a294b3fe9eadec$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M13.706 9.698a.988.988 0 000-1.407 1.01 1.01 0 00-1.419 0l-2.965 2.94a1.09 1.09 0 000 1.548l2.955 2.93a1.01 1.01 0 001.42 0 .988.988 0 000-1.407l-2.318-2.297 2.327-2.307z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$36a294b3fe9eadec$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $36a294b3fe9eadec$var$_default = $36a294b3fe9eadec$var$ChevronLeftIcon;
module.exports.default = $36a294b3fe9eadec$var$_default;

});

parcelRegister("h5oNr", function(module, exports) {

$parcel$export(module.exports, "ResizeHandle", () => $b281306696ed6227$export$33f2411a0ad35be7);
$parcel$export(module.exports, "ResizeIcon", () => $b281306696ed6227$export$8a1e762806b47a07);
$parcel$export(module.exports, "ResizeBorder", () => $b281306696ed6227$export$a6c16750034505be);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $b281306696ed6227$var$resizeHandleSelectorName = 'jira-issue-view-common-component-resize-handle';
const $b281306696ed6227$export$3cd44ff7e3089142 = `[data-component-selector="${$b281306696ed6227$var$resizeHandleSelectorName}"]`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b281306696ed6227$var$ResizeHandleComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { resizeHandleZIndex: resizeHandleZIndex, position: position, resizeHandleAsOverlay: resizeHandleAsOverlay, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ravlqm": (0, $9t7rW.default)(__cmplp.resizeHandleZIndex),
            "--_1o4cubd": (0, $9t7rW.default)(__cmplp.position === 'left' ? 'translate3d(-50%, 0, 0)' : 'translate3d(50%, 0, 0)')
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _1bsb1ejb _80omuf7j _1wpz1fhb _1e0c1txw _1bah1h6o _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.resizeHandleZIndex && "_1pby7mzf",
            __cmplp.position === 'left' ? "_1ltvidpf" : "_1xi2idpf",
            __cmplp.resizeHandleAsOverlay && "_154iidpf _kqswstnw _4t3i1osq _t9ec1jw3",
            __cmplp.className
        ])
    });
});
const $b281306696ed6227$export$33f2411a0ad35be7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b281306696ed6227$var$ResizeHandleComponent, {
        "data-component-selector": $b281306696ed6227$var$resizeHandleSelectorName,
        ...props
    });
const $b281306696ed6227$var$appearAnimationBorder = null;
const $b281306696ed6227$var$appearAnimationIcon = null;
const $b281306696ed6227$export$8a1e762806b47a07 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { triggerAnimation: triggerAnimation, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154ixy5q _4t3i1tcg _1bsb1tcg _1ltvxmi2 _tzy4idpf _16qs174l _2rko1ssb _j7hq1s2f _1pgl1ytf _11q7vuon",
            __cmplp.triggerAnimation ? "_5sag9cwz" : "_5sagru3m",
            __cmplp.className
        ])
    });
});
const $b281306696ed6227$export$a6c16750034505be = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { triggerAnimation: triggerAnimation, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbyh40 _1wpz1fhb _j7hq1f9b _1pgl1ytf _v56419xe _11q7194a _tzy4idpf _kqswh2mm _17cdkb7n _vhr0kb7n _1sankb7n",
            __cmplp.triggerAnimation ? "_5sag9cwz" : "_5sagru3m",
            __cmplp.className
        ])
    });
});

});






parcelRegister("ji0W8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c68bd9d94afcd288$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $jFDB6 = parcelRequire("jFDB6");

var $5G3JL = parcelRequire("5G3JL");

var $lBMPF = parcelRequire("lBMPF");

var $jK1pm = parcelRequire("jK1pm");

var $b1Ehe = parcelRequire("b1Ehe");

var $2te5U = parcelRequire("2te5U");
const $c68bd9d94afcd288$var$ActivityFeed = ({ containerWidth: containerWidth })=>{
    const { shouldBeCompact: shouldBeCompact, setMeasuredRef: setMeasuredRef, forceUpdate: forceUpdate } = (0, $jFDB6.useShouldBeCompact)(containerWidth, 15);
    const setActivityItemsRef = (0, $eUqFw.useMemo)(()=>setMeasuredRef('activity-items'), [
        setMeasuredRef
    ]);
    const setSmartRequestSummaryTriggerRef = (0, $eUqFw.useMemo)(()=>setMeasuredRef('issue-smart-summary-trigger'), [
        setMeasuredRef
    ]);
    const setActivitySortRef = (0, $eUqFw.useMemo)(()=>setMeasuredRef('activity-sort'), [
        setMeasuredRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "issue-activity-feed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2te5U.default), {
        shouldDisplayDropdown: shouldBeCompact,
        setActivityItemsRef: setActivityItemsRef,
        setActivitySortRef: setActivitySortRef,
        setSmartRequestSummaryTriggerRef: (0, $b1Ehe.isJsmSmartRequestSummaryEnabled)() ? setSmartRequestSummaryTriggerRef : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onForceUpdateCompactState: (0, $b1Ehe.isJsmSmartRequestSummaryEnabled)() ? forceUpdate : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }));
};
var $c68bd9d94afcd288$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $lBMPF.default))($c68bd9d94afcd288$var$ActivityFeed);

});
parcelRegister("jFDB6", function(module, exports) {

$parcel$export(module.exports, "useShouldBeCompact", () => $d8c10679b430a11a$export$c5552e81046f28bb);

var $eUqFw = parcelRequire("eUqFw");

var $ePZVP = parcelRequire("ePZVP");
const $d8c10679b430a11a$export$c5552e81046f28bb = (containerWidth, offset = 0)=>{
    const [shouldBeCompact, setShouldBeCompact] = (0, $eUqFw.useState)(false);
    const totalExpandedWidthRef = (0, $eUqFw.useRef)(0);
    const expandedWidthsByElement = (0, $eUqFw.useRef)({});
    const elementsToMeasureRef = (0, $eUqFw.useRef)({});
    const updateAndGetTotalWidthOld = (0, $eUqFw.useCallback)(()=>{
        const totalExpandedWidth = Object.values(elementsToMeasureRef.current).reduce((totalWidth, element)=>totalWidth + (element?.deref()?.clientWidth ?? 0), 0);
        if (totalExpandedWidthRef.current < totalExpandedWidth) totalExpandedWidthRef.current = totalExpandedWidth;
        return totalExpandedWidthRef.current;
    }, []);
    const updateAndGetTotalWidthNew = (0, $eUqFw.useCallback)(()=>{
        const widthsByElement = Object.entries(elementsToMeasureRef.current).reduce((acc, [key, element])=>{
            if (element !== null) {
                if (element?.deref() != null) acc[key] = element?.deref()?.clientWidth ?? 0;
            }
            return acc;
        }, {});
        let maxExpandedWidthOfCurrentElements = 0;
        for (const [key, measuredWidth] of Object.entries(widthsByElement)){
            if (typeof expandedWidthsByElement.current[key] !== 'number' || measuredWidth > expandedWidthsByElement.current[key]) expandedWidthsByElement.current[key] = measuredWidth;
            maxExpandedWidthOfCurrentElements += expandedWidthsByElement.current[key];
        }
        return maxExpandedWidthOfCurrentElements;
    }, []);
    const computeShouldBeCompact = (0, $eUqFw.useCallback)(()=>{
        const totalMeasuredWidth = (0, $ePZVP.isJsmSmartRequestSummaryEnabled)() ? updateAndGetTotalWidthNew() : updateAndGetTotalWidthOld();
        if (typeof containerWidth === 'number' && totalMeasuredWidth !== 0) setShouldBeCompact(containerWidth <= totalMeasuredWidth + offset);
    }, [
        containerWidth,
        offset,
        updateAndGetTotalWidthNew,
        updateAndGetTotalWidthOld
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (containerWidth !== undefined) computeShouldBeCompact();
    }, [
        containerWidth,
        computeShouldBeCompact
    ]);
    const setMeasuredRef = (0, $eUqFw.useCallback)((key)=>(element)=>{
            elementsToMeasureRef.current[key] = element != null ? new WeakRef(element) : null;
        }, []);
    return {
        shouldBeCompact: shouldBeCompact,
        setMeasuredRef: setMeasuredRef,
        forceUpdate: computeShouldBeCompact
    };
};

});
parcelRegister("ePZVP", function(module, exports) {

$parcel$export(module.exports, "isJsmSmartRequestSummaryEnabled", () => $670a1505b8deeb94$export$7e4aef4ae0b914e2);

var $1ybV0 = parcelRequire("1ybV0");
const $670a1505b8deeb94$export$7e4aef4ae0b914e2 = ()=>(0, $1ybV0.ff)('enable-jsm-smart-request-summary_kva1r', false);

});


parcelRegister("lBMPF", function(module, exports) {

$parcel$export(module.exports, "default", () => $145116e343b09eaf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $a576Y = parcelRequire("a576Y");

var $5qTKr = parcelRequire("5qTKr");
const $145116e343b09eaf$export$5279a2ee094e2a65 = (setWidth)=>{
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!ref.current) return;
        const { width: width } = ref.current.getBoundingClientRect();
        setWidth(width);
    }, [
        setWidth
    ]);
    return ref;
};
function $145116e343b09eaf$export$2e2bcd8739ae039(WrappedComponent) {
    var props;
    return (props)=>{
        const [width, setWidth] = (0, $eUqFw.useState)(undefined);
        const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(setWidth, 50);
        const ref = $145116e343b09eaf$export$5279a2ee094e2a65(setWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($145116e343b09eaf$var$RelativeWrapper, {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qTKr.WidthObserver), {
            setWidth: throttledSetWidth
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            containerWidth: width
        }));
    };
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $145116e343b09eaf$var$RelativeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("b1Ehe", function(module, exports) {

$parcel$export(module.exports, "isJsmSmartRequestSummaryEnabled", () => $e09446e1460c1779$export$7e4aef4ae0b914e2);

var $1ybV0 = parcelRequire("1ybV0");
const $e09446e1460c1779$export$7e4aef4ae0b914e2 = ()=>(0, $1ybV0.ff)('enable-jsm-smart-request-summary_kva1r', false); // </itsm-grimlock>

});

parcelRegister("2te5U", function(module, exports) {

$parcel$export(module.exports, "default", () => $5355326710f9ae0c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8sN8t = parcelRequire("8sN8t");

var $7ZZxN = parcelRequire("7ZZxN");

var $gUUjF = parcelRequire("gUUjF");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $7C4za = parcelRequire("7C4za");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $5mT4a = parcelRequire("5mT4a");

var $hc60A = parcelRequire("hc60A");


var $5G3JL = parcelRequire("5G3JL");

var $lBMPF = parcelRequire("lBMPF");

var $iAc02 = parcelRequire("iAc02");

var $8ogeO = parcelRequire("8ogeO");

var $bFoCp = parcelRequire("bFoCp");

var $lqalZ = parcelRequire("lqalZ");

var $hjgGs = parcelRequire("hjgGs");

var $277q1 = parcelRequire("277q1");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $dUqHv = parcelRequire("dUqHv");

var $8CSFK = parcelRequire("8CSFK");

var $8QKSg = parcelRequire("8QKSg");

var $gzLYm = parcelRequire("gzLYm");

var $dmojD = parcelRequire("dmojD");

var $6xFHS = parcelRequire("6xFHS");

var $2KzVh = parcelRequire("2KzVh");

var $9s86T = parcelRequire("9s86T");

var $6VKiL = parcelRequire("6VKiL");

var $4zUUC = parcelRequire("4zUUC");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $guDlK = parcelRequire("guDlK");

var $f26dB = parcelRequire("f26dB");

var $5iuyH = parcelRequire("5iuyH");

var $b1Ehe = parcelRequire("b1Ehe");

var $cboe8 = parcelRequire("cboe8");

var $gnlws = parcelRequire("gnlws");

var $3BQHD = parcelRequire("3BQHD");
var $kvGqG = parcelRequire("kvGqG");
var $fZIQE = parcelRequire("fZIQE");
var $1ccqQ = parcelRequire("1ccqQ");

var $ewnuK = parcelRequire("ewnuK");

var $8XHab = parcelRequire("8XHab");
const $5355326710f9ae0c$var$SINGLE_COLUMN_MAX_WIDTH = 410;
const $5355326710f9ae0c$var$ERROR_LOCATION = 'issue.issue-actions.activity-feed';
const $5355326710f9ae0c$var$SORTABLE_ACTIVITY_TYPES = [
    (0, $hc60A.ALL_ACTIVITY),
    (0, $hc60A.COMMENTS),
    (0, $hc60A.HISTORY),
    (0, $hc60A.WORKLOG),
    (0, $hc60A.APPROVALS)
];
const $5355326710f9ae0c$var$ufoNameSuffixForSwitchingToActivityItem = (item)=>{
    // Intentionally avoiding default case to get exhaustiveness checking. Each of the entries here has a hand-made
    // experience created for it in the performance portal. Therefore, you may want to modify the performance portal
    // if you modify this function.
    //
    // eslint-disable-next-line default-case
    switch(item.type){
        case 0, $hc60A.ALL_ACTIVITY:
            return 'all';
        case 0, $hc60A.APPROVALS:
            return 'approvals';
        case 0, $hc60A.COMMENTS:
            return 'comments';
        case 0, $hc60A.HISTORY:
            return 'history';
        case 0, $hc60A.WORKLOG:
            return 'worklog';
        case 0, $hc60A.CONNECT:
            return 'connect-app';
        case 0, $hc60A.FORGE:
            return 'forge-app';
    }
};
const $5355326710f9ae0c$var$ufoNameForSwitchingToActivityItem = (item)=>`issue-view-activity-button-${$5355326710f9ae0c$var$ufoNameSuffixForSwitchingToActivityItem(item)}`;
const $5355326710f9ae0c$export$330b99dfc58b8723 = ({ shouldDisplayDropdown: shouldDisplayDropdown = false, canAddComments: canAddComments = false, selectedItem: selectedItem = null, ecosystemModules: ecosystemModules = [], commentIds: commentIds, isPreview: isPreview, projectKey: projectKey, onInitialSelectedActivityItem: onInitialSelectedActivityItem, onSwitchSelectedActivityItem: onSwitchSelectedActivityItem, onSwitchSelectedActivitySortOrder: onSwitchSelectedActivitySortOrder, selectedSortOrder: selectedSortOrder, setActivityItemsRef: setActivityItemsRef, setActivitySortRef: setActivitySortRef, setSmartRequestSummaryTriggerRef: setSmartRequestSummaryTriggerRef, onForceUpdateCompactState: onForceUpdateCompactState, shouldShowWorklog: shouldShowWorklog, containerWidth: containerWidth })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const isPremiumUserSeat = (0, $f26dB.useIsPremiumUserSeat)();
    const isSimplifiedProject = (0, $guDlK.useIsSimplifiedProject)(projectKey);
    const hasApprovals = projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT) || projectType === (0, $7ZZxN.CORE_PROJECT) && isPremiumUserSeat && isSimplifiedProject;
    const getAllActivity = (0, $eUqFw.useCallback)(()=>[
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                key: (0, $hc60A.ALL_ACTIVITY),
                type: (0, $hc60A.ALL_ACTIVITY),
                name: formatMessage((0, $cboe8.messages).allActivity)
            }
        ], [
        formatMessage
    ]);
    const getApprovalsActivity = (0, $eUqFw.useCallback)(()=>hasApprovals ? [
            {
                key: (0, $hc60A.APPROVALS),
                type: (0, $hc60A.APPROVALS),
                name: formatMessage((0, $cboe8.messages).approvals)
            }
        ] : [], [
        formatMessage,
        hasApprovals
    ]);
    const getCommentActivity = (0, $eUqFw.useCallback)(()=>commentIds.length || canAddComments ? [
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                key: (0, $hc60A.COMMENTS),
                type: (0, $hc60A.COMMENTS),
                name: formatMessage((0, $cboe8.messages).comments)
            }
        ] : [], [
        canAddComments,
        commentIds.length,
        formatMessage
    ]);
    const getHistoryActivity = (0, $eUqFw.useCallback)(()=>[
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                key: (0, $hc60A.HISTORY),
                type: (0, $hc60A.HISTORY),
                name: formatMessage((0, $cboe8.messages).history)
            }
        ], [
        formatMessage
    ]);
    const getWorklogActivity = (0, $eUqFw.useCallback)(()=>shouldShowWorklog ? [
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                key: (0, $hc60A.WORKLOG),
                type: (0, $hc60A.WORKLOG),
                name: formatMessage((0, $cboe8.messages).worklog)
            }
        ] : [], [
        formatMessage,
        shouldShowWorklog
    ]);
    const getEcosystemActivity = (0, $eUqFw.useCallback)(()=>ecosystemModules.map((item)=>{
            switch(item.type){
                case 0, $hc60A.FORGE:
                    return {
                        key: (0, $7C4za.toForgeKey)(item.appKey, item.moduleKey),
                        ...item
                    };
                case 0, $hc60A.CONNECT:
                    return {
                        key: `${item.moduleKey}${item.appKey}`,
                        ...item
                    };
                default:
                    (0, $gUUjF.default).safeErrorWithoutCustomerData($5355326710f9ae0c$var$ERROR_LOCATION, 'Tried to show ecosystem activity with other type than connect or forge');
                    return null;
            }
        }).filter(Boolean), [
        ecosystemModules
    ]);
    const getSelectedItem = (0, $eUqFw.useCallback)((activityItems = [])=>{
        if (selectedItem) return selectedItem;
        const permalink = (0, $9s86T.getPermalinkTypeAndId)();
        if (permalink) {
            const { permalinkType: permalinkType } = permalink;
            const activityItem = activityItems.find((item)=>item.type === permalinkType);
            if (activityItem) {
                onInitialSelectedActivityItem(activityItem);
                return activityItem;
            }
        }
        const initialSelectedItem = activityItems[1];
        return initialSelectedItem;
    }, [
        onInitialSelectedActivityItem,
        selectedItem
    ]);
    const getActivityItems = (0, $eUqFw.useCallback)(()=>[
            ...getAllActivity(),
            ...getCommentActivity(),
            ...getHistoryActivity(),
            ...getWorklogActivity(),
            ...getEcosystemActivity(),
            ...getApprovalsActivity()
        ], [
        getAllActivity,
        getApprovalsActivity,
        getCommentActivity,
        getEcosystemActivity,
        getHistoryActivity,
        getWorklogActivity
    ]);
    const getAnalyticsData = (0, $eUqFw.useCallback)((item)=>{
        switch(item.type){
            case 0, $hc60A.FORGE:
                return {
                    extensionId: item.extension.id
                };
            case 0, $hc60A.CONNECT:
                return (0, $8ogeO.activityPanelAnalyticsData)(item.appKey, item.moduleKey);
            default:
                return {
                    activityItemType: item.type
                };
        }
    }, []);
    const ufoInteractionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    const ufoTraceSelectionOfActivityItem = (0, $eUqFw.useCallback)((item, timeStamp)=>{
        const ufoName = $5355326710f9ae0c$var$ufoNameForSwitchingToActivityItem(item);
        ufoInteractionContext && ufoInteractionContext.tracePress(ufoName, timeStamp);
    }, [
        ufoInteractionContext
    ]);
    const selectActivityItem = (0, $eUqFw.useCallback)((item, analyticsEvent, subject, timeStamp)=>{
        const analyticsData = [
            subject,
            getAnalyticsData(item)
        ];
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, ...analyticsData);
        ufoTraceSelectionOfActivityItem(item, timeStamp);
        // This needs to be persisted in redux otherwise when upper components remount, the selected item will be lost
        // This can happen when IssueLayout switches into compact mode.
        onSwitchSelectedActivityItem(item);
    }, [
        getAnalyticsData,
        onSwitchSelectedActivityItem,
        ufoTraceSelectionOfActivityItem
    ]);
    const selectSortOrder = (0, $eUqFw.useCallback)((order, analyticsEvent, subject)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, subject, {
            selectedSortOrder: order,
            selectedActivityFeed: selectedItem?.key
        });
        onSwitchSelectedActivitySortOrder(order);
    }, [
        onSwitchSelectedActivitySortOrder,
        selectedItem?.key
    ]);
    const [getActivityItemsInState] = (0, $eUqFw.useState)(()=>getActivityItems);
    const [getSelectedItemInState] = (0, $eUqFw.useState)(()=>getSelectedItem);
    const [onInitialSelectedActivityItemInState] = (0, $eUqFw.useState)(()=>onInitialSelectedActivityItem);
    // componentDidMount
    (0, $eUqFw.useEffect)(()=>{
        const activityItems = getActivityItemsInState();
        const chosenItem = getSelectedItemInState(activityItems);
        onInitialSelectedActivityItemInState(chosenItem);
    }, [
        getActivityItemsInState,
        getSelectedItemInState,
        onInitialSelectedActivityItemInState
    ]);
    const renderChangeboardingMount = (0, $eUqFw.useCallback)(()=>{
        const { permalinkType: permalinkType } = (0, $9s86T.getPermalinkTypeAndId)() || {};
        const hasCommentOrWorklogPermalink = permalinkType === (0, $hc60A.COMMENTS) || permalinkType === (0, $hc60A.WORKLOG);
        if (!hasCommentOrWorklogPermalink) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: (analyticsEvent)=>{
                (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, permalinkType === (0, $hc60A.COMMENTS) ? 'permalinkWithChangeboardingModalComments mounted' : 'permalinkWithChangeboardingModalWorklog mounted');
            }
        });
    }, []);
    // When mounting and unmounting the button, we want to force update the activity items' "compact" state
    // This will collapse/uncollapse the activity items dropdown as necessary
    const smartRequestSummaryTriggerRef = (0, $b1Ehe.isJsmSmartRequestSummaryEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
    (0, $2KzVh.default)(setSmartRequestSummaryTriggerRef, onForceUpdateCompactState) : undefined;
    const isPremium = (0, $1ybV0.ff)('issue.details.jira-smart-summary-platform_0jta9') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4zUUC.useIsPremium)() : false;
    const renderSmartRequestSummarizeAction = (0, $eUqFw.useCallback)((chosenItem)=>{
        const shouldExcludeSmartSummary = (0, $1ybV0.ff)('issue.details.jira-smart-summary-platform_0jta9') ? projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT) || !isPremium : projectType !== (0, $7ZZxN.SERVICE_DESK_PROJECT);
        if (chosenItem.type !== (0, $hc60A.COMMENTS) || shouldExcludeSmartSummary) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
            id: "issue.issue-view.activity.smart-summary",
            packageName: "issueActivityFeed"
        }, projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewnuK.JsmSmartRequestSummaryTrigger), {
            ref: smartRequestSummaryTriggerRef,
            isCompact: !!containerWidth && containerWidth <= $5355326710f9ae0c$var$SINGLE_COLUMN_MAX_WIDTH,
            totalComments: commentIds.length
        }), projectType !== (0, $7ZZxN.SERVICE_DESK_PROJECT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8XHab.IssueSmartRequestSummaryTrigger), {
            ref: smartRequestSummaryTriggerRef,
            isCompact: !!containerWidth && containerWidth <= $5355326710f9ae0c$var$SINGLE_COLUMN_MAX_WIDTH,
            totalComments: commentIds.length
        }));
    }, [
        projectType,
        isPremium,
        smartRequestSummaryTriggerRef,
        containerWidth,
        commentIds.length
    ]);
    const renderActivitySortDropdownOld = (0, $eUqFw.useCallback)((activityItems, chosenItem)=>{
        if (!selectedSortOrder) return null;
        const WrapperComponent = activityItems.length > 1 ? (0, $gnlws.ActivitySortingWrapper) : (0, $gnlws.ActivityItemHeading);
        // We want to disable the ability to allow users to sort ecosystem activity feeds
        // @ts-expect-error - TS2345 - Argument of type '"AllActivity" | "Approvals" | "Comments" | "CONNECT_ENTITY_TYPE" | "FORGE_ENTITY_TYPE" | "History" | "Worklog"' is not assignable to parameter of type '"AllActivity" | "Approvals" | "Comments" | "History" | "Worklog"'.
        const isDisabled = !$5355326710f9ae0c$var$SORTABLE_ACTIVITY_TYPES.includes(chosenItem.type);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperComponent, {
            ref: setActivitySortRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ccqQ.ActivitySortingToggle), {
            selectedSortOrder: selectedSortOrder,
            onSelectSortOrder: selectSortOrder,
            isDisabled: isDisabled
        }));
    }, [
        selectSortOrder,
        selectedSortOrder,
        setActivitySortRef
    ]);
    const renderActivitySortDropdownNew = (0, $eUqFw.useCallback)((chosenItem)=>{
        // We want to disable the ability to allow users to sort ecosystem activity feeds
        // @ts-expect-error - TS2345 - Argument of type '"AllActivity" | "Approvals" | "Comments" | "CONNECT_ENTITY_TYPE" | "FORGE_ENTITY_TYPE" | "History" | "Worklog"' is not assignable to parameter of type '"AllActivity" | "Approvals" | "Comments" | "History" | "Worklog"'.
        const isDisabled = !$5355326710f9ae0c$var$SORTABLE_ACTIVITY_TYPES.includes(chosenItem.type);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: setActivitySortRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ccqQ.ActivitySortingToggle), {
            selectedSortOrder: selectedSortOrder,
            onSelectSortOrder: selectSortOrder,
            isDisabled: isDisabled
        }));
    }, [
        selectSortOrder,
        selectedSortOrder,
        setActivitySortRef
    ]);
    const renderActvityHeadingRow = (activityItems, chosenItem)=>{
        if (activityItems.length <= 1) return (0, $b1Ehe.isJsmSmartRequestSummaryEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gnlws.ActivityItemHeading), null, renderActivitySortDropdownNew(chosenItem)) : renderActivitySortDropdownOld(activityItems, chosenItem);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gnlws.ActivityItemHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gnlws.ActivityItems), {
            ref: setActivityItemsRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.HeadingWithDraft), null, formatMessage((0, $cboe8.messages).filterBy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
            name: (0, $ab3fc2ac1a2f2638$export$f9baa44349b5d6b8)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingIcons), {
            leftAlign: true,
            ...!shouldDisplayDropdown ? {
                role: 'menubar'
            } : {}
        }, shouldDisplayDropdown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kvGqG.ActivityFeedDropdown), {
            items: activityItems,
            selectedItem: chosenItem,
            onSelectActivityItem: selectActivityItem
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3BQHD.ActivityFeedButtons), {
            items: activityItems,
            selectedItem: chosenItem,
            onSelectActivityItem: selectActivityItem
        })))), (0, $b1Ehe.isJsmSmartRequestSummaryEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gnlws.ActivityHeadingEndWrapper), null, renderSmartRequestSummarizeAction(chosenItem), renderActivitySortDropdownNew(chosenItem)) : renderActivitySortDropdownOld(activityItems, chosenItem));
    };
    const SmartRequestSummaryEntryPointContextProvider = (0, $1ybV0.ff)('issue.details.jira-smart-summary-platform_0jta9') && projectType !== (0, $7ZZxN.SERVICE_DESK_PROJECT) ? (0, $hjgGs.IssueSmartRequestSummaryEntryPointContextProvider) : (0, $hjgGs.JsmSmartRequestSummaryEntryPointContextProvider);
    const { permalinkType: permalinkType } = (0, $9s86T.getPermalinkTypeAndId)() || {};
    if ((permalinkType === (0, $6VKiL.WORKLOG) || !commentIds.length) && isPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bFoCp.default), null);
    const activityItems = getActivityItems();
    const chosenItem = getSelectedItem(activityItems);
    if (!activityItems.length || !chosenItem) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "activityFeed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SmartRequestSummaryEntryPointContextProvider, null, renderChangeboardingMount(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeading), {
        leftAlign: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingTitle), {
        "data-testid": "issue-activity-feed.heading"
    }, activityItems.length > 1 ? formatMessage((0, $cboe8.messages).activity) : chosenItem.name)), renderActvityHeadingRow(activityItems, chosenItem), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xFHS.AsyncActivityFeedFilter), {
        selectedActivityFeed: chosenItem.key
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fZIQE.default), {
        selectedItem: chosenItem,
        selectedSortOrder: selectedSortOrder
    })));
};
$5355326710f9ae0c$export$330b99dfc58b8723.displayName = 'FeedDisplay';
const $5355326710f9ae0c$var$FeedDisplayWithEcosystemModules = (props)=>{
    const { forgeModules: forgeModules, ...rest } = props;
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ value: activityPanels, isReady: isReady }] = (0, $5mT4a.default)(issueKey);
    const [ecosystemModules, setEcosystemModules] = (0, $eUqFw.useState)(forgeModules || []);
    (0, $eUqFw.useEffect)(()=>{
        setEcosystemModules([
            ...forgeModules || [],
            ...activityPanels
        ].sort((0, $8CSFK.activitiesComparator)));
    }, [
        isReady,
        activityPanels,
        forgeModules
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5355326710f9ae0c$export$330b99dfc58b8723, {
        ...rest,
        ecosystemModules: ecosystemModules
    });
};
const $5355326710f9ae0c$var$FeedDisplayOld = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        isPreview: (0, $jZDJX.isPreviewSelector)(state),
        isServiceDesk: (0, $5JqpU.isServiceDeskSelector)(state),
        shouldShowWorklog: (0, $dUqHv.isNativeJiraTimeTrackingEnabledSelector)(state),
        canAddComments: (0, $dmojD.canAddCommentsSelector)(state),
        commentIds: (0, $dmojD.visibleCommentIdsSelector)(state),
        ecosystemModules: (0, $8CSFK.ecosystemActivityPanelsSelector)(state),
        selectedItem: (0, $gzLYm.getSelectedActivityItem)(state),
        selectedSortOrder: (0, $gzLYm.getSelectedActivitySortOrder)(state),
        projectKey: (0, $5JqpU.projectKeySelector)(state)
    }), (dispatch)=>({
        onSwitchSelectedActivityItem: (activityItem)=>{
            dispatch((0, $277q1.setSelectedActivityItem)(activityItem));
        },
        onInitialSelectedActivityItem: (activityItem)=>{
            dispatch((0, $277q1.setInitialSelectedActivityItem)(activityItem));
        },
        onSwitchSelectedActivitySortOrder: (sortOrder)=>{
            dispatch((0, $277q1.setSelectedActivitySortOrder)(sortOrder));
            dispatch((0, $277q1.updateActivitySortOrderRequest)(sortOrder));
        }
    })))((0, $lBMPF.default)($5355326710f9ae0c$export$330b99dfc58b8723));
const $5355326710f9ae0c$var$FeedDisplayNew = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        isPreview: (0, $jZDJX.isPreviewSelector)(state),
        isServiceDesk: (0, $5JqpU.isServiceDeskSelector)(state),
        shouldShowWorklog: (0, $dUqHv.isNativeJiraTimeTrackingEnabledSelector)(state),
        canAddComments: (0, $dmojD.canAddCommentsSelector)(state),
        commentIds: (0, $dmojD.visibleCommentIdsSelector)(state),
        forgeModules: (0, $8QKSg.forgeIssueActivitySelector)(state),
        selectedItem: (0, $gzLYm.getSelectedActivityItem)(state),
        selectedSortOrder: (0, $gzLYm.getSelectedActivitySortOrder)(state),
        projectKey: (0, $5JqpU.projectKeySelector)(state)
    }), (dispatch)=>({
        onSwitchSelectedActivityItem: (activityItem)=>{
            dispatch((0, $277q1.setSelectedActivityItem)(activityItem));
        },
        onInitialSelectedActivityItem: (activityItem)=>{
            dispatch((0, $277q1.setInitialSelectedActivityItem)(activityItem));
        },
        onSwitchSelectedActivitySortOrder: (sortOrder)=>{
            dispatch((0, $277q1.setSelectedActivitySortOrder)(sortOrder));
            dispatch((0, $277q1.updateActivitySortOrderRequest)(sortOrder));
        }
    })))((0, $lBMPF.default)($5355326710f9ae0c$var$FeedDisplayWithEcosystemModules));
var $5355326710f9ae0c$export$2e2bcd8739ae039 = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('issue-view-remove-activitypanels-from-critical-fetch_43ozj'), $5355326710f9ae0c$var$FeedDisplayNew, $5355326710f9ae0c$var$FeedDisplayOld);

});
parcelRegister("5mT4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8feb3f48e2082d0$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $9sKt4 = parcelRequire("9sKt4");

var $6D0iK = parcelRequire("6D0iK");
const $e8feb3f48e2082d0$var$EMPTY_ACTIVITY_PANELS = [];
const $e8feb3f48e2082d0$export$b5c8e820cf7fe2af = (issueKey)=>{
    const [issueState] = (0, $6D0iK.default)(issueKey);
    const { value: issueData = (0, $9sKt4.emptyIssueData), isReady: isReady = false } = issueState ?? {};
    const { activityPanels: value = $e8feb3f48e2082d0$var$EMPTY_ACTIVITY_PANELS } = issueData;
    return [
        {
            value: value,
            isReady: isReady
        }
    ];
};
const $e8feb3f48e2082d0$var$defaultValue = [
    {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: [],
        isReady: true
    }
];
var $e8feb3f48e2082d0$export$2e2bcd8739ae039 = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('issue-view-remove-activitypanels-from-critical-fetch_43ozj'), $e8feb3f48e2082d0$export$b5c8e820cf7fe2af, ()=>$e8feb3f48e2082d0$var$defaultValue);

});

parcelRegister("iAc02", function(module, exports) {

$parcel$export(module.exports, "DraftIndicator", () => $461562c807a7d93d$export$788d5fa295f9c6a2);
$parcel$export(module.exports, "SectionHeading", () => $461562c807a7d93d$export$72d7ca7a5d1d4807);
$parcel$export(module.exports, "HeadingWithDraft", () => $461562c807a7d93d$export$ac24d0d326bfdb89);
$parcel$export(module.exports, "SectionHeadingTitle", () => $461562c807a7d93d$export$2728a0e216f34727);
$parcel$export(module.exports, "SectionHeadingIcons", () => $461562c807a7d93d$export$26f092b874489d4b);
/* section-heading-view.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $64ypR = parcelRequire("64ypR");
const $461562c807a7d93d$export$788d5fa295f9c6a2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($461562c807a7d93d$var$DraftIndicatorComponent, props));
const $461562c807a7d93d$export$72d7ca7a5d1d4807 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $64ypR.FieldHeadingIconsVisibility), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1n261q9c",
            __cmplp.leftAlign ? "_1bah4jg8" : "_1bah1yb4",
            __cmplp.className
        ])
    });
});
const $461562c807a7d93d$export$ac24d0d326bfdb89 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $64ypR.FieldHeadingIconsVisibility), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1y6m _4cvr1h6o _p12f1osq",
            __cmplp.className
        ])
    });
});
const $461562c807a7d93d$export$2728a0e216f34727 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1x4e _k48pni7l _1dyz44hb _vwz41tcg _syaz1fxt _1i4q1hna _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $461562c807a7d93d$export$26f092b874489d4b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { leftAlign: leftAlign, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.leftAlign && "_18u0ftgi",
            __cmplp.className
        ])
    });
});
const $461562c807a7d93d$var$DraftIndicatorComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _19pkidpf _1o9zidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8ogeO", function(module, exports) {

$parcel$export(module.exports, "glanceAnalyticsData", () => $28d9d0292fd23c28$export$dcb41e1ba18f8135);
$parcel$export(module.exports, "contentPanelAnalyticsOnLoad", () => $28d9d0292fd23c28$export$2c9e7465b3bfeef0);
$parcel$export(module.exports, "contentPanelAnalyticsData", () => $28d9d0292fd23c28$export$67ed0d6c9a9fef51);
$parcel$export(module.exports, "activityPanelAnalyticsData", () => $28d9d0292fd23c28$export$466937901217762c);
const $28d9d0292fd23c28$export$dcb41e1ba18f8135 = (appKey, moduleKey, status)=>{
    const statusType = (status && status.type) ?? '';
    return {
        appKey: appKey,
        moduleKey: moduleKey,
        statusType: statusType
    };
};
const $28d9d0292fd23c28$export$2c9e7465b3bfeef0 = (contentPanels, panelsOnPage)=>{
    let totalOnPage = 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = contentPanels.reduce((acc, contentPanel)=>{
        if (!acc[contentPanel.appKey]) acc[contentPanel.appKey] = {
            total: 0,
            totalOnPage: 0
        };
        const current = acc[contentPanel.appKey];
        current.total += 1;
        const extId = `${contentPanel.appKey}_${contentPanel.moduleKey}`;
        if (panelsOnPage.includes(extId)) {
            current.totalOnPage += 1;
            totalOnPage += 1;
        }
        return acc;
    }, {});
    const safeData = JSON.stringify(data);
    return {
        totalOnPage: totalOnPage,
        total: contentPanels.length,
        data: safeData
    };
};
const $28d9d0292fd23c28$export$67ed0d6c9a9fef51 = (appKey, moduleKey)=>({
        appKey: appKey,
        moduleKey: moduleKey
    });
const $28d9d0292fd23c28$export$f30ba10d53ce49f9 = (appKey, moduleKey, action)=>({
        appKey: appKey,
        moduleKey: moduleKey,
        event: action
    });
const $28d9d0292fd23c28$export$466937901217762c = (appKey, moduleKey)=>({
        appKey: appKey,
        moduleKey: moduleKey
    });
const $28d9d0292fd23c28$var$appKeyModKeyNameTransformer = (items)=>items.map((item)=>({
            appKey: item.appKey,
            moduleKey: item.moduleKey,
            name: item.name
        }));
const $28d9d0292fd23c28$var$appKeyModKeyNameTypeTransformer = (items)=>items.map((item)=>({
            appKey: item.appKey,
            moduleKey: item.moduleKey,
            name: item.name,
            type: item.type
        }));
const $28d9d0292fd23c28$var$contentPanelTransformer = (items)=>items.map((item)=>({
            appKey: item.appKey,
            moduleKey: item.moduleKey,
            name: item.name,
            type: item.type,
            showByDefault: item.showByDefault
        }));
const $28d9d0292fd23c28$var$operationTransformer = (operations)=>operations.map((operation)=>({
            name: operation.name
        }));
const $28d9d0292fd23c28$var$legacyAddonFilter = (addon)=>addon.type === 'WEB_PANEL';
const $28d9d0292fd23c28$var$newAddonFilter = (addon)=>addon.type === 'ISSUE_MODULE';
const $28d9d0292fd23c28$export$7bedeeb69b5cb668 = (glances = [], contentPanels = [], activityPanels = [], operations = [], ecosystemCustomFieldsCount = 0)=>{
    const data = {
        glances: $28d9d0292fd23c28$var$appKeyModKeyNameTypeTransformer(glances),
        contentPanels: $28d9d0292fd23c28$var$contentPanelTransformer(contentPanels),
        activityPanels: $28d9d0292fd23c28$var$appKeyModKeyNameTransformer(activityPanels),
        operations: $28d9d0292fd23c28$var$operationTransformer(operations)
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const totalModules = Object.keys(data).reduce((sum, key)=>data[key] && data[key].length ? sum + data[key].length : sum, 0);
    const dataString = JSON.stringify(data);
    return {
        totalGlances: glances.filter($28d9d0292fd23c28$var$newAddonFilter).length,
        totalLegacyGlances: glances.filter($28d9d0292fd23c28$var$legacyAddonFilter).length,
        totalContentPanels: contentPanels.filter($28d9d0292fd23c28$var$newAddonFilter).length,
        totalLegacyContentPanels: contentPanels.filter($28d9d0292fd23c28$var$legacyAddonFilter).length,
        totalActivityPanels: activityPanels.length,
        totalOperations: operations.length,
        totalCustomIssueFields: ecosystemCustomFieldsCount,
        totalModules: totalModules,
        data: dataString
    };
};

});

parcelRegister("bFoCp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7237f6b1c50999cd$export$2e2bcd8739ae039);
/* activity-feed-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hJ992 = parcelRequire("hJ992");

var $fkeu9 = parcelRequire("fkeu9");

var $2xN2s = parcelRequire("2xN2s");

var $iMstM = parcelRequire("iMstM");

var $3o7jb = parcelRequire("3o7jb");

var $c75Wq = parcelRequire("c75Wq");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7237f6b1c50999cd$var$FormContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $7237f6b1c50999cd$var$Border = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $iMstM.CleanDiv), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbftgi",
            __cmplp.className
        ])
    });
});
var $7237f6b1c50999cd$export$2e2bcd8739ae039 = ()=>{
    const isModal = (0, $hJ992.useIsModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3o7jb.default), {
        "data-testid": "issue.skeleton.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMstM.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xN2s.default), {
        isModal: isModal,
        paddingTop: 0,
        paddingBottom: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xN2s.default), {
        isModal: isModal,
        paddingTop: 32,
        paddingBottom: 12
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c75Wq.default), {
        isModal: isModal,
        fontSize: 14,
        lineHeight: 16,
        intrusion: 300
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7237f6b1c50999cd$var$FormContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fkeu9.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7237f6b1c50999cd$var$Border, {
        isModal: isModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c75Wq.default), {
        isModal: isModal,
        fontSize: 40,
        lineHeight: 40,
        intrusion: 0
    }))));
};

});
parcelRegister("fkeu9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dbcd396b3a650bb$export$2e2bcd8739ae039);
/* avatar-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3dbcd396b3a650bb$var$SC1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ylp _4t3i1ylp _1itk1x4n",
            __cmplp.className
        ])
    });
});
var $3dbcd396b3a650bb$export$2e2bcd8739ae039 = $3dbcd396b3a650bb$var$SC1;

});

parcelRegister("2xN2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $4724dbf507794f29$export$2e2bcd8739ae039);
/* container-mask-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4724dbf507794f29$var$SC1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, paddingTop: paddingTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1cgzp5c": (0, $9t7rW.default)(__cmplp.paddingTop, "px"),
            "--_1ntldin": (0, $9t7rW.default)(__cmplp.paddingBottom, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsb1osq",
            __cmplp.isModal ? "_x3doostm" : "_x3do3rsf",
            __cmplp.isModal ? "_n7zlfiih" : "_n7zlh1it",
            __cmplp.className
        ])
    });
});
var $4724dbf507794f29$export$2e2bcd8739ae039 = $4724dbf507794f29$var$SC1;

});

parcelRegister("iMstM", function(module, exports) {

$parcel$export(module.exports, "CleanDiv", () => $ac9f216c767cd799$export$e2099645cdcaf24c);
$parcel$export(module.exports, "default", () => $ac9f216c767cd799$export$2e2bcd8739ae039);
/* skeleton-background-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $ac9f216c767cd799$var$shimmer = null;
const $ac9f216c767cd799$export$e2099645cdcaf24c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1itkglyw",
            __cmplp.isModal ? "_bfhk1bhr" : "_bfhkvuon",
            __cmplp.className
        ])
    });
});
const $ac9f216c767cd799$var$SC1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhk1yrq _1itkygre _12vemgnk _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.className
        ])
    });
});
var $ac9f216c767cd799$export$2e2bcd8739ae039 = $ac9f216c767cd799$var$SC1;

});

parcelRegister("3o7jb", function(module, exports) {

$parcel$export(module.exports, "default", () => $93316a0a0a2c434d$export$2e2bcd8739ae039);
/* skeleton-container-view.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $93316a0a0a2c434d$var$SC1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1e0c1txw _kqswh2mm",
            __cmplp.className
        ])
    });
});
var $93316a0a0a2c434d$export$2e2bcd8739ae039 = $93316a0a0a2c434d$var$SC1;

});

parcelRegister("c75Wq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7c0f40bfd895f01$export$2e2bcd8739ae039);
/* text-line-mask-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d7c0f40bfd895f01$var$SC1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, intrusion: intrusion, lineHeight: lineHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1sswcfi": (0, $9t7rW.default)(`${__cmplp.fontSize}px`),
            "--_172l934": (0, $9t7rW.default)(__cmplp.intrusion, "px"),
            "--_1o6j0d": (0, $9t7rW.default)((__cmplp.lineHeight - __cmplp.fontSize) / 2, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i1l57",
            __cmplp.isModal ? "_1s7z12nn" : "_1s7z1cpt",
            __cmplp.isModal ? "_x3do12pv" : "_x3do16rq",
            __cmplp.isModal ? "_n7zl12pv" : "_n7zl16rq",
            __cmplp.className
        ])
    });
});
var $d7c0f40bfd895f01$export$2e2bcd8739ae039 = $d7c0f40bfd895f01$var$SC1;

});


parcelRegister("hjgGs", function(module, exports) {

$parcel$export(module.exports, "JsmSmartRequestSummaryEntryPointContext", () => $e28323c4e05eeef7$export$3267382ec06b34b1);
$parcel$export(module.exports, "JsmSmartRequestSummaryEntryPointContextProvider", () => $e28323c4e05eeef7$export$5d727a5cbf687f6e);
$parcel$export(module.exports, "IssueSmartRequestSummaryEntryPointContext", () => $e28323c4e05eeef7$export$c975d3564f9814f4);
$parcel$export(module.exports, "IssueSmartRequestSummaryEntryPointContextProvider", () => $e28323c4e05eeef7$export$b0c164cfddb76d2e);

var $eUqFw = parcelRequire("eUqFw");

var $gRxol = parcelRequire("gRxol");
var $6j4bv = parcelRequire("6j4bv");

var $9zysr = parcelRequire("9zysr");
var $bAQOb = parcelRequire("bAQOb");

var $aGDeG = parcelRequire("aGDeG");

var $lSyum = parcelRequire("lSyum");

var $4765X = parcelRequire("4765X");
const $e28323c4e05eeef7$export$3267382ec06b34b1 = (0, $gRxol.createUseEntryPointContext)();
// rename to JsmSmartRequestSummaryEntryPointContextProvider when cleaning up enable-jsm-smart-request-summary_kva1r
// and export this
const $e28323c4e05eeef7$var$EnabledJsmSmartRequestSummaryEntryPointContextProvider = ({ children: children })=>{
    const entryPoint = (0, $6j4bv.useEntryPoint)((0, $lSyum.jsmSmartRequestSummaryEntryPoint), {});
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e28323c4e05eeef7$export$3267382ec06b34b1.Provider, {
        value: entryPoint
    }, children);
};
// update displayName when cleaning up enable-jsm-smart-request-summary_kva1r
$e28323c4e05eeef7$var$EnabledJsmSmartRequestSummaryEntryPointContextProvider.displayName = 'EnabledJsmSmartRequestSummaryEntryPointContextProvider';
const $e28323c4e05eeef7$export$5d727a5cbf687f6e = (0, $9zysr.componentWithCondition)((0, $4765X.isJsmSmartRequestSummaryEnabled), $e28323c4e05eeef7$var$EnabledJsmSmartRequestSummaryEntryPointContextProvider, (0, $eUqFw.Fragment));
$e28323c4e05eeef7$export$5d727a5cbf687f6e.displayName = 'JsmSmartRequestSummaryEntryPointContextProvider';
const $e28323c4e05eeef7$export$c975d3564f9814f4 = (0, $gRxol.createUseEntryPointContext)();
const $e28323c4e05eeef7$var$EMPTY_ENTRY_POINT_PARAMS = {};
const $e28323c4e05eeef7$var$EnabledIssueSmartRequestSummaryEntryPointContextProvider = ({ children: children })=>{
    const entryPoint = (0, $6j4bv.useEntryPoint)((0, $aGDeG.issueSmartRequestSummaryEntryPoint), $e28323c4e05eeef7$var$EMPTY_ENTRY_POINT_PARAMS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e28323c4e05eeef7$export$c975d3564f9814f4.Provider, {
        value: entryPoint
    }, children);
};
$e28323c4e05eeef7$var$EnabledIssueSmartRequestSummaryEntryPointContextProvider.displayName = 'EnabledIssueSmartRequestSummaryEntryPointContextProvider';
const $e28323c4e05eeef7$export$b0c164cfddb76d2e = (0, $bAQOb.componentWithFF)('issue.details.jira-smart-summary-platform_0jta9', $e28323c4e05eeef7$var$EnabledIssueSmartRequestSummaryEntryPointContextProvider, (0, $eUqFw.Fragment));
$e28323c4e05eeef7$export$b0c164cfddb76d2e.displayName = 'IssueSmartRequestSummaryEntryPointContextProvider';

});
parcelRegister("aGDeG", function(module, exports) {

$parcel$export(module.exports, "issueSmartRequestSummaryEntryPoint", () => $62dd1660ed3df752$export$f724ccb2064f12c4);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $62dd1660ed3df752$export$f724ccb2064f12c4 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("k2Fk6")).then((module)=>module.SmartRequestSummary), {
        moduleId: "42f5619c"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("k2Fk6", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('fhDcY')
        ]);
        const value = parcelRequire('c0seW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("fhDcY")
    ]).then(()=>parcelRequire('c0seW'));
}

});


parcelRegister("lSyum", function(module, exports) {

$parcel$export(module.exports, "jsmSmartRequestSummaryEntryPoint", () => $f226acb193f21492$export$be47748d40a245ac);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $f226acb193f21492$export$be47748d40a245ac = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("4NMYo")).then((module)=>module.SmartRequestSummary), {
        moduleId: "f44929fc"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4NMYo", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('h5Rvz');
        const value = parcelRequire('71aSv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("h5Rvz").then(()=>parcelRequire('71aSv'));
}

});


parcelRegister("4765X", function(module, exports) {

$parcel$export(module.exports, "isJsmSmartRequestSummaryEnabled", () => $32d65b0c1914fe19$export$7e4aef4ae0b914e2);

var $1ybV0 = parcelRequire("1ybV0");
const $32d65b0c1914fe19$export$7e4aef4ae0b914e2 = ()=>(0, $1ybV0.ff)('enable-jsm-smart-request-summary_kva1r', false); // </itsm-grimlock>

});


parcelRegister("6xFHS", function(module, exports) {

$parcel$export(module.exports, "AsyncActivityFeedFilter", () => $604fb382ed681f14$export$6ec25d39ce3f42e5);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $9IbuV = parcelRequire("9IbuV");

var $1aMPi = parcelRequire("1aMPi");

const $604fb382ed681f14$var$ActivityFeedFilterComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("tAUa6")).then((module)=>module.ActivityFeedFilter), {
    moduleId: "./src/packages/issue/issue-actions/activity-feed-filter/src/ui/index.tsx"
});
const $604fb382ed681f14$export$6ec25d39ce3f42e5 = (props)=>{
    (0, $9IbuV.useUFOComponentExperience)((0, $1aMPi.jsmActivityFeedFilterExperience));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-activity-feed-filter",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($604fb382ed681f14$var$ActivityFeedFilterComponent, props));
};

});
parcelRegister("9IbuV", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $dfcd8ff9c232688c$export$30ab340faaed55d4);

var $eUqFw = parcelRequire("eUqFw");
const $dfcd8ff9c232688c$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eUqFw.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $dfcd8ff9c232688c$export$30ab340faaed55d4 = (experience)=>{
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $dfcd8ff9c232688c$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("1aMPi", function(module, exports) {

$parcel$export(module.exports, "jsmActivityFeedFilterExperience", () => $aedd471898b41554$export$69e7b825b66592c7);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $aedd471898b41554$export$69e7b825b66592c7 = new (0, $kDfSL.UFOExperience)('jsm-activity-feed-filter', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("tAUa6", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('6xQY6')
        ]);
        const value = parcelRequire('7Nhsa');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("6xQY6")
    ]).then(()=>parcelRequire('7Nhsa'));
}

});


parcelRegister("f26dB", function(module, exports) {

$parcel$export(module.exports, "navigationResource", () => $2dec1e8aa31afb0b$export$62940941ee574cdc);
$parcel$export(module.exports, "useNavigationResource", () => $2dec1e8aa31afb0b$export$c17011c09e042a31);
$parcel$export(module.exports, "useIsPremiumUserSeat", () => $2dec1e8aa31afb0b$export$90749419e9042370);
$parcel$export(module.exports, "useTriggerOverviewChangeboarding", () => $2dec1e8aa31afb0b$export$30f6f0b00bf4f2f8);

var $8blac = parcelRequire("8blac");

var $1ybV0 = parcelRequire("1ybV0");

var $huI7r = parcelRequire("huI7r");

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $gQNVa = parcelRequire("gQNVa");


const $2dec1e8aa31afb0b$export$62940941ee574cdc = (0, $3HCkE.createResource)({
    type: 'BUSINESS_NAVIGATION',
    getKey: ()=>'BUSINESS_NAVIGATION',
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        const isPloverviewMigrationEnabled = (0, $1ybV0.ff)('ploverview_overviews_to_plans_migration');
        const isCustomProjectNavEnabled = (0, $1ybV0.ff)('jwm.custom-project-navigation');
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(projectKey)) return (0, $gQNVa.fetchNavigation)((0, $dac6815921c324c6$export$a40c5d12b8a53ba2), {
            cloudId: cloudId,
            projectKey: projectKey,
            isPloverviewMigrationEnabled: isPloverviewMigrationEnabled,
            isCustomProjectNavEnabled: isCustomProjectNavEnabled
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(projectId)) return (0, $gQNVa.fetchNavigation)((0, $dac6815921c324c6$export$7c9197b656229b53), {
            cloudId: cloudId,
            projectId: (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'project',
                resourceId: projectId
            }),
            isPloverviewMigrationEnabled: isPloverviewMigrationEnabled,
            isCustomProjectNavEnabled: isCustomProjectNavEnabled
        });
        return (0, $gQNVa.fetchNavigation)((0, $dac6815921c324c6$export$c378ca4a0e2c9fec), {
            cloudId: cloudId,
            isPloverviewMigrationEnabled: isPloverviewMigrationEnabled,
            isCustomProjectNavEnabled: isCustomProjectNavEnabled
        });
    },
    maxAge: Infinity
});
const $2dec1e8aa31afb0b$export$c17011c09e042a31 = ()=>(0, $3HCkE.useResource)($2dec1e8aa31afb0b$export$62940941ee574cdc);
const $2dec1e8aa31afb0b$export$90749419e9042370 = ()=>{
    const { data: data } = $2dec1e8aa31afb0b$export$c17011c09e042a31();
    if (data === 'NOT_APPLICABLE') return false;
    return Boolean(data?.isPremiumUserSeat);
};
const $2dec1e8aa31afb0b$export$30f6f0b00bf4f2f8 = ()=>{
    const { data: data } = $2dec1e8aa31afb0b$export$c17011c09e042a31();
    if (data === 'NOT_APPLICABLE') return false;
    return Boolean(data?.showPlansOnboarding);
};

});
parcelRegister("gQNVa", function(module, exports) {

$parcel$export(module.exports, "fetchNavigation", () => $83fda10f52c953b2$export$1fc5fff73d9a570c);

var $dlVOn = parcelRequire("dlVOn");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");


var $2Y7Cf = parcelRequire("2Y7Cf");
const $83fda10f52c953b2$var$EMPTY_RESPONSE = {
    recents: [],
    favorites: [],
    hasMoreFavorite: false,
    overviews: [],
    overviewsError: null,
    isPremiumUserSeat: false,
    showPlansOnboarding: false,
    shouldHideOverviews: false
};
const $83fda10f52c953b2$export$1fc5fff73d9a570c = async (query, params)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: (0, $02a4cc31089f6443$export$3349219a88ac77cd),
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        // checking only for undefined, as null is a valid value (not applicable)
        if (response.data?.jira?.navigation === undefined) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        let areOverviewsGone = false;
        if ((0, $1ybV0.ff)('ploverview_overviews_to_plans_migration') && Array.isArray(response.errors)) // Overviews have been migrated to plans and should no longer be shown to the user
        areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
        return (0, $2Y7Cf.transformData)(response.data.jira.navigation, areOverviewsGone);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $guiFP.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesBusinessNavigation',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $83fda10f52c953b2$var$EMPTY_RESPONSE;
};

});
parcelRegister("dlVOn", function(module, exports) {

$parcel$export(module.exports, "GraphQLErrors", () => $c8c10c82db3c32ef$export$89c202e66b2de2b6);

var $hbMki = parcelRequire("hbMki");

var $1c8hB = parcelRequire("1c8hB");
// Sets the error message on this error according to the
// the GraphQL errors that are present.
const $c8c10c82db3c32ef$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `${errorMessage}\n`;
    });
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $c8c10c82db3c32ef$export$89c202e66b2de2b6 extends Error {
    constructor(graphQLErrors){
        super();
        this.graphQLErrors = graphQLErrors != null ? (0, (/*@__PURE__*/$parcel$interopDefault($hbMki)))(graphQLErrors) : [];
        this.message = $c8c10c82db3c32ef$var$generateErrorMessage(this);
        this.cause = this.graphQLErrors?.[0];
        this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
        this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
    }
}

});
parcelRegister("hbMki", function(module, exports) {

var $1c8hB = parcelRequire("1c8hB");
/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $c838f35dc30c870d$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $1c8hB(value) ? value : [
        value
    ];
}
module.exports = $c838f35dc30c870d$var$castArray;

});


const $02a4cc31089f6443$export$3349219a88ac77cd = 10;
const $02a4cc31089f6443$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';

parcelRegister("2Y7Cf", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $e5db137f9c283ecc$export$3ceb62baab058c6b);

var $kar7l = parcelRequire("kar7l");

var $1ybV0 = parcelRequire("1ybV0");


var $vsTb8 = parcelRequire("vsTb8");
const $e5db137f9c283ecc$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
const $e5db137f9c283ecc$var$PREMIUM = 'PREMIUM';
const $e5db137f9c283ecc$var$mapProjectNode = (node)=>({
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.projectStyle === $e5db137f9c283ecc$var$SIMPLIFIED_PROJECT_STYLE,
        isFavorite: node.isFavourite,
        permissions: {
            viewIssues: node.viewIssues.canPerform
        },
        defaultView: node.defaultView?.typeKey?.toLowerCase()
    });
const $e5db137f9c283ecc$var$mapOverviewNode = (node)=>({
        id: node.id,
        name: node.name,
        theme: node?.theme ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG).name
    });
const $e5db137f9c283ecc$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
    if (navigation == null) // not a JWM context
    return 0, $02a4cc31089f6443$export$e8958a6508ec5b71;
    let overviews = [];
    let overviewsError = null;
    const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $e5db137f9c283ecc$var$PREMIUM;
    if (isPremiumUserSeat) {
        if (navigation.overviews?.__typename === (0, $vsTb8.OVERVIEWS_SUCCESS_RESPONSE_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        overviews = navigation.overviews.edges.map((edge)=>$e5db137f9c283ecc$var$mapOverviewNode(edge.node));
        else overviewsError = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        navigation.overviews ?? new Error('Unknown overviews error');
    }
    let recents = navigation.recentProjects?.edges?.map((edge)=>$e5db137f9c283ecc$var$mapProjectNode(edge.node)) ?? [];
    const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$e5db137f9c283ecc$var$mapProjectNode(edge.node)) ?? [];
    // Remove favorited projects from the recent projects list
    recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
    const showPlansOnboarding = Boolean(navigation.jwmOverviewPlanMigrationState?.changeboardingActive);
    const shouldHideOverviews = (0, $1ybV0.ff)('ploverview_overviews_to_plans_migration') && areOverviewsGone && !showPlansOnboarding;
    return {
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
        overviews: overviews,
        overviewsError: overviewsError,
        isPremiumUserSeat: isPremiumUserSeat,
        showPlansOnboarding: showPlansOnboarding,
        shouldHideOverviews: shouldHideOverviews
    };
};

});
parcelRegister("kar7l", function(module, exports) {

$parcel$export(module.exports, "STAR_ICON_COLOR", () => $15099970f99feec5$export$9e0962e0cb41695d);
$parcel$export(module.exports, "Variables", () => $15099970f99feec5$export$8bb9d79ea938efc9);
$parcel$export(module.exports, "Tokens", () => $15099970f99feec5$export$8e1e81ac145e31be);
$parcel$export(module.exports, "BASE_THEME", () => $15099970f99feec5$export$8a6e9b3370a0f87a);
$parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", () => $15099970f99feec5$export$f286efa6bd1e8f9d);
$parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", () => $15099970f99feec5$export$97cb21c6432e07e8);
$parcel$export(module.exports, "GRADIENT_THEME", () => $15099970f99feec5$export$b124f62a6aab972);
$parcel$export(module.exports, "IMAGE_BACKGROUND_CONFIG", () => $15099970f99feec5$export$9441e0d8f766c59a);
$parcel$export(module.exports, "NO_BACKGROUND_CONFIG", () => $15099970f99feec5$export$4c351ec1dc290344);
$parcel$export(module.exports, "BACKGROUND_CONFIGS_OLD", () => $15099970f99feec5$export$34373eced7ee212e);
$parcel$export(module.exports, "BACKGROUND_COLOR_CONFIGS", () => $15099970f99feec5$export$5ddfadab7b1e12c1);
$parcel$export(module.exports, "SOLID_COLOR_BACKGROUND_CONFIGS", () => $15099970f99feec5$export$349e5dbeac874253);
$parcel$export(module.exports, "GRADIENT_BACKGROUND_CONFIGS", () => $15099970f99feec5$export$242b2d2213fedf27);
$parcel$export(module.exports, "OLD_TO_NEW_BACKGROUND_CONFIG_MAP", () => $15099970f99feec5$export$fe05a238062e2c3d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", () => $15099970f99feec5$export$cab9d853866386f2);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $15099970f99feec5$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "HORIZONTAL_NAV_HEIGHT", () => $15099970f99feec5$export$baaf8255c30ea280);
$parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", () => $15099970f99feec5$export$8e357501548afe78);
$parcel$export(module.exports, "BUSINESS_NAV_HEIGHT", () => $15099970f99feec5$export$d9035bc768f8226d);
$parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", () => $15099970f99feec5$export$4810531e30462f89);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $15099970f99feec5$export$1c0b806722927549);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", () => $15099970f99feec5$export$77cdace62a821419);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", () => $15099970f99feec5$export$3efe68325dd9dc02);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout

var $ho1Ek = parcelRequire("ho1Ek");

var $PdmhA = parcelRequire("PdmhA");

var $aYtGv = parcelRequire("aYtGv");
const $15099970f99feec5$export$b8b9d90f9e5bd72b = 'jiraBusinessThemeConstants';
const $15099970f99feec5$export$9e0962e0cb41695d = '#FFAB00';
const $15099970f99feec5$export$8bb9d79ea938efc9 = {
    BACKDROP_FILTER: '--jwm-backdrop-filter',
    COLOR_BACKGROUND_BRAND_BOLD: '--jwm-color-background-brand-bold',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--jwm-color-background-brand-bold-hovered',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--jwm-color-background-brand-bold-pressed',
    COLOR_BACKGROUND_DISABLED: '--jwm-color-background-disabled',
    COLOR_BACKGROUND_INPUT: '--jwm-background-input',
    COLOR_BACKGROUND_NEUTRAL: '--jwm-background-neutral',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: '--jwm-background-neutral-hovered',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: '--jwm-background-neutral-pressed',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--jwm-background-neutral-subtle-hovered',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--jwm-background-neutral-subtle-pressed',
    COLOR_BACKGROUND_SELECTED: '--jwm-background-selected',
    COLOR_BORDER: '--jwm-color-border',
    COLOR_BORDER_INPUT: '--jwm-color-border-input',
    COLOR_BORDER_INVERSE: '--jwm-color-border-inverse',
    COLOR_BORDER_SELECTED: '--jwm-color-border-selected',
    COLOR_ELEVATION_SURFACE: '--jwm-color-elevation-surface',
    COLOR_ICON_DANGER: '--jwm-color-icon-danger',
    COLOR_ICON_INFORMATION: '--jwm-color-icon-information',
    COLOR_ICON_SUCCESS: '--jwm-color-icon-success',
    COLOR_ICON_WARNING: '--jwm-color-icon-warning',
    COLOR_LINK: '--jwm-color-link',
    COLOR_LINK_PRESSED: '--jwm-color-link-pressed',
    COLOR_SKELETON: '--jwm-skeleton',
    COLOR_TEXT: '--jwm-color-text',
    COLOR_TEXT_DISABLED: '--jwm-color-text-disabled',
    COLOR_TEXT_INVERSE: '--jwm-color-text-inverse',
    COLOR_TEXT_SELECTED: '--jwm-color-text-selected',
    COLOR_TEXT_SUBTLE: '--jwm-color-text-subtle',
    COLOR_TEXT_SUBTLEST: '--jwm-color-text-subtlest',
    CONTENT_HEIGHT: '--jwm-content-height',
    CONTENT_WIDTH: '--jwm-content-width',
    ELEVATION_SURFACE: '--jwm-elevation-surface',
    ELEVATION_SURFACE_CONTRAST: '--jwm-elevation-surface-contrast',
    ELEVATION_SURFACE_CONTRAST_BOLDER: '--jwm-elevation-surface-contrast-bolder',
    WRAPPER_BACKGROUND: '--jwm-wrapper-background',
    WRAPPER_BORDER_RADIUS: '--jwm-wrapper-border-radius',
    WRAPPER_HEIGHT: '--jwm-wrapper-height',
    WRAPPER_PADDING: '--jwm-wrapper-padding',
    WRAPPER_WIDTH: '--jwm-wrapper-width'
};
const $15099970f99feec5$export$8e1e81ac145e31be = {
    BACKDROP_FILTER: 'var(--jwm-backdrop-filter)',
    COLOR_BACKGROUND_BRAND_BOLD: 'var(--jwm-color-background-brand-bold)',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--jwm-color-background-brand-bold-hovered)',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--jwm-color-background-brand-bold-pressed)',
    COLOR_BACKGROUND_DISABLED: 'var(--jwm-color-background-disabled)',
    COLOR_BACKGROUND_INPUT: 'var(--jwm-background-input)',
    COLOR_BACKGROUND_NEUTRAL: 'var(--jwm-background-neutral)',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--jwm-background-neutral-hovered)',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--jwm-background-neutral-pressed)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--jwm-background-neutral-subtle-hovered)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--jwm-background-neutral-subtle-pressed)',
    COLOR_BACKGROUND_SELECTED: 'var(--jwm-background-selected)',
    COLOR_BORDER: 'var(--jwm-color-border)',
    COLOR_BORDER_INPUT: 'var(--jwm-color-border-input)',
    COLOR_BORDER_INVERSE: 'var(--jwm-color-border-inverse)',
    COLOR_BORDER_SELECTED: 'var(--jwm-color-border-selected)',
    COLOR_ELEVATION_SURFACE: 'var(--jwm-color-elevation-surface)',
    COLOR_ICON_DANGER: 'var(--jwm-color-icon-danger)',
    COLOR_ICON_INFORMATION: 'var(--jwm-color-icon-information)',
    COLOR_ICON_SUCCESS: 'var(--jwm-color-icon-success)',
    COLOR_ICON_WARNING: 'var(--jwm-color-icon-warning)',
    COLOR_LINK: 'var(--jwm-color-link)',
    COLOR_LINK_PRESSED: 'var(--jwm-color-link-pressed)',
    COLOR_SKELETON: 'var(--jwm-skeleton)',
    COLOR_TEXT: 'var(--jwm-color-text)',
    COLOR_TEXT_DISABLED: 'var(--jwm-color-text-disabled)',
    COLOR_TEXT_INVERSE: 'var(--jwm-color-text-inverse)',
    COLOR_TEXT_SELECTED: 'var(--jwm-color-text-selected)',
    COLOR_TEXT_SUBTLE: 'var(--jwm-color-text-subtle)',
    COLOR_TEXT_SUBTLEST: 'var(--jwm-color-text-subtlest)',
    CONTENT_HEIGHT: 'var(--jwm-content-height)',
    CONTENT_WIDTH: 'var(--jwm-content-width)',
    ELEVATION_SURFACE: 'var(--jwm-elevation-surface)',
    ELEVATION_SURFACE_CONTRAST: 'var(--jwm-elevation-surface-contrast)',
    ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--jwm-elevation-surface-contrast-bolder)',
    WRAPPER_BACKGROUND: 'var(--jwm-wrapper-background)',
    WRAPPER_BORDER_RADIUS: 'var(--jwm-wrapper-border-radius)',
    WRAPPER_HEIGHT: 'var(--jwm-wrapper-height)',
    WRAPPER_PADDING: 'var(--jwm-wrapper-padding)',
    WRAPPER_WIDTH: 'var(--jwm-wrapper-width)'
};
const $15099970f99feec5$export$8a6e9b3370a0f87a = {
    'color.background.brand.bold': "var(--ds-background-brand-bold, #09326C)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0C66E4)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #09326C)",
    'color.background.disabled': "var(--ds-background-disabled, #091E4208)",
    'color.background.input': `var(--ds-background-input, ${(0, $PdmhA).N0})`,
    'color.background.neutral': `var(--ds-background-neutral, ${(0, $PdmhA).N30A})`,
    'color.background.neutral.hovered': `var(--ds-background-neutral-hovered, ${(0, $PdmhA).N40A})`,
    'color.background.neutral.pressed': `var(--ds-background-neutral-pressed, ${(0, $PdmhA).N50A})`,
    'color.background.neutral.subtle.hovered': `var(--ds-background-neutral-subtle-hovered, ${(0, $PdmhA).N40A})`,
    'color.background.neutral.subtle.pressed': `var(--ds-background-neutral-subtle-pressed, ${(0, $PdmhA).N50A})`,
    'color.background.selected': `var(--ds-background-selected, ${(0, $PdmhA).B400})`,
    'color.elevation.surface': `var(--ds-surface, ${(0, $PdmhA).N0})`,
    'color.border': `var(--ds-border, ${(0, $PdmhA).N40A})`,
    'color.border.input': "var(--ds-border-input, #091E4224)",
    'color.border.inverse': `var(--ds-border-inverse, ${(0, $PdmhA).N0})`,
    'color.border.selected': `var(--ds-border-selected, ${(0, $PdmhA).B400})`,
    'color.icon.danger': `var(--ds-icon-danger, ${(0, $PdmhA).R200})`,
    'color.icon.information': `var(--ds-icon-information, ${(0, $PdmhA).B200})`,
    'color.icon.success': `var(--ds-icon-success, ${(0, $PdmhA).G200})`,
    'color.icon.warning': `var(--ds-icon-warning, ${(0, $PdmhA).Y200})`,
    'color.link': "var(--ds-link, #0c66e4)",
    'color.link.pressed': "var(--ds-link-pressed, #0055cc)",
    'color.skeleton': `var(--ds-background-neutral, ${(0, $PdmhA).N20A})`,
    'color.text': `var(--ds-text, ${(0, $PdmhA).N800})`,
    'color.text.disabled': "var(--ds-text-disabled, #091E424F)",
    'color.text.inverse': `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    'color.text.selected': `var(--ds-text-selected, ${(0, $PdmhA).B400})`,
    'color.text.subtle': `var(--ds-text-subtle, ${(0, $PdmhA).N500})`,
    'color.text.subtlest': "var(--ds-text-subtlest, #626f86)",
    'elevation.surface.contrast': 'transparent',
    'elevation.surface.contrast.bolder': 'transparent'
};
const $15099970f99feec5$export$f286efa6bd1e8f9d = {
    'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
    'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.background.disabled': "var(--ds-background-neutral, #091E420F)",
    'color.background.input': 'rgba(255, 255, 255, 0.8)',
    'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.text.selected': `var(--ds-text-inverse, ${(0, $PdmhA).N0})`
};
const $15099970f99feec5$export$97cb21c6432e07e8 = {
    'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
    'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
    'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
    'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
    'color.background.input': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
    'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
    'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
    'color.background.selected': 'rgba(255, 255, 255, 0.6)',
    'color.elevation.surface': '#172b4d',
    'color.border': 'rgba(255, 255, 255, 0.14)',
    'color.border.input': 'rgba(255, 255, 255, 0.3)',
    'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
    'color.border.selected': (0, $PdmhA).N0,
    'color.icon.danger': (0, $PdmhA).N0,
    'color.icon.information': (0, $PdmhA).N0,
    'color.icon.success': (0, $PdmhA).N0,
    'color.icon.warning': (0, $PdmhA).N0,
    'color.skeleton': 'rgba(255,255,255,0.08)',
    'color.text': (0, $PdmhA).N0,
    'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
    'color.text.inverse': '#172B4D',
    // Neutral 1000
    'color.text.selected': '#172B4D',
    // Neutral 1000
    'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
    'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
};
const $15099970f99feec5$export$b124f62a6aab972 = {
    'color.link': '#CCE0FF',
    // Blue 200
    'color.link.pressed': '#E9F2FF' // Blue 100
};
const $15099970f99feec5$export$9441e0d8f766c59a = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.text.selected': `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
            'elevation.surface.contrast.bolder': `var(--ds-surface, ${(0, $PdmhA).N0})`
        },
        dark: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #8C9BAB)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #9FADBC)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
            'color.background.input': 'rgba(34, 39, 43, 0.8)',
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
            'color.elevation.surface': '#172b4d',
            'color.border': 'rgba(255, 255, 255, 0.14)',
            'color.border.input': 'rgba(255, 255, 255, 0.3)',
            'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
            'color.icon.danger': (0, $PdmhA).N0,
            'color.icon.information': (0, $PdmhA).N0,
            'color.icon.success': (0, $PdmhA).N0,
            'color.icon.warning': (0, $PdmhA).N0,
            'color.link': "var(--ds-text-accent-blue-bolder, #CCE0FF)",
            'color.link.pressed': "var(--ds-text-accent-blue, #85B8FF)",
            'color.skeleton': 'rgba(255,255,255,0.8)',
            'color.text': (0, $PdmhA).N0,
            'color.text.selected': "var(--ds-text-inverse, #1D2125)",
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #1D2125)"
        }
    }
};
// Old Colors
const $15099970f99feec5$var$WHITE_BACKGROUND_CONFIG = {
    name: 'white'
};
const $15099970f99feec5$var$LIGHT_PURPLE_BACKGROUND_CONFIG = {
    name: 'light-purple'
};
const $15099970f99feec5$var$LIGHT_BLUE_BACKGROUND_CONFIG = {
    name: 'light-blue'
};
const $15099970f99feec5$var$LIGHT_TEAL_BACKGROUND_CONFIG = {
    name: 'light-teal'
};
const $15099970f99feec5$var$LIGHT_GREEN_BACKGROUND_CONFIG = {
    name: 'light-green'
};
const $15099970f99feec5$var$LIGHT_YELLOW_BACKGROUND_CONFIG = {
    name: 'light-yellow'
};
const $15099970f99feec5$var$LIGHT_RED_BACKGROUND_CONFIG = {
    name: 'light-red'
};
const $15099970f99feec5$var$LIGHT_MAGENTA_BACKGROUND_CONFIG = {
    name: 'light-magenta'
};
const $15099970f99feec5$var$LIGHT_ORANGE_BACKGROUND_CONFIG = {
    name: 'light-orange'
};
const $15099970f99feec5$var$DARK_BACKGROUND_CONFIG = {
    name: 'dark'
};
const $15099970f99feec5$var$PURPLE_BACKGROUND_CONFIG = {
    name: 'purple'
};
const $15099970f99feec5$var$BLUE_BACKGROUND_CONFIG = {
    name: 'blue'
};
const $15099970f99feec5$var$TEAL_BACKGROUND_CONFIG = {
    name: 'teal'
};
const $15099970f99feec5$var$GREEN_BACKGROUND_CONFIG = {
    name: 'green'
};
const $15099970f99feec5$var$YELLOW_BACKGROUND_CONFIG = {
    name: 'yellow'
};
const $15099970f99feec5$var$RED_BACKGROUND_CONFIG = {
    name: 'red'
};
const $15099970f99feec5$var$MAGENTA_BACKGROUND_CONFIG = {
    name: 'magenta'
};
const $15099970f99feec5$var$ORANGE_BACKGROUND_CONFIG = {
    name: 'orange'
};
// New Colors
const $15099970f99feec5$var$DARKER_GRAY_BACKGROUND_CONFIG = {
    name: 'darker-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $15099970f99feec5$var$DARKER_PURPLE_BACKGROUND_CONFIG = {
    name: 'darker-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $15099970f99feec5$var$DARKER_BLUE_BACKGROUND_CONFIG = {
    name: 'darker-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $15099970f99feec5$var$DARKER_TEAL_BACKGROUND_CONFIG = {
    name: 'darker-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $15099970f99feec5$var$DARKER_GREEN_BACKGROUND_CONFIG = {
    name: 'darker-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $15099970f99feec5$var$DARKER_LIME_BACKGROUND_CONFIG = {
    name: 'darker-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $15099970f99feec5$var$DARKER_YELLOW_BACKGROUND_CONFIG = {
    name: 'darker-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $15099970f99feec5$var$DARKER_ORANGE_BACKGROUND_CONFIG = {
    name: 'darker-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $15099970f99feec5$var$DARKER_RED_BACKGROUND_CONFIG = {
    name: 'darker-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $15099970f99feec5$var$DARKER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darker-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_GRAY_BACKGROUND_CONFIG = {
    name: 'darkest-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'darkest-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_BLUE_BACKGROUND_CONFIG = {
    name: 'darkest-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_TEAL_BACKGROUND_CONFIG = {
    name: 'darkest-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_GREEN_BACKGROUND_CONFIG = {
    name: 'darkest-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_LIME_BACKGROUND_CONFIG = {
    name: 'darkest-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'darkest-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'darkest-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_RED_BACKGROUND_CONFIG = {
    name: 'darkest-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darkest-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_GRAY_BACKGROUND_CONFIG = {
    name: 'lightest-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F1F2F4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'lightest-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F3F0FF',
            // Purple 100
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_BLUE_BACKGROUND_CONFIG = {
    name: 'lightest-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E9F2FF',
            // Blue 100
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_TEAL_BACKGROUND_CONFIG = {
    name: 'lightest-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E7F9FF',
            // Teal 100
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_GREEN_BACKGROUND_CONFIG = {
    name: 'lightest-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCFFF1',
            // Green 100
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_LIME_BACKGROUND_CONFIG = {
    name: 'lightest-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#EFFFD6',
            // Lime 100
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'lightest-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF7D6',
            // Yellow 100
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'lightest-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF3EB',
            // Orange 100
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_RED_BACKGROUND_CONFIG = {
    name: 'lightest-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECEB',
            // Red 100
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lightest-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECF8',
            // Magenta 100
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_GRAY_BACKGROUND_CONFIG = {
    name: 'lighter-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCDFE4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_PURPLE_BACKGROUND_CONFIG = {
    name: 'lighter-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DFD8FD',
            // Purple 200
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_BLUE_BACKGROUND_CONFIG = {
    name: 'lighter-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#CCE0FF',
            // Blue 200
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_TEAL_BACKGROUND_CONFIG = {
    name: 'lighter-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#C6EDFB',
            // Teal 200
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_GREEN_BACKGROUND_CONFIG = {
    name: 'lighter-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#BAF3DB',
            // Green 200
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_LIME_BACKGROUND_CONFIG = {
    name: 'lighter-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#D3F1A7',
            // Lime 200
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_YELLOW_BACKGROUND_CONFIG = {
    name: 'lighter-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F8E6A0',
            // Yellow 200
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_ORANGE_BACKGROUND_CONFIG = {
    name: 'lighter-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FEDEC8',
            // Orange 200
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_RED_BACKGROUND_CONFIG = {
    name: 'lighter-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFD5D2',
            // Red 200
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lighter-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FDD0EC',
            // Magenta 200
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $15099970f99feec5$export$4c351ec1dc290344 = {
    name: 'no-background',
    brightness: 'high',
    theme: {
        light: $15099970f99feec5$export$8a6e9b3370a0f87a,
        dark: $15099970f99feec5$export$8a6e9b3370a0f87a
    }
};
// Gradients
const $15099970f99feec5$var$GRADIENT_GRAY_TO_BLACK_META = {
    name: 'gradient-gray-to-black',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META = {
    name: 'gradient-dark-to-medium-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_LIGHT_TO_DARK_BLUE_META = {
    name: 'gradient-light-to-dark-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_BLUE_TO_TEAL_META = {
    name: 'gradient-blue-to-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_PURPLE_TO_MAGENTA_META = {
    name: 'gradient-purple-to-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_MAGENTA_TO_ORANGE_META = {
    name: 'gradient-magenta-to-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_RED_META = {
    name: 'gradient-dark-to-light-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META = {
    name: 'gradient-dark-to-light-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_GREEN_TO_LIME_META = {
    name: 'gradient-dark-green-to-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
    name: 'gradient-dark-to-medium-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        }
    }
};
const $15099970f99feec5$export$34373eced7ee212e = [
    $15099970f99feec5$var$WHITE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_MAGENTA_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARK_BACKGROUND_CONFIG,
    $15099970f99feec5$var$PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$MAGENTA_BACKGROUND_CONFIG
];
const $15099970f99feec5$export$5ddfadab7b1e12c1 = [
    $15099970f99feec5$var$LIGHTEST_GRAY_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_LIME_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_GRAY_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_LIME_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_GRAY_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_LIME_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_MAGENTA_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_LIME_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_MAGENTA_BACKGROUND_CONFIG
];
const $15099970f99feec5$export$349e5dbeac874253 = [
    ...$15099970f99feec5$export$5ddfadab7b1e12c1,
    $15099970f99feec5$export$4c351ec1dc290344
];
const $15099970f99feec5$export$242b2d2213fedf27 = [
    $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_RED_META,
    $15099970f99feec5$var$GRADIENT_MAGENTA_TO_ORANGE_META,
    $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META,
    $15099970f99feec5$var$GRADIENT_DARK_GREEN_TO_LIME_META,
    $15099970f99feec5$var$GRADIENT_BLUE_TO_TEAL_META,
    $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META,
    $15099970f99feec5$var$GRADIENT_LIGHT_TO_DARK_BLUE_META,
    $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META,
    $15099970f99feec5$var$GRADIENT_PURPLE_TO_MAGENTA_META,
    $15099970f99feec5$var$GRADIENT_GRAY_TO_BLACK_META
];
const $15099970f99feec5$export$8f118a95a310853a = [
    ...$15099970f99feec5$export$242b2d2213fedf27,
    ...$15099970f99feec5$export$349e5dbeac874253
];
const $15099970f99feec5$export$fe05a238062e2c3d = {
    white: $15099970f99feec5$export$4c351ec1dc290344,
    'light-purple': $15099970f99feec5$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    'light-blue': $15099970f99feec5$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    'light-teal': $15099970f99feec5$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    'light-green': $15099970f99feec5$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    'light-yellow': $15099970f99feec5$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    'light-orange': $15099970f99feec5$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    'light-red': $15099970f99feec5$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    'light-magenta': $15099970f99feec5$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    dark: $15099970f99feec5$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    purple: $15099970f99feec5$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    blue: $15099970f99feec5$var$DARKER_BLUE_BACKGROUND_CONFIG,
    teal: $15099970f99feec5$var$DARKER_TEAL_BACKGROUND_CONFIG,
    green: $15099970f99feec5$var$DARKER_GREEN_BACKGROUND_CONFIG,
    yellow: $15099970f99feec5$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    orange: $15099970f99feec5$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    red: $15099970f99feec5$var$DARKER_RED_BACKGROUND_CONFIG,
    magenta: $15099970f99feec5$var$DARKER_MAGENTA_BACKGROUND_CONFIG
};
const $15099970f99feec5$export$cab9d853866386f2 = $15099970f99feec5$export$4c351ec1dc290344;
const $15099970f99feec5$export$ed7cc0d417ee89e = '--jwm-banner-height';
const $15099970f99feec5$export$7009ab5fba189797 = `var(${$15099970f99feec5$export$ed7cc0d417ee89e}, 0px)`;
const $15099970f99feec5$export$baaf8255c30ea280 = 95;
const $15099970f99feec5$export$8e357501548afe78 = 24;
const $15099970f99feec5$export$d9035bc768f8226d = `calc(${$15099970f99feec5$export$baaf8255c30ea280}px + ${$15099970f99feec5$export$7009ab5fba189797})`;
const $15099970f99feec5$export$4810531e30462f89 = `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$15099970f99feec5$export$d9035bc768f8226d})`;
const $15099970f99feec5$export$1c0b806722927549 = `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$15099970f99feec5$export$d9035bc768f8226d} - ${$15099970f99feec5$export$8e357501548afe78 * 2}px)`;
const $15099970f99feec5$export$77cdace62a821419 = `calc(100vw - ${(0, $ho1Ek.LEFT_PANEL_WIDTH)} - ${(0, $ho1Ek.LEFT_SIDEBAR_WIDTH)} - ${(0, $ho1Ek.RIGHT_PANEL_WIDTH)} - ${(0, $ho1Ek.RIGHT_SIDEBAR_WIDTH)}) !important`;
const $15099970f99feec5$export$3efe68325dd9dc02 = `calc(100vw - ${(0, $ho1Ek.LEFT_PANEL_WIDTH)} - ${(0, $ho1Ek.LEFT_SIDEBAR_WIDTH)} - ${(0, $ho1Ek.RIGHT_PANEL_WIDTH)} - ${(0, $ho1Ek.RIGHT_SIDEBAR_WIDTH)} - ${$15099970f99feec5$export$8e357501548afe78 * 2}px) !important`;

});
parcelRegister("aYtGv", function(module, exports) {

$parcel$export(module.exports, "PAGE_LAYOUT_OFFSET_TOP", () => $479507d87baa6502$export$d60454526e2281af);
$parcel$export(module.exports, "HORIZONTAL_GLOBAL_NAV_HEIGHT", () => $479507d87baa6502$export$30fa7cc5f2690a43);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout

var $ho1Ek = parcelRequire("ho1Ek");
const $479507d87baa6502$export$d60454526e2281af = `(${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)} + ${(0, $ho1Ek.BANNER_HEIGHT)})`;
const $479507d87baa6502$export$30fa7cc5f2690a43 = 56;

});


parcelRegister("vsTb8", function(module, exports) {

$parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", () => $8f89cb3175071b7f$export$ddf2fc82885279d);
const $8f89cb3175071b7f$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
const $8f89cb3175071b7f$export$39284f7325536558 = {
    ServiceDesk: 'SERVICE_DESK',
    Business: 'BUSINESS',
    Software: 'SOFTWARE'
};
const $8f89cb3175071b7f$export$1f66f9f05afa05a8 = {
    TeamManagedProject: 'TEAM_MANAGED_PROJECT',
    CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
};

});



const $dac6815921c324c6$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView @include(if: $isCustomProjectNavEnabled) {
    ... on JiraWorkManagementSavedView {
      typeKey
    }
  }
}
`;
const $dac6815921c324c6$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $dac6815921c324c6$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $dac6815921c324c6$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $dac6815921c324c6$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
  jwmOverviewPlanMigrationState @include(if: $isPloverviewMigrationEnabled) {
    ... on JiraOverviewPlanMigrationState {
      changeboardingActive
    }
  }
}
`;
const $dac6815921c324c6$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!, $isPloverviewMigrationEnabled: Boolean!, $isCustomProjectNavEnabled: Boolean!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$dac6815921c324c6$var$ProjectFragment}
${$dac6815921c324c6$var$ProjectConnectionFragment}
${$dac6815921c324c6$var$NavigationDataFragment}
${$dac6815921c324c6$var$OverviewFragment}
${$dac6815921c324c6$var$OverviewConnectionFragment}
`;
const $dac6815921c324c6$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!, $isPloverviewMigrationEnabled: Boolean!, $isCustomProjectNavEnabled: Boolean!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$dac6815921c324c6$var$ProjectFragment}
${$dac6815921c324c6$var$ProjectConnectionFragment}
${$dac6815921c324c6$var$NavigationDataFragment}
${$dac6815921c324c6$var$OverviewFragment}
${$dac6815921c324c6$var$OverviewConnectionFragment}
`;
const $dac6815921c324c6$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!, $isPloverviewMigrationEnabled: Boolean!, $isCustomProjectNavEnabled: Boolean!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$dac6815921c324c6$var$ProjectFragment}
${$dac6815921c324c6$var$ProjectConnectionFragment}
${$dac6815921c324c6$var$NavigationDataFragment}
${$dac6815921c324c6$var$OverviewFragment}
${$dac6815921c324c6$var$OverviewConnectionFragment}
`;


parcelRegister("gnlws", function(module, exports) {

$parcel$export(module.exports, "ActivitySortingWrapper", () => $47ab4691aa65ea45$export$8143edd65c720134);
$parcel$export(module.exports, "ActivityHeadingEndWrapper", () => $47ab4691aa65ea45$export$6bc8232be616fe85);
$parcel$export(module.exports, "ActivityItemHeading", () => $47ab4691aa65ea45$export$829b8778bdb987d9);
$parcel$export(module.exports, "ActivityItems", () => $47ab4691aa65ea45$export$ef3f48e8f285f6f0);
$parcel$export(module.exports, "buttonTheme", () => $47ab4691aa65ea45$export$577deec5d331f6be);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $PdmhA = parcelRequire("PdmhA");

var $iAc02 = parcelRequire("iAc02");
const $47ab4691aa65ea45$export$8143edd65c720134 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wpzesu3",
            __cmplp.className
        ])
    });
});
const $47ab4691aa65ea45$export$6bc8232be616fe85 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wpzesu3 _1e0c1txw _2lx2vrvc _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $47ab4691aa65ea45$export$829b8778bdb987d9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $iAc02.SectionHeading), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1y44",
            __cmplp.className
        ])
    });
});
$47ab4691aa65ea45$export$829b8778bdb987d9.displayName = 'ActivityItemHeading';
const $47ab4691aa65ea45$export$ef3f48e8f285f6f0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $47ab4691aa65ea45$export$577deec5d331f6be = (isSelected)=>(currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
        return {
            ...rest,
            buttonStyles: {
                ...buttonStyles,
                padding: `0 ${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-050, 4px)"}`,
                margin: `0 ${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-050, 4px)"}`,
                backgroundColor: isSelected ? `var(--ds-background-selected, ${(0, $PdmhA).N400})` : `var(--ds-background-neutral, ${(0, $PdmhA).N20})`,
                '&:hover': {
                    backgroundColor: isSelected ? `var(--ds-background-selected-hovered, ${(0, $PdmhA).N400})` : `var(--ds-background-neutral-hovered, ${(0, $PdmhA).N30})`
                },
                '&:active': {
                    backgroundColor: isSelected ? `var(--ds-background-selected-pressed, ${(0, $PdmhA).N400})` : `var(--ds-background-neutral-pressed, ${(0, $PdmhA).B50})`
                }
            }
        };
    };

});

parcelRegister("3BQHD", function(module, exports) {

$parcel$export(module.exports, "ActivityFeedButtons", () => $9eacaa7f9c7c2679$export$f06806a8852d078b);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");

var $fkvsU = parcelRequire("fkvsU");

var $8AZFW = parcelRequire("8AZFW");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $gnlws = parcelRequire("gnlws");
const $9eacaa7f9c7c2679$var$ButtonComponent = ({ children: children, onClick: onClick, isSelected: isSelected, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        appearance: "subtle",
        spacing: "compact",
        isSelected: isSelected,
        theme: (0, $gnlws.buttonTheme)(isSelected),
        onClick: onClick,
        testId: testId,
        "aria-checked": isSelected,
        role: "menuitemradio",
        interactionName: "auto-generated.jira-issue-activity-feed.ui.buttons.button"
    }, children);
const $9eacaa7f9c7c2679$export$f06806a8852d078b = ({ items: items, selectedItem: selectedItem, onSelectActivityItem: onSelectActivityItem })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "activityFeedButtons"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (event)=>(0, $jMP2a.fireScreenAnalyticsDeferred)(event)
    }), items.map((item)=>{
        const props = {
            key: item.key,
            isSelected: selectedItem.key === item.key,
            onClick: (event, analyticsEvent)=>onSelectActivityItem(item, analyticsEvent, 'buttonItemSelected', event.timeStamp)
        };
        return item.type === (0, $fkvsU.FORGE_ENTITY_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8AZFW.ForgeIssueActivityItem), {
            ...props,
            component: $9eacaa7f9c7c2679$var$ButtonComponent,
            item: item
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9eacaa7f9c7c2679$var$ButtonComponent, {
            ...props,
            testId: `issue-activity-feed.ui.buttons.${item.key}`
        }, item.name);
    }));

});
parcelRegister("8AZFW", function(module, exports) {

$parcel$export(module.exports, "ForgeIssueActivityTrigger", () => $9f1c02c37a4298e2$export$d61a78deea466c0f);
$parcel$export(module.exports, "ForgeIssueActivityItem", () => $9f1c02c37a4298e2$export$fab3921e07384913);

var $eUqFw = parcelRequire("eUqFw");

var $1boRu = parcelRequire("1boRu");

var $5syGA = parcelRequire("5syGA");

var $6KvCq = parcelRequire("6KvCq");

var $6kPQJ = parcelRequire("6kPQJ");

var $fT83w = parcelRequire("fT83w");
const $9f1c02c37a4298e2$export$d61a78deea466c0f = ({ item: item, component: component })=>{
    const Component = component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fT83w.ExtensionTitle), {
        extensionName: item.name,
        extensionEnvType: item.extension.environmentType,
        extensionEnvKey: item.extension.environmentKey
    }));
};
const $9f1c02c37a4298e2$export$308fb0b07f10e0f7 = ({ component: component, item: item, onClick: onClick, isSelected: isSelected })=>{
    const Component = component;
    const handleOnClick = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    (event, analyticsEvent)=>{
        (0, $6KvCq.fireUiTriggerClickedEvent)();
        onClick(event, analyticsEvent);
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        onClick: handleOnClick,
        isSelected: !!isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fT83w.ExtensionTitle), {
        extensionName: item.name,
        extensionEnvType: item.extension.environmentType,
        extensionEnvKey: item.extension.environmentKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: {
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(item.extension)
        }
    }));
};
const $9f1c02c37a4298e2$export$fab3921e07384913 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6kPQJ.TriggerAnalyticsWrapper), {
        attributes: (0, $5syGA.getAnalyticsAttributesFromExtension)(props.item.extension)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9f1c02c37a4298e2$export$308fb0b07f10e0f7, props));

});
parcelRegister("6KvCq", function(module, exports) {

$parcel$export(module.exports, "fireUiTriggerClickedEvent", () => $c1dcf7ebeef29ed1$export$cc0cc6563e35ae9);

var $2Rqjr = parcelRequire("2Rqjr");

var $8XU7c = parcelRequire("8XU7c");

var $cYWDh = parcelRequire("cYWDh");

var $d6g7g = parcelRequire("d6g7g");

var $hRcYT = parcelRequire("hRcYT");
const $c1dcf7ebeef29ed1$var$triggerEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.ISSUE_ACTIVITY_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER)
});
const $c1dcf7ebeef29ed1$export$cc0cc6563e35ae9 = (source, attributes)=>{
    (0, $d6g7g.forgeModulesLoadTime).start({
        startTime: performance.now()
    });
    return (0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).CLICKED, {
        id: $c1dcf7ebeef29ed1$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};

});

parcelRegister("6kPQJ", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $580f7788c46b2811$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $580f7788c46b2811$export$e1a79e3d472c925a);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");
const $580f7788c46b2811$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.ISSUE_ACTIVITY_MODULE),
        ...props
    });
const $580f7788c46b2811$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.ISSUE_ACTIVITY_MODULE),
        moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("fT83w", function(module, exports) {

$parcel$export(module.exports, "ExtensionTitle", () => $3a6007e5947da50f$export$3aa4a75e461c581c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2Rqjr = parcelRequire("2Rqjr");

var $7eMp1 = parcelRequire("7eMp1");
const $3a6007e5947da50f$var$shouldShowEnv = (extensionEnvType)=>[
        (0, $2Rqjr.STAGING_ENVIRONMENT),
        (0, $2Rqjr.DEVELOPMENT_ENVIRONMENT)
    ].includes(extensionEnvType);
const $3a6007e5947da50f$export$3aa4a75e461c581c = ({ extensionEnvType: extensionEnvType, extensionEnvKey: extensionEnvKey, extensionName: extensionName })=>{
    if (!$3a6007e5947da50f$var$shouldShowEnv(extensionEnvType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, extensionName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3a6007e5947da50f$var$ExtensionTitleWrapper, null, (0, $7eMp1.nameWithCustomEnvironment)(extensionName, extensionEnvType, extensionEnvKey), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eMp1.EnvironmentLozenge), {
        environmentType: extensionEnvType
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a6007e5947da50f$var$ExtensionTitleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1q9y _13aiidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7eMp1", function(module, exports) {

$parcel$export(module.exports, "EnvironmentLozenge", () => $cd44a5efa9c7c2f2$export$278f8e01799d0418);
$parcel$export(module.exports, "nameWithCustomEnvironment", () => $cd44a5efa9c7c2f2$export$f9338c21ba7c7334);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $2Rqjr = parcelRequire("2Rqjr");

var $8uD7Y = parcelRequire("8uD7Y");

var $aghg0 = parcelRequire("aghg0");
const $cd44a5efa9c7c2f2$export$50589a87e4fb3dae = (environmentType)=>{
    switch(environmentType){
        case 0, $2Rqjr.DEVELOPMENT_ENVIRONMENT:
            return (0, $aghg0.messages).developmentEnvironmentLozenge;
        case 0, $2Rqjr.STAGING_ENVIRONMENT:
            return (0, $aghg0.messages).stagingEnvironmentLozenge;
        default:
            return null;
    }
};
const $cd44a5efa9c7c2f2$export$278f8e01799d0418 = (props)=>{
    const { environmentType: environmentType } = props;
    const labelKey = $cd44a5efa9c7c2f2$export$50589a87e4fb3dae(environmentType);
    return labelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
        appearance: environmentType === (0, $2Rqjr.DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), labelKey)) : null;
};
const $cd44a5efa9c7c2f2$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
    if (environmentType === (0, $2Rqjr.DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, $2Rqjr.DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
    return name;
};

});
parcelRegister("aghg0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ea116b14fefa1e63$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ea116b14fefa1e63$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    developmentEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
        "defaultMessage": "DEV"
    },
    stagingEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
        "defaultMessage": "STG"
    }
});

});





parcelRegister("kvGqG", function(module, exports) {

$parcel$export(module.exports, "ActivityFeedDropdown", () => $9a69dc4ce603eb84$export$aee7c92e8512d53b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bbaTG = parcelRequire("bbaTG");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $86Ndv = parcelRequire("86Ndv");

var $PdmhA = parcelRequire("PdmhA");

var $fkvsU = parcelRequire("fkvsU");

var $8AZFW = parcelRequire("8AZFW");

var $g8JvH = parcelRequire("g8JvH");
var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");
var $bFzGY = parcelRequire("bFzGY");
// eslint-disable-next-line jira/styled/styled-component-order, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9a69dc4ce603eb84$var$StyledDropdownItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $hD6GJ.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91qr7",
            __cmplp.className
        ])
    });
});
$9a69dc4ce603eb84$var$StyledDropdownItem.displayName = 'DropdownItem';
const $9a69dc4ce603eb84$var$DropdownItemWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('dropdownItem', {
    onClick: 'clicked'
})($9a69dc4ce603eb84$var$StyledDropdownItem);
const $9a69dc4ce603eb84$var$DropdownItemComponent = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a69dc4ce603eb84$var$DropdownItemWithAnalytics, {
        onClick: onClick
    }, children);
const $9a69dc4ce603eb84$export$f48224de87d33a65 = ()=>(0, $eUqFw.useState)(false);
const $9a69dc4ce603eb84$export$aee7c92e8512d53b = ({ items: items, selectedItem: selectedItem, onSelectActivityItem: onSelectActivityItem })=>{
    const [isDropdownOpen, setIsDropdownOpen] = $9a69dc4ce603eb84$export$f48224de87d33a65();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const dropdownTrigger = (0, $eUqFw.useCallback)(({ triggerRef: triggerRef, ...triggerProps })=>{
        const customThemeButtonProps = {
            appearance: 'subtle',
            spacing: 'compact',
            theme: (currentTheme, themeProps)=>{
                const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
                const customStyles = {
                    padding: `0 ${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-050, 4px)"}`,
                    margin: `0 ${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-050, 4px)"}`,
                    backgroundColor: isDropdownOpen ? `var(--ds-background-selected, ${(0, $PdmhA).N400})` : `var(--ds-background-neutral, ${(0, $PdmhA).N20})`,
                    '&:hover': {
                        backgroundColor: isDropdownOpen ? `var(--ds-background-selected-hovered, ${(0, $PdmhA).N400})` : `var(--ds-background-neutral-hovered, ${(0, $PdmhA).N30})`
                    },
                    '&:active': {
                        backgroundColor: isDropdownOpen ? `var(--ds-background-selected-pressed, ${(0, $PdmhA).N400})` : `var(--ds-background-neutral-pressed, ${(0, $PdmhA).B50})`
                    }
                };
                return {
                    ...rest,
                    buttonStyles: {
                        ...buttonStyles,
                        ...customStyles
                    }
                };
            },
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: ""
            })
        };
        if (selectedItem.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
            ref: triggerRef,
            ...triggerProps,
            ...customThemeButtonProps,
            interactionName: "auto-generated.jira-issue-activity-feed.ui.dropdown.button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8AZFW.ForgeIssueActivityTrigger), {
            item: selectedItem,
            // @ts-expect-error - TS2322 - Type 'FC<any>' is not assignable to type '(props: { children: ReactNode; }) => ReactElement<any, string | JSXElementConstructor<any>>'.
            component: $9a69dc4ce603eb84$var$DropdownTrigger
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
            ref: triggerRef,
            ...triggerProps,
            ...customThemeButtonProps,
            interactionName: "auto-generated.jira-issue-activity-feed.ui.dropdown.button1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a69dc4ce603eb84$var$DropdownTrigger, null, selectedItem.name));
    }, [
        isDropdownOpen,
        selectedItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$d1123261ca8831d2),
        sourceName: "activityFeed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (0, $jMP2a.fireScreenAnalytics)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        isOpen: isDropdownOpen,
        testId: "issue-activity-feed.ui.dropdown.dropdown-menu-stateless",
        placement: "bottom-start",
        trigger: dropdownTrigger,
        onOpenChange: ({ isOpen: isOpen })=>{
            setIsDropdownOpen(isOpen);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'toggled',
                actionSubject: 'dropdownMenu'
            }), {
                isOpen: isOpen
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, items.filter((item)=>item.key !== selectedItem.key).map((item)=>{
        const props = {
            key: item.key,
            onClick: (e, analyticsEvent)=>onSelectActivityItem(item, analyticsEvent, 'dropdownItemSelected', e.timeStamp)
        };
        return item.type === (0, $fkvsU.FORGE_ENTITY_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8AZFW.ForgeIssueActivityItem), {
            ...props,
            component: $9a69dc4ce603eb84$var$DropdownItemComponent,
            item: item
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a69dc4ce603eb84$var$DropdownItemComponent, props, item.name);
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9a69dc4ce603eb84$var$DropdownTrigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1lit _1e0c1o8l _vwz44jg8 _s7n41ndm _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});
$9a69dc4ce603eb84$var$DropdownTrigger.displayName = 'DropdownTrigger';

});

parcelRegister("fZIQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb08674ea00c4f6d$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $xdRNY = parcelRequire("xdRNY");

var $djQa4 = parcelRequire("djQa4");

var $5qhK4 = parcelRequire("5qhK4");

var $hc60A = parcelRequire("hc60A");
var $fkvsU = parcelRequire("fkvsU");

var $haEFN = parcelRequire("haEFN");

var $eVaiT = parcelRequire("eVaiT");

var $lqalZ = parcelRequire("lqalZ");

var $5JqpU = parcelRequire("5JqpU");

var $gS8e9 = parcelRequire("gS8e9");

var $8QKSg = parcelRequire("8QKSg");

var $gGtKh = parcelRequire("gGtKh");

var $6vrw7 = parcelRequire("6vrw7");
const $fb08674ea00c4f6d$var$withActivityFeedItemBoundary = (id)=>(WrappedComponent)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
                id: id,
                packageName: "issue"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
                name: "activity-feed-item-boundary",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.FeedContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xdRNY.default), null))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props)));

const $fb08674ea00c4f6d$var$AllActivity = $fb08674ea00c4f6d$var$withActivityFeedItemBoundary('activity-feed-all-activity')((0, $7rh0R.lazyForPaint)(()=>(parcelRequire("hsGiA")), {
    moduleId: "./src/packages/issue/issue-actions/issue-all-activity/src/index.tsx"
}));
$fb08674ea00c4f6d$var$AllActivity.displayName = 'AllActivity';

const $fb08674ea00c4f6d$var$History = $fb08674ea00c4f6d$var$withActivityFeedItemBoundary('activity-feed-item-history')((0, $7rh0R.lazyForPaint)(()=>(parcelRequire("fRJQb")), {
    moduleId: "./src/packages/issue/issue-actions/issue-history/src/index.tsx"
}));
$fb08674ea00c4f6d$var$History.displayName = 'History';

const $fb08674ea00c4f6d$var$Worklog = $fb08674ea00c4f6d$var$withActivityFeedItemBoundary('activity-feed-item-worklog')(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>(parcelRequire("eR41V")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view-activity/src/worklog/index.tsx"
}));
$fb08674ea00c4f6d$var$Worklog.displayName = 'Worklog';

const $fb08674ea00c4f6d$var$Approvals = $fb08674ea00c4f6d$var$withActivityFeedItemBoundary('activity-feed-item-approvals')((0, $7rh0R.lazyForPaint)(()=>(parcelRequire("53Pzf")), {
    moduleId: "./src/packages/issue/issue-actions/approval-activity/src/index.tsx"
}));
$fb08674ea00c4f6d$var$Approvals.displayName = 'Approvals';
const $fb08674ea00c4f6d$export$18796eda586fad5 = ({ selectedItem: selectedItem, baseUrl: baseUrl, issueKey: issueKey, timeZone: timeZone, selectedSortOrder: selectedSortOrder, extensionData: extensionData, source: source, mediaContext: mediaContext })=>{
    if (!selectedItem) return null;
    switch(selectedItem.type){
        case 0, $hc60A.ALL_ACTIVITY:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fb08674ea00c4f6d$var$AllActivity, {
                sortOrder: selectedSortOrder,
                mediaContext: mediaContext
            });
        case 0, $hc60A.COMMENTS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qhK4.default), null);
        case 0, $hc60A.CONNECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $haEFN.default), {
                appKey: selectedItem.appKey,
                moduleKey: selectedItem.moduleKey,
                options: selectedItem.options,
                appName: selectedItem.name,
                location: "issueActionsActivityFeed"
            });
        case 0, $fkvsU.FORGE_ENTITY_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eVaiT.default), {
                key: selectedItem.extension.id,
                source: source,
                extensionData: extensionData,
                extension: selectedItem.extension
            });
        case 0, $hc60A.HISTORY:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fb08674ea00c4f6d$var$History, {
                baseUrl: (0, $6vrw7.toBaseUrl)(baseUrl),
                issueKey: (0, $6vrw7.toIssueKey)(issueKey),
                timeZone: timeZone,
                sortOrder: selectedSortOrder
            });
        case 0, $hc60A.WORKLOG:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fb08674ea00c4f6d$var$Worklog, {
                timeZone: timeZone
            });
        case 0, $hc60A.APPROVALS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fb08674ea00c4f6d$var$Approvals, {
                issueKey: issueKey,
                sortOrder: selectedSortOrder
            });
        default:
            return null;
    }
};
const $fb08674ea00c4f6d$var$ConnectedComponent = (0, $lqalZ.connect)((state)=>({
        baseUrl: (0, $5JqpU.baseUrlSelector)(state),
        issueKey: (0, $5JqpU.issueKeySelector)(state),
        timeZone: undefined,
        extensionData: (0, $8QKSg.forgeIssueDataSelector)(state),
        source: (0, $5JqpU.analyticsSourceSelector)(state),
        mediaContext: (0, $gS8e9.mediaContextSelector)(state)
    }), {})($fb08674ea00c4f6d$export$18796eda586fad5);
var $fb08674ea00c4f6d$export$2e2bcd8739ae039 = $fb08674ea00c4f6d$var$ConnectedComponent;

});
parcelRegister("xdRNY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6da0de659ae0ee53$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");

var $hJ992 = parcelRequire("hJ992");

var $hCroN = parcelRequire("hCroN");

var $2xN2s = parcelRequire("2xN2s");

var $iMstM = parcelRequire("iMstM");

var $3o7jb = parcelRequire("3o7jb");

var $c75Wq = parcelRequire("c75Wq");

var $keOMr = parcelRequire("keOMr");

var $84CBi = parcelRequire("84CBi");
const $6da0de659ae0ee53$var$activityItemSkeleton = (isModal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6da0de659ae0ee53$var$AvatarWrapper, {
        isModal: isModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hCroN.default), {
        isModal: isModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6da0de659ae0ee53$var$Divider, {
        isModal: isModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xN2s.default), {
        isModal: isModal,
        paddingTop: 0,
        paddingBottom: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xN2s.default), {
        isModal: isModal,
        paddingTop: 1,
        paddingBottom: 5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c75Wq.default), {
        isModal: isModal,
        fontSize: 14,
        lineHeight: 16,
        intrusion: 250
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xN2s.default), {
        isModal: isModal,
        paddingTop: 4,
        paddingBottom: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c75Wq.default), {
        isModal: isModal,
        fontSize: 24,
        lineHeight: 24,
        intrusion: 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6da0de659ae0ee53$var$FillerMask, {
        isModal: isModal
    })));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6da0de659ae0ee53$export$2e2bcd8739ae039 = ()=>{
    const isModal = (0, $hJ992.useIsModal)();
    const isEmbedMode = (0, $keOMr.useIsEmbedMode)();
    const isLayered = isModal || isEmbedMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "activity-feed-skeleton"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6da0de659ae0ee53$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMstM.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6da0de659ae0ee53$var$FormContainer, {
        isModal: isLayered,
        paddingTop: 0,
        paddingBottom: 0
    }, $6da0de659ae0ee53$var$activityItemSkeleton(isLayered)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6da0de659ae0ee53$var$FormContainer, {
        isModal: isLayered,
        paddingTop: 0,
        paddingBottom: 0
    }, $6da0de659ae0ee53$var$activityItemSkeleton(isLayered))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6da0de659ae0ee53$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $3o7jb.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $6da0de659ae0ee53$var$FormContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $2xN2s.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $6da0de659ae0ee53$var$Divider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $iMstM.CleanDiv), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbrdoj _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $6da0de659ae0ee53$var$FillerMask = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $iMstM.CleanDiv), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3iqslr",
            __cmplp.className
        ])
    });
});
const $6da0de659ae0ee53$var$AvatarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1d0yzzt": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${(0, $c9TLT.gridSize) * 4}px solid ${__cmplp.isModal ? "var(--ds-surface-overlay, white)" : "var(--ds-surface, white)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n7zl1vzo _4t3i1ylp _1o9zidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hCroN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fde01c2e11a41db1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");
const $fde01c2e11a41db1$var$Avatar = ({ isModal: isModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "circle-cutout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "0",
        y: "0",
        width: "40",
        height: "40",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "18",
        cy: "18",
        r: "16",
        fill: "black"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "0",
        y: "0",
        width: "40",
        height: "40",
        mask: "url(#circle-cutout)",
        fill: isModal ? `var(--ds-surface-overlay, ${(0, $PdmhA).N0})` : `var(--ds-surface, ${(0, $PdmhA).N0})`
    }));
var $fde01c2e11a41db1$export$2e2bcd8739ae039 = $fde01c2e11a41db1$var$Avatar;

});


parcelRegister("djQa4", function(module, exports) {

$parcel$export(module.exports, "Emphasise", () => $43ac64dedb7ab423$export$e37ce51e697da8bf);
$parcel$export(module.exports, "GridContainer", () => $43ac64dedb7ab423$export$cc55614734af2d87);
$parcel$export(module.exports, "FeedContainer", () => $43ac64dedb7ab423$export$80ab5be5aa0a54ea);
$parcel$export(module.exports, "AdditionalHeaderContentPermalinkContainer", () => $43ac64dedb7ab423$export$b2b5c2b3066bf175);
$parcel$export(module.exports, "GridContentContainer", () => $43ac64dedb7ab423$export$61ddb209b0ea5e1);
$parcel$export(module.exports, "ActivityTimestampStyles", () => $43ac64dedb7ab423$export$b633a13c56e91288);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/styled/no-styled-export */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");
const $43ac64dedb7ab423$export$e37ce51e697da8bf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pbfng",
            __cmplp.className
        ])
    });
});
$43ac64dedb7ab423$export$e37ce51e697da8bf.displayName = 'Emphasise';
const $43ac64dedb7ab423$export$cc55614734af2d87 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ii7kb7n _18u01b66 _o5721q9c",
            __cmplp.className
        ])
    });
});
$43ac64dedb7ab423$export$cc55614734af2d87.displayName = 'GridContainer';
const $43ac64dedb7ab423$export$80ab5be5aa0a54ea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8gx6n",
            __cmplp.className
        ])
    });
});
const $43ac64dedb7ab423$export$d1ac28722bca370e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
$43ac64dedb7ab423$export$d1ac28722bca370e.displayName = 'TimestampContainer';
const $43ac64dedb7ab423$export$b2b5c2b3066bf175 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0r5cr _1e0c11p5",
            __cmplp.className
        ])
    });
});
const $43ac64dedb7ab423$export$61ddb209b0ea5e1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5",
            __cmplp.className
        ])
    });
});
$43ac64dedb7ab423$export$61ddb209b0ea5e1.displayName = 'GridContentContainer';
const $43ac64dedb7ab423$export$b633a13c56e91288 = {
    // @ts-expect-error - TS2322 - Type 'InterpolationValue[]' is not assignable to type 'string'.
    // eslint-disable-next-line jira/compiled/styled-components-usages
    always: (0, $kwce8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-subtle, ${(0, $PdmhA).N500})`
    }),
    // @ts-expect-error - TS2322 -Type 'InterpolationValue[]' is not assignable to type 'string'.
    // eslint-disable-next-line jira/compiled/styled-components-usages
    whenDisplaySettingSwitchable: (0, $kwce8.css)({
        ':hover': {
            color: 'inherit'
        }
    })
};

});

parcelRegister("5qhK4", function(module, exports) {

$parcel$export(module.exports, "default", () => $446f78f5028137ea$export$2e2bcd8739ae039);
/* comments-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2jDha = parcelRequire("2jDha");

var $hFmdR = parcelRequire("hFmdR");

var $7ZZxN = parcelRequire("7ZZxN");

var $0cdA8 = parcelRequire("0cdA8");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $8uD7Y = parcelRequire("8uD7Y");

var $4FTLi = parcelRequire("4FTLi");


var $4h3ZP = parcelRequire("4h3ZP");

var $cbjlv = parcelRequire("cbjlv");

var $9n6qV = parcelRequire("9n6qV");

var $hc60A = parcelRequire("hc60A");
var $eTy9x = parcelRequire("eTy9x");

var $eTy9x = parcelRequire("eTy9x");

var $kiT8o = parcelRequire("kiT8o");

var $lqalZ = parcelRequire("lqalZ");

var $lkPj1 = parcelRequire("lkPj1");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $gzLYm = parcelRequire("gzLYm");

var $9D3Vo = parcelRequire("9D3Vo");

var $dmojD = parcelRequire("dmojD");

var $9s86T = parcelRequire("9s86T");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");

var $jK1pm = parcelRequire("jK1pm");

var $2k5N2 = parcelRequire("2k5N2");

var $22kXV = parcelRequire("22kXV");

var $ff62D = parcelRequire("ff62D");
const $446f78f5028137ea$export$8cf44888942822ef = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s87f67",
            __cmplp.className
        ])
    });
});
class $446f78f5028137ea$export$434c217d363ea16 extends (0, $eUqFw.Component) {
    static{
        this.displayName = (0, $hc60A.COMMENTS);
    }
    static{
        this.defaultProps = {
            canAddComments: false
        };
    }
    componentDidMount() {
        const { fetchCommentVisibilities: fetchCommentVisibilities } = this.props;
        if ((0, $1ybV0.ff)('lower-comment-visibility-list-fetch') === false) fetchCommentVisibilities && fetchCommentVisibilities();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        // We fetch more comments when there are no comments left visible
        // but there are still comments available to be fetched (i.e. hidden)
        if (nextProps.loadedComments !== this.props.loadedComments && nextProps.loadedComments === 0 && nextProps.totalComments > 0) {
            if (nextProps.startIndex === 0) nextProps.fetchMoreOlderComments();
            else nextProps.fetchMoreNewerComments();
        }
        if (!nextProps.isLoadingMoreComments) this.setState({
            loadMoreButtonTypeClicked: undefined
        });
    }
    renderLoadOlderButton(numOlderCommentsToLoad) {
        const { isLoadingMoreComments: isLoadingMoreComments } = this.props;
        const { loadMoreButtonTypeClicked: loadMoreButtonTypeClicked } = this.state;
        const { onLoadOlderButtonClick: onLoadOlderButtonClick } = this;
        const isLoading = loadMoreButtonTypeClicked === (0, $eTy9x.LOAD_OLDER_BUTTON) && isLoadingMoreComments;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9n6qV.default), {
            onClick: onLoadOlderButtonClick,
            numberToLoad: numOlderCommentsToLoad,
            isDisabled: isLoadingMoreComments,
            isLoading: isLoading
        }, numOlderCommentsToLoad < (0, $eTy9x.NUM_PAGED_ITEMS_TO_LOAD) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            id: "issue.comments-view-sorted-older-remaining-comments-text-numberToLoad",
            defaultMessage: "View {numberToLoad, plural, one {1 older comment} other {{numberToLoad} remaining older comments}}",
            values: {
                numberToLoad: numOlderCommentsToLoad
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            id: "issue.comments-view-sorted-older-comments-text",
            defaultMessage: "View {numberToLoad, plural, one {1 older comment} other {{numberToLoad} older comments}}",
            values: {
                numberToLoad: numOlderCommentsToLoad
            }
        }));
    }
    renderLoadNewerButton(numNewerCommentsToLoad) {
        const { isLoadingMoreComments: isLoadingMoreComments } = this.props;
        const { loadMoreButtonTypeClicked: loadMoreButtonTypeClicked } = this.state;
        const { onLoadNewerButtonClick: onLoadNewerButtonClick } = this;
        const isLoading = loadMoreButtonTypeClicked === (0, $eTy9x.LOAD_NEWER_BUTTON) && isLoadingMoreComments;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9n6qV.default), {
            onClick: onLoadNewerButtonClick,
            numberToLoad: numNewerCommentsToLoad,
            isDisabled: isLoadingMoreComments,
            isLoading: isLoading
        }, numNewerCommentsToLoad < (0, $eTy9x.NUM_PAGED_ITEMS_TO_LOAD) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            id: "issue.comments-view-sorted-newer-remaining-comments-text-numberToLoad",
            defaultMessage: "View {numberToLoad, plural, one {1 newer comment} other {{numberToLoad} remaining newer comments}}",
            values: {
                numberToLoad: numNewerCommentsToLoad
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            id: "issue.comments-view-sorted-newer-comments-text",
            defaultMessage: "View {numberToLoad, plural, one {1 newer comment} other {{numberToLoad} newer comments}}",
            values: {
                numberToLoad: numNewerCommentsToLoad
            }
        }));
    }
    render() {
        const { commentIds: commentIds, canAddComments: canAddComments, totalComments: totalComments, loadedComments: loadedComments, fullIssueUrl: fullIssueUrl, startIndex: startIndex, loadingStage: loadingStage, selectedSortOrder: selectedSortOrder, projectType: projectType } = this.props;
        if (!commentIds.length && !canAddComments) return null;
        const { numPrevCommentsToLoad: numPrevCommentsToLoad, numNextCommentsToLoad: numNextCommentsToLoad } = (0, $kiT8o.calculateNumberOfCommentsToLoad)(totalComments, loadedComments, startIndex);
        const { hasPermalink: hasPermalink, permalinkId: permalinkId } = (0, $9s86T.getPermalinkStatus)((0, $hc60A.COMMENTS));
        const sortedList = commentIds.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, selectedSortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) && this.renderLoadNewerButton(numPrevCommentsToLoad), selectedSortOrder === (0, $25476979aca7c7e0$export$e86669f498228fff) && this.renderLoadOlderButton(numNextCommentsToLoad), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($446f78f5028137ea$export$8cf44888942822ef, {
            "data-testid": "issue.activity.comments-list"
        }, commentIds.map((commentId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4h3ZP.default), {
                key: commentId,
                commentId: commentId,
                fullIssueUrl: fullIssueUrl,
                isHighlighted: hasPermalink && commentId === permalinkId
            }))), selectedSortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) && this.renderLoadOlderButton(numNextCommentsToLoad), selectedSortOrder === (0, $25476979aca7c7e0$export$e86669f498228fff) && this.renderLoadNewerButton(numPrevCommentsToLoad)) : null;
        const renderSmartRequestSummaryEntryPointContainer = ()=>{
            if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) return (0, $2k5N2.isJsmSmartRequestSummaryEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22kXV.JsmSmartRequestSummaryEntryPointContainer), null);
            if (projectType === (0, $7ZZxN.SOFTWARE_PROJECT) || projectType === (0, $7ZZxN.CORE_PROJECT)) return (0, $1ybV0.ff)('issue.details.jira-smart-summary-platform_0jta9') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ff62D.IssueSmartRequestSummaryEntryPointContainer), null);
            return null;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderSmartRequestSummaryEntryPointContainer(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
            sourceName: "commentsActivityFeed"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cbjlv.default), {
            loadingStage: loadingStage,
            canAddComments: canAddComments,
            list: sortedList,
            numPrevCommentsToLoad: numPrevCommentsToLoad,
            selectedSortOrder: selectedSortOrder
        })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            loadMoreButtonTypeClicked: undefined
        };
        this.onLoadOlderButtonClick = (event, analyticsEvent)=>{
            const { fetchMoreOlderComments: fetchMoreOlderComments } = this.props;
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'loadMoreButtonClicked', {
                loadMoreButtonType: (0, $eTy9x.LOAD_OLDER_BUTTON)
            });
            this.setState({
                loadMoreButtonTypeClicked: (0, $eTy9x.LOAD_OLDER_BUTTON)
            });
            fetchMoreOlderComments();
        };
        this.onLoadNewerButtonClick = (event, analyticsEvent)=>{
            const { fetchMoreNewerComments: fetchMoreNewerComments } = this.props;
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'loadMoreButtonClicked', {
                loadMoreButtonType: (0, $eTy9x.LOAD_NEWER_BUTTON)
            });
            this.setState({
                loadMoreButtonTypeClicked: (0, $eTy9x.LOAD_NEWER_BUTTON)
            });
            fetchMoreNewerComments();
        };
    }
}
const $446f78f5028137ea$var$ConnectedComments = (0, $lqalZ.connect)((state)=>({
        commentIds: (0, $dmojD.sortedVisibleCommentIdsSelector)(state),
        canAddComments: (0, $dmojD.canAddCommentsSelector)(state),
        totalComments: (0, $dmojD.totalCommentsSelector)(state),
        startIndex: (0, $dmojD.startIndexCommentsSelector)(state),
        loadedComments: (0, $dmojD.loadedCommentsSelector)(state),
        isLoadingMoreComments: (0, $dmojD.isLoadingMoreCommentsSelector)(state),
        ...(0, $2k5N2.isJsmSmartRequestSummaryEnabled)() ? {
            projectType: (0, $jZDJX.projectTypeSelector)(state)
        } : {},
        // baseUrl, issueKey & shouldFetchCommentVisibilities are used in with-comment-visibilities.js
        baseUrl: (0, $5JqpU.baseUrlSelector)(state),
        issueKey: (0, $5JqpU.issueKeySelector)(state),
        shouldFetchCommentVisibilities: (0, $dmojD.isCommentVisibilityRestrictionSupportedSelector)(state),
        // fullIssueUrl for the comments permalink
        fullIssueUrl: (0, $9D3Vo.fullIssueUrlSelector)(state),
        loadingStage: (0, $dmojD.loadingStageSelector)(state),
        selectedSortOrder: (0, $gzLYm.getSelectedActivitySortOrder)(state)
    }), (dispatch)=>({
        fetchMoreOlderComments: ()=>{
            dispatch((0, $lkPj1.fetchOlderCommentsRequest)());
        },
        fetchMoreNewerComments: ()=>{
            dispatch((0, $lkPj1.fetchNewerCommentsRequest)());
        }
    }))((0, $4FTLi.default)($446f78f5028137ea$export$434c217d363ea16));
const $446f78f5028137ea$var$ConnectedCommentsWithAnalyticsSubject = (0, $hFmdR.AnalyticsSubject)('comment')(// @ts-expect-error - Argument of type 'ConnectedComponentClass<ComponentType<CommentVisibilitiesComponentProps<OwnProps & StateProps & DispatchProps>>, Omit<...>>' is not assignable to parameter of type 'JSXElementConstructor<WithAnalyticsEventsProps> & ComponentClass<Omit<CommentVisibilitiesComponentProps<OwnProps & StateProps & DispatchProps>, "baseUrl" | ... 12 more ... | "shouldFetchCommentVisibilities">, any> & { ...; }'.
(0, $2jDha.default)()($446f78f5028137ea$var$ConnectedComments));
const $446f78f5028137ea$var$IssueViewCommentNew = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "issue-view-comments"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "issue.issue-view.activity.comments",
        packageName: "jiraIssueViewActivity",
        teamName: "bento",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($446f78f5028137ea$var$ConnectedCommentsWithAnalyticsSubject, null)));
const $446f78f5028137ea$var$IssueViewCommentOld = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue.issue-view.activity.comments"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($446f78f5028137ea$var$ConnectedCommentsWithAnalyticsSubject, null));
var $446f78f5028137ea$export$2e2bcd8739ae039 = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('issue-comment-render_tt9jk', false), $446f78f5028137ea$var$IssueViewCommentNew, $446f78f5028137ea$var$IssueViewCommentOld);

});
parcelRegister("4FTLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $57d5e7e507f4a41e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kbe0n = parcelRequire("kbe0n");

var $6SC7J = parcelRequire("6SC7J");
const $57d5e7e507f4a41e$var$withCommentVisibilities = (WrappedComponent)=>(props)=>{
        const { baseUrl: baseUrl, issueKey: issueKey, shouldFetchCommentVisibilities: shouldFetchCommentVisibilities, createAnalyticsEvent: createAnalyticsEvent } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbe0n.default), {
            baseUrl: baseUrl,
            issueKey: issueKey,
            createAnalyticsEvent: createAnalyticsEvent,
            scope: issueKey,
            key: issueKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6SC7J.default), null, (_, { fetch: fetch })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                fetchCommentVisibilities: shouldFetchCommentVisibilities ? fetch : undefined
            })));
    };
var $57d5e7e507f4a41e$export$2e2bcd8739ae039 = $57d5e7e507f4a41e$var$withCommentVisibilities;

});
parcelRegister("kbe0n", function(module, exports) {

$parcel$export(module.exports, "default", () => $e87f52ae0fa298b3$export$2e2bcd8739ae039);

var $heB5U = parcelRequire("heB5U");

var $31iPz = parcelRequire("31iPz");
var $e87f52ae0fa298b3$export$2e2bcd8739ae039 = (0, $heB5U.createContainer)((0, $31iPz.default), {
    displayName: 'CommentVisibilitiesContainer'
});

});
parcelRegister("31iPz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca7c3ebb45d4d7ee$export$2e2bcd8739ae039);

var $a61MH = parcelRequire("a61MH");

var $jKgjg = parcelRequire("jKgjg");
const $ca7c3ebb45d4d7ee$export$d4c72bab9d6cc13a = {
    data: null,
    loading: false,
    error: null
};
var $ca7c3ebb45d4d7ee$export$2e2bcd8739ae039 = (0, $a61MH.createStore)({
    name: 'issue-view-comment-visibilities',
    initialState: $ca7c3ebb45d4d7ee$export$d4c72bab9d6cc13a,
    actions: $jKgjg.default
});

});
parcelRegister("jKgjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d8fc239ada76b1e$export$2e2bcd8739ae039);

var $2Hkzr = parcelRequire("2Hkzr");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8d8fc239ada76b1e$export$2e2bcd8739ae039 = {
    fetch: $2Hkzr.default
};

});
parcelRegister("2Hkzr", function(module, exports) {

$parcel$export(module.exports, "default", () => $99152fb12fa20ac8$export$2e2bcd8739ae039);


var $3A3OQ = parcelRequire("3A3OQ");

var $jMP2a = parcelRequire("jMP2a");

var $7anu7 = parcelRequire("7anu7");
const $99152fb12fa20ac8$var$logError = (error)=>{
    (0, $3A3OQ.trackOrLogClientError)('issue.fetch.comment-visibilities', 'An error occurred attempting to fetch comment visibilities from gira', error);
};
const $99152fb12fa20ac8$var$sendCommentVisibilityAnalytics = (// @ts-expect-error - TS2304 - Cannot find name 'AnalyticsEvent'.
createAnalyticsEvent, // @ts-expect-error - TS2304 - Cannot find name 'CommentVisibility'.
commentVisibilities)=>{
    const analyticsEvent = createAnalyticsEvent({
        action: 'fetched'
    });
    const commentVisibilityStats = {
        totalCount: commentVisibilities.length,
        roleCount: commentVisibilities.filter((commentVisibility)=>commentVisibility.type === (0, $b9bd3ab49fd3c4c9$export$28a8bb936dce2def)).length,
        groupCount: commentVisibilities.filter((commentVisibility)=>commentVisibility.type === (0, $b9bd3ab49fd3c4c9$export$537a061b2f9c8800)).length
    };
    (0, $jMP2a.fireOperationalAnalyticsDeferred)(analyticsEvent, 'commentVisibilities fetched', commentVisibilityStats);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$99152fb12fa20ac8$export$2e2bcd8739ae039 = ()=>async ({ getState: getState, setState: setState }, { issueKey: issueKey, baseUrl: baseUrl, createAnalyticsEvent: createAnalyticsEvent })=>{
        const currentState = getState();
        if (currentState.loading || currentState.error || currentState.data) return;
        setState({
            loading: true,
            error: null,
            data: null
        });
        try {
            const commentVisibilities = await (0, $7anu7.fetchCommentVisibilities)(baseUrl, issueKey);
            setState({
                loading: false,
                error: null,
                data: {
                    commentVisibilities: commentVisibilities
                }
            });
            $99152fb12fa20ac8$var$sendCommentVisibilityAnalytics(createAnalyticsEvent, commentVisibilities);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            $99152fb12fa20ac8$var$logError(error);
            setState({
                loading: false,
                error: error,
                data: null
            });
        }
    };

});
parcelRegister("7anu7", function(module, exports) {

$parcel$export(module.exports, "fetchCommentVisibilities", () => $1af26b01e075cca5$export$f0e1b4b790c7c8ca);

var $kXzsJ = parcelRequire("kXzsJ");

var $hhPjP = parcelRequire("hhPjP");

var $dH8ya = parcelRequire("dH8ya");

const $1af26b01e075cca5$var$transformData = (jiraCommentVisibilities)=>jiraCommentVisibilities.map((edge)=>(0, $hhPjP.transformJiraCommentVisibility)(edge.node));
const $1af26b01e075cca5$export$f0e1b4b790c7c8ca = async (baseUrl, issueKey)=>{
    const { errors: errors, data: data } = await (0, $kXzsJ.getClient)(baseUrl).query({
        query: (0, $dH8ya.commentVisibilitiesQuery),
        variables: {
            issueKey: issueKey
        }
    });
    if (errors) throw new Error((0, $83b90fd5aa4f6299$export$b2f70af5a5c18e45));
    if (data?.viewIssue?.jiraCommentVisibilities) {
        const transformedData = $1af26b01e075cca5$var$transformData(data.viewIssue.jiraCommentVisibilities.edges);
        return transformedData;
    }
    throw new Error((0, $83b90fd5aa4f6299$export$13ec698b470de206));
};

});
const $83b90fd5aa4f6299$export$b2f70af5a5c18e45 = 'GraphqlErrorResponse';
const $83b90fd5aa4f6299$export$13ec698b470de206 = 'GraphqlNullData';






parcelRegister("6SC7J", function(module, exports) {

$parcel$export(module.exports, "default", () => $3356a423ea49d97b$export$2e2bcd8739ae039);

var $dYfll = parcelRequire("dYfll");

var $31iPz = parcelRequire("31iPz");
var $3356a423ea49d97b$export$2e2bcd8739ae039 = (0, $dYfll.createSubscriber)((0, $31iPz.default), {
    displayName: 'CommentVisibilitiesSubscriber'
});

});


parcelRegister("4h3ZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bfeb72a971b273d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $eGI9v = parcelRequire("eGI9v");
var $8un0w = parcelRequire("8un0w");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $cp79T = parcelRequire("cp79T");

var $lkPj1 = parcelRequire("lkPj1");

var $hG9XE = parcelRequire("hG9XE");

var $1GZlZ = parcelRequire("1GZlZ");

var $kzOoN = parcelRequire("kzOoN");

var $cv7ro = parcelRequire("cv7ro");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $gS8e9 = parcelRequire("gS8e9");

var $dgIQq = parcelRequire("dgIQq");

var $eW7lD = parcelRequire("eW7lD");


var $dmojD = parcelRequire("dmojD");

var $cY77j = parcelRequire("cY77j");

var $aVgcg = parcelRequire("aVgcg");

var $dMR0q = parcelRequire("dMR0q");

var $gGtKh = parcelRequire("gGtKh");

const $8bfeb72a971b273d$var$LazyIssueComment = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("iNbuy")), {
    moduleId: "./src/packages/issue/issue-actions/issue-comment-base/src/index.tsx"
});
const $8bfeb72a971b273d$var$IssueComment = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-comment",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8bfeb72a971b273d$var$LazyIssueComment, props));
const $8bfeb72a971b273d$export$d62f28fdecfe27b6 = (props)=>{
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "comment-item",
        packageName: "issue",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8bfeb72a971b273d$var$IssueComment, {
        ...props,
        intl: intl
    }));
};
const $8bfeb72a971b273d$var$isNewComment = (commentId)=>commentId.includes((0, $b10b5cb385fb5d46$export$c4134c813c47beb0));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8bfeb72a971b273d$var$getExtractionStateProps = (state, commentId)=>({
        baseUrl: (0, $5JqpU.baseUrlSelector)(state),
        isReactionsFeatureActive: (0, $dgIQq.shouldShowReactionsSelector)(state),
        issueAri: (0, $jZDJX.issueAriSelector)(state),
        commentAri: (0, $dgIQq.commentAriSelector)(commentId)(state),
        projectType: (0, $jZDJX.projectTypeSelector)(state),
        mentionProvider: (0, $cp79T.mentionProviderSelector)(state),
        mediaContext: (0, $gS8e9.mediaContextSelector)(state),
        contextIdentifier: (0, $cv7ro.memoizedContextIdentifierSelector)(state, commentId),
        sharedAtTimestamp: (0, $dMR0q.getTimestampForSharingAsComment)(state),
        sharedValue: (0, $dMR0q.getValueForSharingAsComment)(state),
        activityProvider: (0, $kzOoN.activityProviderSelector)(state)
    });
const $8bfeb72a971b273d$var$getExtractionDispatchProps = (dispatch)=>({
        onEditorExpandedFailure: ()=>{
            dispatch((0, $hG9XE.editorExpandedFailure)());
        },
        onEditorSaveFailure: ()=>{
            dispatch((0, $hG9XE.editorSaveFailure)());
        },
        onEditorClearSharedValues: ()=>{
            dispatch((0, $1GZlZ.clearSharedAsCommentValues)());
        }
    });
var $8bfeb72a971b273d$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $eGI9v.default)('issueFields', {
    onEditSave: 'updated',
    onDeleteConfirm: 'deleted',
    onScrolledToPermalink: 'scrolled'
}), (0, $8un0w.default)({
    onCopyClick: 'copyCommentUrl'
}), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ commentId: string; isHighlighted: boolean; issueAri?: string | null | undefined; isReactionsFeatureActive?: boolean | undefined; baseUrl?: string | undefined; projectType?: "software" | ... 4 more ... | undefined; ... 55 more ...; intl?: IntlShape | undefined; }, { ...; }>' is not assignable to parameter of type 'FlowStep<WithUIAnalyticsEvent<PropsWithoutRef<Omit<{ [K in keyof Props]: K extends "onEditSave" | "onDeleteConfirm" | "onScrolledToPermalink" ? (...args: [...Parameters<Props[K]>, UIAnalyticsEvent]) => ReturnType<...> : Props[K]; }, keyof WithAnalyticsEventsProps>>, { ...; }>, ConnectedComponent<...>>'.
(0, $lqalZ.connect)((initialState, { commentId: commentId })=>(state, { isHighlighted: isHighlighted })=>({
            jsdAuthorCanSeeRequest: (0, $dmojD.commentOutsiderCommentSelector)(commentId)(state),
            bodyAdf: (0, $dmojD.commentEditingOrViewBodyAdfSelector)(commentId)(state),
            bodyHtml: (0, $dmojD.commentBodyHtmlSelector)(commentId)(state),
            hasDraft: (0, $cY77j.fieldHasDraftSelector)((0, $eW7lD.createCommentDraftKey)(commentId))(state),
            author: (0, $dmojD.commentAuthorSelector)(commentId)(state),
            updateAuthor: (0, $dmojD.commentUpdateAuthorSelector)(commentId)(state),
            createdDate: (0, $dmojD.commentCreatedDateSelector)(commentId)(state),
            updatedDate: (0, $dmojD.commentUpdatedDateSelector)(commentId)(state),
            edited: (0, $dmojD.commentEditedSelector)(commentId)(state),
            isOptimistic: (0, $dmojD.commentIsOptimisticSelector)(commentId)(state),
            hasSaveFailed: (0, $dmojD.commentSaveFailedSelector)(commentId)(state),
            canEdit: (0, $dmojD.canEditCommentSelector)(commentId)(state),
            isEditing: (0, $dmojD.isEditingCommentSelector)(commentId)(state),
            canDelete: (0, $dmojD.canDeleteCommentSelector)(commentId)(state),
            hasDeleteModal: (0, $dmojD.commentHasDeleteModalSelector)(commentId)(state),
            visibility: (0, $dmojD.commentVisibilitySelector)(commentId)(state),
            visibilityEdited: (0, $dmojD.commentEditingOrViewVisibilitySelector)(commentId)(state),
            isInternal: (0, $dmojD.isInternalCommentSelector)(commentId)(state),
            isEditingInternal: (0, $dmojD.isEditingInternalCommentSelector)(commentId)(state),
            eventOccurredAt: (0, $dmojD.commentEventOccurredAtSelector)(commentId)(state),
            jsdIncidentActivityViewHidden: (0, $dmojD.commentJsdIncidentActivityViewHiddenSelector)(commentId)(state),
            showReactions: (0, $dgIQq.shouldShowReactionsSelector)(state),
            shouldShowCommentVisibility: (0, $dmojD.isCommentVisibilityRestrictionSupportedSelector)(state),
            // checks whether certain async components that may affect comment scroll has finished loading.
            shouldScrollAfterAsyncComponentsLoaded: isHighlighted && (0, $aVgcg.isIssueRemoteDataLoadingCompleteSelector)(state),
            // whether permalink scroll has occured. Need to not scroll again if user resizes to single column view or vice versa
            hasScrolledPermalink: (0, $dmojD.hasScrolledPermalinkCommentSelector)(state),
            ...$8bfeb72a971b273d$var$getExtractionStateProps(state, commentId)
        }), (dispatch, { commentId: commentId })=>({
        getOnEditClick: (isInternal)=>dispatch((0, $lkPj1.editCommentBegin)(commentId, isInternal)),
        onEditCancel: ()=>dispatch((0, $lkPj1.editCommentCancel)(commentId)),
        onEditUpdate: (editValue)=>dispatch((0, $lkPj1.editCommentUpdate)(commentId, editValue)),
        onEditPaste: (pastedContent)=>dispatch((0, $lkPj1.pastedIntoCommentForm)(commentId, pastedContent)),
        onBlur: ()=>dispatch((0, $lkPj1.editCommentCollapse)(commentId)),
        getOnEditSave: (eventData, analyticsEvent)=>dispatch((0, $lkPj1.saveCommentRequest)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                id: commentId,
                ...eventData
            }, analyticsEvent)),
        onCommentVisibilityChange: (visibility)=>{
            dispatch((0, $lkPj1.editCommentVisibility)(commentId, visibility));
        },
        onDeleteClick: ()=>dispatch((0, $lkPj1.showDeleteCommentModal)(commentId)),
        getOnDeleteConfirm: (analyticsEvent)=>dispatch((0, $lkPj1.deleteCommentRequest)(commentId, analyticsEvent)),
        onDeleteCancel: ()=>dispatch((0, $lkPj1.deleteCommentCancel)()),
        onSaveRetry: ()=>dispatch((0, $lkPj1.saveCommentRetry)(commentId, new Date().toISOString(), $8bfeb72a971b273d$var$isNewComment(commentId))),
        onSaveEdit: ()=>dispatch((0, $lkPj1.saveCommentEdit)(commentId)),
        onSaveCancel: ()=>dispatch((0, $lkPj1.saveCommentCancel)(commentId)),
        setScrollStatus: (status)=>dispatch((0, $lkPj1.setCommentScrollStatus)(status)),
        ...$8bfeb72a971b273d$var$getExtractionDispatchProps(dispatch)
    }), // WARNING !!!
//
// DO NOT merge props. The underlying comment has been optimised and removed it from the
// connected component.
//
(stateProps, dispatchProps, ownProps)=>({
        ...stateProps,
        ...dispatchProps,
        ...ownProps
    })))($8bfeb72a971b273d$export$d62f28fdecfe27b6);

});
parcelRegister("kzOoN", function(module, exports) {

$parcel$export(module.exports, "activityProviderSelector", () => $d518fe43a894dd5b$export$214e8cd47f3c92cd);

var $df4Sl = parcelRequire("df4Sl");

var $h040W = parcelRequire("h040W");

var $5JqpU = parcelRequire("5JqpU");
const $d518fe43a894dd5b$var$ACTIVITY_URL = '/gateway/api/graphql';
const $d518fe43a894dd5b$export$214e8cd47f3c92cd = (0, $df4Sl.createSelector)((0, $5JqpU.cloudIdSelector), (cloudId)=>new (0, $h040W.default)($d518fe43a894dd5b$var$ACTIVITY_URL, cloudId));

});
parcelRegister("h040W", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6058ce7dcc2a98a$export$2e2bcd8739ae039);

var $jbNLw = parcelRequire("jbNLw");

var $9glAq = parcelRequire("9glAq");
/**
 * Currently the underlying FE service can only retrieve the first page of results, which is limited at 100 results.
 * See ACT-3418 for upcoming fix.
 */ const $c6058ce7dcc2a98a$var$DEFAULT_ACTIVITY_COUNT = 100;
class $c6058ce7dcc2a98a$export$2e2bcd8739ae039 {
    /**
   *
   * @param url
   * @param cloudId - this will be transformed into an ARI
   * @param options - @deprecated this is no longer used
   */ constructor(url, cloudId, options = {}){
        this.cloudId = `ari:cloud:platform::site/${cloudId}`;
        this.client = (0, $jbNLw.createActivityClient)('v3', 'editor', undefined, url);
    }
    async getRecentItems(limit = $c6058ce7dcc2a98a$var$DEFAULT_ACTIVITY_COUNT) {
        if (!this.recentPromise) this.recentPromise = this.client.fetchActivities([
            50
        ], {
            rootContainerIds: [
                this.cloudId
            ],
            limit: limit
        }, [
            'viewed'
        ]);
        try {
            const response = await this.recentPromise;
            return response.viewed.map((node)=>{
                var _node$object$icon, _node$object$icon2;
                return {
                    objectId: node.object.id,
                    name: node.object.name || '',
                    container: this.getContainerName(node.containers),
                    url: node.object.url,
                    iconUrl: ((_node$object$icon = node.object.icon) === null || _node$object$icon === void 0 ? void 0 : _node$object$icon.type) === 'EMOJI' && node.object.icon.fallback ? node.object.icon.fallback : ((_node$object$icon2 = node.object.icon) === null || _node$object$icon2 === void 0 ? void 0 : _node$object$icon2.value) || '',
                    type: node.object.type,
                    viewedTimestamp: node.timestamp
                };
            }).filter((item)=>Boolean(item.name));
        } catch (err) {
            throw new (0, $9glAq.ActivityError)(err.message, err.code);
        }
    }
    async searchRecent(query) {
        const items = await this.getRecentItems();
        return this.filterItems(items, query);
    }
    /**
   * It should return the closet container's name
   */ getContainerName(containers) {
        for(let i = containers.length - 1; i >= 0; --i){
            const containerName = containers[i].name;
            if (containerName) return containerName;
        }
        return '';
    }
    filterItems(items, searchTerm) {
        if (!searchTerm) return [];
        return items.filter((item)=>{
            var _item$name, _item$name$toLowerCas;
            return (_item$name = item.name) === null || _item$name === void 0 ? void 0 : (_item$name$toLowerCas = _item$name.toLowerCase()) === null || _item$name$toLowerCas === void 0 ? void 0 : _item$name$toLowerCas.includes(searchTerm.toLowerCase());
        });
    }
}

});
parcelRegister("9glAq", function(module, exports) {

$parcel$export(module.exports, "ActivityError", () => $6be65a4f0661c477$export$16bbef74695765fd);
class $6be65a4f0661c477$export$16bbef74695765fd extends Error {
    constructor(message, status){
        super(message);
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $6be65a4f0661c477$export$16bbef74695765fd.prototype);
        this.status = status;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}

});



parcelRegister("cv7ro", function(module, exports) {

$parcel$export(module.exports, "contextIdentifierSelector", () => $db651153d48d5980$export$e7b98f351757f9e8);
$parcel$export(module.exports, "memoizedContextIdentifierSelector", () => $db651153d48d5980$export$99bf3c0aef0a8445);

var $df4Sl = parcelRequire("df4Sl");

var $jqvCZ = parcelRequire("jqvCZ");


var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");
const $db651153d48d5980$var$commentIdSelector = (state, { commentId: commentId })=>commentId || (0, $b10b5cb385fb5d46$export$c4134c813c47beb0);
const $db651153d48d5980$var$contextIdentifierSelectorResultFn = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((issueId, containerId, childObjectId)=>({
        objectId: issueId,
        containerId: containerId,
        childObjectId: childObjectId
    }), (...args)=>args.join('_'));
const $db651153d48d5980$export$e7b98f351757f9e8 = (0, $df4Sl.createSelector)((0, $5JqpU.issueIdSelector), (0, $jZDJX.projectIdSelector), $db651153d48d5980$var$commentIdSelector, (issueId, containerId, childObjectId)=>$db651153d48d5980$var$contextIdentifierSelectorResultFn(issueId, containerId, childObjectId));
// sadly there is no easy way to reuse the list of arguments:
// https://stackoverflow.com/questions/46596235/flow-generic-type-for-function-expression-arrow-functions
const $db651153d48d5980$var$memoizeContextIdentifierObject = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((issueId, projectId, commentId)=>({
        objectId: String(issueId),
        containerId: String(projectId),
        ...typeof commentId === 'string' && {
            childObjectId: commentId
        }
    }), (issueId, projectId, commentId)=>`${String(issueId)}-${String(projectId)}-${String(commentId)}`);
const $db651153d48d5980$export$99bf3c0aef0a8445 = (state, commentId)=>{
    const { objectId: objectId, containerId: containerId, childObjectId: childObjectId } = $db651153d48d5980$export$e7b98f351757f9e8(state, {
        commentId: commentId
    });
    return $db651153d48d5980$var$memoizeContextIdentifierObject(objectId, containerId, childObjectId);
};

});

parcelRegister("dgIQq", function(module, exports) {

$parcel$export(module.exports, "commentAriSelector", () => $25dc12d11a4e56e6$export$b600fd41c88f35c8);
$parcel$export(module.exports, "shouldShowReactionsSelector", () => $25dc12d11a4e56e6$export$595ba3a824affd54);

var $df4Sl = parcelRequire("df4Sl");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");
const $25dc12d11a4e56e6$export$b600fd41c88f35c8 = (commentId)=>(0, $df4Sl.createSelector)((0, $jZDJX.baseAriSelector), (baseAri)=>{
        if (!baseAri || !commentId) return null;
        return `${baseAri}:comment/${commentId}`;
    });
const $25dc12d11a4e56e6$export$595ba3a824affd54 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (0, $5JqpU.cloudIdSelector), (permissions, cloudId)=>!!(permissions.canAddComments && cloudId));

});

parcelRegister("cY77j", function(module, exports) {

$parcel$export(module.exports, "fieldHasDraftSelector", () => $39d630122285797e$export$399d80068f240c24);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $39d630122285797e$export$16dcbd7c208b86e1 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.drafts);
const $39d630122285797e$export$399d80068f240c24 = (fieldId)=>(0, $df4Sl.createSelector)($39d630122285797e$export$16dcbd7c208b86e1, (drafts)=>!!drafts[fieldId]);

});

parcelRegister("aVgcg", function(module, exports) {

$parcel$export(module.exports, "isIssueRemoteDataLoadingCompleteSelector", () => $37e3f8c1f16eaff6$export$f8309130a0175daf);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $37e3f8c1f16eaff6$var$issueRemoteDataSelector = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.issueRemoteData);
const $37e3f8c1f16eaff6$export$f8309130a0175daf = (0, $df4Sl.createSelector)($37e3f8c1f16eaff6$var$issueRemoteDataSelector, (issueRemoteData)=>issueRemoteData.isLoadingComplete);

});

parcelRegister("dMR0q", function(module, exports) {

$parcel$export(module.exports, "getValueForSharingAsComment", () => $3f116406aec90558$export$6d3010314bcab531);
$parcel$export(module.exports, "getTimestampForSharingAsComment", () => $3f116406aec90558$export$8b1df3c94dcc37b3);

var $df4Sl = parcelRequire("df4Sl");
const $3f116406aec90558$var$shareAsCommentSelector = (state)=>state.shareAsComment;
const $3f116406aec90558$export$6d3010314bcab531 = (0, $df4Sl.createSelector)($3f116406aec90558$var$shareAsCommentSelector, (shareAsComment)=>shareAsComment.value);
const $3f116406aec90558$export$8b1df3c94dcc37b3 = (0, $df4Sl.createSelector)($3f116406aec90558$var$shareAsCommentSelector, (shareAsComment)=>shareAsComment.timestamp);

});

parcelRegister("iNbuy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8vjEc');
        const value = parcelRequire('jbwVk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8vjEc").then(()=>parcelRequire('jbwVk'));
}

});


parcelRegister("cbjlv", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c747f7a143df1a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8sN8t = parcelRequire("8sN8t");


var $aQy8T = parcelRequire("aQy8T");


var $f6MOn = parcelRequire("f6MOn");

var $kS8l2 = parcelRequire("kS8l2");

var $djQa4 = parcelRequire("djQa4");

var $xdRNY = parcelRequire("xdRNY");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$34c747f7a143df1a$export$2e2bcd8739ae039 = (props)=>{
    const { list: list, loadingStage: loadingStage, canAddComments: canAddComments, numPrevCommentsToLoad: numPrevCommentsToLoad, selectedSortOrder: selectedSortOrder } = props;
    const [, { register: register }] = (0, $kS8l2.useGlobalRefStoreActions)();
    const onRef = (0, $eUqFw.useCallback)((ref)=>{
        register((0, $ab3fc2ac1a2f2638$export$6f48b612d5c03f4d), ref);
    }, [
        register
    ]);
    const onCommentActionRef = (0, $eUqFw.useCallback)((ref)=>{
        register((0, $ab3fc2ac1a2f2638$export$75867eab2abae162), ref);
    }, [
        register
    ]);
    // Note: since the comments feed is only being fetched with orderBy="-created",
    // we can assume numPrevCommentsToLoad will always represents the number of
    // OLDER comments to load. With a dynamic orderBy value, we normally cannot
    // make this assumption as orderBy="created" would result in numPrevCommentsToLoad
    // to be the number of NEWER comments more to load.
    const isLatestCommentNotVisible = numPrevCommentsToLoad > 0;
    if (loadingStage === (0, $f6MOn.LOADING) || loadingStage === (0, $f6MOn.SAVE_COMMENT_LOADING) && isLatestCommentNotVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.FeedContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xdRNY.default), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
        name: (0, $ab3fc2ac1a2f2638$export$6f48b612d5c03f4d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($34c747f7a143df1a$var$RefWrapper, {
        ref: onRef
    }), " "), !canAddComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
        name: (0, $ab3fc2ac1a2f2638$export$75867eab2abae162)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($34c747f7a143df1a$var$RefWrapper, {
        ref: onCommentActionRef
    })), canAddComments && selectedSortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aQy8T.default), null), list, canAddComments && selectedSortOrder === (0, $25476979aca7c7e0$export$e86669f498228fff) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aQy8T.default), null));
};
// eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $34c747f7a143df1a$var$RefWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aQy8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdcb520927dcd368$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $eGI9v = parcelRequire("eGI9v");

var $2ijRB = parcelRequire("2ijRB");

var $1ybV0 = parcelRequire("1ybV0");

var $j3Xcx = parcelRequire("j3Xcx");

var $4y397 = parcelRequire("4y397");

var $2wCUM = parcelRequire("2wCUM");

var $f6MOn = parcelRequire("f6MOn");

var $5G3JL = parcelRequire("5G3JL");

var $bm1XB = parcelRequire("bm1XB");

var $lBMPF = parcelRequire("lBMPF");

var $lqalZ = parcelRequire("lqalZ");

var $lkPj1 = parcelRequire("lkPj1");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $eW7lD = parcelRequire("eW7lD");

var $gzLYm = parcelRequire("gzLYm");

var $9D3Vo = parcelRequire("9D3Vo");


var $dmojD = parcelRequire("dmojD");

var $cY77j = parcelRequire("cY77j");

var $jMP2a = parcelRequire("jMP2a");

var $1TrR5 = parcelRequire("1TrR5");

var $2StPr = parcelRequire("2StPr");

var $lGT7F = parcelRequire("lGT7F");
const $bdcb520927dcd368$var$isCannedResponseEnabled = (state)=>{
    const isServiceDesk = (0, $5JqpU.isServiceDeskSelector)(state);
    const isMobile = (0, $5JqpU.isMobileSelector)(state);
    const isAdminOrAgent = (0, $9F6MO.canAdministerJiraPermissionsSelector)(state) || (0, $9F6MO.canAdministerProjectPermissionsSelector)(state) || (0, $9F6MO.canUseServiceDeskAgentFeaturesSelector)(state);
    return (0, $2StPr.isCannedResponseFFEnabled)() && isServiceDesk && !isMobile && isAdminOrAgent;
};
const $bdcb520927dcd368$var$mapStateToProps = (state)=>({
        authorId: (0, $5JqpU.accountIdloggedInUserSelector)(state),
        avatarUrl: (0, $jZDJX.loggedInUserAvatarUrlSelector)(state),
        displayName: (0, $jZDJX.loggedInUserDisplayNameSelector)(state),
        newCommentDraft: (0, $dmojD.commentEditingOrViewBodyAdfSelector)((0, $b10b5cb385fb5d46$export$c4134c813c47beb0))(state),
        hasDraft: (0, $cY77j.fieldHasDraftSelector)((0, $eW7lD.createCommentDraftKey)((0, $b10b5cb385fb5d46$export$c4134c813c47beb0)))(state),
        // We should expand if we have explicitly requested expansion
        // or if we have currently have a draft
        isExpanded: (0, $dmojD.isAddCommentEditorExpandedSelector)(state) || (0, $dmojD.commentEditingBodySelector)((0, $b10b5cb385fb5d46$export$c4134c813c47beb0))(state) != null,
        forceFocus: (0, $dmojD.addCommentEditorForceFocusSelector)(state),
        isServiceDesk: (0, $5JqpU.isServiceDeskSelector)(state),
        isEditorFocused: (0, $fokFV.isRichTextFieldEditingSelector)(state) || (0, $dmojD.isEditingAnyCommentSelector)(state),
        isLoading: (0, $5JqpU.isServiceDeskSelector)(state) && (0, $dmojD.isCommentAttachmentInProgressSelector)(state),
        shouldShowCommentVisibilitySelect: (0, $dmojD.isCommentVisibilityRestrictionSupportedSelector)(state),
        visibility: (0, $dmojD.commentEditingVisibilitySelector)((0, $b10b5cb385fb5d46$export$c4134c813c47beb0))(state) || (0, $f6MOn.COMMENT_VISIBILITY_PUBLIC),
        sortOrder: (0, $gzLYm.getSelectedActivitySortOrder)(state),
        eventOccurredAt: (0, $dmojD.commentEditingEventOccurredAtSelector)((0, $b10b5cb385fb5d46$export$c4134c813c47beb0))(state) || null,
        isEditingInternal: (0, $dmojD.isEditingInternalCommentSelector)((0, $b10b5cb385fb5d46$export$c4134c813c47beb0))(state),
        fullIssueUrl: (0, $9D3Vo.fullIssueUrlSelector)(state),
        isCannedResponseEnabled: $bdcb520927dcd368$var$isCannedResponseEnabled(state)
    });
const $bdcb520927dcd368$var$mapDispatchToProps = (dispatch)=>({
        onExpand: ()=>dispatch((0, $lkPj1.addCommentFormExpand)()),
        onEdit: (value)=>dispatch((0, $lkPj1.editCommentUpdate)((0, $b10b5cb385fb5d46$export$c4134c813c47beb0), value)),
        onVisibilityChange: (visibility)=>dispatch((0, $lkPj1.editCommentVisibility)((0, $b10b5cb385fb5d46$export$c4134c813c47beb0), visibility)),
        onPaste: (pastedContent)=>dispatch((0, $lkPj1.pastedIntoCommentForm)((0, $b10b5cb385fb5d46$export$c4134c813c47beb0), pastedContent)),
        onBlur: ()=>dispatch((0, $lkPj1.addCommentFormCollapse)()),
        onCancel: ()=>dispatch((0, $lkPj1.addCommentFormCancel)()),
        onEventOccurredAtChange: (eventOccurredAt)=>{
            dispatch((0, $lkPj1.editCommentEventOccurredAt)((0, $b10b5cb385fb5d46$export$c4134c813c47beb0), eventOccurredAt));
        },
        getOnSave: (eventData, analyticsEvent)=>dispatch((0, $lkPj1.saveCommentRequest)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                id: `${(0, $b10b5cb385fb5d46$export$c4134c813c47beb0)}_${new Date().getTime()}`,
                createdDate: new Date().toISOString(),
                isNewComment: true,
                ...eventData
            }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            analyticsEvent))
    });
const $bdcb520927dcd368$var$mergePropsOld = (stateProps, dispatchProps, ownProps)=>{
    const jsmTimelineComponents = (0, $2StPr.isJsmTimelineEnabled)() && stateProps.isEditingInternal ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4y397.EventOccurredAtSelector), {
            key: "eventOccurredAtSelector",
            initialValue: stateProps.eventOccurredAt,
            onChange: (eventOccurredAt)=>{
                dispatchProps.onEventOccurredAtChange(eventOccurredAt);
            }
        })
    ] : [];
    const shouldShowCommentVisibility = (0, $1ybV0.ff)('jsm-restrict-internal-comment-visibility') ? stateProps.shouldShowCommentVisibilitySelect && stateProps.isEditingInternal : stateProps.shouldShowCommentVisibilitySelect;
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        editorSecondaryToolbarComponents: shouldShowCommentVisibility ? [
            ...jsmTimelineComponents,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j3Xcx.default), {
                key: "commentVisibilitySelect",
                initialValue: stateProps.visibility,
                onChange: dispatchProps.onVisibilityChange
            })
        ] : jsmTimelineComponents,
        onSave: (value, analyticsEvent)=>{
            if ((0, $1ybV0.ff)('sea-2350-analytics-for-mentions-in-board-and-backlog_2gkji')) {
                if (value?.content) {
                    const mentions = (0, $bm1XB.findMentionsInAdfContent)(value.content);
                    analyticsEvent.update({
                        mentionedUserIds: mentions.map((mention)=>mention.attrs.id)
                    });
                }
            }
            stateProps.eventOccurredAt ? analyticsEvent.update({
                isEventOccurredAtSelected: true
            }) : analyticsEvent.update({
                isEventOccurredAtSelected: false
            });
            if (stateProps.shouldShowCommentVisibilitySelect) analyticsEvent.update({
                isCommentRestricted: stateProps.visibility.type !== (0, $b9bd3ab49fd3c4c9$export$a3863626f98a38c2)
            });
            dispatchProps.getOnSave({
                authorId: stateProps.authorId,
                bodyAdf: value,
                bodyHtml: undefined,
                richContent: undefined,
                visibility: stateProps.visibility,
                ...(0, $2StPr.isJsmTimelineEnabled)() && ownProps.isIssueOfIncidentsPractice && stateProps.isEditingInternal ? {
                    eventOccurredAt: stateProps.eventOccurredAt,
                    jsdIncidentActivityViewHidden: false,
                    fullIssueUrl: stateProps.fullIssueUrl,
                    triggerIncidentSaveCommentFlag: Boolean(ownProps.isIssueOfIncidentsPractice && stateProps.eventOccurredAt)
                } : {}
            }, analyticsEvent);
        },
        onEditorExpandedWithAnalytics: (analyticsEvent)=>{
            dispatchProps.onExpand();
            (0, $jMP2a.fireOperationalAnalytics)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            analyticsEvent, 'addCommentEditor expanded', {
                hasDraft: stateProps.hasDraft
            });
        }
    };
};
const $bdcb520927dcd368$var$editorSecondaryToolbarComponentsFactory = (0, $5iWql.default)((shouldShowCommentVisibility, visibility, onVisibilityChange, jsmTimelineComponents)=>shouldShowCommentVisibility ? [
        ...jsmTimelineComponents,
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j3Xcx.default), {
            key: "commentVisibilitySelect",
            initialValue: visibility,
            onChange: onVisibilityChange
        })
    ] : jsmTimelineComponents);
const $bdcb520927dcd368$var$onSaveFactory = (0, $5iWql.default)((eventOccurredAt, shouldShowCommentVisibilitySelect, visibility, getOnSave, authorId, isIssueOfIncidentsPractice, isEditingInternal, fullIssueUrl)=>(value, analyticsEvent)=>{
        if ((0, $1ybV0.ff)('sea-2350-analytics-for-mentions-in-board-and-backlog_2gkji')) {
            if (value?.content) {
                const mentions = (0, $bm1XB.findMentionsInAdfContent)(value.content);
                analyticsEvent.update({
                    mentionedUserIds: mentions.map((mention)=>mention.attrs.id)
                });
            }
        }
        eventOccurredAt ? analyticsEvent.update({
            isEventOccurredAtSelected: true
        }) : analyticsEvent.update({
            isEventOccurredAtSelected: false
        });
        if (shouldShowCommentVisibilitySelect) analyticsEvent.update({
            isCommentRestricted: visibility.type !== (0, $b9bd3ab49fd3c4c9$export$a3863626f98a38c2)
        });
        getOnSave({
            authorId: authorId,
            bodyAdf: value,
            bodyHtml: undefined,
            richContent: undefined,
            visibility: visibility,
            ...(0, $2StPr.isJsmTimelineEnabled)() && isIssueOfIncidentsPractice && isEditingInternal ? {
                eventOccurredAt: eventOccurredAt,
                jsdIncidentActivityViewHidden: false,
                fullIssueUrl: fullIssueUrl,
                triggerIncidentSaveCommentFlag: Boolean(isIssueOfIncidentsPractice && eventOccurredAt)
            } : {}
        }, analyticsEvent);
    });
const $bdcb520927dcd368$var$onEditorExpandedWithAnalyticsFactory = (0, $5iWql.default)((onExpand, hasDraft)=>(analyticsEvent)=>{
        onExpand();
        (0, $jMP2a.fireOperationalAnalytics)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        analyticsEvent, 'addCommentEditor expanded', {
            hasDraft: hasDraft
        });
    });
const $bdcb520927dcd368$var$jsmTimelineComponentsFactory = (0, $5iWql.default)((isJsmTimelineEnabledFF, isEditingInternal, statePropsEventOccurredAt, onEventOccurredAtChange)=>isJsmTimelineEnabledFF && isEditingInternal ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4y397.EventOccurredAtSelector), {
            key: "eventOccurredAtSelector",
            initialValue: statePropsEventOccurredAt,
            onChange: (eventOccurredAt)=>{
                onEventOccurredAtChange(eventOccurredAt);
            }
        })
    ] : []);
const $bdcb520927dcd368$var$mergePropsNew = (stateProps, dispatchProps, ownProps)=>{
    const jsmTimelineComponents = $bdcb520927dcd368$var$jsmTimelineComponentsFactory((0, $2StPr.isJsmTimelineEnabled)(), stateProps.isEditingInternal, stateProps.eventOccurredAt, dispatchProps.onEventOccurredAtChange);
    const shouldShowCommentVisibility = (0, $1ybV0.ff)('jsm-restrict-internal-comment-visibility') ? stateProps.shouldShowCommentVisibilitySelect && stateProps.isEditingInternal : stateProps.shouldShowCommentVisibilitySelect;
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        editorSecondaryToolbarComponents: $bdcb520927dcd368$var$editorSecondaryToolbarComponentsFactory(shouldShowCommentVisibility, stateProps.visibility, dispatchProps.onVisibilityChange, jsmTimelineComponents),
        onSave: $bdcb520927dcd368$var$onSaveFactory(stateProps.eventOccurredAt, stateProps.shouldShowCommentVisibilitySelect, stateProps.visibility, dispatchProps.getOnSave, stateProps.authorId, ownProps.isIssueOfIncidentsPractice, stateProps.isEditingInternal, stateProps.fullIssueUrl),
        onEditorExpandedWithAnalytics: $bdcb520927dcd368$var$onEditorExpandedWithAnalyticsFactory(dispatchProps.onExpand, stateProps.hasDraft)
    };
};
const $bdcb520927dcd368$export$e581f83e003b33cb = (0, $5G3JL.flowWithSafeComponent)((0, $lBMPF.default), (0, $eGI9v.default)('issueFields', {
    onSave: 'created',
    onEditorExpandedWithAnalytics: 'commentExpanded'
}), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ editorSecondaryToolbarComponents: Element[]; onSave: (value: DocNode, analyticsEvent: UIAnalyticsEvent) => void; onEditorExpandedWithAnalytics: (analyticsEvent: UIAnalyticsEvent) => void; ... 25 more ...; isIssueOfIncidentsPractice?: boolean | undefined; }, { ...; }>' is not assignable to parameter of type 'FlowStep<FC<Omit<{ [K in keyof PropsWithRef<Omit<P, "containerWidth">>]: K extends "onSave" | "onEditorExpandedWithAnalytics" ? (...args: [...Parameters<PropsWithRef<Omit<P, "containerWidth">>[K]>, UIAnalyticsEvent]) => ReturnType<...> : PropsWithRef<...>[K]; }, keyof WithAnalyticsEventsProps>>, ConnectedComponent<....'.
(0, $lqalZ.connect)($bdcb520927dcd368$var$mapStateToProps, $bdcb520927dcd368$var$mapDispatchToProps, (0, $1TrR5.functionWithFFRedux)($bdcb520927dcd368$var$mergePropsNew, $bdcb520927dcd368$var$mergePropsOld)))((0, $lGT7F.AddCommentForm));
const $bdcb520927dcd368$export$f7155506fc77105 = ()=>{
    const isIssueOfIncidentsPractice = (0, $2wCUM.useIsIssueOfIncidentsPractice)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdcb520927dcd368$export$e581f83e003b33cb, {
        isIssueOfIncidentsPractice: isIssueOfIncidentsPractice
    });
};
var $bdcb520927dcd368$export$2e2bcd8739ae039 = (0, $2ijRB.default)((0, $2StPr.isJsmTimelineEnabled), $bdcb520927dcd368$export$f7155506fc77105, $bdcb520927dcd368$export$e581f83e003b33cb);

});
parcelRegister("j3Xcx", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d7172a2c144ea54$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $wKt79 = parcelRequire("wKt79");

var $6SC7J = parcelRequire("6SC7J");

var $66fdV = parcelRequire("66fdV");
const $0d7172a2c144ea54$var$CommentVisibilitySelect = ({ initialValue: initialValue, onChange: onChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6SC7J.default), null, ({ loading: loading, error: error, data: data }, { fetch: fetch })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $66fdV.default), {
            initialValue: initialValue,
            onChange: onChange,
            isLoading: loading,
            error: error,
            options: data ? data.commentVisibilities : null,
            getCommentVisibilityData: fetch
        }));
var $0d7172a2c144ea54$export$2e2bcd8739ae039 = (0, $wKt79.safeComponent)()($0d7172a2c144ea54$var$CommentVisibilitySelect);

});
parcelRegister("66fdV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bbdaebc912154b2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $86RCm = parcelRequire("86RCm");
const $5bbdaebc912154b2$export$36518eb9cbf30f69 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        prefixOverride: "issue",
        id: "safe(CommentVisibilityViewWithAnalytics)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (analyticsEvent)=>{
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'commentVisibilitySelect mounted', {
                isLoading: props.isLoading
            });
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $86RCm.CommentVisibilityView), props)));
var $5bbdaebc912154b2$export$2e2bcd8739ae039 = $5bbdaebc912154b2$export$36518eb9cbf30f69;

});
parcelRegister("86RCm", function(module, exports) {

$parcel$export(module.exports, "CommentVisibilityView", () => $4dd38869a6cbf57d$export$84044fded70e314d);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gHHen = parcelRequire("gHHen");

var $8blac = parcelRequire("8blac");

var $9nt1B = parcelRequire("9nt1B");

var $f4A0J = parcelRequire("f4A0J");

var $8HBl8 = parcelRequire("8HBl8");

var $jQxSL = parcelRequire("jQxSL");
var $4IBr3 = parcelRequire("4IBr3");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("f6MOn");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $kd4G1 = parcelRequire("kd4G1");

var $ajLVr = parcelRequire("ajLVr");

var $aHCyw = parcelRequire("aHCyw");

var $cXP4L = parcelRequire("cXP4L");

var $dJFS1 = parcelRequire("dJFS1");
const $4dd38869a6cbf57d$var$OPTION_FILTER_THRESHOLD = 30;
const $4dd38869a6cbf57d$var$OPTION_TOOLTIP_DELAY = 2000;
const $4dd38869a6cbf57d$var$actionSubjectId = 'commentVisibilityView';
const $4dd38869a6cbf57d$var$formatGroupLabel = ({ label: label })=>label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4dd38869a6cbf57d$var$GroupLabel, null, label); // @ts-expect-error - TS7031 - Binding element 'selected' implicitly has an 'any' type. | TS7031 - Binding element 'isFocused' implicitly has an 'any' type.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4dd38869a6cbf57d$var$customOptionStyles = (baseStyles, { data: { selected: selected }, isFocused: isFocused })=>{
    const maybeFocusedColor = isFocused ? `var(--ds-background-neutral-hovered, ${(0, $PdmhA).N20})` : baseStyles.backgroundColor;
    const backgroundColor = selected ? `var(--ds-background-selected, ${(0, $PdmhA).B50})` : maybeFocusedColor;
    return {
        ...baseStyles,
        backgroundColor: backgroundColor
    };
};
const $4dd38869a6cbf57d$var$styles = {
    // @ts-expect-error - TS7006 - Parameter 'baseStyles' implicitly has an 'any' type.
    container: (baseStyles)=>({
            ...baseStyles,
            paddingBottom: '0',
            paddingTop: '0'
        }),
    // @ts-expect-error - TS7006 - Parameter 'baseStyles' implicitly has an 'any' type.
    group: (baseStyles)=>({
            ...baseStyles,
            paddingBottom: "var(--ds-space-050, 4px)",
            paddingTop: '0'
        }),
    option: $4dd38869a6cbf57d$var$customOptionStyles
};
const $4dd38869a6cbf57d$var$popperProps = ()=>({
        placement: 'bottom-end',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [
                        0,
                        (0, $c9TLT.gridSize)
                    ]
                }
            },
            {
                // Update the z-index of the portaled popper (menu) component so menu is visible when viewing issue in dialog.
                // The same thing could be achieved with setting positionFixed to true but that caused us to loose the ability
                // to interact with the menu using keyboard (see BENTO-5561).
                name: 'setZIndex',
                enabled: true,
                phase: 'read',
                // @ts-expect-error - TS7031 - Binding element 'state' implicitly has an 'any' type.
                fn: ({ state: state })=>({
                        ...state,
                        styles: {
                            ...state.styles,
                            popper: {
                                ...state.styles?.popper,
                                zIndex: (0, $c9TLT.layers).modal
                            }
                        }
                    })
            },
            {
                // Ensure menu is not detached from the trigger (button) and remain in view when trigger is no longer in view (see BENTO-5551).
                name: 'preventOverflow',
                options: {
                    padding: 5,
                    escapeWithReference: true
                }
            }
        ]
    });
const $4dd38869a6cbf57d$var$PopupSelectWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('commentVisibilitySelect', {
    onOpen: 'opened',
    onChange: 'changed'
})((0, $4IBr3.default));
const $4dd38869a6cbf57d$export$2cf7ef1e2dd6c6b1 = ({ value: value, selected: selected, isPublic: isPublic, toolTipDelay: toolTipDelay = $4dd38869a6cbf57d$var$OPTION_TOOLTIP_DELAY })=>{
    const Icon = isPublic ? (0, (/*@__PURE__*/$parcel$interopDefault($8HBl8))) : (0, (/*@__PURE__*/$parcel$interopDefault($f4A0J)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: value,
        delay: toolTipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4dd38869a6cbf57d$var$OptionContainer, {
        "data-testid": "issue-comment-base.ui.comment.comment-visibility.option-label"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4dd38869a6cbf57d$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4dd38869a6cbf57d$var$OptionText, null, value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4dd38869a6cbf57d$var$CheckedContainer, null, selected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
        primaryColor: `var(--ds-text-selected, ${(0, $PdmhA).B500})`,
        label: ""
    }) : null)));
};
const $4dd38869a6cbf57d$export$84044fded70e314d = ({ isLoading: isLoading, options: options, getCommentVisibilityData: getCommentVisibilityData, initialValue: initialValue, onChange: onChange, error: error })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isErrorOrLoading = isLoading || error;
    const [selectedOption, setValue] = (0, $eUqFw.useState)(initialValue);
    const onChangeAction = (option)=>{
        onChange(option);
        setValue(option);
    };
    const [isOpen, setOpen] = (0, $eUqFw.useState)(false);
    const onOpen = (0, $eUqFw.useCallback)(()=>setOpen(true), []);
    const onClose = (0, $eUqFw.useCallback)(()=>setOpen(false), []);
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('lower-comment-visibility-list-fetch')) {
            if (options === null && !isErrorOrLoading) getCommentVisibilityData();
        }
    }, [
        getCommentVisibilityData,
        options,
        isErrorOrLoading
    ]);
    const isInitialOptionPublic = initialValue.type === (0, $b9bd3ab49fd3c4c9$export$a3863626f98a38c2);
    if ((isErrorOrLoading || (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options)) && isInitialOptionPublic) return null;
    const optionGroups = isErrorOrLoading || options == null ? (0, $cXP4L.getEmptyOptionsWithInitialValue)(initialValue, selectedOption, formatMessage) : (0, $cXP4L.getDefaultOptionGroups)(options, formatMessage, selectedOption); // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const MenuList = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MenuList, props, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4dd38869a6cbf57d$var$StyledFooter, null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ajLVr.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dJFS1.LoadingSpinner), null)));
    const componentsList = isErrorOrLoading ? {
        MenuList: MenuList
    } : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (analyticsEvent)=>(0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'commentVisibilitySelect rendered')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4dd38869a6cbf57d$var$CommentVisibilityWrapper, {
        "data-testid": "issue-comment-base.ui.comment.comment-visibility.comment-visibility-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4dd38869a6cbf57d$var$PopupSelectWithAnalytics, {
        onClose: onClose,
        onOpen: (analyticsEvent)=>{
            onOpen();
            const optionTypeCounts = (0, (/*@__PURE__*/$parcel$interopDefault($gHHen)))(options, 'type');
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $4dd38869a6cbf57d$var$actionSubjectId, {
                roleCount: optionTypeCounts[0, $b9bd3ab49fd3c4c9$export$28a8bb936dce2def] || 0,
                groupCount: optionTypeCounts[0, $b9bd3ab49fd3c4c9$export$537a061b2f9c8800] || 0,
                // the +1 is for the public option
                totalCount: options == null ? 1 : options.length + 1
            });
        },
        maxMenuWidth: (0, $kd4G1.buttonMaxWidth),
        minMenuWidth: 175,
        maxMenuHeight: 340,
        formatOptionLabel: ({ type: type, value: value, selected: selected })=>{
            const isPublic = type === (0, $b9bd3ab49fd3c4c9$export$a3863626f98a38c2);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4dd38869a6cbf57d$export$2cf7ef1e2dd6c6b1, {
                isPublic: isPublic,
                selected: selected,
                value: isPublic ? formatMessage((0, $aHCyw.default).visibleToAllUsers) : value
            });
        },
        popperProps: $4dd38869a6cbf57d$var$popperProps(),
        components: componentsList,
        styles: $4dd38869a6cbf57d$var$styles,
        formatGroupLabel: $4dd38869a6cbf57d$var$formatGroupLabel,
        options: optionGroups,
        target: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kd4G1.default), {
                selectedOption: selectedOption,
                isSelected: isOpen
            })),
        isLoading: isLoading,
        error: error,
        onChange: (opt, _, analyticsEvent)=>{
            onChangeAction((0, $cXP4L.transformOption)(opt));
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $4dd38869a6cbf57d$var$actionSubjectId);
        },
        isSearchable: // The +1 is for the public option
        options == null ? false : options.length + 1 > $4dd38869a6cbf57d$var$OPTION_FILTER_THRESHOLD,
        searchThreshold: $4dd38869a6cbf57d$var$OPTION_FILTER_THRESHOLD,
        classNamePrefix: "comment-visibility"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dd38869a6cbf57d$var$OptionContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1e5h _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dd38869a6cbf57d$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f314y2 _n3tdidpf _19bvidpf _1o9zidpf _c71l1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dd38869a6cbf57d$var$CheckedContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66 _c71l1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dd38869a6cbf57d$var$GroupLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81vlj _ca0q1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dd38869a6cbf57d$var$OptionText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dd38869a6cbf57d$var$StyledFooter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _1yt4pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dd38869a6cbf57d$var$CommentVisibilityWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul914no _18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gHHen", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $f2sQe = parcelRequire("f2sQe");
/** Used for built-in method references. */ var $c292323d8f404a9d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c292323d8f404a9d$var$hasOwnProperty = $c292323d8f404a9d$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $c292323d8f404a9d$var$countBy = $f2sQe(function(result, value, key) {
    if ($c292323d8f404a9d$var$hasOwnProperty.call(result, key)) ++result[key];
    else $3pSMu(result, key, 1);
});
module.exports = $c292323d8f404a9d$var$countBy;

});

parcelRegister("9nt1B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d3cc6c41555bcf7$var$_react = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6d3cc6c41555bcf7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6d3cc6c41555bcf7$var$CheckIcon = (props)=>/*#__PURE__*/ $6d3cc6c41555bcf7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6.735 12.322a1 1 0 00-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2335.638 2335.638 0 003.939-3.883l.04-.04a492.598 492.598 0 003.658-3.643 1 1 0 00-1.424-1.404 518.42 518.42 0 01-3.64 3.625l-.04.04a2049.114 2049.114 0 01-3.775 3.722l-3.098-3.363z" fill="currentColor"/></svg>`
    }, props));
$6d3cc6c41555bcf7$var$CheckIcon.displayName = 'CheckIcon';
var $6d3cc6c41555bcf7$var$_default = $6d3cc6c41555bcf7$var$CheckIcon;
module.exports.default = $6d3cc6c41555bcf7$var$_default;

});

parcelRegister("4IBr3", function(module, exports) {

$parcel$export(module.exports, "default", () => $36f84f608ae38274$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $6Pq2D = parcelRequire("6Pq2D");

var $hOLnS = parcelRequire("hOLnS");
var $cEc3i = parcelRequire("cEc3i");

var $tkrFt = parcelRequire("tkrFt");

var $iiw56 = parcelRequire("iiw56");
var $cbuUX = parcelRequire("cbuUX");
var $3ejJG = parcelRequire("3ejJG");

var $lbDTY = parcelRequire("lbDTY");

var $asNSH = parcelRequire("asNSH");

var $4zgIJ = parcelRequire("4zgIJ");

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");

var $fspOv = parcelRequire("fspOv");

var $9zvxA = parcelRequire("9zvxA");

var $74BVL = parcelRequire("74BVL");
/** Are we rendering on the client or server? */ const $36f84f608ae38274$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Types
// ==============================
// ==============================
// Class
// ==============================
const $36f84f608ae38274$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $36f84f608ae38274$var$defaultPopperProps = {
    modifiers: $36f84f608ae38274$var$modifiers,
    placement: 'bottom-start'
};
const $36f84f608ae38274$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $36f84f608ae38274$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(...args){
        var _this$defaultOpenStat;
        super(...args);
        (0, $5zQU9.default)(this, "menuRef", null);
        (0, $5zQU9.default)(this, "targetRef", null);
        (0, $5zQU9.default)(this, "unbindWindowClick", null);
        (0, $5zQU9.default)(this, "unbindWindowKeydown", null);
        (0, $5zQU9.default)(this, "defaultStyles", (0, $cEc3i.m)((0, $9zvxA.default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $PdmhA.N80})`
                })
        }));
        (0, $5zQU9.default)(this, "isOpenControlled", this.props.isOpen !== undefined);
        (0, $5zQU9.default)(this, "defaultOpenState", this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen);
        (0, $5zQU9.default)(this, "state", {
            focusLockEnabled: false,
            isOpen: (_this$defaultOpenStat = this.defaultOpenState) !== null && _this$defaultOpenStat !== void 0 ? _this$defaultOpenStat : false,
            mergedComponents: (0, $fspOv.defaultComponents),
            mergedPopperProps: $36f84f608ae38274$var$defaultPopperProps
        });
        (0, $5zQU9.default)(this, "popperWrapperId", `${(0, $tkrFt.uid)({
            options: this.props.options
        })}-popup-select`);
        // Event Handlers
        // ==============================
        (0, $5zQU9.default)(this, "handleTargetKeyDown", (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        });
        (0, $5zQU9.default)(this, "handleKeyDown", (event)=>{
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        });
        (0, $5zQU9.default)(this, "handleClick", ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        });
        (0, $5zQU9.default)(this, "handleSelectChange", (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        });
        (0, $5zQU9.default)(this, "handleFirstPopperUpdate", ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        });
        // Internal Lifecycle
        // ==============================
        /**
     * Opens the popup
     *
     * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
     */ (0, $5zQU9.default)(this, "open", (options)=>{
            const { onOpen: onOpen } = this.props;
            if (!(options !== null && options !== void 0 && options.controlOverride) && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            this.setState({
                isOpen: true
            });
            if (this.selectRef) {
                var _this$selectRef$selec;
                (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? (_this$selectRef$selec = this.selectRef.select) === null || _this$selectRef$selec === void 0 || _this$selectRef$selec.openMenu('first') : this.selectRef.openMenu('first');
            }
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        });
        /**
     * Closes the popup
     *
     * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
     */ (0, $5zQU9.default)(this, "close", (options)=>{
            var _this$unbindWindowKey;
            const { onClose: onClose } = this.props;
            if (!(options !== null && options !== void 0 && options.controlOverride) && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            (_this$unbindWindowKey = this.unbindWindowKeydown) === null || _this$unbindWindowKey === void 0 || _this$unbindWindowKey.call(this);
            this.unbindWindowKeydown = null;
        });
        // Refs
        // ==============================
        (0, $5zQU9.default)(this, "resolveTargetRef", (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            });
        (0, $5zQU9.default)(this, "resolveMenuRef", (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            });
        (0, $5zQU9.default)(this, "getSelectRef", (ref)=>{
            this.selectRef = ref;
        });
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        (0, $5zQU9.default)(this, "getItemCount", ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        });
        (0, $5zQU9.default)(this, "getMaxHeight", ()=>{
            var _this$selectRef$selec2;
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            let controlRef = (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? (_this$selectRef$selec2 = this.selectRef.select) === null || _this$selectRef$selec2 === void 0 ? void 0 : _this$selectRef$selec2.controlRef : this.selectRef.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        });
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        (0, $5zQU9.default)(this, "showSearchControl", ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        });
        // Renderers
        // ==============================
        (0, $5zQU9.default)(this, "renderSelect", ()=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $36f84f608ae38274$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $fspOv.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const InternalSelect = (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? (0, $4zgIJ.default) : (0, $hOLnS.default);
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cbuUX.Popper), (0, $kU09D.default)({}, mergedPopperProps, {
                onFirstUpdate: (state)=>{
                    var _mergedPopperProps$on;
                    this.handleFirstPopperUpdate();
                    (_mergedPopperProps$on = mergedPopperProps.onFirstUpdate) === null || _mergedPopperProps$on === void 0 || _mergedPopperProps$on.call(mergedPopperProps, state);
                }
            }), ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
                    innerRef: this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fspOv.MenuDialog), {
                    style: style,
                    "data-placement": placement,
                    minWidth: minMenuWidth,
                    maxWidth: maxMenuWidth,
                    id: this.popperWrapperId,
                    testId: testId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
                    disabled: !focusLockEnabled,
                    returnFocus: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InternalSelect, (0, $kU09D.default)({
                    "aria-label": getLabel(),
                    backspaceRemovesValue: false,
                    controlShouldRenderValue: false,
                    isClearable: false,
                    tabSelectsValue: false,
                    menuIsOpen: true,
                    placeholder: placeholder,
                    ref: this.getSelectRef
                }, props, {
                    onMenuClose: ()=>{
                        var _props$onMenuClose;
                        (0, $XHGTv.getBooleanFF)('platform.design-system-team.popup-select-close_8h15h') && this.close();
                        (_props$onMenuClose = props.onMenuClose) === null || _props$onMenuClose === void 0 || _props$onMenuClose.call(props);
                    },
                    isSearchable: showSearchControl,
                    styles: (0, $cEc3i.m)(this.defaultStyles, props.styles || {}),
                    maxMenuHeight: this.getMaxHeight(),
                    components: selectComponents,
                    onChange: this.handleSelectChange
                })), footer))));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $lEfVV.createPortal)(popper, portalDestination);
        });
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$36f84f608ae38274$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $fspOv.defaultComponents),
            ...props.components
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$36f84f608ae38274$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $74BVL.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        var _this$unbindWindowCli, _this$unbindWindowKey2;
        if (typeof window === 'undefined') return;
        (_this$unbindWindowCli = this.unbindWindowClick) === null || _this$unbindWindowCli === void 0 || _this$unbindWindowCli.call(this);
        this.unbindWindowClick = null;
        (_this$unbindWindowKey2 = this.unbindWindowKeydown) === null || _this$unbindWindowKey2 === void 0 || _this$unbindWindowKey2.call(this);
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iiw56.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ejJG.Reference), null, ({ ref: ref })=>target && target({
                isOpen: isOpen,
                onKeyDown: this.handleTargetKeyDown,
                ref: this.resolveTargetRef(ref),
                'aria-haspopup': 'true',
                'aria-expanded': isOpen,
                'aria-controls': isOpen ? this.popperWrapperId : undefined
            })), this.renderSelect());
    }
}
(0, $5zQU9.default)($36f84f608ae38274$export$2e2bcd8739ae039, "defaultProps", {
    closeMenuOnSelect: true,
    components: {},
    maxMenuHeight: 300,
    maxMenuWidth: 440,
    minMenuWidth: 220,
    popperProps: {},
    isSearchable: true,
    searchThreshold: 5,
    styles: {},
    options: []
});

});
parcelRegister("iiw56", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $d522cb1ec4ed2636$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $d522cb1ec4ed2636$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $d522cb1ec4ed2636$export$d0d38e7dec7a1a61);

var $eUqFw = parcelRequire("eUqFw");
var $d522cb1ec4ed2636$export$3dbd3405086fec7b = $eUqFw.createContext();
var $d522cb1ec4ed2636$export$cbabb21c2529b130 = $eUqFw.createContext();
function $d522cb1ec4ed2636$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eUqFw.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eUqFw.useRef(false);
    $eUqFw.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eUqFw.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement($d522cb1ec4ed2636$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eUqFw.createElement($d522cb1ec4ed2636$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("cbuUX", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $8dee7eba72bb3400$export$badac9ada3a0bdf9);

var $eUqFw = parcelRequire("eUqFw");

var $iiw56 = parcelRequire("iiw56");

var $huDqj = parcelRequire("huDqj");

var $5LqcT = parcelRequire("5LqcT");
var $8dee7eba72bb3400$var$NOOP = function NOOP() {
    return void 0;
};
var $8dee7eba72bb3400$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $8dee7eba72bb3400$var$EMPTY_MODIFIERS = [];
function $8dee7eba72bb3400$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $8dee7eba72bb3400$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eUqFw.useContext((0, $iiw56.ManagerReferenceNodeContext));
    var _React$useState = $eUqFw.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eUqFw.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eUqFw.useEffect(function() {
        (0, $huDqj.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eUqFw.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $5LqcT.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eUqFw.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $8dee7eba72bb3400$var$NOOP,
            update: update || $8dee7eba72bb3400$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $huDqj.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("huDqj", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $cbc3d1a7952f8fa8$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $cbc3d1a7952f8fa8$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $cbc3d1a7952f8fa8$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $cbc3d1a7952f8fa8$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $cbc3d1a7952f8fa8$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $cbc3d1a7952f8fa8$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $cbc3d1a7952f8fa8$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $cbc3d1a7952f8fa8$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $cbc3d1a7952f8fa8$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $cbc3d1a7952f8fa8$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $cbc3d1a7952f8fa8$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;

});

parcelRegister("5LqcT", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $4325abb4fbc9939e$export$f4d5bf230a36dd6e);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $7pWCP = parcelRequire("7pWCP");

var $an8Qp = parcelRequire("an8Qp");

var $huDqj = parcelRequire("huDqj");
var $4325abb4fbc9939e$var$EMPTY_MODIFIERS = [];
var $4325abb4fbc9939e$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eUqFw.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $4325abb4fbc9939e$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eUqFw.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eUqFw.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $lEfVV.flushSync(function() {
                    setState({
                        styles: (0, $huDqj.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $huDqj.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eUqFw.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($an8Qp)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eUqFw.useRef();
    (0, $huDqj.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $huDqj.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $7pWCP.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("7pWCP", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $566857f0a154df20$export$8f7491d57c8f97a9);

var $lA5MA = parcelRequire("lA5MA");

var $lFv6k = parcelRequire("lFv6k");

var $7BANQ = parcelRequire("7BANQ");

var $9KLSl = parcelRequire("9KLSl");

var $l6PRw = parcelRequire("l6PRw");

var $lLxyM = parcelRequire("lLxyM");

var $fhBPq = parcelRequire("fhBPq");

var $geXxb = parcelRequire("geXxb");

var $35AcE = parcelRequire("35AcE");

var $ertZm = parcelRequire("ertZm");


var $566857f0a154df20$export$d34966752335dd47 = [
    (0, $lFv6k.default),
    (0, $7BANQ.default),
    (0, $9KLSl.default),
    (0, $l6PRw.default),
    (0, $lLxyM.default),
    (0, $fhBPq.default),
    (0, $geXxb.default),
    (0, $35AcE.default),
    (0, $ertZm.default)
];
var $566857f0a154df20$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $lA5MA.popperGenerator)({
    defaultModifiers: $566857f0a154df20$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("lA5MA", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $fb61720f27b564a2$export$ed5e13716264f202);

var $5ZUsr = parcelRequire("5ZUsr");

var $8mi4M = parcelRequire("8mi4M");

var $d9u4j = parcelRequire("d9u4j");

var $n5GX2 = parcelRequire("n5GX2");

var $jfAsh = parcelRequire("jfAsh");

var $dQ8tg = parcelRequire("dQ8tg");

var $kLEYt = parcelRequire("kLEYt");


var $1NPtr = parcelRequire("1NPtr");
var $fb61720f27b564a2$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $fb61720f27b564a2$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $fb61720f27b564a2$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $fb61720f27b564a2$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $fb61720f27b564a2$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $1NPtr.isElement)(reference) ? (0, $d9u4j.default)(reference) : reference.contextElement ? (0, $d9u4j.default)(reference.contextElement) : [],
                    popper: (0, $d9u4j.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $jfAsh.default)((0, $kLEYt.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$fb61720f27b564a2$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $5ZUsr.default)(reference, (0, $n5GX2.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $8mi4M.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dQ8tg.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$fb61720f27b564a2$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $fb61720f27b564a2$export$8f7491d57c8f97a9 = /*#__PURE__*/ $fb61720f27b564a2$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("5ZUsr", function(module, exports) {

$parcel$export(module.exports, "default", () => $45de718ff7bcd1bd$export$2e2bcd8739ae039);

var $4RsZx = parcelRequire("4RsZx");

var $kXi7L = parcelRequire("kXi7L");

var $8x62b = parcelRequire("8x62b");

var $1NPtr = parcelRequire("1NPtr");

var $47uKA = parcelRequire("47uKA");

var $haGKf = parcelRequire("haGKf");

var $6Aij3 = parcelRequire("6Aij3");

var $1aMsW = parcelRequire("1aMsW");
function $45de718ff7bcd1bd$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $1aMsW.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $1aMsW.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $45de718ff7bcd1bd$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $1NPtr.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $1NPtr.isHTMLElement)(offsetParent) && $45de718ff7bcd1bd$var$isElementScaled(offsetParent);
    var documentElement = (0, $haGKf.default)(offsetParent);
    var rect = (0, $4RsZx.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $8x62b.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $6Aij3.default)(documentElement)) scroll = (0, $kXi7L.default)(offsetParent);
        if ((0, $1NPtr.isHTMLElement)(offsetParent)) {
            offsets = (0, $4RsZx.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $47uKA.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("4RsZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $38a299c837a31e38$export$2e2bcd8739ae039);

var $1NPtr = parcelRequire("1NPtr");

var $1aMsW = parcelRequire("1aMsW");

var $jLR6t = parcelRequire("jLR6t");

var $jE2je = parcelRequire("jE2je");
function $38a299c837a31e38$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $1NPtr.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $1aMsW.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $1aMsW.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $1NPtr.isElement)(element) ? (0, $jLR6t.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $jE2je.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("1NPtr", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $15024bab9923b10d$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $15024bab9923b10d$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $15024bab9923b10d$export$af51f0f06c0f328a);

var $jLR6t = parcelRequire("jLR6t");
function $15024bab9923b10d$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $jLR6t.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $15024bab9923b10d$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $jLR6t.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $15024bab9923b10d$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $jLR6t.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("jLR6t", function(module, exports) {

$parcel$export(module.exports, "default", () => $e64b9958c7002d99$export$2e2bcd8739ae039);
function $e64b9958c7002d99$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("1aMsW", function(module, exports) {

$parcel$export(module.exports, "max", () => $0dac51e7e4d285b7$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $0dac51e7e4d285b7$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $0dac51e7e4d285b7$export$2077e0241d6afd3c);
var $0dac51e7e4d285b7$export$8960430cfd85939f = Math.max;
var $0dac51e7e4d285b7$export$96ec731ed4dcb222 = Math.min;
var $0dac51e7e4d285b7$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("jE2je", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4d38b4ddf84e1d1$export$2e2bcd8739ae039);

var $adzFN = parcelRequire("adzFN");
function $e4d38b4ddf84e1d1$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $adzFN.default)());
}

});
parcelRegister("adzFN", function(module, exports) {

$parcel$export(module.exports, "default", () => $7706ca328685f397$export$2e2bcd8739ae039);
function $7706ca328685f397$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("kXi7L", function(module, exports) {

$parcel$export(module.exports, "default", () => $f417606d849a86f9$export$2e2bcd8739ae039);

var $81df1 = parcelRequire("81df1");

var $jLR6t = parcelRequire("jLR6t");

var $1NPtr = parcelRequire("1NPtr");

var $h2oh5 = parcelRequire("h2oh5");
function $f417606d849a86f9$export$2e2bcd8739ae039(node) {
    if (node === (0, $jLR6t.default)(node) || !(0, $1NPtr.isHTMLElement)(node)) return (0, $81df1.default)(node);
    else return (0, $h2oh5.default)(node);
}

});
parcelRegister("81df1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d68b029d3dd5191$export$2e2bcd8739ae039);

var $jLR6t = parcelRequire("jLR6t");
function $5d68b029d3dd5191$export$2e2bcd8739ae039(node) {
    var win = (0, $jLR6t.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("h2oh5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c675740440d9797c$export$2e2bcd8739ae039);
function $c675740440d9797c$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("8x62b", function(module, exports) {

$parcel$export(module.exports, "default", () => $63661614fbaf72be$export$2e2bcd8739ae039);
function $63661614fbaf72be$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("47uKA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fffab3cf3e4e753$export$2e2bcd8739ae039);

var $4RsZx = parcelRequire("4RsZx");

var $haGKf = parcelRequire("haGKf");

var $81df1 = parcelRequire("81df1");
function $2fffab3cf3e4e753$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $4RsZx.default)((0, $haGKf.default)(element)).left + (0, $81df1.default)(element).scrollLeft;
}

});
parcelRegister("haGKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c804871e727c911e$export$2e2bcd8739ae039);

var $1NPtr = parcelRequire("1NPtr");
function $c804871e727c911e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $1NPtr.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("6Aij3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cb44e1a3617689f$export$2e2bcd8739ae039);

var $hE1eD = parcelRequire("hE1eD");
function $4cb44e1a3617689f$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $hE1eD.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("hE1eD", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd872155b8d2ff11$export$2e2bcd8739ae039);

var $jLR6t = parcelRequire("jLR6t");
function $cd872155b8d2ff11$export$2e2bcd8739ae039(element) {
    return (0, $jLR6t.default)(element).getComputedStyle(element);
}

});



parcelRegister("8mi4M", function(module, exports) {

$parcel$export(module.exports, "default", () => $615e66539a7ab1ae$export$2e2bcd8739ae039);

var $4RsZx = parcelRequire("4RsZx");
function $615e66539a7ab1ae$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $4RsZx.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("d9u4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $99337097ea891852$export$2e2bcd8739ae039);

var $hzh21 = parcelRequire("hzh21");

var $6f1Yi = parcelRequire("6f1Yi");

var $jLR6t = parcelRequire("jLR6t");

var $6Aij3 = parcelRequire("6Aij3");
function $99337097ea891852$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $hzh21.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $jLR6t.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $6Aij3.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($99337097ea891852$export$2e2bcd8739ae039((0, $6f1Yi.default)(target)));
}

});
parcelRegister("hzh21", function(module, exports) {

$parcel$export(module.exports, "default", () => $cca2eab2af036ba0$export$2e2bcd8739ae039);

var $6f1Yi = parcelRequire("6f1Yi");

var $6Aij3 = parcelRequire("6Aij3");

var $8x62b = parcelRequire("8x62b");

var $1NPtr = parcelRequire("1NPtr");
function $cca2eab2af036ba0$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $8x62b.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $1NPtr.isHTMLElement)(node) && (0, $6Aij3.default)(node)) return node;
    return $cca2eab2af036ba0$export$2e2bcd8739ae039((0, $6f1Yi.default)(node));
}

});
parcelRegister("6f1Yi", function(module, exports) {

$parcel$export(module.exports, "default", () => $48b5ac4e31cb4dca$export$2e2bcd8739ae039);

var $8x62b = parcelRequire("8x62b");

var $haGKf = parcelRequire("haGKf");

var $1NPtr = parcelRequire("1NPtr");
function $48b5ac4e31cb4dca$export$2e2bcd8739ae039(element) {
    if ((0, $8x62b.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $1NPtr.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $haGKf.default)(element) // fallback
    );
}

});



parcelRegister("n5GX2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0456905cda2acc95$export$2e2bcd8739ae039);

var $jLR6t = parcelRequire("jLR6t");

var $8x62b = parcelRequire("8x62b");

var $hE1eD = parcelRequire("hE1eD");

var $1NPtr = parcelRequire("1NPtr");

var $cnnz8 = parcelRequire("cnnz8");

var $6f1Yi = parcelRequire("6f1Yi");

var $adzFN = parcelRequire("adzFN");
function $0456905cda2acc95$var$getTrueOffsetParent(element) {
    if (!(0, $1NPtr.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $hE1eD.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $0456905cda2acc95$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $adzFN.default)());
    var isIE = /Trident/i.test((0, $adzFN.default)());
    if (isIE && (0, $1NPtr.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $hE1eD.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $6f1Yi.default)(element);
    if ((0, $1NPtr.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $1NPtr.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $8x62b.default)(currentNode)) < 0){
        var css = (0, $hE1eD.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $0456905cda2acc95$export$2e2bcd8739ae039(element) {
    var window = (0, $jLR6t.default)(element);
    var offsetParent = $0456905cda2acc95$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cnnz8.default)(offsetParent) && (0, $hE1eD.default)(offsetParent).position === 'static')offsetParent = $0456905cda2acc95$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $8x62b.default)(offsetParent) === 'html' || (0, $8x62b.default)(offsetParent) === 'body' && (0, $hE1eD.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $0456905cda2acc95$var$getContainingBlock(element) || window;
}

});
parcelRegister("cnnz8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9029e9a6d9eb8e05$export$2e2bcd8739ae039);

var $8x62b = parcelRequire("8x62b");
function $9029e9a6d9eb8e05$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $8x62b.default)(element)) >= 0;
}

});


parcelRegister("jfAsh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e03bb24644f893dd$export$2e2bcd8739ae039);

var $iApVm = parcelRequire("iApVm");
function $e03bb24644f893dd$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $e03bb24644f893dd$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $e03bb24644f893dd$var$order(modifiers); // order based on phase
    return (0, $iApVm.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("iApVm", function(module, exports) {

$parcel$export(module.exports, "top", () => $d87fb2c4b50b27e8$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $d87fb2c4b50b27e8$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $d87fb2c4b50b27e8$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $d87fb2c4b50b27e8$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $d87fb2c4b50b27e8$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $d87fb2c4b50b27e8$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $d87fb2c4b50b27e8$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $d87fb2c4b50b27e8$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $d87fb2c4b50b27e8$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $d87fb2c4b50b27e8$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $d87fb2c4b50b27e8$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $d87fb2c4b50b27e8$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $d87fb2c4b50b27e8$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $d87fb2c4b50b27e8$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $d87fb2c4b50b27e8$export$d087d3878fdf71d5);
var $d87fb2c4b50b27e8$export$1e95b668f3b82d = 'top';
var $d87fb2c4b50b27e8$export$40e543e69a8b3fbb = 'bottom';
var $d87fb2c4b50b27e8$export$79ffe56a765070d2 = 'right';
var $d87fb2c4b50b27e8$export$eabcd2c8791e7bf4 = 'left';
var $d87fb2c4b50b27e8$export$dfb5619354ba860 = 'auto';
var $d87fb2c4b50b27e8$export$aec2ce47c367b8c3 = [
    $d87fb2c4b50b27e8$export$1e95b668f3b82d,
    $d87fb2c4b50b27e8$export$40e543e69a8b3fbb,
    $d87fb2c4b50b27e8$export$79ffe56a765070d2,
    $d87fb2c4b50b27e8$export$eabcd2c8791e7bf4
];
var $d87fb2c4b50b27e8$export$b3571188c770cc5a = 'start';
var $d87fb2c4b50b27e8$export$bd5df0f255a350f8 = 'end';
var $d87fb2c4b50b27e8$export$390fd549c5303b4d = 'clippingParents';
var $d87fb2c4b50b27e8$export$d7b7311ec04a3e8f = 'viewport';
var $d87fb2c4b50b27e8$export$ae5ab1c730825774 = 'popper';
var $d87fb2c4b50b27e8$export$ca50aac9f3ba507f = 'reference';
var $d87fb2c4b50b27e8$export$368f9a87e87fa4e1 = /*#__PURE__*/ $d87fb2c4b50b27e8$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $d87fb2c4b50b27e8$export$b3571188c770cc5a,
        placement + "-" + $d87fb2c4b50b27e8$export$bd5df0f255a350f8
    ]);
}, []);
var $d87fb2c4b50b27e8$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($d87fb2c4b50b27e8$export$aec2ce47c367b8c3, [
    $d87fb2c4b50b27e8$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $d87fb2c4b50b27e8$export$b3571188c770cc5a,
        placement + "-" + $d87fb2c4b50b27e8$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $d87fb2c4b50b27e8$export$421679a7c3d56e = 'beforeRead';
var $d87fb2c4b50b27e8$export$aafa59e2e03f2942 = 'read';
var $d87fb2c4b50b27e8$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $d87fb2c4b50b27e8$export$c65e99957a05207c = 'beforeMain';
var $d87fb2c4b50b27e8$export$f22da7240b7add18 = 'main';
var $d87fb2c4b50b27e8$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $d87fb2c4b50b27e8$export$8d4d2d70e7d46032 = 'beforeWrite';
var $d87fb2c4b50b27e8$export$68d8715fc104d294 = 'write';
var $d87fb2c4b50b27e8$export$70a6e5159acce2e6 = 'afterWrite';
var $d87fb2c4b50b27e8$export$d087d3878fdf71d5 = [
    $d87fb2c4b50b27e8$export$421679a7c3d56e,
    $d87fb2c4b50b27e8$export$aafa59e2e03f2942,
    $d87fb2c4b50b27e8$export$6964f6c886723980,
    $d87fb2c4b50b27e8$export$c65e99957a05207c,
    $d87fb2c4b50b27e8$export$f22da7240b7add18,
    $d87fb2c4b50b27e8$export$bab79516f2d662fe,
    $d87fb2c4b50b27e8$export$8d4d2d70e7d46032,
    $d87fb2c4b50b27e8$export$68d8715fc104d294,
    $d87fb2c4b50b27e8$export$70a6e5159acce2e6
];

});


parcelRegister("dQ8tg", function(module, exports) {

$parcel$export(module.exports, "default", () => $a136b3de4435c1da$export$2e2bcd8739ae039);
function $a136b3de4435c1da$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("kLEYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1e7fb1342c636a8$export$2e2bcd8739ae039);
function $f1e7fb1342c636a8$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("lFv6k", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc658d534e08b6db$export$2e2bcd8739ae039);

var $jLR6t = parcelRequire("jLR6t");
var $fc658d534e08b6db$var$passive = {
    passive: true
};
function $fc658d534e08b6db$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $jLR6t.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $fc658d534e08b6db$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $fc658d534e08b6db$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $fc658d534e08b6db$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $fc658d534e08b6db$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $fc658d534e08b6db$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $fc658d534e08b6db$var$effect,
    data: {}
};

});

parcelRegister("7BANQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5898896686ae425d$export$2e2bcd8739ae039);

var $h8TFm = parcelRequire("h8TFm");
function $5898896686ae425d$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $h8TFm.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $5898896686ae425d$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $5898896686ae425d$var$popperOffsets,
    data: {}
};

});
parcelRegister("h8TFm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7ae5d2d3e7260e1$export$2e2bcd8739ae039);

var $dc3Oq = parcelRequire("dc3Oq");

var $K5O3a = parcelRequire("K5O3a");

var $4WF0V = parcelRequire("4WF0V");

var $iApVm = parcelRequire("iApVm");
function $c7ae5d2d3e7260e1$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $dc3Oq.default)(placement) : null;
    var variation = placement ? (0, $K5O3a.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $iApVm.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $iApVm.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $iApVm.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $iApVm.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $4WF0V.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $iApVm.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $iApVm.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("dc3Oq", function(module, exports) {

$parcel$export(module.exports, "default", () => $99af5a6b4a52896b$export$2e2bcd8739ae039);

function $99af5a6b4a52896b$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("K5O3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $08a8ccfe99949dae$export$2e2bcd8739ae039);
function $08a8ccfe99949dae$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("4WF0V", function(module, exports) {

$parcel$export(module.exports, "default", () => $399c64bbb5202a59$export$2e2bcd8739ae039);
function $399c64bbb5202a59$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("9KLSl", function(module, exports) {

$parcel$export(module.exports, "default", () => $719d8c09c49b7a14$export$2e2bcd8739ae039);

var $iApVm = parcelRequire("iApVm");

var $n5GX2 = parcelRequire("n5GX2");

var $jLR6t = parcelRequire("jLR6t");

var $haGKf = parcelRequire("haGKf");

var $hE1eD = parcelRequire("hE1eD");

var $dc3Oq = parcelRequire("dc3Oq");

var $K5O3a = parcelRequire("K5O3a");

var $1aMsW = parcelRequire("1aMsW");
var $719d8c09c49b7a14$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $719d8c09c49b7a14$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $1aMsW.round)(x * dpr) / dpr || 0,
        y: (0, $1aMsW.round)(y * dpr) / dpr || 0
    };
}
function $719d8c09c49b7a14$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $iApVm.left);
    var sideY = (0, $iApVm.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $n5GX2.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $jLR6t.default)(popper)) {
            offsetParent = (0, $haGKf.default)(popper);
            if ((0, $hE1eD.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $iApVm.top) || (placement === (0, $iApVm.left) || placement === (0, $iApVm.right)) && variation === (0, $iApVm.end)) {
            sideY = (0, $iApVm.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $iApVm.left) || (placement === (0, $iApVm.top) || placement === (0, $iApVm.bottom)) && variation === (0, $iApVm.end)) {
            sideX = (0, $iApVm.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $719d8c09c49b7a14$var$unsetSides);
    var _ref4 = roundOffsets === true ? $719d8c09c49b7a14$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $jLR6t.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $719d8c09c49b7a14$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $dc3Oq.default)(state.placement),
        variation: (0, $K5O3a.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $719d8c09c49b7a14$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $719d8c09c49b7a14$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $719d8c09c49b7a14$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $719d8c09c49b7a14$var$computeStyles,
    data: {}
};

});

parcelRegister("l6PRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5e26348094faaa3$export$2e2bcd8739ae039);

var $8x62b = parcelRequire("8x62b");

var $1NPtr = parcelRequire("1NPtr");
// and applies them to the HTMLElements such as popper and arrow
function $f5e26348094faaa3$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $1NPtr.isHTMLElement)(element) || !(0, $8x62b.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $f5e26348094faaa3$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $1NPtr.isHTMLElement)(element) || !(0, $8x62b.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $f5e26348094faaa3$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $f5e26348094faaa3$var$applyStyles,
    effect: $f5e26348094faaa3$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("lLxyM", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd8805141aa012f3$export$2e2bcd8739ae039);

var $dc3Oq = parcelRequire("dc3Oq");

var $iApVm = parcelRequire("iApVm");
function $fd8805141aa012f3$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $dc3Oq.default)(placement);
    var invertDistance = [
        (0, $iApVm.left),
        (0, $iApVm.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $iApVm.left),
        (0, $iApVm.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $fd8805141aa012f3$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $iApVm.placements).reduce(function(acc, placement) {
        acc[placement] = $fd8805141aa012f3$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $fd8805141aa012f3$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $fd8805141aa012f3$var$offset
};

});

parcelRegister("fhBPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b205c9823ca4d8a3$export$2e2bcd8739ae039);

var $5MtDQ = parcelRequire("5MtDQ");

var $dc3Oq = parcelRequire("dc3Oq");

var $2l6V5 = parcelRequire("2l6V5");

var $g0uQ5 = parcelRequire("g0uQ5");

var $5TLyK = parcelRequire("5TLyK");

var $iApVm = parcelRequire("iApVm");

var $K5O3a = parcelRequire("K5O3a");
function $b205c9823ca4d8a3$var$getExpandedFallbackPlacements(placement) {
    if ((0, $dc3Oq.default)(placement) === (0, $iApVm.auto)) return [];
    var oppositePlacement = (0, $5MtDQ.default)(placement);
    return [
        (0, $2l6V5.default)(placement),
        oppositePlacement,
        (0, $2l6V5.default)(oppositePlacement)
    ];
}
function $b205c9823ca4d8a3$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $dc3Oq.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $5MtDQ.default)(preferredPlacement)
    ] : $b205c9823ca4d8a3$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $dc3Oq.default)(placement) === (0, $iApVm.auto) ? (0, $5TLyK.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $dc3Oq.default)(placement);
        var isStartVariation = (0, $K5O3a.default)(placement) === (0, $iApVm.start);
        var isVertical = [
            (0, $iApVm.top),
            (0, $iApVm.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $g0uQ5.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $iApVm.right) : (0, $iApVm.left) : isStartVariation ? (0, $iApVm.bottom) : (0, $iApVm.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $5MtDQ.default)(mainVariationSide);
        var altVariationSide = (0, $5MtDQ.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b205c9823ca4d8a3$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $b205c9823ca4d8a3$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("5MtDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $43586da5f0031b80$export$2e2bcd8739ae039);
var $43586da5f0031b80$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $43586da5f0031b80$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $43586da5f0031b80$var$hash[matched];
    });
}

});

parcelRegister("2l6V5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b42e90e0a657b3d$export$2e2bcd8739ae039);
var $1b42e90e0a657b3d$var$hash = {
    start: 'end',
    end: 'start'
};
function $1b42e90e0a657b3d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $1b42e90e0a657b3d$var$hash[matched];
    });
}

});

parcelRegister("g0uQ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba74916f21266ef1$export$2e2bcd8739ae039);

var $5x7RN = parcelRequire("5x7RN");

var $haGKf = parcelRequire("haGKf");

var $4RsZx = parcelRequire("4RsZx");

var $h8TFm = parcelRequire("h8TFm");

var $1tw6h = parcelRequire("1tw6h");

var $iApVm = parcelRequire("iApVm");

var $1NPtr = parcelRequire("1NPtr");

var $eqpj7 = parcelRequire("eqpj7");

var $4kGOs = parcelRequire("4kGOs");
function $ba74916f21266ef1$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $iApVm.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $iApVm.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $iApVm.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $eqpj7.default)(typeof padding !== 'number' ? padding : (0, $4kGOs.default)(padding, (0, $iApVm.basePlacements)));
    var altContext = elementContext === (0, $iApVm.popper) ? (0, $iApVm.reference) : (0, $iApVm.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5x7RN.default)((0, $1NPtr.isElement)(element) ? element : element.contextElement || (0, $haGKf.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $4RsZx.default)(state.elements.reference);
    var popperOffsets = (0, $h8TFm.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $1tw6h.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $iApVm.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $iApVm.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $iApVm.right),
                (0, $iApVm.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $iApVm.top),
                (0, $iApVm.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5x7RN", function(module, exports) {

$parcel$export(module.exports, "default", () => $407622f423d15ad4$export$2e2bcd8739ae039);

var $iApVm = parcelRequire("iApVm");

var $3Iqcw = parcelRequire("3Iqcw");

var $5Zc7D = parcelRequire("5Zc7D");

var $d9u4j = parcelRequire("d9u4j");

var $n5GX2 = parcelRequire("n5GX2");

var $haGKf = parcelRequire("haGKf");

var $hE1eD = parcelRequire("hE1eD");

var $1NPtr = parcelRequire("1NPtr");

var $4RsZx = parcelRequire("4RsZx");

var $6f1Yi = parcelRequire("6f1Yi");

var $gopSB = parcelRequire("gopSB");

var $8x62b = parcelRequire("8x62b");

var $1tw6h = parcelRequire("1tw6h");

var $1aMsW = parcelRequire("1aMsW");
function $407622f423d15ad4$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $4RsZx.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $407622f423d15ad4$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $iApVm.viewport) ? (0, $1tw6h.default)((0, $3Iqcw.default)(element, strategy)) : (0, $1NPtr.isElement)(clippingParent) ? $407622f423d15ad4$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $1tw6h.default)((0, $5Zc7D.default)((0, $haGKf.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $407622f423d15ad4$var$getClippingParents(element) {
    var clippingParents = (0, $d9u4j.default)((0, $6f1Yi.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $hE1eD.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $1NPtr.isHTMLElement)(element) ? (0, $n5GX2.default)(element) : element;
    if (!(0, $1NPtr.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $1NPtr.isElement)(clippingParent) && (0, $gopSB.default)(clippingParent, clipperElement) && (0, $8x62b.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $407622f423d15ad4$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $407622f423d15ad4$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $407622f423d15ad4$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $1aMsW.max)(rect.top, accRect.top);
        accRect.right = (0, $1aMsW.min)(rect.right, accRect.right);
        accRect.bottom = (0, $1aMsW.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $1aMsW.max)(rect.left, accRect.left);
        return accRect;
    }, $407622f423d15ad4$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("3Iqcw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b49ce1f015f2294$export$2e2bcd8739ae039);

var $jLR6t = parcelRequire("jLR6t");

var $haGKf = parcelRequire("haGKf");

var $47uKA = parcelRequire("47uKA");

var $jE2je = parcelRequire("jE2je");
function $2b49ce1f015f2294$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $jLR6t.default)(element);
    var html = (0, $haGKf.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $jE2je.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $47uKA.default)(element),
        y: y
    };
}

});

parcelRegister("5Zc7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $011fefb36130bccf$export$2e2bcd8739ae039);

var $haGKf = parcelRequire("haGKf");

var $hE1eD = parcelRequire("hE1eD");

var $47uKA = parcelRequire("47uKA");

var $81df1 = parcelRequire("81df1");

var $1aMsW = parcelRequire("1aMsW");
function $011fefb36130bccf$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $haGKf.default)(element);
    var winScroll = (0, $81df1.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $1aMsW.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $1aMsW.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $47uKA.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $hE1eD.default)(body || html).direction === 'rtl') x += (0, $1aMsW.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("gopSB", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef2f663599c52df$export$2e2bcd8739ae039);

var $1NPtr = parcelRequire("1NPtr");
function $bef2f663599c52df$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $1NPtr.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("1tw6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $113166521d853740$export$2e2bcd8739ae039);
function $113166521d853740$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("eqpj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8071fe662688afb$export$2e2bcd8739ae039);

var $kZkU0 = parcelRequire("kZkU0");
function $a8071fe662688afb$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $kZkU0.default)(), paddingObject);
}

});
parcelRegister("kZkU0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f479b7ed958d6f3a$export$2e2bcd8739ae039);
function $f479b7ed958d6f3a$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("4kGOs", function(module, exports) {

$parcel$export(module.exports, "default", () => $327a3d6a70014801$export$2e2bcd8739ae039);
function $327a3d6a70014801$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("5TLyK", function(module, exports) {

$parcel$export(module.exports, "default", () => $44b6fb1b59530ffb$export$2e2bcd8739ae039);

var $K5O3a = parcelRequire("K5O3a");

var $iApVm = parcelRequire("iApVm");

var $g0uQ5 = parcelRequire("g0uQ5");

var $dc3Oq = parcelRequire("dc3Oq");
function $44b6fb1b59530ffb$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $iApVm.placements) : _options$allowedAutoP;
    var variation = (0, $K5O3a.default)(placement);
    var placements = variation ? flipVariations ? (0, $iApVm.variationPlacements) : (0, $iApVm.variationPlacements).filter(function(placement) {
        return (0, $K5O3a.default)(placement) === variation;
    }) : (0, $iApVm.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $g0uQ5.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $dc3Oq.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("geXxb", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd2c22689f37e30b$export$2e2bcd8739ae039);

var $iApVm = parcelRequire("iApVm");

var $dc3Oq = parcelRequire("dc3Oq");

var $4WF0V = parcelRequire("4WF0V");

var $9DiDF = parcelRequire("9DiDF");

var $jwXjP = parcelRequire("jwXjP");

var $8mi4M = parcelRequire("8mi4M");

var $n5GX2 = parcelRequire("n5GX2");

var $g0uQ5 = parcelRequire("g0uQ5");

var $K5O3a = parcelRequire("K5O3a");

var $kZkU0 = parcelRequire("kZkU0");

var $1aMsW = parcelRequire("1aMsW");
function $bd2c22689f37e30b$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $g0uQ5.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $dc3Oq.default)(state.placement);
    var variation = (0, $K5O3a.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $4WF0V.default)(basePlacement);
    var altAxis = (0, $9DiDF.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $iApVm.top) : (0, $iApVm.left);
        var altSide = mainAxis === 'y' ? (0, $iApVm.bottom) : (0, $iApVm.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $iApVm.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $iApVm.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $8mi4M.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $kZkU0.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $jwXjP.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $n5GX2.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $jwXjP.within)(tether ? (0, $1aMsW.min)(min, tetherMin) : min, offset, tether ? (0, $1aMsW.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $iApVm.top) : (0, $iApVm.left);
        var _altSide = mainAxis === 'x' ? (0, $iApVm.bottom) : (0, $iApVm.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $iApVm.top),
            (0, $iApVm.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $jwXjP.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $jwXjP.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $bd2c22689f37e30b$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $bd2c22689f37e30b$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("9DiDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $703636ddc8b8e36f$export$2e2bcd8739ae039);
function $703636ddc8b8e36f$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("jwXjP", function(module, exports) {

$parcel$export(module.exports, "within", () => $e37f04f7b2bb8fbe$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $e37f04f7b2bb8fbe$export$86c8af6d3ef0b4a);

var $1aMsW = parcelRequire("1aMsW");
function $e37f04f7b2bb8fbe$export$f28d906d67a997f3(min, value, max) {
    return (0, $1aMsW.max)(min, (0, $1aMsW.min)(value, max));
}
function $e37f04f7b2bb8fbe$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $e37f04f7b2bb8fbe$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("35AcE", function(module, exports) {

$parcel$export(module.exports, "default", () => $23fdebe2ff4a4900$export$2e2bcd8739ae039);

var $dc3Oq = parcelRequire("dc3Oq");

var $8mi4M = parcelRequire("8mi4M");

var $gopSB = parcelRequire("gopSB");

var $n5GX2 = parcelRequire("n5GX2");

var $4WF0V = parcelRequire("4WF0V");

var $jwXjP = parcelRequire("jwXjP");

var $eqpj7 = parcelRequire("eqpj7");

var $4kGOs = parcelRequire("4kGOs");

var $iApVm = parcelRequire("iApVm");
var $23fdebe2ff4a4900$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $eqpj7.default)(typeof padding !== 'number' ? padding : (0, $4kGOs.default)(padding, (0, $iApVm.basePlacements)));
};
function $23fdebe2ff4a4900$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $dc3Oq.default)(state.placement);
    var axis = (0, $4WF0V.default)(basePlacement);
    var isVertical = [
        (0, $iApVm.left),
        (0, $iApVm.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $23fdebe2ff4a4900$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $8mi4M.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $iApVm.top) : (0, $iApVm.left);
    var maxProp = axis === 'y' ? (0, $iApVm.bottom) : (0, $iApVm.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $n5GX2.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $jwXjP.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $23fdebe2ff4a4900$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $gopSB.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $23fdebe2ff4a4900$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $23fdebe2ff4a4900$var$arrow,
    effect: $23fdebe2ff4a4900$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("ertZm", function(module, exports) {

$parcel$export(module.exports, "default", () => $02b6a068f8e63868$export$2e2bcd8739ae039);

var $iApVm = parcelRequire("iApVm");

var $g0uQ5 = parcelRequire("g0uQ5");
function $02b6a068f8e63868$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $02b6a068f8e63868$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $iApVm.top),
        (0, $iApVm.right),
        (0, $iApVm.bottom),
        (0, $iApVm.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $02b6a068f8e63868$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $g0uQ5.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $g0uQ5.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $02b6a068f8e63868$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $02b6a068f8e63868$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $02b6a068f8e63868$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $02b6a068f8e63868$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $02b6a068f8e63868$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $02b6a068f8e63868$var$hide
};

});




parcelRegister("3ejJG", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $25a1fd0607584679$export$e0be378c32fb70a7);

var $eUqFw = parcelRequire("eUqFw");

var $k6muC = parcelRequire("k6muC");

var $iiw56 = parcelRequire("iiw56");

var $huDqj = parcelRequire("huDqj");
function $25a1fd0607584679$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eUqFw.useContext((0, $iiw56.ManagerReferenceNodeSetterContext));
    var refHandler = $eUqFw.useCallback(function(node) {
        (0, $huDqj.setRef)(innerRef, node);
        (0, $huDqj.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eUqFw.useEffect(function() {
        return function() {
            return (0, $huDqj.setRef)(innerRef, null);
        };
    }, []);
    $eUqFw.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $huDqj.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("asNSH", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $c9294410708307cc$export$3e67810a3f0e9f1c);
function $c9294410708307cc$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $c9294410708307cc$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $c9294410708307cc$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $c9294410708307cc$export$967a6b9924a689f7(a, b);
    return $c9294410708307cc$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("fspOv", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $b40d7e9c1dd54ebf$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $b40d7e9c1dd54ebf$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $b40d7e9c1dd54ebf$export$71abc632aa29e6fe);

var $kU09D = parcelRequire("kU09D");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $lkPEe = parcelRequire("lkPEe");

var $bPZtE = parcelRequire("bPZtE");

var $lcnyw = parcelRequire("lcnyw");

var $PdmhA = parcelRequire("PdmhA");
// ==============================
// Styled Components
// ==============================
const $b40d7e9c1dd54ebf$var$menuDialogStyles = (0, $byn9U.css)({
    backgroundColor: "var(--ds-surface-overlay, white)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $PdmhA.N40A)}, 0 4px 11px ${(0, $PdmhA.N40A)}`})`,
    zIndex: (0, $lcnyw.layers).modal()
});
const $b40d7e9c1dd54ebf$export$c94219dad7c0e37d = ({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId })=>(0, $byn9U.jsx)("div", {
        css: [
            $b40d7e9c1dd54ebf$var$menuDialogStyles,
            // There is not a limited amount of values for the widths, so they need
            // to remain dynamic.
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        ],
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`
    }, children);
// ==============================
// Custom Components
// ==============================
const $b40d7e9c1dd54ebf$var$dropdownStyles = (0, $byn9U.css)({
    marginInlineEnd: "var(--ds-space-025, 2px)",
    textAlign: 'center',
    width: 32
});
const $b40d7e9c1dd54ebf$var$DropdownIndicator = ()=>(0, $byn9U.jsx)("div", {
        css: $b40d7e9c1dd54ebf$var$dropdownStyles
    }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPZtE))), {
        label: "open"
    }));
const $b40d7e9c1dd54ebf$var$controlStyles = (0, $byn9U.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
});
const $b40d7e9c1dd54ebf$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>(0, $byn9U.jsx)("div", {
        ref: innerRef,
        css: $b40d7e9c1dd54ebf$var$controlStyles
    }, (0, $byn9U.jsx)((0, $jQxSL.c).Control, (0, $kU09D.default)({}, props, {
        innerProps: innerProps
    })));
const $b40d7e9c1dd54ebf$export$87ce933b7fc29b8c = (props)=>(0, $byn9U.jsx)((0, $lkPEe.default), null, (0, $byn9U.jsx)((0, $jQxSL.c).Control, props));
// NOTE `props` intentionally omitted from `Fragment`
const $b40d7e9c1dd54ebf$var$Menu = ({ children: children, innerProps: innerProps })=>(0, $byn9U.jsx)("div", innerProps, children);
const $b40d7e9c1dd54ebf$export$71abc632aa29e6fe = {
    Control: $b40d7e9c1dd54ebf$var$Control,
    DropdownIndicator: $b40d7e9c1dd54ebf$var$DropdownIndicator,
    Menu: $b40d7e9c1dd54ebf$var$Menu
};

});
parcelRegister("bPZtE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89e4253a013a6022$var$_react = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $89e4253a013a6022$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $89e4253a013a6022$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $89e4253a013a6022$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M14.823 15.883a5.5 5.5 0 111.06-1.06l2.647 2.647c.293.293.53.59 0 1.06-.53.47-.767.293-1.06 0l-2.647-2.647zM11.5 15.5a4 4 0 100-8 4 4 0 000 8z" fill="currentColor"/></svg>`
    }, props));
$89e4253a013a6022$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $89e4253a013a6022$var$_default = $89e4253a013a6022$var$EditorSearchIcon;
module.exports.default = $89e4253a013a6022$var$_default;

});



parcelRegister("kd4G1", function(module, exports) {

$parcel$export(module.exports, "buttonMaxWidth", () => $fad8645f4fa6a58a$export$ffcfc0a1074ba0d6);
$parcel$export(module.exports, "default", () => $fad8645f4fa6a58a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $f4A0J = parcelRequire("f4A0J");

var $8HBl8 = parcelRequire("8HBl8");

var $8cU5f = parcelRequire("8cU5f");

var $8uD7Y = parcelRequire("8uD7Y");
parcelRequire("f6MOn");

var $0WQKK = parcelRequire("0WQKK");
const $fad8645f4fa6a58a$export$ffcfc0a1074ba0d6 = 300; // px
const $fad8645f4fa6a58a$var$TargetButton = ({ selectedOption: selectedOption, isSelected: isSelected })=>{
    const isPublic = selectedOption.type === (0, $b9bd3ab49fd3c4c9$export$a3863626f98a38c2);
    const Icon = isPublic ? (0, (/*@__PURE__*/$parcel$interopDefault($8HBl8))) : (0, (/*@__PURE__*/$parcel$interopDefault($f4A0J)));
    const tooltipContent = !isPublic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $0WQKK.default).optionsTooltip,
        values: {
            value: selectedOption.value
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $0WQKK.default).publicTooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fad8645f4fa6a58a$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipContent,
        position: "left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        spacing: "default",
        isSelected: isSelected,
        shouldFitContainer: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fad8645f4fa6a58a$var$ButtonContent, {
            removeIconMargin: !isPublic
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            label: ""
        })),
        testId: "issue-comment-base.ui.comment.comment-visibility.button",
        interactionName: "auto-generated.issue-comment-base.ui.comment.comment-visibility.button.button"
    }, !isPublic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fad8645f4fa6a58a$var$OptionText, null, selectedOption.value))));
};
var $fad8645f4fa6a58a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $fad8645f4fa6a58a$var$TargetButton;
const $fad8645f4fa6a58a$var$ButtonContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { removeIconMargin: removeIconMargin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.removeIconMargin && "_18s83l1n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fad8645f4fa6a58a$var$OptionText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s _p12fr0r7 _18u01b66",
            __cmplp.className
        ])
    });
});
const $fad8645f4fa6a58a$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1mjv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("0WQKK", function(module, exports) {

$parcel$export(module.exports, "default", () => $6834d446a3685402$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6834d446a3685402$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    publicTooltip: {
        "id": "issue-comment-base.comment.comment-visibility.button.public-tooltip",
        "defaultMessage": "Visible to all users"
    },
    optionsTooltip: {
        "id": "issue-comment-base.comment.comment-visibility.button.options-tooltip",
        "defaultMessage": "Only visible to {value}"
    }
});

});


parcelRegister("ajLVr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa9f1e9a7c63c006$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $4ksts = parcelRequire("4ksts");

var $8chKh = parcelRequire("8chKh");

var $aVfY4 = parcelRequire("aVfY4");
const $fa9f1e9a7c63c006$var$ErrorImage = ()=>{
    const intl = (0, $4ksts.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa9f1e9a7c63c006$var$DialogContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa9f1e9a7c63c006$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa9f1e9a7c63c006$var$ErrorImageContainer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa9f1e9a7c63c006$var$ErrorMessageStyling, null, intl.formatMessage((0, $aVfY4.default).errorMessage))));
};
var $fa9f1e9a7c63c006$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $fa9f1e9a7c63c006$var$ErrorImage;
const $fa9f1e9a7c63c006$var$DialogContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbuuw1",
            __cmplp.className
        ])
    });
});
const $fa9f1e9a7c63c006$var$ErrorImageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1prxliv": (0, $9t7rW.default)((0, (/*@__PURE__*/$parcel$interopDefault($8chKh))), ")", "url(")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbys9h _4t3iys9h _18s85uws _11q71cf0",
            __cmplp.className
        ])
    });
});
const $fa9f1e9a7c63c006$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $fa9f1e9a7c63c006$var$ErrorMessageStyling = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8chKh", function(module, exports) {
module.exports = new URL("Error.6b090a72.svg", import.meta.url).toString();

});

parcelRegister("aVfY4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f9f7775c141375f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8f9f7775c141375f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "issue-comment-base.comment.comment-visibility.error-image.error-message",
        "defaultMessage": "We couldn't load the visibility options"
    }
});

});


parcelRegister("aHCyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4fb100db5d45963$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a4fb100db5d45963$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    visibleToAllUsers: {
        "id": "issue-comment-base.comment.comment-visibility.visible-to-all-users",
        "defaultMessage": "Visible to all users"
    },
    projectRolesLabel: {
        "id": "issue-comment-base.comment.comment-visibility.project-roles-label",
        "defaultMessage": "Project roles"
    },
    groupsLabel: {
        "id": "issue-comment-base.comment.comment-visibility.groups-label",
        "defaultMessage": "Groups"
    }
});

});

parcelRegister("cXP4L", function(module, exports) {

$parcel$export(module.exports, "transformOption", () => $9a73cee22a76700c$export$bd33285d78067b38);
$parcel$export(module.exports, "getDefaultOptionGroups", () => $9a73cee22a76700c$export$20e276c91fecd7dc);
$parcel$export(module.exports, "getEmptyOptionsWithInitialValue", () => $9a73cee22a76700c$export$7f1f10c5f9865ca9);

var $f6MOn = parcelRequire("f6MOn");

var $aHCyw = parcelRequire("aHCyw");

var $htKr7 = parcelRequire("htKr7");
const $9a73cee22a76700c$export$bd33285d78067b38 = ({ type: type, value: value, groupId: groupId })=>({
        type: type,
        value: value,
        groupId: groupId
    });
const $9a73cee22a76700c$var$transformCommentVisibilities = (options, value, type)=>options.filter((item)=>item.type === type).map((item)=>({
            ...item,
            selected: item ? (0, $htKr7.areCommentVisibilitiesEqual)(item, value) : false
        }));
const $9a73cee22a76700c$var$publicOption = (selectedOption)=>({
        label: '',
        options: [
            {
                ...(0, $f6MOn.COMMENT_VISIBILITY_PUBLIC),
                selected: selectedOption.type === (0, $b9bd3ab49fd3c4c9$export$a3863626f98a38c2)
            }
        ]
    });
const $9a73cee22a76700c$export$20e276c91fecd7dc = (options, formatMessage, selectedOption)=>[
        $9a73cee22a76700c$var$publicOption(selectedOption),
        {
            label: formatMessage((0, $aHCyw.default).projectRolesLabel),
            options: $9a73cee22a76700c$var$transformCommentVisibilities(options, selectedOption, (0, $b9bd3ab49fd3c4c9$export$28a8bb936dce2def))
        },
        {
            label: formatMessage((0, $aHCyw.default).groupsLabel),
            options: $9a73cee22a76700c$var$transformCommentVisibilities(options, selectedOption, (0, $b9bd3ab49fd3c4c9$export$537a061b2f9c8800))
        }
    ];
const $9a73cee22a76700c$export$7f1f10c5f9865ca9 = (initialValue, selectedOption, formatMessage)=>{
    const emptyOptionsGroup = [
        $9a73cee22a76700c$var$publicOption(selectedOption)
    ];
    if (initialValue) {
        const isInitialValueSelected = initialValue.type === selectedOption.type && initialValue.value === selectedOption.value;
        emptyOptionsGroup.push({
            label: initialValue.type === (0, $b9bd3ab49fd3c4c9$export$537a061b2f9c8800) ? formatMessage((0, $aHCyw.default).groupsLabel) : formatMessage((0, $aHCyw.default).projectRolesLabel),
            options: [
                {
                    ...initialValue,
                    selected: isInitialValueSelected
                }
            ]
        });
    }
    return emptyOptionsGroup;
};

});
parcelRegister("htKr7", function(module, exports) {

$parcel$export(module.exports, "areCommentVisibilitiesEqual", () => $8c8419d02311c49f$export$fa22c427e1c7f9e8);
const $8c8419d02311c49f$export$fa22c427e1c7f9e8 = (item, item2)=>item.value === item2.value && item.type === item2.type;

});


parcelRegister("dJFS1", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", () => $d90353bd699d3f1c$export$b08b517936747730);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
const $d90353bd699d3f1c$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d90353bd699d3f1c$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        testId: "issue-comment-base.ui.comment.comment-visibility.spinner.spinner"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d90353bd699d3f1c$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3iqkoa",
            __cmplp.className
        ])
    });
});

});




parcelRegister("4y397", function(module, exports) {

$parcel$export(module.exports, "EventOccurredAtSelector", () => $210bfe99fe48e344$export$b28045135b1492ee);

var $eUqFw = parcelRequire("eUqFw");

var $3xcI8 = parcelRequire("3xcI8");

var $bbmZl = parcelRequire("bbmZl");
var $h0vyZ = parcelRequire("h0vyZ");

var $7u4fN = parcelRequire("7u4fN");

var $3dY0o = parcelRequire("3dY0o");

var $7XRtk = parcelRequire("7XRtk");

var $aO9bw = parcelRequire("aO9bw");
var $1U6Rx = parcelRequire("1U6Rx");
var $8sN8t = parcelRequire("8sN8t");
var $8NdH4 = parcelRequire("8NdH4");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5ge6s = parcelRequire("5ge6s");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2wCUM = parcelRequire("2wCUM");

var $eHw0J = parcelRequire("eHw0J");

var $cWiVr = parcelRequire("cWiVr");

var $4xHig = parcelRequire("4xHig");

var $76Sm1 = parcelRequire("76Sm1");

var $j6hsl = parcelRequire("j6hsl");
const $210bfe99fe48e344$export$dc59854f87f8c633 = (args)=>args ? new Date(args) : new Date();
const $210bfe99fe48e344$var$CustomPopupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, 'data-testid': testId, ...containerProps }, ref)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $210bfe99fe48e344$var$dateTimePickerWrapperStyle,
        testId: testId,
        ...containerProps,
        ref: ref
    }, children));
const $210bfe99fe48e344$export$b28045135b1492ee = (props)=>{
    const locale = (0, $4xHig.useLocale)();
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5JgJ2.default)();
    const standardizedLocale = (0, $eHw0J.standardizeLocale)(locale);
    const currentUser = (0, $cWiVr.useCurrentUser)();
    const timeZone = currentUser.data.user && 'timeZone' in currentUser.data.user && typeof currentUser.data.user.timeZone !== 'undefined' ? currentUser.data.user.timeZone : Intl.DateTimeFormat().resolvedOptions().timeZone;
    const [dateTimeValue, updateDateTimeValue] = (0, $eUqFw.useState)(props.initialValue ? (0, $bbmZl.default)($210bfe99fe48e344$export$dc59854f87f8c633(props.initialValue), timeZone).toISOString() : null);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eUqFw.useState)(true);
    const [showDateTimePicker, changeShowDateTimePicker] = (0, $eUqFw.useState)(false);
    const isIssueOfIncidentPractice = (0, $2wCUM.useIsIssueOfIncidentsPractice)();
    if (!isIssueOfIncidentPractice) return null;
    const getOptions = ()=>{
        const options = [];
        for(let hour = 0; hour < 24; hour += 1)for(let min = 0; min < 60; min += 15){
            const hourPart = hour < 10 ? `0${hour}` : hour;
            const minPart = min < 10 ? `0${min}` : min;
            options.push(`${hourPart}:${minPart}`);
        }
        return options;
    };
    const times = getOptions();
    const fetchDate = (date)=>{
        const eventDate = $210bfe99fe48e344$export$dc59854f87f8c633(date);
        const dd = String(eventDate.getDate()).padStart(2, '0');
        const mm = String(eventDate.getMonth() + 1).padStart(2, '0');
        const yyyy = eventDate.getFullYear();
        return `${yyyy}-${mm}-${dd}`;
    };
    const onChangeDateTimePicker = (value)=>{
        if (value !== '') {
            const zonedTimeInUtc = (0, $h0vyZ.default)($210bfe99fe48e344$export$dc59854f87f8c633(value), timeZone);
            updateDateTimeValue(value);
            changeShowDateTimePicker(false);
            props.onChange(zonedTimeInUtc.getTime());
        } else {
            updateDateTimeValue(null);
            props.onChange(null);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1U6Rx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: showDateTimePicker,
        onClose: ()=>changeShowDateTimePicker(false),
        popupComponent: $210bfe99fe48e344$var$CustomPopupContainer,
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dY0o.default), {
                onChange: onChangeDateTimePicker,
                locale: standardizedLocale,
                value: dateTimeValue || undefined,
                datePickerProps: {
                    ...dateTimeValue == null ? {
                        placeholder: fetchDate((0, $bbmZl.default)($210bfe99fe48e344$export$dc59854f87f8c633(), timeZone))
                    } : {},
                    maxDate: (0, $bbmZl.default)((0, $3xcI8.default)($210bfe99fe48e344$export$dc59854f87f8c633().toISOString()), timeZone).toISOString()
                },
                timePickerProps: {
                    ...dateTimeValue == null && {
                        placeholder: (0, $bbmZl.default)($210bfe99fe48e344$export$dc59854f87f8c633(), timeZone).toLocaleTimeString([], {
                            hour: '2-digit',
                            minute: '2-digit'
                        })
                    },
                    times: times
                }
            }),
        trigger: (triggerProps)=>// eslint-disable-next-line react/jsx-props-no-spreading
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                ...triggerProps,
                xcss: $210bfe99fe48e344$var$wrapperStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
                name: "send-events-to-past-target"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7XRtk))), {
                    label: "",
                    size: "medium"
                }),
                onClick: ()=>{
                    changeShowDateTimePicker(!showDateTimePicker);
                },
                isSelected: showDateTimePicker
            }, showDateTimePicker ? formatMessage((0, $j6hsl.default).selectDateAndTimeText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, dateTimeValue ? formatDate(dateTimeValue, (0, $76Sm1.DATE_FORMAT)) : formatMessage((0, $j6hsl.default).addToPast)))))
    }), isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ge6s.default), {
        messageId: "spotlight-for-manual-incident-timelines"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8NdH4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aO9bw.default), {
        actions: [
            {
                onClick: ()=>setIsSpotlightActive(false),
                text: 'Dismiss'
            },
            {
                appearance: 'subtle',
                onClick: ()=>{
                    window.open('https://support.atlassian.com/jira-service-management-cloud/docs/what-is-the-incident-timeline/', '_blank');
                },
                text: 'Learn more'
            }
        ],
        heading: formatMessage((0, $j6hsl.default).spotlightHeading),
        target: "send-events-to-past-target",
        key: "send-events-to-past-target",
        targetRadius: 3,
        dialogPlacement: "right middle"
    }, formatMessage((0, $j6hsl.default).spotlightDescription)))));
};
const $210bfe99fe48e344$var$dateTimePickerWrapperStyle = (0, $1ZAYh.xcss)({
    width: '21rem'
});
const $210bfe99fe48e344$var$wrapperStyle = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.050'
});

});
parcelRegister("7XRtk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cc785836207fa6c$var$_react = $5cc785836207fa6c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $5cc785836207fa6c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5cc785836207fa6c$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $5cc785836207fa6c$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$5cc785836207fa6c$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $5cc785836207fa6c$var$_default = $5cc785836207fa6c$var$EmojiFrequentIcon;
module.exports.default = $5cc785836207fa6c$var$_default;

});

parcelRegister("eHw0J", function(module, exports) {

$parcel$export(module.exports, "standardizeLocale", () => $74eaa3a8d4b2e848$export$ca06804549ae25fb);
$parcel$export(module.exports, "verifyTimeZone", () => $74eaa3a8d4b2e848$export$93ff13646da25bd);

var $ao0hp = parcelRequire("ao0hp");

var $gUUjF = parcelRequire("gUUjF");
const $74eaa3a8d4b2e848$export$95b7602913551865 = 'en-US';
const $74eaa3a8d4b2e848$export$ca06804549ae25fb = (jiraLocale)=>{
    if (typeof jiraLocale !== 'string') {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jira-issue-format-date.standardize-locale', `Invalid input type for locale was passed in: ${jiraLocale}. Falling back to ${$74eaa3a8d4b2e848$export$95b7602913551865}.`);
        return $74eaa3a8d4b2e848$export$95b7602913551865;
    }
    const standardizedLocale = jiraLocale.replace('_', '-');
    switch(standardizedLocale){
        case 'en':
            return 'en-US';
        case 'en-UK':
            return 'en-GB';
        default:
            if (!(0, $ao0hp.default).includes(jiraLocale)) (0, $gUUjF.default).safeWarnWithoutCustomerData('jira-issue-format-date.standardize-locale', `Discovered unsupported locale: ${jiraLocale}. This value was not modified, but its use may lead to unpredictable behaviour for formatting.`);
            return standardizedLocale;
    }
};
const $74eaa3a8d4b2e848$export$93ff13646da25bd = (timeZone)=>{
    try {
        Intl.DateTimeFormat($74eaa3a8d4b2e848$export$95b7602913551865, {
            timeZone: timeZone
        });
        return timeZone;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jira-issue-format-date.verify-time-zone', `Invalid timeZone: ${String(timeZone)}. Date time formatting cannot be performed with this value. Falling back to undefined`, error);
        return undefined;
    }
};

});

parcelRegister("76Sm1", function(module, exports) {

$parcel$export(module.exports, "DATE_FORMAT", () => $4fbb7d92164c81e5$export$45c85543ba71221d);
const $4fbb7d92164c81e5$export$45c85543ba71221d = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};

});

parcelRegister("j6hsl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a51e75fed96d8cf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4a51e75fed96d8cf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addToPast: {
        "id": "issue-comment-base.comment.event-occurred-at-selector.add-to-past",
        "defaultMessage": "Add to past"
    },
    selectDateAndTimeText: {
        "id": "issue-comment-base.comment.event-occurred-at-selector.select-date-and-time-text",
        "defaultMessage": "Select date & time"
    },
    spotlightHeading: {
        "id": "issue-comment-base.comment.event-occurred-at-selector.spotlight-heading",
        "defaultMessage": "Add internal notes to the past"
    },
    spotlightDescription: {
        "id": "issue-comment-base.comment.event-occurred-at-selector.spotlight-description",
        "defaultMessage": "Assign any incident or post-incident review related activity to a specific date and time in the past using the internal notes feature. Click Add internal note > Select your desired date and time in the past > Save."
    }
});

});


parcelRegister("2StPr", function(module, exports) {

$parcel$export(module.exports, "isJsmTimelineEnabled", () => $bbf94eb665e9d514$export$575e1bf822db15b5);
$parcel$export(module.exports, "isCannedResponseFFEnabled", () => $bbf94eb665e9d514$export$9f71233b08c04922);

var $1ybV0 = parcelRequire("1ybV0");
const $bbf94eb665e9d514$export$575e1bf822db15b5 = ()=>(0, $1ybV0.ff)('jsm-timelines-phase-2_70gja', false);
const $bbf94eb665e9d514$export$9f71233b08c04922 = ()=>(0, $1ybV0.ff)('jsm-canned-response', false);

});

parcelRegister("lGT7F", function(module, exports) {

$parcel$export(module.exports, "AddCommentForm", () => $0a0b7a463c5da3b0$export$3b1e45ae95278b31);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $a576Y = parcelRequire("a576Y");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $iJlfe = parcelRequire("iJlfe");

var $ffiyv = parcelRequire("ffiyv");

var $dHsEU = parcelRequire("dHsEU");
var $3W0Cg = parcelRequire("3W0Cg");

var $auelM = parcelRequire("auelM");
var $a4zUq = parcelRequire("a4zUq");
var $e511u = parcelRequire("e511u");

var $zcJ0y = parcelRequire("zcJ0y");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $4ksts = parcelRequire("4ksts");

var $9SGG8 = parcelRequire("9SGG8");

var $hJ992 = parcelRequire("hJ992");

var $7GSu6 = parcelRequire("7GSu6");


var $cSEXi = parcelRequire("cSEXi");

var $autRb = parcelRequire("autRb");

var $jyFd9 = parcelRequire("jyFd9");

var $keOMr = parcelRequire("keOMr");

var $3Fnwd = parcelRequire("3Fnwd");


var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7Vbpp = parcelRequire("7Vbpp");

var $dE2jf = parcelRequire("dE2jf");

var $5Zdar = parcelRequire("5Zdar");

var $Otmhl = parcelRequire("Otmhl");

var $fYY80 = parcelRequire("fYY80");

const $0a0b7a463c5da3b0$var$resolveIssueEditor = ()=>(parcelRequire("5v6fH"));

const $0a0b7a463c5da3b0$export$eeacc38c67750323 = (0, $7rh0R.lazyForPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("5v6fH")), {
    moduleId: "./src/packages/issue/issue-view-activity-comment/src/comment-add/add-comment-editor/index.tsx"
});
const $0a0b7a463c5da3b0$var$STICKY_NAME = 'comment-add';
const $0a0b7a463c5da3b0$var$COMPACT_EDITOR_WIDTH = 550;
const $0a0b7a463c5da3b0$export$3b1e45ae95278b31 = ({ isServiceDesk: isServiceDesk = false, isLoading: isLoading = false, hasDraft: hasDraft = false, avatarUrl: avatarUrl, displayName: displayName = null, newCommentDraft: newCommentDraft = null, onExpand: onExpand = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSave: onSave = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onEdit: onEdit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onPaste: onPaste = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onBlur: onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isExpanded: isExpanded, isEditorFocused: isEditorFocused, editorSecondaryToolbarComponents: editorSecondaryToolbarComponents, sortOrder: sortOrder, onEditorExpandedWithAnalytics: onEditorExpandedWithAnalytics, containerWidth: containerWidth, isCannedResponseEnabled: isCannedResponseEnabled, forceFocus: forceFocus })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const isEmbedMode = (0, $keOMr.useIsEmbedMode)();
    const addCommentContainerRef = (0, $eUqFw.useRef)(null);
    const addCommentContainerBlockRef = (0, $eUqFw.useRef)(null);
    const editorContainerRef = (0, $eUqFw.useRef)(null);
    const containerBottomRef = (0, $eUqFw.useRef)(null);
    const containerTopRef = (0, $eUqFw.useRef)(null);
    const editorEndOrStartElementRef = (0, $eUqFw.useRef)(null);
    const overflowNodeRef = (0, $eUqFw.useRef)(null);
    const observerRef = (0, $eUqFw.useRef)(null);
    const mountedRef = (0, $eUqFw.useRef)(false);
    const editorActionsRef = (0, $eUqFw.useRef)(null);
    const [isKeylineVisible, setIsKeylineVisible] = (0, $eUqFw.useState)(false);
    const [shouldHide, setShouldHide] = (0, $eUqFw.useState)(false);
    const [touchingTop, setTouchingTop] = (0, $eUqFw.useState)(false); // is the form touching (or past) the top of the scroll area
    const [previousForceFocus, setPreviousForceFocus] = (0, $eUqFw.useState)(forceFocus);
    const previousIsExpanded = (0, $hzcvF.usePrevious)(isExpanded);
    const previousIsEditorFocused = (0, $hzcvF.usePrevious)(isEditorFocused);
    const isCompact = (0, $jyFd9.useIsCompactMode)();
    const isModal = (0, $hJ992.useIsModal)();
    const isLayered = isModal || isEmbedMode;
    const { registerSticky: registerSticky, deregisterSticky: deregisterSticky } = (0, $7GSu6.useStickyHeaderRegistration)();
    const isAgentSignatureEnabled = isCannedResponseEnabled && (0, $1ybV0.ff)('jsm-agent-signature-cr-enabled');
    const [signatureCrQueryReference, loadSignatureCrQuery] = (0, $iWLL0.useQueryLoader)((0, $a4zUq.SignatureCrFetchComponentQuery));
    const projectAri = (0, $dHsEU.useProjectAri)();
    const [signature, { setSignature: setSignature, resetSignature: resetSignature }] = (0, $3W0Cg.useSignature)();
    const setEditorContainerRef = (0, $eUqFw.useCallback)((container)=>{
        editorContainerRef.current = container;
    }, []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleOnEditorExpandedWithAnalytics = (0, $eUqFw.useCallback)(()=>{
        onEditorExpandedWithAnalytics();
    }, [
        onEditorExpandedWithAnalytics
    ]);
    const handleOnSave = (0, $eUqFw.useCallback)((value)=>{
        const isValueEmpty = (0, $7Vbpp.isOnlyWhitespaceAdf)(value);
        if (!isValueEmpty) {
            onSave?.(value);
            onCancel?.();
            isAgentSignatureEnabled && signature && (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'signatureCannedResponse inserted');
        }
    }, [
        onCancel,
        onSave,
        isAgentSignatureEnabled,
        signature,
        createAnalyticsEvent
    ]);
    const prefetchSignatureCr = (0, $eUqFw.useCallback)(()=>{
        !signatureCrQueryReference && loadSignatureCrQuery({
            projectAri: projectAri
        });
    }, [
        loadSignatureCrQuery,
        projectAri,
        signatureCrQueryReference
    ]);
    const handleOnExpand = (0, $eUqFw.useCallback)(()=>{
        onExpand?.();
        isAgentSignatureEnabled && $0a0b7a463c5da3b0$export$eeacc38c67750323.preload();
    }, [
        onExpand,
        isAgentSignatureEnabled
    ]);
    const setSticky = (0, $eUqFw.useCallback)(()=>{
        if (sortOrder === (0, $25476979aca7c7e0$export$e86669f498228fff)) {
            if (overflowNodeRef.current && containerBottomRef.current) {
                const { current: currentOverflowNodeRef } = overflowNodeRef;
                const { current: currentContainerBottomRef } = containerBottomRef;
                const overflowNodeRect = currentOverflowNodeRef.getBoundingClientRect();
                const containerRect = currentContainerBottomRef.getBoundingClientRect();
                const overflowNodeBottom = Math.min(overflowNodeRect.bottom, window.innerHeight);
                const isKeylineVisibleNew = !isExpanded && containerRect.bottom >= overflowNodeBottom;
                setIsKeylineVisible(isKeylineVisibleNew);
            }
        } else if (sortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c)) {
            if (overflowNodeRef.current && containerTopRef.current && containerBottomRef.current) {
                const { current: currentOverflowNodeRef } = overflowNodeRef;
                const { current: currentContainerBottomRef } = containerBottomRef;
                const { current: currentContainerTopRef } = containerTopRef;
                const overflowNodeRect = currentOverflowNodeRef.getBoundingClientRect();
                const containerTopRect = currentContainerTopRef.getBoundingClientRect();
                const containerBottomRect = currentContainerBottomRef.getBoundingClientRect();
                const overflowNodeBottom = Math.min(overflowNodeRect.bottom, window.innerHeight);
                const overflowNodeTop = Math.min(overflowNodeRect.top, window.innerHeight);
                const isKeylineVisibleToTop = !isExpanded && containerTopRect.top <= overflowNodeTop;
                const isKeylineVisibleToBottom = !isExpanded && containerBottomRect.bottom >= overflowNodeBottom;
                const isKeylineVisibleNew = isKeylineVisibleToTop || isKeylineVisibleToBottom;
                setIsKeylineVisible(isKeylineVisibleNew);
            }
        }
    }, [
        isExpanded,
        sortOrder
    ]);
    const throttledSticky = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(setSticky, 100), [
        setSticky
    ]);
    const getScrollParent = (0, $eUqFw.useCallback)((node)=>{
        // If we reach the issue app wrapper class we have gone too far, this check is in place to
        // ensure we don't stick to the view port or another scrollable div further up the DOM tree.
        if (!node || node.className === (0, $cSEXi.issueAppModalWrapperClassName)) return null;
        if (window.getComputedStyle(node).overflowY === 'auto' || window.getComputedStyle(node).overflowY === 'scroll') return node;
        return getScrollParent(node.parentElement);
    }, []);
    const setOverflowNode = (0, $eUqFw.useCallback)(()=>{
        if (!overflowNodeRef.current) overflowNodeRef.current = getScrollParent(containerBottomRef.current);
        setSticky();
    }, [
        getScrollParent,
        setSticky
    ]);
    const scrollEditorIntoView = (0, $eUqFw.useCallback)(()=>{
        // The purpose of the timeout is to wait until the editor has expanded,
        // so we get the correct height for this calculation.
        setTimeout(()=>{
            (0, $autRb.smoothScrollIntoViewIfNeeded)(addCommentContainerRef.current, {
                scrollMode: 'if-needed',
                behavior: 'auto',
                // This takes into account a user who may have turned off scrolling animations at the browser level who may have animation sickness etc.
                block: 'end'
            });
        });
    }, []);
    /**
   * This sets up an IntersectionObserver to check whether the comment form is outside of the viewport. In that case
   * we need to update the `isKeylineVisible` state to show the keyline above the comment form. There is no other good way to be notified
   * whether an element has entered the 'sticky' position or not.
   *
   * We also use the same IntersectionObserver to monitor when the
   * editor has entered or left the viewport to decide if we should hide the sticky add comment box
   *
   * It is required for cases where the position of the comment box changes independent of resizes, for example when
   * content above the comment form pushes it down below the viewport (for example, when an image has finished loading).
   *
   * This does not work in Safari / IE11, so they won't see the keyline. The comment form will still be sticky however, as
   * that's solved by just CSS (except for IE11).
   */ const setupStickyObserver = (0, $eUqFw.useCallback)(()=>{
        if (window.IntersectionObserver && containerBottomRef.current && containerTopRef.current) {
            const { current: currentContainerBottomRef } = containerBottomRef;
            const { current: currentContainerTopRef } = containerTopRef;
            const handleIntersect = (entries)=>{
                entries.forEach((entry)=>{
                    const isKeylineVisibleNewValue = !isExpanded && !entry.isIntersecting;
                    switch(entry.target){
                        case currentContainerTopRef:
                            if (entry.boundingClientRect && entry.rootBounds && entry.boundingClientRect.top <= entry.rootBounds.top) setTouchingTop(true);
                            else setTouchingTop(false);
                            setIsKeylineVisible(isKeylineVisibleNewValue);
                            break;
                        case editorEndOrStartElementRef.current:
                            {
                                // We are checking boundingClientRect.y to ensure that the editor
                                // is trailing off the bottom of the page, not the top
                                const oldestFirstShouldHide = !entry.rootBounds || !entry.isIntersecting && entry.boundingClientRect.y >= 0 && entry.boundingClientRect.y >= entry.rootBounds.y;
                                const newestFirstShouldHide = !entry.rootBounds || !entry.isIntersecting && entry.boundingClientRect.y <= entry.rootBounds.y;
                                const shouldHideNew = sortOrder === (0, $25476979aca7c7e0$export$e86669f498228fff) ? oldestFirstShouldHide : newestFirstShouldHide;
                                setShouldHide(shouldHideNew);
                                break;
                            }
                        default:
                            break;
                    }
                });
            };
            const options = {
                root: overflowNodeRef.current,
                rootMargin: '0px',
                threshold: 0
            };
            observerRef.current = new IntersectionObserver(handleIntersect, options);
            const { current: observer } = observerRef;
            observer.observe(currentContainerBottomRef);
            observer.observe(currentContainerTopRef);
        }
    }, [
        isExpanded,
        sortOrder
    ]);
    const setupStickyHidingObserver = (0, $eUqFw.useCallback)(()=>{
        if (window.IntersectionObserver && observerRef.current) // The editor is loaded async so we need to wait for:
        // 1: the Editor bundle to load async via the exported promise
        // 2: a setTimeout to allow the editor time to render itself properly on the DOM
        $0a0b7a463c5da3b0$var$resolveIssueEditor().then(()=>setTimeout(()=>{
                // find markers pointing to the Editor's "nearest" edge
                const nodes = overflowNodeRef.current?.getElementsByClassName(sortOrder === (0, $25476979aca7c7e0$export$e86669f498228fff) ? (0, $cSEXi.EDITOR_END_CLASS_NAME) : (0, $cSEXi.EDITOR_START_CLASS_NAME)) || [];
                // expectation is to have two nodes - one is "add-comment-form", and another is the real editor
                // the order depends on the sortOrder
                editorEndOrStartElementRef.current = nodes.length === 2 ? nodes[sortOrder === (0, $25476979aca7c7e0$export$e86669f498228fff) ? 0 : 1] : // if we have any other number of nodes - consider as undefined behavior and ignore
                null;
                // FIXME: editorEndOrStartElementRef.current should be stored in State, not in ref
                // that will simplify and unify logic to observe and unobserve
                if (editorEndOrStartElementRef.current && observerRef.current) observerRef.current.observe(editorEndOrStartElementRef.current);
            }));
    }, [
        sortOrder
    ]);
    const deferredComponentDidMount = (0, $eUqFw.useCallback)(()=>{
        overflowNodeRef.current = getScrollParent(containerBottomRef.current);
        // We only want to react to resize and scroll events and ensure stickiness when
        // *NOT* running in IE11. In IE11, sticky simply does not work and by registering
        // these listeners in IE11, we end up sending a lot of errors to Sentry.
        if (!(0, $zcJ0y.isIE11)()) {
            window.addEventListener('resize', setOverflowNode);
            if (overflowNodeRef.current) {
                overflowNodeRef.current.addEventListener('scroll', throttledSticky);
                setSticky();
            }
        }
        if (isExpanded) scrollEditorIntoView();
        setupStickyObserver();
        if (isEditorFocused) setupStickyHidingObserver();
    }, [
        getScrollParent,
        isEditorFocused,
        isExpanded,
        scrollEditorIntoView,
        setOverflowNode,
        setSticky,
        throttledSticky,
        setupStickyHidingObserver,
        setupStickyObserver
    ]);
    const removeStickyHidingObserver = (0, $eUqFw.useCallback)(()=>{
        if (window.IntersectionObserver && observerRef.current && editorEndOrStartElementRef.current) observerRef.current.unobserve(editorEndOrStartElementRef.current);
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        requestAnimationFrame(()=>deferredComponentDidMount());
        return ()=>{
            if (!(0, $zcJ0y.isIE11)()) {
                window.removeEventListener('resize', setOverflowNode);
                if (overflowNodeRef.current) overflowNodeRef.current.removeEventListener('scroll', throttledSticky);
            }
            const { current: currentContainerBottomRef } = containerBottomRef;
            const { current: currentContainerTopRef } = containerTopRef;
            if (observerRef.current && currentContainerBottomRef) observerRef.current.unobserve(currentContainerBottomRef);
            if (observerRef.current && currentContainerTopRef) observerRef.current.unobserve(currentContainerTopRef);
            if (observerRef.current && editorEndOrStartElementRef.current) observerRef.current.unobserve(editorEndOrStartElementRef.current);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>()=>{
            resetSignature();
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $eUqFw.useEffect)(()=>{
        if (!mountedRef.current) mountedRef.current = true;
        else {
            if (Boolean(previousIsExpanded) === false && isExpanded) scrollEditorIntoView();
            if (previousIsEditorFocused !== isEditorFocused) {
                if (isEditorFocused) setupStickyHidingObserver();
                else // Since the DOM element we are observing will be removed from the page, we should stop observing
                removeStickyHidingObserver();
            }
        }
    }, [
        isEditorFocused,
        isExpanded,
        previousIsEditorFocused,
        previousIsExpanded,
        removeStickyHidingObserver,
        scrollEditorIntoView,
        setupStickyHidingObserver,
        deregisterSticky
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (addCommentContainerBlockRef.current && touchingTop && !shouldHide && !isCompact && sortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) && !isExpanded) registerSticky($0a0b7a463c5da3b0$var$STICKY_NAME, addCommentContainerBlockRef);
        else deregisterSticky($0a0b7a463c5da3b0$var$STICKY_NAME);
        return ()=>{
            deregisterSticky($0a0b7a463c5da3b0$var$STICKY_NAME);
        };
    }, [
        shouldHide,
        touchingTop,
        isCompact,
        sortOrder,
        isExpanded,
        deregisterSticky,
        registerSticky
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (forceFocus !== previousForceFocus && editorActionsRef?.current) {
            editorActionsRef?.current.focus();
            setPreviousForceFocus(forceFocus);
        }
    }, [
        editorActionsRef,
        forceFocus,
        previousForceFocus
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isAgentSignatureEnabled && !signatureCrQueryReference && isExpanded) loadSignatureCrQuery && loadSignatureCrQuery({
            projectAri: projectAri
        });
    }, [
        isExpanded,
        isAgentSignatureEnabled,
        signatureCrQueryReference,
        loadSignatureCrQuery,
        projectAri
    ]);
    const isHidden = isEditorFocused && shouldHide && !isExpanded;
    // We need to be able to determine if add comment should stick to the top.
    // Normally it should when sorted NEWEST_FIRST, but we want to avoid this when the issue isCompact
    // to prevent it from blocking the issue actions at the top.
    const shouldApplyTopSticky = sortOrder !== (0, $25476979aca7c7e0$export$e86669f498228fff) && !isCompact;
    const setSignatureCRData = (0, $eUqFw.useCallback)((signatureCR)=>{
        setSignature(signatureCR);
    }, [
        setSignature
    ]);
    const addCommentEditor = (0, $eUqFw.useMemo)(()=>{
        const placeholder = hasDraft && !(0, $7Vbpp.isOnlyWhitespaceAdf)(newCommentDraft) ? `\u{2022} ${formatMessage((0, $Otmhl.messages).draftPlaceholder)}` : formatMessage((0, $Otmhl.messages).placeholder);
        const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dE2jf.IssueAddCommentEditorLoading), {
            placeholder: placeholder,
            onExpanded: handleOnEditorExpandedWithAnalytics
        });
        const isEditorCompact = !!containerWidth && containerWidth < $0a0b7a463c5da3b0$var$COMPACT_EDITOR_WIDTH;
        const primaryToolbarComponents = isCannedResponseEnabled ? (editorActions)=>[
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $auelM.CannedResponseToolbarButton), {
                    key: "cannedResponseToolbarButton",
                    editorActions: editorActions,
                    isCompact: isEditorCompact
                })
            ] : undefined;
        const commentButtonActions = isAgentSignatureEnabled ? {
            onFocus: prefetchSignatureCr,
            onMouseEnter: prefetchSignatureCr
        } : undefined;
        const focusAtStart = !!(isAgentSignatureEnabled && !newCommentDraft && signature);
        const addCommentEditorComponent = ({ assistiveLabel: assistiveLabel = '' })=>{
            if (isAgentSignatureEnabled && signatureCrQueryReference && signature === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e511u.SignatureCrFetchWrapper), {
                queryReference: signatureCrQueryReference,
                setSignatureCR: setSignatureCRData
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dE2jf.IssueAddCommentEditorBoundary), {
                packageName: "issue",
                fallback: fallback
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0a0b7a463c5da3b0$export$eeacc38c67750323, {
                externalId: "issue.comment.add-form",
                defaultValue: newCommentDraft || signature || undefined,
                isExpanded: isExpanded,
                shouldFocus: true,
                collapsedPlaceholder: placeholder,
                placeholder: isCannedResponseEnabled ? formatMessage((0, $Otmhl.messages).cannedResponsesPlaceholder) : formatMessage((0, $Otmhl.messages).easyMentionsPlaceholder),
                onExpanded: handleOnEditorExpandedWithAnalytics,
                onChange: onEdit,
                onSave: handleOnSave,
                onPaste: onPaste,
                onBlur: onBlur,
                onCancel: onCancel,
                isLoading: isLoading,
                secondaryToolbarComponents: editorSecondaryToolbarComponents,
                isCannedResponseEnabled: isCannedResponseEnabled,
                primaryToolbarComponents: primaryToolbarComponents,
                actionsRef: editorActionsRef,
                ...assistiveLabel && {
                    assistiveLabel: assistiveLabel
                },
                focusAtStart: focusAtStart
            }));
        };
        return isServiceDesk ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Fnwd.default), {
            isExpanded: isExpanded,
            onExpanded: handleOnExpand,
            commentId: (0, $b10b5cb385fb5d46$export$c4134c813c47beb0),
            commentButtonActions: commentButtonActions
        }, addCommentEditorComponent) : addCommentEditorComponent({
            assistiveLabel: formatMessage((0, $Otmhl.messages).comment)
        });
    }, [
        hasDraft,
        newCommentDraft,
        formatMessage,
        handleOnEditorExpandedWithAnalytics,
        containerWidth,
        isCannedResponseEnabled,
        isExpanded,
        onEdit,
        handleOnSave,
        onPaste,
        onBlur,
        onCancel,
        isLoading,
        editorSecondaryToolbarComponents,
        editorActionsRef,
        isServiceDesk,
        handleOnExpand,
        signatureCrQueryReference,
        isAgentSignatureEnabled,
        signature,
        setSignatureCRData,
        prefetchSignatureCr
    ]);
    const shortcutKey = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, "M"), []);
    const proTipText = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $Otmhl.messages).commentShortcutHintHeading)), []);
    const avatarAriaLabel = (0, $eUqFw.useMemo)(()=>displayName !== null && displayName !== '' ? formatMessage((0, $Otmhl.messages).userAvatarAriaLabel, {
            displayName: displayName
        }) : undefined, [
        displayName,
        formatMessage
    ]);
    const commentShortCutHint = (0, $eUqFw.useMemo)(()=>!isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Zdar.default), {
            messageDescriptor: (0, $Otmhl.messages).commentShortcutHintMessage,
            values: {
                shortcutKey: shortcutKey,
                proTipText: proTipText
            }
        }), [
        isExpanded,
        proTipText,
        shortcutKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ref: addCommentContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ref: containerTopRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fYY80.StickyWrapper), {
        sortOrder: sortOrder,
        isModal: isLayered,
        isHidden: isHidden,
        isKeylineVisible: isKeylineVisible,
        shouldApplySticky: !isExpanded,
        shouldApplyTopSticky: shouldApplyTopSticky
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fYY80.Wrapper), {
        isModal: isLayered,
        isKeylineVisible: isKeylineVisible,
        sortOrder: sortOrder,
        shouldApplySticky: !isExpanded,
        shouldApplyTopSticky: shouldApplyTopSticky,
        ref: (container)=>{
            addCommentContainerBlockRef.current = container;
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fYY80.AvatarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "medium",
        src: avatarUrl || undefined,
        name: avatarAriaLabel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9SGG8.EditorContainer), {
        ref: setEditorContainerRef,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "issue.activity.comment"
    }, addCommentEditor, commentShortCutHint))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ref: containerBottomRef
    }));
};

});
parcelRegister("dHsEU", function(module, exports) {

$parcel$export(module.exports, "useProjectAri", () => $e31471116bc2d6fc$export$8688254b761eadc4);

var $8npnf = parcelRequire("8npnf");

var $hJ992 = parcelRequire("hJ992");

var $guDlK = parcelRequire("guDlK");

var $dWLk9 = parcelRequire("dWLk9");
const $e31471116bc2d6fc$export$8688254b761eadc4 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectId = (0, $guDlK.useProjectId)(projectKey);
    const siteId = (0, $dWLk9.useCloudId)();
    const projectAri = projectId && (0, $8npnf.JiraProjectAri).create({
        siteId: siteId,
        projectId: projectId
    }).toString();
    return projectAri || '';
};

});
parcelRegister("8npnf", function(module, exports) {

$parcel$export(module.exports, "JiraProjectAri", () => $682906413775fbdd$export$75a0a0a7cb0a58ae);

var $dbOi4 = parcelRequire("dbOi4");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/project/manifest.ts
var $682906413775fbdd$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $dbOi4.JiraProjectAriResourceOwner),
    resourceType: (0, $dbOi4.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $682906413775fbdd$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $682906413775fbdd$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $682906413775fbdd$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $682906413775fbdd$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $682906413775fbdd$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $682906413775fbdd$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $682906413775fbdd$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
};

});
parcelRegister("dbOi4", function(module, exports) {

$parcel$export(module.exports, "JiraProjectAriResourceOwner", () => $fc714a2435bc97e4$export$99d538a3b04916b1);
$parcel$export(module.exports, "JiraProjectAriResourceType", () => $fc714a2435bc97e4$export$736763838d3aa22e);
// src/jira/project/types.ts
var $fc714a2435bc97e4$export$99d538a3b04916b1 = "jira", $fc714a2435bc97e4$export$736763838d3aa22e = "project";

});



parcelRegister("3W0Cg", function(module, exports) {

$parcel$export(module.exports, "useSignature", () => $62539245dbb31bd0$export$9f441453ff0620ff);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $36xIQ = parcelRequire("36xIQ");

var $dgDlB = parcelRequire("dgDlB");
const $62539245dbb31bd0$var$initialState = {
    signature: undefined
};
const $62539245dbb31bd0$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    initialState: $62539245dbb31bd0$var$initialState,
    actions: $36xIQ.actions,
    name: 'CannedResponseCommonStore'
});
const $62539245dbb31bd0$export$9f441453ff0620ff = (0, $ggKAj.createHook)($62539245dbb31bd0$export$6f57813fe9f31bf9, {
    selector: (0, $dgDlB.getSignature)
});

});
parcelRegister("36xIQ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $8113bc69984ec1cc$export$e324594224ef24da);

var $2jfdy = parcelRequire("2jfdy");
const $8113bc69984ec1cc$export$e324594224ef24da = {
    setSignature: $2jfdy.setSignature,
    resetSignature: $2jfdy.resetSignature
};

});
parcelRegister("2jfdy", function(module, exports) {

$parcel$export(module.exports, "setSignature", () => $b243ee0cd851f42c$export$db61683581bf65b7);
$parcel$export(module.exports, "resetSignature", () => $b243ee0cd851f42c$export$2dca26ca8969a3aa);
const $b243ee0cd851f42c$export$db61683581bf65b7 = (cannedResponseContent)=>async ({ getState: getState, setState: setState })=>{
        const formattedContent = cannedResponseContent && JSON.parse(cannedResponseContent);
        setState({
            ...getState(),
            signature: formattedContent || null
        });
    };
const $b243ee0cd851f42c$export$2dca26ca8969a3aa = ()=>async ({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            signature: undefined
        });
    };

});


parcelRegister("dgDlB", function(module, exports) {

$parcel$export(module.exports, "getSignature", () => $1dbf655e9fdc97f7$export$2f768fec5d73d91a);
const $1dbf655e9fdc97f7$export$2f768fec5d73d91a = (state)=>state.signature;

});


parcelRegister("auelM", function(module, exports) {

$parcel$export(module.exports, "CannedResponseToolbarButton", () => $3786675e075fd896$export$4f454379b367e814);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $04yGa = parcelRequire("04yGa");

var $8cU5f = parcelRequire("8cU5f");

var $ea0Qe = parcelRequire("ea0Qe");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hALzt = parcelRequire("hALzt");

var $lE405 = parcelRequire("lE405");
const $3786675e075fd896$export$4f454379b367e814 = ({ editorActions: editorActions, isCompact: isCompact = false })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage, locale: locale } = (0, $5JgJ2.default)();
    const [content, setContent] = (0, $eUqFw.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [issueViewData, setIssueViewData] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        // need to make sure that dropdown is closed before inserting extension node to manage cursor position
        if (!isOpen && content && issueViewData) (0, $ea0Qe.insertCannedResponseInEditor)(content, issueViewData, editorActions);
        else if (!isOpen && !content) (0, $ea0Qe.focusEditor)(editorActions);
    }, [
        isOpen,
        content,
        editorActions,
        issueViewData
    ]);
    const openModal = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'cannedResponsesButton clicked');
        setContent(null);
        setIsOpen(true);
    }, [
        createAnalyticsEvent
    ]);
    const closeModal = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const onInsert = (cannedResponseContent, templateVariableData)=>{
        setIsOpen(false);
        setContent(cannedResponseContent);
        setIssueViewData(templateVariableData);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $lE405.default).cannedResponseToolbarButton),
        testId: "canned-response-extension.ui.canned-response-toolbar-button.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: openModal,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($04yGa))), {
            label: formatMessage((0, $lE405.default).cannedResponseToolbarButton),
            size: "medium"
        })
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: openModal,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($04yGa))), {
            label: "",
            size: "medium"
        })
    }, formatMessage((0, $lE405.default).cannedResponseToolbarButton)), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hALzt.default), {
        isOpen: isOpen,
        onClose: closeModal,
        intlLocale: locale,
        onInsert: onInsert
    }));
};
var $3786675e075fd896$export$2e2bcd8739ae039 = $3786675e075fd896$export$4f454379b367e814;

});
parcelRegister("04yGa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00db4662892de9af$var$_react = $00db4662892de9af$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $00db4662892de9af$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $00db4662892de9af$var$MediaServicesAddCommentIcon = (props)=>/*#__PURE__*/ $00db4662892de9af$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M14 4.187A10.704 10.704 0 0012 4c-4.963 0-9 3.37-9 7.513s4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 00.164.033.515.515 0 00.474-.716v-.002s-1.563-2.26-.766-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513a6.34 6.34 0 00-.02-.513h-2.008c.02.169.03.34.03.513 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51 0-3.038 3.141-5.51 7.002-5.51.695 0 1.366.08 2 .229V4.187z"/><rect x="17" y="4" width="2" height="6" rx="1"/><rect x="15" y="6" width="6" height="2" rx="1"/></g></svg>`
    }, props));
$00db4662892de9af$var$MediaServicesAddCommentIcon.displayName = 'MediaServicesAddCommentIcon';
var $00db4662892de9af$var$_default = $00db4662892de9af$var$MediaServicesAddCommentIcon;
module.exports.default = $00db4662892de9af$var$_default;

});

parcelRegister("ea0Qe", function(module, exports) {

$parcel$export(module.exports, "insertADFNodesInEditor", () => $42c094802e0404dd$export$256652f71aefa6b0);
$parcel$export(module.exports, "insertCannedResponseInEditor", () => $42c094802e0404dd$export$ce7efcf9a240236b);
$parcel$export(module.exports, "focusEditor", () => $42c094802e0404dd$export$dae10379fc585a50);
$parcel$export(module.exports, "hasTemplateVariables", () => $42c094802e0404dd$export$b7761960cfe1604);

var $12nnS = parcelRequire("12nnS");
var $fkCu1 = parcelRequire("fkCu1");

var $eplIb = parcelRequire("eplIb");

var $guiFP = parcelRequire("guiFP");


var $bkyWF = parcelRequire("bkyWF");
const $42c094802e0404dd$var$DOC_TYPE = 'doc';
const $42c094802e0404dd$var$PARAGRAPH_NODE_TYPE = 'paragraph';
const $42c094802e0404dd$export$9b537081e5efeb02 = (document)=>{
    if (document && document.type === $42c094802e0404dd$var$DOC_TYPE && Array.isArray(document.content) && document.content.length && document.content[0].type === $42c094802e0404dd$var$PARAGRAPH_NODE_TYPE) {
        const firstNodeContent = document.content[0].content;
        const contentWithoutFirstParagraph = document.content.slice(1);
        if (Array.isArray(firstNodeContent) && Array.isArray(contentWithoutFirstParagraph)) {
            const newContent = Array.isArray(firstNodeContent) && Array.isArray(contentWithoutFirstParagraph) ? [
                ...firstNodeContent,
                ...contentWithoutFirstParagraph
            ] : [];
            const formattedDocument = {
                ...document,
                content: newContent
            };
            return formattedDocument;
        }
    }
    return document;
};
const $42c094802e0404dd$export$d9a4e0037b7dfe53 = (document, issueData)=>{
    const updatedDoc = (0, $fkCu1.traverse)(document, {
        inlineExtension: (extNode)=>{
            if (extNode.attrs) {
                const { extensionKey: extensionKey, text: text, parameters: parameters } = extNode.attrs;
                if (extensionKey === (0, $c138a99bd60d32bc$export$42c498377b6a6569)) {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    if (!issueData[text]) return false;
                    switch(parameters?.type){
                        case (0, $bkyWF.ADFNode).INLINE_CARD:
                            return {
                                type: 'inlineCard',
                                attrs: {
                                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                    url: issueData[text]
                                }
                            };
                        case (0, $bkyWF.ADFNode).TEXT:
                            return {
                                type: 'text',
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                text: issueData[text]
                            };
                        default:
                            return {
                                type: 'text',
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                text: issueData[text]
                            };
                    }
                }
            }
            return extNode;
        }
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return updatedDoc;
};
const $42c094802e0404dd$export$256652f71aefa6b0 = (doc, editorActions)=>{
    if (editorActions) {
        const editorView = editorActions._privateGetEditorView();
        if (editorView) try {
            editorView.focus();
            const { selection: selection, schema: schema, tr: tr } = editorView.state || {};
            const { from: from, to: to } = selection;
            const formattedDoc = $42c094802e0404dd$export$9b537081e5efeb02(doc);
            const cannedResponseNodes = schema.nodeFromJSON(formattedDoc);
            const replacementTextLength = cannedResponseNodes.content.size ? from + cannedResponseNodes.content.size : from + 1;
            const emptyPara = schema.nodeFromJSON({
                type: 'text',
                text: ' '
            });
            editorView.dispatch(tr.replaceRangeWith(from, to, cannedResponseNodes));
            (0, $eplIb.setTextSelection)(editorView, replacementTextLength);
            editorView.dispatch(editorView.state.tr.insert(replacementTextLength, emptyPara).scrollIntoView());
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'insertADFNodesInEditor'
                }
            });
        }
    }
};
const $42c094802e0404dd$export$ce7efcf9a240236b = (doc, issueData, editorActions)=>{
    const replacedContent = $42c094802e0404dd$export$d9a4e0037b7dfe53(doc, issueData);
    if (replacedContent) $42c094802e0404dd$export$256652f71aefa6b0(replacedContent, editorActions);
};
const $42c094802e0404dd$export$dae10379fc585a50 = (editorActions)=>{
    if (editorActions) {
        const editorView = editorActions._privateGetEditorView();
        if (editorView) {
            editorView.focus();
            const { selection: selection } = editorView.state || {};
            const { from: from } = selection;
            (0, $eplIb.setTextSelection)(editorView, from);
        }
    }
};
const $42c094802e0404dd$export$b7761960cfe1604 = (document)=>{
    const links = (0, $12nnS.filter)(document, (node)=>!!(node.type === 'inlineExtension' && node.attrs?.extensionKey === (0, $c138a99bd60d32bc$export$42c498377b6a6569)));
    return !!links.length;
};

});
parcelRegister("eplIb", function(module, exports) {

$parcel$export(module.exports, "isEmptyParagraph", () => $a7d43df40a208c8a$export$b648602b09795358);
$parcel$export(module.exports, "stepHasSlice", () => $a7d43df40a208c8a$export$53780b185b887309);
$parcel$export(module.exports, "stepAddsOneOf", () => $a7d43df40a208c8a$export$f4d51ccab05f55c9);
$parcel$export(module.exports, "extractSliceFromStep", () => $a7d43df40a208c8a$export$d0a9dfe2556a9577);
$parcel$export(module.exports, "isTextSelection", () => $a7d43df40a208c8a$export$38b50bf35e79aaf3);
$parcel$export(module.exports, "isElementInTableCell", () => $a7d43df40a208c8a$export$5588122b9eea7733);
$parcel$export(module.exports, "isLastItemMediaGroup", () => $a7d43df40a208c8a$export$142c0ee6457f50d6);
$parcel$export(module.exports, "setNodeSelection", () => $a7d43df40a208c8a$export$a367515ca2c9ace1);
$parcel$export(module.exports, "setTextSelection", () => $a7d43df40a208c8a$export$1df6d14df6b0b758);
$parcel$export(module.exports, "nonNullable", () => $a7d43df40a208c8a$export$26128561c93f5847);
$parcel$export(module.exports, "isValidPosition", () => $a7d43df40a208c8a$export$de0495c7bd37bf4e);
$parcel$export(module.exports, "isInLayoutColumn", () => $a7d43df40a208c8a$export$2de06a6e688827fd);
$parcel$export(module.exports, "filterChildrenBetween", () => $a7d43df40a208c8a$export$e46323d96cf32194);
$parcel$export(module.exports, "removeBlockMarks", () => $a7d43df40a208c8a$export$fba8af3b998832b9);

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $2zbl1 = parcelRequire("2zbl1");

var $1khQb = parcelRequire("1khQb");

var $ahtjn = parcelRequire("ahtjn");
function $a7d43df40a208c8a$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
const $a7d43df40a208c8a$export$53780b185b887309 = (step)=>step && step.hasOwnProperty('slice');
function $a7d43df40a208c8a$export$f4d51ccab05f55c9(step, nodeTypes) {
    let adds = false;
    if (!$a7d43df40a208c8a$export$53780b185b887309(step)) return adds;
    step.slice.content.descendants((node)=>{
        if (nodeTypes.has(node.type)) adds = true;
        return !adds;
    });
    return adds;
}
const $a7d43df40a208c8a$export$d0a9dfe2556a9577 = (step)=>{
    if (!(step instanceof (0, $d6JJW.ReplaceStep)) && !(step instanceof (0, $d6JJW.ReplaceAroundStep))) return null;
    // @ts-ignore This is by design. Slice is a private property, but accesible, from ReplaceStep.
    // However, we need to read it to found if the step was adding a newline
    const slice = step.slice;
    return slice;
};
const $a7d43df40a208c8a$export$38b50bf35e79aaf3 = (selection)=>selection instanceof (0, $kpTIW.TextSelection);
const $a7d43df40a208c8a$export$5588122b9eea7733 = (element)=>{
    return (0, $ahtjn.closest)(element, 'td') || (0, $ahtjn.closest)(element, 'th');
};
const $a7d43df40a208c8a$export$142c0ee6457f50d6 = (node)=>{
    const { content: content } = node;
    return !!content.lastChild && content.lastChild.type.name === 'mediaGroup';
};
const $a7d43df40a208c8a$export$a367515ca2c9ace1 = (view, pos)=>{
    const { state: state, dispatch: dispatch } = view;
    if (!isFinite(pos)) return;
    const tr = state.tr.setSelection((0, $kpTIW.NodeSelection).create(state.doc, pos));
    dispatch(tr);
};
function $a7d43df40a208c8a$export$1df6d14df6b0b758(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection((0, $kpTIW.TextSelection).create(state.doc, anchor, head));
    dispatch(tr);
}
function $a7d43df40a208c8a$export$abad69d764760c05(view) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection(new (0, $kpTIW.AllSelection)(view.state.doc));
    dispatch(tr);
}
function $a7d43df40a208c8a$export$8f10f8581a0e9ba2(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    dispatch(state.tr.setSelection((0, $1khQb.CellSelection).create(state.doc, anchor, head)));
}
function $a7d43df40a208c8a$export$26128561c93f5847(value) {
    return value !== null && value !== undefined;
}
const $a7d43df40a208c8a$export$de0495c7bd37bf4e = (pos, state)=>{
    if (typeof pos !== 'number') return false;
    if (pos >= 0 && pos <= state.doc.resolve(0).end()) return true;
    return false;
};
const $a7d43df40a208c8a$export$2de06a6e688827fd = (state)=>{
    return (0, $2zbl1.hasParentNodeOfType)(state.schema.nodes.layoutSection)(state.selection);
};
function $a7d43df40a208c8a$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}
const $a7d43df40a208c8a$export$fba8af3b998832b9 = (state, marks)=>{
    const { selection: selection, schema: schema } = state;
    let { tr: tr } = state;
    // Marks might not exist in Schema
    const marksToRemove = marks.filter(Boolean);
    if (marksToRemove.length === 0) return undefined;
    /** Saves an extra dispatch */ let blockMarksExists = false;
    const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
    /**
   * When you need to toggle the selection
   * when another type which does not allow alignment is applied
   */ state.doc.nodesBetween(selection.from, selection.to, (node, pos)=>{
        if (node.type === schema.nodes.paragraph && node.marks.some(hasMark)) {
            blockMarksExists = true;
            const resolvedPos = state.doc.resolve(pos);
            const withoutBlockMarks = node.marks.filter($a7d43df40a208c8a$var$not(hasMark));
            tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
        }
    });
    return blockMarksExists ? tr : undefined;
};
const $a7d43df40a208c8a$var$not = (fn)=>(arg)=>!fn(arg);

});
parcelRegister("1khQb", function(module, exports) {

$parcel$export(module.exports, "CellSelection", () => $0f757f7f986e015f$export$831cc7e2a83afa94);
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $fb0pF = parcelRequire("fb0pF");

var $lOHTr = parcelRequire("lOHTr");

var $cISA4 = parcelRequire("cISA4");

var $2LFT7 = parcelRequire("2LFT7");

var $bhEEe = parcelRequire("bhEEe");

var $jLTwB = parcelRequire("jLTwB");
class $0f757f7f986e015f$export$831cc7e2a83afa94 extends (0, $kpTIW.Selection) {
    // :: (ResolvedPos, ?ResolvedPos)
    // A table selection is identified by its anchor and head cells. The
    // positions given to this constructor should point _before_ two
    // cells in the same table. They may be the same, to select a single
    // cell.
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $bhEEe.getCellSelectionRanges)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $cISA4.pointsAtCell)($anchorCell) && (0, $cISA4.pointsAtCell)($headCell) && (0, $jLTwB.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $0f757f7f986e015f$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $0f757f7f986e015f$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $0f757f7f986e015f$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $kpTIW.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $lOHTr.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $2LFT7.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) attrs = (0, $2LFT7.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            rows.push(table.child(row).copy((0, $7dkLM.Fragment).from(rowContent)));
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $7dkLM.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $7dkLM.Slice).empty : content);
        }
        const sel = (0, $kpTIW.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $lOHTr.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $lOHTr.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $0f757f7f986e015f$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $lOHTr.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        let maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $0f757f7f986e015f$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $lOHTr.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return new $0f757f7f986e015f$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $0f757f7f986e015f$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $0f757f7f986e015f$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $fb0pF.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
    }
}
(0, $kpTIW.Selection).jsonID('cell', $0f757f7f986e015f$export$831cc7e2a83afa94);

});
parcelRegister("fb0pF", function(module, exports) {

$parcel$export(module.exports, "CellBookmark", () => $b0c83420e1d3469b$export$ca751a6394ad160e);

var $kpTIW = parcelRequire("kpTIW");

var $jLTwB = parcelRequire("jLTwB");
class $b0c83420e1d3469b$export$ca751a6394ad160e {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $b0c83420e1d3469b$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $jLTwB.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $kpTIW.Selection).fromJSON(doc, data);
        }
        return (0, $kpTIW.Selection).near($headCell, 1);
    }
}

});
parcelRegister("jLTwB", function(module, exports) {

$parcel$export(module.exports, "isInTable", () => $e64d7a30c3b108eb$export$217a88ad224d1b11);
$parcel$export(module.exports, "inSameTable", () => $e64d7a30c3b108eb$export$debd62b44eb7e281);
function $e64d7a30c3b108eb$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $e64d7a30c3b108eb$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("lOHTr", function(module, exports) {

$parcel$export(module.exports, "Rect", () => $fe2050c0d04753e9$export$c79fc6492f3af13d);
$parcel$export(module.exports, "TableProblemTypes", () => $fe2050c0d04753e9$export$d8cd393a71edca79);
$parcel$export(module.exports, "TableMap", () => $fe2050c0d04753e9$export$493da463fed0a57a);

var $5zQU9 = parcelRequire("5zQU9");
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let $fe2050c0d04753e9$var$readFromCache, $fe2050c0d04753e9$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    let cache = new WeakMap();
    $fe2050c0d04753e9$var$readFromCache = (key)=>cache.get(key);
    $fe2050c0d04753e9$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    let cache = [];
    let cacheSize = 10;
    let cachePos = 0;
    $fe2050c0d04753e9$var$readFromCache = (key)=>{
        for(let i = 0; i < cache.length; i += 2){
            if (cache[i] === key) return cache[i + 1];
        }
    };
    $fe2050c0d04753e9$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = key;
        return cache[cachePos++] = value;
    };
}
class $fe2050c0d04753e9$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
let $fe2050c0d04753e9$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
const $fe2050c0d04753e9$export$c60fae4049791eae = 140;
class $fe2050c0d04753e9$export$493da463fed0a57a {
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        // The width of the table
        // The table's height
        (0, $5zQU9.default)(this, "mapByColumn", []);
        (0, $5zQU9.default)(this, "mapByRow", []);
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            let curPos = this.map[i];
            if (curPos !== pos) continue;
            let left = i % this.width;
            let top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new $fe2050c0d04753e9$export$c79fc6492f3af13d(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        let { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        let { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        let { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new $fe2050c0d04753e9$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        let result = [];
        let seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            let index = row * this.width + col;
            let pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            let rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                let rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        let parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return $fe2050c0d04753e9$var$readFromCache(table) || $fe2050c0d04753e9$var$addToCache(table, $fe2050c0d04753e9$var$computeMap(table));
    }
}
// Compute a table map.
function $fe2050c0d04753e9$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    let width = $fe2050c0d04753e9$var$findWidth(table);
    let height = table.childCount;
    let map = [], mapPos = 0, problems = null, colWidths = [];
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        let rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            let cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: $fe2050c0d04753e9$export$d8cd393a71edca79.OVERLONG_ROWSPAN,
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                let start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: $fe2050c0d04753e9$export$d8cd393a71edca79.COLLISION,
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    let colW = colwidth && colwidth[w];
                    if (colW) {
                        let widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        let expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: $fe2050c0d04753e9$export$d8cd393a71edca79.MISSING,
            row: row,
            n: missing
        });
        pos++;
    }
    let mapByRow = Array(height);
    let mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        var _mapByColumn$columnIn, _mapByRow$rowIndex;
        const columnIndex = i % width;
        mapByColumn[columnIndex] = (_mapByColumn$columnIn = mapByColumn[columnIndex]) !== null && _mapByColumn$columnIn !== void 0 ? _mapByColumn$columnIn : [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = (_mapByRow$rowIndex = mapByRow[rowIndex]) !== null && _mapByRow$rowIndex !== void 0 ? _mapByRow$rowIndex : [];
        mapByRow[rowIndex].push(map[i]);
    }
    let tableMap = new $fe2050c0d04753e9$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($fe2050c0d04753e9$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $fe2050c0d04753e9$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $fe2050c0d04753e9$var$findWidth(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        let rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            let prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                let cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            let cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $fe2050c0d04753e9$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    let seen = {};
    for(let i = 0; i < map.map.length; i++){
        let pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        let node = table.nodeAt(pos), updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            let col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $fe2050c0d04753e9$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: $fe2050c0d04753e9$export$d8cd393a71edca79.COLWIDTH_MISMATCH,
            pos: pos,
            colwidth: updated
        });
    }
}
function $fe2050c0d04753e9$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    let result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}

});

parcelRegister("cISA4", function(module, exports) {

$parcel$export(module.exports, "pointsAtCell", () => $9433eeb5f32b73ac$export$3c89e45c7dff9619);
$parcel$export(module.exports, "cellNear", () => $9433eeb5f32b73ac$export$7a283ef453dbae9e);
$parcel$export(module.exports, "cellAround", () => $9433eeb5f32b73ac$export$1f482d92c57578ce);
$parcel$export(module.exports, "nextCell", () => $9433eeb5f32b73ac$export$172699367bb25225);

var $lOHTr = parcelRequire("lOHTr");
function $9433eeb5f32b73ac$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $9433eeb5f32b73ac$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $9433eeb5f32b73ac$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $9433eeb5f32b73ac$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $lOHTr.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}

});

parcelRegister("2LFT7", function(module, exports) {

$parcel$export(module.exports, "removeColSpan", () => $204076a130be55e8$export$b24d9c3cc95412e0);
$parcel$export(module.exports, "assertColspan", () => $204076a130be55e8$export$6fccdf7cee1b5201);
$parcel$export(module.exports, "addColSpan", () => $204076a130be55e8$export$147ee78a1321ac36);
function $204076a130be55e8$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $204076a130be55e8$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $204076a130be55e8$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $204076a130be55e8$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}

});

parcelRegister("bhEEe", function(module, exports) {

$parcel$export(module.exports, "getCellSelectionRanges", () => $8370d00aa7f5bc1e$export$a60a444208fd5099);

var $kpTIW = parcelRequire("kpTIW");

var $lOHTr = parcelRequire("lOHTr");
function $8370d00aa7f5bc1e$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $lOHTr.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $kpTIW.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});



const $c138a99bd60d32bc$export$64c9f49c3b5c86e4 = 'com.atlassian.template.extensions';
const $c138a99bd60d32bc$export$42c498377b6a6569 = 'template-variable';

parcelRegister("bkyWF", function(module, exports) {

$parcel$export(module.exports, "ADFNode", () => $ff83d560137dcb91$export$926dcd1d4040971c);
const $ff83d560137dcb91$export$926dcd1d4040971c = {
    TEXT: 'text',
    INLINE_CARD: 'inlineCard'
};

});


parcelRegister("hALzt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a49cfcb1333edbcd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a49cfcb1333edbcd$var$CannedResponseModalDI = (0, $7rh0R.lazy)(()=>(parcelRequire("jNEdr")).then(({ CannedResponseModal: CannedResponseModal })=>CannedResponseModal), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/canned-response-issue-view-modal/src/index.tsx"
});
const $a49cfcb1333edbcd$var$CannedResponseLazyLoadedModal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "canned-response-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a49cfcb1333edbcd$var$CannedResponseModalDI, props));
var $a49cfcb1333edbcd$export$2e2bcd8739ae039 = $a49cfcb1333edbcd$var$CannedResponseLazyLoadedModal;

});
parcelRegister("jNEdr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('46yxM')
        ]);
        const value = parcelRequire('3URpJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("46yxM")
    ]).then(()=>parcelRequire('3URpJ'));
}

});


parcelRegister("lE405", function(module, exports) {

$parcel$export(module.exports, "default", () => $06e04c9be968c920$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $06e04c9be968c920$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    cannedResponseToolbarButton: {
        "id": "canned-response-extension.canned-response-toolbar-button.canned-response-toolbar-button",
        "defaultMessage": "Canned responses"
    }
});

});


parcelRegister("a4zUq", function(module, exports) {

$parcel$export(module.exports, "SignatureCrFetchComponentQuery", () => $9ec03ca7707e9931$export$6fe9308419c4febd);
$parcel$export(module.exports, "SignatureCrFetchComponent", () => $9ec03ca7707e9931$export$19be9b5934b96dee);

var $loMwz = parcelRequire("loMwz");

var $eUqFw = parcelRequire("eUqFw");

var $bKeny = parcelRequire("bKeny");

var $guiFP = parcelRequire("guiFP");

var $7EhAs = parcelRequire("7EhAs");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $9ec03ca7707e9931$export$6fe9308419c4febd = (0, $loMwz.default);
const $9ec03ca7707e9931$export$19be9b5934b96dee = ({ queryReference: queryReference, setSignatureCR: setSignatureCR })=>{
    const response = (0, $bKeny.usePreloadedQuery)($9ec03ca7707e9931$export$6fe9308419c4febd, queryReference);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const searchResponse = response?.jiraCannedResponse?.searchCannedResponses;
    const signatureCR = searchResponse?.edges?.map((edge)=>edge.node).filter((node)=>node?.isSignature)[0] || null;
    const content = signatureCR?.content || null;
    (0, $eUqFw.useEffect)(()=>{
        setSignatureCR(content);
        const hasError = searchResponse?.errors?.find((err)=>err.__typename);
        if (hasError) {
            const extensions = searchResponse?.errors?.[0]?.extensions?.[0];
            const errorType = extensions?.errorType || 'FETCH_FAILED';
            const statusCode = extensions?.statusCode || 500;
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchSignatureCannedResponse'
                },
                error: new (0, $7EhAs.default)(statusCode, errorType)
            });
        } else (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchSignatureCannedResponse succeeded');
    }, [
        setSignatureCR,
        content,
        createAnalyticsEvent,
        searchResponse,
        searchResponse?.errors
    ]);
    return null;
};

});
parcelRegister("loMwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $aae21fb63451b0dc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f95d021c1dc90b340008807616951fbd>>
 * @relayHash df195733ff48b9549a66bccf7f29c881
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e749ba152221f5828b74b11f741abd8463da006e3d2639e3e11631fce9e8fedb
const $aae21fb63451b0dc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "projectAri",
                    "variableName": "projectAri"
                },
                {
                    "kind": "Literal",
                    "name": "scopes",
                    "value": [
                        "PERSONAL"
                    ]
                },
                {
                    "kind": "Literal",
                    "name": "signature",
                    "value": true
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "name": "lastUpdatedAt",
                "order": "DESC"
            }
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "content"
    }, v3 = {
        "kind": "ScalarField",
        "name": "isSignature"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "signatureCrFetchComponentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraCannedResponseQueryApi",
                        "kind": "LinkedField",
                        "name": "jiraCannedResponse",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraCannedResponseConnection",
                                "kind": "LinkedField",
                                "name": "searchCannedResponses",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraCannedResponseEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCannedResponse",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v2 /*: any*/ ,
                                                    v3 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "QueryError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            v4 /*: any*/ ,
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": true,
                                                "selections": [
                                                    v5 /*: any*/ ,
                                                    v6 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jiraCannedResponse"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "signatureCrFetchComponentQuery",
            "selections": [
                {
                    "concreteType": "JiraCannedResponseQueryApi",
                    "kind": "LinkedField",
                    "name": "jiraCannedResponse",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCannedResponseConnection",
                            "kind": "LinkedField",
                            "name": "searchCannedResponses",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraCannedResponseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCannedResponse",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e749ba152221f5828b74b11f741abd8463da006e3d2639e3e11631fce9e8fedb",
            "metadata": {},
            "name": "signatureCrFetchComponentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$aae21fb63451b0dc$var$node.hash = "73f9d866c4fee376d15c66d003965359";
var $aae21fb63451b0dc$export$2e2bcd8739ae039 = $aae21fb63451b0dc$var$node;

});

parcelRegister("bKeny", function(module, exports) {
/**
 * Relay v0.0.0-main-2ccd6998
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("dEnKS"));

});
parcelRegister("dEnKS", function(module, exports) {
'use strict';

var $ktZit = parcelRequire("ktZit");

var $4eYm4 = parcelRequire("4eYm4");

var $gGu5q = parcelRequire("gGu5q");
var $9f01700fda1d4b99$var$loadQuery = $gGu5q.loadQuery;

var $g5mcN = parcelRequire("g5mcN");

var $8yAv0 = parcelRequire("8yAv0");

var $arY1U = parcelRequire("arY1U");

var $ecek5 = parcelRequire("ecek5");

var $bbHCB = parcelRequire("bbHCB");

var $23izV = parcelRequire("23izV");

var $1mzuO = parcelRequire("1mzuO");

var $3MY9R = parcelRequire("3MY9R");

var $9XEcJ = parcelRequire("9XEcJ");

var $a3Jof = parcelRequire("a3Jof");

var $9h9Ru = parcelRequire("9h9Ru");

var $bBviX = parcelRequire("bBviX");

var $cu8fo = parcelRequire("cu8fo");

var $cNy9K = parcelRequire("cNy9K");
module.exports = {
    ConnectionHandler: $cNy9K.ConnectionHandler,
    applyOptimisticMutation: $cNy9K.applyOptimisticMutation,
    commitLocalUpdate: $cNy9K.commitLocalUpdate,
    commitMutation: $cNy9K.commitMutation,
    graphql: $cNy9K.graphql,
    readInlineData: $cNy9K.readInlineData,
    requestSubscription: $cNy9K.requestSubscription,
    EntryPointContainer: $ktZit,
    RelayEnvironmentProvider: $8yAv0,
    ProfilerContext: $g5mcN,
    fetchQuery: $cNy9K.fetchQuery,
    loadQuery: $9f01700fda1d4b99$var$loadQuery,
    loadEntryPoint: $4eYm4,
    useFragment: $ecek5,
    useLazyLoadQuery: $bbHCB,
    useEntryPointLoader: $arY1U,
    useQueryLoader: $9XEcJ,
    useMutation: $23izV,
    usePaginationFragment: $1mzuO,
    usePreloadedQuery: $3MY9R,
    useRefetchableFragment: $a3Jof,
    useRelayEnvironment: $9h9Ru,
    useSubscribeToInvalidationState: $bBviX,
    useSubscription: $cu8fo
};

});



parcelRegister("e511u", function(module, exports) {

$parcel$export(module.exports, "SignatureCrFetchWrapper", () => $3f24aa859234ff3b$export$bea744a379644504);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $a4zUq = parcelRequire("a4zUq");
const $3f24aa859234ff3b$export$d57b6b390e78d90f = 'jsm-ironhide';
const $3f24aa859234ff3b$export$b8b9d90f9e5bd72b = 'cannedResponses';
const $3f24aa859234ff3b$export$f190c2faae0c1cf7 = 'cannedResponsesissueView';
const $3f24aa859234ff3b$export$bea744a379644504 = ({ queryReference: queryReference, setSignatureCR: setSignatureCR })=>{
    const onError = ()=>{
        setSignatureCR(null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        teamName: $3f24aa859234ff3b$export$d57b6b390e78d90f,
        packageName: $3f24aa859234ff3b$export$b8b9d90f9e5bd72b,
        id: $3f24aa859234ff3b$export$f190c2faae0c1cf7,
        onError: onError,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "canned-response-container",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a4zUq.SignatureCrFetchComponent), {
        queryReference: queryReference,
        setSignatureCR: setSignatureCR
    })));
};

});

parcelRegister("9SGG8", function(module, exports) {

$parcel$export(module.exports, "CommentContent", () => $b8d16f89f605320c$export$9cb18b34ecc5c89e);
$parcel$export(module.exports, "EditorContainer", () => $b8d16f89f605320c$export$b38a2fd24b22fb35);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $3Fnwd = parcelRequire("3Fnwd");

var $5m7aG = parcelRequire("5m7aG");

var $4jpQt = parcelRequire("4jpQt");

var $2g6Qf = parcelRequire("2g6Qf");

const $b8d16f89f605320c$export$9746802d6f14e3e8 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("l47Hs")), {
    moduleId: "./src/packages/issue/issue-actions/issue-comment-base/src/ui/comment/content/comment-editor/index.tsx"
});
class $b8d16f89f605320c$export$9cb18b34ecc5c89e extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'CommentContent';
    }
    static{
        this.defaultProps = {
            isServiceDesk: false,
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onSave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onPaste: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onHideSave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b8d16f89f605320c$export$b38a2fd24b22fb35, null, this.props.isEditing ? this.renderEditor() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2g6Qf.default), {
            key: `comment-${this.props.commentId}`,
            adf: this.props.bodyAdf
        }));
    }
    constructor(...args){
        super(...args);
        this.getEditValue = ()=>this.props.draftValue || this.props.bodyAdf;
        this.getIssueCommentEditor = ({ assistiveLabel: assistiveLabel = '' })=>{
            const editorProps = {
                isExpanded: true,
                isExpandedByDefault: true,
                shouldFocus: true,
                defaultValue: this.getEditValue(),
                secondaryToolbarComponents: this.props.secondaryToolbarComponents,
                onBlur: this.props.onBlur,
                onSave: this.props.onSave,
                onCancel: this.props.onCancel,
                onChange: this.props.onChange,
                onPaste: this.props.onPaste,
                onHideSave: this.props.onHideSave
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4jpQt.IssueEditorBoundary), {
                packageName: "issue",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2g6Qf.default), {
                    key: `comment-${this.props.commentId}`,
                    adf: this.props.bodyAdf
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b8d16f89f605320c$export$9746802d6f14e3e8, {
                ...editorProps,
                ...assistiveLabel && {
                    assistiveLabel: assistiveLabel
                }
            }));
        };
        this.renderEditor = ()=>this.props.isServiceDesk ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Fnwd.default), {
                isExpanded: true,
                commentId: this.props.commentId
            }, this.getIssueCommentEditor) : this.getIssueCommentEditor({
                assistiveLabel: this.props.intl.formatMessage((0, $5m7aG.default).comment)
            });
    }
}
const $b8d16f89f605320c$export$b38a2fd24b22fb35 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _swxz1kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3Fnwd", function(module, exports) {

$parcel$export(module.exports, "default", () => $17c9e1115d1af912$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8sN8t = parcelRequire("8sN8t");


var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $lkPj1 = parcelRequire("lkPj1");

var $9F6MO = parcelRequire("9F6MO");

var $dmojD = parcelRequire("dmojD");

var $kINbc = parcelRequire("kINbc");
const $17c9e1115d1af912$export$4f89d6b3093c3570 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
        name: (0, $ab3fc2ac1a2f2638$export$d3dadb39db0c423)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kINbc.default), props));
var $17c9e1115d1af912$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state, ownProps)=>({
        isInternal: (0, $dmojD.isEditingInternalCommentSelector)(ownProps.commentId)(state),
        isPublicCommentAllowed: (0, $9F6MO.canUseServiceDeskAgentFeaturesSelector)(state)
    }), (dispatch, ownProps)=>({
        onCommentVisibilityChange: (isInternal)=>{
            dispatch((0, $lkPj1.changeCommentVisibility)(ownProps.commentId, isInternal));
        }
    }), (stateProps, dispatchProps, allOwnProps)=>{
    // Omit commentId from the props that get passed to the component
    const { commentId: commentId, ...ownProps } = allOwnProps;
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps
    };
}))($17c9e1115d1af912$export$4f89d6b3093c3570);

});
parcelRegister("kINbc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b296456a28f00b2b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5dpJB = parcelRequire("5dpJB");
var $c9awd = parcelRequire("c9awd");
var $6xBtK = parcelRequire("6xBtK");
var $emR29 = parcelRequire("emR29");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $gzJNj = parcelRequire("gzJNj");

var $3hOJx = parcelRequire("3hOJx");
const $b296456a28f00b2b$export$516dbae3e1050541 = 'internal';
const $b296456a28f00b2b$export$c8c375193052eb0 = 'public';
const $b296456a28f00b2b$var$TABS = {
    public: {
        id: $b296456a28f00b2b$export$c8c375193052eb0,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3hOJx.default).replyToCustomer),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null)
    },
    internal: {
        id: $b296456a28f00b2b$export$516dbae3e1050541,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3hOJx.default).addInternalNote),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null)
    }
};
const $b296456a28f00b2b$var$ExpandedView = ({ isInternal: isInternal, isPublicCommentAllowed: isPublicCommentAllowed, children: children, onTabSelect: onTabSelect })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const selectedTabIndex = isPublicCommentAllowed && !isInternal ? $b296456a28f00b2b$var$TABS.public : $b296456a28f00b2b$var$TABS.internal;
    const tabs = isPublicCommentAllowed ? [
        $b296456a28f00b2b$var$TABS.internal,
        $b296456a28f00b2b$var$TABS.public
    ] : [
        $b296456a28f00b2b$var$TABS.internal
    ];
    const handleChange = (0, $eUqFw.useCallback)((index)=>{
        onTabSelect({
            id: index === 0 ? $b296456a28f00b2b$export$516dbae3e1050541 : $b296456a28f00b2b$export$c8c375193052eb0
        });
    }, [
        onTabSelect
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b296456a28f00b2b$var$tabsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5dpJB.default), {
        selected: selectedTabIndex.id === $b296456a28f00b2b$export$516dbae3e1050541 ? 0 : 1,
        onChange: handleChange,
        id: "comment-editor-container-tabs",
        shouldUnmountTabPanelOnChange: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xBtK.default), null, tabs.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9awd.default), {
            key: index
        }, tab.label))), tabs.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $emR29.default), {
            key: index
        }, tab.content)))), children({
        assistiveLabel: formatMessage(isInternal ? (0, $3hOJx.default).addInternalNote : (0, $3hOJx.default).replyToCustomer)
    }));
};
const $b296456a28f00b2b$var$CollapsedView = ({ onReplyToCustomer: onReplyToCustomer, onAddInternalNote: onAddInternalNote, isPublicCommentAllowed: isPublicCommentAllowed, replyToCustomerButtonActions: replyToCustomerButtonActions, addInternalNoteButtonActions: addInternalNoteButtonActions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gzJNj.default), {
        onReplyToCustomer: onReplyToCustomer,
        onAddInternalNote: onAddInternalNote,
        isPublicCommentAllowed: isPublicCommentAllowed,
        replyToCustomerButtonActions: replyToCustomerButtonActions,
        addInternalNoteButtonActions: addInternalNoteButtonActions
    });
const $b296456a28f00b2b$export$403b6d98f3dc0f95 = ({ isExpanded: isExpanded = false, isInternal: isInternal = false, isPublicCommentAllowed: isPublicCommentAllowed = false, onExpanded: onExpanded = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onCommentVisibilityChange: onCommentVisibilityChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), children: children, commentButtonActions: commentButtonActions })=>{
    const expandEditor = (0, $eUqFw.useCallback)(()=>{
        if (!isExpanded) onExpanded && onExpanded();
    }, [
        isExpanded,
        onExpanded
    ]);
    const onReplyToCustomer = (0, $eUqFw.useCallback)(()=>{
        onCommentVisibilityChange(false);
        expandEditor();
    }, [
        expandEditor,
        onCommentVisibilityChange
    ]);
    const onAddInternalNote = (0, $eUqFw.useCallback)(()=>{
        onCommentVisibilityChange(true);
        expandEditor();
    }, [
        expandEditor,
        onCommentVisibilityChange
    ]);
    const onTabSelect = (0, $eUqFw.useCallback)((selectedTab)=>{
        onCommentVisibilityChange(selectedTab.id === $b296456a28f00b2b$export$516dbae3e1050541);
    }, [
        onCommentVisibilityChange
    ]);
    return isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b296456a28f00b2b$var$ExpandedView, {
        isInternal: isInternal,
        isPublicCommentAllowed: isPublicCommentAllowed,
        onTabSelect: onTabSelect
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b296456a28f00b2b$var$CollapsedView, {
        onReplyToCustomer: onReplyToCustomer,
        onAddInternalNote: onAddInternalNote,
        isPublicCommentAllowed: isPublicCommentAllowed,
        replyToCustomerButtonActions: commentButtonActions,
        addInternalNoteButtonActions: commentButtonActions
    });
};
var $b296456a28f00b2b$export$2e2bcd8739ae039 = $b296456a28f00b2b$export$403b6d98f3dc0f95;
const $b296456a28f00b2b$var$tabsContainerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.200'
});

});
parcelRegister("5dpJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $86fff1fa4f16d75d$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $hcuCm = parcelRequire("hcuCm");

var $9qnib = parcelRequire("9qnib");
function $86fff1fa4f16d75d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $86fff1fa4f16d75d$var$baseStyles = {
    name: "7i0hsw",
    styles: "display:flex;max-width:100%;min-height:0%;flex-basis:100%;flex-direction:column;flex-grow:1"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $86fff1fa4f16d75d$var$tabsStyles = (0, $9qnib.getTabsStyles)();
const $86fff1fa4f16d75d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: undefined,
    packageVersion: undefined
};
const $86fff1fa4f16d75d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel);
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $86fff1fa4f16d75d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $eUqFw.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $eUqFw.Children).toArray(children)// Don't include any conditional children
    .filter((child)=>Boolean(child));
    // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray;
    // Keep track of visited and add to a set
    const visited = (0, $eUqFw.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $eUqFw.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$86fff1fa4f16d75d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $86fff1fa4f16d75d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$86fff1fa4f16d75d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return(// Only styles that affect the Tabs container itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTabPanel(),
    // which applies accessibility attributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $86fff1fa4f16d75d$var$baseStyles,
            $86fff1fa4f16d75d$var$tabsStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, tabPanelsWithContext)));
};
var $86fff1fa4f16d75d$export$2e2bcd8739ae039 = $86fff1fa4f16d75d$var$Tabs;

});
parcelRegister("hcuCm", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $3a21d9894028b7fb$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $3a21d9894028b7fb$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $3a21d9894028b7fb$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eUqFw = parcelRequire("eUqFw");
const $3a21d9894028b7fb$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3a21d9894028b7fb$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3a21d9894028b7fb$export$2054129d247c3102 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});

parcelRegister("9qnib", function(module, exports) {

$parcel$export(module.exports, "getTabsStyles", () => $f50084288d7b85a1$export$dd5afd2190fb792c);
$parcel$export(module.exports, "getTabListStyles", () => $f50084288d7b85a1$export$42a3c683c377bcb2);

var $byn9U = parcelRequire("byn9U");

var $4xRua = parcelRequire("4xRua");
const $f50084288d7b85a1$var$tabInlinePadding = "var(--ds-space-100, 8px)";
const $f50084288d7b85a1$var$tabBlockPadding = "var(--ds-space-075, 6px)";
const $f50084288d7b85a1$var$tabInlineMargin = "var(--ds-space-negative-100, -8px)";
// TODO this should probably be `border.width.indicator`
const $f50084288d7b85a1$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
const $f50084288d7b85a1$var$getTabPanelStyles = ()=>({
        flexGrow: 1,
        /*
     NOTE min-height set to 0% because of Firefox bug
     FF http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
   */ minHeight: '0%',
        display: 'flex'
    });
const $f50084288d7b85a1$export$dd5afd2190fb792c = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tabpanel"]': $f50084288d7b85a1$var$getTabPanelStyles(),
        // The hidden attribute doesn't work on flex elements
        // Change display to be none
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > [hidden]': {
            display: 'none'
        }
    });
const $f50084288d7b85a1$var$tabLineStyles = {
    content: '""',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $f50084288d7b85a1$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $f50084288d7b85a1$export$42a3c683c377bcb2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $f50084288d7b85a1$export$916c8b0fccbb37d2(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $f50084288d7b85a1$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$f50084288d7b85a1$var$tabLineStyles,
            height: $f50084288d7b85a1$var$underlineHeight,
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $4xRua.tabLineColors).lineColor
        }
    });
const $f50084288d7b85a1$export$916c8b0fccbb37d2 = ()=>{
    const colors = (0, $4xRua.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$f50084288d7b85a1$var$tabBlockPadding} ${$f50084288d7b85a1$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};

});
parcelRegister("4xRua", function(module, exports) {

$parcel$export(module.exports, "tabColors", () => $d893d977d51d4780$export$5159a1ad8efe50bc);
$parcel$export(module.exports, "tabLineColors", () => $d893d977d51d4780$export$6be6fa4649b31472);

var $PdmhA = parcelRequire("PdmhA");
const $d893d977d51d4780$export$5159a1ad8efe50bc = {
    labelColor: `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`,
    activeLabelColor: `var(--ds-text, ${(0, $PdmhA.B500)})`,
    hoverLabelColor: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
    selectedColor: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
    focusBorderColor: `var(--ds-border-focused, ${(0, $PdmhA.B100)})`
};
const $d893d977d51d4780$export$6be6fa4649b31472 = {
    lineColor: `var(--ds-border, ${(0, $PdmhA.N30)})`,
    hoveredColor: "var(--ds-border, transparent)",
    activeColor: "var(--ds-border, transparent)",
    selectedColor: `var(--ds-border-selected, ${(0, $PdmhA.B400)})`
};

});



parcelRegister("c9awd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d17b011d788c2ed$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $51sCz = parcelRequire("51sCz");

var $1Yimi = parcelRequire("1Yimi");

var $kgCsd = parcelRequire("kgCsd");
function $4d17b011d788c2ed$export$2e2bcd8739ae039({ children: children, testId: testId }) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $kgCsd.useTab)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        weight: "medium",
        color: "inherit",
        maxLines: 1
    }, children)));
}

});
parcelRegister("kgCsd", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $87f26a44f88daafa$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $87f26a44f88daafa$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $87f26a44f88daafa$export$fae0121b5afe572d);

var $eUqFw = parcelRequire("eUqFw");

var $hcuCm = parcelRequire("hcuCm");
const $87f26a44f88daafa$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $eUqFw.useContext)((0, $hcuCm.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $87f26a44f88daafa$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $eUqFw.useContext)((0, $hcuCm.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $87f26a44f88daafa$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $eUqFw.useContext)((0, $hcuCm.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("6xBtK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b552637a2f5925a8$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $kgCsd = parcelRequire("kgCsd");

var $hcuCm = parcelRequire("hcuCm");

var $9qnib = parcelRequire("9qnib");
function $b552637a2f5925a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b552637a2f5925a8$var$baseStyles = {
    name: "g0wsdz",
    styles: "display:flex;padding:var(--ds-space-0, 0px);position:relative"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $b552637a2f5925a8$var$tabListStyles = (0, $9qnib.getTabListStyles)();
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $b552637a2f5925a8$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $kgCsd.useTabList)();
    const ref = /*#__PURE__*/ (0, $eUqFw.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $eUqFw.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $eUqFw.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $eUqFw.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return(// Only styles that affect the TabList itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTab(),
    // which applies accessibility atributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "tablist",
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $b552637a2f5925a8$var$baseStyles,
            $b552637a2f5925a8$var$tabListStyles
        ]
    }, childrenArray.map((child, index)=>getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        }))));
};
var $b552637a2f5925a8$export$2e2bcd8739ae039 = $b552637a2f5925a8$var$TabList;

});

parcelRegister("emR29", function(module, exports) {

$parcel$export(module.exports, "default", () => $854be789e89981e2$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $51sCz = parcelRequire("51sCz");

var $kgCsd = parcelRequire("kgCsd");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $854be789e89981e2$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $kgCsd.useTabPanel)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, children)));
};
var $854be789e89981e2$export$2e2bcd8739ae039 = $854be789e89981e2$var$TabPanel;

});

parcelRegister("gzJNj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5cd0a618a3f335c$export$2e2bcd8739ae039);

var $8un0w = parcelRequire("8un0w");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $dmojD = parcelRequire("dmojD");

var $lfz3N = parcelRequire("lfz3N");
const $d5cd0a618a3f335c$var$CollapsedEditor = (0, $5G3JL.flowWithSafeComponent)(// @ts-expect-error - Argument of type '<T extends ComponentType<any>, Props = PropsWithoutRef<ComponentProps<T>>>(WrappedComponent: T) => WithUIAnalyticsEvent<Props, { onReplyToCustomer: string; onAddInternalNote: string; }>' is not assignable to parameter of type 'FlowStep<T, ComponentType<Matching<StateProps & {}, Props & { onReplyToCustomer?: ("onReplyToCustomer" extends keyof Props ? Props[keyof Props & "onReplyToCustomer"] : AnalyticsCallback) | undefined; onAddInternalNote?: ("onAddInternalNote" extends keyof Props ? Props[keyof Props & "onAddInternalNote"] : AnalyticsCa...'.
(0, $8un0w.default)({
    onReplyToCustomer: 'onReplyToCustomer',
    onAddInternalNote: 'onAddInternalNote'
}), (0, $lqalZ.connect)((state)=>({
        isCommentAttachmentInProgress: (0, $dmojD.isCommentAttachmentInProgressSelector)(state)
    }), {}));
var $d5cd0a618a3f335c$export$2e2bcd8739ae039 = $d5cd0a618a3f335c$var$CollapsedEditor((0, $lfz3N.CollapsedEditorView));

});
parcelRegister("lfz3N", function(module, exports) {

$parcel$export(module.exports, "CollapsedEditorView", () => $6ec72560a275f964$export$19e20a01fb7ade55);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bFzGY = parcelRequire("bFzGY");

var $7u4fN = parcelRequire("7u4fN");

var $c0jFd = parcelRequire("c0jFd");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $2wCUM = parcelRequire("2wCUM");

var $94z0Q = parcelRequire("94z0Q");
var $2jB3y = parcelRequire("2jB3y");

var $jMP2a = parcelRequire("jMP2a");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");

var $8L3Y4 = parcelRequire("8L3Y4");

var $cezKj = parcelRequire("cezKj");

var $gd0Sp = parcelRequire("gd0Sp");

var $3hOJx = parcelRequire("3hOJx");

var $5dZWW = parcelRequire("5dZWW");
const $6ec72560a275f964$var$UpdateStakeholderLinkInnerOld = ()=>{
    const [isStakeHolderModalOpen, setIsStakeHolderModalOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, ' / ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: (event, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'viewUpdateStakeholderModal');
            setIsStakeHolderModalOpen(true);
        },
        interactionName: "auto-generated.jira-issue-view-servicedesk-editor-container.collapsed-editor-view.button"
    }, formatMessage((0, $3hOJx.default).informStakeholders)), isStakeHolderModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94z0Q.AsyncSendStakeholderUpdatesModal), {
        onCloseUpdateStakeholderModal: ()=>setIsStakeHolderModalOpen(false)
    }));
};
const $6ec72560a275f964$var$UpdateStakeholderLinkInner = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isStakeHolderModalOpen, setIsStakeHolderModalOpen] = (0, $eUqFw.useState)(false);
    const [{ limits: limits, issueVersion: issueVersion }] = (0, $2jB3y.useStakeholderUpdatesStore)();
    if (issueVersion.isNew) {
        const isLimitsExceed = limits.isEmailQuotaExceeded && limits.isTrial;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, "\xa0/\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: isLimitsExceed ? formatMessage((0, $3hOJx.default).informStakeholderLimitExceed) : ''
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            isDisabled: isLimitsExceed,
            appearance: "link",
            onClick: (event, analyticsEvent)=>{
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'viewUpdateStakeholderModal');
                setIsStakeHolderModalOpen(true);
            },
            interactionName: "auto-generated.jira-issue-view-servicedesk-editor-container.collapsed-editor-view.button1"
        }, formatMessage((0, $3hOJx.default).informStakeholders))), isStakeHolderModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94z0Q.AsyncSendStakeholderUpdatesModal), {
            onCloseUpdateStakeholderModal: ()=>setIsStakeHolderModalOpen(false)
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ec72560a275f964$var$UpdateStakeholderLinkInnerOld, null);
};
const $6ec72560a275f964$export$54c002f5d9342e56 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const issueId = (0, $hJ992.useIssueId)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const isStakeholderVisible = (0, $5YYzL.useCanUseServiceDeskAgentFeatures)(projectKey);
    const [hasOpsgenieAccount] = (0, $8L3Y4.useHasCurrentUserOpsgenieAccount)();
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const [{ data: incidentCapabilities }] = (0, $cezKj.useIncidentCapabilitiesProvisionState)();
    const hasSystemIncident = incidentCapabilities?.provisionState === (0, $50b9feecb89aca70$export$71efb3495f6084f2);
    const showStakeholderUpdatesLink = isStakeholderVisible && hasOpsgenieAccount === true;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    if (incidentCapabilities === undefined || !hasSystemIncident || !showStakeholderUpdatesLink) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2jB3y.StakeholderUpdatesStoreContainer), {
        analyticsEvent: createAnalyticsEvent({}),
        issueId: issueId,
        cloudId: cloudId,
        scope: issueId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ec72560a275f964$var$UpdateStakeholderLinkInner, null));
};
const $6ec72560a275f964$export$19e20a01fb7ade55 = ({ onReplyToCustomer: onReplyToCustomer, onAddInternalNote: onAddInternalNote, isCommentAttachmentInProgress: isCommentAttachmentInProgress, isPublicCommentAllowed: isPublicCommentAllowed, replyToCustomerButtonActions: replyToCustomerButtonActions, addInternalNoteButtonActions: addInternalNoteButtonActions })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isIssueOfIncidentsPractice = (0, $2wCUM.useIsIssueOfIncidentsPractice)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ec72560a275f964$var$ServiceDeskCommentButtonsContainer, null, isCommentAttachmentInProgress ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ec72560a275f964$var$LoadingAttachmentStatus, null, formatMessage((0, $3hOJx.default).loadingAttachments)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: onAddInternalNote,
        interactionName: "auto-generated.jira-issue-view-servicedesk-editor-container.collapsed-editor-view.button2",
        ...addInternalNoteButtonActions
    }, formatMessage((0, $3hOJx.default).addInternalNote)), isPublicCommentAllowed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, "\xa0/\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: onReplyToCustomer,
        interactionName: "auto-generated.jira-issue-view-servicedesk-editor-container.collapsed-editor-view.button3",
        ...replyToCustomerButtonActions
    }, formatMessage((0, $3hOJx.default).replyToCustomer))), isIssueOfIncidentsPractice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ec72560a275f964$export$54c002f5d9342e56, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5dZWW.default), null));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ec72560a275f964$var$ServiceDeskCommentButtonsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _19ith6cr _4t3i1ylp _vchhusvi _1yt4swc3 _2rko1l7b _1e0c1txw _4cvr1h6o _1reo15vq _18m915vq _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ec72560a275f964$var$LoadingAttachmentStatus = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4h8dc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $6ec72560a275f964$export$7ed12d2a5241e393 = {
    LoadingAttachmentStatus: $6ec72560a275f964$var$LoadingAttachmentStatus
};

});
parcelRegister("94z0Q", function(module, exports) {

$parcel$export(module.exports, "AsyncSendStakeholderUpdatesModal", () => $42fc2feb78733a59$export$6af999048e1303b3);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $42fc2feb78733a59$var$SendStakeholderUpdatesModalLazy = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5lemg")), {
    moduleId: "./src/packages/servicedesk/incident-management/issue-view/stakeholder-updates/src/ui/send-stakeholder-updates/index.tsx"
});
const $42fc2feb78733a59$export$6af999048e1303b3 = ({ onCloseUpdateStakeholderModal: onCloseUpdateStakeholderModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "send-stakeholder-updates-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($42fc2feb78733a59$var$SendStakeholderUpdatesModalLazy, {
        onCloseUpdateStakeholderModal: onCloseUpdateStakeholderModal
    }));

});
parcelRegister("5lemg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('98XD7');
        const value = parcelRequire('cNCAy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("98XD7").then(()=>parcelRequire('cNCAy'));
}

});


parcelRegister("2jB3y", function(module, exports) {

$parcel$export(module.exports, "StakeholderUpdatesStoreContainer", () => $b6d27b7dab9fa140$export$7060c723b1b08025);
$parcel$export(module.exports, "useStakeholderUpdatesStore", () => $b6d27b7dab9fa140$export$2af4ca59866e845);
$parcel$export(module.exports, "useUpdatedServices", () => $b6d27b7dab9fa140$export$17227b41fe2f368);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $gtNJH = parcelRequire("gtNJH");
const $b6d27b7dab9fa140$export$7060c723b1b08025 = (0, $heB5U.createContainer)();
const $b6d27b7dab9fa140$export$d4c72bab9d6cc13a = {
    issueVersion: {
        isNew: undefined
    },
    limits: {
        emailQuota: 50,
        isEmailQuotaExceeded: false,
        isTrial: false
    },
    informModal: {
        isUpdateStakeholderLoading: false,
        latestUpdate: {
            isLoading: false
        }
    },
    isStakeholderUpdatesModalOpen: false,
    stakeholders: {
        loading: true
    }
};
const $b6d27b7dab9fa140$export$dc3fed948a31751d = (0, $a61MH.createStore)({
    name: 'JSDIncidentManagementStakeholderUpdatesStore',
    initialState: $b6d27b7dab9fa140$export$d4c72bab9d6cc13a,
    actions: $gtNJH.actions,
    containedBy: $b6d27b7dab9fa140$export$7060c723b1b08025,
    handlers: {
        onInit: ()=>async ({ dispatch: dispatch, getState: getState })=>{
                await dispatch((0, $gtNJH.actions).getIssueVersion());
                const { issueVersion: issueVersion } = getState();
                if (issueVersion.isNew) await dispatch((0, $gtNJH.actions).getLimits());
            }
    }
});
const $b6d27b7dab9fa140$export$2af4ca59866e845 = (0, $ggKAj.createHook)($b6d27b7dab9fa140$export$dc3fed948a31751d);
const $b6d27b7dab9fa140$var$delays = [
    10000,
    15000,
    25000
];
const $b6d27b7dab9fa140$var$updatedServicesStore = (0, $a61MH.createStore)({
    initialState: {
        hasServicesUpdated: ''
    },
    actions: {
        updateServices: ()=>// @ts-expect-error - TS2322 - Type '({ setState }: StoreActionApi<AffectedServicesUpdatedState>) => void' is not assignable to type 'Action<AffectedServicesUpdatedState, void, Promise<undefined> | undefined>'.
            ({ setState: setState })=>{
                $b6d27b7dab9fa140$var$delays.forEach((delay)=>{
                    setTimeout(()=>{
                        setState({
                            hasServicesUpdated: new Date().toISOString()
                        });
                    }, delay);
                });
            }
    }
});
const $b6d27b7dab9fa140$export$17227b41fe2f368 = (0, $ggKAj.createHook)($b6d27b7dab9fa140$var$updatedServicesStore);

});
parcelRegister("gtNJH", function(module, exports) {

$parcel$export(module.exports, "actions", () => $7020df5817fdb750$export$e324594224ef24da);

var $bDf62 = parcelRequire("bDf62");

var $3g94f = parcelRequire("3g94f");

var $bGpkw = parcelRequire("bGpkw");

var $tee1M = parcelRequire("tee1M");

var $9mRfP = parcelRequire("9mRfP");

var $4EOX0 = parcelRequire("4EOX0");

var $2G2Gh = parcelRequire("2G2Gh");
const $7020df5817fdb750$export$e324594224ef24da = {
    getStakeholders: $3g94f.getStakeholders,
    addStakeholder: $bDf62.addStakeholder,
    removeStakeholder: $4EOX0.removeStakeholder,
    updateStakeholder: $2G2Gh.updateStakeholder,
    getLatestUpdate: $tee1M.getLatestUpdate,
    getLimits: $9mRfP.getLimits,
    getIssueVersion: $bGpkw.getIssueVersion
};

});
parcelRegister("bDf62", function(module, exports) {

$parcel$export(module.exports, "addStakeholder", () => $787b52f8ddc258de$export$54a1b87b3e67636f);

var $iVIEg = parcelRequire("iVIEg");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");

var $iCRmp = parcelRequire("iCRmp");

var $hmDJ3 = parcelRequire("hmDJ3");

var $hRfPV = parcelRequire("hRfPV");
const $787b52f8ddc258de$export$54a1b87b3e67636f = (updatedStakeholders)=>async ({ getState: getState, setState: setState }, { issueId: issueId, cloudId: cloudId, analyticsEvent: analyticsEvent })=>{
        const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
        const { stakeholders: stakeholders, issueVersion: issueVersion } = getState();
        if (!issueId) {
            setState({
                stakeholders: {
                    error: 'Missing issueId'
                }
            });
            return;
        }
        // @ts-expect-error - TS2345 - Argument of type 'Stakeholders | undefined' is not assignable to parameter of type 'List<Stakeholder>'.
        const addedStakeholders = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(updatedStakeholders, stakeholders.data);
        if (issueVersion.isNew) setState({
            stakeholders: {
                ...stakeholders,
                error: undefined,
                isAddStakeholderLoading: true
            }
        });
        else {
            // @ts-expect-error: After old version of stakeholders removed/deprecated, that util will be removed. `isNew` is the condition
            const data = (0, $hmDJ3.transformStkeholdersDetailResponseData)(updatedStakeholders);
            setState({
                stakeholders: {
                    error: undefined,
                    data: data
                }
            });
        }
        try {
            let url;
            if (issueVersion.isNew) url = `/gateway/api/jsm/stakeholders/cloudId/${cloudId}/v1/stakeholders/issue/${issueId}`;
            else url = `${(0, $iCRmp.getEscalatorBaseUrl)(cloudId)}/issue/${issueId}/incident/stakeholders`;
            const response = await (0, $lRmyA.performPostRequest)(url, {
                body: JSON.stringify({
                    stakeholderAris: issueVersion.isNew ? addedStakeholders : addedStakeholders.map((stakeholder)=>stakeholder.ari)
                })
            });
            if (issueVersion.isNew) setState({
                stakeholders: {
                    data: [
                        ...stakeholders.data ?? [],
                        ...response
                    ],
                    error: undefined,
                    isAddStakeholderLoading: false
                }
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/59451
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'addStakeholder succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // https://data-portal.internal.atlassian.com/analytics/registry/41051
            (0, $guiFP.default)({
                event: analyticsEvent,
                meta: {
                    id: 'addStakeholder',
                    packageName: 'jiraJsmStakeholderUpdates',
                    teamName: 'itsm-agni'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
            if (issueVersion.isNew) setState({
                stakeholders: {
                    ...stakeholders,
                    isAddStakeholderLoading: false,
                    error: e.message
                }
            });
            else setState({
                stakeholders: {
                    error: e.message
                }
            });
            showFlag({
                type: 'error',
                title: (0, $hRfPV.default).failureHeading,
                description: (0, $hRfPV.default).failureDescription
            });
        }
    };

});
parcelRegister("iCRmp", function(module, exports) {

$parcel$export(module.exports, "getEscalatorBaseUrl", () => $d4b29ef63f8469c6$export$3347c4c96d7e38d8);
$parcel$export(module.exports, "getChatOpsBaseUrl", () => $d4b29ef63f8469c6$export$70e4317decab60c9);
$parcel$export(module.exports, "getServiceDeskAgentContextUrl", () => $d4b29ef63f8469c6$export$13a6ceb36d0ccd1b);
const $d4b29ef63f8469c6$export$3347c4c96d7e38d8 = (cloudId)=>`/gateway/api/jsd/escalator/${cloudId}/api`;
const $d4b29ef63f8469c6$export$70e4317decab60c9 = (cloudId)=>`/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat`;
const $d4b29ef63f8469c6$export$13a6ceb36d0ccd1b = (projectKey)=>`/rest/servicedesk/1/pages/agent/servicedesk/${projectKey}`;

});

parcelRegister("hmDJ3", function(module, exports) {

$parcel$export(module.exports, "transformStkeholdersDetailResponseData", () => $a4e89c17cefa7b90$export$e741ef7a988a6aec);
$parcel$export(module.exports, "toServiceListString", () => $a4e89c17cefa7b90$export$f13a341bd4969e8);
const $a4e89c17cefa7b90$export$e741ef7a988a6aec = (stakeholders)=>// @ts-expect-error: After old version of stakeholders removed/deprecated, that util will be removed. `isNew` is the condition
    stakeholders.map((stakeholder)=>({
            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Stakeholder | Stakeholder'. | TS2339 - Property 'name' does not exist on type 'Stakeholder | Stakeholder'. | TS2339 - Property 'fullName' does not exist on type 'Stakeholder | Stakeholder'.
            name: stakeholder.name !== undefined ? stakeholder.name : stakeholder.fullName,
            avatarUrl: stakeholder.avatarUrl,
            // @ts-expect-error: After old version of stakeholders removed/deprecated, that util will be removed. `isNew` is the condition
            ari: stakeholder.ari,
            // @ts-expect-error: After old version of stakeholders removed/deprecated, that util will be removed. `isNew` is the condition
            id: stakeholder.ari,
            // @ts-expect-error: After old version of stakeholders removed/deprecated, that util will be removed. `isNew` is the condition
            isManuallyAdded: stakeholder?.isManuallyAdded,
            services: stakeholder?.services
        }));
const $a4e89c17cefa7b90$export$f13a341bd4969e8 = (services)=>{
    if (!services || !services.length) return '';
    return services.join(', ');
};

});

parcelRegister("hRfPV", function(module, exports) {

$parcel$export(module.exports, "default", () => $56b66719c57adec4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $56b66719c57adec4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    failureHeading: {
        "id": "jsm-stakeholder-updates.services.actions.add-stakeholder.failure-heading",
        "defaultMessage": "Stakeholder was not added"
    },
    failureDescription: {
        "id": "jsm-stakeholder-updates.services.actions.add-stakeholder.failure-description",
        "defaultMessage": "Something went wrong. Try refreshing the page."
    }
});

});


parcelRegister("3g94f", function(module, exports) {

$parcel$export(module.exports, "getStakeholders", () => $71c10fbad1a0bfc6$export$30370cfbc42a80a5);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");

var $iCRmp = parcelRequire("iCRmp");

var $hmDJ3 = parcelRequire("hmDJ3");

var $6ndAv = parcelRequire("6ndAv");
const $71c10fbad1a0bfc6$export$30370cfbc42a80a5 = ()=>async ({ setState: setState, getState: getState }, { issueId: issueId, cloudId: cloudId, analyticsEvent: analyticsEvent })=>{
        const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
        const { issueVersion: issueVersion } = getState();
        if (!issueId) {
            setState({
                stakeholders: {
                    loading: null,
                    error: 'Missing issueId'
                }
            });
            return;
        }
        try {
            let url;
            if (issueVersion.isNew) url = `/gateway/api/jsm/stakeholders/cloudId/${cloudId}/v1/stakeholders/issue/${issueId}`;
            else url = `${(0, $iCRmp.getEscalatorBaseUrl)(cloudId)}/issue/${issueId}/incident/v2/stakeholders`;
            const response = await (0, $2OdyW.default)(url);
            setState({
                stakeholders: {
                    loading: true
                }
            });
            let data;
            if (issueVersion.isNew) data = response;
            else // @ts-expect-error: After old version of stakeholders removed/deprecated, that util will be removed. `isNew` is the condition
            data = (0, $hmDJ3.transformStkeholdersDetailResponseData)(response.stakeholders);
            setState({
                stakeholders: {
                    loading: null,
                    data: data
                }
            });
            if (issueVersion.isNew) // https://data-portal.internal.atlassian.com/analytics/registry/41036
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'getStakeholders succeeded');
            else (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'getStakeholdersV2 succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // https://data-portal.internal.atlassian.com/analytics/registry/41045
            (0, $guiFP.default)({
                event: analyticsEvent,
                meta: {
                    id: 'getStakeholders',
                    packageName: 'jiraJsmStakeholderUpdates',
                    teamName: 'itsm-agni'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                stakeholders: {
                    loading: null,
                    error: e.message
                }
            });
            showFlag({
                type: 'error',
                title: (0, $6ndAv.default).failureHeading,
                description: (0, $6ndAv.default).failureDescription
            });
        }
    };

});
parcelRegister("6ndAv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3b4ba0a996b7981$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b3b4ba0a996b7981$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    failureHeading: {
        "id": "jsm-stakeholder-updates.services.actions.fetch-stakeholders.failure-heading",
        "defaultMessage": "Stakeholders were not populated"
    },
    failureDescription: {
        "id": "jsm-stakeholder-updates.services.actions.fetch-stakeholders.failure-description",
        "defaultMessage": "Something went wrong. Try refreshing the page."
    }
});

});


parcelRegister("bGpkw", function(module, exports) {

$parcel$export(module.exports, "getIssueVersion", () => $ec737457a489895b$export$2ccef744c0739e3b);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");
const $ec737457a489895b$export$2ccef744c0739e3b = ()=>async ({ setState: setState }, { cloudId: cloudId, analyticsEvent: analyticsEvent, issueId: issueId })=>{
        if (!issueId) {
            setState({
                stakeholders: {
                    error: 'Missing issueId'
                }
            });
            return;
        }
        try {
            const response = await (0, $2OdyW.default)(`/gateway/api/jsm/stakeholders/cloudId/${cloudId}/v1/stakeholders/issue/${issueId}/new-issue-property`);
            setState({
                issueVersion: {
                    isNew: response.value
                }
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/59452
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'getIssueVersion succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            setState({
                issueVersion: {
                    isNew: false
                }
            });
            (0, $guiFP.default)({
                // https://data-portal.internal.atlassian.com/analytics/registry/59453
                event: analyticsEvent,
                meta: {
                    id: 'getIssueVersion',
                    packageName: 'jiraJsmStakeholderUpdates',
                    teamName: 'itsm-agni'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };

});

parcelRegister("tee1M", function(module, exports) {

$parcel$export(module.exports, "getLatestUpdate", () => $97616d4c24569625$export$eaeb7cc2c34ef8a9);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");
const $97616d4c24569625$export$eaeb7cc2c34ef8a9 = ()=>async ({ getState: getState, setState: setState }, { issueId: issueId, cloudId: cloudId, analyticsEvent: analyticsEvent })=>{
        const { informModal: { latestUpdate: { isLoading: isLoading }, ...rest }, ...state } = getState();
        if (!issueId) {
            setState({
                stakeholders: {
                    error: 'Missing issueId'
                }
            });
            return;
        }
        if (isLoading) return;
        setState({
            ...state,
            informModal: {
                ...rest,
                latestUpdate: {
                    isLoading: true,
                    data: undefined
                }
            }
        });
        try {
            const data = await (0, $lRmyA.performGetRequest)(`/gateway/api/jsm/stakeholders/cloudId/${cloudId}/v1/stakeholders/issue/${issueId}/status-update/latest`);
            setState({
                ...state,
                informModal: {
                    ...rest,
                    latestUpdate: {
                        isLoading: true,
                        data: data
                    }
                }
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/59451
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'getLatestUpdate succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // https://data-portal.internal.atlassian.com/analytics/registry/59455
            (0, $guiFP.default)({
                event: analyticsEvent,
                meta: {
                    id: 'getLatestUpdate',
                    packageName: 'jiraJsmStakeholderUpdates',
                    teamName: 'itsm-agni'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                ...state,
                informModal: {
                    ...rest,
                    latestUpdate: {
                        isLoading: false,
                        data: undefined
                    }
                }
            });
        }
    };

});

parcelRegister("9mRfP", function(module, exports) {

$parcel$export(module.exports, "getLimits", () => $efc595c239ff30b5$export$fb6dcbdbba8c49f1);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");
const $efc595c239ff30b5$export$fb6dcbdbba8c49f1 = ()=>async ({ setState: setState }, { cloudId: cloudId, analyticsEvent: analyticsEvent, issueId: issueId })=>{
        if (!issueId) {
            setState({
                stakeholders: {
                    error: 'Missing issueId'
                }
            });
            return;
        }
        try {
            const limits = await (0, $2OdyW.default)(`/gateway/api/jsm/stakeholders/cloudId/${cloudId}/v1/stakeholders/feature-gating`);
            setState({
                limits: limits
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/59456
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'getLimits succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // https://data-portal.internal.atlassian.com/analytics/registry/59457
            (0, $guiFP.default)({
                event: analyticsEvent,
                meta: {
                    id: 'getLimits',
                    packageName: 'jiraJsmStakeholderUpdates',
                    teamName: 'itsm-agni'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };

});

parcelRegister("4EOX0", function(module, exports) {

$parcel$export(module.exports, "removeStakeholder", () => $04514247eabf7bb7$export$20b3a8c5e5d20c9b);

var $iVIEg = parcelRequire("iVIEg");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");

var $iCRmp = parcelRequire("iCRmp");

var $hmDJ3 = parcelRequire("hmDJ3");

var $6Rubo = parcelRequire("6Rubo");
const $04514247eabf7bb7$export$20b3a8c5e5d20c9b = (updatedStakeholders)=>async ({ setState: setState, getState: getState }, { issueId: issueId, cloudId: cloudId, analyticsEvent: analyticsEvent })=>{
        const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
        const { stakeholders: stakeholders, issueVersion: issueVersion } = getState();
        if (!issueId) {
            setState({
                stakeholders: {
                    error: 'Missing issueId'
                }
            });
            return;
        }
        const removedStakeholders = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(stakeholders.data, updatedStakeholders);
        let data;
        if (issueVersion.isNew) data = updatedStakeholders;
        else data = (0, $hmDJ3.transformStkeholdersDetailResponseData)(updatedStakeholders);
        setState({
            stakeholders: {
                error: undefined,
                data: data
            }
        });
        try {
            if (issueVersion.isNew) (0, $lRmyA.performDeleteRequest)(`/gateway/api/jsm/stakeholders/cloudId/${cloudId}/v1/stakeholders/issue/${issueId}`, {
                body: JSON.stringify({
                    stakeholderIds: removedStakeholders.map((stakeholder)=>stakeholder.id)
                })
            });
            else await (0, $lRmyA.performPutRequest)(`${(0, $iCRmp.getEscalatorBaseUrl)(cloudId)}/issue/${issueId}/incident/stakeholders`, {
                body: JSON.stringify({
                    stakeholderAris: removedStakeholders.map(// @ts-expect-error: After old version of stakeholders removed/deprecated, that util will be removed. `isNew` is the condition
                    (stakeholder)=>stakeholder.ari)
                })
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/41046
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'removeStakeholder succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // https://data-portal.internal.atlassian.com/analytics/registry/41048
            (0, $guiFP.default)({
                event: analyticsEvent,
                meta: {
                    id: 'removeStakeholder',
                    packageName: 'jiraJsmStakeholderUpdates',
                    teamName: 'itsm-agni'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                stakeholders: {
                    error: e.message
                }
            });
            showFlag({
                type: 'error',
                title: (0, $6Rubo.default).failureHeading,
                description: (0, $6Rubo.default).failureDescription
            });
        }
    };

});
parcelRegister("6Rubo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f7d3581531f5915$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0f7d3581531f5915$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    failureHeading: {
        "id": "jsm-stakeholder-updates.services.actions.remove-stakeholder.failure-heading",
        "defaultMessage": "Stakeholder was not removed"
    },
    failureDescription: {
        "id": "jsm-stakeholder-updates.services.actions.remove-stakeholder.failure-description",
        "defaultMessage": "Something went wrong. Try refreshing the page."
    }
});

});


parcelRegister("2G2Gh", function(module, exports) {

$parcel$export(module.exports, "updateStakeholder", () => $9b98c8bafa8845d8$export$817fb696654404cf);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");

var $iCRmp = parcelRequire("iCRmp");

var $5y3CU = parcelRequire("5y3CU");
const $9b98c8bafa8845d8$export$817fb696654404cf = (stakeholderPayload)=>async ({ getState: getState, setState: setState }, { issueId: issueId, cloudId: cloudId, analyticsEvent: analyticsEvent, onCloseUpdateStakeholderModal: onCloseUpdateStakeholderModal })=>{
        const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
        const { message: message, description: description } = stakeholderPayload;
        const { informModal: { isUpdateStakeholderLoading: isUpdateStakeholderLoading, ...rest }, issueVersion: issueVersion } = getState();
        if (isUpdateStakeholderLoading) return;
        if (!issueId) {
            setState({
                stakeholders: {
                    error: 'Missing issueId'
                }
            });
            return;
        }
        setState({
            informModal: {
                ...rest,
                isUpdateStakeholderLoading: true
            }
        });
        const url = issueVersion.isNew ? `/gateway/api/jsm/stakeholders/cloudId/${cloudId}/v1/stakeholders/issue/${issueId}/status-update        ` : `${(0, $iCRmp.getEscalatorBaseUrl)(cloudId)}/issue/${issueId}/incident/communication/status-update`;
        try {
            await (0, $lRmyA.performPostRequest)(url, {
                body: JSON.stringify({
                    message: message,
                    description: description
                })
            });
            setState({
                informModal: {
                    ...rest,
                    isUpdateStakeholderLoading: false
                }
            });
            showFlag({
                type: 'success',
                title: issueVersion.isNew ? (0, $5y3CU.default).updateSuccess : (0, $5y3CU.default).updateStakeholderSuccess
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/41055
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'updateStakeholder succeeded');
            onCloseUpdateStakeholderModal?.();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // https://data-portal.internal.atlassian.com/analytics/registry/41054
            (0, $guiFP.default)({
                event: analyticsEvent,
                meta: {
                    id: 'updateStakeholder',
                    packageName: 'jiraJsmStakeholderUpdates',
                    teamName: 'itsm-agni'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                informModal: {
                    ...rest,
                    isUpdateStakeholderLoading: false
                }
            });
            showFlag({
                type: 'error',
                title: issueVersion.isNew ? (0, $5y3CU.default).updateError : (0, $5y3CU.default).updateStakeholderError
            });
        }
    };

});
parcelRegister("5y3CU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6466c00e9518a37$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e6466c00e9518a37$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    updateStakeholderError: {
        "id": "jsm-stakeholder-updates.services.actions.update-stakeholder.update-stakeholder-error",
        "defaultMessage": "Something went wrong. Please try again."
    },
    updateStakeholderSuccess: {
        "id": "jsm-stakeholder-updates.services.actions.update-stakeholder.update-stakeholder-success",
        "defaultMessage": "Message sent to stakeholders."
    },
    updateError: {
        "id": "jsm-stakeholder-updates.services.actions.update-stakeholder.update-error",
        "defaultMessage": "Couldn\u2019t send message. Try again."
    },
    updateSuccess: {
        "id": "jsm-stakeholder-updates.services.actions.update-stakeholder.update-success",
        "defaultMessage": "Message sent!"
    }
});

});




parcelRegister("8L3Y4", function(module, exports) {

$parcel$export(module.exports, "useHasCurrentUserOpsgenieAccount", () => $3eb256f41526dd4b$export$340013ec995e6863);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $cWiVr = parcelRequire("cWiVr");

var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $cPeK1 = parcelRequire("cPeK1");

var $a40QR = parcelRequire("a40QR");
const $3eb256f41526dd4b$export$d4c72bab9d6cc13a = {
    data: {
        hasOpsgenieAccount: undefined
    },
    isLoading: false,
    error: undefined
};
const $3eb256f41526dd4b$export$152a899769dcec7a = (0, $a61MH.createStore)({
    name: 'hasOpsgenieAccount',
    initialState: $3eb256f41526dd4b$export$d4c72bab9d6cc13a,
    actions: (0, $a40QR.actions)
});
const $3eb256f41526dd4b$export$1370c8074eb7b15c = (0, $ggKAj.createHook)($3eb256f41526dd4b$export$152a899769dcec7a);
const $3eb256f41526dd4b$export$340013ec995e6863 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [state, { fetchHasOpgenieAccount: fetchHasOpgenieAccount }] = $3eb256f41526dd4b$export$1370c8074eb7b15c();
    const userId = (0, $cWiVr.useCurrentUser)().data.user.accountId;
    const { baseUrl: baseUrl, cloudId: cloudId, isAnonymous: isAnonymous } = (0, $gd0Sp.useTenantContext)();
    (0, $eUqFw.useEffect)(()=>{
        fetchHasOpgenieAccount({
            baseUrl: baseUrl,
            cloudId: cloudId,
            userId: userId,
            isAnonymousUser: isAnonymous,
            analyticsEvent: createAnalyticsEvent({}),
            packageName: (0, $cPeK1.PACKAGE_NAME)
        });
    }, [
        fetchHasOpgenieAccount,
        baseUrl,
        cloudId,
        userId,
        isAnonymous,
        createAnalyticsEvent
    ]);
    return [
        state.data.hasOpsgenieAccount,
        {}
    ];
};

});
parcelRegister("cPeK1", function(module, exports) {

$parcel$export(module.exports, "MODAL_WIDTH", () => $bbf0d4b406038aac$export$3d931b64f46140b3);
$parcel$export(module.exports, "PACKAGE_NAME", () => $bbf0d4b406038aac$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PRIORITIES", () => $bbf0d4b406038aac$export$19868e2467c966ad);
$parcel$export(module.exports, "OG_PRIORITY_MAP", () => $bbf0d4b406038aac$export$b589c96cf5816a9a);
$parcel$export(module.exports, "priorityColor", () => $bbf0d4b406038aac$export$1d50193093c58ff5);

var $PdmhA = parcelRequire("PdmhA");

var $2DOwT = parcelRequire("2DOwT");
const $bbf0d4b406038aac$export$3d931b64f46140b3 = 1100;
const $bbf0d4b406038aac$export$89b184e16097a22c = 520;
const $bbf0d4b406038aac$export$b8b9d90f9e5bd72b = '@atlassian/jira-servicedesk-incident-management-common';
const $bbf0d4b406038aac$export$e8805feb671eaec0 = 'P1';
const $bbf0d4b406038aac$export$d427e17c6d064ec6 = 'P2';
const $bbf0d4b406038aac$export$e81d4063aa06b4a6 = 'P3';
const $bbf0d4b406038aac$export$ea76bf8c3641289b = 'P4';
const $bbf0d4b406038aac$export$73b8c7bebfca6d79 = 'P5';
const $bbf0d4b406038aac$export$19868e2467c966ad = {
    P1: $bbf0d4b406038aac$export$e8805feb671eaec0,
    P2: $bbf0d4b406038aac$export$d427e17c6d064ec6,
    P3: $bbf0d4b406038aac$export$e81d4063aa06b4a6,
    P4: $bbf0d4b406038aac$export$ea76bf8c3641289b,
    P5: $bbf0d4b406038aac$export$73b8c7bebfca6d79
};
const $bbf0d4b406038aac$export$231eb4d67f0067d8 = 'icc';
const $bbf0d4b406038aac$var$PRIORITY_COLORS = {
    [$bbf0d4b406038aac$export$e8805feb671eaec0]: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA.R500)})`,
    [$bbf0d4b406038aac$export$d427e17c6d064ec6]: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA.R200)})`,
    [$bbf0d4b406038aac$export$e81d4063aa06b4a6]: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA.Y300)})`,
    [$bbf0d4b406038aac$export$ea76bf8c3641289b]: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA.G300)})`,
    [$bbf0d4b406038aac$export$73b8c7bebfca6d79]: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA.G500)})`
};
const $bbf0d4b406038aac$var$PRIORITY_COLORS_CONSOLIDATION = {
    [$bbf0d4b406038aac$export$e8805feb671eaec0]: "var(--ds-background-danger-bold, #CA3521)",
    [$bbf0d4b406038aac$export$d427e17c6d064ec6]: "var(--ds-background-accent-red-subtle, #F87462)",
    [$bbf0d4b406038aac$export$e81d4063aa06b4a6]: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    [$bbf0d4b406038aac$export$ea76bf8c3641289b]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [$bbf0d4b406038aac$export$73b8c7bebfca6d79]: "var(--ds-background-accent-green-bolder, #1F845A)"
};
const $bbf0d4b406038aac$export$b589c96cf5816a9a = [
    {
        value: $bbf0d4b406038aac$export$19868e2467c966ad.P1,
        label: (0, $2DOwT.default).criticalAlertPriority
    },
    {
        value: $bbf0d4b406038aac$export$19868e2467c966ad.P2,
        label: (0, $2DOwT.default).highAlertPriority
    },
    {
        value: $bbf0d4b406038aac$export$19868e2467c966ad.P3,
        label: (0, $2DOwT.default).moderateAlertPriority
    },
    {
        value: $bbf0d4b406038aac$export$19868e2467c966ad.P4,
        label: (0, $2DOwT.default).lowAlertPriority
    },
    {
        value: $bbf0d4b406038aac$export$19868e2467c966ad.P5,
        label: (0, $2DOwT.default).informationalAlertPriority
    }
];
const $bbf0d4b406038aac$export$1d50193093c58ff5 = (p, consolidated = false)=>consolidated ? $bbf0d4b406038aac$var$PRIORITY_COLORS_CONSOLIDATION[p] : $bbf0d4b406038aac$var$PRIORITY_COLORS[p];

});
parcelRegister("2DOwT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc561cd6a65795b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bdc561cd6a65795b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    criticalAlertPriority: {
        "id": "servicedesk-incident-management-common.critical-alert-priority",
        "defaultMessage": "Critical"
    },
    highAlertPriority: {
        "id": "servicedesk-incident-management-common.high-alert-priority",
        "defaultMessage": "High"
    },
    moderateAlertPriority: {
        "id": "servicedesk-incident-management-common.moderate-alert-priority",
        "defaultMessage": "Moderate"
    },
    lowAlertPriority: {
        "id": "servicedesk-incident-management-common.low-alert-priority",
        "defaultMessage": "Low"
    },
    informationalAlertPriority: {
        "id": "servicedesk-incident-management-common.informational-alert-priority",
        "defaultMessage": "Informational"
    }
});

});


parcelRegister("a40QR", function(module, exports) {

$parcel$export(module.exports, "actions", () => $1383f62edd59f6e9$export$e324594224ef24da);

var $8Ukxz = parcelRequire("8Ukxz");
const $1383f62edd59f6e9$export$e324594224ef24da = {
    fetchHasOpgenieAccount: $8Ukxz.fetchHasOpgenieAccount
};

});
parcelRegister("8Ukxz", function(module, exports) {

$parcel$export(module.exports, "fetchHasOpgenieAccount", () => $7bdb9ae1c0bcf364$export$4260d7dd363de357);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");
const $7bdb9ae1c0bcf364$var$isValidFetchState = ({ data: { hasOpsgenieAccount: hasOpsgenieAccount }, isLoading: isLoading, error: error })=>hasOpsgenieAccount === undefined && !isLoading && error === undefined;
const $7bdb9ae1c0bcf364$export$4260d7dd363de357 = ({ baseUrl: baseUrl, cloudId: cloudId, userId: userId, isAnonymousUser: isAnonymousUser, analyticsEvent: analyticsEvent, packageName: packageName })=>async ({ getState: getState, setState: setState })=>{
        if (!$7bdb9ae1c0bcf364$var$isValidFetchState(getState())) return;
        if (isAnonymousUser) {
            setState({
                data: {
                    hasOpsgenieAccount: false
                },
                isLoading: false,
                error: undefined
            });
            return;
        }
        if (userId == null) return;
        setState({
            isLoading: true,
            error: undefined
        });
        try {
            const response = await (0, $lRmyA.performGetRequest)(`${baseUrl || ''}/gateway/api/jsd/escalator/${cloudId}/api/user-rights/has-opsgenie-access?accountId=${userId}`);
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'fetchHasOpgenieAccount succeeded');
            setState({
                data: {
                    hasOpsgenieAccount: response
                },
                isLoading: false,
                error: undefined
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'fetchHasOpgenieAccount',
                    packageName: packageName
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                isLoading: false,
                error: error
            });
        }
    };

});



const $50b9feecb89aca70$export$308b1adbd1c265c4 = 'FETCH_INCIDENT_CAPABILITIES_PROVISION_STATE_ERROR';
const $50b9feecb89aca70$export$8cf2ab04a7290f8e = 'UPDATE_SYSTEM_INCIDENT_ERROR';
const $50b9feecb89aca70$export$2daf2ae6b87b6acf = 'unsuppress_alert_creation';
const $50b9feecb89aca70$export$12df15eb7a33df57 = 'suppress_alert_creation';
const $50b9feecb89aca70$export$84a9ec0d18610c1e = 'not_provisioned';
const $50b9feecb89aca70$export$5a9ac66c2785cc13 = 'in_progress';
const $50b9feecb89aca70$export$71efb3495f6084f2 = 'done';
const $50b9feecb89aca70$export$103bedf43ba882db = 'error';

parcelRegister("cezKj", function(module, exports) {

$parcel$export(module.exports, "IncidentCapabilitiesProvisionContainer", () => $a038602a5b3179fb$export$a2377e9dd25b3a13);
$parcel$export(module.exports, "useIncidentCapabilitiesProvisionState", () => $a038602a5b3179fb$export$7dafe9ace6d249b2);
$parcel$export(module.exports, "useProvisionIncidentCapabalities", () => $a038602a5b3179fb$export$9f03bf1c2bac0dc7);

var $eUqFw = parcelRequire("eUqFw");

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $hJ992 = parcelRequire("hJ992");

var $2wCUM = parcelRequire("2wCUM");

var $gd0Sp = parcelRequire("gd0Sp");

var $f1E05 = parcelRequire("f1E05");
const $a038602a5b3179fb$export$d4c72bab9d6cc13a = {
    incidentCapabilitiesProvisionState: {
        data: undefined,
        forIssueId: undefined,
        error: undefined,
        isLoading: false
    },
    provisioningIncidentCapabalities: {
        hasUpdateCompleted: false,
        error: undefined,
        isLoading: false
    }
};
const $a038602a5b3179fb$var$incidentManagementIncidentCapabilitiesProvisionStore = (0, $a61MH.createStore)({
    name: 'JSDIncidentManagementIncidentCapabilitiesProvision',
    initialState: $a038602a5b3179fb$export$d4c72bab9d6cc13a,
    actions: $f1E05.actions
});
const $a038602a5b3179fb$export$a2377e9dd25b3a13 = (0, $heB5U.createContainer)($a038602a5b3179fb$var$incidentManagementIncidentCapabilitiesProvisionStore);
const $a038602a5b3179fb$export$282e577dbd609d4b = (0, $ggKAj.createHook)($a038602a5b3179fb$var$incidentManagementIncidentCapabilitiesProvisionStore, {
    selector: ({ incidentCapabilitiesProvisionState: incidentCapabilitiesProvisionState })=>incidentCapabilitiesProvisionState
});
const $a038602a5b3179fb$export$7dafe9ace6d249b2 = ()=>{
    const result = $a038602a5b3179fb$export$282e577dbd609d4b();
    const [{ forIssueId: forIssueId }, { fetchIncidentCapabilitiesProvisionState: fetchIncidentCapabilitiesProvisionState }] = result;
    const issueId = (0, $hJ992.useIssueId)();
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const isIncidentsPracticeEnabled = (0, $2wCUM.useIsIssueOfIncidentsPractice)();
    (0, $eUqFw.useEffect)(()=>{
        if (isIncidentsPracticeEnabled && issueId && forIssueId !== issueId) fetchIncidentCapabilitiesProvisionState(issueId, cloudId);
    }, [
        isIncidentsPracticeEnabled,
        issueId,
        cloudId,
        forIssueId,
        fetchIncidentCapabilitiesProvisionState
    ]);
    return result;
};
const $a038602a5b3179fb$export$9f03bf1c2bac0dc7 = (0, $ggKAj.createHook)($a038602a5b3179fb$var$incidentManagementIncidentCapabilitiesProvisionStore, {
    selector: ({ provisioningIncidentCapabalities: provisioningIncidentCapabalities })=>provisioningIncidentCapabalities
});

});
parcelRegister("f1E05", function(module, exports) {

$parcel$export(module.exports, "actions", () => $6a0e19df982f3ef3$export$e324594224ef24da);

var $gyTMg = parcelRequire("gyTMg");

var $6l48U = parcelRequire("6l48U");
const $6a0e19df982f3ef3$export$e324594224ef24da = {
    fetchIncidentCapabilitiesProvisionState: $gyTMg.fetchIncidentCapabilitiesProvisionState,
    provisionIncidentCapabalities: $6l48U.provisionIncidentCapabalities
};

});
parcelRegister("gyTMg", function(module, exports) {

$parcel$export(module.exports, "fetchIncidentCapabilitiesProvisionState", () => $431d5f9b312b5ebc$export$9f9b40a56cb5ab43);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $iCRmp = parcelRequire("iCRmp");

const $431d5f9b312b5ebc$export$9f9b40a56cb5ab43 = (issueId, cloudId, analyticsEvent)=>async ({ getState: getState, setState: setState })=>{
        const { incidentCapabilitiesProvisionState: incidentCapabilitiesProvisionState, provisioningIncidentCapabalities: provisioningIncidentCapabalities } = getState();
        if (incidentCapabilitiesProvisionState.isLoading || !issueId) return;
        setState({
            incidentCapabilitiesProvisionState: {
                ...incidentCapabilitiesProvisionState,
                forIssueId: issueId,
                isLoading: true,
                error: undefined
            }
        });
        try {
            const response = await (0, $2OdyW.default)(`${(0, $iCRmp.getEscalatorBaseUrl)(cloudId)}/issue/${issueId}/incident/provision`);
            if (provisioningIncidentCapabalities?.isLoading && response?.provisionState === (0, $50b9feecb89aca70$export$71efb3495f6084f2)) setState({
                incidentCapabilitiesProvisionState: {
                    data: response,
                    forIssueId: issueId,
                    isLoading: false,
                    error: undefined
                },
                provisioningIncidentCapabalities: {
                    hasUpdateCompleted: true,
                    isLoading: false,
                    error: undefined
                }
            });
            else setState({
                incidentCapabilitiesProvisionState: {
                    data: response,
                    forIssueId: issueId,
                    isLoading: false,
                    error: undefined
                }
            });
            analyticsEvent && (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'fetchIncidentCapabilitiesProvisionState succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $guiFP.trackFetchErrors)({
                event: analyticsEvent,
                error: e,
                id: 'fetchIncidentCapabilitiesProvisionState',
                sendToPrivacyUnsafeSplunk: true,
                packageName: 'jiraServicedeskSystemIncidentStatus'
            });
            if (provisioningIncidentCapabalities?.isLoading) setState({
                incidentCapabilitiesProvisionState: {
                    data: undefined,
                    forIssueId: issueId,
                    isLoading: false,
                    error: {
                        value: e.message,
                        type: (0, $50b9feecb89aca70$export$308b1adbd1c265c4)
                    }
                },
                provisioningIncidentCapabalities: {
                    hasUpdateCompleted: false,
                    isLoading: false,
                    error: undefined
                }
            });
            else setState({
                incidentCapabilitiesProvisionState: {
                    data: undefined,
                    forIssueId: issueId,
                    isLoading: false,
                    error: {
                        value: e.message,
                        type: (0, $50b9feecb89aca70$export$308b1adbd1c265c4)
                    }
                }
            });
        }
    };

});

parcelRegister("6l48U", function(module, exports) {

$parcel$export(module.exports, "provisionIncidentCapabalities", () => $eb00cd5fcc1bdc17$export$b83cf9b24594c13c);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $iCRmp = parcelRequire("iCRmp");

const $eb00cd5fcc1bdc17$export$b83cf9b24594c13c = (issueId, cloudId, analyticsEvent)=>async ({ getState: getState, setState: setState })=>{
        const { provisioningIncidentCapabalities: provisioningIncidentCapabalities } = getState();
        if (provisioningIncidentCapabalities.isLoading || !issueId) return;
        setState({
            provisioningIncidentCapabalities: {
                hasUpdateCompleted: false,
                isLoading: true,
                error: undefined
            }
        });
        try {
            await (0, $lRmyA.performPostRequest)(`${(0, $iCRmp.getEscalatorBaseUrl)(cloudId)}/issue/${issueId}/incident/provision`);
            /* provisioningIncidentCapabalities state is not updated here as <PeriodicExecutor /> will
            fire once isLoading is true, will be set to updateComplete true and isLoading false once
            async task is finished. Look inside fetch-incident-capabilities-provision-state for more details. */ analyticsEvent && (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'provisionIncidentCapabilities succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $guiFP.trackFetchErrors)({
                event: analyticsEvent,
                error: e,
                id: 'provisionIncidentCapabilities',
                sendToPrivacyUnsafeSplunk: true,
                packageName: 'jiraServicedeskSystemIncidentStatus'
            });
            setState({
                provisioningIncidentCapabalities: {
                    hasUpdateCompleted: false,
                    isLoading: false,
                    error: {
                        value: e.message,
                        type: (0, $50b9feecb89aca70$export$8cf2ab04a7290f8e)
                    }
                }
            });
        }
    };

});



parcelRegister("3hOJx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9844f100df2ee929$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $9844f100df2ee929$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    replyToCustomer: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.reply-to-customer-button",
        "defaultMessage": "Reply to customer"
    },
    addInternalNote: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.add-internal-note-button",
        "defaultMessage": "Add internal note"
    },
    loadingAttachments: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.loading-attachments",
        "defaultMessage": "Loading attachments\u2026"
    },
    informStakeholders: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.inform-stakeholders",
        "defaultMessage": "Inform stakeholders"
    },
    informStakeholderLimitExceed: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.inform-stakeholder-limit-exceed",
        "defaultMessage": "You cannot send any updates as your trial period limit of 50 stakeholder emails per day is over."
    }
});

});

parcelRegister("5dZWW", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b7b45bd33dce833$export$2e2bcd8739ae039);

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $1v6Su = parcelRequire("1v6Su");

var $dmojD = parcelRequire("dmojD");

var $hb9Gq = parcelRequire("hb9Gq");
var $1b7b45bd33dce833$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        isCommentAttachmentInProgress: (0, $dmojD.isCommentAttachmentInProgressSelector)(state)
    }), (dispatch)=>({
        onClick: ()=>{
            dispatch((0, $1v6Su.attachmentPickerPopupOpenSuccess)());
        }
    })))((0, $hb9Gq.default));

});
parcelRegister("hb9Gq", function(module, exports) {

$parcel$export(module.exports, "default", () => $354bb3f475af6744$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $jUThT = parcelRequire("jUThT");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fKHlF = parcelRequire("fKHlF");
const $354bb3f475af6744$var$AttachmentPicker = (props)=>{
    const { onClick: onClick, isCommentAttachmentInProgress: isCommentAttachmentInProgress } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($354bb3f475af6744$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $fKHlF.default).addAttachmentLabel),
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        spacing: "none",
        appearance: "subtle-link" // @ts-expect-error - TS2322 - Type '{ spacing: "none"; appearance: "subtle-link"; isLoading: boolean; iconBefore: Element; externalId: string; onClick: () => void; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
        ,
        isLoading: isCommentAttachmentInProgress,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($354bb3f475af6744$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jUThT))), {
            size: "medium",
            label: formatMessage((0, $fKHlF.default).addAttachmentLabel)
        })),
        externalId: "attachment",
        onClick: onClick,
        interactionName: "auto-generated.jira-issue-view-servicedesk-editor-container.collapsed-editor-view.attachment-picker.button"
    })));
};
var $354bb3f475af6744$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $354bb3f475af6744$var$AttachmentPicker;
const $354bb3f475af6744$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $354bb3f475af6744$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01wug _2hwxu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jUThT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7fe223acf10e6f6$var$_react = $e7fe223acf10e6f6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e7fe223acf10e6f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e7fe223acf10e6f6$var$AttachmentIcon = (props)=>/*#__PURE__*/ $e7fe223acf10e6f6$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.643 17.965c-1.53 1.495-4.016 1.496-5.542.004a3.773 3.773 0 01.002-5.412l7.147-6.985a2.316 2.316 0 013.233-.003c.893.873.895 2.282.004 3.153l-6.703 6.55a.653.653 0 01-.914-.008.62.62 0 010-.902l6.229-6.087a.941.941 0 000-1.353.995.995 0 00-1.384 0l-6.23 6.087a2.502 2.502 0 000 3.607 2.643 2.643 0 003.683.009l6.703-6.55a4.074 4.074 0 00-.003-5.859 4.306 4.306 0 00-6.002.003l-7.148 6.985a5.655 5.655 0 00-.001 8.118c2.29 2.239 6.015 2.238 8.31-.005l6.686-6.533a.941.941 0 000-1.353.995.995 0 00-1.384 0l-6.686 6.534z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$e7fe223acf10e6f6$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $e7fe223acf10e6f6$var$_default = $e7fe223acf10e6f6$var$AttachmentIcon;
module.exports.default = $e7fe223acf10e6f6$var$_default;

});

parcelRegister("fKHlF", function(module, exports) {

$parcel$export(module.exports, "default", () => $52b1695ed61363ef$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $52b1695ed61363ef$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addAttachmentLabel: {
        "id": "issue.label-for-add-attachment-button",
        "defaultMessage": "Add attachment"
    }
});

});







parcelRegister("5m7aG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ac973f1376a8fef$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2ac973f1376a8fef$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    editedBy: {
        "id": "issue-comment-base.comment.edited-by",
        "defaultMessage": "{timestamp} by {author}"
    },
    anonymous: {
        "id": "issue-comment-base.comment.anonymous",
        "defaultMessage": "Anonymous"
    },
    edit: {
        "id": "issue-comment-base.comment.edit",
        "defaultMessage": "Edit"
    },
    hide: {
        "id": "issue-comment-base.comment.hide",
        "defaultMessage": "Hide"
    },
    unhide: {
        "id": "issue-comment-base.comment.unhide",
        "defaultMessage": "Unhide"
    },
    delete: {
        "id": "issue-comment-base.comment.delete",
        "defaultMessage": "Delete"
    },
    edited: {
        "id": "issue-comment-base.comment.edited",
        "defaultMessage": "Edited"
    },
    retrySave: {
        "id": "issue-comment-base.comment.retry-save",
        "defaultMessage": "Retry"
    },
    cancelSave: {
        "id": "issue-comment-base.comment.cancel-save",
        "defaultMessage": "Cancel"
    },
    saving: {
        "id": "issue-comment-base.comment.saving",
        "defaultMessage": "Saving..."
    },
    confirmationHeader: {
        "id": "issue-comment-base.comment.confirmation-header",
        "defaultMessage": "Delete this comment?"
    },
    confirmationContent: {
        "id": "issue-comment-base.comment.confirmation-content",
        "defaultMessage": "Once you delete, it's gone for good."
    },
    cancelDelete: {
        "id": "issue-comment-base.comment.cancel-delete",
        "defaultMessage": "Cancel"
    },
    confirmationActionText: {
        "id": "issue-comment-base.comment.confirmation-action-text",
        "defaultMessage": "Delete"
    },
    internalNote: {
        "id": "issue-comment-base.comment.internal-note",
        "defaultMessage": "Internal note"
    },
    copy: {
        "id": "issue-comment-base.comment.copy",
        "defaultMessage": "Copy link to comment"
    },
    lozenge: {
        "id": "issue-comment-base.comment.lozenge",
        "defaultMessage": "Comments"
    },
    addedCommentDescription: {
        "id": "issue-comment-base.comment.added-comment-description",
        "defaultMessage": "added a <span>Comment</span>"
    },
    addedCommentDescriptionLowercase: {
        "id": "issue-comment-base.comment.added-comment-description-lowercase",
        "defaultMessage": "added a <span>comment</span>"
    },
    notRequestParticipant: {
        "id": "issue-comment-base.comment.not-request-participant",
        "defaultMessage": "(not a request participant)"
    },
    comment: {
        "id": "issue-comment-base.comment.comment",
        "defaultMessage": "Comment"
    }
});

});

parcelRegister("2g6Qf", function(module, exports) {

$parcel$export(module.exports, "default", () => $afc261e38337521c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $Jptg5 = parcelRequire("Jptg5");

var $f0w6p = parcelRequire("f0w6p");
const $afc261e38337521c$var$ConnectedRenderer = ({ adf: adf })=>{
    const [{ mentionProvider: mentionProvider, contextIdentifier: contextIdentifier, mediaContext: mediaContext }] = (0, $f0w6p.useEditorState)();
    if (!mentionProvider || !contextIdentifier || !mediaContext) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Jptg5.default), {
        adf: adf,
        mentionProvider: mentionProvider,
        contextIdentifier: contextIdentifier,
        mediaContext: mediaContext
    });
};
var $afc261e38337521c$export$2e2bcd8739ae039 = $afc261e38337521c$var$ConnectedRenderer;

});
parcelRegister("f0w6p", function(module, exports) {

$parcel$export(module.exports, "useContextState", () => $c4144b74a893d288$export$678f7876866dd0b1);
$parcel$export(module.exports, "useEditorState", () => $c4144b74a893d288$export$e6e340c65601d57b);
$parcel$export(module.exports, "useReactionsState", () => $c4144b74a893d288$export$2c4c0ee735162c7d);
$parcel$export(module.exports, "useCommentActivityStoreActions", () => $c4144b74a893d288$export$ea49c34f8e661fcf);
$parcel$export(module.exports, "CommentActivityStoreContainer", () => $c4144b74a893d288$export$406af6e6c6ae7c57);

var $jG2Eu = parcelRequire("jG2Eu");

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $ckFWs = parcelRequire("ckFWs");
const $c4144b74a893d288$var$emptyMentionEncoder = ()=>'';
const $c4144b74a893d288$export$d4c72bab9d6cc13a = {
    context: {
        issueAri: null,
        commentAri: null,
        projectType: null
    },
    editor: {
        contextIdentifier: null,
        mentionProvider: null,
        getEncodedMention: $c4144b74a893d288$var$emptyMentionEncoder,
        activityProvider: null,
        mediaContext: null,
        sharedAtTimestamp: null,
        sharedValue: undefined,
        onEditorExpandedFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onEditorSaveFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onEditorClearSharedValues: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    },
    reactions: {
        isActive: false
    }
};
const $c4144b74a893d288$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-comment',
    initialState: $c4144b74a893d288$export$d4c72bab9d6cc13a,
    actions: $ckFWs.actions
});
const $c4144b74a893d288$export$678f7876866dd0b1 = (0, $ggKAj.createHook)($c4144b74a893d288$export$6f57813fe9f31bf9, {
    selector: (state)=>state.context
});
const $c4144b74a893d288$export$e6e340c65601d57b = (0, $ggKAj.createHook)($c4144b74a893d288$export$6f57813fe9f31bf9, {
    selector: (state)=>state.editor
});
const $c4144b74a893d288$export$2c4c0ee735162c7d = (0, $ggKAj.createHook)($c4144b74a893d288$export$6f57813fe9f31bf9, {
    selector: (state)=>state.reactions
});
const $c4144b74a893d288$export$ea49c34f8e661fcf = (0, $ggKAj.createHook)($c4144b74a893d288$export$6f57813fe9f31bf9, {
    selector: null
});
const $c4144b74a893d288$export$406af6e6c6ae7c57 = (0, $heB5U.createContainer)($c4144b74a893d288$export$6f57813fe9f31bf9);

});
parcelRegister("ckFWs", function(module, exports) {

$parcel$export(module.exports, "actions", () => $2b8fbd1ae0bd3c52$export$e324594224ef24da);
const $2b8fbd1ae0bd3c52$var$setContextState = (contextState)=>({ setState: setState, getState: getState })=>{
        const newState = {
            ...getState(),
            context: contextState
        };
        setState(newState);
    };
const $2b8fbd1ae0bd3c52$var$setEditorState = (editorState)=>({ setState: setState, getState: getState })=>{
        const newState = {
            ...getState(),
            editor: editorState
        };
        setState(newState);
    };
const $2b8fbd1ae0bd3c52$var$setReactionsState = (reactionsState)=>({ setState: setState, getState: getState })=>{
        const newState = {
            ...getState(),
            reactions: reactionsState
        };
        setState(newState);
    };
const $2b8fbd1ae0bd3c52$export$e324594224ef24da = {
    setContextState: $2b8fbd1ae0bd3c52$var$setContextState,
    setEditorState: $2b8fbd1ae0bd3c52$var$setEditorState,
    setReactionsState: $2b8fbd1ae0bd3c52$var$setReactionsState
};

});



parcelRegister("l47Hs", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('dff37')
        ]);
        const value = parcelRequire('2lO2j');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("dff37")
    ]).then(()=>parcelRequire('2lO2j'));
}

});


parcelRegister("autRb", function(module, exports) {

$parcel$export(module.exports, "smoothScrollIntoViewIfNeeded", () => $ac96ec4b62c1bc71$export$5b29358fb792ecd7);
$parcel$export(module.exports, "smoothScrollIntoCenterIfNeeded", () => $ac96ec4b62c1bc71$export$779b53aa119940dc);

var $k7cZh = parcelRequire("k7cZh");
const $ac96ec4b62c1bc71$var$behavior = 'smooth';
const $ac96ec4b62c1bc71$export$5b29358fb792ecd7 = (element, options = Object.freeze({}))=>{
    if (element) (0, $k7cZh.default)(element, {
        behavior: $ac96ec4b62c1bc71$var$behavior,
        ...options
    });
};
const $ac96ec4b62c1bc71$export$779b53aa119940dc = (element)=>{
    if (element) $ac96ec4b62c1bc71$export$5b29358fb792ecd7(element, {
        block: 'center'
    });
};

});

parcelRegister("dE2jf", function(module, exports) {

$parcel$export(module.exports, "IssueAddCommentEditorLoading", () => $45a89f9f78d08c61$export$9261a11fead00f43);
$parcel$export(module.exports, "IssueAddCommentEditorBoundary", () => $45a89f9f78d08c61$export$1e708cc6fee59bcf);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $47rWJ = parcelRequire("47rWJ");
const $45a89f9f78d08c61$export$9261a11fead00f43 = (0, $47rWJ.default);
const $45a89f9f78d08c61$export$1e708cc6fee59bcf = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-add-comment-editor",
        packageName: packageName,
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallback)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-add-comment-editor",
        fallback: fallback
    }, children));

});
parcelRegister("47rWJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cb8f362f576c021$export$2e2bcd8739ae039);

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $5JqpU = parcelRequire("5JqpU");

var $gbrvO = parcelRequire("gbrvO");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$8cb8f362f576c021$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        isServiceDesk: (0, $5JqpU.isServiceDeskSelector)(state)
    }), {}))((0, $gbrvO.FallbackAddCommentEditor));

});
parcelRegister("gbrvO", function(module, exports) {

$parcel$export(module.exports, "FallbackAddCommentEditor", () => $82f970997d42766d$export$23159fb879e88dfb);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $4Bees = parcelRequire("4Bees");

var $1DJqS = parcelRequire("1DJqS");
class $82f970997d42766d$export$23159fb879e88dfb extends (0, $eUqFw.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            placeholder: '',
            onExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    static getServiceDeskFallbackEditor() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1DJqS.ServiceDeskSpinner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "medium"
        }));
    }
    getGeneralFallbackEditor() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1DJqS.Button), {
            onClick: this.onClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1DJqS.Flex), null, this.props.placeholder, this.state.changed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1DJqS.SpinnerSpan), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small"
        }))));
    }
    render() {
        const shouldUseServiceDeskCommentEditor = this.props.isServiceDesk;
        return shouldUseServiceDeskCommentEditor ? $82f970997d42766d$export$23159fb879e88dfb.getServiceDeskFallbackEditor() : this.getGeneralFallbackEditor();
    }
    constructor(...args){
        super(...args);
        this.state = {
            changed: false
        };
        this.onClick = ()=>{
            this.props.onExpanded();
            this.setState({
                changed: true
            });
        };
    }
}

});
parcelRegister("1DJqS", function(module, exports) {

$parcel$export(module.exports, "Button", () => $2467860b61dcf636$export$353f5b6fc5456de1);
$parcel$export(module.exports, "Flex", () => $2467860b61dcf636$export$f51f4c4ede09e011);
$parcel$export(module.exports, "SpinnerSpan", () => $2467860b61dcf636$export$fcb30187a4aff565);
$parcel$export(module.exports, "ServiceDeskSpinner", () => $2467860b61dcf636$export$dbd1cb1120d87325);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");
const $2467860b61dcf636$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_u4lxiy": (0, $9t7rW.default)((0, $XHGTv.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? `var(--ds-border-input, ${(0, $PdmhA).N100})` : `var(--ds-border, ${(0, $PdmhA).N40})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h _syaz13nv _11c81kw7 _11q7vuon _1bsb1osq _4t3i1ylp _19bvv47k _u5f3v47k _ca0qutpp _n3tdutpp _2rko1l7b _vchhusvi _19ithk1e",
            __cmplp.className
        ])
    });
});
const $2467860b61dcf636$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _4t3idlk8 _ca0qv77o _1dyzdjp5",
            __cmplp.className
        ])
    });
});
const $2467860b61dcf636$export$fcb30187a4aff565 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0q1b66",
            __cmplp.className
        ])
    });
});
const $2467860b61dcf636$export$dbd1cb1120d87325 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
});

});




parcelRegister("5Zdar", function(module, exports) {

$parcel$export(module.exports, "default", () => $a54a4b11c58aa1d3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $keOMr = parcelRequire("keOMr");

var $fYY80 = parcelRequire("fYY80");
const $a54a4b11c58aa1d3$var$CommentShortcutHint = ({ messageDescriptor: messageDescriptor, values: values })=>{
    const isEmbedMode = (0, $keOMr.useIsEmbedMode)();
    if (isEmbedMode) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fYY80.StyledCommentShortcutHint), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...messageDescriptor,
        values: values
    }));
};
var $a54a4b11c58aa1d3$export$2e2bcd8739ae039 = $a54a4b11c58aa1d3$var$CommentShortcutHint;

});
parcelRegister("fYY80", function(module, exports) {

$parcel$export(module.exports, "StyledCommentShortcutHint", () => $ed26b54da2d96908$export$903538afaf45a25b);
$parcel$export(module.exports, "StickyWrapper", () => $ed26b54da2d96908$export$c1bdd37d1f2cfe01);
$parcel$export(module.exports, "Wrapper", () => $ed26b54da2d96908$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "AvatarContainer", () => $ed26b54da2d96908$export$6027454d331df3c4);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $PdmhA = parcelRequire("PdmhA");


var $jBZ6y = parcelRequire("jBZ6y");
const $ed26b54da2d96908$var$CONTAINER_HEIGHT = 100;
const $ed26b54da2d96908$export$903538afaf45a25b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _1e0c1ule _19pku2gc _o5721q9c _1wyb1crf _vwz41cnx",
            __cmplp.className
        ])
    });
});
const $ed26b54da2d96908$export$c1bdd37d1f2cfe01 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldApplySticky: shouldApplySticky, isKeylineVisible: isKeylineVisible, isHidden: isHidden, sortOrder: sortOrder, shouldApplyTopSticky: shouldApplyTopSticky, isModal: isModal, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_17l2vjj": (0, $9t7rW.default)(__cmplp.isKeylineVisible ? (0, $jBZ6y.issueViewLayers).baseLayer : 0),
            "--_pcpduf": (0, $9t7rW.default)(__cmplp.isHidden ? `translate(0, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            __cmplp.sortOrder === (0, $25476979aca7c7e0$export$e86669f498228fff) ? $ed26b54da2d96908$var$CONTAINER_HEIGHT : $ed26b54da2d96908$var$CONTAINER_HEIGHT * -1}px)` : 'translate(0, 0)'),
            "--_13x3tqy": (0, $9t7rW.default)(__cmplp.shouldApplyTopSticky ? 0 : undefined),
            "--_1lo5oba": (0, $9t7rW.default)(__cmplp.isModal ? "var(--ds-surface-overlay, white)" : "var(--ds-surface, white)")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_17gjpfqs",
            __cmplp.shouldApplySticky && "_kqsw1if8 _1pbympez _v5641pm3 _t9ec1tti _94n51i6y _154i186y _11q71brw _19bvu2gc _18u0x0bf",
            __cmplp.shouldApplySticky && __cmplp.isHidden && "_1e0c1bgi",
            __cmplp.className
        ])
    });
});
const $ed26b54da2d96908$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { sortOrder: sortOrder, isModal: isModal, isKeylineVisible: isKeylineVisible, shouldApplySticky: shouldApplySticky, shouldApplyTopSticky: shouldApplyTopSticky, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1yn2po1": (0, $9t7rW.default)(__cmplp.shouldApplyTopSticky ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `0 2px 0 0 ${`var(--ds-border, ${(0, $PdmhA).N30})`}, 0 -2px 0 0 ${`var(--ds-border, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $PdmhA).N30})`}` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `0 -2px 0 0 ${`var(--ds-border, ${(0, $PdmhA).N30})`}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _ca0qpxbi _n3tdpxbi _19pku2gc",
            __cmplp.sortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) ? "_otyrmgjw" : "_otyridpf",
            __cmplp.isModal ? "_11q71bhr" : "_11q7vuon",
            __cmplp.isKeylineVisible && __cmplp.shouldApplySticky && "_16qsxbao _19pku2gc",
            __cmplp.className
        ])
    });
});
const $ed26b54da2d96908$export$6027454d331df3c4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxutpp _19pkv77o",
            __cmplp.className
        ])
    });
});

});


parcelRegister("Otmhl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2d8c975449a2a9b5$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $2d8c975449a2a9b5$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    easyMentionsPlaceholder: {
        "id": "issue.easy-mentions-placeholder-for-empty-comment-editor",
        "defaultMessage": "Type @ to mention and notify someone."
    },
    cannedResponsesPlaceholder: {
        "id": "issue.canned-responses-placeholder-for-empty-comment-editor",
        "defaultMessage": "Type /canned to create or insert predefined responses."
    },
    placeholder: {
        "id": "issue.placeholder-for-empty-comment-editor",
        "defaultMessage": "Add a comment\u2026"
    },
    draftPlaceholder: {
        "id": "issue.draft-placeholder-for-empty-comment-editor",
        "defaultMessage": "You have an unsaved comment"
    },
    commentShortcutHintHeading: {
        "id": "issue.comment.shortcut-hint-pro-tip-text",
        "defaultMessage": "Pro tip:"
    },
    commentShortcutHintMessage: {
        "id": "issue.comment.shortcut-hint-message-with-pro-tip-text",
        "defaultMessage": "{proTipText} press {shortcutKey} to comment"
    },
    userAvatarAriaLabel: {
        "id": "issue.comment.user-avatar-aria-label",
        "defaultMessage": "Profile image of {displayName}"
    },
    comment: {
        "id": "issue-view.comment.comment-add.comment",
        "defaultMessage": "Comment"
    }
});

});

parcelRegister("5v6fH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('fJWBd')
        ]);
        const value = parcelRequire('1nm8f');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("fJWBd")
    ]).then(()=>parcelRequire('1nm8f'));
}

});



parcelRegister("kS8l2", function(module, exports) {

$parcel$export(module.exports, "useGlobalRef", () => $450c796f66462b96$export$361e4f658203e95);
$parcel$export(module.exports, "useGlobalRefStoreActions", () => $450c796f66462b96$export$3c6c6911d09d7d8a);
$parcel$export(module.exports, "withGlobalRef", () => $450c796f66462b96$export$6b4b878b04fd3017);

var $eUqFw = parcelRequire("eUqFw");

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $450c796f66462b96$var$store = (0, $a61MH.createStore)({
    initialState: {},
    actions: {
        register: (key, ref)=>({ setState: setState })=>{
                setState({
                    [key]: ref || undefined
                });
            }
    },
    name: 'refs-store'
});
const $450c796f66462b96$export$4beaa3baa53198e4 = (0, $heB5U.createContainer)($450c796f66462b96$var$store);
const $450c796f66462b96$var$useGlobalRefStateSelector = (0, $ggKAj.createStateHook)($450c796f66462b96$var$store, {
    selector: (state, key)=>state[key]
});
const $450c796f66462b96$export$361e4f658203e95 = (key)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        $450c796f66462b96$var$useGlobalRefStateSelector(key)
    ];
const $450c796f66462b96$export$3c6c6911d09d7d8a = (0, $ggKAj.createHook)($450c796f66462b96$var$store, {
    selector: null
});
const $450c796f66462b96$export$6b4b878b04fd3017 = (propName, refName)=>(Component)=>(props)=>{
            const [ref] = $450c796f66462b96$export$361e4f658203e95(refName);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                ...props,
                [propName]: ref
            });
        };

});


parcelRegister("9n6qV", function(module, exports) {

$parcel$export(module.exports, "default", () => $15b5aba978e81c98$export$2e2bcd8739ae039);

var $kgyAe = parcelRequire("kgyAe");
var $15b5aba978e81c98$export$2e2bcd8739ae039 = (0, $kgyAe.default);

});
parcelRegister("kgyAe", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e181536d1f2e32$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7opLA = parcelRequire("7opLA");
const $c5e181536d1f2e32$var$LoadMoreButton = ({ onClick: onClick, isDisabled: isDisabled, isLoading: isLoading, numberToLoad: numberToLoad, children: children })=>{
    if (numberToLoad <= 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5e181536d1f2e32$var$LoadMoreButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        onClick: onClick,
        isDisabled: isDisabled,
        isLoading: isLoading,
        shouldFitContainer: true,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "issue.activity.common.component.load-more-button.loading-button",
        interactionName: "auto-generated.issue.activity.common.component.load-more-button.loading-button.button"
    }, children));
};
var $c5e181536d1f2e32$export$2e2bcd8739ae039 = $c5e181536d1f2e32$var$LoadMoreButton;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5e181536d1f2e32$var$LoadMoreButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8zu5n",
            __cmplp.className
        ])
    });
});
$c5e181536d1f2e32$var$LoadMoreButtonContainer.displayName = 'LoadMoreButtonContainer';

});


parcelRegister("2k5N2", function(module, exports) {

$parcel$export(module.exports, "isJsmSmartRequestSummaryEnabled", () => $d9f18234c3f17aa8$export$7e4aef4ae0b914e2);

var $1ybV0 = parcelRequire("1ybV0");
const $d9f18234c3f17aa8$export$7e4aef4ae0b914e2 = ()=>(0, $1ybV0.ff)('enable-jsm-smart-request-summary_kva1r', false);

});

parcelRegister("22kXV", function(module, exports) {

$parcel$export(module.exports, "JsmSmartRequestSummaryEntryPointContainer", () => $47a4f221a52d74b9$export$ca38248bf7b9638d);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $hjgGs = parcelRequire("hjgGs");
const $47a4f221a52d74b9$var$runtimeProps = {};
const $47a4f221a52d74b9$export$ca38248bf7b9638d = ()=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $eUqFw.useContext)((0, $hjgGs.JsmSmartRequestSummaryEntryPointContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jsmSmartRequestSummary",
        packageName: "issue",
        teamName: "itsm-grimlock",
        runtimeProps: $47a4f221a52d74b9$var$runtimeProps,
        fallback: null,
        errorFallback: "flag"
    });
};

});

parcelRegister("ff62D", function(module, exports) {

$parcel$export(module.exports, "IssueSmartRequestSummaryEntryPointContainer", () => $22bf92369f8f80b7$export$4437b78e7402ece1);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $hjgGs = parcelRequire("hjgGs");
const $22bf92369f8f80b7$var$runtimeProps = {};
const $22bf92369f8f80b7$export$4437b78e7402ece1 = ()=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $eUqFw.useContext)((0, $hjgGs.IssueSmartRequestSummaryEntryPointContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "issueSmartRequestSummary",
        packageName: "issue",
        teamName: "Bento",
        runtimeProps: $22bf92369f8f80b7$var$runtimeProps,
        fallback: null,
        errorFallback: "flag"
    });
};

});


parcelRegister("eVaiT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e9ab086e6c62a1$export$2e2bcd8739ae039);
/* renderer-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5syGA = parcelRequire("5syGA");

var $6kPQJ = parcelRequire("6kPQJ");

var $C5eOu = parcelRequire("C5eOu");

var $eyYNo = parcelRequire("eyYNo");
const $a9e9ab086e6c62a1$export$f11e9d3ad5fe26 = ({ source: source, extension: extension, extensionData: extensionData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a9e9ab086e6c62a1$var$Padding, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $C5eOu.AsyncIssueActivity), {
        extension: extension,
        extensionData: extensionData,
        analyticsAttributes: {
            source: source
        }
    }));
const $a9e9ab086e6c62a1$export$2bc4ae602e4f56d7 = (props)=>{
    const refreshedOn = (0, $eyYNo.useOnDemandIssueRefreshTime)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6kPQJ.ViewAnalyticsWrapper), {
        key: refreshedOn,
        attributes: {
            source: props.source,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a9e9ab086e6c62a1$export$f11e9d3ad5fe26, props));
};
var $a9e9ab086e6c62a1$export$2e2bcd8739ae039 = $a9e9ab086e6c62a1$export$2bc4ae602e4f56d7;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a9e9ab086e6c62a1$var$Padding = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
});
$a9e9ab086e6c62a1$var$Padding.displayName = 'Padding';

});
parcelRegister("C5eOu", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueActivity", () => $0d04ec3de5ef81f9$export$fa0be1b838beb75e);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $1boRu = parcelRequire("1boRu");

var $2Rqjr = parcelRequire("2Rqjr");

var $2vJHJ = parcelRequire("2vJHJ");

var $gGtKh = parcelRequire("gGtKh");

var $aIPS7 = parcelRequire("aIPS7");

var $8Nthx = parcelRequire("8Nthx");
const $0d04ec3de5ef81f9$var$skeletonConfig = [
    {
        width: 75
    },
    {
        width: 100
    }
];

const $0d04ec3de5ef81f9$export$5041e090c844c406 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8Kuph")), {
    ssr: false,
    moduleId: "./src/packages/forge/forge-ui-async/src/ui/issue-activity/index.tsx"
}));
const $0d04ec3de5ef81f9$export$9c52ef29d3a28f0f = (props)=>{
    const { extension: extension, extensionData: extensionData } = props;
    const loadingComponent = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Nthx.Skeleton), {
            skeletonConfig: $0d04ec3de5ef81f9$var$skeletonConfig
        }), []);
    const extensionDataValue = (0, $eUqFw.useMemo)(()=>({
            ...extensionData,
            type: (0, $2Rqjr.ISSUE_ACTIVITY_MODULE)
        }), [
        extensionData
    ]);
    const extraProps = (0, $eUqFw.useMemo)(()=>({
            loadingComponent: loadingComponent,
            module: (0, $2Rqjr.ISSUE_ACTIVITY_MODULE),
            extensionData: extensionDataValue,
            contextToken: (0, $2Rqjr.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        loadingComponent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-activity",
        fallback: loadingComponent
    }, (0, $2vJHJ.isCustomUIExtension)(extension) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aIPS7.LazyIssueViewIframe), {
        ...props,
        ...extraProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0d04ec3de5ef81f9$export$5041e090c844c406, {
        ...props,
        ...extraProps
    }));
};
const $0d04ec3de5ef81f9$export$fa0be1b838beb75e = $0d04ec3de5ef81f9$export$9c52ef29d3a28f0f;

});
parcelRegister("aIPS7", function(module, exports) {

$parcel$export(module.exports, "LazyIssueViewIframe", () => $746f8ddafbc2b86a$export$1da68c038e57853b);
$parcel$export(module.exports, "LazyIssueViewModalIframe", () => $746f8ddafbc2b86a$export$d26aad84362c2402);

var $7rh0R = parcelRequire("7rh0R");

var $1boRu = parcelRequire("1boRu");

const $746f8ddafbc2b86a$var$getModule = ()=>(parcelRequire("9urM9"));
const $746f8ddafbc2b86a$export$1da68c038e57853b = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$746f8ddafbc2b86a$var$getModule().then((module)=>module.IssueViewIframeRenderer), {
    ssr: false
}));
const $746f8ddafbc2b86a$export$d26aad84362c2402 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazy)(()=>$746f8ddafbc2b86a$var$getModule().then((module)=>module.IssueViewModalIframeRenderer), {}));

});
parcelRegister("9urM9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('76qFt')
        ]);
        const value = parcelRequire('l3Kpv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("76qFt")
    ]).then(()=>parcelRequire('l3Kpv'));
}

});


parcelRegister("8Nthx", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $fb59735ddb4a6800$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "SkeletonLayout", () => $fb59735ddb4a6800$export$af3ba02ef74c9bdf);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $fb59735ddb4a6800$export$69f3c7f0b2b87aa2 = [];
const $fb59735ddb4a6800$export$8f31e4c4a37b8e9c = ({ skeletonConfig: skeletonConfig = $fb59735ddb4a6800$export$69f3c7f0b2b87aa2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, skeletonConfig.map(({ width: width }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fb59735ddb4a6800$var$ForgeSkeleton, {
            "data-testId": `forgeskeleton-${index}`,
            key: index,
            width: width
        })));
const $fb59735ddb4a6800$export$af3ba02ef74c9bdf = ({ children: children, layout: layout })=>{
    if (!layout) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "forge-ui-async.common.ui.skeleton.box",
        xcss: $fb59735ddb4a6800$var$layoutStyles
    }, children);
};
const $fb59735ddb4a6800$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fb59735ddb4a6800$var$ForgeSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1y04s53": (0, $9t7rW.default)(`${__cmplp.width}%`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1mcm _4t3ipxbi _19pkpxbi _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk",
            __cmplp.className
        ])
    });
});
const $fb59735ddb4a6800$var$layoutStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});

});

parcelRegister("8Kuph", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iWNHC');
        const value = parcelRequire('iWFfp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iWNHC").then(()=>parcelRequire('iWFfp'));
}

});



parcelRegister("hsGiA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2cOc3');
        const value = parcelRequire('1bbh7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2cOc3").then(()=>parcelRequire('1bbh7'));
}

});

parcelRegister("fRJQb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5WxKL');
        const value = parcelRequire('leiBZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5WxKL").then(()=>parcelRequire('leiBZ'));
}

});

parcelRegister("eR41V", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gGh37');
        const value = parcelRequire('cCOuV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gGh37").then(()=>parcelRequire('cCOuV'));
}

});

parcelRegister("53Pzf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1LeUP');
        const value = parcelRequire('9MKS3');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1LeUP").then(()=>parcelRequire('9MKS3'));
}

});


parcelRegister("1ccqQ", function(module, exports) {

$parcel$export(module.exports, "ActivitySortingToggle", () => $673adaa3e0776459$export$1e2412abadf07bd4);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $8cU5f = parcelRequire("8cU5f");

var $gUUjF = parcelRequire("gUUjF");

var $5JgJ2 = parcelRequire("5JgJ2");


var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");
var $bFzGY = parcelRequire("bFzGY");

var $fn3wn = parcelRequire("fn3wn");

var $8QGvZ = parcelRequire("8QGvZ");
const $673adaa3e0776459$export$1e2412abadf07bd4 = (props)=>{
    const { selectedSortOrder: selectedSortOrder, onSelectSortOrder: onSelectSortOrder, isDisabled: isDisabled = false } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const sortOptions = (0, $8QGvZ.getSortOptions)(formatMessage);
    const selectedSortOption = sortOptions.find((item)=>item.type === selectedSortOrder);
    if (!selectedSortOption) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.activity.activity-sorting.select-sort-order', `Failed to select a sort option with selected sort of ${selectedSortOrder}`);
        return null;
    }
    const onToggle = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        if (selectedSortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c)) onSelectSortOrder((0, $25476979aca7c7e0$export$e86669f498228fff), analyticsEvent, 'sortOrderItemToggled');
        if (selectedSortOrder === (0, $25476979aca7c7e0$export$e86669f498228fff)) onSelectSortOrder((0, $25476979aca7c7e0$export$eda5fe8da1abb04c), analyticsEvent, 'sortOrderItemToggled');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "activityFeedSort"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (0, $jMP2a.fireScreenAnalytics)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $fn3wn.messages).tooltip),
        hideTooltipOnMouseDown: true,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        isDisabled: isDisabled,
        onClick: onToggle,
        // @ts-expect-error - TS2322 - Type 'ReactNode' is not assignable to type 'ReactChild | undefined'.
        iconAfter: selectedSortOption.icon,
        spacing: "compact",
        testId: "issue-activity-feed.ui.activity-sorting-toggle.sorting-button",
        interactionName: "auto-generated.issue-activity-feed.ui.activity-sorting-toggle.sorting-button.button"
    }, selectedSortOption.name)));
};
var $673adaa3e0776459$export$2e2bcd8739ae039 = $673adaa3e0776459$export$1e2412abadf07bd4;

});
parcelRegister("fn3wn", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0d3c4ee1649af931$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $0d3c4ee1649af931$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    tooltip: {
        "id": "issue-activity-feed.activity-sorting-toggle.tooltip",
        "defaultMessage": "Reverse sort direction"
    },
    newestFirstLabel: {
        "id": "issue-activity-feed.activity-sorting-toggle.newest-first-label",
        "defaultMessage": "Newest first"
    },
    oldestFirstLabel: {
        "id": "issue-activity-feed.activity-sorting-toggle.oldest-first-label",
        "defaultMessage": "Oldest first"
    }
});

});

parcelRegister("8QGvZ", function(module, exports) {

$parcel$export(module.exports, "getSortOptions", () => $d53022ddf7e892a7$export$b8f8eacf78386ba3);

var $eUqFw = parcelRequire("eUqFw");


var $8OAd8 = parcelRequire("8OAd8");

var $w6dKR = parcelRequire("w6dKR");

var $fn3wn = parcelRequire("fn3wn");
const $d53022ddf7e892a7$export$b8f8eacf78386ba3 = (formatMessage)=>[
        {
            key: (0, $25476979aca7c7e0$export$eda5fe8da1abb04c),
            type: (0, $25476979aca7c7e0$export$eda5fe8da1abb04c),
            name: formatMessage((0, $fn3wn.messages).newestFirstLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8OAd8.ArrowDownIcon), {
                label: ""
            })
        },
        {
            key: (0, $25476979aca7c7e0$export$e86669f498228fff),
            type: (0, $25476979aca7c7e0$export$e86669f498228fff),
            name: formatMessage((0, $fn3wn.messages).oldestFirstLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $w6dKR.ArrowUpIcon), {
                label: ""
            })
        }
    ];

});
parcelRegister("8OAd8", function(module, exports) {

$parcel$export(module.exports, "ArrowDownIcon", () => $1bc224474873a9c5$export$1c939d3c9b6931b);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $1bc224474873a9c5$var$ArrowDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.8,4.3 C6.6,4.1 6.3,4 6,4 C5.7,4 5.4,4.1 5.2,4.3 L2.3,7.2 C1.9,7.6 1.9,8.3 2.3,8.7 C2.7,9.1 3.3,9.1 3.7,8.7 L5,7.4 L5,19.1 C5,19.6 5.4,20 6,20 C6.6,20 7,19.6 7,19.1 L7,7.4 L8.3,8.7 C8.7,9.1 9.3,9.1 9.7,8.7 C10.1,8.3 10.1,7.6 9.7,7.2 C9.04754611,6.54754611 8.5582057,6.0582057 8.23197876,5.73197876 C7.91376126,5.41376126 7.436435,4.936435 6.8,4.3 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero",
        transform: "translate(6.000000, 12.000000) rotate(180.000000) translate(-6.000000, -12.000000) "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21,5 L13,5 C12.4,5 12,5.4 12,6 C12,6.6 12.4,7 13,7 L21,7 C21.6,7 22,6.6 22,6 C22,5.4 21.6,5 21,5 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13,13 L18,13 C18.6,13 19,12.6 19,12 C19,11.4 18.6,11 18,11 L13,11 C12.4,11 12,11.4 12,12 C12,12.6 12.4,13 13,13 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13,19 L16,19 C16.6,19 17,18.6 17,18 C17,17.4 16.6,17 16,17 L13,17 C12.4,17 12,17.4 12,18 C12,18.6 12.4,19 13,19 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    })));
const $1bc224474873a9c5$export$1c939d3c9b6931b = ({ label: label })=>// @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => JSX.Element' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        size: "small",
        label: label,
        glyph: $1bc224474873a9c5$var$ArrowDownGlyph
    });

});

parcelRegister("w6dKR", function(module, exports) {

$parcel$export(module.exports, "ArrowUpIcon", () => $90ad34b5848afcd7$export$f1a507b991affc46);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $90ad34b5848afcd7$var$ArrowUpGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.8,4.3 C7.6,4.1 7.3,4 7,4 C6.7,4 6.4,4.1 6.2,4.3 L3.3,7.2 C2.9,7.6 2.9,8.3 3.3,8.7 C3.7,9.1 4.3,9.1 4.7,8.7 L6,7.4 L6,19.1 C6,19.6 6.4,20 7,20 C7.6,20 8,19.6 8,19.1 L8,7.4 L9.3,8.7 C9.7,9.1 10.3,9.1 10.7,8.7 C11.1,8.3 11.1,7.6 10.7,7.2 C10.0475461,6.54754611 9.5582057,6.0582057 9.23197876,5.73197876 C8.91376126,5.41376126 8.436435,4.936435 7.8,4.3 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21,17 L13,17 C12.4,17 12,17.4 12,18 C12,18.6 12.4,19 13,19 L21,19 C21.6,19 22,18.6 22,18 C22,17.4 21.6,17 21,17 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13,13 L18,13 C18.6,13 19,12.6 19,12 C19,11.4 18.6,11 18,11 L13,11 C12.4,11 12,11.4 12,12 C12,12.6 12.4,13 13,13 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13,7 L16,7 C16.6,7 17,6.6 17,6 C17,5.4 16.6,5 16,5 L13,5 C12.4,5 12,5.4 12,6 C12,6.6 12.4,7 13,7 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    })));
const $90ad34b5848afcd7$export$f1a507b991affc46 = ({ label: label })=>// @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => JSX.Element' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        size: "small",
        label: label,
        glyph: $90ad34b5848afcd7$var$ArrowUpGlyph
    });

});



parcelRegister("ewnuK", function(module, exports) {

$parcel$export(module.exports, "JsmSmartRequestSummaryTrigger", () => $4ffe8d9c108f9433$export$19346ac1c87cd3b1);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $l3Qg0 = parcelRequire("l3Qg0");

var $1HzcR = parcelRequire("1HzcR");

var $hjgGs = parcelRequire("hjgGs");

var $2KzVh = parcelRequire("2KzVh");

var $ewjGW = parcelRequire("ewjGW");
const $4ffe8d9c108f9433$var$entryPointParams = {};
const $4ffe8d9c108f9433$export$19346ac1c87cd3b1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isCompact: isCompact, totalComments: totalComments }, ref)=>{
    // The button is the trigger for loading the JsmSmartRequestSummary panel through this entrypoint context
    const jsmSmartRequestSummaryEntryPoint = (0, $eUqFw.useContext)((0, $hjgGs.JsmSmartRequestSummaryEntryPointContext));
    const entryPointTriggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(jsmSmartRequestSummaryEntryPoint.entryPointActions);
    const triggerRef = (0, $2KzVh.default)(ref, entryPointTriggerRef);
    // Button entrypoint - we load this in asynchronously
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $6j4bv.useEntryPoint)((0, $ewjGW.jsmSmartRequestSummaryTriggerEntryPoint), $4ffe8d9c108f9433$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            totalComments: totalComments,
            triggerRef: triggerRef,
            isCompact: isCompact
        }), [
        totalComments,
        isCompact,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jsmSmartRequestSummaryTrigger",
        packageName: "issueActivityFeed",
        teamName: "itsm-grimlock",
        fallback: null,
        errorFallback: "flag",
        runtimeProps: runtimeProps
    });
});

});
parcelRegister("ewjGW", function(module, exports) {

$parcel$export(module.exports, "jsmSmartRequestSummaryTriggerEntryPoint", () => $465452774ed0bbc0$export$2cc23d1206bc0faf);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $465452774ed0bbc0$export$2cc23d1206bc0faf = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("2NHoo")).then((module)=>module.SmartRequestSummaryTrigger), {
        moduleId: "f18b70bb"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2NHoo", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('XMEdn');
        const value = parcelRequire('etmxU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("XMEdn").then(()=>parcelRequire('etmxU'));
}

});



parcelRegister("8XHab", function(module, exports) {

$parcel$export(module.exports, "IssueSmartRequestSummaryTrigger", () => $03c3407026cc7bc3$export$dfb2f6fecfee5c5d);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $l3Qg0 = parcelRequire("l3Qg0");

var $1HzcR = parcelRequire("1HzcR");

var $cyeRO = parcelRequire("cyeRO");

var $hjgGs = parcelRequire("hjgGs");

var $2KzVh = parcelRequire("2KzVh");
const $03c3407026cc7bc3$var$EMPTY_ENTRY_POINT_PARAMS = {};
const $03c3407026cc7bc3$export$dfb2f6fecfee5c5d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isCompact: isCompact, totalComments: totalComments, hasComments: hasComments }, ref)=>{
    // The button is the trigger for loading the JsmSmartRequestSummary panel through this entrypoint context
    const issueSmartRequestSummaryEntryPoint = (0, $eUqFw.useContext)((0, $hjgGs.IssueSmartRequestSummaryEntryPointContext));
    const entryPointTriggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(issueSmartRequestSummaryEntryPoint.entryPointActions);
    const triggerRef = (0, $2KzVh.default)(ref, entryPointTriggerRef);
    // Button entrypoint - we load this in asynchronously
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $6j4bv.useEntryPoint)((0, $cyeRO.issueSmartRequestSummaryTriggerEntryPoint), $03c3407026cc7bc3$var$EMPTY_ENTRY_POINT_PARAMS);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            totalComments: totalComments,
            hasComments: hasComments,
            triggerRef: triggerRef,
            isCompact: isCompact
        }), [
        totalComments,
        hasComments,
        isCompact,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "issueSmartRequestSummaryTrigger",
        packageName: "issueActivityFeed",
        teamName: "Bento",
        fallback: null,
        errorFallback: "flag",
        runtimeProps: runtimeProps
    });
});

});
parcelRegister("cyeRO", function(module, exports) {

$parcel$export(module.exports, "issueSmartRequestSummaryTriggerEntryPoint", () => $f27ef3b52f69995d$export$2e121e5cb0435aae);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $f27ef3b52f69995d$export$2e121e5cb0435aae = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("1Ip8y")).then((module)=>module.SmartRequestSummaryTrigger), {
        moduleId: "cf473c59"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1Ip8y", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('b3TGk');
        const value = parcelRequire('Igjcz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("b3TGk").then(()=>parcelRequire('Igjcz'));
}

});





parcelRegister("4Fgoy", function(module, exports) {

$parcel$export(module.exports, "ContextPanel", () => $99515c14fc2b6ac7$export$c174a7dc96b2afb8);

var $eUqFw = parcelRequire("eUqFw");

var $gpZWO = parcelRequire("gpZWO");

var $fee69 = parcelRequire("fee69");

var $hJ992 = parcelRequire("hJ992");


var $fCyzk = parcelRequire("fCyzk");

var $10dMm = parcelRequire("10dMm");

var $7ahhR = parcelRequire("7ahhR");

var $cUA2o = parcelRequire("cUA2o");

var $g1Vb4 = parcelRequire("g1Vb4");

var $328UO = parcelRequire("328UO");
const $99515c14fc2b6ac7$export$c174a7dc96b2afb8 = (props)=>{
    const { refs: refs } = props;
    const issueKey = (0, $hJ992.useIssueKey)();
    const [contextPanel] = (0, $fCyzk.useIssueLayoutContextPanel)(issueKey);
    const [, { setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel }] = (0, $fCyzk.useIssueLayoutActions)();
    const layoutItemEntryMap = (0, $10dMm.default)();
    const isOpen = contextPanel !== undefined;
    const onHidePanel = (0, $eUqFw.useCallback)(()=>{
        setIssueViewLayoutContextPanel(issueKey, undefined);
    }, [
        issueKey,
        setIssueViewLayoutContextPanel
    ]);
    let PanelComponent = null;
    if (contextPanel) {
        const layoutItemEntry = layoutItemEntryMap[contextPanel.type];
        PanelComponent = // tabs cannot be in the map because they need the map to determine what items
        // to render, which would create a circular dependency
        contextPanel.type === (0, $51be06d2b94fb740$export$7f66491e43ca5015) ? (0, $g1Vb4.default) : layoutItemEntry && layoutItemEntry.panel;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
        id: "issue.issue-view.issue-base.context.context-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ahhR.default), {
        refs: refs,
        isOpen: isOpen
    }, (styles)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $328UO.HeaderContainer), {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "issue.views.issue-base.context.context-panel.back"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $328UO.HeaderContentContainer), {
            maxWidth: styles.headerWidth,
            onClick: onHidePanel,
            tabIndex: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $328UO.RoundButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gpZWO))), {
            size: "medium",
            label: "Return"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUA2o.HeaderBreadcrumb), null, contextPanel && contextPanel.title))), PanelComponent && contextPanel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PanelComponent, {
            // @ts-expect-error - Property 'contentWidth' does not exist on type ComponentType<unknown>
            contentWidth: styles.contentWidth,
            type: contextPanel.type,
            panelKey: contextPanel.key,
            payload: contextPanel.payload,
            headerWidth: styles.headerWidth
        }) : null)));
};
$99515c14fc2b6ac7$export$c174a7dc96b2afb8.displayName = 'ContextPanel';
var $99515c14fc2b6ac7$export$2e2bcd8739ae039 = $99515c14fc2b6ac7$export$c174a7dc96b2afb8;

});
parcelRegister("gpZWO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf3f089e16becc19$var$_react = $bf3f089e16becc19$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $bf3f089e16becc19$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $bf3f089e16becc19$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $bf3f089e16becc19$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.207 5.793a1 1 0 010 1.414L8.414 11H18a1 1 0 110 2H8.414l3.793 3.793a1 1 0 11-1.415 1.414l-5.499-5.5A.997.997 0 015 12.028v-.057a.996.996 0 01.293-.678l5.499-5.5a1 1 0 011.415 0z" fill="currentColor"/></svg>`
    }, props));
$bf3f089e16becc19$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $bf3f089e16becc19$var$_default = $bf3f089e16becc19$var$ArrowLeftIcon;
module.exports.default = $bf3f089e16becc19$var$_default;

});

const $51be06d2b94fb740$export$8bcece6b344db0b9 = 'FIELD';
const $51be06d2b94fb740$export$f65dd83d96b675ee = 'DEV_SUMMARY';
const $51be06d2b94fb740$export$971ccedc18d35178 = 'RELEASES_PANEL';
const $51be06d2b94fb740$export$18e4c648db363204 = 'PANEL';
const $51be06d2b94fb740$export$7f66491e43ca5015 = 'TAB';
const $51be06d2b94fb740$export$a231b3330d485b3d = 'CONTEXT';
const $51be06d2b94fb740$export$c13258770702df9a = 'CONTENT';
const $51be06d2b94fb740$export$421b00803862d868 = 'FOUNDATION';
const $51be06d2b94fb740$export$e4418ff667dd706f = 'CONTENT_REQUEST';
const $51be06d2b94fb740$export$71b340ce197e12d2 = 'CONTENT_VISIBLE';
const $51be06d2b94fb740$export$4c18784248f8734e = 'CONTENT_HIDDEN';
const $51be06d2b94fb740$export$5f22838fc80a3849 = 'CONTEXT_PRIMARY';
const $51be06d2b94fb740$export$e021289133d77118 = 'CONTEXT_SECONDARY';
const $51be06d2b94fb740$export$4fb704db6e8ae4e3 = 'CONTEXT_HIDDEN';
const $51be06d2b94fb740$export$96c8257f075531de = 'FOUNDATION_CONTEXT';
const $51be06d2b94fb740$export$9ebdd3f0d5c993ea = 'FOUNDATION_CONTENT';

parcelRegister("10dMm", function(module, exports) {

$parcel$export(module.exports, "default", () => $555e854fcfd6d514$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $4K830 = parcelRequire("4K830");

var $i3ixo = parcelRequire("i3ixo");

var $1ybV0 = parcelRequire("1ybV0");

var $d5IT2 = parcelRequire("d5IT2");

var $jDxSo = parcelRequire("jDxSo");

var $3BIZK = parcelRequire("3BIZK");

var $lO4Or = parcelRequire("lO4Or");

var $du4hK = parcelRequire("du4hK");

var $grHZ2 = parcelRequire("grHZ2");

var $juEyd = parcelRequire("juEyd");

var $fzgBH = parcelRequire("fzgBH");

var $a3bgl = parcelRequire("a3bgl");

var $4F0Ed = parcelRequire("4F0Ed");

var $hmDMY = parcelRequire("hmDMY");

var $jC0O0 = parcelRequire("jC0O0");

var $cQ19t = parcelRequire("cQ19t");

var $2Wayk = parcelRequire("2Wayk");

var $7PGxf = parcelRequire("7PGxf");

var $74NI5 = parcelRequire("74NI5");

var $44TdC = parcelRequire("44TdC");

var $b6qiJ = parcelRequire("b6qiJ");

var $e929z = parcelRequire("e929z");
var $af2Be = parcelRequire("af2Be");
var $jJtOG = parcelRequire("jJtOG");

var $oM0hT = parcelRequire("oM0hT");

var $ep9Nd = parcelRequire("ep9Nd");

var $7TbxN = parcelRequire("7TbxN");

var $gPgMB = parcelRequire("gPgMB");

var $h0VIp = parcelRequire("h0VIp");
var $5Jgk8 = parcelRequire("5Jgk8");

var $jjGk4 = parcelRequire("jjGk4");

var $joq2j = parcelRequire("joq2j");

var $f27hK = parcelRequire("f27hK");

var $hKCXf = parcelRequire("hKCXf");
var $1EAis = parcelRequire("1EAis");

var $bB8lM = parcelRequire("bB8lM");

var $lt9b8 = parcelRequire("lt9b8");

var $2iQQa = parcelRequire("2iQQa");

var $2hl6U = parcelRequire("2hl6U");

var $i36oV = parcelRequire("i36oV");

var $bognG = parcelRequire("bognG");

var $4DDvU = parcelRequire("4DDvU");

var $6ozze = parcelRequire("6ozze");

var $4kMbu = parcelRequire("4kMbu");

var $g8COw = parcelRequire("g8COw");

var $8gMne = parcelRequire("8gMne");

var $cKvbd = parcelRequire("cKvbd");

var $6PFPL = parcelRequire("6PFPL");

var $jaMGi = parcelRequire("jaMGi");

var $bFovQ = parcelRequire("bFovQ");

var $hUaSJ = parcelRequire("hUaSJ");

var $jfAST = parcelRequire("jfAST");

var $74ZhC = parcelRequire("74ZhC");

var $cuBGL = parcelRequire("cuBGL");

var $iMiO1 = parcelRequire("iMiO1");

var $2eoeo = parcelRequire("2eoeo");
var $8tzjM = parcelRequire("8tzjM");

var $dZRNS = parcelRequire("dZRNS");

var $8xvFk = parcelRequire("8xvFk");

var $dCijO = parcelRequire("dCijO");

var $cBCw0 = parcelRequire("cBCw0");

var $4O7Na = parcelRequire("4O7Na");

var $jcGEU = parcelRequire("jcGEU");

var $flT7U = parcelRequire("flT7U");

var $iaPbS = parcelRequire("iaPbS");

var $lwO5u = parcelRequire("lwO5u");

var $6nkZV = parcelRequire("6nkZV");

var $czHVU = parcelRequire("czHVU");

var $7Vb23 = parcelRequire("7Vb23");

var $26F4r = parcelRequire("26F4r");

var $dO6co = parcelRequire("dO6co");

var $hfza4 = parcelRequire("hfza4");

var $fOQE6 = parcelRequire("fOQE6");

var $9Nizy = parcelRequire("9Nizy");

var $2XDqb = parcelRequire("2XDqb");
/*
    The reasons why we memoize this function and not declare it as an object are:
      * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
      * memoization is needed because we call getLayoutItemMap many times throughout renders. Returning a different object each time would cause huge
        render performance issues.
      * If we declare layout map as a simple object - there are issues with tests.
        Because some fields, like description, are being instantiated too early, making it being saved in the object as undefined.
        But with memoisation we instantiate it at the first time we call the function.
        It is probably not worth making this an object until we understand how this failing test affects prod
        @atlassian/jira-issue-view/src/views/issue-details/parameterised-integration-tests.js
*/ const $555e854fcfd6d514$var$getLayoutItemMap = ()=>{
    const layoutFieldKeys = (0, $lO4Or.getLayoutFieldTypes)();
    const baseLayoutItems = {
        // The system types
        [layoutFieldKeys.ASSIGNEE_TYPE]: {
            item: (0, $a3bgl.default)
        },
        [layoutFieldKeys.DUE_DATE_TYPE]: {
            item: (0, $44TdC.default)
        },
        [layoutFieldKeys.PRIORITY_TYPE]: {
            item: (0, $6PFPL.default)
        },
        [layoutFieldKeys.REPORTER_TYPE]: {
            item: (0, $jfAST.default)
        },
        [layoutFieldKeys.DESCRIPTION_TYPE]: {
            item: (0, $grHZ2.default)
        },
        [layoutFieldKeys.LABELS_TYPE]: {
            item: (0, $jjGk4.default)
        },
        [layoutFieldKeys.COMPONENTS_TYPE]: {
            item: (0, $2Wayk.default)
        },
        [layoutFieldKeys.SPRINT_TYPE]: {
            item: (0, $4O7Na.default)
        },
        [layoutFieldKeys.STORY_POINTS_TYPE]: {
            item: (0, $jcGEU.StoryPointEstimate)
        },
        [layoutFieldKeys.TEAMS_PLATFORM_CF_TYPE]: {
            item: (0, $9Nizy.isTeamsCustomFieldTypeEnabled)() ? (0, $flT7U.TeamFieldNext) : ()=>null
        },
        [layoutFieldKeys.EPIC_TYPE]: {
            item: (0, $9Nizy.isHideEpicLinkFromIssueViewForEpicRenamingBetaEnabled)() ? ()=>null : (0, $ep9Nd.default)
        },
        [layoutFieldKeys.FIX_VERSIONS_TYPE]: {
            item: (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $dO6co.VersionsFieldWithRelayEditView) : (0, $hfza4.default)
        },
        [layoutFieldKeys.AFFECTS_VERSIONS_TYPE]: {
            item: (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $dO6co.VersionsFieldWithRelayEditView) : (0, $hfza4.default)
        },
        [layoutFieldKeys.TIME_ESTIMATE_TYPE]: {
            item: (0, $4kMbu.default)
        },
        [layoutFieldKeys.TIME_TRACKING_TYPE]: {
            item: (0, $lwO5u.default)
        },
        // This field is shown only in Content area in Classic Software (Mar 2020)
        [layoutFieldKeys.ENVIRONMENT_TYPE]: {
            item: (0, $juEyd.default)
        },
        // panels
        [layoutFieldKeys.DEV_SUMMARY_TYPE]: {
            item: (0, $fzgBH.default)
        },
        // @ts-expect-error - TS2322 - Type '{ assignee: { item: any; }; duedate: { item: ComponentClass<Omit<{ fieldId: string; area: Area; label: string; } & { isEditing?: boolean | undefined; issueKey: string; fieldKey: string; } & Flow.Diff<Props, { ...; }> & { ...; } & { ...; }, keyof DispatchProps>> & { ...; }; }; ... 79 more ...; "com.pyxis.greenhopper....' is not assignable to type 'CheckFieldTypeDefinitions<CheckedLegacyFieldTypeDefinitions<LayoutItemMapEntry>, IgnoredFieldChecks<LayoutItemMapEntry>>'.
        [layoutFieldKeys.APPROVALS_PANEL_TYPE]: {
            item: (0, $3BIZK.ApprovalPanel),
            panel: (0, $3BIZK.ApprovalGlance)
        },
        [layoutFieldKeys.KNOWLEDGE_BASE_TYPE]: {
            item: (0, $5Jgk8.default),
            panel: (0, $h0VIp.default)
        },
        [layoutFieldKeys.SLA_PANEL_TYPE]: {
            item: (0, $du4hK.default)
        },
        [layoutFieldKeys.LINKED_ALERTS_TYPE]: {
            item: (0, $joq2j.default)
        },
        [layoutFieldKeys.CHAT_CHANNEL_TYPE]: {
            item: (0, $4K830.isFedRamp)() ? ()=>null : (0, $hmDMY.default)
        },
        [layoutFieldKeys.MSTEAMS_CHANNEL_TYPE]: {
            item: (0, $4K830.isFedRamp)() ? ()=>null : (0, $lt9b8.default)
        },
        [layoutFieldKeys.ZOOM_MEETING_TYPE]: {
            item: (0, $4K830.isFedRamp)() ? ()=>null : (0, $fOQE6.default)
        },
        [layoutFieldKeys.MANAGE_STAKEHOLDERS_TYPE]: {
            item: (0, $hKCXf.StakeholdersGlanceComponent),
            panel: (0, $1EAis.StakeholdersGlancePanel)
        },
        [layoutFieldKeys.CONFERENCE_CALL_TYPE]: {
            item: (0, $1ybV0.ff)('hide-icc-for-all-users_avyh5') ? ()=>null : (0, $7PGxf.default)
        },
        [layoutFieldKeys.ASSETS_CF_TYPE]: {
            item: (0, $2XDqb.AssetsPanel),
            panel: (0, $i3ixo.AssetsGlance)
        },
        [layoutFieldKeys.RESPONDERS_CF_TYPE]: {
            item: (0, $2eoeo.default),
            panel: (0, $8tzjM.default)
        },
        [layoutFieldKeys.MAJOR_INCIDENT_CF_TYPE]: {
            item: (0, $f27hK.default)
        },
        // Epic color field is rendered in the base layout, so it must be excluded from context items list
        [layoutFieldKeys.COLOR_CF_TYPE]: {
            item: ()=>null
        },
        [layoutFieldKeys.EPIC_COLOR_TYPE]: {
            item: ()=>null
        },
        [layoutFieldKeys.RELEASES_TYPE]: {
            item: ()=>null
        },
        // The custom types
        [layoutFieldKeys.PARENT_CF_TYPE]: {
            item: (0, $9Nizy.isRemoveParentLinkFromIssueViewEnabled)() ? ()=>null : (0, $8gMne.default)
        },
        [layoutFieldKeys.BASELINE_START_CF_TYPE]: {
            item: (0, $44TdC.default)
        },
        [layoutFieldKeys.BASELINE_END_CF_TYPE]: {
            item: (0, $44TdC.default)
        },
        [layoutFieldKeys.LABELS_CF_TYPE]: {
            item: (0, $jjGk4.default)
        },
        [layoutFieldKeys.TEXT_CF_TYPE]: {
            item: (0, $dCijO.default)
        },
        [layoutFieldKeys.MULTI_USER_CF_TYPE]: {
            item: (0, $i36oV.default)
        },
        [layoutFieldKeys.PARTICIPANTS_CF_TYPE]: {
            item: (0, $i36oV.default)
        },
        [layoutFieldKeys.URL_CF_TYPE]: {
            item: (0, $6nkZV.default)
        },
        [layoutFieldKeys.NUMBER_CF_TYPE]: {
            item: (0, $bognG.default)
        },
        [layoutFieldKeys.STORY_POINT_ESTIMATE_CF_TYPE]: {
            item: (0, $4DDvU.default)
        },
        [layoutFieldKeys.SELECT_CF_TYPE]: {
            item: (0, $cBCw0.default)
        },
        [layoutFieldKeys.EPIC_STATUS_TYPE]: {
            item: (0, $cBCw0.default)
        },
        [layoutFieldKeys.MULTI_SELECT_CF_TYPE]: {
            item: (0, $2hl6U.MultiSelectFieldWithRelayEditView)
        },
        [layoutFieldKeys.ECOSYSTEM_GLANCE_TYPE]: {
            item: (0, $e929z.default)
        },
        [layoutFieldKeys.FORGE_CUSTOM_FIELD_TYPE]: {
            item: (0, $af2Be.default)
        },
        [layoutFieldKeys.ISSUE_FIELD_USER_CF_TYPE]: {
            item: (0, $czHVU.default)
        },
        [layoutFieldKeys.ISSUE_FIELD_GROUPS_CF_TYPE]: {
            item: (0, $7TbxN.default)
        },
        [layoutFieldKeys.ISSUE_FIELD_STRINGS_CF_TYPE]: {
            item: (0, $jjGk4.default)
        },
        [layoutFieldKeys.FORGE_GLANCE_TYPE]: {
            item: (0, $jJtOG.default)
        },
        // This field is shown only in Content area in Classic and Next-gen Software (Mar 2020)
        [layoutFieldKeys.TEXT_AREA_CF_TYPE]: {
            item: (0, $juEyd.default)
        },
        [layoutFieldKeys.MULTI_VERSION_CF_TYPE]: {
            item: (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $dO6co.VersionsFieldWithRelayEditView) : (0, $26F4r.default)
        },
        [layoutFieldKeys.VERSION_CF_TYPE]: {
            item: (0, $7Vb23.default)
        },
        [layoutFieldKeys.DATE_CF_TYPE]: {
            item: (0, $44TdC.default)
        },
        [layoutFieldKeys.GROUP_CF_TYPE]: {
            item: (0, $gPgMB.default)
        },
        [layoutFieldKeys.MULTI_GROUP_CF_TYPE]: {
            item: (0, $7TbxN.default)
        },
        [layoutFieldKeys.USER_CF_TYPE]: {
            item: (0, $czHVU.default)
        },
        [layoutFieldKeys.DATETIME_CF_TYPE]: {
            item: (0, $b6qiJ.default)
        },
        [layoutFieldKeys.MULTI_CHECKBOXES_CF_TYPE]: {
            item: (0, $jC0O0.default)
        },
        [layoutFieldKeys.RADIO_BUTTONS_CF_TYPE]: {
            item: (0, $bFovQ.default)
        },
        [layoutFieldKeys.TEAM_CF_TYPE]: {
            item: (0, $iaPbS.default)
        },
        [layoutFieldKeys.ISSUE_FIELD_NUMBER_CF_TYPE]: {
            item: (0, $bognG.default)
        },
        [layoutFieldKeys.ISSUE_FIELD_DATETIME_CF_TYPE]: {
            item: (0, $b6qiJ.default)
        },
        [layoutFieldKeys.ISSUE_FIELD_STRING_CF_TYPE]: {
            item: (0, $dCijO.default)
        },
        [layoutFieldKeys.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE]: {
            item: (0, $cBCw0.default)
        },
        [layoutFieldKeys.ISSUE_FIELD_MULTI_SELECT_CF_TYPE]: {
            item: (0, $2iQQa.default)
        },
        [layoutFieldKeys.REQUEST_TYPE_CF_TYPE]: {
            item: (0, $74NI5.default)
        },
        [layoutFieldKeys.SERVICE_ENTITY_CF_TYPE]: {
            item: (0, $8xvFk.ConnectedServiceEntity)
        },
        [layoutFieldKeys.REQUEST_PARTICIPANTS_CF_TYPE]: {
            item: (0, $iMiO1.default)
        },
        [layoutFieldKeys.ORGANIZATIONS_CF_TYPE]: {
            item: (0, $6ozze.default)
        },
        [layoutFieldKeys.REQUEST_FEEDBACK_CF_TYPE]: {
            item: (0, $74ZhC.default)
        },
        [layoutFieldKeys.PEOPLE_CF_TYPE]: {
            item: (0, $cKvbd.default)
        },
        [layoutFieldKeys.REQUEST_LANGUAGE_CF_TYPE]: {
            item: (0, $cuBGL.default)
        },
        [layoutFieldKeys.ASSET_ONBOARDING_TYPE]: {
            item: (0, $2XDqb.AssetsOnboarding)
        },
        [layoutFieldKeys.APPROVERS_LIST_CF_TYPE]: {
            item: (0, $cKvbd.default)
        },
        [layoutFieldKeys.CASCADING_SELECT_CF_TYPE]: {
            item: (0, $4F0Ed.default)
        },
        [layoutFieldKeys.PROJECT_PICKER_CF_TYPE]: {
            item: (0, $jaMGi.default)
        },
        [layoutFieldKeys.CMDB_OBJECT_CF_TYPE]: {
            item: (0, $cQ19t.default)
        },
        [layoutFieldKeys.READ_ONLY_CF_TYPE]: {
            item: (0, $hUaSJ.default)
        },
        [layoutFieldKeys.MESSAGE_VIEW_CF_TYPE]: {
            item: (0, $bB8lM.default)
        },
        [layoutFieldKeys.MESSAGE_EDIT_CF_TYPE]: {
            item: (0, $bB8lM.default)
        },
        [layoutFieldKeys.EPIC_NAME_TYPE]: {
            item: (0, $dCijO.default)
        },
        [layoutFieldKeys.ECOSYSTEM_CONTEXT_TYPE]: {
            item: (0, $d5IT2.default)
        },
        [layoutFieldKeys.CATEGORY_TYPE]: {
            item: (0, $cBCw0.default)
        }
    };
    if (layoutFieldKeys.FORGE_CONTEXT_TYPE) Object.assign(baseLayoutItems, {
        [layoutFieldKeys.FORGE_CONTEXT_TYPE]: {
            item: (0, $jDxSo.ForgeIssueContext)
        }
    });
    if ((0, $9Nizy.isParentInIssueViewEnabled)() && layoutFieldKeys.PARENT_TYPE) Object.assign(baseLayoutItems, {
        [layoutFieldKeys.PARENT_TYPE]: {
            item: (0, $g8COw.default)
        }
    });
    if ((0, $9Nizy.isProductsAndEntitlementsMilestone2Enabled)() && layoutFieldKeys.ENTITLEMENT_CF_TYPE) Object.assign(baseLayoutItems, {
        [layoutFieldKeys.ENTITLEMENT_CF_TYPE]: {
            item: (0, $oM0hT.default)
        }
    });
    if ((0, $1ybV0.ff)('jsm-sentiment-analysis_1dage') && layoutFieldKeys.SENTIMENT_TYPE) Object.assign(baseLayoutItems, {
        [layoutFieldKeys.SENTIMENT_TYPE]: {
            item: (0, $dZRNS.default)
        }
    });
    // Moved to an indexed type to facilitate Object.assign()
    const layoutItems = baseLayoutItems;
    return layoutItems;
};
var $555e854fcfd6d514$export$2e2bcd8739ae039 = (0, $5iWql.default)($555e854fcfd6d514$var$getLayoutItemMap);

});
parcelRegister("i3ixo", function(module, exports) {

$parcel$export(module.exports, "AssetsGlance", () => $48d5cd06afd8785b$export$118e68b25df1d042);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $fXhZS = parcelRequire("fXhZS");

const $48d5cd06afd8785b$export$47e8a15abd65023d = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("hgIoY")), {
    moduleId: "./src/packages/platform/ui/asset-tracking/assets-glance/src/index.tsx"
});
const $48d5cd06afd8785b$export$118e68b25df1d042 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fXhZS.Boundary), {
        id: "assets-glance"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($48d5cd06afd8785b$export$47e8a15abd65023d, props));

});
parcelRegister("fXhZS", function(module, exports) {

$parcel$export(module.exports, "Boundary", () => $3177cdfe06ac022c$export$f43eab0e9866fe6f);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");
const $3177cdfe06ac022c$export$f43eab0e9866fe6f = ({ children: children, id: id, fallback: fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: id,
        packageName: "issue",
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "boundary",
        fallback: fallback
    }, children));

});

parcelRegister("hgIoY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('axT1j');
        const value = parcelRequire('iG4sT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("axT1j").then(()=>parcelRequire('iG4sT'));
}

});


parcelRegister("d5IT2", function(module, exports) {

$parcel$export(module.exports, "default", () => $57a70a1dd826fff3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
parcelRequire("eo4Zu");
var $14gc1 = parcelRequire("14gc1");

var $adX4B = parcelRequire("adX4B");

var $c9TLT = parcelRequire("c9TLT");

var $gUUjF = parcelRequire("gUUjF");

var $4lxPQ = parcelRequire("4lxPQ");

var $jLerq = parcelRequire("jLerq");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $eyYNo = parcelRequire("eyYNo");

var $2V7AK = parcelRequire("2V7AK");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $57a70a1dd826fff3$var$Loading = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57a70a1dd826fff3$var$StyledLoading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: 5 * (0, $c9TLT.gridSize)
    }));
const $57a70a1dd826fff3$export$ea599f1ec415fbe3 = ({ name: name, options: options, appKey: appKey, moduleKey: moduleKey })=>{
    const [connectHost, setConnectHost] = (0, $eUqFw.useState)(()=>(0, $4lxPQ.getConnectHost)());
    const refreshedOn = (0, $eyYNo.useOnDemandIssueRefreshTime)();
    const issueId = (0, $hJ992.useIssueId)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const connectIframeProvider = (0, $adX4B.useDefaultConnectIframeProvider)({
        isAutoresizeBugfixEnabled: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { url: url } = options || {};
    (0, $eUqFw.useEffect)(()=>{
        if (!connectHost) {
            (0, $gUUjF.default).safeInfoWithoutCustomerData('issue.ecosystem.context.panel', 'Delayed initialization of ecosystem context panel');
            (0, $4lxPQ.withConnectHost)((host)=>{
                setConnectHost(host);
            });
        }
    }, [
        connectHost
    ]);
    // If url contains the JWT, valid the JWT before loading the Iframe
    const isJwtExpired = url && connectHost && connectHost.hasJwt?.(url) && connectHost.isJwtExpired?.(url);
    (0, $eUqFw.useEffect)(()=>{
        if (isJwtExpired) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'ConnectIframe expired', {
            location: 'ContextPanel'
        });
    }, [
        isJwtExpired,
        createAnalyticsEvent
    ]);
    // there is a situation when during SPA transition issueId is yet undefined
    const hasCorrectIssueInformation = (0, $2V7AK.useIsEcosystemDataLoadedFor)((0, $hJ992.useIssueKey)());
    const connectKeyIssueId = `connect-iFrame-${options?.origin}-${issueId}-${refreshedOn}`;
    const connectKeyIssueKey = `connect-iFrame-${options?.origin}-${issueKey}-${refreshedOn}`;
    if ((0, $1ybV0.ff)('issue.details.connect-iframe-analytics')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eUqFw.useEffect)(()=>{
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'ConnectContextPanel loaded');
        }, [
            createAnalyticsEvent
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eUqFw.useEffect)(()=>{
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'ConnectContextPanel updated');
        }, [
            connectKeyIssueKey,
            createAnalyticsEvent
        ]);
    }
    // there is a situation when during SPA transition:
    // - issueId is yet undefined
    // - contentPanel is different between states, including not yet being present
    const renderUnblocked = connectHost && Boolean(issueId) && hasCorrectIssueInformation;
    if (!renderUnblocked || !url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57a70a1dd826fff3$var$Loading, null);
    if (isJwtExpired && !(0, $1ybV0.ff)('connect-context-panel-jwt-expiry-handling_99uex')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jLerq.EcosystemExpiredView), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $14gc1.ConnectIframe), {
        // @TODO JIV-17989 replace connectKeyIssueId with connectKeyIssueKey
        key: connectKeyIssueId,
        connectHost: connectHost,
        appKey: appKey,
        moduleKey: moduleKey,
        url: url,
        height: "100%",
        width: "100%",
        connectIframeProvider: connectIframeProvider,
        options: connectIframeProvider?.convertConnectOptions(options),
        // @ts-expect-error - TS2322 - Type '() => JSX.Element' is not assignable to type 'new () => PureComponent<{ failedCallback: Function; }, {}, any>'.
        timeoutIndicator: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jLerq.EcosystemTimeoutViewAsync), {
                appName: name,
                appKey: appKey
            })
    });
};
var $57a70a1dd826fff3$export$2e2bcd8739ae039 = $57a70a1dd826fff3$export$ea599f1ec415fbe3;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57a70a1dd826fff3$var$StyledLoading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _18s8gx6n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eo4Zu", function(module, exports) {

$parcel$export(module.exports, "ConnectIframe", () => (parcelRequire("14gc1")).ConnectIframe);

var $iRhDL = parcelRequire("iRhDL");

var $2d2X3 = parcelRequire("2d2X3");

var $5cXdJ = parcelRequire("5cXdJ");

var $7MI9d = parcelRequire("7MI9d");

var $14gc1 = parcelRequire("14gc1");

var $8C7oT = parcelRequire("8C7oT");

var $1Ot6R = parcelRequire("1Ot6R");

var $98v0E = parcelRequire("98v0E");

var $gJr07 = parcelRequire("gJr07");

var $6MSBx = parcelRequire("6MSBx");

var $3W7Ti = parcelRequire("3W7Ti");

var $eH5Sl = parcelRequire("eH5Sl");

var $2bcQh = parcelRequire("2bcQh");

var $hye1w = parcelRequire("hye1w");

var $1ZsfM = parcelRequire("1ZsfM");

var $h5Pjm = parcelRequire("h5Pjm");

var $dX5ge = parcelRequire("dX5ge");

var $ds4ui = parcelRequire("ds4ui");

var $chvxa = parcelRequire("chvxa");

});
parcelRegister("iRhDL", function(module, exports) {

$parcel$export(module.exports, "analytics", () => $dbaadc376f1e3fb7$export$71a493436f9bccb6);

var $auHMt = parcelRequire("auHMt");

var $eH5Sl = parcelRequire("eH5Sl");
var $dbaadc376f1e3fb7$var$AnalyticsController = /** @class */ function() {
    function AnalyticsController() {
        this.loggingEnabled = false;
    }
    AnalyticsController.prototype.isLoggingEnabled = function() {
        return this.loggingEnabled;
    };
    /**
     * In the browser console, enable analytics logging by entering window._analyticsController.enableAnalyticsLogging().
     */ AnalyticsController.prototype.enableAnalyticsLogging = function() {
        console.info('Enabling analytics logging...');
        this.loggingEnabled = true;
        return "Analytics logging is now enabled. (>'-')> <('_'<) ^('_')\- \m/(-_-)\m/ <( '-')> \_( .\")> <( ._.)-`";
    };
    /**
     * In the browser console, disable analytics logging by entering window._analyticsController.disableAnalyticsLogging().
     */ AnalyticsController.prototype.disableAnalyticsLogging = function() {
        console.info('Disabling analytics logging...');
        this.loggingEnabled = false;
        return "Analytics logging is now disabled. \xaf\\_(\u30C4)_/\xaf";
    };
    return AnalyticsController;
}();
/**
 * This class serves two purposes:
 *   - It provides the ability for products to register their implementations
 *     of AnalyticsAPI for use by the connect front end code.
 *   - It provides the AnalyticsAPI implementation that connect front end code
 *     should use. This implementation delegates to the registered AnalyticsAPI
 *     implementation. This class should be used within the connect front end
 *     code as follows:
 *
 *     import analytics from '../adaptors/analytics/AnalyticsAdaptor';
 *
 *     analytics.trigger('Flags', 'close', {'type': 'warning'});
 */ var $dbaadc376f1e3fb7$var$AnalyticsAdaptor = /** @class */ function() {
    function AnalyticsAdaptor() {
        this.analyticsAPI = (0, $auHMt.default);
        this.analyticsController = new $dbaadc376f1e3fb7$var$AnalyticsController();
        window._analyticsController = this.analyticsController;
    }
    /**
     * Implementation of AnalyticsRegistry#registerAnalyticsAPI().
     */ AnalyticsAdaptor.prototype.registerAnalyticsAPI = function(analyticsAPI) {
        this.analyticsAPI = analyticsAPI;
    };
    /**
     * Implementation of AnalyticsAPI#trigger() for use by connect-module-core code.
     */ AnalyticsAdaptor.prototype.trigger = function(category, action, appKey, payload) {
        try {
            this.analyticsAPI.trigger(category, action, appKey, payload);
            if (this.analyticsController.isLoggingEnabled()) (0, $eH5Sl.logger).info('Analytics:', category, action, appKey, payload);
        } catch (exception) {
            (0, $eH5Sl.logger).warn('Exception trapped triggering analytics event', exception);
        }
    };
    AnalyticsAdaptor.prototype.markAsSafe = function() {
        var allowedStrings = [];
        for(var _i = 0; _i < arguments.length; _i++)allowedStrings[_i] = arguments[_i];
        if (this.analyticsAPI.markAsSafe) return (_a = this.analyticsAPI).markAsSafe.apply(_a, allowedStrings);
        else return (0, $auHMt.default).markAsSafe.apply((0, $auHMt.default), allowedStrings);
        var _a;
    };
    AnalyticsAdaptor.prototype.dangerouslyCreateSafeString = function(value) {
        if (this.analyticsAPI.dangerouslyCreateSafeString) return this.analyticsAPI.dangerouslyCreateSafeString(value);
        else return (0, $auHMt.default).dangerouslyCreateSafeString(value);
    };
    return AnalyticsAdaptor;
}();
var $dbaadc376f1e3fb7$export$71a493436f9bccb6 = new $dbaadc376f1e3fb7$var$AnalyticsAdaptor();

});
parcelRegister("auHMt", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a3eaaaa8e7f97aa$export$2e2bcd8739ae039);
var $7a3eaaaa8e7f97aa$var$DefaultAnalyticsAPI = /** @class */ function() {
    function DefaultAnalyticsAPI() {}
    DefaultAnalyticsAPI.prototype.trigger = function(category, action, payload) {
    // Do nothing.
    };
    DefaultAnalyticsAPI.prototype.markAsSafe = function() {
        var allowedStrings = [];
        for(var _i = 0; _i < arguments.length; _i++)allowedStrings[_i] = arguments[_i];
        // Do no filtering
        return function(value) {
            return value;
        };
    };
    DefaultAnalyticsAPI.prototype.dangerouslyCreateSafeString = function(value) {
        // Do nothing
        return value;
    };
    return DefaultAnalyticsAPI;
}();
var $7a3eaaaa8e7f97aa$export$2e2bcd8739ae039 = new $7a3eaaaa8e7f97aa$var$DefaultAnalyticsAPI();

});

parcelRegister("eH5Sl", function(module, exports) {

$parcel$export(module.exports, "logger", () => $ab29a3967976254d$export$af88d00dbe7f521);

var $gZfKR = parcelRequire("gZfKR");
var $ab29a3967976254d$var$LoggerController = /** @class */ function() {
    function LoggerController() {
        this.debugEnabled = false;
        this.infoEnabled = true;
    }
    LoggerController.prototype.isDebugEnabled = function() {
        return this.debugEnabled;
    };
    LoggerController.prototype.isInfoEnabled = function() {
        return this.infoEnabled;
    };
    /**
     * In the browser console, enable debug by entering window._loggerController.enableDebug().
     */ LoggerController.prototype.enableDebug = function() {
        console.info('Enabling debug...');
        this.debugEnabled = true;
        return "Debug level logging is now enabled.   \u06DC(\u05E1\u05BC\u06BA\u05E1\u05BC\u064E` )/\u06DC";
    };
    /**
     * In the browser console, disable debug by entering window._loggerController.disableDebug().
     */ LoggerController.prototype.disableDebug = function() {
        console.info('Disabling debug...');
        this.debugEnabled = false;
        return "Debug level logging is now disabled. \u03B5(\xb4\u05E1\u05BC\uFE35\u05E1\u05BC`)\u0437";
    };
    /**
     * In the browser console, enable info by entering window._loggerController.enableInfo().
     */ LoggerController.prototype.enableInfo = function() {
        console.info('Enabling info...');
        this.infoEnabled = true;
        return "Info level logging is now enabled. \u3010\u30C4\u3011";
    };
    /**
     * In the browser console, disable info by entering window._loggerController.disableInfo().
     * <br/>
     * <strong>Note</strong>: disabling info will also disable debug.
     */ LoggerController.prototype.disableInfo = function() {
        console.info('Disabling info...');
        this.debugEnabled = false;
        this.infoEnabled = false;
        return 'Info level logging is now disabled. (-.-)Zzz...';
    };
    return LoggerController;
}();
/**
 * This class serves two purposes:
 *   - It provides the ability for products to register their implementations
 *     of LoggerAPI for use by the connect front end code.
 *   - It provides the LoggerAPI implementation that connect front end code
 *     should use. This implementation delegates to the registered LoggerAPI
 *     implementation. This class should be used within the connect front end
 *     code as follows:
 *
 *     import logger from '../adaptors/logger/LoggerAdaptor';
 *
 *     logger.info('My message', extraStuffOfInterest, etc, ...);
 */ var $ab29a3967976254d$var$LoggerAdaptor = /** @class */ function() {
    function LoggerAdaptor() {
        this.loggerAPI = (0, $gZfKR.default);
        this.loggerController = new $ab29a3967976254d$var$LoggerController();
        window._loggerController = this.loggerController;
    }
    /**
     * Implementation of AnalyticsRegistry#registerAnalyticsAPI().
     */ LoggerAdaptor.prototype.registerLoggerAPI = function(loggerAPI) {
        this.loggerAPI = loggerAPI;
    };
    /**
     * Implementation of LoggerAPI#debug() for use by connect-module-core code.
     */ LoggerAdaptor.prototype.debug = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        try {
            if (this.loggerController.isDebugEnabled()) this.loggerAPI.debug.apply(this.loggerAPI, arguments);
        } catch (exception) {
        // Ignore
        }
    };
    /**
     * Implementation of LoggerAPI#info() for use by connect-module-core code.
     */ LoggerAdaptor.prototype.info = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        try {
            if (this.loggerController.isInfoEnabled()) this.loggerAPI.info.apply(this.loggerAPI, arguments);
        } catch (exception) {
        // Ignore
        }
    };
    /**
     * Implementation of LoggerAPI#warn() for use by connect-module-core code.
     */ LoggerAdaptor.prototype.warn = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        try {
            this.loggerAPI.warn.apply(this.loggerAPI, arguments);
        } catch (exception) {
            var logger_1 = console.warn || console.log;
            if (logger_1) logger_1.apply(logger_1, arguments);
        }
    };
    /**
     * Implementation of LoggerAPI#error() for use by connect-module-core code.
     */ LoggerAdaptor.prototype.error = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        try {
            this.loggerAPI.error.apply(this.loggerAPI, arguments);
        } catch (exception) {
            var logger_2 = console.error || console.log;
            if (logger_2) logger_2.apply(logger_2, arguments);
        }
    };
    return LoggerAdaptor;
}();
var $ab29a3967976254d$export$af88d00dbe7f521 = new $ab29a3967976254d$var$LoggerAdaptor();

});
parcelRegister("gZfKR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5de906b4bed8890$export$2e2bcd8739ae039);
var $c5de906b4bed8890$var$DefaultLoggerAPI = /** @class */ function() {
    function DefaultLoggerAPI() {}
    DefaultLoggerAPI.prototype.debug = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        console.debug.apply(console, arguments);
    };
    DefaultLoggerAPI.prototype.info = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        console.info.apply(console, arguments);
    };
    DefaultLoggerAPI.prototype.warn = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        console.warn.apply(console, arguments);
    };
    DefaultLoggerAPI.prototype.error = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        console.error.apply(console, arguments);
    };
    return DefaultLoggerAPI;
}();
var $c5de906b4bed8890$export$2e2bcd8739ae039 = new $c5de906b4bed8890$var$DefaultLoggerAPI();

});



parcelRegister("2d2X3", function(module, exports) {

var $fKE23 = parcelRequire("fKE23");

var $5cXdJ = parcelRequire("5cXdJ");
/**
 * This class provides the Adaptor implementation for ACJS
 */ var $19bf15cbc4359beb$var$ACJSFrameworkAdaptor = /** @class */ function(_super) {
    $fKE23.__extends(ACJSFrameworkAdaptor, _super);
    function ACJSFrameworkAdaptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ACJSFrameworkAdaptor.prototype.registerModuleWithHost = function(moduleName, simpleXdmDefinition) {
    // Do nothing - ACJS is already registering all core modules.
    };
    ACJSFrameworkAdaptor.prototype.getProviderByModuleName = function(moduleName) {
        return _super.prototype.getProviderByModuleName.call(this, moduleName);
    };
    return ACJSFrameworkAdaptor;
}((0, $5cXdJ.BaseFrameworkAdaptor));
var $19bf15cbc4359beb$export$8782e9f160c2e1e7 = new $19bf15cbc4359beb$var$ACJSFrameworkAdaptor();

});
parcelRegister("5cXdJ", function(module, exports) {

$parcel$export(module.exports, "BaseFrameworkAdaptor", () => $3cac02afa1724286$export$4944e39ef1fb1533);
/**
 * This class provides common behaviour relating to the adaption of functionality to a
 * particular Connect client framework. This is necessary for an interim period during which
 * we have multiple Connect client frameworks that we need to support: ACJS and CaaS Client.
 */ var $3cac02afa1724286$export$4944e39ef1fb1533 = /** @class */ function() {
    function BaseFrameworkAdaptor() {
        this.moduleNamesToModules = new Map();
    }
    /**
     * This method registers a module with the Connect client framework relating to this adaptor instance.
     * @param moduleDefinition the definition of the module.
     */ BaseFrameworkAdaptor.prototype.registerModule = function(module, props) {
        var moduleRegistrationName = module.getModuleRegistrationName();
        this.moduleNamesToModules.set(moduleRegistrationName, module);
        var simpleXdmDefinitionBuilder = module.getSimpleXdmDefinitionBuilder();
        var simpleXdmDefinition = simpleXdmDefinitionBuilder.buildSimpleXdmDefinition();
        this.registerModuleWithHost(moduleRegistrationName, simpleXdmDefinition);
    };
    BaseFrameworkAdaptor.prototype.getModuleByName = function(moduleName) {
        return this.moduleNamesToModules.get(moduleName);
    };
    /**
     * This routine gets a module provider based on the module's name. The provider will only be returned if
     * the module is enabled.
     * @param moduleName the name of the module.
     * @returns {any} the module provider if found and enabled.
     */ BaseFrameworkAdaptor.prototype.getProviderByModuleName = function(moduleName) {
        var module = this.moduleNamesToModules.get(moduleName);
        if (module && module.isEnabled()) return module.getProvider();
        else return undefined;
    };
    return BaseFrameworkAdaptor;
}();

});


parcelRegister("7MI9d", function(module, exports) {

var $fKE23 = parcelRequire("fKE23");

var $5cXdJ = parcelRequire("5cXdJ");
/**
 * This class provides the Connect client framework adaptor implementation for CaaS.
 */ var $0176709007a08607$var$CaaSFrameworkAdaptor = /** @class */ function(_super) {
    $fKE23.__extends(CaaSFrameworkAdaptor, _super);
    function CaaSFrameworkAdaptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CaaSFrameworkAdaptor.prototype.registerModuleWithHost = function(moduleName, simpleXdmDefinition) {
    // Removing the dependency on connect-client to ensure we don't bloat out the size of
    // the code unnecessarily. The following line will be re-instated during the migration
    // to CaaS.
    //defineModule(moduleName, simpleXdmDefinition);
    };
    return CaaSFrameworkAdaptor;
}((0, $5cXdJ.BaseFrameworkAdaptor));
var $0176709007a08607$export$6fe9107a24d38c8 = new $0176709007a08607$var$CaaSFrameworkAdaptor();

});

parcelRegister("14gc1", function(module, exports) {

$parcel$export(module.exports, "ConnectIframe", () => $0c72b9bb3b67092e$export$8968565585c2471b);

var $fKE23 = parcelRequire("fKE23");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $eH5Sl = parcelRequire("eH5Sl");

var $iRhDL = parcelRequire("iRhDL");

var $lrr1W = parcelRequire("lrr1W");

var $iKwYn = parcelRequire("iKwYn");
var $0c72b9bb3b67092e$export$62aa48085237e36f = Object.freeze({
    INIT: Symbol('init'),
    LOADED: Symbol('loaded'),
    FAILED: Symbol('failed'),
    TIMEOUT: Symbol('timeout'),
    LOADING: Symbol('loading'),
    RESOLVING: Symbol('resolving')
});
/**
 * ConnectIframe represents an add-on within a view.
 *
 * Important: Many iframe props, such as URL and options (context) cannot be changed after the iframe has been initialized.
 * This is because these props are passed to the iframe upon initial creation.
 * If you wish to change these properties, you must force the React component to be destroyed and recreated.
 * The easiest way to do this is by using React's "key" prop to create a new instance of the component.
 */ var $0c72b9bb3b67092e$export$8968565585c2471b = /** @class */ function(_super) {
    $fKE23.__extends(ConnectIframe, _super);
    function ConnectIframe(props) {
        var _this = _super.call(this, props) || this;
        _this.unmountCallbacks = [];
        _this.resize = function(width, height) {
            _this.setState({
                width: width,
                height: height
            });
        };
        _this.sizeToParent = function() {
            _this.setState({
                width: '100%',
                height: '100%'
            });
        };
        _this.registerUnmountCallback = function(callback) {
            _this.unmountCallbacks.push(callback);
        };
        _this.hideInlineDialog = function() {
            if (_this.props.connectIframeProvider.onHideInlineDialog) _this.props.connectIframeProvider.onHideInlineDialog();
        };
        _this.getId = function() {
            if (_this.iframeAttributes) return _this.iframeAttributes.id;
            else return null;
        };
        _this.getIFrameLifecycleEventManager = function() {
            return _this.iframeLifecycleEventManager;
        };
        _this.iframeEstablishedCallback = function() {
            _this.setState({
                loadingState: $0c72b9bb3b67092e$export$62aa48085237e36f.LOADED
            });
        };
        _this.iframeFailedToLoadCallback = function() {
            _this.setState({
                loadingState: $0c72b9bb3b67092e$export$62aa48085237e36f.FAILED
            });
        };
        _this.iframeTimeoutCallback = function() {
            _this.setState({
                loadingState: $0c72b9bb3b67092e$export$62aa48085237e36f.TIMEOUT
            });
        };
        _this._createIFrameLifecycleManager = function() {
            _this.iframeLifecycleEventManager = new (0, $lrr1W.default)(_this);
        };
        _this._unregisterIFrameLifecycleManager = function() {
            if (_this.iframeLifecycleEventManager) _this.iframeLifecycleEventManager.unregister(_this);
        };
        _this._createExtension = function() {
            var simpleXdmExtension = _this.props.connectHost.createExtension({
                addon_key: _this.iframeContext.appKey,
                key: _this.iframeContext.moduleKey,
                url: _this.iframeContext.url,
                options: Object.assign({}, _this.iframeContext.options, {
                    resize: _this.resize.bind(_this),
                    sizeToParent: _this.sizeToParent.bind(_this),
                    registerUnmountCallback: _this.registerUnmountCallback.bind(_this),
                    _contextualOperations: {
                        hideInlineDialog: _this.hideInlineDialog.bind(_this)
                    },
                    hostFrameOffset: 1
                })
            });
            _this.iframeAttributes = simpleXdmExtension.iframeAttributes;
            (0, $eH5Sl.logger).debug('Created iframe for add-on ', _this.iframeContext.appKey, _this.iframeAttributes);
            (0, $iRhDL.analytics).trigger((0, $iKwYn.AnalyticsCategories).iframe, (0, $iRhDL.analytics).markAsSafe.apply((0, $iRhDL.analytics), (0, $iKwYn.allowedStrings))((0, $iKwYn.AnalyticsActions).create), (0, $iRhDL.analytics).dangerouslyCreateSafeString(_this.iframeContext.appKey), {});
        };
        _this._destroyExtension = function() {
            if (_this.iframeAttributes) _this.props.connectHost.destroy(_this.iframeAttributes.id);
        };
        _this._isSubIframe = function() {
            return _this.state.hostFrameOffset && _this.state.hostFrameOffset > 1;
        };
        _this._initialise = function() {
            if (_this.props.children && _this.props.connectIframeProvider.onStoreNestedIframeJSON) {
                var childComponent = _this.props.children;
                var childProps = childComponent.props;
                _this.props.connectIframeProvider.onStoreNestedIframeJSON(childProps);
            }
            if (_this._isSubIframe()) {
                _this.setState({
                    loadingState: $0c72b9bb3b67092e$export$62aa48085237e36f.LOADING
                });
                return;
            }
            _this._createIFrameLifecycleManager();
            if (!_this.props.connectIframeProvider.resolveIframeContext) {
                _this._createExtension();
                _this.setState({
                    loadingState: $0c72b9bb3b67092e$export$62aa48085237e36f.LOADING
                });
                return;
            }
            _this.props.connectIframeProvider.resolveIframeContext(_this.iframeContext, _this.props.connectHost).then(function(iframeContext) {
                var propsMutated = iframeContext.appKey !== _this.props.appKey || iframeContext.moduleKey !== _this.props.moduleKey;
                if (propsMutated) {
                    (0, $eH5Sl.logger).warn('Iframe context changed during resolution');
                    return;
                }
                _this.iframeContext = iframeContext;
                _this._createExtension();
                _this.setState({
                    loadingState: $0c72b9bb3b67092e$export$62aa48085237e36f.LOADING
                });
            });
        };
        _this.state = {
            width: props.width,
            height: props.height,
            loadingState: $0c72b9bb3b67092e$export$62aa48085237e36f.INIT,
            hostFrameOffset: props.options.hostFrameOffset || 1
        };
        _this.iframeContext = {
            url: props.url,
            appKey: props.appKey,
            moduleKey: props.moduleKey,
            options: props.options
        };
        return _this;
    }
    ConnectIframe.prototype.componentWillReceiveProps = function(nextProps) {
        if (this.props.appKey !== nextProps.appKey || this.props.moduleKey !== nextProps.moduleKey) {
            this._unregisterIFrameLifecycleManager();
            this._destroyExtension();
            this.setState({
                width: nextProps.width,
                height: nextProps.height,
                hostFrameOffset: nextProps.options.hostFrameOffset || 1,
                loadingState: $0c72b9bb3b67092e$export$62aa48085237e36f.INIT
            });
            this.iframeContext = {
                url: nextProps.url,
                appKey: nextProps.appKey,
                moduleKey: nextProps.moduleKey,
                options: nextProps.options
            };
        }
    };
    ConnectIframe.prototype.componentWillUnmount = function() {
        this.unmountCallbacks.forEach(function(cb) {
            return cb();
        });
        this._unregisterIFrameLifecycleManager();
        this._destroyExtension();
    };
    ConnectIframe.prototype.render = function() {
        switch(this.state.loadingState){
            case $0c72b9bb3b67092e$export$62aa48085237e36f.LOADED:
            case $0c72b9bb3b67092e$export$62aa48085237e36f.LOADING:
            case $0c72b9bb3b67092e$export$62aa48085237e36f.TIMEOUT:
                var iframeStyles = void 0;
                // Ask the product for the styles to use...
                if (this.props.connectIframeProvider.buildIframeStyles) iframeStyles = this.props.connectIframeProvider.buildIframeStyles(this.state.loadingState, $0c72b9bb3b67092e$export$62aa48085237e36f);
                // if iframeStyles is undefined and loadingState is loading/timeout, set the default style
                if (!iframeStyles && (this.state.loadingState === $0c72b9bb3b67092e$export$62aa48085237e36f.LOADING || this.state.loadingState === $0c72b9bb3b67092e$export$62aa48085237e36f.TIMEOUT)) iframeStyles = {
                    opacity: 0.0
                };
                return $eUqFw.createElement(this.props.iframeContainer, {
                    width: this.state.width,
                    height: this.state.height
                }, this.state.loadingState === $0c72b9bb3b67092e$export$62aa48085237e36f.TIMEOUT ? $eUqFw.createElement(this.props.timeoutIndicator, {
                    failedCallback: this.iframeFailedToLoadCallback.bind(this)
                }) : null, this.state.loadingState === $0c72b9bb3b67092e$export$62aa48085237e36f.LOADING ? $eUqFw.createElement(this.props.loadingIndicator, null) : null, this._isSubIframe() ? this.props.children : $eUqFw.createElement("iframe", $fKE23.__assign({
                    frameBorder: "0",
                    width: this.state.width,
                    height: this.state.height,
                    style: $fKE23.__assign({
                        display: 'block'
                    }, iframeStyles)
                }, this.iframeAttributes, {
                    referrerPolicy: 'no-referrer'
                }), this.props.children));
            case $0c72b9bb3b67092e$export$62aa48085237e36f.FAILED:
                return $eUqFw.createElement("div", {
                    style: {
                        height: this.state.height
                    }
                }, $eUqFw.createElement(this.props.failedToLoadIndicator, null));
            case $0c72b9bb3b67092e$export$62aa48085237e36f.INIT:
            case $0c72b9bb3b67092e$export$62aa48085237e36f.RESOLVING:
            default:
                return null;
        }
    };
    ConnectIframe.prototype.componentDidMount = function() {
        if (this.state.loadingState === $0c72b9bb3b67092e$export$62aa48085237e36f.INIT) {
            this.setState({
                loadingState: $0c72b9bb3b67092e$export$62aa48085237e36f.RESOLVING
            });
            this._initialise();
        }
    };
    ConnectIframe.prototype.componentDidUpdate = function() {
        if (this.state.loadingState === $0c72b9bb3b67092e$export$62aa48085237e36f.INIT) {
            this.setState({
                loadingState: $0c72b9bb3b67092e$export$62aa48085237e36f.RESOLVING
            });
            this._initialise();
        }
    };
    ConnectIframe.propTypes = {
        connectHost: $1Qivz.object.isRequired,
        appKey: $1Qivz.string.isRequired,
        moduleKey: $1Qivz.string.isRequired,
        iframeContainer: $1Qivz.func,
        loadingIndicator: $1Qivz.func,
        failedToLoadIndicator: $1Qivz.func,
        timeoutIndicator: $1Qivz.func,
        url: $1Qivz.string,
        width: $1Qivz.string,
        height: $1Qivz.string,
        options: $1Qivz.object,
        connectIframeProvider: $1Qivz.object
    };
    ConnectIframe.defaultProps = {
        options: {},
        connectIframeProvider: {},
        iframeContainer: function(_a) {
            var width = _a.width, height = _a.height, children = _a.children;
            return $eUqFw.createElement("div", {
                style: {
                    position: 'relative',
                    width: width === '100%' ? '100%' : 'auto',
                    height: height === '100%' ? '100%' : 'auto'
                }
            }, children);
        },
        failedToLoadIndicator: function() {
            return null;
        },
        loadingIndicator: function() {
            return null;
        },
        timeoutIndicator: function() {
            return null;
        }
    };
    return ConnectIframe;
}($eUqFw.PureComponent);

});
parcelRegister("lrr1W", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9c11642bfcb1a35$export$2e2bcd8739ae039);

var $eH5Sl = parcelRequire("eH5Sl");

var $iRhDL = parcelRequire("iRhDL");

var $iKwYn = parcelRequire("iKwYn");
/*
 * Same as in ACJS. See loading_indicator.js.
 */ var $f9c11642bfcb1a35$var$DEFAULT_APP_LOADING_TIMEOUT = 12000;
var $f9c11642bfcb1a35$var$connectIframes = [];
var $f9c11642bfcb1a35$var$registerHostCallbacks = true;
var $f9c11642bfcb1a35$var$hostIframeEstablishedCallback = function(data) {
    var connectIframe = $f9c11642bfcb1a35$var$connectIframes.find(function(connectIframe) {
        return data.extension.id === connectIframe.getId();
    });
    if (connectIframe) {
        var manager = connectIframe.getIFrameLifecycleEventManager();
        if (manager) manager.iframeEstablishedCallback(data);
    }
};
var $f9c11642bfcb1a35$var$hostIframeUnloadCallback = function(data) {
    var connectIframe = $f9c11642bfcb1a35$var$connectIframes.find(function(connectIframe) {
        return data.extension.id === connectIframe.getId();
    });
    if (connectIframe) {
        var manager = connectIframe.getIFrameLifecycleEventManager();
        if (manager) manager.iframeUnloadCallback(data);
    }
};
var $f9c11642bfcb1a35$var$IFrameLifecycleEventManager = /** @class */ function() {
    function IFrameLifecycleEventManager(connectIframe) {
        var _this = this;
        this.reset = function() {
            $f9c11642bfcb1a35$var$connectIframes = [];
            $f9c11642bfcb1a35$var$registerHostCallbacks = true;
        };
        this.unregister = function(connectIframe) {
            var index = $f9c11642bfcb1a35$var$connectIframes.indexOf(connectIframe);
            if (index > -1) $f9c11642bfcb1a35$var$connectIframes.splice(index, 1);
            _this.clearTimeoutDetectionProcessing();
        };
        this.iframeEstablishedCallback = function(data) {
            (0, $eH5Sl.logger).debug('Established iframe for add-on ', data.extension.addon_key, data);
            if (_this.connectIframe.props.connectIframeProvider.handleIframeLoadingComplete) _this.connectIframe.props.connectIframeProvider.handleIframeLoadingComplete(data.extension.addon_key);
            var loadTime = new Date().getTime();
            var durationToLoadMs = loadTime - _this.creationTimeMs;
            var payload = {
                hostFrameOffset: (0, $iRhDL.analytics).dangerouslyCreateSafeString((_this.connectIframe.props.options.hostFrameOffset || 1).toString()),
                durationToLoadMs: (0, $iRhDL.analytics).dangerouslyCreateSafeString(durationToLoadMs.toString())
            };
            (0, $iRhDL.analytics).trigger((0, $iKwYn.AnalyticsCategories).iframe, (0, $iRhDL.analytics).markAsSafe.apply((0, $iRhDL.analytics), (0, $iKwYn.allowedStrings))((0, $iKwYn.AnalyticsActions).established), (0, $iRhDL.analytics).dangerouslyCreateSafeString(data.extension.addon_key), payload);
            _this.connectIframe.iframeEstablishedCallback();
            _this.clearTimeoutDetectionProcessing();
        };
        this.iframeUnloadCallback = function(data) {
            (0, $eH5Sl.logger).debug('Unloaded iframe for add-on ', data.extension.id, data);
            if (_this.connectIframe.props.connectIframeProvider.handleIframeUnload) _this.connectIframe.props.connectIframeProvider.handleIframeUnload(data.extension.id);
            var unloadTime = new Date().getTime();
            var sessionDurationMs = unloadTime - _this.creationTimeMs;
            var payload = {
                hostFrameOffset: (0, $iRhDL.analytics).dangerouslyCreateSafeString((_this.connectIframe.props.options.hostFrameOffset || 1).toString()),
                sessionDurationMs: (0, $iRhDL.analytics).dangerouslyCreateSafeString(sessionDurationMs.toString())
            };
            (0, $iRhDL.analytics).trigger((0, $iKwYn.AnalyticsCategories).iframe, (0, $iRhDL.analytics).markAsSafe.apply((0, $iRhDL.analytics), (0, $iKwYn.allowedStrings))((0, $iKwYn.AnalyticsActions).close), (0, $iRhDL.analytics).dangerouslyCreateSafeString(data.extension.id), payload);
        };
        this.startTimeoutDetectionProcessing = function() {
            (0, $eH5Sl.logger).debug('Starting iframe timed out processing for add-on ', _this.connectIframe.props.appKey);
            var timeoutMilliseconds = _this.getLoadingTimeout();
            _this.timeoutHandle = window.setTimeout(function() {
                (0, $eH5Sl.logger).warn('Add-on iframe timed out for add-on ', _this.connectIframe.props.appKey);
                _this.timeoutHandle = 0;
                if (_this.connectIframe.props.connectIframeProvider.handleIframeLoadTimeout) _this.connectIframe.props.connectIframeProvider.handleIframeLoadTimeout(_this.connectIframe.props.appKey, _this.connectIframe.iframeFailedToLoadCallback.bind(_this));
                var payload = {
                    hostFrameOffset: (0, $iRhDL.analytics).dangerouslyCreateSafeString((_this.connectIframe.props.options.hostFrameOffset || 1).toString())
                };
                (0, $iRhDL.analytics).trigger((0, $iKwYn.AnalyticsCategories).iframe, (0, $iRhDL.analytics).markAsSafe.apply((0, $iRhDL.analytics), (0, $iKwYn.allowedStrings))((0, $iKwYn.AnalyticsActions).timeout), (0, $iRhDL.analytics).dangerouslyCreateSafeString(_this.connectIframe.props.appKey), payload);
                _this.connectIframe.iframeTimeoutCallback();
            }, timeoutMilliseconds);
        };
        this.getLoadingTimeout = function() {
            var providedTimeoutMilliseconds = _this.connectIframe.props.connectIframeProvider.getLoadingTimeoutMilliseconds ? _this.connectIframe.props.connectIframeProvider.getLoadingTimeoutMilliseconds(_this.connectIframe.props.appKey) : $f9c11642bfcb1a35$var$DEFAULT_APP_LOADING_TIMEOUT;
            var timeoutMilliseconds = providedTimeoutMilliseconds && providedTimeoutMilliseconds > 0 ? providedTimeoutMilliseconds : $f9c11642bfcb1a35$var$DEFAULT_APP_LOADING_TIMEOUT;
            return timeoutMilliseconds;
        };
        this.clearTimeoutDetectionProcessing = function() {
            if (_this.timeoutHandle) {
                (0, $eH5Sl.logger).debug('Clearing iframe timed out timer for add-on ', _this.connectIframe.props.appKey);
                window.clearTimeout(_this.timeoutHandle);
                _this.timeoutHandle = 0;
            }
        };
        this.creationTimeMs = new Date().getTime();
        this.connectIframe = connectIframe;
        $f9c11642bfcb1a35$var$connectIframes.push(connectIframe);
        if ($f9c11642bfcb1a35$var$registerHostCallbacks) {
            this.connectIframe.props.connectHost.onIframeEstablished($f9c11642bfcb1a35$var$hostIframeEstablishedCallback);
            this.connectIframe.props.connectHost.onIframeUnload($f9c11642bfcb1a35$var$hostIframeUnloadCallback);
            $f9c11642bfcb1a35$var$registerHostCallbacks = false;
        }
        this.startTimeoutDetectionProcessing();
        if (this.connectIframe.props.connectIframeProvider.handleIframeLoadingStarted) this.connectIframe.props.connectIframeProvider.handleIframeLoadingStarted(this.connectIframe.props.appKey);
    }
    return IFrameLifecycleEventManager;
}();
var $f9c11642bfcb1a35$export$2e2bcd8739ae039 = $f9c11642bfcb1a35$var$IFrameLifecycleEventManager;

});
parcelRegister("iKwYn", function(module, exports) {

$parcel$export(module.exports, "AnalyticsCategories", () => $da661996f5332cfe$export$99cb2c76c1f7b090);
$parcel$export(module.exports, "AnalyticsActions", () => $da661996f5332cfe$export$9dbfb0e4698d080f);
$parcel$export(module.exports, "allowedStrings", () => $da661996f5332cfe$export$cb67e4122f7d424a);
var $da661996f5332cfe$export$99cb2c76c1f7b090;
(function(AnalyticsCategories) {
    AnalyticsCategories.dialog = 'dialog';
    AnalyticsCategories.iframe = 'iframe';
    AnalyticsCategories.inlineDialog = 'inlineDialog';
})($da661996f5332cfe$export$99cb2c76c1f7b090 || ($da661996f5332cfe$export$99cb2c76c1f7b090 = {}));
var $da661996f5332cfe$export$9dbfb0e4698d080f;
(function(AnalyticsActions) {
    AnalyticsActions.create = 'create';
    AnalyticsActions.close = 'close';
    AnalyticsActions.error = 'error';
    AnalyticsActions.timeout = 'timeout';
    AnalyticsActions.established = 'established';
})($da661996f5332cfe$export$9dbfb0e4698d080f || ($da661996f5332cfe$export$9dbfb0e4698d080f = {}));
var $da661996f5332cfe$export$cb67e4122f7d424a = [
    $da661996f5332cfe$export$9dbfb0e4698d080f.create,
    $da661996f5332cfe$export$9dbfb0e4698d080f.close,
    $da661996f5332cfe$export$9dbfb0e4698d080f.error,
    $da661996f5332cfe$export$9dbfb0e4698d080f.timeout,
    $da661996f5332cfe$export$9dbfb0e4698d080f.established
];

});



parcelRegister("8C7oT", function(module, exports) {

var $fKE23 = parcelRequire("fKE23");

var $2bcQh = parcelRequire("2bcQh");

var $lkulQ = parcelRequire("lkulQ");
var $64579ceb4a3914dd$export$748372235e8d793;
(function(FlagModuleDefinitions) {
    FlagModuleDefinitions.FLAG_MODULE_NAME = 'flag';
    var Props = /** @class */ function() {
        function Props(adaptor, flagProvider) {
            this.adaptor = adaptor;
            this.flagProvider = flagProvider;
        }
        return Props;
    }();
    FlagModuleDefinitions.Props = Props;
    var State = /** @class */ function() {
        function State(flagProvider) {
            this.enabled = true;
            this.registered = false;
            this.flagProvider = flagProvider;
            this.simpleXdmDefinitionBuilder = new (0, $lkulQ.FlagSimpleXdmDefinitionBuilder)(flagProvider);
        }
        return State;
    }();
    FlagModuleDefinitions.State = State;
})($64579ceb4a3914dd$export$748372235e8d793 || ($64579ceb4a3914dd$export$748372235e8d793 = {}));
/**
 * This module provides flag related functionality.
 */ var $64579ceb4a3914dd$export$7031eb52127e17da = /** @class */ function(_super) {
    $fKE23.__extends(FlagModule, _super);
    function FlagModule(props) {
        return _super.call(this, props) || this;
    }
    FlagModule.prototype.componentWillMount = function() {
        if (!this.props.flagProvider) throw new Error('this.props.flagProvider is not defined');
        this.setState(new $64579ceb4a3914dd$export$748372235e8d793.State(this.props.flagProvider));
    };
    FlagModule.prototype.getModuleRegistrationName = function() {
        return $64579ceb4a3914dd$export$748372235e8d793.FLAG_MODULE_NAME;
    };
    FlagModule.prototype.getSimpleXdmDefinitionBuilder = function() {
        return this.state.simpleXdmDefinitionBuilder;
    };
    FlagModule.prototype.getProvider = function() {
        return this.props.flagProvider;
    };
    FlagModule.prototype.render = function() {
        return null;
    };
    return FlagModule;
}((0, $2bcQh.BaseModule));

});
parcelRegister("2bcQh", function(module, exports) {

$parcel$export(module.exports, "BaseModule", () => $1966920cacd4f7bb$export$adea4f5921a64958);

var $fKE23 = parcelRequire("fKE23");

var $eUqFw = parcelRequire("eUqFw");

var $eH5Sl = parcelRequire("eH5Sl");
var $1966920cacd4f7bb$export$ff885fcfc37de939;
(function(ModuleDefinitions) {
    ModuleDefinitions.MIN_REGISTRATION_NAME_LENGTH = 1;
    ModuleDefinitions.MAX_REGISTRATION_NAME_LENGTH = 50;
})($1966920cacd4f7bb$export$ff885fcfc37de939 || ($1966920cacd4f7bb$export$ff885fcfc37de939 = {}));
/**
 * This class provides common module behaviour and characteristics. The term 'Module' refers to
 * a set of related functionality and provides the interface between a product that requires the
 * module functionality and the framework that implements it.
 */ var $1966920cacd4f7bb$export$adea4f5921a64958 = /** @class */ function(_super) {
    $fKE23.__extends(BaseModule, _super);
    function BaseModule(props) {
        return _super.call(this, props) || this;
    }
    BaseModule.prototype.componentDidMount = function() {
        var props = this.props;
        var registrationName = this.getModuleRegistrationName();
        (0, $eH5Sl.logger).debug('Mounting module', registrationName, '...');
        this.validateRegistrationName(registrationName);
        props.adaptor.registerModule(this, props);
        var moduleState = this.state;
        moduleState.enabled = true;
        moduleState.registered = true;
        this.setState(moduleState);
    };
    BaseModule.prototype.setEnabled = function(enabled) {
        var moduleState = this.state;
        moduleState.enabled = enabled;
        this.setState(moduleState);
    };
    BaseModule.prototype.isEnabled = function() {
        return this.state.enabled;
    };
    BaseModule.prototype.componentWillUnmount = function() {
    // Do nothing - we don't unregister modules.
    };
    BaseModule.prototype.shouldComponentUpdate = function() {
        // This module hierarchy never renders anything.
        return false;
    };
    BaseModule.prototype.validateRegistrationName = function(registrationName) {
        if (!registrationName || registrationName.length < $1966920cacd4f7bb$export$ff885fcfc37de939.MIN_REGISTRATION_NAME_LENGTH) throw new Error('The registration name is too short (< ' + $1966920cacd4f7bb$export$ff885fcfc37de939.MIN_REGISTRATION_NAME_LENGTH + ' characters).');
        if (registrationName.length > $1966920cacd4f7bb$export$ff885fcfc37de939.MAX_REGISTRATION_NAME_LENGTH) throw new Error('The registration name is too long (> ' + $1966920cacd4f7bb$export$ff885fcfc37de939.MAX_REGISTRATION_NAME_LENGTH + ' characters).');
        if (!registrationName.match(/^[a-z]+$/i)) throw new Error('The registration name must only contain alphabetic characters.');
    };
    BaseModule.prototype.render = function() {
        return null;
    };
    return BaseModule;
}($eUqFw.Component);

});

parcelRegister("lkulQ", function(module, exports) {

$parcel$export(module.exports, "FlagSimpleXdmDefinitionBuilder", () => $f873025e3c7f6896$export$94f22dab2f68a598);
var $f873025e3c7f6896$export$94f22dab2f68a598 = /** @class */ function() {
    function FlagSimpleXdmDefinitionBuilder(flagProvider) {
        if (!flagProvider) throw new Error('flagProvider is not defined');
        this.flagProvider = flagProvider;
    }
    FlagSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function() {
        var flagProvider = this.flagProvider;
        /*
         * This class is a proxy to the flag object created by the flag provider. It is
         * equivalent to the Flag class defined in atlassian-connect-js/src/modules/flag.js
         * except that it does not pull in any AUI flag implementation.
         */ var FlagProxy = /** @class */ function() {
            function FlagProxy(options, callback) {
                options.id = callback._id;
                var flagId = callback._id;
                var actions = [];
                if (typeof options.actions === 'object') actions = Object.getOwnPropertyNames(options.actions).map(function(key) {
                    return {
                        actionKey: key,
                        actionText: options.actions[key],
                        executeAction: function() {
                            console.log('This needs to be implemented by broadcasting a "flag-action-invoked" event.');
                        }
                    };
                });
                var flagOptions = {
                    id: flagId,
                    title: options.title,
                    body: options.body,
                    actions: actions,
                    onClose: function() {
                        console.log('This needs to be implemented by broadcasting a "flag.close" event.');
                    },
                    close: options.close,
                    type: options.type.toLowerCase()
                };
                this.flag = flagProvider.create(flagOptions);
            }
            FlagProxy.prototype.close = function() {
                this.flag.close();
            };
            return FlagProxy;
        }();
        return {
            create: {
                constructor: FlagProxy,
                close: FlagProxy.prototype.close
            }
        };
    };
    return FlagSimpleXdmDefinitionBuilder;
}();

});


parcelRegister("1Ot6R", function(module, exports) {

var $iRhDL = parcelRequire("iRhDL");

var $iKwYn = parcelRequire("iKwYn");

var $eH5Sl = parcelRequire("eH5Sl");
/**
 * This is the default way that products should use to implement InlineDialogProvider operations.
 */ var $15210a88747615d6$export$42f4559178b41306 = /** @class */ function() {
    function DefaultInlineDialogProvider() {}
    DefaultInlineDialogProvider.prototype.hide = function(appContext) {
        var appHasHideOperation = appContext.extension.options._contextualOperations && appContext.extension.options._contextualOperations.hideInlineDialog && typeof appContext.extension.options._contextualOperations.hideInlineDialog === 'function';
        if (appHasHideOperation) {
            appContext.extension.options._contextualOperations.hideInlineDialog();
            (0, $eH5Sl.logger).debug('Hiding inline dialog...');
            (0, $iRhDL.analytics).trigger((0, $iKwYn.AnalyticsCategories).inlineDialog, (0, $iKwYn.AnalyticsActions).close, appContext.extension.addon_key, {});
        } else {
            (0, $eH5Sl.logger).warn('Attempted to hide the inline dialog for a malformed app: ', appContext);
            (0, $iRhDL.analytics).trigger((0, $iKwYn.AnalyticsCategories).inlineDialog, (0, $iKwYn.AnalyticsActions).error, appContext.extension.addon_key, {
                message: 'No hideInlineDialog function'
            });
        }
    };
    return DefaultInlineDialogProvider;
}();

});

parcelRegister("98v0E", function(module, exports) {

var $fKE23 = parcelRequire("fKE23");

var $2bcQh = parcelRequire("2bcQh");

var $5b7rO = parcelRequire("5b7rO");
var $6a6cea3fcc66cc79$export$b2c1533e87918fe9;
(function(DialogModuleDefinitions) {
    DialogModuleDefinitions.DIALOG_MODULE_NAME = 'dialog';
    var Props = /** @class */ function() {
        function Props(adaptor, dialogProvider) {
            this.adaptor = adaptor;
            this.dialogProvider = dialogProvider;
        }
        return Props;
    }();
    DialogModuleDefinitions.Props = Props;
    var State = /** @class */ function() {
        function State(dialogProvider) {
            this.enabled = true;
            this.registered = false;
            this.dialogProvider = dialogProvider;
            this.simpleXdmDefinitionBuilder = new (0, $5b7rO.DialogSimpleXdmDefinitionBuilder)(dialogProvider);
        }
        return State;
    }();
    DialogModuleDefinitions.State = State;
})($6a6cea3fcc66cc79$export$b2c1533e87918fe9 || ($6a6cea3fcc66cc79$export$b2c1533e87918fe9 = {}));
/**
 * This module provides dialog related functionality.
 */ var $6a6cea3fcc66cc79$export$d9193a0e0fca7cd8 = /** @class */ function(_super) {
    $fKE23.__extends(DialogModule, _super);
    function DialogModule(props) {
        return _super.call(this, props) || this;
    }
    DialogModule.prototype.componentWillMount = function() {
        if (!this.props.dialogProvider) throw new Error('this.props.dialogProvider is not defined');
        this.setState(new $6a6cea3fcc66cc79$export$b2c1533e87918fe9.State(this.props.dialogProvider));
    };
    DialogModule.prototype.getModuleRegistrationName = function() {
        return $6a6cea3fcc66cc79$export$b2c1533e87918fe9.DIALOG_MODULE_NAME;
    };
    DialogModule.prototype.getSimpleXdmDefinitionBuilder = function() {
        return this.state.simpleXdmDefinitionBuilder;
    };
    DialogModule.prototype.getProvider = function() {
        return this.props.dialogProvider;
    };
    DialogModule.prototype.render = function() {
        return null;
    };
    return DialogModule;
}((0, $2bcQh.BaseModule));

});
parcelRegister("5b7rO", function(module, exports) {

$parcel$export(module.exports, "DialogSimpleXdmDefinitionBuilder", () => $3c53c1c03a676972$export$b85c05da5be2a57c);
var $3c53c1c03a676972$export$b85c05da5be2a57c = /** @class */ function() {
    function DialogSimpleXdmDefinitionBuilder(dialogProvider) {
        if (!dialogProvider) throw new Error('dialogProvider is not defined');
        this.dialogProvider = dialogProvider;
    }
    DialogSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function() {
        return {};
    };
    return DialogSimpleXdmDefinitionBuilder;
}();

});


parcelRegister("gJr07", function(module, exports) {

var $fKE23 = parcelRequire("fKE23");

var $2bcQh = parcelRequire("2bcQh");

var $kOWZg = parcelRequire("kOWZg");
var $c2e5cb22e81a5a78$export$4279eadb1f181402;
(function(DropdownModuleDefinitions) {
    DropdownModuleDefinitions.DROPDOWN_MODULE_NAME = 'dropdown';
    var Props = /** @class */ function() {
        function Props(adaptor, dropdownProvider) {
            this.adaptor = adaptor;
            this.dropdownProvider = dropdownProvider;
        }
        return Props;
    }();
    DropdownModuleDefinitions.Props = Props;
    var State = /** @class */ function() {
        function State(dropdownProvider) {
            this.enabled = true;
            this.registered = false;
            this.dropdownProvider = dropdownProvider;
            this.simpleXdmDefinitionBuilder = new (0, $kOWZg.DropdownSimpleXdmDefinitionBuilder)(dropdownProvider);
        }
        return State;
    }();
    DropdownModuleDefinitions.State = State;
})($c2e5cb22e81a5a78$export$4279eadb1f181402 || ($c2e5cb22e81a5a78$export$4279eadb1f181402 = {}));
/**
 * This module provides dropdown related functionality.
 */ var $c2e5cb22e81a5a78$export$f4d87b4303498ba0 = /** @class */ function(_super) {
    $fKE23.__extends(DropdownModule, _super);
    function DropdownModule(props) {
        return _super.call(this, props) || this;
    }
    DropdownModule.prototype.componentWillMount = function() {
        if (!this.props.dropdownProvider) throw new Error('this.props.dropdownProvider is not defined');
        this.setState(new $c2e5cb22e81a5a78$export$4279eadb1f181402.State(this.props.dropdownProvider));
    };
    DropdownModule.prototype.getModuleRegistrationName = function() {
        return $c2e5cb22e81a5a78$export$4279eadb1f181402.DROPDOWN_MODULE_NAME;
    };
    DropdownModule.prototype.getSimpleXdmDefinitionBuilder = function() {
        return this.state.simpleXdmDefinitionBuilder;
    };
    DropdownModule.prototype.getProvider = function() {
        return this.props.dropdownProvider;
    };
    DropdownModule.prototype.render = function() {
        return null;
    };
    return DropdownModule;
}((0, $2bcQh.BaseModule));

});
parcelRegister("kOWZg", function(module, exports) {

$parcel$export(module.exports, "DropdownSimpleXdmDefinitionBuilder", () => $f2863bc2345ca73e$export$338fba6bed3be020);
var $f2863bc2345ca73e$export$338fba6bed3be020 = /** @class */ function() {
    function DropdownSimpleXdmDefinitionBuilder(dropdownProvider) {
        if (!dropdownProvider) throw new Error('dropdownProvider is not defined');
        this.dropdownProvider = dropdownProvider;
    }
    DropdownSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function() {
        return {};
    };
    return DropdownSimpleXdmDefinitionBuilder;
}();

});


parcelRegister("6MSBx", function(module, exports) {

var $fKE23 = parcelRequire("fKE23");

var $2bcQh = parcelRequire("2bcQh");

var $3GQVS = parcelRequire("3GQVS");
var $4f119511ddd04701$export$ae7b722dbdc6e5c7;
(function(InlineDialogModuleDefinitions) {
    InlineDialogModuleDefinitions.INLINE_DIALOG_MODULE_NAME = 'inlineDialog';
    var Props = /** @class */ function() {
        function Props(adaptor, inlineDialogProvider) {
            this.adaptor = adaptor;
            this.inlineDialogProvider = inlineDialogProvider;
        }
        return Props;
    }();
    InlineDialogModuleDefinitions.Props = Props;
    var State = /** @class */ function() {
        function State(inlineDialogProvider) {
            this.enabled = true;
            this.registered = false;
            this.inlineDialogProvider = inlineDialogProvider;
            this.simpleXdmDefinitionBuilder = new (0, $3GQVS.InlineDialogSimpleXdmDefinitionBuilder)(inlineDialogProvider);
        }
        return State;
    }();
    InlineDialogModuleDefinitions.State = State;
})($4f119511ddd04701$export$ae7b722dbdc6e5c7 || ($4f119511ddd04701$export$ae7b722dbdc6e5c7 = {}));
/**
 * This module provides inlineDialog related functionality.
 */ var $4f119511ddd04701$export$b1f44b14f5988e61 = /** @class */ function(_super) {
    $fKE23.__extends(InlineDialogModule, _super);
    function InlineDialogModule(props) {
        return _super.call(this, props) || this;
    }
    InlineDialogModule.prototype.componentWillMount = function() {
        if (!this.props.inlineDialogProvider) throw new Error('this.props.inlineDialogProvider is not defined');
        this.setState(new $4f119511ddd04701$export$ae7b722dbdc6e5c7.State(this.props.inlineDialogProvider));
    };
    InlineDialogModule.prototype.getModuleRegistrationName = function() {
        return $4f119511ddd04701$export$ae7b722dbdc6e5c7.INLINE_DIALOG_MODULE_NAME;
    };
    InlineDialogModule.prototype.getSimpleXdmDefinitionBuilder = function() {
        return this.state.simpleXdmDefinitionBuilder;
    };
    InlineDialogModule.prototype.getProvider = function() {
        return this.props.inlineDialogProvider;
    };
    InlineDialogModule.prototype.render = function() {
        return null;
    };
    return InlineDialogModule;
}((0, $2bcQh.BaseModule));

});
parcelRegister("3GQVS", function(module, exports) {

$parcel$export(module.exports, "InlineDialogSimpleXdmDefinitionBuilder", () => $2afe5a9ca1d365e4$export$f57ca3ba8378bc0b);
var $2afe5a9ca1d365e4$export$f57ca3ba8378bc0b = /** @class */ function() {
    function InlineDialogSimpleXdmDefinitionBuilder(inlineDialogProvider) {
        if (!inlineDialogProvider) throw new Error('inlineDialogProvider is not defined');
        this.inlineDialogProvider = inlineDialogProvider;
    }
    InlineDialogSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function() {
        return {};
    };
    return InlineDialogSimpleXdmDefinitionBuilder;
}();

});


parcelRegister("3W7Ti", function(module, exports) {

var $fKE23 = parcelRequire("fKE23");

var $2bcQh = parcelRequire("2bcQh");

var $iZcsu = parcelRequire("iZcsu");
var $2ddce8d7d6441cab$export$8322ec4fed7b0ec;
(function(MessageModuleDefinitions) {
    MessageModuleDefinitions.MESSAGE_MODULE_NAME = 'messages';
    var Props = /** @class */ function() {
        function Props(adaptor, messageProvider) {
            this.adaptor = adaptor;
            this.messageProvider = messageProvider;
        }
        return Props;
    }();
    MessageModuleDefinitions.Props = Props;
    var State = /** @class */ function() {
        function State(messageProvider) {
            this.enabled = true;
            this.registered = false;
            this.messageProvider = messageProvider;
            this.simpleXdmDefinitionBuilder = new (0, $iZcsu.MessageSimpleXdmDefinitionBuilder)(messageProvider);
        }
        return State;
    }();
    MessageModuleDefinitions.State = State;
})($2ddce8d7d6441cab$export$8322ec4fed7b0ec || ($2ddce8d7d6441cab$export$8322ec4fed7b0ec = {}));
/**
 * This module provides message related functionality.
 */ var $2ddce8d7d6441cab$export$22578b4f731c13ad = /** @class */ function(_super) {
    $fKE23.__extends(MessageModule, _super);
    function MessageModule(props) {
        return _super.call(this, props) || this;
    }
    MessageModule.prototype.componentWillMount = function() {
        if (!this.props.messageProvider) throw new Error('this.props.messageProvider is not defined');
        this.setState(new $2ddce8d7d6441cab$export$8322ec4fed7b0ec.State(this.props.messageProvider));
    };
    MessageModule.prototype.getModuleRegistrationName = function() {
        return $2ddce8d7d6441cab$export$8322ec4fed7b0ec.MESSAGE_MODULE_NAME;
    };
    MessageModule.prototype.getSimpleXdmDefinitionBuilder = function() {
        return this.state.simpleXdmDefinitionBuilder;
    };
    MessageModule.prototype.getProvider = function() {
        return this.props.messageProvider;
    };
    MessageModule.prototype.render = function() {
        return null;
    };
    return MessageModule;
}((0, $2bcQh.BaseModule));

});
parcelRegister("iZcsu", function(module, exports) {

$parcel$export(module.exports, "MessageSimpleXdmDefinitionBuilder", () => $dd279681c704831e$export$a2377c7acc103422);
var $dd279681c704831e$export$a2377c7acc103422 = /** @class */ function() {
    function MessageSimpleXdmDefinitionBuilder(messageProvider) {
        if (!messageProvider) throw new Error('messageProvider is not defined');
        this.messageProvider = messageProvider;
    }
    MessageSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function() {
        return {};
    };
    return MessageSimpleXdmDefinitionBuilder;
}();

});


parcelRegister("hye1w", function(module, exports) {

var $ds4ui = parcelRequire("ds4ui");
/**
 * This class validates an instance of DialogProvider. This is intended to be used by consumers of this library in
 * their tests to validate their implementations. Knowing products have incorporated this into their test suite will
 * allow breaking changes to be introduced in the library.
 */ var $cc707d7432ee96b1$export$728f00fa4551317c = /** @class */ function() {
    function DialogProviderValidator() {}
    DialogProviderValidator.validate = function(dialogProvider) {
        (0, $ds4ui.default).checkFunctionExists('dialogProvider', dialogProvider, 'create');
        (0, $ds4ui.default).checkFunctionExists('dialogProvider', dialogProvider, 'close');
        (0, $ds4ui.default).checkFunctionExists('dialogProvider', dialogProvider, 'setButtonDisabled');
        (0, $ds4ui.default).checkFunctionExists('dialogProvider', dialogProvider, 'isButtonDisabled');
        (0, $ds4ui.default).checkFunctionExists('dialogProvider', dialogProvider, 'toggleButton');
        (0, $ds4ui.default).checkFunctionExists('dialogProvider', dialogProvider, 'setButtonHidden');
        (0, $ds4ui.default).checkFunctionExists('dialogProvider', dialogProvider, 'isButtonHidden');
        (0, $ds4ui.default).checkFunctionExists('dialogProvider', dialogProvider, 'isActiveDialog');
        var actionClicked = false;
        var myAction = {
            identifier: 'my-action',
            text: 'Some Action',
            onClick: function() {
                actionClicked = true;
            }
        };
        var dialogCreationOptions = {
            key: 'my-dialog',
            size: 'medium',
            width: '100%',
            height: '50px',
            chrome: false,
            header: 'My header',
            actions: [
                myAction
            ],
            closeOnEscape: true,
            hint: 'this is a test'
        };
        var bogus_addon_key = 'bogus_app';
        var addon_key = 'foo-app';
        var dialogExtension = {
            addon_key: addon_key,
            key: 'foo-key',
            options: {}
        };
        var dialog = dialogProvider.create(dialogCreationOptions, dialogExtension);
        // Allow contenet resolver promises to complete
        setTimeout(function() {
            // TODO: Fix under ACJS-735
            // ValidationUtil.checkExists('dialog', dialog);
            // ValidationUtil.checkFunctionExists('dialog', dialog, 'on');
            // Check the dialog is active...
            var isActiveAfterCreation = dialogProvider.isActiveDialog(addon_key);
            if (!isActiveAfterCreation) throw new Error('The dialog should be active');
            // Check the active status returns false for another add-on...
            var isAnotherAppsDialogActive = dialogProvider.isActiveDialog(bogus_addon_key);
            if (isAnotherAppsDialogActive) throw new Error('The dialog should not be active');
            // Check the enabled state of a button...
            if (dialogProvider.isButtonDisabled('my-action')) throw new Error('Button should be enabled by default');
            // Disable a button...
            dialogProvider.setButtonDisabled('my-action', true);
            if (!dialogProvider.isButtonDisabled('my-action')) throw new Error('Button should have been disabled.');
            // Re-enabled a button...
            dialogProvider.toggleButton('my-action');
            if (dialogProvider.isButtonDisabled('my-action')) throw new Error('Button should have been re-enabled.');
            // Check the visibility of a button...
            if (dialogProvider.isButtonHidden('my-action')) throw new Error('Button should be visible by default');
            // Hide a button...
            dialogProvider.setButtonHidden('my-action', true);
            if (!dialogProvider.isButtonHidden('my-action')) throw new Error('Button should have been hidden.');
            dialogProvider.close();
        }, 0);
    };
    return DialogProviderValidator;
}();

});
parcelRegister("ds4ui", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cb15f0918b4823d$export$2e2bcd8739ae039);
var $9cb15f0918b4823d$export$fa29912b5fdf77b5 = /** @class */ function() {
    function ValidationUtil() {}
    ValidationUtil.checkExists = function(objectName, object) {
        if (!object) throw new Error(objectName + " does not exist.");
    };
    ValidationUtil.checkPropertyExists = function(objectName, object, propertyName) {
        var objectProperty = object[propertyName];
        if (!objectProperty) throw new Error("Expected " + objectName + " to have a property: " + propertyName + ".");
        if (ValidationUtil.isFunction(objectProperty)) throw new Error(objectName + " has a property " + propertyName + ", but it is a function.");
    };
    ValidationUtil.checkFunctionExists = function(objectName, object, functionName) {
        var objectProperty = object[functionName];
        if (!objectProperty) throw new Error("Expected " + objectName + " to have a function: " + functionName + ".");
        if (!ValidationUtil.isFunction(objectProperty)) {
            var objectPropertyTypeInfo = typeof objectProperty + ' (value: ' + objectProperty + ')';
            throw new Error(objectName + " has a property " + functionName + ", but it is a " + objectPropertyTypeInfo + " rather than a function.");
        }
    };
    ValidationUtil.isFunction = function(object) {
        return typeof object === 'function';
    };
    return ValidationUtil;
}();
var $9cb15f0918b4823d$export$2e2bcd8739ae039 = $9cb15f0918b4823d$export$fa29912b5fdf77b5;

});


parcelRegister("1ZsfM", function(module, exports) {

var $d3aAA = parcelRequire("d3aAA");

var $ds4ui = parcelRequire("ds4ui");
/**
 * This class validates an instance of FlagProvider. This is intended to be used by consumers of this library in
 * their tests to validate their implementations. Knowing products have incorporated this into their test suite will
 * allow breaking changes to be introduced in the library.
 */ var $173167848e8b7e38$export$a28584b2365c8dd4 = /** @class */ function() {
    function FlagProviderValidator() {}
    FlagProviderValidator.validate = function(flagProvider) {
        (0, $ds4ui.default).checkFunctionExists('flagProvider', flagProvider, 'create');
        (0, $ds4ui.default).checkFunctionExists('flagProvider', flagProvider, 'isFlagOpen');
        FlagProviderValidator.validateFlagCreationAndDeletions(flagProvider, 'manual');
        FlagProviderValidator.validateFlagCreationAndDeletions(flagProvider, 'auto');
        FlagProviderValidator.validateFlagCreationAndDeletions(flagProvider, 'never');
    };
    FlagProviderValidator.validateFlagCreationAndDeletions = function(flagProvider, closeFlagOption) {
        var flagActions = [];
        FlagProviderValidator.validateFlagCreationAndDeletion(flagProvider, closeFlagOption, flagActions, false);
        var flagAction = new (0, $d3aAA.FlagAction)();
        flagAction.actionKey = 'some-action';
        flagAction.actionText = 'Some Action';
        flagAction.executeAction = function() {
            console.log('Action clicked');
        };
        flagActions.push(flagAction);
        FlagProviderValidator.validateFlagCreationAndDeletion(flagProvider, closeFlagOption, flagActions, false);
        var flagActionMissingExecuteAction = new (0, $d3aAA.FlagAction)();
        flagActionMissingExecuteAction.actionKey = 'some-action';
        flagActionMissingExecuteAction.actionText = 'Some Action';
        flagActions[0] = flagActionMissingExecuteAction;
        FlagProviderValidator.validateFlagCreationAndDeletion(flagProvider, closeFlagOption, flagActions, true);
    };
    FlagProviderValidator.validateFlagCreationAndDeletion = function(flagProvider, closeFlagOption, flagActions, expectValidationError) {
        var flagIdsToFlags = new Map();
        var flagId = 'flag-' + new Date().getMilliseconds();
        var flagOptions = {
            id: flagId,
            title: 'My Flag',
            body: 'My flag content',
            type: 'success',
            close: closeFlagOption,
            onClose: function(flagId) {
                flagIdsToFlags.delete(flagId);
            },
            actions: flagActions
        };
        try {
            var flag = flagProvider.create(flagOptions);
            if (expectValidationError) throw new Error('Expected a validation error, but did not get one.');
            flagIdsToFlags.set(flag.id, flag);
            (0, $ds4ui.default).checkExists('flag', flag);
            (0, $ds4ui.default).checkFunctionExists('flag', flag, 'close');
            if (closeFlagOption !== 'auto') {
                var flagOpen = flagProvider.isFlagOpen(flag.id);
                if (!flagOpen) throw new Error("Expected flag to exist.");
            }
            flag.close();
            if (flagIdsToFlags.size) throw new Error('It looks like the provider did not synchronously call back the onClose method.');
        } catch (exception) {
            if (expectValidationError) ;
            else throw new Error('Did not expect a validation error, but got one.');
        }
    };
    return FlagProviderValidator;
}();

});
parcelRegister("d3aAA", function(module, exports) {

$parcel$export(module.exports, "FlagAction", () => $9803c4f2fd849921$export$137131383bc80874);
var $9803c4f2fd849921$export$137131383bc80874 = /** @class */ function() {
    function FlagAction() {}
    return FlagAction;
}();
/**
 * This interface describes the options controlling the creation of flags.
 */ var $9803c4f2fd849921$export$b7026fd91c62192e = /** @class */ function() {
    function FlagCreationOptions() {}
    return FlagCreationOptions;
}();

});


parcelRegister("h5Pjm", function(module, exports) {

var $ds4ui = parcelRequire("ds4ui");

var $jbXHh = parcelRequire("jbXHh");
/**
 * This class validates an instance of InlineDialogProvider. This is intended to be used by consumers of this library in
 * their tests to validate their implementations. Knowing products have incorporated this into their test suite will
 * allow breaking changes to be introduced in the library.
 */ var $c71ab4aaca173015$export$c73136b548ed0f6f = /** @class */ function() {
    function InlineDialogProviderValidator() {}
    InlineDialogProviderValidator.validate = function(inlineDialogProvider) {
        (0, $ds4ui.default).checkFunctionExists('inlineDialogProvider', inlineDialogProvider, 'hide');
        var appContext = (0, $jbXHh.TestAppContext).buildNewInstance();
        inlineDialogProvider.hide(appContext);
    };
    return InlineDialogProviderValidator;
}();

});
parcelRegister("jbXHh", function(module, exports) {

$parcel$export(module.exports, "TestAppContext", () => $df8d5a023733831e$export$c2ea901ef0c0e837);
var $df8d5a023733831e$export$2d6b340a940d682f = /** @class */ function() {
    function TestContextualOperations() {
        this.inlineDialogOpen = true;
    }
    TestContextualOperations.prototype.resize = function(width, height) {
        throw new Error('Not implemented yet');
    };
    TestContextualOperations.prototype.sizeToParent = function() {
        throw new Error('Not implemented yet');
    };
    /**
     * This method hides the inline dialog that the add-on identified by this context is
     * being displayed in.
     */ TestContextualOperations.prototype.hideInlineDialog = function() {
        this.inlineDialogOpen = false;
    };
    TestContextualOperations.prototype.isInlineDialogOpen = function() {
        return this.inlineDialogOpen;
    };
    return TestContextualOperations;
}();
var $df8d5a023733831e$export$f4e04f09a1f31b14 = /** @class */ function() {
    function TestAppInstance(appKey, id, key, options) {
        this.addon_key = appKey;
        this.id = id;
        this.key = key;
        this.options = options;
    }
    return TestAppInstance;
}();
var $df8d5a023733831e$export$13e597eb521ea346 = /** @class */ function() {
    function TestAppOptions(autoresize, widthinpx, hostFrameOffset, _contextualOperations) {
        this.autoresize = autoresize;
        this.widthinpx = widthinpx;
        this.hostFrameOffset = hostFrameOffset;
        this._contextualOperations = _contextualOperations;
    }
    return TestAppOptions;
}();
var $df8d5a023733831e$export$c2ea901ef0c0e837 = /** @class */ function() {
    function TestAppContext(extension) {
        this.extension = extension;
    }
    TestAppContext.buildNewInstance = function() {
        var contextualOperations = new $df8d5a023733831e$export$2d6b340a940d682f();
        var autoresize = true;
        var widthinpx = true;
        var hostFrameOffset = 1;
        var appOptions = new $df8d5a023733831e$export$13e597eb521ea346(autoresize, widthinpx, hostFrameOffset, contextualOperations);
        var randomId = new Date().getMilliseconds();
        var appKey = 'foo';
        var key = 'bar';
        var id = appKey + '__' + key + '__' + randomId;
        var appInstance = new $df8d5a023733831e$export$f4e04f09a1f31b14(appKey, id, key, appOptions);
        var appContext = new TestAppContext(appInstance);
        return appContext;
    };
    return TestAppContext;
}();

});


parcelRegister("dX5ge", function(module, exports) {

var $ds4ui = parcelRequire("ds4ui");
/**
 * This class validates an instance of MessageProvider. This is intended to be used by consumers of this library in
 * their tests to validate their implementations. Knowing products have incorporated this into their test suite will
 * allow breaking changes to be introduced in the library.
 */ var $a284ddbfc6777552$export$4aff556677cdd09a = /** @class */ function() {
    function MessageProviderValidator() {}
    MessageProviderValidator.validate = function(messageProvider) {
        (0, $ds4ui.default).checkFunctionExists('messageProvider', messageProvider, 'clear');
        (0, $ds4ui.default).checkFunctionExists('messageProvider', messageProvider, 'onClose');
        var creationRoutineNames = [
            'generic',
            'hint',
            'info',
            'success',
            'warning',
            'error'
        ];
        creationRoutineNames.forEach(function(creationRoutineName) {
            (0, $ds4ui.default).checkFunctionExists('messageProvider', messageProvider, creationRoutineName);
            var messageId = 'message-' + new Date().getMilliseconds();
            var title = 'My Message';
            var body = 'My message content';
            var messageOptions = {
                id: messageId,
                closeable: true,
                fadeout: true,
                delay: 2000,
                duration: 4000
            };
            if (creationRoutineName === 'generic') messageProvider.generic(title, body, messageOptions);
            else if (creationRoutineName === 'hint') messageProvider.hint(title, body, messageOptions);
            else if (creationRoutineName === 'info') messageProvider.info(title, body, messageOptions);
            else if (creationRoutineName === 'success') messageProvider.success(title, body, messageOptions);
            else if (creationRoutineName === 'warning') messageProvider.warning(title, body, messageOptions);
            else if (creationRoutineName === 'error') messageProvider.error(title, body, messageOptions);
            (0, $ds4ui.default).checkExists('messageId', messageId);
            var dummyOnCloseCalled = false;
            var onCloseCalled = false;
            messageProvider.onClose(messageId, function() {
                onCloseCalled = true;
            });
            messageProvider.onClose('dummy-message-id', function() {
                dummyOnCloseCalled = true;
            });
            messageProvider.clear(messageId);
            if (!onCloseCalled) throw new Error('Expected onClose callback to be called after calling clear.');
            if (dummyOnCloseCalled) throw new Error('Did not expect the dummy onClose callback to be called.');
        });
    };
    return MessageProviderValidator;
}();

});

parcelRegister("chvxa", function(module, exports) {

var $g7tBV = parcelRequire("g7tBV");
/**
 * This class provides a mock implementation of ConnectHost.
 */ var $8f0f888bda643534$export$d34d7bcfe7ba9cee = /** @class */ function() {
    function MockConnectHost() {
        this.onIframeEstablished = jest.fn();
        this.offIframeEstablished = jest.fn();
        this.onIframeUnload = jest.fn();
        this.offIframeUnload = jest.fn();
        this.createExtension = jest.fn(function(params) {
            var val = new (0, $g7tBV.MockSimpleXdmExtension);
            val.iframeAttributes.src = params.url;
            return val;
        });
        this.destroy = jest.fn();
        this.getContentResolver = jest.fn();
        this.hasJwt = jest.fn();
        this.isJwtExpired = jest.fn();
    }
    return MockConnectHost;
}();

});
parcelRegister("g7tBV", function(module, exports) {

$parcel$export(module.exports, "MockSimpleXdmExtension", () => $bbc444d5d7676bee$export$1cddb33ac1c7fcc0);

var $ckbVZ = parcelRequire("ckbVZ");
var $bbc444d5d7676bee$export$1cddb33ac1c7fcc0 = /** @class */ function() {
    function MockSimpleXdmExtension() {
        this.iframeAttributes = new (0, $ckbVZ.MockConnectIframeInterface)();
        this.extension = {};
    }
    return MockSimpleXdmExtension;
}();

});
parcelRegister("ckbVZ", function(module, exports) {

$parcel$export(module.exports, "MockConnectIframeInterface", () => $8f909c2f7c566eef$export$72c538805177fc9d);
var $8f909c2f7c566eef$export$72c538805177fc9d = /** @class */ function() {
    function MockConnectIframeInterface() {
        this.id = 'mock-iframe-id';
        this.src = 'mock-iframe-src';
        this.name = 'mock-iframe-name';
    }
    return MockConnectIframeInterface;
}();

});




parcelRegister("adX4B", function(module, exports) {

$parcel$export(module.exports, "default", () => $816c4296d91c0154$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useDefaultConnectIframeProvider", () => $816c4296d91c0154$export$ac083e2d52357959);
/* eslint-disable no-param-reassign */ 
var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $gUUjF = parcelRequire("gUUjF");
// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
const $816c4296d91c0154$var$log = (message, event)=>(0, $gUUjF.default).safeInfoWithoutCustomerData('Ecosystem.DefaultConnectIFrameProvider', message, event);
class $816c4296d91c0154$export$2e2bcd8739ae039 {
    constructor({ handleHideInlineDialog: handleHideInlineDialog, handleOnLoadingComplete: handleOnLoadingComplete, handleOnTimeout: handleOnTimeout, isAutoresizeBugfixEnabled: isAutoresizeBugfixEnabled } = {}){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.convertConnectOptions = (data)=>window._AP._convertConnectOptions(data).options;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onStoreNestedIframeJSON = (connectAppProps)=>{
            $816c4296d91c0154$var$log('onStoreNestedIframeJSON', connectAppProps);
        };
        this.getLoadingTimeoutMilliseconds = (appKey)=>{
            $816c4296d91c0154$var$log('getLoadingTimeoutMilliseconds', {
                appKey: appKey
            });
            // In the ACJS we use an aggressive timeout value so we can test more quickly.
            return 30000;
        };
        this.handleIframeLoadingStarted = (appKey)=>{
            $816c4296d91c0154$var$log('handleIframeLoadingStarted', {
                appKey: appKey
            });
        };
        this.handleIframeLoadingComplete = (appKey)=>{
            this.handleOnLoadingComplete();
            $816c4296d91c0154$var$log('handleIframeLoadingComplete', {
                appKey: appKey
            });
        };
        this.handleIframeUnload = (appKey)=>{
            $816c4296d91c0154$var$log('handleIframeUnload', {
                appKey: appKey
            });
        };
        this.handleIframeLoadTimeout = (appKey)=>{
            this.handleOnTimeout();
            $816c4296d91c0154$var$log('handleIframeLoadTimeout', {
                appKey: appKey
            });
        };
        this.isJwtExpired = (url, connectHost)=>{
            if (connectHost.hasJwt && connectHost.isJwtExpired) return url && connectHost.hasJwt(url) && connectHost.isJwtExpired(url);
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            $816c4296d91c0154$var$log('connectHost missing JWT utilities');
            return false;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.sanitiseContext = (ctx)=>typeof ctx === 'string' ? JSON.parse(ctx) : ctx;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.buildIframeStyles = (loadingState, LoadingState)=>{
            if (loadingState === LoadingState.TIMEOUT) return {
                opacity: 0.0,
                height: '0px'
            };
            if (loadingState === LoadingState.LOADED) {
                // This is a hack to try to prevent the autoresize behaviour in the atlassian-connect/all.js for connect addons from
                // self-sizing to zero height (we see this flake very occasionally in pollinator)
                // We should see logs of this occurring outside pollinator when switched on in prod if it is a bug affecting customers.
                if (this.isAutoresizeBugfixEnabled && this.iframeContext && this.connectHost) {
                    const iframes = Object.keys(this.connectHost?.getExtensions()).filter((extensionKey)=>this.iframeContext && extensionKey.startsWith(this.iframeContext.options?.uniqueKey))// prettier-ignore
                    .map((extensionKey)=>window.document.getElementById(extensionKey)).filter((node)=>node != null);
                    iframes.forEach((iframe)=>{
                        if (iframe?.style?.height === '0px') {
                            (0, $gUUjF.default).safeWarnWithoutCustomerData('ecosystem.iframe.provider', `Connect addon iframe with 0 height in loaded state. Set to 100%. appKey: ${this.iframeContext?.appKey ?? 'null'}, modulekey: ${this.iframeContext?.moduleKey ?? 'null'}`);
                            iframe.style.height = '100%';
                        }
                    });
                }
                return {
                    opacity: 1.0,
                    maxWidth: '100%'
                };
            }
            return null;
        };
        this.resolveIframeContext = (iframeContext, connectHost)=>{
            this.iframeContext = iframeContext;
            this.connectHost = connectHost;
            return new Promise((resolve)=>{
                if (iframeContext.url && !this.isJwtExpired(iframeContext.url, connectHost)) {
                    resolve(iframeContext);
                    return;
                }
                if (!connectHost.getContentResolver || !connectHost.getContentResolver()) {
                    // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
                    $816c4296d91c0154$var$log('No content resolver supplied');
                    resolve(iframeContext);
                    return;
                }
                let options;
                try {
                    options = {
                        ...iframeContext.options,
                        productContext: this.sanitiseContext(iframeContext.options.productContext || iframeContext.options.productCtx || {}),
                        structuredContext: this.sanitiseContext(iframeContext.options.structuredContext || iframeContext.options.structuredCtx || {})
                    };
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
                    $816c4296d91c0154$var$log('Unable to parse supplied productCtx');
                    resolve(iframeContext);
                    return;
                }
                connectHost.getContentResolver()({
                    addon_key: iframeContext.appKey,
                    key: iframeContext.moduleKey,
                    options: options,
                    classifier: 'json'
                }).then((promiseData)=>{
                    /* eslint-disable no-prototype-builtins */ if (typeof promiseData !== 'object' || !promiseData.hasOwnProperty('url')) {
                        // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
                        $816c4296d91c0154$var$log('Invalid response');
                        resolve(iframeContext);
                    } else resolve({
                        url: promiseData.url,
                        appKey: promiseData.addon_key || iframeContext.appKey,
                        moduleKey: promiseData.key || iframeContext.moduleKey,
                        options: {
                            ...iframeContext.options,
                            ...promiseData.options
                        }
                    });
                });
            });
        };
        this.handleHideInlineDialog = handleHideInlineDialog || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.handleOnLoadingComplete = handleOnLoadingComplete || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.handleOnTimeout = handleOnTimeout || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.isAutoresizeBugfixEnabled = isAutoresizeBugfixEnabled || false;
    }
    onHideInlineDialog() {
        this.handleHideInlineDialog();
        // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
        $816c4296d91c0154$var$log('DefaultConnectAppProvider.onHideInlineDialog');
    }
}
const $816c4296d91c0154$export$44a359abb235afe0 = (props)=>{
    const providerRef = (0, $eUqFw.useRef)();
    if (providerRef.current == null) providerRef.current = new $816c4296d91c0154$export$2e2bcd8739ae039(props);
    return providerRef.current;
};
const $816c4296d91c0154$export$3135535e219232c6 = (props)=>(0, $eUqFw.useState)(()=>new $816c4296d91c0154$export$2e2bcd8739ae039(props))[0];
const $816c4296d91c0154$export$ac083e2d52357959 = (props)=>$816c4296d91c0154$export$3135535e219232c6(props);

});


parcelRegister("jDxSo", function(module, exports) {

$parcel$export(module.exports, "ForgeIssueContext", () => $8de984ad6bc37558$export$fbd92c91edffa55c);

var $eUqFw = parcelRequire("eUqFw");

var $5syGA = parcelRequire("5syGA");

var $6FUgR = parcelRequire("6FUgR");

var $1atdS = parcelRequire("1atdS");

var $hJ992 = parcelRequire("hJ992");
const $8de984ad6bc37558$export$fbd92c91edffa55c = (props)=>{
    const source = (0, $hJ992.useAnalyticsSource)();
    const { extension: extension } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6FUgR.ViewAnalyticsWrapper), {
        attributes: {
            source: source,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1atdS.AsyncIssueContext), props));
};

});
parcelRegister("6FUgR", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $5bcc4c278695fcc8$export$c794eb4124961145);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");
const $5bcc4c278695fcc8$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.ISSUE_CONTEXT_MODULE),
        ...props
    });
const $5bcc4c278695fcc8$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.ISSUE_CONTEXT_MODULE),
        moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("1atdS", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueContext", () => $d3857a4f2006c1ba$export$59245c9672749487);
/* async.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $4Bees = parcelRequire("4Bees");

var $c9TLT = parcelRequire("c9TLT");

var $is86i = parcelRequire("is86i");

var $1boRu = parcelRequire("1boRu");

var $2Rqjr = parcelRequire("2Rqjr");

var $2vJHJ = parcelRequire("2vJHJ");

var $gGtKh = parcelRequire("gGtKh");

var $aIPS7 = parcelRequire("aIPS7");
const $d3857a4f2006c1ba$export$bed6cc91e533babe = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _1mou1ejb",
            __cmplp.className
        ])
    });
});
const $d3857a4f2006c1ba$var$loadingComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3857a4f2006c1ba$export$bed6cc91e533babe, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
    size: 5 * (0, $c9TLT.gridSize)
}));

const $d3857a4f2006c1ba$export$65f1e889269f10fd = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>(parcelRequire("jhEVV")), {
    ssr: false,
    moduleId: "./src/packages/forge/forge-ui-async/src/ui/issue-context-panel/index.tsx"
}));
const $d3857a4f2006c1ba$export$59245c9672749487 = (props)=>{
    const { extension: extension } = props;
    const forgeUiIssueData = (0, $is86i.useForgeUiIssueData)();
    const extensionData = (0, $eUqFw.useMemo)(()=>forgeUiIssueData && {
            ...forgeUiIssueData,
            type: (0, $2Rqjr.ISSUE_CONTEXT_MODULE)
        } || null, [
        forgeUiIssueData
    ]);
    const LoadingComponent = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.loadingComponent), [
        props.loadingComponent
    ]);
    const extraProps = (0, $eUqFw.useMemo)(()=>extensionData && {
            loadingComponent: LoadingComponent,
            module: (0, $2Rqjr.ISSUE_CONTEXT_MODULE),
            extensionData: extensionData,
            contextToken: (0, $2Rqjr.CONTEXT_TOKEN_TYPE_JIRA)
        } || null, [
        LoadingComponent,
        extensionData
    ]);
    if (!extensionData || !extraProps) return LoadingComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-context",
        fallback: $d3857a4f2006c1ba$var$loadingComponent
    }, (0, $2vJHJ.isCustomUIExtension)(extension) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aIPS7.LazyIssueViewIframe), {
        ...props,
        ...extraProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3857a4f2006c1ba$export$65f1e889269f10fd, {
        ...props,
        ...extraProps
    }));
};

});
parcelRegister("jhEVV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('62VvL');
        const value = parcelRequire('kqicD');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("62VvL").then(()=>parcelRequire('kqicD'));
}

});



parcelRegister("3BIZK", function(module, exports) {

$parcel$export(module.exports, "ApprovalGlance", () => $422db1ffa8a289f3$export$11e17aad30e64f44);
$parcel$export(module.exports, "ApprovalPanel", () => $422db1ffa8a289f3$export$7bbd6594fd571776);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $hJ992 = parcelRequire("hJ992");

var $lqalZ = parcelRequire("lqalZ");

var $iW1Wx = parcelRequire("iW1Wx");

var $fYteL = parcelRequire("fYteL");

var $guDlK = parcelRequire("guDlK");

var $2fQNL = parcelRequire("2fQNL");

var $hhl51 = parcelRequire("hhl51");

var $5ld5d = parcelRequire("5ld5d");
const $422db1ffa8a289f3$export$989168bbffac33ef = (0, $lqalZ.connect)(null, {
    renderApproverList: (0, $fYteL.refreshIssueRequest),
    updateApprovalLinkedUserPickerField: $iW1Wx.updateApprovalLinkedUserPickerField
})((0, $2fQNL.default));
const $422db1ffa8a289f3$export$2031fe8258a2c18 = (0, $lqalZ.connect)(null, {
    setRefreshIssue: (0, $fYteL.refreshIssueRequest)
})((0, $hhl51.JSMApprovalPanelOld));
const $422db1ffa8a289f3$export$709845d5f926bf24 = (0, $lqalZ.connect)(null, {
    renderApproverList: (0, $fYteL.refreshIssueRequest),
    updateApprovalLinkedUserPickerField: $iW1Wx.updateApprovalLinkedUserPickerField,
    setRefreshIssue: (0, $fYteL.refreshIssueRequest)
})((0, $hhl51.JSMApprovalPanel));
const $422db1ffa8a289f3$export$27b762cc02ce33d7 = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('convert-approvals-glance-to-collapsible-context-group_gqbgz'), $422db1ffa8a289f3$export$709845d5f926bf24, $422db1ffa8a289f3$export$2031fe8258a2c18);
const $422db1ffa8a289f3$export$71ac28de485b6c67 = (0, $lqalZ.connect)(null, {
    setRefreshIssue: (0, $fYteL.refreshIssueRequest)
})((0, $5ld5d.default));
const $422db1ffa8a289f3$export$11e17aad30e64f44 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "JSMApprovalGlancePanel",
        /* eslint-disable-next-line jira/js/package-name-enforcer-for-error-boundary */ packageName: "jiraIssueView",
        // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
        teamName: "jsm-getting-started",
        fallback: "unmount",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($422db1ffa8a289f3$export$989168bbffac33ef, props));
const $422db1ffa8a289f3$export$7bbd6594fd571776 = (props)=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    return projectType === (0, $7ZZxN.CORE_PROJECT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "JWMApprovalPanel",
        /* eslint-disable-next-line jira/js/package-name-enforcer-for-error-boundary */ packageName: "jiraIssueView",
        // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
        teamName: "wanjel",
        fallback: "unmount",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($422db1ffa8a289f3$export$71ac28de485b6c67, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "JSMApprovalPanel",
        /* eslint-disable-next-line jira/js/package-name-enforcer-for-error-boundary */ packageName: "jiraIssueView",
        // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
        teamName: "jsm-getting-started",
        fallback: "unmount",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($422db1ffa8a289f3$export$27b762cc02ce33d7, props));
};

});
parcelRegister("2fQNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $49b10ae9e903178e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $brySu = parcelRequire("brySu");

var $fCyzk = parcelRequire("fCyzk");

var $lO4Or = parcelRequire("lO4Or");

var $bFzGY = parcelRequire("bFzGY");

var $2oReF = parcelRequire("2oReF");

var $gCIFM = parcelRequire("gCIFM");

var $lVvc7 = parcelRequire("lVvc7");
/**
 * Convert Group Approver Principals to Multi-Group-Picker values.
 *
 * This converts the Approver principals into a format suitable for sending to the back-end. The
 * reason it uses `.flatMap()` instead of `.map()` is because Flow can’t tell that the output will
 * _only_ be group approvers. So we write the conversion in a format Flow can understand.
 *
 * @param {ApproverFieldValue | ReadOnlyArray<ApproverFieldValue> | ReadOnlyArray<GroupApproverPrincipal>} list A list of approvers.
 * @returns An array of multi-group-picker values.
 */ const $49b10ae9e903178e$var$convertGroupFieldValues = (list)=>{
    if (list == null) return [];
    const approvers = Array.isArray(list) ? list : [
        list
    ];
    return approvers.flatMap((approver)=>approver.type === 'group' && typeof approver.name === 'string' ? [
            {
                name: approver.name
            }
        ] : []);
};
/**
 * Filter out approvers that aren't single user values.
 *
 * This is a cludge to get Flow to recognise that the return value is purely a list of single
 * user approvers and doesn't contain any group approvers. The reason it uses `.flatMap()` instead
 * of `.map()` is because Flow can’t tell that the output will _only_ be user approvers. So we
 * write the conversion in a format Flow can understand.
 *
 * @param {ApproverFieldValue | ReadOnlyArray<ApproverFieldValue> | ReadOnlyArray<GroupApproverPrincipal>} list A list of approvers.
 * @returns Only the approvers that are single user picker values.
 */ const $49b10ae9e903178e$var$onlyUserApprovers = (list)=>{
    if (list == null) return null;
    // @ts-expect-error - TS2322 - Type 'readonly GroupApproverPrincipal[] | ApproverFieldValue | readonly ApproverFieldValue[]' is not assignable to type 'ApproverFieldValue | readonly ApproverFieldValue[] | null'.
    if (!Array.isArray(list)) return list;
    return list.flatMap((approver)=>approver.type === 'group' ? [] : [
            approver
        ]);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$49b10ae9e903178e$export$2e2bcd8739ae039 = (props)=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const portalElement = (0, $brySu.getIssueModalAkDropdownPortal)() || document.body;
    const [, { setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel }] = (0, $fCyzk.useIssueLayoutActions)();
    const approvalFieldId = props.payload && props.payload.approvalFieldId || (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE);
    const onHidePanel = (0, $eUqFw.useCallback)(()=>{
        setIssueViewLayoutContextPanel(issueKey, undefined);
    }, [
        issueKey,
        setIssueViewLayoutContextPanel
    ]);
    const onAddApproverError = (0, $eUqFw.useCallback)(()=>{
        showFlag({
            type: 'error',
            title: (0, $gCIFM.default).addApproverError
        });
    }, [
        showFlag
    ]);
    const onRemoveApproverError = (0, $eUqFw.useCallback)(()=>{
        showFlag({
            type: 'error',
            title: (0, $gCIFM.default).removeApproverError
        });
    }, [
        showFlag
    ]);
    const { approval: approval, linkedFieldId: linkedFieldId, saveLinkedFieldValue: saveLinkedFieldValue, autoCompleteUrl: autoCompleteUrl, isEditable: isEditable } = (0, $lVvc7.default)({
        issueKey: issueKey,
        approvalFieldId: approvalFieldId
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [statusFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.STATUS_TYPE)
    });
    const onApproverListUpdated = (newApproverList)=>{
        const fieldValues = approval?.configuration.approvers.type === 'multi_group_picker' ? $49b10ae9e903178e$var$convertGroupFieldValues(newApproverList) : $49b10ae9e903178e$var$onlyUserApprovers(newApproverList);
        Promise.all([
            saveLinkedFieldValue(fieldValues, null, createAnalyticsEvent({
                approverSourceFieldType: approval?.configuration.approvers.type
            })),
            Promise.resolve(// TODO - Keep redux + ss in sync. Remove when approvals multi-user-picker is extracted
            props.updateApprovalLinkedUserPickerField(linkedFieldId, newApproverList))
        ])// Once saveLinkedFieldValue() finishes, we need to trigger a background refresh so that
        // we can work out whether the current user is able to approve the request or not.
        // Ideally, we'd only request data for the servicedesk-approvals calculated field, but
        // at this particular location, we don't have a way to do that.
        .then(props.renderApproverList);
    };
    const approvalGlanceProps = {
        fieldId: linkedFieldId,
        fieldMetaKey: linkedFieldId,
        approval: approval,
        issueKey: issueKey,
        fieldAutoCompleteUrl: autoCompleteUrl ?? '',
        hasLinkedFieldEditPermissions: isEditable,
        issueStatusId: statusFieldValue.id,
        portalElement: portalElement,
        onRemoveApproverError: onRemoveApproverError,
        onAddApproverError: onAddApproverError,
        onHidePanel: onHidePanel,
        renderApproverList: props.renderApproverList,
        onApproverListUpdated: onApproverListUpdated
    };
    // @ts-expect-error - TS2322 - Type '{ fieldId: string; fieldMetaKey: string; approval: Approval | null; issueKey: string; fieldAutoCompleteUrl: string; hasLinkedFieldEditPermissions: boolean | undefined; issueStatusId: any; ... 5 more ...; onApproverListUpdated: (newApproverList: readonly GroupApproverPrincipal[] | ... 2 more ... | null) => void; }' is not assignable to type 'ApprovalGlancePanelProps'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2oReF.AsyncApprovalGlancePanel), approvalGlanceProps);
};

});
parcelRegister("brySu", function(module, exports) {

$parcel$export(module.exports, "getIssueModalAkDropdownPortal", () => $e2849714aa1f2f06$export$6385326f64887479);
$parcel$export(module.exports, "getIssueModalEditorDropdownPortal", () => $e2849714aa1f2f06$export$41b7e03648367f3c);
// These were copied across from src/packages/issue/issue-view/src/common/constants/index.tsx to avoid circular deps
const $e2849714aa1f2f06$export$bab98b619b4558be = 'issue-app-modal-ak-dropdown-portal';
const $e2849714aa1f2f06$export$2ec9dc4e52ec0b5d = 'issue-app-modal-editor-dropdown-portal';
const $e2849714aa1f2f06$export$6385326f64887479 = ()=>document.querySelector(`.${$e2849714aa1f2f06$export$bab98b619b4558be}`);
const $e2849714aa1f2f06$export$41b7e03648367f3c = ()=>document.querySelector(`.${$e2849714aa1f2f06$export$2ec9dc4e52ec0b5d}`);

});

parcelRegister("2oReF", function(module, exports) {

$parcel$export(module.exports, "AsyncApprovalPanel", () => $521c2d10c78e8ed2$export$e50b7230ae74f97e);
$parcel$export(module.exports, "AsyncApprovalGlancePanel", () => $521c2d10c78e8ed2$export$ea952cd5d2be58a4);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $h97Af = parcelRequire("h97Af");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $521c2d10c78e8ed2$var$Panel = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("5t9Wz")).then((exportedModule)=>exportedModule.ApprovalPanel), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/approval-panel/src/ui/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $521c2d10c78e8ed2$var$GlancePanel = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("5t9Wz")).then((exportedModule)=>exportedModule.ApprovalGlancePanel), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/approval-panel/src/ui/index.tsx"
});
const $521c2d10c78e8ed2$export$e50b7230ae74f97e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $87b668220903e931$export$2711a5ddda9be77a)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($521c2d10c78e8ed2$var$Panel, props));
const $521c2d10c78e8ed2$export$ea952cd5d2be58a4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "glance-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $87b668220903e931$export$b872fcbc2d3e17f5)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($521c2d10c78e8ed2$var$GlancePanel, props));

});
// Performance mark keys for approval panel.
const $87b668220903e931$export$c081fb77a4b68736 = 'servicedesk.approval-panel-load:';
const $87b668220903e931$export$2711a5ddda9be77a = `${$87b668220903e931$export$c081fb77a4b68736}start`;
const $87b668220903e931$export$3b4f712a55fbc256 = `${$87b668220903e931$export$c081fb77a4b68736}end`;
const $87b668220903e931$export$2c63d5e957d035ac = 'servicedesk.approval-glance-panel-load:';
const $87b668220903e931$export$b872fcbc2d3e17f5 = `${$87b668220903e931$export$2c63d5e957d035ac}start`;
const $87b668220903e931$export$9b75229be47baf11 = `${$87b668220903e931$export$2c63d5e957d035ac}end`;
const $87b668220903e931$export$7cba791a20c35c0c = 'custom_field';
const $87b668220903e931$export$6970b7f446ea00e5 = 'multi_group_picker';
const $87b668220903e931$export$2a3170603623dd77 = 'percent';
const $87b668220903e931$export$c13f2da236d97b51 = 'numberPerPrincipal';
const $87b668220903e931$export$c444e09421f4e38b = 'number';

parcelRegister("5t9Wz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jhe65');
        const value = parcelRequire('i0Yc0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jhe65").then(()=>parcelRequire('i0Yc0'));
}

});


parcelRegister("gCIFM", function(module, exports) {

$parcel$export(module.exports, "default", () => $da86e4d3d8b15de8$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $da86e4d3d8b15de8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removeApproverError: {
        "id": "issue-field-approval-panel.approval-glance.remove-approver-error",
        "defaultMessage": "We couldn\u2019t remove the approver"
    },
    addApproverError: {
        "id": "issue-field-approval-panel.approval-glance.add-approver-error",
        "defaultMessage": "We couldn\u2019t add the approver"
    },
    saveSuccess: {
        "id": "issue-field-approval-panel.approval-panel.save-success",
        "defaultMessage": "We've saved your response."
    },
    saveError: {
        "id": "issue-field-approval-panel.approval-panel.save-error",
        "defaultMessage": "We couldn\u2019t save your approval response"
    },
    saveConflictError: {
        "id": "issue-field-approval-panel.approval-panel.save-conflict-error",
        "defaultMessage": "An approval response has already been submitted for this issue"
    }
});

});

parcelRegister("lVvc7", function(module, exports) {

$parcel$export(module.exports, "default", () => $843b9e31461a643d$export$2e2bcd8739ae039);

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");

var $8tiYL = parcelRequire("8tiYL");
const $843b9e31461a643d$var$getApproval = (activeApproval, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
linkedFieldValue, title, linkedFieldType)=>{
    if (!activeApproval) return null;
    if (linkedFieldType == null) return {
        ...activeApproval,
        linkedFieldName: '',
        isSingleUserPicker: false
    };
    return (0, $8tiYL.getApprovalWithMergeApprovers)(activeApproval, linkedFieldValue, title, linkedFieldType);
};
const $843b9e31461a643d$var$useApprovalField = ({ issueKey: issueKey, approvalFieldId: approvalFieldId = (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE) })=>{
    // Approvers field value
    const [{ value: approvalValue }, { saveValue: saveApprovers }] = (0, $gGiWF.useEditField)({
        fieldKey: approvalFieldId,
        issueKey: issueKey,
        fieldType: (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE),
        initialValue: null
    });
    const activeApproval = approvalValue?.activeApproval;
    const activeConfiguration = activeApproval ? activeApproval.configuration : null;
    const linkedFieldId = activeConfiguration?.approvers.customFieldId ?? '';
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, linkedFieldId);
    const { isEditable: isEditable, title: title, autoCompleteUrl: autoCompleteUrl, schema: schema } = fieldConfig || {};
    const { custom: linkedFieldType } = schema || {};
    // Linked Field value
    // Approvals contains a linked field in the glance panel. This is the main value that is updated
    const [{ value: linkedFieldValue }, { saveValue: saveLinkedFieldValue }] = (0, $gGiWF.useEditField)({
        fieldKey: linkedFieldId,
        fieldType: linkedFieldId,
        issueKey: issueKey,
        initialValue: null
    });
    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    const approval = $843b9e31461a643d$var$getApproval(activeApproval, linkedFieldValue, title, linkedFieldType);
    return {
        approval: approval,
        isEditable: isEditable,
        saveApprovers: saveApprovers,
        saveLinkedFieldValue: saveLinkedFieldValue,
        linkedFieldId: linkedFieldId,
        autoCompleteUrl: autoCompleteUrl
    };
};
var $843b9e31461a643d$export$2e2bcd8739ae039 = $843b9e31461a643d$var$useApprovalField;

});
parcelRegister("8tiYL", function(module, exports) {

$parcel$export(module.exports, "getApprovalWithMergeApprovers", () => $4d095883b6173b4f$export$f1beb94a6cd862bc);

var $2KlF4 = parcelRequire("2KlF4");

var $2M1wI = parcelRequire("2M1wI");

var $hUrHq = parcelRequire("hUrHq");

var $23qRX = parcelRequire("23qRX");

var $lO4Or = parcelRequire("lO4Or");

var $gfK50 = parcelRequire("gfK50");

var $1V98A = parcelRequire("1V98A");
const $4d095883b6173b4f$var$GROUP_FIELD_TYPE = 'multi_group_picker';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4d095883b6173b4f$var$isVoid = (x)=>x === undefined;
const $4d095883b6173b4f$var$getOr = (dflt, path, obj)=>$4d095883b6173b4f$var$isVoid((0, (/*@__PURE__*/$parcel$interopDefault($2M1wI)))(path, obj)) ? dflt : (0, (/*@__PURE__*/$parcel$interopDefault($2M1wI)))(path, obj);
// intersectionBy() and differenceBy() are provided by lodash, but lodash loses the types. These
// versions preserve the type of the first array provided.
const $4d095883b6173b4f$var$intersectionBy = (f, as, bs)=>as.filter((a)=>bs.some((b)=>f(a) === f(b)));
const $4d095883b6173b4f$var$differenceBy = (f, xs, ys)=>xs.filter((x)=>!ys.some((y)=>f(x) === f(y)));
const $4d095883b6173b4f$export$1c8de577549309c0 = (approvers)=>{
    if (!Array.isArray(approvers)) return [];
    return approvers.flatMap((approver)=>typeof approver.name === 'string' && typeof approver.accountId === 'undefined' ? [
            {
                name: approver.name
            }
        ] : []);
};
const $4d095883b6173b4f$var$asApproverFieldValue = (approver)=>{
    // @ts-expect-error - TS2339 - Property 'accountId' does not exist on type 'ApproverFieldValue | GroupApproverFieldValue'. | TS2339 - Property 'displayName' does not exist on type 'ApproverFieldValue | GroupApproverFieldValue'.
    if (typeof approver.accountId === 'undefined' || typeof approver.displayName === 'undefined') return null;
    // @ts-expect-error - TS2339 - Property 'accountId' does not exist on type 'ApproverFieldValue | GroupApproverFieldValue'. | TS2339 - Property 'displayName' does not exist on type 'ApproverFieldValue | GroupApproverFieldValue'.
    const { accountId: accountId, displayName: displayName } = approver;
    return {
        ...approver,
        accountId: accountId,
        displayName: displayName
    };
};
const $4d095883b6173b4f$export$af3a322d4e925670 = (approvers)=>{
    if (approvers == null) return [];
    // @ts-expect-error - TS2322 - Type 'ApproverFieldValue | readonly ApproverFieldValue[] | readonly GroupApproverFieldValue[]' is not assignable to type 'ApproverFieldValue'.
    if (!Array.isArray(approvers)) return [
        approvers
    ];
    return approvers.map($4d095883b6173b4f$var$asApproverFieldValue).filter(Boolean);
};
const $4d095883b6173b4f$var$asGroupApprovers = (approvers)=>(0, $gfK50.toArray)(approvers).flatMap((x)=>x.type === 'group' ? [
            x
        ] : []);
const $4d095883b6173b4f$var$transformApproverFromUserPickerValue = ({ key: key, accountId: accountId, displayName: displayName, avatarUrls: avatarUrls })=>({
        approver: {
            accountId: accountId,
            key: key,
            displayName: displayName,
            isFromLinkedField: true,
            avatarUrl: $4d095883b6173b4f$var$getOr((0, (/*@__PURE__*/$parcel$interopDefault($1V98A))), '24x24', avatarUrls)
        }
    });
const $4d095883b6173b4f$var$transformApproverFromApproval = ({ approver: { key: key, accountId: accountId, displayName: displayName, avatarUrl: avatarUrl }, approverDecision: approverDecision })=>({
        approver: {
            accountId: accountId,
            key: key,
            displayName: displayName,
            avatarUrl: avatarUrl
        },
        approverDecision: approverDecision
    });
const $4d095883b6173b4f$var$markLinkedFieldApprovers = (principalsFromLinkedField, mergedApprovers)=>{
    const linkedFieldApproverIds = principalsFromLinkedField.map((approver)=>approver.approver.accountId);
    return mergedApprovers.map((approver)=>{
        if (linkedFieldApproverIds.includes(approver.approver.accountId)) return {
            approverDecision: approver.approverDecision,
            approver: {
                ...approver.approver,
                isFromLinkedField: true
            }
        };
        return approver;
    });
};
const $4d095883b6173b4f$var$mergeApprovers = (approversFromPendingApproval, principalsFromLinkedField, excludedApprovers = [])=>{
    const hasAccountId = (0, (/*@__PURE__*/$parcel$interopDefault($2KlF4)))(principalsFromLinkedField, (a)=>a.approver.accountId);
    const mergedApprovers = (0, (/*@__PURE__*/$parcel$interopDefault($hUrHq)))(approversFromPendingApproval, principalsFromLinkedField, // When update value of a user picker field, Bento only put username into the state, so if accountId is not present,
    // we use username to identify an user when merge
    (approverWithDecision)=>hasAccountId ? approverWithDecision.approver.accountId : null);
    const mergedApproversSansExclusions = mergedApprovers.filter((a)=>!excludedApprovers.some((e)=>e.accountId === a.approver.accountId));
    // preserving the isLinkedField if present in the linked Field
    return $4d095883b6173b4f$var$markLinkedFieldApprovers(principalsFromLinkedField, mergedApproversSansExclusions);
};
const $4d095883b6173b4f$var$getApprovalWithMergedApproversFromUserSelector = (approval, principalsFromLinkedField, linkedFieldName, linkedFieldType)=>{
    // Filter out the pending approvers from approval because they will be in linked user picker field if agents want
    // to keep them, otherwise that means they are removed. We keep the approvers returned from graphql when
    // approverDecision is approved/declined because when an approver has already approved/declined, remove him/her from
    // the linked user picker field won't remove the approval decision.
    const approversFromApproval = principalsFromLinkedField ? approval.approvers.filter((a)=>a.approverDecision !== (0, $23qRX.APPROVER_PENDING)) : approval.approvers;
    const transformedApproversFromApproval = approversFromApproval.map($4d095883b6173b4f$var$transformApproverFromApproval);
    const principals = principalsFromLinkedField && !Array.isArray(principalsFromLinkedField) ? [
        principalsFromLinkedField
    ] : principalsFromLinkedField;
    const transformedApproversFromLinkedUserPickerFieldValue = (principals ?? []).map($4d095883b6173b4f$var$transformApproverFromUserPickerValue);
    const mergedApprovers = $4d095883b6173b4f$var$mergeApprovers(transformedApproversFromApproval, transformedApproversFromLinkedUserPickerFieldValue, approval.excludedApprovers);
    const isSingleUserPicker = linkedFieldType === (0, $lO4Or.USER_CF_TYPE);
    const { id: id, name: name, finalDecision: finalDecision, canAnswerApproval: canAnswerApproval, decisions: decisions, approverPrincipals: approverPrincipals, excludedApprovers: excludedApprovers, approvalState: approvalState, approvedStatus: approvedStatus } = approval;
    return {
        id: id,
        name: name,
        finalDecision: finalDecision,
        approvers: mergedApprovers,
        canAnswerApproval: canAnswerApproval,
        linkedFieldName: linkedFieldName,
        isSingleUserPicker: isSingleUserPicker,
        decisions: (decisions || []).map($4d095883b6173b4f$var$transformApproverFromApproval),
        approverPrincipals: approverPrincipals,
        configuration: approval.configuration,
        pendingApprovalCount: approval.pendingApprovalCount,
        excludedApprovers: excludedApprovers,
        approvalState: approvalState,
        approvedStatus: approvedStatus
    };
};
const $4d095883b6173b4f$var$fieldValToGroupApprover = ({ name: name })=>({
        name: name,
        type: 'group',
        meta: {
            memberCount: NaN,
            approvedCount: NaN
        },
        id: undefined
    });
// Merge Group Approvers.
//
// We need this function because of the way updates to the global state work. When we update
// approvers using the approval-glance-panel, only the linked field is updated in state. The
// approverGroups field is left untouched with stale data. To get additional information about
// number of members, etc. we have to send a refresh request (this happens elsewhere). In the
// meantime we don't want to leave users hanging, so we make do as best we can with the values from
// the linked field.
const $4d095883b6173b4f$var$mergeGroupApprovers = (approverPrincipals, groupsFromLinkedField)=>{
    const approverGroups = approverPrincipals || [];
    // First we want to exclude any approver principals that ARE NOT in the linked field. This is
    // because our user may have deleted approver groups.
    // Next we want to add in any principals from the linked field that ARE NOT already in
    // the approval principals array. This is because our user may have added new approver groups.
    return [
        ...$4d095883b6173b4f$var$intersectionBy((0, (/*@__PURE__*/$parcel$interopDefault($2M1wI)))('name'), approverGroups, groupsFromLinkedField),
        ...$4d095883b6173b4f$var$differenceBy((0, (/*@__PURE__*/$parcel$interopDefault($2M1wI)))('name'), groupsFromLinkedField, approverGroups).map($4d095883b6173b4f$var$fieldValToGroupApprover)
    ];
};
const $4d095883b6173b4f$var$getApprovalWithMergedApproversFromGroupSelector = ({ id: id, name: name, finalDecision: finalDecision, approvers: approvers, configuration: configuration, canAnswerApproval: canAnswerApproval, decisions: decisions, approverPrincipals: approverPrincipals, pendingApprovalCount: pendingApprovalCount, excludedApprovers: excludedApprovers, approvalState: approvalState, approvedStatus: approvedStatus }, principalsFromLinkedField, linkedFieldName)=>({
        id: id,
        name: name,
        finalDecision: finalDecision,
        approvers: approvers.map($4d095883b6173b4f$var$transformApproverFromApproval),
        canAnswerApproval: canAnswerApproval,
        linkedFieldName: linkedFieldName,
        isSingleUserPicker: false,
        decisions: (decisions || []).map($4d095883b6173b4f$var$transformApproverFromApproval),
        approverPrincipals: $4d095883b6173b4f$var$mergeGroupApprovers($4d095883b6173b4f$var$asGroupApprovers(approverPrincipals), principalsFromLinkedField),
        pendingApprovalCount: pendingApprovalCount,
        configuration: configuration,
        excludedApprovers: excludedApprovers,
        approvalState: approvalState,
        approvedStatus: approvedStatus
    });
const $4d095883b6173b4f$export$f1beb94a6cd862bc = (approval, principalsFromLinkedField, linkedFieldName, linkedFieldType)=>approval.configuration.approvers.type !== $4d095883b6173b4f$var$GROUP_FIELD_TYPE ? $4d095883b6173b4f$var$getApprovalWithMergedApproversFromUserSelector(approval, $4d095883b6173b4f$export$af3a322d4e925670(principalsFromLinkedField), linkedFieldName, linkedFieldType) : $4d095883b6173b4f$var$getApprovalWithMergedApproversFromGroupSelector(approval, $4d095883b6173b4f$export$1c8de577549309c0(principalsFromLinkedField), linkedFieldName);

});
parcelRegister("2M1wI", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $20513f9d24db9b50$var$func = $jFIrw('get', (parcelRequire("illlw")));

$20513f9d24db9b50$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $20513f9d24db9b50$var$func;

});

parcelRegister("hUrHq", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");

var $7qARj = parcelRequire("7qARj");

var $9eFtX = parcelRequire("9eFtX");

var $42tFs = parcelRequire("42tFs");

var $cRpul = parcelRequire("cRpul");

var $iTvqy = parcelRequire("iTvqy");
/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ var $d09d27278857fdca$var$unionBy = $9eFtX(function(arrays) {
    var iteratee = $iTvqy(arrays);
    if ($cRpul(iteratee)) iteratee = undefined;
    return $42tFs($hKE3p(arrays, 1, $cRpul, true), $7qARj(iteratee, 2));
});
module.exports = $d09d27278857fdca$var$unionBy;

});

parcelRegister("gfK50", function(module, exports) {

$parcel$export(module.exports, "zeroApprovalRequired", () => $3847740a3eab3d8c$export$2620c7e56dc68d0);
$parcel$export(module.exports, "getApprovalConditionDescription", () => $3847740a3eab3d8c$export$5c16c3f0e3799d86);
$parcel$export(module.exports, "getApprovalWarningTitle", () => $3847740a3eab3d8c$export$b7b6aba8b0945297);
$parcel$export(module.exports, "getApprovalSummary", () => $3847740a3eab3d8c$export$e6bcb48318b9ff52);
$parcel$export(module.exports, "get", () => $3847740a3eab3d8c$export$3988ae62b71be9a3);
$parcel$export(module.exports, "assign", () => $3847740a3eab3d8c$export$e6e34fd1f2686227);
$parcel$export(module.exports, "toArray", () => $3847740a3eab3d8c$export$45b10814cc054894);
$parcel$export(module.exports, "compose2", () => $3847740a3eab3d8c$export$3f77d4ba3adcbe30);
$parcel$export(module.exports, "toError", () => $3847740a3eab3d8c$export$cc3b967c039ed3e7);
$parcel$export(module.exports, "withUIAnalyticsEvent", () => $3847740a3eab3d8c$export$27f5f19bc42d5e7b);

var $jMP2a = parcelRequire("jMP2a");


var $23qRX = parcelRequire("23qRX");
const $3847740a3eab3d8c$export$2620c7e56dc68d0 = (approval)=>approval.approvalState === (0, $23qRX.APPROVAL_OK) && approval.pendingApprovalCount === 0;
const $3847740a3eab3d8c$export$9fa9d451a57dbd4e = (approvalState, approversLength, approverPrincipalsLength, fieldType, fieldName, m, formatMessage)=>{
    if (fieldType === (0, $87b668220903e931$export$6970b7f446ea00e5)) switch(true){
        case approvalState === (0, $23qRX.APPROVAL_OK):
            return formatMessage(m.allConditionTypeGroupApprovers, {
                fieldName: fieldName
            });
        // Below are the cases where the approvalState !== OK and it is implied something is wrong
        case approverPrincipalsLength === 0:
            return formatMessage(m.allConditionTypeGroupApproversNoGroups, {
                fieldName: fieldName
            });
        // it may seem overkill to split the below into 2 messages, but cannot put multiple
        case approverPrincipalsLength === 1:
            return formatMessage(m.allConditionTypeGroupApproversInsufficientMembersOneGroup, {
                fieldName: fieldName
            });
        case approverPrincipalsLength > 1:
            // more that 1 group
            return formatMessage(m.allConditionTypeGroupApproversInsufficientMembersMultipleGroups, {
                fieldName: fieldName
            });
        default:
            // just return the approvalState === OK message
            return formatMessage(m.allConditionTypeGroupApprovers, {
                fieldName: fieldName
            });
    }
    else // fieldType === USER_FIELD_TYPE
    switch(true){
        case approvalState === (0, $23qRX.APPROVAL_OK):
            return formatMessage(m.allConditionType, {
                fieldName: fieldName
            });
        // Below are the cases where the approvalState !== OK and it is implied something is wrong
        case approversLength === 0:
            return formatMessage(m.allConditionTypeNoApprovers, {
                fieldName: fieldName
            });
        default:
            // just return the approvalState === OK message
            return formatMessage(m.allConditionType, {
                fieldName: fieldName
            });
    }
};
const $3847740a3eab3d8c$export$6c8a248eca0433b7 = (approvalState, approversLength, approverPrincipalsLength, fieldType, args, m, formatMessage)=>{
    if (fieldType === (0, $87b668220903e931$export$6970b7f446ea00e5)) switch(true){
        case approvalState === (0, $23qRX.APPROVAL_OK):
            return formatMessage(m.numberConditionTypeGroupApprovers, args);
        // Below are the cases where the approvalState !== OK and it is implied something is wrong
        // it may seem overkill to split the below into 2 messages, but cannot put multiple
        case approverPrincipalsLength === 0:
            return formatMessage(m.numberConditionTypeGroupApproversNoGroups, args);
        case approverPrincipalsLength > 0 && approversLength < Number(args.value):
            return formatMessage(m.numberConditionTypeGroupApproversInsufficientMembers, args);
        default:
            // just return the approvalState === OK message
            return formatMessage(m.numberConditionTypeGroupApprovers, args);
    }
    else // fieldType === USER_FIELD_TYPE
    switch(true){
        case approvalState === (0, $23qRX.APPROVAL_OK):
            return formatMessage(m.numberConditionType, args);
        // Below are the cases where the approvalState !== OK and it is implied something is wrong
        case approversLength === 0:
            return formatMessage(m.numberConditionTypeNoApprovers, args);
        case approversLength < Number(args.value):
            return formatMessage(m.numberConditionTypeInsufficientApprovers, args);
        default:
            // just return the approvalState === OK message
            return formatMessage(m.numberConditionType, args);
    }
};
const $3847740a3eab3d8c$export$258a5e300c0cf6df = (approvalState, approverPrincipalsLength, fieldName, args, m, formatMessage)=>{
    switch(true){
        case approvalState === (0, $23qRX.APPROVAL_OK):
            return formatMessage(m.nPerBagConditionType, args);
        // Below are the cases where the approvalState !== OK and it is implied something is wrong
        case approverPrincipalsLength === 0:
            return formatMessage(m.nPerBagConditionTypeNoGroups, args);
        // again, it may seem overkill to split the below into 2 messages, but cannot put multiple
        // plurals in one message due to the difficulty it creates localising
        case args.value === '1':
            return formatMessage(m.nPerBagConditionTypeNoMembers, {
                fieldName: fieldName
            });
        default:
            // rule is more than one person per bag
            return formatMessage(m.nPerBagConditionTypeInsufficientMembers, args);
    }
};
const $3847740a3eab3d8c$export$5c16c3f0e3799d86 = ({ approvalState: approvalState, configuration: configuration, approvers: approvers, approverPrincipals: approverPrincipals }, m, { formatMessage: formatMessage })=>{
    const fieldType = configuration.approvers.type;
    const fieldName = configuration.approvers.customFieldName;
    const conditionType = configuration.condition.type;
    const { value: value } = configuration.condition;
    const args = {
        value: value,
        fieldName: fieldName
    };
    switch(conditionType){
        case 0, $87b668220903e931$export$2a3170603623dd77:
            return $3847740a3eab3d8c$export$9fa9d451a57dbd4e(approvalState, approvers.length, approverPrincipals?.length ?? 0, fieldType, fieldName, m, formatMessage);
        case 0, $87b668220903e931$export$c444e09421f4e38b:
            return $3847740a3eab3d8c$export$6c8a248eca0433b7(approvalState, approvers.length, approverPrincipals?.length ?? 0, fieldType, args, m, formatMessage);
        default:
            // nPerBagConditionType
            return $3847740a3eab3d8c$export$258a5e300c0cf6df(approvalState, approverPrincipals?.length ?? 0, fieldName, args, m, formatMessage);
    }
};
const $3847740a3eab3d8c$export$b7b6aba8b0945297 = ({ approvalState: approvalState, configuration: configuration }, m, { formatMessage: formatMessage })=>{
    if (approvalState === (0, $23qRX.APPROVAL_OK)) return ''; // Assuming this should not happen
    const fieldType = configuration.approvers.type;
    const conditionType = configuration.condition.type;
    const { value: value } = configuration.condition;
    switch(conditionType){
        case 0, $87b668220903e931$export$2a3170603623dd77:
            switch(true){
                case fieldType !== (0, $87b668220903e931$export$6970b7f446ea00e5):
                    // approvers.length === 0 implied from condition not being OK
                    return formatMessage(m.addApproversWarning, {
                        value: 1
                    });
                default:
                    // Group field type
                    return formatMessage(m.updateApproverGroupsWarning);
            }
        case 0, $87b668220903e931$export$c444e09421f4e38b:
            switch(true){
                case fieldType !== (0, $87b668220903e931$export$6970b7f446ea00e5):
                    return formatMessage(m.addApproversWarning, {
                        value: value
                    });
                default:
                    // from group source
                    return formatMessage(m.updateApproverGroupsWarning);
            }
        default:
            // nPerBagConditionType
            // Group source warnings were simplified to 'Update', nPerBag can only be from group source.
            return formatMessage(m.updateApproverGroupsWarning);
    }
};
const $3847740a3eab3d8c$export$e6bcb48318b9ff52 = ({ pendingApprovalCount: pendingApprovalCount, approvalState: approvalState, configuration: configuration /* approvers */  }, canEditApprovers, messages, { formatMessage: formatMessage })=>{
    switch(true){
        case approvalState === (0, $23qRX.APPROVAL_OK) || configuration.condition.type === (0, $87b668220903e931$export$c444e09421f4e38b):
            return formatMessage(messages.waitingForApprovals, {
                pendingApprovalCount: pendingApprovalCount
            });
        default:
            return formatMessage(messages.waitingForApproval);
    }
};
const $3847740a3eab3d8c$export$3988ae62b71be9a3 = (key)=>(x)=>x[key];
const $3847740a3eab3d8c$export$ed97f33186d4b816 = (obj)=>Object.keys(obj);
const $3847740a3eab3d8c$export$e6e34fd1f2686227 = (a)=>(b)=>({
            ...a,
            ...b
        });
const $3847740a3eab3d8c$var$isArray = (a)=>Array.isArray(a);
const $3847740a3eab3d8c$export$45b10814cc054894 = (x)=>{
    if (x === null || x === undefined) return [];
    // @ts-expect-error - Type 'A & readonly (readonly A[] | (A & {}))[]' is not assignable to type 'readonly A[]'.
    if ($3847740a3eab3d8c$var$isArray(x)) /*              */ return x;
    // @ts-expect-error - Type 'readonly A[] | (A & {})' is not assignable to type 'A'.
    /* otherwise                    */ return [
        x
    ];
};
const $3847740a3eab3d8c$export$3f77d4ba3adcbe30 = (f, g)=>(x)=>f(g(x));
const $3847740a3eab3d8c$export$cc3b967c039ed3e7 = (e)=>e instanceof Error ? e : new Error(e);
const $3847740a3eab3d8c$export$27f5f19bc42d5e7b = (id, handler, fire)=>(uiEvent, analyticsEvent)=>{
        (fire || (0, $jMP2a.fireUIAnalytics))(analyticsEvent, id);
        return handler(uiEvent, analyticsEvent);
    };

});

parcelRegister("1V98A", function(module, exports) {
module.exports = new URL("default-avatar.8d6e3095.svg", import.meta.url).toString();

});




parcelRegister("hhl51", function(module, exports) {

$parcel$export(module.exports, "JSMApprovalPanelOld", () => $669b7763101d8815$export$d5d6c20f72b8ee65);
$parcel$export(module.exports, "JSMApprovalPanel", () => $669b7763101d8815$export$d050e10843d4f5da);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $brySu = parcelRequire("brySu");

var $fCyzk = parcelRequire("fCyzk");

var $lO4Or = parcelRequire("lO4Or");

var $bFzGY = parcelRequire("bFzGY");

var $2oReF = parcelRequire("2oReF");

var $gCIFM = parcelRequire("gCIFM");

var $lVvc7 = parcelRequire("lVvc7");
/**
 * Convert Group Approver Principals to Multi-Group-Picker values.
 * @param {ApproverFieldValue | ReadOnlyArray<ApproverFieldValue> | ReadOnlyArray<GroupApproverPrincipal>} list A list of approvers.
 * @returns An array of multi-group-picker values.
 */ const $669b7763101d8815$var$convertGroupFieldValues = (list)=>{
    if (list == null) return [];
    const approvers = Array.isArray(list) ? list : [
        list
    ];
    return approvers.filter((approver)=>approver.type === 'group' && typeof approver.name === 'string').map((approver)=>({
            name: approver.name
        }));
};
/**
 * Filter out approvers that aren't single user values.
 * @param {ApproverFieldValue | ReadOnlyArray<ApproverFieldValue> | ReadOnlyArray<GroupApproverPrincipal>} list A list of approvers.
 * @returns Only the approvers that are single user picker values.
 */ const $669b7763101d8815$var$onlyUserApprovers = (list)=>{
    if (list == null) return null;
    // @ts-expect-error - TS2322 - Type 'readonly GroupApproverPrincipal[] | ApproverFieldValue | readonly ApproverFieldValue[]' is not assignable to type 'ApproverFieldValue | readonly ApproverFieldValue[] | null'.
    if (!Array.isArray(list)) return list;
    return list.filter((approver)=>approver.type !== 'group');
};
const $669b7763101d8815$export$d5d6c20f72b8ee65 = (props)=>{
    const { setRefreshIssue: setRefreshIssue } = props;
    const issueKey = (0, $hJ992.useIssueKey)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const approvalFieldId = props.payload && props.payload.approvalFieldId || (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE);
    const [, { setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel }] = (0, $fCyzk.useIssueLayoutActions)();
    const onSaveApprovalAnswerSuccess = (0, $eUqFw.useCallback)(()=>{
        setRefreshIssue();
        showFlag({
            type: 'success',
            title: (0, $gCIFM.default).saveSuccess
        });
    }, [
        showFlag,
        setRefreshIssue
    ]);
    const onSaveApprovalAnswerError = (0, $eUqFw.useCallback)((refreshIssue)=>{
        if (refreshIssue) {
            setRefreshIssue();
            showFlag({
                type: 'error',
                title: (0, $gCIFM.default).saveConflictError
            });
        } else showFlag({
            type: 'error',
            title: (0, $gCIFM.default).saveError
        });
    }, [
        setRefreshIssue,
        showFlag
    ]);
    const onSaveApprovalAnswerErrorOld = (0, $eUqFw.useCallback)(()=>{
        showFlag({
            type: 'error',
            title: (0, $gCIFM.default).saveError
        });
    }, [
        showFlag
    ]);
    const onOpenPanel = (fieldId, title)=>{
        setIssueViewLayoutContextPanel(issueKey, {
            key: (0, $lO4Or.APPROVALS_PANEL_TYPE),
            type: (0, $lO4Or.APPROVALS_PANEL_TYPE),
            title: title,
            payload: {
                approvalFieldId: fieldId
            }
        });
    };
    const { approval: approval, isEditable: isEditable } = (0, $lVvc7.default)({
        issueKey: issueKey,
        approvalFieldId: approvalFieldId
    });
    // No need to render ApprovalPanel if there are no active approvals
    if (approval == null) return null;
    const approvalProps = {
        approval: approval,
        fieldId: approvalFieldId,
        hasLinkedFieldEditPermissions: isEditable,
        canCurrentUserApprove: approval.canAnswerApproval,
        onOpenPanel: onOpenPanel,
        onSaveApprovalAnswerSuccess: onSaveApprovalAnswerSuccess,
        onSaveApprovalAnswerError: (0, $1ybV0.ff)('improving-stale-jsm-approval-panel_9hkh2') ? onSaveApprovalAnswerError : onSaveApprovalAnswerErrorOld,
        onZeroApprovalRequired: setRefreshIssue
    };
    // @ts-expect-error - TS2322 - Type '{ approval: Approval; fieldId: string; hasLinkedFieldEditPermissions: boolean | undefined; canCurrentUserApprove: any; onOpenPanel: (fieldId: string, title: string) => void; onSaveApprovalAnswerSuccess: () => void; onSaveApprovalAnswerError: () => void; onZeroApprovalRequired: () => void; }' is not assignable to type 'ApprovalPanelProps'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2oReF.AsyncApprovalPanel), approvalProps);
};
const $669b7763101d8815$export$d050e10843d4f5da = (props)=>{
    const { setRefreshIssue: setRefreshIssue } = props;
    const issueKey = (0, $hJ992.useIssueKey)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const approvalFieldId = props.payload && props.payload.approvalFieldId || (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE);
    const [, { setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel }] = (0, $fCyzk.useIssueLayoutActions)();
    const onSaveApprovalAnswerSuccess = (0, $eUqFw.useCallback)(()=>{
        setRefreshIssue();
        showFlag({
            type: 'success',
            title: (0, $gCIFM.default).saveSuccess
        });
    }, [
        showFlag,
        setRefreshIssue
    ]);
    const onSaveApprovalAnswerError = (0, $eUqFw.useCallback)((refreshIssue)=>{
        if (refreshIssue) {
            setRefreshIssue();
            showFlag({
                type: 'error',
                title: (0, $gCIFM.default).saveConflictError
            });
        } else showFlag({
            type: 'error',
            title: (0, $gCIFM.default).saveError
        });
    }, [
        setRefreshIssue,
        showFlag
    ]);
    const onSaveApprovalAnswerErrorOld = (0, $eUqFw.useCallback)(()=>{
        showFlag({
            type: 'error',
            title: (0, $gCIFM.default).saveError
        });
    }, [
        showFlag
    ]);
    const onOpenPanel = (fieldId, title)=>{
        setIssueViewLayoutContextPanel(issueKey, {
            key: (0, $lO4Or.APPROVALS_PANEL_TYPE),
            type: (0, $lO4Or.APPROVALS_PANEL_TYPE),
            title: title,
            payload: {
                approvalFieldId: fieldId
            }
        });
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const portalElement = (0, $brySu.getIssueModalAkDropdownPortal)() || document.body;
    const onHidePanel = (0, $eUqFw.useCallback)(()=>{
        setIssueViewLayoutContextPanel(issueKey, undefined);
    }, [
        issueKey,
        setIssueViewLayoutContextPanel
    ]);
    const onAddApproverError = (0, $eUqFw.useCallback)(()=>{
        showFlag({
            type: 'error',
            title: (0, $gCIFM.default).addApproverError
        });
    }, [
        showFlag
    ]);
    const onRemoveApproverError = (0, $eUqFw.useCallback)(()=>{
        showFlag({
            type: 'error',
            title: (0, $gCIFM.default).removeApproverError
        });
    }, [
        showFlag
    ]);
    const { approval: approval, linkedFieldId: linkedFieldId, saveLinkedFieldValue: saveLinkedFieldValue, autoCompleteUrl: autoCompleteUrl, isEditable: isEditable } = (0, $lVvc7.default)({
        issueKey: issueKey,
        approvalFieldId: approvalFieldId
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [statusFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.STATUS_TYPE)
    });
    const onApproverListUpdated = (0, $eUqFw.useCallback)((newApproverList)=>{
        const fieldValues = approval?.configuration.approvers.type === 'multi_group_picker' ? $669b7763101d8815$var$convertGroupFieldValues(newApproverList) : $669b7763101d8815$var$onlyUserApprovers(newApproverList);
        Promise.all([
            saveLinkedFieldValue(fieldValues, null, createAnalyticsEvent({
                approverSourceFieldType: approval?.configuration.approvers.type
            })),
            Promise.resolve(// TODO - Keep redux + ss in sync. Remove when approvals multi-user-picker is extracted
            props.updateApprovalLinkedUserPickerField(linkedFieldId, newApproverList))
        ])// Once saveLinkedFieldValue() finishes, we need to trigger a background refresh so that
        // we can work out whether the current user is able to approve the request or not.
        // Ideally, we'd only request data for the servicedesk-approvals calculated field, but
        // at this particular location, we don't have a way to do that.
        .then(props.renderApproverList);
    }, [
        approval?.configuration.approvers.type,
        createAnalyticsEvent,
        linkedFieldId,
        props,
        saveLinkedFieldValue
    ]);
    // No need to render ApprovalPanel if there are no active approvals
    if (approval == null) return null;
    const approvalProps = {
        fieldId: linkedFieldId,
        fieldMetaKey: linkedFieldId,
        approval: approval,
        issueKey: issueKey,
        fieldAutoCompleteUrl: autoCompleteUrl ?? '',
        hasLinkedFieldEditPermissions: !!isEditable,
        issueStatusId: statusFieldValue.id,
        portalElement: portalElement,
        onRemoveApproverError: onRemoveApproverError,
        onAddApproverError: onAddApproverError,
        onHidePanel: onHidePanel,
        renderApproverList: props.renderApproverList,
        onApproverListUpdated: onApproverListUpdated,
        canCurrentUserApprove: approval.canAnswerApproval,
        onOpenPanel: onOpenPanel,
        onSaveApprovalAnswerSuccess: onSaveApprovalAnswerSuccess,
        onSaveApprovalAnswerError: (0, $1ybV0.ff)('improving-stale-jsm-approval-panel_9hkh2') ? onSaveApprovalAnswerError : onSaveApprovalAnswerErrorOld,
        onZeroApprovalRequired: setRefreshIssue
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2oReF.AsyncApprovalPanel), approvalProps);
};

});

parcelRegister("5ld5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $e654a76dc86ebca9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9U4Mi = parcelRequire("9U4Mi");

var $hJ992 = parcelRequire("hJ992");

var $lO4Or = parcelRequire("lO4Or");

var $lVvc7 = parcelRequire("lVvc7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e654a76dc86ebca9$export$2e2bcd8739ae039 = (props)=>{
    const { setRefreshIssue: setRefreshIssue } = props;
    const issueKey = (0, $hJ992.useIssueKey)();
    const approvalFieldId = props.payload && props.payload.approvalFieldId || (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE);
    const { approval: approval, isEditable: isEditable, saveLinkedFieldValue: saveLinkedFieldValue } = (0, $lVvc7.default)({
        issueKey: issueKey,
        approvalFieldId: approvalFieldId
    });
    // No need to render ApprovalPanel if there are no active approvals
    if (approval == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9U4Mi.default), {
        approval: approval,
        hasLinkedFieldEditPermissions: Boolean(isEditable),
        // A key is used to destroy and recreate the approval panel component when the approval step changes
        // This ensures the internal state is reset when using consecutive approval steps
        key: approval.id,
        onSaveLinkedFieldValue: saveLinkedFieldValue,
        setRefreshIssue: setRefreshIssue
    });
};

});
parcelRegister("9U4Mi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad86464ca1b7b93a$export$2e2bcd8739ae039);

var $cRG9R = parcelRequire("cRG9R");
var $ad86464ca1b7b93a$export$2e2bcd8739ae039 = (0, $cRG9R.default);

});
parcelRegister("cRG9R", function(module, exports) {

$parcel$export(module.exports, "default", () => $a46c5c271e0b1eaa$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a46c5c271e0b1eaa$var$ApprovalPanelComponent = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("h7lfQ")), {
    ssr: false,
    moduleId: "./src/packages/business/approvals/issue-view-panel/src/ui/index.tsx"
});
const $a46c5c271e0b1eaa$var$AsyncApprovalPanel = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "approvalsPanel",
        packageName: "jiraBusinessApprovalsIssueViewPanel",
        teamName: "wanjel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "approval-panel-component",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a46c5c271e0b1eaa$var$ApprovalPanelComponent, props)));
var $a46c5c271e0b1eaa$export$2e2bcd8739ae039 = $a46c5c271e0b1eaa$var$AsyncApprovalPanel;

});
parcelRegister("h7lfQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dj5QJ');
        const value = parcelRequire('5QujV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dj5QJ").then(()=>parcelRequire('5QujV'));
}

});





parcelRegister("du4hK", function(module, exports) {

$parcel$export(module.exports, "default", () => $14cbdfea72e3c107$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $14cbdfea72e3c107$var$SlaPanel = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("78c6U")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/sla-panel/src/index.tsx"
});
const $14cbdfea72e3c107$var$AsyncSlaPanel = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.sla.panel",
        packageName: "atlassian/jira-servicedesk-sla-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "sla-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($14cbdfea72e3c107$var$SlaPanel, null)));
var $14cbdfea72e3c107$export$2e2bcd8739ae039 = $14cbdfea72e3c107$var$AsyncSlaPanel;

});
parcelRegister("78c6U", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('ieB6y')
        ]);
        const value = parcelRequire('bgEFq');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("ieB6y")
    ]).then(()=>parcelRequire('bgEFq'));
}

});


parcelRegister("grHZ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4673196808c797a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $8yne0 = parcelRequire("8yne0");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $4ksts = parcelRequire("4ksts");

var $hJ992 = parcelRequire("hJ992");

var $8411R = parcelRequire("8411R");

var $64ypR = parcelRequire("64ypR");

var $4bZws = parcelRequire("4bZws");

var $73FRM = parcelRequire("73FRM");

var $hHKWU = parcelRequire("hHKWU");

var $iAc02 = parcelRequire("iAc02");

var $lXXLM = parcelRequire("lXXLM");

var $f9RL0 = parcelRequire("f9RL0");

var $lqalZ = parcelRequire("lqalZ");

var $hSjJg = parcelRequire("hSjJg");

var $fokFV = parcelRequire("fokFV");

var $cY77j = parcelRequire("cY77j");

var $bMnlH = parcelRequire("bMnlH");

var $gyN16 = parcelRequire("gyN16");
const $a4673196808c797a$export$393edc798c47379d = (props)=>{
    const { area: area = (0, $73FRM.CONTEXT), fieldId: fieldId, hasDraft: hasDraft, isEditing: isEditing, isWaiting: isWaiting, onExperienceSuccess: onExperienceSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) } = props;
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ value: value }] = (0, $8411R.useFieldConfig)(issueKey, (0, $f9RL0.DESCRIPTION));
    const label = value?.title;
    const intl = (0, $4ksts.useIntlV2)();
    const HeadingWrapper = area === (0, $73FRM.CONTENT) ? (0, $iAc02.SectionHeading) : (0, $64ypR.MultilineFieldHeading);
    const HeadingTitle = area === (0, $73FRM.CONTENT) ? (0, $iAc02.SectionHeadingTitle) : (0, $64ypR.MultilineFieldHeadingTitle);
    const showPinButton = (0, $hHKWU.default)(area);
    const [, { updateSidebarMinWidth: updateSidebarMinWidth, resetSidebarMinWidth: resetSidebarMinWidth }] = (0, $hSjJg.useIssueLayout)();
    (0, $eUqFw.useEffect)(()=>{
        if (area === (0, $73FRM.CONTEXT)) {
            if (isEditing === true) {
                updateSidebarMinWidth((0, $hSjJg.MIN_EDITOR_SIDEBAR_CONTAINER_WIDTH));
                return;
            }
            resetSidebarMinWidth();
        }
    }, [
        isEditing,
        area,
        updateSidebarMinWidth,
        resetSidebarMinWidth
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onExperienceSuccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bMnlH.TextareaWrapperWithoutMargin), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeadingWrapper, {
        "data-testid": "issue-view-base.common.description.heading-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.HeadingWithDraft), {
        "data-testid": "issue-view-base.common.description.heading-with-draft"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeadingTitle, {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.issue-base.common.description.label"
    }, label), hasDraft && !isEditing && !isWaiting ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.DraftIndicator), {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.issue-base.common.description.draft-indicator",
        "aria-label": intl.formatMessage((0, $lXXLM.default).draftIndicator)
    }, `\u{2022} ${intl.formatMessage((0, $lXXLM.default).draftIndicator)}`) : null, showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldId,
        label: label
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gyN16.default), null));
};
const $a4673196808c797a$var$DescriptionWrapper = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        prefixOverride: "issue",
        id: "Description"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), {
        location: "description-container"
    }, ({ onExperienceSuccess: onExperienceSuccess })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a4673196808c797a$export$393edc798c47379d, {
            onExperienceSuccess: onExperienceSuccess,
            ...props
        })));
var $a4673196808c797a$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state)=>({
        hasDraft: (0, $cY77j.fieldHasDraftSelector)((0, $f9RL0.DESCRIPTION))(state),
        isEditing: (0, $fokFV.isFieldEditingSelector)((0, $f9RL0.DESCRIPTION))(state),
        isWaiting: (0, $fokFV.isFieldWaitingSelector)((0, $f9RL0.DESCRIPTION))(state)
    }), {})($a4673196808c797a$var$DescriptionWrapper);

});
parcelRegister("4bZws", function(module, exports) {

$parcel$export(module.exports, "FieldPin", () => $39fd12aa6c79d613$export$ac23b3f2cf393875);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $hJ992 = parcelRequire("hJ992");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7h6vQ = parcelRequire("7h6vQ");

var $iED9L = parcelRequire("iED9L");

var $a7Tjf = parcelRequire("a7Tjf");

var $uo395 = parcelRequire("uo395");
const $39fd12aa6c79d613$export$ac23b3f2cf393875 = (props)=>{
    const { fieldId: fieldId, label: label = '' } = props;
    const issueKey = (0, $hJ992.useIssueKey)();
    const [pinnedFields, setPinnedFields] = (0, $uo395.usePinnedFields)(issueKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const dispatchPinnedFieldAnalytics = ({ isPinned: isPinned, newPinnedFieldLength: newPinnedFieldLength, pinnedFieldPosition: pinnedFieldPosition, setPinSuccess: setPinSuccess, savedFieldIdLength: savedFieldIdLength, fieldName: fieldName })=>{
        const payload = {
            isPinned: isPinned,
            newPinnedFieldCount: newPinnedFieldLength,
            pinnedFieldPosition: pinnedFieldPosition,
            setPinSuccess: setPinSuccess,
            savedFieldIdLength: savedFieldIdLength,
            ...(0, $7h6vQ.isSortingPinnedFieldsEnabled)() ? {
                fieldName: fieldName
            } : {}
        };
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'pinnedFieldButton'
        });
        (0, $jMP2a.fireUIAnalytics)(event, 'pinnedFields', payload);
    };
    // Without the issueKey, there is not point pinning the field, as we won't know the project key either.
    // The code block has to be after the hook ^
    if (!issueKey) return null;
    const isPinned = (0, $uo395.isFieldPinned)(pinnedFields, fieldId);
    const userHasPinnedFields = (0, $7h6vQ.isSortingPinnedFieldsEnabled)() ? pinnedFields.length > 0 : undefined;
    const onClick = ()=>{
        const clonedPinnedFields = [
            ...pinnedFields
        ];
        let pinnedFieldIndex = -1;
        if (isPinned) {
            // Unpin the field
            pinnedFieldIndex = clonedPinnedFields.indexOf(fieldId);
            clonedPinnedFields.splice(pinnedFieldIndex, 1);
        } else // Pin the field
        clonedPinnedFields.push(fieldId);
        const setPinSuccess = setPinnedFields(clonedPinnedFields);
        dispatchPinnedFieldAnalytics({
            isPinned: !isPinned,
            newPinnedFieldLength: clonedPinnedFields.length,
            pinnedFieldPosition: isPinned ? pinnedFieldIndex : clonedPinnedFields.indexOf(fieldId),
            setPinSuccess: setPinSuccess,
            savedFieldIdLength: (0, $uo395.encodePinnedFields)(clonedPinnedFields).length,
            ...(0, $7h6vQ.isSortingPinnedFieldsEnabled)() ? {
                fieldName: label
            } : {}
        });
        if (!isPinned) showFlag(setPinSuccess ? {
            type: 'success',
            title: [
                (0, $a7Tjf.default).fieldPinned,
                {
                    fieldLabel: label
                }
            ]
        } : {
            title: (0, $a7Tjf.default).errorTooManyPinnedTitle,
            description: (0, $7h6vQ.isSortingPinnedFieldsEnabled)() ? (0, $a7Tjf.default).errorTooManyPinnedDescription : (0, $a7Tjf.default).errorTooManyPinnedText,
            type: 'error'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iED9L.default), {
        label: label,
        onClick: onClick,
        isPinned: isPinned,
        hasPinnedFields: userHasPinnedFields
    });
};

});

parcelRegister("73FRM", function(module, exports) {

$parcel$export(module.exports, "CONTEXT", () => $5cb55325c16dafaa$export$64368ce5f5cfe139);
$parcel$export(module.exports, "CONTENT", () => $5cb55325c16dafaa$export$d1213e82613ff4df);
$parcel$export(module.exports, "CONTENT_REQUEST", () => $5cb55325c16dafaa$export$1e1b674d57cd6ef8);
$parcel$export(module.exports, "TAB_PANEL", () => $5cb55325c16dafaa$export$1bc1faf0ee61fa47);
const $5cb55325c16dafaa$export$64368ce5f5cfe139 = 'context';
const $5cb55325c16dafaa$export$d1213e82613ff4df = 'content';
const $5cb55325c16dafaa$export$1e1b674d57cd6ef8 = 'content-request';
const $5cb55325c16dafaa$export$f41ea57e4bf69bb4 = 'foundation';
const $5cb55325c16dafaa$export$1bc1faf0ee61fa47 = 'tab-panel';

});

parcelRegister("hHKWU", function(module, exports) {

$parcel$export(module.exports, "default", () => $934c772abcd2bbe6$export$2e2bcd8739ae039);

var $73FRM = parcelRequire("73FRM");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$934c772abcd2bbe6$export$2e2bcd8739ae039 = (area)=>area === (0, $73FRM.CONTEXT);

});

parcelRegister("lXXLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bebdf69419c1e32$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $5bebdf69419c1e32$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    draftIndicator: {
        "id": "issue.draft-indicator-for-multiline-field",
        "defaultMessage": "Unsaved changes"
    }
});

});

parcelRegister("bMnlH", function(module, exports) {

$parcel$export(module.exports, "TextareaWrapperWithoutMargin", () => $7dc588282472fa83$export$252d6de3f21ff929);
$parcel$export(module.exports, "default", () => $7dc588282472fa83$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5iWql = parcelRequire("5iWql");

var $lRmyA = parcelRequire("lRmyA");

var $4ksts = parcelRequire("4ksts");

var $9LvPd = parcelRequire("9LvPd");

var $64ypR = parcelRequire("64ypR");

var $4bZws = parcelRequire("4bZws");

var $cEDU9 = parcelRequire("cEDU9");

var $0NycV = parcelRequire("0NycV");

var $73FRM = parcelRequire("73FRM");

var $brySu = parcelRequire("brySu");

var $hHKWU = parcelRequire("hHKWU");

var $lBMPF = parcelRequire("lBMPF");

var $3uwfp = parcelRequire("3uwfp");

var $iAc02 = parcelRequire("iAc02");

var $lXXLM = parcelRequire("lXXLM");

var $hSjJg = parcelRequire("hSjJg");

var $cp79T = parcelRequire("cp79T");

var $hG9XE = parcelRequire("hG9XE");

var $kzOoN = parcelRequire("kzOoN");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $gS8e9 = parcelRequire("gS8e9");

var $cY77j = parcelRequire("cY77j");

var $40QX1 = parcelRequire("40QX1");

var $1TrR5 = parcelRequire("1TrR5");

var $323Nh = parcelRequire("323Nh");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7dc588282472fa83$var$performPut = (baseUrl, issueKey, fieldId, value)=>{
    const url = `${baseUrl}/rest/api/3/issue/${issueKey}`;
    return (0, $lRmyA.performPutRequest)(url, {
        body: JSON.stringify({
            fields: {
                [fieldId]: value
            }
        })
    });
};
const $7dc588282472fa83$export$b6085e1a20ac144a = (props)=>{
    const { label: label, area: area, hasDraft: hasDraft, isEditing: isEditing, containerWidth: containerWidth, issueKey: issueKey, ...otherProps } = props;
    const intl = (0, $4ksts.useIntlV2)();
    const shouldShowDraftIndicator = hasDraft && !isEditing;
    const HeadingWrapper = area === (0, $73FRM.CONTENT) ? (0, $iAc02.SectionHeading) : (0, $64ypR.MultilineFieldHeading);
    const HeadingTitle = area === (0, $73FRM.CONTENT) ? (0, $iAc02.SectionHeadingTitle) : (0, $64ypR.MultilineFieldHeadingTitle);
    const showPinButton = (0, $hHKWU.default)(area);
    const [, { updateSidebarMinWidth: updateSidebarMinWidth, resetSidebarMinWidth: resetSidebarMinWidth }] = (0, $hSjJg.useIssueLayout)();
    (0, $eUqFw.useEffect)(()=>{
        if (area === (0, $73FRM.CONTEXT)) {
            if (isEditing === true) {
                updateSidebarMinWidth((0, $hSjJg.MIN_EDITOR_SIDEBAR_CONTAINER_WIDTH));
                return;
            }
            resetSidebarMinWidth();
        }
    }, [
        isEditing,
        area,
        updateSidebarMinWidth,
        resetSidebarMinWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dc588282472fa83$export$252d6de3f21ff929, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.HeadingWithDraft), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeadingTitle, {
        "data-testid": `issue.views.issue-base.common.${props.fieldId}.label`
    }, label), shouldShowDraftIndicator === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.DraftIndicator), null, `\u{2022} ${intl.formatMessage((0, $lXXLM.default).draftIndicator)}`) : null, issueKey !== undefined && props.fieldId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: props.fieldId,
        label: label
    }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: props.fieldId,
        label: label
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEDU9.default), {
        isEditing: isEditing,
        label: label,
        ...otherProps
    }));
};
const $7dc588282472fa83$var$additionalCallbacksMemo = (0, $5iWql.default)((dispatch)=>({
        onExpandedFailure: ()=>dispatch((0, $hG9XE.editorExpandedFailure)()),
        onSaveFailure: ()=>dispatch((0, $hG9XE.editorSaveFailure)()),
        onChangeFailure: ()=>dispatch((0, $hG9XE.editorChangeFailure)())
    }));
var $7dc588282472fa83$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        shouldSaveDraft: true,
        // See: https://jdog.jira-dev.com/browse/BENTO-631
        isOptimistic: true,
        saveField: ({ baseUrl: baseUrl, issueKey: issueKey, value: value })=>$7dc588282472fa83$var$performPut(baseUrl, issueKey, ownPropsOnMount.fieldId, value),
        canContainMediaContent: true,
        onSaveFailureFlagType: (0, $0NycV.RICH_CONTENT_FIELD_CONFIRM_ERROR),
        // @ts-expect-error - TS2322 - Type '(state: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, intl: IntlShapeV2) => { ...' is not assignable to type 'AdditionalProps<unknown>'.
        additionalProps: (state, intl)=>{
            const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
            return {
                baseUrl: baseUrl,
                portalElement: (0, $40QX1.isFieldInTabSelector)(ownPropsOnMount.fieldId)(state) ? // Using a portal element here because otherwise dropdowns would get cut off
                // See: https://jdog.jira-dev.com/browse/BENTO-4100
                (0, $brySu.getIssueModalEditorDropdownPortal)() || document.body : undefined,
                adfValue: (0, $fokFV.fieldEditingAdfValueSelector)(ownPropsOnMount.fieldId)(state),
                hasDraft: (0, $cY77j.fieldHasDraftSelector)(ownPropsOnMount.fieldId)(state),
                htmlValue: (0, $fokFV.fieldHtmlValueSelector)(ownPropsOnMount.fieldId)(state),
                isInvalid: (0, $fokFV.fieldInvalidSelector)(ownPropsOnMount.fieldId)(state),
                invalidMessage: (0, $fokFV.fieldInvalidMessageSelector)(ownPropsOnMount.fieldId)(state),
                mediaContext: (0, $gS8e9.mediaContextSelector)(state),
                mentionProvider: (0, $cp79T.mentionProviderSelector)(state),
                activityProvider: (0, $kzOoN.activityProviderSelector)(state),
                externalId: `issue.${ownPropsOnMount.fieldId}`,
                noValueText: intl.formatMessage((0, $323Nh.messages).noValueText),
                area: ownPropsOnMount.area
            };
        },
        // @ts-expect-error - TS2345 - memoized additionalCallbacks types incompatiblity
        additionalCallbacks: (0, $1TrR5.functionWithFFRedux)($7dc588282472fa83$var$additionalCallbacksMemo, (dispatch)=>({
                onExpandedFailure: ()=>dispatch((0, $hG9XE.editorExpandedFailure)()),
                onSaveFailure: ()=>dispatch((0, $hG9XE.editorSaveFailure)()),
                onChangeFailure: ()=>dispatch((0, $hG9XE.editorChangeFailure)())
            }))
    }))((0, $lBMPF.default)($7dc588282472fa83$export$b6085e1a20ac144a));
const $7dc588282472fa83$export$252d6de3f21ff929 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1runpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9LvPd", function(module, exports) {

$parcel$export(module.exports, "FieldDescription", () => $715d23e167cf7f8b$export$873ced4623a3149c);

var $eUqFw = parcelRequire("eUqFw");

var $8411R = parcelRequire("8411R");

var $iNF54 = parcelRequire("iNF54");

var $15sFp = parcelRequire("15sFp");

var $fPfMJ = parcelRequire("fPfMJ");
const $715d23e167cf7f8b$export$873ced4623a3149c = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, fieldKey: fieldKey, label: label = '' })=>{
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const [adfDescription, setAdfDescription] = (0, $eUqFw.useState)(null);
    const fieldDescription = fieldConfig?.description || null;
    (0, $eUqFw.useEffect)(()=>{
        fieldDescription && (0, $iNF54.convertWikiToAdfAsync)(fieldDescription).then((convertedAdfValue)=>{
            setAdfDescription(convertedAdfValue);
        });
    }, [
        fieldDescription
    ]);
    if (!adfDescription) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fPfMJ.FieldDescriptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fPfMJ.default), {
        adfDescription: adfDescription,
        label: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15sFp.default), null)));
});
var $715d23e167cf7f8b$export$2e2bcd8739ae039 = $715d23e167cf7f8b$export$873ced4623a3149c;

});

parcelRegister("cEDU9", function(module, exports) {

$parcel$export(module.exports, "default", () => $32d019412088dae0$export$2e2bcd8739ae039);
/* rich-text-inline-edit-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $2gGF1 = parcelRequire("2gGF1");

var $1ybV0 = parcelRequire("1ybV0");

var $iSAvW = parcelRequire("iSAvW");
var $lFWFO = parcelRequire("lFWFO");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $78fR1 = parcelRequire("78fR1");

var $Jptg5 = parcelRequire("Jptg5");

var $7Vbpp = parcelRequire("7Vbpp");

var $9zKvO = parcelRequire("9zKvO");

var $lBM0g = parcelRequire("lBM0g");
const $32d019412088dae0$var$containerSelectorName = 'jira-issue-view-rich-text-inline-edit-view-container';
const $32d019412088dae0$var$CONTAINER_COMPONENT_SELECTOR = `[data-component-selector="${$32d019412088dae0$var$containerSelectorName}"]`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $32d019412088dae0$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $32d019412088dae0$var$nonEditableStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $32d019412088dae0$var$InlineEditContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1bohx0bf _a4q3x0bf _1gzc1txw _auuz1h6o _1o4r1hna _osjgidpf _alyvidpf _pa3x12x7 _2g9b12x7",
            !__cmplp.isEditable && "_13y21txw _7wl71bp4 _uos01h6o _g9m51hna _fz1rusvi _h98av77o _ucrdv77o _7sty12x7 _b42yu2gc _7p85x0bf _1evfxmi2 _1o5szwfg",
            __cmplp.className
        ])
    });
});
const $32d019412088dae0$export$3314179b18ad6595 = ({ isEditable: isEditable = false, isEditing: isEditing = false, isMobile: isMobile = false, label: label = '', adfValue: adfValue, contextIdentifier: contextIdentifier, onExperienceSuccess: onExperienceSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), fieldId: fieldId, portalElement: portalElement, baseUrl: baseUrl, mediaContext: mediaContext, mentionProvider: mentionProvider, mentionEncoder: mentionEncoder, activityProvider: activityProvider, externalId: externalId, noValueText: noValueText, editorActionsRef: editorActionsRef, onEditRequest: onEditRequest, onCancel: onCancel, onConfirm: onConfirm, onChange: onChange, onBlur: onBlur, onSaveFailure: onSaveFailure, onChangeFailure: onChangeFailure, onPaste: onPaste, onViewRefresh: onViewRefresh, onUploadRefresh: onUploadRefresh })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [readViewRef, setReadViewRef] = (0, $eUqFw.useState)({
        current: null
    });
    const readViewRefCallback = (0, $eUqFw.useCallback)((node)=>setReadViewRef({
            current: node
        }), []);
    const mouseDownSelection = (0, $eUqFw.useRef)(null);
    const issueKey = (0, $hJ992.useIssueKey)();
    if ((0, $1ybV0.ff)('feature.reading-aid-in-issue-description')) {
        if ((0, $1ybV0.ff)('jira-reading-aid-acronyms-highlight_3hr5i')) {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const { highlightAcronyms: highlightAcronyms, resetAcronymsData: resetAcronymsData } = (0, $iSAvW.useAcronymHighlighter)(readViewRef); // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $eUqFw.useEffect)(()=>{
                if (fieldId === 'description') {
                    if (readViewRef.current) {
                        highlightAcronyms(adfValue);
                        return resetAcronymsData;
                    }
                }
            }, [
                adfValue,
                fieldId,
                highlightAcronyms,
                readViewRef,
                resetAcronymsData
            ]);
        } // eslint-disable-next-line react-hooks/rules-of-hooks
        const { register: register, unregister: unregister } = (0, $lFWFO.useOnHighlight)(readViewRef); // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eUqFw.useEffect)(()=>{
            if (fieldId === 'description') {
                if (!isEditing) register();
                return unregister;
            }
        }, [
            unregister,
            register,
            isEditing,
            fieldId
        ]);
    }
    const [onExperienceSuccessInState] = (0, $eUqFw.useState)(()=>onExperienceSuccess);
    (0, $eUqFw.useEffect)(()=>{
        onExperienceSuccessInState();
    }, [
        onExperienceSuccessInState
    ]);
    const onMouseDownEditView = (0, $eUqFw.useCallback)(()=>{
        // When the user is deselecting text on the screen by clicking,
        // by the time the onclick handler is called the window.getSelection() value will already be cleared.
        // mousedown callback is called before the selection is cleared.
        mouseDownSelection.current = window?.getSelection()?.toString();
    }, []);
    const onEditRequested = (0, $eUqFw.useCallback)(()=>{
        const selection = window?.getSelection()?.toString();
        const hasSelection = selection && selection.length !== 0; // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const hasSelectionMouseDown = mouseDownSelection.current?.length !== 0;
        if (!hasSelection && !hasSelectionMouseDown) onEditRequest();
    }, [
        onEditRequest
    ]);
    const getEditValue = (0, $eUqFw.useCallback)(()=>adfValue, [
        adfValue
    ]);
    const addContentButtonLabel = (0, $2gGF1.default).addButtonLabel;
    const editContentButtonLabel = (0, $2gGF1.default).editButtonLabel;
    const [editButtonLabel, setEditButtonLabel] = (0, $eUqFw.useState)(addContentButtonLabel);
    const isDynamicEditButtonLabelEnabled = (0, $1ybV0.ff)('a11y-jira-team-enable-dynamic-edit-button-label-for-issue-field_mpv9f');
    const updateLabel = (0, $eUqFw.useCallback)((contentLength)=>{
        if (!contentLength) {
            setEditButtonLabel(addContentButtonLabel);
            return;
        }
        if (editButtonLabel === editContentButtonLabel) return;
        setEditButtonLabel(editContentButtonLabel);
    }, [
        editButtonLabel,
        addContentButtonLabel,
        editContentButtonLabel
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isDynamicEditButtonLabelEnabled) updateLabel(getEditValue()?.content?.length);
    }, [
        getEditValue,
        updateLabel,
        isDynamicEditButtonLabelEnabled
    ]);
    const renderContent = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($32d019412088dae0$var$Container, {
            "data-component-selector": $32d019412088dae0$var$containerSelectorName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Jptg5.default), {
            key: `issue-${issueKey}-field-${fieldId}-renderer-with-media-provider`,
            mediaContext: mediaContext,
            onViewRefresh: onViewRefresh,
            onUploadRefresh: onUploadRefresh,
            mentionProvider: mentionProvider,
            contextIdentifier: contextIdentifier,
            adf: (0, $7Vbpp.removeNewLineCharactersFromAdf)(adfValue),
            placeholder: isEditable ? noValueText : formatMessage((0, $9zKvO.default).nonEditablePlaceholderText)
        })), [
        adfValue,
        contextIdentifier,
        fieldId,
        formatMessage,
        issueKey,
        isEditable,
        mediaContext,
        mentionProvider,
        noValueText,
        onUploadRefresh,
        onViewRefresh
    ]);
    const renderReadView = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            onMouseDown: onMouseDownEditView,
            role: "presentation",
            "data-testid": `issue.views.field.rich-text.${fieldId}`,
            ...(0, $1ybV0.ff)('feature.reading-aid-in-issue-description') && fieldId === 'description' ? {
                ref: readViewRefCallback
            } : {}
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($32d019412088dae0$var$InlineEditContainer, {
            isEditable: isEditable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78fR1.default), {
            readView: renderContent || null,
            isEditing: false,
            isEditable: isEditable,
            editButtonLabel: formatMessage((0, $1ybV0.ff)('a11y-jira-team-enable-dynamic-edit-button-label-for-issue-field_mpv9f') ? editButtonLabel : (0, $2gGF1.default).editButtonLabel, {
                fieldName: label
            }),
            confirmButtonLabel: formatMessage((0, $2gGF1.default).confirmButtonLabel, {
                fieldName: label
            }),
            cancelButtonLabel: formatMessage((0, $2gGF1.default).cancelButtonLabel, {
                fieldName: label
            }),
            onEdit: onEditRequested,
            // if field is editable otherwise it should be undefined
            editView: isEditable ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null) : null,
            // but we are only interested in the read view and hover+click to edit
            onConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            readViewFitContainerWidth: !isMobile
        }))), [
        editButtonLabel,
        fieldId,
        formatMessage,
        isEditable,
        isMobile,
        label,
        readViewRefCallback,
        onEditRequested,
        onMouseDownEditView,
        renderContent
    ]);
    const renderEditView = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lBM0g.default), {
            baseUrl: baseUrl,
            mediaContext: mediaContext,
            onViewRefresh: onViewRefresh,
            onUploadRefresh: onUploadRefresh,
            portalElement: portalElement,
            mentionProvider: mentionProvider,
            mentionEncoder: mentionEncoder,
            contextIdentifier: contextIdentifier,
            activityProvider: activityProvider,
            externalId: externalId,
            // most likely reached this scenario: https://jdog.jira-dev.com/browse/BENTO-2012
            // This means we block the editor from being touched until a page refresh
            isDisabled: undefined,
            editorActionsRef: editorActionsRef,
            isExpanded: true,
            shouldFocus: true,
            value: getEditValue(),
            onCancel: onCancel,
            onChange: onChange,
            onBlur: onBlur,
            onSave: onConfirm,
            onSaveFailure: onSaveFailure,
            onChangeFailure: onChangeFailure,
            onPaste: onPaste,
            assistiveLabel: label
        }), [
        activityProvider,
        baseUrl,
        contextIdentifier,
        editorActionsRef,
        externalId,
        getEditValue,
        label,
        mediaContext,
        mentionEncoder,
        mentionProvider,
        onBlur,
        onCancel,
        onChange,
        onChangeFailure,
        onConfirm,
        onPaste,
        onSaveFailure,
        onUploadRefresh,
        onViewRefresh,
        portalElement
    ]);
    return isEditing ? renderEditView() : renderReadView();
};
$32d019412088dae0$export$3314179b18ad6595.displayName = 'RichTextInlineEditView';
var $32d019412088dae0$export$2e2bcd8739ae039 = $32d019412088dae0$export$3314179b18ad6595;

});
parcelRegister("2gGF1", function(module, exports) {

$parcel$export(module.exports, "default", () => $14f580392b8b6f26$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $14f580392b8b6f26$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    confirmButtonLabel: {
        "id": "inline-edit.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "inline-edit.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "inline-edit.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    },
    addButtonLabel: {
        "id": "inline-edit.add-button-label",
        "defaultMessage": "Add {fieldName}"
    },
    extendedEditButtonLabel: {
        "id": "inline-edit.extended-edit-button-label",
        "defaultMessage": "{inputFieldValue}- edit {fieldName}"
    },
    disabledEditButtonLabel: {
        "id": "inline-edit.disabled-edit-button-label",
        "defaultMessage": "{fieldName} - can\u2019t be edited"
    },
    disabledReporterTooltip: {
        "id": "inline-edit.disabled-inline-edit-tooltip",
        "defaultMessage": "{fieldName} can\u2019t be edited"
    }
});

});

parcelRegister("iSAvW", function(module, exports) {

$parcel$export(module.exports, "useAcronymHighlighter", () => $64f7fcd91e44e5a6$export$c9d72f2ca1d7f2bf);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $4zUUC = parcelRequire("4zUUC");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $guDlK = parcelRequire("guDlK");

var $bq3w7 = parcelRequire("bq3w7");

var $icJ7m = parcelRequire("icJ7m");

var $f6HJu = parcelRequire("f6HJu");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $64f7fcd91e44e5a6$var$noop = ()=>{};
const $64f7fcd91e44e5a6$export$c9d72f2ca1d7f2bf = (descriptionRef)=>{
    const { highlightEnabled: highlightEnabled } = (0, $icJ7m.useIsHighlightEnabled)();
    const { data: data, loadAcronyms: loadAcronyms, resetData: resetData } = (0, $bq3w7.useAcronymsQuery)();
    const { toggleAcronymDialog: toggleAcronymDialog } = (0, $icJ7m.useHighlightActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isAiOptInEnabled = (0, $hJ992.useIsAiOptInEnabled)();
    const isPremium = (0, $4zUUC.useIsPremium)();
    const isFeatureEnabled = isPremium && isAiOptInEnabled;
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const edition = (0, $guDlK.useEdition)(projectKey, true);
    const onClick = (0, $eUqFw.useCallback)((e)=>{
        e.stopPropagation();
        toggleAcronymDialog(e.clientX, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        e.target);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'jiraReadingAidsAcronymHighlight'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
            isReadingAidsEnabled: isFeatureEnabled,
            edition: edition
        });
    }, [
        toggleAcronymDialog,
        createAnalyticsEvent,
        edition,
        isFeatureEnabled
    ]);
    const loadData = (0, $eUqFw.useCallback)((adfValue)=>{
        const content = (0, $f6HJu.parseContent)(adfValue);
        if (content) loadAcronyms(content);
    }, [
        loadAcronyms
    ]);
    const highlightAcronyms = (0, $eUqFw.useCallback)((adfValue)=>{
        if (adfValue) loadData(adfValue);
    }, [
        loadData
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (data && descriptionRef.current) {
            const { acronyms: acronyms } = data;
            (0, $f6HJu.markUpContentGracefully)(descriptionRef.current, acronyms, onClick);
        }
    }, [
        data,
        descriptionRef,
        onClick
    ]);
    const resetAcronymsData = (0, $eUqFw.useCallback)(()=>{
        resetData();
    }, [
        resetData
    ]);
    return !highlightEnabled ? {
        highlightAcronyms: $64f7fcd91e44e5a6$var$noop,
        resetAcronymsData: $64f7fcd91e44e5a6$var$noop
    } : {
        highlightAcronyms: highlightAcronyms,
        resetAcronymsData: resetAcronymsData
    };
};

});
parcelRegister("bq3w7", function(module, exports) {

$parcel$export(module.exports, "fetchNlpData", () => $2027408971ae33f1$export$615f80e8c8828d17);
$parcel$export(module.exports, "useAcronymsQuery", () => $2027408971ae33f1$export$8aee223a6a42973c);

var $15fyB = parcelRequire("15fyB");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $ejLgE = parcelRequire("ejLgE");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $amu7D = parcelRequire("amu7D");
const $2027408971ae33f1$export$615f80e8c8828d17 = async (query, locations, locale, additionalContext)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            method: 'POST',
            body: JSON.stringify({
                query: $2027408971ae33f1$export$833062bc9f56d000(query, locale, locations, additionalContext)
            })
        });
        return response.data;
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'fetchNlpDataService',
                packageName: 'jiraHighlightActions',
                teamName: 'crocs'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        });
        throw error;
    }
};
const $2027408971ae33f1$export$833062bc9f56d000 = (query, locale, cloudIdARI, additionalContext)=>(0, $ejLgE.gqlTagRest)`query NlpSearchQuery {
    nlpSearch(
      query: "${query}"
      locale:  "${locale}"
      followups_enabled: false
      locations: ["${cloudIdARI}"]
      additionalContext: "${additionalContext || ''}",
      experience: "readingAids"
    ) @optIn(to: "Nlp Search") {
      nlpResults {
        nlpResult
        sources {
          id
          title
          url
          iconUrl
          type
          lastModified
          spaceName
          spaceUrl
        }
      }
      format
      nlpFollowUpResults {
        followUps
      }
      uniqueSources {
        id
        title
        url
        iconUrl
        type
        lastModified
        spaceName
        spaceUrl
      }
      errorState
      disclaimer
    }
  }`;
const $2027408971ae33f1$export$2d3e38d46be26c3 = async (content)=>{
    try {
        const data = await (0, $iWLL0.fetchQuery)((0, $amu7D.default), (0, $15fyB.default), {
            content: content
        }).toPromise();
        const acronyms = data?.getKeywords ?? null;
        return {
            acronyms: acronyms
        };
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'fetchAcronymsDataService',
                packageName: 'jiraHighlightActions',
                teamName: 'crocs'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        });
        throw error;
    }
};
const $2027408971ae33f1$var$initialState = {
    data: undefined,
    loading: false,
    error: undefined
};
const $2027408971ae33f1$export$8aee223a6a42973c = ()=>{
    const [state, setState] = (0, $eUqFw.useState)($2027408971ae33f1$var$initialState);
    const loadAcronyms = (0, $eUqFw.useCallback)(async (contentData)=>{
        try {
            setState({
                ...$2027408971ae33f1$var$initialState,
                loading: true
            });
            const data = await $2027408971ae33f1$export$2d3e38d46be26c3(contentData);
            setState({
                ...$2027408971ae33f1$var$initialState,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...$2027408971ae33f1$var$initialState,
                error: error
            });
            return undefined;
        }
    }, []);
    const resetData = (0, $eUqFw.useCallback)(()=>{
        setState($2027408971ae33f1$var$initialState);
    }, []);
    return {
        ...state,
        loadAcronyms: loadAcronyms,
        resetData: resetData
    };
};

});
parcelRegister("15fyB", function(module, exports) {

$parcel$export(module.exports, "default", () => $dacb88e926e94c65$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f363e4edea709dd2b415656b6c68b2b7>>
 * @relayHash d18f9f3978b3600b46084d44d46c9aba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 67e935705eee63c3a933e86d7e13e3e9087e01504aee222834e09b93f7f54580
const $dacb88e926e94c65$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "content"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Literal",
                            "name": "format",
                            "value": "PLAIN_TEXT"
                        },
                        {
                            "kind": "Variable",
                            "name": "text",
                            "variableName": "content"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "textInput"
                }
            ],
            "kind": "ScalarField",
            "name": "getKeywords"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "servicesReadingAids_acronymsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "servicesReadingAids_acronymsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "67e935705eee63c3a933e86d7e13e3e9087e01504aee222834e09b93f7f54580",
            "metadata": {},
            "name": "servicesReadingAids_acronymsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$dacb88e926e94c65$var$node.hash = "add25bd4b5083989935d4c67fbb740e6";
var $dacb88e926e94c65$export$2e2bcd8739ae039 = $dacb88e926e94c65$var$node;

});


parcelRegister("icJ7m", function(module, exports) {

$parcel$export(module.exports, "HighlightActionsContainer", () => $d2a1380f84362131$export$f26eb80746d1e7d0);
$parcel$export(module.exports, "useTriggerPosition", () => $d2a1380f84362131$export$7c7db56c3e96bef7);
$parcel$export(module.exports, "useSelectedText", () => $d2a1380f84362131$export$d64e1644ca53b6b1);
$parcel$export(module.exports, "useHighlightActions", () => $d2a1380f84362131$export$eb3086681271316f);
$parcel$export(module.exports, "useActivePopup", () => $d2a1380f84362131$export$85280a1499195492);
$parcel$export(module.exports, "useSetHighlightContainerRef", () => $d2a1380f84362131$export$6a494309ff8aed73);
$parcel$export(module.exports, "useIsHighlightEnabled", () => $d2a1380f84362131$export$7f03c71af73fb70c);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $OUdnA = parcelRequire("OUdnA");

var $hJ992 = parcelRequire("hJ992");

var $4zUUC = parcelRequire("4zUUC");

var $6yplV = parcelRequire("6yplV");
var $j3FUN = parcelRequire("j3FUN");

var $2lYB6 = parcelRequire("2lYB6");

var $jZgII = parcelRequire("jZgII");
const $d2a1380f84362131$var$Store = (0, $a61MH.createStore)({
    initialState: {
        containerRef: {
            current: null
        },
        activePopup: undefined,
        selectedText: undefined
    },
    actions: $jZgII.actions,
    name: 'highlight-actions-store'
});
const $d2a1380f84362131$export$f26eb80746d1e7d0 = (0, $heB5U.createContainer)($d2a1380f84362131$var$Store);
const $d2a1380f84362131$var$getTriggerPosition = (state)=>state.triggerPosition;
const $d2a1380f84362131$export$7c7db56c3e96bef7 = (0, $ggKAj.createStateHook)($d2a1380f84362131$var$Store, {
    selector: $d2a1380f84362131$var$getTriggerPosition
});
const $d2a1380f84362131$var$getSelectedText = (state)=>state.selectedText;
const $d2a1380f84362131$export$d64e1644ca53b6b1 = (0, $ggKAj.createStateHook)($d2a1380f84362131$var$Store, {
    selector: $d2a1380f84362131$var$getSelectedText
});
const $d2a1380f84362131$export$eb3086681271316f = (0, $ggKAj.createActionsHook)($d2a1380f84362131$var$Store);
const $d2a1380f84362131$export$280520c45367f0e5 = (0, $ggKAj.createStateHook)($d2a1380f84362131$var$Store);
const $d2a1380f84362131$var$getActivePopup = (state)=>state.activePopup;
const $d2a1380f84362131$export$85280a1499195492 = (0, $ggKAj.createStateHook)($d2a1380f84362131$var$Store, {
    selector: $d2a1380f84362131$var$getActivePopup
});
const $d2a1380f84362131$export$6a494309ff8aed73 = (ref)=>{
    const { setContainerRef: setContainerRef } = $d2a1380f84362131$export$eb3086681271316f();
    (0, $eUqFw.useEffect)(()=>{
        setContainerRef(ref);
    }, [
        ref,
        setContainerRef
    ]);
};
const $d2a1380f84362131$var$useIsHighlightEnabledOld = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const hasConfluence = !!licensedProducts.confluence;
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const canOptIn = (0, $4zUUC.useCanOptIn)();
    const isPremium = (0, $4zUUC.useIsPremium)();
    const isAiOptInEnabled = (0, $hJ992.useIsAiOptInEnabled)();
    const isAIFeatureEnabled = isPremium && isAiOptInEnabled;
    return {
        highlightEnabled: hasConfluence && !isAnonymous && (isAIFeatureEnabled || canOptIn)
    };
};
const $d2a1380f84362131$export$97288e6a331d751a = ()=>{
    const hasConfluenceAccess = (0, $2lYB6.useUserHasConfluenceAccess)().hasAccess;
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const canOptIn = (0, $4zUUC.useCanOptIn)();
    const isPremium = (0, $4zUUC.useIsPremium)();
    const isAiOptInEnabled = (0, $hJ992.useIsAiOptInEnabled)();
    const isAIFeatureEnabled = isPremium && isAiOptInEnabled;
    return {
        highlightEnabled: hasConfluenceAccess && !isAnonymous && (isAIFeatureEnabled || canOptIn)
    };
};
const $d2a1380f84362131$export$7f03c71af73fb70c = (0, $OUdnA.functionWithFF)('issue-view-disable-definition-feature-if-the-user-doesnt-have-confluence-access_inh6g', $d2a1380f84362131$export$97288e6a331d751a, $d2a1380f84362131$var$useIsHighlightEnabledOld);

});
parcelRegister("OUdnA", function(module, exports) {

$parcel$export(module.exports, "functionWithFF", () => $4f946782842d29a3$export$3b8cbae22108d228);

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");
const $4f946782842d29a3$export$3b8cbae22108d228 = (featureFlagName, functionTrue, functionFalse)=>(0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)(featureFlagName), functionTrue, functionFalse);

});

parcelRegister("2lYB6", function(module, exports) {

$parcel$export(module.exports, "useUserHasConfluenceAccess", () => $0099070d2c79fb1d$export$bddce71054147149);

var $eUqFw = parcelRequire("eUqFw");

var $2OdyW = parcelRequire("2OdyW");

var $cWiVr = parcelRequire("cWiVr");

var $j3FUN = parcelRequire("j3FUN");

var $hAmXy = parcelRequire("hAmXy");
const $0099070d2c79fb1d$export$be853db8ef50fa0b = async ()=>{
    try {
        const response = await (0, $2OdyW.default)('/wiki/rest/api/user/current?expand=operations');
        return response.operations && response.operations.length > 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return false;
    }
};
const $0099070d2c79fb1d$export$bddce71054147149 = ()=>{
    const { data: currentUser } = (0, $cWiVr.useCurrentUser)();
    const storageKey = `jira-definition-user-has-confluence-access-${currentUser.user.accountId}`;
    const cachedData = (0, $eUqFw.useMemo)(()=>(0, $hAmXy.getSessionStorageData)(storageKey), [
        storageKey
    ]);
    const [hasAccess, setHasAccess] = (0, $eUqFw.useState)(Boolean(cachedData));
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const hasConfluence = !!licensedProducts.confluence;
    (0, $eUqFw.useEffect)(()=>{
        if (!hasConfluence) return;
        const getConfluenceAccessPermissions = async ()=>{
            const response = await $0099070d2c79fb1d$export$be853db8ef50fa0b();
            (0, $hAmXy.setSessionStorageData)(storageKey, response);
            setHasAccess(Boolean(response));
        };
        if (cachedData === undefined) getConfluenceAccessPermissions();
        else setHasAccess(cachedData);
    }, [
        hasConfluence,
        storageKey,
        cachedData
    ]);
    return {
        hasAccess: hasAccess
    };
};

});
parcelRegister("hAmXy", function(module, exports) {

$parcel$export(module.exports, "getSessionStorageData", () => $0a0b9f11ddeee388$export$af84d82ff1eea56d);
$parcel$export(module.exports, "setSessionStorageData", () => $0a0b9f11ddeee388$export$be8cb7c8f1a1db6b);

var $89bO2 = parcelRequire("89bO2");
const $0a0b9f11ddeee388$var$ONE_DAY = 86400000; // 1 day
const $0a0b9f11ddeee388$var$storage = (0, $89bO2.createSessionExpirableStorageProvider)('jira-definitions-current-confluence-access');
$0a0b9f11ddeee388$var$storage.removeExpiredKeys();
const $0a0b9f11ddeee388$export$af84d82ff1eea56d = (key)=>$0a0b9f11ddeee388$var$storage.get(key);
const $0a0b9f11ddeee388$export$be8cb7c8f1a1db6b = (key, value)=>{
    const expiresAt = Date.now() + $0a0b9f11ddeee388$var$ONE_DAY;
    $0a0b9f11ddeee388$var$storage.set(key, value, expiresAt);
};

});


parcelRegister("jZgII", function(module, exports) {

$parcel$export(module.exports, "actions", () => $ba7e80739ecc2649$export$e324594224ef24da);

var $lkgh7 = parcelRequire("lkgh7");
const $ba7e80739ecc2649$export$e324594224ef24da = {
    setContainerRef: (ref)=>({ setState: setState })=>setState({
                containerRef: ref
            }),
    setTriggerPosition: (mouseX, trigger, popupType)=>({ setState: setState, getState: getState })=>{
            const { containerRef: containerRef } = getState();
            if (!containerRef.current) return;
            const { position: triggerPosition, selectedText: selectedText } = (0, $lkgh7.calculateTriggerPosition)(containerRef.current, mouseX, trigger) || {};
            const activePopup = selectedText ? popupType || 'action-menu' : undefined;
            setState({
                triggerPosition: triggerPosition,
                selectedText: selectedText,
                activePopup: activePopup
            });
        },
    toggleAcronymDialog: (mouseX, trigger)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { containerRef: containerRef, triggerPosition: triggerPosition } = getState();
            if (!containerRef.current) return;
            if (triggerPosition) {
                dispatch($ba7e80739ecc2649$export$e324594224ef24da.resetTriggerPosition());
                return;
            }
            const { position: position, selectedText: selectedText } = (0, $lkgh7.calculateTriggerPosition)(containerRef.current, mouseX, trigger) || {};
            setState({
                triggerPosition: position,
                selectedText: selectedText,
                activePopup: 'acronyms-dialog'
            });
        },
    resetTriggerPosition: ()=>({ setState: setState })=>{
            setState({
                triggerPosition: undefined,
                selectedText: undefined
            });
        },
    openAnswerDialog: ()=>({ setState: setState, getState: getState })=>{
            if (!getState().selectedText) return;
            setState({
                activePopup: 'answer-dialog'
            });
        },
    openOptInDialog: ()=>({ setState: setState, getState: getState })=>{
            if (!getState().selectedText) return;
            setState({
                activePopup: 'opt-in-dialog'
            });
        }
};

});
parcelRegister("lkgh7", function(module, exports) {

$parcel$export(module.exports, "calculateTriggerPosition", () => $346966591eead738$export$3d2a453463446d65);
// In IE, selectionRange.toString() always convert all &nbsp; to normal space on other browsers, it does not.
// So we must convert manually to made consistency across all browsers
const $346966591eead738$export$8ef5e8476b59682e = (selectedText)=>{
    if (!selectedText) return '';
    return selectedText.replace(/\u00a0/g, '\u0020').replace(/\n/, ' ').trim();
};
const $346966591eead738$export$d438974ad9b681ee = [
    'SPAN',
    'A',
    'STRONG',
    'CODE'
];
const $346966591eead738$export$cc7a49ae74d7e55f = (range)=>{
    const container = range.startContainer.parentElement;
    if (!range || !container) return '';
    if ($346966591eead738$export$d438974ad9b681ee.includes(container.tagName)) return container.parentElement ? container.parentElement.textContent || container.innerText : '';
    return container.textContent || container.innerText;
};
const $346966591eead738$var$SENTENCE_REGEX = /(?=[^])(?:\P{Sentence_Terminal}|\p{Sentence_Terminal}(?!['"`\p{Close_Punctuation}\p{Final_Punctuation}\s]))*(?:\p{Sentence_Terminal}+['"`\p{Close_Punctuation}\p{Final_Punctuation}]*|$)/guy;
const $346966591eead738$var$MAX_SENTENCE_LENGTH = 200;
const $346966591eead738$export$ea910e56c1dc90c8 = (content, query)=>{
    const contextSentences = content.match($346966591eead738$var$SENTENCE_REGEX)?.filter((sentence)=>!!sentence.match(query.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&')));
    if (contextSentences && contextSentences[0] && contextSentences[0].length <= $346966591eead738$var$MAX_SENTENCE_LENGTH) return contextSentences[0].trim();
    return '';
};
const $346966591eead738$export$cbc892c0a0f7699e = (trigger)=>{
    if (trigger) {
        if (!trigger.innerText) return {};
        const selectedContext = trigger.parentElement;
        const additionalContext = selectedContext ? selectedContext.textContent || selectedContext.innerText : '';
        return {
            boundingRect: trigger.getBoundingClientRect(),
            selectedText: {
                value: trigger.innerText,
                context: additionalContext
            }
        };
    }
    const selection = window.getSelection();
    if (!selection || selection.isCollapsed) return {};
    const range = selection.getRangeAt(0);
    const value = $346966591eead738$export$8ef5e8476b59682e(range.toString());
    if (!value) return {};
    const rects = range.getClientRects();
    const boundingRect = Array.from(rects).find((r)=>r.width !== 0 && r.height !== 0);
    if (!boundingRect) return {};
    const parentContent = $346966591eead738$export$cc7a49ae74d7e55f(range);
    const context = $346966591eead738$export$ea910e56c1dc90c8(parentContent, value);
    return {
        selectedText: {
            value: value,
            context: context
        },
        boundingRect: boundingRect
    };
};
const $346966591eead738$export$3d2a453463446d65 = (container, _mouseX, trigger)=>{
    const { boundingRect: boundingRect, selectedText: selectedText } = $346966591eead738$export$cbc892c0a0f7699e(trigger);
    if (boundingRect && selectedText) {
        const { left: left, top: top, width: width, height: height } = boundingRect;
        const { left: portalLeft, top: portalTop } = container.getBoundingClientRect();
        const position = {
            top: top - portalTop,
            left: left - portalLeft,
            width: width,
            height: height
        };
        return {
            position: position,
            selectedText: selectedText
        };
    }
    return undefined;
};

});



parcelRegister("f6HJu", function(module, exports) {

$parcel$export(module.exports, "parseContent", () => $8bf3e077a84b3b9e$export$4cf5403beffb0fc1);
$parcel$export(module.exports, "markUpContentGracefully", () => $8bf3e077a84b3b9e$export$dede6dc4674fec89);

var $hyGEo = parcelRequire("hyGEo");
const $8bf3e077a84b3b9e$var$TIME_OUT = 300;
const $8bf3e077a84b3b9e$var$validMarks = (data)=>{
    const invalidMarks = [
        'annotation',
        'link'
    ];
    return !data.marks || !data.marks.some((mark)=>invalidMarks.includes(mark.type));
};
const $8bf3e077a84b3b9e$var$validType = (data)=>{
    const invalidTypes = [
        'codeBlock'
    ];
    return !invalidTypes.includes(data.type);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8bf3e077a84b3b9e$var$extractContent = (data, flatMap)=>{
    if ($8bf3e077a84b3b9e$var$validType(data)) {
        if (data.content && data.content.length > 0) for (const node of data.content)$8bf3e077a84b3b9e$var$extractContent(node, flatMap);
    }
    // leaf node
    if (data.type === 'text' && $8bf3e077a84b3b9e$var$validMarks(data)) flatMap.push(data);
};
const $8bf3e077a84b3b9e$export$4cf5403beffb0fc1 = (adfValue)=>{
    const flatMap = [];
    $8bf3e077a84b3b9e$var$extractContent(adfValue, flatMap);
    return flatMap.map((node)=>node.text).join(',');
};
/**
 *
 * @param walker
 * @param acronyms
 * @returns AcronymNode[]
 *
 * Optimistically go through the DOM node and find all the occurences
 */ const $8bf3e077a84b3b9e$var$findAllOccurencesOptimisticallly = (walker, acronyms)=>{
    const nodesToReplace = [];
    // keep track of parent node and whether it's been skipped already
    let lastParentNode = null;
    let skip = false;
    const existingMatches = new Set();
    // Prefill existing data
    const highlightedAcronyms = document.querySelectorAll('.acronym-highlight');
    highlightedAcronyms.forEach((item)=>item.textContent && existingMatches.add(item.textContent));
    while(walker.nextNode()){
        const node = walker.currentNode;
        // skip text nodes that have parents we don't want, such as span or a elements
        // only checks again if we encounter a new parent node
        if (node.parentNode !== lastParentNode) {
            lastParentNode = node.parentNode;
            skip = !(0, $hyGEo.ALLOWED_ELEMENTS).includes(node.parentNode?.nodeName.toLowerCase() || '');
        }
        // eslint-disable-next-line no-continue
        if (skip) continue;
        const nodeValue = node.nodeValue || '';
        // find all valid acronym matches in the text node
        for (const acronymMatch of nodeValue.matchAll((0, $hyGEo.DEFAULT_ACRONYM_HIGHLIGHT_REGEX)))if (!existingMatches.has(acronymMatch[0]) && acronyms.includes(acronymMatch[0])) {
            nodesToReplace.push({
                node: node,
                matchIndex: acronymMatch.index,
                matchLength: acronymMatch[0].length
            });
            existingMatches.add(acronymMatch[0]);
        }
    }
    return nodesToReplace;
};
const $8bf3e077a84b3b9e$var$markUpNodes = (nodesToReplace, onClick)=>{
    while(nodesToReplace.length > 0){
        const item = nodesToReplace.pop();
        const { node: node, matchIndex: matchIndex, matchLength: matchLength } = item || {};
        if (!node || matchIndex === undefined || !matchLength || !node?.nodeValue || !node.parentNode) continue;
        // split up the text node content into part before match, match, and after match
        const before = node.nodeValue.substr(0, matchIndex);
        const middle = node.nodeValue.substr(matchIndex, matchLength);
        const after = node.nodeValue.substr(matchIndex + matchLength);
        // replace text node with part before match
        node.nodeValue = before;
        const fragment = document.createDocumentFragment();
        const replacementSpan = $8bf3e077a84b3b9e$var$createReplacementNode(middle, onClick);
        fragment.appendChild(replacementSpan);
        const afterNode = document.createTextNode(after);
        fragment.appendChild(afterNode);
        // insert new text node with span and part after match
        node.parentNode.insertBefore(fragment, node.nextSibling);
    }
};
/* eslint-disable no-param-reassign */ const $8bf3e077a84b3b9e$var$applyDefaultStyle = (htmlElement)=>{
    htmlElement.style.background = 'none';
    htmlElement.style.borderImage = `linear-gradient(to right, ${"var(--ds-background-accent-blue-bolder, #3B78F4)"}, ${"var(--ds-background-accent-teal-subtle, #9DD9E3)"}, ${"var(--ds-background-accent-yellow-subtler, #F5E6A8)"}) 0 0 100% 0`;
    htmlElement.style.borderWidth = '2px';
    htmlElement.style.borderBottomStyle = 'solid';
};
/* eslint-disable no-param-reassign */ const $8bf3e077a84b3b9e$var$applyHoverStyle = (htmlElement)=>{
    htmlElement.style.background = `linear-gradient(to right, ${"var(--ds-background-accent-blue-subtlest, #E9f2ff)"}, ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"})`;
    htmlElement.style.cursor = 'pointer';
};
const $8bf3e077a84b3b9e$var$createReplacementNode = (middle, onClick)=>{
    const replacementSpan = document.createElement('span');
    replacementSpan.classList.add('acronym-highlight');
    replacementSpan.textContent = middle;
    $8bf3e077a84b3b9e$var$applyDefaultStyle(replacementSpan);
    const mouseOverHandler = ()=>{
        $8bf3e077a84b3b9e$var$applyHoverStyle(replacementSpan);
    };
    const mouseOutHandler = ()=>{
        $8bf3e077a84b3b9e$var$applyDefaultStyle(replacementSpan);
    };
    replacementSpan.addEventListener('mouseover', mouseOverHandler);
    replacementSpan.addEventListener('mouseout', mouseOutHandler);
    replacementSpan.addEventListener('click', onClick);
    // prevent the trigger of undesired effect onpointerup event
    // in /src/ui/utils.tsx
    replacementSpan.addEventListener('pointerup', (e)=>e.stopPropagation());
    return replacementSpan;
};
const $8bf3e077a84b3b9e$var$markUpContent = (element, acronyms, onClick)=>{
    if (!acronyms) return;
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const nodesToReplace = $8bf3e077a84b3b9e$var$findAllOccurencesOptimisticallly(walker, acronyms);
    $8bf3e077a84b3b9e$var$markUpNodes(nodesToReplace, onClick);
};
const $8bf3e077a84b3b9e$export$dede6dc4674fec89 = (element, acronyms, onClick)=>{
    setTimeout(()=>$8bf3e077a84b3b9e$var$markUpContent(element, acronyms, onClick), $8bf3e077a84b3b9e$var$TIME_OUT);
};

});
parcelRegister("hyGEo", function(module, exports) {

$parcel$export(module.exports, "ALLOWED_ELEMENTS", () => $1dffa724450e5c72$export$1a619e034ec0bfc4);
$parcel$export(module.exports, "DEFAULT_ACRONYM_HIGHLIGHT_REGEX", () => $1dffa724450e5c72$export$f510408cc58010fb);
const $1dffa724450e5c72$export$1a619e034ec0bfc4 = [
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'strong',
    'em',
    'u',
    'sub',
    'sup'
];
const $1dffa724450e5c72$export$f510408cc58010fb = /(\b)[A-Z][A-Z0-9&]{1,}(\b)/g;

});



parcelRegister("lFWFO", function(module, exports) {

$parcel$export(module.exports, "useOnHighlight", () => $38874bdacb2fcd7e$export$a980f818692fd0ba);

var $eUqFw = parcelRequire("eUqFw");

var $icJ7m = parcelRequire("icJ7m");
const $38874bdacb2fcd7e$export$a980f818692fd0ba = (ref)=>{
    const { setTriggerPosition: setTriggerPosition, resetTriggerPosition: resetTriggerPosition } = (0, $icJ7m.useHighlightActions)();
    const triggerPosition = (0, $icJ7m.useTriggerPosition)();
    const onPointerUp = (0, $eUqFw.useCallback)((e)=>{
        setTriggerPosition(e.clientX);
    }, [
        setTriggerPosition
    ]);
    const onClick = (0, $eUqFw.useCallback)((e)=>{
        if (triggerPosition) e.stopPropagation();
        /* setImmediate callback is needed here because when texts are deselected by clicking on the same
            selection again. The isCollapsed value is only reflected correctly after event loop concludes */ setImmediate(()=>{
            if (window.getSelection()?.isCollapsed) resetTriggerPosition();
        });
    }, [
        resetTriggerPosition,
        triggerPosition
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const currentRef = ref.current;
        if (currentRef) {
            currentRef.addEventListener('click', onClick);
            currentRef.addEventListener('touchend', onClick);
        }
        return ()=>{
            if (currentRef) {
                currentRef.removeEventListener('click', onClick);
                currentRef.removeEventListener('touchend', onClick);
            }
        };
    }, [
        onClick,
        ref
    ]);
    const register = (0, $eUqFw.useCallback)(()=>{
        if (ref.current) ref.current.addEventListener('pointerup', onPointerUp);
    }, [
        onPointerUp,
        ref
    ]);
    const unregister = (0, $eUqFw.useCallback)(()=>{
        if (ref.current) ref.current.removeEventListener('pointerup', onPointerUp);
    }, [
        onPointerUp,
        ref
    ]);
    return {
        register: register,
        unregister: unregister
    };
};

});

parcelRegister("78fR1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfe5c8af1b3264d4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6oQPP = parcelRequire("6oQPP");
const $cfe5c8af1b3264d4$var$compactWrapperControlSelectorName = 'jira.issue-view.common.inline-edit.compact-wrapper-control';
const $cfe5c8af1b3264d4$export$ecaec0bd8eb1a831 = `[data-component-selector="${$cfe5c8af1b3264d4$var$compactWrapperControlSelectorName}"]`;
const $cfe5c8af1b3264d4$export$60c99ad211486e87 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfe5c8af1b3264d4$export$548301e42542a028, {
        isEditing: props.isEditing,
        isGrouped: props.isGrouped,
        "data-testid": props['data-testid'],
        "data-component-selector": $cfe5c8af1b3264d4$var$compactWrapperControlSelectorName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), props));
var $cfe5c8af1b3264d4$export$2e2bcd8739ae039 = $cfe5c8af1b3264d4$export$60c99ad211486e87;
const $cfe5c8af1b3264d4$export$548301e42542a028 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isGrouped: isGrouped, isEditing: isEditing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isGrouped !== true ? "_otyr1ejb" : "_otyridpf",
            !__cmplp.isEditing && "_3tcu1h67",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6oQPP", function(module, exports) {

$parcel$export(module.exports, "FieldInlineEditStateLess", () => $9da4571f07ee5984$export$9a29c614a3f4aae1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $5i12b = parcelRequire("5i12b");

var $f8Yej = parcelRequire("f8Yej");

var $g8JvH = parcelRequire("g8JvH");
var $bFzGY = parcelRequire("bFzGY");

var $5St1r = parcelRequire("5St1r");
const $9da4571f07ee5984$export$5af7124b5599afd0 = (0, $g8JvH.AnalyticsEventToProps)('EnterEscapeHandler', {
    onEnter: 'entered',
    onEscape: 'escaped'
})((0, $f8Yej.default));
const $9da4571f07ee5984$export$41b20ce1a1b4f6f1 = (0, $g8JvH.AnalyticsEventToProps)('EscapeHandler', {
    onEscape: 'escaped'
})((0, $f8Yej.default));
const $9da4571f07ee5984$export$bfbc426ae4e1403d = (0, $g8JvH.AnalyticsEventToProps)('EnterHandler', {
    onEnter: 'entered'
})((0, $f8Yej.default)); // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9da4571f07ee5984$var$FieldContainer = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1u79nuj-0"
})({
    /* @see: BENTO-10009 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& > form > div > div > button:focus': {
        outline: 'none'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9da4571f07ee5984$var$NonEditableMargin = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81uch",
            __cmplp.className
        ])
    });
});
const $9da4571f07ee5984$var$useCallbackWithAnalyticsEvent = (callback, payload)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(()=>{
        if (typeof callback === 'function') callback(createAnalyticsEvent(payload));
    }, [
        callback,
        createAnalyticsEvent,
        payload
    ]);
};
const $9da4571f07ee5984$export$9a29c614a3f4aae1 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { actionSubject: actionSubject = 'fieldInlineEdit', editView: editView, isEditable: isEditable = false, isEditing: isEditing = false, isLabelHidden: isLabelHidden = true, readView: readView, testId: testId, onCancel: onCancel, onConfirm: onConfirm, onEdit: onEdit, onEditRequested: onEditRequested, onEnter: onEnter, onEscape: onEscape } = props;
    const handleEnter = $9da4571f07ee5984$var$useCallbackWithAnalyticsEvent(onEnter, {
        action: 'entered',
        actionSubject: actionSubject,
        ...props.componentAnalyticsData
    });
    const handleEscape = $9da4571f07ee5984$var$useCallbackWithAnalyticsEvent(onEscape, {
        action: 'escaped',
        actionSubject: actionSubject,
        ...props.componentAnalyticsData
    });
    const handleEdit = $9da4571f07ee5984$var$useCallbackWithAnalyticsEvent(onEditRequested || onEdit, {
        action: 'focused',
        actionSubject: actionSubject,
        ...props.componentAnalyticsData
    });
    const handleCancel = $9da4571f07ee5984$var$useCallbackWithAnalyticsEvent(onCancel, {
        action: 'canceled',
        actionSubject: actionSubject,
        ...props.componentAnalyticsData
    });
    const handleConfirm = (0, $eUqFw.useCallback)((_, event)=>{
        if (typeof onConfirm === 'function') onConfirm(event.update({
            action: 'confirmed',
            actionSubject: actionSubject,
            ...props.componentAnalyticsData
        }));
    }, [
        actionSubject,
        onConfirm,
        props.componentAnalyticsData
    ]);
    const renderReadView = typeof readView === 'function' ? readView : ()=>readView;
    const renderEditView = (0, $eUqFw.useMemo)(()=>{
        if (typeof editView === 'function') return editView;
        return ()=>editView;
    }, [
        editView
    ]);
    const renderEditViewWithHandlers = (0, $eUqFw.useCallback)((editProps, ref)=>{
        if (editView === null) return null;
        if (onEnter && onEscape) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9da4571f07ee5984$export$5af7124b5599afd0, {
            onEnter: handleEnter,
            onEscape: handleEscape
        }, renderEditView(editProps, ref));
        if (onEnter) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9da4571f07ee5984$export$bfbc426ae4e1403d, {
            onEnter: handleEnter
        }, renderEditView(editProps, ref));
        if (onEscape) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9da4571f07ee5984$export$41b20ce1a1b4f6f1, {
            onEscape: handleEscape
        }, renderEditView(editProps, ref));
        return renderEditView(editProps, ref);
    }, [
        editView,
        onEnter,
        onEscape,
        handleEnter,
        handleEscape,
        renderEditView
    ]);
    const inlineEditProps = {
        defaultValue: 'defaultValue' in props ? props.defaultValue : props.value,
        onConfirm: handleConfirm,
        readView: renderReadView,
        editView: renderEditViewWithHandlers,
        isEditing: isEditing,
        onCancel: handleCancel,
        onEdit: handleEdit,
        isRequired: props.isRequired,
        analyticsContext: props.analyticsContext,
        cancelButtonLabel: props.cancelButtonLabel,
        confirmButtonLabel: props.confirmButtonLabel,
        editButtonLabel: props.editButtonLabel,
        hideActionButtons: 'hideActionButtons' in props ? props.hideActionButtons : props.areActionButtonsHidden,
        keepEditViewOpenOnBlur: 'keepEditViewOpenOnBlur' in props ? props.keepEditViewOpenOnBlur : props.isConfirmOnBlurDisabled,
        label: isLabelHidden === true ? undefined : props.label,
        readViewFitContainerWidth: 'readViewFitContainerWidth' in props ? props.readViewFitContainerWidth : props.isFitContainerWidthReadView,
        startWithEditViewOpen: props.startWithEditViewOpen,
        validate: props.validate
    };
    return isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9da4571f07ee5984$var$FieldContainer, {
        "data-testid": testId != null ? `${testId}--container` : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i12b.default), inlineEditProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9da4571f07ee5984$var$NonEditableMargin, {
        "data-component-selector": (0, $5St1r.readOnlyViewContainerSelectorName),
        "data-testid": testId != null ? `${testId}--read-only-container` : undefined
    }, renderReadView());
});
var $9da4571f07ee5984$export$2e2bcd8739ae039 = $9da4571f07ee5984$export$9a29c614a3f4aae1;

});
parcelRegister("5i12b", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d9f6f937f8f20c0$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $4LhB6 = parcelRequire("4LhB6");

var $lzLxZ = parcelRequire("lzLxZ");

var $4ZL0y = parcelRequire("4ZL0y");

var $lkPEe = parcelRequire("lkPEe");

var $isSG6 = parcelRequire("isSG6");

var $h0GNF = parcelRequire("h0GNF");

var $6X9B5 = parcelRequire("6X9B5");
const $3d9f6f937f8f20c0$var$fieldStyles = (0, $byn9U.css)({
    maxWidth: '100%',
    position: 'relative'
});
const $3d9f6f937f8f20c0$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "@atlaskit/inline-edit",
    packageVersion: "13.4.1"
};
const $3d9f6f937f8f20c0$var$noop = ()=>{};
const $3d9f6f937f8f20c0$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel = $3d9f6f937f8f20c0$var$noop, onEdit: providedOnEdit = $3d9f6f937f8f20c0$var$noop, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $eUqFw.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $eUqFw.useState)(startWithEditViewOpen);
    const timerRef = (0, $eUqFw.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $h0GNF.default)(isEditing, isEditingState);
    const onCancel = (0, $eUqFw.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $eUqFw.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$3d9f6f937f8f20c0$var$analyticsAttributes
    });
    const onCancelClick = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $eUqFw.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]);
    /** If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
   *  confirms the value, if the focus is not transferred to the action buttons.
   *
   *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
   *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
   *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
   *  `autoSubmitWhenBlur`.
   *
   *  There are two paths here the function can be triggered:
   *
   *  - focus on input first, and then use keyboard to `submit`
   *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
   */ const onEditViewWrapperBlur = (0, $eUqFw.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]);
    /** Gets called when focus is transferred to the editView, or action buttons.
   *
   * There are three paths here the function can be called:
   *
   * - when a user click the `editView`
   * - when a user use keyboard to tab into `editView`
   * - when a user use keyboard to tab into `submit` when they were on input field.
   */ const onEditViewWrapperFocus = (0, $eUqFw.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const renderReadView = ()=>{
        return (0, $byn9U.jsx)((0, $6X9B5.default), {
            editButtonLabel: editButtonLabel,
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return (0, $byn9U.jsx)((0, $lzLxZ.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit)
    }, ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>(0, $byn9U.jsx)("form", {
            /**
     * It is not normally acceptable to add key handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * to add support for keyboard functionality instead of creating an inaccessible
     * custom element, we can add role="presentation" so that there is no negative
     * impacts to assistive technologies.
     */ role: "presentation",
            onKeyDown: (e)=>{
                onKeyDown(e);
                if (e.key === 'Esc' || e.key === 'Escape') onCancel();
            },
            onSubmit: onSubmit,
            ref: formRef
        }, shouldBeEditing ? (0, $byn9U.jsx)((0, $4LhB6.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: defaultValue,
            validate: validate,
            isRequired: isRequired,
            key: "edit-view" // used for reset to default value
        }, ({ fieldProps: fieldProps, error: error })=>(0, $byn9U.jsx)("div", {
                css: $3d9f6f937f8f20c0$var$fieldStyles,
                onBlur: ()=>{
                    onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                },
                onFocus: onEditViewWrapperFocus
            }, editView({
                ...fieldProps,
                errorMessage: error
            }, editViewRef), !hideActionButtons ? (0, $byn9U.jsx)((0, $isSG6.default), {
                testId: testId,
                cancelButtonLabel: cancelButtonLabel,
                confirmButtonLabel: confirmButtonLabel,
                onMouseDown: ()=>{
                    /** Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used */ doNotFocusOnEditButton();
                },
                onCancelClick: (e)=>{
                    reset();
                    onCancelClick(e);
                }
            }) : /** This is to allow Ctrl + Enter to submit without action buttons */ (0, $byn9U.jsx)((0, $4ZL0y.default), {
                hidden: true,
                type: "submit"
            }, (0, $byn9U.jsx)((0, $lkPEe.default), null, "Submit")))) : /** Field is used here only for the label and spacing */ (0, $byn9U.jsx)((0, $4LhB6.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: "",
            isRequired: isRequired,
            key: "read-view" // used for reset to default value
        }, renderReadView)));
};
const $3d9f6f937f8f20c0$var$InlineEdit = (props)=>{
    return (0, $byn9U.jsx)($3d9f6f937f8f20c0$var$InnerInlineEdit, props);
};
var $3d9f6f937f8f20c0$export$2e2bcd8739ae039 = $3d9f6f937f8f20c0$var$InlineEdit;

});
parcelRegister("isSG6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d71541753a68a64f$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $j9fWg = parcelRequire("j9fWg");

var $9nt1B = parcelRequire("9nt1B");

var $jWuk1 = parcelRequire("jWuk1");

var $PdmhA = parcelRequire("PdmhA");

var $cGaKT = parcelRequire("cGaKT");
const $d71541753a68a64f$var$buttonsContainerStyles = (0, $byn9U.css)({
    display: 'flex',
    marginBlockStart: "var(--ds-space-075, 6px)",
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    insetBlockStart: '100%',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    insetInlineEnd: 0,
    flexShrink: 0
});
const $d71541753a68a64f$var$buttonWrapperBaseStyles = (0, $byn9U.css)({
    boxSizing: 'border-box',
    width: "var(--ds-space-400, 32px)",
    zIndex: 200,
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    fontSize: (0, $cGaKT.fontSize),
    '&:last-child': {
        marginInlineStart: "var(--ds-space-050, 4px)"
    },
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`,
    // These buttons are floating, so they need an override to overlay interaction states
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > button': {
        backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N20A)})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > button:hover': {
        backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $PdmhA.N30A)})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > button:active': {
        backgroundColor: "var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6))",
        color: `var(--ds-text, ${(0, $PdmhA.B400)})`
    }
});
const $d71541753a68a64f$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return (0, $byn9U.jsx)("div", {
        css: $d71541753a68a64f$var$buttonsContainerStyles
    }, (0, $byn9U.jsx)("div", {
        css: $d71541753a68a64f$var$buttonWrapperBaseStyles
    }, (0, $byn9U.jsx)((0, $j9fWg.default), {
        type: "submit",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))),
        UNSAFE_size: "small",
        onMouseDown: onMouseDown,
        label: confirmButtonLabel,
        testId: testId && `${testId}--confirm`
    })), (0, $byn9U.jsx)("div", {
        css: $d71541753a68a64f$var$buttonWrapperBaseStyles
    }, (0, $byn9U.jsx)((0, $j9fWg.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))),
        UNSAFE_size: "small",
        label: cancelButtonLabel,
        onClick: onCancelClick,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}--cancel`
    })));
};
var $d71541753a68a64f$export$2e2bcd8739ae039 = $d71541753a68a64f$var$Buttons;

});
parcelRegister("cGaKT", function(module, exports) {

$parcel$export(module.exports, "fontSize", () => $93b1c0113113c1e6$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "borderRadius", () => $93b1c0113113c1e6$export$7a57f79000377ca2);

var $lcnyw = parcelRequire("lcnyw");
const $93b1c0113113c1e6$export$85e3c3ca0c6fb93 = (0, $lcnyw.fontSize)();
const $93b1c0113113c1e6$export$7a57f79000377ca2 = (0, $lcnyw.borderRadius)();

});


parcelRegister("h0GNF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c623a2faf66fdde1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $c623a2faf66fdde1$var$usePrevious = (value)=>{
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $c623a2faf66fdde1$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $eUqFw.useRef)(null);
    const editViewRef = (0, $eUqFw.useRef)();
    const preventFocusOnEditButtonRef = (0, $eUqFw.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $c623a2faf66fdde1$var$usePrevious(shouldBeEditing);
    (0, $eUqFw.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        /**
     * This logic puts the focus on the edit button after confirming using
     * the confirm button or using the keyboard to confirm, but not when
     * it is confirmed by wrapper blur
     */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $c623a2faf66fdde1$export$2e2bcd8739ae039 = $c623a2faf66fdde1$var$useButtonFocusHook;

});

parcelRegister("6X9B5", function(module, exports) {

$parcel$export(module.exports, "default", () => $50ffb290c03240e6$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $lkPEe = parcelRequire("lkPEe");

var $cGaKT = parcelRequire("cGaKT");
const $50ffb290c03240e6$var$readViewContainerStyles = (0, $byn9U.css)({
    lineHeight: 1
});
const $50ffb290c03240e6$var$editButtonStyles = (0, $1ZAYh.xcss)({
    display: 'block',
    margin: 'space.0',
    padding: 'space.0',
    appearance: 'none',
    background: 'transparent',
    border: 0,
    lineHeight: 1,
    outline: 0,
    ':focus-visible': {
        outline: 0
    },
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ':focus + div': {
        borderColor: 'color.border.focused',
        borderWidth: 'border.width.outline',
        borderStyle: 'solid'
    }
});
const $50ffb290c03240e6$var$readViewWrapperStyles = (0, $byn9U.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    border: '2px solid transparent',
    borderRadius: (0, $cGaKT.borderRadius),
    transition: 'background 0.2s',
    '&:hover': {
        background: `var(--ds-background-neutral-subtle-hovered, ${(0, $PdmhA.N30)})`
    }
});
const $50ffb290c03240e6$var$readViewFitContainerWidthStyles = (0, $byn9U.css)({
    width: '100%'
});
const $50ffb290c03240e6$var$DRAG_THRESHOLD = 5;
const $50ffb290c03240e6$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $eUqFw.useRef)(0);
    const startY = (0, $eUqFw.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $50ffb290c03240e6$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $50ffb290c03240e6$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /** If a link is clicked in the read view, default action should be taken */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return (0, $byn9U.jsx)("div", {
        css: $50ffb290c03240e6$var$readViewContainerStyles
    }, (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $50ffb290c03240e6$var$editButtonStyles,
        onClick: onEditRequested,
        ref: editButtonRef,
        testId: testId && `${testId}--edit-button`
    }, (0, $byn9U.jsx)((0, $lkPEe.default), null, editButtonLabel)), (0, $byn9U.jsx)("div", {
        css: [
            $50ffb290c03240e6$var$readViewWrapperStyles,
            readViewFitContainerWidth && $50ffb290c03240e6$var$readViewFitContainerWidthStyles
        ],
        role: "presentation",
        onClick: onReadViewClick,
        onMouseDown: (e)=>{
            startX.current = e.clientX;
            startY.current = e.clientY;
        },
        "data-read-view-fit-container-width": readViewFitContainerWidth
    }, readView()));
};
var $50ffb290c03240e6$export$2e2bcd8739ae039 = $50ffb290c03240e6$var$ReadView;

});


parcelRegister("f8Yej", function(module, exports) {

$parcel$export(module.exports, "default", () => $874373505540c4d3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gtzuR = parcelRequire("gtzuR");
class $874373505540c4d3$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onEscape: null,
            onEnter: null,
            onBlur: null,
            className: undefined
        };
    }
    componentDidMount() {
        // AK Modal uses document.addEventListener() so we also have to use addEventListener.
        // We can't rely on React Synthetic events as stopPropagation won't work
        // This is due to the way React handles events
        // https://github.com/facebook/react/issues/7094
        if (this.ref) this.ref.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        if (this.ref) this.ref.removeEventListener('keydown', this.handleKeyDown);
    }
    render() {
        return(// @ts-expect-error - TS2322 - Type '(() => void) | null' is not assignable to type 'FocusEventHandler<HTMLDivElement> | undefined'.
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            onBlur: this.props.onBlur,
            ref: this.setRef,
            className: this.props.className
        }, this.props.children));
    }
    constructor(...args){
        super(...args);
        this.setRef = (ref)=>{
            this.ref = ref;
        };
        this.handleKeyDown = (event)=>{
            switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('escape'):
                    if (this.props.onEscape) {
                        this.props.onEscape(event);
                        event.stopPropagation();
                    }
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter'):
                    if (this.props.onEnter) {
                        this.props.onEnter(event);
                        event.stopPropagation();
                    }
                    break;
                default:
                    break;
            }
        };
    }
}

});
parcelRegister("gtzuR", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});


parcelRegister("5St1r", function(module, exports) {

$parcel$export(module.exports, "InlineEditContainer", () => $855e16297707df80$export$9f16bbb9a44c7bf6);
$parcel$export(module.exports, "InlineEditContainerExperiment", () => $855e16297707df80$export$409c96a6d46b6d0);
$parcel$export(module.exports, "ReadViewContainer", () => $855e16297707df80$export$ebb3489b83262b26);
$parcel$export(module.exports, "readOnlyViewContainerSelectorName", () => $855e16297707df80$export$dafe48f89a07868a);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");
/*
 Using calc as this margin negates 2 things:
 - Left displacement which ensures there's more space for the input element that becomes visible on focus.
 - The focus outline offset for the badge (implemented as a 2px border) which is in PX everywhere currently.
 The REM is affected by browser font size settings while PX isn't. So, this ensures the spacing behaves in a consistent manner.
 */ const $855e16297707df80$var$MARGIN_LEFT = `calc(${"var(--ds-space-negative-075, -6px)"} - 2px)`;
const $855e16297707df80$export$9f16bbb9a44c7bf6 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "q52d93-0"
})`margin-left:${()=>(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? $855e16297707df80$var$MARGIN_LEFT : "var(--ds-space-negative-100, -8px)"};margin-top:${"var(--ds-space-negative-100, -8px)"};padding-right:${"var(--ds-space-100, 8px)"};& div[data-read-view-fit-container-width]{width:100%;min-height:${(0, $c9TLT.gridSize) * 4}px;${({ hasValue: hasValue })=>hasValue ? // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-css-tagged-template-expression
    (0, $kwce8.css)`padding:0;` : // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-css-tagged-template-expression
    (0, $kwce8.css)`padding:${"var(--ds-space-100, 8px)"} 0;`}}`;
const $855e16297707df80$export$409c96a6d46b6d0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasValue: hasValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0x0bf _19pkx0bf _u5f3u2gc _6vgs1osq _1rjezwfg",
            __cmplp.hasValue ? "_osjgidpf _2g9bidpf _alyvidpf _pa3xidpf" : "_osjg1v6z _2g9bidpf _alyv1v6z _pa3xidpf",
            __cmplp.className
        ])
    });
});
const $855e16297707df80$export$ebb3489b83262b26 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "q52d93-1"
})({
    wordBreak: 'break-word',
    position: 'relative',
    left: "var(--ds-space-075, 6px)"
});
const $855e16297707df80$var$readViewContainerSelectorName = 'jira-issue-field-inline-edit-read-view-container';
const $855e16297707df80$export$dafe48f89a07868a = 'jira-issue-field-inline-edit-readonly-view-container';
const $855e16297707df80$export$5c18970ef161f5b6 = `[data-component-selector="${$855e16297707df80$var$readViewContainerSelectorName}"]`;
const $855e16297707df80$export$eab846169c2a4f66 = `[data-component-selector="${$855e16297707df80$export$dafe48f89a07868a}"]`;
$855e16297707df80$export$ebb3489b83262b26.defaultProps = {
    'data-component-selector': $855e16297707df80$var$readViewContainerSelectorName
}; // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $855e16297707df80$export$646e0a1b0db8be98 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1nmz1hna _kqswh2mm _1ltv12x7",
            __cmplp.className
        ])
    });
});
const $855e16297707df80$export$3b079ed2709f4949 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});

});



parcelRegister("9zKvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0c82e456ac60014$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $b0c82e456ac60014$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    nonEditablePlaceholderText: {
        "id": "issue.views.field.rich-text.nonEditablePlaceholderText",
        "defaultMessage": "None"
    }
});

});

parcelRegister("lBM0g", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1c11074c8afe974$export$2e2bcd8739ae039);
/* rich-text-field-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $4jpQt = parcelRequire("4jpQt");

const $b1c11074c8afe974$export$b6c2380c03bebc2b = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("3lwIp")), {
    moduleId: "./src/packages/issue/issue-view-common/src/component/editor/index.tsx"
});
function $b1c11074c8afe974$export$2e2bcd8739ae039(props) {
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4jpQt.IssueEditorReadonly), {
        mediaContext: props.mediaContext,
        defaultValue: props.value,
        onViewRefresh: props.onViewRefresh
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1c11074c8afe974$var$EditorContainer // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-testid": "issue.views.field.rich-text.editor-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4jpQt.IssueEditorBoundary), {
        packageName: "issue",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1c11074c8afe974$export$b6c2380c03bebc2b, {
        portalElement: props.portalElement,
        mediaContext: props.mediaContext,
        onViewRefresh: props.onViewRefresh,
        onUploadRefresh: props.onUploadRefresh,
        mentionProvider: props.mentionProvider,
        contextIdentifier: props.contextIdentifier,
        mentionEncoder: props.mentionEncoder,
        activityProvider: props.activityProvider,
        emojiProvider: props.emojiProvider,
        externalId: props.externalId,
        defaultValue: props.value,
        onCancel: props.onCancel,
        onBlur: props.onBlur,
        onSave: props.onSave,
        onChange: props.onChange,
        isDisabled: props.isDisabled,
        isInvalid: props.isInvalid,
        isExpanded: props.isExpanded,
        actionsRef: props.editorActionsRef,
        shouldFocus: props.shouldFocus,
        onSaveFailure: props.onSaveFailure,
        onChangeFailure: props.onChangeFailure,
        onPaste: props.onPaste,
        useStickyToolbar: true,
        ...props.assistiveLabel && {
            assistiveLabel: props.assistiveLabel
        }
    })));
}
$b1c11074c8afe974$export$2e2bcd8739ae039.defaultProps = {
    isDisabled: false,
    isInvalid: false,
    isExpanded: false,
    shouldFocus: false,
    value: null,
    mediaContext: null,
    mentionEncoder: null,
    emojiProvider: null,
    onPaste: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
$b1c11074c8afe974$export$2e2bcd8739ae039.displayName = 'RichTextFieldView'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b1c11074c8afe974$var$EditorContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("40QX1", function(module, exports) {

$parcel$export(module.exports, "isFieldInTabSelector", () => $4d3d77328f6bd8e2$export$d1559f6929d096f8);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $4d3d77328f6bd8e2$export$982ea170efb9d0c1 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesIssueSelector), (issue)=>issue && issue.tabs || {});
const $4d3d77328f6bd8e2$export$d1559f6929d096f8 = (fieldId)=>(0, $df4Sl.createSelector)($4d3d77328f6bd8e2$export$982ea170efb9d0c1, (tabs)=>Boolean(Object.keys(tabs).find((tabId)=>tabs[tabId].items.find((item)=>item.id === fieldId))));

});

parcelRegister("323Nh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f8b07eccdac18493$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $f8b07eccdac18493$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    noValueText: {
        "id": "issue.multiline-field.empty-placeholder",
        "defaultMessage": "None"
    }
});

});


parcelRegister("gyN16", function(module, exports) {

$parcel$export(module.exports, "default", () => $105d135961624d03$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c8Guq = parcelRequire("c8Guq");

var $5iWql = parcelRequire("5iWql");

var $k7cZh = parcelRequire("k7cZh");

var $41ICj = parcelRequire("41ICj");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $bYYP0 = parcelRequire("bYYP0");

var $cEDU9 = parcelRequire("cEDU9");

var $0NycV = parcelRequire("0NycV");

var $brySu = parcelRequire("brySu");

var $3uwfp = parcelRequire("3uwfp");

var $3PPRL = parcelRequire("3PPRL");

var $f9RL0 = parcelRequire("f9RL0");

var $j3Krp = parcelRequire("j3Krp");

var $cp79T = parcelRequire("cp79T");

var $hG9XE = parcelRequire("hG9XE");

var $20th5 = parcelRequire("20th5");

var $hlJEN = parcelRequire("hlJEN");

var $kzOoN = parcelRequire("kzOoN");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $gS8e9 = parcelRequire("gS8e9");

var $1Pjbl = parcelRequire("1Pjbl");

var $40QX1 = parcelRequire("40QX1");

var $1TrR5 = parcelRequire("1TrR5");

var $fayGz = parcelRequire("fayGz");

var $kMgpX = parcelRequire("kMgpX");
const $105d135961624d03$var$performPut = (issueKey, value)=>{
    const url = `/rest/api/3/issue/${issueKey}`;
    return (0, $lRmyA.performPutRequest)(url, {
        body: JSON.stringify({
            fields: {
                description: value
            }
        })
    });
};
const $105d135961624d03$var$SCROLL_MARGIN_TOP = 100;
const $105d135961624d03$export$336230c809f2ec53 = (props)=>{
    const { onEditRequest: onEditRequest, onConfirm: onConfirm } = props;
    const [{ recommendationDetails: recommendationDetails }, linkPasteActions] = (0, $41ICj.useDevOpsAppRecommendationsStore)();
    const editorActionsRef = (0, $eUqFw.useRef)(null);
    const editorRef = (0, $eUqFw.useRef)(null);
    const focusOnEditor = (0, $eUqFw.useCallback)(()=>{
        if (editorActionsRef?.current) editorActionsRef.current.focus();
    }, [
        editorActionsRef
    ]);
    const onEditRequestHandler = (0, $eUqFw.useCallback)(()=>{
        if ((0, $1ybV0.ff)('issue-update-analytics-events-on-issue-view')) (0, $bYYP0.getUpdateAnalyticsFlowHelper)().setAttributes('description', {
            isCommandPaletteEditing: false
        });
        onEditRequest();
    }, [
        onEditRequest
    ]);
    const onCompalEditRequestHandler = (0, $eUqFw.useCallback)(()=>{
        if ((0, $1ybV0.ff)('issue-update-analytics-events-on-issue-view')) (0, $bYYP0.getUpdateAnalyticsFlowHelper)().setAttributes('description', {
            isCommandPaletteEditing: true
        });
        onEditRequest();
        // prevent race condition when editor has not finished rendering immediately
        setTimeout(()=>{
            focusOnEditor?.();
            if (editorRef?.current) {
                if (editorRef.current.offsetHeight > window.innerHeight / 2) editorRef.current.scrollIntoView({
                    block: 'end'
                });
                else (0, $k7cZh.default)(editorRef.current, {
                    block: 'start',
                    scrollMode: 'if-needed',
                    // this behaves like scrollMarginTop style property
                    behavior: (actions)=>actions.forEach(({ el: el, top: top })=>{
                            // eslint-disable-next-line no-param-reassign
                            el.scrollTop = top - $105d135961624d03$var$SCROLL_MARGIN_TOP;
                        })
                });
            }
        });
    }, [
        onEditRequest,
        focusOnEditor,
        editorRef
    ]);
    const onConfirmHandler = (0, $eUqFw.useCallback)(()=>{
        onConfirm();
        if ((0, $3PPRL.isDevOpsAppRecommenderEnabled)() && recommendationDetails) linkPasteActions.setShowRecommendation(true);
    }, [
        onConfirm,
        recommendationDetails,
        linkPasteActions
    ]);
    (0, $kMgpX.useRegisterInCommandPalette)({
        onEditRequest: onCompalEditRequestHandler
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($105d135961624d03$var$EditorContainer, {
        ref: editorRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEDU9.default), {
        ...props,
        onEditRequest: onEditRequestHandler,
        onConfirm: onConfirmHandler,
        editorActionsRef: editorActionsRef
    }));
};
const $105d135961624d03$var$onExpandedFailureFactory = (0, $5iWql.default)((dispatch)=>()=>dispatch((0, $hG9XE.editorExpandedFailure)()));
const $105d135961624d03$var$onSaveFailureFactory = (0, $5iWql.default)((dispatch)=>()=>dispatch((0, $hG9XE.editorSaveFailure)()));
const $105d135961624d03$var$onChangeFailureFactory = (0, $5iWql.default)((dispatch)=>()=>dispatch((0, $hG9XE.editorChangeFailure)()));
const $105d135961624d03$var$onViewRefreshFactory = (0, $5iWql.default)((dispatch)=>()=>dispatch((0, $hlJEN.fetchViewContextRequest)()));
const $105d135961624d03$var$onUploadRefreshFactory = (0, $5iWql.default)((dispatch)=>()=>dispatch((0, $20th5.fetchUploadContextRequest)()));
var $105d135961624d03$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $j3Krp.withEditExperienceTracker)((0, $f9RL0.DESCRIPTION)), (0, $3uwfp.default)(()=>({
        fieldId: (0, $f9RL0.DESCRIPTION),
        shouldSaveDraft: true,
        isOptimistic: true,
        saveField: ({ issueKey: issueKey, value: value })=>$105d135961624d03$var$performPut(issueKey, value),
        canContainMediaContent: true,
        onSaveFailureFlagType: (0, $0NycV.RICH_CONTENT_FIELD_CONFIRM_ERROR),
        // @ts-expect-error - TS2322 - Type '(state: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, intl: IntlShapeV2) => { ...' is not assignable to type 'AdditionalProps<unknown>'.
        additionalProps: (state, intl)=>{
            const baseUrl = (0, $5JqpU.baseUrlSelector)(state);
            return {
                baseUrl: baseUrl,
                portalElement: (0, $40QX1.isFieldInTabSelector)((0, $f9RL0.DESCRIPTION))(state) ? // Using a portal element here because otherwise dropdowns would get cut off
                // See: https://jdog.jira-dev.com/browse/BENTO-4100
                (0, $brySu.getIssueModalEditorDropdownPortal)() || document.body : undefined,
                adfValue: (0, $fokFV.fieldEditingAdfValueSelector)((0, $f9RL0.DESCRIPTION))(state),
                htmlValue: (0, $fokFV.fieldHtmlValueSelector)((0, $f9RL0.DESCRIPTION))(state),
                isInvalid: (0, $fokFV.fieldInvalidSelector)((0, $f9RL0.DESCRIPTION))(state),
                invalidMessage: (0, $fokFV.fieldInvalidMessageSelector)((0, $f9RL0.DESCRIPTION))(state),
                mediaContext: (0, $gS8e9.mediaContextSelector)(state),
                mentionProvider: (0, $cp79T.mentionProviderSelector)(state),
                contextIdentifier: (0, $1Pjbl.richDescriptionContextIdentifierSelector)(state),
                activityProvider: (0, $kzOoN.activityProviderSelector)(state),
                externalId: 'issue.descriptionHtml',
                noValueText: intl.formatMessage((0, $fayGz.messages).noValueText)
            };
        },
        additionalCallbacks: (0, $1TrR5.functionWithFFRedux)((dispatch)=>({
                onExpandedFailure: $105d135961624d03$var$onExpandedFailureFactory(dispatch),
                onSaveFailure: $105d135961624d03$var$onSaveFailureFactory(dispatch),
                onChangeFailure: $105d135961624d03$var$onChangeFailureFactory(dispatch),
                onViewRefresh: $105d135961624d03$var$onViewRefreshFactory(dispatch),
                onUploadRefresh: $105d135961624d03$var$onUploadRefreshFactory(dispatch)
            }), (dispatch)=>({
                onExpandedFailure: ()=>dispatch((0, $hG9XE.editorExpandedFailure)()),
                onSaveFailure: ()=>dispatch((0, $hG9XE.editorSaveFailure)()),
                onChangeFailure: ()=>dispatch((0, $hG9XE.editorChangeFailure)()),
                onViewRefresh: ()=>dispatch((0, $hlJEN.fetchViewContextRequest)()),
                onUploadRefresh: ()=>dispatch((0, $20th5.fetchUploadContextRequest)())
            }))
    })))($105d135961624d03$export$336230c809f2ec53);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $105d135961624d03$var$EditorContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1b0m53f4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j3Krp", function(module, exports) {

$parcel$export(module.exports, "withEditExperienceTracker", () => $2d2daed7e1f57986$export$f5fdb76fdfd05fdb);

var $eUqFw = parcelRequire("eUqFw");

var $9nqhv = parcelRequire("9nqhv");
var $jUWXQ = parcelRequire("jUWXQ");

var $lqalZ = parcelRequire("lqalZ");

var $gbger = parcelRequire("gbger");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $cJkBv = parcelRequire("cJkBv");
const $2d2daed7e1f57986$export$14eff82cfc592437 = (0, $lqalZ.connect)((state)=>({
        experience: 'editIssue',
        application: (0, $gbger.applicationSelector)(state),
        edition: (0, $gbger.applicationEditionSelector)(state),
        analyticsSource: (0, $5JqpU.analyticsSourceSelector)(state)
    }), {})((0, $jUWXQ.default));
const $2d2daed7e1f57986$var$EditExperienceTracker = (0, $lqalZ.connect)((state, ownProps)=>({
        field: ownProps.fieldId,
        isEditing: (0, $fokFV.isFieldEditingSelector)(ownProps.fieldId)(state)
    }), {})((0, $9nqhv.default));
const $2d2daed7e1f57986$export$f5fdb76fdfd05fdb = (fieldId)=>(ComponentBeingTracked)=>{
        const WithEditExperienceTracker = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2d2daed7e1f57986$var$EditExperienceTracker, {
                fieldId: fieldId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentBeingTracked, props));
        WithEditExperienceTracker.displayName = `WithEditExperienceTracker(${(0, $cJkBv.getComponentDisplayName)(ComponentBeingTracked)})`;
        return WithEditExperienceTracker;
    };

});
parcelRegister("9nqhv", function(module, exports) {

$parcel$export(module.exports, "default", () => $a739ba1d1af88c72$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $kogDC = parcelRequire("kogDC");

var $k7MHL = parcelRequire("k7MHL");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a739ba1d1af88c72$export$2e2bcd8739ae039 = (props)=>// We need `onFailure` to be available in the experience tracker's
    // lifecycle methods. The version of React we're on doesn't support `Class.contextType`,
    // (v16.6.0 needed) so we're using a wrapper component to achieve this instead.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kogDC.default).Consumer, null, (context)=>{
        if (context === null) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('edit-experience-tracker.missing-provider', 'Edit experience tracker rendered without a provider');
            return props.children;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k7MHL.default), {
            field: props.field,
            isEditing: props.isEditing,
            onFailure: context.onFailure
        }, props.children);
    });

});
parcelRegister("k7MHL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d37c2d9307adb8e2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $JRB5w = parcelRequire("JRB5w");
class $d37c2d9307adb8e2$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidCatch(error) {
        // This filters for any errors that are related to network connectivity
        // We don't care to send any failure event should this happen.
        if (this.props.isEditing && !(0, $JRB5w.isClientFetchError)(error)) {
            // @ts-expect-error - TS2339 - Property 'traceId' does not exist on type 'Error'.
            const { message: message, traceId: traceId } = error;
            this.props.onFailure(this.props.field, message, {
                ...traceId !== undefined && traceId !== null ? {
                    traceId: traceId
                } : {}
            });
        }
        throw error;
    }
    render() {
        return this.props.children;
    }
}

});



parcelRegister("1Pjbl", function(module, exports) {

$parcel$export(module.exports, "richDescriptionContextIdentifierSelector", () => $d06945a40c350770$export$6cbce610807abdcc);

var $df4Sl = parcelRequire("df4Sl");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");
const $d06945a40c350770$export$6cbce610807abdcc = (0, $df4Sl.createSelector)((0, $5JqpU.issueIdSelector), (0, $jZDJX.projectIdSelector), (issueId, projectId)=>({
        objectId: issueId,
        containerId: projectId
    }));

});

parcelRegister("fayGz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0e62b651d9c09b8b$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $0e62b651d9c09b8b$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    noValueText: {
        "id": "issue.placeholder-for-empty-issue-description-field",
        "defaultMessage": "Add a description..."
    }
});

});

parcelRegister("kMgpX", function(module, exports) {

$parcel$export(module.exports, "useRegisterInCommandPalette", () => $5839bd223c5880d6$export$5013d91483149826);

var $eUqFw = parcelRequire("eUqFw");

var $bZ1Zi = parcelRequire("bZ1Zi");

var $6jiFZ = parcelRequire("6jiFZ");

var $46gH8 = parcelRequire("46gH8");
var $36mrL = parcelRequire("36mrL");
var $gfXKy = parcelRequire("gfXKy");

var $fmmnJ = parcelRequire("fmmnJ");
var $gjNh9 = parcelRequire("gjNh9");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");

var $dEg1m = parcelRequire("dEg1m");
const $5839bd223c5880d6$export$5013d91483149826 = ({ onEditRequest: onEditRequest })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const [{ canEditIssues: canEditIssues }] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    const commands = canEditIssues ? [
        {
            id: `issue-edit-description-${issueKey}`,
            name: formatMessage((0, $dEg1m.messages).editDescription),
            keywords: getKeywords('editDescriptionSynonyms'),
            primaryAction: {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>onEditRequest()
            },
            section: (0, $46gH8.getCommandPaletteIssueActionsHeader)(issueKey),
            priority: (0, $36mrL.getCommandPaletteIssueActionsPriority)('OLD_ISSUE_FIELDS'),
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZ1Zi))), {
                        label: formatMessage((0, $dEg1m.messages).editDescription)
                    })
            },
            analytics: {
                action: 'updateDescription'
            }
        }
    ] : [];
    (0, $gjNh9.useRegisterCommands)((0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).DESCRIPTION, commands, [
        issueKey,
        canEditIssues
    ]);
};

});
parcelRegister("bZ1Zi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b96eef1afb7c03f$var$_react = $8b96eef1afb7c03f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $8b96eef1afb7c03f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8b96eef1afb7c03f$var$EditIcon = (props)=>/*#__PURE__*/ $8b96eef1afb7c03f$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4.02 19.23a1 1 0 001.18 1.18l3.81-.78-4.21-4.21-.78 3.81zm5.921-2.62l-2.12-2.12L16.306 6h.002l2.121 2.121-8.489 8.49zm9.903-9.903l-2.12-2.122A1.997 1.997 0 0016.308 4c-.512 0-1.024.195-1.415.585l-9.757 9.758 4.95 4.95 9.757-9.758a2 2 0 000-2.828z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$8b96eef1afb7c03f$var$EditIcon.displayName = 'EditIcon';
var $8b96eef1afb7c03f$var$_default = $8b96eef1afb7c03f$var$EditIcon;
module.exports.default = $8b96eef1afb7c03f$var$_default;

});

parcelRegister("gjNh9", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommands", () => $5aa93b9a91fcbcd2$export$3f626f8a5dbc29e4);

var $fqCN8 = parcelRequire("fqCN8");
const $5aa93b9a91fcbcd2$export$3f626f8a5dbc29e4 = (0, $fqCN8.useRegisterCommandsWithRegistry);

});

parcelRegister("dEg1m", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2a6e5bf8d1d74647$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $2a6e5bf8d1d74647$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    editDescription: {
        "id": "issue.placeholder-for-empty-issue-description-field",
        "defaultMessage": "Edit description"
    }
});

});




parcelRegister("juEyd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d37e8e4785b90d7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $73FRM = parcelRequire("73FRM");

var $lqalZ = parcelRequire("lqalZ");

var $fokFV = parcelRequire("fokFV");

var $xOSTC = parcelRequire("xOSTC");

var $bMnlH = parcelRequire("bMnlH");
const $0d37e8e4785b90d7$var$SwitchingMultilineField = (props)=>{
    const { isRichTextField: isRichTextField, fieldId: fieldId, area: area = (0, $73FRM.CONTEXT) } = props;
    return isRichTextField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bMnlH.default), {
        fieldId: fieldId,
        area: area
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xOSTC.default), {
        fieldId: fieldId,
        area: area
    });
};
var $0d37e8e4785b90d7$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state, ownProps)=>({
        // @ts-expect-error - TS2339 - Property 'fieldId' does not exist on type '{}'. | TS2345 - Argument of type '{}' is not assignable to parameter of type 'Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>'.
        isRichTextField: (0, $fokFV.isRichTextFieldSelector)(ownProps.fieldId)(state)
    }), {})($0d37e8e4785b90d7$var$SwitchingMultilineField);

});
parcelRegister("xOSTC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e69c060426eb806a$export$2e2bcd8739ae039);

var $1XHYi = parcelRequire("1XHYi");

var $3uwfp = parcelRequire("3uwfp");

var $lhCbW = parcelRequire("lhCbW");
var $e69c060426eb806a$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        // @ts-expect-error - TS2322 - Type '(state: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, intl: IntlShapeV2) => { ...' is not assignable to type 'AdditionalProps<unknown>'.
        additionalProps: (state, intl)=>({
                noValueText: intl.formatMessage((0, $lhCbW.default).noValue),
                area: ownPropsOnMount.area
            })
    }))((0, $1XHYi.default));

});
parcelRegister("1XHYi", function(module, exports) {

$parcel$export(module.exports, "default", () => $89450c739e702534$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $f8Yej = parcelRequire("f8Yej");

var $2gGF1 = parcelRequire("2gGF1");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9LvPd = parcelRequire("9LvPd");

var $64ypR = parcelRequire("64ypR");

var $4bZws = parcelRequire("4bZws");

var $4xwq2 = parcelRequire("4xwq2");

var $73FRM = parcelRequire("73FRM");

var $hHKWU = parcelRequire("hHKWU");

var $78fR1 = parcelRequire("78fR1");

var $iAc02 = parcelRequire("iAc02");

var $7Vbpp = parcelRequire("7Vbpp");

var $9UgW8 = parcelRequire("9UgW8");

var $khMio = parcelRequire("khMio");
const $89450c739e702534$export$2bf68416ce940128 = ({ isEditable: isEditable = false, isEditing: isEditing = false, isConfirmOnBlurDisabled: isConfirmOnBlurDisabled = false, value: value = '', label: label = '', noValueText: noValueText = null, invalidMessage: invalidMessage = null, fieldId: fieldId, area: area, onEditRequest: onEditRequest, onCancel: onCancel, onChange: onChange, onConfirm: onConfirm, issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleOnConfirm = ()=>{
        if (value !== null) onChange((0, $7Vbpp.removeTrailingNewLineCharacters)(value));
        onConfirm();
    };
    const readView = (0, $eUqFw.useRef)();
    const renderReadView = ()=>{
        if (value && value.trim().length !== 0) {
            if (area === (0, $73FRM.CONTENT) || area === (0, $73FRM.CONTENT_REQUEST)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9UgW8.TextContentAreaWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.TextContentArea), {
                "data-testid": "issue-internal-fields.text-area.text-content-area",
                // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'
                ref: readView
            }, value && (0, $7Vbpp.removeTrailingNewLineCharacters)(value)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9UgW8.ScrollableAreaWrapper), {
                isEditable: isEditable
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.ScrollableArea), {
                ref: readView,
                maxRows: (0, $khMio.MAX_ROWS_CONTEXT)
            }, value));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9UgW8.EmptyValueWrapper), {
            isEditable: isEditable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), null, noValueText));
    };
    const renderEditView = ()=>{
        let scrollRows;
        if (readView.current) {
            // @ts-expect-error - TS2339 - Property 'scrollHeight' does not exist on type 'unknown'.
            const { scrollHeight: scrollHeight } = readView.current;
            // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'Element'.
            const style = window.getComputedStyle(readView.current);
            const lineHeight = Number.parseFloat(style.getPropertyValue('line-height'));
            scrollRows = Math.round(scrollHeight / lineHeight);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $khMio.default), {
            value: value,
            onChange: onChange,
            invalidMessage: invalidMessage,
            scrollRows: scrollRows,
            area: area
        });
    };
    const getField = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
            onEscape: onCancel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9UgW8.InlineEditContainer), {
            isEditable: isEditable,
            isEditing: isEditing,
            // @ts-expect-error - TS2322 - Type '{ children: Element; isEditable: boolean; isEditing: boolean; isContentArea: boolean; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { ...; }, any>, any, any>> & Readonly<...> & Readonly<...>'.
            isContentArea: area === (0, $73FRM.CONTENT)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78fR1.default), {
            isLabelHidden: true,
            label: label,
            isEditable: isEditable,
            readView: renderReadView(),
            editView: isEditable ? renderEditView() : null,
            disableEditViewFieldBase: true,
            isEditing: isEditing,
            onConfirm: handleOnConfirm,
            onCancel: onCancel,
            onEditRequested: onEditRequest,
            isFitContainerWidthReadView: true,
            isConfirmOnBlurDisabled: isConfirmOnBlurDisabled,
            editButtonLabel: formatMessage((0, $2gGF1.default).editButtonLabel, {
                fieldName: label
            }),
            confirmButtonLabel: formatMessage((0, $2gGF1.default).confirmButtonLabel, {
                fieldName: label
            }),
            cancelButtonLabel: formatMessage((0, $2gGF1.default).cancelButtonLabel, {
                fieldName: label
            })
        })));
    const showPinButton = (0, $hHKWU.default)(area);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9UgW8.TextareaWrapper), null, area === (0, $73FRM.CONTENT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeading), {
        leftAlign: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingTitle), null, label), issueKey !== undefined && fieldId !== undefined && // @ts-expect-error label is required, please pass it through when working on this code.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldId
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.MultilineFieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.MultilineFieldHeadingTitle), null, label), issueKey !== undefined && fieldId !== undefined && // @ts-expect-error label is required, please pass it through when working on this code.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldId
    }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldId,
        label: label
    })), getField());
};
var $89450c739e702534$export$2e2bcd8739ae039 = $89450c739e702534$export$2bf68416ce940128;

});
parcelRegister("9UgW8", function(module, exports) {

$parcel$export(module.exports, "TextareaWrapper", () => $a04493538d2237c1$export$89a319cd58975ce0);
$parcel$export(module.exports, "InlineEditContainer", () => $a04493538d2237c1$export$9f16bbb9a44c7bf6);
$parcel$export(module.exports, "ScrollableAreaWrapper", () => $a04493538d2237c1$export$853f2229d5810c56);
$parcel$export(module.exports, "EmptyValueWrapper", () => $a04493538d2237c1$export$4982fecb4dd2826a);
$parcel$export(module.exports, "TextContentAreaWrapper", () => $a04493538d2237c1$export$dc8e4c2c9f964048);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $a04493538d2237c1$export$89a319cd58975ce0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_i2q7idpf _2d6bidpf _2i7kidpf",
            __cmplp.className
        ])
    });
});
const $a04493538d2237c1$export$9f16bbb9a44c7bf6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, isEditing: isEditing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1bohx0bf _1gzc1txw _auuz1h6o _1o4r1hna _osjgidpf _alyvidpf _pa3xidpf _2g9b12x7",
            __cmplp.isEditable ? "_19pkr5cr" : "_19pkx0bf _n3td1b66",
            __cmplp.isEditing && "_2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $a04493538d2237c1$export$9bae7ab71a95b847 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0x0bf",
            __cmplp.className
        ])
    });
});
const $a04493538d2237c1$export$853f2229d5810c56 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isEditable && "_19bv12x7",
            __cmplp.className
        ])
    });
});
const $a04493538d2237c1$export$4982fecb4dd2826a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isEditable ? "_ca0qidpf" : "_ca0q1b66",
            __cmplp.isEditable ? "_n3tdidpf" : "_n3tdv77o",
            __cmplp.isEditable ? "_19bv12x7" : "_19bvidpf",
            __cmplp.isEditable ? "_u5f312x7" : "_u5f3idpf",
            __cmplp.className
        ])
    });
});
const $a04493538d2237c1$export$dc8e4c2c9f964048 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u012x7",
            __cmplp.className
        ])
    });
});

});

parcelRegister("khMio", function(module, exports) {

$parcel$export(module.exports, "MAX_ROWS_CONTEXT", () => $37abdc86c51c5f8e$export$960389c2c178a9c9);
$parcel$export(module.exports, "default", () => $37abdc86c51c5f8e$export$2e2bcd8739ae039);
/* text-area-field-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $xeS7R = parcelRequire("xeS7R");

var $73FRM = parcelRequire("73FRM");
const $37abdc86c51c5f8e$var$MIN_ROWS = 2;
const $37abdc86c51c5f8e$export$960389c2c178a9c9 = 5;
const $37abdc86c51c5f8e$export$650f8d92d421a159 = 20;
const $37abdc86c51c5f8e$var$countRows = (value)=>{
    if (!value) return 0;
    return value.split(/\r\n|\r|\n/).length;
};
const $37abdc86c51c5f8e$var$TextAreaField = (props)=>{
    const onChange = (event)=>{
        props.onChange(event.target.value);
    };
    const numRows = $37abdc86c51c5f8e$var$countRows(props.value);
    const rows = props.scrollRows || numRows;
    const maxRows = props.area === (0, $73FRM.CONTENT) ? $37abdc86c51c5f8e$export$650f8d92d421a159 : $37abdc86c51c5f8e$export$960389c2c178a9c9;
    const minimumRows = Math.min(maxRows, Math.max($37abdc86c51c5f8e$var$MIN_ROWS, rows));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($37abdc86c51c5f8e$var$TextAreaTransparentScrollTrack, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xeS7R.default), {
        value: props.value,
        onChange: onChange,
        isInvalid: !!props.invalidMessage,
        // @ts-expect-error - TS2322 - Type '{ value: string; onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void; isInvalid: boolean; invalidMessage: string | null; shouldFitContainer: true; autoFocus: true; isLabelHidden: true; label: string; minimumRows: number; }' is not assignable to type 'IntrinsicAttributes & Pick<Combine<Pick<TextareaHTMLAttributes<HTMLTextAreaElement>, "dir" | "form" | "slot" | ... 262 more ... | "dirName">, OwnProps>, "dir" | ... 277 more ... | "isMonospaced"> & RefAttributes<...>'.
        invalidMessage: props.invalidMessage,
        shouldFitContainer: true,
        autoFocus: true,
        isLabelHidden: true,
        label: "",
        minimumRows: minimumRows
    }));
};
$37abdc86c51c5f8e$var$TextAreaField.defaultProps = {
    value: '',
    invalidMessage: null,
    scrollRows: null,
    area: (0, $73FRM.CONTEXT)
};
$37abdc86c51c5f8e$var$TextAreaField.displayName = 'TextAreaField';
var $37abdc86c51c5f8e$export$2e2bcd8739ae039 = $37abdc86c51c5f8e$var$TextAreaField;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $37abdc86c51c5f8e$var$TextAreaTransparentScrollTrack = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1nlaftgi _1a2118uv _1qlirg55 _bsk719bv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("xeS7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe3143162b284fd$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $dkGpW = parcelRequire("dkGpW");
const $2fe3143162b284fd$var$packageName = undefined;
const $2fe3143162b284fd$var$packageVersion = undefined;
const $2fe3143162b284fd$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $2fe3143162b284fd$var$packageName,
    packageVersion: $2fe3143162b284fd$var$packageVersion
};
const $2fe3143162b284fd$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = (0, $dkGpW.borderWidth);
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $2fe3143162b284fd$var$InnerTextArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const ourRef = (0, $eUqFw.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
    (0, $eUqFw.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eUqFw.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const baseStyles = (0, $eUqFw.useMemo)(()=>(0, $dkGpW.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        }), [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    const textAreaStyles = /*#__PURE__*/ (0, $byn9U.css)([
        baseStyles,
        (0, $dkGpW.dynamicStyles)(appearance)
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        // TODO refactor to follow emotion styling rules
        // see: https://product-fabric.atlassian.net/browse/DSP-6060
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: textAreaStyles,
        ...rest
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $2fe3143162b284fd$var$TextArea = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($2fe3143162b284fd$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$2fe3143162b284fd$var$TextArea.displayName = 'TextArea';
var $2fe3143162b284fd$export$2e2bcd8739ae039 = $2fe3143162b284fd$var$TextArea;

});
parcelRegister("dkGpW", function(module, exports) {

$parcel$export(module.exports, "borderWidth", () => $ffa47244c710aa2a$export$12879c7697ed953d);
$parcel$export(module.exports, "getBaseStyles", () => $ffa47244c710aa2a$export$bff8031d86bb089);
$parcel$export(module.exports, "dynamicStyles", () => $ffa47244c710aa2a$export$98856a888ef36079);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");

var $9rnqv = parcelRequire("9rnqv");
function $ffa47244c710aa2a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ffa47244c710aa2a$var$disabledRules = {
    backgroundColor: $9rnqv.disabledBackground,
    backgroundColorFocus: $9rnqv.disabledBackground,
    backgroundColorHover: $9rnqv.disabledBackground,
    borderColor: $9rnqv.disabledBorder,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    textColor: $9rnqv.disabledTextColor
};
const $ffa47244c710aa2a$var$invalidRules = {
    borderColor: $9rnqv.invalidBorderColor,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    backgroundColor: $9rnqv.defaultBackgroundColor,
    backgroundColorFocus: $9rnqv.defaultBackgroundColorFocus,
    backgroundColorHover: $9rnqv.defaultBackgroundColorHover
};
const $ffa47244c710aa2a$var$backgroundColor = {
    standard: $9rnqv.defaultBackgroundColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorFocus = {
    standard: $9rnqv.defaultBackgroundColorFocus,
    subtle: $9rnqv.defaultBackgroundColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorHover = {
    standard: $9rnqv.defaultBackgroundColorHover,
    subtle: $9rnqv.defaultBackgroundColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColor = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorFocus = {
    standard: $9rnqv.defaultBorderColorFocus,
    subtle: $9rnqv.defaultBorderColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorHover = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.subtleBorderColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$grid = (0, $lcnyw.gridSize)();
const $ffa47244c710aa2a$var$lineHeightBase = $ffa47244c710aa2a$var$grid * 2.5;
const $ffa47244c710aa2a$var$lineHeightCompact = $ffa47244c710aa2a$var$grid * 2;
const $ffa47244c710aa2a$var$compactVerticalPadding = 2;
const $ffa47244c710aa2a$var$verticalPadding = 6;
const $ffa47244c710aa2a$var$horizontalPadding = $ffa47244c710aa2a$var$grid;
const $ffa47244c710aa2a$var$transitionDuration = '0.2s';
const $ffa47244c710aa2a$var$fontSize = (0, $lcnyw.fontSize)();
const $ffa47244c710aa2a$var$fontFamily = (0, $lcnyw.fontFamily)();
const $ffa47244c710aa2a$var$codeFontFamily = (0, $lcnyw.codeFontFamily)();
const $ffa47244c710aa2a$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
const $ffa47244c710aa2a$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
const $ffa47244c710aa2a$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
    const contentHeight = $ffa47244c710aa2a$var$lineHeightBase * minimumRows;
    return contentHeight + $ffa47244c710aa2a$var$verticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
    const contentHeightCompact = $ffa47244c710aa2a$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $ffa47244c710aa2a$var$compactVerticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$bgAndBorderColorStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$borderColorFocus[appearance]}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColorFocus}`
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
        },
        // Disabled background and border styles should not be applied to components that
        // have either no background or transparent background to begin with
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...appearance === 'standard' ? {
            '&:disabled:focus': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorFocus,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColorFocus
            },
            '&:disabled:not(:focus)': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColor,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColor
            }
        } : {}
    });
const $ffa47244c710aa2a$var$placeholderStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.placeholderTextColor
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $ffa47244c710aa2a$var$disabledRules.textColor
    }
});
const $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
            }
        }
    });
var $ffa47244c710aa2a$var$_ref = {
    name: "utehjx",
    styles: "resize:none"
};
var $ffa47244c710aa2a$var$_ref2 = {
    name: "bolgb9",
    styles: "resize:both"
};
const $ffa47244c710aa2a$var$resizeStyle = (resize)=>{
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.css)({
        resize: resize
    });
    if (resize === 'auto') return $ffa47244c710aa2a$var$_ref2;
    return $ffa47244c710aa2a$var$_ref;
};
const $ffa47244c710aa2a$var$borderStyle = (appearance)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
const $ffa47244c710aa2a$var$fontFamilyStyle = (isMonospaced)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? $ffa47244c710aa2a$var$codeFontFamily : $ffa47244c710aa2a$var$fontFamily
    });
const $ffa47244c710aa2a$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
    const borderWidth = appearance !== 'none' ? 1 : 2;
    const horizontalPaddingWithoutBorderWidth = $ffa47244c710aa2a$var$horizontalPadding - borderWidth;
    const borderHeight = borderWidth;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            lineHeight: $ffa47244c710aa2a$var$lineHeightCompact / $ffa47244c710aa2a$var$fontSize
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            lineHeight: $ffa47244c710aa2a$var$lineHeightBase / $ffa47244c710aa2a$var$fontSize
        }
    });
};
const $ffa47244c710aa2a$var$staticStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    fontSize: $ffa47244c710aa2a$var$fontSize,
    outline: 'none',
    overflow: 'auto',
    transition: `background-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out,
               border-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out`,
    wordWrap: 'break-word',
    '&:disabled': {
        cursor: 'not-allowed',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$ffa47244c710aa2a$var$overrideSafariDisabledStyles
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
const $ffa47244c710aa2a$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderStyle(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    });
const $ffa47244c710aa2a$export$98856a888ef36079 = (appearance)=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.textColor,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $ffa47244c710aa2a$var$disabledRules.textColor
        }
    });

});
parcelRegister("9rnqv", function(module, exports) {

$parcel$export(module.exports, "disabledBackground", () => $f5064939140dcbf4$export$ae3cba7672df0890);
$parcel$export(module.exports, "disabledBorder", () => $f5064939140dcbf4$export$fe505fe3c5edbdf6);
$parcel$export(module.exports, "invalidBorderColor", () => $f5064939140dcbf4$export$7f333bbf7ddab792);
$parcel$export(module.exports, "defaultBorderColor", () => $f5064939140dcbf4$export$dafd83031c202ca8);
$parcel$export(module.exports, "defaultBorderColorFocus", () => $f5064939140dcbf4$export$e8320c09dc1e4012);
$parcel$export(module.exports, "defaultBackgroundColor", () => $f5064939140dcbf4$export$b13414ee9ac9cae6);
$parcel$export(module.exports, "defaultBackgroundColorHover", () => $f5064939140dcbf4$export$bca15982c103d57b);
$parcel$export(module.exports, "defaultBackgroundColorFocus", () => $f5064939140dcbf4$export$21287e4b7f134f09);
$parcel$export(module.exports, "subtleBorderColorHover", () => $f5064939140dcbf4$export$a87538d56ee366ec);
$parcel$export(module.exports, "placeholderTextColor", () => $f5064939140dcbf4$export$5e076b2557ef7bbb);
$parcel$export(module.exports, "textColor", () => $f5064939140dcbf4$export$32f78bffcd82ff28);
$parcel$export(module.exports, "disabledTextColor", () => $f5064939140dcbf4$export$eb4a7d363eec53c8);
$parcel$export(module.exports, "transparent", () => $f5064939140dcbf4$export$f4d082c200a4b4b8);

var $PdmhA = parcelRequire("PdmhA");
const $f5064939140dcbf4$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`;
const $f5064939140dcbf4$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $PdmhA.N40)})`;
const $f5064939140dcbf4$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $PdmhA.R400)})`;
const $f5064939140dcbf4$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $PdmhA.N100)})`;
const $f5064939140dcbf4$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $PdmhA.B200)})`;
const $f5064939140dcbf4$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $PdmhA.N10)})`;
const $f5064939140dcbf4$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`;
const $f5064939140dcbf4$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`;
const $f5064939140dcbf4$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
const $f5064939140dcbf4$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`;
const $f5064939140dcbf4$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $PdmhA.N900)})`;
const $f5064939140dcbf4$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $PdmhA.N70)})`;
const $f5064939140dcbf4$export$f4d082c200a4b4b8 = 'transparent';

});





parcelRegister("lhCbW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffa4dbcd04323b82$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $ffa4dbcd04323b82$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noValue: {
        "id": "issue.common.multi-line-text.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "None"
    }
});

});



parcelRegister("fzgBH", function(module, exports) {

$parcel$export(module.exports, "default", () => $89ed115c4c781b17$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5qg5k = parcelRequire("5qg5k");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $lqalZ = parcelRequire("lqalZ");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");
const $89ed115c4c781b17$export$608ee4144b32291c = ({ canViewDevTools: canViewDevTools, issueId: issueId, issueAri: issueAri })=>issueId !== null && issueAri !== null && issueId !== undefined && issueAri !== undefined && canViewDevTools ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qg5k.AsyncDevPanel), {
        issueId: issueId,
        issueAri: issueAri
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), null);
$89ed115c4c781b17$export$608ee4144b32291c.displayName = 'AllDevInfoPanel';
var $89ed115c4c781b17$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state)=>({
        canViewDevTools: (0, $9F6MO.canViewDevToolsPermissionsSelector)(state),
        issueId: (0, $jZDJX.idSelector)(state),
        issueAri: (0, $jZDJX.issueAriSelector)(state)
    }), {})($89ed115c4c781b17$export$608ee4144b32291c);

});
parcelRegister("5qg5k", function(module, exports) {

$parcel$export(module.exports, "AsyncDevPanel", () => $caeb3c6af066ac33$export$c277d0073bb1bd97);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $caeb3c6af066ac33$var$LazyDevPanel = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("i7t8U")), {
    moduleId: "./src/packages/development/dev-info-panel/src/view/index.tsx"
});
const $caeb3c6af066ac33$export$c277d0073bb1bd97 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-dev-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($caeb3c6af066ac33$var$LazyDevPanel, props));

});
parcelRegister("i7t8U", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('8qvsa')
        ]);
        const value = parcelRequire('d1lkg');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("8qvsa")
    ]).then(()=>parcelRequire('d1lkg'));
}

});



parcelRegister("a3bgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ea500b93f29dbbe$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $jqvCZ = parcelRequire("jqvCZ");

var $5iWql = parcelRequire("5iWql");

var $2jDha = parcelRequire("2jDha");

var $8sN8t = parcelRequire("8sN8t");

var $dXCcw = parcelRequire("dXCcw");

var $7ZZxN = parcelRequire("7ZZxN");

var $8uNQc = parcelRequire("8uNQc");

var $guiFP = parcelRequire("guiFP");

var $bAQOb = parcelRequire("bAQOb");

var $2OdyW = parcelRequire("2OdyW");

var $k8Qyf = parcelRequire("k8Qyf");

var $iPlEr = parcelRequire("iPlEr");

var $90IgZ = parcelRequire("90IgZ");
var $4ksts = parcelRequire("4ksts");

var $obNhg = parcelRequire("obNhg");
var $9zbkD = parcelRequire("9zbkD");
var $fmXYE = parcelRequire("fmXYE");

var $kwEon = parcelRequire("kwEon");
var $lhFcf = parcelRequire("lhFcf");

var $hJ992 = parcelRequire("hJ992");

var $dC6Sf = parcelRequire("dC6Sf");
var $dnK1q = parcelRequire("dnK1q");

var $exOWK = parcelRequire("exOWK");

var $eMxRI = parcelRequire("eMxRI");

var $brySu = parcelRequire("brySu");
var $autRb = parcelRequire("autRb");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $f9RL0 = parcelRequire("f9RL0");

var $j3Krp = parcelRequire("j3Krp");

var $lqalZ = parcelRequire("lqalZ");

var $kohoO = parcelRequire("kohoO");

var $crsr5 = parcelRequire("crsr5");

var $9ZAfP = parcelRequire("9ZAfP");

var $cf5zb = parcelRequire("cf5zb");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $fVCj0 = parcelRequire("fVCj0");

var $40QX1 = parcelRequire("40QX1");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");

var $5YYzL = parcelRequire("5YYzL");

var $6WXNs = parcelRequire("6WXNs");

var $aaQTg = parcelRequire("aaQTg");

var $ab6rA = parcelRequire("ab6rA");
var $1R3n5 = parcelRequire("1R3n5");

var $gczGB = parcelRequire("gczGB");

var $jf5VS = parcelRequire("jf5VS");

var $cWTCI = parcelRequire("cWTCI");
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ const $6ea500b93f29dbbe$var$messages = (0, $90IgZ.defineMessages)({
    assignToMe: {
        "id": "issue.assignee.text-for-logged-in-user",
        "defaultMessage": "Assign to me"
    },
    unassignedOption: {
        "id": "issue.assignee.text-when-no-value-is-provided",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue.assignee.text-for-automatic-assignee",
        "defaultMessage": "Automatic"
    },
    inviteAndAssign: {
        "id": "issue.assignee.invite-and-assign-non-final",
        "defaultMessage": "Invite and assign"
    }
});
const $6ea500b93f29dbbe$var$analyticsAttributeIdRetriever = (value)=>value && value.accountId;
const $6ea500b93f29dbbe$export$80859424956457b4 = (0, $5iWql.default)((formatMessage)=>({
        avatarUrl: '',
        name: formatMessage($6ea500b93f29dbbe$var$messages.unassignedOption)
    }));
const $6ea500b93f29dbbe$var$getAssignToMeOption = (0, $5iWql.default)((loggedInUser, formatMessage)=>{
    if (!loggedInUser) return [];
    return [
        {
            avatarUrl: loggedInUser.avatarUrl,
            id: loggedInUser.id,
            name: loggedInUser.displayName,
            displayName: formatMessage($6ea500b93f29dbbe$var$messages.assignToMe)
        }
    ];
});
const $6ea500b93f29dbbe$var$getAutomaticOption = (0, $5iWql.default)((loggedInUser, formatMessage)=>{
    if (!loggedInUser) return [];
    return [
        {
            avatarUrl: '',
            id: -1,
            name: formatMessage($6ea500b93f29dbbe$var$messages.automaticOption),
            displayName: formatMessage($6ea500b93f29dbbe$var$messages.automaticOption)
        }
    ];
});
const $6ea500b93f29dbbe$var$getUnassignedOption = (0, $5iWql.default)((loggedInUser, formatMessage)=>{
    if (!loggedInUser) return [];
    return [
        {
            avatarUrl: '',
            id: null,
            name: formatMessage($6ea500b93f29dbbe$var$messages.unassignedOption),
            displayName: formatMessage($6ea500b93f29dbbe$var$messages.unassignedOption)
        }
    ];
});
const $6ea500b93f29dbbe$var$getInitialOptions = (0, $5iWql.default)((loggedInUser, initialValue, formatMessage, canBeAssigned)=>{
    const isLoggedInUser = Boolean(initialValue && loggedInUser && loggedInUser.id === initialValue.accountId);
    const assignToMeOption = !isLoggedInUser && canBeAssigned ? $6ea500b93f29dbbe$var$getAssignToMeOption(loggedInUser, formatMessage) : [];
    const unassignedOption = initialValue ? $6ea500b93f29dbbe$var$getUnassignedOption(loggedInUser, formatMessage) : [];
    const automaticOption = $6ea500b93f29dbbe$var$getAutomaticOption(loggedInUser, formatMessage);
    return [
        ...assignToMeOption,
        ...unassignedOption,
        ...automaticOption
    ];
});
const $6ea500b93f29dbbe$var$isMatchingDefaultOption = (query, option)=>!!query && option.toLowerCase().startsWith(query.toLowerCase());
const $6ea500b93f29dbbe$export$3c2eeb7a5204ad57 = (loggedInUser, formatMessage)=>(0, $5iWql.default)((query)=>{
        const isMatchingAssignToMe = $6ea500b93f29dbbe$var$isMatchingDefaultOption(query, formatMessage($6ea500b93f29dbbe$var$messages.assignToMe));
        const isMatchingUnassigned = $6ea500b93f29dbbe$var$isMatchingDefaultOption(query, formatMessage($6ea500b93f29dbbe$var$messages.unassignedOption));
        const maybeNoAssigneeOption = isMatchingUnassigned ? $6ea500b93f29dbbe$var$getUnassignedOption(loggedInUser, formatMessage) : [];
        const maybeAssignToMeOption = isMatchingAssignToMe ? $6ea500b93f29dbbe$var$getAssignToMeOption(loggedInUser, formatMessage) : [];
        const isMatchingAutomatic = $6ea500b93f29dbbe$var$isMatchingDefaultOption(query, formatMessage($6ea500b93f29dbbe$var$messages.automaticOption));
        const mayBeAutomaticOption = isMatchingAutomatic ? $6ea500b93f29dbbe$var$getAutomaticOption(loggedInUser, formatMessage) : [];
        return [
            ...maybeNoAssigneeOption,
            ...maybeAssignToMeOption,
            ...mayBeAutomaticOption
        ];
    });
const $6ea500b93f29dbbe$export$ad58cc735169a172 = (0, $5iWql.default)((loggedInUser, formatMessage)=>(0, $5iWql.default)((query)=>{
        const isMatchingAssignToMe = $6ea500b93f29dbbe$var$isMatchingDefaultOption(query, formatMessage($6ea500b93f29dbbe$var$messages.assignToMe));
        const isMatchingUnassigned = $6ea500b93f29dbbe$var$isMatchingDefaultOption(query, formatMessage($6ea500b93f29dbbe$var$messages.unassignedOption));
        const maybeNoAssigneeOption = isMatchingUnassigned ? $6ea500b93f29dbbe$var$getUnassignedOption(loggedInUser, formatMessage) : [];
        const maybeAssignToMeOption = isMatchingAssignToMe ? $6ea500b93f29dbbe$var$getAssignToMeOption(loggedInUser, formatMessage) : [];
        const isMatchingAutomatic = $6ea500b93f29dbbe$var$isMatchingDefaultOption(query, formatMessage($6ea500b93f29dbbe$var$messages.automaticOption));
        const mayBeAutomaticOption = isMatchingAutomatic ? $6ea500b93f29dbbe$var$getAutomaticOption(loggedInUser, formatMessage) : [];
        return [
            ...maybeNoAssigneeOption,
            ...maybeAssignToMeOption,
            ...mayBeAutomaticOption
        ];
    }));
const $6ea500b93f29dbbe$export$2b81811283cd2d9d = (0, $5iWql.default)((autoCompleteUrl, loggedInUser, formatMessage, createAnalyticsEvent)=>(query, sessionId)=>{
        if (!autoCompleteUrl) return Promise.resolve([]);
        const getAssigneeDefaultOptions = $6ea500b93f29dbbe$export$3c2eeb7a5204ad57(loggedInUser, formatMessage);
        const defaultSuggestions = getAssigneeDefaultOptions(query);
        const queryString = sessionId != null ? `&sessionId=${sessionId}` : '';
        const startTime = (0, $8uNQc.default).now();
        const queryLength = query.length;
        return (0, $2OdyW.default)(`${autoCompleteUrl}${query}${queryString}`).then((response)=>{
            (0, $kwEon.fireSuggestionsRequestSuccessEvent)((0, $f9RL0.ASSIGNEE), startTime, createAnalyticsEvent, {
                sessionId: sessionId,
                queryLength: queryLength
            });
            const fetchedSuggestions = response.map((0, $jf5VS.transformFromStateValue)).filter(Boolean);
            return [
                ...defaultSuggestions,
                ...fetchedSuggestions
            ];
        }).catch((error)=>{
            (0, $kwEon.fireSuggestionsRequestFailedEvent)((0, $f9RL0.ASSIGNEE), startTime, createAnalyticsEvent, {
                sessionId: sessionId
            });
            throw error;
        });
    });
const $6ea500b93f29dbbe$export$72a8b15fb4557735 = async ({ baseUrl: baseUrl, issueKey: issueKey, value: value, saveFieldData: saveFieldData })=>{
    const accountId = value == null ? null : value.accountId;
    await (0, $9ZAfP.assignIssue)(baseUrl, issueKey, accountId, saveFieldData);
    if (accountId === -1) {
        try {
            const response = await (0, $9ZAfP.currentAssignee)(baseUrl, issueKey, saveFieldData);
            const { assignee: assignee = null } = response.fields || {};
            if (assignee !== null) {
                const transformedState = (0, $jf5VS.transformFromStateValue)(response.fields.assignee);
                return {
                    updatedFieldValue: (0, $jf5VS.transformToStateValue)(transformedState)
                };
            }
            // Issue is unassigned as result of automatic
            return {
                updatedFieldValue: null
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'currentAssigneeFetch',
                    // eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics
                    packageName: 'jiraIssueView'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return null;
    }
    return null;
};
const $6ea500b93f29dbbe$export$2d95b66f107864b4 = (prefetchResult, viewProps)=>(query, assignSessionId)=>{
        if (!query && prefetchResult !== undefined && prefetchResult !== null) {
            const { prefetchSessionId: prefetchSessionId, prefetched: prefetched, fieldValuePromise: fieldValuePromise, sessionId: sessionId } = prefetchResult;
            const { createAnalyticsEvent: createAnalyticsEvent } = viewProps;
            if (prefetched && fieldValuePromise !== null && sessionId !== null) {
                const defaultSuggestions = viewProps.getDefaultOptions(query);
                (0, $lhFcf.triggerCacheHitEvent)(createAnalyticsEvent, prefetchSessionId, assignSessionId || '', sessionId, (0, $f9RL0.ASSIGNEE));
                const startTime = (0, $8uNQc.default).now();
                return fieldValuePromise.then((response)=>{
                    // query length from prefetch should be 0
                    (0, $kwEon.fireSuggestionsRequestSuccessEvent)((0, $f9RL0.ASSIGNEE), startTime, createAnalyticsEvent, {
                        sessionId: assignSessionId,
                        isPrefetched: true,
                        queryLength: 0
                    });
                    const fetchedSuggestions = response.map((0, $jf5VS.transformFromStateValue)).filter(Boolean);
                    return [
                        ...defaultSuggestions,
                        ...fetchedSuggestions
                    ];
                }).catch((error)=>{
                    (0, $kwEon.fireSuggestionsRequestFailedEvent)((0, $f9RL0.ASSIGNEE), startTime, createAnalyticsEvent, {
                        sessionId: assignSessionId,
                        isPrefetched: true
                    });
                    throw error;
                });
            }
            (0, $lhFcf.triggerCacheMissEvent)(createAnalyticsEvent, prefetchSessionId, assignSessionId || '', (0, $f9RL0.ASSIGNEE));
            return viewProps.fetchSuggestions(query, assignSessionId);
        }
        return viewProps.fetchSuggestions(query, assignSessionId);
    };
const $6ea500b93f29dbbe$var$getMemoizedPrefetchSuggestionsFactory = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))($6ea500b93f29dbbe$export$2d95b66f107864b4, (prefetchResult, viewProps)=>`${prefetchResult && prefetchResult.prefetchSessionId || ''}_${viewProps.issueKey}`);
const $6ea500b93f29dbbe$var$getAppEdition = (appEditions, projectType)=>{
    try {
        if (projectType) return (0, $6WXNs.getEditionForProject)(projectType, appEditions);
    } catch (e) {
    // unknown product
    }
    return 0, $6WXNs.UNLICENSED;
};
const $6ea500b93f29dbbe$var$ConnectedAssignToMeButton = (0, $lqalZ.connect)(null, (dispatch)=>({
        onUpdate: (onUpdateValue)=>dispatch((0, $fVCj0.sweetStateFieldUpdated)((0, $lO4Or.ASSIGNEE_TYPE), onUpdateValue)),
        onFailure: (error)=>dispatch((0, $fVCj0.sweetStateFieldSaveFailure)((0, $lO4Or.ASSIGNEE_TYPE), 'The value could not be saved', error, {
                isRichTextField: false,
                isOptimistic: false,
                shouldSaveDraft: false,
                canContainMediaContent: false,
                saveField: $6ea500b93f29dbbe$export$72a8b15fb4557735,
                shouldDiscardChangeOnFailure: true,
                onSaveFailureFlagType: null,
                onSaveSuccessFlagType: null
            }))
    }))((0, $dC6Sf.AssignToMeButton));
const $6ea500b93f29dbbe$var$ASSIGNEE_INVITED_FLAG_ID = 'issue-assignee-invited-flag';
const $6ea500b93f29dbbe$export$83531ad8a694f8e0 = (props)=>{
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useLayoutEffect)(()=>props.initFieldOptions(), []);
    const assigneeContainerRef = (0, $eUqFw.useRef)(null);
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    (0, $eUqFw.useEffect)(()=>{
        if (assigneeContainerRef.current && props.isEditing) // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLElement | null'.
        (0, $autRb.smoothScrollIntoCenterIfNeeded)(assigneeContainerRef.current);
    }, [
        props.isEditing
    ]);
    const [{ value: value, fieldConfig: fieldConfig }] = (0, $dnK1q.default)({
        issueKey: props.issueKey
    });
    const projectKey = (0, $hJ992.useProjectKey)();
    const [{ canBeAssignedToIssues: canBeAssignedToIssues }] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const isEditable = !!fieldConfig?.isEditable;
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const initialOptions = $6ea500b93f29dbbe$var$getInitialOptions(props.loggedInUser, value, formatMessage, !!canBeAssignedToIssues);
    const inviteUser = (0, $iPlEr.userInEnglishLocale)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $crsr5.useInviteUserService)({
        analyticsSource: 'boardIssueViewScreen'
    }) : undefined;
    const assignInvitedUser = (0, $iPlEr.userInEnglishLocale)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kohoO.useAssignInvitedUserService)() : undefined;
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const isSoftwareProjectType = props.projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
    const appEdition = $6ea500b93f29dbbe$var$getAppEdition(appEditions, props.projectType);
    const isFreeEdition = appEdition === (0, $6WXNs.FREE_EDITION);
    const loggedInEmailDomain = (0, $cf5zb.useGetUserEmailDomain)({
        isSoftwareProjectType: isSoftwareProjectType,
        isFreeEdition: isFreeEdition,
        userInEnglishLocale: (0, $iPlEr.userInEnglishLocale)()
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const handleOnCreateOption = (0, $eUqFw.useCallback)(async (newValue)=>{
        if (Array.isArray(newValue) || !newValue?.id) {
            (0, $guiFP.default)({
                meta: {
                    id: 'handleOnCreateOption',
                    // eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics
                    packageName: 'jiraIssueView',
                    // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                    teamName: 'jlove-makkuro'
                },
                error: new Error('Unsupported value type')
            });
            return;
        }
        // @ts-expect-error - type 'UIAnalyticsEvent | undefined' is not assignable to parameter of type 'UIAnalyticsEvent'
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent?.({}), 'option selected', 'assigneeViewField', {
            type: 'email'
        });
        showFlag({
            id: $6ea500b93f29dbbe$var$ASSIGNEE_INVITED_FLAG_ID,
            render (flagProps) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gczGB.AssigneeInvitedFlag), {
                    id: $6ea500b93f29dbbe$var$ASSIGNEE_INVITED_FLAG_ID,
                    email: newValue.id,
                    onDismissed: async ()=>{
                        dismissFlag($6ea500b93f29dbbe$var$ASSIGNEE_INVITED_FLAG_ID);
                        const user = await inviteUser?.({
                            email: newValue.id,
                            issueKey: props.issueKey
                        });
                        if (user?.isInviteSuccessful) await assignInvitedUser?.({
                            issueKey: props.issueKey,
                            accountId: user.userId
                        });
                    },
                    onCancel: ()=>{
                        dismissFlag($6ea500b93f29dbbe$var$ASSIGNEE_INVITED_FLAG_ID);
                    },
                    ...flagProps
                });
            }
        });
    }, [
        assignInvitedUser,
        dismissFlag,
        inviteUser,
        props.issueKey,
        createAnalyticsEvent,
        showFlag
    ]);
    const renderAssignToMeButton = (0, $eUqFw.useCallback)(()=>{
        if (!props.issueKey) return null;
        const isAssignedToLoggedInUser = Boolean(value && props.loggedInUser && props.loggedInUser.id === value.accountId);
        const showAssignToMeButton = !!props.loggedInUser && isEditable && !!canBeAssignedToIssues && !isAssignedToLoggedInUser;
        if (!showAssignToMeButton) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ea500b93f29dbbe$var$ConnectedAssignToMeButton, {
            issueKey: props.issueKey
        });
    }, [
        canBeAssignedToIssues,
        isEditable,
        props.issueKey,
        props.loggedInUser,
        value
    ]);
    const renderWithCachedValue = (0, $eUqFw.useCallback)(()=>{
        const FieldLoadedValueSubscriber = (0, $aaQTg.getFieldLoadedValueSubscriber)(props.issueKey, (0, $f9RL0.ASSIGNEE));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldLoadedValueSubscriber, {
            fieldId: (0, $f9RL0.ASSIGNEE)
        }, (prefetchResult)=>{
            const fetchSuggestions = $6ea500b93f29dbbe$var$getMemoizedPrefetchSuggestionsFactory(prefetchResult, props);
            const { getDefaultOptions: getDefaultOptions, initFieldOptions: initFieldOptions, issueKey: issueKey, loggedInUser: loggedInUser, ...userInlineEditViewProps } = props;
            const transformedValue = (0, $jf5VS.transformFromStateValue)(value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $exOWK.default), {
                ...userInlineEditViewProps,
                // @ts-expect-error - TS2322 - Type '(query: string, assignSessionId?: string | undefined) => Promise<readonly (UserOption | null)[]>' is not assignable to type '(query: string, sessionId?: string | undefined) => Promise<UserOption[]>'.
                fetchSuggestions: fetchSuggestions,
                fieldId: (0, $f9RL0.ASSIGNEE),
                issueKey: issueKey,
                value: transformedValue,
                // @ts-expect-error - TS2322 - Type 'readonly never[] | readonly { readonly avatarUrl: ""; readonly id: null; readonly name: string; readonly displayName: string; }[] | readonly [...never[], { readonly avatarUrl: ""; readonly id: -1; readonly name: string; readonly displayName: string; }] | ... 4 more ... | readonly [...]' is not assignable to type 'UserOption[] | undefined'.
                initialOptions: initialOptions,
                isEditable: isEditable,
                emptyOption: $6ea500b93f29dbbe$export$80859424956457b4(formatMessage),
                belowFieldView: renderAssignToMeButton(),
                emailLabel: formatMessage($6ea500b93f29dbbe$var$messages.inviteAndAssign),
                suggestEmailsForDomain: loggedInEmailDomain || undefined,
                allowEmail: Boolean(isSiteAdmin && isSoftwareProjectType && isFreeEdition),
                onCreateOption: handleOnCreateOption
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cWTCI.CommandPaletteAssigneeList), {
                fetchSuggestions: fetchSuggestions,
                prefetchResult: prefetchResult,
                initialOptions: initialOptions,
                value: transformedValue
            }));
        });
    }, [
        props,
        value,
        initialOptions,
        isEditable,
        formatMessage,
        renderAssignToMeButton,
        loggedInEmailDomain,
        isSiteAdmin,
        handleOnCreateOption,
        isFreeEdition,
        isSoftwareProjectType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
        name: (0, $eMxRI.EDIT_FIELD)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: (ref)=>{
            assigneeContainerRef.current = ref;
        }
    }, renderWithCachedValue()));
};
const $6ea500b93f29dbbe$export$4088f997a3e38586 = (props)=>{
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useLayoutEffect)(()=>props.initFieldOptions(), []);
    const assigneeContainerRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (assigneeContainerRef.current && props.isEditing) // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLElement | null'.
        (0, $autRb.smoothScrollIntoCenterIfNeeded)(assigneeContainerRef.current);
    }, [
        props.isEditing
    ]);
    const [{ value: value, fieldConfig: fieldConfig }] = (0, $dnK1q.default)({
        issueKey: props.issueKey
    });
    const projectKey = (0, $hJ992.useProjectKey)();
    const [{ canBeAssignedToIssues: canBeAssignedToIssues }] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const isEditable = !!fieldConfig?.isEditable;
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const initialOptions = $6ea500b93f29dbbe$var$getInitialOptions(props.loggedInUser, value, formatMessage, !!canBeAssignedToIssues);
    const triggerInviteAndAssign = (0, $9zbkD.useInviteAndAssign)({
        issueKey: props.issueKey,
        analyticsSource: 'assigneeViewField'
    });
    const shouldApplyInviteAndAssignIssueView = (0, $fmXYE.useShouldApplyInviteAndAssign)();
    const domain = (0, $dXCcw.useUserEmailDomain)(shouldApplyInviteAndAssignIssueView);
    const loggedInEmailDomain = shouldApplyInviteAndAssignIssueView && domain?.data ? domain?.data : undefined;
    const handleOnCreateOption = (0, $eUqFw.useCallback)(async (newValue)=>{
        if (Array.isArray(newValue) || !newValue?.id) {
            (0, $guiFP.default)({
                meta: {
                    id: 'handleOnCreateOption',
                    // eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics
                    packageName: 'jiraIssueView',
                    // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                    teamName: 'jlove-makkuro'
                },
                error: new Error('Unsupported value type')
            });
            return;
        }
        triggerInviteAndAssign(newValue.name);
    }, [
        triggerInviteAndAssign
    ]);
    const renderAssignToMeButton = (0, $eUqFw.useCallback)(()=>{
        if (!props.issueKey) return null;
        const isAssignedToLoggedInUser = Boolean(value && props.loggedInUser && props.loggedInUser.id === value.accountId);
        const showAssignToMeButton = !!props.loggedInUser && isEditable && !!canBeAssignedToIssues && !isAssignedToLoggedInUser;
        if (!showAssignToMeButton) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ea500b93f29dbbe$var$ConnectedAssignToMeButton, {
            issueKey: props.issueKey
        });
    }, [
        canBeAssignedToIssues,
        isEditable,
        props.issueKey,
        props.loggedInUser,
        value
    ]);
    const renderWithCachedValue = (0, $eUqFw.useCallback)(()=>{
        const FieldLoadedValueSubscriber = (0, $aaQTg.getFieldLoadedValueSubscriber)(props.issueKey, (0, $f9RL0.ASSIGNEE));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldLoadedValueSubscriber, {
            fieldId: (0, $f9RL0.ASSIGNEE)
        }, (prefetchResult)=>{
            const fetchSuggestions = $6ea500b93f29dbbe$var$getMemoizedPrefetchSuggestionsFactory(prefetchResult, props);
            const { getDefaultOptions: getDefaultOptions, initFieldOptions: initFieldOptions, issueKey: issueKey, loggedInUser: loggedInUser, ...userInlineEditViewProps } = props;
            const transformedValue = (0, $jf5VS.transformFromStateValue)(value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $exOWK.default), {
                ...userInlineEditViewProps,
                // @ts-expect-error - TS2322 - Type '(query: string, assignSessionId?: string | undefined) => Promise<readonly (UserOption | null)[]>' is not assignable to type '(query: string, sessionId?: string | undefined) => Promise<UserOption[]>'.
                fetchSuggestions: fetchSuggestions,
                fieldId: (0, $f9RL0.ASSIGNEE),
                issueKey: issueKey,
                value: transformedValue,
                // @ts-expect-error - TS2322 - Type 'readonly never[] | readonly { readonly avatarUrl: ""; readonly id: null; readonly name: string; readonly displayName: string; }[] | readonly [...never[], { readonly avatarUrl: ""; readonly id: -1; readonly name: string; readonly displayName: string; }] | ... 4 more ... | readonly [...]' is not assignable to type 'UserOption[] | undefined'.
                initialOptions: initialOptions,
                isEditable: isEditable,
                emptyOption: $6ea500b93f29dbbe$export$80859424956457b4(formatMessage),
                belowFieldView: renderAssignToMeButton(),
                emailLabel: formatMessage((0, $obNhg.default).inviteAndAssign),
                suggestEmailsForDomain: loggedInEmailDomain,
                allowEmail: shouldApplyInviteAndAssignIssueView,
                onCreateOption: handleOnCreateOption
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cWTCI.CommandPaletteAssigneeList), {
                fetchSuggestions: fetchSuggestions,
                prefetchResult: prefetchResult,
                initialOptions: initialOptions,
                value: transformedValue
            }));
        });
    }, [
        props,
        value,
        initialOptions,
        isEditable,
        formatMessage,
        renderAssignToMeButton,
        loggedInEmailDomain,
        shouldApplyInviteAndAssignIssueView,
        handleOnCreateOption
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
        name: (0, $eMxRI.EDIT_FIELD)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: (ref)=>{
            assigneeContainerRef.current = ref;
        }
    }, renderWithCachedValue()));
};
const $6ea500b93f29dbbe$var$AssigneeView = (0, $bAQOb.componentWithFF)('issue.details.invite-and-assign-refactoring', $6ea500b93f29dbbe$export$4088f997a3e38586, $6ea500b93f29dbbe$export$83531ad8a694f8e0);
$6ea500b93f29dbbe$var$AssigneeView.displayName = 'AssigneeView';
const $6ea500b93f29dbbe$var$getSuggestionUrl = (baseUrl, issueKey)=>`${baseUrl}/rest/api/3/user/assignable/search?issueKey=${issueKey}&recommend=true&query=`;
// @ts-expect-error - TS7006 - Parameter 'ownPropsOnMount' implicitly has an 'any' type.
const $6ea500b93f29dbbe$var$getConnectedProps = (ownPropsOnMount)=>({
        fieldId: (0, $f9RL0.ASSIGNEE),
        transformFromStateValue: $jf5VS.transformFromStateValue,
        transformToStateValue: $jf5VS.transformToStateValue,
        saveField: $6ea500b93f29dbbe$export$72a8b15fb4557735,
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type. | TS7006 - Parameter 'intl' implicitly has an 'any' type.
        additionalProps: (state, intl)=>{
            const loggedInUser = (0, $jZDJX.loggedInUserDetailsSelector)(state);
            const projectType = (0, $jZDJX.projectTypeSelector)(state);
            return {
                portalElement: (0, $40QX1.isFieldInTabSelector)(ownPropsOnMount.fieldId)(state) ? // Using a portal element here because otherwise dropdowns would get cut off
                // See: https://jdog.jira-dev.com/browse/BENTO-4101
                (0, $brySu.getIssueModalAkDropdownPortal)() || document.body : undefined,
                fetchSuggestions: $6ea500b93f29dbbe$export$2b81811283cd2d9d($6ea500b93f29dbbe$var$getSuggestionUrl((0, $5JqpU.baseUrlSelector)(state), (0, $5JqpU.issueKeySelector)(state)), loggedInUser, intl.formatMessage, ownPropsOnMount.createAnalyticsEvent),
                issueKey: (0, $5JqpU.issueKeySelector)(state),
                getDefaultOptions: $6ea500b93f29dbbe$export$ad58cc735169a172(loggedInUser, intl.formatMessage),
                loggedInUser: loggedInUser,
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area),
                analyticsAttributeIdRetriever: $6ea500b93f29dbbe$var$analyticsAttributeIdRetriever,
                enablePeopleInvite: true,
                projectType: projectType
            };
        }
    });
var $6ea500b93f29dbbe$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $2jDha.default)(), (0, $j3Krp.withEditExperienceTracker)((0, $f9RL0.ASSIGNEE)), (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>$6ea500b93f29dbbe$var$getConnectedProps(ownPropsOnMount)))($6ea500b93f29dbbe$var$AssigneeView);

});
parcelRegister("dXCcw", function(module, exports) {

$parcel$export(module.exports, "useUserEmailDomain", () => $83089f0402187830$export$f95c1c6f997ec47f);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");

var $glXjI = parcelRequire("glXjI");
const $83089f0402187830$export$d4c72bab9d6cc13a = {
    isFetching: false,
    wasFetchedOnce: false,
    fetchError: null
};
const $83089f0402187830$var$Store = (0, $a61MH.createStore)({
    initialState: $83089f0402187830$export$d4c72bab9d6cc13a,
    actions: $glXjI.actions,
    name: 'atlassian-account'
});
const $83089f0402187830$var$loggedInEmailDomainSelector = (0, $bj4JM.createSelector)((state)=>state.data, (accountInfo)=>{
    if (!accountInfo) return null;
    const [, loggedInEmailDomain] = accountInfo.email?.split('@') ?? [];
    return loggedInEmailDomain;
});
const $83089f0402187830$export$2a9b22328f7b68fa = (0, $ggKAj.createHook)($83089f0402187830$var$Store, {
    selector: $83089f0402187830$var$loggedInEmailDomainSelector
});
const $83089f0402187830$export$f95c1c6f997ec47f = (isEligibleToCall = true)=>{
    const [loggedInEmailDomain, { fetchAtlassianAccountData: fetchAtlassianAccountData }] = $83089f0402187830$export$2a9b22328f7b68fa();
    (0, $eUqFw.useEffect)(()=>{
        if (isEligibleToCall && !loggedInEmailDomain) fetchAtlassianAccountData();
    }, [
        fetchAtlassianAccountData,
        isEligibleToCall,
        loggedInEmailDomain
    ]);
    return {
        data: loggedInEmailDomain
    };
};
const $83089f0402187830$export$19d38f479bd18098 = (0, $ggKAj.createHook)($83089f0402187830$var$Store);

});
parcelRegister("glXjI", function(module, exports) {

$parcel$export(module.exports, "actions", () => $776c04853ec68f69$export$e324594224ef24da);

var $7RALw = parcelRequire("7RALw");
const $776c04853ec68f69$export$e324594224ef24da = {
    fetchAtlassianAccountData: ()=>async ({ setState: setState, getState: getState })=>{
            const { isFetching: isFetching, wasFetchedOnce: wasFetchedOnce } = getState();
            if (isFetching || wasFetchedOnce) return;
            setState({
                isFetching: true
            });
            try {
                const data = await (0, $7RALw.getAtlassianAccountWithRethrow)();
                if (data !== null) setState({
                    data: data
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    wasFetchedOnce: true
                });
            }
        }
};

});
parcelRegister("7RALw", function(module, exports) {

$parcel$export(module.exports, "getAtlassianAccountWithRethrow", () => $fb5817803e08281a$export$1f20b0741dc598bc);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

const $fb5817803e08281a$export$1f20b0741dc598bc = async ({ source: source } = {})=>{
    try {
        const { extended_profile: { job_title: jobTitle, team_type: teamType }, email: email, account_id: accountId } = await (0, $lRmyA.performGetRequestWithRetry)((0, $f4af0f0c163da88b$export$80945eb3738bcee8));
        return {
            extendedProfile: {
                jobTitle: jobTitle,
                teamType: teamType
            },
            email: email,
            accountId: accountId
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'getAtlassianAccountWithRethrow',
                packageName: 'jiraAtlassianAccount',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                source: source
            },
            error: error
        });
        throw error;
    }
};

});
const $f4af0f0c163da88b$export$80945eb3738bcee8 = '/gateway/api/me';




parcelRegister("iPlEr", function(module, exports) {

$parcel$export(module.exports, "userInEnglishLocale", () => $8365e9e840affcbd$export$26ec1ea85a0393b5);

var $6rW04 = parcelRequire("6rW04");
const $8365e9e840affcbd$export$26ec1ea85a0393b5 = ()=>{
    const usersLocale = (0, $6rW04.default)('ajs-user-locale');
    return !!usersLocale && typeof usersLocale === 'string' && usersLocale.toLowerCase().indexOf('en', 0) !== -1;
};

});

parcelRegister("obNhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d50baaac4d43c10b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d50baaac4d43c10b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    inviteAndAssign: {
        "id": "invite-and-assign.common.invite-and-assign",
        "defaultMessage": "Invite and assign"
    }
});

});

parcelRegister("9zbkD", function(module, exports) {

$parcel$export(module.exports, "useInviteAndAssign", () => $4e4ed5fa2239effe$export$938e35fad967b70e);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lgHE9 = parcelRequire("lgHE9");

var $9ZJqc = parcelRequire("9ZJqc");

var $fzR7l = parcelRequire("fzR7l");

var $8aRqJ = parcelRequire("8aRqJ");
const $4e4ed5fa2239effe$var$ASSIGNEE_INVITED_FLAG_ID = (0, $eo17r.toFlagId)('issue-assignee-invited-flag');
const $4e4ed5fa2239effe$export$938e35fad967b70e = ({ issueKey: issueKey, analyticsSource: analyticsSource })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const assignInvitedUser = (0, $fzR7l.useAssignInvitedUser)({
        analyticsSource: analyticsSource
    });
    const inviteUser = (0, $8aRqJ.useInviteUser)({
        analyticsSource: analyticsSource
    });
    const inviteAndAssignHandler = (0, $eUqFw.useCallback)(async (email, fireCustomAnalytics)=>{
        if (!(0, $9ZJqc.isValidEmailAddress)(email)) {
            (0, $guiFP.default)({
                meta: {
                    id: 'inviteAndAssignHandler',
                    packageName: 'jiraInviteAndAssign',
                    teamName: 'jlove-makkuro'
                },
                error: new Error(`Not a valid email address: ${email}`)
            });
            return;
        }
        if (fireCustomAnalytics) fireCustomAnalytics(analyticsSource, {
            type: 'email'
        });
        else (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'option selected', analyticsSource, {
            type: 'email'
        });
        showFlag({
            id: $4e4ed5fa2239effe$var$ASSIGNEE_INVITED_FLAG_ID,
            render (flagProps) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgHE9.AssigneeInvitedFlag), {
                    id: $4e4ed5fa2239effe$var$ASSIGNEE_INVITED_FLAG_ID,
                    email: email,
                    onDismissed: async ()=>{
                        dismissFlag($4e4ed5fa2239effe$var$ASSIGNEE_INVITED_FLAG_ID);
                        const inviteResult = await inviteUser({
                            email: email,
                            issueKey: issueKey
                        });
                        if (inviteResult.isInviteSuccessful) await assignInvitedUser({
                            issueKey: issueKey,
                            userId: inviteResult.userId
                        });
                    },
                    onCancel: ()=>{
                        dismissFlag($4e4ed5fa2239effe$var$ASSIGNEE_INVITED_FLAG_ID);
                        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                            actionSubject: 'button',
                            action: 'clicked'
                        }), 'cancelButton', {
                            source: 'inviteAndAssignFlag',
                            integration: analyticsSource
                        });
                    },
                    ...flagProps
                });
            }
        });
    }, [
        createAnalyticsEvent,
        analyticsSource,
        issueKey,
        showFlag,
        dismissFlag,
        inviteUser,
        assignInvitedUser
    ]);
    return inviteAndAssignHandler;
};

});
parcelRegister("lgHE9", function(module, exports) {

$parcel$export(module.exports, "AssigneeInvitedFlag", () => $1f3a513f9c518c28$export$a390cb5ab934b7);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ccE3R = parcelRequire("ccE3R");

var $kQ0RL = parcelRequire("kQ0RL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jDY1o = parcelRequire("jDY1o");
const $1f3a513f9c518c28$export$a390cb5ab934b7 = ({ email: email, onCancel: onCancel, onDismissed: onDismissed, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.SuccessAutoDismissFlag), {
        title: formatMessage((0, $jDY1o.messages).title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $jDY1o.messages).description, {
            email: email,
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f3a513f9c518c28$var$RecaptchaTermsAndPolicyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ccE3R.default), null))),
        onDismissed: onDismissed,
        actions: [
            {
                content: formatMessage((0, $jDY1o.messages).actionCancel),
                onClick: onCancel
            }
        ],
        ...props
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f3a513f9c518c28$var$RecaptchaTermsAndPolicyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1crf _vwz47vkz _19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ccE3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e25ae5da5703a42$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $8CiA2 = parcelRequire("8CiA2");

var $kJWlj = parcelRequire("kJWlj");
const $8e25ae5da5703a42$var$RecaptchaTermsAndPolicy = ({ tagName: tagName = 'span' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CiA2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $kJWlj.default).termsAndPolicy, {
        tagName: tagName,
        values: {
            privacyPolicy: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: "https://policies.google.com/privacy",
                target: "_blank",
                rel: "noopener noreferrer"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kJWlj.default).privacyPolicy)),
            termsOfService: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: "https://policies.google.com/terms",
                target: "_blank",
                rel: "noopener noreferrer"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kJWlj.default).termsOfService))
        }
    })));
var $8e25ae5da5703a42$export$2e2bcd8739ae039 = $8e25ae5da5703a42$var$RecaptchaTermsAndPolicy;

});
parcelRegister("8CiA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $646049013297ff2e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
var $5JgJ2 = parcelRequire("5JgJ2");

var $NQj1A = parcelRequire("NQj1A");
const $646049013297ff2e$var$IntlProvider = ({ children: children })=>{
    const { locale: locale } = (0, $5JgJ2.default)();
    const { messages: messages } = (0, $NQj1A.useFetchMessagesByLocale)(locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        messages: messages,
        key: locale,
        locale: locale
    }, children);
};
var $646049013297ff2e$export$2e2bcd8739ae039 = $646049013297ff2e$var$IntlProvider;

});
parcelRegister("NQj1A", function(module, exports) {

$parcel$export(module.exports, "useFetchMessagesByLocale", () => $095d2691c7faa92d$export$5ac26fa9b941854e);
/* eslint-disable import/dynamic-import-chunkname */ 
var $eUqFw = parcelRequire("eUqFw");
























function $095d2691c7faa92d$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("d93VE"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("4RtUz"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("9aB1n"));
        case 'en-GB':
            return (parcelRequire("cfFwT"));
        case 'en-US':
        case 'en':
            return (parcelRequire("d3J2C"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("1avYr"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("lwLzo"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("7V5Tk"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("bfexJ"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("a5Rzb"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("9WeqC"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("kBPEW"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("eqfZ9"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("izUq0"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("caCEb"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("hTDBO"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("iIdSQ"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("nTsbd"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("lO5fp"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("61fEw"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("6is9v"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("j5ipG"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("2T6jA"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("gKKnK"));
    }
    return Promise.resolve({
        default: {}
    });
}
function $095d2691c7faa92d$export$5ac26fa9b941854e(locale) {
    const [messages, setMessages] = (0, $eUqFw.useState)({});
    (0, $eUqFw.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            // Intl.Locale doesn't like underscores
            const finalLocale = new Intl.Locale(locale.replace('_', '-')).toString();
            try {
                const module = await $095d2691c7faa92d$export$c08b58fa4727b0d2(finalLocale);
                const newMessages = module.default || module;
                setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale
    ]);
    return {
        messages: messages
    };
}

});
parcelRegister("d93VE", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jEnOM');
        const value = parcelRequire('4kyfl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jEnOM").then(()=>parcelRequire('4kyfl'));
}

});

parcelRegister("4RtUz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8hQCV');
        const value = parcelRequire('6sxci');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8hQCV").then(()=>parcelRequire('6sxci'));
}

});

parcelRegister("9aB1n", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jpv0A');
        const value = parcelRequire('ic6Qe');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jpv0A").then(()=>parcelRequire('ic6Qe'));
}

});

parcelRegister("cfFwT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('czJFY');
        const value = parcelRequire('lljyC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("czJFY").then(()=>parcelRequire('lljyC'));
}

});

parcelRegister("d3J2C", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fg8Uv');
        const value = parcelRequire('76nZb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fg8Uv").then(()=>parcelRequire('76nZb'));
}

});

parcelRegister("1avYr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('i8Urc');
        const value = parcelRequire('7qVNW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("i8Urc").then(()=>parcelRequire('7qVNW'));
}

});

parcelRegister("lwLzo", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('enY8c');
        const value = parcelRequire('4TPGr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("enY8c").then(()=>parcelRequire('4TPGr'));
}

});

parcelRegister("7V5Tk", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('80i7X');
        const value = parcelRequire('8XZEE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("80i7X").then(()=>parcelRequire('8XZEE'));
}

});

parcelRegister("bfexJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('aV9Fx');
        const value = parcelRequire('qQPcl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("aV9Fx").then(()=>parcelRequire('qQPcl'));
}

});

parcelRegister("a5Rzb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7B4HE');
        const value = parcelRequire('i05lU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7B4HE").then(()=>parcelRequire('i05lU'));
}

});

parcelRegister("9WeqC", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('d8DO7');
        const value = parcelRequire('dOfRM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("d8DO7").then(()=>parcelRequire('dOfRM'));
}

});

parcelRegister("kBPEW", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9p5DQ');
        const value = parcelRequire('fnJiV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9p5DQ").then(()=>parcelRequire('fnJiV'));
}

});

parcelRegister("eqfZ9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gochK');
        const value = parcelRequire('5mTfQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gochK").then(()=>parcelRequire('5mTfQ'));
}

});

parcelRegister("izUq0", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fGPSZ');
        const value = parcelRequire('erUqV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fGPSZ").then(()=>parcelRequire('erUqV'));
}

});

parcelRegister("caCEb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('d94bC');
        const value = parcelRequire('mLuqZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("d94bC").then(()=>parcelRequire('mLuqZ'));
}

});

parcelRegister("hTDBO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6lR2a');
        const value = parcelRequire('2r94e');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6lR2a").then(()=>parcelRequire('2r94e'));
}

});

parcelRegister("iIdSQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bdkQq');
        const value = parcelRequire('jdZvd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bdkQq").then(()=>parcelRequire('jdZvd'));
}

});

parcelRegister("nTsbd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('27hr8');
        const value = parcelRequire('lQOHP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("27hr8").then(()=>parcelRequire('lQOHP'));
}

});

parcelRegister("lO5fp", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1WXzw');
        const value = parcelRequire('erePk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1WXzw").then(()=>parcelRequire('erePk'));
}

});

parcelRegister("61fEw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('copPz');
        const value = parcelRequire('asHTl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("copPz").then(()=>parcelRequire('asHTl'));
}

});

parcelRegister("6is9v", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bzESp');
        const value = parcelRequire('7fOVW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bzESp").then(()=>parcelRequire('7fOVW'));
}

});

parcelRegister("j5ipG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hJUR0');
        const value = parcelRequire('jXdHl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hJUR0").then(()=>parcelRequire('jXdHl'));
}

});

parcelRegister("2T6jA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hUAQ4');
        const value = parcelRequire('bWoIS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hUAQ4").then(()=>parcelRequire('bWoIS'));
}

});

parcelRegister("gKKnK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6qsqZ');
        const value = parcelRequire('kHXHB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6qsqZ").then(()=>parcelRequire('kHXHB'));
}

});



parcelRegister("kJWlj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1954448fc4722f4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $f1954448fc4722f4$var$messages = (0, $90IgZ.defineMessages)({
    termsAndPolicy: {
        id: 'growth.google-recaptcha.terms-and-policy.text',
        description: 'Text substitute for reCAPTCHA branding when badge is visibly hidden',
        defaultMessage: 'This site is protected by reCAPTCHA and the Google {privacyPolicy} and {termsOfService} apply.'
    },
    privacyPolicy: {
        id: 'growth.google-recaptcha.terms-and-policy.privacy-policy',
        description: 'Privacy Policy link text',
        defaultMessage: 'Privacy Policy'
    },
    termsOfService: {
        id: 'growth.google-recaptcha.terms-and-policy.terms-of-service',
        description: 'Terms of Service link text',
        defaultMessage: 'Terms of Service'
    }
});
var $f1954448fc4722f4$export$2e2bcd8739ae039 = $f1954448fc4722f4$var$messages;

});


parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintCommonFlag = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("5L0Jp", function(module, exports) {

$parcel$export(module.exports, "FlagsBoundary", () => $3e0b01ebb413784c$export$8b4a0fffcddd96f4);

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");
const $3e0b01ebb413784c$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "flags",
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "flags-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, children));

});

parcelRegister("aiVXY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cCYJs')
        ]);
        const value = parcelRequire('kbpOk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cCYJs")
    ]).then(()=>parcelRequire('kbpOk'));
}

});

parcelRegister("Tabui", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hkLGi');
        const value = parcelRequire('jkRT2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hkLGi").then(()=>parcelRequire('jkRT2'));
}

});


parcelRegister("jDY1o", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f1b6db18bf1a8376$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $f1b6db18bf1a8376$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "invite-and-assign.common.assignee-invited-flag.title",
        "defaultMessage": "Success!"
    },
    description: {
        "id": "invite-and-assign.common.assignee-invited-flag.description",
        "defaultMessage": "We emailed <strong>{email}</strong> inviting them to join Jira. They will be assigned to the issue shortly."
    },
    actionCancel: {
        "id": "invite-and-assign.common.assignee-invited-flag.action-cancel",
        "defaultMessage": "Cancel invite"
    }
});

});


parcelRegister("9ZJqc", function(module, exports) {

$parcel$export(module.exports, "isValidEmailAddress", () => $3811abc2872da18e$export$866f45a7554d0870);
$parcel$export(module.exports, "getInviteAndAssignPeopleOption", () => $3811abc2872da18e$export$34e0d98131b0b98a);

var $d5vpa = parcelRequire("d5vpa");

var $4gwMF = parcelRequire("4gwMF");


var $obNhg = parcelRequire("obNhg");
const $3811abc2872da18e$var$getInviteAndAssignOption = (inputValue, suggestedEmailDomain)=>{
    const isEmail = inputValue && [
        (0, $1199e142050a1a33$export$18d36911c7f94286),
        (0, $1199e142050a1a33$export$da1c529049028734)
    ].includes((0, $d5vpa.isValidEmail)(inputValue));
    const value = isEmail || !suggestedEmailDomain ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${suggestedEmailDomain}`;
    return value;
};
const $3811abc2872da18e$export$866f45a7554d0870 = (inputValue)=>inputValue && (0, $d5vpa.isValidEmail)(inputValue) === (0, $1199e142050a1a33$export$18d36911c7f94286);
const $3811abc2872da18e$export$34e0d98131b0b98a = (formatMessage, input, suggestedEmailDomain)=>{
    const possibleEmail = $3811abc2872da18e$var$getInviteAndAssignOption(input, suggestedEmailDomain);
    return {
        id: (0, $1199e142050a1a33$export$898547b9297d1a3a),
        name: possibleEmail,
        avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($4gwMF))),
        byline: formatMessage((0, $obNhg.default).inviteAndAssign),
        isDisabled: (0, $d5vpa.isValidEmail)(possibleEmail) !== 'VALID'
    };
};

});
parcelRegister("d5vpa", function(module, exports) {

$parcel$export(module.exports, "isValidEmail", () => $98741a5ab537910f$export$371e338370561054);
const $98741a5ab537910f$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $98741a5ab537910f$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $98741a5ab537910f$export$371e338370561054 = (inputText)=>{
    if (inputText.match($98741a5ab537910f$var$validRegex)) return 'VALID';
    if (inputText.match($98741a5ab537910f$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});

parcelRegister("4gwMF", function(module, exports) {
module.exports = new URL("email.43fa850c.png", import.meta.url).toString();

});

const $1199e142050a1a33$export$898547b9297d1a3a = '_INVITE_AND_ASSIGN_ID_';
const $1199e142050a1a33$export$18d36911c7f94286 = 'VALID';
const $1199e142050a1a33$export$da1c529049028734 = 'POTENTIAL';


parcelRegister("fzR7l", function(module, exports) {

$parcel$export(module.exports, "useAssignInvitedUser", () => $324cd7fd58e277d0$export$22a0bc066cbeaa7a);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $le4fs = parcelRequire("le4fs");

var $gOxUJ = parcelRequire("gOxUJ");
const $324cd7fd58e277d0$export$6f42aa8a19554362 = (0, $eo17r.toFlagId)('ASSIGN_INVITED_USER_ERROR');
const $324cd7fd58e277d0$export$22a0bc066cbeaa7a = ({ analyticsSource: analyticsSource })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    return (0, $eUqFw.useCallback)(async ({ issueKey: issueKey, userId: userId })=>{
        try {
            await (0, $le4fs.postAssignInvitedUsers)({
                issueKey: issueKey,
                invitedUserId: userId
            });
            const analyticsEvent = createAnalyticsEvent({});
            const attributes = {
                fieldKey: 'assignee',
                fieldType: 'user',
                ...(0, $1ybV0.ff)('issue.details.invite-and-assign-refactoring') ? {
                    assignInvitedUserSource: analyticsSource,
                    isAssignInvitedUser: true
                } : {
                    isAssignInvitedUser: true
                }
            };
            // intentionally firing the event even if BE call fails to update the field
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'field updated', attributes);
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', attributes);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useAssignInvitedUser',
                    packageName: 'jiraInviteAndAssign',
                    teamName: 'jlove-makkuro'
                },
                error: error,
                ...(0, $1ybV0.ff)('issue.details.invite-and-assign-refactoring') && {
                    attributes: {
                        analyticsSource: analyticsSource
                    }
                }
            });
            showFlag({
                id: $324cd7fd58e277d0$export$6f42aa8a19554362,
                type: 'error',
                title: formatMessage((0, $gOxUJ.messages).errorFlagTitle),
                description: formatMessage((0, $gOxUJ.messages).errorFlagDescription),
                isAutoDismiss: true
            });
        }
    }, [
        createAnalyticsEvent,
        formatMessage,
        showFlag,
        analyticsSource
    ]);
};

});
parcelRegister("le4fs", function(module, exports) {

$parcel$export(module.exports, "postAssignInvitedUsers", () => $f0ea733b309d2372$export$822b7818947d1011);

var $lRmyA = parcelRequire("lRmyA");
const $f0ea733b309d2372$var$getRestApiPath = (issueKey)=>`/rest/internal/latest/issue/${issueKey}/assignInvitedUser`;
const $f0ea733b309d2372$export$822b7818947d1011 = async ({ issueKey: issueKey, invitedUserId: invitedUserId })=>(0, $lRmyA.performPostRequest)($f0ea733b309d2372$var$getRestApiPath(issueKey), {
        body: JSON.stringify({
            invitedUserId: invitedUserId
        })
    });

});

parcelRegister("gOxUJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b858e57df83d90c3$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $b858e57df83d90c3$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    errorFlagTitle: {
        "id": "invite-and-assign.controllers.assign-invited-user.error-flag-title",
        "defaultMessage": "We couldn\u2019t assign this issue"
    },
    errorFlagDescription: {
        "id": "invite-and-assign.controllers.assign-invited-user.error-flag-description",
        "defaultMessage": "Try adding the assignee again. If this problem persists, contact your site administrator."
    }
});

});


parcelRegister("8aRqJ", function(module, exports) {

$parcel$export(module.exports, "useInviteUser", () => $8cebc34673e917cf$export$3cfd75d9f06fc17d);

var $eUqFw = parcelRequire("eUqFw");

var $jkH4Q = parcelRequire("jkH4Q");

var $65Cy1 = parcelRequire("65Cy1");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dWLk9 = parcelRequire("dWLk9");
var $3e9vj = parcelRequire("3e9vj");

var $eRLmj = parcelRequire("eRLmj");

var $7loGC = parcelRequire("7loGC");

var $akRyJ = parcelRequire("akRyJ");

var $3Iwg7 = parcelRequire("3Iwg7");
var $aaDIj = parcelRequire("aaDIj");
const $8cebc34673e917cf$export$935cc6a120ce59fd = (0, $eo17r.toFlagId)('INVITE_USER_ERROR');
const $8cebc34673e917cf$export$3cfd75d9f06fc17d = ({ analyticsSource: analyticsSource })=>{
    const environment = (0, $3e9vj.useEnvironment)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const handleInvitedUserResult = (0, $7loGC.useHandleInviteUserResult)();
    const { getRecaptchaToken: getRecaptchaToken } = (0, $65Cy1.useInvisibleRecaptcha)({
        siteKey: (0, $aaDIj.getRecaptchaSiteKey)(environment),
        displayBadge: false,
        analyticsChannel: 'jira',
        analyticsSource: analyticsSource
    });
    return (0, $eUqFw.useCallback)(async ({ email: email, issueKey: issueKey })=>{
        try {
            const jiraSoftwareAri = (0, $3Iwg7.getJiraSoftwareAri)(cloudId);
            const recaptchaToken = await getRecaptchaToken?.('v1_invitations_invite').catch(// If token generation fails we want to just continue with the
            // request without a recaptcha token (the lib will fire an event)
            ()=>undefined);
            const atlOrigin = new (0, $jkH4Q.default)({
                product: 'jira'
            });
            const continueUrl = atlOrigin.addToUrl(`${window.location.origin}/browse/${issueKey}`);
            const invitedUsers = await (0, $eRLmj.postInviteUsers)({
                resources: [
                    jiraSoftwareAri
                ],
                users: [
                    {
                        email: email
                    }
                ],
                continueUrl: continueUrl,
                recaptchaToken: recaptchaToken
            });
            const invitedUser = invitedUsers?.[0];
            return handleInvitedUserResult({
                invitedUser: invitedUser,
                resourceAri: jiraSoftwareAri,
                integrationSource: analyticsSource,
                atlOrigin: atlOrigin
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useInviteUser',
                    packageName: 'jiraInviteAndAssign',
                    teamName: 'jlove-makkuro'
                },
                error: error,
                ...(0, $1ybV0.ff)('issue.details.invite-and-assign-refactoring') && {
                    attributes: {
                        analyticsSource: analyticsSource
                    }
                }
            });
            showFlag({
                id: $8cebc34673e917cf$export$935cc6a120ce59fd,
                type: 'error',
                title: formatMessage((0, $akRyJ.messages).errorFlagTitle),
                description: formatMessage((0, $akRyJ.messages).errorFlagDescription),
                isAutoDismiss: true
            });
            return {
                userId: null,
                isInviteSuccessful: false
            };
        }
    }, [
        analyticsSource,
        cloudId,
        formatMessage,
        getRecaptchaToken,
        handleInvitedUserResult,
        showFlag
    ]);
};

});
parcelRegister("65Cy1", function(module, exports) {

$parcel$export(module.exports, "useInvisibleRecaptcha", () => $0124ebd076e0c80c$export$9a22eec761fce66);

var $eUqFw = parcelRequire("eUqFw");

var $kNXiP = parcelRequire("kNXiP");

var $50nLT = parcelRequire("50nLT");
const $0124ebd076e0c80c$export$9a22eec761fce66 = ({ siteKey: siteKey, displayBadge: displayBadge = true, analyticsChannel: analyticsChannel, analyticsSource: analyticsSource })=>{
    const triggerEvent = (0, $kNXiP.useAnalytics)(analyticsChannel, analyticsSource);
    const [isRecaptchaLoaded, setIsRecaptchaLoaded] = (0, $eUqFw.useState)(false);
    const [recaptchaLoadErrorReason, setRecaptchaLoadErrorReason] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        const initRecaptcha = async ()=>{
            try {
                await (0, $50nLT.loadRecaptcha)(siteKey);
                if (!displayBadge) (0, $50nLT.hideRecaptchaBadge)(siteKey);
                setIsRecaptchaLoaded(true);
                triggerEvent((0, $kNXiP.recaptchaLoaded));
                setRecaptchaLoadErrorReason(undefined);
            } catch (err) {
                const errorMessage = String(err);
                triggerEvent((0, $kNXiP.recaptchaLoadFailed), errorMessage);
                setRecaptchaLoadErrorReason(errorMessage);
            }
        };
        initRecaptcha();
        return ()=>{
            (0, $50nLT.unloadRecaptcha)(siteKey);
            setRecaptchaLoadErrorReason(undefined);
        };
    }, [
        displayBadge,
        siteKey,
        triggerEvent
    ]);
    const getRecaptchaToken = (0, $eUqFw.useCallback)(async (action)=>{
        try {
            var _window, _window$grecaptcha, _window$grecaptcha$en;
            if (!isRecaptchaLoaded || !((_window = window) !== null && _window !== void 0 && (_window$grecaptcha = _window.grecaptcha) !== null && _window$grecaptcha !== void 0 && (_window$grecaptcha$en = _window$grecaptcha.enterprise) !== null && _window$grecaptcha$en !== void 0 && _window$grecaptcha$en.execute)) throw new (0, $50nLT.RecaptchaError)('Execute function not ready');
            return await window.grecaptcha.enterprise.execute(siteKey, {
                action: action
            });
        } catch (err) {
            triggerEvent((0, $kNXiP.recaptchaExecuteFailed), String(err));
            throw err;
        }
    }, [
        isRecaptchaLoaded,
        siteKey,
        triggerEvent
    ]);
    return {
        isRecaptchaLoaded: isRecaptchaLoaded,
        getRecaptchaToken: getRecaptchaToken,
        recaptchaLoadErrorReason: recaptchaLoadErrorReason
    };
};

});
parcelRegister("kNXiP", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", () => $f25662869bf969b0$export$e955abb82869dc84);
$parcel$export(module.exports, "recaptchaLoaded", () => $f25662869bf969b0$export$b97b16bc7fe47920);
$parcel$export(module.exports, "recaptchaLoadFailed", () => $f25662869bf969b0$export$3a46331396e3fda);
$parcel$export(module.exports, "recaptchaExecuteFailed", () => $f25662869bf969b0$export$ea782407790eb26c);

var $eUqFw = parcelRequire("eUqFw");


var $hM7RE = parcelRequire("hM7RE");
var $bFzGY = parcelRequire("bFzGY");
const $f25662869bf969b0$var$ACTION_SUBJECT = 'recaptcha';
const $f25662869bf969b0$export$e955abb82869dc84 = (channel, source)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const triggerEvent = (0, $eUqFw.useCallback)((eventFactory, ...args)=>{
        const analyticsEvent = {
            source: source,
            ...eventFactory(...args)
        };
        (0, $hM7RE.default)(channel)(analyticsEvent)(createAnalyticsEvent);
    }, [
        source,
        channel,
        createAnalyticsEvent
    ]);
    return triggerEvent;
};
const $f25662869bf969b0$export$b97b16bc7fe47920 = ()=>({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $f25662869bf969b0$var$ACTION_SUBJECT,
        action: 'loaded'
    });
const $f25662869bf969b0$export$3a46331396e3fda = (errorMessage)=>({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $f25662869bf969b0$var$ACTION_SUBJECT,
        actionSubjectId: 'load',
        action: 'failed',
        attributes: {
            error: errorMessage
        }
    });
const $f25662869bf969b0$export$ea782407790eb26c = (errorMessage)=>({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $f25662869bf969b0$var$ACTION_SUBJECT,
        actionSubjectId: 'execute',
        action: 'failed',
        attributes: {
            error: errorMessage
        }
    });

});

parcelRegister("50nLT", function(module, exports) {

$parcel$export(module.exports, "loadRecaptcha", () => $3a4f6458dcf76ab1$export$29933d84054794ee);
$parcel$export(module.exports, "unloadRecaptcha", () => $3a4f6458dcf76ab1$export$cfad80fecff3cb16);
$parcel$export(module.exports, "hideRecaptchaBadge", () => $3a4f6458dcf76ab1$export$924e44702e93d253);
$parcel$export(module.exports, "RecaptchaError", () => $3a4f6458dcf76ab1$export$e037dc82f45cc746);
const $3a4f6458dcf76ab1$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE = 'Failed to load grecaptcha enterprise';
const $3a4f6458dcf76ab1$export$b8e8ecca99719d00 = 'https://www.recaptcha.net/recaptcha/enterprise.js';
const $3a4f6458dcf76ab1$var$RECAPTCHA_BADGE_SELECTOR = '.grecaptcha-badge';
const $3a4f6458dcf76ab1$export$29933d84054794ee = (siteKey)=>new Promise((resolve, reject)=>{
        if ($3a4f6458dcf76ab1$var$isRecaptchaLoaded(siteKey)) {
            resolve();
            return;
        }
        const scriptElement = document.createElement('script');
        scriptElement.src = `${$3a4f6458dcf76ab1$export$b8e8ecca99719d00}?render=${siteKey}`;
        scriptElement.async = true;
        scriptElement.defer = true;
        scriptElement.id = siteKey;
        scriptElement.onload = ()=>{
            var _window, _window$grecaptcha;
            if (!((_window = window) !== null && _window !== void 0 && (_window$grecaptcha = _window.grecaptcha) !== null && _window$grecaptcha !== void 0 && _window$grecaptcha.enterprise)) reject($3a4f6458dcf76ab1$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE);
            else window.grecaptcha.enterprise.ready(resolve);
        };
        scriptElement.onerror = (error)=>{
            var _message;
            reject(typeof error === 'string' ? error : (_message = error.message) !== null && _message !== void 0 ? _message : $3a4f6458dcf76ab1$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE);
        };
        document.body.appendChild(scriptElement);
    });
const $3a4f6458dcf76ab1$var$isRecaptchaLoaded = (siteKey)=>Boolean(document.getElementById(siteKey));
const $3a4f6458dcf76ab1$export$cfad80fecff3cb16 = (siteKey)=>{
    $3a4f6458dcf76ab1$var$removeRecaptchaScriptElement(siteKey);
    $3a4f6458dcf76ab1$var$removeRecaptchaBadgeStyleElement(siteKey);
    $3a4f6458dcf76ab1$var$removeRecaptchaBadge();
};
const $3a4f6458dcf76ab1$export$924e44702e93d253 = (siteKey)=>{
    const id = `${siteKey}-styles`;
    if (document.getElementById(id)) return;
    const styleElement = document.createElement('style');
    styleElement.id = `${siteKey}-styles`;
    styleElement.innerText = `${$3a4f6458dcf76ab1$var$RECAPTCHA_BADGE_SELECTOR} { visibility: hidden; }`;
    document.head.appendChild(styleElement);
};
const $3a4f6458dcf76ab1$var$removeRecaptchaScriptElement = (siteKey)=>{
    const scriptElement = document.getElementById(siteKey);
    if (scriptElement) scriptElement.remove();
};
const $3a4f6458dcf76ab1$var$removeRecaptchaBadgeStyleElement = (siteKey)=>{
    const styleElement = document.getElementById(`${siteKey}-styles`);
    if (styleElement) styleElement.remove();
};
const $3a4f6458dcf76ab1$var$removeRecaptchaBadge = ()=>{
    const badgeElements = document.querySelectorAll($3a4f6458dcf76ab1$var$RECAPTCHA_BADGE_SELECTOR);
    for (const el of badgeElements)el.remove();
};
class $3a4f6458dcf76ab1$export$e037dc82f45cc746 extends Error {
    constructor(message){
        super(message);
        // fixing the `instanceof` operators, see https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $3a4f6458dcf76ab1$export$e037dc82f45cc746.prototype);
    }
}

});


parcelRegister("eRLmj", function(module, exports) {

$parcel$export(module.exports, "postInviteUsers", () => $215bcec7253b859c$export$ec0604f9ead641f3);

var $lRmyA = parcelRequire("lRmyA");

const $215bcec7253b859c$export$ec0604f9ead641f3 = async ({ resources: resources, users: users, continueUrl: continueUrl, recaptchaToken: recaptchaToken })=>(0, $lRmyA.performPostRequest)((0, $992200f9b1544b21$export$ff111916f5a23b5a), {
        headers: {
            'Content-Type': 'application/json',
            ...recaptchaToken ? {
                'G-Recaptcha-Token': recaptchaToken
            } : {}
        },
        body: JSON.stringify({
            users: users,
            resources: resources,
            continueUrl: continueUrl
        })
    });

});
const $992200f9b1544b21$export$ff111916f5a23b5a = '/gateway/api/invitations/invite';


parcelRegister("7loGC", function(module, exports) {

$parcel$export(module.exports, "useHandleInviteUserResult", () => $d42510f2bdb925a8$export$df44c23eb36a0ef3);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $8ljF9 = parcelRequire("8ljF9");
const $d42510f2bdb925a8$export$df44c23eb36a0ef3 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(({ invitedUser: invitedUser, resourceAri: resourceAri, integrationSource: integrationSource, atlOrigin: atlOrigin })=>{
        const inviteResult = invitedUser.results[resourceAri];
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'user invited', invitedUser.id, {
            integration: integrationSource,
            products: [
                (0, $2edfd53057852e41$export$1346c9aa3cbb477d)
            ],
            inviteResult: [
                {
                    resourceAri: resourceAri,
                    status: inviteResult
                }
            ],
            ...atlOrigin.toAnalyticsAttributes({
                hasGeneratedId: true
            })
        });
        const errorReason = invitedUser.errorReasons[resourceAri];
        if (errorReason && errorReason.message) throw new Error(errorReason.message);
        // Throw error for responses that have no errorReason and are not a status we consider to be successful
        if ((0, $8ljF9.SUCCESSFUL_INVITE_STATUSES).includes(inviteResult) === false) throw new Error(`Unsuccessful invite. Response returned result of ${inviteResult}`);
        return {
            userId: invitedUser.id,
            isInviteSuccessful: true
        };
    }, [
        createAnalyticsEvent
    ]);
};

});
const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';

parcelRegister("8ljF9", function(module, exports) {

$parcel$export(module.exports, "SUCCESSFUL_INVITE_STATUSES", () => $0922ae319011d3bc$export$f09962c5ceace608);
const $0922ae319011d3bc$export$2bfda8e94627965c = 'INVITED';
const $0922ae319011d3bc$export$4d0bb6166dd6896a = 'USER_EXISTS';
const $0922ae319011d3bc$export$f09962c5ceace608 = [
    $0922ae319011d3bc$export$2bfda8e94627965c,
    $0922ae319011d3bc$export$4d0bb6166dd6896a
];

});


parcelRegister("akRyJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $14aa7216ea2ffd63$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $14aa7216ea2ffd63$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    errorFlagTitle: {
        "id": "invite-and-assign.controllers.invite-user.error-flag-title",
        "defaultMessage": "We couldn\u2019t send your invite"
    },
    errorFlagDescription: {
        "id": "invite-and-assign.controllers.invite-user.error-flag-description",
        "defaultMessage": "Try sending the invite again. If this problem persists, contact your site administrator."
    }
});

});

parcelRegister("3Iwg7", function(module, exports) {

$parcel$export(module.exports, "getJiraSoftwareAri", () => $09ccef2faeef5522$export$4aa75fccdcc4833c);

var $huI7r = parcelRequire("huI7r");

const $09ccef2faeef5522$export$4aa75fccdcc4833c = (cloudId)=>(0, $huI7r.createAri)({
        resourceOwner: (0, $2edfd53057852e41$export$1346c9aa3cbb477d),
        resourceType: 'site',
        resourceId: cloudId
    });

});

parcelRegister("aaDIj", function(module, exports) {

$parcel$export(module.exports, "getRecaptchaSiteKey", () => $f53e10f00df62bab$export$f6c02f8ff560b96f);

const $f53e10f00df62bab$export$f6c02f8ff560b96f = (environment)=>{
    switch(environment){
        case 'prod':
            return 0, $257e30e385c784f7$export$2c2f58a9d84da733;
        case 'staging':
            return 0, $257e30e385c784f7$export$cd719d3567d9b31d;
        default:
            return 0, $257e30e385c784f7$export$34c3413ecdf1b634;
    }
};

});
// These public keys are safe to store in code
const $257e30e385c784f7$export$2c2f58a9d84da733 = '6LfOcIYhAAAAADBS5OnBllme06dW9vyW4Zgowiru';
const $257e30e385c784f7$export$cd719d3567d9b31d = '6LebaYYhAAAAAKFQt-KH6vVkTJQqwZddT-HJCIM3';
const $257e30e385c784f7$export$34c3413ecdf1b634 = '6Le_DxYiAAAAABV8BsFSj3AmZf3OkP9Fh9lfbZOZ';




parcelRegister("fmXYE", function(module, exports) {

$parcel$export(module.exports, "useShouldApplyInviteAndAssign", () => $94ed7ea390fc0831$export$dd717a0a6d95d97d);

var $7ZZxN = parcelRequire("7ZZxN");

var $bNe1g = parcelRequire("bNe1g");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");
var $1R3n5 = parcelRequire("1R3n5");
const $94ed7ea390fc0831$export$dd717a0a6d95d97d = ()=>{
    const { data: project } = (0, $bNe1g.useProjectContext)();
    const { software: software } = (0, $ab6rA.useAppEditions)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isJSW = project?.projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
    const isTMP = !!project?.simplified;
    const isFreeInstance = software === (0, $6WXNs.FREE_EDITION);
    return isJSW && isFreeInstance && isTMP && isSiteAdmin;
};

});

parcelRegister("kwEon", function(module, exports) {

$parcel$export(module.exports, "fireSuggestionsRequestSuccessEvent", () => $fdc9d057cb7638cd$export$7eeca21c46efa338);
$parcel$export(module.exports, "fireSuggestionsRequestFailedEvent", () => $fdc9d057cb7638cd$export$a31ac580130dee62);

var $8uNQc = parcelRequire("8uNQc");

var $jMP2a = parcelRequire("jMP2a");
const $fdc9d057cb7638cd$var$fireRequestEvent = (action, actionSubject, startTime, createAnalyticsEvent, additionalAttributes)=>{
    const attributes = {
        ...additionalAttributes,
        elapsedTimeMs: (0, $8uNQc.default).now() - startTime
    };
    createAnalyticsEvent && (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    }), `${actionSubject} ${action}`, attributes);
};
const $fdc9d057cb7638cd$export$7eeca21c46efa338 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
    $fdc9d057cb7638cd$var$fireRequestEvent('succeeded', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
};
const $fdc9d057cb7638cd$export$a31ac580130dee62 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
    $fdc9d057cb7638cd$var$fireRequestEvent('failed', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
};

});

parcelRegister("lhFcf", function(module, exports) {

$parcel$export(module.exports, "triggerCacheHitEvent", () => $f615d2962d4de9a9$export$e4b7c8a5d9a71de9);
$parcel$export(module.exports, "triggerCacheMissEvent", () => $f615d2962d4de9a9$export$c4723e47d9727429);

var $jMP2a = parcelRequire("jMP2a");
const $f615d2962d4de9a9$var$triggerCacheEvent = (createAnalyticsEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
cacheHit, prefetchSessionId, fieldSelectionSessionId, fieldId, fieldPrefetchSessionId)=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'access';
    const actionSubject = 'fieldPrefetchCache';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: fieldSelectionSessionId
    });
    const attrs = {
        fieldSelectionSessionId: fieldSelectionSessionId,
        fieldFetchSessionId: fieldPrefetchSessionId,
        prefetchSessionId: prefetchSessionId,
        cacheHit: cacheHit,
        fieldId: fieldId
    };
    (0, $jMP2a.fireOperationalAnalytics)(event, `${actionSubject} ${action}`, fieldSelectionSessionId, attrs);
};
const $f615d2962d4de9a9$export$e4b7c8a5d9a71de9 = (createAnalyticsEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
prefetchSessionId, fieldSelectionSessionId, fieldPrefetchSessionId, fieldId)=>$f615d2962d4de9a9$var$triggerCacheEvent(createAnalyticsEvent, true, prefetchSessionId, fieldSelectionSessionId, fieldId, fieldPrefetchSessionId);
const $f615d2962d4de9a9$export$c4723e47d9727429 = (createAnalyticsEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
prefetchSessionId, fieldSelectionSessionId, fieldId)=>$f615d2962d4de9a9$var$triggerCacheEvent(createAnalyticsEvent, false, prefetchSessionId, fieldSelectionSessionId, fieldId);

});

parcelRegister("dC6Sf", function(module, exports) {

$parcel$export(module.exports, "AssignToMeButton", () => $3a403980b2ec621d$export$415ce5a868e4a3bb);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");

var $f8Yej = parcelRequire("f8Yej");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $cWiVr = parcelRequire("cWiVr");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $5YYzL = parcelRequire("5YYzL");

var $7rvH0 = parcelRequire("7rvH0");

var $51p9V = parcelRequire("51p9V");

var $dnK1q = parcelRequire("dnK1q");
const $3a403980b2ec621d$export$415ce5a868e4a3bb = ({ issueKey: issueKey, value: value, onUpdate: onUpdate, onFailure: onFailure })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { saveValue: saveValue }] = (0, $dnK1q.default)({
        issueKey: issueKey,
        onSuccess: onUpdate,
        onFailure: onFailure
    });
    const projectKey = (0, $hJ992.useProjectKey)();
    const [{ canBeAssignedToIssues: canBeAssignedToIssues, canAssignIssues: canAssignIssues }] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: (0, $7rvH0.ASSIGN_TO_ME_ANALYTICS).ACTION,
            actionSubject: (0, $7rvH0.ASSIGN_TO_ME_ANALYTICS).ACTION_SUBJECT
        }));
        const { isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin, siteAdminStatus: siteAdminStatus, userFullname: userFullname, ...transformedUser } = {
            ...user,
            // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
            avatarUrls: user.avatarUrls ? user.avatarUrls : {},
            displayName: // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'displayName' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
            user.displayName !== null && user.displayName !== undefined ? // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
            user.displayName : user.userFullname
        };
        saveValue(transformedUser, null, createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent,
        saveValue,
        user
    ]);
    const escapeHandler = (0, $eUqFw.useCallback)(()=>{
        if (document && document.activeElement) // @ts-expect-error - TS2339 - Property 'blur' does not exist on type 'Element'.
        document.activeElement.blur();
    }, []);
    // Do not render the button if the issue is already assigned to the logged in user
    if (value?.accountId === user.accountId) return null;
    // Do not render the button if the logged in user cannot be assigned to issues
    if (!canBeAssignedToIssues) return null;
    // Do not render the button if the user does not have permissions to assign issues
    if (!canAssignIssues) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
        onEnter: handleClick,
        onEscape: escapeHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3a403980b2ec621d$var$LinkText, {
        tabIndex: 0,
        onClick: handleClick,
        role: "button"
    }, formatMessage((0, $51p9V.default).assignToMe)));
};
var $3a403980b2ec621d$export$2e2bcd8739ae039 = $3a403980b2ec621d$export$415ce5a868e4a3bb;
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a403980b2ec621d$var$LinkText = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1c1ekr5-0"
})({
    color: `var(--ds-link, ${(0, $PdmhA.B400)})`,
    fontSize: '14px',
    cursor: 'pointer',
    marginTop: "var(--ds-space-050, 4px)",
    marginLeft: "var(--ds-space-100, 8px)",
    '&:hover': {
        textDecoration: 'underline'
    },
    '&:active': {
        color: `var(--ds-link-pressed, ${(0, $PdmhA.B400)})`
    }
});

});
parcelRegister("7rvH0", function(module, exports) {

$parcel$export(module.exports, "ASSIGN_TO_ME_ANALYTICS", () => $611cb25600d075ba$export$ce92d6f9a7b43ef8);
const $611cb25600d075ba$export$ce92d6f9a7b43ef8 = Object.freeze({
    ACTION: 'clicked',
    ACTION_SUBJECT: 'assignToMeButton'
});

});

parcelRegister("51p9V", function(module, exports) {

$parcel$export(module.exports, "default", () => $62a9b3be869d04c4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $62a9b3be869d04c4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue-field-assignee.automatic-option",
        "defaultMessage": "Automatic"
    },
    assignToMe: {
        "id": "issue-field-assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    searchForAssignee: {
        "id": "issue-field-assignee.search-for-assignee",
        "defaultMessage": "Search for assignee"
    },
    invitePeopleOption: {
        "id": "issue-field-assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-field-assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});


parcelRegister("exOWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $68fd47e6563e43f4$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $7jPhn = parcelRequire("7jPhn");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $f8Yej = parcelRequire("f8Yej");

var $2gGF1 = parcelRequire("2gGF1");

var $e91YZ = parcelRequire("e91YZ");

var $bAQOb = parcelRequire("bAQOb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $9LvPd = parcelRequire("9LvPd");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $6oQPP = parcelRequire("6oQPP");

var $4bZws = parcelRequire("4bZws");

var $4kGCj = parcelRequire("4kGCj");

var $kpn8k = parcelRequire("kpn8k");

var $lO4Or = parcelRequire("lO4Or");


var $i4m05 = parcelRequire("i4m05");

var $bTMEp = parcelRequire("bTMEp");

var $7EhsI = parcelRequire("7EhsI");

var $3mqjZ = parcelRequire("3mqjZ");

var $afUCr = parcelRequire("afUCr");
const $68fd47e6563e43f4$var$AvatarWrapper = (0, $bAQOb.componentWithFF)('issue-view-fit-and-finish-full-page-milestone2_ebk0i', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qze3t _11pjwsi6",
            __cmplp.className
        ])
    });
}), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qv77o _11pjwsi6",
            __cmplp.className
        ])
    });
}));
const $68fd47e6563e43f4$var$AvatarFocusRingStyles = null;
const $68fd47e6563e43f4$export$57297ff83c1c34ea = ({ isMobile: isMobile = false, label: label = '', initialOptions: initialOptions = [], emptyOption: emptyOption = null, invalidMessage: invalidMessage = null, value: value = null, isEditing: isEditing, isEditable: isEditable, fieldId: fieldId, titleView: titleView = label, showPinButton: showPinButton, belowFieldView: belowFieldView, onCancel: onCancel, customReadView: customReadView, issueKey: issueKey, fieldContentWrapper: FieldContentWrapper, portalElement: portalElement, fetchSuggestions: fetchSuggestions, onConfirm: onConfirm, enablePeopleInvite: enablePeopleInvite, onEditRequest: onEditRequest, onChange: onChange, emailLabel: emailLabel, suggestEmailsForDomain: suggestEmailsForDomain, allowEmail: allowEmail, onCreateOption: onCreateOption })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)(); /* eslint-disable react-hooks/rules-of-hooks */ 
    const isModal = (0, $i4m05.isInviteFromAssignModalFeEnabled)() ? (0, $hJ992.useIsModal)() : false; /* eslint-enable react-hooks/rules-of-hooks */ 
    const getActions = (0, $eUqFw.useCallback)(()=>{
        if (fieldId === (0, $lO4Or.REPORTER_TYPE)) return [
            (0, $2f37035f7aaf1787$export$23cedd3261bd8015),
            (0, $2f37035f7aaf1787$export$6b36f20db7a18a86)
        ];
        if (fieldId === (0, $lO4Or.ASSIGNEE_TYPE)) return [
            (0, $2f37035f7aaf1787$export$23cedd3261bd8015),
            (0, $2f37035f7aaf1787$export$6bef782d14a92db8)
        ];
        return undefined;
    }, [
        fieldId
    ]);
    const getInvitePeopleOption = (0, $eUqFw.useCallback)(()=>{
        const { isAdmin: isAdmin } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
        return {
            name: formatMessage(isAdmin ? (0, $afUCr.default).invitePeopleOptionAdmin : (0, $afUCr.default).invitePeopleOption),
            avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($bTMEp)))
        };
    }, [
        formatMessage
    ]);
    const handleOnChange = (0, $eUqFw.useCallback)((lValue)=>{
        onChange(lValue);
    }, [
        onChange
    ]); // eslint-disable-next-line @typescript-eslint/no-empty-function
    const handleOnDataRequest = (0, $eUqFw.useCallback)((_isInitial)=>{}, []); // eslint-disable-next-line @typescript-eslint/no-empty-function
    const handleOnDataLoaded = (0, $eUqFw.useCallback)((_isInitial = true, _resultsLength = 0)=>{}, []);
    const handleOnEditRequested = (0, $eUqFw.useCallback)(()=>{
        onEditRequest();
    }, [
        onEditRequest
    ]);
    const renderReadView = (0, $eUqFw.useCallback)(()=>{
        if (customReadView) return customReadView(value);
        const lValue = value || emptyOption || {
            avatarUrl: '',
            name: ''
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3mqjZ.default), {
            "data-testId": "read-view-container",
            "data-component-selector": (0, $3mqjZ.readViewContainerSelectorName)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_1cwgidpf _2rko1ssb _1e381ynk _nc1q1r31 _xjlvglyw _1vb81o36"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kpn8k.default), {
            userAccount: lValue,
            analyticsData: {
                trigger: fieldId
            },
            position: "left-start",
            actions: getActions()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($68fd47e6563e43f4$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            borderColor: "transparent",
            src: lValue.avatarUrl,
            size: "small"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $68fd47e6563e43f4$var$avatarPaddingStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3mqjZ.NameWrapper), {
            "data-testid": `issue.views.field.user.${fieldId}.name.wrapper`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, lValue.name), lValue?.active === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3mqjZ.UserStatus), null, `(${formatMessage((0, $afUCr.default).deactivated)})`)));
    }, [
        customReadView,
        emptyOption,
        fieldId,
        formatMessage,
        getActions,
        value
    ]);
    const renderReadViewWithContentWrapper = (0, $eUqFw.useCallback)(()=>{
        if (FieldContentWrapper) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldContentWrapper, null, renderReadView());
        return renderReadView();
    }, [
        FieldContentWrapper,
        renderReadView
    ]);
    const renderEditViewInviteModalExp = (0, $eUqFw.useCallback)(()=>{
        const userPickerProps = {
            portalElement: portalElement,
            emptyOption: emptyOption,
            initialOptions: initialOptions,
            fetchSuggestions: fetchSuggestions,
            fieldId: fieldId,
            value: value,
            onCancel: onCancel,
            onSelection: onConfirm,
            width: '100%',
            onDataRequest: handleOnDataRequest,
            onDataLoaded: handleOnDataLoaded,
            onChange: handleOnChange,
            enablePeopleInvite: enablePeopleInvite,
            invitePeopleOption: enablePeopleInvite === true ? getInvitePeopleOption() : null,
            isIssueViewModal: isModal,
            emailLabel: emailLabel,
            suggestEmailsForDomain: suggestEmailsForDomain,
            allowEmail: allowEmail,
            onCreateOption: onCreateOption
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kGCj.default), userPickerProps);
    }, [
        portalElement,
        emptyOption,
        initialOptions,
        fetchSuggestions,
        fieldId,
        value,
        onCancel,
        onConfirm,
        handleOnDataRequest,
        handleOnDataLoaded,
        handleOnChange,
        enablePeopleInvite,
        getInvitePeopleOption,
        isModal,
        emailLabel,
        suggestEmailsForDomain,
        allowEmail,
        onCreateOption
    ]);
    const renderEditViewDefault = (0, $eUqFw.useCallback)(()=>{
        const userPickerProps = {
            portalElement: portalElement,
            emptyOption: emptyOption,
            initialOptions: initialOptions,
            fetchSuggestions: fetchSuggestions,
            fieldId: fieldId,
            value: value,
            onCancel: onCancel,
            onSelection: onConfirm,
            width: '100%',
            onDataRequest: handleOnDataRequest,
            onDataLoaded: handleOnDataLoaded,
            onChange: handleOnChange,
            enablePeopleInvite: enablePeopleInvite,
            invitePeopleOption: enablePeopleInvite === true ? getInvitePeopleOption() : null,
            emailLabel: emailLabel,
            suggestEmailsForDomain: suggestEmailsForDomain,
            allowEmail: allowEmail,
            onCreateOption: onCreateOption
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kGCj.default), userPickerProps);
    }, [
        allowEmail,
        emailLabel,
        emptyOption,
        enablePeopleInvite,
        fetchSuggestions,
        fieldId,
        getInvitePeopleOption,
        handleOnChange,
        handleOnDataLoaded,
        handleOnDataRequest,
        initialOptions,
        onCancel,
        onConfirm,
        onCreateOption,
        portalElement,
        suggestEmailsForDomain,
        value
    ]);
    const renderEditView = (0, $i4m05.isInviteFromAssignModalFeEnabled)() ? renderEditViewInviteModalExp : renderEditViewDefault;
    const editButtonLabel = (0, $eUqFw.useMemo)(()=>{
        if (!isEditable) return formatMessage((0, $2gGF1.default).disabledEditButtonLabel, {
            fieldName: label
        });
        if (value?.name) return formatMessage((0, $2gGF1.default).extendedEditButtonLabel, {
            inputFieldValue: value.name,
            fieldName: label
        });
        if (emptyOption?.name) return formatMessage((0, $2gGF1.default).extendedEditButtonLabel, {
            inputFieldValue: emptyOption.name,
            fieldName: label
        });
        return formatMessage((0, $2gGF1.default).editButtonLabel, {
            fieldName: label
        });
    }, [
        emptyOption,
        formatMessage,
        isEditable,
        label,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), {
        "data-testid": `issue.views.field.user.${fieldId}.wrapper`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), {
        fieldId: fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, titleView), issueKey !== undefined && fieldId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldId,
        label: label
    }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldId,
        label: label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), {
        isEditing: isEditing,
        fixedHeight: !customReadView,
        hasTooltip: true,
        "data-testid": `issue.views.field.user.${fieldId}`
    }, invalidMessage != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), {
        key: `${fieldId}-error-message`
    }, invalidMessage) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: !isEditable ? formatMessage((0, $2gGF1.default).disabledReporterTooltip, {
            fieldName: label
        }) : null,
        position: "mouse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
        onEscape: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7EhsI.default), {
        isEditable: isEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        editView: isEditable ? renderEditView : ()=>null,
        readView: renderReadViewWithContentWrapper,
        hideActionButtons: true,
        isEditing: isEditing,
        isEditable: isEditable,
        onEdit: handleOnEditRequested,
        readViewFitContainerWidth: !isMobile,
        editButtonLabel: editButtonLabel,
        confirmButtonLabel: formatMessage((0, $2gGF1.default).confirmButtonLabel, {
            fieldName: label
        }),
        cancelButtonLabel: formatMessage((0, $2gGF1.default).cancelButtonLabel, {
            fieldName: label
        })
    }), belowFieldView)))));
};
const $68fd47e6563e43f4$var$avatarPaddingStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.100'
});
$68fd47e6563e43f4$export$57297ff83c1c34ea.displayName = 'UserInlineEditView';
var $68fd47e6563e43f4$export$2e2bcd8739ae039 = $68fd47e6563e43f4$export$57297ff83c1c34ea;

});
parcelRegister("iKmKk", function(module, exports) {

$parcel$export(module.exports, "FieldHeading", () => $0b4a6c22634107b1$export$fe86312a0bb04944);

var $eUqFw = parcelRequire("eUqFw");

var $kdPjr = parcelRequire("kdPjr");

var $64ypR = parcelRequire("64ypR");
const $0b4a6c22634107b1$export$fe86312a0bb04944 = ({ fieldId: fieldId = 'field', children: children, ...rest })=>{
    const isCompact = (0, $eUqFw.useContext)((0, $kdPjr.FieldsCompactModeContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.StyledFieldHeading), {
        "data-testid": `issue-field-heading-styled-field-heading.${fieldId}`,
        isCompact: isCompact,
        ...rest
    }, children);
};

});
parcelRegister("kdPjr", function(module, exports) {

$parcel$export(module.exports, "FieldsCompactModeContext", () => $7d9a3b2e93590b98$export$12b8a1ae7844d92a);
$parcel$export(module.exports, "FieldsCompactModeProvider", () => $7d9a3b2e93590b98$export$e136df3a99c3632a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $a576Y = parcelRequire("a576Y");

var $5qTKr = parcelRequire("5qTKr");
const $7d9a3b2e93590b98$export$12b8a1ae7844d92a = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const { Provider: $7d9a3b2e93590b98$var$Provider } = $7d9a3b2e93590b98$export$12b8a1ae7844d92a;
// The number is based on field label min-width (120px) / width (40%) + the padding and border (25px)
const $7d9a3b2e93590b98$var$FIELD_COMPACT_MAX_WIDTH = 325;
const $7d9a3b2e93590b98$export$e136df3a99c3632a = ({ children: children, defaultIsCompact: defaultIsCompact = false })=>{
    const [isCompact, setIsCompact] = (0, $eUqFw.useState)(defaultIsCompact);
    const throttledSetIsCompact = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(setIsCompact, 50), []);
    const setWidth = (0, $eUqFw.useCallback)((newWidth)=>{
        throttledSetIsCompact(newWidth != null ? newWidth <= $7d9a3b2e93590b98$var$FIELD_COMPACT_MAX_WIDTH : false);
    }, [
        throttledSetIsCompact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7d9a3b2e93590b98$var$RelativeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qTKr.WidthObserver), {
        setWidth: setWidth
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7d9a3b2e93590b98$var$Provider, {
        value: isCompact
    }, children));
};
// This component is used as the parent wrapper for WidthObserver, which is an absolute element
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7d9a3b2e93590b98$var$RelativeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});

});


parcelRegister("4kGCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $358d6b8033369b7f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $jG2Eu = parcelRequire("jG2Eu");

var $2jDha = parcelRequire("2jDha");

var $3Kv5Q = parcelRequire("3Kv5Q");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $iPlEr = parcelRequire("iPlEr");

var $hiBi9 = parcelRequire("hiBi9");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");


var $lhOlj = parcelRequire("lhOlj");
const $358d6b8033369b7f$var$emptyUserOption = {
    id: (0, $79f5e0bdbf2d77b2$export$61a0b64dfe00294c),
    name: ''
};
const $358d6b8033369b7f$export$251bdbdbce9550ea = 300;
const $358d6b8033369b7f$var$stringContains = (str, substr)=>{
    if (str == null) return false;
    if (substr == null || substr === '') return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $358d6b8033369b7f$var$fireInviteFromAssignExposureEvent = (createAnalyticsEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
fieldId, suggestionsCount)=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'exposed';
    const actionSubject = 'feature';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: fieldId,
        flagKey: (0, $lhOlj.INVITE_FROM_ASSIGN),
        value: (0, $lhOlj.getInviteFromAssignCohort)(),
        userRole: (0, $6rW04.default)('ajs-is-admin') === 'true' ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField'
    };
    (0, $jMP2a.fireOperationalAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
const $358d6b8033369b7f$var$fireInviteItemRendererEvent = (createAnalyticsEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
fieldId, suggestionsCount)=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'rendered';
    const actionSubject = 'inviteItem';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: fieldId,
        userRole: (0, $6rW04.default)('ajs-is-admin') === 'true' ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField'
    };
    (0, $jMP2a.fireUIAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
const $358d6b8033369b7f$var$triggerOpenDrawerOrModal = (createAnalyticsEvent, isIssueViewModal, assignModalCohort)=>{
    if (!isIssueViewModal) (0, $hiBi9.triggerOpenDrawer)(createAnalyticsEvent ?? null, {
        inviteFlow: 'assignee'
    }, {
        inviteFromAssignModalCohort: assignModalCohort
    });
    else (0, $hiBi9.triggerOpenDrawer)(createAnalyticsEvent ?? null, {
        inviteFlow: 'assignee'
    });
};
class $358d6b8033369b7f$export$19bf2f43b59d9e90 extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'UserPickerView';
    }
    static{
        this.defaultProps = {
            isDisabled: false,
            value: null,
            initialOptions: [],
            emptyOption: null,
            invitePeopleOption: null,
            enablePeopleInvite: false,
            width: undefined,
            menuMinWidth: undefined,
            portalElement: undefined,
            fetchSuggestions: ()=>Promise.resolve([]),
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onSelection: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onDataRequest: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onDataLoaded: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            emailLabel: undefined,
            suggestEmailsForDomain: undefined,
            allowEmail: false,
            onCreateOption: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    componentWillUnmount() {
        this.wasUnmounted = true;
        this.debouncedRequestSuggestion.cancel();
    }
    isCurrentValue(value) {
        if (!value) return this.props.value === null;
        return this.props.value ? value.id === this.props.value.id : value.id === (0, $79f5e0bdbf2d77b2$export$61a0b64dfe00294c);
    }
    render() {
        const suggestions = this.getSuggestions();
        const pickerValue = this.props.value || this.getEmptyValue();
        const emailInviteProps = (0, $iPlEr.userInEnglishLocale)() || (0, $1ybV0.ff)('issue.details.invite-and-assign-refactoring') ? {
            emailLabel: this.props.emailLabel,
            // only show email suggestion when there is a query
            suggestEmailsForDomain: this.state.query && !this.state.isLoading ? this.props.suggestEmailsForDomain : undefined,
            allowEmail: Boolean(this.props.enablePeopleInvite && this.props.allowEmail),
            onChange: (value, action)=>{
                if (action === 'create-option') this.props.onCreateOption(value, action);
            }
        } : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Kv5Q.UserPicker), {
            value: pickerValue,
            options: suggestions,
            open: this.state.isDropdownVisible,
            fieldId: this.props.fieldId,
            menuMinWidth: this.props.menuMinWidth,
            menuPortalTarget: this.props.portalElement,
            width: this.props.width,
            appearance: "compact",
            isClearable: !!this.props.value,
            isDisabled: this.props.isDisabled,
            placeholder: this.props.placeholder,
            isLoading: this.state.isLoading && this.state.isDropdownVisible,
            onBlur: this.onBlur,
            onClear: this.onClear,
            onFocus: this.onFocus,
            onInputChange: this.onQueryChange,
            onSelection: this.onSuggestionSelect,
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $c9TLT.layers).modal
                    }),
                menu: (base)=>({
                        ...base,
                        zIndex: (0, $c9TLT.layers).modal
                    })
            },
            ...emailInviteProps
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            suggestions: [],
            isDropdownVisible: true,
            wasFocused: false,
            isLoading: false,
            wasQueryCleared: false,
            query: null
        };
        this.wasUnmounted = false;
        // stored not in state because of race condition of setState and onBlur event handler
        this.wasCleared = false;
        this.invitePeopleExposeEventFired = false;
        this.onChange = (value)=>{
            // Don't fire the onChange if the user selects the same value again.
            // We don't expect value to be null or an array since this component only supports a single
            // select currently, but need to check to satisfy flow.
            if (!value || Array.isArray(value) || this.isCurrentValue(value)) return;
            const valueId = value.id;
            const initialOption = this.props.initialOptions.find((option)=>option.id === valueId);
            if (initialOption) // If the value is an initialOption, emit the special value.
            this.props.onChange(initialOption.id ? initialOption : null);
            else if (valueId === (0, $79f5e0bdbf2d77b2$export$61a0b64dfe00294c)) // If the value is the empty option, emit null.
            this.props.onChange(null);
            else if ((0, $lhOlj.isInviteFromAssignEnabled)() && this.props.enablePeopleInvite === true && valueId === (0, $79f5e0bdbf2d77b2$export$d875316cb0cd94f7)) {
                if ((0, $lhOlj.isInviteFromAssignModalFeEnabled)()) {
                    const inviteFromAssignModalCohort = (0, $lhOlj.getInviteFromAssignModalCohort)();
                    $358d6b8033369b7f$var$triggerOpenDrawerOrModal(this.props.createAnalyticsEvent ?? null, this.props.isIssueViewModal, inviteFromAssignModalCohort);
                } else (0, $hiBi9.triggerOpenDrawer)(this.props.createAnalyticsEvent ?? null, {
                    inviteFlow: 'assignee'
                });
            } else // Otherwise emit the value that the user picked.
            this.props.onChange(value);
        };
        this.onSuggestionSelect = (value, sessionId)=>{
            this.wasCleared = false;
            this.setState({
                suggestions: [],
                wasFocused: false,
                isLoading: false,
                wasQueryCleared: false
            });
            this.onChange(Array.isArray(value) ? null : value);
            this.props.onSelection(sessionId);
        };
        this.onBlur = ()=>{
            this.setState({
                suggestions: [],
                isDropdownVisible: false,
                wasFocused: false,
                isLoading: false,
                wasQueryCleared: false
            });
            if (this.wasCleared) {
                this.onSuggestionSelect($358d6b8033369b7f$var$emptyUserOption);
                return;
            }
            this.props.onCancel();
        };
        this.onFocus = (sessionId)=>{
            this.wasCleared = false;
            this.setState({
                isDropdownVisible: true,
                isLoading: true,
                wasFocused: true
            });
            // Submit an empty query on initial load.
            this.requestSuggestions(sessionId);
        };
        this.onQueryChange = (query, sessionId)=>{
            this.setState({
                wasFocused: false,
                isLoading: true,
                query: query || '',
                wasQueryCleared: !query
            });
            this.debouncedRequestSuggestion(sessionId);
        };
        this.onClear = ()=>{
            this.wasCleared = true;
            this.onChange($358d6b8033369b7f$var$emptyUserOption);
        };
        this.getEmptyValue = ()=>this.props.emptyOption ? {
                ...this.props.emptyOption,
                id: (0, $79f5e0bdbf2d77b2$export$61a0b64dfe00294c)
            } : null;
        this.getInvitePeopleValue = ()=>this.props.invitePeopleOption ? {
                ...this.props.invitePeopleOption,
                id: (0, $79f5e0bdbf2d77b2$export$d875316cb0cd94f7)
            } : null;
        this.getInitialAndEmptyOptionSuggestions = ()=>{
            const { initialOptions: initialOptions, emptyOption: emptyOption } = this.props;
            const { wasFocused: wasFocused, wasQueryCleared: wasQueryCleared } = this.state;
            const shouldShowInitialOptions = wasFocused && initialOptions.length > 0;
            const shouldShowEmptyOption = emptyOption && !shouldShowInitialOptions && wasQueryCleared;
            const emptyValue = this.getEmptyValue();
            const initialOptionsToDisplay = shouldShowInitialOptions ? initialOptions : [];
            const emptyOptionToDisplay = shouldShowEmptyOption === true && emptyValue ? [
                emptyValue
            ] : [];
            return [
                ...initialOptionsToDisplay,
                ...emptyOptionToDisplay
            ];
        };
        this.debouncedRequestSuggestion = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((sessionId)=>this.requestSuggestions(sessionId), $358d6b8033369b7f$export$251bdbdbce9550ea);
        this.requestSuggestions = (sessionId)=>{
            const { onDataRequest: onDataRequest, fetchSuggestions: fetchSuggestions } = this.props;
            const { query: query } = this.state;
            onDataRequest(query === null);
            const queryStr = query || '';
            return fetchSuggestions(queryStr, sessionId).then((results)=>this.handleSuggestions(results, queryStr)).catch(()=>this.handleSuggestions([], queryStr));
        };
        this.isMatchingQuery = (suggestion)=>{
            // when feature flag is false the predict should allow all
            const { query: query, isLoading: isLoading } = this.state;
            const { displayName: displayName, name: name } = suggestion;
            return !isLoading || $358d6b8033369b7f$var$stringContains(displayName, query) || $358d6b8033369b7f$var$stringContains(name, query);
        };
        // Prepend any required initialOptions or emptyOption to the suggestions.
        this.getSuggestions = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent, enablePeopleInvite: enablePeopleInvite, fieldId: fieldId } = this.props;
            const { query: query, isLoading: isLoading } = this.state;
            const queryStr = query || '';
            const initialAndEmptyOptions = this.getInitialAndEmptyOptionSuggestions();
            // Filter out any suggestions that are in the initial or empty options.
            const suggestionIdsToFilterOut = initialAndEmptyOptions.map((option)=>option.id);
            const suggestions = this.state.suggestions.filter((suggestion)=>!suggestionIdsToFilterOut.includes(suggestion.id) && // apply filters on the front while backend is serving the request, this is to make the filtering faster.
                // so filter already displayed results while backend is serving the request.
                this.isMatchingQuery(suggestion));
            const allSuggestions = [
                ...initialAndEmptyOptions,
                ...suggestions
            ];
            const invitePeopleValue = this.getInvitePeopleValue();
            const invitePeopleOptions = [];
            const isAssigneeFieldType = fieldId === (0, $lO4Or.ASSIGNEE_TYPE);
            const showEmailOption = (0, $1ybV0.ff)('issue.details.invite-and-assign-refactoring') ? Boolean(queryStr && !isLoading && isAssigneeFieldType && this.props.allowEmail && this.props.enablePeopleInvite) : Boolean(queryStr && !isLoading && isAssigneeFieldType && this.props.allowEmail && this.props.enablePeopleInvite && (0, $iPlEr.userInEnglishLocale)());
            // refresh
            if (!isLoading && enablePeopleInvite === true && invitePeopleValue && queryStr && allSuggestions.length <= 2) {
                if (!this.invitePeopleExposeEventFired) {
                    $358d6b8033369b7f$var$fireInviteFromAssignExposureEvent(createAnalyticsEvent, fieldId, allSuggestions.length);
                    this.invitePeopleExposeEventFired = true;
                }
                if ((0, $lhOlj.isInviteFromAssignEnabled)()) {
                    $358d6b8033369b7f$var$fireInviteItemRendererEvent(createAnalyticsEvent, fieldId, allSuggestions.length);
                    if (!showEmailOption) invitePeopleOptions.push(invitePeopleValue);
                }
            }
            return [
                ...allSuggestions,
                ...invitePeopleOptions
            ].map((userOption)=>{
                const { displayName: displayName, ...option } = userOption;
                // BENTO-4739: The AK user picker uses publicName instead of displayName in its API, so
                // we need to transform the suggestions to the correct shape.
                return displayName ? {
                    ...option,
                    // @ts-expect-error - TS2322 - Type '{ id: string; accountId?: string | undefined; avatarUrl?: string | undefined; active?: boolean | undefined; name: string; byline?: string | undefined; } | { publicName: string; id: string; ... 4 more ...; byline?: string | undefined; }' is not assignable to type 'UserOption'.
                    publicName: displayName
                } : option;
            });
        };
        this.handleSuggestions = (newSuggestions, resultsForQuery)=>{
            const { isDropdownVisible: isDropdownVisible, query: query } = this.state;
            const isForCurrentQuery = resultsForQuery === (query || '');
            if (this.wasUnmounted || !isDropdownVisible || !isForCurrentQuery) return;
            // Prevent the selected value from appearing in the list of suggestions at initial load.
            const suggestions = this.state.wasFocused ? newSuggestions.filter((suggestion)=>!this.isCurrentValue(suggestion)) : newSuggestions;
            this.setState({
                isLoading: false,
                suggestions: suggestions
            });
            this.props.onDataLoaded(query === null, suggestions.length);
        };
    }
}
var $358d6b8033369b7f$export$2e2bcd8739ae039 = (0, $2jDha.default)()($358d6b8033369b7f$export$19bf2f43b59d9e90);

});
parcelRegister("3Kv5Q", function(module, exports) {

$parcel$export(module.exports, "UserPicker", () => $2badc972face4d0a$export$83e0c73b09b3a9cd);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $2jDha = parcelRequire("2jDha");

var $1EOkb = parcelRequire("1EOkb");
var $4zgIJ = parcelRequire("4zgIJ");

var $uMitL = parcelRequire("uMitL");

var $eUqFw = parcelRequire("eUqFw");

var $5YsND = parcelRequire("5YsND");

var $9KdAH = parcelRequire("9KdAH");

var $cSqUf = parcelRequire("cSqUf");

var $5n5Lr = parcelRequire("5n5Lr");

var $3uP8y = parcelRequire("3uP8y");

var $9BvGg = parcelRequire("9BvGg");

var $taler = parcelRequire("taler");

var $cfhr2 = parcelRequire("cfhr2");

var $hompL = parcelRequire("hompL");
class $2badc972face4d0a$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.ufoId = (0, $hompL.v4)();
        const experienceForId = (0, $cfhr2.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        experienceForId.start();
    }
    componentDidMount() {
        const experienceForId = (0, $cfhr2.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $uMitL.UFOExperienceState).IN_PROGRESS.id,
            (0, $uMitL.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $1EOkb.default) : (0, $4zgIJ.default);
        const creatableProps = suggestEmailsForDomain ? (0, $3uP8y.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $5n5Lr.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cfhr2.UfoErrorBoundary), {
            id: this.ufoId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9BvGg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $taler.ExusUserSourceProvider), {
            fetchUserSource: loadUserSource
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5YsND.BaseUserPickerWithoutAnalytics), (0, $kU09D.default)({}, this.props, {
            width: width,
            SelectComponent: SelectComponent,
            styles: (0, $9KdAH.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles),
            components: (0, $cSqUf.getComponents)(isMulti, anchor),
            pickerProps: pickerProps
        })))));
    }
}
(0, $5zQU9.default)($2badc972face4d0a$export$164f4d95e5d7e2f5, "defaultProps", {
    width: 350,
    isMulti: false
});
const $2badc972face4d0a$export$83e0c73b09b3a9cd = (0, $2jDha.default)()($2badc972face4d0a$export$164f4d95e5d7e2f5);

});
parcelRegister("5YsND", function(module, exports) {

$parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", () => $4598e5555308a71c$export$b4ff48c8d43b18c3);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $2jDha = parcelRequire("2jDha");

var $uMitL = parcelRequire("uMitL");

var $dxIU5 = parcelRequire("dxIU5");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hompL = parcelRequire("hompL");

var $2MDcQ = parcelRequire("2MDcQ");

var $9VAEd = parcelRequire("9VAEd");

var $uT8cL = parcelRequire("uT8cL");

var $fsJBk = parcelRequire("fsJBk");

var $cfhr2 = parcelRequire("cfhr2");
const $4598e5555308a71c$var$loadingMessage = ()=>null;
const $4598e5555308a71c$var$classNamePrefix = 'fabric-user-picker';
class $4598e5555308a71c$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $fsJBk.optionToSelectableOptions)(nextProps.value);
        else if ((0, $fsJBk.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $fsJBk.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    // session id for focus to blur
    constructor(props){
        super(props);
        (0, $5zQU9.default)(this, "getSessionId", ()=>this.session && this.session.id ? this.session.id : undefined);
        (0, $5zQU9.default)(this, "withSelectRef", (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            });
        (0, $5zQU9.default)(this, "nextOption", this.withSelectRef((select)=>select.focusOption('down')));
        (0, $5zQU9.default)(this, "previousOption", this.withSelectRef((select)=>select.focusOption('up')));
        (0, $5zQU9.default)(this, "focus", ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        });
        (0, $5zQU9.default)(this, "blur", ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        });
        (0, $5zQU9.default)(this, "selectOption", this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        }));
        // value = null if user deletes the last item in the user picker
        (0, $5zQU9.default)(this, "handleChange", (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $fsJBk.callCallback)(onChange, (0, $fsJBk.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $fsJBk.callCallback)(onSelection, (0, $fsJBk.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $2MDcQ.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $2MDcQ.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $fsJBk.callCallback)(onClear);
                    this.fireEvent((0, $2MDcQ.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $2MDcQ.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $2MDcQ.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        });
        (0, $5zQU9.default)(this, "handleSelectRef", (ref)=>{
            this.selectRef = ref;
        });
        (0, $5zQU9.default)(this, "addOptions", (0, $9VAEd.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        }));
        (0, $5zQU9.default)(this, "handleLoadOptionsError", ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $2MDcQ.failedEvent));
        });
        (0, $5zQU9.default)(this, "debouncedLoadOptions", (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState(({ inflightRequest: previousRequest })=>{
                const inflightRequest = previousRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $fsJBk.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                return {
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                };
            });
        }, 200));
        (0, $5zQU9.default)(this, "abortOptionsShownUfoExperience", ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $uMitL.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        });
        (0, $5zQU9.default)(this, "startOptionsShownUfoExperience", ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        });
        (0, $5zQU9.default)(this, "executeLoadOptions", (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        });
        (0, $5zQU9.default)(this, "handleFocus", (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $fsJBk.callCallback)(this.props.onFocus, this.getSessionId());
            if (!this.isMenuOpenOnClickForSingleSelect) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $fsJBk.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        });
        (0, $5zQU9.default)(this, "resetInputState", ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $fsJBk.callCallback)(this.props.onInputChange, '', this.getSessionId());
        });
        (0, $5zQU9.default)(this, "handleBlur", ()=>{
            (0, $fsJBk.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $fsJBk.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        });
        (0, $5zQU9.default)(this, "handleOpen", ()=>{
            (0, $fsJBk.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        });
        (0, $5zQU9.default)(this, "handleClose", ()=>{
            this.resetInputState();
            (0, $fsJBk.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        });
        (0, $5zQU9.default)(this, "handleInputChange", (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $fsJBk.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        });
        (0, $5zQU9.default)(this, "fireEvent", (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $2MDcQ.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        });
        (0, $5zQU9.default)(this, "startSession", ()=>{
            this.session = (0, $2MDcQ.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $2MDcQ.focusEvent));
        });
        (0, $5zQU9.default)(this, "handleKeyDown", (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
        });
        (0, $5zQU9.default)(this, "handleClearIndicatorHover", (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        });
        (0, $5zQU9.default)(this, "getOptions", ()=>{
            const options = (0, $fsJBk.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return filteredOptions.slice(0, maxOptions);
            }
            return options;
        });
        (0, $5zQU9.default)(this, "getAppearance", ()=>this.props.appearance ? this.props.appearance : 'normal');
        (0, $5zQU9.default)(this, "handleClickDraggableParentComponent", ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        });
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = (0, $cfhr2.userPickerOptionsShownUfoExperience).getInstance((0, $hompL.v4)());
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(_, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $2MDcQ.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $2MDcQ.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $uMitL.UFOExperienceState).STARTED.id,
            (0, $uMitL.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: true
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectComponent, (0, $kU09D.default)({
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            "aria-labelledby": ariaLabelledBy,
            "aria-label": ariaLabel,
            "aria-live": ariaLive,
            "aria-required": required // This has been added as a safety net.
            ,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $4598e5555308a71c$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $uT8cL.messages).placeholder),
            addMoreMessage: addMoreMessage,
            classNamePrefix: $4598e5555308a71c$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null // disable local filtering
            ,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar
        }, this.ariaProps, pickerProps, UNSAFE_hasDraggableParentComponent && {
            onValueContainerClick: this.handleClickDraggableParentComponent
        }, menuOpenDeciderProps));
    }
}
(0, $5zQU9.default)($4598e5555308a71c$export$b4ff48c8d43b18c3, "defaultProps", {
    isMulti: false,
    subtle: false,
    noBorder: false,
    textFieldBackgroundColor: false,
    isClearable: true,
    loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $uT8cL.messages).errorMessage),
    openMenuOnClick: false
});
const $4598e5555308a71c$export$d099ade7b4f4d2a4 = (0, $2jDha.default)()($4598e5555308a71c$export$b4ff48c8d43b18c3);

});
parcelRegister("2MDcQ", function(module, exports) {

$parcel$export(module.exports, "startSession", () => $206e7a053ad1b0e9$export$c0d84948cecf78d8);
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $206e7a053ad1b0e9$export$53eef0dcd9611650);
$parcel$export(module.exports, "focusEvent", () => $206e7a053ad1b0e9$export$e7818c470f37c4bd);
$parcel$export(module.exports, "clearEvent", () => $206e7a053ad1b0e9$export$7b5800e732182efb);
$parcel$export(module.exports, "deleteEvent", () => $206e7a053ad1b0e9$export$95711ec6c6227e9a);
$parcel$export(module.exports, "cancelEvent", () => $206e7a053ad1b0e9$export$e9caaaecfee38128);
$parcel$export(module.exports, "selectEvent", () => $206e7a053ad1b0e9$export$48143d759475d90f);
$parcel$export(module.exports, "searchedEvent", () => $206e7a053ad1b0e9$export$911fb7184b6037eb);
$parcel$export(module.exports, "failedEvent", () => $206e7a053ad1b0e9$export$c2aec355fef65c9c);
$parcel$export(module.exports, "userInfoEvent", () => $206e7a053ad1b0e9$export$f541f04954b0c11e);

var $hM7RE = parcelRequire("hM7RE");

var $hompL = parcelRequire("hompL");

var $fsJBk = parcelRequire("fsJBk");
const $206e7a053ad1b0e9$var$packageName = "@atlaskit/user-picker";
const $206e7a053ad1b0e9$var$packageVersion = "10.21.0";
const $206e7a053ad1b0e9$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $206e7a053ad1b0e9$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $206e7a053ad1b0e9$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $206e7a053ad1b0e9$export$c0d84948cecf78d8 = ()=>({
        id: (0, $hompL.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $206e7a053ad1b0e9$export$53eef0dcd9611650 = (0, $hM7RE.default)('fabric-elements');
const $206e7a053ad1b0e9$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $206e7a053ad1b0e9$var$packageName,
            packageVersion: $206e7a053ad1b0e9$var$packageVersion,
            ...attributes
        }
    });
const $206e7a053ad1b0e9$var$checkValidId = (id)=>{
    return $206e7a053ad1b0e9$var$UUID_REGEXP_NEW_AAID.test(id) || $206e7a053ad1b0e9$var$UUID_REGEXP_OLD_AAID.test(id) || $206e7a053ad1b0e9$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $206e7a053ad1b0e9$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $206e7a053ad1b0e9$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $fsJBk.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $fsJBk.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $206e7a053ad1b0e9$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$206e7a053ad1b0e9$var$optionData2Analytics(data));
    }
    return [];
};
const $206e7a053ad1b0e9$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $206e7a053ad1b0e9$var$sessionId(session),
        pickerType: $206e7a053ad1b0e9$var$pickerType(props),
        journeyId: journeyId
    });
const $206e7a053ad1b0e9$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$206e7a053ad1b0e9$var$createEvent('ui', 'focused', 'userPicker', {
        ...$206e7a053ad1b0e9$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $206e7a053ad1b0e9$var$buildValueForAnalytics(state.value)
    });
const $206e7a053ad1b0e9$export$7b5800e732182efb = (props, state, session, journeyId)=>$206e7a053ad1b0e9$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$206e7a053ad1b0e9$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $206e7a053ad1b0e9$var$values(state)
    });
const $206e7a053ad1b0e9$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$206e7a053ad1b0e9$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $206e7a053ad1b0e9$var$sessionId(session),
        journeyId: journeyId,
        value: $206e7a053ad1b0e9$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen
    });
const $206e7a053ad1b0e9$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$206e7a053ad1b0e9$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$206e7a053ad1b0e9$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $206e7a053ad1b0e9$var$sessionDuration(session),
        queryLength: $206e7a053ad1b0e9$var$queryLength(args[0]),
        spaceInQuery: $206e7a053ad1b0e9$var$spaceInQuery(args[0]),
        upKeyCount: $206e7a053ad1b0e9$var$upKeyCount(session),
        downKeyCount: $206e7a053ad1b0e9$var$downKeyCount(session)
    });
const $206e7a053ad1b0e9$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $206e7a053ad1b0e9$var$createEvent('ui', $206e7a053ad1b0e9$var$selectEventType(session), 'userPicker', {
        ...$206e7a053ad1b0e9$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $206e7a053ad1b0e9$var$sessionDuration(session),
        position: $206e7a053ad1b0e9$var$position(state, args[0]),
        queryLength: $206e7a053ad1b0e9$var$queryLength(state),
        spaceInQuery: $206e7a053ad1b0e9$var$spaceInQuery(state),
        upKeyCount: $206e7a053ad1b0e9$var$upKeyCount(session),
        downKeyCount: $206e7a053ad1b0e9$var$downKeyCount(session),
        result: $206e7a053ad1b0e9$var$result(args[0]),
        numberOfResults: $206e7a053ad1b0e9$var$numberOfResults(state)
    });
};
const $206e7a053ad1b0e9$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $206e7a053ad1b0e9$var$results(state);
    return $206e7a053ad1b0e9$var$createEvent('operational', 'searched', 'userPicker', {
        ...$206e7a053ad1b0e9$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $206e7a053ad1b0e9$var$sessionDuration(session),
        durationSinceInputChange: $206e7a053ad1b0e9$var$durationSinceInputChange(session),
        queryLength: $206e7a053ad1b0e9$var$queryLength(state),
        isLoading: $206e7a053ad1b0e9$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $206e7a053ad1b0e9$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$206e7a053ad1b0e9$var$createEvent('operational', 'failed', 'userPicker', {
        ...$206e7a053ad1b0e9$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $206e7a053ad1b0e9$export$f541f04954b0c11e = (sources, accountId)=>$206e7a053ad1b0e9$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $206e7a053ad1b0e9$var$checkValidId(accountId) ? accountId : null
    });
function $206e7a053ad1b0e9$var$queryLength(state) {
    return state.inputValue.length;
}
function $206e7a053ad1b0e9$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $206e7a053ad1b0e9$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $206e7a053ad1b0e9$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $206e7a053ad1b0e9$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $206e7a053ad1b0e9$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $206e7a053ad1b0e9$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $206e7a053ad1b0e9$var$sessionId(session) {
    return session && session.id;
}
function $206e7a053ad1b0e9$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $206e7a053ad1b0e9$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $206e7a053ad1b0e9$var$result(option) {
    return option ? $206e7a053ad1b0e9$var$optionData2Analytics(option.data) : null;
}
function $206e7a053ad1b0e9$var$results(state) {
    return (state.options || []).map($206e7a053ad1b0e9$var$optionData2Analytics);
}
function $206e7a053ad1b0e9$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $206e7a053ad1b0e9$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$206e7a053ad1b0e9$var$optionData2Analytics(option.data)) : [
        $206e7a053ad1b0e9$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $206e7a053ad1b0e9$var$numberOfResults(state) {
    return (state.options || []).length;
}

});
parcelRegister("fsJBk", function(module, exports) {

$parcel$export(module.exports, "isExternalUser", () => $b41cd7f39a1f52c7$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $b41cd7f39a1f52c7$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $b41cd7f39a1f52c7$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $b41cd7f39a1f52c7$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $b41cd7f39a1f52c7$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $b41cd7f39a1f52c7$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $b41cd7f39a1f52c7$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $b41cd7f39a1f52c7$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $b41cd7f39a1f52c7$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $b41cd7f39a1f52c7$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $b41cd7f39a1f52c7$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $b41cd7f39a1f52c7$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $b41cd7f39a1f52c7$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $b41cd7f39a1f52c7$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $b41cd7f39a1f52c7$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $b41cd7f39a1f52c7$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $b41cd7f39a1f52c7$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $b41cd7f39a1f52c7$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $b41cd7f39a1f52c7$export$5419897287f5f1c7);

var $5iWql = parcelRequire("5iWql");


var $4IBr3 = parcelRequire("4IBr3");
const $b41cd7f39a1f52c7$export$f6058dbcb5980cb = (option)=>option.type === (0, $2147a04a3259adea$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $b41cd7f39a1f52c7$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $2147a04a3259adea$export$8436e53e45ffe15b);
const $b41cd7f39a1f52c7$export$f8c4277cb588611f = (option)=>option.type === (0, $2147a04a3259adea$export$26bc40b960693765);
const $b41cd7f39a1f52c7$export$d7976824e9f55785 = (option)=>option.type === (0, $2147a04a3259adea$export$d460f747b73abb10);
const $b41cd7f39a1f52c7$export$7fbbfbca30081d0 = (option)=>option.type === (0, $2147a04a3259adea$export$6662b3461398ef8c);
const $b41cd7f39a1f52c7$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $2147a04a3259adea$export$eafd0979afa5b224);
const $b41cd7f39a1f52c7$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $b41cd7f39a1f52c7$var$isOptionData = (option)=>option.name !== undefined;
const $b41cd7f39a1f52c7$export$3f993c492bd6c728 = (option)=>{
    if ($b41cd7f39a1f52c7$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $b41cd7f39a1f52c7$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $b41cd7f39a1f52c7$export$9652023d9040757 = (a)=>typeof a[Symbol.iterator] === 'function';
const $b41cd7f39a1f52c7$export$d2312e68e1f5ad00 = (0, $5iWql.default)((options)=>options.map($b41cd7f39a1f52c7$export$3f993c492bd6c728));
const $b41cd7f39a1f52c7$export$e6fda14a194bcbcc = (0, $5iWql.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($b41cd7f39a1f52c7$export$3f993c492bd6c728);
    return $b41cd7f39a1f52c7$export$3f993c492bd6c728(defaultValue);
});
const $b41cd7f39a1f52c7$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $b41cd7f39a1f52c7$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $b41cd7f39a1f52c7$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $b41cd7f39a1f52c7$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $b41cd7f39a1f52c7$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
};
const $b41cd7f39a1f52c7$export$b4f8f1f54acec99b = (optionData)=>{
    if ($b41cd7f39a1f52c7$export$2e44165f1da65304(optionData) || $b41cd7f39a1f52c7$export$f8c4277cb588611f(optionData) || $b41cd7f39a1f52c7$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $b41cd7f39a1f52c7$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $4IBr3.default);
const $b41cd7f39a1f52c7$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $b41cd7f39a1f52c7$export$5419897287f5f1c7 = (lozengeProp)=>{
    return (lozengeProp === null || lozengeProp === void 0 ? void 0 : lozengeProp.hasOwnProperty('text')) || false;
};

});
const $2147a04a3259adea$export$8436e53e45ffe15b = 'user';
const $2147a04a3259adea$export$50042ec1d2e00e63 = 'external_user';
const $2147a04a3259adea$export$26bc40b960693765 = 'team';
const $2147a04a3259adea$export$d460f747b73abb10 = 'group';
const $2147a04a3259adea$export$6662b3461398ef8c = 'email';
const $2147a04a3259adea$export$eafd0979afa5b224 = 'custom';



parcelRegister("9VAEd", function(module, exports) {

$parcel$export(module.exports, "batchByKey", () => $73a5dd6395055dac$export$da86c38211c1c0a8);
function $73a5dd6395055dac$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}

});

parcelRegister("uT8cL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $05cd91644e203b83$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $05cd91644e203b83$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    placeholder: {
        id: 'fabric.elements.user-picker.placeholder',
        defaultMessage: 'Enter people or teams...',
        description: 'Placeholder description for empty user/team/email select field.'
    },
    addMore: {
        id: 'fabric.elements.user-picker.placeholder.add-more',
        defaultMessage: 'add more people...',
        description: 'Placeholder for multi user picker when the field is not empty.'
    },
    remove: {
        id: 'fabric.elements.user-picker.multi.remove-item',
        defaultMessage: 'Remove',
        description: 'Tooltip for the single item remove button in a multi user select field.'
    },
    clear: {
        id: 'fabric.elements.user-picker.single.clear',
        defaultMessage: 'Clear',
        description: 'Tooltip for clear button in the single user select field.'
    },
    errorMessage: {
        id: 'fabric.elements.user-picker.error.message',
        defaultMessage: 'Something went wrong',
        description: 'Error message to display when options fail to load.'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.user-picker.team.member.count.including.you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    addEmail: {
        id: 'fabric.elements.user-picker.email.add',
        defaultMessage: 'Add user',
        description: 'Byline for valid email option.'
    },
    selectToAddEmail: {
        id: 'fabric.elements.user-picker.email.select.to.add',
        defaultMessage: 'Select an email address',
        description: 'Byline for valid email option.'
    },
    continueToAddEmail: {
        id: 'fabric.elements.user-picker.email.add.potential',
        defaultMessage: 'Enter an email address',
        description: 'Byline for a potentially valid email option.'
    },
    groupByline: {
        id: 'fabric.elements.user-picker.group.byline',
        defaultMessage: 'Admin-managed group',
        description: 'Byline for admin-managed groups'
    },
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    externalUserSourcesError: {
        id: 'fabric.elements.user-picker.external.sourced.error',
        defaultMessage: "We can't connect you right now.",
        description: "Error message when we can't fetch a user's import sources"
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    jiraSource: {
        id: 'fabric.elements.user-picker.source.jira',
        defaultMessage: 'Jira',
        description: 'This external user is sourced from Jira'
    },
    confluenceSource: {
        id: 'fabric.elements.user-picker.source.confluence',
        defaultMessage: 'Confluence',
        description: 'This external user is sourced from Confluence'
    },
    otherAtlassianSource: {
        id: 'fabric.elements.user-picker.source.other-atlassian',
        defaultMessage: 'Other Atlassian products',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    }
});

});

parcelRegister("cfhr2", function(module, exports) {

$parcel$export(module.exports, "userPickerRenderedUfoExperience", () => $8ea468fc9bc8c5e4$export$b49757166e1acfc2);
$parcel$export(module.exports, "userPickerOptionsShownUfoExperience", () => $8ea468fc9bc8c5e4$export$135a264e0da507ae);
$parcel$export(module.exports, "UfoErrorBoundary", () => $8ea468fc9bc8c5e4$export$5ef1c2550074a375);

var $eUqFw = parcelRequire("eUqFw");

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
var $uMitL = parcelRequire("uMitL");
const $8ea468fc9bc8c5e4$export$b49757166e1acfc2 = new (0, $2kFUE.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $3yYXq.ExperienceTypes).Load,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad
});
const $8ea468fc9bc8c5e4$export$135a264e0da507ae = new (0, $2kFUE.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $3yYXq.ExperienceTypes).Operation,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
});
class $8ea468fc9bc8c5e4$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch() {
        const instance = $8ea468fc9bc8c5e4$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $uMitL.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("9KdAH", function(module, exports) {

$parcel$export(module.exports, "BORDER_PADDING", () => $7182f3cede2caefc$export$59c188914e58c94b);
$parcel$export(module.exports, "getStyles", () => $7182f3cede2caefc$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "getPopupStyles", () => $7182f3cede2caefc$export$4e983f376ad8a3af);

var $PdmhA = parcelRequire("PdmhA");

var $5iWql = parcelRequire("5iWql");

var $cEc3i = parcelRequire("cEc3i");
const $7182f3cede2caefc$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $7182f3cede2caefc$export$53937c04f7dfc2ae = 6;
const $7182f3cede2caefc$export$2c62ba763e976c54 = 39;
const $7182f3cede2caefc$export$ffd58b7f6f099a57 = (0, $5iWql.default)((width, isMulti, isCompact, overrideStyles)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $PdmhA.N40})`,
                backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $PdmhA.N10})` : `var(--ds-background-input, ${0, $PdmhA.N20})`,
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $PdmhA.B100})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $PdmhA.N40})`,
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $PdmhA.R50})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $PdmhA.N0})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $PdmhA.N10})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`
                },
                padding: 0,
                minHeight: isCompact ? 'none' : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: `var(--ds-icon-danger, ${0, $PdmhA.R400})`
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? 0 : $7182f3cede2caefc$export$59c188914e58c94b,
                paddingBottom: isCompact ? 0 : $7182f3cede2caefc$export$59c188914e58c94b,
                paddingLeft: isMulti ? $7182f3cede2caefc$export$59c188914e58c94b : 0,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                fontSize: '100%',
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$7182f3cede2caefc$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $7182f3cede2caefc$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>({
                ...css,
                overflow: 'hidden'
            }),
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: state.selectProps.isMulti ? 0 : $7182f3cede2caefc$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: `var(--ds-text-subtlest, ${0, $PdmhA.N100})`,
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: `var(--ds-text-subtlest, ${0, $PdmhA.N100})`
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $cEc3i.m)(styles, overrideStyles) : styles;
});
const $7182f3cede2caefc$export$4e983f376ad8a3af = (0, $5iWql.default)((width, isMulti, overrideStyles)=>({
        ...$7182f3cede2caefc$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles)
    }));

});

parcelRegister("cSqUf", function(module, exports) {

$parcel$export(module.exports, "getComponents", () => $95ff6637f10715bb$export$4e811121b221213b);
$parcel$export(module.exports, "getPopupComponents", () => $95ff6637f10715bb$export$19205fd341a6bb08);

var $5iWql = parcelRequire("5iWql");

var $2irAk = parcelRequire("2irAk");

var $31lbJ = parcelRequire("31lbJ");

var $cdIEP = parcelRequire("cdIEP");

var $doN3Q = parcelRequire("doN3Q");

var $3sQY8 = parcelRequire("3sQY8");

var $1szwy = parcelRequire("1szwy");

var $jQNxv = parcelRequire("jQNxv");

var $46jU3 = parcelRequire("46jU3");

var $4CvDN = parcelRequire("4CvDN");

var $5u7kw = parcelRequire("5u7kw");
const $95ff6637f10715bb$export$4e811121b221213b = (0, $5iWql.default)((multi, anchor)=>{
    if (anchor) return {
        Control: anchor,
        Option: $doN3Q.Option
    };
    else return {
        MultiValue: $31lbJ.MultiValue,
        DropdownIndicator: null,
        SingleValue: $3sQY8.SingleValue,
        ClearIndicator: multi ? null : (0, $2irAk.ClearIndicator),
        Option: $doN3Q.Option,
        ValueContainer: multi ? (0, $cdIEP.MultiValueContainer) : (0, $jQNxv.SingleValueContainer),
        Input: $1szwy.Input,
        Menu: $5u7kw.Menu
    };
});
const $95ff6637f10715bb$export$19205fd341a6bb08 = (0, $5iWql.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $3sQY8.SingleValue,
        ClearIndicator: $2irAk.ClearIndicator,
        Option: $doN3Q.Option,
        ValueContainer: (0, $jQNxv.SingleValueContainer),
        Input: (0, $46jU3.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $4CvDN.PopupControl)
    };
    return baseProps;
});

});
parcelRegister("2irAk", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $1ac2a8fba8ba908d$export$ecf9cf59142dd54a);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

const $1ac2a8fba8ba908d$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("18Hlr")).then((module)=>{
        return {
            default: module.default
        };
    }));
class $1ac2a8fba8ba908d$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "handleMouseDown", (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue();
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        });
    }
    render() {
        const { selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).ClearIndicator, (0, $kU09D.default)({}, this.props, {
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            }
        }));
        return clearValueLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
            fallback: Indicator
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ac2a8fba8ba908d$var$AsyncTooltip, {
            content: clearValueLabel
        }, Indicator)) : Indicator;
    }
}

});

parcelRegister("31lbJ", function(module, exports) {

$parcel$export(module.exports, "MultiValue", () => $2331e69db1f26beb$export$419cdf50db8b579);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $1YA4v = parcelRequire("1YA4v");

var $cudsP = parcelRequire("cudsP");

var $uT8cL = parcelRequire("uT8cL");

var $fsJBk = parcelRequire("fsJBk");

var $4nce6 = parcelRequire("4nce6");
const $2331e69db1f26beb$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $2331e69db1f26beb$var$groupTagContainer = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.025'
});
const $2331e69db1f26beb$var$nameWrapper = (0, $byn9U.css)({
    paddingLeft: `${"var(--ds-space-050, 4px)"}`
});
class $2331e69db1f26beb$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        (0, $5zQU9.default)(this, "getElemBefore", ()=>{
            const { data: { data: data }, selectProps: selectProps } = this.props;
            if ((0, $fsJBk.isEmail)(data)) return selectProps.emailLabel ? (0, $byn9U.jsx)((0, $1YA4v.AddOptionAvatar), {
                isLozenge: true,
                label: selectProps.emailLabel
            }) : (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $uT8cL.messages).addEmail, (label)=>(0, $byn9U.jsx)((0, $1YA4v.AddOptionAvatar), {
                    isLozenge: true,
                    label: label
                }));
            if ((0, $fsJBk.isGroup)(data)) return (0, $byn9U.jsx)((0, $b5IAe.default), {
                xcss: $2331e69db1f26beb$var$groupTagContainer
            }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
                label: "group-icon",
                size: "small"
            }));
            return (0, $byn9U.jsx)((0, $cudsP.SizeableAvatar), {
                appearance: "multi",
                src: (0, $fsJBk.getAvatarUrl)(data)
            });
        });
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
    }
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $2331e69db1f26beb$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: innerProps, ...rest } = this.props;
        return (0, $byn9U.jsx)((0, $jQxSL.c).MultiValue, (0, $kU09D.default)({}, rest, {
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }), this.getElemBefore(), " ", (0, $byn9U.jsx)("div", {
            css: $2331e69db1f26beb$var$nameWrapper
        }, children));
    }
}

});
parcelRegister("1YA4v", function(module, exports) {

$parcel$export(module.exports, "AddOptionAvatar", () => $1707601c2404a903$export$df396db45e491922);
/** @jsx jsx */ 
var $8IVhP = parcelRequire("8IVhP");

var $PdmhA = parcelRequire("PdmhA");

var $byn9U = parcelRequire("byn9U");
parcelRequire("eUqFw");
const $1707601c2404a903$var$getEmailAvatarWrapperStyle = (isLozenge)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    return (0, $byn9U.css)({
        padding: padding,
        backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA.N40)})`,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center'
    });
};
const $1707601c2404a903$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label })=>{
    return (0, $byn9U.jsx)("div", {
        css: $1707601c2404a903$var$getEmailAvatarWrapperStyle(isLozenge)
    }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8IVhP))), {
        label: label,
        size: isLozenge ? 'small' : 'medium',
        primaryColor: `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`
    }));
};

});
parcelRegister("8IVhP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $659edeb603307d4b$var$_react = $659edeb603307d4b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $659edeb603307d4b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $659edeb603307d4b$var$EmailIcon = (props)=>/*#__PURE__*/ $659edeb603307d4b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5 7v10h14V7H5zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h14z" fill-rule="nonzero"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 004.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.119 1.119 0 01-1.583 0L5.498 6.5z"/></g></svg>`
    }, props));
$659edeb603307d4b$var$EmailIcon.displayName = 'EmailIcon';
var $659edeb603307d4b$var$_default = $659edeb603307d4b$var$EmailIcon;
module.exports.default = $659edeb603307d4b$var$_default;

});


parcelRegister("cudsP", function(module, exports) {

$parcel$export(module.exports, "SizeableAvatar", () => $9172bb06a3d68af4$export$44d81a88129649da);

var $iJlfe = parcelRequire("iJlfe");

var $3Dk5Z = parcelRequire("3Dk5Z");

var $eUqFw = parcelRequire("eUqFw");

var $fsJBk = parcelRequire("fsJBk");
class $9172bb06a3d68af4$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person' } = this.props;
        const props = {
            size: (0, $fsJBk.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence
        };
        return type === 'team' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Dk5Z.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), props);
    }
}

});
parcelRegister("3Dk5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $1869a65c00213d53$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $PdmhA = parcelRequire("PdmhA");

var $eJ2Jf = parcelRequire("eJ2Jf");
const $1869a65c00213d53$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`;
const $1869a65c00213d53$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $PdmhA.N90)})`;
function $1869a65c00213d53$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "circle",
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`
    }, (innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ2Jf.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            ...innerProps
        }));
}

});
parcelRegister("eJ2Jf", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $3fb7f58cf3c7f578$export$ac3673635a5387be);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $4nce6 = parcelRequire("4nce6");

var $PdmhA = parcelRequire("PdmhA");
function $3fb7f58cf3c7f578$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3fb7f58cf3c7f578$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`;
const $3fb7f58cf3c7f578$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $PdmhA.N90)})`;
// used in a size calculation so can't be a token. Without this the avatar looks very squished
const $3fb7f58cf3c7f578$var$ICON_PADDING = 4;
const $3fb7f58cf3c7f578$var$avatarDefaultIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    backgroundColor: $3fb7f58cf3c7f578$var$ICON_COLOR,
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
});
const $3fb7f58cf3c7f578$var$nestedAvatarStyles = Object.entries((0, $eri7S.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $byn9U.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`,
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: `${size - $3fb7f58cf3c7f578$var$ICON_PADDING}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: `${size - $3fb7f58cf3c7f578$var$ICON_PADDING}px`
            }
        })
    };
}, {});
const $3fb7f58cf3c7f578$var$avatarImageStyles = {
    name: "n68006",
    styles: "display:flex;flex:1 1 100%;width:100%;height:100%"
};
const $3fb7f58cf3c7f578$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, ...rest })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eUqFw.useState)(false);
    // If src changes, reset state
    (0, $eUqFw.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $3fb7f58cf3c7f578$var$avatarDefaultIconStyles,
            $3fb7f58cf3c7f578$var$nestedAvatarStyles[size]
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
        label: alt,
        primaryColor: $3fb7f58cf3c7f578$var$ICON_BACKGROUND,
        secondaryColor: $3fb7f58cf3c7f578$var$ICON_COLOR,
        testId: testId && `${testId}--team`
    }));
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", rest, /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        css: $3fb7f58cf3c7f578$var$avatarImageStyles,
        onError: ()=>setHasImageErrored(true)
    }));
};

});
parcelRegister("4nce6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32f2cb577afb3a41$var$_react = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $32f2cb577afb3a41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $32f2cb577afb3a41$var$PeopleIcon = (props)=>/*#__PURE__*/ $32f2cb577afb3a41$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0V15z"/><path d="M13 12a1.997 1.997 0 00-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3.001 3.001 0 0112.997 12H13z"/></g></svg>`
    }, props));
$32f2cb577afb3a41$var$PeopleIcon.displayName = 'PeopleIcon';
var $32f2cb577afb3a41$var$_default = $32f2cb577afb3a41$var$PeopleIcon;
module.exports.default = $32f2cb577afb3a41$var$_default;

});





parcelRegister("cdIEP", function(module, exports) {

$parcel$export(module.exports, "MultiValueContainer", () => $8e595700d047ff1f$export$cf9cf2a30a59265c);

var $5zQU9 = parcelRequire("5zQU9");

var $jQxSL = parcelRequire("jQxSL");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $8uD7Y = parcelRequire("8uD7Y");

var $uT8cL = parcelRequire("uT8cL");

var $fsJBk = parcelRequire("fsJBk");

var $96aln = parcelRequire("96aln");
class $8e595700d047ff1f$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    constructor(props){
        super(props);
        (0, $5zQU9.default)(this, "timeoutId", null);
        (0, $5zQU9.default)(this, "scrollToBottom", ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) {
                    const container = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).findDOMNode(current);
                    if (container instanceof HTMLDivElement) container.scrollTop = container.scrollHeight;
                }
                this.timeoutId = null;
            });
        });
        (0, $5zQU9.default)(this, "showPlaceholder", ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        });
        (0, $5zQU9.default)(this, "addPlaceholder", (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(this.props.children, (child)=>(0, $fsJBk.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, children);
        });
        (0, $5zQU9.default)(this, "renderChildren", ()=>{
            const { selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
            // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $uT8cL.messages).addMore, (addMore)=>{
                var _join, _addMoreMessages;
                let addMoreMessages = addMore;
                if (addMore && typeof addMore === 'string') addMoreMessages = [
                    addMore
                ];
                const placeholder = (_join = (_addMoreMessages = addMoreMessages) === null || _addMoreMessages === void 0 ? void 0 : _addMoreMessages.join('')) !== null && _join !== void 0 ? _join : '';
                return this.addPlaceholder(placeholder);
            });
            return this.addPlaceholder(addMoreMessage);
        });
        (0, $5zQU9.default)(this, "onValueContainerClick", this.props.selectProps.onValueContainerClick);
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef()
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            innerProps: this.valueContainerInnerProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $96aln.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).ValueContainer, props, this.renderChildren()));
    }
}

});
parcelRegister("96aln", function(module, exports) {

$parcel$export(module.exports, "default", () => $69fcb2a1436bd977$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ const $69fcb2a1436bd977$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? (0, $byn9U.jsx)("div", {
        css: (0, $byn9U.css)({
            flexGrow: 1
        }),
        onMouseDown: onMouseDown
    }, children) : children;
};
var $69fcb2a1436bd977$export$2e2bcd8739ae039 = $69fcb2a1436bd977$var$ValueContainerWrapper;

});


parcelRegister("doN3Q", function(module, exports) {

$parcel$export(module.exports, "Option", () => $9c1392baec0378bc$export$36d18380658d5d20);

var $b5IAe = parcelRequire("b5IAe");

var $jQxSL = parcelRequire("jQxSL");

var $8cU5f = parcelRequire("8cU5f");

var $eUqFw = parcelRequire("eUqFw");

var $85OGa = parcelRequire("85OGa");

var $2GFk4 = parcelRequire("2GFk4");

var $iMZce = parcelRequire("iMZce");

var $cpaBb = parcelRequire("cpaBb");

var $6dmbS = parcelRequire("6dmbS");

var $gpQTF = parcelRequire("gpQTF");

var $fsJBk = parcelRequire("fsJBk");

var $d5vpa = parcelRequire("d5vpa");
const $9c1392baec0378bc$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>/*#__PURE__*/ // @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85OGa.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $9c1392baec0378bc$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $fsJBk.isExternalUser)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GFk4.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $fsJBk.isUser)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85OGa.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $fsJBk.isEmail)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6dmbS.default), {
        email: data,
        emailValidity: (0, $d5vpa.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $fsJBk.isTeam)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMZce.default), {
        team: data,
        isSelected: isSelected
    });
    if ((0, $fsJBk.isGroup)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cpaBb.default), {
        group: data,
        isSelected: isSelected
    });
    if ((0, $fsJBk.isCustom)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gpQTF.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $9c1392baec0378bc$var$dataOptionWithTooltip = (props)=>{
    var _props$data, _props$data$data;
    if ((_props$data = props.data) !== null && _props$data !== void 0 && (_props$data$data = _props$data.data) !== null && _props$data$data !== void 0 && _props$data$data.tooltip) {
        var _props$data2, _props$data2$data;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: (_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : (_props$data2$data = _props$data2.data) === null || _props$data2$data === void 0 ? void 0 : _props$data2$data.tooltip
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), tooltipProps, $9c1392baec0378bc$var$dataOption(props)));
    }
    return $9c1392baec0378bc$var$dataOption(props);
};
const $9c1392baec0378bc$export$36d18380658d5d20 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
        fallback: $9c1392baec0378bc$var$defaultOption(props)
    }, $9c1392baec0378bc$var$dataOptionWithTooltip(props)));

});
parcelRegister("85OGa", function(module, exports) {

$parcel$export(module.exports, "UserOption", () => $5e461a2bfe16a0ab$export$8e59f78010871662);

var $5zQU9 = parcelRequire("5zQU9");

var $PdmhA = parcelRequire("PdmhA");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $1LDgP = parcelRequire("1LDgP");

var $cclBP = parcelRequire("cclBP");

var $cudsP = parcelRequire("cudsP");

var $fsJBk = parcelRequire("fsJBk");
class $5e461a2bfe16a0ab$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "getPrimaryText", ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                (0, $byn9U.jsx)("span", {
                    key: "name",
                    css: (0, $1LDgP.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $PdmhA.B400})` : `var(--ds-text, ${0, $PdmhA.N800})`)
                }, (0, $byn9U.jsx)((0, $cclBP.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $fsJBk.hasValue)(publicName) && name.trim() !== publicName.trim()) result.push((0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
                key: "publicName"
            }, ' ', (0, $byn9U.jsx)("span", {
                css: (0, $1LDgP.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $PdmhA.B400})` : `var(--ds-text-subtlest, ${0, $PdmhA.N200})`)
            }, "(", (0, $byn9U.jsx)((0, $cclBP.HighlightText), {
                highlights: highlight && highlight.publicName
            }, publicName), ")")));
            return result;
        });
        (0, $5zQU9.default)(this, "renderSecondaryText", ()=>this.props.user.byline ? (0, $byn9U.jsx)("span", {
                css: (0, $1LDgP.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $PdmhA.B400})` : `var(--ds-text-subtlest, ${0, $PdmhA.N200})`)
            }, this.props.user.byline) : undefined);
        (0, $5zQU9.default)(this, "renderAvatar", ()=>{
            const { user: { avatarUrl: avatarUrl }, status: status } = this.props;
            return (0, $byn9U.jsx)((0, $cudsP.SizeableAvatar), {
                appearance: "big",
                src: avatarUrl,
                presence: status
            });
        });
        (0, $5zQU9.default)(this, "getLozengeProps", ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge);
    }
    render() {
        return (0, $byn9U.jsx)((0, $1LDgP.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
}

});
parcelRegister("1LDgP", function(module, exports) {

$parcel$export(module.exports, "textWrapper", () => $1498a48b708d3e66$export$aa6223da92b253dd);
$parcel$export(module.exports, "AvatarItemOption", () => $1498a48b708d3e66$export$164a9d9b3b86dd0c);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ffiyv = parcelRequire("ffiyv");

var $fsJBk = parcelRequire("fsJBk");

const $1498a48b708d3e66$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("18Hlr")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $1498a48b708d3e66$var$wrapper = (isDisabled)=>(0, $byn9U.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $1498a48b708d3e66$var$optionWrapper = (0, $byn9U.css)({
    maxWidth: '100%',
    minWidth: 0,
    flex: '1 1 100%',
    lineHeight: '1.4',
    paddingLeft: "var(--ds-space-100, 8px)"
});
const $1498a48b708d3e66$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        fontSize: '0.85em'
    } : {};
    return (0, $byn9U.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...secondaryCssArgs
    });
};
const $1498a48b708d3e66$var$additionalInfo = (0, $byn9U.css)({
    float: 'right'
});
const $1498a48b708d3e66$export$aa6223da92b253dd = (color)=>(0, $byn9U.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: color
    });
const $1498a48b708d3e66$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderLozenge = ()=>{
        if ((0, $fsJBk.isLozengeText)(lozenge)) {
            if (lozenge !== null && lozenge !== void 0 && lozenge.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
                fallback: (0, $byn9U.jsx)((0, $ffiyv.default), lozenge, lozenge.text)
            }, (0, $byn9U.jsx)($1498a48b708d3e66$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, (0, $byn9U.jsx)((0, $ffiyv.default), lozenge, lozenge.text)));
            return (0, $byn9U.jsx)((0, $ffiyv.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return (0, $byn9U.jsx)("span", {
        css: $1498a48b708d3e66$var$wrapper(isDisabled)
    }, avatar, (0, $byn9U.jsx)("div", {
        css: $1498a48b708d3e66$var$optionWrapper
    }, (0, $byn9U.jsx)("div", null, (0, $byn9U.jsx)("div", {
        css: $1498a48b708d3e66$var$getTextStyle()
    }, primaryText), secondaryText && (0, $byn9U.jsx)("div", {
        css: $1498a48b708d3e66$var$getTextStyle(true)
    }, secondaryText))), lozenge && (0, $byn9U.jsx)("div", {
        css: $1498a48b708d3e66$var$additionalInfo
    }, renderLozenge()));
};

});

parcelRegister("cclBP", function(module, exports) {

$parcel$export(module.exports, "HighlightText", () => $8e175e26f8d73298$export$bb02e7bc6e1a7119);

var $eUqFw = parcelRequire("eUqFw");
class $8e175e26f8d73298$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", {
                key: index
            }, part.value);
            return part.value;
        });
    }
}

});


parcelRegister("2GFk4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f4f8ed5d1f9a96e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $1f4f8ed5d1f9a96e$var$AsyncExternalUserOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("b67fw")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $1f4f8ed5d1f9a96e$export$2e2bcd8739ae039 = $1f4f8ed5d1f9a96e$var$AsyncExternalUserOption;

});
parcelRegister("b67fw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('cNKih')
        ]);
        const value = parcelRequire('7BrAc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("cNKih")
    ]).then(()=>parcelRequire('7BrAc'));
}

});


parcelRegister("iMZce", function(module, exports) {

$parcel$export(module.exports, "default", () => $dadc2dff35ebfafe$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $dadc2dff35ebfafe$var$AsyncTeamOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("guMLq")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $dadc2dff35ebfafe$export$2e2bcd8739ae039 = $dadc2dff35ebfafe$var$AsyncTeamOption;

});
parcelRegister("guMLq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8E1N9');
        const value = parcelRequire('kQYAJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8E1N9").then(()=>parcelRequire('kQYAJ'));
}

});


parcelRegister("cpaBb", function(module, exports) {

$parcel$export(module.exports, "default", () => $90800a8129880879$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $90800a8129880879$var$AsyncGroupOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("kXGlR")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $90800a8129880879$export$2e2bcd8739ae039 = $90800a8129880879$var$AsyncGroupOption;

});
parcelRegister("kXGlR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8kTUY');
        const value = parcelRequire('9rYyl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8kTUY").then(()=>parcelRequire('9rYyl'));
}

});


parcelRegister("6dmbS", function(module, exports) {

$parcel$export(module.exports, "default", () => $48652b8bd97d3a93$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $48652b8bd97d3a93$var$AsyncEmailOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("3wL4G")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $48652b8bd97d3a93$export$2e2bcd8739ae039 = $48652b8bd97d3a93$var$AsyncEmailOption;

});
parcelRegister("3wL4G", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bIOik');
        const value = parcelRequire('k0t8C');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bIOik").then(()=>parcelRequire('k0t8C'));
}

});


parcelRegister("gpQTF", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf38035a84a2d297$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $bf38035a84a2d297$var$AsyncCustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("2IILC")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $bf38035a84a2d297$export$2e2bcd8739ae039 = $bf38035a84a2d297$var$AsyncCustomOption;

});
parcelRegister("2IILC", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('daOwF');
        const value = parcelRequire('dmdSG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("daOwF").then(()=>parcelRequire('dmdSG'));
}

});



parcelRegister("3sQY8", function(module, exports) {

$parcel$export(module.exports, "SingleValue", () => $285d132ab114b9bf$export$1949dac661ba6e3a);

var $kU09D = parcelRequire("kU09D");

var $6R0C9 = parcelRequire("6R0C9");

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $cudsP = parcelRequire("cudsP");

var $fsJBk = parcelRequire("fsJBk");
const $285d132ab114b9bf$var$avatarItemComponent = (0, $byn9U.css)({
    border: 'none !important',
    padding: `${"var(--ds-space-0, 0px)"} !important`,
    width: 'auto',
    overflow: 'hidden',
    minWidth: '100px',
    '& > span': {
        boxSizing: 'border-box'
    },
    '&:hover': {
        width: 'auto',
        padding: 0,
        border: 'none'
    }
});
const $285d132ab114b9bf$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    return !isFocused ? (0, $byn9U.jsx)((0, $jQxSL.c).SingleValue, props, (0, $byn9U.jsx)((0, $6R0C9.default), {
        backgroundColor: "transparent",
        avatar: (0, $byn9U.jsx)((0, $cudsP.SizeableAvatar), {
            src: (0, $fsJBk.getAvatarUrl)(data),
            appearance: appearance
        }),
        primaryText: label
    }, ({ ref: ref, ...props })=>(0, $byn9U.jsx)("div", (0, $kU09D.default)({
            css: $285d132ab114b9bf$var$avatarItemComponent
        }, props)))) : null;
};

});
parcelRegister("6R0C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d303d2caa12f1c14$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $1Yimi = parcelRequire("1Yimi");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $eri7S = parcelRequire("eri7S");

var $6ecEX = parcelRequire("6ecEX");
function $d303d2caa12f1c14$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d303d2caa12f1c14$var$avatarItemStyles = {
    name: "1dq1lfl",
    styles: "min-width:0;max-width:100%;flex:1 1 100%;line-height:1.4;padding-inline-start:var(--ds-space-100, 8px)"
};
const $d303d2caa12f1c14$var$secondaryTextOldStyles = {
    name: "1udad45",
    styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.85em"
};
const $d303d2caa12f1c14$var$baseTextStyles = {
    name: "1sodx6b",
    styles: "display:block;color:var(--ds-text, #172B4D)"
};
const $d303d2caa12f1c14$var$truncationStyles = {
    name: "n3ut7m",
    styles: "overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $d303d2caa12f1c14$var$getStyles = (css, { backgroundColor: backgroundColor, isInteractive: isInteractive, isDisabled: isDisabled })=>// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @repo/internal/react/no-css-string-literals
    css`
		align-items: center;
		background-color: ${backgroundColor};
		border-radius: ${(0, $lcnyw.borderRadius)()}px;
		border: ${0, $eri7S.BORDER_WIDTH}px solid transparent;
		box-sizing: border-box;
		color: inherit;
		display: flex;
		font-size: inherit;
		font-style: normal;
		font-weight: normal;
		line-height: 1;
		outline: none;
		margin: ${"var(--ds-space-0, 0px)"};
		padding: ${"var(--ds-space-050, 4px)"};
		text-align: left;
		text-decoration: none;
		width: 100%;

		${isInteractive && `
        :hover {
          background-color: ${`var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N30})`};
          cursor: pointer;
          text-decoration: none;
        }

        :focus {
          outline: none;
          border-color: ${`var(--ds-border-focused, ${0, $PdmhA.B200})`};
        }

        :active {
          background-color: ${`var(--ds-background-neutral-subtle-pressed, ${0, $PdmhA.B50})`};
        }
      `}

		${isDisabled && `
        cursor: not-allowed;
        opacity: ${"var(--ds-opacity-disabled, 0.5)"};
        pointer-events: none;
      `}
	`;
/**
 * __Avatar item__
 *
 * An avatar item is a wrapper that goes around an avatar when it's displayed alongside text, such as a name or status.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-item/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-item/code)
 */ const $d303d2caa12f1c14$var$AvatarItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ avatar: avatar, backgroundColor: backgroundColor = 'transparent', children: children, isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label }, ref)=>{
    const getTestId = (testId, children)=>!children ? {
            'data-testid': `${testId}--itemInner`
        } : {
            testId: `${testId}--itemInner`
        };
    const componentProps = ()=>{
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return {
            ...href && (0, $6ecEX.getLinkProps)(href, target),
            ...onClick && !href ? (0, $6ecEX.getButtonProps)(onClick) : {
                onClick: onClick
            }
        };
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>{
        const props = {
            ref: ref,
            className: $d303d2caa12f1c14$var$getStyles(css, {
                backgroundColor: backgroundColor,
                isInteractive: Boolean(onClick || href),
                isDisabled: isDisabled
            }),
            ...componentProps(),
            ...testId && getTestId(testId, children),
            ...(onClick || href) && {
                'aria-label': label
            },
            children: /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, avatar, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: $d303d2caa12f1c14$var$avatarItemStyles
            }, (0, $XHGTv.getBooleanFF)('platform.design-system-team.avatar-item-font-size_830x6') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
                maxLines: isTruncationDisabled ? undefined : 1
            }, primaryText), /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
                color: "color.text.subtlest",
                maxLines: isTruncationDisabled ? undefined : 1,
                size: "UNSAFE_small"
            }, secondaryText)) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: [
                    $d303d2caa12f1c14$var$baseTextStyles,
                    !isTruncationDisabled && $d303d2caa12f1c14$var$truncationStyles
                ]
            }, primaryText), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: [
                    $d303d2caa12f1c14$var$baseTextStyles,
                    $d303d2caa12f1c14$var$secondaryTextOldStyles,
                    !isTruncationDisabled && $d303d2caa12f1c14$var$truncationStyles
                ]
            }, secondaryText))))
        };
        return children ? children(props) : /*#__PURE__*/ (0, $eUqFw.createElement)((0, $6ecEX.getCustomElement)(isDisabled, href, onClick), props);
    });
});
$d303d2caa12f1c14$var$AvatarItem.displayName = 'AvatarItem';
var $d303d2caa12f1c14$export$2e2bcd8739ae039 = $d303d2caa12f1c14$var$AvatarItem;

});


parcelRegister("1szwy", function(module, exports) {

$parcel$export(module.exports, "Input", () => $1103f64c4af6ffef$export$f5b8910cec6cf069);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
class $1103f64c4af6ffef$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        (0, $5zQU9.default)(this, "handleKeyPress", (e)=>{
            var _this$props$selectPro;
            if (e.key === 'Enter') e.preventDefault();
            if ((_this$props$selectPro = this.props.selectProps) !== null && _this$props$selectPro !== void 0 && _this$props$selectPro.disableInput) e.preventDefault();
        });
    }
    /**
   * Overrides the default behaviour of react-select lib
   *
   * The getter is a workaround for original behaviour of the react-select lib.
   * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
   * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
   * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
   */ get ariaLabelledBy() {
        var _this$props$ariaLabe;
        return (_this$props$ariaLabe = this.props['aria-labelledby']) !== null && _this$props$ariaLabe !== void 0 ? _this$props$ariaLabe : this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        var _this$props$selectPro2, _this$props$selectPro3;
        return (_this$props$selectPro2 = (_this$props$selectPro3 = this.props.selectProps) === null || _this$props$selectPro3 === void 0 ? void 0 : _this$props$selectPro3['aria-describedby']) !== null && _this$props$selectPro2 !== void 0 ? _this$props$selectPro2 : this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, (0, $kU09D.default)({}, this.props, {
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress
        }));
    }
}

});

parcelRegister("jQNxv", function(module, exports) {

$parcel$export(module.exports, "SingleValueContainer", () => $e7394d242e680f8c$export$afa5f855316c6a48);

var $5zQU9 = parcelRequire("5zQU9");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $cudsP = parcelRequire("cudsP");

var $9KdAH = parcelRequire("9KdAH");

var $96aln = parcelRequire("96aln");
const $e7394d242e680f8c$var$placeholderIconContainer = (0, $byn9U.css)({
    paddingLeft: (0, $9KdAH.BORDER_PADDING),
    lineHeight: 0,
    gridArea: '1/1/2/2'
});
const $e7394d242e680f8c$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
class $e7394d242e680f8c$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "renderAvatar", ()=>{
            const { hasValue: hasValue, selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) return (0, $byn9U.jsx)((0, $cudsP.SizeableAvatar), {
                appearance: appearance,
                type: placeholderAvatar,
                src: $e7394d242e680f8c$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
            });
            return null;
        });
        (0, $5zQU9.default)(this, "onValueContainerClick", this.props.selectProps.onValueContainerClick);
        (0, $5zQU9.default)(this, "Wrapper", ({ children: children })=>{
            return this.onValueContainerClick ? (0, $byn9U.jsx)("div", {
                css: (0, $byn9U.css)({
                    flexGrow: 1
                }),
                onMouseDown: this.onValueContainerClick
            }, children) : children;
        });
    }
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return (0, $byn9U.jsx)((0, $96aln.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, (0, $byn9U.jsx)((0, $jQxSL.c).ValueContainer, valueContainerProps, (0, $byn9U.jsx)("div", {
            css: $e7394d242e680f8c$var$placeholderIconContainer
        }, this.renderAvatar()), children));
    }
}

});

parcelRegister("46jU3", function(module, exports) {

$parcel$export(module.exports, "PopupInput", () => $2fc7294ac68fce4d$export$d8edbfd510a7db82);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $1szwy = parcelRequire("1szwy");
class $2fc7294ac68fce4d$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "ref", null);
        (0, $5zQU9.default)(this, "handleInnerRef", (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        });
    }
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1szwy.Input), (0, $kU09D.default)({}, this.props, {
            innerRef: this.handleInnerRef
        }));
    }
}

});

parcelRegister("4CvDN", function(module, exports) {

$parcel$export(module.exports, "PopupControl", () => $35d3413fa632bc25$export$a0cb1b4352357fcc);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $35d3413fa632bc25$var$spacing = 8;
const $35d3413fa632bc25$var$fontSize = 12;
const $35d3413fa632bc25$var$innerHeight = $35d3413fa632bc25$var$spacing * 2; // 16px
const $35d3413fa632bc25$var$lineHeight = $35d3413fa632bc25$var$innerHeight / $35d3413fa632bc25$var$fontSize;
const $35d3413fa632bc25$var$controlWrapper = (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $35d3413fa632bc25$var$getLabelStyle = ()=>(0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`,
        fontSize: `${$35d3413fa632bc25$var$fontSize}px`,
        fontWeight: 600,
        lineHeight: `${$35d3413fa632bc25$var$lineHeight}`,
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-0, 0px)",
        paddingRight: "var(--ds-space-0, 0px)",
        paddingTop: "var(--ds-space-250, 20px)"
    });
class $35d3413fa632bc25$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { selectProps: { popupTitle: popupTitle } } = this.props;
        return (0, $byn9U.jsx)("div", {
            css: $35d3413fa632bc25$var$controlWrapper
        }, (0, $byn9U.jsx)("div", {
            css: $35d3413fa632bc25$var$getLabelStyle()
        }, popupTitle), (0, $byn9U.jsx)((0, $jQxSL.c).Control, this.props));
    }
}

});

parcelRegister("5u7kw", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $3fe570ab1a7ed1b2$export$d9b273488cd8ce6f);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");
const $3fe570ab1a7ed1b2$var$getFooterStyle = ()=>{
    return (0, $byn9U.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $3fe570ab1a7ed1b2$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        return (0, $byn9U.jsx)((0, $jQxSL.c).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && (0, $byn9U.jsx)("div", {
            css: $3fe570ab1a7ed1b2$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}

});


parcelRegister("5n5Lr", function(module, exports) {

$parcel$export(module.exports, "getCreatableProps", () => $3e93925dd21e6d89$export$36f97d8afa97203d);

var $5iWql = parcelRequire("5iWql");


var $d5vpa = parcelRequire("d5vpa");

var $fsJBk = parcelRequire("fsJBk");
const $3e93925dd21e6d89$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $3e93925dd21e6d89$var$isValidNewOption = (isValidEmail = (0, $d5vpa.isValidEmail))=>(inputValue)=>inputValue && $3e93925dd21e6d89$var$validOption.includes(isValidEmail(inputValue));
const $3e93925dd21e6d89$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $2147a04a3259adea$export$6662b3461398ef8c)
        }
    });
const $3e93925dd21e6d89$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $3e93925dd21e6d89$var$isOptionDisabled = (isValidEmail = (0, $d5vpa.isValidEmail))=>(option)=>{
        if ((0, $fsJBk.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $3e93925dd21e6d89$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $3e93925dd21e6d89$var$isValidNewOption(isValidEmail),
        getNewOptionData: $3e93925dd21e6d89$var$getNewOptionData,
        formatCreateLabel: $3e93925dd21e6d89$var$formatCreateLabel,
        isOptionDisabled: $3e93925dd21e6d89$var$isOptionDisabled(isValidEmail)
    };
}
const $3e93925dd21e6d89$export$36f97d8afa97203d = (0, $5iWql.default)($3e93925dd21e6d89$var$creatableProps);

});

parcelRegister("3uP8y", function(module, exports) {

$parcel$export(module.exports, "getCreatableSuggestedEmailProps", () => $28bbd7309753d67e$export$34b9dd2dd6a225e5);

var $5iWql = parcelRequire("5iWql");


var $d5vpa = parcelRequire("d5vpa");

var $fsJBk = parcelRequire("fsJBk");
const $28bbd7309753d67e$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $28bbd7309753d67e$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $28bbd7309753d67e$var$getNewOptionData = (isValidEmail = (0, $d5vpa.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $28bbd7309753d67e$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $2147a04a3259adea$export$6662b3461398ef8c),
                suggestion: true
            }
        };
    };
const $28bbd7309753d67e$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $28bbd7309753d67e$var$isOptionDisabled = (isValidEmail = (0, $d5vpa.isValidEmail))=>(option)=>{
        if ((0, $fsJBk.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $28bbd7309753d67e$export$34b9dd2dd6a225e5 = (0, $5iWql.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $28bbd7309753d67e$var$isValidNewOption,
        getNewOptionData: $28bbd7309753d67e$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $28bbd7309753d67e$var$formatCreateLabel,
        isOptionDisabled: $28bbd7309753d67e$var$isOptionDisabled(isValidEmail)
    }));

});

parcelRegister("9BvGg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fe024e08d21387a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
var $5JgJ2 = parcelRequire("5JgJ2");

var $l1UeS = parcelRequire("l1UeS");
const $6fe024e08d21387a$var$EMPTY = {};
const $6fe024e08d21387a$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState($6fe024e08d21387a$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        let aborted = false;
        setMessages($6fe024e08d21387a$var$EMPTY);
        (0, $l1UeS.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $6fe024e08d21387a$var$MessagesIntlProvider = (props)=>{
    const intl = (0, $5JgJ2.default)();
    const { children: children } = props;
    const messages = $6fe024e08d21387a$var$useI18n(intl.locale);
    const mergedMessages = (0, $eUqFw.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: intl.locale,
        messages: mergedMessages
    }, children);
};
var $6fe024e08d21387a$export$2e2bcd8739ae039 = $6fe024e08d21387a$var$MessagesIntlProvider;

});
parcelRegister("l1UeS", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $f4f550d815c67422$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $f4f550d815c67422$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("k9voL")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("jv0Jb")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("bbFru")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("5aRKp")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("7cjbf")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("294be")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("hNzqS")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("aukaS")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("kvTog")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("fmhOS")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("40JNa")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("dwlXf")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("8eTUg")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("aiPF4")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("h1o5l")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("f8mWz")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("7qcDq")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("hdVk3")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("bHXfL")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("133Nn")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("1HVWK")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("abGYc")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("UwAhN")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("h6lMr")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("9IrJK")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("9G4Xj")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("6TF6p")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("bb4bW")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("jz1OY")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $f4f550d815c67422$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("5aRKp")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("k9voL", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('aBxeV');
        const value = parcelRequire('N9XZ8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("aBxeV").then(()=>parcelRequire('N9XZ8'));
}

});

parcelRegister("jv0Jb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5BYGg');
        const value = parcelRequire('dN5Wb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5BYGg").then(()=>parcelRequire('dN5Wb'));
}

});

parcelRegister("bbFru", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cn1q7');
        const value = parcelRequire('bF4fg');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cn1q7").then(()=>parcelRequire('bF4fg'));
}

});

parcelRegister("5aRKp", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ivtYS');
        const value = parcelRequire('k9nIM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ivtYS").then(()=>parcelRequire('k9nIM'));
}

});

parcelRegister("7cjbf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hMs6u');
        const value = parcelRequire('1zbhf');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hMs6u").then(()=>parcelRequire('1zbhf'));
}

});

parcelRegister("294be", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('52cIS');
        const value = parcelRequire('bcV4q');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("52cIS").then(()=>parcelRequire('bcV4q'));
}

});

parcelRegister("hNzqS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fHcZb');
        const value = parcelRequire('TJpNQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fHcZb").then(()=>parcelRequire('TJpNQ'));
}

});

parcelRegister("aukaS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4WLGH');
        const value = parcelRequire('j7NvT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4WLGH").then(()=>parcelRequire('j7NvT'));
}

});

parcelRegister("kvTog", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lHKvw');
        const value = parcelRequire('frO4z');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lHKvw").then(()=>parcelRequire('frO4z'));
}

});

parcelRegister("fmhOS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8tp0J');
        const value = parcelRequire('i2kjt');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8tp0J").then(()=>parcelRequire('i2kjt'));
}

});

parcelRegister("40JNa", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('38vGy');
        const value = parcelRequire('0ekPN');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("38vGy").then(()=>parcelRequire('0ekPN'));
}

});

parcelRegister("dwlXf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('O8ybJ');
        const value = parcelRequire('iwSS6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("O8ybJ").then(()=>parcelRequire('iwSS6'));
}

});

parcelRegister("8eTUg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('89KWR');
        const value = parcelRequire('4A9vZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("89KWR").then(()=>parcelRequire('4A9vZ'));
}

});

parcelRegister("aiPF4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('zkux8');
        const value = parcelRequire('1cYsb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("zkux8").then(()=>parcelRequire('1cYsb'));
}

});

parcelRegister("h1o5l", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1KTQE');
        const value = parcelRequire('2bekF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1KTQE").then(()=>parcelRequire('2bekF'));
}

});

parcelRegister("f8mWz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('961Wz');
        const value = parcelRequire('bec7F');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("961Wz").then(()=>parcelRequire('bec7F'));
}

});

parcelRegister("7qcDq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('g6aLd');
        const value = parcelRequire('4Bw6I');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("g6aLd").then(()=>parcelRequire('4Bw6I'));
}

});

parcelRegister("hdVk3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9bJs0');
        const value = parcelRequire('kl7Jh');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9bJs0").then(()=>parcelRequire('kl7Jh'));
}

});

parcelRegister("bHXfL", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bK955');
        const value = parcelRequire('cV3SN');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bK955").then(()=>parcelRequire('cV3SN'));
}

});

parcelRegister("133Nn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('Txyt5');
        const value = parcelRequire('3maOt');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("Txyt5").then(()=>parcelRequire('3maOt'));
}

});

parcelRegister("1HVWK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('b2lDk');
        const value = parcelRequire('9SpiW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("b2lDk").then(()=>parcelRequire('9SpiW'));
}

});

parcelRegister("abGYc", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kqABn');
        const value = parcelRequire('6xi0i');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kqABn").then(()=>parcelRequire('6xi0i'));
}

});

parcelRegister("UwAhN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5nts0');
        const value = parcelRequire('fMadB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5nts0").then(()=>parcelRequire('fMadB'));
}

});

parcelRegister("h6lMr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5Zbmq');
        const value = parcelRequire('18TWk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5Zbmq").then(()=>parcelRequire('18TWk'));
}

});

parcelRegister("9IrJK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('erNnX');
        const value = parcelRequire('amx9n');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("erNnX").then(()=>parcelRequire('amx9n'));
}

});

parcelRegister("9G4Xj", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dHKxD');
        const value = parcelRequire('2xvmu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dHKxD").then(()=>parcelRequire('2xvmu'));
}

});

parcelRegister("6TF6p", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lWfhs');
        const value = parcelRequire('anPhq');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lWfhs").then(()=>parcelRequire('anPhq'));
}

});

parcelRegister("bb4bW", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2ejpl');
        const value = parcelRequire('1gLy1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2ejpl").then(()=>parcelRequire('1gLy1'));
}

});

parcelRegister("jz1OY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kIgoL');
        const value = parcelRequire('1B1ow');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kIgoL").then(()=>parcelRequire('1B1ow'));
}

});



parcelRegister("taler", function(module, exports) {

$parcel$export(module.exports, "ExusUserSourceProvider", () => $057abb251699d3b5$export$bcd5c65b586ee3c3);
$parcel$export(module.exports, "useUserSource", () => $057abb251699d3b5$export$c6c0c1a2bac363f);

var $eUqFw = parcelRequire("eUqFw");
const $057abb251699d3b5$var$ExusUserSourceContext = /*#__PURE__*/ (0, $eUqFw.createContext)({});
const $057abb251699d3b5$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($057abb251699d3b5$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        }
    }, children);
const $057abb251699d3b5$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $eUqFw.useContext)($057abb251699d3b5$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $eUqFw.useState)([]);
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const abortController = (0, $eUqFw.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController === null || abortController === void 0 || abortController.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController === null || abortController === void 0 ? void 0 : abortController.signal).then((externalSources)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources !== null && existingSources !== void 0 ? existingSources : [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};

});


const $79f5e0bdbf2d77b2$export$61a0b64dfe00294c = 'USER_PICKER_EMPTY';
const $79f5e0bdbf2d77b2$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';

parcelRegister("lhOlj", function(module, exports) {

$parcel$export(module.exports, "INVITE_FROM_ASSIGN", () => $9dd8b7eb4a7274d2$export$d304132d091ca1ac);
$parcel$export(module.exports, "getInviteFromAssignCohort", () => $9dd8b7eb4a7274d2$export$dfa2a595c2323732);
$parcel$export(module.exports, "isInviteFromAssignEnabled", () => $9dd8b7eb4a7274d2$export$cdd5c612352d7bf0);
$parcel$export(module.exports, "getInviteFromAssignModalCohort", () => $9dd8b7eb4a7274d2$export$5b9220081498abd7);
$parcel$export(module.exports, "isInviteFromAssignModalFeEnabled", () => $9dd8b7eb4a7274d2$export$89f18660d3a3bb78);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $1ybV0 = parcelRequire("1ybV0");
const $9dd8b7eb4a7274d2$export$d304132d091ca1ac = 'invite.from.assign';
const $9dd8b7eb4a7274d2$export$dfa2a595c2323732 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)($9dd8b7eb4a7274d2$export$d304132d091ca1ac, 'not-enrolled', [
        'control',
        'not-enrolled',
        'variation'
    ]);
const $9dd8b7eb4a7274d2$export$cdd5c612352d7bf0 = ()=>$9dd8b7eb4a7274d2$export$dfa2a595c2323732() === 'variation';
const $9dd8b7eb4a7274d2$export$5b9220081498abd7 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('invite.from.assign.modal', 'not-enrolled', [
        'control',
        'not-enrolled',
        'variation'
    ]);
const $9dd8b7eb4a7274d2$export$89f18660d3a3bb78 = ()=>(0, $1ybV0.ff)('invite.from.assign.modal.fe.event', false);

});


parcelRegister("kpn8k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c2341632da5aee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aK7xv = parcelRequire("aK7xv");

var $94r7i = parcelRequire("94r7i");

var $2NwGr = parcelRequire("2NwGr");
const $e4c2341632da5aee$var$WithProfileCardNext = (props)=>{
    const accountId = (0, $aK7xv.mapExternalUserToAccountId)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    props.userAccount);
    const fullName = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $94r7i.mapExternalUserToFullName)(props.userAccount);
    const renderAsyncProfileCardWrapper = (accountIdInArgs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2NwGr.AsyncProfileCardNext), {
            accountId: accountIdInArgs,
            analyticsData: props.analyticsData,
            position: props.position,
            actions: props.actions,
            testId: props.testId,
            prepopulatedData: {
                fullName: fullName
            }
        }, props.children);
    return accountId ? renderAsyncProfileCardWrapper(accountId) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
};
var $e4c2341632da5aee$export$2e2bcd8739ae039 = $e4c2341632da5aee$var$WithProfileCardNext;

});
parcelRegister("aK7xv", function(module, exports) {

$parcel$export(module.exports, "mapExternalUserToAccountId", () => $1917fb93a2bbd593$export$4983762135761fa5);
const $1917fb93a2bbd593$export$4983762135761fa5 = (userAccount)=>userAccount && (userAccount.accountId || userAccount.id || userAccount.value);

});

parcelRegister("94r7i", function(module, exports) {

$parcel$export(module.exports, "mapExternalUserToFullName", () => $9b886aa43f58b774$export$41cd9a762b532c74);
const $9b886aa43f58b774$export$41cd9a762b532c74 = (userAccount)=>userAccount && (userAccount?.displayName || userAccount?.name);

});

parcelRegister("2NwGr", function(module, exports) {

$parcel$export(module.exports, "AsyncProfileCardNext", () => $d91bacdeb64d663f$export$a3c0845f856d4292);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $1lXFP = parcelRequire("1lXFP");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d91bacdeb64d663f$var$LazyComponent = (0, $7rh0R.lazy)(()=>(parcelRequire("7TVzk")).then((module)=>module.ProfileCard), {
    moduleId: "./src/packages/profilecard-next/src/main.tsx"
});
const $d91bacdeb64d663f$export$a3c0845f856d4292 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "AsyncProfileCardNext",
        packageName: "jiraProfilecardNext",
        render: ()=>// props.children in this context is the code being wrapped
            // in a <ProfileCardTrigger> (I.e. it is the thing a user hovers over to
            // display a profile card).
            // In the event of an unexpected error within @atlaskit/profilecard,
            // just render the unwrapped children (I.e. they will render but nothing
            // happens on hover)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada",
        attributes: (0, $1lXFP.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-profile-card-next-view",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d91bacdeb64d663f$var$LazyComponent, props)));
var $d91bacdeb64d663f$export$2e2bcd8739ae039 = $d91bacdeb64d663f$export$a3c0845f856d4292;

});
parcelRegister("1lXFP", function(module, exports) {

$parcel$export(module.exports, "isLoaderErrorAttributes", () => $1c31f74fac112a78$export$c7209ce2e0d060ea);

var $7rh0R = parcelRequire("7rh0R");
const $1c31f74fac112a78$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $7rh0R.isLoaderError)(error)
    });

});

parcelRegister("7TVzk", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('keVAk')
        ]);
        const value = parcelRequire('12NzK');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("keVAk")
    ]).then(()=>parcelRequire('12NzK'));
}

});



parcelRegister("i4m05", function(module, exports) {

$parcel$export(module.exports, "isDisableEpicLinkAndParentLinkFieldsEnabled", () => $56bce285869754d0$export$dd5401dbc8bdbdfb);
$parcel$export(module.exports, "isInviteFromAssignModalFeEnabled", () => $56bce285869754d0$export$89f18660d3a3bb78);

var $1ybV0 = parcelRequire("1ybV0");
const $56bce285869754d0$export$dd5401dbc8bdbdfb = ()=>(0, $1ybV0.ff)('disable-epic-link-and-parent-link-fields-in-issue-view-and-gic_zixrt', false);
const $56bce285869754d0$export$89f18660d3a3bb78 = ()=>(0, $1ybV0.ff)('invite.from.assign.modal.fe.event', false);

});

parcelRegister("bTMEp", function(module, exports) {
module.exports = new URL("add.6dea82c4.png", import.meta.url).toString();

});

parcelRegister("7EhsI", function(module, exports) {

$parcel$export(module.exports, "default", () => $444dbbdf6f0864b7$export$2e2bcd8739ae039);
/* inline-edit-container.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $444dbbdf6f0864b7$var$nonEditableStyles = null;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$444dbbdf6f0864b7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _18u0x0bf _19pkx0bf _15wgxy5q",
            !__cmplp.isEditable && "_1bchutpp _79paidpf _1tkg1wug _1a1dkb7n _supgidpf _1os4v77o _u3nv12x7 _omi312x7",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3mqjZ", function(module, exports) {

$parcel$export(module.exports, "readViewContainerSelectorName", () => $10bdaa1802dbda39$export$195ee2a97947e11b);
$parcel$export(module.exports, "NameWrapper", () => $10bdaa1802dbda39$export$45df02f361199409);
$parcel$export(module.exports, "UserStatus", () => $10bdaa1802dbda39$export$a82073022ded66e8);
$parcel$export(module.exports, "default", () => $10bdaa1802dbda39$export$2e2bcd8739ae039);
/* read-view-container.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $10bdaa1802dbda39$export$195ee2a97947e11b = 'jira-issue-view-field-users-read-view-container';
const $10bdaa1802dbda39$export$8fa12d0dcf2da542 = `[data-component-selector="${$10bdaa1802dbda39$export$195ee2a97947e11b}"]`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10bdaa1802dbda39$var$ReadViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _1yt41cy0",
            __cmplp.className
        ])
    });
});
const $10bdaa1802dbda39$export$45df02f361199409 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _zulp1nxw",
            __cmplp.className
        ])
    });
});
const $10bdaa1802dbda39$export$a82073022ded66e8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz",
            __cmplp.className
        ])
    });
});
var $10bdaa1802dbda39$export$2e2bcd8739ae039 = $10bdaa1802dbda39$var$ReadViewContainer;

});

parcelRegister("afUCr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1339487e17920166$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $1339487e17920166$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    invitePeopleOption: {
        "id": "issue.assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue.assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    },
    deactivated: {
        "id": "issue.assignee.deactivated-status",
        "defaultMessage": "Deactivated"
    }
});

});


parcelRegister("kohoO", function(module, exports) {

$parcel$export(module.exports, "useAssignInvitedUserService", () => $6dfee2ecdaa9737a$export$8b5826725f288a6a);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bL8w5 = parcelRequire("bL8w5");
const $6dfee2ecdaa9737a$var$getRestApiPath = (issueKey)=>`/rest/internal/latest/issue/${issueKey}/assignInvitedUser`;
const $6dfee2ecdaa9737a$export$f5e4c120ac01b615 = (0, $eo17r.toFlagId)('ASSIGN_INVITED_USER_ERROR');
const $6dfee2ecdaa9737a$export$8b5826725f288a6a = ()=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(async ({ issueKey: issueKey, accountId: accountId })=>{
        try {
            await (0, $lRmyA.performPostRequest)($6dfee2ecdaa9737a$var$getRestApiPath(issueKey), {
                body: JSON.stringify({
                    invitedUserId: accountId
                })
            });
            const analyticsEvent = createAnalyticsEvent({});
            const attributes = {
                fieldKey: 'assignee',
                fieldType: 'user',
                isAssignInvitedUser: true
            };
            // intentionally firing the event even if BE call fails to update the field
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'field updated', attributes);
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', attributes);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useAssignInvitedUserService',
                    packageName: 'jiraIssueViewServices',
                    // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                    teamName: 'jlove-makkuro'
                },
                error: error
            });
            showFlag({
                id: $6dfee2ecdaa9737a$export$f5e4c120ac01b615,
                type: 'error',
                title: formatMessage((0, $bL8w5.messages).errorFlagTitle),
                description: formatMessage((0, $bL8w5.messages).errorFlagDescription),
                isAutoDismiss: true
            });
        }
    }, [
        createAnalyticsEvent,
        formatMessage,
        showFlag
    ]);
};

});
parcelRegister("bL8w5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8114b6f11932ff0d$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $8114b6f11932ff0d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    errorFlagTitle: {
        "id": "issue.view.assign-invited-user-service.error.flag.title-non-final",
        "defaultMessage": "We couldn\u2019t assign this issue"
    },
    errorFlagDescription: {
        "id": "issue.view.assign-invited-user-service.error.flag.description-non-final",
        "defaultMessage": "Try adding the assignee again. If this problem persists, contact your site administrator."
    }
});

});


parcelRegister("crsr5", function(module, exports) {

$parcel$export(module.exports, "useInviteUserService", () => $8191934e9d349a9a$export$a7ff8105e0e1ab1);

var $eUqFw = parcelRequire("eUqFw");

var $jkH4Q = parcelRequire("jkH4Q");

var $65Cy1 = parcelRequire("65Cy1");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dWLk9 = parcelRequire("dWLk9");
var $3e9vj = parcelRequire("3e9vj");

var $ekQgg = parcelRequire("ekQgg");

var $iQZzw = parcelRequire("iQZzw");

var $6aWgX = parcelRequire("6aWgX");
const $8191934e9d349a9a$export$f5e4c120ac01b615 = (0, $eo17r.toFlagId)('UNSUCCESSFUL_INVITE');
const $8191934e9d349a9a$export$ec0604f9ead641f3 = async ({ resources: resources, users: users, continueUrl: continueUrl, recaptchaToken: recaptchaToken })=>(0, $lRmyA.performPostRequest)((0, $ekQgg.INVITE_USERS_ENDPOINT), {
        headers: {
            'Content-Type': 'application/json',
            ...recaptchaToken ? {
                'G-Recaptcha-Token': recaptchaToken
            } : {}
        },
        body: JSON.stringify({
            users: users,
            resources: resources,
            continueUrl: continueUrl
        })
    });
const $8191934e9d349a9a$export$a7ff8105e0e1ab1 = ({ analyticsSource: analyticsSource })=>{
    const environment = (0, $3e9vj.useEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { getRecaptchaToken: getRecaptchaToken } = (0, $65Cy1.useInvisibleRecaptcha)({
        siteKey: (0, $6aWgX.getRecaptchaSiteKey)(environment),
        displayBadge: false,
        analyticsChannel: 'assigneeView',
        analyticsSource: analyticsSource
    });
    return (0, $eUqFw.useCallback)(async ({ email: email, issueKey: issueKey })=>{
        try {
            const jiraAri = (0, $6aWgX.getJiraSoftwareAri)(cloudId);
            const recaptchaToken = await getRecaptchaToken?.('v1_invitations_invite').catch(// If token generation fails we want to just continue with the
            // request without a recaptcha token (the lib will fire an event)
            ()=>undefined);
            const atlOrigin = new (0, $jkH4Q.default)({
                product: 'jira'
            });
            const continueUrl = atlOrigin.addToUrl(`${window.location.origin}/browse/${issueKey}`);
            const invitedUsers = await $8191934e9d349a9a$export$ec0604f9ead641f3({
                resources: [
                    jiraAri
                ],
                users: [
                    {
                        email: email
                    }
                ],
                continueUrl: continueUrl,
                recaptchaToken: recaptchaToken
            });
            const invitedUser = invitedUsers[0];
            const inviteResult = invitedUser.results[jiraAri];
            if (inviteResult === (0, $ekQgg.INVITED_STATUS)) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'user invited', invitedUser.id, {
                integration: 'assigneeViewField',
                ...atlOrigin.toAnalyticsAttributes({
                    hasGeneratedId: true
                })
            });
            if (inviteResult === (0, $ekQgg.USER_EXISTS_STATUS)) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'userInvite alreadyExists');
            return (0, $6aWgX.transformInviteResult)({
                userId: invitedUser.id,
                result: inviteResult,
                errorReason: invitedUser.errorReasons[jiraAri]
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useInviteUserService',
                    packageName: 'jiraIssueViewServices',
                    // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                    teamName: 'jlove-makkuro'
                },
                error: error
            });
            showFlag({
                id: $8191934e9d349a9a$export$f5e4c120ac01b615,
                type: 'error',
                title: formatMessage((0, $iQZzw.default).errorFlagTitle),
                description: formatMessage((0, $iQZzw.default).errorFlagDescription),
                isAutoDismiss: true
            });
            return {
                userId: null,
                isInviteSuccessful: false
            };
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        formatMessage,
        getRecaptchaToken,
        showFlag
    ]);
};

});
parcelRegister("ekQgg", function(module, exports) {

$parcel$export(module.exports, "INVITED_STATUS", () => $ac29f366ea155ef3$export$2bfda8e94627965c);
$parcel$export(module.exports, "USER_EXISTS_STATUS", () => $ac29f366ea155ef3$export$4d0bb6166dd6896a);
$parcel$export(module.exports, "SUCCESSFUL_INVITE_STATUSES", () => $ac29f366ea155ef3$export$f09962c5ceace608);
$parcel$export(module.exports, "INVITE_USERS_ENDPOINT", () => $ac29f366ea155ef3$export$ff111916f5a23b5a);
$parcel$export(module.exports, "RECAPTCHA_SITE_KEY_PROD", () => $ac29f366ea155ef3$export$2c2f58a9d84da733);
$parcel$export(module.exports, "RECAPTCHA_SITE_KEY_STAGING", () => $ac29f366ea155ef3$export$cd719d3567d9b31d);
$parcel$export(module.exports, "RECAPTCHA_SITE_KEY_DEV", () => $ac29f366ea155ef3$export$34c3413ecdf1b634);
const $ac29f366ea155ef3$export$2bfda8e94627965c = 'INVITED';
const $ac29f366ea155ef3$export$4d0bb6166dd6896a = 'USER_EXISTS';
const $ac29f366ea155ef3$export$f09962c5ceace608 = [
    $ac29f366ea155ef3$export$2bfda8e94627965c,
    $ac29f366ea155ef3$export$4d0bb6166dd6896a
];
const $ac29f366ea155ef3$export$ff111916f5a23b5a = '/gateway/api/invitations/invite';
const $ac29f366ea155ef3$export$2c2f58a9d84da733 = '6LfOcIYhAAAAADBS5OnBllme06dW9vyW4Zgowiru';
const $ac29f366ea155ef3$export$cd719d3567d9b31d = '6LebaYYhAAAAAKFQt-KH6vVkTJQqwZddT-HJCIM3';
const $ac29f366ea155ef3$export$34c3413ecdf1b634 = '6Le_DxYiAAAAABV8BsFSj3AmZf3OkP9Fh9lfbZOZ';

});

parcelRegister("iQZzw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d447d5f41e0bd47b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ $d447d5f41e0bd47b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitle: {
        "id": "issue.view.invite-user-service.error.flag.title",
        "defaultMessage": "We couldn\u2019t send your invite"
    },
    errorFlagDescription: {
        "id": "issue.view.invite-user-service.error.flag.description",
        "defaultMessage": "Try sending the invite again. If this problem persists, contact your site administrator."
    }
});

});

parcelRegister("6aWgX", function(module, exports) {

$parcel$export(module.exports, "getJiraSoftwareAri", () => $b9b72363f52f26bf$export$4aa75fccdcc4833c);
$parcel$export(module.exports, "transformInviteResult", () => $b9b72363f52f26bf$export$55dd38940258be89);
$parcel$export(module.exports, "getRecaptchaSiteKey", () => $b9b72363f52f26bf$export$f6c02f8ff560b96f);

var $huI7r = parcelRequire("huI7r");


var $ekQgg = parcelRequire("ekQgg");
const $b9b72363f52f26bf$export$4aa75fccdcc4833c = (cloudId)=>(0, $huI7r.createAri)({
        resourceOwner: (0, $2edfd53057852e41$export$1346c9aa3cbb477d),
        cloudId: '',
        resourceType: 'site',
        resourceId: cloudId
    });
const $b9b72363f52f26bf$export$55dd38940258be89 = ({ userId: userId, result: result, errorReason: errorReason })=>{
    if (errorReason && errorReason.message) throw new Error(errorReason.message);
    if ((0, $ekQgg.SUCCESSFUL_INVITE_STATUSES).includes(result) === false) throw new Error(`Unsuccessful invite. Response returned result of ${result}`);
    return {
        userId: userId,
        isInviteSuccessful: true
    };
};
const $b9b72363f52f26bf$export$f6c02f8ff560b96f = (environment)=>{
    switch(environment){
        case 'prod':
            return 0, $ekQgg.RECAPTCHA_SITE_KEY_PROD;
        case 'staging':
            return 0, $ekQgg.RECAPTCHA_SITE_KEY_STAGING;
        default:
            return 0, $ekQgg.RECAPTCHA_SITE_KEY_DEV;
    }
};

});


parcelRegister("9ZAfP", function(module, exports) {

$parcel$export(module.exports, "assignIssue", () => $21c6c5730383c978$export$d437b4102a8c134d);
$parcel$export(module.exports, "currentAssignee", () => $21c6c5730383c978$export$dbe9ebd8504b66fa);

var $axhXb = parcelRequire("axhXb");

var $lRmyA = parcelRequire("lRmyA");
const $21c6c5730383c978$export$99d9fafa19da9509 = (baseUrl, issueKey, sessionId)=>sessionId ? `${baseUrl}/rest/api/3/issue/${issueKey}/assignee?sessionId=${sessionId}` : `${baseUrl}/rest/api/3/issue/${issueKey}/assignee`;
const $21c6c5730383c978$export$d437b4102a8c134d = (baseUrl, issueKey, accountId, sessionId)=>(0, $lRmyA.performPutRequest)($21c6c5730383c978$export$99d9fafa19da9509(baseUrl, issueKey, sessionId), {
        ...(0, $axhXb.default),
        body: JSON.stringify({
            accountId: accountId
        })
    });
const $21c6c5730383c978$export$7ff716f0bdf4c335 = (baseUrl, issueKey, sessionId)=>sessionId ? `${baseUrl}/rest/api/3/issue/${issueKey}?fields=assignee&sessionId=${sessionId}` : `${baseUrl}/rest/api/3/issue/${issueKey}?fields=assignee`;
const $21c6c5730383c978$export$dbe9ebd8504b66fa = (baseUrl, issueKey, sessionId)=>(0, $lRmyA.performGetRequest)($21c6c5730383c978$export$7ff716f0bdf4c335(baseUrl, issueKey, sessionId), {
        ...(0, $axhXb.default)
    });

});

parcelRegister("cf5zb", function(module, exports) {

$parcel$export(module.exports, "useGetUserEmailDomain", () => $6ea5684a8b4d1cc9$export$fc1ad07c9bb2e1fe);

var $eUqFw = parcelRequire("eUqFw");

var $1R3n5 = parcelRequire("1R3n5");

var $cBgV4 = parcelRequire("cBgV4");
const $6ea5684a8b4d1cc9$export$fc1ad07c9bb2e1fe = ({ isSoftwareProjectType: isSoftwareProjectType, isFreeEdition: isFreeEdition, userInEnglishLocale: userInEnglishLocale })=>{
    const [{ loggedInEmailDomain: loggedInEmailDomain }, { fetchUserEmailDomain: fetchUserEmailDomain }] = (0, $cBgV4.useUserEmailDomain)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    (0, $eUqFw.useEffect)(()=>{
        if (userInEnglishLocale && isSiteAdmin && isSoftwareProjectType && isFreeEdition && !loggedInEmailDomain) fetchUserEmailDomain();
    }, [
        fetchUserEmailDomain,
        loggedInEmailDomain,
        isSiteAdmin,
        isSoftwareProjectType,
        isFreeEdition,
        userInEnglishLocale
    ]);
    return loggedInEmailDomain;
};

});
parcelRegister("cBgV4", function(module, exports) {

$parcel$export(module.exports, "useUserEmailDomain", () => $71e116b833690447$export$f95c1c6f997ec47f);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $lqgSE = parcelRequire("lqgSE");
const $71e116b833690447$var$initialState = {
    loggedInEmailDomain: null,
    loading: false
};
const $71e116b833690447$export$e324594224ef24da = {
    fetchUserEmailDomain: ()=>async ({ setState: setState, getState: getState })=>{
            const { loading: loading } = getState();
            if (loading) return;
            setState({
                loading: true
            });
            const accountInfo = await (0, $lqgSE.getAtlassianAccount)();
            if (accountInfo) {
                const [, loggedInEmailDomain] = accountInfo.email?.split('@') ?? [];
                setState({
                    loggedInEmailDomain: loggedInEmailDomain
                });
            }
            setState({
                loading: false
            });
        }
};
const $71e116b833690447$var$Store = (0, $a61MH.createStore)({
    initialState: $71e116b833690447$var$initialState,
    actions: $71e116b833690447$export$e324594224ef24da,
    name: 'user-email-domain'
});
const $71e116b833690447$export$f95c1c6f997ec47f = (0, $ggKAj.createHook)($71e116b833690447$var$Store);

});
parcelRegister("lqgSE", function(module, exports) {

$parcel$export(module.exports, "getAtlassianAccount", () => $d471445d59ddc940$export$318c25600a19e2ee);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

const $d471445d59ddc940$export$318c25600a19e2ee = async ()=>{
    try {
        const response = await (0, $lRmyA.performGetRequestWithRetry)((0, $697414ac2e7ad595$export$80945eb3738bcee8));
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'getAtlassianAccount',
                packageName: 'jiraIssueViewServices',
                // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                teamName: 'jlove-makkuro'
            },
            error: error
        });
        return null;
    }
};

});
const $697414ac2e7ad595$export$80945eb3738bcee8 = '/gateway/api/me';




parcelRegister("aaQTg", function(module, exports) {

$parcel$export(module.exports, "getFieldLoadedValueSubscriber", () => $b2eff139752031b3$export$9dc306bc05ecfe4a);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
const $b2eff139752031b3$var$initialState = {
    assignee: null,
    labels: null
};
const $b2eff139752031b3$var$setField = (fieldId, prefetchSessionId, prefetched, sessionId, fieldValuePromise)=>({ setState: setState })=>{
        setState({
            [fieldId]: {
                prefetchSessionId: prefetchSessionId,
                prefetched: prefetched,
                fieldValuePromise: fieldValuePromise,
                sessionId: sessionId
            }
        });
    };
const $b2eff139752031b3$var$actions = {
    setField: $b2eff139752031b3$var$setField
};
const $b2eff139752031b3$var$createIssueStore = (issueKey)=>(0, $a61MH.createStore)({
        name: `smart-issue-prefetch-${issueKey}`,
        initialState: $b2eff139752031b3$var$initialState,
        actions: $b2eff139752031b3$var$actions
    });
const $b2eff139752031b3$var$issueStores = {};
const $b2eff139752031b3$var$getStore = (issueKey)=>{
    if (!$b2eff139752031b3$var$issueStores[issueKey]) $b2eff139752031b3$var$issueStores[issueKey] = $b2eff139752031b3$var$createIssueStore(issueKey);
    return $b2eff139752031b3$var$issueStores[issueKey];
};
const $b2eff139752031b3$var$subscribers = {};
const $b2eff139752031b3$var$getFieldValue = (state, // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS7031 - Binding element 'fieldId' implicitly has an 'any' type.
{ fieldId: fieldId } = {})=>state[fieldId];
const $b2eff139752031b3$var$hooks = {};
const $b2eff139752031b3$export$6bd57d24a911c98b = (issueKey)=>{
    if (!$b2eff139752031b3$var$hooks[issueKey]) // @ts-expect-error - TS2322 - Type 'HookFunction<State, BoundActions<State, { readonly setField: (fieldId: string, prefetchSessionId: string, prefetched: boolean, sessionId: string | null, fieldValuePromise: Promise<FieldShape> | null) => ({ setState }: StoreApi) => void; }>, void>' is not assignable to type '() => HookReturnValue<State, { readonly setField: (fieldId: string, prefetchSessionId: string, prefetched: boolean, sessionId: string | null, fieldValuePromise: Promise<FieldShape> | null) => ({ setState }: StoreApi) => void; }>'.
    $b2eff139752031b3$var$hooks[issueKey] = (0, $ggKAj.createHook)($b2eff139752031b3$var$getStore(issueKey));
    return $b2eff139752031b3$var$hooks[issueKey];
};
const $b2eff139752031b3$export$aeaaf7d2759326c0 = (issueKey, fieldId)=>{
    const [fields] = $b2eff139752031b3$export$6bd57d24a911c98b(issueKey)();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'State'.
    return fields[fieldId];
};
const $b2eff139752031b3$export$9dc306bc05ecfe4a = (issueKey, fieldId)=>{
    if ($b2eff139752031b3$var$subscribers[issueKey] !== undefined && $b2eff139752031b3$var$subscribers[issueKey] !== null) {
        if (// @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ labels: FieldSubscriber<LabelsResponsePayload>; assignee: FieldSubscriber<AssigneePayload[]>; }'.
        $b2eff139752031b3$var$subscribers[issueKey][fieldId] !== undefined && // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ labels: FieldSubscriber<LabelsResponsePayload>; assignee: FieldSubscriber<AssigneePayload[]>; }'.
        $b2eff139752031b3$var$subscribers[issueKey][fieldId] !== null) // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ labels: FieldSubscriber<LabelsResponsePayload>; assignee: FieldSubscriber<AssigneePayload[]>; }'.
        return $b2eff139752031b3$var$subscribers[issueKey][fieldId];
    } else $b2eff139752031b3$var$subscribers[issueKey] = {
        // @ts-expect-error(PARTIAL_RECORD) TS2783 | TS2783 - 'labels' is specified more than once, so this usage will be overwritten. | 'labels' is specified more than once, so this usage will be overwritten.
        labels: null,
        // @ts-expect-error(PARTIAL_RECORD) TS2783 | TS2783 - 'assignee' is specified more than once, so this usage will be overwritten. | 'assignee' is specified more than once, so this usage will be overwritten.
        assignee: null,
        ...$b2eff139752031b3$var$subscribers[issueKey]
    };
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ labels: FieldSubscriber<LabelsResponsePayload>; assignee: FieldSubscriber<AssigneePayload[]>; }'.
    $b2eff139752031b3$var$subscribers[issueKey][fieldId] = (0, $dYfll.createSubscriber)($b2eff139752031b3$var$getStore(issueKey), {
        selector: $b2eff139752031b3$var$getFieldValue
    });
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ labels: FieldSubscriber<LabelsResponsePayload>; assignee: FieldSubscriber<AssigneePayload[]>; }'.
    return $b2eff139752031b3$var$subscribers[issueKey][fieldId];
};

});

parcelRegister("gczGB", function(module, exports) {

$parcel$export(module.exports, "AssigneeInvitedFlag", () => $0a46f30dbd766cfd$export$a390cb5ab934b7);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $ccE3R = parcelRequire("ccE3R");

var $kQ0RL = parcelRequire("kQ0RL");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $kwJ9a = parcelRequire("kwJ9a");
const $0a46f30dbd766cfd$export$a390cb5ab934b7 = ({ email: email, onCancel: onCancel, onDismissed: onDismissed, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.SuccessAutoDismissFlag), {
        title: formatMessage((0, $kwJ9a.messages).title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $kwJ9a.messages).description,
            values: {
                email: email,
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_11c81vlj _19pku2gc"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ccE3R.default), null))),
        onDismissed: onDismissed,
        actions: [
            {
                content: formatMessage((0, $kwJ9a.messages).actionCancel),
                onClick: onCancel
            }
        ],
        ...props
    });
};
const $0a46f30dbd766cfd$var$styles = null;

});
parcelRegister("kwJ9a", function(module, exports) {

$parcel$export(module.exports, "messages", () => $91b70a054f7d175d$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $91b70a054f7d175d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue.assignee.assignee-invited-flag.title",
        "defaultMessage": "Success!"
    },
    description: {
        "id": "issue.assignee.assignee-invited-flag.assignee-invited-description",
        "defaultMessage": "We emailed <strong>{email}</strong> inviting them to join Jira. They will be assigned to the issue shortly."
    },
    actionCancel: {
        "id": "issue.assignee.assignee-invited-flag.action-cancel",
        "defaultMessage": "Cancel invite"
    }
});

});


parcelRegister("jf5VS", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $0b50f6ccec389a45$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $0b50f6ccec389a45$export$1cfcb95cb8fbddb3);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0b50f6ccec389a45$var$toItem = (assignee)=>({
        avatarUrl: assignee.avatarUrls && assignee.avatarUrls['48x48'],
        id: assignee.accountId,
        name: assignee.displayName,
        byline: assignee.emailAddress,
        active: assignee.active
    });
const $0b50f6ccec389a45$export$cb172b2468ab5652 = (value)=>value ? $0b50f6ccec389a45$var$toItem(value) : null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0b50f6ccec389a45$var$toState = (value)=>({
        avatarUrls: {
            '48x48': value.avatarUrl
        },
        displayName: value.name,
        accountId: value.id
    });
const $0b50f6ccec389a45$export$1cfcb95cb8fbddb3 = (value)=>value ? $0b50f6ccec389a45$var$toState(value) : null;

});

parcelRegister("cWTCI", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteAssigneeList", () => $89fe21a38e86b864$export$554dd3e0257beb94);

var $eUqFw = parcelRequire("eUqFw");

var $dlEQk = parcelRequire("dlEQk");

var $6jiFZ = parcelRequire("6jiFZ");

var $46gH8 = parcelRequire("46gH8");
var $36mrL = parcelRequire("36mrL");
var $gfXKy = parcelRequire("gfXKy");

var $bT6OI = parcelRequire("bT6OI");

var $fmmnJ = parcelRequire("fmmnJ");
var $dK5FP = parcelRequire("dK5FP");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");

var $8UUJO = parcelRequire("8UUJO");

var $fsHql = parcelRequire("fsHql");
const $89fe21a38e86b864$export$554dd3e0257beb94 = (props)=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const [{ canAssignIssues: canAssignIssues }] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const subscribeCP = (0, $dK5FP.useSubscribeCommands)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!canAssignIssues) return ()=>{};
        const sectionId = (0, $46gH8.getCommandPaletteIssueActionsHeader)(issueKey);
        const commands = [
            {
                id: 'issue.issue-view.issue-base.assignee',
                priority: (0, $36mrL.getCommandPaletteIssueActionsPriority)('OLD_ISSUE_FIELDS'),
                name: formatMessage((0, $fsHql.messages).assignIssue),
                keywords: getKeywords('assignIssueSynonyms'),
                placeholder: formatMessage((0, $fsHql.messages).searchPeople),
                shortcut: 'a',
                section: sectionId,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dlEQk))), {
                            label: formatMessage((0, $fsHql.messages).assignIssue)
                        })
                },
                primaryAction: {
                    type: (0, $6jiFZ.CommandActionType).COMMAND_LIST,
                    components: {
                        Body: (base)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8UUJO.AssigneeListBody), {
                                ...base,
                                ...props
                            }),
                        ...(0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r') && {
                            Header: (base)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT6OI.CommandFieldHeader), {
                                    ...base,
                                    issueKey: issueKey
                                })
                        }
                    },
                    fallback: {
                        onNoResults: {
                            label: formatMessage((0, $fsHql.messages).fallbackNoResults)
                        },
                        onError: {
                            label: formatMessage((0, $fsHql.messages).fallbackOnError)
                        }
                    }
                },
                analytics: {
                    action: 'updateAssigneeMenu'
                }
            }
        ];
        const unsubscribe = subscribeCP((0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).ISSUE_FIELD_ASSIGN, commands);
        return ()=>{
            unsubscribe();
        };
    }, [
        subscribeCP,
        formatMessage,
        issueKey,
        canAssignIssues,
        getKeywords,
        props
    ]);
    return null;
};

});
parcelRegister("bT6OI", function(module, exports) {

$parcel$export(module.exports, "CommandFieldHeader", () => $f484a350daa785aa$export$c6444eb1c6f44b2d);

var $eUqFw = parcelRequire("eUqFw");

var $1zbEq = parcelRequire("1zbEq");

var $LddR2 = parcelRequire("LddR2");

var $70Z2O = parcelRequire("70Z2O");
const $f484a350daa785aa$export$c6444eb1c6f44b2d = ({ children: children, issueKey: issueKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LddR2.components).Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $70Z2O.IssueTag), {
        issueKey: issueKey
    }), children));

});
parcelRegister("LddR2", function(module, exports) {

$parcel$export(module.exports, "components", () => $de43b6bd284ffa0f$export$9b5ac10f59f76296);

var $eUqFw = parcelRequire("eUqFw");

var $73ZV3 = parcelRequire("73ZV3");

var $gwWoQ = parcelRequire("gwWoQ");

var $b4qUd = parcelRequire("b4qUd");

var $48xUp = parcelRequire("48xUp");
const $de43b6bd284ffa0f$export$9b5ac10f59f76296 = {
    CommandRow: $gwWoQ.CommandRow,
    Name: (0, $eUqFw.Fragment),
    LeftIcon: (0, $eUqFw.Fragment),
    Wrapper: (0, $eUqFw.Fragment),
    Footer: $b4qUd.Footer,
    Body: (0, $73ZV3.CommandPaletteBody),
    Header: $48xUp.Header
};

});
parcelRegister("73ZV3", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteBody", () => $d0ddd4262a5c5e52$export$b1023de69a8756e6);
$parcel$export(module.exports, "NoResultsContainer", () => $d0ddd4262a5c5e52$export$2ab569a6937cb4e4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $bFzGY = parcelRequire("bFzGY");

var $bKxX9 = parcelRequire("bKxX9");

var $gCtL7 = parcelRequire("gCtL7");

var $8FbYY = parcelRequire("8FbYY");

var $5IPbY = parcelRequire("5IPbY");

var $80x7h = parcelRequire("80x7h");

var $f9a4v = parcelRequire("f9a4v");

var $1c3Ul = parcelRequire("1c3Ul");

var $985MX = parcelRequire("985MX");

var $dDiRc = parcelRequire("dDiRc");

var $4PPUt = parcelRequire("4PPUt");
const $d0ddd4262a5c5e52$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands, onAnalytics: onAnalyticsOld })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, expandedCommand: expandedCommand, search: search, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, executeCommand: executeCommand, removeCommandsById: removeCommandsById }] = (0, $gCtL7.useCommandPalette)();
    const [prevActiveIndex, setPrevActiveIndex] = (0, $eUqFw.useState)(activeIndex);
    const onHoverCommand = (index)=>{
        if (index === undefined) return;
        setActiveIndex(index);
    };
    const onClickCommand = (0, $eUqFw.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'mouse',
            createAnalyticsEvent: createAnalyticsEvent,
            onAnalyticsOld: onAnalyticsOld,
            attributes: {
                ...(0, $8FbYY.getAnalyticsAttributesFromResult)(result),
                ...(0, $8FbYY.getRegistryData)(registry, activeRegistry, result?.command.id)
            }
        }, (0, $8FbYY.isSecondaryTrigger)(event));
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        onAnalyticsOld,
        registry
    ]);
    const onMouseDownCommand = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const resultsRefs = (0, $eUqFw.useRef)([]);
    const modalBodyRef = (0, $eUqFw.useRef)(null);
    const onArrowScroll = (0, $eUqFw.useCallback)((newActiveIndex)=>{
        setActiveIndex(newActiveIndex);
    }, [
        setActiveIndex
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
        setPrevActiveIndex(activeIndex);
        const scrollTo = activeIndex > prevActiveIndex ? (0, $dDiRc.SCROLL_DIRECTION).END : (0, $dDiRc.SCROLL_DIRECTION).START;
        const scrollToIndex = (0, $4PPUt.getScrollToIndex)(results, activeIndex, scrollTo);
        const scrolledToResult = resultsRefs.current[scrollToIndex];
        if (scrolledToResult && !(0, $4PPUt.isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
            const lastIndex = results.length - 1;
            const firstIndex = results.findIndex((result)=>!result.isGroup);
            if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
            else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
            else (0, $4PPUt.scrollResultIntoView)(scrolledToResult, scrollTo);
        }
    }, [
        activeIndex,
        prevActiveIndex,
        results
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!modalBodyRef.current?.scrollTo) return;
        modalBodyRef.current.scrollTo(0, 0);
    }, [
        expandedCommand,
        search
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isSearchFieldFocused) return ()=>{};
        const handleArrowScroll = (ev)=>{
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                activeIndex > 0 && onArrowScroll(activeIndex - 1);
            }
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
            }
        };
        window.addEventListener('keydown', handleArrowScroll);
        return ()=>{
            window.removeEventListener('keydown', handleArrowScroll);
        };
    }, [
        isSearchFieldFocused,
        total,
        activeIndex,
        setActiveIndex,
        onArrowScroll
    ]);
    const noResultsFallback = (0, $eUqFw.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
        fallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9a4v.CommandPaletteSearchResultListWrapper), {
        ref: modalBodyRef
    }, !loadingList && noResultsFallback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0ddd4262a5c5e52$export$2ab569a6937cb4e4, {
        "data-testid": (0, $dDiRc.NO_RESULTS_TEST_ID)
    }, noResultsFallback), results.map((result, index)=>{
        if (result.isGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5IPbY.CommandPaletteSearchResultGroupItem), {
            ref: (commandRef)=>{
                if (commandRef) resultsRefs.current[index] = commandRef;
            },
            group: result.group,
            key: index
        }, (0, $bKxX9.ff)('compal-issue-actions-very-high-priority_f5w5r') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0ddd4262a5c5e52$var$GroupContainer, {
            "data-testid": (0, $dDiRc.GROUP_TEST_ID),
            isFirstResult: index === 0
        }, result.renderGroup ? result.renderGroup() : result.group) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0ddd4262a5c5e52$var$GroupContainerOld, {
            "data-testid": (0, $dDiRc.GROUP_TEST_ID),
            isFirstResult: index === 0
        }, result.renderGroup ? result.renderGroup() : result.group));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $985MX.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $8FbYY.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80x7h.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) resultsRefs.current[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1c3Ul.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        })));
    }), (0, $bKxX9.ff)('compal-issue-actions') ? renderAfterCommands?.({}) : !loadingList && renderAfterCommands && renderAfterCommands({}));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d0ddd4262a5c5e52$var$GroupContainerOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $9t7rW.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1skh _k48p1nn1 _syaz1wmz _1p1dangw _1yt41f6d",
            __cmplp.className
        ])
    });
});
const $d0ddd4262a5c5e52$var$GroupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $9t7rW.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1skh _k48p1nn1 _syaz1wmz _1yt41f6d",
            __cmplp.className
        ])
    });
});
const $d0ddd4262a5c5e52$export$2ab569a6937cb4e4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _syaz1e9r _1yt4wd81",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5IPbY", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", () => $43e423a37776a525$export$591c26128e5fd757);

var $eUqFw = parcelRequire("eUqFw");

const $43e423a37776a525$export$591c26128e5fd757 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ group: group, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        "data-testid": (0, $d08d4eae9e022dcf$export$617744f059bfc3ba),
        id: group ? `${0, $d08d4eae9e022dcf$export$f24a36b1556217a1}-${group}` : undefined,
        ...rest
    }));

});
const $d08d4eae9e022dcf$export$5758a25d98c7bb27 = 'compal-listbox';
const $d08d4eae9e022dcf$export$f61172db5aff4b22 = `${$d08d4eae9e022dcf$export$5758a25d98c7bb27}-item`;
const $d08d4eae9e022dcf$export$f24a36b1556217a1 = `${$d08d4eae9e022dcf$export$5758a25d98c7bb27}-group`;
const $d08d4eae9e022dcf$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $d08d4eae9e022dcf$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $d08d4eae9e022dcf$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $d08d4eae9e022dcf$export$65eac2e53f304ab6 = 'compal-listbox-screen-reader';


parcelRegister("80x7h", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListItem", () => $55b21d7cef5b1dbb$export$1f8fa9d1eef77b32);

var $eUqFw = parcelRequire("eUqFw");

const $55b21d7cef5b1dbb$export$1f8fa9d1eef77b32 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ id: id, active: active, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        "data-testid": (0, $d08d4eae9e022dcf$export$617744f059bfc3ba),
        role: "option",
        id: `${(0, $d08d4eae9e022dcf$export$f61172db5aff4b22)}-${id}`,
        "aria-selected": active,
        ...rest
    }));

});

parcelRegister("f9a4v", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", () => $d3691614f8dde395$export$95554f6fb39a83c2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");


var $ezG3R = parcelRequire("ezG3R");
const $d3691614f8dde395$export$95554f6fb39a83c2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3691614f8dde395$var$Wrapper, {
        "data-testid": (0, $d08d4eae9e022dcf$export$85eefac753ab5bdb),
        role: "listbox",
        id: (0, $d08d4eae9e022dcf$export$5758a25d98c7bb27),
        ref: ref,
        "aria-label": (0, $1ybV0.ff)('compal-issue-actions-follow-up-improvements_y49xu') ? formatMessage((0, $ezG3R.messages).commandPaletteSearchResultListBoxLabel) : undefined,
        ...props
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d3691614f8dde395$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71l4u42 _18m91wug _vchhusvi _1yt41bpf _1e0c1txw _2lx21bp4 _zulp1b66 _1tke8vuz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ezG3R", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dae431d5b55d597f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $dae431d5b55d597f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    commandPaletteSearchResultListBoxLabel: {
        "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
        "defaultMessage": "List of commands"
    }
});

});


parcelRegister("1c3Ul", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $673add314e0db490$export$3ef5d254c3c573e3);

var $eUqFw = parcelRequire("eUqFw");

var $8FbYY = parcelRequire("8FbYY");

var $gwWoQ = parcelRequire("gwWoQ");
const $673add314e0db490$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
    const { command: command } = result;
    const isActive = !!(result.active && isSearchFieldFocused);
    const isFirstCommand = result.index === 0;
    const rowProps = {
        index: index,
        isActive: isActive,
        command: command,
        isFirstCommand: isFirstCommand,
        onMouseMove: onHoverCommand,
        onClick: onClickCommand,
        onMouseDown: onMouseDownCommand,
        analyticsAttributes: (0, $8FbYY.getAnalyticsAttributesFromResult)(result)
    };
    if (command.components?.CommandRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.CommandRow, rowProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwWoQ.CommandRow), rowProps);
};

});
parcelRegister("gwWoQ", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $6e9750c220ca1b53$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5t8Df = parcelRequire("5t8Df");


var $8LHLg = parcelRequire("8LHLg");

var $7cPAX = parcelRequire("7cPAX");
const $6e9750c220ca1b53$export$3ef5d254c3c573e3 = ({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, analyticsAttributes: analyticsAttributes, ...rest })=>{
    const InnerContainer = $6e9750c220ca1b53$var$CommandContainerInner;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandContainerWrapper, {
        "data-testid": command.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandContainer, {
        index: index,
        active: isActive,
        "data-active": isActive,
        "data-testid": (0, $d665202372e0655f$export$b0017db5728101cc)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InnerContainer, {
        "data-testid": (0, $d665202372e0655f$export$47c379a40b00a339),
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandLeftIconAndNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandIconsContainer, {
        "data-testid": (0, $d665202372e0655f$export$d6dd1cf63aae711c)
    }, command.components?.LeftIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandLeftIconContainer, {
        "data-testid": (0, $d665202372e0655f$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.LeftIcon, null)), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5t8Df.OutlinedLozenge), {
        "data-testid": (0, $d665202372e0655f$export$72c5368f559dd523)
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8LHLg.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cPAX.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e9750c220ca1b53$var$CommandContainerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _k48p1nn1 _syazjjyb _1yt4swc3",
            !!__cmplp.active && "_syazaj1x _bfhk29zg _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus194a",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandContainerInner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt467l7 _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandIconsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1b66 _zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandLeftIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
            __cmplp.active ? "_syaz2zfp" : "_syazbkuv",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandLeftIconAndNameContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _16jlkb7n _1o9zkb7n _i0dlf1ug _vwz41tcg _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5t8Df", function(module, exports) {

$parcel$export(module.exports, "OutlinedLozenge", () => $cfdd8a3faf592ae6$export$224f9ad7f31e0de6);
$parcel$export(module.exports, "FilledLozenge", () => $cfdd8a3faf592ae6$export$586a428fe10f5ae0);
$parcel$export(module.exports, "SearchLozenge", () => $cfdd8a3faf592ae6$export$2ccc7861eeb7b337);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/@atlaskit+theme -- Avoid using jira specific components to make this component easier to export to atlaskit later - https://hello.atlassian.net/browse/DEE-1558

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfdd8a3faf592ae6$var$Lozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _2rko1l7b _1o9zidpf _4t3igktf _1bsbgktf _1wyb1crf _vwz41crf _syaz1aqp",
            __cmplp.className
        ])
    });
});
const $cfdd8a3faf592ae6$export$224f9ad7f31e0de6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $cfdd8a3faf592ae6$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ect485st _1p1dangw _bfhk1j9a _19it1x8r _syazuxqy _k48pni7l _vchhusvi",
            __cmplp.className
        ])
    });
});
const $cfdd8a3faf592ae6$export$586a428fe10f5ae0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $cfdd8a3faf592ae6$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _ect485st _1p1dangw _1pbykb7n _1cs8stnw _1kt9b3bt _1s6k1d2d _154psxj9 _rfx31l7b _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
            __cmplp.className
        ])
    });
});
const $cfdd8a3faf592ae6$export$2ccc7861eeb7b337 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $cfdd8a3faf592ae6$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4otz2 _1bsb1ris _1wybdlk8 _vwz4dlk8 _bfhk1yrq",
            __cmplp.className
        ])
    });
});

});

const $d665202372e0655f$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $d665202372e0655f$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $d665202372e0655f$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $d665202372e0655f$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $d665202372e0655f$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';

parcelRegister("8LHLg", function(module, exports) {

$parcel$export(module.exports, "RenderCommandName", () => $6ee7061fe3a2c77e$export$931d3f1d35f6c058);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $dtaN9 = parcelRequire("dtaN9");

var $PdmhA = parcelRequire("PdmhA");

var $jCRsd = parcelRequire("jCRsd");

const $6ee7061fe3a2c77e$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
    const renderCommandName = (0, $eUqFw.useCallback)(()=>{
        if (command.components?.Name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.Name, {
            isActive: isActive
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jCRsd.TruncateWithTooltipOnActive), {
            isActive: isActive
        }, command.name);
    }, [
        command,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandNameContainer, {
        "data-testid": (0, $1095276f0211050b$export$1858c2a91b8b53ba),
        active: isActive
    }, command.breadcrumb?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandBreadcrumbContainer, {
        "data-testid": (0, $1095276f0211050b$export$5e3a644e2bbe06f3)
    }, command.breadcrumb.map((BreadCrumb, index, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandBreadcrumbItem, {
            isParent: index !== arr.length - 1,
            "data-testid": (0, $1095276f0211050b$export$fb5462105b23e3e5),
            active: isActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BreadCrumb, {
            isActive: isActive
        })), index !== arr.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandChevronContainer, {
            "data-testid": (0, $1095276f0211050b$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            label: "separator"
        }))))) : renderCommandName());
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ee7061fe3a2c77e$var$CommandNameContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _vwz41tcg",
            __cmplp.active ? "_syaz1qfn" : "_syaz1a45",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandBreadcrumbContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandBreadcrumbItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_zek046": (0, $9t7rW.default)(__cmplp.active ? `var(--ds-text-subtle, ${(0, $PdmhA).N400})` : `var(--ds-text-subtlest, ${(0, $PdmhA).N200})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !!__cmplp.isParent && "_syaz1bu1",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandChevronContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4kb7n _syazjwct",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jCRsd", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnActive", () => $57c74f3e056e4b78$export$4495aca3d261add0);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lcnyw = parcelRequire("lcnyw");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $lXgc2 = parcelRequire("lXgc2");


var $lDcdk = parcelRequire("lDcdk");
const $57c74f3e056e4b78$var$TooltipRenderer = ({ children: children, containerRef: containerRef, shouldShowTooltip: shouldShowTooltip })=>{
    let shouldShowTruncatedTooltip = false;
    if (!(0, $1ybV0.ff)('compal-update-active-tooltip')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $lDcdk.useTruncatedTooltip)({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        containerRef: containerRef,
        tooltipDelay: (0, $79f2d7e0eace9088$export$f9e3e7ede9ba929d)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: (0, $1ybV0.ff)('compal-update-active-tooltip') ? !!shouldShowTooltip : shouldShowTruncatedTooltip,
        autoFocus: false,
        placement: "bottom-end",
        popupComponent: (0, $lXgc2.PopupComponent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
            }, children),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TriggerComponent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                ...triggerProps
            }),
        zIndex: (0, $lcnyw.layers).tooltip()
    });
};
const $57c74f3e056e4b78$export$70f47de153e915ed = ()=>(0, $eUqFw.useRef)(null);
const $57c74f3e056e4b78$var$TruncateWithTooltipOnActiveOld = ({ children: children, isActive: isActive })=>{
    const containerRef = $57c74f3e056e4b78$export$70f47de153e915ed();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TruncateWithTooltipContainer), {
        ref: containerRef
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57c74f3e056e4b78$var$TooltipRenderer, {
        containerRef: containerRef
    }, children));
};
const $57c74f3e056e4b78$var$TruncateWithTooltipOnActiveNew = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
    const containerRef = $57c74f3e056e4b78$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $lDcdk.useTruncatedTooltip)({
        containerRef: containerRef,
        tooltipDelay: (0, $79f2d7e0eace9088$export$f9e3e7ede9ba929d)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ref: containerRef,
        xcss: [
            $57c74f3e056e4b78$var$tooltipContainerStyles,
            !preventTruncate && $57c74f3e056e4b78$var$truncateTooltipStyles
        ]
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57c74f3e056e4b78$var$TooltipRenderer, {
        shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
    }, showTooltip && customTooltip ? customTooltip : children));
};
const $57c74f3e056e4b78$export$4495aca3d261add0 = (0, $bAQOb.componentWithFF)('compal-update-active-tooltip', $57c74f3e056e4b78$var$TruncateWithTooltipOnActiveNew, $57c74f3e056e4b78$var$TruncateWithTooltipOnActiveOld);
const $57c74f3e056e4b78$var$tooltipContainerStyles = (0, $1ZAYh.xcss)({
    position: 'relative',
    flexGrow: 1,
    textTransform: 'none'
});
const $57c74f3e056e4b78$var$truncateTooltipStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("lXgc2", function(module, exports) {

$parcel$export(module.exports, "TooltipComponent", () => $50856cc63ccf025e$export$e18e2f8e82cdc428);
$parcel$export(module.exports, "TriggerComponent", () => $50856cc63ccf025e$export$534fc570264a52a4);
$parcel$export(module.exports, "TooltipTrigger", () => $50856cc63ccf025e$export$8c610744efcf8a1d);
$parcel$export(module.exports, "PopupComponent", () => $50856cc63ccf025e$export$9fac2d040f3ed438);
$parcel$export(module.exports, "TruncateWithTooltipContainer", () => $50856cc63ccf025e$export$8cae238d61c8405a);
$parcel$export(module.exports, "TooltipContent", () => $50856cc63ccf025e$export$e9003e2be37ec060);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $g3tFP = parcelRequire("g3tFP");
const $50856cc63ccf025e$export$e18e2f8e82cdc428 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$var$StyledTooltipPrimitive, {
        ...props,
        ref: ref
    }));
const $50856cc63ccf025e$export$534fc570264a52a4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$export$8c610744efcf8a1d, {
        ...props,
        ref: ref
    }));
const $50856cc63ccf025e$export$9fac2d040f3ed438 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$var$StyledPopupPrimitive, {
        ...props,
        ref: ref
    }, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $50856cc63ccf025e$var$StyledTooltipPrimitive = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $g3tFP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$var$StyledPopupPrimitive = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$export$8cae238d61c8405a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1p1dglyw",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1jfi _11c8qk37",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});

const $79f2d7e0eace9088$export$f9e3e7ede9ba929d = 400;

parcelRegister("lDcdk", function(module, exports) {

$parcel$export(module.exports, "useTruncatedTooltip", () => $8c918be484ad3aec$export$94b118b3187f12c);

var $eUqFw = parcelRequire("eUqFw");

var $8FbYY = parcelRequire("8FbYY");
const $8c918be484ad3aec$export$22c0312879c61300 = ()=>(0, $eUqFw.useState)(false);
const $8c918be484ad3aec$export$1ac6e474a0163418 = ()=>(0, $eUqFw.useState)(false);
const $8c918be484ad3aec$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
    const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $8c918be484ad3aec$export$22c0312879c61300();
    const [isTruncated, setIsTruncated] = $8c918be484ad3aec$export$1ac6e474a0163418();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $8FbYY.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    (0, $eUqFw.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
        else setIsTruncated(false);
    }, [
        setIsTruncated,
        containerRef
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isTruncated && tooltipDelay === 0) {
            setShouldShowTruncatedTooltip(true);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        if (isTruncated && tooltipDelay > 0) {
            setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        setShouldShowTruncatedTooltip(false);
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        isTruncated,
        setShouldShowTruncatedTooltip,
        tooltipDelay,
        setTimeoutFunc
    ]);
    return {
        shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
    };
};

});


const $1095276f0211050b$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $1095276f0211050b$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $1095276f0211050b$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $1095276f0211050b$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';


parcelRegister("7cPAX", function(module, exports) {

$parcel$export(module.exports, "RightContent", () => $b3a3550b1d4e6bec$export$11dbab4b39f15d6b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dwj4T = parcelRequire("dwj4T");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8FbYY = parcelRequire("8FbYY");


var $hBQBI = parcelRequire("hBQBI");

var $iMtOt = parcelRequire("iMtOt");

var $6gNFs = parcelRequire("6gNFs");

var $cAOzG = parcelRequire("cAOzG");
const $b3a3550b1d4e6bec$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const transitionStep = (0, $6gNFs.useHoverTransitionStep)(command, isActive, isFirstCommand);
    const commandHasChildren = (0, $eUqFw.useMemo)(()=>(0, $8FbYY.hasChildren)(command), [
        command
    ]);
    const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
    if (!shouldRenderRightContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$RightContentWrapper, null, commandHasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$CommandRightChevronContainer, {
        "data-testid": (0, $d5b555147cabbe39$export$e3e144c17be58a44),
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
        label: formatMessage((0, $hBQBI.messages).rightChevronLabel)
    })), !!command.shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$ShortcutContainer, {
        "data-testid": (0, $d5b555147cabbe39$export$f3036e9d26f81cd9),
        shouldHaveTransition: commandHasChildren,
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMtOt.Shortcuts), {
        shortcut: command.shortcut
    })));
};
const $b3a3550b1d4e6bec$var$animationFadeIn = null;
const $b3a3550b1d4e6bec$var$animationFadeOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$RightContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1a45",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$CommandRightChevronContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _vwz41tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syazbkuv",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$ShortcutContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
const $d5b555147cabbe39$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $d5b555147cabbe39$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';
const $d5b555147cabbe39$export$e792b5b2b6c9ee7 = 'command-palette.ui.modal.body.command-right-icon-container';

parcelRegister("hBQBI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2fa0ed9a30870185$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2fa0ed9a30870185$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rightChevronLabel: {
        "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
        "defaultMessage": "Command with children icon"
    }
});

});

parcelRegister("iMtOt", function(module, exports) {

$parcel$export(module.exports, "Shortcuts", () => $7fcd400f64ed3fa3$export$b326d77e4b8b7664);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ftpwV = parcelRequire("ftpwV");

var $8FbYY = parcelRequire("8FbYY");

var $5t8Df = parcelRequire("5t8Df");


var $ff5gx = parcelRequire("ff5gx");
const $7fcd400f64ed3fa3$var$KeyElement = ({ shortcut: shortcut })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$export$cde89099db64abe3, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5t8Df.FilledLozenge), {
        "data-testid": (0, $258bfb6c4afc66c3$export$cd62afa4691c297)
    }, shortcut));
const $7fcd400f64ed3fa3$var$DivisorElement = ({ divisor: divisor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$ShortcutDivider, {
        "data-testid": (0, $258bfb6c4afc66c3$export$e06ad7c09a29974b)
    }, divisor);
/**
 * Transform shortcut string into object
 */ const $7fcd400f64ed3fa3$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
    const replacer = replacers.shift();
    if (!replacer) {
        acc.push({
            type: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY,
            key: shortcut
        });
        types.push((0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY);
        return [
            acc,
            types
        ];
    }
    shortcut.split(replacer.char).forEach((str, index, self)=>{
        $7fcd400f64ed3fa3$var$parseShortcut(str, replacers.slice(0), acc, types);
        if (index < self.length - 1) {
            acc.push({
                type: replacer.replacement
            });
            types.push(replacer.replacement);
        }
    });
    return [
        acc,
        types
    ];
};
const $7fcd400f64ed3fa3$export$cfaeb054b183bb20 = ()=>(0, $5JgJ2.default)();
const $7fcd400f64ed3fa3$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
    const { formatMessage: formatMessage } = $7fcd400f64ed3fa3$export$cfaeb054b183bb20();
    const [shortcuts, types] = (0, $eUqFw.useMemo)(()=>$7fcd400f64ed3fa3$var$parseShortcut(shortcut, (0, $8FbYY.getShortcutSpecialCharacters)()), [
        shortcut
    ]);
    const basicShortcutMessage = (0, $eUqFw.useMemo)(()=>{
        if (types.length === 3) {
            if (types[0] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY) {
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN) return (0, $ff5gx.messages).shortcutThen;
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR) return (0, $ff5gx.messages).shortcutOr;
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).PLUS) return (0, $ff5gx.messages).shortcutPlus;
            }
        }
        return null;
    }, [
        types
    ]);
    const formatTypeToMessage = (0, $eUqFw.useCallback)((type)=>{
        switch(type){
            case (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN:
                return formatMessage((0, $ff5gx.messages).divisorThen);
            case (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR:
                return formatMessage((0, $ff5gx.messages).divisorOr);
            default:
                return formatMessage((0, $ff5gx.messages).divisorPlus);
        }
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$ShortcutContainer, {
        "data-testid": (0, $258bfb6c4afc66c3$export$ec8260df4f23714c),
        "aria-hidden": true
    }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
        shortcutA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            shortcut: shortcuts[0].key
        }),
        shortcutB: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            shortcut: shortcuts[2].key
        }),
        divisor: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$DivisorElement, {
                divisor: chunk
            })
    }) : shortcuts.map((obj, index)=>{
        if (obj.type === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            key: index,
            shortcut: obj.key
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$DivisorElement, {
            key: index,
            divisor: formatTypeToMessage(obj.type)
        });
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fcd400f64ed3fa3$var$ShortcutDivider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8otz2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fcd400f64ed3fa3$var$ShortcutContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7fcd400f64ed3fa3$export$cde89099db64abe3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
const $258bfb6c4afc66c3$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $258bfb6c4afc66c3$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $258bfb6c4afc66c3$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';

parcelRegister("ff5gx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9663167573e5dde6$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9663167573e5dde6$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shortcutThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
        "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
    },
    shortcutOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
        "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
    },
    shortcutPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
        "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
    },
    divisorThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
        "defaultMessage": "then"
    },
    divisorOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
        "defaultMessage": "or"
    },
    divisorPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
        "defaultMessage": "+"
    }
});

});


parcelRegister("6gNFs", function(module, exports) {

$parcel$export(module.exports, "useHoverTransitionStep", () => $a5599ff6bbc2ab8e$export$eefd045a02bab4c6);

var $eUqFw = parcelRequire("eUqFw");

var $8YJjX = parcelRequire("8YJjX");

var $guiFP = parcelRequire("guiFP");

var $8FbYY = parcelRequire("8FbYY");

var $cAOzG = parcelRequire("cAOzG");
const $a5599ff6bbc2ab8e$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
    const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $eUqFw.useState)(false);
    const [transitionStep, setTransitionStep] = (0, $eUqFw.useState)((0, $cAOzG.TRANSITION_STEP).INITIAL);
    const timerRef = (0, $eUqFw.useRef)(null);
    const isReducedMotion = (0, $8YJjX.useIsReducedMotion)();
    const commandHasChildren = (0, $8FbYY.hasChildren)(command);
    (0, $eUqFw.useEffect)(()=>{
        setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
        if (timerRef.current) clearTimeout(timerRef.current);
    }, [
        command
    ]);
    const startTimerForNextStep = (nextStep, durationMs)=>{
        timerRef.current = setTimeout(()=>{
            setTransitionStep(nextStep);
            timerRef.current = null;
        }, durationMs);
    };
    const handleReducedMotionTransition = (0, $eUqFw.useCallback)(()=>{
        if (isActive) setTransitionStep((0, $cAOzG.TRANSITION_STEP).FINISHED);
        else setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
    }, [
        isActive
    ]);
    const handleWithMotionTransition = (0, $eUqFw.useCallback)(()=>{
        switch(transitionStep){
            case (0, $cAOzG.TRANSITION_STEP).INITIAL:
                if (isActive) {
                    setTransitionStep((0, $cAOzG.TRANSITION_STEP).DELAYING);
                    startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, $cAOzG.TRANSITION_INITIAL_DELAY_TIME_MS) : (0, $cAOzG.TRANSITION_HOVER_DELAY_TIME_MS));
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).DELAYING:
                if (!isActive) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = null;
                    setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).TRANSITIONING:
                if (isActive) {
                    if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                    if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).FINISHED, (0, $cAOzG.TRANSITION_DURATION_MS));
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).FINISHED:
                if (!isActive) setTransitionStep((0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT);
                break;
            case (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, $cAOzG.TRANSITION_HOVER_DELAY_TIME_MS));
                break;
            case (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).INITIAL, (0, $cAOzG.TRANSITION_DURATION_MS));
                break;
            default:
                (0, $guiFP.default)({
                    error: new Error('Invalid transition step for command'),
                    meta: {
                        id: 'useTransitionStep',
                        packageName: 'jiraCommandPalette',
                        teamName: 'deliveroo'
                    }
                });
        }
    }, [
        command.shortcut,
        hasTransitionedFirstCommand,
        isActive,
        isFirstCommand,
        transitionStep
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (commandHasChildren) {
            if (isReducedMotion) handleReducedMotionTransition();
            else handleWithMotionTransition();
        }
    }, [
        commandHasChildren,
        isReducedMotion,
        handleReducedMotionTransition,
        handleWithMotionTransition
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isFirstCommand) setHasTransitionedFirstCommand(false);
    }, [
        isFirstCommand
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        }, []);
    return transitionStep;
};

});
parcelRegister("cAOzG", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_STEP", () => $2290b1f6fafc03ce$export$42d8d7c94c5a11e9);
$parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", () => $2290b1f6fafc03ce$export$82cfc253a6c33f59);
$parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", () => $2290b1f6fafc03ce$export$e092796a9af3633b);
$parcel$export(module.exports, "TRANSITION_DURATION_MS", () => $2290b1f6fafc03ce$export$1cad4f611a1c0229);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $2290b1f6fafc03ce$export$42d8d7c94c5a11e9;
(function(TRANSITION_STEP) {
    TRANSITION_STEP["INITIAL"] = "initial";
    TRANSITION_STEP["DELAYING"] = "delaying";
    TRANSITION_STEP["TRANSITIONING"] = "transitioning";
    TRANSITION_STEP["FINISHED"] = "finished";
    TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
    TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
})($2290b1f6fafc03ce$export$42d8d7c94c5a11e9 || ($2290b1f6fafc03ce$export$42d8d7c94c5a11e9 = {}));
const $2290b1f6fafc03ce$export$82cfc253a6c33f59 = 600;
const $2290b1f6fafc03ce$export$e092796a9af3633b = 300;
const $2290b1f6fafc03ce$export$1cad4f611a1c0229 = 350;

});





parcelRegister("985MX", function(module, exports) {

$parcel$export(module.exports, "CommandRowErrorBoundary", () => $5142cc04bb4fcd8a$export$223f3c3c93a14a83);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");
const $5142cc04bb4fcd8a$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "command-palette-row",
        packageName: "jiraCommandPalette",
        fallback: "unmount",
        teamName: teamName,
        onError: onError,
        attributes: attributes
    }, children);

});

parcelRegister("dDiRc", function(module, exports) {

$parcel$export(module.exports, "GROUP_TEST_ID", () => $1d3aece513b288cb$export$d83f892940e54128);
$parcel$export(module.exports, "NO_RESULTS_TEST_ID", () => $1d3aece513b288cb$export$bf182a53106ca02e);
$parcel$export(module.exports, "SCROLL_DIRECTION", () => $1d3aece513b288cb$export$a6d65a8fb7b912d6);
const $1d3aece513b288cb$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $1d3aece513b288cb$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $1d3aece513b288cb$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
const $1d3aece513b288cb$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
const $1d3aece513b288cb$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
var $1d3aece513b288cb$export$a6d65a8fb7b912d6;
(function(SCROLL_DIRECTION) {
    SCROLL_DIRECTION["START"] = "start";
    SCROLL_DIRECTION["END"] = "end";
})($1d3aece513b288cb$export$a6d65a8fb7b912d6 || ($1d3aece513b288cb$export$a6d65a8fb7b912d6 = {}));

});

parcelRegister("4PPUt", function(module, exports) {

$parcel$export(module.exports, "isElementVisibleInContainer", () => $4d787935cca8e899$export$b9dc8b6556026098);
$parcel$export(module.exports, "getScrollToIndex", () => $4d787935cca8e899$export$56068eb4c4e3a63c);
$parcel$export(module.exports, "scrollResultIntoView", () => $4d787935cca8e899$export$6be8a7238febd54f);

var $8FbYY = parcelRequire("8FbYY");

var $dDiRc = parcelRequire("dDiRc");
const $4d787935cca8e899$export$b9dc8b6556026098 = (element, container)=>{
    const modalBodyRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
};
const $4d787935cca8e899$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
    const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).START && commandResultIndex > 0) {
        // Verify if there is any active command before this id
        const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, $8FbYY.hasAction)(result.command));
        if (prevActiveCommandIndex === -1) return 0;
    }
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).END) {
        // Verify if there is any active command after this id
        const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, $8FbYY.hasAction)(result.command));
        if (afterActiveCommandIndex === -1) return results.length - 1;
        // Scrolling down, so group headings don't need to be taken into account
        return commandResultIndex;
    }
    const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
    return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
};
const $4d787935cca8e899$export$6be8a7238febd54f = (scrollToResult, scrollTo)=>{
    if (!scrollToResult?.parentElement) return;
    const parent = scrollToResult.parentElement;
    const elemRect = scrollToResult.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
    const gapScroll = 4;
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).END) {
        const commandPosition = elemRect.bottom - parentRect.top;
        const amountToScroll = commandPosition - parentRect.height;
        const pos = amountToScroll + gapScroll + parent.scrollTop;
        scrollToResult.parentElement.scrollTo({
            top: pos
        });
    } else {
        const commandPosition = parentRect.top - elemRect.top;
        const amountToScroll = parent.scrollTop - commandPosition;
        const pos = amountToScroll - gapScroll;
        scrollToResult.parentElement.scrollTo({
            top: pos
        });
    }
};

});


parcelRegister("b4qUd", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $846e4b3bae55c666$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

const $846e4b3bae55c666$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
    const footerChildren = children || defaultFooterContent;
    if (!footerChildren) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($846e4b3bae55c666$var$ModalFooter, {
        "data-testid": (0, $933f109161dc97b5$export$aca3e1b45b29f2bb)
    }, footerChildren);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $846e4b3bae55c666$var$ModalFooter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_mrkb1kw7 _1o0z1kw7 _x3doh6cr _1yt49l6b",
            __cmplp.className
        ])
    });
});

});
const $933f109161dc97b5$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';


parcelRegister("48xUp", function(module, exports) {

$parcel$export(module.exports, "Header", () => $3708226beef9cde7$export$8b251419efc915eb);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

const $3708226beef9cde7$export$8b251419efc915eb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3708226beef9cde7$var$headerStyles,
        testId: (0, $baf314009244cc15$export$bf5b960a2e79e6cf)
    }, children);
const $3708226beef9cde7$var$headerStyles = (0, $1ZAYh.xcss)({
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    padding: 'space.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderBottom: `solid 1px ${`var(--ds-border, ${(0, $PdmhA).N40})`}`
});

});
const $baf314009244cc15$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';



parcelRegister("70Z2O", function(module, exports) {

$parcel$export(module.exports, "IssueTag", () => $f2e2061572377f16$export$a342a0ad2c552031);

var $eUqFw = parcelRequire("eUqFw");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $h2IaY = parcelRequire("h2IaY");

var $b5tfU = parcelRequire("b5tfU");

var $8xsZc = parcelRequire("8xsZc");

var $fWeG1 = parcelRequire("fWeG1");
const $f2e2061572377f16$export$a342a0ad2c552031 = ({ issueKey: issueKey })=>{
    const [{ value: summary }] = (0, $fWeG1.useSummaryField)({
        issueKey: issueKey
    });
    const [{ value: issueType }] = (0, $8xsZc.useIssueTypeField)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $f2e2061572377f16$var$issueTagContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $f2e2061572377f16$var$issueTagStyles,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5tfU.IssueLeftIcon), {
        issueTypeName: issueType?.name,
        iconUrl: issueType?.iconUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h2IaY.TruncateWithTooltipOnHover), null, `${issueKey} ${summary}`)));
};
const $f2e2061572377f16$var$issueTagContainerStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    minWidth: '0'
});
const $f2e2061572377f16$var$issueTagStyles = (0, $1ZAYh.xcss)({
    maxWidth: '100%',
    padding: 'space.050',
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius.100',
    fontSize: '14px',
    color: 'color.text.subtle',
    lineHeight: 1
});

});
parcelRegister("h2IaY", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnHover", () => $dae903da6e3f2851$export$b2323503daaefa);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $lXgc2 = parcelRequire("lXgc2");


var $lDcdk = parcelRequire("lDcdk");
const $dae903da6e3f2851$export$70f47de153e915ed = ()=>(0, $eUqFw.useRef)(null);
const $dae903da6e3f2851$export$b2323503daaefa = ({ children: children })=>{
    const containerRef = $dae903da6e3f2851$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $lDcdk.useTruncatedTooltip)({
        containerRef: containerRef,
        // Tooltip delay is set on the tooltip component
        tooltipDelay: 0
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: shouldShowTruncatedTooltip ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-content"
            }, children) : '',
        component: (0, $lXgc2.TooltipComponent),
        position: "bottom-end",
        delay: (0, $79f2d7e0eace9088$export$f9e3e7ede9ba929d)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TooltipTrigger), {
            "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-trigger",
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TruncateWithTooltipContainer), {
            ref: containerRef
        }, children)));
};

});

parcelRegister("b5tfU", function(module, exports) {

$parcel$export(module.exports, "IssueLeftIcon", () => $1622fc3f30429d58$export$b1b562672a76ad84);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4SlOI = parcelRequire("4SlOI");
const $1622fc3f30429d58$export$b1b562672a76ad84 = ({ iconUrl: iconUrl, issueTypeName: issueTypeName })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: iconUrl,
        alt: formatMessage((0, $4SlOI.messages).issueIconAltText, {
            issueTypeName: issueTypeName
        }),
        height: "16"
    });
};

});
parcelRegister("4SlOI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9a3b0db79e5e3d34$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9a3b0db79e5e3d34$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issueIconAltText: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text",
        "defaultMessage": "Icon for the issue type {issueTypeName}"
    }
});

});


parcelRegister("8xsZc", function(module, exports) {

$parcel$export(module.exports, "useIssueTypeField", () => $d6d526ec7a011453$export$3da96c4009e089ca);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $d6d526ec7a011453$export$3da96c4009e089ca = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, (0, $lO4Or.ISSUE_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', (0, $lO4Or.ISSUE_TYPE));
    const [{ value: value, error: error, loading: loading }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $lO4Or.ISSUE_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig,
            loading: loading
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});



parcelRegister("dK5FP", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommands", () => $882c857bed4a7f74$export$c13b008422be19c7);

var $7Xm2s = parcelRequire("7Xm2s");
const $882c857bed4a7f74$export$c13b008422be19c7 = (0, $7Xm2s.useSubscribeCommandsWithRegistry);

});

parcelRegister("8UUJO", function(module, exports) {

$parcel$export(module.exports, "AssigneeListBody", () => $ad0434595a8afd86$export$e56581bb59139a77);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $6jiFZ = parcelRequire("6jiFZ");
var $LddR2 = parcelRequire("LddR2");
var $hH3bZ = parcelRequire("hH3bZ");

var $9zALC = parcelRequire("9zALC");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $bFzGY = parcelRequire("bFzGY");

var $jf5VS = parcelRequire("jf5VS");

var $fsHql = parcelRequire("fsHql");

var $cccke = parcelRequire("cccke");
const $ad0434595a8afd86$export$e56581bb59139a77 = ({ prefetchResult: prefetchResult, initialOptions: initialOptions = [], value: value, fetchSuggestions: fetchSuggestions, results: results, setChildResult: setChildResult, setLoading: setLoading, ...bodyProps })=>{
    const prefetchSessionId = prefetchResult?.prefetchSessionId || '';
    const issueKey = (0, $hJ992.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { saveAssigneeField: saveAssigneeField } = (0, $cccke.useSaveAssigneeField)(issueKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)(); /**
                             * Function to load the list of all assignees based on the search string
                             */ 
    const loadAssigneeList = (0, $eUqFw.useCallback)(async (searchString)=>{
        let suggestionsResult;
        try {
            suggestionsResult = await fetchSuggestions(searchString, prefetchSessionId);
        } catch  {
            setLoading(false);
            return;
        }
        const initialOptionsActive = initialOptions.map((option)=>({
                ...option,
                active: true
            })); // Filter out any suggestions that are in the initial or empty options.
        const suggestionIdsToFilterOut = initialOptionsActive.map((option)=>option.id);
        const filterOutCurrentUser = value?.id;
        const suggestions = suggestionsResult.filter((result)=>result && !suggestionIdsToFilterOut.includes(result.id) && filterOutCurrentUser !== result.id);
        const fullList = [
            ...initialOptionsActive,
            ...suggestions
        ];
        if (value) {
            const currentIndex = fullList.findIndex((result)=>result?.id === value.id);
            if (currentIndex > -1) fullList.splice(currentIndex, 1);
            if (value?.id) fullList.unshift({
                ...value,
                active: true
            });
        }
        const final = fullList.filter((result)=>!!result?.active).map((result)=>{
            const isUserSelected = value?.id && result.id === value?.id;
            return {
                id: `issue.issue-view.issue-base.assignee.${result.id}`,
                name: result.name,
                keywords: `${result.byline || ''} ${result.displayName || ''}`,
                components: {
                    Name: ({ isActive: isActive })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad0434595a8afd86$var$AssigneeContainer, {
                            active: isActive
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad0434595a8afd86$var$AssigneeNameFlexBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad0434595a8afd86$var$AssigneeNameContainer, null, result.name, result.displayName && result.displayName !== result.name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad0434595a8afd86$var$AssigneeDisplayName, null, "\xa0(", result.displayName, ")")), isUserSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad0434595a8afd86$var$CurrentAssigneeFlagContainer, null, formatMessage((0, $fsHql.messages).currentAssignee))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad0434595a8afd86$var$AssigneeByLine, {
                            active: isActive
                        }, result.byline)),
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad0434595a8afd86$var$AvatarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                            borderColor: "transparent",
                            src: result.avatarUrl,
                            size: "xsmall"
                        }))
                },
                ...!isUserSelected ? {
                    primaryAction: {
                        type: (0, $6jiFZ.CommandActionType).PERFORM,
                        perform: ()=>{
                            const user = (0, $jf5VS.transformToStateValue)(result);
                            saveAssigneeField(user, null, createAnalyticsEvent({}));
                        }
                    }
                } : {
                    primaryAction: undefined
                },
                analytics: {
                    action: 'updateAssignee',
                    actionCategory: (0, $9zALC.COMMAND_PALETTE_ISSUE_ACTIONS)
                }
            };
        });
        const finalChildResult = {
            commands: final
        };
        setChildResult(finalChildResult);
        setLoading(false);
    }, [
        initialOptions,
        value,
        setChildResult,
        setLoading,
        fetchSuggestions,
        prefetchSessionId,
        formatMessage,
        saveAssigneeField,
        createAnalyticsEvent
    ]);
    (0, $hH3bZ.useDebouncedLoadChildren)(loadAssigneeList);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LddR2.components).Body, {
        ...bodyProps,
        setChildResult: setChildResult,
        setLoading: setLoading,
        results: results
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad0434595a8afd86$var$AssigneeContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.active ? "_syazaj1x" : "_syaz1a45",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad0434595a8afd86$var$AssigneeNameFlexBox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad0434595a8afd86$var$AssigneeNameContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad0434595a8afd86$var$AssigneeDisplayName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad0434595a8afd86$var$AssigneeByLine = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4gktf _1wyb1crf",
            __cmplp.active ? "_syaz1o15" : "_syaz1wmz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad0434595a8afd86$var$AvatarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad0434595a8afd86$var$CurrentAssigneeFlagContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hH3bZ", function(module, exports) {

$parcel$export(module.exports, "useDebouncedLoadChildren", () => $2d65e740d1f04fbc$export$d38ddfbd8b9028f);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $1ybV0 = parcelRequire("1ybV0");

var $gCtL7 = parcelRequire("gCtL7");
const $2d65e740d1f04fbc$export$d38ddfbd8b9028f = (callback)=>{
    const [{ search: search }, { setLoadingList: setLoadingList }] = (0, $gCtL7.useCommandPaletteSearch)();
    const loadChildCommands = (0, $eUqFw.useCallback)(async (searchTerm, obj)=>{
        await callback(searchTerm, obj);
        if (!obj.isMounted) return;
        setLoadingList(false);
    }, [
        callback,
        setLoadingList
    ]);
    const executeDebouncer = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(loadChildCommands, (0, $1ybV0.ff)('compal-issue-actions-follow-up-improvements_y49xu') ? 250 : 400), [
        loadChildCommands
    ]);
    (0, $eUqFw.useEffect)(()=>()=>executeDebouncer?.cancel?.(), [
        executeDebouncer
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const obj = {
            isMounted: true
        };
        setLoadingList(true);
        executeDebouncer(search, obj);
        return ()=>{
            obj.isMounted = false;
        };
    }, [
        search,
        executeDebouncer,
        setLoadingList
    ]);
};

});

parcelRegister("fsHql", function(module, exports) {

$parcel$export(module.exports, "messages", () => $47233a7a28a6815d$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $47233a7a28a6815d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    assignIssue: {
        "id": "issue.assignee.command-palette.assign-issue",
        "defaultMessage": "Assign issue"
    },
    searchPeople: {
        "id": "issue.assignee.command-palette.search-people",
        "defaultMessage": "Search people"
    },
    currentAssignee: {
        "id": "issue.assignee.command-palette.current-assignee",
        "defaultMessage": "Current assignee"
    },
    fallbackNoResults: {
        "id": "issue.assignee.command-palette.fallback-no-results",
        "defaultMessage": "No results match your search."
    },
    fallbackOnError: {
        "id": "issue.assignee.command-palette.fallback-on-error",
        "defaultMessage": "We're having trouble loading this data. Wait a few moments, then try again."
    }
});

});

parcelRegister("cccke", function(module, exports) {

$parcel$export(module.exports, "useSaveAssigneeField", () => $a7601e2c9cbbc3ab$export$75fe7568b3d3fc4b);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dnK1q = parcelRequire("dnK1q");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8Uvgu = parcelRequire("8Uvgu");
const $a7601e2c9cbbc3ab$export$75fe7568b3d3fc4b = (issueKey)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ commandPaletteSessionId: commandPaletteSessionId }] = (0, $gCtL7.useCommandPaletteSessionId)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onSaveSuccessfully = (0, $eUqFw.useCallback)((user)=>{
        const action = 'commandPalette';
        const actionSubject = 'assignIssue';
        const eventActionAndSubject = `${actionSubject} ${action}`;
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        (0, $jMP2a.fireTrackAnalytics)(event, eventActionAndSubject, {
            assigneeId: user?.accountId,
            commandPaletteSessionId: commandPaletteSessionId
        });
        showFlag({
            type: 'success',
            title: formatMessage((0, $8Uvgu.messages).successFlagMessage)
        });
    }, [
        commandPaletteSessionId,
        createAnalyticsEvent,
        formatMessage,
        showFlag
    ]);
    const onFailSave = (0, $eUqFw.useCallback)((err)=>{
        (0, $guiFP.default)({
            error: err,
            meta: {
                id: 'commandPaletteAssignIssue',
                // eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics
                packageName: 'jiraIssueView',
                // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                teamName: 'deliveroo'
            }
        });
        showFlag({
            type: 'error',
            title: formatMessage((0, $8Uvgu.messages).errorFlagTitle),
            description: formatMessage((0, $8Uvgu.messages).errorFlagDescription)
        });
    }, [
        formatMessage,
        showFlag
    ]);
    const [, { saveValue: saveAssigneeField }] = (0, $dnK1q.default)({
        issueKey: issueKey,
        onSuccess: onSaveSuccessfully,
        onFailure: onFailSave
    });
    return {
        saveAssigneeField: saveAssigneeField
    };
};

});
parcelRegister("8Uvgu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $599d5947a8865eac$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $599d5947a8865eac$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    successFlagMessage: {
        "id": "issue.command-palette-assignee.use-save-assignee-field.success-flag-message",
        "defaultMessage": "Assignee updated"
    },
    errorFlagTitle: {
        "id": "issue.command-palette-assignee.use-save-assignee-field.error-flag-title",
        "defaultMessage": "We couldn\u2019t update the assignee"
    },
    errorFlagDescription: {
        "id": "issue.command-palette-assignee.use-save-assignee-field.error-flag-description",
        "defaultMessage": "Wait a few moments, then try again."
    }
});

});





parcelRegister("4F0Ed", function(module, exports) {

$parcel$export(module.exports, "default", () => $60243a480fa89959$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8411R = parcelRequire("8411R");
var $kmr29 = parcelRequire("kmr29");

var $5i7o6 = parcelRequire("5i7o6");

var $73FRM = parcelRequire("73FRM");

var $5G3JL = parcelRequire("5G3JL");

var $hHKWU = parcelRequire("hHKWU");

var $4QRaC = parcelRequire("4QRaC");

var $lqalZ = parcelRequire("lqalZ");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $lO4Or = parcelRequire("lO4Or");
const $60243a480fa89959$var$CascadingSelectView = (props)=>{
    const { issueKey: issueKey, fieldKey: fieldKey, label: label } = props;
    const [fieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i7o6.default), {
        ...props,
        allowedValues: fieldConfig && fieldConfig.allowedValues || [],
        isEditable: fieldConfig && fieldConfig.isEditable || false,
        label: fieldConfig && fieldConfig.title || label,
        initialValue: fieldValue
    });
};
var $60243a480fa89959$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state, { fieldId: fieldId, area: area })=>({
        fieldKey: fieldId,
        fieldType: (0, $lO4Or.CASCADING_SELECT_CF_TYPE),
        error: (0, $jZDJX.errorSelector)(state),
        issueKey: (0, $5JqpU.issueKeySelector)(state),
        isMobile: (0, $5JqpU.isMobileSelector)(state),
        label: (0, $fokFV.fieldNameSelector)(fieldId)(state),
        areOptionsOnSameRow: area === (0, $73FRM.CONTENT) || area === (0, $73FRM.CONTENT_REQUEST),
        showPinButton: (0, $hHKWU.default)(area)
    }), {}))((0, $4QRaC.withFieldViewExperienceTracker)()($60243a480fa89959$var$CascadingSelectView));

});
parcelRegister("5i7o6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab6166cb9dff550e$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $f8Yej = parcelRequire("f8Yej");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGiWF = parcelRequire("gGiWF");

var $9LvPd = parcelRequire("9LvPd");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $6oQPP = parcelRequire("6oQPP");

var $4bZws = parcelRequire("4bZws");

var $4xwq2 = parcelRequire("4xwq2");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");

var $i5YRy = parcelRequire("i5YRy");

var $g5UOm = parcelRequire("g5UOm");

var $2O9nE = parcelRequire("2O9nE");
const $ab6166cb9dff550e$var$getReadViewValue = (option, intl)=>{
    if (option && 'child' in option && option.child) return `${option.label} - ${option.child.label}`;
    if (option) return option.label;
    return intl.formatMessage((0, $2O9nE.default).noOptionsSelected);
};
const $ab6166cb9dff550e$var$CascadingSelectInlineEditView = (props)=>{
    const { label: label, isEditable: isEditable, isMobile: isMobile, allowedValues: allowedValues, areOptionsOnSameRow: areOptionsOnSameRow, showPinButton: showPinButton, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, ...fieldOptions } = props;
    const intl = (0, $5JgJ2.default)();
    const [{ value: value, error: error }, { saveValue: saveValue }] = (0, $gGiWF.useEditField)(fieldOptions);
    const [selectedOption, setSelectedOption] = (0, $eUqFw.useState)((0, $i5YRy.transformToOptionValue)(value));
    const [savedSelectedOption, setSavedSelectedOption] = (0, $eUqFw.useState)((0, $i5YRy.transformToOptionValue)(value));
    const [isEditing, setIsEditing] = (0, $eUqFw.useState)(false);
    const [readView, setReadView] = (0, $eUqFw.useState)($ab6166cb9dff550e$var$getReadViewValue(selectedOption, intl));
    const [transformedParentValues, setTransformedParentValues] = (0, $eUqFw.useState)([]);
    const [transformedChildValues, setTransformedChildValues] = (0, $eUqFw.useState)({});
    const updateReadViewWith = (0, $eUqFw.useCallback)((option)=>{
        setReadView($ab6166cb9dff550e$var$getReadViewValue(option, intl));
    }, [
        intl
    ]);
    const onEditRequested = (0, $eUqFw.useCallback)(()=>{
        setTransformedParentValues((0, $i5YRy.transformToOptions)(allowedValues));
        setTransformedChildValues((0, $i5YRy.transformToParentChildOptionMap)(allowedValues));
        setIsEditing(true);
    }, [
        allowedValues
    ]);
    const onConfirm = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        saveValue((0, $i5YRy.transformToServerValue)(selectedOption), null, analyticsEvent);
        setIsEditing(false);
        updateReadViewWith(selectedOption);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'cascadingSelect', {
            hasChild: !!(selectedOption && // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
            selectedOption.child && // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
            selectedOption.child != null),
            isEmpty: !selectedOption
        });
        setSavedSelectedOption(selectedOption);
    }, [
        saveValue,
        selectedOption,
        updateReadViewWith
    ]);
    const onCancel = (0, $eUqFw.useCallback)(()=>{
        setIsEditing(false);
        setSelectedOption(savedSelectedOption);
    }, [
        savedSelectedOption
    ]); // We're using the ViewProps type and it requires an onChange prop that returns a promise
    const updateSelectedOptions = (0, $eUqFw.useCallback)(async (option)=>{
        setSelectedOption(option);
    }, []);
    const renderReadView = (0, $eUqFw.useCallback)(()=>{
        let child;
        if (!selectedOption) child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), null, readView);
        else child = readView;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab6166cb9dff550e$var$ReadViewContainer, {
            "data-component-selector": $ab6166cb9dff550e$export$195ee2a97947e11b
        }, child);
    }, [
        readView,
        selectedOption
    ]);
    const renderEditView = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab6166cb9dff550e$var$EditViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g5UOm.CascadingSelectView), {
            value: selectedOption,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            allowedValues: transformedParentValues,
            allowedChildValues: transformedChildValues,
            onChange: updateSelectedOptions,
            isInvalid: !!error,
            areOptionsOnSameRow: areOptionsOnSameRow,
            isEditable: isEditable
        })), [
        areOptionsOnSameRow,
        error,
        isDropdownMenuFixedAndLayered,
        isEditable,
        onCloseMenuOnScroll,
        selectedOption,
        transformedChildValues,
        transformedParentValues,
        updateSelectedOptions
    ]);
    (0, $eUqFw.useEffect)(()=>{
        updateReadViewWith(selectedOption);
    }, [
        selectedOption,
        updateReadViewWith
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) setIsEditing(true);
    }, [
        error
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setSelectedOption((0, $i5YRy.transformToOptionValue)(value));
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, label), props.issueKey !== undefined && fieldOptions.fieldKey !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: props.issueKey,
        fieldKey: fieldOptions.fieldKey,
        label: label
    }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldOptions.fieldKey,
        label: label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), {
        isEditing: isEditing,
        "data-testid": "issue-field-cascading-select.ui.issue-field-cascading-select"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
        onEscape: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab6166cb9dff550e$var$InlineEditContainer, {
        isEditable: isEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        defaultValue: "",
        readView: renderReadView,
        editView: renderEditView,
        isEditable: isEditable,
        onCancel: onCancel,
        onConfirm: onConfirm,
        onEdit: onEditRequested,
        isEditing: isEditing,
        readViewFitContainerWidth: !isMobile
    })))));
};
$ab6166cb9dff550e$var$CascadingSelectInlineEditView.defaultProps = {
    initialValue: null,
    isMobile: false,
    areOptionsOnSameRow: false,
    fieldType: (0, $lO4Or.CASCADING_SELECT_CF_TYPE)
};
var $ab6166cb9dff550e$export$2e2bcd8739ae039 = $ab6166cb9dff550e$var$CascadingSelectInlineEditView;
const $ab6166cb9dff550e$export$195ee2a97947e11b = 'jira-issue-field-cascading-select-read-view-container';
const $ab6166cb9dff550e$var$READ_VIEW_CONTAINER_COMPONENT_SELECTOR = `[data-component-selector="${$ab6166cb9dff550e$export$195ee2a97947e11b}"]`; // The save/close buttons have an z-index of 200, so the dropdown needs to exist above that
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ab6166cb9dff550e$var$EditViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ab6166cb9dff550e$var$ReadViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _vwz48sxn _p12f1osq _1nmz1hna _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $ab6166cb9dff550e$var$nonEditableStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ab6166cb9dff550e$var$InlineEditContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0x0bf _19pkx0bf _1bsb1osq _1gzc1txw _auuz1h6o _6vgs1osq _1rjezwfg _osjgidpf _alyvidpf _pa3x12x7 _2g9bidpf",
            !__cmplp.isEditable && "_1xn912x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i5YRy", function(module, exports) {

$parcel$export(module.exports, "transformToOptionValue", () => $07c7b256a725a010$export$d1480328df7a42bf);
$parcel$export(module.exports, "transformToOptions", () => $07c7b256a725a010$export$899758961952c638);
$parcel$export(module.exports, "transformToParentChildOptionMap", () => $07c7b256a725a010$export$575da772c90849b8);
$parcel$export(module.exports, "transformToServerValue", () => $07c7b256a725a010$export$6f0c6eec5b71d787);

var $jqvCZ = parcelRequire("jqvCZ");
const $07c7b256a725a010$export$d1480328df7a42bf = (serverValue)=>{
    if (!serverValue) return null;
    const { id: id, value: value, child: child } = serverValue;
    return {
        value: id,
        label: value,
        child: child && {
            value: child.id,
            label: child.value
        }
    };
};
const $07c7b256a725a010$export$899758961952c638 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((values)=>values.map(({ id: id, value: value })=>({
            value: id,
            label: value
        })));
const $07c7b256a725a010$export$575da772c90849b8 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((values)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    values.reduce((acc, { id: id, children: children })=>{
        acc[id] = children ? $07c7b256a725a010$export$899758961952c638(children) : [];
        return acc;
    }, {}));
const $07c7b256a725a010$export$6f0c6eec5b71d787 = (option)=>{
    if (!option) return null;
    const { label: label, value: value } = option;
    // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
    const child = option.child || undefined;
    return {
        id: value,
        value: label,
        child: child && {
            id: child.value,
            value: child.label
        }
    };
};

});

parcelRegister("g5UOm", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectView", () => $619bed3473540601$export$468e769561d652ac);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7jPhn = parcelRequire("7jPhn");

var $4zgIJ = parcelRequire("4zgIJ");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");

var $zaAyA = parcelRequire("zaAyA");

var $7YSy3 = parcelRequire("7YSy3");
const $619bed3473540601$export$468e769561d652ac = (props)=>{
    const { value: value, allowedValues: allowedValues, allowedChildValues: allowedChildValues, onChange: onChange, isInvalid: isInvalid = false, areOptionsOnSameRow: areOptionsOnSameRow = false, autoFocus: autoFocus = true, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isEditable: isEditable = true, isClearable: isClearable = true, ...fieldProps } = props;
    const intl = (0, $5JgJ2.default)();
    const [defaultParentOption, defaultChildOption] = (0, $7YSy3.splitParentChildOptions)(value);
    const [parentOption, setParentOption] = (0, $eUqFw.useState)(defaultParentOption);
    const [childOption, setChildOption] = (0, $eUqFw.useState)(defaultChildOption);
    const [childOptions, setChildOptions] = (0, $eUqFw.useState)(defaultParentOption && allowedChildValues[defaultParentOption.value] || []);
    const [isChildAutoFocus, setIsChildAutoFocus] = (0, $eUqFw.useState)((0, $7YSy3.getIsChildAutoFocus)(value, childOptions));
    const childRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('uim-cascading-select-field-support-gic_h1cda')) {
            setParentOption(defaultParentOption?.value ? {
                label: defaultParentOption.label,
                value: defaultParentOption.value
            } : null);
            setChildOption(defaultChildOption?.value ? {
                label: defaultChildOption.label,
                value: defaultChildOption.value
            } : null);
            setChildOptions(defaultParentOption?.value ? allowedChildValues[defaultParentOption.value] : []);
        }
    }, [
        defaultParentOption?.value,
        defaultParentOption?.label,
        defaultChildOption?.value,
        defaultChildOption?.label,
        allowedChildValues
    ]);
    const onSelectParentOption = (selectedParentOption, // @ts-expect-error - TS7031 - Binding element 'action' implicitly has an 'any' type.
    { action: action }, analyticsEvent)=>{
        setChildOption(null);
        switch(action){
            case 'select-option':
                onChange(selectedParentOption, null, analyticsEvent);
                setParentOption(selectedParentOption);
                setChildOptions(allowedChildValues[selectedParentOption.value] || []);
                setIsChildAutoFocus((0, $7YSy3.getIsChildAutoFocus)(value, childOptions)); // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                childRef && childRef.current && childRef.current.focus();
                break;
            case 'clear':
                onChange(null, null, analyticsEvent);
                setParentOption(null);
                setChildOptions([]);
                break;
            default:
                break;
        }
    };
    // @ts-expect-error - TS7031 - Binding element 'action' implicitly has an 'any' type.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSelectChildOption = (selectedChildOption, { action: action }, analyticsEvent)=>{
        switch(action){
            case 'select-option':
                onChange(// @ts-expect-error - TS2345 - Argument of type '{ child: Option; value?: string | undefined; label?: string | undefined; }' is not assignable to parameter of type 'SelectedOption'.
                {
                    ...parentOption,
                    child: selectedChildOption
                }, null, analyticsEvent);
                setChildOption(selectedChildOption);
                break;
            case 'clear':
                onChange(parentOption, null, analyticsEvent);
                setChildOption(null);
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, intl.formatMessage((0, $zaAyA.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($619bed3473540601$var$Container, {
        areOptionsOnSameRow: areOptionsOnSameRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($619bed3473540601$var$Item, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), {
        ...fieldProps,
        defaultValue: defaultParentOption,
        value: parentOption,
        options: allowedValues,
        onChange: onSelectParentOption,
        isClearable: isClearable,
        autoFocus: autoFocus,
        openMenuOnFocus: true,
        placeholder: intl.formatMessage((0, $zaAyA.default).noOptionsSelected),
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $4NcaX.defaultSelectStyles),
        isDisabled: !isEditable,
        testId: "issue-field-cascading-select.ui.cascading-select-view.select-parent",
        spacing: (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i') ? 'compact' : 'default'
    })), childOptions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($619bed3473540601$var$ChildItem, {
        areOptionsOnSameRow: areOptionsOnSameRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), {
        ...fieldProps,
        defaultValue: defaultChildOption,
        value: childOption,
        testId: "issue-field-cascading-select.ui.cascading-select-view.select-child",
        options: childOptions,
        onChange: onSelectChildOption,
        isClearable: isClearable,
        autoFocus: isChildAutoFocus,
        openMenuOnFocus: true,
        placeholder: intl.formatMessage((0, $zaAyA.default).noOptionsSelected),
        ref: childRef,
        closeMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: (0, $1ybV0.ff)('uim-cascading-select-field-support-gic_h1cda') ? !isEditable : undefined,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $4NcaX.defaultSelectStyles),
        spacing: (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i') ? 'compact' : 'default'
    }))));
};
var $619bed3473540601$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $619bed3473540601$export$468e769561d652ac;
const $619bed3473540601$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { areOptionsOnSameRow: areOptionsOnSameRow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.areOptionsOnSameRow ? "_2lx2vrvc" : "_2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $619bed3473540601$var$Item = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_i0dlidpf _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $619bed3473540601$var$ChildItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $619bed3473540601$var$Item, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.areOptionsOnSameRow ? "_19pkidpf" : "_19pk1y44",
            __cmplp.areOptionsOnSameRow ? "_18u01y44" : "_18u0idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4NcaX", function(module, exports) {

$parcel$export(module.exports, "defaultSelectStyles", () => $114b87bdc51f126d$export$b12192ea1a215e5f);
$parcel$export(module.exports, "indicatorFixSelectStyles", () => $114b87bdc51f126d$export$eca30945eaf474dd);

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");
const $114b87bdc51f126d$export$b12192ea1a215e5f = {
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $c9TLT.layers).modal
        }),
    menu: (base)=>({
            ...base,
            zIndex: (0, $c9TLT.layers).modal
        })
};
const $114b87bdc51f126d$var$inputIconPaddingLeft = "var(--ds-space-025, 2px)";
const $114b87bdc51f126d$var$inputIconPaddingRight = "var(--ds-space-050, 4px)";
const $114b87bdc51f126d$export$eca30945eaf474dd = {
    // need to apply same padding to both loadingIndicator and clearIndicator - not to have input query jumping between lines e.g. in multi-select
    loadingIndicator: (base)=>({
            ...base,
            paddingLeft: $114b87bdc51f126d$var$inputIconPaddingLeft,
            paddingRight: $114b87bdc51f126d$var$inputIconPaddingRight
        }),
    clearIndicator: (base)=>({
            ...base,
            paddingLeft: $114b87bdc51f126d$var$inputIconPaddingLeft,
            paddingRight: $114b87bdc51f126d$var$inputIconPaddingRight
        })
};
const $114b87bdc51f126d$export$a9f371909ef7b4d6 = {
    container: (base)=>({
            ...base,
            border: `${"var(--ds-space-025, 2px)"} solid ${`var(--ds-border-danger, ${(0, $PdmhA).R400})`}`,
            borderRadius: "var(--ds-space-050, 4px)"
        })
};

});

parcelRegister("zaAyA", function(module, exports) {

$parcel$export(module.exports, "default", () => $63927b6f6aa57682$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $63927b6f6aa57682$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noOptionsSelected: {
        "id": "issue-field-cascading-select.cascading-select-view.no-options-selected",
        "defaultMessage": "None"
    },
    errorMessage: {
        "id": "issue-field-cascading-select.cascading-select-view.error-message",
        "defaultMessage": "The value could not be saved"
    }
});

});

parcelRegister("7YSy3", function(module, exports) {

$parcel$export(module.exports, "splitParentChildOptions", () => $c64b9f69a5118fa9$export$a1116d37316e41bc);
$parcel$export(module.exports, "getIsChildAutoFocus", () => $c64b9f69a5118fa9$export$c51f468c74c12b26);
const $c64b9f69a5118fa9$export$a1116d37316e41bc = (parentChildValue)=>{
    if (!parentChildValue) return [
        null,
        null
    ];
    const { label: label, value: value } = parentChildValue;
    // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
    const child = parentChildValue.child || null;
    return [
        {
            label: label,
            value: value
        },
        child
    ];
};
const $c64b9f69a5118fa9$export$c51f468c74c12b26 = (value, childOptions)=>!value || childOptions.length === 0;

});


parcelRegister("2O9nE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5c6eb4f8e3c87b3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a5c6eb4f8e3c87b3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noOptionsSelected: {
        "id": "issue-field-cascading-select.no-options-selected",
        "defaultMessage": "None"
    }
});

});



parcelRegister("hmDMY", function(module, exports) {

$parcel$export(module.exports, "default", () => $72c5a74b4e85f712$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $i8xM4 = parcelRequire("i8xM4");

var $hHKWU = parcelRequire("hHKWU");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$72c5a74b4e85f712$export$2e2bcd8739ae039 = ({ area: area, fieldId: fieldId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i8xM4.AsyncChatChannelField), {
        showPinButton: (0, $hHKWU.default)(area),
        fieldId: fieldId
    });

});
parcelRegister("i8xM4", function(module, exports) {

$parcel$export(module.exports, "AsyncChatChannelField", () => $032e38d4c5465c1b$export$e552babe071b3e3c);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $9IbuV = parcelRequire("9IbuV");

var $8DLnH = parcelRequire("8DLnH");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $032e38d4c5465c1b$var$LazyChatChannel = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("l7AkS")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/incident-management/issue-view/chat-channel/src/ui/index.tsx"
});
const $032e38d4c5465c1b$export$e552babe071b3e3c = (props)=>{
    (0, $9IbuV.useUFOComponentExperience)((0, $8DLnH.jsmChatChannelExperience));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "servicedesk-incident-management-chat-channel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($032e38d4c5465c1b$var$LazyChatChannel, props));
};

});
parcelRegister("8DLnH", function(module, exports) {

$parcel$export(module.exports, "jsmChatChannelExperience", () => $185fb3e3d54d95cf$export$701a20f7ff119fb);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $185fb3e3d54d95cf$export$701a20f7ff119fb = new (0, $kDfSL.UFOExperience)('jsm-chat-channel', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("l7AkS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3m2pd');
        const value = parcelRequire('d7f63');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3m2pd").then(()=>parcelRequire('d7f63'));
}

});



parcelRegister("jC0O0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7aaa06494155928$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $5iWql = parcelRequire("5iWql");

var $90IgZ = parcelRequire("90IgZ");

var $jRMkh = parcelRequire("jRMkh");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $4kDvN = parcelRequire("4kDvN");

var $fokFV = parcelRequire("fokFV");

var $8WZQM = parcelRequire("8WZQM");

var $3Q8Tr = parcelRequire("3Q8Tr");
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ const $a7aaa06494155928$var$messages = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.checkbox-select.text-for-dropdown-when-nothing-selected",
        "defaultMessage": "Select {fieldName}"
    }
});
const $a7aaa06494155928$var$memoizedFetchSuggestionsFactoryV2 = (0, $5iWql.default)((values, allowedValuesOverrides)=>(0, $3Q8Tr.transformSuggestions)((0, $8WZQM.filterAllowedValues)(values, allowedValuesOverrides)));
const $a7aaa06494155928$var$Checkboxes = (0, $huRi7.compose)((0, $4kDvN.withExtraOwnProps), (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $3Q8Tr.transformFromStateValue,
        transformToStateValue: $3Q8Tr.transformToStateValue,
        additionalProps: (state, intl, fieldOptions, extraOwnProps)=>({
                options: $a7aaa06494155928$var$memoizedFetchSuggestionsFactoryV2((0, $fokFV.fieldAllowedValuesSelector)(ownPropsOnMount.fieldId)(state), extraOwnProps?.allowedValuesOverrides),
                placeholder: intl.formatMessage($a7aaa06494155928$var$messages.placeholder, {
                    fieldName: (0, $fokFV.fieldNameSelector)(ownPropsOnMount.fieldId)(state)
                }),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            })
    })))((0, $jRMkh.default));
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
$a7aaa06494155928$export$2e2bcd8739ae039 = $a7aaa06494155928$var$Checkboxes;

});
parcelRegister("jRMkh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba1ad0c7ea5adb40$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2gGF1 = parcelRequire("2gGF1");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9LvPd = parcelRequire("9LvPd");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $6oQPP = parcelRequire("6oQPP");
var $5St1r = parcelRequire("5St1r");

var $4bZws = parcelRequire("4bZws");

var $ac6FY = parcelRequire("ac6FY");

var $aUPgM = parcelRequire("aUPgM");

var $i0V1V = parcelRequire("i0V1V");
const $ba1ad0c7ea5adb40$export$f63d13715f5a09df = ({ isEditable: isEditable = false, isEditing: isEditing = false, isMobile: isMobile = false, options: options = [], value: value = [], label: label = '', placeholder: placeholder, noValueText: noValueText, tagAppearance: tagAppearance = 'default', invalidMessage: invalidMessage, issueKey: issueKey, fieldId: fieldId, showPinButton: showPinButton, onChange: onChange, onEditRequest: onEditRequest, onConfirm: onConfirm, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderReadView = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ac6FY.default), {
            value: value.map(({ label: lLabel, value: lValue })=>({
                    content: lLabel,
                    value: lValue
                })),
            noValueText: noValueText,
            tagAppearance: tagAppearance,
            shouldHideLinks: isMobile
        }), [
        isMobile,
        noValueText,
        tagAppearance,
        value
    ]);
    const renderEditView = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aUPgM.default), {
            value: value,
            options: options,
            onChange: onChange,
            placeholder: placeholder,
            invalidMessage: invalidMessage
        }), [
        value,
        onChange,
        options,
        placeholder,
        invalidMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), {
        "data-testid": `issue.views.field.checkbox-inline-edit.${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), {
        fieldId: fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, label), issueKey !== undefined && fieldId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldId,
        label: label
    }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldId,
        label: label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), {
        isEditing: isEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0V1V.InlineEditContainer), {
        isEditable: isEditable,
        hasValue: value && value.length !== 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        isLabelHidden: true,
        label: label,
        readView: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5St1r.ReadViewContainer), null, renderReadView()),
        testId: `issue.views.field.checkbox-inline-edit.${fieldId}`,
        editView: isEditable ? renderEditView() : null,
        // @ts-expect-error - TS2322 - Property 'disableEditViewFieldBase' does not exist on type 'IntrinsicAttributes & FieldInlineEditStateLessProps<unknown>'.
        disableEditViewFieldBase: true,
        areActionButtonsHidden: true,
        isEditing: isEditing,
        onConfirm: onConfirm,
        onCancel: onCancel,
        onEscape: onCancel,
        onEditRequested: onEditRequest,
        isFitContainerWidthReadView: !isMobile,
        editButtonLabel: formatMessage((0, $2gGF1.default).editButtonLabel, {
            fieldName: label
        }),
        confirmButtonLabel: formatMessage((0, $2gGF1.default).confirmButtonLabel, {
            fieldName: label
        }),
        cancelButtonLabel: formatMessage((0, $2gGF1.default).cancelButtonLabel, {
            fieldName: label
        }),
        isEditable: isEditable
    }))));
};
var $ba1ad0c7ea5adb40$export$2e2bcd8739ae039 = $ba1ad0c7ea5adb40$export$f63d13715f5a09df;

});
parcelRegister("ac6FY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1b348cecfccb214$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $9jNAz = parcelRequire("9jNAz");

var $cAKIH = parcelRequire("cAKIH");

var $8cU5f = parcelRequire("8cU5f");

var $eGI9v = parcelRequire("eGI9v");

var $3ZL8o = parcelRequire("3ZL8o");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4xwq2 = parcelRequire("4xwq2");

var $kpn8k = parcelRequire("kpn8k");

var $kJlBc = parcelRequire("kJlBc");

var $bXJdt = parcelRequire("bXJdt");
const $b1b348cecfccb214$export$3ada91b29c58e2a2 = 8;
const $b1b348cecfccb214$var$ShowHide = ({ handleShowHideMore: handleShowHideMore, handleTagMouseDown: handleTagMouseDown, tagAppearance: tagAppearance, isShowingMore: isShowingMore, value: value })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        onClick: handleShowHideMore,
        role: "presentation",
        onMouseDown: handleTagMouseDown,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "issue-view.common.tag.tag-view.show-hide-more"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        appearance: tagAppearance,
        text: isShowingMore ? formatMessage((0, $bXJdt.default).showLess) : formatMessage((0, $bXJdt.default).showAll, {
            peopleCount: value?.length
        }),
        href: "#"
    }));
};
const $b1b348cecfccb214$var$TagItem = ({ isUserTag: isUserTag = false, shouldHideLinks: shouldHideLinks = false, tagAppearance: tagAppearance = 'default', item: item })=>{
    const CustomTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.common.tag.tag-item",
        appearance: tagAppearance,
        // @ts-expect-error - TS2339 - Property 'content' does not exist on type 'Item'. | TS2339 - Property 'content' does not exist on type 'Item'. | TS2339 - Property 'label' does not exist on type 'Item'.
        text: item.content !== undefined ? item.content : item.label,
        color: item.color,
        href: shouldHideLinks ? undefined : item.href,
        linkComponent: (0, $kJlBc.Link),
        elemBefore: item.elemBefore
    });
    // User Tags
    if (isUserTag) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kpn8k.default), {
        // @ts-expect-error - TS2322 - Type 'Item' is not assignable to type 'ExternalUser'.
        userAccount: item,
        analyticsData: {
            trigger: 'user-tag'
        },
        position: "left-start"
    }, CustomTag);
    return CustomTag;
};
const $b1b348cecfccb214$export$d6512ec35d673798 = ({ isUserTag: isUserTag = false, renderTagItem: renderTagItem, renderTagTooltipContent: renderTagTooltipContent, shouldHideLinks: shouldHideLinks = false, value: value = null, noValueText: noValueText = null, tagAppearance: tagAppearance = 'default', truncateValues: truncateValues = false, onClick: onClick })=>{
    const [isShowingMore, setIsShowingMore] = (0, $eUqFw.useState)(false);
    const handleTagSelected = (0, $eUqFw.useCallback)((e)=>{
        // @ts-expect-error - TS2559 - Type 'EventTarget' has no properties in common with type 'ElementToCheck'.
        if ((0, $3ZL8o.default)(e.target, e.currentTarget)) {
            e.stopPropagation();
            if (onClick) onClick();
        }
    }, [
        onClick
    ]);
    const handleTagMouseDown = (0, $eUqFw.useCallback)((e)=>{
        e.preventDefault();
        // @ts-expect-error - TS2559 - Type 'EventTarget' has no properties in common with type 'ElementToCheck'.
        if ((0, $3ZL8o.default)(e.target, e.currentTarget)) e.stopPropagation();
    }, []);
    const handleShowHideMore = (0, $eUqFw.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        setIsShowingMore(!isShowingMore);
    }, [
        isShowingMore
    ]);
    if (value && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(value)) {
        const newValue = truncateValues && !isShowingMore && value.length > $b1b348cecfccb214$export$3ada91b29c58e2a2 ? value.slice(0, $b1b348cecfccb214$export$3ada91b29c58e2a2) : value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $b1b348cecfccb214$var$tagWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cAKIH.default), null, newValue.map((item)=>{
            const tooltipContent = // eslint-disable-next-line no-nested-ternary
            (0, $1ybV0.ff)('compass-components-in-jira-components_xw42u') && typeof renderTagTooltipContent === 'function' ? renderTagTooltipContent(item) : // @ts-expect-error - TS2339 - Property 'content' does not exist on type 'Item'. | TS2339 - Property 'content' does not exist on type 'Item'.
            item.content !== undefined && item.content.length > 20 ? // @ts-expect-error - TS2339 - Property 'content' does not exist on type 'Item'.
            item.content : '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: tooltipContent,
                // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'Item'. | TS2339 - Property 'key' does not exist on type 'Item'. | TS2339 - Property 'value' does not exist on type 'Item'.
                key: item.key != null ? item.key : item.value
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                onClick: handleTagSelected,
                onMouseDown: handleTagMouseDown,
                onKeyPress: handleTagSelected,
                // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'Item'. | TS2339 - Property 'key' does not exist on type 'Item'. | TS2339 - Property 'value' does not exist on type 'Item'.
                key: item.key != null ? item.key : item.value,
                role: "presentation"
            }, (0, $1ybV0.ff)('compass-components-in-jira-components_xw42u', false) && typeof renderTagItem === 'function' ? renderTagItem(item) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1b348cecfccb214$var$TagItem, {
                isUserTag: isUserTag,
                shouldHideLinks: shouldHideLinks,
                tagAppearance: tagAppearance === 'default' ? 'default' : 'rounded',
                item: item
            })));
        }), truncateValues && value.length > $b1b348cecfccb214$export$3ada91b29c58e2a2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1b348cecfccb214$var$ShowHide, {
            handleShowHideMore: handleShowHideMore,
            handleTagMouseDown: handleTagMouseDown,
            isShowingMore: isShowingMore,
            tagAppearance: tagAppearance === 'default' ? 'default' : 'rounded',
            value: value
        })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), null, noValueText);
};
const $b1b348cecfccb214$var$TagViewWithAnalytics = (0, $eGI9v.default)('tagView', {
    onClick: 'clicked'
})($b1b348cecfccb214$export$d6512ec35d673798);
var $b1b348cecfccb214$export$2e2bcd8739ae039 = $b1b348cecfccb214$var$TagViewWithAnalytics;
const $b1b348cecfccb214$var$tagWrapperStyles = (0, $1ZAYh.xcss)({
    margin: 'space.negative.050',
    width: '100%'
});

});
parcelRegister("9jNAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $02a667cb3800fd5a$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $d9W8K = parcelRequire("d9W8K");

var $6aZHE = parcelRequire("6aZHE");

var $gz2Bi = parcelRequire("gz2Bi");
const $02a667cb3800fd5a$var$SimpleTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $byn9U.jsx)((0, $gz2Bi.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $d9W8K.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $byn9U.jsx)((0, $6aZHE.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
var $02a667cb3800fd5a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($02a667cb3800fd5a$var$SimpleTag);

});
parcelRegister("d9W8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $98c5a9f7a5ded4f8$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jFsza = parcelRequire("jFsza");

var $i6wnX = parcelRequire("i6wnX");
const $98c5a9f7a5ded4f8$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $jFsza.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $jFsza.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $jFsza.cssVar).color.background.default})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.default})`,
    cursor: 'default'
});
const $98c5a9f7a5ded4f8$var$interactiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.hover})`
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.active})`
    }
});
const $98c5a9f7a5ded4f8$var$focusRingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px var(${(0, $jFsza.cssVar).color.focusRing})`,
        outline: 'none'
    }
});
const $98c5a9f7a5ded4f8$var$nonStandardLinkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`
    }
});
const $98c5a9f7a5ded4f8$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? $i6wnX.textColors['standardLink'] : $i6wnX.textColors[color];
    const backgroundHoverColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkHoverBackgroundColors[color];
    const backgroundActiveColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkActiveBackgroundColors[color];
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...other,
        ref: ref,
        css: [
            $98c5a9f7a5ded4f8$var$baseStyles,
            (isRemovable || isLink) && $98c5a9f7a5ded4f8$var$focusRingStyles,
            isLink && !isStandardLink && $98c5a9f7a5ded4f8$var$nonStandardLinkStyles,
            isInteractive && $98c5a9f7a5ded4f8$var$interactiveStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.default]: $i6wnX.textColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.hover]: $i6wnX.textHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.active]: $i6wnX.textActiveColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.link]: textLinkColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.default]: $i6wnX.backgroundColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.hover]: backgroundHoverColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.active]: backgroundActiveColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.focusRing]: $i6wnX.focusRingColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.default]: $i6wnX.removeButtonColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.hover]: $i6wnX.removeButtonHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).borderRadius]: $i6wnX.borderRadius[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$98c5a9f7a5ded4f8$export$2e2bcd8739ae039 = $98c5a9f7a5ded4f8$var$BaseTag;

});
parcelRegister("jFsza", function(module, exports) {

$parcel$export(module.exports, "tagHeight", () => $2e837ad2e72491cc$export$5b2b1030a679f37);
$parcel$export(module.exports, "buttonWidthUnitless", () => $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca);
$parcel$export(module.exports, "maxTextWidthUnitless", () => $2e837ad2e72491cc$export$2e3bcb01bf928995);
$parcel$export(module.exports, "maxTextWidth", () => $2e837ad2e72491cc$export$982d4a1a6de11130);
$parcel$export(module.exports, "defaultBorderRadius", () => $2e837ad2e72491cc$export$35d5d1e251b985cf);
$parcel$export(module.exports, "defaultRoundedBorderRadius", () => $2e837ad2e72491cc$export$c49771100fee18c8);
$parcel$export(module.exports, "defaultMargin", () => $2e837ad2e72491cc$export$6728fea658cfb92e);
$parcel$export(module.exports, "defaultTextPadding", () => $2e837ad2e72491cc$export$c2d03c4c68282362);
$parcel$export(module.exports, "textPaddingRight", () => $2e837ad2e72491cc$export$b5686dedf408caa0);
$parcel$export(module.exports, "textMarginLeft", () => $2e837ad2e72491cc$export$b824cac86306f7a2);
$parcel$export(module.exports, "cssVar", () => $2e837ad2e72491cc$export$8b4981022bd80a4e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");
const $2e837ad2e72491cc$var$gridSizeValue = (0, $lcnyw.gridSize)();
const $2e837ad2e72491cc$var$borderRadiusValue = (0, $lcnyw.borderRadius)();
const $2e837ad2e72491cc$export$b4d89c3994664204 = 2.5 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$2e837ad2e72491cc$export$b4d89c3994664204}px`})`;
const $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca = $2e837ad2e72491cc$export$b4d89c3994664204; // button should be square
const $2e837ad2e72491cc$export$aba002ef70684916 = $2e837ad2e72491cc$export$5b2b1030a679f37; // button should be square
const $2e837ad2e72491cc$export$d5949a2c2ea9dcea = 25 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$488fda99655ff65a = `${$2e837ad2e72491cc$export$d5949a2c2ea9dcea}px`;
const $2e837ad2e72491cc$export$2e3bcb01bf928995 = $2e837ad2e72491cc$export$d5949a2c2ea9dcea - $2e837ad2e72491cc$export$b4d89c3994664204;
const $2e837ad2e72491cc$export$982d4a1a6de11130 = `${$2e837ad2e72491cc$export$2e3bcb01bf928995}px`;
const $2e837ad2e72491cc$export$35d5d1e251b985cf = `${$2e837ad2e72491cc$var$borderRadiusValue}px`;
const $2e837ad2e72491cc$export$c49771100fee18c8 = `${$2e837ad2e72491cc$export$c6f3ea2b4cffd0ca / 2}px`;
const $2e837ad2e72491cc$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $2e837ad2e72491cc$var$gridSizeValue}px`})`;
const $2e837ad2e72491cc$export$b824cac86306f7a2 = $2e837ad2e72491cc$export$5b2b1030a679f37;
const $2e837ad2e72491cc$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});

parcelRegister("i6wnX", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $fc0da2a7c84ba49c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "textHoverColors", () => $fc0da2a7c84ba49c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $fc0da2a7c84ba49c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $fc0da2a7c84ba49c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $fc0da2a7c84ba49c$export$2a31dbe82788f940);
$parcel$export(module.exports, "borderRadius", () => $fc0da2a7c84ba49c$export$7a57f79000377ca2);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $fc0da2a7c84ba49c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $fc0da2a7c84ba49c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $fc0da2a7c84ba49c$export$b03fbc2a369c563e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $PdmhA = parcelRequire("PdmhA");

var $jFsza = parcelRequire("jFsza");
const $fc0da2a7c84ba49c$export$daa0ace263cb20d2 = {
    standard: `var(--ds-text, ${$PdmhA.N700})`,
    standardLink: `var(--ds-link, ${$PdmhA.B400})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$7c7104a5f052cab7 = {
    standard: `var(--ds-link, ${$PdmhA.B300})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$382469baad253eb7 = {
    standard: `var(--ds-link-pressed, ${$PdmhA.B300})`,
    blue: `var(--ds-text-accent-blue, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: `var(--ds-text-accent-gray, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue-bolder, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red-bolder, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green-bolder, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple-bolder, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$b9d7c59a579c23c6 = {
    standard: `var(--ds-background-neutral, ${$PdmhA.N20})`,
    blue: `var(--ds-background-accent-blue-subtle, ${$PdmhA.B100})`,
    red: `var(--ds-background-accent-red-subtle, ${$PdmhA.R100})`,
    yellow: `var(--ds-background-accent-yellow-subtle, ${$PdmhA.Y200})`,
    green: `var(--ds-background-accent-green-subtle, ${$PdmhA.G200})`,
    teal: `var(--ds-background-accent-teal-subtle, ${$PdmhA.T200})`,
    purple: `var(--ds-background-accent-purple-subtle, ${$PdmhA.P100})`,
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: `var(--ds-background-accent-gray-subtle, ${$PdmhA.N500})`,
    blueLight: `var(--ds-background-accent-blue-subtler, ${$PdmhA.B75})`,
    redLight: `var(--ds-background-accent-red-subtler, ${$PdmhA.R75})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler, ${$PdmhA.Y100})`,
    greenLight: `var(--ds-background-accent-green-subtler, ${$PdmhA.G100})`,
    tealLight: `var(--ds-background-accent-teal-subtler, ${$PdmhA.T100})`,
    purpleLight: `var(--ds-background-accent-purple-subtler, ${$PdmhA.P75})`,
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: `var(--ds-background-accent-gray-subtler, ${$PdmhA.N30})`
};
const $fc0da2a7c84ba49c$export$4410079763249c74 = {
    standard: `var(--ds-background-neutral-hovered, ${$PdmhA.N30})`,
    blue: `var(--ds-background-accent-blue-subtle-hovered, ${$PdmhA.B75})`,
    red: `var(--ds-background-accent-red-subtle-hovered, ${$PdmhA.R75})`,
    yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$PdmhA.Y100})`,
    green: `var(--ds-background-accent-green-subtle-hovered, ${$PdmhA.G100})`,
    teal: `var(--ds-background-accent-teal-subtle-hovered, ${$PdmhA.T100})`,
    purple: `var(--ds-background-accent-purple-subtle-hovered, ${$PdmhA.P75})`,
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: `var(--ds-background-accent-gray-subtle-hovered, ${$PdmhA.N400})`,
    blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$PdmhA.B50})`,
    redLight: `var(--ds-background-accent-red-subtler-hovered, ${$PdmhA.R50})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$PdmhA.Y75})`,
    greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$PdmhA.G75})`,
    tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$PdmhA.T75})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$PdmhA.P50})`,
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$PdmhA.N40})`
};
const $fc0da2a7c84ba49c$export$76be99c5e13e3566 = {
    standard: `var(--ds-background-neutral-pressed, ${$PdmhA.N30})`,
    blue: `var(--ds-background-accent-blue-subtle-pressed, ${$PdmhA.B50})`,
    red: `var(--ds-background-accent-red-subtle-pressed, ${$PdmhA.R50})`,
    yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$PdmhA.Y75})`,
    green: `var(--ds-background-accent-green-subtle-pressed, ${$PdmhA.G75})`,
    teal: `var(--ds-background-accent-teal-subtle-pressed, ${$PdmhA.T75})`,
    purple: `var(--ds-background-accent-purple-subtle-pressed, ${$PdmhA.P50})`,
    grey: `var(--ds-background-accent-gray-subtle-pressed, ${$PdmhA.N300})`,
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$PdmhA.B100})`,
    redLight: `var(--ds-background-accent-red-subtler-pressed, ${$PdmhA.R100})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$PdmhA.Y200})`,
    greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$PdmhA.G200})`,
    tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$PdmhA.T200})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$PdmhA.P100})`,
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$PdmhA.N50})`
};
const $fc0da2a7c84ba49c$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$PdmhA.B100})`;
const $fc0da2a7c84ba49c$export$7a57f79000377ca2 = {
    default: (0, $jFsza.defaultBorderRadius),
    rounded: (0, $jFsza.defaultRoundedBorderRadius)
};
const $fc0da2a7c84ba49c$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$PdmhA.R50})`;
const $fc0da2a7c84ba49c$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$PdmhA.R50})`;
const $fc0da2a7c84ba49c$export$17d206ccea111bbb = `var(--ds-text-danger, ${$PdmhA.R500})`;
const $fc0da2a7c84ba49c$export$f64c7641cbc22da7 = {
    standard: `var(--ds-text, ${$PdmhA.N500})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N500})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N500})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N500})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N500})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N500})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N500})`,
    lime: `var(--ds-text-accent-lime-bolder, ${$PdmhA.N500})`,
    magenta: `var(--ds-text-accent-magenta-bolder, ${$PdmhA.N500})`,
    orange: `var(--ds-text-accent-orange-bolder, ${$PdmhA.N500})`,
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N500})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.N500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.N500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.N500})`,
    limeLight: `var(--ds-text-accent-lime, ${$PdmhA.N500})`,
    magentaLight: `var(--ds-text-accent-magenta, ${$PdmhA.N500})`,
    orangeLight: `var(--ds-text-accent-orange, ${$PdmhA.N500})`,
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$b03fbc2a369c563e = {
    standard: `var(--ds-text-danger, ${$PdmhA.N700})`,
    standardLink: `var(--ds-text-danger, ${$PdmhA.B400})`,
    blue: `var(--ds-text-danger, ${$PdmhA.N800})`,
    red: `var(--ds-text-danger, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-danger, ${$PdmhA.N800})`,
    green: `var(--ds-text-danger, ${$PdmhA.N800})`,
    teal: `var(--ds-text-danger, ${$PdmhA.N800})`,
    purple: `var(--ds-text-danger, ${$PdmhA.N800})`,
    lime: `var(--ds-text-danger, ${$PdmhA.N800})`,
    magenta: `var(--ds-text-danger, ${$PdmhA.N800})`,
    orange: `var(--ds-text-danger, ${$PdmhA.N800})`,
    grey: `var(--ds-text-danger, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-danger, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-danger, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    limeLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    magentaLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    orangeLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    greyLight: `var(--ds-text-danger, ${$PdmhA.N500})`
};

});


parcelRegister("6aZHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $70eddb948b5989f5$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $jFsza = parcelRequire("jFsza");
const $70eddb948b5989f5$var$beforeElementStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    insetBlockStart: "var(--ds-space-0, 0px)"
});
const $70eddb948b5989f5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $70eddb948b5989f5$var$beforeElementStyles
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$70eddb948b5989f5$export$2e2bcd8739ae039 = $70eddb948b5989f5$var$Before;

});

parcelRegister("gz2Bi", function(module, exports) {

$parcel$export(module.exports, "default", () => $154b7edc63fec879$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $jFsza = parcelRequire("jFsza");
const $154b7edc63fec879$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $jFsza.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $jFsza.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $154b7edc63fec879$var$linkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.link})`,
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.hover})`,
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`,
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
const $154b7edc63fec879$var$hasAfterStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $jFsza.maxTextWidthUnitless) - (0, $jFsza.buttonWidthUnitless)}px`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.textPaddingRight)
});
const $154b7edc63fec879$var$hasBeforeStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $jFsza.textMarginLeft)
});
const $154b7edc63fec879$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $byn9U.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            $154b7edc63fec879$var$baseStyles,
            $154b7edc63fec879$var$linkStyles,
            elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && $154b7edc63fec879$var$hasAfterStyles
        ]
    }, text);
    else return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $154b7edc63fec879$var$baseStyles,
            elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && $154b7edc63fec879$var$hasAfterStyles
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$154b7edc63fec879$export$2e2bcd8739ae039 = $154b7edc63fec879$var$Content;

});


parcelRegister("cAKIH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b674095defbc4ab$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $8b674095defbc4ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8b674095defbc4ab$var$baseStyles = {
    name: "1pwt1s8",
    styles: "display:flex;width:100%;flex-wrap:wrap"
};
const $8b674095defbc4ab$var$justifyStartStyles = {
    name: "11g6mpt",
    styles: "justify-content:flex-start"
};
const $8b674095defbc4ab$var$justifyEndStyles = {
    name: "1f60if8",
    styles: "justify-content:flex-end"
};
/**
 * __Tag group__
 *
 * A tag group controls the layout and alignment for a collection of tags.
 *
 * - [Examples](https://atlassian.design/components/tag-group/examples)
 * - [Code](https://atlassian.design/components/tag-group/code)
 * - [Usage](https://atlassian.design/components/tag-group/usage)
 */ const $8b674095defbc4ab$var$TagGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ alignment: alignment = 'start', children: children }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref,
        css: [
            $8b674095defbc4ab$var$baseStyles,
            alignment === 'start' && $8b674095defbc4ab$var$justifyStartStyles,
            alignment === 'end' && $8b674095defbc4ab$var$justifyEndStyles
        ]
    }, children);
});
var $8b674095defbc4ab$export$2e2bcd8739ae039 = $8b674095defbc4ab$var$TagGroup;

});

parcelRegister("bXJdt", function(module, exports) {

$parcel$export(module.exports, "default", () => $900ad349a1e245ed$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $900ad349a1e245ed$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showAll: {
        "id": "issue.tag-view.show-all",
        "defaultMessage": "Show all {peopleCount, plural, few {# people} many {# people} other {# people}}"
    },
    showLess: {
        "id": "issue.tag-view.show-less",
        "defaultMessage": "Show less"
    }
});

});


parcelRegister("aUPgM", function(module, exports) {

$parcel$export(module.exports, "default", () => $296ba427887aec85$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aBv1q = parcelRequire("aBv1q");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");

var $gJA1m = parcelRequire("gJA1m");
function $296ba427887aec85$export$2e2bcd8739ae039(props) {
    const { invalidMessage: invalidMessage, options: options, placeholder: placeholder, onChange: onChange, value: value } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJA1m.default), {
        validationState: invalidMessage != null ? 'error' : null,
        validationMessage: invalidMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBv1q.default), {
        options: options,
        placeholder: placeholder,
        // @ts-expect-error - TS2322 - Type '(arg1: CheckboxValueItemShape[]) => void' is not assignable to type '(value: OptionsType<OptionType>, action: ActionMeta<OptionType>) => void'.
        onChange: onChange,
        value: value,
        tabSelectsValue: false,
        autoFocus: true,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $c9TLT.layers).modal
                }),
            menu: (base)=>({
                    ...base,
                    zIndex: (0, $c9TLT.layers).modal
                })
        },
        spacing: (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i') ? 'compact' : 'default'
    }));
}
$296ba427887aec85$export$2e2bcd8739ae039.defaultProps = {
    value: [],
    options: [],
    placeholder: null,
    invalidMessage: null
};
$296ba427887aec85$export$2e2bcd8739ae039.displayName = 'CheckboxFieldView';

});
parcelRegister("aBv1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b856c6b039243e9$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $4zgIJ = parcelRequire("4zgIJ");

var $aVlxK = parcelRequire("aVlxK");
const $7b856c6b039243e9$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $eUqFw.useMemo)(()=>({
            ...components,
            Option: (0, $aVlxK.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), (0, $kU09D.default)({
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true
    }, props, {
        components: mergedComponents
    }));
};
const $7b856c6b039243e9$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo($7b856c6b039243e9$var$CheckboxSelectInternal);
var $7b856c6b039243e9$export$2e2bcd8739ae039 = $7b856c6b039243e9$var$CheckboxSelect;

});
parcelRegister("aVlxK", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $7f3ff04e428d930c$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $7f3ff04e428d930c$export$82ab7168879267a7);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $c6Z6Z = parcelRequire("c6Z6Z");

var $hSJ9G = parcelRequire("hSJ9G");

var $PdmhA = parcelRequire("PdmhA");
const $7f3ff04e428d930c$var$getPrimitiveStyles = (props)=>{
    const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
    const baseStyles = {
        alignItems: 'center',
        backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N20})` : 'transparent',
        color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
        display: 'flex ',
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-200, 16px)",
        paddingTop: "var(--ds-space-050, 4px)",
        // This 'none' needs to be present to ensure that style is not applied when
        // the option is selected but not focused.
        boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $PdmhA.B400})`}` : 'none',
        ':active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $PdmhA.N30)})`
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: isFocused ? '2px solid transparent' : ''
        }
    };
    const augmentedStyles = (0, $byn9U.css)({
        ...getStyles('option', props),
        ...baseStyles
    });
    const bemClasses = {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    };
    // maintain react-select API
    return [
        augmentedStyles,
        cx(bemClasses, className)
    ];
};
// state of the parent option
// the primary color represents the outer or background element
const $7f3ff04e428d930c$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $PdmhA.B75})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $PdmhA.N20A})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $PdmhA.B75})`;
    else if (isActive) return `var(--ds-background-selected-pressed, ${0, $PdmhA.B75})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $PdmhA.B300})`;
    else if (isFocused) return `var(--ds-surface, ${0, $PdmhA.N0})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $PdmhA.B400})`;
    return `var(--ds-background-neutral, ${0, $PdmhA.N0})`;
};
// the secondary color represents the radio dot or checkmark
const $7f3ff04e428d930c$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
    else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $PdmhA.B400})`;
    else if (!isSelected) return 'transparent';
    return `var(--ds-surface, ${0, $PdmhA.N0})`;
};
// the border color surrounds the checkbox/radio
const $7f3ff04e428d930c$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $PdmhA.B400})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $PdmhA.N100})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $PdmhA.B400})`;
    else if (isActive) return `var(--ds-background-selected-bold, ${0, $PdmhA.B400})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $PdmhA.B400})`;
    else if (isFocused) return `var(--ds-border-input, ${0, $PdmhA.N100})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $PdmhA.B400})`;
    return `var(--ds-border-input, ${0, $PdmhA.N100})`;
};
const $7f3ff04e428d930c$var$baseIconStyles = (0, $byn9U.css)({
    alignItems: 'center',
    display: 'flex ',
    flexShrink: 0,
    paddingInlineEnd: "var(--ds-space-050, 4px)",
    // Here we are adding a border to the Checkbox and Radio SVG icons
    // This is an a11y fix for Select only for now but it may be rolled
    // into the `@atlaskit/icon` package's Checkbox and Radio SVGs later
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& svg rect, & svg circle:first-of-type': {
        strokeWidth: "var(--ds-border-width, 1px)",
        strokeLinejoin: 'round'
    }
});
const $7f3ff04e428d930c$var$baseOptionStyles = (0, $byn9U.css)({
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
    flexGrow: 1,
    whiteSpace: 'nowrap'
});
class $7f3ff04e428d930c$var$ControlOption extends (0, $eUqFw.Component) {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            isActive: false
        });
        (0, $5zQU9.default)(this, "onMouseDown", ()=>this.setState({
                isActive: true
            }));
        (0, $5zQU9.default)(this, "onMouseUp", ()=>this.setState({
                isActive: false
            }));
        (0, $5zQU9.default)(this, "onMouseLeave", ()=>this.setState({
                isActive: false
            }));
    }
    render() {
        const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
        // prop assignment
        const props = {
            ...innerProps,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseLeave: this.onMouseLeave
        };
        const [styles, classes] = $7f3ff04e428d930c$var$getPrimitiveStyles({
            getStyles: getStyles,
            ...rest
        });
        return(// These need to remain this way because `react-select` passes props with
        // styles inside, and that must be done dynamically.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        (0, $byn9U.jsx)("div", (0, $kU09D.default)({
            css: styles,
            className: classes,
            ref: innerRef
        }, props), (0, $byn9U.jsx)("div", {
            css: [
                $7f3ff04e428d930c$var$baseIconStyles,
                // Here we are adding a border to the Checkbox and Radio SVG icons
                // This is an a11y fix for Select only for now but it may be rolled
                // into the `@atlaskit/icon` package's Checkbox and Radio SVGs later
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                {
                    // This can eventually be changed to static styles that are
                    // applied conditionally (e.g. `isActive && activeBorderStyles`),
                    // but considering there are multiple instances of `react-select`
                    // requiring styles to be generated dynamically, it seemed like a
                    // low priority.
                    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
                    '& svg rect, & svg circle:first-of-type': {
                        stroke: $7f3ff04e428d930c$var$getBorderColor({
                            ...this.props,
                            ...this.state
                        })
                    }
                }
            ]
        }, !!Icon ? (0, $byn9U.jsx)(Icon, {
            label: "",
            primaryColor: $7f3ff04e428d930c$var$getPrimaryColor({
                ...this.props,
                ...this.state
            }),
            secondaryColor: $7f3ff04e428d930c$var$getSecondaryColor({
                ...this.props,
                ...this.state
            })
        }) : null), (0, $byn9U.jsx)("div", {
            css: $7f3ff04e428d930c$var$baseOptionStyles
        }, children)));
    }
}
const $7f3ff04e428d930c$export$d40cc97ecda916f9 = (props)=>(0, $byn9U.jsx)($7f3ff04e428d930c$var$ControlOption, (0, $kU09D.default)({
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hSJ9G)))
    }, props));
const $7f3ff04e428d930c$export$82ab7168879267a7 = (props)=>(0, $byn9U.jsx)($7f3ff04e428d930c$var$ControlOption, (0, $kU09D.default)({
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c6Z6Z)))
    }, props));

});
parcelRegister("c6Z6Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02468a1d390d1515$var$_react = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $02468a1d390d1515$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $02468a1d390d1515$var$RadioIcon = (props)=>/*#__PURE__*/ $02468a1d390d1515$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="6"/><circle fill="inherit" cx="12" cy="12" r="2"/></g></svg>`
    }, props));
$02468a1d390d1515$var$RadioIcon.displayName = 'RadioIcon';
var $02468a1d390d1515$var$_default = $02468a1d390d1515$var$RadioIcon;
module.exports.default = $02468a1d390d1515$var$_default;

});

parcelRegister("hSJ9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d04a81b304c826a5$var$_react = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d04a81b304c826a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d04a81b304c826a5$var$CheckboxIcon = (props)=>/*#__PURE__*/ $d04a81b304c826a5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect fill="currentColor" x="6" y="6" width="12" height="12" rx="2"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>`
    }, props));
$d04a81b304c826a5$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $d04a81b304c826a5$var$_default = $d04a81b304c826a5$var$CheckboxIcon;
module.exports.default = $d04a81b304c826a5$var$_default;

});



parcelRegister("gJA1m", function(module, exports) {

$parcel$export(module.exports, "default", () => $e964dbd17683650e$export$2e2bcd8739ae039);
/* select-validation-wrapper.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $96IgR = parcelRequire("96IgR");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e964dbd17683650e$var$NoticeContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _19pk1b66",
            __cmplp.className
        ])
    });
});
const $e964dbd17683650e$var$NoticeLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { colour: colour, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_lz0eeo": (0, $9t7rW.default)(__cmplp.colour)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66",
            __cmplp.colour && "_syazcnz6",
            __cmplp.className
        ])
    });
});
const $e964dbd17683650e$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { colour: colour, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1mvk55v": (0, $9t7rW.default)(__cmplp.colour)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazt84y",
            __cmplp.className
        ])
    });
});
const $e964dbd17683650e$var$getTheme = (theme)=>{
    switch(theme){
        case 'error':
            return {
                iconColor: `var(--ds-text-danger, ${(0, $PdmhA).R400})`,
                textColor: `var(--ds-text-danger, ${(0, $PdmhA).R400})`,
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($96IgR)))
            };
        case 'warning':
            return {
                iconColor: `var(--ds-text-warning, ${(0, $PdmhA).Y400})`,
                textColor: null,
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl)))
            };
        case 'success':
        case 'default':
        default:
            return {
                iconColor: null,
                textColor: null,
                Icon: null
            };
    }
};
/**
 * Wrap a Select (or similar) component with an optional error message
 */ const $e964dbd17683650e$var$SelectValidationWrapper = ({ children: children = null, validationState: validationState = 'default', validationMessage: validationMessage = null })=>{
    const { textColor: textColor, iconColor: iconColor, Icon: Icon } = $e964dbd17683650e$var$getTheme(validationState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children, validationState && validationMessage ? // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e964dbd17683650e$var$NoticeContainer, {
        "data-testid": "select-validation-wrapper__notice_container"
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e964dbd17683650e$var$IconContainer, {
        colour: iconColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        label: `${validationState} icon`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e964dbd17683650e$var$NoticeLabel, {
        colour: textColor
    }, validationMessage)) : null);
};
var $e964dbd17683650e$export$2e2bcd8739ae039 = $e964dbd17683650e$var$SelectValidationWrapper;

});


parcelRegister("i0V1V", function(module, exports) {

$parcel$export(module.exports, "InlineEditContainer", () => $f9215da350f594d9$export$9f16bbb9a44c7bf6);
/* checkbox-inline-edit-view.styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5St1r = parcelRequire("5St1r");
const $f9215da350f594d9$export$9f16bbb9a44c7bf6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5St1r.InlineEditContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f3ftgi",
            __cmplp.hasValue ? "_osjg1y44 _2g9bidpf _alyv1y44 _pa3xidpf" : "_osjg1v6z _2g9bidpf _alyv1v6z _pa3xidpf",
            !__cmplp.isEditable && "_18u0idpf _1bchdlk8 _1yb1idpf _79pai2wt _1rhwidpf _15x6idpf _1jwgidpf _f8uyidpf _1q81idpf _bhqsidpf",
            __cmplp.className
        ])
    });
});

});


parcelRegister("huhk2", function(module, exports) {

$parcel$export(module.exports, "genericMessages", () => $5fedb0b7239ddcaa$export$9c77590897927208);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $5fedb0b7239ddcaa$export$9c77590897927208 = (0, $90IgZ.defineMessages)({
    noValue: {
        "id": "issue.context-items.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "None"
    },
    version_no_value_placeholder: {
        "id": "issue.version.text-no-value",
        "defaultMessage": "Select version"
    }
});

});

parcelRegister("4kDvN", function(module, exports) {

$parcel$export(module.exports, "withExtraOwnProps", () => $a37e566eb02c189e$export$37271e30e798fa7f);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $6rkLV = parcelRequire("6rkLV");
const $a37e566eb02c189e$export$37271e30e798fa7f = (WrappedComponent)=>(props)=>{
        const { fieldId: fieldId } = props;
        const issueKey = (0, $hJ992.useIssueKey)();
        const [allowedValuesOverrides] = (0, $6rkLV.useFieldOptionsOverrides)({
            issueKey: issueKey,
            fieldKey: fieldId
        });
        const extraOwnProps = (0, $eUqFw.useMemo)(()=>({
                allowedValuesOverrides: allowedValuesOverrides
            }), [
            allowedValuesOverrides
        ]);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            extraOwnProps: extraOwnProps
        });
    };

});

parcelRegister("8WZQM", function(module, exports) {

$parcel$export(module.exports, "filterAllowedValues", () => $3cba0a3a98367386$export$b8e47574e10966bc);
const $3cba0a3a98367386$export$b8e47574e10966bc = (suggestions, allowedValuesOverrides)=>{
    if (!allowedValuesOverrides || !Array.isArray(allowedValuesOverrides.ids)) return suggestions;
    return suggestions.filter((value)=>{
        // stringify because multi-select and single-select id can be of type number.
        const id = `${value.id}`;
        const isValueInIds = allowedValuesOverrides.ids.includes(id);
        if (allowedValuesOverrides.operation === 'EXCLUDE') return !isValueInIds;
        return isValueInIds;
    });
};

});

parcelRegister("3Q8Tr", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $b7a764d0c051b128$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $b7a764d0c051b128$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformSuggestions", () => $b7a764d0c051b128$export$1d0ee4320c26fb60);
const $b7a764d0c051b128$var$toItem = (fieldData)=>({
        label: fieldData.value,
        value: fieldData.id
    });
const $b7a764d0c051b128$export$cb172b2468ab5652 = (value)=>value ? value.map($b7a764d0c051b128$var$toItem) : [];
const $b7a764d0c051b128$export$1cfcb95cb8fbddb3 = (value)=>value && value.map((item)=>({
            id: item.value,
            value: item.label
        }));
const $b7a764d0c051b128$export$1d0ee4320c26fb60 = (suggestions)=>suggestions && suggestions.map($b7a764d0c051b128$var$toItem) || [];

});


parcelRegister("cQ19t", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b119661b0ba0e44$export$2e2bcd8739ae039);

var $jBy23 = parcelRequire("jBy23");

var $cklpP = parcelRequire("cklpP");

var $3uwfp = parcelRequire("3uwfp");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");
var $3b119661b0ba0e44$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, { fieldId: fieldId, area: area })=>({
        fieldId: fieldId,
        // @ts-expect-error - TS2322 - Type '(state: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => { ...; }' is not assignable to type 'AdditionalProps<unknown>'.
        additionalProps: (state)=>{
            const field = (0, $fokFV.fieldSelector)(fieldId)(state) || {};
            const issueKey = (0, $5JqpU.issueKeySelector)(state);
            const issueId = (0, $5JqpU.issueIdSelector)(state);
            return {
                area: area,
                issueKey: issueKey,
                issueId: issueId,
                projectKey: (0, $jBy23.extractProjectKey)(issueKey),
                // @ts-expect-error - TS2339 - Property 'configuration' does not exist on type '{}'.
                cmdbFieldConfig: field.configuration?.cmdbFieldConfig,
                // @ts-expect-error - TS2339 - Property 'configuration' does not exist on type '{}'.
                wasInsightRequestSuccessful: field.configuration?.wasInsightRequestSuccessful,
                source: 'insight'
            };
        }
    }))((0, $cklpP.AsyncIssueCmdbObjectFieldWithBoundary));

});
parcelRegister("cklpP", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueCmdbObjectFieldWithBoundary", () => $20952ec2ba76c42e$export$fbbe105f84bf875a);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

const $20952ec2ba76c42e$export$fb235f7305ccfbe2 = (0, $7rh0R.lazy)(()=>(parcelRequire("034Qs")).then((module)=>module.CmdbObjectMain), {
    moduleId: "./src/packages/issue/fields/cmdb-object/src/ui/main.tsx"
});
const $20952ec2ba76c42e$export$3aec5f2bf46a2f14 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-field-cmdb-object",
        packageName: "jira-issue-field-cmdb-object"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-field-cmdb-object-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($20952ec2ba76c42e$export$fb235f7305ccfbe2, props)));
const $20952ec2ba76c42e$export$9ed1027984f913a8 = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "flag",
        id: "issue-cmdb-object-field",
        packageName: packageName
    }, children);
const $20952ec2ba76c42e$export$fbbe105f84bf875a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($20952ec2ba76c42e$export$9ed1027984f913a8, {
        packageName: "issue-cmdb-object"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($20952ec2ba76c42e$export$3aec5f2bf46a2f14, props));

});
parcelRegister("034Qs", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('eS49s')
        ]);
        const value = parcelRequire('lOnKp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("eS49s")
    ]).then(()=>parcelRequire('lOnKp'));
}

});



parcelRegister("2Wayk", function(module, exports) {

$parcel$export(module.exports, "default", () => $87bad1444c90805d$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $5iWql = parcelRequire("5iWql");

var $2jDha = parcelRequire("2jDha");

var $gyj10 = parcelRequire("gyj10");

var $gUUjF = parcelRequire("gUUjF");

var $jD201 = parcelRequire("jD201");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $giAhk = parcelRequire("giAhk");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $jMP2a = parcelRequire("jMP2a");

var $kltWb = parcelRequire("kltWb");

var $edqXu = parcelRequire("edqXu");

var $5j4EJ = parcelRequire("5j4EJ");

var $lMkmi = parcelRequire("lMkmi");
const $87bad1444c90805d$var$rankComponents = (0, $5iWql.default)((suggestion, issueId, projectId, sessionId, createAnalyticsEvent)=>(0, $kltWb.default)(suggestion, issueId, projectId, sessionId, createAnalyticsEvent));
const $87bad1444c90805d$var$fetchSuggestionsFactory = (0, $5iWql.default)((intl, suggestions, issueId, projectId, createAnalyticsEvent, projectKey)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    async (query, sessionId)=>{
        const isCompassComponentsPageReworkEnabled = (0, $1ybV0.ff)('compass-components-in-jira-components_xw42u', false);
        const pGlobalComponentsProperty = isCompassComponentsPageReworkEnabled ? (0, $jD201.getGlobalComponentsProperty)(projectKey) : Promise.resolve({
            value: false
        });
        const pRankedComponents = $87bad1444c90805d$var$rankComponents(suggestions, issueId, projectId, sessionId, createAnalyticsEvent);
        const [globalComponentsProperty, rankedComponents, cachedComponents] = await Promise.all([
            pGlobalComponentsProperty,
            pRankedComponents,
            (0, $gyj10.default).getAll()
        ]);
        const globalComponentsEnabled = globalComponentsProperty.value === true;
        return (0, $5j4EJ.transformSuggestionsFromServerAndCache)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        rankedComponents, globalComponentsEnabled ? [] : cachedComponents, intl, projectKey);
    });
const $87bad1444c90805d$var$countAddedAndRemovedComponents = (stateComponents)=>{
    const { value: existingComponents, pendingValue: pendingComponents } = stateComponents;
    const componentCounts = {
        addedCompass: 0,
        removedCompass: 0,
        addedJira: 0,
        removedJira: 0
    };
    const idMap = (components)=>new Map(components.map((comp)=>[
                comp.id,
                comp
            ]));
    const existingIdMap = idMap(existingComponents);
    const pendingIdMap = idMap(pendingComponents);
    const updateCounts = (component, added)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const key = `${added ? 'added' : 'removed'}${component.ari === undefined || component.ari === null ? 'Jira' : 'Compass'}`;
        componentCounts[key]++;
    };
    existingComponents.forEach((comp)=>{
        if (!pendingIdMap.has(comp.id)) updateCounts(comp, false);
    });
    pendingComponents.forEach((comp)=>{
        if (!existingIdMap.has(comp.id)) updateCounts(comp, true);
    });
    return componentCounts;
};
const $87bad1444c90805d$var$saveField = (// @ts-expect-error - TS7031 - Binding element 'baseUrl' implicitly has an 'any' type. | TS7031 - Binding element 'issueKey' implicitly has an 'any' type. | TS7031 - Binding element 'fieldMetaKey' implicitly has an 'any' type. | TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'fieldEditSessionId' implicitly has an 'any' type.
{ baseUrl: baseUrl, issueKey: issueKey, fieldMetaKey: fieldMetaKey, value: value, fieldEditSessionId: fieldEditSessionId }, state, // @ts-expect-error - TS7006 - Parameter 'ownPropsOnMount' implicitly has an 'any' type.
ownPropsOnMount)=>{
    const url = fieldEditSessionId !== undefined ? `${baseUrl}/rest/api/2/issue/${issueKey}?fieldEditSessionId=${fieldEditSessionId}` : `${baseUrl}/rest/api/2/issue/${issueKey}`;
    const projectKey = (0, $5JqpU.projectKeySelector)(state);
    // @ts-expect-error - TS7006 - Parameter 'current' implicitly has an 'any' type.
    value.forEach((current)=>{
        try {
            if (ownPropsOnMount.createAnalyticsEvent) (0, $jMP2a.fireOperationalAnalytics)(ownPropsOnMount.createAnalyticsEvent({}), 'componentPickerCache set', {
                isFromCache: current.fromCache
            });
            current.id && (0, $gyj10.default).set(`${current.id}`, {
                ...current,
                projectKey: projectKey
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-view.components.cache.set', error.message);
        }
    });
    return (0, $lRmyA.performPutRequest)(url, {
        body: JSON.stringify({
            fields: {
                [fieldMetaKey]: value
            }
        })
    }).then(()=>{
        if (ownPropsOnMount.createAnalyticsEvent && (0, $1ybV0.ff)('compass-components-in-jira-components_xw42u') === true) (0, $jMP2a.fireTrackAnalytics)(ownPropsOnMount.createAnalyticsEvent({}), 'componentField updated', {
            componentCounts: $87bad1444c90805d$var$countAddedAndRemovedComponents(state.fields.components)
        });
    }).catch((error)=>{
        // @ts-expect-error - TS7006 - Parameter 'current' implicitly has an 'any' type.
        value.forEach((current)=>{
            try {
                if (ownPropsOnMount.createAnalyticsEvent) (0, $jMP2a.fireOperationalAnalytics)(ownPropsOnMount.createAnalyticsEvent({}), 'componentPickerCache removed');
                current.id && (0, $gyj10.default).remove(`${current.id}`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-view.components.cache.remove', e.message);
            }
        });
        throw error;
    });
};
// @ts-expect-error - TS7006 - Parameter 'ownPropsOnMount' implicitly has an 'any' type.
const $87bad1444c90805d$var$getConnectedComponentProps = (ownPropsOnMount)=>{
    // use memoized factory in the absence of redux-thunk
    const getDataFromCacheFactory = (0, $5iWql.default)((projectKey)=>()=>(0, $gyj10.default).getAll().then((components)=>(0, $5j4EJ.transformSuggestionsFromServerAndCache)([], components, ownPropsOnMount.intl, projectKey)));
    return {
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $5j4EJ.transformFromStateValue,
        transformToStateValue: $5j4EJ.transformToStateValue,
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type. | TS7006 - Parameter 'intl' implicitly has an 'any' type.
        additionalProps: (state, intl)=>({
                baseUrl: (0, $5JqpU.baseUrlSelector)(state),
                projectKey: (0, $5JqpU.projectKeySelector)(state),
                isMobile: (0, $5JqpU.isMobileSelector)(state),
                fetchSuggestions: $87bad1444c90805d$var$fetchSuggestionsFactory(intl, (0, $fokFV.fieldAllowedValuesSelector)(ownPropsOnMount.fieldId)(state), (0, $5JqpU.issueIdSelector)(state), (0, $jZDJX.projectIdSelector)(state), ownPropsOnMount.createAnalyticsEvent, (0, $5JqpU.projectKeySelector)(state)),
                placeholder: intl.formatMessage((0, $edqXu.default).placeholder),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                shouldShowFooter: ((0, $9F6MO.canAdministerProjectPermissionsSelector)(state) || (0, $9F6MO.canAdministerJiraPermissionsSelector)(state)) && !(0, $5JqpU.isMobileSelector)(state),
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area),
                getDataFromCache: getDataFromCacheFactory((0, $5JqpU.projectKeySelector)(state))
            }),
        // @ts-expect-error - TS2345 - Argument of type 'SaveFieldArguments<unknown>' is not assignable to parameter of type '{ baseUrl: any; issueKey: any; fieldMetaKey: any; value: any; fieldEditSessionId: any; }'.
        saveField: (...args)=>$87bad1444c90805d$var$saveField(...args, ownPropsOnMount)
    };
};
var $87bad1444c90805d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $giAhk.injectIntlV2), (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>$87bad1444c90805d$var$getConnectedComponentProps(ownPropsOnMount)), (0, $2jDha.default)())((0, $lMkmi.View));

});
parcelRegister("gyj10", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f5d6a8cf5cca0c$export$2e2bcd8739ae039);

var $jhVpU = parcelRequire("jhVpU");

var $3bIxc = parcelRequire("3bIxc");
var $59f5d6a8cf5cca0c$export$2e2bcd8739ae039 = (0, $jhVpU.default)((0, $3bIxc.props));

});
parcelRegister("jhVpU", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a98829846b4116$export$2e2bcd8739ae039);

var $kBiqn = parcelRequire("kBiqn");
const $47a98829846b4116$var$pNothing = ()=>Promise.resolve();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$47a98829846b4116$export$2e2bcd8739ae039 = (config)=>{
    {
        const Cache = (0, $kBiqn.default)(config);
        const getAll = ()=>Cache.then((cache)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
        const get = (key)=>Cache.then((cache)=>cache.get(key));
        const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
        const remove = (key)=>Cache.then((cache)=>cache.delete(key));
        const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
        const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
        const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Promise.all(entries.map(([key])=>cache.delete(key)))) // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .then(()=>{}));
        return {
            get: get,
            getAll: getAll,
            set: set,
            remove: remove,
            update: update,
            refresh: refresh,
            clearAll: clearAll
        };
    }
    return {
        // @ts-expect-error - TS2322 - Type '() => Promise<void>' is not assignable to type '(key: string) => Promise<C | undefined>'.
        get: $47a98829846b4116$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getAll: ()=>Promise.resolve([]),
        set: ()=>Promise.resolve(),
        remove: $47a98829846b4116$var$pNothing,
        update: $47a98829846b4116$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refresh: ()=>Promise.resolve([]),
        clearAll: $47a98829846b4116$var$pNothing
    };
};

});
parcelRegister("kBiqn", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $32f02625ea3a7ccc$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $32f02625ea3a7ccc$export$2e2bcd8739ae039);

var $aZaPn = parcelRequire("aZaPn");
var $89bO2 = parcelRequire("89bO2");

var $gUUjF = parcelRequire("gUUjF");


var $48k9t = parcelRequire("48k9t");
const $32f02625ea3a7ccc$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $32f02625ea3a7ccc$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $48k9t.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $32f02625ea3a7ccc$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $32f02625ea3a7ccc$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)) storage = (0, $aZaPn.createLocalStorageProvider)((0, $48k9t.CACHE_PREFIX));
        else storage = (0, $89bO2.createSessionStorageProvider)((0, $48k9t.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $834cc2f16be60bc5$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $834cc2f16be60bc5$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $gUUjF.default).safeWarnWithoutCustomerData((0, $834cc2f16be60bc5$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $834cc2f16be60bc5$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $834cc2f16be60bc5$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $48k9t.default).scopes.current !== (0, $48k9t.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32f02625ea3a7ccc$var$cacheMap = {};
const $32f02625ea3a7ccc$var$getCache = async (props)=>{
    await (0, $48k9t.scopeGuard)().catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $32f02625ea3a7ccc$var$cacheMap[cacheKey] = $32f02625ea3a7ccc$var$cacheMap[cacheKey] || new $32f02625ea3a7ccc$export$94affb487e701bf2(props);
    return $32f02625ea3a7ccc$var$cacheMap[cacheKey];
};
const $32f02625ea3a7ccc$export$710d301bf26d9700 = ()=>{
    Object.values($32f02625ea3a7ccc$var$cacheMap).forEach((cache)=>cache.clear());
};
var $32f02625ea3a7ccc$export$2e2bcd8739ae039 = $32f02625ea3a7ccc$var$getCache;

});
const $834cc2f16be60bc5$export$7271276960377470 = 'common-cache';
const $834cc2f16be60bc5$export$a61768fefd33fcb1 = 'capacity exceeded';
const $834cc2f16be60bc5$export$6c4d37c7f376a1de = 'clear';
const $834cc2f16be60bc5$export$e271b26eefe41db8 = 'update';
const $834cc2f16be60bc5$export$4bd2facc4a3e6aa1 = 'delete';
const $834cc2f16be60bc5$export$26d12233004a7a60 = 'delete stale entry';
const $834cc2f16be60bc5$export$1bb358554aac31c1 = 'get';
const $834cc2f16be60bc5$export$61f74127e2b53cbe = 'hydrate';
const $834cc2f16be60bc5$export$5e8f180ef0142226 = 'set';
const $834cc2f16be60bc5$export$9eb68924983e00fb = 'get entries';
const $834cc2f16be60bc5$export$bf340b99118a1511 = 'memory';
const $834cc2f16be60bc5$export$2670cb7d5d4f7184 = 'local';
const $834cc2f16be60bc5$export$b796061ff0c82e1a = 'session';

parcelRegister("48k9t", function(module, exports) {

$parcel$export(module.exports, "CACHE_PREFIX", () => $619b603377692131$export$69ca515e4489d790);
$parcel$export(module.exports, "scopeGuard", () => $619b603377692131$export$653cd03438bb0386);
$parcel$export(module.exports, "default", () => $619b603377692131$export$2e2bcd8739ae039);

var $aZaPn = parcelRequire("aZaPn");
let $619b603377692131$var$resolveCachePromise;
const $619b603377692131$var$cachePromise = new Promise((resolve)=>{
    $619b603377692131$var$resolveCachePromise = resolve;
});
const $619b603377692131$export$27be962d708928a = '__scope_key__';
const $619b603377692131$export$69ca515e4489d790 = 'cache_prefix';
const $619b603377692131$var$TIMEOUT = 10000;
const $619b603377692131$var$promiseWithMaxExecutionTime = (ms, promise)=>{
    let id;
    const timeout = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        id = setTimeout(()=>{
            const storage = (0, $aZaPn.createLocalStorageProvider)($619b603377692131$export$69ca515e4489d790);
            storage.clearAll();
            reject(new Error(`Cache scope was not set within ${$619b603377692131$var$TIMEOUT}ms`));
        }, ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).then((result)=>{
        clearTimeout(id);
        return result;
    });
};
const $619b603377692131$export$653cd03438bb0386 = ()=>$619b603377692131$var$promiseWithMaxExecutionTime($619b603377692131$var$TIMEOUT, $619b603377692131$var$cachePromise);
const $619b603377692131$var$config = {
    devTools: false,
    scopes: {
        prev: null,
        current: null
    },
    set (scopeKey) {
        const storage = (0, $aZaPn.createLocalStorageProvider)($619b603377692131$export$69ca515e4489d790);
        const scopeKeyInStorage = storage.get($619b603377692131$export$27be962d708928a);
        // init value
        if (this.scopes.prev === null && this.scopes.current === null) {
            if (scopeKeyInStorage) {
                // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
                this.scopes.prev = scopeKeyInStorage;
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.scopes.current = scopeKeyInStorage;
            }
        }
        // same account id
        if (this.scopes.current !== scopeKey) {
            // diffrent account id
            if (this.scopes.current !== null) // scope has changed during session
            storage.clearAll();
            // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
            this.scopes.prev = this.scopes.current;
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.scopes.current = scopeKey;
            storage.set($619b603377692131$export$27be962d708928a, scopeKey);
        }
        // @ts-expect-error - TS7005 - Variable 'resolveCachePromise' implicitly has an 'any' type.
        $619b603377692131$var$resolveCachePromise();
    },
    get () {
        return this.scopes.current;
    }
};
var $619b603377692131$export$2e2bcd8739ae039 = $619b603377692131$var$config;

});



parcelRegister("3bIxc", function(module, exports) {

$parcel$export(module.exports, "props", () => $db1ce1616d9abcdd$export$8128bb6492cf3de7);

const $db1ce1616d9abcdd$var$MAX_RESULTS = 10;
const $db1ce1616d9abcdd$var$CACHE_SIZE = $db1ce1616d9abcdd$var$MAX_RESULTS * 2;
const $db1ce1616d9abcdd$var$COMPONENTS_CACHE_KEY = 'components';
const $db1ce1616d9abcdd$export$8128bb6492cf3de7 = {
    size: $db1ce1616d9abcdd$var$CACHE_SIZE,
    cacheKey: $db1ce1616d9abcdd$var$COMPONENTS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)
};

});


parcelRegister("jD201", function(module, exports) {

$parcel$export(module.exports, "getGlobalComponentsProperty", () => $623baa6e9886872f$export$1db3503600a1638e);
$parcel$export(module.exports, "setGlobalComponentsProperty", () => $623baa6e9886872f$export$71702a5b14caff65);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $623baa6e9886872f$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $623baa6e9886872f$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $623baa6e9886872f$var$getProjectId = async (projectKey)=>{
    const project = await (0, $lRmyA.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $623baa6e9886872f$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$623baa6e9886872f$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $623baa6e9886872f$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $623baa6e9886872f$var$url(projectId, $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $623baa6e9886872f$var$url(projectKey, $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $lRmyA.performGetRequest)(endpoint);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $guiFP.default)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};
async function $623baa6e9886872f$export$71702a5b14caff65(projectKey, value) {
    try {
        let endpoint;
        if (!$623baa6e9886872f$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $623baa6e9886872f$var$getProjectId(projectKey);
            if (!projectId) return;
            endpoint = $623baa6e9886872f$var$url(projectId, $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $623baa6e9886872f$var$url(projectKey, $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        await (0, $lRmyA.performPutRequest)(endpoint, {
            body: JSON.stringify(value)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'setGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
}

});

parcelRegister("kltWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b57f2fa021b0846a$export$2e2bcd8739ae039);

var $63BlZ = parcelRequire("63BlZ");

var $lO4Or = parcelRequire("lO4Or");
var /*
 * Rank list of components by calling Field recommendations service
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$b57f2fa021b0846a$export$2e2bcd8739ae039 = (components, issueId, projectId, sessionId, createAnalyticsEvent)=>(0, $63BlZ.default)((0, $lO4Or.COMPONENTS_TYPE), components, issueId, projectId, sessionId, createAnalyticsEvent);

});
parcelRegister("63BlZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $468ef57f87354cfb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useFieldRanker", () => $468ef57f87354cfb$export$7c15acf923fb53c7);

var $eUqFw = parcelRequire("eUqFw");

var $3aUuh = parcelRequire("3aUuh");

var $bDIST = parcelRequire("bDIST");

var $bFzGY = parcelRequire("bFzGY");

var $fVqUX = parcelRequire("fVqUX");

var $8uNQc = parcelRequire("8uNQc");

var $e91YZ = parcelRequire("e91YZ");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");

var $kwEon = parcelRequire("kwEon");

var $lO4Or = parcelRequire("lO4Or");

var $dxcfv = parcelRequire("dxcfv");
var $dWLk9 = parcelRequire("dWLk9");


var $2mJrt = parcelRequire("2mJrt");
const $468ef57f87354cfb$var$fetchRankedFields = (fieldId, values, issueId, projectId, sessionId, createAnalyticsEvent)=>{
    const { atlassianAccountId: atlassianAccountId, cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const valuesMap = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(values, 'id');
    // JIV-15235: Pass experience as argument
    const experience = fieldId === (0, $lO4Or.COMPONENTS_TYPE) ? 'JiraComponents' : 'JiraFields';
    const startTime = (0, $8uNQc.default).now();
    return (0, $2OdyW.default)((0, $3379d852a3f63848$export$6d1e923f8a929932), {
        ...(0, $fVqUX.default),
        method: 'POST',
        body: JSON.stringify({
            context: {
                fieldId: fieldId,
                product: 'jira',
                containerId: projectId,
                objectId: issueId,
                userId: atlassianAccountId,
                tenantId: cloudId,
                additionalContextList: values.map(({ id: id, name: name })=>({
                        key: id,
                        value: name
                    }))
            },
            modelRequestParams: {
                experience: experience,
                caller: 'jira'
            },
            requestingUserId: atlassianAccountId,
            sessionId: sessionId
        })
    }).then(({ recommendedEntities: recommendedEntities })=>{
        (0, $kwEon.fireSuggestionsRequestSuccessEvent)(fieldId, startTime, createAnalyticsEvent, {
            sessionId: sessionId
        });
        // Collaboration Graph returns entities by the order it was passed, so we need to sort them by score
        // NOTE: This is not type-safe, no way to check if 'score' actually exists
        const sortedRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($bDIST)))(recommendedEntities, 'score', 'desc');
        return sortedRecommendations.map(({ id: id })=>valuesMap[id]);
    }).catch((e)=>{
        (0, $kwEon.fireSuggestionsRequestFailedEvent)(fieldId, startTime, createAnalyticsEvent, {
            sessionId: sessionId
        });
        (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $3379d852a3f63848$export$6bc20faf7154cd43), `error while ranking ${fieldId} via CG`, e);
        return values;
    });
};
var /**
 * Rank list of field values by calling Field recommendations service
 *
 * @deprecated Use `useFieldRanker` instead
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$468ef57f87354cfb$export$2e2bcd8739ae039 = (fieldId, values, issueId, projectId, sessionId, createAnalyticsEvent)=>{
    // empty list or single element list
    // no need to call server as no need to rank
    if (!values || values.length <= 1) return Promise.resolve(values);
    return (0, $2mJrt.executeWithTimeout)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>$468ef57f87354cfb$var$fetchRankedFields(fieldId, values, issueId, projectId, sessionId, createAnalyticsEvent), values, (0, $3379d852a3f63848$export$2492cb4848fb3f4d), fieldId, sessionId, createAnalyticsEvent);
};
const $468ef57f87354cfb$export$7c15acf923fb53c7 = (props)=>{
    const { experience: experience, fieldId: fieldId, issueId: issueId, projectId: projectId, sessionId: sessionId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const accountId = (0, $dxcfv.useAccountId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    /**
	 * Function that ranks the field options using the Collaboration Graph API.
	 */ const rankFieldOptions = (0, $eUqFw.useCallback)(/**
		 * Calls `fetchRecommendations()` with the field options to be ranked.
		 *
		 * @typeParam Option - The type of the option to be transformed as `SmartsKeyValue`s
		 * @param {Option[]} options - List of options to get recommendations for.
		 * @param {Function} getSmartsKeyValue - Function that transforms `Option` to `SmartsKeyValue` shape required by the Collaboration Graph API.
		 *
		 * @returns Either the sorted options based on the recommendation scores, or the same options passed if the request fails.
		 */ async (options, getSmartsKeyValue)=>{
        if (!options || options.length <= 1) return Promise.resolve(options);
        const contextList = [];
        /**
			 * Create a map of the options based on the `key` value from `getSmartsKeyValue`.
			 * This will make it easier to sort the recommended results.
			 */ const optionsMap = {};
        options.forEach((option)=>{
            const smartsKeyValue = getSmartsKeyValue(option);
            contextList.push(smartsKeyValue);
            optionsMap[smartsKeyValue.key] = option;
        });
        const context = {
            cloudId: cloudId,
            contextList: contextList,
            fieldId: fieldId,
            issueId: issueId,
            projectId: projectId,
            userId: accountId ?? ''
        };
        return (0, $2mJrt.executeWithTimeout)(async ()=>{
            const rankedEntities = await (0, $2mJrt.fetchRecommendations)(context, experience, sessionId, createAnalyticsEvent);
            return rankedEntities.map(({ key: key })=>optionsMap[key]);
        }, options, (0, $3379d852a3f63848$export$2492cb4848fb3f4d), fieldId, sessionId, createAnalyticsEvent);
    }, [
        accountId,
        cloudId,
        createAnalyticsEvent,
        experience,
        fieldId,
        issueId,
        projectId,
        sessionId
    ]);
    return {
        rankFieldOptions: rankFieldOptions
    };
};

});
parcelRegister("bDIST", function(module, exports) {

var $943C2 = parcelRequire("943C2");

var $1c8hB = parcelRequire("1c8hB");
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $8796275107b9d4d1$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$1c8hB(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$1c8hB(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $943C2(collection, iteratees, orders);
}
module.exports = $8796275107b9d4d1$var$orderBy;

});
parcelRegister("943C2", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $dS3e6 = parcelRequire("dS3e6");

var $7qARj = parcelRequire("7qARj");

var $iA1h1 = parcelRequire("iA1h1");

var $hVWSV = parcelRequire("hVWSV");

var $74vSq = parcelRequire("74vSq");

var $2UGl0 = parcelRequire("2UGl0");

var $3QMTK = parcelRequire("3QMTK");

var $1c8hB = parcelRequire("1c8hB");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $69974a25804cb8c6$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $kJvGp(iteratees, function(iteratee) {
        if ($1c8hB(iteratee)) return function(value) {
            return $dS3e6(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $3QMTK
    ];
    var index = -1;
    iteratees = $kJvGp(iteratees, $74vSq($7qARj));
    var result = $iA1h1(collection, function(value, key, collection) {
        var criteria = $kJvGp(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $hVWSV(result, function(object, other) {
        return $2UGl0(object, other, orders);
    });
}
module.exports = $69974a25804cb8c6$var$baseOrderBy;

});
parcelRegister("hVWSV", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $d0e56fd712f7edce$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $d0e56fd712f7edce$var$baseSortBy;

});

parcelRegister("2UGl0", function(module, exports) {

var $3Sx56 = parcelRequire("3Sx56");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $21f1a725ef116621$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $3Sx56(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $21f1a725ef116621$var$compareMultiple;

});
parcelRegister("3Sx56", function(module, exports) {

var $8aco7 = parcelRequire("8aco7");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $2d301382a375e0f6$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $8aco7(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $8aco7(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $2d301382a375e0f6$var$compareAscending;

});




/**
 * Endpoint used to request field recommendations from the Collaboration Graph API
 *
 * See documentation for more details: {@link https://developer.atlassian.com/platform/collaboration-graph/rest/api-group-collaboration-graph-recommendations-api/#api-v2-recommend-fields-post}
 */ const $3379d852a3f63848$export$6d1e923f8a929932 = '/gateway/api/collaboration/v2/recommend/fields';
const $3379d852a3f63848$export$6bc20faf7154cd43 = 'smarts.fields.ranking';
const $3379d852a3f63848$export$2492cb4848fb3f4d = 5000;

parcelRegister("2mJrt", function(module, exports) {

$parcel$export(module.exports, "executeWithTimeout", () => $0fdee2d884897382$export$464a831a19a277ec);
$parcel$export(module.exports, "fetchRecommendations", () => $0fdee2d884897382$export$ad90a8b5454baf8e);

var $fVqUX = parcelRequire("fVqUX");

var $8uNQc = parcelRequire("8uNQc");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");

var $kwEon = parcelRequire("kwEon");

const $0fdee2d884897382$export$464a831a19a277ec = (thunk, defaultValue, timeout, fieldId, sessionId, createAnalyticsEvent)=>{
    let id;
    const defaultPromise = new Promise((resolve)=>{
        id = setTimeout(()=>{
            (0, $gUUjF.default).safeWarnWithoutCustomerData((0, $3379d852a3f63848$export$6bc20faf7154cd43), `CG has timeout after ${timeout}ms`);
            (0, $kwEon.fireSuggestionsRequestFailedEvent)(fieldId, timeout, createAnalyticsEvent, {
                sessionId: sessionId
            });
            resolve(defaultValue);
        }, timeout);
    });
    const frsResponsePromise = thunk().then((value)=>{
        if (id) clearTimeout(id);
        return value;
    });
    return Promise.race([
        defaultPromise,
        frsResponsePromise
    ]);
};
const $0fdee2d884897382$export$ad90a8b5454baf8e = async (context, experience, sessionId, createAnalyticsEvent)=>{
    const { cloudId: cloudId, contextList: contextList, fieldId: fieldId, userId: userId, issueId: issueId, projectId: projectId } = context;
    const startTime = (0, $8uNQc.default).now();
    try {
        const { recommendedEntities: recommendedEntities } = await (0, $2OdyW.default)((0, $3379d852a3f63848$export$6d1e923f8a929932), {
            ...(0, $fVqUX.default),
            method: 'POST',
            body: JSON.stringify({
                context: {
                    fieldId: fieldId,
                    userId: userId,
                    product: 'jira',
                    additionalContextList: contextList,
                    containerId: projectId,
                    objectId: issueId,
                    tenantId: cloudId
                },
                modelRequestParams: {
                    experience: experience,
                    caller: 'jira'
                },
                requestingUserId: context.userId,
                sessionId: sessionId
            })
        });
        (0, $kwEon.fireSuggestionsRequestSuccessEvent)(fieldId, startTime, createAnalyticsEvent, {
            sessionId: sessionId
        });
        // Collaboration Graph returns entities by the order it was passed, so we need to sort them by score in descending order
        recommendedEntities.sort((a, b)=>b.score - a.score);
        return recommendedEntities.map(({ id: id, value: value })=>({
                value: value,
                key: id
            }));
    } catch (error) {
        (0, $kwEon.fireSuggestionsRequestFailedEvent)(fieldId, startTime, createAnalyticsEvent, {
            sessionId: sessionId
        });
        (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $3379d852a3f63848$export$6bc20faf7154cd43), `error while ranking ${fieldId} via CG`, error instanceof Error ? error : undefined);
        return contextList;
    }
};

});



parcelRegister("edqXu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b59c9d6a8fdadf7$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $6b59c9d6a8fdadf7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.components.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "Select component"
    },
    createNewItem: {
        "id": "issue.components.create-new-component-message",
        "defaultMessage": "Create new component"
    },
    recent: {
        "id": "issue.components.recent-items",
        "defaultMessage": "Recent components"
    },
    all: {
        "id": "issue.components.all-items",
        "defaultMessage": "All components"
    },
    disabledJiraComponent: {
        "id": "issue.tag-view.disabled-jira-component",
        "defaultMessage": "<italic>{componentName}</italic> can be removed from this issue, but to add it again, switch to Jira components from the <strong>Components</strong> page."
    },
    disabledCompassComponent: {
        "id": "issue.tag-view.disabled-compass-component",
        "defaultMessage": "<italic>{componentName}</italic> can be removed from this issue, but to add it again, switch to Compass components from the <strong>Components</strong> page."
    }
});

});

parcelRegister("5j4EJ", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $b87244b15308deca$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformSuggestionsFromServerAndCache", () => $b87244b15308deca$export$ecddc37cd50b50fd);
$parcel$export(module.exports, "transformToStateValue", () => $b87244b15308deca$export$1cfcb95cb8fbddb3);

var $gyj10 = parcelRequire("gyj10");

var $8g5hT = parcelRequire("8g5hT");

var $1ybV0 = parcelRequire("1ybV0");

var $edqXu = parcelRequire("edqXu");
const $b87244b15308deca$export$cb172b2468ab5652 = (value, { projectKey: projectKey })=>{
    if (!value || value.length === 0) return [];
    return value.map((item)=>{
        const jql = `project = ${(0, $8g5hT.toQuotedString)(projectKey)} AND component = ${(0, $8g5hT.toQuotedString)(item.name)}`;
        const href = (0, $8g5hT.createIssuesUrl)(jql);
        return {
            href: href,
            content: item.name,
            value: item.id,
            ...(0, $1ybV0.ff)('compass-components-in-jira-components_xw42u', false) ? {
                ari: item.ari,
                metadata: item.metadata
            } : {}
        };
    });
};
// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
const $b87244b15308deca$var$transformItem = (item)=>({
        content: item.name,
        value: item.id,
        fromCache: item.fromCache || false,
        ...(0, $1ybV0.ff)('compass-components-in-jira-components_xw42u', false) ? {
            ari: item.ari,
            metadata: item.metadata
        } : {}
    });
const $b87244b15308deca$var$MAX_RESULTS = 5;
const $b87244b15308deca$export$dc069111282472fb = (rest, cache, projectKey)=>cache.filter((item)=>item.projectKey === projectKey).map((item)=>{
        const duplicatedItem = rest.find((restItem)=>restItem.id === item.id);
        if (duplicatedItem) {
            const newItem = {
                ...duplicatedItem,
                projectKey: projectKey
            };
            (0, $gyj10.default).update(`${item.id}`, newItem);
            return {
                ...newItem,
                fromCache: true
            };
        }
        return {
            ...item,
            fromCache: true
        };
    });
const $b87244b15308deca$export$64c1e7aa265973f8 = (cache)=>cache.slice(-1 * $b87244b15308deca$var$MAX_RESULTS).reverse();
const $b87244b15308deca$export$ecddc37cd50b50fd = (suggestionsFromServer = [], cache = [], intl, projectKey)=>{
    const cacheLists = $b87244b15308deca$export$64c1e7aa265973f8($b87244b15308deca$export$dc069111282472fb(suggestionsFromServer, cache, projectKey));
    return [
        {
            heading: intl.formatMessage((0, $edqXu.default).recent),
            items: cacheLists.map($b87244b15308deca$var$transformItem)
        },
        {
            heading: intl.formatMessage((0, $edqXu.default).all),
            items: suggestionsFromServer.map($b87244b15308deca$var$transformItem)
        }
    ];
};
const $b87244b15308deca$export$1cfcb95cb8fbddb3 = (value)=>value.map((item)=>({
            name: item.content,
            id: item.value,
            fromCache: item.fromCache || false,
            ...(0, $1ybV0.ff)('compass-components-in-jira-components_xw42u', false) ? {
                ari: item.ari,
                metadata: item.metadata
            } : {}
        }));

});
parcelRegister("8g5hT", function(module, exports) {

$parcel$export(module.exports, "toQuotedString", () => $101afcc0c6282ae9$export$dbeab020a4aa404);
$parcel$export(module.exports, "createIssuesUrl", () => $101afcc0c6282ae9$export$c623a4b2d8c439ab);
const $101afcc0c6282ae9$var$ENCODE_MAP = {
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '"': '\\"',
    "'": "\\'",
    '\\': '\\\\'
};
const $101afcc0c6282ae9$export$946fe289c25510be = (character, ignoredCharacter)=>{
    if (character === ignoredCharacter) return character;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly '\t': "\\t"; readonly '\n': "\\n"; readonly '\r': "\\r"; readonly '"': "\\\""; readonly "'": "\\'"; readonly '\\': "\\\\"; }'.
    return $101afcc0c6282ae9$var$ENCODE_MAP[character] || character;
};
const $101afcc0c6282ae9$export$dbeab020a4aa404 = (parameter)=>{
    let escaped = '';
    for(let position = 0; position < parameter.length; position += 1)escaped += $101afcc0c6282ae9$export$946fe289c25510be(parameter[position], "'");
    return `"${escaped}"`;
};
const $101afcc0c6282ae9$export$c623a4b2d8c439ab = (jql)=>`/issues/?jql=${encodeURIComponent(jql)}`;

});


parcelRegister("lMkmi", function(module, exports) {

$parcel$export(module.exports, "View", () => $b8674cf6dc5bfa9b$export$27a5bd065ad55220);

var $eUqFw = parcelRequire("eUqFw");

var $gO9Xw = parcelRequire("gO9Xw");

var $hFxJG = parcelRequire("hFxJG");

var $8HuAw = parcelRequire("8HuAw");

var $l0Tj3 = parcelRequire("l0Tj3");
var $e1gDz = parcelRequire("e1gDz");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $fiMQP = parcelRequire("fiMQP");

var $18KtE = parcelRequire("18KtE");

var $ac6FY = parcelRequire("ac6FY");

var $jK1pm = parcelRequire("jK1pm");

var $fNcqT = parcelRequire("fNcqT");

var $edqXu = parcelRequire("edqXu");
const $b8674cf6dc5bfa9b$var$isGlobalComponent = (item)=>typeof item.ari === 'string' && item.metadata?.typeId !== undefined;
const $b8674cf6dc5bfa9b$var$isComponentInReadonlyState = (item, isGlobalComponentsEnabledForProject)=>$b8674cf6dc5bfa9b$var$isGlobalComponent(item) ? !isGlobalComponentsEnabledForProject : isGlobalComponentsEnabledForProject;
// eslint-disable-next-line jira/react/no-class-components
class $b8674cf6dc5bfa9b$var$ComponentsView extends (0, $eUqFw.Component) {
    renderFooter() {
        const { intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiMQP.FooterContainer), {
            /* eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */ className: "issue-view__select-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
            label: "",
            size: "small"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiMQP.OptionLabel), null, intl.formatMessage((0, $edqXu.default).createNewItem)));
    }
    render() {
        const { shouldShowFooter: shouldShowFooter, onFooterSelect: onFooterSelect, baseUrl: baseUrl, projectKey: projectKey, intl: intl, isGlobalComponentsEnabled: isGlobalComponentsEnabled, ...selectProps } = this.props;
        const { data: data, loading: loading, error: error } = this.state;
        const initialData = {
            data: data,
            loading: loading,
            error: error
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $18KtE.default), {
            ...selectProps,
            customReadView: this.getCustomReadViewProp(),
            styles: (0, $fiMQP.selectFooterStyles),
            fetchSuggestions: this.fetchSuggestions,
            debounceFetchSuggestionsTime: 300,
            initialData: initialData,
            shouldShowFooter: shouldShowFooter,
            footer: this.renderFooter(),
            onFooterSelect: (0, $1ybV0.ff)('compass-components-in-jira-components_xw42u') && onFooterSelect ? onFooterSelect : ()=>(0, $8HuAw.default)(`${baseUrl}/plugins/servlet/project-config/${projectKey}/administer-components`, false),
            allowEmptyValue: true,
            optionValuesSafeForAnalytics: true,
            showNewLozenge: !!isGlobalComponentsEnabled
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            data: [],
            loading: false,
            error: false
        };
        this.componentDidMount = ()=>{
            this.getDataFromCache();
        };
        this.getDataFromCache = ()=>{
            this.props.getDataFromCache?.().then((data)=>{
                this.setState({
                    data: data,
                    loading: false
                });
            });
        };
        this.fetchSuggestions = (query, sessionId)=>this.props.fetchSuggestions(query, sessionId).then((data)=>{
                this.setState({
                    data: data
                });
                return data;
            });
        this.getCustomReadViewProp = ()=>{
            const { shouldShowFooter: shouldShowFooter, baseUrl: baseUrl, projectKey: projectKey, intl: intl, isGlobalComponentsEnabled: isGlobalComponentsEnabled, globalComponentsPropertyLoading: globalComponentsPropertyLoading, ...selectProps } = this.props;
            return (0, $1ybV0.ff)('compass-components-in-jira-components_xw42u', false) ? (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
                    name: "compass-components-hybrid-field"
                }, globalComponentsPropertyLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
                    width: "150px",
                    height: "16px",
                    borderRadius: 3,
                    testId: "issue-view-base.context.components.skeleton",
                    isShimmering: true
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ac6FY.default), {
                    ...selectProps,
                    // @ts-expect-error - Type 'Value | (Value & SelectValueShape[])' is not assignable to type 'Item[] | null | undefined'.
                    value: value,
                    // @ts-expect-error - Type '(item: Item) => string' is not assignable to type '(item: Item) => ReactElement<any, string | JSXElementConstructor<any>>'.
                    renderTagTooltipContent: (item)=>{
                        if ($b8674cf6dc5bfa9b$var$isComponentInReadonlyState(item, isGlobalComponentsEnabled)) return intl.formatMessage($b8674cf6dc5bfa9b$var$isGlobalComponent(item) ? (0, $edqXu.default).disabledCompassComponent : (0, $edqXu.default).disabledJiraComponent, {
                            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks),
                            italic: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("em", null, chunks),
                            componentName: 'content' in item ? item.content : item.label
                        });
                        return 'content' in item && item.content !== undefined && item.content.length > 20 ? item.content : '';
                    },
                    renderTagItem: (item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fNcqT.ComponentTag), {
                            item: item,
                            globalComponentsEnabled: isGlobalComponentsEnabled
                        }),
                    projectKey: projectKey
                })) : undefined;
        };
    }
}
const $b8674cf6dc5bfa9b$var$ComponentsViewWithGlobalComponentsEnabled = (props)=>{
    const { isMobile: isMobile, projectKey: projectKey, shouldShowFooter: shouldShowFooter, baseUrl: baseUrl } = props;
    const { hasCompassPermissions: hasCompassPermissions } = (0, $l0Tj3.useGetCompassPermissions)();
    const getCreateCompassComponentUrl = ()=>{
        const originUrl = window.location.origin;
        const projectLink = encodeURI(`${originUrl}/browse/${projectKey}`);
        return `${originUrl}/compass/home?showCreateComponentModal=true&projectLink=${projectLink}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b8674cf6dc5bfa9b$var$ComponentsView, {
        ...props,
        isGlobalComponentsEnabled: true,
        shouldShowFooter: !isMobile ? hasCompassPermissions : shouldShowFooter,
        onFooterSelect: ()=>hasCompassPermissions ? (0, $8HuAw.default)(getCreateCompassComponentUrl(), true) : (0, $8HuAw.default)(`${baseUrl}/plugins/servlet/project-config/${projectKey}/administer-components`, false)
    });
};
const $b8674cf6dc5bfa9b$var$ComponentsViewWithHooks = (props)=>{
    const { projectKey: projectKey } = props;
    const { enabled: isGlobalComponentsEnabled, loading: globalComponentsPropertyLoading } = (0, $e1gDz.useGlobalComponentsProperty)(projectKey);
    if (isGlobalComponentsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b8674cf6dc5bfa9b$var$ComponentsViewWithGlobalComponentsEnabled, {
        ...props,
        globalComponentsPropertyLoading: globalComponentsPropertyLoading
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b8674cf6dc5bfa9b$var$ComponentsView, {
        ...props,
        globalComponentsPropertyLoading: globalComponentsPropertyLoading
    });
};
const $b8674cf6dc5bfa9b$export$27a5bd065ad55220 = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('compass-components-in-jira-components_xw42u'), $b8674cf6dc5bfa9b$var$ComponentsViewWithHooks, $b8674cf6dc5bfa9b$var$ComponentsView);

});
parcelRegister("gO9Xw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3c90a7e02e55e7e$var$_react = $c3c90a7e02e55e7e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c3c90a7e02e55e7e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c3c90a7e02e55e7e$var$AddIcon = (props)=>/*#__PURE__*/ $c3c90a7e02e55e7e$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M13 11V3.993A.997.997 0 0012 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 003 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0021 12c0-.556-.445-1-.993-1H13z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$c3c90a7e02e55e7e$var$AddIcon.displayName = 'AddIcon';
var $c3c90a7e02e55e7e$var$_default = $c3c90a7e02e55e7e$var$AddIcon;
module.exports.default = $c3c90a7e02e55e7e$var$_default;

});

parcelRegister("hFxJG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6854df9b98f4b182$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");
const $6854df9b98f4b182$var$shimmer = (0, $lcnyw.skeletonShimmer)();
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $6854df9b98f4b182$var$shimmerKeyframes = (0, $byn9U.keyframes)($6854df9b98f4b182$var$shimmer.keyframes);
const $6854df9b98f4b182$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...$6854df9b98f4b182$var$shimmer.css
});
const $6854df9b98f4b182$var$activeShimmerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animationName: `${$6854df9b98f4b182$var$shimmerKeyframes}`
});
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ const $6854df9b98f4b182$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: [
            $6854df9b98f4b182$var$skeletonStyles,
            isShimmering && $6854df9b98f4b182$var$activeShimmerStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                width: width,
                height: height,
                borderRadius: borderRadius
            }
        ],
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        }
    });
};
var $6854df9b98f4b182$export$2e2bcd8739ae039 = $6854df9b98f4b182$var$Skeleton;

});

parcelRegister("l0Tj3", function(module, exports) {

$parcel$export(module.exports, "useGetCompassPermissions", () => $73eea356b24b0a06$export$31f6fe789b504709);

var $eUqFw = parcelRequire("eUqFw");

var $69VZh = parcelRequire("69VZh");
function $73eea356b24b0a06$export$31f6fe789b504709() {
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const [hasCompassPermissions, setHasCompassPermissions] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    (0, $eUqFw.useEffect)(()=>{
        (0, $69VZh.getCompassPermissions)() // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((result)=>{
            if (result.statusCode) setHasCompassPermissions(result.statusCode === 200);
            else setHasCompassPermissions(!!result.entitlements);
        }).catch((e)=>setError(e)).finally(()=>setLoading(false));
    }, []);
    return {
        loading: loading,
        hasCompassPermissions: hasCompassPermissions,
        error: error
    };
}

});
parcelRegister("69VZh", function(module, exports) {

$parcel$export(module.exports, "getCompassPermissions", () => $533110291a72e150$export$a60fbb9830f913a6);

var $lRmyA = parcelRequire("lRmyA");
const $533110291a72e150$var$url = '/gateway/api/compass/v1/entitlements';
const $533110291a72e150$export$a60fbb9830f913a6 = async ()=>{
    try {
        return await (0, $lRmyA.performPostRequest)($533110291a72e150$var$url, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                entitlements: []
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 403) return error;
        throw error;
    }
};

});


parcelRegister("e1gDz", function(module, exports) {

$parcel$export(module.exports, "useGlobalComponentsProperty", () => $10977af94640a909$export$a070f388fcd93df0);

var $eUqFw = parcelRequire("eUqFw");

var $gyj10 = parcelRequire("gyj10");

var $jD201 = parcelRequire("jD201");
function $10977af94640a909$export$a070f388fcd93df0(projectKey) {
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const [enabled, setEnabled] = (0, $eUqFw.useState)(undefined);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    const loadGlobalComponentsProperty = (0, $eUqFw.useCallback)(()=>{
        setEnabled(undefined);
        setError(undefined);
        setLoading(true);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    const resolveGlobalComponentsProperty = (0, $eUqFw.useCallback)((value)=>{
        if (value instanceof Error) {
            setEnabled(undefined);
            setError(value);
        } else {
            setEnabled(value);
            setError(undefined);
        }
        setLoading(false);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        loadGlobalComponentsProperty();
        (0, $jD201.getGlobalComponentsProperty)(projectKey).then((r)=>resolveGlobalComponentsProperty(r.value)).catch((e)=>resolveGlobalComponentsProperty(e));
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    const setProperty = (0, $eUqFw.useCallback)((newValue)=>{
        loadGlobalComponentsProperty();
        return (0, $jD201.setGlobalComponentsProperty)(projectKey, newValue)// We are clearing the Jira components cache here which is the
        // data source for "Recent components" in the components field
        // for Jira issues. This should be cleared when toggling between
        // global components enabled or disabled to avoid stales
        // suggestions from either.
        .then(()=>(0, $gyj10.default).clearAll()).then(()=>resolveGlobalComponentsProperty(newValue)).catch((e)=>{
            resolveGlobalComponentsProperty(e);
            throw e;
        });
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    return {
        enabled: enabled,
        loading: loading,
        error: error,
        setProperty: setProperty
    };
}

});

parcelRegister("fiMQP", function(module, exports) {

$parcel$export(module.exports, "OptionContainer", () => $2bca1db405f83116$export$ee0e52d575fd6e30);
$parcel$export(module.exports, "OptionLabel", () => $2bca1db405f83116$export$2cf7ef1e2dd6c6b1);
$parcel$export(module.exports, "FooterContainer", () => $2bca1db405f83116$export$651095642c93be3d);
$parcel$export(module.exports, "selectFooterStyles", () => $2bca1db405f83116$export$a48e2d0fe2470199);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");
const $2bca1db405f83116$export$ee0e52d575fd6e30 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $2bca1db405f83116$export$2cf7ef1e2dd6c6b1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $2bca1db405f83116$export$651095642c93be3d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz1vl3 _1yt41ano _irr31s4m _1di64h4s",
            __cmplp.className
        ])
    });
});
const $2bca1db405f83116$export$a48e2d0fe2470199 = {
    option: (base, state)=>{
        const akSelectMenuPaddingBottom = "var(--ds-space-100, 8px)";
        const akSelectMenuPaddingBottomOffset = "var(--ds-space-negative-100, -8px)";
        return {
            ...base,
            // apply styles only for 'Create new' option: https://github.com/JedWatson/react-select/issues/3377
            ...state.data.__isNew__ === true ? {
                ...state.isFocused ? {
                    '> .issue-view__select-footer': {
                        backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA).N20})`
                    }
                } : {},
                position: 'sticky',
                bottom: 0,
                backgroundColor: `${`var(--ds-surface, ${(0, $PdmhA).N0})`} !important`,
                // N900, hex does not work with rgba()
                borderTop: `2px solid ${"var(--ds-border, rgba(9, 30, 66, 0.13))"}`,
                padding: 0,
                paddingTop: "var(--ds-space-100, 8px)",
                // resetting 'padding' alone does not work in this component's case
                paddingBottom: 0,
                // to ensure that :after element is shown even though it's outside of the main one
                overflow: 'visible',
                ':after': {
                    // need this element to avoid having another option part being shown below Create one on scrolling (it is shown because options list element has padding)
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    bottom: akSelectMenuPaddingBottomOffset,
                    left: 0,
                    width: '100%',
                    height: akSelectMenuPaddingBottom,
                    // to have same footer height both when list scrolling is at the top and at the very bottom.
                    backgroundColor: `var(--ds-surface, ${(0, $PdmhA).N0})`,
                    borderBottomLeftRadius: '4px',
                    // need to match menu's border-radius, not to hide menu's border
                    borderBottomRightRadius: '4px'
                }
            } : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {},
            ...state.data.isAkSelectOption === true ? {
                textAlign: 'center',
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-200, 16px)"
            } : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {}
        };
    },
    menu: (base)=>({
            ...base,
            // without properly set zIndex value dropdown with options is shown behind the action buttons
            zIndex: (0, $c9TLT.layers).modal
        })
};

});

parcelRegister("18KtE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bfe6c420843e20e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ac6FY = parcelRequire("ac6FY");

var $3UUH8 = parcelRequire("3UUH8");
const $9bfe6c420843e20e$var$MultiSelectInlineEditView = (props)=>{
    const renderReadView = ()=>{
        const { value: value = [], noValueText: noValueText, tagAppearance: tagAppearance, isMobile: isMobile, customReadView: customReadView, isEditable: isEditable, isUserTag: isUserTag } = props;
        return !customReadView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ac6FY.default), {
            value: value?.map(({ value: val, content: content, color: color, elemBefore: elemBefore, href: href })=>({
                    value: val.toString(),
                    content: content,
                    color: color,
                    elemBefore: elemBefore,
                    href: href
                })),
            noValueText: noValueText,
            tagAppearance: tagAppearance,
            shouldHideLinks: isMobile,
            truncateValues: !isEditable && isUserTag,
            isUserTag: isUserTag
        }) : customReadView(value);
    };
    const { validate: validate, invalidMessage: invalidMessage, value: value, onChange: onChange, tagAppearance: tagAppearance, onDataRequest: onDataRequest, onDataLoaded: onDataLoaded, customReadView: customReadView, customEditView: customEditView, isUserTag: isUserTag, showNewLozenge: showNewLozenge, ...restProps } = props;
    const errorMessage = (0, $eUqFw.useMemo)(()=>validate(value) || invalidMessage, [
        value,
        validate,
        invalidMessage
    ]);
    const renderEditView = customEditView ? ()=>customEditView({
            value: value,
            onChange: onChange,
            validate: validate,
            customReadView: customReadView,
            invalidMessage: errorMessage,
            ...restProps
        }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3UUH8.default), {
        ...restProps,
        value: value,
        isMulti: true,
        onChangeMulti: onChange,
        invalidMessage: errorMessage,
        renderReadView: renderReadView,
        renderEditView: renderEditView,
        onDataRequest: onDataRequest,
        onDataLoaded: onDataLoaded,
        showNewLozenge: showNewLozenge
    });
};
$9bfe6c420843e20e$var$MultiSelectInlineEditView.displayName = 'MultiSelectInlineEditView';
$9bfe6c420843e20e$var$MultiSelectInlineEditView.defaultProps = {
    tagAppearance: 'default',
    validate: ()=>null,
    hasAutocomplete: true,
    debounceFetchSuggestionsTime: 300
};
var $9bfe6c420843e20e$export$2e2bcd8739ae039 = $9bfe6c420843e20e$var$MultiSelectInlineEditView;

});
parcelRegister("3UUH8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc520c2cc506b788$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $ffiyv = parcelRequire("ffiyv");

var $f8Yej = parcelRequire("f8Yej");

var $2gGF1 = parcelRequire("2gGF1");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9LvPd = parcelRequire("9LvPd");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $6oQPP = parcelRequire("6oQPP");

var $4bZws = parcelRequire("4bZws");

var $dAVhd = parcelRequire("dAVhd");

var $h4i9t = parcelRequire("h4i9t");

var $gLLZt = parcelRequire("gLLZt");

var $uj4Ix = parcelRequire("uj4Ix");
const $bc520c2cc506b788$export$8f89af0cfe4485a = ({ isEditable: isEditable = false, isEditing: isEditing = false, isMobile: isMobile = false, isMulti: isMulti = false, isInvalid: isInvalid = false, hasAutocomplete: hasAutocomplete = false, label: label = '', noValueText: noValueText = null, classNamePrefix: classNamePrefix, allowEmptyValue: allowEmptyValue = false, debounceFetchSuggestionsTime: debounceFetchSuggestionsTime = 0, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onConfirm: onConfirm, onInputChange: onInputChange, fieldId: fieldId, showPinButton: showPinButton, titleView: titleView = label, value: value, optionValuesSafeForAnalytics: optionValuesSafeForAnalytics, fieldContentWrapper: FieldContentWrapper, renderReadView: renderReadViewInProps, renderEditView: renderEditViewInProps, fetchSuggestions: fetchSuggestions, additionalAnalyticsProps: additionalAnalyticsProps, placeholder: placeholder, invalidMessage: invalidMessage, portalElement: portalElement, canCreateNewItem: canCreateNewItem, formatCreateLabel: formatCreateLabel, styles: styles, onCancel: onCancel, onChangeMulti: onChangeMulti, footer: footer, onEditRequest: onEditRequest, onFooterSelect: onFooterSelect, shouldShowFooter: shouldShowFooter, filterOption: filterOption, formatOptionLabel: formatOptionLabel, onDataRequest: onDataRequest, onDataLoaded: onDataLoaded, components: components, componentsProps: componentsProps, issueKey: issueKey, initialData: initialData, noOptionsMessage: noOptionsMessage, showNewLozenge: showNewLozenge })=>{
    const testId = `issue.views.field.select.common.select-inline-edit.${fieldId}`;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleOnChange = (0, $eUqFw.useCallback)((newValue, actionMeta)=>{
        onChange?.(newValue, actionMeta);
        onConfirm();
    }, [
        onChange,
        onConfirm
    ]);
    const hasValue = (0, $eUqFw.useMemo)(// @ts-expect-error - TS2339 - Property 'length' does not exist on type 'SelectValueShape | SelectValueShape[]'.
    ()=>Boolean(isMulti === true && value?.length || isMulti === false && value), [
        isMulti,
        value
    ]);
    const editButtonLabel = (0, $eUqFw.useMemo)(()=>{
        if (!hasValue) return formatMessage((0, $h4i9t.messages).extendedEditButtonLabel, {
            inputFieldValue: noValueText,
            fieldName: label
        });
        // @ts-expect-error - TS2339 - Property 'content' does not exist on type 'SelectValueShape | SelectValueShape[]'.
        if (isMulti === false && value?.content !== undefined) return formatMessage((0, $h4i9t.messages).extendedEditButtonLabel, {
            // @ts-expect-error - TS2339 - Property 'content' does not exist on type 'SelectValueShape | SelectValueShape[]'.
            inputFieldValue: value.content,
            fieldName: label
        });
        return formatMessage((0, $2gGF1.default).editButtonLabel, {
            fieldName: label
        });
    }, [
        formatMessage,
        hasValue,
        isMulti,
        label,
        noValueText,
        value
    ]);
    const renderDefaultEditView = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $uj4Ix.SelectFieldViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLLZt.default), {
            onInputChange: onInputChange,
            classNamePrefix: classNamePrefix,
            initialData: initialData,
            componentsProps: componentsProps,
            components: components,
            fieldId: fieldId,
            value: value,
            fetchSuggestions: fetchSuggestions,
            additionalAnalyticsProps: additionalAnalyticsProps,
            placeholder: placeholder,
            isOpen: isEditing,
            isInvalid: isInvalid,
            invalidMessage: invalidMessage,
            hasAutocomplete: hasAutocomplete,
            debounceFetchSuggestionsTime: debounceFetchSuggestionsTime,
            isClearable: allowEmptyValue,
            portalElement: portalElement,
            canCreateNewItem: canCreateNewItem,
            formatCreateLabel: formatCreateLabel,
            styles: styles,
            autoFocus: true,
            onChange: handleOnChange,
            footer: footer,
            onFooterSelect: onFooterSelect,
            shouldShowFooter: shouldShowFooter,
            onChangeMulti: onChangeMulti,
            isMulti: isMulti,
            filterOption: filterOption,
            formatOptionLabel: formatOptionLabel,
            onDataRequest: onDataRequest,
            onDataLoaded: onDataLoaded,
            optionValuesSafeForAnalytics: optionValuesSafeForAnalytics,
            ariaLabel: label,
            noOptionsMessage: (0, $dAVhd.isJsmFixIncompatibleRequestTypeInconsistenciesEnabled)() ? noOptionsMessage : undefined
        })), [
        additionalAnalyticsProps,
        allowEmptyValue,
        canCreateNewItem,
        classNamePrefix,
        components,
        componentsProps,
        debounceFetchSuggestionsTime,
        fetchSuggestions,
        onInputChange,
        fieldId,
        filterOption,
        footer,
        formatCreateLabel,
        formatOptionLabel,
        handleOnChange,
        hasAutocomplete,
        initialData,
        invalidMessage,
        isEditing,
        isMulti,
        isInvalid,
        label,
        onChangeMulti,
        onDataLoaded,
        onDataRequest,
        onFooterSelect,
        optionValuesSafeForAnalytics,
        placeholder,
        portalElement,
        shouldShowFooter,
        styles,
        value,
        noOptionsMessage
    ]);
    const renderEditView = (0, $eUqFw.useMemo)(()=>{
        if (renderEditViewInProps != null) return renderEditViewInProps;
        return renderDefaultEditView;
    }, [
        renderEditViewInProps,
        renderDefaultEditView
    ]);
    const renderReadViewOld = (0, $eUqFw.useCallback)(()=>{
        if (FieldContentWrapper !== undefined && FieldContentWrapper !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldContentWrapper, null, renderReadViewInProps());
        return renderReadViewInProps();
    }, [
        FieldContentWrapper,
        renderReadViewInProps
    ]);
    const renderReadView = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $uj4Ix.ReadViewContainer), {
            "data-component-selector": (0, $uj4Ix.readViewContainerSelectorName)
        }, renderReadViewOld()), [
        renderReadViewOld
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), {
        fieldId: fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, titleView), issueKey !== undefined && fieldId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldId,
        label: label
    }), (0, $1ybV0.ff)('compass-components-in-jira-components_xw42u', false) && showNewLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $uj4Ix.LozengeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "new"
    }, formatMessage((0, $h4i9t.messages).newLozenge))), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldId,
        label: label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), {
        isEditing: isEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
        onEscape: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $uj4Ix.InlineEditContainer), {
        isEditable: isEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        testId: `${testId}.field-inline-edit-state-less`,
        isLabelHidden: true,
        label: label,
        readView: renderReadView,
        editView: renderEditView,
        isEditing: isEditing,
        isEditable: isEditable,
        hideActionButtons: !isMulti,
        readViewFitContainerWidth: !isMobile,
        onConfirm: onConfirm,
        onCancel: onCancel,
        onEdit: onEditRequest,
        editButtonLabel: editButtonLabel,
        confirmButtonLabel: formatMessage((0, $2gGF1.default).confirmButtonLabel, {
            fieldName: label
        }),
        cancelButtonLabel: formatMessage((0, $2gGF1.default).cancelButtonLabel, {
            fieldName: label
        })
    })))));
};
var $bc520c2cc506b788$export$2e2bcd8739ae039 = $bc520c2cc506b788$export$8f89af0cfe4485a;

});
parcelRegister("dAVhd", function(module, exports) {

$parcel$export(module.exports, "isJsmFixIncompatibleRequestTypeInconsistenciesEnabled", () => $cf8bc70b83a17b24$export$733566d04cfe61b1);

var $1ybV0 = parcelRequire("1ybV0");
const $cf8bc70b83a17b24$export$733566d04cfe61b1 = ()=>(0, $1ybV0.ff)('jsm-fix-invalid-request-type-inconsistencies_x7maw', false);

});

parcelRegister("h4i9t", function(module, exports) {

$parcel$export(module.exports, "messages", () => $82592cfc98049faf$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $82592cfc98049faf$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    newLozenge: {
        "id": "issue-internal-field-select.common.select-inline-edit.new-lozenge",
        "defaultMessage": "NEW"
    },
    extendedEditButtonLabel: {
        "id": "issue-internal-field-select.common.select-inline-edit.extended-edit-button-label",
        "defaultMessage": "Edit {fieldName}, {inputFieldValue} selected"
    }
});

});

parcelRegister("gLLZt", function(module, exports) {

$parcel$export(module.exports, "defaultSelectProps", () => $1ddf1cf19915b578$export$d69279bb4fae6c37);
$parcel$export(module.exports, "default", () => $1ddf1cf19915b578$export$2e2bcd8739ae039);
$parcel$export(module.exports, "defaultSelectStyles", () => (parcelRequire("7nzO5")).defaultSelectStyles);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("1NUMQ");
parcelRequire("8jBvP");
parcelRequire("9O5En");
parcelRequire("3wBUP");

var $7jPhn = parcelRequire("7jPhn");

var $9JyRh = parcelRequire("9JyRh");

var $c9TLT = parcelRequire("c9TLT");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hzcvF = parcelRequire("hzcvF");

var $kDIIr = parcelRequire("kDIIr");

var $aIgWU = parcelRequire("aIgWU");

var $jqJe9 = parcelRequire("jqJe9");

var $7nzO5 = parcelRequire("7nzO5");

var $52Iro = parcelRequire("52Iro");
const $1ddf1cf19915b578$export$d69279bb4fae6c37 = {
    hideSelectedOptions: true,
    allowCreateWhileLoading: true,
    filterOption: (0, $kDIIr.filterOptionByLabelAndFilterValues)
};
const $1ddf1cf19915b578$var$transformToOption = (item)=>({
        label: item.content,
        ...item
    });
const $1ddf1cf19915b578$var$transformFromOption = (option, actionMeta)=>{
    const { label: label, filterValues: filterValues, ...optionValueProperties } = option;
    const result = {
        ...optionValueProperties
    };
    if (actionMeta.action === 'create-option' && result.content === undefined) result.content = option.label;
    return result;
};
const $1ddf1cf19915b578$export$2073539080b8c707 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isMulti: isMulti = false, value: value = null, debounceFetchSuggestionsTime: debounceFetchSuggestionsTime = 0, filterOption: filterOption = $1ddf1cf19915b578$export$d69279bb4fae6c37.filterOption, errorMessagePosition: errorMessagePosition = 'top', onChangeMulti: onChangeMulti = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onInputChange: onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onDataRequest: onDataRequest, onDataLoaded: onDataLoaded, fetchSuggestions: fetchSuggestions, additionalAnalyticsProps: additionalAnalyticsProps, initialData: initialData, changeQueryValue: changeQueryValue, formatOptionLabel: formatOptionLabel, invalidMessage: invalidMessage, fieldId: fieldId } = props;
    const subscription = (0, $eUqFw.useRef)(null);
    const query$ = (0, $eUqFw.useRef)(null);
    const query = (0, $eUqFw.useRef)(null);
    const additionalAnalyticsPropsInRef = (0, $eUqFw.useRef)(additionalAnalyticsProps);
    const fetchSuggestionsInRef = (0, $eUqFw.useRef)(fetchSuggestions);
    const debounceFetchSuggestionsTimeInRef = (0, $eUqFw.useRef)(debounceFetchSuggestionsTime);
    const onDataLoadedInRef = (0, $eUqFw.useRef)(onDataLoaded);
    const onDataRequestInRef = (0, $eUqFw.useRef)(onDataRequest);
    onDataRequestInRef.current = onDataRequest;
    onDataLoadedInRef.current = onDataLoaded;
    debounceFetchSuggestionsTimeInRef.current = debounceFetchSuggestionsTime;
    fetchSuggestionsInRef.current = fetchSuggestions;
    additionalAnalyticsPropsInRef.current = additionalAnalyticsProps;
    const previousInitialData = (0, $hzcvF.usePrevious)(initialData);
    const transformItems = (0, $eUqFw.useCallback)((items)=>{
        if (items && items.length > 0) return items.map($1ddf1cf19915b578$var$transformToOption);
        return [];
    }, []);
    const transformToOptions = (0, $eUqFw.useCallback)((suggestions)=>{
        // A single list of Options, no groups
        if (suggestions.length === 1 && !suggestions[0].heading) return transformItems(suggestions[0].items);
        // Handle Option groups case
        return suggestions.map((suggestion)=>{
            const options = transformItems(suggestion.items);
            return suggestion.heading !== undefined ? {
                label: suggestion.heading,
                options: options
            } : {
                options: options
            };
        });
    }, [
        transformItems
    ]);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(()=>{
        if (initialData?.data) return Boolean(initialData.loading);
        return true;
    });
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $eUqFw.useState)(()=>{
        if (initialData?.data) return Boolean(initialData.error);
        return false;
    });
    const [options, setOptions] = (0, $eUqFw.useState)(()=>{
        if (initialData?.data) return transformToOptions(initialData.data);
        return [];
    });
    const handleOnFocus = (0, $eUqFw.useCallback)((focusEvent, sessionId)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        query$.current?.next({
            query: '',
            sessionId: sessionId,
            isImmediate: true
        });
    }, []);
    const handleOnChange = (0, $eUqFw.useCallback)((selectedOption, actionMeta, sessionId)=>{
        if (query$.current && isMulti) {
            if (!onChangeMulti) return;
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            query$.current.next({
                query: query.current || '',
                sessionId: sessionId,
                isImmediate: true
            });
            const selectedOptions = Array.isArray(selectedOption) ? selectedOption.map((item)=>$1ddf1cf19915b578$var$transformFromOption(item, actionMeta)) : []; // `[]` is sent from Ak when user clicks Clear button, `null` is sent when they delete items one by one. Previous behavior was to return empty array in both cases. This is simpler to handle for the consumers as well.
            onChangeMulti(selectedOptions, actionMeta);
        } else {
            if (!onChange || Array.isArray(selectedOption)) return;
            onChange(selectedOption && $1ddf1cf19915b578$var$transformFromOption(selectedOption, actionMeta), actionMeta);
        }
    }, [
        isMulti,
        onChange,
        onChangeMulti
    ]);
    const handleOnInputChange = (0, $eUqFw.useCallback)((inputValue, actionMeta, sessionId)=>{
        // This prevents us setting the selected value to nothing when the select loses focus. Previous implementation (via onFilterChange) did not call props.onFilterChange() in other cases
        if (actionMeta.action !== 'input-change' && actionMeta.action !== 'set-value') return;
        let lQuery = inputValue;
        if (changeQueryValue) lQuery = changeQueryValue(inputValue);
        query.current = lQuery;
        if (actionMeta.action === 'input-change') {
            // do not fetch when user selected a value
            setIsLoading(true);
            // need to do this here, otherwise loading state will be applied only after a debounce timeout, causing jank
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            query$.current?.next({
                query: lQuery,
                sessionId: sessionId
            });
        }
        onInputChange?.(lQuery, actionMeta);
    }, [
        changeQueryValue,
        onInputChange
    ]);
    const getSelectedValue = (0, $eUqFw.useCallback)(()=>{
        if (!value) return null;
        if (Array.isArray(value)) return value.map($1ddf1cf19915b578$var$transformToOption);
        return $1ddf1cf19915b578$var$transformToOption(value);
    }, [
        value
    ]);
    const doFormatOptionLabel = (0, $eUqFw.useCallback)((option, meta)=>{
        if (formatOptionLabel !== undefined) return formatOptionLabel(option, meta);
        if (!option.iconUrl) return option.label;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7nzO5.OptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7nzO5.ImgSpan), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
            src: option.iconUrl,
            alt: "",
            width: 2 * (0, $c9TLT.gridSize),
            height: 2 * (0, $c9TLT.gridSize),
            role: "none"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7nzO5.FlexSpan), null, option.label));
    }, [
        formatOptionLabel
    ]);
    // To run only once during init,
    const failedFetchMessage = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7nzO5.FailedFetchOptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $aIgWU.default).failedFetch), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            role: "button",
            href: window.location.href,
            onClick: ()=>window.location.reload()
        }, formatMessage((0, $aIgWU.default).reloadIssue)))), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Translation for the constructor code.
    // Will only run once at the time on intialisation
    // `constructor memo translation`
    (0, $eUqFw.useMemo)(()=>{
        query$.current = new (0, $70s4u.Subject)();
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        subscription.current = query$.current// @ts-expect-error - TS7031 - Binding element 'isImmediate' implicitly has an 'any' type.
        .debounce(({ isImmediate: isImmediate })=>isImmediate ? (0, $3JafE.Observable).empty() : (0, $3JafE.Observable).timer(debounceFetchSuggestionsTimeInRef.current || 0))// @ts-expect-error - TS7031 - Binding element 'lQuery' implicitly has an 'any' type. | TS7031 - Binding element 'sessionId' implicitly has an 'any' type.
        .switchMap(({ query: lQuery, sessionId: sessionId })=>{
            onDataRequestInRef.current?.({
                isInitial: query.current === null
            });
            setIsLoading(true);
            const fetchPromise = fetchSuggestionsInRef.current(lQuery, sessionId || undefined);
            return fetchPromise.then((suggestions)=>{
                setHasLastFetchFailed(false);
                return suggestions;
            }).catch((error)=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.select.transform-suggestions', 'Could not fetch or transform suggestions to display in select', error);
                additionalAnalyticsPropsInRef.current && (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.select.fetch-transform-suggestions.details', 'Could not fetch or transform retrieved data', {
                    ...additionalAnalyticsPropsInRef.current,
                    message: error.message
                });
                (0, $guiFP.default)({
                    meta: {
                        id: 'issueSelectFetchFailure',
                        packageName: 'jiraIssueInternalFieldSelect'
                    },
                    error: error,
                    attributes: {
                        ...additionalAnalyticsPropsInRef.current ?? {}
                    }
                });
                setHasLastFetchFailed(true);
                // Generate an option containing the error message if the suggestions fetch fails
                return [
                    {
                        items: [
                            {
                                content: failedFetchMessage,
                                value: '',
                                isDisabled: true
                            }
                        ]
                    }
                ];
            });
        }).subscribe((suggestions)=>{
            setOptions(transformToOptions(suggestions));
            setIsLoading(false);
            onDataLoadedInRef.current?.({
                isInitial: query.current === null
            });
        });
    }, [
        failedFetchMessage,
        transformToOptions
    ]);
    const doFilterOption = (0, $eUqFw.useCallback)((option)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        // at least need to ignore inputValue/query change to "" on "input-blur" - not to reset list to all items before closing the menu (causes flickr)
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string'.
        return filterOption?.(option, query.current || '');
    }, [
        filterOption,
        hasLastFetchFailed
    ]);
    // component did update translation
    (0, $eUqFw.useEffect)(()=>{
        if (initialData?.data && previousInitialData?.data) {
            const { loading: loading, error: error, data: data } = initialData;
            if (loading !== previousInitialData.loading || error !== previousInitialData.error) {
                setIsLoading(loading);
                setHasLastFetchFailed(error);
                setOptions(transformToOptions(data));
            }
        }
    }, [
        initialData,
        previousInitialData?.data,
        previousInitialData?.error,
        previousInitialData?.loading,
        transformToOptions
    ]);
    // Component did unmount translation
    (0, $eUqFw.useEffect)(()=>()=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            subscription.current?.unsubscribe();
        }, []);
    const selectField = (0, $eUqFw.useMemo)(()=>{
        const { placeholder: lPlaceholder = '', noOptionsMessage: // undefined will show non-i18n "Select..." text
        noOptionsMessage = ()=>formatMessage((0, $aIgWU.default).empty), loadingMessage: loadingMessage = ()=>formatMessage((0, $9JyRh.default).loading), fieldId: lFieldId, onChangeMulti: lOnChangeMulti, invalidMessage: lInvalidMessage, isOpen: isOpen, isInvalid: isInvalid, hasAutocomplete: hasAutocomplete, portalElement: portalElement, fetchSuggestions: lFetchSuggestions, debounceFetchSuggestionsTime: lDebounceFetchSuggestionsTime, changeQueryValue: lChangeQueryValue, errorMessagePosition: lErrorMessagePosition, ariaLabel: lAriaLabel = '', spacing: spacing = (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i') ? 'compact' : 'default', ...selectProps } = props;
        const validationState = invalidMessage ? 'error' : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jqJe9.default), {
            ...$1ddf1cf19915b578$export$d69279bb4fae6c37,
            ...selectProps,
            filterOption: doFilterOption,
            key: fieldId,
            fieldId: fieldId,
            options: options,
            value: getSelectedValue(),
            styles: (0, $52Iro.mergeReactSelectStyles)((0, $7nzO5.defaultSelectStyles), (0, $7nzO5.issueFieldSelectStyles), props.styles),
            isLoading: isLoading,
            isSearchable: hasAutocomplete,
            isInvalid: isInvalid,
            menuIsOpen: isOpen,
            menuPortalTarget: portalElement,
            menuPlacement: "auto",
            placeholder: lPlaceholder,
            noOptionsMessage: noOptionsMessage,
            loadingMessage: loadingMessage,
            validationState: validationState,
            formatOptionLabel: doFormatOptionLabel,
            // @ts-expect-error - TS2322 - Type '(selectedOption: Option | Option[] | null, actionMeta: ActionMeta<Option>, sessionId?: string | undefined) => void' is not assignable to type '((selectedOption: Option | readonly Option[] | null, arg2: ActionMeta<Option>) => void) & ((selectedOption: Option | Option[] | null, actionMeta: ActionMeta<...>, sessionId?: string | undefined) => void)'.
            onChange: handleOnChange,
            onFocus: handleOnFocus,
            onInputChange: handleOnInputChange,
            "aria-label": lAriaLabel,
            spacing: spacing
        });
    }, [
        doFilterOption,
        doFormatOptionLabel,
        fieldId,
        formatMessage,
        getSelectedValue,
        handleOnChange,
        handleOnFocus,
        handleOnInputChange,
        invalidMessage,
        isLoading,
        options,
        props
    ]);
    const errorMessage = (0, $eUqFw.useMemo)(()=>invalidMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7nzO5.ErrorMessageWrapper), {
            key: `${fieldId}-error-message`,
            errorMessagePosition: errorMessagePosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, invalidMessage)) : null, [
        errorMessagePosition,
        fieldId,
        invalidMessage
    ]);
    const components = [
        selectField
    ];
    errorMessagePosition === 'top' ? // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'Element'.
    components.unshift(errorMessage) : // @ts-expect-error - TS2345 - Argument of type 'Element | null' is not assignable to parameter of type 'Element'.
    components.push(errorMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, components);
};
var $1ddf1cf19915b578$export$2e2bcd8739ae039 = $1ddf1cf19915b578$export$2073539080b8c707;

});
parcelRegister("9JyRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dd98b27101186e6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4dd98b27101186e6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noOptions: {
        "id": "common.components.picker.base.no-options",
        "defaultMessage": "No results"
    },
    loading: {
        "id": "common.components.picker.base.loading",
        "defaultMessage": "Searching..."
    },
    defaultPlaceholder: {
        "id": "common.components.picker.base.default-placeholder",
        "defaultMessage": "Select..."
    },
    clearSelected: {
        "id": "common.components.picker.base.clear-selected",
        "defaultMessage": "Clear selected"
    }
});

});

parcelRegister("kDIIr", function(module, exports) {

$parcel$export(module.exports, "filterOptionByLabelAndFilterValues", () => $825d712365a3dc25$export$58bb91b619b113f6);
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $825d712365a3dc25$var$matchesProperty = (val, inputValueIgnoredCase)=>// label can be Object for new option in CreatableSelect
    typeof val === 'string' && val// no need to .trim() since input is already trimmed and we search for .includes() so it does not matter if field has leading or trailing spaces
    .toLowerCase().includes(inputValueIgnoredCase);
const $825d712365a3dc25$export$58bb91b619b113f6 = (option, inputValue)=>{
    if (option.data && option.data.__isNew__ === true) return true;
    // we do trim() and lowerCase() to match ignoreCase: true, and trim: true default behavior in react-select: https://github.com/JedWatson/react-select/blob/b7868d23ccd0b9e623b277f971e89020d426fbdb/packages/react-select/src/filters.js
    const inputValueIgnoredCase = inputValue.trim().toLowerCase();
    if ($825d712365a3dc25$var$matchesProperty(option.label, inputValueIgnoredCase)) return true;
    return option.data && option.data.filterValues ? option.data.filterValues.some((filterValue)=>$825d712365a3dc25$var$matchesProperty(filterValue, inputValueIgnoredCase)) : false;
};

});

parcelRegister("aIgWU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e619cae8beca61c5$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $e619cae8beca61c5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    empty: {
        "id": "issue.views.field.select.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue.views.field.select.failed-fetch",
        "defaultMessage": "Search failed."
    },
    reloadIssue: {
        "id": "issue.views.field.select.reload-issue",
        "defaultMessage": "Try reloading the issue."
    }
});

});

parcelRegister("jqJe9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8efaa17fcac698a4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $hompL = parcelRequire("hompL");

var $2jDha = parcelRequire("2jDha");

var $1EOkb = parcelRequire("1EOkb");

var $eGI9v = parcelRequire("eGI9v");

var $8uNQc = parcelRequire("8uNQc");

var $azx3n = parcelRequire("azx3n");

var $jMP2a = parcelRequire("jMP2a");

var $e349w = parcelRequire("e349w");

var $3z5LL = parcelRequire("3z5LL");
const $8efaa17fcac698a4$var$analyticsProps = {
    onChange: 'valueChanged',
    onInputChange: 'inputChanged',
    onMenuOpen: 'menuOpened',
    onMenuClose: 'menuClosed'
};
const $8efaa17fcac698a4$var$SelectWithFooterAnalytics = (0, $eGI9v.default)('select', $8efaa17fcac698a4$var$analyticsProps)((0, $e349w.default));
const $8efaa17fcac698a4$var$CreatableSelectWithAnalytics = (0, $eGI9v.default)('select', $8efaa17fcac698a4$var$analyticsProps)((0, $1EOkb.default));
const $8efaa17fcac698a4$var$fakeAction = {
    action: 'fake-action'
};
const $8efaa17fcac698a4$export$188f9cea2089f4b2 = 20;
class $8efaa17fcac698a4$export$ad1829ce08a68011 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isLoading: false,
            createAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            optionValuesSafeForAnalytics: false,
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onMenuClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    constructor(props){
        super(props);
        this.getDefaultAnalyticsAttributes = (query)=>{
            const { fieldId: fieldId, value: value, isLoading: isLoading, optionValuesSafeForAnalytics: optionValuesSafeForAnalytics } = this.props;
            const queryAttributes = {
                queryLength: query.length,
                queryHash: query === '' ? query : (0, $azx3n.memoizedHashString)(query)
            };
            const selectedOptions = (0, $3z5LL.flattenSelectedOptions)(value);
            let filteredOptions = (0, $3z5LL.filterOptions)(this.flatOptions, query);
            const optionsLength = filteredOptions.length;
            // truncate to reduce payload size
            filteredOptions = filteredOptions.slice(0, $8efaa17fcac698a4$export$188f9cea2089f4b2);
            const safeFilteredOptions = (0, $3z5LL.getSafeOptionsForAnalytics)(filteredOptions, optionValuesSafeForAnalytics);
            return {
                fieldId: fieldId,
                componentName: 'select',
                packageName: '@atlaskit/select',
                options: safeFilteredOptions,
                optionsLength: optionsLength,
                optionsLengths: (0, $3z5LL.getOptionValuesLengths)(filteredOptions),
                optionIds: (0, $3z5LL.getOptionIdsForAnalytics)(filteredOptions),
                selectedOptions: (0, $3z5LL.getSafeOptionsForAnalytics)(selectedOptions, optionValuesSafeForAnalytics),
                selectedOptionsLengths: (0, $3z5LL.getOptionValuesLengths)(selectedOptions),
                selectedOptionIds: (0, $3z5LL.getOptionIdsForAnalytics)(selectedOptions),
                sessionId: this.sessionId,
                truncationSize: $8efaa17fcac698a4$export$188f9cea2089f4b2,
                isLoading: isLoading,
                ...queryAttributes,
                optionValuesSafeForAnalytics: optionValuesSafeForAnalytics,
                ...this.props.additionalAnalyticsProps
            };
        };
        this.getItemOrder = (selectedItem)=>{
            const matchedIndexes = [];
            this.flatOptions.forEach((option, index)=>{
                const filterValues = option.filterValues || [];
                // @ts-expect-error - TS2345 - Argument of type 'Value' is not assignable to parameter of type 'string'.
                if (option.value === selectedItem.value || filterValues.includes(selectedItem.value)) matchedIndexes.push(index);
            });
            return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
        };
        this.startSession = ()=>{
            this.sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
            this.sessionStartedAt = (0, $8uNQc.default).now();
            this.fireTrackAnalyticsEvent(this.props.createAnalyticsEvent({
                action: 'started'
            }), 'started', 'optionSelectionSession');
        };
        this.endSession = ()=>{
            if (this.sessionId) {
                const elapsedTime = this.sessionStartedAt ? (0, $8uNQc.default).now() - this.sessionStartedAt : 0;
                this.fireTrackAnalyticsEvent(this.props.createAnalyticsEvent({
                    action: 'ended'
                }), 'ended', 'optionSelectionSession', {
                    elapsedTime: elapsedTime,
                    ...this.props.additionalAnalyticsProps
                });
            }
            this.sessionStartedAt = 0;
            this.sessionId = undefined;
        };
        this.flatOptions = [];
        this.sessionId = undefined;
        this.queryAtSetValue = '';
        this.query = '';
        this.sessionStartedAt = 0;
        this.isOpened = false;
        this.fireInputChangedEvent = (query, actionMeta, analyticsEvent)=>{
            if (actionMeta.action === 'set-value') // save query for option changed analytic
            this.queryAtSetValue = this.query;
            this.query = query;
            analyticsEvent.update({
                action: 'changed',
                actionSubject: 'filter'
            });
            this.fireAnalyticsEvent(analyticsEvent, this.query);
            return this.sessionId;
        };
        this.restartSession = ()=>{
            this.endSession();
            if (this.props.menuIsOpen) {
                // keep opened
                this.isOpened = true;
                this.startSession();
            }
        };
        this.fireOptionCreatedEvent = (option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'created',
                actionSubject: 'option'
            });
            const oldSessionId = this.sessionId;
            this.restartSession();
            this.fireAnalyticsEvent(analyticsEvent, this.queryAtSetValue, {
                selectedOption: (0, $3z5LL.getSafeValue)(option.value, this.props.optionValuesSafeForAnalytics),
                sessionId: oldSessionId
            });
        };
        this.fireOptionRemovedEvent = (removedOption, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'removed',
                actionSubject: 'option'
            });
            this.fireAnalyticsEvent(analyticsEvent, this.query, {
                removedItem: removedOption ? (0, $3z5LL.getSafeValue)(removedOption.value, this.props.optionValuesSafeForAnalytics) : undefined
            });
        };
        this.fireOptionSelectedEvent = (option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'changed',
                actionSubject: 'option'
            });
            const oldSessionId = this.sessionId;
            this.restartSession();
            this.fireAnalyticsEvent(analyticsEvent, this.queryAtSetValue, {
                selectedOrder: this.getItemOrder(option),
                selectedOption: (0, $3z5LL.getSafeValue)(option.value, this.props.optionValuesSafeForAnalytics),
                selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
                sessionId: oldSessionId
            });
        };
        this.fireOpenChangedEvent = (event, analyticsEvent)=>{
            if (event.isOpen && !this.isOpened) this.startSession();
            this.isOpened = event.isOpen;
            analyticsEvent.update({
                action: event.isOpen ? 'opened' : 'closed',
                actionSubject: 'optionSelect',
                attributes: this.getDefaultAnalyticsAttributes(this.query)
            });
            this.fireAnalyticsEvent(analyticsEvent, this.query);
        };
        this.onChange = (selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
            const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
            const oldSessionid = this.sessionId;
            switch(actionMeta.action){
                case 'create-option':
                    if (selectedOption !== null) this.fireOptionCreatedEvent(selectedOption, analyticsEvent);
                    break;
                case 'remove-value':
                case 'pop-value':
                case 'deselect-option':
                    this.fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                    break;
                case 'select-option':
                    if (selectedOption !== null) this.fireOptionSelectedEvent(selectedOption, analyticsEvent);
                    break;
                default:
                    break;
            }
            if (this.props.onChange) this.props.onChange(selectedOptionOrOptions, actionMeta, oldSessionid);
        };
        this.onInputChange = (value, actionMeta, analyticsEvent)=>{
            const { onInputChange: onInputChange } = this.props;
            if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') this.fireInputChangedEvent(value, actionMeta, analyticsEvent);
            onInputChange(value, actionMeta, this.sessionId);
        };
        this.onMenuOpen = (analyticsEvent)=>{
            this.fireOpenChangedEvent({
                isOpen: true
            }, analyticsEvent);
            const { onMenuOpen: onMenuOpen } = this.props;
            if (onMenuOpen) onMenuOpen(analyticsEvent);
        };
        this.onMenuClose = (analyticsEvent)=>{
            this.fireOpenChangedEvent({
                isOpen: false
            }, analyticsEvent);
            const { onMenuClose: onMenuClose } = this.props;
            if (onMenuClose) onMenuClose(analyticsEvent);
        };
        this.onFocus = (focusEvent)=>{
            this.props.onFocus(focusEvent, this.sessionId);
        };
        this.flatOptions = (0, $3z5LL.flattenOptions)(this.props.options);
        // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
        this.isOpened = props.menuIsOpen;
        if (this.isOpened) {
            this.startSession();
            this.fireInputChangedEvent('', $8efaa17fcac698a4$var$fakeAction, this.props.createAnalyticsEvent({}));
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.options !== prevProps.options) this.flatOptions = (0, $3z5LL.flattenOptions)(this.props.options);
    }
    componentWillUnmount() {
        this.endSession();
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fireAnalyticsEvent(event, query, extraAttributes = {}) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attributes = {
            ...this.getDefaultAnalyticsAttributes(query),
            ...extraAttributes
        };
        (0, $jMP2a.fireUIAnalytics)(event, attributes);
    }
    fireTrackAnalyticsEvent(analyticsEvent, action, actionSubject, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    extraAttributes) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attributes = {
            ...this.getDefaultAnalyticsAttributes(this.query),
            ...extraAttributes
        };
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
    }
    render() {
        const { canCreateNewItem: canCreateNewItem, createAnalyticsEvent: createAnalyticsEvent, ...restProps } = this.props;
        const SelectComponentWithAnalytics = canCreateNewItem ? $8efaa17fcac698a4$var$CreatableSelectWithAnalytics : $8efaa17fcac698a4$var$SelectWithFooterAnalytics;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectComponentWithAnalytics, {
            ...restProps,
            onFocus: this.onFocus,
            // @ts-expect-error - Type '(selectedOptionOrOptions: Option | Option[] | null, actionMeta: ActionMeta<Option>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(selectedOption: Option | Group | readonly (Option | Group)[] | null, arg2: ActionMeta<Option | Group>, args_2: UIAnalyticsEvent) => any'.
            onChange: this.onChange,
            // @ts-expect-error - Type '(value: string, actionMeta: ActionMeta<Option>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(value: string, arg2: ActionMeta<Option | Group>, args_2: UIAnalyticsEvent) => any'.
            onInputChange: this.onInputChange,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose
        });
    }
}
var // @ts-expect-error - Argument of type 'typeof SelectWithAnalyticsView' is not assignable to parameter of type 'ComponentType<Props> & typeof SelectWithAnalyticsView'.
$8efaa17fcac698a4$export$2e2bcd8739ae039 = (0, $2jDha.default)()($8efaa17fcac698a4$export$ad1829ce08a68011);

});
parcelRegister("azx3n", function(module, exports) {

$parcel$export(module.exports, "memoizedHashString", () => $403b450273ddd0e6$export$c9e165da390f6283);

var $aHQJS = parcelRequire("aHQJS");

var $5iWql = parcelRequire("5iWql");

var $e91YZ = parcelRequire("e91YZ");
const $403b450273ddd0e6$var$getCloudId = (0, $5iWql.default)(()=>{
    const { cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    return cloudId;
});
const $403b450273ddd0e6$export$c9e165da390f6283 = (attribute)=>{
    const cloudId = $403b450273ddd0e6$var$getCloudId();
    const hash = (0, $aHQJS.createHash)('sha256').update(`${cloudId}_${attribute.trim()}`).digest('hex');
    return hash;
};

});
parcelRegister("aHQJS", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $7cb6d463ef497bec$export$5f828d93ff035aa8, (v) => $7cb6d463ef497bec$export$5f828d93ff035aa8 = v);
$parcel$export(module.exports, "rng", () => $7cb6d463ef497bec$export$cd94982b18c6332c, (v) => $7cb6d463ef497bec$export$cd94982b18c6332c = v);
$parcel$export(module.exports, "pseudoRandomBytes", () => $7cb6d463ef497bec$export$1d518568e4f529b0, (v) => $7cb6d463ef497bec$export$1d518568e4f529b0 = v);
$parcel$export(module.exports, "prng", () => $7cb6d463ef497bec$export$5285b6d41c912b41, (v) => $7cb6d463ef497bec$export$5285b6d41c912b41 = v);
$parcel$export(module.exports, "createHash", () => $7cb6d463ef497bec$export$2fb37efbf6ae0c0e, (v) => $7cb6d463ef497bec$export$2fb37efbf6ae0c0e = v);
$parcel$export(module.exports, "Hash", () => $7cb6d463ef497bec$export$ab85ecd77ce6a5cd, (v) => $7cb6d463ef497bec$export$ab85ecd77ce6a5cd = v);
$parcel$export(module.exports, "createHmac", () => $7cb6d463ef497bec$export$da39cf97e1eb7c91, (v) => $7cb6d463ef497bec$export$da39cf97e1eb7c91 = v);
$parcel$export(module.exports, "Hmac", () => $7cb6d463ef497bec$export$52a9039d7177394f, (v) => $7cb6d463ef497bec$export$52a9039d7177394f = v);
$parcel$export(module.exports, "getHashes", () => $7cb6d463ef497bec$export$f7201db400317331, (v) => $7cb6d463ef497bec$export$f7201db400317331 = v);
$parcel$export(module.exports, "pbkdf2", () => $7cb6d463ef497bec$export$448fa22aedc9dbca, (v) => $7cb6d463ef497bec$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $7cb6d463ef497bec$export$b80c7ba289c8fa56, (v) => $7cb6d463ef497bec$export$b80c7ba289c8fa56 = v);
$parcel$export(module.exports, "Cipher", () => $7cb6d463ef497bec$export$26e5786e8ac8e530, (v) => $7cb6d463ef497bec$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipher", () => $7cb6d463ef497bec$export$bdd223f16383713e, (v) => $7cb6d463ef497bec$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipheriv", () => $7cb6d463ef497bec$export$20533d26f07f1ee0, (v) => $7cb6d463ef497bec$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createCipheriv", () => $7cb6d463ef497bec$export$2f64596b8cbf08b4, (v) => $7cb6d463ef497bec$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Decipher", () => $7cb6d463ef497bec$export$2ce6d8d0e8b04e1a, (v) => $7cb6d463ef497bec$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipher", () => $7cb6d463ef497bec$export$12ada9414fbc594c, (v) => $7cb6d463ef497bec$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipheriv", () => $7cb6d463ef497bec$export$f5e7e39d57cd9700, (v) => $7cb6d463ef497bec$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "createDecipheriv", () => $7cb6d463ef497bec$export$36b6d6ef312eab39, (v) => $7cb6d463ef497bec$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $7cb6d463ef497bec$export$58a258485f1e49f6, (v) => $7cb6d463ef497bec$export$58a258485f1e49f6 = v);
$parcel$export(module.exports, "listCiphers", () => $7cb6d463ef497bec$export$dedd8dc3dc62b370, (v) => $7cb6d463ef497bec$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "DiffieHellmanGroup", () => $7cb6d463ef497bec$export$971862a2fcb1bb40, (v) => $7cb6d463ef497bec$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $7cb6d463ef497bec$export$c6ff6a88acbeaf40, (v) => $7cb6d463ef497bec$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $7cb6d463ef497bec$export$fdc27893e98845cc, (v) => $7cb6d463ef497bec$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $7cb6d463ef497bec$export$6671fb9a1323bed, (v) => $7cb6d463ef497bec$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $7cb6d463ef497bec$export$d74daf141a551db, (v) => $7cb6d463ef497bec$export$d74daf141a551db = v);
$parcel$export(module.exports, "createSign", () => $7cb6d463ef497bec$export$45df7cae684751af, (v) => $7cb6d463ef497bec$export$45df7cae684751af = v);
$parcel$export(module.exports, "Sign", () => $7cb6d463ef497bec$export$1db683ad541682f6, (v) => $7cb6d463ef497bec$export$1db683ad541682f6 = v);
$parcel$export(module.exports, "createVerify", () => $7cb6d463ef497bec$export$6f65485f87568e37, (v) => $7cb6d463ef497bec$export$6f65485f87568e37 = v);
$parcel$export(module.exports, "Verify", () => $7cb6d463ef497bec$export$91a8e56769aeb334, (v) => $7cb6d463ef497bec$export$91a8e56769aeb334 = v);
$parcel$export(module.exports, "createECDH", () => $7cb6d463ef497bec$export$2d4117e99c2179e4, (v) => $7cb6d463ef497bec$export$2d4117e99c2179e4 = v);
$parcel$export(module.exports, "publicEncrypt", () => $7cb6d463ef497bec$export$512823e338ddb1b7, (v) => $7cb6d463ef497bec$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateEncrypt", () => $7cb6d463ef497bec$export$9d0e0c0c4a8d30f3, (v) => $7cb6d463ef497bec$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $7cb6d463ef497bec$export$b9d55ff329113abd, (v) => $7cb6d463ef497bec$export$b9d55ff329113abd = v);
$parcel$export(module.exports, "privateDecrypt", () => $7cb6d463ef497bec$export$7efb24e2fddf99b9, (v) => $7cb6d463ef497bec$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "randomFill", () => $7cb6d463ef497bec$export$bb1abf2ce84fc7e8, (v) => $7cb6d463ef497bec$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $7cb6d463ef497bec$export$2f7171e78e524d5e, (v) => $7cb6d463ef497bec$export$2f7171e78e524d5e = v);
$parcel$export(module.exports, "createCredentials", () => $7cb6d463ef497bec$export$e1d879b482f37d98, (v) => $7cb6d463ef497bec$export$e1d879b482f37d98 = v);
$parcel$export(module.exports, "constants", () => $7cb6d463ef497bec$export$1a988e7317c65621, (v) => $7cb6d463ef497bec$export$1a988e7317c65621 = v);
var $7cb6d463ef497bec$export$5f828d93ff035aa8;
var $7cb6d463ef497bec$export$cd94982b18c6332c;
var $7cb6d463ef497bec$export$1d518568e4f529b0;
var $7cb6d463ef497bec$export$5285b6d41c912b41;
var $7cb6d463ef497bec$export$2fb37efbf6ae0c0e;
var $7cb6d463ef497bec$export$ab85ecd77ce6a5cd;
var $7cb6d463ef497bec$export$da39cf97e1eb7c91;
var $7cb6d463ef497bec$export$52a9039d7177394f;
var $7cb6d463ef497bec$export$f7201db400317331;
var $7cb6d463ef497bec$export$448fa22aedc9dbca;
var $7cb6d463ef497bec$export$b80c7ba289c8fa56;
var $7cb6d463ef497bec$export$26e5786e8ac8e530;
var $7cb6d463ef497bec$export$bdd223f16383713e;
var $7cb6d463ef497bec$export$20533d26f07f1ee0;
var $7cb6d463ef497bec$export$2f64596b8cbf08b4;
var $7cb6d463ef497bec$export$2ce6d8d0e8b04e1a;
var $7cb6d463ef497bec$export$12ada9414fbc594c;
var $7cb6d463ef497bec$export$f5e7e39d57cd9700;
var $7cb6d463ef497bec$export$36b6d6ef312eab39;
var $7cb6d463ef497bec$export$58a258485f1e49f6;
var $7cb6d463ef497bec$export$dedd8dc3dc62b370;
var $7cb6d463ef497bec$export$971862a2fcb1bb40;
var $7cb6d463ef497bec$export$c6ff6a88acbeaf40;
var $7cb6d463ef497bec$export$fdc27893e98845cc;
var $7cb6d463ef497bec$export$6671fb9a1323bed;
var $7cb6d463ef497bec$export$d74daf141a551db;
var $7cb6d463ef497bec$export$45df7cae684751af;
var $7cb6d463ef497bec$export$1db683ad541682f6;
var $7cb6d463ef497bec$export$6f65485f87568e37;
var $7cb6d463ef497bec$export$91a8e56769aeb334;
var $7cb6d463ef497bec$export$2d4117e99c2179e4;
var $7cb6d463ef497bec$export$512823e338ddb1b7;
var $7cb6d463ef497bec$export$9d0e0c0c4a8d30f3;
var $7cb6d463ef497bec$export$b9d55ff329113abd;
var $7cb6d463ef497bec$export$7efb24e2fddf99b9;
var $7cb6d463ef497bec$export$bb1abf2ce84fc7e8;
var $7cb6d463ef497bec$export$2f7171e78e524d5e;
var $7cb6d463ef497bec$export$e1d879b482f37d98;
var $7cb6d463ef497bec$export$1a988e7317c65621;
'use strict';

$7cb6d463ef497bec$export$5f828d93ff035aa8 = $7cb6d463ef497bec$export$cd94982b18c6332c = $7cb6d463ef497bec$export$1d518568e4f529b0 = $7cb6d463ef497bec$export$5285b6d41c912b41 = (parcelRequire("ugwNY"));

$7cb6d463ef497bec$export$2fb37efbf6ae0c0e = $7cb6d463ef497bec$export$ab85ecd77ce6a5cd = (parcelRequire("cnL2y"));

$7cb6d463ef497bec$export$da39cf97e1eb7c91 = $7cb6d463ef497bec$export$52a9039d7177394f = (parcelRequire("jPoqK"));

var $61Iwu = parcelRequire("61Iwu");
var $7cb6d463ef497bec$var$algoKeys = Object.keys($61Iwu);
var $7cb6d463ef497bec$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($7cb6d463ef497bec$var$algoKeys);
$7cb6d463ef497bec$export$f7201db400317331 = function() {
    return $7cb6d463ef497bec$var$hashes;
};

var $8bTm7 = parcelRequire("8bTm7");
$7cb6d463ef497bec$export$448fa22aedc9dbca = $8bTm7.pbkdf2;
$7cb6d463ef497bec$export$b80c7ba289c8fa56 = $8bTm7.pbkdf2Sync;

var $9rGLx = parcelRequire("9rGLx");
$7cb6d463ef497bec$export$26e5786e8ac8e530 = $9rGLx.Cipher;
$7cb6d463ef497bec$export$bdd223f16383713e = $9rGLx.createCipher;
$7cb6d463ef497bec$export$20533d26f07f1ee0 = $9rGLx.Cipheriv;
$7cb6d463ef497bec$export$2f64596b8cbf08b4 = $9rGLx.createCipheriv;
$7cb6d463ef497bec$export$2ce6d8d0e8b04e1a = $9rGLx.Decipher;
$7cb6d463ef497bec$export$12ada9414fbc594c = $9rGLx.createDecipher;
$7cb6d463ef497bec$export$f5e7e39d57cd9700 = $9rGLx.Decipheriv;
$7cb6d463ef497bec$export$36b6d6ef312eab39 = $9rGLx.createDecipheriv;
$7cb6d463ef497bec$export$58a258485f1e49f6 = $9rGLx.getCiphers;
$7cb6d463ef497bec$export$dedd8dc3dc62b370 = $9rGLx.listCiphers;

var $fPWK2 = parcelRequire("fPWK2");
$7cb6d463ef497bec$export$971862a2fcb1bb40 = $fPWK2.DiffieHellmanGroup;
$7cb6d463ef497bec$export$c6ff6a88acbeaf40 = $fPWK2.createDiffieHellmanGroup;
$7cb6d463ef497bec$export$fdc27893e98845cc = $fPWK2.getDiffieHellman;
$7cb6d463ef497bec$export$6671fb9a1323bed = $fPWK2.createDiffieHellman;
$7cb6d463ef497bec$export$d74daf141a551db = $fPWK2.DiffieHellman;

var $cQURD = parcelRequire("cQURD");
$7cb6d463ef497bec$export$45df7cae684751af = $cQURD.createSign;
$7cb6d463ef497bec$export$1db683ad541682f6 = $cQURD.Sign;
$7cb6d463ef497bec$export$6f65485f87568e37 = $cQURD.createVerify;
$7cb6d463ef497bec$export$91a8e56769aeb334 = $cQURD.Verify;

$7cb6d463ef497bec$export$2d4117e99c2179e4 = (parcelRequire("ks6qZ"));

var $bZRnR = parcelRequire("bZRnR");
$7cb6d463ef497bec$export$512823e338ddb1b7 = $bZRnR.publicEncrypt;
$7cb6d463ef497bec$export$9d0e0c0c4a8d30f3 = $bZRnR.privateEncrypt;
$7cb6d463ef497bec$export$b9d55ff329113abd = $bZRnR.publicDecrypt;
$7cb6d463ef497bec$export$7efb24e2fddf99b9 = $bZRnR.privateDecrypt;

var $hF130 = parcelRequire("hF130");
$7cb6d463ef497bec$export$bb1abf2ce84fc7e8 = $hF130.randomFill;
$7cb6d463ef497bec$export$2f7171e78e524d5e = $hF130.randomFillSync;
$7cb6d463ef497bec$export$e1d879b482f37d98 = function() {
    throw new Error([
        'sorry, createCredentials is not implemented yet',
        'we accept pull requests',
        'https://github.com/crypto-browserify/crypto-browserify'
    ].join('\n'));
};
$7cb6d463ef497bec$export$1a988e7317c65621 = {
    'DH_CHECK_P_NOT_SAFE_PRIME': 2,
    'DH_CHECK_P_NOT_PRIME': 1,
    'DH_UNABLE_TO_CHECK_GENERATOR': 4,
    'DH_NOT_SUITABLE_GENERATOR': 8,
    'NPN_ENABLED': 1,
    'ALPN_ENABLED': 1,
    'RSA_PKCS1_PADDING': 1,
    'RSA_SSLV23_PADDING': 2,
    'RSA_NO_PADDING': 3,
    'RSA_PKCS1_OAEP_PADDING': 4,
    'RSA_X931_PADDING': 5,
    'RSA_PKCS1_PSS_PADDING': 6,
    'POINT_CONVERSION_COMPRESSED': 2,
    'POINT_CONVERSION_UNCOMPRESSED': 4,
    'POINT_CONVERSION_HYBRID': 6
};

});
parcelRegister("ugwNY", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $05af9f9868efc57c$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $05af9f9868efc57c$var$MAX_UINT32 = 4294967295;
function $05af9f9868efc57c$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $ijh2q = parcelRequire("ijh2q");
var $05af9f9868efc57c$require$Buffer = $ijh2q.Buffer;
var $05af9f9868efc57c$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($05af9f9868efc57c$var$crypto && $05af9f9868efc57c$var$crypto.getRandomValues) module.exports = $05af9f9868efc57c$var$randomBytes;
else module.exports = $05af9f9868efc57c$var$oldBrowser;
function $05af9f9868efc57c$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $05af9f9868efc57c$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $05af9f9868efc57c$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $05af9f9868efc57c$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $05af9f9868efc57c$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $05af9f9868efc57c$var$crypto.getRandomValues(bytes.slice(generated, generated + $05af9f9868efc57c$var$MAX_BYTES));
        else $05af9f9868efc57c$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $2fFJv.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("ijh2q", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $aul3P = parcelRequire("aul3P");
var $d54737c7644fd369$var$Buffer = $aul3P.Buffer;
// alternative to using Object.keys for old browsers
function $d54737c7644fd369$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($d54737c7644fd369$var$Buffer.from && $d54737c7644fd369$var$Buffer.alloc && $d54737c7644fd369$var$Buffer.allocUnsafe && $d54737c7644fd369$var$Buffer.allocUnsafeSlow) module.exports = $aul3P;
else {
    // Copy properties from require('buffer')
    $d54737c7644fd369$var$copyProps($aul3P, module.exports);
    module.exports.Buffer = $d54737c7644fd369$var$SafeBuffer;
}
function $d54737c7644fd369$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $d54737c7644fd369$var$Buffer(arg, encodingOrOffset, length);
}
$d54737c7644fd369$var$SafeBuffer.prototype = Object.create($d54737c7644fd369$var$Buffer.prototype);
// Copy static methods from Buffer
$d54737c7644fd369$var$copyProps($d54737c7644fd369$var$Buffer, $d54737c7644fd369$var$SafeBuffer);
$d54737c7644fd369$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $d54737c7644fd369$var$Buffer(arg, encodingOrOffset, length);
};
$d54737c7644fd369$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $d54737c7644fd369$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$d54737c7644fd369$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $d54737c7644fd369$var$Buffer(size);
};
$d54737c7644fd369$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $aul3P.SlowBuffer(size);
};

});


parcelRegister("cnL2y", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $903c1f32ad17f34f$require$Buffer = $aul3P.Buffer;
'use strict';

var $lyUaN = parcelRequire("lyUaN");

var $6Kk1A = parcelRequire("6Kk1A");

var $bGrC1 = parcelRequire("bGrC1");

var $lqV5D = parcelRequire("lqV5D");

var $7hBrF = parcelRequire("7hBrF");
function $903c1f32ad17f34f$var$HashNoConstructor(hash) {
    $7hBrF.call(this, 'digest');
    this._hash = hash;
    this.buffers = [];
}
$lyUaN($903c1f32ad17f34f$var$HashNoConstructor, $7hBrF);
$903c1f32ad17f34f$var$HashNoConstructor.prototype._update = function(data) {
    this.buffers.push(data);
};
$903c1f32ad17f34f$var$HashNoConstructor.prototype._final = function() {
    var buf = $903c1f32ad17f34f$require$Buffer.concat(this.buffers);
    var r = this._hash(buf);
    this.buffers = null;
    return r;
};
function $903c1f32ad17f34f$var$Hash(hash) {
    $7hBrF.call(this, 'digest');
    this._hash = hash;
}
$lyUaN($903c1f32ad17f34f$var$Hash, $7hBrF);
$903c1f32ad17f34f$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$903c1f32ad17f34f$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $903c1f32ad17f34f$var$HashNoConstructor($6Kk1A);
    if (alg === 'rmd160' || alg === 'ripemd160') return new $903c1f32ad17f34f$var$Hash(new $bGrC1());
    return new $903c1f32ad17f34f$var$Hash($lqV5D(alg));
};

});
parcelRegister("lyUaN", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("6Kk1A", function(module, exports) {
'use strict';

var $9nTll = parcelRequire("9nTll");
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */ function $4e969272193b5eb7$var$core_md5(x, len) {
    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    for(var i = 0; i < x.length; i += 16){
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;
        a = $4e969272193b5eb7$var$md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
        d = $4e969272193b5eb7$var$md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = $4e969272193b5eb7$var$md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = $4e969272193b5eb7$var$md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = $4e969272193b5eb7$var$md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = $4e969272193b5eb7$var$md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = $4e969272193b5eb7$var$md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = $4e969272193b5eb7$var$md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = $4e969272193b5eb7$var$md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = $4e969272193b5eb7$var$md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = $4e969272193b5eb7$var$md5_ff(c, d, a, b, x[i + 10], 17, -42063);
        b = $4e969272193b5eb7$var$md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = $4e969272193b5eb7$var$md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = $4e969272193b5eb7$var$md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = $4e969272193b5eb7$var$md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = $4e969272193b5eb7$var$md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = $4e969272193b5eb7$var$md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = $4e969272193b5eb7$var$md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = $4e969272193b5eb7$var$md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = $4e969272193b5eb7$var$md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
        a = $4e969272193b5eb7$var$md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = $4e969272193b5eb7$var$md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = $4e969272193b5eb7$var$md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = $4e969272193b5eb7$var$md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = $4e969272193b5eb7$var$md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = $4e969272193b5eb7$var$md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = $4e969272193b5eb7$var$md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = $4e969272193b5eb7$var$md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = $4e969272193b5eb7$var$md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = $4e969272193b5eb7$var$md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = $4e969272193b5eb7$var$md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = $4e969272193b5eb7$var$md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = $4e969272193b5eb7$var$md5_hh(a, b, c, d, x[i + 5], 4, -378558);
        d = $4e969272193b5eb7$var$md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = $4e969272193b5eb7$var$md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = $4e969272193b5eb7$var$md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = $4e969272193b5eb7$var$md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = $4e969272193b5eb7$var$md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = $4e969272193b5eb7$var$md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = $4e969272193b5eb7$var$md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = $4e969272193b5eb7$var$md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = $4e969272193b5eb7$var$md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
        c = $4e969272193b5eb7$var$md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = $4e969272193b5eb7$var$md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = $4e969272193b5eb7$var$md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = $4e969272193b5eb7$var$md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = $4e969272193b5eb7$var$md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = $4e969272193b5eb7$var$md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = $4e969272193b5eb7$var$md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
        d = $4e969272193b5eb7$var$md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = $4e969272193b5eb7$var$md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = $4e969272193b5eb7$var$md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = $4e969272193b5eb7$var$md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = $4e969272193b5eb7$var$md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = $4e969272193b5eb7$var$md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = $4e969272193b5eb7$var$md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = $4e969272193b5eb7$var$md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = $4e969272193b5eb7$var$md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = $4e969272193b5eb7$var$md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = $4e969272193b5eb7$var$md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = $4e969272193b5eb7$var$md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = $4e969272193b5eb7$var$md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = $4e969272193b5eb7$var$md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = $4e969272193b5eb7$var$md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = $4e969272193b5eb7$var$safe_add(a, olda);
        b = $4e969272193b5eb7$var$safe_add(b, oldb);
        c = $4e969272193b5eb7$var$safe_add(c, oldc);
        d = $4e969272193b5eb7$var$safe_add(d, oldd);
    }
    return [
        a,
        b,
        c,
        d
    ];
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */ function $4e969272193b5eb7$var$md5_cmn(q, a, b, x, s, t) {
    return $4e969272193b5eb7$var$safe_add($4e969272193b5eb7$var$bit_rol($4e969272193b5eb7$var$safe_add($4e969272193b5eb7$var$safe_add(a, q), $4e969272193b5eb7$var$safe_add(x, t)), s), b);
}
function $4e969272193b5eb7$var$md5_ff(a, b, c, d, x, s, t) {
    return $4e969272193b5eb7$var$md5_cmn(b & c | ~b & d, a, b, x, s, t);
}
function $4e969272193b5eb7$var$md5_gg(a, b, c, d, x, s, t) {
    return $4e969272193b5eb7$var$md5_cmn(b & d | c & ~d, a, b, x, s, t);
}
function $4e969272193b5eb7$var$md5_hh(a, b, c, d, x, s, t) {
    return $4e969272193b5eb7$var$md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function $4e969272193b5eb7$var$md5_ii(a, b, c, d, x, s, t) {
    return $4e969272193b5eb7$var$md5_cmn(c ^ (b | ~d), a, b, x, s, t);
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function $4e969272193b5eb7$var$safe_add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */ function $4e969272193b5eb7$var$bit_rol(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
}
module.exports = function md5(buf) {
    return $9nTll(buf, $4e969272193b5eb7$var$core_md5);
};

});
parcelRegister("9nTll", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $6d5131133b33993d$require$Buffer = $aul3P.Buffer;
'use strict';
var $6d5131133b33993d$var$intSize = 4;
var $6d5131133b33993d$var$zeroBuffer = new $6d5131133b33993d$require$Buffer($6d5131133b33993d$var$intSize);
$6d5131133b33993d$var$zeroBuffer.fill(0);
var $6d5131133b33993d$var$charSize = 8;
var $6d5131133b33993d$var$hashSize = 16;
function $6d5131133b33993d$var$toArray(buf) {
    if (buf.length % $6d5131133b33993d$var$intSize !== 0) {
        var len = buf.length + ($6d5131133b33993d$var$intSize - buf.length % $6d5131133b33993d$var$intSize);
        buf = $6d5131133b33993d$require$Buffer.concat([
            buf,
            $6d5131133b33993d$var$zeroBuffer
        ], len);
    }
    var arr = new Array(buf.length >>> 2);
    for(var i = 0, j = 0; i < buf.length; i += $6d5131133b33993d$var$intSize, j++)arr[j] = buf.readInt32LE(i);
    return arr;
}
module.exports = function hash(buf, fn) {
    var arr = fn($6d5131133b33993d$var$toArray(buf), buf.length * $6d5131133b33993d$var$charSize);
    buf = new $6d5131133b33993d$require$Buffer($6d5131133b33993d$var$hashSize);
    for(var i = 0; i < arr.length; i++)buf.writeInt32LE(arr[i], i << 2, true);
    return buf;
};

});


parcelRegister("bGrC1", function(module, exports) {
'use strict';

var $aul3P = parcelRequire("aul3P");
var $88190928fdba87c8$require$Buffer = $aul3P.Buffer;

var $lyUaN = parcelRequire("lyUaN");

var $2UmI8 = parcelRequire("2UmI8");
var $88190928fdba87c8$var$ARRAY16 = new Array(16);
var $88190928fdba87c8$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $88190928fdba87c8$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $88190928fdba87c8$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $88190928fdba87c8$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $88190928fdba87c8$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $88190928fdba87c8$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $88190928fdba87c8$var$RIPEMD160() {
    $2UmI8.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$lyUaN($88190928fdba87c8$var$RIPEMD160, $2UmI8);
$88190928fdba87c8$var$RIPEMD160.prototype._update = function() {
    var words = $88190928fdba87c8$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $88190928fdba87c8$var$fn1(al, bl, cl, dl, el, words[$88190928fdba87c8$var$zl[i]], $88190928fdba87c8$var$hl[0], $88190928fdba87c8$var$sl[i]);
            tr = $88190928fdba87c8$var$fn5(ar, br, cr, dr, er, words[$88190928fdba87c8$var$zr[i]], $88190928fdba87c8$var$hr[0], $88190928fdba87c8$var$sr[i]);
        } else if (i < 32) {
            tl = $88190928fdba87c8$var$fn2(al, bl, cl, dl, el, words[$88190928fdba87c8$var$zl[i]], $88190928fdba87c8$var$hl[1], $88190928fdba87c8$var$sl[i]);
            tr = $88190928fdba87c8$var$fn4(ar, br, cr, dr, er, words[$88190928fdba87c8$var$zr[i]], $88190928fdba87c8$var$hr[1], $88190928fdba87c8$var$sr[i]);
        } else if (i < 48) {
            tl = $88190928fdba87c8$var$fn3(al, bl, cl, dl, el, words[$88190928fdba87c8$var$zl[i]], $88190928fdba87c8$var$hl[2], $88190928fdba87c8$var$sl[i]);
            tr = $88190928fdba87c8$var$fn3(ar, br, cr, dr, er, words[$88190928fdba87c8$var$zr[i]], $88190928fdba87c8$var$hr[2], $88190928fdba87c8$var$sr[i]);
        } else if (i < 64) {
            tl = $88190928fdba87c8$var$fn4(al, bl, cl, dl, el, words[$88190928fdba87c8$var$zl[i]], $88190928fdba87c8$var$hl[3], $88190928fdba87c8$var$sl[i]);
            tr = $88190928fdba87c8$var$fn2(ar, br, cr, dr, er, words[$88190928fdba87c8$var$zr[i]], $88190928fdba87c8$var$hr[3], $88190928fdba87c8$var$sr[i]);
        } else {
            tl = $88190928fdba87c8$var$fn5(al, bl, cl, dl, el, words[$88190928fdba87c8$var$zl[i]], $88190928fdba87c8$var$hl[4], $88190928fdba87c8$var$sl[i]);
            tr = $88190928fdba87c8$var$fn1(ar, br, cr, dr, er, words[$88190928fdba87c8$var$zr[i]], $88190928fdba87c8$var$hr[4], $88190928fdba87c8$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $88190928fdba87c8$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $88190928fdba87c8$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$88190928fdba87c8$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $88190928fdba87c8$require$Buffer.alloc ? $88190928fdba87c8$require$Buffer.alloc(20) : new $88190928fdba87c8$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $88190928fdba87c8$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $88190928fdba87c8$var$fn1(a, b, c, d, e, m, k, s) {
    return $88190928fdba87c8$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $88190928fdba87c8$var$fn2(a, b, c, d, e, m, k, s) {
    return $88190928fdba87c8$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $88190928fdba87c8$var$fn3(a, b, c, d, e, m, k, s) {
    return $88190928fdba87c8$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $88190928fdba87c8$var$fn4(a, b, c, d, e, m, k, s) {
    return $88190928fdba87c8$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $88190928fdba87c8$var$fn5(a, b, c, d, e, m, k, s) {
    return $88190928fdba87c8$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $88190928fdba87c8$var$RIPEMD160;

});
parcelRegister("2UmI8", function(module, exports) {
'use strict';

var $ijh2q = parcelRequire("ijh2q");
var $21e26da029925685$require$Buffer = $ijh2q.Buffer;

var $anz8L = parcelRequire("anz8L");
var $21e26da029925685$require$Transform = $anz8L.Transform;

var $lyUaN = parcelRequire("lyUaN");
function $21e26da029925685$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$21e26da029925685$require$Buffer.isBuffer(val) && typeof val !== 'string') throw new TypeError(prefix + ' must be a string or a buffer');
}
function $21e26da029925685$var$HashBase(blockSize) {
    $21e26da029925685$require$Transform.call(this);
    this._block = $21e26da029925685$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$lyUaN($21e26da029925685$var$HashBase, $21e26da029925685$require$Transform);
$21e26da029925685$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$21e26da029925685$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$21e26da029925685$var$HashBase.prototype.update = function(data, encoding) {
    $21e26da029925685$var$throwIfNotStringOrBuffer(data, 'Data');
    if (this._finalized) throw new Error('Digest already called');
    if (!$21e26da029925685$require$Buffer.isBuffer(data)) data = $21e26da029925685$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$21e26da029925685$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$21e26da029925685$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$21e26da029925685$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $21e26da029925685$var$HashBase;

});
parcelRegister("anz8L", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $78e74f7c5379cef2$var$Stream;

var $3sTLs = parcelRequire("3sTLs");
var $78e74f7c5379cef2$require$EE = $3sTLs.EventEmitter;

var $lyUaN = parcelRequire("lyUaN");
$lyUaN($78e74f7c5379cef2$var$Stream, $78e74f7c5379cef2$require$EE);

$78e74f7c5379cef2$var$Stream.Readable = (parcelRequire("hd0Wp"));

$78e74f7c5379cef2$var$Stream.Writable = (parcelRequire("kKpgC"));

$78e74f7c5379cef2$var$Stream.Duplex = (parcelRequire("aoI29"));

$78e74f7c5379cef2$var$Stream.Transform = (parcelRequire("lUyqo"));

$78e74f7c5379cef2$var$Stream.PassThrough = (parcelRequire("4kZwd"));

$78e74f7c5379cef2$var$Stream.finished = (parcelRequire("jV6VG"));

$78e74f7c5379cef2$var$Stream.pipeline = (parcelRequire("8Ms18"));
// Backwards-compat with node 0.4.x
$78e74f7c5379cef2$var$Stream.Stream = $78e74f7c5379cef2$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $78e74f7c5379cef2$var$Stream() {
    $78e74f7c5379cef2$require$EE.call(this);
}
$78e74f7c5379cef2$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($78e74f7c5379cef2$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("hd0Wp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2fFJv = parcelRequire("2fFJv");
'use strict';
module.exports = $c874616fccc431a8$var$Readable;
/*<replacement>*/ var $c874616fccc431a8$var$Duplex;
/*</replacement>*/ $c874616fccc431a8$var$Readable.ReadableState = $c874616fccc431a8$var$ReadableState;

var $3sTLs = parcelRequire("3sTLs");
var $c874616fccc431a8$require$EE = $3sTLs.EventEmitter;
var $c874616fccc431a8$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $8wk3O = parcelRequire("8wk3O");

var $aul3P = parcelRequire("aul3P");
var $c874616fccc431a8$require$Buffer = $aul3P.Buffer;
var $c874616fccc431a8$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $c874616fccc431a8$var$_uint8ArrayToBuffer(chunk) {
    return $c874616fccc431a8$require$Buffer.from(chunk);
}
function $c874616fccc431a8$var$_isUint8Array(obj) {
    return $c874616fccc431a8$require$Buffer.isBuffer(obj) || obj instanceof $c874616fccc431a8$var$OurUint8Array;
}

var $jFleb = parcelRequire("jFleb");
var $c874616fccc431a8$var$debug;
if ($jFleb && $jFleb.debuglog) $c874616fccc431a8$var$debug = $jFleb.debuglog('stream');
else $c874616fccc431a8$var$debug = function debug() {};

var $jx80w = parcelRequire("jx80w");

var $lzWKR = parcelRequire("lzWKR");

var $dsJPG = parcelRequire("dsJPG");
var $c874616fccc431a8$var$getHighWaterMark = $dsJPG.getHighWaterMark;

var $i8n8u = parcelRequire("i8n8u");
var $c874616fccc431a8$require$_require$codes = $i8n8u.codes;
var $c874616fccc431a8$var$ERR_INVALID_ARG_TYPE = $c874616fccc431a8$require$_require$codes.ERR_INVALID_ARG_TYPE, $c874616fccc431a8$var$ERR_STREAM_PUSH_AFTER_EOF = $c874616fccc431a8$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $c874616fccc431a8$var$ERR_METHOD_NOT_IMPLEMENTED = $c874616fccc431a8$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $c874616fccc431a8$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $c874616fccc431a8$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $c874616fccc431a8$var$StringDecoder;
var $c874616fccc431a8$var$createReadableStreamAsyncIterator;
var $c874616fccc431a8$var$from;

(parcelRequire("lyUaN"))($c874616fccc431a8$var$Readable, $8wk3O);
var $c874616fccc431a8$var$errorOrDestroy = $lzWKR.errorOrDestroy;
var $c874616fccc431a8$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $c874616fccc431a8$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $c874616fccc431a8$var$ReadableState(options, stream, isDuplex) {
    $c874616fccc431a8$var$Duplex = $c874616fccc431a8$var$Duplex || (parcelRequire("aoI29"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $c874616fccc431a8$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $c874616fccc431a8$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $jx80w();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$c874616fccc431a8$var$StringDecoder) $c874616fccc431a8$var$StringDecoder = (parcelRequire("iSptP")).StringDecoder;
        this.decoder = new $c874616fccc431a8$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $c874616fccc431a8$var$Readable(options) {
    $c874616fccc431a8$var$Duplex = $c874616fccc431a8$var$Duplex || (parcelRequire("aoI29"));
    if (!(this instanceof $c874616fccc431a8$var$Readable)) return new $c874616fccc431a8$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $c874616fccc431a8$var$Duplex;
    this._readableState = new $c874616fccc431a8$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $8wk3O.call(this);
}
Object.defineProperty($c874616fccc431a8$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$c874616fccc431a8$var$Readable.prototype.destroy = $lzWKR.destroy;
$c874616fccc431a8$var$Readable.prototype._undestroy = $lzWKR.undestroy;
$c874616fccc431a8$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$c874616fccc431a8$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $c874616fccc431a8$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $c874616fccc431a8$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$c874616fccc431a8$var$Readable.prototype.unshift = function(chunk) {
    return $c874616fccc431a8$var$readableAddChunk(this, chunk, null, true, false);
};
function $c874616fccc431a8$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $c874616fccc431a8$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $c874616fccc431a8$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $c874616fccc431a8$var$chunkInvalid(state, chunk);
        if (er) $c874616fccc431a8$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $c874616fccc431a8$require$Buffer.prototype) chunk = $c874616fccc431a8$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $c874616fccc431a8$var$errorOrDestroy(stream, new $c874616fccc431a8$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $c874616fccc431a8$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $c874616fccc431a8$var$errorOrDestroy(stream, new $c874616fccc431a8$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $c874616fccc431a8$var$addChunk(stream, state, chunk, false);
                    else $c874616fccc431a8$var$maybeReadMore(stream, state);
                } else $c874616fccc431a8$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $c874616fccc431a8$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $c874616fccc431a8$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $c874616fccc431a8$var$emitReadable(stream);
    }
    $c874616fccc431a8$var$maybeReadMore(stream, state);
}
function $c874616fccc431a8$var$chunkInvalid(state, chunk) {
    var er;
    if (!$c874616fccc431a8$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $c874616fccc431a8$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$c874616fccc431a8$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$c874616fccc431a8$var$Readable.prototype.setEncoding = function(enc) {
    if (!$c874616fccc431a8$var$StringDecoder) $c874616fccc431a8$var$StringDecoder = (parcelRequire("iSptP")).StringDecoder;
    var decoder = new $c874616fccc431a8$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $c874616fccc431a8$var$MAX_HWM = 0x40000000;
function $c874616fccc431a8$var$computeNewHighWaterMark(n) {
    if (n >= $c874616fccc431a8$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $c874616fccc431a8$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c874616fccc431a8$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $c874616fccc431a8$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$c874616fccc431a8$var$Readable.prototype.read = function(n) {
    $c874616fccc431a8$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $c874616fccc431a8$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $c874616fccc431a8$var$endReadable(this);
        else $c874616fccc431a8$var$emitReadable(this);
        return null;
    }
    n = $c874616fccc431a8$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $c874616fccc431a8$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $c874616fccc431a8$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $c874616fccc431a8$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $c874616fccc431a8$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $c874616fccc431a8$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $c874616fccc431a8$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $c874616fccc431a8$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $c874616fccc431a8$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $c874616fccc431a8$var$onEofChunk(stream, state) {
    $c874616fccc431a8$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $c874616fccc431a8$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $c874616fccc431a8$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $c874616fccc431a8$var$emitReadable(stream) {
    var state = stream._readableState;
    $c874616fccc431a8$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $c874616fccc431a8$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2fFJv.nextTick($c874616fccc431a8$var$emitReadable_, stream);
    }
}
function $c874616fccc431a8$var$emitReadable_(stream) {
    var state = stream._readableState;
    $c874616fccc431a8$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $c874616fccc431a8$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $c874616fccc431a8$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $2fFJv.nextTick($c874616fccc431a8$var$maybeReadMore_, stream, state);
    }
}
function $c874616fccc431a8$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $c874616fccc431a8$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$c874616fccc431a8$var$Readable.prototype._read = function(n) {
    $c874616fccc431a8$var$errorOrDestroy(this, new $c874616fccc431a8$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$c874616fccc431a8$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $c874616fccc431a8$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2fFJv.stdout && dest !== $2fFJv.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2fFJv.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $c874616fccc431a8$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $c874616fccc431a8$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $c874616fccc431a8$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $c874616fccc431a8$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $c874616fccc431a8$var$debug('ondata');
        var ret = dest.write(chunk);
        $c874616fccc431a8$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $c874616fccc431a8$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $c874616fccc431a8$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $c874616fccc431a8$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($c874616fccc431a8$var$EElistenerCount(dest, 'error') === 0) $c874616fccc431a8$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $c874616fccc431a8$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $c874616fccc431a8$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $c874616fccc431a8$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $c874616fccc431a8$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $c874616fccc431a8$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $c874616fccc431a8$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $c874616fccc431a8$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $c874616fccc431a8$var$flow(src);
        }
    };
}
$c874616fccc431a8$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $c874616fccc431a8$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$c874616fccc431a8$var$Readable.prototype.on = function(ev, fn) {
    var res = $8wk3O.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $c874616fccc431a8$var$debug('on readable', state.length, state.reading);
            if (state.length) $c874616fccc431a8$var$emitReadable(this);
            else if (!state.reading) $2fFJv.nextTick($c874616fccc431a8$var$nReadingNextTick, this);
        }
    }
    return res;
};
$c874616fccc431a8$var$Readable.prototype.addListener = $c874616fccc431a8$var$Readable.prototype.on;
$c874616fccc431a8$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $8wk3O.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2fFJv.nextTick($c874616fccc431a8$var$updateReadableListening, this);
    return res;
};
$c874616fccc431a8$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $8wk3O.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2fFJv.nextTick($c874616fccc431a8$var$updateReadableListening, this);
    return res;
};
function $c874616fccc431a8$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $c874616fccc431a8$var$nReadingNextTick(self1) {
    $c874616fccc431a8$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$c874616fccc431a8$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $c874616fccc431a8$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $c874616fccc431a8$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $c874616fccc431a8$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2fFJv.nextTick($c874616fccc431a8$var$resume_, stream, state);
    }
}
function $c874616fccc431a8$var$resume_(stream, state) {
    $c874616fccc431a8$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $c874616fccc431a8$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$c874616fccc431a8$var$Readable.prototype.pause = function() {
    $c874616fccc431a8$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $c874616fccc431a8$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $c874616fccc431a8$var$flow(stream) {
    var state = stream._readableState;
    $c874616fccc431a8$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$c874616fccc431a8$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $c874616fccc431a8$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $c874616fccc431a8$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $c874616fccc431a8$var$kProxyEvents.length; n++)stream.on($c874616fccc431a8$var$kProxyEvents[n], this.emit.bind(this, $c874616fccc431a8$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $c874616fccc431a8$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $c874616fccc431a8$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($c874616fccc431a8$var$createReadableStreamAsyncIterator === undefined) $c874616fccc431a8$var$createReadableStreamAsyncIterator = (parcelRequire("eryNp"));
    return $c874616fccc431a8$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($c874616fccc431a8$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($c874616fccc431a8$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($c874616fccc431a8$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$c874616fccc431a8$var$Readable._fromList = $c874616fccc431a8$var$fromList;
Object.defineProperty($c874616fccc431a8$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c874616fccc431a8$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $c874616fccc431a8$var$endReadable(stream) {
    var state = stream._readableState;
    $c874616fccc431a8$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2fFJv.nextTick($c874616fccc431a8$var$endReadableNT, state, stream);
    }
}
function $c874616fccc431a8$var$endReadableNT(state, stream) {
    $c874616fccc431a8$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $c874616fccc431a8$var$Readable.from = function(iterable, opts) {
    if ($c874616fccc431a8$var$from === undefined) $c874616fccc431a8$var$from = (parcelRequire("gljMO"));
    return $c874616fccc431a8$var$from($c874616fccc431a8$var$Readable, iterable, opts);
};
function $c874616fccc431a8$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("8wk3O", function(module, exports) {

module.exports = (parcelRequire("3sTLs")).EventEmitter;

});

parcelRegister("jFleb", function(module, exports) {
"use strict";

});

parcelRegister("jx80w", function(module, exports) {
'use strict';
function $e3874f7ac1f848ee$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e3874f7ac1f848ee$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e3874f7ac1f848ee$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e3874f7ac1f848ee$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e3874f7ac1f848ee$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e3874f7ac1f848ee$var$_defineProperty(obj, key, value) {
    key = $e3874f7ac1f848ee$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e3874f7ac1f848ee$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e3874f7ac1f848ee$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e3874f7ac1f848ee$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e3874f7ac1f848ee$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e3874f7ac1f848ee$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e3874f7ac1f848ee$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e3874f7ac1f848ee$var$_toPropertyKey(arg) {
    var key = $e3874f7ac1f848ee$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $e3874f7ac1f848ee$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $aul3P = parcelRequire("aul3P");
var $e3874f7ac1f848ee$var$Buffer = $aul3P.Buffer;

var $jFleb = parcelRequire("jFleb");
var $e3874f7ac1f848ee$var$inspect = $jFleb.inspect;
var $e3874f7ac1f848ee$var$custom = $e3874f7ac1f848ee$var$inspect && $e3874f7ac1f848ee$var$inspect.custom || 'inspect';
function $e3874f7ac1f848ee$var$copyBuffer(src, target, offset) {
    $e3874f7ac1f848ee$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $e3874f7ac1f848ee$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $e3874f7ac1f848ee$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $e3874f7ac1f848ee$var$Buffer.alloc(0);
                var ret = $e3874f7ac1f848ee$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $e3874f7ac1f848ee$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $e3874f7ac1f848ee$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $e3874f7ac1f848ee$var$custom,
            value: function value(_, options) {
                return $e3874f7ac1f848ee$var$inspect(this, $e3874f7ac1f848ee$var$_objectSpread($e3874f7ac1f848ee$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("lzWKR", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $fb5a7154f411547f$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $2fFJv.nextTick($fb5a7154f411547f$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $2fFJv.nextTick($fb5a7154f411547f$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $2fFJv.nextTick($fb5a7154f411547f$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $2fFJv.nextTick($fb5a7154f411547f$var$emitErrorAndCloseNT, _this, err);
            } else $2fFJv.nextTick($fb5a7154f411547f$var$emitCloseNT, _this);
        } else if (cb) {
            $2fFJv.nextTick($fb5a7154f411547f$var$emitCloseNT, _this);
            cb(err);
        } else $2fFJv.nextTick($fb5a7154f411547f$var$emitCloseNT, _this);
    });
    return this;
}
function $fb5a7154f411547f$var$emitErrorAndCloseNT(self, err) {
    $fb5a7154f411547f$var$emitErrorNT(self, err);
    $fb5a7154f411547f$var$emitCloseNT(self);
}
function $fb5a7154f411547f$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $fb5a7154f411547f$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $fb5a7154f411547f$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $fb5a7154f411547f$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $fb5a7154f411547f$var$destroy,
    undestroy: $fb5a7154f411547f$var$undestroy,
    errorOrDestroy: $fb5a7154f411547f$var$errorOrDestroy
};

});

parcelRegister("dsJPG", function(module, exports) {
'use strict';

var $9cd1714906576d1f$var$ERR_INVALID_OPT_VALUE = (parcelRequire("i8n8u")).codes.ERR_INVALID_OPT_VALUE;
function $9cd1714906576d1f$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $9cd1714906576d1f$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $9cd1714906576d1f$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $9cd1714906576d1f$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $9cd1714906576d1f$var$getHighWaterMark
};

});
parcelRegister("i8n8u", function(module, exports) {

$parcel$export(module.exports, "codes", () => $d33aeba58cf9ee4e$export$e45cb6485273080e, (v) => $d33aeba58cf9ee4e$export$e45cb6485273080e = v);
var $d33aeba58cf9ee4e$export$e45cb6485273080e;
'use strict';
function $d33aeba58cf9ee4e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $d33aeba58cf9ee4e$var$codes = {};
function $d33aeba58cf9ee4e$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $d33aeba58cf9ee4e$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $d33aeba58cf9ee4e$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $d33aeba58cf9ee4e$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $d33aeba58cf9ee4e$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $d33aeba58cf9ee4e$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $d33aeba58cf9ee4e$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$d33aeba58cf9ee4e$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$d33aeba58cf9ee4e$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $d33aeba58cf9ee4e$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($d33aeba58cf9ee4e$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($d33aeba58cf9ee4e$var$oneOf(expected, 'type'));
    else {
        var type = $d33aeba58cf9ee4e$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($d33aeba58cf9ee4e$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$d33aeba58cf9ee4e$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$d33aeba58cf9ee4e$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$d33aeba58cf9ee4e$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$d33aeba58cf9ee4e$export$e45cb6485273080e = $d33aeba58cf9ee4e$var$codes;

});


parcelRegister("aoI29", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $2fFJv = parcelRequire("2fFJv");
'use strict';
/*<replacement>*/ var $791e4d7664ce07ae$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $791e4d7664ce07ae$var$Duplex;

var $hd0Wp = parcelRequire("hd0Wp");

var $kKpgC = parcelRequire("kKpgC");

(parcelRequire("lyUaN"))($791e4d7664ce07ae$var$Duplex, $hd0Wp);
// Allow the keys array to be GC'ed.
var $791e4d7664ce07ae$var$keys = $791e4d7664ce07ae$var$objectKeys($kKpgC.prototype);
for(var $791e4d7664ce07ae$var$v = 0; $791e4d7664ce07ae$var$v < $791e4d7664ce07ae$var$keys.length; $791e4d7664ce07ae$var$v++){
    var $791e4d7664ce07ae$var$method = $791e4d7664ce07ae$var$keys[$791e4d7664ce07ae$var$v];
    if (!$791e4d7664ce07ae$var$Duplex.prototype[$791e4d7664ce07ae$var$method]) $791e4d7664ce07ae$var$Duplex.prototype[$791e4d7664ce07ae$var$method] = $kKpgC.prototype[$791e4d7664ce07ae$var$method];
}
function $791e4d7664ce07ae$var$Duplex(options) {
    if (!(this instanceof $791e4d7664ce07ae$var$Duplex)) return new $791e4d7664ce07ae$var$Duplex(options);
    $hd0Wp.call(this, options);
    $kKpgC.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $791e4d7664ce07ae$var$onend);
        }
    }
}
Object.defineProperty($791e4d7664ce07ae$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($791e4d7664ce07ae$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($791e4d7664ce07ae$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $791e4d7664ce07ae$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $2fFJv.nextTick($791e4d7664ce07ae$var$onEndNT, this);
}
function $791e4d7664ce07ae$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($791e4d7664ce07ae$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("kKpgC", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $2fFJv = parcelRequire("2fFJv");
'use strict';
module.exports = $f1abb40b22f49859$var$Writable;
/* <replacement> */ function $f1abb40b22f49859$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $f1abb40b22f49859$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $f1abb40b22f49859$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $f1abb40b22f49859$var$Duplex;
/*</replacement>*/ $f1abb40b22f49859$var$Writable.WritableState = $f1abb40b22f49859$var$WritableState;

/*<replacement>*/ var $f1abb40b22f49859$var$internalUtil = {
    deprecate: (parcelRequire("6UWyy"))
};

var $8wk3O = parcelRequire("8wk3O");

var $aul3P = parcelRequire("aul3P");
var $f1abb40b22f49859$require$Buffer = $aul3P.Buffer;
var $f1abb40b22f49859$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $f1abb40b22f49859$var$_uint8ArrayToBuffer(chunk) {
    return $f1abb40b22f49859$require$Buffer.from(chunk);
}
function $f1abb40b22f49859$var$_isUint8Array(obj) {
    return $f1abb40b22f49859$require$Buffer.isBuffer(obj) || obj instanceof $f1abb40b22f49859$var$OurUint8Array;
}

var $lzWKR = parcelRequire("lzWKR");

var $dsJPG = parcelRequire("dsJPG");
var $f1abb40b22f49859$var$getHighWaterMark = $dsJPG.getHighWaterMark;

var $i8n8u = parcelRequire("i8n8u");
var $f1abb40b22f49859$require$_require$codes = $i8n8u.codes;
var $f1abb40b22f49859$var$ERR_INVALID_ARG_TYPE = $f1abb40b22f49859$require$_require$codes.ERR_INVALID_ARG_TYPE, $f1abb40b22f49859$var$ERR_METHOD_NOT_IMPLEMENTED = $f1abb40b22f49859$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $f1abb40b22f49859$var$ERR_MULTIPLE_CALLBACK = $f1abb40b22f49859$require$_require$codes.ERR_MULTIPLE_CALLBACK, $f1abb40b22f49859$var$ERR_STREAM_CANNOT_PIPE = $f1abb40b22f49859$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $f1abb40b22f49859$var$ERR_STREAM_DESTROYED = $f1abb40b22f49859$require$_require$codes.ERR_STREAM_DESTROYED, $f1abb40b22f49859$var$ERR_STREAM_NULL_VALUES = $f1abb40b22f49859$require$_require$codes.ERR_STREAM_NULL_VALUES, $f1abb40b22f49859$var$ERR_STREAM_WRITE_AFTER_END = $f1abb40b22f49859$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $f1abb40b22f49859$var$ERR_UNKNOWN_ENCODING = $f1abb40b22f49859$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $f1abb40b22f49859$var$errorOrDestroy = $lzWKR.errorOrDestroy;

(parcelRequire("lyUaN"))($f1abb40b22f49859$var$Writable, $8wk3O);
function $f1abb40b22f49859$var$nop() {}

function $f1abb40b22f49859$var$WritableState(options, stream, isDuplex) {
    $f1abb40b22f49859$var$Duplex = $f1abb40b22f49859$var$Duplex || (parcelRequire("aoI29"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $f1abb40b22f49859$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $f1abb40b22f49859$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $f1abb40b22f49859$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $f1abb40b22f49859$var$CorkedRequest(this);
}
$f1abb40b22f49859$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($f1abb40b22f49859$var$WritableState.prototype, 'buffer', {
            get: $f1abb40b22f49859$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $f1abb40b22f49859$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $f1abb40b22f49859$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($f1abb40b22f49859$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($f1abb40b22f49859$var$realHasInstance.call(this, object)) return true;
            if (this !== $f1abb40b22f49859$var$Writable) return false;
            return object && object._writableState instanceof $f1abb40b22f49859$var$WritableState;
        }
    });
} else $f1abb40b22f49859$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $f1abb40b22f49859$var$Writable(options) {
    $f1abb40b22f49859$var$Duplex = $f1abb40b22f49859$var$Duplex || (parcelRequire("aoI29"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $f1abb40b22f49859$var$Duplex;
    if (!isDuplex && !$f1abb40b22f49859$var$realHasInstance.call($f1abb40b22f49859$var$Writable, this)) return new $f1abb40b22f49859$var$Writable(options);
    this._writableState = new $f1abb40b22f49859$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $8wk3O.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$f1abb40b22f49859$var$Writable.prototype.pipe = function() {
    $f1abb40b22f49859$var$errorOrDestroy(this, new $f1abb40b22f49859$var$ERR_STREAM_CANNOT_PIPE());
};
function $f1abb40b22f49859$var$writeAfterEnd(stream, cb) {
    var er = new $f1abb40b22f49859$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $f1abb40b22f49859$var$errorOrDestroy(stream, er);
    $2fFJv.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $f1abb40b22f49859$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $f1abb40b22f49859$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $f1abb40b22f49859$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $f1abb40b22f49859$var$errorOrDestroy(stream, er);
        $2fFJv.nextTick(cb, er);
        return false;
    }
    return true;
}
$f1abb40b22f49859$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $f1abb40b22f49859$var$_isUint8Array(chunk);
    if (isBuf && !$f1abb40b22f49859$require$Buffer.isBuffer(chunk)) chunk = $f1abb40b22f49859$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $f1abb40b22f49859$var$nop;
    if (state.ending) $f1abb40b22f49859$var$writeAfterEnd(this, cb);
    else if (isBuf || $f1abb40b22f49859$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $f1abb40b22f49859$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$f1abb40b22f49859$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$f1abb40b22f49859$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $f1abb40b22f49859$var$clearBuffer(this, state);
    }
};
$f1abb40b22f49859$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $f1abb40b22f49859$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($f1abb40b22f49859$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $f1abb40b22f49859$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $f1abb40b22f49859$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($f1abb40b22f49859$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $f1abb40b22f49859$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $f1abb40b22f49859$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $f1abb40b22f49859$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $f1abb40b22f49859$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $f1abb40b22f49859$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $f1abb40b22f49859$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $2fFJv.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $2fFJv.nextTick($f1abb40b22f49859$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $f1abb40b22f49859$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $f1abb40b22f49859$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $f1abb40b22f49859$var$finishMaybe(stream, state);
    }
}
function $f1abb40b22f49859$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $f1abb40b22f49859$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $f1abb40b22f49859$var$ERR_MULTIPLE_CALLBACK();
    $f1abb40b22f49859$var$onwriteStateUpdate(state);
    if (er) $f1abb40b22f49859$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $f1abb40b22f49859$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $f1abb40b22f49859$var$clearBuffer(stream, state);
        if (sync) $2fFJv.nextTick($f1abb40b22f49859$var$afterWrite, stream, state, finished, cb);
        else $f1abb40b22f49859$var$afterWrite(stream, state, finished, cb);
    }
}
function $f1abb40b22f49859$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $f1abb40b22f49859$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $f1abb40b22f49859$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $f1abb40b22f49859$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $f1abb40b22f49859$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $f1abb40b22f49859$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $f1abb40b22f49859$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $f1abb40b22f49859$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$f1abb40b22f49859$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $f1abb40b22f49859$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$f1abb40b22f49859$var$Writable.prototype._writev = null;
$f1abb40b22f49859$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $f1abb40b22f49859$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($f1abb40b22f49859$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $f1abb40b22f49859$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $f1abb40b22f49859$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $f1abb40b22f49859$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $f1abb40b22f49859$var$finishMaybe(stream, state);
    });
}
function $f1abb40b22f49859$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $2fFJv.nextTick($f1abb40b22f49859$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $f1abb40b22f49859$var$finishMaybe(stream, state) {
    var need = $f1abb40b22f49859$var$needFinish(state);
    if (need) {
        $f1abb40b22f49859$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $f1abb40b22f49859$var$endWritable(stream, state, cb) {
    state.ending = true;
    $f1abb40b22f49859$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $2fFJv.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $f1abb40b22f49859$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($f1abb40b22f49859$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$f1abb40b22f49859$var$Writable.prototype.destroy = $lzWKR.destroy;
$f1abb40b22f49859$var$Writable.prototype._undestroy = $lzWKR.undestroy;
$f1abb40b22f49859$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("6UWyy", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $50956520c48d9d9c$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $50956520c48d9d9c$var$deprecate(fn, msg) {
    if ($50956520c48d9d9c$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($50956520c48d9d9c$var$config('throwDeprecation')) throw new Error(msg);
            else if ($50956520c48d9d9c$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $50956520c48d9d9c$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("iSptP", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $dbe108f5fb9524a7$export$63a7aa211a91ed69, (v) => $dbe108f5fb9524a7$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $dbe108f5fb9524a7$export$63a7aa211a91ed69;
'use strict';

var $ijh2q = parcelRequire("ijh2q");
var $dbe108f5fb9524a7$require$Buffer = $ijh2q.Buffer;
/*</replacement>*/ var $dbe108f5fb9524a7$var$isEncoding = $dbe108f5fb9524a7$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $dbe108f5fb9524a7$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $dbe108f5fb9524a7$var$normalizeEncoding(enc) {
    var nenc = $dbe108f5fb9524a7$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($dbe108f5fb9524a7$require$Buffer.isEncoding === $dbe108f5fb9524a7$var$isEncoding || !$dbe108f5fb9524a7$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$dbe108f5fb9524a7$export$63a7aa211a91ed69 = $dbe108f5fb9524a7$var$StringDecoder;
function $dbe108f5fb9524a7$var$StringDecoder(encoding) {
    this.encoding = $dbe108f5fb9524a7$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $dbe108f5fb9524a7$var$utf16Text;
            this.end = $dbe108f5fb9524a7$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $dbe108f5fb9524a7$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $dbe108f5fb9524a7$var$base64Text;
            this.end = $dbe108f5fb9524a7$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $dbe108f5fb9524a7$var$simpleWrite;
            this.end = $dbe108f5fb9524a7$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $dbe108f5fb9524a7$require$Buffer.allocUnsafe(nb);
}
$dbe108f5fb9524a7$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$dbe108f5fb9524a7$var$StringDecoder.prototype.end = $dbe108f5fb9524a7$var$utf8End;
// Returns only complete characters in a Buffer
$dbe108f5fb9524a7$var$StringDecoder.prototype.text = $dbe108f5fb9524a7$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$dbe108f5fb9524a7$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $dbe108f5fb9524a7$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $dbe108f5fb9524a7$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $dbe108f5fb9524a7$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $dbe108f5fb9524a7$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $dbe108f5fb9524a7$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $dbe108f5fb9524a7$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $dbe108f5fb9524a7$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $dbe108f5fb9524a7$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $dbe108f5fb9524a7$var$utf8Text(buf, i) {
    var total = $dbe108f5fb9524a7$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $dbe108f5fb9524a7$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $dbe108f5fb9524a7$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $dbe108f5fb9524a7$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $dbe108f5fb9524a7$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $dbe108f5fb9524a7$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $dbe108f5fb9524a7$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $dbe108f5fb9524a7$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("eryNp", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
'use strict';
var $a83e941260fb2f21$var$_Object$setPrototypeO;
function $a83e941260fb2f21$var$_defineProperty(obj, key, value) {
    key = $a83e941260fb2f21$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a83e941260fb2f21$var$_toPropertyKey(arg) {
    var key = $a83e941260fb2f21$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $a83e941260fb2f21$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $jV6VG = parcelRequire("jV6VG");
var $a83e941260fb2f21$var$kLastResolve = Symbol('lastResolve');
var $a83e941260fb2f21$var$kLastReject = Symbol('lastReject');
var $a83e941260fb2f21$var$kError = Symbol('error');
var $a83e941260fb2f21$var$kEnded = Symbol('ended');
var $a83e941260fb2f21$var$kLastPromise = Symbol('lastPromise');
var $a83e941260fb2f21$var$kHandlePromise = Symbol('handlePromise');
var $a83e941260fb2f21$var$kStream = Symbol('stream');
function $a83e941260fb2f21$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $a83e941260fb2f21$var$readAndResolve(iter) {
    var resolve = iter[$a83e941260fb2f21$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$a83e941260fb2f21$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$a83e941260fb2f21$var$kLastPromise] = null;
            iter[$a83e941260fb2f21$var$kLastResolve] = null;
            iter[$a83e941260fb2f21$var$kLastReject] = null;
            resolve($a83e941260fb2f21$var$createIterResult(data, false));
        }
    }
}
function $a83e941260fb2f21$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $2fFJv.nextTick($a83e941260fb2f21$var$readAndResolve, iter);
}
function $a83e941260fb2f21$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$a83e941260fb2f21$var$kEnded]) {
                resolve($a83e941260fb2f21$var$createIterResult(undefined, true));
                return;
            }
            iter[$a83e941260fb2f21$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $a83e941260fb2f21$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $a83e941260fb2f21$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($a83e941260fb2f21$var$_Object$setPrototypeO = {
    get stream () {
        return this[$a83e941260fb2f21$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$a83e941260fb2f21$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$a83e941260fb2f21$var$kEnded]) return Promise.resolve($a83e941260fb2f21$var$createIterResult(undefined, true));
        if (this[$a83e941260fb2f21$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $2fFJv.nextTick(function() {
                if (_this[$a83e941260fb2f21$var$kError]) reject(_this[$a83e941260fb2f21$var$kError]);
                else resolve($a83e941260fb2f21$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$a83e941260fb2f21$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($a83e941260fb2f21$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$a83e941260fb2f21$var$kStream].read();
            if (data !== null) return Promise.resolve($a83e941260fb2f21$var$createIterResult(data, false));
            promise = new Promise(this[$a83e941260fb2f21$var$kHandlePromise]);
        }
        this[$a83e941260fb2f21$var$kLastPromise] = promise;
        return promise;
    }
}, $a83e941260fb2f21$var$_defineProperty($a83e941260fb2f21$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $a83e941260fb2f21$var$_defineProperty($a83e941260fb2f21$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$a83e941260fb2f21$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($a83e941260fb2f21$var$createIterResult(undefined, true));
        });
    });
}), $a83e941260fb2f21$var$_Object$setPrototypeO), $a83e941260fb2f21$var$AsyncIteratorPrototype);
var $a83e941260fb2f21$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($a83e941260fb2f21$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kStream, {
        value: stream,
        writable: true
    }), $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kLastResolve, {
        value: null,
        writable: true
    }), $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kLastReject, {
        value: null,
        writable: true
    }), $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kError, {
        value: null,
        writable: true
    }), $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$a83e941260fb2f21$var$kStream].read();
            if (data) {
                iterator[$a83e941260fb2f21$var$kLastPromise] = null;
                iterator[$a83e941260fb2f21$var$kLastResolve] = null;
                iterator[$a83e941260fb2f21$var$kLastReject] = null;
                resolve($a83e941260fb2f21$var$createIterResult(data, false));
            } else {
                iterator[$a83e941260fb2f21$var$kLastResolve] = resolve;
                iterator[$a83e941260fb2f21$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$a83e941260fb2f21$var$kLastPromise] = null;
    $jV6VG(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$a83e941260fb2f21$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$a83e941260fb2f21$var$kLastPromise] = null;
                iterator[$a83e941260fb2f21$var$kLastResolve] = null;
                iterator[$a83e941260fb2f21$var$kLastReject] = null;
                reject(err);
            }
            iterator[$a83e941260fb2f21$var$kError] = err;
            return;
        }
        var resolve = iterator[$a83e941260fb2f21$var$kLastResolve];
        if (resolve !== null) {
            iterator[$a83e941260fb2f21$var$kLastPromise] = null;
            iterator[$a83e941260fb2f21$var$kLastResolve] = null;
            iterator[$a83e941260fb2f21$var$kLastReject] = null;
            resolve($a83e941260fb2f21$var$createIterResult(undefined, true));
        }
        iterator[$a83e941260fb2f21$var$kEnded] = true;
    });
    stream.on('readable', $a83e941260fb2f21$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $a83e941260fb2f21$var$createReadableStreamAsyncIterator;

});
parcelRegister("jV6VG", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $e808b73f4846b37f$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("i8n8u")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $e808b73f4846b37f$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $e808b73f4846b37f$var$noop() {}
function $e808b73f4846b37f$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $e808b73f4846b37f$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $e808b73f4846b37f$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $e808b73f4846b37f$var$once(callback || $e808b73f4846b37f$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $e808b73f4846b37f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $e808b73f4846b37f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($e808b73f4846b37f$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $e808b73f4846b37f$var$eos;

});


parcelRegister("gljMO", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("lUyqo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $ff3987f7b5428486$var$Transform;

var $i8n8u = parcelRequire("i8n8u");
var $ff3987f7b5428486$require$_require$codes = $i8n8u.codes;
var $ff3987f7b5428486$var$ERR_METHOD_NOT_IMPLEMENTED = $ff3987f7b5428486$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $ff3987f7b5428486$var$ERR_MULTIPLE_CALLBACK = $ff3987f7b5428486$require$_require$codes.ERR_MULTIPLE_CALLBACK, $ff3987f7b5428486$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $ff3987f7b5428486$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $ff3987f7b5428486$var$ERR_TRANSFORM_WITH_LENGTH_0 = $ff3987f7b5428486$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $aoI29 = parcelRequire("aoI29");

(parcelRequire("lyUaN"))($ff3987f7b5428486$var$Transform, $aoI29);
function $ff3987f7b5428486$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $ff3987f7b5428486$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $ff3987f7b5428486$var$Transform(options) {
    if (!(this instanceof $ff3987f7b5428486$var$Transform)) return new $ff3987f7b5428486$var$Transform(options);
    $aoI29.call(this, options);
    this._transformState = {
        afterTransform: $ff3987f7b5428486$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $ff3987f7b5428486$var$prefinish);
}
function $ff3987f7b5428486$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $ff3987f7b5428486$var$done(_this, er, data);
    });
    else $ff3987f7b5428486$var$done(this, null, null);
}
$ff3987f7b5428486$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $aoI29.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$ff3987f7b5428486$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $ff3987f7b5428486$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$ff3987f7b5428486$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$ff3987f7b5428486$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$ff3987f7b5428486$var$Transform.prototype._destroy = function(err, cb) {
    $aoI29.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $ff3987f7b5428486$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $ff3987f7b5428486$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $ff3987f7b5428486$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("4kZwd", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $3288bffe507d45ca$var$PassThrough;

var $lUyqo = parcelRequire("lUyqo");

(parcelRequire("lyUaN"))($3288bffe507d45ca$var$PassThrough, $lUyqo);
function $3288bffe507d45ca$var$PassThrough(options) {
    if (!(this instanceof $3288bffe507d45ca$var$PassThrough)) return new $3288bffe507d45ca$var$PassThrough(options);
    $lUyqo.call(this, options);
}
$3288bffe507d45ca$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("8Ms18", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $66488a15dea22053$var$eos;
function $66488a15dea22053$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $i8n8u = parcelRequire("i8n8u");
var $66488a15dea22053$require$_require$codes = $i8n8u.codes;
var $66488a15dea22053$var$ERR_MISSING_ARGS = $66488a15dea22053$require$_require$codes.ERR_MISSING_ARGS, $66488a15dea22053$var$ERR_STREAM_DESTROYED = $66488a15dea22053$require$_require$codes.ERR_STREAM_DESTROYED;
function $66488a15dea22053$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $66488a15dea22053$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $66488a15dea22053$var$destroyer(stream, reading, writing, callback) {
    callback = $66488a15dea22053$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($66488a15dea22053$var$eos === undefined) $66488a15dea22053$var$eos = (parcelRequire("jV6VG"));
    $66488a15dea22053$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($66488a15dea22053$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $66488a15dea22053$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $66488a15dea22053$var$call(fn) {
    fn();
}
function $66488a15dea22053$var$pipe(from, to) {
    return from.pipe(to);
}
function $66488a15dea22053$var$popCallback(streams) {
    if (!streams.length) return $66488a15dea22053$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $66488a15dea22053$var$noop;
    return streams.pop();
}
function $66488a15dea22053$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $66488a15dea22053$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $66488a15dea22053$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $66488a15dea22053$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($66488a15dea22053$var$call);
            if (reading) return;
            destroys.forEach($66488a15dea22053$var$call);
            callback(error);
        });
    });
    return streams.reduce($66488a15dea22053$var$pipe);
}
module.exports = $66488a15dea22053$var$pipeline;

});




parcelRegister("lqV5D", function(module, exports) {
var $f9a84f91b73961ae$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $f9a84f91b73961ae$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

$f9a84f91b73961ae$var$exports.sha = (parcelRequire("aq7sD"));

$f9a84f91b73961ae$var$exports.sha1 = (parcelRequire("5hjhX"));

$f9a84f91b73961ae$var$exports.sha224 = (parcelRequire("7Rfie"));

$f9a84f91b73961ae$var$exports.sha256 = (parcelRequire("eF9el"));

$f9a84f91b73961ae$var$exports.sha384 = (parcelRequire("9B479"));

$f9a84f91b73961ae$var$exports.sha512 = (parcelRequire("bir8L"));

});
parcelRegister("aq7sD", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $lyUaN = parcelRequire("lyUaN");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $79621eabed5f8c00$require$Buffer = $ijh2q.Buffer;
var $79621eabed5f8c00$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $79621eabed5f8c00$var$W = new Array(80);
function $79621eabed5f8c00$var$Sha() {
    this.init();
    this._w = $79621eabed5f8c00$var$W;
    $laXlc.call(this, 64, 56);
}
$lyUaN($79621eabed5f8c00$var$Sha, $laXlc);
$79621eabed5f8c00$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $79621eabed5f8c00$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $79621eabed5f8c00$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $79621eabed5f8c00$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$79621eabed5f8c00$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $79621eabed5f8c00$var$rotl5(a) + $79621eabed5f8c00$var$ft(s, b, c, d) + e + W[j] + $79621eabed5f8c00$var$K[s] | 0;
        e = d;
        d = c;
        c = $79621eabed5f8c00$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$79621eabed5f8c00$var$Sha.prototype._hash = function() {
    var H = $79621eabed5f8c00$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $79621eabed5f8c00$var$Sha;

});
parcelRegister("laXlc", function(module, exports) {

var $ijh2q = parcelRequire("ijh2q");
var $f6a89006f13ce239$require$Buffer = $ijh2q.Buffer;
// prototype class for hash functions
function $f6a89006f13ce239$var$Hash(blockSize, finalSize) {
    this._block = $f6a89006f13ce239$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$f6a89006f13ce239$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === 'string') {
        enc = enc || 'utf8';
        data = $f6a89006f13ce239$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$f6a89006f13ce239$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$f6a89006f13ce239$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $f6a89006f13ce239$var$Hash;

});


parcelRegister("5hjhX", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $lyUaN = parcelRequire("lyUaN");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $3d7d809e7a1ab643$require$Buffer = $ijh2q.Buffer;
var $3d7d809e7a1ab643$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $3d7d809e7a1ab643$var$W = new Array(80);
function $3d7d809e7a1ab643$var$Sha1() {
    this.init();
    this._w = $3d7d809e7a1ab643$var$W;
    $laXlc.call(this, 64, 56);
}
$lyUaN($3d7d809e7a1ab643$var$Sha1, $laXlc);
$3d7d809e7a1ab643$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $3d7d809e7a1ab643$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $3d7d809e7a1ab643$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $3d7d809e7a1ab643$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $3d7d809e7a1ab643$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$3d7d809e7a1ab643$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $3d7d809e7a1ab643$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $3d7d809e7a1ab643$var$rotl5(a) + $3d7d809e7a1ab643$var$ft(s, b, c, d) + e + W[j] + $3d7d809e7a1ab643$var$K[s] | 0;
        e = d;
        d = c;
        c = $3d7d809e7a1ab643$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$3d7d809e7a1ab643$var$Sha1.prototype._hash = function() {
    var H = $3d7d809e7a1ab643$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $3d7d809e7a1ab643$var$Sha1;

});

parcelRegister("7Rfie", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $lyUaN = parcelRequire("lyUaN");

var $eF9el = parcelRequire("eF9el");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $5b895883d67b9370$require$Buffer = $ijh2q.Buffer;
var $5b895883d67b9370$var$W = new Array(64);
function $5b895883d67b9370$var$Sha224() {
    this.init();
    this._w = $5b895883d67b9370$var$W // new Array(64)
    ;
    $laXlc.call(this, 64, 56);
}
$lyUaN($5b895883d67b9370$var$Sha224, $eF9el);
$5b895883d67b9370$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$5b895883d67b9370$var$Sha224.prototype._hash = function() {
    var H = $5b895883d67b9370$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $5b895883d67b9370$var$Sha224;

});
parcelRegister("eF9el", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $lyUaN = parcelRequire("lyUaN");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $aacc0e009da62399$require$Buffer = $ijh2q.Buffer;
var $aacc0e009da62399$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $aacc0e009da62399$var$W = new Array(64);
function $aacc0e009da62399$var$Sha256() {
    this.init();
    this._w = $aacc0e009da62399$var$W // new Array(64)
    ;
    $laXlc.call(this, 64, 56);
}
$lyUaN($aacc0e009da62399$var$Sha256, $laXlc);
$aacc0e009da62399$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $aacc0e009da62399$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $aacc0e009da62399$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $aacc0e009da62399$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $aacc0e009da62399$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $aacc0e009da62399$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $aacc0e009da62399$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$aacc0e009da62399$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $aacc0e009da62399$var$gamma1(W[i - 2]) + W[i - 7] + $aacc0e009da62399$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $aacc0e009da62399$var$sigma1(e) + $aacc0e009da62399$var$ch(e, f, g) + $aacc0e009da62399$var$K[j] + W[j] | 0;
        var T2 = $aacc0e009da62399$var$sigma0(a) + $aacc0e009da62399$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$aacc0e009da62399$var$Sha256.prototype._hash = function() {
    var H = $aacc0e009da62399$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $aacc0e009da62399$var$Sha256;

});


parcelRegister("9B479", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $bir8L = parcelRequire("bir8L");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $6fcac2cb2d39f17a$require$Buffer = $ijh2q.Buffer;
var $6fcac2cb2d39f17a$var$W = new Array(160);
function $6fcac2cb2d39f17a$var$Sha384() {
    this.init();
    this._w = $6fcac2cb2d39f17a$var$W;
    $laXlc.call(this, 128, 112);
}
$lyUaN($6fcac2cb2d39f17a$var$Sha384, $bir8L);
$6fcac2cb2d39f17a$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$6fcac2cb2d39f17a$var$Sha384.prototype._hash = function() {
    var H = $6fcac2cb2d39f17a$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $6fcac2cb2d39f17a$var$Sha384;

});
parcelRegister("bir8L", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $83966da3ee4e453b$require$Buffer = $ijh2q.Buffer;
var $83966da3ee4e453b$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $83966da3ee4e453b$var$W = new Array(160);
function $83966da3ee4e453b$var$Sha512() {
    this.init();
    this._w = $83966da3ee4e453b$var$W;
    $laXlc.call(this, 128, 112);
}
$lyUaN($83966da3ee4e453b$var$Sha512, $laXlc);
$83966da3ee4e453b$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $83966da3ee4e453b$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $83966da3ee4e453b$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $83966da3ee4e453b$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $83966da3ee4e453b$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $83966da3ee4e453b$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $83966da3ee4e453b$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $83966da3ee4e453b$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $83966da3ee4e453b$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $83966da3ee4e453b$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$83966da3ee4e453b$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $83966da3ee4e453b$var$Gamma0(xh, xl);
        var gamma0l = $83966da3ee4e453b$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $83966da3ee4e453b$var$Gamma1(xh, xl);
        var gamma1l = $83966da3ee4e453b$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $83966da3ee4e453b$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $83966da3ee4e453b$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $83966da3ee4e453b$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $83966da3ee4e453b$var$maj(ah, bh, ch);
        var majl = $83966da3ee4e453b$var$maj(al, bl, cl);
        var sigma0h = $83966da3ee4e453b$var$sigma0(ah, al);
        var sigma0l = $83966da3ee4e453b$var$sigma0(al, ah);
        var sigma1h = $83966da3ee4e453b$var$sigma1(eh, el);
        var sigma1l = $83966da3ee4e453b$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $83966da3ee4e453b$var$K[j];
        var Kil = $83966da3ee4e453b$var$K[j + 1];
        var chh = $83966da3ee4e453b$var$Ch(eh, fh, gh);
        var chl = $83966da3ee4e453b$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $83966da3ee4e453b$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $83966da3ee4e453b$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $83966da3ee4e453b$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $83966da3ee4e453b$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $83966da3ee4e453b$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $83966da3ee4e453b$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $83966da3ee4e453b$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $83966da3ee4e453b$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $83966da3ee4e453b$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $83966da3ee4e453b$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $83966da3ee4e453b$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $83966da3ee4e453b$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $83966da3ee4e453b$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $83966da3ee4e453b$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $83966da3ee4e453b$var$getCarry(this._hl, hl) | 0;
};
$83966da3ee4e453b$var$Sha512.prototype._hash = function() {
    var H = $83966da3ee4e453b$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $83966da3ee4e453b$var$Sha512;

});



parcelRegister("7hBrF", function(module, exports) {

var $ijh2q = parcelRequire("ijh2q");
var $54d72ac3f9f3d584$require$Buffer = $ijh2q.Buffer;

var $anz8L = parcelRequire("anz8L");
var $54d72ac3f9f3d584$require$Transform = $anz8L.Transform;

var $iSptP = parcelRequire("iSptP");
var $54d72ac3f9f3d584$require$StringDecoder = $iSptP.StringDecoder;

var $lyUaN = parcelRequire("lyUaN");
function $54d72ac3f9f3d584$var$CipherBase(hashMode) {
    $54d72ac3f9f3d584$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$lyUaN($54d72ac3f9f3d584$var$CipherBase, $54d72ac3f9f3d584$require$Transform);
$54d72ac3f9f3d584$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === 'string') data = $54d72ac3f9f3d584$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$54d72ac3f9f3d584$var$CipherBase.prototype.setAutoPadding = function() {};
$54d72ac3f9f3d584$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$54d72ac3f9f3d584$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$54d72ac3f9f3d584$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$54d72ac3f9f3d584$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$54d72ac3f9f3d584$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$54d72ac3f9f3d584$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $54d72ac3f9f3d584$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$54d72ac3f9f3d584$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $54d72ac3f9f3d584$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error('can\'t switch encodings');
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $54d72ac3f9f3d584$var$CipherBase;

});


parcelRegister("jPoqK", function(module, exports) {
'use strict';

var $lyUaN = parcelRequire("lyUaN");

var $lYCTE = parcelRequire("lYCTE");

var $7hBrF = parcelRequire("7hBrF");

var $ijh2q = parcelRequire("ijh2q");
var $e6f5bb1bc44e45c9$require$Buffer = $ijh2q.Buffer;

var $6Kk1A = parcelRequire("6Kk1A");

var $bGrC1 = parcelRequire("bGrC1");

var $lqV5D = parcelRequire("lqV5D");
var $e6f5bb1bc44e45c9$var$ZEROS = $e6f5bb1bc44e45c9$require$Buffer.alloc(128);
function $e6f5bb1bc44e45c9$var$Hmac(alg, key) {
    $7hBrF.call(this, 'digest');
    if (typeof key === 'string') key = $e6f5bb1bc44e45c9$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $bGrC1() : $lqV5D(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $e6f5bb1bc44e45c9$require$Buffer.concat([
        key,
        $e6f5bb1bc44e45c9$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $e6f5bb1bc44e45c9$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $e6f5bb1bc44e45c9$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $bGrC1() : $lqV5D(alg);
    this._hash.update(ipad);
}
$lyUaN($e6f5bb1bc44e45c9$var$Hmac, $7hBrF);
$e6f5bb1bc44e45c9$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$e6f5bb1bc44e45c9$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $bGrC1() : $lqV5D(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $e6f5bb1bc44e45c9$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $lYCTE($6Kk1A, key);
    return new $e6f5bb1bc44e45c9$var$Hmac(alg, key);
};

});
parcelRegister("lYCTE", function(module, exports) {
'use strict';

var $lyUaN = parcelRequire("lyUaN");

var $ijh2q = parcelRequire("ijh2q");
var $fffd5f9b09d9e4a8$require$Buffer = $ijh2q.Buffer;

var $7hBrF = parcelRequire("7hBrF");
var $fffd5f9b09d9e4a8$var$ZEROS = $fffd5f9b09d9e4a8$require$Buffer.alloc(128);
var $fffd5f9b09d9e4a8$var$blocksize = 64;
function $fffd5f9b09d9e4a8$var$Hmac(alg, key) {
    $7hBrF.call(this, 'digest');
    if (typeof key === 'string') key = $fffd5f9b09d9e4a8$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $fffd5f9b09d9e4a8$var$blocksize) key = alg(key);
    else if (key.length < $fffd5f9b09d9e4a8$var$blocksize) key = $fffd5f9b09d9e4a8$require$Buffer.concat([
        key,
        $fffd5f9b09d9e4a8$var$ZEROS
    ], $fffd5f9b09d9e4a8$var$blocksize);
    var ipad = this._ipad = $fffd5f9b09d9e4a8$require$Buffer.allocUnsafe($fffd5f9b09d9e4a8$var$blocksize);
    var opad = this._opad = $fffd5f9b09d9e4a8$require$Buffer.allocUnsafe($fffd5f9b09d9e4a8$var$blocksize);
    for(var i = 0; i < $fffd5f9b09d9e4a8$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$lyUaN($fffd5f9b09d9e4a8$var$Hmac, $7hBrF);
$fffd5f9b09d9e4a8$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$fffd5f9b09d9e4a8$var$Hmac.prototype._final = function() {
    var h = this._alg($fffd5f9b09d9e4a8$require$Buffer.concat(this._hash));
    return this._alg($fffd5f9b09d9e4a8$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $fffd5f9b09d9e4a8$var$Hmac;

});


parcelRegister("61Iwu", function(module, exports) {

module.exports = (parcelRequire("5x0OM"));

});
parcelRegister("5x0OM", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("8bTm7", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $5f6a4a4c3eb5e5e3$export$448fa22aedc9dbca, (v) => $5f6a4a4c3eb5e5e3$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $5f6a4a4c3eb5e5e3$export$b80c7ba289c8fa56, (v) => $5f6a4a4c3eb5e5e3$export$b80c7ba289c8fa56 = v);
var $5f6a4a4c3eb5e5e3$export$448fa22aedc9dbca;
var $5f6a4a4c3eb5e5e3$export$b80c7ba289c8fa56;

$5f6a4a4c3eb5e5e3$export$448fa22aedc9dbca = (parcelRequire("fkARo"));

$5f6a4a4c3eb5e5e3$export$b80c7ba289c8fa56 = (parcelRequire("fVtzD"));

});
parcelRegister("fkARo", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");

var $jS82b = parcelRequire("jS82b");

var $lniV2 = parcelRequire("lniV2");

var $fVtzD = parcelRequire("fVtzD");

var $ijh2q = parcelRequire("ijh2q");
var $b29550e988d9fb77$require$Buffer = $ijh2q.Buffer;
var $b29550e988d9fb77$var$ZERO_BUF;
var $b29550e988d9fb77$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $b29550e988d9fb77$var$toBrowser = {
    'sha': 'SHA-1',
    'sha-1': 'SHA-1',
    'sha1': 'SHA-1',
    'sha256': 'SHA-256',
    'sha-256': 'SHA-256',
    'sha384': 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    'sha512': 'SHA-512'
};
var $b29550e988d9fb77$var$checks = [];
function $b29550e988d9fb77$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$b29550e988d9fb77$var$subtle || !$b29550e988d9fb77$var$subtle.importKey || !$b29550e988d9fb77$var$subtle.deriveBits) return Promise.resolve(false);
    if ($b29550e988d9fb77$var$checks[algo] !== undefined) return $b29550e988d9fb77$var$checks[algo];
    $b29550e988d9fb77$var$ZERO_BUF = $b29550e988d9fb77$var$ZERO_BUF || $b29550e988d9fb77$require$Buffer.alloc(8);
    var prom = $b29550e988d9fb77$var$browserPbkdf2($b29550e988d9fb77$var$ZERO_BUF, $b29550e988d9fb77$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $b29550e988d9fb77$var$checks[algo] = prom;
    return prom;
}
function $b29550e988d9fb77$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $b29550e988d9fb77$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $b29550e988d9fb77$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $b29550e988d9fb77$require$Buffer.from(res);
    });
}
function $b29550e988d9fb77$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $2fFJv.nextTick(function() {
            callback(null, out);
        });
    }, function(e) {
        $2fFJv.nextTick(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (!$b29550e988d9fb77$require$Buffer.isBuffer(password)) password = $b29550e988d9fb77$require$Buffer.from(password, $lniV2);
    if (!$b29550e988d9fb77$require$Buffer.isBuffer(salt)) salt = $b29550e988d9fb77$require$Buffer.from(salt, $lniV2);
    $jS82b(iterations, keylen);
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $b29550e988d9fb77$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') return $2fFJv.nextTick(function() {
        var out;
        try {
            out = $fVtzD(password, salt, iterations, keylen, digest);
        } catch (e) {
            return callback(e);
        }
        callback(null, out);
    });
    $b29550e988d9fb77$var$resolvePromise($b29550e988d9fb77$var$checkNative(algo).then(function(resp) {
        if (resp) return $b29550e988d9fb77$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        else return $fVtzD(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("jS82b", function(module, exports) {
var $e7794aead791fe5d$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $e7794aead791fe5d$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("lniV2", function(module, exports) {
var $f8fa6bde347fdcff$var$defaultEncoding;
var $f8fa6bde347fdcff$var$pVersionMajor;
$f8fa6bde347fdcff$var$defaultEncoding = 'utf-8';
module.exports = $f8fa6bde347fdcff$var$defaultEncoding;

});

parcelRegister("fVtzD", function(module, exports) {

var $6Kk1A = parcelRequire("6Kk1A");

var $bGrC1 = parcelRequire("bGrC1");

var $lqV5D = parcelRequire("lqV5D");

var $jS82b = parcelRequire("jS82b");

var $lniV2 = parcelRequire("lniV2");

var $ijh2q = parcelRequire("ijh2q");
var $b9831e9db81e0e59$require$Buffer = $ijh2q.Buffer;
var $b9831e9db81e0e59$var$ZEROS = $b9831e9db81e0e59$require$Buffer.alloc(128);
var $b9831e9db81e0e59$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $b9831e9db81e0e59$var$Hmac(alg, key, saltLen) {
    var hash = $b9831e9db81e0e59$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $b9831e9db81e0e59$require$Buffer.concat([
        key,
        $b9831e9db81e0e59$var$ZEROS
    ], blocksize);
    var ipad = $b9831e9db81e0e59$require$Buffer.allocUnsafe(blocksize + $b9831e9db81e0e59$var$sizes[alg]);
    var opad = $b9831e9db81e0e59$require$Buffer.allocUnsafe(blocksize + $b9831e9db81e0e59$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $b9831e9db81e0e59$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $b9831e9db81e0e59$var$sizes[alg];
}
$b9831e9db81e0e59$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $b9831e9db81e0e59$var$getDigest(alg) {
    function shaFunc(data) {
        return $lqV5D(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $bGrC1;
    if (alg === 'md5') return $6Kk1A;
    return shaFunc;
}
function $b9831e9db81e0e59$var$pbkdf2(password, salt, iterations, keylen, digest) {
    if (!$b9831e9db81e0e59$require$Buffer.isBuffer(password)) password = $b9831e9db81e0e59$require$Buffer.from(password, $lniV2);
    if (!$b9831e9db81e0e59$require$Buffer.isBuffer(salt)) salt = $b9831e9db81e0e59$require$Buffer.from(salt, $lniV2);
    $jS82b(iterations, keylen);
    digest = digest || 'sha1';
    var hmac = new $b9831e9db81e0e59$var$Hmac(digest, password, salt.length);
    var DK = $b9831e9db81e0e59$require$Buffer.allocUnsafe(keylen);
    var block1 = $b9831e9db81e0e59$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $b9831e9db81e0e59$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $b9831e9db81e0e59$var$pbkdf2;

});



parcelRegister("9rGLx", function(module, exports) {

$parcel$export(module.exports, "createCipher", () => $6e07cf0dc2bcbbb7$export$bdd223f16383713e, (v) => $6e07cf0dc2bcbbb7$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $6e07cf0dc2bcbbb7$export$26e5786e8ac8e530, (v) => $6e07cf0dc2bcbbb7$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $6e07cf0dc2bcbbb7$export$2f64596b8cbf08b4, (v) => $6e07cf0dc2bcbbb7$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $6e07cf0dc2bcbbb7$export$20533d26f07f1ee0, (v) => $6e07cf0dc2bcbbb7$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $6e07cf0dc2bcbbb7$export$12ada9414fbc594c, (v) => $6e07cf0dc2bcbbb7$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $6e07cf0dc2bcbbb7$export$2ce6d8d0e8b04e1a, (v) => $6e07cf0dc2bcbbb7$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $6e07cf0dc2bcbbb7$export$36b6d6ef312eab39, (v) => $6e07cf0dc2bcbbb7$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $6e07cf0dc2bcbbb7$export$f5e7e39d57cd9700, (v) => $6e07cf0dc2bcbbb7$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $6e07cf0dc2bcbbb7$export$dedd8dc3dc62b370, (v) => $6e07cf0dc2bcbbb7$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $6e07cf0dc2bcbbb7$export$58a258485f1e49f6, (v) => $6e07cf0dc2bcbbb7$export$58a258485f1e49f6 = v);
var $6e07cf0dc2bcbbb7$export$bdd223f16383713e;
var $6e07cf0dc2bcbbb7$export$26e5786e8ac8e530;
var $6e07cf0dc2bcbbb7$export$2f64596b8cbf08b4;
var $6e07cf0dc2bcbbb7$export$20533d26f07f1ee0;
var $6e07cf0dc2bcbbb7$export$12ada9414fbc594c;
var $6e07cf0dc2bcbbb7$export$2ce6d8d0e8b04e1a;
var $6e07cf0dc2bcbbb7$export$36b6d6ef312eab39;
var $6e07cf0dc2bcbbb7$export$f5e7e39d57cd9700;
var $6e07cf0dc2bcbbb7$export$dedd8dc3dc62b370;
var $6e07cf0dc2bcbbb7$export$58a258485f1e49f6;

var $d9sFZ = parcelRequire("d9sFZ");

var $FyTgm = parcelRequire("FyTgm");

var $A6QqV = parcelRequire("A6QqV");

var $9Xue6 = parcelRequire("9Xue6");

var $2z1oX = parcelRequire("2z1oX");
function $6e07cf0dc2bcbbb7$var$createCipher(suite, password) {
    var keyLen, ivLen;
    suite = suite.toLowerCase();
    if ($2z1oX[suite]) {
        keyLen = $2z1oX[suite].key;
        ivLen = $2z1oX[suite].iv;
    } else if ($9Xue6[suite]) {
        keyLen = $9Xue6[suite].key * 8;
        ivLen = $9Xue6[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $d9sFZ(password, false, keyLen, ivLen);
    return $6e07cf0dc2bcbbb7$var$createCipheriv(suite, keys.key, keys.iv);
}
function $6e07cf0dc2bcbbb7$var$createDecipher(suite, password) {
    var keyLen, ivLen;
    suite = suite.toLowerCase();
    if ($2z1oX[suite]) {
        keyLen = $2z1oX[suite].key;
        ivLen = $2z1oX[suite].iv;
    } else if ($9Xue6[suite]) {
        keyLen = $9Xue6[suite].key * 8;
        ivLen = $9Xue6[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $d9sFZ(password, false, keyLen, ivLen);
    return $6e07cf0dc2bcbbb7$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $6e07cf0dc2bcbbb7$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($2z1oX[suite]) return $FyTgm.createCipheriv(suite, key, iv);
    else if ($9Xue6[suite]) return new $A6QqV({
        key: key,
        iv: iv,
        mode: suite
    });
    else throw new TypeError('invalid suite type');
}
function $6e07cf0dc2bcbbb7$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($2z1oX[suite]) return $FyTgm.createDecipheriv(suite, key, iv);
    else if ($9Xue6[suite]) return new $A6QqV({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    else throw new TypeError('invalid suite type');
}
$6e07cf0dc2bcbbb7$export$bdd223f16383713e = $6e07cf0dc2bcbbb7$export$26e5786e8ac8e530 = $6e07cf0dc2bcbbb7$var$createCipher;
$6e07cf0dc2bcbbb7$export$2f64596b8cbf08b4 = $6e07cf0dc2bcbbb7$export$20533d26f07f1ee0 = $6e07cf0dc2bcbbb7$var$createCipheriv;
$6e07cf0dc2bcbbb7$export$12ada9414fbc594c = $6e07cf0dc2bcbbb7$export$2ce6d8d0e8b04e1a = $6e07cf0dc2bcbbb7$var$createDecipher;
$6e07cf0dc2bcbbb7$export$36b6d6ef312eab39 = $6e07cf0dc2bcbbb7$export$f5e7e39d57cd9700 = $6e07cf0dc2bcbbb7$var$createDecipheriv;
function $6e07cf0dc2bcbbb7$var$getCiphers() {
    return Object.keys($9Xue6).concat($FyTgm.getCiphers());
}
$6e07cf0dc2bcbbb7$export$dedd8dc3dc62b370 = $6e07cf0dc2bcbbb7$export$58a258485f1e49f6 = $6e07cf0dc2bcbbb7$var$getCiphers;

});
parcelRegister("d9sFZ", function(module, exports) {

var $ijh2q = parcelRequire("ijh2q");
var $99325c1fe2a705db$require$Buffer = $ijh2q.Buffer;

var $fVE4x = parcelRequire("fVE4x");
/* eslint-disable camelcase */ function $99325c1fe2a705db$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$99325c1fe2a705db$require$Buffer.isBuffer(password)) password = $99325c1fe2a705db$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$99325c1fe2a705db$require$Buffer.isBuffer(salt)) salt = $99325c1fe2a705db$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $99325c1fe2a705db$require$Buffer.alloc(keyLen);
    var iv = $99325c1fe2a705db$require$Buffer.alloc(ivLen || 0);
    var tmp = $99325c1fe2a705db$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $fVE4x();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $99325c1fe2a705db$var$EVP_BytesToKey;

});
parcelRegister("fVE4x", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $b98b436904fea768$require$Buffer = $aul3P.Buffer;
'use strict';

var $lyUaN = parcelRequire("lyUaN");

var $2UmI8 = parcelRequire("2UmI8");
var $b98b436904fea768$var$ARRAY16 = new Array(16);
function $b98b436904fea768$var$MD5() {
    $2UmI8.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$lyUaN($b98b436904fea768$var$MD5, $2UmI8);
$b98b436904fea768$var$MD5.prototype._update = function() {
    var M = $b98b436904fea768$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $b98b436904fea768$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $b98b436904fea768$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $b98b436904fea768$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $b98b436904fea768$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $b98b436904fea768$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $b98b436904fea768$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $b98b436904fea768$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $b98b436904fea768$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $b98b436904fea768$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $b98b436904fea768$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $b98b436904fea768$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $b98b436904fea768$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $b98b436904fea768$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $b98b436904fea768$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $b98b436904fea768$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $b98b436904fea768$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $b98b436904fea768$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $b98b436904fea768$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $b98b436904fea768$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $b98b436904fea768$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $b98b436904fea768$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $b98b436904fea768$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $b98b436904fea768$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $b98b436904fea768$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $b98b436904fea768$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $b98b436904fea768$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $b98b436904fea768$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $b98b436904fea768$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $b98b436904fea768$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $b98b436904fea768$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $b98b436904fea768$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $b98b436904fea768$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $b98b436904fea768$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $b98b436904fea768$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $b98b436904fea768$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $b98b436904fea768$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $b98b436904fea768$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $b98b436904fea768$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $b98b436904fea768$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $b98b436904fea768$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $b98b436904fea768$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $b98b436904fea768$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $b98b436904fea768$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $b98b436904fea768$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $b98b436904fea768$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $b98b436904fea768$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $b98b436904fea768$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $b98b436904fea768$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $b98b436904fea768$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $b98b436904fea768$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $b98b436904fea768$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $b98b436904fea768$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $b98b436904fea768$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $b98b436904fea768$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $b98b436904fea768$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $b98b436904fea768$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $b98b436904fea768$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $b98b436904fea768$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $b98b436904fea768$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $b98b436904fea768$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $b98b436904fea768$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $b98b436904fea768$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $b98b436904fea768$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $b98b436904fea768$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$b98b436904fea768$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = new $b98b436904fea768$require$Buffer(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $b98b436904fea768$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $b98b436904fea768$var$fnF(a, b, c, d, m, k, s) {
    return $b98b436904fea768$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $b98b436904fea768$var$fnG(a, b, c, d, m, k, s) {
    return $b98b436904fea768$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $b98b436904fea768$var$fnH(a, b, c, d, m, k, s) {
    return $b98b436904fea768$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $b98b436904fea768$var$fnI(a, b, c, d, m, k, s) {
    return $b98b436904fea768$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $b98b436904fea768$var$MD5;

});


parcelRegister("FyTgm", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $07cee4f1b56d3371$export$2f64596b8cbf08b4, (v) => $07cee4f1b56d3371$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $07cee4f1b56d3371$export$36b6d6ef312eab39, (v) => $07cee4f1b56d3371$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $07cee4f1b56d3371$export$58a258485f1e49f6, (v) => $07cee4f1b56d3371$export$58a258485f1e49f6 = v);
var $07cee4f1b56d3371$export$bdd223f16383713e;
var $07cee4f1b56d3371$export$26e5786e8ac8e530;
var $07cee4f1b56d3371$export$2f64596b8cbf08b4;
var $07cee4f1b56d3371$export$20533d26f07f1ee0;
var $07cee4f1b56d3371$export$12ada9414fbc594c;
var $07cee4f1b56d3371$export$2ce6d8d0e8b04e1a;
var $07cee4f1b56d3371$export$36b6d6ef312eab39;
var $07cee4f1b56d3371$export$f5e7e39d57cd9700;
var $07cee4f1b56d3371$export$dedd8dc3dc62b370;
var $07cee4f1b56d3371$export$58a258485f1e49f6;

var $6VQvi = parcelRequire("6VQvi");

var $2o6Y4 = parcelRequire("2o6Y4");

var $bv6dQ = parcelRequire("bv6dQ");
function $07cee4f1b56d3371$var$getCiphers() {
    return Object.keys($bv6dQ);
}
$07cee4f1b56d3371$export$bdd223f16383713e = $07cee4f1b56d3371$export$26e5786e8ac8e530 = $6VQvi.createCipher;
$07cee4f1b56d3371$export$2f64596b8cbf08b4 = $07cee4f1b56d3371$export$20533d26f07f1ee0 = $6VQvi.createCipheriv;
$07cee4f1b56d3371$export$12ada9414fbc594c = $07cee4f1b56d3371$export$2ce6d8d0e8b04e1a = $2o6Y4.createDecipher;
$07cee4f1b56d3371$export$36b6d6ef312eab39 = $07cee4f1b56d3371$export$f5e7e39d57cd9700 = $2o6Y4.createDecipheriv;
$07cee4f1b56d3371$export$dedd8dc3dc62b370 = $07cee4f1b56d3371$export$58a258485f1e49f6 = $07cee4f1b56d3371$var$getCiphers;

});
parcelRegister("6VQvi", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $50c0cb1d854268c2$export$2f64596b8cbf08b4, (v) => $50c0cb1d854268c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $50c0cb1d854268c2$export$bdd223f16383713e, (v) => $50c0cb1d854268c2$export$bdd223f16383713e = v);
var $50c0cb1d854268c2$export$2f64596b8cbf08b4;
var $50c0cb1d854268c2$export$bdd223f16383713e;

var $2z1oX = parcelRequire("2z1oX");

var $jEzvF = parcelRequire("jEzvF");

var $ijh2q = parcelRequire("ijh2q");
var $50c0cb1d854268c2$require$Buffer = $ijh2q.Buffer;

var $96zpw = parcelRequire("96zpw");

var $7hBrF = parcelRequire("7hBrF");

var $hPkMt = parcelRequire("hPkMt");

var $d9sFZ = parcelRequire("d9sFZ");

var $lyUaN = parcelRequire("lyUaN");
function $50c0cb1d854268c2$var$Cipher(mode, key, iv) {
    $7hBrF.call(this);
    this._cache = new $50c0cb1d854268c2$var$Splitter();
    this._cipher = new $hPkMt.AES(key);
    this._prev = $50c0cb1d854268c2$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$lyUaN($50c0cb1d854268c2$var$Cipher, $7hBrF);
$50c0cb1d854268c2$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $50c0cb1d854268c2$require$Buffer.concat(out);
};
var $50c0cb1d854268c2$var$PADDING = $50c0cb1d854268c2$require$Buffer.alloc(16, 0x10);
$50c0cb1d854268c2$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($50c0cb1d854268c2$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$50c0cb1d854268c2$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $50c0cb1d854268c2$var$Splitter() {
    this.cache = $50c0cb1d854268c2$require$Buffer.allocUnsafe(0);
}
$50c0cb1d854268c2$var$Splitter.prototype.add = function(data) {
    this.cache = $50c0cb1d854268c2$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$50c0cb1d854268c2$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$50c0cb1d854268c2$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $50c0cb1d854268c2$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $50c0cb1d854268c2$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $50c0cb1d854268c2$var$createCipheriv(suite, password, iv) {
    var config = $2z1oX[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $50c0cb1d854268c2$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $50c0cb1d854268c2$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $96zpw(config.module, password, iv);
    else if (config.type === 'auth') return new $jEzvF(config.module, password, iv);
    return new $50c0cb1d854268c2$var$Cipher(config.module, password, iv);
}
function $50c0cb1d854268c2$var$createCipher(suite, password) {
    var config = $2z1oX[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $d9sFZ(password, false, config.key, config.iv);
    return $50c0cb1d854268c2$var$createCipheriv(suite, keys.key, keys.iv);
}
$50c0cb1d854268c2$export$2f64596b8cbf08b4 = $50c0cb1d854268c2$var$createCipheriv;
$50c0cb1d854268c2$export$bdd223f16383713e = $50c0cb1d854268c2$var$createCipher;

});
parcelRegister("2z1oX", function(module, exports) {








var $1ddfeffa5f98a92e$var$modeModules = {
    ECB: (parcelRequire("hZIaM")),
    CBC: (parcelRequire("fmope")),
    CFB: (parcelRequire("lG0PJ")),
    CFB8: (parcelRequire("llTPt")),
    CFB1: (parcelRequire("efIgE")),
    OFB: (parcelRequire("1xe0H")),
    CTR: (parcelRequire("dJNe4")),
    GCM: (parcelRequire("dJNe4"))
};

var $bv6dQ = parcelRequire("bv6dQ");
for(var $1ddfeffa5f98a92e$var$key in $bv6dQ)$bv6dQ[$1ddfeffa5f98a92e$var$key].module = $1ddfeffa5f98a92e$var$modeModules[$bv6dQ[$1ddfeffa5f98a92e$var$key].mode];
module.exports = $bv6dQ;

});
parcelRegister("hZIaM", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $d19a65fdbdc127ec$export$5b0f6292f11d1d18, (v) => $d19a65fdbdc127ec$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $d19a65fdbdc127ec$export$e85a0c9a1067c5d3, (v) => $d19a65fdbdc127ec$export$e85a0c9a1067c5d3 = v);
var $d19a65fdbdc127ec$export$5b0f6292f11d1d18;
var $d19a65fdbdc127ec$export$e85a0c9a1067c5d3;
$d19a65fdbdc127ec$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$d19a65fdbdc127ec$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("fmope", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b2ebd79d572bda0f$export$5b0f6292f11d1d18, (v) => $b2ebd79d572bda0f$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $b2ebd79d572bda0f$export$e85a0c9a1067c5d3, (v) => $b2ebd79d572bda0f$export$e85a0c9a1067c5d3 = v);
var $b2ebd79d572bda0f$export$5b0f6292f11d1d18;
var $b2ebd79d572bda0f$export$e85a0c9a1067c5d3;

var $4fAiV = parcelRequire("4fAiV");
$b2ebd79d572bda0f$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $4fAiV(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$b2ebd79d572bda0f$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $4fAiV(out, pad);
};

});
parcelRegister("4fAiV", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $3184b96a1696b3ca$require$Buffer = $aul3P.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $3184b96a1696b3ca$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("lG0PJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $fc7e2ab8e9fb41d3$export$5b0f6292f11d1d18, (v) => $fc7e2ab8e9fb41d3$export$5b0f6292f11d1d18 = v);
var $fc7e2ab8e9fb41d3$export$5b0f6292f11d1d18;

var $ijh2q = parcelRequire("ijh2q");
var $fc7e2ab8e9fb41d3$require$Buffer = $ijh2q.Buffer;

var $4fAiV = parcelRequire("4fAiV");
function $fc7e2ab8e9fb41d3$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $4fAiV(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $fc7e2ab8e9fb41d3$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$fc7e2ab8e9fb41d3$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $fc7e2ab8e9fb41d3$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $fc7e2ab8e9fb41d3$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $fc7e2ab8e9fb41d3$require$Buffer.concat([
                out,
                $fc7e2ab8e9fb41d3$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $fc7e2ab8e9fb41d3$require$Buffer.concat([
                out,
                $fc7e2ab8e9fb41d3$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("llTPt", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $f8b6dda5639be9f3$export$5b0f6292f11d1d18, (v) => $f8b6dda5639be9f3$export$5b0f6292f11d1d18 = v);
var $f8b6dda5639be9f3$export$5b0f6292f11d1d18;

var $ijh2q = parcelRequire("ijh2q");
var $f8b6dda5639be9f3$require$Buffer = $ijh2q.Buffer;
function $f8b6dda5639be9f3$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $f8b6dda5639be9f3$require$Buffer.concat([
        self._prev.slice(1),
        $f8b6dda5639be9f3$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$f8b6dda5639be9f3$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $f8b6dda5639be9f3$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $f8b6dda5639be9f3$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("efIgE", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $a604cdff2a21876e$export$5b0f6292f11d1d18, (v) => $a604cdff2a21876e$export$5b0f6292f11d1d18 = v);
var $a604cdff2a21876e$export$5b0f6292f11d1d18;

var $ijh2q = parcelRequire("ijh2q");
var $a604cdff2a21876e$require$Buffer = $ijh2q.Buffer;
function $a604cdff2a21876e$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $a604cdff2a21876e$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $a604cdff2a21876e$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $a604cdff2a21876e$require$Buffer.allocUnsafe(buffer.length);
    buffer = $a604cdff2a21876e$require$Buffer.concat([
        buffer,
        $a604cdff2a21876e$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$a604cdff2a21876e$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $a604cdff2a21876e$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $a604cdff2a21876e$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("1xe0H", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $11e3bdad54d46713$export$5b0f6292f11d1d18, (v) => $11e3bdad54d46713$export$5b0f6292f11d1d18 = v);
var $11e3bdad54d46713$export$5b0f6292f11d1d18;

var $aul3P = parcelRequire("aul3P");
var $11e3bdad54d46713$require$Buffer = $aul3P.Buffer;

var $4fAiV = parcelRequire("4fAiV");
function $11e3bdad54d46713$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$11e3bdad54d46713$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $11e3bdad54d46713$require$Buffer.concat([
        self._cache,
        $11e3bdad54d46713$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $4fAiV(chunk, pad);
};

});

parcelRegister("dJNe4", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $a005a98f556409fd$export$5b0f6292f11d1d18, (v) => $a005a98f556409fd$export$5b0f6292f11d1d18 = v);
var $a005a98f556409fd$export$5b0f6292f11d1d18;

var $4fAiV = parcelRequire("4fAiV");

var $ijh2q = parcelRequire("ijh2q");
var $a005a98f556409fd$require$Buffer = $ijh2q.Buffer;

var $lkgcL = parcelRequire("lkgcL");
function $a005a98f556409fd$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $lkgcL(self._prev);
    return out;
}
var $a005a98f556409fd$var$blockSize = 16;
$a005a98f556409fd$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $a005a98f556409fd$var$blockSize);
    var start = self._cache.length;
    self._cache = $a005a98f556409fd$require$Buffer.concat([
        self._cache,
        $a005a98f556409fd$require$Buffer.allocUnsafe(chunkNum * $a005a98f556409fd$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $a005a98f556409fd$var$getBlock(self);
        var offset = start + i * $a005a98f556409fd$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $4fAiV(chunk, pad);
};

});
parcelRegister("lkgcL", function(module, exports) {
function $f868092934fdc144$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $f868092934fdc144$var$incr32;

});


parcelRegister("bv6dQ", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("jEzvF", function(module, exports) {

var $hPkMt = parcelRequire("hPkMt");

var $ijh2q = parcelRequire("ijh2q");
var $e4ed4c3b1c2c6a88$require$Buffer = $ijh2q.Buffer;

var $7hBrF = parcelRequire("7hBrF");

var $lyUaN = parcelRequire("lyUaN");

var $kWTRq = parcelRequire("kWTRq");

var $4fAiV = parcelRequire("4fAiV");

var $lkgcL = parcelRequire("lkgcL");
function $e4ed4c3b1c2c6a88$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $e4ed4c3b1c2c6a88$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $e4ed4c3b1c2c6a88$require$Buffer.concat([
            iv,
            $e4ed4c3b1c2c6a88$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $e4ed4c3b1c2c6a88$require$Buffer.concat([
            iv,
            $e4ed4c3b1c2c6a88$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $kWTRq(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($e4ed4c3b1c2c6a88$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($e4ed4c3b1c2c6a88$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $e4ed4c3b1c2c6a88$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $e4ed4c3b1c2c6a88$require$Buffer.from(self._finID);
    $lkgcL(out);
    return out;
}
function $e4ed4c3b1c2c6a88$var$StreamCipher(mode, key, iv, decrypt) {
    $7hBrF.call(this);
    var h = $e4ed4c3b1c2c6a88$require$Buffer.alloc(4, 0);
    this._cipher = new $hPkMt.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $kWTRq(ck);
    iv = $e4ed4c3b1c2c6a88$var$calcIv(this, iv, ck);
    this._prev = $e4ed4c3b1c2c6a88$require$Buffer.from(iv);
    this._cache = $e4ed4c3b1c2c6a88$require$Buffer.allocUnsafe(0);
    this._secCache = $e4ed4c3b1c2c6a88$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$lyUaN($e4ed4c3b1c2c6a88$var$StreamCipher, $7hBrF);
$e4ed4c3b1c2c6a88$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $e4ed4c3b1c2c6a88$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$e4ed4c3b1c2c6a88$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $4fAiV(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $e4ed4c3b1c2c6a88$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$e4ed4c3b1c2c6a88$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$e4ed4c3b1c2c6a88$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$e4ed4c3b1c2c6a88$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$e4ed4c3b1c2c6a88$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $e4ed4c3b1c2c6a88$var$StreamCipher;

});
parcelRegister("hPkMt", function(module, exports) {

$parcel$export(module.exports, "AES", () => $cfa751ba4428ce31$export$b80fbe1c3a2b92b5, (v) => $cfa751ba4428ce31$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $cfa751ba4428ce31$export$b80fbe1c3a2b92b5;

var $ijh2q = parcelRequire("ijh2q");
var $cfa751ba4428ce31$require$Buffer = $ijh2q.Buffer;
function $cfa751ba4428ce31$var$asUInt32Array(buf) {
    if (!$cfa751ba4428ce31$require$Buffer.isBuffer(buf)) buf = $cfa751ba4428ce31$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $cfa751ba4428ce31$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $cfa751ba4428ce31$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $cfa751ba4428ce31$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $cfa751ba4428ce31$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $cfa751ba4428ce31$var$AES(key) {
    this._key = $cfa751ba4428ce31$var$asUInt32Array(key);
    this._reset();
}
$cfa751ba4428ce31$var$AES.blockSize = 16;
$cfa751ba4428ce31$var$AES.keySize = 32;
$cfa751ba4428ce31$var$AES.prototype.blockSize = $cfa751ba4428ce31$var$AES.blockSize;
$cfa751ba4428ce31$var$AES.prototype.keySize = $cfa751ba4428ce31$var$AES.keySize;
$cfa751ba4428ce31$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $cfa751ba4428ce31$var$G.SBOX[t >>> 24] << 24 | $cfa751ba4428ce31$var$G.SBOX[t >>> 16 & 0xff] << 16 | $cfa751ba4428ce31$var$G.SBOX[t >>> 8 & 0xff] << 8 | $cfa751ba4428ce31$var$G.SBOX[t & 0xff];
            t ^= $cfa751ba4428ce31$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $cfa751ba4428ce31$var$G.SBOX[t >>> 24] << 24 | $cfa751ba4428ce31$var$G.SBOX[t >>> 16 & 0xff] << 16 | $cfa751ba4428ce31$var$G.SBOX[t >>> 8 & 0xff] << 8 | $cfa751ba4428ce31$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $cfa751ba4428ce31$var$G.INV_SUB_MIX[0][$cfa751ba4428ce31$var$G.SBOX[tt >>> 24]] ^ $cfa751ba4428ce31$var$G.INV_SUB_MIX[1][$cfa751ba4428ce31$var$G.SBOX[tt >>> 16 & 0xff]] ^ $cfa751ba4428ce31$var$G.INV_SUB_MIX[2][$cfa751ba4428ce31$var$G.SBOX[tt >>> 8 & 0xff]] ^ $cfa751ba4428ce31$var$G.INV_SUB_MIX[3][$cfa751ba4428ce31$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$cfa751ba4428ce31$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $cfa751ba4428ce31$var$asUInt32Array(M);
    return $cfa751ba4428ce31$var$cryptBlock(M, this._keySchedule, $cfa751ba4428ce31$var$G.SUB_MIX, $cfa751ba4428ce31$var$G.SBOX, this._nRounds);
};
$cfa751ba4428ce31$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $cfa751ba4428ce31$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$cfa751ba4428ce31$var$AES.prototype.decryptBlock = function(M) {
    M = $cfa751ba4428ce31$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $cfa751ba4428ce31$var$cryptBlock(M, this._invKeySchedule, $cfa751ba4428ce31$var$G.INV_SUB_MIX, $cfa751ba4428ce31$var$G.INV_SBOX, this._nRounds);
    var buf = $cfa751ba4428ce31$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$cfa751ba4428ce31$var$AES.prototype.scrub = function() {
    $cfa751ba4428ce31$var$scrubVec(this._keySchedule);
    $cfa751ba4428ce31$var$scrubVec(this._invKeySchedule);
    $cfa751ba4428ce31$var$scrubVec(this._key);
};
$cfa751ba4428ce31$export$b80fbe1c3a2b92b5 = $cfa751ba4428ce31$var$AES;

});

parcelRegister("kWTRq", function(module, exports) {

var $ijh2q = parcelRequire("ijh2q");
var $f4048e34861b21d9$require$Buffer = $ijh2q.Buffer;
var $f4048e34861b21d9$var$ZEROES = $f4048e34861b21d9$require$Buffer.alloc(16, 0);
function $f4048e34861b21d9$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $f4048e34861b21d9$var$fromArray(out) {
    var buf = $f4048e34861b21d9$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $f4048e34861b21d9$var$GHASH(key) {
    this.h = key;
    this.state = $f4048e34861b21d9$require$Buffer.alloc(16, 0);
    this.cache = $f4048e34861b21d9$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$f4048e34861b21d9$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$f4048e34861b21d9$var$GHASH.prototype._multiply = function() {
    var Vi = $f4048e34861b21d9$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $f4048e34861b21d9$var$fromArray(Zi);
};
$f4048e34861b21d9$var$GHASH.prototype.update = function(buf) {
    this.cache = $f4048e34861b21d9$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$f4048e34861b21d9$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($f4048e34861b21d9$require$Buffer.concat([
        this.cache,
        $f4048e34861b21d9$var$ZEROES
    ], 16));
    this.ghash($f4048e34861b21d9$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $f4048e34861b21d9$var$GHASH;

});


parcelRegister("96zpw", function(module, exports) {

var $hPkMt = parcelRequire("hPkMt");

var $ijh2q = parcelRequire("ijh2q");
var $6a10246aaec37d32$require$Buffer = $ijh2q.Buffer;

var $7hBrF = parcelRequire("7hBrF");

var $lyUaN = parcelRequire("lyUaN");
function $6a10246aaec37d32$var$StreamCipher(mode, key, iv, decrypt) {
    $7hBrF.call(this);
    this._cipher = new $hPkMt.AES(key);
    this._prev = $6a10246aaec37d32$require$Buffer.from(iv);
    this._cache = $6a10246aaec37d32$require$Buffer.allocUnsafe(0);
    this._secCache = $6a10246aaec37d32$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$lyUaN($6a10246aaec37d32$var$StreamCipher, $7hBrF);
$6a10246aaec37d32$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$6a10246aaec37d32$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $6a10246aaec37d32$var$StreamCipher;

});


parcelRegister("2o6Y4", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $1bd33a57d41157b4$export$12ada9414fbc594c, (v) => $1bd33a57d41157b4$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $1bd33a57d41157b4$export$36b6d6ef312eab39, (v) => $1bd33a57d41157b4$export$36b6d6ef312eab39 = v);
var $1bd33a57d41157b4$export$12ada9414fbc594c;
var $1bd33a57d41157b4$export$36b6d6ef312eab39;

var $jEzvF = parcelRequire("jEzvF");

var $ijh2q = parcelRequire("ijh2q");
var $1bd33a57d41157b4$require$Buffer = $ijh2q.Buffer;

var $2z1oX = parcelRequire("2z1oX");

var $96zpw = parcelRequire("96zpw");

var $7hBrF = parcelRequire("7hBrF");

var $hPkMt = parcelRequire("hPkMt");

var $d9sFZ = parcelRequire("d9sFZ");

var $lyUaN = parcelRequire("lyUaN");
function $1bd33a57d41157b4$var$Decipher(mode, key, iv) {
    $7hBrF.call(this);
    this._cache = new $1bd33a57d41157b4$var$Splitter();
    this._last = void 0;
    this._cipher = new $hPkMt.AES(key);
    this._prev = $1bd33a57d41157b4$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$lyUaN($1bd33a57d41157b4$var$Decipher, $7hBrF);
$1bd33a57d41157b4$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $1bd33a57d41157b4$require$Buffer.concat(out);
};
$1bd33a57d41157b4$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $1bd33a57d41157b4$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$1bd33a57d41157b4$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $1bd33a57d41157b4$var$Splitter() {
    this.cache = $1bd33a57d41157b4$require$Buffer.allocUnsafe(0);
}
$1bd33a57d41157b4$var$Splitter.prototype.add = function(data) {
    this.cache = $1bd33a57d41157b4$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$1bd33a57d41157b4$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$1bd33a57d41157b4$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $1bd33a57d41157b4$var$unpad(last) {
    var padded = last[15];
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $1bd33a57d41157b4$var$createDecipheriv(suite, password, iv) {
    var config = $2z1oX[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $1bd33a57d41157b4$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $1bd33a57d41157b4$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $96zpw(config.module, password, iv, true);
    else if (config.type === 'auth') return new $jEzvF(config.module, password, iv, true);
    return new $1bd33a57d41157b4$var$Decipher(config.module, password, iv);
}
function $1bd33a57d41157b4$var$createDecipher(suite, password) {
    var config = $2z1oX[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $d9sFZ(password, false, config.key, config.iv);
    return $1bd33a57d41157b4$var$createDecipheriv(suite, keys.key, keys.iv);
}
$1bd33a57d41157b4$export$12ada9414fbc594c = $1bd33a57d41157b4$var$createDecipher;
$1bd33a57d41157b4$export$36b6d6ef312eab39 = $1bd33a57d41157b4$var$createDecipheriv;

});


parcelRegister("A6QqV", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $06c8ac1f3fd38271$require$Buffer = $aul3P.Buffer;

var $7hBrF = parcelRequire("7hBrF");

var $dGxNe = parcelRequire("dGxNe");

var $lyUaN = parcelRequire("lyUaN");
var $06c8ac1f3fd38271$var$modes = {
    'des-ede3-cbc': $dGxNe.CBC.instantiate($dGxNe.EDE),
    'des-ede3': $dGxNe.EDE,
    'des-ede-cbc': $dGxNe.CBC.instantiate($dGxNe.EDE),
    'des-ede': $dGxNe.EDE,
    'des-cbc': $dGxNe.CBC.instantiate($dGxNe.DES),
    'des-ecb': $dGxNe.DES
};
$06c8ac1f3fd38271$var$modes.des = $06c8ac1f3fd38271$var$modes['des-cbc'];
$06c8ac1f3fd38271$var$modes.des3 = $06c8ac1f3fd38271$var$modes['des-ede3-cbc'];
module.exports = $06c8ac1f3fd38271$var$DES;
$lyUaN($06c8ac1f3fd38271$var$DES, $7hBrF);
function $06c8ac1f3fd38271$var$DES(opts) {
    $7hBrF.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $06c8ac1f3fd38271$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $06c8ac1f3fd38271$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$06c8ac1f3fd38271$var$DES.prototype._update = function(data) {
    return new $06c8ac1f3fd38271$require$Buffer(this._des.update(data));
};
$06c8ac1f3fd38271$var$DES.prototype._final = function() {
    return new $06c8ac1f3fd38271$require$Buffer(this._des.final());
};

});
parcelRegister("dGxNe", function(module, exports) {

$parcel$export(module.exports, "utils", () => $9f69693503109cbe$export$eab97d15b1788b8d, (v) => $9f69693503109cbe$export$eab97d15b1788b8d = v);
$parcel$export(module.exports, "Cipher", () => $9f69693503109cbe$export$26e5786e8ac8e530, (v) => $9f69693503109cbe$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "DES", () => $9f69693503109cbe$export$cc8859615686b300, (v) => $9f69693503109cbe$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $9f69693503109cbe$export$8ad3f227af08fcc5, (v) => $9f69693503109cbe$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $9f69693503109cbe$export$947646e34766044f, (v) => $9f69693503109cbe$export$947646e34766044f = v);
var $9f69693503109cbe$export$eab97d15b1788b8d;
var $9f69693503109cbe$export$26e5786e8ac8e530;
var $9f69693503109cbe$export$cc8859615686b300;
var $9f69693503109cbe$export$8ad3f227af08fcc5;
var $9f69693503109cbe$export$947646e34766044f;
'use strict';

$9f69693503109cbe$export$eab97d15b1788b8d = (parcelRequire("7GCGw"));

$9f69693503109cbe$export$26e5786e8ac8e530 = (parcelRequire("5sKz7"));

$9f69693503109cbe$export$cc8859615686b300 = (parcelRequire("dZrBr"));

$9f69693503109cbe$export$8ad3f227af08fcc5 = (parcelRequire("gNVcN"));

$9f69693503109cbe$export$947646e34766044f = (parcelRequire("4Xu4n"));

});
parcelRegister("7GCGw", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $598a76a19b3b2ec0$export$cfaef8ed399428b0, (v) => $598a76a19b3b2ec0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $598a76a19b3b2ec0$export$a80c7deaea7cbd80, (v) => $598a76a19b3b2ec0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $598a76a19b3b2ec0$export$ed7577ae6e1cd0ef, (v) => $598a76a19b3b2ec0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $598a76a19b3b2ec0$export$5dcbef3aa594f567, (v) => $598a76a19b3b2ec0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $598a76a19b3b2ec0$export$5bc8001ca71ed9c5, (v) => $598a76a19b3b2ec0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $598a76a19b3b2ec0$export$3e714e2c5d5d8cb2, (v) => $598a76a19b3b2ec0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $598a76a19b3b2ec0$export$94c3e544fd062b7f, (v) => $598a76a19b3b2ec0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $598a76a19b3b2ec0$export$9f77e0932fb78f72, (v) => $598a76a19b3b2ec0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $598a76a19b3b2ec0$export$d865ce2836f5927f, (v) => $598a76a19b3b2ec0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $598a76a19b3b2ec0$export$95e62ad65da8b7d2, (v) => $598a76a19b3b2ec0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $598a76a19b3b2ec0$export$209139ff098c441a, (v) => $598a76a19b3b2ec0$export$209139ff098c441a = v);
var $598a76a19b3b2ec0$export$cfaef8ed399428b0;
var $598a76a19b3b2ec0$export$a80c7deaea7cbd80;
var $598a76a19b3b2ec0$export$ed7577ae6e1cd0ef;
var $598a76a19b3b2ec0$export$5dcbef3aa594f567;
var $598a76a19b3b2ec0$export$5bc8001ca71ed9c5;
var $598a76a19b3b2ec0$export$3e714e2c5d5d8cb2;
var $598a76a19b3b2ec0$export$94c3e544fd062b7f;
var $598a76a19b3b2ec0$export$9f77e0932fb78f72;
var $598a76a19b3b2ec0$export$d865ce2836f5927f;
var $598a76a19b3b2ec0$export$95e62ad65da8b7d2;
var $598a76a19b3b2ec0$export$209139ff098c441a;
'use strict';
$598a76a19b3b2ec0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$598a76a19b3b2ec0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$598a76a19b3b2ec0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$598a76a19b3b2ec0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$598a76a19b3b2ec0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$598a76a19b3b2ec0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $598a76a19b3b2ec0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$598a76a19b3b2ec0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $598a76a19b3b2ec0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $598a76a19b3b2ec0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $598a76a19b3b2ec0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $598a76a19b3b2ec0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$598a76a19b3b2ec0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $598a76a19b3b2ec0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$598a76a19b3b2ec0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $598a76a19b3b2ec0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $598a76a19b3b2ec0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $598a76a19b3b2ec0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$598a76a19b3b2ec0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $598a76a19b3b2ec0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $598a76a19b3b2ec0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$598a76a19b3b2ec0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("5sKz7", function(module, exports) {
'use strict';

var $aOIMZ = parcelRequire("aOIMZ");
function $3fa3b03628a4362d$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
}
module.exports = $3fa3b03628a4362d$var$Cipher;
$3fa3b03628a4362d$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$3fa3b03628a4362d$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$3fa3b03628a4362d$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$3fa3b03628a4362d$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$3fa3b03628a4362d$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$3fa3b03628a4362d$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$3fa3b03628a4362d$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$3fa3b03628a4362d$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$3fa3b03628a4362d$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$3fa3b03628a4362d$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$3fa3b03628a4362d$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $aOIMZ.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("aOIMZ", function(module, exports) {
module.exports = $7e015117bb8d6cde$var$assert;
function $7e015117bb8d6cde$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$7e015117bb8d6cde$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("dZrBr", function(module, exports) {
'use strict';

var $aOIMZ = parcelRequire("aOIMZ");

var $lyUaN = parcelRequire("lyUaN");

var $dGxNe = parcelRequire("dGxNe");
var $a2f6623cd6d516cb$var$utils = $dGxNe.utils;
var $a2f6623cd6d516cb$var$Cipher = $dGxNe.Cipher;
function $a2f6623cd6d516cb$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $a2f6623cd6d516cb$var$DES(options) {
    $a2f6623cd6d516cb$var$Cipher.call(this, options);
    var state = new $a2f6623cd6d516cb$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$lyUaN($a2f6623cd6d516cb$var$DES, $a2f6623cd6d516cb$var$Cipher);
module.exports = $a2f6623cd6d516cb$var$DES;
$a2f6623cd6d516cb$var$DES.create = function create(options) {
    return new $a2f6623cd6d516cb$var$DES(options);
};
var $a2f6623cd6d516cb$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$a2f6623cd6d516cb$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $aOIMZ.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $a2f6623cd6d516cb$var$utils.readUInt32BE(key, 0);
    var kR = $a2f6623cd6d516cb$var$utils.readUInt32BE(key, 4);
    $a2f6623cd6d516cb$var$utils.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $a2f6623cd6d516cb$var$shiftTable[i >>> 1];
        kL = $a2f6623cd6d516cb$var$utils.r28shl(kL, shift);
        kR = $a2f6623cd6d516cb$var$utils.r28shl(kR, shift);
        $a2f6623cd6d516cb$var$utils.pc2(kL, kR, state.keys, i);
    }
};
$a2f6623cd6d516cb$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $a2f6623cd6d516cb$var$utils.readUInt32BE(inp, inOff);
    var r = $a2f6623cd6d516cb$var$utils.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $a2f6623cd6d516cb$var$utils.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $a2f6623cd6d516cb$var$utils.writeUInt32BE(out, l, outOff);
    $a2f6623cd6d516cb$var$utils.writeUInt32BE(out, r, outOff + 4);
};
$a2f6623cd6d516cb$var$DES.prototype._pad = function _pad(buffer, off) {
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$a2f6623cd6d516cb$var$DES.prototype._unpad = function _unpad(buffer) {
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$aOIMZ.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$a2f6623cd6d516cb$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $a2f6623cd6d516cb$var$utils.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $a2f6623cd6d516cb$var$utils.substitute(keyL, keyR);
        var f = $a2f6623cd6d516cb$var$utils.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $a2f6623cd6d516cb$var$utils.rip(r, l, out, off);
};
$a2f6623cd6d516cb$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $a2f6623cd6d516cb$var$utils.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $a2f6623cd6d516cb$var$utils.substitute(keyL, keyR);
        var f = $a2f6623cd6d516cb$var$utils.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $a2f6623cd6d516cb$var$utils.rip(l, r, out, off);
};

});

parcelRegister("gNVcN", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $c3bd98be17497432$export$f9bb8d20ccc7477a, (v) => $c3bd98be17497432$export$f9bb8d20ccc7477a = v);
var $c3bd98be17497432$export$f9bb8d20ccc7477a;
'use strict';

var $aOIMZ = parcelRequire("aOIMZ");

var $lyUaN = parcelRequire("lyUaN");
var $c3bd98be17497432$var$proto = {};
function $c3bd98be17497432$var$CBCState(iv) {
    $aOIMZ.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $c3bd98be17497432$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $lyUaN(CBC, Base);
    var keys = Object.keys($c3bd98be17497432$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $c3bd98be17497432$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$c3bd98be17497432$export$f9bb8d20ccc7477a = $c3bd98be17497432$var$instantiate;
$c3bd98be17497432$var$proto._cbcInit = function _cbcInit() {
    var state = new $c3bd98be17497432$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$c3bd98be17497432$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("4Xu4n", function(module, exports) {
'use strict';

var $aOIMZ = parcelRequire("aOIMZ");

var $lyUaN = parcelRequire("lyUaN");

var $dGxNe = parcelRequire("dGxNe");
var $39c3ff54fa87a964$var$Cipher = $dGxNe.Cipher;
var $39c3ff54fa87a964$var$DES = $dGxNe.DES;
function $39c3ff54fa87a964$var$EDEState(type, key) {
    $aOIMZ.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $39c3ff54fa87a964$var$DES.create({
            type: 'encrypt',
            key: k1
        }),
        $39c3ff54fa87a964$var$DES.create({
            type: 'decrypt',
            key: k2
        }),
        $39c3ff54fa87a964$var$DES.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $39c3ff54fa87a964$var$DES.create({
            type: 'decrypt',
            key: k3
        }),
        $39c3ff54fa87a964$var$DES.create({
            type: 'encrypt',
            key: k2
        }),
        $39c3ff54fa87a964$var$DES.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $39c3ff54fa87a964$var$EDE(options) {
    $39c3ff54fa87a964$var$Cipher.call(this, options);
    var state = new $39c3ff54fa87a964$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$lyUaN($39c3ff54fa87a964$var$EDE, $39c3ff54fa87a964$var$Cipher);
module.exports = $39c3ff54fa87a964$var$EDE;
$39c3ff54fa87a964$var$EDE.create = function create(options) {
    return new $39c3ff54fa87a964$var$EDE(options);
};
$39c3ff54fa87a964$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$39c3ff54fa87a964$var$EDE.prototype._pad = $39c3ff54fa87a964$var$DES.prototype._pad;
$39c3ff54fa87a964$var$EDE.prototype._unpad = $39c3ff54fa87a964$var$DES.prototype._unpad;

});



parcelRegister("9Xue6", function(module, exports) {

$parcel$export(module.exports, "des-ecb", () => $7401121727af84fc$export$116f8a5cee447347, (v) => $7401121727af84fc$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $7401121727af84fc$export$7483c4066bfb7ae9, (v) => $7401121727af84fc$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $7401121727af84fc$export$e7a565d2e588bb06, (v) => $7401121727af84fc$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $7401121727af84fc$export$aaa2f54a426f3eb8, (v) => $7401121727af84fc$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $7401121727af84fc$export$eba20568dde4ada, (v) => $7401121727af84fc$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $7401121727af84fc$export$d3b5e5996938f5ae, (v) => $7401121727af84fc$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $7401121727af84fc$export$57c08356130bc99b, (v) => $7401121727af84fc$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $7401121727af84fc$export$c7169791d5c1e65d, (v) => $7401121727af84fc$export$c7169791d5c1e65d = v);
var $7401121727af84fc$export$116f8a5cee447347;
var $7401121727af84fc$export$7483c4066bfb7ae9;
var $7401121727af84fc$export$e7a565d2e588bb06;
var $7401121727af84fc$export$aaa2f54a426f3eb8;
var $7401121727af84fc$export$eba20568dde4ada;
var $7401121727af84fc$export$d3b5e5996938f5ae;
var $7401121727af84fc$export$57c08356130bc99b;
var $7401121727af84fc$export$c7169791d5c1e65d;
$7401121727af84fc$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$7401121727af84fc$export$7483c4066bfb7ae9 = $7401121727af84fc$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$7401121727af84fc$export$aaa2f54a426f3eb8 = $7401121727af84fc$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$7401121727af84fc$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$7401121727af84fc$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$7401121727af84fc$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("fPWK2", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", () => $b8792f4d453e7272$export$971862a2fcb1bb40, (v) => $b8792f4d453e7272$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $b8792f4d453e7272$export$c6ff6a88acbeaf40, (v) => $b8792f4d453e7272$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $b8792f4d453e7272$export$fdc27893e98845cc, (v) => $b8792f4d453e7272$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $b8792f4d453e7272$export$6671fb9a1323bed, (v) => $b8792f4d453e7272$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $b8792f4d453e7272$export$d74daf141a551db, (v) => $b8792f4d453e7272$export$d74daf141a551db = v);
var $b8792f4d453e7272$export$971862a2fcb1bb40;
var $b8792f4d453e7272$export$c6ff6a88acbeaf40;
var $b8792f4d453e7272$export$fdc27893e98845cc;
var $b8792f4d453e7272$export$6671fb9a1323bed;
var $b8792f4d453e7272$export$d74daf141a551db;

var $aul3P = parcelRequire("aul3P");
var $b8792f4d453e7272$require$Buffer = $aul3P.Buffer;

var $5Imi1 = parcelRequire("5Imi1");

var $aBb26 = parcelRequire("aBb26");

var $4ybg5 = parcelRequire("4ybg5");
function $b8792f4d453e7272$var$getDiffieHellman(mod) {
    var prime = new $b8792f4d453e7272$require$Buffer($aBb26[mod].prime, 'hex');
    var gen = new $b8792f4d453e7272$require$Buffer($aBb26[mod].gen, 'hex');
    return new $4ybg5(prime, gen);
}
var $b8792f4d453e7272$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $b8792f4d453e7272$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($b8792f4d453e7272$require$Buffer.isBuffer(enc) || $b8792f4d453e7272$var$ENCODINGS[enc] === undefined) return $b8792f4d453e7272$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $b8792f4d453e7272$require$Buffer([
        2
    ]);
    if (!$b8792f4d453e7272$require$Buffer.isBuffer(generator)) generator = new $b8792f4d453e7272$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $4ybg5($5Imi1(prime, generator), generator, true);
    if (!$b8792f4d453e7272$require$Buffer.isBuffer(prime)) prime = new $b8792f4d453e7272$require$Buffer(prime, enc);
    return new $4ybg5(prime, generator, true);
}
$b8792f4d453e7272$export$971862a2fcb1bb40 = $b8792f4d453e7272$export$c6ff6a88acbeaf40 = $b8792f4d453e7272$export$fdc27893e98845cc = $b8792f4d453e7272$var$getDiffieHellman;
$b8792f4d453e7272$export$6671fb9a1323bed = $b8792f4d453e7272$export$d74daf141a551db = $b8792f4d453e7272$var$createDiffieHellman;

});
parcelRegister("5Imi1", function(module, exports) {

var $ugwNY = parcelRequire("ugwNY");
module.exports = $42925a0e7985bf7e$var$findPrime;
$42925a0e7985bf7e$var$findPrime.simpleSieve = $42925a0e7985bf7e$var$simpleSieve;
$42925a0e7985bf7e$var$findPrime.fermatTest = $42925a0e7985bf7e$var$fermatTest;

var $61SlE = parcelRequire("61SlE");
var $42925a0e7985bf7e$var$TWENTYFOUR = new $61SlE(24);

var $4qHnY = parcelRequire("4qHnY");
var $42925a0e7985bf7e$var$millerRabin = new $4qHnY();
var $42925a0e7985bf7e$var$ONE = new $61SlE(1);
var $42925a0e7985bf7e$var$TWO = new $61SlE(2);
var $42925a0e7985bf7e$var$FIVE = new $61SlE(5);
var $42925a0e7985bf7e$var$SIXTEEN = new $61SlE(16);
var $42925a0e7985bf7e$var$EIGHT = new $61SlE(8);
var $42925a0e7985bf7e$var$TEN = new $61SlE(10);
var $42925a0e7985bf7e$var$THREE = new $61SlE(3);
var $42925a0e7985bf7e$var$SEVEN = new $61SlE(7);
var $42925a0e7985bf7e$var$ELEVEN = new $61SlE(11);
var $42925a0e7985bf7e$var$FOUR = new $61SlE(4);
var $42925a0e7985bf7e$var$TWELVE = new $61SlE(12);
var $42925a0e7985bf7e$var$primes = null;
function $42925a0e7985bf7e$var$_getPrimes() {
    if ($42925a0e7985bf7e$var$primes !== null) return $42925a0e7985bf7e$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $42925a0e7985bf7e$var$primes = res;
    return res;
}
function $42925a0e7985bf7e$var$simpleSieve(p) {
    var primes = $42925a0e7985bf7e$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $42925a0e7985bf7e$var$fermatTest(p) {
    var red = $61SlE.mont(p);
    return $42925a0e7985bf7e$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $42925a0e7985bf7e$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $61SlE([
            0x8c,
            0x7b
        ]);
        else return new $61SlE([
            0x8c,
            0x27
        ]);
    }
    gen = new $61SlE(gen);
    var num, n2;
    while(true){
        num = new $61SlE($ugwNY(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($42925a0e7985bf7e$var$ONE);
        if (!num.testn(1)) num.iadd($42925a0e7985bf7e$var$TWO);
        if (!gen.cmp($42925a0e7985bf7e$var$TWO)) while(num.mod($42925a0e7985bf7e$var$TWENTYFOUR).cmp($42925a0e7985bf7e$var$ELEVEN))num.iadd($42925a0e7985bf7e$var$FOUR);
        else if (!gen.cmp($42925a0e7985bf7e$var$FIVE)) while(num.mod($42925a0e7985bf7e$var$TEN).cmp($42925a0e7985bf7e$var$THREE))num.iadd($42925a0e7985bf7e$var$FOUR);
        n2 = num.shrn(1);
        if ($42925a0e7985bf7e$var$simpleSieve(n2) && $42925a0e7985bf7e$var$simpleSieve(num) && $42925a0e7985bf7e$var$fermatTest(n2) && $42925a0e7985bf7e$var$fermatTest(num) && $42925a0e7985bf7e$var$millerRabin.test(n2) && $42925a0e7985bf7e$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("61SlE", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        Buffer = (parcelRequire("jFleb")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') start++;
        if (base === 16) this._parseHex(number, start);
        else this._parseBase(number, base, start);
        if (number[0] === '-') this.negative = 1;
        this.strip();
        if (endian !== 'le') return;
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex(str, start, end) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r <<= 4;
            // 'a' - 'f'
            if (c >= 49 && c <= 54) r |= c - 49 + 0xa;
            else if (c >= 17 && c <= 22) r |= c - 17 + 0xa;
            else r |= c & 0xf;
        }
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        // Scan 24-bit chunks and add them to the number
        var off = 0;
        for(i = number.length - 6, j = 0; i >= start; i -= 6){
            w = parseHex(number, i, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        if (i + 6 !== start) {
            w = parseHex(number, start, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else r.strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("4qHnY", function(module, exports) {

var $61SlE = parcelRequire("61SlE");

var $7EB5r = parcelRequire("7EB5r");
function $339b3e9b9b7e3050$var$MillerRabin(rand) {
    this.rand = rand || new $7EB5r.Rand();
}
module.exports = $339b3e9b9b7e3050$var$MillerRabin;
$339b3e9b9b7e3050$var$MillerRabin.create = function create(rand) {
    return new $339b3e9b9b7e3050$var$MillerRabin(rand);
};
$339b3e9b9b7e3050$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $61SlE(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$339b3e9b9b7e3050$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$339b3e9b9b7e3050$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $61SlE.mont(n);
    var rone = new $61SlE(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $61SlE(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$339b3e9b9b7e3050$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $61SlE.mont(n);
    var rone = new $61SlE(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $61SlE(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("7EB5r", function(module, exports) {
var $5929097e933a50fa$var$r;
module.exports = function rand(len) {
    if (!$5929097e933a50fa$var$r) $5929097e933a50fa$var$r = new $5929097e933a50fa$var$Rand(null);
    return $5929097e933a50fa$var$r.generate(len);
};
function $5929097e933a50fa$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5929097e933a50fa$var$Rand;
$5929097e933a50fa$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5929097e933a50fa$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5929097e933a50fa$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5929097e933a50fa$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $5929097e933a50fa$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5929097e933a50fa$var$crypto = (parcelRequire("jFleb"));
    if (typeof $5929097e933a50fa$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $5929097e933a50fa$var$Rand.prototype._rand = function _rand(n) {
        return $5929097e933a50fa$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("aBb26", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("4ybg5", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $3503121994d90ae3$require$Buffer = $aul3P.Buffer;

var $61SlE = parcelRequire("61SlE");

var $4qHnY = parcelRequire("4qHnY");
var $3503121994d90ae3$var$millerRabin = new $4qHnY();
var $3503121994d90ae3$var$TWENTYFOUR = new $61SlE(24);
var $3503121994d90ae3$var$ELEVEN = new $61SlE(11);
var $3503121994d90ae3$var$TEN = new $61SlE(10);
var $3503121994d90ae3$var$THREE = new $61SlE(3);
var $3503121994d90ae3$var$SEVEN = new $61SlE(7);

var $5Imi1 = parcelRequire("5Imi1");

var $ugwNY = parcelRequire("ugwNY");
module.exports = $3503121994d90ae3$var$DH;
function $3503121994d90ae3$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$3503121994d90ae3$require$Buffer.isBuffer(pub)) pub = new $3503121994d90ae3$require$Buffer(pub, enc);
    this._pub = new $61SlE(pub);
    return this;
}
function $3503121994d90ae3$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$3503121994d90ae3$require$Buffer.isBuffer(priv)) priv = new $3503121994d90ae3$require$Buffer(priv, enc);
    this._priv = new $61SlE(priv);
    return this;
}
var $3503121994d90ae3$var$primeCache = {};
function $3503121994d90ae3$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $3503121994d90ae3$var$primeCache) return $3503121994d90ae3$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$5Imi1.simpleSieve || !$5Imi1.fermatTest(prime) || !$3503121994d90ae3$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $3503121994d90ae3$var$primeCache[hex] = error;
        return error;
    }
    if (!$3503121994d90ae3$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($3503121994d90ae3$var$TWENTYFOUR).cmp($3503121994d90ae3$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($3503121994d90ae3$var$TEN);
            if (rem.cmp($3503121994d90ae3$var$THREE) && rem.cmp($3503121994d90ae3$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $3503121994d90ae3$var$primeCache[hex] = error;
    return error;
}
function $3503121994d90ae3$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $61SlE(prime);
    this._prime = $61SlE.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $3503121994d90ae3$var$setPublicKey;
        this.setPrivateKey = $3503121994d90ae3$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($3503121994d90ae3$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $3503121994d90ae3$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$3503121994d90ae3$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $61SlE($ugwNY(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$3503121994d90ae3$var$DH.prototype.computeSecret = function(other) {
    other = new $61SlE(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $3503121994d90ae3$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $3503121994d90ae3$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $3503121994d90ae3$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$3503121994d90ae3$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $3503121994d90ae3$var$formatReturnValue(this._pub, enc);
};
$3503121994d90ae3$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $3503121994d90ae3$var$formatReturnValue(this._priv, enc);
};
$3503121994d90ae3$var$DH.prototype.getPrime = function(enc) {
    return $3503121994d90ae3$var$formatReturnValue(this.__prime, enc);
};
$3503121994d90ae3$var$DH.prototype.getGenerator = function(enc) {
    return $3503121994d90ae3$var$formatReturnValue(this._gen, enc);
};
$3503121994d90ae3$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$3503121994d90ae3$require$Buffer.isBuffer(gen)) gen = new $3503121994d90ae3$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $61SlE(gen);
    return this;
};
function $3503121994d90ae3$var$formatReturnValue(bn, enc) {
    var buf = new $3503121994d90ae3$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("cQURD", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $95b6735c8554685b$require$Buffer = $aul3P.Buffer;

var $cnL2y = parcelRequire("cnL2y");

var $anz8L = parcelRequire("anz8L");

var $lyUaN = parcelRequire("lyUaN");

var $9WtmX = parcelRequire("9WtmX");

var $bdxL8 = parcelRequire("bdxL8");

var $5x0OM = parcelRequire("5x0OM");
Object.keys($5x0OM).forEach(function(key) {
    $5x0OM[key].id = new $95b6735c8554685b$require$Buffer($5x0OM[key].id, 'hex');
    $5x0OM[key.toLowerCase()] = $5x0OM[key];
});
function $95b6735c8554685b$var$Sign(algorithm) {
    $anz8L.Writable.call(this);
    var data = $5x0OM[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $cnL2y(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$lyUaN($95b6735c8554685b$var$Sign, $anz8L.Writable);
$95b6735c8554685b$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$95b6735c8554685b$var$Sign.prototype.update = function update(data, enc) {
    if (typeof data === 'string') data = new $95b6735c8554685b$require$Buffer(data, enc);
    this._hash.update(data);
    return this;
};
$95b6735c8554685b$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $9WtmX(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $95b6735c8554685b$var$Verify(algorithm) {
    $anz8L.Writable.call(this);
    var data = $5x0OM[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $cnL2y(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$lyUaN($95b6735c8554685b$var$Verify, $anz8L.Writable);
$95b6735c8554685b$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$95b6735c8554685b$var$Verify.prototype.update = function update(data, enc) {
    if (typeof data === 'string') data = new $95b6735c8554685b$require$Buffer(data, enc);
    this._hash.update(data);
    return this;
};
$95b6735c8554685b$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    if (typeof sig === 'string') sig = new $95b6735c8554685b$require$Buffer(sig, enc);
    this.end();
    var hash = this._hash.digest();
    return $bdxL8(sig, hash, key, this._signType, this._tag);
};
function $95b6735c8554685b$var$createSign(algorithm) {
    return new $95b6735c8554685b$var$Sign(algorithm);
}
function $95b6735c8554685b$var$createVerify(algorithm) {
    return new $95b6735c8554685b$var$Verify(algorithm);
}
module.exports = {
    Sign: $95b6735c8554685b$var$createSign,
    Verify: $95b6735c8554685b$var$createVerify,
    createSign: $95b6735c8554685b$var$createSign,
    createVerify: $95b6735c8554685b$var$createVerify
};

});
parcelRegister("9WtmX", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $aul3P = parcelRequire("aul3P");
var $73d04ff15cc0067d$require$Buffer = $aul3P.Buffer;

var $jPoqK = parcelRequire("jPoqK");

var $kFMzy = parcelRequire("kFMzy");

var $6nTxf = parcelRequire("6nTxf");
var $73d04ff15cc0067d$require$EC = $6nTxf.ec;

var $61SlE = parcelRequire("61SlE");

var $lXsfV = parcelRequire("lXsfV");

var $fyXn0 = parcelRequire("fyXn0");
function $73d04ff15cc0067d$var$sign(hash, key, hashType, signType, tag) {
    var priv = $lXsfV(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $73d04ff15cc0067d$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $73d04ff15cc0067d$var$dsaSign(hash, priv, hashType);
    } else {
        if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    }
    hash = $73d04ff15cc0067d$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $kFMzy(pad, priv);
    return out;
}
function $73d04ff15cc0067d$var$ecSign(hash, priv) {
    var curveId = $fyXn0[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $73d04ff15cc0067d$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return new $73d04ff15cc0067d$require$Buffer(out.toDER());
}
function $73d04ff15cc0067d$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $61SlE(0);
    var k;
    var H = $73d04ff15cc0067d$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $73d04ff15cc0067d$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $73d04ff15cc0067d$var$makeKey(q, kv, algo);
        r = $73d04ff15cc0067d$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $61SlE(0);
        }
    }
    return $73d04ff15cc0067d$var$toDER(r, s);
}
function $73d04ff15cc0067d$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return new $73d04ff15cc0067d$require$Buffer(res);
}
function $73d04ff15cc0067d$var$getKey(x, q, hash, algo) {
    x = new $73d04ff15cc0067d$require$Buffer(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = new $73d04ff15cc0067d$require$Buffer(q.byteLength() - x.length);
        zeros.fill(0);
        x = $73d04ff15cc0067d$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $73d04ff15cc0067d$var$bits2octets(hash, q);
    var v = new $73d04ff15cc0067d$require$Buffer(hlen);
    v.fill(1);
    var k = new $73d04ff15cc0067d$require$Buffer(hlen);
    k.fill(0);
    k = $jPoqK(algo, k).update(v).update(new $73d04ff15cc0067d$require$Buffer([
        0
    ])).update(x).update(hbits).digest();
    v = $jPoqK(algo, k).update(v).digest();
    k = $jPoqK(algo, k).update(v).update(new $73d04ff15cc0067d$require$Buffer([
        1
    ])).update(x).update(hbits).digest();
    v = $jPoqK(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $73d04ff15cc0067d$var$bits2int(obits, q) {
    var bits = new $61SlE(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $73d04ff15cc0067d$var$bits2octets(bits, q) {
    bits = $73d04ff15cc0067d$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = new $73d04ff15cc0067d$require$Buffer(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = new $73d04ff15cc0067d$require$Buffer(q.byteLength() - out.length);
        zeros.fill(0);
        out = $73d04ff15cc0067d$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $73d04ff15cc0067d$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = new $73d04ff15cc0067d$require$Buffer(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $jPoqK(algo, kv.k).update(kv.v).digest();
            t = $73d04ff15cc0067d$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $73d04ff15cc0067d$var$bits2int(t, q);
        kv.k = $jPoqK(algo, kv.k).update(kv.v).update(new $73d04ff15cc0067d$require$Buffer([
            0
        ])).digest();
        kv.v = $jPoqK(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $73d04ff15cc0067d$var$makeR(g, k, p, q) {
    return g.toRed($61SlE.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $73d04ff15cc0067d$var$sign;
module.exports.getKey = $73d04ff15cc0067d$var$getKey;
module.exports.makeKey = $73d04ff15cc0067d$var$makeKey;

});
parcelRegister("kFMzy", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $f0cd5073c174da16$require$Buffer = $aul3P.Buffer;

var $61SlE = parcelRequire("61SlE");

var $ugwNY = parcelRequire("ugwNY");
module.exports = $f0cd5073c174da16$var$crt;
function $f0cd5073c174da16$var$blind(priv) {
    var r = $f0cd5073c174da16$var$getr(priv);
    var blinder = r.toRed($61SlE.mont(priv.modulus)).redPow(new $61SlE(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $f0cd5073c174da16$var$crt(msg, priv) {
    var blinds = $f0cd5073c174da16$var$blind(priv);
    var len = priv.modulus.byteLength();
    var mod = $61SlE.mont(priv.modulus);
    var blinded = new $61SlE(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($61SlE.mont(priv.prime1));
    var c2 = blinded.toRed($61SlE.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1);
    var m2 = c2.redPow(priv.exponent2);
    m1 = m1.fromRed();
    m2 = m2.fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p);
    h.imul(q);
    m2.iadd(h);
    return new $f0cd5073c174da16$require$Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
$f0cd5073c174da16$var$crt.getr = $f0cd5073c174da16$var$getr;
function $f0cd5073c174da16$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r = new $61SlE($ugwNY(len));
    while(r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2))r = new $61SlE($ugwNY(len));
    return r;
}

});

parcelRegister("6nTxf", function(module, exports) {
'use strict';
var $4a5ff836d3f5a0fb$var$elliptic = module.exports;

$4a5ff836d3f5a0fb$var$elliptic.version = (parcelRequire("aeDj6")).version;

$4a5ff836d3f5a0fb$var$elliptic.utils = (parcelRequire("8qPu3"));

$4a5ff836d3f5a0fb$var$elliptic.rand = (parcelRequire("7EB5r"));

$4a5ff836d3f5a0fb$var$elliptic.curve = (parcelRequire("g9z1u"));

$4a5ff836d3f5a0fb$var$elliptic.curves = (parcelRequire("8XT4W"));

// Protocols
$4a5ff836d3f5a0fb$var$elliptic.ec = (parcelRequire("h6mem"));

$4a5ff836d3f5a0fb$var$elliptic.eddsa = (parcelRequire("j0pZO"));

});
parcelRegister("aeDj6", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.4.0\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"jscs\":\"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js\",\"jshint\":\"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js\",\"lint\":\"npm run jscs && npm run jshint\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^1.4.3\",\"coveralls\":\"^2.11.3\",\"grunt\":\"^0.4.5\",\"grunt-browserify\":\"^5.0.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-connect\":\"^1.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^1.0.1\",\"grunt-mocha-istanbul\":\"^3.0.1\",\"grunt-saucelabs\":\"^8.6.2\",\"istanbul\":\"^0.4.2\",\"jscs\":\"^2.9.0\",\"jshint\":\"^2.6.0\",\"mocha\":\"^2.1.0\"},\"dependencies\":{\"bn.js\":\"^4.4.0\",\"brorand\":\"^1.0.1\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.0\",\"inherits\":\"^2.0.1\",\"minimalistic-assert\":\"^1.0.0\",\"minimalistic-crypto-utils\":\"^1.0.0\"}}");

});

parcelRegister("8qPu3", function(module, exports) {
'use strict';
var $6238b007fc990f16$var$utils = module.exports;

var $61SlE = parcelRequire("61SlE");

var $aOIMZ = parcelRequire("aOIMZ");

var $9a0Ug = parcelRequire("9a0Ug");
$6238b007fc990f16$var$utils.assert = $aOIMZ;
$6238b007fc990f16$var$utils.toArray = $9a0Ug.toArray;
$6238b007fc990f16$var$utils.zero2 = $9a0Ug.zero2;
$6238b007fc990f16$var$utils.toHex = $9a0Ug.toHex;
$6238b007fc990f16$var$utils.encode = $9a0Ug.encode;
// Represent num in a w-NAF form
function $6238b007fc990f16$var$getNAF(num, w) {
    var naf = [];
    var ws = 1 << w + 1;
    var k = num.clone();
    while(k.cmpn(1) >= 0){
        var z;
        if (k.isOdd()) {
            var mod = k.andln(ws - 1);
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf.push(z);
        // Optimization, shift by word if possible
        var shift = k.cmpn(0) !== 0 && k.andln(ws - 1) === 0 ? w + 1 : 1;
        for(var i = 1; i < shift; i++)naf.push(0);
        k.iushrn(shift);
    }
    return naf;
}
$6238b007fc990f16$var$utils.getNAF = $6238b007fc990f16$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $6238b007fc990f16$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            var m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            var m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$6238b007fc990f16$var$utils.getJSF = $6238b007fc990f16$var$getJSF;
function $6238b007fc990f16$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$6238b007fc990f16$var$utils.cachedProperty = $6238b007fc990f16$var$cachedProperty;
function $6238b007fc990f16$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $6238b007fc990f16$var$utils.toArray(bytes, 'hex') : bytes;
}
$6238b007fc990f16$var$utils.parseBytes = $6238b007fc990f16$var$parseBytes;
function $6238b007fc990f16$var$intFromLE(bytes) {
    return new $61SlE(bytes, 'hex', 'le');
}
$6238b007fc990f16$var$utils.intFromLE = $6238b007fc990f16$var$intFromLE;

});
parcelRegister("9a0Ug", function(module, exports) {
'use strict';
var $6ab5c03eb880a4ce$var$utils = module.exports;
function $6ab5c03eb880a4ce$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$6ab5c03eb880a4ce$var$utils.toArray = $6ab5c03eb880a4ce$var$toArray;
function $6ab5c03eb880a4ce$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$6ab5c03eb880a4ce$var$utils.zero2 = $6ab5c03eb880a4ce$var$zero2;
function $6ab5c03eb880a4ce$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $6ab5c03eb880a4ce$var$zero2(msg[i].toString(16));
    return res;
}
$6ab5c03eb880a4ce$var$utils.toHex = $6ab5c03eb880a4ce$var$toHex;
$6ab5c03eb880a4ce$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $6ab5c03eb880a4ce$var$toHex(arr);
    else return arr;
};

});


parcelRegister("g9z1u", function(module, exports) {
'use strict';
var $bc28a777bbaba7c9$var$curve = module.exports;

$bc28a777bbaba7c9$var$curve.base = (parcelRequire("7FXqf"));

$bc28a777bbaba7c9$var$curve.short = (parcelRequire("o1Os9"));

$bc28a777bbaba7c9$var$curve.mont = (parcelRequire("hap7r"));

$bc28a777bbaba7c9$var$curve.edwards = (parcelRequire("3Oe4N"));

});
parcelRegister("7FXqf", function(module, exports) {
'use strict';

var $61SlE = parcelRequire("61SlE");

var $6nTxf = parcelRequire("6nTxf");
var $596a74c8a0293328$var$utils = $6nTxf.utils;
var $596a74c8a0293328$var$getNAF = $596a74c8a0293328$var$utils.getNAF;
var $596a74c8a0293328$var$getJSF = $596a74c8a0293328$var$utils.getJSF;
var $596a74c8a0293328$var$assert = $596a74c8a0293328$var$utils.assert;
function $596a74c8a0293328$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $61SlE(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $61SlE.red(conf.prime) : $61SlE.mont(this.p);
    // Useful for many curves
    this.zero = new $61SlE(0).toRed(this.red);
    this.one = new $61SlE(1).toRed(this.red);
    this.two = new $61SlE(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $61SlE(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $596a74c8a0293328$var$BaseCurve;
$596a74c8a0293328$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$596a74c8a0293328$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$596a74c8a0293328$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $596a74c8a0293328$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $596a74c8a0293328$var$getNAF(k, 1);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    for(var j = 0; j < naf.length; j += doubles.step){
        var nafW = 0;
        for(var k = j + doubles.step - 1; k >= j; k--)nafW = (nafW << 1) + naf[k];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(var j = 0; j < repr.length; j++){
            var nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$596a74c8a0293328$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $596a74c8a0293328$var$getNAF(k, w);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var k = 0; i >= 0 && naf[i] === 0; i--)k++;
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        var z = naf[i];
        $596a74c8a0293328$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$596a74c8a0293328$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    for(var i = 0; i < len; i++){
        var p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(var i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $596a74c8a0293328$var$getNAF(coeffs[a], wndWidth[a]);
            naf[b] = $596a74c8a0293328$var$getNAF(coeffs[b], wndWidth[b]);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3 /* 1 1 */ 
        ];
        var jsf = $596a74c8a0293328$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(var j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(var i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(var j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(var j = 0; j < len; j++){
            var z = tmp[j];
            var p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(var i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $596a74c8a0293328$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$596a74c8a0293328$var$BaseCurve.BasePoint = $596a74c8a0293328$var$BasePoint;
$596a74c8a0293328$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$596a74c8a0293328$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$596a74c8a0293328$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $596a74c8a0293328$var$utils.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $596a74c8a0293328$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $596a74c8a0293328$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$596a74c8a0293328$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$596a74c8a0293328$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$596a74c8a0293328$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $596a74c8a0293328$var$utils.encode(this._encode(compact), enc);
};
$596a74c8a0293328$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$596a74c8a0293328$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$596a74c8a0293328$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$596a74c8a0293328$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$596a74c8a0293328$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$596a74c8a0293328$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("o1Os9", function(module, exports) {
'use strict';

var $g9z1u = parcelRequire("g9z1u");

var $6nTxf = parcelRequire("6nTxf");

var $61SlE = parcelRequire("61SlE");

var $lyUaN = parcelRequire("lyUaN");
var $0483a5fb6d44f11e$var$Base = $g9z1u.base;
var $0483a5fb6d44f11e$var$assert = $6nTxf.utils.assert;
function $0483a5fb6d44f11e$var$ShortCurve(conf) {
    $0483a5fb6d44f11e$var$Base.call(this, 'short', conf);
    this.a = new $61SlE(conf.a, 16).toRed(this.red);
    this.b = new $61SlE(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$lyUaN($0483a5fb6d44f11e$var$ShortCurve, $0483a5fb6d44f11e$var$Base);
module.exports = $0483a5fb6d44f11e$var$ShortCurve;
$0483a5fb6d44f11e$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $61SlE(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $61SlE(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $0483a5fb6d44f11e$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $61SlE(vec.a, 16),
            b: new $61SlE(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$0483a5fb6d44f11e$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $61SlE.mont(num);
    var tinv = new $61SlE(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $61SlE(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$0483a5fb6d44f11e$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $61SlE(1);
    var y1 = new $61SlE(0);
    var x2 = new $61SlE(0);
    var y2 = new $61SlE(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$0483a5fb6d44f11e$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$0483a5fb6d44f11e$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $61SlE(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$0483a5fb6d44f11e$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$0483a5fb6d44f11e$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $0483a5fb6d44f11e$var$Point(curve, x, y, isRed) {
    $0483a5fb6d44f11e$var$Base.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $61SlE(x, 16);
        this.y = new $61SlE(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$lyUaN($0483a5fb6d44f11e$var$Point, $0483a5fb6d44f11e$var$Base.BasePoint);
$0483a5fb6d44f11e$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $0483a5fb6d44f11e$var$Point(this, x, y, isRed);
};
$0483a5fb6d44f11e$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $0483a5fb6d44f11e$var$Point.fromJSON(this, obj, red);
};
$0483a5fb6d44f11e$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$0483a5fb6d44f11e$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$0483a5fb6d44f11e$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$0483a5fb6d44f11e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$0483a5fb6d44f11e$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$0483a5fb6d44f11e$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$0483a5fb6d44f11e$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$0483a5fb6d44f11e$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$0483a5fb6d44f11e$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$0483a5fb6d44f11e$var$Point.prototype.mul = function mul(k) {
    k = new $61SlE(k, 16);
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$0483a5fb6d44f11e$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$0483a5fb6d44f11e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$0483a5fb6d44f11e$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$0483a5fb6d44f11e$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$0483a5fb6d44f11e$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $0483a5fb6d44f11e$var$JPoint(curve, x, y, z) {
    $0483a5fb6d44f11e$var$Base.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $61SlE(0);
    } else {
        this.x = new $61SlE(x, 16);
        this.y = new $61SlE(y, 16);
        this.z = new $61SlE(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$lyUaN($0483a5fb6d44f11e$var$JPoint, $0483a5fb6d44f11e$var$Base.BasePoint);
$0483a5fb6d44f11e$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $0483a5fb6d44f11e$var$JPoint(this, x, y, z);
};
$0483a5fb6d44f11e$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$0483a5fb6d44f11e$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$0483a5fb6d44f11e$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(var i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(var i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$0483a5fb6d44f11e$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$0483a5fb6d44f11e$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $61SlE(k, kbase);
    return this.curve._wnafMul(this, k);
};
$0483a5fb6d44f11e$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$0483a5fb6d44f11e$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
    return false;
};
$0483a5fb6d44f11e$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$0483a5fb6d44f11e$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("hap7r", function(module, exports) {
'use strict';

var $g9z1u = parcelRequire("g9z1u");

var $61SlE = parcelRequire("61SlE");

var $lyUaN = parcelRequire("lyUaN");
var $c7f6daee520e45ff$var$Base = $g9z1u.base;

var $6nTxf = parcelRequire("6nTxf");
var $c7f6daee520e45ff$var$utils = $6nTxf.utils;
function $c7f6daee520e45ff$var$MontCurve(conf) {
    $c7f6daee520e45ff$var$Base.call(this, 'mont', conf);
    this.a = new $61SlE(conf.a, 16).toRed(this.red);
    this.b = new $61SlE(conf.b, 16).toRed(this.red);
    this.i4 = new $61SlE(4).toRed(this.red).redInvm();
    this.two = new $61SlE(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$lyUaN($c7f6daee520e45ff$var$MontCurve, $c7f6daee520e45ff$var$Base);
module.exports = $c7f6daee520e45ff$var$MontCurve;
$c7f6daee520e45ff$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $c7f6daee520e45ff$var$Point(curve, x, z) {
    $c7f6daee520e45ff$var$Base.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $61SlE(x, 16);
        this.z = new $61SlE(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$lyUaN($c7f6daee520e45ff$var$Point, $c7f6daee520e45ff$var$Base.BasePoint);
$c7f6daee520e45ff$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($c7f6daee520e45ff$var$utils.toArray(bytes, enc), 1);
};
$c7f6daee520e45ff$var$MontCurve.prototype.point = function point(x, z) {
    return new $c7f6daee520e45ff$var$Point(this, x, z);
};
$c7f6daee520e45ff$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $c7f6daee520e45ff$var$Point.fromJSON(this, obj);
};
$c7f6daee520e45ff$var$Point.prototype.precompute = function precompute() {
// No-op
};
$c7f6daee520e45ff$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$c7f6daee520e45ff$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $c7f6daee520e45ff$var$Point(curve, obj[0], obj[1] || curve.one);
};
$c7f6daee520e45ff$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$c7f6daee520e45ff$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$c7f6daee520e45ff$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$c7f6daee520e45ff$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$c7f6daee520e45ff$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$c7f6daee520e45ff$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$c7f6daee520e45ff$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$c7f6daee520e45ff$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$c7f6daee520e45ff$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$c7f6daee520e45ff$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$c7f6daee520e45ff$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("3Oe4N", function(module, exports) {
'use strict';

var $g9z1u = parcelRequire("g9z1u");

var $6nTxf = parcelRequire("6nTxf");

var $61SlE = parcelRequire("61SlE");

var $lyUaN = parcelRequire("lyUaN");
var $2c60f5dbd111f643$var$Base = $g9z1u.base;
var $2c60f5dbd111f643$var$assert = $6nTxf.utils.assert;
function $2c60f5dbd111f643$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $2c60f5dbd111f643$var$Base.call(this, 'edwards', conf);
    this.a = new $61SlE(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $61SlE(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $61SlE(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $2c60f5dbd111f643$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$lyUaN($2c60f5dbd111f643$var$EdwardsCurve, $2c60f5dbd111f643$var$Base);
module.exports = $2c60f5dbd111f643$var$EdwardsCurve;
$2c60f5dbd111f643$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$2c60f5dbd111f643$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$2c60f5dbd111f643$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$2c60f5dbd111f643$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $61SlE(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$2c60f5dbd111f643$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $61SlE(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - 1) / (d y^2 + 1)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.one);
    var rhs = y2.redMul(this.d).redAdd(this.one);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$2c60f5dbd111f643$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $2c60f5dbd111f643$var$Point(curve, x, y, z, t) {
    $2c60f5dbd111f643$var$Base.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $61SlE(x, 16);
        this.y = new $61SlE(y, 16);
        this.z = z ? new $61SlE(z, 16) : this.curve.one;
        this.t = t && new $61SlE(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$lyUaN($2c60f5dbd111f643$var$Point, $2c60f5dbd111f643$var$Base.BasePoint);
$2c60f5dbd111f643$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $2c60f5dbd111f643$var$Point.fromJSON(this, obj);
};
$2c60f5dbd111f643$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $2c60f5dbd111f643$var$Point(this, x, y, z, t);
};
$2c60f5dbd111f643$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $2c60f5dbd111f643$var$Point(curve, obj[0], obj[1], obj[2]);
};
$2c60f5dbd111f643$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$2c60f5dbd111f643$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && this.y.cmp(this.z) === 0;
};
$2c60f5dbd111f643$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$2c60f5dbd111f643$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    if (this.curve.twisted) {
        // E = a * C
        var e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            var h = this.z.redSqr();
            // J = F - 2 * H
            var j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        var e = c.redAdd(d);
        // H = (c * Z1)^2
        var h = this.curve._mulC(this.c.redMul(this.z)).redSqr();
        // J = E - 2 * H
        var j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$2c60f5dbd111f643$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$2c60f5dbd111f643$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$2c60f5dbd111f643$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$2c60f5dbd111f643$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$2c60f5dbd111f643$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$2c60f5dbd111f643$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$2c60f5dbd111f643$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$2c60f5dbd111f643$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$2c60f5dbd111f643$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$2c60f5dbd111f643$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$2c60f5dbd111f643$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$2c60f5dbd111f643$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$2c60f5dbd111f643$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
    return false;
};
// Compatibility with BaseCurve
$2c60f5dbd111f643$var$Point.prototype.toP = $2c60f5dbd111f643$var$Point.prototype.normalize;
$2c60f5dbd111f643$var$Point.prototype.mixedAdd = $2c60f5dbd111f643$var$Point.prototype.add;

});


parcelRegister("8XT4W", function(module, exports) {
'use strict';
var $686e8eebd7f02f1e$var$curves = module.exports;

var $1b2Pi = parcelRequire("1b2Pi");

var $6nTxf = parcelRequire("6nTxf");
var $686e8eebd7f02f1e$var$assert = $6nTxf.utils.assert;
function $686e8eebd7f02f1e$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $6nTxf.curve.short(options);
    else if (options.type === 'edwards') this.curve = new $6nTxf.curve.edwards(options);
    else this.curve = new $6nTxf.curve.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $686e8eebd7f02f1e$var$assert(this.g.validate(), 'Invalid curve');
    $686e8eebd7f02f1e$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$686e8eebd7f02f1e$var$curves.PresetCurve = $686e8eebd7f02f1e$var$PresetCurve;
function $686e8eebd7f02f1e$var$defineCurve(name, options) {
    Object.defineProperty($686e8eebd7f02f1e$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $686e8eebd7f02f1e$var$PresetCurve(options);
            Object.defineProperty($686e8eebd7f02f1e$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$686e8eebd7f02f1e$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $1b2Pi.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$686e8eebd7f02f1e$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $1b2Pi.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$686e8eebd7f02f1e$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $1b2Pi.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$686e8eebd7f02f1e$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $1b2Pi.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$686e8eebd7f02f1e$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $1b2Pi.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$686e8eebd7f02f1e$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $1b2Pi.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$686e8eebd7f02f1e$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $1b2Pi.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $686e8eebd7f02f1e$var$pre;

try {
    $686e8eebd7f02f1e$var$pre = (parcelRequire("93PGC"));
} catch (e) {
    $686e8eebd7f02f1e$var$pre = undefined;
}
$686e8eebd7f02f1e$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $1b2Pi.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $686e8eebd7f02f1e$var$pre
    ]
});

});
parcelRegister("1b2Pi", function(module, exports) {
var $0db902c75b4d9429$var$hash = module.exports;

$0db902c75b4d9429$var$hash.utils = (parcelRequire("5m5RF"));

$0db902c75b4d9429$var$hash.common = (parcelRequire("ap5FC"));

$0db902c75b4d9429$var$hash.sha = (parcelRequire("4TZSF"));

$0db902c75b4d9429$var$hash.ripemd = (parcelRequire("8pLmN"));

$0db902c75b4d9429$var$hash.hmac = (parcelRequire("bVEBB"));
// Proxy hash functions to the main object
$0db902c75b4d9429$var$hash.sha1 = $0db902c75b4d9429$var$hash.sha.sha1;
$0db902c75b4d9429$var$hash.sha256 = $0db902c75b4d9429$var$hash.sha.sha256;
$0db902c75b4d9429$var$hash.sha224 = $0db902c75b4d9429$var$hash.sha.sha224;
$0db902c75b4d9429$var$hash.sha384 = $0db902c75b4d9429$var$hash.sha.sha384;
$0db902c75b4d9429$var$hash.sha512 = $0db902c75b4d9429$var$hash.sha.sha512;
$0db902c75b4d9429$var$hash.ripemd160 = $0db902c75b4d9429$var$hash.ripemd.ripemd160;

});
parcelRegister("5m5RF", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $3e638e6515e2acb0$export$69f1b2dcda23c5f8, (v) => $3e638e6515e2acb0$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $3e638e6515e2acb0$export$45b10814cc054894, (v) => $3e638e6515e2acb0$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $3e638e6515e2acb0$export$7ea66e3774a60b67, (v) => $3e638e6515e2acb0$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $3e638e6515e2acb0$export$34a52f00f601f6f1, (v) => $3e638e6515e2acb0$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $3e638e6515e2acb0$export$812b0cbd5e8a72ab, (v) => $3e638e6515e2acb0$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $3e638e6515e2acb0$export$f24f9e11d63bb314, (v) => $3e638e6515e2acb0$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $3e638e6515e2acb0$export$b71357c7e07ca1f1, (v) => $3e638e6515e2acb0$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $3e638e6515e2acb0$export$2e58a4b541fdcbe8, (v) => $3e638e6515e2acb0$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $3e638e6515e2acb0$export$183b950bde9faab8, (v) => $3e638e6515e2acb0$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $3e638e6515e2acb0$export$4785c77169fea59e, (v) => $3e638e6515e2acb0$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $3e638e6515e2acb0$export$242a185dfcffac5b, (v) => $3e638e6515e2acb0$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $3e638e6515e2acb0$export$58c04ae0ae31877d, (v) => $3e638e6515e2acb0$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $3e638e6515e2acb0$export$d058ca695f8c6f11, (v) => $3e638e6515e2acb0$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $3e638e6515e2acb0$export$a1efd7fc3e986367, (v) => $3e638e6515e2acb0$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $3e638e6515e2acb0$export$bbfea4a2b5abaab4, (v) => $3e638e6515e2acb0$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $3e638e6515e2acb0$export$97ad4afc7de86152, (v) => $3e638e6515e2acb0$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $3e638e6515e2acb0$export$ce4673d9a79f6a4b, (v) => $3e638e6515e2acb0$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $3e638e6515e2acb0$export$786cc99fc6eedc0b, (v) => $3e638e6515e2acb0$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $3e638e6515e2acb0$export$45c59b9a1848dd0, (v) => $3e638e6515e2acb0$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $3e638e6515e2acb0$export$50d8f613e76d3034, (v) => $3e638e6515e2acb0$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $3e638e6515e2acb0$export$b8e83683c60ee162, (v) => $3e638e6515e2acb0$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $3e638e6515e2acb0$export$aeeb51790d1bcc4a, (v) => $3e638e6515e2acb0$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $3e638e6515e2acb0$export$bb7c616f719ad9c, (v) => $3e638e6515e2acb0$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $3e638e6515e2acb0$export$4d63290824f9d7df, (v) => $3e638e6515e2acb0$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $3e638e6515e2acb0$export$2f64ceb90ef28ea1, (v) => $3e638e6515e2acb0$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $3e638e6515e2acb0$export$8d2089d465f6d10d, (v) => $3e638e6515e2acb0$export$8d2089d465f6d10d = v);
var $3e638e6515e2acb0$export$69f1b2dcda23c5f8;
var $3e638e6515e2acb0$export$45b10814cc054894;
var $3e638e6515e2acb0$export$7ea66e3774a60b67;
var $3e638e6515e2acb0$export$34a52f00f601f6f1;
var $3e638e6515e2acb0$export$812b0cbd5e8a72ab;
var $3e638e6515e2acb0$export$f24f9e11d63bb314;
var $3e638e6515e2acb0$export$b71357c7e07ca1f1;
var $3e638e6515e2acb0$export$2e58a4b541fdcbe8;
var $3e638e6515e2acb0$export$183b950bde9faab8;
var $3e638e6515e2acb0$export$4785c77169fea59e;
var $3e638e6515e2acb0$export$242a185dfcffac5b;
var $3e638e6515e2acb0$export$58c04ae0ae31877d;
var $3e638e6515e2acb0$export$d058ca695f8c6f11;
var $3e638e6515e2acb0$export$a1efd7fc3e986367;
var $3e638e6515e2acb0$export$bbfea4a2b5abaab4;
var $3e638e6515e2acb0$export$97ad4afc7de86152;
var $3e638e6515e2acb0$export$ce4673d9a79f6a4b;
var $3e638e6515e2acb0$export$786cc99fc6eedc0b;
var $3e638e6515e2acb0$export$45c59b9a1848dd0;
var $3e638e6515e2acb0$export$50d8f613e76d3034;
var $3e638e6515e2acb0$export$b8e83683c60ee162;
var $3e638e6515e2acb0$export$aeeb51790d1bcc4a;
var $3e638e6515e2acb0$export$bb7c616f719ad9c;
var $3e638e6515e2acb0$export$4d63290824f9d7df;
var $3e638e6515e2acb0$export$2f64ceb90ef28ea1;
var $3e638e6515e2acb0$export$8d2089d465f6d10d;
'use strict';

var $aOIMZ = parcelRequire("aOIMZ");

var $lyUaN = parcelRequire("lyUaN");
$3e638e6515e2acb0$export$69f1b2dcda23c5f8 = $lyUaN;
function $3e638e6515e2acb0$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$3e638e6515e2acb0$export$45b10814cc054894 = $3e638e6515e2acb0$var$toArray;
function $3e638e6515e2acb0$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $3e638e6515e2acb0$var$zero2(msg[i].toString(16));
    return res;
}
$3e638e6515e2acb0$export$7ea66e3774a60b67 = $3e638e6515e2acb0$var$toHex;
function $3e638e6515e2acb0$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$3e638e6515e2acb0$export$34a52f00f601f6f1 = $3e638e6515e2acb0$var$htonl;
function $3e638e6515e2acb0$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $3e638e6515e2acb0$var$htonl(w);
        res += $3e638e6515e2acb0$var$zero8(w.toString(16));
    }
    return res;
}
$3e638e6515e2acb0$export$812b0cbd5e8a72ab = $3e638e6515e2acb0$var$toHex32;
function $3e638e6515e2acb0$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$3e638e6515e2acb0$export$f24f9e11d63bb314 = $3e638e6515e2acb0$var$zero2;
function $3e638e6515e2acb0$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$3e638e6515e2acb0$export$b71357c7e07ca1f1 = $3e638e6515e2acb0$var$zero8;
function $3e638e6515e2acb0$var$join32(msg, start, end, endian) {
    var len = end - start;
    $aOIMZ(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$3e638e6515e2acb0$export$2e58a4b541fdcbe8 = $3e638e6515e2acb0$var$join32;
function $3e638e6515e2acb0$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$3e638e6515e2acb0$export$183b950bde9faab8 = $3e638e6515e2acb0$var$split32;
function $3e638e6515e2acb0$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$3e638e6515e2acb0$export$4785c77169fea59e = $3e638e6515e2acb0$var$rotr32;
function $3e638e6515e2acb0$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$3e638e6515e2acb0$export$242a185dfcffac5b = $3e638e6515e2acb0$var$rotl32;
function $3e638e6515e2acb0$var$sum32(a, b) {
    return a + b >>> 0;
}
$3e638e6515e2acb0$export$58c04ae0ae31877d = $3e638e6515e2acb0$var$sum32;
function $3e638e6515e2acb0$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$3e638e6515e2acb0$export$d058ca695f8c6f11 = $3e638e6515e2acb0$var$sum32_3;
function $3e638e6515e2acb0$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$3e638e6515e2acb0$export$a1efd7fc3e986367 = $3e638e6515e2acb0$var$sum32_4;
function $3e638e6515e2acb0$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$3e638e6515e2acb0$export$bbfea4a2b5abaab4 = $3e638e6515e2acb0$var$sum32_5;
function $3e638e6515e2acb0$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$3e638e6515e2acb0$export$97ad4afc7de86152 = $3e638e6515e2acb0$var$sum64;
function $3e638e6515e2acb0$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$3e638e6515e2acb0$export$ce4673d9a79f6a4b = $3e638e6515e2acb0$var$sum64_hi;
function $3e638e6515e2acb0$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$3e638e6515e2acb0$export$786cc99fc6eedc0b = $3e638e6515e2acb0$var$sum64_lo;
function $3e638e6515e2acb0$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$3e638e6515e2acb0$export$45c59b9a1848dd0 = $3e638e6515e2acb0$var$sum64_4_hi;
function $3e638e6515e2acb0$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$3e638e6515e2acb0$export$50d8f613e76d3034 = $3e638e6515e2acb0$var$sum64_4_lo;
function $3e638e6515e2acb0$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$3e638e6515e2acb0$export$b8e83683c60ee162 = $3e638e6515e2acb0$var$sum64_5_hi;
function $3e638e6515e2acb0$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$3e638e6515e2acb0$export$aeeb51790d1bcc4a = $3e638e6515e2acb0$var$sum64_5_lo;
function $3e638e6515e2acb0$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$3e638e6515e2acb0$export$bb7c616f719ad9c = $3e638e6515e2acb0$var$rotr64_hi;
function $3e638e6515e2acb0$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$3e638e6515e2acb0$export$4d63290824f9d7df = $3e638e6515e2acb0$var$rotr64_lo;
function $3e638e6515e2acb0$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$3e638e6515e2acb0$export$2f64ceb90ef28ea1 = $3e638e6515e2acb0$var$shr64_hi;
function $3e638e6515e2acb0$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$3e638e6515e2acb0$export$8d2089d465f6d10d = $3e638e6515e2acb0$var$shr64_lo;

});

parcelRegister("ap5FC", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7930a331e2b8bb39$export$8687658379b577e6, (v) => $7930a331e2b8bb39$export$8687658379b577e6 = v);
var $7930a331e2b8bb39$export$8687658379b577e6;
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $aOIMZ = parcelRequire("aOIMZ");
function $7930a331e2b8bb39$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7930a331e2b8bb39$export$8687658379b577e6 = $7930a331e2b8bb39$var$BlockHash;
$7930a331e2b8bb39$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $5m5RF.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $5m5RF.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7930a331e2b8bb39$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $aOIMZ(this.pending === null);
    return this._digest(enc);
};
$7930a331e2b8bb39$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("4TZSF", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $391c4cb3e26fcd89$export$5091bdda49ba90f5, (v) => $391c4cb3e26fcd89$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $391c4cb3e26fcd89$export$97b70509d4e397ea, (v) => $391c4cb3e26fcd89$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $391c4cb3e26fcd89$export$bced8d2aada2d1c9, (v) => $391c4cb3e26fcd89$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $391c4cb3e26fcd89$export$612d47d55dedde45, (v) => $391c4cb3e26fcd89$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $391c4cb3e26fcd89$export$a888d2532e6dc7bb, (v) => $391c4cb3e26fcd89$export$a888d2532e6dc7bb = v);
var $391c4cb3e26fcd89$export$5091bdda49ba90f5;
var $391c4cb3e26fcd89$export$97b70509d4e397ea;
var $391c4cb3e26fcd89$export$bced8d2aada2d1c9;
var $391c4cb3e26fcd89$export$612d47d55dedde45;
var $391c4cb3e26fcd89$export$a888d2532e6dc7bb;
'use strict';

$391c4cb3e26fcd89$export$5091bdda49ba90f5 = (parcelRequire("1YLg9"));

$391c4cb3e26fcd89$export$97b70509d4e397ea = (parcelRequire("fTyPw"));

$391c4cb3e26fcd89$export$bced8d2aada2d1c9 = (parcelRequire("kjGwI"));

$391c4cb3e26fcd89$export$612d47d55dedde45 = (parcelRequire("fVCT0"));

$391c4cb3e26fcd89$export$a888d2532e6dc7bb = (parcelRequire("hpDZE"));

});
parcelRegister("1YLg9", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $ap5FC = parcelRequire("ap5FC");

var $5pCtI = parcelRequire("5pCtI");
var $17100dcd25bebb06$var$rotl32 = $5m5RF.rotl32;
var $17100dcd25bebb06$var$sum32 = $5m5RF.sum32;
var $17100dcd25bebb06$var$sum32_5 = $5m5RF.sum32_5;
var $17100dcd25bebb06$var$ft_1 = $5pCtI.ft_1;
var $17100dcd25bebb06$var$BlockHash = $ap5FC.BlockHash;
var $17100dcd25bebb06$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $17100dcd25bebb06$var$SHA1() {
    if (!(this instanceof $17100dcd25bebb06$var$SHA1)) return new $17100dcd25bebb06$var$SHA1();
    $17100dcd25bebb06$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$5m5RF.inherits($17100dcd25bebb06$var$SHA1, $17100dcd25bebb06$var$BlockHash);
module.exports = $17100dcd25bebb06$var$SHA1;
$17100dcd25bebb06$var$SHA1.blockSize = 512;
$17100dcd25bebb06$var$SHA1.outSize = 160;
$17100dcd25bebb06$var$SHA1.hmacStrength = 80;
$17100dcd25bebb06$var$SHA1.padLength = 64;
$17100dcd25bebb06$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $17100dcd25bebb06$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $17100dcd25bebb06$var$sum32_5($17100dcd25bebb06$var$rotl32(a, 5), $17100dcd25bebb06$var$ft_1(s, b, c, d), e, W[i], $17100dcd25bebb06$var$sha1_K[s]);
        e = d;
        d = c;
        c = $17100dcd25bebb06$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $17100dcd25bebb06$var$sum32(this.h[0], a);
    this.h[1] = $17100dcd25bebb06$var$sum32(this.h[1], b);
    this.h[2] = $17100dcd25bebb06$var$sum32(this.h[2], c);
    this.h[3] = $17100dcd25bebb06$var$sum32(this.h[3], d);
    this.h[4] = $17100dcd25bebb06$var$sum32(this.h[4], e);
};
$17100dcd25bebb06$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5m5RF.toHex32(this.h, 'big');
    else return $5m5RF.split32(this.h, 'big');
};

});
parcelRegister("5pCtI", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $3f0d228f2ba28050$export$5a92649d7ddb9f63, (v) => $3f0d228f2ba28050$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $3f0d228f2ba28050$export$c6d0d020c3a6269, (v) => $3f0d228f2ba28050$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $3f0d228f2ba28050$export$eb90c27fca05f956, (v) => $3f0d228f2ba28050$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $3f0d228f2ba28050$export$14a4a98e063b1999, (v) => $3f0d228f2ba28050$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $3f0d228f2ba28050$export$d20cecfa1564c686, (v) => $3f0d228f2ba28050$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $3f0d228f2ba28050$export$44fd472a12fc6db, (v) => $3f0d228f2ba28050$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $3f0d228f2ba28050$export$1ed238bb6ea1dd47, (v) => $3f0d228f2ba28050$export$1ed238bb6ea1dd47 = v);
var $3f0d228f2ba28050$export$5a92649d7ddb9f63;
var $3f0d228f2ba28050$export$c6d0d020c3a6269;
var $3f0d228f2ba28050$export$eb90c27fca05f956;
var $3f0d228f2ba28050$export$cc992891a14496a1;
var $3f0d228f2ba28050$export$14a4a98e063b1999;
var $3f0d228f2ba28050$export$d20cecfa1564c686;
var $3f0d228f2ba28050$export$44fd472a12fc6db;
var $3f0d228f2ba28050$export$1ed238bb6ea1dd47;
'use strict';

var $5m5RF = parcelRequire("5m5RF");
var $3f0d228f2ba28050$var$rotr32 = $5m5RF.rotr32;
function $3f0d228f2ba28050$var$ft_1(s, x, y, z) {
    if (s === 0) return $3f0d228f2ba28050$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $3f0d228f2ba28050$var$p32(x, y, z);
    if (s === 2) return $3f0d228f2ba28050$var$maj32(x, y, z);
}
$3f0d228f2ba28050$export$5a92649d7ddb9f63 = $3f0d228f2ba28050$var$ft_1;
function $3f0d228f2ba28050$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$3f0d228f2ba28050$export$c6d0d020c3a6269 = $3f0d228f2ba28050$var$ch32;
function $3f0d228f2ba28050$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$3f0d228f2ba28050$export$eb90c27fca05f956 = $3f0d228f2ba28050$var$maj32;
function $3f0d228f2ba28050$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$3f0d228f2ba28050$export$cc992891a14496a1 = $3f0d228f2ba28050$var$p32;
function $3f0d228f2ba28050$var$s0_256(x) {
    return $3f0d228f2ba28050$var$rotr32(x, 2) ^ $3f0d228f2ba28050$var$rotr32(x, 13) ^ $3f0d228f2ba28050$var$rotr32(x, 22);
}
$3f0d228f2ba28050$export$14a4a98e063b1999 = $3f0d228f2ba28050$var$s0_256;
function $3f0d228f2ba28050$var$s1_256(x) {
    return $3f0d228f2ba28050$var$rotr32(x, 6) ^ $3f0d228f2ba28050$var$rotr32(x, 11) ^ $3f0d228f2ba28050$var$rotr32(x, 25);
}
$3f0d228f2ba28050$export$d20cecfa1564c686 = $3f0d228f2ba28050$var$s1_256;
function $3f0d228f2ba28050$var$g0_256(x) {
    return $3f0d228f2ba28050$var$rotr32(x, 7) ^ $3f0d228f2ba28050$var$rotr32(x, 18) ^ x >>> 3;
}
$3f0d228f2ba28050$export$44fd472a12fc6db = $3f0d228f2ba28050$var$g0_256;
function $3f0d228f2ba28050$var$g1_256(x) {
    return $3f0d228f2ba28050$var$rotr32(x, 17) ^ $3f0d228f2ba28050$var$rotr32(x, 19) ^ x >>> 10;
}
$3f0d228f2ba28050$export$1ed238bb6ea1dd47 = $3f0d228f2ba28050$var$g1_256;

});


parcelRegister("fTyPw", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $kjGwI = parcelRequire("kjGwI");
function $b927028e6008aa5f$var$SHA224() {
    if (!(this instanceof $b927028e6008aa5f$var$SHA224)) return new $b927028e6008aa5f$var$SHA224();
    $kjGwI.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$5m5RF.inherits($b927028e6008aa5f$var$SHA224, $kjGwI);
module.exports = $b927028e6008aa5f$var$SHA224;
$b927028e6008aa5f$var$SHA224.blockSize = 512;
$b927028e6008aa5f$var$SHA224.outSize = 224;
$b927028e6008aa5f$var$SHA224.hmacStrength = 192;
$b927028e6008aa5f$var$SHA224.padLength = 64;
$b927028e6008aa5f$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $5m5RF.toHex32(this.h.slice(0, 7), 'big');
    else return $5m5RF.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("kjGwI", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $ap5FC = parcelRequire("ap5FC");

var $5pCtI = parcelRequire("5pCtI");

var $aOIMZ = parcelRequire("aOIMZ");
var $eca691e7cafb0ba8$var$sum32 = $5m5RF.sum32;
var $eca691e7cafb0ba8$var$sum32_4 = $5m5RF.sum32_4;
var $eca691e7cafb0ba8$var$sum32_5 = $5m5RF.sum32_5;
var $eca691e7cafb0ba8$var$ch32 = $5pCtI.ch32;
var $eca691e7cafb0ba8$var$maj32 = $5pCtI.maj32;
var $eca691e7cafb0ba8$var$s0_256 = $5pCtI.s0_256;
var $eca691e7cafb0ba8$var$s1_256 = $5pCtI.s1_256;
var $eca691e7cafb0ba8$var$g0_256 = $5pCtI.g0_256;
var $eca691e7cafb0ba8$var$g1_256 = $5pCtI.g1_256;
var $eca691e7cafb0ba8$var$BlockHash = $ap5FC.BlockHash;
var $eca691e7cafb0ba8$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $eca691e7cafb0ba8$var$SHA256() {
    if (!(this instanceof $eca691e7cafb0ba8$var$SHA256)) return new $eca691e7cafb0ba8$var$SHA256();
    $eca691e7cafb0ba8$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $eca691e7cafb0ba8$var$sha256_K;
    this.W = new Array(64);
}
$5m5RF.inherits($eca691e7cafb0ba8$var$SHA256, $eca691e7cafb0ba8$var$BlockHash);
module.exports = $eca691e7cafb0ba8$var$SHA256;
$eca691e7cafb0ba8$var$SHA256.blockSize = 512;
$eca691e7cafb0ba8$var$SHA256.outSize = 256;
$eca691e7cafb0ba8$var$SHA256.hmacStrength = 192;
$eca691e7cafb0ba8$var$SHA256.padLength = 64;
$eca691e7cafb0ba8$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $eca691e7cafb0ba8$var$sum32_4($eca691e7cafb0ba8$var$g1_256(W[i - 2]), W[i - 7], $eca691e7cafb0ba8$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $aOIMZ(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $eca691e7cafb0ba8$var$sum32_5(h, $eca691e7cafb0ba8$var$s1_256(e), $eca691e7cafb0ba8$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $eca691e7cafb0ba8$var$sum32($eca691e7cafb0ba8$var$s0_256(a), $eca691e7cafb0ba8$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $eca691e7cafb0ba8$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $eca691e7cafb0ba8$var$sum32(T1, T2);
    }
    this.h[0] = $eca691e7cafb0ba8$var$sum32(this.h[0], a);
    this.h[1] = $eca691e7cafb0ba8$var$sum32(this.h[1], b);
    this.h[2] = $eca691e7cafb0ba8$var$sum32(this.h[2], c);
    this.h[3] = $eca691e7cafb0ba8$var$sum32(this.h[3], d);
    this.h[4] = $eca691e7cafb0ba8$var$sum32(this.h[4], e);
    this.h[5] = $eca691e7cafb0ba8$var$sum32(this.h[5], f);
    this.h[6] = $eca691e7cafb0ba8$var$sum32(this.h[6], g);
    this.h[7] = $eca691e7cafb0ba8$var$sum32(this.h[7], h);
};
$eca691e7cafb0ba8$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5m5RF.toHex32(this.h, 'big');
    else return $5m5RF.split32(this.h, 'big');
};

});


parcelRegister("fVCT0", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $hpDZE = parcelRequire("hpDZE");
function $b98a57e318409183$var$SHA384() {
    if (!(this instanceof $b98a57e318409183$var$SHA384)) return new $b98a57e318409183$var$SHA384();
    $hpDZE.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$5m5RF.inherits($b98a57e318409183$var$SHA384, $hpDZE);
module.exports = $b98a57e318409183$var$SHA384;
$b98a57e318409183$var$SHA384.blockSize = 1024;
$b98a57e318409183$var$SHA384.outSize = 384;
$b98a57e318409183$var$SHA384.hmacStrength = 192;
$b98a57e318409183$var$SHA384.padLength = 128;
$b98a57e318409183$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5m5RF.toHex32(this.h.slice(0, 12), 'big');
    else return $5m5RF.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("hpDZE", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $ap5FC = parcelRequire("ap5FC");

var $aOIMZ = parcelRequire("aOIMZ");
var $cad3cb514f4c9f49$var$rotr64_hi = $5m5RF.rotr64_hi;
var $cad3cb514f4c9f49$var$rotr64_lo = $5m5RF.rotr64_lo;
var $cad3cb514f4c9f49$var$shr64_hi = $5m5RF.shr64_hi;
var $cad3cb514f4c9f49$var$shr64_lo = $5m5RF.shr64_lo;
var $cad3cb514f4c9f49$var$sum64 = $5m5RF.sum64;
var $cad3cb514f4c9f49$var$sum64_hi = $5m5RF.sum64_hi;
var $cad3cb514f4c9f49$var$sum64_lo = $5m5RF.sum64_lo;
var $cad3cb514f4c9f49$var$sum64_4_hi = $5m5RF.sum64_4_hi;
var $cad3cb514f4c9f49$var$sum64_4_lo = $5m5RF.sum64_4_lo;
var $cad3cb514f4c9f49$var$sum64_5_hi = $5m5RF.sum64_5_hi;
var $cad3cb514f4c9f49$var$sum64_5_lo = $5m5RF.sum64_5_lo;
var $cad3cb514f4c9f49$var$BlockHash = $ap5FC.BlockHash;
var $cad3cb514f4c9f49$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $cad3cb514f4c9f49$var$SHA512() {
    if (!(this instanceof $cad3cb514f4c9f49$var$SHA512)) return new $cad3cb514f4c9f49$var$SHA512();
    $cad3cb514f4c9f49$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $cad3cb514f4c9f49$var$sha512_K;
    this.W = new Array(160);
}
$5m5RF.inherits($cad3cb514f4c9f49$var$SHA512, $cad3cb514f4c9f49$var$BlockHash);
module.exports = $cad3cb514f4c9f49$var$SHA512;
$cad3cb514f4c9f49$var$SHA512.blockSize = 1024;
$cad3cb514f4c9f49$var$SHA512.outSize = 512;
$cad3cb514f4c9f49$var$SHA512.hmacStrength = 192;
$cad3cb514f4c9f49$var$SHA512.padLength = 128;
$cad3cb514f4c9f49$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $cad3cb514f4c9f49$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $cad3cb514f4c9f49$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $cad3cb514f4c9f49$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $cad3cb514f4c9f49$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $cad3cb514f4c9f49$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $cad3cb514f4c9f49$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$cad3cb514f4c9f49$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $aOIMZ(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $cad3cb514f4c9f49$var$s1_512_hi(eh, el);
        var c1_lo = $cad3cb514f4c9f49$var$s1_512_lo(eh, el);
        var c2_hi = $cad3cb514f4c9f49$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $cad3cb514f4c9f49$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $cad3cb514f4c9f49$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $cad3cb514f4c9f49$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $cad3cb514f4c9f49$var$s0_512_hi(ah, al);
        c0_lo = $cad3cb514f4c9f49$var$s0_512_lo(ah, al);
        c1_hi = $cad3cb514f4c9f49$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $cad3cb514f4c9f49$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $cad3cb514f4c9f49$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $cad3cb514f4c9f49$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $cad3cb514f4c9f49$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $cad3cb514f4c9f49$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $cad3cb514f4c9f49$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $cad3cb514f4c9f49$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $cad3cb514f4c9f49$var$sum64(this.h, 0, ah, al);
    $cad3cb514f4c9f49$var$sum64(this.h, 2, bh, bl);
    $cad3cb514f4c9f49$var$sum64(this.h, 4, ch, cl);
    $cad3cb514f4c9f49$var$sum64(this.h, 6, dh, dl);
    $cad3cb514f4c9f49$var$sum64(this.h, 8, eh, el);
    $cad3cb514f4c9f49$var$sum64(this.h, 10, fh, fl);
    $cad3cb514f4c9f49$var$sum64(this.h, 12, gh, gl);
    $cad3cb514f4c9f49$var$sum64(this.h, 14, hh, hl);
};
$cad3cb514f4c9f49$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5m5RF.toHex32(this.h, 'big');
    else return $5m5RF.split32(this.h, 'big');
};
function $cad3cb514f4c9f49$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$s0_512_hi(xh, xl) {
    var c0_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $cad3cb514f4c9f49$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $cad3cb514f4c9f49$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$s0_512_lo(xh, xl) {
    var c0_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $cad3cb514f4c9f49$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $cad3cb514f4c9f49$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$s1_512_hi(xh, xl) {
    var c0_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $cad3cb514f4c9f49$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$s1_512_lo(xh, xl) {
    var c0_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $cad3cb514f4c9f49$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$g0_512_hi(xh, xl) {
    var c0_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $cad3cb514f4c9f49$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$g0_512_lo(xh, xl) {
    var c0_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $cad3cb514f4c9f49$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$g1_512_hi(xh, xl) {
    var c0_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $cad3cb514f4c9f49$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $cad3cb514f4c9f49$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$g1_512_lo(xh, xl) {
    var c0_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $cad3cb514f4c9f49$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $cad3cb514f4c9f49$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("8pLmN", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $62056695c4cb62fc$export$d1cea0ee4e3f0d3e, (v) => $62056695c4cb62fc$export$d1cea0ee4e3f0d3e = v);
var $62056695c4cb62fc$export$d1cea0ee4e3f0d3e;
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $ap5FC = parcelRequire("ap5FC");
var $62056695c4cb62fc$var$rotl32 = $5m5RF.rotl32;
var $62056695c4cb62fc$var$sum32 = $5m5RF.sum32;
var $62056695c4cb62fc$var$sum32_3 = $5m5RF.sum32_3;
var $62056695c4cb62fc$var$sum32_4 = $5m5RF.sum32_4;
var $62056695c4cb62fc$var$BlockHash = $ap5FC.BlockHash;
function $62056695c4cb62fc$var$RIPEMD160() {
    if (!(this instanceof $62056695c4cb62fc$var$RIPEMD160)) return new $62056695c4cb62fc$var$RIPEMD160();
    $62056695c4cb62fc$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$5m5RF.inherits($62056695c4cb62fc$var$RIPEMD160, $62056695c4cb62fc$var$BlockHash);
$62056695c4cb62fc$export$d1cea0ee4e3f0d3e = $62056695c4cb62fc$var$RIPEMD160;
$62056695c4cb62fc$var$RIPEMD160.blockSize = 512;
$62056695c4cb62fc$var$RIPEMD160.outSize = 160;
$62056695c4cb62fc$var$RIPEMD160.hmacStrength = 192;
$62056695c4cb62fc$var$RIPEMD160.padLength = 64;
$62056695c4cb62fc$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $62056695c4cb62fc$var$sum32($62056695c4cb62fc$var$rotl32($62056695c4cb62fc$var$sum32_4(A, $62056695c4cb62fc$var$f(j, B, C, D), msg[$62056695c4cb62fc$var$r[j] + start], $62056695c4cb62fc$var$K(j)), $62056695c4cb62fc$var$s[j]), E);
        A = E;
        E = D;
        D = $62056695c4cb62fc$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $62056695c4cb62fc$var$sum32($62056695c4cb62fc$var$rotl32($62056695c4cb62fc$var$sum32_4(Ah, $62056695c4cb62fc$var$f(79 - j, Bh, Ch, Dh), msg[$62056695c4cb62fc$var$rh[j] + start], $62056695c4cb62fc$var$Kh(j)), $62056695c4cb62fc$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $62056695c4cb62fc$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $62056695c4cb62fc$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $62056695c4cb62fc$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $62056695c4cb62fc$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $62056695c4cb62fc$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $62056695c4cb62fc$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$62056695c4cb62fc$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5m5RF.toHex32(this.h, 'little');
    else return $5m5RF.split32(this.h, 'little');
};
function $62056695c4cb62fc$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $62056695c4cb62fc$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $62056695c4cb62fc$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $62056695c4cb62fc$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $62056695c4cb62fc$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $62056695c4cb62fc$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $62056695c4cb62fc$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("bVEBB", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $aOIMZ = parcelRequire("aOIMZ");
function $8af483f723c67b6b$var$Hmac(hash, key, enc) {
    if (!(this instanceof $8af483f723c67b6b$var$Hmac)) return new $8af483f723c67b6b$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($5m5RF.toArray(key, enc));
}
module.exports = $8af483f723c67b6b$var$Hmac;
$8af483f723c67b6b$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $aOIMZ(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$8af483f723c67b6b$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$8af483f723c67b6b$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("93PGC", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("h6mem", function(module, exports) {
'use strict';

var $61SlE = parcelRequire("61SlE");

var $g1um0 = parcelRequire("g1um0");

var $6nTxf = parcelRequire("6nTxf");
var $c7343dc2badb09ab$var$utils = $6nTxf.utils;
var $c7343dc2badb09ab$var$assert = $c7343dc2badb09ab$var$utils.assert;

var $5G0Zf = parcelRequire("5G0Zf");

var $27zvB = parcelRequire("27zvB");
function $c7343dc2badb09ab$var$EC(options) {
    if (!(this instanceof $c7343dc2badb09ab$var$EC)) return new $c7343dc2badb09ab$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $c7343dc2badb09ab$var$assert($6nTxf.curves.hasOwnProperty(options), 'Unknown curve ' + options);
        options = $6nTxf.curves[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $6nTxf.curves.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $c7343dc2badb09ab$var$EC;
$c7343dc2badb09ab$var$EC.prototype.keyPair = function keyPair(options) {
    return new $5G0Zf(this, options);
};
$c7343dc2badb09ab$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $5G0Zf.fromPrivate(this, priv, enc);
};
$c7343dc2badb09ab$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $5G0Zf.fromPublic(this, pub, enc);
};
$c7343dc2badb09ab$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $g1um0({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $6nTxf.rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $61SlE(2));
    do {
        var priv = new $61SlE(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }while (true);
};
$c7343dc2badb09ab$var$EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$c7343dc2badb09ab$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $61SlE(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $g1um0({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $61SlE(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $61SlE(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $27zvB({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$c7343dc2badb09ab$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $61SlE(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $27zvB(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    if (!this.curve._maxwellTrick) {
        var p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    var p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$c7343dc2badb09ab$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $c7343dc2badb09ab$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $27zvB(signature, enc);
    var n = this.n;
    var e = new $61SlE(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$c7343dc2badb09ab$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $27zvB(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("g1um0", function(module, exports) {
'use strict';

var $1b2Pi = parcelRequire("1b2Pi");

var $9a0Ug = parcelRequire("9a0Ug");

var $aOIMZ = parcelRequire("aOIMZ");
function $baa448f8c81bebd3$var$HmacDRBG(options) {
    if (!(this instanceof $baa448f8c81bebd3$var$HmacDRBG)) return new $baa448f8c81bebd3$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $9a0Ug.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $9a0Ug.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $9a0Ug.toArray(options.pers, options.persEnc || 'hex');
    $aOIMZ(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $baa448f8c81bebd3$var$HmacDRBG;
$baa448f8c81bebd3$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$baa448f8c81bebd3$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $1b2Pi.hmac(this.hash, this.K);
};
$baa448f8c81bebd3$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$baa448f8c81bebd3$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $9a0Ug.toArray(entropy, entropyEnc);
    add = $9a0Ug.toArray(add, addEnc);
    $aOIMZ(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$baa448f8c81bebd3$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $9a0Ug.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $9a0Ug.encode(res, enc);
};

});

parcelRegister("5G0Zf", function(module, exports) {
'use strict';

var $61SlE = parcelRequire("61SlE");

var $6nTxf = parcelRequire("6nTxf");
var $4221a3fd0ff06be5$var$utils = $6nTxf.utils;
var $4221a3fd0ff06be5$var$assert = $4221a3fd0ff06be5$var$utils.assert;
function $4221a3fd0ff06be5$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $4221a3fd0ff06be5$var$KeyPair;
$4221a3fd0ff06be5$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $4221a3fd0ff06be5$var$KeyPair) return pub;
    return new $4221a3fd0ff06be5$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$4221a3fd0ff06be5$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $4221a3fd0ff06be5$var$KeyPair) return priv;
    return new $4221a3fd0ff06be5$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$4221a3fd0ff06be5$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$4221a3fd0ff06be5$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$4221a3fd0ff06be5$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$4221a3fd0ff06be5$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $61SlE(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$4221a3fd0ff06be5$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $4221a3fd0ff06be5$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $4221a3fd0ff06be5$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$4221a3fd0ff06be5$var$KeyPair.prototype.derive = function derive(pub) {
    return pub.mul(this.priv).getX();
};
// ECDSA
$4221a3fd0ff06be5$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$4221a3fd0ff06be5$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$4221a3fd0ff06be5$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("27zvB", function(module, exports) {
'use strict';

var $61SlE = parcelRequire("61SlE");

var $6nTxf = parcelRequire("6nTxf");
var $18b7c786830ea982$var$utils = $6nTxf.utils;
var $18b7c786830ea982$var$assert = $18b7c786830ea982$var$utils.assert;
function $18b7c786830ea982$var$Signature(options, enc) {
    if (options instanceof $18b7c786830ea982$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $18b7c786830ea982$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $61SlE(options.r, 16);
    this.s = new $61SlE(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $18b7c786830ea982$var$Signature;
function $18b7c786830ea982$var$Position() {
    this.place = 0;
}
function $18b7c786830ea982$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
    }
    p.place = off;
    return val;
}
function $18b7c786830ea982$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$18b7c786830ea982$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $18b7c786830ea982$var$utils.toArray(data, enc);
    var p = new $18b7c786830ea982$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $18b7c786830ea982$var$getLength(data, p);
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $18b7c786830ea982$var$getLength(data, p);
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $18b7c786830ea982$var$getLength(data, p);
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0 && r[1] & 0x80) r = r.slice(1);
    if (s[0] === 0 && s[1] & 0x80) s = s.slice(1);
    this.r = new $61SlE(r);
    this.s = new $61SlE(s);
    this.recoveryParam = null;
    return true;
};
function $18b7c786830ea982$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$18b7c786830ea982$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $18b7c786830ea982$var$rmPadding(r);
    s = $18b7c786830ea982$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $18b7c786830ea982$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $18b7c786830ea982$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $18b7c786830ea982$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $18b7c786830ea982$var$utils.encode(res, enc);
};

});


parcelRegister("j0pZO", function(module, exports) {
'use strict';

var $1b2Pi = parcelRequire("1b2Pi");

var $6nTxf = parcelRequire("6nTxf");
var $dd622ea45c6600da$var$utils = $6nTxf.utils;
var $dd622ea45c6600da$var$assert = $dd622ea45c6600da$var$utils.assert;
var $dd622ea45c6600da$var$parseBytes = $dd622ea45c6600da$var$utils.parseBytes;

var $kiVpu = parcelRequire("kiVpu");

var $jwPwB = parcelRequire("jwPwB");
function $dd622ea45c6600da$var$EDDSA(curve) {
    $dd622ea45c6600da$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $dd622ea45c6600da$var$EDDSA)) return new $dd622ea45c6600da$var$EDDSA(curve);
    var curve = $6nTxf.curves[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $1b2Pi.sha512;
}
module.exports = $dd622ea45c6600da$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $dd622ea45c6600da$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $dd622ea45c6600da$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $dd622ea45c6600da$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $dd622ea45c6600da$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$dd622ea45c6600da$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $dd622ea45c6600da$var$utils.intFromLE(hash.digest()).umod(this.curve.n);
};
$dd622ea45c6600da$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $kiVpu.fromPublic(this, pub);
};
$dd622ea45c6600da$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $kiVpu.fromSecret(this, secret);
};
$dd622ea45c6600da$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $jwPwB) return sig;
    return new $jwPwB(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $dd622ea45c6600da$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$dd622ea45c6600da$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $dd622ea45c6600da$var$utils.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $dd622ea45c6600da$var$utils.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$dd622ea45c6600da$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$dd622ea45c6600da$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $dd622ea45c6600da$var$utils.intFromLE(bytes);
};
$dd622ea45c6600da$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("kiVpu", function(module, exports) {
'use strict';

var $6nTxf = parcelRequire("6nTxf");
var $ec82058b2f28f2e5$var$utils = $6nTxf.utils;
var $ec82058b2f28f2e5$var$assert = $ec82058b2f28f2e5$var$utils.assert;
var $ec82058b2f28f2e5$var$parseBytes = $ec82058b2f28f2e5$var$utils.parseBytes;
var $ec82058b2f28f2e5$var$cachedProperty = $ec82058b2f28f2e5$var$utils.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $ec82058b2f28f2e5$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $ec82058b2f28f2e5$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $ec82058b2f28f2e5$var$parseBytes(params.pub);
}
$ec82058b2f28f2e5$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $ec82058b2f28f2e5$var$KeyPair) return pub;
    return new $ec82058b2f28f2e5$var$KeyPair(eddsa, {
        pub: pub
    });
};
$ec82058b2f28f2e5$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $ec82058b2f28f2e5$var$KeyPair) return secret;
    return new $ec82058b2f28f2e5$var$KeyPair(eddsa, {
        secret: secret
    });
};
$ec82058b2f28f2e5$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$ec82058b2f28f2e5$var$KeyPair.prototype.sign = function sign(message) {
    $ec82058b2f28f2e5$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$ec82058b2f28f2e5$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$ec82058b2f28f2e5$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $ec82058b2f28f2e5$var$assert(this._secret, 'KeyPair is public only');
    return $ec82058b2f28f2e5$var$utils.encode(this.secret(), enc);
};
$ec82058b2f28f2e5$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $ec82058b2f28f2e5$var$utils.encode(this.pubBytes(), enc);
};
module.exports = $ec82058b2f28f2e5$var$KeyPair;

});

parcelRegister("jwPwB", function(module, exports) {
'use strict';

var $61SlE = parcelRequire("61SlE");

var $6nTxf = parcelRequire("6nTxf");
var $e378f93fe9f62b7b$var$utils = $6nTxf.utils;
var $e378f93fe9f62b7b$var$assert = $e378f93fe9f62b7b$var$utils.assert;
var $e378f93fe9f62b7b$var$cachedProperty = $e378f93fe9f62b7b$var$utils.cachedProperty;
var $e378f93fe9f62b7b$var$parseBytes = $e378f93fe9f62b7b$var$utils.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $e378f93fe9f62b7b$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $e378f93fe9f62b7b$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $e378f93fe9f62b7b$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $61SlE) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$e378f93fe9f62b7b$var$cachedProperty($e378f93fe9f62b7b$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$e378f93fe9f62b7b$var$cachedProperty($e378f93fe9f62b7b$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$e378f93fe9f62b7b$var$cachedProperty($e378f93fe9f62b7b$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$e378f93fe9f62b7b$var$cachedProperty($e378f93fe9f62b7b$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$e378f93fe9f62b7b$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$e378f93fe9f62b7b$var$Signature.prototype.toHex = function toHex() {
    return $e378f93fe9f62b7b$var$utils.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $e378f93fe9f62b7b$var$Signature;

});



parcelRegister("lXsfV", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $ffc506b4f2050cfc$require$Buffer = $aul3P.Buffer;

var $cfiQZ = parcelRequire("cfiQZ");

var $fJ1z5 = parcelRequire("fJ1z5");

var $1qG0a = parcelRequire("1qG0a");

var $FyTgm = parcelRequire("FyTgm");

var $8bTm7 = parcelRequire("8bTm7");
module.exports = $ffc506b4f2050cfc$var$parseKeys;
function $ffc506b4f2050cfc$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$ffc506b4f2050cfc$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = new $ffc506b4f2050cfc$require$Buffer(buffer);
    var stripped = $1qG0a(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $cfiQZ.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $cfiQZ.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $cfiQZ.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $cfiQZ.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
            throw new Error('unknown key type ' + type);
        case 'ENCRYPTED PRIVATE KEY':
            data = $cfiQZ.EncryptedPrivateKey.decode(data, 'der');
            data = $ffc506b4f2050cfc$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $cfiQZ.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $cfiQZ.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $cfiQZ.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $cfiQZ.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
            throw new Error('unknown key type ' + type);
        case 'RSA PUBLIC KEY':
            return $cfiQZ.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $cfiQZ.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $cfiQZ.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $cfiQZ.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$ffc506b4f2050cfc$var$parseKeys.signature = $cfiQZ.signature;
function $ffc506b4f2050cfc$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $fJ1z5[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $8bTm7.pbkdf2Sync(password, salt, iters, keylen);
    var cipher = $FyTgm.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $ffc506b4f2050cfc$require$Buffer.concat(out);
}

});
parcelRegister("cfiQZ", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $8ea582b0d1e4c2ff$export$c98397a6eb8d0678, (v) => $8ea582b0d1e4c2ff$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $8ea582b0d1e4c2ff$export$f4aab6816f64fa6b, (v) => $8ea582b0d1e4c2ff$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $8ea582b0d1e4c2ff$export$4471f5c65d097c11, (v) => $8ea582b0d1e4c2ff$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $8ea582b0d1e4c2ff$export$ca8b6604d6ce14de, (v) => $8ea582b0d1e4c2ff$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $8ea582b0d1e4c2ff$export$8f54525b330fd87b, (v) => $8ea582b0d1e4c2ff$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $8ea582b0d1e4c2ff$export$23cd2842b44ca3e7, (v) => $8ea582b0d1e4c2ff$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $8ea582b0d1e4c2ff$export$245c9aaa9f5ce4ce, (v) => $8ea582b0d1e4c2ff$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $8ea582b0d1e4c2ff$export$8ad762e3e6399afe, (v) => $8ea582b0d1e4c2ff$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $8ea582b0d1e4c2ff$export$32ef6f92e22c6ab0, (v) => $8ea582b0d1e4c2ff$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $8ea582b0d1e4c2ff$export$c9cd164b539ebb63, (v) => $8ea582b0d1e4c2ff$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $8ea582b0d1e4c2ff$export$c98397a6eb8d0678;
var $8ea582b0d1e4c2ff$export$f4aab6816f64fa6b;
var $8ea582b0d1e4c2ff$export$4471f5c65d097c11;
var $8ea582b0d1e4c2ff$export$ca8b6604d6ce14de;
var $8ea582b0d1e4c2ff$export$8f54525b330fd87b;
var $8ea582b0d1e4c2ff$export$23cd2842b44ca3e7;
var $8ea582b0d1e4c2ff$export$245c9aaa9f5ce4ce;
var $8ea582b0d1e4c2ff$export$8ad762e3e6399afe;
var $8ea582b0d1e4c2ff$export$32ef6f92e22c6ab0;
var $8ea582b0d1e4c2ff$export$c9cd164b539ebb63;
'use strict';

var $7nj2w = parcelRequire("7nj2w");

$8ea582b0d1e4c2ff$export$c98397a6eb8d0678 = (parcelRequire("hZGUx"));
var $8ea582b0d1e4c2ff$var$RSAPrivateKey = $7nj2w.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version').int(), this.key('modulus').int(), this.key('publicExponent').int(), this.key('privateExponent').int(), this.key('prime1').int(), this.key('prime2').int(), this.key('exponent1').int(), this.key('exponent2').int(), this.key('coefficient').int());
});
$8ea582b0d1e4c2ff$export$f4aab6816f64fa6b = $8ea582b0d1e4c2ff$var$RSAPrivateKey;
var $8ea582b0d1e4c2ff$var$RSAPublicKey = $7nj2w.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus').int(), this.key('publicExponent').int());
});
$8ea582b0d1e4c2ff$export$4471f5c65d097c11 = $8ea582b0d1e4c2ff$var$RSAPublicKey;
var $8ea582b0d1e4c2ff$var$PublicKey = $7nj2w.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($8ea582b0d1e4c2ff$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$8ea582b0d1e4c2ff$export$ca8b6604d6ce14de = $8ea582b0d1e4c2ff$var$PublicKey;
var $8ea582b0d1e4c2ff$var$AlgorithmIdentifier = $7nj2w.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p').int(), this.key('q').int(), this.key('g').int()).optional());
});
var $8ea582b0d1e4c2ff$var$PrivateKeyInfo = $7nj2w.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version').int(), this.key('algorithm').use($8ea582b0d1e4c2ff$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$8ea582b0d1e4c2ff$export$8f54525b330fd87b = $8ea582b0d1e4c2ff$var$PrivateKeyInfo;
var $8ea582b0d1e4c2ff$var$EncryptedPrivateKeyInfo = $7nj2w.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters').int())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$8ea582b0d1e4c2ff$export$23cd2842b44ca3e7 = $8ea582b0d1e4c2ff$var$EncryptedPrivateKeyInfo;
var $8ea582b0d1e4c2ff$var$DSAPrivateKey = $7nj2w.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version').int(), this.key('p').int(), this.key('q').int(), this.key('g').int(), this.key('pub_key').int(), this.key('priv_key').int());
});
$8ea582b0d1e4c2ff$export$245c9aaa9f5ce4ce = $8ea582b0d1e4c2ff$var$DSAPrivateKey;
$8ea582b0d1e4c2ff$export$8ad762e3e6399afe = $7nj2w.define('DSAparam', function() {
    this.int();
});
var $8ea582b0d1e4c2ff$var$ECPrivateKey = $7nj2w.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version').int(), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($8ea582b0d1e4c2ff$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$8ea582b0d1e4c2ff$export$32ef6f92e22c6ab0 = $8ea582b0d1e4c2ff$var$ECPrivateKey;
var $8ea582b0d1e4c2ff$var$ECParameters = $7nj2w.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$8ea582b0d1e4c2ff$export$c9cd164b539ebb63 = $7nj2w.define('signature', function() {
    this.seq().obj(this.key('r').int(), this.key('s').int());
});

});
parcelRegister("7nj2w", function(module, exports) {
var $55e9734436f4a826$var$asn1 = module.exports;

$55e9734436f4a826$var$asn1.bignum = (parcelRequire("61SlE"));

$55e9734436f4a826$var$asn1.define = (parcelRequire("6uEen")).define;

$55e9734436f4a826$var$asn1.base = (parcelRequire("gvyuX"));

$55e9734436f4a826$var$asn1.constants = (parcelRequire("cgbG6"));

$55e9734436f4a826$var$asn1.decoders = (parcelRequire("9EvL1"));

$55e9734436f4a826$var$asn1.encoders = (parcelRequire("i6gsd"));

});
parcelRegister("6uEen", function(module, exports) {

var $7nj2w = parcelRequire("7nj2w");

var $lyUaN = parcelRequire("lyUaN");
var $4ba4c06a7be5b446$var$api = module.exports;
$4ba4c06a7be5b446$var$api.define = function define(name, body) {
    return new $4ba4c06a7be5b446$var$Entity(name, body);
};
function $4ba4c06a7be5b446$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$4ba4c06a7be5b446$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("gLs15")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $lyUaN(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$4ba4c06a7be5b446$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($7nj2w.decoders[enc]);
    return this.decoders[enc];
};
$4ba4c06a7be5b446$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$4ba4c06a7be5b446$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($7nj2w.encoders[enc]);
    return this.encoders[enc];
};
$4ba4c06a7be5b446$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("gLs15", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("gvyuX", function(module, exports) {
var $c04a4d3689eb5b96$var$base = module.exports;

$c04a4d3689eb5b96$var$base.Reporter = (parcelRequire("5vbYl")).Reporter;

$c04a4d3689eb5b96$var$base.DecoderBuffer = (parcelRequire("hv1XP")).DecoderBuffer;

$c04a4d3689eb5b96$var$base.EncoderBuffer = (parcelRequire("hv1XP")).EncoderBuffer;

$c04a4d3689eb5b96$var$base.Node = (parcelRequire("kFkCQ"));

});
parcelRegister("5vbYl", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $4019227616839f63$export$957313a2f485e5ed, (v) => $4019227616839f63$export$957313a2f485e5ed = v);
var $4019227616839f63$export$957313a2f485e5ed;

var $lyUaN = parcelRequire("lyUaN");
function $4019227616839f63$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$4019227616839f63$export$957313a2f485e5ed = $4019227616839f63$var$Reporter;
$4019227616839f63$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $4019227616839f63$var$ReporterError;
};
$4019227616839f63$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$4019227616839f63$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$4019227616839f63$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$4019227616839f63$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$4019227616839f63$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$4019227616839f63$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$4019227616839f63$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$4019227616839f63$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$4019227616839f63$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $4019227616839f63$var$ReporterError;
    if (inherited) err = msg;
    else err = new $4019227616839f63$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$4019227616839f63$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $4019227616839f63$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$lyUaN($4019227616839f63$var$ReporterError, Error);
$4019227616839f63$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $4019227616839f63$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("hv1XP", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $cbd6daf20c01fb9a$export$bf9f79cdc4a49163, (v) => $cbd6daf20c01fb9a$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $cbd6daf20c01fb9a$export$8ff24f7760c7a78e, (v) => $cbd6daf20c01fb9a$export$8ff24f7760c7a78e = v);
var $cbd6daf20c01fb9a$export$bf9f79cdc4a49163;
var $cbd6daf20c01fb9a$export$8ff24f7760c7a78e;

var $lyUaN = parcelRequire("lyUaN");

var $gvyuX = parcelRequire("gvyuX");
var $cbd6daf20c01fb9a$require$Reporter = $gvyuX.Reporter;

var $aul3P = parcelRequire("aul3P");
var $cbd6daf20c01fb9a$require$Buffer = $aul3P.Buffer;
function $cbd6daf20c01fb9a$var$DecoderBuffer(base, options) {
    $cbd6daf20c01fb9a$require$Reporter.call(this, options);
    if (!$cbd6daf20c01fb9a$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$lyUaN($cbd6daf20c01fb9a$var$DecoderBuffer, $cbd6daf20c01fb9a$require$Reporter);
$cbd6daf20c01fb9a$export$bf9f79cdc4a49163 = $cbd6daf20c01fb9a$var$DecoderBuffer;
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $cbd6daf20c01fb9a$require$Reporter.prototype.save.call(this)
    };
};
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $cbd6daf20c01fb9a$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $cbd6daf20c01fb9a$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $cbd6daf20c01fb9a$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $cbd6daf20c01fb9a$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $cbd6daf20c01fb9a$var$EncoderBuffer)) item = new $cbd6daf20c01fb9a$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $cbd6daf20c01fb9a$require$Buffer.byteLength(value);
    } else if ($cbd6daf20c01fb9a$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$cbd6daf20c01fb9a$export$8ff24f7760c7a78e = $cbd6daf20c01fb9a$var$EncoderBuffer;
$cbd6daf20c01fb9a$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $cbd6daf20c01fb9a$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($cbd6daf20c01fb9a$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("kFkCQ", function(module, exports) {

var $gvyuX = parcelRequire("gvyuX");
var $f0b7a2ced72bd4e2$require$Reporter = $gvyuX.Reporter;

var $gvyuX = parcelRequire("gvyuX");
var $f0b7a2ced72bd4e2$require$EncoderBuffer = $gvyuX.EncoderBuffer;

var $gvyuX = parcelRequire("gvyuX");
var $f0b7a2ced72bd4e2$require$DecoderBuffer = $gvyuX.DecoderBuffer;

var $aOIMZ = parcelRequire("aOIMZ");
// Supported tags
var $f0b7a2ced72bd4e2$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $f0b7a2ced72bd4e2$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($f0b7a2ced72bd4e2$var$tags);
// Overrided methods list
var $f0b7a2ced72bd4e2$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $f0b7a2ced72bd4e2$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $f0b7a2ced72bd4e2$var$Node;
var $f0b7a2ced72bd4e2$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$f0b7a2ced72bd4e2$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $f0b7a2ced72bd4e2$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$f0b7a2ced72bd4e2$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $f0b7a2ced72bd4e2$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$f0b7a2ced72bd4e2$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $aOIMZ(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $aOIMZ.equal(state.children.length, 1, 'Root node can have only one child');
};
$f0b7a2ced72bd4e2$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $aOIMZ(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $aOIMZ(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$f0b7a2ced72bd4e2$var$overrided.forEach(function(method) {
    $f0b7a2ced72bd4e2$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$f0b7a2ced72bd4e2$var$tags.forEach(function(tag) {
    $f0b7a2ced72bd4e2$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $aOIMZ(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$f0b7a2ced72bd4e2$var$Node.prototype.use = function use(item) {
    $aOIMZ(item);
    var state = this._baseState;
    $aOIMZ(state.use === null);
    state.use = item;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $aOIMZ(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $aOIMZ(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $aOIMZ(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $aOIMZ(state.key === null);
    state.key = newKey;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $aOIMZ(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $aOIMZ(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$f0b7a2ced72bd4e2$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $f0b7a2ced72bd4e2$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$f0b7a2ced72bd4e2$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$f0b7a2ced72bd4e2$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $aOIMZ(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$f0b7a2ced72bd4e2$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$f0b7a2ced72bd4e2$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $f0b7a2ced72bd4e2$require$EncoderBuffer(data, this.reporter);
};
$f0b7a2ced72bd4e2$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$f0b7a2ced72bd4e2$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $f0b7a2ced72bd4e2$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be ommited only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$f0b7a2ced72bd4e2$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $aOIMZ(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$f0b7a2ced72bd4e2$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$f0b7a2ced72bd4e2$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$f0b7a2ced72bd4e2$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("cgbG6", function(module, exports) {
var $8ed009b1b044eb12$var$constants = module.exports;
// Helper
$8ed009b1b044eb12$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$8ed009b1b044eb12$var$constants.der = (parcelRequire("iMa14"));

});
parcelRegister("iMa14", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $dab47ab30b53675f$export$3584c46ed60baee8, (v) => $dab47ab30b53675f$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $dab47ab30b53675f$export$f18596ef8d632e49, (v) => $dab47ab30b53675f$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $dab47ab30b53675f$export$2b067c6666111485, (v) => $dab47ab30b53675f$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $dab47ab30b53675f$export$f17df38a421ab9e3, (v) => $dab47ab30b53675f$export$f17df38a421ab9e3 = v);
var $dab47ab30b53675f$export$3584c46ed60baee8;
var $dab47ab30b53675f$export$f18596ef8d632e49;
var $dab47ab30b53675f$export$2b067c6666111485;
var $dab47ab30b53675f$export$f17df38a421ab9e3;

var $cgbG6 = parcelRequire("cgbG6");
$dab47ab30b53675f$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$dab47ab30b53675f$export$f18596ef8d632e49 = $cgbG6._reverse($dab47ab30b53675f$export$3584c46ed60baee8);
$dab47ab30b53675f$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$dab47ab30b53675f$export$f17df38a421ab9e3 = $cgbG6._reverse($dab47ab30b53675f$export$2b067c6666111485);

});


parcelRegister("9EvL1", function(module, exports) {
var $70707bd996b6328a$var$decoders = module.exports;

$70707bd996b6328a$var$decoders.der = (parcelRequire("1fGAm"));

$70707bd996b6328a$var$decoders.pem = (parcelRequire("kKHKZ"));

});
parcelRegister("1fGAm", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $7nj2w = parcelRequire("7nj2w");
var $0e9839ba2999c100$var$base = $7nj2w.base;
var $0e9839ba2999c100$var$bignum = $7nj2w.bignum;
// Import DER constants
var $0e9839ba2999c100$var$der = $7nj2w.constants.der;
function $0e9839ba2999c100$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $0e9839ba2999c100$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $0e9839ba2999c100$var$DERDecoder;
$0e9839ba2999c100$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $0e9839ba2999c100$var$base.DecoderBuffer)) data = new $0e9839ba2999c100$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $0e9839ba2999c100$var$DERNode(parent) {
    $0e9839ba2999c100$var$base.Node.call(this, 'der', parent);
}
$lyUaN($0e9839ba2999c100$var$DERNode, $0e9839ba2999c100$var$base.Node);
$0e9839ba2999c100$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $0e9839ba2999c100$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$0e9839ba2999c100$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $0e9839ba2999c100$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $0e9839ba2999c100$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$0e9839ba2999c100$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $0e9839ba2999c100$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $0e9839ba2999c100$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$0e9839ba2999c100$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$0e9839ba2999c100$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$0e9839ba2999c100$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$0e9839ba2999c100$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$0e9839ba2999c100$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$0e9839ba2999c100$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$0e9839ba2999c100$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $0e9839ba2999c100$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$0e9839ba2999c100$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $0e9839ba2999c100$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $0e9839ba2999c100$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $0e9839ba2999c100$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $0e9839ba2999c100$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("kKHKZ", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $aul3P = parcelRequire("aul3P");
var $f1ba0bbf43f136ce$require$Buffer = $aul3P.Buffer;

var $1fGAm = parcelRequire("1fGAm");
function $f1ba0bbf43f136ce$var$PEMDecoder(entity) {
    $1fGAm.call(this, entity);
    this.enc = 'pem';
}
$lyUaN($f1ba0bbf43f136ce$var$PEMDecoder, $1fGAm);
module.exports = $f1ba0bbf43f136ce$var$PEMDecoder;
$f1ba0bbf43f136ce$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $f1ba0bbf43f136ce$require$Buffer(base64, 'base64');
    return $1fGAm.prototype.decode.call(this, input, options);
};

});


parcelRegister("i6gsd", function(module, exports) {
var $d2d58cf9aaab919e$var$encoders = module.exports;

$d2d58cf9aaab919e$var$encoders.der = (parcelRequire("87XP3"));

$d2d58cf9aaab919e$var$encoders.pem = (parcelRequire("2eIuS"));

});
parcelRegister("87XP3", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $aul3P = parcelRequire("aul3P");
var $5ead61af4dab57dd$require$Buffer = $aul3P.Buffer;

var $7nj2w = parcelRequire("7nj2w");
var $5ead61af4dab57dd$var$base = $7nj2w.base;
// Import DER constants
var $5ead61af4dab57dd$var$der = $7nj2w.constants.der;
function $5ead61af4dab57dd$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $5ead61af4dab57dd$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $5ead61af4dab57dd$var$DEREncoder;
$5ead61af4dab57dd$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $5ead61af4dab57dd$var$DERNode(parent) {
    $5ead61af4dab57dd$var$base.Node.call(this, 'der', parent);
}
$lyUaN($5ead61af4dab57dd$var$DERNode, $5ead61af4dab57dd$var$base.Node);
$5ead61af4dab57dd$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $5ead61af4dab57dd$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $5ead61af4dab57dd$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $5ead61af4dab57dd$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$5ead61af4dab57dd$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $5ead61af4dab57dd$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$5ead61af4dab57dd$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $5ead61af4dab57dd$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $5ead61af4dab57dd$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$5ead61af4dab57dd$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $5ead61af4dab57dd$var$two(date.getFullYear()),
        $5ead61af4dab57dd$var$two(date.getUTCMonth() + 1),
        $5ead61af4dab57dd$var$two(date.getUTCDate()),
        $5ead61af4dab57dd$var$two(date.getUTCHours()),
        $5ead61af4dab57dd$var$two(date.getUTCMinutes()),
        $5ead61af4dab57dd$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $5ead61af4dab57dd$var$two(date.getFullYear() % 100),
        $5ead61af4dab57dd$var$two(date.getUTCMonth() + 1),
        $5ead61af4dab57dd$var$two(date.getUTCDate()),
        $5ead61af4dab57dd$var$two(date.getUTCHours()),
        $5ead61af4dab57dd$var$two(date.getUTCMinutes()),
        $5ead61af4dab57dd$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$5ead61af4dab57dd$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$5ead61af4dab57dd$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$5ead61af4dab57dd$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $5ead61af4dab57dd$require$Buffer(numArray);
    }
    if ($5ead61af4dab57dd$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $5ead61af4dab57dd$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $5ead61af4dab57dd$require$Buffer(out));
};
$5ead61af4dab57dd$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$5ead61af4dab57dd$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$5ead61af4dab57dd$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $5ead61af4dab57dd$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($5ead61af4dab57dd$var$der.tagByName.hasOwnProperty(tag)) res = $5ead61af4dab57dd$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $5ead61af4dab57dd$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("2eIuS", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $87XP3 = parcelRequire("87XP3");
function $1a0f67c4be613f4f$var$PEMEncoder(entity) {
    $87XP3.call(this, entity);
    this.enc = 'pem';
}
$lyUaN($1a0f67c4be613f4f$var$PEMEncoder, $87XP3);
module.exports = $1a0f67c4be613f4f$var$PEMEncoder;
$1a0f67c4be613f4f$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $87XP3.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("hZGUx", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $7nj2w = parcelRequire("7nj2w");
var $d1996b602810d0a2$var$Time = $7nj2w.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $d1996b602810d0a2$var$AttributeTypeValue = $7nj2w.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $d1996b602810d0a2$var$AlgorithmIdentifier = $7nj2w.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional());
});
var $d1996b602810d0a2$var$SubjectPublicKeyInfo = $7nj2w.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($d1996b602810d0a2$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $d1996b602810d0a2$var$RelativeDistinguishedName = $7nj2w.define('RelativeDistinguishedName', function() {
    this.setof($d1996b602810d0a2$var$AttributeTypeValue);
});
var $d1996b602810d0a2$var$RDNSequence = $7nj2w.define('RDNSequence', function() {
    this.seqof($d1996b602810d0a2$var$RelativeDistinguishedName);
});
var $d1996b602810d0a2$var$Name = $7nj2w.define('Name', function() {
    this.choice({
        rdnSequence: this.use($d1996b602810d0a2$var$RDNSequence)
    });
});
var $d1996b602810d0a2$var$Validity = $7nj2w.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($d1996b602810d0a2$var$Time), this.key('notAfter').use($d1996b602810d0a2$var$Time));
});
var $d1996b602810d0a2$var$Extension = $7nj2w.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $d1996b602810d0a2$var$TBSCertificate = $7nj2w.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0).int(), this.key('serialNumber').int(), this.key('signature').use($d1996b602810d0a2$var$AlgorithmIdentifier), this.key('issuer').use($d1996b602810d0a2$var$Name), this.key('validity').use($d1996b602810d0a2$var$Validity), this.key('subject').use($d1996b602810d0a2$var$Name), this.key('subjectPublicKeyInfo').use($d1996b602810d0a2$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($d1996b602810d0a2$var$Extension).optional());
});
var $d1996b602810d0a2$var$X509Certificate = $7nj2w.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($d1996b602810d0a2$var$TBSCertificate), this.key('signatureAlgorithm').use($d1996b602810d0a2$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $d1996b602810d0a2$var$X509Certificate;

});


parcelRegister("fJ1z5", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("1qG0a", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip

var $aul3P = parcelRequire("aul3P");
var $10a8cccf60464d54$require$Buffer = $aul3P.Buffer;
var $10a8cccf60464d54$var$findProc = /Proc-Type: 4,ENCRYPTED\n\r?DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)\n\r?\n\r?([0-9A-z\n\r\+\/\=]+)\n\r?/m;
var $10a8cccf60464d54$var$startRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----\n/m;
var $10a8cccf60464d54$var$fullRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----\n\r?([0-9A-z\n\r\+\/\=]+)\n\r?-----END \1-----$/m;

var $d9sFZ = parcelRequire("d9sFZ");

var $FyTgm = parcelRequire("FyTgm");
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($10a8cccf60464d54$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($10a8cccf60464d54$var$fullRegex);
        decrypted = new $10a8cccf60464d54$require$Buffer(match2[2].replace(/\r?\n/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = new $10a8cccf60464d54$require$Buffer(match[2], 'hex');
        var cipherText = new $10a8cccf60464d54$require$Buffer(match[3].replace(/\r?\n/g, ''), 'base64');
        var cipherKey = $d9sFZ(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $FyTgm.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $10a8cccf60464d54$require$Buffer.concat(out);
    }
    var tag = key.match($10a8cccf60464d54$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("fyXn0", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("bdxL8", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $aul3P = parcelRequire("aul3P");
var $82ab18793442ce1b$require$Buffer = $aul3P.Buffer;

var $61SlE = parcelRequire("61SlE");

var $6nTxf = parcelRequire("6nTxf");
var $82ab18793442ce1b$require$EC = $6nTxf.ec;

var $lXsfV = parcelRequire("lXsfV");

var $fyXn0 = parcelRequire("fyXn0");
function $82ab18793442ce1b$var$verify(sig, hash, key, signType, tag) {
    var pub = $lXsfV(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $82ab18793442ce1b$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $82ab18793442ce1b$var$dsaVerify(sig, hash, pub);
    } else {
        if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    }
    hash = $82ab18793442ce1b$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum++;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = new $82ab18793442ce1b$require$Buffer(pad);
    var red = $61SlE.mont(pub.modulus);
    sig = new $61SlE(sig).toRed(red);
    sig = sig.redPow(new $61SlE(pub.publicExponent));
    sig = new $82ab18793442ce1b$require$Buffer(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $82ab18793442ce1b$var$ecVerify(sig, hash, pub) {
    var curveId = $fyXn0[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $82ab18793442ce1b$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $82ab18793442ce1b$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $lXsfV.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $82ab18793442ce1b$var$checkValue(s, q);
    $82ab18793442ce1b$var$checkValue(r, q);
    var montp = $61SlE.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $61SlE(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $82ab18793442ce1b$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= q) throw new Error('invalid sig');
}
module.exports = $82ab18793442ce1b$var$verify;

});


parcelRegister("ks6qZ", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $ee3b69e69526809e$require$Buffer = $aul3P.Buffer;

var $6nTxf = parcelRequire("6nTxf");

var $61SlE = parcelRequire("61SlE");
module.exports = function createECDH(curve) {
    return new $ee3b69e69526809e$var$ECDH(curve);
};
var $ee3b69e69526809e$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$ee3b69e69526809e$var$aliases.p224 = $ee3b69e69526809e$var$aliases.secp224r1;
$ee3b69e69526809e$var$aliases.p256 = $ee3b69e69526809e$var$aliases.secp256r1 = $ee3b69e69526809e$var$aliases.prime256v1;
$ee3b69e69526809e$var$aliases.p192 = $ee3b69e69526809e$var$aliases.secp192r1 = $ee3b69e69526809e$var$aliases.prime192v1;
$ee3b69e69526809e$var$aliases.p384 = $ee3b69e69526809e$var$aliases.secp384r1;
$ee3b69e69526809e$var$aliases.p521 = $ee3b69e69526809e$var$aliases.secp521r1;
function $ee3b69e69526809e$var$ECDH(curve) {
    this.curveType = $ee3b69e69526809e$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $6nTxf.ec(this.curveType.name);
    this.keys = void 0;
}
$ee3b69e69526809e$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$ee3b69e69526809e$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$ee3b69e69526809e$require$Buffer.isBuffer(other)) other = new $ee3b69e69526809e$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $ee3b69e69526809e$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$ee3b69e69526809e$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $ee3b69e69526809e$var$formatReturnValue(key, enc);
};
$ee3b69e69526809e$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $ee3b69e69526809e$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$ee3b69e69526809e$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$ee3b69e69526809e$require$Buffer.isBuffer(pub)) pub = new $ee3b69e69526809e$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$ee3b69e69526809e$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$ee3b69e69526809e$require$Buffer.isBuffer(priv)) priv = new $ee3b69e69526809e$require$Buffer(priv, enc);
    var _priv = new $61SlE(priv);
    _priv = _priv.toString(16);
    this.keys._importPrivate(_priv);
    return this;
};
function $ee3b69e69526809e$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $ee3b69e69526809e$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $ee3b69e69526809e$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $ee3b69e69526809e$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRegister("bZRnR", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", () => $8bbecd28b745cfbe$export$512823e338ddb1b7, (v) => $8bbecd28b745cfbe$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $8bbecd28b745cfbe$export$7efb24e2fddf99b9, (v) => $8bbecd28b745cfbe$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $8bbecd28b745cfbe$export$9d0e0c0c4a8d30f3, (v) => $8bbecd28b745cfbe$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $8bbecd28b745cfbe$export$b9d55ff329113abd, (v) => $8bbecd28b745cfbe$export$b9d55ff329113abd = v);
var $8bbecd28b745cfbe$export$512823e338ddb1b7;
var $8bbecd28b745cfbe$export$7efb24e2fddf99b9;
var $8bbecd28b745cfbe$export$9d0e0c0c4a8d30f3;
var $8bbecd28b745cfbe$export$b9d55ff329113abd;

$8bbecd28b745cfbe$export$512823e338ddb1b7 = (parcelRequire("bFrdv"));

$8bbecd28b745cfbe$export$7efb24e2fddf99b9 = (parcelRequire("9r10x"));
$8bbecd28b745cfbe$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $8bbecd28b745cfbe$export$512823e338ddb1b7(key, buf, true);
};
$8bbecd28b745cfbe$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $8bbecd28b745cfbe$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("bFrdv", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $87e8a2b93b4dc2f1$require$Buffer = $aul3P.Buffer;

var $lXsfV = parcelRequire("lXsfV");

var $ugwNY = parcelRequire("ugwNY");

var $cnL2y = parcelRequire("cnL2y");

var $6y9Gi = parcelRequire("6y9Gi");

var $dphJC = parcelRequire("dphJC");

var $61SlE = parcelRequire("61SlE");

var $6P0f1 = parcelRequire("6P0f1");

var $kFMzy = parcelRequire("kFMzy");
var $87e8a2b93b4dc2f1$var$constants = {
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_PKCS1_PADDIN: 1,
    RSA_NO_PADDING: 3
};
module.exports = function publicEncrypt(public_key, msg, reverse) {
    var padding;
    if (public_key.padding) padding = public_key.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $lXsfV(public_key);
    var paddedMsg;
    if (padding === 4) paddedMsg = $87e8a2b93b4dc2f1$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $87e8a2b93b4dc2f1$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $61SlE(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $kFMzy(paddedMsg, key);
    else return $6P0f1(paddedMsg, key);
};
function $87e8a2b93b4dc2f1$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $cnL2y('sha1').update(new $87e8a2b93b4dc2f1$require$Buffer('')).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = new $87e8a2b93b4dc2f1$require$Buffer(k - mLen - hLen2 - 2);
    ps.fill(0);
    var dblen = k - hLen - 1;
    var seed = $ugwNY(hLen);
    var maskedDb = $dphJC($87e8a2b93b4dc2f1$require$Buffer.concat([
        iHash,
        ps,
        new $87e8a2b93b4dc2f1$require$Buffer([
            1
        ]),
        msg
    ], dblen), $6y9Gi(seed, dblen));
    var maskedSeed = $dphJC(seed, $6y9Gi(maskedDb, hLen));
    return new $61SlE($87e8a2b93b4dc2f1$require$Buffer.concat([
        new $87e8a2b93b4dc2f1$require$Buffer([
            0
        ]),
        maskedSeed,
        maskedDb
    ], k));
}
function $87e8a2b93b4dc2f1$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) {
        ps = new $87e8a2b93b4dc2f1$require$Buffer(k - mLen - 3);
        ps.fill(0xff);
    } else ps = $87e8a2b93b4dc2f1$var$nonZero(k - mLen - 3);
    return new $61SlE($87e8a2b93b4dc2f1$require$Buffer.concat([
        new $87e8a2b93b4dc2f1$require$Buffer([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        new $87e8a2b93b4dc2f1$require$Buffer([
            0
        ]),
        msg
    ], k));
}
function $87e8a2b93b4dc2f1$var$nonZero(len, crypto) {
    var out = new $87e8a2b93b4dc2f1$require$Buffer(len);
    var i = 0;
    var cache = $ugwNY(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $ugwNY(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("6y9Gi", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $4c4d6d8832c8b18b$require$Buffer = $aul3P.Buffer;

var $cnL2y = parcelRequire("cnL2y");
module.exports = function(seed, len) {
    var t = new $4c4d6d8832c8b18b$require$Buffer('');
    var i = 0, c;
    while(t.length < len){
        c = $4c4d6d8832c8b18b$var$i2ops(i++);
        t = $4c4d6d8832c8b18b$require$Buffer.concat([
            t,
            $cnL2y('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4c4d6d8832c8b18b$var$i2ops(c) {
    var out = new $4c4d6d8832c8b18b$require$Buffer(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("dphJC", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("6P0f1", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $4f77b16f6d4bef69$require$Buffer = $aul3P.Buffer;

var $61SlE = parcelRequire("61SlE");
function $4f77b16f6d4bef69$var$withPublic(paddedMsg, key) {
    return new $4f77b16f6d4bef69$require$Buffer(paddedMsg.toRed($61SlE.mont(key.modulus)).redPow(new $61SlE(key.publicExponent)).fromRed().toArray());
}
module.exports = $4f77b16f6d4bef69$var$withPublic;

});


parcelRegister("9r10x", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $6de76ac48d76b0c4$require$Buffer = $aul3P.Buffer;

var $lXsfV = parcelRequire("lXsfV");

var $6y9Gi = parcelRequire("6y9Gi");

var $dphJC = parcelRequire("dphJC");

var $61SlE = parcelRequire("61SlE");

var $kFMzy = parcelRequire("kFMzy");

var $cnL2y = parcelRequire("cnL2y");

var $6P0f1 = parcelRequire("6P0f1");
module.exports = function privateDecrypt(private_key, enc, reverse) {
    var padding;
    if (private_key.padding) padding = private_key.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $lXsfV(private_key);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $61SlE(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $6P0f1(new $61SlE(enc), key);
    else msg = $kFMzy(enc, key);
    var zBuffer = new $6de76ac48d76b0c4$require$Buffer(k - msg.length);
    zBuffer.fill(0);
    msg = $6de76ac48d76b0c4$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $6de76ac48d76b0c4$var$oaep(key, msg);
    else if (padding === 1) return $6de76ac48d76b0c4$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $6de76ac48d76b0c4$var$oaep(key, msg) {
    var n = key.modulus;
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $cnL2y('sha1').update(new $6de76ac48d76b0c4$require$Buffer('')).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $dphJC(maskedSeed, $6y9Gi(maskedDb, hLen));
    var db = $dphJC(maskedDb, $6y9Gi(seed, k - hLen - 1));
    if ($6de76ac48d76b0c4$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $6de76ac48d76b0c4$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    var p2 = msg.slice(i - 1, i);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $6de76ac48d76b0c4$var$compare(a, b) {
    a = new $6de76ac48d76b0c4$require$Buffer(a);
    b = new $6de76ac48d76b0c4$require$Buffer(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("hF130", function(module, exports) {

$parcel$export(module.exports, "randomFill", () => $cdb7140970b08e8d$export$bb1abf2ce84fc7e8, (v) => $cdb7140970b08e8d$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $cdb7140970b08e8d$export$2f7171e78e524d5e, (v) => $cdb7140970b08e8d$export$2f7171e78e524d5e = v);
var $cdb7140970b08e8d$export$bb1abf2ce84fc7e8;
var $cdb7140970b08e8d$export$2f7171e78e524d5e;

var $2fFJv = parcelRequire("2fFJv");
'use strict';
function $cdb7140970b08e8d$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $ijh2q = parcelRequire("ijh2q");

var $ugwNY = parcelRequire("ugwNY");
var $cdb7140970b08e8d$var$Buffer = $ijh2q.Buffer;
var $cdb7140970b08e8d$var$kBufferMaxLength = $ijh2q.kMaxLength;
var $cdb7140970b08e8d$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $cdb7140970b08e8d$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $cdb7140970b08e8d$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $cdb7140970b08e8d$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $cdb7140970b08e8d$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $cdb7140970b08e8d$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $cdb7140970b08e8d$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $cdb7140970b08e8d$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($cdb7140970b08e8d$var$crypto && $cdb7140970b08e8d$var$crypto.getRandomValues || false) {
    $cdb7140970b08e8d$export$bb1abf2ce84fc7e8 = $cdb7140970b08e8d$var$randomFill;
    $cdb7140970b08e8d$export$2f7171e78e524d5e = $cdb7140970b08e8d$var$randomFillSync;
} else {
    $cdb7140970b08e8d$export$bb1abf2ce84fc7e8 = $cdb7140970b08e8d$var$oldBrowser;
    $cdb7140970b08e8d$export$2f7171e78e524d5e = $cdb7140970b08e8d$var$oldBrowser;
}
function $cdb7140970b08e8d$var$randomFill(buf, offset, size, cb) {
    if (!$cdb7140970b08e8d$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $cdb7140970b08e8d$var$assertOffset(offset, buf.length);
    $cdb7140970b08e8d$var$assertSize(size, offset, buf.length);
    return $cdb7140970b08e8d$var$actualFill(buf, offset, size, cb);
}
function $cdb7140970b08e8d$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $cdb7140970b08e8d$var$crypto.getRandomValues(uint);
    if (cb) {
        $2fFJv.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $ugwNY(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $ugwNY(size);
    bytes.copy(buf, offset);
    return buf;
}
function $cdb7140970b08e8d$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$cdb7140970b08e8d$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $cdb7140970b08e8d$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $cdb7140970b08e8d$var$assertSize(size, offset, buf.length);
    return $cdb7140970b08e8d$var$actualFill(buf, offset, size);
}

});



parcelRegister("e349w", function(module, exports) {

$parcel$export(module.exports, "default", () => $be8fcd590c19793f$export$2e2bcd8739ae039);
/**
 * This component is a wrapper for the @atlaskit/select component that adds these props:
 * - `footer`
 * - `shouldShowFooter`
 * - `onFooterSelect`
 * by overriding the following props:
 * - `formatCreateLabel`
 * - `isValidNewOption`
 * - `onCreateOption`
 * Replace usages of this with the official AtlasKit footer prop when it is implemented: AK-6503
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $1EOkb = parcelRequire("1EOkb");

var $1ybV0 = parcelRequire("1ybV0");

var $adEL3 = parcelRequire("adEL3");

var $3z5LL = parcelRequire("3z5LL");
const $be8fcd590c19793f$var$EMPTY_USER_INPUT = '';
const $be8fcd590c19793f$var$getLoadingMessageOption = (0, $5iWql.default)((loadingMessage)=>({
        label: loadingMessage($be8fcd590c19793f$var$EMPTY_USER_INPUT),
        isDisabled: true,
        isAkSelectOption: true
    }));
const $be8fcd590c19793f$var$getNoOptionsMessageOption = (0, $5iWql.default)((noOptionsMessage)=>({
        label: noOptionsMessage($be8fcd590c19793f$var$EMPTY_USER_INPUT),
        isDisabled: true,
        isAkSelectOption: true
    }));
const $be8fcd590c19793f$var$getSelectWithFooterOptions = (0, $5iWql.default)((shouldShowFooter, options, noOptionsMessageOption, loadingMessageOption)=>shouldShowFooter === true ? [
        ...options,
        noOptionsMessageOption,
        loadingMessageOption
    ] : options);
class $be8fcd590c19793f$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            shouldShowFooter: true
        };
    }
    render() {
        const { footer: footer, onFooterSelect: onFooterSelect, options: options, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, filterOption: filterOption, spacing: spacing, onMenuScrollToBottom: onMenuScrollToBottom, ...otherProps } = this.props;
        const shouldShowFooter = this.getShouldShowFooter();
        // need to add noOptionsMessage since ak/select does not show it if Create label is shown
        const noOptionsMessageOption = $be8fcd590c19793f$var$getNoOptionsMessageOption(noOptionsMessage);
        const loadingMessageOption = $be8fcd590c19793f$var$getLoadingMessageOption(loadingMessage); // need this not to have flickr between loading and noOptions states
        const selectWithFooterOptions = $be8fcd590c19793f$var$getSelectWithFooterOptions(shouldShowFooter, options, noOptionsMessageOption, loadingMessageOption);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adEL3.default), {
            name: "select-with-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1EOkb.default), {
            ...otherProps,
            ...(0, $1ybV0.ff)('issue.details.async-field-options-tech-debt') && {
                onMenuScrollToBottom: onMenuScrollToBottom
            },
            spacing: spacing,
            options: selectWithFooterOptions,
            formatCreateLabel: this.formatCreateLabel,
            isValidNewOption: this.getShouldShowFooter,
            onCreateOption: onFooterSelect,
            filterOption: shouldShowFooter === true ? this.filterOptionWithFooterAndShowNoOptionsMessage : filterOption,
            // @ts-expect-error - Type '(inputValue: string) => string | null' is not assignable to type '(obj: { inputValue: string; }) => ReactNode'. Types of parameters 'inputValue' and 'obj' are incompatible. Type '{ inputValue: string; }' is not assignable to type 'string'.
            loadingMessage: loadingMessage,
            // @ts-expect-error - Type '(inputValue: string) => string | null' is not assignable to type '(obj: { inputValue: string; }) => ReactNode'. Types of parameters 'inputValue' and 'obj' are incompatible. Type '{ inputValue: string; }' is not assignable to type 'string'.
            noOptionsMessage: noOptionsMessage,
            allowCreateWhileLoading: true,
            ...(0, $1ybV0.ff)('issue.details.async-field-options-tech-debt') && {
                captureMenuScroll: true
            }
        }));
    }
    constructor(...args){
        super(...args);
        this.formatCreateLabel = (inputValue)=>{
            const { footer: footer, formatCreateLabel: formatCreateLabel } = this.props;
            if (footer === undefined) // in case `footer` was not passed - behave as normal
            return formatCreateLabel ? formatCreateLabel(inputValue) : inputValue;
            if (typeof footer === 'function') return footer(inputValue);
            return footer;
        };
        this.getShouldShowFooter = ()=>{
            const { footer: footer, shouldShowFooter: shouldShowFooter } = this.props;
            const hasCreateItemFooter = !!footer;
            return hasCreateItemFooter && shouldShowFooter;
        };
        this.isOptionShownInDropdown = (option, inputValue)=>{
            const { filterOption: filterOption, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, value: selectedOptions } = this.props;
            return(// will not be filtered out by ak/select based on user input (even if there is no refetch)
            filterOption(option, inputValue) && // not a manually added noOptionsMessageOption
            option.label !== noOptionsMessage($be8fcd590c19793f$var$EMPTY_USER_INPUT) && option.label !== loadingMessage($be8fcd590c19793f$var$EMPTY_USER_INPUT) && // not in selected values
            !(0, $3z5LL.flattenSelectedOptions)(selectedOptions).find((selectedOption)=>selectedOption.value === option.value));
        };
        /**
	 * react-select does not show No options message and create new option label together.
	 * That's why we need this function
	 */ this.filterOptionWithFooterAndShowNoOptionsMessage = (option, inputValue)=>{
            const { filterOption: filterOption, options: options, isLoading: isLoading, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage } = this.props;
            if (option.label === noOptionsMessage($be8fcd590c19793f$var$EMPTY_USER_INPUT)) // render noOptionsMessage only if there're no other options in the dropdown
            return isLoading !== true && !(0, $3z5LL.flattenOptions)(options).some((opt)=>this.isOptionShownInDropdown(opt, inputValue));
            if (option.label === loadingMessage($be8fcd590c19793f$var$EMPTY_USER_INPUT)) return isLoading === true && !(0, $3z5LL.flattenOptions)(options).some((opt)=>this.isOptionShownInDropdown(opt, inputValue));
            return filterOption(option, inputValue); // apply default filtering function
        };
    }
}

});
parcelRegister("3z5LL", function(module, exports) {

$parcel$export(module.exports, "flattenOptions", () => $afe29b7a76094dd0$export$7baa7c13b358b002);
$parcel$export(module.exports, "filterOptions", () => $afe29b7a76094dd0$export$60d56ed3961c839c);
$parcel$export(module.exports, "flattenSelectedOptions", () => $afe29b7a76094dd0$export$768714d87d82938f);
$parcel$export(module.exports, "getSafeValue", () => $afe29b7a76094dd0$export$d05672fd1312a6d);
$parcel$export(module.exports, "getSafeOptionsForAnalytics", () => $afe29b7a76094dd0$export$fde3d804891b8254);
$parcel$export(module.exports, "getOptionIdsForAnalytics", () => $afe29b7a76094dd0$export$8b176f4924e7119b);
$parcel$export(module.exports, "getOptionValuesLengths", () => $afe29b7a76094dd0$export$e2e167245697ed4e);

var $9OdO2 = parcelRequire("9OdO2");

var $azx3n = parcelRequire("azx3n");

var $1pc0M = parcelRequire("1pc0M");
const $afe29b7a76094dd0$export$7baa7c13b358b002 = (optionsOrOptionGroups)=>(0, (/*@__PURE__*/$parcel$interopDefault($9OdO2)))(optionsOrOptionGroups.map((optionOrGroup)=>// @ts-expect-error - TS2339 - Property 'options' does not exist on type 'Option | Group'. | TS2339 - Property 'options' does not exist on type 'Option | Group'.
        (0, $1pc0M.isGroup)(optionOrGroup) && optionOrGroup.options ? optionOrGroup.options : optionOrGroup));
const $afe29b7a76094dd0$export$60d56ed3961c839c = (options, query)=>options.filter((option)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase()));
const $afe29b7a76094dd0$export$768714d87d82938f = (selectedOptions)=>{
    if (selectedOptions == null) return [];
    return Array.isArray(selectedOptions) ? selectedOptions : [
        selectedOptions
    ];
};
const $afe29b7a76094dd0$export$d05672fd1312a6d = (val, valueSafeForAnalytics = false)=>valueSafeForAnalytics ? val?.toString() : (0, $azx3n.memoizedHashString)(val?.toString())?.toString();
const $afe29b7a76094dd0$export$fde3d804891b8254 = (items, valuesSafeForAnalytics = false)=>items.filter((item)=>item.value).map(({ value: value })=>$afe29b7a76094dd0$export$d05672fd1312a6d(value, valuesSafeForAnalytics));
const $afe29b7a76094dd0$export$8b176f4924e7119b = (items)=>{
    const optionIds = items.map(({ id: id })=>id || null);
    return optionIds.every((x)=>x === null) ? [] : optionIds;
};
const $afe29b7a76094dd0$export$e2e167245697ed4e = (items)=>items.filter((item)=>item.value).map(({ value: value })=>value != null ? `${value}`.length : 0);

});
parcelRegister("9OdO2", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");

var $eo8NR = parcelRequire("eo8NR");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $72437e2c2a373df9$var$flatMap(collection, iteratee) {
    return $hKE3p($eo8NR(collection, iteratee), 1);
}
module.exports = $72437e2c2a373df9$var$flatMap;

});

parcelRegister("1pc0M", function(module, exports) {

$parcel$export(module.exports, "isGroup", () => $4dd1810c3c4e8cdb$export$d7976824e9f55785);
const $4dd1810c3c4e8cdb$export$d7976824e9f55785 = (optionOrGroup)=>// @ts-expect-error - TS2339 - Property 'options' does not exist on type 'Option | Group'.
    optionOrGroup.options !== undefined;

});




parcelRegister("7nzO5", function(module, exports) {

$parcel$export(module.exports, "defaultSelectStyles", () => $eb823e17d82bde1d$export$b12192ea1a215e5f);
$parcel$export(module.exports, "issueFieldSelectStyles", () => $eb823e17d82bde1d$export$ab8d0ae91aee120c);
$parcel$export(module.exports, "OptionWrapper", () => $eb823e17d82bde1d$export$d6f6a072cce04542);
$parcel$export(module.exports, "FailedFetchOptionWrapper", () => $eb823e17d82bde1d$export$38a1a0a811e06255);
$parcel$export(module.exports, "ImgSpan", () => $eb823e17d82bde1d$export$df67068a00dece12);
$parcel$export(module.exports, "FlexSpan", () => $eb823e17d82bde1d$export$d90eccb59fb62cab);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $eb823e17d82bde1d$export$9e874bb1adc98a55);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $PdmhA = parcelRequire("PdmhA");

var $lDnwy = parcelRequire("lDnwy");

var $c9TLT = parcelRequire("c9TLT");
const $eb823e17d82bde1d$export$b12192ea1a215e5f = {
    multiValue: (base)=>({
            ...base,
            backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA).N20})`
        }),
    option: (base, state)=>({
            ...base,
            ...(0, $lDnwy.getOptionBaseStyles)(state),
            cursor: 'pointer',
            ...state.isFocused && !state.isSelected ? {
                backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA).N20})` // so that option does not change color once cursor is moved outside of select
            } : {},
            '&:hover': {
                ...state.isSelected ? {} : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA).N20})`
                },
                ...state.isDisabled ? {
                    backgroundColor: 'transparent',
                    cursor: 'not-allowed'
                } : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {}
            }
        }),
    menu: (base)=>({
            ...base,
            // without properly set zIndex value dropdown with options is cut inside modal dialogs
            zIndex: (0, $c9TLT.layers).modal
        }),
    menuPortal: (base)=>({
            ...base,
            // Safari fix - otherwise dropdown menu will be shown below elements which have transform: translateZ set: https://github.com/JedWatson/react-select/issues/1010, BENTO-5741
            transform: 'translateZ(0)',
            // without properly set zIndex value dropdown with options is behind containers with a higher zIndex
            zIndex: (0, $c9TLT.layers).modal
        })
};
const $eb823e17d82bde1d$export$ab8d0ae91aee120c = {
    indicatorsContainer: (base)=>({
            ...base,
            paddingRight: "var(--ds-space-050, 4px)" // this is fixed in ak/select v10.2.0 and will no longer be needed
        }),
    // need to apply same padding to both loadingIndicator and clearIndicator - not to have input query jumping between lines e.g. in multi-select
    loadingIndicator: (base)=>({
            ...base,
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-050, 4px)"
        }),
    clearIndicator: (base)=>({
            ...base,
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-050, 4px)"
        }),
    dropdownIndicator: (base)=>({
            ...base,
            display: 'none' // there seems to be no way to keep dropdown open on option selected (which we do in multi-select field), but closed on dropdownIndicator icon click. Because both call ony onMenuClose() without any params to distinguish the source of the call
        })
};
const $eb823e17d82bde1d$export$d6f6a072cce04542 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $eb823e17d82bde1d$export$38a1a0a811e06255 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $eb823e17d82bde1d$export$d6f6a072cce04542, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bah1h6o _o5724jg8 _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $eb823e17d82bde1d$export$df67068a00dece12 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $eb823e17d82bde1d$export$d90eccb59fb62cab = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $eb823e17d82bde1d$export$9e874bb1adc98a55 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { errorMessagePosition: errorMessagePosition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_a56l1wug",
            __cmplp.errorMessagePosition === 'top' && "_otyr12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lDnwy", function(module, exports) {

$parcel$export(module.exports, "getOptionBaseStyles", () => $2d2d94270c4a127f$export$cef6e25059b681a);
$parcel$export(module.exports, "Picker", () => $2d2d94270c4a127f$export$ba25329847403e11);
$parcel$export(module.exports, "default", () => $2d2d94270c4a127f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dxIU5 = parcelRequire("dxIU5");

var $jG2Eu = parcelRequire("jG2Eu");

var $bbaTG = parcelRequire("bbaTG");

var $29yDk = parcelRequire("29yDk");

var $2II8o = parcelRequire("2II8o");
var $aBv1q = parcelRequire("aBv1q");
var $jQxSL = parcelRequire("jQxSL");
var $1EOkb = parcelRequire("1EOkb");
var $4zgIJ = parcelRequire("4zgIJ");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $3Hawu = parcelRequire("3Hawu");

var $bujW1 = parcelRequire("bujW1");

var $c9TLT = parcelRequire("c9TLT");

var $dzpl6 = parcelRequire("dzpl6");

var $giAhk = parcelRequire("giAhk");

var $9JyRh = parcelRequire("9JyRh");
const $2d2d94270c4a127f$export$3a3072dd741f354b = 500;
const $2d2d94270c4a127f$var$Clear = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ...props,
        theme: (0, $dzpl6.getTheme)({
            buttonStyles: {
                link: {
                    borderRadius: 0,
                    borderBottom: `${(0, $c9TLT.gridSize) * 0.25}px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $PdmhA).N40})`}`,
                    height: 'auto',
                    /*
       * Button doesn't have any top/bottom padding so moving it up a bit using a negative margin
       * is the most convenient way to fix its appearance inside the dropdown menu which has its own padding.
       */ marginTop: `-${(0, $c9TLT.gridSize) * 0.7}px`,
                    marginBottom: "var(--ds-space-050, 4px)",
                    textAlign: 'left'
                }
            }
        })
    });
const $2d2d94270c4a127f$export$cef6e25059b681a = (optionState)=>({
        ...optionState.isDisabled ? {
            cursor: 'not-allowed',
            color: `var(--ds-text-subtlest, ${(0, $PdmhA).N90})`,
            '&, :active': {
                backgroundColor: 'transparent'
            }
        } : {
            cursor: 'pointer'
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
class $2d2d94270c4a127f$export$ba25329847403e11 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: false,
            isCompact: false,
            isCreatable: false,
            isMulti: false,
            noPortal: false,
            isCheckbox: false,
            label: '',
            defaultValue: undefined,
            width: 'auto',
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onMultiSelected: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    static getDerivedStateFromProps(props) {
        if (props.menuIsOpen !== undefined) return {
            menuIsOpen: props.menuIsOpen
        };
        return null;
    }
    constructor(props){
        super(props); // This is initialized in constructor because when it is a class property then flow gets confused about the generic type in callback.
        this.state = {
            validationState: 'default',
            showErrorMessage: false,
            menuWasOpen: false,
            menuIsOpen: false,
            initialFocusHandled: false
        };
        this.onSelected = (selection, action, analyticsEvent)=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
            const { isMulti: isMulti } = this.props;
            if (Array.isArray(selection)) {
                if (isMulti) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                this.props.onMultiSelected(selection, analyticsEvent);
                else // When the selection is cleared in single select mode, selection is an array.
                this.props.onSelected(undefined, analyticsEvent);
            } else // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'SelectOption'.
            selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
        };
        this.onMenuOpen = ()=>{
            this.setState(()=>({
                    menuIsOpen: true,
                    menuWasOpen: true
                }));
        };
        this.onMenuClose = ()=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
        };
        this.onBlur = (event)=>{
            this.hideErrorMessage();
            const { onBlur: onBlur } = this.props;
            if (onBlur && typeof onBlur === 'function') onBlur(event);
        };
        this.onFocus = (event)=>{
            this.showErrorMessage();
            const { onFocus: onFocus } = this.props;
            if (onFocus && typeof onFocus === 'function') onFocus(event);
        };
        this.setErrorState = ()=>{
            this.setState({
                showErrorMessage: true,
                validationState: 'error'
            });
        };
        this.showErrorMessage = ()=>this.setState({
                showErrorMessage: true
            });
        this.hideErrorMessage = ()=>this.setState({
                showErrorMessage: false
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ;
        this.loadOptions = (filter, callback)=>{
            this.setState({
                validationState: 'default'
            });
            this.debouncedLoadOptions(filter, callback);
        };
        this.renderOption = (props)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const propsData = props.data;
            const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                position: "right",
                content: disableReason
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , props));
        };
        this.renderMenuList = (menuListProps)=>{
            const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
            return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; hasValue: boolean; clearValue: () => void; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': cx, getStyles, getValue, isMulti, and 6 more.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MenuList, menuListProps, isClearable && menuListProps.hasValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2d2d94270c4a127f$var$Clear, {
                appearance: "link",
                shouldFitContainer: true,
                onClick: menuListProps.clearValue
            }, formatMessage((0, $9JyRh.default).clearSelected)), menuListProps.children));
        };
        this.renderValueContainer = (props)=>{
            const { onValueContainerClick: onValueContainerClick } = props.selectProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2d2d94270c4a127f$var$StyledValueContainer, {
                "data-testid": "common-components-picker.base.react-dnd-and-select-focus-bug-fix",
                onClick: onValueContainerClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).ValueContainer, props));
        };
        // That is a known bug: https://github.com/facebook/flow/issues/6978
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter, callback)=>{
            // @ts-expect-error - TS2349 - This expression is not callable.
            this.props.options(filter).then(callback, ()=>{
                callback([]);
                this.setErrorState();
            });
        }, $2d2d94270c4a127f$export$3a3072dd741f354b); // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
        this.selectRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
    }
    getSelectComponent(isAsync) {
        if (this.props.isCreatable) return isAsync ? (0, $2II8o.default) : (0, $1EOkb.default);
        if (isAsync) return 0, $3Hawu.AsyncSelectWithAnalytics;
        return this.props.isCheckbox ? (0, $aBv1q.default) : (0, $4zgIJ.default);
    }
    getComponentOverrides() {
        const { menuWasOpen: menuWasOpen } = this.state;
        const Option = {
            Option: this.renderOption
        };
        const MenuList = {
            MenuList: this.renderMenuList
        };
        const LoadingIndicator = menuWasOpen ? {} : {
            LoadingIndicator: null
        };
        return {
            ...Option,
            ...MenuList,
            ...LoadingIndicator
        };
    }
    render() {
        const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, $9JyRh.default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
        const isAsync = typeof options === 'function';
        const SelectComponent = this.getSelectComponent(isAsync);
        const isErrorMessageOpened = showErrorMessage && validationState === 'error';
        let selectParams = {
            placeholder: placeholder,
            isDisabled: isDisabled,
            isClearable: isClearableWithCrossIcon || false,
            defaultValue: defaultValue,
            defaultOptions: true,
            autoFocus: !!this.props.autoFocus,
            loadOptions: isAsync && this.loadOptions,
            options: !isAsync && options,
            onChange: this.onSelected,
            noOptionsMessage: ()=>formatMessage((0, $9JyRh.default).noOptions),
            loadingMessage: ()=>formatMessage((0, $9JyRh.default).loading),
            validationState: this.state.validationState,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            menuPortalTarget: noPortal ? null : document.body,
            spacing: isCompact ? 'compact' : 'default',
            styles: {
                // without properly set zIndex value dropdown with options is cut inside modal dialogs
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $c9TLT.layers).modal
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                container: (base)=>({
                        ...base,
                        width: width,
                        minWidth: minWidth
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                option: (base, optionState)=>({
                        ...base,
                        ...$2d2d94270c4a127f$export$cef6e25059b681a(optionState),
                        ...listItemCustomStyles
                    })
            }
        };
        if (!isCheckbox) selectParams = {
            ...selectParams,
            menuIsOpen: // @ts-expect-error - TS2322 - Type '{ menuIsOpen: boolean; onMenuOpen: () => void; onMenuClose: () => void; components: { LoadingIndicator?: undefined; MenuList: (menuListProps: MenuListProps) => JSX.Element; Option: (props: CommonProps<...> & ... 1 more ... & { ...; }) => JSX.Element; } | { ...; }; ... 16 more ...; styles: { ...; }; }' is not assignable to type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'.
            menuIsOpen,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            components: this.getComponentOverrides()
        };
         // When "hasDraggableParentComponent" is true, this means <Select /> is nested inside <Draggable /> from react-beautiful-dnd
        // This relationship prevents the dropdown menu from opening because of bugs in the default focus state and clicking in a particular area of <Select />
        // Context: https://hello.atlassian.net/wiki/spaces/~989411314/pages/2861097485/Investigation+Notes+for+atlaskit+select+react-beautiful-dnd#Temporary-Solution
        if (hasDraggableParentComponent) {
            const { initialFocusHandled: initialFocusHandled } = this.state;
            const handleClick = ()=>{
                if (initialFocusHandled) // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                this.setState((state)=>({
                        menuIsOpen: !state.menuIsOpen
                    }));
                else if (!menuIsOpen) {
                    // Trigger focus state when ValueContainer is clicked for the first time
                    // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                    // to manage the state of the dropdown menu
                    // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                    this.selectRef.current.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            selectParams = {
                ...selectParams,
                // @ts-expect-error - Object literal may only specify known properties, and 'ref' does not exist in type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'
                // + Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                ref: this.selectRef,
                components: {
                    ...this.getComponentOverrides,
                    ValueContainer: this.renderValueContainer
                },
                onValueContainerClick: handleClick,
                openMenuOnFocus: true
            };
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bujW1.default), {
            htmlFor: this.props.inputId,
            label: label,
            isRequired: isRequired
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
            content: errorMessage,
            isOpen: isErrorMessageOpened,
            placement: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectComponent, {
            inputId: this.props.inputId,
            ...this.props,
            ...selectParams,
            options: isAsync ? undefined : this.props.options
        })));
    }
}
var // @ts-expect-error - TS2345 - Argument of type 'typeof Picker' is not assignable to parameter of type 'ComponentType<Record<any, any>>'.
$2d2d94270c4a127f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($2d2d94270c4a127f$export$ba25329847403e11);
const $2d2d94270c4a127f$var$StyledValueContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2II8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fb1ecfe0c79aacc$export$2e2bcd8739ae039);

var $03F4S = parcelRequire("03F4S");

var $bSpUS = parcelRequire("bSpUS");
var $1fb1ecfe0c79aacc$export$2e2bcd8739ae039 = (0, $bSpUS.default)((0, $03F4S.default));

});
parcelRegister("03F4S", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b02518902b6778$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $3IL7Z = parcelRequire("3IL7Z");

var $7IqRg = parcelRequire("7IqRg");

var $6xNN4 = parcelRequire("6xNN4");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $00b02518902b6778$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var stateManagerProps = (0, $3IL7Z.u)(props);
    var creatableProps = (0, $7IqRg.u)(stateManagerProps);
    var selectProps = (0, $6xNN4.u)(creatableProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $00b02518902b6778$export$2e2bcd8739ae039 = $00b02518902b6778$var$AsyncCreatableSelect;

});
parcelRegister("3IL7Z", function(module, exports) {

$parcel$export(module.exports, "u", () => $2b5a09c16d37496a$export$3b14a55fb2447963);

var $5zQU9 = parcelRequire("5zQU9");

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
var $2b5a09c16d37496a$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $2b5a09c16d37496a$export$3b14a55fb2447963(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $bwPfh.default)(_ref, $2b5a09c16d37496a$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $eUqFw.useRef)(undefined);
    var mounted = (0, $eUqFw.useRef)(false);
    var _useState = (0, $eUqFw.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $aKcqM.default)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsDefaultOptions === true), _useState6 = (0, $aKcqM.default)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $eUqFw.useState)(undefined), _useState8 = (0, $aKcqM.default)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $eUqFw.useState)([]), _useState10 = (0, $aKcqM.default)(_useState9, 2), loadedOptions = _useState10[0], setLoadedOptions = _useState10[1];
    var _useState11 = (0, $eUqFw.useState)(false), _useState12 = (0, $aKcqM.default)(_useState11, 2), passEmptyOptions = _useState12[0], setPassEmptyOptions = _useState12[1];
    var _useState13 = (0, $eUqFw.useState)({}), _useState14 = (0, $aKcqM.default)(_useState13, 2), optionsCache = _useState14[0], setOptionsCache = _useState14[1];
    var _useState15 = (0, $eUqFw.useState)(undefined), _useState16 = (0, $aKcqM.default)(_useState15, 2), prevDefaultOptions = _useState16[0], setPrevDefaultOptions = _useState16[1];
    var _useState17 = (0, $eUqFw.useState)(undefined), _useState18 = (0, $aKcqM.default)(_useState17, 2), prevCacheOptions = _useState18[0], setPrevCacheOptions = _useState18[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $eUqFw.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $eUqFw.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $jQxSL.L)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, $1Xn5q.default)((0, $1Xn5q.default)({}, optionsCache), {}, (0, $5zQU9.default)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});



parcelRegister("3Hawu", function(module, exports) {

$parcel$export(module.exports, "AsyncSelectWithAnalytics", () => $7680050c258e1266$export$ee664e5add893f9);

var $lXktr = parcelRequire("lXktr");

var $eGI9v = parcelRequire("eGI9v");
const $7680050c258e1266$export$ee664e5add893f9 = (0, $eGI9v.default)('select', {
    onChange: 'changed'
})((0, $lXktr.default));

});
parcelRegister("lXktr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffbefd51a1e8f957$export$2e2bcd8739ae039);

var $hgTYM = parcelRequire("hgTYM");

var $bSpUS = parcelRequire("bSpUS");
var $ffbefd51a1e8f957$export$2e2bcd8739ae039 = (0, $bSpUS.default)((0, $hgTYM.default));

});
parcelRegister("hgTYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c92f5a99b4ea3691$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("3IL7Z")).u);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $7IqRg = parcelRequire("7IqRg");

var $3IL7Z = parcelRequire("3IL7Z");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $c92f5a99b4ea3691$var$AsyncSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var stateManagedProps = (0, $3IL7Z.u)(props);
    var selectProps = (0, $7IqRg.u)(stateManagedProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $c92f5a99b4ea3691$export$2e2bcd8739ae039 = $c92f5a99b4ea3691$var$AsyncSelect;

});



parcelRegister("bujW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1634e0d0f9f8a3e7$export$2e2bcd8739ae039);

var $8BJaJ = parcelRequire("8BJaJ");
var $1634e0d0f9f8a3e7$export$2e2bcd8739ae039 = (0, $8BJaJ.FieldLabel);

});
parcelRegister("8BJaJ", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $816236d547316819$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");

var $c9TLT = parcelRequire("c9TLT");
const $816236d547316819$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$LabelText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$RequiredIndicator, {
        role: "presentation"
    }, "*") : null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $816236d547316819$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $816236d547316819$var$LabelText = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-9kgl5s-0"
})`${(0, $4lTFP.h200)()} display:block;font-family:${(0, $c9TLT.fontFamily)};margin:0;${// eslint-disable-next-line jira/compiled/styled-components-usages
(0, $kwce8.css)({
    padding: `${"var(--ds-space-250, 20px)"} 0px ${"var(--ds-space-050, 4px)"} 0px`
})}`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $816236d547316819$var$RequiredIndicator = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-9kgl5s-1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-danger, ${(0, $PdmhA).R400})`,
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    paddingLeft: "var(--ds-space-025, 2px)"
});
$816236d547316819$var$RequiredIndicator.displayName = 'RequiredIndicator';

});


parcelRegister("dzpl6", function(module, exports) {

$parcel$export(module.exports, "getTheme", () => $55e2e88bfdce03b8$export$89cbf1a0881c8b9c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // @ts-expect-error - TS2614 - Module '"@atlaskit/button"' has no exported member 'ButtonTheme'. Did you mean to use 'import ButtonTheme from "@atlaskit/button"' instead?

var $PdmhA = parcelRequire("PdmhA");
const $55e2e88bfdce03b8$export$9e61512f2dc2cbb0 = (currentTheme, props)=>{
    const { buttonStyles: buttonStyles, ...rest } = currentTheme(props);
    const theme = {
        ...rest,
        buttonStyles: {
            ...buttonStyles,
            backgroundColor: (0, $PdmhA).P400,
            '> span': {
                color: (0, $PdmhA).N0
            }
        }
    };
    return theme;
};
const $55e2e88bfdce03b8$export$f9380c9a627682d3 = (newTheme, themeProps)=>{
    const { appearance: appearance, mode: mode, state: state } = themeProps;
    if (!appearance || !newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    // @ts-expect-error - TS2739 - Type 'Record<string, any>' is missing the following properties from type 'ThemeTokens': buttonStyles, spinnerStyles
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!item) return;
            if (!node[item] && node[item] !== 0) return;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return;
            }
            // @ts-expect-error - TS2322 - Type 'string | number | { [key: string]: string | number; } | T' is not assignable to type '{ [key: string]: string | number; } | T'.
            node = node[item];
        });
        return acc;
    }, {});
};
const $55e2e88bfdce03b8$export$89cbf1a0881c8b9c = (overrides)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        // @ts-expect-error - TS2322 - Type 'Record<string, any>' is not assignable to type 'ThemeTokens'.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const styles = Object.entries(theme).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            if (!overrides?.[key]) {
                acc[key] = value;
                return acc;
            }
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            const overriddenStyles = $55e2e88bfdce03b8$export$f9380c9a627682d3(overrides[key], themeProps);
            acc[key] = {
                ...value,
                ...overriddenStyles
            };
            return acc;
        }, {});
        return styles;
    };

});



parcelRegister("52Iro", function(module, exports) {

$parcel$export(module.exports, "mergeReactSelectStyles", () => $7040b57e4bb56132$export$29d31ac2c000a524);
const $7040b57e4bb56132$export$29d31ac2c000a524 = (styles, ...stylesToMergeArray)=>{
    const originalStyles = styles || {};
    if (stylesToMergeArray.length === 0) return originalStyles;
    const result = {
        ...originalStyles
    };
    stylesToMergeArray.forEach((stylesToMerge)=>{
        if (!stylesToMerge) return;
        Object.keys(stylesToMerge).forEach((key)=>{
            const currentStyleFunction = result[key];
            const styleFunctionToMerge = stylesToMerge[key];
            if (currentStyleFunction) // stylesToMerge should override originalStyles css props if they overlap (because stylesToMerge are passed from props), that's why we call it last
            // @ts-expect-error - TS2322 - Type '(base: AkSelectStyles, state: SelectElementState) => ElementStyles' is not assignable to type '(providedStyles: ElementStyles, state: SelectElementState) => ElementStyles'.
            result[key] = (base, ...otherArgs)=>// @ts-expect-error - TS2345 - Argument of type 'AkSelectStyles' is not assignable to parameter of type 'ElementStyles'.
                styleFunctionToMerge(currentStyleFunction(base, ...otherArgs), ...otherArgs);
            else result[key] = styleFunctionToMerge;
        });
    });
    return result;
};

});


parcelRegister("uj4Ix", function(module, exports) {

$parcel$export(module.exports, "readViewContainerSelectorName", () => $946a0c666a8aa4b0$export$195ee2a97947e11b);
$parcel$export(module.exports, "ReadViewContainer", () => $946a0c666a8aa4b0$export$ebb3489b83262b26);
$parcel$export(module.exports, "LozengeWrapper", () => $946a0c666a8aa4b0$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "InlineEditContainer", () => $946a0c666a8aa4b0$export$9f16bbb9a44c7bf6);
$parcel$export(module.exports, "SelectFieldViewContainer", () => $946a0c666a8aa4b0$export$e119ef2d6ebe4016);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $946a0c666a8aa4b0$export$195ee2a97947e11b = 'jira-issue-view-select-inline-edit-read-view-container';
const $946a0c666a8aa4b0$var$READ_VIEW_CONTAINER_COMPONENT_SELECTOR = `[data-component-selector="${$946a0c666a8aa4b0$export$195ee2a97947e11b}"]`;
const $946a0c666a8aa4b0$export$ebb3489b83262b26 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _1nmz1hna _kqswh2mm _vwz48sxn",
            __cmplp.className
        ])
    });
});
const $946a0c666a8aa4b0$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $946a0c666a8aa4b0$var$nonEditableStyles = {
    [$946a0c666a8aa4b0$var$READ_VIEW_CONTAINER_COMPONENT_SELECTOR]: {
        /* First tag is always mis-aligned so use the container padding to position the field */ paddingLeft: "var(--ds-space-075, 6px)"
    }
};
const $946a0c666a8aa4b0$export$9f16bbb9a44c7bf6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _18u0x0bf _19pkx0bf _1gzc1txw _auuz1h6o _6vgs1osq _1rjezwfg _osjgidpf _alyvidpf _pa3x12x7 _2g9bidpf",
            !__cmplp.isEditable && "_mqi112x7",
            __cmplp.className
        ])
    });
});
const $946a0c666a8aa4b0$export$e119ef2d6ebe4016 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vuuczwfg",
            __cmplp.className
        ])
    });
});

});



parcelRegister("fNcqT", function(module, exports) {

$parcel$export(module.exports, "ComponentTag", () => $7bbe994559fff4f8$export$622eeeb4edc41d63);
/* component-tag.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9jNAz = parcelRequire("9jNAz");

var $7DokK = parcelRequire("7DokK");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $7bbe994559fff4f8$var$getComponentTag = (isGlobalComponent, isGlobalComponentsEnabled, createAnalyticsEvent)=>{
    if (isGlobalComponentsEnabled) {
        if (isGlobalComponent) return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7bbe994559fff4f8$var$EnabledGlobalComponentTag, {
                ...props,
                "data-testid": "issue-view-base.context.components.enabled-global-component-tag",
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'compassComponentLink');
                }
            });
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7bbe994559fff4f8$var$DisabledProjectComponentTag, {
                ...props,
                "data-testid": "issue-view-base.context.components.disabled-project-component-tag"
            });
    }
    if (isGlobalComponent) return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7bbe994559fff4f8$var$DisabledGlobalComponentTag, {
            ...props,
            "data-testid": "issue-view-base.context.components.disabled-global-component-tag"
        });
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7bbe994559fff4f8$var$EnabledProjectComponentTag, {
            ...props,
            "data-testid": "issue-view-base.context.components.enabled-project-component-tag"
        });
};
const $7bbe994559fff4f8$export$622eeeb4edc41d63 = (props)=>{
    const { item: item, globalComponentsEnabled: globalComponentsEnabled } = props;
    const isGlobalComponent = typeof item.ari === 'string' && item.metadata?.typeId !== undefined;
    const isDisabledComponent = isGlobalComponent ? !globalComponentsEnabled : globalComponentsEnabled;
    const componentId = item.ari && (0, $7DokK.getIdFromAri)(item.ari);
    const text = 'content' in item ? item.content : item.label;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const TagComponent = $7bbe994559fff4f8$var$getComponentTag(isGlobalComponent, globalComponentsEnabled, createAnalyticsEvent);
    const renderComponentIcon = (isOpaque)=>{
        const typeId = item?.metadata?.typeId?.replaceAll('_', '-').toLowerCase() || 'other';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7bbe994559fff4f8$export$6cad5d2db58c0e19, {
            src: `https://compass-ui.prod-east.frontend.public.atl-paas.net/assets/${typeId}.svg`,
            height: 16,
            width: 16,
            isOpaque: isOpaque,
            alt: typeId
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        text: text,
        href: isGlobalComponent && componentId ? `/compass/component/${componentId}` : item.href,
        linkComponent: TagComponent,
        elemBefore: isGlobalComponent ? renderComponentIcon(isDisabledComponent && isGlobalComponent) : item.elemBefore
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7bbe994559fff4f8$var$EnabledGlobalComponentTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bvu2gc _ca0qv77o _syaz1y58 _p12f10bg _9oik18uv _1bnx8stv _jf4cnqa1 _d0altlke",
            __cmplp.className
        ])
    });
});
const $7bbe994559fff4f8$var$DisabledGlobalComponentTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itglyw _11q7glyw _19bvu2gc _ca0qv77o _syaz1kdx _p12f10bg _d0altlke _9oik18uv _1bnxglyw _jf4cnqa1 _30l3aqb7",
            __cmplp.className
        ])
    });
});
const $7bbe994559fff4f8$var$EnabledProjectComponentTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qv77o _syaz1dx5 _9oik18uv _1bnx8stv _jf4cnqa1 _d0altlke",
            __cmplp.className
        ])
    });
});
const $7bbe994559fff4f8$var$DisabledProjectComponentTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itglyw _11q7glyw _ca0qv77o _syaz1kdx _d0altlke _9oik18uv _1bnxglyw _jf4cnqa1 _30l3bfqm",
            __cmplp.className
        ])
    });
});
const $7bbe994559fff4f8$export$6cad5d2db58c0e19 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpaque: isOpaque, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bv1b66 _ca0qv77o",
            __cmplp.isOpaque ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7DokK", function(module, exports) {

$parcel$export(module.exports, "getColorForProgress", () => $58ab428192c64887$export$58950a4b8fb8acf4);
$parcel$export(module.exports, "getScorecardHealthCountsFromScores", () => $58ab428192c64887$export$a64a7643d5a3fae);
$parcel$export(module.exports, "getSummaryText", () => $58ab428192c64887$export$d48af90fda49897);
$parcel$export(module.exports, "getScorecardsSortedByHealth", () => $58ab428192c64887$export$6e2af0614a0d9b67);
$parcel$export(module.exports, "getIdFromAri", () => $58ab428192c64887$export$79640a85913af5aa);

var $PdmhA = parcelRequire("PdmhA");

var $84JxC = parcelRequire("84JxC");
const $58ab428192c64887$export$aa91e30498abc411 = {
    FAILING: 0,
    NEEDS_ATTENTION: 50,
    PASSING: 100
};
const $58ab428192c64887$var$COLOR_RANGES = [
    {
        start: $58ab428192c64887$export$aa91e30498abc411.FAILING,
        end: $58ab428192c64887$export$aa91e30498abc411.NEEDS_ATTENTION - 1,
        color: (0, $PdmhA).R300
    },
    {
        start: $58ab428192c64887$export$aa91e30498abc411.NEEDS_ATTENTION,
        end: $58ab428192c64887$export$aa91e30498abc411.PASSING - 1,
        color: (0, $PdmhA).Y300
    },
    {
        start: $58ab428192c64887$export$aa91e30498abc411.PASSING,
        end: $58ab428192c64887$export$aa91e30498abc411.PASSING,
        color: (0, $PdmhA).G300
    }
];
const $58ab428192c64887$export$58950a4b8fb8acf4 = (progress)=>{
    for (const { start: start, end: end, color: color } of $58ab428192c64887$var$COLOR_RANGES){
        if (progress >= start && progress <= end) return color;
    }
    // Default.
    return (0, $PdmhA).R300;
};
const $58ab428192c64887$export$921f23fa0f13f23e = 90;
const $58ab428192c64887$export$69a1d9a35c04a358 = 50;
const $58ab428192c64887$export$a64a7643d5a3fae = (scorecardScores)=>{
    let failingScorecards = 0;
    let needsAttentionScorecards = 0;
    let totalScorecards = 0;
    scorecardScores.forEach((scorecardScore)=>{
        const totalScore = scorecardScore?.totalScore ?? 0;
        totalScorecards += 1;
        if (totalScore < $58ab428192c64887$export$69a1d9a35c04a358) failingScorecards += 1;
        else if (totalScore >= $58ab428192c64887$export$69a1d9a35c04a358 && totalScore < $58ab428192c64887$export$921f23fa0f13f23e) needsAttentionScorecards += 1;
    });
    return {
        total: totalScorecards,
        passing: totalScorecards - failingScorecards - needsAttentionScorecards,
        needsAttention: needsAttentionScorecards
    };
};
const $58ab428192c64887$export$d48af90fda49897 = (scorecardHealthCount, totalScorecardsCount, formatMessage)=>{
    const { passing: passing } = scorecardHealthCount;
    const { needsAttention: needsAttention } = scorecardHealthCount;
    let numerator = 0;
    let message;
    if (passing === 0 && totalScorecardsCount === 0) message = (0, $84JxC.default).noScorecards;
    else if (passing + needsAttention < totalScorecardsCount) {
        numerator = Math.floor(totalScorecardsCount) - Math.floor(passing) - Math.floor(needsAttention);
        message = (0, $84JxC.default).summaryTextForFailing;
    } else if (needsAttention > 0) {
        numerator = Math.floor(needsAttention);
        message = (0, $84JxC.default).summaryTextForNeedsAttention;
    } else {
        numerator = Math.floor(totalScorecardsCount);
        message = (0, $84JxC.default).summaryTextForHealthy;
    }
    return formatMessage(message, {
        numerator: numerator
    });
};
const $58ab428192c64887$export$6e2af0614a0d9b67 = (scorecards)=>[
        ...scorecards
    ].sort((a, b)=>{
        const aTotalScore = a?.scorecardScore?.totalScore ?? 0;
        const bTotalScore = b?.scorecardScore?.totalScore ?? 0;
        return aTotalScore - bTotalScore;
    });
function $58ab428192c64887$export$79640a85913af5aa(ari) {
    const regex = /\/([\w-]+)$/; // Matches the id at the end of the string
    const match = ari.match(regex);
    return match ? match[1] : '';
}

});
parcelRegister("84JxC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fef52355ba5b93b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8fef52355ba5b93b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noScorecards: {
        "id": "compass-common.common.no-scorecards",
        "defaultMessage": "No scorecards"
    },
    summaryTextForFailing: {
        "id": "compass-common.common.summary-text-for-failing",
        "defaultMessage": "{numerator} {numerator, plural, one {failing} other {failing}}"
    },
    summaryTextForHealthy: {
        "id": "compass-common.common.summary-text-for-healthy",
        "defaultMessage": "All passing"
    },
    summaryTextForNeedsAttention: {
        "id": "compass-common.common.summary-text-for-needs-attention",
        "defaultMessage": "{numerator} {numerator, plural, one {needs} other {need}} attention"
    }
});

});





parcelRegister("7PGxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $0585fa737ce1927b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $d0sq6 = parcelRequire("d0sq6");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $hHKWU = parcelRequire("hHKWU");

var $lqalZ = parcelRequire("lqalZ");

var $9F6MO = parcelRequire("9F6MO");
const $0585fa737ce1927b$export$3b6333c79357da19 = ({ isVisible: isVisible = true, area: area, fieldId: fieldId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), null, isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d0sq6.AsyncConferenceCallField), {
        fieldId: fieldId,
        showPinButton: (0, $hHKWU.default)(area)
    }));
var $0585fa737ce1927b$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state)=>({
        isVisible: (0, $9F6MO.canUseServiceDeskAgentFeaturesSelector)(state)
    }), {})($0585fa737ce1927b$export$3b6333c79357da19);

});
parcelRegister("d0sq6", function(module, exports) {

$parcel$export(module.exports, "AsyncConferenceCallField", () => $945feeeb4ea08478$export$3400a487303e28f);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $9IbuV = parcelRequire("9IbuV");

var $3ATPh = parcelRequire("3ATPh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $945feeeb4ea08478$var$LazyConferenceCallField = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("7UvB2")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/incident-management/issue-view/conference-call/src/ui/conference-call-field/index.tsx"
});
const $945feeeb4ea08478$export$3400a487303e28f = (props)=>{
    (0, $9IbuV.useUFOComponentExperience)((0, $3ATPh.jsmConferenceCallExperience));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "servicedesk-incident-management-conference-call-field",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($945feeeb4ea08478$var$LazyConferenceCallField, props));
};

});
parcelRegister("3ATPh", function(module, exports) {

$parcel$export(module.exports, "jsmConferenceCallExperience", () => $2f4790754606097e$export$c0ab9539c4bb25f2);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $2f4790754606097e$export$c0ab9539c4bb25f2 = new (0, $kDfSL.UFOExperience)('jsm-conference-call', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("7UvB2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5SjTi');
        const value = parcelRequire('2ZmT9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5SjTi").then(()=>parcelRequire('2ZmT9'));
}

});



parcelRegister("74NI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $75208bb4df681c69$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $2OdyW = parcelRequire("2OdyW");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $lncKX = parcelRequire("lncKX");

var $5JqpU = parcelRequire("5JqpU");

var $9D3Vo = parcelRequire("9D3Vo");

var $7FqHc = parcelRequire("7FqHc");

var $9Nizy = parcelRequire("9Nizy");

var $lkxXF = parcelRequire("lkxXF");

var $RIJ1J = parcelRequire("RIJ1J");

var $55jeu = parcelRequire("55jeu");
const $75208bb4df681c69$var$DEBOUNCE_FETCH_SUGGESTIONS_TIME = 300;
const $75208bb4df681c69$var$getSuggestionUrl = (baseUrl, issueId)=>{
    if (issueId) return `${baseUrl}/rest/servicedesk/1/servicedesk/request/${issueId}/request-types?query=`;
    return null;
};
const $75208bb4df681c69$export$2b81811283cd2d9d = (0, $5iWql.default)((autoCompleteUrl)=>(query)=>{
        if (!autoCompleteUrl) return Promise.resolve([]);
        return (0, $2OdyW.default)(`${autoCompleteUrl}${query}`).then((0, $RIJ1J.transformSuggestions));
    });
const $75208bb4df681c69$export$72a8b15fb4557735 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
{ baseUrl: baseUrl, value: value }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
state)=>{
    const { requestType: requestType } = value;
    const issueId = (0, $5JqpU.issueIdSelector)(state);
    return (0, $lncKX.updateRequestType)(baseUrl, issueId, requestType.id);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $75208bb4df681c69$var$analyticsAttributeIdRetriever = (value)=>value && value.requestType && value.requestType.id;
var $75208bb4df681c69$export$2e2bcd8739ae039 = (0, $3uwfp.default)((_, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $RIJ1J.transformFromStateValue,
        transformToStateValue: $RIJ1J.transformToStateValue,
        saveField: $75208bb4df681c69$export$72a8b15fb4557735,
        additionalProps: (state, intl)=>({
                fetchSuggestions: $75208bb4df681c69$export$2b81811283cd2d9d($75208bb4df681c69$var$getSuggestionUrl((0, $5JqpU.baseUrlSelector)(state), (0, $5JqpU.issueIdSelector)(state))),
                isEditable: (0, $7FqHc.canEditIssuesSelector)(state),
                // remove issueTypeId when cleaning jsm-fix-invalid-request-type-inconsistencies_x7maw
                issueTypeId: (0, $9D3Vo.issueTypeIdSelector)(state),
                issueType: (0, $9Nizy.isJsmFixIncompatibleRequestTypeInconsistenciesEnabled)() && (0, $9D3Vo.issueTypeSelector)(state),
                hasAutocomplete: true,
                placeholder: intl.formatMessage((0, $lkxXF.default).placeholder),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                debounceFetchSuggestionsTime: $75208bb4df681c69$var$DEBOUNCE_FETCH_SUGGESTIONS_TIME,
                analyticsAttributeIdRetriever: $75208bb4df681c69$var$analyticsAttributeIdRetriever,
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            })
    }))((0, $55jeu.RequestTypeField));

});
parcelRegister("lncKX", function(module, exports) {

$parcel$export(module.exports, "updateRequestType", () => $dab224d69c6fe97b$export$f088ce6c741f3719);

var $lRmyA = parcelRequire("lRmyA");
const $dab224d69c6fe97b$export$9d7c743b509e267 = (baseUrl, issueId)=>`${baseUrl}/rest/servicedesk/1/servicedesk/request/${issueId}/request-types/`;
const $dab224d69c6fe97b$export$f088ce6c741f3719 = async (baseUrl, issueId, requestTypeId)=>{
    if (!issueId) throw new Error('Issue ID not available');
    return (0, $lRmyA.performPostRequest)($dab224d69c6fe97b$export$9d7c743b509e267(baseUrl, issueId), {
        body: JSON.stringify({
            rtId: requestTypeId
        })
    });
};

});

parcelRegister("9Nizy", function(module, exports) {

$parcel$export(module.exports, "isModernGlobalIssueCreateTriggerEnabled", () => $48d802f094f8b2ee$export$67305b99ef59566c);
$parcel$export(module.exports, "PlaceHolderTemplateFlags", () => $48d802f094f8b2ee$export$bf10032e4a734a65);
$parcel$export(module.exports, "getPlaceHolderTemplateVariant", () => $48d802f094f8b2ee$export$fb512d5beec30a90);
$parcel$export(module.exports, "isConfluencePageDummyLinkExperiment", () => $48d802f094f8b2ee$export$6e7dfb06c9e45ae7);
$parcel$export(module.exports, "isConfluencePageDummyLinkEnabled", () => $48d802f094f8b2ee$export$ef28379ba310de6e);
$parcel$export(module.exports, "isForgeFixStaleFormatterValueOnChangeEnabled", () => $48d802f094f8b2ee$export$765c98b15ee2232f);
$parcel$export(module.exports, "isPlaceHolderTemplateE2EEnabled", () => $48d802f094f8b2ee$export$4df93ecfbfdca877);
$parcel$export(module.exports, "isCreateLinkedIssueTriggerPointEnabled", () => $48d802f094f8b2ee$export$fa44fb942e45b85d);
$parcel$export(module.exports, "isCustomMessageForLinkingWithoutPermissionsEnabled", () => $48d802f094f8b2ee$export$3068bf83bd6f9396);
$parcel$export(module.exports, "isJsmFixIncompatibleRequestTypeInconsistenciesEnabled", () => $48d802f094f8b2ee$export$733566d04cfe61b1);
$parcel$export(module.exports, "isSearchByEmailInMultiselectUserPickerEnabled", () => $48d802f094f8b2ee$export$da019fa3d31e5c7e);
$parcel$export(module.exports, "isChangeboardingForParentEnabled", () => $48d802f094f8b2ee$export$a0e01c32249a7097);
$parcel$export(module.exports, "isRespondersFieldAvailableInAllProjectsEnabled", () => $48d802f094f8b2ee$export$6f0be57bd65ee8bc);
$parcel$export(module.exports, "isTeamFieldInSubtasksEnabled", () => $48d802f094f8b2ee$export$150e448c819201a7);
$parcel$export(module.exports, "isTeamsCustomFieldTypeEnabled", () => $48d802f094f8b2ee$export$d7d142f5ac020394);
$parcel$export(module.exports, "isHideEpicLinkFromIssueViewForEpicRenamingBetaEnabled", () => $48d802f094f8b2ee$export$73957227bab0d3f7);
$parcel$export(module.exports, "isRemoveParentLinkFromIssueViewEnabled", () => $48d802f094f8b2ee$export$6e06c78fd874f07f);
$parcel$export(module.exports, "isParentInIssueViewEnabled", () => $48d802f094f8b2ee$export$9c7fa56ed1fa2e15);
$parcel$export(module.exports, "isMediaInlineEnabled", () => $48d802f094f8b2ee$export$a3e5d5dfe1ed90ed);
$parcel$export(module.exports, "isSearchByEmailInRequestParticipantsEnabled", () => $48d802f094f8b2ee$export$690dc5ed8282c797);
$parcel$export(module.exports, "isProductsAndEntitlementsMilestone2Enabled", () => $48d802f094f8b2ee$export$9d25c3a3874f1891);

var $1Iui1 = parcelRequire("1Iui1");

var $1ybV0 = parcelRequire("1ybV0");

const $48d802f094f8b2ee$export$67305b99ef59566c = ()=>(0, $1ybV0.ff)('project.config.pce.modern.global-issue-create.trigger', false);
const $48d802f094f8b2ee$export$9ba0da55e7f403e1 = ()=>(0, $1ybV0.ff)('project.config.pce.modern.global-subtask-issue-create-trigger', false);
const $48d802f094f8b2ee$export$bf10032e4a734a65 = {
    CROSS_FLOW: 'jira.issue-view.placeholder-template-cross-flow'
};
const $48d802f094f8b2ee$export$fb512d5beec30a90 = (experiment)=>experiment ? (0, $1ybV0.getMultivariateFeatureFlag)(experiment, (0, $1Iui1.NOT_ENROLLED), [
        (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7),
        (0, $3401608855dcf8dc$export$c52ae1847ec8c2c),
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.NOT_ENROLLED)
    ]) : (0, $1Iui1.NOT_ENROLLED);
const $48d802f094f8b2ee$export$6e7dfb06c9e45ae7 = ()=>[
        (0, $1Iui1.CONTROL),
        (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7)
    ].includes($48d802f094f8b2ee$export$fb512d5beec30a90($48d802f094f8b2ee$export$bf10032e4a734a65.CROSS_FLOW));
const $48d802f094f8b2ee$export$ef28379ba310de6e = (experiment)=>$48d802f094f8b2ee$export$fb512d5beec30a90(experiment) === (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7);
const $48d802f094f8b2ee$export$765c98b15ee2232f = ()=>(0, $1ybV0.ff)('fix-stale-formatter-on-value-change-coming-from-issue-background-refresh_8hluu', false);
const $48d802f094f8b2ee$export$4df93ecfbfdca877 = ()=>(0, $1ybV0.ff)('jira.issue-view.placeholder-template-e2e-iteration', false);
const $48d802f094f8b2ee$export$ca7c31f03d6e8f02 = ()=>(0, $1ybV0.ff)('trello.card.integration.patch', false);
const $48d802f094f8b2ee$export$fa44fb942e45b85d = ()=>(0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view', false);
const $48d802f094f8b2ee$export$dbaf42ba39b66293 = ()=>$48d802f094f8b2ee$export$67305b99ef59566c() && $48d802f094f8b2ee$export$9ba0da55e7f403e1();
const $48d802f094f8b2ee$export$3068bf83bd6f9396 = ()=>(0, $1ybV0.ff)('issue.details.custom-message-for-linking-with-no-permissions_k7qsn', false);
const $48d802f094f8b2ee$export$733566d04cfe61b1 = ()=>(0, $1ybV0.ff)('jsm-fix-invalid-request-type-inconsistencies_x7maw', false);
const $48d802f094f8b2ee$export$da019fa3d31e5c7e = ()=>(0, $1ybV0.ff)('issue-view.enable-search-by-email-in-multiselect-user-picker-field', false);
const $48d802f094f8b2ee$export$a0e01c32249a7097 = ()=>(0, $1ybV0.ff)('parent-field-changeboarding_4ljdy', false);
const $48d802f094f8b2ee$export$6f0be57bd65ee8bc = ()=>(0, $1ybV0.ff)('responders-field-in-all-projects-issues-ui', false);
const $48d802f094f8b2ee$export$150e448c819201a7 = ()=>(0, $1ybV0.ff)('jira.frontend.ptc.team-field-in-subtasks', false);
const $48d802f094f8b2ee$export$d7d142f5ac020394 = ()=>(0, $1ybV0.ff)('jira.teams.enable-new-custom-field-types', false);
const $48d802f094f8b2ee$export$73957227bab0d3f7 = ()=>(0, $1ybV0.ff)('hide-epic-link-from-issue-view-for-epic-renaming-beta_r1g77', false);
const $48d802f094f8b2ee$export$6e06c78fd874f07f = ()=>(0, $1ybV0.ff)('remove-parent-link-from-issue-view_4t7dy', false);
const $48d802f094f8b2ee$export$9c7fa56ed1fa2e15 = ()=>(0, $1ybV0.ff)('parent-field-in-issue-view_x4zn4', false);
const $48d802f094f8b2ee$export$a3e5d5dfe1ed90ed = ()=>(0, $1ybV0.ff)('issue.details.media-inline', false);
const $48d802f094f8b2ee$export$bff466c504f395b3 = ()=>(0, $1ybV0.ff)('issue-update-analytics-events-on-issue-view', false);
const $48d802f094f8b2ee$export$690dc5ed8282c797 = ()=>(0, $1ybV0.ff)('enable-search-by-email-in-request-participants-field_gd9bw', false);
const $48d802f094f8b2ee$export$9d25c3a3874f1891 = ()=>(0, $1ybV0.ff)('products-and-entitlements-m2', false);

});

parcelRegister("lkxXF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba42631bd5161195$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $ba42631bd5161195$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.customer-request-type.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "Select Request Type"
    },
    incompatibleRequestTypeWithHelpLink: {
        "id": "issue.customer-request-type.incompatible-request-type-with-help-link",
        "defaultMessage": "Select a new request type from the dropdown. Request types must have the same issue type as the issue. {learnMore}"
    },
    incompatibleRequestTypeErrorIconLabel: {
        "id": "issue.customer-request-type.incompatible-request-type-error-icon-label",
        "defaultMessage": "Select a new request type from the dropdown. Request types must have the same issue type as the issue."
    },
    learnMoreAboutIncompatibleRequestType: {
        "id": "issue.customer-request-type.learn-more-about-incompatible-request-type",
        "defaultMessage": "Learn more about the connection between issue types and request types."
    },
    noOptions: {
        "id": "issue.customer-request-type.no-options",
        "defaultMessage": "No matches found. Create a new request type with the {issueType} issue type."
    }
});

});

parcelRegister("RIJ1J", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $68ad4e0ac83c2687$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $68ad4e0ac83c2687$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformSuggestions", () => $68ad4e0ac83c2687$export$1d0ee4320c26fb60);
const $68ad4e0ac83c2687$var$toItem = (stateValue)=>{
    /* When the current user cannot see the request type, an error message will be returned. In this case, we want to
    hide the Request type field. */ if (stateValue.errorMessage) return {
        hasError: true
    };
    if (!stateValue.requestType) return null;
    const { icon: icon, issueTypeId: issueTypeId, id: id, name: name } = stateValue.requestType;
    const iconUrl = icon._links.iconUrls['48x48'];
    return {
        issueTypeId: issueTypeId,
        content: name,
        value: id,
        iconUrl: iconUrl
    };
};
const $68ad4e0ac83c2687$var$toSuggestion = (requestType)=>({
        issueTypeId: requestType.issueType.toString(),
        content: requestType.name,
        value: requestType.id,
        iconUrl: requestType.iconUrl
    });
const $68ad4e0ac83c2687$export$cb172b2468ab5652 = (stateValue)=>stateValue && $68ad4e0ac83c2687$var$toItem(stateValue);
const $68ad4e0ac83c2687$export$1cfcb95cb8fbddb3 = (value)=>({
        requestType: {
            icon: {
                _links: {
                    iconUrls: {
                        '48x48': value.iconUrl || ''
                    }
                }
            },
            id: value.value,
            name: value.content,
            issueTypeId: value.issueTypeId
        }
    });
const $68ad4e0ac83c2687$export$1d0ee4320c26fb60 = (suggestionsFromServer)=>{
    const validRequestTypeItems = suggestionsFromServer.validRequestTypes.map($68ad4e0ac83c2687$var$toSuggestion);
    return [
        {
            items: validRequestTypeItems
        }
    ];
};

});

parcelRegister("55jeu", function(module, exports) {

$parcel$export(module.exports, "RequestTypeField", () => $337afb73688ebb90$export$1a5dbbb48aa8b666);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $96IgR = parcelRequire("96IgR");

var $3MV1G = parcelRequire("3MV1G");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jxxzJ = parcelRequire("jxxzJ");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dgw2u = parcelRequire("dgw2u");

var $lI78N = parcelRequire("lI78N");
var $hByPr = parcelRequire("hByPr");

var $9Nizy = parcelRequire("9Nizy");

var $lkxXF = parcelRequire("lkxXF");
const $337afb73688ebb90$var$ErrorIconWithPopup = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [showPopup, setShowPopup] = (0, $eUqFw.useState)(false);
    const learnMoreAboutIncompatibleRequestTypeLink = 'https://support.atlassian.com/jira-service-management-cloud/docs/how-do-workflows-issue-types-and-request-types-connect/';
    const popupContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($337afb73688ebb90$var$InlinePopupContentControl, null, formatMessage((0, $lkxXF.default).incompatibleRequestTypeWithHelpLink, {
        learnMore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dgw2u.ExternalLink), {
            href: learnMoreAboutIncompatibleRequestTypeLink
        }, formatMessage((0, $lkxXF.default).learnMoreAboutIncompatibleRequestType))
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: showPopup,
        onClose: ()=>setShowPopup(false),
        placement: "bottom-start",
        content: ()=>popupContent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($337afb73688ebb90$var$ErrorIconContainer, {
                ...triggerProps,
                onMouseEnter: ()=>{
                    setShowPopup(!showPopup);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA).R500})`,
                size: "medium",
                label: formatMessage((0, $lkxXF.default).incompatibleRequestTypeErrorIconLabel)
            }))
    });
};
const $337afb73688ebb90$var$singleSelectFieldRenderErrorView = ({ iconUrl: iconUrl, content: content })=>{
    if (!iconUrl) return undefined;
    return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($337afb73688ebb90$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lI78N.default), {
            iconUrl: iconUrl,
            content: content
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($337afb73688ebb90$var$ErrorIconWithPopup, null));
};
const $337afb73688ebb90$export$1a5dbbb48aa8b666 = (props)=>{
    const { issueType: issueType, issueTypeId: issueTypeId, ...selectProps } = props;
    const { value: value, onChange: onChange } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isRequestTypeInvalid = value != null && value && issueTypeId !== value.issueTypeId;
    const checkedValue = isRequestTypeInvalid ? null : selectProps.value;
    const isRequestTypeIncompatible = value != null && value && issueType.id !== value.issueTypeId;
    const valueForRequestType = (0, $eUqFw.useMemo)(()=>{
        if (!value || !(0, $9Nizy.isJsmFixIncompatibleRequestTypeInconsistenciesEnabled)()) return value;
        return {
            ...value,
            isInvalid: isRequestTypeIncompatible,
            noOptionsMessage: ()=>formatMessage((0, $lkxXF.default).noOptions, {
                    issueType: issueType.name
                })
        };
    }, [
        isRequestTypeIncompatible,
        value,
        issueType.name,
        formatMessage
    ]);
    const onChangeWithAnalytics = (0, $eUqFw.useCallback)((...args)=>{
        isRequestTypeIncompatible && (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'incompatibleRequestType updated');
        onChange(...args);
    }, [
        createAnalyticsEvent,
        isRequestTypeIncompatible,
        onChange
    ]);
    if (value?.hasError === true) return null;
    const convertedSelectProps = {
        ...selectProps,
        value: (0, $9Nizy.isJsmFixIncompatibleRequestTypeInconsistenciesEnabled)() ? valueForRequestType : checkedValue,
        onChange: (0, $9Nizy.isJsmFixIncompatibleRequestTypeInconsistenciesEnabled)() ? onChangeWithAnalytics : onChange
    };
    if (!(0, $9Nizy.isJsmFixIncompatibleRequestTypeInconsistenciesEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jxxzJ.default), {
        ...convertedSelectProps,
        renderReadView: (0, $hByPr.singleSelectFieldRenderReadView)(checkedValue)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jxxzJ.default), {
        ...convertedSelectProps,
        renderReadView: valueForRequestType?.isInvalid ? $337afb73688ebb90$var$singleSelectFieldRenderErrorView(valueForRequestType) : (0, $hByPr.singleSelectFieldRenderReadView)(valueForRequestType)
    }), valueForRequestType?.isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "incompatibleRequestType",
        sourceType: (0, $41ea3621645e2acc$export$d1123261ca8831d2)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $337afb73688ebb90$var$ErrorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1ick _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $337afb73688ebb90$var$ErrorIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $337afb73688ebb90$var$InlinePopupContentControl = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _zg8l4jg8 _k48p1nn1 _p12f1mjv _1yt4pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jxxzJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $70427907d870389b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3Il9w = parcelRequire("3Il9w");

var $4xwq2 = parcelRequire("4xwq2");

var $3UUH8 = parcelRequire("3UUH8");

var $dAVhd = parcelRequire("dAVhd");
const $70427907d870389b$var$defaultRenderReadView = (props)=>()=>{
        const { value: value, noValueText: noValueText } = props;
        if (value && !Array.isArray(value)) {
            const { iconUrl: iconUrl, content: content } = value;
            if (iconUrl !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Il9w.default), {
                iconUrl: iconUrl
            }, content);
            return content;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), null, noValueText);
    };
const $70427907d870389b$var$SingleSelectInlineEditView = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3UUH8.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type '() => string | JSX.Element' is not assignable to type '() => ReactElement<any, string | JSXElementConstructor<any>>'.
        renderReadView: props.renderReadView || $70427907d870389b$var$defaultRenderReadView(props),
        isMulti: false,
        isInvalid: props.value?.isInvalid,
        noOptionsMessage: (0, $dAVhd.isJsmFixIncompatibleRequestTypeInconsistenciesEnabled)() ? props.value?.noOptionsMessage : undefined
    });
$70427907d870389b$var$SingleSelectInlineEditView.displayName = 'SingleSelectInlineEditView';
var $70427907d870389b$export$2e2bcd8739ae039 = $70427907d870389b$var$SingleSelectInlineEditView;

});
parcelRegister("3Il9w", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdae31d75a9fc657$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hnzPP = parcelRequire("hnzPP");
function $fdae31d75a9fc657$export$2e2bcd8739ae039(props) {
    const { children: children, iconTitle: iconTitle, iconUrl: iconUrl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fdae31d75a9fc657$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
        url: iconUrl,
        title: iconTitle,
        alt: iconTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fdae31d75a9fc657$var$Text, null, children));
}
$fdae31d75a9fc657$export$2e2bcd8739ae039.defaultProps = {
    iconUrl: undefined,
    iconTitle: ''
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fdae31d75a9fc657$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $fdae31d75a9fc657$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});

});


parcelRegister("dgw2u", function(module, exports) {

$parcel$export(module.exports, "ExternalLink", () => $d97c0d35b5876450$export$b2bf131c9f9cce5d);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const $d97c0d35b5876450$export$b2bf131c9f9cce5d = ({ enabled: enabled = true, href: href, children: children = null, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        rel: "noreferrer",
        href: href,
        target: "_blank",
        onClick: onClick
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);

});

parcelRegister("lI78N", function(module, exports) {

$parcel$export(module.exports, "default", () => $47d43750c2da5c7f$export$2e2bcd8739ae039);

var $hByPr = parcelRequire("hByPr");
var $47d43750c2da5c7f$export$2e2bcd8739ae039 = (0, $hByPr.default);

});
parcelRegister("hByPr", function(module, exports) {

$parcel$export(module.exports, "singleSelectFieldRenderReadView", () => $73b196b5be3a46e4$export$b9d94102320aea17);
$parcel$export(module.exports, "default", () => $73b196b5be3a46e4$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hnzPP = parcelRequire("hnzPP");
const $73b196b5be3a46e4$export$ca47fb9544dbee74 = ({ iconUrl: iconUrl, content: content })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73b196b5be3a46e4$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73b196b5be3a46e4$var$AsyncIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
        url: iconUrl
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73b196b5be3a46e4$var$Text, null, content));
const $73b196b5be3a46e4$export$b9d94102320aea17 = (value)=>{
    if (!value?.iconUrl) return undefined;
    const { iconUrl: iconUrl, content: content } = value;
    return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73b196b5be3a46e4$export$ca47fb9544dbee74, {
            iconUrl: iconUrl,
            content: content
        });
};
var $73b196b5be3a46e4$export$2e2bcd8739ae039 = $73b196b5be3a46e4$export$ca47fb9544dbee74;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $73b196b5be3a46e4$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $73b196b5be3a46e4$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $73b196b5be3a46e4$var$AsyncIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _19bv12x7 _u5f312x7",
            __cmplp.className
        ])
    });
});

});




parcelRegister("44TdC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f184ae3b99b0d4a5$export$2e2bcd8739ae039);

var $lqalZ = parcelRequire("lqalZ");

var $fVCj0 = parcelRequire("fVCj0");

var $10K82 = parcelRequire("10K82");
var $f184ae3b99b0d4a5$export$2e2bcd8739ae039 = (0, $lqalZ.connect)(null, (dispatch, ownProps)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onConfirm: (value)=>dispatch((0, $fVCj0.fieldConfirmNewField)(ownProps.fieldId, value)),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onError: (value)=>dispatch((0, $fVCj0.fieldConfirmFailureNewField)(ownProps.fieldId, value))
    }))((0, $10K82.default));

});
parcelRegister("10K82", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca3371eeae131fad$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $8BXih = parcelRequire("8BXih");
var $6c1W0 = parcelRequire("6c1W0");

var $9LvPd = parcelRequire("9LvPd");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $4bZws = parcelRequire("4bZws");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");
const $ca3371eeae131fad$var$Date = ({ fieldId: fieldKey, label: label, area: area, onError: onError, onConfirm: onConfirm })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const showPinButton = (0, $hHKWU.default)(area);
    const [{ value: value, fieldConfig: fieldConfig }] = (0, $6c1W0.useDateField)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldLabel = fieldConfig?.title || label;
    const onErrorCallback = (0, $eUqFw.useCallback)(()=>{
        onError?.(value);
    }, [
        onError,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ca3371eeae131fad$export$4e9726c08ed3f339, {
        "data-testid": `issue.views.field.date-inline-edit.${fieldKey}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), {
        fieldId: fieldKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, fieldLabel), issueKey !== undefined && fieldKey !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldKey,
        label: fieldLabel
    }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldKey,
        label: fieldLabel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BXih.DateField), {
        isFitContainerWidthReadView: true,
        issueKey: issueKey,
        fieldKey: fieldKey,
        noValueText: formatMessage((0, $huhk2.genericMessages).noValue),
        onConfirm: onConfirm,
        onError: onErrorCallback
    })));
};
var $ca3371eeae131fad$export$2e2bcd8739ae039 // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = /*#__PURE__*/ (0, $eUqFw.memo)($ca3371eeae131fad$var$Date);
const $ca3371eeae131fad$export$4e9726c08ed3f339 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $64ypR.FieldWrapper), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16ep1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8BXih", function(module, exports) {

$parcel$export(module.exports, "DateField", () => $4e10657fe5ca20b2$export$d9781c7894a82487);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");

var $dWGNJ = parcelRequire("dWGNJ");

var $6oQPP = parcelRequire("6oQPP");
var $5St1r = parcelRequire("5St1r");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");


var $6c1W0 = parcelRequire("6c1W0");

var $aIJTm = parcelRequire("aIJTm");

var $6XfCe = parcelRequire("6XfCe");

var $jtwp1 = parcelRequire("jtwp1");
const $4e10657fe5ca20b2$export$7525482b5931e326 = 'dateFieldInlineEdit';
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e10657fe5ca20b2$var$ReadViewContainer = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1jubey0-0"
})({
    display: 'flex',
    flex: '1 1 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: (0, $c9TLT.gridSize) * 2.5 / (0, $c9TLT.fontSize),
    wordBreak: 'break-word',
    position: 'relative',
    width: '100%'
});
const $4e10657fe5ca20b2$var$editViewContainerStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.075'
});
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-css-tagged-template-expression
const $4e10657fe5ca20b2$var$nonEditableDateInlineEditContainerStyles = /*#__PURE__*/ (0, $kwce8.css)`margin-left:0;${'' /* NonEditableMargin overrides */ } & > div{margin:11px 0 3px ${"var(--ds-space-100, 8px)"};}${$4e10657fe5ca20b2$var$ReadViewContainer}{left:0;padding:${"var(--ds-space-075, 6px)"} 0;line-height:1;}`;
// @ts-expect-error - TS2345: Argument of type 'StyledComponentClass'
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e10657fe5ca20b2$var$DateInlineEditContainer = /*#__PURE__*/ (0, $kwce8.default)((0, $5St1r.InlineEditContainer)).withConfig({
    componentId: "sc-1jubey0-1"
})`${({ isEditable: isEditable })=>!isEditable && $4e10657fe5ca20b2$var$nonEditableDateInlineEditContainerStyles} width:100%;margin-left:${"var(--ds-space-negative-100, -8px)"};margin-top:${"var(--ds-space-negative-100, -8px)"};padding-right:${"var(--ds-space-100, 8px)"};& div[data-read-view-fit-container-width]{display:flex;align-items:center;width:100%;min-height:${(0, $c9TLT.gridSize) * 4}px;padding:0 0 0 ${"var(--ds-space-075, 6px)"};}`;
const $4e10657fe5ca20b2$export$d9781c7894a82487 = ({ fieldKey: fieldKey, issueKey: issueKey, isEditing: isForceEditing, onFormatDate: onFormatDate, onCancel: onCancel, onEdit: onEdit, onEscape: onEscape, onConfirm: onConfirm, onEnter: onEnter, onUpdate: onUpdate, onError: onError, readView: readView, editView: editView, noValueText: noValueText, ...rest })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isEditing, setIsEditing] = (0, $eUqFw.useState)(false);
    const onSuccess = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'newValue' implicitly has an 'any' type.
    (newValue)=>{
        onUpdate?.(newValue);
        setIsEditing(false);
    }, [
        onUpdate
    ]);
    const [{ value: value, error: error, fieldConfig: fieldConfig }, { saveValue: saveValue, resetError: resetError }] = (0, $6c1W0.useDateField)({
        issueKey: (0, $6vrw7.toIssueKey)(issueKey),
        fieldKey: fieldKey,
        onSuccess: onSuccess
    });
    const [updatedValue, setUpdatedValue] = (0, $eUqFw.useState)(value);
    const isFieldEditable = fieldConfig?.isEditable ?? false;
    (0, $eUqFw.useEffect)(()=>{
        if (error) {
            setIsEditing(true);
            onError?.(error);
        }
        // This setUpdatedValue call is expected to be cleaned up during the ff cleanup of teamcamp.confirm-issue-date-field-onchange-instead-of-onblur
        if (!isEditing) setUpdatedValue(value);
    }, [
        error,
        isEditing,
        onError,
        value
    ]);
    const save = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        if (updatedValue !== value) saveValue(updatedValue, null, analyticsEvent);
        else setIsEditing(false);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        saveValue,
        updatedValue,
        value
    ]);
    const cancel = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        resetError();
        setIsEditing(false);
        // This setUpdatedValue call is expected to be cleaned up during the ff cleanup of teamcamp.confirm-issue-date-field-onchange-instead-of-onblur
        setUpdatedValue(value);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        resetError,
        value
    ]);
    const onCancelRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onCancel?.(analyticsEvent);
    }, [
        onCancel,
        cancel
    ]);
    const onConfirmRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        save(analyticsEvent);
        onConfirm?.(updatedValue, analyticsEvent);
    }, [
        onConfirm,
        save,
        updatedValue
    ]);
    const onEditRequested = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        setIsEditing(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onEdit?.(analyticsEvent);
    }, [
        onEdit
    ]);
    const onEscapeRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onEscape?.(analyticsEvent);
    }, [
        onEscape,
        cancel
    ]);
    const confirm = (0, $eUqFw.useCallback)((newValue, analyticsEvent)=>{
        setIsEditing(false);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onConfirm?.(newValue, analyticsEvent);
    }, [
        onConfirm
    ]);
    const onConfirmRequestWithoutSave = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        confirm(value, analyticsEvent);
    }, [
        confirm,
        value
    ]);
    const onChangeWithSave = (0, $eUqFw.useCallback)((newValue)=>{
        resetError();
        // Mimic onConfirm analytics
        const analyticsEvent = createAnalyticsEvent({
            action: 'confirmed',
            actionSubject: 'dateFieldInlineEdit'
        });
        if (newValue !== value) saveValue(newValue, null, analyticsEvent);
        confirm(newValue, analyticsEvent);
    }, [
        resetError,
        createAnalyticsEvent,
        confirm,
        saveValue,
        value
    ]);
    const onChange = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'newValue' implicitly has an 'any' type.
    (newValue)=>{
        resetError();
        setUpdatedValue(newValue);
    }, [
        resetError,
        setUpdatedValue
    ]);
    const renderReadView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e10657fe5ca20b2$var$ReadViewContainer, {
        "data-testid": (0, $fea9453687b7a640$export$5bb460bfb6e6f41a)
    }, readView !== undefined ? readView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtwp1.DateFieldReadView), {
        value: value,
        noValueText: noValueText,
        onFormatDate: onFormatDate
    }));
    const renderEditView = (0, $eUqFw.useCallback)(()=>editView !== undefined ? editView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $4e10657fe5ca20b2$var$editViewContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aIJTm.DateFieldEditView), {
            autoFocus: true,
            value: (0, $1ybV0.ff)('teamcamp.confirm-issue-date-field-onchange-instead-of-onblur') ? value : updatedValue,
            onChange: (0, $1ybV0.ff)('teamcamp.confirm-issue-date-field-onchange-instead-of-onblur') ? onChangeWithSave : onChange,
            isInvalid: !!error
        })), [
        editView,
        error,
        onChange,
        onChangeWithSave,
        updatedValue,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, error != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: error,
        title: (0, $6XfCe.default).errorTitle,
        description: (0, $6XfCe.default).errorMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e10657fe5ca20b2$var$DateInlineEditContainer, {
        isEditable: isFieldEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        testId: (0, $fea9453687b7a640$export$c00fba31715b400c),
        areActionButtonsHidden: true,
        actionSubject: $4e10657fe5ca20b2$export$7525482b5931e326,
        isEditable: isFieldEditable,
        isEditing: isForceEditing ?? isEditing,
        readView: renderReadView,
        editView: isFieldEditable ? renderEditView : null,
        onCancel: onCancelRequest,
        onConfirm: (0, $1ybV0.ff)('teamcamp.confirm-issue-date-field-onchange-instead-of-onblur') ? onConfirmRequestWithoutSave : onConfirmRequest,
        onEdit: onEditRequested,
        onEscape: onEscapeRequest,
        ...rest
    })));
};

});
parcelRegister("dWGNJ", function(module, exports) {

$parcel$export(module.exports, "ErrorFlag", () => $1e474dd65cc72606$export$518ba8e0e60f145f);

var $eUqFw = parcelRequire("eUqFw");

var $7byHA = parcelRequire("7byHA");

var $izafr = parcelRequire("izafr");
const $1e474dd65cc72606$export$518ba8e0e60f145f = ({ error: error, title: title, description: description })=>{
    if (!error) return null;
    if (error instanceof (0, $7byHA.ValidationError)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errorMessage = error.message || error.errors && error.errors[0] && error.errors[0].error || description;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izafr.FlagRenderer), {
            // @ts-expect-error - TS2322 - Type '{ flag: { type: string; title: MessageDescriptorV2; description: any; }; }' is not assignable to type 'IntrinsicAttributes'.
            flag: {
                type: 'warning',
                title: title,
                description: errorMessage
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izafr.FlagRenderer), {
        // @ts-expect-error - TS2322 - Type '{ flag: { type: string; title: MessageDescriptorV2; description: MessageDescriptorV2; }; }' is not assignable to type 'IntrinsicAttributes'.
        flag: {
            type: 'error',
            title: title,
            description: description
        }
    });
};

});
parcelRegister("izafr", function(module, exports) {

$parcel$export(module.exports, "FlagRenderer", () => $e43c89914c6fc6a2$export$7c38ebd1f7ca6a5a);

var $gf6nQ = parcelRequire("gf6nQ");

var $5oIBC = parcelRequire("5oIBC");
const $e43c89914c6fc6a2$export$7c38ebd1f7ca6a5a = (0, $5oIBC.default)((0, $gf6nQ.default));

});
parcelRegister("gf6nQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eec4e9461c786a4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8vPhU = parcelRequire("8vPhU");
class $7eec4e9461c786a4$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { flagService: flagService, flag: flag } = this.props;
        if (flagService) this.flagId = flagService.showFlag(flag);
    }
    componentWillUnmount() {
        const { flagService: flagService } = this.props;
        if (flagService && this.flagId) flagService.dismissFlag((0, $8vPhU.dismissFlag)(this.flagId));
    }
    render() {
        return null;
    }
}

});

parcelRegister("5oIBC", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f0696c76a3faa9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");
const $43f0696c76a3faa9$var$withFlagService = (WrappedComponent)=>{
    return (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $k8Qyf.flagService)
        });
};
var $43f0696c76a3faa9$export$2e2bcd8739ae039 = $43f0696c76a3faa9$var$withFlagService;

});



const $fea9453687b7a640$export$c00fba31715b400c = 'issue-field-date.ui.issue-field-date';
const $fea9453687b7a640$export$d0df74202c5dc6c2 = 'issue-field-date.ui.issue-field-date--container';
const $fea9453687b7a640$export$6b1d06caa26d2c8f = 'issue-field-date.ui.issue-field-date--read-only-container';
const $fea9453687b7a640$export$5bb460bfb6e6f41a = 'issue-field-date.ui.issue-field-date-read-view';
const $fea9453687b7a640$export$845e1054649a85c2 = 0; // Sunday

parcelRegister("6c1W0", function(module, exports) {

$parcel$export(module.exports, "useDateField", () => $7692b2da789358d0$export$5591b0b878c1a989);

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $7692b2da789358d0$export$5591b0b878c1a989 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.type ?? 'date';
    const [{ loading: loading, value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess
    });
    return [
        {
            loading: loading,
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("aIJTm", function(module, exports) {

$parcel$export(module.exports, "DateFieldEditView", () => $e4a8ee1cdbadcc18$export$2b0116c9fc6a0c8e);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $21l2t = parcelRequire("21l2t");

var $1iSiO = parcelRequire("1iSiO");

var $4fDms = parcelRequire("4fDms");

var $1ybV0 = parcelRequire("1ybV0");

var $eHw0J = parcelRequire("eHw0J");

var $8K9kM = parcelRequire("8K9kM");

var $4xHig = parcelRequire("4xHig");

const $e4a8ee1cdbadcc18$export$2b0116c9fc6a0c8e = ({ autoFocus: autoFocus, isDisabled: isDisabled, isInvalid: isInvalid, value: value, defaultIsOpen: defaultIsOpen = true, onChange: onChange, hideIcon: hideIcon })=>{
    const locale = (0, $4xHig.useLocale)();
    const handleOnChange = (0, $eUqFw.useCallback)((isoDateValue)=>{
        const convertedIso = (0, $4fDms.convertISODateFormat)(isoDateValue ?? '');
        if ((0, (/*@__PURE__*/$parcel$interopDefault($21l2t)))(Date.parse(convertedIso))) onChange?.(null);
        else onChange?.(convertedIso);
    }, [
        onChange
    ]);
    const standardizedLocale = (0, $eHw0J.standardizeLocale)(locale);
    // Use of non-standardized locale is intentional, getLocale map accounts for this.
    const startOfWeekDay = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))((0, $8K9kM.getLocale)(locale), 'options.weekStartsOn', (0, $fea9453687b7a640$export$845e1054649a85c2));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iSiO.default), {
        spacing: (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i') ? 'compact' : 'default',
        testId: "issue-field-date.ui.edit.issue-field-date-picker",
        locale: standardizedLocale,
        autoFocus: autoFocus,
        defaultIsOpen: defaultIsOpen,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        value: value || '',
        onChange: handleOnChange,
        weekStartDay: startOfWeekDay,
        hideIcon: hideIcon
    });
};

});

parcelRegister("6XfCe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e74da74464d37bf0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e74da74464d37bf0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "issue-field-date.error-title",
        "defaultMessage": "We couldn't set the date"
    },
    errorMessage: {
        "id": "issue-field-date.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});

parcelRegister("jtwp1", function(module, exports) {

$parcel$export(module.exports, "DateFieldReadView", () => $c8c9fa413d15ea07$export$5b4bee05cbcd0422);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6v322 = parcelRequire("6v322");

var $5GnyN = parcelRequire("5GnyN");

var $jvpgW = parcelRequire("jvpgW");
const $c8c9fa413d15ea07$export$5b4bee05cbcd0422 = ({ value: value, noValueText: noValueText, onFormatDate: onFormatDate })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { formatDateOnly: formatDateOnly } = (0, $6v322.useDateTimeFormatter)();
    if (value == null || value === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvpgW.EmptyValue), null, noValueText ?? formatMessage((0, $5GnyN.default).defaultNoValueText));
    if (onFormatDate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, onFormatDate(value));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatDateOnly(value));
};

});
parcelRegister("6v322", function(module, exports) {

$parcel$export(module.exports, "useDateTimeFormatter", () => $446d9deeb4d90baf$export$163f492669f74d5b);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $cWiVr = parcelRequire("cWiVr");

var $4xHig = parcelRequire("4xHig");

var $lR5a1 = parcelRequire("lR5a1");

var $eHw0J = parcelRequire("eHw0J");
const $446d9deeb4d90baf$export$163f492669f74d5b = (overrideTimeZone)=>{
    (0, $asu8X.di)(Intl);
    const { data: { // @ts-expect-error - TS2339 - Property 'timeZone' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    user: { timeZone: timeZonePreference } } } = (0, $cWiVr.useCurrentUser)();
    const timeZone = overrideTimeZone ?? timeZonePreference;
    const jiraLocal = (0, $4xHig.useLocale)();
    const standardizedLocale = (0, $eHw0J.standardizeLocale)(jiraLocal);
    const verifiedTimeZone = (0, $eHw0J.verifyTimeZone)(timeZone);
    const dateTimeFormatter = (0, $eUqFw.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
            ...(0, $lR5a1.longDateTimeFormat),
            timeZone: verifiedTimeZone
        }), [
        standardizedLocale,
        verifiedTimeZone
    ]);
    const dateOnlyFormatter = (0, $eUqFw.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
            ...(0, $lR5a1.longDateOnlyFormat),
            timeZone: 'UTC'
        }), [
        standardizedLocale
    ]);
    const formatDateTime = (0, $eUqFw.useCallback)((date)=>{
        const rawValue = typeof date === 'string' ? new Date(date) : date;
        return dateTimeFormatter.format(rawValue);
    }, [
        dateTimeFormatter
    ]);
    const formatDateOnly = (0, $eUqFw.useCallback)((date)=>dateOnlyFormatter.format(new Date(date)), [
        dateOnlyFormatter
    ]);
    return {
        formatDateTime: /**
		 * Returns the long form of a date value with respect to the user's locale and timezone preferences
		 *
		 * @param {string|number|date} date Value as either an [ISO8601 string](https://www.w3.org/TR/NOTE-datetime) (eg `"1997-07-16T19:20:30.45+01:00"`), epoch number (eg `1615431020`), or vanilla `Date` object
		 *
		 * ## Examples
		 *
		 * ```js
		 * // returns Jan 22, 2021, 1:11 PM
		 * formatDateTime(1611281490857) // where user locale is "en-US"
		 *
		 * // returns 2021年1月22日 午後1:11
		 * formatDateTime(1611281490857) // where user locale is "ja-JP"
		 * ```
		 */ formatDateTime,
        formatDateOnly: /**
		 * Returns the long form of a date without time value with respect to the user's locale. Timezones do not apply to these dates.
		 *
		 * @param {string} date Value as a 'YYYY-MM-DD' string (eg `"1997-07-16"`)
		 *
		 * ## Examples
		 *
		 * ```js
		 * // returns Jan 22, 2021
		 * formatDateOnly('2021-01-22') // where user locale is "en-US"
		 *
		 * // returns 2021年1月22日
		 * formatDateOnly('2021-01-22') // where user locale is "ja-JP"
		 * ```
		 */ formatDateOnly
    };
};

});
parcelRegister("lR5a1", function(module, exports) {

$parcel$export(module.exports, "longDateTimeFormat", () => $a517eed2e8954534$export$f2f390060309965);
$parcel$export(module.exports, "longDateOnlyFormat", () => $a517eed2e8954534$export$51f819d50bcd4ae1);
/**
 * If this file gets changed, please update platform/packages/proforma/proforma-common-core/src/form-system/components/questions/common/defaultDateTimeFormats.tsx or let the owners know via #jsm-request-intake.
 *
 * Proforma wants to stay consistent with Jira date and time format options.
 *
 * Later on Proforma will introduce React Context to pass config props, and this will be removed.
 */ /**
 * Long format of a date time, eg "Jun 16, 1971, 2:34 AM" with 12h/24h formatting resolved from locale
 */ const $a517eed2e8954534$export$f2f390060309965 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};
const $a517eed2e8954534$export$51f819d50bcd4ae1 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
};

});


parcelRegister("5GnyN", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e982fff48b9a56e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8e982fff48b9a56e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    defaultNoValueText: {
        "id": "issue-field-date.default-no-value-text",
        "defaultMessage": "None"
    }
});

});

parcelRegister("jvpgW", function(module, exports) {

$parcel$export(module.exports, "EmptyValue", () => $d7742910f87780eb$export$1ebe45ee63a8a144);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $d7742910f87780eb$export$1ebe45ee63a8a144 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz",
            __cmplp.className
        ])
    });
});

});





parcelRegister("b6qiJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b38e57d29f508ef$export$2e2bcd8739ae039);

var $lqalZ = parcelRequire("lqalZ");

var $fVCj0 = parcelRequire("fVCj0");

var $jdZRd = parcelRequire("jdZRd");
const $1b38e57d29f508ef$var$ConnectedDateTimeField = (0, $lqalZ.connect)(null, (dispatch, ownProps)=>({
        onUpdate: (value)=>// @ts-expect-error - TS2339 - Property 'fieldId' does not exist on type '{}'.
            dispatch((0, $fVCj0.sweetStateFieldUpdated)(ownProps.fieldId, value))
    }))((0, $jdZRd.default));
var $1b38e57d29f508ef$export$2e2bcd8739ae039 = $1b38e57d29f508ef$var$ConnectedDateTimeField;

});
parcelRegister("jdZRd", function(module, exports) {

$parcel$export(module.exports, "DateTimeFieldWrapper", () => $8f46d3a433753baa$export$a1eae8168e6dd79e);
$parcel$export(module.exports, "default", () => $8f46d3a433753baa$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $7zkAK = parcelRequire("7zkAK");
var $j9Hm5 = parcelRequire("j9Hm5");

var $9LvPd = parcelRequire("9LvPd");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $4bZws = parcelRequire("4bZws");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");
const $8f46d3a433753baa$var$DateTime = ({ fieldId: fieldKey, label: label, area: area, onUpdate: onUpdate })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const showPinButton = (0, $hHKWU.default)(area);
    const [{ fieldConfig: fieldConfig }] = (0, $j9Hm5.useDateTimeField)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldLabel = fieldConfig?.title || label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f46d3a433753baa$export$a1eae8168e6dd79e, {
        "data-testid": `issue.views.field.date-inline-edit.${fieldKey}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), {
        fieldId: fieldKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, fieldLabel), issueKey !== undefined && fieldKey !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldKey,
        label: fieldLabel
    }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldKey,
        label: fieldLabel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zkAK.DateTimeField), {
        isFitContainerWidthReadView: true,
        issueKey: issueKey,
        fieldKey: fieldKey,
        noValueText: formatMessage((0, $huhk2.genericMessages).noValue),
        onUpdate: onUpdate
    })));
};
var $8f46d3a433753baa$export$2e2bcd8739ae039 // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = /*#__PURE__*/ (0, $eUqFw.memo)($8f46d3a433753baa$var$DateTime);
const $8f46d3a433753baa$export$a1eae8168e6dd79e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $64ypR.FieldWrapper), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16ep1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7zkAK", function(module, exports) {

$parcel$export(module.exports, "DateTimeField", () => $4921739857f43d06$export$ae1ced156568f0b0);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $dWGNJ = parcelRequire("dWGNJ");

var $6oQPP = parcelRequire("6oQPP");
var $5St1r = parcelRequire("5St1r");

var $jMP2a = parcelRequire("jMP2a");

var $6vrw7 = parcelRequire("6vrw7");


var $j9Hm5 = parcelRequire("j9Hm5");

var $9zdZs = parcelRequire("9zdZs");

var $l5nwH = parcelRequire("l5nwH");

var $gQHT8 = parcelRequire("gQHT8");
const $4921739857f43d06$export$7525482b5931e326 = 'dateTimeFieldInlineEdit';
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-css-tagged-template-expression
const $4921739857f43d06$var$nonEditableDateTimeInlineEditContainerStyles = /*#__PURE__*/ (0, $kwce8.css)`${'' /* NonEditableMargin overrides */ } & > div{margin:17px 0 9px ${"var(--ds-space-025, 2px)"};}${(0, $5St1r.ReadViewContainer)}{line-height:1;}`;
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4921739857f43d06$var$InlineEditDateTimeContainer = /*#__PURE__*/ (0, $kwce8.default)((0, $5St1r.InlineEditContainer)).withConfig({
    componentId: "tazs2k-0"
})`${({ isEditable: isEditable })=>!isEditable && $4921739857f43d06$var$nonEditableDateTimeInlineEditContainerStyles}`;
const $4921739857f43d06$export$ae1ced156568f0b0 = ({ fieldKey: fieldKey, issueKey: issueKey, timeZone: timeZone, isEditing: isForceEditing, onFormatDateTime: onFormatDateTime, onParseValue: onParseValue, onCancel: onCancel, onEdit: onEdit, onEscape: onEscape, onConfirm: onConfirm, onEnter: onEnter, onUpdate: onUpdate, readView: readView, editView: editView, noValueText: noValueText, ...rest })=>{
    const [isEditing, setIsEditing] = (0, $eUqFw.useState)(false);
    const onSuccess = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'newValue' implicitly has an 'any' type.
    (newValue)=>{
        onUpdate?.(newValue);
        setIsEditing(false);
    }, [
        onUpdate
    ]);
    const [{ value: value, error: error, fieldConfig: fieldConfig }, { saveValue: saveValue, resetError: resetError }] = (0, $j9Hm5.useDateTimeField)({
        issueKey: (0, $6vrw7.toIssueKey)(issueKey),
        fieldKey: fieldKey,
        onSuccess: onSuccess
    });
    const [updatedValue, setUpdatedValue] = (0, $eUqFw.useState)(value);
    const isFieldEditable = fieldConfig?.isEditable ?? false;
    (0, $eUqFw.useEffect)(()=>{
        if (error) setIsEditing(true);
        if (!isEditing) setUpdatedValue(value);
    }, [
        error,
        isEditing,
        value
    ]);
    const save = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        if (updatedValue !== value) saveValue(updatedValue, null, analyticsEvent);
        else setIsEditing(false);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        saveValue,
        updatedValue,
        value
    ]);
    const cancel = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        resetError();
        setIsEditing(false);
        setUpdatedValue(value);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        resetError,
        value
    ]);
    const onCancelRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onCancel?.(analyticsEvent);
    }, [
        onCancel,
        cancel
    ]);
    const onConfirmRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        save(analyticsEvent);
        onConfirm?.(analyticsEvent);
    }, [
        onConfirm,
        save
    ]);
    const onEditRequested = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        setIsEditing(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onEdit?.(analyticsEvent);
    }, [
        onEdit
    ]);
    const onEscapeRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onEscape?.(analyticsEvent);
    }, [
        onEscape,
        cancel
    ]);
    const onChange = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'newValue' implicitly has an 'any' type.
    (newValue)=>{
        resetError();
        setUpdatedValue(newValue);
    }, [
        resetError,
        setUpdatedValue
    ]);
    const renderReadView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5St1r.ReadViewContainer), {
        "data-testid": (0, $6a6213da9f6f0130$export$e7bde1fef7b00f31)
    }, readView !== undefined ? readView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQHT8.DateTimeFieldReadView), {
        timeZone: timeZone,
        value: value,
        noValueText: noValueText,
        onFormatDateTime: onFormatDateTime
    }));
    const renderEditView = ()=>editView !== undefined ? editView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9zdZs.DateTimeFieldEditView), {
            value: updatedValue,
            onChange: onChange,
            isInvalid: !!error,
            onParseValue: onParseValue,
            timeZone: timeZone
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, error != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: error,
        title: (0, $l5nwH.default).errorTitle,
        description: (0, $l5nwH.default).errorMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4921739857f43d06$var$InlineEditDateTimeContainer, {
        isEditable: isFieldEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        testId: (0, $6a6213da9f6f0130$export$70416ee2ee64f0f2),
        areActionButtonsHidden: true,
        actionSubject: $4921739857f43d06$export$7525482b5931e326,
        isEditable: isFieldEditable,
        isEditing: isForceEditing ?? isEditing,
        readView: renderReadView,
        editView: isFieldEditable ? renderEditView() : null,
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onEdit: onEditRequested,
        onEscape: onEscapeRequest,
        ...rest
    })));
};

});
const $6a6213da9f6f0130$export$70416ee2ee64f0f2 = 'issue-field-date-time.ui.issue-field-date-time';
const $6a6213da9f6f0130$export$11e4bf91070de493 = 'issue-field-date-time.ui.issue-field-date-time--container';
const $6a6213da9f6f0130$export$c2fa5692d4ccdefc = 'issue-field-date-time.ui.issue-field-date-time--read-only-container';
const $6a6213da9f6f0130$export$e7bde1fef7b00f31 = 'issue-field-date-time.ui.issue-field-date-time-read-view';
const $6a6213da9f6f0130$export$845e1054649a85c2 = 0; // Sunday

parcelRegister("j9Hm5", function(module, exports) {

$parcel$export(module.exports, "useDateTimeField", () => $8718ed734e82bf7e$export$2c2e7f1ceedfa8fa);

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $8718ed734e82bf7e$export$2c2e7f1ceedfa8fa = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.type ?? 'datetime';
    const [{ loading: loading, value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            loading: loading,
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("9zdZs", function(module, exports) {

$parcel$export(module.exports, "DateTimeFieldEditView", () => $16c95475c54d0285$export$29a80838ec2d779d);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $21l2t = parcelRequire("21l2t");

var $3dY0o = parcelRequire("3dY0o");

var $iPvRp = parcelRequire("iPvRp");

var $4fDms = parcelRequire("4fDms");

var $1ybV0 = parcelRequire("1ybV0");

var $eHw0J = parcelRequire("eHw0J");

var $cWiVr = parcelRequire("cWiVr");

var $8K9kM = parcelRequire("8K9kM");

var $4xHig = parcelRequire("4xHig");


var $fKLQy = parcelRequire("fKLQy");
const $16c95475c54d0285$export$29a80838ec2d779d = ({ autoFocus: autoFocus, isDisabled: isDisabled, isInvalid: isInvalid, timeZone: timeZone, onParseValue: onParseValue = (0, $fKLQy.parseDateTimeValue), value: value, onChange: onChange, datePickerSelectProps: datePickerSelectProps = {}, timePickerSelectProps: timePickerSelectProps = {}, label: label, ...fieldProps })=>{
    const locale = (0, $4xHig.useLocale)();
    const { data: { // @ts-expect-error - TS2339 - Property 'timeZone' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    user: { timeZone: currentUserTimeZone = null } } } = (0, $cWiVr.useCurrentUser)();
    // Prefer timeZone prop (even if it's null!), and default to current user's timezone if prop is not set
    const timeZoneToUse = timeZone !== undefined ? timeZone : currentUserTimeZone;
    const handleOnChange = (0, $eUqFw.useCallback)((isoDateTimeValue)=>{
        const convertedIso = (0, $4fDms.convertISODateFormat)(isoDateTimeValue ?? '');
        if ((0, (/*@__PURE__*/$parcel$interopDefault($21l2t)))(Date.parse(convertedIso))) onChange?.(null);
        else onChange?.(convertedIso);
    }, [
        onChange
    ]);
    const parseValue = (0, $eUqFw.useCallback)((dateTimeValue, fallbackDate, fallbackTime, fallbackTimeZone)=>onParseValue(dateTimeValue, fallbackDate, fallbackTime, timeZoneToUse ?? fallbackTimeZone), [
        onParseValue,
        timeZoneToUse
    ]);
    const standardizedLocale = (0, $eHw0J.standardizeLocale)(locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dY0o.default), {
        testId: "issue-field-date-time.ui.edit.date-time-picker",
        locale: standardizedLocale,
        autoFocus: autoFocus,
        // @ts-expect-error - TS2322 - Type '{ datePickerProps?: { weekStartDay: any; } | undefined; testId: string; locale: string; autoFocus: boolean | undefined; defaultIsOpen: boolean; isDisabled: boolean | undefined; isInvalid: boolean | undefined; ... 6 more ...; datePickerSelectProps: DatePickerSelectProps; }' is not assignable to type 'IntrinsicAttributes & Pick<Pick<Pick<DateTimePickerProps, "name" | "value" | "locale" | "id" | "autoFocus" | "defaultValue" | "onFocus" | ... 17 more ... | "parseValue">, "value" | ... 4 more ... | "parseValue"> & Partial<...> & Partial<...> & RefAttributes<...> & WithContextProps, "name" | ... 25 more ... | "parseV...'.
        defaultIsOpen: false,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        value: value || '',
        onChange: handleOnChange,
        timeIsEditable: true,
        parseValue: timeZoneToUse != null ? parseValue : undefined,
        timePickerSelectProps: {
            ...timePickerSelectProps,
            formatCreateLabel: (val)=>val,
            // Want to show the dropdown option if the user input
            // matches the value (22:30) or the label (10:30pm)
            filterOption: (option, val)=>!val || option.value === val || option.label === val
        },
        times: (0, $iPvRp.default),
        // @atlaskit/datetime-picker assigns aria-label to a default value if not passed
        datePickerSelectProps: {
            'aria-labelledby': `${fieldProps?.id}-label ${fieldProps?.id}-message`,
            inputId: fieldProps?.id,
            ...datePickerSelectProps
        },
        // Use of non-standardized locale is intentional, getLocale map accounts for this.
        datePickerProps: {
            weekStartDay: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))((0, $8K9kM.getLocale)(locale), 'options.weekStartsOn', (0, $6a6213da9f6f0130$export$845e1054649a85c2))
        },
        spacing: (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i') ? 'compact' : 'default'
    });
};

});
parcelRegister("fKLQy", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeValue", () => $80f637b45ec814e2$export$30dbc3f5fc81f24a);

var $4p54N = parcelRequire("4p54N");
var $bbmZl = parcelRequire("bbmZl");

var $7ueqz = parcelRequire("7ueqz");
const $80f637b45ec814e2$export$30dbc3f5fc81f24a = (dateTimeValue, fallbackDate, fallbackTime, timeZone)=>{
    const parsed = dateTimeValue !== null && (0, $7ueqz.default)(new Date(dateTimeValue)) ? (0, $bbmZl.default)(new Date(dateTimeValue), timeZone) : null;
    return parsed !== null && (0, $7ueqz.default)(parsed) ? {
        dateValue: (0, $4p54N.default)(parsed, 'yyyy-MM-dd', {
            timeZone: timeZone
        }),
        timeValue: (0, $4p54N.default)(parsed, 'HH:mm', {
            timeZone: timeZone
        }),
        zoneValue: (0, $4p54N.default)(parsed, 'XX', {
            timeZone: timeZone
        })
    } : {
        dateValue: fallbackDate,
        timeValue: fallbackTime,
        zoneValue: (0, $4p54N.default)(new Date(), 'XX', {
            timeZone: timeZone
        })
    };
};

});


parcelRegister("l5nwH", function(module, exports) {

$parcel$export(module.exports, "default", () => $efb998946f1ea073$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $efb998946f1ea073$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "issue-field-date-time.error-title",
        "defaultMessage": "We couldn't set the date"
    },
    errorMessage: {
        "id": "issue-field-date-time.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});

parcelRegister("gQHT8", function(module, exports) {

$parcel$export(module.exports, "DateTimeFieldReadView", () => $c60dcd5181a013cf$export$ed24114cf731e7f7);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6v322 = parcelRequire("6v322");

var $d2xTw = parcelRequire("d2xTw");

var $gTTDJ = parcelRequire("gTTDJ");
const $c60dcd5181a013cf$export$ed24114cf731e7f7 = ({ timeZone: overrideTimeZone, value: value, noValueText: noValueText, onFormatDateTime: onFormatDateTime })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { formatDateTime: formatDateTime } = (0, $6v322.useDateTimeFormatter)(overrideTimeZone);
    if (value == null || value === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gTTDJ.EmptyValue), null, noValueText ?? formatMessage((0, $d2xTw.default).defaultNoValueText));
    try {
        return onFormatDateTime ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, onFormatDateTime(value)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatDateTime(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return null;
    }
};

});
parcelRegister("d2xTw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d72f46f0f0826ed6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d72f46f0f0826ed6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    defaultNoValueText: {
        "id": "issue-field-date-time.default-no-value-text",
        "defaultMessage": "None"
    }
});

});

parcelRegister("gTTDJ", function(module, exports) {

$parcel$export(module.exports, "EmptyValue", () => $b42a91277daaa490$export$1ebe45ee63a8a144);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $b42a91277daaa490$export$1ebe45ee63a8a144 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz",
            __cmplp.className
        ])
    });
});

});





parcelRegister("e929z", function(module, exports) {

$parcel$export(module.exports, "default", () => $124792459dfc6f5d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $9nkwJ = parcelRequire("9nkwJ");

var $cSu9v = parcelRequire("cSu9v");

var $23NQ5 = parcelRequire("23NQ5");

var $ffiyv = parcelRequire("ffiyv");

var $5oStv = parcelRequire("5oStv");

var $hnzPP = parcelRequire("hnzPP");

var $f8Yej = parcelRequire("f8Yej");

var $dnhZn = parcelRequire("dnhZn");

var $ciZ8Y = parcelRequire("ciZ8Y");


var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");

var $hJ992 = parcelRequire("hJ992");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $4ceCM = parcelRequire("4ceCM");


var $5G3JL = parcelRequire("5G3JL");

var $8ogeO = parcelRequire("8ogeO");

var $fCyzk = parcelRequire("fCyzk");

var $lqalZ = parcelRequire("lqalZ");

var $axK6P = parcelRequire("axK6P");

var $3e5wZ = parcelRequire("3e5wZ");


var $8CSFK = parcelRequire("8CSFK");

var $5aFoH = parcelRequire("5aFoH");

var $cbR1M = parcelRequire("cbR1M");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $guDlK = parcelRequire("guDlK");

var $9p0KY = parcelRequire("9p0KY");

var $jdDsK = parcelRequire("jdDsK");
class $124792459dfc6f5d$export$8abd85361e7598db extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'ConnectGlance';
    }
    static{
        this.defaultProps = {
            icon: null,
            openedGlance: null,
            status: null,
            workMode: (0, $f643c2ba9b5f8dbd$export$97926ea1af5082fa),
            onGlanceShowAnalytics: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    componentDidMount() {
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $5oStv.default).addUpdateIssueGlanceListener(this.onGlanceUpdate);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $5oStv.default).removeUpdateIssueGlanceListener(this.onGlanceUpdate);
    }
    render() {
        const { name: name, glance: glance } = this.props;
        const icon = this.getGlanceIcon();
        const connectGlanceField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), {
            /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.issue-base.context.ecosystem.connect.field-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), {
            /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.issue-base.context.ecosystem.connect.field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
            onEnter: this.handleOpenGlancePanel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: (analyticsEvent)=>this.setState({
                    analyticsEvent: analyticsEvent
                })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9p0KY.ContentContainer), {
            onClick: this.handleOpenGlancePanel,
            tabIndex: 0,
            "data-testid": "issue-view-base.context.ecosystem.connect.content-container",
            ...this.eventHandlers
        }, icon && glance && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9p0KY.Icon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
            url: (0, $axK6P.convertIconUrlToAbsolute)(glance.options.origin, icon.url),
            alt: icon.alt,
            width: 24,
            height: 24
        })), this.renderContent(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9p0KY.StatusContainer), null, this.renderStatus()), this.state.isHovering && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cbR1M.default), {
            mountAnimation: (0, $9p0KY.SlideInAnimation)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9p0KY.RoundButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9p0KY.RoundButton), null, this.getGlanceWorkMode() === (0, $f643c2ba9b5f8dbd$export$793430482145304b) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
            size: "medium",
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
            size: "medium",
            label: ""
        }))))))));
        if ((0, $1ybV0.ff)('instrumentation-of-issue-ecosystem-reliability-slo-metrics-rhs_tpmqi')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
            id: "issue-view.context.ecosystem-glance-field",
            packageName: "jiraIssueViewBase",
            onError: (location, error)=>{
                (0, $4ceCM.sendExperienceAnalytics)({
                    experience: 'issueViewConnectGlanceFieldRender',
                    analyticsSource: 'issueViewConnectGlanceFieldView',
                    action: (0, $99e7a4e4cbcb5db0$export$b48b3d1872522384),
                    wasExperienceSuccesful: false,
                    application: this.props.application ?? null,
                    edition: this.props.edition ?? null,
                    additionalAttributes: {
                        location: location,
                        errorMessage: error.message
                    }
                });
            }
        }, connectGlanceField, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: ()=>(0, $4ceCM.sendExperienceAnalytics)({
                    experience: 'issueViewConnectGlanceFieldRender',
                    analyticsSource: 'issueViewConnectGlanceFieldView',
                    application: this.props.application ?? null,
                    edition: this.props.edition ?? null,
                    wasExperienceSuccesful: true,
                    action: (0, $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a)
                })
        }));
        return connectGlanceField;
    }
    constructor(...args){
        super(...args);
        this.state = {
            isHovering: false,
            update: undefined,
            analyticsEvent: undefined
        };
        this.onGlanceUpdate = (event)=>{
            const payload = event.detail[1];
            if (payload.addonKey === this.props.appKey && payload.moduleKey === this.props.moduleKey) this.setState({
                update: (0, $jdDsK.sanitizeGlanceUpdate)(payload.data)
            });
        };
        this.getGlanceIcon = ()=>this.state.update && this.state.update.icon ? this.state.update.icon : this.props.icon;
        this.getGlanceWorkMode = ()=>this.state.update && this.state.update.workMode || this.props.workMode;
        this.eventHandlers = {
            onMouseEnter: ()=>this.setState({
                    isHovering: true
                }),
            onMouseLeave: ()=>this.setState({
                    isHovering: false
                }),
            onFocus: ()=>this.setState({
                    isHovering: true
                }),
            onBlur: ()=>this.setState({
                    isHovering: false
                })
        };
        this.handleOpenGlancePanel = ()=>{
            const { appKey: appKey, moduleKey: moduleKey, options: options = {}, status: status, onGlanceShowAnalytics: onGlanceShowAnalytics, onOpenGlancePanel: onOpenGlancePanel, onClickThroughGlancePanel: onClickThroughGlancePanel } = this.props;
            const currentWorkMode = this.getGlanceWorkMode();
            if (this.state.analyticsEvent) {
                // We must mutate the event since fireUIAnalytics ignores the action in the second param
                const thisAnalyticsEvent = this.state.analyticsEvent;
                if (thisAnalyticsEvent.payload) thisAnalyticsEvent.payload.action = 'clicked';
                (0, $jMP2a.fireUIAnalytics)(thisAnalyticsEvent, 'connectGlancePanel clicked', {
                    moduleType: options.moduleType,
                    iframeIsCacheable: String(options.url).includes('xdm_e='),
                    moduleKey: options.key,
                    moduleLocation: options.moduleLocation,
                    pearApp: Boolean(options.pearApp),
                    issueField: options.addon_key
                });
            }
            if (currentWorkMode === (0, $f643c2ba9b5f8dbd$export$97926ea1af5082fa)) {
                onGlanceShowAnalytics((0, $8ogeO.glanceAnalyticsData)(appKey, moduleKey, status));
                onOpenGlancePanel(appKey, moduleKey);
            } else if (currentWorkMode === (0, $f643c2ba9b5f8dbd$export$793430482145304b)) onClickThroughGlancePanel(appKey, moduleKey);
        };
        this.renderStatus = ()=>{
            const status = this.state.update && this.state.update.status ? this.state.update.status : this.props.status;
            if (!status) return null;
            // TODO: remove any type and add value check for undefined.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const { value: value, type: type } = status;
            if (value.label) switch(type){
                case 'lozenge':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                        appearance: value.type
                    }, value.label);
                case 'icon':
                    return this.props.glance ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
                        url: (0, $axK6P.convertIconUrlToAbsolute)(this.props.glance.options.origin, value.label),
                        alt: value.type,
                        width: 24,
                        height: 24
                    }) : null;
                case 'badge':
                    {
                        const num = parseInt(value.label, 10);
                        if (num >= 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
                            appearance: "default"
                        }, num);
                        return null;
                    }
                default:
                    return null;
            }
            return null;
        };
        this.renderContent = ()=>{
            if (this.state.update && this.state.update.content) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9p0KY.Content), null, this.state.update.content);
            const { label: label, name: name } = this.props;
            return label.value === name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9p0KY.Content), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                id: "issue.ecosystem.context.rich-glance-label",
                defaultMessage: "Open {label}",
                values: {
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9p0KY.Bold), null, label.value)
                }
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9p0KY.Content), null, label.value);
        };
    }
}
const $124792459dfc6f5d$var$onClickThroughGlancePanel = (appKey, moduleKey)=>{
    (0, $dnhZn.default)((0, $0effd28d911d2d1b$export$6fdafcc5bb9d64eb), {
        addon_key: appKey,
        key: moduleKey
    });
};
const $124792459dfc6f5d$var$ConnectGlanceWithIssueLayout = (props)=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [, { setIssueViewLayoutGlance: setIssueViewLayoutGlance }] = (0, $fCyzk.useIssueLayoutActions)();
    let application;
    let edition;
    if ((0, $1ybV0.ff)('instrumentation-of-issue-ecosystem-reliability-slo-metrics-rhs_tpmqi')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
        const projectKey = (0, $guDlK.useProjectKey)(issueKey);
        // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
        application = (0, $guDlK.useApplication)(projectKey, true);
        // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
        edition = (0, $guDlK.useEdition)(projectKey, true);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($124792459dfc6f5d$export$8abd85361e7598db, {
        ...props,
        application: application,
        edition: edition,
        onOpenGlancePanel: (appKey, moduleKey)=>{
            setIssueViewLayoutGlance(issueKey, {
                appKey: appKey,
                moduleKey: moduleKey
            });
            (0, $dnhZn.default)((0, $0effd28d911d2d1b$export$c660c310dd8f90b), {
                addon_key: appKey,
                key: moduleKey
            });
        }
    });
};
var $124792459dfc6f5d$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state, ownProps)=>({
        openedGlance: (0, $5aFoH.openedGlanceSelector)(state),
        glance: (0, $8CSFK.glancePanelSelector)(ownProps.appKey, ownProps.moduleKey)(state),
        onClickThroughGlancePanel: $124792459dfc6f5d$var$onClickThroughGlancePanel
    }), (dispatch)=>({
        onOpenGlancePanel: (appKey, moduleKey)=>{
            dispatch((0, $3e5wZ.ecosystemShowGlance)(appKey, moduleKey));
            (0, $dnhZn.default)((0, $0effd28d911d2d1b$export$c660c310dd8f90b), {
                addon_key: appKey,
                key: moduleKey
            });
        }
    })))($124792459dfc6f5d$var$ConnectGlanceWithIssueLayout);

});
const $f643c2ba9b5f8dbd$export$793430482145304b = 'click_through';
const $f643c2ba9b5f8dbd$export$97926ea1af5082fa = 'open_panel';

/* Events Issue View will trigger for ecosystem add-on */ const $0effd28d911d2d1b$export$8b56667c724a6334 = 'ISSUE_QUICK_ADD_CLICKED';
const $0effd28d911d2d1b$export$c660c310dd8f90b = 'ISSUE_GLANCE_OPENED';
const $0effd28d911d2d1b$export$6fdafcc5bb9d64eb = 'ISSUE_GLANCE_CONTENT_CLICKED';

parcelRegister("5aFoH", function(module, exports) {

$parcel$export(module.exports, "openedGlanceSelector", () => $4be22032707e24cc$export$4b0be4e92d00d34d);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $4be22032707e24cc$export$4b0be4e92d00d34d = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.ecosystem && ui.ecosystem.glance);

});

parcelRegister("cbR1M", function(module, exports) {

$parcel$export(module.exports, "default", () => $46cd662c448bc9fe$export$2e2bcd8739ae039);
/* mount-animator.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46cd662c448bc9fe$var$OffScreenWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltvqkuk",
            __cmplp.className
        ])
    });
});
class $46cd662c448bc9fe$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            mountAnimation: undefined
        };
    }
    render() {
        const { mountAnimation: MountAnimation, children: children } = this.props;
        // Render only the child element if the animation has completed.
        if (!this.state.shouldAnimateMount) return children;
        // Render the children off-screen to calculate their size before animating.
        if (!this.state.childSize) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46cd662c448bc9fe$var$OffScreenWrapper, {
            ref: this.calculateSize
        }, children);
        // Actually animate the new elements.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MountAnimation, {
            onAnimationEnd: this.onMountAnimationEnd,
            height: this.state.childSize.height,
            width: this.state.childSize.width
        }, children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldAnimateMount: true,
            childSize: null
        };
        this.onMountAnimationEnd = ()=>{
            this.setState({
                shouldAnimateMount: false
            });
        };
        this.calculateSize = (domNode)=>{
            if (!domNode) return;
            requestAnimationFrame(()=>{
                const { width: width, height: height } = domNode.getBoundingClientRect();
                this.setState({
                    childSize: {
                        width: width,
                        height: height
                    }
                });
            });
        };
    }
}

});

parcelRegister("9p0KY", function(module, exports) {

$parcel$export(module.exports, "ContentContainer", () => $dff26d3479542d3f$export$9d2b4227a95687cc);
$parcel$export(module.exports, "Icon", () => $dff26d3479542d3f$export$f04a61298a47a40f);
$parcel$export(module.exports, "Content", () => $dff26d3479542d3f$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "Bold", () => $dff26d3479542d3f$export$95aa4184327d6b72);
$parcel$export(module.exports, "StatusContainer", () => $dff26d3479542d3f$export$15529022dcaf3eec);
$parcel$export(module.exports, "RoundButtonContainer", () => $dff26d3479542d3f$export$47f382d3644add98);
$parcel$export(module.exports, "RoundButton", () => $dff26d3479542d3f$export$1e9fb32f4c490b67);
$parcel$export(module.exports, "SlideInAnimation", () => $dff26d3479542d3f$export$dc6db0e0e0a00752);
/* styled-glance-view.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/styled/no-styled-export */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $dff26d3479542d3f$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1reo15vq _18m915vq _1e0c1txw _2rko1l7b _18u0x0bf _4t3izwfg _1bsb1osq _v564r5cv _7ehi1vt6 _nt751r31 _49pcglyw _1hvwidpf _1du2l9t9 _19lc14ae _d0altlke",
            __cmplp.className
        ])
    });
});
const $dff26d3479542d3f$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _19pk1b66 _otyr1b66 _18u0u2gc _4t3i1tcg _1bsb1tcg _4cvr1h6o _19bvv77o _u5f3v77o",
            __cmplp.className
        ])
    });
});
const $dff26d3479542d3f$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s _16jlkb7n _1o9zkb7n _i0dlf1ug _vwz4zwfg _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $dff26d3479542d3f$export$95aa4184327d6b72 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l _1e0c1nu9",
            __cmplp.className
        ])
    });
});
const $dff26d3479542d3f$export$15529022dcaf3eec = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz15i6 _1e0c1txw _4cvr1h6o _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $dff26d3479542d3f$export$47f382d3644add98 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1xi2idpf _1bsb8vuz _4t3izwfg",
            __cmplp.className
        ])
    });
});
const $dff26d3479542d3f$export$1e9fb32f4c490b67 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1xi2idpf _18s8d9x7 _4t3i1ou6 _1bsb1ou6 _11q7hkel _syaz1tae _2rko1ssb _4cvr1h6o _1yt41nvr",
            __cmplp.className
        ])
    });
});
const $dff26d3479542d3f$var$slideIn = null;
const $dff26d3479542d3f$export$dc6db0e0e0a00752 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _y44v1d95",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jdDsK", function(module, exports) {

$parcel$export(module.exports, "sanitizeGlanceUpdate", () => $fd361c41c5d3f56d$export$1c0f406130247bc5);

var $i7Fym = parcelRequire("i7Fym");

const $fd361c41c5d3f56d$var$validateWorkMode = (value)=>[
        (0, $f643c2ba9b5f8dbd$export$793430482145304b),
        (0, $f643c2ba9b5f8dbd$export$97926ea1af5082fa)
    ].find((workMode)=>workMode === value) || (0, $f643c2ba9b5f8dbd$export$97926ea1af5082fa);
const $fd361c41c5d3f56d$export$1c0f406130247bc5 = (glanceUpdate)=>{
    const withSetValues = (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))(glanceUpdate, (value)=>value === undefined || value === null);
    return withSetValues.workMode === undefined ? withSetValues : {
        ...withSetValues,
        workMode: $fd361c41c5d3f56d$var$validateWorkMode(withSetValues.workMode)
    };
};

});


parcelRegister("af2Be", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e858f84f318487c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");

var $8ohna = parcelRequire("8ohna");

var $eyYNo = parcelRequire("eyYNo");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $lqalZ = parcelRequire("lqalZ");

var $fokFV = parcelRequire("fokFV");

var $fVCj0 = parcelRequire("fVCj0");

var $1TdsV = parcelRequire("1TdsV");

var $7BiDI = parcelRequire("7BiDI");

var $3Q233 = parcelRequire("3Q233");

var $4aJzJ = parcelRequire("4aJzJ");
const $6e858f84f318487c$export$673580e21c2d743e = (props)=>{
    const { fieldId: fieldId } = props;
    const { loading: loading, data: data } = (0, $8ohna.useFetchIssueCustomFieldData)({
        fieldId: fieldId
    });
    const refreshedOn = (0, $eyYNo.useOnDemandIssueRefreshTime)();
    const { shouldReportFailure: shouldReportFailure, reportFailure: reportFailure } = (0, $1TdsV.useReportFailure)(data ? data.extension : null, fieldId, data?.fieldExistsInJira, data?.isFilteredOut, !!data);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldReportFailure) reportFailure();
    }, [
        shouldReportFailure,
        reportFailure
    ]);
    const extension = data ? data.extension : null;
    const ForgeField = (0, $eUqFw.useMemo)(()=>(0, $3Q233.default)(extension), [
        extension
    ]);
    if (loading || !data || !extension || data?.isFilteredOut || !ForgeField) return null;
    const { shouldUseFormatter: shouldUseFormatter, extensionData: extensionData, fieldName: fieldName } = data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7BiDI.CustomFieldAnalyticsWrapper), {
        extension: extension,
        key: refreshedOn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4aJzJ.ForgeCustomFieldView), {
        ...props,
        shouldUseFormatter: shouldUseFormatter,
        extension: extension,
        extensionData: extensionData,
        fieldId: fieldId,
        fieldName: fieldName,
        ForgeField: ForgeField
    }));
};
var $6e858f84f318487c$export$2e2bcd8739ae039 = (0, $huRi7.compose)((0, $3uwfp.default)((stateOnMount, { fieldId: fieldId, area: area })=>({
        fieldId: fieldId,
        additionalProps: (state)=>({
                showPinButton: (0, $hHKWU.default)(area),
                invalidMessage: (0, $fokFV.fieldInvalidMessageSelector)(fieldId)(state)
            })
    })), // eslint-disable-next-line @typescript-eslint/no-explicit-any
(0, $lqalZ.connect)(null, (dispatch, ownProps)=>({
        onSave: (value)=>dispatch((0, $fVCj0.fieldUpdate)(ownProps.fieldId, value, ownProps.fieldOptions))
    })))($6e858f84f318487c$export$673580e21c2d743e);

});
parcelRegister("8ohna", function(module, exports) {

$parcel$export(module.exports, "useFetchIssueCustomFieldData", () => $b056fd2ddae98284$export$8bf63fbafe8a123f);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $gUUjF = parcelRequire("gUUjF");

var $is86i = parcelRequire("is86i");

var $fTsDx = parcelRequire("fTsDx");

var $hJ992 = parcelRequire("hJ992");

var $8411R = parcelRequire("8411R");

var $2Sajo = parcelRequire("2Sajo");

var $guDlK = parcelRequire("guDlK");

var $buCkT = parcelRequire("buCkT");

var $5OsXa = parcelRequire("5OsXa");
const $b056fd2ddae98284$export$ff045d6918ed5c0 = (ecosystemEnabled, issueViewStaticContext, extension, extensionId, blockedExtensions)=>{
    if (!ecosystemEnabled) return false;
    if (extension) return !(0, $fTsDx.doesExtensionMeetConditions)(extension, issueViewStaticContext);
    const blockedCustomFieldExtensionIds = blockedExtensions.map((e)=>e?.id);
    return blockedCustomFieldExtensionIds.includes(extensionId);
};
const $b056fd2ddae98284$export$39bf238e05ee7c0 = (extension)=>{
    if (!extension) return false;
    const hasRenderingFunction = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(extension.properties.function);
    const hasNativeResource = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(extension.properties.resource) && extension.properties.render === 'native';
    const hasFormatterDefined = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(extension.properties.formatter);
    return !hasRenderingFunction && !hasNativeResource && hasFormatterDefined;
};
const $b056fd2ddae98284$export$75894d0ee69c5e12 = (fieldId, fieldsConfiguration)=>!!fieldsConfiguration[fieldId];
const $b056fd2ddae98284$export$3128dedc24eee543 = (fieldId, fieldsConfiguration)=>{
    if (fieldsConfiguration[fieldId]?.title) return fieldsConfiguration[fieldId]?.title;
    (0, $gUUjF.default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
    return '';
};
const $b056fd2ddae98284$export$8bf63fbafe8a123f = ({ fieldId: fieldId })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const { ecosystemEnabled: ecosystemEnabled = false } = (0, $guDlK.useProjectConfiguration)(projectKey);
    const issueViewStaticContext = (0, $5OsXa.useIssueViewStaticContext)();
    const { loading: extensionIdLoading, data: extensionId } = (0, $buCkT.useIssueViewExtensionId)(issueKey, fieldId);
    const extensionData = (0, $is86i.useForgeUiIssueData)();
    const extension = (0, $2Sajo.useForgeCustomField)(extensionId || '') || null;
    const blockedExtensions = (0, $2Sajo.useBlockedExtensions)();
    const [{ loading: fieldsConfigurationLoading, value: fieldsConfiguration }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    const blockedCustomFields = (0, $eUqFw.useMemo)(()=>[
            ...blockedExtensions ? blockedExtensions.customField : [],
            ...blockedExtensions ? blockedExtensions.customFieldType : []
        ], [
        blockedExtensions
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            loading: extensionIdLoading || fieldsConfigurationLoading,
            data: extensionId && fieldsConfiguration && extensionData ? {
                isFilteredOut: $b056fd2ddae98284$export$ff045d6918ed5c0(ecosystemEnabled, issueViewStaticContext, extension, extensionId, blockedCustomFields),
                shouldUseFormatter: $b056fd2ddae98284$export$39bf238e05ee7c0(extension),
                extension: extension,
                extensionData: extensionData,
                fieldExistsInJira: $b056fd2ddae98284$export$75894d0ee69c5e12(fieldId, fieldsConfiguration),
                fieldName: $b056fd2ddae98284$export$3128dedc24eee543(fieldId, fieldsConfiguration)
            } : undefined,
            error: undefined
        }), [
        fieldId,
        ecosystemEnabled,
        issueViewStaticContext,
        extension,
        extensionIdLoading,
        extensionId,
        extensionData,
        fieldsConfigurationLoading,
        fieldsConfiguration,
        blockedCustomFields
    ]);
};

});
parcelRegister("buCkT", function(module, exports) {

$parcel$export(module.exports, "useIssueViewExtensionId", () => $3ef9547f11495e85$export$ae0e7aa5a1d532aa);

var $eUqFw = parcelRequire("eUqFw");

var $8411R = parcelRequire("8411R");
const $3ef9547f11495e85$export$ae0e7aa5a1d532aa = (issueKey, fieldId)=>{
    const [{ loading: loading, value: value }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    return (0, $eUqFw.useMemo)(()=>{
        if (loading) return {
            loading: loading
        };
        return {
            loading: loading,
            data: value && value[fieldId]?.schema.custom
        };
    }, [
        fieldId,
        loading,
        value
    ]);
};

});

parcelRegister("5OsXa", function(module, exports) {

$parcel$export(module.exports, "useIssueViewStaticContext", () => $64353eb78d3a1d4e$export$c9612f9e6f8725ce);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $lO4Or = parcelRequire("lO4Or");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");
const $64353eb78d3a1d4e$export$c9612f9e6f8725ce = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const issueId = (0, $hJ992.useIssueId)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectId = (0, $guDlK.useProjectId)(projectKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const [issueType] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.ISSUE_TYPE)
    });
    const [permissions] = (0, $5YYzL.useProjectPermissions)(projectKey);
    return (0, $eUqFw.useMemo)(()=>({
            issueKey: issueKey,
            issueId: issueId || null,
            issueType: issueType?.name || null,
            projectId: projectId || null,
            projectKey: projectKey,
            projectType: projectType || null,
            canAddComments: permissions.canAddComments,
            canAdministerJira: permissions.canAdministerJira,
            canAdministerProjects: permissions.canAdministerProject,
            canAssignIssues: permissions.canAssignIssues,
            canBeAssignedToIssues: permissions.canBeAssignedToIssues,
            canCloneIssues: permissions.canCloneIssue,
            canCreateAttachments: permissions.canCreateAttachments,
            canCreateChildren: permissions.canCreateChildren,
            canCreateSubtasks: permissions.canCreateSubtask,
            canDeleteAllAttachments: permissions.canDeleteAllAttachments,
            canDeleteAllComments: permissions.canDeleteAllComments,
            canDeleteAllWorklogs: permissions.canDeleteAllWorklogs,
            canDeleteIssues: permissions.canDeleteIssue,
            canDeleteOwnAttachments: permissions.canDeleteOwnAttachments,
            canDeleteOwnComments: permissions.canDeleteOwnComments,
            canDeleteOwnWorklogs: permissions.canDeleteOwnWorklogs,
            canEditAllComments: permissions.canEditAllComments,
            canEditAllWorklogs: permissions.canEditAllWorklogs,
            canEditIssues: permissions.canEditIssues,
            canEditOwnComments: permissions.canEditOwnComments,
            canEditOwnWorklogs: permissions.canEditOwnWorklogs,
            canLinkIssues: permissions.canLinkIssues,
            canLogWork: permissions.canLogWork,
            canManageWatchers: permissions.canManageWatchers,
            canModifyReporters: permissions.canModifyReporter,
            canMoveIssues: permissions.canMoveIssue,
            canScheduleIssues: permissions.canScheduleIssues,
            canUseServiceManagementAgentFeatures: permissions.canUseServiceDeskAgentFeatures,
            canBrowseUsers: permissions.canBrowseUsers,
            canViewDevTools: permissions.canViewDevTools,
            canViewWatchers: permissions.canViewWatchers
        }), [
        issueId,
        issueKey,
        issueType,
        projectId,
        projectKey,
        projectType,
        permissions.canAddComments,
        permissions.canAdministerJira,
        permissions.canAdministerProject,
        permissions.canAssignIssues,
        permissions.canBeAssignedToIssues,
        permissions.canCloneIssue,
        permissions.canCreateAttachments,
        permissions.canCreateChildren,
        permissions.canCreateSubtask,
        permissions.canDeleteAllAttachments,
        permissions.canDeleteAllComments,
        permissions.canDeleteAllWorklogs,
        permissions.canDeleteIssue,
        permissions.canDeleteOwnAttachments,
        permissions.canDeleteOwnComments,
        permissions.canDeleteOwnWorklogs,
        permissions.canEditAllComments,
        permissions.canEditAllWorklogs,
        permissions.canEditIssues,
        permissions.canEditOwnComments,
        permissions.canEditOwnWorklogs,
        permissions.canLinkIssues,
        permissions.canLogWork,
        permissions.canManageWatchers,
        permissions.canModifyReporter,
        permissions.canMoveIssue,
        permissions.canScheduleIssues,
        permissions.canUseServiceDeskAgentFeatures,
        permissions.canBrowseUsers,
        permissions.canViewDevTools,
        permissions.canViewWatchers
    ]);
};

});


parcelRegister("1TdsV", function(module, exports) {

$parcel$export(module.exports, "useReportFailure", () => $3c6edc1a44f64657$export$f11f1585be2ce05d);

var $eUqFw = parcelRequire("eUqFw");

var $5syGA = parcelRequire("5syGA");

var $5Jqzu = parcelRequire("5Jqzu");

var $hJ992 = parcelRequire("hJ992");

var $2Sajo = parcelRequire("2Sajo");

var $3Q233 = parcelRequire("3Q233");

var $7BiDI = parcelRequire("7BiDI");
const $3c6edc1a44f64657$export$f11f1585be2ce05d = (extension, fieldId, fieldExistsInJira, isFilteredOut, isCustomFieldDataAvailable)=>{
    const ForgeField = (0, $3Q233.default)(extension);
    const [isForgeInitiallyLoaded] = (0, $2Sajo.useForgeDataComplete)();
    const isForgeLoadingFailed = (0, $2Sajo.useForgeLoadingFailed)();
    const isForgeDataEmpty = (0, $2Sajo.useIsForgeDataEmpty)();
    const source = (0, $hJ992.useAnalyticsSource)();
    /*
        The error should be reported when:
        * there is all required data fetched
        * there was no error occurred while fetching data
        * Forge data is not empty (fetch modules returns empty data for excluded errors)
        * extensions is not filtered out
        * there is no extension or Forge component
     */ const shouldReportFailure = (0, $eUqFw.useMemo)(()=>isCustomFieldDataAvailable && isForgeInitiallyLoaded && !isForgeLoadingFailed && !isForgeDataEmpty && !isFilteredOut && !(extension && ForgeField), [
        isForgeInitiallyLoaded,
        isForgeLoadingFailed,
        isForgeDataEmpty,
        isFilteredOut,
        extension,
        ForgeField,
        isCustomFieldDataAvailable
    ]);
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>extension ? {
            source: source,
            fieldId: fieldId,
            renderContext: (0, $7BiDI.ISSUE_VIEW_RENDER_CONTEXT),
            module: extension?.type,
            fieldType: extension?.properties.type,
            extensionProperties: extension?.properties,
            ...extension && (0, $5syGA.getAnalyticsAttributesFromExtension)(extension)
        } : {
            source: source,
            fieldId: fieldId,
            renderContext: (0, $7BiDI.ISSUE_VIEW_RENDER_CONTEXT)
        }, [
        extension,
        source,
        fieldId
    ]);
    const report = (0, $eUqFw.useCallback)((reporter, errorMessage)=>reporter(source, {
            ...analyticsAttributes,
            error: Error(errorMessage)
        }), [
        analyticsAttributes,
        source
    ]);
    const reportFailure = (0, $eUqFw.useCallback)(()=>{
        // Unsupported type
        if (extension && !ForgeField) {
            report((0, $5Jqzu.fireOperationalFailedEvent), `Forge custom field ${extension.properties.type} type is not supported`);
            return;
        }
        // The field doesn't exist in Jira, but Jira wants to render it (as per issue layout config).
        // See https://hello.atlassian.net/wiki/spaces/SMITE/pages/1496973741/CustomField+extension+breaching#UPD-3
        if (!fieldExistsInJira) {
            report((0, $5Jqzu.fireOperationalLayoutIssueEvent), "ForgeCustomField component can't be rendered as Jira isn't aware of that field (layout issue)");
            return;
        }
        // There is no corresponding Forge extension
        report((0, $5Jqzu.fireOperationalFailedEvent), 'Forge extension passed to ForgeCustomField component is not found');
    }, [
        extension,
        ForgeField,
        fieldExistsInJira,
        report
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            shouldReportFailure: shouldReportFailure,
            reportFailure: reportFailure
        }), [
        shouldReportFailure,
        reportFailure
    ]);
};

});
parcelRegister("5Jqzu", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $68403a15c669f0d5$export$add44f896fb31ba3);
$parcel$export(module.exports, "fireOperationalLayoutIssueEvent", () => $68403a15c669f0d5$export$847d594bb41d0bf);

var $2Rqjr = parcelRequire("2Rqjr");

var $8XU7c = parcelRequire("8XU7c");

var $cYWDh = parcelRequire("cYWDh");

var $7ALvE = parcelRequire("7ALvE");

var $hRcYT = parcelRequire("hRcYT");
const $68403a15c669f0d5$var$moduleEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_EXTENSION)
});
const $68403a15c669f0d5$export$add44f896fb31ba3 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).FAILED, {
        id: $68403a15c669f0d5$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $68403a15c669f0d5$export$847d594bb41d0bf = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)('layout issue', {
        id: $68403a15c669f0d5$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $68403a15c669f0d5$export$bfa9af8b9019292e = (message)=>(0, $7ALvE.logError)((0, $7ALvE.CUSTOM_FIELD_OBJECT_TYPE), message);

});

parcelRegister("3Q233", function(module, exports) {

$parcel$export(module.exports, "default", () => $5baa34804edb14c5$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");

var $fcFuj = parcelRequire("fcFuj");

var $1pLkJ = parcelRequire("1pLkJ");

var $bgSwJ = parcelRequire("bgSwJ");
var $hvLI5 = parcelRequire("hvLI5");

var $1eeQr = parcelRequire("1eeQr");

var $1KJ1D = parcelRequire("1KJ1D");

var $7QgAj = parcelRequire("7QgAj");
var $ih03o = parcelRequire("ih03o");

var $53RLl = parcelRequire("53RLl");
// TODO ARKEN-707: undefined components should receive an implementation
const $5baa34804edb14c5$var$getFieldMap = ()=>({
        none: {
            string: (0, $1KJ1D.default),
            number: (0, $1KJ1D.default),
            object: (0, $1KJ1D.default),
            user: (0, $7QgAj.default),
            group: (0, $bgSwJ.default),
            datetime: (0, $1pLkJ.default),
            date: (0, $fcFuj.default)
        },
        list: {
            string: (0, $1eeQr.default),
            number: undefined,
            object: undefined,
            group: (0, $hvLI5.default),
            user: (0, $ih03o.default),
            datetime: undefined,
            date: undefined
        }
    });
const $5baa34804edb14c5$var$getComponent = (extension)=>{
    if (!extension) return null;
    const { type: type, collection: collection = 'none' } = extension.properties;
    const fieldCollection = $5baa34804edb14c5$var$getFieldMap()[collection];
    return (fieldCollection && fieldCollection[type]) ?? null;
};
const $5baa34804edb14c5$var$getComponentWithMetrics = (extension)=>{
    const Component = $5baa34804edb14c5$var$getComponent(extension);
    if (!Component || !extension) return null;
    return (0, $53RLl.withRenderingMetrics)(Component, extension.id);
};
const $5baa34804edb14c5$var$memoizedGetComponentWithMetrics = (0, $5iWql.default)($5baa34804edb14c5$var$getComponentWithMetrics);
const $5baa34804edb14c5$var$getForgeCustomFields = (extension)=>{
    if ((0, $1ybV0.ff)('remove-invalid-forge-metrics_n3ddj')) return $5baa34804edb14c5$var$getComponent(extension);
    const isCustomNativeField = !extension?.properties.function;
    if (isCustomNativeField) return $5baa34804edb14c5$var$memoizedGetComponentWithMetrics(extension);
    return $5baa34804edb14c5$var$getComponent(extension);
};
var $5baa34804edb14c5$export$2e2bcd8739ae039 = (0, $5iWql.default)($5baa34804edb14c5$var$getForgeCustomFields);

});
parcelRegister("fcFuj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b588dcaed8dff2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $c9TLT = parcelRequire("c9TLT");

var $1boRu = parcelRequire("1boRu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $8BXih = parcelRequire("8BXih");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $4bZws = parcelRequire("4bZws");

var $huhk2 = parcelRequire("huhk2");

var $jdZRd = parcelRequire("jdZRd");

var $iZkNq = parcelRequire("iZkNq");
const $e7b588dcaed8dff2$export$27a5bd065ad55220 = ({ label: label, showPinButton: showPinButton, fieldId: fieldId, customReadView: customReadView, onEditRequest: onEditRequest, isEditing: isEditing, onCancel: onCancel, value: value, shouldFireScreenEvent: shouldFireScreenEvent, fieldContentWrapper: fieldContentWrapper, titleView: titleView = label, extension: extension })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // If app does not specifies edit view than we go with native edit view which will rely on inner state of DateField
    const isControlledEditing = extension.properties.edit ? isEditing : undefined;
    const analyticsAttributes = (0, $iZkNq.useAnalyticsAttributesContext)();
    const attributes = (0, $eUqFw.useMemo)(()=>({
            ...analyticsAttributes,
            renderMode: 'default'
        }), [
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jdZRd.DateTimeFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, titleView), showPinButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldId,
        label: label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), {
        isEditing: isEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7b588dcaed8dff2$export$6ce170286acaa8d3, {
        fieldContentWrapper: fieldContentWrapper
    }, shouldFireScreenEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: attributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BXih.DateField), {
        isFitContainerWidthReadView: true,
        readView: customReadView ? customReadView(value) : undefined,
        onEdit: onEditRequest,
        noValueText: formatMessage((0, $huhk2.genericMessages).noValue),
        issueKey: issueKey,
        fieldKey: fieldId,
        onCancel: onCancel,
        isEditing: isControlledEditing
    }))));
};
const $e7b588dcaed8dff2$export$6ce170286acaa8d3 = (props)=>{
    const { fieldContentWrapper: FieldContentWrapper } = props;
    if (FieldContentWrapper) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldContentWrapper, {
        topMargin: 0.75 * (0, $c9TLT.gridSize)
    }, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
};
var $e7b588dcaed8dff2$export$2e2bcd8739ae039 = $e7b588dcaed8dff2$export$27a5bd065ad55220;

});
parcelRegister("iZkNq", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsAttributesContext", () => $2e56c04e23319134$export$da4da5285a2fd344);
$parcel$export(module.exports, "AnalyticsAttributesContextProvider", () => $2e56c04e23319134$export$3b22f90ab23e4f6d);

var $eUqFw = parcelRequire("eUqFw");
const $2e56c04e23319134$var$AnalyticsAttributesContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    appId: 'appId',
    envId: 'envId',
    source: 'unknownSource'
});
const $2e56c04e23319134$export$da4da5285a2fd344 = ()=>(0, $eUqFw.useContext)($2e56c04e23319134$var$AnalyticsAttributesContext);
const $2e56c04e23319134$export$3b22f90ab23e4f6d = $2e56c04e23319134$var$AnalyticsAttributesContext.Provider;

});


parcelRegister("1pLkJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $abe58f7609e171dc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $c9TLT = parcelRequire("c9TLT");

var $1boRu = parcelRequire("1boRu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $7zkAK = parcelRequire("7zkAK");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $4bZws = parcelRequire("4bZws");

var $huhk2 = parcelRequire("huhk2");

var $6aKs0 = parcelRequire("6aKs0");

var $6vrw7 = parcelRequire("6vrw7");

var $lGLse = parcelRequire("lGLse");

var $jdZRd = parcelRequire("jdZRd");

var $iZkNq = parcelRequire("iZkNq");
const $abe58f7609e171dc$export$27a5bd065ad55220 = ({ label: label, showPinButton: showPinButton, fieldId: fieldId, customReadView: customReadView, isEditing: isEditing, value: value, onEditRequest: onEditRequest, onCancel: onCancel, onSave: onSave, shouldFireScreenEvent: shouldFireScreenEvent, titleView: titleView = label, extension: extension, fieldContentWrapper: fieldContentWrapper })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const timeZone = (0, $eUqFw.useMemo)(()=>loggedInUser ? loggedInUser.timeZone : (0, $6vrw7.toTimeZone)((0, $6aKs0.getBrowserTimeZone)()), [
        loggedInUser
    ]);
    // If app does not specifies edit view than we go with native edit view which will rely on redux state
    const isControlledEditing = extension.properties.edit ? isEditing : undefined;
    const onUpdateCallback = (0, $eUqFw.useCallback)((newValue)=>{
        if (typeof newValue === 'string' || typeof newValue === 'object' && newValue === null) onSave && onSave(newValue);
    }, [
        onSave
    ]);
    const analyticsAttributes = (0, $iZkNq.useAnalyticsAttributesContext)();
    const attributes = (0, $eUqFw.useMemo)(()=>({
            ...analyticsAttributes,
            renderMode: 'default'
        }), [
        analyticsAttributes
    ]);
    const renderContent = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldFireScreenEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
            attributes: attributes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zkAK.DateTimeField), {
            isFitContainerWidthReadView: true,
            readView: customReadView ? customReadView(value) : undefined,
            onEdit: onEditRequest,
            noValueText: formatMessage((0, $huhk2.genericMessages).noValue),
            issueKey: issueKey,
            fieldKey: fieldId,
            timeZone: timeZone,
            onUpdate: onUpdateCallback,
            onCancel: onCancel,
            isEditing: isControlledEditing
        })), [
        shouldFireScreenEvent,
        customReadView,
        value,
        onEditRequest,
        issueKey,
        fieldId,
        timeZone,
        onUpdateCallback,
        onCancel,
        attributes,
        formatMessage,
        isControlledEditing
    ]);
    const renderContentWithContentWrapper = ()=>{
        const FieldContentWrapper = fieldContentWrapper;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(FieldContentWrapper)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldContentWrapper, {
            topMargin: 0.75 * (0, $c9TLT.gridSize)
        }, renderContent());
        return renderContent();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jdZRd.DateTimeFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, titleView), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldId,
        label: label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), {
        "data-testid": "issue-view-base.context.ecosystem.forge.custom-field.fields.date-time.side-by-side-field",
        isEditing: isControlledEditing
    }, renderContentWithContentWrapper()));
};
var $abe58f7609e171dc$export$2e2bcd8739ae039 = $abe58f7609e171dc$export$27a5bd065ad55220;

});
parcelRegister("6aKs0", function(module, exports) {

$parcel$export(module.exports, "SYDNEY_TIMEZONE", () => $c7bf7e7164aeb193$export$1a022a080ce6c5bb);
$parcel$export(module.exports, "getBrowserTimeZone", () => $c7bf7e7164aeb193$export$efc596861aea1477);
const $c7bf7e7164aeb193$export$1a022a080ce6c5bb = 'Australia/Sydney';
const $c7bf7e7164aeb193$export$efc596861aea1477 = ()=>Intl.DateTimeFormat().resolvedOptions().timeZone || $c7bf7e7164aeb193$export$1a022a080ce6c5bb;

});


parcelRegister("bgSwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d90a6b53efac07$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $5iWql = parcelRequire("5iWql");

var $1boRu = parcelRequire("1boRu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $8411R = parcelRequire("8411R");

var $jxxzJ = parcelRequire("jxxzJ");

var $huhk2 = parcelRequire("huhk2");

var $7TScN = parcelRequire("7TScN");

var $iZkNq = parcelRequire("iZkNq");

var $9kbyQ = parcelRequire("9kbyQ");
const $88d90a6b53efac07$var$fromSelectOption = (0, $5iWql.default)((option)=>!option ? null : {
        name: String(option.value)
    });
const $88d90a6b53efac07$var$toSelectOption = (0, $5iWql.default)((value)=>!value ? null : {
        value: String(value.name),
        content: String(value.name)
    });
const $88d90a6b53efac07$export$27a5bd065ad55220 = ({ fieldId: fieldId, shouldFireScreenEvent: shouldFireScreenEvent, value: value, customReadView: customReadView, onChange: onChange, ...restProps })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ value: fieldConfig }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    const allowEmptyValue = (fieldConfig && !fieldConfig[fieldId]?.isRequired) ?? false;
    const fetchSuggestions = (0, $7TScN.fetchSuggestionsFactory)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onChangeWithTransformation = (0, $eUqFw.useCallback)((newValue)=>onChange($88d90a6b53efac07$var$fromSelectOption(newValue)), [
        onChange
    ]);
    const customReadViewWithTransformation = (0, $eUqFw.useCallback)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(customReadView) ? customReadView(value) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null), [
        value,
        customReadView
    ]);
    const optionalCustomReadView = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(customReadView) ? customReadViewWithTransformation : undefined;
    const analyticsAttributes = (0, $iZkNq.useAnalyticsAttributesContext)();
    const attributes = (0, $eUqFw.useMemo)(()=>({
            ...analyticsAttributes,
            renderMode: 'default'
        }), [
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldFireScreenEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: attributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jxxzJ.default), {
        ...restProps,
        fieldId: fieldId,
        allowEmptyValue: allowEmptyValue,
        fetchSuggestions: fetchSuggestions,
        renderReadView: optionalCustomReadView,
        value: $88d90a6b53efac07$var$toSelectOption(value),
        placeholder: formatMessage((0, $9kbyQ.default).placeholder),
        noValueText: formatMessage((0, $huhk2.genericMessages).noValue),
        onChange: onChangeWithTransformation,
        hasAutocomplete: true
    }));
};
var $88d90a6b53efac07$export$2e2bcd8739ae039 = $88d90a6b53efac07$export$27a5bd065ad55220;

});
parcelRegister("7TScN", function(module, exports) {

$parcel$export(module.exports, "toItem", () => $2d2c01b4a3d490a3$export$349df36256e1ddc6);
$parcel$export(module.exports, "fetchSuggestionsFactory", () => $2d2c01b4a3d490a3$export$2b81811283cd2d9d);

var $5iWql = parcelRequire("5iWql");

var $2OdyW = parcelRequire("2OdyW");
const $2d2c01b4a3d490a3$export$349df36256e1ddc6 = (group)=>({
        content: group.name,
        value: group.name
    });
const $2d2c01b4a3d490a3$export$1d0ee4320c26fb60 = (suggestionsFromServer)=>{
    if (!suggestionsFromServer || !suggestionsFromServer.groups) return [
        {
            items: []
        }
    ];
    return [
        {
            items: suggestionsFromServer.groups.map($2d2c01b4a3d490a3$export$349df36256e1ddc6)
        }
    ];
};
const $2d2c01b4a3d490a3$export$2b81811283cd2d9d = (0, $5iWql.default)(()=>(query)=>(0, $2OdyW.default)(`/rest/api/2/groups/picker?query=${encodeURIComponent(query)}`).then((response)=>$2d2c01b4a3d490a3$export$1d0ee4320c26fb60(response)));

});

parcelRegister("9kbyQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $429711caa77f5996$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $429711caa77f5996$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.forge.group.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "Select group"
    }
});

});


parcelRegister("hvLI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f2e69698bf31742$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $5iWql = parcelRequire("5iWql");

var $1boRu = parcelRequire("1boRu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $8411R = parcelRequire("8411R");

var $18KtE = parcelRequire("18KtE");

var $huhk2 = parcelRequire("huhk2");

var $7TScN = parcelRequire("7TScN");

var $iZkNq = parcelRequire("iZkNq");

var $08S64 = parcelRequire("08S64");
const $0f2e69698bf31742$var$fromSelectOption = (0, $5iWql.default)((option)=>option.map((o)=>({
            name: String(o.value)
        })));
const $0f2e69698bf31742$var$toSelectOption = (0, $5iWql.default)((value)=>!value ? [] : value.map((v)=>({
            value: String(v.name),
            content: String(v.name)
        })));
const $0f2e69698bf31742$export$27a5bd065ad55220 = ({ fieldId: fieldId, shouldFireScreenEvent: shouldFireScreenEvent, value: value, customReadView: customReadView, onChange: onChange, ...restProps })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ value: fieldConfig }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    const allowEmptyValue = (fieldConfig && !fieldConfig[fieldId]?.isRequired) ?? false;
    const fetchSuggestions = (0, $7TScN.fetchSuggestionsFactory)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onChangeWithTransformation = (0, $eUqFw.useCallback)((newValue)=>onChange($0f2e69698bf31742$var$fromSelectOption(newValue)), [
        onChange
    ]);
    const customReadViewWithTransformation = (0, $eUqFw.useCallback)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(customReadView) ? customReadView(value) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null), [
        value,
        customReadView
    ]);
    const optionalCustomReadView = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(customReadView) ? customReadViewWithTransformation : undefined;
    const analyticsAttributes = (0, $iZkNq.useAnalyticsAttributesContext)();
    const attributes = (0, $eUqFw.useMemo)(()=>({
            ...analyticsAttributes,
            renderMode: 'default'
        }), [
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldFireScreenEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: attributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $18KtE.default), {
        ...restProps,
        fieldId: fieldId,
        allowEmptyValue: allowEmptyValue,
        fetchSuggestions: fetchSuggestions,
        value: $0f2e69698bf31742$var$toSelectOption(value),
        customReadView: optionalCustomReadView,
        placeholder: formatMessage((0, $08S64.default).placeholder),
        noValueText: formatMessage((0, $huhk2.genericMessages).noValue),
        onChange: onChangeWithTransformation
    }));
};
var $0f2e69698bf31742$export$2e2bcd8739ae039 = $0f2e69698bf31742$export$27a5bd065ad55220;

});
parcelRegister("08S64", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff88c5e8de7f45d6$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $ff88c5e8de7f45d6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.forge.groups.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "Select groups"
    }
});

});


parcelRegister("1eeQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $22367605978a7a44$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $jG2Eu = parcelRequire("jG2Eu");

var $1boRu = parcelRequire("1boRu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $8411R = parcelRequire("8411R");

var $huhk2 = parcelRequire("huhk2");

var $guDlK = parcelRequire("guDlK");

var $gd0Sp = parcelRequire("gd0Sp");

var $CmfBs = parcelRequire("CmfBs");

var $6xujD = parcelRequire("6xujD");

var $gzP87 = parcelRequire("gzP87");

var $iZkNq = parcelRequire("iZkNq");

var $ck9Uy = parcelRequire("ck9Uy");

var $bOFmK = parcelRequire("bOFmK");
const $22367605978a7a44$var$validateFn = (values)=>{
    const valuesToValidate = values.map((element)=>({
            value: String(element.value),
            content: element.content,
            href: element.href || ''
        }));
    return (0, $bOFmK.validate)(valuesToValidate);
};
const $22367605978a7a44$export$27a5bd065ad55220 = ({ fieldId: fieldId, value: value, onChange: onChange, shouldFireScreenEvent: shouldFireScreenEvent, extension: extension, customReadView: customReadView, ...restProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const [{ value: fieldConfig }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    const fieldAutoCompleteUrl = (fieldConfig && fieldConfig[fieldId].autoCompleteUrl) ?? null;
    const { baseUrl: baseUrl } = (0, $gd0Sp.useTenantContext)();
    const fetchSuggestions = (0, $CmfBs.getMemoizedSuggestionsFactory)(fieldAutoCompleteUrl, fieldId, undefined, undefined, formatMessage);
    const formatCreateLabel = (0, $eUqFw.useCallback)((inputValue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $ck9Uy.default).createNewItem, {
            value: inputValue
        })), [
        formatMessage
    ]);
    const transformedValue = (0, $eUqFw.useMemo)(()=>{
        const transformerContext = {
            baseUrl: baseUrl,
            projectKey: projectKey,
            issueKey: issueKey,
            fieldId: fieldId
        };
        const transValue = (0, $6xujD.transformFromStateValue)(value, transformerContext).map((element)=>({
                value: String(element.value),
                content: element.content,
                href: element.href || ''
            }));
        return transValue;
    }, [
        baseUrl,
        projectKey,
        issueKey,
        fieldId,
        value
    ]);
    const onChangeWithTransform = (0, $eUqFw.useCallback)((newValue)=>{
        const transValue = (0, $6xujD.transformToStateValue)(newValue.map((element)=>({
                value: String(element.value),
                content: element.content,
                href: element.href || ''
            })));
        onChange(transValue);
    }, [
        onChange
    ]);
    const customReadViewWithTransformation = (0, $eUqFw.useCallback)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(customReadView) ? customReadView(value) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null), [
        value,
        customReadView
    ]);
    const optionalCustomReadView = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(customReadView) ? customReadViewWithTransformation : undefined;
    const analyticsAttributes = (0, $iZkNq.useAnalyticsAttributesContext)();
    const attributes = (0, $eUqFw.useMemo)(()=>({
            ...analyticsAttributes,
            renderMode: 'default'
        }), [
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldFireScreenEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: attributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gzP87.default), {
        ...restProps,
        issueKey: issueKey,
        fieldId: fieldId,
        formatMessage: formatMessage,
        fetchSuggestions: fetchSuggestions,
        placeholder: formatMessage((0, $ck9Uy.default).placeholder),
        noValueText: formatMessage((0, $huhk2.genericMessages).noValue),
        customReadView: optionalCustomReadView,
        canCreateNewItem: true,
        allowEmptyValue: true,
        validate: $22367605978a7a44$var$validateFn,
        formatCreateLabel: formatCreateLabel,
        value: transformedValue,
        onChange: onChangeWithTransform,
        initFieldOptions: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }));
};
var $22367605978a7a44$export$2e2bcd8739ae039 = $22367605978a7a44$export$27a5bd065ad55220;

});
parcelRegister("CmfBs", function(module, exports) {

$parcel$export(module.exports, "getMemoizedSuggestionsFactory", () => $36123aff944afb28$export$bdf4c14af95757ad);
$parcel$export(module.exports, "getMemoizedPrefetchSuggestionsFactory", () => $36123aff944afb28$export$8abfe47a3e2c339a);

var $jqvCZ = parcelRequire("jqvCZ");

var $795rA = parcelRequire("795rA");

var $8uNQc = parcelRequire("8uNQc");

var $2OdyW = parcelRequire("2OdyW");

var $kwEon = parcelRequire("kwEon");
var $lhFcf = parcelRequire("lhFcf");

var $f9RL0 = parcelRequire("f9RL0");

var $lO4Or = parcelRequire("lO4Or");

var $6xujD = parcelRequire("6xujD");
const $36123aff944afb28$var$labelsCache = (0, $795rA.getLabelsCache)();
const $36123aff944afb28$export$2b81811283cd2d9d = (autoCompleteUrl, fieldId, fieldEditSessionId, createAnalyticsEvent, formatMessage)=>(query, sessionId)=>{
        if (autoCompleteUrl == null) return Promise.resolve([]);
        let url = `${autoCompleteUrl}${encodeURIComponent(query)}`;
        if (sessionId != null) url = `${url}&sessionId=${sessionId}`;
        if (fieldEditSessionId != null) url = `${url}&fieldEditSessionId=${fieldEditSessionId}`;
        const startTime = (0, $8uNQc.default).now();
        const queryLength = query.length;
        return Promise.all([
            (0, $2OdyW.default)(url),
            $36123aff944afb28$var$labelsCache.getAll()
        ]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then(([dataFromAPI, cache])=>{
            fieldId === (0, $lO4Or.LABELS_TYPE) && // @ts-expect-error - TS2345 - Argument of type 'CreateUIAnalyticsEvent | null | undefined' is not assignable to parameter of type 'CreateUIAnalyticsEvent | undefined'.
            (0, $kwEon.fireSuggestionsRequestSuccessEvent)((0, $f9RL0.LABELS), startTime, createAnalyticsEvent, {
                sessionId: sessionId,
                queryLength: queryLength
            });
            return (0, $6xujD.transformSuggestionsFromServerAndCache)(dataFromAPI, cache, formatMessage);
        }).catch((error)=>{
            fieldId === (0, $lO4Or.LABELS_TYPE) && // @ts-expect-error - TS2345 - Argument of type 'CreateUIAnalyticsEvent | null | undefined' is not assignable to parameter of type 'CreateUIAnalyticsEvent | undefined'.
            (0, $kwEon.fireSuggestionsRequestFailedEvent)((0, $f9RL0.LABELS), startTime, createAnalyticsEvent, {
                sessionId: sessionId
            });
            throw error;
        });
    };
const $36123aff944afb28$export$bdf4c14af95757ad = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))($36123aff944afb28$export$2b81811283cd2d9d, (url, session)=>`${url}_${session}`);
const $36123aff944afb28$export$2d95b66f107864b4 = (prefetchResult, viewProps)=>(query, assignSessionId)=>{
        if (!query && prefetchResult !== undefined && prefetchResult !== null) {
            const { prefetched: prefetched, fieldValuePromise: fieldValuePromise, sessionId: sessionId, prefetchSessionId: prefetchSessionId } = prefetchResult;
            const { createAnalyticsEvent: createAnalyticsEvent } = viewProps;
            if (prefetched && fieldValuePromise !== null && sessionId !== null) {
                (0, $lhFcf.triggerCacheHitEvent)(createAnalyticsEvent, prefetchSessionId, assignSessionId || '', sessionId, (0, $f9RL0.LABELS));
                const startTime = (0, $8uNQc.default).now();
                return Promise.all([
                    fieldValuePromise,
                    $36123aff944afb28$var$labelsCache.getAll()
                ]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .then(([dataFromAPI, cache])=>{
                    // query length for prefetch should be 0
                    (0, $kwEon.fireSuggestionsRequestSuccessEvent)((0, $f9RL0.LABELS), startTime, createAnalyticsEvent, {
                        sessionId: assignSessionId,
                        isPrefetched: true,
                        queryLength: 0
                    });
                    return (0, $6xujD.transformSuggestionsFromServerAndCache)(dataFromAPI, cache, viewProps.formatMessage);
                }).catch((error)=>{
                    (0, $kwEon.fireSuggestionsRequestFailedEvent)((0, $f9RL0.LABELS), startTime, createAnalyticsEvent, {
                        sessionId: assignSessionId,
                        isPrefetched: true
                    });
                    throw error;
                });
            }
            (0, $lhFcf.triggerCacheMissEvent)(createAnalyticsEvent, prefetchSessionId, assignSessionId || '', (0, $f9RL0.LABELS));
        }
        return viewProps.fetchSuggestions(query, assignSessionId);
    };
const $36123aff944afb28$export$8abfe47a3e2c339a = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))($36123aff944afb28$export$2d95b66f107864b4, (prefetchResult, viewProps)=>`${prefetchResult && prefetchResult.prefetchSessionId || ''}_${viewProps.issueKey}`);

});
parcelRegister("795rA", function(module, exports) {

$parcel$export(module.exports, "getLabelsCache", () => $067031930a03af74$export$f7e90ae127ed72ef);

var $jhVpU = parcelRequire("jhVpU");

var $4kPng = parcelRequire("4kPng");
const $067031930a03af74$var$labelsCaches = {};
const $067031930a03af74$export$f7e90ae127ed72ef = (labelsFieldId)=>{
    const cacheKey = labelsFieldId || (0, $4kPng.props).cacheKey;
    if (!$067031930a03af74$var$labelsCaches[cacheKey]) $067031930a03af74$var$labelsCaches[cacheKey] = (0, $jhVpU.default)({
        ...(0, $4kPng.props),
        cacheKey: cacheKey
    });
    return $067031930a03af74$var$labelsCaches[cacheKey];
};

});
parcelRegister("4kPng", function(module, exports) {

$parcel$export(module.exports, "props", () => $8a5603666df57d90$export$8128bb6492cf3de7);

const $8a5603666df57d90$var$MAX_RESULTS = 10;
const $8a5603666df57d90$var$CACHE_SIZE = $8a5603666df57d90$var$MAX_RESULTS * 2;
const $8a5603666df57d90$var$LABELS_CACHE_KEY = 'labels';
const $8a5603666df57d90$export$8128bb6492cf3de7 = {
    size: $8a5603666df57d90$var$CACHE_SIZE,
    cacheKey: $8a5603666df57d90$var$LABELS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)
};

});


parcelRegister("6xujD", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $34aa3d39d570086b$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $34aa3d39d570086b$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformToCacheItem", () => $34aa3d39d570086b$export$414142b656d35285);
$parcel$export(module.exports, "transformSuggestionsFromServerAndCache", () => $34aa3d39d570086b$export$ecddc37cd50b50fd);

var $8g5hT = parcelRequire("8g5hT");

var $8JR0x = parcelRequire("8JR0x");
const $34aa3d39d570086b$export$faff4881e53b3cb6 = (fieldId)=>{
    const customFieldPrefix = 'customfield_';
    if (fieldId.startsWith(customFieldPrefix)) {
        const customId = fieldId.substring(customFieldPrefix.length, fieldId.length);
        return `cf[${customId}]`;
    }
    return fieldId;
};
const $34aa3d39d570086b$export$cb172b2468ab5652 = (value, { baseUrl: baseUrl, fieldId: fieldId })=>{
    // Label custom fields can have a null value
    if (!value) return [];
    return value.map((item)=>{
        const jqlEncodedValue = encodeURIComponent(`${$34aa3d39d570086b$export$faff4881e53b3cb6(fieldId)} = ${(0, $8g5hT.toQuotedString)(item)}`);
        return {
            content: item,
            value: item,
            href: `${baseUrl}/issues/?jql=${jqlEncodedValue}`
        };
    });
};
const $34aa3d39d570086b$export$1cfcb95cb8fbddb3 = (value)=>value.map((item)=>item.value);
const $34aa3d39d570086b$var$transformItem = (suggestion)=>({
        content: suggestion.label,
        value: suggestion.label
    });
const $34aa3d39d570086b$export$414142b656d35285 = (label)=>({
        label: label
    });
const $34aa3d39d570086b$var$MAX_RESULTS = 5;
const $34aa3d39d570086b$export$64c1e7aa265973f8 = (cache)=>cache.slice(-1 * $34aa3d39d570086b$var$MAX_RESULTS).reverse();
const $34aa3d39d570086b$export$ecddc37cd50b50fd = (response, cache = [], formatMessage)=>{
    const serverItems = response.suggestions || [];
    const cacheLists = $34aa3d39d570086b$export$64c1e7aa265973f8(cache);
    return [
        {
            heading: formatMessage((0, $8JR0x.default).recent),
            items: cacheLists.map($34aa3d39d570086b$var$transformItem)
        },
        {
            heading: formatMessage((0, $8JR0x.default).all),
            items: serverItems.map($34aa3d39d570086b$var$transformItem)
        }
    ];
};

});
parcelRegister("8JR0x", function(module, exports) {

$parcel$export(module.exports, "default", () => $f99cb50789a44451$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $f99cb50789a44451$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "issue.labels.label",
        "defaultMessage": "Labels"
    },
    placeholder: {
        "id": "issue.labels.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "Select Label"
    },
    createNewItem: {
        "id": "issue.labels.create-new-item-message",
        "defaultMessage": "New label"
    },
    recent: {
        "id": "issue.labels.recent-items",
        "defaultMessage": "Recent labels"
    },
    all: {
        "id": "issue.labels.all-items",
        "defaultMessage": "All labels"
    }
});

});



parcelRegister("gzP87", function(module, exports) {

$parcel$export(module.exports, "default", () => $41d2d40a53f14b8e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jqvCZ = parcelRequire("jqvCZ");

var $18KtE = parcelRequire("18KtE");

var $f9RL0 = parcelRequire("f9RL0");

var $lO4Or = parcelRequire("lO4Or");

var $aaQTg = parcelRequire("aaQTg");

var $CmfBs = parcelRequire("CmfBs");
// eslint-disable-next-line jira/react/no-class-components
class $41d2d40a53f14b8e$var$LabelsView extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'LabelsView';
    }
    componentDidMount() {
        this.props.initFieldOptions();
        this.getDataFromCache();
    }
    renderMultiSelectInlineEditView(props) {
        const { initFieldOptions: initFieldOptions, issueKey: issueKey, createAnalyticsEvent: createAnalyticsEvent, formatMessage: formatMessage, ...otherProps } = props;
        const instrumentationProps = this.props.fieldId === (0, $lO4Or.LABELS_TYPE) ? {
            onEditRequest: this.onEditRequest,
            onConfirm: this.onConfirm,
            onCancel: this.onCancel,
            onChange: this.onChange,
            onDataRequest: this.onDataRequest,
            onDataLoaded: this.onDataLoaded
        } : {};
        const { data: data, loading: loading, error: error } = this.state;
        const initialData = {
            data: data,
            loading: loading,
            error: error
        };
        const fetchSuggestionsFromProps = this.fetchSuggestions(props.fetchSuggestions);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41d2d40a53f14b8e$var$MemoizedLabels, {
            debounceFetchSuggestionsTime: 400,
            initialData: initialData,
            ...otherProps,
            fetchSuggestions: fetchSuggestionsFromProps,
            ...instrumentationProps,
            issueKey: issueKey
        });
    }
    renderWithCachedValue() {
        const { issueKey: issueKey } = this.props;
        const FieldLoadedValueSubscriber = (0, $aaQTg.getFieldLoadedValueSubscriber)(issueKey, (0, $f9RL0.LABELS));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldLoadedValueSubscriber, {
            fieldId: (0, $f9RL0.LABELS)
        }, (prefetchResult)=>{
            const fetchSuggestions = (0, $CmfBs.getMemoizedPrefetchSuggestionsFactory)(prefetchResult, this.props);
            const newProps = {
                ...this.props,
                fetchSuggestions: fetchSuggestions
            };
            return this.renderMultiSelectInlineEditView(newProps);
        });
    }
    render() {
        if (this.props.fieldId === (0, $f9RL0.LABELS)) return this.renderWithCachedValue();
        return this.renderMultiSelectInlineEditView(this.props);
    }
    constructor(...args){
        super(...args);
        this.state = {
            data: [],
            loading: false,
            error: false
        };
        this.getDataFromCache = ()=>{
            this.props.getDataFromCache?.().then((data)=>{
                this.setState({
                    data: data,
                    loading: false
                });
            });
        };
        this.fetchSuggestions = (fetchSuggestions)=>(query, sessionId)=>fetchSuggestions(query, sessionId).then((data)=>{
                    this.setState({
                        data: data
                    });
                    return data;
                });
        this.onEditRequest = ()=>{
            this.props.onEditRequest();
        };
        this.onConfirm = ()=>{
            this.props.onConfirm();
        };
        this.onCancel = ()=>{
            this.props.onCancel();
        };
        this.onChange = (selectedValues, _actionMeta)=>{
            this.props.onChange(selectedValues);
        };
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.onDataRequest = ({ isInitial: _ })=>{};
        // go/jfe-eslint
        // @ts-expect-error - TS2741 - Property 'isInitial' is missing in type '{}' but required in type '{ isInitial: boolean; }'.
        this.onDataLoaded = ({ isInitial: _ } = {})=>{};
    }
}
const $41d2d40a53f14b8e$var$MemoizedLabels = (props)=>{
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fetchSuggestions = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(props.fetchSuggestions, (url)=>`${url}_${props.fieldEditSessionId || ''}`), [
        props.fetchSuggestions,
        props.fieldEditSessionId,
        props.invalidMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $18KtE.default), {
        ...props,
        fetchSuggestions: fetchSuggestions
    });
};
var $41d2d40a53f14b8e$export$2e2bcd8739ae039 = $41d2d40a53f14b8e$var$LabelsView;

});

parcelRegister("ck9Uy", function(module, exports) {

$parcel$export(module.exports, "default", () => $64bb980a57fef712$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $64bb980a57fef712$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.forge.labels.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "Select label"
    },
    createNewItem: {
        "id": "issue.forge.labels.create-new-item-message",
        "defaultMessage": "{value} (New label)"
    }
});

});

parcelRegister("bOFmK", function(module, exports) {

$parcel$export(module.exports, "validate", () => $96d4dc4dfcb6b640$export$a22775fa5e2eebd9);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $ddZ4y = parcelRequire("ddZ4y");
const $96d4dc4dfcb6b640$export$a22775fa5e2eebd9 = (values)=>{
    if (values.length > (0, $ddZ4y.MAX_ALLOWED_LABELS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        id: "issue.labels-view.input-too-many-labels",
        defaultMessage: "Can't have more than {max} labels.",
        values: {
            max: (0, $ddZ4y.MAX_ALLOWED_LABELS)
        }
    });
    const isInvalid = values.map((value)=>value.content.trim()).some((content)=>content.length > (0, $ddZ4y.MAX_LABEL_SIZE));
    return isInvalid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        id: "issue.labels-view.input-label-is-invalid",
        defaultMessage: "Labels can't have more than {max} characters.",
        values: {
            max: (0, $ddZ4y.MAX_LABEL_SIZE)
        }
    }) : undefined;
};

});
parcelRegister("ddZ4y", function(module, exports) {

$parcel$export(module.exports, "MAX_LABEL_SIZE", () => $cf0ccc41f92f7fa3$export$9151073f92820ff8);
$parcel$export(module.exports, "MAX_ALLOWED_LABELS", () => $cf0ccc41f92f7fa3$export$1fdf850c93de8bae);
$parcel$export(module.exports, "validate", () => $cf0ccc41f92f7fa3$export$a22775fa5e2eebd9);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
const $cf0ccc41f92f7fa3$export$9151073f92820ff8 = 255;
const $cf0ccc41f92f7fa3$export$1fdf850c93de8bae = 55;
const $cf0ccc41f92f7fa3$export$a22775fa5e2eebd9 = (values)=>{
    if (values.length > $cf0ccc41f92f7fa3$export$1fdf850c93de8bae) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        id: "issue.labels-view.input-too-many-labels",
        defaultMessage: "Can't have more than {max} labels.",
        values: {
            max: $cf0ccc41f92f7fa3$export$1fdf850c93de8bae
        }
    });
    const isInvalid = values.map((value)=>value.content.trim()).some((content)=>content.includes(' ') || content.length > $cf0ccc41f92f7fa3$export$9151073f92820ff8);
    return isInvalid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        id: "issue.labels-view.input-label-is-invalid",
        defaultMessage: "Labels can't have spaces or be more than {max} characters.",
        values: {
            max: $cf0ccc41f92f7fa3$export$9151073f92820ff8
        }
    }) : undefined;
};

});



parcelRegister("1KJ1D", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c917d2f4bdc2b07$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1boRu = parcelRequire("1boRu");

var $7wpzp = parcelRequire("7wpzp");

var $iZkNq = parcelRequire("iZkNq");
const $3c917d2f4bdc2b07$var$getFieldType = (forgeType)=>{
    switch(forgeType){
        case 'string':
            return 'text';
        case 'number':
            return forgeType;
        case 'object':
            return forgeType;
        default:
            return 'text';
    }
};
const $3c917d2f4bdc2b07$export$27a5bd065ad55220 = ({ shouldFireScreenEvent: shouldFireScreenEvent, extension: extension, ...restProps })=>{
    const { type: type } = extension.properties;
    const analyticsAttributes = (0, $iZkNq.useAnalyticsAttributesContext)();
    const attributes = (0, $eUqFw.useMemo)(()=>({
            ...analyticsAttributes,
            renderMode: 'default'
        }), [
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldFireScreenEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: attributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7wpzp.default), {
        ...restProps,
        noValueText: null,
        type: $3c917d2f4bdc2b07$var$getFieldType(type)
    }));
};
var $3c917d2f4bdc2b07$export$2e2bcd8739ae039 = $3c917d2f4bdc2b07$export$27a5bd065ad55220;

});
parcelRegister("7wpzp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0620d7aebc2e8689$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2gGF1 = parcelRequire("2gGF1");

var $4ixnM = parcelRequire("4ixnM");

var $jXQ07 = parcelRequire("jXQ07");

var $elM3a = parcelRequire("elM3a");

var $1ybV0 = parcelRequire("1ybV0");

var $90IgZ = parcelRequire("90IgZ");
var $4ksts = parcelRequire("4ksts");

var $9LvPd = parcelRequire("9LvPd");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $6oQPP = parcelRequire("6oQPP");

var $4bZws = parcelRequire("4bZws");

var $4xwq2 = parcelRequire("4xwq2");

var $hzcvF = parcelRequire("hzcvF");

var $b3bu0 = parcelRequire("b3bu0");

var $jzS9W = parcelRequire("jzS9W");

var $dM5tc = parcelRequire("dM5tc");
// eslint-disable-next-line no-script-url
const $0620d7aebc2e8689$var$forbiddenScheme = 'javascript:';
const $0620d7aebc2e8689$var$formatReadValue = (type, value)=>{
    switch(type){
        case 'number':
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90IgZ.FormattedNumber), {
                value: parseInt(value, 10)
            });
        // The text field tries to be helpful with linking and formatting
        case 'text':
            if ((0, $4ixnM.default)(value)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: `mailto:${value}`
            }, value);
            // Must come before url check because (e.g.) 42.1 is a valid url
            if (Number(value)) return value;
            if ((0, $jXQ07.default)(value, true) && !value.toString().startsWith($0620d7aebc2e8689$var$forbiddenScheme)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                rel: "noopener noreferrer",
                href: (0, $elM3a.default)(value, '//'),
                target: "_blank"
            }, value);
            return value;
        // The url field is forced to be a link
        case 'url':
            if (value.toString().startsWith($0620d7aebc2e8689$var$forbiddenScheme)) return value;
            if ((0, $4ixnM.default)(value)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: `mailto:${value}`
            }, value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: (0, $elM3a.default)(value, '//'),
                target: "_blank"
            }, value);
        case 'object':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, JSON.stringify(value));
        default:
            return value;
    }
};
const $0620d7aebc2e8689$export$ad603a514b680587 = ({ isEditable: isEditable = false, isEditing: isEditing = false, isMobile: isMobile = false, value: value = null, noValueText: noValueText = null, invalidMessage: propInvalidMessage = null, type: type = 'text', label: label = '', issueKey: issueKey, placeholder: placeholder, fieldId: fieldId, showPinButton: showPinButton, customReadView: customReadView, titleView: titleView = label, fieldContentWrapper: FieldContentWrapper, onEditRequest: onEditRequest, onCancel: onCancel, onChange: onChange, onConfirm: onConfirm })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const editFieldRef = (0, $eUqFw.useRef)(null);
    const [invalidMessage, setInvalidMessage] = (0, $eUqFw.useState)(null);
    const [showValidationMessage, setShowValidationMessage] = (0, $eUqFw.useState)(false);
    const [displayValue, setDisplayValue] = (0, $eUqFw.useState)(null);
    const testId = `issue.views.field.single-line-text-inline-edit.${fieldId}`;
    const previousValue = (0, $hzcvF.usePrevious)(value);
    const handleOnChange = (0, $eUqFw.useCallback)((event)=>{
        let lValue;
        if (type === 'number') {
            if (event.target.value === '') lValue = null;
            else {
                lValue = Number(event.target.value);
                setDisplayValue(event.target.value);
            }
        } else if (type === 'object') try {
            lValue = JSON.parse(event.target.value);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            lValue = event.target.value;
        }
        else lValue = event.target.value;
        if (type === 'url') {
            setShowValidationMessage(false);
            let { validationMessage: validationMessage } = event.target;
            if (event.target.value.toString().startsWith($0620d7aebc2e8689$var$forbiddenScheme)) validationMessage = formatMessage((0, $b3bu0.default).validUrl);
            setInvalidMessage(validationMessage);
        }
        onChange(lValue);
    }, [
        formatMessage,
        onChange,
        type
    ]);
    const handleOnConfirm = (0, $eUqFw.useCallback)(()=>{
        if (invalidMessage) {
            setShowValidationMessage(true);
            editFieldRef.current?.focus();
        } else onConfirm();
    }, [
        editFieldRef,
        invalidMessage,
        onConfirm
    ]);
    const handleOnCancel = (0, $eUqFw.useCallback)(()=>{
        if (type === 'url') {
            setShowValidationMessage(false);
            setInvalidMessage(null);
        }
        onCancel();
    }, [
        onCancel,
        type
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (previousValue !== undefined && type === 'number' && value !== previousValue) setDisplayValue(null);
    }, [
        previousValue,
        type,
        value
    ]);
    const editView = (0, $eUqFw.useMemo)(()=>{
        if (!isEditable) return null;
        let lDisplayValue = '';
        if (value != null) {
            if (type === 'object' && typeof value === 'object') lDisplayValue = JSON.stringify(value);
            else lDisplayValue = displayValue || value.toString();
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jzS9W.default), {
            compact: (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i'),
            ref: editFieldRef,
            type: type,
            value: lDisplayValue,
            placeholder: placeholder,
            onChange: handleOnChange,
            invalidMessage: propInvalidMessage || (showValidationMessage ? invalidMessage : null)
        });
    }, [
        displayValue,
        handleOnChange,
        invalidMessage,
        isEditable,
        placeholder,
        propInvalidMessage,
        showValidationMessage,
        type,
        value
    ]);
    const readView = (0, $eUqFw.useMemo)(()=>{
        if (customReadView) return customReadView(value);
        if (value == null || value === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), null, noValueText);
        const lDisplayValue = $0620d7aebc2e8689$var$formatReadValue(type, value);
        const lTestId = `issue.views.field.single-line-text-inline-edit.read-view.${fieldId}`;
        if (type === 'text') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": lTestId
        }, lDisplayValue);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.Ellipsis), {
            "data-testid": lTestId,
            // @ts-expect-error - TS2322 - Type 'Element | NumberOrString' is not assignable to type 'string | undefined'.
            title: lDisplayValue
        }, lDisplayValue) /* eslint-enable jira/integration/enforce-data-testid-usage */ ;
    }, [
        customReadView,
        fieldId,
        noValueText,
        type,
        value
    ]);
    const readViewWithContentWrapper = (0, $eUqFw.useMemo)(()=>{
        if (FieldContentWrapper) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dM5tc.ReadViewContainer), {
            "data-component-selector": (0, $dM5tc.readViewContainerSelectorName)
        }, readView));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dM5tc.ReadViewContainer), {
            "data-component-selector": (0, $dM5tc.readViewContainerSelectorName)
        }, readView);
    }, [
        FieldContentWrapper,
        readView
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), {
        fieldId: fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, titleView), issueKey !== undefined && fieldId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldId,
        label: label
    }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldId,
        label: label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), {
        isEditing: isEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dM5tc.InlineEditContainer), {
        isEditing: isEditing,
        isEditable: isEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        isLabelHidden: true,
        label: label,
        readView: readViewWithContentWrapper,
        editView: editView,
        isEditing: isEditing,
        isEditable: isEditable,
        onConfirm: handleOnConfirm,
        onCancel: handleOnCancel,
        onEdit: onEditRequest,
        onEscape: handleOnCancel,
        readViewFitContainerWidth: !isMobile,
        editButtonLabel: formatMessage((0, $2gGF1.default).editButtonLabel, {
            fieldName: label
        }),
        confirmButtonLabel: formatMessage((0, $2gGF1.default).confirmButtonLabel, {
            fieldName: label
        }),
        cancelButtonLabel: formatMessage((0, $2gGF1.default).cancelButtonLabel, {
            fieldName: label
        })
    }))));
};
var $0620d7aebc2e8689$export$2e2bcd8739ae039 = $0620d7aebc2e8689$export$ad603a514b680587;

});
parcelRegister("4ixnM", function(module, exports) {

$parcel$export(module.exports, "default", () => $03220679a6b885f0$export$2e2bcd8739ae039);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
var $03220679a6b885f0$export$2e2bcd8739ae039 = (string)=>{
    if (!string || typeof string !== 'string') return false;
    return /\S+@\S+/.test(string);
};

});

parcelRegister("jXQ07", function(module, exports) {

$parcel$export(module.exports, "default", () => $48ae0ec2b139375a$export$2e2bcd8739ae039);
/**
 * The URL standard regex for spec.: RFC 3986
 * https://tools.ietf.org/html/rfc3986#page-51
 */ const $48ae0ec2b139375a$var$URLStandardRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?');
/**
 * Full Domain name limits as per RFC is 256 characters
 * TLD limit as per RFC 1035 is 63 characters. Although, TLDs can contain numbers, since none of the existing popular TLDs are numbers, we are not allowing numbers in TLD.
 * Any characters allowed in protocol and query string. Domain name needs to be alphanumeric with hyphens allowed.
 */ const $48ae0ec2b139375a$var$stricterURLRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?[-a-zA-Z0-9@:.]{2,256}.[a-z]{2,63}\\b([-a-zA-Z0-9@:%_+.~#?&//=]*)');
const $48ae0ec2b139375a$var$protocolRegex = new RegExp('^(http|https|ftp)://.*|^//[^/]*?');
function $48ae0ec2b139375a$export$bef94a5618bf18bf(string, strict = false) {
    // Have to be string
    if (!string || typeof string !== 'string') return false;
    // Exit early if there is a space, no need to regex that
    if (string.indexOf(' ') >= 0 || string.length === 0) return false;
    // Localhost is bit different, doesn't need a dot but others likely should
    if (string.indexOf('localhost') === -1 && string.indexOf('.') === -1) return false;
    if (strict === true) return $48ae0ec2b139375a$var$stricterURLRegex.test(string) || $48ae0ec2b139375a$var$protocolRegex.test(string);
    return $48ae0ec2b139375a$var$URLStandardRegex.test(string);
}
var $48ae0ec2b139375a$export$2e2bcd8739ae039 = $48ae0ec2b139375a$export$bef94a5618bf18bf;

});

parcelRegister("elM3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bea9a46c9159d23$export$2e2bcd8739ae039);

var $jXQ07 = parcelRequire("jXQ07");
/**
 * Absolute URL regex
 */ const $7bea9a46c9159d23$var$AbsoluteURLRegex = new RegExp(/^[a-z][a-z\d+.-]*:/);
var /**
 * Prefix url if it is url, return what we got if not
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$7bea9a46c9159d23$export$2e2bcd8739ae039 = (string, prefix)=>{
    // The same line is in isUrl, but flow requires it here too
    if (typeof string !== 'string' || !prefix) return string;
    // Exit early
    if (!(0, $jXQ07.default)(string)) return string;
    // Double slash urls are absolute too, relative to the schema used in current window
    if (string.substring(0, 2) === '//') return string;
    // If it's an absolute URL, return it, no need to prefix
    if ($7bea9a46c9159d23$var$AbsoluteURLRegex.test(string)) return string;
    // If it's a relative URL, prefix it with prefix
    return prefix + string;
};

});

parcelRegister("b3bu0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8599cea486b6530$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $c8599cea486b6530$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    validUrl: {
        "id": "issue.views.field.single-line-text.validUrl",
        "defaultMessage": "Please enter a valid URL."
    }
});

});

parcelRegister("jzS9W", function(module, exports) {

$parcel$export(module.exports, "default", () => $c528301d88030cff$export$2e2bcd8739ae039);
/* single-line-text-field-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7jPhn = parcelRequire("7jPhn");

var $5YsMl = parcelRequire("5YsMl");

var $cf2Y4 = parcelRequire("cf2Y4");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $2KzVh = parcelRequire("2KzVh");

var $gYYP4 = parcelRequire("gYYP4");
const $c528301d88030cff$var$Warning = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c528301d88030cff$var$WarningWrapper, {
        "data-testid": "issue-internal-field-single-line-text.warning-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        size: "medium",
        primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y300)})`,
        label: ""
    }));
const $c528301d88030cff$var$SingleLineTextField = (props, ref)=>{
    const { type: type = 'text', value: value = '', placeholder: placeholder = '', invalidMessage: invalidMessage, onChange: onChange, compact: compact = false } = props;
    const typingPerformanceTracingRef = (0, $gYYP4.default)('single-line-text-field-type-tracing');
    const fieldRef = (0, $2KzVh.default)(ref, typingPerformanceTracingRef);
    const afterElement = compact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: invalidMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c528301d88030cff$var$Warning, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c528301d88030cff$var$Warning, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        type: type,
        value: value,
        placeholder: placeholder,
        onChange: onChange,
        isInvalid: !!invalidMessage,
        autoFocus: true,
        ref: fieldRef,
        isCompact: compact,
        elemAfterInput: !!invalidMessage === true ? afterElement : null
    }), !compact && invalidMessage != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, invalidMessage) : null);
};
$c528301d88030cff$var$SingleLineTextField.displayName = 'SingleLineTextField';
var $c528301d88030cff$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.forwardRef)($c528301d88030cff$var$SingleLineTextField);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c528301d88030cff$var$WarningWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0r5cr _2hwx1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gYYP4", function(module, exports) {

$parcel$export(module.exports, "default", () => $25f3b9f7ec96214f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9oL1R = parcelRequire("9oL1R");

var $hompL = parcelRequire("hompL");

var $dZdw5 = parcelRequire("dZdw5");

var $4vWWq = parcelRequire("4vWWq");

var $fVaJL = parcelRequire("fVaJL");
const $25f3b9f7ec96214f$var$getTypingMetadata = (times, computeStartTime, typingPerformanceTracingMethod)=>{
    let min = 0;
    let max = 0;
    let avg = 0;
    let index = 0;
    let below50count = 0;
    times.forEach((time)=>{
        if (time !== 0) {
            avg = (avg * index + time) / ++index;
            if (time > max) max = time;
            if (min === 0 || time < min) min = time;
            if (time < 50) below50count++;
        }
    });
    return {
        typing: {
            min: min,
            max: max,
            avg: avg,
            count: index,
            below50count: below50count,
            compute: performance.now() - computeStartTime,
            typeTracingMethod: typingPerformanceTracingMethod
        }
    };
};
function $25f3b9f7ec96214f$var$typingPerformanceTracingTimeout(element, name, rate) {
    let tsubmit;
    let times = [];
    let isInteractionInitialised = false;
    let id;
    const start = ()=>{
        id = (0, $hompL.v4)();
        (0, $fVaJL.addNewInteraction)(id, name, 'typing', performance.now(), rate, null, null);
        isInteractionInitialised = true;
    };
    const end = ()=>{
        isInteractionInitialised = false;
        const timesCopy = times;
        times = [];
        (0, $9oL1R.unstable_scheduleCallback)((0, $9oL1R.unstable_IdlePriority), ()=>{
            const computeStartTime = performance.now();
            const data = $25f3b9f7ec96214f$var$getTypingMetadata(timesCopy, computeStartTime, 'timeout');
            (0, $fVaJL.addMetadata)(id, data);
            (0, $fVaJL.tryComplete)(id);
        });
    };
    const onKeyPressHandler = (event)=>{
        if (!isInteractionInitialised) start();
        const startTime = event.timeStamp;
        setTimeout(()=>{
            const endTime = performance.now();
            const time = endTime - startTime;
            times.push(time);
            clearTimeout(tsubmit);
            tsubmit = setTimeout(end, 2000); // debounce
        }, 0);
    };
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    element.addEventListener('keypress', onKeyPressHandler);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.removeEventListener('keypress', onKeyPressHandler);
    };
}
function $25f3b9f7ec96214f$var$typingPerformanceTracingTimeoutNoAlloc(element, name, rate) {
    let tsubmit;
    let isInteractionInitialised = false;
    let min = 0;
    let max = 0;
    let below50count = 0;
    let avg = 0;
    let count = 0;
    let id;
    const resetStats = ()=>{
        min = 0;
        max = 0;
        below50count = 0;
        avg = 0;
        count = 0;
    };
    const start = ()=>{
        id = (0, $hompL.v4)();
        (0, $fVaJL.addNewInteraction)(id, name, 'typing', performance.now(), rate, null, null);
        isInteractionInitialised = true;
    };
    const end = ()=>{
        isInteractionInitialised = false;
        const typingMetaData = {
            typing: {
                min: min,
                max: max,
                avg: avg,
                count: count,
                below50count: below50count,
                typeTracingMethod: 'timeoutNoAlloc'
            }
        };
        resetStats();
        (0, $9oL1R.unstable_scheduleCallback)((0, $9oL1R.unstable_IdlePriority), ()=>{
            (0, $fVaJL.addMetadata)(id, typingMetaData);
            (0, $fVaJL.tryComplete)(id);
        });
    };
    const onKeyPressHandler = (event)=>{
        if (!isInteractionInitialised) start();
        const startTime = event.timeStamp;
        setTimeout(()=>{
            const endTime = performance.now();
            const time = endTime - startTime;
            if (time !== 0) {
                avg = (avg * count + time) / ++count;
                if (time > max) max = time;
                if (min === 0 || time < min) min = time;
                if (time < 50) below50count++;
            }
            clearTimeout(tsubmit);
            tsubmit = setTimeout(end, 2000); // debounce
        }, 0);
    };
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    element.addEventListener('keypress', onKeyPressHandler);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.removeEventListener('keypress', onKeyPressHandler);
    };
}
function $25f3b9f7ec96214f$var$typingPerformanceTracingMutationObserver(element, name, rate) {
    let eventTime = -1;
    let isInteractionInitialised = false;
    let count = 0;
    let id;
    let tsubmit;
    const keyLimit = 20;
    const times = new Float64Array(keyLimit);
    const resetTimesArray = ()=>{
        times.fill(0);
    };
    const resetEventTime = ()=>{
        eventTime = -1;
    };
    const start = ()=>{
        id = (0, $hompL.v4)();
        (0, $fVaJL.addNewInteraction)(id, name, 'typing', performance.now(), rate, null, null);
        isInteractionInitialised = true;
    };
    const end = ()=>{
        isInteractionInitialised = false;
        if (count === 0) return;
        const timesCopy = new Float64Array(times);
        const countCopy = count;
        resetTimesArray();
        resetEventTime();
        count = 0;
        (0, $9oL1R.unstable_scheduleCallback)((0, $9oL1R.unstable_IdlePriority), ()=>{
            const computeStartTime = performance.now();
            const timesSubarray = timesCopy.subarray(0, countCopy);
            const data = $25f3b9f7ec96214f$var$getTypingMetadata(timesSubarray, computeStartTime, 'mutationObserver');
            (0, $fVaJL.addMetadata)(id, data);
            (0, $fVaJL.tryComplete)(id);
        });
    };
    const onKeyPressHandler = (event)=>{
        if (!isInteractionInitialised) start();
        eventTime = event.timeStamp;
        setTimeout(()=>{
            clearTimeout(tsubmit);
            tsubmit = setTimeout(end, 2000); // debounce
        }, 0);
    };
    const mo = new MutationObserver((events)=>{
        const moTime = performance.now();
        if (eventTime === -1) return;
        if (count > keyLimit - 1) {
            end();
            return;
        }
        const startTime = eventTime;
        resetEventTime();
        events.forEach(()=>{
            requestAnimationFrame((firstFrameTime)=>{
                if (firstFrameTime < moTime) requestAnimationFrame((secondFrameTime)=>{
                    times[count] = secondFrameTime - startTime;
                    count++;
                });
                else {
                    times[count] = firstFrameTime - startTime;
                    count++;
                }
            });
        });
    });
    mo.observe(element, {
        attributeFilter: [
            'value'
        ],
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true
    });
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    element.addEventListener('keypress', onKeyPressHandler);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.removeEventListener('keypress', onKeyPressHandler);
        mo.disconnect();
    };
}
const $25f3b9f7ec96214f$var$typingPerformanceTracingMethods = {
    timeout: $25f3b9f7ec96214f$var$typingPerformanceTracingTimeout,
    timeoutNoAlloc: $25f3b9f7ec96214f$var$typingPerformanceTracingTimeoutNoAlloc,
    mutationObserver: $25f3b9f7ec96214f$var$typingPerformanceTracingMutationObserver
};
function $25f3b9f7ec96214f$export$2e2bcd8739ae039(name) {
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        const rate = (0, $4vWWq.getInteractionRate)(name, 'typing');
        if ((0, $dZdw5.default)(rate) && ref.current != null) {
            const method = (0, $4vWWq.getTypingPerformanceTracingMethod)();
            return $25f3b9f7ec96214f$var$typingPerformanceTracingMethods[method](ref.current, name, rate);
        }
    }, [
        name
    ]);
    return ref;
}

});


parcelRegister("dM5tc", function(module, exports) {

$parcel$export(module.exports, "readViewContainerSelectorName", () => $15f991bc4ce130a4$export$195ee2a97947e11b);
$parcel$export(module.exports, "ReadViewContainer", () => $15f991bc4ce130a4$export$ebb3489b83262b26);
$parcel$export(module.exports, "InlineEditContainer", () => $15f991bc4ce130a4$export$9f16bbb9a44c7bf6);
/* single-line-text-inline-edit-view.styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c9TLT = parcelRequire("c9TLT");
const $15f991bc4ce130a4$export$195ee2a97947e11b = 'jira-issue-view-single-line-text-inline-edit-view-read-view-container';
const $15f991bc4ce130a4$var$READ_VIEW_CONTAINER_COMPONENT_SELECTOR = `[data-component-selector="${$15f991bc4ce130a4$export$195ee2a97947e11b}"]`;
const $15f991bc4ce130a4$export$ebb3489b83262b26 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _vwz48sxn _1nmz1hna _kqswh2mm _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $15f991bc4ce130a4$var$nonEditableStyles = {
    margin: 0,
    '& > div': {
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: "var(--ds-space-100, 8px)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: 0,
        paddingRight: "var(--ds-space-025, 2px)"
    },
    [$15f991bc4ce130a4$var$READ_VIEW_CONTAINER_COMPONENT_SELECTOR]: {
        minHeight: `${(0, $c9TLT.gridSize) * 4 - 4}px`,
        alignItems: 'center'
    }
};
const $15f991bc4ce130a4$export$9f16bbb9a44c7bf6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0x0bf _19pkx0bf _1bsb1osq _1gzc1txw _auuz1h6o _6vgs1osq _1rjezwfg _osjgidpf _alyvidpf _pa3x12x7 _2g9bidpf",
            !__cmplp.isEditable && "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bchidpf _79paidpf _1rhwidpf _1yb1u2gc _3lltv77o _k4bfv77o _1vxpidpf _1onpv77o _qtm91f4h _96lc1h6o",
            __cmplp.className
        ])
    });
});

});



parcelRegister("7QgAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b78daafe01ebb21$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2OdyW = parcelRequire("2OdyW");

var $1boRu = parcelRequire("1boRu");

var $4ksts = parcelRequire("4ksts");

var $exOWK = parcelRequire("exOWK");

var $huhk2 = parcelRequire("huhk2");

var $brySu = parcelRequire("brySu");

var $lqalZ = parcelRequire("lqalZ");

var $fokFV = parcelRequire("fokFV");

var $40QX1 = parcelRequire("40QX1");

var $jf5VS = parcelRequire("jf5VS");

var $iZkNq = parcelRequire("iZkNq");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8b78daafe01ebb21$var$transformSuggestions = (suggestions)=>suggestions.users ? suggestions.users.map((0, $jf5VS.transformFromStateValue)) : [];
const $8b78daafe01ebb21$var$fetchSuggestionsFactory = (0, $5iWql.default)((autoCompleteUrl)=>(query)=>{
        if (autoCompleteUrl === null) return Promise.resolve([]);
        return (0, $2OdyW.default)(`${autoCompleteUrl}${query}`).then($8b78daafe01ebb21$var$transformSuggestions);
    });
const $8b78daafe01ebb21$export$80859424956457b4 = (0, $5iWql.default)((intl)=>({
        avatarUrl: '',
        name: intl.formatMessage((0, $huhk2.genericMessages).noValue)
    }));
const $8b78daafe01ebb21$export$27a5bd065ad55220 = ({ shouldFireScreenEvent: shouldFireScreenEvent, isFieldRequired: isFieldRequired, extension: extension, type: type, value: value, isFieldInTab: isFieldInTab, ...editProps })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const onChange = (newValue)=>{
        editProps.onChange((0, $jf5VS.transformToStateValue)(newValue));
    };
    const portalElement = isFieldInTab ? (0, $brySu.getIssueModalAkDropdownPortal)() || document.body || undefined : undefined;
    const analyticsAttributes = (0, $iZkNq.useAnalyticsAttributesContext)();
    const attributes = (0, $eUqFw.useMemo)(()=>({
            ...analyticsAttributes,
            renderMode: 'default'
        }), [
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldFireScreenEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: attributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $exOWK.default), {
        ...editProps,
        value: (0, $jf5VS.transformFromStateValue)(value),
        emptyOption: isFieldRequired ? undefined : $8b78daafe01ebb21$export$80859424956457b4(intl),
        // @ts-expect-error - TS2322 - Type 'Element | undefined' is not assignable to type 'HTMLElement | undefined'.
        portalElement: portalElement,
        onChange: onChange
    }));
};
var $8b78daafe01ebb21$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state, { fieldId: fieldId })=>({
        isFieldInTab: (0, $40QX1.isFieldInTabSelector)(fieldId)(state),
        fetchSuggestions: $8b78daafe01ebb21$var$fetchSuggestionsFactory((0, $fokFV.fieldAutoCompleteUrlSelector)(fieldId)(state)),
        isFieldRequired: (0, $fokFV.isFieldRequiredSelector)(fieldId)(state)
    }), {})($8b78daafe01ebb21$export$27a5bd065ad55220);

});

parcelRegister("ih03o", function(module, exports) {

$parcel$export(module.exports, "default", () => $962a18392de9baba$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $iJlfe = parcelRequire("iJlfe");

var $1boRu = parcelRequire("1boRu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $fiMQP = parcelRequire("fiMQP");

var $18KtE = parcelRequire("18KtE");

var $huhk2 = parcelRequire("huhk2");

var $i36oV = parcelRequire("i36oV");

var $ksNhF = parcelRequire("ksNhF");

var $lKmtj = parcelRequire("lKmtj");

var $iZkNq = parcelRequire("iZkNq");
// @ts-expect-error - TS2749 - 'Option' refers to a value, but is being used as a type here. Did you mean 'typeof Option'?
const $962a18392de9baba$var$formatOptionLabel = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiMQP.OptionContainer), null, !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(option.avatarUrl) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "small",
        src: option.avatarUrl
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiMQP.OptionLabel), null, option.label));
const $962a18392de9baba$export$27a5bd065ad55220 = ({ shouldFireScreenEvent: shouldFireScreenEvent, extension: extension, type: type, value: value, onChange: onChange, customReadView: customReadView, ...editProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onChangeWithTransformation = (0, $eUqFw.useCallback)((newValue)=>onChange((0, $lKmtj.transformToStateValue)(newValue)), [
        onChange
    ]);
    const customReadViewWithTransformation = (0, $eUqFw.useCallback)((val)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(customReadView)) {
            if (val && 'length' in val) return customReadView((0, $lKmtj.transformToStateValue)(val));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    }, [
        customReadView
    ]);
    const optionalCustomReadView = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(customReadView) ? customReadViewWithTransformation : undefined;
    const analyticsAttributes = (0, $iZkNq.useAnalyticsAttributesContext)();
    const attributes = (0, $eUqFw.useMemo)(()=>({
            ...analyticsAttributes,
            renderMode: 'default'
        }), [
        analyticsAttributes
    ]);
    const issueKey = (0, $hJ992.useIssueKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldFireScreenEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: attributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $18KtE.default), {
        ...editProps,
        value: (0, $lKmtj.transformFromStateValue)(value),
        customReadView: optionalCustomReadView,
        placeholder: formatMessage((0, $ksNhF.default).placeholder),
        noValueText: formatMessage((0, $huhk2.genericMessages).noValue),
        onChange: onChangeWithTransformation,
        tagAppearance: "rounded",
        formatOptionLabel: $962a18392de9baba$var$formatOptionLabel,
        fetchSuggestions: (0, $i36oV.fetchSuggestionsFactory)(issueKey)
    }));
};
var $962a18392de9baba$export$2e2bcd8739ae039 = $962a18392de9baba$export$27a5bd065ad55220;

});
parcelRegister("i36oV", function(module, exports) {

$parcel$export(module.exports, "fetchSuggestionsFactory", () => $fcb224f33a996a4f$export$2b81811283cd2d9d);
$parcel$export(module.exports, "default", () => $fcb224f33a996a4f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jqvCZ = parcelRequire("jqvCZ");

var $2OdyW = parcelRequire("2OdyW");

var $f1dS7 = parcelRequire("f1dS7");

var $18KtE = parcelRequire("18KtE");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $5JqpU = parcelRequire("5JqpU");

var $9Nizy = parcelRequire("9Nizy");

var $ksNhF = parcelRequire("ksNhF");

var $lKmtj = parcelRequire("lKmtj");

var $kX2Cf = parcelRequire("kX2Cf");
const $fcb224f33a996a4f$export$2b81811283cd2d9d = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((issueKey)=>async (query)=>{
        const suggestions = await (0, $2OdyW.default)(`/rest/api/3/user/recommend?${new URLSearchParams({
            context: 'CustomMultiUserField',
            ...issueKey && {
                issueKey: issueKey
            },
            query: query
        })}`);
        return (0, $lKmtj.transformSuggestions)(suggestions);
    });
const $fcb224f33a996a4f$export$322216d90ffb8d0e = (option, meta)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f1dS7.default), {
        avatarUrl: option.avatarUrl,
        email: option.email,
        label: option.label,
        context: meta.context
    });
const $fcb224f33a996a4f$var$multiUserSelectFilterOption = (0, $9Nizy.isSearchByEmailInMultiselectUserPickerEnabled)() ? (0, $kX2Cf.filterOption) : undefined;
var $fcb224f33a996a4f$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $lKmtj.transformFromStateValue,
        transformToStateValue: $lKmtj.transformToStateValue,
        additionalProps: (state, intl)=>({
                fetchSuggestions: $fcb224f33a996a4f$export$2b81811283cd2d9d((0, $5JqpU.issueKeySelector)(state)),
                placeholder: intl.formatMessage((0, $ksNhF.default).placeholder),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                tagAppearance: 'rounded',
                showDropdownOnClick: false,
                isUserTag: true,
                formatOptionLabel: $fcb224f33a996a4f$export$322216d90ffb8d0e,
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area),
                filterOption: $fcb224f33a996a4f$var$multiUserSelectFilterOption
            })
    }))((0, $18KtE.default));

});
parcelRegister("f1dS7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c377f3ca549a4e8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");
const $5c377f3ca549a4e8$var$UserOptionView = ({ avatarUrl: avatarUrl, label: label, email: email, context: context })=>{
    const avatarSize = context === 'value' ? 'xsmall' : 'medium';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5c377f3ca549a4e8$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        testId: "issue-internal-field-select.common.custom-format.user-option.avatar",
        size: avatarSize,
        src: avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5c377f3ca549a4e8$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5c377f3ca549a4e8$var$Text, null, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5c377f3ca549a4e8$var$Text, {
        secondary: true
    }, email))));
};
var $5c377f3ca549a4e8$export$2e2bcd8739ae039 = $5c377f3ca549a4e8$var$UserOptionView;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c377f3ca549a4e8$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _vchhusvi _1e0c1txw _vwz4kb7n _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsb1osq _80omtlke",
            __cmplp.className
        ])
    });
});
const $5c377f3ca549a4e8$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1osq _1ul9idpf _16jlkb7n _1o9zkb7n _i0dl1osq _vwz419ii _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $5c377f3ca549a4e8$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { secondary: secondary, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazj3m3 _1reo15vq _1bto1l2s _o5721q9c",
            __cmplp.secondary && "_syaz1wmz _1wyb181o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ksNhF", function(module, exports) {

$parcel$export(module.exports, "default", () => $edb7c615946319f0$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $edb7c615946319f0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.multi-user.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "Select User"
    }
});

});

parcelRegister("lKmtj", function(module, exports) {

$parcel$export(module.exports, "transformToStateValue", () => $36cc342e720f3478$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformFromStateValue", () => $36cc342e720f3478$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformSuggestions", () => $36cc342e720f3478$export$1d0ee4320c26fb60);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $iJlfe = parcelRequire("iJlfe");

var $6vrw7 = parcelRequire("6vrw7");
const $36cc342e720f3478$var$avatarSize = '24x24';
const $36cc342e720f3478$export$1cfcb95cb8fbddb3 = (0, $5iWql.default)((value)=>value && value.map((item)=>({
            displayName: item.content,
            accountId: item.accountId,
            id: (0, $6vrw7.toAccountId)(String(item.value)),
            avatarUrls: {
                [$36cc342e720f3478$var$avatarSize]: String(item.avatarUrl)
            }
        })));
const $36cc342e720f3478$export$cb172b2468ab5652 = (0, $5iWql.default)((value)=>{
    // Custom fields can have a null value
    if (!value) return [];
    return value.map((item)=>({
            content: item.displayName,
            value: String(item.accountId),
            key: item.accountId,
            avatarUrl: item.avatarUrls && item.avatarUrls[$36cc342e720f3478$var$avatarSize],
            accountId: item.accountId,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                size: "xsmall",
                src: item.avatarUrls && item.avatarUrls[$36cc342e720f3478$var$avatarSize]
            })
        }));
});
const $36cc342e720f3478$export$1d0ee4320c26fb60 = (0, $5iWql.default)((response)=>{
    const items = response ?? [];
    return [
        {
            items: items.map((item)=>({
                    content: item.displayName,
                    value: String(item.accountId),
                    accountId: item.accountId,
                    avatarUrl: item.avatarUrls[$36cc342e720f3478$var$avatarSize],
                    email: item.emailAddress
                }))
        }
    ];
});

});

parcelRegister("kX2Cf", function(module, exports) {

$parcel$export(module.exports, "filterOption", () => $e9045564bbc70d2e$export$9ec48f819895657b);

var $kDIIr = parcelRequire("kDIIr");
const $e9045564bbc70d2e$export$9ec48f819895657b = (option, inputValue)=>{
    const userEmail = option.data.email;
    let optionToFilter = {
        label: option.label,
        value: option.value
    };
    if (userEmail) optionToFilter = {
        data: {
            filterValues: [
                userEmail
            ]
        },
        ...optionToFilter
    };
    return (0, $kDIIr.filterOptionByLabelAndFilterValues)(optionToFilter, inputValue);
};

});



parcelRegister("53RLl", function(module, exports) {

$parcel$export(module.exports, "withRenderingMetrics", () => $d02d92d9d1051348$export$3b13ef132e3112b1);

var $eUqFw = parcelRequire("eUqFw");

var $8XU7c = parcelRequire("8XU7c");

var $d6g7g = parcelRequire("d6g7g");
const $d02d92d9d1051348$export$3b13ef132e3112b1 = (Component, concurrentMetricsId)=>(props)=>{
        const startTime = performance.now();
        // useLayoutEffect aligns more closely with react profiler's rendering time than useEffect (after paint).
        (0, $eUqFw.useLayoutEffect)(()=>{
            const eventId = (0, $8XU7c.getBrowserMetricsEventId)({
                module: 'jira:customField',
                entryPoint: 'view',
                forgeUiType: 'native-ui'
            });
            const stopTime = performance.now();
            (0, $d6g7g.forgeModulesConcurrentLoadTime)(concurrentMetricsId).start({
                startTime: startTime
            });
            (0, $d6g7g.forgeModulesConcurrentLoadTime)(concurrentMetricsId).stop({
                stopTime: stopTime,
                customData: {
                    eventId: eventId
                }
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps -- startTime changes on every rerender, but we only want to send the metrics once
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props);
    };

});


parcelRegister("7BiDI", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_RENDER_CONTEXT", () => $92c4747ef990745b$export$b84331d233be2fa5);
$parcel$export(module.exports, "CustomFieldAnalyticsWrapper", () => $92c4747ef990745b$export$8772de3bcda9e89b);

var $eUqFw = parcelRequire("eUqFw");

var $5syGA = parcelRequire("5syGA");

var $1i4cf = parcelRequire("1i4cf");

var $elbiT = parcelRequire("elbiT");

var $hJ992 = parcelRequire("hJ992");

var $lcJyp = parcelRequire("lcJyp");

var $iZkNq = parcelRequire("iZkNq");

var $jw1J9 = parcelRequire("jw1J9");
const $92c4747ef990745b$export$b84331d233be2fa5 = 'issue-view';
const $92c4747ef990745b$export$8772de3bcda9e89b = ({ extension: extension, children: children })=>{
    const source = (0, $hJ992.useAnalyticsSource)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            source: source,
            renderContext: $92c4747ef990745b$export$b84331d233be2fa5,
            module: extension.type,
            fieldType: extension.properties.type,
            ...extension && (0, $5syGA.getAnalyticsAttributesFromExtension)(extension)
        }), [
        extension,
        source
    ]);
    const [{ currentPage: currentPageTiming }] = (0, $lcJyp.useSpaState)();
    const [{ extensionsMeasuredStartTime: extensionsMeasuredStartTime }, { updateExtensionMeasuredStartTime: updateExtensionMeasuredStartTime }] = (0, $1i4cf.usePerformanceAnalytics)();
    const performanceAnalyticsProps = (0, $eUqFw.useMemo)(()=>({
            issueKey: issueKey,
            currentPageTiming: currentPageTiming,
            extensionsMeasuredStartTime: extensionsMeasuredStartTime,
            updateExtensionMeasuredStartTime: updateExtensionMeasuredStartTime,
            performanceAttributes: {
                extensionId: extension.id,
                module: extension.type,
                source: source,
                renderContext: $92c4747ef990745b$export$b84331d233be2fa5,
                customData: source ? (0, $jw1J9.getPerformanceCustomData)(source, $92c4747ef990745b$export$b84331d233be2fa5, extension) : undefined
            },
            additionalTimings: {
                pageSegmentLoad: (0, $jw1J9.getAdditionalPageSegmentLoadTimings)()
            }
        }), [
        issueKey,
        currentPageTiming,
        extensionsMeasuredStartTime,
        updateExtensionMeasuredStartTime,
        extension,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iZkNq.AnalyticsAttributesContextProvider), {
        value: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elbiT.ViewAnalyticsWrapper), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1i4cf.PerformanceAnalyticsContainer), performanceAnalyticsProps, children)));
};

});
parcelRegister("1i4cf", function(module, exports) {

$parcel$export(module.exports, "usePerformanceAnalytics", () => $a26ff22c3bd6e0b1$export$a8c9835719b09864);
$parcel$export(module.exports, "usePerformanceAnalyticsActions", () => $a26ff22c3bd6e0b1$export$44548fd9155bf8f9);
$parcel$export(module.exports, "PerformanceAnalyticsContainer", () => $a26ff22c3bd6e0b1$export$79ea62a56147dbe1);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $d6g7g = parcelRequire("d6g7g");

var $hIaxI = parcelRequire("hIaxI");

var $aueAZ = parcelRequire("aueAZ");
const $a26ff22c3bd6e0b1$export$463a8f9a4ee27b49 = {
    extensionsMeasuredStartTime: {}
};
const $a26ff22c3bd6e0b1$var$globalStore = (0, $a61MH.createStore)({
    initialState: $a26ff22c3bd6e0b1$export$463a8f9a4ee27b49,
    actions: (0, $hIaxI.globalActions),
    name: 'forge-ui-performance-analytics-global'
});
const $a26ff22c3bd6e0b1$export$a8c9835719b09864 = (0, $ggKAj.createHook)($a26ff22c3bd6e0b1$var$globalStore);
const $a26ff22c3bd6e0b1$export$cc4837824a3bf6eb = {
    performanceAttributes: undefined,
    pageSegmentLoadPreviouslyMeasured: false,
    pageSegmentLoadMetric: undefined,
    pageSegmentLoadAdditionalTimings: undefined,
    interactionMetric: undefined,
    interactionAdditionalTimings: undefined
};
const $a26ff22c3bd6e0b1$var$containerStore = (0, $a61MH.createStore)({
    initialState: $a26ff22c3bd6e0b1$export$cc4837824a3bf6eb,
    actions: (0, $hIaxI.containerActions),
    name: 'forge-ui-performance-analytics-container'
});
const $a26ff22c3bd6e0b1$export$44548fd9155bf8f9 = (0, $ggKAj.createActionsHook)($a26ff22c3bd6e0b1$var$containerStore);
function $a26ff22c3bd6e0b1$export$ec815b0823ccd0fe({ setState: setState }, { issueKey: issueKey, currentPageTiming: currentPageTiming, extensionsMeasuredStartTime: extensionsMeasuredStartTime, updateExtensionMeasuredStartTime: updateExtensionMeasuredStartTime, performanceAttributes: performanceAttributes, additionalTimings: additionalTimings }, shouldMeasurePageSegmentLoad = (0, $aueAZ.defaultShouldMeasurePageSegmentLoad)) {
    const { extensionId: extensionId, module: module, source: source, renderContext: renderContext } = performanceAttributes;
    const { startTime: currentPageStartTime } = currentPageTiming;
    const extensionMeasuredKey = typeof extensionId === 'string' ? (0, $aueAZ.getExtensionMeasuredKey)(issueKey, extensionId) : undefined;
    /**
	 * How to prevent `pageSegmentLoadMetric` to be measured on "every" component remount?
	 * - We store `extensionsMeasuredStartTime` in a global store for every extension (filled with `currentPageStartTime`)
	 * - `currentPageStartTime` is brought by @atlassian/jira-spa-state-controller
	 *
	 * We then measure a "pageSegmentLoad" metric:
	 * - if [extensionMeasuredKey][extensionsMeasuredStartTime] === undefined (initial load)
	 * - if [extensionMeasuredKey][extensionsMeasuredStartTime] < `currentPageStartTime` (renewed after each SPA transition)
	 *
	 * This way, "pageSegmentLoad" metric is only measured on initial load, SPA transition, but not during any other interaction causing a component remount.
	 */ const pageSegmentLoadPreviouslyMeasured = typeof extensionMeasuredKey === 'string' && typeof extensionsMeasuredStartTime[extensionMeasuredKey] === 'number' && currentPageStartTime <= extensionsMeasuredStartTime[extensionMeasuredKey];
    switch(module){
        case 'jira:customField':
        case 'jira:customFieldType':
            if (shouldMeasurePageSegmentLoad(source, renderContext)) {
                const pageSegmentLoadMetric = (0, $d6g7g.customFieldPageSegmentLoadMetric)(additionalTimings?.pageSegmentLoad);
                // the trick here not to measure is simply not to start our metric
                if (!pageSegmentLoadPreviouslyMeasured && typeof extensionId === 'string') {
                    pageSegmentLoadMetric.startFromPageLoad();
                    updateExtensionMeasuredStartTime(issueKey, extensionId, currentPageStartTime);
                }
                setState({
                    pageSegmentLoadPreviouslyMeasured: pageSegmentLoadPreviouslyMeasured,
                    pageSegmentLoadMetric: pageSegmentLoadMetric
                });
            }
            setState({
                performanceAttributes: performanceAttributes,
                pageSegmentLoadAdditionalTimings: additionalTimings?.pageSegmentLoad,
                interactionAdditionalTimings: additionalTimings?.interaction
            });
            break;
        default:
    }
}
const $a26ff22c3bd6e0b1$export$79ea62a56147dbe1 = (0, $heB5U.createContainer)($a26ff22c3bd6e0b1$var$containerStore, {
    displayName: 'PerformanceAnalyticsContainer',
    onInit: ()=>(storeApi, { issueKey: issueKey, currentPageTiming: currentPageTiming, extensionsMeasuredStartTime: extensionsMeasuredStartTime, updateExtensionMeasuredStartTime: updateExtensionMeasuredStartTime, performanceAttributes: performanceAttributes, additionalTimings: additionalTimings })=>$a26ff22c3bd6e0b1$export$ec815b0823ccd0fe(storeApi, {
                issueKey: issueKey,
                currentPageTiming: currentPageTiming,
                extensionsMeasuredStartTime: extensionsMeasuredStartTime,
                updateExtensionMeasuredStartTime: updateExtensionMeasuredStartTime,
                performanceAttributes: performanceAttributes,
                additionalTimings: additionalTimings
            })
});

});
parcelRegister("hIaxI", function(module, exports) {

$parcel$export(module.exports, "globalActions", () => $c02d75841768871c$export$ee9660aeb5c82cd0);
$parcel$export(module.exports, "containerActions", () => $c02d75841768871c$export$5de6fa201bc99c4c);

var $d6g7g = parcelRequire("d6g7g");

var $hRcYT = parcelRequire("hRcYT");

var $aueAZ = parcelRequire("aueAZ");
const $c02d75841768871c$export$bff1e8cfa3c14640 = (issueKey, extensionId, measuredStartTime)=>({ getState: getState, setState: setState })=>{
        const { extensionsMeasuredStartTime: extensionsMeasuredStartTime } = getState();
        setState({
            extensionsMeasuredStartTime: {
                ...extensionsMeasuredStartTime,
                [(0, $aueAZ.getExtensionMeasuredKey)(issueKey, extensionId)]: measuredStartTime
            }
        });
    };
const $c02d75841768871c$export$63c69f21c65af240 = ()=>({ getState: getState, setState: setState })=>{
        const { pageSegmentLoadPreviouslyMeasured: pageSegmentLoadPreviouslyMeasured, pageSegmentLoadMetric: pageSegmentLoadMetric } = getState();
        if (!pageSegmentLoadPreviouslyMeasured && pageSegmentLoadMetric && pageSegmentLoadMetric.getData().state === 'started') {
            pageSegmentLoadMetric.markFMP();
            pageSegmentLoadMetric.mark((0, $hRcYT.PERFORMANCE_KEYS).MARKS.TTI_START);
            setState({
                pageSegmentLoadMetric: pageSegmentLoadMetric
            });
        }
    };
const $c02d75841768871c$export$a39f1a87c92bcfb4 = ()=>({ getState: getState, setState: setState })=>{
        const { performanceAttributes: performanceAttributes, pageSegmentLoadPreviouslyMeasured: pageSegmentLoadPreviouslyMeasured, pageSegmentLoadMetric: pageSegmentLoadMetric, pageSegmentLoadAdditionalTimings: pageSegmentLoadAdditionalTimings } = getState();
        if (performanceAttributes && !pageSegmentLoadPreviouslyMeasured && pageSegmentLoadMetric && pageSegmentLoadMetric.getData().state === 'started') {
            const { customData: customData } = performanceAttributes;
            pageSegmentLoadMetric.mark((0, $hRcYT.PERFORMANCE_KEYS).MARKS.TTI_END);
            if (Array.isArray(pageSegmentLoadAdditionalTimings)) (0, $d6g7g.markAdditionalTimingsFromWindowPerformance)(pageSegmentLoadMetric, pageSegmentLoadAdditionalTimings);
            pageSegmentLoadMetric.stop({
                customData: // will show as BM3 props "custom:key = value"
                customData
            });
            setState({
                pageSegmentLoadMetric: pageSegmentLoadMetric
            });
        }
    };
const $c02d75841768871c$export$40e17a9276814f1 = (shouldMeasureInteraction = (0, $aueAZ.defaultShouldMeasureInteraction))=>({ getState: getState, setState: setState })=>{
        const { performanceAttributes: performanceAttributes, interactionAdditionalTimings: interactionAdditionalTimings } = getState();
        if (performanceAttributes) {
            const { source: source, renderContext: renderContext, module: module } = performanceAttributes;
            switch(module){
                case 'jira:customField':
                case 'jira:customFieldType':
                    if (shouldMeasureInteraction(source, renderContext)) {
                        const interactionMetric = (0, $d6g7g.customFieldInteractionMetric)(interactionAdditionalTimings);
                        interactionMetric.start();
                        setState({
                            interactionMetric: interactionMetric
                        });
                    }
                    break;
                default:
            }
        }
    };
const $c02d75841768871c$export$b963da7503f3d8c2 = ()=>({ getState: getState, setState: setState })=>{
        const { interactionMetric: interactionMetric } = getState();
        if (interactionMetric && interactionMetric.getData().state === 'started') {
            interactionMetric.mark('feedback');
            setState({
                interactionMetric: interactionMetric
            });
        }
    };
const $c02d75841768871c$export$47bbc6d6a5eb9a12 = ()=>({ getState: getState, setState: setState })=>{
        const { performanceAttributes: performanceAttributes, interactionMetric: interactionMetric, interactionAdditionalTimings: interactionAdditionalTimings } = getState();
        if (performanceAttributes && interactionMetric && interactionMetric.getData().state === 'started') {
            const { customData: customData } = performanceAttributes;
            if (Array.isArray(interactionAdditionalTimings)) (0, $d6g7g.markAdditionalTimingsFromWindowPerformance)(interactionMetric, interactionAdditionalTimings);
            interactionMetric.stop({
                customData: // will show as BM3 props "custom:key = value"
                customData
            });
            setState({
                interactionMetric: undefined
            });
        }
    };
const $c02d75841768871c$export$ee9660aeb5c82cd0 = {
    updateExtensionMeasuredStartTime: $c02d75841768871c$export$bff1e8cfa3c14640
};
const $c02d75841768871c$export$5de6fa201bc99c4c = {
    markPageSegmentFMP: $c02d75841768871c$export$63c69f21c65af240,
    markPageSegmentAsInterative: $c02d75841768871c$export$a39f1a87c92bcfb4,
    startUserInteraction: $c02d75841768871c$export$40e17a9276814f1,
    markUserInteractionFeedback: $c02d75841768871c$export$b963da7503f3d8c2,
    finishUserInteraction: $c02d75841768871c$export$47bbc6d6a5eb9a12
};

});
parcelRegister("aueAZ", function(module, exports) {

$parcel$export(module.exports, "getExtensionMeasuredKey", () => $7e94cba9077ad748$export$e6d48f955b8a378f);
$parcel$export(module.exports, "defaultShouldMeasurePageSegmentLoad", () => $7e94cba9077ad748$export$c5648dd06fc33b3e);
$parcel$export(module.exports, "defaultShouldMeasureInteraction", () => $7e94cba9077ad748$export$8b696a6968b73c09);
const $7e94cba9077ad748$export$e6d48f955b8a378f = (issueKey, extensionId)=>`${issueKey}-${extensionId}`;
function $7e94cba9077ad748$export$c5648dd06fc33b3e(source, renderContext) {
    return source === 'full-issue' && renderContext === 'issue-view';
}
function $7e94cba9077ad748$export$8b696a6968b73c09(source, renderContext) {
    return renderContext === 'issue-view' && !!source && [
        'roadmap-issue',
        'software-issue',
        'issue-navigator-next',
        'global-issue-navigator-issue',
        'full-issue'
    ].includes(source);
}

});



parcelRegister("elbiT", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $4ecd31271e5beb2f$export$c794eb4124961145);
$parcel$export(module.exports, "EditAnalyticsWrapper", () => $4ecd31271e5beb2f$export$947ae3996b2bc000);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");
const $4ecd31271e5beb2f$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $4ecd31271e5beb2f$export$947ae3996b2bc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
        ...props
    });

});

parcelRegister("jw1J9", function(module, exports) {

$parcel$export(module.exports, "getPerformanceCustomData", () => $1d0da4c10e536674$export$4ac72e67e3e2dd26);
$parcel$export(module.exports, "getAdditionalPageSegmentLoadTimings", () => $1d0da4c10e536674$export$2be9dd3074ba78fc);

var $hRcYT = parcelRequire("hRcYT");


function $1d0da4c10e536674$export$4ac72e67e3e2dd26(source, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
renderContext, extension) {
    if (extension?.properties) {
        let viewRendering;
        let editRendering;
        if (typeof extension.properties.function === 'string') viewRendering = 'ui-kit';
        else if (typeof extension.properties.formatter?.expression === 'string') viewRendering = 'formatter';
        else viewRendering = 'default';
        // @ts-expect-error - TS2339 - Property 'function' does not exist on type '{ function: string; } | { resource: string; }'.
        if (typeof extension.properties.edit?.function === 'string') editRendering = 'ui-kit';
        else if (typeof extension.properties.edit?.resource === 'string') editRendering = 'custom-ui';
        else editRendering = 'default';
        return typeof source === 'string' ? {
            source: source,
            renderContext: renderContext,
            fieldType: extension.properties.type,
            hasValueFunction: typeof extension.properties.value?.function === 'string',
            viewRendering: viewRendering,
            editRendering: editRendering
        } : {
            renderContext: renderContext,
            fieldType: extension.properties.type,
            hasValueFunction: typeof extension.properties.value?.function === 'string',
            viewRendering: viewRendering,
            editRendering: editRendering
        };
    }
    return undefined;
}
function $1d0da4c10e536674$export$2be9dd3074ba78fc() {
    const additionalPageSegmentLoadTimings = [
        // TODO ARKEN-363: might not be accurate
        {
            key: 'issueView',
            startMark: $848ef1328a091c81$export$10082883a7f4ea4d,
            endMark: $848ef1328a091c81$export$7f7b606f70e669e6
        },
        {
            key: 'pinnedItems',
            startMark: $332dd3e353a5c68d$export$8c06a6d84357e389,
            endMark: $332dd3e353a5c68d$export$fd068082b2bace69
        },
        {
            key: 'detailsFields',
            startMark: $332dd3e353a5c68d$export$e166220c4ce2fecc,
            endMark: $332dd3e353a5c68d$export$484838e86c8a663c
        },
        {
            key: 'moreFields',
            startMark: $332dd3e353a5c68d$export$f24b11cc15db1e61,
            endMark: $332dd3e353a5c68d$export$84bcb5360cf1a9a9
        },
        {
            key: 'customFieldAsyncBundle',
            startMark: (0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START,
            endMark: (0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END,
            cleanStart: true,
            cleanEnd: true
        },
        {
            key: 'customFieldValueFunction',
            startMark: (0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START,
            endMark: (0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END,
            cleanStart: true,
            cleanEnd: true
        }
    ];
    return additionalPageSegmentLoadTimings;
}

});
const $332dd3e353a5c68d$export$8c06a6d84357e389 = 'PINNED_FIELDS_BEGIN_MARK';
const $332dd3e353a5c68d$export$fd068082b2bace69 = 'PINNED_FIELDS_END_MARK';
const $332dd3e353a5c68d$export$e166220c4ce2fecc = 'DETAILS_FIELDS_BEGIN_MARK';
const $332dd3e353a5c68d$export$484838e86c8a663c = 'DETAILS_FIELDS_END_MARK';
const $332dd3e353a5c68d$export$f24b11cc15db1e61 = 'MORE_FIELDS_BEGIN_MARK';
const $332dd3e353a5c68d$export$84bcb5360cf1a9a9 = 'MORE_FIELDS_END_MARK';
const $332dd3e353a5c68d$export$87b38ef9bc160e8f = 'ECOSYSTEM_CONTEXT_BEGIN_MARK';
const $332dd3e353a5c68d$export$ba0fc47b302982aa = 'ECOSYSTEM_CONTEXT_END_MARK';




parcelRegister("4aJzJ", function(module, exports) {

$parcel$export(module.exports, "ForgeCustomFieldView", () => $fb8031283dc51ab0$export$4edba301650506c5);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $fT83w = parcelRequire("fT83w");

var $2vJHJ = parcelRequire("2vJHJ");

var $hJ992 = parcelRequire("hJ992");

var $epjaV = parcelRequire("epjaV");

var $eIva2 = parcelRequire("eIva2");

var $3Le4M = parcelRequire("3Le4M");

var $9IO8A = parcelRequire("9IO8A");
const $fb8031283dc51ab0$export$4edba301650506c5 = ({ value: value, fieldId: fieldId, fieldName: fieldName, onSave: onSave, shouldUseFormatter: shouldUseFormatter, extension: extension, extensionData: extensionData, ForgeField: ForgeField, ...restProps })=>{
    const issueId = (0, $hJ992.useIssueId)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const shouldUseValueFunction = (0, $eUqFw.useMemo)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(extension?.properties.value), [
        extension
    ]);
    const { error: valueFunctionError, isLoading: isLoadingValueFunction, requestExecuteValueFunction: requestExecuteValueFunction } = (0, $9IO8A.useValueFunction)(issueKey, issueId, fieldId, extension?.properties?.type, shouldUseValueFunction, onSave);
    const { formatterValue: formatterValue, isLoading: isLoadingFormatter } = (0, $3Le4M.useFormatterValue)({
        value: value,
        formatterProperty: extension?.properties.formatter,
        fieldId: fieldId,
        issueKey: issueKey,
        issueId: issueId,
        shouldUseFormatter: shouldUseFormatter,
        isEditing: restProps.isEditing
    });
    (0, $eUqFw.useEffect)(()=>{
        if (shouldUseValueFunction) requestExecuteValueFunction();
    }, [
        requestExecuteValueFunction,
        shouldUseValueFunction
    ]);
    const { requiresUserConsent: requiresUserConsent } = extension || {};
    const [userConsentRequired, setUserConsentRequired] = (0, $eUqFw.useState)(requiresUserConsent);
    const { type: type, collection: collection, function: extensionFunction, resource: extensionResource, render: render } = extension.properties;
    const shouldRenderCustomReadView = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(extensionFunction) || !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(extensionResource) && render === 'native' || shouldUseFormatter && (formatterValue !== null || isLoadingFormatter) || shouldUseValueFunction && (valueFunctionError !== null || isLoadingValueFunction);
    const onUserConsentGranted = (0, $eUqFw.useCallback)(()=>setUserConsentRequired(false), []);
    const renderCustomReadView = (0, $epjaV.useRenderCustomReadView)({
        extension: extension,
        extensionData: extensionData,
        type: type,
        fieldId: fieldId,
        fieldName: fieldName,
        collection: collection,
        shouldUseFormatter: shouldUseFormatter,
        onUserConsentGranted: onUserConsentGranted,
        formatterValue: formatterValue,
        error: valueFunctionError,
        isLoadingValueFunction: isLoadingValueFunction,
        onRequestExecuteValueFunction: requestExecuteValueFunction,
        isLoadingFormatter: isLoadingFormatter
    });
    const viewProps = {
        shouldFireScreenEvent: !shouldRenderCustomReadView,
        value: value,
        fieldId: fieldId,
        fieldName: fieldName,
        extension: extension,
        titleView: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fT83w.ExtensionTitle), {
            extensionName: restProps.label,
            extensionEnvType: extension.environmentType,
            extensionEnvKey: extension.environmentKey
        }),
        ...shouldRenderCustomReadView ? {
            customReadView: renderCustomReadView
        } : null,
        ...restProps
    };
    if (extension.properties.edit) {
        const { onCancel: onCancel } = restProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eIva2.ForgeCustomFieldEdit), {
            issueKey: issueKey,
            fieldId: fieldId,
            fieldName: fieldName,
            value: value,
            extension: (0, $2vJHJ.overrideExtension)(extension, {
                requiresUserConsent: userConsentRequired
            }),
            extensionData: extensionData,
            renderCustomReadView: renderCustomReadView,
            shouldRenderCustomReadView: shouldRenderCustomReadView,
            viewProps: viewProps,
            ForgeField: ForgeField,
            onCancel: onCancel,
            onSave: onSave
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ForgeField, viewProps);
};

});
parcelRegister("epjaV", function(module, exports) {

$parcel$export(module.exports, "useRenderCustomReadView", () => $c9f3537d05bc3464$export$d66b4ce638ad5d96);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1boRu = parcelRequire("1boRu");

var $eTZsp = parcelRequire("eTZsp");

var $8Nthx = parcelRequire("8Nthx");

var $fe3vy = parcelRequire("fe3vy");

var $7ujNe = parcelRequire("7ujNe");

var $iZkNq = parcelRequire("iZkNq");

var $eryJn = parcelRequire("eryJn");

var $fBDi2 = parcelRequire("fBDi2");
const $c9f3537d05bc3464$var$skeletonConfig = [
    {
        width: 100
    }
];
const $c9f3537d05bc3464$export$d66b4ce638ad5d96 = (options)=>{
    const { extension: extension, extensionData: extensionData, type: type, fieldId: fieldId, fieldName: fieldName, collection: collection, shouldUseFormatter: shouldUseFormatter, onUserConsentGranted: onUserConsentGranted, formatterValue: formatterValue, error: error, isLoadingFormatter: isLoadingFormatter, isLoadingValueFunction: isLoadingValueFunction, onRequestExecuteValueFunction: onRequestExecuteValueFunction } = options;
    return (0, $eUqFw.useCallback)((newValue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9f3537d05bc3464$var$CustomReadView, {
            newValue: newValue,
            extension: extension,
            extensionData: extensionData,
            type: type,
            fieldId: fieldId,
            fieldName: fieldName,
            collection: collection,
            shouldUseFormatter: shouldUseFormatter,
            onUserConsentGranted: onUserConsentGranted,
            formatterValue: formatterValue,
            error: error,
            isLoadingValueFunction: isLoadingValueFunction,
            isLoadingFormatter: isLoadingFormatter,
            onRequestExecuteValueFunction: onRequestExecuteValueFunction
        }), [
        collection,
        error,
        extension,
        extensionData,
        fieldId,
        fieldName,
        formatterValue,
        isLoadingFormatter,
        isLoadingValueFunction,
        onRequestExecuteValueFunction,
        onUserConsentGranted,
        shouldUseFormatter,
        type
    ]);
};
const $c9f3537d05bc3464$var$CustomReadView = (props)=>{
    const { extension: extension, extensionData: extensionData, fieldId: fieldId, fieldName: fieldName, formatterValue: formatterValue, shouldUseFormatter: shouldUseFormatter, type: type, onUserConsentGranted: onUserConsentGranted, collection: collection, newValue: newValue, isLoadingValueFunction: isLoadingValueFunction, error: error, isLoadingFormatter: isLoadingFormatter, onRequestExecuteValueFunction: onRequestExecuteValueFunction } = props;
    const extensionDataOverrides = (0, $eUqFw.useMemo)(()=>({
            ...extensionData,
            fieldId: fieldId,
            fieldType: extension.id,
            fieldName: fieldName,
            renderContext: 'issue-view'
        }), [
        extensionData,
        fieldId,
        extension.id,
        fieldName
    ]);
    const extensionPayload = (0, $eUqFw.useMemo)(()=>({
            fieldValue: (0, $eryJn.toForgeFieldValue)({
                type: type,
                collection: // @ts-expect-error - TS2322 - Type 'CollectionType' is not assignable to type '"none" | "list"'.
                collection,
                // @ts-expect-error - TS2322 - Type 'ForgeCustomFieldValue' is not assignable to type 'string | number | string[] | UserOption | Group | StateUser[] | Group[] | { [key: string]: unknown; } | null'.
                value: newValue
            })
        }), [
        collection,
        newValue,
        type
    ]);
    const analyticsAttributes = (0, $iZkNq.useAnalyticsAttributesContext)();
    const analyticsAttributesOverridesCustom = (0, $eUqFw.useMemo)(()=>({
            ...analyticsAttributes,
            renderMode: 'custom'
        }), [
        analyticsAttributes
    ]);
    const customFieldDataId = 'CustomFieldContentContainer';
    if (error !== null && !(0, $eTZsp.userConsentErrorRegex).test(error.message)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ujNe.ErrorPanel), {
        error: error,
        onRetry: onRequestExecuteValueFunction
    });
    if (isLoadingValueFunction || isLoadingFormatter) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Nthx.Skeleton), {
        skeletonConfig: $c9f3537d05bc3464$var$skeletonConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9f3537d05bc3464$var$CustomFieldContentContainer, {
        "data-id": customFieldDataId
    }, shouldUseFormatter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fBDi2.FormattedValueContainer), {
        dangerouslySetInnerHTML: {
            __html: formatterValue || ''
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: {
            ...analyticsAttributes,
            renderMode: 'formatter'
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fe3vy.AsyncCustomField), {
        extension: extension,
        extensionData: extensionDataOverrides,
        extensionPayload: extensionPayload,
        analyticsAttributes: analyticsAttributesOverridesCustom,
        onUserConsentGranted: onUserConsentGranted
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c9f3537d05bc3464$var$CustomFieldContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fe3vy", function(module, exports) {

$parcel$export(module.exports, "AsyncCustomField", () => $553f56b38256a231$export$3d94b128d17ce776);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $d6g7g = parcelRequire("d6g7g");
var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");

var $2Rqjr = parcelRequire("2Rqjr");

var $gGtKh = parcelRequire("gGtKh");

var $8Nthx = parcelRequire("8Nthx");

const $553f56b38256a231$var$getModule = ()=>(0, $d6g7g.measureInitialPageLoadAsyncResourcesTiming)((0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START, (0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END, ()=>(parcelRequire("h7L0G")));
const $553f56b38256a231$var$skeletonConfig = [
    {
        width: 100
    }
];
const $553f56b38256a231$export$2a6d819caf09da30 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$553f56b38256a231$var$getModule().then((module)=>module.CustomField), {
    ssr: false
}));
const $553f56b38256a231$export$ffc72ef953e96226 = (props)=>{
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = props;
    const loadingComponent = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Nthx.Skeleton), {
            skeletonConfig: $553f56b38256a231$var$skeletonConfig
        }), []);
    const extensionDataValue = (0, $eUqFw.useMemo)(()=>{
        const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
            fieldType: extensionData.fieldType,
            fieldId: extensionData.fieldId,
            fieldName: extensionData.fieldName,
            renderContext: extensionData.renderContext
        };
        return {
            ...preparedExtensionData,
            type: extension.type
        };
    }, [
        extension.type,
        extensionData
    ]);
    const extraProps = (0, $eUqFw.useMemo)(()=>({
            loadingComponent: loadingComponent,
            module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
            extensionData: extensionDataValue,
            extensionPayload: extensionPayload,
            contextToken: (0, $2Rqjr.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        extensionPayload,
        loadingComponent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "custom-field-renderer",
        fallback: loadingComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($553f56b38256a231$export$2a6d819caf09da30, {
        ...props,
        ...extraProps
    }));
};
const $553f56b38256a231$export$3d94b128d17ce776 = $553f56b38256a231$export$ffc72ef953e96226;

});
parcelRegister("h7L0G", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('bf9ps'),
            load('kWrFZ'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('auozo')
        ]);
        const value = parcelRequire('j34Xs');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("bf9ps"),
        load("kWrFZ"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("auozo")
    ]).then(()=>parcelRequire('j34Xs'));
}

});


parcelRegister("7ujNe", function(module, exports) {

$parcel$export(module.exports, "ErrorPanel", () => $4f4c1cd445d31479$export$9f3dc18e1adf5d8f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lRvnl = parcelRequire("lRvnl");
var $cEUHb = parcelRequire("cEUHb");

var $4Bees = parcelRequire("4Bees");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1N1hD = parcelRequire("1N1hD");
const $4f4c1cd445d31479$var$Loader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f4c1cd445d31479$var$LoaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        testId: "forge-ui-renderers.common.ui.error-panel.forge-app-loading-spinner",
        size: "large"
    }));
const $4f4c1cd445d31479$export$9f3dc18e1adf5d8f = ({ error: error, onRetry: onRetry })=>{
    const { message: message, errorMessage: errorMessage, errorDetails: errorDetails } = error;
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const intl = (0, $5JgJ2.default)();
    const onClickStopPropagation = (0, $eUqFw.useCallback)((e)=>e.stopPropagation(), []);
    const reinitializeApp = (0, $eUqFw.useCallback)(async (e)=>{
        setIsLoading(true);
        try {
            e.stopPropagation();
            if (onRetry) await onRetry();
        } catch  {} finally{
            setIsLoading(false);
        }
    }, [
        onRetry
    ]);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f4c1cd445d31479$var$Loader, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f4c1cd445d31479$var$ContentWrapper, {
        onClick: onClickStopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "error",
        title: message,
        actions: onRetry ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEUHb.default), {
                onClick: reinitializeApp,
                key: "refresh"
            }, intl.formatMessage((0, $1N1hD.default).refreshApp))
        ] : []
    }, errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f4c1cd445d31479$var$ErrorMessageWrapper, null, errorMessage), errorDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f4c1cd445d31479$var$ErrorDetailsWrapper, null, errorDetails)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f4c1cd445d31479$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _k7zyidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f4c1cd445d31479$var$LoaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _ca0qutpp _n3tdutpp _1bsb1osq _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f4c1cd445d31479$var$ErrorMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721jtm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f4c1cd445d31479$var$ErrorDetailsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "pre", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721jtm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lRvnl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dc3a504e8cabc14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $gf4A3 = parcelRequire("gf4A3");
const $4dc3a504e8cabc14$var$sectionMessageStyles = (0, $1ZAYh.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'border.radius'
});
const $4dc3a504e8cabc14$var$bleedStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginBlock: 'space.negative.025'
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $4dc3a504e8cabc14$var$SectionMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $gf4A3.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "section",
        backgroundColor: $4dc3a504e8cabc14$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $4dc3a504e8cabc14$var$sectionMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4dc3a504e8cabc14$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        testId: testId && `${testId}--content`
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        level: "h500"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        shouldWrap: true,
        testId: testId && `${testId}--actions`,
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0"
    }, actionsArray))));
});
const $4dc3a504e8cabc14$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$4dc3a504e8cabc14$var$SectionMessage.displayName = 'SectionMessage';
var $4dc3a504e8cabc14$export$2e2bcd8739ae039 = $4dc3a504e8cabc14$var$SectionMessage;

});
parcelRegister("gf4A3", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $5e1f1f04e3e69c39$export$e9b82d2e21ac0c1f);

var $eUqFw = parcelRequire("eUqFw");

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $ioiQ7 = parcelRequire("ioiQ7");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");
const $5e1f1f04e3e69c39$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $PdmhA.B50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $PdmhA.B500)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $PdmhA.Y50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y500)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $PdmhA.R50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($96IgR))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $PdmhA.R500)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $PdmhA.G50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $PdmhA.G500)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $PdmhA.P50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $PdmhA.P500)})`
    }
};
function $5e1f1f04e3e69c39$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $5e1f1f04e3e69c39$export$faa35441caff5bb6[appearance] || $5e1f1f04e3e69c39$export$faa35441caff5bb6.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("2bv8J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1974c390fcca76c2$var$_react = $1974c390fcca76c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $1974c390fcca76c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1974c390fcca76c2$var$InfoIcon = (props)=>/*#__PURE__*/ $1974c390fcca76c2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12z" fill="currentColor"/><rect fill="inherit" x="11" y="10" width="2" height="7" rx="1"/><circle fill="inherit" cx="12" cy="8" r="1"/></g></svg>`
    }, props));
$1974c390fcca76c2$var$InfoIcon.displayName = 'InfoIcon';
var $1974c390fcca76c2$var$_default = $1974c390fcca76c2$var$InfoIcon;
module.exports.default = $1974c390fcca76c2$var$_default;

});



parcelRegister("cEUHb", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8e69e42130a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $6eba8e69e42130a2$var$SectionMessageAction = /*#__PURE__*/ (0, $eUqFw.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    // FIXME: This path doesn't make sense
    // If the intent of the design for this component is to use an action, not providing `href` or `onClick`
    // makes the use case invalid. This should be addressed.
    return onClick || href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
});
$6eba8e69e42130a2$var$SectionMessageAction.displayName = 'SectionMessageAction';
var $6eba8e69e42130a2$export$2e2bcd8739ae039 = $6eba8e69e42130a2$var$SectionMessageAction;

});

parcelRegister("1N1hD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9b96b0ffaa98017$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c9b96b0ffaa98017$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    refreshApp: {
        "id": "forge-ui-renderers.common.error-panel.refresh-app",
        "defaultMessage": "Refresh app"
    }
});

});


parcelRegister("eryJn", function(module, exports) {

$parcel$export(module.exports, "toForgeFieldValue", () => $042166772218c704$export$59053768cd6706ce);

var $05jFi = parcelRequire("05jFi");
var $kXdfH = parcelRequire("kXdfH");

var $kOS48 = parcelRequire("kOS48");
var $25Hxx = parcelRequire("25Hxx");
const $042166772218c704$export$59053768cd6706ce = (fieldValue)=>{
    switch(fieldValue.type){
        case 'user':
            return fieldValue.collection === 'list' ? (0, $25Hxx.toCustomFieldValue)(fieldValue.value) : (0, $kOS48.toCustomFieldValue)(fieldValue.value);
        case 'group':
            return fieldValue.collection === 'list' ? (0, $kXdfH.toCustomFieldValue)(fieldValue.value) : (0, $05jFi.toCustomFieldValue)(fieldValue.value);
        case 'datetime':
        case 'date':
        case 'string':
        case 'number':
        case 'object':
        default:
            return fieldValue.value;
    }
};

});
parcelRegister("05jFi", function(module, exports) {

$parcel$export(module.exports, "toCustomFieldValue", () => $e2e6ad73fc525a9f$export$fa2fb5ab01b2795d);
const $e2e6ad73fc525a9f$export$fa2fb5ab01b2795d = (value)=>value == null ? null : value.name;

});

parcelRegister("kXdfH", function(module, exports) {

$parcel$export(module.exports, "toCustomFieldValue", () => $b705a4e1dc9aa297$export$fa2fb5ab01b2795d);
const $b705a4e1dc9aa297$export$fa2fb5ab01b2795d = (value)=>value == null ? null : value.map((v)=>v.name);

});

parcelRegister("kOS48", function(module, exports) {

$parcel$export(module.exports, "toCustomFieldValue", () => $3588f6a3e506eb46$export$fa2fb5ab01b2795d);

var $ldoFd = parcelRequire("ldoFd");
const $3588f6a3e506eb46$export$fa2fb5ab01b2795d = (value)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value)) return null;
    return {
        accountId: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value.accountId) ? value.accountId : value.id
    };
};

});

parcelRegister("25Hxx", function(module, exports) {

$parcel$export(module.exports, "toCustomFieldValue", () => $54a6797cb41084b0$export$fa2fb5ab01b2795d);

var $ldoFd = parcelRequire("ldoFd");
const $54a6797cb41084b0$export$fa2fb5ab01b2795d = (value)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value)) return null;
    // @ts-expect-error - TS2322 - Type '{ accountId: string | null; }[]' is not assignable to type 'User[]'.
    return value.map((option)=>({
            accountId: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(option.accountId) ? option.accountId : option.id
        }));
};

});


parcelRegister("fBDi2", function(module, exports) {

$parcel$export(module.exports, "FormattedValueContainer", () => $2671c4a886d99756$export$a40bedb936dfbdcd);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $2671c4a886d99756$export$a40bedb936dfbdcd = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _bfhk18uv _2lx21bp4 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm _1reo15vq _18m915vq _4cvr1y6m _1bsb1osq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("eIva2", function(module, exports) {

$parcel$export(module.exports, "ForgeCustomFieldEdit", () => $dff966e589fd6608$export$225b80fdf77ca94e);

var $eUqFw = parcelRequire("eUqFw");

var $elbiT = parcelRequire("elbiT");

var $iZkNq = parcelRequire("iZkNq");

var $hTIGT = parcelRequire("hTIGT");

var $dJKMo = parcelRequire("dJKMo");
const $dff966e589fd6608$export$41f4d10685ccd347 = ({ renderCustomReadView: renderCustomReadView, shouldRenderCustomReadView: shouldRenderCustomReadView, ForgeField: ForgeField, viewProps: viewProps, ...restProps })=>{
    const viewComponent = (switchToEditMode, newValue, isLoading)=>{
        const readView = (fieldValue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hTIGT.default), {
                isLoading: isLoading
            }, renderCustomReadView(fieldValue));
        const fieldContentWrapper = ({ topMargin: topMargin, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hTIGT.default), {
                isCustomReadView: shouldRenderCustomReadView,
                topMargin: topMargin,
                isLoading: isLoading
            }, children);
        const editViewProps = {
            ...viewProps,
            onEditRequest: switchToEditMode,
            value: newValue,
            ...shouldRenderCustomReadView ? {
                customReadView: readView
            } : {
                fieldContentWrapper: fieldContentWrapper
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ForgeField, editViewProps);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dJKMo.ForgeCustomFieldEditView), {
        ...restProps,
        viewComponent: viewComponent
    });
};
const $dff966e589fd6608$export$225b80fdf77ca94e = (props)=>{
    const analyticsAttributes = (0, $iZkNq.useAnalyticsAttributesContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elbiT.EditAnalyticsWrapper), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dff966e589fd6608$export$41f4d10685ccd347, props));
};

});
parcelRegister("hTIGT", function(module, exports) {

$parcel$export(module.exports, "default", () => $74ec36cbe4cf9c12$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $1HE2D = parcelRequire("1HE2D");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$74ec36cbe4cf9c12$export$2e2bcd8739ae039 = ({ children: children, topMargin: topMargin = 0, isCustomReadView: isCustomReadView = false, isLoading: isLoading })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HE2D.ForgeFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HE2D.ForgeFieldContainer), {
        isLoading: isLoading
    }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HE2D.ForgeFieldSpinnerContainer), {
        topMargin: topMargin,
        isCustomReadView: isCustomReadView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small"
    })));

});
parcelRegister("1HE2D", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldWrapper", () => $e2ff8d4f896ec25e$export$235fa5071a3803c9);
$parcel$export(module.exports, "ForgeFieldContainer", () => $e2ff8d4f896ec25e$export$68c865710fad6ebf);
$parcel$export(module.exports, "ForgeFieldSpinnerContainer", () => $e2ff8d4f896ec25e$export$6e0e69e14fa4e23);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $e2ff8d4f896ec25e$export$235fa5071a3803c9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $e2ff8d4f896ec25e$export$68c865710fad6ebf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isLoading ? "_tzy415iw" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $e2ff8d4f896ec25e$export$6e0e69e14fa4e23 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { topMargin: topMargin, isCustomReadView: isCustomReadView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_17ovblo": (0, $9t7rW.default)(`${__cmplp.topMargin}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154i6g43",
            __cmplp.isCustomReadView ? "_1xi2i2wt" : "_1xi21crf",
            __cmplp.className
        ])
    });
});

});


parcelRegister("dJKMo", function(module, exports) {

$parcel$export(module.exports, "ForgeCustomFieldEditView", () => $7cb1aa95128b5c8c$export$b171f65fda54c8cf);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $1i4cf = parcelRequire("1i4cf");

var $dh9qu = parcelRequire("dh9qu");

var $3zABe = parcelRequire("3zABe");

var $e4byB = parcelRequire("e4byB");

var $8SL1Z = parcelRequire("8SL1Z");

var $68tex = parcelRequire("68tex");

var $iZkNq = parcelRequire("iZkNq");

var $ayI0Q = parcelRequire("ayI0Q");

var $eLWt7 = parcelRequire("eLWt7");
const $7cb1aa95128b5c8c$export$b171f65fda54c8cf = ({ issueKey: issueKey, extensionData: extensionData, extension: extension, fieldId: fieldId, fieldName: fieldName, value: value, viewComponent: viewComponent, onCancel: onCancel, onSave: onSave })=>{
    const [{ isEditing: isEditing, isLoading: isLoading, editValue: editValue }, dispatch] = (0, $eUqFw.useReducer)((0, $eLWt7.default), {
        isEditing: false,
        isLoading: false,
        editValue: value
    });
    const analyticsAttributes = (0, $iZkNq.useAnalyticsAttributesContext)();
    const performanceAnalyticsActions = (0, $1i4cf.usePerformanceAnalyticsActions)();
    (0, $eUqFw.useEffect)(()=>{
        dispatch((0, $ayI0Q.forgeCustomFieldEditSetValue)(value));
    }, [
        value
    ]);
    const attributes = (0, $eUqFw.useMemo)(()=>({
            ...analyticsAttributes,
            displayType: 'modal'
        }), [
        analyticsAttributes
    ]);
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const onEditConfirm = (0, $eUqFw.useCallback)((newValue)=>{
        // to update redux store with new value
        onSave && onSave(newValue);
        dispatch((0, $ayI0Q.forgeCustomFieldEditSetValue)(newValue));
        (0, $dh9qu.fireTrackEditedEvent)(attributes.source, attributes);
    }, [
        onSave,
        attributes
    ]);
    const onEditCancel = (0, $eUqFw.useCallback)(()=>{
        onCancel();
        dispatch((0, $ayI0Q.forgeCustomFieldEditCancel)());
        (0, $dh9qu.fireUiCanceledEvent)(attributes.source, attributes);
    }, [
        onCancel,
        attributes
    ]);
    const onEditRender = (0, $eUqFw.useCallback)(()=>{
        dispatch((0, $ayI0Q.forgeCustomFieldEditRendered)());
        performanceAnalyticsActions.finishUserInteraction();
    }, [
        performanceAnalyticsActions
    ]);
    const onEditFail = (0, $eUqFw.useCallback)(()=>{
        if (isEditing) // if isEditing, user has edit modal open and is trying to submit it
        showFlag((0, $e4byB.default)());
        else // otherwise, edit modal isn't open, and the error is firing as they click on the field
        showFlag((0, $8SL1Z.default)());
        dispatch((0, $ayI0Q.forgeCustomFieldEditFailed)());
    }, [
        showFlag,
        isEditing
    ]);
    const switchToEditMode = (0, $eUqFw.useCallback)(()=>{
        (0, $dh9qu.fireUiTriggerClickEvent)(attributes.source, attributes);
        performanceAnalyticsActions.startUserInteraction();
        dispatch((0, $ayI0Q.forgeCustomFieldEditInitialization)());
    }, [
        attributes,
        performanceAnalyticsActions
    ]);
    // switchToEditMode visual feedback
    (0, $eUqFw.useEffect)(()=>{
        if (isEditing && isLoading) performanceAnalyticsActions.markUserInteractionFeedback();
    }, [
        isEditing,
        isLoading,
        performanceAnalyticsActions
    ]);
    const { save: save } = (0, $68tex.useCustomFieldService)({
        issueKey: issueKey,
        fieldId: fieldId,
        fieldType: extension.id,
        source: attributes.source
    });
    const memoizedExtensionData = (0, $eUqFw.useMemo)(()=>({
            ...extensionData,
            fieldId: fieldId,
            fieldName: fieldName,
            fieldType: extension.id,
            renderContext: 'issue-view'
        }), [
        extension,
        extensionData,
        fieldId,
        fieldName
    ]);
    const memoizedExtensionPayload = (0, $eUqFw.useMemo)(()=>({
            fieldValue: editValue
        }), [
        editValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, viewComponent(switchToEditMode, editValue, isLoading), isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3zABe.AsyncCustomFieldEdit), {
        extension: extension,
        extensionData: memoizedExtensionData,
        extensionPayload: memoizedExtensionPayload,
        onConfirm: onEditConfirm,
        onCancel: onEditCancel,
        onRender: onEditRender,
        onError: onEditFail,
        onSave: save,
        analyticsAttributes: attributes
    }));
};

});
parcelRegister("dh9qu", function(module, exports) {

$parcel$export(module.exports, "fireTrackEditedEvent", () => $76db82789679977a$export$1798d320c6527c08);
$parcel$export(module.exports, "fireUiCanceledEvent", () => $76db82789679977a$export$fc09afa3d0d5294c);
$parcel$export(module.exports, "fireOperationalEditFailedEvent", () => $76db82789679977a$export$762dee9e981de3e1);
$parcel$export(module.exports, "fireUiTriggerClickEvent", () => $76db82789679977a$export$cfefb608fbbf02c9);
$parcel$export(module.exports, "fireOperationalFailedEvent", () => $76db82789679977a$export$add44f896fb31ba3);

var $2Rqjr = parcelRequire("2Rqjr");

var $8XU7c = parcelRequire("8XU7c");

var $cYWDh = parcelRequire("cYWDh");

var $d6g7g = parcelRequire("d6g7g");

var $hRcYT = parcelRequire("hRcYT");
const $76db82789679977a$var$moduleEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_EXTENSION),
    entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT)
});
const $76db82789679977a$var$triggerEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
    entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT)
});
const $76db82789679977a$export$1798d320c6527c08 = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).EDITED, {
        id: $76db82789679977a$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $76db82789679977a$export$fc09afa3d0d5294c = (source, attributes)=>(0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).CANCELED, {
        id: $76db82789679977a$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $76db82789679977a$export$762dee9e981de3e1 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).EDIT_FAILED, {
        id: $76db82789679977a$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $76db82789679977a$export$cfefb608fbbf02c9 = (source, attributes)=>{
    (0, $d6g7g.forgeModulesLoadTime).start({
        startTime: performance.now()
    });
    return (0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).CLICKED, {
        id: $76db82789679977a$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};
const $76db82789679977a$export$add44f896fb31ba3 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).FAILED, {
        id: $76db82789679977a$var$moduleEventId,
        source: source,
        attributes: attributes
    });

});

parcelRegister("3zABe", function(module, exports) {

$parcel$export(module.exports, "AsyncCustomFieldEdit", () => $c7a0c627b293f096$export$61f4a77d813bf4b4);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $d6g7g = parcelRequire("d6g7g");
var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");

var $2Rqjr = parcelRequire("2Rqjr");

var $gamHX = parcelRequire("gamHX");

var $2vJHJ = parcelRequire("2vJHJ");

var $k9lIU = parcelRequire("k9lIU");

var $gGtKh = parcelRequire("gGtKh");

var $gWRle = parcelRequire("gWRle");
const $c7a0c627b293f096$export$fc8c2ed652969e74 = (fieldValue, onSave, onConfirm, showFlag)=>onSave(fieldValue).then((response)=>{
        if (response == null) return;
        // The error is handled in the catch block
        if ('error' in response) {
            if (response.error) throw response.error;
        } else onConfirm(response.data);
    }).catch((error)=>{
        showFlag((0, $k9lIU.default)(error));
        // Custom UI depends on this error to get know whether the form was successfully submitted or not
        if ((0, $7byHA.isValidationError)(error)) throw error;
        throw Error(`Unable to save custom field, error: ${error.message}`);
    });

const $c7a0c627b293f096$var$getModule = ()=>(0, $d6g7g.measureInitialPageLoadAsyncResourcesTiming)((0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START, (0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END, ()=>(parcelRequire("almRi")));
const $c7a0c627b293f096$export$55429035358dd625 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$c7a0c627b293f096$var$getModule().then((module)=>module.CustomFieldEdit), {
    ssr: false
}));
const $c7a0c627b293f096$export$5ffe94eb10d5f1f4 = ({ onSave: onSave, onCancel: onCancel, onConfirm: onConfirm, onError: onError, onRender: onRender, ...restProps })=>{
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = restProps;
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const extensionDataValue = (0, $eUqFw.useMemo)(()=>{
        const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
            fieldType: extensionData.fieldType,
            fieldId: extensionData.fieldId,
            fieldName: extensionData.fieldName,
            renderContext: extensionData.renderContext
        };
        return {
            ...preparedExtensionData,
            type: extension.type,
            entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT)
        };
    }, [
        extension.type,
        extensionData
    ]);
    const extraProps = (0, $eUqFw.useMemo)(()=>({
            module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
            entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
            extensionData: extensionDataValue,
            extensionPayload: extensionPayload,
            contextToken: (0, $2Rqjr.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        extensionPayload
    ]);
    const submit = (0, $eUqFw.useCallback)(({ data: fieldValue })=>$c7a0c627b293f096$export$fc8c2ed652969e74(fieldValue, onSave, onConfirm, showFlag), // todo SMT-491 onConfirm, onSave (fieldId) was changing every time component tree was changed by Bento issue view.
    // root cause - Bento's connect-field is creating onConfirm function and fieldId every time. More in mentioned ticket
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        showFlag
    ]);
    const close = onCancel;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const bridge = (0, $eUqFw.useMemo)(()=>({
            submit: submit,
            close: close
        }), [
        submit,
        close
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWRle.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "custom-field-edit",
        fallback: null
    }, (0, $2vJHJ.isCustomUIExtension)(extension, (0, $2Rqjr.ENTRY_POINT_EDIT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gamHX.LazyModalIframe), {
        ...restProps,
        ...extraProps,
        bridge: bridge,
        onClose: onCancel,
        onLoad: onRender
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7a0c627b293f096$export$55429035358dd625, {
        ...restProps,
        ...extraProps,
        onError: onError,
        onRender: onRender,
        onCancel: onCancel,
        submit: submit,
        bridge: bridge
    })));
};
const $c7a0c627b293f096$export$61f4a77d813bf4b4 = $c7a0c627b293f096$export$5ffe94eb10d5f1f4;

});
parcelRegister("k9lIU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a38e26aef80874b3$export$2e2bcd8739ae039);

var $7byHA = parcelRequire("7byHA");

var $e4byB = parcelRequire("e4byB");

var $gYPHE = parcelRequire("gYPHE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a38e26aef80874b3$export$2e2bcd8739ae039 = (error)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $7byHA.isValidationError)(error) ? (0, $gYPHE.default)(error.errors) : (0, $e4byB.default)();

});
parcelRegister("e4byB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b05c03b9263b7a0c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $b05c03b9263b7a0c$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.custom-field.edit-failed.generic-error.title",
        "defaultMessage": "We were unable to edit this custom field. Please try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b05c03b9263b7a0c$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $b05c03b9263b7a0c$var$messages.title,
        isAutoDismiss: false
    });

});

parcelRegister("gYPHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbc09c79bc08bf01$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $dbc09c79bc08bf01$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.custom-field.edit-failed.validation-error.title",
        "defaultMessage": "Validation error"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dbc09c79bc08bf01$export$2e2bcd8739ae039 = (errors)=>({
        type: 'error',
        title: $dbc09c79bc08bf01$var$messages.title,
        description: errors.map(({ error: error })=>error).join(', '),
        isAutoDismiss: false
    });

});


parcelRegister("gWRle", function(module, exports) {

$parcel$export(module.exports, "StopSubmitPropagation", () => $1ee7d0bd2c357478$export$238f56c0891e9254);

var $eUqFw = parcelRequire("eUqFw");
const $1ee7d0bd2c357478$export$e6dfd72ab29f8598 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "forge-ui-async.common.ui.submit-stop-propogation-wrapper.forge-stop-propagation-wrapper",
        onSubmit: props.onSubmit
    }, props.children);
const $1ee7d0bd2c357478$export$238f56c0891e9254 = ({ children: children })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSubmit = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ee7d0bd2c357478$export$e6dfd72ab29f8598, {
        onSubmit: handleSubmit
    }, children);
};

});

parcelRegister("almRi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('bf9ps'),
            load('kWrFZ'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('7pzTP')
        ]);
        const value = parcelRequire('hd1cG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("bf9ps"),
        load("kWrFZ"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("7pzTP")
    ]).then(()=>parcelRequire('hd1cG'));
}

});


parcelRegister("8SL1Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e8fd0d473960334$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $4e8fd0d473960334$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.custom-field.edit-failed.open-model-error.title",
        "defaultMessage": "We were unable to load the form to edit this field. Please try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4e8fd0d473960334$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $4e8fd0d473960334$var$messages.title,
        isAutoDismiss: false
    });

});

parcelRegister("68tex", function(module, exports) {

$parcel$export(module.exports, "useCustomFieldService", () => $e4dc1a7c3c415f39$export$cb362d01c10e239);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $gGiWF = parcelRequire("gGiWF");

var $efTkq = parcelRequire("efTkq");
const $e4dc1a7c3c415f39$var$useSaveCustomField = ({ issueKey: issueKey, fieldId: fieldId, fieldType: fieldType, source: source })=>{
    const [, { saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldId,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        saveField: (0, $efTkq.createSaveCustomField)(source)
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'submit',
        actionSubject: 'forgeCustomFieldEdit'
    });
    return async (valueToSave)=>saveValue(valueToSave, null, analyticsEvent);
};
const $e4dc1a7c3c415f39$var$useCreateServiceInner = (params)=>{
    const saveCustomField = $e4dc1a7c3c415f39$var$useSaveCustomField(params);
    return (0, $eUqFw.useMemo)(()=>({
            save: (value)=>saveCustomField(value)
        }), [
        saveCustomField
    ]);
};
const $e4dc1a7c3c415f39$export$cb362d01c10e239 = (params)=>$e4dc1a7c3c415f39$var$useCreateServiceInner(params);

});
parcelRegister("efTkq", function(module, exports) {

$parcel$export(module.exports, "createSaveCustomField", () => $08bf3643b1caf37f$export$b42a84e7da484344);

var $7byHA = parcelRequire("7byHA");
var $lRmyA = parcelRequire("lRmyA");

var $dh9qu = parcelRequire("dh9qu");
const $08bf3643b1caf37f$export$b42a84e7da484344 = (source)=>async (issueKey, fieldId, value)=>{
        try {
            await (0, $lRmyA.performPutRequest)(`/rest/api/2/issue/${issueKey}`, {
                body: JSON.stringify({
                    fields: {
                        [fieldId]: value
                    }
                })
            });
            return {
                data: value
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (!(0, $7byHA.isValidationError)(error)) (0, $dh9qu.fireOperationalEditFailedEvent)(source, {
                error: error
            });
            throw error;
        }
    };

});


parcelRegister("ayI0Q", function(module, exports) {

$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_EDIT_INITIALIZATION", () => $4c45c21a2a9691e2$export$f54467bec932fd17);
$parcel$export(module.exports, "forgeCustomFieldEditInitialization", () => $4c45c21a2a9691e2$export$c8e5c757ff398336);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_EDIT_RENDERED", () => $4c45c21a2a9691e2$export$ba880396cd557a52);
$parcel$export(module.exports, "forgeCustomFieldEditRendered", () => $4c45c21a2a9691e2$export$59e7b2d3e44df441);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_EDIT_CANCEL", () => $4c45c21a2a9691e2$export$959f1cead0b08352);
$parcel$export(module.exports, "forgeCustomFieldEditCancel", () => $4c45c21a2a9691e2$export$c8d5d12256a3a440);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_EDIT_SET_VALUE", () => $4c45c21a2a9691e2$export$3478e6004895873f);
$parcel$export(module.exports, "forgeCustomFieldEditSetValue", () => $4c45c21a2a9691e2$export$1228188a06c855e8);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_EDIT_FAILED", () => $4c45c21a2a9691e2$export$56d381e9b6b6cf3e);
$parcel$export(module.exports, "forgeCustomFieldEditFailed", () => $4c45c21a2a9691e2$export$8bb98c31415e3304);
const $4c45c21a2a9691e2$export$f54467bec932fd17 = 'FORGE_CUSTOM_FIELD_EDIT_INITIALIZATION';
const $4c45c21a2a9691e2$export$c8e5c757ff398336 = ()=>({
        type: $4c45c21a2a9691e2$export$f54467bec932fd17
    });
const $4c45c21a2a9691e2$export$ba880396cd557a52 = 'FORGE_CUSTOM_FIELD_EDIT_RENDERED';
const $4c45c21a2a9691e2$export$59e7b2d3e44df441 = ()=>({
        type: $4c45c21a2a9691e2$export$ba880396cd557a52
    });
const $4c45c21a2a9691e2$export$959f1cead0b08352 = 'FORGE_CUSTOM_FIELD_EDIT_CANCEL';
const $4c45c21a2a9691e2$export$c8d5d12256a3a440 = ()=>({
        type: $4c45c21a2a9691e2$export$959f1cead0b08352
    });
const $4c45c21a2a9691e2$export$3478e6004895873f = 'FORGE_CUSTOM_FIELD_EDIT_SET_VALUE';
const $4c45c21a2a9691e2$export$1228188a06c855e8 = (action)=>({
        type: $4c45c21a2a9691e2$export$3478e6004895873f,
        payload: action
    });
const $4c45c21a2a9691e2$export$56d381e9b6b6cf3e = 'FORGE_CUSTOM_FIELD_EDIT_FAILED';
const $4c45c21a2a9691e2$export$8bb98c31415e3304 = ()=>({
        type: $4c45c21a2a9691e2$export$56d381e9b6b6cf3e
    });

});

parcelRegister("eLWt7", function(module, exports) {

$parcel$export(module.exports, "default", () => $36d765b1156f8571$export$2e2bcd8739ae039);

var $ayI0Q = parcelRequire("ayI0Q");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$36d765b1156f8571$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 0, $ayI0Q.FORGE_CUSTOM_FIELD_EDIT_INITIALIZATION:
            return {
                ...state,
                isEditing: true,
                isLoading: true
            };
        case 0, $ayI0Q.FORGE_CUSTOM_FIELD_EDIT_RENDERED:
            return {
                ...state,
                isLoading: false
            };
        case 0, $ayI0Q.FORGE_CUSTOM_FIELD_EDIT_CANCEL:
            return {
                ...state,
                isEditing: false
            };
        case 0, $ayI0Q.FORGE_CUSTOM_FIELD_EDIT_SET_VALUE:
            return {
                ...state,
                isEditing: false,
                editValue: action.payload
            };
        case 0, $ayI0Q.FORGE_CUSTOM_FIELD_EDIT_FAILED:
            return {
                ...state,
                isEditing: false,
                isLoading: false
            };
        default:
            return state;
    }
};

});



parcelRegister("3Le4M", function(module, exports) {

$parcel$export(module.exports, "useFormatterValue", () => $327f69ecfea13b96$export$a1c61a651d2a96b9);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $2OdyW = parcelRequire("2OdyW");

var $k8Qyf = parcelRequire("k8Qyf");

var $5Jqzu = parcelRequire("5Jqzu");

var $k3tie = parcelRequire("k3tie");
var $8p8vy = parcelRequire("8p8vy");

var $9Nizy = parcelRequire("9Nizy");

var $iZkNq = parcelRequire("iZkNq");

var $eVpBb = parcelRequire("eVpBb");
const $327f69ecfea13b96$var$FETCH_ERROR_FLAG = {
    type: 'error',
    title: (0, $eVpBb.messages).fetchErrorTitle
};
const $327f69ecfea13b96$export$a1c61a651d2a96b9 = ({ value: value, formatterProperty: formatterProperty, fieldId: fieldId, issueKey: issueKey, issueId: issueId, shouldUseFormatter: shouldUseFormatter, isEditing: isEditing })=>{
    const [formatterValue, setFormatterValue] = (0, $eUqFw.useState)(null);
    const [fieldValue, setFieldValue] = (0, $eUqFw.useState)(value);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(shouldUseFormatter);
    const hasPendingChangeRequestRef = (0, $eUqFw.useRef)(false);
    const isEditModeRef = (0, $eUqFw.useRef)(isEditing);
    const previousValue = (0, $eUqFw.useRef)(undefined);
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [, { registerEventHandler: registerEventHandler }] = (0, $8p8vy.useIssueViewFieldUpdateEvents)();
    const analyticsAttributes = (0, $iZkNq.useAnalyticsAttributesContext)();
    const fetchFormattedValue = (0, $eUqFw.useCallback)(async ()=>{
        if (formatterProperty) try {
            setIsLoading(true);
            const result = await (0, $2OdyW.default)(`/rest/api/3/issue/${issueKey}?fields=${fieldId}&expand=renderedFields`);
            setFormatterValue(result.renderedFields[fieldId]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            showFlag($327f69ecfea13b96$var$FETCH_ERROR_FLAG);
            (0, $5Jqzu.fireOperationalFailedEvent)(analyticsAttributes.source, {
                ...analyticsAttributes,
                error: Error(`Fetching formatted value after edit failed: ${err}`)
            });
        } finally{
            setIsLoading(false);
        }
    }, [
        analyticsAttributes,
        formatterProperty,
        fieldId,
        issueKey,
        showFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldUseFormatter) // extra check for object type
        {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(fieldValue, previousValue.current)) fetchFormattedValue();
        }
        previousValue.current = fieldValue;
    }, [
        shouldUseFormatter,
        fieldValue,
        fetchFormattedValue
    ]);
    if ((0, $9Nizy.isForgeFixStaleFormatterValueOnChangeEnabled)()) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eUqFw.useEffect)(()=>{
            isEditModeRef.current = isEditing;
        }, [
            isEditing
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eUqFw.useEffect)(()=>{
            // We should set the new value when not in the edit mode and a few other conditions are met.
            // The reason for that is that we may get new value from the server as well as from the current edit component.
            // So when it comes from the server we just set it and when it is from the edit component, we are leaving the set operation for the field edit flow.
            // Because the hook is running in the edit mode as well, we should ignore all the changes coming from there and instead wait for the change request.
            // We know whether it is a new server data or an edit mode/submission based on the refs.
            // We can't use props/state in here because of race conditions with update events, instead we have to switch to refs.
            // The refs are mutated instantly and do not cause useEffect overload since they aren't part of the dependency array.
            if (shouldUseFormatter && !isEditModeRef.current && !hasPendingChangeRequestRef.current && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(fieldValue, value)) setFieldValue(value);
        }, [
            shouldUseFormatter,
            value,
            fieldValue
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eUqFw.useEffect)(()=>{
            if (shouldUseFormatter) {
                const unregister = registerEventHandler('onChange', (event)=>{
                    if (event.meta.fieldId === fieldId && event.issueId === issueId) {
                        hasPendingChangeRequestRef.current = false;
                        switch(event.type){
                            case (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_REQUESTED:
                                hasPendingChangeRequestRef.current = true;
                                setIsLoading(true);
                                break;
                            case (0, $k3tie.ChangeEventTypes).FIELD_CHANGED:
                                // We do not unset the loading in here because we want to keep the spinner spinning until the formatted value is fetched.
                                setFieldValue(event.meta.fieldValue);
                                break;
                            case (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_FAILED:
                                showFlag($327f69ecfea13b96$var$FETCH_ERROR_FLAG);
                                setIsLoading(false);
                                break;
                            default:
                                setIsLoading(false);
                        }
                    }
                });
                return unregister;
            }
        }, [
            registerEventHandler,
            shouldUseFormatter,
            fieldId,
            issueId,
            showFlag
        ]);
    } else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useEffect)(()=>{
        if (shouldUseFormatter) {
            const unregister = registerEventHandler('onChange', (event)=>{
                if (event.meta.fieldId === fieldId && event.issueId === issueId) switch(event.type){
                    case (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_REQUESTED:
                        setIsLoading(true);
                        break;
                    case (0, $k3tie.ChangeEventTypes).FIELD_CHANGED:
                        setFieldValue(event.meta.fieldValue);
                        break;
                    case (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_FAILED:
                        showFlag($327f69ecfea13b96$var$FETCH_ERROR_FLAG);
                        setIsLoading(false);
                        break;
                    default:
                        setIsLoading(false);
                }
            });
            return unregister;
        }
    }, [
        registerEventHandler,
        shouldUseFormatter,
        fieldId,
        issueId,
        showFlag
    ]);
    return {
        formatterValue: formatterValue,
        isLoading: isLoading
    };
};

});
parcelRegister("eVpBb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c50c85af868d98be$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $c50c85af868d98be$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    fetchErrorTitle: {
        "id": "issue.forge.formatter.fetch-error-title",
        "defaultMessage": "We couldn't fetch the edited value. Please reload the page."
    }
});

});


parcelRegister("9IO8A", function(module, exports) {

$parcel$export(module.exports, "useValueFunction", () => $b3ee8a3625e8ff76$export$2f29232abcf0282d);

var $eUqFw = parcelRequire("eUqFw");

var $7byHA = parcelRequire("7byHA");

var $eTZsp = parcelRequire("eTZsp");

var $5Jqzu = parcelRequire("5Jqzu");

var $kmr29 = parcelRequire("kmr29");

var $iZkNq = parcelRequire("iZkNq");

var $lfXnU = parcelRequire("lfXnU");
const $b3ee8a3625e8ff76$export$2f29232abcf0282d = (issueKey, issueId, fieldId, extensionType, defaultLoadingState, onSave)=>{
    const [, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldId
    });
    const analyticsAttributes = (0, $iZkNq.useAnalyticsAttributesContext)();
    const [value, setValue] = (0, $eUqFw.useState)(null);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(defaultLoadingState);
    const requestExecuteValueFunction = (0, $eUqFw.useCallback)(async ()=>{
        if (!issueId) return;
        setError(null);
        setIsLoading(true);
        try {
            const response = await (0, $lfXnU.executeValueFunction)(fieldId, [
                issueId
            ]);
            if (response) {
                const valueFunction = response?.values[0];
                const newValue = valueFunction.value;
                setValue(valueFunction);
                onSave && onSave(newValue);
                setFieldValue(issueKey, fieldId, newValue);
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const attributes = {
                ...analyticsAttributes,
                error: new (0, $7byHA.default)(err?.statusCode, `${(0, $eTZsp.INVOKE_VALUE_FUNCTION_FAILED)} ${err.message}`)
            };
            (0, $5Jqzu.fireOperationalFailedEvent)(analyticsAttributes.source, attributes);
            setError(err);
        } finally{
            setIsLoading(false);
        }
    // we don't want onSave function to constantly recall this function
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        extensionType,
        setFieldValue,
        fieldId,
        issueId,
        issueKey,
        analyticsAttributes
    ]);
    return {
        error: error,
        value: value,
        isLoading: isLoading,
        requestExecuteValueFunction: requestExecuteValueFunction
    };
};

});
parcelRegister("lfXnU", function(module, exports) {

$parcel$export(module.exports, "executeValueFunction", () => $77d72adf3c7f69ac$export$9f0386fe29ffcc46);

var $lRmyA = parcelRequire("lRmyA");

var $d6g7g = parcelRequire("d6g7g");

var $hRcYT = parcelRequire("hRcYT");
const $77d72adf3c7f69ac$export$9f0386fe29ffcc46 = (customFieldId, issueIds)=>{
    const postValueFunction = (0, $lRmyA.performPostRequest)('/rest/internal/3/forge/field/value', {
        body: JSON.stringify({
            customFieldId: customFieldId,
            issueIds: issueIds
        })
    });
    return (0, $d6g7g.measureInitialPageLoadAsyncResourcesTiming)((0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START, (0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END, ()=>postValueFunction);
};

});




parcelRegister("jJtOG", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e4c71c5f29e515$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cSu9v = parcelRequire("cSu9v");

var $hnzPP = parcelRequire("hnzPP");

var $f8Yej = parcelRequire("f8Yej");

var $ciZ8Y = parcelRequire("ciZ8Y");


var $1ybV0 = parcelRequire("1ybV0");

var $1boRu = parcelRequire("1boRu");

var $5syGA = parcelRequire("5syGA");

var $31FPg = parcelRequire("31FPg");

var $54bfs = parcelRequire("54bfs");

var $2Rqjr = parcelRequire("2Rqjr");

var $fT83w = parcelRequire("fT83w");

var $hJ992 = parcelRequire("hJ992");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $4ceCM = parcelRequire("4ceCM");

var $5G3JL = parcelRequire("5G3JL");

var $fCyzk = parcelRequire("fCyzk");

var $lqalZ = parcelRequire("lqalZ");

var $5JqpU = parcelRequire("5JqpU");

var $8QKSg = parcelRequire("8QKSg");

var $cbR1M = parcelRequire("cbR1M");

var $2qZHF = parcelRequire("2qZHF");

var $guDlK = parcelRequire("guDlK");

var $9p0KY = parcelRequire("9p0KY");

var $8bEhp = parcelRequire("8bEhp");
const $54e4c71c5f29e515$export$ce501251cde8d2f3 = ({ title: title, label: label, extension: extension, icon: icon, source: source, appKey: appKey, moduleKey: moduleKey, onOpenGlancePanel: onOpenGlancePanel, extensionData: extensionData })=>{
    const [isHovering, setIsHovering] = (0, $eUqFw.useState)(false);
    const eventHandlers = {
        onMouseEnter: ()=>setIsHovering(true),
        onMouseLeave: ()=>setIsHovering(false),
        onFocus: ()=>setIsHovering(true),
        onBlur: ()=>setIsHovering(false)
    };
    const openGlancePanel = ()=>{
        (0, $31FPg.fireUiTriggerClickedEvent)(source, {
            moduleKey: moduleKey
        });
        onOpenGlancePanel(appKey, moduleKey);
    };
    let application;
    let edition;
    if ((0, $1ybV0.ff)('instrumentation-of-issue-ecosystem-reliability-slo-metrics-rhs_tpmqi')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
        const issueKey = (0, $hJ992.useIssueKey)();
        // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
        const projectKey = (0, $guDlK.useProjectKey)(issueKey);
        // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
        application = (0, $guDlK.useApplication)(projectKey, true);
        // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
        edition = (0, $guDlK.useEdition)(projectKey, true);
    }
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    const wrappedContentFFOn = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fT83w.ExtensionTitle), {
        extensionName: title,
        extensionEnvType: environmentType,
        extensionEnvKey: environmentKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.issue-base.context.ecosystem.forge.issue-glance.field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
        onEnter: openGlancePanel,
        "data-testid": "issue-view-base.context.ecosystem.forge.issue-glance.enter-escape-handler"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9p0KY.ContentContainer), {
        onClick: openGlancePanel,
        tabIndex: 0,
        ...eventHandlers,
        "data-testid": "issue-view-base.context.ecosystem.forge.issue-glance.container"
    }, icon != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9p0KY.Icon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
        url: icon,
        width: 24,
        height: 24
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9p0KY.Content), null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8bEhp.Status), {
        extension: extension,
        extensionData: extensionData,
        appKey: appKey,
        moduleKey: moduleKey
    }), isHovering && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cbR1M.default), {
        mountAnimation: (0, $9p0KY.SlideInAnimation)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9p0KY.RoundButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9p0KY.RoundButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        size: "medium",
        label: ""
    }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: {
            source: source,
            moduleKey: moduleKey,
            moduleType: (0, $2Rqjr.ISSUE_GLANCE_MODULE)
        }
    }));
    if ((0, $1ybV0.ff)('instrumentation-of-issue-ecosystem-reliability-slo-metrics-rhs_tpmqi')) {
        const commonAnalyticAttributes = {
            experience: 'issueViewForgeGlanceFieldRender',
            analyticsSource: 'issueViewForgeGlanceFieldView',
            application: application ?? null,
            edition: edition ?? null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
            id: "issue-view.context.ecosystem-glance-field-forge",
            onError: (location, error)=>(0, $4ceCM.sendExperienceAnalytics)({
                    ...commonAnalyticAttributes,
                    wasExperienceSuccesful: false,
                    action: (0, $99e7a4e4cbcb5db0$export$b48b3d1872522384),
                    additionalAttributes: {
                        location: location,
                        errorMessage: error.message
                    }
                })
        }, wrappedContentFFOn, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: ()=>(0, $4ceCM.sendExperienceAnalytics)({
                    ...commonAnalyticAttributes,
                    wasExperienceSuccesful: true,
                    action: (0, $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a)
                })
        }));
    }
    return wrappedContentFFOn;
};
const $54e4c71c5f29e515$export$874c27ab19785ccc = (props)=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [, { setIssueViewLayoutGlance: setIssueViewLayoutGlance }] = (0, $fCyzk.useIssueLayoutActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($54e4c71c5f29e515$export$ce501251cde8d2f3, {
        ...props,
        onOpenGlancePanel: (appKey, moduleKey)=>{
            setIssueViewLayoutGlance(issueKey, {
                appKey: appKey,
                moduleKey: moduleKey
            });
        }
    });
};
const $54e4c71c5f29e515$export$91b8454fffa2d685 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $54bfs.TriggerAnalyticsWrapper), {
        attributes: {
            source: props.source,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($54e4c71c5f29e515$export$874c27ab19785ccc, props));
var $54e4c71c5f29e515$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        source: (0, $5JqpU.analyticsSourceSelector)(state),
        extensionData: (0, $8QKSg.forgeIssueDataSelector)(state)
    }), {}))($54e4c71c5f29e515$export$91b8454fffa2d685);

});
parcelRegister("31FPg", function(module, exports) {

$parcel$export(module.exports, "fireUiTriggerClickedEvent", () => $2b43361c7b574ab0$export$cc0cc6563e35ae9);

var $2Rqjr = parcelRequire("2Rqjr");

var $8XU7c = parcelRequire("8XU7c");

var $cYWDh = parcelRequire("cYWDh");

var $d6g7g = parcelRequire("d6g7g");

var $hRcYT = parcelRequire("hRcYT");
const $2b43361c7b574ab0$var$triggerEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.ISSUE_GLANCE_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER)
});
const $2b43361c7b574ab0$export$cc0cc6563e35ae9 = (source, attributes)=>{
    (0, $d6g7g.forgeModulesLoadTime).start({
        startTime: performance.now()
    });
    return (0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).CLICKED, {
        id: $2b43361c7b574ab0$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};

});

parcelRegister("54bfs", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $8439b55858078f85$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $8439b55858078f85$export$e1a79e3d472c925a);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");
const $8439b55858078f85$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.ISSUE_GLANCE_MODULE),
        ...props
    });
const $8439b55858078f85$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.ISSUE_GLANCE_MODULE),
        moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("8bEhp", function(module, exports) {

$parcel$export(module.exports, "Status", () => $85f96f4350013200$export$96e9906d6d93a972);

var $eUqFw = parcelRequire("eUqFw");

var $9nkwJ = parcelRequire("9nkwJ");

var $96IgR = parcelRequire("96IgR");

var $ffiyv = parcelRequire("ffiyv");

var $4Bees = parcelRequire("4Bees");

var $PdmhA = parcelRequire("PdmhA");

var $hnzPP = parcelRequire("hnzPP");

var $cKMNR = parcelRequire("cKMNR");

var $hJ992 = parcelRequire("hJ992");

var $fCyzk = parcelRequire("fCyzk");

var $9p0KY = parcelRequire("9p0KY");
const $85f96f4350013200$export$96e9906d6d93a972 = ({ extension: extension, extensionData: extensionData, appKey: appKey, moduleKey: moduleKey })=>{
    const { properties: properties, error: error, isLoading: isLoading, fetch: fetch } = (0, $cKMNR.useDynamicProperties)(extension, extensionData);
    const issueKey = (0, $hJ992.useIssueKey)();
    const [openedGlance] = (0, $fCyzk.useIssueLayoutGlance)(issueKey);
    const hasDynamicProperties = !!extension.properties.dynamicProperties;
    const isOpen = !!openedGlance && openedGlance.appKey === appKey && openedGlance.moduleKey === moduleKey;
    (0, $eUqFw.useEffect)(()=>{
        if (hasDynamicProperties && !isOpen) fetch();
    }, [
        hasDynamicProperties,
        isOpen,
        fetch
    ]);
    const render = ()=>{
        if (hasDynamicProperties) {
            if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
                size: "small"
            });
            if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                label: "Error",
                primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA.R300)})`
            });
        }
        const { status: extensionStatus = {} } = extension.properties;
        const status = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        hasDynamicProperties && properties && properties.status ? // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        properties.status : extensionStatus;
        switch(status.type){
            case 'lozenge':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                    appearance: status.value.type
                }, status.value.label);
            case 'badge':
                {
                    const num = parseInt(status.value.label, 10);
                    if (num >= 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
                        appearance: "default"
                    }, num);
                    return null;
                }
            case 'icon':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
                    url: status.value.url,
                    width: 24,
                    height: 24
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9p0KY.StatusContainer), null, render());
};

});
parcelRegister("cKMNR", function(module, exports) {

$parcel$export(module.exports, "useDynamicProperties", () => $47cca41b0282c3a6$export$59a2a2cb52e44fd3);

var $fE3S2 = parcelRequire("fE3S2");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $gd0Sp = parcelRequire("gd0Sp");
const $47cca41b0282c3a6$export$59a2a2cb52e44fd3 = (extension, extensionData)=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $gd0Sp.useTenantContext)();
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [invokeExtensionMutation, isLoading] = (0, $iWLL0.useMutation)((0, $fE3S2.default));
    const request = (0, $eUqFw.useCallback)(()=>invokeExtensionMutation({
            variables: {
                input: {
                    entryPoint: 'dynamicProperties',
                    extensionId: extension.id,
                    contextIds: (0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x') ? [
                        `ari:cloud:jira:${cloudId}:workspace/${activationId}`
                    ] : [
                        `ari:cloud:jira::site/${cloudId}`
                    ],
                    payload: {
                        cloudId: cloudId,
                        extension: {
                            type: extension.type,
                            ...extensionData
                        }
                    }
                }
            },
            onCompleted: (result, errors)=>{
                setError(errors ? errors[0] : null);
                setData(result?.invokeExtension?.response?.body);
            },
            onError: (err)=>{
                setError(err);
            }
        }), [
        invokeExtensionMutation,
        extension.id,
        extension.type,
        cloudId,
        activationId,
        extensionData
    ]);
    return {
        properties: data,
        error: error,
        isLoading: isLoading,
        fetch: request
    };
};

});
parcelRegister("fE3S2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea2ed460056b7287$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<039371d467fb0ab33ece99f023ffb133>>
 * @relayHash 7d01262d5025697f028307c1ed6a3870
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6882ce66b70a24b78202abfbb7cd6c9229b8f3b47d2ae586672a184e84b32399
const $ea2ed460056b7287$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "InvocationResponsePayload",
        "kind": "LinkedField",
        "name": "response",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "body"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "dynamicPropertiesMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "InvokeExtensionResponse",
                    "kind": "LinkedField",
                    "name": "invokeExtension",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "dynamicPropertiesMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "InvokeExtensionResponse",
                    "kind": "LinkedField",
                    "name": "invokeExtension",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6882ce66b70a24b78202abfbb7cd6c9229b8f3b47d2ae586672a184e84b32399",
            "metadata": {},
            "name": "dynamicPropertiesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$ea2ed460056b7287$var$node.hash = "d8ddf6e5c2dae3430b192a70c44d0079";
var $ea2ed460056b7287$export$2e2bcd8739ae039 = $ea2ed460056b7287$var$node;

});




parcelRegister("oM0hT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1802e9bd3e2f1182$export$2e2bcd8739ae039);

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $8711r = parcelRequire("8711r");
var $1802e9bd3e2f1182$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        additionalProps: ()=>({
                fieldId: ownPropsOnMount.fieldId,
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            })
    }))((0, $8711r.AsyncEntitlementsField));

});
parcelRegister("8711r", function(module, exports) {

$parcel$export(module.exports, "AsyncEntitlementsField", () => $726ac7e99f752c3b$export$a2fb6aab825d065b);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $9IbuV = parcelRequire("9IbuV");

var $fBXcZ = parcelRequire("fBXcZ");

const $726ac7e99f752c3b$var$LazyEntitlementsField = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("4P9pp")), {
    moduleId: "./src/packages/servicedesk/customer-service/entitlements-field/src/ui/issue-view-entitlement-field/index.tsx"
});
const $726ac7e99f752c3b$export$a2fb6aab825d065b = (props)=>{
    (0, $9IbuV.useUFOComponentExperience)((0, $fBXcZ.entitlementFieldIssueViewMountExperience));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "jsmCustomerServiceEntitlementsField",
        packageName: "atlassian/jira-servicedesk-customer-service-entitlements-field",
        onError: ()=>(0, $fBXcZ.entitlementFieldIssueViewMountExperience).failure()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-customer-service-entitlements-field",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($726ac7e99f752c3b$var$LazyEntitlementsField, props)));
};

});
parcelRegister("fBXcZ", function(module, exports) {

$parcel$export(module.exports, "entitlementFieldGicMountExperience", () => $64cb0afcb2836c16$export$588fc8ac7a187272);
$parcel$export(module.exports, "entitlementFieldDataFetchExperience", () => $64cb0afcb2836c16$export$7f9aebf7c6d536d6);
$parcel$export(module.exports, "entitlementFieldIssueViewMountExperience", () => $64cb0afcb2836c16$export$66e03de8aa0e97b8);
$parcel$export(module.exports, "editEntitlementFieldIssueViewExperience", () => $64cb0afcb2836c16$export$6889e91b24599276);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $64cb0afcb2836c16$export$588fc8ac7a187272 = new (0, $kDfSL.UFOExperience)('jsm-cs-entitlement-custom-field-gic-mount', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $64cb0afcb2836c16$export$7f9aebf7c6d536d6 = new (0, $kDfSL.UFOExperience)('jsm-cs-entitlement-custom-field-data-fetch', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $64cb0afcb2836c16$export$66e03de8aa0e97b8 = new (0, $kDfSL.UFOExperience)('jsm-cs-entitlement-custom-field-issue-view-mount', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $64cb0afcb2836c16$export$6889e91b24599276 = new (0, $kDfSL.UFOExperience)('jsm-cs-entitlement-custom-field-issue-view-edit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("4P9pp", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iykkT');
        const value = parcelRequire('gazh2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iykkT").then(()=>parcelRequire('gazh2'));
}

});



parcelRegister("ep9Nd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a68771f368354c4$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $ck220 = parcelRequire("ck220");

var $2OdyW = parcelRequire("2OdyW");
var $lRmyA = parcelRequire("lRmyA");

var $8E9UG = parcelRequire("8E9UG");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");


var $lV5H0 = parcelRequire("lV5H0");

var $5JqpU = parcelRequire("5JqpU");

var $jMP2a = parcelRequire("jMP2a");

var $kjUsy = parcelRequire("kjUsy");

var $isr2y = parcelRequire("isr2y");
const $6a68771f368354c4$export$2b81811283cd2d9d = (0, $5iWql.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(baseUrl, projectKey, intl)=>(query, excludeDone)=>{
        const queryParams = new URLSearchParams({
            excludeDone: excludeDone,
            projectKey: projectKey,
            maxResults: String((0, $01ebb9fb24166a6d$export$dc19dd4ec6aafc74)),
            query: query
        });
        const url = `${baseUrl}/rest/agile/1.0/epic/search?${queryParams.toString()}`;
        const dataFromServer = (0, $2OdyW.default)(url).then((data)=>data).catch((error)=>{
            throw error;
        });
        return Promise.all([
            dataFromServer,
            (0, $ck220.default).getAll()
        ]).then(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([dataFromAPI, cache])=>{
            const dataFromCache = (0, $isr2y.transformCacheEntries)(cache, excludeDone);
            return (0, $isr2y.transformSuggestionsFromPublicAPIAndCache)(dataFromAPI, dataFromCache, intl);
        });
    });
var $6a68771f368354c4$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>{
    const getDataFromCache = (excludeDone)=>(0, $ck220.default).getAll().then((epics)=>(0, $isr2y.transformCacheEntries)(epics, excludeDone)).then((epics)=>(0, $isr2y.transformSuggestionsFromPublicAPIAndCache)(undefined, epics, ownPropsOnMount.intl));
    return {
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $isr2y.transformFromStateValue,
        transformToStateValue: $isr2y.transformToStateValue,
        additionalProps: (state, intl)=>({
                fetchSuggestions: $6a68771f368354c4$export$2b81811283cd2d9d((0, $5JqpU.baseUrlSelector)(state), (0, $5JqpU.projectKeySelector)(state), intl),
                placeholder: intl.formatMessage((0, $kjUsy.default).placeholder),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                allowEmptyValue: true,
                getDataFromCache: getDataFromCache,
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            }),
        saveField: ({ baseUrl: baseUrl, issueKey: issueKey, fieldMetaKey: fieldMetaKey, value: value })=>{
            if (ownPropsOnMount.createAnalyticsEvent && value?.key) {
                (0, $jMP2a.fireOperationalAnalytics)(ownPropsOnMount.createAnalyticsEvent({}), 'epicPickerCache set', {
                    isFromCache: value.fromCache
                });
                (0, $ck220.default).set(value.key, value);
            }
            return (0, $lRmyA.performPutRequest)((0, $lV5H0.getIssueApiUrl)(baseUrl, issueKey), {
                body: JSON.stringify({
                    fields: {
                        [fieldMetaKey]: value ? value.key : null
                    }
                })
            }).catch((error)=>{
                if (ownPropsOnMount.createAnalyticsEvent && value?.key) {
                    (0, $jMP2a.fireOperationalAnalytics)(ownPropsOnMount.createAnalyticsEvent({}), 'epicPickerCache removed');
                    value?.key && (0, $ck220.default).remove(value.key);
                }
                throw error;
            });
        }
    };
})((0, $8E9UG.default));

});
parcelRegister("ck220", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb8be99d586c2747$export$2e2bcd8739ae039);

var $jhVpU = parcelRequire("jhVpU");

var $cSWEO = parcelRequire("cSWEO");
var $fb8be99d586c2747$export$2e2bcd8739ae039 = (0, $jhVpU.default)((0, $cSWEO.props));

});
parcelRegister("cSWEO", function(module, exports) {

$parcel$export(module.exports, "props", () => $b1352952baa712be$export$8128bb6492cf3de7);

const $b1352952baa712be$var$MAX_RESULTS = 5;
const $b1352952baa712be$var$CACHE_SIZE = $b1352952baa712be$var$MAX_RESULTS * 2;
const $b1352952baa712be$var$EPICS_CACHE_KEY = 'epics';
const $b1352952baa712be$export$8128bb6492cf3de7 = {
    size: $b1352952baa712be$var$CACHE_SIZE,
    cacheKey: $b1352952baa712be$var$EPICS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)
};

});


parcelRegister("8E9UG", function(module, exports) {

$parcel$export(module.exports, "getOptionColorElemPatch", () => $59f3cb3eeeff4940$export$917c137fb1de5bbc);
$parcel$export(module.exports, "default", () => $59f3cb3eeeff4940$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kFGm5 = parcelRequire("kFGm5");

var $9jNAz = parcelRequire("9jNAz");

var $tgbCK = parcelRequire("tgbCK");

var $jxxzJ = parcelRequire("jxxzJ");

var $i4m05 = parcelRequire("i4m05");

var $KpAsD = parcelRequire("KpAsD");

var $afDma = parcelRequire("afDma");

var $5XicQ = parcelRequire("5XicQ");

var $fHNT1 = parcelRequire("fHNT1");
const $59f3cb3eeeff4940$export$b00899e73680c477 = (tagColor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        color: tagColor,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($59f3cb3eeeff4940$var$OptionColorSizer, null),
        text: ""
    });
const $59f3cb3eeeff4940$export$917c137fb1de5bbc = (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($59f3cb3eeeff4940$var$ColorPatch, {
        color: color
    });
const $59f3cb3eeeff4940$export$a76a187c69cb5b4b = (query, content)=>{
    const SPECIAL_CHARS_REGEX = /[.*+?^${}()|[\]\\]/g;
    const boundary = SPECIAL_CHARS_REGEX.test(query) ? 'B' : 'b';
    const escapedQuery = query.replace(SPECIAL_CHARS_REGEX, '\\$&');
    const regexWordBoundary = new RegExp(`\\${boundary}${escapedQuery}.*`, 'i');
    const regexInAnyWords = new RegExp(`.*${escapedQuery}.*`, 'i');
    const selectedViaWordBoundarySearch = regexWordBoundary.test(content);
    const selectedViaInAnyWordsSearch = !selectedViaWordBoundarySearch ? regexInAnyWords.test(content) : false;
    return {
        selectedViaWordBoundarySearch: selectedViaWordBoundarySearch,
        selectedViaInAnyWordsSearch: selectedViaInAnyWordsSearch
    };
};
class $59f3cb3eeeff4940$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'EpicInlineEditView';
    }
    render() {
        const additionalAnalyticsProps = {
            isEpicLink: true
        };
        const { data: data, loading: loading, error: error } = this.state;
        const initialData = {
            data: data,
            loading: loading,
            error: error
        };
        const componentsProps = {
            isChecked: this.state.includeDoneEpics,
            onChange: this.onChangeIncludeDone
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jxxzJ.default), {
            ...(0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(this.props, 'getDataFromCache'),
            debounceFetchSuggestionsTime: 300,
            initialData: initialData,
            // @ts-expect-error - TS2322 - Type '{ isChecked: boolean; onChange: () => Promise<void>; }' is not assignable to type '{ isChecked: boolean; onChange: () => Promise<undefined> | undefined; } & { isChecked: boolean; onChange: () => Promise<undefined> | undefined; } & { isChecked: boolean; onChange: () => Promise<...> | undefined; }'.
            componentsProps: componentsProps,
            fetchSuggestions: this.fetchSuggestions,
            additionalAnalyticsProps: additionalAnalyticsProps,
            // @ts-expect-error - TS2322 - Type '(props: Props) => JSX.Element' is not assignable to type 'ReactNode'.
            components: {
                Menu: $5XicQ.default
            },
            renderReadView: this.renderReadView,
            // @ts-expect-error - TS2322 - Type '(option: OptionType, { context }: FormatOptionLabelMeta) => string | JSX.Element' is not assignable to type 'FormatOptionLabel'.
            formatOptionLabel: this.formatOptionLabel,
            hasAutocomplete: true,
            isEditable: !(0, $i4m05.isDisableEpicLinkAndParentLinkFieldsEnabled)()
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            includeDoneEpics: false,
            query: '',
            data: [],
            loading: false,
            error: false
        };
        this.componentDidMount = ()=>{
            this.getDataFromCache();
        };
        this.sessionId = 'default-session-id' // uuid represent epic selection session
        ;
        this.getDataFromCache = ()=>{
            // API accepts exclude done epics param
            this.props.getDataFromCache?.(!this.state.includeDoneEpics).then((data)=>{
                this.setState({
                    data: data,
                    loading: false
                });
            });
        };
        this.renderReadView = ()=>{
            const { value: value, noValueText: noValueText, isMobile: isMobile } = this.props;
            if ((0, $i4m05.isDisableEpicLinkAndParentLinkFieldsEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $KpAsD.DisabledInlineReadView), null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $afDma.InlineReadView), {
                value: value,
                noValueText: noValueText,
                isMobile: isMobile
            });
        };
        this.fetchSuggestions = (query, sessionId)=>{
            if (sessionId !== null && sessionId !== undefined && sessionId !== '') this.sessionId = sessionId;
            this.setState({
                query: query
            });
            // API accepts exclude done epics param
            return this.props.fetchSuggestions(query, !this.state.includeDoneEpics, this.sessionId).then((data)=>{
                this.setState({
                    data: data
                });
                return data;
            });
        };
        this.onChangeIncludeDone = async ()=>{
            const { query: query, includeDoneEpics: includeDoneEpics } = this.state;
            this.setState({
                includeDoneEpics: !includeDoneEpics,
                loading: true
            }, ()=>this.fetchSuggestions(query).then((data)=>{
                    this.setState({
                        data: data,
                        loading: false,
                        error: false
                    });
                }).catch(()=>{
                    this.setState({
                        data: [],
                        loading: false,
                        error: true
                    });
                }));
        };
        this.formatOptionLabel = (option, { context: context })=>{
            if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fHNT1.default), {
                option: option
            });
            return option.label;
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59f3cb3eeeff4940$var$OptionColorSizer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91crf",
            __cmplp.className
        ])
    });
});
const $59f3cb3eeeff4940$var$ColorPatch = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1csmnvd": (0, $9t7rW.default)((0, $tgbCK.MAP_COLORS_TO_VALUE)[__cmplp.color])
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbgktf _1ul9gktf _4t3igktf _2rko1y44 _bfhksav4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("KpAsD", function(module, exports) {

$parcel$export(module.exports, "DisabledInlineReadView", () => $2c22f07b06be65d7$export$bcd3fb98db31050);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8uD7Y = parcelRequire("8uD7Y");

var $kzIu1 = parcelRequire("kzIu1");
const $2c22f07b06be65d7$export$bcd3fb98db31050 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2c22f07b06be65d7$var$DisabledInlineReadViewWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $kzIu1.default).replacedByParentField,
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
        }
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2c22f07b06be65d7$var$DisabledInlineReadViewWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721jtm _syaz1wmz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kzIu1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e89e98b4f90404b4$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $e89e98b4f90404b4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    checkboxLabel: {
        "id": "issue.views.field.epic.checkbox.label",
        "defaultMessage": "Show done epics"
    },
    doneEpicLabel: {
        "id": "issue.views.field.epic.done.label",
        "defaultMessage": "Done"
    },
    epicTitle: {
        "id": "issue.views.field.epic.epic.title",
        "defaultMessage": "Click to visit"
    },
    replacedByParentField: {
        "id": "issue.views.field.epic.replaced.by.parent",
        "defaultMessage": "Replaced by <strong>Parent</strong> field"
    }
});

});


parcelRegister("afDma", function(module, exports) {

$parcel$export(module.exports, "InlineReadView", () => $53075d07e38c912c$export$61837c9bdb9791f5);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $3ZL8o = parcelRequire("3ZL8o");

var $4ZBoO = parcelRequire("4ZBoO");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lPQPn = parcelRequire("lPQPn");
var $tgbCK = parcelRequire("tgbCK");

var $4xwq2 = parcelRequire("4xwq2");

var $6vrw7 = parcelRequire("6vrw7");

var $kzIu1 = parcelRequire("kzIu1");

var $ibAPE = parcelRequire("ibAPE");
// type assertion is fine as the record key is of type Color
const $53075d07e38c912c$var$findColor = (color)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys((0, $tgbCK.MAP_COLOR_TO_AK_COLOR)).find((key)=>(0, $tgbCK.MAP_COLOR_TO_AK_COLOR)[key] === color);
const $53075d07e38c912c$var$handleMouseDown = (e)=>{
    // @ts-expect-error - TS2559 - Type 'EventTarget' has no properties in common with type 'ElementToCheck'.
    if ((0, $3ZL8o.default)(e.target, e.currentTarget)) e.stopPropagation();
};
const $53075d07e38c912c$export$61837c9bdb9791f5 = ({ value: value, noValueText: noValueText, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, value?.content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZBoO.AsyncEpicCard), {
        issueKey: (0, $6vrw7.toIssueKey)(value.value.toString()),
        epicName: value.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: value?.content.length > 20 ? value?.content : ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        onClick: $53075d07e38c912c$var$handleMouseDown,
        onMouseDown: $53075d07e38c912c$var$handleMouseDown,
        onKeyPress: $53075d07e38c912c$var$handleMouseDown,
        role: "presentation"
    }, isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ibAPE.TagWrapperNoClick), {
        /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ style: (0, $lPQPn.getLozengeThemeByColor)($53075d07e38c912c$var$findColor(value.color))
    }, value.content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ibAPE.TagWrapper), {
        href: value.href,
        "aria-label": `${formatMessage((0, $kzIu1.default).epicTitle)} ${value.content}`,
        /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ style: (0, $lPQPn.getLozengeThemeByColor)($53075d07e38c912c$var$findColor(value.color))
    }, value.content)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), null, noValueText));
};

});
parcelRegister("4ZBoO", function(module, exports) {

$parcel$export(module.exports, "AsyncEpicCard", () => $01e60cecdbf0b73a$export$1f1572e418be80f4);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $01e60cecdbf0b73a$var$AsyncLazyEpicCard = (0, $7rh0R.lazy)(()=>(parcelRequire("kISq0")), {
    moduleId: "./src/packages/issue/epic-card/src/ui/index.tsx"
});
const $01e60cecdbf0b73a$export$1f1572e418be80f4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "epic-card",
        packageName: "jira-epic-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-details-epic-card",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($01e60cecdbf0b73a$var$AsyncLazyEpicCard, props)));

});
parcelRegister("kISq0", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fqEqj');
        const value = parcelRequire('5LQqL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fqEqj").then(()=>parcelRequire('5LQqL'));
}

});


parcelRegister("ibAPE", function(module, exports) {

$parcel$export(module.exports, "TagWrapper", () => $47b8277b0f3d32e9$export$5cae96c96545dd75);
$parcel$export(module.exports, "TagWrapperNoClick", () => $47b8277b0f3d32e9$export$8743590f0930aedd);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $47b8277b0f3d32e9$export$5cae96c96545dd75 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _vwz47vkz _4t3if6fq _p12fmgvx _1yt4u49m _1wybdlk8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c _2rko1l7b _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $47b8277b0f3d32e9$export$8743590f0930aedd = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _vwz47vkz _4t3if6fq _p12fmgvx _1yt4u49m _1wybdlk8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c _2rko1l7b _lcxvglyw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("5XicQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ff2fcf4de6022b9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bT7k5 = parcelRequire("bT7k5");

var $jQxSL = parcelRequire("jQxSL");

var $4ksts = parcelRequire("4ksts");


var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $amhNL = parcelRequire("amhNL");

var $kzIu1 = parcelRequire("kzIu1");

var $eQohw = parcelRequire("eQohw");
const $8ff2fcf4de6022b9$var$Menu = (props)=>{
    const intl = (0, $4ksts.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '0 | undefined' and '20' have no overlap.
    const isOptionsLengthMax = props.options[1]?.options?.length === (0, $01ebb9fb24166a6d$export$dc19dd4ec6aafc74);
    const onChange = props.selectProps.componentsProps?.onChange;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const isChecked = props.selectProps.componentsProps?.isChecked;
    const onVisibilityChange = (0, $eUqFw.useCallback)((isVisible)=>{
        if (isVisible && isOptionsLengthMax) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'intersectionComponent viewed', 'epicLink');
        }
    }, [
        createAnalyticsEvent,
        isOptionsLengthMax
    ]);
    const onClick = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'args' implicitly has an 'any' type.
    (args)=>{
        if (onChange) {
            onChange(args);
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'doneEpics filtered', 'epicLink', {
                includeDone: !isChecked
            });
        }
    }, [
        createAnalyticsEvent,
        isChecked,
        onChange
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        // stopping propagation when focus moves to checkbox because select already binded with space and enter for selection
        if (event.key === ' ') event.stopPropagation();
    }, []);
    const label = intl.formatMessage((0, $kzIu1.default).checkboxLabel);
    return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; options: Option[]; selectProps: { componentsProps?: { isChecked?: boolean | undefined; onChange?: ((arg1: ChangeEvent<HTMLInputElement>) => void) | undefined; } | undefined; }; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 6 more.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Menu, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eQohw.CheckboxWrapper), {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        onKeyDown: onKeyDown,
        isChecked: isChecked,
        size: "medium",
        label: label,
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.field.epic.checkbox"
    })), props.children, isOptionsLengthMax && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $amhNL.default), {
        onVisibilityChange: onVisibilityChange
    })));
};
var $8ff2fcf4de6022b9$export$2e2bcd8739ae039 = $8ff2fcf4de6022b9$var$Menu;

});
const $01ebb9fb24166a6d$export$dc19dd4ec6aafc74 = 20;

parcelRegister("amhNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3149ef8d4dc18dc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $b3149ef8d4dc18dc$var$Intersection = ({ onVisibilityChange: onVisibilityChange })=>{
    const [isIntersecting, setIsIntersecting] = (0, $eUqFw.useState)(false);
    const observer = (0, $eUqFw.useRef)();
    const component = (0, $eUqFw.useRef)();
    const setupObserver = ()=>{
        if (window.IntersectionObserver && component.current) {
            const handleIntersect = (entries)=>{
                entries.forEach((entry)=>{
                    if (entry.target === component.current) setIsIntersecting(entry.isIntersecting);
                });
            };
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0
            };
            observer.current = new IntersectionObserver(handleIntersect, options).observe(// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'Element'.
            component.current);
        }
    };
    (0, $eUqFw.useEffect)(()=>{
        onVisibilityChange(isIntersecting);
    }, [
        isIntersecting,
        onVisibilityChange
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setupObserver();
        const node = component.current;
        return ()=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            observer.current?.unobserve(node);
        };
    }, []);
    // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: component
    });
};
var $b3149ef8d4dc18dc$export$2e2bcd8739ae039 = $b3149ef8d4dc18dc$var$Intersection;

});

parcelRegister("eQohw", function(module, exports) {

$parcel$export(module.exports, "CheckboxWrapper", () => $b29b9c537b756d52$export$eef12940a6696c78);
$parcel$export(module.exports, "OptionDescriptionWrapper", () => $b29b9c537b756d52$export$d0efa178ba28855b);
$parcel$export(module.exports, "Description", () => $b29b9c537b756d52$export$393edc798c47379d);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $b29b9c537b756d52$export$7e45b7e9a9d29a91 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8kv7m",
            __cmplp.className
        ])
    });
});
const $b29b9c537b756d52$export$eef12940a6696c78 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1y6m _1yt41bcq _n7zlpe8f _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $b29b9c537b756d52$export$d0efa178ba28855b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _syaz1rc1 _1wyb1crf _19pk1b66",
            __cmplp.className
        ])
    });
});
const $b29b9c537b756d52$export$393edc798c47379d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _p12f1osq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("fHNT1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e537f9b5eaa0890e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k9Z3M = parcelRequire("k9Z3M");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ayA76 = parcelRequire("ayA76");

var $7nzO5 = parcelRequire("7nzO5");

var $kzIu1 = parcelRequire("kzIu1");

var $eQohw = parcelRequire("eQohw");
const $e537f9b5eaa0890e$var$renderOptionDescription = (option, doneEpicLabel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eQohw.OptionDescriptionWrapper), null, option.description != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eQohw.Description), null, option.description) : null, option.isDone === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
        primaryColor: `var(--ds-icon-success, ${(0, $PdmhA).G500})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, doneEpicLabel)) : null);
const $e537f9b5eaa0890e$var$CustomOption = ({ option: option })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7nzO5.OptionWrapper), null, option.elemBefore != null ? option.elemBefore : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ayA76.OptionTextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ayA76.OptionLabel), null, option.label), $e537f9b5eaa0890e$var$renderOptionDescription(option, formatMessage((0, $kzIu1.default).doneEpicLabel))));
};
var $e537f9b5eaa0890e$export$2e2bcd8739ae039 = $e537f9b5eaa0890e$var$CustomOption;

});
parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ead4032469749d51$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M7.356 10.942a.497.497 0 00-.713 0l-.7.701a.501.501 0 00-.003.71l3.706 3.707a.501.501 0 00.705.003l7.712-7.712a.493.493 0 00-.006-.708l-.7-.7a.504.504 0 00-.714 0l-6.286 6.286a.506.506 0 01-.713 0l-2.288-2.287z" fill="currentColor"/></svg>`
    }, props));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = $ead4032469749d51$var$EditorDoneIcon;
module.exports.default = $ead4032469749d51$var$_default;

});

parcelRegister("ayA76", function(module, exports) {

$parcel$export(module.exports, "RichOptionView", () => $1dc158f445bdb2eb$export$d9c388ae098d24cc);
$parcel$export(module.exports, "OptionTextContainer", () => $1dc158f445bdb2eb$export$c6c33847de6c74ef);
$parcel$export(module.exports, "OptionLabel", () => $1dc158f445bdb2eb$export$2cf7ef1e2dd6c6b1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7nzO5 = parcelRequire("7nzO5");
const $1dc158f445bdb2eb$export$d9c388ae098d24cc = ({ option: option })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7nzO5.OptionWrapper), null, option.elemBefore != null ? option.elemBefore : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1dc158f445bdb2eb$export$c6c33847de6c74ef, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1dc158f445bdb2eb$export$2cf7ef1e2dd6c6b1, null, option.label), option.description != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1dc158f445bdb2eb$var$OptionDescription, null, option.description) : null));
const $1dc158f445bdb2eb$export$c6c33847de6c74ef = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _18s8h8dc _1yt4x7n9 _1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $1dc158f445bdb2eb$export$2cf7ef1e2dd6c6b1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $1dc158f445bdb2eb$var$OptionDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _syaz1rc1 _1wyb1crf _19pk1b66",
            __cmplp.className
        ])
    });
});

});



parcelRegister("kjUsy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a9b668c81a99eb7$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $6a9b668c81a99eb7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.epic.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "Select Epic"
    },
    recent: {
        "id": "issue.epic.text-for-heading-in-recent-group",
        "defaultMessage": "Recent epics"
    },
    allEpics: {
        "id": "issue.epic.text-for-heading-in-all-epics-group",
        "defaultMessage": "All epics"
    }
});

});

parcelRegister("isr2y", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $94c3610520077076$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformCacheEntries", () => $94c3610520077076$export$64c1e7aa265973f8);
$parcel$export(module.exports, "transformToStateValue", () => $94c3610520077076$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformSuggestionsFromPublicAPIAndCache", () => $94c3610520077076$export$5dc79713d7032c85);

var $ck220 = parcelRequire("ck220");

var $tgbCK = parcelRequire("tgbCK");

var $8E9UG = parcelRequire("8E9UG");

var $kjUsy = parcelRequire("kjUsy");
const $94c3610520077076$var$getColor = (epic)=>{
    // @ts-expect-error - TS2339 - Property 'colorKey' does not exist on type 'EpicLink'.
    const colorKey = epic.color ? epic.color.key : (0, $tgbCK.MAP_CLASSIC_COLOR_TO_AGILE_COLOR)[epic.colorKey];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return colorKey ? (0, $tgbCK.MAP_AGILE_COLOR_TO_AK_COLOR)[colorKey] : null;
};
const $94c3610520077076$var$toItem = (epic, baseUrl)=>({
        content: epic.summary,
        value: epic.key,
        isDone: epic.done,
        color: $94c3610520077076$var$getColor(epic),
        href: `${baseUrl}/browse/${epic.key}`,
        fromCache: epic.fromCache
    });
const $94c3610520077076$export$cb172b2468ab5652 = (stateValue, { baseUrl: baseUrl })=>stateValue && $94c3610520077076$var$toItem(stateValue, baseUrl);
const $94c3610520077076$var$MAX_RESULTS = 5;
const $94c3610520077076$export$dc069111282472fb = (rest, cache)=>cache.map((item)=>{
        const duplicatedItem = rest.find((restItem)=>restItem.key === item.key);
        if (duplicatedItem) {
            (0, $ck220.default).update(item.key, duplicatedItem);
            return duplicatedItem;
        }
        return item;
    });
const $94c3610520077076$export$64c1e7aa265973f8 = (epics, excludeDone)=>epics.filter((item)=>!(excludeDone && item.done) && item.key && item.name && item.color && item.color.key).slice(-1 * $94c3610520077076$var$MAX_RESULTS).reverse();
const $94c3610520077076$var$getAtlasKitColor = (epic)=>{
    if (epic.issueColor) return (0, $tgbCK.MAP_COLOR_TO_AK_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[epic.issueColor.key]];
    // Return default color if we can't find the issue color
    const colors = Object.values((0, $tgbCK.MAP_AGILE_COLOR_TO_AK_COLOR));
    return colors[0];
};
const $94c3610520077076$export$9227063fc962e54 = (epic, fromCache = false)=>{
    const atlasKitColor = $94c3610520077076$var$getAtlasKitColor(epic);
    // Return default color if we can't find the issue color
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const defaultColour = Object.keys((0, $tgbCK.MAP_FROM_SERVER_COLOR))[0];
    const color = (0, $tgbCK.MAP_FROM_SERVER_COLOR)[epic.issueColor?.key || defaultColour];
    return {
        color: atlasKitColor,
        content: epic.summary,
        value: epic.key,
        id: epic.id,
        description: epic.key,
        elemBefore: (0, $8E9UG.getOptionColorElemPatch)(color),
        filterValues: [
            epic.summary,
            epic.key
        ],
        isDone: epic.done,
        fromCache: fromCache
    };
};
const $94c3610520077076$export$1cfcb95cb8fbddb3 = (value)=>{
    if (!value) return null;
    const colorKeys = Object.keys((0, $tgbCK.MAP_AGILE_COLOR_TO_AK_COLOR));
    const colorKey = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    colorKeys.find((key)=>(0, $tgbCK.MAP_AGILE_COLOR_TO_AK_COLOR)[key] === value.color) || colorKeys[0];
    return {
        name: value.content,
        summary: value.content,
        key: value.value,
        done: value.isDone,
        id: value.id,
        color: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            key: colorKey
        },
        fromCache: value.fromCache
    };
};
const $94c3610520077076$export$5dc79713d7032c85 = (response, cache, intl)=>{
    const epicLists = response?.values || [];
    const cacheLists = $94c3610520077076$export$dc069111282472fb(epicLists, cache);
    return [
        {
            heading: intl.formatMessage((0, $kjUsy.default).recent),
            items: cacheLists.map((item)=>$94c3610520077076$export$9227063fc962e54(item, true))
        },
        {
            heading: intl.formatMessage((0, $kjUsy.default).allEpics),
            items: epicLists.map((item)=>$94c3610520077076$export$9227063fc962e54(item, false))
        }
    ];
};

});


parcelRegister("7TbxN", function(module, exports) {

$parcel$export(module.exports, "default", () => $da98fcee13e336d6$export$2e2bcd8739ae039);

var $18KtE = parcelRequire("18KtE");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $7TScN = parcelRequire("7TScN");

var $fipdU = parcelRequire("fipdU");

var $cwolO = parcelRequire("cwolO");
var $da98fcee13e336d6$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $cwolO.transformFromStateValue,
        transformToStateValue: $cwolO.transformToStateValue,
        additionalProps: (state, intl)=>({
                fetchSuggestions: (0, $7TScN.fetchSuggestionsFactory)(),
                placeholder: intl.formatMessage((0, $fipdU.default).placeholder),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            })
    }))((0, $18KtE.default));

});
parcelRegister("fipdU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d212306d3913d82$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $9d212306d3913d82$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.multi-group-picker.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "Select groups"
    }
});

});

parcelRegister("cwolO", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $6b43c9499383f10a$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $6b43c9499383f10a$export$1cfcb95cb8fbddb3);

var $lszPP = parcelRequire("lszPP");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6b43c9499383f10a$var$toItems = (groups)=>groups.map((group)=>$lszPP.transformFromStateValue(group));
const $6b43c9499383f10a$export$cb172b2468ab5652 = (stateValues)=>{
    if (!stateValues) return [];
    return $6b43c9499383f10a$var$toItems(stateValues);
};
const $6b43c9499383f10a$export$1cfcb95cb8fbddb3 = (values)=>{
    if (!values) return [];
    return values.map((value)=>$lszPP.transformToStateValue(value));
};

});
parcelRegister("lszPP", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $e404d0d5fc76b699$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $e404d0d5fc76b699$export$1cfcb95cb8fbddb3);

var $7TScN = parcelRequire("7TScN");
const $e404d0d5fc76b699$export$cb172b2468ab5652 = (stateValue)=>stateValue && (0, $7TScN.toItem)(stateValue);
const $e404d0d5fc76b699$export$1cfcb95cb8fbddb3 = (value)=>value && {
        name: value.value
    };

});



parcelRegister("gPgMB", function(module, exports) {

$parcel$export(module.exports, "default", () => $41d2070df46b2339$export$2e2bcd8739ae039);

var $jxxzJ = parcelRequire("jxxzJ");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $fokFV = parcelRequire("fokFV");

var $7TScN = parcelRequire("7TScN");

var $9SyeP = parcelRequire("9SyeP");

var $lszPP = parcelRequire("lszPP");
var $41d2070df46b2339$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $lszPP.transformFromStateValue,
        transformToStateValue: $lszPP.transformToStateValue,
        additionalProps: (state, intl)=>({
                fetchSuggestions: (0, $7TScN.fetchSuggestionsFactory)(),
                placeholder: intl.formatMessage((0, $9SyeP.default).placeholder),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                allowEmptyValue: !(0, $fokFV.isFieldRequiredSelector)(ownPropsOnMount.fieldId)(state),
                hasAutocomplete: true,
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            })
    }))((0, $jxxzJ.default));

});
parcelRegister("9SyeP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5a0c18a8829f559$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $a5a0c18a8829f559$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.group-picker.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "Select group"
    }
});

});


parcelRegister("h0VIp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e42957cf1be6ad75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $hJ992 = parcelRequire("hJ992");

var $5G3JL = parcelRequire("5G3JL");

var $fCyzk = parcelRequire("fCyzk");

var $lqalZ = parcelRequire("lqalZ");

var $1GZlZ = parcelRequire("1GZlZ");

var $dmojD = parcelRequire("dmojD");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e42957cf1be6ad75$var$KbGlancePanelV2 = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("4IlCQ")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/knowledge-glance-v2/src/ui/kb-glance-panel/index.tsx"
});
const $e42957cf1be6ad75$var$KbGlancePanelContainer = (props)=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [contextPanel] = (0, $fCyzk.useIssueLayoutContextPanel)(issueKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "kb-glance-panel-v2",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e42957cf1be6ad75$var$KbGlancePanelV2, {
        ...props,
        isPanelOpen: contextPanel !== undefined
    }));
};
var $e42957cf1be6ad75$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        isEditorOpen: (0, $dmojD.isAddCommentEditorExpandedSelector)(state)
    }), {
    onShareAsComment: (0, $1GZlZ.shareAsComment)
}))($e42957cf1be6ad75$var$KbGlancePanelContainer);

});
parcelRegister("4IlCQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('aHb9q')
        ]);
        const value = parcelRequire('6Aqxj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("aHb9q")
    ]).then(()=>parcelRequire('6Aqxj'));
}

});


parcelRegister("5Jgk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f6a578cc879e73e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5G3JL = parcelRequire("5G3JL");

var $hHKWU = parcelRequire("hHKWU");

var $lqalZ = parcelRequire("lqalZ");

var $1GZlZ = parcelRequire("1GZlZ");

var $5JqpU = parcelRequire("5JqpU");

var $9F6MO = parcelRequire("9F6MO");

var $gGtKh = parcelRequire("gGtKh");

var $dUSCA = parcelRequire("dUSCA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0f6a578cc879e73e$var$KbGlanceV2 = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("2VdfE")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/knowledge-glance-v2/src/ui/kb-glance/index.tsx"
});
const $0f6a578cc879e73e$export$e26168bb841de6aa = ({ isVisible: isVisible = true, baseUrl: baseUrl, issueKey: issueKey, issueId: issueId, projectKey: projectKey, isAdmin: isAdmin, itemId: itemId, showPinButton: showPinButton, isLast: isLast, onShareAsComment: onShareAsComment })=>{
    if (isVisible) (0, $dUSCA.kbGlanceLoadExperience).start();
    return isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "kb-glance-v2",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0f6a578cc879e73e$var$KbGlanceV2, {
        baseUrl: baseUrl,
        issueKey: issueKey,
        issueId: issueId,
        projectKey: projectKey,
        onShareAsComment: onShareAsComment,
        isAdmin: isAdmin,
        itemId: itemId,
        showPinButton: showPinButton,
        isLast: isLast
    })) : null;
};
var $0f6a578cc879e73e$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state, ownPropsOnMount)=>({
        itemId: ownPropsOnMount.itemId,
        isLast: ownPropsOnMount.isLast,
        isVisible: (0, $9F6MO.canUseServiceDeskAgentFeaturesSelector)(state),
        baseUrl: (0, $5JqpU.baseUrlSelector)(state),
        issueKey: (0, $5JqpU.issueKeySelector)(state),
        locale: (0, $5JqpU.localeSelector)(state),
        // FIXME: JIV-17455 this field can be null
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        issueId: (0, $5JqpU.issueIdSelector)(state),
        projectKey: (0, $5JqpU.projectKeySelector)(state),
        isAdmin: (0, $5JqpU.siteAdminStatusSelector)(state) === 'admin',
        showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
    }), {
    onShareAsComment: (0, $1GZlZ.shareAsComment)
}))($0f6a578cc879e73e$export$e26168bb841de6aa);

});
parcelRegister("dUSCA", function(module, exports) {

$parcel$export(module.exports, "kbGlanceLoadExperience", () => $87c9383169917141$export$e118e57d9083be7d);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $87c9383169917141$export$e118e57d9083be7d = new (0, $kDfSL.UFOExperience)('jsm-kb-glance-load', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("2VdfE", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8GMby');
        const value = parcelRequire('8JsR1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8GMby").then(()=>parcelRequire('8JsR1'));
}

});


parcelRegister("jjGk4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c0595d07b35eb98$export$2e2bcd8739ae039);

var $jqvCZ = parcelRequire("jqvCZ");

var $795rA = parcelRequire("795rA");

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");

var $giAhk = parcelRequire("giAhk");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jMP2a = parcelRequire("jMP2a");

var $CmfBs = parcelRequire("CmfBs");

var $8JR0x = parcelRequire("8JR0x");

var $6xujD = parcelRequire("6xujD");

var $ddZ4y = parcelRequire("ddZ4y");

var $gzP87 = parcelRequire("gzP87");
const $3c0595d07b35eb98$var$labelsCache = (0, $795rA.getLabelsCache)();
const $3c0595d07b35eb98$var$saveField = (// @ts-expect-error - TS7031 - Binding element 'baseUrl' implicitly has an 'any' type. | TS7031 - Binding element 'issueKey' implicitly has an 'any' type. | TS7031 - Binding element 'fieldMetaKey' implicitly has an 'any' type. | TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'fieldEditSessionId' implicitly has an 'any' type.
{ baseUrl: baseUrl, issueKey: issueKey, fieldMetaKey: fieldMetaKey, value: value, fieldEditSessionId: fieldEditSessionId }, _, // @ts-expect-error - TS7006 - Parameter 'ownPropsOnMount' implicitly has an 'any' type.
ownPropsOnMount)=>{
    const url = fieldEditSessionId !== undefined ? `${baseUrl}/rest/api/2/issue/${issueKey}?fieldEditSessionId=${fieldEditSessionId}` : `${baseUrl}/rest/api/2/issue/${issueKey}`;
    // @ts-expect-error - TS7006 - Parameter 'current' implicitly has an 'any' type.
    value.forEach((current)=>{
        $3c0595d07b35eb98$var$labelsCache.get(current).then((cachedItem)=>{
            if (ownPropsOnMount.createAnalyticsEvent) (0, $jMP2a.fireOperationalAnalytics)(ownPropsOnMount.createAnalyticsEvent({}), 'labelPickerCache set', {
                isFromCache: Boolean(cachedItem?.label)
            });
            current && $3c0595d07b35eb98$var$labelsCache.set(`${current}`, (0, $6xujD.transformToCacheItem)(current));
        }).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-view.labels.cache.set', error.message);
        });
    });
    return (0, $lRmyA.performPutRequest)(url, {
        body: JSON.stringify({
            fields: {
                [fieldMetaKey]: value
            }
        })
    }).catch((error)=>{
        // @ts-expect-error - TS7006 - Parameter 'current' implicitly has an 'any' type.
        value.forEach((current)=>{
            // Logging only cache removals
            $3c0595d07b35eb98$var$labelsCache.get(current).then((cachedItem)=>{
                if (cachedItem?.label && ownPropsOnMount.createAnalyticsEvent) {
                    (0, $jMP2a.fireOperationalAnalytics)(ownPropsOnMount.createAnalyticsEvent({}), 'labelPickerCache removed');
                    cachedItem && $3c0595d07b35eb98$var$labelsCache.remove(`${cachedItem.label}`);
                }
            }).catch((e)=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-view.labels.cache.remove', e.message);
            });
        });
        throw error;
    });
};
const $3c0595d07b35eb98$export$259666bd743e3987 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((intl)=>(inputValue)=>`${inputValue} (${intl.formatMessage((0, $8JR0x.default).createNewItem)})`);
const $3c0595d07b35eb98$var$ConnectedLabelsField = (0, $giAhk.injectIntlV2)((0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>{
    // Added two flow fix  here after bending over backwards
    // NOTE -> The labels extracted version is coming soon, which will render the
    // connected components obsolete :) This will all be DELETED very very soon :)
    const formatCreateLabel = $3c0595d07b35eb98$export$259666bd743e3987(ownPropsOnMount.intl);
    const getDataFromCache = ()=>$3c0595d07b35eb98$var$labelsCache.getAll().then((labels)=>(0, $6xujD.transformSuggestionsFromServerAndCache)({}, labels, ownPropsOnMount.intl.formatMessage));
    const fieldAutoCompleteUrlSelectorGetter = (0, $fokFV.fieldAutoCompleteUrlSelector)(ownPropsOnMount.fieldId);
    const fieldEditSessionIdSelectorGetter = (0, $fokFV.fieldEditSessionIdSelector)(ownPropsOnMount.fieldId);
    return {
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $6xujD.transformFromStateValue,
        transformToStateValue: $6xujD.transformToStateValue,
        additionalProps: (state, intl)=>({
                fetchSuggestions: (0, $CmfBs.getMemoizedSuggestionsFactory)(fieldAutoCompleteUrlSelectorGetter(state), ownPropsOnMount.fieldId, fieldEditSessionIdSelectorGetter(state), ownPropsOnMount.createAnalyticsEvent, intl.formatMessage),
                formatMessage: intl.formatMessage,
                placeholder: intl.formatMessage((0, $8JR0x.default).placeholder),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                formatCreateLabel: formatCreateLabel,
                canCreateNewItem: true,
                allowEmptyValue: true,
                validate: $ddZ4y.validate,
                issueKey: (0, $5JqpU.issueKeySelector)(state),
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area),
                getDataFromCache: getDataFromCache
            }),
        // @ts-expect-error - TS2345 - Argument of type 'SaveFieldArguments<unknown>' is not assignable to parameter of type '{ baseUrl: any; issueKey: any; fieldMetaKey: any; value: any; fieldEditSessionId: any; }'.
        saveField: (...args)=>$3c0595d07b35eb98$var$saveField(...args, ownPropsOnMount)
    };
})((0, $gzP87.default)));
var $3c0595d07b35eb98$export$2e2bcd8739ae039 = $3c0595d07b35eb98$var$ConnectedLabelsField;

});

parcelRegister("joq2j", function(module, exports) {

$parcel$export(module.exports, "default", () => $636ee23ae03bb7f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hHKWU = parcelRequire("hHKWU");

var $cZZo6 = parcelRequire("cZZo6");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$636ee23ae03bb7f3$export$2e2bcd8739ae039 = ({ count: count, fieldId: fieldId, area: area })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cZZo6.AsyncLinkedAlertsField), {
        count: count,
        fieldId: fieldId,
        showPinButton: (0, $hHKWU.default)(area)
    });

});
parcelRegister("cZZo6", function(module, exports) {

$parcel$export(module.exports, "AsyncLinkedAlertsField", () => $bbff2024d86d3ee8$export$5dd38ea4ae79439a);
$parcel$export(module.exports, "AsyncLinkedAlertsViewModal", () => $bbff2024d86d3ee8$export$6d1be04a3fa81bb0);
$parcel$export(module.exports, "AsyncLinkedAlertsLinkModal", () => $bbff2024d86d3ee8$export$ec631909efc866);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

const $bbff2024d86d3ee8$var$LazyAsyncLinkedAlertsField = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("7ulM0")), {
    moduleId: "./src/packages/servicedesk/incident-management/issue-view/linked-alerts/src/ui/linked-alerts-field/index.tsx"
});
const $bbff2024d86d3ee8$export$5dd38ea4ae79439a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "jira-servicedesk.incident-management.linked-alerts-field.async",
        packageName: "AsyncLinkedAlertsField"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "servicedesk-incident-management-linked-alerts-field",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bbff2024d86d3ee8$var$LazyAsyncLinkedAlertsField, props)));

const $bbff2024d86d3ee8$var$LazyAsyncLinkedAlertsViewModal = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("bbMRx")), {
    moduleId: "./src/packages/servicedesk/incident-management/issue-view/linked-alerts/src/ui/view-modal/index.tsx"
});
const $bbff2024d86d3ee8$export$6d1be04a3fa81bb0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "jira-servicedesk.incident-management.linked-alerts-view-modal.async",
        packageName: "AsyncLinkedAlertsViewModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "servicedesk-incident-management-view-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bbff2024d86d3ee8$var$LazyAsyncLinkedAlertsViewModal, null)));

const $bbff2024d86d3ee8$var$LazyAsyncLinkedAlertsLinkModal = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("2f28W")), {
    moduleId: "./src/packages/servicedesk/incident-management/issue-view/linked-alerts/src/ui/link-modal/index.tsx"
});
const $bbff2024d86d3ee8$export$ec631909efc866 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "jira-servicedesk.incident-management.linked-alerts-link-modal.async",
        packageName: "AsyncLinkedAlertsLinkModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "servicedesk-incident-management-link-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bbff2024d86d3ee8$var$LazyAsyncLinkedAlertsLinkModal, null)));

});
parcelRegister("7ulM0", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fNgqb');
        const value = parcelRequire('7Y92Y');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fNgqb").then(()=>parcelRequire('7Y92Y'));
}

});

parcelRegister("bbMRx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('6ybzB')
        ]);
        const value = parcelRequire('ENPpD');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("6ybzB")
    ]).then(()=>parcelRequire('ENPpD'));
}

});

parcelRegister("2f28W", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('8i0II')
        ]);
        const value = parcelRequire('72qUp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("8i0II")
    ]).then(()=>parcelRequire('72qUp'));
}

});



parcelRegister("f27hK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d9fd53e106da4dc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $hHKWU = parcelRequire("hHKWU");

var $62b0N = parcelRequire("62b0N");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0d9fd53e106da4dc$export$2e2bcd8739ae039 = ({ fieldId: fieldId, area: area })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $62b0N.AsyncMajorIncidentField), {
        issueKey: issueKey,
        showPinButton: (0, $hHKWU.default)(area),
        fieldId: fieldId
    });
};

});
parcelRegister("62b0N", function(module, exports) {

$parcel$export(module.exports, "AsyncMajorIncidentField", () => $a5d5b32010ae62e9$export$b747935787b5491a);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $9IbuV = parcelRequire("9IbuV");

var $cYRAl = parcelRequire("cYRAl");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a5d5b32010ae62e9$var$LazyMajorIncidentField = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("lBcAh")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/incident-management/issue-view/major-incident/src/ui/index.tsx"
});
const $a5d5b32010ae62e9$export$b747935787b5491a = (props)=>{
    (0, $9IbuV.useUFOComponentExperience)((0, $cYRAl.jsmMajorIncidentExperience));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "servicedesk-incident-management-major-incident-field",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a5d5b32010ae62e9$var$LazyMajorIncidentField, props));
};

});
parcelRegister("cYRAl", function(module, exports) {

$parcel$export(module.exports, "jsmMajorIncidentExperience", () => $4902470c6229e5df$export$62078b21f7fe9b37);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $4902470c6229e5df$export$62078b21f7fe9b37 = new (0, $kDfSL.UFOExperience)('jsm-major-incident', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("lBcAh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('d9mFg');
        const value = parcelRequire('7EHju');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("d9mFg").then(()=>parcelRequire('7EHju'));
}

});



parcelRegister("hKCXf", function(module, exports) {

$parcel$export(module.exports, "StakeholdersGlanceComponent", () => $3015ef9ecb938b1d$export$f4f9ac546f0fd48f);

var $hHKWU = parcelRequire("hHKWU");

var $lqalZ = parcelRequire("lqalZ");

var $9F6MO = parcelRequire("9F6MO");

var $1EAis = parcelRequire("1EAis");
const $3015ef9ecb938b1d$export$f4f9ac546f0fd48f = (0, $lqalZ.connect)((state, ownPropsOnMount)=>({
        itemId: ownPropsOnMount.itemId,
        isVisible: (0, $9F6MO.canUseServiceDeskAgentFeaturesSelector)(state),
        showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
    }), {})((0, $1EAis.StakeholdersGlance));

});
parcelRegister("1EAis", function(module, exports) {

$parcel$export(module.exports, "StakeholdersGlance", () => $fc0d298b189acf06$export$f0789d7bc770a7f4);
$parcel$export(module.exports, "StakeholdersGlancePanel", () => $fc0d298b189acf06$export$f60053996f9c95bb);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $9IbuV = parcelRequire("9IbuV");

var $lMlPB = parcelRequire("lMlPB");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $fc0d298b189acf06$var$StakeholdersGlanceComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("bRDZi")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/incident-management/issue-view/stakeholder-updates/src/ui/glance/stakeholders-glance/index.tsx"
});
const $fc0d298b189acf06$export$f0789d7bc770a7f4 = (props)=>{
    (0, $9IbuV.useUFOComponentExperience)((0, $lMlPB.jsmStakeholderUpdatesExperience));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.stakeholders.glance",
        packageName: "atlassian/jira-jsm-stakeholder-updates"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "stakeholders-glance",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc0d298b189acf06$var$StakeholdersGlanceComponent, props)));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $fc0d298b189acf06$var$StakeholdersGlancePanelComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("j8VC5")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/incident-management/issue-view/stakeholder-updates/src/ui/glance/stakeholders-glance-panel/index.tsx"
});
const $fc0d298b189acf06$export$f60053996f9c95bb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.stakeholders.glance.panel",
        packageName: "atlassian/jira-jsm-stakeholder-updates"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "stakeholders-glance-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc0d298b189acf06$var$StakeholdersGlancePanelComponent, props)));

});
parcelRegister("lMlPB", function(module, exports) {

$parcel$export(module.exports, "jsmStakeholderUpdatesExperience", () => $43ecb9ef9fc164a2$export$fe38c870512d3a4d);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $43ecb9ef9fc164a2$export$fe38c870512d3a4d = new (0, $kDfSL.UFOExperience)('jsm-stakeholder-updates', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("bRDZi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('keg0V');
        const value = parcelRequire('hafpn');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("keg0V").then(()=>parcelRequire('hafpn'));
}

});

parcelRegister("j8VC5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('fTJ1T')
        ]);
        const value = parcelRequire('inVZT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("fTJ1T")
    ]).then(()=>parcelRequire('inVZT'));
}

});



parcelRegister("bB8lM", function(module, exports) {

$parcel$export(module.exports, "default", () => $694b81fecceea7c1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $0cdA8 = parcelRequire("0cdA8");

var $hJ992 = parcelRequire("hJ992");

var $9LvPd = parcelRequire("9LvPd");

var $64ypR = parcelRequire("64ypR");

var $4VwG6 = parcelRequire("4VwG6");

var $eqaG8 = parcelRequire("eqaG8");

var $4bZws = parcelRequire("4bZws");

var $73FRM = parcelRequire("73FRM");

var $hHKWU = parcelRequire("hHKWU");

var $iAc02 = parcelRequire("iAc02");

var $gGtKh = parcelRequire("gGtKh");
const $694b81fecceea7c1$var$View = ({ fieldId: fieldKey, area: area, label: label })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const showPinButton = (0, $hHKWU.default)(area);
    const [{ value: value, fieldConfig: fieldConfig }] = (0, $4VwG6.useMessageField)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const HeadingWrapper = area === (0, $73FRM.CONTENT) ? (0, $iAc02.SectionHeading) : (0, $64ypR.MultilineFieldHeading);
    const HeadingTitle = area === (0, $73FRM.CONTENT) ? (0, $iAc02.SectionHeadingTitle) : (0, $64ypR.MultilineFieldHeadingTitle);
    const fieldLabel = fieldConfig?.title || label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "MessageCustomField",
        packageName: "jiraIssueViewBase",
        fallback: "unmount",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $694b81fecceea7c1$var$fieldContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeadingTitle, null, fieldLabel), issueKey !== undefined && fieldKey !== undefined && // @ts-expect-error label is required, please pass it through when working on this code.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldKey
    }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldKey,
        label: fieldLabel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $694b81fecceea7c1$var$messageFieldWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-lazy-jira-issue-field-message-view",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eqaG8.AsyncMessageFieldView), {
        value: value
    })))));
};
var $694b81fecceea7c1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($694b81fecceea7c1$var$View);
const $694b81fecceea7c1$var$messageFieldWrapperStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.050'
});
const $694b81fecceea7c1$var$fieldContainerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.200'
});

});
parcelRegister("4VwG6", function(module, exports) {

$parcel$export(module.exports, "useMessageField", () => $1c88fb61519d29a4$export$f53ab423bded0c99);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $1c88fb61519d29a4$export$f53ab423bded0c99 = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'string');
    const [{ value: value, error: error }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        }
    ];
};

});

parcelRegister("eqaG8", function(module, exports) {

$parcel$export(module.exports, "AsyncMessageFieldView", () => $2e933626d28ab080$export$a91f58240347e94e);

var $7rh0R = parcelRequire("7rh0R");

const $2e933626d28ab080$export$a91f58240347e94e = (0, $7rh0R.lazy)(()=>(parcelRequire("1IJYz")).then((module)=>module.MessageFieldView), {
    moduleId: "./src/packages/issue/fields/message-custom-field/src/index.tsx"
});

});
parcelRegister("1IJYz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9itAR');
        const value = parcelRequire('1UHZ2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9itAR").then(()=>parcelRequire('1UHZ2'));
}

});



parcelRegister("lt9b8", function(module, exports) {

$parcel$export(module.exports, "default", () => $48af727f273bc756$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hHKWU = parcelRequire("hHKWU");

var $gktFk = parcelRequire("gktFk");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48af727f273bc756$export$2e2bcd8739ae039 = ({ area: area, fieldId: fieldId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gktFk.AsyncMsTeamsConversationField), {
        showPinButton: (0, $hHKWU.default)(area),
        fieldId: fieldId
    });

});
parcelRegister("gktFk", function(module, exports) {

$parcel$export(module.exports, "AsyncMsTeamsConversationField", () => $13d5e4c2b2f567ce$export$b01242709f6bae2b);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $13d5e4c2b2f567ce$var$LazyMsTeamsConversation = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8T3J2")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/incident-management/issue-view/msteams-channel/src/ui/index.tsx"
});
const $13d5e4c2b2f567ce$export$b01242709f6bae2b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "servicedesk-incident-management-msteams-conversation",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($13d5e4c2b2f567ce$var$LazyMsTeamsConversation, props));

});
parcelRegister("8T3J2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('67NaU');
        const value = parcelRequire('aA0gv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("67NaU").then(()=>parcelRequire('aA0gv'));
}

});



parcelRegister("2iQQa", function(module, exports) {

$parcel$export(module.exports, "default", () => $df2c24bb2239cb5c$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $5iWql = parcelRequire("5iWql");

var $18KtE = parcelRequire("18KtE");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $4kDvN = parcelRequire("4kDvN");

var $fokFV = parcelRequire("fokFV");

var $8WZQM = parcelRequire("8WZQM");

var $etCF7 = parcelRequire("etCF7");

var $18PEg = parcelRequire("18PEg");
const $df2c24bb2239cb5c$var$fetchSuggestionsFactoryV2 = (0, $5iWql.default)((suggestions, allowedValuesOverrides)=>()=>Promise.resolve((0, $8WZQM.filterAllowedValues)(suggestions, allowedValuesOverrides)).then((0, $18PEg.transformSuggestions)));
const $df2c24bb2239cb5c$var$MultiSelect = (0, $huRi7.compose)((0, $4kDvN.withExtraOwnProps), (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>{
    const fieldAllowedValuesSelectorGetter = (0, $fokFV.fieldAllowedValuesSelector)(ownPropsOnMount.fieldId);
    return {
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $18PEg.transformFromStateValue,
        transformToStateValue: $18PEg.transformToStateValue,
        additionalProps: (state, intl, fieldOptions, extraOwnProps)=>({
                fetchSuggestions: $df2c24bb2239cb5c$var$fetchSuggestionsFactoryV2(fieldAllowedValuesSelectorGetter(state), extraOwnProps?.allowedValuesOverrides),
                placeholder: intl.formatMessage((0, $etCF7.default).placeholder, {
                    fieldName: (0, $fokFV.fieldNameSelector)(ownPropsOnMount.fieldId)(state)
                }),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            })
    };
}))((0, $18KtE.default));
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
$df2c24bb2239cb5c$export$2e2bcd8739ae039 = $df2c24bb2239cb5c$var$MultiSelect;

});
parcelRegister("etCF7", function(module, exports) {

$parcel$export(module.exports, "default", () => $cff1d49ce271a4b1$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $cff1d49ce271a4b1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.multi-select.text-for-dropdown-when-nothing-selected",
        "defaultMessage": "Select {fieldName}"
    }
});

});

parcelRegister("18PEg", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $7e80cae97114cb8d$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $7e80cae97114cb8d$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformSuggestions", () => $7e80cae97114cb8d$export$1d0ee4320c26fb60);
const $7e80cae97114cb8d$var$toItem = (fieldData)=>({
        value: fieldData.id,
        content: fieldData.value
    });
const $7e80cae97114cb8d$export$cb172b2468ab5652 = (value)=>value ? value.map($7e80cae97114cb8d$var$toItem) : [];
const $7e80cae97114cb8d$export$1cfcb95cb8fbddb3 = (value)=>value && value.map((item)=>({
            id: item.value,
            value: item.content
        }));
const $7e80cae97114cb8d$export$1d0ee4320c26fb60 = (suggestions)=>suggestions && [
        {
            items: suggestions.map($7e80cae97114cb8d$var$toItem)
        }
    ] || [];

});


parcelRegister("2hl6U", function(module, exports) {

$parcel$export(module.exports, "MultiSelectFieldWithRelayEditView", () => $4f3db9905c618467$export$d989ddafa4938753);

var $cNUSG = parcelRequire("cNUSG");

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");

var $5iWql = parcelRequire("5iWql");

var $7jPhn = parcelRequire("7jPhn");

var $1zbEq = parcelRequire("1zbEq");

var $1ybV0 = parcelRequire("1ybV0");

var $4Hwcq = parcelRequire("4Hwcq");

var $6zwEK = parcelRequire("6zwEK");

var $hW84d = parcelRequire("hW84d");

var $18KtE = parcelRequire("18KtE");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $4kDvN = parcelRequire("4kDvN");

var $fokFV = parcelRequire("fokFV");

var $jioZP = parcelRequire("jioZP");
const $4f3db9905c618467$export$7021083b97636719 = (0, $5iWql.default)((ari)=>({ onChange: onChange, value: value, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, invalidMessage: invalidMessage, label: label, isInvalid: isInvalid, optionsFilter: optionsFilter })=>{
        const handleChange = (values, actionMeta)=>{
            const legacyValues = values?.map((0, $jioZP.transformRelayToReduxValue)) ?? [];
            const legacyActionMeta = {
                action: actionMeta.action,
                ...actionMeta.option ? {
                    option: (0, $jioZP.transformRelayToReduxValue)(actionMeta.option)
                } : null,
                ...actionMeta.removedValue ? {
                    removedValue: (0, $jioZP.transformRelayToReduxValue)(actionMeta.removedValue)
                } : null
            };
            onChange?.(legacyValues, legacyActionMeta);
        };
        const selectedOptions = (0, $eUqFw.useMemo)(()=>value.map((0, $jioZP.transformReduxToRelayValue)), [
            value
        ]);
        const editViewNoOptionsMessage = (0, $eUqFw.useMemo)(()=>{
            if (noOptionsMessage) return (inputValue)=>noOptionsMessage(inputValue);
        }, [
            noOptionsMessage
        ]);
        const editViewLoadingMessage = (0, $eUqFw.useMemo)(()=>{
            if (loadingMessage) return (inputValue)=>loadingMessage(inputValue);
        }, [
            loadingMessage
        ]);
        const getCustomSelectableMessages = (0, $eUqFw.useMemo)(()=>{
            if ((0, $1ybV0.ff)('issue.details.follow-up-relay-multi-select-field-issue-view-integration')) return {
                noOptionsMessage: noOptionsMessage,
                loadingMessage: loadingMessage
            };
            return {};
        }, [
            noOptionsMessage,
            loadingMessage
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.075"
        }, Boolean(invalidMessage) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, invalidMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zwEK.MultiSelectEditView), {
            autoFocus: true,
            filterOptionsById: optionsFilter,
            fieldName: label,
            fieldId: ari || '',
            value: selectedOptions,
            onChange: handleChange,
            noOptionsMessage: editViewNoOptionsMessage,
            loadingMessage: editViewLoadingMessage,
            isInvalid: isInvalid,
            ...getCustomSelectableMessages,
            isMulti: true,
            spacing: (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i') ? 'compact' : 'default'
        }));
    });
const $4f3db9905c618467$export$65e53bb5f4a801b6 = (props)=>{
    // Temporary FF to disable prefetching for select customers that experience issue like https://getsupport.atlassian.com/browse/PCS-277464
    // Proper solution will be done under https://jplat.jira.atlassian.cloud/browse/JIV-18302
    if ((0, $1ybV0.ff)('issue-view-disable-fields-prefetch') === false) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hW84d.useLazyLoadQueryAfterPageLoad)((0, $cNUSG.default), {
        id: props.ari,
        first: (0, $4Hwcq.PREFETCH_OPTIONS_COUNT),
        isSelectableField: (0, $1ybV0.ff)('issue.details.follow-up-relay-multi-select-field-issue-view-integration')
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $18KtE.default), props);
};
const $4f3db9905c618467$export$d989ddafa4938753 = (0, $huRi7.compose)((0, $4kDvN.withExtraOwnProps), (0, $3uwfp.default)((_, ownPropsOnMount)=>{
    const fieldARISelectorGetter = (0, $fokFV.fieldARISelector)(ownPropsOnMount.fieldId);
    return {
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $jioZP.transformFromStateValue,
        transformToStateValue: $jioZP.transformToStateValue,
        additionalProps: (state, intl)=>({
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area),
                customEditView: $4f3db9905c618467$export$7021083b97636719(fieldARISelectorGetter(state)),
                ari: fieldARISelectorGetter(state)
            })
    };
}))($4f3db9905c618467$export$65e53bb5f4a801b6);

});
parcelRegister("cNUSG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b1d12d939c8fc23$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<716b8ebcbde491b59b31e2c4eba8a4a3>>
 * @relayHash efb61ffbceedd384139bac603a332ca5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 746679e02f2d43ad1d6a3c7a0bcc8232b2c1e257737124123e8a9beb06e6d762
const $9b1d12d939c8fc23$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSelectableField"
    }, v3 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v4 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v5 = {
        "kind": "Literal",
        "name": "searchBy",
        "value": ""
    }, v6 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ 
    ], v7 = [
        v4 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = [
        v3 /*: any*/ ,
        v5 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "isDisabled"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v14 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v15 = [
        "searchBy",
        "filterById"
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "multiSelectWithRelayEditViewFieldOptionsPrefetchQuery",
            "selections": [
                {
                    "condition": "isSelectableField",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "multiSelect_issueFieldMultiSelectEditviewFull_MultiSelectEditViewWithFieldOptionsFragment"
                        }
                    ]
                },
                {
                    "condition": "isSelectableField",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "ui_issueSelectableFieldEditView_SelectableFieldEditViewWithFieldOptionsFragment"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "multiSelectWithRelayEditViewFieldOptionsPrefetchQuery",
            "selections": [
                {
                    "condition": "isSelectableField",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v9 /*: any*/ ,
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldOptions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": "value",
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                },
                                                                {
                                                                    "alias": "label",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                v10 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        v13 /*: any*/ 
                                                    ]
                                                },
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v9 /*: any*/ ,
                                            "filters": v15 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "multiSelect_issueFieldMultiSelectEditviewFull_fieldOptions",
                                            "kind": "LinkedHandle",
                                            "name": "fieldOptions"
                                        }
                                    ],
                                    "type": "JiraMultipleSelectField"
                                },
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isSelectableField",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        }
                                    ],
                                    "type": "JiraIssueField",
                                    "abstractKey": "__isJiraIssueField"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v9 /*: any*/ ,
                                            "concreteType": "JiraSelectableValueConnection",
                                            "kind": "LinkedField",
                                            "name": "selectableValueOptions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSelectableValueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "selectableLabel"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "selectableGroupKey"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "selectableIconUrl"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        v10 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraOption"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "versionId"
                                                                        }
                                                                    ],
                                                                    "type": "JiraVersion"
                                                                }
                                                            ]
                                                        },
                                                        v13 /*: any*/ 
                                                    ]
                                                },
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v9 /*: any*/ ,
                                            "filters": v15 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "selectableValue_issueFieldEditviewFull_fieldOptions__selectableValueOptions",
                                            "kind": "LinkedHandle",
                                            "name": "selectableValueOptions"
                                        }
                                    ],
                                    "type": "JiraHasSelectableValueOptions",
                                    "abstractKey": "__isJiraHasSelectableValueOptions"
                                },
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "746679e02f2d43ad1d6a3c7a0bcc8232b2c1e257737124123e8a9beb06e6d762",
            "metadata": {},
            "name": "multiSelectWithRelayEditViewFieldOptionsPrefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9b1d12d939c8fc23$var$node.hash = "b1aa220871b9e277aa6c9ec97f255935";
var $9b1d12d939c8fc23$export$2e2bcd8739ae039 = $9b1d12d939c8fc23$var$node;

});

parcelRegister("4Hwcq", function(module, exports) {

$parcel$export(module.exports, "FRAGMENT_FIELD_OPTIONS_FIRST", () => $925d304e66e922f5$export$971747fe11f2a6f4);
$parcel$export(module.exports, "FRAGMENT_SELECTABLE_FIELD_OPTIONS_FIRST", () => $925d304e66e922f5$export$1a6463c5895cff9e);
$parcel$export(module.exports, "SELECTABLE_FIELD_PAGE_OPTIONS", () => $925d304e66e922f5$export$d1beabd8dceb4469);
$parcel$export(module.exports, "SEARCH_DEBOUNCE_TIMEOUT", () => $925d304e66e922f5$export$228cc37ca8dce73);
$parcel$export(module.exports, "PREFETCH_OPTIONS_COUNT", () => $925d304e66e922f5$export$f76df03b68138e45);
$parcel$export(module.exports, "versionStatus", () => $925d304e66e922f5$export$7fc41a408a0533d3);
/**
 * This will be used to set the default value for the number of options
 * to be fetched in the first request for the field options.
 */ const $925d304e66e922f5$export$971747fe11f2a6f4 = 100;
const $925d304e66e922f5$export$1a6463c5895cff9e = 50;
const $925d304e66e922f5$export$d1beabd8dceb4469 = 50;
const $925d304e66e922f5$export$228cc37ca8dce73 = 300;
const $925d304e66e922f5$export$f76df03b68138e45 = 20;
const $925d304e66e922f5$export$b983f2cb1f658a55 = 'RELEASED';
const $925d304e66e922f5$export$cb459d726a8530a5 = 'UNRELEASED';
const $925d304e66e922f5$export$c936349447a77fe0 = 'ARCHIVED';
const $925d304e66e922f5$export$7fc41a408a0533d3 = {
    RELEASED: $925d304e66e922f5$export$b983f2cb1f658a55,
    UNRELEASED: $925d304e66e922f5$export$cb459d726a8530a5,
    ARCHIVED: $925d304e66e922f5$export$c936349447a77fe0
};

});

parcelRegister("6zwEK", function(module, exports) {

$parcel$export(module.exports, "MultiSelectEditViewDeprecated", () => $83716484cc393aca$export$9e146201a297da1);
$parcel$export(module.exports, "MultiSelectEditView", () => $83716484cc393aca$export$d9a16e93c876151);

var $lNkYw = parcelRequire("lNkYw");

var $dc5YE = parcelRequire("dc5YE");

var $22Obm = parcelRequire("22Obm");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $4zgIJ = parcelRequire("4zgIJ");

var $bAQOb = parcelRequire("bAQOb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4Hwcq = parcelRequire("4Hwcq");

var $4NcaX = parcelRequire("4NcaX");
var $g6sIQ = parcelRequire("g6sIQ");

var $4bMJ9 = parcelRequire("4bMJ9");

var $3OCmX = parcelRequire("3OCmX");

var $2jdHI = parcelRequire("2jdHI");

var $hhQTE = parcelRequire("hhQTE");

var $dezip = parcelRequire("dezip");
const $83716484cc393aca$export$d9ad18d331070695 = ({ autoFocus: autoFocus = false, fieldId: fieldId, fieldOptionsFragmentRef: fieldOptionsFragmentRef, onChange: onChange, value: value, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, fieldName: fieldName, isInvalid: isInvalid = false, isDisabled: isDisabled = false, filterOptionsById: filterOptionsById = null, inputId: inputId, spacing: spacing = 'default' })=>{
    const [menuIsOpen, setMenuIsOpen] = (0, $eUqFw.useState)(autoFocus);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getNoOptionsMessage = (0, $eUqFw.useMemo)(()=>{
        if (noOptionsMessage) return ({ inputValue: inputValue })=>noOptionsMessage(inputValue);
        return ()=>formatMessage((0, $dezip.default).empty);
    }, [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $eUqFw.useMemo)(()=>{
        if (loadingMessage) return ({ inputValue: inputValue })=>loadingMessage(inputValue);
        return ()=>formatMessage((0, $dezip.default).loading);
    }, [
        formatMessage,
        loadingMessage
    ]);
    // #region Relay
    // suggestions fragment with pagination and refetch
    const { data: fieldOptionsSearchData, refetch: refetchSuggestions } = (0, $iWLL0.usePaginationFragment)((0, $22Obm.default), fieldOptionsFragmentRef);
    const { edges: fieldOptionsData } = fieldOptionsSearchData.node?.fieldOptions || {};
    // #endregion
    // #region Common state (might be handy for other components)
    const [searchByString, setSearchByString] = (0, $eUqFw.useState)('');
    // #endregion
    // #region Debounced suspensless refetch helpers
    const [searchSuspenselessRefetch, isLoading, lastFetchError] = (0, $4bMJ9.useSuspenselessRefetch)((0, $hhQTE.default), refetchSuggestions);
    const [searchDebouncedSuspenselessRefetch] = (0, $2jdHI.default)(searchSuspenselessRefetch, (0, $4Hwcq.SEARCH_DEBOUNCE_TIMEOUT));
    const [leadingSearchDebouncedSuspenselessRefetch] = (0, $2jdHI.default)(searchSuspenselessRefetch, (0, $4Hwcq.SEARCH_DEBOUNCE_TIMEOUT), {
        leading: true
    });
    // #region Common callbacks for the selector
    const onSelectFocus = (0, $eUqFw.useCallback)((_e)=>{
        setMenuIsOpen(true);
        leadingSearchDebouncedSuspenselessRefetch({
            id: fieldId,
            searchBy: searchByString,
            filterById: filterOptionsById,
            first: (0, $4Hwcq.FRAGMENT_SELECTABLE_FIELD_OPTIONS_FIRST)
        });
    }, [
        leadingSearchDebouncedSuspenselessRefetch,
        fieldId,
        searchByString,
        filterOptionsById
    ]);
    const onSelectBlur = (0, $eUqFw.useCallback)((_e)=>{
        setMenuIsOpen(false);
    }, []);
    const onSearchByStringChangeFunction = (0, $eUqFw.useCallback)((newSearchByString)=>{
        setSearchByString(newSearchByString);
        searchDebouncedSuspenselessRefetch({
            id: fieldId,
            searchBy: newSearchByString || '',
            filterById: filterOptionsById,
            first: (0, $4Hwcq.FRAGMENT_SELECTABLE_FIELD_OPTIONS_FIRST)
        });
    }, [
        fieldId,
        searchDebouncedSuspenselessRefetch,
        filterOptionsById
    ]);
    // #endregion
    const defaultFailedOption = (0, $eUqFw.useMemo)(()=>({
            label: formatMessage((0, $dezip.default).failedFetch),
            value: '',
            isDisabled: true,
            optionId: ''
        }), [
        formatMessage
    ]);
    // #region Transform options data from relay to AK Select
    const selectFieldOptions = (0, $eUqFw.useMemo)(()=>{
        // checks for query errors
        if (lastFetchError != null) return [
            defaultFailedOption
        ];
        return fieldOptionsData?.map((edge)=>edge?.node).filter(Boolean).map(({ label: label, value: optionValue, optionId: optionId, isDisabled: isOptionDisabled })=>({
                label: label ?? '',
                value: optionValue,
                optionId: optionId,
                isDisabled: isOptionDisabled
            })) ?? [];
    }, [
        lastFetchError,
        fieldOptionsData,
        defaultFailedOption
    ]);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), {
        isMulti: true,
        autoFocus: autoFocus,
        menuIsOpen: menuIsOpen,
        fieldId: fieldId,
        options: selectFieldOptions,
        value: value,
        onBlur: onSelectBlur,
        onFocus: onSelectFocus,
        noOptionsMessage: getNoOptionsMessage,
        loadingMessage: getLoadingMessage,
        onInputChange: onSearchByStringChangeFunction,
        onChange: onChange,
        isLoading: menuIsOpen && isLoading,
        // @ts-expect-error: Type '<TInternalOption extends InternalOptionShape>(option: TInternalOption, inputValue: string) => boolean' is not assignable to type '(option: FilterOptionOption<Option>, inputValue: string) => boolean'
        filterOption: (0, $g6sIQ.filterOptionByLabelAndFilterValues),
        placeholder: formatMessage((0, $dezip.default).placeholder, {
            fieldName: fieldName
        }),
        inputId: inputId,
        isInvalid: isInvalid,
        isDisabled: isDisabled,
        menuPosition: "fixed",
        styles: (0, $4NcaX.defaultSelectStyles),
        spacing: spacing
    });
};
const $83716484cc393aca$export$9e146201a297da1 = (props)=>{
    const suggestionsData = (0, $iWLL0.useLazyLoadQuery)((0, $dc5YE.default), {
        id: props.fieldId
    }, {
        fetchPolicy: 'store-only'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($83716484cc393aca$export$d9ad18d331070695, {
        ...props,
        fieldOptionsFragmentRef: suggestionsData
    });
};
const $83716484cc393aca$var$MultiSelectableFieldEditView = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const suggestionsData = (0, $iWLL0.useLazyLoadQuery)((0, $lNkYw.default), {
        id: props.fieldId
    }, {
        fetchPolicy: 'store-only'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3OCmX.SelectableFieldEditViewWithFieldOptionsFragment), {
        ...props,
        isMulti: true,
        placeholder: props.fieldName ? formatMessage((0, $dezip.default).placeholder, {
            fieldName: props.fieldName
        }) : undefined,
        fieldOptionsFragmentRef: suggestionsData
    });
};
const $83716484cc393aca$export$d9a16e93c876151 = (0, $bAQOb.componentWithFF)('issue.details.follow-up-relay-multi-select-field-issue-view-integration', $83716484cc393aca$var$MultiSelectableFieldEditView, $83716484cc393aca$export$9e146201a297da1);

});
parcelRegister("lNkYw", function(module, exports) {

$parcel$export(module.exports, "default", () => $99636dc3dc22c574$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fd456d65dc068c55be59e25386c984a3>>
 * @relayHash 65e6946219813a81ef3df056e7862093
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f35cf9aad9f8ef24ee68589034585b80577387d68cbdf67f01493b4cd9aefea7
const $99636dc3dc22c574$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiSelect_issueSelectableFieldQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "ui_issueSelectableFieldEditView_SelectableFieldEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiSelect_issueSelectableFieldQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                }
                            ],
                            "type": "JiraIssueField",
                            "abstractKey": "__isJiraIssueField"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraSelectableValueConnection",
                                    "kind": "LinkedField",
                                    "name": "selectableValueOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSelectableValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableLabel"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableGroupKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableIconUrl"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDisabled"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "optionId"
                                                                }
                                                            ],
                                                            "type": "JiraOption"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "versionId"
                                                                }
                                                            ],
                                                            "type": "JiraVersion"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "selectableValueOptions(first:20,searchBy:\"\")"
                                },
                                {
                                    "args": v3 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "selectableValue_issueFieldEditviewFull_fieldOptions__selectableValueOptions",
                                    "kind": "LinkedHandle",
                                    "name": "selectableValueOptions"
                                }
                            ],
                            "type": "JiraHasSelectableValueOptions",
                            "abstractKey": "__isJiraHasSelectableValueOptions"
                        },
                        v4 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "f35cf9aad9f8ef24ee68589034585b80577387d68cbdf67f01493b4cd9aefea7",
            "metadata": {},
            "name": "multiSelect_issueSelectableFieldQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$99636dc3dc22c574$var$node.hash = "ce6badc1402bb3f94df7ed7da90986be";
var $99636dc3dc22c574$export$2e2bcd8739ae039 = $99636dc3dc22c574$var$node;

});

parcelRegister("dc5YE", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaaa0114b87e6c34$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<80616067a462a246378e523f5bb9b662>>
 * @relayHash ac4264e98da7328c5646fb6e0b53a255
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b74c7abaad1a0507eb3d9c80c537b2b734da6f17163f614e999f9f48e57d468c
const $aaaa0114b87e6c34$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v2 = {
        "kind": "Literal",
        "name": "searchBy",
        "value": ""
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        v2 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiSelect_multiSelectSearchQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "multiSelect_issueFieldMultiSelectEditviewFull_MultiSelectEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiSelect_multiSelectSearchQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "optionId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isDisabled"
                                                        },
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "fieldOptions(first:50,searchBy:\"\")"
                                },
                                {
                                    "args": v4 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "multiSelect_issueFieldMultiSelectEditviewFull_fieldOptions",
                                    "kind": "LinkedHandle",
                                    "name": "fieldOptions"
                                }
                            ],
                            "type": "JiraMultipleSelectField"
                        },
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "b74c7abaad1a0507eb3d9c80c537b2b734da6f17163f614e999f9f48e57d468c",
            "metadata": {},
            "name": "multiSelect_multiSelectSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$aaaa0114b87e6c34$var$node.hash = "170b625685e90c09b57edc6e6886d85c";
var $aaaa0114b87e6c34$export$2e2bcd8739ae039 = $aaaa0114b87e6c34$var$node;

});

parcelRegister("22Obm", function(module, exports) {

$parcel$export(module.exports, "default", () => $510082257b6e6319$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c4257dc7989a8dace4c270f9ec8afd9a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $hhQTE = parcelRequire("hhQTE");
const $510082257b6e6319$var$node = function() {
    var v0 = [
        "node",
        "fieldOptions"
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filterById"
            },
            {
                "defaultValue": 50,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "id"
            },
            {
                "defaultValue": "",
                "kind": "LocalArgument",
                "name": "searchBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $hhQTE.default)
            }
        },
        "name": "multiSelect_issueFieldMultiSelectEditviewFull_MultiSelectEditViewWithFieldOptionsFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "id"
                    }
                ],
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": "fieldOptions",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "filterById",
                                        "variableName": "filterById"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "searchBy",
                                        "variableName": "searchBy"
                                    }
                                ],
                                "concreteType": "JiraOptionConnection",
                                "kind": "LinkedField",
                                "name": "__multiSelect_issueFieldMultiSelectEditviewFull_fieldOptions_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraOptionEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": "value",
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    },
                                                    {
                                                        "alias": "label",
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "optionId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isDisabled"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraMultipleSelectField"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$510082257b6e6319$var$node.hash = "a3ae907dbf5796c4114f4ff7702c4077";
var $510082257b6e6319$export$2e2bcd8739ae039 = $510082257b6e6319$var$node;

});
parcelRegister("hhQTE", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab6593ff75cf159$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7368bfc9f23fb4db9cc79976aac01cb4>>
 * @relayHash 270bd11601261b685e3bec9d2b0692b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cc585c35974f739f8f835f565eaf6102e5a2a0a0045b8aa256cc6079d344f38c
const $aab6593ff75cf159$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        },
        {
            "defaultValue": 50,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "searchBy"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v2 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v3 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v4 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v5 = {
        "kind": "Variable",
        "name": "searchBy",
        "variableName": "searchBy"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiSelect_multiSelectSearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "multiSelect_issueFieldMultiSelectEditviewFull_MultiSelectEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiSelect_multiSelectSearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v4 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "optionId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isDisabled"
                                                        },
                                                        v8 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "multiSelect_issueFieldMultiSelectEditviewFull_fieldOptions",
                                    "kind": "LinkedHandle",
                                    "name": "fieldOptions"
                                }
                            ],
                            "type": "JiraMultipleSelectField"
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "cc585c35974f739f8f835f565eaf6102e5a2a0a0045b8aa256cc6079d344f38c",
            "metadata": {},
            "name": "multiSelect_multiSelectSearchRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$aab6593ff75cf159$var$node.hash = "a3ae907dbf5796c4114f4ff7702c4077";
var $aab6593ff75cf159$export$2e2bcd8739ae039 = $aab6593ff75cf159$var$node;

});


parcelRegister("g6sIQ", function(module, exports) {

$parcel$export(module.exports, "filterOptionByLabelAndFilterValues", () => $2dc2777cac843338$export$58bb91b619b113f6);

var $5iWql = parcelRequire("5iWql");

var $cEc3i = parcelRequire("cEc3i");
const $2dc2777cac843338$export$d3e698d53f63efcd = (val, inputValueIgnoredCase)=>// label can be Object for new option in CreatableSelect
    typeof val === 'string' && val// no need to .trim() since input is already trimmed and we search for .includes() so it does not matter if field has leading or trailing spaces
    .toLowerCase().includes(inputValueIgnoredCase);
const $2dc2777cac843338$var$stringifyLabelAndDataFilterValues = (option)=>{
    const { label: label, data: data } = option || {};
    const { filterValues: filterValues } = data || {};
    const labelString = typeof label === 'string' ? label : '';
    const filterValuesString = (filterValues || []).join(' ');
    return `${labelString} ${filterValuesString}`;
};
/**
 * By default react-select matches by both option.label and option.value: https://github.com/JedWatson/react-select/blob/b7868d23ccd0b9e623b277f971e89020d426fbdb/packages/react-select/src/filters.js#L14.
 * This leads to undesired UX, when filter result includes options without displayed text including the query (which is very confusing for the user): BENTO-5735, BENTO-5655.
 * That's why we need this function.
 */ const $2dc2777cac843338$var$filterOptionByLabelAndFilterValuesInternal = (0, $5iWql.default)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $cEc3i.c)({
        // Take an option object and convert it to a string that needs to partially match the user's query
        stringify: $2dc2777cac843338$var$stringifyLabelAndDataFilterValues
    }));
const $2dc2777cac843338$export$58bb91b619b113f6 = (option, inputValue)=>$2dc2777cac843338$var$filterOptionByLabelAndFilterValuesInternal()(option, inputValue);

});

parcelRegister("4bMJ9", function(module, exports) {

$parcel$export(module.exports, "useSuspenselessRefetch", () => $93417f2cf15e39ef$export$c7ce5f64dc007896);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $3koWU = parcelRequire("3koWU");
const $93417f2cf15e39ef$var$useInFlightRequests = ({ setIsLoading: setIsLoading })=>{
    const inFlightRequestsRef = (0, $eUqFw.useRef)([]);
    return (0, $eUqFw.useMemo)(()=>({
            onNewRequest: (request)=>{
                inFlightRequestsRef.current.push(request);
            },
            onRequestFinish: (request, /**
				 * Called only if the request hasn't been superceded by a more recent request's success / failure
				 */ onIfRequestIsRelevant)=>{
                // find the first occurrence of this request
                const inFlightRequestIndex = inFlightRequestsRef.current.indexOf(request);
                // If the current request is still considered "in flight"
                if (inFlightRequestIndex !== -1) {
                    onIfRequestIsRelevant?.();
                    // Cut out the current and all proceeding requests from the in-flight queue
                    inFlightRequestsRef.current = inFlightRequestsRef.current.slice(inFlightRequestIndex + 1);
                    // Update isLoading to reflect the current number of in-flight requests
                    setIsLoading?.(!!inFlightRequestsRef.current.length);
                }
            }
        }), [
        setIsLoading
    ]);
};
const $93417f2cf15e39ef$export$ae1adabf094b2244 = (// Relay-generated query from the @refetchable annotation in a useRefetchableFragment
// or usePaginationFragment
query, // Refetch function from a useRefetchableFragment or usePaginationFragment
// (which ordinarily would trigger suspense)
refetch, { setIsLoading: setIsLoading, setLastFetchError: setLastFetchError, fetchPolicy: fetchPolicy = 'store-or-network', networkCacheConfig: networkCacheConfig } = {})=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const isMounted = (0, $3koWU.useIsMounted)();
    const { onNewRequest: onNewRequest, onRequestFinish: onRequestFinish } = $93417f2cf15e39ef$var$useInFlightRequests({
        setIsLoading: setIsLoading
    });
    return (0, $eUqFw.useCallback)((variables)=>{
        if (isMounted.current) setIsLoading?.(true);
        onNewRequest(variables);
        return (0, $iWLL0.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: networkCacheConfig
        }).subscribe({
            complete () {
                if (isMounted.current) {
                    setLastFetchError?.(null);
                    onRequestFinish(variables, ()=>refetch(variables, {
                            fetchPolicy: 'store-only'
                        }));
                }
            },
            error (e) {
                if (isMounted.current) onRequestFinish(variables, ()=>setLastFetchError?.(e));
            }
        });
    }, [
        environment,
        fetchPolicy,
        isMounted,
        networkCacheConfig,
        onNewRequest,
        onRequestFinish,
        query,
        refetch,
        setIsLoading,
        setLastFetchError
    ]);
};
const $93417f2cf15e39ef$export$c7ce5f64dc007896 = (query, refetch, options)=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [lastFetchError, setLastFetchError] = (0, $eUqFw.useState)(null);
    const refetchFunction = $93417f2cf15e39ef$export$ae1adabf094b2244(query, refetch, {
        ...options,
        setIsLoading: setIsLoading,
        setLastFetchError: setLastFetchError
    });
    return [
        refetchFunction,
        isLoading,
        lastFetchError
    ];
};

});

parcelRegister("3OCmX", function(module, exports) {

$parcel$export(module.exports, "SelectableFieldEditViewWithFieldOptionsFragment", () => $1eca3fe325cf5c7e$export$6d0c23ae5fe3899c);

var $5n2kr = parcelRequire("5n2kr");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");

var $4Bees = parcelRequire("4Bees");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4Hwcq = parcelRequire("4Hwcq");

var $jM2Oz = parcelRequire("jM2Oz");

var $4bMJ9 = parcelRequire("4bMJ9");
parcelRequire("gLLZt");
var $7nzO5 = parcelRequire("7nzO5");

var $e349w = parcelRequire("e349w");

var $2jdHI = parcelRequire("2jdHI");

var $bMEzK = parcelRequire("bMEzK");

var $1QVWH = parcelRequire("1QVWH");

var $adEL3 = parcelRequire("adEL3");

var $84CBi = parcelRequire("84CBi");

var $fa2D3 = parcelRequire("fa2D3");

var $5AQD1 = parcelRequire("5AQD1");

var $E4PoK = parcelRequire("E4PoK");
const $1eca3fe325cf5c7e$var$LoadingIndicator = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small",
        interactionName: "loading"
    })); /**
          * MultiSelectableFieldEditViewWithFieldOptionsFragment is a version of the edit view that allows
          * the passing of a fragment for experiences like GIC that might want to group fetch data on mount
          * instead of having a separate network request for it
          *
          * @param props [SelectableFieldEditViewWithFieldOptionsFragmentProps](./types.tsx)
          */ 
const $1eca3fe325cf5c7e$export$6d0c23ae5fe3899c = ({ autoFocus: autoFocus = false, cachedOptions: cachedOptions, classNamePrefix: classNamePrefix, fieldId: fieldId, fieldOptionsFragmentRef: fieldOptionsFragmentRef, filterOptionsById: filterOptionsById = null, footer: footer, formatGroupLabel: formatGroupLabel, hasInfiniteScroll: hasInfiniteScroll = true, validationState: validationState = 'default', isMulti: isMulti = false, isClearable: isClearable, isDisabled: isFieldDisabled = false, isInvalid: isInvalid = false, onChange: onChange, onFooterSelect: onFooterSelect, required: required = false, inputId: inputId, menuPosition: menuPosition, styles: styles, value: value, loadingMessage: loadingMessage, noOptionsMessage: noOptionsMessage, loadOptions: loadOptions, optionsFirstCount: optionsFirstCount = (0, $4Hwcq.FRAGMENT_SELECTABLE_FIELD_OPTIONS_FIRST), optionsPageCount: optionsPageCount = (0, $4Hwcq.SELECTABLE_FIELD_PAGE_OPTIONS), spacing: spacing = 'default', sortOptions: sortOptions, placeholder: placeholder, recentOptionsLabel: recentOptionsLabel, allOptionsLabel: allOptionsLabel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const loadOptionsTracing = (0, $fa2D3.default)('selectable-field-edit-view.load-options');
    const getPlaceholderMessage = (0, $eUqFw.useCallback)(()=>placeholder ?? formatMessage((0, $5AQD1.default).placeholder), [
        formatMessage,
        placeholder
    ]);
    const getRecentOptionsLabel = (0, $eUqFw.useCallback)(()=>recentOptionsLabel ?? formatMessage((0, $5AQD1.default).recent), [
        formatMessage,
        recentOptionsLabel
    ]);
    const getAllOptionsLabel = (0, $eUqFw.useCallback)(()=>allOptionsLabel ?? formatMessage((0, $5AQD1.default).all), [
        formatMessage,
        allOptionsLabel
    ]);
    const { data: fieldOptionsSearchData, refetch: refetch, loadNext: loadNext, hasNext: hasNext, isLoadingNext: isLoadingNext } = (0, $iWLL0.usePaginationFragment)((0, $5n2kr.default), fieldOptionsFragmentRef);
    // #region Common state (might be handy for other components)
    /** Determines if options are being loaded externally; used by the `loadOptions` callback */ const [isLoadingOptions, setIsLoadingOptions] = (0, $eUqFw.useState)(false); /** The Relay options transformed to the AK Select `options` prop */ 
    const [loadedOptions, setLoadedOptions] = (0, $eUqFw.useState)([]);
    const [searchByString, setSearchByString] = (0, $eUqFw.useState)(''); // #endregion
    // #region Refetching suggestions
    const refetchSuggestions = (0, $eUqFw.useCallback)((variables, options = {})=>refetch(variables, {
            ...options,
            onComplete: ()=>{
                setIsLoadingOptions(true);
            }
        }), [
        refetch
    ]); // #endregion
    // #region Debounced suspensless refetch helpers
    const [searchSuspenselessRefetch, isFetching, lastFetchError] = (0, $4bMJ9.useSuspenselessRefetch)((0, $bMEzK.default), refetchSuggestions);
    const searchSuspenselessRefetchWithTracing = (0, $eUqFw.useCallback)((...args)=>{
        // Traces both `selectableFieldSearchRefetchQuery` and the `loadOptions` callback (if provided)
        loadOptionsTracing();
        return searchSuspenselessRefetch(...args);
    }, [
        loadOptionsTracing,
        searchSuspenselessRefetch
    ]);
    const [searchDebouncedSuspenselessRefetch] = (0, $2jdHI.default)(searchSuspenselessRefetchWithTracing, (0, $4Hwcq.SEARCH_DEBOUNCE_TIMEOUT));
    const [searchLeadingEdgeSuspenselessRefetch] = (0, $2jdHI.default)(searchSuspenselessRefetchWithTracing, (0, $4Hwcq.SEARCH_DEBOUNCE_TIMEOUT), {
        leading: true
    }); // #endregion
    // #region Common callbacks for the selector
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        searchLeadingEdgeSuspenselessRefetch({
            id: fieldId,
            searchBy: searchByString,
            filterById: filterOptionsById,
            first: optionsFirstCount
        });
    }, [
        fieldId,
        searchByString,
        searchLeadingEdgeSuspenselessRefetch,
        filterOptionsById,
        optionsFirstCount
    ]);
    const onSearchByStringChangeFunction = (0, $eUqFw.useCallback)((newSearchByString)=>{
        setSearchByString(newSearchByString);
        searchDebouncedSuspenselessRefetch({
            id: fieldId,
            searchBy: newSearchByString,
            filterById: filterOptionsById,
            first: optionsFirstCount
        });
    }, [
        fieldId,
        searchDebouncedSuspenselessRefetch,
        filterOptionsById,
        optionsFirstCount
    ]);
    const handleFilterOption = (0, $eUqFw.useCallback)((option, query = '')=>option.data?.__isNew__ || option.label.toLowerCase().includes(query.toLowerCase()), []); // #endregion
    const defaultFailedOption = (0, $eUqFw.useMemo)(()=>({
            label: formatMessage((0, $5AQD1.default).failedFetch),
            content: formatMessage((0, $5AQD1.default).failedFetch),
            value: '',
            isDisabled: true
        }), [
        formatMessage
    ]);
    const selectableValueOptions = (0, $eUqFw.useMemo)(()=>{
        const { edges: edges } = fieldOptionsSearchData.node?.selectableValueOptions || {};
        const options = edges?.map((edge)=>edge?.node ?? null).filter(Boolean).filter((option)=>option && option.selectableLabel != null) || [];
        return sortOptions ? sortOptions(options) : options;
    }, [
        fieldOptionsSearchData.node?.selectableValueOptions,
        sortOptions
    ]);
    const options = (0, $eUqFw.useMemo)(()=>{
        if (lastFetchError != null) return [
            defaultFailedOption
        ];
        const groupedOptions = (0, $E4PoK.getGroupedOptions)(loadedOptions, cachedOptions, getAllOptionsLabel(), getRecentOptionsLabel(), formatMessage((0, $5AQD1.default).other));
        return groupedOptions;
    }, [
        loadedOptions,
        lastFetchError,
        defaultFailedOption,
        cachedOptions,
        formatMessage,
        getAllOptionsLabel,
        getRecentOptionsLabel
    ]); // #endregion
    const selectedValue = (0, $eUqFw.useMemo)(()=>{
        if (!value) return null;
        const optionsArray = Array.isArray(value) ? value : [
            value
        ];
        return optionsArray.map((option)=>({
                ari: option.id,
                id: option.versionId || option.optionId,
                label: option.selectableLabel || '',
                value: option.selectableLabel || '',
                isDisabled: option.isDisabled || false,
                groupKey: option.selectableGroupKey,
                content: '',
                iconUrl: option.selectableIconUrl
            }));
    }, [
        value
    ]);
    const getSelectableValueOption = (0, $eUqFw.useCallback)((selectedOption)=>{
        if (!selectedOption.ari) return undefined;
        const fieldOptionId = typeof selectedOption.id === 'number' ? String(selectedOption.id) : selectedOption.id;
        return {
            id: selectedOption.ari,
            selectableLabel: selectedOption.label,
            selectableGroupKey: selectedOption.groupKey,
            selectableIconUrl: selectedOption.iconUrl,
            isDisabled: selectedOption.isDisabled ?? false,
            optionId: fieldOptionId,
            versionId: fieldOptionId
        };
    }, []);
    const handleOnChange = (selectedOption, actionMeta)=>{
        if (onChange) {
            if (!selectedOption) {
                onChange(null, {
                    action: actionMeta.action
                });
                return;
            }
            const option = Array.isArray(selectedOption) ? selectedOption : [
                selectedOption
            ];
            const selectedOptions = option.map((opt)=>getSelectableValueOption(opt)).filter(Boolean);
            onChange(selectedOptions, {
                action: actionMeta.action,
                option: actionMeta.option && 'value' in actionMeta.option ? getSelectableValueOption(actionMeta.option) : undefined,
                removedValue: actionMeta.removedValue && 'value' in actionMeta.removedValue ? getSelectableValueOption(actionMeta.removedValue) : undefined
            });
        }
    };
    const getLoadingMessage = (0, $eUqFw.useMemo)(()=>{
        if (loadingMessage) return loadingMessage;
        return ()=>formatMessage((0, $5AQD1.default).loading);
    }, [
        loadingMessage,
        formatMessage
    ]);
    const getNoOptionsMessage = (0, $eUqFw.useMemo)(()=>{
        if (noOptionsMessage) return noOptionsMessage;
        return ()=>formatMessage((0, $5AQD1.default).empty);
    }, [
        noOptionsMessage,
        formatMessage
    ]);
    const selectValidationState = (0, $eUqFw.useMemo)(()=>{
        if (isInvalid) return 'error';
        return validationState;
    }, [
        isInvalid,
        validationState
    ]);
    const setOrLoadOptions = (0, $eUqFw.useCallback)(async ()=>{
        if (loadOptions == null) setLoadedOptions(selectableValueOptions);
        else if (isLoadingOptions) {
            /**
       * Call only when `refetch` completes, via the `isLoadingOptions` prop.
       *
       * This prevents `loadOptions` from getting called twice on initial render
       * if the fetch policy includes getting cached data.
       */ const result = await loadOptions(selectableValueOptions);
            setLoadedOptions(result);
        }
        setIsLoadingOptions(false);
    }, [
        isLoadingOptions,
        loadOptions,
        selectableValueOptions
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isFetching) setOrLoadOptions();
    }, [
        isFetching,
        setOrLoadOptions
    ]);
    const onMenuScrollToBottom = ()=>{
        if (hasNext) loadNext(optionsPageCount);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adEL3.default), {
        name: "selectable-field-edit-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e349w.default), {
        "aria-label": formatMessage((0, $5AQD1.default).selectLabel),
        autoFocus: autoFocus,
        classNamePrefix: classNamePrefix,
        components: {
            LoadingIndicator: $1eca3fe325cf5c7e$var$LoadingIndicator
        },
        filterOption: handleFilterOption,
        footer: footer,
        formatGroupLabel: formatGroupLabel,
        formatOptionLabel: $1eca3fe325cf5c7e$export$f64ca8d680ed0ac0,
        isDisabled: isFieldDisabled,
        isLoading: isFetching || isLoadingOptions || isLoadingNext,
        isMulti: isMulti,
        isClearable: isClearable,
        isRequired: required,
        loadingMessage: getLoadingMessage,
        noOptionsMessage: getNoOptionsMessage,
        onChange: handleOnChange,
        onFocus: onFocus,
        onFooterSelect: onFooterSelect,
        onInputChange: onSearchByStringChangeFunction,
        ...(0, $1ybV0.ff)('issue.details.async-field-options-tech-debt') && hasInfiniteScroll && {
            onMenuScrollToBottom: onMenuScrollToBottom
        },
        options: options,
        placeholder: getPlaceholderMessage(),
        shouldShowFooter: !!footer,
        styles: styles ?? (0, $7nzO5.defaultSelectStyles),
        validationState: selectValidationState,
        value: selectedValue,
        openMenuOnFocus: true,
        closeMenuOnSelect: false,
        spacing: spacing,
        inputId: inputId,
        menuPosition: menuPosition,
        hideSelectedOptions: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QVWH.default), {
        data: {
            typeName: fieldOptionsSearchData.node?.__typename,
            hasSearchByString: searchByString.length > 0,
            /**
       * Don't report `issueFieldType` if `node` is not a `JiraIssueField`
       * e.g., `JiraParentOption` implements `JiraHasSelectableValueOptions` but doesn't have the `type` field
       */ issueFieldType: fieldOptionsSearchData.node?.type ?? undefined
        }
    }), loadOptions != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "load-options-callback",
        hold: isLoadingOptions
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1eca3fe325cf5c7e$var$LabelTextWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $1eca3fe325cf5c7e$export$f64ca8d680ed0ac0 = (option)=>option.iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jM2Oz.OptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jM2Oz.ImgSpan), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: option.iconUrl || '',
        alt: option.label,
        width: 2 * (0, $c9TLT.gridSize),
        height: 2 * (0, $c9TLT.gridSize),
        role: "none"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1eca3fe325cf5c7e$var$LabelTextWrapper, null, option.label)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, option.label);

});
parcelRegister("5n2kr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c854976595bcc7b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<34a30f6e444cb8b9481f73f1016edea7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $bMEzK = parcelRequire("bMEzK");
const $c854976595bcc7b0$var$node = function() {
    var v0 = [
        "node",
        "selectableValueOptions"
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filterById"
            },
            {
                "defaultValue": 20,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "id"
            },
            {
                "defaultValue": "",
                "kind": "LocalArgument",
                "name": "searchBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $bMEzK.default)
            }
        },
        "name": "ui_issueSelectableFieldEditView_SelectableFieldEditViewWithFieldOptionsFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "id"
                    }
                ],
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "type"
                            }
                        ],
                        "type": "JiraIssueField",
                        "abstractKey": "__isJiraIssueField"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": "selectableValueOptions",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "filterById",
                                        "variableName": "filterById"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "searchBy",
                                        "variableName": "searchBy"
                                    }
                                ],
                                "concreteType": "JiraSelectableValueConnection",
                                "kind": "LinkedField",
                                "name": "__selectableValue_issueFieldEditviewFull_fieldOptions__selectableValueOptions_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSelectableValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "selectableLabel"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "selectableGroupKey"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "selectableIconUrl"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "isDisabled"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "optionId"
                                                            }
                                                        ],
                                                        "type": "JiraOption"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "versionId"
                                                            }
                                                        ],
                                                        "type": "JiraVersion"
                                                    },
                                                    v1 /*: any*/ 
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraHasSelectableValueOptions",
                        "abstractKey": "__isJiraHasSelectableValueOptions"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$c854976595bcc7b0$var$node.hash = "3d267c6a0410eaf695cd68ed2129a201";
var $c854976595bcc7b0$export$2e2bcd8739ae039 = $c854976595bcc7b0$var$node;

});
parcelRegister("bMEzK", function(module, exports) {

$parcel$export(module.exports, "default", () => $444a8426fb36b854$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4365c46490427f2c4b65dcdf859a8a49>>
 * @relayHash f4ffc323cb00ada665310bce77aef5ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7035d5f9a07f8abb7f55c0cb68453efbbf1f2c4fb6b42bbf597ac310eef71c57
const $444a8426fb36b854$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        },
        {
            "defaultValue": 20,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "searchBy"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v2 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v3 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v4 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v5 = {
        "kind": "Variable",
        "name": "searchBy",
        "variableName": "searchBy"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "selectableFieldSearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "ui_issueSelectableFieldEditView_SelectableFieldEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "selectableFieldSearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v4 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                }
                            ],
                            "type": "JiraIssueField",
                            "abstractKey": "__isJiraIssueField"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraSelectableValueConnection",
                                    "kind": "LinkedField",
                                    "name": "selectableValueOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSelectableValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableLabel"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableGroupKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableIconUrl"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDisabled"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "optionId"
                                                                }
                                                            ],
                                                            "type": "JiraOption"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "versionId"
                                                                }
                                                            ],
                                                            "type": "JiraVersion"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "selectableValue_issueFieldEditviewFull_fieldOptions__selectableValueOptions",
                                    "kind": "LinkedHandle",
                                    "name": "selectableValueOptions"
                                }
                            ],
                            "type": "JiraHasSelectableValueOptions",
                            "abstractKey": "__isJiraHasSelectableValueOptions"
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "7035d5f9a07f8abb7f55c0cb68453efbbf1f2c4fb6b42bbf597ac310eef71c57",
            "metadata": {},
            "name": "selectableFieldSearchRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$444a8426fb36b854$var$node.hash = "3d267c6a0410eaf695cd68ed2129a201";
var $444a8426fb36b854$export$2e2bcd8739ae039 = $444a8426fb36b854$var$node;

});


parcelRegister("jM2Oz", function(module, exports) {

$parcel$export(module.exports, "FailedFetchOptionWrapper", () => $9987adeb236c664b$export$38a1a0a811e06255);
$parcel$export(module.exports, "getFailedFetchSelectOptionsWithDefaultLabel", () => $9987adeb236c664b$export$aa3357fb0ebcdb2b);
$parcel$export(module.exports, "OptionWrapper", () => $9987adeb236c664b$export$d6f6a072cce04542);
$parcel$export(module.exports, "ImgSpan", () => $9987adeb236c664b$export$df67068a00dece12);
$parcel$export(module.exports, "FlexSpan", () => $9987adeb236c664b$export$d90eccb59fb62cab);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $9987adeb236c664b$export$9e874bb1adc98a55);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hnFco = parcelRequire("hnFco");
const $9987adeb236c664b$export$6ed0d629c0656ce1 = (query, label)=>[
        {
            options: [
                {
                    label: label,
                    value: '',
                    isDisabled: true,
                    filterValues: [
                        query
                    ] // filterOptionByLabelAndFilterValues will check `filterValues` and since it contains the user's query, this option will always show
                }
            ]
        }
    ];
const $9987adeb236c664b$var$DefaultFailedFetchMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const failedFetchMessage = (0, $hnFco.default).failedFetch;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9987adeb236c664b$export$38a1a0a811e06255, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage(failedFetchMessage), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        role: "button",
        href: window.location.href,
        onClick: ()=>window.location.reload()
    }, formatMessage((0, $hnFco.default).reloadIssue))));
};
const $9987adeb236c664b$export$aa3357fb0ebcdb2b = (query)=>$9987adeb236c664b$export$6ed0d629c0656ce1(query, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9987adeb236c664b$var$DefaultFailedFetchMessage, null)); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9987adeb236c664b$export$d6f6a072cce04542 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9987adeb236c664b$export$38a1a0a811e06255 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $9987adeb236c664b$export$d6f6a072cce04542, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bah1h6o",
            __cmplp.className
        ])
    });
});
const $9987adeb236c664b$export$df67068a00dece12 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $9987adeb236c664b$export$d90eccb59fb62cab = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $9987adeb236c664b$export$9e874bb1adc98a55 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { errorMessagePopsition: errorMessagePopsition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.errorMessagePopsition === 'top' && "_otyri2wt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hnFco", function(module, exports) {

$parcel$export(module.exports, "default", () => $79fb52d38fb3e29a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $79fb52d38fb3e29a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    failedFetch: {
        "id": "issue-field-select-base.failed-fetch-options.failed-fetch",
        "defaultMessage": "Search failed."
    },
    reloadIssue: {
        "id": "issue-field-select-base.failed-fetch-options.reload-issue",
        "defaultMessage": "Try reloading the issue."
    }
});

});


parcelRegister("2jdHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3243fa342b695d88$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");
function $3243fa342b695d88$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eUqFw.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $eUqFw.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eUqFw.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eUqFw.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("5AQD1", function(module, exports) {

$parcel$export(module.exports, "default", () => $307a50efeb37e59b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $307a50efeb37e59b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    empty: {
        "id": "issue-selectable-field-edit-view.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-selectable-field-edit-view.failed-fetch",
        "defaultMessage": "Search failed"
    },
    loading: {
        "id": "issue-selectable-field-edit-view.loading",
        "defaultMessage": "Searching..."
    },
    placeholder: {
        "id": "issue-selectable-field-edit-view.placeholder",
        "defaultMessage": "Select..."
    },
    recent: {
        "id": "issue-selectable-field-edit-view.recent",
        "defaultMessage": "Recent"
    },
    all: {
        "id": "issue-selectable-field-edit-view.all",
        "defaultMessage": "All"
    },
    other: {
        "id": "issue-selectable-field-edit-view.other",
        "defaultMessage": "Other"
    },
    selectLabel: {
        "id": "issue-selectable-field-edit-view.select-label",
        "defaultMessage": "Select with footer"
    }
});

});

parcelRegister("E4PoK", function(module, exports) {

$parcel$export(module.exports, "getGroupedOptions", () => $f72dedb9ccbcb2ad$export$721c3d9226425f9c);
const $f72dedb9ccbcb2ad$export$edf1d6fede1416aa = (option)=>({
        ari: option.id,
        id: option.versionId || option.optionId,
        label: option.selectableLabel || '',
        value: option.selectableLabel || '',
        isDisabled: option.isDisabled || false,
        content: '',
        iconUrl: option.selectableIconUrl,
        groupKey: option.selectableGroupKey
    });
const $f72dedb9ccbcb2ad$export$54cff29101d9f4b9 = (options)=>{
    const optionsArray = Array.isArray(options) ? options : [
        options
    ];
    return optionsArray.map($f72dedb9ccbcb2ad$export$edf1d6fede1416aa);
};
const $f72dedb9ccbcb2ad$export$721c3d9226425f9c = (options, cachedOptions, allLabel, recentLabel, otherLabel)=>{
    const groupedOptions = [];
    const hasCache = !!cachedOptions?.length;
    const hasOrExpectsCacheAndHasOtionsWithoutGroupKey = cachedOptions && cachedOptions?.length >= 0 && options.length && // assuming that if the first option has groupKey, all of the options have groupKey
    !options[0].selectableGroupKey;
    // if there are cached options, group them under the 'Recent' group label
    if (hasCache) groupedOptions.push({
        label: recentLabel,
        options: $f72dedb9ccbcb2ad$export$54cff29101d9f4b9(cachedOptions)
    });
    // if there are cached options (or they are expected) and options without groupKey, group options under the 'All' group label
    if (hasOrExpectsCacheAndHasOtionsWithoutGroupKey) {
        groupedOptions.push({
            label: allLabel,
            options: $f72dedb9ccbcb2ad$export$54cff29101d9f4b9(options)
        });
        return groupedOptions;
    }
    if (options?.length) {
        // normalize options into groups
        options.forEach((option)=>{
            if (option.selectableGroupKey) {
                const group = groupedOptions.find((groupedOption)=>option.selectableGroupKey === groupedOption.label);
                if (group) group.options.push($f72dedb9ccbcb2ad$export$edf1d6fede1416aa(option));
                else groupedOptions.push({
                    label: option.selectableGroupKey,
                    options: $f72dedb9ccbcb2ad$export$54cff29101d9f4b9([
                        option
                    ])
                });
            }
        });
        // handle possible scenario where some of the options have selectableGroupKey and some don't. Group the options with no selectableGroupKey under the Other group
        const allOptionsCount = cachedOptions ? cachedOptions?.length + options.length : options.length;
        const allGroupedOptionsCount = groupedOptions.map((x)=>x.options).flat().length;
        const hasUngroupedOptions = allGroupedOptionsCount && allGroupedOptionsCount !== allOptionsCount;
        if (hasUngroupedOptions) {
            const unGroupedOptions = options.filter((x)=>x.selectableGroupKey == null);
            groupedOptions.push({
                label: otherLabel,
                options: $f72dedb9ccbcb2ad$export$54cff29101d9f4b9([
                    ...unGroupedOptions
                ])
            });
        }
        if (!groupedOptions.length) return $f72dedb9ccbcb2ad$export$54cff29101d9f4b9(options);
    }
    return groupedOptions;
};

});


parcelRegister("dezip", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a14e34b8ac14904$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6a14e34b8ac14904$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    empty: {
        "id": "issue-field-multi-select-editview-full.multi-select.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-multi-select-editview-full.multi-select.failed-fetch",
        "defaultMessage": "Search failed"
    },
    loading: {
        "id": "issue-field-multi-select-editview-full.multi-select.loading",
        "defaultMessage": "Searching..."
    },
    placeholder: {
        "id": "issue-field-multi-select-editview-full.multi-select.placeholder",
        "defaultMessage": "Select {fieldName}"
    }
});

});


parcelRegister("hW84d", function(module, exports) {

$parcel$export(module.exports, "useLazyLoadQueryAfterPageLoad", () => $a7366610004d0c48$export$f81512884fc78f5);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $gUUjF = parcelRequire("gUUjF");

var $epT40 = parcelRequire("epT40");
const $a7366610004d0c48$export$f81512884fc78f5 = (query, queryArguments)=>{
    const [queryReference, loadQuery] = (0, $iWLL0.useQueryLoader)(query);
    const [{ hasLoaded: hasLoaded }] = (0, $epT40.default)();
    (0, $eUqFw.useEffect)(()=>{
        try {
            if (hasLoaded === true && Object.values(queryArguments).every((arg)=>arg != null)) loadQuery(queryArguments);
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error';
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.use-lazy-load-query-after-page-load-hook', `Error occurred while loading query: ${errorMessage}`);
        }
    // This eslint disable is here to ensure that loadQuery is only executed exactly when hasLoaded has changed to
    // true and not due to a change in any other variable, guaranteeing it is only executed once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasLoaded
    ]);
    return queryReference;
};

});

parcelRegister("jioZP", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $fff75b9fbe3b6db2$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $fff75b9fbe3b6db2$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformRelayToReduxValue", () => $fff75b9fbe3b6db2$export$5049f227693bb420);
$parcel$export(module.exports, "transformReduxToRelayValue", () => $fff75b9fbe3b6db2$export$882a4e6f4273327b);

var $1ybV0 = parcelRequire("1ybV0");
const $fff75b9fbe3b6db2$var$toItem = (fieldData)=>({
        value: fieldData.id,
        content: fieldData.value || '',
        ari: fieldData.ari
    });
const $fff75b9fbe3b6db2$export$cb172b2468ab5652 = (value)=>value ? value.map($fff75b9fbe3b6db2$var$toItem) : [];
const $fff75b9fbe3b6db2$export$1cfcb95cb8fbddb3 = (value)=>value && value.map((item)=>({
            id: String(item.value),
            value: item.content,
            ari: item.ari
        }));
const $fff75b9fbe3b6db2$export$5049f227693bb420 = (option)=>{
    if (!(0, $1ybV0.ff)('issue.details.follow-up-relay-multi-select-field-issue-view-integration') && 'label' in option) return {
        value: option.optionId ?? '',
        label: option.label,
        content: option.label,
        ari: option.value
    };
    return {
        value: option.optionId ?? '',
        label: option.selectableLabel ?? '',
        content: option.selectableLabel ?? '',
        ari: option.id
    };
};
const $fff75b9fbe3b6db2$export$882a4e6f4273327b = (option)=>({
        value: option.ari || '',
        label: option.content,
        optionId: String(option.value),
        selectableLabel: option.content || '',
        selectableGroupKey: null,
        selectableIconUrl: null,
        id: option.ari || ''
    });

});


parcelRegister("bognG", function(module, exports) {

$parcel$export(module.exports, "default", () => $76ba0b25fe9c0c82$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4ksts = parcelRequire("4ksts");

var $hJ992 = parcelRequire("hJ992");

var $9LvPd = parcelRequire("9LvPd");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $7vU0J = parcelRequire("7vU0J");

var $eY8vu = parcelRequire("eY8vu");

var $4bZws = parcelRequire("4bZws");

var $huhk2 = parcelRequire("huhk2");

var $4xwq2 = parcelRequire("4xwq2");

var $hHKWU = parcelRequire("hHKWU");
const $76ba0b25fe9c0c82$var$View = ({ fieldId: fieldKey, label: label, area: area })=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $4ksts.useIntlV2)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const showPinButton = (0, $hHKWU.default)(area);
    const [{ value: value, fieldConfig: fieldConfig }] = (0, $eY8vu.useNumberField)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldLabel = fieldConfig?.title || label;
    const renderReadView = (0, $eUqFw.useCallback)(()=>{
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'number' and 'string' have no overlap.
        if (value === null || value === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), null, formatMessage((0, $huhk2.genericMessages).noValue));
        return formatNumber(value);
    }, [
        formatMessage,
        formatNumber,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($76ba0b25fe9c0c82$var$NumberFieldWrapper, {
        "data-testid": `issue.views.issue-base.context.number.${fieldKey}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), {
        fieldId: fieldKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, fieldLabel), issueKey !== undefined && fieldKey !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldKey,
        label: fieldLabel
    }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldKey,
        label: fieldLabel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vU0J.default), {
        label: fieldLabel,
        issueKey: issueKey,
        fieldKey: fieldKey,
        noValueText: formatMessage((0, $huhk2.genericMessages).noValue),
        readView: renderReadView(),
        isFitContainerWidthReadView: true
    })));
};
var $76ba0b25fe9c0c82$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($76ba0b25fe9c0c82$var$View);
const $76ba0b25fe9c0c82$var$NumberFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $64ypR.FieldWrapper), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16ep1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7vU0J", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "actionSubject", () => $793ea3f21196f3ec$export$fd8ebf59dd2b58b6);
$parcel$export(module.exports, "default", () => $793ea3f21196f3ec$export$2e2bcd8739ae039);
$parcel$export(module.exports, "LozengeChildNumberFieldContainer", () => $793ea3f21196f3ec$export$e5940b0448e9a6f);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $illlw = parcelRequire("illlw");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $dWGNJ = parcelRequire("dWGNJ");

var $6oQPP = parcelRequire("6oQPP");
var $5St1r = parcelRequire("5St1r");

var $jMP2a = parcelRequire("jMP2a");

var $6vrw7 = parcelRequire("6vrw7");



var $eY8vu = parcelRequire("eY8vu");

var $bHYrY = parcelRequire("bHYrY");

var $9OWHk = parcelRequire("9OWHk");

var $6UA3n = parcelRequire("6UA3n");
const $793ea3f21196f3ec$export$fd8ebf59dd2b58b6 = 'numberInlineEdit';
var $793ea3f21196f3ec$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { fieldKey: fieldKey, issueKey: issueKey, onCancel: onCancel, onEdit: onEdit, onEscape: onEscape, onConfirm: onConfirm, onEnter: onEnter, onUpdate: onUpdate, onSubmit: onSubmit, onFailure: onFailure, readView: readView, editView: editView, noValueText: noValueText, fieldFocusStyle: fieldFocusStyle, fieldEditStyle: fieldEditStyle, saveField: saveField, ...rest } = props;
    const [isEditing, setIsEditing] = (0, $eUqFw.useState)(false);
    const onSuccess = (newValue)=>{
        onUpdate && onUpdate(newValue);
        setIsEditing(false);
    };
    const [{ value: value, error: error, fieldConfig: fieldConfig }, { saveValue: saveValue, resetError: resetError }] = (0, $eY8vu.useNumberField)({
        issueKey: (0, $6vrw7.toIssueKey)(issueKey),
        fieldKey: fieldKey,
        onSuccess: onSuccess,
        onSubmit: onSubmit,
        onFailure: onFailure,
        saveField: saveField
    });
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'number');
    const [updatedValue, setUpdatedValue] = (0, $eUqFw.useState)(value);
    const isFieldEditable = fieldConfig ? fieldConfig.isEditable : false;
    (0, $eUqFw.useEffect)(()=>{
        if (error) setIsEditing(true);
        if (!isEditing) setUpdatedValue(value);
    }, [
        error,
        isEditing,
        value
    ]);
    const save = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        if (updatedValue !== value) saveValue(updatedValue, null, analyticsEvent);
        else setIsEditing(false);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        saveValue,
        updatedValue,
        value
    ]);
    const cancel = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        resetError();
        setIsEditing(false);
        setUpdatedValue(value);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        resetError,
        value
    ]);
    const onCancelRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onCancel && onCancel(analyticsEvent);
    }, [
        onCancel,
        cancel
    ]);
    const onConfirmRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        save(analyticsEvent);
        onConfirm && onConfirm(analyticsEvent);
    }, [
        onConfirm,
        save
    ]);
    const onEditRequested = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        setIsEditing(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onEdit && onEdit(analyticsEvent);
    }, [
        onEdit
    ]);
    const onEscapeRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onEscape && onEscape(analyticsEvent);
    }, [
        onEscape,
        cancel
    ]);
    const onEnterRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onEnter && onEnter(analyticsEvent);
    }, [
        onEnter
    ]);
    const onChange = (0, $eUqFw.useCallback)((event)=>{
        resetError();
        const typedValue = event.target.value === '' ? null : parseFloat(Number(event.target.value).toFixed(3));
        setUpdatedValue(typedValue);
    }, [
        resetError,
        setUpdatedValue
    ]);
    const renderEditView = ()=>editView !== undefined ? editView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bHYrY.NumberEdit), {
            defaultValue: updatedValue,
            onChange: onChange,
            type: fieldType,
            isInvalid: !!error
        });
    const renderReadView = ()=>readView !== undefined ? readView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6UA3n.NumberView), {
            isEditable: isFieldEditable,
            value: value,
            setIsEditing: setIsEditing
        });
    let InlineEditContainer = $793ea3f21196f3ec$var$NumberInlineEditContainer;
    if (fieldFocusStyle === (0, $ada2d6cf4ae575cf$export$44f42916442b37c3)) InlineEditContainer = $793ea3f21196f3ec$var$LozengeNumberFieldContainer;
    if (fieldFocusStyle === (0, $ada2d6cf4ae575cf$export$797ed91ebb8db1c5)) InlineEditContainer = $793ea3f21196f3ec$export$e5940b0448e9a6f;
    if (isEditing) {
        if (fieldEditStyle === (0, $ada2d6cf4ae575cf$export$1ff9623b26415f8)) InlineEditContainer = $793ea3f21196f3ec$var$InlineWidthContainer;
    }
    const numberInlineEdit = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: error,
        title: (0, $9OWHk.default).errorTitle,
        description: (0, $9OWHk.default).errorMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InlineEditContainer, {
        isEditable: isFieldEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        testId: (0, $f6a7c9af3be196db$export$195635d59130784a),
        actionSubject: $793ea3f21196f3ec$export$fd8ebf59dd2b58b6,
        isEditable: isFieldEditable,
        isEditing: isEditing,
        readView: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5St1r.ReadViewContainer), null, renderReadView()),
        editView: isFieldEditable ? renderEditView() : null,
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onEdit: onEditRequested,
        onEscape: onEscapeRequest,
        onEnter: onEnterRequest,
        ...rest
    })));
    if (fieldFocusStyle !== (0, $ada2d6cf4ae575cf$export$797ed91ebb8db1c5)) return numberInlineEdit;
    return isEditing ? numberInlineEdit : // @ts-expect-error - TS2741 - Property 'hasValue' is missing in type '{ children: Element; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { hasValue: boolean; }, any>>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InlineEditContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5St1r.ReadViewContainer), null, renderReadView()));
});
// @ts-expect-error - TS2345: Argument of type 'StyledComponentClass'
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $793ea3f21196f3ec$var$LozengeNumberFieldContainer = /*#__PURE__*/ (0, $kwce8.default)((0, $5St1r.InlineEditContainer)).withConfig({
    componentId: "ngcazt-0"
})`padding-right:${"var(--ds-space-075, 6px)"};& div[data-read-view-fit-container-width]{background:transparent !important;border:none !important;vertical-align:${()=>(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? 'top' // not perfectly vertically centered without this
     : undefined};}& button[aria-label='Edit']:focus + div > div:first-child{border:2px solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`};border-radius:${"var(--ds-border-radius-300, 12px)"};margin-left:${()=>(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? '-2px' : "var(--ds-space-negative-025, -2px)"};margin-right:${()=>(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? '-6px' : "var(--ds-space-negative-075, -6px)"};}`;
const $793ea3f21196f3ec$export$e5940b0448e9a6f = /*#__PURE__*/ (0, $kwce8.default)($793ea3f21196f3ec$var$LozengeNumberFieldContainer).withConfig({
    componentId: "ngcazt-1"
})`padding-top:${"var(--ds-space-100, 8px)"};`;
// @ts-expect-error - TS2345: Argument of type 'StyledComponentClass'
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $793ea3f21196f3ec$var$InlineWidthContainer = /*#__PURE__*/ (0, $kwce8.default)((0, $5St1r.InlineEditContainer)).withConfig({
    componentId: "ngcazt-2"
})`padding-right:${"var(--ds-space-075, 6px)"};width:68px;margin-right:${"var(--ds-space-negative-075, -6px)"};& [data-ds--text-field--container]{border-color:${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`};}`;
// @ts-expect-error - TS2345: Argument of type 'StyledComponentClass'
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $793ea3f21196f3ec$var$NumberInlineEditContainer = /*#__PURE__*/ (0, $kwce8.default)((0, $5St1r.InlineEditContainer)).withConfig({
    componentId: "ngcazt-3"
})`${({ isEditable: isEditable })=>!isEditable ? // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-css-tagged-template-expression
    (0, $kwce8.css)`left:0;padding:${"var(--ds-space-075, 6px)"} 0;${'' /* NonEditableMargin overrides */ } & > div{margin:11px 0 3px ${"var(--ds-space-025, 2px)"};}${0, $5St1r.ReadViewContainer}{margin-left:0;line-height:1;}` : null}`;

});
const $f6a7c9af3be196db$export$195635d59130784a = 'issue-field-number.ui.issue-field-number';
const $f6a7c9af3be196db$export$5dadcbcc34de35f = 'issue-field-number.ui.issue-field-number--container';
const $f6a7c9af3be196db$export$ddb0dcfa9074309f = 'issue-field-number.ui.badge';
const $f6a7c9af3be196db$export$3cb3b73ace5de3d1 = `${$f6a7c9af3be196db$export$ddb0dcfa9074309f}-hover-container`;
const $f6a7c9af3be196db$export$ac421571f56485b8 = 'issue-field-number.edit.warning-icon';

const $ada2d6cf4ae575cf$export$1ff9623b26415f8 = 'INLINE';
const $ada2d6cf4ae575cf$export$44f42916442b37c3 = 'LOZENGE';
const $ada2d6cf4ae575cf$export$eade6b6091579183 = 'NORMAL';
const $ada2d6cf4ae575cf$export$797ed91ebb8db1c5 = 'CHILD_ISSUE_LOZENGE';

parcelRegister("eY8vu", function(module, exports) {

$parcel$export(module.exports, "useNumberField", () => $847782734a282d47$export$23f548e970bdf099);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $847782734a282d47$export$23f548e970bdf099 = ({ issueKey: issueKey, fieldKey: fieldKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, saveField: saveField })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'number');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        saveField: saveField
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("bHYrY", function(module, exports) {

$parcel$export(module.exports, "NumberEdit", () => $21f405aa5957688e$export$a902121087114074);

var $eUqFw = parcelRequire("eUqFw");

var $5YsMl = parcelRequire("5YsMl");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $cf2Y4 = parcelRequire("cf2Y4");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");


var $9OWHk = parcelRequire("9OWHk");
const $21f405aa5957688e$export$a902121087114074 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { isInvalid: isInvalid = false, type: type, defaultValue: defaultValue, ...rest } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const value = defaultValue === null ? '' : Number(defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $21f405aa5957688e$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        isCompact: true,
        "aria-label": formatMessage((0, $9OWHk.default).accessibleLabel),
        isInvalid: isInvalid,
        type: type,
        value: value,
        step: "any",
        autoFocus: true,
        elemAfterInput: isInvalid === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $21f405aa5957688e$var$warningWrapperStyles,
            testId: (0, $f6a7c9af3be196db$export$ac421571f56485b8)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            size: "medium",
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y300)})`,
            label: ""
        })) : null,
        ...rest
    }));
});
const $21f405aa5957688e$var$containerStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    cursor: 'auto'
});
const $21f405aa5957688e$var$warningWrapperStyles = (0, $1ZAYh.xcss)({
    marginLeft: "var(--ds-space-negative-050, -4px)",
    marginRight: "var(--ds-space-050, 4px)"
});

});
parcelRegister("9OWHk", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c06c48241b420dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9c06c48241b420dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "issue-field-number.error-title",
        "defaultMessage": "We couldn't set the story point value"
    },
    errorMessage: {
        "id": "issue-field-number.error-message",
        "defaultMessage": "You can try again in a few minutes, or refresh the page."
    },
    accessibleLabel: {
        "id": "issue-field-number.accessible-label",
        "defaultMessage": "Enter story point estimate"
    }
});

});


parcelRegister("6UA3n", function(module, exports) {

$parcel$export(module.exports, "NumberView", () => $72c87111b6cdadb5$export$3a0cbbcc23d8ca3d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $9nkwJ = parcelRequire("9nkwJ");

var $PdmhA = parcelRequire("PdmhA");

var $4ksts = parcelRequire("4ksts");

const $72c87111b6cdadb5$var$noValueText = '-';
const $72c87111b6cdadb5$export$3a0cbbcc23d8ca3d = ({ isEditable: isEditable, value: value, setIsEditing: setIsEditing })=>{
    const { formatNumber: formatNumber } = (0, $4ksts.useIntlV2)();
    const handleOnClick = (0, $eUqFw.useCallback)(()=>{
        setIsEditing?.(true);
    }, [
        setIsEditing
    ]);
    if (value === undefined) return null;
    const displayValue = value === null ? $72c87111b6cdadb5$var$noValueText : formatNumber(value);
    const BadgeComp = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        testId: (0, $f6a7c9af3be196db$export$ddb0dcfa9074309f)
    }, displayValue);
    const BadgeComponent = isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($72c87111b6cdadb5$var$HoverContainer, {
        "data-testid": `${(0, $f6a7c9af3be196db$export$ddb0dcfa9074309f)}-hover-container`,
        onClick: handleOnClick
    }, BadgeComp) : BadgeComp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($72c87111b6cdadb5$var$BadgeWrapper, null, BadgeComponent);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $72c87111b6cdadb5$var$HoverContainer = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "b6v085-0"
})({
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&:hover > span': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `${`var(--ds-text, ${(0, $PdmhA).N800})`} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `${`var(--ds-background-neutral-hovered, ${(0, $PdmhA).N90})`} !important`
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $72c87111b6cdadb5$var$BadgeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itj1ic",
            __cmplp.className
        ])
    });
});

});



parcelRegister("4DDvU", function(module, exports) {

$parcel$export(module.exports, "default", () => $71dd0a7381906413$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $5JqpU = parcelRequire("5JqpU");

var $fVCj0 = parcelRequire("fVCj0");

var $1TrR5 = parcelRequire("1TrR5");

var $aDBQh = parcelRequire("aDBQh");
const $71dd0a7381906413$var$onUpdateFactory = (0, $5iWql.default)((dispatch, fieldId)=>({
        // @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
        onUpdate: (value)=>dispatch((0, $fVCj0.sweetStateFieldUpdated)(fieldId, value))
    }));
var $71dd0a7381906413$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        additionalProps: (state, intl)=>({
                issueKey: (0, $5JqpU.issueKeySelector)(state),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                type: 'number',
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            }),
        additionalCallbacks: (0, $1TrR5.functionWithFFRedux)((dispatch)=>({
                onUpdate: $71dd0a7381906413$var$onUpdateFactory(dispatch, ownPropsOnMount.fieldId)
            }), // @ts-expect-error - TS2345 - Property 'clear' is missing in type '(this: any, dispatch: any)
        (dispatch)=>({
                // @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
                onUpdate: (value)=>dispatch((0, $fVCj0.sweetStateFieldUpdated)(ownPropsOnMount.fieldId, value))
            }))
    }))((0, $aDBQh.default));

});
parcelRegister("aDBQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3be484e8543ad413$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $9nkwJ = parcelRequire("9nkwJ");

var $4ksts = parcelRequire("4ksts");

var $9LvPd = parcelRequire("9LvPd");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $87GQt = parcelRequire("87GQt");
var $eY8vu = parcelRequire("eY8vu");

var $4bZws = parcelRequire("4bZws");

var $4xwq2 = parcelRequire("4xwq2");

var $7q3Z5 = parcelRequire("7q3Z5");

const $3be484e8543ad413$export$88b57365e3a3cb92 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("1Vqi3")), {
    moduleId: "./src/packages/issue/fields/number/src/index.tsx"
});
const $3be484e8543ad413$var$NumberView = ({ issueKey: issueKey, fieldId: fieldKey, label: label, noValueText: noValueText, onUpdate: onUpdate, showPinButton: showPinButton })=>{
    const [{ value: value }] = (0, $eY8vu.useNumberField)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $4ksts.useIntlV2)();
    const readView = // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'number' and 'string' have no overlap.
    value === null || value === '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), null, noValueText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), null, formatNumber(value));
    const editButtonLabel = formatMessage((0, $7q3Z5.messages).extendedEditButtonLabel, {
        inputFieldValue: value !== null ? value : noValueText,
        fieldName: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, label), issueKey !== undefined && fieldKey !== undefined && // @ts-expect-error label cannot be undefined, please pass it through when working on this code. If there is really no need then pass through an empty string :) */}
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldKey,
        label: label
    }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldKey,
        label: label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3be484e8543ad413$var$NumberFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $87GQt.IssueNumberFieldBoundary), {
        packageName: "issue",
        fallback: readView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3be484e8543ad413$export$88b57365e3a3cb92, {
        label: label,
        issueKey: issueKey,
        fieldKey: fieldKey,
        readView: readView,
        isFitContainerWidthReadView: true,
        onUpdate: onUpdate,
        editButtonLabel: editButtonLabel
    }))));
};
var $3be484e8543ad413$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($3be484e8543ad413$var$NumberView);
const $3be484e8543ad413$var$NumberFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $64ypR.SideBySideField), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_i5qy1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("87GQt", function(module, exports) {

$parcel$export(module.exports, "IssueNumberFieldBoundary", () => $0112f83c609a0972$export$5efed0d3367e90db);
$parcel$export(module.exports, "IssueNumberFieldReadonly", () => (parcelRequire("6UA3n")).NumberView);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $6UA3n = parcelRequire("6UA3n");

const $0112f83c609a0972$export$17e6ae9e4022a01f = (0, $7rh0R.lazy)(()=>Promise.resolve((parcelRequire("7vU0J"))), {
    moduleId: "./src/packages/issue/fields/number/src/ui/index.tsx"
});
const $0112f83c609a0972$export$e170b9657d273707 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-field-number",
        packageName: "jira-issue-field-number",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6UA3n.NumberView), {
                isEditable: props.isEditable !== undefined ? props.isEditable : false
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-field-number-readonly",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6UA3n.NumberView), {
            isEditable: props.isEditable !== undefined ? props.isEditable : false
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0112f83c609a0972$export$17e6ae9e4022a01f, props)));
const $0112f83c609a0972$export$5efed0d3367e90db = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "issue-number-field",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-number-field-boundary",
        fallback: fallback
    }, children));

});

parcelRegister("7q3Z5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $271d56eb28d5ffce$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $271d56eb28d5ffce$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    extendedEditButtonLabel: {
        "id": "issue-view-base.context.number-estimate.extended-edit-button-label",
        "defaultMessage": "Edit {fieldName}, currently {inputFieldValue}"
    }
});

});

parcelRegister("1Vqi3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('66oUu');
        const value = parcelRequire('41OSj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("66oUu").then(()=>parcelRequire('41OSj'));
}

});



parcelRegister("6ozze", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fe4e039f377689f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $5iWql = parcelRequire("5iWql");

var $iwsIy = parcelRequire("iwsIy");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $fiMQP = parcelRequire("fiMQP");

var $18KtE = parcelRequire("18KtE");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $3Fosa = parcelRequire("3Fosa");

var $fokFV = parcelRequire("fokFV");

var $3FyZ4 = parcelRequire("3FyZ4");

var $1TrR5 = parcelRequire("1TrR5");

var $7oJmH = parcelRequire("7oJmH");

var $jf2mO = parcelRequire("jf2mO");
const $8fe4e039f377689f$var$createSuccessEvent = ({ isSearchStringEmpty: isSearchStringEmpty })=>({
        source: 'issueView',
        action: 'succeeded',
        actionSubject: 'jsmOrganizationsFieldSearch',
        attributes: {
            isSearchStringEmpty: isSearchStringEmpty
        }
    });
// @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
const $8fe4e039f377689f$var$fireSearchSuccessEvent = async (analyticsEvent)=>{
    const client = await (0, $3FyZ4.getAnalyticsWebClientPromise)();
    client.getInstance().sendTrackEvent(analyticsEvent);
};
// we debounce the success event firing, to more accurately represent a complete search
// as opposed to a search which is triggered mid-way through a user's search term
const $8fe4e039f377689f$var$searchSuccessDebounceTime = 2000;
const $8fe4e039f377689f$var$debouncedFireSearchSuccessEvent = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))($8fe4e039f377689f$var$fireSearchSuccessEvent, $8fe4e039f377689f$var$searchSuccessDebounceTime, {
    leading: true,
    trailing: false
} // fire event on the leading edge of the debounce
);
const $8fe4e039f377689f$export$2b81811283cd2d9d = (0, $5iWql.default)((autoCompleteUrl)=>(query)=>{
        if (!autoCompleteUrl) return Promise.resolve([]);
        const url = `${autoCompleteUrl}${encodeURIComponent(query)}`;
        return (0, $2OdyW.default)(url).then((res)=>{
            $8fe4e039f377689f$var$debouncedFireSearchSuccessEvent($8fe4e039f377689f$var$createSuccessEvent({
                isSearchStringEmpty: query === ''
            }));
            return (0, $jf2mO.transformSuggestions)(res);
        }).catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'jsmOrganizationsFieldSearch',
                    // eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics
                    packageName: 'jiraIssueView'
                },
                error: error,
                attributes: {
                    isSearchStringEmpty: query === ''
                }
            });
            throw error;
        });
    });
const $8fe4e039f377689f$export$72a8b15fb4557735 = ({ baseUrl: baseUrl, issueKey: issueKey, fieldMetaKey: fieldMetaKey, value: value // eslint-disable-next-line @typescript-eslint/no-explicit-any
 })=>(0, $3Fosa.updateOrganization)(baseUrl, issueKey, fieldMetaKey, value);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8fe4e039f377689f$var$analyticsAttributeIdRetriever = (value)=>value && Array.isArray(value) ? value.map((org)=>org.id).join(',') : value;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8fe4e039f377689f$var$formatOptionLabelMemoized = (0, $5iWql.default)((intl)=>(option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiMQP.OptionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))), {
            label: intl.formatMessage((0, $7oJmH.default).organizationIconLabel)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiMQP.OptionLabel), null, option.content)));
const $8fe4e039f377689f$var$additionalPropsMemoized = (0, $5iWql.default)((ownPropsOnMount)=>(state, intl)=>{
        const fieldAutoCompleteUrlSelectorGetter = (0, $fokFV.fieldAutoCompleteUrlSelector)(ownPropsOnMount.fieldId);
        return {
            tagAppearance: 'rounded',
            formatOptionLabel: $8fe4e039f377689f$var$formatOptionLabelMemoized(intl),
            classNamePrefix: 'organizations-field',
            fetchSuggestions: $8fe4e039f377689f$export$2b81811283cd2d9d(fieldAutoCompleteUrlSelectorGetter(state)),
            placeholder: intl.formatMessage((0, $7oJmH.default).placeholder),
            noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
            analyticsAttributeIdRetriever: $8fe4e039f377689f$var$analyticsAttributeIdRetriever,
            showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
        };
    });
const $8fe4e039f377689f$var$connectFieldNext = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $jf2mO.transformFromStateValue,
        transformToStateValue: $jf2mO.transformToStateValue,
        saveField: $8fe4e039f377689f$export$72a8b15fb4557735,
        additionalProps: $8fe4e039f377689f$var$additionalPropsMemoized(ownPropsOnMount)
    }));
const $8fe4e039f377689f$var$connectFieldPrev = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>{
    const fieldAutoCompleteUrlSelectorGetter = (0, $fokFV.fieldAutoCompleteUrlSelector)(ownPropsOnMount.fieldId);
    return {
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $jf2mO.transformFromStateValue,
        transformToStateValue: $jf2mO.transformToStateValue,
        saveField: $8fe4e039f377689f$export$72a8b15fb4557735,
        additionalProps: (state, intl)=>({
                tagAppearance: 'rounded',
                // @ts-expect-error - TS7006 - Parameter 'option' implicitly has an 'any' type.
                formatOptionLabel: (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiMQP.OptionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))), {
                        label: intl.formatMessage((0, $7oJmH.default).organizationIconLabel)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiMQP.OptionLabel), null, option.content)),
                classNamePrefix: 'organizations-field',
                fetchSuggestions: $8fe4e039f377689f$export$2b81811283cd2d9d(fieldAutoCompleteUrlSelectorGetter(state)),
                placeholder: intl.formatMessage((0, $7oJmH.default).placeholder),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                analyticsAttributeIdRetriever: $8fe4e039f377689f$var$analyticsAttributeIdRetriever,
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            })
    };
});
var $8fe4e039f377689f$export$2e2bcd8739ae039 = (0, $1TrR5.functionWithFFRedux)($8fe4e039f377689f$var$connectFieldNext, $8fe4e039f377689f$var$connectFieldPrev)((0, $18KtE.default));

});
parcelRegister("3Fosa", function(module, exports) {

$parcel$export(module.exports, "updateOrganization", () => $0c20950f49d93102$export$3f4430ea1068bd7f);

var $lRmyA = parcelRequire("lRmyA");

var $lV5H0 = parcelRequire("lV5H0");
const $0c20950f49d93102$export$3f4430ea1068bd7f = (baseUrl, issueKey, fieldMetaKey, value)=>(0, $lRmyA.performPutRequest)((0, $lV5H0.getIssueApiUrl)(baseUrl, issueKey), {
        body: JSON.stringify({
            fields: {
                [fieldMetaKey]: value.map((org)=>Number(org.id))
            }
        })
    });

});

parcelRegister("7oJmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $437973f4aa11c286$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $437973f4aa11c286$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.organizations.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "Select the Organizations"
    },
    organizationIconLabel: {
        "id": "issue.organizations.organization-icon-label",
        "defaultMessage": "Organization icon"
    }
});

});

parcelRegister("jf2mO", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $73778de89267c3db$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $73778de89267c3db$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformSuggestions", () => $73778de89267c3db$export$1d0ee4320c26fb60);

var $eUqFw = parcelRequire("eUqFw");

var $iwsIy = parcelRequire("iwsIy");
const $73778de89267c3db$var$toItem = (organization)=>({
        value: organization.id,
        content: organization.name,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))), {
            label: ""
        })
    });
const $73778de89267c3db$export$cb172b2468ab5652 = (stateValues)=>{
    if (!stateValues) return [];
    return stateValues.map($73778de89267c3db$var$toItem);
};
const $73778de89267c3db$export$1cfcb95cb8fbddb3 = (value)=>value && value.map((item)=>({
            id: item.value,
            name: item.content
        }));
const $73778de89267c3db$export$1d0ee4320c26fb60 = (suggestionsFromServer)=>[
        {
            items: suggestionsFromServer.map($73778de89267c3db$var$toItem)
        }
    ];

});


parcelRegister("4kMbu", function(module, exports) {

$parcel$export(module.exports, "default", () => $704e54f0c65d15bc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $dUqHv = parcelRequire("dUqHv");

var $fVCj0 = parcelRequire("fVCj0");

var $lO4Or = parcelRequire("lO4Or");

var $5zSUY = parcelRequire("5zSUY");

var $1TrR5 = parcelRequire("1TrR5");

var $kLhiV = parcelRequire("kLhiV");
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ const $704e54f0c65d15bc$var$messages = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.time-estimate.placeholder-for-the-field",
        "defaultMessage": "2w 4d 6h 45m"
    }
});
const $704e54f0c65d15bc$var$invalidTimeFormatMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
    id: "issue.time-estimate.input-time-string-is-invalid",
    defaultMessage: "Your estimate must be in the format {format}.",
    values: {
        format: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, "2w 4d 6h 45m")
    }
});
const $704e54f0c65d15bc$var$onUpdateFactory = (0, $5iWql.default)(// @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
(dispatch, fieldId)=>(value)=>dispatch((0, $fVCj0.sweetStateFieldUpdated)(fieldId, value)));
var $704e54f0c65d15bc$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        // This field is not optimistic because updating this field can trigger an update to the
        // Time tracking field (when Time tracking has no remaining time). Using a non-optimistic
        // field forces the app data to refresh so we can fetch the updated Time tracking state.
        isOptimistic: false,
        additionalProps: (state, intl)=>({
                config: (0, $dUqHv.timeTrackingConfigurationSelector)(state),
                placeholder: intl.formatMessage($704e54f0c65d15bc$var$messages.placeholder),
                issueKey: (0, $5JqpU.issueKeySelector)(state),
                issueId: (0, $5JqpU.issueIdSelector)(state),
                timeTrackingValue: (0, $fokFV.fieldEditingValueSelector)((0, $lO4Or.TIME_TRACKING_TYPE))(state),
                isEditable: (0, $fokFV.isFieldEditableSelector)(ownPropsOnMount.fieldId)(state) && !!(0, $5zSUY.default)(),
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area),
                invalidTimeFormatMessage: $704e54f0c65d15bc$var$invalidTimeFormatMessage
            }),
        additionalCallbacks: (0, $1TrR5.functionWithFFRedux)((dispatch)=>({
                onUpdate: $704e54f0c65d15bc$var$onUpdateFactory(dispatch, ownPropsOnMount.fieldId)
            }), (dispatch)=>({
                onUpdate: (value)=>dispatch((0, $fVCj0.sweetStateFieldUpdated)(ownPropsOnMount.fieldId, value))
            }))
    }))((0, $kLhiV.default));

});
parcelRegister("kLhiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e6a2891d17c62f2$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $7jM0B = parcelRequire("7jM0B");

var $4bZws = parcelRequire("4bZws");
const $7e6a2891d17c62f2$export$20bcfa76782d005e = ({ isEditable: isEditable, isMobile: isMobile, config: config, fieldId: fieldId, invalidTimeFormatMessage: invalidTimeFormatMessage, issueId: issueId, issueKey: issueKey, label: label, placeholder: placeholder, timeTrackingValue: timeTrackingValue, showPinButton: showPinButton, onUpdate: onUpdate })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e6a2891d17c62f2$var$OriginalEstimateFieldWrapper, {
        "data-testid": `issue-view.issue-base.context.original-estimate.${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, label), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldId,
        label: label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jM0B.default), {
        isEditable: isEditable,
        isFitContainerWidthReadView: true,
        isMobile: isMobile,
        config: config,
        fieldId: fieldId,
        invalidTimeFormatMessage: invalidTimeFormatMessage,
        issueId: issueId,
        issueKey: issueKey,
        label: label,
        placeholder: placeholder,
        timeTrackingValue: timeTrackingValue,
        onUpdate: onUpdate
    })));
var $7e6a2891d17c62f2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($7e6a2891d17c62f2$export$20bcfa76782d005e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e6a2891d17c62f2$var$OriginalEstimateFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $64ypR.FieldWrapper), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16ep1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7jM0B", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "actionSubject", () => $99e81782a4f6dee1$export$fd8ebf59dd2b58b6);
$parcel$export(module.exports, "default", () => $99e81782a4f6dee1$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ReadViewContainer", () => $99e81782a4f6dee1$export$ebb3489b83262b26);
$parcel$export(module.exports, "BacklogStylesWrapper", () => $99e81782a4f6dee1$export$93bfa56d55cdb259);
$parcel$export(module.exports, "OriginalEstimateInlineEditContainer", () => $99e81782a4f6dee1$export$11102d50437c0b62);
$parcel$export(module.exports, "FieldInlineEditStateLessContainer", () => $99e81782a4f6dee1$export$e23f4412d23f001d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $h9cCP = parcelRequire("h9cCP");

var $1ybV0 = parcelRequire("1ybV0");

var $4ksts = parcelRequire("4ksts");

var $dWGNJ = parcelRequire("dWGNJ");

var $6oQPP = parcelRequire("6oQPP");
var $5St1r = parcelRequire("5St1r");

var $7Ymv3 = parcelRequire("7Ymv3");

var $jMP2a = parcelRequire("jMP2a");

var $6vrw7 = parcelRequire("6vrw7");

var $7v0hO = parcelRequire("7v0hO");

var $4m29m = parcelRequire("4m29m");

var $dKMPW = parcelRequire("dKMPW");

var $6feMv = parcelRequire("6feMv");

var $k8NVh = parcelRequire("k8NVh");
const $99e81782a4f6dee1$export$fd8ebf59dd2b58b6 = 'originalEstimateInlineEdit';
var $99e81782a4f6dee1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { isMobile: isMobile, config: config, editView: editView, fieldId: fieldId, issueId: issueId, issueKey: issueKey, onUpdate: onUpdate, onFailure: onFailure, onSubmit: onSubmit, placeholder: placeholder, readView: readView, timeTrackingValue: timeTrackingValue, invalidTimeFormatMessage: invalidTimeFormatMessage, onCancel: onCancel, onConfirm: onConfirm, onEdit: onEdit, onEnter: onEnter, onEscape: onEscape, isBacklogComponent: isBacklogComponent = false, ...rest } = props;
    const [{ value: initialValue, error: error, fieldConfig: fieldConfig }, { saveValue: saveValue, resetError: resetError }] = (0, $dKMPW.useOriginalEstimateField)({
        fieldId: fieldId,
        issueId: issueId && (0, $6vrw7.toIssueId)(issueId),
        issueKey: (0, $6vrw7.toIssueKey)(issueKey),
        onSuccess: onUpdate,
        onFailure: onFailure,
        onSubmit: onSubmit,
        timeTrackingValue: timeTrackingValue
    });
    const [isEditing, setIsEditing] = (0, $eUqFw.useState)(false); // Set Initial Value to prevent the value from displaying 0m
    const [timeValue, setTimeValue] = (0, $eUqFw.useState)(initialValue);
    const [inputTime, setInputTime] = (0, $eUqFw.useState)('');
    const [isInvalidInput, setIsInvalidInput] = (0, $eUqFw.useState)(false);
    const intl = (0, $4ksts.useIntlV2)();
    const timeString = (0, $eUqFw.useMemo)(()=>{
        // At this time we need to force the value into an english formatted
        // time string eg: `1w 1d 1h 1m` as that is the only format supported
        // on entry, future changes will support localised values.
        const intlForTimeTrackingInput = {
            ...intl,
            // @ts-expect-error - TS7031 - Binding element 'defaultMessage' implicitly has an 'any' type.
            formatMessage: ({ defaultMessage: defaultMessage })=>defaultMessage || ''
        };
        return (0, $7v0hO.timeTrackingFormatter)(// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'number'.
        timeValue || 0, {
            workingHoursPerDay: config.hoursPerDay,
            workingDaysPerWeek: config.daysPerWeek,
            timeFormat: config.format || (0, $h9cCP.PRETTY),
            defaultUnit: config.defaultUnit
        }, intlForTimeTrackingInput);
    }, [
        config,
        intl,
        timeValue
    ]);
    const readTimeString = (0, $eUqFw.useMemo)(()=>(0, $7v0hO.timeTrackingFormatter)(// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'number'.
        timeValue || 0, {
            workingHoursPerDay: config.hoursPerDay,
            workingDaysPerWeek: config.daysPerWeek,
            timeFormat: config.format || (0, $h9cCP.PRETTY),
            defaultUnit: config.defaultUnit
        }, intl), [
        config,
        intl,
        timeValue
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setInputTime(timeString);
    }, [
        timeString
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setTimeValue(initialValue);
    }, [
        initialValue
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) setIsEditing(true);
    }, [
        error
    ]);
    const isFieldEditable = fieldConfig?.isEditable ?? false;
    const save = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        if (inputTime === timeString) {
            setIsEditing(false);
            return;
        }
        if ((0, $7Ymv3.isValidTimeString)(config)(inputTime)) {
            const newTimeValue = (0, $7Ymv3.parseTimeString)(config)(inputTime);
            saveValue(newTimeValue, null, analyticsEvent);
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
            setIsInvalidInput(false);
            setIsEditing(false);
        } else {
            setIsInvalidInput(true);
            setIsEditing(true);
        }
    }, [
        inputTime,
        timeString,
        config,
        saveValue
    ]);
    const cancel = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        resetError();
        setIsInvalidInput(false);
        setIsEditing(false);
        setInputTime(timeString);
        setTimeValue(initialValue);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        initialValue,
        resetError,
        timeString
    ]);
    const onCancelRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onCancel?.(analyticsEvent);
    }, [
        onCancel,
        cancel
    ]);
    const onConfirmRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        save(analyticsEvent);
        onConfirm?.(analyticsEvent);
    }, [
        save,
        onConfirm
    ]);
    const onEditRequested = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        setIsEditing(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onEdit?.(analyticsEvent);
    }, [
        onEdit
    ]);
    const onEscapeRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onEscape?.(analyticsEvent);
    }, [
        onEscape,
        cancel
    ]);
    const onChange = (0, $eUqFw.useCallback)((event)=>{
        const { value: newStringValue } = event.target;
        setIsInvalidInput(false);
        resetError();
        setInputTime(newStringValue);
    }, [
        resetError,
        setInputTime
    ]);
    const renderReadView = (0, $eUqFw.useCallback)(()=>{
        const view = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8NVh.OriginalEstimateView), {
            value: readTimeString,
            isEditable: isFieldEditable
        });
        if (!isBacklogComponent || !isFieldEditable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($99e81782a4f6dee1$export$ebb3489b83262b26, {
            isEditable: isFieldEditable,
            compactMarginTop: isBacklogComponent
        }, view);
        return view;
    }, [
        isFieldEditable,
        readTimeString,
        isBacklogComponent
    ]);
    const renderEditView = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $99e81782a4f6dee1$var$originalEstimateEditContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6feMv.OriginalEstimateEdit), {
            isInvalidInput: isInvalidInput,
            invalidTimeFormatMessage: invalidTimeFormatMessage,
            placeholder: placeholder,
            value: inputTime,
            onChange: onChange,
            isCompact: isBacklogComponent
        })), [
        inputTime,
        invalidTimeFormatMessage,
        isInvalidInput,
        onChange,
        placeholder,
        isBacklogComponent
    ]);
    const renderErrorFlag = ()=>{
        if (!error) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
            error: error,
            title: (0, $4m29m.default).errorTitle,
            description: (0, $4m29m.default).errorMessage
        });
    };
    const InlineEditContainer = isBacklogComponent ? $99e81782a4f6dee1$export$93bfa56d55cdb259 : $99e81782a4f6dee1$export$11102d50437c0b62;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, error && renderErrorFlag(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InlineEditContainer, {
        isEditing: isEditing,
        isEditable: isFieldEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($99e81782a4f6dee1$export$e23f4412d23f001d, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        actionSubject: $99e81782a4f6dee1$export$fd8ebf59dd2b58b6,
        isEditing: isEditing,
        readView: renderReadView(),
        editView: isFieldEditable ? renderEditView() : null,
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onEdit: onEditRequested,
        onEscape: onEscapeRequest,
        ...rest,
        isEditable: isFieldEditable
    }))));
});
const $99e81782a4f6dee1$var$backlogStylesReverseMarginTop = '-1px'; // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
const $99e81782a4f6dee1$export$ebb3489b83262b26 = /*#__PURE__*/ (0, $kwce8.default)((0, $5St1r.ReadViewContainer)).withConfig({
    componentId: "sc-1re0dq2-0"
})`${({ isEditable: isEditable, compactTopMargin: compactTopMargin })=>!isEditable ? // eslint-disable-next-line jira/compiled/styled-components-usages
    (0, $kwce8.css)({
        paddingRight: "var(--ds-space-025, 2px)",
        marginRight: "var(--ds-space-050, 4px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginTop: compactTopMargin ? "var(--ds-space-negative-100, -8px)" : undefined
    }) : null}`; // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $99e81782a4f6dee1$export$e23f4412d23f001d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f31b66",
            __cmplp.className
        ])
    });
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
const $99e81782a4f6dee1$export$93bfa56d55cdb259 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1re0dq2-1"
})`& form > div{margin-top:0;}${'' /* Prevent width increase before edit container renders */ } ${$99e81782a4f6dee1$export$ebb3489b83262b26}{left:0;padding-right:0;margin-right:0;}${'' /* Input focus style fix */ } & div[data-read-view-fit-container-width]{background:transparent !important;border:none !important;vertical-align:${()=>(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? 'top' // not perfectly vertically centered without this
     : undefined};}& button[aria-label='Edit']:focus + div > div:first-child{border:2px solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`};border-radius:${()=>(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? "var(--ds-border-radius-300, 12px)" : '2em'};padding:${"var(--ds-space-025, 2px)"};margin-top:-10px;margin-bottom:-10px;margin-left:${()=>(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? '-2px' : "var(--ds-space-negative-025, -2px)"};margin-right:${()=>(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? '-6px' : "var(--ds-space-negative-075, -6px)"};}${({ isEditable: isEditable })=>!isEditable ? // eslint-disable-next-line jira/compiled/styled-components-usages
    (0, $kwce8.css)({
        // targets the non-editable wrapper for backlog :S
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            marginTop: 0
        },
        // NonEditableMargin overrides
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div > div': {
            margin: `${$99e81782a4f6dee1$var$backlogStylesReverseMarginTop} 0 0`
        }
    }) : null}`; // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-css-tagged-template-expression
const $99e81782a4f6dee1$var$nonEditableStyles = /*#__PURE__*/ (0, $kwce8.css)`margin-left:${"var(--ds-space-negative-025, -2px)"};${'' /* NonEditableMargin overrides */ } & > div{margin-left:0;}${$99e81782a4f6dee1$export$ebb3489b83262b26}{line-height:1;left:0;padding:3px 0px 3px 0px;}`; // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
const $99e81782a4f6dee1$export$11102d50437c0b62 = /*#__PURE__*/ (0, $kwce8.default)(// @ts-expect-error - TS2345 - Argument of type 'StyledComponentClass'
(0, $5St1r.InlineEditContainer)).withConfig({
    componentId: "sc-1re0dq2-2"
})`${({ isEditable: isEditable })=>!isEditable && $99e81782a4f6dee1$var$nonEditableStyles}`;
const $99e81782a4f6dee1$var$originalEstimateEditContainerStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.075'
});

});
parcelRegister("4m29m", function(module, exports) {

$parcel$export(module.exports, "default", () => $1672f0318a0324d5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1672f0318a0324d5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "issue-field-original-estimate.error-title",
        "defaultMessage": "We couldn't set the original estimate value"
    },
    errorMessage: {
        "id": "issue-field-original-estimate.error-message",
        "defaultMessage": "You can try again in a few minutes, or refresh the page."
    }
});

});

parcelRegister("dKMPW", function(module, exports) {

$parcel$export(module.exports, "saveField", () => $899c478b0ef30ec3$export$72a8b15fb4557735);
$parcel$export(module.exports, "useOriginalEstimateField", () => $899c478b0ef30ec3$export$ce089f5e05395af0);

var $53ciZ = parcelRequire("53ciZ");

var $lRmyA = parcelRequire("lRmyA");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $eDEru = parcelRequire("eDEru");

var $5zSUY = parcelRequire("5zSUY");

var $9JAdq = parcelRequire("9JAdq");
const $899c478b0ef30ec3$export$347b6dd45094a5fd = (timeTrackingValue)=>{
    const hasTimeLogged = timeTrackingValue?.timeSpentSeconds != null;
    const hasTimeRemainUpdated = timeTrackingValue?.remainingEstimateSeconds != null && timeTrackingValue?.remainingEstimateSeconds !== timeTrackingValue?.originalEstimateSeconds;
    return hasTimeLogged || hasTimeRemainUpdated;
};
const $899c478b0ef30ec3$export$72a8b15fb4557735 = async ({ issueId: issueId, newValue: newValue, timeTrackingValue: timeTrackingValue })=>{
    const hasTimeRemainingEstimate = $899c478b0ef30ec3$export$347b6dd45094a5fd(timeTrackingValue);
    // Convert the value in seconds to a time string to send to Jira.
    // 1m is always 60s, so we can do this safely.
    // we have to convert the final value to a whole number as passing decimal
    // values in minutes errors.
    const value = newValue !== null ? (0, $eDEru.secondsToWholeMinuteTimeString)(newValue) : null;
    // https://jdog.jira-dev.com/browse/BENTO-792 - The Time Estimate field is always shown,
    // because we always the return the timeoriginalestimate field from the backend. In order to
    // prevent the field from being visible but not editable when Time Tracking is missing from the
    // screen config, we use this legacy endpoint to save the field.
    return (0, $lRmyA.performPostRequest)('/secure/AjaxIssueAction.jspa?decorator=none', {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: (0, $53ciZ.stringify)({
            issueId: issueId,
            timetracking_originalestimate: value,
            timetracking_targetsubfield: hasTimeRemainingEstimate ? 'timetracking_originalestimate' : undefined,
            ...(0, $9JAdq.originalEstimateBodyParams),
            singleFieldEdit: true,
            skipScreenCheck: true,
            atl_token: (0, $5zSUY.default)()
        })
    });
};
const $899c478b0ef30ec3$export$ce089f5e05395af0 = ({ issueKey: issueKey, issueId: issueId, fieldId: fieldId, timeTrackingValue: timeTrackingValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldId);
    const fieldType = fieldConfig?.schema.system || '';
    const saveClassicField = (_, __, newValue)=>$899c478b0ef30ec3$export$72a8b15fb4557735({
            issueId: issueId,
            newValue: newValue,
            timeTrackingValue: timeTrackingValue
        });
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldId,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        saveField: saveClassicField,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onSubmit: onSubmit
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("6feMv", function(module, exports) {

$parcel$export(module.exports, "OriginalEstimateEdit", () => $d3d068b2e69895e7$export$f73bd095365346a2);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");

var $jzS9W = parcelRequire("jzS9W");

var $9JAdq = parcelRequire("9JAdq");
const $d3d068b2e69895e7$export$f73bd095365346a2 = ({ testId: testId = (0, $9JAdq.originalEstimateEditTestId), isInvalidInput: isInvalidInput, invalidTimeFormatMessage: invalidTimeFormatMessage, placeholder: placeholder, value: value, onChange: onChange, isCompact: isCompact = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3d068b2e69895e7$var$Container, {
        "data-testid": testId,
        isCompact: isCompact
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jzS9W.default), {
        compact: true,
        type: "text",
        value: value,
        placeholder: placeholder,
        onChange: onChange,
        invalidMessage: isInvalidInput ? invalidTimeFormatMessage : undefined
    }));
var $d3d068b2e69895e7$export$2e2bcd8739ae039 = $d3d068b2e69895e7$export$f73bd095365346a2;
const $d3d068b2e69895e7$export$8f73a906779c0fb6 = (0, $c9TLT.gridSize) * 14.5;
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $d3d068b2e69895e7$var$Container = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1csw1l8-0"
})(({ isCompact: isCompact })=>({
        cursor: 'auto',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: isCompact ? `${$d3d068b2e69895e7$export$8f73a906779c0fb6}px` : '100%'
    }));

});




parcelRegister("g8COw", function(module, exports) {

$parcel$export(module.exports, "default", () => $01cc4546b200eb31$export$2e2bcd8739ae039);

var $bXRPD = parcelRequire("bXRPD");
var $01cc4546b200eb31$export$2e2bcd8739ae039 = (0, $bXRPD.default);

});
parcelRegister("bXRPD", function(module, exports) {

$parcel$export(module.exports, "default", () => $675b0b2cba205435$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $9LvPd = parcelRequire("9LvPd");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $d9Uys = parcelRequire("d9Uys");
var $4nN7J = parcelRequire("4nN7J");
var $DX7su = parcelRequire("DX7su");

var $4bZws = parcelRequire("4bZws");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $9Nizy = parcelRequire("9Nizy");
const $675b0b2cba205435$var$Parent = ({ fieldId: fieldKey, label: label, area: area, onConfirm: onConfirm })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const showPinButton = (0, $hHKWU.default)(area);
    const [{ fieldConfig: fieldConfig }] = (0, $DX7su.useParentField)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldLabel = fieldConfig?.title || label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, fieldLabel), issueKey !== undefined && fieldKey !== undefined && // @ts-expect-error label is required, please pass it through when working on this code.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldKey
    }), (0, $9Nizy.isChangeboardingForParentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9Uys.Changeboarding), null), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldKey,
        label: fieldLabel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4nN7J.ParentField), {
        isFitContainerWidthReadView: true,
        issueKey: issueKey,
        fieldKey: fieldKey,
        noValueText: formatMessage((0, $huhk2.genericMessages).noValue),
        onConfirm: onConfirm,
        isExistingIssue: true
    })));
};
var $675b0b2cba205435$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($675b0b2cba205435$var$Parent);

});
parcelRegister("d9Uys", function(module, exports) {

$parcel$export(module.exports, "Changeboarding", () => $2b58ec9c229c5623$export$d7cfba75deb33e5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $ffiyv = parcelRequire("ffiyv");

var $aO9bw = parcelRequire("aO9bw");
var $1U6Rx = parcelRequire("1U6Rx");
var $8sN8t = parcelRequire("8sN8t");
var $8NdH4 = parcelRequire("8NdH4");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lcnyw = parcelRequire("lcnyw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $dxcfv = parcelRequire("dxcfv");

var $1rtMV = parcelRequire("1rtMV");

var $d8va8 = parcelRequire("d8va8");

var $aZZKa = parcelRequire("aZZKa");

var $eGo1D = parcelRequire("eGo1D");
const $2b58ec9c229c5623$var$PARENT_CHANGEBOARDING_UI_EVENT = 'parentFieldChangeboarding';
const $2b58ec9c229c5623$export$8f7c37cb3352ceb8 = 'https://community.atlassian.com/t5/Jira-Software-articles/Introducing-the-new-Parent-field-in-company-managed-projects/ba-p/2377758';
const $2b58ec9c229c5623$export$f960f87b7b043226 = 'https://support.atlassian.com/jira-cloud-administration/docs/what-are-issue-types/#What-are-parent-and-child-issues';
const $2b58ec9c229c5623$export$d7cfba75deb33e5 = (props)=>{
    const { leftPosition: leftPosition } = props; // setting the default to true to avoid new/seen flicker in the long run.
    const [changeboardingDismissed, setChangeboardingDismissed] = (0, $eUqFw.useState)(true);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eUqFw.useState)(false);
    const accountId = (0, $dxcfv.useAccountId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (accountId != null) (0, $eGo1D.getUserProperty)(accountId).then((hasDismissed)=>setChangeboardingDismissed(hasDismissed));
    }, [
        accountId
    ]);
    const onClickNewLozenge = (0, $eUqFw.useCallback)(()=>{
        setIsSpotlightActive(true);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'lozenge'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $2b58ec9c229c5623$var$PARENT_CHANGEBOARDING_UI_EVENT);
    }, [
        setIsSpotlightActive,
        createAnalyticsEvent
    ]);
    const onClickInfo = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(!isOpen);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'infoButton'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $2b58ec9c229c5623$var$PARENT_CHANGEBOARDING_UI_EVENT);
    }, [
        isOpen,
        setIsOpen,
        createAnalyticsEvent
    ]);
    const onInfolinkClicked = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'learnMoreLink'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $2b58ec9c229c5623$var$PARENT_CHANGEBOARDING_UI_EVENT);
    }, [
        createAnalyticsEvent
    ]);
    const onDismiss = (0, $eUqFw.useCallback)(()=>{
        if (accountId != null) {
            setChangeboardingDismissed(true);
            (0, $eGo1D.setUserProperty)(accountId);
        }
    }, [
        setChangeboardingDismissed,
        accountId
    ]);
    const newLearnMore = (0, $eUqFw.useCallback)(()=>{
        setIsSpotlightActive(false);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'newLearnMoreLink'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $2b58ec9c229c5623$var$PARENT_CHANGEBOARDING_UI_EVENT);
        onDismiss();
    }, [
        setIsSpotlightActive,
        onDismiss,
        createAnalyticsEvent
    ]);
    const newDismiss = (0, $eUqFw.useCallback)(()=>{
        setIsSpotlightActive(false);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'okButton'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $2b58ec9c229c5623$var$PARENT_CHANGEBOARDING_UI_EVENT);
        onDismiss();
    }, [
        setIsSpotlightActive,
        onDismiss,
        createAnalyticsEvent
    ]);
    return changeboardingDismissed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        shouldRenderToParent: true,
        placement: "right",
        zIndex: (0, $lcnyw.layers).tooltip(),
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $2b58ec9c229c5623$var$popupContentStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $aZZKa.default).infoMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), {
                ref: setInitialFocusRef,
                target: "_blank",
                href: $2b58ec9c229c5623$export$f960f87b7b043226,
                onClick: ()=>onInfolinkClicked()
            }, formatMessage((0, $aZZKa.default).infoLearnMore)))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: [
                    leftPosition ? (0, $1ZAYh.xcss)({
                        position: 'absolute',
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                        left: `${leftPosition}px`,
                        top: '3px'
                    }) : undefined,
                    $2b58ec9c229c5623$var$infoButtonContainerStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                appearance: "subtle-link",
                "data-ds--inline-message--button": true,
                spacing: "none",
                isSelected: isOpen,
                onClick: ()=>onClickInfo(),
                "aria-label": formatMessage((0, $aZZKa.default).spotligthLearnMore)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d8va8.default), null)))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1U6Rx.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
        name: "parent-field-new"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            leftPosition ? (0, $1ZAYh.xcss)({
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                left: `${leftPosition}px`,
                top: '3px'
            }) : undefined,
            $2b58ec9c229c5623$var$newButtonContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        spacing: "none",
        appearance: "subtle-link",
        onClick: ()=>onClickNewLozenge()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "new" // @ts-expect-error Property 'css' does not exist on type 'IntrinsicAttributes & LozengeProps'.ts(2322)
        ,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $7JEyt.default)([
            "_vwz4gktf"
        ])
    }, formatMessage((0, $aZZKa.default).newLabel))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8NdH4.default), null, isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aO9bw.default), {
        pulse: false,
        dialogPlacement: "right middle",
        dialogWidth: 350,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($1rtMV))),
        actions: [
            {
                onClick: ()=>newDismiss(),
                text: formatMessage((0, $aZZKa.default).ok)
            },
            {
                onClick: ()=>newLearnMore(),
                text: formatMessage((0, $aZZKa.default).spotligthLearnMore),
                href: $2b58ec9c229c5623$export$8f7c37cb3352ceb8,
                target: '_blank',
                appearance: 'subtle'
            }
        ],
        heading: "",
        target: "parent-field-new",
        key: "parent-field-new",
        targetRadius: 3
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $aZZKa.default).spotlightMessage,
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
        }
    })))));
};
const $2b58ec9c229c5623$var$infoButtonContainerStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-latest-xcss-syntax
    marginTop: '-1px',
    display: 'inline-block'
});
const $2b58ec9c229c5623$var$newButtonLozengeStyles = null;
const $2b58ec9c229c5623$var$newButtonContainerStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-latest-xcss-syntax
    marginTop: '-3px',
    // eslint-disable-next-line @atlaskit/design-system/use-latest-xcss-syntax
    marginBottom: '-1px',
    marginLeft: 'space.050',
    marginRight: '0',
    display: 'inline-block'
});
const $2b58ec9c229c5623$var$popupContentStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.250',
    paddingRight: 'space.250',
    width: '300px'
});

});
parcelRegister("1rtMV", function(module, exports) {
module.exports = new URL("hieararchy-animation.763a6bfd.gif", import.meta.url).toString();

});

parcelRegister("d8va8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8924d5c8fdd85c41$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $8924d5c8fdd85c41$var$InfoIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "issue-field-parent.ui.changeboarding.assets.icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12ZM6 10.6667C8.57733 10.6667 10.6667 8.57733 10.6667 6C10.6667 3.42267 8.57733 1.33333 6 1.33333C3.42267 1.33333 1.33333 3.42267 1.33333 6C1.33333 8.57733 3.42267 10.6667 6 10.6667ZM6 9.33333C5.65811 9.33333 5.37633 9.07597 5.33782 8.74441L5.33333 8.66667V6C5.33333 5.63181 5.63181 5.33333 6 5.33333C6.34189 5.33333 6.62367 5.59069 6.66218 5.92225L6.66667 6V8.66667C6.66667 9.03486 6.36819 9.33333 6 9.33333Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 2.66667C5.53976 2.66667 5.16667 3.03976 5.16667 3.5C5.16667 3.96024 5.53976 4.33333 6 4.33333C6.46024 4.33333 6.83333 3.96024 6.83333 3.5C6.83333 3.03976 6.46024 2.66667 6 2.66667Z",
        fill: "currentColor"
    }));
var $8924d5c8fdd85c41$export$2e2bcd8739ae039 = $8924d5c8fdd85c41$var$InfoIcon;

});

parcelRegister("aZZKa", function(module, exports) {

$parcel$export(module.exports, "default", () => $592fafeca2c728e3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $592fafeca2c728e3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    newLabel: {
        "id": "issue-field-parent.changeboarding.new-label",
        "defaultMessage": "New"
    },
    icon: {
        "id": "issue-field-parent.changeboarding.icon",
        "defaultMessage": "{issueType} icon"
    },
    spotlightMessage: {
        "id": "issue-field-parent.changeboarding.spotlight-message",
        "defaultMessage": "The <strong>Parent</strong> field has replaced <strong>Epic Link</strong> and <strong>Parent Link</strong>. It works in the same way."
    },
    spotligthLearnMore: {
        "id": "issue-field-parent.changeboarding.spotligth-learn-more",
        "defaultMessage": "Information on the parent field"
    },
    infoMessage: {
        "id": "issue-field-parent.changeboarding.info-message",
        "defaultMessage": "Your issue type hierarchy determines the issues you can select here."
    },
    infoLearnMore: {
        "id": "issue-field-parent.changeboarding.info-learn-more",
        "defaultMessage": "Learn more about parent issues"
    },
    ok: {
        "id": "issue-field-parent.changeboarding.ok",
        "defaultMessage": "OK"
    },
    parentFieldInfoTitle: {
        "id": "issue-field-parent.changeboarding.parent-field-info-title",
        "defaultMessage": "Parent field information"
    }
});

});

parcelRegister("eGo1D", function(module, exports) {

$parcel$export(module.exports, "setUserProperty", () => $8276a70a04cf6ae6$export$ba821ce5e177c7ef);
$parcel$export(module.exports, "getUserProperty", () => $8276a70a04cf6ae6$export$b3126db2ef6e34ed);

var $lRmyA = parcelRequire("lRmyA");
const $8276a70a04cf6ae6$export$bb10a02fc2feb574 = 'jira.user.parent-field.changeboarding';
const $8276a70a04cf6ae6$var$getUserUrl = (accountId)=>`/rest/api/3/user/properties/${$8276a70a04cf6ae6$export$bb10a02fc2feb574}?accountId=${accountId}`;
const $8276a70a04cf6ae6$export$ba821ce5e177c7ef = async (accountId)=>{
    const url = $8276a70a04cf6ae6$var$getUserUrl(accountId);
    const response = await (0, $lRmyA.performPutRequest)(url, {
        body: JSON.stringify(true)
    });
    if (response && !response.ok) throw Error('Failed to dismiss changeboarding spotlight for Parent field');
};
const $8276a70a04cf6ae6$export$b3126db2ef6e34ed = async (accountId)=>{
    const url = $8276a70a04cf6ae6$var$getUserUrl(accountId);
    const response = await fetch(url);
    // ok is true only when status code is 2xx.
    if (response.ok) {
        const responseObj = await response.json();
        return responseObj.value;
    }
    const { status: status } = response;
    // 404: API deliberately returns 404 if user property is not found, which implies the user has not dismissed the spotlight.
    if (status === 404) return false;
    // returning the default value (dismissed) regardless of endpoint errors.
    return true;
};

});


parcelRegister("4nN7J", function(module, exports) {

$parcel$export(module.exports, "ParentField", () => $21518217056e05c5$export$96c87c0afbe06b37);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $illlw = parcelRequire("illlw");

var $hTLlD = parcelRequire("hTLlD");


var $bAQOb = parcelRequire("bAQOb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $gFVH5 = parcelRequire("gFVH5");

var $6oQPP = parcelRequire("6oQPP");
var $5St1r = parcelRequire("5St1r");

var $3koWU = parcelRequire("3koWU");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $DX7su = parcelRequire("DX7su");

var $ctBfd = parcelRequire("ctBfd");

var $9nOge = parcelRequire("9nOge");

var $i0H65 = parcelRequire("i0H65");
const $21518217056e05c5$var$InlineEditParentContainer = (0, $bAQOb.componentWithFF)('issue-view-fit-and-finish-full-page-milestone2_ebk0i', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5St1r.InlineEditContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !__cmplp.isEditable ? "_f8epkb7n _3qpix7n9" : "_t90mswc3",
            __cmplp.className
        ])
    });
}), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5St1r.InlineEditContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !__cmplp.isEditable && "_f8epkb7n _3qpix7n9",
            __cmplp.className
        ])
    });
}));
$21518217056e05c5$var$InlineEditParentContainer.displayName = 'InlineEditParentContainer';
const $21518217056e05c5$export$96c87c0afbe06b37 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { fieldKey: fieldKey, issueKey: issueKey, label: label, onCancel: onCancel, onEdit: onEdit, onEscape: onEscape, onConfirm: onConfirm, onEnter: onEnter, onUpdate: onUpdate, onCloseMenuOnScroll: onCloseMenuOnScroll, readView: readView, editView: editView, showPinButton: showPinButton, issueId: issueId, startWithEditViewOpen: startWithEditViewOpen = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, isExistingIssue: isExistingIssue, classNamePrefix: classNamePrefix, ...rest } = props;
    // We need to track the mounted state as it is possible that a component
    // using this component can be unmounted before async operations are completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $3koWU.useIsMounted)();
    const source = (0, $hJ992.useAnalyticsSource)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { onFailure: showErrorFlag } = (0, $gFVH5.useFieldFlags)();
    const [isEditing, setIsEditing] = (0, $eUqFw.useState)(startWithEditViewOpen);
    const onSuccess = (0, $eUqFw.useCallback)((value)=>{
        onUpdate?.(value);
    }, [
        onUpdate
    ]);
    const onFailure = (0, $eUqFw.useCallback)((error)=>{
        showErrorFlag({
            error: error,
            title: (0, $9nOge.default).errorTitle,
            description: (0, $9nOge.default).errorMessage
        });
        if (isMounted.current) setIsEditing(true);
    }, [
        isMounted,
        showErrorFlag
    ]);
    const [{ fieldConfig: fieldConfig, value: value }, { resetError: resetError, saveValue: saveValue }] = (0, $DX7su.useParentField)({
        fieldKey: fieldKey,
        issueId: issueId,
        issueKey: (0, $6vrw7.toIssueKey)(issueKey),
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    const isFieldEditable = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'isEditable', false);
    const isMobile = source === (0, $0100842672acae20$export$ce88447986394f2d);
    const save = (0, $eUqFw.useCallback)((option, analyticsEvent)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(option, value)) saveValue(option || null, null, analyticsEvent);
        setIsEditing(false);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        saveValue,
        value,
        setIsEditing
    ]);
    const cancel = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        resetError();
        setIsEditing(false);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        resetError,
        setIsEditing
    ]);
    const onCancelRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onCancel && onCancel(analyticsEvent);
    }, [
        cancel,
        onCancel
    ]);
    const onConfirmRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        setIsEditing(false);
        onConfirm && onConfirm(analyticsEvent);
    }, [
        onConfirm
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onEditRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        setIsEditing(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onEdit && onEdit(analyticsEvent);
    }, [
        onEdit,
        setIsEditing
    ]);
    const onEscapeRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onEscape && onEscape(analyticsEvent);
    }, [
        cancel,
        onEscape
    ]);
    const onChange = (0, $eUqFw.useCallback)((selectedOption)=>{
        resetError();
        const analyticsEvent = createAnalyticsEvent({
            action: 'confirmed',
            actionSubject: 'fieldInlineEdit'
        });
        save(selectedOption, analyticsEvent);
        onConfirmRequest(analyticsEvent);
    }, [
        resetError,
        createAnalyticsEvent,
        onConfirmRequest,
        save
    ]);
    const renderEditView = ()=>editView !== undefined ? editView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ctBfd.ParentFieldEdit), {
            fieldId: fieldKey,
            value: value,
            onChange: onChange,
            isEditing: isEditing,
            autoFocus: true,
            isExistingIssue: isExistingIssue,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            selectedProjectId: selectedProjectId,
            selectedIssueTypeId: selectedIssueTypeId,
            classNamePrefix: classNamePrefix,
            fetchSuggestionsOnFocus: true,
            defaultMenuIsOpen: true
        }));
    const renderReadView = (0, $eUqFw.useCallback)(()=>readView !== undefined ? readView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5St1r.ReadViewContainer), {
            "data-testid": "issue-field-parent.ui.read-view-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0H65.ParentViewField), {
            noValueText: formatMessage((0, $9nOge.default).noValueText),
            value: value,
            isMobile: isMobile
        })), [
        isMobile,
        formatMessage,
        readView,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21518217056e05c5$var$InlineEditParentContainer, {
        isEditable: isFieldEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        isEditable: isFieldEditable,
        isEditing: isEditing,
        isFitContainerWidthReadView: !isMobile,
        testId: "issue-field-parent.ui.inline-edit-field",
        label: label,
        readView: renderReadView(),
        editView: isFieldEditable ? renderEditView() : null,
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onEdit: onEditRequest,
        onEscape: onEscapeRequest,
        disableEditViewFieldBase: true,
        areActionButtonsHidden: true,
        isLabelHidden: true,
        ...rest
    }));
});
$21518217056e05c5$export$96c87c0afbe06b37.displayName = 'ParentField';

});
parcelRegister("gFVH5", function(module, exports) {

$parcel$export(module.exports, "useFieldFlagsOld", () => $756f57949d57f949$export$fd2f59832ff3c361);
$parcel$export(module.exports, "useFieldFlags", () => $756f57949d57f949$export$f2ea4a7e6dbd35b4);

var $eUqFw = parcelRequire("eUqFw");

var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $3uwWv = parcelRequire("3uwWv");
const $756f57949d57f949$export$fd2f59832ff3c361 = ()=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const onSuccess = (0, $eUqFw.useCallback)((title, description)=>{
        showFlag({
            type: 'success',
            title: title,
            description: description
        });
    }, [
        showFlag
    ]);
    const onFailure = (0, $eUqFw.useCallback)((title, description)=>{
        showFlag({
            type: 'error',
            title: title,
            description: description
        });
    }, [
        showFlag
    ]);
    return {
        onSuccess: onSuccess,
        onFailure: onFailure
    };
};
const $756f57949d57f949$export$f2ea4a7e6dbd35b4 = ()=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const onSuccess = (0, $eUqFw.useCallback)(({ title: title, description: description })=>{
        showFlag({
            type: 'success',
            title: title,
            description: description
        });
    }, [
        showFlag
    ]);
    const onFailure = (0, $eUqFw.useCallback)(({ error: error, title: title, description: description })=>{
        if (error instanceof (0, $7byHA.ValidationError)) {
            const errorMessage = (0, $3uwWv.getErrorMessage)(error, description);
            showFlag({
                type: 'warning',
                title: title,
                description: errorMessage
            });
        } else showFlag({
            type: 'error',
            title: title,
            description: description
        });
    }, [
        showFlag
    ]);
    return {
        onSuccess: onSuccess,
        onFailure: onFailure
    };
};

});
parcelRegister("3uwWv", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $f691efb935b9fe1e$export$82f46aa4e6535a45);

const $f691efb935b9fe1e$export$82f46aa4e6535a45 = (error, description)=>{
    const serverError = error.message || error.errors[0]?.error;
    if (serverError) return {
        id: (0, $08c15289d4a57955$export$7db9f52b9f87362c),
        defaultMessage: serverError
    };
    return description;
};

});
const $08c15289d4a57955$export$7db9f52b9f87362c = 'field-flags-service.server-validation-error-message';



parcelRegister("DX7su", function(module, exports) {

$parcel$export(module.exports, "useParentField", () => $7e16df0745dc2b53$export$23f8a245702eecc6);

var $lRmyA = parcelRequire("lRmyA");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $7e16df0745dc2b53$export$984ebf992eeb92e6 = async (issueKey, fieldKey, newValue)=>(0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify({
            fields: {
                [fieldKey]: newValue && newValue.value ? {
                    id: newValue.value
                } : null
            }
        })
    });
const $7e16df0745dc2b53$export$aee311d2cd3543e6 = (response)=>{
    if (!response?.fields) return null;
    return response.fields.parent;
};
const $7e16df0745dc2b53$export$23f8a245702eecc6 = (props)=>{
    const { fieldKey: fieldKey, issueId: issueId, issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure } = props;
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.custom ?? (0, $lO4Or.PARENT_TYPE);
    const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue, saveById: saveById }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        fieldType: fieldType,
        issueId: issueId,
        issueKey: issueKey,
        onSuccess: onSuccess,
        onFailure: onFailure,
        initialValue: null,
        saveField: $7e16df0745dc2b53$export$984ebf992eeb92e6,
        mapNonOptimisticResponse: $7e16df0745dc2b53$export$aee311d2cd3543e6
    });
    const valueOption = value || null;
    return [
        {
            value: valueOption,
            fieldConfig: fieldConfig,
            error: error
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};

});

parcelRegister("ctBfd", function(module, exports) {

$parcel$export(module.exports, "ParentFieldEdit", () => $16b7cfe9b86e2ec5$export$55c2cccecfd24751);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $4zgIJ = parcelRequire("4zgIJ");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $4NcaX = parcelRequire("4NcaX");
var $g6sIQ = parcelRequire("g6sIQ");

var $dWLk9 = parcelRequire("dWLk9");

var $3K8W2 = parcelRequire("3K8W2");

var $gFHZL = parcelRequire("gFHZL");

var $4RHil = parcelRequire("4RHil");

var $1h91k = parcelRequire("1h91k");

var $lNJbX = parcelRequire("lNJbX");
const $16b7cfe9b86e2ec5$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
// clean up on 'com.atlassian.jira.customhierarchy.parent.candidates.with.info.endpoints.enabled' flag removal
function $16b7cfe9b86e2ec5$var$isNewType(response) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return response.options !== undefined;
}
const $16b7cfe9b86e2ec5$export$55c2cccecfd24751 = (props)=>{
    const { onFocus: onFocus, onBlur: onBlur, value: value = null, onChange: onChange, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, isInvalid: isInvalid = false, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled = false, isExistingIssue: isExistingIssue = false, defaultMenuIsOpen: defaultMenuIsOpen = false, isEditing: isEditing, classNamePrefix: classNamePrefix, isClearable: isClearable = true, passedInIssueKey: passedInIssueKey, fieldId: // used for experiences that don't have issueKey in context, eg. bulk edit
    fieldId, spacing: spacingProps = 'compact' } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [suggestions, setSuggestions] = (0, $eUqFw.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $eUqFw.useState)();
    const [noOptionsMessage, setNoOptionsMessage] = (0, $eUqFw.useState)('');
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $eUqFw.useState)(false);
    const [excludeDone, setExcludeDone] = (0, $eUqFw.useState)(true);
    const isInitialMount = (0, $eUqFw.useRef)(true);
    const lastQuery = (0, $eUqFw.useRef)('');
    const cloudId = (0, $dWLk9.useCloudId)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const onCheckboxClick = (0, $eUqFw.useCallback)(()=>{
        setExcludeDone(!excludeDone);
    }, [
        excludeDone
    ]);
    const componentProps = (0, $eUqFw.useMemo)(()=>({
            isChecked: !excludeDone,
            onChange: onCheckboxClick
        }), [
        excludeDone,
        onCheckboxClick
    ]);
    const formatOptionLabel = (0, $eUqFw.useCallback)((option, { context: context })=>{
        if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: option.label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1h91k.default), {
            option: option
        }));
        const label = (0, $1ybV0.ff)('jsm-request-type-layout-supports-parent-field_jiq2s') ? option.label || `${option.key} ${option.fields.summary}` : `${option.key} ${option.fields.summary}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, label);
    }, []);
    const searchParents = (0, $eUqFw.useCallback)(async (query = '')=>{
        setHasLastFetchFailed(false);
        try {
            lastQuery.current = query;
            if (isExistingIssue) {
                const fetchedOptions = (0, $1ybV0.ff)('com.atlassian.jira.customhierarchy.parent.candidates.with.info.endpoints.enabled') ? await (0, $lNJbX.fetchParentsForExisting)({
                    searchTerm: query,
                    issueKey: passedInIssueKey || issueKey,
                    cloudId: cloudId,
                    excludeDone: excludeDone
                }) : await (0, $lNJbX.fetchParentsForExistingOld)({
                    searchTerm: query,
                    issueKey: passedInIssueKey || issueKey,
                    cloudId: cloudId,
                    excludeDone: excludeDone
                });
                return fetchedOptions;
            }
            if (selectedProjectId && selectedIssueTypeId) {
                const fetchedOptions = (0, $1ybV0.ff)('com.atlassian.jira.customhierarchy.parent.candidates.with.info.endpoints.enabled') ? await (0, $lNJbX.fetchParentsForNew)({
                    searchTerm: query,
                    selectedProjectId: selectedProjectId,
                    selectedIssueTypeId: selectedIssueTypeId,
                    cloudId: cloudId,
                    excludeDone: excludeDone
                }) : await (0, $lNJbX.fetchParentsForNewOld)({
                    searchTerm: query,
                    selectedProjectId: selectedProjectId,
                    selectedIssueTypeId: selectedIssueTypeId,
                    cloudId: cloudId,
                    excludeDone: excludeDone
                });
                return fetchedOptions;
            }
            setHasLastFetchFailed(true);
            return [];
        } catch  {
            setHasLastFetchFailed(true);
            return [];
        }
    }, [
        isExistingIssue,
        issueKey,
        cloudId,
        excludeDone,
        selectedProjectId,
        selectedIssueTypeId,
        passedInIssueKey
    ]);
    const requestSuggestions = (0, $eUqFw.useCallback)(async (query = '')=>{
        const response = await searchParents(query);
        if (lastQuery.current === query) {
            if ((0, $1ybV0.ff)('com.atlassian.jira.customhierarchy.parent.candidates.with.info.endpoints.enabled') && $16b7cfe9b86e2ec5$var$isNewType(response)) {
                setSuggestions(response.options);
                if (response.options.length === 0 && response.message) setNoOptionsMessage(response.message);
                if (query === '') setDefaultSuggestions(response.options);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                setSuggestions(response);
                if (query === '') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                setDefaultSuggestions(response);
            }
            setIsLoading(false);
        }
    }, [
        searchParents
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedRequestSuggestions = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(requestSuggestions, $16b7cfe9b86e2ec5$var$LOAD_OPTIONS_DEBOUNCE_TIMER), [
        excludeDone
    ]);
    const onQueryChange = (0, $eUqFw.useCallback)((query)=>{
        debouncedRequestSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoading(true);
            debouncedRequestSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoading(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedRequestSuggestions,
        defaultSuggestions
    ]);
    const handleFocus = (0, $eUqFw.useCallback)((e)=>{
        if (lastQuery.current === '' && !defaultSuggestions) {
            setIsLoading(true);
            requestSuggestions();
        }
        onFocus && onFocus(e);
    }, [
        defaultSuggestions,
        onFocus,
        requestSuggestions
    ]);
    const filterOption = (0, $eUqFw.useCallback)((option)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $g6sIQ.filterOptionByLabelAndFilterValues)(option, lastQuery.current || '');
    }, [
        hasLastFetchFailed
    ]);
    const getNoOptionsMessage = (0, $eUqFw.useCallback)(()=>{
        if ((0, $1ybV0.ff)('com.atlassian.jira.customhierarchy.parent.candidates.with.info.endpoints.enabled')) {
            const noOptions = noOptionsMessage !== '' ? noOptionsMessage : formatMessage((0, $4RHil.default).noMatches);
            // we now get the translated message from the backend, but will fall back to the old message if it's not there
            return hasLastFetchFailed ? formatMessage((0, $4RHil.default).failedFetch) : noOptions;
        }
        return formatMessage(hasLastFetchFailed ? (0, $4RHil.default).failedFetch : (0, $4RHil.default).noMatches);
    }, [
        formatMessage,
        hasLastFetchFailed,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $eUqFw.useCallback)(()=>formatMessage((0, $4RHil.default).loading), [
        formatMessage
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isInitialMount.current) {
            setIsLoading(true);
            requestSuggestions(lastQuery.current);
        }
        isInitialMount.current = false;
    }, [
        excludeDone,
        requestSuggestions
    ]);
    const spacing = (0, $eUqFw.useMemo)(()=>{
        if ((0, $eI5EY.fg)('jira_-_list_-_add_onclick_handler_to_parentview')) return spacingProps;
        if ((0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i')) return 'compact';
        return 'default';
    }, [
        spacingProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), {
        // need to stop esc keydown propagation to avoid modal close if select is open
        onKeyDown: (0, $3K8W2.preventEscKeyPropagationKeyPressHandler),
        inputId: `${fieldId}-field`,
        options: suggestions,
        value: value,
        formatOptionLabel: formatOptionLabel,
        onBlur: onBlur,
        onFocus: handleFocus,
        onChange: onChange,
        menuPosition: isDropdownMenuFixedAndLayered ? 'fixed' : undefined,
        styles: (0, $4NcaX.defaultSelectStyles),
        closeMenuOnScroll: onCloseMenuOnScroll,
        isMulti: false,
        isLoading: isLoading,
        onInputChange: onQueryChange,
        loadingMessage: getLoadingMessage,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: formatMessage((0, $4RHil.default).placeholder),
        components: {
            Menu: $gFHZL.default
        },
        componentsProps: componentProps,
        autoFocus: autoFocus,
        filterOption: filterOption,
        validationState: isInvalid === true ? 'error' : undefined,
        hideSelectedOptions: true,
        isClearable: isClearable,
        ...isEditing !== undefined && {
            menuIsOpen: isEditing
        },
        isDisabled: isDisabled,
        defaultMenuIsOpen: defaultMenuIsOpen,
        classNamePrefix: classNamePrefix,
        spacing: spacing
    });
};

});
parcelRegister("3K8W2", function(module, exports) {

$parcel$export(module.exports, "getOptionColorElem", () => $95b0c6b6b9af6b91$export$b00899e73680c477);
$parcel$export(module.exports, "mapDataToOptions", () => $95b0c6b6b9af6b91$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $95b0c6b6b9af6b91$export$fc800909123977f3);
$parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", () => $95b0c6b6b9af6b91$export$feb08457bf70a411);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $95b0c6b6b9af6b91$export$949dc67535a8ff2);
/* utils.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $1ybV0 = parcelRequire("1ybV0");

var $tgbCK = parcelRequire("tgbCK");
var $lPQPn = parcelRequire("lPQPn");
const $95b0c6b6b9af6b91$export$bc913b9c9057634d = (color)=>color === undefined || color === '' ? 'transparent' : (0, $tgbCK.MAP_COLORS_TO_VALUE)[color];
const $95b0c6b6b9af6b91$export$b00899e73680c477 = (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($95b0c6b6b9af6b91$var$ColorPatch, {
        color: color,
        "data-testid": `issue-field-parent.common.color-patch-${color}`
    });
const $95b0c6b6b9af6b91$export$99a866ffa3af7d8b = (issueParents)=>{
    const transformedResponse = (0, $1ybV0.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') ? issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color, isDone: isDone })=>({
            id: id,
            key: key,
            fields: {
                issuetype: issueType,
                summary: summary
            },
            color: color,
            value: id,
            label: `${key} ${summary}`,
            isDone: isDone
        })) : issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color })=>({
            id: id,
            key: key,
            fields: {
                issuetype: issueType,
                summary: summary
            },
            color: color,
            value: id,
            label: `${key} ${summary}`
        }));
    return transformedResponse;
};
const $95b0c6b6b9af6b91$export$fc800909123977f3 = (option)=>({
        id: option.value
    });
const $95b0c6b6b9af6b91$export$9b822862d986dfdf = (0, $lPQPn.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $95b0c6b6b9af6b91$export$feb08457bf70a411 = (event)=>{
    if (event?.key === 'Escape') event?.nativeEvent?.stopImmediatePropagation();
};
const $95b0c6b6b9af6b91$export$949dc67535a8ff2 = (color)=>$95b0c6b6b9af6b91$export$9b822862d986dfdf[color];
// We adjust the size of the color patch away from normal grid sizes because
// the issue type icon actually has a 1px border on each side, which is 2x1px on width/height
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95b0c6b6b9af6b91$var$ColorPatch = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1nzbko4": (0, $9t7rW.default)($95b0c6b6b9af6b91$export$bc913b9c9057634d(__cmplp.color))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbdlk8 _1ul9dlk8 _4t3idlk8 _2rko1y44 _bfhk1vzt",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gFHZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddeadf926ee0a27e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bT7k5 = parcelRequire("bT7k5");

var $jQxSL = parcelRequire("jQxSL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2iqfg = parcelRequire("2iqfg");
const $ddeadf926ee0a27e$var$Menu = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { children: children, ...restProps } = props;
    const isChecked = props.selectProps?.componentsProps?.isChecked || false;
    const label = formatMessage((0, $2iqfg.default).checkboxLabel);
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        // stopping propagation when focus moves to checkbox because select already binded with space and enter for selection
        if (event.key === ' ') event.stopPropagation();
    }, []);
    /**
   * When the checkbox is clicked, we need to stop the event propagation to prevent the select from closing.
   */ const onChange = (0, $eUqFw.useCallback)((event)=>{
        // stopping propagation when checkbox is clicked to prevent select from closing
        event.stopPropagation();
        event.preventDefault();
        props.selectProps?.componentsProps?.onChange?.(event);
    }, [
        props.selectProps?.componentsProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Menu, restProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ddeadf926ee0a27e$var$CheckboxWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        onKeyDown: onKeyDown,
        onClick: onChange,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChange: ()=>{},
        isChecked: isChecked,
        size: "medium",
        id: "issue-field-parent.ui.edit.menu.checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ddeadf926ee0a27e$var$CheckboxLabel, {
        onClick: onChange,
        htmlFor: "issue-field-parent.ui.edit.menu.checkbox",
        "data-testid": "issue-field-parent.ui.edit.menu.checkbox-label"
    }, label)), children);
};
var $ddeadf926ee0a27e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $ddeadf926ee0a27e$var$Menu;
const $ddeadf926ee0a27e$var$CheckboxWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1y6m _1yt4lce4 _n7zlpe8f _4cvr1h6o _zulp1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ddeadf926ee0a27e$var$CheckboxLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2iqfg", function(module, exports) {

$parcel$export(module.exports, "default", () => $527b2a926f101da8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $527b2a926f101da8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    checkboxLabel: {
        "id": "issue-field-parent.edit.menu.checkbox-label",
        "defaultMessage": "Show done issues"
    }
});

});


parcelRegister("4RHil", function(module, exports) {

$parcel$export(module.exports, "default", () => $1453541c4aca35df$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1453541c4aca35df$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noMatches: {
        "id": "issue-field-parent.edit.no-matches",
        "defaultMessage": "No matches"
    },
    failedFetch: {
        "id": "issue-field-parent.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-parent.edit.placeholder",
        "defaultMessage": "Select parent"
    },
    loading: {
        "id": "issue-field-parent.edit.loading",
        "defaultMessage": "Searching..."
    }
});

});

parcelRegister("1h91k", function(module, exports) {

$parcel$export(module.exports, "default", () => $3459ab43a3b207bd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $k9Z3M = parcelRequire("k9Z3M");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3K8W2 = parcelRequire("3K8W2");

var $gDuhX = parcelRequire("gDuhX");

var $eNV5F = parcelRequire("eNV5F");
const $3459ab43a3b207bd$var$renderOptionDescription = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$OptionDescriptionWrapper, null, option.description != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.Description), null, option.description) : null);
const $3459ab43a3b207bd$var$renderIconsKeyAndDoneLabel = (option, doneParentLabel, iconAltMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$OptionColorTypeKeyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$IconColorKeyWrapper, null, option?.color ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $3K8W2.getOptionColorElem)(option?.color), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$IconWithColor, {
        src: option.fields?.issuetype.iconUrl,
        alt: iconAltMessage
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$Icon, {
        src: option.fields?.issuetype.iconUrl,
        alt: iconAltMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$IssueKey, null, option.key)), option.isDone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$DoneWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
        primaryColor: `var(--ds-text-success, ${(0, $PdmhA).G500})`,
        label: "done-parent-issue"
    }), doneParentLabel) : null);
const $3459ab43a3b207bd$var$CustomOption = ({ option: option })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)(); // narrowing type to ParentFieldOption
    if ('fields' in option) {
        const fields = option?.fields;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionTextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionLabel), null, $3459ab43a3b207bd$var$renderIconsKeyAndDoneLabel(option, formatMessage((0, $gDuhX.default).doneParentLabel), formatMessage((0, $gDuhX.default).icon, {
            issueType: fields?.issuetype.name || ''
        })), option.fields.summary)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionWrapper), null, option.elemBefore != null ? option.elemBefore : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionTextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionLabel), null, option.label), $3459ab43a3b207bd$var$renderOptionDescription(option)));
};
var $3459ab43a3b207bd$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3459ab43a3b207bd$var$CustomOption;
const $3459ab43a3b207bd$var$IconWithColor = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3459ab43a3b207bd$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3459ab43a3b207bd$var$IconColorKeyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz1a45",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3459ab43a3b207bd$var$DoneWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz1rc1",
            __cmplp.className
        ])
    });
});
const $3459ab43a3b207bd$var$IssueKey = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _p12f1osq _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $3459ab43a3b207bd$var$OptionColorTypeKeyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _syaz1rc1 _1wyb1crf _otyr1b66",
            __cmplp.className
        ])
    });
});
const $3459ab43a3b207bd$var$OptionDescriptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1wyb1crf _19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gDuhX", function(module, exports) {

$parcel$export(module.exports, "default", () => $de48ca9994a523f3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $de48ca9994a523f3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    icon: {
        "id": "issue-field-parent.edit.option.icon",
        "defaultMessage": "{issueType} icon"
    },
    doneParentLabel: {
        "id": "issue-field-parent.edit.option.done-parent-label",
        "defaultMessage": "Done"
    }
});

});

parcelRegister("eNV5F", function(module, exports) {

$parcel$export(module.exports, "OptionWrapper", () => $8880269126d01244$export$d6f6a072cce04542);
$parcel$export(module.exports, "OptionTextContainer", () => $8880269126d01244$export$c6c33847de6c74ef);
$parcel$export(module.exports, "Description", () => $8880269126d01244$export$393edc798c47379d);
$parcel$export(module.exports, "OptionLabel", () => $8880269126d01244$export$2cf7ef1e2dd6c6b1);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8880269126d01244$export$d6f6a072cce04542 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $8880269126d01244$export$c6c33847de6c74ef = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _18s8h8dc _1yt4x7n9 _1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $8880269126d01244$export$393edc798c47379d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _p12f1osq",
            __cmplp.className
        ])
    });
});
const $8880269126d01244$export$2cf7ef1e2dd6c6b1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _16jlkb7n",
            __cmplp.className
        ])
    });
});

});


parcelRegister("lNJbX", function(module, exports) {

$parcel$export(module.exports, "fetchParentsForNew", () => $a94fa604b4d453e4$export$73bed6a0175e413);
$parcel$export(module.exports, "fetchParentsForNewOld", () => $a94fa604b4d453e4$export$d981b87d937d9d4b);
$parcel$export(module.exports, "fetchParentsForExisting", () => $a94fa604b4d453e4$export$f995718992ca6c2f);
$parcel$export(module.exports, "fetchParentsForExistingOld", () => $a94fa604b4d453e4$export$ea853815efb7401);

var $guiFP = parcelRequire("guiFP");

var $ksJPv = parcelRequire("ksJPv");
var $ijrxj = parcelRequire("ijrxj");

var $3K8W2 = parcelRequire("3K8W2");
const $a94fa604b4d453e4$export$cfeee2ee86ead336 = 'bento';
const $a94fa604b4d453e4$export$73bed6a0175e413 = async (props)=>{
    const { searchTerm: searchTerm, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, cloudId: cloudId, excludeDone: excludeDone } = props;
    // This is a gira request
    try {
        const response = await (0, $ijrxj.fetchParentCandidatesForNewIssue)(cloudId, selectedProjectId, selectedIssueTypeId, searchTerm, excludeDone);
        return {
            options: (0, $3K8W2.mapDataToOptions)(response.candidates),
            message: response.message
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'fetchParentsForNew',
                packageName: 'jiraIssueFieldParent',
                teamName: $a94fa604b4d453e4$export$cfeee2ee86ead336
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error(error);
    }
};
const $a94fa604b4d453e4$export$d981b87d937d9d4b = async (props)=>{
    const { searchTerm: searchTerm, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, cloudId: cloudId, excludeDone: excludeDone } = props;
    // This is a gira request
    try {
        const response = await (0, $ijrxj.fetchParentCandidatesForNewIssueOld)(cloudId, selectedProjectId, selectedIssueTypeId, searchTerm, excludeDone);
        return (0, $3K8W2.mapDataToOptions)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'fetchParentsForNew',
                packageName: 'jiraIssueFieldParent',
                teamName: $a94fa604b4d453e4$export$cfeee2ee86ead336
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error(error);
    }
};
const $a94fa604b4d453e4$export$f995718992ca6c2f = async (props)=>{
    const { searchTerm: searchTerm, issueKey: issueKey, cloudId: cloudId, excludeDone: excludeDone } = props;
    // This is a gira request
    try {
        const response = await (0, $ksJPv.fetchParentCandidatesForExistingIssue)(cloudId, issueKey, searchTerm, excludeDone);
        return {
            options: (0, $3K8W2.mapDataToOptions)(response.candidates),
            message: response.message
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'fetchParentsForExisting',
                packageName: 'jiraIssueFieldParent',
                teamName: $a94fa604b4d453e4$export$cfeee2ee86ead336
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $a94fa604b4d453e4$export$ea853815efb7401 = async (props)=>{
    const { searchTerm: searchTerm, issueKey: issueKey, cloudId: cloudId, excludeDone: excludeDone } = props;
    // This is a gira request
    try {
        const response = await (0, $ksJPv.fetchParentCandidatesForExistingIssueOld)(cloudId, issueKey, searchTerm, excludeDone);
        return (0, $3K8W2.mapDataToOptions)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'fetchParentsForExisting',
                packageName: 'jiraIssueFieldParent',
                teamName: $a94fa604b4d453e4$export$cfeee2ee86ead336
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("ijrxj", function(module, exports) {

$parcel$export(module.exports, "fetchParentCandidatesForNewIssueOld", () => $5934be41627d9230$export$7576c1f792a62ced);
$parcel$export(module.exports, "fetchParentCandidatesForNewIssue", () => $5934be41627d9230$export$48a29a1313179c04);


var $7EhAs = parcelRequire("7EhAs");

var $go64Z = parcelRequire("go64Z");

var $7SU3A = parcelRequire("7SU3A");

var $gbHOB = parcelRequire("gbHOB");

var $hKxcm = parcelRequire("hKxcm");
// clean up on 'com.atlassian.jira.customhierarchy.parent.candidates.with.info.endpoints.enabled' flag removal
function $5934be41627d9230$var$isNewType(giraData) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return giraData.parentCandidatesWithInfoForNewIssue !== undefined;
}
function $5934be41627d9230$var$isOldType(giraData) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return giraData.parentCandidatesForNewIssue !== undefined;
}
const $5934be41627d9230$export$7576c1f792a62ced = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
    const response = (0, $go64Z.default)(cloudId, projectId, issueTypeId, searchTerm, excludeDone);
    const { data: data, errors: errors } = await response;
    if (!data || errors) {
        const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
        throw new (0, $gbHOB.default)(new Error(message), (0, $7SU3A.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY));
    }
    if ($5934be41627d9230$var$isOldType(data.jira) && !data.jira?.parentCandidatesForNewIssue) {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify(errors);
            // if `parentCandidatesForExistingIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $gbHOB.default)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, $7SU3A.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $gbHOB.default)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, $7SU3A.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY));
    }
    return $5934be41627d9230$var$isOldType(data.jira) ? (0, $hKxcm.transformData)(data.jira.parentCandidatesForNewIssue.edges) : [];
};
const $5934be41627d9230$export$48a29a1313179c04 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
    const response = (0, $go64Z.default)(cloudId, projectId, issueTypeId, searchTerm, excludeDone);
    const { data: data, errors: errors } = await response;
    if (!data || errors) {
        const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
        throw new (0, $gbHOB.default)(new Error(message), (0, $7SU3A.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
    }
    if (!data.jira?.parentCandidatesWithInfoForNewIssue) {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify(errors);
            // if `parentCandidatesForExistingIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $gbHOB.default)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, $7SU3A.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $gbHOB.default)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, $7SU3A.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
    }
    const candidates = $5934be41627d9230$var$isNewType(data.jira) ? (0, $hKxcm.transformData)(data.jira.parentCandidatesWithInfoForNewIssue.parentCandidates.edges) : [];
    return {
        candidates: candidates,
        message: $5934be41627d9230$var$isNewType(data.jira) ? data.jira.parentCandidatesWithInfoForNewIssue.message : undefined
    };
};

});
parcelRegister("go64Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $381d472c7acaff8f$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");

var $7SU3A = parcelRequire("7SU3A");

var $kXzsJ = parcelRequire("kXzsJ");
const $381d472c7acaff8f$export$1fd3b40492f4ef9f = 20;
const $381d472c7acaff8f$var$isParentCandidatesWithInfoEndpointsEnabled = ()=>(0, $1ybV0.ff)('com.atlassian.jira.customhierarchy.parent.candidates.with.info.endpoints.enabled');
var /**
 * Returns parent candidates for a new issue (e.g one that is about to be created)
 *
 * @param cloudId - The cloud ID of the instance
 * @param projectId - The ID of the project in which the issue will be created
 * @param issueTypeId - The issue type of the project to be created
 * @param searchTerm - A search string for the parent, on either full key match or partial summary match
 * @param excludeDone - Whether to exclude done issues from the list of parent candidate results
 * @returns A list of possible parent issues for the specified project and issue type
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$381d472c7acaff8f$export$2e2bcd8739ae039 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
    const variables = $381d472c7acaff8f$var$isParentCandidatesWithInfoEndpointsEnabled() ? {
        cloudId: cloudId,
        projectId: projectId,
        issueTypeId: issueTypeId,
        searchTerm: searchTerm,
        excludeDone: excludeDone,
        first: $381d472c7acaff8f$export$1fd3b40492f4ef9f
    } : {
        cloudId: cloudId,
        project: {
            projectId: projectId
        },
        issueType: {
            issueTypeId: issueTypeId
        },
        searchTerm: searchTerm,
        excludeDone: excludeDone,
        first: $381d472c7acaff8f$export$1fd3b40492f4ef9f
    };
    let operationName;
    if ($381d472c7acaff8f$var$isParentCandidatesWithInfoEndpointsEnabled()) operationName = `jira_parenting_${0, $7SU3A.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO}`;
    else operationName = `jira_parenting_${0, $7SU3A.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY}`;
    const response = await (0, $kXzsJ.getClient)('').query({
        query: $381d472c7acaff8f$var$isParentCandidatesWithInfoEndpointsEnabled() ? (0, $7SU3A.buildParentCandidatesForNewIssueQuery)() : (0, $7SU3A.buildParentCandidatesForNewIssueQueryOld)(),
        variables: variables,
        operationName: operationName
    });
    return response;
};

});
parcelRegister("7SU3A", function(module, exports) {

$parcel$export(module.exports, "PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY", () => $dbe4fea6910fdc7f$export$83c2582c20a93059);
$parcel$export(module.exports, "PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO", () => $dbe4fea6910fdc7f$export$26f006aaa0389bc0);
$parcel$export(module.exports, "buildParentCandidatesForNewIssueQuery", () => $dbe4fea6910fdc7f$export$453f3d2e0fac3592);
$parcel$export(module.exports, "buildParentCandidatesForNewIssueQueryOld", () => $dbe4fea6910fdc7f$export$dee38981730d6162);

var $hIakI = parcelRequire("hIakI");
const $dbe4fea6910fdc7f$export$83c2582c20a93059 = 'issueParentCandidatesForNewIssuesQuery';
const $dbe4fea6910fdc7f$export$26f006aaa0389bc0 = 'issueParentCandidatesForNewIssuesQueryWithInfo';
const $dbe4fea6910fdc7f$export$453f3d2e0fac3592 = ()=>`
    query jira_parenting_${$dbe4fea6910fdc7f$export$26f006aaa0389bc0}($projectId: ID!, $issueTypeId: ID!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, $hIakI.parentCandidatesForNewIssueQuery)()}
    }
`;
const $dbe4fea6910fdc7f$export$dee38981730d6162 = ()=>`
    query jira_parenting_${$dbe4fea6910fdc7f$export$83c2582c20a93059}($project: JiraProjectInput!, $issueType: JiraIssueTypeInput!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, $hIakI.parentCandidatesForNewIssueQueryOld)()}
    }
`;

});
parcelRegister("hIakI", function(module, exports) {

$parcel$export(module.exports, "parentCandidatesForNewIssueQueryOld", () => $a7df5a978940517d$export$e469a8d2a012570e);
$parcel$export(module.exports, "parentCandidatesForNewIssueQuery", () => $a7df5a978940517d$export$1dfd5c8a625d5960);

var $bKxX9 = parcelRequire("bKxX9");
const $a7df5a978940517d$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
const $a7df5a978940517d$var$summary = ()=>` 
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
const $a7df5a978940517d$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
const $a7df5a978940517d$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
const $a7df5a978940517d$var$fieldsByIdOld = ()=>`fieldsById(ids:["summary", "issuetype"]){
  edges{
    node{
      ${$a7df5a978940517d$var$issueType()}
      ${$a7df5a978940517d$var$summary()}
    }
  }
}`;
const $a7df5a978940517d$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$a7df5a978940517d$var$issueType()}
      ${$a7df5a978940517d$var$summary()}
      ${$a7df5a978940517d$var$status()}
    }
  }
}`;
const $a7df5a978940517d$export$e469a8d2a012570e = ()=>`
    jira {
        parentCandidatesForNewIssue(project: $project, issueType: $issueType, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
          edges {
            node {
              issueId
              key
              ${$a7df5a978940517d$var$color()}
              ${(0, $bKxX9.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') ? $a7df5a978940517d$var$fieldsById() : $a7df5a978940517d$var$fieldsByIdOld()}
            }
          }
        }
      }
`;
const $a7df5a978940517d$export$1dfd5c8a625d5960 = ()=>`
    jira {
        parentCandidatesWithInfoForNewIssue(projectId: $projectId, issueTypeId: $issueTypeId, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
          parentCandidates {
            edges {
              node {
                issueId
                key
                ${$a7df5a978940517d$var$color()}
                ${(0, $bKxX9.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') ? $a7df5a978940517d$var$fieldsById() : $a7df5a978940517d$var$fieldsByIdOld()}
              }
            }
          }
          message
        }
      }
`;

});






parcelRegister("9nOge", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea1f7f1d73fb707a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ea1f7f1d73fb707a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "issue-field-parent.error-title",
        "defaultMessage": "We couldn't set the parent value"
    },
    errorMessage: {
        "id": "issue-field-parent.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    noValueText: {
        "id": "issue-field-parent.no-value-text",
        "defaultMessage": "None"
    },
    editButtonLabel: {
        "id": "issue-field-parent.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    }
});

});

parcelRegister("i0H65", function(module, exports) {

$parcel$export(module.exports, "ParentViewField", () => $ef6f97e64b612d5b$export$51036c707862fc9f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $3K8W2 = parcelRequire("3K8W2");

var $iSEc1 = parcelRequire("iSEc1");
const $ef6f97e64b612d5b$var$Summary = ({ isMobile: isMobile, onClick: onClick, label: label, lozengeTheme: lozengeTheme, issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$WrapperNoClick, {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: lozengeTheme
    }, label);
    if (onClick != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$ButtonText, {
        onClick: onClick,
        style: lozengeTheme
    }, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$LinkText, {
        "data-testid": "issue-field-parent.ui.view-link",
        href: `/browse/${issueKey}`,
        "aria-label": formatMessage((0, $iSEc1.default).parentTitle, {
            label: label
        }),
        style: lozengeTheme
    }, label);
};
const $ef6f97e64b612d5b$var$ParentViewFieldNew = (props)=>{
    const { value: value, noValueText: noValueText, isMobile: isMobile, onClick: onClick } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (value) {
        const { key: key, fields: fields } = value;
        const label = `${key} ${fields.summary}`;
        const style = value.color ? (0, $3K8W2.getLozengeThemeByColor)(value.color) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: label,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$Container, {
            "data-testid": "issue-field-parent.ui.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$Icon, {
            src: fields.issuetype.iconUrl,
            alt: formatMessage((0, $iSEc1.default).icon, {
                issueType: fields?.issuetype.name || ''
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$Summary, {
            isMobile: isMobile,
            label: label,
            lozengeTheme: style,
            onClick: onClick,
            issueKey: key
        })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$EmptyValue, {
        "data-testid": "issue-field-parent.ui.view-read-view-empty-value"
    }, noValueText);
};
const $ef6f97e64b612d5b$var$ParentViewFieldOld = (props)=>{
    const { value: value, noValueText: noValueText, isMobile: isMobile } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (value) {
        const { key: key, fields: fields } = value;
        const label = `${key} ${fields.summary}`;
        const style = value.color ? (0, $3K8W2.getLozengeThemeByColor)(value.color) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: label,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$Container, {
            "data-testid": "issue-field-parent.ui.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$Icon, {
            src: fields.issuetype.iconUrl,
            alt: formatMessage((0, $iSEc1.default).icon, {
                issueType: fields?.issuetype.name || ''
            })
        }), isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$WrapperNoClick // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        , {
            style: style
        }, label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$LinkText, {
            "data-testid": "issue-field-parent.ui.view-link",
            href: `/browse/${key}`,
            "aria-label": formatMessage((0, $iSEc1.default).parentTitle, {
                label: label
            }),
            style: style
        }, label)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$EmptyValue, {
        "data-testid": "issue-field-parent.ui.view-read-view-empty-value"
    }, noValueText);
};
const $ef6f97e64b612d5b$export$51036c707862fc9f = (props)=>{
    if ((0, $eI5EY.fg)('jira_-_list_-_add_onclick_handler_to_parentview')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$ParentViewFieldNew, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$ParentViewFieldOld, props);
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef6f97e64b612d5b$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1reo15vq _18m915vq _o5721q9c _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ef6f97e64b612d5b$var$LinkText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $kJlBc.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _80omtlke _vwz47vkz _4t3i7vkz _p12f1osq _2rko1l7b _1yt4u49m _1wybdlk8 _2hwxu2gc _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ef6f97e64b612d5b$var$ButtonText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _o5721q9c _80omtlke _4t3igktf _p12f1osq _2rko1l7b _1yt4u49m _11c81oud _2hwxu2gc _19itglyw _11q7glyw _syaz1kw7 _12ji1r31 _1qu21kw7 _12y31o36 _vwz44jg8 _1bto1l2s _1e0c1ule _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef6f97e64b612d5b$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx12x7 _p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ef6f97e64b612d5b$var$WrapperNoClick = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _1e0c1ule _vwz47vkz _4t3i7vkz _2rko1l7b _1yt4u49m _1wybdlk8 _p12f1osq _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef6f97e64b612d5b$var$EmptyValue = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iSEc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5298e5dcf31dbd81$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5298e5dcf31dbd81$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    parentTitle: {
        "id": "issue-field-parent.parent-title",
        "defaultMessage": "Click to visit {label}"
    },
    icon: {
        "id": "issue-field-parent.icon",
        "defaultMessage": "{issueType} icon"
    }
});

});





parcelRegister("8gMne", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1e628d77c37077f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $lRmyA = parcelRequire("lRmyA");

var $YLXGO = parcelRequire("YLXGO");

var $huhk2 = parcelRequire("huhk2");

var $brySu = parcelRequire("brySu");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $lV5H0 = parcelRequire("lV5H0");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $zaqzH = parcelRequire("zaqzH");

var $jZDJX = parcelRequire("jZDJX");

var $fAlCw = parcelRequire("fAlCw");

var $9D3Vo = parcelRequire("9D3Vo");

var $40QX1 = parcelRequire("40QX1");

var $dtZSS = parcelRequire("dtZSS");
const $b1e628d77c37077f$var$fetchSuggestionsFactory = (0, $5iWql.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(baseUrl, projectId, issueTypeId, initialValue)=>(query)=>issueTypeId ? (0, $lRmyA.performPostRequest)(`${baseUrl}/rest/jpo/1.0/parent/suggest`, {
            body: JSON.stringify({
                query: query,
                projectId: projectId,
                issueTypeId: issueTypeId,
                maxResults: 100
            })
        }).then((suggestion)=>(0, $dtZSS.transformSuggestions)(suggestion, baseUrl, initialValue)) : []);
const $b1e628d77c37077f$var$ParentView = ({ epic: epic, isVisible: isVisible, ...otherProps })=>{
    if (!isVisible) return null;
    const hasEpic = epic !== null && epic !== undefined;
    // @ts-expect-error - TS2783 - 'hasEpic' is specified more than once, so this usage will be overwritten.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $YLXGO.default), {
        hasEpic: hasEpic,
        ...otherProps
    });
};
var $b1e628d77c37077f$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: (state, context)=>(0, $dtZSS.transformFromStateValue)(state, context),
        transformToStateValue: $dtZSS.transformToStateValue,
        additionalProps: (state, intl)=>({
                fetchSuggestions: $b1e628d77c37077f$var$fetchSuggestionsFactory((0, $5JqpU.baseUrlSelector)(state), (0, $jZDJX.projectIdSelector)(state), (0, $9D3Vo.issueTypeIdSelector)(state), (0, $fokFV.fieldPendingValueSelector)(ownPropsOnMount.fieldId)(state)),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                epic: (0, $fAlCw.epicSelector)(state),
                isVisible: (0, $zaqzH.isParentTypeVisibleSelector)(ownPropsOnMount.fieldId)(state),
                portalElement: (0, $40QX1.isFieldInTabSelector)(ownPropsOnMount.fieldId)(state) // Using portalElement because otherwise dropdowns would get cut off by the container borders. See BENTO-4101
                 ? (0, $brySu.getIssueModalAkDropdownPortal)() || document.body : undefined,
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            }),
        saveField: ({ baseUrl: baseUrl, issueKey: issueKey, fieldMetaKey: fieldMetaKey, value: value })=>(0, $lRmyA.performPutRequest)((0, $lV5H0.getIssueApiUrl)(baseUrl, issueKey), {
                body: JSON.stringify({
                    fields: {
                        [fieldMetaKey]: value && value.data ? value.data.key : null
                    }
                })
            })
    }))($b1e628d77c37077f$var$ParentView);

});
parcelRegister("YLXGO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7557c6c93a7a076a$export$2e2bcd8739ae039);

var $4qNe1 = parcelRequire("4qNe1");
var $7557c6c93a7a076a$export$2e2bcd8739ae039 = (0, $4qNe1.default);

});
parcelRegister("4qNe1", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc728d99d75d1c0$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $f8Yej = parcelRequire("f8Yej");

var $9LvPd = parcelRequire("9LvPd");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $6oQPP = parcelRequire("6oQPP");
var $5St1r = parcelRequire("5St1r");

var $4bZws = parcelRequire("4bZws");

var $KpAsD = parcelRequire("KpAsD");

var $i4m05 = parcelRequire("i4m05");

var $lxqVm = parcelRequire("lxqVm");

var $hIhWc = parcelRequire("hIhWc");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9fc728d99d75d1c0$var$InlineEditParentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5St1r.InlineEditContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !__cmplp.isEditable && "_f8epkb7n _16ksyh40 _c4daidpf _shl0yh40 _c0f6idpf",
            __cmplp.className
        ])
    });
});
$9fc728d99d75d1c0$var$InlineEditParentContainer.displayName = 'InlineEditParentContainer';
class $9fc728d99d75d1c0$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    renderEditableField() {
        const { onChange: onChange, onConfirm: onConfirm, fetchSuggestions: fetchSuggestions, value: value, portalElement: portalElement, menuPlacement: menuPlacement } = this.props;
        // Using an extra span to explicitly mark this as not included by our selector.
        // We are using the custom wrapper + selector as a workaround until we can move
        // to using inline edits in compact mode.
        // See: https://jdog.jira-dev.com/browse/BENTO-2979
        return !this.shouldShowError() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxqVm.default), {
            value: value,
            loadOptions: fetchSuggestions,
            portalElement: portalElement,
            menuPlacement: menuPlacement,
            onChange: onChange,
            onConfirm: onConfirm
        })) : null;
    }
    render() {
        const { isEditing: isEditing, onConfirm: onConfirm, onCancel: onCancel, onEditRequest: onEditRequest, isMobile: isMobile, isEditable: isEditable, fieldId: fieldId, label: label, showPinButton: showPinButton, issueKey: issueKey } = this.props;
        // The Parent Link field is being deprecated in favour of the Parent field
        // Regardless of whether it is editable or not, we should block the user from actually editing it
        // And render a read view that indicates to the user that they should use the Parent field instead.
        const isEditableWithParentField = (0, $i4m05.isDisableEpicLinkAndParentLinkFieldsEnabled)() ? false : isEditable;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, label), issueKey !== undefined && fieldId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
            issueKey: issueKey,
            fieldKey: fieldId,
            label: label
        }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
            fieldId: fieldId,
            label: label
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), {
            isEditing: isEditing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
            onEscape: onCancel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9fc728d99d75d1c0$var$InlineEditParentContainer, {
            isEditable: isEditableWithParentField
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
            isLabelHidden: true,
            label: label,
            readView: this.renderReadView(),
            editView: isEditableWithParentField ? this.renderEditableField() : null,
            // @ts-expect-error - TS2322 - Property 'disableEditViewFieldBase' does not exist on type 'IntrinsicAttributes & FieldInlineEditStateLessProps<unknown>'.
            disableEditViewFieldBase: true,
            areActionButtonsHidden: true,
            isEditing: isEditing,
            onConfirm: onConfirm,
            onCancel: onCancel,
            onEditRequested: onEditRequest,
            isFitContainerWidthReadView: !isMobile,
            isEditable: isEditableWithParentField
        })))));
    }
    constructor(...args){
        super(...args);
        this.shouldShowError = ()=>this.props.hasEpic && this.props.value?.hasEpicLinkFieldDependency;
        this.renderReadView = ()=>{
            const { value: value, noValueText: noValueText } = this.props;
            return (0, $i4m05.isDisableEpicLinkAndParentLinkFieldsEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5St1r.ReadViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $KpAsD.DisabledInlineReadView), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5St1r.ReadViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hIhWc.default), {
                noValueText: noValueText,
                value: value,
                showError: this.shouldShowError()
            }));
        };
    }
}

});
parcelRegister("lxqVm", function(module, exports) {

$parcel$export(module.exports, "default", () => $af846c859497e9b2$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $lSBJq = parcelRequire("lSBJq");
var $af846c859497e9b2$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $lSBJq.default));

});
parcelRegister("lSBJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $53d474988586dc34$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dxIU5 = parcelRequire("dxIU5");

var $lXktr = parcelRequire("lXktr");
var $jQxSL = parcelRequire("jQxSL");

var $4ksts = parcelRequire("4ksts");

var $4NcaX = parcelRequire("4NcaX");

var $fVxie = parcelRequire("fVxie");
const $53d474988586dc34$var$MenuList = (props)=>{
    const intl = (0, $4ksts.useIntlV2)();
    return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 8 more.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MenuList, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53d474988586dc34$var$Container, null, intl.formatMessage((0, $fVxie.default).menuHeader)), props.children));
};
const $53d474988586dc34$var$Option = (props)=>{
    const optionValue = props.data.data;
    if (optionValue) {
        const { issueType: issueType, summary: summary, key: key } = optionValue;
        const { iconUrl: iconUrl } = issueType;
        return(// @ts-expect-error - TS2740 - Type '{ children: Element; data: ParentFieldType; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 8 more.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53d474988586dc34$var$OptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53d474988586dc34$var$Icon, {
            src: iconUrl
        }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53d474988586dc34$var$OptionText, null, key, " ", summary))));
    }
    return null;
};
const $53d474988586dc34$var$SingleValue = (props)=>{
    const intl = (0, $4ksts.useIntlV2)();
    const { data: data } = props.data;
    const label = data ? data.label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53d474988586dc34$var$Placeholder, null, intl.formatMessage((0, $fVxie.default).placeholder));
    // @ts-expect-error - TS2740 - Type '{ children: string | Element; data: ParentFieldType; }' is missing the following properties from type 'CommonProps<ParentFieldType, false, GroupTypeBase<ParentFieldType>>': clearValue, cx, getStyles, getValue, and 8 more.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).SingleValue, props, label);
};
class $53d474988586dc34$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { value: value, portalElement: portalElement, menuPlacement: menuPlacement, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXktr.default), {
            value: value,
            autoFocus: true,
            defaultOptions: true,
            components: {
                MenuList: $53d474988586dc34$var$MenuList,
                Option: $53d474988586dc34$var$Option,
                SingleValue: $53d474988586dc34$var$SingleValue
            },
            menuPortalTarget: portalElement,
            // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'MenuPlacement | undefined'.
            menuPlacement: menuPlacement,
            // @ts-expect-error - TS2322 - Type '(value?: ParentFieldType | undefined) => void' is not assignable to type '(value: ParentFieldType | null, action: ActionMeta<ParentFieldType>) => void'.
            onChange: this.onChange,
            loadOptions: this.debouncedLoadOptions,
            defaultMenuIsOpen: true,
            isClearable: value.data !== null,
            noOptionsMessage: ()=>formatMessage((0, $fVxie.default).noMatches),
            styles: (0, $4NcaX.defaultSelectStyles),
            cacheOptions: true
        });
    }
    constructor(...args){
        super(...args);
        this.onChange = (value)=>{
            const { hasEpicLinkFieldDependency: hasEpicLinkFieldDependency, showField: showField } = this.props.value;
            const selectedData = value != null ? value.data : null;
            const selectedValue = {
                data: selectedData,
                value: selectedData ? selectedData.key : null,
                hasEpicLinkFieldDependency: hasEpicLinkFieldDependency,
                showField: showField
            };
            this.props.onChange(selectedValue);
            this.props.onConfirm(selectedValue);
        };
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((searchText, callback)=>{
            this.props.loadOptions(searchText).then(callback, ()=>{
                callback([]);
            });
        }, 300);
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $53d474988586dc34$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $53d474988586dc34$var$OptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $53d474988586dc34$var$OptionText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $53d474988586dc34$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41mul",
            __cmplp.className
        ])
    });
});
const $53d474988586dc34$var$Placeholder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1ifp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fVxie", function(module, exports) {

$parcel$export(module.exports, "default", () => $d864ae05f1f6a7f8$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $d864ae05f1f6a7f8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    menuHeader: {
        "id": "issue.views.field.parent.edit.menuHeader",
        "defaultMessage": "To set an epic as a parent, use the epic link instead."
    },
    noMatches: {
        "id": "issue.views.field.parent.edit.noMatches",
        "defaultMessage": "No Matches"
    },
    placeholder: {
        "id": "issue.views.field.parent.edit.placeholder",
        "defaultMessage": "Choose a parent to assign this issue to."
    }
});

});



parcelRegister("hIhWc", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd2de80366aafcbf$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4xwq2 = parcelRequire("4xwq2");

var $g0dp4 = parcelRequire("g0dp4");
const $dd2de80366aafcbf$var$ParentViewField = (props)=>{
    const { showError: showError, value: value, noValueText: noValueText } = props;
    if (showError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g0dp4.default), null);
    if (value.data) {
        const { key: key, summary: summary, issueType: { iconUrl: iconUrl }, url: url } = value.data;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd2de80366aafcbf$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd2de80366aafcbf$var$Icon, {
            src: iconUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd2de80366aafcbf$var$Link, {
            href: url,
            target: "_blank"
        }, key), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd2de80366aafcbf$var$Summary, null, summary));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), null, noValueText);
};
var $dd2de80366aafcbf$export$2e2bcd8739ae039 = $dd2de80366aafcbf$var$ParentViewField;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dd2de80366aafcbf$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1reo15vq _18m915vq _o5721q9c",
            __cmplp.className
        ])
    });
});
const $dd2de80366aafcbf$var$Link = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _80omtlke",
            __cmplp.className
        ])
    });
});
const $dd2de80366aafcbf$var$Summary = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $dd2de80366aafcbf$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("g0dp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $31d1b86f6fbe90ea$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ZBodB = parcelRequire("ZBodB");
const $31d1b86f6fbe90ea$var$EpicLinkExistsMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31d1b86f6fbe90ea$var$Container, null, formatMessage((0, $ZBodB.default).epicLinkExists));
};
var $31d1b86f6fbe90ea$export$2e2bcd8739ae039 = $31d1b86f6fbe90ea$var$EpicLinkExistsMessage;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31d1b86f6fbe90ea$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1ifp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ZBodB", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fc57ab7efff080b$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $7fc57ab7efff080b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    epicLinkExists: {
        "id": "issue.views.field.parent.epic-link-exists-message.epicLinkExists",
        "defaultMessage": "Cannot use parent link when epic link is set."
    }
});

});





parcelRegister("zaqzH", function(module, exports) {

$parcel$export(module.exports, "isRequestLanguageVisibleSelector", () => $d7194d3b43ef1aef$export$a8e89722b32669c7);
$parcel$export(module.exports, "isRequestFeedbackVisibleSelector", () => $d7194d3b43ef1aef$export$58613045a8d6f662);
$parcel$export(module.exports, "isParentTypeVisibleSelector", () => $d7194d3b43ef1aef$export$f507970ff4b62a9e);

var $df4Sl = parcelRequire("df4Sl");

var $fokFV = parcelRequire("fokFV");

var $9F6MO = parcelRequire("9F6MO");
const $d7194d3b43ef1aef$export$a8e89722b32669c7 = (fieldId)=>(0, $df4Sl.createSelector)((0, $fokFV.fieldAllowedValuesSelector)(fieldId), (requestLanguageDataAllowedValues)=>!requestLanguageDataAllowedValues || requestLanguageDataAllowedValues.length > 1);
const $d7194d3b43ef1aef$export$58613045a8d6f662 = (fieldId)=>(0, $df4Sl.createSelector)((0, $9F6MO.canUseServiceDeskAgentFeaturesSelector), (0, $fokFV.fieldPersistedValueSelector)(fieldId), (canUseServiceDeskAgentFeatures, fieldPersistedValue)=>Boolean(canUseServiceDeskAgentFeatures && fieldPersistedValue && fieldPersistedValue.rating));
const $d7194d3b43ef1aef$export$f507970ff4b62a9e = (fieldId)=>(0, $df4Sl.createSelector)((0, $fokFV.fieldPendingValueSelector)(fieldId), (fieldPendingValue)=>Boolean(fieldPendingValue && (fieldPendingValue.showField || fieldPendingValue.hasEpicLinkFieldDependency)));

});

parcelRegister("fAlCw", function(module, exports) {

$parcel$export(module.exports, "epicSelector", () => $97b85317133225bf$export$2370ebfc2175976e);
$parcel$export(module.exports, "isClassicOrNextGenEpicSelector", () => $97b85317133225bf$export$d104ff91326403ed);

var $df4Sl = parcelRequire("df4Sl");

var $3l6tm = parcelRequire("3l6tm");

var $f9RL0 = parcelRequire("f9RL0");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $1b2Vj = parcelRequire("1b2Vj");
const $97b85317133225bf$export$2370ebfc2175976e = (0, $df4Sl.createSelector)((0, $fokFV.fieldPendingValueSelector)((0, $f9RL0.EPIC)), (epicField)=>epicField !== null ? epicField : undefined);
const $97b85317133225bf$export$d104ff91326403ed = (0, $df4Sl.createSelector)((0, $jZDJX.isEpicSelector), (0, $1b2Vj.hierarchyLevelSelector), (isClassicEpic, issueHierarchyLevel)=>isClassicEpic || (0, $3l6tm.isEpicHierarchyLevel)(issueHierarchyLevel));

});

parcelRegister("dtZSS", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $b3cd722049a949f9$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $b3cd722049a949f9$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformSuggestions", () => $b3cd722049a949f9$export$1d0ee4320c26fb60);
const $b3cd722049a949f9$var$defaultStateValue = {
    data: null,
    hasEpicLinkFieldDependency: false,
    showField: false
};
const $b3cd722049a949f9$var$toItem = (issue, baseUrl)=>({
        hasEpicLinkFieldDependency: issue.hasEpicLinkFieldDependency,
        showField: issue.showField,
        value: issue.data && issue.data.key ? issue.data.key : null,
        data: issue.data ? {
            key: issue.data.key,
            value: issue.data.key,
            summary: issue.data.summary,
            url: `${baseUrl}/browse/${issue.data.key}`,
            label: `${issue.data.key} ${issue.data.summary}`,
            issueType: issue.data.issueType ? {
                iconUrl: `${baseUrl}${issue.data.issueType.iconUrl}`,
                id: String(issue.data.issueType.id)
            } : issue.data.issueType
        } : null
    });
const $b3cd722049a949f9$export$cb172b2468ab5652 = (// Value returned from state can be void -> Fallback required
stateValue = $b3cd722049a949f9$var$defaultStateValue, // eslint-disable-next-line @typescript-eslint/no-explicit-any
transformerContext)=>$b3cd722049a949f9$var$toItem(stateValue, transformerContext.baseUrl);
const $b3cd722049a949f9$export$1cfcb95cb8fbddb3 = (value)=>value;
const $b3cd722049a949f9$export$1d0ee4320c26fb60 = (suggestionsFromServer, baseUrl, // Initial value returned from pendingState selector can be void -> Fallback required
initialValue = {
    hasEpicLinkFieldDependency: false,
    showField: false
})=>{
    if (!suggestionsFromServer || !suggestionsFromServer.issues || suggestionsFromServer.issues.length <= 0) return [];
    const { projects: projects } = suggestionsFromServer;
    const avatars = suggestionsFromServer.issueTypes;
    const formattedData = suggestionsFromServer.issues.map((issue)=>{
        const projectKey = projects.filter((p)=>p.id === issue.projectId)[0].key;
        const issueKey = `${projectKey}-${issue.issueKey}`; // e.g. ABC-123
        const { iconUrl: iconUrl } = avatars.filter((icon)=>+icon.id === issue.issueTypeId)[0];
        return {
            data: {
                key: issueKey,
                summary: issue.issueSummary,
                value: issueKey,
                label: `${issueKey} ${issue.issueSummary}`,
                issueType: {
                    id: String(issue.issueTypeId),
                    iconUrl: `${baseUrl}${iconUrl}`
                },
                url: `${baseUrl}/browse/${issueKey}`
            },
            hasEpicLinkFieldDependency: initialValue.hasEpicLinkFieldDependency,
            showField: initialValue.showField,
            value: issueKey
        };
    });
    return formattedData;
};

});


parcelRegister("cKvbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0315a9018b476600$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $1TrR5 = parcelRequire("1TrR5");

var $6vrw7 = parcelRequire("6vrw7");

var $ifZde = parcelRequire("ifZde");

var $3F9y1 = parcelRequire("3F9y1");
const $0315a9018b476600$var$emptyField = {};
const $0315a9018b476600$var$emptyConfiguration = {};
const $0315a9018b476600$var$additionalPropsFactory = (0, $5iWql.default)((fieldId, area)=>(state)=>{
        const field = (0, $fokFV.fieldSelector)(fieldId)(state) || $0315a9018b476600$var$emptyField;
        return {
            baseUrl: (0, $6vrw7.toBaseUrl)((0, $5JqpU.baseUrlSelector)(state)),
            // @ts-expect-error - TS2339 - Property 'configuration' does not exist on type '{}'.
            configuration: field.configuration || $0315a9018b476600$var$emptyConfiguration,
            showPinButton: (0, $hHKWU.default)(area)
        };
    });
var $0315a9018b476600$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, { fieldId: fieldId, area: area })=>({
        fieldId: fieldId,
        transformFromStateValue: $ifZde.transformFromStateValue,
        transformToStateValue: $ifZde.transformToStateValue,
        additionalProps: (0, $1TrR5.functionWithFFRedux)($0315a9018b476600$var$additionalPropsFactory(fieldId, area), (state)=>{
            const field = (0, $fokFV.fieldSelector)(fieldId)(state) || {};
            return {
                baseUrl: (0, $6vrw7.toBaseUrl)((0, $5JqpU.baseUrlSelector)(state)),
                // @ts-expect-error - TS2339 - Property 'configuration' does not exist on type '{}'.
                configuration: field.configuration || {},
                showPinButton: (0, $hHKWU.default)(area)
            };
        })
    }))((0, $3F9y1.People));

});
parcelRegister("ifZde", function(module, exports) {

$parcel$export(module.exports, "transformToStateValue", () => $06b529054f3e9d25$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformFromStateValue", () => $06b529054f3e9d25$export$cb172b2468ab5652);

var $6vrw7 = parcelRequire("6vrw7");
const $06b529054f3e9d25$var$avatarSize = '24x24';
const $06b529054f3e9d25$export$1cfcb95cb8fbddb3 = (value)=>value.map((item)=>({
            id: (0, $6vrw7.toAccountId)(item.id),
            accountId: (0, $6vrw7.toAccountId)(item.id),
            displayName: item.name,
            avatarUrls: {
                [$06b529054f3e9d25$var$avatarSize]: item.avatarUrl
            }
        }));
const $06b529054f3e9d25$var$toUser = (data)=>{
    if (!data || typeof data !== 'object' || !data.accountId || !data.displayName) return null;
    let avatarUrl = '';
    if (data.avatarUrls && typeof data.avatarUrls === 'object') avatarUrl = String(data.avatarUrls[$06b529054f3e9d25$var$avatarSize]);
    return {
        id: String(data.accountId),
        name: String(data.displayName),
        type: 'user',
        fixed: false,
        avatarUrl: avatarUrl
    };
};
const $06b529054f3e9d25$export$cb172b2468ab5652 = (value)=>{
    // Custom fields can have a null value
    if (!Array.isArray(value)) return [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return value.reduce((users, item)=>{
        const user = $06b529054f3e9d25$var$toUser(item);
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        return user ? [
            ...users,
            user
        ] : users;
    }, []);
};

});

parcelRegister("3F9y1", function(module, exports) {

$parcel$export(module.exports, "People", () => $b9d23e9bbb2f6f6c$export$8d3edc4d62e152ad);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5iWql = parcelRequire("5iWql");

var $iJlfe = parcelRequire("iJlfe");

var $f8Yej = parcelRequire("f8Yej");

var $2gGF1 = parcelRequire("2gGF1");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9LvPd = parcelRequire("9LvPd");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $6oQPP = parcelRequire("6oQPP");
var $5St1r = parcelRequire("5St1r");

var $4bZws = parcelRequire("4bZws");

var $huhk2 = parcelRequire("huhk2");

var $ac6FY = parcelRequire("ac6FY");

var $iYP3S = parcelRequire("iYP3S");

var $2QP4C = parcelRequire("2QP4C");
const $b9d23e9bbb2f6f6c$var$nonEditableStyles = null;
const $b9d23e9bbb2f6f6c$var$toTags = (0, $5iWql.default)((users)=>users.map((user)=>({
            value: user.id,
            content: user.name,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                size: "xsmall",
                src: user.avatarUrl
            })
        })));
const $b9d23e9bbb2f6f6c$var$isMulti = (configuration)=>!configuration || configuration.isMulti !== false;
const $b9d23e9bbb2f6f6c$var$isValid = ({ configuration: configuration, value: value })=>!$b9d23e9bbb2f6f6c$var$isMulti(configuration) && value.length > 1;
const $b9d23e9bbb2f6f6c$var$RenderReadView = ({ value: value, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ac6FY.default), {
        value: $b9d23e9bbb2f6f6c$var$toTags(value),
        noValueText: formatMessage((0, $huhk2.genericMessages).noValue),
        tagAppearance: "rounded",
        shouldHideLinks: isMobile,
        isUserTag: true
    });
};
const $b9d23e9bbb2f6f6c$var$RenderEditView = ({ configuration: configuration, value: value, baseUrl: baseUrl, onChange: onChange, issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isMultiMode = $b9d23e9bbb2f6f6c$var$isMulti(configuration) || value.length > 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iYP3S.default), {
        baseUrl: baseUrl,
        isMulti: isMultiMode,
        autoFocus: true,
        isInvalid: $b9d23e9bbb2f6f6c$var$isValid({
            configuration: configuration,
            value: value
        }),
        isInputDisabled: $b9d23e9bbb2f6f6c$var$isValid({
            configuration: configuration,
            value: value
        }),
        invalidMessage: formatMessage((0, $2QP4C.default).singleValueValidationError),
        placeholder: formatMessage(isMultiMode ? (0, $2QP4C.default).placeholderMulti : (0, $2QP4C.default).placeholderSingle),
        isDisabled: false,
        appearance: "compact",
        onChange: onChange,
        value: value,
        issueKey: issueKey
    });
};
const $b9d23e9bbb2f6f6c$export$8d3edc4d62e152ad = (props)=>{
    const { isEditable: isEditable, isEditing: isEditing, isMobile: isMobile, issueKey: issueKey, label: label, configuration: configuration, baseUrl: baseUrl, value: value, fieldId: fieldId, showPinButton: showPinButton, onChange: onChange, onEditRequest: onEditRequest, onConfirm: onConfirm, onCancel: onCancel } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isSingleMode = !$b9d23e9bbb2f6f6c$var$isMulti(configuration) && value.length <= 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, label), issueKey !== undefined && fieldId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldId,
        label: label
    }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldId,
        label: label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), {
        isEditing: isEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
        onEscape: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b9d23e9bbb2f6f6c$var$PeopleInlineEditContainer, {
        isEditable: isEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        isLabelHidden: true,
        label: label,
        readView: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5St1r.ReadViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b9d23e9bbb2f6f6c$var$RenderReadView, {
            value: value,
            isMobile: isMobile
        })),
        editView: isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b9d23e9bbb2f6f6c$var$RenderEditView, {
            configuration: configuration,
            value: value,
            baseUrl: baseUrl,
            onChange: onChange,
            issueKey: issueKey
        }) : null,
        disableEditViewFieldBase: true,
        isEditing: isEditing,
        shouldConfirmOnEnter: isSingleMode,
        // we should remove it from here or implement the isValid functionality in FieldInlineEditStateLess
        isValid: isEditing ? $b9d23e9bbb2f6f6c$var$isValid({
            configuration: configuration,
            value: value
        }) : true,
        onConfirm: onConfirm,
        onCancel: onCancel,
        areActionButtonsHidden: isSingleMode,
        onEditRequested: onEditRequest,
        isFitContainerWidthReadView: !isMobile,
        editButtonLabel: formatMessage((0, $2gGF1.default).editButtonLabel, {
            fieldName: label
        }),
        confirmButtonLabel: formatMessage((0, $2gGF1.default).confirmButtonLabel, {
            fieldName: label
        }),
        cancelButtonLabel: formatMessage((0, $2gGF1.default).cancelButtonLabel, {
            fieldName: label
        }),
        onEscape: onCancel,
        isEditable: isEditable
    })))));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b9d23e9bbb2f6f6c$var$PeopleInlineEditContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5St1r.InlineEditContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !__cmplp.isEditable && "_18u0idpf _1bchidpf _1yb1idpf _79paidpf _1rhwidpf _15x6idpf _wqg61dkb _170didpf _q7f5idpf _1tq6idpf _pjvaidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iYP3S", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eb13b32fd266703$export$2e2bcd8739ae039);

var $frGUG = parcelRequire("frGUG");
var $0eb13b32fd266703$export$2e2bcd8739ae039 = (0, $frGUG.default);

});
parcelRegister("frGUG", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb8be85eff134653$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $kwce8 = parcelRequire("kwce8");

var $dxIU5 = parcelRequire("dxIU5");

var $5YsMl = parcelRequire("5YsMl");

var $29yDk = parcelRequire("29yDk");

var $PdmhA = parcelRequire("PdmhA");

var $3Kv5Q = parcelRequire("3Kv5Q");

var $c9TLT = parcelRequire("c9TLT");

var $giAhk = parcelRequire("giAhk");

var $7HH9W = parcelRequire("7HH9W");

var $1JAiO = parcelRequire("1JAiO");
const $bb8be85eff134653$var$DropdownPortal = ({ innerRef: innerRef, isOpen: isOpen })=>{
    if (document.body !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bb8be85eff134653$var$DropdownWrapper, {
        isOpen: isOpen,
        innerRef: innerRef
    }), document.body);
    return null;
};
class $bb8be85eff134653$export$60af7cb065ef1e98 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isInvalid: false,
            isInputDisabled: false,
            appearance: 'normal',
            placeholder: '',
            value: undefined,
            minQueryLength: 1,
            autoFocus: false,
            invalidMessage: '',
            usePortalForDropdown: true
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.isInputDisabled && state.isOpen) return {
            isOpen: false
        };
        return null;
    }
    constructor(props){
        super(props);
        this.onChange = (value)=>{
            this.setState({
                isOpen: false
            });
            if (value && !Array.isArray(value)) this.props.onChange([
                value
            ]);
            else this.props.onChange(value || []);
        };
        this.onDropdownPortalRefChange = (ref)=>{
            if (!this.dropdownPortalRef && ref) this.setState({
                isDropdownPortalReady: true
            });
            this.dropdownPortalRef = ref;
        };
        this.onQueryChange = (query)=>{
            const { minQueryLength: minQueryLength } = this.props;
            if (query === undefined || query === '' || query.length < minQueryLength) {
                this.setState({
                    isLoading: false,
                    query: query,
                    options: []
                });
                return;
            }
            this.setState({
                query: query,
                isLoading: true
            }, ()=>this.updateOptions(query));
        };
        this.onBlur = ()=>this.setState({
                isOpen: false
            });
        // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.getNoOptionsMessage = ()=>{
            const { query: query } = this.state;
            const { minQueryLength: minQueryLength, intl: { formatMessage: formatMessage } } = this.props;
            const queryLength = query == null ? 0 : query.length;
            return formatMessage(queryLength < minQueryLength ? (0, $1JAiO.default).startTyping : (0, $1JAiO.default).empty);
        };
        this.updateOptions = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((query)=>{
            this.fetchOptions(query).then((options)=>{
                if (query !== this.state.query) return;
                this.setState({
                    options: options,
                    isOpen: true,
                    isLoading: false
                });
            }).catch(()=>{
                if (query === this.state.query) this.setState({
                    isLoading: false
                });
            });
        }, 300);
        this.cache = {};
        this.dropdownPortalRef = null;
        this.state = {
            query: '',
            options: [],
            isLoading: false,
            isDropdownPortalReady: false,
            // right now this is the only way to simulate 'autoFocus' behaviour for UserPicker
            isOpen: props.autoFocus
        };
    }
    getValue() {
        const { isMulti: isMulti, value: value } = this.props;
        if (isMulti || !value) return value;
        return value.length ? value[0] : null;
    }
    fetchOptions(query = '') {
        if (this.cache[query]) return Promise.resolve(this.cache[query]);
        const fetch = async ()=>{
            const response = await (0, $7HH9W.default)(this.props.projectKey, this.props.issueKey, query);
            this.cache[query] = response;
            return response;
        };
        return fetch();
    }
    renderUserPicker() {
        const { isLoading: isLoading, options: options, isOpen: isOpen, isDropdownPortalReady: isDropdownPortalReady } = this.state;
        const { isMulti: isMulti, usePortalForDropdown: usePortalForDropdown, appearance: appearance, placeholder: placeholder, isDisabled: isDisabled, isInvalid: isInvalid, invalidMessage: invalidMessage, isInputDisabled: isInputDisabled, inputId: inputId } = this.props;
        const { dropdownPortalRef: dropdownPortalRef } = this;
        if (usePortalForDropdown && !isDropdownPortalReady) // we should wait for dropdown wrapper
        // otherwise the first mount can look weird
        return null;
        const userPicker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Kv5Q.UserPicker), {
            width: "100%",
            isLoading: isLoading,
            options: options,
            addMoreMessage: "",
            onBlur: this.onBlur,
            isClearable: true,
            onInputChange: this.onQueryChange,
            open: !isInputDisabled && isOpen,
            // This needs to be passed as a function due to a bug in the component
            // https://product-fabric.atlassian.net/browse/FS-4023
            noOptionsMessage: this.getNoOptionsMessage,
            menuPortalTarget: dropdownPortalRef || undefined,
            isMulti: isMulti,
            disableInput: isInputDisabled,
            appearance: appearance,
            placeholder: placeholder,
            // @ts-expect-error - TS2322 - Type 'User | readonly User[] | null | undefined' is not assignable to type 'Value'.
            value: this.getValue(),
            onChange: this.onChange,
            isDisabled: isDisabled,
            fieldId: "people-field",
            inputId: inputId,
            UNSAFE_hasDraggableParentComponent: true
        });
        if (!isInvalid) return userPicker;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
            isOpen: true,
            content: invalidMessage,
            placement: "right"
        }, userPicker, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bb8be85eff134653$var$WarningIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "warning"
        })));
    }
    render() {
        const { isOpen: isOpen } = this.state;
        const { usePortalForDropdown: usePortalForDropdown } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.renderUserPicker(), usePortalForDropdown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bb8be85eff134653$var$DropdownPortal, {
            isOpen: isOpen,
            innerRef: this.onDropdownPortalRefChange
        }) : null);
    }
}
// @ts-expect-error - TS2322 - Type 'ComponentType<Diff<Record<any, any> | (Record<any, any> & { children?: ReactNode; }), InjectIntlVoidProps>>' is not assignable to type 'ComponentType<PeopleFieldPropsWithDefault>'. | TS2345 - Argument of type 'typeof PeopleField' is not assignable to parameter of type 'ComponentType<Record<any, any>>'.
const $bb8be85eff134653$var$WithIntl = (0, $giAhk.injectIntlV2)($bb8be85eff134653$export$60af7cb065ef1e98);
var $bb8be85eff134653$export$2e2bcd8739ae039 = $bb8be85eff134653$var$WithIntl;
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb8be85eff134653$var$DropdownWrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-15ma8sh-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $c9TLT.layers).modal,
        overflow: 'visible',
        position: 'absolute',
        left: 0,
        top: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.isOpen ? undefined : 'none'
    }));
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb8be85eff134653$var$WarningIcon = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-15ma8sh-1"
})({
    zIndex: 1,
    position: 'absolute',
    right: "var(--ds-space-050, 4px)",
    bottom: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-warning, ${(0, $PdmhA).yellow()})`
});

});
parcelRegister("7HH9W", function(module, exports) {

$parcel$export(module.exports, "default", () => $a141f739949b537a$export$2e2bcd8739ae039);

var $2OdyW = parcelRequire("2OdyW");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a141f739949b537a$var$toItem = (user)=>({
        avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
        id: user.accountId,
        name: user.displayName,
        byline: user.emailAddress,
        type: 'user',
        fixed: false
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a141f739949b537a$var$transform = (value)=>value ? $a141f739949b537a$var$toItem(value) : null;
const $a141f739949b537a$var$getUrl = (projectKey, issueKey, query)=>`/rest/api/3/user/recommend?${new URLSearchParams({
        context: 'People',
        ...projectKey && {
            project: projectKey
        },
        ...issueKey && {
            issueKey: issueKey
        },
        query: query
    })}`;
const $a141f739949b537a$var$searchUser = async (projectKey, issueKey, query)=>{
    const response = await (0, $2OdyW.default)($a141f739949b537a$var$getUrl(projectKey, issueKey, query));
    return response.map($a141f739949b537a$var$transform);
};
var $a141f739949b537a$export$2e2bcd8739ae039 = $a141f739949b537a$var$searchUser;

});

parcelRegister("1JAiO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c17901a3957e1f37$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $c17901a3957e1f37$var$messages = (0, $90IgZ.defineMessages)({
    startTyping: {
        "id": "project-settings-apps.people-field.start-typing",
        "defaultMessage": "Start typing"
    },
    empty: {
        "id": "project-settings-apps.people-field.empty",
        "defaultMessage": "No options"
    }
});
var $c17901a3957e1f37$export$2e2bcd8739ae039 = $c17901a3957e1f37$var$messages;

});



parcelRegister("2QP4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9a7608a7cae76dd$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $f9a7608a7cae76dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholderMulti: {
        "id": "issue.people.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "Choose people"
    },
    placeholderSingle: {
        "id": "issue.people.text-for-edit-view-when-no-value-is-provided-single-mode",
        "defaultMessage": "Choose a person"
    },
    singleValueValidationError: {
        "id": "issue.people.single-value-validation-error",
        "defaultMessage": "You can only add one person to this field"
    }
});

});



parcelRegister("6PFPL", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e22ccc5a38af3c7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dNhRY = parcelRequire("dNhRY");

var $ldoFd = parcelRequire("ldoFd");

var $5iWql = parcelRequire("5iWql");

var $90IgZ = parcelRequire("90IgZ");

var $iSDPL = parcelRequire("iSDPL");

var $jxxzJ = parcelRequire("jxxzJ");

var $huhk2 = parcelRequire("huhk2");

var $brySu = parcelRequire("brySu");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $4kDvN = parcelRequire("4kDvN");

var $lqalZ = parcelRequire("lqalZ");

var $fokFV = parcelRequire("fokFV");

var $fVCj0 = parcelRequire("fVCj0");

var $40QX1 = parcelRequire("40QX1");

var $hByPr = parcelRequire("hByPr");

var $8WZQM = parcelRequire("8WZQM");

var $hnJ03 = parcelRequire("hnJ03");
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ const $3e22ccc5a38af3c7$var$messages = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.priority.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "Select priority"
    }
});
const $3e22ccc5a38af3c7$var$fetchSuggestionsFactory = (0, $5iWql.default)((suggestions)=>()=>Promise.resolve(suggestions).then((0, $hnJ03.transformSuggestions)));
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $3e22ccc5a38af3c7$var$onDataRequest = ()=>{};
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $3e22ccc5a38af3c7$var$onDataLoaded = ()=>{};
const $3e22ccc5a38af3c7$export$f042834aee608b6c = (props)=>{
    const { isEditing: isEditing, value: value, onChange: onChange, onEditRequest: onEditRequest, onConfirm: onConfirm, onCancel: onCancel, issueKey: issueKey, onSave: onSave, ...rest } = props;
    const selectProps = {
        ...rest,
        isEditing: isEditing,
        value: value
    };
    const wasOnChangeCalled = (0, $eUqFw.useRef)(false);
    const [{ value: valueInSweetState }] = (0, $iSDPL.usePriorityField)({
        issueKey: issueKey
    });
    (0, $eUqFw.useEffect)(()=>{
        // Check for values to be present, and check user has not changed the value from the issue view before allowing the state to sync
        const valueUpdatedInSweetState = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(valueInSweetState) && value.content !== valueInSweetState.name && !wasOnChangeCalled.current;
        if (valueUpdatedInSweetState) onSave && onSave(valueInSweetState);
    }, [
        isEditing,
        onSave,
        value,
        valueInSweetState
    ]);
    const onChangeHandler = (0, $eUqFw.useCallback)((selectedValue)=>{
        wasOnChangeCalled.current = true;
        onChange(selectedValue);
    }, [
        onChange
    ]);
    const onEditRequestHandler = (0, $eUqFw.useCallback)(()=>{
        onEditRequest();
    }, [
        onEditRequest
    ]);
    const onConfirmHandler = (0, $eUqFw.useCallback)(()=>{
        wasOnChangeCalled.current = false;
        onConfirm();
    }, [
        onConfirm
    ]);
    const onCancelHandler = (0, $eUqFw.useCallback)(()=>{
        onCancel();
    }, [
        onCancel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jxxzJ.default), {
        ...selectProps,
        onEditRequest: onEditRequestHandler,
        onConfirm: onConfirmHandler,
        onCancel: onCancelHandler,
        onChange: onChangeHandler,
        onDataRequest: $3e22ccc5a38af3c7$var$onDataRequest,
        onDataLoaded: $3e22ccc5a38af3c7$var$onDataLoaded,
        renderReadView: (0, $hByPr.singleSelectFieldRenderReadView)(value)
    });
};
// FIXME: JIV-17455 use function composition
const $3e22ccc5a38af3c7$var$ConnectedField = (0, $lqalZ.connect)(undefined, (dispatch, ownProps)=>({
        onSave: (value)=>dispatch((0, $fVCj0.fieldUpdate)(ownProps.fieldId, value, ownProps.fieldOptions))
    }))($3e22ccc5a38af3c7$export$f042834aee608b6c);
const $3e22ccc5a38af3c7$export$171b31829f46f49a = (0, $5iWql.default)((suggestions, allowedValuesOverrides)=>(0, $8WZQM.filterAllowedValues)(suggestions, allowedValuesOverrides));
var $3e22ccc5a38af3c7$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($dNhRY)))((0, $4kDvN.withExtraOwnProps), (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $hnJ03.transformFromStateValue,
        transformToStateValue: $hnJ03.transformToStateValue,
        additionalProps: (state, intl, fieldOptions, extraOwnProps)=>({
                fetchSuggestions: $3e22ccc5a38af3c7$var$fetchSuggestionsFactory($3e22ccc5a38af3c7$export$171b31829f46f49a((0, $fokFV.fieldAllowedValuesSelector)(ownPropsOnMount.fieldId)(state), extraOwnProps?.allowedValuesOverrides)),
                placeholder: intl.formatMessage($3e22ccc5a38af3c7$var$messages.placeholder),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                portalElement: (0, $40QX1.isFieldInTabSelector)(ownPropsOnMount.fieldId)(state) ? (0, $brySu.getIssueModalAkDropdownPortal)() || document.body : undefined,
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            })
    })))($3e22ccc5a38af3c7$var$ConnectedField);

});
parcelRegister("dNhRY", function(module, exports) {

var $fpEqY = parcelRequire("fpEqY");
/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */ var $a0adb679f56a9638$var$flowRight = $fpEqY(true);
module.exports = $a0adb679f56a9638$var$flowRight;

});

parcelRegister("iSDPL", function(module, exports) {

$parcel$export(module.exports, "usePriorityField", () => $ea13115a319d0598$export$802647efbc71d051);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $ea13115a319d0598$export$802647efbc71d051 = ({ issueKey: issueKey, onFailure: onFailure, onSuccess: onSuccess })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, (0, $lO4Or.PRIORITY_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'schema.type', 'priority');
    const options = fieldConfig.value?.allowedValues ?? [];
    const [{ value: value, error: error }, { saveValue: saveValue, saveById: saveById, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $lO4Or.PRIORITY_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onFailure: onFailure,
        onSuccess: onSuccess
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig,
            options: options
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};

});

parcelRegister("hnJ03", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $0c34eb65f5599a75$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $0c34eb65f5599a75$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformSuggestions", () => $0c34eb65f5599a75$export$1d0ee4320c26fb60);
const $0c34eb65f5599a75$var$toItem = (priority)=>({
        content: priority.name,
        value: priority.id,
        iconUrl: priority.iconUrl
    });
const $0c34eb65f5599a75$export$cb172b2468ab5652 = (stateValue)=>stateValue && $0c34eb65f5599a75$var$toItem(stateValue);
const $0c34eb65f5599a75$export$1cfcb95cb8fbddb3 = (value)=>value && {
        name: value.content,
        id: value.value,
        iconUrl: value.iconUrl
    };
const $0c34eb65f5599a75$export$1d0ee4320c26fb60 = (suggestionsFromServer)=>[
        {
            items: suggestionsFromServer.map($0c34eb65f5599a75$var$toItem)
        }
    ];

});


parcelRegister("jaMGi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bfe485defde873a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $9LvPd = parcelRequire("9LvPd");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $4bZws = parcelRequire("4bZws");

var $kITvE = parcelRequire("kITvE");
var $hIoRx = parcelRequire("hIoRx");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");
const $4bfe485defde873a$var$View = ({ fieldId: fieldKey, area: area, label: label })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const showPinButton = (0, $hHKWU.default)(area);
    const [{ fieldConfig: fieldConfig }] = (0, $hIoRx.useProjectField)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldLabel = fieldConfig?.title || label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4bfe485defde873a$var$ProjectFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, fieldLabel), issueKey !== undefined && fieldKey !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldKey,
        label: fieldLabel
    }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldKey,
        label: fieldLabel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kITvE.default), {
        issueKey: issueKey,
        fieldKey: fieldKey,
        noValueText: formatMessage((0, $huhk2.genericMessages).noValue)
    })));
};
var $4bfe485defde873a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($4bfe485defde873a$var$View);
const $4bfe485defde873a$var$ProjectFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $64ypR.FieldWrapper), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tyxidpf _kgplidpf _1siwidpf _1k3tidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kITvE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5bedf8722711811$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gFVH5 = parcelRequire("gFVH5");

var $6oQPP = parcelRequire("6oQPP");
var $5St1r = parcelRequire("5St1r");

var $3koWU = parcelRequire("3koWU");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");

var $6vrw7 = parcelRequire("6vrw7");

var $25vda = parcelRequire("25vda");

var $39CTK = parcelRequire("39CTK");

var $hIoRx = parcelRequire("hIoRx");

var $cD14K = parcelRequire("cD14K");
var $b7kS0 = parcelRequire("b7kS0");

var $fNbtM = parcelRequire("fNbtM");

var $aA1aH = parcelRequire("aA1aH");
const $c5bedf8722711811$export$fd8ebf59dd2b58b6 = 'projectInlineEdit';
const $c5bedf8722711811$export$b6fef027b75b99a6 = (0, $g8JvH.AnalyticsEventToProps)('ProjectPicker', {
    onChange: 'changed'
})((0, $6oQPP.FieldInlineEditStateLess));
var $c5bedf8722711811$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { fieldKey: fieldKey, issueKey: issueKey, onCancel: onCancel, onEdit: onEdit, onEscape: onEscape, onConfirm: onConfirm, onEnter: onEnter, readView: readView, editView: editView, noValueText: noValueText, ...rest } = props;
    const [isEditing, setIsEditing] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { onFailure: showErrorFlag } = (0, $gFVH5.useFieldFlags)(); // Track mounted state of edit view for async operations
    const isMounted = (0, $3koWU.useIsMounted)();
    const onFailure = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
    (error)=>{
        showErrorFlag({
            error: error,
            title: (0, $fNbtM.default).errorTitle,
            description: (0, $fNbtM.default).errorMessage
        });
        if (isMounted.current) setIsEditing(true);
    }, [
        isMounted,
        showErrorFlag
    ]);
    const [{ value: value, error: error, fieldConfig: fieldConfig }, { resetError: resetError, saveValue: saveValue }] = (0, $hIoRx.useProjectField)({
        fieldKey: fieldKey,
        issueKey: (0, $6vrw7.toIssueKey)(issueKey),
        onFailure: onFailure
    });
    const updatedValue = (0, $eUqFw.useRef)(value);
    const allowedValues = fieldConfig?.allowedValues || [];
    const autoCompleteUrl = fieldConfig?.autoCompleteUrl ?? '';
    const isFieldEditable = fieldConfig?.isEditable ?? false;
    const save = (0, $eUqFw.useCallback)((newValue, analyticsEvent)=>{
        if (newValue !== value) saveValue(newValue, null, analyticsEvent);
        setIsEditing(false);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        saveValue,
        value
    ]);
    const saveWithoutValue = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        if (updatedValue.current !== value) saveValue(updatedValue.current, null, analyticsEvent);
        setIsEditing(false);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        saveValue,
        updatedValue,
        value
    ]);
    const cancel = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        resetError();
        updatedValue.current = value;
        setIsEditing(false);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        resetError,
        value
    ]);
    const onCancelRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onCancel && onCancel(analyticsEvent);
    }, [
        cancel,
        onCancel
    ]);
    const onConfirmRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        setIsEditing(false);
        saveWithoutValue(analyticsEvent);
    }, [
        saveWithoutValue
    ]);
    const onEditRequested = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        setIsEditing(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onEdit && onEdit(analyticsEvent);
    }, [
        onEdit
    ]);
    const onEscapeRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onEscape && onEscape(analyticsEvent);
    }, [
        onEscape,
        cancel
    ]);
    const onChange = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (option, _, analyticsEvent)=>{
        const projectOption = option ? (0, $25vda.mapOptionToData)(option) : option;
        updatedValue.current = projectOption;
        save(projectOption, analyticsEvent);
    }, [
        save
    ]);
    const onChangeWithoutAnalytics = (0, $eUqFw.useCallback)((option)=>{
        const projectOption = option ? (0, $25vda.mapOptionToData)(option) : option;
        resetError();
        updatedValue.current = projectOption;
    }, [
        resetError
    ]);
    const renderEditView = ()=>{
        if (editView !== undefined) return editView;
        const dataValue = updatedValue.current;
        const optionValue = dataValue === null ? null : (0, $25vda.mapDataToOption)(dataValue);
        const shouldShowCustomProjectField = (0, $39CTK.isStopLoadingFieldConfigTwiceEnabled)() ? autoCompleteUrl !== '' : true;
        return shouldShowCustomProjectField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cD14K.ProjectCustomFieldEdit), {
            autoFocus: true,
            blurInputOnSelect: true,
            fetchSuggestionsOnFocus: true,
            hideSelectedOptions: true,
            openMenuOnFocus: true,
            spacing: "compact",
            autoCompleteUrl: autoCompleteUrl,
            fieldId: fieldKey,
            isInvalid: !!error,
            onChange: onChangeWithoutAnalytics,
            value: optionValue
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b7kS0.ProjectEditView), {
            autoFocus: true,
            isInvalid: !!error,
            placeholder: formatMessage((0, $fNbtM.default).placeholder),
            onChange: onChange,
            options: (0, $25vda.mapDataToOptions)(allowedValues),
            value: optionValue
        });
    };
    const renderReadView = ()=>readView !== undefined ? readView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aA1aH.ProjectReadView), {
            value: value,
            noValueText: noValueText
        });
    return(// @ts-expect-error - TS2322 - Type '{ children: any[]; isEditing: boolean; hasValue: boolean; isEditable: boolean; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { ...; }, any>, any, any>> & Readonly<...> & Readonly<...>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5bedf8722711811$var$ProjectInlineEditContainer, {
        isEditing: isEditing,
        hasValue: !!value,
        isEditable: isFieldEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5bedf8722711811$export$b6fef027b75b99a6, {
        testId: "issue-field-project.ui.inline-edit-field",
        actionSubject: $c5bedf8722711811$export$fd8ebf59dd2b58b6,
        isEditable: isFieldEditable,
        isEditing: isEditing,
        readView: renderReadView(),
        editView: isFieldEditable ? renderEditView() : null,
        onConfirm: onConfirmRequest,
        onCancel: onCancelRequest,
        onEdit: onEditRequested,
        onEscape: onEscapeRequest,
        areActionButtonsHidden: true,
        ...rest
    })));
});
const $c5bedf8722711811$var$PROJECT_READ_VIEW_CONTAINER_SELECTOR = '[data-component-selector="project-read-view-container"]'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5bedf8722711811$var$ProjectInlineEditContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5St1r.InlineEditContainerExperiment), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !__cmplp.isEditable && __cmplp.hasValue && "_18u0idpf _1akukb7n _1oooswc3 _ix5l1m6d",
            __cmplp.className
        ])
    });
});

});
parcelRegister("25vda", function(module, exports) {

$parcel$export(module.exports, "mapDataToOption", () => $ffcb0af364b4a885$export$5c1e24ea9ccb80aa);
$parcel$export(module.exports, "mapDataToOptions", () => $ffcb0af364b4a885$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $ffcb0af364b4a885$export$fc800909123977f3);
const $ffcb0af364b4a885$export$5c1e24ea9ccb80aa = (data)=>({
        label: data.name,
        value: data.key,
        iconUrl: data.avatarUrls['48x48'],
        projectId: data.id
    });
const $ffcb0af364b4a885$export$99a866ffa3af7d8b = (data)=>data.map($ffcb0af364b4a885$export$5c1e24ea9ccb80aa);
const $ffcb0af364b4a885$export$fc800909123977f3 = ({ label: label, value: value, iconUrl: iconUrl })=>({
        key: value,
        name: label,
        avatarUrls: {
            '48x48': iconUrl
        }
    });

});

parcelRegister("39CTK", function(module, exports) {

$parcel$export(module.exports, "isStopLoadingFieldConfigTwiceEnabled", () => $71e2e9faedebb256$export$98dcb5ffd7beaf00);

var $1ybV0 = parcelRequire("1ybV0");
const $71e2e9faedebb256$export$98dcb5ffd7beaf00 = ()=>(0, $1ybV0.ff)('jracloud-81255-stop-loading-field-config-twice_jfdek', false);

});

parcelRegister("hIoRx", function(module, exports) {

$parcel$export(module.exports, "useProjectField", () => $d2d345492fb3d8fc$export$85a22e7dcab3be80);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $d2d345492fb3d8fc$export$85a22e7dcab3be80 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', (0, $lO4Or.PROJECT_PICKER_CF_TYPE));
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("cD14K", function(module, exports) {

$parcel$export(module.exports, "ProjectCustomFieldEdit", () => $1ce22f3ef8bc3b96$export$8d413eb197febcb2);

var $eUqFw = parcelRequire("eUqFw");

var $lXktr = parcelRequire("lXktr");

var $lEpcX = parcelRequire("lEpcX");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");
var $bKilX = parcelRequire("bKilX");

var $a60Hj = parcelRequire("a60Hj");

var $fO0l8 = parcelRequire("fO0l8");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fdV7M = parcelRequire("fdV7M");

var $40Hqo = parcelRequire("40Hqo");
const $1ce22f3ef8bc3b96$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $1ce22f3ef8bc3b96$var$PROJECT_OPTIONS_LOADED = 'issue-field-project-options-loaded';
const $1ce22f3ef8bc3b96$var$projectOptionsLoadedMetric = (0, $lEpcX.metrics).custom({
    key: $1ce22f3ef8bc3b96$var$PROJECT_OPTIONS_LOADED
});
const $1ce22f3ef8bc3b96$export$8d413eb197febcb2 = (props)=>{
    const { fieldId: fieldId, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus, blurInputOnSelect: blurInputOnSelect, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, hideSelectedOptions: hideSelectedOptions, onChange: onChange, onCloseMenuOnScroll: onCloseMenuOnScroll, openMenuOnFocus: openMenuOnFocus, spacing: spacing, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, isInvalid: isInvalid = false, value: value = null, onBlur: onBlur } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [lastFetchFailed, setLastFetchFailed] = (0, $eUqFw.useState)(false);
    const [defaultOptions, setDefaultOptions] = (0, $eUqFw.useState)([]);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const shouldFetchDefaultOptions = (0, $eUqFw.useRef)(true);
    const isInSampleAnalytics = (0, $eUqFw.useRef)((0, $a60Hj.isInSample)());
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireOptionsLoadedAnalyticsEvent = (duration)=>{
        const action = 'loaded';
        const actionSubject = 'projectFieldOptions';
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        const attrs = {
            duration: duration
        };
        (0, $jMP2a.fireOperationalAnalytics)(event, `${actionSubject} ${action}`, attrs);
    };
    const searchProjects = async (query = '')=>{
        setLastFetchFailed(false);
        isInSampleAnalytics.current && $1ce22f3ef8bc3b96$var$projectOptionsLoadedMetric.start();
        return (0, $40Hqo.fetchProjects)(query, autoCompleteUrl).then((projectsData)=>{
            if (isInSampleAnalytics.current) {
                $1ce22f3ef8bc3b96$var$projectOptionsLoadedMetric.stop();
                const { start: start, stop: stop } = $1ce22f3ef8bc3b96$var$projectOptionsLoadedMetric.getData();
                const duration = stop && start ? stop - start : null;
                fireOptionsLoadedAnalyticsEvent(duration);
            }
            return projectsData;
        }).catch(()=>{
            isInSampleAnalytics.current && $1ce22f3ef8bc3b96$var$projectOptionsLoadedMetric.cancel();
            setLastFetchFailed(true);
            return [];
        });
    };
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await searchProjects();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    // go/jfe-eslint
    const loadOptionsDebounced = (0, $fO0l8.default)(searchProjects, $1ce22f3ef8bc3b96$var$LOAD_OPTIONS_DEBOUNCE_TIMER);
    const getNoOptionsMessage = (0, $eUqFw.useCallback)(()=>formatMessage(lastFetchFailed ? (0, $fdV7M.default).failedFetch : (0, $fdV7M.default).noMatches), [
        formatMessage,
        lastFetchFailed
    ]);
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    // NOTE: Only used for drilling down `react-select` props!
    // See: https://react-select.com/props
    const additionalSelectProps = {
        blurInputOnSelect: blurInputOnSelect,
        hideSelectedOptions: hideSelectedOptions,
        openMenuOnFocus: openMenuOnFocus,
        spacing: spacing
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXktr.default), {
        fieldId: fieldId,
        autoFocus: autoFocus,
        ...defaultOptionsProps(),
        ...additionalSelectProps,
        isClearable: true,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        formatOptionLabel: (0, $bKilX.formatOptionLabel),
        loadOptions: loadOptionsDebounced,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: formatMessage((0, $fdV7M.default).placeholder),
        styles: (0, $4NcaX.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        value: value,
        // @ts-expect-error - TS2322 - Type '(value: Option) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
        onChange: onChange,
        onBlur: onBlur
    });
};

});
parcelRegister("bKilX", function(module, exports) {

$parcel$export(module.exports, "formatOptionLabel", () => $03dfe231efe3dc8b$export$322216d90ffb8d0e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");
const $03dfe231efe3dc8b$export$b4053b30a2d3983b = (props)=>{
    const { option: { label: label, iconUrl: iconUrl, description: description }, optionContext: optionContext } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$var$FlexRow, null, Boolean(iconUrl) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "square",
        size: "xsmall",
        src: iconUrl,
        borderColor: "transparent"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$var$FlexColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$var$Label, null, label), optionContext === 'menu' && Boolean(description) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$var$Description, null, description)));
};
const $03dfe231efe3dc8b$export$322216d90ffb8d0e = (option, { context: context })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$export$b4053b30a2d3983b, {
        option: option,
        optionContext: context
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03dfe231efe3dc8b$var$FlexRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $03dfe231efe3dc8b$var$FlexColumn = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2lx21bp4 _1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $03dfe231efe3dc8b$var$AvatarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $03dfe231efe3dc8b$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});
const $03dfe231efe3dc8b$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1skh _syaz1rc1",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fO0l8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5761c68e5511d47$export$2e2bcd8739ae039);
const $a5761c68e5511d47$var$defer = ()=>{
    const deferred = {};
    deferred.promise = new Promise((resolve, reject)=>{
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a5761c68e5511d47$var$debounce(fn, wait = 0) {
    let deferred;
    let timer;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let lastArgs;
    function flush() {
        const thisDeferred = deferred;
        clearTimeout(timer);
        if (thisDeferred) // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation. | TS7005 - Variable 'lastArgs' implicitly has an 'any' type.
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        Promise.resolve(fn.apply(this, lastArgs)).then(thisDeferred.resolve, thisDeferred.reject);
        lastArgs = [];
        deferred = null;
    }
    // @ts-expect-error - TS2322 - Type '(...args: readonly any[]) => any' is not assignable to type 'F'.
    return function debounced(...args) {
        if (deferred) clearTimeout(timer);
        else deferred = $a5761c68e5511d47$var$defer();
        lastArgs = args;
        // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        timer = setTimeout(flush.bind(this), wait);
        return deferred.promise;
    };
}
var $a5761c68e5511d47$export$2e2bcd8739ae039 = $a5761c68e5511d47$var$debounce;

});

parcelRegister("fdV7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb26ea260b249b4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ecb26ea260b249b4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noMatches: {
        "id": "issue-field-project.edit.async-project-cf.no-matches",
        "defaultMessage": "No matches"
    },
    failedFetch: {
        "id": "issue-field-project.edit.async-project-cf.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-project.edit.async-project-cf.placeholder",
        "defaultMessage": "Select project"
    },
    loading: {
        "id": "issue-field-project.edit.async-project-cf.loading",
        "defaultMessage": "Searching..."
    }
});

});

parcelRegister("40Hqo", function(module, exports) {

$parcel$export(module.exports, "fetchProjects", () => $4c62c9e4bb900226$export$f0d2ca471cdb99b0);

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");
var $lRmyA = parcelRequire("lRmyA");

var $25vda = parcelRequire("25vda");
const $4c62c9e4bb900226$export$f0d2ca471cdb99b0 = async (inputValue, autoCompleteUrl)=>(0, $lRmyA.performGetRequest)(`${autoCompleteUrl}${inputValue}`).then((response)=>(0, $25vda.mapDataToOptions)(response.values)).catch((error)=>{
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'fetchProjects',
            packageName: 'jiraIssueFieldProject',
            logToSentry: !(0, $7byHA.isValidationError)(error),
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });

});


parcelRegister("b7kS0", function(module, exports) {

$parcel$export(module.exports, "ProjectEditView", () => $a6a6309f443d5cee$export$a465ccd4f55759e4);

var $eUqFw = parcelRequire("eUqFw");

var $4zgIJ = parcelRequire("4zgIJ");

var $4NcaX = parcelRequire("4NcaX");
var $bKilX = parcelRequire("bKilX");
const $a6a6309f443d5cee$export$a465ccd4f55759e4 = (props)=>{
    const [menuIsOpen, setMenuIsOpen] = (0, $eUqFw.useState)(false);
    const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus, isInvalid: isInvalid } = props;
    const onSelectFocus = (0, $eUqFw.useCallback)((e)=>{
        setMenuIsOpen(true);
        onFocus && onFocus(e);
    }, [
        onFocus
    ]);
    const onSelectBlur = (0, $eUqFw.useCallback)((e)=>{
        setMenuIsOpen(false);
        onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), {
        value: value,
        options: options,
        placeholder: placeholder,
        // @ts-expect-error - TS2322 - Type '((value: Option | null, _: undefined, analyticsEvent: UIAnalyticsEventInterface) => void) | undefined' is not assignable to type '((value: Option | null, action: ActionMeta<Option>) => void) | undefined'.
        onChange: onChange,
        onFocus: onSelectFocus,
        onBlur: onSelectBlur,
        autoFocus: autoFocus,
        formatOptionLabel: (0, $bKilX.formatOptionLabel),
        isClearable: true,
        hideSelectedOptions: true,
        menuIsOpen: menuIsOpen,
        spacing: "compact",
        styles: (0, $4NcaX.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null
    });
};

});

parcelRegister("fNbtM", function(module, exports) {

$parcel$export(module.exports, "default", () => $18e90a4dd0599bb5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $18e90a4dd0599bb5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue-field-project.placeholder",
        "defaultMessage": "Select project"
    },
    errorTitle: {
        "id": "issue-field-project.error-title",
        "defaultMessage": "We couldn't set the project value"
    },
    errorMessage: {
        "id": "issue-field-project.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});

parcelRegister("aA1aH", function(module, exports) {

$parcel$export(module.exports, "ProjectReadView", () => $26d520d2a340bb02$export$5c3359f22f4596bc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $kJlBc = parcelRequire("kJlBc");
const $26d520d2a340bb02$export$5c3359f22f4596bc = ({ value: value, noValueText: noValueText, onClick: onClick })=>{
    const onClickLink = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        e.stopPropagation();
        onClick && onClick(e);
    }, [
        onClick
    ]);
    if (value === undefined || value === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $26d520d2a340bb02$var$emptyValueContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26d520d2a340bb02$var$EmptyValue, {
        "data-testid": "issue-field-project.ui.view-read-view-empty-value"
    }, noValueText || ''));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const stopPropagation = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26d520d2a340bb02$var$ReadViewContainer, {
        "data-component-selector": "project-read-view-container"
    }, Boolean(value.avatarUrls['48x48']) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26d520d2a340bb02$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "square",
        size: "xsmall",
        src: value.avatarUrls['48x48'],
        borderColor: "transparent",
        testId: "issue-field-project.ui.project-avatar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26d520d2a340bb02$var$Label, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), {
        "data-testid": "issue-field-project.ui.view-label-link",
        onClick: onClickLink,
        onKeyPress: stopPropagation,
        href: `/projects/${value.key}`
    }, value.name)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26d520d2a340bb02$var$EmptyValue = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz",
            __cmplp.className
        ])
    });
});
const $26d520d2a340bb02$var$ReadViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _p12fuuw1 _1yt41b66",
            __cmplp.className
        ])
    });
});
const $26d520d2a340bb02$var$emptyValueContainerStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.075',
    paddingRight: 'space.075'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26d520d2a340bb02$var$AvatarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $26d520d2a340bb02$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1ul9idpf _2hwxu2gc _1x211q9c _1rg815vq _1yoo15vq _1p6l1l2s _h5vp1o8l _i78x1osq",
            __cmplp.className
        ])
    });
});

});



parcelRegister("bFovQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $32e545c58e12f87f$export$2e2bcd8739ae039);

var $dNhRY = parcelRequire("dNhRY");

var $5iWql = parcelRequire("5iWql");

var $90IgZ = parcelRequire("90IgZ");

var $58dNI = parcelRequire("58dNI");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $4kDvN = parcelRequire("4kDvN");

var $fokFV = parcelRequire("fokFV");

var $8WZQM = parcelRequire("8WZQM");

var $laQtd = parcelRequire("laQtd");
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ const $32e545c58e12f87f$var$messages = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.radio-select.text-for-dropdown-when-nothing-selected",
        "defaultMessage": "Select {fieldName}"
    }
});
const $32e545c58e12f87f$export$171b31829f46f49a = (0, $5iWql.default)((values, allowedValuesOverrides)=>(0, $laQtd.transformSuggestions)((0, $8WZQM.filterAllowedValues)(values, allowedValuesOverrides)));
const $32e545c58e12f87f$var$RadioButton = (0, (/*@__PURE__*/$parcel$interopDefault($dNhRY)))((0, $4kDvN.withExtraOwnProps), (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $laQtd.transformFromStateValue,
        transformToStateValue: $laQtd.transformToStateValue,
        additionalProps: (state, intl, fieldOptions, extraOwnProps)=>({
                options: $32e545c58e12f87f$export$171b31829f46f49a((0, $fokFV.fieldAllowedValuesSelector)(ownPropsOnMount.fieldId)(state), extraOwnProps?.allowedValuesOverrides),
                placeholder: intl.formatMessage($32e545c58e12f87f$var$messages.placeholder, {
                    fieldName: (0, $fokFV.fieldNameSelector)(ownPropsOnMount.fieldId)(state)
                }),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area),
                isRequired: (0, $fokFV.isFieldRequiredSelector)(ownPropsOnMount.fieldId)(state)
            })
    })))((0, $58dNI.default));
var $32e545c58e12f87f$export$2e2bcd8739ae039 = $32e545c58e12f87f$var$RadioButton;

});
parcelRegister("58dNI", function(module, exports) {

$parcel$export(module.exports, "default", () => $14aa145535309410$export$2e2bcd8739ae039);
/* radio-inline-edit-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $f8Yej = parcelRequire("f8Yej");

var $2gGF1 = parcelRequire("2gGF1");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9LvPd = parcelRequire("9LvPd");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $6oQPP = parcelRequire("6oQPP");

var $4bZws = parcelRequire("4bZws");

var $huhk2 = parcelRequire("huhk2");

var $4xwq2 = parcelRequire("4xwq2");

var $bURhy = parcelRequire("bURhy");

var $m8phw = parcelRequire("m8phw");
const $14aa145535309410$export$900aeca2e40ef17f = ({ isEditable: isEditable = false, isEditing: isEditing = false, isMobile: isMobile = false, isRequired: isRequired = false, options: options = [], label: label = '', placeholder: placeholder, noValueText: noValueText, invalidMessage: invalidMessage, value: value, portalElement: portalElement, onChange: onChange, issueKey: issueKey, fieldId: fieldId, showPinButton: showPinButton, onEditRequest: onEditRequest, onConfirm: onConfirm, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const emptyOption = (0, $eUqFw.useMemo)(()=>({
            label: formatMessage((0, $huhk2.genericMessages).noValue)
        }), [
        formatMessage
    ]);
    const getOptions = (0, $eUqFw.useCallback)(()=>!isRequired && value ? [
            emptyOption,
            ...options
        ] : options, [
        emptyOption,
        options,
        isRequired,
        value
    ]);
    const renderReadViewOld = (0, $eUqFw.useCallback)(()=>{
        if (value) return value.label;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), null, noValueText);
    }, [
        noValueText,
        value
    ]);
    const renderReadView = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $m8phw.ReadViewContainer), {
            "data-component-selector": (0, $m8phw.readViewContainerSelectorName)
        }, renderReadViewOld()), [
        renderReadViewOld
    ]);
    const renderEditView = (0, $eUqFw.useCallback)(()=>{
        if (!isEditable) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bURhy.default), {
            portalElement: portalElement,
            value: value,
            options: getOptions(),
            onChange: onChange,
            placeholder: placeholder,
            invalidMessage: invalidMessage
        });
    }, [
        getOptions,
        invalidMessage,
        isEditable,
        onChange,
        placeholder,
        portalElement,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), {
        "data-testid": `issue.views.field.radio-inline-edit.${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), {
        fieldId: fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, label), issueKey !== undefined && fieldId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldId,
        label: label
    }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldId,
        label: label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), {
        isEditing: isEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
        onEscape: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($14aa145535309410$export$79c3e1f640e3705f, {
        isEditable: isEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        testId: `issue.views.field.issue-internal-fields.radio-select.${fieldId}`,
        hideActionButtons: true,
        readView: renderReadView,
        editView: renderEditView,
        isEditing: isEditing,
        isEditable: isEditable,
        onEdit: onEditRequest,
        onConfirm: onConfirm,
        onCancel: onCancel,
        readViewFitContainerWidth: !isMobile,
        editButtonLabel: formatMessage((0, $2gGF1.default).editButtonLabel, {
            fieldName: label
        }),
        confirmButtonLabel: formatMessage((0, $2gGF1.default).confirmButtonLabel, {
            fieldName: label
        }),
        cancelButtonLabel: formatMessage((0, $2gGF1.default).cancelButtonLabel, {
            fieldName: label
        })
    })))));
};
var $14aa145535309410$export$2e2bcd8739ae039 // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $14aa145535309410$export$900aeca2e40ef17f;
const $14aa145535309410$export$79c3e1f640e3705f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $m8phw.InlineEditContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !__cmplp.isEditable && "_18u0idpf _1rhwidpf _1wj1idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bURhy", function(module, exports) {

$parcel$export(module.exports, "default", () => $9477e771e91e841d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $brkBi = parcelRequire("brkBi");

var $1ybV0 = parcelRequire("1ybV0");

var $4NcaX = parcelRequire("4NcaX");

var $gJA1m = parcelRequire("gJA1m");
function $9477e771e91e841d$export$2e2bcd8739ae039(props) {
    const { invalidMessage: invalidMessage, options: options, placeholder: placeholder, onChange: onChange, value: value, portalElement: portalElement } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJA1m.default), {
        validationState: invalidMessage != null ? 'error' : null,
        validationMessage: invalidMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brkBi.default), {
        menuPortalTarget: portalElement,
        // @ts-expect-error - TS2322 - Type 'RadioValueItemShape[]' is not assignable to type 'readonly (OptionType | GroupTypeBase<OptionType>)[]'.
        options: options,
        placeholder: placeholder,
        // @ts-expect-error - TS2322 - Type '(arg1: RadioValueItemShape) => void' is not assignable to type '(value: OptionType | null, action: ActionMeta<OptionType>) => void'.
        onChange: onChange,
        // @ts-expect-error - TS2322 - Type 'RadioValueItemShape | null' is not assignable to type 'OptionType | readonly OptionType[] | null | undefined'.
        value: value,
        tabSelectsValue: false,
        autoFocus: true,
        styles: (0, $4NcaX.defaultSelectStyles),
        spacing: (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i') ? 'compact' : 'default'
    }));
}
$9477e771e91e841d$export$2e2bcd8739ae039.defaultProps = {
    value: null,
    options: [],
    placeholder: null,
    invalidMessage: null
};
$9477e771e91e841d$export$2e2bcd8739ae039.displayName = 'RadioFieldView';

});
parcelRegister("brkBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8542322e57b08d91$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $4zgIJ = parcelRequire("4zgIJ");

var $aVlxK = parcelRequire("aVlxK");
const $8542322e57b08d91$var$RadioSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ components: components, ...props })=>{
    const mergedComponents = (0, $eUqFw.useMemo)(()=>({
            ...components,
            Option: (0, $aVlxK.RadioOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), (0, $kU09D.default)({}, props, {
        isMulti: false,
        components: mergedComponents
    }));
});
var $8542322e57b08d91$export$2e2bcd8739ae039 = $8542322e57b08d91$var$RadioSelect;

});


parcelRegister("m8phw", function(module, exports) {

$parcel$export(module.exports, "readViewContainerSelectorName", () => $7c8cd9a32ae4f9db$export$195ee2a97947e11b);
$parcel$export(module.exports, "ReadViewContainer", () => $7c8cd9a32ae4f9db$export$ebb3489b83262b26);
$parcel$export(module.exports, "InlineEditContainer", () => $7c8cd9a32ae4f9db$export$9f16bbb9a44c7bf6);
/* radio-inline-edit-view.styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $7c8cd9a32ae4f9db$export$195ee2a97947e11b = 'jira-issue-view-radio-inline-edit-view-read-view-container';
const $7c8cd9a32ae4f9db$export$8fa12d0dcf2da542 = `[data-component-selector="${$7c8cd9a32ae4f9db$export$195ee2a97947e11b}"]`;
const $7c8cd9a32ae4f9db$export$ebb3489b83262b26 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _1nmz1hna _kqswh2mm _vwz48sxn",
            __cmplp.className
        ])
    });
});
const $7c8cd9a32ae4f9db$export$9f16bbb9a44c7bf6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _18u0x0bf _19pkx0bf _1gzc1txw _auuz1h6o _6vgs1osq _1rjezwfg _osjgidpf _alyvidpf _pa3x12x7 _2g9bidpf",
            __cmplp.className
        ])
    });
});

});


parcelRegister("laQtd", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $f1fdefd5eb35509a$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $f1fdefd5eb35509a$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformSuggestions", () => $f1fdefd5eb35509a$export$1d0ee4320c26fb60);
const $f1fdefd5eb35509a$var$toItem = (fieldData)=>({
        label: fieldData.value,
        value: fieldData.id
    });
const $f1fdefd5eb35509a$export$cb172b2468ab5652 = (value)=>value ? $f1fdefd5eb35509a$var$toItem(value) : null;
const $f1fdefd5eb35509a$export$1cfcb95cb8fbddb3 = (value)=>{
    if (!value || value.value === undefined) return null;
    return {
        id: value.value,
        value: value.label
    };
};
const $f1fdefd5eb35509a$export$1d0ee4320c26fb60 = (suggestions)=>suggestions && suggestions.map($f1fdefd5eb35509a$var$toItem) || [];

});


parcelRegister("hUaSJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $973b9992a11e43a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $9LvPd = parcelRequire("9LvPd");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $4bZws = parcelRequire("4bZws");

var $15Um0 = parcelRequire("15Um0");
var $cJOF6 = parcelRequire("cJOF6");
var $67xr3 = parcelRequire("67xr3");

var $huhk2 = parcelRequire("huhk2");

var $4xwq2 = parcelRequire("4xwq2");

var $hHKWU = parcelRequire("hHKWU");

var $gFXkx = parcelRequire("gFXkx");
const $973b9992a11e43a2$var$ReadOnlyView = ({ fieldId: fieldKey, label: label, area: area })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ fieldConfig: fieldConfig }] = (0, $67xr3.useReadOnlyField)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldLabel = fieldConfig?.title || label;
    const { noValue: noValue } = (0, $huhk2.genericMessages);
    const renderReadView = (0, $eUqFw.useCallback)(({ value: value })=>{
        if (value == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), null, formatMessage(noValue));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cJOF6.ReadOnlyFieldView), {
            value: value
        });
    }, [
        formatMessage,
        noValue
    ]);
    const showPinButton = (0, $hHKWU.default)(area);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gFXkx.ReadOnlyFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, fieldLabel), issueKey !== undefined && fieldKey !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldKey,
        label: fieldLabel
    }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldKey,
        label: fieldLabel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15Um0.default), {
        fieldKey: fieldKey,
        readView: renderReadView
    })));
};
var $973b9992a11e43a2$export$2e2bcd8739ae039 = $973b9992a11e43a2$var$ReadOnlyView;

});
parcelRegister("15Um0", function(module, exports) {

$parcel$export(module.exports, "default", () => $677cd6bdd1985cb7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $67xr3 = parcelRequire("67xr3");

var $cJOF6 = parcelRequire("cJOF6");
const $677cd6bdd1985cb7$var$ReadOnlyField = ({ fieldKey: fieldKey, readView: readView })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ value: value }] = (0, $67xr3.useReadOnlyField)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return readView != null && typeof readView === 'function' ? /*#__PURE__*/ (0, $eUqFw.createElement)(readView, {
        value: value
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cJOF6.ReadOnlyFieldView), {
        value: value
    });
};
var $677cd6bdd1985cb7$export$2e2bcd8739ae039 = $677cd6bdd1985cb7$var$ReadOnlyField;

});
parcelRegister("67xr3", function(module, exports) {

$parcel$export(module.exports, "useReadOnlyField", () => $d7425080201de74f$export$b06b47228f9d24e0);

var $8411R = parcelRequire("8411R");
var $kmr29 = parcelRequire("kmr29");
const $d7425080201de74f$export$b06b47228f9d24e0 = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const [value] = (0, $kmr29.useFieldValue)({
        fieldKey: fieldKey,
        issueKey: issueKey
    });
    return [
        {
            value: value,
            fieldConfig: fieldConfig
        },
        {}
    ];
};

});

parcelRegister("cJOF6", function(module, exports) {

$parcel$export(module.exports, "ReadOnlyFieldView", () => $3cb93a632425575e$export$88c3b8fce1ee7e29);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $3cb93a632425575e$export$88c3b8fce1ee7e29 = ({ value: value })=>// preserving layout with non breaking space
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb93a632425575e$var$Ellipsis, null, value || '\u00A0');
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cb93a632425575e$var$Ellipsis = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("gFXkx", function(module, exports) {

$parcel$export(module.exports, "ReadOnlyFieldWrapper", () => $ca6f17f8e7fdb34f$export$87d670d5b5090e54);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $64ypR = parcelRequire("64ypR");
const $ca6f17f8e7fdb34f$export$87d670d5b5090e54 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $64ypR.FieldWrapper), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o",
            __cmplp.className
        ])
    });
});

});


parcelRegister("jfAST", function(module, exports) {

$parcel$export(module.exports, "default", () => $154ab5da162cebb1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");

var $exOWK = parcelRequire("exOWK");

var $brySu = parcelRequire("brySu");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $40QX1 = parcelRequire("40QX1");

var $jf5VS = parcelRequire("jf5VS");

var $dIZCs = parcelRequire("dIZCs");
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ const $154ab5da162cebb1$var$messages = (0, $90IgZ.defineMessages)({
    noReporter: {
        "id": "issue.reporter.text-when-no-value-is-provided",
        "defaultMessage": "Anonymous"
    }
});
var $154ab5da162cebb1$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $jf5VS.transformFromStateValue,
        transformToStateValue: $jf5VS.transformToStateValue,
        additionalProps: (state, intl)=>{
            const issueKey = (0, $5JqpU.issueKeySelector)(state);
            const isRequired = (0, $fokFV.isFieldRequiredSelector)(ownPropsOnMount.fieldId)(state);
            const anonymousUser = intl.formatMessage($154ab5da162cebb1$var$messages.noReporter);
            return {
                portalElement: (0, $40QX1.isFieldInTabSelector)(ownPropsOnMount.fieldId)(state) ? // Using a portal element here because otherwise dropdowns would get cut off
                // See: https://jdog.jira-dev.com/browse/BENTO-4101
                (0, $brySu.getIssueModalAkDropdownPortal)() || document.body : undefined,
                fetchSuggestions: (0, $dIZCs.default)(`/rest/api/3/user/recommend?${new URLSearchParams({
                    context: 'Reporter',
                    ...issueKey && {
                        issueKey: issueKey
                    },
                    query: ''
                })}`, anonymousUser, isRequired),
                emptyOption: isRequired ? undefined : (0, $dIZCs.getEmptyOption)(anonymousUser),
                initialOptions: isRequired ? undefined : (0, $dIZCs.getEmptyOptionArray)(anonymousUser),
                fieldId: 'reporter',
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            };
        }
    }))((0, $exOWK.default));

});
parcelRegister("dIZCs", function(module, exports) {

$parcel$export(module.exports, "getEmptyOption", () => $a54a5ed4109b75c5$export$80859424956457b4);
$parcel$export(module.exports, "getEmptyOptionArray", () => $a54a5ed4109b75c5$export$59f62bfa7c966de8);
$parcel$export(module.exports, "default", () => $a54a5ed4109b75c5$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $2OdyW = parcelRequire("2OdyW");

var $jf5VS = parcelRequire("jf5VS");
const $a54a5ed4109b75c5$var$isMatchingDefaultOption = (query, option)=>!!query && !!option && option.toLowerCase().startsWith(query.toLowerCase());
const $a54a5ed4109b75c5$export$80859424956457b4 = (0, $5iWql.default)((anonymousUser)=>({
        avatarUrl: '',
        name: anonymousUser,
        id: null
    }));
const $a54a5ed4109b75c5$export$59f62bfa7c966de8 = (0, $5iWql.default)((anonymousUser)=>[
        $a54a5ed4109b75c5$export$80859424956457b4(anonymousUser)
    ]);
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$a54a5ed4109b75c5$export$2e2bcd8739ae039 = (0, $5iWql.default)((autoCompleteUrl, anonymousUser, isRequired)=>async (query)=>{
        if (!autoCompleteUrl) return [];
        const defaultOptions = !isRequired && $a54a5ed4109b75c5$var$isMatchingDefaultOption(query, anonymousUser) ? [
            $a54a5ed4109b75c5$export$80859424956457b4(anonymousUser)
        ] : [];
        const response = await (0, $2OdyW.default)(`${autoCompleteUrl}${query}`);
        const fetchedOptions = response.map((0, $jf5VS.transformFromStateValue));
        return [
            ...defaultOptions,
            ...fetchedOptions
        ];
    });

});


parcelRegister("74ZhC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0875e3a67cb99eba$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

const $0875e3a67cb99eba$var$RequestFeedback = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("afqDN")), {
    moduleId: "./src/packages/issue/issue-view-base/src/context/request-feedback/index.tsx"
});
const $0875e3a67cb99eba$var$AsyncRequestFeedback = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "jsmRequestFeedback",
        packageName: "atlassian/jira-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-request-feedback",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0875e3a67cb99eba$var$RequestFeedback, props)));
var $0875e3a67cb99eba$export$2e2bcd8739ae039 = $0875e3a67cb99eba$var$AsyncRequestFeedback;

});
parcelRegister("afqDN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('1cyaL')
        ]);
        const value = parcelRequire('eXzra');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("1cyaL")
    ]).then(()=>parcelRequire('eXzra'));
}

});


parcelRegister("cuBGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5b0deb1420bcd4f$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $bOSGt = parcelRequire("bOSGt");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $zaqzH = parcelRequire("zaqzH");

var $62Dgz = parcelRequire("62Dgz");

var $cWSyb = parcelRequire("cWSyb");

var $iRLRJ = parcelRequire("iRLRJ");
const $d5b0deb1420bcd4f$var$fetchSuggestionsFactory = (0, $5iWql.default)((suggestions, intl)=>()=>Promise.resolve((0, $cWSyb.transformSuggestions)(suggestions, intl)));
const $d5b0deb1420bcd4f$export$72a8b15fb4557735 = ({ baseUrl: baseUrl, value: value }, state)=>{
    const { languageCode: languageCode } = value;
    const issueId = (0, $5JqpU.issueIdSelector)(state);
    return (0, $bOSGt.updateRequestLanguage)(baseUrl, issueId, languageCode);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d5b0deb1420bcd4f$var$analyticsAttributeIdRetriever = (value)=>value && value.languageCode;
var $d5b0deb1420bcd4f$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $cWSyb.transformFromStateValue,
        transformToStateValue: $cWSyb.transformToStateValue,
        saveField: $d5b0deb1420bcd4f$export$72a8b15fb4557735,
        additionalProps: (state, intl)=>({
                fetchSuggestions: $d5b0deb1420bcd4f$var$fetchSuggestionsFactory((0, $fokFV.fieldAllowedValuesSelector)(ownPropsOnMount.fieldId)(state), intl),
                shouldHide: !(0, $zaqzH.isRequestLanguageVisibleSelector)(ownPropsOnMount.fieldId)(state),
                hasAutocomplete: true,
                placeholder: intl.formatMessage((0, $62Dgz.default).placeholder),
                analyticsAttributeIdRetriever: $d5b0deb1420bcd4f$var$analyticsAttributeIdRetriever,
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            })
    }))((0, $iRLRJ.default));

});
parcelRegister("bOSGt", function(module, exports) {

$parcel$export(module.exports, "updateRequestLanguage", () => $85a0e0e4a2127ed2$export$6bbfb56ce04e87bc);

var $lRmyA = parcelRequire("lRmyA");
const $85a0e0e4a2127ed2$var$getUpdateRequestLanguageUrl = (baseUrl, issueId)=>`${baseUrl}/rest/servicedesk/lingo-integration/1/request-language/${issueId}`;
const $85a0e0e4a2127ed2$export$6bbfb56ce04e87bc = async (baseUrl, issueId, languageCode)=>{
    if (!issueId) throw new Error('Issue ID not available');
    return (0, $lRmyA.performPutRequest)($85a0e0e4a2127ed2$var$getUpdateRequestLanguageUrl(baseUrl, issueId), {
        body: JSON.stringify({
            languageCode: languageCode
        })
    });
};

});

parcelRegister("62Dgz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ee0483e96ebffca$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $2ee0483e96ebffca$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.request-language.placeholder",
        "defaultMessage": "Select Request language"
    },
    languageUnknown: {
        "id": "issue.request-language.languageUnknown",
        "defaultMessage": "Language unknown"
    }
});

});

parcelRegister("cWSyb", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $fa378ff7f2c5205b$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $fa378ff7f2c5205b$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformSuggestions", () => $fa378ff7f2c5205b$export$1d0ee4320c26fb60);

var $5iWql = parcelRequire("5iWql");

var $62Dgz = parcelRequire("62Dgz");
const $fa378ff7f2c5205b$var$toItem = (stateValue)=>({
        content: stateValue.displayName,
        value: stateValue.languageCode
    });
const $fa378ff7f2c5205b$var$getUnknownLanguageValue = (0, $5iWql.default)((intl)=>({
        displayName: intl.formatMessage((0, $62Dgz.default).languageUnknown),
        languageCode: ''
    }));
const $fa378ff7f2c5205b$export$cb172b2468ab5652 = (stateValue, transformerContext, intl)=>$fa378ff7f2c5205b$var$toItem(stateValue || $fa378ff7f2c5205b$var$getUnknownLanguageValue(intl));
const $fa378ff7f2c5205b$export$1cfcb95cb8fbddb3 = (value)=>({
        displayName: value.content,
        languageCode: value.value.toString()
    });
const $fa378ff7f2c5205b$export$1d0ee4320c26fb60 = (suggestionsFromServer, intl)=>{
    const suggestionsWithUnknownLanguage = [
        $fa378ff7f2c5205b$var$getUnknownLanguageValue(intl),
        ...suggestionsFromServer
    ];
    const singleSelectItems = suggestionsWithUnknownLanguage.map($fa378ff7f2c5205b$var$toItem);
    return [
        {
            items: singleSelectItems
        }
    ];
};

});

parcelRegister("iRLRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c21db5886531f626$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jxxzJ = parcelRequire("jxxzJ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c21db5886531f626$export$2e2bcd8739ae039 = (props)=>{
    const { shouldHide: shouldHide, ...selectProps } = props;
    if (shouldHide) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jxxzJ.default), selectProps);
};

});


parcelRegister("iMiO1", function(module, exports) {

$parcel$export(module.exports, "default", () => $71f48a450aa01ba5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2OdyW = parcelRequire("2OdyW");

var $f1dS7 = parcelRequire("f1dS7");

var $18KtE = parcelRequire("18KtE");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $fokFV = parcelRequire("fokFV");

var $9Nizy = parcelRequire("9Nizy");

var $9k3MZ = parcelRequire("9k3MZ");

var $1QVaR = parcelRequire("1QVaR");
const $71f48a450aa01ba5$export$2b81811283cd2d9d = (0, $5iWql.default)((autoCompleteUrl)=>(query)=>{
        if (!autoCompleteUrl) return Promise.resolve([]);
        return (0, $2OdyW.default)(`${autoCompleteUrl}${query}`).then((0, $1QVaR.transformSuggestions));
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $71f48a450aa01ba5$var$analyticsAttributeIdRetriever = (value)=>value && Array.isArray(value) ? value.map((participant)=>participant.accountId).join(',') : value;
const $71f48a450aa01ba5$export$322216d90ffb8d0e = (option, meta)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f1dS7.default), {
        avatarUrl: option.avatarUrl,
        email: option.email,
        label: option.label,
        context: meta.context
    });
const $71f48a450aa01ba5$var$filterOption = ()=>true;
const $71f48a450aa01ba5$var$multiUserSelectFilterOption = (0, $9Nizy.isSearchByEmailInRequestParticipantsEnabled)() ? $71f48a450aa01ba5$var$filterOption : undefined;
var $71f48a450aa01ba5$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>{
    const fieldAutoCompleteUrlSelectorGetter = (0, $fokFV.fieldAutoCompleteUrlSelector)(ownPropsOnMount.fieldId);
    return {
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $1QVaR.transformFromStateValue,
        transformToStateValue: $1QVaR.transformToStateValue,
        additionalProps: (state, intl)=>({
                fetchSuggestions: $71f48a450aa01ba5$export$2b81811283cd2d9d(fieldAutoCompleteUrlSelectorGetter(state)),
                placeholder: intl.formatMessage((0, $9k3MZ.default).placeholder),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                tagAppearance: 'rounded',
                analyticsAttributeIdRetriever: $71f48a450aa01ba5$var$analyticsAttributeIdRetriever,
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area),
                formatOptionLabel: $71f48a450aa01ba5$export$322216d90ffb8d0e,
                filterOption: $71f48a450aa01ba5$var$multiUserSelectFilterOption
            })
    };
})((0, $18KtE.default));

});
parcelRegister("9k3MZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $20e1f15ef139b35a$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $20e1f15ef139b35a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.request-participants.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "Select the Request Participants"
    }
});

});

parcelRegister("1QVaR", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $dc1177c086d079ec$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $dc1177c086d079ec$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformSuggestions", () => $dc1177c086d079ec$export$1d0ee4320c26fb60);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $6vrw7 = parcelRequire("6vrw7");
const $dc1177c086d079ec$var$avatarSize = '24x24';
const $dc1177c086d079ec$export$cb172b2468ab5652 = (stateValues)=>{
    if (!stateValues) return [];
    return stateValues.map((item)=>({
            content: item.displayName,
            value: item.accountId,
            avatarUrl: item.avatarUrls[$dc1177c086d079ec$var$avatarSize],
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                size: "xsmall",
                src: item.avatarUrls[$dc1177c086d079ec$var$avatarSize]
            })
        }));
};
const $dc1177c086d079ec$export$1cfcb95cb8fbddb3 = (value)=>value && value.map((item)=>({
            displayName: item.content,
            id: (0, $6vrw7.toAccountId)(item.value),
            accountId: (0, $6vrw7.toAccountId)(item.value),
            avatarUrls: {
                [$dc1177c086d079ec$var$avatarSize]: item.avatarUrl
            }
        }));
const $dc1177c086d079ec$export$1d0ee4320c26fb60 = (response)=>{
    const items = response && response.users || [];
    return [
        {
            items: items.map((user)=>({
                    content: user.displayName,
                    value: user.accountId,
                    avatarUrl: user.avatarUrl,
                    email: user.email
                }))
        }
    ];
};

});


parcelRegister("2eoeo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a1ce873a23819d3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $hHKWU = parcelRequire("hHKWU");

var $lqalZ = parcelRequire("lqalZ");

var $9F6MO = parcelRequire("9F6MO");

var $f8f9V = parcelRequire("f8f9V");

var $9Nizy = parcelRequire("9Nizy");
const $2a1ce873a23819d3$export$1f494c8fe1660523 = ({ isVisible: isVisible = true, onOpenPanel: onOpenPanel, fieldId: fieldId, showPinButton: showPinButton })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), null, isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8f9V.RespondersGlance), {
        onOpenPanel: onOpenPanel,
        fieldId: fieldId,
        showPinButton: showPinButton
    }));
var $2a1ce873a23819d3$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state, ownPropsOnMount)=>({
        isVisible: (0, $9Nizy.isRespondersFieldAvailableInAllProjectsEnabled)() || (0, $9F6MO.canUseServiceDeskAgentFeaturesSelector)(state),
        showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
    }), {})($2a1ce873a23819d3$export$1f494c8fe1660523);

});
parcelRegister("f8f9V", function(module, exports) {

$parcel$export(module.exports, "RespondersGlance", () => $5af4c52d194f73e4$export$903f0ce21c6afe58);
$parcel$export(module.exports, "RespondersGlancePanel", () => $5af4c52d194f73e4$export$10832108d343f8da);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5af4c52d194f73e4$var$RespondersGlanceComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("kOFB1")), {
    ssr: false,
    moduleId: "./src/packages/issue/fields/responders/src/ui/responders-glance/index.tsx"
});
const $5af4c52d194f73e4$export$903f0ce21c6afe58 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.responders.glance",
        packageName: "atlassian/jira-responders"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "responders-glance-component",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5af4c52d194f73e4$var$RespondersGlanceComponent, props)));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5af4c52d194f73e4$var$RespondersGlancePanelComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("lWeaR")), {
    ssr: false,
    moduleId: "./src/packages/issue/fields/responders/src/ui/responders-glance-panel/index.tsx"
});
const $5af4c52d194f73e4$export$10832108d343f8da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.responders.glance.panel",
        packageName: "atlassian/jira-responders"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "responders-glance-panel-component",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5af4c52d194f73e4$var$RespondersGlancePanelComponent, props)));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5af4c52d194f73e4$var$RespondersInlineViewComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("kiF96")), {
    ssr: false,
    moduleId: "./src/packages/issue/fields/responders/src/ui/inline/index.tsx"
});
const $5af4c52d194f73e4$export$c1d034b633262480 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.responders.inline.view",
        packageName: "atlassian/jira-responders"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "responders-glance-inline-view-component",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5af4c52d194f73e4$var$RespondersInlineViewComponent, props)));

});
parcelRegister("kOFB1", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lriJI');
        const value = parcelRequire('9sTKk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lriJI").then(()=>parcelRequire('9sTKk'));
}

});

parcelRegister("lWeaR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('9t5j2')
        ]);
        const value = parcelRequire('hoL7f');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("9t5j2")
    ]).then(()=>parcelRequire('hoL7f'));
}

});

parcelRegister("kiF96", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iNogz');
        const value = parcelRequire('difW2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iNogz").then(()=>parcelRequire('difW2'));
}

});



parcelRegister("8tzjM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24d3d0fa6f95c56$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kG4jb = parcelRequire("kG4jb");

var $bFzGY = parcelRequire("bFzGY");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $guiFP = parcelRequire("guiFP");

var $hJ992 = parcelRequire("hJ992");

var $dnK1q = parcelRequire("dnK1q");

var $fCyzk = parcelRequire("fCyzk");

var $jMP2a = parcelRequire("jMP2a");

var $f8f9V = parcelRequire("f8f9V");
var $67gJt = parcelRequire("67gJt");

var $1F3d4 = parcelRequire("1F3d4");

var $gd0Sp = parcelRequire("gd0Sp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d24d3d0fa6f95c56$export$2e2bcd8739ae039 = (props)=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { baseUrl: baseUrl, cloudId: cloudId } = tenantContext;
    const issueKey = (0, $hJ992.useIssueKey)();
    const [contextPanel] = (0, $fCyzk.useIssueLayoutContextPanel)(issueKey);
    const [{ value: currentAssignee }] = (0, $dnK1q.default)({
        issueKey: issueKey
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onSuccess = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'respondersField updateSucceeded', {});
    }, [
        createAnalyticsEvent
    ]);
    const onFailure = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
    (error)=>{
        (0, $guiFP.default)({
            event: createAnalyticsEvent({}),
            meta: {
                id: 'respondersFieldUpdate',
                // eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics
                packageName: 'jiraIssueView'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        createAnalyticsEvent
    ]);
    const onSubmit = (0, $eUqFw.useCallback)((oldValue, newValue, meta, event)=>{
        const sanitisedOldValue = oldValue || [];
        const sanitisedNewValue = newValue || [];
        const numberOfOriginalTeamResponder = sanitisedOldValue.filter((it)=>it.type === 'team').length;
        const numberOfNewValueTeamResponder = sanitisedNewValue.filter((it)=>it.type === 'team').length;
        const numberOfOriginalUserResponder = sanitisedOldValue.filter((it)=>it.type === 'user').length;
        const numberOfNewValueUserResponder = sanitisedNewValue.filter((it)=>it.type === 'user').length;
        const numberOfTotalOriginalResponders = sanitisedOldValue.length;
        const isRemoveOperation = (0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(sanitisedOldValue, sanitisedNewValue).length > 0;
        if (isRemoveOperation) (0, $jMP2a.fireTrackAnalytics)(event, 'respondersField updateStarted', {
            operationType: 'remove',
            numberOfTotalOriginalResponders: numberOfTotalOriginalResponders,
            numberOfOriginalTeamResponder: numberOfOriginalTeamResponder,
            numberOfOriginalUserResponder: numberOfOriginalUserResponder,
            numberOfTotalRemovedResponders: sanitisedNewValue.length,
            numberOfRemovedTeamResponder: numberOfNewValueTeamResponder,
            numberOfRemovedUserResponder: numberOfNewValueUserResponder
        });
        else (0, $jMP2a.fireTrackAnalytics)(event, 'respondersField updateStarted', {
            operationType: 'add',
            numberOfTotalOriginalResponders: numberOfTotalOriginalResponders,
            numberOfOriginalTeamResponder: numberOfOriginalTeamResponder,
            numberOfOriginalUserResponder: numberOfOriginalUserResponder,
            numberOfTotalAddedResponders: sanitisedNewValue.length,
            numberOfAddedTeamResponder: numberOfNewValueTeamResponder,
            numberOfAddeddUserResponder: numberOfNewValueUserResponder
        });
    }, []);
    const [{ value: responders, error: error }, { addResponders: addResponders, removeResponders: removeResponders, resetError: resetError }] = (0, $67gJt.useRespondersField)({
        issueKey: issueKey,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onSubmit: onSubmit
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1F3d4.IncidentConfigurationProvider), {
        baseUrl: baseUrl,
        cloudId: cloudId,
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8f9V.RespondersGlancePanel), {
        ...props,
        responders: responders,
        isPanelOpen: contextPanel !== undefined,
        currentAssignee: currentAssignee,
        onAddResponders: addResponders,
        onRemoveResponders: removeResponders,
        respondersFieldError: {
            error: error,
            resetError: resetError
        }
    })));
};

});
parcelRegister("kG4jb", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $kIBQX = parcelRequire("kIBQX");

var $9eFtX = parcelRequire("9eFtX");

var $arA63 = parcelRequire("arA63");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $f0db1270e02fec98$var$intersection = $9eFtX(function(arrays) {
    var mapped = $kJvGp(arrays, $arA63);
    return mapped.length && mapped[0] === arrays[0] ? $kIBQX(mapped) : [];
});
module.exports = $f0db1270e02fec98$var$intersection;

});
parcelRegister("kIBQX", function(module, exports) {

var $lYFvJ = parcelRequire("lYFvJ");

var $lqZWH = parcelRequire("lqZWH");

var $6v6uu = parcelRequire("6v6uu");

var $kJvGp = parcelRequire("kJvGp");

var $74vSq = parcelRequire("74vSq");

var $8AO5Q = parcelRequire("8AO5Q");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f155478e4676feef$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $f155478e4676feef$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $6v6uu : $lqZWH, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $kJvGp(array, $74vSq(iteratee));
        maxLength = $f155478e4676feef$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $lYFvJ(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $8AO5Q(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $8AO5Q(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $f155478e4676feef$var$baseIntersection;

});

parcelRegister("arA63", function(module, exports) {

var $cRpul = parcelRequire("cRpul");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $79a86d09190de0cd$var$castArrayLikeObject(value) {
    return $cRpul(value) ? value : [];
}
module.exports = $79a86d09190de0cd$var$castArrayLikeObject;

});


parcelRegister("67gJt", function(module, exports) {

$parcel$export(module.exports, "useRespondersField", () => $3c351a9630bc831c$export$bcdf543111dfabb9);

var $gGiWF = parcelRequire("gGiWF");

var $PRuwW = parcelRequire("PRuwW");
const $3c351a9630bc831c$export$bcdf543111dfabb9 = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, onSubmit: onSubmit })=>{
    const { respondersFieldIdKey: fieldKey, fieldType: fieldType } = (0, $PRuwW.useRespondersConfig)(issueKey);
    const [{ value: value, error: error }, { addValues: addResponders, removeValues: removeResponders, resetError: resetError }] = (0, $gGiWF.useEditField)({
        issueKey: issueKey,
        fieldKey: fieldKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onSubmit: onSubmit
    });
    return [
        {
            value: value,
            error: error
        },
        {
            addResponders: addResponders,
            removeResponders: removeResponders,
            resetError: resetError
        }
    ];
};

});
parcelRegister("PRuwW", function(module, exports) {

$parcel$export(module.exports, "useRespondersConfig", () => $e8664b3a4b9aac93$export$8f646271fa407bc);

var $eUqFw = parcelRequire("eUqFw");

var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $e8664b3a4b9aac93$export$8f646271fa407bc = (issueKey)=>{
    const [{ value: fieldConfig }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    const [respondersFieldIdKey, searchUrl, fieldType] = (0, $eUqFw.useMemo)(()=>{
        if (fieldConfig != null) {
            const fieldId = Object.keys(fieldConfig).find((fieldKey)=>fieldConfig[fieldKey].schema.custom === (0, $lO4Or.RESPONDERS_CF_TYPE));
            if (fieldId != null) {
                const respondersConfig = fieldConfig[fieldId];
                const { autoCompleteUrl: autoCompleteUrl, schema: { type: type } } = respondersConfig;
                return [
                    fieldId,
                    autoCompleteUrl || '',
                    type
                ];
            }
        }
        return [
            '',
            '',
            'array'
        ];
    }, [
        fieldConfig
    ]);
    return {
        respondersFieldIdKey: respondersFieldIdKey,
        searchUrl: searchUrl,
        fieldType: fieldType
    };
};

});


parcelRegister("1F3d4", function(module, exports) {

$parcel$export(module.exports, "useIncidentConfiguration", () => $0191368888cb85df$export$ea81f28af77666ec);
$parcel$export(module.exports, "IncidentConfigurationProvider", () => $0191368888cb85df$export$464eb7a182450d2d);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $5F3zw = parcelRequire("5F3zw");
const $0191368888cb85df$export$d4c72bab9d6cc13a = {
    configuration: undefined,
    fetchStatus: undefined
};
const $0191368888cb85df$export$493afd3316abdd54 = (0, $a61MH.createStore)({
    name: 'JSDIncidentConfiguration',
    initialState: $0191368888cb85df$export$d4c72bab9d6cc13a,
    actions: (0, $5F3zw.actions)
});
const $0191368888cb85df$export$3ecd0010017a3557 = (0, $dYfll.createSubscriber)($0191368888cb85df$export$493afd3316abdd54);
const $0191368888cb85df$export$ea81f28af77666ec = (0, $ggKAj.createHook)($0191368888cb85df$export$493afd3316abdd54);
const $0191368888cb85df$export$464eb7a182450d2d = (0, $heB5U.createContainer)($0191368888cb85df$export$493afd3316abdd54);

});
parcelRegister("5F3zw", function(module, exports) {

$parcel$export(module.exports, "actions", () => $9f1103163b0c4ad0$export$e324594224ef24da);

var $c4LCf = parcelRequire("c4LCf");
const $9f1103163b0c4ad0$export$e324594224ef24da = {
    fetchConfiguration: $c4LCf.fetchConfiguration
};

});
parcelRegister("c4LCf", function(module, exports) {

$parcel$export(module.exports, "fetchConfiguration", () => $3a542319e188ac82$export$9911e92fcb5c83c0);

var $guiFP = parcelRequire("guiFP");


var $gtOoI = parcelRequire("gtOoI");

var $3nvzH = parcelRequire("3nvzH");
const $3a542319e188ac82$export$9911e92fcb5c83c0 = ()=>async ({ getState: getState, setState: setState }, { cloudId: cloudId })=>{
        const { configuration: currentConfiguration, fetchStatus: currentFetchStatus } = getState();
        if (currentConfiguration || currentFetchStatus === (0, $gtOoI.FETCH_STATUS).inProgress) return;
        setState({
            fetchStatus: (0, $gtOoI.FETCH_STATUS).inProgress
        });
        try {
            const configuration = await (0, $3nvzH.remoteGet)({
                cloudId: cloudId
            });
            setState({
                fetchStatus: undefined,
                configuration: configuration
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                fetchStatus: error.statusCode === 403 ? (0, $gtOoI.FETCH_STATUS).forbiddenError : (0, $gtOoI.FETCH_STATUS).error
            });
            (0, $guiFP.trackFetchErrors)({
                error: error,
                id: 'fetchConfiguration',
                packageName: (0, $21a59c72a152301d$export$b8b9d90f9e5bd72b),
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };

});
const $21a59c72a152301d$export$c54c70b6aa3e6297 = 'closed';
const $21a59c72a152301d$export$c3a052103aefa6ac = 'open';
const $21a59c72a152301d$export$d2a6feecbd4b4865 = 'resolved';
const $21a59c72a152301d$export$3af8c933c922bf8b = 'ongoing';
const $21a59c72a152301d$export$a8815f96c182a2fa = 'past';
const $21a59c72a152301d$export$231eb4d67f0067d8 = 'icc';
const $21a59c72a152301d$export$b8b9d90f9e5bd72b = 'jiraServicedeskIncidentManagementServices';

parcelRegister("gtOoI", function(module, exports) {

$parcel$export(module.exports, "FETCH_STATUS", () => $486a1eb3230d94d4$export$7279934be2ca35bc);
const $486a1eb3230d94d4$export$7279934be2ca35bc = {
    inProgress: 'IN_PROGRESS_FETCH_STATUS',
    error: 'ERROR_FETCH_STATUS',
    forbiddenError: 'ERROR_FORBIDDEN_FETCH_STATUS'
};

});

parcelRegister("3nvzH", function(module, exports) {

$parcel$export(module.exports, "remoteGet", () => $30e2dbf6a379a079$export$3eb5f19ac16138d9);

var $2OdyW = parcelRequire("2OdyW");

var $iCRmp = parcelRequire("iCRmp");
const $30e2dbf6a379a079$var$getUrl = (cloudId)=>`${(0, $iCRmp.getEscalatorBaseUrl)(cloudId)}/context/incident-management`;
const $30e2dbf6a379a079$export$3eb5f19ac16138d9 = async ({ cloudId: cloudId })=>(0, $2OdyW.default)($30e2dbf6a379a079$var$getUrl(cloudId));

});





parcelRegister("dZRNS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0888d880d7d3ca3e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $hJ992 = parcelRequire("hJ992");

var $5G3JL = parcelRequire("5G3JL");

var $hHKWU = parcelRequire("hHKWU");

var $lqalZ = parcelRequire("lqalZ");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0888d880d7d3ca3e$var$SentimentDropdown = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("b4n0R")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/sentiment-field/src/ui/sentiment-panel/index.tsx"
});
const $0888d880d7d3ca3e$export$96b9f782d56b6a7b = ({ fieldId: fieldId, showPinButton: showPinButton })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "sentiment-field",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0888d880d7d3ca3e$var$SentimentDropdown, {
        issueKey: issueKey,
        fieldId: fieldId,
        showPinButton: showPinButton
    }));
};
var $0888d880d7d3ca3e$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state, props)=>({
        fieldId: props.fieldId,
        showPinButton: (0, $hHKWU.default)(props.area)
    }), {}))($0888d880d7d3ca3e$export$96b9f782d56b6a7b);

});
parcelRegister("b4n0R", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('aq5hB');
        const value = parcelRequire('hjF2S');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("aq5hB").then(()=>parcelRequire('hjF2S'));
}

});


parcelRegister("8xvFk", function(module, exports) {

$parcel$export(module.exports, "ConnectedServiceEntity", () => $053ddc4a93f80eec$export$e7f96d90c1202940);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $idJ8T = parcelRequire("idJ8T");

var $3uwfp = parcelRequire("3uwfp");
const $053ddc4a93f80eec$var$ServiceEntity = (props)=>{
    const { fieldId: fieldId, area: area, onChange: onChange, onConfirm: onConfirm } = props;
    const projectKey = (0, $hJ992.useProjectKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idJ8T.IssueServiceEntityFieldBoundary), {
        packageName: "issue-service-entity-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idJ8T.AsyncServiceEntityField), {
        area: area,
        fieldId: fieldId,
        projectKey: projectKey,
        onChange: onChange,
        onConfirm: onConfirm
    }));
};
const $053ddc4a93f80eec$export$e7f96d90c1202940 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        area: ownPropsOnMount.area,
        fieldId: ownPropsOnMount.fieldId
    }))($053ddc4a93f80eec$var$ServiceEntity);
var $053ddc4a93f80eec$export$2e2bcd8739ae039 = $053ddc4a93f80eec$var$ServiceEntity;

});
parcelRegister("idJ8T", function(module, exports) {

$parcel$export(module.exports, "AsyncServiceEntityField", () => $a171fa9f6c7ed1f4$export$fd80fbad511273e3);
$parcel$export(module.exports, "IssueServiceEntityFieldBoundary", () => $a171fa9f6c7ed1f4$export$fe0475c584280e24);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a171fa9f6c7ed1f4$var$AsyncLazyServiceEntityField = (0, $7rh0R.lazy)(()=>(parcelRequire("gfqwY")).then((module)=>module.ServiceEntityMain), {
    moduleId: "./src/packages/issue/fields/service-entity/src/ui/main.tsx"
});
const $a171fa9f6c7ed1f4$export$fd80fbad511273e3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "field-service-entity",
        packageName: "jira-issue-field-service-entity"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "service-entity-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a171fa9f6c7ed1f4$var$AsyncLazyServiceEntityField, props)));
const $a171fa9f6c7ed1f4$export$fe0475c584280e24 = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "issue-service-entity-field",
        packageName: packageName,
        fallback: "flag"
    }, children);

});
parcelRegister("gfqwY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('ffl3E')
        ]);
        const value = parcelRequire('eSeA6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("ffl3E")
    ]).then(()=>parcelRequire('eSeA6'));
}

});



parcelRegister("dCijO", function(module, exports) {

$parcel$export(module.exports, "default", () => $20a290026e7c0d5f$export$2e2bcd8739ae039);

var $7wpzp = parcelRequire("7wpzp");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");
var $20a290026e7c0d5f$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        additionalProps: (state, intl)=>({
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                type: 'text',
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            })
    }))((0, $7wpzp.default));

});

parcelRegister("cBCw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb95b7877a2035f6$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $5iWql = parcelRequire("5iWql");

var $90IgZ = parcelRequire("90IgZ");

var $jxxzJ = parcelRequire("jxxzJ");

var $huhk2 = parcelRequire("huhk2");

var $brySu = parcelRequire("brySu");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $4kDvN = parcelRequire("4kDvN");

var $fokFV = parcelRequire("fokFV");

var $40QX1 = parcelRequire("40QX1");

var $8WZQM = parcelRequire("8WZQM");

var $6IHCZ = parcelRequire("6IHCZ");
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ const $bb95b7877a2035f6$var$messages = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.single-select.text-for-dropdown-when-nothing-selected",
        "defaultMessage": "Select {fieldName}"
    }
});
const $bb95b7877a2035f6$var$getMemoizedSuggestionsFactoryV2 = (0, $5iWql.default)((suggestions, allowedValuesOverrides)=>()=>Promise.resolve((0, $8WZQM.filterAllowedValues)(suggestions, allowedValuesOverrides)).then((0, $6IHCZ.transformSuggestions)));
const $bb95b7877a2035f6$var$SingleSelect = (0, $huRi7.compose)((0, $4kDvN.withExtraOwnProps), (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $6IHCZ.transformFromStateValue,
        transformToStateValue: $6IHCZ.transformToStateValue,
        additionalProps: (state, intl, fieldOptions, extraOwnProps)=>({
                fetchSuggestions: $bb95b7877a2035f6$var$getMemoizedSuggestionsFactoryV2((0, $fokFV.fieldAllowedValuesSelector)(ownPropsOnMount.fieldId)(state), extraOwnProps?.allowedValuesOverrides),
                placeholder: intl.formatMessage($bb95b7877a2035f6$var$messages.placeholder, {
                    fieldName: (0, $fokFV.fieldNameSelector)(ownPropsOnMount.fieldId)(state)
                }),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                allowEmptyValue: true,
                hasAutocomplete: true,
                portalElement: (0, $40QX1.isFieldInTabSelector)(ownPropsOnMount.fieldId)(state) ? (0, $brySu.getIssueModalAkDropdownPortal)() || document.body : undefined,
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            })
    })))((0, $jxxzJ.default));
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
$bb95b7877a2035f6$export$2e2bcd8739ae039 = $bb95b7877a2035f6$var$SingleSelect;

});
parcelRegister("6IHCZ", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $2a9a150321a51900$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $2a9a150321a51900$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformSuggestions", () => $2a9a150321a51900$export$1d0ee4320c26fb60);
const $2a9a150321a51900$var$toItem = (fieldData)=>({
        value: fieldData.id,
        content: fieldData.value,
        iconUrl: fieldData.iconUrl
    });
const $2a9a150321a51900$export$cb172b2468ab5652 = (stateValue)=>stateValue && $2a9a150321a51900$var$toItem(stateValue);
const $2a9a150321a51900$export$1cfcb95cb8fbddb3 = (fieldValue)=>fieldValue && {
        id: fieldValue.value,
        value: fieldValue.content,
        iconUrl: fieldValue.iconUrl
    };
const $2a9a150321a51900$export$1d0ee4320c26fb60 = (suggestions)=>suggestions && [
        {
            items: suggestions.map($2a9a150321a51900$var$toItem)
        }
    ] || [];

});


parcelRegister("4O7Na", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5d0e67c682019d8$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $G9kf0 = parcelRequire("G9kf0");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
var $lRmyA = parcelRequire("lRmyA");

var $5HcFi = parcelRequire("5HcFi");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $lV5H0 = parcelRequire("lV5H0");

var $1OJS4 = parcelRequire("1OJS4");

var $5JqpU = parcelRequire("5JqpU");

var $4DBLa = parcelRequire("4DBLa");

var $jMP2a = parcelRequire("jMP2a");

var $1TrR5 = parcelRequire("1TrR5");

var $6vbAg = parcelRequire("6vbAg");

var $lxaI9 = parcelRequire("lxaI9");

var $9lHoC = parcelRequire("9lHoC");
const $f5d0e67c682019d8$export$2b81811283cd2d9d = (0, $5iWql.default)((intl, baseUrl, projectKey)=>(query, restrictSprintSuggestion)=>{
        const queryParams = new URLSearchParams({
            query: query,
            maxResults: '10',
            maxActiveSprints: '5'
        });
        let getCachedSprints = (0, $G9kf0.default).getAll();
        if (restrictSprintSuggestion && projectKey) {
            queryParams.append('projectKey', projectKey);
            getCachedSprints = getCachedSprints.then((sprints)=>sprints.filter((sprint)=>sprint.projectKeys?.includes(projectKey)));
        }
        const url = `${baseUrl}/rest/greenhopper/1.0/sprint/picker?${queryParams.toString()}`;
        const dataFromServer = (0, $2OdyW.default)(url);
        return Promise.all([
            dataFromServer,
            getCachedSprints
        ]).then(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([dataFromAPI, cache])=>(0, $lxaI9.transformSuggestionsFromServerAndCache)(dataFromAPI, cache, intl));
    });
// @ts-expect-error - TS7006 - Parameter 'baseUrl' implicitly has an 'any' type. | TS7006 - Parameter 'intl' implicitly has an 'any' type.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f5d0e67c682019d8$var$closedSprintFactory = (stateClosedSprints, baseUrl, intl)=>(0, $lxaI9.transformedClosedSprints)(stateClosedSprints, baseUrl, intl);
const $f5d0e67c682019d8$var$memoizedClosedSprintFactory = (0, $5iWql.default)($f5d0e67c682019d8$var$closedSprintFactory);
// @ts-expect-error - TS7031 - Binding element 'baseUrl' implicitly has an 'any' type. | TS7031 - Binding element 'issueKey' implicitly has an 'any' type. | TS7031 - Binding element 'fieldMetaKey' implicitly has an 'any' type. | TS7031 - Binding element 'value' implicitly has an 'any' type. | TS2304 - Cannot find name 'State'. | TS7006 - Parameter 'ownPropsOnMount' implicitly has an 'any' type.
const $f5d0e67c682019d8$var$saveField = ({ baseUrl: baseUrl, issueKey: issueKey, fieldMetaKey: fieldMetaKey, value: value }, _, ownPropsOnMount)=>{
    const activeSprint = (0, $9lHoC.findActiveSprint)(value);
    // @ts-expect-error - TS7006 - Parameter 'current' implicitly has an 'any' type.
    value.forEach((current)=>{
        try {
            if (ownPropsOnMount.createAnalyticsEvent) (0, $jMP2a.fireOperationalAnalytics)(ownPropsOnMount.createAnalyticsEvent({}), 'sprintPickerCache set', {
                isFromCache: current.fromCache
            });
            current.id && (0, $G9kf0.default).set(`${current.id}`, current);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-view.sprints.cache.set', error.message);
        }
    });
    return (0, $lRmyA.performPutRequest)((0, $lV5H0.getIssueApiUrl)(baseUrl, issueKey), {
        body: JSON.stringify({
            fields: {
                [fieldMetaKey]: activeSprint ? activeSprint.id : null
            }
        })
    }).catch((error)=>{
        // @ts-expect-error - TS7006 - Parameter 'current' implicitly has an 'any' type.
        value.forEach((current)=>{
            try {
                if (ownPropsOnMount.createAnalyticsEvent) (0, $jMP2a.fireOperationalAnalytics)(ownPropsOnMount.createAnalyticsEvent({}), 'sprintPickerCache removed');
                current.id && (0, $G9kf0.default).remove(`${current.id}`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-view.sprints.cache.remove', e.message);
            }
        });
        throw error;
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f5d0e67c682019d8$var$getDataFromCache = (intl)=>(0, $G9kf0.default).getAll().then((sprints)=>(0, $lxaI9.transformSuggestionsFromServerAndCache)({}, sprints, intl));
const $f5d0e67c682019d8$var$onSprintClickedFactory = (0, $5iWql.default)(// @ts-expect-error - TS7006 - Parameter 'sprintId' implicitly has an 'any' type.
(dispatch)=>(sprintId)=>dispatch((0, $1OJS4.navigateToSprint)(sprintId)));
const $f5d0e67c682019d8$var$ConnectedSprintField = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>{
    const stateClosedSprints = (0, $4DBLa.closedSprintsSelector)(ownPropsOnMount.fieldId)(stateOnMount);
    return {
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $lxaI9.transformFromStateValue,
        transformToStateValue: (0, $lxaI9.transformToStateValue)(stateClosedSprints),
        additionalProps: (state, intl)=>({
                fetchSuggestions: $f5d0e67c682019d8$export$2b81811283cd2d9d(intl, (0, $5JqpU.baseUrlSelector)(state), (0, $5JqpU.projectKeySelector)(state)),
                closedSprints: $f5d0e67c682019d8$var$memoizedClosedSprintFactory(stateClosedSprints, (0, $5JqpU.baseUrlSelector)(state), intl),
                closedSprintsLabel: (0, $lxaI9.getClosedSprintsLabel)(stateClosedSprints, intl),
                placeholder: intl.formatMessage((0, $6vbAg.default).placeholder),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                allowEmptyValue: true,
                baseUrl: (0, $5JqpU.baseUrlSelector)(state),
                isEditable: (0, $4DBLa.canChangeSprintSelector)(ownPropsOnMount.fieldId)(state),
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area),
                getDataFromCache: $f5d0e67c682019d8$var$getDataFromCache,
                projectKey: (0, $5JqpU.projectKeySelector)(state)
            }),
        additionalCallbacks: (0, $1TrR5.functionWithFFRedux)((dispatch)=>({
                onSprintClicked: $f5d0e67c682019d8$var$onSprintClickedFactory(dispatch)
            }), (dispatch)=>({
                onSprintClicked: (sprintId)=>dispatch((0, $1OJS4.navigateToSprint)(sprintId))
            })),
        saveField: (...args)=>$f5d0e67c682019d8$var$saveField(...args, ownPropsOnMount)
    };
})((0, $5HcFi.default));
var $f5d0e67c682019d8$export$2e2bcd8739ae039 = $f5d0e67c682019d8$var$ConnectedSprintField;

});
parcelRegister("G9kf0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cca602fd04e526a3$export$2e2bcd8739ae039);

var $jhVpU = parcelRequire("jhVpU");

var $by2Ey = parcelRequire("by2Ey");
var $cca602fd04e526a3$export$2e2bcd8739ae039 = (0, $jhVpU.default)((0, $by2Ey.props));

});
parcelRegister("by2Ey", function(module, exports) {

$parcel$export(module.exports, "props", () => $9cabbbe3f3cc43c6$export$8128bb6492cf3de7);

const $9cabbbe3f3cc43c6$var$MAX_RESULTS = 5;
const $9cabbbe3f3cc43c6$var$CACHE_SIZE = $9cabbbe3f3cc43c6$var$MAX_RESULTS * 2;
const $9cabbbe3f3cc43c6$var$SPRINTS_CACHE_KEY = 'sprints';
const $9cabbbe3f3cc43c6$export$8128bb6492cf3de7 = {
    size: $9cabbbe3f3cc43c6$var$CACHE_SIZE,
    cacheKey: $9cabbbe3f3cc43c6$var$SPRINTS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)
};

});


parcelRegister("5HcFi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b5424ca74f1351d$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $9SGuZ = parcelRequire("9SGuZ");

var $5C3wV = parcelRequire("5C3wV");

var $ayA76 = parcelRequire("ayA76");

var $jxxzJ = parcelRequire("jxxzJ");

var $4xwq2 = parcelRequire("4xwq2");

var $6Ibtn = parcelRequire("6Ibtn");

var $bMFLr = parcelRequire("bMFLr");

var $10fdS = parcelRequire("10fdS");

var $dm51a = parcelRequire("dm51a");
class $3b5424ca74f1351d$export$c035f6dfde6d5d50 extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'SprintInlineEditView';
    }
    static{
        this.defaultProps = {
            closedSprints: [],
            closedSprintsLabel: null
        };
    }
    render() {
        const { baseUrl: baseUrl, closedSprints: closedSprints, closedSprintsLabel: closedSprintsLabel, rapidViewId: rapidViewId, onSprintClicked: onSprintClicked, intl: intl, getDataFromCache: getDataFromCache, route: route, projectKey: projectKey, ...selectProps } = this.props;
        const { data: data, loading: loading, error: error } = this.state;
        const initialData = {
            data: data,
            loading: loading,
            error: error
        };
        const componentsProps = {
            isChecked: this.state.restrictSprintSuggestion,
            onChange: this.onCheckboxClick.bind(this),
            projectKey: projectKey
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jxxzJ.default), {
            ...selectProps,
            fetchSuggestions: this.fetchSuggestions,
            debounceFetchSuggestionsTime: 300,
            initialData: initialData,
            onEditRequest: this.onEditRequest,
            onChange: this.onChange,
            onConfirm: this.onConfirm,
            onCancel: this.onCancel,
            componentsProps: projectKey ? componentsProps : undefined,
            components: projectKey ? {
                Menu: $9SGuZ.default
            } : undefined,
            onDataRequest: this.onDataRequest,
            onDataLoaded: this.onDataLoaded,
            renderReadView: this.renderReadView,
            formatOptionLabel: this.formatOptionLabel,
            hasAutocomplete: true,
            optionValuesSafeForAnalytics: true
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            restrictSprintSuggestion: (0, $5C3wV.getCheckboxValueFromLocalStorage)((0, $5C3wV.EDIT_SPRINT_CHECKBOX_CACHE_KEY)),
            query: '',
            data: [],
            loading: false,
            error: false
        };
        this.componentDidMount = ()=>{
            this.getDataFromCache();
        };
        this.sessionId = 'default-session-id';
        this.getDataFromCache = ()=>{
            this.props.getDataFromCache?.(this.props.intl).then((data)=>{
                this.setState({
                    data: data,
                    loading: false
                });
            });
        };
        this.onSprintClick = (event)=>{
            const { rapidViewId: rapidViewId, value: value, onSprintClicked: onSprintClicked } = this.props;
            if (rapidViewId !== undefined && value) onSprintClicked(value.value);
            event.stopPropagation();
        };
        this.onEditRequest = ()=>{
            this.props.onEditRequest();
        };
        this.onChange = (selectedValue, _actionMeta)=>{
            this.props.onChange(selectedValue);
        };
        this.onConfirm = ()=>{
            this.props.onConfirm();
        };
        this.onCancel = ()=>{
            this.props.onCancel();
        } // go/jfe-eslint
        ;
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.onDataRequest = ({ isInitial: _ })=>{} // go/jfe-eslint
        ;
        // @ts-expect-error - TS2741 - Property 'isInitial' is missing in type '{}' but required in type '{ isInitial: boolean; }'.
        this.onDataLoaded = ({ isInitial: _ } = {})=>{};
        this.renderSprintContent = ()=>{
            const { baseUrl: baseUrl, rapidViewId: rapidViewId, value: value, route: route } = this.props;
            const isIssueViewInBacklogSideBar = (0, $bMFLr.isBacklogSidebar)(route) && typeof rapidViewId === 'number' && rapidViewId > 0;
            if (isIssueViewInBacklogSideBar) // Don't show sprint link while in backlog side bar.
            return value && value.content;
             // Show sprint as link while in dialog or full issue view
            return(// this needs to be anchor, so bitbucket entry index will add target="_blank" to element.
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: rapidViewId == null && value ? (0, $6Ibtn.getRapidViewUrl)(baseUrl, value.value) // issue in full page view
                 : undefined,
                onClick: this.onSprintClick
            }, value && value.content));
        };
        this.renderReadView = ()=>{
            const { value: value, noValueText: noValueText, closedSprints: closedSprints, closedSprintsLabel: closedSprintsLabel, isMobile: isMobile } = this.props;
            const sprintView = value ? this.renderSprintContent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), null, noValueText);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3b5424ca74f1351d$var$ReadWrapper, null, (0, $1ybV0.ff)('sprint-field-long-text-bug_fo95j') ? sprintView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3b5424ca74f1351d$var$Ellipsis, null, sprintView), closedSprints.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dm51a.default), {
                closedSprints: closedSprints,
                closedSprintsLabel: closedSprintsLabel,
                shouldHideLinks: isMobile
            }));
        };
        // go/jfe-eslint
        this.formatOptionLabel = (option, { context: context })=>{
            if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ayA76.RichOptionView), {
                option: option
            });
            return option.label;
        };
        this.fetchSuggestions = (query, sessionId)=>{
            if (sessionId !== null && sessionId !== undefined && sessionId !== '') this.sessionId = sessionId;
            this.setState({
                query: query
            });
            return this.props.fetchSuggestions(query, this.state.restrictSprintSuggestion, this.sessionId).then((data)=>{
                this.setState({
                    data: data
                });
                return data;
            });
        };
        this.onCheckboxClick = async ()=>{
            const { query: query, restrictSprintSuggestion: restrictSprintSuggestion } = this.state;
            this.setState({
                restrictSprintSuggestion: !restrictSprintSuggestion,
                loading: true
            }, ()=>{
                this.fetchSuggestions(query).then((data)=>{
                    this.setState({
                        data: data,
                        loading: false,
                        error: false
                    });
                }).catch(()=>{
                    this.setState({
                        data: [],
                        loading: false,
                        error: true
                    });
                });
            });
            (0, $5C3wV.setCheckBoxValueInLocalStorage)((0, $5C3wV.EDIT_SPRINT_CHECKBOX_CACHE_KEY), !restrictSprintSuggestion);
        };
    }
}
const $3b5424ca74f1351d$var$SprintInlineEditViewWithHooks = ({ rapidViewId: rapidViewIdOld, ...props })=>{
    const rapidViewId = (0, $hJ992.useRapidViewId)();
    const route = (0, $10fdS.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3b5424ca74f1351d$export$c035f6dfde6d5d50, {
        ...props,
        route: route,
        rapidViewId: rapidViewId
    });
};
$3b5424ca74f1351d$var$SprintInlineEditViewWithHooks.defaultProps = {
    closedSprints: [],
    closedSprintsLabel: null
};
var $3b5424ca74f1351d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3b5424ca74f1351d$var$SprintInlineEditViewWithHooks;
const $3b5424ca74f1351d$var$ReadWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b5424ca74f1351d$var$Ellipsis = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9SGuZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $949140d940a171ec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bT7k5 = parcelRequire("bT7k5");

var $jQxSL = parcelRequire("jQxSL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fsrhm = parcelRequire("fsrhm");

var $c4gPs = parcelRequire("c4gPs");
const $949140d940a171ec$var$Menu = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { children: children, ...restProps } = props;
    const isChecked = props.selectProps?.componentsProps?.isChecked || false;
    const projectKey = props.selectProps?.componentsProps?.projectKey || null;
    const label = formatMessage((0, $fsrhm.default).checkboxLabel, {
        projectKey: projectKey
    });
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        // stopping propagation when focus moves to checkbox because select already binded with space and enter for selection
        if (event.key === ' ') event.stopPropagation();
    }, []);
    return(// @ts-expect-error - TS2746 - This JSX tag's 'children' prop expects a single child of type 'ReactElement<any, string | JSXElementConstructor<any>>', but multiple children were provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Menu, restProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4gPs.CheckboxWrapper), {
        onClick: props.selectProps?.componentsProps?.onChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        onKeyDown: onKeyDown,
        isChecked: isChecked,
        size: "medium",
        label: label,
        testId: "issue-field-sprint.ui.edit.menu.checkbox"
    })), children)));
};
var // @ts-expect-error - TS2352 - Conversion of type '(props: Props) => JSX.Element' to type 'ReactNode' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$949140d940a171ec$export$2e2bcd8739ae039 = $949140d940a171ec$var$Menu;

});
parcelRegister("fsrhm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a44e5d63af21206e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a44e5d63af21206e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    checkboxLabel: {
        "id": "issue-field-sprint.edit.menu.checkbox-label",
        "defaultMessage": "Only show sprints in this project ({projectKey})"
    }
});

});

parcelRegister("c4gPs", function(module, exports) {

$parcel$export(module.exports, "CheckboxWrapper", () => $eb0173849e3208ba$export$eef12940a6696c78);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $eb0173849e3208ba$export$eef12940a6696c78 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1y6m _1yt41bs6 _n7zlpe8f _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});


parcelRegister("5C3wV", function(module, exports) {

$parcel$export(module.exports, "EDIT_SPRINT_CHECKBOX_CACHE_KEY", () => $0fe4293f03bf1f14$export$90fd8fcc9388370d);
$parcel$export(module.exports, "getCheckboxValueFromLocalStorage", () => $0fe4293f03bf1f14$export$b6ec857d138d143b);
$parcel$export(module.exports, "setCheckBoxValueInLocalStorage", () => $0fe4293f03bf1f14$export$1750bf12ee05e0ac);

var $53ciZ = parcelRequire("53ciZ");
const $0fe4293f03bf1f14$var$getViewMode = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(window.location.search).view || '';
const $0fe4293f03bf1f14$export$d5e150c1e3186bd1 = ()=>$0fe4293f03bf1f14$var$getViewMode().includes('planning');
const $0fe4293f03bf1f14$export$90fd8fcc9388370d = 'edit_sprint_cache_value';
const $0fe4293f03bf1f14$export$b6ec857d138d143b = (key)=>{
    const value = window.localStorage?.getItem(key);
    return value ? JSON.parse(value) : true;
};
const $0fe4293f03bf1f14$export$1750bf12ee05e0ac = (key, value)=>{
    try {
        // @ts-expect-error - TS2345 - Argument of type 'boolean' is not assignable to parameter of type 'string'.
        window.localStorage.setItem(key, value);
    } catch  {
    // do nothing
    }
};

});

parcelRegister("6Ibtn", function(module, exports) {

$parcel$export(module.exports, "getRapidViewUrl", () => $70c87d1b5a849b73$export$e6c9132cef5ee76f);
const $70c87d1b5a849b73$export$e6c9132cef5ee76f = (baseUrl, sprintId)=>`${baseUrl}/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;

});

parcelRegister("bMFLr", function(module, exports) {

$parcel$export(module.exports, "isBacklogSidebar", () => $c9daa458e10c56eb$export$d5e150c1e3186bd1);
$parcel$export(module.exports, "isInSidebar", () => $c9daa458e10c56eb$export$4edab6cc518fd967);

var $53ciZ = parcelRequire("53ciZ");

var $exb0h = parcelRequire("exb0h");

const $c9daa458e10c56eb$var$getViewMode = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(window.location.search).view || '';
const $c9daa458e10c56eb$export$cd376d3ec8ab1533 = ()=>$c9daa458e10c56eb$var$getViewMode().includes('planning');
const $c9daa458e10c56eb$export$d5e150c1e3186bd1 = (route)=>route.name === (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BACKLOG || route.name === (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BACKLOG;
const $c9daa458e10c56eb$export$6f9198fe10b0d35c = ()=>$c9daa458e10c56eb$var$getViewMode() === 'detail';
const $c9daa458e10c56eb$export$4edab6cc518fd967 = (viewMode)=>{
    if (viewMode) return viewMode === (0, $935e771f19f8ea28$export$705305d6da432040);
    return $c9daa458e10c56eb$export$cd376d3ec8ab1533() || $c9daa458e10c56eb$export$6f9198fe10b0d35c();
};

});

parcelRegister("dm51a", function(module, exports) {

$parcel$export(module.exports, "default", () => $069460699417a80a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $29yDk = parcelRequire("29yDk");

var $c9TLT = parcelRequire("c9TLT");
class $069460699417a80a$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            shouldHideLinks: false,
            closedSprints: [],
            closedSprintsLabel: null
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($069460699417a80a$var$Container, {
            onClick: this.handleDialogClick,
            onMouseDown: this.handleDialogMouseDown
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
            content: this.renderInlineDialogContent(),
            isOpen: this.state.isDialogOpen,
            // @ts-expect-error - TS2322 - Type '(data: {    isOpen: false;    event: SyntheticEvent<HTMLDivElement>;}) => void' is not assignable to type '(obj: { isOpen: boolean; event: Event; }) => void'.
            onClose: this.handleDialogClose,
            placement: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: this.handleButtonClick,
            spacing: "none",
            isSelected: this.state.isDialogOpen,
            interactionName: "auto-generated.jira-issue-internal-fields.sprint.closed-sprints.button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($069460699417a80a$var$ClosedSprintsCount, null, `+${this.props.closedSprints.length}`))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isDialogOpen: false
        };
        this.handleButtonClick = (e)=>{
            this.setState({
                isDialogOpen: !this.state.isDialogOpen
            });
            e.stopPropagation();
        };
        this.handleDialogClose = (data)=>{
            this.setState({
                isDialogOpen: data.isOpen
            });
        };
        this.handleDialogClick = (e)=>{
            e.stopPropagation();
        };
        this.handleDialogMouseDown = (e)=>{
            e.preventDefault();
            e.stopPropagation();
        };
        this.renderInlineDialogContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($069460699417a80a$var$Title, null, this.props.closedSprintsLabel), this.props.closedSprints.map((sprint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($069460699417a80a$var$ItemContainer, {
                    key: sprint.name
                }, this.props.shouldHideLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($069460699417a80a$var$NameSpan, null, sprint.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($069460699417a80a$var$NameLink, {
                    href: sprint.href
                }, sprint.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($069460699417a80a$var$NoWrapDate, null, sprint.endDate))));
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $069460699417a80a$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $069460699417a80a$var$ClosedSprintsCount = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41b66",
            __cmplp.className
        ])
    });
});
const $069460699417a80a$var$ItemContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _1e0c1txw _1bah1yb4 _p12f1mjv",
            __cmplp.className
        ])
    });
});
const $069460699417a80a$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pbfng",
            __cmplp.className
        ])
    });
});
const $069460699417a80a$var$nameStyles = `
    margin-right: ${(0, $c9TLT.gridSize) * 3}px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $069460699417a80a$var$NameLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1tcg _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $069460699417a80a$var$NameSpan = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1tcg _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $069460699417a80a$var$NoWrapDate = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
});

});


parcelRegister("4DBLa", function(module, exports) {

$parcel$export(module.exports, "closedSprintsSelector", () => $2ee35d405b88a369$export$d65469bc1d3a93ed);
$parcel$export(module.exports, "canChangeSprintSelector", () => $2ee35d405b88a369$export$eb18941e5d2eaa21);

var $df4Sl = parcelRequire("df4Sl");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");
const $2ee35d405b88a369$export$d65469bc1d3a93ed = (fieldId)=>(0, $df4Sl.createSelector)((0, $fokFV.fieldSelector)(fieldId), (sprints)=>sprints && sprints.value ? sprints.value.filter(// @ts-expect-error - TS7006 - Parameter 'sprint' implicitly has an 'any' type.
        (sprint)=>sprint.state === 'closed' || sprint.state === 'CLOSED') : []);
const $2ee35d405b88a369$export$eb18941e5d2eaa21 = (fieldId)=>(0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (0, $jZDJX.isCompletedLoadingSelector), (0, $fokFV.isFieldEditableSelector)(fieldId), (permissions, isCompletedLoading, isFieldEditable)=>permissions.canScheduleIssues && isCompletedLoading && isFieldEditable);

});

parcelRegister("6vbAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bc5b4ec91d51995$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $5bc5b4ec91d51995$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "issue.sprint.label",
        "defaultMessage": "Sprint"
    },
    placeholder: {
        "id": "issue.sprint.text-for-edit-view-when-no-value-is-provided",
        "defaultMessage": "Select Sprint"
    },
    activeSprints: {
        "id": "issue.sprint.active-heading",
        "defaultMessage": "Active"
    },
    recentSprints: {
        "id": "issue.sprint.recent-heading",
        "defaultMessage": "Recent sprints"
    },
    futureSprints: {
        "id": "issue.sprint.future-heading",
        "defaultMessage": "Future"
    },
    closedSprintsLabel: {
        "id": "issue.sprint.text-for-closed-sprints-inline-dialog",
        "defaultMessage": "{count} completed {count, plural, one {sprint} other {sprints}}"
    }
});

});

parcelRegister("lxaI9", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $79ac84670cc42586$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $79ac84670cc42586$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformSuggestionsFromServerAndCache", () => $79ac84670cc42586$export$ecddc37cd50b50fd);
$parcel$export(module.exports, "transformedClosedSprints", () => $79ac84670cc42586$export$c202b151e3106769);
$parcel$export(module.exports, "getClosedSprintsLabel", () => $79ac84670cc42586$export$b63ee9af37156029);

var $5iWql = parcelRequire("5iWql");

var $G9kf0 = parcelRequire("G9kf0");

var $6Ibtn = parcelRequire("6Ibtn");

var $6vbAg = parcelRequire("6vbAg");

var $9lHoC = parcelRequire("9lHoC");
// @ts-expect-error - TS7006 - Parameter 'sprint' implicitly has an 'any' type.
const $79ac84670cc42586$var$toItem = (sprint)=>({
        content: sprint.name,
        value: sprint.id,
        fromCache: sprint.fromCache || false
    });
const $79ac84670cc42586$export$cb172b2468ab5652 = (stateValue)=>{
    const activeSprint = (0, $9lHoC.findActiveSprint)(stateValue);
    const futureSprint = (0, $9lHoC.findFutureSprint)(stateValue);
    return activeSprint && $79ac84670cc42586$var$toItem(activeSprint) || futureSprint && $79ac84670cc42586$var$toItem(futureSprint);
};
const $79ac84670cc42586$export$1cfcb95cb8fbddb3 = (closedSprints)=>(item)=>{
        if (!item) return closedSprints;
        const activeSprint = {
            name: item.content,
            id: item.value,
            state: 'active',
            fromCache: item.fromCache || false
        };
        // @ts-expect-error - TS2769 - No overload matches this call.
        return closedSprints.concat(activeSprint);
    };
const $79ac84670cc42586$var$toSuggestionsItem = (suggestion)=>({
        content: suggestion.name,
        value: suggestion.id,
        description: suggestion.boardName,
        id: suggestion.id,
        fromCache: suggestion.fromCache || false
    });
const $79ac84670cc42586$export$dc069111282472fb = (rest, cache)=>cache.map((item)=>{
        const duplicatedItem = rest.find((restItem)=>restItem.id === item.id);
        if (duplicatedItem) {
            (0, $G9kf0.default).update(`${item.id}`, duplicatedItem);
            return {
                ...duplicatedItem,
                fromCache: true
            };
        }
        return {
            ...item,
            fromCache: true
        };
    });
const $79ac84670cc42586$var$MAX_RESULTS = 5;
const $79ac84670cc42586$export$64c1e7aa265973f8 = (cache)=>cache.slice(-1 * $79ac84670cc42586$var$MAX_RESULTS).reverse();
const $79ac84670cc42586$export$ecddc37cd50b50fd = (suggestionsFromServer, cache = [], intl)=>{
    const suggestions = suggestionsFromServer.suggestions || [];
    const allMatches = suggestionsFromServer.allMatches || [];
    const allItems = suggestions.concat(allMatches);
    const activeItems = allItems.filter((sprint)=>sprint.stateKey === 'ACTIVE').map($79ac84670cc42586$var$toSuggestionsItem);
    const futureItems = allItems.filter((sprint)=>sprint.stateKey === 'FUTURE').map($79ac84670cc42586$var$toSuggestionsItem);
    const cacheLists = $79ac84670cc42586$export$64c1e7aa265973f8($79ac84670cc42586$export$dc069111282472fb(allItems, cache));
    const cacheItems = cacheLists.map($79ac84670cc42586$var$toSuggestionsItem);
    return [
        {
            heading: intl.formatMessage((0, $6vbAg.default).recentSprints),
            items: cacheItems
        },
        {
            heading: intl.formatMessage((0, $6vbAg.default).activeSprints),
            items: activeItems
        },
        {
            heading: intl.formatMessage((0, $6vbAg.default).futureSprints),
            items: futureItems
        }
    ];
};
const $79ac84670cc42586$var$transformClosedSprint = (0, $5iWql.default)((intl, baseUrl, sprint)=>({
        id: sprint.id,
        name: sprint.name,
        href: (0, $6Ibtn.getRapidViewUrl)(baseUrl, sprint.id),
        endDate: intl.formatDate(sprint.endDate, {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        })
    }));
const $79ac84670cc42586$export$c202b151e3106769 = (closedSprints, baseUrl, intl)=>closedSprints.map((sprint)=>$79ac84670cc42586$var$transformClosedSprint(intl, baseUrl, sprint));
const $79ac84670cc42586$export$b63ee9af37156029 = (closedSprints, intl)=>{
    const numberOfClosedSprints = closedSprints.length;
    return numberOfClosedSprints > 0 ? intl.formatMessage((0, $6vbAg.default).closedSprintsLabel, {
        count: numberOfClosedSprints
    }) : null;
};

});
parcelRegister("9lHoC", function(module, exports) {

$parcel$export(module.exports, "findActiveSprint", () => $0c34bbfd31b0d97d$export$b1dcf01b3ae45fab);
$parcel$export(module.exports, "findFutureSprint", () => $0c34bbfd31b0d97d$export$fca660b6e7caa30c);
const $0c34bbfd31b0d97d$export$b1dcf01b3ae45fab = (sprints)=>{
    const activeSprint = sprints ? sprints.find((sprint)=>sprint.state && sprint.state.toLowerCase() === 'active') : null;
    return activeSprint || null;
};
const $0c34bbfd31b0d97d$export$fca660b6e7caa30c = (sprints)=>{
    const futureSprint = sprints ? sprints.find((sprint)=>sprint.state && sprint.state.toLowerCase() === 'future') : null;
    return futureSprint || null;
};

});



parcelRegister("jcGEU", function(module, exports) {

$parcel$export(module.exports, "StoryPointEstimate", () => $4f43a3cada795245$export$d2b8a63eb3206511);

var $5iWql = parcelRequire("5iWql");

var $huhk2 = parcelRequire("huhk2");


var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $fVCj0 = parcelRequire("fVCj0");

var $5zSUY = parcelRequire("5zSUY");

var $1TrR5 = parcelRequire("1TrR5");

var $2Pr2d = parcelRequire("2Pr2d");
const $4f43a3cada795245$var$onUpdateMemoized = (0, $5iWql.default)((dispatch, ownPropsOnMount)=>({
        // @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
        onUpdate: (value)=>dispatch((0, $fVCj0.sweetStateFieldUpdated)(ownPropsOnMount.fieldId, value))
    }));
const $4f43a3cada795245$export$d2b8a63eb3206511 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        additionalProps: (state, intl)=>({
                issueKey: (0, $5JqpU.issueKeySelector)(state),
                issueId: (0, $5JqpU.issueIdSelector)(state),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                isEditable: (0, $fokFV.isFieldEditableSelector)(ownPropsOnMount.fieldId)(state) && (0, $jZDJX.loadingStageSelector)(state) !== (0, $d6ff0428d6ad71a2$export$1b56cc494043d9bf) && !!(0, $5zSUY.default)(),
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            }),
        additionalCallbacks: (0, $1TrR5.functionWithFFRedux)((dispatch)=>({
                onUpdate: $4f43a3cada795245$var$onUpdateMemoized(dispatch, ownPropsOnMount.fieldId)
            }), (dispatch)=>({
                // @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
                onUpdate: (value)=>dispatch((0, $fVCj0.sweetStateFieldUpdated)(ownPropsOnMount.fieldId, value))
            }))
    }))((0, $2Pr2d.View));
var $4f43a3cada795245$export$2e2bcd8739ae039 = $4f43a3cada795245$export$d2b8a63eb3206511;

});
parcelRegister("2Pr2d", function(module, exports) {

$parcel$export(module.exports, "View", () => $094e8ee8d287098a$export$27a5bd065ad55220);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $j2Y6t = parcelRequire("j2Y6t");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $4bZws = parcelRequire("4bZws");
const $094e8ee8d287098a$export$27a5bd065ad55220 = ({ issueKey: issueKey, fieldId: fieldKey, showPinButton: showPinButton, issueId: issueId, label: label, noValueText: noValueText, onUpdate: onUpdate })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($094e8ee8d287098a$var$StoryPointsFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, label), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldKey,
        label: label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j2Y6t.default), {
        label: label,
        issueKey: issueKey,
        issueId: issueId,
        fieldKey: fieldKey,
        noValueText: noValueText,
        isFitContainerWidthReadView: true,
        onUpdate: onUpdate
    })));
var $094e8ee8d287098a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($094e8ee8d287098a$export$27a5bd065ad55220);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $094e8ee8d287098a$var$StoryPointsFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $64ypR.FieldWrapper), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16ep1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j2Y6t", function(module, exports) {

$parcel$export(module.exports, "default", () => $648107ee81a89f2c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $illlw = parcelRequire("illlw");

var $2gGF1 = parcelRequire("2gGF1");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dWGNJ = parcelRequire("dWGNJ");

var $6oQPP = parcelRequire("6oQPP");
var $5St1r = parcelRequire("5St1r");

var $jMP2a = parcelRequire("jMP2a");

var $6vrw7 = parcelRequire("6vrw7");


var $jCKUR = parcelRequire("jCKUR");

var $8Bn0M = parcelRequire("8Bn0M");

var $9u8QI = parcelRequire("9u8QI");

var $8e0tE = parcelRequire("8e0tE");
const $648107ee81a89f2c$var$nonEditableInlineEditContainerStyles = null;
const $648107ee81a89f2c$export$fd8ebf59dd2b58b6 = 'numberInlineEdit';
var $648107ee81a89f2c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { fieldKey: fieldKey, issueKey: issueKey, issueId: issueId, onCancel: onCancel, onEdit: onEdit, onEscape: onEscape, onConfirm: onConfirm, onEnter: onEnter, onUpdate: onUpdate, readView: readView, editView: editView, noValueText: noValueText, label: label, ...rest } = props;
    const [{ value: value, error: error, fieldConfig: fieldConfig }, { saveValue: saveValue, resetError: resetError }] = (0, $8Bn0M.useClassicStoryPointField)({
        issueKey: (0, $6vrw7.toIssueKey)(issueKey),
        issueId: issueId && (0, $6vrw7.toIssueId)(issueId),
        fieldKey: fieldKey,
        onSuccess: onUpdate
    });
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'number');
    const [isEditing, setIsEditing] = (0, $eUqFw.useState)(false);
    const [updatedValue, setUpdatedValue] = (0, $eUqFw.useState)(value);
    const isFieldEditable = fieldConfig ? fieldConfig.isEditable : false;
    const [isInvalidInput, setIsInvalidInput] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        if (error) setIsEditing(true);
        if (!isEditing) setUpdatedValue(value);
    }, [
        error,
        isEditing,
        value
    ]);
    const save = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        if (updatedValue !== value) {
            if (updatedValue !== null && updatedValue < 0) {
                setIsInvalidInput(true);
                return;
            }
            saveValue(updatedValue, null, analyticsEvent);
        }
        setIsEditing(false);
        setIsInvalidInput(false);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        saveValue,
        updatedValue,
        value
    ]);
    const cancel = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        resetError();
        setIsEditing(false);
        setUpdatedValue(value);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        setIsInvalidInput(false);
    }, [
        resetError,
        value
    ]);
    const onCancelRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onCancel && onCancel(analyticsEvent);
    }, [
        onCancel,
        cancel
    ]);
    const onConfirmRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        save(analyticsEvent);
        onConfirm && onConfirm(analyticsEvent);
    }, [
        onConfirm,
        save
    ]);
    const onEditRequested = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        setIsEditing(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onEdit && onEdit(analyticsEvent);
    }, [
        onEdit
    ]);
    const onEscapeRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onEscape && onEscape(analyticsEvent);
    }, [
        onEscape,
        cancel
    ]);
    const onChange = (0, $eUqFw.useCallback)((event)=>{
        resetError();
        const typedValue = event.target.value === '' ? null : Number(event.target.value);
        setUpdatedValue(typedValue);
    }, [
        resetError,
        setUpdatedValue
    ]);
    const renderEditView = ()=>editView !== undefined ? editView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9u8QI.ClassicStoryPointEdit), {
            defaultValue: updatedValue,
            onChange: onChange,
            type: fieldType,
            isInvalid: isInvalidInput
        });
    const renderReadView = ()=>readView !== undefined ? readView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5St1r.ReadViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8e0tE.ClassicStoryPointView), {
            isEditable: isFieldEditable,
            value: value,
            noValueText: noValueText
        }));
    const renderErrorFlag = ()=>{
        if (!error) return null;
        const description = error.message === (0, $jCKUR.default).negativeNumbersNotAllowed.id ? (0, $jCKUR.default).negativeNumbersNotAllowed : (0, $jCKUR.default).errorMessage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
            error: error,
            title: (0, $jCKUR.default).errorTitle,
            description: description
        });
    };
    const getEditButtonLabel = ()=>formatMessage((0, $2gGF1.default).extendedEditButtonLabel, {
            inputFieldValue: value !== null ? value : noValueText,
            fieldName: label
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, error && renderErrorFlag(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($648107ee81a89f2c$var$StoryPointInlineEditContainer, {
        isEditable: isFieldEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        testId: (0, $278051bf0c41af4d$export$61c6dd0e4450dc53),
        editButtonLabel: getEditButtonLabel(),
        actionSubject: $648107ee81a89f2c$export$fd8ebf59dd2b58b6,
        isEditable: isFieldEditable,
        isEditing: isEditing,
        readView: renderReadView(),
        editView: isFieldEditable ? renderEditView() : null,
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onEdit: onEditRequested,
        onEscape: onEscapeRequest,
        ...rest
    })));
});
// @ts-expect-error - TS2339 - Property 'isEditable' does not exist on type '{}'.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $648107ee81a89f2c$var$StoryPointInlineEditContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5St1r.InlineEditContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !__cmplp.isEditable && "_18u0idpf _ix5l1m38 _15x6idpf _f8epkb7n",
            __cmplp.className
        ])
    });
});

});
const $278051bf0c41af4d$export$61c6dd0e4450dc53 = 'issue-field-classic-story-point.ui.issue-field-classic-story-point';
const $278051bf0c41af4d$export$2e9ec484766eea26 = 'issue-field-classic-story-point.ui.issue-field-classic-story-point--container';
const $278051bf0c41af4d$export$abf39b1ac36b2351 = 'issue-field-classic-story-point.ui.issue-field-classic-story-point--read-only-container';
const $278051bf0c41af4d$export$5891d7123ec72106 = 'issue-field-classic-story-point.ui.issue-field-classic-story-point-read-view';

parcelRegister("jCKUR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8d52f102484c631$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e8d52f102484c631$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "issue-field-classic-story-point.error-title",
        "defaultMessage": "We couldn't set the story point value"
    },
    errorMessage: {
        "id": "issue-field-classic-story-point.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    negativeNumbersNotAllowed: {
        "id": "issue-field-classic-story-point.negative-numbers-not-allowed",
        "defaultMessage": "Time for some positivity. Story point estimates can't be negative."
    }
});

});

parcelRegister("8Bn0M", function(module, exports) {

$parcel$export(module.exports, "saveField", () => $462f30fdfe9ba1ca$export$72a8b15fb4557735);
$parcel$export(module.exports, "useClassicStoryPointField", () => $462f30fdfe9ba1ca$export$aa8e8a51326640a2);

var $illlw = parcelRequire("illlw");

var $53ciZ = parcelRequire("53ciZ");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $5zSUY = parcelRequire("5zSUY");

var $6vrw7 = parcelRequire("6vrw7");
const $462f30fdfe9ba1ca$export$72a8b15fb4557735 = async (issueId, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPostRequest)(`${baseUrl}/secure/AjaxIssueAction.jspa?decorator=none`, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: (0, $53ciZ.stringify)({
            [fieldKey]: newValue,
            issueId: issueId,
            skipScreenCheck: true,
            atl_token: (0, $5zSUY.default)(),
            singleFieldEdit: true
        })
    });
const $462f30fdfe9ba1ca$export$aa8e8a51326640a2 = ({ issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, onSuccess: onSuccess })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'number');
    const saveClassicField = (_issueKey, _fieldKey, newValue, baseUrl)=>$462f30fdfe9ba1ca$export$72a8b15fb4557735((0, $6vrw7.toIssueKey)(issueId.toString()), fieldKey, newValue, baseUrl);
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        saveField: saveClassicField,
        onSuccess: onSuccess,
        ...(0, $1ybV0.ff)('issue.detail.issue-view-story-point-field-type-analytics_n9ha6') ? {
            analyticsFieldTypeAlias: 'classicstorypoint'
        } : {}
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("9u8QI", function(module, exports) {

$parcel$export(module.exports, "ClassicStoryPointEdit", () => $c6e16e12f074ae3d$export$9add273a07c195b0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7jPhn = parcelRequire("7jPhn");

var $5YsMl = parcelRequire("5YsMl");

var $cf2Y4 = parcelRequire("cf2Y4");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jCKUR = parcelRequire("jCKUR");
const $c6e16e12f074ae3d$export$9add273a07c195b0 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { isInvalid: isInvalid = false, type: type, defaultValue: defaultValue, ...rest } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const value = defaultValue === null ? '' : defaultValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e16e12f074ae3d$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        testId: "issue-field-classic-story-point.ui.edit.inline-edit-field",
        appearance: "subtle",
        autoFocus: true,
        isCompact: true // @ts-expect-error - TS2322 - Type '{ onChange?: ((arg1: ChangeEvent<HTMLInputElement>) => void) | undefined; testId: string; appearance: "subtle"; autoFocus: true; isCompact: true; isLabelHidden: true; ... 4 more ...; elemAfterInput: Element | null; }' is not assignable to type 'IntrinsicAttributes & TextfieldProps & RefAttributes<unknown>'.
        ,
        isLabelHidden: true,
        isInvalid: isInvalid,
        type: type,
        value: value,
        step: "any",
        elemAfterInput: isInvalid === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6e16e12f074ae3d$export$e2229b703bf96afa, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            size: "medium",
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y300)})`,
            label: ""
        })) : null,
        ...rest
    }), isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $jCKUR.default).negativeNumbersNotAllowed)));
});
var $c6e16e12f074ae3d$export$2e2bcd8739ae039 // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $c6e16e12f074ae3d$export$9add273a07c195b0;
const $c6e16e12f074ae3d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80om1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c6e16e12f074ae3d$export$e2229b703bf96afa = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0r5cr _2hwx1b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8e0tE", function(module, exports) {

$parcel$export(module.exports, "ClassicStoryPointView", () => $2aab08c692bb2124$export$218268e664b4e88e);

var $eUqFw = parcelRequire("eUqFw");

var $9nkwJ = parcelRequire("9nkwJ");

var $4ksts = parcelRequire("4ksts");

var $loeG4 = parcelRequire("loeG4");
const $2aab08c692bb2124$var$TEST_ID_CONTAINER = 'issue-field-classic-story-point.ui.inline-view-field-container';
const $2aab08c692bb2124$var$TEST_ID = 'issue-field-classic-story-point.ui.inline-view-field';
const $2aab08c692bb2124$export$218268e664b4e88e = ({ isEditable: isEditable, noValueText: noValueText, value: value })=>{
    const { formatNumber: formatNumber } = (0, $4ksts.useIntlV2)();
    const badgeProps = {
        min: Number.MAX_SAFE_INTEGER * -1,
        max: Number.MAX_SAFE_INTEGER
    };
    if (value === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $loeG4.EmptyValue), {
        "data-testid": $2aab08c692bb2124$var$TEST_ID
    }, noValueText);
    const BadgeComp = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        testId: $2aab08c692bb2124$var$TEST_ID,
        ...badgeProps
    }, formatNumber(value));
    if (isEditable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $loeG4.HoverContainer), {
        "data-testid": $2aab08c692bb2124$var$TEST_ID_CONTAINER
    }, BadgeComp);
    return BadgeComp;
};
var $2aab08c692bb2124$export$2e2bcd8739ae039 = $2aab08c692bb2124$export$218268e664b4e88e;

});
parcelRegister("loeG4", function(module, exports) {

$parcel$export(module.exports, "HoverContainer", () => $31066e8549780802$export$514273ed3d3e3e2c);
$parcel$export(module.exports, "EmptyValue", () => $31066e8549780802$export$1ebe45ee63a8a144);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $31066e8549780802$export$514273ed3d3e3e2c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80omtlke _kvyv16l4 _6nvk1prw",
            __cmplp.className
        ])
    });
});
const $31066e8549780802$export$1ebe45ee63a8a144 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1",
            __cmplp.className
        ])
    });
});

});





parcelRegister("flT7U", function(module, exports) {

$parcel$export(module.exports, "TeamFieldNext", () => $d12e77fb7d0a7798$export$2035b7fa52a68f74);

var $5iWql = parcelRequire("5iWql");

var $huhk2 = parcelRequire("huhk2");


var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $f9RL0 = parcelRequire("f9RL0");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $fVCj0 = parcelRequire("fVCj0");

var $5zSUY = parcelRequire("5zSUY");

var $1TrR5 = parcelRequire("1TrR5");

var $1Mwww = parcelRequire("1Mwww");
const $d12e77fb7d0a7798$var$onUpdateFactory = (0, $5iWql.default)((dispatch, fieldId)=>({
        // @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
        onUpdate: (value)=>dispatch((0, $fVCj0.sweetStateFieldUpdated)(fieldId, value))
    }));
const $d12e77fb7d0a7798$export$2035b7fa52a68f74 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        additionalProps: (state, intl)=>({
                issueKey: (0, $5JqpU.issueKeySelector)(state),
                issueId: (0, $5JqpU.issueIdSelector)(state),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                isEditable: (0, $fokFV.isFieldEditableSelector)(ownPropsOnMount.fieldId)(state) && (0, $jZDJX.loadingStageSelector)(state) !== (0, $d6ff0428d6ad71a2$export$1b56cc494043d9bf) && !!(0, $5zSUY.default)(),
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area),
                isSubTask: !!(0, $fokFV.fieldSelector)((0, $f9RL0.ISSUE_TYPE))(state)?.value?.subtask
            }),
        additionalCallbacks: (0, $1TrR5.functionWithFFRedux)((dispatch)=>({
                onUpdate: $d12e77fb7d0a7798$var$onUpdateFactory(dispatch, ownPropsOnMount.fieldId)
            }), // @ts-expect-error - TS2345 - Property 'clear' is missing in type '(this: any, dispatch: any)
        (dispatch)=>({
                // @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
                onUpdate: (value)=>dispatch((0, $fVCj0.sweetStateFieldUpdated)(ownPropsOnMount.fieldId, value))
            }))
    }))((0, $1Mwww.View));
var $d12e77fb7d0a7798$export$2e2bcd8739ae039 = $d12e77fb7d0a7798$export$2035b7fa52a68f74;

});
parcelRegister("1Mwww", function(module, exports) {

$parcel$export(module.exports, "View", () => $e16f63b2dba85a63$export$27a5bd065ad55220);

var $eUqFw = parcelRequire("eUqFw");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $4bZws = parcelRequire("4bZws");

var $dPhTW = parcelRequire("dPhTW");

var $9Nizy = parcelRequire("9Nizy");
const $e16f63b2dba85a63$export$27a5bd065ad55220 = (props)=>{
    const { label: label, issueKey: issueKey, fieldId: fieldId, issueId: issueId, isSubTask: isSubTask, onUpdate: onUpdate, noValueText: noValueText, showPinButton: showPinButton } = props;
    // For the Teams in Jira EAP we want to hide the team field on subtasks when FF isTeamFieldInSubtasksEnabled is off
    if (isSubTask && !(0, $9Nizy.isTeamFieldInSubtasksEnabled)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, label), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldId,
        label: label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dPhTW.default), {
        label: label,
        issueKey: issueKey,
        issueId: issueId,
        fieldKey: fieldId,
        onUpdate: onUpdate,
        noValueText: noValueText,
        isFitContainerWidthReadView: true
    })));
};
var $e16f63b2dba85a63$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($e16f63b2dba85a63$export$27a5bd065ad55220);

});
parcelRegister("dPhTW", function(module, exports) {

$parcel$export(module.exports, "default", () => $82aa148134021024$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $ldoFd = parcelRequire("ldoFd");

var $c9TLT = parcelRequire("c9TLT");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $dWGNJ = parcelRequire("dWGNJ");

var $6oQPP = parcelRequire("6oQPP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $gd0Sp = parcelRequire("gd0Sp");

var $iC4qb = parcelRequire("iC4qb");

var $5JDtt = parcelRequire("5JDtt");

var $hOa1E = parcelRequire("hOa1E");

var $eHKLj = parcelRequire("eHKLj");

var $5R1rN = parcelRequire("5R1rN");
const $82aa148134021024$export$fd8ebf59dd2b58b6 = 'teamInlineEdit';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$82aa148134021024$export$2e2bcd8739ae039 = (props)=>{
    const { fieldKey: fieldKey, issueKey: issueKey, issueId: issueId, onCancel: onCancel, onEdit: onEdit, onEscape: onEscape, onConfirm: onConfirm, onEnter: onEnter, onUpdate: onUpdate, readView: readView, editView: editView, noValueText: // We must overwrite the default placeholder from the user picker to have a consistent message for read and edit mode
    noValueText = 'DEFAULT PLACEHOLDER MESSAGE', useTeamField: // TODO: need to intl
    useTeamField = (0, $5JDtt.useTeamField), ...rest } = props;
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const siteId = tenantContext.cloudId;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isAssigningNewlyCreatedTeam, setIsAssigningNewlyCreatedTeam] = (0, $eUqFw.useState)(false);
    const onFailure = (0, $eUqFw.useCallback)((err)=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'field updateFailed', 'teamIssueField', {
            isAssigningNewlyCreatedTeam: isAssigningNewlyCreatedTeam,
            error: err
        });
        setIsAssigningNewlyCreatedTeam(false);
    }, [
        createAnalyticsEvent,
        isAssigningNewlyCreatedTeam
    ]);
    const onSuccess = (0, $eUqFw.useCallback)((newValue)=>{
        setIsAssigningNewlyCreatedTeam(false);
        if (onUpdate) onUpdate(newValue);
    }, [
        onUpdate
    ]);
    const [{ value: value, error: error, fieldConfig: fieldConfig }, { saveValue: saveValue, resetError: resetError }] = useTeamField({
        issueKey: (0, $6vrw7.toIssueKey)(issueKey),
        fieldKey: fieldKey,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    const [isEditing, setIsEditing] = (0, $eUqFw.useState)(false);
    const updatedValue = (0, $eUqFw.useRef)(value);
    const isFieldEditable = fieldConfig?.isEditable ?? false;
    const isValueEmpty = (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(updatedValue.current);
    const onCreate = (0, $eUqFw.useCallback)((team)=>{
        if (team && team?.id !== value?.id) {
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'createTeamInline succeeded', 'teamIssueField', {
                memberCount: team.memberCount
            });
            // required wait for new created team to be available
            setTimeout(()=>{
                setIsAssigningNewlyCreatedTeam(true);
                saveValue(team, null, createAnalyticsEvent({
                    action: 'succeeded',
                    actionSubject: 'createTeamInline',
                    attributes: {
                        memberCount: team.memberCount
                    }
                }));
                setIsEditing(false);
            }, 1000);
        }
    }, [
        createAnalyticsEvent,
        saveValue,
        value?.id
    ]);
    const [createTeamDialog, createTeamDialogTrigger] = (0, $eHKLj.useCreateTeamDialog)({
        onCreate: onCreate
    });
    (0, $eUqFw.useEffect)(()=>{
        if (error) setIsEditing(true);
        if (!isEditing) updatedValue.current = value;
    }, [
        error,
        value,
        isEditing
    ]);
    const save = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        // Needed when assigning team failed, otherwise it would stuck in a loop and cannot be closed.
        resetError();
        if (updatedValue.current?.id !== value?.id) saveValue(updatedValue.current, null, analyticsEvent);
        setIsEditing(false);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        resetError,
        saveValue,
        value?.id
    ]);
    const cancel = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        resetError();
        setIsEditing(false);
        updatedValue.current = value;
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        resetError,
        value
    ]);
    const onCancelRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onCancel && onCancel(analyticsEvent);
    }, [
        cancel,
        onCancel
    ]);
    const onConfirmRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        save(analyticsEvent);
        onConfirm && onConfirm(analyticsEvent);
    }, [
        onConfirm,
        save
    ]);
    const onEditRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        setIsEditing(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onEdit && onEdit(analyticsEvent);
    }, [
        onEdit
    ]);
    const onEscapeRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onEscape && onEscape(analyticsEvent);
    }, [
        cancel,
        onEscape
    ]);
    const onChange = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'val' implicitly has an 'any' type.
    (val)=>{
        resetError();
        updatedValue.current = val;
    }, [
        resetError
    ]);
    const renderEditView = ()=>editView !== undefined ? editView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hOa1E.TeamPickerEdit), {
            defaultValue: updatedValue.current,
            siteId: siteId,
            onChange: onChange,
            autoFocus: true,
            noValueText: noValueText,
            createTeamDialogTrigger: createTeamDialogTrigger
        });
    const renderReadView = ()=>readView !== undefined ? readView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5R1rN.TeamPickerView), {
            defaultValue: updatedValue.current,
            placeholder: noValueText,
            isEditable: isFieldEditable
        });
    const renderErrorFlag = ()=>{
        if (!error) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
            error: error,
            title: (0, $iC4qb.default).errorTitle,
            description: (0, $iC4qb.default).errorMessage
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, error && renderErrorFlag(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82aa148134021024$export$663ed42385f12929, {
        isFieldEditable: isFieldEditable,
        isEditing: isEditing,
        fixedHeight: false,
        isEmpty: readView === undefined && isValueEmpty
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        testId: "issue-field-team.ui.view",
        isEditable: isFieldEditable,
        isEditing: isEditing,
        areActionButtonsHidden: true,
        isFitContainerWidthReadView: true,
        readView: renderReadView(),
        editView: isFieldEditable ? renderEditView() : null,
        onEdit: onEditRequest,
        shouldConfirmOnEnter: true,
        actionSubject: $82aa148134021024$export$fd8ebf59dd2b58b6,
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onEscape: onEscapeRequest,
        ...rest
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-field-team-create-dialog"
    }, createTeamDialog));
};
const $82aa148134021024$export$663ed42385f12929 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "l4exg-0"
})`margin-left:${"var(--ds-space-negative-100, -8px)"};margin-right:${"var(--ds-space-100, 8px)"};margin-top:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>{
    if (props.isFieldEditable) return "var(--ds-space-negative-100, -8px)";
    if (props.isEmpty) return '-13px';
    return "var(--ds-space-negative-150, -12px)";
}};${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>!props.isEditing && props.fixedHeight ? `height: ${(0, $c9TLT.gridSize) * 4}px` : ''};`;

});
parcelRegister("iC4qb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f0b2f105010cb38$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5f0b2f105010cb38$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "issue-field-team.error-title",
        "defaultMessage": "We couldn't set the team value"
    },
    errorMessage: {
        "id": "issue-field-team.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    teamErrorViewTooltip: {
        "id": "issue-field-team.team-error-view-tooltip",
        "defaultMessage": "This team may have been deleted, or you do not have access"
    },
    teamErrorViewText: {
        "id": "issue-field-team.team-error-view-text",
        "defaultMessage": "Not available"
    },
    placeholderTeamEditSelector: {
        "id": "issue-field-team.placeholder-team-edit-selector",
        "defaultMessage": "Choose a team"
    },
    defaultNoValueText: {
        "id": "issue-field-team.default-no-value-text",
        "defaultMessage": "None"
    },
    createTeamButtonText: {
        "id": "issue-field-team.create-team-button-text",
        "defaultMessage": "Create a team"
    },
    emptyStateDescription: {
        "id": "issue-field-team.empty-state-description",
        "defaultMessage": "Create a team to assign work across Jira and track it on your team\u2019s profile"
    },
    noOptionsMessage: {
        "id": "issue-field-team.no-options-message",
        "defaultMessage": "No options"
    }
});

});

parcelRegister("5JDtt", function(module, exports) {

$parcel$export(module.exports, "useTeamField", () => $3373352d37138ba2$export$183b0f27978cd3a6);

var $illlw = parcelRequire("illlw");

var $fecbI = parcelRequire("fecbI");
var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $3373352d37138ba2$var$saveField = async (issueKey, fieldKey, newValue, baseUrl)=>{
    const newId = newValue?.id ?? null;
    return (0, $fecbI.defaultSaveField)(issueKey, fieldKey, newId, baseUrl);
};
const $3373352d37138ba2$export$183b0f27978cd3a6 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'array');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        saveField: $3373352d37138ba2$var$saveField,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("hOa1E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "TeamPickerEdit", () => $b22fbd8eb6ed88af$export$cb5f622bec189851);
$parcel$export(module.exports, "default", () => $b22fbd8eb6ed88af$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $i9N6e = parcelRequire("i9N6e");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");

var $jD3pk = parcelRequire("jD3pk");


var $iC4qb = parcelRequire("iC4qb");

var $j7YJ9 = parcelRequire("j7YJ9");

var $hg5fi = parcelRequire("hg5fi");

var $iwGX8 = parcelRequire("iwGX8");
// FIXME: These are overrides for @atlaskit/select@15.6 -> react-select@4.3.x
//        Once @atlaskit/select@15.6 resolution has been removed from package.json
//        these should be removed as well. See PTC-6238.
const $b22fbd8eb6ed88af$var$stylesOverrides = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    valueContainer: (base)=>({
            ...base,
            display: 'grid'
        }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    placeholder: (base)=>({
            ...base,
            position: undefined,
            top: undefined,
            left: undefined,
            transform: undefined
        })
};
const $b22fbd8eb6ed88af$export$cb5f622bec189851 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { siteId: siteId, defaultValue: defaultValue, isClearable: isClearable = true, isDisabled: isDisabled = false, autoFocus: autoFocus = false, width: width = '100%', debounceTime: debounceTime = 300, onChange: onChange, placeholder: placeholder = formatMessage((0, $iC4qb.default).placeholderTeamEditSelector), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, styles: styles, noValueText: noValueText, createTeamDialogTrigger: createTeamDialogTrigger, isCompact: isCompact = true, hasNoTeamOption: hasNoTeamOption = true, ...fieldProps } = props;
    const [isCreateButtonFocused, setIsCreateButtonFocused] = (0, $eUqFw.useState)(false);
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const [hasTeams, setHasTeams] = (0, $eUqFw.useState)(true);
    const formattedNoValueText = formatMessage((0, $iC4qb.default).defaultNoValueText);
    const [updatedPlaceholder, setUpdatedPlaceholder] = (0, $eUqFw.useState)(placeholder);
    const [inputQuery, setInputQuery] = (0, $eUqFw.useState)('');
    const finalStyles = {
        ...(0, $4NcaX.defaultSelectStyles),
        ...styles || {},
        ...$b22fbd8eb6ed88af$var$stylesOverrides
    };
    const maybeAddNoTeamOption = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'users' implicitly has an 'any' type.
    (users, query)=>{
        setHasTeams(!(users.length === 0 && query.length === 0));
        if (query === '' && !!defaultValue && hasNoTeamOption) return [
            {
                avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($j7YJ9))),
                id: (0, $153fcafb1d4658a6$export$53782b65600ab96d),
                name: noValueText ?? formattedNoValueText
            }
        ].concat(users);
        setIsCreateButtonFocused(query.length > 0 && users.length === 0);
        return users;
    }, [
        defaultValue,
        noValueText,
        formattedNoValueText,
        hasNoTeamOption
    ]);
    const handleOnChange = (newValue, actionType)=>{
        if (Array.isArray(newValue)) return;
        if (onChange) {
            onChange(newValue?.id === (0, $153fcafb1d4658a6$export$53782b65600ab96d) ? null : newValue, actionType);
            setUpdatedPlaceholder(newValue?.id === (0, $153fcafb1d4658a6$export$53782b65600ab96d) ? formattedNoValueText : placeholder);
        }
    };
    const handleCreateTeam = (0, $eUqFw.useCallback)(()=>{
        createTeamDialogTrigger(inputQuery);
    }, [
        inputQuery,
        createTeamDialogTrigger
    ]);
    const handleOnKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (isCreateButtonFocused && event.key === 'Enter') handleCreateTeam();
    }, [
        isCreateButtonFocused,
        handleCreateTeam
    ]);
    const handleOnInputChange = (0, $eUqFw.useCallback)((query)=>{
        setInputQuery(query || '');
    }, [
        setInputQuery
    ]);
    const footer = (0, $eUqFw.useMemo)(()=>hasTeams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hg5fi.CreateTeamOption), {
            isFocused: isCreateButtonFocused,
            onClick: handleCreateTeam
        }), [
        hasTeams,
        handleCreateTeam,
        isCreateButtonFocused
    ]);
    const noOptionsMessage = (0, $eUqFw.useMemo)(()=>!hasTeams ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iwGX8.TeamPickerEmptyState), {
                onActionClick: handleCreateTeam
            }) : undefined, [
        hasTeams,
        handleCreateTeam
    ]);
    const menuListStyle = (0, $eUqFw.useMemo)(()=>!hasTeams ? {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            menuList: (base)=>({
                    ...base,
                    maxHeight: '350px'
                })
        } : {}, [
        hasTeams
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i9N6e.default), {
        // Setting width=100% will allow dropdown to size correctly
        width: width,
        autoFocus: autoFocus,
        appearance: isCompact ? 'compact' : 'normal',
        debounceTime: debounceTime,
        fieldId: "team",
        filterOptions: maybeAddNoTeamOption,
        footer: footer,
        includeGroups: false,
        includeTeams: true,
        includeUsers: false,
        isClearable: isClearable,
        isMulti: false,
        isDisabled: isDisabled,
        productKey: "jira",
        siteId: siteId,
        value: defaultValue,
        onChange: handleOnChange,
        orgId: orgId,
        placeholder: updatedPlaceholder,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'absolute' : undefined,
        styles: {
            ...finalStyles,
            ...menuListStyle
        },
        onInputChange: handleOnInputChange,
        onKeyDown: handleOnKeyDown,
        noOptionsMessage: noOptionsMessage,
        ariaLabelledBy: fieldProps['aria-labelledby'],
        placeholderAvatar: (0, $eI5EY.fg)('show_team_avatar_in_team_field_placeholder') ? 'team' : undefined
    });
};
var $b22fbd8eb6ed88af$export$2e2bcd8739ae039 = $b22fbd8eb6ed88af$export$cb5f622bec189851;

});
parcelRegister("i9N6e", function(module, exports) {

$parcel$export(module.exports, "default", () => $d37f2762b081e0cd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2NIYQ = parcelRequire("2NIYQ");

var $jqLGp = parcelRequire("jqLGp");

var $f4awa = parcelRequire("f4awa");
const $d37f2762b081e0cd$var$SmartUserPickerWithIntlProvider = (props)=>{
    const ufoId = props.inputId || props.fieldId;
    (0, $f4awa.useUFOConcurrentExperience)((0, $f4awa.smartUserPickerRenderedUfoExperience), ufoId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f4awa.UfoErrorBoundary), {
        id: ufoId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jqLGp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2NIYQ.SmartUserPicker), props)));
};
var $d37f2762b081e0cd$export$2e2bcd8739ae039 = $d37f2762b081e0cd$var$SmartUserPickerWithIntlProvider;

});
parcelRegister("2NIYQ", function(module, exports) {

$parcel$export(module.exports, "SmartUserPicker", () => $20a30c8fcb268fa7$export$9eedb6e5d313efdb);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $hompL = parcelRequire("hompL");

var $2jDha = parcelRequire("2jDha");

var $5iWql = parcelRequire("5iWql");

var $2qhQi = parcelRequire("2qhQi");

var $uMitL = parcelRequire("uMitL");

var $3Kv5Q = parcelRequire("3Kv5Q");
var $fsJBk = parcelRequire("fsJBk");

var $aQp4t = parcelRequire("aQp4t");

var $jqLGp = parcelRequire("jqLGp");

var $2LkxT = parcelRequire("2LkxT");
var $2VvJ9 = parcelRequire("2VvJ9");

var $f4awa = parcelRequire("f4awa");
const $20a30c8fcb268fa7$var$DEFAULT_DEBOUNCE_TIME_MS = 150;
const $20a30c8fcb268fa7$var$ufoEndStateConfig = (fieldId)=>{
    return {
        metadata: {
            contextType: fieldId
        }
    };
};
const $20a30c8fcb268fa7$var$hasContextChanged = (oldContext, newContext)=>oldContext.siteId !== newContext.siteId || oldContext.orgId !== newContext.orgId || oldContext.productKey !== newContext.productKey || oldContext.principalId !== newContext.principalId || oldContext.containerId !== newContext.containerId || oldContext.objectId !== newContext.objectId || oldContext.childObjectId !== newContext.childObjectId;
const $20a30c8fcb268fa7$var$stringContains = (str, substr)=>{
    if (str === null || str === undefined) return false;
    if (substr === null || substr === '' || substr === undefined) return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $20a30c8fcb268fa7$var$getUsersForAnalytics = (users)=>(users || []).map(({ id: id, type: type })=>({
            id: id,
            type: type
        }));
const $20a30c8fcb268fa7$var$checkIf500Event = (statusCode)=>500 <= statusCode && statusCode < 600;
class $20a30c8fcb268fa7$export$9b9bd453d1d4e4ce extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        var _this$props$debounceT;
        super(props);
        (0, $5zQU9.default)(this, "state", {
            users: [],
            loading: false,
            closed: true,
            query: '',
            defaultValue: [],
            bootstrapOptions: []
        });
        (0, $5zQU9.default)(this, "abortOptionsShownUfoExperience", ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $uMitL.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        });
        (0, $5zQU9.default)(this, "startOptionsShownUfoExperience", ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        });
        (0, $5zQU9.default)(this, "fireEvent", (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $aQp4t.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, ...args))(createAnalyticsEvent);
        });
        (0, $5zQU9.default)(this, "filterOptions", (users, query, propFilterOptions)=>propFilterOptions ? propFilterOptions(users, query) : users);
        (0, $5zQU9.default)(this, "memoizedFilterOptions", (0, $5iWql.default)(this.filterOptions));
        (0, $5zQU9.default)(this, "getUsers", (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(async ()=>{
            const { query: query, sessionId: sessionId, closed: closed } = this.state;
            const { baseUrl: baseUrl, childObjectId: childObjectId, containerId: containerId, fieldId: fieldId, includeGroups: includeGroups, includeTeams: includeTeams, includeUsers: includeUsers, includeNonLicensedUsers: includeNonLicensedUsers, intl: intl, maxOptions: maxOptions, objectId: objectId, onEmpty: onEmpty, onError: onError, overrideByline: overrideByline, orgId: orgId, principalId: principalId, productAttributes: productAttributes, productKey: productKey, searchQueryFilter: searchQueryFilter, siteId: siteId } = this.props;
            const maxNumberOfResults = maxOptions || 100;
            const startTime = window.performance.now();
            const recommendationsRequest = {
                baseUrl: baseUrl,
                context: {
                    containerId: containerId,
                    contextType: fieldId,
                    objectId: objectId,
                    principalId: principalId,
                    productKey: productKey,
                    siteId: siteId,
                    organizationId: orgId,
                    childObjectId: childObjectId,
                    sessionId: sessionId,
                    productAttributes: productAttributes
                },
                includeUsers: includeUsers,
                includeGroups: includeGroups,
                includeTeams: includeTeams,
                includeNonLicensedUsers: includeNonLicensedUsers,
                maxNumberOfResults: maxNumberOfResults,
                query: query,
                searchQueryFilter: searchQueryFilter
            };
            try {
                var _await$onEmpty;
                this.fireEvent((0, $aQp4t.requestUsersEvent));
                const recommendedUsers = await (0, $2LkxT.default)(recommendationsRequest, intl);
                if (overrideByline) {
                    for (let option of recommendedUsers)if ((0, $fsJBk.isUser)(option) || (0, $fsJBk.isExternalUser)(option) || (0, $fsJBk.isTeam)(option)) option.byline = overrideByline(option);
                }
                const elapsedTimeMilli = window.performance.now() - startTime;
                const displayedUsers = recommendedUsers.length === 0 && onEmpty ? (_await$onEmpty = await onEmpty(query)) !== null && _await$onEmpty !== void 0 ? _await$onEmpty : [] : recommendedUsers;
                this.setState((state)=>{
                    const applicable = state.query === query;
                    const users = applicable ? displayedUsers : state.users;
                    const loading = !applicable;
                    this.fireEvent((0, $aQp4t.successfulRequestUsersEvent), {
                        users: $20a30c8fcb268fa7$var$getUsersForAnalytics(recommendedUsers),
                        elapsedTimeMilli: elapsedTimeMilli,
                        displayedUsers: $20a30c8fcb268fa7$var$getUsersForAnalytics(displayedUsers),
                        productAttributes: productAttributes,
                        applicable: applicable
                    });
                    return {
                        users: users,
                        loading: loading
                    };
                });
            } catch (e) {
                const is5xxEvent = $20a30c8fcb268fa7$var$checkIf500Event(e.statusCode);
                if (!closed && !onError && is5xxEvent) // If the user lookup fails while the menu is open, and the consumer is not providing a
                // fallback data source via the onError prop, then send UFO failure
                this.optionsShownUfoExperienceInstance.failure($20a30c8fcb268fa7$var$ufoEndStateConfig(this.props.fieldId));
                this.setState({
                    users: []
                });
                let onErrorProducedError = false;
                let defaultUsers = [];
                try {
                    defaultUsers = onError ? await onError(e, recommendationsRequest) || [] : [];
                } catch (error) {
                    onErrorProducedError = true;
                }
                if (onErrorProducedError && is5xxEvent) // Log error from fallback data source `onError` to UFO
                this.optionsShownUfoExperienceInstance.failure($20a30c8fcb268fa7$var$ufoEndStateConfig(this.props.fieldId));
                if (!is5xxEvent && (!onError && !closed || onErrorProducedError)) this.abortOptionsShownUfoExperience();
                this.setState({
                    users: defaultUsers,
                    loading: false
                });
                const elapsedTimeMilli = window.performance.now() - startTime;
                this.fireEvent((0, $aQp4t.failedRequestUsersEvent), {
                    elapsedTimeMilli: elapsedTimeMilli,
                    productAttributes: productAttributes
                });
            }
        }, (_this$props$debounceT = this.props.debounceTime) !== null && _this$props$debounceT !== void 0 ? _this$props$debounceT : 0));
        (0, $5zQU9.default)(this, "onInputChange", (newQuery, sessionId)=>{
            const query = newQuery || '';
            const { closed: closed } = this.state;
            if (query === this.state.query) return;
            if (!closed) {
                // If the input has been typed into and the dropdown has not been closed
                // (i.e. input blurred) then start the UFO timer.
                // If there's a previous UFO timer running for the same "options shown" experience,
                // it will be aborted first.
                this.startOptionsShownUfoExperience();
                this.setState({
                    loading: true,
                    query: query,
                    sessionId: sessionId
                });
                if (this.props.onInputChange) this.props.onInputChange(query, sessionId);
            }
        });
        (0, $5zQU9.default)(this, "filterUsers", ()=>{
            const { loading: loading, users: users, query: query } = this.state;
            const filteredUsers = this.memoizedFilterOptions(users, query, this.props.filterOptions);
            //If bootstrapOptions have been passed in and it is bootstrap
            if (this.props.bootstrapOptions && this.props.bootstrapOptions.length !== 0 && query === '') {
                const bootstrapFilteredUsers = this.memoizedFilterOptions(this.props.bootstrapOptions, query, this.props.filterOptions);
                this.fireEvent((0, $aQp4t.filterUsersEvent), {
                    filtered: $20a30c8fcb268fa7$var$getUsersForAnalytics(bootstrapFilteredUsers),
                    all: $20a30c8fcb268fa7$var$getUsersForAnalytics(this.props.bootstrapOptions)
                });
                return bootstrapFilteredUsers;
            }
            // while when not loading just return already filtered result from server.
            if (!loading) return filteredUsers;
            const queryFilteredUsers = filteredUsers.filter((user)=>$20a30c8fcb268fa7$var$stringContains(user.name, query));
            this.fireEvent((0, $aQp4t.filterUsersEvent), {
                filtered: $20a30c8fcb268fa7$var$getUsersForAnalytics(queryFilteredUsers),
                all: $20a30c8fcb268fa7$var$getUsersForAnalytics(users)
            });
            // when loading filter previous result.
            return filteredUsers;
        });
        (0, $5zQU9.default)(this, "onFocus", (sessionId)=>{
            const state = {
                query: '',
                closed: false
            };
            this.startOptionsShownUfoExperience();
            if (this.state.users.length === 0) {
                state.sessionId = sessionId;
                state.loading = true;
            } else this.fireEvent((0, $aQp4t.preparedUsersLoadedEvent), {
                users: $20a30c8fcb268fa7$var$getUsersForAnalytics(this.state.users),
                preparedSessionId: this.state.sessionId,
                sessionId: sessionId
            });
            this.setState((currentState)=>({
                    ...currentState,
                    ...state
                }));
            if (this.props.onFocus) this.props.onFocus(sessionId);
        });
        (0, $5zQU9.default)(this, "onBlur", (sessionId)=>{
            this.getUsers.cancel();
            this.abortOptionsShownUfoExperience();
            // clear old users if query is populated so that on refocus,
            // the old list is not shown
            const users = this.state.query.length === 0 ? this.state.users : [];
            this.setState({
                loading: false,
                closed: true,
                users: users
            });
            if (this.props.onBlur) this.props.onBlur(sessionId);
        });
        this.optionsShownUfoExperienceInstance = (0, $f4awa.smartUserPickerOptionsShownUfoExperience).getInstance(props.inputId || props.fieldId);
    }
    async componentDidMount() {
        try {
            const value = await (0, $2VvJ9.default)(this.props.baseUrl, this.props.defaultValue, this.props.productKey);
            this.setState({
                defaultValue: value
            });
        } catch (e) {
            const defaultValue = await (this.props.onValueError ? this.props.onValueError(e, this.props.defaultValue) || Promise.resolve([]) : Promise.resolve([]));
            this.setState({
                defaultValue: defaultValue
            });
        }
        const { prefetch: prefetch } = this.props;
        if (prefetch) {
            const sessionId = (0, $hompL.v4)();
            this.fireEvent((0, $aQp4t.mountedWithPrefetchEvent), {
                sessionId: sessionId
            });
            this.setState({
                sessionId: sessionId
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if ($20a30c8fcb268fa7$var$hasContextChanged(prevProps, this.props) || this.props.fieldId !== prevProps.fieldId) this.setState({
            users: []
        });
        if ((this.state.sessionId !== prevState.sessionId || this.state.query !== prevState.query) && (this.state.query !== '' || !this.props.bootstrapOptions)) this.getUsers();
        else if (!this.state.closed && !this.state.loading) // If the component has rendered (including its dropdown list) and it
        // is not loading anything further, send the success UFO event
        {
            if (![
                (0, $uMitL.UFOExperienceState).FAILED.id,
                (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
                (0, $uMitL.UFOExperienceState).ABORTED.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success($20a30c8fcb268fa7$var$ufoEndStateConfig(this.props.fieldId));
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jqLGp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Kv5Q.UserPicker), (0, $kU09D.default)({}, this.props, {
            onInputChange: this.onInputChange,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            defaultValue: this.state.defaultValue,
            isLoading: this.props.isLoading || this.state.loading && !this.state.closed && (!this.props.bootstrapOptions || this.state.query !== ''),
            options: this.filterUsers()
        })));
    }
}
// TODO: Smart User picker team will have to add a type annotation here
(0, $5zQU9.default)($20a30c8fcb268fa7$export$9b9bd453d1d4e4ce, "defaultProps", {
    baseUrl: '',
    includeUsers: true,
    includeGroups: false,
    includeTeams: false,
    includeNonLicensedUsers: false,
    prefetch: false,
    principalId: 'Context',
    debounceTime: $20a30c8fcb268fa7$var$DEFAULT_DEBOUNCE_TIME_MS
});
const $20a30c8fcb268fa7$export$9eedb6e5d313efdb = (0, $2jDha.default)()((0, $2qhQi.default)($20a30c8fcb268fa7$export$9b9bd453d1d4e4ce));

});
parcelRegister("aQp4t", function(module, exports) {

$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $7e523554c939c105$export$53eef0dcd9611650);
$parcel$export(module.exports, "preparedUsersLoadedEvent", () => $7e523554c939c105$export$185f4c3d9b7ef9bf);
$parcel$export(module.exports, "mountedWithPrefetchEvent", () => $7e523554c939c105$export$9cfb4251e50d7b91);
$parcel$export(module.exports, "filterUsersEvent", () => $7e523554c939c105$export$fbba77127d7cb173);
$parcel$export(module.exports, "requestUsersEvent", () => $7e523554c939c105$export$1762ed8845ff2d9b);
$parcel$export(module.exports, "successfulRequestUsersEvent", () => $7e523554c939c105$export$bfc020018aa738d0);
$parcel$export(module.exports, "failedRequestUsersEvent", () => $7e523554c939c105$export$738aca68b593db8e);

var $hM7RE = parcelRequire("hM7RE");

var $hompL = parcelRequire("hompL");
const $7e523554c939c105$var$packageName = "@atlaskit/smart-user-picker";
const $7e523554c939c105$var$packageVersion = "6.9.3";
const $7e523554c939c105$export$c0d84948cecf78d8 = ()=>({
        id: (0, $hompL.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $7e523554c939c105$export$53eef0dcd9611650 = (0, $hM7RE.default)('fabric-elements');
const $7e523554c939c105$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $7e523554c939c105$var$packageName,
            packageVersion: $7e523554c939c105$var$packageVersion,
            ...attributes
        }
    });
const $7e523554c939c105$var$createDefaultSmartPickerAttributes = (props, state)=>{
    const { fieldId: fieldId, objectId: objectId, containerId: containerId, childObjectId: childObjectId, prefetch: prefetch, maxOptions: maxOptions, includeTeams: includeTeams, productKey: productKey, principalId: principalId, siteId: siteId, orgId: orgId, filterOptions: filterOptions } = props;
    const { sessionId: sessionId, query: query } = state;
    const maxNumberOfResults = maxOptions || 100;
    return {
        context: fieldId,
        childObjectId: childObjectId,
        containerId: containerId,
        hasFilterOptions: Boolean(filterOptions),
        includeTeams: includeTeams,
        maxNumberOfResults: maxNumberOfResults,
        objectId: objectId,
        prefetch: prefetch,
        principalId: principalId,
        productKey: productKey,
        queryLength: (query || '').length,
        siteId: siteId,
        orgId: orgId,
        sessionId: sessionId
    };
};
const $7e523554c939c105$var$createSmartUserPickerEvent = (action, actionSubect, attributes = {})=>({
        source: 'smart-user-picker',
        ...$7e523554c939c105$var$createEvent('operational', action, actionSubect, attributes)
    });
const $7e523554c939c105$export$185f4c3d9b7ef9bf = (props, state, attributes = {})=>$7e523554c939c105$var$createSmartUserPickerEvent('loaded', 'preparedUsers', {
        ...$7e523554c939c105$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7e523554c939c105$export$9cfb4251e50d7b91 = (props, state, attributes = {})=>$7e523554c939c105$var$createSmartUserPickerEvent('mounted', 'prefetch', {
        ...$7e523554c939c105$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7e523554c939c105$export$fbba77127d7cb173 = (props, state, attributes = {})=>$7e523554c939c105$var$createSmartUserPickerEvent('filtered', 'users', {
        ...$7e523554c939c105$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7e523554c939c105$export$1762ed8845ff2d9b = (props, state, attributes = {})=>$7e523554c939c105$var$createSmartUserPickerEvent('requested', 'users', {
        ...$7e523554c939c105$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7e523554c939c105$export$bfc020018aa738d0 = (props, state, attributes = {})=>$7e523554c939c105$var$createSmartUserPickerEvent('successful', 'usersRequest', {
        ...$7e523554c939c105$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7e523554c939c105$export$738aca68b593db8e = (props, state, attributes = {})=>$7e523554c939c105$var$createSmartUserPickerEvent('failed', 'usersRequest', {
        ...$7e523554c939c105$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });

});

parcelRegister("jqLGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2556ee0c6b878c2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");
var $3dpxL = parcelRequire("3dpxL");

var $gdgmT = parcelRequire("gdgmT");
const $e2556ee0c6b878c2$var$EMPTY = {};
const $e2556ee0c6b878c2$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState($e2556ee0c6b878c2$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        let aborted = false;
        setMessages($e2556ee0c6b878c2$var$EMPTY);
        (0, $gdgmT.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $e2556ee0c6b878c2$var$MessagesIntlProvider = (props)=>{
    const { intl: intl, children: children } = props;
    const messages = $e2556ee0c6b878c2$var$useI18n(intl.locale);
    const mergedMessages = (0, $eUqFw.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: intl.locale,
        messages: mergedMessages
    }, children);
};
var $e2556ee0c6b878c2$export$2e2bcd8739ae039 = (0, $2qhQi.default)($e2556ee0c6b878c2$var$MessagesIntlProvider);

});
parcelRegister("gdgmT", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $bcda8e9ed43ba114$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $bcda8e9ed43ba114$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("aULwa")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("hP8LB")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("lIqEs")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("jCqfT")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("bKRln")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("dRdOo")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("ccAZ6")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("4lWVp")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("5iQJP")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("2iMAF")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("kstUu")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("2H75t")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("a8Xfq")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("cX1RU")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("7BdvF")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("la0e7")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("kBch1")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("1XFq8")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("4K7MJ")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("cYjpb")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("d6SC8")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("2VImw")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("3zGc1")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("k9ba1")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("bvXw7")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("14lt8")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("aYuLG")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("f1hhB")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("ijXGZ")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $bcda8e9ed43ba114$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("jCqfT")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("aULwa", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gBgAn');
        const value = parcelRequire('7YW17');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gBgAn").then(()=>parcelRequire('7YW17'));
}

});

parcelRegister("hP8LB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2XVoA');
        const value = parcelRequire('95XHn');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2XVoA").then(()=>parcelRequire('95XHn'));
}

});

parcelRegister("lIqEs", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ch5pT');
        const value = parcelRequire('6eRFN');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ch5pT").then(()=>parcelRequire('6eRFN'));
}

});

parcelRegister("jCqfT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('boaFN');
        const value = parcelRequire('ayf0Z');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("boaFN").then(()=>parcelRequire('ayf0Z'));
}

});

parcelRegister("bKRln", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9z5yF');
        const value = parcelRequire('eVBO4');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9z5yF").then(()=>parcelRequire('eVBO4'));
}

});

parcelRegister("dRdOo", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hDa5V');
        const value = parcelRequire('4kvIH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hDa5V").then(()=>parcelRequire('4kvIH'));
}

});

parcelRegister("ccAZ6", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jRiXZ');
        const value = parcelRequire('bv8An');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jRiXZ").then(()=>parcelRequire('bv8An'));
}

});

parcelRegister("4lWVp", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('i94SQ');
        const value = parcelRequire('83cf4');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("i94SQ").then(()=>parcelRequire('83cf4'));
}

});

parcelRegister("5iQJP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cMmDe');
        const value = parcelRequire('ht5U7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cMmDe").then(()=>parcelRequire('ht5U7'));
}

});

parcelRegister("2iMAF", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dWmnI');
        const value = parcelRequire('fxUys');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dWmnI").then(()=>parcelRequire('fxUys'));
}

});

parcelRegister("kstUu", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8ih1J');
        const value = parcelRequire('1eZdq');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8ih1J").then(()=>parcelRequire('1eZdq'));
}

});

parcelRegister("2H75t", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4un30');
        const value = parcelRequire('fHk6T');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4un30").then(()=>parcelRequire('fHk6T'));
}

});

parcelRegister("a8Xfq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lM8hf');
        const value = parcelRequire('easT3');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lM8hf").then(()=>parcelRequire('easT3'));
}

});

parcelRegister("cX1RU", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8ojT8');
        const value = parcelRequire('hWg5C');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8ojT8").then(()=>parcelRequire('hWg5C'));
}

});

parcelRegister("7BdvF", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4ty2n');
        const value = parcelRequire('5YgvV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4ty2n").then(()=>parcelRequire('5YgvV'));
}

});

parcelRegister("la0e7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dZEYD');
        const value = parcelRequire('7gNut');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dZEYD").then(()=>parcelRequire('7gNut'));
}

});

parcelRegister("kBch1", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iOX4q');
        const value = parcelRequire('1AAqf');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iOX4q").then(()=>parcelRequire('1AAqf'));
}

});

parcelRegister("1XFq8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gSB29');
        const value = parcelRequire('4fYMf');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gSB29").then(()=>parcelRequire('4fYMf'));
}

});

parcelRegister("4K7MJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('egZJv');
        const value = parcelRequire('6T99L');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("egZJv").then(()=>parcelRequire('6T99L'));
}

});

parcelRegister("cYjpb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9mFAU');
        const value = parcelRequire('8zJ36');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9mFAU").then(()=>parcelRequire('8zJ36'));
}

});

parcelRegister("d6SC8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3WIZ5');
        const value = parcelRequire('4xgbL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3WIZ5").then(()=>parcelRequire('4xgbL'));
}

});

parcelRegister("2VImw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bq5Z2');
        const value = parcelRequire('1Hyap');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bq5Z2").then(()=>parcelRequire('1Hyap'));
}

});

parcelRegister("3zGc1", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1UDTG');
        const value = parcelRequire('kiBSd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1UDTG").then(()=>parcelRequire('kiBSd'));
}

});

parcelRegister("k9ba1", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5DInQ');
        const value = parcelRequire('17brZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5DInQ").then(()=>parcelRequire('17brZ'));
}

});

parcelRegister("bvXw7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('h7mSQ');
        const value = parcelRequire('1t9mo');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("h7mSQ").then(()=>parcelRequire('1t9mo'));
}

});

parcelRegister("14lt8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('chKLl');
        const value = parcelRequire('jmzUy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("chKLl").then(()=>parcelRequire('jmzUy'));
}

});

parcelRegister("aYuLG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hedLP');
        const value = parcelRequire('7ojo4');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hedLP").then(()=>parcelRequire('7ojo4'));
}

});

parcelRegister("f1hhB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('e8aYo');
        const value = parcelRequire('baf7C');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("e8aYo").then(()=>parcelRequire('baf7C'));
}

});

parcelRegister("ijXGZ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bRVdL');
        const value = parcelRequire('3VaB6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bRVdL").then(()=>parcelRequire('3VaB6'));
}

});



parcelRegister("2LkxT", function(module, exports) {

$parcel$export(module.exports, "default", () => $202fe87cd76a185c$export$2e2bcd8739ae039);

var $ldtyu = parcelRequire("ldtyu");

var $7OojT = parcelRequire("7OojT");
const $202fe87cd76a185c$var$getUserRecommendations = (request, intl)=>{
    var _request$context, _request$context$prod;
    const url = (0, $7OojT.config).getRecommendationServiceUrl(request.baseUrl || '');
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            includeNonLicensedUsers: request.includeNonLicensedUsers,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                ...((_request$context = request.context) === null || _request$context === void 0 ? void 0 : (_request$context$prod = _request$context.productAttributes) === null || _request$context$prod === void 0 ? void 0 : _request$context$prod.isEntitledConfluenceExternalCollaborator) && {
                    productAccessPermissionIds: [
                        'write',
                        'external-collaborator-write'
                    ]
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`,
            statusCode: response.status
        });
    }).then((response)=>(0, $ldtyu.transformUsers)(response, intl));
};
var $202fe87cd76a185c$export$2e2bcd8739ae039 = $202fe87cd76a185c$var$getUserRecommendations;

});
parcelRegister("ldtyu", function(module, exports) {

$parcel$export(module.exports, "transformUsers", () => $f721bcf2dfb1123d$export$fb8c90bfc4beaa59);


var $6wM4F = parcelRequire("6wM4F");

var $9CDxC = parcelRequire("9CDxC");
const $f721bcf2dfb1123d$var$getLozenzeProperties = (entity, intl)=>{
    var _entity$attributes, _entity$attributes2;
    if ((_entity$attributes = entity.attributes) !== null && _entity$attributes !== void 0 && _entity$attributes.workspaceMember) return intl.formatMessage((0, $6wM4F.messages).memberLozengeText);
    if ((_entity$attributes2 = entity.attributes) !== null && _entity$attributes2 !== void 0 && _entity$attributes2.isConfluenceExternalCollaborator) {
        const lozengeTooltipMessage = entity.entityType === (0, $9CDxC.EntityType).GROUP ? (0, $6wM4F.messages).guestGroupLozengeTooltip : (0, $6wM4F.messages).guestUserLozengeTooltip;
        return {
            text: intl.formatMessage((0, $6wM4F.messages).guestLozengeText),
            tooltip: intl.formatMessage(lozengeTooltipMessage),
            appearance: 'default'
        };
    }
    return undefined;
};
const $f721bcf2dfb1123d$var$transformUser = (item, intl)=>{
    const type = item.entityType;
    if (type === (0, $9CDxC.EntityType).USER) {
        const user = item;
        const lozenge = $f721bcf2dfb1123d$var$getLozenzeProperties(user, intl);
        return {
            id: user.id,
            type: user.nonLicensedUser ? (0, $2147a04a3259adea$export$50042ec1d2e00e63) : (0, $2147a04a3259adea$export$8436e53e45ffe15b),
            avatarUrl: user.avatarUrl,
            name: user.name,
            email: user.email,
            title: user.title,
            lozenge: lozenge,
            tooltip: user.name,
            isExternal: Boolean(user.nonLicensedUser),
            sources: user.nonLicensedUser ? [
                'other-atlassian'
            ] : undefined
        };
    }
    if (type === (0, $9CDxC.EntityType).TEAM) {
        const team = item;
        return {
            id: team.id,
            type: (0, $2147a04a3259adea$export$26bc40b960693765),
            description: team.description || '',
            name: team.displayName || '',
            memberCount: team.memberCount,
            members: team.members,
            includesYou: team.includesYou,
            avatarUrl: team.largeAvatarImageUrl || team.smallAvatarImageUrl,
            tooltip: team.displayName
        };
    }
    if (type === (0, $9CDxC.EntityType).GROUP) {
        const group = item;
        const lozenge = $f721bcf2dfb1123d$var$getLozenzeProperties(group, intl);
        return {
            id: group.id,
            type: (0, $2147a04a3259adea$export$d460f747b73abb10),
            name: group.name || '',
            lozenge: lozenge
        };
    }
    return;
};
const $f721bcf2dfb1123d$export$fb8c90bfc4beaa59 = (serverResponse, intl)=>(serverResponse.recommendedUsers || []).map((item)=>$f721bcf2dfb1123d$var$transformUser(item, intl)).filter((user)=>!!user).map((user)=>user);

});
parcelRegister("6wM4F", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4c0b05cd21c88248$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $4c0b05cd21c88248$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    }
});

});

parcelRegister("9CDxC", function(module, exports) {

$parcel$export(module.exports, "EntityType", () => $701655bc656c0901$export$8eda7e02f8f033b2);
let $701655bc656c0901$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({}); // Override UserPickerProps below with replacement documentation

});


parcelRegister("7OojT", function(module, exports) {

$parcel$export(module.exports, "config", () => $5b0011534d786bea$export$e506a1d27d1eaa20);
const $5b0011534d786bea$export$e506a1d27d1eaa20 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey, baseUrl = '') {
        return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};

});


parcelRegister("2VvJ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2219840672662387$export$2e2bcd8739ae039);


var $7OojT = parcelRequire("7OojT");

var $jr2e9 = parcelRequire("jr2e9");

var $brKQH = parcelRequire("brKQH");

var $7dKWk = parcelRequire("7dKWk");
const $2219840672662387$var$getHydratedUsersFromProducts = (request)=>{
    const url = `${(0, $7OojT.config).getUsersServiceUrl(request.productKey, request.baseUrl)}`;
    let params = new URLSearchParams();
    request.accountIds.map((id)=>params.append('accountId', id));
    params.append('maxResults', '2000');
    return fetch(`${url}?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling users service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then(request.productKey === 'jira' ? $2219840672662387$var$transformJiraUsers : $2219840672662387$var$transformConfluenceUsers);
};
const $2219840672662387$var$transformJiraUsers = (userResponse)=>userResponse.values.map($2219840672662387$var$transformJiraUser).filter((user)=>!!user).map((user)=>user);
const $2219840672662387$var$transformJiraUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $2147a04a3259adea$export$8436e53e45ffe15b),
        avatarUrl: item.avatarUrls ? item.avatarUrls['16x16'] : '',
        name: item.displayName,
        email: item.emailAddress
    };
};
const $2219840672662387$var$transformConfluenceUsers = (userResponse)=>userResponse.results.map($2219840672662387$var$transformConfluenceUser).filter((user)=>!!user).map((user)=>user);
const $2219840672662387$var$transformConfluenceUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $2147a04a3259adea$export$8436e53e45ffe15b),
        avatarUrl: item.profilePicture ? item.profilePicture.path : '',
        name: item.publicName,
        email: item.email
    };
};
const $2219840672662387$var$sortResults = (options, sortIds)=>{
    const resultsMap = new Map(options.map((option)=>[
            option && option.id,
            option
        ]));
    return sortIds.map((option)=>{
        const user = resultsMap.get(option.id);
        if (user) return user;
        return {
            id: option.id,
            type: option.type,
            name: (0, $7dKWk.UNKNOWN)
        };
    });
};
const $2219840672662387$var$isOptionData = (option)=>{
    return option.name !== undefined;
};
const $2219840672662387$var$hydrateTeamIds = async (baseUrl, values)=>{
    if (values.length === 0) return [];
    const legionPromises = values.map((value)=>(0, $brKQH.default)({
            baseUrl: baseUrl,
            id: value.id
        }));
    return await Promise.all(legionPromises);
};
const $2219840672662387$var$hydrateAccountIds = async (baseUrl, productKey, values)=>{
    if (values.length === 0) return [];
    const accountIds = values.map((val)=>val.id);
    //if we are not jira or confluence then use PRS platform hydration
    return productKey === 'jira' || productKey === 'confluence' ? await $2219840672662387$var$getHydratedUsersFromProducts({
        baseUrl: baseUrl,
        productKey: productKey,
        accountIds: accountIds
    }) : await (0, $jr2e9.default)(baseUrl, accountIds);
};
async function $2219840672662387$var$hydrateDefaultValues(baseUrl, value, productKey) {
    //return if no value
    if (!value || Array.isArray(value) && value.length === 0) return [];
    const values = Array.isArray(value) ? value : [
        value
    ];
    // return if all hydrated
    if (!values.some((val)=>!$2219840672662387$var$isOptionData(val))) return value;
    const [hydratedUsers, hydratedTeams] = await Promise.all([
        $2219840672662387$var$hydrateAccountIds(baseUrl, productKey, values.filter((val)=>!$2219840672662387$var$isOptionData(val) && val.type === 'user')),
        $2219840672662387$var$hydrateTeamIds(baseUrl, values.filter((val)=>!$2219840672662387$var$isOptionData(val) && val.type === 'team'))
    ]);
    const hydratedOptions = values.filter((val)=>$2219840672662387$var$isOptionData(val)).map((val)=>val).concat(hydratedUsers).concat(hydratedTeams);
    return $2219840672662387$var$sortResults(hydratedOptions, values);
}
var $2219840672662387$export$2e2bcd8739ae039 = $2219840672662387$var$hydrateDefaultValues;

});
parcelRegister("jr2e9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2624435520c46d9$export$2e2bcd8739ae039);

var $7dKWk = parcelRequire("7dKWk");

var $yD9xY = parcelRequire("yD9xY");

var $7OojT = parcelRequire("7OojT");
/**
 * @param  {string} accountIds ids to hydrate
 * @return GraphQL Query
 */ const $e2624435520c46d9$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
      picture
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $e2624435520c46d9$var$makeRequest = async (url, accountIds)=>{
    const query = $e2624435520c46d9$var$buildUsersQuery(accountIds);
    return await (0, $yD9xY.graphqlQuery)(url, query);
};
const $e2624435520c46d9$var$modifyResponse = (users)=>users.map(({ accountId: accountId, name: name, picture: picture })=>({
            avatarUrl: picture,
            id: accountId,
            name: name,
            type: 'user'
        }));
const $e2624435520c46d9$var$getHydratedUsers = (baseUrl, userIds)=>{
    const url = (0, $7OojT.config).getGraphQLUrl(baseUrl);
    return new Promise((resolve)=>{
        $e2624435520c46d9$var$makeRequest(url, userIds).then((data)=>{
            resolve($e2624435520c46d9$var$modifyResponse(data.users));
        }).catch(()=>{
            // on network error, return original list with label 'Unknown'
            resolve(userIds.map((id)=>({
                    ...(0, $7dKWk.UNKNOWN_USER),
                    id: id
                })));
        });
    });
};
var $e2624435520c46d9$export$2e2bcd8739ae039 = $e2624435520c46d9$var$getHydratedUsers;

});
parcelRegister("7dKWk", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN", () => $541e288fc0a7b7e3$export$78244dbb77cfa6b6);
$parcel$export(module.exports, "UNKNOWN_USER", () => $541e288fc0a7b7e3$export$d1f5101c0939e3fe);
$parcel$export(module.exports, "UNKNOWN_TEAM", () => $541e288fc0a7b7e3$export$8144dcfc9025ca57);
const $541e288fc0a7b7e3$export$78244dbb77cfa6b6 = 'Unknown';
const $541e288fc0a7b7e3$export$d1f5101c0939e3fe = {
    id: $541e288fc0a7b7e3$export$78244dbb77cfa6b6,
    name: $541e288fc0a7b7e3$export$78244dbb77cfa6b6,
    type: 'user'
};
const $541e288fc0a7b7e3$export$8144dcfc9025ca57 = {
    id: $541e288fc0a7b7e3$export$78244dbb77cfa6b6,
    name: $541e288fc0a7b7e3$export$78244dbb77cfa6b6,
    type: 'team'
};

});

parcelRegister("yD9xY", function(module, exports) {

$parcel$export(module.exports, "graphqlQuery", () => $06818c0ec101f6a5$export$74eb8d79ae3e02b5);
const $06818c0ec101f6a5$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
function $06818c0ec101f6a5$export$74eb8d79ae3e02b5(serviceUrl, query) {
    const headers = $06818c0ec101f6a5$var$buildHeaders();
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) {
            var _json$errors$;
            return Promise.reject({
                reason: ((_json$errors$ = json.errors[0]) === null || _json$errors$ === void 0 ? void 0 : _json$errors$.category) || 'default'
            });
        }
        return json.data;
    });
}

});


parcelRegister("brKQH", function(module, exports) {

$parcel$export(module.exports, "default", () => $85568e928bebc3e5$export$2e2bcd8739ae039);

var $7OojT = parcelRequire("7OojT");

var $7dKWk = parcelRequire("7dKWk");
const $85568e928bebc3e5$var$transformTeam = (team, id)=>{
    return {
        id: id,
        name: team.displayName,
        type: 'team',
        avatarUrl: team.smallAvatarImageUrl
    };
};
const $85568e928bebc3e5$var$hydrateTeamFromLegion = (request)=>{
    const url = `${(0, $7OojT.config).getTeamsUrl(request.baseUrl)}/${request.id}`;
    return fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling Legion, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>{
        return $85568e928bebc3e5$var$transformTeam(response, request.id);
    }).catch(()=>({
            ...(0, $7dKWk.UNKNOWN_TEAM),
            // on network error, return original team with label 'Unknown'
            id: request.id
        }));
};
var $85568e928bebc3e5$export$2e2bcd8739ae039 = $85568e928bebc3e5$var$hydrateTeamFromLegion;

});


parcelRegister("f4awa", function(module, exports) {

$parcel$export(module.exports, "smartUserPickerRenderedUfoExperience", () => $af7f635f795f594b$export$df77da4c0210f1c1);
$parcel$export(module.exports, "smartUserPickerOptionsShownUfoExperience", () => $af7f635f795f594b$export$a0e7cca3ab9586eb);
$parcel$export(module.exports, "useUFOConcurrentExperience", () => $af7f635f795f594b$export$e5e0512991825310);
$parcel$export(module.exports, "UfoErrorBoundary", () => $af7f635f795f594b$export$5ef1c2550074a375);

var $eUqFw = parcelRequire("eUqFw");

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
var $uMitL = parcelRequire("uMitL");
const $af7f635f795f594b$var$COMPONENT_NAME = 'smart-user-picker';
const $af7f635f795f594b$export$df77da4c0210f1c1 = new (0, $2kFUE.ConcurrentExperience)('smart-user-picker-rendered', {
    platform: {
        component: $af7f635f795f594b$var$COMPONENT_NAME
    },
    type: (0, $3yYXq.ExperienceTypes).Load,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad
});
const $af7f635f795f594b$export$a0e7cca3ab9586eb = new (0, $2kFUE.ConcurrentExperience)('smart-user-picker-options-shown', {
    platform: {
        component: $af7f635f795f594b$var$COMPONENT_NAME
    },
    type: (0, $3yYXq.ExperienceTypes).Operation,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
});
const $af7f635f795f594b$export$e5e0512991825310 = (experience, id)=>{
    const experienceForId = experience.getInstance(id);
    // Equivalent to componentWillMount - replace with @atlaskit/ufo's
    // useUFOComponentExperience when it supports ConcurrentExperience.
    (0, $eUqFw.useState)(()=>{
        experienceForId.start();
    });
    // Replace with @atlaskit/ufo's <ExperienceSuccess> when it supports ConcurrentExperience
    (0, $eUqFw.useEffect)(()=>{
        if (experienceForId.state !== (0, $uMitL.UFOExperienceState)['FAILED']) experienceForId.success();
        return ()=>{
            if ([
                (0, $uMitL.UFOExperienceState)['STARTED'],
                (0, $uMitL.UFOExperienceState)['IN_PROGRESS']
            ].includes(experienceForId.state)) experienceForId.abort();
        };
    // We only want this useEffect to run once after component mount, so no deps are needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
class $af7f635f795f594b$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch() {
        $af7f635f795f594b$export$df77da4c0210f1c1.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}

});



const $153fcafb1d4658a6$export$53782b65600ab96d = '__UNASSIGNED_TEAM__';
const $153fcafb1d4658a6$export$3f4352abc4ee4b48 = '__CREATE_TEAM__';

parcelRegister("j7YJ9", function(module, exports) {
module.exports = new URL("no-team-avatar.fa4b7eb2.svg", import.meta.url).toString();

});

parcelRegister("hg5fi", function(module, exports) {

$parcel$export(module.exports, "CreateTeamOption", () => $3e6659f308c3f040$export$8920795307e75f7e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cnPHV = parcelRequire("cnPHV");

var $gpQTF = parcelRequire("gpQTF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $iC4qb = parcelRequire("iC4qb");

var $euphn = parcelRequire("euphn");

var $ijjw7 = parcelRequire("ijjw7");
function $3e6659f308c3f040$export$8920795307e75f7e({ onClick: onClick, isFocused: isFocused }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const formattedCreateTeamText = formatMessage((0, $iC4qb.default).createTeamButtonText);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleCreateTeamOptionClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createTeamInline', {
            teamsFieldEmptyState: false
        });
        onClick();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const { canCreateTeams: canCreateTeams } = (0, $euphn.useTeamPermissions)();
    return canCreateTeams ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cnPHV.default), {
        inline: "space.200",
        block: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e6659f308c3f040$var$CreateButtonBorder, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e6659f308c3f040$var$Container, {
        onClick: handleCreateTeamOptionClick,
        isFocused: isFocused,
        "data-testid": "issue-field-team.ui.edit-mode.create-team-option.create-team-inline-option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e6659f308c3f040$var$OptionDataWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gpQTF.default), {
        isSelected: false,
        data: {
            id: (0, $153fcafb1d4658a6$export$3f4352abc4ee4b48),
            name: formattedCreateTeamText,
            type: 'custom',
            avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ijjw7)))
        }
    }))))) : null;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e6659f308c3f040$var$CreateButtonBorder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_x3do13y8",
            __cmplp.className
        ])
    });
});
const $3e6659f308c3f040$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkv77o _1bsb1osq _4t3i1osq _irr31dko _1dbz1l95",
            __cmplp.isFocused ? "_bfhk1dko" : "_bfhk18uv",
            __cmplp.isFocused ? "_16qs1l95" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $3e6659f308c3f040$var$OptionDataWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41ano",
            __cmplp.className
        ])
    });
});

});
parcelRegister("euphn", function(module, exports) {

$parcel$export(module.exports, "useTeamPermissions", () => $65306eb550cfd141$export$8cbbe0c59dd60253);

var $jD3pk = parcelRequire("jD3pk");

var $gd0Sp = parcelRequire("gd0Sp");

var $72tMA = parcelRequire("72tMA");
const $65306eb550cfd141$export$8cbbe0c59dd60253 = ()=>{
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { permissions: permissions } = (0, $72tMA.useTeamsPermissionsService)({
        orgId: orgId,
        cloudId: cloudId
    }, {
        enabled: false
    });
    return permissions;
};

});

parcelRegister("ijjw7", function(module, exports) {
module.exports = new URL("create-team-avatar.a06263d8.svg", import.meta.url).toString();

});


parcelRegister("iwGX8", function(module, exports) {

$parcel$export(module.exports, "TeamPickerEmptyState", () => $7e4e95ace69f4573$export$f53d61da818dafb4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");

var $8uD7Y = parcelRequire("8uD7Y");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iC4qb = parcelRequire("iC4qb");

var $euphn = parcelRequire("euphn");

var $1OcPZ = parcelRequire("1OcPZ");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e4e95ace69f4573$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz10s3 _otyr1ejb _19pkze3t",
            __cmplp.className
        ])
    });
});
const $7e4e95ace69f4573$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});
const $7e4e95ace69f4573$export$f53d61da818dafb4 = ({ onActionClick: onActionClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { canCreateTeams: canCreateTeams } = (0, $euphn.useTeamPermissions)();
    const handleCreateTeamOptionClick = ()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createTeamInline', {
            teamsFieldEmptyState: true
        });
        onActionClick();
    };
    return canCreateTeams ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlock: "space.200",
        testId: "issue-field-team.ui.edit-mode.team-picker-empty-state.empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e4e95ace69f4573$var$Image, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1OcPZ))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e4e95ace69f4573$var$Description, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iC4qb.default).emptyStateDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: handleCreateTeamOptionClick,
        testId: "issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button",
        interactionName: "auto-generated.issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iC4qb.default).createTeamButtonText))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iC4qb.default).noOptionsMessage);
};

});
parcelRegister("1OcPZ", function(module, exports) {
module.exports = new URL("team-picker-empty-state.7b7878d7.svg", import.meta.url).toString();

});



parcelRegister("eHKLj", function(module, exports) {

$parcel$export(module.exports, "useCreateTeamDialog", () => $d4e307a1265eaa92$export$e8b8170429d616be);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ao10V = parcelRequire("ao10V");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $Gz4Lz = parcelRequire("Gz4Lz");

var $82rJa = parcelRequire("82rJa");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $cWiVr = parcelRequire("cWiVr");

var $jD3pk = parcelRequire("jD3pk");

var $gd0Sp = parcelRequire("gd0Sp");

var $idyMy = parcelRequire("idyMy");

const $d4e307a1265eaa92$export$75096afde50756fd = (0, $7rh0R.lazy)(()=>(parcelRequire("dNLwe")).then((module)=>module.TeamCreateDialog), {
    moduleId: "./node_modules/@atlassian/people-teams/dist/cjs/index.js"
});
const $d4e307a1265eaa92$export$e8b8170429d616be = (props = {})=>{
    const { locale: locale } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [inputTeamName, setInputTeamName] = (0, $eUqFw.useState)('');
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const enableMembershipSettingsChoice = (0, $1ybV0.ff)('ptc.membership-controls');
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = tenantContext;
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    if (!atlassianAccountId && !user.accountId) throw new Error('Missing current user id');
    const addFlag = (0, $eUqFw.useCallback)(({ appearance: appearance, ...flagProps })=>{
        if (appearance === 'success' || appearance === 'normal') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Gz4Lz.default), {
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'warning') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82rJa.default), {
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'error') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y2Y8.default), {
                ...flagProps,
                ...serviceProps
            }));
    }, [
        showFlag
    ]);
    const { onCancel: onCancel } = {
        onCancel: ()=>null,
        ...props
    };
    const callback = (0, $eUqFw.useCallback)((teamName)=>{
        setInputTeamName(teamName);
        setIsOpen(true);
    }, []);
    const handleOnClose = ()=>{
        setIsOpen(false);
        onCancel();
    };
    const handleOnCreate = (team)=>{
        const formattedTeam = {
            ...team,
            name: team.displayName
        };
        props.onCreate?.(formattedTeam);
    };
    return [
        isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "team-create-dialog"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idyMy.PeopleAndTeamsConfigurationProvider), {
            product: "jira",
            locale: (0, $ao10V.default)(locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4e307a1265eaa92$export$75096afde50756fd, {
            cloudId: cloudId,
            orgId: orgId,
            product: "jira",
            principalId: atlassianAccountId || user.accountId || '',
            onClose: handleOnClose,
            onCreateTeamSuccess: handleOnCreate,
            extraAnalyticsAttrs: props.analyticsCtx,
            enableMembershipSettingsChoice: enableMembershipSettingsChoice,
            currentUser: user.accountId ? {
                id: user.accountId,
                fullName: user.userFullname,
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
                ...user
            } : undefined,
            prepopulatedFields: {
                teamName: inputTeamName
            },
            addFlag: addFlag
        }))) : null,
        callback
    ];
};

});
parcelRegister("3Y2Y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $23cb4ade2efc0679$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $23cb4ade2efc0679$export$2e2bcd8739ae039 = (0, $kQ0RL.ErrorFlag);

});

parcelRegister("Gz4Lz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1273ecbdbcfe24cd$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $1273ecbdbcfe24cd$export$2e2bcd8739ae039 = (0, $kQ0RL.SuccessFlag);

});

parcelRegister("82rJa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c8bd85b08cb5610$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $9c8bd85b08cb5610$export$2e2bcd8739ae039 = (0, $kQ0RL.WarningFlag);

});

parcelRegister("dNLwe", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('41Rip')
        ]);
        const value = parcelRequire('3PkL8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("41Rip")
    ]).then(()=>parcelRequire('3PkL8'));
}

});


parcelRegister("5R1rN", function(module, exports) {

$parcel$export(module.exports, "TeamPickerView", () => $02e77c5f09326d91$export$d284ae84f659e68c);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $ldoFd = parcelRequire("ldoFd");

var $51sCz = parcelRequire("51sCz");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4xwq2 = parcelRequire("4xwq2");

var $fFRi9 = parcelRequire("fFRi9");

var $iC4qb = parcelRequire("iC4qb");
const $02e77c5f09326d91$var$ErrorView = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $iC4qb.default).teamErrorViewTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$Text, {
        isDisabled: true,
        "data-testid": "issue-field-team.ui.view-error-value-text"
    }, formatMessage((0, $iC4qb.default).teamErrorViewText))));
};
const $02e77c5f09326d91$export$d284ae84f659e68c = (props)=>{
    const { defaultValue: defaultValue, isEditable: isEditable, placeholder: placeholder, noPaddingLeft: noPaddingLeft } = props;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(defaultValue)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$ReadViewContainerEmpty, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), {
        "data-testid": "issue-field-team.ui.view-empty-value-text"
    }, placeholder));
    if (defaultValue.isVisible === false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$ErrorView, null);
    const team = defaultValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$Wrapper, {
        isEditable: isEditable,
        noPaddingLeft: noPaddingLeft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fFRi9.default), {
        teamId: team.id,
        trigger: "hover-click",
        position: "left-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$Text, {
        "data-testid": "issue-field-team.ui.view-team-name"
    }, team.name))));
};
var $02e77c5f09326d91$export$2e2bcd8739ae039 = $02e77c5f09326d91$export$d284ae84f659e68c;
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02e77c5f09326d91$var$ReadViewContainerEmpty = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-18930yh-0"
})({
    display: 'flex',
    fontSize: `${(0, $lcnyw.fontSize)()}px`,
    maxWidth: '100%',
    padding: "var(--ds-space-075, 6px)",
    minHeight: `${(0, $lcnyw.gridSize)() * 2}px`,
    alignItems: 'center'
});
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02e77c5f09326d91$var$Text = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-18930yh-1"
})((props)=>({
        lineHeight: (0, $lcnyw.gridSize)() * 2.5 / (0, $lcnyw.fontSize)(),
        textAlign: 'left',
        color: props.isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N300})` : `var(--ds-text, ${0, $PdmhA.N900})`,
        alignItems: 'center',
        display: 'flex',
        padding: `${"var(--ds-space-025, 2px)"} 0`
    }));
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02e77c5f09326d91$var$Wrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-18930yh-2"
})((props)=>({
        cursor: props.isEditable ? 'pointer' : 'default',
        paddingLeft: props.noPaddingLeft ? undefined : "var(--ds-space-075, 6px)",
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        '> a': {
            display: 'flex',
            alignItems: 'center'
        }
    }));

});
parcelRegister("fFRi9", function(module, exports) {

$parcel$export(module.exports, "default", () => $13d635822c142a4d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $13d635822c142a4d$var$AsyncTeamProfileCardNext = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("esepU")), {
    ssr: false,
    moduleId: "./src/packages/profilecard-next/src/ui/team-profilecard/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$13d635822c142a4d$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.profilecard-next.team-profilecard",
        packageName: "async.profilecard-next.team-profilecard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-team-profilecard-next",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($13d635822c142a4d$var$AsyncTeamProfileCardNext, props)));

});
parcelRegister("esepU", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('cyrhR')
        ]);
        const value = parcelRequire('aBa6h');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("cyrhR")
    ]).then(()=>parcelRequire('aBa6h'));
}

});






parcelRegister("iaPbS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b4a0a9840965aa5$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $lRmyA = parcelRequire("lRmyA");

var $jJZmc = parcelRequire("jJZmc");

var $huhk2 = parcelRequire("huhk2");

var $brySu = parcelRequire("brySu");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $lV5H0 = parcelRequire("lV5H0");

var $5JqpU = parcelRequire("5JqpU");

var $dv9do = parcelRequire("dv9do");

var $40QX1 = parcelRequire("40QX1");

var $6tCYA = parcelRequire("6tCYA");
const $0b4a0a9840965aa5$var$fetchSuggestionsFactory = (0, $5iWql.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(baseUrl)=>(query)=>(0, $lRmyA.performPostRequest)(`${baseUrl}/rest/teams/1.0/teams/find`, {
            body: JSON.stringify({
                query: query,
                excludedIds: [],
                maxResults: 100
            })
        }).then((suggestion)=>(0, $6tCYA.transformSuggestions)(suggestion, baseUrl)));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0b4a0a9840965aa5$var$saveField = ({ baseUrl: baseUrl, issueKey: issueKey, fieldMetaKey: fieldMetaKey, value: value })=>{
    const teamId = value && value.id ? value.id.toString() : null;
    return (0, $lRmyA.performPutRequest)((0, $lV5H0.getIssueApiUrl)(baseUrl, issueKey), {
        body: JSON.stringify({
            fields: {
                [fieldMetaKey]: teamId
            }
        })
    });
};
var $0b4a0a9840965aa5$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $6tCYA.transformFromStateValue,
        transformToStateValue: $6tCYA.transformToStateValue,
        additionalProps: (state, intl)=>({
                fetchSuggestions: $0b4a0a9840965aa5$var$fetchSuggestionsFactory((0, $5JqpU.baseUrlSelector)(state)),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                portalElement: (0, $40QX1.isFieldInTabSelector)(ownPropsOnMount.fieldId)(state) // Using portalElement because otherwise dropdowns would get cut off by the container borders. See BENTO-4101
                 ? (0, $brySu.getIssueModalAkDropdownPortal)() || document.body : undefined,
                isSubTask: (0, $dv9do.isSubtaskSelector)(state),
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            }),
        saveField: $0b4a0a9840965aa5$var$saveField
    }))((0, $jJZmc.default));

});
parcelRegister("jJZmc", function(module, exports) {

$parcel$export(module.exports, "default", () => $47ec842c8bb0d981$export$2e2bcd8739ae039);

var $HXH0h = parcelRequire("HXH0h");
var $47ec842c8bb0d981$export$2e2bcd8739ae039 = (0, $HXH0h.default);

});
parcelRegister("HXH0h", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e6c4f0bc399890d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $f8Yej = parcelRequire("f8Yej");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9LvPd = parcelRequire("9LvPd");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $6oQPP = parcelRequire("6oQPP");
var $5St1r = parcelRequire("5St1r");

var $4bZws = parcelRequire("4bZws");

var $bvMN1 = parcelRequire("bvMN1");

var $f3YBD = parcelRequire("f3YBD");

var $XPkom = parcelRequire("XPkom");
// eslint-disable-next-line jira/compiled/styled-components-usages
const $7e6c4f0bc399890d$var$nonEditableInlineEditContainerStyles = /*#__PURE__*/ (0, $kwce8.css)({
    marginLeft: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    [`${''} & > div`]: {
        margin: `${"var(--ds-space-150, 12px)"} 0 ${"var(--ds-space-075, 6px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`${0, $5St1r.ReadViewContainer}`]: {
        left: 0
    }
});
const $7e6c4f0bc399890d$export$eb5d526f212c79c3 = (props)=>{
    const { isEditable: isEditable, isSubTask: isSubTask, fetchSuggestions: fetchSuggestions, onChange: onChange, onConfirm: onConfirm, value: value, portalElement: portalElement, menuPlacement: menuPlacement } = props;
    // Using an extra span to explicitly mark this as not included by our selector.
    // We are using the custom wrapper + selector as a workaround until we can move
    // to using inline edits in compact mode.
    // See: https://jdog.jira-dev.com/browse/BENTO-2979
    return isEditable && !isSubTask ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bvMN1.default), {
        value: value,
        loadOptions: fetchSuggestions,
        portalElement: portalElement,
        menuPlacement: menuPlacement,
        onChange: onChange,
        onConfirm: onConfirm
    })) : null;
};
const $7e6c4f0bc399890d$export$6f6cb44144d37e0d = (props)=>{
    const { isSubTask: isSubTask, fetchSuggestions: fetchSuggestions, portalElement: portalElement, menuPlacement: menuPlacement, onChange: onChange, value: value, noValueText: noValueText, isEditing: isEditing, onConfirm: onConfirm, onCancel: onCancel, onEditRequest: onEditRequest, isMobile: isMobile, fieldId: fieldId, showPinButton: showPinButton, isEditable: isEditable, issueKey: issueKey } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const label = formatMessage((0, $f3YBD.default).label);
    const renderReadField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5St1r.ReadViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $XPkom.default), {
        noValueText: noValueText,
        value: value
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, label), issueKey !== undefined && fieldId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LvPd.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldId,
        label: label
    }), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: fieldId,
        label: label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), {
        isEditing: isEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
        onEscape: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e6c4f0bc399890d$export$4eada4f37929cb99, {
        hasValue: !!value,
        isEditable: isEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        isLabelHidden: true,
        label: label,
        readView: renderReadField,
        editView: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e6c4f0bc399890d$export$eb5d526f212c79c3, {
            isSubTask: isSubTask,
            fetchSuggestions: fetchSuggestions,
            portalElement: portalElement,
            menuPlacement: menuPlacement,
            onChange: onChange,
            onConfirm: onConfirm,
            isEditable: isEditable,
            value: value
        }),
        // @ts-expect-error - TS2322 - Property 'disableEditViewFieldBase' does not exist on type 'IntrinsicAttributes & FieldInlineEditStateLessProps<unknown>'.
        disableEditViewFieldBase: true,
        areActionButtonsHidden: true,
        isEditing: isEditing,
        onConfirm: onConfirm,
        onCancel: onCancel,
        onEditRequested: onEditRequest,
        isFitContainerWidthReadView: !isMobile,
        onEscape: onCancel,
        isEditable: isEditable
    })))));
};
var $7e6c4f0bc399890d$export$2e2bcd8739ae039 = $7e6c4f0bc399890d$export$6f6cb44144d37e0d;
const $7e6c4f0bc399890d$export$4eada4f37929cb99 = /*#__PURE__*/ (0, $kwce8.default)((0, $5St1r.InlineEditContainer)).withConfig({
    componentId: "bvd5cn-0"
})`${(0, $5St1r.ReadViewContainer)}{line-height:20px;}${({ isEditable: isEditable })=>!isEditable && $7e6c4f0bc399890d$var$nonEditableInlineEditContainerStyles}`;

});
parcelRegister("bvMN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $640a91b9c564fb62$export$2e2bcd8739ae039);

var $3oO1P = parcelRequire("3oO1P");
var $640a91b9c564fb62$export$2e2bcd8739ae039 = (0, $3oO1P.default);

});
parcelRegister("3oO1P", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9bc89d076e02d56$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dxIU5 = parcelRequire("dxIU5");

var $lXktr = parcelRequire("lXktr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");

var $8APk9 = parcelRequire("8APk9");

var $gIBpJ = parcelRequire("gIBpJ");

var $1SlWt = parcelRequire("1SlWt");

var $d87Cj = parcelRequire("d87Cj");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d9bc89d076e02d56$var$MenuList = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8APk9.default), props);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d9bc89d076e02d56$var$SingleValue = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d87Cj.default), props);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d9bc89d076e02d56$var$Option = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1SlWt.default), props);
const $d9bc89d076e02d56$var$GroupHeading = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9bc89d076e02d56$var$OptionHeader, null, formatMessage((0, $gIBpJ.default).sharedTeam));
};
const $d9bc89d076e02d56$export$ab0b3fa382932861 = ({ value: value, portalElement: portalElement, menuPlacement: menuPlacement, loadOptions: loadOptions, onChange: onChange, onConfirm: onConfirm })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onChangeNew = (0, $eUqFw.useCallback)((val)=>{
        onChange(val);
        onConfirm(val);
    }, [
        onChange,
        onConfirm
    ]);
    const debouncedLoadOptions = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((searchText, callback)=>{
            loadOptions(searchText).then(callback, ()=>{
                callback([]);
            });
        }, 300), [
        loadOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXktr.default), {
        value: value,
        autoFocus: true,
        defaultOptions: true,
        menuPortalTarget: portalElement,
        menuPlacement: menuPlacement,
        components: {
            MenuList: $d9bc89d076e02d56$var$MenuList,
            Option: $d9bc89d076e02d56$var$Option,
            SingleValue: $d9bc89d076e02d56$var$SingleValue,
            GroupHeading: $d9bc89d076e02d56$var$GroupHeading
        },
        onChange: onChangeNew,
        loadOptions: debouncedLoadOptions,
        defaultMenuIsOpen: true,
        isClearable: value !== null,
        noOptionsMessage: ()=>formatMessage((0, $gIBpJ.default).noMatches),
        placeholder: formatMessage((0, $gIBpJ.default).placeholder),
        styles: (0, $4NcaX.defaultSelectStyles),
        cacheOptions: true
    });
};
var $d9bc89d076e02d56$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d9bc89d076e02d56$export$ab0b3fa382932861;
const $d9bc89d076e02d56$var$OptionHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt465p0 _syaz1a2j _k48p8n31 _1wyb1crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8APk9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6360af4aa5149b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gIBpJ = parcelRequire("gIBpJ");

var $2w8XX = parcelRequire("2w8XX");
const $f6360af4aa5149b5$var$MenuListComponent = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { options: options } = props;
    const footer = options.length > 0 && options[0].moreResultsAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2w8XX.MenuFooterText), null, formatMessage((0, $gIBpJ.default).menuFooter)) : null;
    return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; options: GroupOption[]; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 7 more.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MenuList, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2w8XX.Container), null, formatMessage((0, $gIBpJ.default).menuHeader)), props.children, footer));
};
var $f6360af4aa5149b5$export$2e2bcd8739ae039 = $f6360af4aa5149b5$var$MenuListComponent;

});
parcelRegister("gIBpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5151db08281a922$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $c5151db08281a922$var$messages = (0, $90IgZ.defineMessages)({
    menuHeader: {
        "id": "issue.views.field.team.edit.menuHeader",
        "defaultMessage": "Plan-specific teams can only be selected through a plan."
    },
    noMatches: {
        "id": "issue.views.field.team.edit.noMatches",
        "defaultMessage": "No Matches"
    },
    placeholder: {
        "id": "issue.views.field.team.edit.placeholder",
        "defaultMessage": "Choose a team to assign this issue to."
    },
    sharedTeam: {
        "id": "issue.context-items.team.shared-team",
        "defaultMessage": "Shared Team"
    },
    menuFooter: {
        "id": "issue.context-items.team.edit.menuFooter",
        "defaultMessage": "Showing 100 results. To display more results, please refine your search."
    }
});
var $c5151db08281a922$export$2e2bcd8739ae039 = $c5151db08281a922$var$messages;

});

parcelRegister("2w8XX", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $798c88a339ca7afb$export$f04a61298a47a40f);
$parcel$export(module.exports, "OptionWrapper", () => $798c88a339ca7afb$export$d6f6a072cce04542);
$parcel$export(module.exports, "OptionText", () => $798c88a339ca7afb$export$b774ce8d8a47645);
$parcel$export(module.exports, "Container", () => $798c88a339ca7afb$export$42a852a2b6b56249);
$parcel$export(module.exports, "MenuFooterText", () => $798c88a339ca7afb$export$67799009a469a52);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $798c88a339ca7afb$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $798c88a339ca7afb$export$d6f6a072cce04542 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1reo15vq _18m915vq _4cvr1h6o _1bahv2br _1yt4otz2",
            __cmplp.className
        ])
    });
});
const $798c88a339ca7afb$export$b774ce8d8a47645 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $798c88a339ca7afb$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41mul",
            __cmplp.className
        ])
    });
});
const $798c88a339ca7afb$export$67799009a469a52 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1ifp _1wyb1crf _1yt41pyq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1SlWt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3278ca3ef2deb982$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $hguKV = parcelRequire("hguKV");

var $2w8XX = parcelRequire("2w8XX");
const $3278ca3ef2deb982$var$OptionComponent = (props)=>{
    const value = props.data;
    if (value) {
        const { avatarUrl: avatarUrl } = value;
        return(// @ts-expect-error - TS2740 - Type '{ children: Element; data: TeamFieldType; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 8 more.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2w8XX.OptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2w8XX.Icon), {
            src: avatarUrl || (0, (/*@__PURE__*/$parcel$interopDefault($hguKV)))
        }), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2w8XX.OptionText), null, props.children))));
    }
    return null;
};
var $3278ca3ef2deb982$export$2e2bcd8739ae039 = $3278ca3ef2deb982$var$OptionComponent;

});
parcelRegister("hguKV", function(module, exports) {
module.exports = new URL("default-avatar.8d6e3095.svg", import.meta.url).toString();

});


parcelRegister("d87Cj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5834f86416578d8f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $4ksts = parcelRequire("4ksts");

var $4xwq2 = parcelRequire("4xwq2");

var $gIBpJ = parcelRequire("gIBpJ");
const $5834f86416578d8f$var$SingleValueComponent = (props)=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const { data: data } = props;
    const label = data ? data.label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), null, formatMessage((0, $gIBpJ.default).placeholder));
    // @ts-expect-error - TS2740 - Type '{ children: string | Element; data: TeamFieldType; intl: IntlShapeV2; }' is missing the following properties from type 'CommonProps<OptionTypeBase, false, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 8 more.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).SingleValue, props, label);
};
var $5834f86416578d8f$export$2e2bcd8739ae039 = $5834f86416578d8f$var$SingleValueComponent;

});



parcelRegister("f3YBD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3a7becde0c7e2af$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $a3a7becde0c7e2af$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "issue.views.field.team.label",
        "defaultMessage": "Team"
    }
});

});

parcelRegister("XPkom", function(module, exports) {

$parcel$export(module.exports, "default", () => $58d487da05c38ae6$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dFWNP = parcelRequire("dFWNP");

var $4xwq2 = parcelRequire("4xwq2");

var $hguKV = parcelRequire("hguKV");
const $58d487da05c38ae6$var$TeamViewField = (props)=>{
    const { value: value, noValueText: noValueText } = props;
    if (value) {
        const { label: label, isShared: isShared, avatarUrl: avatarUrl } = value;
        const shareIcon = isShared ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($58d487da05c38ae6$var$SharedIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
            label: "",
            size: "small"
        })) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($58d487da05c38ae6$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($58d487da05c38ae6$var$Avatar, {
            src: avatarUrl || (0, (/*@__PURE__*/$parcel$interopDefault($hguKV)))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($58d487da05c38ae6$var$Title, null, label), shareIcon);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), null, noValueText);
};
var $58d487da05c38ae6$export$2e2bcd8739ae039 = $58d487da05c38ae6$var$TeamViewField;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58d487da05c38ae6$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1reo15vq _18m915vq _o5721q9c _4cvr1h6o _1bahv2br",
            __cmplp.className
        ])
    });
});
const $58d487da05c38ae6$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _2hwxu2gc _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $58d487da05c38ae6$var$Avatar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_s7n4nkob _1bsb1tcg _4t3i1tcg _2hwxu2gc _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $58d487da05c38ae6$var$SharedIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _syaz1gtz",
            __cmplp.className
        ])
    });
});

});



parcelRegister("6tCYA", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $179ad73d6b28d2be$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $179ad73d6b28d2be$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformSuggestions", () => $179ad73d6b28d2be$export$1d0ee4320c26fb60);
const $179ad73d6b28d2be$var$toItem = (data, baseUrl)=>({
        value: data.id,
        label: data.title,
        isShared: data.isShared,
        avatarUrl: data.avatarUrl ? `${baseUrl}${data.avatarUrl}` : ''
    });
const $179ad73d6b28d2be$var$fromItemData = (data)=>({
        id: data.value,
        title: data.label,
        isShared: data.isShared,
        avatarUrl: data.avatarUrl ? data.avatarUrl : ''
    });
const $179ad73d6b28d2be$export$cb172b2468ab5652 = (value, transformerContext)=>value ? $179ad73d6b28d2be$var$toItem(value, transformerContext.baseUrl) : null;
const $179ad73d6b28d2be$export$1cfcb95cb8fbddb3 = (value)=>value ? $179ad73d6b28d2be$var$fromItemData(value) : null;
const $179ad73d6b28d2be$export$1d0ee4320c26fb60 = (suggestions, baseUrl)=>{
    const formattedData = suggestions.teams.map((team)=>({
            value: team.id,
            label: team.title,
            isShared: team.shareable,
            avatarUrl: team.avatarUrl ? `${baseUrl}${team.avatarUrl}` : ''
        }));
    return [
        {
            options: formattedData,
            moreResultsAvailable: suggestions.moreResultsAvailable
        }
    ];
};

});


parcelRegister("lwO5u", function(module, exports) {

$parcel$export(module.exports, "default", () => $a483552cc7d919de$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hFmdR = parcelRequire("hFmdR");
var $8un0w = parcelRequire("8un0w");

var $2gGF1 = parcelRequire("2gGF1");

var $8Qd0L = parcelRequire("8Qd0L");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $aR8n6 = parcelRequire("aR8n6");

var $8uD7Y = parcelRequire("8uD7Y");
var $4ksts = parcelRequire("4ksts");


var $hHKWU = parcelRequire("hHKWU");

var $lqalZ = parcelRequire("lqalZ");

var $9Y7ra = parcelRequire("9Y7ra");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $dUqHv = parcelRequire("dUqHv");

var $hIdxh = parcelRequire("hIdxh");

var $67G0Q = parcelRequire("67G0Q");

var $3nl2U = parcelRequire("3nl2U");

var $kPtMB = parcelRequire("kPtMB");
const $a483552cc7d919de$var$WrappedViewWithAnalytics = (0, $8un0w.default)({
    onToggleRollingUpData: 'toggleRollingUpData'
})((0, $hFmdR.AnalyticsSubject)('worklog')((0, $kPtMB.default)));
const $a483552cc7d919de$var$WrappedTimeTrackingView = (props)=>{
    // go/jfe-eslint
    const { timeTrackingCalculationSelector: timeTrackingCalculationSelector, area: area, intl: intl, ...viewProps } = props;
    const [isRollingUpData, { markRollingUpData: markRollingUpData, unmarkRollingUpData: unmarkRollingUpData }] = (0, $67G0Q.useWorklogRollingUpData)();
    const onToggleRollingUpData = (0, $eUqFw.useCallback)((includeChildIssues)=>{
        includeChildIssues ? markRollingUpData() : unmarkRollingUpData();
    }, [
        markRollingUpData,
        unmarkRollingUpData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a483552cc7d919de$var$WrappedViewWithAnalytics, {
        ...viewProps,
        value: timeTrackingCalculationSelector(isRollingUpData),
        isRollingUpData: isRollingUpData,
        onToggleRollingUpData: onToggleRollingUpData
    });
};
const $a483552cc7d919de$var$extractedInvalidTimeFormatMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
    id: "issue.time-estimate.input-time-string-is-invalid",
    defaultMessage: "Your estimate must be in the format {format}.",
    values: {
        format: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, "2w 4d 6h 45m")
    }
});
const $a483552cc7d919de$var$ConnectedComponent = (0, $lqalZ.connect)((state, ownProps)=>{
    const { intl: { formatMessage: formatMessage }, area: area, fieldId: fieldId } = ownProps;
    const label = (0, $fokFV.fieldNameSelector)(ownProps.fieldId)(state);
    return {
        formatMessage: formatMessage,
        fieldId: fieldId,
        timeTrackingCalculationSelector: (0, $dUqHv.timeTrackingWithSubtasksOrChildrenRollupSelector)(state),
        config: (0, $dUqHv.timeTrackingConfigurationSelector)(state),
        issueKey: (0, $5JqpU.issueKeySelector)(state),
        issueId: (0, $5JqpU.issueIdSelector)(state),
        isDone: (0, $hIdxh.statusCategorySelector)(state) === (0, $8Qd0L.DONE),
        isEditable: (0, $dUqHv.canLogTimeSelector)(state),
        isMobile: (0, $5JqpU.isMobileSelector)(state),
        isVisible: (0, $dUqHv.isNativeJiraTimeTrackingEnabledSelector)(state),
        label: label,
        editButtonLabel: formatMessage((0, $2gGF1.default).editButtonLabel, {
            fieldName: label
        }),
        confirmButtonLabel: formatMessage((0, $2gGF1.default).confirmButtonLabel, {
            fieldName: label
        }),
        cancelButtonLabel: formatMessage((0, $2gGF1.default).cancelButtonLabel, {
            fieldName: label
        }),
        timeRemainingFieldLabel: formatMessage((0, $3nl2U.default).timeRemainingFieldLabel),
        rollupLabel: (0, $jZDJX.isClassicProjectSelector)(state) ? formatMessage((0, $3nl2U.default).includeSubtasksLabel) : formatMessage((0, $3nl2U.default).includeChildrenLabel),
        showPinButton: (0, $hHKWU.default)(area),
        shouldDisplayRollUpDataControl: (0, $dUqHv.shouldDisplayRollUpDataControlSelector)(state),
        placeholderMessage: '2w 4d 6h 45m',
        invalidTimeFormatMessage: $a483552cc7d919de$var$extractedInvalidTimeFormatMessage
    };
}, (dispatch)=>({
        onEditRequest: ()=>{
            dispatch((0, $9Y7ra.openModal)((0, $0577deea918816be$export$b4c759f3741816e), null));
        }
    }))($a483552cc7d919de$var$WrappedTimeTrackingView);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a483552cc7d919de$export$2e2bcd8739ae039 = (ownProps)=>{
    const intl = (0, $4ksts.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue.issue-view.context.time-tracking-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "context.time-tracking-field",
        /* eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics */ packageName: "jiraIssueView",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a483552cc7d919de$var$ConnectedComponent, {
        ...ownProps,
        intl: intl
    })));
};

});
parcelRegister("3nl2U", function(module, exports) {

$parcel$export(module.exports, "default", () => $165ff90ce499f1ab$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $165ff90ce499f1ab$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timeRemainingFieldLabel: {
        "id": "issue.context.time-remaining-field.label",
        "defaultMessage": "Time remaining"
    },
    includeSubtasksLabel: {
        "id": "issue.time-tracking.include-subtasks",
        "defaultMessage": "Include subtasks"
    },
    includeChildrenLabel: {
        "id": "issue.time-tracking.include-children",
        "defaultMessage": "Include child issues"
    },
    timeSpentRemainingLabel: {
        "id": "issue.context.time-remaining-spent.label",
        "defaultMessage": "{timeSpent} logged, {timeRemaining} remaining- edit {fieldName}"
    },
    extendedTimeRemainingLabel: {
        "id": "issue.context.extended-time-remaining-field.label",
        "defaultMessage": "No time logged, {timeRemaining} remaining- edit {fieldName}"
    },
    extendedTimeSpentLabel: {
        "id": "issue.context.extended-time-spent-field.label",
        "defaultMessage": "{timeSpent} logged- edit {fieldName}"
    },
    noTimeLoggedLabel: {
        "id": "issue.context.no-time-logged-field.label",
        "defaultMessage": "No time logged- edit {fieldName}"
    }
});

});

parcelRegister("kPtMB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3f5d28e7aa63891$export$2e2bcd8739ae039);

var $bgRtu = parcelRequire("bgRtu");
var $f3f5d28e7aa63891$export$2e2bcd8739ae039 = (0, $bgRtu.default);

});
parcelRegister("bgRtu", function(module, exports) {

$parcel$export(module.exports, "default", () => $116462138fcb3ca5$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $f8Yej = parcelRequire("f8Yej");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $6oQPP = parcelRequire("6oQPP");

var $4bZws = parcelRequire("4bZws");

var $cEQ4o = parcelRequire("cEQ4o");

var $bRjfP = parcelRequire("bRjfP");

var $8Islw = parcelRequire("8Islw");

var $iv1w3 = parcelRequire("iv1w3");

var $4YcX1 = parcelRequire("4YcX1");

var $h32Oe = parcelRequire("h32Oe");
const $116462138fcb3ca5$var$location = 'include-subtasks-children-in-time-tracking-toggle-from-context';
const $116462138fcb3ca5$var$actionSubjectId = 'toggleRollUpDataControlFromContext';
class $116462138fcb3ca5$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'TimeTrackingView';
    }
    renderReadView() {
        const { value: value, isDone: isDone, config: config, isEditable: isEditable } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Islw.default), {
            value: (0, $iv1w3.transformFromStateValue)(value),
            estimatedTime: value.originalEstimateSeconds,
            isDone: isDone,
            config: config,
            isEditable: isEditable
        });
    }
    renderRegisterTimeTrackingCommandPalette() {
        const { onEditRequest: onEditRequest, isEditable: isEditable } = this.props;
        return isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h32Oe.RegisterTimeTrackingCommandPalette), {
            onEditRequest: onEditRequest
        }) : null;
    }
    renderRemainingEstimateView() {
        const { config: config, fieldId: fieldId, issueKey: issueKey, issueId: issueId, showPinButton: showPinButton, invalidTimeFormatMessage: invalidTimeFormatMessage, placeholderMessage: placeholderMessage, timeRemainingFieldLabel: timeRemainingFieldLabel } = this.props;
        if (!issueId) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($116462138fcb3ca5$var$RemainingEstimateFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, timeRemainingFieldLabel), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
            fieldId: fieldId,
            label: timeRemainingFieldLabel
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEQ4o.default), {
            config: config,
            issueKey: issueKey,
            issueId: issueId,
            value: "",
            placeholderMessage: placeholderMessage,
            invalidTimeFormatMessage: invalidTimeFormatMessage,
            isFitContainerWidthReadView: true
        })));
    }
    renderRollUpToggle() {
        const { isRollingUpData: isRollingUpData, onToggleRollingUpData: onToggleRollingUpData } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($116462138fcb3ca5$var$RollupToggleWrapper, {
            "data-testid": "issue-view-base.context.time-tracking.rollup-toggle",
            sideBySideMode: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bRjfP.RollupCheckbox), {
            isRollingUpData: isRollingUpData,
            location: $116462138fcb3ca5$var$location,
            actionSubjectId: $116462138fcb3ca5$var$actionSubjectId,
            onToggleRollingUpData: onToggleRollingUpData
        }));
    }
    render() {
        const { isVisible: isVisible, label: label, isEditable: isEditable, isMobile: isMobile, onEditRequest: onEditRequest, confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, fieldId: fieldId, showPinButton: showPinButton, shouldDisplayRollUpDataControl: shouldDisplayRollUpDataControl, formatMessage: formatMessage, config: config, value: value } = this.props;
        if (!isVisible) return this.renderRemainingEstimateView();
        const editButtonLabel = (0, $4YcX1.getEditButtonLabel)(formatMessage, label, config, value);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), {
            "data-testid": `issue.views.issue-base.context.time-tracking.${fieldId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), {
            fieldId: fieldId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, label), showPinButton === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
            fieldId: fieldId,
            label: label
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), {
            /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.issue-base.context.time-tracking.value"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($116462138fcb3ca5$var$CompactWrapper, {
            isEditable: isEditable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
            label: label,
            readView: this.renderReadView(),
            editView: isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null) : null,
            isEditing: false,
            isEditable: isEditable,
            areActionButtonsHidden: true,
            // @ts-expect-error - TS2322 - Property 'disableEditViewFieldBase' does not exist on type 'IntrinsicAttributes & FieldInlineEditStateLessProps<unknown>'.
            disableEditViewFieldBase: true,
            isFitContainerWidthReadView: !isMobile,
            isLabelHidden: true,
            onEditRequested: onEditRequest,
            editButtonLabel: editButtonLabel,
            confirmButtonLabel: confirmButtonLabel,
            cancelButtonLabel: cancelButtonLabel
        })), shouldDisplayRollUpDataControl && this.renderRollUpToggle(), this.renderRegisterTimeTrackingCommandPalette())));
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $116462138fcb3ca5$var$CompactWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isEditable && "_18u0x0bf _19pkx0bf _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $116462138fcb3ca5$var$RemainingEstimateFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $64ypR.FieldWrapper), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16ep1osq",
            __cmplp.className
        ])
    });
});
const $116462138fcb3ca5$var$RollupToggleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { sideBySideMode: sideBySideMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0r5cr _ca0q12x7 _o5e6jjyb",
            __cmplp.sideBySideMode ? "_otyridpf" : "_otyr1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cEQ4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $22e0a8056d94f56c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $hTLlD = parcelRequire("hTLlD");

var $h9cCP = parcelRequire("h9cCP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $dWGNJ = parcelRequire("dWGNJ");

var $6oQPP = parcelRequire("6oQPP");

var $7Ymv3 = parcelRequire("7Ymv3");

var $jMP2a = parcelRequire("jMP2a");

var $5YYzL = parcelRequire("5YYzL");

var $6vrw7 = parcelRequire("6vrw7");

var $7v0hO = parcelRequire("7v0hO");

var $aVFPF = parcelRequire("aVFPF");

var $94HaP = parcelRequire("94HaP");

var $g4ZCt = parcelRequire("g4ZCt");

var $OwcmV = parcelRequire("OwcmV");
const $22e0a8056d94f56c$export$fd8ebf59dd2b58b6 = 'remainingEstimateInlineEdit';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$22e0a8056d94f56c$export$2e2bcd8739ae039 = (props)=>{
    const { config: config, issueKey: issueKey, issueId: issueId, onCancel: onCancel, onEdit: onEdit, onEscape: onEscape, onConfirm: onConfirm, onEnter: onEnter, onUpdate: onUpdate, readView: readView, editView: editView, placeholderMessage: placeholderMessage, invalidTimeFormatMessage: invalidTimeFormatMessage, useRemainingEstimateField: useRemainingEstimateField = (0, $94HaP.useRemainingEstimateField), ...rest } = props;
    const projectKey = (0, $hJ992.useProjectKey)();
    const [permissions] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const isEditable = permissions.canLogWork;
    const [{ value: timeTrackingValue, error: error }, { saveValue: saveValue, resetError: resetError }] = useRemainingEstimateField({
        issueId: issueId,
        issueKey: (0, $6vrw7.toIssueKey)(issueKey),
        // @ts-expect-error - TS2322 - Type '(<T>(arg1: T) => void) | undefined' is not assignable to type '(() => void) | undefined'.
        onSuccess: onUpdate
    });
    const remainingEstimateSecondsValue = timeTrackingValue.remainingEstimateSeconds || 0;
    const [isInvalidInput, setIsInvalidInput] = (0, $eUqFw.useState)(false);
    const [isEditing, setIsEditing] = (0, $eUqFw.useState)(false);
    const intl = (0, $5JgJ2.default)();
    const remainingTimeString = (0, $eUqFw.useMemo)(()=>{
        // At this time we need to force the value into an english formatted
        // time string eg: `1w 1d 1h 1m` as that is the only format supported
        // on entry, future changes will support localised values.
        const intlForTimeTrackingInput = {
            ...intl,
            // @ts-expect-error - TS7031 - Binding element 'defaultMessage' implicitly has an 'any' type.
            formatMessage: ({ defaultMessage: defaultMessage })=>defaultMessage || ''
        };
        return (0, $7v0hO.timeTrackingFormatter)(remainingEstimateSecondsValue || 0, {
            workingHoursPerDay: config.hoursPerDay,
            workingDaysPerWeek: config.daysPerWeek,
            timeFormat: config.format || (0, $h9cCP.PRETTY),
            defaultUnit: config.defaultUnit
        }, intlForTimeTrackingInput);
    }, [
        config,
        intl,
        remainingEstimateSecondsValue
    ]);
    const readTimeString = (0, $eUqFw.useMemo)(()=>(0, $7v0hO.timeTrackingFormatter)(remainingEstimateSecondsValue || 0, {
            workingHoursPerDay: config.hoursPerDay,
            workingDaysPerWeek: config.daysPerWeek,
            timeFormat: config.format || (0, $h9cCP.PRETTY),
            defaultUnit: config.defaultUnit
        }, intl), [
        config,
        intl,
        remainingEstimateSecondsValue
    ]);
    const [inputTime, setInputTime] = (0, $eUqFw.useState)(remainingTimeString);
    (0, $eUqFw.useEffect)(()=>{
        setInputTime(remainingTimeString);
    }, [
        remainingTimeString
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) setIsEditing(true);
    }, [
        error
    ]);
    const save = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(inputTime, remainingTimeString)) {
            setIsEditing(false);
            return;
        }
        if ((0, $7Ymv3.isValidTimeString)(config)(inputTime)) {
            const updatedTimeTrackingValue = {
                ...timeTrackingValue,
                remainingEstimateSeconds: (0, $7Ymv3.parseTimeString)(config)(inputTime) || 0
            };
            saveValue(updatedTimeTrackingValue, null, analyticsEvent);
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
            setIsInvalidInput(false);
            setIsEditing(false);
        } else {
            setIsInvalidInput(true);
            setIsEditing(true);
        }
    }, [
        config,
        remainingTimeString,
        saveValue,
        timeTrackingValue,
        inputTime
    ]);
    const cancel = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        resetError();
        setIsInvalidInput(false);
        setIsEditing(false);
        setInputTime(remainingTimeString);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        remainingTimeString,
        resetError
    ]);
    const onCancelRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onCancel && onCancel(analyticsEvent);
    }, [
        cancel,
        onCancel
    ]);
    const onConfirmRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        save(analyticsEvent);
        onConfirm && onConfirm(analyticsEvent);
    }, [
        onConfirm,
        save
    ]);
    const onEditRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        setIsEditing(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onEdit && onEdit(analyticsEvent);
    }, [
        onEdit
    ]);
    const onEscapeRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onEscape && onEscape(analyticsEvent);
    }, [
        cancel,
        onEscape
    ]);
    const onEnterRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        save(analyticsEvent);
        onEnter && onEnter(analyticsEvent);
    }, [
        onEnter,
        save
    ]);
    const onChange = (0, $eUqFw.useCallback)((e)=>{
        setIsInvalidInput(false);
        resetError();
        setInputTime(e.target.value);
    }, [
        resetError,
        setInputTime
    ]);
    const renderEditView = ()=>editView !== undefined ? editView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g4ZCt.RemainingEstimateEdit), {
            defaultValue: inputTime,
            placeholderMessage: placeholderMessage,
            onChange: onChange,
            invalidTimeFormatMessage: invalidTimeFormatMessage,
            isInvalidInput: isInvalidInput
        });
    const renderReadView = ()=>readView !== undefined ? readView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OwcmV.RemainingEstimateView), {
            defaultValue: readTimeString,
            isHoverable: isEditable
        });
    const renderErrorFlag = ()=>{
        if (!error) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
            error: error,
            title: (0, $aVFPF.default).errorTitle,
            description: (0, $aVFPF.default).errorMessage
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, error && renderErrorFlag(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22e0a8056d94f56c$export$9f16bbb9a44c7bf6, {
        isEditing: isEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        testId: "issue-field-remaining-estimate.ui.ui",
        actionSubject: $22e0a8056d94f56c$export$fd8ebf59dd2b58b6,
        isEditable: isEditable,
        isEditing: isEditing,
        readView: renderReadView(),
        editView: isEditable ? renderEditView() : null,
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onEdit: onEditRequest,
        onEscape: onEscapeRequest,
        onEnter: onEnterRequest,
        ...rest
    })));
};
const $22e0a8056d94f56c$export$9f16bbb9a44c7bf6 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1y4t18g-0"
})`${({ isEditing: isEditing })=>isEditing ? `margin-left: ${"var(--ds-space-negative-075, -6px)"};` : 'margin-left: -10px;'} margin-top:${"var(--ds-space-negative-100, -8px)"};padding-right:${"var(--ds-space-150, 12px)"};padding-left:${"var(--ds-space-050, 4px)"};& div[data-read-view-fit-container-width]{width:100%;min-height:32px;padding:${"var(--ds-space-075, 6px)"} 0;}`;

});
parcelRegister("aVFPF", function(module, exports) {

$parcel$export(module.exports, "default", () => $09ca726651865ff3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $09ca726651865ff3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "issue-field-remaining-estimate.error-title",
        "defaultMessage": "We couldn't set the remaining estimate value"
    },
    errorMessage: {
        "id": "issue-field-remaining-estimate.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});

parcelRegister("94HaP", function(module, exports) {

$parcel$export(module.exports, "useRemainingEstimateField", () => $15aef89dd313b2f8$export$407febf2ed015325);

var $53ciZ = parcelRequire("53ciZ");

var $lRmyA = parcelRequire("lRmyA");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $eDEru = parcelRequire("eDEru");

var $lO4Or = parcelRequire("lO4Or");

var $5zSUY = parcelRequire("5zSUY");
const $15aef89dd313b2f8$export$72a8b15fb4557735 = async ({ issueId: issueId, newValue: newValue, baseUrl: baseUrl })=>{
    // https://jdog.jira-dev.com/browse/BENTO-792 - The Time Estimate field is always shown,
    // because we always the return the timeoriginalestimate field from the backend. In order to
    // prevent the field from being visible but not editable when Time Tracking is missing from the
    // screen config, we use this legacy endpoint to save the field.
    const remainingEstimateValue = newValue.remainingEstimateSeconds;
    // Convert the value in seconds to a time string to send to Jira.
    // 1m is always 60s, so we can do this safely.
    // we have to convert the final value to a whole number as passing decimal
    // values in minutes errors.
    const value = remainingEstimateValue !== undefined ? (0, $eDEru.secondsToWholeMinuteTimeString)(remainingEstimateValue) : null;
    return (0, $lRmyA.performPostRequest)(`${baseUrl}/secure/AjaxIssueAction.jspa?decorator=none`, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: (0, $53ciZ.stringify)({
            issueId: issueId,
            timetracking_remainingestimate: value,
            timetracking_targetsubfield: 'timetracking_remainingestimate',
            fieldsToForcePresent: 'timetracking',
            singleFieldEdit: true,
            skipScreenCheck: true,
            atl_token: (0, $5zSUY.default)()
        })
    });
};
const $15aef89dd313b2f8$export$407febf2ed015325 = ({ issueId: issueId, issueKey: issueKey, onSuccess: onSuccess })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, (0, $lO4Or.TIME_TRACKING_TYPE));
    const fieldType = fieldConfig?.schema.type || 'timetracking';
    const saveClassicField = (_, __, newValue, baseUrl)=>$15aef89dd313b2f8$export$72a8b15fb4557735({
            issueId: issueId,
            newValue: newValue,
            baseUrl: baseUrl
        });
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $lO4Or.TIME_TRACKING_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: {
            originalEstimateSeconds: 0,
            timeSpentSeconds: 0,
            remainingEstimateSeconds: 0
        },
        saveField: saveClassicField,
        onSuccess: onSuccess
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("g4ZCt", function(module, exports) {

$parcel$export(module.exports, "RemainingEstimateEdit", () => $c89e75a0c4e7fb0e$export$1bf4f63f623b967);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jzS9W = parcelRequire("jzS9W");
const $c89e75a0c4e7fb0e$export$1bf4f63f623b967 = (props)=>{
    const { defaultValue: defaultValue, placeholderMessage: placeholderMessage, onChange: onChange, isInvalidInput: isInvalidInput, invalidTimeFormatMessage: invalidTimeFormatMessage } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c89e75a0c4e7fb0e$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jzS9W.default), {
        compact: true,
        type: "text",
        value: defaultValue,
        placeholder: placeholderMessage,
        onChange: onChange,
        invalidMessage: isInvalidInput ? invalidTimeFormatMessage : undefined
    }));
};
var $c89e75a0c4e7fb0e$export$2e2bcd8739ae039 = $c89e75a0c4e7fb0e$export$1bf4f63f623b967;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c89e75a0c4e7fb0e$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80om1wug _1bsb1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("OwcmV", function(module, exports) {

$parcel$export(module.exports, "RemainingEstimateView", () => $b586aff56a17d828$export$f73cc54a4d9a3760);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $9nkwJ = parcelRequire("9nkwJ");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");

const $b586aff56a17d828$export$f73cc54a4d9a3760 = ({ isHoverable: isHoverable = false, defaultValue: defaultValue, testId: testId = (0, $103873dec66c609d$export$4c8530077805da15) })=>{
    const badge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        testId: `${testId}.badge`
    }, defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b586aff56a17d828$var$ReadViewContainer, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b586aff56a17d828$var$BadgeWrapper, null, isHoverable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b586aff56a17d828$var$HoverContainer, {
        "data-testid": `${testId}.hover-container`
    }, badge) : badge));
};
var $b586aff56a17d828$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $b586aff56a17d828$export$f73cc54a4d9a3760;
const $b586aff56a17d828$var$ReadViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1nmz1hna _kqswh2mm _1ltv12x7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b586aff56a17d828$var$HoverContainer = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-4jfcr3-0"
})({
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&:hover > span': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `${`var(--ds-text, ${(0, $PdmhA).N800})`} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `${`var(--ds-background-neutral-hovered, ${(0, $PdmhA).N90})`} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: `${(0, $c9TLT.gridSize) * 2.5}px`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b586aff56a17d828$var$BadgeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _kqswh2mm _19pk196n _otyr196n _2hwx1i6y",
            __cmplp.className
        ])
    });
});

});
const $103873dec66c609d$export$4c8530077805da15 = 'issue-field-remaining-estimate.ui.view';



parcelRegister("iv1w3", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $dce6b5cfd260e135$export$cb172b2468ab5652);

var $i7Fym = parcelRequire("i7Fym");
const $dce6b5cfd260e135$var$isUndefined = (val)=>val === undefined;
const $dce6b5cfd260e135$export$cb172b2468ab5652 = (stateValue)=>{
    if (!stateValue) return Object.seal({});
    const { remainingEstimateSeconds: remainingEstimateSeconds, timeSpentSeconds: timeSpentSeconds } = stateValue;
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
        loggedTime: timeSpentSeconds,
        remainingTime: remainingEstimateSeconds
    }, $dce6b5cfd260e135$var$isUndefined);
};
const $dce6b5cfd260e135$export$1cfcb95cb8fbddb3 = ({ loggedTime: loggedTime, remainingTime: remainingTime })=>(0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
        timeSpentSeconds: loggedTime,
        remainingEstimateSeconds: remainingTime
    }, $dce6b5cfd260e135$var$isUndefined);

});

parcelRegister("4YcX1", function(module, exports) {

$parcel$export(module.exports, "getEditButtonLabel", () => $7e5a9760c343d64d$export$54ac57fc20f00a04);

var $5iWql = parcelRequire("5iWql");

var $7Ymv3 = parcelRequire("7Ymv3");

var $3nl2U = parcelRequire("3nl2U");
const $7e5a9760c343d64d$export$54ac57fc20f00a04 = (0, $5iWql.default)((formatMessage, label, config, value)=>{
    const { timeSpentSeconds: timeSpentSeconds, remainingEstimateSeconds: remainingEstimateSeconds } = value;
    const timeSpent = (0, $7Ymv3.formatTimeString)(config)(timeSpentSeconds || 0);
    const timeRemaining = (0, $7Ymv3.formatTimeString)(config)(remainingEstimateSeconds || 0);
    const isTimeSpentSeconds = !!timeSpentSeconds;
    const isRemainingEstimateSeconds = !!remainingEstimateSeconds;
    const TIME_LOGGED_AND_TIME_REMAINING = isTimeSpentSeconds && isRemainingEstimateSeconds;
    const TIME_REMAINING_AND_NO_TIME_LOGGED = isRemainingEstimateSeconds && !isTimeSpentSeconds;
    const TIME_LOGGED_AND_NO_TIME_REMAINING = isTimeSpentSeconds && !isRemainingEstimateSeconds;
    switch(true){
        case TIME_LOGGED_AND_TIME_REMAINING:
            return formatMessage((0, $3nl2U.default).timeSpentRemainingLabel, {
                timeSpent: timeSpent,
                timeRemaining: timeRemaining,
                fieldName: label
            });
        case TIME_REMAINING_AND_NO_TIME_LOGGED:
            return formatMessage((0, $3nl2U.default).extendedTimeRemainingLabel, {
                timeRemaining: timeRemaining,
                fieldName: label
            });
        case TIME_LOGGED_AND_NO_TIME_REMAINING:
            return formatMessage((0, $3nl2U.default).extendedTimeSpentLabel, {
                timeSpent: timeSpent,
                fieldName: label
            });
        default:
            return formatMessage((0, $3nl2U.default).noTimeLoggedLabel, {
                fieldName: label
            });
    }
});

});

parcelRegister("h32Oe", function(module, exports) {

$parcel$export(module.exports, "RegisterTimeTrackingCommandPalette", () => $3ea9a14213e02aeb$export$26974a870849e775);

var $eUqFw = parcelRequire("eUqFw");

var $7XRtk = parcelRequire("7XRtk");

var $6jiFZ = parcelRequire("6jiFZ");

var $46gH8 = parcelRequire("46gH8");
var $36mrL = parcelRequire("36mrL");
var $gfXKy = parcelRequire("gfXKy");

var $fmmnJ = parcelRequire("fmmnJ");
var $awzwr = parcelRequire("awzwr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");


var $5zPjd = parcelRequire("5zPjd");
const $3ea9a14213e02aeb$export$26974a870849e775 = ({ onEditRequest: onEditRequest })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    const commands = [
        {
            id: `${(0, $cfd0b44afccaf101$export$323f2a4b12c3462e)}-${issueKey}`,
            name: formatMessage((0, $5zPjd.default).logWork),
            keywords: getKeywords('logWorkSynonyms'),
            primaryAction: {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>setTimeout(onEditRequest, 0)
            },
            shortcut: 'q',
            section: (0, $46gH8.getCommandPaletteIssueActionsHeader)(issueKey),
            priority: (0, $36mrL.getCommandPaletteIssueActionsPriority)('ISSUE_HEADER_ITEMS'),
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7XRtk))), {
                        label: formatMessage((0, $5zPjd.default).logWork)
                    })
            },
            analytics: {
                action: 'logWork'
            }
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awzwr.RegisterCommands), {
        registrationId: (0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).LOG_WORK,
        commands: commands,
        deps: [
            issueKey
        ]
    });
};

});
const $cfd0b44afccaf101$export$323f2a4b12c3462e = 'issue-log-work';

parcelRegister("5zPjd", function(module, exports) {

$parcel$export(module.exports, "default", () => $de4231080aa15866$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $de4231080aa15866$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    logWork: {
        "id": "issue-field.log-time-modal.command-palette.log-work",
        "defaultMessage": "Log work"
    }
});

});





parcelRegister("6nkZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f13adaec2c94ebe5$export$2e2bcd8739ae039);

var $7wpzp = parcelRequire("7wpzp");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");
var $f13adaec2c94ebe5$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        additionalProps: (state, intl)=>({
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                type: 'url',
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            })
    }))((0, $7wpzp.default));

});

parcelRegister("czHVU", function(module, exports) {

$parcel$export(module.exports, "default", () => $324d31b580280933$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $2OdyW = parcelRequire("2OdyW");

var $exOWK = parcelRequire("exOWK");

var $huhk2 = parcelRequire("huhk2");

var $brySu = parcelRequire("brySu");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $40QX1 = parcelRequire("40QX1");

var $jf5VS = parcelRequire("jf5VS");
const $324d31b580280933$export$2b81811283cd2d9d = (0, $5iWql.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(fieldId, issueKey)=>async (query)=>{
        const suggestions = await (0, $2OdyW.default)(`/rest/api/3/user/recommend?${new URLSearchParams({
            context: 'CustomUserField',
            ...issueKey && {
                issueKey: issueKey
            },
            ...fieldId && {
                fieldId: fieldId
            },
            query: query ?? ''
        })}`);
        return suggestions.map((0, $jf5VS.transformFromStateValue));
    });
const $324d31b580280933$export$80859424956457b4 = (0, $5iWql.default)((intl)=>({
        avatarUrl: '',
        name: intl.formatMessage((0, $huhk2.genericMessages).noValue)
    }));
var $324d31b580280933$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $jf5VS.transformFromStateValue,
        transformToStateValue: $jf5VS.transformToStateValue,
        additionalProps: (state, intl)=>({
                portalElement: (0, $40QX1.isFieldInTabSelector)(ownPropsOnMount.fieldId)(state) ? // See: https://jdog.jira-dev.com/browse/BENTO-4101
                (0, $brySu.getIssueModalAkDropdownPortal)() || document.body : undefined,
                fetchSuggestions: $324d31b580280933$export$2b81811283cd2d9d(ownPropsOnMount.fieldId, (0, $5JqpU.issueKeySelector)(state)),
                emptyOption: (0, $fokFV.isFieldRequiredSelector)(ownPropsOnMount.fieldId)(state) ? undefined : $324d31b580280933$export$80859424956457b4(intl),
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            })
    }))((0, $exOWK.default));

});

parcelRegister("7Vb23", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea3493823e98cff0$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $jxxzJ = parcelRequire("jxxzJ");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $lUYNo = parcelRequire("lUYNo");

var $kFZsP = parcelRequire("kFZsP");

var $7yPsi = parcelRequire("7yPsi");
const $ea3493823e98cff0$var$fetchSuggestionsFactory = (0, $5iWql.default)((suggestions, intl, projectId)=>()=>Promise.resolve(suggestions).then((resolvedSuggestions)=>(0, $lUYNo.transformSuggestionsFromServerAndCache)(resolvedSuggestions, [], intl, projectId)));
var $ea3493823e98cff0$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $7yPsi.transformFromStateValue,
        transformToStateValue: $7yPsi.transformToStateValue,
        additionalProps: (state, intl)=>({
                fetchSuggestions: $ea3493823e98cff0$var$fetchSuggestionsFactory((0, $fokFV.fieldAllowedValuesSelector)(ownPropsOnMount.fieldId)(state), intl, (0, $jZDJX.projectIdSelector)(state)),
                placeholder: intl.formatMessage((0, $kFZsP.default).placeholder),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                allowEmptyValue: !(0, $fokFV.isFieldRequiredSelector)(ownPropsOnMount.fieldId)(state),
                hasAutocomplete: true,
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            })
    }))((0, $jxxzJ.default));

});
parcelRegister("lUYNo", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValueWithVersionLink", () => $3c8b096a39c2fe93$export$c14d556aa29f9166);
$parcel$export(module.exports, "transformFromStateValue", () => $3c8b096a39c2fe93$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $3c8b096a39c2fe93$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformSuggestionsFromServerAndCache", () => $3c8b096a39c2fe93$export$ecddc37cd50b50fd);

var $e8lGI = parcelRequire("e8lGI");

var $7ZZxN = parcelRequire("7ZZxN");

var $8g5hT = parcelRequire("8g5hT");

var $f9RL0 = parcelRequire("f9RL0");

var $kBz7C = parcelRequire("kBz7C");
const $3c8b096a39c2fe93$var$toItem = (item)=>({
        content: item.name,
        value: item.id,
        // @ts-expect-error - TS2339 - Property 'fromCache' does not exist on type 'Version | TransformedCachedVersion'.
        fromCache: item.fromCache || false
    });
// JQL search keys don't actually match the field keys
const $3c8b096a39c2fe93$var$fieldKeyToJQLMap = {
    [(0, $f9RL0.AFFECTS_VERSIONS)]: 'affectedVersion',
    [(0, $f9RL0.FIX_VERSIONS)]: 'fixVersion'
};
// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly versions: "affectedVersion"; readonly fixVersions: "fixVersion"; }'.
const $3c8b096a39c2fe93$var$getJqlKey = (fieldKey)=>$3c8b096a39c2fe93$var$fieldKeyToJQLMap[fieldKey] || 'fixVersion';
const $3c8b096a39c2fe93$var$getVersionUrl = ({ version: version, fieldId: fieldId, projectKey: projectKey, projectType: projectType })=>{
    if (// Version details page is only available in Software projects.
    projectType === (0, $7ZZxN.SOFTWARE_PROJECT) && // Version details page only shows issues that are *fixed* in a version, not those that *affect* it.
    // Therefore it only makes sense to link to the version details page from the fix version field.
    fieldId === (0, $f9RL0.FIX_VERSIONS)) return `/projects/${projectKey}/versions/${version.id}/tab/release-report-all-issues`;
    // Use an issue search URL as a fallback for cases where the version details page doesn't make sense.
    const jql = `project = ${(0, $8g5hT.toQuotedString)(projectKey)} AND ${$3c8b096a39c2fe93$var$getJqlKey(fieldId)} = ${(0, $8g5hT.toQuotedString)(version.name)}`;
    return (0, $8g5hT.createIssuesUrl)(jql);
};
const $3c8b096a39c2fe93$export$c14d556aa29f9166 = (value, { baseUrl: baseUrl, projectKey: projectKey, projectType: projectType, fieldId: fieldId })=>value ? value.map((item)=>({
            href: $3c8b096a39c2fe93$var$getVersionUrl({
                version: item,
                fieldId: fieldId,
                projectKey: projectKey,
                projectType: projectType,
                baseUrl: baseUrl
            }),
            content: item.name,
            value: item.id
        })) : [];
const $3c8b096a39c2fe93$export$cb172b2468ab5652 = (value)=>value ? value.map($3c8b096a39c2fe93$var$toItem) : [];
const $3c8b096a39c2fe93$export$1cfcb95cb8fbddb3 = (value)=>value.map((item)=>({
            name: item.content,
            id: item.value,
            fromCache: item.fromCache
        }));
const $3c8b096a39c2fe93$export$dc069111282472fb = (rest, cache, projectId)=>cache.filter((item)=>item.projectId === projectId).map((item)=>{
        const duplicatedItem = rest.find((restItem)=>restItem.id === item.id);
        if (duplicatedItem) {
            const newItem = {
                ...duplicatedItem,
                projectId: projectId
            };
            (0, $e8lGI.default).update(`${item.id}`, newItem);
            return {
                ...newItem,
                fromCache: true
            };
        }
        return {
            ...item,
            fromCache: true
        };
    });
const $3c8b096a39c2fe93$var$MAX_RESULTS = 5;
const $3c8b096a39c2fe93$export$64c1e7aa265973f8 = (cache)=>cache.slice(-1 * $3c8b096a39c2fe93$var$MAX_RESULTS).reverse();
const $3c8b096a39c2fe93$export$ecddc37cd50b50fd = (suggestionsFromServer, suggestionsFromCache, intl, projectId)=>{
    const activeSuggestions = suggestionsFromServer.filter((suggestion)=>!suggestion.archived);
    const unreleasedItems = activeSuggestions.filter((suggestion)=>!suggestion.released).map($3c8b096a39c2fe93$var$toItem);
    const releasedItems = activeSuggestions.filter((suggestion)=>suggestion.released).map($3c8b096a39c2fe93$var$toItem);
    const suggestionsFromServerIds = new Set(suggestionsFromServer.map(({ id: id })=>id));
    const cacheItems = $3c8b096a39c2fe93$export$dc069111282472fb(suggestionsFromServer, suggestionsFromCache, projectId).filter((v)=>!v.archived)// the following filter fixes a bug where archived versions are still showing despite the server response not including them.
    // this is because the the archived version may still exist inside the browser cache with an 'unreleased' status.
    // to fix this, remove any version in the browser cache that isn't part of the server response.
    // https://hello.atlassian.net/wiki/spaces/~494408470/pages/1657964060/Recent+Versions+Bug
    .filter((v)=>suggestionsFromServerIds.has(v.id));
    const cacheLists = $3c8b096a39c2fe93$export$64c1e7aa265973f8(cacheItems);
    return [
        {
            heading: intl.formatMessage((0, $kBz7C.default).recent),
            items: cacheLists.map($3c8b096a39c2fe93$var$toItem)
        },
        {
            heading: intl.formatMessage((0, $kBz7C.default).unreleasedHeading),
            items: unreleasedItems
        },
        {
            heading: intl.formatMessage((0, $kBz7C.default).releasedHeading),
            items: releasedItems
        }
    ];
};

});
parcelRegister("e8lGI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e661cf7df424f9c$export$2e2bcd8739ae039);

var $jhVpU = parcelRequire("jhVpU");

var $ci8Ys = parcelRequire("ci8Ys");
var $5e661cf7df424f9c$export$2e2bcd8739ae039 = (0, $jhVpU.default)((0, $ci8Ys.props));

});
parcelRegister("ci8Ys", function(module, exports) {

$parcel$export(module.exports, "props", () => $b5c07452b2940246$export$8128bb6492cf3de7);

const $b5c07452b2940246$var$MAX_RESULTS = 10;
const $b5c07452b2940246$var$CACHE_SIZE = $b5c07452b2940246$var$MAX_RESULTS * 2;
const $b5c07452b2940246$var$VERSIONS_CACHE_KEY = 'versions';
const $b5c07452b2940246$export$8128bb6492cf3de7 = {
    size: $b5c07452b2940246$var$CACHE_SIZE,
    cacheKey: $b5c07452b2940246$var$VERSIONS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)
};

});


parcelRegister("kBz7C", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b4a659bc3f41e9a$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $4b4a659bc3f41e9a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createNewItem: {
        "id": "issue.fix-versions.create-new-component-message",
        "defaultMessage": "Create new version"
    },
    recent: {
        "id": "issue.fix-versions.create-new-component-message.recent",
        "defaultMessage": "Recent versions"
    },
    releasedHeading: {
        "id": "issue.fix-versions.released-message",
        "defaultMessage": "Released"
    },
    unreleasedHeading: {
        "id": "issue.fix-versions.unreleased-message",
        "defaultMessage": "Unreleased"
    }
});

});


parcelRegister("kFZsP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccbff0754180d203$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $ccbff0754180d203$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue.single-version-picker.text-for-dropdown-when-nothing-selected",
        "defaultMessage": "Select version"
    }
});

});

parcelRegister("7yPsi", function(module, exports) {

$parcel$export(module.exports, "transformToStateValue", () => $3016146b0aab3ad5$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformFromStateValue", () => $3016146b0aab3ad5$export$cb172b2468ab5652);
const $3016146b0aab3ad5$export$1cfcb95cb8fbddb3 = (item)=>item && {
        name: item.content,
        id: item.value
    };
const $3016146b0aab3ad5$export$cb172b2468ab5652 = (stateValue)=>stateValue && {
        content: stateValue.name,
        value: stateValue.id
    };

});


parcelRegister("26F4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $51c14e063d4258e3$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $18KtE = parcelRequire("18KtE");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $lUYNo = parcelRequire("lUYNo");
const $51c14e063d4258e3$var$fetchSuggestionsFactory = (0, $5iWql.default)((suggestions, intl, projectId)=>()=>Promise.resolve(suggestions).then((resolvedSuggestions)=>(0, $lUYNo.transformSuggestionsFromServerAndCache)(resolvedSuggestions, [], intl, projectId)));
var $51c14e063d4258e3$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>({
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $lUYNo.transformFromStateValue,
        transformToStateValue: $lUYNo.transformToStateValue,
        additionalProps: (state, intl)=>({
                fetchSuggestions: $51c14e063d4258e3$var$fetchSuggestionsFactory((0, $fokFV.fieldAllowedValuesSelector)(ownPropsOnMount.fieldId)(state), intl, (0, $jZDJX.projectIdSelector)(state)),
                placeholder: intl.formatMessage((0, $huhk2.genericMessages).version_no_value_placeholder),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area)
            })
    }))((0, $18KtE.default));

});

parcelRegister("dO6co", function(module, exports) {

$parcel$export(module.exports, "VersionsFieldWithRelayEditView", () => $25efe743f3969708$export$3238fd140c42520);

var $ls7cS = parcelRequire("ls7cS");

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");

var $5iWql = parcelRequire("5iWql");

var $hompL = parcelRequire("hompL");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $4Hwcq = parcelRequire("4Hwcq");

var $kiXet = parcelRequire("kiXet");

var $2U8tE = parcelRequire("2U8tE");

var $63BlZ = parcelRequire("63BlZ");

var $hW84d = parcelRequire("hW84d");

var $ats0p = parcelRequire("ats0p");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $4kDvN = parcelRequire("4kDvN");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $lO4Or = parcelRequire("lO4Or");

var $guDlK = parcelRequire("guDlK");

var $5aUxM = parcelRequire("5aUxM");

var $hXRWO = parcelRequire("hXRWO");

var $7DBqv = parcelRequire("7DBqv");
const $25efe743f3969708$export$90fa20d58c8becf5 = (0, $5iWql.default)((ari)=>({ onChange: onChange, value: value, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, isInvalid: isInvalid, fieldId: fieldId, footer: footer, onFooterSelect: onFooterSelect, shouldShowFooter: shouldShowFooter })=>{
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        const issueId = (0, $hJ992.useIssueId)();
        const issueKey = (0, $hJ992.useIssueKey)();
        const projectKey = (0, $guDlK.useProjectKey)(issueKey);
        const projectId = (0, $guDlK.useProjectId)(projectKey);
        const sessionId = (0, $eUqFw.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
        const isReleaseVersionsField = fieldId === (0, $lO4Or.FIX_VERSIONS_TYPE) || fieldId === (0, $lO4Or.AFFECTS_VERSIONS_TYPE);
        const canCreateVersion = shouldShowFooter && isReleaseVersionsField;
        const [cachedOptions, { addToCache: addToCache, getAllCachedVersions: getAllCachedVersions, refreshCachedVersions: refreshCachedVersions }] = (0, $2U8tE.useReleaseVersionsCache)(String(projectId), ari);
        (0, $eUqFw.useEffect)(()=>{
            (async function getCachedVersions() {
                await getAllCachedVersions();
                refreshCachedVersions();
            })();
        }, [
            getAllCachedVersions,
            refreshCachedVersions
        ]);
        const { rankFieldOptions: rankFieldOptions } = (0, $63BlZ.useFieldRanker)({
            fieldId: fieldId,
            issueId: issueId,
            projectId: projectId,
            experience: 'JiraFields',
            sessionId: sessionId.current
        });
        const handleChange = (values, actionMeta)=>{
            const legacyValues = values?.map((0, $hXRWO.transformRelayToReduxValue)) ?? [];
            const legacyActionMeta = {
                action: actionMeta.action,
                // value was selected
                ...actionMeta.option ? {
                    option: (0, $hXRWO.transformRelayToReduxValue)(actionMeta.option)
                } : null,
                // value was removed
                ...actionMeta.removedValue ? {
                    removedValue: (0, $hXRWO.transformRelayToReduxValue)(actionMeta.removedValue)
                } : null
            };
            onChange?.(legacyValues, legacyActionMeta);
            if (values) addToCache(values);
        };
        const selectedOptions = (0, $eUqFw.useMemo)(()=>value ? value.map((0, $hXRWO.transformReduxToRelayValue)) : [], [
            value
        ]);
        const loadOptions = (0, $eUqFw.useCallback)(async (options)=>rankFieldOptions(options, (option)=>({
                    key: option.versionId ?? '',
                    value: option.selectableLabel ?? ''
                })), [
            rankFieldOptions
        ]);
        const getClassNamePrefix = (field)=>{
            switch(field){
                case 0, $lO4Or.FIX_VERSIONS_TYPE:
                case 0, $lO4Or.AFFECTS_VERSIONS_TYPE:
                    return 'issue-view-fix-versions';
                default:
                    return '';
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kiXet.ReleaseVersionsEditView), {
            autoFocus: true,
            fieldId: ari || '',
            value: selectedOptions,
            loadOptions: isReleaseVersionsField ? loadOptions : undefined,
            sortOptions: (0, $7DBqv.sortOptions),
            cachedOptions: cachedOptions,
            onChange: handleChange,
            noOptionsMessage: noOptionsMessage,
            loadingMessage: loadingMessage,
            isInvalid: isInvalid,
            isMulti: true,
            spacing: "compact",
            classNamePrefix: getClassNamePrefix(fieldId),
            footer: footer,
            onFooterSelect: onFooterSelect,
            shouldShowFooter: canCreateVersion,
            recentOptionsLabel: formatMessage((0, $5aUxM.default).recentVersions)
        });
    });
const $25efe743f3969708$export$c44514f505e10d77 = (props)=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // Temporary FF to disable prefetching for select customers that experience issue like https://getsupport.atlassian.com/browse/PCS-277464
    // Proper solution will be done under https://jplat.jira.atlassian.cloud/browse/JIV-18302
    if ((0, $1ybV0.ff)('issue-view-disable-fields-prefetch') === false) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hW84d.useLazyLoadQueryAfterPageLoad)((0, $ls7cS.default), {
        id: props.ari,
        first: (0, $4Hwcq.PREFETCH_OPTIONS_COUNT),
        isSelectableField: (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration')
    });
    const [, { addToCache: addToCache }] = (0, $2U8tE.useReleaseVersionsCache)(String(props.projectId), props.ari);
    const handleOnVersionCreated = (0, $eUqFw.useCallback)((version)=>{
        addToCache([
            {
                id: version.ari || '',
                selectableLabel: version.name,
                selectableGroupKey: version.status,
                selectableIconUrl: null,
                versionId: version.id,
                isDisabled: false
            }
        ]);
        showFlag({
            type: 'success',
            title: formatMessage((0, $5aUxM.default).successFlagCreation, {
                name: version.name
            })
        });
    }, [
        addToCache,
        formatMessage,
        showFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ats0p.default), {
        ...props,
        onVersionCreated: handleOnVersionCreated
    });
};
const $25efe743f3969708$export$3238fd140c42520 = (0, $huRi7.compose)((0, $4kDvN.withExtraOwnProps), (0, $3uwfp.default)((_, ownPropsOnMount)=>{
    const fieldARISelectorGetter = (0, $fokFV.fieldARISelector)(ownPropsOnMount.fieldId);
    return {
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $hXRWO.transformFromStateValue,
        transformToStateValue: $hXRWO.transformToStateValue,
        additionalProps: (state, intl)=>({
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area),
                customEditView: $25efe743f3969708$export$90fa20d58c8becf5(fieldARISelectorGetter(state)),
                projectId: (0, $jZDJX.projectIdSelector)(state),
                ari: fieldARISelectorGetter(state),
                createNewItemMessage: intl.formatMessage((0, $5aUxM.default).createNewItem),
                createNewItemIconLabel: intl.formatMessage((0, $5aUxM.default).createNewIcon),
                canAdministerProject: (0, $9F6MO.canAdministerProjectPermissionsSelector)(state),
                canAdministerJira: (0, $9F6MO.canAdministerJiraPermissionsSelector)(state)
            })
    };
}))($25efe743f3969708$export$c44514f505e10d77);

});
parcelRegister("ls7cS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4813cb243f521cc2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6e68f7f3b223b4b4187dd250d75d180c>>
 * @relayHash 89597fc3307b7b18edd2931c875ebc5a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7a1f32f967e3590ee594566a2bf7dcc2183c2551278753075962e8f568443cdc
const $4813cb243f521cc2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSelectableField"
    }, v3 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v4 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v5 = {
        "kind": "Literal",
        "name": "searchBy",
        "value": ""
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        v3 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "versionsWithRelayEditViewFieldOptionsPrefetchQuery",
            "selections": [
                {
                    "condition": "isSelectableField",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "ui_issueSelectableFieldEditView_SelectableFieldEditViewWithFieldOptionsFragment"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "versionsWithRelayEditViewFieldOptionsPrefetchQuery",
            "selections": [
                {
                    "condition": "isSelectableField",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v4 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        }
                                    ],
                                    "type": "JiraIssueField",
                                    "abstractKey": "__isJiraIssueField"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v7 /*: any*/ ,
                                            "concreteType": "JiraSelectableValueConnection",
                                            "kind": "LinkedField",
                                            "name": "selectableValueOptions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSelectableValueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "selectableLabel"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "selectableGroupKey"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "selectableIconUrl"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isDisabled"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "optionId"
                                                                        }
                                                                    ],
                                                                    "type": "JiraOption"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "versionId"
                                                                        }
                                                                    ],
                                                                    "type": "JiraVersion"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v7 /*: any*/ ,
                                            "filters": [
                                                "searchBy",
                                                "filterById"
                                            ],
                                            "handle": "connection",
                                            "key": "selectableValue_issueFieldEditviewFull_fieldOptions__selectableValueOptions",
                                            "kind": "LinkedHandle",
                                            "name": "selectableValueOptions"
                                        }
                                    ],
                                    "type": "JiraHasSelectableValueOptions",
                                    "abstractKey": "__isJiraHasSelectableValueOptions"
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7a1f32f967e3590ee594566a2bf7dcc2183c2551278753075962e8f568443cdc",
            "metadata": {},
            "name": "versionsWithRelayEditViewFieldOptionsPrefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4813cb243f521cc2$var$node.hash = "a4594cf7984d240ea2159d7070119e86";
var $4813cb243f521cc2$export$2e2bcd8739ae039 = $4813cb243f521cc2$var$node;

});

parcelRegister("kiXet", function(module, exports) {

$parcel$export(module.exports, "ReleaseVersionsEditViewDeprecated", () => $3d4a9c97b5e121f8$export$c1d02fd25e1fc37b);
$parcel$export(module.exports, "ReleaseVersionsEditView", () => $3d4a9c97b5e121f8$export$7e81d0b6f6962f78);

var $jMDIW = parcelRequire("jMDIW");

var $5kgX6 = parcelRequire("5kgX6");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $gO9Xw = parcelRequire("gO9Xw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $4Hwcq = parcelRequire("4Hwcq");

var $4bMJ9 = parcelRequire("4bMJ9");

var $fiMQP = parcelRequire("fiMQP");

var $3OCmX = parcelRequire("3OCmX");

var $guDlK = parcelRequire("guDlK");

var $dfM7q = parcelRequire("dfM7q");

var $bMEzK = parcelRequire("bMEzK");

var $5n2kr = parcelRequire("5n2kr");

var $hbz7x = parcelRequire("hbz7x");
var $4SZlZ = parcelRequire("4SZlZ");

var $dxcfv = parcelRequire("dxcfv");

var $gFuwP = parcelRequire("gFuwP");
const $3d4a9c97b5e121f8$var$CreatableReleaseVersionsEditView = ({ onReleaseCreation: onReleaseCreation, onChange: onChange, value: value, fieldId: fieldId, fieldOptionsFragmentRef: fieldOptionsFragmentRef, classNamePrefix: classNamePrefix, isMulti: isMulti, isClearable: isClearable, projectId: projectId, ...restProps })=>{
    const accountId = (0, $dxcfv.useAccountId)();
    const experienceStart = (0, $4SZlZ.useCreateReleaseExperienceStart)('issueView');
    const projectKey = (0, $hJ992.useProjectKey)();
    const issueProjectId = (0, $guDlK.useProjectId)(projectKey);
    const [isDialogOpen, setIsDialogOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [createReleaseFormQueryRef, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $dfM7q.default));
    const loadCreateReleaseQuery = ()=>{
        if (!createReleaseFormQueryRef && accountId) loadQuery({
            accountId: accountId
        });
    };
    const onFooterClick = ()=>{
        experienceStart();
        loadCreateReleaseQuery();
    };
    const [, refetch] = (0, $iWLL0.useRefetchableFragment)((0, $5n2kr.default), fieldOptionsFragmentRef);
    const [suspenselessRefetch] = (0, $4bMJ9.useSuspenselessRefetch)((0, $bMEzK.default), refetch, {
        fetchPolicy: 'network-only'
    });
    const onSuccess = (version)=>{
        if (onChange && version.ari) {
            let currentValues = [];
            if (value) currentValues = Array.isArray(value) ? value : [
                value
            ];
            onChange([
                ...currentValues,
                {
                    id: version.ari,
                    versionId: version.id,
                    selectableLabel: version.name,
                    selectableGroupKey: null,
                    selectableIconUrl: null,
                    isDisabled: false
                }
            ], {
                action: 'select-option'
            });
            onReleaseCreation?.(version);
            suspenselessRefetch({
                id: fieldId
            });
        }
    };
    const Footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3d4a9c97b5e121f8$var$CreateReleaseVersionFooter, {
        "data-testid": "issue-field-release-versions-editview-full.ui.release-versions.create-release-version-footer",
        onClick: onFooterClick,
        onFocus: loadCreateReleaseQuery,
        onMouseOver: loadCreateReleaseQuery
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
        label: formatMessage((0, $gFuwP.default).createNewIcon),
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiMQP.OptionLabel), null, formatMessage((0, $gFuwP.default).createNewItem)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isDialogOpen && createReleaseFormQueryRef != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hbz7x.CreateReleaseModal), {
        queryReference: createReleaseFormQueryRef,
        onClose: ()=>setIsDialogOpen(false),
        projectId: projectId || String(issueProjectId),
        onReleaseCreation: onSuccess
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3OCmX.SelectableFieldEditViewWithFieldOptionsFragment), {
        ...restProps,
        fieldId: fieldId,
        onChange: onChange,
        value: value,
        footer: Footer,
        onFooterSelect: ()=>setIsDialogOpen(true),
        styles: (0, $fiMQP.selectFooterStyles),
        classNamePrefix: classNamePrefix,
        isMulti: isMulti,
        isClearable: isClearable,
        fieldOptionsFragmentRef: fieldOptionsFragmentRef,
        hasInfiniteScroll: false
    }));
};
const $3d4a9c97b5e121f8$export$c1d02fd25e1fc37b = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const formatGroupLabel = (group)=>{
        switch(group.label){
            case (0, $4Hwcq.versionStatus).RELEASED:
                return formatMessage((0, $gFuwP.default).releasedHeading);
            case (0, $4Hwcq.versionStatus).UNRELEASED:
                return formatMessage((0, $gFuwP.default).unreleasedHeading);
            default:
                return group.label;
        }
    };
    const Component = props.canCreateVersions ? $3d4a9c97b5e121f8$var$CreatableReleaseVersionsEditView : (0, $3OCmX.SelectableFieldEditViewWithFieldOptionsFragment);
    const suggestionsData = (0, $iWLL0.useLazyLoadQuery)((0, $5kgX6.default), {
        id: props.fieldId
    }, {
        fetchPolicy: 'store-only'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        ...props,
        formatGroupLabel: formatGroupLabel,
        classNamePrefix: props.classNamePrefix,
        fieldOptionsFragmentRef: suggestionsData,
        placeholder: formatMessage((0, $gFuwP.default).placeholder)
    });
};
const $3d4a9c97b5e121f8$export$7e81d0b6f6962f78 = ({ shouldShowFooter: shouldShowFooter, onCreateFooterSelect: onCreateFooterSelect, onCreateFooterFocus: onCreateFooterFocus, footer: footer, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const formatGroupLabel = (group)=>{
        switch(group.label){
            case (0, $4Hwcq.versionStatus).RELEASED:
                return formatMessage((0, $gFuwP.default).releasedHeading);
            case (0, $4Hwcq.versionStatus).UNRELEASED:
                return formatMessage((0, $gFuwP.default).unreleasedHeading);
            default:
                return group.label;
        }
    };
    const Footer = (0, $eUqFw.useMemo)(()=>{
        if (shouldShowFooter) {
            if (footer) return footer;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3d4a9c97b5e121f8$var$CreateReleaseVersionFooter, {
                "data-testid": "issue-field-release-versions-editview-full.ui.release-versions.create-release-version-footer",
                onClick: onCreateFooterSelect,
                onFocus: onCreateFooterFocus,
                onMouseOver: onCreateFooterFocus
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                label: formatMessage((0, $gFuwP.default).createNewIcon),
                size: "small"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiMQP.OptionLabel), null, formatMessage((0, $gFuwP.default).createNewItem)));
        }
    }, [
        formatMessage,
        shouldShowFooter,
        onCreateFooterSelect,
        onCreateFooterFocus,
        footer
    ]);
    const suggestionsData = (0, $iWLL0.useLazyLoadQuery)((0, $jMDIW.default), {
        id: props.fieldId
    }, {
        fetchPolicy: 'store-only'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3OCmX.SelectableFieldEditViewWithFieldOptionsFragment), {
        ...props,
        formatGroupLabel: formatGroupLabel,
        classNamePrefix: props.classNamePrefix,
        placeholder: formatMessage((0, $gFuwP.default).placeholder),
        styles: (0, $fiMQP.selectFooterStyles),
        footer: Footer,
        fieldOptionsFragmentRef: suggestionsData,
        hasInfiniteScroll: false
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3d4a9c97b5e121f8$var$CreateReleaseVersionFooter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $fiMQP.FooterContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11vwgxsz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jMDIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $65af99929bc113cc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc5f914ddeda3fa08df4b74e2644aeb3>>
 * @relayHash da7e5f7ead17c0a95af3b0f7dc52a037
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 128afec195e9ef2d35b1dae62e549291cf15ec32c36644aab6ee557f126a7c18
const $65af99929bc113cc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "releaseVersions_issueSelectableFieldQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "ui_issueSelectableFieldEditView_SelectableFieldEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "releaseVersions_issueSelectableFieldQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                }
                            ],
                            "type": "JiraIssueField",
                            "abstractKey": "__isJiraIssueField"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraSelectableValueConnection",
                                    "kind": "LinkedField",
                                    "name": "selectableValueOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSelectableValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableLabel"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableGroupKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableIconUrl"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDisabled"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "optionId"
                                                                }
                                                            ],
                                                            "type": "JiraOption"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "versionId"
                                                                }
                                                            ],
                                                            "type": "JiraVersion"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "selectableValueOptions(first:20,searchBy:\"\")"
                                },
                                {
                                    "args": v3 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "selectableValue_issueFieldEditviewFull_fieldOptions__selectableValueOptions",
                                    "kind": "LinkedHandle",
                                    "name": "selectableValueOptions"
                                }
                            ],
                            "type": "JiraHasSelectableValueOptions",
                            "abstractKey": "__isJiraHasSelectableValueOptions"
                        },
                        v4 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "128afec195e9ef2d35b1dae62e549291cf15ec32c36644aab6ee557f126a7c18",
            "metadata": {},
            "name": "releaseVersions_issueSelectableFieldQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$65af99929bc113cc$var$node.hash = "45b5f6a9d125088317d11ad5f17179d4";
var $65af99929bc113cc$export$2e2bcd8739ae039 = $65af99929bc113cc$var$node;

});

parcelRegister("5kgX6", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbf63181cc27fe0f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7f0a92286e46b0fd298d2faf6aa9cf7e>>
 * @relayHash 6dfc5664150f893f941130e1d433475b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e685f33d11ea690311bca7f0d9a53d4f2ceb4c5a5bd6916e4313564f74e29e5c
const $cbf63181cc27fe0f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "releaseVersionsEditViewFullFieldQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "ui_issueSelectableFieldEditView_SelectableFieldEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "releaseVersionsEditViewFullFieldQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                }
                            ],
                            "type": "JiraIssueField",
                            "abstractKey": "__isJiraIssueField"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraSelectableValueConnection",
                                    "kind": "LinkedField",
                                    "name": "selectableValueOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSelectableValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableLabel"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableGroupKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableIconUrl"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDisabled"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "optionId"
                                                                }
                                                            ],
                                                            "type": "JiraOption"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "versionId"
                                                                }
                                                            ],
                                                            "type": "JiraVersion"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "selectableValueOptions(first:20,searchBy:\"\")"
                                },
                                {
                                    "args": v3 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "selectableValue_issueFieldEditviewFull_fieldOptions__selectableValueOptions",
                                    "kind": "LinkedHandle",
                                    "name": "selectableValueOptions"
                                }
                            ],
                            "type": "JiraHasSelectableValueOptions",
                            "abstractKey": "__isJiraHasSelectableValueOptions"
                        },
                        v4 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "e685f33d11ea690311bca7f0d9a53d4f2ceb4c5a5bd6916e4313564f74e29e5c",
            "metadata": {},
            "name": "releaseVersionsEditViewFullFieldQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cbf63181cc27fe0f$var$node.hash = "e4fde9306f5268fc1a6acd99a90546f7";
var $cbf63181cc27fe0f$export$2e2bcd8739ae039 = $cbf63181cc27fe0f$var$node;

});

parcelRegister("dfM7q", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea18d7a2065f19b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b973f7193843497a07c1470c89d06f40>>
 * @relayHash 61fe91a04aa18abb03fb45259643fc02
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ba7f55b9606c6306f9ffee483513fccb037383f6a29e7aa236eb5cbac386518
const $0ea18d7a2065f19b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "createReleaseModalQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "createReleaseForm_softwareReleasesReleaseModalsRelay"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "user"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "createReleaseModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isUser"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7ba7f55b9606c6306f9ffee483513fccb037383f6a29e7aa236eb5cbac386518",
            "metadata": {},
            "name": "createReleaseModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0ea18d7a2065f19b$var$node.hash = "9f85087ab53fe21f6df07185269b323d";
var $0ea18d7a2065f19b$export$2e2bcd8739ae039 = $0ea18d7a2065f19b$var$node;

});

parcelRegister("hbz7x", function(module, exports) {

$parcel$export(module.exports, "CreateReleaseModal", () => $906fc6be338a9246$export$98347b760d62204c);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $1ybV0 = parcelRequire("1ybV0");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $906fc6be338a9246$var$LazyCreateReleaseModal = (0, $7rh0R.lazy)(()=>(parcelRequire("l7EFD")).then((module)=>module.CreateReleaseModal), {
    moduleId: "./src/packages/releases/release-modals-relay/src/ui/create-release-modal/index.tsx"
});
const $906fc6be338a9246$export$98347b760d62204c = ({ fallback: fallback = null, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "create-release-modal",
        fallback: (0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r') ? fallback : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($906fc6be338a9246$var$LazyCreateReleaseModal, props));

});
parcelRegister("l7EFD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('f0FhN')
        ]);
        const value = parcelRequire('jGGnN');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("f0FhN")
    ]).then(()=>parcelRequire('jGGnN'));
}

});


parcelRegister("4SZlZ", function(module, exports) {

$parcel$export(module.exports, "useCreateReleaseExperienceStart", () => $8752bd65d472c75c$export$137d6976ddfff3f4);
$parcel$export(module.exports, "useCreateReleaseExperienceFail", () => $8752bd65d472c75c$export$aeb23334e467d1ba);
$parcel$export(module.exports, "useCreateReleaseExperienceSuccess", () => $8752bd65d472c75c$export$af6b8a20eaaa829c);

var $4qhD6 = parcelRequire("4qhD6");
var $bDhRl = parcelRequire("bDhRl");
var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
const $8752bd65d472c75c$export$52919046b94109dc = 'createRelease';
const $8752bd65d472c75c$export$137d6976ddfff3f4 = (analyticsSource)=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return (0, $bDhRl.useExperienceStart)({
        experience: $8752bd65d472c75c$export$52919046b94109dc,
        experienceId: `${Date.now()}`,
        analyticsSource: analyticsSource,
        application: (0, $eIp1n.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $8752bd65d472c75c$export$aeb23334e467d1ba = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $8752bd65d472c75c$export$52919046b94109dc
    });
const $8752bd65d472c75c$export$af6b8a20eaaa829c = ()=>(0, $fDZ6r.useExperienceSuccess)({
        experience: $8752bd65d472c75c$export$52919046b94109dc
    });

});
parcelRegister("4qhD6", function(module, exports) {

$parcel$export(module.exports, "useExperienceFail", () => $2f159cb06c119de7$export$606da7704d8eaf06);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $JRB5w = parcelRequire("JRB5w");

var $gtrMw = parcelRequire("gtrMw");
const $2f159cb06c119de7$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $gtrMw.useExperienceContext)();
    const self = (0, $eUqFw.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $eUqFw.useCallback)((location, error, extraAttributes = {})=>{
        const { current: current } = self;
        // ignore client side errors from impacting experience metrics
        if ((0, $7rh0R.isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, $JRB5w.isClientFetchError)(error)) return;
        current.experienceTracker.fail({
            name: current.name,
            error: error,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                location: location
            }
        });
    }, [
        self
    ]);
};

});
parcelRegister("gtrMw", function(module, exports) {

$parcel$export(module.exports, "useExperienceContext", () => $b35642cd91fe7353$export$be8ec22ac9208049);

var $eUqFw = parcelRequire("eUqFw");

var $1xrmr = parcelRequire("1xrmr");
const $b35642cd91fe7353$export$be8ec22ac9208049 = ()=>{
    const context = (0, $eUqFw.useContext)((0, $1xrmr.ExperienceTrackerContext));
    return context;
};

});


parcelRegister("bDhRl", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $61606509e9879b1e$export$675e0d25df38d426);
$parcel$export(module.exports, "ExperienceStart", () => $61606509e9879b1e$export$f20b867e738a222c);

var $eUqFw = parcelRequire("eUqFw");

var $10fdS = parcelRequire("10fdS");

var $gtrMw = parcelRequire("gtrMw");
const $61606509e9879b1e$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect = ()=>undefined })=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const experienceTracker = (0, $gtrMw.useExperienceContext)();
    const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
    const self = (0, $eUqFw.useRef)({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        experienceTracker: experienceTracker,
        disableSli: disableSli,
        userLocation: userLocation,
        collect: collect
    });
    self.current.experienceId = experienceId;
    self.current.experience = experience;
    self.current.timeout = timeout;
    self.current.analyticsSource = analyticsSource;
    self.current.application = application;
    self.current.edition = edition;
    self.current.experienceTracker = experienceTracker;
    self.current.userLocation = userLocation;
    self.current.collect = collect;
    return (0, $eUqFw.useCallback)(()=>{
        const { current: current } = self;
        current.experienceTracker.start({
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            id: current.experienceId,
            name: current.experience,
            timeout: current.timeout,
            attributes: {
                analyticsSource: current.analyticsSource,
                experience: current.experience,
                experienceId: current.experienceId,
                application: current.application,
                edition: current.edition,
                disableSli: current.disableSli,
                userLocation: current.userLocation
            },
            collect: current.collect,
            onSuccess: ()=>undefined
        });
    }, [
        self
    ]);
};
const $61606509e9879b1e$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
    const onStart = $61606509e9879b1e$export$675e0d25df38d426({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        disableSli: disableSli,
        collect: collect
    });
    (0, $eUqFw.useMemo)(()=>{
        onStart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onStart,
        experienceId,
        experience,
        timeout,
        analyticsSource,
        application,
        edition,
        disableSli,
        collect
    ]);
    return null;
};

});

parcelRegister("fDZ6r", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", () => $62a77bba99475ca2$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "ExperienceSuccess", () => $62a77bba99475ca2$export$4962f3898bd5c829);

var $eUqFw = parcelRequire("eUqFw");

var $10fdS = parcelRequire("10fdS");

var $gtrMw = parcelRequire("gtrMw");
const $62a77bba99475ca2$var$STABLE_EMPTY_OBJECT = {};
const $62a77bba99475ca2$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $62a77bba99475ca2$var$STABLE_EMPTY_OBJECT })=>{
    const experienceTracker = (0, $gtrMw.useExperienceContext)();
    const route = (0, $10fdS.useCurrentRoute)();
    const self = (0, $eUqFw.useRef)({
        experience: experience,
        attributes: attributes,
        experienceTracker: experienceTracker,
        route: route
    });
    self.current.route = route;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    self.current.experience = experience;
    return (0, $eUqFw.useCallback)((extraAttributes = {})=>{
        const { current: current } = self;
        if (current.route && current.route.isRedirect === true) return;
        current.experienceTracker.succeed({
            name: current.experience,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};
const $62a77bba99475ca2$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $62a77bba99475ca2$var$STABLE_EMPTY_OBJECT })=>{
    const onExperienceSuccess = $62a77bba99475ca2$export$e94f0da4fc0603c6({
        experience: experience,
        attributes: attributes
    });
    (0, $eUqFw.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        attributes,
        onExperienceSuccess
    ]);
    (0, $eUqFw.useMemo)(()=>{}, [
        onExperienceSuccess
    ]);
    return null;
};

});


parcelRegister("gFuwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $53fddb8b033c1872$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $53fddb8b033c1872$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createNewIcon: {
        "id": "issue-field-release-versions-editview-full.release-versions.create-new-icon",
        "defaultMessage": "Create new version icon"
    },
    createNewItem: {
        "id": "issue-field-release-versions-editview-full.release-versions.create-new-item",
        "defaultMessage": "Create new version"
    },
    releasedHeading: {
        "id": "issue-field-release-versions-editview-full.release-versions.released-heading",
        "defaultMessage": "Released"
    },
    unreleasedHeading: {
        "id": "issue-field-release-versions-editview-full.release-versions.unreleased-heading",
        "defaultMessage": "Unreleased"
    },
    placeholder: {
        "id": "issue-field-release-versions-editview-full.release-versions.placeholder",
        "defaultMessage": "Select version"
    }
});

});


parcelRegister("2U8tE", function(module, exports) {

$parcel$export(module.exports, "useReleaseVersionsCache", () => $47f742c48b2cbaf3$export$8c45da8f2ba893a7);

var $g1vTA = parcelRequire("g1vTA");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $e8lGI = parcelRequire("e8lGI");

var $gUUjF = parcelRequire("gUUjF");

var $4Hwcq = parcelRequire("4Hwcq");
const $47f742c48b2cbaf3$export$8c8afb39d2208a1f = 5;
const $47f742c48b2cbaf3$export$8c45da8f2ba893a7 = (projectId, fieldId)=>{
    const [cachedReleaseVersions, setCachedReleaseVersions] = (0, $eUqFw.useState)([]);
    const environment = (0, $iWLL0.useRelayEnvironment)();
    /**
   * Get displayable cached versions. This function will return the cached versions
   * while only show the last MAX_CACHED_OPTIONS_SHOWN versions and reverse the order
   * to show the latest cached version at the top
   */ const getDisplayableCachedVersions = (0, $eUqFw.useCallback)(async ()=>{
        const cachedVersions = await (0, $e8lGI.default).getAll();
        const releaseVersions = cachedVersions.filter((version)=>Boolean(version.ari) && version.projectId === projectId);
        return releaseVersions.slice(-1 * $47f742c48b2cbaf3$export$8c8afb39d2208a1f).reverse();
    }, [
        projectId
    ]);
    /**
   * Refresh cached versions in against the server versions. This function will
   * make a request to the server to get the latest versions based on the cached
   * version ARIs in local state and update the cache accordingly.
   */ const refreshCachedVersions = (0, $eUqFw.useCallback)(async ()=>{
        if (!fieldId) return;
        try {
            const displayableCachedVersions = await getDisplayableCachedVersions();
            if (!displayableCachedVersions.length) return;
            const serverData = await (0, $iWLL0.fetchQuery)(environment, (0, $g1vTA.default), {
                id: fieldId,
                filterById: {
                    optionIds: displayableCachedVersions.map((version)=>version.ari).filter(Boolean),
                    operation: 'ALLOW'
                }
            }).toPromise();
            const serverVersions = serverData?.node?.selectableValueOptions?.edges || [];
            const refreshPromises = displayableCachedVersions.map(async (version)=>{
                const found = serverVersions.find((serverVersion)=>serverVersion?.node?.id === version.ari);
                if (!found) {
                    await (0, $e8lGI.default).remove(String(version.id));
                    return;
                }
                const serverVersionNode = found.node;
                if (!serverVersionNode || !serverVersionNode.id) return;
                const updatedCachedVersion = {
                    name: serverVersionNode.selectableLabel || '',
                    ari: serverVersionNode.id,
                    id: version.id || '',
                    released: serverVersionNode.selectableGroupKey === (0, $4Hwcq.versionStatus).RELEASED,
                    projectId: projectId
                };
                await (0, $e8lGI.default).update(String(version.id), updatedCachedVersion);
                return {
                    ...serverVersionNode,
                    selectableIconUrl: null,
                    versionId: version.id,
                    isDisabled: false
                };
            });
            const refreshedCachedVersions = await Promise.all(refreshPromises);
            setCachedReleaseVersions(refreshedCachedVersions.filter(Boolean));
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error during validating cached versions';
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-view.release-versions-cache-service.validateCachedVersions', errorMessage);
        }
    }, [
        projectId,
        environment,
        fieldId,
        getDisplayableCachedVersions
    ]);
    const getAllCachedVersions = (0, $eUqFw.useCallback)(async ()=>{
        try {
            const displayableCachedVersions = await getDisplayableCachedVersions();
            const transformedReleaseVersions = displayableCachedVersions.map((version)=>({
                    id: version.ari || '',
                    selectableLabel: version.name,
                    selectableGroupKey: version.released ? (0, $4Hwcq.versionStatus).RELEASED : (0, $4Hwcq.versionStatus).UNRELEASED,
                    selectableIconUrl: null,
                    versionId: version.id,
                    isDisabled: false
                }));
            setCachedReleaseVersions(transformedReleaseVersions);
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error during fetching cached versions';
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-view.release-versions-cache-service.getAll', errorMessage);
        }
    }, [
        setCachedReleaseVersions,
        getDisplayableCachedVersions
    ]);
    const addToCache = (0, $eUqFw.useCallback)(async (versions)=>{
        await Promise.all(versions.map(async (version)=>{
            try {
                if (!version.id || !version.versionId) return;
                await (0, $e8lGI.default).set(String(version.versionId), {
                    name: version.selectableLabel || '',
                    id: version.versionId,
                    ari: version.id,
                    released: version.selectableGroupKey === (0, $4Hwcq.versionStatus).RELEASED,
                    projectId: projectId
                });
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : 'Unknown error during adding versions to cache';
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-view.release-versions-cache-service.addToCache', errorMessage);
            }
        }));
        await getAllCachedVersions();
    }, [
        getAllCachedVersions,
        projectId
    ]);
    return [
        cachedReleaseVersions,
        {
            addToCache: addToCache,
            getAllCachedVersions: getAllCachedVersions,
            refreshCachedVersions: refreshCachedVersions
        }
    ];
};

});
parcelRegister("g1vTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $331d67543186044a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<df2ce88826d3a41bb38317b7a814f197>>
 * @relayHash a08f123b6b07a31b8073c836ee129767
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd2c823ad40c4cb156b67202af2c6b9e922cc488b39fcc33bb68f8a483471c2f
const $331d67543186044a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterById"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "filterById",
            "variableName": "filterById"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "selectableLabel"
    }, v7 = {
        "kind": "ScalarField",
        "name": "selectableGroupKey"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "releaseVersionsCacheServicesValidateQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraSelectableValueConnection",
                                    "kind": "LinkedField",
                                    "name": "selectableValueOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSelectableValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraHasSelectableValueOptions",
                            "abstractKey": "__isJiraHasSelectableValueOptions"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "releaseVersionsCacheServicesValidateQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraSelectableValueConnection",
                                    "kind": "LinkedField",
                                    "name": "selectableValueOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSelectableValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraHasSelectableValueOptions",
                            "abstractKey": "__isJiraHasSelectableValueOptions"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "cd2c823ad40c4cb156b67202af2c6b9e922cc488b39fcc33bb68f8a483471c2f",
            "metadata": {},
            "name": "releaseVersionsCacheServicesValidateQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$331d67543186044a$var$node.hash = "90a3fc305cc12cf7ee6fa89acc4448c0";
var $331d67543186044a$export$2e2bcd8739ae039 = $331d67543186044a$var$node;

});


parcelRegister("ats0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eaf84574882a541$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $fiMQP = parcelRequire("fiMQP");

var $18KtE = parcelRequire("18KtE");

var $hbz7x = parcelRequire("hbz7x");

var $2f2Xp = parcelRequire("2f2Xp");
const $8eaf84574882a541$export$5f1d715c3da4ade5 = 20;
const $8eaf84574882a541$export$5afacdde33fc0cb9 = (data, inputQueryStr)=>data.map((categoryData)=>({
            ...categoryData,
            items: categoryData.items.filter((x)=>x.content.toLowerCase().includes(inputQueryStr.toLowerCase()))// apply sort to ensure that exact matches are not sliced off
            .sort((a, b)=>Number(b.content.toLowerCase() === inputQueryStr.toLowerCase()) - Number(a.content.toLowerCase() === inputQueryStr.toLowerCase())).slice(0, $8eaf84574882a541$export$5f1d715c3da4ade5)
        }));
class $8eaf84574882a541$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    renderSelect(selectProps) {
        const { canAdministerProject: canAdministerProject, canAdministerJira: canAdministerJira, createNewItemMessage: createNewItemMessage } = this.props;
        const shouldShowFooter = canAdministerProject || canAdministerJira;
        const { data: data, loading: loading, error: error } = this.state;
        const initialData = {
            data: data,
            loading: loading,
            error: error
        };
        const createNewItemIconLabel = (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? {
            createNewItemIconLabel: this.props.createNewItemIconLabel
        } : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $18KtE.default), {
            ...selectProps,
            classNamePrefix: "issue-view-fix-versions",
            styles: (0, $fiMQP.selectFooterStyles),
            onInputChange: this.onInputChange,
            shouldShowFooter: shouldShowFooter,
            footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2f2Xp.CreateVersionButton), {
                createNewItemLabel: createNewItemMessage,
                onCreate: this.setQueryRef,
                ...createNewItemIconLabel
            }),
            onFooterSelect: this.openDialog,
            allowEmptyValue: true,
            optionValuesSafeForAnalytics: true,
            fetchSuggestions: this.fetchSuggestions,
            debounceFetchSuggestionsTime: 300,
            initialData: initialData,
            customEditView: this.props.customEditView
        });
    }
    render() {
        const { baseUrl: baseUrl, projectId: projectId, createNewItemMessage: createNewItemMessage, canAdministerProject: canAdministerProject, canAdministerJira: canAdministerJira, onVersionCreated: onVersionCreated, versionFieldIds: versionFieldIds, ...selectProps } = this.props;
        const { isDialogOpen: isDialogOpen, createReleaseModalQueryReference: createReleaseModalQueryReference } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isDialogOpen && createReleaseModalQueryReference != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hbz7x.CreateReleaseModal), {
            queryReference: createReleaseModalQueryReference,
            onClose: this.closeDialog,
            projectId: String(projectId),
            onReleaseCreation: this.onSuccess
        }), this.renderSelect(selectProps));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isDialogOpen: false,
            data: [],
            loading: false,
            error: false,
            inputQueryStr: '',
            createReleaseModalQueryReference: null
        };
        this.componentDidMount = ()=>{
            this.getDataFromCache();
        };
        this.getDataFromCache = ()=>{
            this.props.getDataFromCache?.().then((data)=>{
                this.setState({
                    data: data,
                    loading: false
                });
            });
        };
        this.fetchSuggestions = (query, sessionId)=>this.props.fetchSuggestions(query, sessionId).then((data)=>{
                const { inputQueryStr: inputQueryStr } = this.state;
                const filteredAndSlicedData = $8eaf84574882a541$export$5afacdde33fc0cb9(data, inputQueryStr);
                this.setState({
                    data: filteredAndSlicedData
                });
                return filteredAndSlicedData;
            });
        this.openDialog = ()=>{
            this.setState({
                isDialogOpen: true
            });
        };
        this.closeDialog = ()=>{
            this.setState({
                isDialogOpen: false
            });
        };
        this.setQueryRef = (queryRef)=>{
            this.setState({
                createReleaseModalQueryReference: queryRef
            });
        };
        this.onInputChange = (inputQueryStr)=>{
            this.setState({
                inputQueryStr: inputQueryStr
            });
        };
        this.onSuccess = (version)=>{
            const { onChange: onChange, value: value, onVersionCreated: onVersionCreated, versionFieldIds: versionFieldIds } = this.props;
            const versionARI = (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? {
                ari: version.ari
            } : {};
            // dispatch a change event which will add the new version to the list and focus the field again
            onChange([
                ...value,
                {
                    content: version.name,
                    value: version.id,
                    ...versionARI
                }
            ]);
            this.closeDialog();
            onVersionCreated(version, versionFieldIds);
        };
    }
}

});
parcelRegister("2f2Xp", function(module, exports) {

$parcel$export(module.exports, "CreateVersionButton", () => $5539b59543c950e4$export$4950e58c7f6a3cf);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $gO9Xw = parcelRequire("gO9Xw");

var $fiMQP = parcelRequire("fiMQP");

var $dfM7q = parcelRequire("dfM7q");

var $4SZlZ = parcelRequire("4SZlZ");

var $dxcfv = parcelRequire("dxcfv");
const $5539b59543c950e4$var$ISSUE_VIEW = 'issueView';
const $5539b59543c950e4$export$4950e58c7f6a3cf = ({ createNewItemLabel: createNewItemLabel, createNewItemIconLabel: createNewItemIconLabel, onCreate: onCreate })=>{
    const accountId = (0, $dxcfv.useAccountId)();
    const [createReleaseFormQueryRef, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $dfM7q.default));
    const experienceStart = (0, $4SZlZ.useCreateReleaseExperienceStart)($5539b59543c950e4$var$ISSUE_VIEW);
    const loadCreateReleaseQuery = ()=>{
        if (!createReleaseFormQueryRef && accountId) loadQuery({
            accountId: accountId
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiMQP.FooterContainer), {
        /* eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */ className: "issue-view__select-footer",
        onClick: ()=>{
            experienceStart();
            loadCreateReleaseQuery();
            onCreate(createReleaseFormQueryRef);
        },
        onFocus: loadCreateReleaseQuery,
        onMouseOver: loadCreateReleaseQuery
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
        label: createNewItemIconLabel || '',
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiMQP.OptionLabel), null, createNewItemLabel));
};

});


parcelRegister("5aUxM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a16bf9511b403a5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3a16bf9511b403a5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    successFlagCreation: {
        "id": "issue-view-base.context.versions-with-relay-edit-view.success-flag-creation",
        "defaultMessage": "{name} created."
    },
    createNewIcon: {
        "id": "issue-view-base.context.versions-with-relay-edit-view.create-new-icon",
        "defaultMessage": "Create new version icon"
    },
    createNewItem: {
        "id": "issue-view-base.context.versions-with-relay-edit-view.create-new-item",
        "defaultMessage": "Create new version"
    },
    recentVersions: {
        "id": "issue-view-base.context.versions-with-relay-edit-view.recent-versions",
        "defaultMessage": "Recent versions"
    }
});

});

parcelRegister("hXRWO", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $ec5927018b4070a5$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $ec5927018b4070a5$export$1cfcb95cb8fbddb3);
$parcel$export(module.exports, "transformRelayToReduxValue", () => $ec5927018b4070a5$export$5049f227693bb420);
$parcel$export(module.exports, "transformReduxToRelayValue", () => $ec5927018b4070a5$export$882a4e6f4273327b);

var $1ybV0 = parcelRequire("1ybV0");

var $7DBqv = parcelRequire("7DBqv");
const $ec5927018b4070a5$export$cb172b2468ab5652 = (value, { projectKey: projectKey, projectType: projectType, fieldId: fieldId })=>value ? value.map((version)=>({
            value: version.id,
            content: version.name || '',
            href: (0, $7DBqv.getVersionUrl)({
                version: version,
                fieldId: fieldId,
                projectKey: projectKey,
                projectType: projectType
            }),
            ari: version.ari
        })) : [];
const $ec5927018b4070a5$export$1cfcb95cb8fbddb3 = (value)=>value && value.map((item)=>({
            name: item.content,
            id: String(item.value),
            ari: item.ari
        }));
const $ec5927018b4070a5$export$5049f227693bb420 = (option)=>{
    if (!(0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') && 'label' in option) return {
        value: option.versionId ?? '',
        label: option.label,
        content: option.label,
        ari: option.value
    };
    return {
        value: option.versionId ?? '',
        label: option.selectableLabel ?? '',
        content: option.selectableLabel ?? '',
        ari: option.id
    };
};
const $ec5927018b4070a5$export$882a4e6f4273327b = (option)=>({
        versionId: String(option.value),
        selectableLabel: option.content || '',
        selectableGroupKey: null,
        selectableIconUrl: null,
        id: option.ari || ''
    });

});
parcelRegister("7DBqv", function(module, exports) {

$parcel$export(module.exports, "getVersionUrl", () => $612b3e424371ab16$export$f6b360c59c43e332);
$parcel$export(module.exports, "sortOptions", () => $612b3e424371ab16$export$2ecc3309bc48a1e0);

var $7ZZxN = parcelRequire("7ZZxN");

var $8g5hT = parcelRequire("8g5hT");

var $f9RL0 = parcelRequire("f9RL0");
// JQL search keys don't actually match the field keys
const $612b3e424371ab16$var$fieldKeyToJQLMap = {
    [(0, $f9RL0.AFFECTS_VERSIONS)]: 'affectedVersion',
    [(0, $f9RL0.FIX_VERSIONS)]: 'fixVersion'
};
// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly versions: "affectedVersion"; readonly fixVersions: "fixVersion"; }'.
const $612b3e424371ab16$var$getJqlKey = (fieldKey)=>$612b3e424371ab16$var$fieldKeyToJQLMap[fieldKey] || 'fixVersion';
const $612b3e424371ab16$export$f6b360c59c43e332 = ({ version: version, fieldId: fieldId, projectKey: projectKey, projectType: projectType })=>{
    if (// Version details page is only available in Software projects.
    projectType === (0, $7ZZxN.SOFTWARE_PROJECT) && // Version details page only shows issues that are *fixed* in a version, not those that *affect* it.
    // Therefore it only makes sense to link to the version details page from the fix version field.
    fieldId === (0, $f9RL0.FIX_VERSIONS)) return `/projects/${projectKey}/versions/${version.id}/tab/release-report-all-issues`;
    // Use an issue search URL as a fallback for cases where the version details page doesn't make sense.
    const jql = `project = ${(0, $8g5hT.toQuotedString)(projectKey)} AND ${$612b3e424371ab16$var$getJqlKey(fieldId)} = ${(0, $8g5hT.toQuotedString)(version.name)}`;
    return (0, $8g5hT.createIssuesUrl)(jql);
};
const $612b3e424371ab16$var$sortOrder = [
    'RECENT',
    'UNRELEASED',
    'RELEASED'
];
const $612b3e424371ab16$export$2ecc3309bc48a1e0 = (options)=>options.sort((a, b)=>$612b3e424371ab16$var$sortOrder.indexOf(a?.selectableGroupKey || '') - $612b3e424371ab16$var$sortOrder.indexOf(b?.selectableGroupKey || ''));

});



parcelRegister("hfza4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d596ce8c602e5a2$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $e8lGI = parcelRequire("e8lGI");

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");

var $ats0p = parcelRequire("ats0p");

var $huhk2 = parcelRequire("huhk2");

var $hHKWU = parcelRequire("hHKWU");

var $3uwfp = parcelRequire("3uwfp");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $6KjC3 = parcelRequire("6KjC3");

var $jMP2a = parcelRequire("jMP2a");

var $1TrR5 = parcelRequire("1TrR5");

var $kBz7C = parcelRequire("kBz7C");

var $i2n5C = parcelRequire("i2n5C");

var $lUYNo = parcelRequire("lUYNo");
const $1d596ce8c602e5a2$var$rankVersions = (0, $5iWql.default)((versionFieldId, suggestion, issueId, projectId, sessionId, createAnalyticsEvent)=>(0, $i2n5C.default)(versionFieldId, suggestion, issueId, projectId, sessionId, createAnalyticsEvent));
const $1d596ce8c602e5a2$var$fetchSuggestionsFactory = (0, $5iWql.default)((suggestions, intl, versionFieldId, issueId, projectId, createAnalyticsEvent)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (query, sessionId)=>{
        const dataFromServer = $1d596ce8c602e5a2$var$rankVersions(versionFieldId, suggestions, issueId, projectId, sessionId, createAnalyticsEvent);
        return Promise.all([
            dataFromServer,
            (0, $e8lGI.default).refresh()
        ]).then(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        async ([dataFromAPI, cache])=>(0, $lUYNo.transformSuggestionsFromServerAndCache)(dataFromAPI, cache, intl, projectId));
    });
const $1d596ce8c602e5a2$var$saveField = (// @ts-expect-error - TS7031 - Binding element 'baseUrl' implicitly has an 'any' type. | TS7031 - Binding element 'issueKey' implicitly has an 'any' type. | TS7031 - Binding element 'fieldMetaKey' implicitly has an 'any' type. | TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'fieldEditSessionId' implicitly has an 'any' type.
{ baseUrl: baseUrl, issueKey: issueKey, fieldMetaKey: fieldMetaKey, value: value, fieldEditSessionId: fieldEditSessionId }, // @ts-expect-error - TS2304 - Cannot find name 'State'.
state, // @ts-expect-error - TS7006 - Parameter 'ownPropsOnMount' implicitly has an 'any' type.
ownPropsOnMount)=>{
    const url = fieldEditSessionId !== undefined ? `${baseUrl}/rest/api/2/issue/${issueKey}?fieldEditSessionId=${fieldEditSessionId}` : `${baseUrl}/rest/api/2/issue/${issueKey}`;
    const projectId = (0, $jZDJX.projectIdSelector)(state);
    // @ts-expect-error - TS7006 - Parameter 'current' implicitly has an 'any' type.
    value.forEach((current)=>{
        try {
            if (ownPropsOnMount.createAnalyticsEvent) (0, $jMP2a.fireOperationalAnalytics)(ownPropsOnMount.createAnalyticsEvent({}), 'versionPickerCache set', {
                isFromCache: current.fromCache
            });
            current.id && (0, $e8lGI.default).set(`${current.id}`, {
                ...current,
                projectId: projectId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-view.versions.cache.set', error.message);
        }
    });
    return (0, $lRmyA.performPutRequest)(url, {
        body: JSON.stringify({
            fields: {
                [fieldMetaKey]: value
            }
        })
    }).catch((error)=>{
        // @ts-expect-error - TS7006 - Parameter 'current' implicitly has an 'any' type.
        value.forEach((current)=>{
            try {
                if (ownPropsOnMount.createAnalyticsEvent) (0, $jMP2a.fireOperationalAnalytics)(ownPropsOnMount.createAnalyticsEvent({}), 'versionPickerCache removed');
                current.id && (0, $e8lGI.default).remove(`${current.id}`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-view.versions.cache.remove', e.message);
            }
        });
        throw error;
    });
};
const $1d596ce8c602e5a2$var$additionalCallbacksFactory = (0, $5iWql.default)((dispatch)=>({
        onVersionCreated: (version, versionFieldIds)=>{
            versionFieldIds.forEach((fieldId)=>{
                dispatch((0, $6KjC3.fieldAddAllowedValues)(fieldId, [
                    version
                ]));
            });
        }
    }));
var $1d596ce8c602e5a2$export$2e2bcd8739ae039 = (0, $3uwfp.default)((stateOnMount, ownPropsOnMount)=>{
    const onTagClick = (analyticEvent)=>(0, $jMP2a.fireUIAnalytics)(analyticEvent, {
            name: ownPropsOnMount.fieldId
        });
    // use memoized factory in the absence of redux-thunk
    const getDataFromCacheFactory = (0, $5iWql.default)((projectId)=>()=>(0, $e8lGI.default).getAll().then((versions)=>(0, $lUYNo.transformSuggestionsFromServerAndCache)([], versions, ownPropsOnMount.intl, projectId)));
    return {
        fieldId: ownPropsOnMount.fieldId,
        transformFromStateValue: $lUYNo.transformFromStateValueWithVersionLink,
        transformToStateValue: $lUYNo.transformToStateValue,
        additionalProps: (state, intl)=>({
                fetchSuggestions: $1d596ce8c602e5a2$var$fetchSuggestionsFactory((0, $fokFV.fieldAllowedValuesSelector)(ownPropsOnMount.fieldId)(state), intl, ownPropsOnMount.fieldId, (0, $5JqpU.issueIdSelector)(state), (0, $jZDJX.projectIdSelector)(state), ownPropsOnMount.createAnalyticsEvent),
                canAdministerProject: (0, $9F6MO.canAdministerProjectPermissionsSelector)(state),
                canAdministerJira: (0, $9F6MO.canAdministerJiraPermissionsSelector)(state),
                createNewItemMessage: intl.formatMessage((0, $kBz7C.default).createNewItem),
                baseUrl: (0, $5JqpU.baseUrlSelector)(state),
                projectId: (0, $jZDJX.projectIdSelector)(state),
                isMobile: (0, $5JqpU.isMobileSelector)(state),
                placeholder: intl.formatMessage((0, $huhk2.genericMessages).version_no_value_placeholder),
                noValueText: intl.formatMessage((0, $huhk2.genericMessages).noValue),
                // Passing these in so we can use them in `onVersionCreated` down below.
                // There appears to be no way to reference them directly in the 'onVersionCreated' method
                versionFieldIds: (0, $fokFV.getVersionsFieldIds)(state),
                onTagClick: onTagClick,
                showPinButton: (0, $hHKWU.default)(ownPropsOnMount.area),
                getDataFromCache: getDataFromCacheFactory((0, $jZDJX.projectIdSelector)(state))
            }),
        // @ts-expect-error - TS2345 - Property 'clear' is missing in type '(this: any, dispatch: any)
        additionalCallbacks: (0, $1TrR5.functionWithFFRedux)($1d596ce8c602e5a2$var$additionalCallbacksFactory, (dispatch)=>({
                onVersionCreated: (version, versionFieldIds)=>{
                    versionFieldIds.forEach((fieldId)=>{
                        dispatch((0, $6KjC3.fieldAddAllowedValues)(fieldId, [
                            version
                        ]));
                    });
                }
            })),
        // @ts-expect-error - TS2345 - Argument of type 'SaveFieldArguments<unknown>' is not assignable to parameter of type '{ baseUrl: any; issueKey: any; fieldMetaKey: any; value: any; fieldEditSessionId: any; }'.
        saveField: (...args)=>$1d596ce8c602e5a2$var$saveField(...args, ownPropsOnMount)
    };
})((0, $ats0p.default));

});
parcelRegister("i2n5C", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cf19da9cf18a5a8$export$2e2bcd8739ae039);

var $63BlZ = parcelRequire("63BlZ");
var /*
 * Rank list of versions by calling Field recommendations service
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$6cf19da9cf18a5a8$export$2e2bcd8739ae039 = (fieldId, versions, issueId, projectId, sessionId, createAnalyticsEvent)=>(0, $63BlZ.default)(fieldId, versions, issueId, projectId, sessionId, createAnalyticsEvent);

});


parcelRegister("fOQE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a502962f6ffcbc9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kCtRS = parcelRequire("kCtRS");

var $hHKWU = parcelRequire("hHKWU");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2a502962f6ffcbc9$export$2e2bcd8739ae039 = ({ area: area, fieldId: fieldId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCtRS.AsyncChatAppCommunicationTool), {
        showPinButton: (0, $hHKWU.default)(area),
        fieldId: fieldId,
        type: "zoom"
    });

});
parcelRegister("kCtRS", function(module, exports) {

$parcel$export(module.exports, "AsyncChatAppCommunicationTool", () => $a5d224266cf8c8a6$export$287a9db69415ef52);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a5d224266cf8c8a6$var$LazyChatAppCommunicationTool = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("ghGCI")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/incident-management/issue-view/chatops-app/src/ui/index.tsx"
});
const $a5d224266cf8c8a6$export$287a9db69415ef52 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "servicedesk-incident-management-chat-app-communication-tool",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a5d224266cf8c8a6$var$LazyChatAppCommunicationTool, props));

});
parcelRegister("ghGCI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('beCu7');
        const value = parcelRequire('lEaXE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("beCu7").then(()=>parcelRequire('lEaXE'));
}

});



parcelRegister("2XDqb", function(module, exports) {

$parcel$export(module.exports, "AssetsPanel", () => $321101720039f29b$export$9e20a0d47647deca);
$parcel$export(module.exports, "AssetsOnboarding", () => $321101720039f29b$export$b9d18f0aea836100);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $fXhZS = parcelRequire("fXhZS");

const $321101720039f29b$var$LazyAssetsPanel = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("jYqLH")), {
    moduleId: "./src/packages/issue/issue-view-base/src/context/assets-panel/assets-panel-view.tsx"
});

const $321101720039f29b$var$LazyAssetsOnboarding = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("1setl")), {
    moduleId: "./src/packages/issue/issue-view-base/src/context/assets-onboarding/assets-onboarding-view.tsx"
});
const $321101720039f29b$export$9e20a0d47647deca = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fXhZS.Boundary), {
        id: "assets-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($321101720039f29b$var$LazyAssetsPanel, props));
const $321101720039f29b$export$b9d18f0aea836100 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fXhZS.Boundary), {
        id: "assets-onboarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($321101720039f29b$var$LazyAssetsOnboarding, props));

});
parcelRegister("jYqLH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4e1st');
        const value = parcelRequire('3fpVp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4e1st").then(()=>parcelRequire('3fpVp'));
}

});

parcelRegister("1setl", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2iyEc');
        const value = parcelRequire('9pQSR');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2iyEc").then(()=>parcelRequire('9pQSR'));
}

});



parcelRegister("7ahhR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0fccf087babaa0e$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5iWql = parcelRequire("5iWql");

var $c9TLT = parcelRequire("c9TLT");

var $gUUjF = parcelRequire("gUUjF");

var $hJ992 = parcelRequire("hJ992");

var $cSEXi = parcelRequire("cSEXi");

var $9alas = parcelRequire("9alas");
var $hzhuB = parcelRequire("hzhuB");

var $h3mHU = parcelRequire("h3mHU");

var $8ApTi = parcelRequire("8ApTi");

var $jCici = parcelRequire("jCici");

var $cUA2o = parcelRequire("cUA2o");

var $77s9Q = parcelRequire("77s9Q");
class $b0fccf087babaa0e$export$8689d3888980b1f3 extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'SidePanel';
    }
    constructor(props){
        super(props);
        this.state = {
            styles: {
                panelWidth: 0,
                headerWidth: 0,
                contentWidth: 0,
                contextWidth: 0,
                panelTop: 0,
                panelHeight: 0
            }
        };
        // panel's scroll parent. Can be page, modal etc.
        this.scrollContainerCached = null;
        this.scrollContainerResizeObserver = $parcel$global && $parcel$global.ResizeObserver ? new window.ResizeObserver(()=>{
            requestAnimationFrame(()=>{
                this.updateSidePanelStyles();
            });
        }) : null;
        this.getMemoizedStyles = (0, $5iWql.default)((panelWidth, panelTop, panelHeight, headerWidth, contentWidth, contextWidth)=>({
                panelWidth: panelWidth,
                panelTop: panelTop,
                panelHeight: panelHeight,
                headerWidth: headerWidth,
                contentWidth: contentWidth,
                contextWidth: contextWidth
            }));
        this.currentPosition = {
            panelWidth: undefined,
            headerWidth: undefined,
            contentWidth: undefined,
            contextWidth: undefined,
            panelTop: undefined,
            panelHeight: undefined
        };
        this.updateSidePanelStyles = ()=>{
            if (!this.props || !this.props.isOpen) return;
            const { refs: refs } = this.props;
            const panelColumnHeader = document.getElementById((0, $cSEXi.ELID_ISSUE_HEADER_ACTIONS));
            // Content
            const panelColumn = refs.refPanelColumnElement;
            const panelColumnStyle = panelColumn && getComputedStyle(panelColumn);
            const contextWidth = (0, $77s9Q.getContextWidth)(refs);
            const contentWidth = (0, $77s9Q.getContentWidth)(refs, panelColumnStyle);
            const headerWidth = (0, $77s9Q.getHeaderWidth)(panelColumnHeader, contentWidth);
            // Panel
            const panelPos = this.calculateSidePanelPosition();
            const panelWidth = (0, $77s9Q.getPanelWidth)(refs, panelColumnStyle);
            const panelTop = panelPos && panelPos.panelTop ? panelPos.panelTop : undefined;
            const panelHeight = panelPos && panelPos.panelHeight ? panelPos.panelHeight : undefined;
            const styles = this.getMemoizedStyles(panelWidth, panelTop, panelHeight, headerWidth, contentWidth, contextWidth);
            if (styles !== this.state.styles) {
                this.setState({
                    styles: styles
                });
                this.setSidePanelPosition(panelPos);
            }
        };
        this.getGlanceOffsetTop = (scrollContainer)=>{
            if (!scrollContainer) return undefined;
            const scrollContainerTop = scrollContainer.getBoundingClientRect().top;
            let issueHeaderBottom = (0, $jCici.EXTRA_GLANCE_PANEL_OFFSET); // bottom relative to scrollContainer
            const issueHeaderElement = document.getElementById((0, $cSEXi.ELID_ISSUE_HEADER_ACTIONS)) || document.getElementById((0, $cSEXi.ELID_ISSUE_HEADER));
            /* On scrolling, header will stay in 'sticky' position, so we need to show panel below the header.
             In modal, scrollContainer is actually just an issue body for modal, so header is outside of scrollContainer there */ if (issueHeaderElement && scrollContainer.contains(issueHeaderElement)) {
                /**
       * In case getBoundingClientRect returns incorrect value, during resize,
       * with changeboarding panel at the top, we can use container top value
       * as a fallback.
       */ const layoutContainer = this.props.refs.refLayoutContainer;
                const layoutContainerTop = layoutContainer ? layoutContainer.getBoundingClientRect().top : 0;
                const headerElementRect = issueHeaderElement.getBoundingClientRect();
                const bottomPosition = headerElementRect && headerElementRect.bottom < 0 ? layoutContainerTop + headerElementRect.height : headerElementRect.bottom;
                issueHeaderBottom = bottomPosition + (0, $jCici.EXTRA_GLANCE_PANEL_OFFSET) - scrollContainerTop;
            }
            // In IE11 position:sticky of the header becomes position: relative, therefore header can be scrolled to be "above" the viewport
            issueHeaderBottom = Math.max(issueHeaderBottom, (0, $jCici.EXTRA_GLANCE_PANEL_OFFSET));
            return issueHeaderBottom;
        };
        this.setSidePanelPosition = (position)=>{
            if (!position) return;
            const { panelTop: panelTop, panelHeight: panelHeight } = position;
            if (this.currentPosition.panelTop !== panelTop && this.refFixedPanel.current) {
                this.currentPosition.panelTop = panelTop;
                this.refFixedPanel.current.style.top = panelTop != null ? `${panelTop}px` : ''; // this executes in 0.1-0.16ms instead of 14-17ms for .setState() (which will become bigger the more fields we have in context tab, because it causes extra call of all React lifecycle methods). Faster time is very important for changes on scroll - to achieve smooth scrolling.
            }
            if (this.currentPosition.panelHeight !== panelHeight && this.refPanelPositioner.current) {
                this.currentPosition.panelHeight = panelHeight;
                this.refPanelPositioner.current.style.height = panelHeight != null ? `${panelHeight}px` : '';
            }
        };
        this.calculateSidePanelPosition = ()=>{
            const scrollContainer = this.getScrollContainer();
            // scrollContainerHeight must not include scrollbar height - so that panel is not shown on top of the scrollbar
            const scrollContainerInnerHeight = (0, $9alas.getInnerHeight)(scrollContainer);
            if (scrollContainer === null || scrollContainerInnerHeight === null) return undefined;
            // min(window.innerHeight, ...) is needed e.g. for mobile issue view
            const scrollContainerHeight = Math.min(window.innerHeight, scrollContainerInnerHeight || 0);
            const panelOffsetTop = this.getGlanceOffsetTop(scrollContainer) || 0;
            /*
            Note: because mobile has a page wrapper (id="inner-container") with `transfrom:` applied - ANY child `position: fixed` element (including glance panel) behaves like `position: absolute`.
            https://stackoverflow.com/questions/36855473/position-fixed-not-working-is-working-like-absolute/36857029
          */ const panelTop = panelOffsetTop + scrollContainer.getBoundingClientRect().top;
            const panelHeight = Math.max(scrollContainerHeight - panelTop, scrollContainerHeight - panelOffsetTop);
            if (panelHeight <= 0) (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $jCici.LOG_LOCATION), `panel height is <= 0: panelHeight='${panelHeight}`, new Error('panel height is <= 0'));
            return {
                panelTop: panelTop,
                panelHeight: panelHeight < 0 ? undefined : panelHeight
            };
        };
        this.updateSidePanelPosition = ()=>{
            // not to calculate on scroll when glance panel is closed for example - not to slow down page scroll, even if it is only for 1-4ms
            if (!this.props.isOpen) return;
            requestAnimationFrame(()=>{
                const newPosition = this.calculateSidePanelPosition();
                this.setSidePanelPosition(newPosition);
            });
        };
        this.refPanelPositioner = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.refFixedPanel = /*#__PURE__*/ (0, $eUqFw.createRef)();
    }
    componentDidMount() {
        // Update side Panel Styles also calls setSidePanelPosition
        this.updateSidePanelStyles();
        this.attachSidePanelListeners();
        // ResizeObserver
        if (this.props && this.props.refs && this.scrollContainerResizeObserver) {
            if (this.props.refs.refLayoutContainer) this.scrollContainerResizeObserver.observe(this.props.refs.refLayoutContainer);
            if (this.props.refs.refPanelColumnElement) this.scrollContainerResizeObserver.observe(this.props.refs.refPanelColumnElement);
        }
    }
    componentDidUpdate(prevProps) {
        // On panel open
        if (this.props.isOpen && this.props.isOpen !== prevProps.isOpen) this.updateSidePanelStyles();
        // Update ResizeObserver
        if (this.scrollContainerResizeObserver) {
            const { refs: { refPanelColumnElement: newRefPanelColumnElement, refLayoutContainer: newRefLayoutContainer } } = this.props;
            const { refs: { refPanelColumnElement: oldRefPanelColumnElement, refLayoutContainer: oldRefLayoutContainer } } = prevProps;
            // Make sure column and layout resizes are observed, in case the component
            // is mounted in a compact mode and one or the other is not passed in.
            if (newRefPanelColumnElement) this.scrollContainerResizeObserver.observe(newRefPanelColumnElement);
            if (newRefLayoutContainer) this.scrollContainerResizeObserver.observe(newRefLayoutContainer);
            if (newRefPanelColumnElement !== oldRefPanelColumnElement || newRefLayoutContainer !== oldRefLayoutContainer) {
                if (oldRefPanelColumnElement && this.scrollContainerResizeObserver) this.scrollContainerResizeObserver.unobserve(oldRefPanelColumnElement);
                if (oldRefLayoutContainer && this.scrollContainerResizeObserver) this.scrollContainerResizeObserver.unobserve(oldRefLayoutContainer);
                // Update styles if Scroll Container has changed
                this.detachSidePanelListeners();
                this.updateSidePanelPosition();
                this.attachSidePanelListeners();
            }
        }
    }
    componentWillUnmount() {
        this.detachSidePanelListeners();
        if (this.scrollContainerResizeObserver) this.scrollContainerResizeObserver.disconnect();
    }
    getScrollContainer() {
        if (this.props.refs.refSidePanelContainerElement) return this.props.refs.refSidePanelContainerElement;
        if (!this.scrollContainerCached) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        this.scrollContainerCached = (0, $hzhuB.getScrollParent)(this.refPanelPositioner.current, false);
        return this.scrollContainerCached;
    }
    getSidePanelListenerNode() {
        const scrollContainer = this.getScrollContainer();
        if (!scrollContainer) return;
        return scrollContainer === document.body ? document : scrollContainer;
    }
    attachSidePanelListeners() {
        this.getSidePanelListenerNode()?.addEventListener('scroll', this.updateSidePanelPosition);
    }
    detachSidePanelListeners() {
        this.getSidePanelListenerNode()?.removeEventListener('scroll', this.updateSidePanelPosition);
    }
    render() {
        const { isOpen: isOpen, isModal: isModal, children: children } = this.props;
        const { styles: styles } = this.state;
        const classyAnimatorWidth = styles.panelWidth ? styles.panelWidth : (styles.contextWidth || 0) + (0, $c9TLT.gridSize);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ApTi.default), {
            ref: this.refPanelPositioner,
            width: classyAnimatorWidth,
            show: isOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUA2o.Container), {
            "data-testid": "issue-view-base.context.side-panel.container",
            isModal: isModal,
            ref: this.refFixedPanel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0fccf087babaa0e$var$ContainerInner, null, children(styles))));
    }
}
const $b0fccf087babaa0e$export$c6f7de1916b295c6 = ({ isOpen: isOpen, ...rest })=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const isModal = (0, $hJ992.useIsModal)();
    // We perform the expensive animation calculations before TTI only on user interaction
    if (!isOpen && !isReady) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0fccf087babaa0e$export$8689d3888980b1f3, {
        isOpen: isOpen,
        isModal: isModal,
        ...rest
    });
};
var $b0fccf087babaa0e$export$2e2bcd8739ae039 = $b0fccf087babaa0e$export$c6f7de1916b295c6;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0fccf087babaa0e$var$ContainerInner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4t3i1osq _19bvu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9alas", function(module, exports) {

$parcel$export(module.exports, "getInnerHeight", () => $3536f62fd30be276$export$5a2da8cd883b1f88);
/**
 *  Analog of $(element).innerHeight()
 *  This function will still works if [adding is set in % in css, because getComputedStyle() always returns value in pixels
 */ const $3536f62fd30be276$export$5a2da8cd883b1f88 = (element)=>{
    if (!element) return undefined;
    const elementStyle = getComputedStyle(element);
    const elementPadding = (parseFloat(elementStyle.paddingTop) || 0) + (parseFloat(elementStyle.paddingBottom) || 0);
    return element.clientHeight - elementPadding; // Doing this instead of .getComputedStyle().height; to make it work for both 'box-sizing: content-box' and 'border-box'. .clientHeight excludes  horizontal scrollbars height which is good
};

});

parcelRegister("h3mHU", function(module, exports) {

$parcel$export(module.exports, "useSpaStatePageReady", () => $76cb153a8803a558$export$ea2491906b753456);
$parcel$export(module.exports, "SpaStatePageReady", () => $76cb153a8803a558$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $76cb153a8803a558$export$41e70078eeddaddc);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");

var $3viaK = parcelRequire("3viaK");

var $lcJyp = parcelRequire("lcJyp");

var $cfLkw = parcelRequire("cfLkw");
const $76cb153a8803a558$export$e6897aa59ee7aee5 = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    return {
        isReady: appIds.length ? appIds.every((id)=>apps[id].endTime || apps[id].timeoutTime) : false
    };
};
const $76cb153a8803a558$export$ea2491906b753456 = (0, $ggKAj.createHook)((0, $cfLkw.default), {
    selector: $76cb153a8803a558$export$e6897aa59ee7aee5
});
const $76cb153a8803a558$export$c34439f945fccbdf = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: setAppReady
        }));
const $76cb153a8803a558$export$41e70078eeddaddc = ({ comparer: comparer })=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: setAppReady,
            args: comparer
        }));

});

parcelRegister("8ApTi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5977ffb9157b8358$export$2e2bcd8739ae039);
/* classy-animator.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");
const $5977ffb9157b8358$var$ClassyAnimator = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // @ts-expect-error - TS2322: Property 'align' is missing in type 'HTMLElement' but required in type 'HTMLDivElement'.
        ref: ref,
        /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: {
            "--_1vp45zu": (0, $9t7rW.default)(props.show ? props.width : 0, "px"),
            "--_14nmwu5": (0, $9t7rW.default)(typeof props.height === 'number' ? `${props.height}px` : 'auto'),
            "--_rvpvc6": (0, $9t7rW.default)(props.show ? 'width 0.5s cubic-bezier(0.15, 1, 0.3, 1)' : 'width 0.5s cubic-bezier(0.15, 1, 0.3, 1), opacity 0, 0.5s, visibility 0, 0.5s'),
            "--_16gl462": (0, $9t7rW.default)(props.show ? 1 : 0),
            "--_oydxcm": (0, $9t7rW.default)(props.show ? 'visible' : 'hidden')
        },
        /* eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */ className: (0, $7JEyt.default)([
            "_kqswstnw _1xi2idpf _154iidpf _1bsbb5ls _4t3i10op _v564fa9t _1reo15vq _18m915vq _tzy41rex _3um010df"
        ])
    }, props.children));
var $5977ffb9157b8358$export$2e2bcd8739ae039 = $5977ffb9157b8358$var$ClassyAnimator;

});

parcelRegister("jCici", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $f089f4e8e176598b$export$25a759e49d5049db);
$parcel$export(module.exports, "EXTRA_GLANCE_PANEL_OFFSET", () => $f089f4e8e176598b$export$e1569567e2e8cc36);

var $fPlP8 = parcelRequire("fPlP8");
const $f089f4e8e176598b$export$25a759e49d5049db = 'issue.views.issue-base.context.side-panel';
const $f089f4e8e176598b$export$e1569567e2e8cc36 = (0, $fPlP8.ISSUE_HEADER_SHADOW_HEIGHT) * 2; // second shadow is applied to panel header on focus

});

parcelRegister("cUA2o", function(module, exports) {

$parcel$export(module.exports, "Container", () => $1135535c3fd2a0f2$export$42a852a2b6b56249);
$parcel$export(module.exports, "HeaderBreadcrumb", () => $1135535c3fd2a0f2$export$f836de4f99592497);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $1135535c3fd2a0f2$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, top: top, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_i8cyql": (0, $9t7rW.default)(__cmplp.top, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1kw7 _4t3i1kw7 _tzy4kb7n _bfhkvuon _1e0c1txw _2lx21bp4 _1reo15vq _18m915vq",
            __cmplp.isModal !== undefined && __cmplp.isModal !== false ? "_kqswpfqs" : "_kqsw1n9t",
            __cmplp.top != null ? "_154i1fr9" : "_154i1wug",
            __cmplp.className
        ])
    });
});
const $1135535c3fd2a0f2$export$f836de4f99592497 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s _16jlkb7n _1o9zkb7n _i0dlf1ug _4t3i1ul9 _18s85axq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("77s9Q", function(module, exports) {

$parcel$export(module.exports, "getPanelWidth", () => $38a5d362bc8caa35$export$7c83e6f5bcf776d5);
$parcel$export(module.exports, "getContentWidth", () => $38a5d362bc8caa35$export$f61abf052f87399f);
$parcel$export(module.exports, "getHeaderWidth", () => $38a5d362bc8caa35$export$134d8f4885c418ba);
$parcel$export(module.exports, "getContextWidth", () => $38a5d362bc8caa35$export$3bf8db4cba100062);

var $fPlP8 = parcelRequire("fPlP8");
const $38a5d362bc8caa35$export$7c83e6f5bcf776d5 = (refs, panelColumnStyle)=>{
    const sidePanelContainer = refs.refSidePanelContainerElement;
    if (!sidePanelContainer || !(sidePanelContainer instanceof HTMLElement)) return 0;
    return sidePanelContainer.offsetWidth + (0, $fPlP8.stickyLineExtraLengthLeft) - (panelColumnStyle ? parseFloat(panelColumnStyle.paddingLeft) : 0);
};
const $38a5d362bc8caa35$export$f61abf052f87399f = (refs, panelColumnStyle)=>{
    const panelColumn = refs.refPanelColumnElement;
    if (!panelColumn || !panelColumnStyle) return undefined;
    return panelColumn.offsetWidth - parseFloat(panelColumnStyle.paddingLeft) - parseFloat(panelColumnStyle.paddingRight);
};
const $38a5d362bc8caa35$export$134d8f4885c418ba = (panelColumnHeader, contentWidth)=>panelColumnHeader ? panelColumnHeader.offsetWidth : contentWidth ?? 0 + (0, $fPlP8.stickyLineExtraLengthLeft);
const $38a5d362bc8caa35$export$3bf8db4cba100062 = (refs)=>refs.refVisibilityContainer ? refs.refVisibilityContainer.offsetWidth : undefined;

});


parcelRegister("g1Vb4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6579d0b7f81ee9c$export$2e2bcd8739ae039);

var $dewtR = parcelRequire("dewtR");


var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $fokFV = parcelRequire("fokFV");

var $9F6MO = parcelRequire("9F6MO");

var $fobmH = parcelRequire("fobmH");

var $eAUUy = parcelRequire("eAUUy");
var // FIXME: JIV-17455 should be fully typed
$d6579d0b7f81ee9c$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)(// @ts-expect-error - Argument of type '<C extends ComponentType<P>, P = ComponentProps<C>>(WrappedComponent: C) => ContextResult<C, P>' is not assignable to parameter of type 'FlowStep<C, ComponentType<Matching<{ renderedItems: TabNode[]; tabItems: TabItem[]; type: string; panelKey: string; isProjectAdmin: boolean; } & {}, PropsWithoutRef<LibraryManagedAttributes<C, P & WithContextProps>> & RefAttributes<...>>>>'.
(0, $dewtR.default)({
    attributes: {
        contextPanelType: (0, $51be06d2b94fb740$export$7f66491e43ca5015)
    }
}), // @ts-expect-error - Type instantiation is excessively deep and possibly infinite.
(0, $lqalZ.connect)((state, { type: type, panelKey: panelKey, payload: { tabItems: tabItems } })=>({
        renderedItems: (0, $fobmH.default)(tabItems, (0, $fokFV.fieldsSelector)(state)),
        tabItems: tabItems,
        type: type,
        panelKey: panelKey,
        isProjectAdmin: (0, $9F6MO.canAdministerProjectPermissionsSelector)(state)
    }), {}))((0, $eAUUy.default));

});
parcelRegister("dewtR", function(module, exports) {

$parcel$export(module.exports, "default", () => $47ac80de2ea993f9$export$2e2bcd8739ae039);

var $1ngde = parcelRequire("1ngde");

var $klunD = parcelRequire("klunD");
var /**
 * @deprecated - Just provide the data when firing analytics events.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$47ac80de2ea993f9$export$2e2bcd8739ae039 = (payload)=>(WrappedComponent)=>(0, $1ngde.default)((0, $klunD.default)(payload))(WrappedComponent);

});

parcelRegister("fobmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ff10b67c6db2021$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");


var $73FRM = parcelRequire("73FRM");

var $btjMs = parcelRequire("btjMs");

var $fokFV = parcelRequire("fokFV");

var $10dMm = parcelRequire("10dMm");
const $6ff10b67c6db2021$var$logLocation = 'issue.views.issue-base.context.tab-panel';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6ff10b67c6db2021$export$2e2bcd8739ae039 = (tabItems, fields)=>{
    const layoutItemMap = (0, $10dMm.default)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return tabItems.reduce((renderedItems, tabItem)=>{
        switch(tabItem.type){
            case 0, $51be06d2b94fb740$export$8bcece6b344db0b9:
                {
                    const fieldType = (0, $btjMs.getFieldType)((0, $fokFV.getFieldHandlingSpecialFields)(tabItem.id, fields));
                    if (!fieldType || !Object.keys(layoutItemMap).includes(fieldType)) {
                        (0, $gUUjF.default).safeErrorWithoutCustomerData($6ff10b67c6db2021$var$logLocation, `Could not find a matching component for field '${fieldType || '(unknown type)'}' with id '${tabItem.id}'`, new Error('Could not find a matching component'));
                        return renderedItems;
                    }
                    const ContextItemComponent = layoutItemMap[fieldType].item;
                    const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContextItemComponent, {
                        key: tabItem.id,
                        fieldId: tabItem.id,
                        area: (0, $73FRM.TAB_PANEL)
                    });
                    renderedItems.push({
                        fieldType: fieldType,
                        component: component
                    });
                    return renderedItems;
                }
            default:
                (0, $gUUjF.default).safeErrorWithoutCustomerData($6ff10b67c6db2021$var$logLocation, `Unknown tab item '${JSON.stringify(tabItem)}'`, new Error('Unknown tab item'));
                return renderedItems;
        }
    }, []);
};

});

parcelRegister("eAUUy", function(module, exports) {

$parcel$export(module.exports, "default", () => $de6867e13f1ebc41$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eGI9v = parcelRequire("eGI9v");
var $iMMQz = parcelRequire("iMMQz");

var $3NCZx = parcelRequire("3NCZx");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $328UO = parcelRequire("328UO");

var $h9jt7 = parcelRequire("h9jt7");
const $de6867e13f1ebc41$export$3d96ec278d3efce4 = ({ isProjectAdmin: isProjectAdmin, renderedItems: renderedItems, tabItems: tabItems, contentWidth: contentWidth, onComponentMounted: onComponentMounted })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        const renderedTabItemTypes = new Set(renderedItems.map((item)=>item.fieldType));
        const tabItemIds = tabItems.map((item)=>item.id);
        const unrenderedTabItemTypes = tabItemIds.filter((tabItemId)=>!renderedTabItemTypes.has(tabItemId));
        onComponentMounted({
            renderedFieldsCount: renderedTabItemTypes.size,
            unrenderedFieldsCount: unrenderedTabItemTypes.length,
            unrenderedFieldTypes: unrenderedTabItemTypes.join(',')
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Ensure that we at least have some fields to render, otherwise
    // display an empty error state
    if (renderedItems.every((i)=>i.component == null)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NCZx.default), {
        size: "narrow",
        isSubtle: true,
        header: formatMessage((0, $h9jt7.default).emptyStateHeader),
        description: isProjectAdmin ? formatMessage((0, $h9jt7.default).emptyStateMessageAdmin) : formatMessage((0, $h9jt7.default).emptyStateMessage)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($de6867e13f1ebc41$var$PanelContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $328UO.PanelContentContainerInner), {
        maxWidth: contentWidth
    }, renderedItems.map((item)=>item.component)));
};
var $de6867e13f1ebc41$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $5G3JL.flowWithSafeComponent)(// @ts-expect-error - Argument of type '<T extends ComponentType<any>, Props = ComponentPropsWithRef<T>>(WrappedComponent: T) => FC<Omit<{ [K in keyof Props]: K extends "onComponentMounted" ? (...args: [......]) => ReturnType<...> : Props[K]; }, keyof WithAnalyticsEventsProps>>' is not assignable to parameter of type 'FlowStep<T, ComponentType<Matching<{ onComponentMounted: (analytics: RenderedFieldAnalytics, analyticsEvent: UIAnalyticsEvent) => void; } & {}, Omit<{ [K in keyof Props]: K extends "onComponentMounted" ? (...args: [......]) => ReturnType<...> : Props[K]; }, keyof WithAnalyticsEventsProps>>>>'.
(0, $eGI9v.default)('fieldTab', {
    onComponentMounted: 'rendered'
}), (0, $lqalZ.connect)(// FIXME: this is mapDispatch
(state, props)=>({
        onComponentMounted: (analytics, analyticsEvent)=>{
            (0, $iMMQz.fireUiAnalytics)(analyticsEvent, {
                name: props.panelKey,
                attributes: {
                    contextPanelType: props.type,
                    ...analytics
                }
            });
        }
    }), {}))($de6867e13f1ebc41$export$3d96ec278d3efce4);
const $de6867e13f1ebc41$var$PanelContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41n25 _1reo1wug _18m91wug _4t3i1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iMMQz", function(module, exports) {

$parcel$export(module.exports, "fireUiAnalytics", () => $087b448d474fca07$export$4909253b5bf1eed7);

var $3LiTJ = parcelRequire("3LiTJ");

var $etqm0 = parcelRequire("etqm0");

var $klunD = parcelRequire("klunD");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $087b448d474fca07$var$isNotUndefined = (a)=>a !== undefined;
const $087b448d474fca07$var$mapPayload = (payload)=>{
    const context = (0, $klunD.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $087b448d474fca07$var$isNotUndefined);
};
const $087b448d474fca07$export$4909253b5bf1eed7 = (event, payload)=>{
    event.update({
        ...$087b448d474fca07$var$mapPayload(payload),
        analyticsType: (0, $etqm0.UI_EVENT_TYPE)
    }).fire();
};

});

parcelRegister("3NCZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cbb1e7780288e8f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $giAhk = parcelRequire("giAhk");

var $eadHj = parcelRequire("eadHj");

var $2U97Y = parcelRequire("2U97Y");

var $eQdlC = parcelRequire("eQdlC");
function $0cbb1e7780288e8f$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($eadHj))) : (0, (/*@__PURE__*/$parcel$interopDefault($2U97Y)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        testId: "common-components-error-state.empty-state",
        size: size,
        imageWidth: imageWidth,
        imageUrl: errorImage || defaultImageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage))
    });
}
$0cbb1e7780288e8f$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $eQdlC.default).retry
};
var $0cbb1e7780288e8f$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($0cbb1e7780288e8f$export$edf27be85e5f6da0);

});
parcelRegister("eadHj", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("2U97Y", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("eQdlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc26b353252dab4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8bc26b353252dab4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("328UO", function(module, exports) {

$parcel$export(module.exports, "HeaderContainer", () => $49276bf13cca4603$export$1e86fd0e1db89578);
$parcel$export(module.exports, "HeaderContentContainer", () => $49276bf13cca4603$export$822597a26b6eb20);
$parcel$export(module.exports, "PanelContentContainerInner", () => $49276bf13cca4603$export$2c3904dc5a5970e4);
$parcel$export(module.exports, "RoundButton", () => $49276bf13cca4603$export$1e9fb32f4c490b67);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $49276bf13cca4603$export$1e86fd0e1db89578 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf _11q7vuon _12ji1r31 _1qu2glyw _12y3idpf _1tke1ylp",
            __cmplp.className
        ])
    });
});
const $49276bf13cca4603$export$822597a26b6eb20 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxWidth: maxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $9t7rW.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _kqswh2mm _vchhusvi _16qs1xhv _18u0x0bf _19bvu2gc _7ehi168b _nt751r31 _49pcglyw _1hvwidpf _d0altlke",
            __cmplp.maxWidth ? "_p12f1ayu" : "_p12fglyw",
            __cmplp.className
        ])
    });
});
const $49276bf13cca4603$export$2c3904dc5a5970e4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxWidth: maxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $9t7rW.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1o8l _1bsb1osq",
            __cmplp.maxWidth ? "_p12f1ayu" : "_p12fglyw",
            __cmplp.className
        ])
    });
});
const $49276bf13cca4603$export$1e9fb32f4c490b67 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4t3i1f4h _1bsb1f4h _19itglyw _2rko1ssb _11q71yrq _syaz1dop _4cvr1h6o _19bvv77o _18u01b66 _d0altlke",
            __cmplp.className
        ])
    });
});

});

parcelRegister("h9jt7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f15cdf8f3128581$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $6f15cdf8f3128581$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyStateHeader: {
        "id": "issue.context.tab-panel.empty-state.header",
        "defaultMessage": "No fields to show"
    },
    emptyStateMessage: {
        "id": "issue.context.tab-panel.empty-state.message",
        "defaultMessage": "If you expect to see fields here, ask your Jira admin to check permissions and field configuration."
    },
    emptyStateMessageAdmin: {
        "id": "issue.context.tab-panel.empty-state.message.admin",
        "defaultMessage": "If you expect to see fields here, check your permission and field configuration settings."
    }
});

});




parcelRegister("lBBEU", function(module, exports) {

$parcel$export(module.exports, "default", () => $15847236905bdba0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fkvsU = parcelRequire("fkvsU");

var $7ahhR = parcelRequire("7ahhR");

var $9wdvp = parcelRequire("9wdvp");

var $fYQU9 = parcelRequire("fYQU9");
class $15847236905bdba0$export$74753b26471367c extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            openedGlance: null
        };
    }
    renderGlance(styles, isOpen) {
        const { glance: glance } = this.props;
        switch(glance.glanceType){
            case 0, $fkvsU.CONNECT_ENTITY_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9wdvp.GlancePanelWithoutAnalytics), {
                    styles: styles,
                    appKey: glance.appKey,
                    moduleKey: glance.moduleKey,
                    key: `issue.ecosystem.glance.panel_${glance.appKey}_${glance.moduleKey}`
                });
            case 0, $fkvsU.FORGE_ENTITY_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fYQU9.default), {
                    // @ts-expect-error - this field does not exist
                    panelWidth: styles.panelWidth,
                    styles: styles,
                    key: `issue.forge.glance.panel_${glance.appKey}_${glance.moduleKey}`,
                    glance: glance,
                    isOpen: isOpen
                });
            default:
                return null;
        }
    }
    render() {
        const { openedGlance: openedGlance, glance: glance, refs: refs } = this.props;
        const isOpen = !!openedGlance && openedGlance.appKey === glance.appKey && openedGlance.moduleKey === glance.moduleKey;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ahhR.default), {
            refs: refs,
            isOpen: isOpen
        }, (styles)=>this.renderGlance(styles, isOpen));
    }
}
var $15847236905bdba0$export$2e2bcd8739ae039 = $15847236905bdba0$export$74753b26471367c;

});
parcelRegister("9wdvp", function(module, exports) {

$parcel$export(module.exports, "GlancePanelWithoutAnalytics", () => $b8ca58e2ae2ebbcf$export$50bf1fe7e9376ed9);

var $eUqFw = parcelRequire("eUqFw");

var $gpZWO = parcelRequire("gpZWO");
parcelRequire("eo4Zu");
var $14gc1 = parcelRequire("14gc1");

var $adX4B = parcelRequire("adX4B");

var $gUUjF = parcelRequire("gUUjF");

var $4lxPQ = parcelRequire("4lxPQ");

var $jLerq = parcelRequire("jLerq");

var $ciZ8Y = parcelRequire("ciZ8Y");


var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $hJ992 = parcelRequire("hJ992");

var $eyYNo = parcelRequire("eyYNo");

var $4ceCM = parcelRequire("4ceCM");

var $5G3JL = parcelRequire("5G3JL");

var $2V7AK = parcelRequire("2V7AK");

var $fCyzk = parcelRequire("fCyzk");

var $lqalZ = parcelRequire("lqalZ");

var $hIdxh = parcelRequire("hIdxh");

var $2qZHF = parcelRequire("2qZHF");

var $guDlK = parcelRequire("guDlK");

var $328UO = parcelRequire("328UO");

var $cUA2o = parcelRequire("cUA2o");

var $8fRP9 = parcelRequire("8fRP9");
const $b8ca58e2ae2ebbcf$export$e9b69fbf7db330bf = (prevProps, nextProps)=>{
    const hasAppKeyChanged = prevProps.appKey !== nextProps.appKey;
    const hasModuleKeyChanged = prevProps.moduleKey !== nextProps.moduleKey;
    const hasStatusChanged = prevProps.statusCategory !== nextProps.statusCategory;
    const hasStylesRefreshed = prevProps.styles !== nextProps.styles;
    return !(hasAppKeyChanged || hasModuleKeyChanged || hasStatusChanged || hasStylesRefreshed);
};
const $b8ca58e2ae2ebbcf$export$caebd94f3176f689 = ({ appKey: appKey, moduleKey: moduleKey, styles: styles = {}, statusCategory: statusCategory })=>{
    const refreshedOn = (0, $eyYNo.useOnDemandIssueRefreshTime)();
    const [connectHost, setConnectHost] = (0, $eUqFw.useState)(window.connectHost);
    const issueKey = (0, $hJ992.useIssueKey)();
    const [, { setIssueViewLayoutGlance: setIssueViewLayoutGlance }] = (0, $fCyzk.useIssueLayoutActions)();
    const glance = (0, $2V7AK.useEcosystemGlancePanel)(appKey, moduleKey);
    let application;
    let edition;
    if ((0, $1ybV0.ff)('instrumentation-of-issue-ecosystem-reliability-slo-metrics-rhs_tpmqi')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
        const projectKey = (0, $guDlK.useProjectKey)(issueKey);
        // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
        application = (0, $guDlK.useApplication)(projectKey, true);
        // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
        edition = (0, $guDlK.useEdition)(projectKey, true);
    }
    (0, $eUqFw.useEffect)(()=>{
        if (!connectHost) {
            (0, $gUUjF.default).safeInfoWithoutCustomerData('issue.ecosystem.glance.panel', 'Delayed initialization of ecosystem glance panel');
            (0, $4lxPQ.withConnectHost)((host)=>setConnectHost(host));
        }
    }, [
        connectHost
    ]);
    const handleHideGlancePanel = ()=>{
        setIssueViewLayoutGlance(issueKey, undefined);
    };
    const connectIframeProvider = (0, $adX4B.useDefaultConnectIframeProvider)({
        isAutoresizeBugfixEnabled: true
    });
    const issueId = (0, $hJ992.useIssueId)();
    const hasCorrectIssueInformation = (0, $2V7AK.useIsEcosystemDataLoadedFor)((0, $hJ992.useIssueKey)());
    if (!glance) return null;
    const { options: { origin: origin } } = glance;
    // there is a situation when during SPA transition issueId is yet undefined
    const renderUnblocked = connectHost && Boolean(issueId) && hasCorrectIssueInformation;
    const glancePanelWithHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $328UO.HeaderContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $328UO.HeaderContentContainer), {
        maxWidth: styles.headerWidth,
        onClick: handleHideGlancePanel,
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $328UO.RoundButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gpZWO))), {
        size: "medium",
        label: "Return"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUA2o.HeaderBreadcrumb), null, glance.name))), renderUnblocked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fRP9.PanelContents), {
        panelWidth: styles.contentWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $328UO.PanelContentContainerInner), {
        maxWidth: styles.contentWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $14gc1.ConnectIframe), {
        key: `connect-iFrame-${origin}-${issueId}-${statusCategory}-${refreshedOn}`,
        // setting data testid same as key here to assert in unit tests as key is not accessible
        "data-testid": `connect-iFrame-${origin}-${issueId}-${statusCategory}-${refreshedOn}`,
        connectHost: connectHost,
        appKey: appKey,
        moduleKey: moduleKey,
        url: glance.options.url,
        options: connectIframeProvider.convertConnectOptions(glance.options),
        height: "100%",
        width: "100%",
        connectIframeProvider: connectIframeProvider,
        // @ts-expect-error - TS2322 - Type '() => JSX.Element' is not assignable to type 'new () => PureComponent<{ failedCallback: Function; }, {}, any>'.
        timeoutIndicator: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jLerq.EcosystemTimeoutViewAsync), {
                appName: glance.name,
                appKey: appKey
            })
    }))));
    if ((0, $1ybV0.ff)('instrumentation-of-issue-ecosystem-reliability-slo-metrics-rhs_tpmqi')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-view.context.ecosystem-glance-panel",
        packageName: "jiraIssueViewBase",
        onError: (location, error)=>{
            (0, $4ceCM.sendExperienceAnalytics)({
                experience: 'issueViewConnectGlancePanelRender',
                wasExperienceSuccesful: false,
                analyticsSource: 'issueViewConnectGlancePanelView',
                application: application ?? null,
                edition: edition ?? null,
                additionalAttributes: {
                    location: location,
                    errorMessage: error.message
                }
            });
        }
    }, glancePanelWithHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: ()=>(0, $4ceCM.sendExperienceAnalytics)({
                experience: 'issueViewConnectGlancePanelRender',
                analyticsSource: 'issueViewConnectGlancePanelView',
                application: application ?? null,
                edition: edition ?? null,
                wasExperienceSuccesful: true,
                action: (0, $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a)
            })
    }));
    return glancePanelWithHeader;
};
const $b8ca58e2ae2ebbcf$export$c983240b4c5c1b39 = /*#__PURE__*/ (0, $eUqFw.memo)($b8ca58e2ae2ebbcf$export$caebd94f3176f689, $b8ca58e2ae2ebbcf$export$e9b69fbf7db330bf);
const $b8ca58e2ae2ebbcf$export$61d20212dfea439a = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        statusCategory: (0, $hIdxh.statusCategorySelector)(state)
    })))($b8ca58e2ae2ebbcf$export$c983240b4c5c1b39);
const $b8ca58e2ae2ebbcf$export$e2758965622fcb70 = (0, $lqalZ.connect)((state)=>({
        statusCategory: (0, $hIdxh.statusCategorySelector)(state)
    }))($b8ca58e2ae2ebbcf$export$c983240b4c5c1b39);
const $b8ca58e2ae2ebbcf$export$50bf1fe7e9376ed9 = (0, $bAQOb.componentWithFF)('instrumentation-of-issue-ecosystem-reliability-slo-metrics-rhs_tpmqi', $b8ca58e2ae2ebbcf$export$e2758965622fcb70, $b8ca58e2ae2ebbcf$export$61d20212dfea439a);

});
parcelRegister("8fRP9", function(module, exports) {

$parcel$export(module.exports, "PanelContents", () => $2c431d4124ab88e5$export$ce9a691eaa932c28);
/* styled-glance-panel.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $2c431d4124ab88e5$export$ce9a691eaa932c28 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { panelWidth: panelWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ttsh9p": (0, $9t7rW.default)(__cmplp.panelWidth, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _1reo1wug _18m91wug _kqswh2mm _1yt4u2gc",
            __cmplp.panelWidth ? "_1ul9q38m" : "_1ul9idpf",
            __cmplp.className
        ])
    });
});

});


parcelRegister("fYQU9", function(module, exports) {

$parcel$export(module.exports, "default", () => $80a1d2972b9a3ca6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gpZWO = parcelRequire("gpZWO");

var $ciZ8Y = parcelRequire("ciZ8Y");


var $1ybV0 = parcelRequire("1ybV0");

var $5syGA = parcelRequire("5syGA");

var $54bfs = parcelRequire("54bfs");

var $jun0V = parcelRequire("jun0V");

var $hJ992 = parcelRequire("hJ992");

var $eyYNo = parcelRequire("eyYNo");

var $4ceCM = parcelRequire("4ceCM");

var $5G3JL = parcelRequire("5G3JL");

var $fCyzk = parcelRequire("fCyzk");

var $lqalZ = parcelRequire("lqalZ");

var $5JqpU = parcelRequire("5JqpU");

var $8QKSg = parcelRequire("8QKSg");

var $2qZHF = parcelRequire("2qZHF");

var $guDlK = parcelRequire("guDlK");

var $328UO = parcelRequire("328UO");

var $cUA2o = parcelRequire("cUA2o");

var $8fRP9 = parcelRequire("8fRP9");
const $80a1d2972b9a3ca6$export$cbf0aa82b9a0aa9f = ({ glance: glance, extensionData: extensionData, styles: styles, source: source, isOpen: isOpen })=>{
    const [shouldRenderGlance, setShouldRenderGlance] = (0, $eUqFw.useState)(false);
    const issueKey = (0, $hJ992.useIssueKey)();
    let application;
    let edition;
    if ((0, $1ybV0.ff)('instrumentation-of-issue-ecosystem-reliability-slo-metrics-rhs_tpmqi')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
        const projectKey = (0, $guDlK.useProjectKey)(issueKey);
        // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
        application = (0, $guDlK.useApplication)(projectKey, true);
        // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
        edition = (0, $guDlK.useEdition)(projectKey, true);
    }
    const [, { setIssueViewLayoutGlance: setIssueViewLayoutGlance }] = (0, $fCyzk.useIssueLayoutActions)();
    const hideForgeGlance = (0, $eUqFw.useCallback)(()=>{
        setIssueViewLayoutGlance(issueKey, undefined);
    }, [
        issueKey,
        setIssueViewLayoutGlance
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isOpen && !shouldRenderGlance) setShouldRenderGlance(true);
    }, [
        isOpen,
        shouldRenderGlance
    ]);
    const forgeGlancePanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $328UO.HeaderContainer), {
        onClick: undefined,
        tabIndex: undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $328UO.HeaderContentContainer), {
        "data-testid": "issue-view-base.context.ecosystem.forge.issue-glance.header-content-container",
        maxWidth: styles.headerWidth,
        onClick: hideForgeGlance,
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $328UO.RoundButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gpZWO))), {
        size: "medium",
        label: "Return"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUA2o.HeaderBreadcrumb), null, glance.title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fRP9.PanelContents), {
        panelWidth: styles.contentWidth,
        "data-testid": "issue-view-base.context.ecosystem.forge.issue-glance.panel-contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $328UO.PanelContentContainerInner), {
        maxWidth: styles.contentWidth
    }, shouldRenderGlance && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jun0V.AsyncIssueGlance), {
        extensionData: extensionData,
        extension: glance.extension,
        analyticsAttributes: {
            source: source
        }
    }))));
    if ((0, $1ybV0.ff)('instrumentation-of-issue-ecosystem-reliability-slo-metrics-rhs_tpmqi')) {
        const commonAnalyticAttributes = {
            experience: 'issueViewForgeGlancePanelRender',
            analyticsSource: 'issueViewForgeGlancePanelView',
            application: application ?? null,
            edition: edition ?? null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
            id: "issue-view.context.ecosystem-glance-panel-forge",
            onError: (location, error)=>(0, $4ceCM.sendExperienceAnalytics)({
                    ...commonAnalyticAttributes,
                    wasExperienceSuccesful: false,
                    action: (0, $99e7a4e4cbcb5db0$export$b48b3d1872522384),
                    additionalAttributes: {
                        location: location,
                        errorMessage: error.message
                    }
                })
        }, forgeGlancePanel, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: ()=>(0, $4ceCM.sendExperienceAnalytics)({
                    ...commonAnalyticAttributes,
                    wasExperienceSuccesful: true,
                    action: (0, $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a)
                })
        }));
    }
    return forgeGlancePanel;
};
$80a1d2972b9a3ca6$export$cbf0aa82b9a0aa9f.displayName = 'ForgeGlancePanel';
const $80a1d2972b9a3ca6$export$c33768b4655a5813 = ({ ...props })=>{
    const refreshedOn = (0, $eyYNo.useOnDemandIssueRefreshTime)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $54bfs.ViewAnalyticsWrapper), {
        key: refreshedOn,
        attributes: {
            source: props.source,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.glance.extension)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80a1d2972b9a3ca6$export$cbf0aa82b9a0aa9f, props));
};
var $80a1d2972b9a3ca6$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        extensionData: (0, $8QKSg.forgeIssueDataSelector)(state),
        source: (0, $5JqpU.analyticsSourceSelector)(state)
    }), {}))($80a1d2972b9a3ca6$export$c33768b4655a5813);

});
parcelRegister("jun0V", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueGlance", () => $7b2678f4d90ac758$export$ada2c1b12e0a1b2d);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $1boRu = parcelRequire("1boRu");

var $2Rqjr = parcelRequire("2Rqjr");

var $2vJHJ = parcelRequire("2vJHJ");

var $gGtKh = parcelRequire("gGtKh");

var $aIPS7 = parcelRequire("aIPS7");

var $8Nthx = parcelRequire("8Nthx");
const $7b2678f4d90ac758$var$skeletonConfig = [
    {
        width: 100
    },
    {
        width: 100
    },
    {
        width: 75
    }
];

const $7b2678f4d90ac758$export$705adf83389c1131 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>(parcelRequire("3T80U")), {
    ssr: false,
    moduleId: "./src/packages/forge/forge-ui-async/src/ui/issue-glance/index.tsx"
}));
const $7b2678f4d90ac758$export$3b79e4d1f103704 = (props)=>{
    const { extension: extension, extensionData: extensionData } = props;
    const loadingComponent = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Nthx.Skeleton), {
            skeletonConfig: $7b2678f4d90ac758$var$skeletonConfig
        }), []);
    const extensionDataValue = (0, $eUqFw.useMemo)(()=>({
            ...extensionData,
            type: (0, $2Rqjr.ISSUE_GLANCE_MODULE)
        }), [
        extensionData
    ]);
    const extraProps = (0, $eUqFw.useMemo)(()=>({
            loadingComponent: loadingComponent,
            module: (0, $2Rqjr.ISSUE_GLANCE_MODULE),
            extensionData: extensionDataValue,
            contextToken: (0, $2Rqjr.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        loadingComponent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-glance",
        fallback: loadingComponent
    }, (0, $2vJHJ.isCustomUIExtension)(extension) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aIPS7.LazyIssueViewIframe), {
        ...props,
        ...extraProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b2678f4d90ac758$export$705adf83389c1131, {
        ...props,
        ...extraProps
    }));
};
const $7b2678f4d90ac758$export$ada2c1b12e0a1b2d = $7b2678f4d90ac758$export$3b79e4d1f103704;

});
parcelRegister("3T80U", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('a9YYL');
        const value = parcelRequire('htAEh');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("a9YYL").then(()=>parcelRequire('htAEh'));
}

});




parcelRegister("4oInG", function(module, exports) {

$parcel$export(module.exports, "isBrokenSafari", () => $9da64f34067bf066$export$c30bec4654cc0b65);
/**
 * @module is-broken-safari
 * XXX: This module exists solely as a preventive measure for
 * HOT-94246, where Safari >= 14.0.3 presents reasonable performance
 * regressions. Once Safari fixes this issue, we should completely
 * get rid of this verification.
 */ const $9da64f34067bf066$var$VERSION_REGEX = /Version\/(\d+\.\d+(\.\d+)?)/;
const $9da64f34067bf066$var$BROKEN_VERSION = [
    14,
    0,
    3
];
/**
 * Compare semver versions and return whether the given version
 * is newer or the same as the broken Safari version.
 *
 * @param {string} version version to compare
 * @return whether the given version is >= 14.0.3
 */ const $9da64f34067bf066$var$isNewerOrEqualVersion = (version)=>{
    const parts = version.split('.');
    for(let i = 0; i < parts.length; i++){
        const component = parseInt(parts[i], 10);
        if (component === $9da64f34067bf066$var$BROKEN_VERSION[i]) continue;
        return component > $9da64f34067bf066$var$BROKEN_VERSION[i];
    }
    return true;
};
const $9da64f34067bf066$export$c30bec4654cc0b65 = ()=>{
    if (typeof navigator === 'undefined') return false;
    const { appVersion: appVersion } = navigator;
    if (appVersion.includes('Chrome') || !appVersion.includes('Safari')) return false;
    const match = appVersion.match($9da64f34067bf066$var$VERSION_REGEX) ?? [];
    const version = match[1] ?? '0.0.0';
    return $9da64f34067bf066$var$isNewerOrEqualVersion(version);
};

});

parcelRegister("4CLbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $972bead93263b56b$export$2e2bcd8739ae039);

var $gv6AN = parcelRequire("gv6AN");
var $972bead93263b56b$export$2e2bcd8739ae039 = (0, $gv6AN.ConfigurationButton);

});
parcelRegister("gv6AN", function(module, exports) {

$parcel$export(module.exports, "ConfigurationButton", () => $63954339bc199733$export$d135bcb304f7cb12);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $8mHDC = parcelRequire("8mHDC");

var $iw0Y6 = parcelRequire("iw0Y6");

var $8cU5f = parcelRequire("8cU5f");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $1ybV0 = parcelRequire("1ybV0");

var $4ksts = parcelRequire("4ksts");

var $4YPB1 = parcelRequire("4YPB1");

var $jMP2a = parcelRequire("jMP2a");

var $kJlBc = parcelRequire("kJlBc");

var $1BSrn = parcelRequire("1BSrn");

var $j7j9l = parcelRequire("j7j9l");

var $7u4Wc = parcelRequire("7u4Wc");

var $dux6J = parcelRequire("dux6J");

var $4yHrv = parcelRequire("4yHrv");
const $63954339bc199733$var$configButtonOptionsFromMode = (mode, formatMessage)=>{
    switch(mode){
        case 0, $4YPB1.CONFIG_LINK_MODE_SHOW:
            return {
                tooltipText: formatMessage((0, $dux6J.default).configureTooltipAdmin),
                isDisabled: false
            };
        case 0, $4YPB1.CONFIG_LINK_MODE_DISABLED_PERMISSION:
            return {
                tooltipText: formatMessage((0, $dux6J.default).configureTooltipEndUser),
                isDisabled: true
            };
        case 0, $4YPB1.CONFIG_LINK_MODE_DISABLED_NO_REQUEST_TYPE:
            return {
                tooltipText: formatMessage((0, $dux6J.default).configureTooltipAdminNoRequestType),
                isDisabled: true
            };
        case 0, $4YPB1.CONFIG_LINK_MODE_DISABLED_NO_SCREEN_ID:
            return {
                tooltipText: '',
                isDisabled: true
            };
        case 0, $4YPB1.CONFIG_LINK_MODE_HIDE:
        default:
            return {
                isHidden: true
            };
    }
};
const $63954339bc199733$export$d135bcb304f7cb12 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const configurationLinkMode = (0, $j7j9l.default)();
    const configurationButtonOptions = $63954339bc199733$var$configButtonOptionsFromMode(configurationLinkMode, formatMessage);
    if (configurationButtonOptions.isHidden) return null;
    const { tooltipText: tooltipText, isDisabled: isDisabled } = configurationButtonOptions;
    const buttonText = formatMessage((0, $1BSrn.default).configure);
    const href = (0, $7u4Wc.default)(formatMessage);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onClick = (event, analyticsEvent)=>{
        event.preventDefault(); // This is required as CMP's event propogation triggers full page reload
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'configureButton');
        push(href);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        prefixOverride: "issue",
        id: "Safe(ConfigurationButton)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4yHrv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "mouse",
        mousePosition: "left",
        content: tooltipText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.foundation.configuration-button.configuration-button",
        isDisabled: isDisabled,
        appearance: "subtle-link",
        iconBefore: (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8mHDC))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))), {
            label: ""
        }),
        href: href,
        onClick: onClick,
        interactionName: "auto-generated.issue.views.issue-base.foundation.configuration-button.configuration-button.button"
    }, buttonText))));
});

});
parcelRegister("8mHDC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61723a6b5c2ed414$var$_react = $61723a6b5c2ed414$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $61723a6b5c2ed414$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $61723a6b5c2ed414$var$EditorSettingsIcon = (props)=>/*#__PURE__*/ $61723a6b5c2ed414$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12.002 15.504a3.502 3.502 0 110-7.004 3.502 3.502 0 010 7.004m6.732-1.987a1.605 1.605 0 01-.001-3.034.386.386 0 00.253-.462 7.2 7.2 0 00-.672-1.604.384.384 0 00-.481-.156c-.31.127-.668.16-1.039.065a1.6 1.6 0 01-1.129-1.124 1.641 1.641 0 01.061-1.043.385.385 0 00-.157-.48 7.225 7.225 0 00-1.59-.665.385.385 0 00-.461.252 1.604 1.604 0 01-3.032 0 .387.387 0 00-.463-.252c-.57.16-1.11.39-1.613.677a.378.378 0 00-.159.468 1.611 1.611 0 01-2.088 2.108.385.385 0 00-.479.158 7.2 7.2 0 00-.67 1.604.386.386 0 00.248.46 1.605 1.605 0 010 3.021.385.385 0 00-.249.46c.143.504.34.986.582 1.44.096.179.318.24.502.156.479-.22 1.08-.213 1.693.191a.881.881 0 01.243.242c.424.643.412 1.272.16 1.76a.381.381 0 00.134.506 7.197 7.197 0 001.697.721.381.381 0 00.459-.251A1.605 1.605 0 0112 17.645c.707 0 1.302.457 1.518 1.09.066.19.265.306.459.251a7.212 7.212 0 001.677-.71.38.38 0 00.134-.508c-.256-.49-.271-1.12.154-1.766a.884.884 0 01.243-.243c.62-.411 1.228-.413 1.71-.185a.384.384 0 00.505-.153c.244-.454.441-.937.585-1.443a.385.385 0 00-.252-.461" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$61723a6b5c2ed414$var$EditorSettingsIcon.displayName = 'EditorSettingsIcon';
var $61723a6b5c2ed414$var$_default = $61723a6b5c2ed414$var$EditorSettingsIcon;
module.exports.default = $61723a6b5c2ed414$var$_default;

});

parcelRegister("4YPB1", function(module, exports) {

$parcel$export(module.exports, "shouldShowSwiftLinkSelector", () => $67e504ef363202fe$export$8095e83d2a0297cc);
$parcel$export(module.exports, "shouldShowActionsSelector", () => $67e504ef363202fe$export$6ca02b12fd857d);
$parcel$export(module.exports, "CONFIG_LINK_MODE_SHOW", () => $67e504ef363202fe$export$901ae91534259733);
$parcel$export(module.exports, "CONFIG_LINK_MODE_HIDE", () => $67e504ef363202fe$export$393bd472eea33d10);
$parcel$export(module.exports, "CONFIG_LINK_MODE_DISABLED_PERMISSION", () => $67e504ef363202fe$export$484437905c134937);
$parcel$export(module.exports, "CONFIG_LINK_MODE_DISABLED_NO_REQUEST_TYPE", () => $67e504ef363202fe$export$110bc4f7519dc357);
$parcel$export(module.exports, "CONFIG_LINK_MODE_DISABLED_NO_SCREEN_ID", () => $67e504ef363202fe$export$7ca7bd0283e01d2c);
$parcel$export(module.exports, "shouldShowFindOutMoreSelector", () => $67e504ef363202fe$export$d307ef4302d2afc2);

var $df4Sl = parcelRequire("df4Sl");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $6X01q = parcelRequire("6X01q");

var $6Fp9G = parcelRequire("6Fp9G");

var $dv9do = parcelRequire("dv9do");
const $67e504ef363202fe$var$canAdministerSimplifiedIssueTypeSelector = (0, $df4Sl.createSelector)((0, $9F6MO.canAdministerProjectPermissionsSelector), (0, $9F6MO.canAdministerJiraPermissionsSelector), (isProjectAdmin, isJiraAdmin)=>isProjectAdmin || isJiraAdmin);
const $67e504ef363202fe$export$8095e83d2a0297cc = (0, $df4Sl.createSelector)((0, $jZDJX.isSimplifiedProjectSelector), $67e504ef363202fe$var$canAdministerSimplifiedIssueTypeSelector, (isSimplified, isAdmin)=>isAdmin && isSimplified);
const $67e504ef363202fe$export$6ca02b12fd857d = (0, $df4Sl.createSelector)((0, $jZDJX.errorSelector), (0, $5JqpU.isMobileSelector), (error, isMobile)=>!error && !isMobile);
const $67e504ef363202fe$export$901ae91534259733 = 'show';
const $67e504ef363202fe$export$393bd472eea33d10 = 'hide';
const $67e504ef363202fe$export$484437905c134937 = 'disabled_permission';
const $67e504ef363202fe$export$110bc4f7519dc357 = 'disabled_no_request_type';
const $67e504ef363202fe$export$7ca7bd0283e01d2c = 'disabled_no_screen_id';
const $67e504ef363202fe$export$6cc8f3ebc5284513 = (0, $df4Sl.createSelector)((0, $dv9do.isSubtaskSelector), (0, $dv9do.hasSubtasksSelector), (0, $6Fp9G.isSubtaskTypesPresentSelector), (0, $jZDJX.isClassicProjectSelector), (isSubtask, hasSubtasks, hasSubtaskTypes, isClassic)=>!isSubtask && !hasSubtasks && hasSubtaskTypes && isClassic);
const $67e504ef363202fe$export$e9f395ef48898f9c = (0, $df4Sl.createSelector)((0, $dv9do.isSubtaskSelector), (0, $jZDJX.isClassicProjectSelector), (isSubtask, isClassic)=>isSubtask && isClassic);
const $67e504ef363202fe$export$d307ef4302d2afc2 = (0, $df4Sl.createSelector)((0, $jZDJX.isServiceDeskSelector), (0, $6X01q.shouldShowChangeboardingSelector), (isServiceDeskProject, shouldShowChangeboarding)=>isServiceDeskProject || shouldShowChangeboarding);

});
parcelRegister("6X01q", function(module, exports) {

$parcel$export(module.exports, "shouldShowChangeboardingSelector", () => $0b26891d52f475f9$export$81d5858fa7dad15d);
$parcel$export(module.exports, "shouldShowTourSelector", () => $0b26891d52f475f9$export$fd676a25f3d72281);
$parcel$export(module.exports, "isBannerDismissed", () => $0b26891d52f475f9$export$d9853b07d3a8476b);

var $df4Sl = parcelRequire("df4Sl");


var $bIxSV = parcelRequire("bIxSV");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $5kY2l = parcelRequire("5kY2l");

var $5aFoH = parcelRequire("5aFoH");

var $5C9Wz = parcelRequire("5C9Wz");
const $0b26891d52f475f9$var$changeboardingUiSelector = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.changeboarding);
/** sources that show the welcome modal */ const $0b26891d52f475f9$var$analyticsSourceChangeboardingWhitelist = [
    (0, $0100842672acae20$export$cebf0bc8b2ccaf57),
    (0, $0100842672acae20$export$b19f949fb9713614),
    (0, $0100842672acae20$export$9c5d81b901471b27),
    (0, $0100842672acae20$export$f72626bf0d75dfad)
];
const $0b26891d52f475f9$export$71aeb243289eba18 = [
    (0, $0100842672acae20$export$b19f949fb9713614),
    (0, $0100842672acae20$export$7063ee6d0035a982),
    (0, $0100842672acae20$export$5bd5011b6596a0e7)
];
const $0b26891d52f475f9$export$81d5858fa7dad15d = (0, $df4Sl.createSelector)((0, $5JqpU.analyticsSourceSelector), (0, $5C9Wz.isNewIssueViewLockedInSelector), (0, $jZDJX.isSimplifiedProjectSelector), (analyticsSource, isNewIssueViewLockedIn, isSimplified)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $0b26891d52f475f9$var$analyticsSourceChangeboardingWhitelist.includes(analyticsSource) && !isNewIssueViewLockedIn && !isSimplified);
const $0b26891d52f475f9$export$fd676a25f3d72281 = (0, $df4Sl.createSelector)((0, $5JqpU.analyticsSourceSelector), (0, $5C9Wz.isNewIssueViewLockedInSelector), (0, $jZDJX.isSimplifiedProjectSelector), (analyticsSource)=>Boolean(analyticsSource && [
        ...$0b26891d52f475f9$export$71aeb243289eba18,
        (0, $0100842672acae20$export$cebf0bc8b2ccaf57)
    ] // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .includes(analyticsSource)));
const $0b26891d52f475f9$var$hasSeenBannerLessTimesThanThresholdSelector = ()=>(0, $5kY2l.getChangeboardingBannerSeenTimes)() < 7;
const $0b26891d52f475f9$var$isBannerEnabledForInstanceSelector = (state)=>{
    const { firstActivationDateMs: firstActivationDateMs } = state.context;
    return (0, $bIxSV.default)(firstActivationDateMs);
};
const $0b26891d52f475f9$export$94bc9f1471fa624 = (0, $df4Sl.createSelector)($0b26891d52f475f9$export$81d5858fa7dad15d, $0b26891d52f475f9$var$changeboardingUiSelector, $0b26891d52f475f9$var$isBannerEnabledForInstanceSelector, $0b26891d52f475f9$var$hasSeenBannerLessTimesThanThresholdSelector, (0, $5aFoH.openedGlanceSelector), (0, $5C9Wz.isNewIssueViewLockedInSelector), (shouldShowChangeboarding, changeboardingUi, isBannerEnabledForInstance, hasSeenBannerLessTimesThanThreshold, openedGlance, isNewIssueViewLockedIn)=>{
    const shouldShowChangeBoardingBanner = shouldShowChangeboarding && changeboardingUi.isBannerVisible && isBannerEnabledForInstance && hasSeenBannerLessTimesThanThreshold && !openedGlance;
    return shouldShowChangeBoardingBanner && !isNewIssueViewLockedIn;
});
const $0b26891d52f475f9$export$29adcae86fb06c92 = (0, $df4Sl.createSelector)($0b26891d52f475f9$var$changeboardingUiSelector, (changeboardingUi)=>changeboardingUi.isTourActive);
const $0b26891d52f475f9$export$d9853b07d3a8476b = (0, $df4Sl.createSelector)($0b26891d52f475f9$var$changeboardingUiSelector, (changeboardingUi)=>changeboardingUi.isBannerDismissed);

});
parcelRegister("bIxSV", function(module, exports) {

$parcel$export(module.exports, "default", () => $17ba08ea543d4b60$export$2e2bcd8739ae039);
const $17ba08ea543d4b60$var$cutoffDateMs = 1535727600000; // 2018-09-01T01:00:00 UTC
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$17ba08ea543d4b60$export$2e2bcd8739ae039 = (firstActivationDateMs)=>{
    if (firstActivationDateMs == null) return false;
    return firstActivationDateMs < $17ba08ea543d4b60$var$cutoffDateMs;
};

});

parcelRegister("5kY2l", function(module, exports) {

$parcel$export(module.exports, "getChangeboardingBannerSeenTimes", () => $7827e64a219950ca$export$6884713030befa1d);

var $aZaPn = parcelRequire("aZaPn");
const $7827e64a219950ca$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('issue-changeboarding');
const $7827e64a219950ca$var$BANNER_SEEN_TIMES_KEY = 'banner-seen-times';
const $7827e64a219950ca$var$BANNER_FIRST_SEEN_TIMESTAMP_KEY = 'banner-first-seen-timestamp';
const $7827e64a219950ca$export$6884713030befa1d = ()=>$7827e64a219950ca$var$localStorage.get($7827e64a219950ca$var$BANNER_SEEN_TIMES_KEY) || 0;
const $7827e64a219950ca$export$8de5ce76daf3074e = (seenTimes)=>$7827e64a219950ca$var$localStorage.set($7827e64a219950ca$var$BANNER_SEEN_TIMES_KEY, seenTimes);
const $7827e64a219950ca$export$6239abacfbbcbc19 = ()=>$7827e64a219950ca$var$localStorage.get($7827e64a219950ca$var$BANNER_FIRST_SEEN_TIMESTAMP_KEY);
const $7827e64a219950ca$export$429292b3ea485862 = (firstSeenTimestamp)=>$7827e64a219950ca$var$localStorage.set($7827e64a219950ca$var$BANNER_FIRST_SEEN_TIMESTAMP_KEY, firstSeenTimestamp);

});

parcelRegister("5C9Wz", function(module, exports) {

$parcel$export(module.exports, "isNewIssueViewLockedInSelector", () => $96ef0fbc659e88d5$export$de8a9ab2d8461da);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $96ef0fbc659e88d5$export$e12c9e70b7535991 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.uiConfig);
const $96ef0fbc659e88d5$export$de8a9ab2d8461da = (0, $df4Sl.createSelector)($96ef0fbc659e88d5$export$e12c9e70b7535991, (uiConfig)=>Boolean(uiConfig && uiConfig.newIssueViewLockedIn));

});



parcelRegister("1BSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2a302fb1d8cff05$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $c2a302fb1d8cff05$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    move: {
        "id": "issue.move",
        "defaultMessage": "Move"
    },
    clone: {
        "id": "issue.clone",
        "defaultMessage": "Clone"
    },
    delete: {
        "id": "issue.delete",
        "defaultMessage": "Delete"
    },
    print: {
        "id": "issue.print",
        "defaultMessage": "Print"
    },
    exportXML: {
        "id": "issue.export-xml",
        "defaultMessage": "Export XML"
    },
    exportDOC: {
        "id": "issue.export-doc",
        "defaultMessage": "Export Word"
    },
    switchToModal: {
        "id": "issue.switch-to-modal",
        "defaultMessage": "Open issues in dialog"
    },
    switchToSidebar: {
        "id": "issue.switch-to-sidebar",
        "defaultMessage": "Open issues in sidebar"
    },
    newIssueView: {
        "id": "issue.title-for-new-issue-actions",
        "defaultMessage": "New Jira issue view"
    },
    swiftLink: {
        "id": "issue.swift-link",
        "defaultMessage": "Configure"
    },
    swiftBacklink: {
        "id": "issue.swift-backlink-title",
        "defaultMessage": "Back to {issueKey}"
    },
    startTour: {
        "id": "issue.start-guided-tour",
        "defaultMessage": "Show me the highlights"
    },
    findOutMore: {
        "id": "issue.find-out-more",
        "defaultMessage": "Find out more"
    },
    seeOldView: {
        "id": "issue.see-old-view",
        "defaultMessage": "See the old view"
    },
    turnOffNewIssueView: {
        "id": "issue.turn-off-new-issue-view",
        "defaultMessage": "Turn off new issue view"
    },
    turnOffForNow: {
        "id": "issue.turn-off-issue-view-for-now",
        "defaultMessage": "Turn off for now"
    },
    triggerButtonLabel: {
        "id": "issue.label-for-issue-actions-button",
        "defaultMessage": "Actions"
    },
    configure: {
        "id": "issue.configure",
        "defaultMessage": "Configure"
    },
    addToParentLevel: {
        "id": "issue.add-to-parent-level",
        "defaultMessage": "Add parent"
    },
    changeParentLevel: {
        "id": "issue.change-parent-level",
        "defaultMessage": "Change parent"
    },
    convertToSubtask: {
        "id": "issue.convert-to-subtask",
        "defaultMessage": "Convert to Subtask"
    },
    convertToIssue: {
        "id": "issue.convert-to-issue",
        "defaultMessage": "Convert to Issue"
    }
});

});

parcelRegister("j7j9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bd209978012d373$export$2e2bcd8739ae039);

var $7ZZxN = parcelRequire("7ZZxN");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");
var $8411R = parcelRequire("8411R");

var $f9RL0 = parcelRequire("f9RL0");

var $4YPB1 = parcelRequire("4YPB1");

var $lO4Or = parcelRequire("lO4Or");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");

var $egOyn = parcelRequire("egOyn");
var // Determine how to show the configure button in the bottom right for classic and simplified (next gen) issues
// eslint-disable-next-line jira/import/no-anonymous-default-export
$9bd209978012d373$export$2e2bcd8739ae039 = ()=>{
    const projectKey = (0, $hJ992.useProjectKey)();
    const canUseServiceDeskAgentFeatures = (0, $5YYzL.useCanUseServiceDeskAgentFeatures)(projectKey);
    const canConfigureIssues = (0, $5YYzL.useCanConfigureIssue)(projectKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const isClassicProject = !(0, $guDlK.useIsSimplifiedProject)(projectKey);
    const issueKey = (0, $hJ992.useIssueKey)();
    const viewScreenId = (0, $hJ992.useViewScreenId)();
    const [{ value: issueFieldsConfig }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    let requestKeyCustomFieldKey = (0, $f9RL0.ISSUE_TYPE);
    // Classic service desk is the only project to have a request type
    if (isClassicProject && projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT) && issueFieldsConfig) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    requestKeyCustomFieldKey = (0, $egOyn.getFieldKeyByCustomType)((0, $lO4Or.REQUEST_TYPE_CF_TYPE), issueFieldsConfig);
    const key = requestKeyCustomFieldKey !== undefined ? requestKeyCustomFieldKey : (0, $f9RL0.ISSUE_TYPE);
    // Classic project request type id is custom, next gen is the issue type
    const [requestType] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: key
    });
    const issueTypeIdFieldKey = (0, $f9RL0.ISSUE_TYPE);
    const [issueTypeId] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: issueTypeIdFieldKey
    });
    if (!canConfigureIssues) return 0, $4YPB1.CONFIG_LINK_MODE_DISABLED_PERMISSION;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            if (!canUseServiceDeskAgentFeatures) return 0, $4YPB1.CONFIG_LINK_MODE_DISABLED_PERMISSION;
            if (isClassicProject && !(requestKeyCustomFieldKey !== null && requestType != null && requestType.requestType !== undefined && requestType.requestType.id !== undefined) || !isClassicProject && !(issueTypeId && issueTypeId.id)) // classic project doesn't have request type id
            // next gen project doesn't have issue type
            return 0, $4YPB1.CONFIG_LINK_MODE_DISABLED_NO_REQUEST_TYPE;
            break;
        default:
    }
    if ((viewScreenId == null || viewScreenId === 0) && isClassicProject) // Classic project requires screen ID for configuration
    return 0, $4YPB1.CONFIG_LINK_MODE_DISABLED_NO_SCREEN_ID;
    return 0, $4YPB1.CONFIG_LINK_MODE_SHOW;
};

});
parcelRegister("egOyn", function(module, exports) {

$parcel$export(module.exports, "getFieldKeyByCustomType", () => $d727b5f399613c5b$export$16331f936cdf7999);
const $d727b5f399613c5b$export$16331f936cdf7999 = (customType, fieldsConfiguration)=>Object.keys(fieldsConfiguration).find((field)=>fieldsConfiguration[field].schema.custom !== null && fieldsConfiguration[field].schema.custom === customType);

});


parcelRegister("7u4Wc", function(module, exports) {

$parcel$export(module.exports, "default", () => $662b8f3d60e983ed$export$2e2bcd8739ae039);

var $7ZZxN = parcelRequire("7ZZxN");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");
var $8411R = parcelRequire("8411R");

var $f9RL0 = parcelRequire("f9RL0");

var $lO4Or = parcelRequire("lO4Or");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");

var $cqJw8 = parcelRequire("cqJw8");

var $asgbs = parcelRequire("asgbs");

var $egOyn = parcelRequire("egOyn");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$662b8f3d60e983ed$export$2e2bcd8739ae039 = (formatMessage)=>{
    const projectKey = (0, $hJ992.useProjectKey)();
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const issueKey = (0, $hJ992.useIssueKey)();
    const viewScreenId = (0, $hJ992.useViewScreenId)();
    const isSimplifiedProject = (0, $guDlK.useIsSimplifiedProject)(projectKey);
    const canConfigureIssue = (0, $5YYzL.useCanConfigureIssue)(projectKey);
    const shouldShowSwiftLink = isSimplifiedProject && canConfigureIssue;
    const issueTypeIdFieldKey = (0, $f9RL0.ISSUE_TYPE);
    const [issueTypeId] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: issueTypeIdFieldKey
    });
    const [{ value: issueFieldsConfig }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    let requestKeyCustomFieldKey = (0, $f9RL0.ISSUE_TYPE);
    // Classic service desk is the only project to have a request type
    if (!isSimplifiedProject && projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT) && issueFieldsConfig) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    requestKeyCustomFieldKey = (0, $egOyn.getFieldKeyByCustomType)((0, $lO4Or.REQUEST_TYPE_CF_TYPE), issueFieldsConfig);
    const key = requestKeyCustomFieldKey !== undefined ? requestKeyCustomFieldKey : (0, $f9RL0.ISSUE_TYPE);
    // Classic project request type id is custom, next gen is the issue type
    const [requestType] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: key
    });
    // Next gen project
    if (isSimplifiedProject && shouldShowSwiftLink && projectType) {
        const { pathname: pathname, search: search } = window.location;
        return (0, $cqJw8.getNextgenSettingsIssueTypesUrl)(projectType, projectKey, issueTypeId?.id, {
            // url and title are not using encodeURIComponent here because it will be serialized later.
            url: `${pathname}${search}`,
            title: formatMessage((0, $asgbs.default).swiftBacklink, {
                issueKey: issueKey
            })
        });
    }
    // Classic & Service Desk
    if (!projectKey || viewScreenId == null || viewScreenId === 0 || isSimplifiedProject) // Next gen failed or classic project with missing information
    return projectType ? (0, $f9RL0.itemDocumentationUrls)[projectType] : (0, $f9RL0.itemDocumentationUrls)[0, $7ZZxN.SOFTWARE_PROJECT];
    if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) {
        if (requestType == null || requestType.requestType === undefined || requestType.requestType.id === undefined) return (0, $f9RL0.itemDocumentationUrls)[0, $7ZZxN.SERVICE_DESK_PROJECT];
        const { pathname: pathname, search: search } = window.location;
        return (0, $cqJw8.getClassicRequestTypeLayoutSettingsUrl)({
            projectKey: projectKey,
            requestTypeId: requestType.requestType.id,
            backLink: {
                // url and title are not using encodeURIComponent here because it will be serialized later.
                url: `${pathname}${search}`,
                title: formatMessage((0, $asgbs.default).swiftBacklink, {
                    issueKey: issueKey
                })
            }
        });
    }
    if (!viewScreenId) // invalid classic project
    return projectType ? (0, $f9RL0.itemDocumentationUrls)[projectType] : (0, $f9RL0.itemDocumentationUrls)[0, $7ZZxN.SOFTWARE_PROJECT];
    const { pathname: pathname, search: search } = window.location;
    return (0, $cqJw8.getClassicIssueLayoutSettingsUrl)({
        projectKey: projectKey,
        viewScreenId: viewScreenId,
        backLink: {
            // url and title are not using encodeURIComponent here because it will be serialized later.
            url: `${pathname}${search}`,
            title: formatMessage((0, $asgbs.default).swiftBacklink, {
                issueKey: issueKey
            })
        }
    });
};

});
parcelRegister("cqJw8", function(module, exports) {

$parcel$export(module.exports, "getNextgenSettingsUrl", () => $8bf9744795c994e7$export$26432406821aa7bf);
$parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", () => $8bf9744795c994e7$export$defee92e506aa306);
$parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", () => $8bf9744795c994e7$export$9133e09a98a043dc);
$parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", () => $8bf9744795c994e7$export$b0d20d18e0230e83);
$parcel$export(module.exports, "getClassicJSWSettingsUrl", () => $8bf9744795c994e7$export$ff0a17aa36a000df);
$parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", () => $8bf9744795c994e7$export$d531a9788343348f);
$parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", () => $8bf9744795c994e7$export$dad567762dae162e);

var $7ZZxN = parcelRequire("7ZZxN");

var $6bYiA = parcelRequire("6bYiA");

var $6ZTsa = parcelRequire("6ZTsa");

var $avawr = parcelRequire("avawr");
const $8bf9744795c994e7$export$26432406821aa7bf = (projectType, projectKey)=>{
    const products = {
        [(0, $7ZZxN.CORE_PROJECT)]: 'core',
        [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software',
        [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
    };
    const product = products[projectType];
    if (!product) {
        (0, $avawr.logError)((0, $6bYiA.PACKAGE_NAME), (0, $6ZTsa.toErrorId)('urls'), (0, $6ZTsa.toErrorMessage)(`Can't build default project settings url for project type: ${projectType}`), new Error(`Unexpected project type: ${projectType}`));
        // let's return classic url in that case
        return `/projects/${projectKey}/settings`;
    }
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
    return `/jira/${product}/projects/${projectKey}/settings`;
};
const $8bf9744795c994e7$var$serializeBackLink = (backLink)=>{
    if (backLink == null) return '';
    const { url: url, title: title } = backLink;
    return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
};
const $8bf9744795c994e7$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}`;
    return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;
};
const $8bf9744795c994e7$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
    return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
};
const $8bf9744795c994e7$export$b0d20d18e0230e83 = (projectKey)=>`${$8bf9744795c994e7$export$26432406821aa7bf((0, $7ZZxN.SERVICE_DESK_PROJECT), projectKey)}/automation`;
const $8bf9744795c994e7$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
const $8bf9744795c994e7$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;
const $8bf9744795c994e7$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;

});
parcelRegister("6bYiA", function(module, exports) {

$parcel$export(module.exports, "TASK", () => $b6aeae99b4bfc5a4$export$9355e489ad16f98e);
$parcel$export(module.exports, "BUG", () => $b6aeae99b4bfc5a4$export$bcf558c186108044);
$parcel$export(module.exports, "STORY", () => $b6aeae99b4bfc5a4$export$1ea39a3ae330045);
$parcel$export(module.exports, "EPIC", () => $b6aeae99b4bfc5a4$export$3cb4a99a332e4186);
$parcel$export(module.exports, "SUB_TASK", () => $b6aeae99b4bfc5a4$export$a06f889861f6537d);
$parcel$export(module.exports, "CUSTOM", () => $b6aeae99b4bfc5a4$export$952581bc40160893);
$parcel$export(module.exports, "TEMPLATES_WHITELIST", () => $b6aeae99b4bfc5a4$export$dff1da4a9bab6d3e);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $b6aeae99b4bfc5a4$export$39cd48613b53ce2f);
$parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$56eae1056efd4899);
$parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$ca61f05d869b2ea3);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", () => $b6aeae99b4bfc5a4$export$2ec42920a0df6b9a);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", () => $b6aeae99b4bfc5a4$export$40c10ba35ceb5c6b);
$parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", () => $b6aeae99b4bfc5a4$export$a11dccbf88784c62);
$parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY_APP_NAME", () => $b6aeae99b4bfc5a4$export$f35dc2e6deb1692e);
$parcel$export(module.exports, "JIRA_APP_NAME", () => $b6aeae99b4bfc5a4$export$ec5d0e43836cb3c7);
$parcel$export(module.exports, "toPackageName", () => $b6aeae99b4bfc5a4$export$f31a652635bd75fe);
$parcel$export(module.exports, "PACKAGE_NAME", () => $b6aeae99b4bfc5a4$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", () => $b6aeae99b4bfc5a4$export$a2231d79966e0ccc);
$parcel$export(module.exports, "RADIO_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$28a4bdf7d9b6f9);
$parcel$export(module.exports, "USERPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$9d758b3e8c6e0ed1);
$parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$b0e37d421e006913);
$parcel$export(module.exports, "SELECT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$d77765147749db6b);
$parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$42ef68d6bd555a8d);
$parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$4db6eb15b3c529cf);
$parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$ee975373b7797e8a);
$parcel$export(module.exports, "TEXT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$aa99342cc6a8ced5);
$parcel$export(module.exports, "NUMBER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$6f327bf99e20320);
$parcel$export(module.exports, "DATETIME_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$dc64bdfdf9660a05);
$parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$e6d73ed745b9a04);
$parcel$export(module.exports, "DATE_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$d8b50f59220c7580);
$parcel$export(module.exports, "ASSETSPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$3a6f0a44478f1d2);
$parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$68b76ef93df5a880);
$parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$e7773fccbeec45e6);
$parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$b45487b145c52a37);
$parcel$export(module.exports, "VERSION_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$48548129a6d117f5);
$parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$722c271a9e11cb94);
$parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$33dbe2a903610aa1);
$parcel$export(module.exports, "emptyTenantContext", () => $b6aeae99b4bfc5a4$export$ac655f5b3ff7b929);
// Issue Type Templates

var $ao0hp = parcelRequire("ao0hp");

var $lO4Or = parcelRequire("lO4Or");

var $6WXNs = parcelRequire("6WXNs");
var $7HKaW = parcelRequire("7HKaW");
var $38OPi = parcelRequire("38OPi");
var $6vrw7 = parcelRequire("6vrw7");
const $b6aeae99b4bfc5a4$export$9355e489ad16f98e = 'task';
const $b6aeae99b4bfc5a4$export$bcf558c186108044 = 'bug';
const $b6aeae99b4bfc5a4$export$1ea39a3ae330045 = 'story';
const $b6aeae99b4bfc5a4$export$3cb4a99a332e4186 = 'epic';
const $b6aeae99b4bfc5a4$export$a06f889861f6537d = 'subtask';
const $b6aeae99b4bfc5a4$export$952581bc40160893 = 'custom';
const $b6aeae99b4bfc5a4$export$dff1da4a9bab6d3e = [
    $b6aeae99b4bfc5a4$export$9355e489ad16f98e,
    $b6aeae99b4bfc5a4$export$bcf558c186108044,
    $b6aeae99b4bfc5a4$export$1ea39a3ae330045,
    $b6aeae99b4bfc5a4$export$3cb4a99a332e4186
];
const $b6aeae99b4bfc5a4$export$39cd48613b53ce2f = (0, $lO4Or.TEXT_AREA_CF_TYPE);
const $b6aeae99b4bfc5a4$export$56eae1056efd4899 = (0, $lO4Or.DESCRIPTION_TYPE);
const $b6aeae99b4bfc5a4$export$ca61f05d869b2ea3 = (0, $lO4Or.ENVIRONMENT_TYPE);
const $b6aeae99b4bfc5a4$export$2ec42920a0df6b9a = 'Story point estimate';
const $b6aeae99b4bfc5a4$export$40c10ba35ceb5c6b = 'storyPointEstimate';
const $b6aeae99b4bfc5a4$export$a4d3702d4c7481d6 = 44;
const $b6aeae99b4bfc5a4$export$8a6a961f6caf7a8b = [
    $b6aeae99b4bfc5a4$export$56eae1056efd4899,
    $b6aeae99b4bfc5a4$export$39cd48613b53ce2f,
    $b6aeae99b4bfc5a4$export$ca61f05d869b2ea3
];
const $b6aeae99b4bfc5a4$export$e27914436cc13e3c = 'Jira Software';
const $b6aeae99b4bfc5a4$export$a11dccbf88784c62 = 'Jira Service Management';
const $b6aeae99b4bfc5a4$export$9f4aa232cbb6be46 = 'Jira Work Management';
const $b6aeae99b4bfc5a4$export$b3c4739240716eb6 = 'Jira Ops';
const $b6aeae99b4bfc5a4$export$f35dc2e6deb1692e = 'Jira Product Discovery';
const $b6aeae99b4bfc5a4$export$ec5d0e43836cb3c7 = 'Jira';
const $b6aeae99b4bfc5a4$export$f31a652635bd75fe = (packageName)=>packageName;
const $b6aeae99b4bfc5a4$export$b8b9d90f9e5bd72b = $b6aeae99b4bfc5a4$export$f31a652635bd75fe('jiraProjectSettingsAppsCommon');
const $b6aeae99b4bfc5a4$export$a2231d79966e0ccc = 'NEW_';
const $b6aeae99b4bfc5a4$export$13dc44d2a9a248a4 = 'swift_openAddIssueTypeModal';
const $b6aeae99b4bfc5a4$export$28a4bdf7d9b6f9 = 'radio';
const $b6aeae99b4bfc5a4$export$9d758b3e8c6e0ed1 = 'userpicker';
const $b6aeae99b4bfc5a4$export$b0e37d421e006913 = 'multiuserpicker';
const $b6aeae99b4bfc5a4$export$d77765147749db6b = 'select';
const $b6aeae99b4bfc5a4$export$42ef68d6bd555a8d = 'cascadingselect';
const $b6aeae99b4bfc5a4$export$4db6eb15b3c529cf = 'multiselect';
const $b6aeae99b4bfc5a4$export$ee975373b7797e8a = 'checkbox';
const $b6aeae99b4bfc5a4$export$aa99342cc6a8ced5 = 'text';
const $b6aeae99b4bfc5a4$export$6f327bf99e20320 = 'number';
const $b6aeae99b4bfc5a4$export$dc64bdfdf9660a05 = 'datetime';
const $b6aeae99b4bfc5a4$export$e6d73ed745b9a04 = 'projectpicker';
const $b6aeae99b4bfc5a4$export$d8b50f59220c7580 = 'date';
const $b6aeae99b4bfc5a4$export$3a6f0a44478f1d2 = 'assetspicker';
const $b6aeae99b4bfc5a4$export$68b76ef93df5a880 = 'labelpicker';
const $b6aeae99b4bfc5a4$export$e7773fccbeec45e6 = 'grouppicker';
const $b6aeae99b4bfc5a4$export$b45487b145c52a37 = 'multigrouppicker';
const $b6aeae99b4bfc5a4$export$48548129a6d117f5 = 'version';
const $b6aeae99b4bfc5a4$export$722c271a9e11cb94 = 'multiversion';
const $b6aeae99b4bfc5a4$export$33dbe2a903610aa1 = 'textarea';
const $b6aeae99b4bfc5a4$export$ac655f5b3ff7b929 = ()=>({
        appEditions: (0, $6WXNs.populateApplicationEditions)(),
        appPermissions: (0, $38OPi.populateApplicationPermissions)(),
        applicationKey: null,
        areProductSuggestionsEnabled: false,
        atlassianAccountId: null,
        baseUrl: (0, $6vrw7.toBaseUrl)(''),
        cloudId: (0, $6vrw7.toCloudId)(''),
        activationId: (0, $6vrw7.toActivationId)(''),
        cloudName: (0, $6vrw7.toCloudName)(''),
        devopsProjectSignupSource: (0, $6vrw7.toDevopsProjectSignupSource)(''),
        environment: null,
        fabricActivityUrl: null,
        fabricNotificationLogUrl: null,
        fabricPfDirUrl: null,
        firstActivationDateMs: null,
        isAdmin: false,
        isAnonymous: false,
        isDevMode: false,
        isDevopsProjectCreationScenario: false,
        isMarketingOptOut: false,
        isSiteAdmin: false,
        languageTag: null,
        licenseStates: (0, $7HKaW.populateApplicationLicenseStates)(),
        licensedProducts: {},
        locale: (0, $ao0hp.defaultLocale),
        loggedInUser: null,
        productCrossSellConfig: 'unknown',
        productEntitlementDetails: null,
        productPermissionGated: {
            core: false,
            software: false,
            serviceDesk: false,
            productDiscovery: false
        },
        siteAdminStatus: 'unknown',
        userFullname: null,
        xsrfToken: null,
        hasDlpEnabled: false
    });

});

parcelRegister("6ZTsa", function(module, exports) {

$parcel$export(module.exports, "toErrorId", () => $36a0a2a2a499297e$export$706bbe4209d93dfe);
$parcel$export(module.exports, "toErrorMessage", () => $36a0a2a2a499297e$export$95506c204c060a3);
// Package name to be used in famaCatchAndLogFetchError and logError utils

var $6bYiA = parcelRequire("6bYiA");
const $36a0a2a2a499297e$export$706bbe4209d93dfe = (id)=>id;
const $36a0a2a2a499297e$export$95506c204c060a3 = (message)=>message;

});

parcelRegister("avawr", function(module, exports) {

$parcel$export(module.exports, "logError", () => $f57ea56200106b95$export$58da9968c3170cb1);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");
const $f57ea56200106b95$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
    // Send error log to analytics pipeline (i.e. SFX) and Sentry
    (0, $guiFP.default)({
        meta: {
            packageName: packageName,
            id: errorId,
            teamName: 'morphinecake'
        },
        attributes: {
            ...attributes,
            message: message
        },
        error: error
    });
    // Send error log to Splunk
    // We use this instead of `sendToPrivacyUnsafeSplunk` to preserve error message and custom properties
    const location = `${packageName}.${errorId}`;
    (0, $gUUjF.default).unsafeErrorWithCustomerData(location, message, error);
};

});


parcelRegister("asgbs", function(module, exports) {

$parcel$export(module.exports, "default", () => $487077d25e539047$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $487077d25e539047$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    configure: {
        "id": "issue.configure",
        "defaultMessage": "Configure"
    },
    swiftBacklink: {
        "id": "issue.swift-backlink-title",
        "defaultMessage": "Back to {issueKey}"
    }
});

});


parcelRegister("dux6J", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c6b2c302caad33$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $62c6b2c302caad33$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    configureTooltipAdmin: {
        "id": "issue.details.configuration-button.configure-fields.tooltip-admin",
        "defaultMessage": "Configure fields"
    },
    configureTooltipEndUser: {
        "id": "issue.details.configuration-button.configure-fields.tooltip-end-user",
        "defaultMessage": "Contact your admin to change the field order & layout"
    },
    configureTooltipAdminNoRequestType: {
        "id": "issue.details.configuration-button.configure-fields.tooltip-admin-no-request-type",
        "defaultMessage": "You can\u2019t configure the layout of an issue while it doesn\u2019t have a request type."
    }
});

});

parcelRegister("4yHrv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f7cfeb04f5ed951$export$2e2bcd8739ae039);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $2f7cfeb04f5ed951$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8l6jh _1e0c1ule _1ul9idpf _p12f1osq _2hwxidpf _1jfnidpf _85kgidpf _1l3fidpf _k0oridpf _dtz21crf _1aohidpf _19tbidpf _1tvmidpf _1irvidpf _16d1n7od _1sb97vkz _17f7idpf",
            __cmplp.className
        ])
    });
});
var $2f7cfeb04f5ed951$export$2e2bcd8739ae039 = $2f7cfeb04f5ed951$export$e6dfd72ab29f8598;

});



parcelRegister("3TfAL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b7fcf976ca78825$export$2e2bcd8739ae039);
/* meta-container-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1SeDs = parcelRequire("1SeDs");

var $hJ992 = parcelRequire("hJ992");

var $4rf77 = parcelRequire("4rf77");

var $kIxSX = parcelRequire("kIxSX");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b7fcf976ca78825$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1b66 _2hwxpxbi _16jlkb7n _1o9zkb7n _i0dlf1ug _19bvutpp",
            __cmplp.className
        ])
    });
});
var $1b7fcf976ca78825$export$2e2bcd8739ae039 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b7fcf976ca78825$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1SeDs.default), {
        issueKey: issueKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIxSX.default), {
        issueKey: issueKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4rf77.default), {
        issueKey: issueKey
    }));
};

});
parcelRegister("1SeDs", function(module, exports) {

$parcel$export(module.exports, "default", () => $14bbab94f6f77763$export$2e2bcd8739ae039);

var $cUrPW = parcelRequire("cUrPW");

var $14bbab94f6f77763$export$2e2bcd8739ae039 = (0, $cUrPW.CreatedDateField);

});
parcelRegister("cUrPW", function(module, exports) {

$parcel$export(module.exports, "CreatedDateField", () => $111cfea1f5e7f38b$export$18b884e4285fe572);

var $eUqFw = parcelRequire("eUqFw");

var $kUxEM = parcelRequire("kUxEM");

var $bqFdI = parcelRequire("bqFdI");
const $111cfea1f5e7f38b$export$18b884e4285fe572 = ({ issueKey: issueKey })=>{
    const [{ value: createdDate }] = (0, $kUxEM.default)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bqFdI.CreatedDate), {
        date: createdDate
    });
};

});
parcelRegister("kUxEM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5628c6d441eeefe$export$2e2bcd8739ae039);

var $kmr29 = parcelRequire("kmr29");

var $lO4Or = parcelRequire("lO4Or");
const $e5628c6d441eeefe$var$useCreatedDateField = ({ issueKey: issueKey })=>{
    const [value] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.CREATED)
    });
    return [
        {
            value: value
        }
    ];
};
var $e5628c6d441eeefe$export$2e2bcd8739ae039 = $e5628c6d441eeefe$var$useCreatedDateField;

});

parcelRegister("bqFdI", function(module, exports) {

$parcel$export(module.exports, "CreatedDate", () => $cccea7b7d363ef79$export$71ddacaac65a33a4);

var $eUqFw = parcelRequire("eUqFw");

var $fee69 = parcelRequire("fee69");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hUGb7 = parcelRequire("hUGb7");


var $4IWMT = parcelRequire("4IWMT");
const $cccea7b7d363ef79$export$71ddacaac65a33a4 = ({ date: date })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return date !== null && date !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUGb7.default), {
        testId: (0, $eae6fc9f9f6664ae$export$28db549dd85ab6df),
        date: date,
        text: formatMessage((0, $4IWMT.default).createdLabel)
    })) : null;
};

});
parcelRegister("hUGb7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dde8491b8518c1a$export$2e2bcd8739ae039);

var $2hMkg = parcelRequire("2hMkg");
var $1dde8491b8518c1a$export$2e2bcd8739ae039 = (0, $2hMkg.default);

});
parcelRegister("2hMkg", function(module, exports) {

$parcel$export(module.exports, "default", () => $baa84b1091e846b2$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $4iC3C = parcelRequire("4iC3C");
const $baa84b1091e846b2$var$MetaDate = (props)=>{
    const { text: text, date: date, testId: testId } = props;
    if (date === undefined || date === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        testId: testId,
        xcss: $baa84b1091e846b2$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($baa84b1091e846b2$var$TextSpan, null, text, "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4iC3C.default), {
        value: date,
        extraStyles: $baa84b1091e846b2$export$cfbd42e6289bc323,
        tooltipPosition: "right"
    })));
};
var $baa84b1091e846b2$export$2e2bcd8739ae039 = $baa84b1091e846b2$var$MetaDate;
const $baa84b1091e846b2$var$containerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.050'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $baa84b1091e846b2$var$TextSpan = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1gjq _ca0qv77o _o5721q9c _19pkidpf _1wyb1crf _vwz41clk",
            __cmplp.className
        ])
    });
});
$baa84b1091e846b2$var$TextSpan.displayName = 'TextSpan'; // eslint-disable-next-line @atlaskit/design-system/no-exported-css, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $baa84b1091e846b2$export$cfbd42e6289bc323 = {
    // eslint-disable-next-line jira/compiled/styled-components-usages
    whenDisplaySettingSwitchable: (0, $kwce8.css)({
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values  -- Ignored via go/DSP-18766
            color: `var(--ds-text-subtle, ${(0, $PdmhA).N500})`
        }
    })
};

});
parcelRegister("4iC3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1a1c7a2e73b38d4$export$2e2bcd8739ae039);

var $5TykG = parcelRequire("5TykG");

var $c1a1c7a2e73b38d4$export$2e2bcd8739ae039 = (0, $5TykG.default);

});
parcelRegister("5TykG", function(module, exports) {

$parcel$export(module.exports, "default", () => $da6a9dc8604f8c0a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $ldoFd = parcelRequire("ldoFd");

var $jG2Eu = parcelRequire("jG2Eu");

var $8cU5f = parcelRequire("8cU5f");

var $gUUjF = parcelRequire("gUUjF");

var $1IqwQ = parcelRequire("1IqwQ");
var $4ksts = parcelRequire("4ksts");

var $kPvBW = parcelRequire("kPvBW");

var $i9pAn = parcelRequire("i9pAn");

var $6aKs0 = parcelRequire("6aKs0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lGLse = parcelRequire("lGLse");

var $jsScF = parcelRequire("jsScF");

var $hAlQB = parcelRequire("hAlQB");
const $da6a9dc8604f8c0a$var$TimestampView = (props)=>{
    const { value: value, extraStyles: extraStyles = {}, tooltipPosition: tooltipPosition = 'top' } = props;
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const loggedInUserTimeZone = loggedInUser ? loggedInUser.timeZone : undefined;
    const userTimeZone = loggedInUserTimeZone || (0, $6aKs0.getBrowserTimeZone)();
    const isADGTimestampDisplaySettingRelative = (0, $hAlQB.getADGTimestampDisplaySetting)(value) === (0, $jsScF.RELATIVE);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatDate: formatDate } = (0, $4ksts.useIntlV2)();
    const [userDisplaySetting, { setValue: setTimestampDisplaySetting }] = (0, $i9pAn.useUserPreferencesValue)((0, $kPvBW.TIMESTAMP_DISPLAY_SETTING));
    // Use relative display setting if user hasn't set anything
    const displaySetting = (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(userDisplaySetting) || userDisplaySetting === '' ? (0, $jsScF.RELATIVE) : userDisplaySetting;
    const formattedAbsoluteTimestamp = (0, $eUqFw.useMemo)(()=>formatDate(value, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            timeZone: userTimeZone
        }), [
        formatDate,
        userTimeZone,
        value
    ]);
    const onAbsoluteClick = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'absoluteTimeButton');
        setTimestampDisplaySetting((0, $jsScF.RELATIVE)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.components.timestamp', 'Failed to set timestamp display to RELATIVE', error);
        });
    }, [
        createAnalyticsEvent,
        setTimestampDisplaySetting
    ]);
    const onRelativeClick = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'relativeTimeButton');
        setTimestampDisplaySetting((0, $jsScF.ABSOLUTE)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.components.timestamp', 'Failed to set timestamp display to ABSOLUTE', error);
        });
    }, [
        createAnalyticsEvent,
        setTimestampDisplaySetting
    ]);
    const renderAbsolute = (0, $eUqFw.useCallback)((canSwitchDisplaySetting)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da6a9dc8604f8c0a$var$TimestampWrapper, {
            canSwitchDisplaySetting: canSwitchDisplaySetting,
            onKeyDown: (e)=>{
                if ((e.key === 'Enter' || e.key === 'Space') && canSwitchDisplaySetting) onAbsoluteClick();
            },
            role: "presentation",
            onClick: canSwitchDisplaySetting ? onAbsoluteClick : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            extraStyles: extraStyles
        }, formattedAbsoluteTimestamp), [
        extraStyles,
        formattedAbsoluteTimestamp,
        onAbsoluteClick
    ]);
    const renderRelative = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da6a9dc8604f8c0a$var$TimestampWrapper, {
            canSwitchDisplaySetting: true,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && onRelativeClick(),
            role: "presentation",
            onClick: onRelativeClick,
            extraStyles: extraStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            tag: "span",
            content: formattedAbsoluteTimestamp,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-testid": "issue-timestamp.relative-time"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1IqwQ.FormattedRelativeV2), {
            value: value
        })))), [
        extraStyles,
        formattedAbsoluteTimestamp,
        onRelativeClick,
        tooltipPosition,
        value
    ]);
    // BENTO-2569: Users have requested the ability to switch to absolute timestamps when the timestamp is to be displayed as relative.
    // When the timestamp is to be displayed as absolute then we cannot allow them to switch (to comply with ADG)
    return isADGTimestampDisplaySettingRelative && displaySetting === (0, $jsScF.RELATIVE) ? renderRelative() : renderAbsolute(isADGTimestampDisplaySettingRelative);
};
$da6a9dc8604f8c0a$var$TimestampView.displayName = 'TimestampView';
var $da6a9dc8604f8c0a$export$2e2bcd8739ae039 = $da6a9dc8604f8c0a$var$TimestampView;
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da6a9dc8604f8c0a$var$TimestampWrapper = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "erd76u-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: props.canSwitchDisplaySetting ? 'pointer' : 'default'
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ extraStyles: extraStyles })=>extraStyles.always, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ canSwitchDisplaySetting: canSwitchDisplaySetting, extraStyles: { whenDisplaySettingSwitchable: extraStylesWhenSwitchable } })=>canSwitchDisplaySetting ? extraStylesWhenSwitchable : '');
$da6a9dc8604f8c0a$var$TimestampWrapper.displayName = 'TimestampWrapper';

});
parcelRegister("kPvBW", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $b682c7d6e9f17978$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $b682c7d6e9f17978$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $b682c7d6e9f17978$export$b38f30d67f730bc4);
const $b682c7d6e9f17978$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $b682c7d6e9f17978$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $b682c7d6e9f17978$export$757f91ad408a28d4 = 'jira.user.issue.filter.hide-done-subtasks';
const $b682c7d6e9f17978$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery'
};

});

parcelRegister("jsScF", function(module, exports) {

$parcel$export(module.exports, "RELATIVE", () => $ad8b3ae3c84be75e$export$91389b1eb9882ae7);
$parcel$export(module.exports, "ABSOLUTE", () => $ad8b3ae3c84be75e$export$8cd2c3eb7eeb9644);
const $ad8b3ae3c84be75e$export$91389b1eb9882ae7 = 'RELATIVE';
const $ad8b3ae3c84be75e$export$8cd2c3eb7eeb9644 = 'ABSOLUTE';

});

parcelRegister("hAlQB", function(module, exports) {

$parcel$export(module.exports, "getADGTimestampDisplaySetting", () => $86e37847e2293e72$export$e89759fbd7b8f45a);

var $jsScF = parcelRequire("jsScF");
// @ts-expect-error - TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
const $86e37847e2293e72$var$getDaysElapsed = (date)=>(Date.now() - new Date(date)) / 86400000;
const $86e37847e2293e72$export$e89759fbd7b8f45a = (date)=>$86e37847e2293e72$var$getDaysElapsed(date) < 8 ? (0, $jsScF.RELATIVE) : (0, $jsScF.ABSOLUTE);

});





const $eae6fc9f9f6664ae$export$28db549dd85ab6df = 'created-date.ui.read.meta-date';

parcelRegister("4IWMT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d026f0fb3c5911e6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d026f0fb3c5911e6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createdLabel: {
        "id": "created-date.read.created-label",
        "defaultMessage": "Created"
    }
});

});




parcelRegister("4rf77", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceb57563d527be0b$export$2e2bcd8739ae039);

var $bWNR8 = parcelRequire("bWNR8");

var $ceb57563d527be0b$export$2e2bcd8739ae039 = (0, $bWNR8.ResolvedDateField);

});
parcelRegister("bWNR8", function(module, exports) {

$parcel$export(module.exports, "ResolvedDateField", () => $b2ab0093a73f1e17$export$821b0e53537ab70d);

var $eUqFw = parcelRequire("eUqFw");

var $bBMQU = parcelRequire("bBMQU");

var $iZMQb = parcelRequire("iZMQb");
const $b2ab0093a73f1e17$export$821b0e53537ab70d = ({ issueKey: issueKey })=>{
    const [{ value: resolvedDate }] = (0, $bBMQU.default)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iZMQb.ResolvedDate), {
        date: resolvedDate
    });
};

});
parcelRegister("bBMQU", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd444067f48e0c0d$export$2e2bcd8739ae039);

var $kmr29 = parcelRequire("kmr29");

var $lO4Or = parcelRequire("lO4Or");
const $fd444067f48e0c0d$var$useResolvedDateField = ({ issueKey: issueKey })=>{
    const [value] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.RESOLUTION_DATE)
    });
    return [
        {
            value: value
        }
    ];
};
var $fd444067f48e0c0d$export$2e2bcd8739ae039 = $fd444067f48e0c0d$var$useResolvedDateField;

});

parcelRegister("iZMQb", function(module, exports) {

$parcel$export(module.exports, "ResolvedDate", () => $c0dfa265d39a6d12$export$a30ef0630a43e5ae);

var $eUqFw = parcelRequire("eUqFw");

var $fee69 = parcelRequire("fee69");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hUGb7 = parcelRequire("hUGb7");

var $hTXM3 = parcelRequire("hTXM3");
const $c0dfa265d39a6d12$export$a30ef0630a43e5ae = ({ date: date })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return date !== null && date !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUGb7.default), {
        date: date,
        text: formatMessage((0, $hTXM3.default).resolvedLabel)
    })) : null;
};

});
parcelRegister("hTXM3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5b7d72c9e82a761$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a5b7d72c9e82a761$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    resolvedLabel: {
        "id": "resolved-date.read.resolved-label",
        "defaultMessage": "Resolved"
    }
});

});




parcelRegister("kIxSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7770385c37c995da$export$2e2bcd8739ae039);

var $bv5MS = parcelRequire("bv5MS");

var $7770385c37c995da$export$2e2bcd8739ae039 = (0, $bv5MS.UpdatedDateField);

});
parcelRegister("bv5MS", function(module, exports) {

$parcel$export(module.exports, "UpdatedDateField", () => $70bef4c6e9c8b949$export$38578e62a97aeba2);

var $eUqFw = parcelRequire("eUqFw");

var $9IJNi = parcelRequire("9IJNi");

var $9hvP9 = parcelRequire("9hvP9");
const $70bef4c6e9c8b949$export$38578e62a97aeba2 = ({ issueKey: issueKey })=>{
    const [{ value: updatedDate }] = (0, $9IJNi.default)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9hvP9.UpdatedDate), {
        date: updatedDate
    });
};

});
parcelRegister("9IJNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2441f7ccf934e195$export$2e2bcd8739ae039);

var $kmr29 = parcelRequire("kmr29");

var $lO4Or = parcelRequire("lO4Or");
const $2441f7ccf934e195$var$useUpdatedDateField = ({ issueKey: issueKey })=>{
    const [value] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.UPDATED)
    });
    return [
        {
            value: value
        }
    ];
};
var $2441f7ccf934e195$export$2e2bcd8739ae039 = $2441f7ccf934e195$var$useUpdatedDateField;

});

parcelRegister("9hvP9", function(module, exports) {

$parcel$export(module.exports, "UpdatedDate", () => $6a299e8d87b4f712$export$b35f52e6703bf6e5);

var $eUqFw = parcelRequire("eUqFw");

var $fee69 = parcelRequire("fee69");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hUGb7 = parcelRequire("hUGb7");


var $bp60k = parcelRequire("bp60k");
const $6a299e8d87b4f712$export$b35f52e6703bf6e5 = ({ date: date })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return date !== null && date !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUGb7.default), {
        testId: (0, $efc8386f27caf0ff$export$5af0222d5fa60156),
        date: date,
        text: formatMessage((0, $bp60k.default).updatedLabel)
    })) : null;
};

});
const $efc8386f27caf0ff$export$5af0222d5fa60156 = 'updated-date.ui.read.meta-date';

parcelRegister("bp60k", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2cf7bb0aad8707$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7c2cf7bb0aad8707$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    updatedLabel: {
        "id": "updated-date.read.updated-label",
        "defaultMessage": "Updated"
    }
});

});





parcelRegister("1vsSU", function(module, exports) {

$parcel$export(module.exports, "actionDispatchToProps", () => $d0798527b149106f$export$3a5ba3fabde143a0);
$parcel$export(module.exports, "default", () => $d0798527b149106f$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $lBMPF = parcelRequire("lBMPF");

var $1JRs5 = parcelRequire("1JRs5");

var $lqalZ = parcelRequire("lqalZ");

var $1v6Su = parcelRequire("1v6Su");

var $hHnBv = parcelRequire("hHnBv");

var $6ySNE = parcelRequire("6ySNE");

var $bCaZl = parcelRequire("bCaZl");

var $f62OU = parcelRequire("f62OU");

var $cn1uL = parcelRequire("cn1uL");

var $49xWy = parcelRequire("49xWy");

var $hficN = parcelRequire("hficN");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $isrrj = parcelRequire("isrrj");

var $lO4Or = parcelRequire("lO4Or");

var $kEYGi = parcelRequire("kEYGi");

var $4CPxR = parcelRequire("4CPxR");
const $d0798527b149106f$export$3a5ba3fabde143a0 = (dispatch)=>({
        onAddAttachmentClick: ()=>{
            dispatch((0, $1v6Su.attachmentPickerPopupOpenSuccess)());
        },
        onCreateSubtaskClick: ()=>{
            dispatch((0, $hHnBv.subtaskQuickAddClicked)());
        },
        onCreateIssueInEpicClick: ()=>{
            dispatch((0, $hHnBv.issueInEpicQuickAddClicked)());
        },
        onAddIssueLinkClick: ()=>{
            dispatch((0, $49xWy.addIssueLinkClick)());
        },
        onChildCreateClick: ()=>{
            dispatch((0, $hHnBv.childIssueQuickAddClicked)());
        },
        onLinkConfluencePageClick: ()=>{
            dispatch((0, $6ySNE.linkConfluencePageClicked)());
        },
        onInvestigateIncidentClick: ()=>{
            dispatch((0, $cn1uL.investigateIncidentClicked)());
        },
        onAddWebLinkClick: ()=>{
            dispatch((0, $hficN.showCreateWebLinkForm)());
        }
    });
const $d0798527b149106f$var$QuickAddItemswithContainerWidth = (0, $lBMPF.default)((0, $kEYGi.QuickAddItems));
var $d0798527b149106f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $1JRs5.default)({
    fieldKey: (0, $lO4Or.SERVICEDESK_PRACTICES_TYPE),
    propName: 'practices'
}), (0, $lqalZ.connect)((state)=>({
        ...(0, $isrrj.quickAddItemsPermissionsSelector)(state),
        locale: (0, $5JqpU.localeSelector)(state),
        projectType: (0, $jZDJX.projectTypeSelector)(state),
        issueKey: (0, $5JqpU.issueKeySelector)(state),
        isAnonymousUser: (0, $5JqpU.isAnonymousSelector)(state)
    }), (dispatch)=>({
        ...$d0798527b149106f$export$3a5ba3fabde143a0(dispatch),
        onAddExtension: (extension)=>{
            dispatch((0, $bCaZl.addContentPanelRequest)(extension));
        },
        onSelectContentPanel: (addonModuleKey)=>{
            dispatch((0, $bCaZl.contentPanelSelected)(addonModuleKey));
        },
        fetchConfluenceAppLinks: ()=>{
            dispatch((0, $f62OU.fetchConfluenceAppLinks)());
        }
    })))($d0798527b149106f$var$QuickAddItemswithContainerWidth);

});
parcelRegister("1JRs5", function(module, exports) {

$parcel$export(module.exports, "default", () => $68e27ba13a0b6681$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kmr29 = parcelRequire("kmr29");
/**
 * HOC subscriber to the fieldValue sweet-state store
 * @param fieldKey key for the field to get
 * @param propName wrapped component property to set field value to
 * @param isEnabled if returns true, hoc will add field value to the wrapped component, otherwise it will
 *                  add only passed properties. Useful when FF needs to be checked, as FF check outside of
 *                  render function breaks the SSR
 * @param FieldValueSubscriber field value subscriber DI
 * @returns Wrapped component
 */ const $68e27ba13a0b6681$var$withFieldValue = ({ fieldKey: fieldKey, propName: propName, isEnabled: isEnabled = ()=>true, FieldValueSubscriber: FieldValueSubscriber = (0, $kmr29.FieldValueSubscriber) })=>(WrappedComponent)=>(ownProps)=>{
            if (!isEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, ownProps);
            const { issueKey: issueKey } = ownProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldValueSubscriber, {
                issueKey: issueKey,
                fieldKey: fieldKey
            }, (fieldValue)=>{
                const props = {
                    ...ownProps,
                    [propName]: fieldValue
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props);
            });
        };
var $68e27ba13a0b6681$export$2e2bcd8739ae039 = $68e27ba13a0b6681$var$withFieldValue;

});

parcelRegister("isrrj", function(module, exports) {

$parcel$export(module.exports, "quickAddItemsPermissionsSelector", () => $957f710203406aea$export$7de445dfe3e9bafc);

var $df4Sl = parcelRequire("df4Sl");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $1b2Vj = parcelRequire("1b2Vj");

var $7SLq9 = parcelRequire("7SLq9");

var $kZlOa = parcelRequire("kZlOa");

var $dOXkm = parcelRequire("dOXkm");

var $7FqHc = parcelRequire("7FqHc");

var $ddnuS = parcelRequire("ddnuS");

var $dv9do = parcelRequire("dv9do");

var $6gpYd = parcelRequire("6gpYd");
const $957f710203406aea$export$7de445dfe3e9bafc = (0, $df4Sl.createSelector)((0, $dv9do.canCreateSubtaskSelector), (0, $kZlOa.canCreateIssuesInEpicSelector), (0, $1b2Vj.supportsChildCreationSelector), (0, $jZDJX.isEpicSelector), (0, $7SLq9.canCreateAttachmentsSelector), (0, $ddnuS.canAddIssueLinksSelector), (0, $5JqpU.isServiceDeskSelector), (0, $5JqpU.isAnonymousSelector), (0, $dOXkm.canLinkConfluencePageSelector), (0, $6gpYd.canAddWebLinksSelector), (0, $7FqHc.canEditIssuesSelector), (canCreateSubtask, canCreateIssuesInEpic, supportsChildCreation, isEpic, canCreateAttachment, canCreateIssueLink, isServiceDesk, isAnonymous, canLinkConfluencePage, canAddWebLinks, canEditIssues)=>{
    const shouldShowIssueInEpicButton = canCreateIssuesInEpic && !supportsChildCreation && isEpic;
    const shouldShowCreateSubtaskButton = canCreateSubtask && !supportsChildCreation && !shouldShowIssueInEpicButton;
    return {
        canCreateAttachment: canCreateAttachment,
        shouldShowCreateSubtaskButton: shouldShowCreateSubtaskButton,
        shouldShowIssueInEpicButton: shouldShowIssueInEpicButton,
        supportsChildCreation: supportsChildCreation,
        canCreateIssueLink: canCreateIssueLink,
        isServiceDesk: isServiceDesk,
        isAnonymousUser: isAnonymous,
        canLinkConfluencePage: canLinkConfluencePage,
        canAddWebLinks: canAddWebLinks,
        canEditIssues: canEditIssues
    };
});

});
parcelRegister("kZlOa", function(module, exports) {

$parcel$export(module.exports, "canCreateIssuesInEpicSelector", () => $d4a69c8261acc616$export$a48d521512591de6);

var $df4Sl = parcelRequire("df4Sl");

var $5JqpU = parcelRequire("5JqpU");

var $9F6MO = parcelRequire("9F6MO");

var $ke6cX = parcelRequire("ke6cX");
const $d4a69c8261acc616$var$hasUnsupportedTypeSelector = (0, $df4Sl.createSelector)((0, $ke6cX.issueTypesForClassicProjectEpicSelector), (issueTypes)=>!!issueTypes.find((0, $ke6cX.hasUnsupportedType)));
const $d4a69c8261acc616$export$a48d521512591de6 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), $d4a69c8261acc616$var$hasUnsupportedTypeSelector, (0, $5JqpU.isMobileSelector), (0, $5JqpU.isBitbucketSelector), // @ts-expect-error - TS2339 - Property 'canCreateIssuesInClassicProjectEpic' does not exist on type 'Permissions'.
({ canCreateIssuesInClassicProjectEpic: canCreateIssuesInClassicProjectEpic }, hasUnsupportedTypes, isMobile, isBitbucket)=>{
    const shouldHideForMobileOrBitbucket = hasUnsupportedTypes ? isMobile || isBitbucket : false;
    return canCreateIssuesInClassicProjectEpic && !shouldHideForMobileOrBitbucket;
});

});


parcelRegister("kEYGi", function(module, exports) {

$parcel$export(module.exports, "QuickAddItems", () => $de8f70b74bb083d9$export$2a22c5c29a389552);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $8sN8t = parcelRequire("8sN8t");

var $8cU5f = parcelRequire("8cU5f");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2wCUM = parcelRequire("2wCUM");

var $jFDB6 = parcelRequire("jFDB6");



var $eMxRI = parcelRequire("eMxRI");

var $LVaY5 = parcelRequire("LVaY5");

var $5OaGg = parcelRequire("5OaGg");

var $fq6rr = parcelRequire("fq6rr");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");

var $kS8l2 = parcelRequire("kS8l2");

var $blBdM = parcelRequire("blBdM");
var $bDQbB = parcelRequire("bDQbB");

var $l3wGN = parcelRequire("l3wGN");

var $f1lMr = parcelRequire("f1lMr");

var $6vrw7 = parcelRequire("6vrw7");

var $jK1pm = parcelRequire("jK1pm");

var $keVDO = parcelRequire("keVDO");

var $kexaW = parcelRequire("kexaW");

var $lPRkf = parcelRequire("lPRkf");

var $5TSLN = parcelRequire("5TSLN");

var $3bM93 = parcelRequire("3bM93");

var $7SjRo = parcelRequire("7SjRo");

var $aqpSx = parcelRequire("aqpSx");

var $2sCaG = parcelRequire("2sCaG");

var $4CPxR = parcelRequire("4CPxR");

var $20g0V = parcelRequire("20g0V");

var $1hkvR = parcelRequire("1hkvR");
const $de8f70b74bb083d9$export$2a22c5c29a389552 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { register: register }] = (0, $kS8l2.useGlobalRefStoreActions)();
    const { onAddAttachmentClick: onAddAttachmentClick, onAddWebLinkClick: onAddWebLinkClick, onLinkConfluencePageClick: onLinkConfluencePageClick, fetchConfluenceAppLinks: fetchConfluenceAppLinks, triggerButtonClickAnalytics: triggerButtonClickAnalytics, onSelectContentPanel: onSelectContentPanel, isServiceDesk: isServiceDesk, isAnonymousUser: isAnonymousUser, canCreateAttachment: canCreateAttachment, canAddWebLinks: canAddWebLinks, canLinkConfluencePage: canLinkConfluencePage, onAddExtension: onAddExtension, issueKey: issueKey, containerWidth: containerWidth } = props;
    const { shouldBeCompact: shouldBeCompact, setMeasuredRef: setMeasuredRef, forceUpdate: forceUpdate } = (0, $jFDB6.useShouldBeCompact)(containerWidth);
    const [, { openLinkAlertsModal: onLinkAlertsClick }] = (0, $5OaGg.useLinkAlertsModalActions)();
    const createSubtaskRef = (0, $eUqFw.useRef)(null);
    const linkIssueRef = (0, $eUqFw.useRef)(null);
    const [{ value: { hasIssueForms: hasIssueForms, hasProjectForms: hasProjectForms } }, { onClickAddFormButton: onClickAddFormButton }] = (0, $fq6rr.useForms)({
        issueKey: (0, $6vrw7.toIssueKey)(issueKey)
    });
    (0, $eUqFw.useEffect)(()=>{
        fetchConfluenceAppLinks();
    }, [
        fetchConfluenceAppLinks,
        issueKey
    ]);
    (0, $eUqFw.useEffect)(()=>{
        register('quick-add-items.create-subtask', createSubtaskRef.current);
        register('quick-add-items.link-issue', linkIssueRef.current);
    }, [
        register,
        createSubtaskRef,
        linkIssueRef
    ]);
    const sendAnalyticsEvent = (0, $eUqFw.useCallback)((id, itemIndex, handleFunc)=>()=>{
            handleFunc();
            if (typeof triggerButtonClickAnalytics === 'function') triggerButtonClickAnalytics(id, itemIndex, 4);
        }, [
        triggerButtonClickAnalytics
    ]);
    const onAddChildCommand = (0, $eUqFw.useMemo)(()=>(0, $4CPxR.default)({
            ...props,
            formatMessage: formatMessage,
            onLinkAlertsClick: onLinkAlertsClick
        }).issueActions.find(({ id: id })=>[
                (0, $186d4efeb1fdfd01$export$4120809d47d0c2ef),
                (0, $186d4efeb1fdfd01$export$1881ebb86087228d),
                (0, $186d4efeb1fdfd01$export$53277773f5d5866d)
            ].includes(id))?.onClick, [
        formatMessage,
        onLinkAlertsClick,
        props
    ]);
    const shouldRenderAttachCommand = !isServiceDesk && canCreateAttachment;
    (0, $lPRkf.useRegisterQuickAddInCommandPalette)({
        onAddAttachmentClick: onAddAttachmentClick,
        onAddAUrlClick: onAddWebLinkClick,
        onLinkConfluencePageClick: onLinkConfluencePageClick,
        onAddChildCommand: onAddChildCommand ?? (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        isAttachCommandEnabled: shouldRenderAttachCommand,
        isAddAUrlEnabled: canAddWebLinks,
        isLinkConfluencePageEnabled: canLinkConfluencePage,
        isAddChildEnabled: onAddChildCommand !== undefined
    });
    const createItemView = (0, $eUqFw.useCallback)((itemToRender)=>{
        const { id: id, tooltip: tooltip, label: label, icon: icon, onClick: onClick, itemIndex: itemIndex, testId: testId, hasGlobalSpotlightTarget: hasGlobalSpotlightTarget, hasSpotlightPulse: hasSpotlightPulse, noWrapper: noWrapper } = itemToRender;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: tooltip,
            position: "bottom",
            key: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aqpSx.default), {
            key: id,
            id: id,
            icon: icon,
            onClick: sendAnalyticsEvent(id, itemIndex, onClick),
            label: label,
            compactMode: shouldBeCompact,
            testId: testId,
            hasGlobalSpotlightTarget: hasGlobalSpotlightTarget,
            hasSpotlightPulse: hasSpotlightPulse,
            noWrapper: noWrapper,
            ...id === (0, $186d4efeb1fdfd01$export$4120809d47d0c2ef) && {
                ref: createSubtaskRef
            }
        }));
    }, [
        sendAnalyticsEvent,
        shouldBeCompact,
        createSubtaskRef
    ]);
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const [{ canEditIssues: canEditIssues }] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const [practices] = (0, $2wCUM.usePracticesFieldValue)({
        issueKey: issueKey
    });
    const shouldShowScheduleChangeButton = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    canEditIssues && (practices?.some((practice)=>practice === (0, $f1lMr.CHANGES)) ?? false);
    const isIssueOfIncidentsPractice = (0, $2wCUM.useIsIssueOfIncidentsPractice)();
    const isDeveloperEscalationsEnabled = (0, $bDQbB.useIsDeveloperEscalationsEnabled)();
    const getQuickAddActionData = (0, $eUqFw.useCallback)(()=>{
        const { issueActions: issueActions, linkingActions: linkingActions } = (0, $4CPxR.default)({
            ...props,
            formatMessage: formatMessage,
            onLinkAlertsClick: onLinkAlertsClick
        });
        const mappedIssueActions = issueActions.map(createItemView);
        const dropdownMessage = shouldBeCompact ? (0, $20g0V.default).linkDropdownButtonCompactLabel : (0, $20g0V.default).linkDropdownButtonLabel;
        const dropdownTooltipLabel = formatMessage(dropdownMessage);
        const linkButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3bM93.default), {
            compactMode: shouldBeCompact,
            actions: linkingActions,
            tooltipLabel: dropdownTooltipLabel,
            ref: linkIssueRef
        });
        const linkButtonActions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
            key: "quick-add-web-link-button",
            name: `${(0, $eMxRI.ISSUE_FIELD_SPOTLIGHT_PREFIX)}${(0, $186d4efeb1fdfd01$export$fd149869be79c530)}`
        }, linkButton);
        const reviewButton = isIssueOfIncidentsPractice && props.canCreateIssueLink ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3wGN.AsyncReviewButton), {
                onAddIssueLinkClick: props.onAddIssueLinkClick,
                compactMode: shouldBeCompact,
                key: "async-review-button"
            })
        ] : [];
        const changeManagementActions = [
            shouldShowScheduleChangeButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2sCaG.ScheduleChangeButton), {
                key: (0, $186d4efeb1fdfd01$export$37044520a5955cb1),
                createItemView: createItemView
            })
        ].filter(Boolean);
        const developerEscalationsAction = isDeveloperEscalationsEnabled ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $blBdM.AsyncDeveloperEscalationsButton), {
                key: "async-developer-escalations-button",
                createItemView: createItemView
            })
        ] : [];
        const ecosystemActions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LVaY5.default), {
            key: "quick-add-content-panel",
            externalId: "issue.ecosystem.quick-add-content-panel",
            // @ts-expect-error - TS7006 - Parameter 'addonModuleKey' implicitly has an 'any' type.
            onSelectContentPanel: (addonModuleKey)=>{
                onSelectContentPanel(addonModuleKey);
                triggerButtonClickAnalytics((0, $186d4efeb1fdfd01$export$a43a3d706c1a1e2a), 3, 4);
            },
            // @ts-expect-error - TS7006 - Parameter 'extension' implicitly has an 'any' type.
            onAddExtension: (extension)=>{
                onAddExtension(extension);
                triggerButtonClickAnalytics((0, $186d4efeb1fdfd01$export$916320efd0fb57ba), 3, 4);
            },
            createItemView: createItemView,
            startIndex: mappedIssueActions.length
        });
        const formsActions = hasProjectForms ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kexaW.AddFormButton), {
                key: "add-form-button",
                createItemView: createItemView,
                onClick: onClickAddFormButton,
                hasIssueForms: hasIssueForms
            })
        ] : [];
        const designActions = !isAnonymousUser && canEditIssues ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $keVDO.AddDesignItem), {
                key: "add-design-button",
                createItemView: createItemView,
                onMount: forceUpdate
            })
        ] : [];
        const asyncConfluenceContentMenu = (0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-pages', false) ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5TSLN.CreateConfluenceContentMenu), {
                key: "create-confluence-content-menu",
                appearance: shouldBeCompact ? 'compact' : ''
            })
        ] : [];
        const loomRecordVideoButton = (0, $1ybV0.ff)('loom-quick-action-button-in-issue-view_pvh5u', false) ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7SjRo.LoomQuickAddItemView), {
                key: "loom-record-video",
                shouldBeCompact: shouldBeCompact
            })
        ] : [];
        return [
            ...mappedIssueActions,
            linkButtonActions,
            ...changeManagementActions,
            ...formsActions,
            ...reviewButton,
            ...developerEscalationsAction,
            ...designActions,
            ...asyncConfluenceContentMenu,
            ...loomRecordVideoButton,
            ecosystemActions
        ];
    }, [
        props,
        formatMessage,
        onLinkAlertsClick,
        createItemView,
        shouldBeCompact,
        isIssueOfIncidentsPractice,
        shouldShowScheduleChangeButton,
        isDeveloperEscalationsEnabled,
        hasProjectForms,
        onClickAddFormButton,
        hasIssueForms,
        isAnonymousUser,
        forceUpdate,
        onSelectContentPanel,
        triggerButtonClickAnalytics,
        onAddExtension,
        canEditIssues
    ]);
    const actions = getQuickAddActionData();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "issue-quick-add-items"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "jira.issuebase.quickadditems"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
        name: (0, $ab3fc2ac1a2f2638$export$1ba8bc5ff9e50d09)
    }, actions.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1hkvR.QuickAddWrapper), {
        ref: setMeasuredRef('quick-add-items')
    }, actions) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null))));
};
$de8f70b74bb083d9$export$2a22c5c29a389552.defaultProps = {
    canCreateIssueLink: false,
    canCreateAttachment: false,
    canLinkConfluencePage: false,
    canAddWebLinks: false,
    triggerButtonClickAnalytics: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};

});
const $186d4efeb1fdfd01$export$ce507a739019b88f = 'attachment';
const $186d4efeb1fdfd01$export$4120809d47d0c2ef = 'create-subtask';
const $186d4efeb1fdfd01$export$1881ebb86087228d = 'create-issue-in-epic';
const $186d4efeb1fdfd01$export$fd149869be79c530 = 'issue-links';
const $186d4efeb1fdfd01$export$916320efd0fb57ba = 'add_contentpanel';
const $186d4efeb1fdfd01$export$a43a3d706c1a1e2a = 'select_contentpanel';
const $186d4efeb1fdfd01$export$53277773f5d5866d = 'create-child';
const $186d4efeb1fdfd01$export$f8c55ed63efafeaa = 'link-confluence-page';
const $186d4efeb1fdfd01$export$4aeabd8adfb8f280 = 'link-alerts';
const $186d4efeb1fdfd01$export$a166f12df222f496 = 'add-web-link';
const $186d4efeb1fdfd01$export$37044520a5955cb1 = 'schedule-change';
const $186d4efeb1fdfd01$export$8764350a3b03b53 = 'add-form';
const $186d4efeb1fdfd01$export$5a77973997addb1e = 'description';
const $186d4efeb1fdfd01$export$2361268bb33d7359 = 'investigate-incident';
const $186d4efeb1fdfd01$export$4587d388b59a4ea7 = 'add-design';

parcelRegister("LVaY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $954b5047843ce1d6$export$2e2bcd8739ae039);
/* ecosystem-content-panel-quickadd-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dxIU5 = parcelRequire("dxIU5");

var $3hSi4 = parcelRequire("3hSi4");

var $c8Guq = parcelRequire("c8Guq");

var $jG2Eu = parcelRequire("jG2Eu");

var $bbaTG = parcelRequire("bbaTG");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $gO9Xw = parcelRequire("gO9Xw");

var $iFXD5 = parcelRequire("iFXD5");

var $jG1wZ = parcelRequire("jG1wZ");

var $8cU5f = parcelRequire("8cU5f");

var $8un0w = parcelRequire("8un0w");

var $hnzPP = parcelRequire("hnzPP");

var $c9TLT = parcelRequire("c9TLT");

var $dnhZn = parcelRequire("dnhZn");

var $1ybV0 = parcelRequire("1ybV0");

var $gdPSX = parcelRequire("gdPSX");

var $7C4za = parcelRequire("7C4za");

var $90IgZ = parcelRequire("90IgZ");
var $4ksts = parcelRequire("4ksts");

var $fkvsU = parcelRequire("fkvsU");

var $wKt79 = parcelRequire("wKt79");

var $duMa0 = parcelRequire("duMa0");

var $8ogeO = parcelRequire("8ogeO");

var $lqalZ = parcelRequire("lqalZ");

var $hficN = parcelRequire("hficN");

var $5JqpU = parcelRequire("5JqpU");


var $8CSFK = parcelRequire("8CSFK");

var $8QKSg = parcelRequire("8QKSg");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $954b5047843ce1d6$var$SHOW_EXTENSION_COUNT_THRESHOLD = 3;
const $954b5047843ce1d6$export$3036909f1e6a314e = 'issue.views.issue-base.foundation.quick-add.ecosystem-content-button';
const $954b5047843ce1d6$var$iconSize = (0, $c9TLT.gridSize) * 3; // FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ const $954b5047843ce1d6$var$messages = (0, $90IgZ.defineMessages)({
    quickAddAddonLabel: {
        "id": "issue.quickadd.addon",
        "defaultMessage": "Add app"
    },
    addMore: {
        "id": "issue.quickadd.addon.add.more",
        "defaultMessage": "Add apps"
    }
}); // @ts-expect-error - TS7006 - Parameter 'extension' implicitly has an 'any' type.
const $954b5047843ce1d6$var$isNewExtension = (extension)=>!!extension.tooltip && !!extension.iconUrl;
const $954b5047843ce1d6$export$c0117b1abc6c64e3 = (0, $g8JvH.AnalyticsEventToProps)('dropdownItem', {
    onClick: 'clicked'
})((0, $hD6GJ.default));
const $954b5047843ce1d6$export$57f94bec3a197244 = ({ canInstallAddons: canInstallAddons = false, canSaveForgeIssuePanel: canSaveForgeIssuePanel = true, availableAddons: availableAddons = [], contentPanelsInIssue: contentPanelsInIssue = [], onContentPanelListLoadedAnalytics: // @ts-expect-error - TS2322 - Type '(...args: any[]) => void' is not assignable to type '(obj: PanelListAnalytics) => null | undefined'.
onContentPanelListLoadedAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onContentPanelAddAnalytics: // @ts-expect-error - TS2322 - Type '(...args: any[]) => void' is not assignable to type '(data: AppKeyModuleKeyType) => null | undefined'.
onContentPanelAddAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onContentPanelFocusAnalytics: // @ts-expect-error - TS2322 - Type '(...args: any[]) => void' is not assignable to type '(data: AppKeyModuleKeyType) => null | undefined'.
onContentPanelFocusAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onAddExtensionsClick: // @ts-expect-error - TS2322 - Type '(...args: any[]) => void' is not assignable to type '(eventData: EventData) => null | undefined'.
onAddExtensionsClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onQuickAddClick: onQuickAddClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), startIndex: startIndex, createItemView: createItemView, source: source, onSelectContentPanel: onSelectContentPanel, onAddExtension: onAddExtension, baseUrl: baseUrl, onAddExtensionsDropdownTriggerClick: // @ts-expect-error - TS2322 - Type '(...args: any[]) => void' is not assignable to type '(eventData: EventData) => null | undefined'.
onAddExtensionsDropdownTriggerClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (availableAddons.length > 0) onContentPanelListLoadedAnalytics((0, $8ogeO.contentPanelAnalyticsOnLoad)(availableAddons, contentPanelsInIssue));
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getFallbackIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXD5))), {
            size: "medium",
            label: props.name
        });
    const getIcon = (0, $eUqFw.useCallback)((extension)=>extension.iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
            title: extension.name,
            url: extension.iconUrl,
            width: $954b5047843ce1d6$var$iconSize,
            height: $954b5047843ce1d6$var$iconSize,
            fallback: ()=>getFallbackIcon({
                    name: extension.name
                })
        }) : getFallbackIcon({
            name: extension.name
        }), []);
    const getExtensionsToShowIconsFor = (0, $eUqFw.useCallback)(()=>availableAddons.filter($954b5047843ce1d6$var$isNewExtension).slice(0, $954b5047843ce1d6$var$SHOW_EXTENSION_COUNT_THRESHOLD), [
        availableAddons
    ]);
    const getExtensionsToShowInDropdown = (0, $eUqFw.useCallback)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3hSi4)))(availableAddons, getExtensionsToShowIconsFor(), 'moduleKey'), [
        availableAddons,
        getExtensionsToShowIconsFor
    ]);
    const sendQuickAddClickedEvent = (0, $eUqFw.useCallback)((isNewToIssue, name, appKey, moduleKey, isForge, analyticEvent)=>{
        if (analyticEvent) {
            const attributes = {
                addon_key: appKey,
                key: moduleKey,
                isNewToIssue: isNewToIssue.toString()
            };
            (0, $jMP2a.fireUIAnalytics)(analyticEvent, attributes);
        } // Should always call onQuickAddClick, because connect apps are relying on its event broadcasting
        onQuickAddClick((0, $0effd28d911d2d1b$export$8b56667c724a6334), {
            addon_key: appKey,
            key: moduleKey
        }, {
            isNewToIssue: isNewToIssue.toString()
        });
        if (isForge) {
            const issueViewAnalytics = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'forgeApp'
            });
            const appName = name.replaceAll(/\s/g, '');
            const attributes = {
                appName: appName,
                appKey: appKey,
                moduleKey: moduleKey,
                actionType: 'forge'
            };
            (0, $jMP2a.fireUIAnalytics)(issueViewAnalytics, attributes); // Forge UI analytics
            (0, $gdPSX.fireUiTriggerSelectedEvent)(source, {
                isNewToIssue: isNewToIssue
            });
        }
    }, [
        onQuickAddClick,
        source,
        createAnalyticsEvent
    ]);
    const itemSelected = (0, $eUqFw.useCallback)((extension, analyticEvent)=>{
        const staticModuleKey = (0, $duMa0.removeTimestamp)(extension.moduleKey, 10);
        const isForge = extension.type === (0, $fkvsU.FORGE_ENTITY_TYPE);
        let extensionId = isForge ? (0, $7C4za.toForgeKey)(extension.appKey, extension.moduleKey) : (0, $7C4za.toConnectKey)(extension.appKey, extension.moduleKey);
        if (isForge) {
            const prefix = `${extensionId}-`;
            const panelKey = contentPanelsInIssue.find((key)=>(0, $7C4za.isKeyMatchPrefix)(key, prefix)); // when allowMultiple is true we do not override extensionId to invoke onAddExtension prop
            // @ts-expect-error - TS2339 - Property 'allowMultiple' does not exist on type 'Panel | EcosystemContentPanel'.
            if (panelKey != null && extension.allowMultiple === false) extensionId = panelKey;
        }
        if (extension.showByDefault || contentPanelsInIssue.includes(`${extension.appKey}_${staticModuleKey}`) || contentPanelsInIssue.includes(extensionId)) {
            onContentPanelFocusAnalytics((0, $8ogeO.contentPanelAnalyticsData)(extension.appKey, extension.moduleKey));
            onSelectContentPanel(extensionId);
            sendQuickAddClickedEvent(false, extension.name, extension.appKey, extension.moduleKey, isForge, analyticEvent);
        } else if (!(isForge && !canSaveForgeIssuePanel)) {
            onContentPanelAddAnalytics((0, $8ogeO.contentPanelAnalyticsData)(extension.appKey, extension.moduleKey));
            onAddExtension(extensionId);
            sendQuickAddClickedEvent(true, extension.name, extension.appKey, extension.moduleKey, isForge, analyticEvent);
        }
    }, [
        canSaveForgeIssuePanel,
        contentPanelsInIssue,
        onAddExtension,
        onContentPanelAddAnalytics,
        onContentPanelFocusAnalytics,
        onSelectContentPanel,
        sendQuickAddClickedEvent
    ]); // eslint does not understand the deboune
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedItemSelected = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(itemSelected, 300), [
        itemSelected
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            debouncedItemSelected.cancel();
        }, [
        debouncedItemSelected
    ]);
    const transformExtension = (0, $eUqFw.useCallback)((extension)=>{
        const dropDownItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($954b5047843ce1d6$export$c0117b1abc6c64e3, {
            key: extension.moduleKey,
            elemBefore: getIcon(extension),
            onClick: (_, analyticEvent)=>itemSelected(extension, analyticEvent)
        }, extension.name);
        return extension.tooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: extension.tooltip,
            key: extension.moduleKey
        }, dropDownItem) : dropDownItem;
    }, [
        getIcon,
        itemSelected
    ]);
    const createDropdownItems = (0, $eUqFw.useCallback)((extensions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, extensions.map(transformExtension), canInstallAddons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($954b5047843ce1d6$export$c0117b1abc6c64e3, {
            key: $954b5047843ce1d6$var$messages.addMore.id,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($954b5047843ce1d6$export$b50a704410e6837e, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                label: formatMessage($954b5047843ce1d6$var$messages.addMore)
            })),
            onClick: (_, analyticEvent)=>onAddExtensionsClick(analyticEvent),
            href: `${baseUrl}/plugins/servlet/upm/marketplace/featured`,
            target: "_new"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($954b5047843ce1d6$export$b50a704410e6837e, null, formatMessage($954b5047843ce1d6$var$messages.addMore)))), [
        baseUrl,
        canInstallAddons,
        formatMessage,
        onAddExtensionsClick,
        transformExtension
    ]);
    const transformExtensionToQuickIcon = (0, $eUqFw.useCallback)((extension, currentIndex)=>createItemView({
            id: `${extension.appKey}_${extension.moduleKey}`,
            testId: `${$954b5047843ce1d6$export$3036909f1e6a314e}.${extension.appKey}_${extension.moduleKey}`,
            label: extension.tooltip || extension.name,
            icon: getIcon(extension),
            onClick: (_, analyticEvent)=>debouncedItemSelected(extension, analyticEvent),
            itemIndex: startIndex + currentIndex
        }), [
        createItemView,
        getIcon,
        debouncedItemSelected,
        startIndex
    ]);
    const extensionsToShow = (0, $eUqFw.useMemo)(()=>{
        const extensionsToShowinLocal = getExtensionsToShowIconsFor();
        const addonQuickAddItems = extensionsToShowinLocal.filter((addon)=>!((0, $1ybV0.ff)('hrz-716-integrate-goal-picker-into-issue-view') && addon.moduleKey.includes('linked-goals-content-panel'))).map((addon, currentIndex)=>transformExtensionToQuickIcon(addon, currentIndex));
        return addonQuickAddItems;
    }, [
        getExtensionsToShowIconsFor,
        transformExtensionToQuickIcon
    ]);
    const extensionDropdownItems = (0, $eUqFw.useMemo)(()=>{
        const dropdownExtensionItems = getExtensionsToShowInDropdown();
        const shouldRenderDropdown = dropdownExtensionItems.length > 0 || canInstallAddons;
        const eventsProps = {
            onClick: (_, analyticEvent)=>onAddExtensionsDropdownTriggerClick(analyticEvent)
        };
        return shouldRenderDropdown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
            key: "ecosystem-actions-dropdown" // @ts-expect-error - TS2769 - No overload matches this call.
            ,
            boundariesElement: "scrollParent",
            testId: "issue-view-ecosystem.dropdown-menu",
            shouldRenderToParent: true,
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
                    ...triggerProps,
                    spacing: "none",
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($954b5047843ce1d6$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                        size: "medium",
                        label: ""
                    })),
                    theme: (current, props)=>{
                        const styles = current(props);
                        return {
                            ...styles,
                            buttonStyles: {
                                ...styles.buttonStyles,
                                margin: 0
                            }
                        };
                    },
                    "aria-label": formatMessage($954b5047843ce1d6$var$messages.quickAddAddonLabel),
                    ...eventsProps,
                    onClick: (event, analyticEvent)=>{
                        triggerProps?.onClick?.(event);
                        eventsProps.onClick(event, analyticEvent);
                    },
                    ref: triggerRef,
                    interactionName: "auto-generated.jira-issue-view-ecosystem.button"
                })
        }, createDropdownItems(dropdownExtensionItems)) : null;
    }, [
        canInstallAddons,
        createDropdownItems,
        formatMessage,
        getExtensionsToShowInDropdown,
        onAddExtensionsDropdownTriggerClick
    ]); /*
                                                                                                                                   *  Simply returning the list has the same effect as the parent styled-component
                                                                                                                                   *  already provides the inline-flex prop, but this is required as a workaround
                                                                                                                                   *  to enzyme not yet supporting rendered lists
                                                                                                                                   */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($954b5047843ce1d6$export$e4ffa760b2c563f6, {
        "data-testid": "issue-view-ecosystem.ecosystem-actions-wrapper"
    }, [
        ...extensionsToShow,
        extensionDropdownItems
    ]);
};
const $954b5047843ce1d6$export$e46fa66648e0577f = (eventName, addonFilter, eventData)=>{
    (0, $dnhZn.default)(eventName, addonFilter, eventData);
};
const $954b5047843ce1d6$var$UnsafeAddonsQuickAddWithCondition = $954b5047843ce1d6$export$57f94bec3a197244;
const $954b5047843ce1d6$var$UnsafeAddonsQuickAddWithConnect = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $8un0w.default)({
    onAddExtensionsClick: 'quickAddDropdownMenuItem',
    onAddWebLinkClick: 'quickAddWebLink',
    onAddExtensionsDropdownTriggerClick: 'quickAddDropdownMenuTrigger'
}), (0, $lqalZ.connect)((state)=>({
        availableAddons: (0, $8CSFK.ecosystemAllPanelsSelector)(state),
        contentPanelsInIssue: (0, $8CSFK.issueContentPanelsSelector)(state),
        baseUrl: (0, $5JqpU.baseUrlSelector)(state),
        canInstallAddons: (0, $8CSFK.canInstallAddonsSelector)(state),
        canSaveForgeIssuePanel: (0, $8QKSg.forgeUserCanSaveIssuePanelSelector)(state),
        source: (0, $5JqpU.analyticsSourceSelector)(state)
    }), (dispatch)=>({
        onAddWebLinkClick: ()=>dispatch((0, $hficN.showCreateWebLinkForm)()),
        onQuickAddClick: $954b5047843ce1d6$export$e46fa66648e0577f
    })), (0, $wKt79.safeComponent)())($954b5047843ce1d6$var$UnsafeAddonsQuickAddWithCondition);
var $954b5047843ce1d6$export$2e2bcd8739ae039 // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $954b5047843ce1d6$var$UnsafeAddonsQuickAddWithConnect;
const $954b5047843ce1d6$export$be58b4326e23250f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $954b5047843ce1d6$export$e4ffa760b2c563f6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $954b5047843ce1d6$export$b50a704410e6837e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1c86",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3hSi4", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $hKE3p = parcelRequire("hKE3p");

var $7qARj = parcelRequire("7qARj");

var $9eFtX = parcelRequire("9eFtX");

var $cRpul = parcelRequire("cRpul");

var $iTvqy = parcelRequire("iTvqy");
/**
 * This method is like `_.difference` except that it accepts `iteratee` which
 * is invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */ var $264d129342447f48$var$differenceBy = $9eFtX(function(array, values) {
    var iteratee = $iTvqy(values);
    if ($cRpul(iteratee)) iteratee = undefined;
    return $cRpul(array) ? $fa0Ox(array, $hKE3p(values, 1, $cRpul, true), $7qARj(iteratee, 2)) : [];
});
module.exports = $264d129342447f48$var$differenceBy;

});


parcelRegister("5OaGg", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_SELECTED_SAVED_SEARCH_ID", () => $c18d64d6bd27ac92$export$2f24961b1af32904);
$parcel$export(module.exports, "resetState", () => $c18d64d6bd27ac92$export$8e84bad0b35de9e8);
$parcel$export(module.exports, "useLinkedAlertsViewModalState", () => $c18d64d6bd27ac92$export$7b5acacb1fa31394);
$parcel$export(module.exports, "useAlertsSelectionState", () => $c18d64d6bd27ac92$export$16887f9d75568a70);
$parcel$export(module.exports, "useLinkAlertsModalActions", () => $c18d64d6bd27ac92$export$9c2d6b8c43e32fd);
$parcel$export(module.exports, "useSelectedLinkModalAlertIds", () => $c18d64d6bd27ac92$export$68b21fbfd381dfbd);
$parcel$export(module.exports, "useLinkedAlerts", () => $c18d64d6bd27ac92$export$2b66d9ba8a8cb696);
$parcel$export(module.exports, "useLinkedAlertsItems", () => $c18d64d6bd27ac92$export$653fa9b787728633);
$parcel$export(module.exports, "useLinkAlertsModal", () => $c18d64d6bd27ac92$export$b94c36009c550cfb);
$parcel$export(module.exports, "useLinkModalAlerts", () => $c18d64d6bd27ac92$export$9d366ffce42a139d);
$parcel$export(module.exports, "useLinkModalAlertsItems", () => $c18d64d6bd27ac92$export$f27a7c8fabca4144);
$parcel$export(module.exports, "useLinkModalFilter", () => $c18d64d6bd27ac92$export$7a1607816de9838e);
$parcel$export(module.exports, "useSelectedSavedSearch", () => $c18d64d6bd27ac92$export$26c1a24d665090c);
$parcel$export(module.exports, "getSelectedSavedSearchText", () => $c18d64d6bd27ac92$export$c51461579a275a1b);

var $eUqFw = parcelRequire("eUqFw");

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $hJ992 = parcelRequire("hJ992");

var $8L3Y4 = parcelRequire("8L3Y4");

var $g6mpL = parcelRequire("g6mpL");

var $hBeFS = parcelRequire("hBeFS");
var $4CvpM = parcelRequire("4CvpM");

var $aemT3 = parcelRequire("aemT3");
const $c18d64d6bd27ac92$export$2f24961b1af32904 = (0, $4CvpM.PREDEFINED_FILTER_ALL);
const $c18d64d6bd27ac92$export$d4c72bab9d6cc13a = {
    isViewModalOpen: false,
    isLinkModalOpen: false,
    linkedAlerts: {
        forIssueId: undefined,
        isLoading: false,
        error: undefined,
        data: undefined,
        startIndex: null
    },
    linkModalAlerts: {
        startIndex: 0,
        isLoading: true,
        error: undefined,
        data: undefined
    },
    linkModalFilter: {
        selectedSavedSearchId: $c18d64d6bd27ac92$export$2f24961b1af32904,
        savedSearchOptions: {
            isLoading: false,
            error: undefined,
            data: {
                [(0, $g6mpL.PREDEFINED)]: [],
                [(0, $g6mpL.CREATED_BY_ME)]: [],
                [(0, $g6mpL.SHARED_WITH_ME)]: []
            }
        },
        textSearch: undefined
    },
    selectedAlertsToLinkIds: []
};
const $c18d64d6bd27ac92$export$8e84bad0b35de9e8 = (state, setState)=>{
    setState({
        ...$c18d64d6bd27ac92$export$d4c72bab9d6cc13a,
        isViewModalOpen: state.isViewModalOpen,
        isLinkModalOpen: state.isLinkModalOpen,
        linkedAlerts: {
            ...$c18d64d6bd27ac92$export$d4c72bab9d6cc13a.linkedAlerts,
            forIssueId: state.linkedAlerts.forIssueId,
            data: state.linkedAlerts.data,
            startIndex: state.linkedAlerts.startIndex
        },
        linkModalFilter: state.linkModalFilter
    });
};
const $c18d64d6bd27ac92$var$incidentManagementLinkedAlertsStore = (0, $a61MH.createStore)({
    name: 'JSDIncidentManagementLinkedAlertsModal',
    initialState: $c18d64d6bd27ac92$export$d4c72bab9d6cc13a,
    actions: $hBeFS.actions
});
const $c18d64d6bd27ac92$var$_IncidentManagementLinkedAlertsContainerImpl = (0, $heB5U.createContainer)($c18d64d6bd27ac92$var$incidentManagementLinkedAlertsStore);
const $c18d64d6bd27ac92$export$7b5acacb1fa31394 = (0, $ggKAj.createHook)($c18d64d6bd27ac92$var$incidentManagementLinkedAlertsStore, {
    selector: ({ isViewModalOpen: isViewModalOpen })=>isViewModalOpen
});
const $c18d64d6bd27ac92$var$useLinkedAlertsImpl = (0, $ggKAj.createHook)($c18d64d6bd27ac92$var$incidentManagementLinkedAlertsStore, {
    selector: ({ linkedAlerts: linkedAlerts })=>linkedAlerts
});
const $c18d64d6bd27ac92$var$useAlertsSelectionStateInternal = (0, $ggKAj.createHook)($c18d64d6bd27ac92$var$incidentManagementLinkedAlertsStore, {
    selector: ({ linkModalAlerts: { data: data }, selectedAlertsToLinkIds: selectedAlertsToLinkIds })=>{
        if (data?.results == null) return {
            selectedAlertIds: [],
            selectableAlertIds: []
        };
        const selectableAlertIds = (0, $aemT3.getSelectableAlertIds)(data.results);
        return {
            selectedAlertIds: selectedAlertsToLinkIds,
            selectableAlertIds: selectableAlertIds
        };
    }
});
const $c18d64d6bd27ac92$export$16887f9d75568a70 = ()=>{
    const [state, { onSelectAllChange: onSelectAllChange }] = $c18d64d6bd27ac92$var$useAlertsSelectionStateInternal();
    return [
        state,
        onSelectAllChange
    ];
};
const $c18d64d6bd27ac92$export$9c2d6b8c43e32fd = (0, $ggKAj.createHook)($c18d64d6bd27ac92$var$incidentManagementLinkedAlertsStore, {
    selector: null
});
const $c18d64d6bd27ac92$var$useSelectedLinkModalAlertIdsInternal = (0, $ggKAj.createHook)($c18d64d6bd27ac92$var$incidentManagementLinkedAlertsStore, {
    selector: ({ selectedAlertsToLinkIds: selectedAlertsToLinkIds })=>selectedAlertsToLinkIds
});
const $c18d64d6bd27ac92$export$68b21fbfd381dfbd = ()=>{
    const [state, { onAlertCheckboxChanged: onAlertCheckboxChanged }] = $c18d64d6bd27ac92$var$useSelectedLinkModalAlertIdsInternal();
    return [
        state,
        onAlertCheckboxChanged
    ];
};
const $c18d64d6bd27ac92$export$2b66d9ba8a8cb696 = ()=>{
    const issueId = (0, $hJ992.useIssueId)();
    const [hasOpsgenieAccount] = (0, $8L3Y4.useHasCurrentUserOpsgenieAccount)();
    const [linkedAlerts, { fetchLinkedAlerts: fetchLinkedAlerts }] = $c18d64d6bd27ac92$var$useLinkedAlertsImpl();
    return [
        linkedAlerts,
        {
            fetchLinkedAlerts: (0, $eUqFw.useCallback)((cloudId, analyticsEvent, startIndex = null)=>{
                fetchLinkedAlerts({
                    issueId: issueId,
                    cloudId: cloudId,
                    hasOpsgenieAccount: hasOpsgenieAccount,
                    analyticsEvent: analyticsEvent,
                    startIndex: startIndex
                });
            }, [
                fetchLinkedAlerts,
                issueId,
                hasOpsgenieAccount
            ])
        }
    ];
};
const $c18d64d6bd27ac92$export$653fa9b787728633 = ()=>{
    const [{ data: data }] = $c18d64d6bd27ac92$export$2b66d9ba8a8cb696();
    return data;
};
const $c18d64d6bd27ac92$export$b94c36009c550cfb = (0, $ggKAj.createHook)($c18d64d6bd27ac92$var$incidentManagementLinkedAlertsStore, {
    selector: ({ isLinkModalOpen: isLinkModalOpen })=>isLinkModalOpen
});
const $c18d64d6bd27ac92$export$7c08ca85cfadee7a = (0, $dYfll.createSubscriber)($c18d64d6bd27ac92$var$incidentManagementLinkedAlertsStore);
const $c18d64d6bd27ac92$export$9d366ffce42a139d = (0, $ggKAj.createHook)($c18d64d6bd27ac92$var$incidentManagementLinkedAlertsStore, {
    selector: ({ linkModalAlerts: linkModalAlerts })=>linkModalAlerts
});
const $c18d64d6bd27ac92$export$f27a7c8fabca4144 = ()=>{
    const [{ data: data }] = $c18d64d6bd27ac92$export$9d366ffce42a139d();
    return data?.results || [];
};
const $c18d64d6bd27ac92$export$7a1607816de9838e = (0, $ggKAj.createHook)($c18d64d6bd27ac92$var$incidentManagementLinkedAlertsStore, {
    selector: ({ linkModalFilter: linkModalFilter })=>linkModalFilter
});
const $c18d64d6bd27ac92$export$865c5df908503471 = (linkModalFilter)=>{
    let result;
    const { data: data } = linkModalFilter.savedSearchOptions;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const dataKeys = Object.keys(data);
    dataKeys.some((groupKey)=>{
        // .some( is used instead of .forEach( to be able to break out of the loop. Usage of for ... of is prohibited by (an obsolete) eslint rule ("iterators/generators require regenerator-runtime" rule in `no-restricted-syntax` one).
        result = linkModalFilter.savedSearchOptions.data[groupKey].find((savedSearch)=>savedSearch.id === linkModalFilter.selectedSavedSearchId);
        return !!result; // exit loop early
    });
    return result;
};
const $c18d64d6bd27ac92$export$26c1a24d665090c = (0, $ggKAj.createHook)($c18d64d6bd27ac92$var$incidentManagementLinkedAlertsStore, {
    selector: (state)=>$c18d64d6bd27ac92$export$865c5df908503471(state.linkModalFilter)
});
const $c18d64d6bd27ac92$export$c51461579a275a1b = (linkModalFilter, formatMessage)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "preDefined--ALL": MessageDescriptorV2; readonly "preDefined--Open": MessageDescriptorV2; readonly "preDefined--Closed": MessageDescriptorV2; readonly "preDefined--Un'Acked": MessageDescriptorV2; readonly "preDefined--Not Seen": MessageDescriptorV2; readonly "preDefined--Assigned to me": MessageDescriptor...'.
    const predefinedSearchText = (0, $4CvpM.predefinedIdToNameMap)[linkModalFilter.selectedSavedSearchId];
    if (predefinedSearchText) return formatMessage(predefinedSearchText);
    const selectedSavedSearch = $c18d64d6bd27ac92$export$865c5df908503471(linkModalFilter);
    return selectedSavedSearch?.name || '';
};

});
parcelRegister("g6mpL", function(module, exports) {

$parcel$export(module.exports, "CREATED_BY_ME", () => $0e2e29ee99d7a73a$export$cb36dc3cdc08799e);
$parcel$export(module.exports, "SHARED_WITH_ME", () => $0e2e29ee99d7a73a$export$1d098792f806b45d);
$parcel$export(module.exports, "PREDEFINED", () => $0e2e29ee99d7a73a$export$694301a31c85be91);
$parcel$export(module.exports, "SEARCH_ALERTS_PAGE_SIZE", () => $0e2e29ee99d7a73a$export$401ce20f5b86dc23);
$parcel$export(module.exports, "RESPONDER", () => $0e2e29ee99d7a73a$export$c2954eee6922c80f);
$parcel$export(module.exports, "ALERT_STATUS", () => $0e2e29ee99d7a73a$export$ab1ab8f93b50d437);
$parcel$export(module.exports, "MODAL_DISPLAY_STATE", () => $0e2e29ee99d7a73a$export$5586e42b99affb59);
const $0e2e29ee99d7a73a$export$cb36dc3cdc08799e = 'CreatedByMe';
const $0e2e29ee99d7a73a$export$1d098792f806b45d = 'SharedWithMe';
const $0e2e29ee99d7a73a$export$694301a31c85be91 = 'PreDefined';
const $0e2e29ee99d7a73a$export$ff09b90989b21a8 = 'User';
const $0e2e29ee99d7a73a$export$bc8b984358922f81 = 'Team';
const $0e2e29ee99d7a73a$export$2cb68534ade458e0 = 'Schedule';
const $0e2e29ee99d7a73a$export$ebd1c89ae58b8d46 = 'Escalation';
const $0e2e29ee99d7a73a$export$401ce20f5b86dc23 = 30;
const $0e2e29ee99d7a73a$export$c2954eee6922c80f = {
    USER: $0e2e29ee99d7a73a$export$ff09b90989b21a8,
    TEAM: $0e2e29ee99d7a73a$export$bc8b984358922f81,
    SCHEDULE: $0e2e29ee99d7a73a$export$2cb68534ade458e0,
    ESCALATION: $0e2e29ee99d7a73a$export$ebd1c89ae58b8d46
};
const $0e2e29ee99d7a73a$var$OPEN = 'Open';
const $0e2e29ee99d7a73a$var$CLOSED = 'Closed';
const $0e2e29ee99d7a73a$var$ACKED = 'Acked';
const $0e2e29ee99d7a73a$var$SNOOZED = 'Snoozed';
const $0e2e29ee99d7a73a$export$ab1ab8f93b50d437 = {
    OPEN: $0e2e29ee99d7a73a$var$OPEN,
    CLOSED: $0e2e29ee99d7a73a$var$CLOSED,
    ACKED: $0e2e29ee99d7a73a$var$ACKED,
    SNOOZED: $0e2e29ee99d7a73a$var$SNOOZED
};
const $0e2e29ee99d7a73a$var$DATA = 'DATA';
const $0e2e29ee99d7a73a$var$ERROR = 'ERROR';
const $0e2e29ee99d7a73a$var$EMPTY = 'EMPTY';
const $0e2e29ee99d7a73a$var$NO_INCIDENT = 'NO_INCIDENT';
const $0e2e29ee99d7a73a$var$NO_OPSGENIE_ACCOUNT = 'NO_OPSGENIE_ACCOUNT';
const $0e2e29ee99d7a73a$export$5586e42b99affb59 = {
    DATA: $0e2e29ee99d7a73a$var$DATA,
    ERROR: $0e2e29ee99d7a73a$var$ERROR,
    EMPTY: $0e2e29ee99d7a73a$var$EMPTY,
    NO_INCIDENT: $0e2e29ee99d7a73a$var$NO_INCIDENT,
    NO_OPSGENIE_ACCOUNT: $0e2e29ee99d7a73a$var$NO_OPSGENIE_ACCOUNT
};

});

parcelRegister("hBeFS", function(module, exports) {

$parcel$export(module.exports, "actions", () => $107f3af301ac7086$export$e324594224ef24da);

var $gZkwn = parcelRequire("gZkwn");

var $hY0MQ = parcelRequire("hY0MQ");

var $TDfwS = parcelRequire("TDfwS");

var $d6vfY = parcelRequire("d6vfY");

var $jxn5S = parcelRequire("jxn5S");

var $iGmdw = parcelRequire("iGmdw");

var $hFeQx = parcelRequire("hFeQx");

var $1L67x = parcelRequire("1L67x");

var $5PTsQ = parcelRequire("5PTsQ");

var $enh4O = parcelRequire("enh4O");

var $4CvpM = parcelRequire("4CvpM");



const $107f3af301ac7086$export$e324594224ef24da = {
    closeViewModal: $enh4O.closeViewModal,
    openViewModal: $enh4O.openViewModal,
    fetchLinkedAlerts: $hY0MQ.fetchLinkedAlerts,
    searchAlerts: $1L67x.searchAlerts,
    openLinkAlertsModal: $d6vfY.openLinkAlertsModal,
    closeLinkAlertsModal: $d6vfY.closeLinkAlertsModal,
    initLinkModal: $d6vfY.initLinkModal,
    fetchSavedSearches: $TDfwS.fetchSavedSearches,
    setTextSearch: $jxn5S.setTextSearch,
    setSelectedSavedSearchId: $jxn5S.setSelectedSavedSearchId,
    onAlertCheckboxChanged: $hFeQx.onAlertCheckboxChanged,
    linkSelectedAlerts: $iGmdw.linkSelectedAlerts,
    unlinkAlert: $5PTsQ.unlinkAlert,
    onSelectAllChange: $gZkwn.onSelectAllChange
};

});
parcelRegister("gZkwn", function(module, exports) {

$parcel$export(module.exports, "onSelectAllChange", () => $0673e0f0b1790387$export$c2d7d635a1c5e793);

var $aemT3 = parcelRequire("aemT3");
const $0673e0f0b1790387$export$c2d7d635a1c5e793 = (shouldSelectAll)=>({ getState: getState, setState: setState })=>{
        const { linkModalAlerts: linkModalAlerts } = getState();
        const { data: data } = linkModalAlerts;
        if (data?.results == null) return;
        // no need to merge with previous search results ids, since shouldSelectAll is true only if selectedAlertsIds.length is 0
        const newSelectedAlertsToLinkIds = shouldSelectAll ? (0, $aemT3.getSelectableAlertIds)(data.results) : [];
        setState({
            selectedAlertsToLinkIds: newSelectedAlertsToLinkIds
        });
    };

});
parcelRegister("aemT3", function(module, exports) {

$parcel$export(module.exports, "getSelectableAlertIds", () => $55c3fdefa70196e2$export$5e90dcde69069b7c);
const $55c3fdefa70196e2$export$5e90dcde69069b7c = (alerts)=>alerts.filter((alert)=>!alert.isLinked).map((alert)=>alert.id);

});


parcelRegister("hY0MQ", function(module, exports) {

$parcel$export(module.exports, "fetchLinkedAlerts", () => $121c68a3b7bc02fb$export$8a4dab4de8157a61);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");

var $iCRmp = parcelRequire("iCRmp");

var $ipisk = parcelRequire("ipisk");


var $fbc8s = parcelRequire("fbc8s");

var $3VqyI = parcelRequire("3VqyI");
const $121c68a3b7bc02fb$export$8a4dab4de8157a61 = ({ issueId: issueId, cloudId: cloudId, hasOpsgenieAccount: hasOpsgenieAccount = false, analyticsEvent: analyticsEvent, startIndex: startIndex })=>async ({ getState: getState, setState: setState })=>{
        const { linkedAlerts: linkedAlerts } = getState();
        const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
        if (linkedAlerts.isLoading || !issueId || !hasOpsgenieAccount) return;
        // This is to avoid a refetch showing empty state when data exists
        const data = linkedAlerts.forIssueId === issueId ? linkedAlerts.data : undefined;
        setState({
            linkedAlerts: {
                forIssueId: issueId,
                data: data,
                error: undefined,
                isLoading: true,
                startIndex: null
            }
        });
        try {
            const requestUri = startIndex ? `/issue/${issueId}/incident/associated-alerts?size=25&startKey=${startIndex}` : `/issue/${issueId}/incident/associated-alerts?size=25`; // this param is hardcoded here for a reason, see: GHOST-5316
            const response = await (0, $2OdyW.default)(`${(0, $iCRmp.getEscalatorBaseUrl)(cloudId)}${requestUri}`);
            const result = response.results?.map((alert)=>(0, $fbc8s.transformEscalatorAlertResponse)(alert));
            const mergedData = linkedAlerts?.data && startIndex ? [
                ...linkedAlerts?.data,
                ...result
            ] : result;
            setState({
                linkedAlerts: {
                    ...linkedAlerts,
                    forIssueId: issueId,
                    isLoading: false,
                    data: mergedData,
                    startIndex: response.startKey
                }
            });
            analyticsEvent && (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'fetchLinkedAlerts succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            showFlag({
                type: 'error',
                title: (0, $3VqyI.default).errorTitle,
                description: (0, $ipisk.default).errorDescription
            });
            (0, $guiFP.trackFetchErrors)({
                event: analyticsEvent,
                error: e,
                id: 'fetchLinkedAlerts',
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                linkedAlerts: {
                    ...linkedAlerts,
                    forIssueId: issueId,
                    isLoading: false,
                    error: {
                        value: e.message,
                        type: (0, $aaae4dc4d7cd5525$export$2d83167d88c09341)
                    }
                }
            });
        }
    };

});
parcelRegister("ipisk", function(module, exports) {

$parcel$export(module.exports, "default", () => $69a2095e82ac96cc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $69a2095e82ac96cc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorDescription: {
        "id": "linked-alerts.common.error-description",
        "defaultMessage": "We're not quite sure what went wrong. Refresh the page if the error persists."
    }
});

});

const $aaae4dc4d7cd5525$export$2d83167d88c09341 = 'FETCH_LINKED_ALERTS_ERROR';
const $aaae4dc4d7cd5525$export$31f1110b09506e64 = 'SEARCH_ALERTS_ERROR';

parcelRegister("fbc8s", function(module, exports) {

$parcel$export(module.exports, "transformEscalatorAlertResponse", () => $f50a9294cbc86fdc$export$f686c72597d14328);

var $cPeK1 = parcelRequire("cPeK1");

var $g6mpL = parcelRequire("g6mpL");

var $KZeGY = parcelRequire("KZeGY");
// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly P1: "P1"; readonly P2: "P2"; readonly P3: "P3"; readonly P4: "P4"; readonly P5: "P5"; }'.
const $f50a9294cbc86fdc$var$toPriority = (value)=>(0, $cPeK1.PRIORITIES)[value] || (0, $cPeK1.PRIORITIES).P5;
const $f50a9294cbc86fdc$var$toAlertStatus = (status, acknowledgedBy)=>{
    if (status === (0, $g6mpL.ALERT_STATUS).OPEN && acknowledgedBy != null) return (0, $g6mpL.ALERT_STATUS).ACKED;
    if (status === (0, $g6mpL.ALERT_STATUS).CLOSED) return (0, $g6mpL.ALERT_STATUS).CLOSED;
    return (0, $g6mpL.ALERT_STATUS).OPEN;
};
const $f50a9294cbc86fdc$export$f686c72597d14328 = (alert, linkedAlertIds = {})=>{
    const alertId = (0, $KZeGY.toAlertId)(alert.id);
    return {
        id: alertId,
        tinyId: alert.tinyId,
        priority: $f50a9294cbc86fdc$var$toPriority(alert.priority),
        message: alert.message,
        owner: alert.owner,
        responders: alert.responders,
        acknowledgedBy: alert.acknowledgedBy,
        status: $f50a9294cbc86fdc$var$toAlertStatus(alert.status, alert.acknowledgedBy),
        count: alert.count,
        createdAt: alert.createdAt,
        url: alert.url,
        isLinked: !!linkedAlertIds[alertId],
        summary: 'summary'
    };
};

});
parcelRegister("KZeGY", function(module, exports) {

$parcel$export(module.exports, "toAlertId", () => $a7f14cf324827b1a$export$2bafc8614990b833);
const $a7f14cf324827b1a$export$2bafc8614990b833 = (value)=>value;

});


parcelRegister("3VqyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $58bf45a66c4b9fa4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $58bf45a66c4b9fa4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "linked-alerts.services.actions.fetch-linked-alerts.error-title",
        "defaultMessage": "We could not load linked alerts"
    }
});

});


parcelRegister("TDfwS", function(module, exports) {

$parcel$export(module.exports, "fetchSavedSearches", () => $57c36c04a352f819$export$3e0f24bd3cb20a52);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");

var $iCRmp = parcelRequire("iCRmp");

var $g6mpL = parcelRequire("g6mpL");

var $ipisk = parcelRequire("ipisk");

var $hkGX1 = parcelRequire("hkGX1");
const $57c36c04a352f819$export$af3f654b80ed9235 = (data)=>{
    const transformedData = {
        [(0, $g6mpL.PREDEFINED)]: [],
        [(0, $g6mpL.CREATED_BY_ME)]: [],
        [(0, $g6mpL.SHARED_WITH_ME)]: []
    };
    // @ts-expect-error - TS2345 - Argument of type '{ id: string; name: string; description: string | null; alertSearchQuery: string; }' is not assignable to parameter of type 'never'.
    data.forEach(({ category: category, ...rest })=>transformedData[category].push(rest));
    return transformedData;
};
const $57c36c04a352f819$export$3e0f24bd3cb20a52 = ({ cloudId: cloudId, hasOpsgenieAccount: hasOpsgenieAccount = false, analyticsEvent: analyticsEvent })=>async ({ getState: getState, setState: setState })=>{
        const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
        const { linkModalFilter: linkModalFilter } = getState();
        const { savedSearchOptions: savedSearchOptions } = linkModalFilter;
        if (savedSearchOptions.isLoading || !hasOpsgenieAccount) return;
        setState({
            linkModalFilter: {
                ...linkModalFilter,
                savedSearchOptions: {
                    ...savedSearchOptions,
                    isLoading: true
                }
            }
        });
        try {
            const response = await (0, $2OdyW.default)(`${(0, $iCRmp.getEscalatorBaseUrl)(cloudId)}/alerts/saved-searches`);
            setState({
                linkModalFilter: {
                    ...linkModalFilter,
                    savedSearchOptions: {
                        error: undefined,
                        isLoading: false,
                        data: $57c36c04a352f819$export$af3f654b80ed9235(response.results)
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'fetchSavedSearches succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            showFlag({
                type: 'error',
                title: (0, $hkGX1.default).errorTitle,
                description: (0, $ipisk.default).errorDescription
            });
            (0, $guiFP.trackFetchErrors)({
                event: analyticsEvent,
                error: e,
                id: 'fetchSavedSearches',
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                linkModalFilter: {
                    ...linkModalFilter,
                    savedSearchOptions: {
                        ...savedSearchOptions,
                        error: new Error(e),
                        isLoading: false
                    }
                }
            });
        }
    };

});
parcelRegister("hkGX1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1da5ec8d191d433e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1da5ec8d191d433e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    all: {
        "id": "linked-alerts.services.actions.fetch-saved-searches.all",
        "defaultMessage": "All"
    },
    open: {
        "id": "linked-alerts.services.actions.fetch-saved-searches.open",
        "defaultMessage": "Open"
    },
    closed: {
        "id": "linked-alerts.services.actions.fetch-saved-searches.closed",
        "defaultMessage": "Closed"
    },
    unAcked: {
        "id": "linked-alerts.services.actions.fetch-saved-searches.un-acked",
        "defaultMessage": "Un'Acked"
    },
    notSeen: {
        "id": "linked-alerts.services.actions.fetch-saved-searches.not-seen",
        "defaultMessage": "Not seen"
    },
    assigned: {
        "id": "linked-alerts.services.actions.fetch-saved-searches.assigned",
        "defaultMessage": "Assigned to me"
    },
    errorTitle: {
        "id": "linked-alerts.services.actions.fetch-saved-searches.error-title",
        "defaultMessage": "We could not load your saved searches"
    }
});

});


parcelRegister("d6vfY", function(module, exports) {

$parcel$export(module.exports, "openLinkAlertsModal", () => $67e609b10e096654$export$15c727b56d3b3fb1);
$parcel$export(module.exports, "closeLinkAlertsModal", () => $67e609b10e096654$export$acc31e325e6dbe9);
$parcel$export(module.exports, "initLinkModal", () => $67e609b10e096654$export$ff4d6363d0cec0ff);

var $1ybV0 = parcelRequire("1ybV0");

var $7eGvX = parcelRequire("7eGvX");

var $5OaGg = parcelRequire("5OaGg");
const $67e609b10e096654$export$15c727b56d3b3fb1 = (shouldUseJSM)=>({ getState: getState, setState: setState })=>{
        // need to reset state since closeLinkAlertsModal() is not always called when Link modal is closed (e.g. after you linked alerts).
        (0, $5OaGg.resetState)({
            ...getState(),
            isLinkModalOpen: true,
            ...(0, $1ybV0.ff)('linked-alerts-feedback-release-update') && shouldUseJSM ? {} : {
                isViewModalOpen: false
            }
        }, setState);
    };
const $67e609b10e096654$export$acc31e325e6dbe9 = ()=>({ getState: getState, setState: setState })=>{
        (0, $5OaGg.resetState)({
            ...getState(),
            isLinkModalOpen: false
        }, setState);
    };
const $67e609b10e096654$export$ff4d6363d0cec0ff = (analyticsEvent)=>async ({ getState: getState, setState: setState })=>{
        const { linkModalFilter: linkModalFilter } = getState();
        const textSearch = (0, $7eGvX.getFilterFromLocalStorage)((0, $7eGvX.TEXT_SEARCH_KEY), analyticsEvent) || '';
        const selectedSavedSearchId = (0, $7eGvX.getFilterFromLocalStorage)((0, $7eGvX.SAVED_SEARCH_ID_KEY), analyticsEvent) || (0, $5OaGg.DEFAULT_SELECTED_SAVED_SEARCH_ID);
        setState({
            linkModalFilter: {
                ...linkModalFilter,
                textSearch: textSearch,
                selectedSavedSearchId: selectedSavedSearchId
            }
        });
    };

});
parcelRegister("7eGvX", function(module, exports) {

$parcel$export(module.exports, "TEXT_SEARCH_KEY", () => $865ed98e0d0b92fe$export$c4f49be30d19fa45);
$parcel$export(module.exports, "SAVED_SEARCH_ID_KEY", () => $865ed98e0d0b92fe$export$d70cd71312ec5a1d);
$parcel$export(module.exports, "getFilterFromLocalStorage", () => $865ed98e0d0b92fe$export$7f8fe563ed4dc16b);
$parcel$export(module.exports, "setFilterInLocalStorage", () => $865ed98e0d0b92fe$export$53c44c562c1e6177);

var $aZaPn = parcelRequire("aZaPn");

var $jMP2a = parcelRequire("jMP2a");
const $865ed98e0d0b92fe$export$72f6692c81a0e6b3 = 'jsm-linked-alerts';
const $865ed98e0d0b92fe$export$c4f49be30d19fa45 = 'text-search';
const $865ed98e0d0b92fe$export$d70cd71312ec5a1d = 'saved-search-id';
const $865ed98e0d0b92fe$export$aa821bfb3308a1f5 = (0, $aZaPn.createLocalStorageProvider)($865ed98e0d0b92fe$export$72f6692c81a0e6b3);
const $865ed98e0d0b92fe$export$7f8fe563ed4dc16b = (key, analyticsEvent)=>{
    try {
        return $865ed98e0d0b92fe$export$aa821bfb3308a1f5.get(key);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'getFilterFromLocalStorage failed');
        return null;
    }
};
const $865ed98e0d0b92fe$export$53c44c562c1e6177 = (key, value, analyticsEvent)=>{
    try {
        $865ed98e0d0b92fe$export$aa821bfb3308a1f5.set(key, value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'setFilterInLocalStorage failed');
    }
};

});


parcelRegister("jxn5S", function(module, exports) {

$parcel$export(module.exports, "setTextSearch", () => $43082aa4bb62f66a$export$1350a617a58f8442);
$parcel$export(module.exports, "setSelectedSavedSearchId", () => $43082aa4bb62f66a$export$dd72702a7fd92da0);

var $7eGvX = parcelRequire("7eGvX");
const $43082aa4bb62f66a$export$1350a617a58f8442 = (textSearch, analyticsEvent)=>async ({ getState: getState, setState: setState })=>{
        const { linkModalFilter: linkModalFilter } = getState();
        setState({
            linkModalFilter: {
                ...linkModalFilter,
                textSearch: textSearch
            }
        });
        (0, $7eGvX.setFilterInLocalStorage)((0, $7eGvX.TEXT_SEARCH_KEY), textSearch, analyticsEvent);
    };
const $43082aa4bb62f66a$export$dd72702a7fd92da0 = (selectedSavedSearchId, analyticsEvent)=>async ({ getState: getState, setState: setState })=>{
        const { linkModalFilter: linkModalFilter } = getState();
        setState({
            linkModalFilter: {
                ...linkModalFilter,
                selectedSavedSearchId: selectedSavedSearchId
            }
        });
        (0, $7eGvX.setFilterInLocalStorage)((0, $7eGvX.SAVED_SEARCH_ID_KEY), selectedSavedSearchId, analyticsEvent);
    };

});

parcelRegister("iGmdw", function(module, exports) {

$parcel$export(module.exports, "linkSelectedAlerts", () => $69ab82b1713e4973$export$5c7ceb7deec8a623);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");

var $iCRmp = parcelRequire("iCRmp");

var $ipisk = parcelRequire("ipisk");

var $b21bF = parcelRequire("b21bF");
const $69ab82b1713e4973$export$5c7ceb7deec8a623 = (cloudId, issueId, analyticsEvent)=>async ({ getState: getState, setState: setState })=>{
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
        const { selectedAlertsToLinkIds: selectedAlertsToLinkIds } = getState();
        if (selectedAlertsToLinkIds.length === 0) return;
        try {
            await (0, $lRmyA.performPostRequest)(`${(0, $iCRmp.getEscalatorBaseUrl)(cloudId)}/issue/${issueId}/incident/associated-alerts`, {
                body: JSON.stringify(selectedAlertsToLinkIds)
            });
            analyticsEvent && (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'linkAlerts success');
            setState({
                isLinkModalOpen: false
            });
            const flagId = showFlag({
                type: 'success',
                isAutoDismiss: true,
                title: (0, $b21bF.default).successTitle,
                actions: [
                    {
                        content: (0, $b21bF.default).successDescription,
                        onClick: ()=>{
                            if (flagId) dismissFlag(flagId);
                            setState({
                                isViewModalOpen: true
                            });
                        }
                    }
                ],
                testId: 'linked-alerts.services.actions.link-selected-alerts.success-flag'
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            showFlag({
                type: 'error',
                isAutoDismiss: true,
                title: (0, $b21bF.default).errorTitle,
                description: (0, $ipisk.default).errorDescription
            });
            (0, $guiFP.trackFetchErrors)({
                event: analyticsEvent,
                error: e,
                id: 'linkAlerts',
                sendToPrivacyUnsafeSplunk: true
            });
            throw e;
        }
    };

});
parcelRegister("b21bF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c929a73c2b834578$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c929a73c2b834578$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    successTitle: {
        "id": "linked-alerts.services.actions.link-selected-alerts.success-title",
        "defaultMessage": "Success!"
    },
    successDescription: {
        "id": "linked-alerts.services.actions.link-selected-alerts.success-description",
        "defaultMessage": "View linked alerts"
    },
    errorTitle: {
        "id": "linked-alerts.services.actions.link-selected-alerts.error-title",
        "defaultMessage": "We could not link the selected alerts"
    }
});

});


parcelRegister("hFeQx", function(module, exports) {

$parcel$export(module.exports, "onAlertCheckboxChanged", () => $6fed82c5f55f4038$export$a1656d789276b699);
const $6fed82c5f55f4038$export$a1656d789276b699 = (alertId, isSelected)=>({ getState: getState, setState: setState })=>{
        const { linkModalAlerts: linkModalAlerts, selectedAlertsToLinkIds: selectedAlertsToLinkIds } = getState();
        const { data: data } = linkModalAlerts;
        if (!data?.results) return;
        if (!isSelected) {
            const updatedAlerts = selectedAlertsToLinkIds.filter((selectedAlertId)=>selectedAlertId !== alertId);
            setState({
                selectedAlertsToLinkIds: updatedAlerts
            });
        } else if (!selectedAlertsToLinkIds.includes(alertId)) {
            const updatedAlerts = [
                ...selectedAlertsToLinkIds,
                alertId
            ];
            setState({
                selectedAlertsToLinkIds: updatedAlerts
            });
        }
    };

});

parcelRegister("1L67x", function(module, exports) {

$parcel$export(module.exports, "searchAlerts", () => $991507d22473a7f8$export$a119d8c015398f1c);

var $hUrHq = parcelRequire("hUrHq");

var $53ciZ = parcelRequire("53ciZ");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $iCRmp = parcelRequire("iCRmp");

var $g6mpL = parcelRequire("g6mpL");


var $fbc8s = parcelRequire("fbc8s");
let $991507d22473a7f8$var$controller;
const $991507d22473a7f8$export$a119d8c015398f1c = ({ cloudId: cloudId, textSearch: textSearch, startIndex: startIndex, hasOpsgenieAccount: hasOpsgenieAccount = false, analyticsEvent: analyticsEvent })=>async ({ getState: getState, setState: setState })=>{
        if (!hasOpsgenieAccount) return;
        if (!$991507d22473a7f8$var$controller) $991507d22473a7f8$var$controller = new AbortController();
        const { linkModalAlerts: linkModalAlertsBeforeLoading, linkedAlerts: linkedAlerts } = getState();
        if (linkModalAlertsBeforeLoading.isLoading) {
            $991507d22473a7f8$var$controller.abort();
            $991507d22473a7f8$var$controller = new AbortController();
        }
        setState({
            linkModalAlerts: {
                ...linkModalAlertsBeforeLoading,
                data: startIndex === 0 ? undefined : linkModalAlertsBeforeLoading.data,
                error: undefined,
                isLoading: true,
                startIndex: startIndex
            }
        });
        try {
            const extraQuery = '(NOT "incident-alert-type": "responder")';
            const query = {
                query: textSearch.length > 0 ? `${textSearch} AND ${extraQuery}` : extraQuery,
                start: startIndex,
                size: (0, $g6mpL.SEARCH_ALERTS_PAGE_SIZE)
            };
            const url = `${(0, $iCRmp.getEscalatorBaseUrl)(cloudId)}/alerts/search?${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(query)}`;
            const response = await (0, $2OdyW.default)(url, {
                signal: $991507d22473a7f8$var$controller.signal
            });
            const linkedAlertIds = (linkedAlerts.data || []).reduce((acc, linkedAlert)=>{
                acc[linkedAlert.id] = true;
                return acc;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            }, {});
            const newAlerts = response.results?.map((alert)=>(0, $fbc8s.transformEscalatorAlertResponse)(alert, linkedAlertIds)) || [];
            const { linkModalAlerts: linkModalAlerts } = getState();
            setState({
                linkModalAlerts: {
                    ...linkModalAlerts,
                    isLoading: false,
                    data: {
                        ...linkModalAlerts.data,
                        ...response,
                        // merging by id, to avoid inserting duplicates
                        results: (0, (/*@__PURE__*/$parcel$interopDefault($hUrHq)))(linkModalAlerts.data?.results || [], newAlerts, (alert)=>alert.id)
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'searchAlerts succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e.name === 'AbortError') return;
            (0, $guiFP.trackFetchErrors)({
                event: analyticsEvent,
                error: e,
                id: 'searchAlerts',
                sendToPrivacyUnsafeSplunk: true
            });
            const { linkModalAlerts: linkModalAlerts } = getState();
            setState({
                linkModalAlerts: {
                    ...linkModalAlerts,
                    isLoading: false,
                    error: {
                        value: e.message,
                        type: (0, $aaae4dc4d7cd5525$export$31f1110b09506e64)
                    }
                }
            });
        }
    };

});

parcelRegister("5PTsQ", function(module, exports) {

$parcel$export(module.exports, "unlinkAlert", () => $f8e3a8cb9f601801$export$9e0be8a6fd9411a);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");

var $iCRmp = parcelRequire("iCRmp");

var $hY0MQ = parcelRequire("hY0MQ");

var $2O9ud = parcelRequire("2O9ud");
const $f8e3a8cb9f601801$export$9e0be8a6fd9411a = ({ cloudId: cloudId, issueId: issueId, alertId: alertId, hasOpsgenieAccount: hasOpsgenieAccount = false, analyticsEvent: analyticsEvent })=>async ({ dispatch: dispatch })=>{
        const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
        try {
            await (0, $lRmyA.performDeleteRequest)(`${(0, $iCRmp.getEscalatorBaseUrl)(cloudId)}/issue/${issueId}/incident/associated-alerts`, {
                body: JSON.stringify([
                    alertId
                ])
            });
            dispatch((0, $hY0MQ.fetchLinkedAlerts)({
                issueId: issueId,
                cloudId: cloudId,
                hasOpsgenieAccount: hasOpsgenieAccount,
                analyticsEvent: analyticsEvent
            }));
            showFlag({
                type: 'success',
                isAutoDismiss: true,
                title: (0, $2O9ud.default).successTitle,
                description: (0, $2O9ud.default).successDescription,
                testId: 'linked-alerts.services.actions.unlink-alert.success-flag'
            });
            analyticsEvent && (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'UnlinkAlert succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            showFlag({
                type: 'error',
                isAutoDismiss: true,
                title: (0, $2O9ud.default).errorTitle,
                description: (0, $2O9ud.default).errorDescription
            });
            (0, $guiFP.trackFetchErrors)({
                event: analyticsEvent,
                error: e,
                id: 'unlinkAlert',
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };

});
parcelRegister("2O9ud", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d218246356edc1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a4d218246356edc1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    successTitle: {
        "id": "linked-alerts.services.actions.unlink-alert.success-title",
        "defaultMessage": "Success"
    },
    successDescription: {
        "id": "linked-alerts.services.actions.unlink-alert.success-description",
        "defaultMessage": "The alert was unlinked"
    },
    errorTitle: {
        "id": "linked-alerts.services.actions.unlink-alert.error-title",
        "defaultMessage": "We couldn\u2019t unlink the alert"
    },
    errorDescription: {
        "id": "linked-alerts.services.actions.unlink-alert.error-description",
        "defaultMessage": "Select Unlink or refresh the page to try again."
    }
});

});


parcelRegister("enh4O", function(module, exports) {

$parcel$export(module.exports, "openViewModal", () => $b704b3aa54c25eed$export$5b5d416130bcd98e);
$parcel$export(module.exports, "closeViewModal", () => $b704b3aa54c25eed$export$e08b7ada2e0ac5c9);

var $5OaGg = parcelRequire("5OaGg");
const $b704b3aa54c25eed$export$5b5d416130bcd98e = ()=>({ getState: getState, setState: setState })=>{
        (0, $5OaGg.resetState)({
            ...getState(),
            isViewModalOpen: true
        }, setState);
    };
const $b704b3aa54c25eed$export$e08b7ada2e0ac5c9 = ()=>({ getState: getState, setState: setState })=>{
        (0, $5OaGg.resetState)({
            ...getState(),
            isViewModalOpen: false
        }, setState);
    };

});

parcelRegister("4CvpM", function(module, exports) {

$parcel$export(module.exports, "PREDEFINED_FILTER_ALL", () => $1570d293b0be4579$export$798025af3acb829);
$parcel$export(module.exports, "predefinedIdToNameMap", () => $1570d293b0be4579$export$d268d0899468b67e);

var $hkGX1 = parcelRequire("hkGX1");
const $1570d293b0be4579$export$798025af3acb829 = 'preDefined--ALL';
const $1570d293b0be4579$export$624c944546759919 = 'preDefined--Open';
const $1570d293b0be4579$export$fe75f8f9d3b07bba = 'preDefined--Closed';
const $1570d293b0be4579$export$95601b4af0d288d7 = "preDefined--Un'Acked";
const $1570d293b0be4579$export$74064f2032b7cef = 'preDefined--Not Seen';
const $1570d293b0be4579$export$c99165fe6d4db651 = 'preDefined--Assigned to me';
const $1570d293b0be4579$export$d268d0899468b67e = {
    [$1570d293b0be4579$export$798025af3acb829]: (0, $hkGX1.default).all,
    [$1570d293b0be4579$export$624c944546759919]: (0, $hkGX1.default).open,
    [$1570d293b0be4579$export$fe75f8f9d3b07bba]: (0, $hkGX1.default).closed,
    [$1570d293b0be4579$export$95601b4af0d288d7]: (0, $hkGX1.default).unAcked,
    [$1570d293b0be4579$export$74064f2032b7cef]: (0, $hkGX1.default).notSeen,
    [$1570d293b0be4579$export$c99165fe6d4db651]: (0, $hkGX1.default).assigned
};

});



parcelRegister("fq6rr", function(module, exports) {

$parcel$export(module.exports, "useForms", () => $b4e91797a38922f4$export$4f95a4085cc93847);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");

var $gL8eB = parcelRequire("gL8eB");
const $b4e91797a38922f4$export$4f95a4085cc93847 = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    /*
	 * useFieldConfig and useEditField grab info out of 2 react-sweet-state containers on the
	 * issue view.
	 * */ const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, (0, $lO4Or.PROFORMA_FORMS));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'schema.type', 'proforma-forms');
    const [{ value: value, error: error }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $lO4Or.PROFORMA_FORMS),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: {
            hasIssueForms: undefined,
            hasProjectForms: undefined
        },
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    const [issueViewAddFormButtonClickedCount, { onClickAddFormButton: onClickAddFormButton, resetAddFormButtonCount: resetAddFormButtonCount }] = (0, $gL8eB.useFormsInIssueStatus)();
    return [
        {
            value: {
                hasIssueForms: value?.hasIssueForms,
                hasProjectForms: value?.hasProjectForms,
                issueViewAddFormButtonClickedCount: issueViewAddFormButtonClickedCount
            },
            error: error,
            fieldConfig: fieldConfig
        },
        {
            onClickAddFormButton: onClickAddFormButton,
            resetAddFormButtonCount: resetAddFormButtonCount
        }
    ];
};

});

parcelRegister("blBdM", function(module, exports) {

$parcel$export(module.exports, "AsyncDeveloperEscalationsButton", () => $556e826242d61fd1$export$e49b6de7c77efbf);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $556e826242d61fd1$var$DeveloperEscalationsButtonAsync = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("36gmW")).then((exportedModule)=>exportedModule.DeveloperEscalationsButton), {
    moduleId: "./src/packages/servicedesk/customer-service/escalations-issue-view-button/src/ui/index.tsx"
});
const $556e826242d61fd1$export$e49b6de7c77efbf = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "DeveloperEscalationsButton",
        packageName: "jiraServicedeskCustomerServiceEscalationsIssueViewButton",
        teamName: "boysenberry",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "developer-escalations-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($556e826242d61fd1$var$DeveloperEscalationsButtonAsync, props)));

});
parcelRegister("36gmW", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('23OVO');
        const value = parcelRequire('hkVz0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("23OVO").then(()=>parcelRequire('hkVz0'));
}

});


parcelRegister("bDQbB", function(module, exports) {

$parcel$export(module.exports, "useIsDeveloperEscalationsEnabled", () => $1ee814d9d49a9baa$export$29f56b6441ef14df);

var $7ZZxN = parcelRequire("7ZZxN");

var $hJ992 = parcelRequire("hJ992");

var $2wCUM = parcelRequire("2wCUM");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");
const $1ee814d9d49a9baa$export$29f56b6441ef14df = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const [{ canEditIssues: canEditIssues }] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const isIssueOfDeveloperEscalations = (0, $2wCUM.useIsIssueOfDeveloperEscalationPractice)();
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const isServiceDeskProject = projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);
    return isServiceDeskProject && !isIssueOfDeveloperEscalations && canEditIssues;
};

});

parcelRegister("l3wGN", function(module, exports) {

$parcel$export(module.exports, "AsyncReviewButton", () => $209e97b1af3d8c90$export$788f79f100486d43);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $209e97b1af3d8c90$var$ReviewButtonAsync = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("inkdQ")), {
    moduleId: "./src/packages/servicedesk/post-incident-review/src/ui/review-button/index.tsx"
});
const $209e97b1af3d8c90$export$788f79f100486d43 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "pir-review-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($209e97b1af3d8c90$var$ReviewButtonAsync, props));

});
parcelRegister("inkdQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9dBqI');
        const value = parcelRequire('5sMpu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9dBqI").then(()=>parcelRequire('5sMpu'));
}

});


parcelRegister("keVDO", function(module, exports) {

$parcel$export(module.exports, "AddDesignItem", () => $a740c2d44247d9a4$export$b1781759671f1313);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $9qOyB = parcelRequire("9qOyB");

var $6J9Jw = parcelRequire("6J9Jw");

var $huI7r = parcelRequire("huI7r");

var $dWLk9 = parcelRequire("dWLk9");
const $a740c2d44247d9a4$export$b1781759671f1313 = ({ createItemView: createItemView, onMount: onMount })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const siteAri = (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        resourceType: 'site',
        resourceId: cloudId
    });
    const entryPointParams = (0, $eUqFw.useMemo)(()=>({
            siteAri: siteAri
        }), [
        siteAri
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $9qOyB.addDesignButtonEntryPoint), entryPointParams);
    const [, { setShouldShowAddDesignForm: setShouldShowAddDesignForm }] = (0, $6J9Jw.useDesignPanelStore)();
    (0, $eUqFw.useEffect)(()=>entryPointActions.load(), [
        entryPointActions
    ]);
    const onDesignItemClick = (0, $eUqFw.useCallback)(()=>{
        setShouldShowAddDesignForm(true);
    }, [
        setShouldShowAddDesignForm
    ]);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            onClick: onDesignItemClick,
            onMount: onMount,
            createItemView: createItemView
        }), [
        onDesignItemClick,
        onMount,
        createItemView
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jiraIssueAddDesignItem",
        packageName: "jiraIssueViewFoundation",
        errorFallback: "unmount",
        teamName: "mdt-zora",
        runtimeProps: runtimeProps
    });
};

});
parcelRegister("9qOyB", function(module, exports) {

$parcel$export(module.exports, "addDesignButtonEntryPoint", () => $8a460c5d81828cd0$export$f49c443e5ebbf504);

var $Jd7vz = parcelRequire("Jd7vz");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $8a460c5d81828cd0$export$f49c443e5ebbf504 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("jZ7pE")), {
        moduleId: "dd9a94a6"
    }),
    getPreloadProps: ({ siteAri: siteAri })=>({
            queries: {
                designButton: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $Jd7vz.default,
                    variables: {
                        siteAri: siteAri
                    }
                }
            }
        })
});

});
parcelRegister("Jd7vz", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cd0fb429b415792$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a099795726b4fbf97c1f598fd011899>>
 * @relayHash 70514cf683bcc08b9ab38b0801acfcfe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c52564fc6e18bfe5d6ffffb644763a69a83c8570f17b6b541dcc96aca53a133e
const $7cd0fb429b415792$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c52564fc6e18bfe5d6ffffb644763a69a83c8570f17b6b541dcc96aca53a133e",
        "metadata": {},
        "name": "ui_AddDesignButtonQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7cd0fb429b415792$export$2e2bcd8739ae039 = $7cd0fb429b415792$var$node;

});

parcelRegister("jZ7pE", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7UAgj');
        const value = parcelRequire('bLW4Z');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7UAgj").then(()=>parcelRequire('bLW4Z'));
}

});



parcelRegister("kexaW", function(module, exports) {

$parcel$export(module.exports, "AddFormButton", () => $94e67920cad014f3$export$82b8c78f52c955c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2ziLQ = parcelRequire("2ziLQ");

var $fY29z = parcelRequire("fY29z");
var $8sN8t = parcelRequire("8sN8t");

var $5JgJ2 = parcelRequire("5JgJ2");


var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $55q9h = parcelRequire("55q9h");

var $8jbCj = parcelRequire("8jbCj");

var $5Z2y1 = parcelRequire("5Z2y1");

var $kM2t7 = parcelRequire("kM2t7");
const $94e67920cad014f3$var$PROFORMA_ISSUE_VIEW_ADD_FORM_SEEN_STATUS_USER_PROPERTY_KEY = 'proforma-issue-view-add-form-seen-status';
const $94e67920cad014f3$export$82b8c78f52c955c = ({ createItemView: createItemView, onClick: onClick, hasIssueForms: hasIssueForms })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const testId = 'add-form-quick-add-item';
    const [{ isSeen: hasSeenSpotlight }, { markAsSeen: markSpotlightAsSeen }] = (0, $55q9h.useSeenStatus)({
        userPropertyKey: $94e67920cad014f3$var$PROFORMA_ISSUE_VIEW_ADD_FORM_SEEN_STATUS_USER_PROPERTY_KEY,
        isSeenValue: true,
        packageName: 'jiraIssueView',
        teamName: 'jsm-transformers'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [shouldShowPulse, setShouldShowPulse] = (0, $eUqFw.useState)(false);
    const [shouldShowSpotlight, setShouldShowSpotlight] = (0, $eUqFw.useState)(false);
    const [hasSpotlightDisplayed, setHasSpotlightDisplayed] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (hasIssueForms === false && !hasSeenSpotlight && !hasSpotlightDisplayed) setShouldShowPulse(!hasSeenSpotlight);
    }, [
        hasIssueForms,
        hasSeenSpotlight,
        hasSpotlightDisplayed
    ]);
    const onClickWithAnalytics = ()=>{
        onClick();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'addFormButton');
    };
    const onDisplaySpotlight = ()=>{
        if (shouldShowPulse) {
            setShouldShowPulse(false);
            setShouldShowSpotlight(true);
        }
    };
    const onAcknowledgeSpotlight = ()=>{
        onClickWithAnalytics();
        markSpotlightAsSeen();
        setHasSpotlightDisplayed(true);
        setShouldShowSpotlight(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94e67920cad014f3$var$ButtonWrapper, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
        name: (0, $25561c8e4853b1dd$export$3c389bd4d38f57a0),
        key: "add-form-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fY29z.Pulse), {
        radius: 3,
        pulse: shouldShowPulse
    }, createItemView({
        id: (0, $186d4efeb1fdfd01$export$8764350a3b03b53),
        tooltip: formatMessage((0, $kM2t7.default).tooltip),
        label: formatMessage((0, $kM2t7.default).label),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
            glyph: (0, $5Z2y1.default),
            label: "",
            size: "medium"
        }),
        onClick: hasIssueForms || hasSeenSpotlight ? onClickWithAnalytics : onDisplaySpotlight,
        itemIndex: 3,
        shouldRender: true,
        noWrapper: true,
        testId: testId
    })), shouldShowSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jbCj.AddFormSpotlight), {
        onAcknowledge: onAcknowledgeSpotlight
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94e67920cad014f3$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("55q9h", function(module, exports) {

$parcel$export(module.exports, "useSeenStatus", () => $7bd6bae75d49466d$export$12667e37571b0a02);

var $eUqFw = parcelRequire("eUqFw");


var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");
var $JRB5w = parcelRequire("JRB5w");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");
const $7bd6bae75d49466d$var$initialState = {
    isSeen: true,
    isLoading: false,
    error: undefined
};
const $7bd6bae75d49466d$export$f7ab30339d40bcd = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';
const $7bd6bae75d49466d$export$12667e37571b0a02 = ({ userPropertyKey: userPropertyKey, isSeenValue: isSeenValue, packageName: packageName, teamName: teamName })=>{
    const [state, setState] = (0, $eUqFw.useState)($7bd6bae75d49466d$var$initialState);
    const { atlassianAccountId: accountId } = (0, $gd0Sp.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const reportErrorDeps = (0, $eUqFw.useRef)({
        packageName: packageName,
        teamName: teamName
    });
    reportErrorDeps.current = {
        packageName: packageName,
        teamName: teamName
    };
    const reportError = (0, $eUqFw.useCallback)((errorId, error)=>{
        (0, $guiFP.default)({
            meta: {
                id: errorId,
                ...reportErrorDeps.current
            },
            error: error,
            attributes: {
                isClientFetchError: (0, $JRB5w.isClientFetchError)(error)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (accountId && !$7bd6bae75d49466d$export$f7ab30339d40bcd()) {
            setState((oldState)=>({
                    ...oldState,
                    isLoading: true
                }));
            (0, $48bs8.getUserProperty)('', accountId, userPropertyKey).catch((error)=>{
                if (error.statusCode === (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef)) // user property has not been set
                return false;
                throw error;
            }).then((value)=>{
                setState((oldState)=>({
                        ...oldState,
                        isSeen: value === isSeenValue,
                        isLoading: false
                    }));
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useSeenStatus.fetchStatus succeeded', {
                    userPropertyKey: userPropertyKey
                });
            }).catch((error)=>{
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false,
                        error: error
                    }));
                reportError('useSeenStatus.fetchStatus', error);
            });
        }
    }, [
        userPropertyKey,
        accountId,
        isSeenValue,
        reportError,
        createAnalyticsEvent
    ]);
    const markAsSeen = (0, $eUqFw.useCallback)(()=>{
        if (accountId && !$7bd6bae75d49466d$export$f7ab30339d40bcd()) {
            setState((oldState)=>({
                    ...oldState,
                    isSeen: true,
                    isLoading: true
                }));
            (0, $48bs8.setUserProperties)('', accountId, userPropertyKey, JSON.stringify(isSeenValue)).then((res)=>{
                if (!res.ok) return res.text().then((errResp)=>{
                    throw new (0, $7byHA.default)(res.status, errResp);
                });
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false
                    }));
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'useSeenStatus.markAsSeen succeeded', {
                    userPropertyKey: userPropertyKey
                });
                return Promise.resolve();
            }).catch((error)=>{
                // leave `isSeen` as true. we don't want to block the user
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false,
                        error: error
                    }));
                reportError('useSeenStatus.markAsSeen', error);
            });
        }
    }, [
        accountId,
        userPropertyKey,
        isSeenValue,
        createAnalyticsEvent,
        reportError
    ]);
    return [
        state,
        {
            markAsSeen: markAsSeen
        }
    ];
};

});
parcelRegister("48bs8", function(module, exports) {

$parcel$export(module.exports, "getUserPropertiesUrl", () => $016bb9e2a17179ab$export$f474e53c8191800a);
$parcel$export(module.exports, "setUserProperties", () => $016bb9e2a17179ab$export$d0e176862bf869b8);
$parcel$export(module.exports, "getUserProperty", () => $016bb9e2a17179ab$export$b3126db2ef6e34ed);

var $axhXb = parcelRequire("axhXb");

var $7EhAs = parcelRequire("7EhAs");
const $016bb9e2a17179ab$export$f474e53c8191800a = (baseUrl, accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const $016bb9e2a17179ab$export$d0e176862bf869b8 = async (baseUrl, accountId, propertyKey, data)=>fetch($016bb9e2a17179ab$export$f474e53c8191800a(baseUrl, accountId, propertyKey), {
        ...(0, $axhXb.default),
        method: 'PUT',
        body: data
    });
const $016bb9e2a17179ab$export$b3126db2ef6e34ed = (baseUrl, accountId, propertyKey)=>fetch($016bb9e2a17179ab$export$f474e53c8191800a(baseUrl, accountId, propertyKey), (0, $axhXb.default)).then((res)=>{
        if (res.status === 200) return res.json();
        return res.text().then((errResp)=>{
            throw new (0, $7EhAs.default)(res.status, errResp);
        });
    }).then((data)=>data.value);

});


parcelRegister("8jbCj", function(module, exports) {

$parcel$export(module.exports, "AddFormSpotlight", () => $ab3cc0ce0c4a626e$export$4a1201c1cde67efb);

var $eUqFw = parcelRequire("eUqFw");

var $aO9bw = parcelRequire("aO9bw");
var $8NdH4 = parcelRequire("8NdH4");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");


var $kTdiA = parcelRequire("kTdiA");
const $ab3cc0ce0c4a626e$export$4a1201c1cde67efb = ({ onAcknowledge: onAcknowledge })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8NdH4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $25561c8e4853b1dd$export$c313dd364f628116),
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aO9bw.default), {
        target: (0, $25561c8e4853b1dd$export$3c389bd4d38f57a0),
        actions: [
            {
                text: formatMessage((0, $kTdiA.default).ok),
                onClick: onAcknowledge
            }
        ],
        dialogWidth: 336,
        key: (0, $25561c8e4853b1dd$export$1222b4ae9a94b9ec),
        targetBgColor: `var(--ds-surface-raised, ${(0, $PdmhA.N0)})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $kTdiA.default).message))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};

});
const $25561c8e4853b1dd$export$c313dd364f628116 = 'proformaIssueViewQuickAddFormChangeboardingSpotlight';
const $25561c8e4853b1dd$export$1222b4ae9a94b9ec = 'proforma-issue-view-quick-add-form-changeboarding-spotlight';
const $25561c8e4853b1dd$export$3c389bd4d38f57a0 = 'proforma-issue-view-quick-add-form-changeboarding-spotlight-target';

parcelRegister("kTdiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $389ed2658a83525f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $389ed2658a83525f$var$messages = (0, $90IgZ.defineMessages)({
    ok: {
        "id": "issue-view-foundation.quick-add.add-form-button.add-form-spotlight.ok",
        "defaultMessage": "OK"
    },
    message: {
        "id": "issue-view-foundation.quick-add.add-form-button.add-form-spotlight.message",
        "defaultMessage": "Attach forms to an issue so you can collect more information from customers, or complete internal team processes."
    }
});
var $389ed2658a83525f$export$2e2bcd8739ae039 = $389ed2658a83525f$var$messages;

});


parcelRegister("5Z2y1", function(module, exports) {

$parcel$export(module.exports, "default", () => $76689e1fe0990e7b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $76689e1fe0990e7b$var$FormIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "18",
        viewBox: "0 -2 14 22"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        d: "M1.994 2v14h10V2h-10ZM0 1.791C0 .8028.897 0 2.006 0h9.988C13.102 0 14 .8082 14 1.791v14.418c0 .9891-.897 1.791-2.006 1.791H2.006c-.5295.0007-1.03778-.1873-1.41369-.5229C.21639 17.1415.00344 16.6855 0 16.209V1.791Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        d: "M6.9013 11.1153h2.8718c.5287 0 .9572-.3997.9572-.8929 0-.4931-.4285-.8928-.9572-.8928H6.9013c-.5287 0-.9573.3997-.9573.8928 0 .4932.4286.8929.9573.8929ZM6.9013 8.2231h2.8718c.5287 0 .9572-.3997.9572-.8928 0-.49314-.4285-.89288-.9572-.89288H6.9013c-.5287 0-.9573.39974-.9573.89288 0 .4931.4286.8928.9573.8928ZM6.9013 5.40103h2.8718c.5287 0 .9572-.39975.9572-.89286s-.4285-.89286-.9572-.89286L6.9013 3.6153c-.5287 0-.9573.39976-.9573.89287 0 .49311.4286.89286.9573.89286ZM3.1488 5.32959h1.83796c0-.82142-.00001-1.22117 0-1.71429H3.1488v1.71429ZM3.22598 8.1517H5.0639V6.43742H3.22598V8.1517ZM3.22598 11.0439H5.0639V9.3296H3.22598v1.7143ZM4.18324 14H9.812c.5286 0 .9572-.3997.9572-.8929 0-.4931-.4286-.8928-.9572-.8928H4.18324c-.52868 0-.95726.3997-.95726.8928 0 .4932.42858.8929.95726.8929Z"
    }));
var $76689e1fe0990e7b$export$2e2bcd8739ae039 = $76689e1fe0990e7b$var$FormIcon;

});

parcelRegister("kM2t7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2043559e93e9382$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e2043559e93e9382$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "issue-view-foundation.quick-add.add-form-button.add-form-button-view.label",
        "defaultMessage": "Add form"
    },
    tooltip: {
        "id": "issue-view-foundation.quick-add.add-form-button.add-form-button-view.tooltip",
        "defaultMessage": "Add Form"
    }
});

});


parcelRegister("lPRkf", function(module, exports) {

$parcel$export(module.exports, "useRegisterQuickAddInCommandPalette", () => $ce8e909bf3749b05$export$4a8134d6ec1b3100);

var $eUqFw = parcelRequire("eUqFw");

var $gO9Xw = parcelRequire("gO9Xw");

var $jUThT = parcelRequire("jUThT");

var $8CfG4 = parcelRequire("8CfG4");

var $8tfNS = parcelRequire("8tfNS");

var $6jiFZ = parcelRequire("6jiFZ");

var $46gH8 = parcelRequire("46gH8");
var $36mrL = parcelRequire("36mrL");
var $gfXKy = parcelRequire("gfXKy");

var $fmmnJ = parcelRequire("fmmnJ");
var $gjNh9 = parcelRequire("gjNh9");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $bjWU0 = parcelRequire("bjWU0");
const $ce8e909bf3749b05$export$4a8134d6ec1b3100 = ({ onAddAttachmentClick: onAddAttachmentClick, onAddAUrlClick: onAddAUrlClick, onLinkConfluencePageClick: onLinkConfluencePageClick, onAddChildCommand: onAddChildCommand, isAttachCommandEnabled: isAttachCommandEnabled, isAddAUrlEnabled: isAddAUrlEnabled, isLinkConfluencePageEnabled: isLinkConfluencePageEnabled, isAddChildEnabled: isAddChildEnabled })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    const addAttachmentCommand = (0, $eUqFw.useMemo)(()=>({
            id: `issue-add-attachment-${issueKey}`,
            name: formatMessage((0, $bjWU0.messages).addAttachment),
            keywords: getKeywords('addAttachmentSynonyms'),
            primaryAction: {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>{
                    onAddAttachmentClick();
                }
            },
            section: (0, $46gH8.getCommandPaletteIssueActionsHeader)(issueKey),
            priority: (0, $36mrL.getCommandPaletteIssueActionsPriority)('SUB_HEADER_ITEMS'),
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jUThT))), {
                        label: formatMessage((0, $bjWU0.messages).addAttachment)
                    })
            },
            analytics: {
                action: 'addAttachment'
            }
        }), [
        formatMessage,
        getKeywords,
        issueKey,
        onAddAttachmentClick
    ]);
    const addAUrlCommand = (0, $eUqFw.useMemo)(()=>({
            id: `issue-add-a-url-${issueKey}`,
            name: formatMessage((0, $bjWU0.messages).addAUrl),
            keywords: getKeywords?.('addAUrlSynonyms'),
            primaryAction: {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>setTimeout(onAddAUrlClick, 0)
            },
            section: (0, $46gH8.getCommandPaletteIssueActionsHeader)(issueKey),
            priority: (0, $36mrL.getCommandPaletteIssueActionsPriority)('SUB_HEADER_ITEMS'),
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tfNS))), {
                        label: formatMessage((0, $bjWU0.messages).addAUrl)
                    })
            },
            analytics: {
                action: 'addIssueUrl'
            }
        }), [
        formatMessage,
        getKeywords,
        issueKey,
        onAddAUrlClick
    ]);
    const linkConfluencePageCommand = (0, $eUqFw.useMemo)(()=>({
            id: `issue-link-confluence-page-${issueKey}`,
            name: formatMessage((0, $bjWU0.messages).linkConfluencePage),
            keywords: getKeywords?.('linkConfluencePageSynonyms'),
            primaryAction: {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>setTimeout(()=>{
                        onLinkConfluencePageClick();
                    }, 0)
            },
            section: (0, $46gH8.getCommandPaletteIssueActionsHeader)(issueKey),
            priority: (0, $36mrL.getCommandPaletteIssueActionsPriority)('SUB_HEADER_ITEMS'),
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                        label: formatMessage((0, $bjWU0.messages).linkConfluencePage)
                    })
            },
            analytics: {
                action: 'linkConfluencePage'
            }
        }), [
        formatMessage,
        getKeywords,
        issueKey,
        onLinkConfluencePageClick
    ]);
    const addChildCommand = (0, $eUqFw.useMemo)(()=>({
            id: `issue-add-child-issue-${issueKey}`,
            name: formatMessage((0, $bjWU0.messages).addChild),
            keywords: formatMessage((0, $bjWU0.messages).addChildSynonyms),
            primaryAction: {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>onAddChildCommand()
            },
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                        label: formatMessage((0, $bjWU0.messages).addChild)
                    })
            },
            section: (0, $46gH8.getCommandPaletteIssueActionsHeader)(issueKey),
            priority: (0, $36mrL.getCommandPaletteIssueActionsPriority)('SUB_HEADER_ITEMS'),
            analytics: {
                action: 'addChild'
            }
        }), [
        formatMessage,
        issueKey,
        onAddChildCommand
    ]);
    const commands = [
        ...isAttachCommandEnabled ? [
            addAttachmentCommand
        ] : [],
        ...isAddAUrlEnabled ? [
            addAUrlCommand
        ] : [],
        ...isLinkConfluencePageEnabled ? [
            linkConfluencePageCommand
        ] : [],
        ...isAddChildEnabled ? [
            addChildCommand
        ] : []
    ];
    (0, $gjNh9.useRegisterCommands)((0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).QUICK_ADD, commands, [
        issueKey,
        isAttachCommandEnabled,
        isAddAUrlEnabled,
        isLinkConfluencePageEnabled,
        addAttachmentCommand,
        addAUrlCommand,
        linkConfluencePageCommand,
        addChildCommand
    ]);
};

});
parcelRegister("8CfG4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $645e088e86b3f594$var$_react = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $645e088e86b3f594$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $645e088e86b3f594$var$PageIcon = (props)=>/*#__PURE__*/ $645e088e86b3f594$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><rect x="8" y="6" width="8" height="2" rx="1"/><rect x="8" y="9" width="8" height="2" rx="1"/><rect x="8" y="12" width="4" height="2" rx="1"/><path d="M7 4v16h10V4H7zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 015 20.01V3.99z" fill-rule="nonzero"/></g></svg>`
    }, props));
$645e088e86b3f594$var$PageIcon.displayName = 'PageIcon';
var $645e088e86b3f594$var$_default = $645e088e86b3f594$var$PageIcon;
module.exports.default = $645e088e86b3f594$var$_default;

});

parcelRegister("8tfNS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62ad4a6c20067d20$var$_react = $62ad4a6c20067d20$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $62ad4a6c20067d20$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $62ad4a6c20067d20$var$WorldIcon = (props)=>/*#__PURE__*/ $62ad4a6c20067d20$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 21a9 9 0 100-18 9 9 0 000 18zm-.9-1.863A7.19 7.19 0 014.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8v1.737zm6.21-2.286A1.786 1.786 0 0015.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$62ad4a6c20067d20$var$WorldIcon.displayName = 'WorldIcon';
var $62ad4a6c20067d20$var$_default = $62ad4a6c20067d20$var$WorldIcon;
module.exports.default = $62ad4a6c20067d20$var$_default;

});

parcelRegister("bjWU0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1f77972e4fd90a5c$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $1f77972e4fd90a5c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    addAttachment: {
        "id": "issue-field-attachment.command-palette.add-attachment",
        "defaultMessage": "Add attachment"
    },
    addAUrl: {
        "id": "issue-field-attachment.command-palette.add-a-url",
        "defaultMessage": "Add a URL"
    },
    addChild: {
        "id": "issue-field-attachment.command-palette.add-child",
        "defaultMessage": "Add child"
    },
    addChildSynonyms: {
        "id": "issue-field-attachment.command-palette.add-child-synonyms",
        "defaultMessage": "Subtask Create"
    },
    linkConfluencePage: {
        "id": "issue-field-attachment.command-palette.link-confluence-page",
        "defaultMessage": "Link Confluence page"
    }
});

});


parcelRegister("5TSLN", function(module, exports) {

$parcel$export(module.exports, "CreateConfluenceContentMenu", () => $7699f7fc77ea3291$export$988cc6caaf667bdd);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3555e = parcelRequire("3555e");

var $cGCxH = parcelRequire("cGCxH");
var $2D6D5 = parcelRequire("2D6D5");
var $9Hi6E = parcelRequire("9Hi6E");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");


var $4Efjz = parcelRequire("4Efjz");


var $8PPG1 = parcelRequire("8PPG1");

var $8N8dV = parcelRequire("8N8dV");

var $6luwQ = parcelRequire("6luwQ");

var $kmr29 = parcelRequire("kmr29");

var $f9RL0 = parcelRequire("f9RL0");

var $bFzGY = parcelRequire("bFzGY");

var $a6Xhe = parcelRequire("a6Xhe");
var $07840 = parcelRequire("07840");
const $7699f7fc77ea3291$var$EMBEDDED_CONFLUENCE_ISSUE_VIEW_CROSS_FLOW_PULSE_LIMIT = 1; // When a user is first allocated to the experiment
const $7699f7fc77ea3291$var$JSW_XFLOW_NUDGE_EXP_PULSE_LIMIT = 3;
const $7699f7fc77ea3291$var$ISSUE_TYPES_TO_EXCLUDE_FOR_CROSS_FLOW_EXP = [
    'Bug',
    'Epic',
    'Story'
];
const $7699f7fc77ea3291$export$988cc6caaf667bdd = ({ appearance: appearance })=>{
    const { entryPointActions: confluenceContentMenuActions, entryPointReferenceSubject: confluenceContentMenuSubject } = (0, $6j4bv.useEntryPoint)((0, $6luwQ.createConfluenceContentMenuEntrypoint), {});
    const confluenceAccessOld = (0, $4Efjz.useUserHasConfluenceAccess)((0, $1b2c5e0fcb49d7fc$export$2d990bc8cd668ca1), (0, $1ybV0.ff)('confluence-admin-product-controls')).hasAccess;
    const confluenceAccessNew = (0, $1ybV0.ff)('confluence-admin-product-controls') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $9Hi6E.useUserHasConfluenceAccess)((0, $1b2c5e0fcb49d7fc$export$2d990bc8cd668ca1), !(0, $1ybV0.ff)('confluence-admin-product-controls')).hasAccess : confluenceAccessOld;
    const confluenceAccess = (0, $1ybV0.ff)('confluence-admin-product-controls') ? confluenceAccessNew : confluenceAccessOld;
    const tenantHasConfluence = (0, $3555e.useTenantHasConfluence)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isCrossSellEnabled = (0, $1ybV0.ff)('confluence-admin-product-controls') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2D6D5.useIsCrossSellEnabled)((0, $cGCxH.ConfluenceFeatureKeys).CREATE_MENU_TOP_ACTIONS) : false;
    const [, embedConfluenceAAFireExposureEvent] = (0, $79xbN.UNSAFE_noExposureExp)('platform_embed-conf_jira-issue_cross-join_exp_aa');
    const [embedConfluenceConfig] = (0, $79xbN.UNSAFE_noExposureExp)('platform_embed-conf_jira-issue_cross-join_exp');
    const embedConfluenceCohort = embedConfluenceConfig.get('cohort', 'not-enrolled');
    const [, confluenceContentCrossflowAAFireExposureEvent] = (0, $79xbN.UNSAFE_noExposureExp)('jira_create_confluence_content_crossflow_aa');
    const [confluenceContentCrossflowConfig, confluenceContentCrossflowFireExposureEvent] = (0, $79xbN.UNSAFE_noExposureExp)('jira_create_confluence_content_crossflow');
    const confluenceContentCrossflowCohort = confluenceContentCrossflowConfig.get('cohort', 'not-enrolled');
    // Embedded Confluence cross-join experiment begins
    (0, $eUqFw.useEffect)(()=>{
        if (!confluenceAccess && tenantHasConfluence) // expose feature to enrolled cohort for Calibration experiment
        embedConfluenceAAFireExposureEvent();
        if (!tenantHasConfluence) {
            // expose feature to enrolled cohort for Calibration experiment
            confluenceContentCrossflowAAFireExposureEvent();
            if ((0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-content-crossflow')) confluenceContentCrossflowFireExposureEvent();
        }
    }, [
        confluenceAccess,
        tenantHasConfluence,
        createAnalyticsEvent,
        embedConfluenceAAFireExposureEvent,
        confluenceContentCrossflowAAFireExposureEvent,
        confluenceContentCrossflowFireExposureEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const shouldRenderForCrossJoin = tenantHasConfluence && (0, $1ybV0.ff)('platform_embed-conf_jira-issue_create_cross-join') && embedConfluenceCohort === 'experiment';
        const shouldRenderForCrossFlow = !tenantHasConfluence && (0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-content-crossflow') && confluenceContentCrossflowCohort === 'experiment';
        if ((0, $1ybV0.ff)('confluence-admin-product-controls')) {
            if (confluenceAccess || (shouldRenderForCrossJoin || shouldRenderForCrossFlow) && isCrossSellEnabled) confluenceContentMenuActions.load();
        } else if (confluenceAccess || tenantHasConfluence && (0, $1ybV0.ff)('platform_embed-conf_jira-issue_create_cross-join') && embedConfluenceCohort === 'experiment' || !tenantHasConfluence && (0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-content-crossflow') && confluenceContentCrossflowCohort === 'experiment') confluenceContentMenuActions.load();
    }, [
        confluenceAccess,
        confluenceContentMenuActions,
        tenantHasConfluence,
        isCrossSellEnabled,
        embedConfluenceCohort,
        confluenceContentCrossflowCohort
    ]);
    const isExperiment = (0, $07840.useXflowNudgeExperiment)();
    const [open, setOpen] = (0, $eUqFw.useState)(false);
    const componentInternals = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: confluenceContentMenuSubject,
        id: "confluenceContentMenuEntryPointContainer",
        packageName: "@atlassian/jira-issue-create-confluence-content",
        teamName: "confluence-better-together",
        runtimeProps: {
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PPG1.CreatePageMenuItem), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N8dV.CreateWhiteboardMenuItem), null)),
            isOpenByDefault: open,
            hasConfluenceAccess: confluenceAccess,
            appearance: appearance,
            embeddedConfluenceSource: (0, $1b2c5e0fcb49d7fc$export$2d990bc8cd668ca1)
        }
    });
    const issueKey = (0, $hJ992.useIssueKey)();
    const [issueTypeId] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $f9RL0.ISSUE_TYPE)
    });
    const issueType = issueTypeId?.name ?? '';
    const shouldShowNudgeSpotlight = (0, $1ybV0.ff)('jsw.xflow.issue-view-nudge-experiment', false) && isExperiment || !tenantHasConfluence && (0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-content-crossflow') && confluenceContentCrossflowCohort === 'experiment' && $7699f7fc77ea3291$var$ISSUE_TYPES_TO_EXCLUDE_FOR_CROSS_FLOW_EXP.indexOf(issueType) === -1;
    /*
     To determine which experiment to nudge for, the key indicator is whether or not the tenant has confluence
     The criteria for being enrolled in the JSW_XFLOW_NUDGE_EXP is that a user has not returned to Confluence after 3
     days of provisioning it. So it would come into picture when the tenant does have Confluence. However, for the
     EMBEDDED_CONFLUENCE_ISSUE_VIEW_CREATE_CONFLUENCE_CONTENT_CROSS_FLOW_KEY experiment the user is only enrolled when
     tenant doesn't have confluence. So we check for this condition first, and if it does not apply, then we default it
     to the JSW_XFLOW_NUDGE_EXP experiment and pulse limit value.
  */ const experimentToShowNudgeFor = !tenantHasConfluence ? (0, $35b9cb9c9c5b9881$export$6c66b7c0a63aae32) : (0, $07840.JSW_XFLOW_NUDGE_EXP);
    const nudgePulseLimit = !tenantHasConfluence ? $7699f7fc77ea3291$var$EMBEDDED_CONFLUENCE_ISSUE_VIEW_CROSS_FLOW_PULSE_LIMIT : $7699f7fc77ea3291$var$JSW_XFLOW_NUDGE_EXP_PULSE_LIMIT;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7699f7fc77ea3291$var$ButtonWrapper, null, shouldShowNudgeSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a6Xhe.IssueViewNudgeExperiment), {
        experimentKey: experimentToShowNudgeFor,
        onClick: ()=>setOpen(!open),
        issueType: issueType,
        pulseLimit: nudgePulseLimit,
        embeddedConfluenceSource: !tenantHasConfluence ? (0, $1b2c5e0fcb49d7fc$export$2d990bc8cd668ca1) : undefined
    }, componentInternals) : componentInternals);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7699f7fc77ea3291$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3555e", function(module, exports) {

$parcel$export(module.exports, "useTenantHasConfluence", () => $583c95185f8eb6cc$export$964fe2dd9242a588);

var $e91YZ = parcelRequire("e91YZ");

var $j3FUN = parcelRequire("j3FUN");
const $583c95185f8eb6cc$export$964fe2dd9242a588 = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    return Boolean(licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).CONFLUENCE]);
};

});

parcelRegister("2D6D5", function(module, exports) {

$parcel$export(module.exports, "useIsCrossSellEnabled", () => $28cd01a970e0e651$export$15690b04dfbb7844);

var $eUqFw = parcelRequire("eUqFw");

var $89bO2 = parcelRequire("89bO2");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $gd0Sp = parcelRequire("gd0Sp");

var $cGCxH = parcelRequire("cGCxH");

var $kMSlI = parcelRequire("kMSlI");

var $3qF4w = parcelRequire("3qF4w");
const $28cd01a970e0e651$var$storage = (0, $89bO2.createSessionStorageProvider)((0, $cGCxH.CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY));
const $28cd01a970e0e651$var$TIME_TO_LIVE = 18000000; // 30 minutes
const $28cd01a970e0e651$export$15690b04dfbb7844 = (controlKey)=>{
    const [isCrossSellEnabled, setIsCrossSellEnabled] = (0, $eUqFw.useState)(false);
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const applicationPropertiesCache = (0, $eUqFw.useMemo)(()=>(0, $3qF4w.getSessionStorageData)((0, $cGCxH.CONFLUENCE_CONTROLS_STORAGE_KEY), $28cd01a970e0e651$var$storage) ?? null, []);
    const shouldFetchApplicationProperty = (0, $eUqFw.useMemo)(()=>!isCrossSellEnabled && ((0, $3qF4w.isStorageKeyExpired)((0, $cGCxH.CONFLUENCE_CONTROLS_STORAGE_KEY), $28cd01a970e0e651$var$storage) || !applicationPropertiesCache), [
        applicationPropertiesCache,
        isCrossSellEnabled
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const getConfluenceApplicationPropertyData = async ()=>{
            if (!(0, $1ybV0.ff)('confluence-admin-product-controls')) return;
            try {
                const confluenceApplicationPropertiesMap = await (0, $kMSlI.getConfluenceApplicationProperties)(cloudId);
                (0, $3qF4w.setSessionStorageData)({
                    key: (0, $cGCxH.CONFLUENCE_CONTROLS_STORAGE_KEY),
                    value: confluenceApplicationPropertiesMap,
                    ttl: $28cd01a970e0e651$var$TIME_TO_LIVE,
                    storage: $28cd01a970e0e651$var$storage
                });
                setIsCrossSellEnabled(confluenceApplicationPropertiesMap[controlKey].value);
            } catch (e) {
                const error = e instanceof Error ? e : new Error('Failed to get application properties');
                (0, $guiFP.default)({
                    meta: {
                        id: 'useIsCrossSellEnabled',
                        packageName: 'jiraConfluenceIntegrationControls'
                    },
                    error: error
                });
            }
        };
        if (shouldFetchApplicationProperty) getConfluenceApplicationPropertyData();
        else setIsCrossSellEnabled(applicationPropertiesCache[controlKey].value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return isCrossSellEnabled;
};

});
parcelRegister("kMSlI", function(module, exports) {

$parcel$export(module.exports, "getConfluenceApplicationProperties", () => $b35b16c0892c7e3f$export$74f15d152aa3d90d);
$parcel$export(module.exports, "setConfluenceApplicationProperty", () => $b35b16c0892c7e3f$export$1becbc41e80a8aea);

var $bInDC = parcelRequire("bInDC");

var $iWLL0 = parcelRequire("iWLL0");

var $89bO2 = parcelRequire("89bO2");

var $guiFP = parcelRequire("guiFP");

var $2OUyw = parcelRequire("2OUyw");

var $amu7D = parcelRequire("amu7D");

var $cGCxH = parcelRequire("cGCxH");

var $3qF4w = parcelRequire("3qF4w");
const $b35b16c0892c7e3f$var$storage = (0, $89bO2.createSessionStorageProvider)((0, $cGCxH.CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY));
const $b35b16c0892c7e3f$export$74f15d152aa3d90d = async (cloudId)=>{
    try {
        const data = await (0, $iWLL0.fetchQuery)((0, $amu7D.default), (0, $bInDC.default), {
            cloudId: cloudId,
            keys: Object.values((0, $cGCxH.ConfluenceFeatureKeys))
        }, {
            fetchPolicy: 'store-or-network'
        }).toPromise();
        const response = data?.jira?.applicationPropertiesByKey;
        if (!response) throw new Error('GraphQL error fetching application properties');
        return response.reduce((accumulator, responseObject)=>{
            const { key: key, value: value } = responseObject;
            accumulator[key] = {
                key: key,
                value: value === 'true'
            };
            return accumulator;
        }, {});
    } catch (e) {
        const error = e instanceof Error ? e : new Error('Failed to fetch application properties');
        (0, $guiFP.default)({
            meta: {
                id: 'getConfluenceApplicationProperties',
                packageName: 'jiraConfluenceIntegrationControls'
            },
            error: error
        });
        throw error;
    }
};
const $b35b16c0892c7e3f$export$1becbc41e80a8aea = async (featureKey, value)=>{
    const data = {
        id: featureKey,
        value: value
    };
    try {
        const { id: id, value: updatedValue } = await (0, $2OUyw.setApplicationProperties)('', featureKey, JSON.stringify(data));
        // For admins who had previously cached values used in features
        (0, $3qF4w.clearSessionStorageData)((0, $cGCxH.CONFLUENCE_CONTROLS_STORAGE_KEY), $b35b16c0892c7e3f$var$storage);
        return {
            key: id,
            value: updatedValue === 'true'
        };
    } catch (e) {
        const error = e instanceof Error ? e : new Error('Failed to set application properties');
        (0, $guiFP.default)({
            meta: {
                id: 'setConfluenceApplicationProperty',
                packageName: 'jiraConfluenceIntegrationControls'
            },
            error: error
        });
        throw error;
    }
};

});
parcelRegister("bInDC", function(module, exports) {

$parcel$export(module.exports, "default", () => $58790bf35641a677$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ae999777cbfd22caef956051c2c40e88>>
 * @relayHash 86c70b4eeb101ecb6586554a0835034b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c0fec7afcdea33af0b796ec9b4bb29c26bd102c7eafa58714a7c1bdae4678cb8
const $58790bf35641a677$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "keys"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "keys",
            "variableName": "keys"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "applicationPropertiesGetConfluencePropertiesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "applicationPropertiesGetConfluencePropertiesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c0fec7afcdea33af0b796ec9b4bb29c26bd102c7eafa58714a7c1bdae4678cb8",
            "metadata": {},
            "name": "applicationPropertiesGetConfluencePropertiesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$58790bf35641a677$var$node.hash = "22bd28d5a1b34c4d3bb8292e3ce92fb3";
var $58790bf35641a677$export$2e2bcd8739ae039 = $58790bf35641a677$var$node;

});

parcelRegister("2OUyw", function(module, exports) {

$parcel$export(module.exports, "getApplicationProperty", () => $1aedb09dd94ce128$export$68f9d9c41caba043);
$parcel$export(module.exports, "setApplicationProperties", () => $1aedb09dd94ce128$export$8bb6477dd3ceb5fc);

var $lRmyA = parcelRequire("lRmyA");

const $1aedb09dd94ce128$var$getApplicationPropertyUrl = (baseUrl, propertyKey)=>`${baseUrl}${0, $263c1cd0ef263638$export$3dd4dc5621aeefdb}?key=${propertyKey}`;
const $1aedb09dd94ce128$var$getApplicationPropertiesUrl = (propertyKeyFilter)=>`${0, $263c1cd0ef263638$export$3dd4dc5621aeefdb}?keyFilter=${propertyKeyFilter}`;
const $1aedb09dd94ce128$var$setApplicationPropertiesUrl = (baseUrl, propertyKey)=>`${baseUrl}${0, $263c1cd0ef263638$export$3dd4dc5621aeefdb}/${propertyKey}`;
const $1aedb09dd94ce128$export$68f9d9c41caba043 = (baseUrl, propertyKey)=>(0, $lRmyA.performGetRequest)($1aedb09dd94ce128$var$getApplicationPropertyUrl(baseUrl, propertyKey));
const $1aedb09dd94ce128$export$6b1cb50e5883af63 = (propertyKeyFilter)=>(0, $lRmyA.performGetRequest)($1aedb09dd94ce128$var$getApplicationPropertiesUrl(propertyKeyFilter));
const $1aedb09dd94ce128$export$8bb6477dd3ceb5fc = async (baseUrl, propertyKey, data)=>(0, $lRmyA.performPutRequest)($1aedb09dd94ce128$var$setApplicationPropertiesUrl(baseUrl, propertyKey), {
        body: data
    });

});
const $263c1cd0ef263638$export$3dd4dc5621aeefdb = '/rest/api/3/application-properties';




parcelRegister("9Hi6E", function(module, exports) {

$parcel$export(module.exports, "useUserHasConfluenceAccess", () => $bdf8426cb8b155be$export$bddce71054147149);

var $eUqFw = parcelRequire("eUqFw");

var $89bO2 = parcelRequire("89bO2");

var $3555e = parcelRequire("3555e");

var $guiFP = parcelRequire("guiFP");

var $gd0Sp = parcelRequire("gd0Sp");

var $cGCxH = parcelRequire("cGCxH");

var $cj5H0 = parcelRequire("cj5H0");

var $3qF4w = parcelRequire("3qF4w");

var $e4oen = parcelRequire("e4oen");
const $bdf8426cb8b155be$var$TIME_TO_LIVE = 3600000; // 1 hr
const $bdf8426cb8b155be$var$storage = (0, $89bO2.createSessionStorageProvider)((0, $cGCxH.CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY));
const $bdf8426cb8b155be$export$bddce71054147149 = (embeddedConfluenceSource, skip = false)=>{
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const fireAnalyticsEvent = (0, $e4oen.useEmbeddedPageTracking)();
    const tenantHasConfluence = (0, $3555e.useTenantHasConfluence)();
    const [hasAccess, setHasAccess] = (0, $eUqFw.useState)(false);
    const permitted = (0, $eUqFw.useMemo)(()=>(0, $3qF4w.getSessionStorageData)((0, $cGCxH.CONFLUENCE_ACCESS_STORAGE_KEY), $bdf8426cb8b155be$var$storage)?.permitted, []);
    const getConfluencePermissions = (0, $eUqFw.useCallback)(async ()=>{
        try {
            const response = tenantHasConfluence ? await (0, $cj5H0.fetchConfluenceUserPermissions)(cloudId) : {
                permitted: false
            };
            fireAnalyticsEvent({
                action: 'success',
                eventName: 'userConfluenceAccess',
                embeddedConfluenceSource: embeddedConfluenceSource
            });
            (0, $3qF4w.setSessionStorageData)({
                key: (0, $cGCxH.CONFLUENCE_ACCESS_STORAGE_KEY),
                value: response,
                ttl: $bdf8426cb8b155be$var$TIME_TO_LIVE,
                storage: $bdf8426cb8b155be$var$storage
            });
            setHasAccess(response?.permitted);
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'userConfluenceAccess',
                    teamName: 'confluence-better-together'
                },
                attributes: {
                    embeddedConfluenceSource: embeddedConfluenceSource
                },
                error: new Error(`Failed to get user confluence access status: ${error}`)
            });
        }
    }, [
        cloudId,
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        tenantHasConfluence
    ]);
    const refetchHasAccess = (0, $eUqFw.useCallback)(async ()=>{
        (0, $3qF4w.setSessionStorageData)({
            key: (0, $cGCxH.CONFLUENCE_ACCESS_STORAGE_KEY),
            value: {},
            ttl: $bdf8426cb8b155be$var$TIME_TO_LIVE,
            storage: $bdf8426cb8b155be$var$storage
        });
        await getConfluencePermissions();
    }, [
        getConfluencePermissions
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (skip) return;
        if (!(0, $3qF4w.getSessionStorageData)((0, $cGCxH.CONFLUENCE_ACCESS_STORAGE_KEY), $bdf8426cb8b155be$var$storage)) (0, $3qF4w.setSessionStorageData)({
            key: (0, $cGCxH.CONFLUENCE_ACCESS_STORAGE_KEY),
            value: {},
            ttl: $bdf8426cb8b155be$var$TIME_TO_LIVE,
            storage: $bdf8426cb8b155be$var$storage
        });
        if (!(0, $3qF4w.isStorageKeyExpired)((0, $cGCxH.CONFLUENCE_ACCESS_STORAGE_KEY), $bdf8426cb8b155be$var$storage) && permitted !== undefined) setHasAccess(permitted);
        else if (cloudId) getConfluencePermissions();
    }, [
        cloudId,
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        getConfluencePermissions,
        permitted,
        skip
    ]);
    return {
        hasAccess: hasAccess,
        refetchHasAccess: refetchHasAccess
    };
};

});
parcelRegister("cj5H0", function(module, exports) {

$parcel$export(module.exports, "fetchConfluenceUserPermissions", () => $9735c9c605819bed$export$e1aee708fe0c56c2);

var $2OdyW = parcelRequire("2OdyW");
const $9735c9c605819bed$export$e1aee708fe0c56c2 = async (cloudId)=>{
    const response = await (0, $2OdyW.default)('/gateway/api/permissions/permitted', {
        method: 'POST',
        body: JSON.stringify({
            resourceId: `ari:cloud:confluence::site/${cloudId}`,
            permissionId: 'write'
        }),
        headers: {
            Accept: 'application/json'
        }
    });
    return response;
};

});

parcelRegister("e4oen", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPageTracking", () => $563833caf662c029$export$9fcd107e4ed1de75);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $hJ992 = parcelRequire("hJ992");

var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $5DqQW = parcelRequire("5DqQW");
const $563833caf662c029$var$getParentProduct = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $7ZZxN.CORE_PROJECT:
            return 'JWM';
        default:
            return 'JSW';
    }
};
const $563833caf662c029$export$9fcd107e4ed1de75 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const source = (0, $hJ992.useAnalyticsSource)();
    const trackEmbeddedConfluence = (0, $eUqFw.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject ?? `${eventName}`
        });
        const attributes = {
            parentProduct: $563833caf662c029$var$getParentProduct(projectType),
            tenantEditions: tenantContext?.appEditions,
            productEntitlementDetails: tenantContext?.productEntitlementDetails,
            embeddedConfluenceSource: embeddedConfluenceSource,
            jiraIssueSurfaceArea: source,
            userHasConfluenceAccess: userHasConfluenceAccess,
            tenantHasConfluence: tenantHasConfluence,
            crossJoinStatus: crossJoinStatus,
            originProduct: originProduct,
            requestedProduct: requestedProduct
        };
        (0, $5DqQW.fireEmbeddedConfluenceAnalytics)({
            analyticsEvent: analyticsEvent,
            attributes: attributes,
            eventType: eventType,
            eventName: `${actionSubject ?? eventName} ${action}`
        });
    }, [
        source,
        tenantContext,
        createAnalyticsEvent
    ]);
    return trackEmbeddedConfluence;
};

});
parcelRegister("5DqQW", function(module, exports) {

$parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", () => $731065451fcf0853$export$864bc2da9014e8e9);

var $jMP2a = parcelRequire("jMP2a");
const $731065451fcf0853$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
    switch(eventType){
        case 'ui':
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, attributes);
            break;
        case 'operational':
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        case 'track':
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        default:
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, attributes);
            break;
    }
};

});



const $1b2c5e0fcb49d7fc$export$f19c4e560a68c416 = 'jiraIssueView';
const $1b2c5e0fcb49d7fc$export$2e6ff5d53a830129 = 'jiraIssueViewLinkedMentionedPage';
const $1b2c5e0fcb49d7fc$export$2d990bc8cd668ca1 = 'jiraIssueViewQuickAddItem';
const $1b2c5e0fcb49d7fc$export$d3566448206b58e = 'jiraIssueViewLinkConfluencePage';
const $1b2c5e0fcb49d7fc$export$c257b3d4e328f4ba = 'jiraIssueViewLengthyDescriptionMessage';
const $1b2c5e0fcb49d7fc$export$d7568f1916ebda24 = 'jiraSoftwareBacklogEndOfSprintRetro';

parcelRegister("4Efjz", function(module, exports) {

$parcel$export(module.exports, "useUserHasConfluenceAccess", () => $bfed4d0392b4a82b$export$bddce71054147149);

var $eUqFw = parcelRequire("eUqFw");

var $3555e = parcelRequire("3555e");

var $guiFP = parcelRequire("guiFP");

var $gd0Sp = parcelRequire("gd0Sp");

var $annFZ = parcelRequire("annFZ");

var $eq2dV = parcelRequire("eq2dV");

var $9oEBG = parcelRequire("9oEBG");
const $bfed4d0392b4a82b$var$CONFLUENCE_ACCESS_KEY = 'userConfluenceAccess';
const $bfed4d0392b4a82b$var$TIME_TO_LIVE = 3600000; // 1 hr
const $bfed4d0392b4a82b$export$bddce71054147149 = (embeddedConfluenceSource, skip = false)=>{
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const fireAnalyticsEvent = (0, $eq2dV.useEmbeddedPageTracking)();
    const tenantHasConfluence = (0, $3555e.useTenantHasConfluence)();
    const [hasAccess, setHasAccess] = (0, $eUqFw.useState)(false);
    const { permitted: permitted } = (0, $eUqFw.useMemo)(()=>(0, $9oEBG.getLocalStorageData)($bfed4d0392b4a82b$var$CONFLUENCE_ACCESS_KEY), []);
    const getConfluencePermissions = (0, $eUqFw.useCallback)(async ()=>{
        try {
            const response = await (0, $annFZ.fetchConfluenceUserPermissions)(cloudId);
            fireAnalyticsEvent({
                action: 'success',
                eventName: 'userConfluenceAccess',
                embeddedConfluenceSource: embeddedConfluenceSource
            });
            (0, $9oEBG.setLocalStorageData)($bfed4d0392b4a82b$var$CONFLUENCE_ACCESS_KEY, response);
            setHasAccess(response?.permitted);
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'userConfluenceAccess',
                    teamName: 'confluence-better-together'
                },
                attributes: {
                    embeddedConfluenceSource: embeddedConfluenceSource
                },
                error: new Error(`Failed to get user confluence access status: ${error}`)
            });
        }
    }, [
        cloudId,
        embeddedConfluenceSource,
        fireAnalyticsEvent
    ]);
    const refetchHasAccess = (0, $eUqFw.useCallback)(async ()=>{
        (0, $9oEBG.setLocalStorageData)($bfed4d0392b4a82b$var$CONFLUENCE_ACCESS_KEY, {});
        await getConfluencePermissions();
    }, [
        getConfluencePermissions
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (skip) return;
        if (!(0, $9oEBG.getLocalStorageData)($bfed4d0392b4a82b$var$CONFLUENCE_ACCESS_KEY)) (0, $9oEBG.setLocalStorageData)($bfed4d0392b4a82b$var$CONFLUENCE_ACCESS_KEY, {});
        if (!(0, $9oEBG.isCacheExpired)($bfed4d0392b4a82b$var$CONFLUENCE_ACCESS_KEY, $bfed4d0392b4a82b$var$TIME_TO_LIVE) && permitted !== undefined) setHasAccess(permitted);
        else if (tenantHasConfluence && cloudId) getConfluencePermissions();
    }, [
        cloudId,
        tenantHasConfluence,
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        getConfluencePermissions,
        permitted,
        skip
    ]);
    return {
        hasAccess: hasAccess,
        refetchHasAccess: refetchHasAccess
    };
};

});
parcelRegister("annFZ", function(module, exports) {

$parcel$export(module.exports, "fetchConfluenceUserPermissions", () => $cfb6a8e2294a1fe2$export$e1aee708fe0c56c2);

var $2OdyW = parcelRequire("2OdyW");
const $cfb6a8e2294a1fe2$export$e1aee708fe0c56c2 = async (cloudId)=>{
    const response = await (0, $2OdyW.default)('/gateway/api/permissions/permitted', {
        method: 'POST',
        body: JSON.stringify({
            resourceId: `ari:cloud:confluence::site/${cloudId}`,
            permissionId: 'write'
        }),
        headers: {
            Accept: 'application/json'
        }
    });
    return response;
};

});

parcelRegister("eq2dV", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPageTracking", () => $471d338f836f9c77$export$9fcd107e4ed1de75);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $ls5tj = parcelRequire("ls5tj");

var $6myYy = parcelRequire("6myYy");
const $471d338f836f9c77$export$9fcd107e4ed1de75 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const source = (0, $hJ992.useAnalyticsSource)();
    const trackEmbeddedConfluence = (0, $eUqFw.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject ?? `${eventName}`
        });
        const attributes = {
            parentProduct: (0, $ls5tj.getParentProduct)(projectType),
            tenantEditions: tenantContext?.appEditions,
            productEntitlementDetails: tenantContext?.productEntitlementDetails,
            embeddedConfluenceSource: embeddedConfluenceSource,
            jiraIssueSurfaceArea: source,
            userHasConfluenceAccess: userHasConfluenceAccess,
            tenantHasConfluence: tenantHasConfluence,
            crossJoinStatus: crossJoinStatus,
            originProduct: originProduct,
            requestedProduct: requestedProduct,
            isSiteAdmin: tenantContext?.isSiteAdmin
        };
        (0, $6myYy.fireEmbeddedConfluenceAnalytics)({
            analyticsEvent: analyticsEvent,
            attributes: attributes,
            eventType: eventType,
            eventName: `${actionSubject ?? eventName} ${action}`
        });
    }, [
        source,
        tenantContext,
        createAnalyticsEvent
    ]);
    return trackEmbeddedConfluence;
};

});
parcelRegister("ls5tj", function(module, exports) {

$parcel$export(module.exports, "ACCESS_REQUEST_CAPABILITIES", () => $f8a0c629383095b7$export$b4e6d6efc113ca5);
$parcel$export(module.exports, "VALID_DIRECT_ACCESS_STATUS", () => $f8a0c629383095b7$export$bf1e31028b579014);
$parcel$export(module.exports, "ACCESS_DENIED_STATUSES", () => $f8a0c629383095b7$export$2fe5bb2d968b01fc);
$parcel$export(module.exports, "getParentProduct", () => $f8a0c629383095b7$export$e873edb2560a07ef);

var $7ZZxN = parcelRequire("7ZZxN");

var $64PSE = parcelRequire("64PSE");

var $4YFgD = parcelRequire("4YFgD");

var $2XxeS = parcelRequire("2XxeS");

var $fEdG4 = parcelRequire("fEdG4");
const $f8a0c629383095b7$export$b4e6d6efc113ca5 = {
    ACCESS_GRANTED: 'ACCESS_GRANTED',
    ACCESS_EXISTS: 'ACCESS_EXISTS',
    DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
    DIRECT_ACCESS: 'DIRECT_ACCESS',
    FORBIDDEN: 'FORBIDDEN',
    PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
    REQUEST_ACCESS: 'REQUEST_ACCESS'
};
const $f8a0c629383095b7$export$bf1e31028b579014 = [
    $f8a0c629383095b7$export$b4e6d6efc113ca5.ACCESS_EXISTS,
    $f8a0c629383095b7$export$b4e6d6efc113ca5.ACCESS_GRANTED,
    $f8a0c629383095b7$export$b4e6d6efc113ca5.PENDING_REQUEST_EXISTS
];
const $f8a0c629383095b7$export$2fe5bb2d968b01fc = [
    $f8a0c629383095b7$export$b4e6d6efc113ca5.FORBIDDEN,
    $f8a0c629383095b7$export$b4e6d6efc113ca5.DENIED_REQUEST_EXISTS
];
const $f8a0c629383095b7$export$e873edb2560a07ef = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $7ZZxN.CORE_PROJECT:
            return 'JWM';
        default:
            return 'JSW';
    }
};

});
parcelRegister("64PSE", function(module, exports) {

$parcel$export(module.exports, "getSpaceKey", () => $098d58786c2b42cf$export$c74e0ded7b123e80);

var $78Ywx = parcelRequire("78Ywx");

var $1d3eD = parcelRequire("1d3eD");
const $098d58786c2b42cf$var$pattern = '/wiki/spaces/:spaceKey/whiteboard/:contentId(\\d+)';
const $098d58786c2b42cf$export$c74e0ded7b123e80 = (url)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($78Ywx))).parse(url, true);
    const pathname = parsed.pathname ?? '';
    const match = (0, $1d3eD.default)(pathname, {
        path: $098d58786c2b42cf$var$pattern,
        exact: true
    });
    return match?.params.spaceKey;
};

});
parcelRegister("1d3eD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e1983bddd0ee331$export$2e2bcd8739ae039);

var $43pB1 = parcelRequire("43pB1");
var $0e1983bddd0ee331$var$patternCache = {};
var $0e1983bddd0ee331$var$cacheLimit = 10000;
var $0e1983bddd0ee331$var$cacheCount = 0;
var $0e1983bddd0ee331$var$compilePath = function compilePath(pattern, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var cache = $0e1983bddd0ee331$var$patternCache[cacheKey] || ($0e1983bddd0ee331$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];
    var re = (0, (/*@__PURE__*/$parcel$interopDefault($43pB1)))(pattern, keys, options);
    var compiledPattern = {
        re: re,
        keys: keys
    };
    if ($0e1983bddd0ee331$var$cacheCount < $0e1983bddd0ee331$var$cacheLimit) {
        cache[pattern] = compiledPattern;
        $0e1983bddd0ee331$var$cacheCount++;
    }
    return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */ var $0e1983bddd0ee331$var$matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parent = arguments[2];
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
    if (path == null) return parent;
    var _compilePath = $0e1983bddd0ee331$var$compilePath(path, {
        end: exact,
        strict: strict,
        sensitive: sensitive
    }), re = _compilePath.re, keys = _compilePath.keys;
    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
        path: path,
        url: path === "/" && url === "" ? "/" : url,
        isExact: isExact,
        params: keys.reduce(function(memo, key, index) {
            memo[key.name] = values[index];
            return memo;
        }, {})
    };
};
var $0e1983bddd0ee331$export$2e2bcd8739ae039 = $0e1983bddd0ee331$var$matchPath;

});


parcelRegister("4YFgD", function(module, exports) {

$parcel$export(module.exports, "isValidUrl", () => $b579652caee60b2f$export$bef94a5618bf18bf);
const $b579652caee60b2f$export$bef94a5618bf18bf = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};

});

parcelRegister("2XxeS", function(module, exports) {

$parcel$export(module.exports, "isCustomDomain", () => $114e25cd3035a797$export$97f4c254b641e719);
const $114e25cd3035a797$var$atlassianDomains = [
    '.atlassian.com',
    '.atlassian.net',
    '.jira-dev.com',
    '.jira.com',
    '.atlassian-stg-fedm.net',
    '.atlassian-us-gov-mod.net',
    '.atlassian-us-gov-mod.com'
];
const $114e25cd3035a797$export$97f4c254b641e719 = (hostname)=>!$114e25cd3035a797$var$atlassianDomains.some((domain)=>hostname.endsWith(domain));

});

parcelRegister("fEdG4", function(module, exports) {

$parcel$export(module.exports, "getHostnameFromUrl", () => $ee5f489954b592fe$export$280e79c794cf814e);

var $4YFgD = parcelRequire("4YFgD");
const $ee5f489954b592fe$export$280e79c794cf814e = (url)=>(0, $4YFgD.isValidUrl)(url) ? new URL(url)?.hostname : '';

});


parcelRegister("6myYy", function(module, exports) {

$parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", () => $be7aa4fcf32865f7$export$864bc2da9014e8e9);

var $jMP2a = parcelRequire("jMP2a");
const $be7aa4fcf32865f7$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
    switch(eventType){
        case 'ui':
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, attributes);
            break;
        case 'operational':
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        case 'track':
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        default:
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, attributes);
            break;
    }
};

});


parcelRegister("9oEBG", function(module, exports) {

$parcel$export(module.exports, "getSessionStorageData", () => $639a137dc454ed17$export$af84d82ff1eea56d);
$parcel$export(module.exports, "setSessionStorageData", () => $639a137dc454ed17$export$be8cb7c8f1a1db6b);
$parcel$export(module.exports, "isStorageKeyExpired", () => $639a137dc454ed17$export$59dd918a314efec0);
$parcel$export(module.exports, "getLocalStorageData", () => $639a137dc454ed17$export$b2521dd6e4e1a602);
$parcel$export(module.exports, "setLocalStorageData", () => $639a137dc454ed17$export$66e1b6860596375e);
$parcel$export(module.exports, "isCacheExpired", () => $639a137dc454ed17$export$d812b641f1458de4);

var $89bO2 = parcelRequire("89bO2");

var $guiFP = parcelRequire("guiFP");
const $639a137dc454ed17$var$createTTLTimestamp = (ttl)=>Date.now() + ttl;
const $639a137dc454ed17$var$storage = (0, $89bO2.createSessionStorageProvider)('create-confluence-content');
const $639a137dc454ed17$export$af84d82ff1eea56d = (key)=>$639a137dc454ed17$var$storage.get(key);
const $639a137dc454ed17$export$be8cb7c8f1a1db6b = ({ key: key, value: value, ttl: ttl })=>{
    const expiresAt = $639a137dc454ed17$var$createTTLTimestamp(ttl);
    $639a137dc454ed17$var$storage.set(key, {
        ...value,
        expiresAt: expiresAt
    });
};
const $639a137dc454ed17$export$59dd918a314efec0 = (key)=>{
    const expiresAt = $639a137dc454ed17$export$af84d82ff1eea56d(key)?.expiresAt;
    return new Date().getTime() >= expiresAt;
};
const $639a137dc454ed17$export$b2521dd6e4e1a602 = (cachedRequestId)=>JSON.parse(localStorage?.getItem(cachedRequestId) ?? '""');
const $639a137dc454ed17$export$66e1b6860596375e = (cachedRequestId, responseData)=>{
    const currentTime = new Date().getTime();
    try {
        localStorage.setItem(cachedRequestId, JSON.stringify({
            ...responseData,
            storedAt: currentTime
        }));
    } catch (error) {
        // localStorage.setItem might fail if the storage is full
        (0, $guiFP.default)({
            meta: {
                id: 'setLocalStorageData',
                packageName: 'jiraIssueCreateConfluenceContent'
            },
            error: error instanceof Error ? error : undefined
        });
    }
};
const $639a137dc454ed17$export$d812b641f1458de4 = (cachedRequestId, invalidAt)=>{
    const { storedAt: storedAt } = $639a137dc454ed17$export$b2521dd6e4e1a602(cachedRequestId);
    if (!storedAt) return true;
    const currentTime = new Date().getTime();
    const timeDifference = currentTime - storedAt;
    return storedAt && timeDifference > invalidAt;
};

});


const $35b9cb9c9c5b9881$export$f453f0ae4d2b19d6 = 'platform_embed-conf_jira-issue_cross-join_exp_aa';
const $35b9cb9c9c5b9881$export$91b9a518fb7a083c = 'platform_embed-conf_jira-issue_cross-join_exp';
const $35b9cb9c9c5b9881$export$78c16e54abd09d11 = 'platform_embed-conf_bento_linked_crossjoin_exp';
const $35b9cb9c9c5b9881$export$75e1ed3108cef5fb = 'platform_embed-conf_bento_linked_crossjoin_exp_aa';
const $35b9cb9c9c5b9881$export$f2efdae3d6c327d1 = 'platform_embed_conf_jira-issue_co-use_exp';
const $35b9cb9c9c5b9881$export$6c66b7c0a63aae32 = 'jira_create_confluence_content_crossflow';
const $35b9cb9c9c5b9881$export$e972245bccbd8ae3 = 'jira_create_confluence_content_crossflow_aa';
const $35b9cb9c9c5b9881$export$3d370c33621572df = 'cohort';
const $35b9cb9c9c5b9881$export$8ea6555e3e46f620 = 'not-enrolled';
const $35b9cb9c9c5b9881$export$e9cae393a0b9eb85 = 'experiment';
const $35b9cb9c9c5b9881$export$b3ba2b75eab4739d = 'control';

parcelRegister("8PPG1", function(module, exports) {

$parcel$export(module.exports, "CreatePageMenuItem", () => $9e1226a1bb0fdfc5$export$537bfd39b76beb57);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $dc3ju = parcelRequire("dc3ju");

var $3555e = parcelRequire("3555e");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hXqDm = parcelRequire("hXqDm");

var $6mvny = parcelRequire("6mvny");

var $pdpBS = parcelRequire("pdpBS");

var $eq2dV = parcelRequire("eq2dV");

var $bczMu = parcelRequire("bczMu");

var $lw8L4 = parcelRequire("lw8L4");
const $9e1226a1bb0fdfc5$export$537bfd39b76beb57 = ({ onCancel: onCancel, onCloseComplete: onCloseComplete, onCreate: onCreate, onFailure: onFailure, onOpenComplete: onOpenComplete, onCreateBehavior: onCreateBehavior })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { accessStatus: accessStatus, setIsCreateContentModalOpen: setIsCreateContentModalOpen, setCreateContentRuntimeProps: setCreateContentRuntimeProps, setActivePageUrl: setActivePageUrl, setIsEpModalOpen: setIsEpModalOpen, embeddedConfluenceSource: embeddedConfluenceSource, userHasConfluenceAccess: userHasConfluenceAccess } = (0, $eUqFw.useContext)((0, $6mvny.ContentMenuContext));
    const fireAnalyticsEvent = (0, $eq2dV.useEmbeddedPageTracking)();
    const getCreateContentClickBehavior = (0, $pdpBS.useCreateContentClickBehavior)();
    const tenantHasConfluence = (0, $3555e.useTenantHasConfluence)();
    const createConfluencePage = ()=>{
        setIsCreateContentModalOpen(true);
        setCreateContentRuntimeProps({
            isOpen: true,
            contentType: (0, $hXqDm.CONTENT_TYPE).PAGE,
            onCancel: onCancel,
            onCloseComplete: onCloseComplete,
            onCreate: (payload)=>{
                onCreate && onCreate(payload);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const links = payload.data?.links;
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const spaceKey = payload.data?.spaceKey;
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const spaceId = payload.data?.spaceId;
                const linkableUrl = (0, $bczMu.convertUrlSpaceIdToSpaceKey)({
                    url: payload.url,
                    spaceId: spaceId,
                    spaceKey: spaceKey
                });
                setActivePageUrl(`${linkableUrl}?draftShareId=${(0, $bczMu.getDraftShareId)(links?.editui)}`);
                setIsEpModalOpen(true);
            },
            onFailure: onFailure,
            onOpenComplete: onOpenComplete,
            onCreateBehavior: onCreateBehavior
        });
    };
    const onOpen = ()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            eventName: 'createPageMenuItem',
            embeddedConfluenceSource: embeddedConfluenceSource,
            userHasConfluenceAccess: userHasConfluenceAccess,
            tenantHasConfluence: tenantHasConfluence,
            crossJoinStatus: accessStatus
        });
        return getCreateContentClickBehavior({
            accessStatus: accessStatus,
            createContent: createConfluencePage,
            tenantHasConfluence: tenantHasConfluence
        })();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        testId: "issue-create-confluence-content.ui.create-confluence-content-menu.create-page-menu-item.create-page-menu-item",
        onClick: onOpen,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dc3ju))), {
            label: ""
        })
    }, formatMessage((0, $lw8L4.default).createConfluencePageItem));
};

});
parcelRegister("dc3ju", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99aef74ed3f6888e$var$_react = $99aef74ed3f6888e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $99aef74ed3f6888e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $99aef74ed3f6888e$var$Page16Icon = (props)=>/*#__PURE__*/ $99aef74ed3f6888e$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm2 3a1 1 0 100 2h8a1 1 0 000-2H4zm0 4a1 1 0 100 2h8a1 1 0 000-2H4zm0 4a1 1 0 000 2h4a1 1 0 000-2H4z"/></svg>`
    }, props, {
        size: "small"
    }));
$99aef74ed3f6888e$var$Page16Icon.displayName = 'Page16Icon';
var $99aef74ed3f6888e$var$_default = $99aef74ed3f6888e$var$Page16Icon;
module.exports.default = $99aef74ed3f6888e$var$_default;

});

parcelRegister("hXqDm", function(module, exports) {

$parcel$export(module.exports, "LINK_CREATE_DRAFT_STATUS", () => $2dbaf2df18d7ad8b$export$b86d51ea0323efca);
$parcel$export(module.exports, "CONTENT_TYPE", () => $2dbaf2df18d7ad8b$export$a982aaff75f1c348);
$parcel$export(module.exports, "CONTENT_TYPE_TO_ENTITY_KEYS", () => $2dbaf2df18d7ad8b$export$de75e0e058bd457c);

var $6SW9p = parcelRequire("6SW9p");
const $2dbaf2df18d7ad8b$export$b86d51ea0323efca = 'draft';
const $2dbaf2df18d7ad8b$export$85e0e0ee2a57b9f = 'current';
const $2dbaf2df18d7ad8b$export$a982aaff75f1c348 = {
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
const $2dbaf2df18d7ad8b$export$de75e0e058bd457c = {
    [$2dbaf2df18d7ad8b$export$a982aaff75f1c348.PAGE]: (0, $6SW9p.entityKeys).confluencePage,
    [$2dbaf2df18d7ad8b$export$a982aaff75f1c348.WHITEBOARD]: (0, $6SW9p.entityKeys).confluenceWhiteboard
};

});
parcelRegister("6SW9p", function(module, exports) {

$parcel$export(module.exports, "entityKeys", () => $5034e4bdbbb056c3$export$be0551febfd6121e);
$parcel$export(module.exports, "ContentTypes", () => $5034e4bdbbb056c3$export$b9e669a853ca2f38);
$parcel$export(module.exports, "Fields", () => $5034e4bdbbb056c3$export$833b3e5a19fb8939);
$parcel$export(module.exports, "testIds", () => $5034e4bdbbb056c3$export$800daf5fbbe96aff);
$parcel$export(module.exports, "CONFLUENCE_EVENT_NAME", () => $5034e4bdbbb056c3$export$c312550dc4e28902);
const $5034e4bdbbb056c3$export$be0551febfd6121e = {
    confluencePage: 'confluence-page',
    confluenceWhiteboard: 'confluence-whiteboard'
};
const $5034e4bdbbb056c3$export$b9e669a853ca2f38 = {
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
let $5034e4bdbbb056c3$export$833b3e5a19fb8939 = /*#__PURE__*/ function(Fields) {
    Fields["Title"] = "title";
    Fields["Site"] = "site";
    Fields["SpacePage"] = "space_or_page";
    return Fields;
}({});
const $5034e4bdbbb056c3$export$800daf5fbbe96aff = {
    form: 'link-create-confluence-form',
    title: 'link-create-confluence-title',
    site: 'link-create-confluence-site-picker',
    space: 'link-create-confluence-space-picker',
    error: 'link-create-confluence-form-error'
};
const $5034e4bdbbb056c3$export$c312550dc4e28902 = {
    EDIT_PAGE: 'edit-page',
    EDIT_PAGE_LOAD: 'edit-page/load',
    EDIT_PAGE_PUBLISH: 'edit-page/publish',
    EDIT_PAGE_CLOSE: 'edit-page/close'
};

});


parcelRegister("6mvny", function(module, exports) {

$parcel$export(module.exports, "ContentMenuContext", () => $3896cb369d195153$export$16feceba178f5778);
$parcel$export(module.exports, "CreateConfluenceContentMenuProvider", () => $3896cb369d195153$export$2e078c4b60dc248e);

var $eUqFw = parcelRequire("eUqFw");

var $hXqDm = parcelRequire("hXqDm");

var $ls5tj = parcelRequire("ls5tj");
const $3896cb369d195153$var$defaultWhiteboardData = {
    url: '',
    objectId: '',
    objectType: ''
};
const $3896cb369d195153$export$16feceba178f5778 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    activePageUrl: '',
    accessStatus: (0, $ls5tj.ACCESS_REQUEST_CAPABILITIES).ACCESS_EXISTS,
    isCreateContentModalOpen: false,
    embeddedConfluenceSource: '',
    isEpModalOpen: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsCreateContentModalOpen: (_value)=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setActivePageUrl: (_value)=>{},
    createContentRuntimeProps: {
        isOpen: true,
        contentType: (0, $hXqDm.CONTENT_TYPE).PAGE
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setCreateContentRuntimeProps: (_value)=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsEpModalOpen: (_value)=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setAccessStatus: (_value)=>{},
    userHasConfluenceAccess: false,
    activeWhiteboardData: $3896cb369d195153$var$defaultWhiteboardData,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setActiveWhiteboardData: (_value)=>{},
    isEmbeddedWhiteboardModalOpen: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setEmbeddedWhiteboardModalOpen: (_value)=>{},
    isCrossFlowModalOpen: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsCrossFlowModalOpen: (_value)=>{}
});
const $3896cb369d195153$export$2e078c4b60dc248e = ({ children: children, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', hasConfluenceAccess: hasConfluenceAccess })=>{
    const [isCreateContentModalOpen, setIsCreateContentModalOpen] = (0, $eUqFw.useState)(false);
    const [isEpModalOpen, setIsEpModalOpen] = (0, $eUqFw.useState)(false);
    const [isEmbeddedWhiteboardModalOpen, setEmbeddedWhiteboardModalOpen] = (0, $eUqFw.useState)(false);
    const [isCrossFlowModalOpen, setIsCrossFlowModalOpen] = (0, $eUqFw.useState)(false);
    const [activePageUrl, setActivePageUrl] = (0, $eUqFw.useState)('');
    const [activeWhiteboardData, setActiveWhiteboardData] = (0, $eUqFw.useState)($3896cb369d195153$var$defaultWhiteboardData);
    const [createContentRuntimeProps, setCreateContentRuntimeProps] = (0, $eUqFw.useState)({
        onCreateBehavior: (0, $hXqDm.LINK_CREATE_DRAFT_STATUS),
        isOpen: true,
        contentType: (0, $hXqDm.CONTENT_TYPE).PAGE
    });
    const [accessStatus, setAccessStatus] = (0, $eUqFw.useState)('');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3896cb369d195153$export$16feceba178f5778.Provider, {
        value: {
            accessStatus: accessStatus,
            setAccessStatus: setAccessStatus,
            isCreateContentModalOpen: isCreateContentModalOpen,
            setIsCreateContentModalOpen: setIsCreateContentModalOpen,
            activePageUrl: activePageUrl,
            setActivePageUrl: setActivePageUrl,
            createContentRuntimeProps: createContentRuntimeProps,
            setCreateContentRuntimeProps: setCreateContentRuntimeProps,
            isEpModalOpen: isEpModalOpen,
            setIsEpModalOpen: setIsEpModalOpen,
            embeddedConfluenceSource: embeddedConfluenceSource,
            userHasConfluenceAccess: hasConfluenceAccess,
            activeWhiteboardData: activeWhiteboardData,
            setActiveWhiteboardData: setActiveWhiteboardData,
            isEmbeddedWhiteboardModalOpen: isEmbeddedWhiteboardModalOpen,
            setEmbeddedWhiteboardModalOpen: setEmbeddedWhiteboardModalOpen,
            isCrossFlowModalOpen: isCrossFlowModalOpen,
            setIsCrossFlowModalOpen: setIsCrossFlowModalOpen
        }
    }, children);
};

});

parcelRegister("pdpBS", function(module, exports) {

$parcel$export(module.exports, "useCreateContentClickBehavior", () => $5000b4bec5d19b98$export$b0b94aecf211287e);

var $eUqFw = parcelRequire("eUqFw");

var $6mvny = parcelRequire("6mvny");

var $dIFo2 = parcelRequire("dIFo2");

var $eq2dV = parcelRequire("eq2dV");

var $ls5tj = parcelRequire("ls5tj");
const $5000b4bec5d19b98$var$BASE_DELAY = 300;
const $5000b4bec5d19b98$var$MAX_DELAY = 10000;
const $5000b4bec5d19b98$export$b0b94aecf211287e = ()=>{
    const { embeddedConfluenceSource: embeddedConfluenceSource, setAccessStatus: setAccessStatus, setIsCrossFlowModalOpen: setIsCrossFlowModalOpen } = (0, $eUqFw.useContext)((0, $6mvny.ContentMenuContext));
    const fireAnalyticsEvent = (0, $eq2dV.useEmbeddedPageTracking)();
    const { directJoin: directJoin } = (0, $dIFo2.useDirectJoinConfluence)({
        embeddedConfluenceSource: embeddedConfluenceSource,
        onSuccess: ()=>setAccessStatus((0, $ls5tj.ACCESS_REQUEST_CAPABILITIES).ACCESS_EXISTS)
    });
    const requestAccess = ()=>{
        fireAnalyticsEvent({
            action: 'requested',
            actionSubject: 'productAccess',
            eventName: 'productAccess requested',
            embeddedConfluenceSource: embeddedConfluenceSource,
            originProduct: 'jira',
            requestedProduct: 'confluence',
            eventType: 'track'
        });
        const tenantUrl = window.location.origin;
        window.open(`${tenantUrl}/wiki`, '_blank');
    };
    const handleDirectJoin = (retries = 15)=>directJoin({
            retries: retries,
            baseDelay: $5000b4bec5d19b98$var$BASE_DELAY,
            maxDelay: $5000b4bec5d19b98$var$MAX_DELAY
        });
    const openCrossFlowModal = ()=>{
        setIsCrossFlowModalOpen(true);
    };
    const getCreateContentClickBehavior = ({ accessStatus: accessStatus, createContent: createContent, tenantHasConfluence: tenantHasConfluence })=>{
        if (!tenantHasConfluence) return openCrossFlowModal;
        switch(accessStatus){
            case (0, $ls5tj.ACCESS_REQUEST_CAPABILITIES).REQUEST_ACCESS:
            case (0, $ls5tj.ACCESS_REQUEST_CAPABILITIES).PENDING_REQUEST_EXISTS:
            case (0, $ls5tj.ACCESS_REQUEST_CAPABILITIES).DENIED_REQUEST_EXISTS:
            case (0, $ls5tj.ACCESS_REQUEST_CAPABILITIES).FORBIDDEN:
                return requestAccess;
            case (0, $ls5tj.ACCESS_REQUEST_CAPABILITIES).DIRECT_ACCESS:
                return handleDirectJoin;
            case (0, $ls5tj.ACCESS_REQUEST_CAPABILITIES).ACCESS_EXISTS:
                return createContent;
            default:
                return requestAccess;
        }
    };
    return getCreateContentClickBehavior;
};

});
parcelRegister("dIFo2", function(module, exports) {

$parcel$export(module.exports, "useDirectJoinConfluence", () => $f2edfc8e265010ed$export$cddadceba3dc777c);

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gd0Sp = parcelRequire("gd0Sp");

var $6afam = parcelRequire("6afam");

var $493fK = parcelRequire("493fK");

var $7o3Dg = parcelRequire("7o3Dg");

var $eq2dV = parcelRequire("eq2dV");

var $ls5tj = parcelRequire("ls5tj");

var $81HMX = parcelRequire("81HMX");
/*
        We arbitrarily set the base retry number to 15 because there is a 10-20s delay between
        a user being granted access to Confluence and their Confluence account being created.
        Their account must be created in order for them to be able to create a page.
    */ const $f2edfc8e265010ed$var$RETRIES = 15;
const $f2edfc8e265010ed$var$BASE_DELAY = 300;
const $f2edfc8e265010ed$var$MAX_DELAY = 10000;
const $f2edfc8e265010ed$export$cddadceba3dc777c = ({ embeddedConfluenceSource: embeddedConfluenceSource, onError: onError, onSuccess: onSuccess })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const fireAnalyticsEvent = (0, $eq2dV.useEmbeddedPageTracking)();
    const handleError = (0, $7o3Dg.handleFailureWithNotification)({
        embeddedConfluenceSource: embeddedConfluenceSource,
        showFlag: showFlag
    });
    const handleSuccess = (0, $7o3Dg.handleSuccessWithNotification)({
        fireAnalytics: fireAnalyticsEvent,
        embeddedConfluenceSource: embeddedConfluenceSource,
        showFlag: showFlag
    });
    const directJoin = async ({ retries: retries = $f2edfc8e265010ed$var$RETRIES, baseDelay: baseDelay = $f2edfc8e265010ed$var$BASE_DELAY, maxDelay: maxDelay = $f2edfc8e265010ed$var$MAX_DELAY })=>{
        try {
            const response = await (0, $493fK.directJoinConfluence)(cloudId);
            const data = await response.json();
            const status = data?.results?.[`${0, $493fK.CONF_REQUEST_ACCESS_CAPABILITIES_ARI}${cloudId}`];
            handleSuccess({
                eventName: 'directJoinConfluence',
                flagId: (0, $6afam.SUCCESS_FLAGS).directJoinSuccess,
                title: formatMessage((0, $81HMX.default).directJoinSuccessTitle),
                description: formatMessage((0, $81HMX.default).directJoinSuccessDescription),
                useConfIcon: true
            });
            if ((0, $ls5tj.VALID_DIRECT_ACCESS_STATUS).includes(status)) {
                const requestResponse = await (0, $493fK.getCurrentConfluenceUser)({
                    cloudId: cloudId,
                    retries: retries,
                    baseDelay: baseDelay,
                    maxDelay: maxDelay
                });
                if (!requestResponse.success) throw requestResponse.error;
                onSuccess && onSuccess(status);
                handleSuccess({
                    action: 'joined',
                    actionSubject: 'product',
                    eventName: 'product joined',
                    eventType: 'track',
                    originProduct: 'jira',
                    requestedProduct: 'confluence',
                    flagId: (0, $6afam.SUCCESS_FLAGS).verifyDirectJoinSuccess,
                    title: formatMessage((0, $81HMX.default).directJoinVerifySuccessTitle),
                    description: formatMessage((0, $81HMX.default).directJoinVerifySuccessDescription),
                    useConfIcon: true
                });
            } else if ((0, $ls5tj.ACCESS_DENIED_STATUSES).includes(status)) handleSuccess({
                action: 'denied',
                actionSubject: 'product',
                eventName: 'product joined',
                originProduct: 'jira',
                requestedProduct: 'confluence',
                flagId: (0, $6afam.FAIL_FLAGS).directJoinDenied,
                title: formatMessage((0, $81HMX.default).directJoinDeniedTitle),
                description: formatMessage((0, $81HMX.default).directJoinDeniedDescription),
                useConfIcon: true
            });
            else throw new Error(`User status is ${status}`);
        } catch (error) {
            onError && onError(error);
            handleError({
                id: 'directJoinConfluence',
                flagId: (0, $6afam.FAIL_FLAGS).directJoinFailed,
                title: formatMessage((0, $81HMX.default).directJoinFailTitle),
                description: formatMessage((0, $81HMX.default).directJoinFailDescription),
                error: new Error('Failed to direct join Confluence.', {
                    cause: error
                })
            });
        }
    };
    return {
        directJoin: directJoin
    };
};

});
parcelRegister("6afam", function(module, exports) {

$parcel$export(module.exports, "SUCCESS_FLAGS", () => $b53b254913930e20$export$d561d48b09f7b3a8);
$parcel$export(module.exports, "FAIL_FLAGS", () => $b53b254913930e20$export$104a2dcda2980c38);
const $b53b254913930e20$var$DIRECT_JOIN_CONFLUENCE_SUCCESS = 'directJoinConfluenceSuccess';
const $b53b254913930e20$var$VERIFY_DIRECT_JOIN_CONFLUENCE_SUCCESS = 'verifyDirectJoinConfluenceSuccess';
const $b53b254913930e20$var$DIRECT_JOIN_DENIED = 'directJoinConfluenceDenied';
const $b53b254913930e20$var$DIRECT_JOIN_FAILED = 'directJoinConfluenceFailed';
const $b53b254913930e20$export$d561d48b09f7b3a8 = {
    directJoinSuccess: $b53b254913930e20$var$DIRECT_JOIN_CONFLUENCE_SUCCESS,
    verifyDirectJoinSuccess: $b53b254913930e20$var$VERIFY_DIRECT_JOIN_CONFLUENCE_SUCCESS
};
const $b53b254913930e20$export$104a2dcda2980c38 = {
    directJoinFailed: $b53b254913930e20$var$DIRECT_JOIN_FAILED,
    directJoinDenied: $b53b254913930e20$var$DIRECT_JOIN_DENIED
};

});

parcelRegister("493fK", function(module, exports) {

$parcel$export(module.exports, "CONF_REQUEST_ACCESS_CAPABILITIES_ARI", () => $86b48dc08a675a39$export$fb1e23ef92641dca);
$parcel$export(module.exports, "deleteDraftPage", () => $86b48dc08a675a39$export$bc4ca43bab3718f9);
$parcel$export(module.exports, "requestConfluenceAccess", () => $86b48dc08a675a39$export$4f24948d0f96d76c);
$parcel$export(module.exports, "directJoinConfluence", () => $86b48dc08a675a39$export$22356c3e95450ea4);
$parcel$export(module.exports, "getCurrentConfluenceUser", () => $86b48dc08a675a39$export$cc1983611292bd3d);

var $4FgNe = parcelRequire("4FgNe");
const $86b48dc08a675a39$export$d45ec748bc4242cc = '/gateway/api/invitations/v1/access-requests/capabilities?';
const $86b48dc08a675a39$export$fb1e23ef92641dca = 'ari:cloud:confluence::site/';
const $86b48dc08a675a39$var$CONF_DIRECT_JOIN_API = '/gateway/api/invitations/v1/access-requests/request';
/**
 * Exponential backoff with max delay and jitter
 * https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/
 */ const $86b48dc08a675a39$var$maxExpBackoffWithJitter = (retries, baseDelay, maxDelay)=>{
    const exponential = Math.pow(2, retries) * baseDelay;
    const delay = Math.min(exponential, maxDelay);
    const jitter = Math.random();
    const delayWithJitter = Math.floor(jitter * delay);
    return delayWithJitter;
};
const $86b48dc08a675a39$export$cffaac380b94df26 = async ({ url: url, options: options, shouldRetryOnApiError: shouldRetryOnApiError, retries: retries = 3, baseDelay: baseDelay = 300, maxDelay: maxDelay = 10000 })=>{
    try {
        const response = await fetch(url, options);
        if (response.ok) {
            const body = await response.json();
            return {
                success: true,
                result: body
            };
        }
        if (shouldRetryOnApiError) throw new Error('Failed request with a confluence error');
        const errorBody = await response.json();
        const errorMessage = (0, $4FgNe.getConfluenceApiErrorMessage)(errorBody);
        return {
            success: false,
            error: new Error(errorMessage)
        };
    } catch (error) {
        if (retries > 0) {
            const retryDelay = $86b48dc08a675a39$var$maxExpBackoffWithJitter(retries, baseDelay, maxDelay);
            await new Promise((resolve)=>setTimeout(resolve, retryDelay));
            return $86b48dc08a675a39$export$cffaac380b94df26({
                url: url,
                options: options,
                shouldRetryOnApiError: shouldRetryOnApiError,
                retries: retries - 1,
                baseDelay: baseDelay,
                maxDelay: maxDelay
            });
        }
        const newError = error instanceof Error ? error : new Error('An unknown error occurred');
        return {
            success: false,
            error: newError
        };
    }
};
const $86b48dc08a675a39$export$bc4ca43bab3718f9 = async (cloudId, pageId)=>fetch(`/gateway/api/ex/${cloudId}/wiki/rest/api/content/${pageId}?status=draft`, {
        method: 'DELETE'
    });
const $86b48dc08a675a39$export$4f24948d0f96d76c = (cloudId)=>{
    const params = new URLSearchParams({
        resource: `${$86b48dc08a675a39$export$fb1e23ef92641dca}${cloudId}`
    });
    return fetch(`${$86b48dc08a675a39$export$d45ec748bc4242cc}${params.toString()}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            Accept: 'application/json'
        }
    });
};
const $86b48dc08a675a39$export$22356c3e95450ea4 = (cloudId)=>fetch(`${$86b48dc08a675a39$var$CONF_DIRECT_JOIN_API}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            resource: `${$86b48dc08a675a39$export$fb1e23ef92641dca}${cloudId}`
        })
    });
const $86b48dc08a675a39$export$cc1983611292bd3d = async ({ cloudId: cloudId, shouldRetryOnApiError: shouldRetryOnApiError = true, retries: retries = 3, baseDelay: baseDelay, maxDelay: maxDelay })=>$86b48dc08a675a39$export$cffaac380b94df26({
        url: `/gateway/api/ex/confluence/${cloudId}/wiki/rest/api/user/current?expand=operations`,
        options: {
            credentials: 'include',
            headers: {
                Accept: 'application/json'
            }
        },
        shouldRetryOnApiError: shouldRetryOnApiError,
        retries: retries,
        baseDelay: baseDelay,
        maxDelay: maxDelay
    });
const $86b48dc08a675a39$var$getCreateConfluencePageURL = (cloudId)=>`/gateway/api/ex/confluence/${cloudId}/wiki/api/v2/pages?${new URLSearchParams({
        expand: 'space'
    }).toString()}`;
const $86b48dc08a675a39$export$2f73234140ca5aad = async (cloudId)=>$86b48dc08a675a39$export$cffaac380b94df26({
        url: `/gateway/api/ex/confluence/${cloudId}/wiki/rest/api/user/current?expand=personalSpace`,
        options: {
            credentials: 'include',
            headers: {
                Accept: 'application/json'
            }
        },
        shouldRetryOnApiError: false
    });
const $86b48dc08a675a39$export$35a28ef15d43eade = async (cloudId, spaceId)=>{
    try {
        /** API docs at
		 * https://developer.atlassian.com/cloud/confluence/rest/v2/api-group-page/#api-pages-post
		 */ const response = await fetch($86b48dc08a675a39$var$getCreateConfluencePageURL(cloudId), {
            method: 'post',
            credentials: 'include',
            headers: {
                accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                status: 'draft',
                spaceId: spaceId,
                body: {
                    representation: 'storage',
                    value: ''
                }
            })
        });
        if (!response.ok) {
            // We could have multiple errors from the v2 api.
            const responseBody = await response.json();
            return {
                success: false,
                error: new Error((0, $4FgNe.getConfluenceApiErrorMessage)(responseBody))
            };
        }
        const responseJson = await response.json();
        return {
            success: true,
            result: responseJson
        };
    } catch (error) {
        // This is some type of Network error
        const newError = error instanceof Error ? error : new Error('An unknown error occurred.');
        return {
            success: false,
            error: newError
        };
    }
};

});
parcelRegister("4FgNe", function(module, exports) {

$parcel$export(module.exports, "getConfluenceApiErrorMessage", () => $486ddfd9a7757944$export$864bf3d717a46ad4);
const $486ddfd9a7757944$export$864bf3d717a46ad4 = (error)=>{
    if ($486ddfd9a7757944$var$isConfluenceV1Error(error)) return `${error.statusCode}: ${error.message}`;
    if ($486ddfd9a7757944$var$isConfluenceV2Error(error)) return error.errors.map((e)=>`${e.status}: ${e.title}`).join('\n');
    return `unknown confluence error: ${error}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $486ddfd9a7757944$var$isConfluenceV1Error = (error)=>!!error && typeof error === 'object' && 'statusCode' in error && 'message' in error;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $486ddfd9a7757944$var$isConfluenceV2Error = (error)=>!!error && typeof error === 'object' && Array.isArray(error.errors) && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.errors.every((e)=>'status' in e && 'title' in e);

});


parcelRegister("7o3Dg", function(module, exports) {

$parcel$export(module.exports, "handleSuccessWithNotification", () => $c00dcc496908cfe6$export$40266d24505cab05);
$parcel$export(module.exports, "handleFailureWithNotification", () => $c00dcc496908cfe6$export$e9e91a36ea1f4fd8);

var $eUqFw = parcelRequire("eUqFw");

var $5KT10 = parcelRequire("5KT10");

var $guiFP = parcelRequire("guiFP");

var $eo17r = parcelRequire("eo17r");
const $c00dcc496908cfe6$var$EVENT_SUCCESS = 'success';
const $c00dcc496908cfe6$var$EVENT_ERROR = 'error';
const $c00dcc496908cfe6$var$OPERATIONAL_EVENT_TYPE = 'operational';
const $c00dcc496908cfe6$var$TEAM_NAME = 'confluence-better-together';
const $c00dcc496908cfe6$export$40266d24505cab05 = ({ fireAnalytics: fireAnalytics, embeddedConfluenceSource: embeddedConfluenceSource, showFlag: showFlag })=>({ action: action, actionSubject: actionSubject, eventName: eventName, eventType: eventType, originProduct: originProduct, requestedProduct: requestedProduct, flagId: flagId, title: title, description: description, useConfIcon: useConfIcon })=>{
        fireAnalytics && eventName && fireAnalytics({
            action: action ?? $c00dcc496908cfe6$var$EVENT_SUCCESS,
            actionSubject: actionSubject,
            eventName: eventName,
            embeddedConfluenceSource: embeddedConfluenceSource,
            originProduct: originProduct,
            requestedProduct: requestedProduct,
            eventType: eventType ?? $c00dcc496908cfe6$var$OPERATIONAL_EVENT_TYPE
        });
        flagId && showFlag({
            key: (0, $eo17r.toFlagId)(flagId),
            type: 'success',
            title: title,
            description: description,
            icon: useConfIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KT10.ConfluenceIcon), {
                appearance: "brand",
                size: "small"
            }) : null
        });
    };
const $c00dcc496908cfe6$export$e9e91a36ea1f4fd8 = ({ embeddedConfluenceSource: embeddedConfluenceSource, showFlag: showFlag })=>({ id: id, error: error, flagId: flagId, title: title, description: description })=>{
        (0, $guiFP.default)({
            meta: {
                id: id,
                teamName: $c00dcc496908cfe6$var$TEAM_NAME
            },
            attributes: {
                embeddedConfluenceSource: embeddedConfluenceSource
            },
            error: error
        });
        flagId && showFlag({
            key: (0, $eo17r.toFlagId)(flagId),
            type: $c00dcc496908cfe6$var$EVENT_ERROR,
            title: title,
            description: description
        });
    };

});

parcelRegister("81HMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a23c95bb68e8612$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5a23c95bb68e8612$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    directJoinSuccessTitle: {
        "id": "issue-create-confluence-content.controllers.use-direct-join-confluence.direct-join-success-title",
        "defaultMessage": "We're creating your Confluence account"
    },
    directJoinSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-direct-join-confluence.direct-join-success-description",
        "defaultMessage": "This should only take a few moments..."
    },
    directJoinVerifySuccessTitle: {
        "id": "issue-create-confluence-content.controllers.use-direct-join-confluence.direct-join-verify-success-title",
        "defaultMessage": "All done"
    },
    directJoinVerifySuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-direct-join-confluence.direct-join-verify-success-description",
        "defaultMessage": "You can now create Confluence Pages from Jira"
    },
    directJoinFailTitle: {
        "id": "issue-create-confluence-content.controllers.use-direct-join-confluence.direct-join-fail-title",
        "defaultMessage": "Error creating your Confluence account"
    },
    directJoinFailDescription: {
        "id": "issue-create-confluence-content.controllers.use-direct-join-confluence.direct-join-fail-description",
        "defaultMessage": "Failed to join Confluence. Please try again."
    },
    directJoinDeniedTitle: {
        "id": "issue-create-confluence-content.controllers.use-direct-join-confluence.direct-join-denied-title",
        "defaultMessage": "Access Denied"
    },
    directJoinDeniedDescription: {
        "id": "issue-create-confluence-content.controllers.use-direct-join-confluence.direct-join-denied-description",
        "defaultMessage": "Your request to join Confluence has been denied. Please reach out to your admin for assistance."
    }
});

});



parcelRegister("bczMu", function(module, exports) {

$parcel$export(module.exports, "getDraftShareId", () => $13c13bf829800cbb$export$f31b9480a5e4fdcf);
$parcel$export(module.exports, "convertUrlSpaceIdToSpaceKey", () => $13c13bf829800cbb$export$be3b1ed3560ef0e6);
const $13c13bf829800cbb$export$f31b9480a5e4fdcf = (uri)=>{
    if (!uri || uri === '') return '';
    const matches = uri.match(/draftShareId=([^&])*/g);
    return matches ? matches[0].split('=')[1] : '';
};
const $13c13bf829800cbb$export$be3b1ed3560ef0e6 = ({ url: url, spaceId: spaceId, spaceKey: spaceKey })=>{
    if (!(url && spaceId && spaceKey)) return undefined;
    return url.replace(`spaces/${spaceId}`, `spaces/${spaceKey}`);
};
const $13c13bf829800cbb$export$e87b28852220b5cd = ({ data: data, spaceKey: spaceKey, hostname: hostname })=>{
    // In case something went wrong but is not an error
    if (!data.id || !data.spaceId) return '';
    let domain = '';
    if (typeof window.location !== 'undefined') domain = hostname ?? window.location.origin;
    // Success:: build and return URL from the response data
    return `${domain}/wiki/spaces/${spaceKey}/pages/edit-v2/${data.id}/`;
};

});

parcelRegister("lw8L4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b61955e35b145b9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8b61955e35b145b9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createConfluencePageItem: {
        "id": "issue-create-confluence-content.create-confluence-content-menu.create-page-menu-item.create-confluence-page-item",
        "defaultMessage": "Page"
    }
});

});


parcelRegister("8N8dV", function(module, exports) {

$parcel$export(module.exports, "CreateWhiteboardMenuItem", () => $123d51cbe0adfb5b$export$60b5e4d8bec6f836);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $ffiyv = parcelRequire("ffiyv");

var $3555e = parcelRequire("3555e");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3Tszs = parcelRequire("3Tszs");

var $3ElT9 = parcelRequire("3ElT9");

var $lqalZ = parcelRequire("lqalZ");

var $aMhhi = parcelRequire("aMhhi");

var $hXqDm = parcelRequire("hXqDm");

var $6mvny = parcelRequire("6mvny");

var $pdpBS = parcelRequire("pdpBS");

var $eq2dV = parcelRequire("eq2dV");

var $9MHPS = parcelRequire("9MHPS");

var $6XLyv = parcelRequire("6XLyv");

var $ls5tj = parcelRequire("ls5tj");

var $bgQ5u = parcelRequire("bgQ5u");

var $4xfOp = parcelRequire("4xfOp");
const $123d51cbe0adfb5b$var$WhiteboardLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        ...props,
        target: "_blank",
        ref: ref,
        href: "https://www.atlassian.com/software/confluence/whiteboards"
    }, children));
const $123d51cbe0adfb5b$export$758f8a09875ae520 = ({ onCancel: onCancel, onCloseComplete: onCloseComplete, onCreate: onCreate, onFailure: onFailure, onOpenComplete: onOpenComplete, onFetchConfluenceWhiteboardSuccess: onFetchConfluenceWhiteboardSuccess })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { setIsCreateContentModalOpen: setIsCreateContentModalOpen, setCreateContentRuntimeProps: setCreateContentRuntimeProps, embeddedConfluenceSource: embeddedConfluenceSource, accessStatus: accessStatus, setActiveWhiteboardData: setActiveWhiteboardData, setEmbeddedWhiteboardModalOpen: setEmbeddedWhiteboardModalOpen } = (0, $eUqFw.useContext)((0, $6mvny.ContentMenuContext));
    const issueAri = (0, $3Tszs.useIssueAri)();
    const { linkIssueToWhiteboard: linkIssueToWhiteboard } = (0, $6XLyv.useWhiteboardIssueLinking)({
        issueAri: issueAri
    });
    const { fetchConfluenceWhiteboard: fetchConfluenceWhiteboard } = (0, $9MHPS.useConfluenceWhiteboard)();
    const fireAnalyticsEvent = (0, $eq2dV.useEmbeddedPageTracking)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const tenantHasConfluence = (0, $3555e.useTenantHasConfluence)();
    const getCreateContentClickBehavior = (0, $pdpBS.useCreateContentClickBehavior)();
    const isWhiteboardStandaloneEnabled = (0, $1ybV0.ff)('jira-issue-view-whiteboards-standalone');
    const showWhiteboardLink = ()=>{
        if (tenantHasConfluence && (!isWhiteboardStandaloneEnabled || isWhiteboardStandaloneEnabled && accessStatus !== (0, $ls5tj.ACCESS_REQUEST_CAPABILITIES).ACCESS_EXISTS)) return {
            component: $123d51cbe0adfb5b$var$WhiteboardLink
        };
        return {};
    };
    const linkWhiteboard = (0, $eUqFw.useCallback)(async (whiteboardAri, confluenceWhiteboardUrl)=>{
        try {
            await linkIssueToWhiteboard(whiteboardAri);
            showFlag({
                key: (0, $eo17r.toFlagId)('createdWhiteboardSucceededOnLink'),
                type: 'success',
                title: formatMessage((0, $4xfOp.default).createdWhiteboardSucceededOnLinkTitle),
                description: formatMessage((0, $4xfOp.default).createdWhiteboardSucceededOnLinkDescription)
            });
            fireAnalyticsEvent({
                action: 'success',
                eventName: 'linkIssueToWhiteboard',
                embeddedConfluenceSource: embeddedConfluenceSource,
                eventType: 'operational'
            });
        } catch (error) {
            showFlag({
                key: (0, $eo17r.toFlagId)('createdWhiteboardFailedOnLink'),
                type: 'error',
                title: formatMessage((0, $4xfOp.default).createdWhiteboardFailedOnLinkTitle),
                description: formatMessage((0, $4xfOp.default).createdWhiteboardFailedOnLinkDescription),
                actions: [
                    {
                        onClick: ()=>window.open(confluenceWhiteboardUrl, '_blank'),
                        content: (0, $4xfOp.default).createdWhiteboardFailedOnLinkAction
                    }
                ]
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'linkIssueToWhiteboard',
                    teamName: 'confluence-better-together',
                    packageName: 'jiraIssueCreateConfluenceContent'
                },
                attributes: {
                    embeddedConfluenceSource: embeddedConfluenceSource
                },
                error: new Error(`Failed to link Confluence whiteboard: ${error}`)
            });
            throw new Error('linkIssueToWhiteboardFailed');
        }
    }, [
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        formatMessage,
        linkIssueToWhiteboard,
        showFlag
    ]);
    const linkAndFetchWhiteboard = (0, $eUqFw.useCallback)(async (whiteboardAri, confluenceWhiteboardUrl)=>{
        try {
            await linkWhiteboard(whiteboardAri, confluenceWhiteboardUrl);
            const confluenceWhiteboard = await fetchConfluenceWhiteboard(whiteboardAri);
            const whiteboard = {
                whiteboardId: confluenceWhiteboard.whiteboardId,
                href: `${confluenceWhiteboard.links?.base}${confluenceWhiteboard.links?.webUi}`,
                author: confluenceWhiteboard.author,
                title: confluenceWhiteboard.title,
                id: confluenceWhiteboard.id,
                type: (0, $3ElT9.CONFLUENCE_WHITEBOARD)
            };
            onFetchConfluenceWhiteboardSuccess(whiteboard);
            fireAnalyticsEvent({
                action: 'success',
                eventName: 'fetchConfluenceWhiteboard',
                embeddedConfluenceSource: embeddedConfluenceSource,
                eventType: 'operational'
            });
        } catch (error) {
            showFlag({
                key: (0, $eo17r.toFlagId)('createdWhiteboardFailedOnLinkFetch'),
                type: 'error',
                title: formatMessage((0, $4xfOp.default).createdWhiteboardFailedOnLinkTitle),
                description: formatMessage((0, $4xfOp.default).createdWhiteboardFailedOnLinkDescription),
                actions: [
                    {
                        onClick: ()=>window.open(confluenceWhiteboardUrl, '_blank'),
                        content: (0, $4xfOp.default).createdWhiteboardFailedOnLinkAction
                    }
                ]
            });
            if (error instanceof Error && error?.message === 'linkIssueToWhiteboardFailed') return;
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchConfluenceWhiteboard',
                    teamName: 'confluence-better-together',
                    packageName: 'jiraIssueCreateConfluenceContent'
                },
                attributes: {
                    embeddedConfluenceSource: embeddedConfluenceSource
                },
                error: new Error(`Failed to fetch Confluence whiteboard: ${error}`)
            });
        }
    }, [
        linkWhiteboard,
        fetchConfluenceWhiteboard,
        onFetchConfluenceWhiteboardSuccess,
        fireAnalyticsEvent,
        embeddedConfluenceSource,
        showFlag,
        formatMessage
    ]);
    const createConfluenceWhiteboard = (0, $eUqFw.useCallback)(()=>{
        setIsCreateContentModalOpen(true);
        setCreateContentRuntimeProps({
            isOpen: true,
            contentType: (0, $hXqDm.CONTENT_TYPE).WHITEBOARD,
            onCancel: onCancel,
            onOpenComplete: onOpenComplete,
            onCloseComplete: onCloseComplete,
            onCreate: (payload)=>{
                onCreate && onCreate(payload);
                const { url: url, ari: whiteboardAri } = payload;
                const standaloneConfluenceWhiteboardUrl = `${url}?openTemplatePicker=true`;
                if (!whiteboardAri || !url) {
                    showFlag({
                        key: (0, $eo17r.toFlagId)('createConfluenceWhiteboardFailed'),
                        type: 'error',
                        title: formatMessage((0, $4xfOp.default).createWhiteboardFailedTitle),
                        description: formatMessage((0, $4xfOp.default).createWhiteboardFailedDescription)
                    });
                    (0, $guiFP.default)({
                        meta: {
                            id: 'createConfluenceWhiteboard',
                            teamName: 'confluence-better-together',
                            packageName: 'jiraIssueCreateConfluenceContent'
                        },
                        attributes: {
                            embeddedConfluenceSource: embeddedConfluenceSource
                        },
                        error: new Error('Failed to create Confluence whiteboard')
                    });
                    return;
                }
                linkAndFetchWhiteboard(whiteboardAri, standaloneConfluenceWhiteboardUrl);
                setActiveWhiteboardData(payload);
                setEmbeddedWhiteboardModalOpen(true);
                fireAnalyticsEvent({
                    action: 'success',
                    eventName: 'createConfluenceWhiteboard',
                    embeddedConfluenceSource: embeddedConfluenceSource,
                    eventType: 'operational'
                });
            },
            onFailure: (error)=>{
                setIsCreateContentModalOpen(false);
                if (error instanceof Error && error?.message === 'No Whiteboard access') {
                    showFlag({
                        type: 'error',
                        title: formatMessage((0, $4xfOp.default).noWhiteboardBetaAccessToastTitle),
                        actions: [
                            {
                                onClick: ()=>window.open('https://www.atlassian.com/software/confluence/whiteboards', '_blank'),
                                content: (0, $4xfOp.default).noWhiteboardBetaAccessToastAction
                            }
                        ]
                    });
                    return;
                }
                showFlag({
                    key: (0, $eo17r.toFlagId)('createConfluenceWhiteboardFailed'),
                    type: 'error',
                    title: formatMessage((0, $4xfOp.default).createWhiteboardFailedTitle),
                    description: formatMessage((0, $4xfOp.default).createWhiteboardFailedDescription)
                });
                (0, $guiFP.default)({
                    meta: {
                        id: 'createConfluenceWhiteboard',
                        teamName: 'confluence-better-together',
                        packageName: 'jiraIssueCreateConfluenceContent'
                    },
                    attributes: {
                        embeddedConfluenceSource: embeddedConfluenceSource
                    },
                    error: new Error(`Failed to create Confluence whiteboard: ${error}`)
                });
                onFailure && onFailure(error);
            }
        });
    }, [
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        formatMessage,
        linkAndFetchWhiteboard,
        onCancel,
        onCloseComplete,
        onCreate,
        onFailure,
        onOpenComplete,
        setActiveWhiteboardData,
        setCreateContentRuntimeProps,
        setEmbeddedWhiteboardModalOpen,
        setIsCreateContentModalOpen,
        showFlag
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            eventName: 'createWhiteboardMenuItem',
            embeddedConfluenceSource: embeddedConfluenceSource,
            tenantHasConfluence: tenantHasConfluence
        });
        // When cross join is implemented we may not need the if condition here
        if (!tenantHasConfluence || isWhiteboardStandaloneEnabled && accessStatus === (0, $ls5tj.ACCESS_REQUEST_CAPABILITIES).ACCESS_EXISTS) getCreateContentClickBehavior({
            accessStatus: accessStatus,
            createContent: createConfluenceWhiteboard,
            tenantHasConfluence: tenantHasConfluence
        })();
    }, [
        fireAnalyticsEvent,
        embeddedConfluenceSource,
        tenantHasConfluence,
        isWhiteboardStandaloneEnabled,
        accessStatus,
        getCreateContentClickBehavior,
        createConfluenceWhiteboard
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        testId: "issue-create-confluence-content.ui.create-confluence-content-menu.create-whiteboard-menu-item.create-whiteboard-menu-item",
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bgQ5u.Whiteboard16Icon), null),
        elemAfter: !isWhiteboardStandaloneEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "new"
        }, formatMessage((0, $4xfOp.default).whiteboardComingSoonLozenge)) : null,
        onClick: onClick,
        ...showWhiteboardLink()
    }, formatMessage((0, $4xfOp.default).createConfluenceWhiteboardItem));
};
const $123d51cbe0adfb5b$var$mapStateToProps = ()=>({});
const $123d51cbe0adfb5b$var$mapDispatchToProps = {
    onFetchConfluenceWhiteboardSuccess: (0, $aMhhi.fetchConfluenceWhiteboardSuccess)
};
const $123d51cbe0adfb5b$export$60b5e4d8bec6f836 = (0, $lqalZ.connect)($123d51cbe0adfb5b$var$mapStateToProps, $123d51cbe0adfb5b$var$mapDispatchToProps)($123d51cbe0adfb5b$export$758f8a09875ae520);

});
parcelRegister("9MHPS", function(module, exports) {

$parcel$export(module.exports, "useConfluenceWhiteboard", () => $231f2f411037558d$export$37132f3f02c4bce0);

var $dIUZP = parcelRequire("dIUZP");

var $iWLL0 = parcelRequire("iWLL0");

var $amu7D = parcelRequire("amu7D");
const $231f2f411037558d$export$37132f3f02c4bce0 = ()=>{
    const fetchConfluenceWhiteboard = async (whiteboardAri)=>{
        const data = await (0, $iWLL0.fetchQuery)((0, $amu7D.default), (0, $dIUZP.default), {
            id: whiteboardAri
        }, {
            fetchPolicy: 'store-or-network'
        }).toPromise();
        const whiteboard = data?.confluence?.whiteboard;
        if (!whiteboard) throw new Error('Whiteboard not found');
        return whiteboard;
    };
    return {
        fetchConfluenceWhiteboard: fetchConfluenceWhiteboard
    };
};

});
parcelRegister("dIUZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b2d6d7d2b783d52$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e9008ee9dcd2b3f4bcc2b993cbfe95bd>>
 * @relayHash 5f89c2da551b1ec945cbd46c007551e3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f34ce5c5360fc44350e2999d71acb2350f0cd83d29d920197dd3808fc1d504e
const $9b2d6d7d2b783d52$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "whiteboardId"
    }, v3 = {
        "concreteType": "ConfluenceWhiteboardLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "base"
            },
            {
                "kind": "ScalarField",
                "name": "webUi"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFetchWhiteboardFetchConfluenceWhiteboardQuery",
            "selections": [
                {
                    "concreteType": "ConfluenceQueryApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "ConfluenceWhiteboard",
                            "kind": "LinkedField",
                            "name": "whiteboard",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceUserInfo",
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFetchWhiteboardFetchConfluenceWhiteboardQuery",
            "selections": [
                {
                    "concreteType": "ConfluenceQueryApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "ConfluenceWhiteboard",
                            "kind": "LinkedField",
                            "name": "whiteboard",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceUserInfo",
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3f34ce5c5360fc44350e2999d71acb2350f0cd83d29d920197dd3808fc1d504e",
            "metadata": {},
            "name": "useFetchWhiteboardFetchConfluenceWhiteboardQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9b2d6d7d2b783d52$var$node.hash = "34ddc6c67546adc86798747e2fe0da96";
var $9b2d6d7d2b783d52$export$2e2bcd8739ae039 = $9b2d6d7d2b783d52$var$node;

});


parcelRegister("6XLyv", function(module, exports) {

$parcel$export(module.exports, "useWhiteboardIssueLinking", () => $a7edb98132317aef$export$d72eafc26e64a55a);

var $atqxE = parcelRequire("atqxE");

var $fG9UD = parcelRequire("fG9UD");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");
const $a7edb98132317aef$export$d72eafc26e64a55a = ({ issueAri: issueAri })=>{
    const [commitLinkIssueToWhiteboard] = (0, $iWLL0.useMutation)((0, $fG9UD.default));
    const [commitUnlinkIssueFromWhiteboard] = (0, $iWLL0.useMutation)((0, $atqxE.default));
    const linkIssueToWhiteboard = (0, $eUqFw.useCallback)((whiteboardAri)=>new Promise((resolve, reject)=>{
            commitLinkIssueToWhiteboard({
                variables: {
                    issueAri: issueAri,
                    whiteboardAri: whiteboardAri
                },
                onCompleted: (response)=>{
                    if (response.graphStore?.createIssueToWhiteboard?.success) resolve();
                    else {
                        const errors = response.graphStore?.createIssueToWhiteboard?.errors;
                        const errorMessage = errors?.[0]?.message ?? 'Unknown AGS linking error';
                        reject(new Error(errorMessage));
                    }
                },
                onError: (error)=>{
                    reject(error);
                }
            });
        }), [
        commitLinkIssueToWhiteboard,
        issueAri
    ]);
    const unlinkIssueFromWhiteboard = (0, $eUqFw.useCallback)((whiteboardAri, updater)=>new Promise((resolve, reject)=>{
            commitUnlinkIssueFromWhiteboard({
                variables: {
                    input: {
                        relationships: [
                            {
                                from: issueAri,
                                to: whiteboardAri
                            }
                        ]
                    }
                },
                updater: updater,
                onCompleted: (response)=>{
                    if (response?.graphStore?.deleteIssueToWhiteboard?.success) resolve();
                    else {
                        const errors = response?.graphStore?.deleteIssueToWhiteboard?.errors ?? [];
                        const errorMessages = errors.map((error)=>error.message);
                        if (errorMessages.length > 0) reject(new Error(errorMessages.join(', ')));
                        else reject(new Error('Unknown AGS unlinking error'));
                    }
                },
                onError: (error)=>{
                    reject(error);
                }
            });
        }), [
        commitUnlinkIssueFromWhiteboard,
        issueAri
    ]);
    return {
        linkIssueToWhiteboard: linkIssueToWhiteboard,
        unlinkIssueFromWhiteboard: unlinkIssueFromWhiteboard
    };
};

});
parcelRegister("atqxE", function(module, exports) {

$parcel$export(module.exports, "default", () => $af40fc1911b1e6d4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<33168d082653008c292b8363289e1101>>
 * @relayHash cb22e3609fb64e11c6b119b3c0a9069e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0a0bc6b8679a054594aa92883fb8423946f7de79c5058835340cb60c5f7f3167
const $af40fc1911b1e6d4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "GraphStoreMutation",
            "kind": "LinkedField",
            "name": "graphStore",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "GraphStoreDeleteIssueToWhiteboardPayload",
                    "kind": "LinkedField",
                    "name": "deleteIssueToWhiteboard",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useWhiteboardIssueLinkingIssueToWhiteboardDeleteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useWhiteboardIssueLinkingIssueToWhiteboardDeleteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "0a0bc6b8679a054594aa92883fb8423946f7de79c5058835340cb60c5f7f3167",
            "metadata": {},
            "name": "useWhiteboardIssueLinkingIssueToWhiteboardDeleteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$af40fc1911b1e6d4$var$node.hash = "d549f0d76dd33434ca7b5bae79167251";
var $af40fc1911b1e6d4$export$2e2bcd8739ae039 = $af40fc1911b1e6d4$var$node;

});

parcelRegister("fG9UD", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aee9676dc28119b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7287ed73acf98d4887f9b4a9f2b15d3f>>
 * @relayHash d4d017a9817eae9b09cdc9b98c60cda1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9f00656421a631887a9d3a4e023e44dcb718bd03d3b8f87fd8311d90738c0686
const $5aee9676dc28119b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "whiteboardAri"
        }
    ], v1 = [
        {
            "concreteType": "GraphStoreMutation",
            "kind": "LinkedField",
            "name": "graphStore",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "fields": [
                                {
                                    "items": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "from",
                                                    "variableName": "issueAri"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "to",
                                                    "variableName": "whiteboardAri"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "relationships.0"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "relationships"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "input"
                        }
                    ],
                    "concreteType": "GraphStoreCreateIssueToWhiteboardPayload",
                    "kind": "LinkedField",
                    "name": "createIssueToWhiteboard",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useWhiteboardIssueLinkingIssueToWhiteboardCreateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useWhiteboardIssueLinkingIssueToWhiteboardCreateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "9f00656421a631887a9d3a4e023e44dcb718bd03d3b8f87fd8311d90738c0686",
            "metadata": {},
            "name": "useWhiteboardIssueLinkingIssueToWhiteboardCreateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$5aee9676dc28119b$var$node.hash = "8aa5adc11d7ea6f5f25f31cea1c6a9ca";
var $5aee9676dc28119b$export$2e2bcd8739ae039 = $5aee9676dc28119b$var$node;

});


parcelRegister("bgQ5u", function(module, exports) {

$parcel$export(module.exports, "Whiteboard16Icon", () => $5110ac8065b30db7$export$3feee2bd05046f06);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $5110ac8065b30db7$var$whiteboard16Svg = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM6.76162 3.41159C7.86083 2.11703 9.46511 1.64478 10.6195 2.27467C10.7705 2.35706 10.9977 2.49509 11.1722 2.71987C11.373 2.97851 11.4727 3.31107 11.409 3.68304C11.3524 4.01358 11.1765 4.31922 10.9546 4.60153C10.8863 4.68851 10.8097 4.77814 10.7246 4.87072C11.674 4.60241 12.5151 4.65073 13.1473 5.09225C13.9681 5.6655 14.1134 6.66452 13.9141 7.50611C13.8187 7.90918 13.4146 8.15858 13.0115 8.06316C12.6084 7.96774 12.359 7.56363 12.4545 7.16056C12.5709 6.6688 12.4237 6.41651 12.2884 6.32204C12.1286 6.21042 11.6364 6.05866 10.5554 6.52127C10.3091 6.62667 10.0224 6.63652 9.81961 6.62447C9.59851 6.61132 9.32166 6.56256 9.07282 6.44016C8.84101 6.32614 8.43506 6.03646 8.43173 5.48745C8.42884 5.01198 8.74599 4.65814 9.01233 4.43019C9.3922 4.10508 9.63128 3.85787 9.77522 3.67471C9.8072 3.63401 9.83276 3.59864 9.85315 3.56837C9.50001 3.41882 8.68015 3.4696 7.90504 4.38247C7.63694 4.69821 7.16364 4.73684 6.84789 4.46874C6.53215 4.20064 6.49352 3.72734 6.76162 3.41159ZM4.83333 9.41667C5.56971 9.41667 6.16667 8.81971 6.16667 8.08333C6.16667 7.34695 5.56971 6.75 4.83333 6.75C4.09695 6.75 3.5 7.34695 3.5 8.08333C3.5 8.81971 4.09695 9.41667 4.83333 9.41667ZM4.83333 10.9167C6.39814 10.9167 7.66667 9.64814 7.66667 8.08333C7.66667 6.51853 6.39814 5.25 4.83333 5.25C3.26853 5.25 2 6.51853 2 8.08333C2 9.64814 3.26853 10.9167 4.83333 10.9167ZM9.14834 8.88394C9.53883 8.2494 10.4612 8.2494 10.8517 8.88394L13.0621 12.4759C13.4721 13.1422 12.9928 14 12.2104 14H7.78956C7.00724 14 6.52789 13.1422 6.9379 12.4759L9.14834 8.88394ZM8.68435 12.5L10 10.3621L11.3157 12.5H8.68435Z",
        fill: "currentColor"
    }));
const $5110ac8065b30db7$export$3feee2bd05046f06 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $5110ac8065b30db7$var$whiteboard16Svg,
        primaryColor: "var(--ds-icon-accent-teal, #00A3BF)",
        label: ""
    });

});

parcelRegister("4xfOp", function(module, exports) {

$parcel$export(module.exports, "default", () => $62f5e93558a985c5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $62f5e93558a985c5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createConfluenceWhiteboardItem: {
        "id": "issue-create-confluence-content.create-confluence-content-menu.create-whiteboard-menu-item.create-confluence-whiteboard-item",
        "defaultMessage": "Whiteboard"
    },
    whiteboardComingSoonLozenge: {
        "id": "issue-create-confluence-content.create-confluence-content-menu.create-whiteboard-menu-item.whiteboard-coming-soon-lozenge",
        "defaultMessage": "COMING SOON"
    },
    createWhiteboardFailedTitle: {
        "id": "issue-create-confluence-content.create-confluence-content-menu.create-whiteboard-menu-item.create-whiteboard-failed-title",
        "defaultMessage": "We're unable to create a whiteboard"
    },
    createWhiteboardFailedDescription: {
        "id": "issue-create-confluence-content.create-confluence-content-menu.create-whiteboard-menu-item.create-whiteboard-failed-description",
        "defaultMessage": "Please refresh and try again."
    },
    createdWhiteboardFailedOnLinkTitle: {
        "id": "issue-create-confluence-content.create-confluence-content-menu.create-whiteboard-menu-item.created-whiteboard-failed-on-link-title",
        "defaultMessage": "We couldn't link this whiteboard"
    },
    createdWhiteboardFailedOnLinkDescription: {
        "id": "issue-create-confluence-content.create-confluence-content-menu.create-whiteboard-menu-item.created-whiteboard-failed-on-link-description",
        "defaultMessage": "We've created the whiteboard but we couldn't link it to Jira."
    },
    createdWhiteboardFailedOnLinkAction: {
        "id": "issue-create-confluence-content.create-confluence-content-menu.create-whiteboard-menu-item.created-whiteboard-failed-on-link-action",
        "defaultMessage": "View whiteboard"
    },
    createdWhiteboardSucceededOnLinkTitle: {
        "id": "issue-create-confluence-content.create-confluence-content-menu.create-whiteboard-menu-item.created-whiteboard-succeeded-on-link-title",
        "defaultMessage": "Linked!"
    },
    createdWhiteboardSucceededOnLinkDescription: {
        "id": "issue-create-confluence-content.create-confluence-content-menu.create-whiteboard-menu-item.created-whiteboard-succeeded-on-link-description",
        "defaultMessage": "Successfully linked whiteboard"
    },
    noWhiteboardBetaAccessToastTitle: {
        "id": "issue-create-confluence-content.create-confluence-content-menu.create-whiteboard-menu-item.no-whiteboard-beta-access-toast-title",
        "defaultMessage": "Your org does not allow whiteboards"
    },
    noWhiteboardBetaAccessToastAction: {
        "id": "issue-create-confluence-content.create-confluence-content-menu.create-whiteboard-menu-item.no-whiteboard-beta-access-toast-action",
        "defaultMessage": "Learn more about whiteboards"
    }
});

});


parcelRegister("6luwQ", function(module, exports) {

$parcel$export(module.exports, "createConfluenceContentMenuEntrypoint", () => $5cb44a0a7fe69d9c$export$2767537482be1c23);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $5cb44a0a7fe69d9c$export$2767537482be1c23 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("bqX0G")), {
        moduleId: "609f1a90"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bqX0G", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lsJsv');
        const value = parcelRequire('dnfvQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lsJsv").then(()=>parcelRequire('dnfvQ'));
}

});


parcelRegister("a6Xhe", function(module, exports) {

$parcel$export(module.exports, "IssueViewNudgeExperiment", () => $c337b62cc801d0d7$export$630004f1dc1e6bfe);

var $eUqFw = parcelRequire("eUqFw");

var $9WJJx = parcelRequire("9WJJx");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $5JgJ2 = parcelRequire("5JgJ2");

var $07840 = parcelRequire("07840");

var $jghiP = parcelRequire("jghiP");
const $c337b62cc801d0d7$export$630004f1dc1e6bfe = ({ children: children, onClick: onClick, issueType: issueType, experimentKey: experimentKey, pulseLimit: pulseLimit, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const { pulseEnabled: pulseEnabled, suppressPulse: suppressPulse, onHover: onHover, onOk: onOk, onDismiss: onDismiss } = (0, $07840.usePulse)(experimentKey, pulseLimit, embeddedConfluenceSource);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9WJJx.NudgeSpotlight), {
        key: "create-confluence-content-button",
        hidden: !pulseEnabled,
        hideNudgeOnClick: true,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setHidden: ()=>{},
        heading: formatMessage((0, $jghiP.default).cardHeading),
        onShow: onHover,
        onOutsideClick: ()=>{
            suppressPulse();
            onDismiss();
        },
        actions: [
            {
                text: formatMessage((0, $jghiP.default).ok),
                onClick: ()=>{
                    suppressPulse();
                    onClick();
                    onOk();
                }
            }
        ],
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage($c337b62cc801d0d7$var$messageTypeSwitch(issueType)), " "),
        position: "bottom-start",
        showSpotlightCardOnFirstRender: false,
        nudgeTestId: "issue-view-foundation.quick-add.create-confluence-content-menu.issue-view-nudge-experiment.nudge",
        cardTestId: "issue-view-foundation.quick-add.create-confluence-content-menu.issue-view-nudge-experiment.card"
    }, children));
};
const $c337b62cc801d0d7$var$messageTypeSwitch = (issueType)=>{
    switch(issueType){
        case 'Story':
            return (0, $jghiP.default).messageStory;
        case 'Epic':
            return (0, $jghiP.default).messageEpic;
        case 'Bug':
            return (0, $jghiP.default).messageBug;
        case 'Task':
            return (0, $jghiP.default).messageTask;
        case 'Subtask':
            return (0, $jghiP.default).messageSubTask;
        default:
            return (0, $jghiP.default).messageEpic;
    }
};

});
parcelRegister("07840", function(module, exports) {

$parcel$export(module.exports, "JSW_XFLOW_NUDGE_EXP", () => $babf0053888ebe44$export$1847f50399b4d4fc);
$parcel$export(module.exports, "useXflowNudgeExperiment", () => $babf0053888ebe44$export$275b05f53ceac652);
$parcel$export(module.exports, "usePulse", () => $babf0053888ebe44$export$bdb1ef833378368f);

var $eUqFw = parcelRequire("eUqFw");

var $aZaPn = parcelRequire("aZaPn");
var $89bO2 = parcelRequire("89bO2");

var $79xbN = parcelRequire("79xbN");


var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $babf0053888ebe44$export$f1a98e82c0c821bd = {
    EXPERIMENT: 'experiment',
    NOT_ENROLLED: 'not_enrolled',
    CONTROL: 'control'
};
const $babf0053888ebe44$export$1847f50399b4d4fc = 'jsw_issue_view_nudge_exp';
const $babf0053888ebe44$var$SPOTLIGHT_SUPPRESSED = 'spotlightSuppressed';
const $babf0053888ebe44$var$SPOTLIGHT_VIEW_COUNT = 'timesFlagViewed';
const $babf0053888ebe44$export$275b05f53ceac652 = ()=>{
    const [enabled, setEnabled] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        const cohort = (0, $79xbN.expVal)('jsw_issue_view_nudge_exp', 'cohort', 'not_enrolled');
        setEnabled(cohort === $babf0053888ebe44$export$f1a98e82c0c821bd.EXPERIMENT);
    }, []);
    return enabled;
};
const $babf0053888ebe44$export$bdb1ef833378368f = (experimentKey, pulseLimit = 3, embeddedConfluenceSource)=>{
    const [pulseEnabled, setPulseEnabled] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const sessionStorage = (0, $eUqFw.useMemo)(()=>(0, $89bO2.createSessionStorageProvider)(experimentKey), [
        experimentKey
    ]);
    const localStorage = (0, $eUqFw.useMemo)(()=>(0, $aZaPn.createLocalStorageProvider)(experimentKey), [
        experimentKey
    ]);
    const getPulseViewCount = (0, $eUqFw.useCallback)(()=>localStorage.get($babf0053888ebe44$var$SPOTLIGHT_VIEW_COUNT) ?? 0, [
        localStorage
    ]);
    const shouldShowPulse = (0, $eUqFw.useCallback)(()=>!sessionStorage.get($babf0053888ebe44$var$SPOTLIGHT_SUPPRESSED) && !localStorage.get($babf0053888ebe44$var$SPOTLIGHT_SUPPRESSED) && getPulseViewCount() < pulseLimit, [
        localStorage,
        sessionStorage,
        getPulseViewCount,
        pulseLimit
    ]);
    const triggerSpotlightAnalytics = (action, actionSubject, actionKey)=>{
        const analyticsEvent = experimentKey === (0, $35b9cb9c9c5b9881$export$6c66b7c0a63aae32) ? {
            event: {
                action: action,
                actionSubject: actionSubject
            },
            type: (0, $41ea3621645e2acc$export$a1562d08625f5d7e)
        } : {
            event: {},
            type: (0, $41ea3621645e2acc$export$f1d537d508d2945a)
        };
        (0, $jMP2a.fireAnalytics)(createAnalyticsEvent(analyticsEvent.event), analyticsEvent.type, {
            attributes: {
                actionKey: actionKey,
                flagKey: experimentKey,
                growthInitiative: 'cross-flow',
                embeddedConfluenceSource: embeddedConfluenceSource
            }
        });
    };
    const onHover = ()=>{
        triggerSpotlightAnalytics('viewed', 'changeboardingSpotlight', 'onHover');
    };
    const onOk = ()=>{
        triggerSpotlightAnalytics('clicked', 'changeboardingSpotlight', 'onOk');
    };
    const onDismiss = ()=>{
        triggerSpotlightAnalytics('dismissed', 'changeboardingSpotlight', 'onDismiss');
    };
    const suppressPulse = ()=>{
        localStorage.set($babf0053888ebe44$var$SPOTLIGHT_SUPPRESSED, true);
        sessionStorage.set($babf0053888ebe44$var$SPOTLIGHT_SUPPRESSED, true);
        setPulseEnabled(false);
    };
    (0, $eUqFw.useEffect)(()=>{
        if (pulseEnabled) localStorage.set($babf0053888ebe44$var$SPOTLIGHT_VIEW_COUNT, getPulseViewCount() + 1);
    }, [
        pulseEnabled,
        localStorage,
        getPulseViewCount
    ]);
    (0, $eUqFw.useEffect)(()=>setPulseEnabled(shouldShowPulse()), [
        shouldShowPulse
    ]);
    return {
        pulseEnabled: pulseEnabled,
        suppressPulse: suppressPulse,
        onHover: onHover,
        onOk: onOk,
        onDismiss: onDismiss
    };
};

});

parcelRegister("jghiP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8c004059a5e0318$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $b8c004059a5e0318$var$messages = (0, $90IgZ.defineMessages)({
    cardHeading: {
        "id": "issue-view-foundation.quick-add.create-confluence-content-menu.issue-view-nudge-experiment.card-heading",
        "defaultMessage": "Create Confluence docs from Jira issues"
    },
    messageEpic: {
        "id": "issue-view-foundation.quick-add.create-confluence-content-menu.issue-view-nudge-experiment.message-epic",
        "defaultMessage": "Use templates for project requirements, meeting notes, blogs, and more."
    },
    messageBug: {
        "id": "issue-view-foundation.quick-add.create-confluence-content-menu.issue-view-nudge-experiment.message-bug",
        "defaultMessage": "Use templates for incident reports, troubleshooting articles, meeting notes, and more."
    },
    messageStory: {
        "id": "issue-view-foundation.quick-add.create-confluence-content-menu.issue-view-nudge-experiment.message-story",
        "defaultMessage": "Use templates for project requirements, meeting notes, and more."
    },
    messageTask: {
        "id": "issue-view-foundation.quick-add.create-confluence-content-menu.issue-view-nudge-experiment.message-task",
        "defaultMessage": "Use templates for technical specs, how-to articles, reports, and more."
    },
    messageSubTask: {
        "id": "issue-view-foundation.quick-add.create-confluence-content-menu.issue-view-nudge-experiment.message-sub-task",
        "defaultMessage": "Use templates for technical specs, how-to articles, reports, and more."
    },
    ok: {
        "id": "issue-view-foundation.quick-add.create-confluence-content-menu.issue-view-nudge-experiment.ok",
        "defaultMessage": "OK"
    }
});
var $b8c004059a5e0318$export$2e2bcd8739ae039 = $b8c004059a5e0318$var$messages;

});



parcelRegister("3bM93", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab3a8efc6d8e9ba0$export$2e2bcd8739ae039);

var $ccAHr = parcelRequire("ccAHr");
var $ab3a8efc6d8e9ba0$export$2e2bcd8739ae039 = (0, $ccAHr.default);

});
parcelRegister("ccAHr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8308caab33b492f4$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $6zOB7 = parcelRequire("6zOB7");
var $5DIcW = parcelRequire("5DIcW");

var $hUwRB = parcelRequire("hUwRB");

var $8cU5f = parcelRequire("8cU5f");

var $jMP2a = parcelRequire("jMP2a");

var $bDg6c = parcelRequire("bDg6c");

var $1PAoh = parcelRequire("1PAoh");
const $8308caab33b492f4$var$addLinkButtonSubject = 'AddLinkButton';
const $8308caab33b492f4$var$addLinkButtonSubjectId = 'AddLink';
const $8308caab33b492f4$var$LinkButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ compactMode: compactMode, actions: actions, tooltipLabel: tooltipLabel }, ref)=>{
    if (compactMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1PAoh.default), {
        actions: actions,
        tooltip: tooltipLabel,
        isCompactMode: compactMode
    });
    const [{ id: id, onClick: onClick, label: label, tooltip: actionTooltip, testId: testId }, ...rest] = actions;
    const buttonIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8308caab33b492f4$var$IconWrapper, {
        compactMode: compactMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
        size: "medium",
        label: ""
    }));
    const onClickWithAnalyticsEvent = (e, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $8308caab33b492f4$var$addLinkButtonSubjectId, {
            name: $8308caab33b492f4$var$addLinkButtonSubject
        });
        onClick();
    };
    if (rest.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: actionTooltip,
        position: "bottom",
        key: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": actionTooltip,
        spacing: "default",
        iconBefore: buttonIcon,
        onClick: onClickWithAnalyticsEvent,
        testId: testId,
        interactionName: "auto-generated.jira-issue-view-foundation.quick-add.link-button.button"
    }, label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5DIcW.SplitButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: actionTooltip,
        position: "bottom",
        key: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        ref: ref,
        "aria-label": actionTooltip,
        spacing: "default",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))),
        onClick: onClickWithAnalyticsEvent,
        testId: testId,
        interactionName: "auto-generated.jira-issue-view-foundation.quick-add.link-button.button1"
    }, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1PAoh.default), {
        actions: rest,
        placement: "bottom-end",
        tooltip: tooltipLabel
    }));
});
const $8308caab33b492f4$var$LinkButtonWithWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ actions: actions, ...restProps }, ref)=>{
    if (actions.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDg6c.ButtonWrapper), {
        "data-testid": "issue-view-foundation.quick-add.link-button.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8308caab33b492f4$var$LinkButton, {
        actions: actions,
        ref: ref,
        ...restProps
    }));
});
var $8308caab33b492f4$export$2e2bcd8739ae039 = $8308caab33b492f4$var$LinkButtonWithWrapper;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8308caab33b492f4$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { compactMode: compactMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.compactMode ? "_ca0q1y44 _u5f31y44 _n3td1y44 _19bv1y44" : "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.compactMode ? "_18u0idpf" : "_18u0myb0",
            __cmplp.compactMode ? "_2hwxidpf" : "_2hwx12gs",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5DIcW", function(module, exports) {

$parcel$export(module.exports, "SplitButton", () => $ca2b80e5398fd74b$export$651ad66661acd392);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");

var $j5H17 = parcelRequire("j5H17");

var $fVMIz = parcelRequire("fVMIz");
function $ca2b80e5398fd74b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ca2b80e5398fd74b$var$fontSize = (0, $lcnyw.fontSize)();
const $ca2b80e5398fd74b$var$heights = {
    default: `${32 / $ca2b80e5398fd74b$var$fontSize}em`,
    compact: `${24 / $ca2b80e5398fd74b$var$fontSize}em`,
    none: 'auto'
};
const $ca2b80e5398fd74b$var$baseDividerStyles = {
    name: "oxoq0a",
    styles: "display:inline-flex;width:1px;position:relative;z-index:2"
};
const $ca2b80e5398fd74b$var$defaultDividerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: $ca2b80e5398fd74b$var$heights.default
});
const $ca2b80e5398fd74b$var$compactDividerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: $ca2b80e5398fd74b$var$heights.compact
});
const $ca2b80e5398fd74b$var$dividerDisabledStyles = {
    name: "zdtwmy",
    styles: "background-color:var(--ds-text-disabled, #091E4224);cursor:not-allowed"
};
const $ca2b80e5398fd74b$var$navigationDividerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    height: '16px',
    margin: `${"var(--ds-space-100, 8px)"} -0.5px`,
    backgroundColor: "var(--ds-text-subtle, #0052cc)",
    opacity: 0.62
});
const $ca2b80e5398fd74b$var$dividerAppearance = {
    default: {
        name: "w0okts",
        styles: "background-color:var(--ds-text, #172B4D);opacity:0.51"
    },
    primary: {
        name: "7nfjo9",
        styles: "background-color:var(--ds-text-inverse, #FFF);opacity:0.64"
    },
    navigation: $ca2b80e5398fd74b$var$navigationDividerStyles
};
const $ca2b80e5398fd74b$var$dividerHeight = {
    default: $ca2b80e5398fd74b$var$defaultDividerStyles,
    compact: $ca2b80e5398fd74b$var$compactDividerStyles
};
const $ca2b80e5398fd74b$export$2e0a83ec2e27ecbb = ({ appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    return(// I find it funny to provide a div for Divider
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $ca2b80e5398fd74b$var$baseDividerStyles,
            $ca2b80e5398fd74b$var$dividerHeight[spacing],
            $ca2b80e5398fd74b$var$dividerAppearance[appearance],
            isDisabled ? $ca2b80e5398fd74b$var$dividerDisabledStyles : undefined
        ]
    }));
};
const $ca2b80e5398fd74b$var$splitButtonStyles = {
    name: "jzv9d3",
    styles: "display:inline-flex;position:relative;align-items:center;white-space:nowrap"
};
const $ca2b80e5398fd74b$var$primaryButtonStyles = {
    name: "1s736x3",
    styles: "button,a{border-end-end-radius:0;border-start-end-radius:0;}"
};
const $ca2b80e5398fd74b$var$secondaryButtonStyles = {
    name: "1uzrn2e",
    styles: "button,a{border-end-start-radius:0;border-start-start-radius:0;}"
};
const $ca2b80e5398fd74b$export$994ba1b4c598f7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $ca2b80e5398fd74b$var$splitButtonStyles
    }, children);
};
const $ca2b80e5398fd74b$export$651ad66661acd392 = ({ children: children, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = (0, $fVMIz.getActions)(children);
    return /*#__PURE__*/ (0, $byn9U.jsx)($ca2b80e5398fd74b$export$994ba1b4c598f7, null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j5H17.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $ca2b80e5398fd74b$var$primaryButtonStyles
    }, PrimaryAction), /*#__PURE__*/ (0, $byn9U.jsx)($ca2b80e5398fd74b$export$2e0a83ec2e27ecbb, {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $ca2b80e5398fd74b$var$secondaryButtonStyles
    }, SecondaryAction)));
};
const $ca2b80e5398fd74b$export$e3ca81100b492e15 = ({ primaryAction: primaryAction, secondaryAction: secondaryAction, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)($ca2b80e5398fd74b$export$994ba1b4c598f7, null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j5H17.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $ca2b80e5398fd74b$var$primaryButtonStyles
    }, primaryAction), /*#__PURE__*/ (0, $byn9U.jsx)($ca2b80e5398fd74b$export$2e0a83ec2e27ecbb, {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $ca2b80e5398fd74b$var$secondaryButtonStyles
    }, secondaryAction)));
};

});
parcelRegister("fVMIz", function(module, exports) {

$parcel$export(module.exports, "getActions", () => $cd6bfa39f6a9f17b$export$fe3955935f564b31);

var $eUqFw = parcelRequire("eUqFw");

var $2fFJv = parcelRequire("2fFJv");
const $cd6bfa39f6a9f17b$export$fe3955935f564b31 = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, $eUqFw.Children).toArray(children);
    typeof $2fFJv;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});


parcelRegister("bDg6c", function(module, exports) {

$parcel$export(module.exports, "ButtonWrapper", () => $bf23f7da960272cb$export$d53c836cccbb0d90);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $bf23f7da960272cb$export$d53c836cccbb0d90 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $bf23f7da960272cb$export$795c7c5df8a12ee0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1PAoh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fb8bec760c7a60d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $6OfWd = parcelRequire("6OfWd");
var $fEubG = parcelRequire("fEubG");

var $86Ndv = parcelRequire("86Ndv");

var $hUwRB = parcelRequire("hUwRB");

var $8cU5f = parcelRequire("8cU5f");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $anAkG = parcelRequire("anAkG");
const $2fb8bec760c7a60d$export$2e41e03514a7e2c7 = 'linkDropdownListButton';
const $2fb8bec760c7a60d$export$f964cf99bffc225 = 'moreLinksDropdownToggled';
const $2fb8bec760c7a60d$export$fc47494870102d47 = 'linkDropdownListItem';
const $2fb8bec760c7a60d$export$6d0f7c0645cba402 = 'createLink';
const $2fb8bec760c7a60d$var$DropdownListButton = (props)=>{
    const [isExpanded, setIsExpanded] = (0, $eUqFw.useState)(false);
    const { placement: placement, actions: actions, isCompactMode: isCompactMode, tooltip: tooltip } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const triggerButton = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'triggerRef' implicitly has an 'any' type.
    ({ triggerRef: triggerRef, ...triggerProps })=>{
        const dropdownIconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
            ...triggerProps,
            label: tooltip,
            "aria-expanded": isExpanded,
            icon: isCompactMode ? (0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))) : (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
            /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.foundation.quick-add.link-button.ui.link-dropdown-button",
            ref: triggerRef,
            interactionName: "auto-generated.issue.views.issue-base.foundation.quick-add.link-button.ui.link-dropdown-button.button"
        });
        return tooltip !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: tooltip,
            position: "bottom",
            hideTooltipOnClick: true
        }, dropdownIconButton) : dropdownIconButton;
    }, [
        isExpanded,
        isCompactMode,
        tooltip
    ]);
    const onOpenChange = ({ isOpen: isOpen })=>{
        setIsExpanded(isOpen);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        }), $2fb8bec760c7a60d$export$f964cf99bffc225, {
            isOpen: isOpen,
            name: $2fb8bec760c7a60d$export$2e41e03514a7e2c7
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        key: "web-link-actions-dropdown",
        placement: placement,
        trigger: triggerButton,
        onOpenChange: onOpenChange,
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, actions.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $anAkG.default), {
            key: item.id,
            item: item
        }))));
};
var $2fb8bec760c7a60d$export$2e2bcd8739ae039 = $2fb8bec760c7a60d$var$DropdownListButton;

});
parcelRegister("anAkG", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc7bf6a043df2d2b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $cc7bf6a043df2d2b$export$2e41e03514a7e2c7 = 'linkDropdownListButton';
const $cc7bf6a043df2d2b$export$f964cf99bffc225 = 'moreLinksDropdownToggled';
const $cc7bf6a043df2d2b$export$fc47494870102d47 = 'linkDropdownListItem';
const $cc7bf6a043df2d2b$export$6d0f7c0645cba402 = 'createLink';
const $cc7bf6a043df2d2b$var$DropdownListItem = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { id: id, icon: icon, label: label, onClick: onClick, testId: testId } = props.item;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onItemClick = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $cc7bf6a043df2d2b$export$6d0f7c0645cba402, {
            actionItemId: id,
            name: $cc7bf6a043df2d2b$export$fc47494870102d47
        });
        onClick && onClick();
    }, [
        id,
        onClick,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        elemBefore: icon,
        onClick: onItemClick,
        "data-testid": testId
    }, label);
});
var $cc7bf6a043df2d2b$export$2e2bcd8739ae039 = $cc7bf6a043df2d2b$var$DropdownListItem;

});




parcelRegister("7SjRo", function(module, exports) {

$parcel$export(module.exports, "LoomQuickAddItemView", () => $7d0ec0e7befe9a2b$export$c7b42296bb866d26);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $bFzGY = parcelRequire("bFzGY");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");

var $j9fWg = parcelRequire("j9fWg");

var $hI5oG = parcelRequire("hI5oG");

var $jWuk1 = parcelRequire("jWuk1");

var $6bgkQ = parcelRequire("6bgkQ");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $lcnyw = parcelRequire("lcnyw");

var $27nAz = parcelRequire("27nAz");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $j3FUN = parcelRequire("j3FUN");
var $4xHig = parcelRequire("4xHig");

var $aqpSx = parcelRequire("aqpSx");

var $dP8su = parcelRequire("dP8su");

var $esXsF = parcelRequire("esXsF");

var $8Ay13 = parcelRequire("8Ay13");

var $EVCNC = parcelRequire("EVCNC");

var $6PM2r = parcelRequire("6PM2r");

var $1wgt8 = parcelRequire("1wgt8");

var $wcB2r = parcelRequire("wcB2r");

const $7d0ec0e7befe9a2b$export$358bee3af7cf02a6 = (0, $7rh0R.lazy)(()=>(parcelRequire("izEYQ")), {
    moduleId: "./src/packages/issue/issue-view-foundation/src/quick-add/loom-record-item-ad/provider/index.tsx"
});
const $7d0ec0e7befe9a2b$export$c7b42296bb866d26 = ({ shouldBeCompact: shouldBeCompact })=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const locale = (0, $4xHig.useLocale)();
    if (licensedProducts.confluence || !locale.startsWith('en') || !(0, $wcB2r.shouldShowAd)()) return null;
    // Loom quick action button in Issue view Experiment Evaluation (https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/loom_quick_action_button_in_issue_view/setup)
    const cohort = (0, $79xbN.expVal)('loom_quick_action_button_in_issue_view', 'cohort', 'not_enrolled');
    if (cohort === 'not_enrolled' || cohort === 'control') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "loom-quick-add-item",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "loom-quick-add-item",
        attributes: {
            flagName: 'loom_quick_action_button_in_issue_view',
            buttonVersion: cohort
        }
    }, cohort === 'v0' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7d0ec0e7befe9a2b$var$AdProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7d0ec0e7befe9a2b$export$7e965828e2884d, {
        shouldBeCompact: shouldBeCompact
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7d0ec0e7befe9a2b$export$358bee3af7cf02a6, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6PM2r.LoomRecordingButton), {
        shouldBeCompact: shouldBeCompact
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
const $7d0ec0e7befe9a2b$var$AdProvider = ({ children: children })=>{
    const handleAdControlsEvents = ({ analyticsEvent: analyticsEvent, type: type })=>{
        if (!analyticsEvent) return;
        if (type === (0, $e89376e8e86c25a1$export$5c5fc6956b7600ea)) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $EVCNC.SUBJECT_IDS).adControlsFlagDismissed);
        if (type === (0, $e89376e8e86c25a1$export$17ff257e1f6e39f5)) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $EVCNC.SUBJECT_IDS).adControlsMenuButton);
        if (type === (0, $e89376e8e86c25a1$export$5595c6967e83d351)) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $EVCNC.SUBJECT_IDS).adControlsResonsMenuButton);
        if (type === (0, $e89376e8e86c25a1$export$e33200507ac1d20a)) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $EVCNC.SUBJECT_IDS).adControlsNotInterestedButton);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27nAz.default), {
        onEvents: handleAdControlsEvents
    }, children);
};
const $7d0ec0e7befe9a2b$export$7e965828e2884d = ({ shouldBeCompact: shouldBeCompact })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [isModalOpen, setModalOpen] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onModalOpenRequested = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $EVCNC.SUBJECT_IDS).loomRecordVideoButtonTryNow);
        setIsOpen(false);
        setModalOpen(true);
    };
    const handleModalClose = ()=>{
        setModalOpen(false);
    };
    const handleDismissClick = ()=>{
        (0, $wcB2r.persistAdPermanentlySuppressed)();
        setIsOpen(false);
    };
    const handleQuickAddItemClick = ()=>{
        setIsOpen((open)=>!open);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), (0, $EVCNC.SUBJECT_IDS).loomRecordVideoButton);
    };
    const handleCloseClick = ()=>{
        setIsOpen(false);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), (0, $EVCNC.SUBJECT_IDS).loomCloseIconCard);
    };
    // after click dismiss button, will check the shouldShowAd again
    if (!(0, $wcB2r.shouldShowAd)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        zIndex: (0, $lcnyw.layers).modal(),
        fallbackPlacements: [
            'auto'
        ],
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aqpSx.default), {
                ...triggerProps,
                key: "loom-record-video",
                id: "loom-record-video",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6bgkQ.LoomIcon), {
                    size: "small",
                    label: formatMessage((0, $1wgt8.default).loomRecordVideoButtonLabel)
                }),
                onClick: handleQuickAddItemClick,
                label: formatMessage((0, $1wgt8.default).loomRecordVideoButtonLabel),
                compactMode: shouldBeCompact,
                testId: (0, $EVCNC.TEST_IDS).loomRecordVideoButton
            }),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7d0ec0e7befe9a2b$var$Card, {
                onCloseClick: handleCloseClick,
                onModalOpenRequested: onModalOpenRequested,
                onDismissClick: handleDismissClick
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $esXsF.default), {
        isModalOpen: isModalOpen,
        onModalClose: handleModalClose
    }));
};
const $7d0ec0e7befe9a2b$var$Card = ({ onCloseClick: onCloseClick, onModalOpenRequested: onModalOpenRequested, onDismissClick: onDismissClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        backgroundColor: "elevation.surface.overlay",
        xcss: $7d0ec0e7befe9a2b$var$cardContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ay13.CoverImage), {
        altText: formatMessage((0, $1wgt8.default).imageAltTextNoTranslate)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h400"
    }, formatMessage((0, $1wgt8.default).loomAdHeadingNoTranslate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), {
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dP8su.AsyncLoomAdControls), {
        onDimissClick: onDismissClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))),
        spacing: "compact",
        appearance: "subtle",
        label: "Close ad",
        onClick: onCloseClick
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, formatMessage((0, $1wgt8.default).loomAdBodyNoTranslate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onModalOpenRequested,
        testId: (0, $EVCNC.TEST_IDS).tryNowButton
    }, formatMessage((0, $1wgt8.default).loomAdTryNowNoTranslate))))));
};
const $7d0ec0e7befe9a2b$var$cardContainerStyles = (0, $1ZAYh.xcss)({
    boxShadow: 'elevation.shadow.overlay',
    width: '262px'
});

});
parcelRegister("6bgkQ", function(module, exports) {

$parcel$export(module.exports, "LoomIcon", () => $2dc360b00746fd99$export$8d789f76fde3e05);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $2dc360b00746fd99$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsForLoom)(appearance, colorMode);
    return `<svg
    fill="none"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    aria-hidden="true"
  >
    <path
      d="M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884"
      fill="${colors.iconColor}"
    />
  </svg>`;
};
const $2dc360b00746fd99$export$8d789f76fde3e05 = ({ appearance: appearance, label: label = 'Loom', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $2dc360b00746fd99$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

// ACT Event types
// AdControlDropdownMenu
const $e89376e8e86c25a1$export$17ff257e1f6e39f5 = 'AD_CONTROL_DROP_DOWN_MENU_OPENED';
const $e89376e8e86c25a1$export$7fc09cf740f33ed4 = 'AD_CONTROL_DROP_DOWN_MENU_CLOSED';
const $e89376e8e86c25a1$export$e33200507ac1d20a = 'DISMISS_STARTED';
const $e89376e8e86c25a1$export$103f41d1f3bf374e = 'DISMISS_SUCCEEDED';
const $e89376e8e86c25a1$export$6d3088110036f124 = 'DISMISS_FAILED';
const $e89376e8e86c25a1$export$5595c6967e83d351 = 'REASONS_BUTTON_CLICKED';
const $e89376e8e86c25a1$export$ff50ad60f08a4bc0 = 'REASONS_MODAL_SHOWN';
const $e89376e8e86c25a1$export$6bd2d8eacca15ce1 = 'REASONS_MODAL_DISMISSED';
const $e89376e8e86c25a1$export$5c5fc6956b7600ea = 'FLAG_DISMISSED';

parcelRegister("aqpSx", function(module, exports) {

$parcel$export(module.exports, "default", () => $335cca93aebbc3c6$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $fY29z = parcelRequire("fY29z");

var $1ybV0 = parcelRequire("1ybV0");

var $eMxRI = parcelRequire("eMxRI");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $5Xp4r = parcelRequire("5Xp4r");
const $335cca93aebbc3c6$var$View = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { id: id, icon: icon, onClick: onClick, extraAttributes: extraAttributes = {}, label: label = '', compactMode: compactMode = true, testId: testId = '', hasGlobalSpotlightTarget: hasGlobalSpotlightTarget = false, hasSpotlightPulse: hasSpotlightPulse = false, noWrapper: noWrapper = false } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClickWithAnalytics = (0, $eUqFw.useCallback)(()=>{
        if (!(0, $1ybV0.ff)('jira-ai-work-breakdown-onboarding')) return;
        onClick && onClick();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'showChildIssuesInlineCreateButton');
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const themedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": label,
        spacing: compactMode ? 'none' : 'default',
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($335cca93aebbc3c6$var$IconWrapper, {
            compactMode: compactMode
        }, icon),
        onClick: (0, $1ybV0.ff)('jira-ai-work-breakdown-onboarding') ? onClickWithAnalytics : onClick,
        ref: ref,
        interactionName: "auto-generated.jira-issue-view-foundation.quick-add.quick-add-item.button"
    }, !compactMode && label);
    /* NOTE: These GlobalSpotlightTargets (deprecated) can be used throughout Jira not just within
   * the current package. They're often used for onboarding or changeboarding
   * experiences and allow an Atlaskit spotlight to be attached to page elements.
   * If you need to change this, make sure you check where the target ID is being used
   * and contact the relevant team as necessary. This Sourcegraph link should help :)
   * http://go/src/ISSUE_FIELD_SPOTLIGHT_PREFIX|global-spotlight-target-
   */ const buttonItemWithSpotlight = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Xp4r.default), {
        id: `${(0, $eMxRI.ISSUE_FIELD_SPOTLIGHT_PREFIX)}${id}`
    }, themedButton);
    const style = {
        position: 'inherit',
        marginRight: "var(--ds-space-200, 16px)"
    };
    if (noWrapper) return themedButton;
    if (hasGlobalSpotlightTarget && hasSpotlightPulse) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($335cca93aebbc3c6$var$ButtonWrapper, {
        ...extraAttributes,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Xp4r.default), {
        id: `${(0, $eMxRI.ISSUE_FIELD_SPOTLIGHT_PREFIX)}${id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fY29z.Pulse), {
        style: style
    }, themedButton)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($335cca93aebbc3c6$var$ButtonWrapper, {
        ...extraAttributes,
        "data-testid": testId
    }, hasGlobalSpotlightTarget ? buttonItemWithSpotlight : themedButton);
});
var $335cca93aebbc3c6$export$2e2bcd8739ae039 = $335cca93aebbc3c6$var$View;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $335cca93aebbc3c6$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $335cca93aebbc3c6$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { compactMode: compactMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.compactMode ? "_1yt41b66" : "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.compactMode ? "_18u0idpf" : "_18u0r5cr",
            __cmplp.compactMode ? "_2hwxidpf" : "_2hwx1i6y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5Xp4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $e613fe74cb8f0dd1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kS8l2 = parcelRequire("kS8l2");
/**
 * @deprecated This component is deprecated as part of JIG-1315 due to the top level
 * SpotlightManager in Jira Frontend. Atlaskit SpotlightTarget is now usable in
 * Jira Frontend in place of GlobalSpotlightTarget.
 * Please use import { SpotlightTarget } from '@atlaskit/onboarding' instead.
 * NOTE: GlobalSpotlightTarget may also cause OOM errors while using redux-devtools
 * due to the component's usage of global refs to attach spotlights to targets
 */ const $e613fe74cb8f0dd1$var$GlobalSpotlightTargetDeprecated = (props)=>{
    const { id: id, children: children, TargetComponent: TargetComponent } = props;
    const [, { register: register }] = (0, $kS8l2.useGlobalRefStoreActions)();
    const onRef = (0, $eUqFw.useCallback)((ref)=>{
        register(id, ref);
    }, [
        register,
        id
    ]);
    const targetProps = {
        ref: onRef,
        'data-testid': `ref-spotlight-target-${props.id}`
    };
    return TargetComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TargetComponent, targetProps, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e613fe74cb8f0dd1$var$InheritDisplay, targetProps, children);
};
var $e613fe74cb8f0dd1$export$2e2bcd8739ae039 = $e613fe74cb8f0dd1$var$GlobalSpotlightTargetDeprecated;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e613fe74cb8f0dd1$var$InheritDisplay = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1kw7 _2lx21kw7 _4cvr1kw7 _1bah1kw7",
            __cmplp.className
        ])
    });
});

});


parcelRegister("dP8su", function(module, exports) {

$parcel$export(module.exports, "AsyncLoomAdControls", () => $ecd9e8dc81e39e7a$export$d08b7395110f2ce1);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $ecd9e8dc81e39e7a$var$LazyLoomAdControls = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("cILRi")), {
    moduleId: "./src/packages/issue/issue-view-foundation/src/quick-add/loom-record-item-ad/ad-controls/index.tsx"
});
const $ecd9e8dc81e39e7a$export$d08b7395110f2ce1 = ({ onDimissClick: onDimissClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "loom-record-item",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ecd9e8dc81e39e7a$var$LazyLoomAdControls, {
        onDimissClick: onDimissClick
    }));

});
parcelRegister("cILRi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('kZumA')
        ]);
        const value = parcelRequire('etnqD');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("kZumA")
    ]).then(()=>parcelRequire('etnqD'));
}

});


parcelRegister("esXsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $281cb664edb2ee14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k0vzR = parcelRequire("k0vzR");
const $281cb664edb2ee14$var$LoomAdModalContainer = ({ isModalOpen: isModalOpen, onModalClose: onModalClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k0vzR.default), {
        isModalOpen: isModalOpen,
        onClose: onModalClose
    });
var $281cb664edb2ee14$export$2e2bcd8739ae039 = $281cb664edb2ee14$var$LoomAdModalContainer;

});
parcelRegister("k0vzR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec1b481c9795fbb4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");
var $7u4fN = parcelRequire("7u4fN");

var $Q1mNU = parcelRequire("Q1mNU");

var $dxopF = parcelRequire("dxopF");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $dzpl6 = parcelRequire("dzpl6");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $k3YqD = parcelRequire("k3YqD");

var $EVCNC = parcelRequire("EVCNC");

var $kMlHm = parcelRequire("kMlHm");

var $1wgt8 = parcelRequire("1wgt8");

var $BHjeQ = parcelRequire("BHjeQ");

var $dOn9L = parcelRequire("dOn9L");
const $ec1b481c9795fbb4$var$LoomAdModalView = ({ isModalOpen: isModalOpen, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isDarkMode = (0, $kMlHm.useIsDarkMode)();
    const handleCancelClick = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $EVCNC.SUBJECT_IDS).modalCancelButton);
        onClose();
    };
    const handleCtaClick = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $EVCNC.SUBJECT_IDS).modalCtaButton);
    };
    const customTheme = (0, $dzpl6.getTheme)({
        buttonStyles: {
            primary: {
                backgroundColor: isDarkMode ? (0, $EVCNC.STYLES).modal.colors.white : (0, $EVCNC.STYLES).modal.colors.purple,
                borderRadius: "var(--ds-space-250, 20px)",
                color: "var(--ds-text-inverse, #FFFFFF)",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingLeft: "var(--ds-space-150, 12px)",
                paddingRight: "var(--ds-space-150, 12px)",
                marginLeft: "var(--ds-space-050, 4px)",
                textAlign: 'center'
            }
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k3YqD.ModalDialog), {
        onClose: onClose,
        height: 640,
        width: 1140
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: (0, $1ZAYh.xcss)({
            height: '100%',
            width: '100%',
            borderRadius: 'border.radius.100',
            overflow: 'auto',
            backgroundColor: 'elevation.surface'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        xcss: (0, $1ZAYh.xcss)({
            height: '100%',
            width: '570px',
            boxSizing: 'border-box',
            padding: 'space.800'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Q1mNU.LoomLogo), {
        appearance: "brand"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: (0, $1ZAYh.xcss)({
            marginTop: 'space.500',
            fontSize: '29px',
            fontWeight: '400'
        })
    }, formatMessage((0, $1wgt8.default).headingNoTranslate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: (0, $1ZAYh.xcss)({
            marginTop: 'space.100',
            flexGrow: '1'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dOn9L.ProductFeatureList), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        justifyContent: "end",
        gap: "space.025",
        xcss: (0, $1ZAYh.xcss)({
            marginTop: 'space.500'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: handleCancelClick,
        appearance: "subtle",
        testId: (0, $EVCNC.TEST_IDS).cancelSignupButton
    }, formatMessage((0, $1wgt8.default).cancelNoTranslate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        theme: customTheme,
        target: "_blank",
        href: (0, $EVCNC.SIGN_UP_URL),
        appearance: "primary",
        onClick: handleCtaClick,
        testId: (0, $EVCNC.TEST_IDS).getStartedLink
    }, formatMessage((0, $1wgt8.default).getStartedNoTranslate)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $BHjeQ.LoomPreview), null))));
};
var $ec1b481c9795fbb4$export$2e2bcd8739ae039 = $ec1b481c9795fbb4$var$LoomAdModalView;

});
parcelRegister("Q1mNU", function(module, exports) {

$parcel$export(module.exports, "LoomLogo", () => $88ce9691f2b531a8$export$94e206806e36c2ec);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $88ce9691f2b531a8$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsForLoom)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 98 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006"
        fill="${colors.iconColor}"
      />
      <path
        d="M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247"
        fill="${colors.textColor}"
      />
    </svg>`;
};
const $88ce9691f2b531a8$export$94e206806e36c2ec = ({ appearance: appearance, label: label = 'Loom', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $88ce9691f2b531a8$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("EVCNC", function(module, exports) {

$parcel$export(module.exports, "STYLES", () => $de100ffba3f3f64c$export$1c0e52168af9675e);
$parcel$export(module.exports, "TEST_IDS", () => $de100ffba3f3f64c$export$a2b4f255152a6585);
$parcel$export(module.exports, "SIGN_UP_URL", () => $de100ffba3f3f64c$export$e31599958d31a980);
$parcel$export(module.exports, "PRIVACY_POLICY_URL", () => $de100ffba3f3f64c$export$30786e8ac20c09d8);
$parcel$export(module.exports, "STORAGE_KEY", () => $de100ffba3f3f64c$export$86880b4b2e1a2384);
$parcel$export(module.exports, "AD_SUPPRESSED", () => $de100ffba3f3f64c$export$7bacbf7cb5ed4e84);
$parcel$export(module.exports, "SUBJECT_IDS", () => $de100ffba3f3f64c$export$fda1575ee29e8f5);
const $de100ffba3f3f64c$export$1c0e52168af9675e = {
    modal: {
        colors: {
            purple: '#565ADD',
            white: '#EFF0FF'
        }
    },
    background: {
        colors: {
            lightBackground: '#FFF',
            darkBackground: '#1D2125',
            lightOutline: '#B2B3F1',
            darkOutline: '#3D2E7C'
        }
    },
    controls: {
        colors: {
            lightBackground: '#FFF',
            darkBackground: '#1D2125'
        }
    }
};
const $de100ffba3f3f64c$export$a2b4f255152a6585 = {
    loomRecordVideoButton: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-record-video-quick-add-item',
    loomRecordVideoIcon: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-record-video-quick-add-item-icon',
    tryNowButton: 'issue-view-foundation.quick-add.loom-record-item-ad.try-now',
    dismissButton: 'issue-view-foundation.quick-add.loom-record-item-ad.dismiss',
    adControlOptionsButton: 'issue-view-foundation.quick-add.loom-record-item-ad.ad-options',
    getStartedLink: 'issue-view-foundation.quick-add.loom-record-item-ad.get-started',
    cancelSignupButton: 'issue-view-foundation.quick-add.loom-record-item-ad.cancel-signup',
    adControlsPrivacyPolicy: 'issue-view-foundation.quick-add.loom-record-item-ad.ad-controls-privacy-policy',
    linkIssue: 'issue.issue-view.views.issue-base.foundation.quick-add.quick-add-item.link-issue',
    adControlFlag: 'act-flag-loom-ad-issue-view-ad-controls-dismiss',
    loomRecordVideoButtonV1: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-recording-button.quick-add-item-view'
};
const $de100ffba3f3f64c$export$e31599958d31a980 = 'https://loom.com/signup?welcome_from=Jira&utm_campaign=atlassian_loom_demand&utm_source=issue-view-quick-add-v0&utm_content=jira';
const $de100ffba3f3f64c$export$30786e8ac20c09d8 = 'https://www.atlassian.com/legal/privacy-policy';
const $de100ffba3f3f64c$export$86880b4b2e1a2384 = 'jira-issue-action-view-loom-ad';
const $de100ffba3f3f64c$export$7bacbf7cb5ed4e84 = 'ad-supressed';
const $de100ffba3f3f64c$export$fda1575ee29e8f5 = {
    adControlsFlagDismissed: 'loom-record-quick-add-ad-control-flag-dismissed',
    adControlsMenuButton: 'loom-record-quick-add-ad-control-menu-button',
    adControlsResonsMenuButton: 'loom-record-quick-add-ad-control-reasons-menu-button',
    adControlsNotInterestedButton: 'loom-record-quick-add-ad-control-not-interested-button',
    loomRecordVideoButton: 'loom-record-quick-add-button',
    loomCloseIconCard: 'loom-record-quick-add-close-icon-card',
    loomRecordVideoButtonTryNow: 'loom-record-quick-add-button-try-now',
    modalCancelButton: 'loom-record-quick-add-modal-cancel-button',
    modalCtaButton: 'loom-record-quick-add-modal-cta-button'
};

});

parcelRegister("kMlHm", function(module, exports) {

$parcel$export(module.exports, "useIsDarkMode", () => $d0b7b96203c8a462$export$c720381daa58fcbb);

var $4q38b = parcelRequire("4q38b");
function $d0b7b96203c8a462$export$c720381daa58fcbb() {
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return colorMode === 'dark';
}

});

parcelRegister("1wgt8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b37e11bc02ff06f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $9b37e11bc02ff06f$var$messages = (0, $90IgZ.defineMessages)({
    loomRecordVideoButtonLabel: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-record-video-button-label",
        "defaultMessage": "Record a video"
    },
    loomAdImageAltNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-image-alt-no-translate",
        "defaultMessage": "\u201CA man records his screen. A small circle shows his face so that he can add his own commentary.\u201D"
    },
    loomAdTryNowNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-try-now-no-translate",
        "defaultMessage": "Try now"
    },
    loomAdHeadingNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-heading-no-translate",
        "defaultMessage": "Record a video"
    },
    loomAdBodyNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-body-no-translate",
        "defaultMessage": "Share a demo of the work you're doing."
    },
    loomAdAdControlsReasonsNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-ad-controls-reasons-no-translate",
        "defaultMessage": "Why am I seeing this?"
    },
    loomAdAdControlsDismissFlagTitleNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-ad-controls-dismiss-flag-title-no-translate",
        "defaultMessage": "Thanks for letting us know"
    },
    loomAdAdControlsReasonsModalExplanationNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-ad-controls-reasons-modal-explanation-no-translate",
        "defaultMessage": "We think <strong>Loom</strong> will improve your team's productivity. The recommendation is based on:"
    },
    loomAdAdControlsReasonsModalBulletOneNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-ad-controls-reasons-modal-bullet-one-no-translate",
        "defaultMessage": "the size of your team"
    },
    loomAdAdControlsReasonsModalBulletTwoNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-ad-controls-reasons-modal-bullet-two-no-translate",
        "defaultMessage": "your existing Atlassian products"
    },
    loomAdAdControlsPrivacyPolicyNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-ad-controls-privacy-policy-no-translate",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    loomAdControlsAdDismissedFlagTitleNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-controls-ad-dismissed-flag-title-no-translate",
        "defaultMessage": "Thanks for letting us know"
    },
    loomAdAdControlsDismissFlagDescriptionNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-ad-controls-dismiss-flag-description-no-translate",
        "defaultMessage": "You won't be seeing this here anymore"
    },
    headingNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.heading-no-translate",
        "defaultMessage": "Record and share a video"
    },
    contextToAnythingFeatureNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.context-to-anything-feature-no-translate",
        "defaultMessage": "Add context to anything, from code reviews to demos"
    },
    updateYourTeamNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.update-your-team-no-translate",
        "defaultMessage": "Easily update your team without a meeting"
    },
    freeTrialNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.free-trial-no-translate",
        "defaultMessage": "14 day free trial (we'll remind you before it ends)"
    },
    cancelNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.cancel-no-translate",
        "defaultMessage": "Cancel"
    },
    getStartedNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.get-started-no-translate",
        "defaultMessage": "Get started"
    },
    imageAltTextNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.image-alt-text-no-translate",
        "defaultMessage": "A woman records her screen. A small circle shows her face so that she can add her own commentary."
    }
});
var $9b37e11bc02ff06f$export$2e2bcd8739ae039 = $9b37e11bc02ff06f$var$messages;

});

parcelRegister("BHjeQ", function(module, exports) {

$parcel$export(module.exports, "LoomPreview", () => $0b044173a57eab2b$export$3e5c65b0c2c2e2c2);
/* preview.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jC90W = parcelRequire("jC90W");

var $1wgt8 = parcelRequire("1wgt8");

var $kGVGf = parcelRequire("kGVGf");
const $0b044173a57eab2b$export$3e5c65b0c2c2e2c2 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b044173a57eab2b$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jC90W.BenefitLoomBackground), {
        altText: formatMessage((0, $1wgt8.default).loomAdImageAltNoTranslate)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        alignItems: "center",
        gap: "space.200",
        justifyContent: "center",
        xcss: (0, $1ZAYh.xcss)({
            position: 'absolute',
            top: '181px',
            left: '173px'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGVGf.LoomVideoPlayer), {
        type: "video/mp4",
        src: "https://cdn.loom.com/assets/marketing/bubbs/angelina.mp4"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0b044173a57eab2b$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1fdn _1bsb12k8 _kqswh2mm _vwz4idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jC90W", function(module, exports) {

$parcel$export(module.exports, "BenefitLoomBackground", () => $b3579e7b32fd0896$export$b7d26899af3dd0dd);

var $eUqFw = parcelRequire("eUqFw");

var $EVCNC = parcelRequire("EVCNC");

var $kMlHm = parcelRequire("kMlHm");
const $b3579e7b32fd0896$export$b7d26899af3dd0dd = ({ altText: altText })=>{
    const isDarkMode = (0, $kMlHm.useIsDarkMode)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "570",
        height: "100%",
        viewBox: "0 0 570 640",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        role: "img",
        "aria-label": altText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_4042_105232)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "570",
        height: "640",
        fill: isDarkMode ? (0, $EVCNC.STYLES).background.colors.darkBackground : (0, $EVCNC.STYLES).background.colors.lightBackground
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 362C0 401.764 32.2355 434 72 434H570V0H0V362Z",
        fill: isDarkMode ? (0, $EVCNC.STYLES).background.colors.darkOutline : (0, $EVCNC.STYLES).background.colors.lightOutline
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter0_ddd_4042_105232)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip1_4042_105232)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M64 114C64 86.3858 86.3858 64 114 64H570V640H64V114Z",
        fill: "#282E33"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M64 114C64 86.3858 86.3858 64 114 64H570V640H64V114Z",
        fill: "#2B1C50"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M145.267 99.6565V92.8367H143.067V91.7364H146.585V98.5561H148.786V99.6565H145.267ZM145.05 88.8827C145.05 88.5804 145.146 88.3627 145.352 88.2176C145.557 88.0725 145.751 88 145.92 88C146.102 88 146.295 88.0725 146.501 88.2176C146.706 88.3627 146.803 88.5804 146.803 88.8827C146.803 89.1729 146.706 89.3905 146.501 89.5356C146.295 89.6807 146.102 89.7533 145.92 89.7533C145.739 89.7533 145.545 89.6807 145.352 89.5356C145.158 89.3905 145.05 89.1729 145.05 88.8827Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M151.156 99.6565V91.7484H152.317V93.5622C152.68 92.7883 153.018 92.2563 153.333 91.9661C153.647 91.6759 153.961 91.5308 154.288 91.5308C154.675 91.5308 154.977 91.6759 155.207 91.9782C155.437 92.2804 155.558 92.7037 155.558 93.2599V93.6831C155.715 93.1994 155.896 92.8125 156.126 92.5102C156.356 92.2079 156.573 91.9661 156.815 91.7968C157.057 91.6275 157.323 91.5308 157.625 91.5308C157.964 91.5308 158.254 91.6759 158.496 91.9661C158.738 92.2563 158.859 92.8246 158.859 93.6831V99.6686H157.698V94.2635C157.698 93.8161 157.686 93.5138 157.649 93.3566C157.613 93.1994 157.565 93.0664 157.48 92.9818C157.395 92.8972 157.299 92.8488 157.202 92.8488C156.96 92.8488 156.694 93.0422 156.416 93.4171C156.138 93.7919 155.848 94.4207 155.558 95.2792V99.6686H154.457V94.2756C154.457 93.5743 154.385 93.1632 154.252 93.0422C154.119 92.9213 153.998 92.8609 153.877 92.8609C153.635 92.8609 153.381 93.0664 153.103 93.4896C152.825 93.9128 152.559 94.4449 152.305 95.1099V99.6806H151.156V99.6565Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M161.676 93.5141C162.087 92.849 162.571 92.3532 163.127 92.0147C163.683 91.6761 164.203 91.5068 164.675 91.5068C165.34 91.5068 165.932 91.797 166.465 92.3653C166.997 92.9337 167.263 93.8043 167.263 94.9651C167.263 95.8841 167.081 96.6942 166.731 97.4197C166.38 98.1452 165.908 98.7135 165.328 99.1247C164.747 99.5358 164.022 99.7535 163.151 99.7535C162.91 99.7535 162.523 99.7292 162.015 99.6809C161.942 99.6688 161.821 99.6567 161.676 99.6446V102.716H160.358V91.7245H161.676V93.5141ZM161.676 95.086V98.4838C162.148 98.6047 162.595 98.6652 162.994 98.6652C163.792 98.6652 164.469 98.3508 165.014 97.722C165.558 97.0932 165.836 96.2347 165.836 95.1464C165.836 94.3605 165.691 93.768 165.388 93.369C165.086 92.97 164.747 92.7765 164.373 92.7765C163.962 92.7765 163.514 92.982 163.018 93.4053C162.523 93.8285 162.075 94.3847 161.676 95.086Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M172.425 99.8745C171.289 99.8745 170.382 99.4755 169.705 98.6895C169.028 97.9035 168.689 96.8999 168.689 95.6907C168.689 94.4816 169.028 93.49 169.705 92.7041C170.382 91.9181 171.289 91.519 172.425 91.519C173.55 91.519 174.457 91.9181 175.134 92.7041C175.811 93.49 176.15 94.4936 176.15 95.6907C176.15 96.8878 175.811 97.8915 175.134 98.6895C174.457 99.4755 173.55 99.8745 172.425 99.8745ZM172.425 98.7741C173.127 98.7741 173.683 98.496 174.106 97.9519C174.517 97.4078 174.723 96.646 174.723 95.6907C174.723 94.7355 174.517 93.9858 174.106 93.4417C173.695 92.8975 173.127 92.6194 172.425 92.6194C171.724 92.6194 171.156 92.8975 170.745 93.4417C170.334 93.9858 170.128 94.7355 170.128 95.6907C170.128 96.646 170.334 97.4078 170.745 97.9519C171.156 98.496 171.712 98.7741 172.425 98.7741Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M178.556 99.6565V91.7484H179.874V93.4776C180.285 92.8246 180.757 92.3409 181.289 92.0144C181.821 91.6879 182.413 91.5308 183.066 91.5308C183.538 91.5308 184.021 91.6033 184.493 91.7484V94.6021H183.223V92.8004C183.006 92.7641 182.824 92.7399 182.703 92.7399C182.208 92.7399 181.736 92.9334 181.252 93.3204C180.769 93.7073 180.321 94.2877 179.874 95.0616V99.6565H178.556Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M193.199 99.3302C192.583 99.5841 192.135 99.7413 191.857 99.7897C191.579 99.8381 191.313 99.8622 191.047 99.8622C190.491 99.8622 189.983 99.7534 189.536 99.5478C189.088 99.3423 188.725 99.0158 188.496 98.6047C188.266 98.1936 188.145 97.5406 188.145 96.6821V93.4898H186.174V92.3895H188.145V89.1973H189.463V92.3895H192.982V93.4898H189.463V96.6579C189.463 97.2988 189.536 97.7462 189.693 98.0122C189.85 98.2782 190.043 98.4717 190.297 98.5926C190.551 98.7135 190.854 98.774 191.192 98.774C191.833 98.774 192.498 98.5684 193.199 98.1694V99.3302Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M206.875 88V88.8827C206.536 88.9673 206.27 89.1003 206.101 89.2696C205.932 89.4389 205.787 89.6445 205.678 89.8984C205.569 90.1523 205.521 90.4667 205.521 90.8295C205.956 90.8295 206.282 90.9504 206.488 91.2043C206.694 91.4582 206.802 91.7122 206.802 91.9903C206.802 92.3168 206.681 92.5949 206.452 92.8246C206.222 93.0544 205.956 93.1632 205.642 93.1632C205.243 93.1632 204.904 92.9939 204.614 92.6553C204.324 92.3167 204.178 91.8452 204.178 91.2527C204.178 90.7328 204.287 90.237 204.517 89.7775C204.747 89.318 205.049 88.9311 205.436 88.6046C205.835 88.2781 206.307 88.0726 206.875 88ZM210.333 88V88.8827C209.995 88.9673 209.729 89.1003 209.559 89.2696C209.39 89.4389 209.245 89.6445 209.136 89.8984C209.027 90.1523 208.979 90.4667 208.979 90.8295C209.414 90.8295 209.741 90.9504 209.946 91.2043C210.152 91.4582 210.261 91.7122 210.261 91.9903C210.261 92.3168 210.14 92.5949 209.91 92.8246C209.68 93.0544 209.414 93.1632 209.1 93.1632C208.701 93.1632 208.35 92.9939 208.072 92.6553C207.794 92.3167 207.649 91.8452 207.649 91.2527C207.649 90.7328 207.758 90.237 207.987 89.7775C208.217 89.318 208.519 88.9311 208.906 88.6046C209.293 88.2781 209.777 88.0726 210.333 88Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M215.956 99.9828C215.642 99.9828 215.363 99.874 215.146 99.6443C214.928 99.4145 214.807 99.1485 214.807 98.8341C214.807 98.5077 214.916 98.2417 215.146 98.0119C215.376 97.7822 215.642 97.6733 215.956 97.6733C216.27 97.6733 216.536 97.7822 216.766 98.0119C216.996 98.2417 217.105 98.5077 217.105 98.8341C217.105 99.1485 216.996 99.4266 216.766 99.6443C216.536 99.8619 216.27 99.9828 215.956 99.9828Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M221.845 99.9827H220.551L227.54 88.3262H228.798L221.845 99.9827Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M230.213 99.2336V97.8431C230.745 98.1937 231.301 98.4356 231.893 98.5686C232.486 98.7016 232.982 98.7741 233.393 98.7741C234.058 98.7741 234.541 98.6653 234.832 98.4477C235.122 98.23 235.267 97.964 235.267 97.6375C235.267 97.4199 235.194 97.2385 235.061 97.0934C234.928 96.9483 234.59 96.7548 234.046 96.5372L233.586 96.3558L232.667 95.993C231.688 95.6061 231.071 95.2554 230.805 94.9289C230.551 94.6025 230.418 94.2155 230.418 93.756C230.418 93.1031 230.672 92.5711 231.168 92.1478C231.676 91.7246 232.486 91.519 233.622 91.519C234.469 91.519 235.267 91.64 236.029 91.8818V93.0789C235.158 92.7645 234.336 92.6073 233.574 92.6073C233.018 92.6073 232.583 92.7041 232.268 92.8975C231.954 93.091 231.797 93.3328 231.797 93.6351C231.797 93.9132 231.93 94.143 232.208 94.3123C232.474 94.4816 232.921 94.675 233.526 94.9048L234.42 95.2312C235.243 95.5335 235.811 95.8479 236.137 96.1986C236.464 96.5493 236.633 96.9846 236.633 97.5045C236.633 98.1937 236.367 98.75 235.847 99.1973C235.327 99.6447 234.481 99.8624 233.32 99.8624C232.317 99.8745 231.277 99.6568 230.213 99.2336Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M245.448 99.3302C244.831 99.5841 244.384 99.7413 244.106 99.7897C243.828 99.8381 243.562 99.8622 243.296 99.8622C242.739 99.8622 242.232 99.7534 241.784 99.5478C241.337 99.3423 240.974 99.0158 240.744 98.6047C240.514 98.1936 240.394 97.5406 240.394 96.6821V93.4898H238.423V92.3895H240.394V89.1973H241.712V92.3895H245.23V93.4898H241.712V96.6579C241.712 97.2988 241.784 97.7462 241.941 98.0122C242.099 98.2782 242.292 98.4717 242.546 98.5926C242.8 98.7135 243.102 98.774 243.441 98.774C244.082 98.774 244.747 98.5684 245.448 98.1694V99.3302Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M250.454 99.342L246.802 91.7363H248.253L251.167 97.6855L253.598 91.7363H254.928L251.869 99.0881C251.216 100.636 250.611 101.664 250.019 102.172C249.438 102.679 248.677 102.933 247.758 102.933C247.359 102.933 246.996 102.897 246.681 102.824V101.664C247.044 101.773 247.395 101.833 247.721 101.833C248.144 101.833 248.519 101.748 248.858 101.591C249.196 101.434 249.487 101.132 249.765 100.721C250.043 100.297 250.236 99.9346 250.345 99.6323L250.454 99.342Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M258.374 99.6571V89.3186H256.004V88.2183H259.692V98.5567H262.159V99.6571H258.374Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M271.53 99.1247C270.478 99.6204 269.475 99.8743 268.544 99.8743C267.83 99.8743 267.189 99.693 266.633 99.3423C266.077 98.9916 265.618 98.4838 265.279 97.8188C264.94 97.1537 264.771 96.4524 264.771 95.7027C264.771 94.9772 264.928 94.288 265.255 93.6229C265.581 92.9579 266.029 92.4379 266.597 92.063C267.177 91.6882 267.818 91.5068 268.52 91.5068C269.463 91.5068 270.212 91.8454 270.781 92.5104C271.349 93.1755 271.639 94.2154 271.639 95.6059V95.8841H266.186C266.186 96.4282 266.295 96.9361 266.524 97.3955C266.754 97.855 267.056 98.1936 267.431 98.4234C267.806 98.6531 268.229 98.7619 268.701 98.7619C269.547 98.7619 270.49 98.4838 271.518 97.9034V99.1247H271.53ZM266.27 94.9167H270.212V94.7233C270.212 94.0824 270.055 93.5624 269.741 93.1876C269.426 92.8127 269.003 92.6193 268.471 92.6193C267.939 92.6193 267.48 92.8127 267.081 93.1997C266.682 93.5866 266.428 94.155 266.27 94.9167Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M273.755 99.2336V97.8431C274.287 98.1937 274.843 98.4356 275.435 98.5686C276.028 98.7016 276.524 98.7741 276.935 98.7741C277.6 98.7741 278.083 98.6653 278.374 98.4477C278.664 98.23 278.809 97.964 278.809 97.6375C278.809 97.4199 278.736 97.2385 278.603 97.0934C278.47 96.9483 278.132 96.7548 277.588 96.5372L277.128 96.3558L276.209 95.993C275.23 95.6061 274.613 95.2554 274.347 94.9289C274.093 94.6025 273.96 94.2155 273.96 93.756C273.96 93.1031 274.214 92.5711 274.71 92.1478C275.218 91.7246 276.028 91.519 277.164 91.519C278.011 91.519 278.809 91.64 279.571 91.8818V93.0789C278.7 92.7645 277.878 92.6073 277.116 92.6073C276.56 92.6073 276.124 92.7041 275.81 92.8975C275.496 93.091 275.339 93.3328 275.339 93.6351C275.339 93.9132 275.472 94.143 275.75 94.3123C276.016 94.4816 276.463 94.675 277.068 94.9048L277.962 95.2312C278.785 95.5335 279.353 95.8479 279.679 96.1986C280.006 96.5493 280.175 96.9846 280.175 97.5045C280.175 98.1937 279.909 98.75 279.389 99.1973C278.869 99.6447 278.023 99.8624 276.862 99.8624C275.859 99.8745 274.819 99.6568 273.755 99.2336Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M285.617 99.9828C285.303 99.9828 285.025 99.874 284.807 99.6443C284.59 99.4145 284.469 99.1485 284.469 98.8341C284.469 98.5077 284.578 98.2417 284.807 98.0119C285.037 97.7822 285.303 97.6733 285.617 97.6733C285.932 97.6733 286.198 97.7822 286.428 98.0119C286.657 98.2417 286.766 98.5077 286.766 98.8341C286.766 99.1485 286.657 99.4266 286.428 99.6443C286.198 99.8619 285.932 99.9828 285.617 99.9828Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M297.733 99.4267C296.85 99.729 296.003 99.8741 295.205 99.8741C294.407 99.8741 293.706 99.6927 293.089 99.33C292.473 98.9672 291.989 98.4715 291.65 97.8427C291.312 97.2139 291.13 96.5005 291.13 95.7024C291.13 94.5054 291.517 93.5017 292.303 92.7158C293.089 91.9298 294.033 91.5308 295.133 91.5308C295.955 91.5308 296.814 91.688 297.721 91.9903V93.2599C296.802 92.8367 295.979 92.6311 295.254 92.6311C294.77 92.6311 294.323 92.752 293.899 92.9939C293.476 93.2357 293.15 93.5985 292.92 94.1063C292.69 94.6142 292.569 95.1341 292.569 95.6662C292.569 96.3796 292.787 97.0567 293.234 97.7097C293.682 98.3627 294.383 98.677 295.338 98.677C295.629 98.677 295.907 98.6529 296.185 98.6166C296.463 98.5803 296.983 98.4231 297.733 98.1692V99.4267Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M299.874 99.2336V97.8431C300.406 98.1937 300.962 98.4356 301.554 98.5686C302.147 98.7016 302.643 98.7741 303.054 98.7741C303.719 98.7741 304.202 98.6653 304.493 98.4477C304.783 98.23 304.928 97.964 304.928 97.6375C304.928 97.4199 304.855 97.2385 304.722 97.0934C304.589 96.9483 304.251 96.7548 303.707 96.5372L303.247 96.3558L302.328 95.993C301.349 95.6061 300.732 95.2554 300.466 94.9289C300.212 94.6025 300.079 94.2155 300.079 93.756C300.079 93.1031 300.333 92.5711 300.829 92.1478C301.337 91.7246 302.147 91.519 303.283 91.519C304.13 91.519 304.928 91.64 305.69 91.8818V93.0789C304.819 92.7645 303.997 92.6073 303.235 92.6073C302.679 92.6073 302.244 92.7041 301.929 92.8975C301.615 93.091 301.458 93.3328 301.458 93.6351C301.458 93.9132 301.591 94.143 301.869 94.3123C302.135 94.4816 302.582 94.675 303.187 94.9048L304.081 95.2312C304.904 95.5335 305.472 95.8479 305.799 96.1986C306.125 96.5493 306.294 96.9846 306.294 97.5045C306.294 98.1937 306.028 98.75 305.508 99.1973C304.988 99.6447 304.142 99.8624 302.981 99.8624C301.978 99.8745 300.938 99.6568 299.874 99.2336Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M308.58 99.2336V97.8431C309.112 98.1937 309.668 98.4356 310.26 98.5686C310.853 98.7016 311.349 98.7741 311.76 98.7741C312.425 98.7741 312.908 98.6653 313.199 98.4477C313.489 98.23 313.634 97.964 313.634 97.6375C313.634 97.4199 313.561 97.2385 313.428 97.0934C313.295 96.9483 312.957 96.7548 312.413 96.5372L311.953 96.3558L311.034 95.993C310.055 95.6061 309.438 95.2554 309.172 94.9289C308.918 94.6025 308.785 94.2155 308.785 93.756C308.785 93.1031 309.039 92.5711 309.535 92.1478C310.043 91.7246 310.853 91.519 311.989 91.519C312.836 91.519 313.634 91.64 314.396 91.8818V93.0789C313.525 92.7645 312.703 92.6073 311.941 92.6073C311.385 92.6073 310.95 92.7041 310.635 92.8975C310.321 93.091 310.164 93.3328 310.164 93.6351C310.164 93.9132 310.297 94.143 310.575 94.3123C310.841 94.4816 311.288 94.675 311.893 94.9048L312.788 95.2312C313.61 95.5335 314.178 95.8479 314.505 96.1986C314.831 96.5493 315 96.9846 315 97.5045C315 98.1937 314.734 98.75 314.214 99.1973C313.694 99.6447 312.848 99.8624 311.687 99.8624C310.684 99.8745 309.656 99.6568 308.58 99.2336Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M317.37 93.1632V92.2805C317.709 92.1958 317.975 92.0628 318.144 91.8936C318.313 91.7243 318.458 91.5187 318.567 91.2648C318.676 91.0108 318.724 90.6965 318.724 90.3337C318.289 90.3337 317.962 90.2128 317.757 89.9589C317.551 89.7049 317.443 89.451 317.443 89.1729C317.443 88.8464 317.563 88.5683 317.793 88.3386C318.023 88.1088 318.289 88 318.603 88C319.002 88 319.341 88.1693 319.631 88.5078C319.921 88.8464 320.066 89.318 320.066 89.9105C320.066 90.4304 319.958 90.9262 319.728 91.3857C319.498 91.8452 319.196 92.2321 318.809 92.5586C318.41 92.8851 317.938 93.0906 317.37 93.1632ZM320.84 93.1632V92.2805C321.179 92.1958 321.433 92.0628 321.614 91.8936C321.796 91.7243 321.941 91.5187 322.037 91.2648C322.146 91.0108 322.195 90.6965 322.195 90.3337C321.759 90.3337 321.433 90.2128 321.227 89.9589C321.022 89.7049 320.913 89.451 320.913 89.1729C320.913 88.8464 321.022 88.5683 321.251 88.3386C321.481 88.1088 321.747 88 322.062 88C322.461 88 322.811 88.1693 323.102 88.5078C323.392 88.8464 323.537 89.318 323.537 89.9105C323.537 90.4304 323.428 90.9262 323.198 91.3857C322.968 91.8452 322.666 92.2321 322.279 92.5586C321.88 92.8851 321.397 93.0906 320.84 93.1632Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M327.805 102.728V101.845C328.144 101.761 328.41 101.628 328.579 101.459C328.748 101.289 328.894 101.084 329.002 100.818C329.111 100.552 329.16 100.249 329.16 99.8866C328.724 99.8866 328.398 99.7657 328.192 99.5117C327.987 99.2578 327.878 99.0039 327.878 98.7137C327.878 98.3872 327.999 98.1091 328.229 97.8914C328.458 97.6738 328.724 97.5529 329.039 97.5529C329.438 97.5529 329.776 97.7221 330.067 98.0607C330.357 98.3993 330.502 98.8709 330.502 99.4634C330.502 99.9833 330.393 100.467 330.163 100.939C329.933 101.41 329.631 101.797 329.244 102.124C328.857 102.45 328.374 102.656 327.805 102.728ZM329.039 93.8286C328.724 93.8286 328.446 93.7198 328.229 93.49C328.011 93.2603 327.89 92.9943 327.89 92.6799C327.89 92.3534 327.999 92.0874 328.229 91.8576C328.458 91.6279 328.724 91.519 329.039 91.519C329.353 91.519 329.619 91.6279 329.849 91.8576C330.079 92.0874 330.187 92.3534 330.187 92.6799C330.187 92.9943 330.079 93.2724 329.849 93.49C329.619 93.7077 329.365 93.8286 329.039 93.8286Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M145.267 120.213V113.393H143.067V112.293H146.585V119.112H148.786V120.213H145.267ZM145.05 109.439C145.05 109.137 145.146 108.919 145.352 108.774C145.557 108.629 145.751 108.556 145.92 108.556C146.102 108.556 146.295 108.629 146.501 108.774C146.706 108.919 146.803 109.137 146.803 109.439C146.803 109.729 146.706 109.947 146.501 110.092C146.295 110.237 146.102 110.309 145.92 110.309C145.739 110.309 145.545 110.237 145.352 110.092C145.158 109.947 145.05 109.729 145.05 109.439Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M151.156 120.212V112.304H152.317V114.118C152.68 113.344 153.018 112.812 153.333 112.522C153.647 112.232 153.961 112.086 154.288 112.086C154.675 112.086 154.977 112.232 155.207 112.534C155.437 112.836 155.558 113.259 155.558 113.816V114.239C155.715 113.755 155.896 113.368 156.126 113.066C156.356 112.764 156.573 112.522 156.815 112.352C157.057 112.183 157.323 112.086 157.625 112.086C157.964 112.086 158.254 112.232 158.496 112.522C158.738 112.812 158.859 113.38 158.859 114.239V120.224H157.698V114.819C157.698 114.372 157.686 114.069 157.649 113.912C157.613 113.755 157.565 113.622 157.48 113.537C157.395 113.453 157.299 113.404 157.202 113.404C156.96 113.404 156.694 113.598 156.416 113.973C156.138 114.348 155.848 114.976 155.558 115.835V120.224H154.457V114.831C154.457 114.13 154.385 113.719 154.252 113.598C154.119 113.477 153.998 113.417 153.877 113.417C153.635 113.417 153.381 113.622 153.103 114.045C152.825 114.469 152.559 115.001 152.305 115.666V120.236H151.156V120.212Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M161.676 114.07C162.087 113.405 162.571 112.909 163.127 112.57C163.683 112.232 164.203 112.062 164.675 112.062C165.34 112.062 165.932 112.353 166.465 112.921C166.997 113.489 167.263 114.36 167.263 115.521C167.263 116.44 167.081 117.25 166.731 117.975C166.38 118.701 165.908 119.269 165.328 119.68C164.747 120.091 164.022 120.309 163.151 120.309C162.91 120.309 162.523 120.285 162.015 120.237C161.942 120.224 161.821 120.212 161.676 120.2V123.272H160.358V112.28H161.676V114.07ZM161.676 115.642V119.039C162.148 119.16 162.595 119.221 162.994 119.221C163.792 119.221 164.469 118.906 165.014 118.278C165.558 117.649 165.836 116.79 165.836 115.702C165.836 114.916 165.691 114.324 165.388 113.925C165.086 113.526 164.747 113.332 164.373 113.332C163.962 113.332 163.514 113.538 163.018 113.961C162.523 114.384 162.075 114.94 161.676 115.642Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M172.425 120.431C171.289 120.431 170.382 120.032 169.705 119.246C169.028 118.46 168.689 117.456 168.689 116.247C168.689 115.038 169.028 114.046 169.705 113.26C170.382 112.474 171.289 112.075 172.425 112.075C173.55 112.075 174.457 112.474 175.134 113.26C175.811 114.046 176.15 115.05 176.15 116.247C176.15 117.444 175.811 118.448 175.134 119.246C174.457 120.032 173.55 120.431 172.425 120.431ZM172.425 119.33C173.127 119.33 173.683 119.052 174.106 118.508C174.517 117.964 174.723 117.202 174.723 116.247C174.723 115.292 174.517 114.542 174.106 113.998C173.695 113.454 173.127 113.176 172.425 113.176C171.724 113.176 171.156 113.454 170.745 113.998C170.334 114.542 170.128 115.292 170.128 116.247C170.128 117.202 170.334 117.964 170.745 118.508C171.156 119.052 171.712 119.33 172.425 119.33Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M178.556 120.212V112.304H179.874V114.033C180.285 113.38 180.757 112.897 181.289 112.57C181.821 112.244 182.413 112.086 183.066 112.086C183.538 112.086 184.021 112.159 184.493 112.304V115.158H183.223V113.356C183.006 113.32 182.824 113.296 182.703 113.296C182.208 113.296 181.736 113.489 181.252 113.876C180.769 114.263 180.321 114.843 179.874 115.617V120.212H178.556Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M193.199 119.887C192.583 120.141 192.135 120.298 191.857 120.346C191.579 120.395 191.313 120.419 191.047 120.419C190.491 120.419 189.983 120.31 189.536 120.104C189.088 119.899 188.725 119.572 188.496 119.161C188.266 118.75 188.145 118.097 188.145 117.239V114.046H186.174V112.946H188.145V109.754H189.463V112.946H192.982V114.046H189.463V117.215C189.463 117.855 189.536 118.303 189.693 118.569C189.85 118.835 190.043 119.028 190.297 119.149C190.551 119.27 190.854 119.331 191.192 119.331C191.833 119.331 192.498 119.125 193.199 118.726V119.887Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M206.779 115.703C207.214 115.932 207.54 116.162 207.746 116.38C207.951 116.597 208.109 116.827 208.205 117.069C208.302 117.299 208.351 117.577 208.351 117.879C208.351 118.145 208.302 118.496 208.205 118.931L208.024 119.741C207.927 120.177 207.879 120.503 207.879 120.721C207.879 121.011 207.988 121.253 208.218 121.458C208.447 121.664 208.907 121.761 209.608 121.761H210.708V122.861H209.596C208.302 122.861 207.468 122.655 207.093 122.232C206.718 121.821 206.537 121.349 206.537 120.817C206.537 120.539 206.573 120.237 206.646 119.923L206.779 119.354L206.899 118.738L206.984 118.363C207.02 118.193 207.033 118.012 207.033 117.855C207.033 117.42 206.887 117.045 206.585 116.73C206.283 116.416 205.775 116.259 205.025 116.259H204.396V115.158H205.025C205.763 115.158 206.283 115.001 206.573 114.699C206.863 114.397 207.02 114.01 207.02 113.55C207.02 113.381 207.008 113.212 206.972 113.054L206.887 112.692L206.767 112.075L206.634 111.507C206.561 111.18 206.525 110.878 206.525 110.6C206.525 110.08 206.706 109.608 207.081 109.197C207.456 108.774 208.29 108.568 209.584 108.568H210.696V109.669H209.596C208.907 109.669 208.435 109.765 208.218 109.971C208 110.177 207.879 110.418 207.879 110.709C207.879 110.914 207.927 111.241 208.024 111.688L208.205 112.498C208.302 112.934 208.351 113.284 208.351 113.55C208.351 113.852 208.302 114.119 208.205 114.36C208.109 114.59 207.951 114.82 207.746 115.05C207.54 115.279 207.214 115.473 206.779 115.703Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M223.634 120.213V113.393H221.433V112.293H224.952V119.112H227.152V120.213H223.634ZM223.416 109.439C223.416 109.137 223.513 108.919 223.718 108.774C223.924 108.629 224.117 108.556 224.287 108.556C224.468 108.556 224.662 108.629 224.867 108.774C225.073 108.919 225.169 109.137 225.169 109.439C225.169 109.729 225.073 109.947 224.867 110.092C224.662 110.237 224.468 110.309 224.287 110.309C224.105 110.309 223.912 110.237 223.718 110.092C223.525 109.947 223.416 109.729 223.416 109.439Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M230.213 119.79V118.399C230.745 118.75 231.301 118.992 231.893 119.125C232.486 119.258 232.982 119.33 233.393 119.33C234.058 119.33 234.541 119.221 234.832 119.004C235.122 118.786 235.267 118.52 235.267 118.194C235.267 117.976 235.194 117.795 235.061 117.65C234.928 117.504 234.59 117.311 234.046 117.093L233.586 116.912L232.667 116.549C231.688 116.162 231.071 115.812 230.805 115.485C230.551 115.159 230.418 114.772 230.418 114.312C230.418 113.659 230.672 113.127 231.168 112.704C231.676 112.281 232.486 112.075 233.622 112.075C234.469 112.075 235.267 112.196 236.029 112.438V113.635C235.158 113.321 234.336 113.163 233.574 113.163C233.018 113.163 232.583 113.26 232.268 113.454C231.954 113.647 231.797 113.889 231.797 114.191C231.797 114.469 231.93 114.699 232.208 114.868C232.474 115.038 232.921 115.231 233.526 115.461L234.42 115.787C235.243 116.09 235.811 116.404 236.137 116.755C236.464 117.105 236.633 117.541 236.633 118.061C236.633 118.75 236.367 119.306 235.847 119.753C235.327 120.201 234.481 120.419 233.32 120.419C232.317 120.431 231.277 120.213 230.213 119.79Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M238.846 119.97V118.628C239.97 119.172 240.998 119.438 241.929 119.438C242.316 119.438 242.679 119.366 243.041 119.209C243.392 119.064 243.658 118.846 243.839 118.568C244.021 118.29 244.105 117.987 244.105 117.661C244.105 117.274 243.985 116.923 243.731 116.585C243.477 116.246 243.017 115.883 242.328 115.484L241.615 115.073L240.889 114.65C239.595 113.888 238.954 112.945 238.954 111.808C238.954 110.986 239.245 110.285 239.813 109.717C240.381 109.148 241.288 108.87 242.497 108.87C243.283 108.87 244.045 108.979 244.771 109.209V110.43C243.96 110.128 243.174 109.97 242.413 109.97C241.808 109.97 241.312 110.128 240.937 110.454C240.563 110.781 240.381 111.168 240.381 111.615C240.381 112.062 240.526 112.437 240.816 112.74C241.107 113.042 241.469 113.308 241.917 113.562L242.473 113.9L243.162 114.311L243.731 114.65C244.94 115.388 245.544 116.319 245.544 117.431C245.544 118.278 245.23 119.015 244.613 119.62C243.997 120.224 243.005 120.539 241.639 120.539C241.203 120.539 240.792 120.502 240.393 120.43C240.006 120.357 239.486 120.2 238.846 119.97Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M254.046 112.292V120.2H252.728V118.459C252.304 119.112 251.833 119.596 251.313 119.922C250.793 120.249 250.273 120.406 249.753 120.406C249.293 120.406 248.87 120.285 248.483 120.031C248.096 119.777 247.83 119.463 247.673 119.052C247.516 118.64 247.443 117.854 247.443 116.694V112.268H248.761V116.851C248.761 117.613 248.798 118.108 248.87 118.362C248.943 118.616 249.076 118.81 249.269 118.967C249.463 119.124 249.68 119.197 249.898 119.197C250.358 119.197 250.853 118.979 251.385 118.544C251.917 118.108 252.353 117.552 252.703 116.887V112.28H254.046V112.292Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M257.467 114.07C257.878 113.405 258.362 112.909 258.918 112.57C259.474 112.232 259.994 112.062 260.466 112.062C261.131 112.062 261.723 112.353 262.255 112.921C262.787 113.489 263.053 114.36 263.053 115.521C263.053 116.44 262.872 117.25 262.521 117.975C262.171 118.701 261.699 119.269 261.119 119.68C260.538 120.091 259.813 120.309 258.942 120.309C258.7 120.309 258.313 120.285 257.806 120.237C257.733 120.224 257.612 120.212 257.467 120.2V123.272H256.149V112.28H257.467V114.07ZM257.467 115.642V119.039C257.939 119.16 258.386 119.221 258.785 119.221C259.583 119.221 260.26 118.906 260.804 118.278C261.348 117.649 261.627 116.79 261.627 115.702C261.627 114.916 261.482 114.324 261.179 113.925C260.877 113.526 260.538 113.332 260.163 113.332C259.752 113.332 259.305 113.538 258.809 113.961C258.313 114.384 257.854 114.94 257.467 115.642Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M266.174 114.07C266.585 113.405 267.068 112.909 267.625 112.57C268.181 112.232 268.701 112.062 269.172 112.062C269.837 112.062 270.43 112.353 270.962 112.921C271.494 113.489 271.76 114.36 271.76 115.521C271.76 116.44 271.579 117.25 271.228 117.975C270.877 118.701 270.406 119.269 269.825 119.68C269.245 120.091 268.519 120.309 267.649 120.309C267.407 120.309 267.02 120.285 266.512 120.237C266.439 120.224 266.319 120.212 266.174 120.2V123.272H264.855V112.28H266.174V114.07ZM266.174 115.642V119.039C266.645 119.16 267.093 119.221 267.492 119.221C268.29 119.221 268.967 118.906 269.511 118.278C270.055 117.649 270.333 116.79 270.333 115.702C270.333 114.916 270.188 114.324 269.886 113.925C269.583 113.526 269.245 113.332 268.87 113.332C268.459 113.332 268.011 113.538 267.516 113.961C267.02 114.384 266.573 114.94 266.174 115.642Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M276.91 120.431C275.774 120.431 274.867 120.032 274.19 119.246C273.513 118.46 273.174 117.456 273.174 116.247C273.174 115.038 273.513 114.046 274.19 113.26C274.867 112.474 275.774 112.075 276.91 112.075C278.035 112.075 278.942 112.474 279.619 113.26C280.296 114.046 280.635 115.05 280.635 116.247C280.635 117.444 280.296 118.448 279.619 119.246C278.942 120.032 278.047 120.431 276.91 120.431ZM276.91 119.33C277.612 119.33 278.168 119.052 278.591 118.508C279.002 117.964 279.208 117.202 279.208 116.247C279.208 115.292 279.002 114.542 278.591 113.998C278.18 113.454 277.612 113.176 276.91 113.176C276.209 113.176 275.641 113.454 275.23 113.998C274.819 114.542 274.613 115.292 274.613 116.247C274.613 117.202 274.819 117.964 275.23 118.508C275.641 119.052 276.209 119.33 276.91 119.33Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M283.041 120.212V112.304H284.359V114.033C284.77 113.38 285.242 112.897 285.774 112.57C286.306 112.244 286.899 112.086 287.552 112.086C288.023 112.086 288.507 112.159 288.978 112.304V115.158H287.709V113.356C287.491 113.32 287.31 113.296 287.189 113.296C286.693 113.296 286.222 113.489 285.738 113.876C285.254 114.263 284.807 114.843 284.359 115.617V120.212H283.041Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M297.696 119.887C297.08 120.141 296.632 120.298 296.354 120.346C296.076 120.395 295.81 120.419 295.544 120.419C294.988 120.419 294.48 120.31 294.033 120.104C293.585 119.899 293.222 119.572 292.993 119.161C292.763 118.75 292.642 118.097 292.642 117.239V114.046H290.671V112.946H292.642V109.754H293.96V112.946H297.479V114.046H293.96V117.215C293.96 117.855 294.033 118.303 294.19 118.569C294.347 118.835 294.54 119.028 294.794 119.149C295.048 119.27 295.351 119.331 295.689 119.331C296.33 119.331 296.995 119.125 297.696 118.726V119.887Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M306.366 119.68C305.314 120.176 304.31 120.43 303.379 120.43C302.666 120.43 302.025 120.249 301.469 119.898C300.912 119.547 300.453 119.039 300.114 118.374C299.776 117.709 299.607 117.008 299.607 116.258C299.607 115.533 299.764 114.844 300.09 114.179C300.417 113.514 300.864 112.994 301.432 112.619C302.013 112.244 302.654 112.062 303.355 112.062C304.298 112.062 305.048 112.401 305.616 113.066C306.184 113.731 306.475 114.771 306.475 116.162V116.44H301.021C301.021 116.984 301.13 117.492 301.36 117.951C301.59 118.411 301.892 118.749 302.267 118.979C302.642 119.209 303.065 119.318 303.536 119.318C304.383 119.318 305.326 119.039 306.354 118.459V119.68H306.366ZM301.094 115.472H305.036V115.279C305.036 114.638 304.879 114.118 304.564 113.743C304.25 113.368 303.827 113.175 303.295 113.175C302.763 113.175 302.303 113.368 301.904 113.755C301.505 114.142 301.251 114.711 301.094 115.472Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M313.779 118.423C313.38 119.088 312.896 119.584 312.328 119.923C311.759 120.261 311.239 120.43 310.768 120.43C310.103 120.43 309.51 120.14 308.978 119.572C308.446 119.004 308.192 118.133 308.192 116.972C308.192 116.053 308.361 115.243 308.712 114.518C309.063 113.792 309.534 113.224 310.115 112.813C310.695 112.401 311.421 112.184 312.291 112.184C312.545 112.184 312.92 112.208 313.428 112.256C313.5 112.268 313.621 112.281 313.766 112.293V108.774H315.084V120.213H313.766V118.423H313.779ZM313.779 116.863V113.466C313.307 113.345 312.872 113.284 312.473 113.284C311.662 113.284 310.985 113.599 310.441 114.227C309.897 114.856 309.631 115.715 309.631 116.791C309.631 117.577 309.776 118.169 310.078 118.568C310.369 118.967 310.707 119.173 311.094 119.173C311.505 119.173 311.965 118.967 312.461 118.544C312.956 118.121 313.392 117.565 313.779 116.863Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M319.099 123.284V122.401C319.438 122.317 319.704 122.184 319.873 122.015C320.042 121.845 320.188 121.64 320.296 121.374C320.405 121.108 320.454 120.805 320.454 120.443C320.018 120.443 319.692 120.322 319.486 120.068C319.281 119.814 319.172 119.56 319.172 119.27C319.172 118.943 319.293 118.665 319.523 118.447C319.752 118.23 320.018 118.109 320.333 118.109C320.732 118.109 321.07 118.278 321.361 118.617C321.651 118.955 321.796 119.427 321.796 120.019C321.796 120.539 321.687 121.023 321.457 121.495C321.227 121.966 320.925 122.353 320.538 122.68C320.151 123.006 319.668 123.212 319.099 123.284Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M334.709 119.79V118.399C335.242 118.75 335.798 118.992 336.39 119.125C336.983 119.258 337.479 119.33 337.89 119.33C338.555 119.33 339.038 119.221 339.329 119.004C339.619 118.786 339.764 118.52 339.764 118.194C339.764 117.976 339.691 117.795 339.558 117.65C339.425 117.504 339.087 117.311 338.543 117.093L338.083 116.912L337.164 116.549C336.185 116.162 335.568 115.812 335.302 115.485C335.048 115.159 334.915 114.772 334.915 114.312C334.915 113.659 335.169 113.127 335.665 112.704C336.173 112.281 336.983 112.075 338.119 112.075C338.966 112.075 339.764 112.196 340.526 112.438V113.635C339.655 113.321 338.833 113.163 338.071 113.163C337.515 113.163 337.079 113.26 336.765 113.454C336.451 113.647 336.293 113.889 336.293 114.191C336.293 114.469 336.427 114.699 336.705 114.868C336.971 115.038 337.418 115.231 338.023 115.461L338.917 115.787C339.74 116.09 340.308 116.404 340.634 116.755C340.961 117.105 341.13 117.541 341.13 118.061C341.13 118.75 340.864 119.306 340.344 119.753C339.812 120.201 338.978 120.419 337.817 120.419C336.813 120.431 335.774 120.213 334.709 119.79Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M349.896 119.68C348.844 120.176 347.841 120.43 346.91 120.43C346.196 120.43 345.555 120.249 344.999 119.898C344.443 119.547 343.983 119.039 343.645 118.374C343.306 117.709 343.137 117.008 343.137 116.258C343.137 115.533 343.294 114.844 343.621 114.179C343.947 113.514 344.395 112.994 344.963 112.619C345.543 112.244 346.184 112.062 346.886 112.062C347.829 112.062 348.578 112.401 349.147 113.066C349.715 113.731 350.005 114.771 350.005 116.162V116.44H344.552C344.552 116.984 344.673 117.492 344.902 117.951C345.132 118.411 345.434 118.749 345.809 118.979C346.184 119.209 346.607 119.318 347.079 119.318C347.925 119.318 348.869 119.039 349.896 118.459V119.68ZM344.636 115.472H348.578V115.279C348.578 114.638 348.421 114.118 348.107 113.743C347.792 113.368 347.369 113.175 346.837 113.175C346.305 113.175 345.846 113.368 345.459 113.755C345.072 114.142 344.794 114.711 344.636 115.472Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M358.639 119.887C358.022 120.141 357.575 120.298 357.297 120.346C357.019 120.395 356.753 120.419 356.487 120.419C355.93 120.419 355.423 120.31 354.975 120.104C354.528 119.899 354.177 119.572 353.935 119.161C353.693 118.75 353.585 118.097 353.585 117.239V114.046H351.614V112.946H353.585V109.754H354.903V112.946H358.421V114.046H354.903V117.215C354.903 117.855 354.975 118.303 355.132 118.569C355.29 118.835 355.483 119.028 355.737 119.149C355.991 119.27 356.293 119.331 356.632 119.331C357.273 119.331 357.938 119.125 358.639 118.726V119.887Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M367.249 112.292V120.2H365.931V118.459C365.508 119.112 365.036 119.596 364.516 119.922C363.996 120.249 363.476 120.406 362.956 120.406C362.497 120.406 362.074 120.285 361.687 120.031C361.3 119.777 361.034 119.463 360.877 119.052C360.719 118.64 360.647 117.854 360.647 116.694V112.268H361.965V116.851C361.965 117.613 362.001 118.108 362.074 118.362C362.146 118.616 362.279 118.81 362.473 118.967C362.666 119.124 362.884 119.197 363.101 119.197C363.561 119.197 364.057 118.979 364.589 118.544C365.121 118.108 365.556 117.552 365.907 116.887V112.28H367.249V112.292Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M370.659 114.07C371.07 113.405 371.553 112.909 372.11 112.57C372.666 112.232 373.186 112.062 373.657 112.062C374.322 112.062 374.915 112.353 375.447 112.921C375.979 113.489 376.245 114.36 376.245 115.521C376.245 116.44 376.076 117.25 375.713 117.975C375.35 118.701 374.891 119.269 374.31 119.68C373.73 120.091 373.004 120.309 372.134 120.309C371.892 120.309 371.505 120.285 370.997 120.237C370.925 120.224 370.804 120.212 370.659 120.2V123.272H369.341V112.28H370.659V114.07ZM370.659 115.642V119.039C371.13 119.16 371.578 119.221 371.977 119.221C372.775 119.221 373.452 118.906 373.996 118.278C374.54 117.649 374.818 116.79 374.818 115.702C374.818 114.916 374.673 114.324 374.371 113.925C374.068 113.526 373.73 113.332 373.355 113.332C372.944 113.332 372.497 113.538 372.001 113.961C371.505 114.384 371.058 114.94 370.659 115.642Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M390.586 115.703C390.151 115.473 389.824 115.243 389.619 115.026C389.413 114.808 389.256 114.578 389.159 114.336C389.062 114.095 389.014 113.829 389.014 113.526C389.014 113.26 389.062 112.91 389.147 112.474L389.328 111.664C389.425 111.229 389.473 110.902 389.473 110.685C389.473 110.394 389.365 110.153 389.135 109.947C388.905 109.742 388.446 109.645 387.744 109.645H386.644V108.544H387.756C389.05 108.544 389.885 108.75 390.259 109.173C390.634 109.596 390.816 110.056 390.816 110.576C390.816 110.854 390.779 111.156 390.707 111.483L390.574 112.051L390.453 112.668L390.368 113.03C390.332 113.212 390.32 113.381 390.32 113.55C390.32 113.986 390.465 114.361 390.767 114.675C391.07 114.989 391.578 115.147 392.327 115.147H392.956V116.247H392.327C391.59 116.247 391.07 116.404 390.767 116.706C390.465 117.009 390.32 117.396 390.32 117.855C390.32 118.024 390.332 118.182 390.368 118.339L390.453 118.714L390.574 119.33L390.707 119.899C390.779 120.225 390.816 120.527 390.816 120.806C390.816 121.325 390.634 121.797 390.259 122.208C389.885 122.619 389.05 122.825 387.756 122.825H386.644V121.724H387.744C388.446 121.724 388.905 121.628 389.135 121.422C389.365 121.217 389.473 120.975 389.473 120.685C389.473 120.479 389.425 120.153 389.328 119.717L389.147 118.907C389.062 118.472 389.014 118.121 389.014 117.855C389.014 117.553 389.062 117.287 389.159 117.045C389.256 116.803 389.413 116.585 389.619 116.356C389.824 116.126 390.139 115.933 390.586 115.703Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M406.112 120.213V114.046H404.359V112.945H406.112V112.583C406.112 111.543 406.233 110.769 406.463 110.273C406.705 109.777 407.067 109.366 407.563 109.04C408.059 108.713 408.712 108.556 409.522 108.556C410.139 108.556 410.755 108.617 411.396 108.75V109.995C410.707 109.765 410.102 109.656 409.57 109.656C409.147 109.656 408.784 109.729 408.458 109.886C408.131 110.043 407.889 110.297 407.708 110.648C407.527 110.999 407.43 111.591 407.43 112.438V112.945H410.574V114.046H407.43V120.213H406.112Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M413.657 120.212V112.304H414.975V114.033C415.387 113.38 415.858 112.897 416.39 112.57C416.922 112.244 417.515 112.086 418.168 112.086C418.639 112.086 419.123 112.159 419.594 112.304V115.158H418.325V113.356C418.107 113.32 417.926 113.296 417.805 113.296C417.309 113.296 416.838 113.489 416.354 113.876C415.87 114.263 415.423 114.843 414.975 115.617V120.212H413.657Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M424.938 120.431C423.802 120.431 422.895 120.032 422.218 119.246C421.541 118.46 421.202 117.456 421.202 116.247C421.202 115.038 421.541 114.046 422.218 113.26C422.895 112.474 423.802 112.075 424.938 112.075C426.063 112.075 426.97 112.474 427.647 113.26C428.324 114.046 428.663 115.05 428.663 116.247C428.663 117.444 428.324 118.448 427.647 119.246C426.97 120.032 426.075 120.431 424.938 120.431ZM424.938 119.33C425.64 119.33 426.196 119.052 426.619 118.508C427.03 117.964 427.236 117.202 427.236 116.247C427.236 115.292 427.03 114.542 426.619 113.998C426.208 113.454 425.64 113.176 424.938 113.176C424.225 113.176 423.669 113.454 423.258 113.998C422.847 114.542 422.629 115.292 422.629 116.247C422.629 117.202 422.834 117.964 423.258 118.508C423.681 119.052 424.237 119.33 424.938 119.33Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M429.8 120.212V112.304H430.961V114.118C431.324 113.344 431.662 112.812 431.977 112.522C432.291 112.232 432.605 112.086 432.932 112.086C433.319 112.086 433.621 112.232 433.863 112.534C434.105 112.836 434.214 113.259 434.214 113.816V114.239C434.371 113.755 434.564 113.368 434.782 113.066C435 112.764 435.229 112.522 435.459 112.352C435.689 112.183 435.967 112.086 436.269 112.086C436.608 112.086 436.898 112.232 437.14 112.522C437.382 112.812 437.503 113.38 437.503 114.239V120.224H436.342V114.819C436.342 114.372 436.33 114.069 436.293 113.912C436.257 113.755 436.209 113.622 436.124 113.537C436.039 113.453 435.943 113.404 435.846 113.404C435.604 113.404 435.338 113.598 435.06 113.973C434.782 114.348 434.492 114.976 434.201 115.835V120.224H433.101V114.831C433.101 114.13 433.028 113.719 432.895 113.598C432.762 113.477 432.642 113.417 432.521 113.417C432.279 113.417 432.025 113.622 431.747 114.045C431.469 114.469 431.203 115.001 430.949 115.666V120.236H429.8V120.212Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M450.682 108.556V109.439C450.344 109.523 450.09 109.656 449.908 109.826C449.727 109.995 449.594 110.201 449.485 110.455C449.376 110.708 449.328 111.023 449.328 111.386C449.763 111.386 450.09 111.507 450.295 111.76C450.501 112.014 450.61 112.268 450.61 112.546C450.61 112.873 450.489 113.151 450.259 113.381C450.029 113.611 449.763 113.719 449.449 113.719C449.05 113.719 448.711 113.55 448.421 113.211C448.131 112.873 447.986 112.401 447.986 111.809C447.986 111.289 448.095 110.793 448.324 110.334C448.554 109.874 448.856 109.487 449.255 109.161C449.642 108.834 450.114 108.629 450.682 108.556ZM454.141 108.556V109.439C453.802 109.523 453.548 109.656 453.367 109.826C453.185 109.995 453.052 110.201 452.943 110.455C452.835 110.708 452.786 111.023 452.786 111.386C453.222 111.386 453.548 111.507 453.754 111.76C453.959 112.014 454.068 112.268 454.068 112.546C454.068 112.873 453.947 113.151 453.717 113.381C453.488 113.611 453.222 113.719 452.907 113.719C452.508 113.719 452.157 113.55 451.879 113.211C451.601 112.873 451.444 112.401 451.444 111.809C451.444 111.289 451.553 110.793 451.783 110.334C452.012 109.874 452.315 109.487 452.714 109.161C453.113 108.834 453.584 108.629 454.141 108.556Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M459.763 120.539C459.449 120.539 459.171 120.43 458.953 120.2C458.735 119.97 458.614 119.704 458.614 119.39C458.614 119.063 458.735 118.797 458.965 118.568C459.195 118.338 459.461 118.229 459.775 118.229C460.09 118.229 460.355 118.338 460.585 118.568C460.815 118.797 460.924 119.063 460.924 119.39C460.924 119.704 460.815 119.982 460.585 120.2C460.355 120.418 460.09 120.539 459.763 120.539Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M465.664 120.539H464.37L471.359 108.883H472.617L465.664 120.539Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M473.342 120.212V112.304H474.503V114.118C474.866 113.344 475.204 112.812 475.519 112.522C475.833 112.232 476.148 112.086 476.474 112.086C476.861 112.086 477.163 112.232 477.405 112.534C477.647 112.836 477.756 113.259 477.756 113.816V114.239C477.913 113.755 478.107 113.368 478.324 113.066C478.542 112.764 478.772 112.522 479.001 112.352C479.231 112.183 479.509 112.086 479.811 112.086C480.15 112.086 480.44 112.232 480.682 112.522C480.924 112.812 481.045 113.38 481.045 114.239V120.224H479.884V114.819C479.884 114.372 479.872 114.069 479.836 113.912C479.799 113.755 479.751 113.622 479.666 113.537C479.582 113.453 479.485 113.404 479.388 113.404C479.146 113.404 478.88 113.598 478.602 113.973C478.324 114.348 478.034 114.976 477.744 115.835V120.224H476.643V114.831C476.643 114.13 476.571 113.719 476.438 113.598C476.305 113.477 476.184 113.417 476.063 113.417C475.821 113.417 475.567 113.622 475.289 114.045C475.011 114.469 474.745 115.001 474.491 115.666V120.236H473.342V120.212Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M485.893 120.431C484.757 120.431 483.85 120.032 483.173 119.246C482.496 118.46 482.157 117.456 482.157 116.247C482.157 115.038 482.496 114.046 483.173 113.26C483.85 112.474 484.757 112.075 485.893 112.075C487.018 112.075 487.925 112.474 488.602 113.26C489.279 114.046 489.618 115.05 489.618 116.247C489.618 117.444 489.279 118.448 488.602 119.246C487.925 120.032 487.018 120.431 485.893 120.431ZM485.893 119.33C486.595 119.33 487.151 119.052 487.574 118.508C487.985 117.964 488.191 117.202 488.191 116.247C488.191 115.292 487.985 114.542 487.574 113.998C487.163 113.454 486.595 113.176 485.893 113.176C485.18 113.176 484.624 113.454 484.213 113.998C483.801 114.542 483.584 115.292 483.584 116.247C483.584 117.202 483.789 117.964 484.213 118.508C484.636 119.052 485.192 119.33 485.893 119.33Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M496.643 118.423C496.244 119.088 495.76 119.584 495.192 119.923C494.624 120.261 494.104 120.43 493.632 120.43C492.967 120.43 492.374 120.14 491.842 119.572C491.31 119.004 491.057 118.133 491.057 116.972C491.057 116.053 491.226 115.243 491.588 114.518C491.939 113.792 492.411 113.224 492.991 112.813C493.584 112.389 494.309 112.184 495.168 112.184C495.422 112.184 495.796 112.208 496.304 112.256C496.377 112.268 496.498 112.281 496.643 112.293V108.774H497.961V120.213H496.643V118.423ZM496.643 116.863V113.466C496.171 113.345 495.736 113.284 495.337 113.284C494.527 113.284 493.85 113.599 493.306 114.227C492.761 114.856 492.495 115.715 492.495 116.791C492.495 117.577 492.64 118.169 492.943 118.568C493.245 118.967 493.571 119.173 493.958 119.173C494.37 119.173 494.829 118.967 495.325 118.544C495.808 118.121 496.244 117.565 496.643 116.863Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M506.57 112.292V120.2H505.252V118.459C504.829 119.112 504.358 119.596 503.838 119.922C503.318 120.249 502.798 120.406 502.278 120.406C501.818 120.406 501.395 120.285 501.008 120.031C500.621 119.777 500.355 119.463 500.198 119.052C500.041 118.64 499.968 117.854 499.968 116.694V112.268H501.286V116.851C501.286 117.613 501.322 118.108 501.395 118.362C501.468 118.616 501.601 118.81 501.794 118.967C501.988 119.124 502.205 119.197 502.423 119.197C502.882 119.197 503.378 118.979 503.91 118.544C504.442 118.108 504.878 117.552 505.228 116.887V112.28H506.57V112.292Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M510.887 120.213V109.874H508.517V108.774H512.205V119.112H514.672V120.213H510.887Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M524.055 119.68C523.003 120.176 522 120.43 521.069 120.43C520.355 120.43 519.714 120.249 519.158 119.898C518.602 119.547 518.143 119.039 517.804 118.374C517.465 117.709 517.296 117.008 517.296 116.258C517.296 115.533 517.453 114.844 517.78 114.179C518.106 113.514 518.554 112.994 519.122 112.619C519.702 112.244 520.343 112.062 521.044 112.062C521.988 112.062 522.737 112.401 523.306 113.066C523.874 113.731 524.164 114.771 524.164 116.162V116.44H518.711C518.711 116.984 518.832 117.492 519.061 117.951C519.291 118.411 519.593 118.749 519.968 118.979C520.343 119.209 520.766 119.318 521.238 119.318C522.084 119.318 523.027 119.039 524.055 118.459V119.68ZM518.783 115.472H522.725V115.279C522.725 114.638 522.568 114.118 522.254 113.743C521.939 113.368 521.516 113.175 520.984 113.175C520.452 113.175 519.993 113.368 519.606 113.755C519.219 114.142 518.94 114.711 518.783 115.472Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M526.268 119.79V118.399C526.8 118.75 527.356 118.992 527.949 119.125C528.541 119.258 529.037 119.33 529.448 119.33C530.113 119.33 530.597 119.221 530.887 119.004C531.177 118.786 531.322 118.52 531.322 118.194C531.322 117.976 531.25 117.795 531.117 117.65C530.984 117.504 530.645 117.311 530.101 117.093L529.642 116.912L528.723 116.549C527.743 116.162 527.127 115.812 526.861 115.485C526.607 115.159 526.474 114.772 526.474 114.312C526.474 113.659 526.727 113.127 527.223 112.704C527.719 112.281 528.541 112.075 529.678 112.075C530.524 112.075 531.322 112.196 532.084 112.438V113.635C531.214 113.321 530.391 113.163 529.629 113.163C529.073 113.163 528.638 113.26 528.324 113.454C528.009 113.647 527.852 113.889 527.852 114.191C527.852 114.469 527.985 114.699 528.263 114.868C528.529 115.038 528.977 115.231 529.581 115.461L530.476 115.787C531.298 116.09 531.866 116.404 532.193 116.755C532.519 117.105 532.689 117.541 532.689 118.061C532.689 118.75 532.423 119.306 531.903 119.753C531.383 120.201 530.536 120.419 529.376 120.419C528.372 120.431 527.332 120.213 526.268 119.79Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M535.325 120.539H534.031L541.02 108.883H542.278L535.325 120.539Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M545.711 120.213V109.874H543.342V108.774H547.029V119.112H549.496V120.213H545.711Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M555.554 120.431C554.418 120.431 553.511 120.032 552.834 119.246C552.157 118.46 551.818 117.456 551.818 116.247C551.818 115.038 552.157 114.046 552.834 113.26C553.511 112.474 554.418 112.075 555.554 112.075C556.679 112.075 557.586 112.474 558.263 113.26C558.94 114.046 559.279 115.05 559.279 116.247C559.279 117.444 558.94 118.448 558.263 119.246C557.586 120.032 556.679 120.431 555.554 120.431ZM555.554 119.33C556.256 119.33 556.812 119.052 557.235 118.508C557.646 117.964 557.852 117.202 557.852 116.247C557.852 115.292 557.646 114.542 557.235 113.998C556.824 113.454 556.256 113.176 555.554 113.176C554.841 113.176 554.285 113.454 553.874 113.998C553.462 114.542 553.245 115.292 553.245 116.247C553.245 117.202 553.45 117.964 553.874 118.508C554.297 119.052 554.853 119.33 555.554 119.33Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M564.26 120.431C563.124 120.431 562.217 120.032 561.54 119.246C560.863 118.46 560.524 117.456 560.524 116.247C560.524 115.038 560.863 114.046 561.54 113.26C562.217 112.474 563.124 112.075 564.26 112.075C565.385 112.075 566.292 112.474 566.969 113.26C567.646 114.046 567.985 115.05 567.985 116.247C567.985 117.444 567.646 118.448 566.969 119.246C566.292 120.032 565.385 120.431 564.26 120.431ZM564.26 119.33C564.962 119.33 565.518 119.052 565.941 118.508C566.352 117.964 566.558 117.202 566.558 116.247C566.558 115.292 566.352 114.542 565.941 113.998C565.53 113.454 564.962 113.176 564.26 113.176C563.547 113.176 562.991 113.454 562.58 113.998C562.168 114.542 561.951 115.292 561.951 116.247C561.951 117.202 562.156 117.964 562.58 118.508C563.003 119.052 563.559 119.33 564.26 119.33Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M569.121 120.212V112.304H570.282V114.118C570.645 113.344 570.984 112.812 571.298 112.522C571.612 112.232 571.927 112.086 572.253 112.086C572.64 112.086 572.942 112.232 573.184 112.534C573.426 112.836 573.535 113.259 573.535 113.816V114.239C573.692 113.755 573.886 113.368 574.103 113.066C574.321 112.764 574.551 112.522 574.78 112.352C575.01 112.183 575.288 112.086 575.591 112.086C575.929 112.086 576.219 112.232 576.461 112.522C576.703 112.812 576.824 113.38 576.824 114.239V120.224H575.663V114.819C575.663 114.372 575.651 114.069 575.615 113.912C575.578 113.755 575.53 113.622 575.445 113.537C575.361 113.453 575.264 113.404 575.167 113.404C574.926 113.404 574.659 113.598 574.381 113.973C574.103 114.348 573.813 114.976 573.523 115.835V120.224H572.422V114.831C572.422 114.13 572.35 113.719 572.217 113.598C572.084 113.477 571.963 113.417 571.842 113.417C571.6 113.417 571.346 113.622 571.068 114.045C570.79 114.469 570.524 115.001 570.27 115.666V120.236H569.121V120.212Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M149.705 161.095C148.822 161.397 147.976 161.543 147.178 161.543C146.38 161.543 145.679 161.361 145.062 160.998C144.445 160.636 143.962 160.14 143.623 159.511C143.284 158.882 143.103 158.169 143.103 157.371C143.103 156.174 143.49 155.17 144.276 154.384C145.062 153.598 146.005 153.199 147.105 153.199C147.928 153.199 148.786 153.356 149.693 153.659V154.928C148.774 154.505 147.952 154.3 147.226 154.3C146.743 154.3 146.295 154.42 145.872 154.662C145.449 154.904 145.122 155.267 144.893 155.775C144.663 156.283 144.542 156.803 144.542 157.335C144.542 158.048 144.76 158.725 145.207 159.378C145.654 160.031 146.356 160.345 147.311 160.345C147.601 160.345 147.879 160.321 148.157 160.285C148.436 160.249 148.955 160.092 149.705 159.838V161.095Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M155.013 161.543C153.877 161.543 152.97 161.144 152.293 160.358C151.616 159.572 151.277 158.568 151.277 157.359C151.277 156.15 151.616 155.158 152.293 154.373C152.97 153.587 153.877 153.188 155.013 153.188C156.138 153.188 157.045 153.587 157.722 154.373C158.399 155.158 158.738 156.162 158.738 157.359C158.738 158.556 158.399 159.56 157.722 160.358C157.045 161.144 156.138 161.543 155.013 161.543ZM155.013 160.443C155.715 160.443 156.271 160.164 156.694 159.62C157.105 159.076 157.311 158.314 157.311 157.359C157.311 156.404 157.105 155.654 156.694 155.11C156.283 154.566 155.715 154.288 155.013 154.288C154.312 154.288 153.744 154.566 153.333 155.11C152.921 155.654 152.716 156.404 152.716 157.359C152.716 158.314 152.921 159.076 153.333 159.62C153.744 160.164 154.3 160.443 155.013 160.443Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M160.467 161.325V153.417H161.785V155.146C162.159 154.541 162.619 154.058 163.151 153.719C163.683 153.381 164.215 153.199 164.747 153.199C165.219 153.199 165.642 153.32 166.017 153.574C166.392 153.828 166.67 154.142 166.827 154.553C166.984 154.965 167.057 155.739 167.057 156.924V161.349H165.739V156.766C165.739 156.005 165.702 155.509 165.63 155.255C165.557 155.001 165.424 154.807 165.231 154.65C165.037 154.493 164.82 154.421 164.59 154.421C164.13 154.421 163.635 154.638 163.103 155.073C162.571 155.509 162.135 156.065 161.785 156.73V161.337H160.467V161.325Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M169.258 160.902V159.512C169.79 159.862 170.346 160.104 170.938 160.237C171.531 160.37 172.027 160.443 172.438 160.443C173.103 160.443 173.586 160.334 173.877 160.116C174.167 159.898 174.312 159.632 174.312 159.306C174.312 159.088 174.239 158.907 174.106 158.762C173.973 158.617 173.635 158.423 173.091 158.206L172.631 158.024L171.712 157.661C170.733 157.275 170.116 156.924 169.85 156.597C169.596 156.271 169.463 155.884 169.463 155.424C169.463 154.772 169.717 154.24 170.213 153.816C170.721 153.393 171.531 153.188 172.667 153.188C173.514 153.188 174.312 153.308 175.074 153.55V154.747C174.203 154.433 173.381 154.276 172.619 154.276C172.063 154.276 171.628 154.373 171.313 154.566C170.999 154.759 170.842 155.001 170.842 155.304C170.842 155.582 170.975 155.811 171.253 155.981C171.519 156.15 171.966 156.343 172.571 156.573L173.466 156.9C174.288 157.202 174.856 157.516 175.183 157.867C175.509 158.218 175.678 158.653 175.678 159.173C175.678 159.862 175.412 160.418 174.892 160.866C174.372 161.313 173.526 161.531 172.365 161.531C171.374 161.543 170.334 161.325 169.258 160.902Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M184.493 160.999C183.877 161.253 183.429 161.41 183.151 161.458C182.873 161.507 182.607 161.531 182.341 161.531C181.785 161.531 181.277 161.422 180.83 161.216C180.382 161.011 180.019 160.684 179.79 160.273C179.56 159.862 179.439 159.209 179.439 158.351V155.158H177.468V154.058H179.439V150.866H180.757V154.058H184.276V155.158H180.757V158.326C180.757 158.967 180.83 159.415 180.987 159.681C181.144 159.947 181.337 160.14 181.591 160.261C181.845 160.382 182.148 160.442 182.486 160.442C183.127 160.442 183.792 160.237 184.493 159.838V160.999Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M195.412 161.324V150.333H197.564C198.858 150.333 199.716 150.43 200.152 150.623C200.587 150.817 200.914 151.107 201.131 151.494C201.349 151.881 201.458 152.316 201.458 152.8C201.458 153.187 201.397 153.549 201.264 153.9C201.131 154.251 200.95 154.565 200.696 154.855C200.442 155.146 200.079 155.412 199.608 155.665C200.478 156.016 201.071 156.439 201.385 156.959C201.699 157.479 201.845 157.975 201.845 158.495C201.845 158.979 201.712 159.45 201.446 159.91C201.18 160.369 200.817 160.72 200.345 160.962C199.874 161.204 199.112 161.324 198.072 161.324H195.412ZM196.839 155.279H198.338C198.822 155.073 199.184 154.855 199.402 154.638C199.632 154.408 199.789 154.166 199.91 153.888C200.031 153.61 200.079 153.308 200.079 152.981C200.079 152.461 199.922 152.074 199.62 151.82C199.317 151.566 198.725 151.433 197.842 151.433H196.839V155.279ZM196.839 160.224H198.193C198.943 160.224 199.511 160.043 199.874 159.692C200.236 159.341 200.418 158.906 200.418 158.41C200.418 158.048 200.321 157.709 200.115 157.395C199.91 157.08 199.608 156.838 199.196 156.657C198.785 156.476 198.132 156.379 197.238 156.379H196.839V160.224Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M203.792 150.321H205.218V157.54C205.218 158.495 205.303 159.136 205.46 159.487C205.617 159.838 205.859 160.104 206.186 160.285C206.512 160.466 206.875 160.563 207.274 160.563C207.697 160.563 208.072 160.466 208.411 160.273C208.749 160.079 208.991 159.765 209.148 159.354C209.305 158.931 209.39 158.145 209.39 156.996V150.333H210.708V157.516C210.708 158.544 210.551 159.342 210.249 159.922C209.946 160.503 209.547 160.938 209.051 161.228C208.556 161.518 207.939 161.663 207.201 161.663C206.512 161.663 205.908 161.53 205.388 161.276C204.868 161.023 204.469 160.636 204.203 160.128C203.937 159.62 203.804 158.701 203.804 157.359V150.321H203.792Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M215.243 161.324V151.542H211.954V150.333H219.97V151.542H216.682V161.324H215.243Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M223.948 161.324V151.542H220.659V150.333H228.676V151.542H225.387V161.324H223.948Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M233.368 161.651C232.122 161.651 231.167 161.131 230.514 160.079C229.861 159.027 229.523 157.613 229.523 155.823C229.523 154.045 229.849 152.619 230.514 151.579C231.179 150.539 232.122 150.007 233.368 150.007C234.625 150.007 235.568 150.539 236.234 151.579C236.899 152.619 237.213 154.045 237.213 155.823C237.213 157.613 236.886 159.027 236.234 160.079C235.581 161.131 234.625 161.651 233.368 161.651ZM233.368 160.551C234.057 160.551 234.637 160.164 235.097 159.378C235.556 158.592 235.786 157.407 235.786 155.823C235.786 154.239 235.556 153.042 235.097 152.268C234.637 151.494 234.057 151.095 233.368 151.095C232.679 151.095 232.098 151.482 231.639 152.268C231.179 153.054 230.949 154.239 230.949 155.823C230.949 157.407 231.179 158.604 231.639 159.378C232.098 160.152 232.679 160.551 233.368 160.551Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M239.946 161.324H238.628V150.333H239.922L243.804 157.649L244.227 158.737H244.263L244.227 157.649V150.333H245.545V161.324H244.227L240.454 154.13L239.922 152.969L239.946 154.106V161.324Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M246.947 162.413V161.312H254.637V162.413H246.947Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M256.367 161.325V160.224H258.785V151.422H256.367V150.321H262.631V151.422H260.212V160.224H262.631V161.325H256.367Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M264.952 161.324V150.333H267.564C268.761 150.333 269.655 150.539 270.236 150.962C270.816 151.385 271.252 152.014 271.554 152.86C271.856 153.707 271.989 154.71 271.989 155.859C271.989 156.959 271.832 157.915 271.53 158.749C271.227 159.583 270.78 160.212 270.212 160.659C269.643 161.107 268.761 161.324 267.564 161.324H264.952ZM266.379 160.103H267.334C268.301 160.103 268.99 159.934 269.402 159.583C269.813 159.233 270.103 158.761 270.284 158.144C270.466 157.528 270.55 156.681 270.55 155.605C270.55 154.553 270.441 153.743 270.236 153.175C270.03 152.606 269.728 152.171 269.341 151.869C268.954 151.566 268.325 151.409 267.443 151.409H266.379V160.103Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M289.462 155.714V156.814H281.771V155.714H289.462ZM289.462 158.193V159.293H281.771V158.193H289.462Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M302.654 149.668V150.551C302.315 150.635 302.049 150.768 301.88 150.938C301.711 151.107 301.566 151.312 301.457 151.566C301.348 151.82 301.3 152.135 301.3 152.497C301.735 152.497 302.061 152.618 302.267 152.872C302.472 153.126 302.581 153.38 302.581 153.658C302.581 153.985 302.46 154.263 302.231 154.493C302.001 154.722 301.735 154.831 301.421 154.831C301.022 154.831 300.683 154.662 300.393 154.323C300.102 153.985 299.957 153.513 299.957 152.921C299.957 152.401 300.066 151.905 300.296 151.445C300.526 150.986 300.828 150.599 301.215 150.273C301.614 149.946 302.086 149.741 302.654 149.668ZM306.112 149.668V150.551C305.774 150.635 305.508 150.768 305.338 150.938C305.169 151.107 305.024 151.312 304.915 151.566C304.806 151.82 304.758 152.135 304.758 152.497C305.193 152.497 305.52 152.618 305.725 152.872C305.931 153.126 306.04 153.38 306.04 153.658C306.04 153.985 305.919 154.263 305.689 154.493C305.459 154.722 305.193 154.831 304.879 154.831C304.48 154.831 304.129 154.662 303.851 154.323C303.573 153.985 303.428 153.513 303.428 152.921C303.428 152.401 303.537 151.905 303.766 151.445C303.996 150.986 304.298 150.599 304.685 150.273C305.072 149.946 305.556 149.741 306.112 149.668Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M308.289 150.321H309.716V157.54C309.716 158.495 309.8 159.136 309.957 159.487C310.115 159.838 310.356 160.104 310.683 160.285C311.009 160.466 311.372 160.563 311.771 160.563C312.194 160.563 312.569 160.466 312.908 160.273C313.246 160.079 313.488 159.765 313.645 159.354C313.803 158.931 313.887 158.145 313.887 156.996V150.333H315.205V157.516C315.205 158.544 315.048 159.342 314.746 159.922C314.444 160.503 314.044 160.938 313.549 161.228C313.053 161.518 312.436 161.663 311.699 161.663C311.009 161.663 310.405 161.53 309.885 161.276C309.365 161.023 308.966 160.636 308.7 160.128C308.434 159.62 308.301 158.701 308.301 157.359V150.321H308.289Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M318.313 161.324H316.995V150.333H318.289L322.171 157.649L322.594 158.737H322.63L322.594 157.649V150.333H323.912V161.324H322.594L318.821 154.13L318.289 152.969L318.313 154.106V161.324Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M326.028 161.325V160.224H328.446V151.422H326.028V150.321H332.291V151.422H329.873V160.224H332.291V161.325H326.028Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M338.797 161.53C339.123 162.074 339.425 162.461 339.679 162.667C339.933 162.873 340.272 163.042 340.695 163.139C341.106 163.247 341.566 163.296 342.073 163.296H342.206V164.396H341.868C340.961 164.396 340.296 164.299 339.873 164.118C339.45 163.937 339.063 163.634 338.7 163.247C338.337 162.86 337.999 162.316 337.696 161.651C336.838 161.554 336.148 161.288 335.641 160.829C335.133 160.369 334.734 159.668 334.444 158.725C334.153 157.782 334.008 156.754 334.008 155.666C334.008 154.07 334.323 152.727 334.963 151.639C335.604 150.551 336.56 150.007 337.853 150.007C339.099 150.007 340.054 150.527 340.707 151.579C341.36 152.631 341.699 154.045 341.699 155.835C341.699 156.681 341.614 157.504 341.445 158.278C341.275 159.052 340.973 159.741 340.55 160.321C340.139 160.902 339.546 161.313 338.797 161.53ZM337.865 151.083C337.176 151.083 336.596 151.47 336.136 152.256C335.677 153.042 335.447 154.227 335.447 155.811C335.447 157.395 335.677 158.58 336.136 159.366C336.596 160.152 337.176 160.539 337.865 160.539C338.555 160.539 339.135 160.152 339.595 159.366C340.054 158.58 340.284 157.395 340.284 155.811C340.284 154.227 340.054 153.042 339.595 152.256C339.135 151.47 338.555 151.083 337.865 151.083Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M343.113 150.321H344.54V157.54C344.54 158.495 344.625 159.136 344.782 159.487C344.939 159.838 345.181 160.104 345.508 160.285C345.834 160.466 346.197 160.563 346.596 160.563C347.019 160.563 347.394 160.466 347.732 160.273C348.071 160.079 348.313 159.765 348.47 159.354C348.627 158.943 348.712 158.145 348.712 156.996V150.333H350.03V157.516C350.03 158.544 349.885 159.342 349.57 159.922C349.256 160.503 348.869 160.938 348.373 161.228C347.878 161.518 347.261 161.663 346.523 161.663C345.834 161.663 345.229 161.53 344.71 161.276C344.19 161.023 343.791 160.636 343.524 160.128C343.258 159.62 343.126 158.701 343.126 157.359V150.321H343.113Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M358.301 160.104V161.313H352.364V150.321H358.192V151.422H353.791V155.158H357.757V156.258H353.791V160.104H358.301Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M360.139 162.413V161.312H367.829V162.413H360.139Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M369.558 161.324V150.333H371.71C373.004 150.333 373.862 150.43 374.298 150.623C374.733 150.817 375.059 151.107 375.277 151.494C375.495 151.881 375.604 152.316 375.604 152.8C375.604 153.187 375.543 153.549 375.41 153.9C375.277 154.251 375.096 154.565 374.842 154.855C374.588 155.146 374.225 155.412 373.754 155.665C374.624 156.016 375.217 156.439 375.531 156.959C375.845 157.479 375.991 157.975 375.991 158.495C375.991 158.979 375.858 159.45 375.604 159.91C375.35 160.369 374.975 160.72 374.503 160.962C374.032 161.204 373.27 161.324 372.23 161.324H369.558ZM370.997 155.279H372.496C372.98 155.073 373.342 154.855 373.56 154.638C373.79 154.408 373.947 154.166 374.068 153.888C374.189 153.61 374.237 153.308 374.237 152.981C374.237 152.461 374.092 152.074 373.778 151.82C373.475 151.566 372.883 151.433 372 151.433H370.997V155.279ZM370.997 160.224H372.351C373.101 160.224 373.669 160.043 374.032 159.692C374.394 159.341 374.576 158.906 374.576 158.41C374.576 158.048 374.479 157.709 374.274 157.395C374.068 157.08 373.766 156.838 373.355 156.657C372.943 156.476 372.291 156.379 371.396 156.379H370.997V160.224Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M377.95 150.321H379.377V157.54C379.377 158.495 379.461 159.136 379.619 159.487C379.776 159.838 380.018 160.104 380.344 160.285C380.67 160.466 381.033 160.563 381.432 160.563C381.855 160.563 382.23 160.466 382.569 160.273C382.907 160.079 383.149 159.765 383.306 159.354C383.464 158.943 383.548 158.145 383.548 156.996V150.333H384.866V157.516C384.866 158.544 384.721 159.342 384.407 159.922C384.092 160.503 383.705 160.938 383.21 161.228C382.714 161.518 382.097 161.663 381.36 161.663C380.67 161.663 380.066 161.53 379.546 161.276C379.026 161.023 378.627 160.636 378.361 160.128C378.095 159.62 377.962 158.701 377.962 157.359V150.321H377.95Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M389.389 161.324V151.542H386.1V150.333H394.116V151.542H390.828V161.324H389.389Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M398.095 161.324V151.542H394.806V150.333H402.823V151.542H399.534V161.324H398.095Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M407.527 161.651C406.281 161.651 405.326 161.131 404.673 160.079C404.02 159.027 403.681 157.613 403.681 155.823C403.681 154.045 404.008 152.619 404.673 151.579C405.338 150.539 406.281 150.007 407.527 150.007C408.784 150.007 409.727 150.539 410.392 151.579C411.057 152.619 411.372 154.045 411.372 155.823C411.372 157.613 411.045 159.027 410.392 160.079C409.727 161.131 408.772 161.651 407.527 161.651ZM407.527 160.551C408.216 160.551 408.796 160.164 409.256 159.378C409.715 158.592 409.945 157.407 409.945 155.823C409.945 154.239 409.715 153.042 409.256 152.268C408.796 151.494 408.216 151.095 407.527 151.095C406.837 151.095 406.269 151.482 405.797 152.268C405.326 153.054 405.108 154.239 405.108 155.823C405.108 157.407 405.338 158.604 405.797 159.378C406.257 160.152 406.837 160.551 407.527 160.551Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M414.092 161.324H412.774V150.333H414.068L417.95 157.649L418.373 158.737H418.409L418.373 157.649V150.333H419.691V161.324H418.373L414.6 154.13L414.068 152.969L414.092 154.106V161.324Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M421.094 162.413V161.312H428.784V162.413H421.094Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M430.513 161.325V160.224H432.932V151.422H430.513V150.321H436.777V151.422H434.358V160.224H436.777V161.325H430.513Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M439.098 161.324V150.333H441.71C442.907 150.333 443.802 150.539 444.382 150.962C444.963 151.385 445.398 152.014 445.7 152.86C446.003 153.707 446.136 154.71 446.136 155.859C446.136 156.959 445.979 157.915 445.676 158.749C445.374 159.583 444.927 160.212 444.358 160.659C443.79 161.107 442.907 161.324 441.71 161.324H439.098ZM440.537 160.103H441.493C442.46 160.103 443.149 159.934 443.56 159.583C443.971 159.233 444.262 158.761 444.443 158.144C444.624 157.528 444.709 156.681 444.709 155.605C444.709 154.553 444.6 153.743 444.394 153.175C444.189 152.606 443.887 152.171 443.5 151.869C443.113 151.566 442.484 151.409 441.601 151.409H440.537V160.103Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M447.986 154.831V153.948C448.324 153.864 448.59 153.731 448.76 153.562C448.929 153.392 449.074 153.187 449.183 152.933C449.292 152.679 449.34 152.364 449.34 152.002C448.905 152.002 448.578 151.881 448.373 151.627C448.167 151.373 448.058 151.119 448.058 150.841C448.058 150.514 448.179 150.236 448.409 150.007C448.639 149.777 448.905 149.668 449.219 149.668C449.618 149.668 449.957 149.837 450.247 150.176C450.537 150.514 450.682 150.986 450.682 151.578C450.682 152.098 450.573 152.594 450.344 153.054C450.114 153.513 449.812 153.9 449.425 154.227C449.026 154.553 448.554 154.759 447.986 154.831ZM451.456 154.831V153.948C451.795 153.864 452.049 153.731 452.23 153.562C452.411 153.392 452.557 153.187 452.665 152.933C452.774 152.679 452.823 152.364 452.823 152.002C452.387 152.002 452.061 151.881 451.855 151.627C451.65 151.373 451.541 151.119 451.541 150.841C451.541 150.514 451.662 150.236 451.891 150.007C452.121 149.777 452.387 149.668 452.689 149.668C453.088 149.668 453.439 149.837 453.729 150.176C454.02 150.514 454.165 150.986 454.165 151.578C454.165 152.098 454.056 152.594 453.826 153.054C453.596 153.513 453.294 153.9 452.907 154.227C452.496 154.553 452.012 154.759 451.456 154.831Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M458.421 164.397V163.514C458.76 163.429 459.026 163.296 459.195 163.127C459.364 162.958 459.51 162.752 459.618 162.486C459.727 162.22 459.776 161.918 459.776 161.555C459.34 161.555 459.014 161.434 458.808 161.18C458.603 160.926 458.494 160.672 458.494 160.382C458.494 160.056 458.615 159.778 458.844 159.56C459.074 159.342 459.34 159.221 459.655 159.221C460.054 159.221 460.392 159.391 460.682 159.729C460.973 160.068 461.118 160.539 461.118 161.132C461.118 161.652 461.009 162.135 460.779 162.607C460.549 163.079 460.247 163.466 459.86 163.792C459.473 164.119 458.99 164.324 458.421 164.397ZM459.655 155.497C459.34 155.497 459.062 155.388 458.844 155.158C458.627 154.929 458.506 154.663 458.506 154.348C458.506 154.022 458.627 153.756 458.857 153.526C459.086 153.296 459.352 153.188 459.667 153.188C459.981 153.188 460.247 153.296 460.477 153.526C460.707 153.756 460.815 154.022 460.815 154.348C460.815 154.663 460.707 154.941 460.477 155.158C460.247 155.376 459.969 155.497 459.655 155.497Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M148.254 200.66C147.855 201.313 147.371 201.821 146.803 202.147C146.235 202.486 145.715 202.643 145.243 202.643C144.578 202.643 143.986 202.353 143.466 201.785C142.946 201.216 142.68 200.346 142.68 199.185C142.68 198.266 142.849 197.456 143.2 196.73C143.55 196.005 144.022 195.436 144.602 195.025C145.183 194.602 145.908 194.396 146.779 194.396C147.033 194.396 147.407 194.421 147.915 194.469C147.988 194.481 148.109 194.493 148.254 194.505H149.572V200.092C149.572 201.047 149.669 201.821 149.874 202.413H148.496C148.399 202.002 148.314 201.41 148.254 200.66ZM148.254 199.088V195.69C147.782 195.569 147.347 195.509 146.948 195.509C146.138 195.509 145.461 195.823 144.917 196.452C144.372 197.081 144.106 197.939 144.106 199.016C144.106 199.802 144.251 200.394 144.554 200.793C144.844 201.192 145.183 201.398 145.57 201.398C145.981 201.398 146.44 201.192 146.936 200.769C147.432 200.346 147.867 199.789 148.254 199.088Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M151.845 202.014V200.623C152.377 200.974 152.933 201.216 153.526 201.349C154.118 201.482 154.614 201.554 155.025 201.554C155.69 201.554 156.174 201.446 156.464 201.228C156.754 201.01 156.899 200.744 156.899 200.418C156.899 200.2 156.827 200.019 156.694 199.874C156.561 199.729 156.222 199.535 155.678 199.317L155.219 199.136L154.3 198.773C153.32 198.386 152.704 198.036 152.438 197.709C152.184 197.383 152.051 196.996 152.051 196.536C152.051 195.883 152.305 195.351 152.8 194.928C153.308 194.505 154.118 194.299 155.255 194.299C156.101 194.299 156.899 194.42 157.661 194.662V195.859C156.791 195.545 155.968 195.388 155.207 195.388C154.65 195.388 154.215 195.484 153.901 195.678C153.586 195.871 153.429 196.113 153.429 196.415C153.429 196.693 153.562 196.923 153.84 197.093C154.106 197.262 154.554 197.455 155.158 197.685L156.053 198.012C156.875 198.314 157.444 198.628 157.77 198.979C158.097 199.33 158.266 199.765 158.266 200.285C158.266 200.974 158 201.53 157.48 201.978C156.96 202.425 156.114 202.643 154.953 202.643C153.949 202.655 152.909 202.437 151.845 202.014Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M163.381 202.122L159.729 194.517H161.18L164.094 200.466L166.524 194.517H167.855L164.795 201.868C164.142 203.416 163.538 204.444 162.945 204.952C162.365 205.46 161.603 205.714 160.684 205.714C160.285 205.714 159.922 205.677 159.608 205.605V204.444C159.971 204.553 160.321 204.613 160.648 204.613C161.071 204.613 161.446 204.529 161.784 204.371C162.123 204.214 162.413 203.912 162.691 203.501C162.969 203.078 163.163 202.715 163.272 202.413L163.381 202.122Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M169.173 202.437V194.529H170.491V196.258C170.866 195.653 171.325 195.17 171.857 194.831C172.389 194.492 172.921 194.311 173.453 194.311C173.925 194.311 174.348 194.432 174.723 194.686C175.098 194.94 175.376 195.254 175.533 195.665C175.69 196.076 175.763 196.85 175.763 198.035V202.461H174.445V197.878C174.445 197.116 174.409 196.621 174.336 196.367C174.263 196.113 174.13 195.919 173.937 195.762C173.743 195.605 173.526 195.532 173.296 195.532C172.837 195.532 172.341 195.75 171.809 196.185C171.277 196.621 170.841 197.177 170.491 197.842V202.449H169.173V202.437Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M184.542 202.207C183.659 202.509 182.813 202.654 182.014 202.654C181.216 202.654 180.515 202.473 179.898 202.11C179.282 201.748 178.798 201.252 178.459 200.623C178.121 199.994 177.939 199.281 177.939 198.483C177.939 197.286 178.326 196.282 179.112 195.496C179.898 194.71 180.842 194.311 181.942 194.311C182.764 194.311 183.623 194.468 184.53 194.771V196.04C183.611 195.617 182.788 195.411 182.063 195.411C181.579 195.411 181.132 195.532 180.709 195.774C180.285 196.016 179.959 196.379 179.729 196.887C179.499 197.394 179.378 197.914 179.378 198.446C179.378 199.16 179.596 199.837 180.043 200.49C180.491 201.143 181.192 201.457 182.147 201.457C182.438 201.457 182.716 201.433 182.994 201.397C183.272 201.361 183.792 201.203 184.542 200.949V202.207Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M197.129 202.437V196.27H195.376V195.17H197.129V194.807C197.129 193.767 197.25 192.993 197.48 192.497C197.721 192.002 198.084 191.59 198.58 191.264C199.076 190.937 199.729 190.78 200.539 190.78C201.155 190.78 201.772 190.841 202.413 190.974V192.219C201.724 191.989 201.119 191.881 200.587 191.881C200.164 191.881 199.801 191.953 199.475 192.11C199.148 192.268 198.906 192.521 198.725 192.872C198.544 193.223 198.447 193.815 198.447 194.662V195.17H201.591V196.27H198.447V202.437H197.129Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M210.515 194.516V202.424H209.197V200.683C208.774 201.336 208.302 201.82 207.782 202.146C207.262 202.473 206.742 202.63 206.222 202.63C205.763 202.63 205.34 202.509 204.953 202.255C204.566 202.001 204.3 201.687 204.143 201.276C203.985 200.865 203.913 200.079 203.913 198.918V194.492H205.231V199.075C205.231 199.837 205.267 200.333 205.34 200.586C205.412 200.84 205.545 201.034 205.739 201.191C205.932 201.348 206.15 201.421 206.367 201.421C206.827 201.421 207.323 201.203 207.855 200.768C208.387 200.333 208.822 199.776 209.173 199.111V194.504H210.515V194.516Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M212.703 202.437V194.529H214.021V196.258C214.396 195.653 214.856 195.17 215.388 194.831C215.92 194.492 216.452 194.311 216.984 194.311C217.455 194.311 217.879 194.432 218.253 194.686C218.628 194.94 218.906 195.254 219.064 195.665C219.221 196.076 219.293 196.85 219.293 198.035V202.461H217.975V197.878C217.975 197.116 217.939 196.621 217.866 196.367C217.794 196.113 217.661 195.919 217.467 195.762C217.274 195.605 217.056 195.532 216.827 195.532C216.367 195.532 215.871 195.75 215.339 196.185C214.807 196.621 214.372 197.177 214.021 197.842V202.449H212.703V202.437Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M228.072 202.207C227.189 202.509 226.343 202.654 225.545 202.654C224.747 202.654 224.046 202.473 223.429 202.11C222.812 201.748 222.329 201.252 221.99 200.623C221.651 199.994 221.47 199.281 221.47 198.483C221.47 197.286 221.857 196.282 222.643 195.496C223.429 194.71 224.372 194.311 225.472 194.311C226.295 194.311 227.153 194.468 228.06 194.771V196.04C227.141 195.617 226.319 195.411 225.593 195.411C225.11 195.411 224.662 195.532 224.239 195.774C223.816 196.016 223.489 196.379 223.26 196.887C223.03 197.394 222.909 197.914 222.909 198.446C222.909 199.16 223.127 199.837 223.574 200.49C224.021 201.143 224.723 201.457 225.678 201.457C225.968 201.457 226.246 201.433 226.524 201.397C226.803 201.361 227.322 201.203 228.072 200.949V202.207Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M236.742 202.11C236.125 202.364 235.678 202.522 235.4 202.57C235.122 202.618 234.856 202.643 234.59 202.643C234.033 202.643 233.526 202.534 233.078 202.328C232.631 202.123 232.268 201.796 232.038 201.385C231.808 200.974 231.688 200.321 231.688 199.462V196.27H229.717V195.17H231.688V191.978H232.993V195.17H236.512V196.27H232.993V199.438C232.993 200.079 233.066 200.526 233.223 200.792C233.38 201.058 233.574 201.252 233.828 201.373C234.082 201.494 234.384 201.554 234.723 201.554C235.363 201.554 236.029 201.349 236.73 200.95V202.11H236.742Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M241.046 202.437V195.617H238.846V194.517H242.364V201.336H244.565V202.437H241.046ZM240.829 191.663C240.829 191.361 240.925 191.143 241.131 190.998C241.336 190.853 241.53 190.78 241.699 190.78C241.881 190.78 242.074 190.853 242.28 190.998C242.485 191.143 242.582 191.361 242.582 191.663C242.582 191.953 242.485 192.171 242.28 192.316C242.074 192.461 241.881 192.534 241.699 192.534C241.518 192.534 241.324 192.461 241.131 192.316C240.937 192.171 240.829 191.953 240.829 191.663Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M250.792 202.655C249.656 202.655 248.749 202.256 248.072 201.47C247.395 200.684 247.056 199.68 247.056 198.471C247.056 197.262 247.395 196.27 248.072 195.484C248.749 194.698 249.656 194.299 250.792 194.299C251.917 194.299 252.824 194.698 253.501 195.484C254.178 196.27 254.517 197.274 254.517 198.471C254.517 199.668 254.178 200.672 253.501 201.47C252.824 202.256 251.917 202.655 250.792 202.655ZM250.792 201.554C251.494 201.554 252.05 201.276 252.473 200.732C252.884 200.188 253.09 199.426 253.09 198.471C253.09 197.516 252.884 196.766 252.473 196.222C252.062 195.678 251.494 195.4 250.792 195.4C250.091 195.4 249.523 195.678 249.112 196.222C248.701 196.766 248.495 197.516 248.495 198.471C248.495 199.426 248.701 200.188 249.112 200.732C249.523 201.276 250.091 201.554 250.792 201.554Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M256.246 202.437V194.529H257.564V196.258C257.939 195.653 258.398 195.17 258.93 194.831C259.462 194.492 259.994 194.311 260.526 194.311C260.998 194.311 261.421 194.432 261.796 194.686C262.171 194.94 262.449 195.254 262.606 195.665C262.763 196.076 262.836 196.85 262.836 198.035V202.461H261.518V197.878C261.518 197.116 261.482 196.621 261.409 196.367C261.336 196.113 261.203 195.919 261.01 195.762C260.816 195.605 260.599 195.532 260.369 195.532C259.91 195.532 259.414 195.75 258.882 196.185C258.35 196.621 257.914 197.177 257.564 197.842V202.449H256.246V202.437Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M275.883 202.437V195.617H273.682V194.517H277.201V201.336H279.402V202.437H275.883ZM275.665 191.663C275.665 191.361 275.762 191.143 275.968 190.998C276.173 190.853 276.367 190.78 276.536 190.78C276.717 190.78 276.911 190.853 277.116 190.998C277.322 191.143 277.419 191.361 277.419 191.663C277.419 191.953 277.322 192.171 277.116 192.316C276.911 192.461 276.717 192.534 276.536 192.534C276.355 192.534 276.161 192.461 275.968 192.316C275.774 192.171 275.665 191.953 275.665 191.663Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M282.364 202.437V194.529H283.682V196.258C284.057 195.653 284.517 195.17 285.049 194.831C285.581 194.492 286.113 194.311 286.645 194.311C287.116 194.311 287.54 194.432 287.914 194.686C288.289 194.94 288.567 195.254 288.725 195.665C288.882 196.076 288.954 196.85 288.954 198.035V202.461H287.636V197.878C287.636 197.116 287.6 196.621 287.527 196.367C287.455 196.113 287.322 195.919 287.128 195.762C286.935 195.605 286.717 195.532 286.488 195.532C286.028 195.532 285.532 195.75 285 196.185C284.468 196.621 284.033 197.177 283.682 197.842V202.449H282.364V202.437Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M293.295 202.437V195.617H291.094V194.517H294.613V201.336H296.813V202.437H293.295ZM293.077 191.663C293.077 191.361 293.174 191.143 293.379 190.998C293.585 190.853 293.778 190.78 293.948 190.78C294.129 190.78 294.323 190.853 294.528 190.998C294.734 191.143 294.83 191.361 294.83 191.663C294.83 191.953 294.734 192.171 294.528 192.316C294.323 192.461 294.129 192.534 293.948 192.534C293.766 192.534 293.573 192.461 293.379 192.316C293.186 192.171 293.077 191.953 293.077 191.663Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M306.402 202.11C305.786 202.364 305.338 202.522 305.06 202.57C304.782 202.618 304.516 202.643 304.25 202.643C303.694 202.643 303.186 202.534 302.739 202.328C302.291 202.123 301.928 201.796 301.699 201.385C301.469 200.974 301.348 200.321 301.348 199.462V196.27H299.377V195.17H301.348V191.978H302.666V195.17H306.185V196.27H302.666V199.438C302.666 200.079 302.739 200.526 302.896 200.792C303.053 201.058 303.246 201.252 303.5 201.373C303.754 201.494 304.057 201.554 304.395 201.554C305.036 201.554 305.701 201.349 306.402 200.95V202.11Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M314.988 205.073C313.682 204.988 312.582 204.625 311.675 203.96C310.768 203.295 310.067 202.413 309.522 201.288C308.978 200.164 308.712 199.051 308.712 197.926C308.712 196.802 308.978 195.677 309.522 194.565C310.067 193.453 310.78 192.558 311.675 191.893C312.57 191.228 313.67 190.865 314.988 190.78V191.881C313.996 191.965 313.15 192.304 312.437 192.872C311.723 193.453 311.167 194.178 310.756 195.061C310.345 195.943 310.151 196.899 310.151 197.914C310.151 198.93 310.357 199.885 310.756 200.768C311.167 201.651 311.723 202.388 312.437 202.957C313.15 203.525 313.996 203.864 314.988 203.96V205.073Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M317.213 190.78C318.518 190.865 319.619 191.24 320.526 191.893C321.433 192.546 322.134 193.44 322.678 194.565C323.222 195.69 323.488 196.802 323.488 197.926C323.488 199.051 323.222 200.176 322.678 201.288C322.134 202.401 321.42 203.295 320.526 203.96C319.631 204.625 318.531 204.988 317.213 205.073V203.972C318.204 203.876 319.05 203.549 319.764 202.969C320.477 202.388 321.034 201.663 321.445 200.78C321.856 199.897 322.061 198.942 322.061 197.926C322.061 196.911 321.856 195.956 321.445 195.073C321.034 194.19 320.477 193.453 319.764 192.884C319.05 192.316 318.204 191.977 317.213 191.893V190.78Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M337.394 197.926C337.829 198.156 338.156 198.386 338.361 198.603C338.567 198.821 338.724 199.051 338.821 199.293C338.918 199.522 338.966 199.8 338.966 200.103C338.966 200.369 338.918 200.719 338.821 201.155L338.64 201.965C338.543 202.4 338.494 202.727 338.494 202.944C338.494 203.234 338.603 203.476 338.833 203.682C339.063 203.887 339.522 203.984 340.224 203.984H341.324V205.085H340.211C338.918 205.085 338.083 204.879 337.708 204.456C337.334 204.045 337.152 203.573 337.152 203.041C337.152 202.763 337.188 202.461 337.261 202.146L337.394 201.578L337.515 200.961L337.6 200.586C337.636 200.417 337.648 200.236 337.648 200.079C337.648 199.643 337.503 199.268 337.201 198.954C336.898 198.64 336.39 198.482 335.641 198.482H335.012V197.382H335.641C336.378 197.382 336.898 197.225 337.188 196.923C337.479 196.62 337.636 196.233 337.636 195.774C337.636 195.605 337.624 195.435 337.588 195.278L337.503 194.915L337.382 194.299L337.249 193.73C337.176 193.404 337.14 193.102 337.14 192.823C337.14 192.303 337.322 191.832 337.696 191.421C338.071 190.998 338.905 190.792 340.199 190.792H341.312V191.892H340.211C339.522 191.892 339.051 191.989 338.833 192.195C338.615 192.4 338.494 192.642 338.494 192.932C338.494 193.138 338.543 193.464 338.64 193.912L338.821 194.722C338.918 195.157 338.966 195.508 338.966 195.774C338.966 196.076 338.918 196.342 338.821 196.584C338.724 196.814 338.567 197.043 338.361 197.273C338.156 197.503 337.829 197.696 337.394 197.926Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M167.117 222.763C166.234 223.065 165.388 223.211 164.59 223.211C163.792 223.211 163.091 223.029 162.474 222.666C161.857 222.304 161.374 221.808 161.035 221.179C160.696 220.55 160.515 219.837 160.515 219.039C160.515 217.842 160.902 216.838 161.688 216.052C162.474 215.266 163.417 214.867 164.517 214.867C165.34 214.867 166.198 215.024 167.105 215.327V216.596C166.186 216.173 165.364 215.968 164.638 215.968C164.155 215.968 163.707 216.088 163.284 216.33C162.861 216.572 162.534 216.935 162.305 217.443C162.075 217.951 161.954 218.471 161.954 219.003C161.954 219.716 162.172 220.393 162.619 221.046C163.066 221.699 163.768 222.013 164.723 222.013C165.013 222.013 165.291 221.989 165.569 221.953C165.847 221.917 166.367 221.76 167.117 221.506V222.763Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M172.425 223.21C171.289 223.21 170.382 222.811 169.705 222.025C169.028 221.239 168.689 220.236 168.689 219.027C168.689 217.817 169.028 216.826 169.705 216.04C170.382 215.254 171.289 214.855 172.425 214.855C173.55 214.855 174.457 215.254 175.134 216.04C175.811 216.826 176.15 217.83 176.15 219.027C176.15 220.224 175.811 221.227 175.134 222.025C174.457 222.811 173.55 223.21 172.425 223.21ZM172.425 222.11C173.127 222.11 173.683 221.832 174.106 221.288C174.517 220.744 174.723 219.982 174.723 219.027C174.723 218.071 174.517 217.322 174.106 216.778C173.695 216.233 173.127 215.955 172.425 215.955C171.724 215.955 171.156 216.233 170.745 216.778C170.334 217.322 170.128 218.071 170.128 219.027C170.128 219.982 170.334 220.744 170.745 221.288C171.156 221.832 171.712 222.11 172.425 222.11Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M177.878 222.993V215.085H179.196V216.814C179.571 216.209 180.031 215.726 180.563 215.387C181.095 215.049 181.627 214.867 182.159 214.867C182.63 214.867 183.054 214.988 183.428 215.242C183.803 215.496 184.081 215.81 184.239 216.221C184.396 216.633 184.468 217.406 184.468 218.591V223.017H183.15V218.434C183.15 217.673 183.114 217.177 183.042 216.923C182.969 216.669 182.836 216.475 182.642 216.318C182.449 216.161 182.231 216.088 182.002 216.088C181.542 216.088 181.046 216.306 180.514 216.741C179.982 217.177 179.547 217.733 179.196 218.398V223.005H177.878V222.993Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M186.682 222.57V221.179C187.214 221.53 187.77 221.772 188.363 221.905C188.955 222.038 189.451 222.11 189.862 222.11C190.527 222.11 191.011 222.001 191.301 221.784C191.591 221.566 191.736 221.3 191.736 220.973C191.736 220.756 191.664 220.574 191.531 220.429C191.398 220.284 191.059 220.091 190.515 219.873L190.056 219.692L189.137 219.329C188.157 218.942 187.541 218.591 187.274 218.265C187.021 217.938 186.888 217.551 186.888 217.092C186.888 216.439 187.141 215.907 187.637 215.484C188.145 215.061 188.955 214.855 190.092 214.855C190.938 214.855 191.736 214.976 192.498 215.218V216.415C191.628 216.1 190.805 215.943 190.043 215.943C189.487 215.943 189.052 216.04 188.738 216.233C188.423 216.427 188.266 216.669 188.266 216.971C188.266 217.249 188.399 217.479 188.677 217.648C188.943 217.818 189.391 218.011 189.995 218.241L190.89 218.567C191.712 218.869 192.28 219.184 192.607 219.535C192.933 219.885 193.103 220.32 193.103 220.84C193.103 221.53 192.837 222.086 192.317 222.533C191.797 222.981 190.95 223.198 189.79 223.198C188.786 223.21 187.746 222.993 186.682 222.57Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M201.905 222.667C201.288 222.921 200.841 223.078 200.563 223.127C200.285 223.175 200.019 223.199 199.753 223.199C199.196 223.199 198.689 223.09 198.241 222.885C197.794 222.679 197.431 222.353 197.201 221.942C196.972 221.53 196.851 220.878 196.851 220.019V216.827H194.88V215.726H196.851V212.534H198.169V215.726H201.687V216.827H198.169V219.995C198.169 220.636 198.241 221.083 198.398 221.349C198.556 221.615 198.749 221.809 199.003 221.929C199.257 222.05 199.559 222.111 199.898 222.111C200.539 222.111 201.204 221.905 201.905 221.506V222.667Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M213.38 222.993V215.085H214.698V216.814C215.109 216.161 215.581 215.677 216.113 215.351C216.645 215.024 217.238 214.867 217.891 214.867C218.362 214.867 218.846 214.94 219.317 215.085V217.939H218.048V216.137C217.83 216.101 217.649 216.076 217.528 216.076C217.032 216.076 216.56 216.27 216.077 216.657C215.593 217.044 215.146 217.624 214.698 218.398V222.993H213.38Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M224.674 223.21C223.538 223.21 222.631 222.811 221.954 222.025C221.277 221.239 220.938 220.236 220.938 219.027C220.938 217.817 221.277 216.826 221.954 216.04C222.631 215.254 223.538 214.855 224.674 214.855C225.799 214.855 226.706 215.254 227.383 216.04C228.06 216.826 228.399 217.83 228.399 219.027C228.399 220.224 228.06 221.227 227.383 222.025C226.706 222.811 225.799 223.21 224.674 223.21ZM224.674 222.11C225.376 222.11 225.932 221.832 226.355 221.288C226.766 220.744 226.972 219.982 226.972 219.027C226.972 218.071 226.766 217.322 226.355 216.778C225.944 216.233 225.376 215.955 224.674 215.955C223.973 215.955 223.405 216.233 222.994 216.778C222.582 217.322 222.377 218.071 222.377 219.027C222.377 219.982 222.582 220.744 222.994 221.288C223.405 221.832 223.961 222.11 224.674 222.11Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M233.38 223.21C232.243 223.21 231.336 222.811 230.659 222.025C229.982 221.239 229.644 220.236 229.644 219.027C229.644 217.817 229.982 216.826 230.659 216.04C231.336 215.254 232.243 214.855 233.38 214.855C234.504 214.855 235.411 215.254 236.089 216.04C236.766 216.826 237.104 217.83 237.104 219.027C237.104 220.224 236.766 221.227 236.089 222.025C235.411 222.811 234.504 223.21 233.38 223.21ZM233.38 222.11C234.081 222.11 234.638 221.832 235.061 221.288C235.472 220.744 235.677 219.982 235.677 219.027C235.677 218.071 235.472 217.322 235.061 216.778C234.65 216.233 234.081 215.955 233.38 215.955C232.679 215.955 232.11 216.233 231.699 216.778C231.288 217.322 231.082 218.071 231.082 219.027C231.082 219.982 231.288 220.744 231.699 221.288C232.11 221.832 232.667 222.11 233.38 222.11Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M245.448 222.667C244.831 222.921 244.384 223.078 244.106 223.127C243.828 223.175 243.562 223.199 243.296 223.199C242.739 223.199 242.232 223.09 241.784 222.885C241.337 222.679 240.974 222.353 240.744 221.942C240.514 221.53 240.394 220.878 240.394 220.019V216.827H238.423V215.726H240.394V212.534H241.712V215.726H245.23V216.827H241.712V219.995C241.712 220.636 241.784 221.083 241.941 221.349C242.099 221.615 242.292 221.809 242.546 221.929C242.8 222.05 243.102 222.111 243.441 222.111C244.082 222.111 244.747 221.905 245.448 221.506V222.667Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M263.344 217.383V218.483H255.653V217.383H263.344ZM263.344 219.862V220.962H255.653V219.862H263.344Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M278.954 221.203C278.555 221.868 278.071 222.364 277.503 222.703C276.935 223.041 276.415 223.211 275.943 223.211C275.278 223.211 274.686 222.92 274.153 222.352C273.621 221.784 273.368 220.913 273.368 219.752C273.368 218.833 273.537 218.023 273.887 217.298C274.238 216.572 274.71 216.004 275.29 215.593C275.871 215.182 276.596 214.964 277.467 214.964C277.721 214.964 278.095 214.988 278.603 215.037C278.676 215.049 278.797 215.061 278.942 215.073V211.554H280.26V222.993H278.942V221.203H278.954ZM278.954 219.644V216.246C278.482 216.125 278.047 216.064 277.648 216.064C276.838 216.064 276.161 216.379 275.617 217.008C275.072 217.636 274.806 218.495 274.806 219.571C274.806 220.357 274.952 220.95 275.254 221.349C275.544 221.748 275.883 221.953 276.27 221.953C276.681 221.953 277.14 221.748 277.636 221.324C278.132 220.901 278.555 220.345 278.954 219.644Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M285.617 223.21C284.48 223.21 283.574 222.811 282.896 222.025C282.219 221.239 281.881 220.236 281.881 219.027C281.881 217.817 282.219 216.826 282.896 216.04C283.574 215.254 284.48 214.855 285.617 214.855C286.742 214.855 287.648 215.254 288.326 216.04C289.003 216.826 289.341 217.83 289.341 219.027C289.341 220.224 289.003 221.227 288.326 222.025C287.648 222.811 286.754 223.21 285.617 223.21ZM285.617 222.11C286.318 222.11 286.875 221.832 287.298 221.288C287.709 220.744 287.914 219.982 287.914 219.027C287.914 218.071 287.709 217.322 287.298 216.778C286.887 216.233 286.318 215.955 285.617 215.955C284.916 215.955 284.347 216.233 283.936 216.778C283.525 217.322 283.32 218.071 283.32 219.027C283.32 219.982 283.525 220.744 283.936 221.288C284.359 221.832 284.916 222.11 285.617 222.11Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M297.733 222.763C296.85 223.065 296.003 223.211 295.205 223.211C294.407 223.211 293.706 223.029 293.089 222.666C292.473 222.304 291.989 221.808 291.65 221.179C291.312 220.55 291.13 219.837 291.13 219.039C291.13 217.842 291.517 216.838 292.303 216.052C293.089 215.266 294.033 214.867 295.133 214.867C295.955 214.867 296.814 215.024 297.721 215.327V216.596C296.802 216.173 295.979 215.968 295.254 215.968C294.77 215.968 294.323 216.088 293.899 216.33C293.476 216.572 293.15 216.935 292.92 217.443C292.69 217.951 292.569 218.471 292.569 219.003C292.569 219.716 292.787 220.393 293.234 221.046C293.682 221.699 294.383 222.013 295.338 222.013C295.629 222.013 295.907 221.989 296.185 221.953C296.463 221.917 296.983 221.76 297.733 221.506V222.763Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M306.294 215.073V222.981H304.976V221.24C304.553 221.893 304.081 222.376 303.561 222.703C303.041 223.029 302.521 223.187 302.001 223.187C301.542 223.187 301.119 223.066 300.732 222.812C300.345 222.558 300.079 222.243 299.922 221.832C299.764 221.421 299.692 220.635 299.692 219.474V215.049H301.01V219.632C301.01 220.393 301.046 220.889 301.119 221.143C301.191 221.397 301.324 221.591 301.518 221.748C301.711 221.905 301.929 221.977 302.147 221.977C302.606 221.977 303.102 221.76 303.634 221.324C304.166 220.889 304.601 220.333 304.952 219.668V215.061H306.294V215.073Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M307.89 222.993V215.085H309.051V216.899C309.414 216.125 309.752 215.593 310.067 215.303C310.381 215.012 310.695 214.867 311.022 214.867C311.409 214.867 311.711 215.012 311.941 215.315C312.171 215.617 312.292 216.04 312.292 216.596V217.02C312.449 216.536 312.63 216.149 312.86 215.847C313.09 215.544 313.307 215.302 313.549 215.133C313.791 214.964 314.057 214.867 314.359 214.867C314.698 214.867 314.988 215.012 315.23 215.303C315.472 215.593 315.593 216.161 315.593 217.02V223.005H314.432V217.6C314.432 217.153 314.42 216.85 314.383 216.693C314.347 216.536 314.299 216.403 314.214 216.318C314.129 216.234 314.033 216.185 313.936 216.185C313.694 216.185 313.428 216.379 313.15 216.754C312.872 217.128 312.582 217.757 312.292 218.616V223.005H311.191V217.612C311.191 216.911 311.119 216.5 310.986 216.379C310.853 216.258 310.732 216.197 310.611 216.197C310.369 216.197 310.115 216.403 309.837 216.826C309.559 217.249 309.293 217.781 309.039 218.446V223.017H307.89V222.993Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M323.779 222.461C322.727 222.956 321.723 223.21 320.792 223.21C320.079 223.21 319.438 223.029 318.882 222.678C318.325 222.328 317.866 221.82 317.527 221.155C317.189 220.49 317.02 219.788 317.02 219.039C317.02 218.313 317.177 217.624 317.503 216.959C317.83 216.294 318.277 215.774 318.845 215.399C319.426 215.024 320.067 214.843 320.768 214.843C321.711 214.843 322.461 215.181 323.029 215.846C323.598 216.511 323.888 217.551 323.888 218.942V219.22H318.434C318.434 219.764 318.543 220.272 318.773 220.731C319.003 221.191 319.305 221.53 319.68 221.759C320.055 221.989 320.478 222.098 320.949 222.098C321.796 222.098 322.739 221.82 323.767 221.239V222.461H323.779ZM318.519 218.253H322.461V218.059C322.461 217.418 322.304 216.898 321.989 216.524C321.675 216.149 321.252 215.955 320.72 215.955C320.188 215.955 319.728 216.149 319.329 216.536C318.93 216.923 318.676 217.491 318.519 218.253Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M325.907 222.993V215.085H327.225V216.814C327.6 216.209 328.059 215.726 328.591 215.387C329.123 215.049 329.655 214.867 330.187 214.867C330.659 214.867 331.082 214.988 331.457 215.242C331.832 215.496 332.11 215.81 332.267 216.221C332.424 216.633 332.497 217.406 332.497 218.591V223.017H331.179V218.434C331.179 217.673 331.142 217.177 331.07 216.923C330.997 216.669 330.864 216.475 330.671 216.318C330.477 216.161 330.26 216.088 330.03 216.088C329.571 216.088 329.075 216.306 328.543 216.741C328.011 217.177 327.575 217.733 327.225 218.398V223.005H325.907V222.993Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M341.227 222.667C340.61 222.921 340.163 223.078 339.885 223.127C339.607 223.175 339.341 223.199 339.075 223.199C338.518 223.199 338.011 223.09 337.563 222.885C337.116 222.679 336.753 222.353 336.523 221.942C336.294 221.53 336.173 220.878 336.173 220.019V216.827H334.202V215.726H336.173V212.534H337.491V215.726H341.009V216.827H337.491V219.995C337.491 220.636 337.563 221.083 337.72 221.349C337.878 221.615 338.071 221.809 338.325 221.929C338.579 222.05 338.881 222.111 339.22 222.111C339.861 222.111 340.526 221.905 341.227 221.506V222.667Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M346.571 223.319C346.257 223.319 345.979 223.21 345.761 222.981C345.544 222.751 345.423 222.485 345.423 222.171C345.423 221.844 345.544 221.578 345.773 221.348C346.003 221.119 346.269 221.01 346.584 221.01C346.898 221.01 347.164 221.119 347.394 221.348C347.623 221.578 347.732 221.844 347.732 222.171C347.732 222.485 347.623 222.763 347.394 222.981C347.164 223.198 346.886 223.319 346.571 223.319Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M357.322 221.203C356.922 221.868 356.439 222.364 355.87 222.703C355.302 223.041 354.782 223.21 354.311 223.21C353.646 223.21 353.053 222.92 352.521 222.352C351.989 221.784 351.735 220.913 351.735 219.752C351.735 218.833 351.904 218.023 352.255 217.298C352.606 216.572 353.077 216.004 353.658 215.593C354.238 215.182 354.976 214.964 355.834 214.964C356.088 214.964 356.463 214.988 356.971 215.036C357.043 215.049 357.164 215.061 357.309 215.073H358.627V220.671C358.627 222.001 358.615 222.811 358.579 223.114C358.543 223.404 358.494 223.706 358.41 224.009C358.216 224.71 357.793 225.266 357.116 225.677C356.439 226.088 355.629 226.282 354.673 226.282C353.718 226.282 352.739 226.04 351.759 225.544V224.214C352.134 224.468 352.594 224.698 353.138 224.891C353.682 225.085 354.214 225.181 354.722 225.181C355.121 225.181 355.508 225.121 355.858 224.988C356.221 224.855 356.511 224.674 356.729 224.432C356.947 224.19 357.104 223.912 357.189 223.597C357.273 223.283 357.309 222.86 357.309 222.328V221.203H357.322ZM357.322 219.643V216.246C356.85 216.125 356.415 216.064 356.016 216.064C355.205 216.064 354.528 216.379 353.984 217.007C353.44 217.636 353.174 218.495 353.174 219.571C353.174 220.357 353.319 220.949 353.621 221.348C353.924 221.747 354.25 221.953 354.637 221.953C355.048 221.953 355.508 221.747 356.003 221.324C356.487 220.901 356.922 220.345 357.322 219.643Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M367.321 222.461C366.269 222.956 365.266 223.21 364.335 223.21C363.621 223.21 362.98 223.029 362.424 222.678C361.868 222.328 361.408 221.82 361.07 221.155C360.731 220.49 360.562 219.788 360.562 219.039C360.562 218.313 360.719 217.624 361.046 216.959C361.372 216.294 361.82 215.774 362.388 215.399C362.968 215.024 363.609 214.843 364.31 214.843C365.254 214.843 366.003 215.181 366.572 215.846C367.14 216.511 367.43 217.551 367.43 218.942V219.22H361.977C361.977 219.764 362.098 220.272 362.327 220.731C362.557 221.191 362.859 221.53 363.234 221.759C363.609 221.989 364.032 222.098 364.504 222.098C365.35 222.098 366.294 221.82 367.321 221.239V222.461ZM362.049 218.253H366.003V218.059C366.003 217.418 365.846 216.898 365.532 216.524C365.217 216.149 364.794 215.955 364.262 215.955C363.73 215.955 363.271 216.149 362.884 216.536C362.497 216.923 362.206 217.491 362.049 218.253Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M376.064 222.667C375.447 222.921 375 223.078 374.722 223.127C374.444 223.175 374.177 223.199 373.911 223.199C373.355 223.199 372.847 223.09 372.4 222.885C371.953 222.679 371.602 222.353 371.36 221.942C371.118 221.53 371.009 220.878 371.009 220.019V216.827H369.038V215.726H371.009V212.534H372.327V215.726H375.846V216.827H372.327V219.995C372.327 220.636 372.4 221.083 372.557 221.349C372.714 221.615 372.908 221.809 373.162 221.929C373.416 222.05 373.718 222.111 374.057 222.111C374.697 222.111 375.362 221.905 376.064 221.506V222.667Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M384.431 221.772V222.981H378.494V211.99H384.322V213.09H379.921V216.826H383.887V217.927H379.921V221.772H384.431Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M388.978 222.993V212.655H386.608V211.554H390.296V221.893H392.762V222.993H388.978Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M402.145 222.461C401.093 222.956 400.089 223.21 399.158 223.21C398.445 223.21 397.804 223.029 397.248 222.678C396.692 222.328 396.232 221.82 395.893 221.155C395.555 220.49 395.386 219.788 395.386 219.039C395.386 218.313 395.543 217.624 395.869 216.959C396.196 216.294 396.643 215.774 397.211 215.399C397.792 215.024 398.433 214.843 399.134 214.843C400.077 214.843 400.827 215.181 401.395 215.846C401.964 216.511 402.254 217.551 402.254 218.942V219.22H396.8C396.8 219.764 396.921 220.272 397.151 220.731C397.381 221.191 397.683 221.53 398.058 221.759C398.433 221.989 398.856 222.098 399.328 222.098C400.174 222.098 401.117 221.82 402.145 221.239V222.461ZM396.885 218.253H400.827V218.059C400.827 217.418 400.67 216.898 400.355 216.524C400.041 216.149 399.618 215.955 399.086 215.955C398.554 215.955 398.094 216.149 397.707 216.536C397.32 216.923 397.042 217.491 396.885 218.253Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M403.681 222.993V215.085H404.842V216.899C405.205 216.125 405.544 215.593 405.858 215.303C406.172 215.012 406.487 214.867 406.813 214.867C407.2 214.867 407.502 215.012 407.744 215.315C407.986 215.617 408.095 216.04 408.095 216.596V217.02C408.252 216.536 408.446 216.149 408.663 215.847C408.881 215.544 409.111 215.302 409.34 215.133C409.57 214.964 409.848 214.867 410.151 214.867C410.489 214.867 410.779 215.012 411.021 215.303C411.263 215.593 411.384 216.161 411.384 217.02V223.005H410.223V217.6C410.223 217.153 410.211 216.85 410.175 216.693C410.138 216.536 410.09 216.403 410.005 216.318C409.921 216.234 409.824 216.185 409.727 216.185C409.485 216.185 409.219 216.379 408.941 216.754C408.663 217.128 408.373 217.757 408.083 218.616V223.005H406.983V217.612C406.983 216.911 406.91 216.5 406.777 216.379C406.644 216.258 406.523 216.197 406.402 216.197C406.16 216.197 405.906 216.403 405.628 216.826C405.35 217.249 405.084 217.781 404.83 218.446V223.017H403.681V222.993Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M419.558 222.461C418.506 222.956 417.502 223.21 416.571 223.21C415.858 223.21 415.217 223.029 414.661 222.678C414.104 222.328 413.645 221.82 413.306 221.155C412.968 220.49 412.799 219.788 412.799 219.039C412.799 218.313 412.956 217.624 413.282 216.959C413.609 216.294 414.056 215.774 414.624 215.399C415.205 215.024 415.846 214.843 416.547 214.843C417.49 214.843 418.24 215.181 418.808 215.846C419.377 216.511 419.667 217.551 419.667 218.942V219.22H414.213C414.213 219.764 414.334 220.272 414.564 220.731C414.794 221.191 415.096 221.53 415.471 221.759C415.846 221.989 416.269 222.098 416.741 222.098C417.587 222.098 418.53 221.82 419.558 221.239V222.461ZM414.298 218.253H418.24V218.059C418.24 217.418 418.083 216.898 417.768 216.524C417.454 216.149 417.031 215.955 416.499 215.955C415.967 215.955 415.507 216.149 415.12 216.536C414.733 216.923 414.455 217.491 414.298 218.253Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M421.686 222.993V215.085H423.004V216.814C423.379 216.209 423.839 215.726 424.371 215.387C424.903 215.049 425.435 214.867 425.967 214.867C426.438 214.867 426.862 214.988 427.236 215.242C427.611 215.496 427.889 215.81 428.047 216.221C428.204 216.633 428.276 217.406 428.276 218.591V223.017H426.958V218.434C426.958 217.673 426.922 217.177 426.849 216.923C426.777 216.669 426.644 216.475 426.45 216.318C426.257 216.161 426.039 216.088 425.809 216.088C425.35 216.088 424.854 216.306 424.322 216.741C423.79 217.177 423.355 217.733 423.004 218.398V223.005H421.686V222.993Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M437.006 222.667C436.39 222.921 435.942 223.078 435.664 223.127C435.386 223.175 435.12 223.199 434.854 223.199C434.298 223.199 433.79 223.09 433.342 222.885C432.895 222.679 432.544 222.353 432.303 221.942C432.061 221.53 431.952 220.878 431.952 220.019V216.827H429.981V215.726H431.952V212.534H433.27V215.726H436.789V216.827H433.27V219.995C433.27 220.636 433.342 221.083 433.5 221.349C433.657 221.615 433.85 221.809 434.104 221.929C434.358 222.05 434.661 222.111 434.999 222.111C435.64 222.111 436.305 221.905 437.006 221.506V222.667Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M439.219 222.993V212.001H441.371C442.665 212.001 443.524 212.098 443.959 212.292C444.394 212.485 444.721 212.775 444.939 213.162C445.156 213.549 445.265 213.985 445.265 214.468C445.265 214.855 445.205 215.218 445.072 215.569C444.939 215.919 444.757 216.234 444.503 216.524C444.249 216.814 443.887 217.08 443.415 217.334C444.286 217.685 444.878 218.108 445.193 218.628C445.507 219.148 445.652 219.643 445.652 220.163C445.652 220.647 445.519 221.119 445.265 221.578C445.011 222.038 444.636 222.388 444.165 222.63C443.693 222.872 442.931 222.993 441.891 222.993H439.219ZM440.658 216.947H442.157C442.641 216.741 443.004 216.524 443.222 216.306C443.451 216.076 443.609 215.835 443.729 215.556C443.85 215.278 443.899 214.976 443.899 214.65C443.899 214.13 443.754 213.743 443.439 213.489C443.137 213.235 442.544 213.102 441.662 213.102H440.658V216.947ZM440.658 221.893H442.012C442.762 221.893 443.33 221.711 443.693 221.361C444.056 221.01 444.237 220.575 444.237 220.079C444.237 219.716 444.14 219.377 443.935 219.063C443.729 218.749 443.427 218.507 443.016 218.325C442.605 218.144 441.952 218.047 441.057 218.047H440.658V221.893Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M450.718 222.678L447.067 215.073H448.518L451.432 221.022L453.862 215.073H455.192L452.133 222.425C451.48 223.972 450.875 225 450.283 225.508C449.69 226.016 448.941 226.27 448.022 226.27C447.623 226.27 447.26 226.233 446.946 226.161V225C447.308 225.109 447.659 225.169 447.986 225.169C448.409 225.169 448.784 225.085 449.122 224.928C449.461 224.77 449.751 224.468 450.029 224.057C450.295 223.634 450.488 223.271 450.609 222.969L450.718 222.678Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M456.643 222.993V221.893H459.061V213.09H456.643V211.99H462.907V213.09H460.488V221.893H462.907V222.993H456.643Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M465.229 222.993V212.001H467.84C469.037 212.001 469.932 212.207 470.513 212.63C471.093 213.053 471.528 213.682 471.831 214.529C472.133 215.375 472.266 216.379 472.266 217.527C472.266 218.628 472.109 219.583 471.807 220.417C471.504 221.252 471.057 221.88 470.489 222.328C469.92 222.775 469.037 222.993 467.84 222.993H465.229ZM466.655 221.772H467.611C468.578 221.772 469.267 221.602 469.678 221.252C470.089 220.901 470.38 220.429 470.561 219.813C470.742 219.196 470.827 218.35 470.827 217.273C470.827 216.221 470.718 215.411 470.513 214.843C470.307 214.275 470.005 213.839 469.618 213.537C469.231 213.235 468.602 213.078 467.719 213.078H466.655V221.772Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M480.428 225.629C479.122 225.545 478.022 225.182 477.115 224.517C476.208 223.852 475.507 222.969 474.963 221.845C474.418 220.72 474.152 219.608 474.152 218.483C474.152 217.359 474.418 216.234 474.963 215.122C475.507 214.009 476.22 213.114 477.115 212.449C478.01 211.784 479.11 211.422 480.428 211.337V212.437C479.437 212.522 478.59 212.86 477.877 213.429C477.163 214.009 476.607 214.735 476.196 215.617C475.785 216.5 475.579 217.455 475.579 218.471C475.579 219.487 475.785 220.442 476.196 221.325C476.607 222.207 477.163 222.945 477.877 223.513C478.59 224.082 479.437 224.42 480.428 224.517V225.629Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M485.506 211.337V212.22C485.168 212.304 484.914 212.437 484.732 212.607C484.551 212.776 484.418 212.981 484.309 213.235C484.2 213.489 484.152 213.804 484.152 214.166C484.587 214.166 484.914 214.287 485.12 214.541C485.325 214.795 485.434 215.049 485.434 215.327C485.434 215.654 485.313 215.932 485.083 216.162C484.853 216.391 484.588 216.5 484.273 216.5C483.874 216.5 483.535 216.331 483.245 215.992C482.955 215.654 482.81 215.182 482.81 214.59C482.81 214.07 482.919 213.574 483.149 213.114C483.378 212.655 483.681 212.268 484.08 211.942C484.467 211.615 484.95 211.409 485.506 211.337ZM488.977 211.337V212.22C488.638 212.304 488.384 212.437 488.203 212.607C488.022 212.776 487.888 212.981 487.78 213.235C487.671 213.489 487.622 213.804 487.622 214.166C488.058 214.166 488.384 214.287 488.59 214.541C488.795 214.795 488.904 215.049 488.904 215.327C488.904 215.654 488.783 215.932 488.554 216.162C488.324 216.391 488.058 216.5 487.743 216.5C487.344 216.5 486.994 216.331 486.716 215.992C486.437 215.654 486.28 215.182 486.28 214.59C486.28 214.07 486.389 213.574 486.619 213.114C486.849 212.655 487.151 212.268 487.55 211.942C487.937 211.615 488.408 211.409 488.977 211.337Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M496.546 221.216C496.147 221.869 495.664 222.377 495.096 222.703C494.527 223.042 494.019 223.199 493.536 223.199C492.871 223.199 492.278 222.909 491.758 222.34C491.238 221.772 490.972 220.901 490.972 219.74C490.972 218.822 491.142 218.011 491.492 217.286C491.843 216.56 492.314 215.992 492.895 215.581C493.475 215.17 494.213 214.952 495.071 214.952C495.325 214.952 495.7 214.976 496.208 215.025C496.281 215.037 496.401 215.049 496.546 215.061H497.865V220.647C497.865 221.603 497.961 222.377 498.167 222.969H496.788C496.692 222.558 496.619 221.965 496.546 221.216ZM496.559 219.644V216.246C496.087 216.125 495.652 216.065 495.253 216.065C494.443 216.065 493.765 216.379 493.221 217.008C492.677 217.637 492.411 218.495 492.411 219.571C492.411 220.357 492.556 220.95 492.859 221.349C493.161 221.748 493.487 221.953 493.874 221.953C494.285 221.953 494.745 221.748 495.241 221.325C495.724 220.901 496.16 220.345 496.559 219.644Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M501.275 216.85C501.686 216.185 502.169 215.689 502.725 215.351C503.282 215.012 503.802 214.843 504.273 214.843C504.938 214.843 505.531 215.133 506.063 215.701C506.595 216.27 506.861 217.14 506.861 218.301C506.861 219.22 506.692 220.03 506.329 220.756C505.966 221.481 505.507 222.049 504.926 222.461C504.346 222.872 503.62 223.089 502.75 223.089C502.508 223.089 502.121 223.065 501.613 223.017C501.541 223.005 501.42 222.993 501.275 222.981V226.052H499.957V215.06H501.275V216.85ZM501.275 218.422V221.82C501.746 221.941 502.193 222.001 502.592 222.001C503.391 222.001 504.068 221.687 504.612 221.058C505.156 220.429 505.434 219.571 505.434 218.482C505.434 217.696 505.289 217.104 504.987 216.705C504.684 216.306 504.346 216.112 503.971 216.112C503.56 216.112 503.112 216.318 502.617 216.741C502.121 217.164 501.674 217.721 501.275 218.422Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M509.98 216.85C510.391 216.185 510.875 215.689 511.431 215.351C511.987 215.012 512.507 214.843 512.979 214.843C513.644 214.843 514.236 215.133 514.768 215.701C515.3 216.27 515.566 217.14 515.566 218.301C515.566 219.22 515.397 220.03 515.034 220.756C514.672 221.481 514.212 222.049 513.632 222.461C513.051 222.872 512.326 223.089 511.455 223.089C511.213 223.089 510.826 223.065 510.319 223.017C510.246 223.005 510.125 222.993 509.98 222.981V226.052H508.662V215.06H509.98V216.85ZM509.98 218.422V221.82C510.452 221.941 510.899 222.001 511.298 222.001C512.096 222.001 512.773 221.687 513.317 221.058C513.861 220.429 514.14 219.571 514.14 218.482C514.14 217.696 513.995 217.104 513.692 216.705C513.39 216.306 513.051 216.112 512.677 216.112C512.265 216.112 511.818 216.318 511.322 216.741C510.827 217.164 510.379 217.721 509.98 218.422Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M517.647 216.5V215.617C517.985 215.533 518.251 215.4 518.421 215.23C518.59 215.061 518.735 214.856 518.844 214.602C518.953 214.348 519.001 214.033 519.001 213.671C518.566 213.671 518.239 213.55 518.034 213.296C517.828 213.042 517.719 212.788 517.719 212.51C517.719 212.183 517.84 211.905 518.07 211.675C518.3 211.446 518.566 211.337 518.88 211.337C519.279 211.337 519.618 211.506 519.908 211.845C520.198 212.183 520.343 212.655 520.343 213.247C520.343 213.767 520.234 214.263 520.005 214.723C519.775 215.182 519.473 215.569 519.086 215.896C518.687 216.222 518.215 216.428 517.647 216.5ZM521.117 216.5V215.617C521.456 215.533 521.71 215.4 521.891 215.23C522.072 215.061 522.218 214.856 522.326 214.602C522.435 214.348 522.484 214.033 522.484 213.671C522.048 213.671 521.722 213.55 521.516 213.296C521.311 213.042 521.202 212.788 521.202 212.51C521.202 212.183 521.323 211.905 521.552 211.675C521.782 211.446 522.048 211.337 522.351 211.337C522.75 211.337 523.1 211.506 523.39 211.845C523.681 212.183 523.826 212.655 523.826 213.247C523.826 213.767 523.717 214.263 523.487 214.723C523.257 215.182 522.955 215.569 522.568 215.896C522.145 216.222 521.673 216.428 521.117 216.5Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M526.195 211.337C527.501 211.422 528.601 211.796 529.508 212.449C530.415 213.102 531.128 213.997 531.66 215.122C532.193 216.246 532.459 217.359 532.459 218.483C532.459 219.608 532.193 220.732 531.66 221.845C531.128 222.957 530.403 223.852 529.508 224.517C528.613 225.182 527.513 225.545 526.195 225.629V224.529C527.186 224.432 528.033 224.106 528.746 223.525C529.46 222.945 530.016 222.22 530.427 221.337C530.838 220.454 531.044 219.499 531.044 218.483C531.044 217.467 530.838 216.512 530.427 215.629C530.016 214.747 529.46 214.009 528.746 213.441C528.033 212.873 527.186 212.534 526.195 212.449V211.337Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M536.788 226.064V225.181C537.127 225.097 537.393 224.964 537.562 224.794C537.732 224.625 537.877 224.42 537.985 224.154C538.094 223.888 538.143 223.585 538.143 223.223C537.707 223.223 537.381 223.102 537.175 222.848C536.97 222.594 536.861 222.34 536.861 222.05C536.861 221.723 536.982 221.445 537.212 221.227C537.441 221.01 537.707 220.889 538.022 220.889C538.421 220.889 538.759 221.058 539.049 221.397C539.34 221.735 539.485 222.207 539.485 222.799C539.485 223.319 539.376 223.803 539.146 224.275C538.916 224.746 538.614 225.133 538.227 225.46C537.84 225.786 537.357 225.992 536.788 226.064ZM538.022 217.165C537.707 217.165 537.429 217.056 537.212 216.826C536.994 216.596 536.873 216.33 536.873 216.016C536.873 215.689 536.994 215.423 537.224 215.194C537.453 214.964 537.719 214.855 538.034 214.855C538.348 214.855 538.614 214.964 538.844 215.194C539.074 215.423 539.182 215.689 539.182 216.016C539.182 216.33 539.074 216.608 538.844 216.826C538.614 217.044 538.336 217.165 538.022 217.165Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M161.132 264.106V256.198H162.45V257.927C162.861 257.274 163.333 256.79 163.865 256.464C164.397 256.137 164.989 255.98 165.642 255.98C166.114 255.98 166.597 256.053 167.069 256.198V259.051H165.799V257.25C165.582 257.213 165.4 257.189 165.279 257.189C164.784 257.189 164.312 257.383 163.828 257.77C163.345 258.157 162.897 258.737 162.45 259.511V264.106H161.132Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M172.425 264.323C171.289 264.323 170.382 263.924 169.705 263.138C169.028 262.352 168.689 261.349 168.689 260.139C168.689 258.93 169.028 257.939 169.705 257.153C170.382 256.367 171.289 255.968 172.425 255.968C173.55 255.968 174.457 256.367 175.134 257.153C175.811 257.939 176.15 258.942 176.15 260.139C176.15 261.337 175.811 262.34 175.134 263.138C174.457 263.924 173.55 264.323 172.425 264.323ZM172.425 263.223C173.127 263.223 173.683 262.945 174.106 262.401C174.517 261.856 174.723 261.095 174.723 260.139C174.723 259.184 174.517 258.435 174.106 257.89C173.695 257.346 173.127 257.068 172.425 257.068C171.724 257.068 171.156 257.346 170.745 257.89C170.334 258.435 170.128 259.184 170.128 260.139C170.128 261.095 170.334 261.856 170.745 262.401C171.156 262.945 171.712 263.223 172.425 263.223Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M181.131 264.323C179.995 264.323 179.088 263.924 178.411 263.138C177.734 262.352 177.395 261.349 177.395 260.139C177.395 258.93 177.734 257.939 178.411 257.153C179.088 256.367 179.995 255.968 181.131 255.968C182.256 255.968 183.163 256.367 183.84 257.153C184.517 257.939 184.856 258.942 184.856 260.139C184.856 261.337 184.517 262.34 183.84 263.138C183.163 263.924 182.256 264.323 181.131 264.323ZM181.131 263.223C181.833 263.223 182.389 262.945 182.812 262.401C183.223 261.856 183.429 261.095 183.429 260.139C183.429 259.184 183.223 258.435 182.812 257.89C182.401 257.346 181.833 257.068 181.131 257.068C180.43 257.068 179.862 257.346 179.451 257.89C179.039 258.435 178.834 259.184 178.834 260.139C178.834 261.095 179.039 261.856 179.451 262.401C179.862 262.945 180.43 263.223 181.131 263.223Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M193.199 263.779C192.583 264.033 192.135 264.191 191.857 264.239C191.579 264.287 191.313 264.311 191.047 264.311C190.491 264.311 189.983 264.203 189.536 263.997C189.088 263.792 188.725 263.465 188.496 263.054C188.266 262.643 188.145 261.99 188.145 261.131V257.939H186.174V256.839H188.145V253.646H189.463V256.839H192.982V257.939H189.463V261.107C189.463 261.748 189.536 262.195 189.693 262.461C189.85 262.727 190.043 262.921 190.297 263.042C190.551 263.163 190.854 263.223 191.192 263.223C191.833 263.223 192.498 263.018 193.199 262.619V263.779Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M198.544 264.432C198.23 264.432 197.952 264.323 197.734 264.093C197.516 263.864 197.395 263.598 197.395 263.283C197.395 262.957 197.504 262.691 197.734 262.461C197.964 262.231 198.23 262.123 198.544 262.123C198.858 262.123 199.124 262.231 199.354 262.461C199.584 262.691 199.693 262.957 199.693 263.283C199.693 263.598 199.584 263.876 199.354 264.093C199.124 264.311 198.858 264.432 198.544 264.432Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M206.222 264.105V257.285H204.021V256.185H207.54V263.005H209.741V264.105H206.222ZM206.005 253.331C206.005 253.029 206.101 252.811 206.307 252.666C206.512 252.521 206.706 252.449 206.875 252.449C207.057 252.449 207.25 252.521 207.456 252.666C207.661 252.811 207.758 253.029 207.758 253.331C207.758 253.622 207.661 253.839 207.456 253.984C207.25 254.129 207.057 254.202 206.875 254.202C206.694 254.202 206.5 254.129 206.307 253.984C206.113 253.839 206.005 253.622 206.005 253.331Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M212.703 264.106V256.198H214.021V257.927C214.396 257.322 214.856 256.838 215.388 256.5C215.92 256.161 216.452 255.98 216.984 255.98C217.455 255.98 217.879 256.101 218.253 256.355C218.628 256.609 218.906 256.923 219.064 257.334C219.221 257.745 219.293 258.519 219.293 259.704V264.13H217.975V259.547C217.975 258.785 217.939 258.29 217.866 258.036C217.794 257.782 217.661 257.588 217.467 257.431C217.274 257.274 217.056 257.201 216.827 257.201C216.367 257.201 215.871 257.419 215.339 257.854C214.807 258.29 214.372 258.846 214.021 259.511V264.118H212.703V264.106Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M221.409 264.106V256.198H222.727V257.927C223.102 257.322 223.561 256.838 224.093 256.5C224.625 256.161 225.157 255.98 225.689 255.98C226.161 255.98 226.584 256.101 226.959 256.355C227.334 256.609 227.612 256.923 227.769 257.334C227.926 257.745 227.999 258.519 227.999 259.704V264.13H226.681V259.547C226.681 258.785 226.645 258.29 226.572 258.036C226.499 257.782 226.366 257.588 226.173 257.431C225.98 257.274 225.762 257.201 225.532 257.201C225.073 257.201 224.577 257.419 224.045 257.854C223.513 258.29 223.078 258.846 222.727 259.511V264.118H221.409V264.106Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M236.705 263.573C235.653 264.069 234.65 264.323 233.719 264.323C233.005 264.323 232.364 264.141 231.808 263.791C231.252 263.44 230.793 262.932 230.454 262.267C230.115 261.602 229.946 260.901 229.946 260.151C229.946 259.425 230.103 258.736 230.43 258.071C230.756 257.406 231.204 256.886 231.772 256.511C232.352 256.136 232.993 255.955 233.695 255.955C234.638 255.955 235.387 256.294 235.956 256.959C236.524 257.624 236.814 258.664 236.814 260.054V260.332H231.361C231.361 260.876 231.47 261.384 231.699 261.844C231.929 262.303 232.231 262.642 232.606 262.872C232.981 263.101 233.404 263.21 233.876 263.21C234.722 263.21 235.665 262.932 236.693 262.352V263.573H236.705ZM231.445 259.365H235.387V259.172C235.387 258.531 235.23 258.011 234.916 257.636C234.601 257.261 234.178 257.068 233.646 257.068C233.114 257.068 232.655 257.261 232.256 257.648C231.857 258.035 231.591 258.603 231.445 259.365Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M239.499 264.106V256.198H240.817V257.927C241.228 257.274 241.699 256.79 242.231 256.464C242.763 256.137 243.356 255.98 244.009 255.98C244.48 255.98 244.964 256.053 245.436 256.198V259.051H244.166V257.25C243.948 257.213 243.767 257.189 243.646 257.189C243.15 257.189 242.679 257.383 242.195 257.77C241.711 258.157 241.264 258.737 240.817 259.511V264.106H239.499Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M247.334 264.105V253.113H248.761V257.841H252.811V253.113H254.238V264.105H252.811V258.942H248.761V264.105H247.334Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M258.785 264.105V254.322H255.496V253.113H263.513V254.322H260.224V264.105H258.785Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M265.411 264.105H264.25V253.113H265.689L268.229 260.356L270.768 253.113H272.171V264.105H270.853V257.104L270.889 256.136H270.853L270.538 257.104L268.833 261.916H267.407L265.689 257.104L265.411 256.136H265.375L265.411 257.104V264.105Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M280.043 262.884V264.093H274.118V253.102H275.545V262.884H280.043Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M298.168 258.494V259.594H290.478V258.494H298.168ZM298.168 260.973V262.073H290.478V260.973H298.168Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M177.286 280.804L184.977 276.958V278.192L179.717 280.804L184.977 283.452V284.661L177.286 280.804Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M191.881 282.872C191.482 283.537 190.998 284.033 190.43 284.371C189.862 284.71 189.342 284.879 188.87 284.879C188.205 284.879 187.613 284.589 187.081 284.021C186.549 283.452 186.295 282.582 186.295 281.421C186.295 280.502 186.464 279.692 186.814 278.966C187.165 278.241 187.637 277.672 188.217 277.261C188.798 276.85 189.523 276.633 190.394 276.633C190.648 276.633 191.022 276.657 191.53 276.705C191.603 276.717 191.724 276.729 191.869 276.741V273.223H193.187V284.661H191.881V282.872ZM191.881 281.312V277.914C191.409 277.793 190.974 277.733 190.575 277.733C189.765 277.733 189.088 278.047 188.544 278.676C187.999 279.305 187.733 280.163 187.733 281.24C187.733 282.025 187.879 282.618 188.181 283.017C188.471 283.416 188.81 283.622 189.197 283.622C189.608 283.622 190.067 283.416 190.563 282.993C191.059 282.57 191.482 282.013 191.881 281.312Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M197.504 284.661V277.841H195.303V276.741H198.822V283.561H201.023V284.661H197.504ZM197.298 273.887C197.298 273.585 197.395 273.367 197.6 273.222C197.806 273.077 198 273.004 198.169 273.004C198.35 273.004 198.544 273.077 198.749 273.222C198.955 273.367 199.052 273.585 199.052 273.887C199.052 274.177 198.955 274.395 198.749 274.54C198.544 274.685 198.35 274.758 198.169 274.758C197.987 274.758 197.794 274.685 197.6 274.54C197.407 274.395 197.298 274.177 197.298 273.887Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M206.573 284.661L203.139 276.753H204.59L207.31 283.029L210.067 276.753H211.385L207.915 284.661H206.573Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M228.072 284.431C227.189 284.733 226.343 284.878 225.545 284.878C224.747 284.878 224.046 284.697 223.429 284.334C222.812 283.972 222.329 283.476 221.99 282.847C221.651 282.218 221.47 281.505 221.47 280.707C221.47 279.51 221.857 278.506 222.643 277.72C223.429 276.934 224.372 276.535 225.472 276.535C226.295 276.535 227.153 276.692 228.06 276.995V278.264C227.141 277.841 226.319 277.636 225.593 277.636C225.11 277.636 224.662 277.756 224.239 277.998C223.816 278.24 223.489 278.603 223.26 279.111C223.03 279.619 222.909 280.139 222.909 280.671C222.909 281.384 223.127 282.061 223.574 282.714C224.021 283.367 224.723 283.681 225.678 283.681C225.968 283.681 226.246 283.657 226.524 283.621C226.803 283.585 227.322 283.427 228.072 283.174V284.431Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M232.243 284.661V274.323H229.873V273.223H233.561V283.561H236.028V284.661H232.243Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M244.033 282.884C243.634 283.537 243.15 284.045 242.582 284.371C242.014 284.71 241.494 284.867 241.022 284.867C240.357 284.867 239.764 284.577 239.245 284.009C238.725 283.44 238.459 282.57 238.459 281.409C238.459 280.49 238.628 279.68 238.979 278.954C239.329 278.229 239.801 277.66 240.381 277.249C240.962 276.826 241.687 276.621 242.558 276.621C242.812 276.621 243.186 276.645 243.694 276.693C243.767 276.705 243.888 276.717 244.033 276.729H245.351V282.316C245.351 283.271 245.448 284.045 245.653 284.637H244.275C244.178 284.226 244.093 283.634 244.033 282.884ZM244.033 281.312V277.914C243.561 277.794 243.126 277.733 242.727 277.733C241.917 277.733 241.24 278.047 240.696 278.676C240.151 279.305 239.885 280.164 239.885 281.24C239.885 282.026 240.031 282.618 240.333 283.017C240.623 283.416 240.962 283.622 241.349 283.622C241.76 283.622 242.219 283.416 242.715 282.993C243.211 282.57 243.646 282.014 244.033 281.312Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M247.624 284.238V282.847C248.156 283.198 248.712 283.44 249.305 283.573C249.897 283.706 250.393 283.779 250.804 283.779C251.469 283.779 251.953 283.67 252.243 283.452C252.533 283.234 252.679 282.968 252.679 282.642C252.679 282.424 252.606 282.243 252.473 282.098C252.34 281.953 252.001 281.759 251.457 281.542L250.998 281.36L250.079 280.997C249.099 280.61 248.483 280.26 248.217 279.933C247.963 279.607 247.83 279.22 247.83 278.76C247.83 278.107 248.084 277.575 248.579 277.152C249.087 276.729 249.897 276.523 251.034 276.523C251.88 276.523 252.679 276.644 253.44 276.886V278.083C252.57 277.769 251.747 277.612 250.986 277.612C250.429 277.612 249.994 277.708 249.68 277.902C249.365 278.095 249.208 278.337 249.208 278.64C249.208 278.918 249.341 279.147 249.619 279.317C249.885 279.486 250.333 279.679 250.937 279.909L251.832 280.236C252.654 280.538 253.223 280.852 253.549 281.203C253.876 281.554 254.045 281.989 254.045 282.509C254.045 283.198 253.779 283.754 253.259 284.202C252.739 284.649 251.893 284.867 250.732 284.867C249.74 284.879 248.7 284.661 247.624 284.238Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M256.343 284.238V282.847C256.875 283.198 257.431 283.44 258.024 283.573C258.616 283.706 259.112 283.779 259.523 283.779C260.188 283.779 260.672 283.67 260.962 283.452C261.252 283.234 261.397 282.968 261.397 282.642C261.397 282.424 261.325 282.243 261.192 282.098C261.059 281.953 260.72 281.759 260.176 281.542L259.716 281.36L258.798 280.997C257.818 280.61 257.201 280.26 256.935 279.933C256.681 279.607 256.548 279.22 256.548 278.76C256.548 278.107 256.802 277.575 257.298 277.152C257.806 276.729 258.616 276.523 259.753 276.523C260.599 276.523 261.397 276.644 262.159 276.886V278.083C261.288 277.769 260.466 277.612 259.704 277.612C259.148 277.612 258.713 277.708 258.399 277.902C258.084 278.095 257.927 278.337 257.927 278.64C257.927 278.918 258.06 279.147 258.338 279.317C258.604 279.486 259.051 279.679 259.656 279.909L260.551 280.236C261.373 280.538 261.941 280.852 262.268 281.203C262.594 281.554 262.764 281.989 262.764 282.509C262.764 283.198 262.498 283.754 261.978 284.202C261.458 284.649 260.611 284.867 259.45 284.867C258.447 284.879 257.407 284.661 256.343 284.238Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M266.064 284.661H264.746V273.669H266.04L269.922 280.985L270.345 282.073H270.381L270.345 280.985V273.669H271.663V284.661H270.345L266.572 277.466L266.04 276.305L266.064 277.442V284.661Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M278.858 282.884C278.459 283.537 277.975 284.045 277.407 284.371C276.839 284.71 276.319 284.867 275.847 284.867C275.182 284.867 274.59 284.577 274.07 284.009C273.55 283.44 273.284 282.57 273.284 281.409C273.284 280.49 273.453 279.68 273.804 278.954C274.154 278.229 274.626 277.66 275.206 277.249C275.787 276.826 276.512 276.621 277.383 276.621C277.637 276.621 278.012 276.645 278.519 276.693C278.592 276.705 278.713 276.717 278.858 276.729H280.176V282.316C280.176 283.271 280.273 284.045 280.478 284.637H279.1C279.015 284.226 278.931 283.634 278.858 282.884ZM278.87 281.312V277.914C278.399 277.794 277.963 277.733 277.564 277.733C276.754 277.733 276.077 278.047 275.533 278.676C274.989 279.305 274.723 280.164 274.723 281.24C274.723 282.026 274.868 282.618 275.17 283.017C275.46 283.416 275.799 283.622 276.186 283.622C276.597 283.622 277.056 283.416 277.552 282.993C278.048 282.57 278.471 282.014 278.87 281.312Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M281.771 284.661V276.753H282.932V278.567C283.295 277.793 283.634 277.261 283.948 276.97C284.262 276.68 284.577 276.535 284.903 276.535C285.29 276.535 285.592 276.68 285.822 276.983C286.052 277.285 286.173 277.708 286.173 278.264V278.687C286.33 278.204 286.511 277.817 286.741 277.515C286.971 277.212 287.189 276.97 287.43 276.801C287.672 276.632 287.938 276.535 288.241 276.535C288.579 276.535 288.869 276.68 289.111 276.97C289.353 277.261 289.474 277.829 289.474 278.687V284.673H288.313V279.268C288.313 278.821 288.301 278.518 288.265 278.361C288.229 278.204 288.18 278.071 288.095 277.986C288.011 277.902 287.914 277.853 287.817 277.853C287.576 277.853 287.31 278.047 287.031 278.421C286.753 278.796 286.463 279.425 286.173 280.284V284.673H285.073V279.28C285.073 278.579 285 278.168 284.867 278.047C284.734 277.926 284.613 277.865 284.492 277.865C284.25 277.865 283.996 278.071 283.718 278.494C283.44 278.917 283.174 279.449 282.92 280.114V284.685H281.771V284.661Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M297.66 284.129C296.608 284.624 295.605 284.878 294.674 284.878C293.96 284.878 293.319 284.697 292.763 284.346C292.207 283.996 291.747 283.488 291.409 282.823C291.07 282.158 290.901 281.456 290.901 280.707C290.901 279.981 291.058 279.292 291.385 278.627C291.711 277.962 292.159 277.442 292.727 277.067C293.307 276.692 293.948 276.511 294.649 276.511C295.593 276.511 296.342 276.849 296.911 277.514C297.479 278.179 297.769 279.219 297.769 280.61V280.888H292.316C292.316 281.432 292.425 281.94 292.654 282.399C292.884 282.859 293.186 283.198 293.561 283.427C293.936 283.657 294.359 283.766 294.831 283.766C295.677 283.766 296.62 283.488 297.648 282.907V284.129H297.66ZM292.388 279.921H296.33V279.727C296.33 279.086 296.173 278.566 295.859 278.191C295.544 277.817 295.121 277.623 294.589 277.623C294.057 277.623 293.597 277.817 293.198 278.204C292.799 278.591 292.545 279.159 292.388 279.921Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M306.886 279.051V280.151H299.196V279.051H306.886ZM306.886 281.53V282.63H299.196V281.53H306.886Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M311.36 273.004V273.887C311.022 273.972 310.756 274.105 310.586 274.274C310.417 274.443 310.272 274.649 310.163 274.903C310.054 275.157 310.006 275.471 310.006 275.834C310.441 275.834 310.768 275.955 310.973 276.209C311.179 276.463 311.288 276.717 311.288 276.995C311.288 277.321 311.167 277.599 310.937 277.829C310.707 278.059 310.441 278.168 310.127 278.168C309.728 278.168 309.389 277.998 309.099 277.66C308.809 277.321 308.664 276.85 308.664 276.257C308.664 275.737 308.773 275.241 309.002 274.782C309.232 274.322 309.535 273.935 309.921 273.609C310.32 273.283 310.792 273.077 311.36 273.004ZM314.819 273.004V273.887C314.48 273.972 314.214 274.105 314.045 274.274C313.876 274.443 313.73 274.649 313.622 274.903C313.513 275.157 313.464 275.471 313.464 275.834C313.9 275.834 314.226 275.955 314.432 276.209C314.637 276.463 314.746 276.717 314.746 276.995C314.746 277.321 314.625 277.599 314.395 277.829C314.166 278.059 313.9 278.168 313.585 278.168C313.186 278.168 312.836 277.998 312.557 277.66C312.279 277.321 312.134 276.85 312.134 276.257C312.134 275.737 312.243 275.241 312.473 274.782C312.703 274.322 313.005 273.935 313.392 273.609C313.791 273.283 314.262 273.077 314.819 273.004Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M318.422 278.518C318.833 277.853 319.317 277.357 319.873 277.019C320.429 276.68 320.949 276.511 321.421 276.511C322.086 276.511 322.678 276.801 323.21 277.369C323.742 277.938 324.008 278.808 324.008 279.969C324.008 280.888 323.827 281.698 323.476 282.424C323.126 283.149 322.654 283.717 322.074 284.129C321.493 284.54 320.768 284.757 319.897 284.757C319.655 284.757 319.268 284.733 318.761 284.685C318.688 284.673 318.567 284.661 318.422 284.649V287.72H317.104V276.728H318.422V278.518ZM318.422 280.09V283.488C318.894 283.609 319.341 283.669 319.74 283.669C320.538 283.669 321.215 283.355 321.759 282.726C322.303 282.097 322.582 281.239 322.582 280.15C322.582 279.364 322.436 278.772 322.134 278.373C321.832 277.974 321.493 277.78 321.118 277.78C320.707 277.78 320.26 277.986 319.764 278.409C319.268 278.832 318.809 279.389 318.422 280.09Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M328.035 284.661V274.323H325.665V273.223H329.353V283.561H331.82V284.661H328.035Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M339.812 282.884C339.413 283.537 338.929 284.045 338.361 284.371C337.793 284.71 337.273 284.867 336.801 284.867C336.136 284.867 335.544 284.577 335.024 284.009C334.504 283.44 334.238 282.57 334.238 281.409C334.238 280.49 334.407 279.68 334.758 278.954C335.108 278.229 335.58 277.66 336.16 277.249C336.741 276.826 337.466 276.621 338.337 276.621C338.591 276.621 338.966 276.645 339.473 276.693C339.546 276.705 339.667 276.717 339.812 276.729H341.13V282.316C341.13 283.271 341.227 284.045 341.432 284.637H340.054C339.957 284.226 339.873 283.634 339.812 282.884ZM339.824 281.312V277.914C339.352 277.794 338.917 277.733 338.518 277.733C337.708 277.733 337.031 278.047 336.487 278.676C335.943 279.305 335.677 280.164 335.677 281.24C335.677 282.026 335.822 282.618 336.124 283.017C336.414 283.416 336.753 283.622 337.14 283.622C337.551 283.622 338.01 283.416 338.506 282.993C339.002 282.57 339.425 282.014 339.824 281.312Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M346.233 284.346L342.581 276.741H344.032L346.946 282.69L349.377 276.741H350.707L347.648 284.093C346.995 285.64 346.39 286.668 345.798 287.176C345.205 287.684 344.456 287.938 343.537 287.938C343.138 287.938 342.775 287.901 342.46 287.829V286.668C342.823 286.777 343.174 286.837 343.5 286.837C343.924 286.837 344.298 286.753 344.637 286.596C344.976 286.438 345.266 286.136 345.544 285.725C345.81 285.302 346.003 284.939 346.124 284.637L346.233 284.346Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M357.322 282.872C356.922 283.537 356.439 284.033 355.87 284.371C355.302 284.71 354.782 284.879 354.311 284.879C353.646 284.879 353.053 284.589 352.521 284.02C351.989 283.452 351.735 282.581 351.735 281.421C351.735 280.502 351.904 279.692 352.255 278.966C352.606 278.241 353.077 277.672 353.658 277.261C354.238 276.85 354.976 276.632 355.834 276.632C356.088 276.632 356.463 276.657 356.971 276.705C357.043 276.717 357.164 276.729 357.309 276.741H358.627V282.34C358.627 283.67 358.615 284.48 358.579 284.782C358.543 285.072 358.494 285.375 358.41 285.677C358.216 286.378 357.793 286.935 357.116 287.346C356.439 287.757 355.629 287.95 354.673 287.95C353.718 287.95 352.739 287.708 351.759 287.213V285.883C352.134 286.136 352.594 286.366 353.138 286.56C353.682 286.753 354.214 286.85 354.722 286.85C355.121 286.85 355.508 286.789 355.858 286.656C356.221 286.523 356.511 286.342 356.729 286.1C356.947 285.858 357.104 285.58 357.189 285.266C357.273 284.951 357.309 284.528 357.309 283.996V282.872H357.322ZM357.322 281.312V277.914C356.85 277.793 356.415 277.733 356.016 277.733C355.205 277.733 354.528 278.047 353.984 278.676C353.44 279.305 353.174 280.163 353.174 281.239C353.174 282.025 353.319 282.618 353.621 283.017C353.924 283.416 354.25 283.621 354.637 283.621C355.048 283.621 355.508 283.416 356.003 282.993C356.487 282.569 356.922 282.013 357.322 281.312Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M361.408 284.661V276.753H362.726V278.482C363.138 277.829 363.609 277.345 364.141 277.019C364.673 276.692 365.266 276.535 365.919 276.535C366.39 276.535 366.874 276.608 367.345 276.753V279.606H366.076V277.805C365.858 277.769 365.677 277.744 365.556 277.744C365.06 277.744 364.589 277.938 364.105 278.325C363.621 278.712 363.174 279.292 362.726 280.066V284.661H361.408Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M372.702 284.879C371.566 284.879 370.659 284.48 369.982 283.694C369.304 282.908 368.966 281.904 368.966 280.695C368.966 279.486 369.304 278.494 369.982 277.708C370.659 276.922 371.566 276.523 372.702 276.523C373.827 276.523 374.734 276.922 375.411 277.708C376.088 278.494 376.427 279.498 376.427 280.695C376.427 281.892 376.088 282.896 375.411 283.694C374.734 284.48 373.827 284.879 372.702 284.879ZM372.702 283.779C373.404 283.779 373.96 283.5 374.383 282.956C374.794 282.412 375 281.65 375 280.695C375 279.74 374.794 278.99 374.383 278.446C373.972 277.902 373.404 277.624 372.702 277.624C371.989 277.624 371.433 277.902 371.022 278.446C370.61 278.99 370.393 279.74 370.393 280.695C370.393 281.65 370.598 282.412 371.022 282.956C371.445 283.5 371.989 283.779 372.702 283.779Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M384.661 276.741V284.649H383.343V282.908C382.919 283.561 382.448 284.044 381.928 284.371C381.408 284.697 380.888 284.855 380.368 284.855C379.909 284.855 379.485 284.734 379.098 284.48C378.711 284.226 378.445 283.911 378.288 283.5C378.131 283.089 378.058 282.303 378.058 281.142V276.717H379.377V281.3C379.377 282.061 379.413 282.557 379.485 282.811C379.558 283.065 379.691 283.258 379.884 283.416C380.078 283.573 380.295 283.645 380.513 283.645C380.973 283.645 381.468 283.428 382 282.992C382.532 282.557 382.968 282.001 383.318 281.336V276.729H384.661V276.741Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M386.861 284.661V276.753H388.179V278.482C388.554 277.877 389.014 277.394 389.546 277.055C390.078 276.717 390.61 276.535 391.142 276.535C391.613 276.535 392.037 276.656 392.411 276.91C392.786 277.164 393.064 277.478 393.222 277.889C393.379 278.301 393.451 279.074 393.451 280.259V284.685H392.133V280.102C392.133 279.34 392.097 278.845 392.024 278.591C391.952 278.337 391.819 278.143 391.625 277.986C391.432 277.829 391.214 277.756 390.984 277.756C390.525 277.756 390.029 277.974 389.497 278.409C388.965 278.845 388.53 279.401 388.179 280.066V284.673H386.861V284.661Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M400.852 282.872C400.453 283.537 399.969 284.033 399.401 284.371C398.833 284.71 398.313 284.879 397.841 284.879C397.176 284.879 396.584 284.589 396.052 284.021C395.52 283.452 395.266 282.582 395.266 281.421C395.266 280.502 395.435 279.692 395.798 278.966C396.148 278.241 396.62 277.672 397.2 277.261C397.793 276.838 398.518 276.633 399.377 276.633C399.631 276.633 400.006 276.657 400.513 276.705C400.586 276.717 400.707 276.729 400.852 276.741V273.223H402.17V284.661H400.852V282.872ZM400.852 281.312V277.914C400.38 277.793 399.945 277.733 399.546 277.733C398.736 277.733 398.059 278.047 397.515 278.676C396.971 279.305 396.705 280.163 396.705 281.24C396.705 282.025 396.85 282.618 397.152 283.017C397.454 283.416 397.781 283.622 398.168 283.622C398.579 283.622 399.038 283.416 399.534 282.993C400.018 282.57 400.465 282.013 400.852 281.312Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M404.443 278.168V277.285C404.782 277.2 405.048 277.067 405.217 276.898C405.386 276.729 405.531 276.523 405.64 276.269C405.749 276.015 405.797 275.701 405.797 275.338C405.362 275.338 405.036 275.217 404.83 274.963C404.624 274.709 404.516 274.455 404.516 274.177C404.516 273.851 404.637 273.573 404.866 273.343C405.096 273.113 405.362 273.004 405.676 273.004C406.075 273.004 406.414 273.174 406.704 273.512C406.994 273.851 407.14 274.322 407.14 274.915C407.14 275.435 407.031 275.931 406.801 276.39C406.571 276.85 406.269 277.237 405.882 277.563C405.483 277.889 405.011 278.095 404.443 278.168ZM407.913 278.168V277.285C408.252 277.2 408.506 277.067 408.687 276.898C408.869 276.729 409.014 276.523 409.123 276.269C409.231 276.015 409.28 275.701 409.28 275.338C408.844 275.338 408.518 275.217 408.312 274.963C408.107 274.709 407.998 274.455 407.998 274.177C407.998 273.851 408.119 273.573 408.349 273.343C408.578 273.113 408.844 273.004 409.147 273.004C409.546 273.004 409.896 273.174 410.187 273.512C410.477 273.851 410.622 274.322 410.622 274.915C410.622 275.435 410.513 275.931 410.283 276.39C410.054 276.85 409.751 277.237 409.364 277.563C408.953 277.889 408.47 278.095 407.913 278.168Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M420.077 280.804L412.387 284.649V283.428L417.647 280.804L412.387 278.155V276.946L420.077 280.804Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M194.698 301.36L202.389 297.515V298.748L197.129 301.36L202.389 304.008V305.218L194.698 301.36Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M203.997 305.217V293.778H205.315V299.026C205.69 298.422 206.15 297.938 206.682 297.599C207.214 297.261 207.746 297.079 208.278 297.079C208.725 297.079 209.136 297.188 209.511 297.418C209.886 297.648 210.14 297.926 210.285 298.252C210.406 298.506 210.478 298.772 210.527 299.05C210.575 299.328 210.587 299.909 210.587 300.792V305.217H209.269V300.634C209.269 299.873 209.233 299.377 209.16 299.123C209.088 298.869 208.955 298.675 208.761 298.518C208.568 298.361 208.35 298.289 208.121 298.289C207.661 298.289 207.165 298.506 206.633 298.942C206.101 299.377 205.666 299.933 205.315 300.598V305.205H203.997V305.217Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M215.629 304.117V295.64C215.23 295.955 214.843 296.221 214.468 296.438C214.094 296.656 213.586 296.886 212.933 297.116V295.931C213.973 295.495 214.867 294.927 215.629 294.226H216.947V304.129H219.595V305.229H212.945V304.129H215.629V304.117Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M228.519 301.36L220.829 305.205V303.984L226.089 301.36L220.829 298.712V297.502L228.519 301.36Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M235.545 303.79V304.902C235.146 305.156 234.795 305.338 234.493 305.41C234.191 305.483 233.852 305.531 233.502 305.531C232.522 305.531 231.712 305.289 231.083 304.818C230.454 304.346 229.959 303.669 229.584 302.81C229.209 301.952 229.028 300.9 229.028 299.666C229.028 297.949 229.427 296.547 230.213 295.483C230.999 294.419 232.063 293.875 233.405 293.875C234.735 293.875 235.787 294.346 236.549 295.289C237.311 296.232 237.71 297.478 237.71 299.014C237.71 299.691 237.613 300.247 237.407 300.694C237.214 301.13 236.948 301.48 236.621 301.734C236.295 301.988 235.908 302.121 235.436 302.121C235.074 302.121 234.783 302.049 234.554 301.879C234.324 301.722 234.155 301.359 234.046 300.791C233.913 301.093 233.707 301.396 233.441 301.686C233.163 301.976 232.8 302.121 232.329 302.121C231.845 302.121 231.434 301.903 231.12 301.456C230.805 301.009 230.636 300.477 230.636 299.836C230.636 299.05 230.866 298.312 231.325 297.635C231.785 296.958 232.607 296.619 233.792 296.619H235.146V299.727C235.146 300.138 235.158 300.428 235.194 300.61C235.231 300.779 235.291 300.912 235.388 300.997C235.485 301.081 235.593 301.13 235.702 301.13C235.884 301.13 236.065 301.045 236.259 300.864C236.44 300.682 236.585 300.44 236.682 300.114C236.778 299.787 236.827 299.437 236.827 299.062C236.827 298.276 236.682 297.502 236.392 296.764C236.101 296.027 235.678 295.495 235.11 295.168C234.541 294.842 233.949 294.697 233.332 294.697C232.679 294.697 232.099 294.89 231.603 295.289C231.107 295.688 230.696 296.281 230.382 297.067C230.068 297.853 229.898 298.723 229.898 299.679C229.898 300.634 230.055 301.529 230.37 302.339C230.684 303.149 231.12 303.754 231.652 304.128C232.184 304.503 232.788 304.697 233.453 304.697C234.227 304.721 234.916 304.406 235.545 303.79ZM234.082 299.485V297.575H233.828C233.272 297.575 232.873 297.659 232.619 297.841C232.365 298.022 232.184 298.288 232.039 298.663C231.893 299.038 231.821 299.449 231.821 299.896C231.821 300.259 231.881 300.537 231.99 300.743C232.099 300.936 232.256 301.045 232.462 301.045C232.74 301.045 233.03 300.888 233.32 300.561C233.598 300.223 233.852 299.872 234.082 299.485Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M240.95 305.217V294.879H238.58V293.778H242.268V304.117H244.735V305.217H240.95Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M250.792 305.435C249.656 305.435 248.749 305.036 248.072 304.25C247.395 303.464 247.056 302.46 247.056 301.251C247.056 300.042 247.395 299.051 248.072 298.265C248.749 297.479 249.656 297.08 250.792 297.08C251.917 297.08 252.824 297.479 253.501 298.265C254.178 299.051 254.517 300.054 254.517 301.251C254.517 302.448 254.178 303.452 253.501 304.25C252.824 305.036 251.917 305.435 250.792 305.435ZM250.792 304.335C251.494 304.335 252.05 304.057 252.473 303.512C252.884 302.968 253.09 302.207 253.09 301.251C253.09 300.296 252.884 299.546 252.473 299.002C252.062 298.458 251.494 298.18 250.792 298.18C250.091 298.18 249.523 298.458 249.112 299.002C248.701 299.546 248.495 300.296 248.495 301.251C248.495 302.207 248.701 302.968 249.112 303.512C249.523 304.057 250.091 304.335 250.792 304.335Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M259.498 305.435C258.362 305.435 257.455 305.036 256.778 304.25C256.101 303.464 255.762 302.46 255.762 301.251C255.762 300.042 256.101 299.051 256.778 298.265C257.455 297.479 258.362 297.08 259.498 297.08C260.623 297.08 261.53 297.479 262.207 298.265C262.884 299.051 263.223 300.054 263.223 301.251C263.223 302.448 262.884 303.452 262.207 304.25C261.53 305.036 260.623 305.435 259.498 305.435ZM259.498 304.335C260.2 304.335 260.756 304.057 261.179 303.512C261.59 302.968 261.796 302.207 261.796 301.251C261.796 300.296 261.59 299.546 261.179 299.002C260.768 298.458 260.2 298.18 259.498 298.18C258.797 298.18 258.229 298.458 257.818 299.002C257.407 299.546 257.201 300.296 257.201 301.251C257.201 302.207 257.407 302.968 257.818 303.512C258.229 304.057 258.797 304.335 259.498 304.335Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M264.359 305.217V297.309H265.52V299.123C265.883 298.349 266.222 297.817 266.536 297.527C266.85 297.236 267.165 297.091 267.491 297.091C267.878 297.091 268.18 297.236 268.41 297.539C268.64 297.841 268.761 298.264 268.761 298.82V299.244C268.918 298.76 269.099 298.373 269.329 298.071C269.559 297.768 269.777 297.527 270.018 297.357C270.26 297.188 270.526 297.091 270.829 297.091C271.167 297.091 271.457 297.236 271.699 297.527C271.941 297.817 272.062 298.385 272.062 299.244V305.229H270.901V299.824C270.901 299.377 270.889 299.074 270.853 298.917C270.817 298.76 270.768 298.627 270.683 298.542C270.599 298.458 270.502 298.409 270.405 298.409C270.164 298.409 269.898 298.603 269.619 298.978C269.341 299.352 269.051 299.981 268.761 300.84V305.229H267.661V299.836C267.661 299.135 267.588 298.724 267.455 298.603C267.322 298.482 267.201 298.421 267.08 298.421C266.838 298.421 266.584 298.627 266.306 299.05C266.028 299.473 265.762 300.005 265.508 300.67V305.241H264.359V305.217Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M273.658 305.217V293.778H274.976V299.026C275.351 298.422 275.81 297.938 276.342 297.599C276.874 297.261 277.406 297.079 277.938 297.079C278.386 297.079 278.797 297.188 279.172 297.418C279.546 297.648 279.8 297.926 279.945 298.252C280.066 298.506 280.139 298.772 280.187 299.05C280.236 299.328 280.248 299.909 280.248 300.792V305.217H278.942V300.634C278.942 299.873 278.906 299.377 278.833 299.123C278.76 298.869 278.627 298.675 278.434 298.518C278.241 298.361 278.023 298.289 277.793 298.289C277.334 298.289 276.838 298.506 276.306 298.942C275.774 299.377 275.338 299.933 274.988 300.598V305.205H273.658V305.217Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M287.66 303.428C287.261 304.093 286.777 304.589 286.209 304.927C285.641 305.266 285.121 305.435 284.649 305.435C283.984 305.435 283.392 305.145 282.86 304.577C282.327 304.008 282.074 303.138 282.074 301.977C282.074 301.058 282.243 300.248 282.594 299.522C282.944 298.797 283.416 298.228 283.996 297.817C284.577 297.394 285.302 297.188 286.173 297.188C286.427 297.188 286.801 297.213 287.309 297.261C287.382 297.273 287.503 297.285 287.648 297.297H288.966V308.289H287.648V303.428H287.66ZM287.66 301.868V298.47C287.188 298.349 286.753 298.289 286.354 298.289C285.544 298.289 284.867 298.603 284.323 299.232C283.779 299.861 283.513 300.719 283.513 301.795C283.513 302.581 283.658 303.174 283.96 303.573C284.25 303.972 284.589 304.178 284.976 304.178C285.387 304.178 285.846 303.972 286.342 303.549C286.838 303.126 287.261 302.569 287.66 301.868Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M291.506 305.544H290.212L297.201 293.888H298.459L291.506 305.544Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M301.904 305.217V294.879H299.534V293.778H303.222V304.117H305.689V305.217H301.904Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M311.747 305.435C310.61 305.435 309.703 305.036 309.026 304.25C308.349 303.464 308.01 302.46 308.01 301.251C308.01 300.042 308.349 299.051 309.026 298.265C309.703 297.479 310.61 297.08 311.747 297.08C312.871 297.08 313.778 297.479 314.455 298.265C315.133 299.051 315.471 300.054 315.471 301.251C315.471 302.448 315.133 303.452 314.455 304.25C313.778 305.036 312.871 305.435 311.747 305.435ZM311.747 304.335C312.448 304.335 313.004 304.057 313.428 303.512C313.839 302.968 314.044 302.207 314.044 301.251C314.044 300.296 313.839 299.546 313.428 299.002C313.017 298.458 312.448 298.18 311.747 298.18C311.046 298.18 310.477 298.458 310.066 299.002C309.655 299.546 309.449 300.296 309.449 301.251C309.449 302.207 309.655 302.968 310.066 303.512C310.477 304.057 311.033 304.335 311.747 304.335Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M320.454 305.435C319.317 305.435 318.41 305.036 317.733 304.25C317.056 303.464 316.718 302.46 316.718 301.251C316.718 300.042 317.056 299.051 317.733 298.265C318.41 297.479 319.317 297.08 320.454 297.08C321.578 297.08 322.485 297.479 323.162 298.265C323.84 299.051 324.178 300.054 324.178 301.251C324.178 302.448 323.84 303.452 323.162 304.25C322.485 305.036 321.578 305.435 320.454 305.435ZM320.454 304.335C321.155 304.335 321.711 304.057 322.135 303.512C322.546 302.968 322.751 302.207 322.751 301.251C322.751 300.296 322.546 299.546 322.135 299.002C321.724 298.458 321.155 298.18 320.454 298.18C319.753 298.18 319.184 298.458 318.773 299.002C318.362 299.546 318.156 300.296 318.156 301.251C318.156 302.207 318.362 302.968 318.773 303.512C319.184 304.057 319.741 304.335 320.454 304.335Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M325.314 305.217V297.309H326.475V299.123C326.838 298.349 327.176 297.817 327.491 297.527C327.805 297.236 328.119 297.091 328.446 297.091C328.833 297.091 329.135 297.236 329.365 297.539C329.595 297.841 329.715 298.264 329.715 298.82V299.244C329.873 298.76 330.054 298.373 330.284 298.071C330.513 297.768 330.731 297.527 330.973 297.357C331.215 297.188 331.481 297.091 331.783 297.091C332.122 297.091 332.412 297.236 332.654 297.527C332.896 297.817 333.016 298.385 333.016 299.244V305.229H331.856V299.824C331.856 299.377 331.844 299.074 331.807 298.917C331.771 298.76 331.723 298.627 331.638 298.542C331.553 298.458 331.457 298.409 331.36 298.409C331.118 298.409 330.852 298.603 330.574 298.978C330.296 299.352 330.006 299.981 329.715 300.84V305.229H328.615V299.836C328.615 299.135 328.542 298.724 328.409 298.603C328.276 298.482 328.156 298.421 328.035 298.421C327.793 298.421 327.539 298.627 327.261 299.05C326.983 299.473 326.717 300.005 326.463 300.67V305.241H325.314V305.217Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M335.121 301.312V300.211H340.622V301.312H335.121Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M343.416 304.794V303.404C343.948 303.754 344.504 303.996 345.097 304.129C345.689 304.262 346.185 304.335 346.596 304.335C347.261 304.335 347.745 304.226 348.035 304.008C348.325 303.791 348.47 303.525 348.47 303.198C348.47 302.98 348.398 302.799 348.265 302.654C348.132 302.509 347.793 302.315 347.249 302.098L346.79 301.916L345.871 301.554C344.891 301.167 344.275 300.816 344.009 300.489C343.755 300.163 343.622 299.776 343.622 299.317C343.622 298.664 343.875 298.132 344.371 297.708C344.867 297.285 345.689 297.08 346.826 297.08C347.672 297.08 348.47 297.201 349.232 297.442V298.639C348.362 298.325 347.539 298.168 346.777 298.168C346.221 298.168 345.786 298.265 345.472 298.458C345.157 298.652 345 298.893 345 299.196C345 299.474 345.133 299.704 345.411 299.873C345.677 300.042 346.125 300.236 346.729 300.465L347.624 300.792C348.446 301.094 349.014 301.408 349.341 301.759C349.667 302.11 349.837 302.545 349.837 303.065C349.837 303.754 349.571 304.31 349.051 304.758C348.531 305.205 347.684 305.423 346.524 305.423C345.52 305.435 344.48 305.217 343.416 304.794Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M357.322 303.428C356.922 304.093 356.439 304.588 355.87 304.927C355.302 305.266 354.782 305.435 354.311 305.435C353.646 305.435 353.053 305.145 352.521 304.576C351.989 304.008 351.735 303.137 351.735 301.977C351.735 301.058 351.904 300.247 352.267 299.522C352.618 298.796 353.089 298.228 353.67 297.817C354.262 297.394 354.988 297.188 355.846 297.188C356.1 297.188 356.475 297.212 356.983 297.261C357.055 297.273 357.176 297.285 357.322 297.297V293.778H358.639V305.217H357.322V303.428ZM357.322 301.868V298.47C356.85 298.349 356.415 298.289 356.016 298.289C355.205 298.289 354.528 298.603 353.984 299.232C353.44 299.861 353.174 300.719 353.174 301.795C353.174 302.581 353.319 303.174 353.621 303.573C353.924 303.972 354.25 304.177 354.637 304.177C355.048 304.177 355.508 303.972 356.003 303.548C356.487 303.125 356.922 302.569 357.322 301.868Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M361.094 305.217V293.778H362.412V300.961L366.22 297.297H367.962L364.189 300.925L368.071 305.217H366.257L362.412 300.961V305.217H361.094Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M379.364 299.075C379.775 298.41 380.259 297.914 380.815 297.575C381.371 297.237 381.891 297.067 382.363 297.067C383.028 297.067 383.62 297.358 384.152 297.926C384.685 298.494 384.951 299.365 384.951 300.526C384.951 301.445 384.781 302.255 384.418 302.98C384.056 303.706 383.596 304.274 383.016 304.685C382.435 305.096 381.71 305.314 380.839 305.314C380.598 305.314 380.211 305.29 379.703 305.241C379.63 305.229 379.509 305.217 379.364 305.205V308.276H378.046V297.285H379.364V299.075ZM379.364 300.647V304.044C379.836 304.165 380.283 304.226 380.682 304.226C381.48 304.226 382.157 303.911 382.701 303.283C383.246 302.654 383.524 301.795 383.524 300.707C383.524 299.921 383.379 299.329 383.076 298.93C382.774 298.531 382.435 298.337 382.061 298.337C381.65 298.337 381.202 298.543 380.706 298.966C380.211 299.389 379.763 299.945 379.364 300.647Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M388.978 305.217V294.879H386.608V293.778H390.296V304.117H392.762V305.217H388.978Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M400.767 303.44C400.368 304.093 399.885 304.601 399.316 304.928C398.748 305.266 398.24 305.423 397.757 305.423C397.092 305.423 396.499 305.133 395.979 304.565C395.459 303.997 395.193 303.126 395.193 301.965C395.193 301.046 395.362 300.236 395.713 299.51C396.064 298.785 396.535 298.217 397.116 297.806C397.696 297.394 398.434 297.177 399.292 297.177C399.546 297.177 399.921 297.201 400.429 297.249C400.501 297.261 400.622 297.273 400.767 297.286H402.085V302.872C402.085 303.827 402.182 304.601 402.388 305.194H401.009C400.913 304.783 400.828 304.19 400.767 303.44ZM400.767 301.868V298.471C400.296 298.35 399.861 298.289 399.461 298.289C398.651 298.289 397.974 298.604 397.43 299.232C396.886 299.861 396.62 300.72 396.62 301.796C396.62 302.582 396.765 303.174 397.067 303.573C397.37 303.972 397.696 304.178 398.083 304.178C398.494 304.178 398.954 303.972 399.449 303.549C399.933 303.126 400.38 302.57 400.767 301.868Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M407.188 304.903L403.536 297.297H404.987L407.901 303.246L410.331 297.297H411.662L408.602 304.649C407.949 306.196 407.345 307.224 406.752 307.732C406.16 308.24 405.41 308.494 404.491 308.494C404.092 308.494 403.729 308.458 403.415 308.385V307.224C403.778 307.333 404.128 307.394 404.455 307.394C404.878 307.394 405.253 307.309 405.591 307.152C405.93 306.994 406.22 306.692 406.498 306.281C406.764 305.858 406.958 305.495 407.079 305.193L407.188 304.903Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M418.275 303.428C417.876 304.093 417.393 304.589 416.825 304.927C416.256 305.266 415.736 305.435 415.265 305.435C414.6 305.435 414.007 305.145 413.475 304.577C412.943 304.008 412.689 303.138 412.689 301.977C412.689 301.058 412.858 300.248 413.209 299.522C413.56 298.797 414.031 298.228 414.612 297.817C415.192 297.406 415.93 297.188 416.788 297.188C417.042 297.188 417.417 297.213 417.925 297.261C417.997 297.273 418.118 297.285 418.263 297.297H419.582V302.896C419.582 304.226 419.569 305.036 419.533 305.338C419.497 305.629 419.448 305.931 419.364 306.233C419.17 306.934 418.747 307.491 418.07 307.902C417.393 308.313 416.583 308.506 415.627 308.506C414.672 308.506 413.693 308.265 412.713 307.769V306.439C413.088 306.693 413.548 306.922 414.092 307.116C414.636 307.309 415.168 307.406 415.676 307.406C416.075 307.406 416.462 307.346 416.812 307.213C417.175 307.08 417.465 306.898 417.683 306.656C417.901 306.415 418.058 306.136 418.143 305.822C418.227 305.508 418.263 305.084 418.263 304.552V303.428H418.275ZM418.275 301.868V298.47C417.804 298.349 417.369 298.289 416.97 298.289C416.159 298.289 415.482 298.603 414.938 299.232C414.394 299.861 414.128 300.719 414.128 301.795C414.128 302.581 414.273 303.174 414.575 303.573C414.878 303.972 415.204 304.178 415.591 304.178C416.002 304.178 416.462 303.972 416.958 303.549C417.441 303.126 417.876 302.569 418.275 301.868Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M422.363 305.217V297.309H423.681V299.038C424.092 298.385 424.564 297.901 425.096 297.575C425.628 297.248 426.22 297.091 426.873 297.091C427.345 297.091 427.828 297.164 428.3 297.309V300.163H427.03V298.361C426.813 298.325 426.631 298.3 426.51 298.3C426.015 298.3 425.543 298.494 425.059 298.881C424.576 299.268 424.128 299.848 423.681 300.622V305.217H422.363Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M433.657 305.435C432.52 305.435 431.613 305.036 430.936 304.25C430.259 303.464 429.92 302.46 429.92 301.251C429.92 300.042 430.259 299.051 430.936 298.265C431.613 297.479 432.52 297.08 433.657 297.08C434.781 297.08 435.688 297.479 436.365 298.265C437.042 299.051 437.381 300.054 437.381 301.251C437.381 302.448 437.042 303.452 436.365 304.25C435.676 305.036 434.781 305.435 433.657 305.435ZM433.657 304.335C434.358 304.335 434.914 304.057 435.338 303.512C435.749 302.968 435.954 302.207 435.954 301.251C435.954 300.296 435.749 299.546 435.338 299.002C434.926 298.458 434.358 298.18 433.657 298.18C432.943 298.18 432.387 298.458 431.976 299.002C431.565 299.546 431.347 300.296 431.347 301.251C431.347 302.207 431.553 302.968 431.976 303.512C432.399 304.057 432.943 304.335 433.657 304.335Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M445.616 297.297V305.205H444.298V303.463C443.874 304.116 443.403 304.6 442.883 304.927C442.363 305.253 441.843 305.41 441.323 305.41C440.864 305.41 440.44 305.289 440.053 305.035C439.666 304.781 439.4 304.467 439.243 304.056C439.086 303.645 439.013 302.859 439.013 301.698V297.272H440.331V301.855C440.331 302.617 440.368 303.113 440.44 303.367C440.513 303.621 440.646 303.814 440.839 303.971C441.033 304.129 441.25 304.201 441.468 304.201C441.928 304.201 442.423 303.983 442.955 303.548C443.487 303.113 443.923 302.557 444.273 301.892V297.285H445.616V297.297Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M447.804 305.217V297.309H449.122V299.038C449.497 298.434 449.956 297.95 450.488 297.611C451.02 297.273 451.552 297.091 452.084 297.091C452.556 297.091 452.979 297.212 453.354 297.466C453.729 297.72 454.007 298.034 454.164 298.446C454.321 298.857 454.394 299.631 454.394 300.816V305.241H453.076V300.658C453.076 299.897 453.04 299.401 452.967 299.147C452.895 298.893 452.761 298.7 452.568 298.542C452.374 298.385 452.157 298.313 451.927 298.313C451.468 298.313 450.972 298.53 450.44 298.966C449.908 299.401 449.472 299.957 449.122 300.622V305.229H447.804V305.217Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M461.806 303.428C461.407 304.093 460.923 304.588 460.355 304.927C459.787 305.266 459.267 305.435 458.795 305.435C458.13 305.435 457.538 305.145 457.006 304.576C456.474 304.008 456.22 303.137 456.22 301.977C456.22 301.058 456.389 300.247 456.752 299.522C457.102 298.796 457.574 298.228 458.154 297.817C458.747 297.394 459.472 297.188 460.331 297.188C460.585 297.188 460.96 297.212 461.467 297.261C461.54 297.273 461.661 297.285 461.806 297.297V293.778H463.124V305.217H461.806V303.428ZM461.806 301.868V298.47C461.334 298.349 460.899 298.289 460.5 298.289C459.69 298.289 459.013 298.603 458.469 299.232C457.925 299.861 457.659 300.719 457.659 301.795C457.659 302.581 457.804 303.174 458.106 303.573C458.408 303.972 458.735 304.177 459.122 304.177C459.533 304.177 459.992 303.972 460.488 303.548C460.972 303.125 461.419 302.569 461.806 301.868Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M464.624 301.36L472.314 297.515V298.748L467.054 301.36L472.314 304.008V305.218L464.624 301.36Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M474.37 305.544H473.076L480.065 293.888H481.322L474.37 305.544Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M482.641 305.217V293.778H483.959V299.026C484.334 298.422 484.793 297.938 485.325 297.599C485.857 297.261 486.389 297.079 486.921 297.079C487.369 297.079 487.78 297.188 488.155 297.418C488.529 297.648 488.783 297.926 488.928 298.252C489.049 298.506 489.122 298.772 489.17 299.05C489.219 299.328 489.231 299.909 489.231 300.792V305.217H487.913V300.634C487.913 299.873 487.876 299.377 487.804 299.123C487.731 298.869 487.598 298.675 487.405 298.518C487.211 298.361 486.994 298.289 486.764 298.289C486.304 298.289 485.809 298.506 485.277 298.942C484.745 299.377 484.309 299.933 483.959 300.598V305.205H482.641V305.217Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M494.273 304.117V295.64C493.874 295.955 493.487 296.221 493.112 296.438C492.737 296.656 492.229 296.886 491.576 297.116V295.931C492.616 295.495 493.511 294.927 494.273 294.226H495.591V304.129H498.239V305.229H491.588V304.129H494.273V304.117Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M507.151 301.36L499.46 305.205V303.984L504.72 301.36L499.46 298.712V297.502L507.151 301.36Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M194.698 321.916L202.389 318.071V319.304L197.129 321.916L202.389 324.564V325.773L194.698 321.916Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M209.293 323.984C208.894 324.649 208.411 325.145 207.842 325.484C207.274 325.822 206.754 325.991 206.283 325.991C205.617 325.991 205.025 325.701 204.493 325.133C203.961 324.565 203.707 323.694 203.707 322.533C203.707 321.614 203.876 320.804 204.227 320.079C204.578 319.353 205.049 318.785 205.63 318.374C206.21 317.962 206.935 317.745 207.806 317.745C208.06 317.745 208.435 317.769 208.943 317.817C209.015 317.829 209.136 317.842 209.281 317.854V314.335H210.599V325.774H209.281V323.984H209.293ZM209.293 322.424V319.027C208.822 318.906 208.387 318.845 207.988 318.845C207.177 318.845 206.5 319.16 205.956 319.788C205.412 320.417 205.146 321.276 205.146 322.352C205.146 323.138 205.291 323.73 205.593 324.129C205.884 324.528 206.222 324.734 206.609 324.734C207.02 324.734 207.48 324.528 207.975 324.105C208.471 323.682 208.894 323.126 209.293 322.424Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M214.928 325.773V318.953H212.727V317.853H216.246V324.673H218.447V325.773H214.928ZM214.71 314.999C214.71 314.697 214.807 314.479 215.013 314.334C215.218 314.189 215.412 314.117 215.581 314.117C215.762 314.117 215.956 314.189 216.162 314.334C216.367 314.479 216.464 314.697 216.464 314.999C216.464 315.29 216.367 315.507 216.162 315.652C215.956 315.797 215.762 315.87 215.581 315.87C215.4 315.87 215.206 315.797 215.013 315.652C214.819 315.507 214.71 315.29 214.71 314.999Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M223.997 325.774L220.563 317.866H222.014L224.735 324.141L227.492 317.866H228.81L225.34 325.774H223.997Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M245.484 325.543C244.602 325.846 243.755 325.991 242.957 325.991C242.159 325.991 241.458 325.809 240.841 325.447C240.224 325.084 239.741 324.588 239.402 323.959C239.063 323.331 238.882 322.617 238.882 321.819C238.882 320.622 239.269 319.618 240.055 318.832C240.841 318.047 241.784 317.647 242.884 317.647C243.707 317.647 244.565 317.805 245.472 318.107V319.377C244.553 318.953 243.731 318.748 243.005 318.748C242.522 318.748 242.074 318.869 241.651 319.111C241.228 319.352 240.901 319.715 240.672 320.223C240.442 320.731 240.321 321.251 240.321 321.783C240.321 322.496 240.539 323.173 240.986 323.826C241.433 324.479 242.135 324.794 243.09 324.794C243.38 324.794 243.658 324.77 243.936 324.733C244.215 324.697 244.735 324.54 245.484 324.286V325.543Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M249.668 325.774V315.435H247.298V314.335H250.986V324.673H253.453V325.774H249.668Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M261.445 323.996C261.046 324.649 260.563 325.157 259.994 325.483C259.426 325.822 258.906 325.979 258.435 325.979C257.77 325.979 257.177 325.689 256.657 325.12C256.137 324.552 255.871 323.682 255.871 322.521C255.871 321.602 256.04 320.792 256.391 320.066C256.742 319.341 257.213 318.772 257.794 318.361C258.374 317.938 259.1 317.732 259.97 317.732C260.224 317.732 260.599 317.757 261.107 317.805C261.179 317.817 261.3 317.829 261.445 317.841H262.763V323.428C262.763 324.383 262.86 325.157 263.066 325.749H261.687C261.591 325.338 261.506 324.746 261.445 323.996ZM261.458 322.424V319.026C260.986 318.905 260.551 318.845 260.152 318.845C259.341 318.845 258.664 319.159 258.12 319.788C257.576 320.417 257.31 321.275 257.31 322.352C257.31 323.137 257.455 323.73 257.757 324.129C258.048 324.528 258.386 324.734 258.773 324.734C259.184 324.734 259.644 324.528 260.14 324.105C260.635 323.682 261.058 323.125 261.458 322.424Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M265.049 325.35V323.96C265.581 324.31 266.137 324.552 266.73 324.685C267.322 324.818 267.818 324.891 268.229 324.891C268.894 324.891 269.378 324.782 269.668 324.564C269.958 324.347 270.103 324.081 270.103 323.754C270.103 323.537 270.031 323.355 269.898 323.21C269.765 323.065 269.426 322.872 268.882 322.654L268.423 322.472L267.504 322.11C266.524 321.723 265.907 321.372 265.641 321.046C265.388 320.719 265.254 320.332 265.254 319.873C265.254 319.22 265.508 318.688 266.004 318.265C266.512 317.841 267.322 317.636 268.459 317.636C269.305 317.636 270.103 317.757 270.865 317.999V319.196C269.994 318.881 269.172 318.724 268.41 318.724C267.854 318.724 267.419 318.821 267.105 319.014C266.79 319.208 266.633 319.45 266.633 319.752C266.633 320.03 266.766 320.26 267.044 320.429C267.31 320.598 267.758 320.792 268.362 321.021L269.257 321.348C270.079 321.65 270.647 321.965 270.974 322.315C271.3 322.666 271.47 323.101 271.47 323.621C271.47 324.31 271.204 324.867 270.684 325.314C270.164 325.761 269.317 325.979 268.157 325.979C267.153 325.991 266.113 325.774 265.049 325.35Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M273.755 325.35V323.96C274.287 324.31 274.843 324.552 275.435 324.685C276.028 324.818 276.524 324.891 276.935 324.891C277.6 324.891 278.083 324.782 278.374 324.564C278.664 324.347 278.809 324.081 278.809 323.754C278.809 323.537 278.736 323.355 278.603 323.21C278.47 323.065 278.132 322.872 277.588 322.654L277.128 322.472L276.209 322.11C275.23 321.723 274.613 321.372 274.347 321.046C274.093 320.719 273.96 320.332 273.96 319.873C273.96 319.22 274.214 318.688 274.71 318.265C275.218 317.841 276.028 317.636 277.164 317.636C278.011 317.636 278.809 317.757 279.571 317.999V319.196C278.7 318.881 277.878 318.724 277.116 318.724C276.56 318.724 276.124 318.821 275.81 319.014C275.496 319.208 275.339 319.45 275.339 319.752C275.339 320.03 275.472 320.26 275.75 320.429C276.016 320.598 276.463 320.792 277.068 321.021L277.962 321.348C278.785 321.65 279.353 321.965 279.679 322.315C280.006 322.666 280.175 323.101 280.175 323.621C280.175 324.31 279.909 324.867 279.389 325.314C278.869 325.761 278.023 325.979 276.862 325.979C275.859 325.991 274.819 325.774 273.755 325.35Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M283.477 325.773H282.159V314.782H283.453L287.334 322.097L287.757 323.186H287.794L287.757 322.097V314.782H289.075V325.773H287.757L283.985 318.579L283.453 317.418L283.477 318.554V325.773Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M296.281 323.996C295.882 324.649 295.399 325.157 294.83 325.483C294.262 325.822 293.742 325.979 293.27 325.979C292.605 325.979 292.013 325.689 291.493 325.12C290.973 324.552 290.707 323.682 290.707 322.521C290.707 321.602 290.876 320.792 291.227 320.066C291.578 319.341 292.049 318.772 292.63 318.361C293.21 317.938 293.936 317.732 294.806 317.732C295.06 317.732 295.435 317.757 295.943 317.805C296.015 317.817 296.136 317.829 296.281 317.841H297.599V323.428C297.599 324.383 297.696 325.157 297.902 325.749H296.523C296.426 325.338 296.342 324.746 296.281 323.996ZM296.281 322.424V319.026C295.81 318.905 295.375 318.845 294.975 318.845C294.165 318.845 293.488 319.159 292.944 319.788C292.4 320.417 292.134 321.275 292.134 322.352C292.134 323.137 292.279 323.73 292.581 324.129C292.872 324.528 293.21 324.734 293.597 324.734C294.008 324.734 294.468 324.528 294.963 324.105C295.459 323.682 295.894 323.125 296.281 322.424Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M299.184 325.773V317.865H300.345V319.679C300.708 318.905 301.046 318.373 301.361 318.083C301.675 317.793 301.989 317.647 302.316 317.647C302.703 317.647 303.005 317.793 303.235 318.095C303.465 318.397 303.586 318.82 303.586 319.377V319.8C303.743 319.316 303.924 318.929 304.154 318.627C304.384 318.325 304.601 318.083 304.843 317.913C305.085 317.744 305.351 317.647 305.653 317.647C305.992 317.647 306.282 317.793 306.524 318.083C306.766 318.373 306.887 318.941 306.887 319.8V325.785H305.726V320.38C305.726 319.933 305.714 319.631 305.677 319.473C305.641 319.316 305.593 319.183 305.508 319.098C305.423 319.014 305.327 318.965 305.23 318.965C304.988 318.965 304.722 319.159 304.444 319.534C304.166 319.909 303.876 320.537 303.586 321.396V325.785H302.485V320.392C302.485 319.691 302.413 319.28 302.28 319.159C302.147 319.038 302.026 318.978 301.905 318.978C301.663 318.978 301.409 319.183 301.131 319.606C300.853 320.03 300.587 320.562 300.333 321.227V325.797H299.184V325.773Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M315.073 325.241C314.021 325.737 313.017 325.991 312.086 325.991C311.373 325.991 310.732 325.809 310.176 325.459C309.619 325.108 309.16 324.6 308.821 323.935C308.483 323.27 308.313 322.569 308.313 321.819C308.313 321.093 308.471 320.404 308.797 319.739C309.124 319.074 309.571 318.554 310.139 318.179C310.72 317.804 311.361 317.623 312.062 317.623C313.005 317.623 313.755 317.962 314.323 318.627C314.891 319.292 315.182 320.332 315.182 321.722V322H309.728C309.728 322.544 309.837 323.052 310.067 323.512C310.297 323.971 310.599 324.31 310.974 324.54C311.349 324.769 311.772 324.878 312.243 324.878C313.09 324.878 314.033 324.6 315.061 324.02V325.241H315.073ZM309.813 321.033H313.755V320.839C313.755 320.199 313.598 319.679 313.283 319.304C312.969 318.929 312.546 318.735 312.014 318.735C311.482 318.735 311.022 318.929 310.623 319.316C310.224 319.703 309.958 320.271 309.813 321.033Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M324.298 320.163V321.263H316.608V320.163H324.298ZM324.298 322.642V323.742H316.608V322.642H324.298Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M328.772 314.117V314.999C328.434 315.084 328.167 315.217 327.998 315.386C327.829 315.556 327.684 315.761 327.575 316.015C327.466 316.269 327.418 316.583 327.418 316.946C327.853 316.946 328.18 317.067 328.385 317.321C328.591 317.575 328.7 317.829 328.7 318.107C328.7 318.433 328.579 318.712 328.349 318.941C328.119 319.171 327.853 319.28 327.539 319.28C327.14 319.28 326.801 319.111 326.511 318.772C326.221 318.433 326.076 317.962 326.076 317.369C326.076 316.849 326.184 316.354 326.414 315.894C326.644 315.435 326.946 315.048 327.333 314.721C327.732 314.395 328.216 314.189 328.772 314.117ZM332.242 314.117V314.999C331.904 315.084 331.638 315.217 331.469 315.386C331.299 315.556 331.154 315.761 331.045 316.015C330.937 316.269 330.888 316.583 330.888 316.946C331.323 316.946 331.65 317.067 331.855 317.321C332.061 317.575 332.17 317.829 332.17 318.107C332.17 318.433 332.049 318.712 331.819 318.941C331.589 319.171 331.323 319.28 331.009 319.28C330.61 319.28 330.259 319.111 329.981 318.772C329.703 318.433 329.558 317.962 329.558 317.369C329.558 316.849 329.667 316.354 329.897 315.894C330.126 315.435 330.429 315.048 330.816 314.721C331.203 314.395 331.674 314.189 332.242 314.117Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M339.909 323.984C339.51 324.649 339.026 325.145 338.458 325.484C337.89 325.822 337.37 325.991 336.898 325.991C336.233 325.991 335.641 325.701 335.109 325.133C334.576 324.565 334.323 323.694 334.323 322.533C334.323 321.614 334.492 320.804 334.842 320.079C335.193 319.353 335.665 318.785 336.245 318.374C336.826 317.962 337.551 317.745 338.422 317.745C338.676 317.745 339.05 317.769 339.558 317.817C339.631 317.829 339.752 317.842 339.897 317.854V314.335H341.215V325.774H339.897V323.984H339.909ZM339.909 322.424V319.027C339.437 318.906 339.002 318.845 338.603 318.845C337.793 318.845 337.116 319.16 336.572 319.788C336.027 320.417 335.761 321.276 335.761 322.352C335.761 323.138 335.907 323.73 336.209 324.129C336.499 324.528 336.838 324.734 337.225 324.734C337.636 324.734 338.095 324.528 338.591 324.105C339.087 323.682 339.51 323.126 339.909 322.424Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M349.896 325.241C348.844 325.737 347.841 325.991 346.91 325.991C346.196 325.991 345.555 325.809 344.999 325.459C344.443 325.108 343.983 324.6 343.645 323.935C343.306 323.27 343.137 322.569 343.137 321.819C343.137 321.093 343.294 320.404 343.621 319.739C343.947 319.074 344.395 318.554 344.963 318.179C345.543 317.804 346.184 317.623 346.886 317.623C347.829 317.623 348.578 317.962 349.147 318.627C349.715 319.292 350.005 320.332 350.005 321.722V322H344.552C344.552 322.544 344.673 323.052 344.902 323.512C345.132 323.971 345.434 324.31 345.809 324.54C346.184 324.769 346.607 324.878 347.079 324.878C347.925 324.878 348.869 324.6 349.896 324.02V325.241ZM344.636 321.033H348.578V320.839C348.578 320.199 348.421 319.679 348.107 319.304C347.792 318.929 347.369 318.735 346.837 318.735C346.305 318.735 345.846 318.929 345.459 319.316C345.072 319.703 344.794 320.271 344.636 321.033Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M351.433 325.773V317.865H352.594V319.679C352.957 318.905 353.295 318.373 353.609 318.083C353.924 317.793 354.238 317.647 354.565 317.647C354.952 317.647 355.254 317.793 355.496 318.095C355.738 318.397 355.846 318.82 355.846 319.377V319.8C356.004 319.316 356.197 318.929 356.415 318.627C356.632 318.325 356.862 318.083 357.092 317.913C357.322 317.744 357.6 317.647 357.902 317.647C358.241 317.647 358.531 317.793 358.773 318.083C359.015 318.373 359.135 318.941 359.135 319.8V325.785H357.975V320.38C357.975 319.933 357.963 319.631 357.926 319.473C357.89 319.316 357.842 319.183 357.757 319.098C357.672 319.014 357.576 318.965 357.479 318.965C357.237 318.965 356.971 319.159 356.693 319.534C356.415 319.909 356.125 320.537 355.834 321.396V325.785H354.734V320.392C354.734 319.691 354.661 319.28 354.528 319.159C354.395 319.038 354.275 318.978 354.154 318.978C353.912 318.978 353.658 319.183 353.38 319.606C353.102 320.03 352.836 320.562 352.582 321.227V325.797H351.433V325.773Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M363.996 325.991C362.859 325.991 361.952 325.592 361.275 324.806C360.598 324.02 360.259 323.017 360.259 321.807C360.259 320.598 360.598 319.607 361.275 318.821C361.952 318.035 362.859 317.636 363.996 317.636C365.12 317.636 366.027 318.035 366.704 318.821C367.381 319.607 367.72 320.61 367.72 321.807C367.72 323.005 367.381 324.008 366.704 324.806C366.027 325.592 365.12 325.991 363.996 325.991ZM363.996 324.891C364.697 324.891 365.253 324.613 365.677 324.069C366.088 323.524 366.293 322.763 366.293 321.807C366.293 320.852 366.088 320.103 365.677 319.558C365.265 319.014 364.697 318.736 363.996 318.736C363.282 318.736 362.726 319.014 362.315 319.558C361.904 320.103 361.686 320.852 361.686 321.807C361.686 322.763 361.892 323.524 362.315 324.069C362.738 324.613 363.282 324.891 363.996 324.891Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M369.957 321.867V320.767H375.459V321.867H369.957Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M379.364 319.631C379.775 318.966 380.259 318.47 380.815 318.131C381.371 317.793 381.891 317.623 382.363 317.623C383.028 317.623 383.62 317.914 384.152 318.482C384.685 319.05 384.951 319.921 384.951 321.082C384.951 322.001 384.781 322.811 384.418 323.536C384.056 324.262 383.596 324.83 383.016 325.241C382.435 325.652 381.71 325.87 380.839 325.87C380.598 325.87 380.211 325.846 379.703 325.797C379.63 325.785 379.509 325.773 379.364 325.761H378.046V314.322H379.364V319.631ZM379.364 321.203V324.6C379.836 324.721 380.283 324.782 380.682 324.782C381.48 324.782 382.157 324.467 382.701 323.839C383.246 323.21 383.524 322.351 383.524 321.263C383.524 320.477 383.379 319.885 383.076 319.485C382.774 319.086 382.435 318.893 382.061 318.893C381.65 318.893 381.202 319.099 380.706 319.522C380.211 319.945 379.763 320.501 379.364 321.203Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M393.367 317.853V325.761H392.049V324.02C391.626 324.673 391.154 325.157 390.634 325.483C390.114 325.81 389.594 325.967 389.074 325.967C388.615 325.967 388.192 325.846 387.805 325.592C387.418 325.338 387.152 325.024 386.995 324.613C386.837 324.202 386.765 323.416 386.765 322.255V317.829H388.083V322.412C388.083 323.174 388.119 323.669 388.192 323.923C388.264 324.177 388.397 324.371 388.591 324.528C388.784 324.685 389.002 324.758 389.22 324.758C389.679 324.758 390.175 324.54 390.707 324.105C391.239 323.669 391.674 323.113 392.025 322.448V317.841H393.367V317.853Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M402.181 325.447C401.565 325.701 401.117 325.858 400.839 325.906C400.561 325.955 400.295 325.979 400.029 325.979C399.473 325.979 398.965 325.87 398.518 325.665C398.07 325.459 397.72 325.133 397.478 324.721C397.236 324.31 397.127 323.657 397.127 322.799V319.607H395.156V318.506H397.127V315.314H398.445V318.506H401.964V319.607H398.445V322.775C398.445 323.415 398.518 323.863 398.675 324.129C398.832 324.395 399.026 324.588 399.279 324.709C399.533 324.83 399.836 324.891 400.174 324.891C400.815 324.891 401.48 324.685 402.181 324.286V325.447Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M410.888 325.447C410.271 325.701 409.824 325.858 409.546 325.906C409.268 325.955 409.002 325.979 408.736 325.979C408.179 325.979 407.672 325.87 407.224 325.665C406.777 325.459 406.426 325.133 406.184 324.721C405.942 324.31 405.834 323.657 405.834 322.799V319.607H403.863V318.506H405.834V315.314H407.152V318.506H410.67V319.607H407.152V322.775C407.152 323.415 407.224 323.863 407.381 324.129C407.538 324.395 407.732 324.588 407.986 324.709C408.24 324.83 408.542 324.891 408.881 324.891C409.522 324.891 410.187 324.685 410.888 324.286V325.447Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M416.233 325.991C415.096 325.991 414.189 325.592 413.512 324.806C412.835 324.02 412.497 323.017 412.497 321.807C412.497 320.598 412.835 319.607 413.512 318.821C414.189 318.035 415.096 317.636 416.233 317.636C417.357 317.636 418.264 318.035 418.942 318.821C419.619 319.607 419.957 320.61 419.957 321.807C419.957 323.005 419.619 324.008 418.942 324.806C418.264 325.592 417.357 325.991 416.233 325.991ZM416.233 324.891C416.934 324.891 417.491 324.613 417.914 324.069C418.325 323.524 418.53 322.763 418.53 321.807C418.53 320.852 418.325 320.103 417.914 319.558C417.503 319.014 416.934 318.736 416.233 318.736C415.519 318.736 414.963 319.014 414.552 319.558C414.141 320.103 413.923 320.852 413.923 321.807C413.923 322.763 414.129 323.524 414.552 324.069C414.975 324.613 415.532 324.891 416.233 324.891Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M421.686 325.773V317.865H423.004V319.594C423.379 318.99 423.839 318.506 424.371 318.167C424.903 317.829 425.435 317.647 425.967 317.647C426.438 317.647 426.862 317.768 427.236 318.022C427.611 318.276 427.889 318.591 428.047 319.002C428.204 319.413 428.276 320.187 428.276 321.372V325.797H426.958V321.215C426.958 320.453 426.922 319.957 426.849 319.703C426.777 319.449 426.644 319.256 426.45 319.098C426.257 318.941 426.039 318.869 425.809 318.869C425.35 318.869 424.854 319.086 424.322 319.522C423.79 319.957 423.355 320.513 423.004 321.178V325.785H421.686V325.773Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M430.573 319.28V318.397C430.912 318.313 431.178 318.18 431.347 318.01C431.517 317.841 431.662 317.635 431.77 317.381C431.879 317.128 431.928 316.813 431.928 316.45C431.492 316.45 431.166 316.329 430.96 316.076C430.755 315.822 430.646 315.568 430.646 315.29C430.646 314.963 430.767 314.685 430.997 314.455C431.226 314.226 431.492 314.117 431.807 314.117C432.206 314.117 432.544 314.286 432.835 314.625C433.125 314.963 433.27 315.435 433.27 316.027C433.27 316.547 433.161 317.043 432.931 317.502C432.701 317.962 432.399 318.349 432.012 318.675C431.613 319.002 431.13 319.207 430.573 319.28ZM434.032 319.28V318.397C434.37 318.313 434.624 318.18 434.805 318.01C434.987 317.841 435.132 317.635 435.241 317.381C435.35 317.128 435.398 316.813 435.398 316.45C434.963 316.45 434.636 316.329 434.431 316.076C434.225 315.822 434.116 315.568 434.116 315.29C434.116 314.963 434.237 314.685 434.467 314.455C434.697 314.226 434.963 314.117 435.265 314.117C435.664 314.117 436.015 314.286 436.305 314.625C436.595 314.963 436.74 315.435 436.74 316.027C436.74 316.547 436.631 317.043 436.402 317.502C436.172 317.962 435.869 318.349 435.483 318.675C435.071 319.002 434.6 319.207 434.032 319.28Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M446.196 321.916L438.505 325.761V324.54L443.766 321.916L438.505 319.268V318.059L446.196 321.916Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M212.111 342.473L219.802 338.627V339.861L214.542 342.473L219.802 345.121V346.33L212.111 342.473Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M222.631 340.187C223.042 339.522 223.525 339.026 224.082 338.688C224.638 338.349 225.158 338.18 225.629 338.18C226.294 338.18 226.887 338.47 227.419 339.038C227.951 339.607 228.217 340.477 228.217 341.638C228.217 342.557 228.036 343.367 227.685 344.093C227.334 344.818 226.863 345.387 226.282 345.798C225.702 346.209 224.976 346.427 224.106 346.427C223.864 346.427 223.477 346.402 222.969 346.354C222.897 346.342 222.776 346.33 222.631 346.318H221.313V334.879H222.631V340.187ZM222.631 341.759V345.157C223.102 345.278 223.55 345.338 223.949 345.338C224.747 345.338 225.424 345.024 225.968 344.395C226.512 343.766 226.79 342.908 226.79 341.82C226.79 341.034 226.645 340.441 226.343 340.042C226.04 339.643 225.702 339.45 225.327 339.45C224.916 339.45 224.469 339.655 223.973 340.078C223.477 340.502 223.03 341.058 222.631 341.759Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M236.633 338.409V346.317H235.315V344.576C234.891 345.229 234.42 345.712 233.9 346.039C233.38 346.365 232.86 346.523 232.34 346.523C231.881 346.523 231.457 346.402 231.07 346.148C230.683 345.894 230.417 345.579 230.26 345.168C230.103 344.757 230.031 343.971 230.031 342.81V338.385H231.349V342.968C231.349 343.729 231.385 344.225 231.457 344.479C231.53 344.733 231.663 344.926 231.856 345.084C232.05 345.241 232.268 345.313 232.485 345.313C232.945 345.313 233.44 345.096 233.972 344.66C234.504 344.225 234.94 343.669 235.29 343.004V338.397H236.633V338.409Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M245.448 346.003C244.831 346.257 244.384 346.414 244.106 346.463C243.828 346.511 243.562 346.535 243.296 346.535C242.739 346.535 242.232 346.426 241.784 346.221C241.337 346.015 240.974 345.689 240.744 345.278C240.514 344.866 240.394 344.213 240.394 343.355V340.163H238.423V339.062H240.394V335.87H241.712V339.062H245.23V340.163H241.712V343.331C241.712 343.972 241.784 344.419 241.941 344.685C242.099 344.951 242.292 345.145 242.546 345.265C242.8 345.386 243.102 345.447 243.441 345.447C244.082 345.447 244.747 345.241 245.448 344.842V346.003Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M254.154 346.003C253.537 346.257 253.09 346.414 252.812 346.463C252.534 346.511 252.268 346.535 252.002 346.535C251.445 346.535 250.937 346.426 250.49 346.221C250.043 346.015 249.68 345.689 249.45 345.278C249.22 344.866 249.1 344.213 249.1 343.355V340.163H247.129V339.062H249.1V335.87H250.417V339.062H253.936V340.163H250.417V343.331C250.417 343.972 250.49 344.419 250.647 344.685C250.804 344.951 250.998 345.145 251.252 345.265C251.506 345.386 251.808 345.447 252.147 345.447C252.788 345.447 253.453 345.241 254.154 344.842V346.003Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M259.498 346.547C258.362 346.547 257.455 346.148 256.778 345.362C256.101 344.576 255.762 343.573 255.762 342.364C255.762 341.154 256.101 340.163 256.778 339.377C257.455 338.591 258.362 338.192 259.498 338.192C260.623 338.192 261.53 338.591 262.207 339.377C262.884 340.163 263.223 341.166 263.223 342.364C263.223 343.561 262.884 344.564 262.207 345.362C261.53 346.148 260.623 346.547 259.498 346.547ZM259.498 345.447C260.2 345.447 260.756 345.169 261.179 344.625C261.59 344.081 261.796 343.319 261.796 342.364C261.796 341.408 261.59 340.659 261.179 340.115C260.768 339.57 260.2 339.292 259.498 339.292C258.797 339.292 258.229 339.57 257.818 340.115C257.407 340.659 257.201 341.408 257.201 342.364C257.201 343.319 257.407 344.081 257.818 344.625C258.229 345.169 258.797 345.447 259.498 345.447Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M264.952 346.329V338.421H266.27V340.15C266.645 339.546 267.104 339.062 267.636 338.724C268.168 338.385 268.7 338.204 269.232 338.204C269.704 338.204 270.127 338.325 270.502 338.578C270.877 338.832 271.155 339.147 271.312 339.558C271.469 339.969 271.542 340.743 271.542 341.928V346.353H270.224V341.771C270.224 341.009 270.188 340.513 270.115 340.259C270.042 340.005 269.909 339.812 269.716 339.655C269.522 339.497 269.305 339.425 269.075 339.425C268.616 339.425 268.12 339.643 267.588 340.078C267.056 340.513 266.62 341.069 266.27 341.734V346.341H264.952V346.329Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M284.589 346.329V339.51H282.388V338.409H285.907V345.229H288.108V346.329H284.589ZM284.372 335.556C284.372 335.253 284.468 335.036 284.674 334.89C284.879 334.745 285.073 334.673 285.242 334.673C285.424 334.673 285.617 334.745 285.823 334.89C286.028 335.036 286.125 335.253 286.125 335.556C286.125 335.846 286.028 336.063 285.823 336.208C285.617 336.354 285.424 336.426 285.242 336.426C285.061 336.426 284.867 336.354 284.674 336.208C284.48 336.063 284.372 335.846 284.372 335.556Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M296.366 344.54C295.967 345.205 295.484 345.701 294.915 346.04C294.347 346.378 293.827 346.548 293.356 346.548C292.691 346.548 292.098 346.257 291.566 345.689C291.034 345.121 290.78 344.25 290.78 343.089C290.78 342.17 290.949 341.36 291.3 340.635C291.651 339.909 292.122 339.341 292.703 338.93C293.283 338.519 294.009 338.301 294.879 338.301C295.133 338.301 295.508 338.325 296.016 338.374C296.088 338.386 296.209 338.398 296.354 338.41V334.891H297.672V346.33H296.354V344.54H296.366ZM296.366 342.981V339.583C295.895 339.462 295.46 339.401 295.061 339.401C294.25 339.401 293.573 339.716 293.029 340.345C292.485 340.973 292.219 341.832 292.219 342.908C292.219 343.694 292.364 344.286 292.666 344.685C292.957 345.085 293.295 345.29 293.682 345.29C294.093 345.29 294.553 345.084 295.048 344.661C295.544 344.238 295.979 343.682 296.366 342.981Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M306.886 340.719V341.819H299.196V340.719H306.886ZM306.886 343.198V344.298H299.196V343.198H306.886Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M311.36 334.673V335.556C311.022 335.64 310.756 335.773 310.586 335.942C310.417 336.112 310.272 336.317 310.163 336.571C310.054 336.825 310.006 337.14 310.006 337.502C310.441 337.502 310.768 337.623 310.973 337.877C311.179 338.131 311.288 338.385 311.288 338.663C311.288 338.99 311.167 339.268 310.937 339.497C310.707 339.727 310.441 339.836 310.127 339.836C309.728 339.836 309.389 339.667 309.099 339.328C308.809 338.99 308.664 338.518 308.664 337.926C308.664 337.406 308.773 336.91 309.002 336.45C309.232 335.991 309.535 335.604 309.921 335.277C310.32 334.951 310.792 334.745 311.36 334.673ZM314.819 334.673V335.556C314.48 335.64 314.214 335.773 314.045 335.942C313.876 336.112 313.73 336.317 313.622 336.571C313.513 336.825 313.464 337.14 313.464 337.502C313.9 337.502 314.226 337.623 314.432 337.877C314.637 338.131 314.746 338.385 314.746 338.663C314.746 338.99 314.625 339.268 314.395 339.497C314.166 339.727 313.9 339.836 313.585 339.836C313.186 339.836 312.836 339.667 312.557 339.328C312.279 338.99 312.134 338.518 312.134 337.926C312.134 337.406 312.243 336.91 312.473 336.45C312.703 335.991 313.005 335.604 313.392 335.277C313.791 334.951 314.262 334.745 314.819 334.673Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M320.211 347.418V346.305C319.897 346.305 319.57 346.293 319.22 346.257C318.869 346.221 318.555 346.172 318.265 346.1C317.962 346.027 317.624 345.906 317.237 345.737V344.383C317.551 344.54 317.853 344.685 318.156 344.794C318.458 344.903 318.772 345 319.111 345.06C319.449 345.12 319.812 345.169 320.211 345.205V341.263L319.45 340.852C318.011 340.078 317.285 339.147 317.285 338.059C317.285 337.478 317.527 336.91 317.998 336.366C318.47 335.822 319.208 335.495 320.199 335.411V334.238H321.191V335.411C321.747 335.411 322.412 335.507 323.174 335.701V336.922L322.92 336.85C322.206 336.656 321.626 336.535 321.191 336.487V340.344L321.989 340.804C322.738 341.239 323.246 341.662 323.524 342.073C323.803 342.484 323.936 342.932 323.936 343.403C323.936 343.827 323.827 344.226 323.621 344.625C323.416 345.024 323.113 345.362 322.714 345.64C322.315 345.918 321.807 346.124 321.191 346.233V347.442H320.211V347.418ZM320.211 339.752V336.475C319.74 336.584 319.365 336.765 319.111 337.019C318.857 337.273 318.724 337.563 318.724 337.902C318.724 338.216 318.833 338.518 319.05 338.808C319.268 339.099 319.667 339.413 320.211 339.752ZM321.203 341.844V345.108C321.723 344.927 322.061 344.697 322.243 344.431C322.424 344.165 322.521 343.863 322.521 343.536C322.521 343.21 322.436 342.944 322.255 342.714C322.073 342.484 321.723 342.194 321.203 341.844Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M328.688 341.819C329.123 342.049 329.449 342.279 329.655 342.496C329.861 342.714 330.018 342.944 330.114 343.186C330.211 343.415 330.26 343.693 330.26 343.996C330.26 344.262 330.211 344.612 330.114 345.048L329.933 345.858C329.836 346.293 329.788 346.62 329.788 346.837C329.788 347.128 329.897 347.369 330.127 347.575C330.356 347.78 330.816 347.877 331.517 347.877H332.618V348.978H331.505C330.211 348.978 329.377 348.772 329.002 348.349C328.627 347.938 328.446 347.466 328.446 346.934C328.446 346.656 328.482 346.354 328.555 346.039L328.688 345.471L328.809 344.854L328.893 344.479C328.929 344.31 328.942 344.129 328.942 343.972C328.942 343.536 328.796 343.161 328.494 342.847C328.192 342.533 327.684 342.375 326.934 342.375H326.306V341.275H326.934C327.672 341.275 328.192 341.118 328.482 340.816C328.772 340.513 328.93 340.126 328.93 339.667C328.93 339.498 328.917 339.328 328.881 339.171L328.796 338.808L328.676 338.192L328.543 337.623C328.47 337.297 328.434 336.995 328.434 336.717C328.434 336.197 328.615 335.725 328.99 335.314C329.365 334.891 330.199 334.685 331.493 334.685H332.605V335.785H331.505C330.816 335.785 330.344 335.882 330.127 336.088C329.909 336.293 329.788 336.535 329.788 336.825C329.788 337.031 329.836 337.357 329.933 337.805L330.114 338.615C330.211 339.05 330.26 339.401 330.26 339.667C330.26 339.969 330.211 340.235 330.114 340.477C330.018 340.707 329.861 340.937 329.655 341.166C329.449 341.396 329.123 341.589 328.688 341.819Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M334.734 346.329V335.338H336.886C338.18 335.338 339.038 335.435 339.474 335.628C339.909 335.822 340.235 336.112 340.453 336.499C340.671 336.886 340.78 337.321 340.78 337.805C340.78 338.192 340.719 338.554 340.586 338.905C340.453 339.256 340.272 339.57 340.018 339.86C339.764 340.15 339.401 340.416 338.929 340.67C339.8 341.021 340.393 341.444 340.707 341.964C341.021 342.472 341.166 342.98 341.166 343.5C341.166 343.984 341.033 344.455 340.78 344.915C340.514 345.374 340.151 345.725 339.679 345.967C339.208 346.208 338.446 346.329 337.406 346.329H334.734ZM336.16 340.283H337.66C338.144 340.078 338.506 339.86 338.724 339.643C338.954 339.413 339.111 339.171 339.232 338.893C339.353 338.615 339.401 338.312 339.401 337.986C339.401 337.466 339.244 337.079 338.942 336.825C338.639 336.571 338.047 336.438 337.164 336.438H336.16V340.283ZM336.16 345.229H337.515C338.264 345.229 338.833 345.048 339.196 344.697C339.558 344.346 339.74 343.911 339.74 343.415C339.74 343.052 339.643 342.714 339.437 342.4C339.232 342.085 338.93 341.843 338.518 341.662C338.107 341.481 337.454 341.384 336.56 341.384H336.16V345.229Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M343.113 335.326H344.54V342.544C344.54 343.5 344.625 344.141 344.782 344.491C344.939 344.842 345.181 345.108 345.508 345.289C345.834 345.471 346.197 345.567 346.596 345.567C347.019 345.567 347.394 345.471 347.732 345.277C348.071 345.084 348.313 344.769 348.47 344.358C348.627 343.947 348.712 343.149 348.712 342V335.338H350.03V342.52C350.03 343.548 349.885 344.346 349.57 344.927C349.256 345.507 348.869 345.942 348.373 346.233C347.878 346.523 347.261 346.668 346.523 346.668C345.834 346.668 345.229 346.535 344.71 346.281C344.19 346.027 343.791 345.64 343.524 345.132C343.258 344.624 343.126 343.705 343.126 342.363V335.326H343.113Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M354.564 346.329V336.547H351.276V335.338H359.292V336.547H356.003V346.329H354.564Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M363.27 346.329V336.547H359.981V335.338H367.998V336.547H364.709V346.329H363.27Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M372.69 346.656C371.444 346.656 370.489 346.136 369.836 345.084C369.183 344.032 368.845 342.617 368.845 340.827C368.845 339.05 369.171 337.623 369.836 336.583C370.501 335.543 371.444 335.011 372.69 335.011C373.947 335.011 374.891 335.543 375.556 336.583C376.221 337.623 376.535 339.05 376.535 340.827C376.535 342.617 376.209 344.032 375.556 345.084C374.903 346.136 373.947 346.656 372.69 346.656ZM372.69 345.555C373.379 345.555 373.959 345.168 374.419 344.382C374.878 343.596 375.108 342.411 375.108 340.827C375.108 339.243 374.878 338.046 374.419 337.272C373.959 336.499 373.379 336.099 372.69 336.099C372.001 336.099 371.432 336.486 370.961 337.272C370.489 338.058 370.272 339.243 370.272 340.827C370.272 342.411 370.501 343.609 370.961 344.382C371.42 345.156 372.001 345.555 372.69 345.555Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M379.256 346.329H377.938V335.338H379.232L383.113 342.653L383.537 343.742H383.573L383.537 342.653V335.338H384.855V346.329H383.537L379.764 339.135L379.232 337.974L379.256 339.111V346.329Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M386.257 347.417V346.317H393.947V347.417H386.257Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M395.688 346.329V345.229H398.106V336.426H395.688V335.326H401.952V336.426H399.533V345.229H401.952V346.329H395.688Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M404.273 346.329V335.338H406.885C408.082 335.338 408.977 335.543 409.557 335.967C410.138 336.39 410.573 337.019 410.875 337.865C411.178 338.711 411.311 339.715 411.311 340.864C411.311 341.964 411.153 342.919 410.851 343.754C410.549 344.588 410.101 345.217 409.533 345.664C408.965 346.112 408.082 346.329 406.885 346.329H404.273ZM405.7 345.108H406.655C407.623 345.108 408.312 344.939 408.723 344.588C409.134 344.237 409.424 343.766 409.606 343.149C409.787 342.533 409.872 341.686 409.872 340.61C409.872 339.558 409.763 338.748 409.557 338.179C409.352 337.611 409.049 337.176 408.663 336.874C408.276 336.571 407.647 336.414 406.764 336.414H405.7V345.108Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M416.704 341.819C416.269 341.59 415.942 341.36 415.737 341.142C415.531 340.925 415.374 340.695 415.277 340.453C415.18 340.211 415.132 339.945 415.132 339.643C415.132 339.377 415.18 339.026 415.265 338.591L415.447 337.781C415.543 337.345 415.592 337.019 415.592 336.801C415.592 336.511 415.483 336.269 415.253 336.064C415.023 335.858 414.564 335.761 413.862 335.761H412.762V334.661H413.875C415.168 334.661 416.003 334.867 416.378 335.29C416.752 335.713 416.934 336.173 416.934 336.693C416.934 336.971 416.898 337.273 416.825 337.599L416.692 338.168L416.571 338.784L416.486 339.147C416.45 339.329 416.438 339.498 416.438 339.667C416.438 340.102 416.583 340.477 416.885 340.792C417.188 341.106 417.696 341.263 418.445 341.263H419.074V342.364H418.445C417.708 342.364 417.188 342.521 416.885 342.823C416.583 343.125 416.438 343.512 416.438 343.972C416.438 344.141 416.45 344.298 416.486 344.456L416.571 344.83L416.692 345.447L416.825 346.015C416.898 346.342 416.934 346.644 416.934 346.922C416.934 347.442 416.752 347.914 416.378 348.325C416.003 348.736 415.168 348.942 413.875 348.942H412.762V347.841H413.862C414.564 347.841 415.023 347.744 415.253 347.539C415.483 347.333 415.592 347.092 415.592 346.801C415.592 346.596 415.543 346.269 415.447 345.834L415.265 345.024C415.18 344.589 415.132 344.238 415.132 343.972C415.132 343.67 415.18 343.404 415.277 343.162C415.374 342.92 415.531 342.702 415.737 342.472C415.942 342.243 416.269 342.049 416.704 341.819Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M421.868 339.836V338.953C422.206 338.869 422.472 338.736 422.642 338.566C422.811 338.397 422.956 338.192 423.065 337.938C423.174 337.684 423.222 337.369 423.222 337.007C422.787 337.007 422.46 336.886 422.255 336.632C422.049 336.378 421.94 336.124 421.94 335.846C421.94 335.519 422.061 335.241 422.291 335.011C422.521 334.782 422.787 334.673 423.101 334.673C423.5 334.673 423.839 334.842 424.129 335.181C424.419 335.519 424.564 335.991 424.564 336.583C424.564 337.103 424.456 337.599 424.226 338.059C423.996 338.518 423.694 338.905 423.307 339.231C422.908 339.558 422.424 339.763 421.868 339.836ZM425.326 339.836V338.953C425.665 338.869 425.919 338.736 426.1 338.566C426.281 338.397 426.427 338.192 426.535 337.938C426.644 337.684 426.692 337.369 426.692 337.007C426.257 337.007 425.931 336.886 425.725 336.632C425.52 336.378 425.411 336.124 425.411 335.846C425.411 335.519 425.532 335.241 425.761 335.011C425.991 334.782 426.257 334.673 426.559 334.673C426.958 334.673 427.309 334.842 427.599 335.181C427.89 335.519 428.035 335.991 428.035 336.583C428.035 337.103 427.926 337.599 427.696 338.059C427.466 338.518 427.164 338.905 426.777 339.231C426.366 339.558 425.894 339.763 425.326 339.836Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M437.49 342.472L429.8 346.317V345.096L435.06 342.472L429.8 339.824V338.615L437.49 342.472Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M440.489 341.65V346.329H439.062V335.338H442C442.955 335.338 443.669 335.435 444.116 335.628C444.576 335.822 444.914 336.124 445.168 336.511C445.422 336.898 445.543 337.333 445.543 337.793C445.543 338.216 445.458 338.639 445.289 339.074C445.132 339.51 444.902 339.884 444.612 340.223C444.322 340.562 443.898 340.876 443.354 341.178L446.534 346.317H444.829L441.915 341.638H440.489V341.65ZM440.489 340.549H442.484C442.931 340.308 443.27 340.054 443.487 339.8C443.705 339.546 443.874 339.268 443.983 338.99C444.092 338.699 444.152 338.409 444.152 338.119C444.152 337.599 443.971 337.188 443.596 336.886C443.221 336.583 442.544 336.426 441.553 336.426H440.489V340.549Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M454.395 345.798C453.343 346.293 452.339 346.547 451.408 346.547C450.695 346.547 450.054 346.366 449.498 346.015C448.941 345.664 448.482 345.157 448.143 344.492C447.805 343.827 447.635 343.125 447.635 342.376C447.635 341.65 447.793 340.961 448.119 340.296C448.446 339.631 448.893 339.111 449.461 338.736C450.042 338.361 450.683 338.18 451.384 338.18C452.327 338.18 453.077 338.518 453.645 339.183C454.213 339.848 454.504 340.888 454.504 342.279V342.557H449.05C449.05 343.101 449.171 343.609 449.401 344.068C449.631 344.528 449.933 344.866 450.308 345.096C450.683 345.326 451.106 345.435 451.577 345.435C452.424 345.435 453.367 345.157 454.395 344.576V345.798ZM449.123 341.59H453.065V341.396C453.065 340.755 452.907 340.235 452.593 339.86C452.279 339.486 451.856 339.292 451.324 339.292C450.792 339.292 450.332 339.486 449.945 339.873C449.558 340.259 449.28 340.828 449.123 341.59Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M463.173 346.1C462.29 346.402 461.444 346.547 460.645 346.547C459.847 346.547 459.146 346.366 458.529 346.003C457.913 345.64 457.429 345.144 457.09 344.516C456.752 343.887 456.571 343.173 456.571 342.375C456.571 341.178 456.957 340.175 457.743 339.389C458.529 338.603 459.473 338.204 460.573 338.204C461.395 338.204 462.254 338.361 463.161 338.663V339.933C462.242 339.51 461.419 339.304 460.694 339.304C460.21 339.304 459.763 339.425 459.339 339.667C458.916 339.909 458.59 340.271 458.36 340.779C458.13 341.287 458.009 341.807 458.009 342.339C458.009 343.052 458.239 343.73 458.675 344.383C459.11 345.036 459.823 345.35 460.778 345.35C461.069 345.35 461.347 345.326 461.625 345.289C461.903 345.253 462.423 345.096 463.173 344.842V346.1Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M468.481 346.547C467.345 346.547 466.438 346.148 465.761 345.362C465.084 344.576 464.745 343.573 464.745 342.364C464.745 341.154 465.084 340.163 465.761 339.377C466.438 338.591 467.345 338.192 468.481 338.192C469.606 338.192 470.513 338.591 471.19 339.377C471.867 340.163 472.206 341.166 472.206 342.364C472.206 343.561 471.867 344.564 471.19 345.362C470.513 346.148 469.606 346.547 468.481 346.547ZM468.481 345.447C469.183 345.447 469.739 345.169 470.162 344.625C470.573 344.081 470.779 343.319 470.779 342.364C470.779 341.408 470.573 340.659 470.162 340.115C469.751 339.57 469.183 339.292 468.481 339.292C467.768 339.292 467.212 339.57 466.801 340.115C466.389 340.659 466.172 341.408 466.172 342.364C466.172 343.319 466.377 344.081 466.801 344.625C467.224 345.169 467.768 345.447 468.481 345.447Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M474.599 346.329V338.421H475.917V340.15C476.329 339.497 476.8 339.014 477.332 338.687C477.864 338.361 478.457 338.204 479.11 338.204C479.581 338.204 480.065 338.276 480.536 338.421V341.275H479.267V339.473C479.049 339.437 478.868 339.413 478.747 339.413C478.251 339.413 477.78 339.606 477.296 339.993C476.812 340.38 476.365 340.961 475.917 341.734V346.329H474.599Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M487.937 344.54C487.538 345.205 487.054 345.701 486.486 346.04C485.918 346.378 485.398 346.548 484.926 346.548C484.261 346.548 483.669 346.257 483.136 345.689C482.604 345.121 482.35 344.25 482.35 343.089C482.35 342.17 482.52 341.36 482.883 340.635C483.233 339.909 483.705 339.341 484.285 338.93C484.878 338.507 485.603 338.301 486.462 338.301C486.716 338.301 487.091 338.325 487.598 338.374C487.671 338.386 487.792 338.398 487.937 338.41V334.891H489.255V346.33H487.937V344.54ZM487.937 342.981V339.583C487.465 339.462 487.03 339.401 486.631 339.401C485.821 339.401 485.144 339.716 484.6 340.345C484.055 340.973 483.789 341.832 483.789 342.908C483.789 343.694 483.935 344.286 484.237 344.685C484.539 345.085 484.866 345.29 485.253 345.29C485.664 345.29 486.123 345.084 486.619 344.661C487.09 344.238 487.538 343.682 487.937 342.981Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M490.754 342.473L498.445 338.627V339.861L493.185 342.473L498.445 345.121V346.33L490.754 342.473Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M500.488 346.656H499.194L506.184 334.999H507.441L500.488 346.656Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M509.98 340.187C510.391 339.522 510.875 339.026 511.431 338.688C511.987 338.349 512.507 338.18 512.979 338.18C513.644 338.18 514.236 338.47 514.768 339.038C515.3 339.607 515.566 340.477 515.566 341.638C515.566 342.557 515.397 343.367 515.034 344.093C514.672 344.818 514.212 345.387 513.632 345.798C513.051 346.209 512.326 346.427 511.455 346.427C511.213 346.427 510.826 346.402 510.319 346.354C510.246 346.342 510.125 346.33 509.98 346.318H508.662V334.879H509.98V340.187ZM509.98 341.759V345.157C510.452 345.278 510.899 345.338 511.298 345.338C512.096 345.338 512.773 345.024 513.317 344.395C513.861 343.766 514.14 342.908 514.14 341.82C514.14 341.034 513.995 340.441 513.692 340.042C513.39 339.643 513.051 339.45 512.677 339.45C512.265 339.45 511.818 339.655 511.322 340.078C510.827 340.502 510.379 341.058 509.98 341.759Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M523.983 338.409V346.317H522.665V344.576C522.241 345.229 521.77 345.712 521.25 346.039C520.73 346.365 520.21 346.523 519.69 346.523C519.23 346.523 518.807 346.402 518.42 346.148C518.033 345.894 517.767 345.579 517.61 345.168C517.453 344.757 517.38 343.971 517.38 342.81V338.385H518.698V342.968C518.698 343.729 518.735 344.225 518.807 344.479C518.88 344.733 519.013 344.926 519.206 345.084C519.4 345.241 519.617 345.313 519.835 345.313C520.295 345.313 520.79 345.096 521.322 344.66C521.854 344.225 522.29 343.669 522.64 343.004V338.397H523.983V338.409Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M532.797 346.003C532.18 346.257 531.733 346.414 531.455 346.463C531.176 346.511 530.911 346.535 530.645 346.535C530.088 346.535 529.58 346.426 529.133 346.221C528.686 346.015 528.335 345.689 528.093 345.278C527.851 344.866 527.742 344.213 527.742 343.355V340.163H525.771V339.062H527.742V335.87H529.06V339.062H532.579V340.163H529.06V343.331C529.06 343.972 529.133 344.419 529.29 344.685C529.447 344.951 529.641 345.145 529.895 345.265C530.149 345.386 530.451 345.447 530.79 345.447C531.43 345.447 532.095 345.241 532.797 344.842V346.003Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M541.504 346.003C540.887 346.257 540.44 346.414 540.162 346.463C539.884 346.511 539.618 346.535 539.352 346.535C538.795 346.535 538.287 346.426 537.84 346.221C537.393 346.015 537.042 345.689 536.8 345.278C536.558 344.866 536.449 344.213 536.449 343.355V340.163H534.479V339.062H536.449V335.87H537.768V339.062H541.286V340.163H537.768V343.331C537.768 343.972 537.84 344.419 537.997 344.685C538.154 344.951 538.348 345.145 538.602 345.265C538.856 345.386 539.158 345.447 539.497 345.447C540.138 345.447 540.803 345.241 541.504 344.842V346.003Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M546.849 346.547C545.712 346.547 544.805 346.148 544.128 345.362C543.451 344.576 543.112 343.573 543.112 342.364C543.112 341.154 543.451 340.163 544.128 339.377C544.805 338.591 545.712 338.192 546.849 338.192C547.973 338.192 548.88 338.591 549.557 339.377C550.234 340.163 550.573 341.166 550.573 342.364C550.573 343.561 550.234 344.564 549.557 345.362C548.88 346.148 547.973 346.547 546.849 346.547ZM546.849 345.447C547.55 345.447 548.106 345.169 548.529 344.625C548.94 344.081 549.146 343.319 549.146 342.364C549.146 341.408 548.94 340.659 548.529 340.115C548.118 339.57 547.55 339.292 546.849 339.292C546.135 339.292 545.579 339.57 545.168 340.115C544.757 340.659 544.539 341.408 544.539 342.364C544.539 343.319 544.745 344.081 545.168 344.625C545.591 345.169 546.135 345.447 546.849 345.447Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M552.301 346.329V338.421H553.619V340.15C553.994 339.546 554.454 339.062 554.986 338.724C555.518 338.385 556.05 338.204 556.582 338.204C557.053 338.204 557.477 338.325 557.852 338.578C558.226 338.832 558.504 339.147 558.662 339.558C558.819 339.969 558.891 340.743 558.891 341.928V346.353H557.573V341.771C557.573 341.009 557.537 340.513 557.464 340.259C557.392 340.005 557.259 339.812 557.066 339.655C556.872 339.497 556.654 339.425 556.425 339.425C555.965 339.425 555.469 339.643 554.937 340.078C554.405 340.513 553.97 341.069 553.619 341.734V346.341H552.301V346.329Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M568.106 342.472L560.416 346.317V345.096L565.676 342.472L560.416 339.824V338.615L568.106 342.472Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M194.698 363.028L202.389 359.183V360.416L197.129 363.028L202.389 365.676V366.885L194.698 363.028Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M204.432 367.212H203.139L210.128 355.556H211.385L204.432 367.212Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M217.999 365.096C217.6 365.761 217.117 366.257 216.549 366.595C215.98 366.934 215.46 367.103 214.989 367.103C214.324 367.103 213.731 366.813 213.199 366.245C212.667 365.676 212.413 364.806 212.413 363.645C212.413 362.726 212.582 361.916 212.933 361.19C213.284 360.465 213.755 359.897 214.336 359.485C214.916 359.074 215.642 358.857 216.512 358.857C216.766 358.857 217.141 358.881 217.649 358.929C217.721 358.941 217.842 358.953 217.987 358.965V355.447H219.305V366.886H217.987V365.096H217.999ZM217.999 363.536V360.138C217.528 360.017 217.093 359.957 216.694 359.957C215.883 359.957 215.206 360.271 214.662 360.9C214.118 361.529 213.852 362.387 213.852 363.464C213.852 364.25 213.997 364.842 214.299 365.241C214.59 365.64 214.928 365.846 215.315 365.846C215.726 365.846 216.186 365.64 216.682 365.217C217.177 364.794 217.6 364.238 217.999 363.536Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M223.634 366.886V360.066H221.433V358.966H224.952V365.786H227.152V366.886H223.634ZM223.416 356.112C223.416 355.81 223.513 355.592 223.718 355.447C223.924 355.302 224.117 355.229 224.287 355.229C224.468 355.229 224.662 355.302 224.867 355.447C225.073 355.592 225.169 355.81 225.169 356.112C225.169 356.402 225.073 356.62 224.867 356.765C224.662 356.91 224.468 356.983 224.287 356.983C224.105 356.983 223.912 356.91 223.718 356.765C223.525 356.62 223.416 356.402 223.416 356.112Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M232.703 366.886L229.269 358.978H230.72L233.441 365.253L236.198 358.978H237.516L234.045 366.886H232.703Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M245.931 363.028L238.241 366.873V365.652L243.501 363.028L238.241 360.38V359.17L245.931 363.028Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M177.286 383.584L184.977 379.739V380.972L179.717 383.584L184.977 386.232V387.441L177.286 383.584Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M187.02 387.768H185.726L192.716 376.111H193.973L187.02 387.768Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M200.588 385.652C200.188 386.317 199.705 386.813 199.136 387.152C198.568 387.49 198.048 387.659 197.577 387.659C196.912 387.659 196.319 387.369 195.787 386.801C195.255 386.233 195.001 385.362 195.001 384.201C195.001 383.282 195.17 382.472 195.521 381.747C195.872 381.021 196.343 380.453 196.924 380.042C197.504 379.63 198.23 379.413 199.1 379.413C199.354 379.413 199.729 379.437 200.237 379.485C200.309 379.497 200.43 379.51 200.575 379.522V376.003H201.893V387.442H200.575V385.652H200.588ZM200.588 384.092V380.695C200.116 380.574 199.681 380.513 199.282 380.513C198.471 380.513 197.794 380.828 197.25 381.456C196.706 382.085 196.44 382.944 196.44 384.02C196.44 384.806 196.585 385.398 196.887 385.797C197.178 386.196 197.516 386.402 197.903 386.402C198.314 386.402 198.774 386.196 199.269 385.773C199.765 385.35 200.188 384.794 200.588 384.092Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M206.222 387.441V380.621H204.021V379.521H207.54V386.341H209.741V387.441H206.222ZM206.005 376.667C206.005 376.365 206.101 376.147 206.307 376.002C206.512 375.857 206.706 375.785 206.875 375.785C207.057 375.785 207.25 375.857 207.456 376.002C207.661 376.147 207.758 376.365 207.758 376.667C207.758 376.958 207.661 377.175 207.456 377.32C207.25 377.465 207.057 377.538 206.875 377.538C206.694 377.538 206.5 377.465 206.307 377.32C206.113 377.175 206.005 376.958 206.005 376.667Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M215.279 387.442L211.844 379.534H213.296L216.016 385.809L218.773 379.534H220.091L216.621 387.442H215.279Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M228.519 383.584L220.829 387.429V386.208L226.089 383.584L220.829 380.936V379.727L228.519 383.584Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M147.649 396.341V397.224C147.311 397.309 147.045 397.442 146.875 397.611C146.694 397.78 146.561 397.986 146.452 398.24C146.343 398.494 146.295 398.808 146.295 399.171C146.73 399.171 147.057 399.292 147.262 399.546C147.468 399.8 147.577 400.053 147.577 400.332C147.577 400.658 147.456 400.936 147.226 401.166C146.996 401.396 146.73 401.504 146.416 401.504C146.017 401.504 145.678 401.335 145.388 400.997C145.098 400.658 144.953 400.187 144.953 399.594C144.953 399.074 145.062 398.578 145.291 398.119C145.521 397.659 145.823 397.272 146.21 396.946C146.597 396.619 147.081 396.414 147.649 396.341Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M153.659 411.069V410.186C153.997 410.102 154.263 409.969 154.433 409.799C154.602 409.63 154.747 409.424 154.856 409.158C154.965 408.892 155.013 408.59 155.013 408.227C154.578 408.227 154.251 408.106 154.046 407.853C153.84 407.599 153.731 407.345 153.731 407.055C153.731 406.728 153.852 406.45 154.082 406.232C154.312 406.015 154.578 405.894 154.892 405.894C155.291 405.894 155.63 406.063 155.92 406.402C156.21 406.74 156.355 407.212 156.355 407.804C156.355 408.324 156.246 408.808 156.017 409.279C155.787 409.751 155.485 410.138 155.098 410.464C154.711 410.791 154.227 410.996 153.659 411.069ZM154.892 402.169C154.578 402.169 154.3 402.061 154.082 401.831C153.864 401.601 153.743 401.335 153.743 401.021C153.743 400.694 153.852 400.428 154.082 400.198C154.312 399.969 154.578 399.86 154.892 399.86C155.207 399.86 155.473 399.969 155.702 400.198C155.932 400.428 156.041 400.694 156.041 401.021C156.041 401.335 155.932 401.613 155.702 401.831C155.473 402.048 155.207 402.169 154.892 402.169Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M167.117 448.88C166.234 449.183 165.388 449.328 164.59 449.328C163.792 449.328 163.091 449.146 162.474 448.784C161.857 448.421 161.374 447.925 161.035 447.296C160.696 446.668 160.515 445.954 160.515 445.156C160.515 443.959 160.902 442.955 161.688 442.169C162.474 441.383 163.417 440.984 164.517 440.984C165.34 440.984 166.198 441.142 167.105 441.444V442.713C166.186 442.29 165.364 442.085 164.638 442.085C164.155 442.085 163.707 442.206 163.284 442.448C162.861 442.689 162.534 443.052 162.305 443.56C162.075 444.068 161.954 444.588 161.954 445.12C161.954 445.833 162.172 446.51 162.619 447.163C163.066 447.816 163.768 448.131 164.723 448.131C165.013 448.131 165.291 448.106 165.569 448.07C165.847 448.034 166.367 447.877 167.117 447.623V448.88Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M172.425 449.328C171.289 449.328 170.382 448.929 169.705 448.143C169.028 447.357 168.689 446.353 168.689 445.144C168.689 443.935 169.028 442.943 169.705 442.157C170.382 441.371 171.289 440.972 172.425 440.972C173.55 440.972 174.457 441.371 175.134 442.157C175.811 442.943 176.15 443.947 176.15 445.144C176.15 446.341 175.811 447.345 175.134 448.143C174.457 448.929 173.55 449.328 172.425 449.328ZM172.425 448.227C173.127 448.227 173.683 447.949 174.106 447.405C174.517 446.861 174.723 446.099 174.723 445.144C174.723 444.189 174.517 443.439 174.106 442.895C173.695 442.351 173.127 442.073 172.425 442.073C171.724 442.073 171.156 442.351 170.745 442.895C170.334 443.439 170.128 444.189 170.128 445.144C170.128 446.099 170.334 446.861 170.745 447.405C171.156 447.949 171.712 448.227 172.425 448.227Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M177.878 449.11V441.202H179.196V442.931C179.571 442.327 180.031 441.843 180.563 441.504C181.095 441.166 181.627 440.984 182.159 440.984C182.63 440.984 183.054 441.105 183.428 441.359C183.803 441.613 184.081 441.928 184.239 442.339C184.396 442.75 184.468 443.524 184.468 444.709V449.134H183.15V444.551C183.15 443.79 183.114 443.294 183.042 443.04C182.969 442.786 182.836 442.593 182.642 442.435C182.449 442.278 182.231 442.206 182.002 442.206C181.542 442.206 181.046 442.423 180.514 442.859C179.982 443.294 179.547 443.85 179.196 444.515V449.122H177.878V449.11Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M186.682 448.687V447.296C187.214 447.647 187.77 447.889 188.363 448.022C188.955 448.155 189.451 448.227 189.862 448.227C190.527 448.227 191.011 448.118 191.301 447.901C191.591 447.683 191.736 447.417 191.736 447.091C191.736 446.873 191.664 446.692 191.531 446.546C191.398 446.401 191.059 446.208 190.515 445.99L190.056 445.809L189.137 445.446C188.157 445.059 187.541 444.709 187.274 444.382C187.021 444.056 186.888 443.669 186.888 443.209C186.888 442.556 187.141 442.024 187.637 441.601C188.145 441.178 188.955 440.972 190.092 440.972C190.938 440.972 191.736 441.093 192.498 441.335V442.532C191.628 442.218 190.805 442.06 190.043 442.06C189.487 442.06 189.052 442.157 188.738 442.351C188.423 442.544 188.266 442.786 188.266 443.088C188.266 443.366 188.399 443.596 188.677 443.765C188.943 443.935 189.391 444.128 189.995 444.358L190.89 444.684C191.712 444.987 192.28 445.301 192.607 445.652C192.933 446.002 193.103 446.438 193.103 446.958C193.103 447.647 192.837 448.203 192.317 448.651C191.797 449.098 190.95 449.316 189.79 449.316C188.786 449.328 187.746 449.11 186.682 448.687Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M201.905 448.784C201.288 449.038 200.841 449.195 200.563 449.243C200.285 449.292 200.019 449.316 199.753 449.316C199.196 449.316 198.689 449.207 198.241 449.001C197.794 448.796 197.431 448.469 197.201 448.058C196.972 447.647 196.851 446.994 196.851 446.136V442.943H194.88V441.843H196.851V438.651H198.169V441.843H201.687V442.943H198.169V446.112C198.169 446.752 198.241 447.2 198.398 447.466C198.556 447.732 198.749 447.925 199.003 448.046C199.257 448.167 199.559 448.228 199.898 448.228C200.539 448.228 201.204 448.022 201.905 447.623V448.784Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M213.925 442.967C214.336 442.302 214.819 441.806 215.376 441.468C215.932 441.129 216.452 440.96 216.923 440.96C217.588 440.96 218.181 441.25 218.713 441.818C219.245 442.387 219.511 443.257 219.511 444.418C219.511 445.337 219.33 446.147 218.979 446.873C218.628 447.598 218.157 448.167 217.576 448.578C216.996 448.989 216.27 449.206 215.4 449.206C215.158 449.206 214.771 449.182 214.263 449.134C214.191 449.122 214.07 449.11 213.925 449.098H212.607V437.659H213.925V442.967ZM213.925 444.539V447.937C214.396 448.058 214.844 448.118 215.243 448.118C216.041 448.118 216.718 447.804 217.262 447.175C217.806 446.546 218.084 445.688 218.084 444.599C218.084 443.813 217.939 443.221 217.637 442.822C217.334 442.423 216.996 442.229 216.621 442.229C216.21 442.229 215.763 442.435 215.267 442.858C214.771 443.269 214.324 443.838 213.925 444.539Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M227.927 441.189V449.097H226.609V447.356C226.186 448.009 225.714 448.493 225.194 448.819C224.674 449.146 224.154 449.303 223.635 449.303C223.175 449.303 222.752 449.182 222.365 448.928C221.978 448.674 221.712 448.36 221.555 447.949C221.398 447.537 221.325 446.751 221.325 445.591V441.165H222.643V445.748C222.643 446.51 222.679 447.005 222.752 447.259C222.824 447.513 222.957 447.707 223.151 447.864C223.344 448.021 223.562 448.094 223.78 448.094C224.239 448.094 224.735 447.876 225.267 447.441C225.799 447.005 226.234 446.449 226.585 445.784V441.177H227.927V441.189Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M236.742 448.784C236.125 449.038 235.678 449.195 235.4 449.243C235.122 449.292 234.856 449.316 234.59 449.316C234.033 449.316 233.526 449.207 233.078 449.001C232.631 448.796 232.268 448.469 232.038 448.058C231.808 447.647 231.688 446.994 231.688 446.136V442.943H229.717V441.843H231.688V438.651H232.993V441.843H236.512V442.943H232.993V446.112C232.993 446.752 233.066 447.2 233.223 447.466C233.38 447.732 233.574 447.925 233.828 448.046C234.082 448.167 234.384 448.228 234.723 448.228C235.363 448.228 236.029 448.022 236.73 447.623V448.784H236.742Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M245.448 448.784C244.831 449.038 244.384 449.195 244.106 449.243C243.828 449.292 243.562 449.316 243.296 449.316C242.739 449.316 242.232 449.207 241.784 449.001C241.337 448.796 240.974 448.469 240.744 448.058C240.514 447.647 240.394 446.994 240.394 446.136V442.943H238.423V441.843H240.394V438.651H241.712V441.843H245.23V442.943H241.712V446.112C241.712 446.752 241.784 447.2 241.941 447.466C242.099 447.732 242.292 447.925 242.546 448.046C242.8 448.167 243.102 448.228 243.441 448.228C244.082 448.228 244.747 448.022 245.448 447.623V448.784Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M250.792 449.328C249.656 449.328 248.749 448.929 248.072 448.143C247.395 447.357 247.056 446.353 247.056 445.144C247.056 443.935 247.395 442.943 248.072 442.157C248.749 441.371 249.656 440.972 250.792 440.972C251.917 440.972 252.824 441.371 253.501 442.157C254.178 442.943 254.517 443.947 254.517 445.144C254.517 446.341 254.178 447.345 253.501 448.143C252.824 448.929 251.917 449.328 250.792 449.328ZM250.792 448.227C251.494 448.227 252.05 447.949 252.473 447.405C252.884 446.861 253.09 446.099 253.09 445.144C253.09 444.189 252.884 443.439 252.473 442.895C252.062 442.351 251.494 442.073 250.792 442.073C250.091 442.073 249.523 442.351 249.112 442.895C248.701 443.439 248.495 444.189 248.495 445.144C248.495 446.099 248.701 446.861 249.112 447.405C249.523 447.949 250.091 448.227 250.792 448.227Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M256.246 449.11V441.202H257.564V442.931C257.939 442.327 258.398 441.843 258.93 441.504C259.462 441.166 259.994 440.984 260.526 440.984C260.998 440.984 261.421 441.105 261.796 441.359C262.171 441.613 262.449 441.928 262.606 442.339C262.763 442.75 262.836 443.524 262.836 444.709V449.134H261.518V444.551C261.518 443.79 261.482 443.294 261.409 443.04C261.336 442.786 261.203 442.593 261.01 442.435C260.816 442.278 260.599 442.206 260.369 442.206C259.91 442.206 259.414 442.423 258.882 442.859C258.35 443.294 257.914 443.85 257.564 444.515V449.122H256.246V449.11Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M280.756 443.499V444.599H273.066V443.499H280.756ZM280.756 445.978V447.078H273.066V445.978H280.756Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M291.747 449.11V441.202H293.065V442.931C293.477 442.278 293.948 441.795 294.48 441.468C295.012 441.142 295.605 440.984 296.258 440.984C296.729 440.984 297.213 441.057 297.684 441.202V444.056H296.415V442.254C296.197 442.218 296.016 442.194 295.895 442.194C295.399 442.194 294.928 442.387 294.444 442.774C293.96 443.161 293.513 443.741 293.065 444.515V449.11H291.747Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M303.041 449.328C301.904 449.328 300.997 448.929 300.32 448.143C299.643 447.357 299.304 446.353 299.304 445.144C299.304 443.935 299.643 442.943 300.32 442.157C300.997 441.371 301.904 440.972 303.041 440.972C304.165 440.972 305.072 441.371 305.749 442.157C306.426 442.943 306.765 443.947 306.765 445.144C306.765 446.341 306.426 447.345 305.749 448.143C305.072 448.929 304.165 449.328 303.041 449.328ZM303.041 448.227C303.742 448.227 304.298 447.949 304.722 447.405C305.133 446.861 305.338 446.099 305.338 445.144C305.338 444.189 305.133 443.439 304.722 442.895C304.31 442.351 303.742 442.073 303.041 442.073C302.339 442.073 301.771 442.351 301.36 442.895C300.949 443.439 300.743 444.189 300.743 445.144C300.743 446.099 300.949 446.861 301.36 447.405C301.771 447.949 302.327 448.227 303.041 448.227Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M311.747 449.328C310.61 449.328 309.703 448.929 309.026 448.143C308.349 447.357 308.01 446.353 308.01 445.144C308.01 443.935 308.349 442.943 309.026 442.157C309.703 441.371 310.61 440.972 311.747 440.972C312.871 440.972 313.778 441.371 314.455 442.157C315.133 442.943 315.471 443.947 315.471 445.144C315.471 446.341 315.133 447.345 314.455 448.143C313.778 448.929 312.871 449.328 311.747 449.328ZM311.747 448.227C312.448 448.227 313.004 447.949 313.428 447.405C313.839 446.861 314.044 446.099 314.044 445.144C314.044 444.189 313.839 443.439 313.428 442.895C313.017 442.351 312.448 442.073 311.747 442.073C311.046 442.073 310.477 442.351 310.066 442.895C309.655 443.439 309.449 444.189 309.449 445.144C309.449 446.099 309.655 446.861 310.066 447.405C310.477 447.949 311.033 448.227 311.747 448.227Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M323.814 448.784C323.198 449.038 322.75 449.195 322.472 449.243C322.194 449.292 321.928 449.316 321.662 449.316C321.106 449.316 320.598 449.207 320.151 449.001C319.703 448.796 319.34 448.469 319.111 448.058C318.881 447.647 318.76 446.994 318.76 446.136V442.943H316.789V441.843H318.76V438.651H320.078V441.843H323.597V442.943H320.078V446.112C320.078 446.752 320.151 447.2 320.308 447.466C320.465 447.732 320.658 447.925 320.912 448.046C321.166 448.167 321.469 448.228 321.807 448.228C322.448 448.228 323.113 448.022 323.814 447.623V448.784Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M329.159 449.436C328.845 449.436 328.567 449.328 328.349 449.098C328.131 448.868 328.011 448.602 328.011 448.288C328.011 447.961 328.119 447.695 328.349 447.465C328.579 447.236 328.845 447.127 329.159 447.127C329.474 447.127 329.74 447.236 329.969 447.465C330.199 447.695 330.308 447.961 330.308 448.288C330.308 448.602 330.199 448.88 329.969 449.098C329.74 449.316 329.474 449.436 329.159 449.436Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M339.909 447.32C339.51 447.985 339.026 448.481 338.458 448.82C337.89 449.158 337.37 449.328 336.898 449.328C336.233 449.328 335.641 449.037 335.109 448.469C334.576 447.901 334.323 447.03 334.323 445.869C334.323 444.95 334.492 444.14 334.842 443.415C335.193 442.689 335.665 442.121 336.245 441.71C336.826 441.287 337.551 441.081 338.422 441.081C338.676 441.081 339.05 441.105 339.558 441.154C339.631 441.166 339.752 441.178 339.897 441.19H341.215V452.181H339.897V447.32H339.909ZM339.909 445.761V442.363C339.437 442.242 339.002 442.181 338.603 442.181C337.793 442.181 337.116 442.496 336.572 443.125C336.027 443.753 335.761 444.612 335.761 445.688C335.761 446.474 335.907 447.066 336.209 447.465C336.499 447.865 336.838 448.07 337.225 448.07C337.636 448.07 338.095 447.865 338.591 447.441C339.063 447.018 339.51 446.462 339.909 445.761Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M349.825 441.189V449.097H348.507V447.356C348.084 448.009 347.612 448.493 347.092 448.819C346.572 449.146 346.052 449.303 345.532 449.303C345.073 449.303 344.649 449.182 344.262 448.928C343.876 448.674 343.609 448.36 343.452 447.949C343.295 447.537 343.223 446.751 343.223 445.591V441.165H344.541V445.748C344.541 446.51 344.577 447.005 344.649 447.259C344.722 447.513 344.855 447.707 345.048 447.864C345.242 448.021 345.46 448.094 345.677 448.094C346.137 448.094 346.632 447.876 347.164 447.441C347.697 447.005 348.132 446.449 348.483 445.784V441.177H349.825V441.189Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M358.602 448.578C357.551 449.074 356.547 449.328 355.616 449.328C354.902 449.328 354.262 449.146 353.705 448.796C353.149 448.445 352.69 447.937 352.351 447.272C352.012 446.619 351.843 445.906 351.843 445.156C351.843 444.43 352 443.741 352.327 443.076C352.653 442.411 353.101 441.891 353.669 441.516C354.249 441.141 354.89 440.96 355.592 440.96C356.535 440.96 357.284 441.299 357.853 441.964C358.421 442.629 358.711 443.669 358.711 445.059V445.337H353.258C353.258 445.881 353.379 446.389 353.609 446.849C353.838 447.308 354.141 447.647 354.515 447.877C354.89 448.106 355.314 448.215 355.785 448.215C356.632 448.215 357.575 447.925 358.602 447.357V448.578ZM353.343 444.37H357.284V444.176C357.284 443.536 357.127 443.016 356.813 442.641C356.499 442.266 356.075 442.072 355.543 442.072C355.011 442.072 354.552 442.266 354.165 442.653C353.778 443.04 353.5 443.608 353.343 444.37Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M361.408 449.11V441.202H362.726V442.931C363.138 442.278 363.609 441.795 364.141 441.468C364.673 441.142 365.266 440.984 365.919 440.984C366.39 440.984 366.874 441.057 367.345 441.202V444.056H366.076V442.254C365.858 442.218 365.677 442.194 365.556 442.194C365.06 442.194 364.589 442.387 364.105 442.774C363.621 443.161 363.174 443.741 362.726 444.515V449.11H361.408Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M372.351 448.795L368.699 441.189H370.15L373.065 447.139L375.495 441.189H376.825L373.766 448.541C373.113 450.089 372.508 451.117 371.916 451.625C371.323 452.133 370.574 452.386 369.655 452.386C369.256 452.386 368.893 452.35 368.578 452.278V451.117C368.941 451.226 369.292 451.286 369.618 451.286C370.042 451.286 370.416 451.201 370.755 451.032C371.081 450.863 371.384 450.573 371.662 450.162C371.928 449.738 372.121 449.376 372.242 449.073L372.351 448.795Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M378.167 448.867V447.525C379.304 448.069 380.332 448.335 381.251 448.335C381.638 448.335 382.001 448.263 382.363 448.106C382.714 447.96 382.98 447.743 383.161 447.465C383.343 447.187 383.427 446.884 383.427 446.558C383.427 446.171 383.306 445.82 383.053 445.482C382.799 445.143 382.339 444.78 381.65 444.381L380.936 443.97L380.211 443.547C378.929 442.785 378.276 441.842 378.276 440.705C378.276 439.883 378.566 439.182 379.135 438.613C379.703 438.045 380.598 437.767 381.819 437.767C382.605 437.767 383.367 437.876 384.092 438.106V439.327C383.282 439.025 382.496 438.867 381.735 438.867C381.13 438.867 380.634 439.025 380.259 439.351C379.884 439.678 379.703 440.064 379.703 440.512C379.703 440.959 379.848 441.334 380.138 441.636C380.429 441.939 380.791 442.205 381.239 442.459L381.795 442.797L382.484 443.208L383.053 443.547C384.262 444.285 384.866 445.216 384.866 446.328C384.866 447.174 384.552 447.912 383.935 448.517C383.319 449.121 382.327 449.436 380.961 449.436C380.525 449.436 380.114 449.399 379.715 449.327C379.316 449.254 378.808 449.097 378.167 448.867Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M393.439 448.578C392.387 449.074 391.384 449.328 390.453 449.328C389.739 449.328 389.098 449.146 388.542 448.796C387.986 448.445 387.527 447.937 387.188 447.272C386.849 446.619 386.68 445.906 386.68 445.156C386.68 444.43 386.837 443.741 387.164 443.076C387.49 442.411 387.938 441.891 388.506 441.516C389.086 441.141 389.727 440.96 390.429 440.96C391.372 440.96 392.121 441.299 392.69 441.964C393.258 442.629 393.548 443.669 393.548 445.059V445.337H388.095C388.095 445.881 388.216 446.389 388.445 446.849C388.675 447.308 388.978 447.647 389.352 447.877C389.727 448.106 390.15 448.215 390.622 448.215C391.468 448.215 392.412 447.925 393.439 447.357V448.578ZM388.179 444.37H392.121V444.176C392.121 443.536 391.964 443.016 391.65 442.641C391.335 442.266 390.912 442.072 390.38 442.072C389.848 442.072 389.389 442.266 389.002 442.653C388.615 443.04 388.325 443.608 388.179 444.37Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M397.695 449.11V438.771H395.325V437.671H399.013V448.009H401.48V449.11H397.695Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M410.852 448.578C409.8 449.074 408.796 449.328 407.865 449.328C407.152 449.328 406.511 449.146 405.955 448.796C405.398 448.445 404.939 447.937 404.6 447.272C404.262 446.619 404.093 445.906 404.093 445.156C404.093 444.43 404.25 443.741 404.576 443.076C404.903 442.411 405.35 441.891 405.918 441.516C406.499 441.141 407.14 440.96 407.841 440.96C408.784 440.96 409.534 441.299 410.102 441.964C410.67 442.629 410.961 443.669 410.961 445.059V445.337H405.507C405.507 445.881 405.628 446.389 405.858 446.849C406.088 447.308 406.39 447.647 406.765 447.877C407.14 448.106 407.563 448.215 408.034 448.215C408.881 448.215 409.824 447.925 410.852 447.357V448.578ZM405.592 444.37H409.534V444.176C409.534 443.536 409.377 443.016 409.062 442.641C408.748 442.266 408.325 442.072 407.793 442.072C407.261 442.072 406.801 442.266 406.414 442.653C406.027 443.04 405.749 443.608 405.592 444.37Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M419.642 448.88C418.759 449.183 417.913 449.328 417.115 449.328C416.317 449.328 415.615 449.146 414.999 448.784C414.382 448.421 413.898 447.925 413.56 447.296C413.221 446.668 413.04 445.954 413.04 445.156C413.04 443.959 413.427 442.955 414.213 442.169C414.999 441.383 415.942 440.984 417.042 440.984C417.864 440.984 418.723 441.142 419.63 441.444V442.713C418.711 442.29 417.889 442.085 417.163 442.085C416.68 442.085 416.232 442.206 415.809 442.448C415.386 442.689 415.059 443.052 414.829 443.56C414.6 444.068 414.479 444.588 414.479 445.12C414.479 445.833 414.709 446.51 415.144 447.163C415.579 447.816 416.293 448.131 417.248 448.131C417.538 448.131 417.816 448.106 418.094 448.07C418.372 448.034 418.892 447.877 419.642 447.623V448.88Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M428.3 448.784C427.683 449.038 427.236 449.195 426.958 449.243C426.68 449.292 426.414 449.316 426.148 449.316C425.591 449.316 425.084 449.207 424.636 449.001C424.189 448.796 423.838 448.469 423.596 448.058C423.355 447.647 423.246 446.994 423.246 446.136V442.943H421.275V441.843H423.246V438.651H424.564V441.843H428.082V442.943H424.564V446.112C424.564 446.752 424.636 447.2 424.793 447.466C424.951 447.732 425.144 447.925 425.398 448.046C425.652 448.167 425.954 448.228 426.293 448.228C426.934 448.228 427.599 448.022 428.3 447.623V448.784Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M433.657 449.328C432.52 449.328 431.613 448.929 430.936 448.143C430.259 447.357 429.92 446.353 429.92 445.144C429.92 443.935 430.259 442.943 430.936 442.157C431.613 441.371 432.52 440.972 433.657 440.972C434.781 440.972 435.688 441.371 436.365 442.157C437.042 442.943 437.381 443.947 437.381 445.144C437.381 446.341 437.042 447.345 436.365 448.143C435.676 448.929 434.781 449.328 433.657 449.328ZM433.657 448.227C434.358 448.227 434.914 447.949 435.338 447.405C435.749 446.861 435.954 446.099 435.954 445.144C435.954 444.189 435.749 443.439 435.338 442.895C434.926 442.351 434.358 442.073 433.657 442.073C432.943 442.073 432.387 442.351 431.976 442.895C431.565 443.439 431.347 444.189 431.347 445.144C431.347 446.099 431.553 446.861 431.976 447.405C432.399 447.949 432.943 448.227 433.657 448.227Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M439.775 449.11V441.202H441.093V442.931C441.504 442.278 441.976 441.795 442.508 441.468C443.04 441.142 443.633 440.984 444.286 440.984C444.757 440.984 445.241 441.057 445.713 441.202V444.056H444.443V442.254C444.225 442.218 444.044 442.194 443.923 442.194C443.427 442.194 442.956 442.387 442.472 442.774C441.988 443.161 441.541 443.741 441.093 444.515V449.11H439.775Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M454.309 451.746C453.003 451.661 451.903 451.298 450.996 450.633C450.089 449.968 449.388 449.085 448.844 447.961C448.299 446.836 448.033 445.724 448.033 444.599C448.033 443.475 448.299 442.35 448.844 441.238C449.388 440.125 450.101 439.231 450.996 438.566C451.891 437.901 452.991 437.538 454.309 437.453V438.553C453.318 438.638 452.471 438.977 451.758 439.545C451.044 440.125 450.488 440.851 450.077 441.734C449.666 442.628 449.46 443.572 449.46 444.587C449.46 445.603 449.666 446.558 450.077 447.441C450.488 448.336 451.044 449.061 451.758 449.63C452.471 450.198 453.318 450.536 454.309 450.633V451.746Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M461.118 437.453V438.336C460.779 438.42 460.525 438.553 460.344 438.723C460.162 438.892 460.029 439.098 459.921 439.352C459.812 439.605 459.763 439.92 459.763 440.283C460.199 440.283 460.525 440.403 460.731 440.657C460.936 440.911 461.045 441.165 461.045 441.443C461.045 441.77 460.924 442.048 460.695 442.278C460.465 442.507 460.199 442.616 459.884 442.616C459.485 442.616 459.147 442.447 458.857 442.108C458.566 441.77 458.421 441.298 458.421 440.706C458.421 440.186 458.53 439.69 458.76 439.231C458.989 438.771 459.292 438.384 459.691 438.058C460.09 437.731 460.549 437.526 461.118 437.453Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M464.624 446.135V445.144H466.014L466.776 442.23H464.612V441.25H467.03L467.864 438.106H468.904L468.082 441.25H470.089L470.948 438.106H471.988L471.129 441.25H472.326V442.23H470.863L470.077 445.144H472.326V446.135H469.811L469.001 449.11H467.949L468.759 446.135H466.8L466.026 449.11H464.974L465.76 446.135H464.624ZM467.066 445.144H469.037L469.835 442.23H467.84L467.066 445.144Z",
        fill: "#00AE90"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M476.945 450.198V449.086C476.631 449.086 476.304 449.074 475.954 449.037C475.615 449.001 475.301 448.953 474.998 448.88C474.696 448.808 474.358 448.687 473.971 448.517V447.163C474.285 447.32 474.587 447.465 474.89 447.574C475.192 447.683 475.506 447.78 475.845 447.84C476.183 447.901 476.546 447.949 476.945 447.985V444.043L476.183 443.632C474.745 442.858 474.019 441.927 474.019 440.839C474.019 440.259 474.261 439.69 474.732 439.146C475.204 438.59 475.942 438.276 476.933 438.191V437.018H477.925V438.191C478.481 438.191 479.146 438.288 479.908 438.481V439.702L479.654 439.63C478.94 439.436 478.36 439.315 477.913 439.267V443.124L478.711 443.584C479.46 444.019 479.968 444.442 480.246 444.854C480.524 445.265 480.657 445.712 480.657 446.184C480.657 446.607 480.549 447.006 480.343 447.405C480.138 447.804 479.835 448.143 479.436 448.421C479.037 448.699 478.529 448.904 477.913 449.013V450.222H476.945V450.198ZM476.945 442.532V439.255C476.474 439.364 476.099 439.545 475.845 439.799C475.591 440.053 475.458 440.343 475.458 440.682C475.458 440.996 475.567 441.299 475.784 441.589C476.002 441.879 476.401 442.193 476.945 442.532ZM477.937 444.624V447.889C478.457 447.707 478.795 447.477 478.989 447.211C479.182 446.945 479.255 446.643 479.255 446.317C479.255 445.99 479.17 445.724 478.989 445.494C478.807 445.265 478.457 444.974 477.937 444.624Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M485.422 444.599C485.857 444.829 486.184 445.059 486.389 445.277C486.595 445.494 486.74 445.724 486.849 445.966C486.958 446.208 486.994 446.474 486.994 446.776C486.994 447.042 486.945 447.393 486.849 447.828L486.667 448.638C486.571 449.073 486.522 449.4 486.522 449.618C486.522 449.908 486.631 450.15 486.861 450.355C487.091 450.561 487.55 450.657 488.251 450.657H489.352V451.758H488.239C486.945 451.758 486.111 451.552 485.736 451.129C485.362 450.706 485.18 450.246 485.18 449.714C485.18 449.436 485.216 449.134 485.289 448.819L485.422 448.251L485.543 447.635L485.628 447.26C485.664 447.09 485.676 446.909 485.676 446.752C485.676 446.317 485.531 445.942 485.228 445.627C484.938 445.313 484.418 445.156 483.669 445.156H483.04V444.055H483.669C484.406 444.055 484.926 443.898 485.216 443.596C485.519 443.294 485.664 442.907 485.664 442.447C485.664 442.278 485.652 442.109 485.615 441.951L485.531 441.589L485.41 440.972L485.277 440.404C485.204 440.077 485.168 439.775 485.168 439.497C485.168 438.977 485.349 438.505 485.724 438.094C486.099 437.683 486.933 437.465 488.227 437.465H489.34V438.566H488.239C487.55 438.566 487.078 438.662 486.861 438.868C486.631 439.074 486.522 439.315 486.522 439.606C486.522 439.811 486.571 440.138 486.667 440.585L486.849 441.395C486.945 441.83 486.994 442.181 486.994 442.447C486.994 442.749 486.945 443.015 486.849 443.257C486.752 443.499 486.595 443.717 486.389 443.947C486.172 444.14 485.857 444.37 485.422 444.599Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M491.468 449.11V438.118H493.621C494.914 438.118 495.773 438.215 496.208 438.408C496.643 438.602 496.97 438.892 497.188 439.279C497.405 439.666 497.514 440.101 497.514 440.585C497.514 440.972 497.454 441.335 497.321 441.685C497.188 442.036 497.006 442.35 496.752 442.64C496.498 442.931 496.136 443.197 495.664 443.451C496.535 443.801 497.127 444.225 497.441 444.744C497.756 445.264 497.901 445.76 497.901 446.28C497.901 446.764 497.768 447.235 497.514 447.695C497.26 448.154 496.885 448.505 496.414 448.747C495.942 448.989 495.18 449.11 494.14 449.11H491.468ZM492.895 443.064H494.394C494.878 442.858 495.241 442.64 495.458 442.423C495.676 442.205 495.845 441.951 495.966 441.673C496.075 441.395 496.136 441.093 496.136 440.766C496.136 440.246 495.99 439.859 495.676 439.605C495.374 439.352 494.781 439.218 493.899 439.218H492.895V443.064ZM492.895 448.009H494.249C494.999 448.009 495.567 447.828 495.93 447.477C496.293 447.127 496.474 446.691 496.474 446.195C496.474 445.833 496.377 445.494 496.172 445.18C495.966 444.865 495.664 444.624 495.253 444.442C494.842 444.261 494.189 444.164 493.294 444.164H492.895V448.009Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M499.847 438.106H501.274V445.325C501.274 446.281 501.359 446.921 501.516 447.272C501.673 447.623 501.915 447.889 502.242 448.07C502.568 448.251 502.931 448.348 503.33 448.348C503.753 448.348 504.128 448.251 504.467 448.058C504.805 447.865 505.047 447.55 505.204 447.139C505.361 446.728 505.446 445.93 505.446 444.781V438.119H506.764V445.301C506.764 446.329 506.619 447.127 506.305 447.707C505.99 448.288 505.603 448.723 505.107 449.013C504.612 449.303 503.995 449.449 503.257 449.449C502.568 449.449 501.964 449.316 501.444 449.062C500.924 448.808 500.525 448.421 500.259 447.913C499.993 447.405 499.86 446.486 499.86 445.144V438.106H499.847Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M511.299 449.11V439.327H508.01V438.118H516.026V439.327H512.737V449.11H511.299Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M520.005 449.11V439.327H516.716V438.118H524.732V439.327H521.444V449.11H520.005Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M529.424 449.436C528.179 449.436 527.224 448.916 526.571 447.864C525.918 446.812 525.579 445.397 525.579 443.608C525.579 441.83 525.906 440.403 526.571 439.363C527.224 438.312 528.179 437.792 529.424 437.792C530.682 437.792 531.625 438.312 532.29 439.363C532.943 440.415 533.269 441.83 533.269 443.608C533.269 445.397 532.943 446.812 532.29 447.864C531.637 448.916 530.682 449.436 529.424 449.436ZM529.424 448.336C530.113 448.336 530.694 447.949 531.153 447.163C531.613 446.377 531.843 445.192 531.843 443.608C531.843 442.024 531.613 440.827 531.153 440.053C530.694 439.279 530.113 438.88 529.424 438.88C528.735 438.88 528.167 439.267 527.695 440.053C527.223 440.839 527.006 442.024 527.006 443.608C527.006 445.192 527.236 446.377 527.695 447.163C528.155 447.949 528.735 448.336 529.424 448.336Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M536.001 449.11H534.683V438.118H535.977L539.859 445.434L540.282 446.522H540.318L540.282 445.434V438.118H541.6V449.11H540.282L536.509 441.915L535.977 440.754L536.001 441.891V449.11Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M543.003 450.198V449.098H550.693V450.198H543.003Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M552.422 449.11V448.01H554.84V439.207H552.422V438.106H558.686V439.207H556.267V448.01H558.686V449.11H552.422Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M561.008 449.11V438.118H563.62C564.817 438.118 565.711 438.324 566.292 438.747C566.872 439.17 567.307 439.799 567.61 440.645C567.912 441.492 568.045 442.495 568.045 443.644C568.045 444.744 567.888 445.7 567.586 446.534C567.283 447.368 566.836 447.997 566.268 448.445C565.699 448.892 564.817 449.11 563.62 449.11H561.008ZM562.434 447.888H563.39C564.357 447.888 565.046 447.719 565.457 447.368C565.869 447.018 566.159 446.546 566.34 445.929C566.522 445.313 566.606 444.466 566.606 443.39C566.606 442.338 566.497 441.528 566.292 440.96C566.086 440.391 565.784 439.956 565.397 439.654C565.01 439.352 564.381 439.194 563.499 439.194H562.434V447.888Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M573.438 444.6C573.003 444.37 572.676 444.14 572.471 443.923C572.265 443.705 572.108 443.475 572.011 443.233C571.914 442.992 571.866 442.726 571.866 442.423C571.866 442.157 571.914 441.807 571.999 441.371L572.18 440.561C572.277 440.114 572.326 439.799 572.326 439.582C572.326 439.291 572.217 439.05 571.987 438.844C571.757 438.638 571.298 438.542 570.596 438.542H569.496V437.441H570.608C571.902 437.441 572.737 437.647 573.112 438.07C573.486 438.493 573.668 438.953 573.668 439.473C573.668 439.751 573.631 440.053 573.559 440.38L573.426 440.948L573.305 441.565L573.22 441.927C573.184 442.109 573.172 442.278 573.172 442.447C573.172 442.883 573.317 443.258 573.619 443.572C573.922 443.886 574.429 444.044 575.179 444.044H575.808V445.144H575.191C574.454 445.144 573.934 445.301 573.631 445.603C573.329 445.906 573.184 446.293 573.184 446.752C573.184 446.921 573.196 447.079 573.232 447.236L573.317 447.611L573.438 448.227L573.571 448.796C573.644 449.122 573.68 449.424 573.68 449.703C573.68 450.222 573.498 450.694 573.124 451.105C572.749 451.516 571.914 451.722 570.621 451.722H569.508V450.622H570.608C571.31 450.622 571.769 450.525 571.999 450.319C572.229 450.114 572.338 449.872 572.338 449.582C572.338 449.376 572.289 449.05 572.193 448.614L572.011 447.804C571.926 447.369 571.878 447.018 571.878 446.752C571.878 446.45 571.927 446.184 572.023 445.942C572.12 445.7 572.277 445.482 572.483 445.253C572.688 445.023 573.003 444.829 573.438 444.6Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M162.68 490.221V483.402H160.479V482.301H163.998V489.121H166.198V490.221H162.68ZM162.462 479.448C162.462 479.145 162.559 478.928 162.764 478.783C162.97 478.637 163.163 478.565 163.333 478.565C163.514 478.565 163.707 478.637 163.913 478.783C164.119 478.928 164.215 479.145 164.215 479.448C164.215 479.738 164.119 479.955 163.913 480.101C163.707 480.246 163.514 480.318 163.333 480.318C163.151 480.318 162.958 480.246 162.764 480.101C162.571 479.955 162.462 479.738 162.462 479.448Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M171.011 490.221V484.055H169.258V482.954H171.011V482.592C171.011 481.552 171.132 480.778 171.362 480.282C171.603 479.786 171.966 479.375 172.462 479.049C172.958 478.734 173.611 478.565 174.421 478.565C175.037 478.565 175.654 478.625 176.295 478.758V480.004C175.606 479.774 175.001 479.665 174.469 479.665C174.046 479.665 173.683 479.738 173.357 479.895C173.03 480.052 172.788 480.306 172.607 480.657C172.426 481.007 172.329 481.6 172.329 482.446V482.954H175.473V484.055H172.329V490.221H171.011Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M193.078 492.857C191.772 492.773 190.671 492.41 189.764 491.745C188.858 491.08 188.156 490.197 187.612 489.073C187.068 487.948 186.802 486.836 186.802 485.711C186.802 484.587 187.068 483.462 187.612 482.35C188.156 481.237 188.87 480.342 189.764 479.677C190.659 479.012 191.76 478.65 193.078 478.565V479.665C192.086 479.75 191.24 480.088 190.526 480.657C189.813 481.237 189.257 481.963 188.845 482.845C188.434 483.74 188.241 484.683 188.241 485.699C188.241 486.715 188.446 487.67 188.845 488.553C189.257 489.448 189.813 490.173 190.526 490.741C191.24 491.31 192.086 491.648 193.078 491.745V492.857Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M196.512 484.079C196.924 483.414 197.407 482.919 197.964 482.58C198.52 482.241 199.04 482.072 199.511 482.072C200.176 482.072 200.769 482.362 201.301 482.931C201.833 483.499 202.099 484.37 202.099 485.53C202.099 486.449 201.918 487.259 201.567 487.985C201.216 488.71 200.745 489.279 200.164 489.69C199.584 490.101 198.858 490.319 197.988 490.319C197.746 490.319 197.359 490.294 196.851 490.246C196.778 490.234 196.658 490.222 196.512 490.21H195.194V478.771H196.512V484.079ZM196.512 485.651V489.049C196.984 489.17 197.431 489.23 197.83 489.23C198.629 489.23 199.306 488.916 199.85 488.287C200.394 487.658 200.672 486.8 200.672 485.712C200.672 484.926 200.527 484.333 200.225 483.934C199.922 483.535 199.584 483.342 199.209 483.342C198.798 483.342 198.35 483.547 197.855 483.97C197.347 484.382 196.912 484.95 196.512 485.651Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M210.515 482.301V490.21H209.197V488.468C208.774 489.121 208.302 489.605 207.782 489.931C207.262 490.258 206.742 490.415 206.222 490.415C205.763 490.415 205.34 490.294 204.953 490.04C204.566 489.786 204.3 489.472 204.143 489.061C203.985 488.65 203.913 487.864 203.913 486.703V482.277H205.231V486.86C205.231 487.622 205.267 488.118 205.34 488.372C205.412 488.626 205.545 488.819 205.739 488.976C205.932 489.133 206.15 489.206 206.367 489.206C206.827 489.206 207.323 488.988 207.855 488.553C208.387 488.118 208.822 487.561 209.173 486.896V482.289H210.515V482.301Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M219.329 489.896C218.713 490.15 218.265 490.307 217.987 490.355C217.709 490.403 217.443 490.428 217.177 490.428C216.621 490.428 216.113 490.319 215.666 490.113C215.218 489.908 214.855 489.581 214.626 489.17C214.396 488.759 214.275 488.106 214.275 487.248V484.055H212.304V482.955H214.275V479.763H215.593V482.955H219.112V484.055H215.593V487.223C215.593 487.864 215.666 488.312 215.823 488.578C215.98 488.844 216.173 489.037 216.427 489.158C216.681 489.279 216.984 489.339 217.322 489.339C217.963 489.339 218.628 489.134 219.329 488.735V489.896Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M228.035 489.896C227.419 490.15 226.971 490.307 226.693 490.355C226.415 490.403 226.149 490.428 225.883 490.428C225.327 490.428 224.819 490.319 224.371 490.113C223.924 489.908 223.561 489.581 223.332 489.17C223.102 488.759 222.981 488.106 222.981 487.248V484.055H221.01V482.955H222.981V479.763H224.299V482.955H227.818V484.055H224.299V487.223C224.299 487.864 224.371 488.312 224.529 488.578C224.686 488.844 224.879 489.037 225.133 489.158C225.387 489.279 225.689 489.339 226.028 489.339C226.669 489.339 227.334 489.134 228.035 488.735V489.896Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M233.38 490.439C232.243 490.439 231.336 490.04 230.659 489.254C229.982 488.468 229.644 487.465 229.644 486.256C229.644 485.046 229.982 484.055 230.659 483.269C231.336 482.483 232.243 482.084 233.38 482.084C234.504 482.084 235.411 482.483 236.089 483.269C236.766 484.055 237.104 485.059 237.104 486.256C237.104 487.453 236.766 488.456 236.089 489.254C235.411 490.04 234.504 490.439 233.38 490.439ZM233.38 489.339C234.081 489.339 234.638 489.061 235.061 488.517C235.472 487.973 235.677 487.211 235.677 486.256C235.677 485.3 235.472 484.551 235.061 484.007C234.65 483.462 234.081 483.184 233.38 483.184C232.679 483.184 232.11 483.462 231.699 484.007C231.288 484.551 231.082 485.3 231.082 486.256C231.082 487.211 231.288 487.973 231.699 488.517C232.11 489.061 232.667 489.339 233.38 489.339Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M238.834 490.221V482.313H240.152V484.042C240.527 483.438 240.986 482.954 241.518 482.616C242.05 482.277 242.582 482.096 243.114 482.096C243.586 482.096 244.009 482.217 244.384 482.471C244.759 482.724 245.037 483.039 245.194 483.45C245.351 483.861 245.424 484.635 245.424 485.82V490.246H244.106V485.663C244.106 484.901 244.069 484.405 243.997 484.151C243.924 483.897 243.791 483.704 243.598 483.547C243.404 483.39 243.187 483.317 242.957 483.317C242.498 483.317 242.002 483.535 241.47 483.97C240.938 484.405 240.502 484.961 240.152 485.626V490.233H238.834V490.221Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M263.344 484.611V485.711H255.653V484.611H263.344ZM263.344 487.09V488.19H255.653V487.09H263.344Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M272.05 484.611V485.711H264.359V484.611H272.05ZM272.05 487.09V488.19H264.359V487.09H272.05Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M282.364 490.221V482.313H283.682V484.042C284.057 483.438 284.517 482.954 285.049 482.616C285.581 482.277 286.113 482.096 286.645 482.096C287.116 482.096 287.54 482.217 287.914 482.471C288.289 482.724 288.567 483.039 288.725 483.45C288.882 483.861 288.954 484.635 288.954 485.82V490.246H287.636V485.663C287.636 484.901 287.6 484.405 287.527 484.151C287.455 483.897 287.322 483.704 287.128 483.547C286.935 483.39 286.717 483.317 286.488 483.317C286.028 483.317 285.532 483.535 285 483.97C284.468 484.405 284.033 484.961 283.682 485.626V490.233H282.364V490.221Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M297.588 482.301V490.21H296.27V488.468C295.847 489.121 295.375 489.605 294.855 489.931C294.335 490.258 293.815 490.415 293.295 490.415C292.836 490.415 292.413 490.294 292.026 490.04C291.639 489.786 291.373 489.472 291.216 489.061C291.058 488.65 290.986 487.864 290.986 486.703V482.277H292.304V486.86C292.304 487.622 292.34 488.118 292.413 488.372C292.485 488.626 292.618 488.819 292.812 488.976C293.005 489.133 293.223 489.206 293.44 489.206C293.9 489.206 294.396 488.988 294.928 488.553C295.46 488.118 295.895 487.561 296.246 486.896V482.289H297.588V482.301Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M301.904 490.222V479.884H299.534V478.783H303.222V489.122H305.689V490.222H301.904Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M310.61 490.222V479.884H308.24V478.783H311.929V489.122H314.395V490.222H310.61Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M328.579 490.548V478.892H329.74V490.548H328.579Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M337.285 490.548V478.892H338.446V490.548H337.285Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M355.29 490.548C355.011 490.548 354.77 490.451 354.576 490.246C354.383 490.04 354.274 489.81 354.274 489.532C354.274 489.254 354.371 489.012 354.576 488.819C354.782 488.625 355.011 488.516 355.29 488.516C355.568 488.516 355.797 488.613 356.003 488.807C356.208 489 356.305 489.242 356.305 489.52C356.305 489.798 356.208 490.04 356.003 490.246C355.797 490.451 355.556 490.548 355.29 490.548ZM354.673 487.09L354.346 479.23H356.112L355.785 487.09H354.673Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M362.956 490.221V483.402H360.755V482.301H364.274V489.121H366.475V490.221H362.956ZM362.739 479.448C362.739 479.145 362.835 478.928 363.041 478.783C363.246 478.637 363.428 478.565 363.609 478.565C363.791 478.565 363.984 478.637 364.19 478.783C364.395 478.928 364.492 479.145 364.492 479.448C364.492 479.738 364.395 479.955 364.19 480.101C363.984 480.246 363.791 480.318 363.609 480.318C363.428 480.318 363.234 480.246 363.041 480.101C362.835 479.955 362.739 479.738 362.739 479.448Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M369.534 489.799V488.408C370.066 488.759 370.622 489.001 371.214 489.134C371.807 489.267 372.303 489.339 372.714 489.339C373.379 489.339 373.862 489.23 374.153 489.013C374.443 488.795 374.588 488.529 374.588 488.202C374.588 487.985 374.515 487.803 374.382 487.658C374.249 487.513 373.911 487.32 373.367 487.102L372.907 486.921L371.988 486.558C371.009 486.171 370.392 485.82 370.126 485.494C369.872 485.167 369.739 484.781 369.739 484.321C369.739 483.668 369.993 483.136 370.489 482.713C370.985 482.29 371.807 482.084 372.943 482.084C373.79 482.084 374.588 482.205 375.35 482.447V483.644C374.479 483.329 373.657 483.172 372.895 483.172C372.339 483.172 371.904 483.269 371.589 483.462C371.275 483.656 371.118 483.898 371.118 484.2C371.118 484.478 371.251 484.708 371.529 484.877C371.795 485.046 372.242 485.24 372.847 485.47L373.742 485.796C374.564 486.098 375.132 486.413 375.459 486.764C375.785 487.114 375.954 487.549 375.954 488.069C375.954 488.759 375.688 489.315 375.168 489.762C374.648 490.21 373.802 490.427 372.641 490.427C371.638 490.439 370.598 490.222 369.534 489.799Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M378.167 489.98V488.637C379.304 489.182 380.332 489.448 381.251 489.448C381.638 489.448 382.001 489.375 382.363 489.218C382.714 489.073 382.98 488.855 383.161 488.577C383.343 488.299 383.427 487.997 383.427 487.67C383.427 487.283 383.306 486.933 383.053 486.594C382.799 486.255 382.339 485.893 381.65 485.494L380.936 485.082L380.211 484.659C378.929 483.897 378.276 482.954 378.276 481.818C378.276 480.995 378.566 480.294 379.135 479.726C379.703 479.157 380.598 478.879 381.819 478.879C382.605 478.879 383.367 478.988 384.092 479.218V480.439C383.282 480.137 382.496 479.98 381.735 479.98C381.13 479.98 380.634 480.137 380.259 480.463C379.884 480.79 379.703 481.177 379.703 481.624C379.703 482.072 379.848 482.446 380.138 482.749C380.429 483.051 380.791 483.317 381.239 483.571L381.795 483.91L382.484 484.321L383.053 484.659C384.262 485.397 384.866 486.328 384.866 487.44C384.866 488.287 384.552 489.024 383.935 489.629C383.319 490.234 382.327 490.548 380.961 490.548C380.525 490.548 380.114 490.512 379.715 490.439C379.316 490.367 378.808 490.209 378.167 489.98Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M393.367 482.301V490.21H392.049V488.468C391.626 489.121 391.154 489.605 390.634 489.931C390.114 490.258 389.594 490.415 389.074 490.415C388.615 490.415 388.192 490.294 387.805 490.04C387.418 489.786 387.152 489.472 386.995 489.061C386.837 488.65 386.765 487.864 386.765 486.703V482.277H388.083V486.86C388.083 487.622 388.119 488.118 388.192 488.372C388.264 488.626 388.397 488.819 388.591 488.976C388.784 489.133 389.002 489.206 389.22 489.206C389.679 489.206 390.175 488.988 390.707 488.553C391.239 488.118 391.674 487.561 392.025 486.896V482.289H393.367V482.301Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M396.789 484.079C397.2 483.414 397.684 482.918 398.24 482.58C398.796 482.241 399.316 482.072 399.788 482.072C400.453 482.072 401.045 482.362 401.577 482.93C402.109 483.499 402.375 484.369 402.375 485.53C402.375 486.449 402.206 487.259 401.843 487.985C401.481 488.71 401.021 489.279 400.441 489.69C399.86 490.101 399.135 490.318 398.264 490.318C398.022 490.318 397.635 490.294 397.128 490.246C397.055 490.234 396.934 490.222 396.789 490.21V493.281H395.471V482.289H396.789V484.079ZM396.789 485.651V489.049C397.261 489.17 397.708 489.23 398.107 489.23C398.905 489.23 399.582 488.916 400.126 488.287C400.67 487.658 400.949 486.8 400.949 485.711C400.949 484.925 400.803 484.333 400.501 483.934C400.199 483.535 399.86 483.341 399.485 483.341C399.074 483.341 398.627 483.547 398.131 483.97C397.623 484.381 397.176 484.95 396.789 485.651Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M405.495 484.079C405.907 483.414 406.39 482.918 406.946 482.58C407.503 482.241 408.023 482.072 408.494 482.072C409.159 482.072 409.752 482.362 410.284 482.93C410.816 483.499 411.082 484.369 411.082 485.53C411.082 486.449 410.913 487.259 410.55 487.985C410.187 488.71 409.728 489.279 409.147 489.69C408.567 490.101 407.841 490.318 406.971 490.318C406.729 490.318 406.342 490.294 405.834 490.246C405.762 490.234 405.641 490.222 405.495 490.21V493.281H404.177V482.289H405.495V484.079ZM405.495 485.651V489.049C405.967 489.17 406.414 489.23 406.813 489.23C407.612 489.23 408.289 488.916 408.833 488.287C409.377 487.658 409.655 486.8 409.655 485.711C409.655 484.925 409.51 484.333 409.208 483.934C408.905 483.535 408.567 483.341 408.192 483.341C407.781 483.341 407.333 483.547 406.838 483.97C406.33 484.381 405.882 484.95 405.495 485.651Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M416.233 490.439C415.096 490.439 414.189 490.04 413.512 489.254C412.835 488.468 412.497 487.465 412.497 486.256C412.497 485.046 412.835 484.055 413.512 483.269C414.189 482.483 415.096 482.084 416.233 482.084C417.357 482.084 418.264 482.483 418.942 483.269C419.619 484.055 419.957 485.059 419.957 486.256C419.957 487.453 419.619 488.456 418.942 489.254C418.264 490.04 417.357 490.439 416.233 490.439ZM416.233 489.339C416.934 489.339 417.491 489.061 417.914 488.517C418.325 487.973 418.53 487.211 418.53 486.256C418.53 485.3 418.325 484.551 417.914 484.007C417.503 483.462 416.934 483.184 416.233 483.184C415.519 483.184 414.963 483.462 414.552 484.007C414.141 484.551 413.923 485.3 413.923 486.256C413.923 487.211 414.129 487.973 414.552 488.517C414.975 489.061 415.532 489.339 416.233 489.339Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M422.363 490.221V482.313H423.681V484.042C424.092 483.39 424.564 482.906 425.096 482.579C425.628 482.253 426.22 482.096 426.873 482.096C427.345 482.096 427.828 482.168 428.3 482.313V485.167H427.03V483.365C426.813 483.329 426.631 483.305 426.51 483.305C426.015 483.305 425.543 483.498 425.059 483.885C424.576 484.272 424.128 484.853 423.681 485.626V490.221H422.363Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M437.006 489.896C436.39 490.15 435.942 490.307 435.664 490.355C435.386 490.403 435.12 490.428 434.854 490.428C434.298 490.428 433.79 490.319 433.342 490.113C432.895 489.908 432.544 489.581 432.303 489.17C432.061 488.759 431.952 488.106 431.952 487.248V484.055H429.981V482.955H431.952V479.763H433.27V482.955H436.789V484.055H433.27V487.223C433.27 487.864 433.342 488.312 433.5 488.578C433.657 488.844 433.85 489.037 434.104 489.158C434.358 489.279 434.661 489.339 434.999 489.339C435.64 489.339 436.305 489.134 437.006 488.735V489.896Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M445.688 489.69C444.636 490.185 443.632 490.439 442.701 490.439C441.988 490.439 441.347 490.258 440.791 489.907C440.234 489.557 439.775 489.049 439.436 488.384C439.098 487.731 438.928 487.017 438.928 486.268C438.928 485.542 439.086 484.853 439.412 484.188C439.738 483.523 440.186 483.003 440.754 482.628C441.335 482.253 441.976 482.072 442.677 482.072C443.62 482.072 444.37 482.41 444.938 483.075C445.506 483.74 445.797 484.78 445.797 486.171V486.449H440.343C440.343 486.993 440.464 487.501 440.694 487.96C440.924 488.42 441.226 488.759 441.601 488.988C441.976 489.218 442.399 489.327 442.87 489.327C443.717 489.327 444.66 489.037 445.688 488.468V489.69ZM440.416 485.482H444.358V485.288C444.358 484.647 444.2 484.127 443.886 483.753C443.572 483.378 443.148 483.184 442.616 483.184C442.084 483.184 441.625 483.378 441.238 483.765C440.851 484.152 440.573 484.72 440.416 485.482Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M453.1 488.432C452.701 489.097 452.218 489.593 451.649 489.932C451.081 490.27 450.561 490.44 450.09 490.44C449.425 490.44 448.832 490.149 448.3 489.581C447.768 489.013 447.514 488.142 447.514 486.981C447.514 486.062 447.683 485.252 448.046 484.527C448.397 483.801 448.868 483.233 449.449 482.822C450.041 482.399 450.767 482.193 451.625 482.193C451.879 482.193 452.254 482.217 452.762 482.266C452.834 482.278 452.955 482.29 453.1 482.302V478.783H454.418V490.222H453.1V488.432ZM453.1 486.873V483.475C452.629 483.354 452.193 483.293 451.794 483.293C450.984 483.293 450.307 483.608 449.763 484.237C449.219 484.865 448.953 485.724 448.953 486.8C448.953 487.586 449.098 488.179 449.4 488.578C449.69 488.977 450.029 489.182 450.416 489.182C450.827 489.182 451.287 488.977 451.782 488.553C452.266 488.13 452.714 487.574 453.1 486.873Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M463.016 492.857C461.71 492.773 460.61 492.41 459.703 491.745C458.796 491.08 458.094 490.197 457.55 489.073C457.006 487.948 456.74 486.836 456.74 485.711C456.74 484.587 457.006 483.462 457.55 482.35C458.094 481.237 458.808 480.342 459.703 479.677C460.597 479.012 461.698 478.65 463.016 478.565V479.665C462.024 479.75 461.178 480.088 460.464 480.657C459.751 481.237 459.195 481.963 458.784 482.845C458.373 483.74 458.167 484.683 458.167 485.699C458.167 486.715 458.373 487.67 458.784 488.553C459.195 489.448 459.751 490.173 460.464 490.741C461.178 491.31 462.024 491.648 463.016 491.745V492.857Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M465.24 478.565C466.546 478.65 467.647 479.024 468.554 479.677C469.461 480.33 470.174 481.225 470.706 482.35C471.238 483.474 471.504 484.587 471.504 485.711C471.504 486.836 471.238 487.96 470.706 489.073C470.174 490.185 469.449 491.08 468.554 491.745C467.659 492.41 466.558 492.773 465.24 492.857V491.757C466.232 491.66 467.079 491.334 467.792 490.754C468.505 490.185 469.061 489.448 469.473 488.565C469.884 487.682 470.089 486.727 470.089 485.711C470.089 484.695 469.884 483.74 469.473 482.858C469.061 481.975 468.505 481.237 467.792 480.669C467.079 480.101 466.232 479.762 465.24 479.677V478.565Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M473.947 478.565C475.252 478.65 476.353 479.024 477.26 479.677C478.167 480.33 478.88 481.225 479.412 482.35C479.944 483.474 480.21 484.587 480.21 485.711C480.21 486.836 479.944 487.96 479.412 489.073C478.88 490.185 478.154 491.08 477.26 491.745C476.365 492.41 475.265 492.773 473.947 492.857V491.757C474.938 491.66 475.784 491.334 476.498 490.754C477.211 490.185 477.768 489.448 478.179 488.565C478.59 487.682 478.795 486.727 478.795 485.711C478.795 484.695 478.59 483.74 478.179 482.858C477.768 481.975 477.211 481.237 476.498 480.669C475.784 480.101 474.938 479.762 473.947 479.677V478.565Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M494.128 485.711C494.563 485.941 494.89 486.171 495.095 486.388C495.301 486.606 495.446 486.836 495.555 487.078C495.664 487.319 495.7 487.585 495.7 487.888C495.7 488.154 495.652 488.505 495.555 488.94L495.374 489.75C495.277 490.185 495.228 490.512 495.228 490.729C495.228 491.02 495.337 491.261 495.567 491.467C495.797 491.673 496.256 491.769 496.958 491.769H498.058V492.87H496.946C495.652 492.87 494.817 492.664 494.442 492.241C494.068 491.818 493.886 491.358 493.886 490.826C493.886 490.548 493.922 490.246 493.995 489.931L494.128 489.363L494.249 488.746L494.334 488.371C494.37 488.202 494.382 488.021 494.382 487.864C494.382 487.428 494.237 487.054 493.935 486.739C493.644 486.425 493.124 486.268 492.375 486.268H491.746V485.167H492.375C493.112 485.167 493.632 485.01 493.923 484.708C494.225 484.405 494.37 484.018 494.37 483.559C494.37 483.39 494.358 483.22 494.322 483.063L494.237 482.7L494.116 482.084L493.983 481.515C493.91 481.189 493.874 480.887 493.874 480.609C493.874 480.089 494.055 479.617 494.43 479.206C494.805 478.795 495.64 478.577 496.933 478.577H498.046V479.677H496.946C496.256 479.677 495.785 479.774 495.567 479.98C495.337 480.185 495.228 480.427 495.228 480.717C495.228 480.923 495.277 481.249 495.374 481.697L495.555 482.507C495.652 482.942 495.7 483.293 495.7 483.559C495.7 483.861 495.652 484.127 495.555 484.369C495.458 484.611 495.301 484.829 495.095 485.058C494.878 485.252 494.563 485.482 494.128 485.711Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M178.556 510.778V502.87H179.874V504.599C180.285 503.946 180.757 503.463 181.289 503.136C181.821 502.81 182.413 502.652 183.066 502.652C183.538 502.652 184.021 502.725 184.493 502.87V505.724H183.223V503.922C183.006 503.886 182.824 503.862 182.703 503.862C182.208 503.862 181.736 504.055 181.252 504.442C180.769 504.829 180.321 505.409 179.874 506.183V510.778H178.556Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M193.163 510.246C192.111 510.742 191.107 510.996 190.176 510.996C189.463 510.996 188.822 510.814 188.266 510.463C187.71 510.113 187.25 509.605 186.911 508.94C186.573 508.287 186.404 507.574 186.404 506.824C186.404 506.098 186.561 505.409 186.887 504.744C187.214 504.079 187.661 503.559 188.229 503.184C188.81 502.809 189.451 502.628 190.152 502.628C191.095 502.628 191.845 502.967 192.413 503.632C192.982 504.297 193.272 505.337 193.272 506.727V507.005H187.818C187.818 507.549 187.927 508.057 188.157 508.517C188.387 508.976 188.689 509.315 189.064 509.544C189.439 509.774 189.862 509.883 190.333 509.883C191.18 509.883 192.123 509.593 193.151 509.025V510.246H193.163ZM187.903 506.038H191.845V505.844C191.845 505.204 191.688 504.684 191.373 504.309C191.059 503.934 190.636 503.74 190.104 503.74C189.572 503.74 189.112 503.934 188.713 504.321C188.314 504.708 188.06 505.276 187.903 506.038Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M201.905 510.452C201.288 510.706 200.841 510.863 200.563 510.911C200.285 510.96 200.019 510.984 199.753 510.984C199.196 510.984 198.689 510.875 198.241 510.669C197.794 510.464 197.431 510.137 197.201 509.726C196.972 509.315 196.851 508.662 196.851 507.804V504.611H194.88V503.511H196.851V500.319H198.169V503.511H201.687V504.611H198.169V507.779C198.169 508.42 198.241 508.868 198.398 509.134C198.556 509.4 198.749 509.593 199.003 509.714C199.257 509.835 199.559 509.896 199.898 509.896C200.539 509.896 201.204 509.69 201.905 509.291V510.452Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M210.515 502.858V510.766H209.197V509.024C208.774 509.677 208.302 510.161 207.782 510.488C207.262 510.814 206.742 510.971 206.222 510.971C205.763 510.971 205.34 510.85 204.953 510.596C204.566 510.342 204.3 510.028 204.143 509.617C203.985 509.206 203.913 508.42 203.913 507.259V502.833H205.231V507.416C205.231 508.178 205.267 508.674 205.34 508.928C205.412 509.182 205.545 509.375 205.739 509.532C205.932 509.69 206.15 509.762 206.367 509.762C206.827 509.762 207.323 509.544 207.855 509.109C208.387 508.674 208.822 508.118 209.173 507.453V502.846H210.515V502.858Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M213.38 510.778V502.87H214.698V504.599C215.109 503.946 215.581 503.463 216.113 503.136C216.645 502.81 217.238 502.652 217.891 502.652C218.362 502.652 218.846 502.725 219.317 502.87V505.724H218.048V503.922C217.83 503.886 217.649 503.862 217.528 503.862C217.032 503.862 216.56 504.055 216.077 504.442C215.593 504.829 215.146 505.409 214.698 506.183V510.778H213.38Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M221.409 510.778V502.87H222.727V504.599C223.102 503.995 223.561 503.511 224.093 503.172C224.625 502.834 225.157 502.652 225.689 502.652C226.161 502.652 226.584 502.773 226.959 503.027C227.334 503.281 227.612 503.595 227.769 504.007C227.926 504.418 227.999 505.192 227.999 506.377V510.802H226.681V506.219C226.681 505.458 226.645 504.962 226.572 504.708C226.499 504.454 226.366 504.261 226.173 504.103C225.98 503.946 225.762 503.874 225.532 503.874C225.073 503.874 224.577 504.091 224.045 504.527C223.513 504.962 223.078 505.518 222.727 506.183V510.79H221.409V510.778Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M232.026 513.85V512.967C232.365 512.882 232.631 512.749 232.8 512.58C232.969 512.411 233.114 512.205 233.223 511.939C233.332 511.673 233.381 511.371 233.381 511.008C232.945 511.008 232.619 510.887 232.413 510.633C232.208 510.379 232.099 510.125 232.099 509.835C232.099 509.509 232.22 509.231 232.449 509.013C232.679 508.795 232.945 508.674 233.26 508.674C233.659 508.674 233.997 508.844 234.287 509.182C234.578 509.521 234.723 509.992 234.723 510.585C234.723 511.105 234.614 511.589 234.384 512.06C234.154 512.532 233.852 512.919 233.465 513.245C233.078 513.572 232.595 513.777 232.026 513.85ZM233.26 504.95C232.945 504.95 232.667 504.841 232.449 504.612C232.232 504.382 232.111 504.116 232.111 503.801C232.111 503.475 232.22 503.209 232.449 502.979C232.679 502.749 232.945 502.641 233.26 502.641C233.574 502.641 233.84 502.749 234.07 502.979C234.3 503.209 234.408 503.475 234.408 503.801C234.408 504.116 234.3 504.394 234.07 504.612C233.84 504.829 233.574 504.95 233.26 504.95Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M164.19 526.824C163.755 526.594 163.429 526.364 163.223 526.147C163.018 525.929 162.86 525.699 162.764 525.457C162.667 525.216 162.618 524.95 162.618 524.647C162.618 524.381 162.667 524.031 162.751 523.595L162.933 522.785C163.03 522.338 163.078 522.023 163.078 521.806C163.078 521.516 162.969 521.274 162.739 521.068C162.51 520.863 162.05 520.766 161.349 520.766H160.249V519.666H161.361C162.655 519.666 163.489 519.871 163.864 520.294C164.239 520.718 164.432 521.177 164.432 521.697C164.432 521.975 164.396 522.277 164.323 522.604L164.19 523.172L164.07 523.789L163.985 524.152C163.949 524.333 163.937 524.502 163.937 524.672C163.937 525.107 164.082 525.482 164.384 525.796C164.686 526.11 165.194 526.268 165.944 526.268H166.573V527.368H165.944C165.206 527.368 164.686 527.525 164.384 527.827C164.082 528.13 163.937 528.517 163.937 528.976C163.937 529.146 163.949 529.303 163.985 529.46L164.07 529.835L164.19 530.451L164.323 531.02C164.396 531.346 164.432 531.649 164.432 531.927C164.432 532.447 164.239 532.918 163.864 533.329C163.489 533.74 162.655 533.946 161.361 533.946H160.249V532.846H161.349C162.05 532.846 162.51 532.749 162.739 532.543C162.969 532.338 163.078 532.096 163.078 531.806C163.078 531.6 163.03 531.274 162.933 530.838L162.751 530.028C162.667 529.593 162.618 529.242 162.618 528.976C162.618 528.674 162.667 528.408 162.764 528.166C162.86 527.924 163.018 527.707 163.223 527.477C163.429 527.247 163.743 527.054 164.19 526.824Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M167.117 572.216C166.234 572.519 165.388 572.664 164.59 572.664C163.792 572.664 163.091 572.482 162.474 572.12C161.857 571.757 161.374 571.261 161.035 570.632C160.696 570.004 160.515 569.29 160.515 568.492C160.515 567.295 160.902 566.291 161.688 565.505C162.474 564.719 163.417 564.32 164.517 564.32C165.34 564.32 166.198 564.478 167.105 564.78V566.049C166.186 565.626 165.364 565.421 164.638 565.421C164.155 565.421 163.707 565.542 163.284 565.783C162.861 566.025 162.534 566.388 162.305 566.896C162.075 567.404 161.954 567.924 161.954 568.456C161.954 569.169 162.172 569.846 162.619 570.499C163.066 571.152 163.768 571.467 164.723 571.467C165.013 571.467 165.291 571.442 165.569 571.406C165.847 571.37 166.367 571.213 167.117 570.959V572.216Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M172.425 572.664C171.289 572.664 170.382 572.265 169.705 571.479C169.028 570.693 168.689 569.689 168.689 568.48C168.689 567.271 169.028 566.279 169.705 565.493C170.382 564.707 171.289 564.308 172.425 564.308C173.55 564.308 174.457 564.707 175.134 565.493C175.811 566.279 176.15 567.283 176.15 568.48C176.15 569.677 175.811 570.68 175.134 571.479C174.457 572.265 173.55 572.664 172.425 572.664ZM172.425 571.563C173.127 571.563 173.683 571.285 174.106 570.741C174.517 570.197 174.723 569.435 174.723 568.48C174.723 567.525 174.517 566.775 174.106 566.231C173.695 565.687 173.127 565.409 172.425 565.409C171.724 565.409 171.156 565.687 170.745 566.231C170.334 566.775 170.128 567.525 170.128 568.48C170.128 569.435 170.334 570.197 170.745 570.741C171.156 571.285 171.712 571.563 172.425 571.563Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M177.878 572.446V564.538H179.196V566.267C179.571 565.662 180.031 565.179 180.563 564.84C181.095 564.502 181.627 564.32 182.159 564.32C182.63 564.32 183.054 564.441 183.428 564.695C183.803 564.949 184.081 565.263 184.239 565.675C184.396 566.086 184.468 566.86 184.468 568.045V572.47H183.15V567.887C183.15 567.126 183.114 566.63 183.042 566.376C182.969 566.122 182.836 565.929 182.642 565.771C182.449 565.614 182.231 565.542 182.002 565.542C181.542 565.542 181.046 565.759 180.514 566.195C179.982 566.63 179.547 567.186 179.196 567.851V572.458H177.878V572.446Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M186.682 572.023V570.632C187.214 570.983 187.77 571.225 188.363 571.358C188.955 571.491 189.451 571.563 189.862 571.563C190.527 571.563 191.011 571.454 191.301 571.237C191.591 571.019 191.736 570.753 191.736 570.427C191.736 570.209 191.664 570.028 191.531 569.882C191.398 569.737 191.059 569.544 190.515 569.326L190.056 569.145L189.137 568.782C188.157 568.395 187.541 568.044 187.274 567.718C187.021 567.392 186.888 567.005 186.888 566.545C186.888 565.892 187.141 565.36 187.637 564.937C188.145 564.514 188.955 564.308 190.092 564.308C190.938 564.308 191.736 564.429 192.498 564.671V565.868C191.628 565.554 190.805 565.396 190.043 565.396C189.487 565.396 189.052 565.493 188.738 565.687C188.423 565.88 188.266 566.122 188.266 566.424C188.266 566.702 188.399 566.932 188.677 567.101C188.943 567.271 189.391 567.464 189.995 567.694L190.89 568.02C191.712 568.323 192.28 568.637 192.607 568.988C192.933 569.338 193.103 569.774 193.103 570.294C193.103 570.983 192.837 571.539 192.317 571.986C191.797 572.434 190.95 572.651 189.79 572.651C188.786 572.664 187.746 572.446 186.682 572.023Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M201.905 572.12C201.288 572.374 200.841 572.531 200.563 572.58C200.285 572.628 200.019 572.652 199.753 572.652C199.196 572.652 198.689 572.543 198.241 572.338C197.794 572.132 197.431 571.806 197.201 571.395C196.972 570.984 196.851 570.331 196.851 569.472V566.28H194.88V565.18H196.851V561.987H198.169V565.18H201.687V566.28H198.169V569.448C198.169 570.089 198.241 570.536 198.398 570.802C198.556 571.068 198.749 571.262 199.003 571.383C199.257 571.504 199.559 571.564 199.898 571.564C200.539 571.564 201.204 571.358 201.905 570.959V572.12Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M215.484 567.935C215.919 568.165 216.246 568.395 216.452 568.613C216.657 568.83 216.814 569.06 216.911 569.302C217.008 569.532 217.056 569.81 217.056 570.112C217.056 570.378 217.008 570.729 216.911 571.164L216.73 571.974C216.633 572.409 216.584 572.736 216.584 572.954C216.584 573.244 216.693 573.486 216.923 573.691C217.153 573.897 217.612 573.993 218.314 573.993H219.414V575.094H218.302C217.008 575.094 216.173 574.888 215.799 574.465C215.424 574.054 215.242 573.582 215.242 573.05C215.242 572.772 215.279 572.47 215.351 572.155L215.484 571.587L215.605 570.97L215.69 570.596C215.726 570.426 215.738 570.245 215.738 570.088C215.738 569.652 215.593 569.278 215.291 568.963C214.988 568.649 214.481 568.492 213.731 568.492H213.102V567.391H213.731C214.468 567.391 214.988 567.234 215.279 566.932C215.569 566.63 215.726 566.243 215.726 565.783C215.726 565.614 215.714 565.444 215.678 565.287L215.593 564.925L215.472 564.308L215.339 563.74C215.267 563.413 215.23 563.111 215.23 562.833C215.23 562.313 215.412 561.841 215.786 561.43C216.161 561.007 216.996 560.801 218.289 560.801H219.402V561.902H218.302C217.612 561.902 217.141 561.998 216.923 562.204C216.693 562.409 216.584 562.651 216.584 562.941C216.584 563.147 216.633 563.474 216.73 563.921L216.911 564.731C217.008 565.166 217.056 565.517 217.056 565.783C217.056 566.085 217.008 566.351 216.911 566.593C216.814 566.823 216.657 567.053 216.452 567.282C216.246 567.512 215.919 567.706 215.484 567.935Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M236.778 572.216C235.895 572.519 235.049 572.664 234.251 572.664C233.453 572.664 232.752 572.482 232.135 572.12C231.518 571.757 231.035 571.261 230.696 570.632C230.357 570.004 230.176 569.29 230.176 568.492C230.176 567.295 230.563 566.291 231.349 565.505C232.135 564.719 233.078 564.32 234.178 564.32C235.001 564.32 235.859 564.478 236.766 564.78V566.049C235.847 565.626 235.025 565.421 234.299 565.421C233.816 565.421 233.368 565.542 232.945 565.783C232.522 566.025 232.195 566.388 231.966 566.896C231.736 567.404 231.615 567.924 231.615 568.456C231.615 569.169 231.833 569.846 232.28 570.499C232.727 571.152 233.429 571.467 234.384 571.467C234.674 571.467 234.952 571.442 235.23 571.406C235.509 571.37 236.028 571.213 236.778 570.959V572.216Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M242.086 572.664C240.95 572.664 240.043 572.265 239.366 571.479C238.689 570.693 238.35 569.689 238.35 568.48C238.35 567.271 238.689 566.279 239.366 565.493C240.043 564.707 240.95 564.308 242.086 564.308C243.211 564.308 244.118 564.707 244.795 565.493C245.472 566.279 245.811 567.283 245.811 568.48C245.811 569.677 245.472 570.68 244.795 571.479C244.118 572.265 243.211 572.664 242.086 572.664ZM242.086 571.563C242.788 571.563 243.344 571.285 243.767 570.741C244.178 570.197 244.384 569.435 244.384 568.48C244.384 567.525 244.178 566.775 243.767 566.231C243.356 565.687 242.788 565.409 242.086 565.409C241.385 565.409 240.817 565.687 240.406 566.231C239.994 566.775 239.789 567.525 239.789 568.48C239.789 569.435 239.994 570.197 240.406 570.741C240.817 571.285 241.373 571.563 242.086 571.563Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M247.54 572.446V564.538H248.858V566.267C249.233 565.662 249.692 565.179 250.225 564.84C250.757 564.502 251.289 564.32 251.821 564.32C252.292 564.32 252.715 564.441 253.09 564.695C253.465 564.949 253.743 565.263 253.9 565.675C254.058 566.086 254.13 566.86 254.13 568.045V572.47H252.812V567.887C252.812 567.126 252.776 566.63 252.703 566.376C252.631 566.122 252.498 565.929 252.304 565.771C252.111 565.614 251.893 565.542 251.663 565.542C251.204 565.542 250.708 565.759 250.176 566.195C249.644 566.63 249.209 567.186 248.858 567.851V572.458H247.54V572.446Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M258.083 572.447V566.28H256.33V565.179H258.083V564.817C258.083 563.777 258.204 563.003 258.434 562.507C258.676 562.011 259.039 561.6 259.534 561.274C260.03 560.959 260.683 560.79 261.493 560.79C262.11 560.79 262.727 560.85 263.368 560.983V562.229C262.678 561.999 262.074 561.89 261.542 561.89C261.118 561.89 260.756 561.963 260.429 562.12C260.103 562.277 259.861 562.531 259.68 562.882C259.498 563.233 259.401 563.825 259.401 564.671V565.179H262.545V566.28H259.401V572.447H258.083Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M267.164 572.447V565.627H264.964V564.526H268.482V571.346H270.683V572.447H267.164ZM266.959 561.673C266.959 561.37 267.056 561.153 267.261 561.008C267.467 560.863 267.66 560.79 267.829 560.79C268.011 560.79 268.204 560.863 268.41 561.008C268.615 561.153 268.712 561.37 268.712 561.673C268.712 561.963 268.615 562.181 268.41 562.326C268.204 562.471 268.011 562.543 267.829 562.543C267.648 562.543 267.455 562.471 267.261 562.326C267.056 562.181 266.959 561.963 266.959 561.673Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M278.954 570.656C278.555 571.321 278.071 571.817 277.503 572.156C276.935 572.494 276.415 572.664 275.943 572.664C275.278 572.664 274.686 572.373 274.153 571.805C273.621 571.237 273.368 570.366 273.368 569.205C273.368 568.286 273.537 567.476 273.887 566.751C274.238 566.025 274.71 565.457 275.29 565.046C275.871 564.623 276.596 564.417 277.467 564.417C277.721 564.417 278.095 564.441 278.603 564.49C278.676 564.502 278.797 564.514 278.942 564.526H280.26V570.124C280.26 571.454 280.248 572.265 280.211 572.567C280.175 572.869 280.127 573.159 280.042 573.462C279.849 574.163 279.426 574.719 278.748 575.13C278.071 575.541 277.261 575.735 276.306 575.735C275.351 575.735 274.371 575.493 273.392 574.997V573.667C273.767 573.921 274.226 574.151 274.77 574.344C275.314 574.538 275.846 574.635 276.354 574.635C276.753 574.635 277.14 574.574 277.491 574.441C277.854 574.308 278.144 574.127 278.361 573.885C278.579 573.643 278.736 573.365 278.821 573.038C278.906 572.712 278.942 572.301 278.942 571.769V570.656H278.954ZM278.954 569.097V565.699C278.482 565.578 278.047 565.517 277.648 565.517C276.838 565.517 276.161 565.832 275.617 566.461C275.072 567.089 274.806 567.948 274.806 569.024C274.806 569.81 274.952 570.402 275.254 570.801C275.544 571.2 275.883 571.406 276.27 571.406C276.681 571.406 277.14 571.201 277.636 570.777C278.12 570.354 278.555 569.798 278.954 569.097Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M288.881 564.526V572.434H287.564V570.693C287.14 571.346 286.669 571.83 286.149 572.156C285.629 572.482 285.109 572.64 284.589 572.64C284.129 572.64 283.706 572.519 283.319 572.265C282.932 572.011 282.666 571.697 282.509 571.285C282.352 570.874 282.279 570.088 282.279 568.928V564.502H283.597V569.085C283.597 569.847 283.634 570.342 283.706 570.596C283.779 570.85 283.912 571.044 284.105 571.201C284.299 571.358 284.516 571.431 284.734 571.431C285.194 571.431 285.689 571.213 286.221 570.778C286.753 570.342 287.189 569.786 287.539 569.121V564.514H288.881V564.526Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M291.747 572.446V564.538H293.065V566.267C293.477 565.614 293.948 565.13 294.48 564.804C295.012 564.478 295.605 564.32 296.258 564.32C296.729 564.32 297.213 564.393 297.684 564.538V567.392H296.415V565.59C296.197 565.554 296.016 565.529 295.895 565.529C295.399 565.529 294.928 565.723 294.444 566.11C293.96 566.497 293.513 567.077 293.065 567.851V572.446H291.747Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M306.366 571.914C305.314 572.41 304.31 572.663 303.379 572.663C302.666 572.663 302.025 572.482 301.469 572.131C300.912 571.781 300.453 571.273 300.114 570.608C299.776 569.955 299.607 569.241 299.607 568.492C299.607 567.766 299.764 567.077 300.09 566.412C300.417 565.747 300.864 565.227 301.432 564.852C302.013 564.477 302.654 564.296 303.355 564.296C304.298 564.296 305.048 564.634 305.616 565.3C306.184 565.965 306.475 567.004 306.475 568.395V568.673H301.021C301.021 569.217 301.13 569.725 301.36 570.185C301.59 570.644 301.892 570.983 302.267 571.212C302.642 571.442 303.065 571.551 303.536 571.551C304.383 571.551 305.326 571.261 306.354 570.693V571.914H306.366ZM301.094 567.706H305.036V567.512C305.036 566.871 304.879 566.352 304.564 565.977C304.25 565.602 303.827 565.408 303.295 565.408C302.763 565.408 302.303 565.602 301.904 565.989C301.505 566.376 301.251 566.944 301.094 567.706Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M308.616 572.446V561.455H310.768C312.062 561.455 312.92 561.551 313.356 561.745C313.791 561.938 314.117 562.228 314.335 562.615C314.553 563.002 314.662 563.438 314.662 563.921C314.662 564.308 314.601 564.671 314.468 565.022C314.335 565.372 314.154 565.687 313.9 565.977C313.646 566.267 313.283 566.533 312.811 566.787C313.682 567.138 314.275 567.561 314.589 568.081C314.903 568.601 315.048 569.097 315.048 569.617C315.048 570.1 314.915 570.572 314.649 571.031C314.383 571.491 314.021 571.841 313.549 572.083C313.077 572.325 312.316 572.446 311.276 572.446H308.616ZM310.042 566.4H311.542C312.026 566.195 312.388 565.977 312.606 565.759C312.824 565.542 312.993 565.288 313.114 565.01C313.223 564.731 313.283 564.429 313.283 564.103C313.283 563.583 313.126 563.196 312.824 562.942C312.521 562.688 311.929 562.555 311.046 562.555H310.042V566.4ZM310.042 571.346H311.397C312.146 571.346 312.715 571.164 313.077 570.814C313.44 570.463 313.622 570.028 313.622 569.532C313.622 569.169 313.525 568.831 313.319 568.516C313.114 568.202 312.811 567.96 312.4 567.779C311.989 567.597 311.336 567.5 310.441 567.5H310.042V571.346Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M323.706 564.526V572.434H322.388V570.693C321.965 571.346 321.493 571.83 320.973 572.156C320.453 572.482 319.933 572.64 319.414 572.64C318.954 572.64 318.531 572.519 318.144 572.265C317.757 572.011 317.491 571.697 317.334 571.285C317.177 570.874 317.104 570.088 317.104 568.928V564.502H318.422V569.085C318.422 569.847 318.458 570.342 318.531 570.596C318.603 570.85 318.736 571.044 318.93 571.201C319.123 571.358 319.341 571.431 319.559 571.431C320.018 571.431 320.514 571.213 321.046 570.778C321.578 570.342 322.013 569.786 322.364 569.121V564.514H323.706V564.526Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M332.521 572.12C331.904 572.374 331.457 572.531 331.179 572.58C330.901 572.628 330.635 572.652 330.369 572.652C329.812 572.652 329.305 572.543 328.857 572.338C328.41 572.132 328.047 571.806 327.817 571.395C327.587 570.984 327.467 570.331 327.467 569.472V566.28H325.496V565.18H327.467V561.987H328.785V565.18H332.303V566.28H328.785V569.448C328.785 570.089 328.857 570.536 329.014 570.802C329.171 571.068 329.365 571.262 329.619 571.383C329.873 571.504 330.175 571.564 330.514 571.564C331.155 571.564 331.82 571.358 332.521 570.959V572.12Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M341.227 572.12C340.61 572.374 340.163 572.531 339.885 572.58C339.607 572.628 339.341 572.652 339.075 572.652C338.518 572.652 338.011 572.543 337.563 572.338C337.116 572.132 336.753 571.806 336.523 571.395C336.294 570.984 336.173 570.331 336.173 569.472V566.28H334.202V565.18H336.173V561.987H337.491V565.18H341.009V566.28H337.491V569.448C337.491 570.089 337.563 570.536 337.72 570.802C337.878 571.068 338.071 571.262 338.325 571.383C338.579 571.504 338.881 571.564 339.22 571.564C339.861 571.564 340.526 571.358 341.227 570.959V572.12Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M346.571 572.664C345.435 572.664 344.528 572.265 343.851 571.479C343.174 570.693 342.835 569.689 342.835 568.48C342.835 567.271 343.174 566.279 343.851 565.493C344.528 564.707 345.435 564.308 346.571 564.308C347.696 564.308 348.603 564.707 349.28 565.493C349.957 566.279 350.296 567.283 350.296 568.48C350.296 569.677 349.957 570.68 349.28 571.479C348.603 572.265 347.708 572.664 346.571 572.664ZM346.571 571.563C347.273 571.563 347.829 571.285 348.252 570.741C348.663 570.197 348.869 569.435 348.869 568.48C348.869 567.525 348.663 566.775 348.252 566.231C347.841 565.687 347.273 565.409 346.571 565.409C345.858 565.409 345.302 565.687 344.891 566.231C344.48 566.775 344.262 567.525 344.262 568.48C344.262 569.435 344.467 570.197 344.891 570.741C345.314 571.285 345.87 571.563 346.571 571.563Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M352.025 572.446V564.538H353.343V566.267C353.718 565.662 354.177 565.179 354.709 564.84C355.241 564.502 355.773 564.32 356.305 564.32C356.777 564.32 357.2 564.441 357.575 564.695C357.95 564.949 358.228 565.263 358.385 565.675C358.542 566.086 358.615 566.86 358.615 568.045V572.47H357.297V567.887C357.297 567.126 357.261 566.63 357.188 566.376C357.115 566.122 356.982 565.929 356.789 565.771C356.595 565.614 356.378 565.542 356.148 565.542C355.689 565.542 355.193 565.759 354.661 566.195C354.129 566.63 353.693 567.186 353.343 567.851V572.458H352.025V572.446Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M373.173 567.936C372.738 567.706 372.412 567.477 372.206 567.259C372 567.041 371.843 566.812 371.747 566.57C371.65 566.328 371.601 566.062 371.601 565.76C371.601 565.494 371.65 565.143 371.734 564.708L371.916 563.898C372.013 563.45 372.061 563.136 372.061 562.918C372.061 562.628 371.952 562.386 371.722 562.18C371.493 561.975 371.033 561.878 370.332 561.878H369.231V560.778H370.344C371.638 560.778 372.472 560.983 372.847 561.407C373.222 561.83 373.403 562.289 373.403 562.809C373.403 563.087 373.367 563.39 373.294 563.716L373.161 564.284L373.04 564.901L372.956 565.264C372.919 565.445 372.907 565.615 372.907 565.784C372.907 566.219 373.052 566.594 373.355 566.908C373.657 567.223 374.165 567.38 374.915 567.38H375.543V568.48H374.915C374.177 568.48 373.657 568.638 373.355 568.94C373.052 569.242 372.907 569.629 372.907 570.089C372.907 570.258 372.919 570.415 372.956 570.572L373.04 570.947L373.161 571.564L373.294 572.132C373.367 572.459 373.403 572.761 373.403 573.039C373.403 573.559 373.222 574.03 372.847 574.442C372.472 574.853 371.638 575.058 370.344 575.058H369.231V573.958H370.332C371.033 573.958 371.493 573.861 371.722 573.656C371.952 573.45 372.061 573.208 372.061 572.918C372.061 572.712 372.013 572.386 371.916 571.951L371.734 571.141C371.65 570.705 371.601 570.355 371.601 570.089C371.601 569.786 371.65 569.52 371.747 569.278C371.843 569.036 372 568.819 372.206 568.589C372.412 568.359 372.726 568.166 373.173 567.936Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M393.96 566.836V567.936H386.269V566.836H393.96ZM393.96 569.315V570.415H386.269V569.315H393.96Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M409.473 570.668C409.074 571.321 408.59 571.829 408.022 572.156C407.454 572.494 406.946 572.664 406.462 572.664C405.797 572.664 405.205 572.373 404.685 571.805C404.165 571.237 403.899 570.366 403.899 569.205C403.899 568.286 404.068 567.476 404.419 566.751C404.769 566.025 405.241 565.457 405.821 565.046C406.402 564.635 407.139 564.417 407.998 564.417C408.252 564.417 408.627 564.441 409.134 564.49C409.207 564.502 409.328 564.514 409.473 564.526H410.791V570.112C410.791 571.067 410.888 571.841 411.093 572.434H409.715C409.618 572.011 409.533 571.418 409.473 570.668ZM409.485 569.097V565.699C409.014 565.578 408.578 565.517 408.179 565.517C407.369 565.517 406.692 565.832 406.148 566.461C405.604 567.089 405.338 567.948 405.338 569.024C405.338 569.81 405.483 570.402 405.785 570.801C406.075 571.2 406.414 571.406 406.801 571.406C407.212 571.406 407.671 571.201 408.167 570.777C408.639 570.354 409.086 569.798 409.485 569.097Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M413.306 572.446L412.012 564.538H413.245L413.995 569.351L414.188 570.475L414.382 569.351L415.64 564.538H416.825L418.251 569.351L418.505 570.475L418.663 569.351L419.412 564.538H420.428L419.146 572.446H417.913L416.401 567.355L416.159 566.231H416.123L415.906 567.343L414.588 572.446H413.306Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M426.885 570.668C426.486 571.321 426.003 571.829 425.435 572.156C424.866 572.494 424.358 572.664 423.875 572.664C423.21 572.664 422.617 572.373 422.097 571.805C421.577 571.237 421.311 570.366 421.311 569.205C421.311 568.286 421.481 567.476 421.831 566.751C422.182 566.025 422.653 565.457 423.234 565.046C423.814 564.635 424.552 564.417 425.41 564.417C425.664 564.417 426.039 564.441 426.547 564.49C426.619 564.502 426.74 564.514 426.885 564.526H428.203V570.112C428.203 571.067 428.3 571.841 428.506 572.434H427.127C427.031 572.011 426.958 571.418 426.885 570.668ZM426.898 569.097V565.699C426.426 565.578 425.991 565.517 425.592 565.517C424.782 565.517 424.104 565.832 423.56 566.461C423.016 567.089 422.75 567.948 422.75 569.024C422.75 569.81 422.895 570.402 423.198 570.801C423.488 571.2 423.826 571.406 424.213 571.406C424.624 571.406 425.084 571.201 425.58 570.777C426.063 570.354 426.499 569.798 426.898 569.097Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M432.617 572.447V565.627H430.416V564.526H433.935V571.346H436.135V572.447H432.617ZM432.399 561.673C432.399 561.37 432.496 561.153 432.701 561.008C432.907 560.863 433.088 560.79 433.27 560.79C433.451 560.79 433.644 560.863 433.85 561.008C434.056 561.153 434.152 561.37 434.152 561.673C434.152 561.963 434.056 562.181 433.85 562.326C433.644 562.471 433.451 562.543 433.27 562.543C433.088 562.543 432.895 562.471 432.701 562.326C432.496 562.181 432.399 561.963 432.399 561.673Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M445.725 572.12C445.108 572.374 444.661 572.531 444.383 572.58C444.104 572.628 443.839 572.652 443.572 572.652C443.016 572.652 442.508 572.543 442.061 572.338C441.614 572.132 441.263 571.806 441.021 571.395C440.779 570.984 440.67 570.331 440.67 569.472V566.28H438.699V565.18H440.67V561.987H441.988V565.18H445.507V566.28H441.988V569.448C441.988 570.089 442.061 570.536 442.218 570.802C442.375 571.068 442.569 571.262 442.823 571.383C443.077 571.504 443.379 571.564 443.718 571.564C444.358 571.564 445.024 571.358 445.725 570.959V572.12Z",
        fill: "#0088FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M456.607 572.023V570.632C457.139 570.983 457.695 571.225 458.288 571.358C458.88 571.491 459.376 571.563 459.787 571.563C460.452 571.563 460.936 571.454 461.226 571.237C461.516 571.019 461.661 570.753 461.661 570.427C461.661 570.209 461.589 570.028 461.456 569.882C461.323 569.737 460.984 569.544 460.44 569.326L459.981 569.145L459.062 568.782C458.082 568.395 457.466 568.044 457.2 567.718C456.946 567.392 456.813 567.005 456.813 566.545C456.813 565.892 457.066 565.36 457.562 564.937C458.058 564.514 458.88 564.308 460.017 564.308C460.863 564.308 461.661 564.429 462.423 564.671V565.868C461.553 565.554 460.73 565.396 459.968 565.396C459.412 565.396 458.977 565.493 458.663 565.687C458.348 565.88 458.191 566.122 458.191 566.424C458.191 566.702 458.324 566.932 458.602 567.101C458.868 567.271 459.316 567.464 459.92 567.694L460.815 568.02C461.637 568.323 462.205 568.637 462.532 568.988C462.858 569.338 463.028 569.774 463.028 570.294C463.028 570.983 462.762 571.539 462.242 571.986C461.722 572.434 460.875 572.651 459.715 572.651C458.711 572.664 457.671 572.446 456.607 572.023Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M471.806 571.914C470.754 572.41 469.751 572.663 468.82 572.663C468.106 572.663 467.465 572.482 466.909 572.131C466.353 571.781 465.893 571.273 465.555 570.608C465.216 569.955 465.047 569.241 465.047 568.492C465.047 567.766 465.204 567.077 465.531 566.412C465.857 565.747 466.305 565.227 466.873 564.852C467.453 564.477 468.094 564.296 468.795 564.296C469.739 564.296 470.488 564.634 471.057 565.3C471.625 565.965 471.915 567.004 471.915 568.395V568.673H466.462C466.462 569.217 466.583 569.725 466.812 570.185C467.042 570.644 467.344 570.983 467.719 571.212C468.094 571.442 468.517 571.551 468.989 571.551C469.835 571.551 470.778 571.261 471.806 570.693V571.914ZM466.546 567.706H470.488V567.512C470.488 566.871 470.331 566.352 470.017 565.977C469.702 565.602 469.279 565.408 468.747 565.408C468.215 565.408 467.755 565.602 467.369 565.989C466.982 566.376 466.704 566.944 466.546 567.706Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M480.548 572.12C479.932 572.374 479.484 572.531 479.206 572.58C478.928 572.628 478.662 572.652 478.396 572.652C477.84 572.652 477.332 572.543 476.884 572.338C476.437 572.132 476.086 571.806 475.845 571.395C475.603 570.984 475.494 570.331 475.494 569.472V566.28H473.523V565.18H475.494V561.987H476.812V565.18H480.331V566.28H476.812V569.448C476.812 570.089 476.884 570.536 477.042 570.802C477.199 571.068 477.392 571.262 477.646 571.383C477.9 571.504 478.202 571.564 478.541 571.564C479.182 571.564 479.847 571.358 480.548 570.959V572.12Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M489.146 564.526V572.434H487.828V570.693C487.405 571.346 486.933 571.83 486.413 572.156C485.893 572.482 485.373 572.64 484.854 572.64C484.394 572.64 483.971 572.519 483.584 572.265C483.197 572.011 482.931 571.697 482.774 571.285C482.616 570.874 482.544 570.088 482.544 568.928V564.502H483.862V569.085C483.862 569.847 483.898 570.342 483.971 570.596C484.043 570.85 484.176 571.044 484.37 571.201C484.563 571.358 484.781 571.431 484.999 571.431C485.458 571.431 485.954 571.213 486.486 570.778C487.018 570.342 487.453 569.786 487.804 569.121V564.514H489.146V564.526Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M492.568 566.303C492.979 565.638 493.463 565.142 494.019 564.804C494.575 564.465 495.095 564.296 495.567 564.296C496.232 564.296 496.824 564.586 497.356 565.154C497.888 565.723 498.155 566.593 498.155 567.754C498.155 568.673 497.985 569.483 497.622 570.209C497.26 570.934 496.8 571.503 496.22 571.914C495.639 572.325 494.914 572.543 494.043 572.543C493.801 572.543 493.414 572.518 492.907 572.47C492.834 572.458 492.713 572.446 492.568 572.434V575.505H491.25V564.514H492.568V566.303ZM492.568 567.875V571.273C493.04 571.394 493.487 571.454 493.886 571.454C494.684 571.454 495.361 571.14 495.905 570.511C496.45 569.882 496.728 569.024 496.728 567.936C496.728 567.15 496.583 566.557 496.28 566.158C495.978 565.759 495.639 565.566 495.265 565.566C494.853 565.566 494.406 565.771 493.91 566.194C493.415 566.605 492.967 567.174 492.568 567.875Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M506.546 575.083C505.24 574.998 504.14 574.635 503.233 573.97C502.326 573.305 501.625 572.422 501.08 571.298C500.536 570.173 500.27 569.061 500.27 567.936C500.27 566.812 500.536 565.687 501.08 564.575C501.625 563.462 502.338 562.568 503.233 561.902C504.128 561.237 505.228 560.875 506.546 560.79V561.89C505.554 561.975 504.708 562.314 503.995 562.882C503.281 563.462 502.725 564.188 502.314 565.071C501.903 565.965 501.697 566.908 501.697 567.924C501.697 568.94 501.903 569.895 502.314 570.778C502.725 571.673 503.281 572.398 503.995 572.966C504.708 573.535 505.554 573.873 506.546 573.97V575.083Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M511.54 567.935C511.976 568.165 512.302 568.395 512.508 568.613C512.713 568.83 512.859 569.06 512.967 569.302C513.076 569.544 513.112 569.81 513.112 570.112C513.112 570.378 513.064 570.729 512.967 571.164L512.786 571.974C512.689 572.409 512.641 572.736 512.641 572.954C512.641 573.244 512.75 573.486 512.979 573.691C513.209 573.897 513.669 573.993 514.37 573.993H515.47V575.094H514.358C513.064 575.094 512.23 574.888 511.855 574.465C511.48 574.042 511.299 573.582 511.299 573.05C511.299 572.772 511.335 572.47 511.408 572.155L511.54 571.587L511.661 570.97L511.746 570.596C511.782 570.426 511.794 570.245 511.794 570.088C511.794 569.652 511.649 569.278 511.347 568.963C511.057 568.649 510.537 568.492 509.787 568.492H509.158V567.391H509.787C510.525 567.391 511.045 567.234 511.335 566.932C511.637 566.63 511.782 566.243 511.782 565.783C511.782 565.614 511.77 565.444 511.734 565.287L511.649 564.925L511.528 564.308L511.395 563.74C511.323 563.413 511.287 563.111 511.287 562.833C511.287 562.313 511.468 561.841 511.843 561.43C512.218 561.019 513.052 560.801 514.346 560.801H515.458V561.902H514.358C513.669 561.902 513.197 561.998 512.979 562.204C512.75 562.409 512.641 562.651 512.641 562.941C512.641 563.147 512.689 563.474 512.786 563.921L512.967 564.731C513.064 565.166 513.112 565.517 513.112 565.783C513.112 566.085 513.064 566.351 512.967 566.593C512.871 566.835 512.713 567.053 512.508 567.282C512.302 567.476 511.976 567.706 511.54 567.935Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M531.383 570.668C530.984 571.321 530.5 571.829 529.932 572.156C529.363 572.494 528.856 572.664 528.372 572.664C527.707 572.664 527.115 572.373 526.595 571.805C526.075 571.237 525.809 570.366 525.809 569.205C525.809 568.286 525.978 567.476 526.328 566.751C526.679 566.025 527.151 565.457 527.731 565.046C528.312 564.635 529.049 564.417 529.908 564.417C530.162 564.417 530.536 564.441 531.044 564.49C531.117 564.502 531.238 564.514 531.383 564.526H532.701V570.112C532.701 571.067 532.798 571.841 533.003 572.434H531.625C531.528 572.011 531.443 571.418 531.383 570.668ZM531.383 569.097V565.699C530.911 565.578 530.476 565.517 530.077 565.517C529.267 565.517 528.59 565.832 528.046 566.461C527.501 567.089 527.235 567.948 527.235 569.024C527.235 569.81 527.38 570.402 527.683 570.801C527.973 571.2 528.312 571.406 528.699 571.406C529.11 571.406 529.569 571.201 530.065 570.777C530.549 570.354 530.996 569.798 531.383 569.097Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M536.099 566.303C536.51 565.638 536.993 565.142 537.55 564.804C538.106 564.465 538.626 564.296 539.097 564.296C539.762 564.296 540.355 564.586 540.887 565.154C541.419 565.723 541.685 566.593 541.685 567.754C541.685 568.673 541.516 569.483 541.153 570.209C540.79 570.934 540.331 571.503 539.75 571.914C539.17 572.325 538.444 572.543 537.574 572.543C537.332 572.543 536.945 572.518 536.437 572.47C536.365 572.458 536.244 572.446 536.099 572.434V575.505H534.781V564.514H536.099V566.303ZM536.099 567.875V571.273C536.57 571.394 537.018 571.454 537.417 571.454C538.215 571.454 538.892 571.14 539.436 570.511C539.98 569.882 540.258 569.024 540.258 567.936C540.258 567.15 540.113 566.557 539.811 566.158C539.508 565.759 539.17 565.566 538.795 565.566C538.384 565.566 537.937 565.771 537.441 566.194C536.945 566.605 536.498 567.174 536.099 567.875Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M545.808 572.447V565.627H543.608V564.526H547.126V571.346H549.327V572.447H545.808ZM545.603 561.673C545.603 561.37 545.699 561.153 545.905 561.008C546.111 560.863 546.292 560.79 546.473 560.79C546.655 560.79 546.848 560.863 547.054 561.008C547.259 561.153 547.356 561.37 547.356 561.673C547.356 561.963 547.259 562.181 547.054 562.326C546.848 562.471 546.655 562.543 546.473 562.543C546.292 562.543 546.098 562.471 545.905 562.326C545.699 562.181 545.603 561.963 545.603 561.673Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M552.314 572.446V561.455H553.741V566.848L557.828 561.455H559.351L555.41 566.678L559.908 572.458H558.118L553.753 566.848V572.458H552.314V572.446Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M567.585 571.914C566.533 572.41 565.53 572.663 564.599 572.663C563.885 572.663 563.244 572.482 562.688 572.131C562.132 571.781 561.673 571.273 561.334 570.608C560.995 569.955 560.826 569.241 560.826 568.492C560.826 567.766 560.983 567.077 561.31 566.412C561.636 565.747 562.084 565.227 562.652 564.852C563.232 564.477 563.873 564.296 564.574 564.296C565.518 564.296 566.267 564.634 566.836 565.3C567.404 565.965 567.694 567.004 567.694 568.395V568.673H562.241C562.241 569.217 562.362 569.725 562.591 570.185C562.821 570.644 563.123 570.983 563.498 571.212C563.873 571.442 564.296 571.551 564.768 571.551C565.614 571.551 566.558 571.261 567.585 570.693V571.914ZM562.325 567.706H566.267V567.512C566.267 566.871 566.11 566.352 565.796 565.977C565.481 565.602 565.058 565.408 564.526 565.408C563.994 565.408 563.535 565.602 563.148 565.989C562.761 566.376 562.483 566.944 562.325 567.706Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M572.629 572.132L568.977 564.526H570.428L573.342 570.475L575.772 564.526H577.103L574.043 571.878C573.39 573.425 572.786 574.453 572.193 574.961C571.601 575.469 570.851 575.723 569.932 575.723C569.533 575.723 569.17 575.687 568.856 575.614V574.453C569.219 574.562 569.569 574.623 569.896 574.623C570.319 574.623 570.694 574.538 571.033 574.369C571.359 574.199 571.661 573.909 571.939 573.498C572.205 573.075 572.399 572.712 572.52 572.41L572.629 572.132Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M167.117 613.329C166.234 613.631 165.388 613.776 164.59 613.776C163.792 613.776 163.091 613.595 162.474 613.232C161.857 612.869 161.374 612.373 161.035 611.745C160.696 611.116 160.515 610.402 160.515 609.604C160.515 608.407 160.902 607.404 161.688 606.618C162.474 605.832 163.417 605.433 164.517 605.433C165.34 605.433 166.198 605.59 167.105 605.892V607.162C166.186 606.739 165.364 606.533 164.638 606.533C164.155 606.533 163.707 606.654 163.284 606.896C162.861 607.138 162.534 607.5 162.305 608.008C162.075 608.516 161.954 609.036 161.954 609.568C161.954 610.281 162.172 610.959 162.619 611.612C163.066 612.264 163.768 612.579 164.723 612.579C165.013 612.579 165.291 612.555 165.569 612.518C165.847 612.482 166.367 612.325 167.117 612.071V613.329Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M172.425 613.776C171.289 613.776 170.382 613.377 169.705 612.591C169.028 611.805 168.689 610.802 168.689 609.593C168.689 608.383 169.028 607.392 169.705 606.606C170.382 605.82 171.289 605.421 172.425 605.421C173.55 605.421 174.457 605.82 175.134 606.606C175.811 607.392 176.15 608.395 176.15 609.593C176.15 610.79 175.811 611.793 175.134 612.591C174.457 613.377 173.55 613.776 172.425 613.776ZM172.425 612.676C173.127 612.676 173.683 612.398 174.106 611.854C174.517 611.31 174.723 610.548 174.723 609.593C174.723 608.637 174.517 607.888 174.106 607.344C173.695 606.799 173.127 606.521 172.425 606.521C171.724 606.521 171.156 606.799 170.745 607.344C170.334 607.888 170.128 608.637 170.128 609.593C170.128 610.548 170.334 611.31 170.745 611.854C171.156 612.398 171.712 612.676 172.425 612.676Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M177.878 613.558V605.65H179.196V607.379C179.571 606.775 180.031 606.291 180.563 605.953C181.095 605.614 181.627 605.433 182.159 605.433C182.63 605.433 183.054 605.554 183.428 605.807C183.803 606.061 184.081 606.376 184.239 606.787C184.396 607.198 184.468 607.972 184.468 609.157V613.582H183.15V609C183.15 608.238 183.114 607.742 183.042 607.488C182.969 607.234 182.836 607.041 182.642 606.884C182.449 606.726 182.231 606.654 182.002 606.654C181.542 606.654 181.046 606.872 180.514 607.307C179.982 607.742 179.547 608.298 179.196 608.963V613.57H177.878V613.558Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M188.423 613.558V607.392H186.67V606.291H188.423V605.928C188.423 604.889 188.544 604.115 188.774 603.619C189.015 603.123 189.378 602.712 189.874 602.385C190.37 602.071 191.023 601.902 191.833 601.902C192.45 601.902 193.066 601.962 193.707 602.095V603.341C193.018 603.111 192.413 603.002 191.881 603.002C191.458 603.002 191.095 603.075 190.769 603.232C190.442 603.389 190.201 603.643 190.019 603.994C189.838 604.344 189.741 604.937 189.741 605.783V606.291H192.885V607.392H189.741V613.558H188.423Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M197.504 613.558V606.739H195.303V605.638H198.822V612.458H201.023V613.558H197.504ZM197.298 602.785C197.298 602.482 197.395 602.265 197.6 602.119C197.806 601.974 198 601.902 198.169 601.902C198.35 601.902 198.544 601.974 198.749 602.119C198.955 602.265 199.052 602.482 199.052 602.785C199.052 603.075 198.955 603.292 198.749 603.437C198.544 603.583 198.35 603.655 198.169 603.655C197.987 603.655 197.794 603.583 197.6 603.437C197.395 603.292 197.298 603.075 197.298 602.785Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M209.293 611.769C208.894 612.434 208.411 612.929 207.842 613.268C207.274 613.607 206.754 613.776 206.283 613.776C205.617 613.776 205.025 613.486 204.493 612.917C203.961 612.349 203.707 611.478 203.707 610.318C203.707 609.399 203.876 608.589 204.227 607.863C204.578 607.137 205.049 606.569 205.63 606.158C206.21 605.735 206.935 605.529 207.806 605.529C208.06 605.529 208.435 605.553 208.943 605.602C209.015 605.614 209.136 605.626 209.281 605.638H210.599V611.237C210.599 612.567 210.587 613.377 210.551 613.679C210.515 613.981 210.466 614.272 210.382 614.574C210.188 615.275 209.765 615.831 209.088 616.243C208.411 616.654 207.601 616.847 206.645 616.847C205.69 616.847 204.711 616.605 203.731 616.11V614.779C204.106 615.033 204.566 615.263 205.11 615.457C205.654 615.65 206.186 615.747 206.694 615.747C207.093 615.747 207.48 615.686 207.83 615.553C208.193 615.42 208.483 615.239 208.701 614.997C208.919 614.755 209.076 614.477 209.16 614.151C209.245 613.824 209.281 613.413 209.281 612.881V611.769H209.293ZM209.293 610.209V606.811C208.822 606.69 208.387 606.63 207.988 606.63C207.177 606.63 206.5 606.944 205.956 607.573C205.412 608.202 205.146 609.06 205.146 610.136C205.146 610.922 205.291 611.515 205.593 611.914C205.884 612.313 206.222 612.518 206.609 612.518C207.02 612.518 207.48 612.313 207.975 611.89C208.459 611.466 208.894 610.91 209.293 610.209Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M219.22 605.638V613.546H217.903V611.805C217.479 612.458 217.008 612.941 216.488 613.268C215.968 613.594 215.448 613.752 214.928 613.752C214.468 613.752 214.045 613.631 213.658 613.377C213.271 613.123 213.005 612.808 212.848 612.397C212.691 611.986 212.618 611.2 212.618 610.039V605.614H213.936V610.197C213.936 610.958 213.973 611.454 214.045 611.708C214.118 611.962 214.251 612.155 214.444 612.313C214.638 612.47 214.855 612.542 215.073 612.542C215.532 612.542 216.028 612.325 216.56 611.889C217.092 611.454 217.528 610.898 217.878 610.233V605.626H219.22V605.638Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M222.086 613.558V605.65H223.404V607.379C223.816 606.726 224.287 606.243 224.819 605.916C225.351 605.59 225.944 605.433 226.597 605.433C227.068 605.433 227.552 605.505 228.024 605.65V608.504H226.754V606.702C226.536 606.666 226.355 606.642 226.234 606.642C225.738 606.642 225.267 606.835 224.783 607.222C224.299 607.609 223.852 608.19 223.404 608.963V613.558H222.086Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M236.705 613.026C235.653 613.522 234.65 613.776 233.719 613.776C233.005 613.776 232.364 613.594 231.808 613.244C231.252 612.893 230.793 612.385 230.454 611.72C230.115 611.067 229.946 610.354 229.946 609.604C229.946 608.879 230.103 608.189 230.43 607.524C230.756 606.859 231.204 606.339 231.772 605.964C232.352 605.59 232.993 605.408 233.695 605.408C234.638 605.408 235.387 605.747 235.956 606.412C236.524 607.077 236.814 608.117 236.814 609.507V609.785H231.361C231.361 610.33 231.47 610.837 231.699 611.297C231.929 611.756 232.231 612.095 232.606 612.325C232.981 612.555 233.404 612.663 233.876 612.663C234.722 612.663 235.665 612.373 236.693 611.805V613.026H236.705ZM231.445 608.818H235.387V608.625C235.387 607.984 235.23 607.464 234.916 607.089C234.601 606.714 234.178 606.521 233.646 606.521C233.114 606.521 232.655 606.714 232.256 607.101C231.857 607.488 231.591 608.056 231.445 608.818Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M238.955 613.558V602.566H241.107C242.401 602.566 243.259 602.663 243.695 602.857C244.13 603.05 244.456 603.34 244.674 603.727C244.892 604.114 245 604.549 245 605.033C245 605.42 244.94 605.783 244.807 606.134C244.674 606.484 244.493 606.799 244.239 607.089C243.985 607.379 243.622 607.645 243.15 607.899C244.021 608.25 244.614 608.673 244.928 609.193C245.242 609.713 245.387 610.208 245.387 610.728C245.387 611.212 245.254 611.684 244.988 612.143C244.722 612.603 244.36 612.953 243.888 613.195C243.416 613.437 242.655 613.558 241.615 613.558H238.955ZM240.381 607.512H241.881C242.364 607.306 242.727 607.089 242.945 606.871C243.163 606.653 243.332 606.4 243.453 606.121C243.562 605.843 243.622 605.541 243.622 605.215C243.622 604.695 243.465 604.308 243.163 604.054C242.86 603.8 242.268 603.667 241.385 603.667H240.381V607.512ZM240.381 612.457H241.736C242.485 612.457 243.054 612.276 243.416 611.925C243.779 611.575 243.961 611.139 243.961 610.644C243.961 610.281 243.864 609.942 243.658 609.628C243.453 609.314 243.15 609.072 242.739 608.89C242.328 608.709 241.675 608.612 240.78 608.612H240.381V612.457Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M254.046 605.638V613.546H252.728V611.805C252.304 612.458 251.833 612.941 251.313 613.268C250.793 613.594 250.273 613.752 249.753 613.752C249.293 613.752 248.87 613.631 248.483 613.377C248.096 613.123 247.83 612.808 247.673 612.397C247.516 611.986 247.443 611.2 247.443 610.039V605.614H248.761V610.197C248.761 610.958 248.798 611.454 248.87 611.708C248.943 611.962 249.076 612.155 249.269 612.313C249.463 612.47 249.68 612.542 249.898 612.542C250.358 612.542 250.853 612.325 251.385 611.889C251.917 611.454 252.353 610.898 252.703 610.233V605.626H254.046V605.638Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M262.86 613.232C262.243 613.486 261.796 613.643 261.518 613.692C261.24 613.74 260.974 613.764 260.708 613.764C260.151 613.764 259.643 613.655 259.196 613.45C258.749 613.244 258.386 612.918 258.156 612.507C257.926 612.095 257.806 611.442 257.806 610.584V607.392H255.835V606.291H257.806V603.099H259.124V606.291H262.642V607.392H259.124V610.56C259.124 611.201 259.196 611.648 259.353 611.914C259.51 612.18 259.704 612.374 259.958 612.494C260.212 612.615 260.514 612.676 260.853 612.676C261.494 612.676 262.159 612.47 262.86 612.071V613.232Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M271.565 613.232C270.949 613.486 270.501 613.643 270.223 613.692C269.945 613.74 269.679 613.764 269.413 613.764C268.857 613.764 268.349 613.655 267.902 613.45C267.454 613.244 267.092 612.918 266.862 612.507C266.632 612.095 266.511 611.442 266.511 610.584V607.392H264.54V606.291H266.511V603.099H267.829V606.291H271.348V607.392H267.829V610.56C267.829 611.201 267.902 611.648 268.059 611.914C268.216 612.18 268.41 612.374 268.663 612.494C268.917 612.615 269.22 612.676 269.558 612.676C270.199 612.676 270.864 612.47 271.565 612.071V613.232Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M276.91 613.776C275.774 613.776 274.867 613.377 274.19 612.591C273.513 611.805 273.174 610.802 273.174 609.593C273.174 608.383 273.513 607.392 274.19 606.606C274.867 605.82 275.774 605.421 276.91 605.421C278.035 605.421 278.942 605.82 279.619 606.606C280.296 607.392 280.635 608.395 280.635 609.593C280.635 610.79 280.296 611.793 279.619 612.591C278.942 613.377 278.047 613.776 276.91 613.776ZM276.91 612.676C277.612 612.676 278.168 612.398 278.591 611.854C279.002 611.31 279.208 610.548 279.208 609.593C279.208 608.637 279.002 607.888 278.591 607.344C278.18 606.799 277.612 606.521 276.91 606.521C276.209 606.521 275.641 606.799 275.23 607.344C274.819 607.888 274.613 608.637 274.613 609.593C274.613 610.548 274.819 611.31 275.23 611.854C275.641 612.398 276.209 612.676 276.91 612.676Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M282.364 613.558V605.65H283.682V607.379C284.057 606.775 284.517 606.291 285.049 605.953C285.581 605.614 286.113 605.433 286.645 605.433C287.116 605.433 287.54 605.554 287.914 605.807C288.289 606.061 288.567 606.376 288.725 606.787C288.882 607.198 288.954 607.972 288.954 609.157V613.582H287.636V609C287.636 608.238 287.6 607.742 287.527 607.488C287.455 607.234 287.322 607.041 287.128 606.884C286.935 606.726 286.717 606.654 286.488 606.654C286.028 606.654 285.532 606.872 285 607.307C284.468 607.742 284.033 608.298 283.682 608.963V613.57H282.364V613.558Z",
        fill: "#FF5253"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M297.576 616.194C296.27 616.11 295.17 615.747 294.263 615.082C293.356 614.417 292.655 613.534 292.11 612.41C291.566 611.285 291.3 610.173 291.3 609.048C291.3 607.924 291.566 606.799 292.11 605.687C292.655 604.574 293.368 603.679 294.263 603.014C295.158 602.349 296.258 601.986 297.576 601.902V603.002C296.584 603.087 295.738 603.425 295.025 603.994C294.311 604.574 293.755 605.3 293.344 606.182C292.933 607.077 292.739 608.02 292.739 609.036C292.739 610.052 292.945 611.007 293.344 611.89C293.755 612.784 294.311 613.51 295.025 614.078C295.738 614.647 296.584 614.985 297.576 615.082V616.194Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M302.558 609.048C302.993 609.277 303.319 609.507 303.525 609.725C303.731 609.942 303.888 610.172 303.984 610.414C304.081 610.644 304.13 610.922 304.13 611.224C304.13 611.49 304.081 611.841 303.984 612.276L303.803 613.086C303.706 613.522 303.658 613.848 303.658 614.066C303.658 614.356 303.767 614.598 303.997 614.803C304.226 615.009 304.686 615.106 305.387 615.106H306.487V616.206H305.375C304.081 616.206 303.247 616.001 302.872 615.577C302.497 615.166 302.316 614.695 302.316 614.163C302.316 613.884 302.352 613.582 302.425 613.268L302.558 612.699L302.679 612.083L302.763 611.708C302.799 611.539 302.812 611.357 302.812 611.2C302.812 610.765 302.666 610.39 302.364 610.076C302.062 609.761 301.554 609.604 300.804 609.604H300.176V608.504H300.804C301.542 608.504 302.062 608.346 302.352 608.044C302.642 607.742 302.799 607.355 302.799 606.895C302.799 606.726 302.787 606.557 302.751 606.4L302.666 606.037L302.546 605.42L302.412 604.852C302.34 604.525 302.304 604.223 302.304 603.945C302.304 603.425 302.485 602.953 302.86 602.542C303.235 602.119 304.069 601.914 305.363 601.914H306.475V603.014H305.375C304.686 603.014 304.214 603.111 303.997 603.316C303.767 603.522 303.658 603.764 303.658 604.054C303.658 604.259 303.706 604.586 303.803 605.033L303.984 605.843C304.081 606.279 304.13 606.629 304.13 606.895C304.13 607.198 304.081 607.464 303.984 607.706C303.888 607.935 303.731 608.165 303.525 608.395C303.319 608.625 302.993 608.818 302.558 609.048Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M184.457 633.582C183.405 634.078 182.401 634.332 181.47 634.332C180.757 634.332 180.116 634.151 179.56 633.8C179.004 633.449 178.544 632.941 178.205 632.276C177.867 631.623 177.698 630.91 177.698 630.16C177.698 629.435 177.855 628.745 178.181 628.08C178.508 627.415 178.955 626.895 179.524 626.521C180.104 626.146 180.745 625.964 181.446 625.964C182.389 625.964 183.139 626.303 183.707 626.968C184.276 627.633 184.566 628.673 184.566 630.063V630.342H179.112C179.112 630.886 179.221 631.394 179.451 631.853C179.681 632.313 179.983 632.651 180.358 632.881C180.733 633.111 181.156 633.219 181.627 633.219C182.474 633.219 183.417 632.929 184.445 632.361V633.582H184.457ZM179.197 629.374H183.139V629.181C183.139 628.54 182.982 628.02 182.667 627.645C182.353 627.27 181.93 627.077 181.398 627.077C180.866 627.077 180.406 627.27 180.007 627.657C179.608 628.044 179.354 628.612 179.197 629.374Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M188.712 634.114V623.776H186.342V622.675H190.03V633.014H192.497V634.114H188.712Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M201.869 633.582C200.817 634.078 199.813 634.332 198.882 634.332C198.169 634.332 197.528 634.151 196.972 633.8C196.416 633.449 195.956 632.941 195.618 632.276C195.279 631.623 195.11 630.91 195.11 630.16C195.11 629.435 195.267 628.745 195.593 628.08C195.92 627.415 196.367 626.895 196.935 626.521C197.516 626.146 198.157 625.964 198.858 625.964C199.801 625.964 200.551 626.303 201.119 626.968C201.688 627.633 201.978 628.673 201.978 630.063V630.342H196.524C196.524 630.886 196.633 631.394 196.863 631.853C197.093 632.313 197.395 632.651 197.77 632.881C198.145 633.111 198.568 633.219 199.039 633.219C199.886 633.219 200.829 632.929 201.857 632.361V633.582H201.869ZM196.609 629.374H200.551V629.181C200.551 628.54 200.394 628.02 200.079 627.645C199.765 627.27 199.342 627.077 198.81 627.077C198.278 627.077 197.818 627.27 197.419 627.657C197.02 628.044 196.766 628.612 196.609 629.374Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M203.405 634.114V626.206H204.565V628.02C204.928 627.246 205.267 626.714 205.581 626.424C205.895 626.133 206.21 625.988 206.536 625.988C206.923 625.988 207.226 626.133 207.455 626.436C207.685 626.738 207.806 627.161 207.806 627.717V628.141C207.963 627.657 208.145 627.27 208.374 626.968C208.604 626.665 208.822 626.424 209.063 626.254C209.305 626.085 209.571 625.988 209.874 625.988C210.212 625.988 210.502 626.133 210.744 626.424C210.986 626.714 211.107 627.282 211.107 628.141V634.126H209.946V628.721C209.946 628.274 209.934 627.971 209.898 627.814C209.862 627.657 209.813 627.524 209.729 627.439C209.644 627.355 209.547 627.306 209.45 627.306C209.209 627.306 208.943 627.5 208.664 627.875C208.386 628.249 208.096 628.878 207.806 629.737V634.126H206.706V628.733C206.706 628.032 206.633 627.621 206.5 627.5C206.367 627.379 206.246 627.318 206.125 627.318C205.883 627.318 205.629 627.524 205.351 627.947C205.073 628.37 204.807 628.902 204.553 629.567V634.138H203.405V634.114Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M219.293 633.582C218.241 634.078 217.237 634.332 216.306 634.332C215.593 634.332 214.952 634.151 214.396 633.8C213.839 633.449 213.38 632.941 213.041 632.276C212.703 631.623 212.534 630.91 212.534 630.16C212.534 629.435 212.691 628.745 213.017 628.08C213.344 627.415 213.791 626.895 214.359 626.521C214.94 626.146 215.581 625.964 216.282 625.964C217.225 625.964 217.975 626.303 218.543 626.968C219.111 627.633 219.402 628.673 219.402 630.063V630.342H213.948C213.948 630.886 214.057 631.394 214.287 631.853C214.517 632.313 214.819 632.651 215.194 632.881C215.569 633.111 215.992 633.219 216.463 633.219C217.31 633.219 218.253 632.929 219.281 632.361V633.582H219.293ZM214.021 629.374H217.963V629.181C217.963 628.54 217.806 628.02 217.491 627.645C217.177 627.27 216.754 627.077 216.222 627.077C215.69 627.077 215.23 627.27 214.831 627.657C214.432 628.044 214.178 628.612 214.021 629.374Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M221.409 634.114V626.206H222.727V627.935C223.102 627.33 223.561 626.847 224.093 626.508C224.625 626.17 225.157 625.988 225.689 625.988C226.161 625.988 226.584 626.109 226.959 626.363C227.334 626.617 227.612 626.931 227.769 627.343C227.926 627.754 227.999 628.528 227.999 629.713V634.138H226.681V629.555C226.681 628.794 226.645 628.298 226.572 628.044C226.499 627.79 226.366 627.597 226.173 627.439C225.98 627.282 225.762 627.21 225.532 627.21C225.073 627.21 224.577 627.427 224.045 627.862C223.513 628.298 223.078 628.854 222.727 629.519V634.126H221.409V634.114Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M236.742 633.788C236.125 634.042 235.678 634.199 235.4 634.247C235.122 634.296 234.856 634.32 234.59 634.32C234.033 634.32 233.526 634.211 233.078 634.005C232.631 633.8 232.268 633.473 232.038 633.062C231.808 632.651 231.688 631.998 231.688 631.14V627.947H229.717V626.847H231.688V623.655H232.993V626.847H236.512V627.947H232.993V631.115C232.993 631.756 233.066 632.204 233.223 632.47C233.38 632.736 233.574 632.929 233.828 633.05C234.082 633.171 234.384 633.231 234.723 633.231C235.363 633.231 236.029 633.026 236.73 632.627V633.788H236.742Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M242.087 628.286C241.772 628.286 241.494 628.177 241.277 627.948C241.059 627.718 240.938 627.452 240.938 627.137C240.938 626.811 241.047 626.545 241.277 626.315C241.506 626.085 241.772 625.977 242.087 625.977C242.401 625.977 242.667 626.085 242.897 626.315C243.127 626.545 243.236 626.811 243.236 627.137C243.236 627.452 243.127 627.73 242.897 627.948C242.667 628.165 242.401 628.286 242.087 628.286ZM242.087 634.441C241.772 634.441 241.494 634.332 241.277 634.102C241.059 633.873 240.938 633.606 240.938 633.292C240.938 632.966 241.047 632.7 241.277 632.47C241.506 632.24 241.772 632.131 242.087 632.131C242.401 632.131 242.667 632.24 242.897 632.47C243.127 632.7 243.236 632.966 243.236 633.292C243.236 633.606 243.127 633.885 242.897 634.102C242.667 634.32 242.401 634.441 242.087 634.441Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M257.467 627.972C257.878 627.307 258.362 626.811 258.918 626.473C259.474 626.134 259.994 625.965 260.466 625.965C261.131 625.965 261.723 626.255 262.255 626.823C262.787 627.391 263.053 628.262 263.053 629.423C263.053 630.342 262.872 631.152 262.521 631.878C262.171 632.603 261.699 633.171 261.119 633.583C260.538 633.994 259.813 634.211 258.942 634.211C258.7 634.211 258.313 634.187 257.806 634.139C257.733 634.127 257.612 634.115 257.467 634.102H256.149V622.664H257.467V627.972ZM257.467 629.544V632.942C257.939 633.063 258.386 633.123 258.785 633.123C259.583 633.123 260.26 632.809 260.804 632.18C261.348 631.551 261.627 630.693 261.627 629.604C261.627 628.818 261.482 628.226 261.179 627.827C260.877 627.428 260.538 627.234 260.163 627.234C259.752 627.234 259.305 627.44 258.809 627.863C258.301 628.274 257.854 628.842 257.467 629.544Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M271.458 626.194V634.102H270.14V632.361C269.716 633.014 269.245 633.498 268.725 633.824C268.205 634.15 267.685 634.308 267.165 634.308C266.706 634.308 266.282 634.187 265.895 633.933C265.508 633.679 265.242 633.365 265.085 632.953C264.928 632.542 264.855 631.756 264.855 630.595V626.17H266.174V630.753C266.174 631.514 266.21 632.01 266.282 632.264C266.355 632.518 266.488 632.712 266.681 632.869C266.875 633.026 267.092 633.099 267.31 633.099C267.77 633.099 268.265 632.881 268.797 632.446C269.329 632.01 269.765 631.454 270.115 630.789V626.182H271.458V626.194Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M280.272 633.788C279.656 634.042 279.208 634.199 278.93 634.247C278.652 634.296 278.386 634.32 278.12 634.32C277.564 634.32 277.056 634.211 276.609 634.005C276.161 633.8 275.798 633.473 275.569 633.062C275.339 632.651 275.218 631.998 275.218 631.14V627.947H273.247V626.847H275.218V623.655H276.536V626.847H280.055V627.947H276.536V631.115C276.536 631.756 276.609 632.204 276.766 632.47C276.923 632.736 277.116 632.929 277.37 633.05C277.624 633.171 277.927 633.231 278.265 633.231C278.906 633.231 279.571 633.026 280.272 632.627V633.788Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M288.99 633.788C288.374 634.042 287.926 634.199 287.648 634.247C287.37 634.296 287.104 634.32 286.838 634.32C286.282 634.32 285.774 634.211 285.327 634.005C284.879 633.8 284.516 633.473 284.287 633.062C284.057 632.651 283.936 631.998 283.936 631.14V627.947H281.965V626.847H283.936V623.655H285.254V626.847H288.773V627.947H285.254V631.115C285.254 631.756 285.326 632.204 285.484 632.47C285.641 632.736 285.834 632.929 286.088 633.05C286.342 633.171 286.645 633.231 286.983 633.231C287.624 633.231 288.289 633.026 288.99 632.627V633.788Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M294.335 634.332C293.199 634.332 292.292 633.933 291.615 633.147C290.938 632.361 290.599 631.357 290.599 630.148C290.599 628.939 290.938 627.948 291.615 627.162C292.292 626.376 293.199 625.977 294.335 625.977C295.46 625.977 296.367 626.376 297.044 627.162C297.721 627.948 298.06 628.951 298.06 630.148C298.06 631.345 297.721 632.349 297.044 633.147C296.367 633.933 295.46 634.332 294.335 634.332ZM294.335 633.232C295.037 633.232 295.593 632.954 296.016 632.409C296.427 631.865 296.633 631.104 296.633 630.148C296.633 629.193 296.427 628.443 296.016 627.899C295.605 627.355 295.037 627.077 294.335 627.077C293.634 627.077 293.066 627.355 292.655 627.899C292.243 628.443 292.038 629.193 292.038 630.148C292.038 631.104 292.243 631.865 292.655 632.409C293.066 632.954 293.622 633.232 294.335 633.232Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M299.776 634.114V626.206H301.094V627.935C301.469 627.33 301.929 626.847 302.461 626.508C302.993 626.17 303.525 625.988 304.057 625.988C304.528 625.988 304.952 626.109 305.327 626.363C305.701 626.617 305.979 626.931 306.137 627.343C306.294 627.754 306.366 628.528 306.366 629.713V634.138H305.048V629.555C305.048 628.794 305.012 628.298 304.94 628.044C304.867 627.79 304.734 627.597 304.541 627.439C304.347 627.282 304.129 627.21 303.9 627.21C303.44 627.21 302.944 627.427 302.412 627.862C301.88 628.298 301.445 628.854 301.094 629.519V634.126H299.776V634.114Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M310.393 637.186V636.303C310.731 636.218 310.997 636.085 311.167 635.916C311.336 635.747 311.481 635.541 311.59 635.275C311.699 635.009 311.747 634.707 311.747 634.344C311.312 634.344 310.985 634.223 310.78 633.969C310.574 633.715 310.465 633.461 310.465 633.171C310.465 632.845 310.586 632.567 310.816 632.349C311.046 632.131 311.312 632.01 311.626 632.01C312.025 632.01 312.364 632.18 312.654 632.518C312.944 632.857 313.089 633.328 313.089 633.921C313.089 634.441 312.98 634.924 312.751 635.396C312.521 635.868 312.219 636.255 311.832 636.581C311.445 636.907 310.961 637.113 310.393 637.186Z",
        fill: "#EFF0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M95.3636 99.6563H88.7131V98.4471C88.7131 98.1327 88.7736 97.8063 88.9066 97.4435C89.0397 97.0808 89.2815 96.6817 89.6321 96.2464C89.9828 95.8111 90.3697 95.3758 90.7688 94.9647L91.5184 94.2029C91.6635 94.0457 92.0021 93.6829 92.51 93.1146C93.0178 92.5463 93.3564 92.111 93.5136 91.8087C93.6708 91.5064 93.7554 91.2041 93.7554 90.9139C93.7554 90.4423 93.562 90.0796 93.1871 89.8136C92.8123 89.5597 92.3891 89.4266 91.9175 89.4266C91.6515 89.4266 91.3492 89.4629 91.0106 89.5234C90.6841 89.5838 90.3818 89.6564 90.14 89.741C89.886 89.8257 89.487 89.9949 88.9187 90.2489V89.076C89.5112 88.7978 90.1158 88.5923 90.7083 88.4955C91.3008 88.3988 91.7965 88.3384 92.1835 88.3384C92.7518 88.3384 93.2838 88.4351 93.7554 88.6165C94.227 88.7978 94.5897 89.088 94.8195 89.4871C95.0492 89.8861 95.1702 90.2972 95.1702 90.7446C95.1702 91.2404 95.0251 91.7483 94.7228 92.2682C94.4205 92.7882 93.8522 93.4532 93.0299 94.2755L92.2198 95.0735L91.5427 95.7386C91.1073 96.1739 90.7687 96.5971 90.5027 96.9961C90.2367 97.4072 90.0916 97.8909 90.0674 98.4471H95.3515V99.6563H95.3636Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M97.3955 99.4505V98.06C98.4717 98.6041 99.4149 98.8822 100.213 98.8822C100.938 98.8822 101.543 98.6646 102.015 98.2172C102.486 97.7698 102.728 97.2135 102.728 96.5122C102.728 95.8109 102.462 95.2426 101.942 94.8073C101.422 94.372 100.527 94.1543 99.2818 94.1543H98.5563V93.054H99.572C100.491 93.054 101.156 92.8484 101.567 92.4373C101.978 92.0262 102.184 91.5667 102.184 91.0588C102.184 90.5993 102.015 90.2124 101.676 89.898C101.337 89.5836 100.83 89.4264 100.128 89.4264C99.3544 89.4264 98.5079 89.6441 97.6132 90.0794V88.8218C98.5079 88.4833 99.3302 88.314 100.08 88.314C101.422 88.314 102.341 88.58 102.849 89.0999C103.357 89.6199 103.611 90.2245 103.611 90.9016C103.611 91.3974 103.478 91.869 103.212 92.3163C102.946 92.7637 102.45 93.1507 101.724 93.4893C102.365 93.6827 102.849 93.9125 103.175 94.1785C103.502 94.4445 103.744 94.771 103.913 95.1458C104.082 95.5207 104.167 95.9318 104.167 96.4034C104.167 97.4312 103.78 98.2776 103.018 98.9548C102.256 99.6319 101.265 99.9584 100.056 99.9584C99.7051 99.9584 99.3302 99.9342 98.907 99.8858C98.4838 99.8375 97.988 99.7045 97.3955 99.4505Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M95.3636 120.212H88.7131V119.003C88.7131 118.689 88.7736 118.362 88.9066 118C89.0397 117.637 89.2815 117.238 89.6321 116.803C89.9828 116.367 90.3697 115.932 90.7688 115.521L91.5184 114.759C91.6635 114.602 92.0021 114.239 92.51 113.671C93.0178 113.102 93.3564 112.667 93.5136 112.365C93.6708 112.063 93.7554 111.76 93.7554 111.47C93.7554 110.998 93.562 110.636 93.1871 110.37C92.8123 110.116 92.3891 109.983 91.9175 109.983C91.6515 109.983 91.3492 110.019 91.0106 110.08C90.6841 110.14 90.3818 110.213 90.14 110.297C89.886 110.382 89.487 110.551 88.9187 110.805V109.632C89.5112 109.354 90.1158 109.148 90.7083 109.052C91.3008 108.955 91.7965 108.895 92.1835 108.895C92.7518 108.895 93.2838 108.991 93.7554 109.173C94.227 109.354 94.5897 109.644 94.8195 110.043C95.0492 110.442 95.1702 110.853 95.1702 111.301C95.1702 111.797 95.0251 112.304 94.7228 112.824C94.4205 113.344 93.8522 114.009 93.0299 114.832L92.2198 115.63L91.5427 116.295C91.1073 116.73 90.7687 117.153 90.5027 117.552C90.2367 117.963 90.0916 118.447 90.0674 119.003H95.3515V120.212H95.3636Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M101.386 120.212V117.141H96.7061V116.04L101.386 109.221H102.704V116.04H104.735V117.141H102.704V120.212H101.386ZM101.386 116.028V111.204L98.1087 116.028H101.386Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M95.3636 140.768H88.7131V139.559C88.7131 139.245 88.7736 138.918 88.9066 138.555C89.0397 138.193 89.2815 137.794 89.6321 137.358C89.9828 136.923 90.3697 136.488 90.7688 136.076L91.5184 135.315C91.6635 135.157 92.0021 134.795 92.51 134.226C93.0178 133.658 93.3564 133.223 93.5136 132.921C93.6708 132.618 93.7554 132.316 93.7554 132.026C93.7554 131.554 93.562 131.191 93.1871 130.925C92.8123 130.671 92.3891 130.538 91.9175 130.538C91.6515 130.538 91.3492 130.575 91.0106 130.635C90.6841 130.696 90.3818 130.768 90.14 130.853C89.886 130.937 89.487 131.107 88.9187 131.361V130.188C89.5112 129.91 90.1158 129.704 90.7083 129.607C91.3008 129.511 91.7965 129.45 92.1835 129.45C92.7518 129.45 93.2838 129.547 93.7554 129.728C94.227 129.91 94.5897 130.2 94.8195 130.599C95.0492 130.998 95.1702 131.409 95.1702 131.856C95.1702 132.352 95.0251 132.86 94.7228 133.38C94.4205 133.9 93.8522 134.565 93.0299 135.387L92.2198 136.185L91.5427 136.85C91.1073 137.286 90.7687 137.709 90.5027 138.108C90.2367 138.519 90.0916 139.003 90.0674 139.559H95.3515V140.768H95.3636Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M97.6973 135.048V129.764H103.852V131.034H99.0153V133.73H99.2451C100.829 133.73 102.05 134.057 102.897 134.722C103.743 135.387 104.178 136.27 104.178 137.394C104.178 138.108 104.009 138.736 103.659 139.305C103.308 139.873 102.824 140.308 102.195 140.623C101.567 140.937 100.902 141.106 100.188 141.106C99.4748 141.106 98.5679 140.937 97.4675 140.586V139.147C97.8666 139.365 98.314 139.546 98.8098 139.679C99.3055 139.812 99.765 139.885 100.188 139.885C100.611 139.885 101.023 139.788 101.422 139.583C101.821 139.377 102.135 139.087 102.353 138.7C102.57 138.313 102.691 137.914 102.691 137.503C102.691 136.814 102.389 136.245 101.784 135.762C101.18 135.278 100.104 135.048 98.5558 135.048H97.6973Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M95.3636 161.325H88.7131V160.116C88.7131 159.801 88.7736 159.475 88.9066 159.112C89.0397 158.749 89.2815 158.35 89.6321 157.915C89.9828 157.48 90.3697 157.044 90.7688 156.633L91.5184 155.871C91.6635 155.714 92.0021 155.351 92.51 154.783C93.0178 154.215 93.3564 153.779 93.5136 153.477C93.6708 153.175 93.7554 152.873 93.7554 152.582C93.7554 152.111 93.562 151.748 93.1871 151.482C92.8123 151.228 92.3891 151.095 91.9175 151.095C91.6515 151.095 91.3492 151.131 91.0106 151.192C90.6841 151.252 90.3818 151.325 90.14 151.409C89.886 151.494 89.487 151.663 88.9187 151.917V150.744C89.5112 150.466 90.1158 150.261 90.7083 150.164C91.3008 150.067 91.7965 150.007 92.1835 150.007C92.7518 150.007 93.2838 150.104 93.7554 150.285C94.227 150.466 94.5897 150.757 94.8195 151.156C95.0492 151.555 95.1702 151.966 95.1702 152.413C95.1702 152.909 95.0251 153.417 94.7228 153.937C94.4205 154.457 93.8522 155.122 93.0299 155.944L92.2198 156.742L91.5427 157.407C91.1073 157.842 90.7687 158.266 90.5027 158.665C90.2367 159.076 90.0916 159.559 90.0674 160.116H95.3515V161.325H95.3636Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M98.4348 156.162C98.7734 155.654 99.1967 155.243 99.7045 154.928C100.212 154.614 100.757 154.445 101.361 154.445C101.929 154.445 102.474 154.59 102.981 154.868C103.489 155.146 103.888 155.533 104.154 156.029C104.42 156.524 104.553 157.105 104.553 157.77C104.553 158.81 104.215 159.717 103.55 160.49C102.885 161.264 102.002 161.651 100.914 161.651C99.632 161.651 98.6646 161.119 98.0359 160.043C97.4071 158.967 97.0806 157.6 97.0806 155.944C97.0806 154.106 97.4796 152.667 98.2897 151.603C99.0999 150.539 100.188 150.007 101.567 150.007C102.304 150.007 103.03 150.116 103.731 150.333V151.663C102.945 151.289 102.208 151.107 101.518 151.107C100.539 151.107 99.7771 151.555 99.2329 152.461C98.6888 153.368 98.4228 154.505 98.4228 155.896V156.162H98.4348ZM101.023 160.551C101.373 160.551 101.736 160.442 102.087 160.236C102.437 160.031 102.727 159.704 102.933 159.269C103.139 158.834 103.235 158.362 103.235 157.842C103.235 157.177 103.066 156.621 102.715 156.186C102.365 155.75 101.869 155.545 101.228 155.545C100.563 155.545 100.019 155.799 99.5836 156.295C99.1483 156.79 98.9428 157.395 98.9428 158.108C98.9428 158.822 99.1483 159.414 99.5715 159.874C99.9947 160.333 100.478 160.551 101.023 160.551Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M95.3636 181.88H88.7131V180.671C88.7131 180.356 88.7736 180.03 88.9066 179.667C89.0397 179.304 89.2815 178.905 89.6321 178.47C89.9828 178.035 90.3697 177.599 90.7688 177.188L91.5184 176.427C91.6635 176.269 92.0021 175.907 92.51 175.338C93.0178 174.77 93.3564 174.335 93.5136 174.032C93.6708 173.73 93.7554 173.428 93.7554 173.138C93.7554 172.666 93.562 172.303 93.1871 172.037C92.8123 171.783 92.3891 171.65 91.9175 171.65C91.6515 171.65 91.3492 171.687 91.0106 171.747C90.6841 171.807 90.3818 171.88 90.14 171.965C89.886 172.049 89.487 172.219 88.9187 172.473V171.3C89.5112 171.021 90.1158 170.816 90.7083 170.719C91.3008 170.622 91.7965 170.562 92.1835 170.562C92.7518 170.562 93.2838 170.659 93.7554 170.84C94.227 171.021 94.5897 171.312 94.8195 171.711C95.0492 172.11 95.1702 172.521 95.1702 172.968C95.1702 173.464 95.0251 173.972 94.7228 174.492C94.4205 175.012 93.8522 175.677 93.0299 176.499L92.2198 177.297L91.5427 177.962C91.1073 178.397 90.7687 178.821 90.5027 179.22C90.2367 179.631 90.0916 180.115 90.0674 180.671H95.3515V181.88H95.3636Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M98.6286 181.881V180.901C98.6286 180.128 98.7132 179.487 98.8946 178.955C99.076 178.423 99.3783 177.842 99.8136 177.201C100.249 176.56 100.6 176.065 100.866 175.714L102.014 174.19L102.425 173.658C102.74 173.235 103.006 172.752 103.236 172.195H97.5282V170.865H104.505V171.748C104.505 172.099 104.433 172.425 104.3 172.715C104.167 173.005 103.743 173.646 103.03 174.626C102.861 174.856 102.691 175.085 102.534 175.327L101.797 176.355C101.325 177.02 100.974 177.552 100.745 177.951C100.515 178.35 100.346 178.761 100.237 179.196C100.116 179.632 100.068 180.188 100.068 180.889V181.869H98.6286V181.881Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M95.3636 202.437H88.7131V201.227C88.7131 200.913 88.7736 200.587 88.9066 200.224C89.0397 199.861 89.2815 199.462 89.6321 199.027C89.9828 198.591 90.3697 198.156 90.7688 197.745L91.5184 196.983C91.6635 196.826 92.0021 196.463 92.51 195.895C93.0178 195.327 93.3564 194.891 93.5136 194.589C93.6708 194.287 93.7554 193.984 93.7554 193.694C93.7554 193.223 93.562 192.86 93.1871 192.594C92.8123 192.34 92.3891 192.207 91.9175 192.207C91.6515 192.207 91.3492 192.243 91.0106 192.304C90.6841 192.364 90.3818 192.437 90.14 192.521C89.886 192.606 89.487 192.775 88.9187 193.029V191.856C89.5112 191.578 90.1158 191.373 90.7083 191.276C91.3008 191.179 91.7965 191.119 92.1835 191.119C92.7518 191.119 93.2838 191.215 93.7554 191.397C94.227 191.578 94.5897 191.868 94.8195 192.267C95.0492 192.666 95.1702 193.078 95.1702 193.525C95.1702 194.021 95.0251 194.529 94.7228 195.048C94.4205 195.568 93.8522 196.233 93.0299 197.056L92.2198 197.854L91.5427 198.519C91.1073 198.954 90.7687 199.377 90.5027 199.776C90.2367 200.188 90.0916 200.671 90.0674 201.227H95.3515V202.437H95.3636Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M99.6206 196.499L99.3788 196.318C99.0402 196.076 98.7137 195.737 98.3872 195.278C98.0607 194.818 97.9036 194.31 97.9036 193.754C97.9036 193.016 98.1938 192.4 98.7621 191.88C99.3304 191.36 100.068 191.106 100.963 191.106C101.507 191.106 101.991 191.203 102.426 191.396C102.861 191.59 103.2 191.88 103.429 192.267C103.659 192.654 103.78 193.065 103.78 193.524C103.78 193.839 103.732 194.141 103.623 194.431C103.514 194.721 103.357 195.012 103.139 195.29C102.922 195.58 102.498 195.979 101.858 196.499L102.45 196.97C103.151 197.539 103.611 198.022 103.853 198.434C104.095 198.845 104.215 199.304 104.215 199.812C104.215 200.61 103.925 201.299 103.357 201.88C102.789 202.46 101.918 202.75 100.769 202.75C99.6085 202.75 98.75 202.472 98.1696 201.928C97.5892 201.384 97.311 200.707 97.311 199.897C97.311 198.712 98.0729 197.575 99.6206 196.499ZM100.612 197.2C99.3667 198.155 98.7379 199.062 98.7379 199.897C98.7379 200.392 98.9434 200.816 99.3546 201.154C99.7657 201.493 100.249 201.662 100.818 201.662C101.326 201.662 101.785 201.505 102.196 201.178C102.595 200.852 102.801 200.441 102.801 199.957C102.801 199.486 102.559 199.002 102.063 198.506C101.567 198.01 101.229 197.696 101.035 197.539L100.612 197.2ZM100.963 195.822C101.628 195.314 102.051 194.891 102.22 194.552C102.39 194.214 102.474 193.899 102.474 193.597C102.474 193.246 102.317 192.92 102.003 192.63C101.688 192.339 101.289 192.194 100.793 192.194C100.261 192.194 99.8624 192.351 99.5843 192.666C99.3062 192.98 99.1732 193.307 99.1732 193.645C99.1732 193.972 99.2941 194.286 99.5239 194.576C99.7536 194.867 100.128 195.193 100.636 195.556L100.963 195.822Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M95.3636 222.993H88.7131V221.784C88.7131 221.469 88.7736 221.143 88.9066 220.78C89.0397 220.417 89.2815 220.018 89.6321 219.583C89.9828 219.148 90.3697 218.712 90.7688 218.301L91.5184 217.539C91.6635 217.382 92.0021 217.019 92.51 216.451C93.0178 215.883 93.3564 215.447 93.5136 215.145C93.6708 214.843 93.7554 214.541 93.7554 214.25C93.7554 213.779 93.562 213.416 93.1871 213.15C92.8123 212.896 92.3891 212.763 91.9175 212.763C91.6515 212.763 91.3492 212.799 91.0106 212.86C90.6841 212.92 90.3818 212.993 90.14 213.077C89.886 213.162 89.487 213.331 88.9187 213.585V212.412C89.5112 212.134 90.1158 211.929 90.7083 211.832C91.3008 211.735 91.7965 211.675 92.1835 211.675C92.7518 211.675 93.2838 211.772 93.7554 211.953C94.227 212.134 94.5897 212.424 94.8195 212.824C95.0492 213.223 95.1702 213.634 95.1702 214.081C95.1702 214.577 95.0251 215.085 94.7228 215.605C94.4205 216.125 93.8522 216.79 93.0299 217.612L92.2198 218.41L91.5427 219.075C91.1073 219.51 90.7687 219.934 90.5027 220.333C90.2367 220.744 90.0916 221.227 90.0674 221.784H95.3515V222.993H95.3636Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M102.994 217.152C102.655 217.66 102.232 218.071 101.724 218.386C101.216 218.7 100.672 218.869 100.067 218.869C99.4992 218.869 98.955 218.736 98.4472 218.458C97.9393 218.18 97.5403 217.793 97.2743 217.297C97.0083 216.802 96.8752 216.221 96.8752 215.556C96.8752 214.516 97.2138 213.609 97.8789 212.836C98.5439 212.062 99.4266 211.675 100.515 211.675C101.797 211.675 102.764 212.207 103.393 213.283C104.022 214.359 104.348 215.726 104.348 217.382C104.348 219.22 103.949 220.659 103.139 221.723C102.329 222.787 101.24 223.319 99.862 223.319C99.1244 223.319 98.3988 223.21 97.6975 222.981V221.651C98.4834 222.013 99.2211 222.207 99.9103 222.207C100.89 222.207 101.652 221.759 102.196 220.852C102.74 219.946 103.006 218.809 103.006 217.418V217.152H102.994ZM100.406 212.763C100.055 212.763 99.6926 212.872 99.3419 213.077C98.9913 213.283 98.7011 213.609 98.4956 214.045C98.29 214.48 98.1933 214.952 98.1933 215.472C98.1933 216.137 98.3626 216.681 98.7132 217.116C99.0639 217.551 99.5596 217.757 100.2 217.757C100.866 217.757 101.41 217.503 101.845 217.007C102.28 216.512 102.486 215.907 102.486 215.194C102.486 214.48 102.28 213.888 101.857 213.428C101.434 212.969 100.95 212.763 100.406 212.763Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M88.689 243.343V241.953C89.7651 242.497 90.7083 242.775 91.5064 242.775C92.2319 242.775 92.8365 242.557 93.308 242.11C93.7796 241.662 94.0215 241.106 94.0215 240.405C94.0215 239.703 93.7554 239.135 93.2355 238.7C92.7155 238.265 91.8207 238.047 90.5753 238.047H89.8498V236.947H90.8655C91.7845 236.947 92.4495 236.741 92.8607 236.33C93.2718 235.919 93.4773 235.459 93.4773 234.951C93.4773 234.492 93.3081 234.105 92.9695 233.791C92.6309 233.476 92.1231 233.319 91.4217 233.319C90.6478 233.319 89.8015 233.537 88.9067 233.972V232.714C89.8015 232.376 90.6237 232.207 91.3734 232.207C92.7156 232.207 93.6345 232.473 94.1424 232.993C94.6502 233.512 94.9042 234.117 94.9042 234.794C94.9042 235.29 94.7711 235.762 94.5051 236.209C94.2391 236.656 93.7434 237.043 93.0179 237.382C93.6587 237.575 94.1424 237.805 94.4689 238.071C94.7954 238.337 95.0372 238.664 95.2065 239.038C95.3758 239.413 95.4604 239.824 95.4604 240.296C95.4604 241.324 95.0735 242.17 94.3117 242.847C93.5499 243.524 92.5584 243.851 91.3492 243.851C90.9985 243.851 90.6237 243.827 90.2004 243.778C89.7772 243.73 89.2815 243.597 88.689 243.343Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M100.72 232.218C101.978 232.218 102.921 232.738 103.586 233.79C104.251 234.842 104.566 236.257 104.566 238.034C104.566 239.824 104.239 241.239 103.586 242.291C102.933 243.343 101.978 243.863 100.72 243.863C99.475 243.863 98.5197 243.343 97.8668 242.291C97.2138 241.239 96.8752 239.824 96.8752 238.034C96.8752 236.257 97.2017 234.842 97.8668 233.79C98.5318 232.738 99.4629 232.218 100.72 232.218ZM98.5681 240.392L102.365 234.431C102.123 233.996 101.869 233.693 101.579 233.548C101.289 233.403 101.011 233.319 100.708 233.319C99.9224 233.319 99.3178 233.754 98.9067 234.637C98.4955 235.507 98.29 236.62 98.29 237.974C98.29 238.276 98.3021 238.615 98.3142 238.965C98.3504 239.316 98.423 239.788 98.5681 240.392ZM102.836 235.749L99.0639 241.747C99.2694 242.097 99.4992 242.351 99.7652 242.52C100.031 242.69 100.321 242.774 100.648 242.774C101.543 242.774 102.184 242.267 102.558 241.263C102.933 240.259 103.127 239.147 103.127 237.926C103.127 237.176 103.03 236.45 102.836 235.749Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M88.689 263.899V262.509C89.7651 263.053 90.7083 263.331 91.5064 263.331C92.2319 263.331 92.8365 263.113 93.308 262.666C93.7796 262.218 94.0215 261.662 94.0215 260.961C94.0215 260.26 93.7554 259.691 93.2355 259.256C92.7155 258.821 91.8207 258.603 90.5753 258.603H89.8498V257.503H90.8655C91.7845 257.503 92.4495 257.297 92.8607 256.886C93.2718 256.475 93.4773 256.015 93.4773 255.508C93.4773 255.048 93.3081 254.661 92.9695 254.347C92.6309 254.032 92.1231 253.875 91.4217 253.875C90.6478 253.875 89.8015 254.093 88.9067 254.528V253.271C89.8015 252.932 90.6237 252.763 91.3734 252.763C92.7156 252.763 93.6345 253.029 94.1424 253.549C94.6502 254.069 94.9042 254.673 94.9042 255.35C94.9042 255.846 94.7711 256.318 94.5051 256.765C94.2391 257.212 93.7434 257.599 93.0179 257.938C93.6587 258.131 94.1424 258.361 94.4689 258.627C94.7954 258.893 95.0372 259.22 95.2065 259.595C95.3758 259.969 95.4604 260.381 95.4604 260.852C95.4604 261.88 95.0735 262.726 94.3117 263.404C93.5499 264.081 92.5584 264.407 91.3492 264.407C90.9985 264.407 90.6237 264.383 90.2004 264.335C89.7772 264.286 89.2815 264.153 88.689 263.899Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M100.394 263.004V254.528C99.995 254.842 99.608 255.108 99.2332 255.326C98.8583 255.544 98.3505 255.773 97.6975 256.003V254.818C98.7374 254.383 99.6322 253.815 100.394 253.113H101.712V263.016H104.36V264.117H97.7096V263.016H100.394V263.004Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M88.689 284.455V283.064C89.7651 283.608 90.7083 283.887 91.5064 283.887C92.2319 283.887 92.8365 283.669 93.308 283.222C93.7796 282.774 94.0215 282.218 94.0215 281.517C94.0215 280.815 93.7554 280.247 93.2355 279.812C92.7155 279.376 91.8207 279.159 90.5753 279.159H89.8498V278.058H90.8655C91.7845 278.058 92.4495 277.853 92.8607 277.442C93.2718 277.031 93.4773 276.571 93.4773 276.063C93.4773 275.604 93.3081 275.217 92.9695 274.902C92.6309 274.588 92.1231 274.431 91.4217 274.431C90.6478 274.431 89.8015 274.648 88.9067 275.084V273.826C89.8015 273.488 90.6237 273.318 91.3734 273.318C92.7156 273.318 93.6345 273.584 94.1424 274.104C94.6502 274.624 94.9042 275.229 94.9042 275.906C94.9042 276.402 94.7711 276.873 94.5051 277.321C94.2391 277.768 93.7434 278.155 93.0179 278.494C93.6587 278.687 94.1424 278.917 94.4689 279.183C94.7954 279.449 95.0372 279.775 95.2065 280.15C95.3758 280.525 95.4604 280.936 95.4604 281.408C95.4604 282.436 95.0735 283.282 94.3117 283.959C93.5499 284.636 92.5584 284.963 91.3492 284.963C90.9985 284.963 90.6237 284.939 90.2004 284.89C89.7772 284.842 89.2815 284.709 88.689 284.455Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M104.07 284.661H97.4197V283.452C97.4197 283.137 97.4801 282.811 97.6131 282.448C97.7461 282.085 97.988 281.686 98.3387 281.251C98.6893 280.815 99.0763 280.38 99.4753 279.969L100.225 279.207C100.37 279.05 100.709 278.687 101.217 278.119C101.724 277.551 102.063 277.115 102.22 276.813C102.377 276.511 102.462 276.209 102.462 275.918C102.462 275.447 102.269 275.084 101.894 274.818C101.519 274.564 101.096 274.431 100.624 274.431C100.358 274.431 100.056 274.467 99.7172 274.528C99.3907 274.588 99.0883 274.661 98.8465 274.745C98.5926 274.83 98.1935 274.999 97.6252 275.253V274.08C98.2177 273.802 98.8224 273.597 99.4149 273.5C100.007 273.403 100.503 273.343 100.89 273.343C101.458 273.343 101.99 273.439 102.462 273.621C102.934 273.802 103.296 274.092 103.526 274.491C103.756 274.891 103.877 275.302 103.877 275.749C103.877 276.245 103.732 276.753 103.429 277.273C103.127 277.793 102.559 278.458 101.736 279.28L100.926 280.078L100.249 280.743C99.8138 281.178 99.4753 281.601 99.2092 282.001C98.9432 282.412 98.7981 282.895 98.774 283.452H104.058V284.661H104.07Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M88.689 305.011V303.621C89.7651 304.165 90.7083 304.443 91.5064 304.443C92.2319 304.443 92.8365 304.225 93.308 303.778C93.7796 303.33 94.0215 302.774 94.0215 302.073C94.0215 301.371 93.7554 300.803 93.2355 300.368C92.7155 299.933 91.8207 299.715 90.5753 299.715H89.8498V298.615H90.8655C91.7845 298.615 92.4495 298.409 92.8607 297.998C93.2718 297.587 93.4773 297.127 93.4773 296.619C93.4773 296.16 93.3081 295.773 92.9695 295.459C92.6309 295.144 92.1231 294.987 91.4217 294.987C90.6478 294.987 89.8015 295.205 88.9067 295.64V294.382C89.8015 294.044 90.6237 293.875 91.3734 293.875C92.7156 293.875 93.6345 294.141 94.1424 294.66C94.6502 295.18 94.9042 295.785 94.9042 296.462C94.9042 296.958 94.7711 297.43 94.5051 297.877C94.2391 298.324 93.7434 298.711 93.0179 299.05C93.6587 299.243 94.1424 299.473 94.4689 299.739C94.7954 300.005 95.0372 300.332 95.2065 300.706C95.3758 301.081 95.4604 301.492 95.4604 301.964C95.4604 302.992 95.0735 303.838 94.3117 304.515C93.5499 305.192 92.5584 305.519 91.3492 305.519C90.9985 305.519 90.6237 305.495 90.2004 305.446C89.7772 305.398 89.2815 305.265 88.689 305.011Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M97.3955 305.011V303.621C98.4717 304.165 99.4149 304.443 100.213 304.443C100.938 304.443 101.543 304.225 102.015 303.778C102.486 303.33 102.728 302.774 102.728 302.073C102.728 301.371 102.462 300.803 101.942 300.368C101.422 299.933 100.527 299.715 99.2818 299.715H98.5563V298.615H99.572C100.491 298.615 101.156 298.409 101.567 297.998C101.978 297.587 102.184 297.127 102.184 296.619C102.184 296.16 102.015 295.773 101.676 295.459C101.337 295.144 100.83 294.987 100.128 294.987C99.3544 294.987 98.5079 295.205 97.6132 295.64V294.382C98.5079 294.044 99.3302 293.875 100.08 293.875C101.422 293.875 102.341 294.141 102.849 294.66C103.357 295.18 103.611 295.785 103.611 296.462C103.611 296.958 103.478 297.43 103.212 297.877C102.946 298.324 102.45 298.711 101.724 299.05C102.365 299.243 102.849 299.473 103.175 299.739C103.502 300.005 103.744 300.332 103.913 300.706C104.082 301.081 104.167 301.492 104.167 301.964C104.167 302.992 103.78 303.838 103.018 304.515C102.256 305.192 101.265 305.519 100.056 305.519C99.7051 305.519 99.3302 305.495 98.907 305.446C98.4838 305.398 97.988 305.265 97.3955 305.011Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M88.689 325.568V324.177C89.7651 324.721 90.7083 324.999 91.5064 324.999C92.2319 324.999 92.8365 324.782 93.308 324.334C93.7796 323.887 94.0215 323.331 94.0215 322.629C94.0215 321.928 93.7554 321.36 93.2355 320.924C92.7155 320.489 91.8207 320.272 90.5753 320.272H89.8498V319.171H90.8655C91.7845 319.171 92.4495 318.966 92.8607 318.554C93.2718 318.143 93.4773 317.684 93.4773 317.176C93.4773 316.717 93.3081 316.33 92.9695 316.015C92.6309 315.701 92.1231 315.544 91.4217 315.544C90.6478 315.544 89.8015 315.761 88.9067 316.197V314.939C89.8015 314.6 90.6237 314.431 91.3734 314.431C92.7156 314.431 93.6345 314.697 94.1424 315.217C94.6502 315.737 94.9042 316.342 94.9042 317.019C94.9042 317.515 94.7711 317.986 94.5051 318.434C94.2391 318.881 93.7434 319.268 93.0179 319.606C93.6587 319.8 94.1424 320.03 94.4689 320.296C94.7954 320.562 95.0372 320.888 95.2065 321.263C95.3758 321.638 95.4604 322.049 95.4604 322.521C95.4604 323.548 95.0735 324.395 94.3117 325.072C93.5499 325.749 92.5584 326.076 91.3492 326.076C90.9985 326.076 90.6237 326.051 90.2004 326.003C89.7772 325.955 89.2815 325.822 88.689 325.568Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M101.386 325.773V322.701H96.7061V321.601L101.386 314.781H102.704V321.601H104.735V322.701H102.704V325.773H101.386ZM101.386 321.589V316.764L98.1087 321.589H101.386Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M88.689 346.123V344.733C89.7651 345.277 90.7083 345.555 91.5064 345.555C92.2319 345.555 92.8365 345.337 93.308 344.89C93.7796 344.443 94.0215 343.886 94.0215 343.185C94.0215 342.484 93.7554 341.915 93.2355 341.48C92.7155 341.045 91.8207 340.827 90.5753 340.827H89.8498V339.727H90.8655C91.7845 339.727 92.4495 339.521 92.8607 339.11C93.2718 338.699 93.4773 338.24 93.4773 337.732C93.4773 337.272 93.3081 336.885 92.9695 336.571C92.6309 336.256 92.1231 336.099 91.4217 336.099C90.6478 336.099 89.8015 336.317 88.9067 336.752V335.495C89.8015 335.156 90.6237 334.987 91.3734 334.987C92.7156 334.987 93.6345 335.253 94.1424 335.773C94.6502 336.293 94.9042 336.897 94.9042 337.574C94.9042 338.07 94.7711 338.542 94.5051 338.989C94.2391 339.437 93.7434 339.824 93.0179 340.162C93.6587 340.356 94.1424 340.585 94.4689 340.851C94.7954 341.117 95.0372 341.444 95.2065 341.819C95.3758 342.194 95.4604 342.605 95.4604 343.076C95.4604 344.104 95.0735 344.95 94.3117 345.628C93.5499 346.305 92.5584 346.631 91.3492 346.631C90.9985 346.631 90.6237 346.607 90.2004 346.559C89.7772 346.51 89.2815 346.377 88.689 346.123Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M97.6973 340.609V335.325H103.852V336.595H99.0153V339.291H99.2451C100.829 339.291 102.05 339.618 102.897 340.283C103.743 340.948 104.178 341.831 104.178 342.955C104.178 343.669 104.009 344.297 103.659 344.866C103.308 345.434 102.824 345.869 102.195 346.184C101.567 346.498 100.902 346.667 100.188 346.667C99.4748 346.667 98.5679 346.498 97.4675 346.147V344.708C97.8666 344.926 98.314 345.107 98.8098 345.24C99.3055 345.374 99.765 345.446 100.188 345.446C100.611 345.446 101.023 345.349 101.422 345.144C101.821 344.938 102.135 344.648 102.353 344.261C102.57 343.874 102.691 343.475 102.691 343.064C102.691 342.375 102.389 341.806 101.784 341.323C101.18 340.839 100.104 340.609 98.5558 340.609H97.6973Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M88.689 366.68V365.289C89.7651 365.834 90.7083 366.112 91.5064 366.112C92.2319 366.112 92.8365 365.894 93.308 365.447C93.7796 364.999 94.0215 364.443 94.0215 363.742C94.0215 363.04 93.7554 362.472 93.2355 362.037C92.7155 361.601 91.8207 361.384 90.5753 361.384H89.8498V360.283H90.8655C91.7845 360.283 92.4495 360.078 92.8607 359.667C93.2718 359.256 93.4773 358.796 93.4773 358.288C93.4773 357.829 93.3081 357.442 92.9695 357.128C92.6309 356.813 92.1231 356.656 91.4217 356.656C90.6478 356.656 89.8015 356.874 88.9067 357.309V356.051C89.8015 355.713 90.6237 355.543 91.3734 355.543C92.7156 355.543 93.6345 355.809 94.1424 356.329C94.6502 356.849 94.9042 357.454 94.9042 358.131C94.9042 358.627 94.7711 359.098 94.5051 359.546C94.2391 359.993 93.7434 360.38 93.0179 360.719C93.6587 360.912 94.1424 361.142 94.4689 361.408C94.7954 361.674 95.0372 362 95.2065 362.375C95.3758 362.75 95.4604 363.161 95.4604 363.633C95.4604 364.661 95.0735 365.507 94.3117 366.184C93.5499 366.861 92.5584 367.188 91.3492 367.188C90.9985 367.188 90.6237 367.164 90.2004 367.115C89.7772 367.067 89.2815 366.934 88.689 366.68Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M98.4348 361.722C98.7734 361.214 99.1967 360.803 99.7045 360.489C100.212 360.174 100.757 360.005 101.361 360.005C101.929 360.005 102.474 360.15 102.981 360.428C103.489 360.706 103.888 361.093 104.154 361.589C104.42 362.085 104.553 362.665 104.553 363.33C104.553 364.37 104.215 365.277 103.55 366.051C102.885 366.825 102.002 367.212 100.914 367.212C99.632 367.212 98.6646 366.68 98.0359 365.604C97.4071 364.527 97.0806 363.161 97.0806 361.504C97.0806 359.667 97.4796 358.228 98.2897 357.163C99.0999 356.099 100.188 355.567 101.567 355.567C102.304 355.567 103.03 355.676 103.731 355.894V357.224C102.945 356.849 102.208 356.668 101.518 356.668C100.539 356.668 99.7771 357.115 99.2329 358.022C98.6888 358.929 98.4228 360.065 98.4228 361.456V361.722H98.4348ZM101.023 366.111C101.373 366.111 101.736 366.003 102.087 365.797C102.437 365.591 102.727 365.265 102.933 364.83C103.139 364.394 103.235 363.923 103.235 363.403C103.235 362.738 103.066 362.182 102.715 361.746C102.365 361.311 101.869 361.105 101.228 361.105C100.563 361.105 100.019 361.359 99.5836 361.855C99.1483 362.351 98.9428 362.955 98.9428 363.669C98.9428 364.382 99.1483 364.975 99.5715 365.434C99.9947 365.894 100.478 366.111 101.023 366.111Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M88.689 387.235V385.845C89.7651 386.389 90.7083 386.667 91.5064 386.667C92.2319 386.667 92.8365 386.449 93.308 386.002C93.7796 385.554 94.0215 384.998 94.0215 384.297C94.0215 383.596 93.7554 383.027 93.2355 382.592C92.7155 382.157 91.8207 381.939 90.5753 381.939H89.8498V380.839H90.8655C91.7845 380.839 92.4495 380.633 92.8607 380.222C93.2718 379.811 93.4773 379.351 93.4773 378.843C93.4773 378.384 93.3081 377.997 92.9695 377.683C92.6309 377.368 92.1231 377.211 91.4217 377.211C90.6478 377.211 89.8015 377.429 88.9067 377.864V376.606C89.8015 376.268 90.6237 376.099 91.3734 376.099C92.7156 376.099 93.6345 376.365 94.1424 376.885C94.6502 377.405 94.9042 378.009 94.9042 378.686C94.9042 379.182 94.7711 379.654 94.5051 380.101C94.2391 380.548 93.7434 380.935 93.0179 381.274C93.6587 381.467 94.1424 381.697 94.4689 381.963C94.7954 382.229 95.0372 382.556 95.2065 382.93C95.3758 383.305 95.4604 383.716 95.4604 384.188C95.4604 385.216 95.0735 386.062 94.3117 386.739C93.5499 387.417 92.5584 387.743 91.3492 387.743C90.9985 387.743 90.6237 387.719 90.2004 387.671C89.7772 387.622 89.2815 387.489 88.689 387.235Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M98.6286 387.441V386.462C98.6286 385.688 98.7132 385.047 98.8946 384.515C99.076 383.983 99.3783 383.402 99.8136 382.761C100.249 382.121 100.6 381.625 100.866 381.274L102.014 379.751L102.425 379.218C102.74 378.795 103.006 378.312 103.236 377.755H97.5282V376.425H104.505V377.308C104.505 377.659 104.433 377.985 104.3 378.275C104.167 378.566 103.743 379.206 103.03 380.186C102.861 380.416 102.691 380.645 102.534 380.887L101.797 381.915C101.325 382.58 100.974 383.112 100.745 383.511C100.515 383.91 100.346 384.321 100.237 384.757C100.116 385.192 100.068 385.748 100.068 386.449V387.429H98.6286V387.441Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M88.689 407.792V406.401C89.7651 406.945 90.7083 407.224 91.5064 407.224C92.2319 407.224 92.8365 407.006 93.308 406.558C93.7796 406.111 94.0215 405.555 94.0215 404.853C94.0215 404.152 93.7554 403.584 93.2355 403.149C92.7155 402.713 91.8207 402.496 90.5753 402.496H89.8498V401.395H90.8655C91.7845 401.395 92.4495 401.19 92.8607 400.779C93.2718 400.367 93.4773 399.908 93.4773 399.4C93.4773 398.941 93.3081 398.554 92.9695 398.239C92.6309 397.925 92.1231 397.768 91.4217 397.768C90.6478 397.768 89.8015 397.985 88.9067 398.421V397.163C89.8015 396.825 90.6237 396.655 91.3734 396.655C92.7156 396.655 93.6345 396.921 94.1424 397.441C94.6502 397.961 94.9042 398.566 94.9042 399.243C94.9042 399.739 94.7711 400.21 94.5051 400.658C94.2391 401.105 93.7434 401.492 93.0179 401.831C93.6587 402.024 94.1424 402.254 94.4689 402.52C94.7954 402.786 95.0372 403.112 95.2065 403.487C95.3758 403.862 95.4604 404.273 95.4604 404.745C95.4604 405.772 95.0735 406.619 94.3117 407.296C93.5499 407.973 92.5584 408.3 91.3492 408.3C90.9985 408.3 90.6237 408.276 90.2004 408.227C89.7772 408.179 89.2815 408.046 88.689 407.792Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M99.6206 402.06L99.3788 401.879C99.0402 401.637 98.7137 401.298 98.3872 400.839C98.0607 400.379 97.9036 399.871 97.9036 399.315C97.9036 398.578 98.1938 397.961 98.7621 397.441C99.3304 396.921 100.068 396.667 100.963 396.667C101.507 396.667 101.991 396.764 102.426 396.957C102.861 397.151 103.2 397.441 103.429 397.828C103.659 398.215 103.78 398.626 103.78 399.085C103.78 399.4 103.732 399.702 103.623 399.992C103.514 400.282 103.357 400.573 103.139 400.851C102.922 401.141 102.498 401.54 101.858 402.06L102.45 402.532C103.151 403.1 103.611 403.584 103.853 403.995C104.095 404.406 104.215 404.865 104.215 405.373C104.215 406.171 103.925 406.86 103.357 407.441C102.789 408.021 101.918 408.311 100.769 408.311C99.6085 408.311 98.75 408.033 98.1696 407.489C97.5892 406.945 97.311 406.268 97.311 405.458C97.311 404.273 98.0729 403.136 99.6206 402.06ZM100.612 402.761C99.3667 403.717 98.7379 404.623 98.7379 405.458C98.7379 405.954 98.9434 406.377 99.3546 406.715C99.7657 407.054 100.249 407.223 100.818 407.223C101.326 407.223 101.785 407.066 102.196 406.739C102.595 406.413 102.801 406.002 102.801 405.518C102.801 405.047 102.559 404.563 102.063 404.067C101.567 403.571 101.229 403.257 101.035 403.1L100.612 402.761ZM100.963 401.383C101.628 400.875 102.051 400.452 102.22 400.113C102.39 399.775 102.474 399.46 102.474 399.158C102.474 398.807 102.317 398.481 102.003 398.191C101.688 397.9 101.289 397.755 100.793 397.755C100.261 397.755 99.8624 397.912 99.5843 398.227C99.3062 398.541 99.1732 398.868 99.1732 399.206C99.1732 399.533 99.2941 399.847 99.5239 400.137C99.7536 400.428 100.128 400.754 100.636 401.117L100.963 401.383Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M88.689 428.348V426.957C89.7651 427.502 90.7083 427.78 91.5064 427.78C92.2319 427.78 92.8365 427.562 93.308 427.115C93.7796 426.667 94.0215 426.111 94.0215 425.41C94.0215 424.708 93.7554 424.14 93.2355 423.705C92.7155 423.269 91.8207 423.052 90.5753 423.052H89.8498V421.951H90.8655C91.7845 421.951 92.4495 421.746 92.8607 421.335C93.2718 420.924 93.4773 420.464 93.4773 419.956C93.4773 419.497 93.3081 419.11 92.9695 418.795C92.6309 418.481 92.1231 418.324 91.4217 418.324C90.6478 418.324 89.8015 418.541 88.9067 418.977V417.719C89.8015 417.381 90.6237 417.211 91.3734 417.211C92.7156 417.211 93.6345 417.477 94.1424 417.997C94.6502 418.517 94.9042 419.122 94.9042 419.799C94.9042 420.295 94.7711 420.766 94.5051 421.214C94.2391 421.661 93.7434 422.048 93.0179 422.387C93.6587 422.58 94.1424 422.81 94.4689 423.076C94.7954 423.342 95.0372 423.668 95.2065 424.043C95.3758 424.418 95.4604 424.829 95.4604 425.301C95.4604 426.329 95.0735 427.175 94.3117 427.852C93.5499 428.529 92.5584 428.856 91.3492 428.856C90.9985 428.856 90.6237 428.832 90.2004 428.783C89.7772 428.735 89.2815 428.602 88.689 428.348Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M102.994 422.713C102.655 423.221 102.232 423.632 101.724 423.947C101.216 424.261 100.672 424.43 100.067 424.43C99.4992 424.43 98.955 424.298 98.4472 424.019C97.9393 423.741 97.5403 423.354 97.2743 422.859C97.0083 422.363 96.8752 421.782 96.8752 421.117C96.8752 420.077 97.2138 419.171 97.8789 418.397C98.5439 417.623 99.4266 417.236 100.515 417.236C101.797 417.236 102.764 417.768 103.393 418.844C104.022 419.92 104.348 421.287 104.348 422.943C104.348 424.781 103.949 426.22 103.139 427.284C102.329 428.348 101.24 428.88 99.862 428.88C99.1244 428.88 98.3988 428.771 97.6975 428.542V427.212C98.4834 427.574 99.2211 427.768 99.9103 427.768C100.89 427.768 101.652 427.32 102.196 426.414C102.74 425.507 103.006 424.37 103.006 422.979V422.713H102.994ZM100.406 418.324C100.055 418.324 99.6926 418.433 99.3419 418.639C98.9913 418.844 98.7011 419.171 98.4956 419.606C98.29 420.041 98.1933 420.513 98.1933 421.033C98.1933 421.698 98.3626 422.242 98.7132 422.677C99.0639 423.112 99.5596 423.318 100.2 423.318C100.866 423.318 101.41 423.064 101.845 422.568C102.28 422.073 102.486 421.468 102.486 420.755C102.486 420.041 102.28 419.449 101.857 418.989C101.434 418.53 100.95 418.324 100.406 418.324Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M92.6795 449.109V446.038H88V444.937L92.6795 438.118H93.9975V444.937H96.0289V446.038H93.9975V449.109H92.6795ZM92.6795 444.925V440.101L89.4026 444.925H92.6795Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M100.72 437.779C101.978 437.779 102.921 438.299 103.586 439.351C104.251 440.403 104.566 441.818 104.566 443.596C104.566 445.385 104.239 446.8 103.586 447.852C102.933 448.904 101.978 449.424 100.72 449.424C99.475 449.424 98.5197 448.904 97.8668 447.852C97.2138 446.8 96.8752 445.385 96.8752 443.596C96.8752 441.818 97.2017 440.403 97.8668 439.351C98.5318 438.299 99.4629 437.779 100.72 437.779ZM98.5681 445.953L102.365 439.992C102.123 439.557 101.869 439.255 101.579 439.109C101.289 438.964 101.011 438.88 100.708 438.88C99.9224 438.88 99.3178 439.315 98.9067 440.198C98.4955 441.068 98.29 442.181 98.29 443.535C98.29 443.837 98.3021 444.176 98.3142 444.527C98.3504 444.877 98.423 445.349 98.5681 445.953ZM102.836 441.31L99.0639 447.308C99.2694 447.658 99.4992 447.912 99.7652 448.082C100.031 448.251 100.321 448.335 100.648 448.335C101.543 448.335 102.184 447.828 102.558 446.824C102.933 445.82 103.127 444.708 103.127 443.487C103.127 442.737 103.03 442.011 102.836 441.31Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M92.6795 469.666V466.594H88V465.494L92.6795 458.674H93.9975V465.494H96.0289V466.594H93.9975V469.666H92.6795ZM92.6795 465.482V460.657L89.4026 465.482H92.6795Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M100.394 468.565V460.089C99.995 460.403 99.608 460.669 99.2332 460.887C98.8583 461.105 98.3505 461.335 97.6975 461.564V460.379C98.7374 459.944 99.6322 459.376 100.394 458.674H101.712V468.578H104.36V469.678H97.7096V468.578H100.394V468.565Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M92.6795 490.221V487.15H88V486.05L92.6795 479.23H93.9975V486.05H96.0289V487.15H93.9975V490.221H92.6795ZM92.6795 486.038V481.213L89.4026 486.038H92.6795Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M104.07 490.221H97.4197V489.012C97.4197 488.698 97.4801 488.371 97.6131 488.008C97.7461 487.646 97.988 487.247 98.3387 486.811C98.6893 486.376 99.0763 485.941 99.4753 485.53L100.225 484.768C100.37 484.611 100.709 484.248 101.217 483.68C101.724 483.111 102.063 482.676 102.22 482.374C102.377 482.071 102.462 481.769 102.462 481.479C102.462 481.007 102.269 480.645 101.894 480.379C101.519 480.125 101.096 479.992 100.624 479.992C100.358 479.992 100.056 480.028 99.7172 480.088C99.3907 480.149 99.0883 480.221 98.8465 480.306C98.5926 480.391 98.1935 480.56 97.6252 480.814V479.641C98.2177 479.363 98.8224 479.157 99.4149 479.061C100.007 478.964 100.503 478.903 100.89 478.903C101.458 478.903 101.99 479 102.462 479.181C102.934 479.363 103.296 479.653 103.526 480.052C103.756 480.451 103.877 480.862 103.877 481.31C103.877 481.805 103.732 482.313 103.429 482.833C103.127 483.353 102.559 484.018 101.736 484.84L100.926 485.638L100.249 486.304C99.8138 486.739 99.4753 487.162 99.2092 487.561C98.9432 487.972 98.7981 488.456 98.774 489.012H104.058V490.221H104.07Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M92.6795 510.778V507.706H88V506.606L92.6795 499.786H93.9975V506.606H96.0289V507.706H93.9975V510.778H92.6795ZM92.6795 506.594V501.769L89.4026 506.594H92.6795Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M97.3955 510.572V509.182C98.4717 509.726 99.4149 510.004 100.213 510.004C100.938 510.004 101.543 509.786 102.015 509.339C102.486 508.891 102.728 508.335 102.728 507.634C102.728 506.932 102.462 506.364 101.942 505.929C101.422 505.494 100.527 505.276 99.2818 505.276H98.5563V504.176H99.572C100.491 504.176 101.156 503.97 101.567 503.559C101.978 503.148 102.184 502.688 102.184 502.18C102.184 501.721 102.015 501.334 101.676 501.02C101.337 500.705 100.83 500.548 100.128 500.548C99.3544 500.548 98.5079 500.766 97.6132 501.201V499.943C98.5079 499.605 99.3302 499.436 100.08 499.436C101.422 499.436 102.341 499.702 102.849 500.221C103.357 500.741 103.611 501.346 103.611 502.023C103.611 502.519 103.478 502.991 103.212 503.438C102.946 503.885 102.45 504.272 101.724 504.611C102.365 504.804 102.849 505.034 103.175 505.3C103.502 505.566 103.744 505.893 103.913 506.267C104.082 506.642 104.167 507.053 104.167 507.525C104.167 508.553 103.78 509.399 103.018 510.076C102.256 510.753 101.265 511.08 100.056 511.08C99.7051 511.08 99.3302 511.056 98.907 511.007C98.4838 510.959 97.988 510.826 97.3955 510.572Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M92.6795 531.334V528.263H88V527.163L92.6795 520.343H93.9975V527.163H96.0289V528.263H93.9975V531.334H92.6795ZM92.6795 527.15V522.326L89.4026 527.15H92.6795Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M101.386 531.334V528.263H96.7061V527.163L101.386 520.343H102.704V527.163H104.735V528.263H102.704V531.334H101.386ZM101.386 527.15V522.326L98.1087 527.15H101.386Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M92.6795 551.889V548.818H88V547.718L92.6795 540.898H93.9975V547.718H96.0289V548.818H93.9975V551.889H92.6795ZM92.6795 547.706V542.881L89.4026 547.706H92.6795Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M97.6973 546.17V540.886H103.852V542.155H99.0153V544.852H99.2451C100.829 544.852 102.05 545.178 102.897 545.843C103.743 546.508 104.178 547.391 104.178 548.516C104.178 549.229 104.009 549.858 103.659 550.426C103.308 550.995 102.824 551.43 102.195 551.744C101.567 552.059 100.902 552.228 100.188 552.228C99.4748 552.228 98.5679 552.059 97.4675 551.708V550.269C97.8666 550.487 98.314 550.668 98.8098 550.801C99.3055 550.934 99.765 551.007 100.188 551.007C100.611 551.007 101.023 550.91 101.422 550.704C101.821 550.499 102.135 550.209 102.353 549.822C102.57 549.435 102.691 549.036 102.691 548.625C102.691 547.935 102.389 547.367 101.784 546.883C101.18 546.412 100.104 546.17 98.5558 546.17H97.6973Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M92.6795 572.446V569.375H88V568.274L92.6795 561.455H93.9975V568.274H96.0289V569.375H93.9975V572.446H92.6795ZM92.6795 568.262V563.438L89.4026 568.262H92.6795Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M98.4348 567.283C98.7734 566.775 99.1967 566.364 99.7045 566.05C100.212 565.735 100.757 565.566 101.361 565.566C101.929 565.566 102.474 565.711 102.981 565.989C103.489 566.267 103.888 566.654 104.154 567.15C104.42 567.646 104.553 568.226 104.553 568.891C104.553 569.931 104.215 570.838 103.55 571.612C102.885 572.386 102.002 572.773 100.914 572.773C99.632 572.773 98.6646 572.241 98.0359 571.165C97.4071 570.089 97.0806 568.722 97.0806 567.066C97.0806 565.228 97.4796 563.789 98.2897 562.725C99.0999 561.66 100.188 561.128 101.567 561.128C102.304 561.128 103.03 561.237 103.731 561.455V562.785C102.945 562.41 102.208 562.229 101.518 562.229C100.539 562.229 99.7771 562.676 99.2329 563.583C98.6888 564.49 98.4228 565.627 98.4228 567.017V567.283H98.4348ZM101.023 571.673C101.373 571.673 101.736 571.564 102.087 571.358C102.437 571.153 102.727 570.826 102.933 570.391C103.139 569.955 103.235 569.484 103.235 568.964C103.235 568.299 103.066 567.743 102.715 567.307C102.365 566.872 101.869 566.666 101.228 566.666C100.563 566.666 100.019 566.92 99.5836 567.416C99.1483 567.912 98.9428 568.517 98.9428 569.23C98.9428 569.943 99.1483 570.536 99.5715 570.995C99.9947 571.455 100.478 571.673 101.023 571.673Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M92.6795 593.002V589.93H88V588.83L92.6795 582.01H93.9975V588.83H96.0289V589.93H93.9975V593.002H92.6795ZM92.6795 588.818V583.993L89.4026 588.818H92.6795Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M98.6286 593.002V592.023C98.6286 591.249 98.7132 590.608 98.8946 590.076C99.076 589.544 99.3783 588.963 99.8136 588.322C100.249 587.682 100.6 587.186 100.866 586.835L102.014 585.312L102.425 584.78C102.74 584.356 103.006 583.873 103.236 583.316H97.5282V581.986H104.505V582.869C104.505 583.22 104.433 583.546 104.3 583.836C104.167 584.127 103.743 584.767 103.03 585.747C102.861 585.977 102.691 586.206 102.534 586.448L101.797 587.476C101.325 588.141 100.974 588.673 100.745 589.072C100.515 589.471 100.346 589.882 100.237 590.318C100.128 590.753 100.068 591.309 100.068 592.01V593.002H98.6286Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M92.6795 613.558V610.487H88V609.387L92.6795 602.567H93.9975V609.387H96.0289V610.487H93.9975V613.558H92.6795ZM92.6795 609.375V604.55L89.4026 609.375H92.6795Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M99.6206 607.621L99.3788 607.439C99.0402 607.197 98.7137 606.859 98.3872 606.399C98.0607 605.94 97.9036 605.432 97.9036 604.876C97.9036 604.138 98.1938 603.521 98.7621 603.001C99.3304 602.481 100.068 602.228 100.963 602.228C101.507 602.228 101.991 602.324 102.426 602.518C102.861 602.711 103.2 603.001 103.429 603.388C103.659 603.775 103.78 604.186 103.78 604.646C103.78 604.96 103.732 605.263 103.623 605.553C103.514 605.843 103.357 606.133 103.139 606.411C102.922 606.702 102.498 607.101 101.858 607.621L102.45 608.092C103.151 608.66 103.611 609.144 103.853 609.555C104.095 609.966 104.215 610.426 104.215 610.934C104.215 611.732 103.925 612.421 103.357 613.001C102.789 613.582 101.918 613.872 100.769 613.872C99.6085 613.872 98.75 613.594 98.1696 613.05C97.5892 612.506 97.311 611.828 97.311 611.018C97.311 609.833 98.0729 608.697 99.6206 607.621ZM100.612 608.322C99.3667 609.277 98.7379 610.184 98.7379 611.018C98.7379 611.514 98.9434 611.937 99.3546 612.276C99.7657 612.614 100.249 612.784 100.818 612.784C101.326 612.784 101.785 612.627 102.196 612.3C102.595 611.974 102.801 611.562 102.801 611.079C102.801 610.607 102.559 610.124 102.063 609.628C101.567 609.132 101.229 608.818 101.035 608.66L100.612 608.322ZM100.963 606.943C101.628 606.436 102.051 606.012 102.22 605.674C102.39 605.335 102.474 605.021 102.474 604.719C102.474 604.368 102.317 604.041 102.003 603.751C101.688 603.461 101.289 603.316 100.793 603.316C100.261 603.316 99.8624 603.473 99.5843 603.787C99.3062 604.102 99.1732 604.428 99.1732 604.767C99.1732 605.093 99.2941 605.408 99.5239 605.698C99.7536 605.988 100.128 606.315 100.636 606.677L100.963 606.943Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M92.6795 634.115V631.043H88V629.943L92.6795 623.123H93.9975V629.943H96.0289V631.043H93.9975V634.115H92.6795ZM92.6795 629.931V625.106L89.4026 629.931H92.6795Z",
        fill: "#6C9DBD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M102.994 628.274C102.655 628.782 102.232 629.193 101.724 629.507C101.216 629.822 100.672 629.991 100.067 629.991C99.4992 629.991 98.955 629.858 98.4472 629.58C97.9393 629.302 97.5403 628.915 97.2743 628.419C97.0083 627.923 96.8752 627.343 96.8752 626.678C96.8752 625.638 97.2138 624.731 97.8789 623.957C98.5439 623.183 99.4266 622.796 100.515 622.796C101.797 622.796 102.764 623.328 103.393 624.405C104.022 625.481 104.348 626.847 104.348 628.504C104.348 630.342 103.949 631.781 103.139 632.845C102.329 633.909 101.24 634.441 99.862 634.441C99.1244 634.441 98.3988 634.332 97.6975 634.102V632.772C98.4834 633.135 99.2211 633.328 99.9103 633.328C100.89 633.328 101.652 632.881 102.196 631.974C102.74 631.067 103.006 629.931 103.006 628.54V628.274H102.994ZM100.406 623.885C100.055 623.885 99.6926 623.994 99.3419 624.199C98.9913 624.405 98.7011 624.731 98.4956 625.166C98.29 625.602 98.1933 626.073 98.1933 626.593C98.1933 627.258 98.3626 627.802 98.7132 628.238C99.0639 628.673 99.5596 628.879 100.2 628.879C100.866 628.879 101.41 628.625 101.845 628.129C102.28 627.633 102.486 627.029 102.486 626.315C102.486 625.602 102.28 625.009 101.857 624.55C101.434 624.09 100.95 623.885 100.406 623.885Z",
        fill: "#6C9DBD"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter0_ddd_4042_105232",
        x: "4",
        y: "1.98067",
        width: "626",
        height: "698.019",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "5.39326"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "6.74157"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.156863 0 0 0 0 0.0941176 0 0 0 0 0.509804 0 0 0 0.04 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4042_105232"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "-13.48"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "24.2697"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.156863 0 0 0 0 0.0941176 0 0 0 0 0.509804 0 0 0 0.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4042_105232",
        result: "effect2_dropShadow_4042_105232"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "30"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.156863 0 0 0 0 0.0941176 0 0 0 0 0.509804 0 0 0 0.56 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect2_dropShadow_4042_105232",
        result: "effect3_dropShadow_4042_105232"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect3_dropShadow_4042_105232",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter1_d_4042_105232",
        x: "169.759",
        y: "182",
        width: "303.027",
        height: "303.027",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "3.2412"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "1.6206"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4042_105232"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_4042_105232",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("pattern", {
        id: "pattern0",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("use", {
        xlinkHref: "#image0_4042_105232",
        transform: "translate(-0.268991 -0.151114) scale(0.00148504)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter2_dddd_4042_105232",
        x: "63.9208",
        y: "400.705",
        width: "506.421",
        height: "260.554",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "2.06566"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "1.9673"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0592299 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4042_105232"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "5.7113"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "5.43933"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.085 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4042_105232",
        result: "effect2_dropShadow_4042_105232"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "13.7506"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "13.0958"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11077 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect2_dropShadow_4042_105232",
        result: "effect3_dropShadow_4042_105232"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "45.6117"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "43.4397"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect3_dropShadow_4042_105232",
        result: "effect4_dropShadow_4042_105232"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect4_dropShadow_4042_105232",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_4042_105232"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "570",
        height: "640",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip1_4042_105232"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M64 114C64 86.3858 86.3858 64 114 64H570V640H64V114Z",
        fill: "white"
    }))));
};

});

parcelRegister("kGVGf", function(module, exports) {

$parcel$export(module.exports, "LoomVideoPlayer", () => $635c0c372ce0af95$export$7b1ca24dd1baf80e);
/* video-player.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $2SD19 = parcelRequire("2SD19");
const $635c0c372ce0af95$export$7b1ca24dd1baf80e = ({ src: src, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        alignItems: "center",
        gap: "space.200",
        justifyContent: "center",
        xcss: (0, $1ZAYh.xcss)({
            position: 'relative'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($635c0c372ce0af95$var$Video, {
        loop: true,
        muted: true,
        playsInline: true,
        autoPlay: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("source", {
        type: type,
        src: src
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($635c0c372ce0af95$var$VideoControls, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($635c0c372ce0af95$var$VideoPlayerButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "25",
        height: "26",
        viewBox: "0 0 25 26",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "0.197998",
        y: "0.97168",
        width: "24.7986",
        height: "24.7986",
        rx: "3.09982",
        fill: "#FF613D"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2SD19.Countdown), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($635c0c372ce0af95$var$VideoPlayerButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        "aria-label": "Pause recording in animation",
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "20",
        height: "23",
        viewBox: "0 0 20 23",
        fill: "none",
        color: "var(--ds-icon, #44546F)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.9654 0.521484C14.0929 0.521484 12.5749 2.03943 12.5749 3.91192V18.8298C12.5749 20.7023 14.0929 22.2203 15.9654 22.2203C17.8378 22.2203 19.3558 20.7023 19.3558 18.8298V3.91192C19.3558 2.03943 17.8378 0.521484 15.9654 0.521484ZM3.75982 0.521491C1.88733 0.521491 0.369385 2.03944 0.369385 3.91192V18.8298C0.369385 20.7023 1.88733 22.2203 3.75982 22.2203C5.6323 22.2203 7.15025 20.7023 7.15025 18.8298V3.91192C7.15025 2.03944 5.6323 0.521491 3.75982 0.521491Z",
        fill: "currentColor"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($635c0c372ce0af95$var$VideoPlayerButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        "aria-label": "Cancel recording in animation",
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "26",
        height: "29",
        viewBox: "0 0 26 29",
        fill: "none",
        color: "var(--ds-icon, #44546F)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.266113 6.93172C0.266113 6.07573 0.960033 5.38181 1.81603 5.38181H24.1348C24.9908 5.38181 25.6847 6.07573 25.6847 6.93172C25.6847 7.78771 24.9908 8.48163 24.1348 8.48163H1.81603C0.960033 8.48163 0.266113 7.78771 0.266113 6.93172Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4951 3.5217C10.2485 3.5217 10.0119 3.61968 9.83754 3.79408C9.66314 3.96847 9.56516 4.20501 9.56516 4.45165V5.3816H16.3848V4.45165C16.3848 4.20501 16.2868 3.96847 16.1124 3.79408C15.938 3.61968 15.7015 3.5217 15.4548 3.5217H10.4951ZM19.4846 5.3816V4.45165C19.4846 3.38288 19.06 2.3579 18.3043 1.60217C17.5486 0.846439 16.5236 0.421875 15.4548 0.421875H10.4951C9.42635 0.421875 8.40136 0.846439 7.64563 1.60217C6.8899 2.3579 6.46534 3.38288 6.46534 4.45165V5.3816H4.29546C3.43947 5.3816 2.74555 6.07551 2.74555 6.93151V24.2905C2.74555 25.3593 3.17011 26.3843 3.92584 27.14C4.68157 27.8957 5.70656 28.3203 6.77532 28.3203H19.1746C20.2434 28.3203 21.2684 27.8957 22.0241 27.14C22.7798 26.3843 23.2044 25.3593 23.2044 24.2905V6.93151C23.2044 6.07551 22.5105 5.3816 21.6545 5.3816H19.4846ZM5.84537 8.48142V24.2905C5.84537 24.5372 5.94335 24.7737 6.11775 24.9481C6.29215 25.1225 6.52868 25.2205 6.77532 25.2205H19.1746C19.4213 25.2205 19.6578 25.1225 19.8322 24.9481C20.0066 24.7737 20.1046 24.5372 20.1046 24.2905V8.48142H5.84537Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4951 11.5815C11.3511 11.5815 12.045 12.2754 12.045 13.1314V20.5709C12.045 21.4269 11.3511 22.1209 10.4951 22.1209C9.63912 22.1209 8.9452 21.4269 8.9452 20.5709V13.1314C8.9452 12.2754 9.63912 11.5815 10.4951 11.5815Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.455 11.5815C16.311 11.5815 17.005 12.2754 17.005 13.1314V20.5709C17.005 21.4269 16.311 22.1209 15.455 22.1209C14.599 22.1209 13.9051 21.4269 13.9051 20.5709V13.1314C13.9051 12.2754 14.599 11.5815 15.455 11.5815Z",
        fill: "currentColor"
    }))))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $635c0c372ce0af95$var$Video = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "video", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbkpet _2rko1ssb",
            __cmplp.className
        ])
    });
});
const $635c0c372ce0af95$var$VideoControls = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_zulpu2gc _kqswstnw _1bsbnklw _4t3i1n2x _vchhusvi _bfhkvuon _1yt467l7 _2rkojlcs _16qs1kp1 _1e0c1txw _4cvr1h6o _1bah1b1v _94n5mt2g",
            __cmplp.className
        ])
    });
});
const $635c0c372ce0af95$var$VideoPlayerButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i17uw _jq8g1osq _17521osq _1hbsidpf _1u71idpf _y2qtidpf _fl8bidpf _1gflidpf _yhjmidpf _1gqnidpf _11lvidpf _szfsglyw _stfgglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2SD19", function(module, exports) {

$parcel$export(module.exports, "Countdown", () => $cee1774e6953e8c6$export$53819c0e58f98d49);
/* countdown.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $cee1774e6953e8c6$var$SEPARATOR = ':';
const $cee1774e6953e8c6$var$SECONDS_COUNTDOWN = 60;
const $cee1774e6953e8c6$export$53819c0e58f98d49 = ()=>{
    const [startTime, setStartTime] = (0, $eUqFw.useState)(Date.now());
    const [count, setCount] = (0, $eUqFw.useState)(0);
    (0, $eUqFw.useEffect)(()=>{
        function update() {
            const elapsed = Math.floor((Date.now() - startTime) / 1000);
            if (elapsed >= $cee1774e6953e8c6$var$SECONDS_COUNTDOWN) {
                setStartTime(Date.now());
                setCount(0);
            } else setCount(elapsed % $cee1774e6953e8c6$var$SECONDS_COUNTDOWN);
        }
        const interval = setInterval(update, 100);
        return ()=>clearInterval(interval);
    }, [
        setCount,
        setStartTime,
        startTime
    ]);
    const minutes = Math.floor(count / $cee1774e6953e8c6$var$SECONDS_COUNTDOWN);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cee1774e6953e8c6$var$VideoPlayerText, null, minutes, $cee1774e6953e8c6$var$SEPARATOR, count.toFixed(0).padStart(2, '0'));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $cee1774e6953e8c6$var$VideoPlayerText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1x821ts4 _1wyb1k92 _k48pbfng _u5f3xy5q _ca0qu2gc _n3tdu2gc _ect41ag4 _vwz41tcg _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1s7z11i9",
            __cmplp.className
        ])
    });
});

});



parcelRegister("dOn9L", function(module, exports) {

$parcel$export(module.exports, "ProductFeatureList", () => $a21e3eeb54becbde$export$ab38811c469ae95f);
/* product-feature-list.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kMHOY = parcelRequire("kMHOY");

var $d3vNK = parcelRequire("d3vNK");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $EVCNC = parcelRequire("EVCNC");

var $1wgt8 = parcelRequire("1wgt8");
const $a21e3eeb54becbde$export$ab38811c469ae95f = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a21e3eeb54becbde$var$UnorderedList, null, $a21e3eeb54becbde$var$items.map(({ getIcon: getIcon, message: message }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a21e3eeb54becbde$var$ListItem, {
            key: index
        }, getIcon(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: (0, $1ZAYh.xcss)({
                marginLeft: 'space.100'
            })
        }, formatMessage(message)))));
};
const $a21e3eeb54becbde$var$items = [
    {
        getIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a21e3eeb54becbde$var$FixedSizeSvg, {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                color: (0, $EVCNC.STYLES).modal.colors.purple
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 20C10.9494 20 9.90914 19.7931 8.93853 19.391C7.96793 18.989 7.08601 18.3997 6.34315 17.6569C5.60028 16.914 5.011 16.0321 4.60896 15.0615C4.20693 14.0909 4 13.0506 4 12C4 10.9494 4.20693 9.90914 4.60896 8.93853C5.011 7.96793 5.60028 7.08601 6.34315 6.34315C7.08601 5.60028 7.96793 5.011 8.93853 4.60896C9.90914 4.20693 10.9494 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1571 7.84344 20 9.87827 20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM12 18.2857C13.6671 18.2857 15.2659 17.6235 16.4447 16.4447C17.6235 15.2659 18.2857 13.6671 18.2857 12C18.2857 10.3329 17.6235 8.73413 16.4447 7.55533C15.2659 6.37653 13.6671 5.71429 12 5.71429C10.3329 5.71429 8.73413 6.37653 7.55533 7.55533C6.37653 8.73413 5.71429 10.3329 5.71429 12C5.71429 13.6671 6.37653 15.2659 7.55533 16.4447C8.73413 17.6235 10.3329 18.2857 12 18.2857ZM12 11.4286C12.3031 11.4286 12.5938 11.549 12.8081 11.7633C13.0224 11.9776 13.1429 12.2683 13.1429 12.5714V14.8571C13.1429 15.1602 13.0224 15.4509 12.8081 15.6653C12.5938 15.8796 12.3031 16 12 16C11.6969 16 11.4062 15.8796 11.1919 15.6653C10.9776 15.4509 10.8571 15.1602 10.8571 14.8571V12.5714C10.8571 12.2683 10.9776 11.9776 11.1919 11.7633C11.4062 11.549 11.6969 11.4286 12 11.4286ZM12 8C12.3031 8 12.5938 8.12041 12.8081 8.33474C13.0224 8.54906 13.1429 8.83975 13.1429 9.14286C13.1429 9.44596 13.0224 9.73665 12.8081 9.95098C12.5938 10.1653 12.3031 10.2857 12 10.2857C11.6969 10.2857 11.4062 10.1653 11.1919 9.95098C10.9776 9.73665 10.8571 9.44596 10.8571 9.14286C10.8571 8.83975 10.9776 8.54906 11.1919 8.33474C11.4062 8.12041 11.6969 8 12 8Z",
                fill: "currentColor"
            })),
        message: (0, $1wgt8.default).contextToAnythingFeatureNoTranslate
    },
    {
        getIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
                size: "medium",
                label: "Comment bubble icon",
                primaryColor: (0, $EVCNC.STYLES).modal.colors.purple
            }),
        message: (0, $1wgt8.default).updateYourTeamNoTranslate
    },
    {
        getIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
                size: "medium",
                label: "Calendar icon",
                primaryColor: (0, $EVCNC.STYLES).modal.colors.purple
            }),
        message: (0, $1wgt8.default).freeTrialNoTranslate
    }
];
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $a21e3eeb54becbde$var$ListItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19pkv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $a21e3eeb54becbde$var$FixedSizeSvg = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $a21e3eeb54becbde$var$UnorderedList = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkqfva",
            __cmplp.className
        ])
    });
});

});



parcelRegister("8Ay13", function(module, exports) {

$parcel$export(module.exports, "CoverImage", () => $7d5195ed671b9a2b$export$a65e282337ff0f53);
/* cover-image.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $7d5195ed671b9a2b$export$a65e282337ff0f53 = ({ altText: altText })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "262",
        height: "147",
        fill: "none",
        role: "img",
        "aria-label": altText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#2E1B53",
        d: "M0 4a4 4 0 0 1 4-4h254a4 4 0 0 1 4 4v143H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "238",
        height: "40",
        x: "12",
        y: "14",
        fill: "#3C2E5E",
        rx: "8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#565ADD",
        fillRule: "evenodd",
        d: "M31 22h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H31a3 3 0 0 1-3-3V25a3 3 0 0 1 3-3m5.583 7.002-4.29 4.287a1 1 0 0 0 0 1.415l4.291 4.285a.998.998 0 0 0 1.705-.71c0-.264-.105-.518-.292-.706l-3.582-3.576 3.582-3.58a1.002 1.002 0 0 0-1.09-1.632 1 1 0 0 0-.324.217m5.41-.013a1 1 0 0 0 .002 1.413l3.59 3.587-3.59 3.588a1.001 1.001 0 0 0 1.414 1.415l4.298-4.296a1 1 0 0 0 0-1.415l-4.3-4.293a.994.994 0 0 0-1.414.001",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "73",
        height: "6",
        x: "60",
        y: "31",
        fill: "#2E1B53",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#2E1B53",
        fillRule: "evenodd",
        d: "M197 33c0 1.3-.8 2.4-2 2.8V37c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8v-6.4c-1.1-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8h2.2c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3m-11-6c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#2E1B53",
        d: "M215 36a2 2 0 1 0 0-4 2 2 0 0 0 0 4M222 36a2 2 0 1 0 0-4 2 2 0 0 0 0 4M229 36a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "222",
        height: "32",
        x: "28",
        y: "62",
        fill: "#E8F5E3",
        fillOpacity: ".3",
        rx: "8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#2E1B53",
        fillRule: "evenodd",
        d: "M57 77v-3.998a1 1 0 0 0-2 0V77h-3.998a1 1 0 1 0 0 2H55v3.998a1 1 0 1 0 2 0V79h3.998a1 1 0 0 0 0-2z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "131",
        height: "4",
        x: "76",
        y: "76",
        fill: "#2E1B53",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "222",
        height: "32",
        x: "28",
        y: "102",
        fill: "#3C2E5E",
        rx: "8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "56",
        cy: "118",
        r: "2",
        fill: "#2E1B53"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "131",
        height: "4",
        x: "76",
        y: "116",
        fill: "#2E1B53",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7d5195ed671b9a2b$var$Mask, {
        id: "c",
        width: "88",
        height: "88",
        x: "87",
        y: "18",
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "131",
        cy: "62",
        r: "44",
        fill: "#D9D9D9"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#c)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "url(#d)",
        d: "M87 18h88v88H87z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#e)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "100.857",
        height: "32",
        x: "80",
        y: "96",
        fill: "var(--ds-surface, #1D2125)",
        rx: "16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "102.857",
        height: "34",
        x: "79",
        y: "95",
        stroke: "#fff",
        strokeOpacity: ".4",
        strokeWidth: "2",
        rx: "17"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "14",
        height: "14",
        x: "91.5",
        y: "105",
        fill: "#FF613D",
        rx: "2.854"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".14",
        d: "M117 100h.857v24H117z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M134.045 105a2.19 2.19 0 0 0-2.188 2.188v9.624a2.188 2.188 0 1 0 4.375 0v-9.624a2.187 2.187 0 0 0-2.187-2.188m7.875 0a2.19 2.19 0 0 0-2.188 2.188v9.625a2.188 2.188 0 0 0 4.375 0v-9.625A2.187 2.187 0 0 0 141.92 105M157.024 108.2c0-.437.354-.792.791-.792h11.4a.792.792 0 1 1 0 1.584h-11.4a.79.79 0 0 1-.791-.792",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M162.248 106.458a.473.473 0 0 0-.475.475v.475h3.484v-.475a.477.477 0 0 0-.475-.475zm4.592.95v-.475a2.057 2.057 0 0 0-2.058-2.058h-2.534a2.06 2.06 0 0 0-2.058 2.058v.475h-1.108a.793.793 0 0 0-.792.792v8.867a2.057 2.057 0 0 0 2.058 2.058h6.334a2.057 2.057 0 0 0 2.058-2.058V108.2a.79.79 0 0 0-.792-.792zm-6.967 1.584v8.075a.48.48 0 0 0 .475.475h6.334a.475.475 0 0 0 .475-.475v-8.075z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M162.248 110.575c.438 0 .792.355.792.792v3.8a.791.791 0 0 1-1.583 0v-3.8c0-.437.354-.792.791-.792M164.782 110.575c.437 0 .792.355.792.792v3.8a.792.792 0 0 1-1.584 0v-3.8c0-.437.355-.792.792-.792",
        clipRule: "evenodd"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#fff",
        d: "M0 4a4 4 0 0 1 4-4h254a4 4 0 0 1 4 4v143H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#fff",
        d: "M28 22h24v24H28z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("pattern", {
        id: "d",
        width: "1",
        height: "1",
        patternContentUnits: "objectBoundingBox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("use", {
        xlinkHref: "#f",
        transform: "scale(.0052)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "e",
        width: "264.857",
        height: "196",
        x: "-2",
        y: "56",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "1.902"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "1.812"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0592299 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4218_109861"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "5.259"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "5.009"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.085 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        in2: "effect1_dropShadow_4218_109861",
        result: "effect2_dropShadow_4218_109861"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "12.662"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "12.059"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11077 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        in2: "effect2_dropShadow_4218_109861",
        result: "effect3_dropShadow_4218_109861"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "40"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        in2: "effect3_dropShadow_4218_109861",
        result: "effect4_dropShadow_4218_109861"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect4_dropShadow_4218_109861",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("image", {
        xlinkHref: "data:image/png;base64,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",
        id: "f",
        width: "192",
        height: "192"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $7d5195ed671b9a2b$var$Mask = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "mask", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_13aecgrr",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6PM2r", function(module, exports) {

$parcel$export(module.exports, "LoomRecordingButton", () => $10bdeea5a3b342ef$export$92e61376a19b9504);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $6bgkQ = parcelRequire("6bgkQ");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lqalZ = parcelRequire("lqalZ");

var $hficN = parcelRequire("hficN");

var $jMP2a = parcelRequire("jMP2a");

var $6vrw7 = parcelRequire("6vrw7");

var $aqpSx = parcelRequire("aqpSx");

var $EVCNC = parcelRequire("EVCNC");

var $3DBi6 = parcelRequire("3DBi6");

var $1wgt8 = parcelRequire("1wgt8");

var $fpelQ = parcelRequire("fpelQ");
const $10bdeea5a3b342ef$var$COPY_LINK_FLAG_ID = (0, $eo17r.toFlagId)('COPY_LINK_FLAG_ID');
const $10bdeea5a3b342ef$var$COPIED_FLAG_ID = (0, $eo17r.toFlagId)('COPIED_FLAG_ID');
const $10bdeea5a3b342ef$var$LoomRecordingButtonView = ({ shouldBeCompact: shouldBeCompact, onInsertLink: onInsertLink })=>{
    const buttonRef = (0, $eUqFw.useRef)(null);
    const runningSDKButtonRef = (0, $eUqFw.useRef)(null);
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const loomSdk = (0, $3DBi6.useLoomSDK)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onShowCopyLinkFlag = (0, $eUqFw.useCallback)((videoUrl)=>{
        showFlag({
            id: $10bdeea5a3b342ef$var$COPY_LINK_FLAG_ID,
            type: 'success',
            testId: 'issue-view-foundation.quick-add.loom-record-spike.quick-add-item-view.copy-link-flag',
            title: (0, $fpelQ.default).flagTitleNoTranslate,
            description: (0, $fpelQ.default).flagDescriptionNoTranslate,
            isAutoDismiss: true,
            actions: [
                {
                    content: (0, $fpelQ.default).flagCopyLinkNoTranslate,
                    onClick: ()=>{
                        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                            action: 'clicked',
                            actionSubject: 'button'
                        }), 'copyVideoLink');
                        navigator.clipboard.writeText(videoUrl).then(()=>{
                            showFlag({
                                id: $10bdeea5a3b342ef$var$COPIED_FLAG_ID,
                                type: 'success',
                                testId: 'issue-view-foundation.quick-add.loom-record-spike.quick-add-item-view.copied-flag',
                                title: (0, $fpelQ.default).flagCopiedNoTranslate,
                                isAutoDismiss: true
                            });
                        });
                    }
                }
            ]
        });
    }, [
        showFlag,
        createAnalyticsEvent
    ]);
    const handleClick = ()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), (0, $EVCNC.SUBJECT_IDS).loomRecordVideoButton);
    };
    const handleRecordingStartCallback = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'loomRecordingStart');
    }, [
        createAnalyticsEvent
    ]);
    const handleRecordingStartedCallback = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomRecording started');
    }, [
        createAnalyticsEvent
    ]);
    const handleRecordingCancelCallback = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'loomRecordingCancel');
    }, [
        createAnalyticsEvent
    ]);
    const handleRecordingCompleteCallback = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'loomRecordingComplete');
    }, [
        createAnalyticsEvent
    ]);
    const handleRecordingCompletedCallback = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomRecording completed');
    }, [
        createAnalyticsEvent
    ]);
    const handleRecordingUploadedCallback = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomRecording uploaded');
    }, [
        createAnalyticsEvent
    ]);
    const handleRecordingInsertClickCallback = (0, $eUqFw.useCallback)(async (video)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'insertVideoLink');
        onInsertLink(video.title, video.sharedUrl);
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomVideoLink inserted');
        onShowCopyLinkFlag(video.sharedUrl);
    }, [
        createAnalyticsEvent,
        onInsertLink,
        onShowCopyLinkFlag
    ]);
    const handleRecordingOpenOnLoomCallback = (0, $eUqFw.useCallback)(async (video)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'openOnLoom');
        window.open(video.sharedUrl, '_blank');
    }, [
        createAnalyticsEvent
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            if (runningSDKButtonRef.current && loomSdk.sdk) {
                // if we're actively recording, and the button gets unmounted, it means the user has navigated away from issue view and
                // we have to change the behaviour of the CTA to "Open on Loom" instead of "Insert link" since that is no longer possible
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomSDKButton unmountedWhileRecording');
                runningSDKButtonRef.current.off('insert-click', handleRecordingInsertClickCallback);
                runningSDKButtonRef.current.on('insert-click', handleRecordingOpenOnLoomCallback);
                loomSdk.sdk.updateConfig({
                    config: {
                        insertButtonText: 'Open on Loom'
                    }
                });
            }
        }, [
        createAnalyticsEvent,
        handleRecordingInsertClickCallback,
        handleRecordingOpenOnLoomCallback,
        loomSdk.sdk
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const button = buttonRef.current;
        if (!loomSdk.initializing && !loomSdk.supported) {
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'loomSDK unsupported', {
                error: loomSdk.unsupportedError
            });
            return;
        }
        if (!button || !loomSdk.sdk || loomSdk.initializing) return;
        const sdkButton = loomSdk.sdk.configureButton({
            element: button
        });
        sdkButton.on('start', handleRecordingStartCallback);
        sdkButton.on('recording-start', handleRecordingStartedCallback);
        sdkButton.on('cancel', handleRecordingCancelCallback);
        sdkButton.on('complete', handleRecordingCompleteCallback);
        sdkButton.on('recording-complete', handleRecordingCompletedCallback);
        sdkButton.on('upload-complete', handleRecordingUploadedCallback);
        sdkButton.on('insert-click', handleRecordingInsertClickCallback);
        sdkButton.on('lifecycle-update', (state)=>{
            // assign the sdkButtonRef only when we're actively recording
            if (state === 'active-recording') runningSDKButtonRef.current = sdkButton;
            else runningSDKButtonRef.current = null;
        });
        return ()=>{
            sdkButton.off('start', handleRecordingStartCallback);
            sdkButton.off('recording-start', handleRecordingStartedCallback);
            sdkButton.off('cancel', handleRecordingCancelCallback);
            sdkButton.off('complete', handleRecordingCompleteCallback);
            sdkButton.off('recording-complete', handleRecordingCompletedCallback);
            sdkButton.off('upload-complete', handleRecordingUploadedCallback);
            sdkButton.off('insert-click', handleRecordingInsertClickCallback);
        };
    }, [
        buttonRef,
        handleRecordingStartCallback,
        handleRecordingStartedCallback,
        handleRecordingCancelCallback,
        handleRecordingCompleteCallback,
        handleRecordingUploadedCallback,
        handleRecordingInsertClickCallback,
        handleRecordingCompletedCallback,
        loomSdk,
        createAnalyticsEvent
    ]);
    return loomSdk.supported && !loomSdk.initializing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aqpSx.default), {
        key: "loom-recording-button",
        id: "loom-recording-button",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6bgkQ.LoomIcon), {
            size: "small",
            label: ""
        }),
        onClick: handleClick,
        ref: buttonRef,
        label: formatMessage((0, $1wgt8.default).loomRecordVideoButtonLabel),
        compactMode: shouldBeCompact,
        testId: "issue-view-foundation.quick-add.loom-record-item-ad.loom-recording-button.quick-add-item-view"
    });
};
const $10bdeea5a3b342ef$export$92e61376a19b9504 = (0, $lqalZ.connect)(null, (dispatch)=>({
        onInsertLink: (title, url)=>dispatch((0, $hficN.createWebLinkRequest)((0, $6vrw7.toHref)(url), title, (0, $6vrw7.toHref)('')))
    }))($10bdeea5a3b342ef$var$LoomRecordingButtonView);

});
parcelRegister("3DBi6", function(module, exports) {

$parcel$export(module.exports, "useLoomSDK", () => $41402cd86de295f3$export$a116e43f716cde4d);

var $eUqFw = parcelRequire("eUqFw");

var $eBnX6 = parcelRequire("eBnX6");
const $41402cd86de295f3$export$a116e43f716cde4d = ()=>{
    const context = (0, $eUqFw.useContext)((0, $eBnX6.LoomSDKContext));
    if (context === undefined) throw new Error('useLoomSDK must be used within a LoomSDKProvider');
    return context;
};

});
parcelRegister("eBnX6", function(module, exports) {

$parcel$export(module.exports, "LoomSDKContext", () => $2dcada0bc0a7057b$export$42b6276bac782154);

var $eUqFw = parcelRequire("eUqFw");
const $2dcada0bc0a7057b$var$initContextValue = {
    sdk: null,
    initializing: true,
    supported: false
};
const $2dcada0bc0a7057b$export$42b6276bac782154 = /*#__PURE__*/ (0, $eUqFw.createContext)($2dcada0bc0a7057b$var$initContextValue);

});


parcelRegister("fpelQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eeba4d4879561e4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $0eeba4d4879561e4$var$messages = (0, $90IgZ.defineMessages)({
    flagCopyLinkNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-recording-button.flag-copy-link-no-translate",
        "defaultMessage": "Copy Link"
    },
    flagCopiedNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-recording-button.flag-copied-no-translate",
        "defaultMessage": "Link copied"
    },
    flagTitleNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-recording-button.flag-title-no-translate",
        "defaultMessage": "Your Loom video is ready!"
    },
    flagDescriptionNoTranslate: {
        "id": "issue-view-foundation.quick-add.loom-record-item-ad.loom-recording-button.flag-description-no-translate",
        "defaultMessage": "Copy the link to share it with your team."
    }
});
var $0eeba4d4879561e4$export$2e2bcd8739ae039 = $0eeba4d4879561e4$var$messages;

});


parcelRegister("wcB2r", function(module, exports) {

$parcel$export(module.exports, "persistAdPermanentlySuppressed", () => $cb794f31c12f1f23$export$1a66e46e748ed6d4);
$parcel$export(module.exports, "shouldShowAd", () => $cb794f31c12f1f23$export$31bec55ac8ae1e43);

var $aZaPn = parcelRequire("aZaPn");

var $EVCNC = parcelRequire("EVCNC");
const $cb794f31c12f1f23$var$localStorage = (0, $aZaPn.createLocalStorageProvider)((0, $EVCNC.STORAGE_KEY));
const $cb794f31c12f1f23$export$1a66e46e748ed6d4 = ()=>{
    $cb794f31c12f1f23$var$localStorage.set((0, $EVCNC.AD_SUPPRESSED), true);
};
const $cb794f31c12f1f23$export$31bec55ac8ae1e43 = ()=>!$cb794f31c12f1f23$var$localStorage.get((0, $EVCNC.AD_SUPPRESSED));

});

parcelRegister("izEYQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dlaMl');
        const value = parcelRequire('abTkJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dlaMl").then(()=>parcelRequire('abTkJ'));
}

});


parcelRegister("2sCaG", function(module, exports) {

$parcel$export(module.exports, "ScheduleChangeButton", () => $89e5086fe62f66ce$export$687305cc4d99d1b8);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $89e5086fe62f66ce$var$AsyncScheduleChangeButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("g0D8w")).then((exportedModule)=>exportedModule.ScheduleChangeButton), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view-foundation/src/quick-add/schedule-change-button/main.tsx"
});
const $89e5086fe62f66ce$export$687305cc4d99d1b8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-schedule-change-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($89e5086fe62f66ce$var$AsyncScheduleChangeButton, props));

});
parcelRegister("g0D8w", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fNrsI');
        const value = parcelRequire('fkZGv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fNrsI").then(()=>parcelRequire('fkZGv'));
}

});


parcelRegister("4CPxR", function(module, exports) {

$parcel$export(module.exports, "default", () => $13b3e6d0d799e82e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $jUThT = parcelRequire("jUThT");

var $jfQfF = parcelRequire("jfQfF");

var $bPZtE = parcelRequire("bPZtE");

var $6nIG2 = parcelRequire("6nIG2");

var $eyI8O = parcelRequire("eyI8O");

var $8tfNS = parcelRequire("8tfNS");

var $5KT10 = parcelRequire("5KT10");


var $d6f6c = parcelRequire("d6f6c");

var $putLD = parcelRequire("putLD");

var $f1lMr = parcelRequire("f1lMr");

var $20g0V = parcelRequire("20g0V");

var $dydjR = parcelRequire("dydjR");
const $13b3e6d0d799e82e$var$getItemList = (props)=>{
    const { formatMessage: formatMessage, canCreateAttachment: canCreateAttachment, shouldShowCreateSubtaskButton: shouldShowCreateSubtaskButton, shouldShowIssueInEpicButton: shouldShowIssueInEpicButton, canCreateIssueLink: canCreateIssueLink, onAddAttachmentClick: onAddAttachmentClick, onCreateSubtaskClick: onCreateSubtaskClick, onCreateIssueInEpicClick: onCreateIssueInEpicClick, onChildCreateClick: onChildCreateClick, supportsChildCreation: supportsChildCreation, isServiceDesk: isServiceDesk, canLinkConfluencePage: canLinkConfluencePage, onLinkConfluencePageClick: onLinkConfluencePageClick, incidentManagement: incidentManagement, onLinkAlertsClick: onLinkAlertsClick, canAddWebLinks: canAddWebLinks, onAddWebLinkClick: onAddWebLinkClick, onAddIssueLinkClick: onAddIssueLinkClick, onInvestigateIncidentClick: onInvestigateIncidentClick, practices: practices } = props;
    const quickAddActionData = [
        {
            id: (0, $186d4efeb1fdfd01$export$ce507a739019b88f),
            tooltip: formatMessage((0, $20g0V.default).addAttachmentTooltip),
            label: formatMessage((0, $20g0V.default).addAttachmentLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jUThT))), {
                size: "medium",
                label: ""
            }),
            onClick: onAddAttachmentClick,
            itemIndex: 0,
            shouldRender: !isServiceDesk && canCreateAttachment,
            testId: 'issue.issue-view.views.issue-base.foundation.quick-add.quick-add-item.add-attachment'
        },
        {
            id: (0, $186d4efeb1fdfd01$export$4120809d47d0c2ef),
            tooltip: formatMessage((0, $20g0V.default).createSubtaskTooltip),
            label: formatMessage((0, $20g0V.default).createSubtaskLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eyI8O))), {
                size: "medium",
                label: ""
            }),
            onClick: onCreateSubtaskClick,
            itemIndex: 1,
            shouldRender: shouldShowCreateSubtaskButton,
            testId: 'issue.issue-view.views.issue-base.foundation.quick-add.quick-add-item.create-subtask'
        },
        {
            id: (0, $186d4efeb1fdfd01$export$1881ebb86087228d),
            tooltip: formatMessage((0, $20g0V.default).createChildTooltip),
            label: formatMessage((0, $20g0V.default).createChildLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jfQfF))), {
                size: "medium",
                label: ""
            }),
            onClick: onCreateIssueInEpicClick,
            itemIndex: 1,
            shouldRender: shouldShowIssueInEpicButton,
            testId: 'issue.issue-view.views.issue-base.foundation.quick-add.quick-add-item.create-issue-in-epic'
        },
        {
            id: (0, $186d4efeb1fdfd01$export$53277773f5d5866d),
            tooltip: formatMessage((0, $20g0V.default).createChildTooltip),
            label: formatMessage((0, $20g0V.default).createChildLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jfQfF))), {
                size: "medium",
                label: ""
            }),
            onClick: onChildCreateClick,
            itemIndex: 1,
            shouldRender: supportsChildCreation,
            testId: 'issue.issue-view.views.issue-base.foundation.quick-add.quick-add-item.create-child-issue'
        },
        {
            id: (0, $186d4efeb1fdfd01$export$2361268bb33d7359),
            tooltip: formatMessage((0, $20g0V.default).investigateIncidentTooltip),
            label: formatMessage((0, $20g0V.default).investigateIncidentLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
                eventName: "InvestigateIncidentButton viewed",
                componentName: "BentoQuickAddItems"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPZtE))), {
                size: "medium",
                label: ""
            })),
            onClick: onInvestigateIncidentClick,
            itemIndex: 4,
            shouldRender: isServiceDesk && Array.isArray(practices) && practices.includes((0, $f1lMr.INCIDENTS)),
            testId: 'issue.issue-view.views.issue-base.foundation.quick-add.quick-add-item.investigate-incident',
            hasGlobalSpotlightTarget: true
        }
    ];
    const linkingActionsData = [
        {
            id: (0, $186d4efeb1fdfd01$export$fd149869be79c530),
            tooltip: formatMessage((0, $20g0V.default).addIssueLinkTooltip),
            label: formatMessage((0, $20g0V.default).addIssueLinkLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6nIG2))), {
                size: "medium",
                label: ""
            }),
            onClick: onAddIssueLinkClick,
            itemIndex: 2,
            shouldRender: canCreateIssueLink,
            testId: 'issue.issue-view.views.issue-base.foundation.quick-add.quick-add-item.link-issue'
        },
        {
            id: (0, $186d4efeb1fdfd01$export$f8c55ed63efafeaa),
            tooltip: formatMessage((0, $20g0V.default).linkConfluenceContentTooltip),
            label: formatMessage((0, $20g0V.default).linkConfluenceContentLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KT10.ConfluenceIcon), {
                appearance: "brand",
                size: "small",
                label: ""
            }),
            onClick: onLinkConfluencePageClick,
            itemIndex: 3,
            shouldRender: canLinkConfluencePage,
            testId: 'issue.issue-view.views.issue-base.foundation.quick-add.quick-add-item.link-page'
        },
        {
            id: (0, $186d4efeb1fdfd01$export$4aeabd8adfb8f280),
            tooltip: formatMessage((0, $20g0V.default).linkAlertsTooltip),
            label: formatMessage((0, $20g0V.default).linkAlertsLabel),
            // @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => JSX.Element' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
                glyph: (0, $putLD.AlertsGlyph),
                size: "medium",
                label: ""
            }),
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onClick: onLinkAlertsClick || (()=>{}),
            itemIndex: 3,
            shouldRender: (0, $dydjR.shouldLinkAlertsItemRender)(incidentManagement),
            testId: 'issue.issue-view.views.issue-base.foundation.quick-add.quick-add-item.link-alerts'
        },
        {
            id: (0, $186d4efeb1fdfd01$export$a166f12df222f496),
            tooltip: formatMessage((0, $20g0V.default).addWebLinkTooltip),
            label: formatMessage((0, $20g0V.default).addWebLinkLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tfNS))), {
                size: "medium",
                label: ""
            }),
            onClick: onAddWebLinkClick,
            itemIndex: 3,
            shouldRender: canAddWebLinks,
            testId: 'issue.issue-view.views.issue-base.foundation.quick-add.quick-add-item.link-web'
        }
    ];
    return {
        issueActions: quickAddActionData.filter((item)=>item.shouldRender),
        linkingActions: linkingActionsData.filter((item)=>item.shouldRender)
    };
};
var $13b3e6d0d799e82e$export$2e2bcd8739ae039 = $13b3e6d0d799e82e$var$getItemList;

});
parcelRegister("jfQfF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e047f322faad4563$var$_react = $e047f322faad4563$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e047f322faad4563$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e047f322faad4563$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $e047f322faad4563$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 011 1v1H6v-1a1 1 0 011-1z"/><path d="M5 18v1h4v-1H5zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2H5a2 2 0 01-2-2v-1a2 2 0 012-2zm10 2v1h4v-1h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2v-1a2 2 0 012-2zM10 5v1h4V5h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2V5a2 2 0 012-2z" fill-rule="nonzero"/></g></svg>`
    }, props));
$e047f322faad4563$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $e047f322faad4563$var$_default = $e047f322faad4563$var$ChildIssuesIcon;
module.exports.default = $e047f322faad4563$var$_default;

});

parcelRegister("eyI8O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9967b301fa2e1c2$var$_react = $a9967b301fa2e1c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a9967b301fa2e1c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a9967b301fa2e1c2$var$SubtaskIcon = (props)=>/*#__PURE__*/ $a9967b301fa2e1c2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M19 7c1.105.003 2 .899 2 2.006v9.988A2.005 2.005 0 0118.994 21H9.006A2.005 2.005 0 017 19h11c.555 0 1-.448 1-1V7zM3 5.006C3 3.898 3.897 3 5.006 3h9.988C16.102 3 17 3.897 17 5.006v9.988A2.005 2.005 0 0114.994 17H5.006A2.005 2.005 0 013 14.994V5.006zM5 5v10h10V5H5z"/><path d="M7.707 9.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L9 10.586 7.707 9.293z"/></g></svg>`
    }, props));
$a9967b301fa2e1c2$var$SubtaskIcon.displayName = 'SubtaskIcon';
var $a9967b301fa2e1c2$var$_default = $a9967b301fa2e1c2$var$SubtaskIcon;
module.exports.default = $a9967b301fa2e1c2$var$_default;

});

parcelRegister("putLD", function(module, exports) {

$parcel$export(module.exports, "AlertsGlyph", () => $ff525307a928abd2$export$176f750a9e6f975b);

var $eUqFw = parcelRequire("eUqFw");
const $ff525307a928abd2$export$176f750a9e6f975b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C13.104 22 14 21.104 14 20H10C10 21.104 10.896 22 12 22Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 16.9295C18.962 16.9585 18.879 16.9995 18.75 16.9995H5.25C5.121 16.9995 5.038 16.9585 5 16.9295V16.3025C6.347 15.8965 7.341 14.7765 7.517 13.4265L7.521 13.3975L7.523 13.3675L7.964 9.00151C8.203 7.28851 9.933 5.99951 12 5.99951C14.067 5.99951 15.797 7.28851 16.036 9.00151L16.477 13.3675L16.479 13.3975L16.483 13.4265C16.659 14.7765 17.654 15.8965 19 16.3025V16.9295ZM19.728 14.4265C19.051 14.2845 18.547 13.7815 18.467 13.1675L18.022 8.76751C17.707 6.35151 15.622 4.47151 13 4.08251V2.99951C13 2.44751 12.553 1.99951 12 1.99951C11.447 1.99951 11 2.44751 11 2.99951V4.08251C8.378 4.47151 6.293 6.35151 5.978 8.76751L5.533 13.1675C5.453 13.7815 4.949 14.2845 4.272 14.4265C3.527 14.5815 3 15.1735 3 15.8535V17.0005C3 18.1045 4.007 18.9995 5.25 18.9995H18.75C19.993 18.9995 21 18.1045 21 17.0005V15.8535C21 15.1735 20.473 14.5815 19.728 14.4265Z",
        fill: "currentColor"
    }));

});

parcelRegister("20g0V", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e3af35c6e8ca5e8$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $3e3af35c6e8ca5e8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addAttachmentTooltip: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.add-attachment-label",
        "defaultMessage": "Add attachment"
    },
    createSubtaskTooltip: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.create-subtask-label",
        "defaultMessage": "Create subtask"
    },
    addIssueLinkTooltip: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.add-issue-link-label",
        "defaultMessage": "Link issue"
    },
    createChildTooltip: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.create-child-label",
        "defaultMessage": "Add a child issue"
    },
    linkConfluencePageTooltip: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.link-confluence-page-label",
        "defaultMessage": "Link a Confluence page"
    },
    linkConfluenceContentTooltip: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.link-confluence-content-label",
        "defaultMessage": "Link a Confluence content"
    },
    addAttachmentLabel: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.add-attachment-button-label",
        "defaultMessage": "Attach"
    },
    createSubtaskLabel: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.create-subtask-button-label",
        "defaultMessage": "Create subtask"
    },
    addIssueLinkLabel: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.add-issue-link-button-label",
        "defaultMessage": "Link issue"
    },
    createChildLabel: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.create-child-button-label",
        "defaultMessage": "Add a child issue"
    },
    linkConfluencePageLabel: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.link-confluence-page-button-label",
        "defaultMessage": "Link Confluence page"
    },
    linkConfluenceContentLabel: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.link-confluence-content-button-label",
        "defaultMessage": "Link Confluence content"
    },
    linkAlertsLabel: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.link-alerts-label",
        "defaultMessage": "Link alerts"
    },
    linkAlertsTooltip: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.link-alerts-tooltip",
        "defaultMessage": "Link alerts"
    },
    investigateIncidentLabel: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.investigate-incident-label",
        "defaultMessage": "Investigate"
    },
    investigateIncidentTooltip: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.investigate-incident-tooltip",
        "defaultMessage": "Investigate deployments and add them as potential causes to this incident"
    },
    addWebLinkLabel: {
        "id": "issue.foundation.quick-add.quick-add-items.add-web-link-label",
        "defaultMessage": "Add web link"
    },
    addWebLinkTooltip: {
        "id": "issue.foundation.quick-add.quick-add-items.add-web-link-tooltip",
        "defaultMessage": "Link web pages and more"
    },
    linkDropdownButtonLabel: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.web-link-dropdown-label",
        "defaultMessage": "Link web pages and more"
    },
    linkDropdownButtonCompactLabel: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.web-link-dropdown-compact-label",
        "defaultMessage": "Link issues, web pages, and more"
    }
});

});

parcelRegister("dydjR", function(module, exports) {

$parcel$export(module.exports, "shouldLinkAlertsItemRender", () => $788624807fd7c87e$export$6ef39a4a1de25aae);
const $788624807fd7c87e$export$6ef39a4a1de25aae = (incidentManagementField)=>{
    if (!incidentManagementField) return false;
    return incidentManagementField.alertLinking.enabled;
};

});


parcelRegister("1hkvR", function(module, exports) {

$parcel$export(module.exports, "QuickAddWrapper", () => $057bb9e4bb3d8735$export$b1495c8f290807ad);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bAQOb = parcelRequire("bAQOb");
const $057bb9e4bb3d8735$export$b1495c8f290807ad = (0, $bAQOb.componentWithFF)('issue-view-fit-and-finish-full-page-milestone2_ebk0i', /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr1b66 _19pk1b66 _1yt4swc3 _1e0c116y",
            __cmplp.className
        ])
    });
}), /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr1b66 _1yt4swc3 _1e0c116y",
            __cmplp.className
        ])
    });
}));

});



parcelRegister("10AzB", function(module, exports) {

$parcel$export(module.exports, "FoundationContentTemplateRenderer", () => $f1249398e85a8bb1$export$4e6f1deed428e837);
$parcel$export(module.exports, "FoundationContextTemplateRenderer", () => $f1249398e85a8bb1$export$7ccc1dd7b23cc796);
$parcel$export(module.exports, "ContentTemplateRenderer", () => $f1249398e85a8bb1$export$bec68ea1ebc6b300);
$parcel$export(module.exports, "ContextTemplateRenderer", () => $f1249398e85a8bb1$export$9b066eb35ee33910);

var $eUqFw = parcelRequire("eUqFw");

var $iWtAM = parcelRequire("iWtAM");

var $7LoGI = parcelRequire("7LoGI");
var $j1DS9 = parcelRequire("j1DS9");
var $dSblC = parcelRequire("dSblC");
var $hE8iF = parcelRequire("hE8iF");

var $3HVY5 = parcelRequire("3HVY5");
var $hqlq1 = parcelRequire("hqlq1");
var $f9N5g = parcelRequire("f9N5g");
var $mhwN9 = parcelRequire("mhwN9");

var $eBJVm = parcelRequire("eBJVm");
const $f1249398e85a8bb1$export$4e6f1deed428e837 = ({ issueViewRelayFragment: issueViewRelayFragment })=>{
    const templateKey = (0, $eBJVm.useTemplateRendererKey)();
    switch(templateKey){
        case 0, $iWtAM.JSD_TEMPLATE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9N5g.default), {
                issueViewRelayFragment: issueViewRelayFragment
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dSblC.default), {
                issueViewRelayFragment: issueViewRelayFragment
            });
    }
};
const $f1249398e85a8bb1$export$7ccc1dd7b23cc796 = ()=>{
    const templateKey = (0, $eBJVm.useTemplateRendererKey)();
    switch(templateKey){
        case 0, $iWtAM.JSD_TEMPLATE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $mhwN9.default), null);
        case 0, $iWtAM.JWM_TEMPLATE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $mhwN9.default), null);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hE8iF.default), null);
    }
};
const $f1249398e85a8bb1$export$bec68ea1ebc6b300 = ({ issueViewRelayFragment: issueViewRelayFragment })=>{
    const templateKey = (0, $eBJVm.useTemplateRendererKey)();
    switch(templateKey){
        case 0, $iWtAM.JSD_TEMPLATE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3HVY5.default), {
                issueViewRelayFragment: issueViewRelayFragment
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7LoGI.default), {
                issueViewRelayFragment: issueViewRelayFragment
            });
    }
};
const $f1249398e85a8bb1$export$9b066eb35ee33910 = ({ issueViewRelayFragment: issueViewRelayFragment })=>{
    const templateKey = (0, $eBJVm.useTemplateRendererKey)();
    switch(templateKey){
        case 0, $iWtAM.JSD_TEMPLATE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqlq1.default), {
                issueViewRelayFragment: issueViewRelayFragment
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1DS9.default), {
                issueViewRelayFragment: issueViewRelayFragment
            });
    }
};

});
parcelRegister("7LoGI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1258b203fdd4a071$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $fCyzk = parcelRequire("fCyzk");

var $1eJhK = parcelRequire("1eJhK");
const $1258b203fdd4a071$var$ContentTemplate = ({ issueViewRelayFragment: issueViewRelayFragment })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [items] = (0, $fCyzk.useLayoutContainerByType)(issueKey, 'CONTENT');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1eJhK.ContentSectionView), {
        items: items,
        issueViewRelayFragment: issueViewRelayFragment
    });
};
var $1258b203fdd4a071$export$2e2bcd8739ae039 = $1258b203fdd4a071$var$ContentTemplate;

});
parcelRegister("1eJhK", function(module, exports) {

$parcel$export(module.exports, "ContentSectionView", () => $edb6d4cd900b15d4$export$128bcf9d7cc2c148);

var $eUqFw = parcelRequire("eUqFw");

var $bLiXo = parcelRequire("bLiXo");

var $3DTsn = parcelRequire("3DTsn");

var $dS6jW = parcelRequire("dS6jW");
const $edb6d4cd900b15d4$export$128bcf9d7cc2c148 = ({ items: items, issueViewRelayFragment: issueViewRelayFragment })=>{
    /**
	 * items can either have tabs or fieldItems but never both at the same time
	 * i.e. JiraIssueItemTabContainer can be in items
	 * so can multiple JiraIssueItemFieldItem
	 * but never JiraIssueItemFieldItem and JiraIssueItemTabContainer since if there are multiple tabs, each field should be in a tab not by itself.
	 * See JRACLOUD-76139 for more information.
	 */ const hasTabs = items.filter((item)=>item.type === (0, $bLiXo.layoutContainerItemTypes).tab).length > 0;
    if (hasTabs) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dS6jW.TabView), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        items: items,
        area: (0, $bLiXo.CONTENT_AREA),
        issueViewRelayFragment: issueViewRelayFragment
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3DTsn.ItemList), {
        items: items,
        area: (0, $bLiXo.CONTENT_AREA),
        layoutItemsDataFragment: issueViewRelayFragment ?? null
    });
};

});
parcelRegister("3DTsn", function(module, exports) {

$parcel$export(module.exports, "ItemList", () => $4ea87c5c2709e5e9$export$168eb813a5fc3f58);

var $hAuaa = parcelRequire("hAuaa");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");


var $hJ992 = parcelRequire("hJ992");

var $8411R = parcelRequire("8411R");

var $bLiXo = parcelRequire("bLiXo");

var $dZWHl = parcelRequire("dZWHl");

var $2Ls45 = parcelRequire("2Ls45");

var $kYk3D = parcelRequire("kYk3D");

var $5Xp4r = parcelRequire("5Xp4r");

var $6VJRG = parcelRequire("6VJRG");

var $j1WdQ = parcelRequire("j1WdQ");
const $4ea87c5c2709e5e9$export$168eb813a5fc3f58 = ({ items: items, area: area, layoutItemsDataFragment: layoutItemsDataFragment, sortableId: sortableId, onSortItems: onSortItems })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    let relayFieldsByLegacyId = {};
    // must-colocate-fragment-spreads doesn't like the memo-HoC-wrapped component (or likely any differently-named HoC wrapped components)
    const data = (0, $iWLL0.useFragment)((0, $hAuaa.default), layoutItemsDataFragment ?? null);
    relayFieldsByLegacyId = (data?.fieldFragments?.edges || []).reduce((acc, fieldEdge)=>{
        const field = fieldEdge?.node;
        const fieldId = field?.fieldId;
        if (!!fieldId && !!field) acc[fieldId] = field;
        return acc;
    }, relayFieldsByLegacyId);
    const mappedItems = (0, $2Ls45.useLayoutItem)(items);
    const [{ value: issueFieldsConfig }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    const lastElement = mappedItems[mappedItems.length - 1];
    const itemArray = mappedItems.map((sectionItem)=>{
        const isLast = sectionItem === lastElement;
        if (sectionItem.type === (0, $bLiXo.CUSTOM_ITEM_TYPE)) {
            if ((0, $6VJRG.isSortingPinnedFieldsEnabled)()) {
                const id = (0, $dZWHl.getLayoutItemId)(sectionItem);
                return {
                    id: id,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        key: id
                    }, sectionItem.item),
                    fieldName: issueFieldsConfig === null || issueFieldsConfig === undefined ? id : issueFieldsConfig[id]?.title
                };
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                key: (0, $dZWHl.getLayoutItemId)(sectionItem)
            }, sectionItem.item);
        }
        if (issueFieldsConfig === null || issueFieldsConfig === undefined) return null;
        // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'FieldSectionItem | TabLayout | PanelSectionItem | EcosystemSectionItem | ForgeSectionItem | ... 4 more ... | TabItem'. | TS2339 - Property 'payload' does not exist on type 'FieldSectionItem | TabLayout | PanelSectionItem | EcosystemSectionItem | ForgeSectionItem | ... 4 more ... | TabItem'.
        const { id: id, type: type, payload: payload, globalRef: globalRef = '' } = sectionItem;
        const LayoutItemComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kYk3D.LayoutItem), {
            key: id,
            id: id,
            type: type,
            area: area,
            payload: payload,
            // @ts-expect-error - Type '{ readonly fieldId: string; readonly " $fragmentSpreads": FragmentRefs<"src_issueViewLayoutTemplatesLayoutItem_LayoutItemInternal">; } | null | undefined' is not assignable to type 'src_issueViewLayoutTemplatesLayoutItem_LayoutItemInternal$key | null'.
            layoutItemFragment: relayFieldsByLegacyId[id],
            isLast: isLast
        });
        if (globalRef) {
            /* NOTE: These GlobalSpotlightTargets (deprecated) can be used throughout Jira not just within
       * the current package. They're often used for onboarding or changeboarding
       * experiences and allow an Atlaskit spotlight to be attached to page elements.
       * If you need to change this, make sure you check where the target ID is being used
       * and contact the relevant team as necessary. This Sourcegraph link should help :)
       * http://go/src/ISSUE_FIELD_SPOTLIGHT_PREFIX|global-spotlight-target-
       */ if ((0, $6VJRG.isSortingPinnedFieldsEnabled)()) return {
                id: id,
                element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Xp4r.default), {
                    id: globalRef,
                    key: id
                }, LayoutItemComponent),
                fieldName: issueFieldsConfig[id]?.title ?? id
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Xp4r.default), {
                id: globalRef,
                key: id
            }, LayoutItemComponent);
        }
        if ((0, $6VJRG.isSortingPinnedFieldsEnabled)()) return {
            id: id,
            element: LayoutItemComponent,
            fieldName: issueFieldsConfig[id]?.title ?? id
        };
        return LayoutItemComponent;
    });
    if ((0, $6VJRG.isSortingPinnedFieldsEnabled)()) {
        const itemListNotNull = itemArray.filter((item)=>item !== null);
        // TODO: Remove eslint-disable-next-line when cleaning 'issue.details.sorting-pinned-fields' FF
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const source = (0, $hJ992.useAnalyticsSource)();
        const isSortable = sortableId !== undefined && itemListNotNull.length > 1 && source !== (0, $0100842672acae20$export$ce88447986394f2d);
        if (!isSortable) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const itemList = itemListNotNull.map((item)=>{
                // TODO Remove hasOwnProperty check when cleaning up isSortingPinnedFieldsEnabled - https://hello.atlassian.net/browse/DEE-914
                if (!Object.prototype.hasOwnProperty.call(item, 'element')) return null;
                return item.element;
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, itemList);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1WdQ.SortableItemList), {
            droppableId: sortableId,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            items: itemListNotNull,
            onSortItems: onSortItems
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, itemArray);
};

});
parcelRegister("hAuaa", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d73c8dc21875e3c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4b7fb1dfef1413ead13df87f517a7100>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7d73c8dc21875e3c$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "issueViewRelayCascadingSelectFlag"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "issueViewRelayGoalsFlag"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "jsmProductsEntitlementsM2Flag"
        }
    ],
    "kind": "Fragment",
    "name": "src_issueViewLayoutTemplatesItemList_ItemList",
    "selections": [
        {
            "alias": "fieldFragments",
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fields",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldId"
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "issueViewRelayCascadingSelectFlag",
                                            "variableName": "issueViewRelayCascadingSelectFlag"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "issueViewRelayGoalsFlag",
                                            "variableName": "issueViewRelayGoalsFlag"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "jsmProductsEntitlementsM2Flag",
                                            "variableName": "jsmProductsEntitlementsM2Flag"
                                        }
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "src_issueViewLayoutTemplatesLayoutItem_LayoutItemInternal"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$7d73c8dc21875e3c$var$node.hash = "e3291e4e29fa38d5586234f41932d82f";
var $7d73c8dc21875e3c$export$2e2bcd8739ae039 = $7d73c8dc21875e3c$var$node;

});

parcelRegister("2Ls45", function(module, exports) {

$parcel$export(module.exports, "useLayoutItem", () => $3abb64b3f261a3a6$export$e2f4c0dffffc8723);

var $hJ992 = parcelRequire("hJ992");

var $8411R = parcelRequire("8411R");

var $bLiXo = parcelRequire("bLiXo");

var $dZWHl = parcelRequire("dZWHl");

var $g8to1 = parcelRequire("g8to1");

const $3abb64b3f261a3a6$export$4c8eccc56e7b0aa8 = Object.freeze({});
const $3abb64b3f261a3a6$export$e2f4c0dffffc8723 = (items)=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ value: issueFieldsConfig }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    if (issueFieldsConfig === null || issueFieldsConfig === undefined) return [];
    const mappedItems = [];
    items.forEach((sectionItem)=>{
        let payload = $3abb64b3f261a3a6$export$4c8eccc56e7b0aa8;
        let analytics = {
            group: '',
            value: ''
        };
        if (sectionItem.type === (0, $bLiXo.CUSTOM_ITEM_TYPE)) mappedItems.push({
            ...sectionItem,
            analytics: {
                group: (0, $4ef7296c62866dd6$export$1c29733909e6e30d),
                value: sectionItem.id
            },
            payload: payload
        });
        const fieldConfig = issueFieldsConfig[(0, $dZWHl.getLayoutItemId)(sectionItem)];
        const { type: type, id: id } = (0, $g8to1.fieldTypeHandler)(fieldConfig, sectionItem);
        if ((0, $g8to1.isUnsupportedItem)(type)) return;
        // default custom or system
        analytics = {
            group: fieldConfig?.schema?.custom !== null ? (0, $4ef7296c62866dd6$export$1c29733909e6e30d) : (0, $4ef7296c62866dd6$export$da3a70ed0c0cd302),
            value: type
        };
        // panelItemTypes
        if (sectionItem.type === (0, $bLiXo.layoutContainerItemTypes).panel) analytics = {
            group: (0, $4ef7296c62866dd6$export$340512504106afd7),
            value: type
        };
        if (sectionItem.type === (0, $bLiXo.ECOSYSTEM_GLANCE_TYPE) || sectionItem.type === (0, $bLiXo.FORGE_GLANCE_TYPE) || sectionItem.type === (0, $bLiXo.ECOSYSTEM_CONTEXT_TYPE) || sectionItem.type === (0, $bLiXo.FORGE_CONTEXT_TYPE)) {
            payload = sectionItem.payload;
            // @ts-expect-error - TS2339 - Property 'appKey' does not exist on type 'Readonly<{}>'.
            analytics = {
                group: (0, $4ef7296c62866dd6$export$95b9271ec103000c),
                value: payload.appKey
            };
        }
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type '"ecosystemGlance" | "forgeGlance" | "JiraIssueItemFieldItem" | "JiraIssueItemPanelItem" | "JiraIssueItemTabContainer" | "TabLayout" | "FieldSectionItem" | "EcosystemSectionItem" | "ForgeSectionItem" | "PanelSectionItem" | "CustomItem"'. | TS2322 - Type '{ group: string; value: string; }' is not assignable to type '{ group: "" | "custom" | "app" | "system" | "panel"; value: string; }'.
        mappedItems.push({
            ...sectionItem,
            id: id,
            type: type,
            payload: payload,
            analytics: analytics
        });
    });
    return mappedItems;
};

});
const $4ef7296c62866dd6$export$95b9271ec103000c = 'app';
const $4ef7296c62866dd6$export$1c29733909e6e30d = 'custom';
const $4ef7296c62866dd6$export$340512504106afd7 = 'panel';
const $4ef7296c62866dd6$export$da3a70ed0c0cd302 = 'system';


parcelRegister("kYk3D", function(module, exports) {

$parcel$export(module.exports, "LayoutItem", () => $c10786fcff898965$export$908a623c79ef2d32);

var $31gY2 = parcelRequire("31gY2");

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $iWLL0 = parcelRequire("iWLL0");

var $gUUjF = parcelRequire("gUUjF");

var $hJ992 = parcelRequire("hJ992");

var $10dMm = parcelRequire("10dMm");

var $fkWZT = parcelRequire("fkWZT");

var $fCyzk = parcelRequire("fCyzk");

var $9HSls = parcelRequire("9HSls");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2xhj4 = parcelRequire("2xhj4");

var $eSV6n = parcelRequire("eSV6n");

var $eZ9k7 = parcelRequire("eZ9k7");
const $c10786fcff898965$export$d626a5e55af0b512 = (graphqlTypename, jiraFieldType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const layoutItemMap = (0, $2xhj4.getLayoutItemMap)();
    const relayLayoutItemEntryOrWrapper = layoutItemMap[graphqlTypename || ''];
    const relayLayoutItemEntry = !!relayLayoutItemEntryOrWrapper && 'splitByJiraFieldType' in relayLayoutItemEntryOrWrapper ? relayLayoutItemEntryOrWrapper.splitByJiraFieldType?.[jiraFieldType || ''] : relayLayoutItemEntryOrWrapper;
    const RelayLayoutItemComponent = relayLayoutItemEntry?.item ?? null;
    return RelayLayoutItemComponent;
};
/**
 * Component responsible for picking the correct component to mount in the issue-view layout-controlled areas.
 * Priority order of component selection:
 * 1. Relay powered component if provided by {@link useRelayLayoutItemComponent} based on the type of the field in its Relay data
 * 2. Falling back to finding matching legacy components via {@link getLayoutItemMap} which forms a circular dep back to {@code @atlassian/jira-issue-view}
 */ const $c10786fcff898965$var$LayoutItemInternal = ({ id: id, type: type, area: area, isLast: isLast, payload: payload = {}, layoutItemFragment: layoutItemFragment })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const data = (0, $iWLL0.useFragment)((0, $31gY2.default), layoutItemFragment);
    const [, { setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel }] = (0, $fCyzk.useIssueLayoutActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleOpenPanel = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'eventPayload' implicitly has an 'any' type.
    (eventPayload)=>{
        const contextPanelData = {
            contextPanelType: data?.type ?? data?.__typename
        };
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'contextPanel viewed', 'issueContextPanel', contextPanelData);
        setIssueViewLayoutContextPanel(issueKey, {
            payload: eventPayload,
            title: eventPayload?.title,
            type: type,
            key: id
        });
    }, [
        createAnalyticsEvent,
        data,
        setIssueViewLayoutContextPanel,
        issueKey,
        type,
        id
    ]);
    const RelayLayoutItemComponent = $c10786fcff898965$export$d626a5e55af0b512(data?.__typename, data?.type);
    if (RelayLayoutItemComponent && (0, $eZ9k7.isRelayDataReady)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eSV6n.RelayLayoutItemErrorBoundary), {
        itemName: data.type
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9HSls.UiModificationsRelayFieldDecorator), {
        fieldId: data.fieldId,
        issueKey: issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xhj4.RelayLayoutItemFragmentContainer), {
        fragmentKey: data,
        area: area,
        onOpenPanel: handleOpenPanel,
        Component: RelayLayoutItemComponent,
        isLast: isLast
    })));
    const legacyLayoutItemMap = (0, $10dMm.default)();
    if (legacyLayoutItemMap[type]) {
        const LegacyLayoutItemComponent = legacyLayoutItemMap[type].item;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fkWZT.ItemBusyWrapperByIssueKey), {
            issueKey: issueKey,
            fieldId: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LegacyLayoutItemComponent, {
            ...payload,
            key: id,
            fieldId: id,
            area: area,
            onOpenPanel: handleOpenPanel,
            isLast: isLast
        }));
    }
    (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.views.issue-base.context', `Could not find a matching component for "${id}" of type "${type}"`);
    return null;
};
const $c10786fcff898965$export$908a623c79ef2d32 = /*#__PURE__*/ (0, $eUqFw.memo)($c10786fcff898965$var$LayoutItemInternal, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
$c10786fcff898965$export$908a623c79ef2d32.displayName = 'LayoutItem';
var $c10786fcff898965$export$2e2bcd8739ae039 = $c10786fcff898965$export$908a623c79ef2d32;

});
parcelRegister("31gY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6e17a836a5bd1f4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<56ffd43742d99ec0ae03f44b55a0a627>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a6e17a836a5bd1f4$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "issueViewRelayCascadingSelectFlag"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "issueViewRelayGoalsFlag"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "jsmProductsEntitlementsM2Flag"
        }
    ],
    "kind": "Fragment",
    "name": "src_issueViewLayoutTemplatesLayoutItem_LayoutItemInternal",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "issueViewRelayCascadingSelectFlag",
                    "variableName": "issueViewRelayCascadingSelectFlag"
                },
                {
                    "kind": "Variable",
                    "name": "issueViewRelayGoalsFlag",
                    "variableName": "issueViewRelayGoalsFlag"
                },
                {
                    "kind": "Variable",
                    "name": "jsmProductsEntitlementsM2Flag",
                    "variableName": "jsmProductsEntitlementsM2Flag"
                }
            ],
            "kind": "FragmentSpread",
            "name": "relayLayoutItems_issueViewLayoutTemplatesLayoutItem_RelayLayoutItemFragmentContainer"
        }
    ],
    "type": "JiraIssueField",
    "abstractKey": "__isJiraIssueField"
};
$a6e17a836a5bd1f4$var$node.hash = "4c49295a91fb4525e07e6478f6f1643e";
var $a6e17a836a5bd1f4$export$2e2bcd8739ae039 = $a6e17a836a5bd1f4$var$node;

});

parcelRegister("fkWZT", function(module, exports) {

$parcel$export(module.exports, "ItemBusyWrapper", () => $b3f2ac6037257a88$export$cd65bc8cbd26e57);
$parcel$export(module.exports, "ItemBusyWrapperByIssueKey", () => $b3f2ac6037257a88$export$b63f56bf9f92ff76);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");

var $6rkLV = parcelRequire("6rkLV");
const $b3f2ac6037257a88$export$cd65bc8cbd26e57 = ({ children: children, isBusy: isBusy })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3f2ac6037257a88$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3f2ac6037257a88$export$67c29eae8ae2137a, {
        isBusy: isBusy
    }, children), isBusy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3f2ac6037257a88$export$a5e06607a5ac6158, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium"
    })));
const $b3f2ac6037257a88$export$b63f56bf9f92ff76 = ({ children: children, issueKey: issueKey, fieldId: fieldId })=>{
    const isBusy = (0, $6rkLV.useIsFieldBusy)({
        issueKey: issueKey,
        fieldId: fieldId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3f2ac6037257a88$export$cd65bc8cbd26e57, {
        isBusy: isBusy
    }, children);
};
const $b3f2ac6037257a88$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $b3f2ac6037257a88$export$67c29eae8ae2137a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isBusy: isBusy, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.isBusy && "_tzy4m20u _lcxvglyw",
            __cmplp.className
        ])
    });
});
const $b3f2ac6037257a88$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswstnw _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9HSls", function(module, exports) {

$parcel$export(module.exports, "UiModificationsRelayFieldDecorator", () => $dccfd14853e48809$export$2e05e7cde3e4fb05);

var $eUqFw = parcelRequire("eUqFw");

var $6rkLV = parcelRequire("6rkLV");

var $646aD = parcelRequire("646aD");

var $fkWZT = parcelRequire("fkWZT");
const $dccfd14853e48809$export$2e05e7cde3e4fb05 = ({ fieldId: fieldId, children: children, issueKey: issueKey })=>{
    const [overrides] = (0, $6rkLV.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldId
    });
    const isBusy = overrides?.isBusy ?? false;
    const fieldInjectionsContextValue = (0, $eUqFw.useMemo)(()=>({
            overriding: {
                overrideIsEditable: (isEditable)=>overrides?.isEditable ?? isEditable,
                overrideDescription: (description)=>overrides?.description ?? description,
                overrideLabel: (label)=>overrides?.title ?? label,
                overrideFieldOptionsFilter: (filter)=>overrides?.optionsFilter ?? filter
            }
        }), [
        overrides?.description,
        overrides?.isEditable,
        overrides?.optionsFilter,
        overrides?.title
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $646aD.InlineEditFieldInjectionsContext).Provider, {
        value: fieldInjectionsContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fkWZT.ItemBusyWrapper), {
        isBusy: isBusy
    }, children));
};

});
parcelRegister("646aD", function(module, exports) {

$parcel$export(module.exports, "InlineEditFieldInjectionsContext", () => $0e8fe4481ac68f37$export$5b3426c89ef7f7de);
$parcel$export(module.exports, "useInlineEditFieldInjections", () => $0e8fe4481ac68f37$export$23de4844126025dd);

var $eUqFw = parcelRequire("eUqFw");

var $a70rT = parcelRequire("a70rT");
const $0e8fe4481ac68f37$export$f36c9b20522c59e3 = {
    overriding: {
        overrideLabel: (0, $a70rT.identity),
        overrideDescription: (0, $a70rT.identity),
        overrideIsEditable: (0, $a70rT.identity),
        overrideFieldOptionsFilter: (0, $a70rT.identity)
    }
};
const $0e8fe4481ac68f37$export$5b3426c89ef7f7de = /*#__PURE__*/ (0, $eUqFw.createContext)($0e8fe4481ac68f37$export$f36c9b20522c59e3);
const $0e8fe4481ac68f37$export$23de4844126025dd = ()=>(0, $eUqFw.useContext)($0e8fe4481ac68f37$export$5b3426c89ef7f7de);

});
parcelRegister("a70rT", function(module, exports) {

$parcel$export(module.exports, "identity", () => $8a5a7d856c2a9d5f$export$f0954fd7d5368655);
$parcel$export(module.exports, "FieldInjectionsContext", () => $8a5a7d856c2a9d5f$export$a6ff76841695c6c0);

var $eUqFw = parcelRequire("eUqFw");
const $8a5a7d856c2a9d5f$export$8793edee2d425525 = ()=>{};
const $8a5a7d856c2a9d5f$export$f0954fd7d5368655 = (x)=>x;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8a5a7d856c2a9d5f$var$initialValue = {
    capturing: {
        captureAllowedValues: $8a5a7d856c2a9d5f$export$8793edee2d425525,
        captureDescription: $8a5a7d856c2a9d5f$export$8793edee2d425525,
        captureFieldId: $8a5a7d856c2a9d5f$export$8793edee2d425525,
        captureFieldType: $8a5a7d856c2a9d5f$export$8793edee2d425525,
        captureIsDisabled: $8a5a7d856c2a9d5f$export$8793edee2d425525,
        captureIsRequired: $8a5a7d856c2a9d5f$export$8793edee2d425525,
        captureLabel: $8a5a7d856c2a9d5f$export$8793edee2d425525,
        captureRenderer: $8a5a7d856c2a9d5f$export$8793edee2d425525
    },
    overriding: {
        overrideLabel: $8a5a7d856c2a9d5f$export$f0954fd7d5368655,
        overrideElementAfterLabel: $8a5a7d856c2a9d5f$export$f0954fd7d5368655,
        overrideIsRequired: $8a5a7d856c2a9d5f$export$f0954fd7d5368655,
        overrideIsDisabled: $8a5a7d856c2a9d5f$export$f0954fd7d5368655,
        overrideAllowedValues: $8a5a7d856c2a9d5f$export$f0954fd7d5368655,
        overrideFieldOptionsFilter: $8a5a7d856c2a9d5f$export$f0954fd7d5368655,
        overrideOnChange: $8a5a7d856c2a9d5f$export$f0954fd7d5368655,
        overrideOnBlur: $8a5a7d856c2a9d5f$export$f0954fd7d5368655,
        overrideDescription: $8a5a7d856c2a9d5f$export$f0954fd7d5368655
    }
};
const $8a5a7d856c2a9d5f$export$a6ff76841695c6c0 = /*#__PURE__*/ (0, $eUqFw.createContext)($8a5a7d856c2a9d5f$var$initialValue);

});



parcelRegister("2xhj4", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemMap", () => $bc6595d2f2aaa758$export$192e2d0583e05de7);
$parcel$export(module.exports, "RelayLayoutItemFragmentContainer", () => $bc6595d2f2aaa758$export$ebff742d9db49e42);

var $kL85n = parcelRequire("kL85n");

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $iWLL0 = parcelRequire("iWLL0");

var $g4Zlx = parcelRequire("g4Zlx");

var $1ybV0 = parcelRequire("1ybV0");

var $7Svlj = parcelRequire("7Svlj");

var $acwaH = parcelRequire("acwaH");

var $eYS0Z = parcelRequire("eYS0Z");

var $8711r = parcelRequire("8711r");
const $bc6595d2f2aaa758$export$192e2d0583e05de7 = (0, $5iWql.default)(()=>({
        JiraCascadingSelectField: (0, $1ybV0.ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration') ? {
            item: (0, $7Svlj.IssueViewCascadingSelectField)
        } : null,
        JiraLabelsField: {
            item: (0, $acwaH.IssueViewLabelsSystemField)
        },
        JiraSingleSelectField: {
            item: (0, $eYS0Z.IssueViewSingleSelectField)
        },
        JiraServiceManagementEntitlementField: (0, $1ybV0.ff)('products-and-entitlements-m2') ? {
            item: (0, $8711r.AsyncEntitlementsField)
        } : null,
        JiraGoalsField: (0, $1ybV0.ff)('hrz-716-integrate-goal-picker-into-issue-view') ? {
            item: (0, $g4Zlx.default)
        } : null
    }));
const $bc6595d2f2aaa758$export$ebff742d9db49e42 = ({ fragmentKey: fragmentKey, area: area, Component: Component, onOpenPanel: onOpenPanel, isLast: isLast })=>{
    const data = (0, $iWLL0.useFragment)((0, $kL85n.default), fragmentKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        area: area,
        fragmentKey: data,
        onOpenPanel: onOpenPanel,
        isLast: isLast
    });
};

});
parcelRegister("kL85n", function(module, exports) {

$parcel$export(module.exports, "default", () => $16f429a2ba22373c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<88eb537726d54a46f6ad0a32b779417e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $16f429a2ba22373c$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "issueViewRelayCascadingSelectFlag"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "issueViewRelayGoalsFlag"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "jsmProductsEntitlementsM2Flag"
        }
    ],
    "kind": "Fragment",
    "name": "relayLayoutItems_issueViewLayoutTemplatesLayoutItem_RelayLayoutItemFragmentContainer",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_issueViewLayoutLabelsSystemField_IssueViewLabelsSystemField"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField"
        },
        {
            "condition": "issueViewRelayCascadingSelectFlag",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueViewLayoutCascadingSelectField_IssueViewCascadingSelectField"
                }
            ]
        },
        {
            "condition": "jsmProductsEntitlementsM2Flag",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "issueViewEntitlementField_servicedeskCustomerServiceEntitlementsField_EntitlementsField"
                }
            ]
        },
        {
            "condition": "issueViewRelayGoalsFlag",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_businessGoalsIssueViewField_GoalsInlineEditViewField"
                }
            ]
        }
    ],
    "type": "Node",
    "abstractKey": "__isNode"
};
$16f429a2ba22373c$var$node.hash = "c0237afb4d3ccffd2c9e26c777d618ca";
var $16f429a2ba22373c$export$2e2bcd8739ae039 = $16f429a2ba22373c$var$node;

});

parcelRegister("g4Zlx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2307932736bcd30$export$2e2bcd8739ae039);

var $3UfnF = parcelRequire("3UfnF");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $9JNni = parcelRequire("9JNni");
var $6ixIu = parcelRequire("6ixIu");

var $6oQPP = parcelRequire("6oQPP");

var $K1Vl8 = parcelRequire("K1Vl8");

var $3Tszs = parcelRequire("3Tszs");

var $hAmRt = parcelRequire("hAmRt");
const $d2307932736bcd30$export$b3a4af788756a79 = ({ fragmentKey: fragmentKey, isEditing: startWithEditViewOpen = false, readViewFitContainerWidth: readViewFitContainerWidth = true, area: area })=>{
    const issueAri = (0, $3Tszs.useIssueAri)();
    const data = (0, $iWLL0.useFragment)((0, $3UfnF.default), fragmentKey);
    const { id: uniqueFieldId, name: fieldName, selectedGoals: selectedGoals, fieldConfig: fieldConfig } = data;
    const [editMode, setEditMode] = (0, $K1Vl8.useOptionallyControlledEditingState)(startWithEditViewOpen, uniqueFieldId);
    const isFieldEditable = fieldConfig?.isEditable || false;
    const onCancelRequest = (0, $eUqFw.useCallback)(()=>{
        setEditMode(false);
    }, [
        setEditMode
    ]);
    const [goalCollection, setGoalCollection] = (0, $eUqFw.useState)([]);
    const onEditRequested = (0, $eUqFw.useCallback)(()=>{
        setEditMode(!editMode);
    }, [
        editMode,
        setEditMode
    ]);
    const onEscape = ()=>{
        setEditMode(false);
    };
    const goals = (0, $eUqFw.useMemo)(()=>selectedGoals?.edges?.map((edge)=>edge?.node).filter((goal)=>goal != null) || [], [
        selectedGoals
    ]);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        setEditMode(false);
    }, [
        setEditMode
    ]); // TODO: this is temporary to satisfy the required GoalsPicker props
    // This will be changed to update the relay cache
    const onGoalPicked = (0, $eUqFw.useCallback)((goal)=>{
        setGoalCollection([
            ...goalCollection,
            goal
        ]);
    }, [
        goalCollection
    ]); // TODO: this is temporary
    const onGoalUnlinked = (0, $eUqFw.useCallback)((goalUnlinkedId, remainingGoals)=>{
        setGoalCollection(remainingGoals);
    }, []);
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            testId: "business-goals-issue-view-field.ui.read-view",
            xcss: $d2307932736bcd30$var$readViewContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $d2307932736bcd30$var$readModeStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ixIu.GoalsCellContent), {
            goals: goals,
            goalCount: selectedGoals?.totalCount || 0,
            isEditable: isFieldEditable
        })));
    const renderEditView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            testId: "business-goals-issue-view-field.ui.edit-view",
            xcss: $d2307932736bcd30$var$editViewContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            alignItems: "center",
            xcss: $d2307932736bcd30$var$editModeStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9JNni.default), {
            goals: goals,
            goalCount: selectedGoals?.totalCount || 0,
            isEditable: isFieldEditable,
            editMode: true,
            shouldRenderToParent: true,
            onGoalPicked: onGoalPicked,
            issueAri: issueAri,
            onClose: onClose,
            onGoalUnlinked: onGoalUnlinked
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hAmRt.IssueViewFieldHeading), {
        area: area,
        fragmentKey: data,
        testId: `issue.issue-view-layout.issue-view-single-select-field.${data.fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d2307932736bcd30$var$InlineEditContainer, {
        isEditable: isFieldEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        editView: renderEditView,
        hideActionButtons: true,
        isEditable: isFieldEditable,
        isEditing: editMode,
        isLabelHidden: true,
        label: fieldName,
        readView: renderReadView,
        readViewFitContainerWidth: readViewFitContainerWidth,
        testId: "business-goals-issue-view-field.ui.field-inline-edit-state-less",
        onCancel: onCancelRequest,
        onEdit: onEditRequested,
        onEscape: onEscape
    })));
};
const $d2307932736bcd30$var$editModeStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    minHeight: '32px',
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.100',
    paddingRight: 'space.075'
});
const $d2307932736bcd30$var$readModeStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.075'
});
const $d2307932736bcd30$var$editViewContainerStyles = (0, $1ZAYh.xcss)({
    zIndex: 'dialog',
    position: 'relative'
});
const $d2307932736bcd30$var$readViewContainerStyles = (0, $1ZAYh.xcss)({
    flex: '1 1 auto',
    wordBreak: 'break-word',
    position: 'relative',
    lineHeight: 1.4
});
const $d2307932736bcd30$var$nonEditableStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $d2307932736bcd30$var$InlineEditContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _19pkx0bf _1gzc1txw _auuz1h6o _6vgs1osq _1rjezwfg",
            !__cmplp.isEditable && "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _1nmz1hna _kqswh2mm _vwz419ii _19bv12x7",
            __cmplp.className
        ])
    });
});
var $d2307932736bcd30$export$2e2bcd8739ae039 = $d2307932736bcd30$export$b3a4af788756a79;

});
parcelRegister("3UfnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6e1233481e15e45$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5733733808d53adf6ecab1249eb564fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c6e1233481e15e45$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_businessGoalsIssueViewField_GoalsInlineEditViewField",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "ui_issueViewLayoutFieldHeading_IssueViewFieldHeading"
            },
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            v1 /*: any*/ ,
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraGoalConnection",
                "kind": "LinkedField",
                "name": "selectedGoals",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "concreteType": "JiraGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "status"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedGoals(first:1)"
            }
        ],
        "type": "JiraGoalsField"
    };
}();
$c6e1233481e15e45$var$node.hash = "f9898ef2fb1d45bf29490a64f1562f9e";
var $c6e1233481e15e45$export$2e2bcd8739ae039 = $c6e1233481e15e45$var$node;

});

parcelRegister("9JNni", function(module, exports) {

$parcel$export(module.exports, "default", () => $302f90b11f728b97$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $jP1Q8 = parcelRequire("jP1Q8");

var $6ixIu = parcelRequire("6ixIu");

var $hKyhk = parcelRequire("hKyhk");
const $302f90b11f728b97$var$POPUP_OFFSET = [
    -8,
    8
];
const $302f90b11f728b97$var$GoalsPicker = ({ issueAri: issueAri, goals: goals, goalCount: goalCount, isEditable: isEditable, editMode: editMode, onClose: onClose, onGoalPicked: onGoalPicked, onGoalUnlinked: onGoalUnlinked, shouldRenderToParent: shouldRenderToParent = false })=>{
    const { hasPermission: hasPermission, loading: loading, hasErrorOccurred: hasErrorOccurred, retry: retry } = (0, $jP1Q8.useUserHasAccessToTitan)();
    const popupTrigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            role: "button",
            xcss: $302f90b11f728b97$var$triggerStyles,
            ...triggerProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ixIu.GoalsCellContent), {
            goals: goals,
            goalCount: goalCount,
            isEditable: isEditable
        })), [
        goalCount,
        goals,
        isEditable
    ]);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hKyhk.GoalsPopup), {
            issueAri: issueAri,
            hasPermission: hasPermission,
            hasErrorOccurred: hasErrorOccurred,
            retryPermissions: retry,
            isLoadingPermissions: loading,
            goalCount: goalCount,
            onClose: onClose,
            onGoalPicked: onGoalPicked,
            onGoalUnlinked: onGoalUnlinked
        }), [
        goalCount,
        hasPermission,
        issueAri,
        onClose,
        onGoalPicked,
        loading,
        onGoalUnlinked,
        hasErrorOccurred,
        retry
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $302f90b11f728b97$var$goalPickerStyles,
        alignItems: "center",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: editMode,
        content: content,
        trigger: popupTrigger,
        offset: $302f90b11f728b97$var$POPUP_OFFSET,
        placement: "bottom-start",
        shouldRenderToParent: shouldRenderToParent
    }));
};
var $302f90b11f728b97$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($302f90b11f728b97$var$GoalsPicker);
const $302f90b11f728b97$var$triggerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    height: '100%',
    width: '100%',
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'center'
});
const $302f90b11f728b97$var$goalPickerStyles = (0, $1ZAYh.xcss)({
    minHeight: '100%',
    width: '100%'
});

});
parcelRegister("jP1Q8", function(module, exports) {

$parcel$export(module.exports, "useUserHasAccessToTitan", () => $f978caea71934043$export$2131603b1e16a8ef);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $guiFP = parcelRequire("guiFP");

var $dWLk9 = parcelRequire("dWLk9");
const $f978caea71934043$var$HAS_TITAN_ACCESS_CACHE = new Map();
const $f978caea71934043$export$dc8bbb756f0afdb7 = async (cloudId)=>{
    const response = await fetch(`/gateway/api/watermelon/workspace/exists?cloudId=${cloudId}`);
    return response.status === 200;
};
const $f978caea71934043$export$2131603b1e16a8ef = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const checkAccess = (0, $eUqFw.useCallback)(async ()=>{
        const cacheValue = $f978caea71934043$var$HAS_TITAN_ACCESS_CACHE.get(cloudId);
        if (cacheValue?.hasAccess !== undefined) return cacheValue.hasAccess;
        if (cacheValue?.request !== undefined) return cacheValue.request;
        const request = $f978caea71934043$export$dc8bbb756f0afdb7(cloudId);
        $f978caea71934043$var$HAS_TITAN_ACCESS_CACHE.set(cloudId, {
            request: request
        });
        const hasAccess = await request;
        $f978caea71934043$var$HAS_TITAN_ACCESS_CACHE.set(cloudId, {
            hasAccess: hasAccess
        });
        return hasAccess;
    }, [
        cloudId
    ]);
    const { loading: loading, error: error, data: hasPermission, fetch: fetchTitanAccess } = (0, $eEzyV.useService)(checkAccess, {
        data: false
    });
    (0, $eUqFw.useEffect)(()=>{
        fetchTitanAccess();
    }, [
        fetchTitanAccess
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $guiFP.default)({
            meta: {
                id: 'fetchTitanPermission',
                packageName: 'jiraBusinessGoalPicker',
                teamName: 'jira-yurree'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: error
        });
    }, [
        error
    ]);
    return {
        hasPermission: hasPermission,
        loading: loading,
        hasErrorOccurred: !!error,
        retry: fetchTitanAccess
    };
};

});

parcelRegister("6ixIu", function(module, exports) {

$parcel$export(module.exports, "GoalsCellContent", () => $85bc4f45d09a6b3a$export$72e457a3c2c5d2a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iY7zv = parcelRequire("iY7zv");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $iGb7O = parcelRequire("iGb7O");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7ERlq = parcelRequire("7ERlq");
var $cxEEX = parcelRequire("cxEEX");

var $3LRXu = parcelRequire("3LRXu");
const $85bc4f45d09a6b3a$export$72e457a3c2c5d2a = ({ goals: goals, goalCount: goalCount, isEditable: isEditable })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (goalCount > 0 && goals !== null && goals.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85bc4f45d09a6b3a$var$Wrapper, {
        "aria-label": formatMessage((0, $3LRXu.default).goalPickerAriaLabel),
        "data-testid": "business-goal-picker.ui.goals-cell-content.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $85bc4f45d09a6b3a$var$iconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iGb7O.GoalIcon), {
        size: "16",
        appearance: (0, $iGb7O.normalizeGoalAppearance)(goals[0].status || 'PENDING')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ERlq.GoalName), {
        name: goals[0].name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cxEEX.GoalsCount), {
        goalCount: goalCount
    }));
    if (isEditable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85bc4f45d09a6b3a$var$Wrapper, {
        "aria-label": formatMessage((0, $3LRXu.default).goalPickerAriaLabel),
        "data-testid": "business-goal-picker.ui.goals-cell-content.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $85bc4f45d09a6b3a$var$addGoalStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iY7zv))), {
        label: "",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $3LRXu.default).addGoal))));
    return null;
};
const $85bc4f45d09a6b3a$var$GOAL_PICKER_ADD_GOAL_DISPLAY = '--jira-goal-picker-cell-add-goal-display';
const $85bc4f45d09a6b3a$var$addGoalStyles = (0, $1ZAYh.xcss)({
    display: `var(${$85bc4f45d09a6b3a$var$GOAL_PICKER_ADD_GOAL_DISPLAY}, none)`,
    gap: 'space.100',
    alignItems: 'center',
    color: 'color.text.subtlest'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $85bc4f45d09a6b3a$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _80omtlke _1bsb1osq _4t3i1osq _16jlkb7n _4cvr1h6o _zulpu2gc _tj4x1txw _2ooc1txw",
            __cmplp.className
        ])
    });
});
const $85bc4f45d09a6b3a$var$iconStyles = (0, $1ZAYh.xcss)({
    width: 'space.200'
});

});
parcelRegister("iY7zv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dcf3b42887852980$var$_react = $dcf3b42887852980$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dcf3b42887852980$var$_UNSAFE_baseNew = $dcf3b42887852980$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $dcf3b42887852980$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Goal".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dcf3b42887852980$var$GoalIcon = (props)=>/*#__PURE__*/ $dcf3b42887852980$var$_react.default.createElement($dcf3b42887852980$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentColor" stroke-width="1.5" d="M8 11.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z"/>`
    }, props));
$dcf3b42887852980$var$GoalIcon.displayName = 'GoalIcon';
var $dcf3b42887852980$var$_default = module.exports.default = $dcf3b42887852980$var$GoalIcon;

});
parcelRegister("gCIXy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("bxHQy")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("bxHQy")).Icon);

var $bxHQy = parcelRequire("bxHQy");

});
parcelRegister("bxHQy", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $68e08bf1bc6fdccc$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $68e08bf1bc6fdccc$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");
function $68e08bf1bc6fdccc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $68e08bf1bc6fdccc$var$commonSVGStyles = {
    name: "10ihzwq",
    styles: "overflow:hidden;pointer-events:none;stop{stop-color:currentColor;}"
};
const $68e08bf1bc6fdccc$var$svgStyles = {
    name: "x6fk93",
    styles: "color:currentColor;vertical-align:bottom"
};
const $68e08bf1bc6fdccc$var$iconStyles = {
    name: "mrp99y",
    styles: "display:inline-block;box-sizing:border-box;flex-shrink:0;line-height:1;padding-inline-end:var(--ds--button--new-icon-padding-end, 0);padding-inline-start:var(--ds--button--new-icon-padding-start, 0)"
};
const $68e08bf1bc6fdccc$var$utilityIconStyles = {
    name: "1j4yvsm",
    styles: "line-height:var(--ds-space-150, 12px)"
};
const $68e08bf1bc6fdccc$var$scaleStyles = {
    name: "1a1gyup",
    styles: "width:inherit;height:inherit"
};
/**
 * For windows high contrast mode
 */ const $68e08bf1bc6fdccc$var$baseHcmStyles = {
    name: "9vywkz",
    styles: "@media screen and (forced-colors: active){color:CanvasText;filter:grayscale(1);}"
};
const $68e08bf1bc6fdccc$var$sizeMap = {
    scale: {
        name: "1a1gyup",
        styles: "width:inherit;height:inherit"
    },
    utility: {
        name: "1w03az9",
        styles: "width:var(--ds-space-150, 12px);height:var(--ds-space-150, 12px)"
    },
    none: {
        name: "1rrhp72",
        styles: "width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px)"
    },
    spacious: {
        name: "ljflj6",
        styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
    }
};
const $68e08bf1bc6fdccc$var$baseSizeMap = {
    global: 16,
    utility: 12
};
const $68e08bf1bc6fdccc$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eUqFw.memo)(function Icon(props) {
    const { color: color = "var(--ds-icon, #44546F)", spacing: providedSpacing = 'none', testId: testId, label: label, LEGACY_secondaryColor: LEGACY_secondaryColor, LEGACY_size: LEGACY_size = 'medium', LEGACY_fallbackIcon: FallbackIcon, type: // Used to set icon dimensions/behaviour in codegen
    type = 'global', dangerouslySetGlyph: // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $XHGTv.getBooleanFF)('platform.design-system-team.enable-new-icons')) // parse out unnecessary props
    return /*#__PURE__*/ (0, $byn9U.jsx)(FallbackIcon, {
        primaryColor: color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId
    });
    // Utility icons don't have 'spacing' as a type, but in case it's provided, we default to 'none'
    const spacing = type === 'utility' ? 'none' : providedSpacing;
    const baseSize = $68e08bf1bc6fdccc$var$baseSizeMap[type];
    const size = type === 'utility' ? 'utility' : shouldScale ? 'scale' : spacing;
    const viewBoxPadding = spacing === 'spacious' ? 4 : 0;
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    let iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = `
<filter id="ds-newIconOpacityFilter">
  <feFlood flood-color="var(--ds-icon-disabled)" />
  <feComposite in2="SourceGraphic" operator="in" />
</filter>
<g filter="url(#ds-newIconOpacityFilter)">
  ${dangerouslySetInnerHTML.__html}
</g>`;
        iconColor = "var(--ds-icon, #44546F)";
    }
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $68e08bf1bc6fdccc$var$iconStyles,
            $68e08bf1bc6fdccc$var$baseHcmStyles,
            shouldScale && $68e08bf1bc6fdccc$var$scaleStyles,
            type === 'utility' && $68e08bf1bc6fdccc$var$utilityIconStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        fill: "none",
        // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
        // we want for Icon Tile
        viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
        role: "presentation",
        css: [
            $68e08bf1bc6fdccc$var$commonSVGStyles,
            $68e08bf1bc6fdccc$var$svgStyles,
            $68e08bf1bc6fdccc$var$sizeMap[size]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $68e08bf1bc6fdccc$export$2e2bcd8739ae039 = $68e08bf1bc6fdccc$export$f04a61298a47a40f;

});



parcelRegister("iGb7O", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $d994c76899d551d6$export$134cbcd70c6693b8);
$parcel$export(module.exports, "normalizeGoalAppearance", () => $d994c76899d551d6$export$f1b3ca93191ce5cc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");


var $5JgJ2 = parcelRequire("5JgJ2");

var $cI2j2 = parcelRequire("cI2j2");

var $iY7zv = parcelRequire("iY7zv");

var $d8mWx = parcelRequire("d8mWx");

var $kX1jP = parcelRequire("kX1jP");
const $d994c76899d551d6$var$appearanceToColorMap = {
    default: 'gray',
    off_track: 'red',
    at_risk: 'yellow',
    on_track: 'green'
};
const $d994c76899d551d6$var$appearanceToLabelMap = {
    default: 'GenericIconLabel',
    off_track: 'townsquare.api.goal-state.off-track',
    at_risk: 'townsquare.api.goal-state.at-risk',
    on_track: 'townsquare.api.goal-state.on-track'
};
const $d994c76899d551d6$export$134cbcd70c6693b8 = ({ appearance: appearance, size: size, localizedLabel: localizedLabel })=>{
    const intl = (0, $5JgJ2.default)();
    const labelMessageId = localizedLabel && (0, $kX1jP.isMessageId)(localizedLabel === null || localizedLabel === void 0 ? void 0 : localizedLabel.messageId) ? localizedLabel.messageId : $d994c76899d551d6$var$appearanceToLabelMap[appearance];
    return /*#__PURE__*/ $eUqFw.createElement((0, $cI2j2.default), {
        size: size,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iY7zv))),
        label: intl.formatMessage((0, $kX1jP.messages)[labelMessageId]),
        appearance: $d994c76899d551d6$var$appearanceToColorMap[appearance]
    });
};
const $d994c76899d551d6$export$f1b3ca93191ce5cc = (statusValue)=>{
    const appearanceLowercase = statusValue.toLocaleLowerCase();
    return (0, $d8mWx.isGoalAppearance)(appearanceLowercase) ? appearanceLowercase : 'default';
};

});
parcelRegister("cI2j2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fb8d50dcfc24c9b$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
function $1fb8d50dcfc24c9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1fb8d50dcfc24c9b$var$sizeMap = {
    '16': {
        name: "157xhr7",
        styles: "width:16px;height:16px"
    },
    '24': {
        name: "rrel8y",
        styles: "width:24px;height:24px"
    },
    '32': {
        name: "68x97p",
        styles: "width:32px;height:32px"
    },
    '40': {
        name: "1mfsro6",
        styles: "width:40px;height:40px"
    },
    '48': {
        name: "18jhpep",
        styles: "width:48px;height:48px"
    }
};
const $1fb8d50dcfc24c9b$var$appearanceMap = {
    grayBold: {
        name: "algye9",
        styles: "background-color:var(--ds-background-accent-gray-bolder, #626F86);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    limeBold: {
        name: "a86nvv",
        styles: "background-color:var(--ds-background-accent-lime-bolder, #5B7F24);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    greenBold: {
        name: "13e2qqr",
        styles: "background-color:var(--ds-background-accent-green-bolder, #1F845A);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    blueBold: {
        name: "jpsdma",
        styles: "background-color:var(--ds-background-accent-blue-bolder, #0C66E4);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    redBold: {
        name: "1bg8y7a",
        styles: "background-color:var(--ds-background-accent-red-bolder, #C9372C);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    purpleBold: {
        name: "19bo3lb",
        styles: "background-color:var(--ds-background-accent-purple-bolder, #6E5DC6);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    magentaBold: {
        name: "1l16rgo",
        styles: "background-color:var(--ds-background-accent-magenta-bolder, #AE4787);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    tealBold: {
        name: "7kw5zl",
        styles: "background-color:var(--ds-background-accent-teal-bolder, #227D9B);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    orangeBold: {
        name: "h77eay",
        styles: "background-color:var(--ds-background-accent-orange-bolder, #C25100);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    yellowBold: {
        name: "sbe4w3",
        styles: "background-color:var(--ds-background-accent-yellow-bolder, #946F00);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    gray: {
        name: "yxgei8",
        styles: "background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);color:var(--ds-icon-accent-gray, #758195)"
    },
    lime: {
        name: "o9c6oh",
        styles: "background-color:var(--ds-background-accent-lime-subtler, #D3F1A7);color:var(--ds-icon-accent-lime, #6A9A23)"
    },
    orange: {
        name: "szqzk5",
        styles: "background-color:var(--ds-background-accent-orange-subtler, #FEDEC8);color:var(--ds-icon-accent-orange, #E56910)"
    },
    magenta: {
        name: "o6ptuw",
        styles: "background-color:var(--ds-background-accent-magenta-subtler, #FDD0EC);color:var(--ds-icon-accent-magenta, #CD519D)"
    },
    green: {
        name: "157dg7e",
        styles: "background-color:var(--ds-background-accent-green-subtler, #BAF3DB);color:var(--ds-icon-accent-green, #22A06B)"
    },
    blue: {
        name: "x3nujl",
        styles: "background-color:var(--ds-background-accent-blue-subtler, #CCE0FF);color:var(--ds-icon-accent-blue, #1D7AFC)"
    },
    red: {
        name: "zqoyws",
        styles: "background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-icon-accent-red, #C9372C)"
    },
    purple: {
        name: "fitjkd",
        styles: "background-color:var(--ds-background-accent-purple-subtler, #DFD8FD);color:var(--ds-icon-accent-purple, #8270DB)"
    },
    teal: {
        name: "b3m1ww",
        styles: "background-color:var(--ds-background-accent-teal-subtler, #C6EDFB);color:var(--ds-icon-accent-teal, #2898BD)"
    },
    yellow: {
        name: "1j18jub",
        styles: "background-color:var(--ds-background-accent-yellow-subtler, #F8E6A0);color:var(--ds-icon-accent-yellow, #B38600)"
    }
};
const $1fb8d50dcfc24c9b$var$shapeMap = {
    square: {
        name: "vwdoqr",
        styles: "border-radius:var(--ds-border-radius-100, 4px)"
    },
    circle: {
        name: "i2ucdk",
        styles: "border-radius:var(--ds-border-radius-circle, 32032px)"
    }
};
const $1fb8d50dcfc24c9b$var$iconTileStyles = {
    name: "ykimcl",
    styles: "display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center"
};
function $1fb8d50dcfc24c9b$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square' } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $1fb8d50dcfc24c9b$var$iconTileStyles,
            $1fb8d50dcfc24c9b$var$appearanceMap[appearance],
            $1fb8d50dcfc24c9b$var$sizeMap[size],
            $1fb8d50dcfc24c9b$var$shapeMap[shape]
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)(ExpandedIcon, {
        color: "currentColor",
        label: label,
        spacing: "spacious",
        shouldScale: true
    }));
}

});

parcelRegister("d8mWx", function(module, exports) {

$parcel$export(module.exports, "isGoalAppearance", () => $98fdd1bd2a38956c$export$86d2476abee3806b);
const $98fdd1bd2a38956c$export$d6870ac5e959c0f5 = [
    'default',
    'on_track',
    'at_risk',
    'off_track'
];
const $98fdd1bd2a38956c$export$86d2476abee3806b = (value)=>$98fdd1bd2a38956c$export$d6870ac5e959c0f5.includes(value);
const $98fdd1bd2a38956c$export$d7b4c6a971e28318 = [
    'ON_TRACK',
    'AT_RISK',
    'OFF_TRACK',
    'PENDING',
    'COMPLETED',
    'CANCELLED',
    'PAUSED'
]; /**
 * This is solely here to support Jira only having these values available
 *
 * @private
 * @deprecated please use `GoalAppearance` instead
 */ 

});

parcelRegister("kX1jP", function(module, exports) {

$parcel$export(module.exports, "isMessageId", () => $f40a573436912ebf$export$d28699f9b486207b);
$parcel$export(module.exports, "messages", () => $f40a573436912ebf$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $f40a573436912ebf$var$MESSAGE_IDS = [
    'townsquare.api.goal-state.on-track',
    'townsquare.api.goal-state.off-track',
    'townsquare.api.goal-state.at-risk',
    'townsquare.api.goal-state.pending',
    'townsquare.api.goal-state.completed',
    'townsquare.api.goal-state.cancelled',
    'townsquare.api.goal-state.paused',
    'GenericIconLabel'
];
const $f40a573436912ebf$export$d28699f9b486207b = (value)=>$f40a573436912ebf$var$MESSAGE_IDS.includes(value);
const $f40a573436912ebf$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    GenericIconLabel: {
        id: 'Goals.icon.label.generic',
        defaultMessage: 'Goal icon',
        description: 'A generic label for the goal icon, for when a label is not supplied and cannot be inferred from the appearance prop.'
    },
    'townsquare.api.goal-state.on-track': {
        id: 'Goals.icon.label.on-track',
        defaultMessage: 'On track',
        description: 'The label for the "on track" goal status'
    },
    'townsquare.api.goal-state.off-track': {
        id: 'Goals.icon.label.off-track',
        defaultMessage: 'Off track',
        description: 'The label for the "off track" goal status'
    },
    'townsquare.api.goal-state.at-risk': {
        id: 'Goals.icon.label.at-risk',
        defaultMessage: 'At risk',
        description: 'The label for the "at risk" goal status'
    },
    'townsquare.api.goal-state.pending': {
        id: 'Goals.icon.label.pending',
        defaultMessage: 'Pending',
        description: 'The label for the "pending" goal status'
    },
    'townsquare.api.goal-state.completed': {
        id: 'Goals.icon.label.completed',
        defaultMessage: 'Completed',
        description: 'The label for the "completed" goal status'
    },
    'townsquare.api.goal-state.cancelled': {
        id: 'Goals.icon.label.cancelled',
        defaultMessage: 'Cancelled',
        description: 'The label for the "cancelled" goal status'
    },
    'townsquare.api.goal-state.paused': {
        id: 'Goals.icon.label.paused',
        defaultMessage: 'Paused',
        description: 'The label for the "paused" goal status'
    }
});

});


parcelRegister("7ERlq", function(module, exports) {

$parcel$export(module.exports, "GoalName", () => $1279a78781638498$export$4427fb3cde8dd0cf);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $1279a78781638498$export$4427fb3cde8dd0cf = ({ name: name })=>name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1279a78781638498$var$goalTextStyles,
        as: "span"
    }, name);
const $1279a78781638498$var$goalTextStyles = (0, $1ZAYh.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});

parcelRegister("cxEEX", function(module, exports) {

$parcel$export(module.exports, "GoalsCount", () => $901a0e7fc0437b9b$export$cb088e21a8acb84d);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $901a0e7fc0437b9b$export$cb088e21a8acb84d = ({ goalCount: goalCount })=>{
    const numberOfGoals = (0, $eUqFw.useMemo)(()=>goalCount > 1 ? `+${goalCount - 1}` : '', [
        goalCount
    ]);
    return numberOfGoals && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $901a0e7fc0437b9b$var$countStyles
    }, numberOfGoals);
};
const $901a0e7fc0437b9b$var$countStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.disabled',
    fontWeight: 400,
    borderRadius: 'border.radius',
    lineHeight: 0.8632,
    padding: 'space.050',
    pointerEvents: 'none'
});

});

parcelRegister("3LRXu", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc93455b2bfca192$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fc93455b2bfca192$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    goalPickerAriaLabel: {
        "id": "business-goal-picker.goals-cell-content.goal-picker-aria-label",
        "defaultMessage": "Link Goals"
    },
    addGoal: {
        "id": "business-goal-picker.goals-cell-content.add-goal",
        "defaultMessage": "Add goal"
    }
});

});


parcelRegister("hKyhk", function(module, exports) {

$parcel$export(module.exports, "GoalsPopup", () => $ce4c0f7dffffb339$export$6bd9f5ff0e0d02c4);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $7rATE = parcelRequire("7rATE");

var $lUluW = parcelRequire("lUluW");
const $ce4c0f7dffffb339$export$6bd9f5ff0e0d02c4 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $lUluW.goalPickerPopoverEntryPoint), {});
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.goals.picker.edit.popup",
        packageName: "jiraBusinessGoalPicker",
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rATE.LoadingContent), null),
        errorFallback: "flag"
    });
};

});
parcelRegister("7rATE", function(module, exports) {

$parcel$export(module.exports, "LoadingContent", () => $96937c76ff371ba7$export$4ab3512e4872e6ff);

var $eUqFw = parcelRequire("eUqFw");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");
const $96937c76ff371ba7$export$4ab3512e4872e6ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $96937c76ff371ba7$var$loadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large"
    }));
const $96937c76ff371ba7$var$loadingStyles = (0, $1ZAYh.xcss)({
    height: '100%',
    width: '342px',
    padding: 'space.500'
});

});

parcelRegister("lUluW", function(module, exports) {

$parcel$export(module.exports, "goalPickerPopoverEntryPoint", () => $48f2d4f515c7ffe8$export$2917eb3a6c81ef7c);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $48f2d4f515c7ffe8$export$2917eb3a6c81ef7c = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("9pvvu")), {
        moduleId: "97c2ac23"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9pvvu", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('60Mfg')
        ]);
        const value = parcelRequire('bioJd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("60Mfg")
    ]).then(()=>parcelRequire('bioJd'));
}

});




parcelRegister("hAmRt", function(module, exports) {

$parcel$export(module.exports, "IssueViewFieldHeading", () => $54759fe7564c9549$export$2af367e1a8944a73);

var $lkTiL = parcelRequire("lkTiL");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $8aB7X = parcelRequire("8aB7X");

var $iKmKk = parcelRequire("iKmKk");
var $64ypR = parcelRequire("64ypR");

var $646aD = parcelRequire("646aD");

var $4bZws = parcelRequire("4bZws");

var $hHKWU = parcelRequire("hHKWU");
const $54759fe7564c9549$export$2af367e1a8944a73 = ({ children: children, area: area, fragmentKey: fragmentKey, testId: testId })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const showPinButton = (0, $hHKWU.default)(area);
    const { overriding: overriding } = (0, $646aD.useInlineEditFieldInjections)();
    const data = (0, $iWLL0.useFragment)((0, $lkTiL.default), fragmentKey);
    const label = overriding.overrideLabel(data.name);
    const description = overriding.overrideDescription(data.description);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldWrapper), {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKmKk.FieldHeading), {
        fieldId: data.fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.FieldHeadingTitle), null, label), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8aB7X.FieldDescriptionIcon), {
        description: description
    }), showPinButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bZws.FieldPin), {
        fieldId: data.fieldId,
        label: label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64ypR.SideBySideField), null, children));
};

});
parcelRegister("lkTiL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dda9ea225ed70e6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e3d46b2dc8532e757b8bef6a790811be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4dda9ea225ed70e6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueViewLayoutFieldHeading_IssueViewFieldHeading",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        }
    ],
    "type": "JiraIssueField",
    "abstractKey": "__isJiraIssueField"
};
$4dda9ea225ed70e6$var$node.hash = "acd038434eb522bc268efa7ab13a2bef";
var $4dda9ea225ed70e6$export$2e2bcd8739ae039 = $4dda9ea225ed70e6$var$node;

});

parcelRegister("8aB7X", function(module, exports) {

$parcel$export(module.exports, "FieldDescriptionIcon", () => $78b0635695c35d88$export$4bb94d2a55439be);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $15sFp = parcelRequire("15sFp");

var $fPfMJ = parcelRequire("fPfMJ");

var $iNF54 = parcelRequire("iNF54");

const $78b0635695c35d88$export$4bb94d2a55439be = ({ description: description })=>{
    const [adfDescription, setAdfDescription] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        (0, $iNF54.convertWikiToAdfAsync)(description).then((convertedAdfValue)=>{
            setAdfDescription(convertedAdfValue);
        });
    }, [
        description
    ]);
    if (!adfDescription) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($78b0635695c35d88$export$b58fb5c82c6114d3, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fPfMJ.default), {
        adfDescription: adfDescription,
        label: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15sFp.default), null)));
};
const $78b0635695c35d88$export$b58fb5c82c6114d3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($78b0635695c35d88$var$FieldDescriptionWrapperComponent, {
        "data-component-selector": (0, $461c48a7fde28617$export$30d6ea8a1c2516c5),
        ...props
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $78b0635695c35d88$var$FieldDescriptionWrapperComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazwtlf _80omtlke _18u01b66 _19pkv77o _1o9zidpf _30l313vh",
            __cmplp.className
        ])
    });
});

});
const $461c48a7fde28617$export$30d6ea8a1c2516c5 = 'jira-issue-field-description-field-description-wrapper';
const $461c48a7fde28617$export$f2317962f4fe5a83 = '[data-component-selector="jira-issue-field-description-field-description-wrapper"]';




parcelRegister("7Svlj", function(module, exports) {

$parcel$export(module.exports, "IssueViewCascadingSelectField", () => $4e2f815aaf12b00e$export$e606bc114d786c6c);

var $kTKnq = parcelRequire("kTKnq");

var $hy2iv = parcelRequire("hy2iv");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $fyo77 = parcelRequire("fyo77");

var $4Hwcq = parcelRequire("4Hwcq");

var $hW84d = parcelRequire("hW84d");

var $8p8vy = parcelRequire("8p8vy");

var $hAmRt = parcelRequire("hAmRt");
const $4e2f815aaf12b00e$export$43f74830b23ada78 = (value)=>{
    if (value == null || value.parentOptionValue == null) return null;
    const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = value;
    return {
        id: parentOptionValue.optionId || '',
        value: parentOptionValue.value || '',
        child: childOptionValue && {
            id: childOptionValue.optionId || '',
            value: childOptionValue.value || ''
        }
    };
};
const $4e2f815aaf12b00e$export$e606bc114d786c6c = ({ area: area, fragmentKey: fragmentKey })=>{
    const issueId = (0, $hJ992.useIssueId)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $8p8vy.useIssueViewFieldUpdateEvents)();
    const [, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldsValuesActions)();
    const data = (0, $iWLL0.useFragment)((0, $hy2iv.default), fragmentKey);
    // Temporary FF to disable prefetching for select customers that experience issue like https://getsupport.atlassian.com/browse/PCS-277464
    // Proper solution will be done under https://jplat.jira.atlassian.cloud/browse/JIV-18302
    if ((0, $1ybV0.ff)('issue-view-disable-fields-prefetch') === false) // Prefetch `fieldOptions` suggestions
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hW84d.useLazyLoadQueryAfterPageLoad)((0, $kTKnq.default), {
        id: data.id,
        first: (0, $4Hwcq.PREFETCH_OPTIONS_COUNT)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hAmRt.IssueViewFieldHeading), {
        area: area,
        fragmentKey: data,
        testId: `issue.issue-view-layout.issue-view-cascading-select-field.${data.fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fyo77.CascadingSelectInlineEditView), {
        fragmentRef: data,
        onSubmit: (value)=>{
            issueId && fieldChangeRequested(issueId, data.fieldId, $4e2f815aaf12b00e$export$43f74830b23ada78(value));
        },
        onSubmitSucceeded: (value)=>{
            const cascadingOption = $4e2f815aaf12b00e$export$43f74830b23ada78(value);
            issueId && fieldChanged(issueId, data.fieldId, cascadingOption);
            setFieldValue(issueKey, data.fieldId, cascadingOption);
        },
        onSubmitFailed: ()=>issueId && fieldChangeFailed(issueId, data.fieldId),
        spacing: (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i') ? 'compact' : 'default'
    }));
};

});
parcelRegister("kTKnq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ad2f8b70f186d25$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d5c44ff334d72ce23b6ba67e54dc83f4>>
 * @relayHash 50e507718df928ca064395fd318fe70c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b6181355159d14cf0c9ada0391cd828e5ee038e19889e4f67c31e1b2b687f2aa
const $5ad2f8b70f186d25$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = [
        v2 /*: any*/ 
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        v6 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "optionId"
        },
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_prefetchCascadingSelectFieldOptionsQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ui_prefetchCascadingSelectFieldOptionsQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraCascadingOptionsConnection",
                                    "kind": "LinkedField",
                                    "name": "cascadingOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCascadingOptionsEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraCascadingOptions",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "parentOptionValue",
                                                            "plural": false,
                                                            "selections": v7 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "childOptionValues",
                                                            "plural": true,
                                                            "selections": v7 /*: any*/ 
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v5 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "cascadingSelect_issueFieldCascadingSelectEditviewFull_cascadingOptions",
                                    "kind": "LinkedHandle",
                                    "name": "cascadingOptions"
                                }
                            ],
                            "type": "JiraCascadingSelectField"
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "b6181355159d14cf0c9ada0391cd828e5ee038e19889e4f67c31e1b2b687f2aa",
            "metadata": {},
            "name": "ui_prefetchCascadingSelectFieldOptionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5ad2f8b70f186d25$var$node.hash = "4ea277c1bd2765da3a550f42a3098fc3";
var $5ad2f8b70f186d25$export$2e2bcd8739ae039 = $5ad2f8b70f186d25$var$node;

});

parcelRegister("hy2iv", function(module, exports) {

$parcel$export(module.exports, "default", () => $55ec8d52f7e6577f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2d263adeae8a9a2b60317872df0ec113>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $55ec8d52f7e6577f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueViewLayoutCascadingSelectField_IssueViewCascadingSelectField",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_issueViewLayoutFieldHeading_IssueViewFieldHeading"
        },
        {
            "kind": "FragmentSpread",
            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditView"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ],
    "type": "JiraCascadingSelectField"
};
$55ec8d52f7e6577f$var$node.hash = "77dd8aa132aea9df61e781500ef9c042";
var $55ec8d52f7e6577f$export$2e2bcd8739ae039 = $55ec8d52f7e6577f$var$node;

});

parcelRegister("fyo77", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectInlineEditView", () => $628e143a28346f29$export$c72b86275efea41a);

var $2ButZ = parcelRequire("2ButZ");

var $s3gn2 = parcelRequire("s3gn2");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7jPhn = parcelRequire("7jPhn");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8M7DN = parcelRequire("8M7DN");

var $ezvQs = parcelRequire("ezvQs");

var $646aD = parcelRequire("646aD");

var $6oQPP = parcelRequire("6oQPP");

var $K1Vl8 = parcelRequire("K1Vl8");

var $ckbVU = parcelRequire("ckbVU");
const $628e143a28346f29$var$isCascadingOptionExist = (value)=>value !== undefined; /**
                                                                                                                   * Inline edit will handle the switching behaviour between the 'readView' and 'editView' components.
                                                                                                                   *
                                                                                                                   * @param props [CascadingSelectInlineEditViewProps](./types.tsx)
                                                                                                                   */ 
const $628e143a28346f29$export$c72b86275efea41a = ({ fragmentRef: fragmentRef, isEditing: startWithEditViewOpen = false, readViewFitContainerWidth: readViewFitContainerWidth = true, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, spacing: spacing = 'default' })=>{
    // #region Relay
    const data = (0, $iWLL0.useFragment)((0, $s3gn2.default), fragmentRef);
    const { id: uniqueFieldId, name: fieldName, cascadingOption: cascadingOption, fieldConfig: fieldConfig } = data;
    const [commit] = (0, $iWLL0.useMutation)((0, $2ButZ.default));
    // #endregion
    // #region Common state
    const { overriding: overriding } = (0, $646aD.useInlineEditFieldInjections)();
    const [isEditing, setIsEditing] = (0, $K1Vl8.useOptionallyControlledEditingState)(startWithEditViewOpen, uniqueFieldId); // @ts-expect-error - Argument of type '{ readonly childOptionValue: { readonly id: string; readonly isDisabled: boolean | null | undefined; readonly value: string | null | undefined; } | null | undefined; readonly parentOptionValue: { ...; } | ... 1 more ... | undefined; } | null | undefined' is not assignable to parameter of type 'CascadingSelectValuePair | (() => CascadingSelectValuePair | null) | null'.
    const [newValue, setNewValue] = (0, $eUqFw.useState)(cascadingOption);
    const [errors, setErrors] = (0, $eUqFw.useState)(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isEditable = fieldConfig?.isEditable || false;
    const isFieldEditable = (0, $1ybV0.ff)('ui-modifications-cascading-select-field-support-_bjjiv') ? overriding.overrideIsEditable(isEditable) : isEditable; // #endregion
    // #region Handle new value
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('ui-modifications-cascading-select-field-support-_bjjiv') && $628e143a28346f29$var$isCascadingOptionExist(cascadingOption)) setNewValue(cascadingOption);
    }, [
        cascadingOption
    ]);
    const onCancelRequest = (0, $eUqFw.useCallback)(()=>{
        setErrors(null);
        setIsEditing(false); // clear the user's state so it reflects the last server state
        setNewValue({
            parentOptionValue: cascadingOption?.parentOptionValue ?? null,
            childOptionValue: cascadingOption?.childOptionValue ?? null
        });
    }, [
        cascadingOption?.childOptionValue,
        cascadingOption?.parentOptionValue,
        setIsEditing
    ]);
    const onEditRequest = (0, $eUqFw.useCallback)(()=>{
        setErrors(null);
        setIsEditing(true);
    }, [
        setIsEditing
    ]);
    const onCommitError = (0, $eUqFw.useCallback)((responseErrors)=>{
        setErrors(responseErrors);
        setIsEditing(true);
        onSubmitFailed?.();
    }, [
        onSubmitFailed,
        setIsEditing
    ]);
    const onCommitCompleted = (0, $eUqFw.useCallback)((response, newOption)=>{
        if (!response.jira?.updateCascadingSelectField) {
            onCommitError([]);
            return;
        }
        const { success: success, errors: responseErrors } = response.jira.updateCascadingSelectField;
        if (!success) {
            onCommitError(responseErrors);
            return;
        }
        setNewValue(newOption ?? null);
        onSubmitSucceeded?.(newOption);
    }, [
        onSubmitSucceeded,
        onCommitError
    ]);
    const handleNewValue = (0, $eUqFw.useCallback)((newOption)=>{
        // Clear errors and exit editing mode
        setErrors(null);
        setIsEditing(false); // note: If these objects happen to include more than what is expected, Relay will complain.
        const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = newOption || {};
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        parentOption: parentOptionValue?.id,
                        childOption: childOptionValue?.id
                    }
                }
            },
            onCompleted (res) {
                onCommitCompleted(res, newOption);
            },
            onError (error) {
                onCommitError([
                    error
                ]);
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            optimisticResponse: {
                jira: {
                    updateCascadingSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            cascadingOption: {
                                parentOptionValue: parentOptionValue,
                                childOptionValue: childOptionValue
                            },
                            fieldConfig: {
                                isEditable: true
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldName,
        onCommitCompleted,
        onCommitError,
        setIsEditing,
        uniqueFieldId
    ]);
    // #endregion
    // #region Common callbacks
    const onConfirmRequest = (0, $eUqFw.useCallback)(()=>{
        handleNewValue(newValue);
        onSubmit?.(newValue);
    }, [
        newValue,
        handleNewValue,
        onSubmit
    ]); // #endregion
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($628e143a28346f29$var$ReadViewContainer, {
            "data-testid": "issue-field-cascading-select-inline-edit-full.ui.cascading-select.read-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ezvQs.CascadingSelectReadView), {
            fragmentRef: data
        })); // #endregion
    // #region Edit view
    const renderEditView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, errors && errors.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, errors[0].message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($628e143a28346f29$var$EditViewContainer, {
            "data-testid": "issue-field-cascading-select-inline-edit-full.ui.cascading-select.edit-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8M7DN.CascadingSelectEditView), {
            autoFocus: true,
            fieldId: uniqueFieldId,
            parentOptionValue: newValue?.parentOptionValue,
            childOptionValue: newValue?.childOptionValue,
            onChange: setNewValue,
            spacing: spacing
        }))); // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($628e143a28346f29$var$InlineEditContainer, {
        isEditable: isFieldEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        editView: renderEditView,
        isEditable: isFieldEditable,
        isEditing: isEditing,
        isLabelHidden: true,
        label: fieldName,
        readView: renderReadView,
        readViewFitContainerWidth: readViewFitContainerWidth,
        testId: "issue-field-cascading-select-inline-edit-full.ui.cascading-select.field-inline-edit-state-less",
        hideActionButtons: false,
        cancelButtonLabel: formatMessage((0, $ckbVU.default).cancelButtonLabel, {
            fieldName: fieldName
        }),
        confirmButtonLabel: formatMessage((0, $ckbVU.default).confirmButtonLabel, {
            fieldName: fieldName
        }),
        editButtonLabel: formatMessage((0, $ckbVU.default).editButtonLabel, {
            fieldName: fieldName
        }),
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onEdit: onEditRequest
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $628e143a28346f29$var$EditViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbyowjs _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $628e143a28346f29$var$ReadViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _1nmz1hna _kqswh2mm _vwz48sxn",
            __cmplp.className
        ])
    });
});
const $628e143a28346f29$var$nonEditableStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $628e143a28346f29$var$InlineEditContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _19pkx0bf _18u0x0bf _1gzc1txw _auuz1h6o _6vgs1osq _1rjezwfg _osjgidpf _alyvidpf _pa3x12x7 _2g9b12x7",
            !__cmplp.isEditable && "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _1nmz1hna _kqswh2mm _vwz48sxn _19bv12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2ButZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ac11d4797a9da6f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bbe2c24190a1e576dd7a3fb57b51c879>>
 * @relayHash 22f70ea90a509c5fbb3f522fe563c448
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2437d4c0c57b8604c86bffcc698522855b6722aa05f18b693f4ab8cf6df9216b
const $2ac11d4797a9da6f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "optionId"
        },
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCascadingSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCascadingSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCascadingSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCascadingSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCascadingSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCascadingSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "concreteType": "JiraCascadingOption",
                                            "kind": "LinkedField",
                                            "name": "cascadingOption",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "parentOptionValue",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "childOptionValue",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraFieldConfig",
                                            "kind": "LinkedField",
                                            "name": "fieldConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2437d4c0c57b8604c86bffcc698522855b6722aa05f18b693f4ab8cf6df9216b",
            "metadata": {},
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$2ac11d4797a9da6f$var$node.hash = "39107e1c60fabad6aacead17d87f3810";
var $2ac11d4797a9da6f$export$2e2bcd8739ae039 = $2ac11d4797a9da6f$var$node;

});

parcelRegister("s3gn2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8575548eee994cab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b5769de2026d3b1fbcb1a3c14f641793>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8575548eee994cab$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "optionId"
        },
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditView",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "FragmentSpread",
                "name": "cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView"
            },
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v1 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v1 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    }
                ]
            }
        ],
        "type": "JiraCascadingSelectField"
    };
}();
$8575548eee994cab$var$node.hash = "f654eea43eed7846fa1659eea9b8ba46";
var $8575548eee994cab$export$2e2bcd8739ae039 = $8575548eee994cab$var$node;

});

parcelRegister("8M7DN", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectEditView", () => $d98cd26108f002b0$export$dcf968b265cd57c5);

var $d8MJ0 = parcelRequire("d8MJ0");

var $5rXYt = parcelRequire("5rXYt");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $cEc3i = parcelRequire("cEc3i");
var $4zgIJ = parcelRequire("4zgIJ");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4Hwcq = parcelRequire("4Hwcq");

var $4bMJ9 = parcelRequire("4bMJ9");

var $2jdHI = parcelRequire("2jdHI");

var $3gurV = parcelRequire("3gurV");

var $7VcJD = parcelRequire("7VcJD");
const $d98cd26108f002b0$var$aggToAtlaskitOption = (item)=>item ? {
        label: item.value || '',
        value: item.id,
        optionId: item.optionId,
        isDisabled: Boolean(item.isDisabled)
    } : null;
const $d98cd26108f002b0$var$atlaskitOptionToAgg = (item)=>item ? {
        value: item.label,
        id: String(item.value),
        optionId: item.optionId,
        isDisabled: Boolean(item.isDisabled)
    } : null;
const $d98cd26108f002b0$var$filterOption = (0, $cEc3i.c)({
    stringify: (option)=>option.label
}); /**
     * CascadingSelectEditViewWithFieldOptionsFragment is a version of the edit view that allows
     * the passing of a fragment for experiences like GIC that might want to group fetch data on mount
     * instead of having a separate network request for it
     *
     * @param props [CascadingSelectEditViewWithFieldOptionsFragmentProps](./types.tsx)
     */ 
const $d98cd26108f002b0$export$bd936cd33aa90610 = ({ autoFocus: autoFocus = true, areOptionsOnSameRow: areOptionsOnSameRow = false, fieldId: fieldId, fieldOptionsFragmentRef: fieldOptionsFragmentRef, onChange: onChange, parentOptionValue: parentOptionValue, childOptionValue: childOptionValue, isDisabled: isDisabled = false, isInvalid: isInvalid = false, fetchSuggestionsOnMount: fetchSuggestionsOnMount = false, spacing: spacing = 'default', menuPosition: menuPosition })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const loadingMessage = (0, $eUqFw.useCallback)(()=>formatMessage((0, $7VcJD.default).loading), [
        formatMessage
    ]);
    const noOptionsMessage = (0, $eUqFw.useCallback)(()=>formatMessage((0, $7VcJD.default).empty), [
        formatMessage
    ]);
    const placeholderMessage = (0, $eUqFw.useMemo)(()=>formatMessage((0, $7VcJD.default).noOptionsSelected), [
        formatMessage
    ]);
    const childRef = (0, $eUqFw.useRef)(null); /** Whether the end-user interacted with the parent selector or not.
                                  * The child selector should never be auto-focussed on the first render.
                                  * However, if the parent option is changed and child options are available, that's fine.
                                  */ 
    const [userChoseParentOption, setUserChoseParentOption] = (0, $eUqFw.useState)(false); // #region Relay
    // suggestions fragment with pagination and refetch
    const { data: fieldOptionsSearchData, refetch: refetchSuggestions } = (0, $iWLL0.usePaginationFragment)((0, $5rXYt.default), fieldOptionsFragmentRef);
    const { edges: fieldOptionsData } = fieldOptionsSearchData.node?.cascadingOptions || {}; // #endregion
    // #region Debounced suspensless refetch helpers
    const [searchSuspenselessRefetch, isLoading, lastFetchError] = (0, $4bMJ9.useSuspenselessRefetch)((0, $3gurV.default), refetchSuggestions);
    const [searchLeadingEdgeSuspenselessRefetch] = (0, $2jdHI.default)(searchSuspenselessRefetch, (0, $4Hwcq.SEARCH_DEBOUNCE_TIMEOUT), {
        leading: true
    }); // #endregion
    // #region Common callbacks for the selector
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        searchLeadingEdgeSuspenselessRefetch({
            id: fieldId
        });
    }, [
        fieldId,
        searchLeadingEdgeSuspenselessRefetch
    ]);
    const onChangeChild = (0, $eUqFw.useCallback)((selectedChildOption)=>{
        const newValue = {
            parentOptionValue: parentOptionValue ?? null,
            childOptionValue: $d98cd26108f002b0$var$atlaskitOptionToAgg(selectedChildOption)
        };
        onChange && onChange(newValue);
    }, [
        onChange,
        parentOptionValue
    ]);
    const onChangeParent = (0, $eUqFw.useCallback)((selectedParentOption)=>{
        const newValue = {
            parentOptionValue: $d98cd26108f002b0$var$atlaskitOptionToAgg(selectedParentOption),
            childOptionValue: null
        };
        onChange && onChange(newValue); // Manage whether the child selector should be focussed.
        // @ts-expect-error Atlaskit's select does not have a typed `focus` prototype member, though it exists in practice.
        childRef && childRef.current && childRef.current.focus(); // once a user has selected a parent, it's fine to auto-focus the child when it disappeared then re-appeared.
        setUserChoseParentOption(true);
    }, [
        onChange
    ]); // #endregion
    // #region Transform options data from relay to AK Select
    const defaultFailedOption = (0, $eUqFw.useMemo)(()=>({
            label: formatMessage((0, $7VcJD.default).failedFetch),
            value: '',
            isDisabled: true
        }), [
        formatMessage
    ]);
    const withErrorOption = (0, $eUqFw.useCallback)((options)=>{
        const arr = options || [];
        if (lastFetchError) arr.push(defaultFailedOption);
        return arr;
    }, [
        lastFetchError,
        defaultFailedOption
    ]); // @ts-expect-error - Type '{ readonly childOptionValues: readonly ({ readonly id: string; readonly isDisabled: boolean | null | undefined; readonly value: string | null | undefined; } | null | undefined)[] | null | undefined; readonly parentOptionValue: { ...; } | ... 1 more ... | undefined; }[]' is not assignable to type 'CascadingSelectOptionPair[]'.
    const cascadingOptionResults = (0, $eUqFw.useMemo)(()=>fieldOptionsData?.map((edge)=>edge?.node).filter(Boolean) ?? [], [
        fieldOptionsData
    ]); // Extract list of allowed parent values. It's just the full list of what we've found for now.
    const parentOptionResults = (0, $eUqFw.useMemo)(()=>withErrorOption(cascadingOptionResults.map((result)=>$d98cd26108f002b0$var$aggToAtlaskitOption(result.parentOptionValue)).filter(Boolean)), [
        withErrorOption,
        cascadingOptionResults
    ]); // Extract list of allowed child values. Only do so if a parent value exists and has a valid optionId, otherwise
    // there's no way we could select a child option.
    const childOptionResults = (0, $eUqFw.useMemo)(()=>withErrorOption(parentOptionValue?.id && cascadingOptionResults.find((result)=>parentOptionValue.id === result.parentOptionValue?.id)?.childOptionValues?.map($d98cd26108f002b0$var$aggToAtlaskitOption).filter(Boolean) || []), [
        withErrorOption,
        cascadingOptionResults,
        parentOptionValue
    ]); // #endregion
    // #region state control between parent and child UI components
    const showChildOptionSelector = parentOptionValue?.value && (childOptionValue?.value || childOptionResults.length > 0); // #endregion
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('changes-in-cascade-select-edit-view-for-form-field_acoii') && fetchSuggestionsOnMount) searchLeadingEdgeSuspenselessRefetch({
            id: fieldId
        });
    }, [
        fieldId,
        searchLeadingEdgeSuspenselessRefetch,
        fetchSuggestionsOnMount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d98cd26108f002b0$var$Container, {
        areOptionsOnSameRow: areOptionsOnSameRow,
        "data-testid": "issue-field-cascading-select-editview-full.ui.cascading-select.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), {
        autoFocus: autoFocus,
        isDisabled: (0, $1ybV0.ff)('changes-in-cascade-select-edit-view-for-form-field_acoii') ? isDisabled : false,
        isInvalid: (0, $1ybV0.ff)('changes-in-cascade-select-edit-view-for-form-field_acoii') ? isInvalid : false,
        openMenuOnFocus: true,
        closeMenuOnSelect: true,
        isClearable: true,
        isLoading: isLoading,
        loadingMessage: loadingMessage,
        noOptionsMessage: noOptionsMessage,
        options: parentOptionResults,
        filterOption: $d98cd26108f002b0$var$filterOption,
        value: $d98cd26108f002b0$var$aggToAtlaskitOption(parentOptionValue),
        placeholder: formatMessage((0, $7VcJD.default).noOptionsSelected),
        onChange: onChangeParent,
        onFocus: onFocus,
        spacing: spacing,
        ...(0, $1ybV0.ff)('changes-in-cascade-select-edit-view-for-form-field_acoii') ? {
            menuPosition: menuPosition
        } : {}
    }), showChildOptionSelector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), {
        isDisabled: (0, $1ybV0.ff)('changes-in-cascade-select-edit-view-for-form-field_acoii') ? isDisabled : false,
        isInvalid: (0, $1ybV0.ff)('changes-in-cascade-select-edit-view-for-form-field_acoii') ? isInvalid : false,
        ref: childRef,
        autoFocus: userChoseParentOption,
        openMenuOnFocus: true,
        closeMenuOnSelect: true,
        isClearable: true,
        isLoading: isLoading,
        loadingMessage: loadingMessage,
        noOptionsMessage: noOptionsMessage,
        options: childOptionResults,
        filterOption: $d98cd26108f002b0$var$filterOption,
        value: $d98cd26108f002b0$var$aggToAtlaskitOption(childOptionValue),
        placeholder: placeholderMessage,
        onChange: onChangeChild,
        onFocus: onFocus,
        spacing: spacing,
        ...(0, $1ybV0.ff)('changes-in-cascade-select-edit-view-for-form-field_acoii') ? {
            menuPosition: menuPosition
        } : {}
    }));
};
const $d98cd26108f002b0$export$dcf968b265cd57c5 = (props)=>{
    const suggestionsData = (0, $iWLL0.useLazyLoadQuery)((0, $d8MJ0.default), {
        id: props.fieldId
    }, {
        fetchPolicy: 'store-only'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d98cd26108f002b0$export$bd936cd33aa90610, {
        ...props,
        fieldOptionsFragmentRef: suggestionsData
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d98cd26108f002b0$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { areOptionsOnSameRow: areOptionsOnSameRow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulp1b66 _osiyidpf _12apkb7n",
            __cmplp.areOptionsOnSameRow ? "_2lx2vrvc" : "_2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d8MJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e14e19bab17b87a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<467df260b1e7812364886fedb6d4a6ee>>
 * @relayHash a5c3ab34fee6e976f943ae49e1ab9574
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d9150d3bc0c8fa720864e5de499cc3f506b815b187b51b727e0e85f1112a286
const $0e14e19bab17b87a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "optionId"
        },
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cascadingSelect_cascadingSelectSearchQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cascadingSelect_cascadingSelectSearchQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraCascadingOptionsConnection",
                                    "kind": "LinkedField",
                                    "name": "cascadingOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCascadingOptionsEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraCascadingOptions",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "parentOptionValue",
                                                            "plural": false,
                                                            "selections": v5 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "childOptionValues",
                                                            "plural": true,
                                                            "selections": v5 /*: any*/ 
                                                        },
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "cascadingOptions(first:1000)"
                                },
                                {
                                    "args": v3 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "cascadingSelect_issueFieldCascadingSelectEditviewFull_cascadingOptions",
                                    "kind": "LinkedHandle",
                                    "name": "cascadingOptions"
                                }
                            ],
                            "type": "JiraCascadingSelectField"
                        },
                        v4 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "5d9150d3bc0c8fa720864e5de499cc3f506b815b187b51b727e0e85f1112a286",
            "metadata": {},
            "name": "cascadingSelect_cascadingSelectSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0e14e19bab17b87a$var$node.hash = "13909fd597ca783ac3c98bb61f08915d";
var $0e14e19bab17b87a$export$2e2bcd8739ae039 = $0e14e19bab17b87a$var$node;

});

parcelRegister("5rXYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $282e3097de1d6853$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b12aa9a854a3316327d2206a06262522>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $3gurV = parcelRequire("3gurV");
const $282e3097de1d6853$var$node = function() {
    var v0 = [
        "node",
        "cascadingOptions"
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "optionId"
        },
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "defaultValue": 1000,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "id"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $3gurV.default)
            }
        },
        "name": "cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "id"
                    }
                ],
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": "cascadingOptions",
                                "concreteType": "JiraCascadingOptionsConnection",
                                "kind": "LinkedField",
                                "name": "__cascadingSelect_issueFieldCascadingSelectEditviewFull_cascadingOptions_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraCascadingOptionsEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCascadingOptions",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraOption",
                                                        "kind": "LinkedField",
                                                        "name": "parentOptionValue",
                                                        "plural": false,
                                                        "selections": v1 /*: any*/ 
                                                    },
                                                    {
                                                        "concreteType": "JiraOption",
                                                        "kind": "LinkedField",
                                                        "name": "childOptionValues",
                                                        "plural": true,
                                                        "selections": v1 /*: any*/ 
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraCascadingSelectField"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$282e3097de1d6853$var$node.hash = "861857f405fb6492f7093672a20e5a50";
var $282e3097de1d6853$export$2e2bcd8739ae039 = $282e3097de1d6853$var$node;

});
parcelRegister("3gurV", function(module, exports) {

$parcel$export(module.exports, "default", () => $edbc856110f92a69$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dcc8d6470279fd94027ab4071b7fa6a3>>
 * @relayHash 71aea56009f2d8825f482e2ad891e13a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a2b481a2dbcebbbb459540b8b7762b7ab1be5f33c38ad906c71e0a2286e31ece
const $edbc856110f92a69$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": 1000,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = [
        v1 /*: any*/ ,
        v2 /*: any*/ 
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        v6 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "optionId"
        },
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cascadingSelect_cascadingSelectSearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cascadingSelect_cascadingSelectSearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraCascadingOptionsConnection",
                                    "kind": "LinkedField",
                                    "name": "cascadingOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCascadingOptionsEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraCascadingOptions",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "parentOptionValue",
                                                            "plural": false,
                                                            "selections": v7 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "childOptionValues",
                                                            "plural": true,
                                                            "selections": v7 /*: any*/ 
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v5 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "cascadingSelect_issueFieldCascadingSelectEditviewFull_cascadingOptions",
                                    "kind": "LinkedHandle",
                                    "name": "cascadingOptions"
                                }
                            ],
                            "type": "JiraCascadingSelectField"
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "a2b481a2dbcebbbb459540b8b7762b7ab1be5f33c38ad906c71e0a2286e31ece",
            "metadata": {},
            "name": "cascadingSelect_cascadingSelectSearchRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$edbc856110f92a69$var$node.hash = "861857f405fb6492f7093672a20e5a50";
var $edbc856110f92a69$export$2e2bcd8739ae039 = $edbc856110f92a69$var$node;

});


parcelRegister("7VcJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5cfa84c1842ba09$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a5cfa84c1842ba09$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    empty: {
        "id": "issue-field-cascading-select-editview-full.cascading-select.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-cascading-select-editview-full.cascading-select.failed-fetch",
        "defaultMessage": "Search failed."
    },
    loading: {
        "id": "issue-field-cascading-select-editview-full.cascading-select.loading",
        "defaultMessage": "Searching..."
    },
    noOptionsSelected: {
        "id": "issue-field-cascading-select-editview-full.cascading-select.no-options-selected",
        "defaultMessage": "None"
    },
    queryError: {
        "id": "issue-field-cascading-select-editview-full.cascading-select.query-error",
        "defaultMessage": "Search failed."
    }
});

});


parcelRegister("ezvQs", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectReadView", () => $10c90b9b719f77b4$export$4b0478fdeeb1c69);

var $bKrSr = parcelRequire("bKrSr");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $cRXCh = parcelRequire("cRXCh");
const $10c90b9b719f77b4$var$getFieldValueAsText = (cascadingOption)=>{
    if (!cascadingOption || !cascadingOption?.parentOptionValue) return null;
    if (!cascadingOption?.childOptionValue) return cascadingOption.parentOptionValue.value;
    return `${cascadingOption.parentOptionValue.value} - ${cascadingOption.childOptionValue.value}`;
};
const $10c90b9b719f77b4$export$4b0478fdeeb1c69 = ({ fragmentRef: fragmentRef })=>{
    const { cascadingOption: cascadingOption } = (0, $iWLL0.useFragment)((0, $bKrSr.default), fragmentRef);
    const fieldValueAsText = $10c90b9b719f77b4$var$getFieldValueAsText(cascadingOption);
    if (!fieldValueAsText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cRXCh.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fieldValueAsText);
};

});
parcelRegister("bKrSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $211a9da60611b154$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e3e7eaf85051bb2d23ffb70d08f4080d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $211a9da60611b154$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView",
        "selections": [
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraCascadingSelectField"
    };
}();
$211a9da60611b154$var$node.hash = "3327b7b284e2098b00737ec46c5db99a";
var $211a9da60611b154$export$2e2bcd8739ae039 = $211a9da60611b154$var$node;

});

parcelRegister("cRXCh", function(module, exports) {

$parcel$export(module.exports, "EmptyFieldText", () => $dea09b50e3f6a61b$export$f6d716da5f11cd01);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $k2rpK = parcelRequire("k2rpK");

var $5GnyL = parcelRequire("5GnyL");
const $dea09b50e3f6a61b$export$f6d716da5f11cd01 = ({ emptyText: emptyText })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GnyL.EmptyValueStyleWrapper), null, emptyText ?? formatMessage((0, $k2rpK.default).emptyFieldText));
};

});
parcelRegister("k2rpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf38d541ebb7a80f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bf38d541ebb7a80f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyFieldText: {
        "id": "issue-empty-field-text.empty-field-text",
        "defaultMessage": "None"
    }
});

});

parcelRegister("5GnyL", function(module, exports) {

$parcel$export(module.exports, "EmptyValueStyleWrapper", () => $a41f82c5883ec6f7$export$d716e4866417fc3b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ybV0 = parcelRequire("1ybV0");
const $a41f82c5883ec6f7$export$d716e4866417fc3b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1",
            (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && "_1reo15vq _18m915vq _1bto1l2s _p12f1osq",
            __cmplp.className
        ])
    });
});

});



parcelRegister("ckbVU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64c6077f8f3b8c4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d64c6077f8f3b8c4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    confirmButtonLabel: {
        "id": "issue-field-cascading-select-inline-edit-full.cascading-select.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "issue-field-cascading-select-inline-edit-full.cascading-select.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "issue-field-cascading-select-inline-edit-full.cascading-select.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    }
});

});



parcelRegister("acwaH", function(module, exports) {

$parcel$export(module.exports, "IssueViewLabelsSystemField", () => $083550584dd95969$export$ad6a3b8151c43a69);

var $cu6dC = parcelRequire("cu6dC");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $g0FAB = parcelRequire("g0FAB");

var $8p8vy = parcelRequire("8p8vy");

var $hAmRt = parcelRequire("hAmRt");
const $083550584dd95969$export$ad6a3b8151c43a69 = ({ area: area, fragmentKey: fragmentKey })=>{
    const issueId = (0, $hJ992.useIssueId)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $8p8vy.useIssueViewFieldUpdateEvents)();
    const [, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldsValuesActions)();
    const data = (0, $iWLL0.useFragment)((0, $cu6dC.default), fragmentKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hAmRt.IssueViewFieldHeading), {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "issue.views.issue-base.context.labels",
        area: area,
        fragmentKey: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $083550584dd95969$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g0FAB.LabelsInlineEditView), {
        fragmentRef: data,
        onSubmit: (newValue)=>issueId && fieldChangeRequested(issueId, data?.fieldId, newValue),
        onSubmitSucceeded: (newValue)=>{
            issueId && fieldChanged(issueId, data?.fieldId, newValue);
            setFieldValue(issueKey, data.fieldId, newValue);
        },
        onSubmitFailed: ()=>issueId && fieldChangeFailed(issueId, data?.fieldId)
    })));
};
// Apply negative left margin to offset the internal padding of the inline edit component, which will left align the
// read view content with the parent.
const $083550584dd95969$var$containerStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.negative.100',
    paddingRight: 'space.100'
});

});
parcelRegister("cu6dC", function(module, exports) {

$parcel$export(module.exports, "default", () => $73207d410b2845f0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<282de2ab139fec91f0aa05104f82f81e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $73207d410b2845f0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueViewLayoutLabelsSystemField_IssueViewLabelsSystemField",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_issueViewLayoutFieldHeading_IssueViewFieldHeading"
        },
        {
            "kind": "FragmentSpread",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditView"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        }
    ],
    "type": "JiraLabelsField"
};
$73207d410b2845f0$var$node.hash = "e1f7b6cc001e180e790ee53a98317eeb";
var $73207d410b2845f0$export$2e2bcd8739ae039 = $73207d410b2845f0$var$node;

});

parcelRegister("g0FAB", function(module, exports) {

$parcel$export(module.exports, "LabelsInlineEditViewWithIsEditable", () => $d3ad6b714aed8150$export$f00c136eadca5f4b);
$parcel$export(module.exports, "LabelsInlineEditView", () => $d3ad6b714aed8150$export$f066b3edf0d7cd25);

var $l3p7O = parcelRequire("l3p7O");

var $8nik1 = parcelRequire("8nik1");

var $1k6qs = parcelRequire("1k6qs");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $hompL = parcelRequire("hompL");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $646aD = parcelRequire("646aD");

var $iQYHK = parcelRequire("iQYHK");

var $lt1uI = parcelRequire("lt1uI");

var $eGvP7 = parcelRequire("eGvP7");

var $Lrz9s = parcelRequire("Lrz9s");

var $kDarC = parcelRequire("kDarC");

var $duaUt = parcelRequire("duaUt");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $208Ws = parcelRequire("208Ws");

var $121wd = parcelRequire("121wd");
const $d3ad6b714aed8150$var$FIELD_KEY = 'labels';
const $d3ad6b714aed8150$var$FIELD_TYPE = 'labels';
const $d3ad6b714aed8150$export$865a98c44e795d94 = 'field updated';
const $d3ad6b714aed8150$export$1b05898090f57b12 = 'issue-field.save-value';
const $d3ad6b714aed8150$export$3f27bc10068ef877 = `Failed to update field ${$d3ad6b714aed8150$var$FIELD_KEY} of type ${$d3ad6b714aed8150$var$FIELD_TYPE}`;
const $d3ad6b714aed8150$var$transformAggToAtlaskitOption = (connection)=>{
    const labelValues = connection?.edges?.map((edge)=>edge?.node ?? null).filter(Boolean).filter((label)=>label && label.name != null) || [];
    const labelOptions = labelValues.map((label)=>({
            label: label.name || '',
            value: label.name || ''
        }));
    return labelOptions;
};
const $d3ad6b714aed8150$var$transformAtlaskitOptionToAgg = (value)=>({
        totalCount: value.length,
        edges: value.map((label)=>({
                node: {
                    name: label.value
                }
            }))
    });
const $d3ad6b714aed8150$var$transformLabelsOptionsToLabelNames = (value)=>value?.map((labelOption)=>labelOption.value) ?? [];
const $d3ad6b714aed8150$var$transformOptionsOperationsIntoAggOperationInput = (operations)=>operations.map(({ operation: operation, value: value })=>({
            operation: operation,
            labels: $d3ad6b714aed8150$var$transformLabelsOptionsToLabelNames(value)
        }));
const $d3ad6b714aed8150$var$isEqualLabels = (a, b)=>a.length === b.length && a.every((option, index)=>option.label === b[index].label && option.value === b[index].value);
const $d3ad6b714aed8150$export$f00c136eadca5f4b = ({ spacing: spacing = 'compact', baseSearchUrl: baseSearchUrl, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, isTruncated: isTruncated, isEditable: isEditable, menuShouldScrollIntoView: menuShouldScrollIntoView, onCancel: onCancel, onEdit: onEdit, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceededProp, onSubmitFailed: onSubmitFailedProp, fragmentRef: fragmentRef, readViewFitContainerHeight: readViewFitContainerHeight })=>{
    const [{ dirtyValue: dirtyValue, operations: operations }, { onChange: onChange, initializeDirtyValue: initializeDirtyValue }] = (0, $duaUt.useMultiSelectFieldDirtyValueOperations)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const sessionId = (0, $eUqFw.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
    const { overriding: overriding } = (0, $646aD.useInlineEditFieldInjections)();
    const data = (0, $iWLL0.useFragment)((0, $1k6qs.default), fragmentRef);
    const { id: uniqueFieldId, name: fieldNameNoOverrides, fieldId: fieldId, type: type } = data;
    const isFieldEditable = overriding.overrideIsEditable(isEditable);
    const fieldName = overriding.overrideLabel(fieldNameNoOverrides);
    const initialValue = (0, $eUqFw.useMemo)(()=>$d3ad6b714aed8150$var$transformAggToAtlaskitOption(data?.selectedLabelsConnection), [
        data?.selectedLabelsConnection
    ]);
    const [cachedLabels, { addToCache: addToCache }] = (0, $eGvP7.useLabelsCache)(fieldId);
    const [commit] = (0, $iWLL0.useMutation)((0, $8nik1.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const validator = (0, $121wd.useLabelsValidator)();
    const isValueEqual = (0, $eUqFw.useCallback)((a, b)=>operations.length === 0 || $d3ad6b714aed8150$var$isEqualLabels(a, b), [
        operations.length
    ]);
    const onUpdateValue = (0, $eUqFw.useCallback)((value, isInitRequest)=>{
        isInitRequest ? initializeDirtyValue(value) : onChange(value);
    }, [
        initializeDirtyValue,
        onChange
    ]);
    const handleSubmit = (0, $eUqFw.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        const updatedValue = $d3ad6b714aed8150$var$transformLabelsOptionsToLabelNames(value);
        addToCache(updatedValue);
        onSubmit?.(updatedValue);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: $d3ad6b714aed8150$var$transformOptionsOperationsIntoAggOperationInput(operations)
                }
            },
            optimisticResponse: {
                jira: {
                    updateLabelsField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            type: type,
                            fieldId: fieldId,
                            selectedLabelsConnection: $d3ad6b714aed8150$var$transformAtlaskitOptionToAgg(dirtyValue)
                        }
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData?.jira?.updateLabelsField?.success) {
                    onSuccess();
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), $d3ad6b714aed8150$export$865a98c44e795d94, {
                        editOperationType: 'set',
                        fieldKey: $d3ad6b714aed8150$var$FIELD_KEY,
                        fieldType: $d3ad6b714aed8150$var$FIELD_TYPE
                    });
                } else {
                    const errorMessage = mutationData?.jira?.updateLabelsField?.errors?.[0]?.message ?? undefined;
                    onFail(undefined, errorMessage);
                    (0, $gUUjF.default).safeErrorWithoutCustomerData($d3ad6b714aed8150$export$1b05898090f57b12, `Failed to update field ${fieldId} of type ${$d3ad6b714aed8150$var$FIELD_TYPE}`);
                }
            },
            onError (error) {
                onFail(error, error.message);
                (0, $gUUjF.default).safeErrorWithoutCustomerData($d3ad6b714aed8150$export$1b05898090f57b12, `Failed to update field ${fieldId} of type ${$d3ad6b714aed8150$var$FIELD_TYPE}`);
            }
        });
    }, [
        addToCache,
        onSubmit,
        commit,
        uniqueFieldId,
        operations,
        fieldName,
        type,
        fieldId,
        dirtyValue,
        createAnalyticsEvent
    ]);
    const handleSubmitSucceeded = (value)=>{
        // onSubmitSucceededProp expects a list of strings so we must map our updated value accordingly.
        onSubmitSucceededProp?.($d3ad6b714aed8150$var$transformLabelsOptionsToLabelNames(value));
    };
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $iQYHK.useFieldInlineEditActions)({
        fieldId: fieldId,
        fieldName: fieldName,
        initialValue: initialValue,
        isValueEqual: isValueEqual,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitSucceeded: handleSubmitSucceeded,
        onSubmitFailed: onSubmitFailedProp,
        onUpdateValue: onUpdateValue,
        updatedValue: dirtyValue,
        validator: validator
    });
    const renderReadView = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kDarC.LabelsReadView), {
            baseSearchUrl: baseSearchUrl,
            fragmentRef: data,
            isTruncated: isTruncated
        }), [
        baseSearchUrl,
        data,
        isTruncated
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            ariaLabel: fieldName,
            spacing: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? spacing : 'compact',
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            onChange: handleChange,
            value: dirtyValue,
            cachedOptions: cachedLabels,
            nodeIdFragment: data,
            isInvalid: !!invalidMessage,
            sessionId: sessionId.current,
            testId: 'issue-field-labels-inline-edit-view-full.ui.labels.edit-view'
        });
    const editButtonLabelProp = formatMessage((0, $208Ws.default).editButtonLabel, {
        fieldName: fieldName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lt1uI.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $Lrz9s.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        invalidMessage: invalidMessage,
        isEditable: isFieldEditable,
        isEditing: isEditing,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        editButtonLabel: (0, $1ybV0.ff)('nin-priority-inline-edit') ? undefined : editButtonLabelProp,
        hasUnsubmittedChanges: hasServerValidationError
    });
};
const $d3ad6b714aed8150$export$f066b3edf0d7cd25 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $iWLL0.useFragment)(/* eslint-disable jira/relay/graphql-naming */ (0, $l3p7O.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3ad6b714aed8150$export$f00c136eadca5f4b, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("l3p7O", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9eb15c96f678542$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a5d785db9d94536cfc54c642b914993>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a9eb15c96f678542$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditView",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraLabelsField"
};
$a9eb15c96f678542$var$node.hash = "83c0a65ee08db15e69b7b1d990bb3c2d";
var $a9eb15c96f678542$export$2e2bcd8739ae039 = $a9eb15c96f678542$var$node;

});

parcelRegister("8nik1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e73f1347c4c30153$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9bb0575e93c8533025e98bb73dc4fe43>>
 * @relayHash ea7ee9ac60ac57c024a2169042e94286
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a08844dc86fc0196fcda1edddfcd41845486dbaf9718fb0ec5c48c964529c6dc
const $e73f1347c4c30153$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraLabelConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedLabelsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                },
                                                {
                                                    "concreteType": "JiraLabelEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraLabel",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a08844dc86fc0196fcda1edddfcd41845486dbaf9718fb0ec5c48c964529c6dc",
            "metadata": {},
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e73f1347c4c30153$var$node.hash = "b7c0af684826341f4d5d5b319e095b51";
var $e73f1347c4c30153$export$2e2bcd8739ae039 = $e73f1347c4c30153$var$node;

});

parcelRegister("1k6qs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cf3c6262ea6ac5a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<50aa70a6efbfeaaecd5b7acc02d927c1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6cf3c6262ea6ac5a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "labels_issueFieldLabelsReadviewFull_LabelsReadView"
            },
            {
                "kind": "FragmentSpread",
                "name": "labels_issueFieldLabelsEditviewFull_LabelsEditView_nodeIdFragment"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1000
                        }
                    ],
                    "concreteType": "JiraLabelConnection",
                    "kind": "LinkedField",
                    "name": "selectedLabelsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        {
                            "concreteType": "JiraLabelEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraLabel",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v0 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ],
                    "storageKey": "selectedLabelsConnection(first:1000)"
                },
                "action": "THROW",
                "path": "selectedLabelsConnection"
            }
        ],
        "type": "JiraLabelsField"
    };
}();
$6cf3c6262ea6ac5a$var$node.hash = "eb1d78891ab7e5335abb92a0453c8f02";
var $6cf3c6262ea6ac5a$export$2e2bcd8739ae039 = $6cf3c6262ea6ac5a$var$node;

});

parcelRegister("iQYHK", function(module, exports) {

$parcel$export(module.exports, "useFieldInlineEditActions", () => $25fa60d86ba17b12$export$ad535fb3592a66ff);

var $eUqFw = parcelRequire("eUqFw");

var $K1Vl8 = parcelRequire("K1Vl8");

var $eWn2Z = parcelRequire("eWn2Z");
var $kad8r = parcelRequire("kad8r");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $25fa60d86ba17b12$var$defaultIsEquals = (a, b)=>a === b;
const $25fa60d86ba17b12$export$ad535fb3592a66ff = ({ fieldId: fieldId, fieldName: fieldName, initialValue: initialValue, isValueEqual: isValueEqual = $25fa60d86ba17b12$var$defaultIsEquals, onCancel: onCancel, onEdit: onEdit, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, onUpdateValue: onUpdateValue, startWithEditViewOpen: startWithEditViewOpen = false, updatedValue: updatedValue, validator: validator })=>{
    const [isEditing, setIsEditing] = (0, $K1Vl8.useOptionallyControlledEditingState)(startWithEditViewOpen, fieldId, {
        // Ensure our updatedValue is re-initialised if editing is enabled via an external store update
        onSharedChange: (sharedIsEditing)=>sharedIsEditing && onUpdateValue(initialValue, true)
    });
    const [invalidMessage, { validateChange: validateChange, validateSubmit: validateSubmit, clearValidation: clearValidation }] = (0, $eWn2Z.useClientValidationHandler)(validator);
    const [hasServerValidationError, { handleSubmitFailed: handleSubmitFailed, clearServerValidation: clearServerValidation }] = (0, $kad8r.useServerValidationHandler)(fieldName, setIsEditing, onSubmitFailed);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    /** Clear any validation errors and transition to read view. */ const onStopEditing = (0, $eUqFw.useCallback)(()=>{
        clearValidation();
        clearServerValidation();
        setIsEditing(false);
    }, [
        clearServerValidation,
        clearValidation,
        setIsEditing
    ]);
    /** Handler to validate and submit the updated value for a field. */ const handleSubmit = (0, $eUqFw.useCallback)((value, analyticsEvent)=>{
        // Early exit if a validation error is present
        if (validateSubmit(value) === 'error') return;
        onStopEditing();
        // Skip mutation if value is unchanged
        if (isValueEqual(initialValue, value)) return;
        onSubmit(value, {
            onSuccess: ()=>onSubmitSucceeded?.(value),
            onFail: (error, message)=>{
                handleSubmitFailed(error, message);
                onSubmitFailed?.();
            }
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        handleSubmitFailed,
        initialValue,
        isValueEqual,
        onStopEditing,
        onSubmit,
        onSubmitFailed,
        onSubmitSucceeded,
        validateSubmit
    ]);
    /** Exits `editView` and switches back to `readView`. This is called when the cancel action button (x) is clicked. */ const handleCancel = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        onStopEditing();
        onCancel?.();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        onCancel,
        onStopEditing
    ]);
    /** Handler called when readView is clicked. */ const handleEdit = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        // Re-initialise the edit view value unless there is a server error, in which case we want to preserve the
        // previous dirty value.
        if (!hasServerValidationError) onUpdateValue(initialValue, true);
        setIsEditing(true);
        onEdit?.();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        hasServerValidationError,
        initialValue,
        onEdit,
        setIsEditing,
        onUpdateValue
    ]);
    /** Saves and confirms the value entered into the field. It exits `editView` and returns to `readView`. */ const handleConfirm = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        handleSubmit(updatedValue, analyticsEvent);
    }, [
        handleSubmit,
        updatedValue
    ]);
    /**
	 * Handler called when the `editView` is updated by the user. This will validate the input and call
	 * `onUpdateValue` to update the value in state.
	 */ const handleChange = (0, $eUqFw.useCallback)((value)=>{
        validateChange(value);
        onUpdateValue(value, false);
    }, [
        onUpdateValue,
        validateChange
    ]);
    /**
	 * Handler called when the `editView` is updated by the user which will immediately confirm the value and return to
	 * `readView`.
	 *
	 * Note that this **will not** run any `change` validator functions. Consumers should instead define a `submit`
	 * validator function if required.
	 */ const handleChangeAndConfirm = (0, $eUqFw.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'confirmed',
            actionSubject: 'inlineEdit'
        });
        onUpdateValue(value, false);
        handleSubmit(value, analyticsEvent);
    }, [
        createAnalyticsEvent,
        handleSubmit,
        onUpdateValue
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            handleCancel: handleCancel,
            handleEdit: handleEdit,
            handleConfirm: handleConfirm,
            handleChange: handleChange,
            handleChangeAndConfirm: handleChangeAndConfirm,
            hasServerValidationError: hasServerValidationError,
            invalidMessage: invalidMessage,
            isEditing: isEditing
        }), [
        handleCancel,
        handleChange,
        handleChangeAndConfirm,
        handleConfirm,
        handleEdit,
        hasServerValidationError,
        invalidMessage,
        isEditing
    ]);
};

});
parcelRegister("eWn2Z", function(module, exports) {

$parcel$export(module.exports, "useClientValidationHandler", () => $bb11b6854e1deca8$export$f57c10638969fb77);

var $eUqFw = parcelRequire("eUqFw");
/** Return an `ValidationStatus` for a given validation message. */ const $bb11b6854e1deca8$var$getValidationStatus = (message)=>message ? message.type : 'success';
// Priority order for ValidationStatus. Higher value = higher priority.
const $bb11b6854e1deca8$var$invalidStatusPriority = {
    success: 0,
    warning: 1,
    error: 2
};
/**
 * Return the higher priority message of `messageA` and `messageB`. If the priority is equal then `messageA` will be
 * returned.
 */ const $bb11b6854e1deca8$var$getHigherPriorityMessage = (messageA, messageB)=>{
    const statusA = $bb11b6854e1deca8$var$getValidationStatus(messageA);
    const statusB = $bb11b6854e1deca8$var$getValidationStatus(messageB);
    return $bb11b6854e1deca8$var$invalidStatusPriority[statusA] >= $bb11b6854e1deca8$var$invalidStatusPriority[statusB] ? messageA : messageB;
};
const $bb11b6854e1deca8$export$f57c10638969fb77 = (validator)=>{
    const [invalidMessage, setInvalidMessage] = (0, $eUqFw.useState)(null);
    const { change: change, submit: submit } = validator ?? {};
    const validateChange = (0, $eUqFw.useCallback)((value)=>{
        // If no change validator is defined then the value is considered valid
        const message = change ? change(value) : null;
        setInvalidMessage(message);
        return $bb11b6854e1deca8$var$getValidationStatus(message);
    }, [
        change
    ]);
    const validateSubmit = (0, $eUqFw.useCallback)((value)=>{
        // If no submit validator is defined then the value is considered valid
        const message = submit ? submit(value) : null;
        // Only update the existing invalid state if a higher priority message is returned
        const higherPriorityMessage = $bb11b6854e1deca8$var$getHigherPriorityMessage(message, invalidMessage);
        setInvalidMessage(higherPriorityMessage);
        return $bb11b6854e1deca8$var$getValidationStatus(higherPriorityMessage);
    }, [
        invalidMessage,
        submit
    ]);
    const clearValidation = (0, $eUqFw.useCallback)(()=>setInvalidMessage(null), []);
    const actions = (0, $eUqFw.useMemo)(()=>({
            validateChange: validateChange,
            validateSubmit: validateSubmit,
            clearValidation: clearValidation
        }), [
        clearValidation,
        validateChange,
        validateSubmit
    ]);
    return [
        invalidMessage,
        actions
    ];
};

});

parcelRegister("kad8r", function(module, exports) {

$parcel$export(module.exports, "useServerValidationHandler", () => $02b13c1c1eacd26c$export$1bf5fbbc94f09320);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $gXvwG = parcelRequire("gXvwG");
const $02b13c1c1eacd26c$export$1bf5fbbc94f09320 = (fieldName, setIsEditing, onSubmitFailed)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { dismissFlag: dismissFlag, showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [hasServerValidationError, setHasServerValidationError] = (0, $eUqFw.useState)(false);
    const handleSubmitFailed = (0, $eUqFw.useCallback)((error, message)=>{
        setHasServerValidationError(true);
        const flagId = showFlag({
            type: 'error',
            title: formatMessage((0, $gXvwG.default).submitFailedTitle, {
                fieldName: fieldName
            }),
            description: message ?? formatMessage((0, $gXvwG.default).submitFailedDescription),
            actions: [
                {
                    content: (0, $gXvwG.default).submitFailedTryAgain,
                    onClick: ()=>{
                        setIsEditing(true);
                        flagId && dismissFlag(flagId);
                    }
                }
            ]
        });
        (0, $guiFP.default)({
            meta: {
                id: 'serverValidationHandler',
                packageName: 'jiraIssueFieldValidationHandler',
                teamName: 'empanada'
            },
            event: createAnalyticsEvent({}),
            error: error,
            attributes: {
                fieldName: fieldName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        onSubmitFailed?.();
    }, [
        dismissFlag,
        fieldName,
        formatMessage,
        onSubmitFailed,
        setIsEditing,
        showFlag,
        createAnalyticsEvent
    ]);
    const clearServerValidation = (0, $eUqFw.useCallback)(()=>setHasServerValidationError(false), []);
    return (0, $eUqFw.useMemo)(()=>[
            hasServerValidationError,
            {
                handleSubmitFailed: handleSubmitFailed,
                clearServerValidation: clearServerValidation
            }
        ], [
        hasServerValidationError,
        handleSubmitFailed,
        clearServerValidation
    ]);
};

});
parcelRegister("gXvwG", function(module, exports) {

$parcel$export(module.exports, "default", () => $441a05b2892cd52e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $441a05b2892cd52e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    submitFailedTitle: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-title",
        "defaultMessage": "We couldn\u2019t update {fieldName}"
    },
    submitFailedDescription: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-description",
        "defaultMessage": "You can try again in a few minutes, or refresh the page."
    },
    submitFailedTryAgain: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-try-again",
        "defaultMessage": "Try editing the field again"
    }
});

});



parcelRegister("lt1uI", function(module, exports) {

$parcel$export(module.exports, "FieldInlineEditLiteWithEntryPoint", () => $bd286e1dc392b3da$export$d14ba912eb773f8d);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $l3Qg0 = parcelRequire("l3Qg0");

var $1HzcR = parcelRequire("1HzcR");

var $1ybV0 = parcelRequire("1ybV0");

var $7gTIL = parcelRequire("7gTIL");

var $4wT8s = parcelRequire("4wT8s");
var $4WtbX = parcelRequire("4WtbX");
const $bd286e1dc392b3da$export$d14ba912eb773f8d = ({ editViewEntryPoint: editViewEntryPoint, editViewEntryPointParams: editViewEntryPointParams, getEditViewProps: getEditViewProps, ...props })=>{
    const { hideEditButton: hideEditButton, isEditable: isEditable, isEditing: isEditing, readView: readView, readViewFitContainerHeight: readViewFitContainerHeight } = props;
    // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)(editViewEntryPoint, editViewEntryPointParams);
    const readViewTrigger = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions);
    (0, $eUqFw.useEffect)(()=>{
        // This component can be mounted in an editing state or toggled externally, so we need to ensure the entrypoint
        // is always explicitly loaded when entering edit view.
        if (isEditing) entryPointActions.load();
    }, [
        isEditing,
        entryPointActions
    ]);
    const renderEditView = (fieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "editView",
            packageName: "jiraIssueFieldInlineEditLite",
            fallback: (0, $1ybV0.ff)('one-issue-table-inline-edit-lite-api-changes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4WtbX.ReadViewNonEditable), {
                hideEditButton: hideEditButton,
                isLoading: true,
                readViewFitContainerHeight: readViewFitContainerHeight
            }, readView()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7gTIL.InlineEditReadViewContainerOld), {
                hideEditButton: hideEditButton,
                isLoading: true,
                readViewFitContainerHeight: readViewFitContainerHeight
            }, readView()),
            runtimeProps: getEditViewProps(fieldProps)
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4wT8s.default), {
        ...props,
        readViewContainerRef: isEditable ? readViewTrigger : undefined,
        editView: renderEditView
    });
};

});
parcelRegister("7gTIL", function(module, exports) {

$parcel$export(module.exports, "InlineEditReadViewContainerOld", () => $3f67180b8fa733ef$export$c485c84f6d88c745);
$parcel$export(module.exports, "default", () => $3f67180b8fa733ef$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $dG2h0 = parcelRequire("dG2h0");

var $4Bees = parcelRequire("4Bees");

var $1ybV0 = parcelRequire("1ybV0");

var $85gCA = parcelRequire("85gCA");
var $5lEkL = parcelRequire("5lEkL");
const $3f67180b8fa733ef$export$c485c84f6d88c745 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ containerProps: containerProps, editButtonProps: editButtonProps, readViewFitContainerHeight: readViewFitContainerHeight = false, hideEditButton: hideEditButton = true, isLoading: isLoading = false, isInvalid: isInvalid = false, children: children }, ref)=>{
    const [isHiddenButtonFocused, setIsHiddenButtonFocused] = (0, $eUqFw.useState)(false);
    // Button focus could be implemented more cleanly with :has pseudo-selector once supported in Firefox (currently in
    // preview https://developer.mozilla.org/en-US/docs/Web/CSS/:has#browser_compatibility)
    const isFocusRingVisible = isHiddenButtonFocused || isLoading;
    let buttonBefore = null;
    let buttonAfter = null;
    if (editButtonProps) {
        if (hideEditButton) {
            const { label: label, ref: editButtonRef, ...rest } = editButtonProps;
            buttonBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f67180b8fa733ef$var$HiddenButton, {
                ...rest,
                ref: (buttonRef)=>{
                    editButtonRef.current = buttonRef;
                },
                "aria-label": label,
                onFocus: ()=>setIsHiddenButtonFocused(true),
                onBlur: ()=>setIsHiddenButtonFocused(false)
            });
        } else {
            const { label: label, ...rest } = editButtonProps;
            buttonAfter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...rest,
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dG2h0))), {
                    label: label,
                    primaryColor: "var(--ds-icon, #44546F)"
                }),
                spacing: "none",
                // In future providing CSS variables *may* be something that makes its way into the design
                // system, but for now this is an acceptable override to prevent managing this state with JS
                // given styles are co-located. More context here https://atlassian.slack.com/archives/C060GTVV988/p1703214250865779?thread_ts=1703212675.166419&cid=C060GTVV988
                /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: $3f67180b8fa733ef$var$editButtonStyles,
                interactionName: "auto-generated.jira-issue-field-inline-edit-read-view-container.ui.button"
            });
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f67180b8fa733ef$var$Container, {
        ...containerProps,
        "data-testid": "issue-field-inline-edit-read-view-container.ui.container",
        readViewFitContainerHeight: readViewFitContainerHeight,
        hideEditButton: hideEditButton,
        isEditable: !!editButtonProps,
        isFocusRingVisible: isFocusRingVisible,
        isInvalid: isInvalid,
        ref: ref
    }, buttonBefore, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f67180b8fa733ef$var$LoadingOverlay, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f67180b8fa733ef$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null))) : children, buttonAfter);
});
/**
 * This component is designed to be rendered within the `readView` of a `FieldInlineEditLite` component. This can be
 * rendered in a 'read-only' layout by omitting the `context` prop which is provided by `useInlineEdit` in
 * `@atlassian/jira-inline-edit-lite`. This ensures consistent spacing for consumers when a field is conditionally
 * editable.
 */ const $3f67180b8fa733ef$var$InlineEditReadViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, context: context, editButtonLabel: editButtonLabel, editButtonRef: editButtonRef, hideEditButton: hideEditButton = true, isEditButtonFocused: isEditButtonFocused = false, isLoading: isLoading = false, isInvalid: isInvalid = false, onClick: onClick, onMouseDown: onMouseDown, onEditButtonBlur: onEditButtonBlur, onEditButtonFocus: onEditButtonFocus, readViewFitContainerHeight: readViewFitContainerHeight = false }, ref)=>{
    const isHiddenButtonFocused = hideEditButton && isEditButtonFocused;
    const isFocusRingVisible = isHiddenButtonFocused || isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f67180b8fa733ef$var$Container, {
        "data-testid": "issue-field-inline-edit-read-view-container.ui.container",
        readViewFitContainerHeight: readViewFitContainerHeight,
        hideEditButton: hideEditButton,
        isEditable: !!context,
        isFocusRingVisible: isFocusRingVisible,
        isInvalid: isInvalid,
        onClick: onClick,
        onMouseDown: onMouseDown,
        role: "presentation",
        ref: ref
    }, hideEditButton && context && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5lEkL.EditButtonHidden), {
        ref: editButtonRef,
        context: context,
        label: editButtonLabel,
        onBlur: onEditButtonBlur,
        onFocus: onEditButtonFocus
    }), isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f67180b8fa733ef$var$LoadingOverlay, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f67180b8fa733ef$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null))) : children, !hideEditButton && context && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85gCA.EditButton), {
        ref: editButtonRef,
        context: context,
        label: editButtonLabel,
        onBlur: onEditButtonBlur,
        onFocus: onEditButtonFocus,
        // In future providing CSS variables *may* be something that makes its way into the design system, but
        // for now this is an acceptable override to prevent managing additional state with JS.
        // More context here https://atlassian.slack.com/archives/C060GTVV988/p1703214250865779?thread_ts=1703212675.166419&cid=C060GTVV988
        /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: $3f67180b8fa733ef$var$editButtonStyles
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f67180b8fa733ef$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { readViewFitContainerHeight: readViewFitContainerHeight, hideEditButton: hideEditButton, isEditable: isEditable, isFocusRingVisible: isFocusRingVisible, isInvalid: isInvalid, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_189eyh40 _1dqonqa1 _2rko1sit _1yt41cy0 _1e0c1txw _zulpu2gc _4cvr1h6o _vchhusvi _p12f1osq _kqswh2mm",
            __cmplp.readViewFitContainerHeight ? "_1tke1osq" : "_1tkezwfg",
            !__cmplp.hideEditButton && !__cmplp.isEditable && "_u5f3auvx",
            __cmplp.isEditable && "_v56412tl _yyosidpf _irr3k6hx _37uft94y _1rr4t94y",
            __cmplp.isFocusRingVisible && "_1h6d1l4g",
            __cmplp.isInvalid && !__cmplp.isFocusRingVisible && "_1h6d16c1",
            !__cmplp.isInvalid && !__cmplp.isFocusRingVisible && "_1h6d3acm",
            (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && "_1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $3f67180b8fa733ef$var$HiddenButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});
const $3f67180b8fa733ef$var$editButtonStyles = {
    flexShrink: 0,
    marginLeft: 'auto',
    opacity: 'var(--edit-button-opacity, 1)'
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f67180b8fa733ef$var$LoadingOverlay = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_lcxvglyw _tzy4n2vs",
            __cmplp.className
        ])
    });
});
const $3f67180b8fa733ef$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltv1ssb _154i1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
var $3f67180b8fa733ef$export$2e2bcd8739ae039 = $3f67180b8fa733ef$var$InlineEditReadViewContainer;

});
parcelRegister("dG2h0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f50f60bfaf41385$var$_react = $9f50f60bfaf41385$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9f50f60bfaf41385$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9f50f60bfaf41385$var$EditorEditIcon = (props)=>/*#__PURE__*/ $9f50f60bfaf41385$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M15.148 6.852a.502.502 0 01.708.004l2.288 2.288a.5.5 0 01.004.708L11 17l-3-3 7.148-7.148zM7 15l3 3-3.51.877c-.27.068-.436-.092-.367-.367L7 15z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$9f50f60bfaf41385$var$EditorEditIcon.displayName = 'EditorEditIcon';
var $9f50f60bfaf41385$var$_default = $9f50f60bfaf41385$var$EditorEditIcon;
module.exports.default = $9f50f60bfaf41385$var$_default;

});

parcelRegister("85gCA", function(module, exports) {

$parcel$export(module.exports, "EditButton", () => $fc008bf6b5060480$export$a8d3280cb45e38b8);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $dG2h0 = parcelRequire("dG2h0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8Ul0j = parcelRequire("8Ul0j");
const $fc008bf6b5060480$export$a8d3280cb45e38b8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ context: { onEdit: onEdit }, label: label, onBlur: onBlur, onFocus: onFocus, style: style }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const finalEditButtonLabel = label ?? formatMessage((0, $8Ul0j.default).editButtonLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dG2h0))), {
            label: finalEditButtonLabel,
            primaryColor: "var(--ds-icon, #44546F)"
        }),
        onClick: onEdit,
        onBlur: onBlur,
        onFocus: onFocus,
        ref: ref,
        spacing: "none",
        // In future providing CSS variables *may* be something that makes its way into the design system, but
        // for now this is an acceptable override to prevent managing additional state with JS.
        // More context here https://atlassian.slack.com/archives/C060GTVV988/p1703214250865779?thread_ts=1703212675.166419&cid=C060GTVV988
        /* eslint-disable-next-line jira/react/no-style-attribute */ style: style
    });
});

});
parcelRegister("8Ul0j", function(module, exports) {

$parcel$export(module.exports, "default", () => $68297121971faf6b$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $68297121971faf6b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    editButtonLabel: {
        "id": "inline-edit-lite.read-view.edit-button-label",
        "defaultMessage": "Edit"
    },
    confirmButtonLabel: {
        "id": "inline-edit-lite.edit-view.confirm-button-label",
        "defaultMessage": "Confirm"
    },
    cancelButtonLabel: {
        "id": "inline-edit-lite.edit-view.cancel-button-label",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("5lEkL", function(module, exports) {

$parcel$export(module.exports, "EditButtonHidden", () => $5641dc670f4406aa$export$c2bd955fafbef8bc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8Ul0j = parcelRequire("8Ul0j");
const $5641dc670f4406aa$export$c2bd955fafbef8bc = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ context: { onEdit: onEdit }, label: label, onBlur: onBlur, onFocus: onFocus }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const finalEditButtonLabel = label ?? formatMessage((0, $8Ul0j.default).editButtonLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5641dc670f4406aa$var$HiddenButton, {
        "aria-label": finalEditButtonLabel,
        onBlur: onBlur,
        onFocus: onFocus,
        onClick: onEdit,
        ref: ref,
        type: "button"
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5641dc670f4406aa$var$HiddenButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("4wT8s", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e2e2ee0756f89b5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ReadViewNonEditable", () => (parcelRequire("4WtbX")).ReadViewNonEditable);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $gFqVk = parcelRequire("gFqVk");
var $9eOMO = parcelRequire("9eOMO");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7gTIL = parcelRequire("7gTIL");

var $hBJVp = parcelRequire("hBJVp");

var $aHoRv = parcelRequire("aHoRv");

var $9svzR = parcelRequire("9svzR");

var $bMLK2 = parcelRequire("bMLK2");

var $4WtbX = parcelRequire("4WtbX");
// Fallback placements to be used for the validation popover if it overflows its clipping parent
const $3e2e2ee0756f89b5$var$fallbackPlacements = [
    'left',
    'top-start',
    'auto'
];
/**
 * Wrapper component around `InlineEditLite` which provides consistent spacing and validation UX for issue fields.
 */ const $3e2e2ee0756f89b5$var$FieldInlineEditLiteOld = ({ editView: editView, fieldName: fieldName, hasUnsubmittedChanges: hasUnsubmittedChanges, hideEditButton: hideEditButton, invalidMessage: invalidMessage, isEditable: isEditable, onConfirm: onConfirm, readViewFitContainerHeight: readViewFitContainerHeight, readViewContainerRef: readViewContainerRef, readView: readView, confirmButtonLabel: confirmButtonLabelProp, cancelButtonLabel: cancelButtonLabelProp, editButtonLabel: editButtonLabelProp, ...inlineEditLiteProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderReadView = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7gTIL.InlineEditReadViewContainerOld), {
            containerProps: props?.containerProps,
            editButtonProps: props?.editButtonProps,
            hideEditButton: hideEditButton,
            ref: readViewContainerRef,
            // Highlight the field as invalid to notify the user if there was an error attempting to submit changes.
            isInvalid: hasUnsubmittedChanges,
            readViewFitContainerHeight: readViewFitContainerHeight
        }, readView());
    const renderEditView = ({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hBJVp.default), {
            fieldId: id,
            message: invalidMessage,
            trigger: (triggerProps)=>editView(triggerProps),
            placement: "right",
            fallbackPlacements: $3e2e2ee0756f89b5$var$fallbackPlacements
        });
    const handleConfirm = (0, $eUqFw.useCallback)((_, analyticsEvent)=>onConfirm(analyticsEvent), [
        onConfirm
    ]);
    if (!isEditable) return renderReadView();
    let confirmButtonLabel = confirmButtonLabelProp;
    let cancelButtonLabel = cancelButtonLabelProp;
    let editButtonLabel = editButtonLabelProp;
    if ((0, $1ybV0.ff)('nin-priority-inline-edit')) {
        confirmButtonLabel = confirmButtonLabelProp ?? formatMessage((0, $9svzR.default).confirmButtonLabel, {
            fieldName: fieldName
        });
        cancelButtonLabel = cancelButtonLabelProp ?? formatMessage((0, $9svzR.default).cancelButtonLabel, {
            fieldName: fieldName
        });
        editButtonLabel = editButtonLabelProp ?? formatMessage((0, $9svzR.default).editButtonLabel, {
            fieldName: fieldName
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gFqVk.default), {
        ...inlineEditLiteProps,
        editView: renderEditView,
        onConfirm: handleConfirm,
        readView: renderReadView,
        confirmButtonLabel: confirmButtonLabel,
        cancelButtonLabel: cancelButtonLabel,
        editButtonLabel: editButtonLabel
    });
};
/**
 * Component leveraging `@atlassian/jira-inline-edit-lite` to provide consistent spacing and validation UX for issue
 * fields.
 */ const $3e2e2ee0756f89b5$var$FieldInlineEditLite = ({ editView: editView, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupMinWidth: editViewPopupMinWidth, fieldName: fieldName, hasUnsubmittedChanges: hasUnsubmittedChanges, hideActionButtons: hideActionButtons, hideEditButton: hideEditButton, invalidMessage: invalidMessage, isEditable: isEditable, isEditing: isEditing, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur, onCancel: onCancel, onConfirm: onConfirm, onEdit: onEdit, readViewFitContainerHeight: readViewFitContainerHeight, readViewContainerRef: readViewContainerRef, readView: readView, confirmButtonLabel: confirmButtonLabelProp, cancelButtonLabel: cancelButtonLabelProp, editButtonLabel: editButtonLabelProp })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { context: context, refs: refs } = (0, $9eOMO.useInlineEdit)({
        isEditing: isEditing,
        onCancel: onCancel,
        onConfirm: onConfirm,
        onEdit: onEdit
    });
    const confirmButtonLabel = confirmButtonLabelProp ?? formatMessage((0, $9svzR.default).confirmButtonLabel, {
        fieldName: fieldName
    });
    const cancelButtonLabel = cancelButtonLabelProp ?? formatMessage((0, $9svzR.default).cancelButtonLabel, {
        fieldName: fieldName
    });
    const editButtonLabel = editButtonLabelProp ?? formatMessage((0, $9svzR.default).editButtonLabel, {
        fieldName: fieldName
    });
    if (!isEditable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4WtbX.ReadViewNonEditable), {
        hideEditButton: hideEditButton,
        readViewFitContainerHeight: readViewFitContainerHeight
    }, readView());
    if (isEditing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aHoRv.EditView), {
        cancelButtonLabel: cancelButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        context: context,
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: editViewPopupMinWidth,
        hideActionButtons: hideActionButtons,
        keepEditViewOpenOnBlur: keepEditViewOpenOnBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hBJVp.default), {
        message: invalidMessage,
        trigger: (triggerProps)=>editView(triggerProps),
        placement: "right",
        fallbackPlacements: $3e2e2ee0756f89b5$var$fallbackPlacements
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bMLK2.ReadView), {
        context: context,
        editButtonLabel: editButtonLabel,
        editButtonRef: refs.editButton,
        hideEditButton: hideEditButton,
        isInvalid: hasUnsubmittedChanges,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readViewContainerRef: readViewContainerRef
    }, readView());
};
var $3e2e2ee0756f89b5$export$2e2bcd8739ae039 = (0, $bAQOb.componentWithFF)('one-issue-table-inline-edit-lite-api-changes', $3e2e2ee0756f89b5$var$FieldInlineEditLite, $3e2e2ee0756f89b5$var$FieldInlineEditLiteOld);

});
parcelRegister("gFqVk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f018e8dc06aa52b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $fBdxv = parcelRequire("fBdxv");

var $iKcHV = parcelRequire("iKcHV");

var $3dXZF = parcelRequire("3dXZF");

var $85gCA = parcelRequire("85gCA");

var $5lEkL = parcelRequire("5lEkL");

var $9YNWW = parcelRequire("9YNWW");

var $9eOMO = parcelRequire("9eOMO");

var $clnSX = parcelRequire("clnSX");
const $5f018e8dc06aa52b$var$actionSubject = 'inlineEdit';
/**
 * This component is a lightweight alternative to `@atlaskit/inline-edit` that is suitable to use in experiences with
 * **many** inline edit components rendered concurrently, e.g. in a table-based layout. The main advantage of this
 * alternative is that it doesn't render any additional DOM elements while in the read view, whereas by default
 * `@atlaskit/inline-edit` renders 4 wrapper elements, including an `@atlaskit/form` field which can lead to performance
 * regression if used heavily throughout the UI.
 *
 * In addition, there are some minor changes to the component API that allow more flexibility/responsibility from the
 * consumer when rendering, key changes are:
 * - Stateless `isEditing` - `isEditing` is a controlled-only prop that must always be provided by the consumer.
 * - No label - Any form labels present in the UI must be rendered manually in the `readView`/`editView` components.
 * - Read view accessibility - Consumers must render their own buttons and wrapper elements as needed to construct an
 * accessible UI. Note that the `readView` prop now accepts an additional argument that includes props the consumer can
 * spread onto the underlying DOM elements to provide an accessible experience.
 *
 * Further optimisations could be made, specifically in the `editView` path, to achieve a lighter bundle, e.g.
 * entrypoints (load on intent), making form rendering a consumer responsibility etc. However, these are considered less
 * impactful on page rendering performance as most use cases will render the `readView` by default, therefore it's
 * currently out of scope of this component.
 *
 * **Note** - Adopters should prefer `@atlaskit/inline-edit` for the most up to date and platform-friendly solution, and
 * should only consider adopting this component if they've explicitly identified a negative impact on performance from
 * the design system solution.
 */ function $5f018e8dc06aa52b$var$InlineEditLite(props) {
    const { cancelButtonLabel: cancelButtonLabel, confirmButtonLabel: confirmButtonLabel, defaultValue: defaultValue, editButtonLabel: editButtonLabel, editView: editView, hideActionButtons: hideActionButtons, isEditing: isEditing, isRequired: isRequired, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur, onCancel: onCancel, onConfirm: onConfirm, onEdit: onEdit, readView: readView, validate: validate } = props;
    const { editButtonRef: editButtonRef, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $3dXZF.default)(isEditing);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onCancelRequest = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'canceled',
            actionSubject: $5f018e8dc06aa52b$var$actionSubject
        });
        onCancel(analyticsEvent);
    }, [
        createAnalyticsEvent,
        onCancel
    ]);
    const onConfirmRequest = (0, $eUqFw.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'confirmed',
            actionSubject: $5f018e8dc06aa52b$var$actionSubject
        });
        onConfirm(value, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onConfirm
    ]);
    const onEditRequest = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'focused',
            actionSubject: $5f018e8dc06aa52b$var$actionSubject
        });
        onEdit(analyticsEvent);
    }, [
        createAnalyticsEvent,
        onEdit
    ]);
    if (isEditing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fBdxv.default), {
        cancelButtonLabel: cancelButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        defaultValue: defaultValue,
        editView: editView,
        hideActionButtons: hideActionButtons,
        isRequired: isRequired,
        keepEditViewOpenOnBlur: keepEditViewOpenOnBlur,
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onDoNotFocusOnEditButton: doNotFocusOnEditButton,
        validate: validate
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKcHV.default), {
        editButtonLabel: editButtonLabel,
        editButtonRef: editButtonRef,
        onEdit: onEditRequest,
        postReadViewClick: doNotFocusOnEditButton,
        readView: readView
    });
}
var $5f018e8dc06aa52b$export$2e2bcd8739ae039 = $5f018e8dc06aa52b$var$InlineEditLite;

});
parcelRegister("fBdxv", function(module, exports) {

$parcel$export(module.exports, "default", () => $93f00aa807a1b55b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4LhB6 = parcelRequire("4LhB6");

var $lzLxZ = parcelRequire("lzLxZ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8Ul0j = parcelRequire("8Ul0j");

var $hk8L2 = parcelRequire("hk8L2");
function $93f00aa807a1b55b$var$EditView(props) {
    const { confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, defaultValue: defaultValue, onDoNotFocusOnEditButton: onDoNotFocusOnEditButton, editView: editView, hideActionButtons: hideActionButtons, isRequired: isRequired, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur, onCancel: onCancel, onConfirm: onConfirm, validate: validate } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const editViewRef = (0, $eUqFw.useRef)(null);
    const wasFocusReceivedSinceLastBlurRef = (0, $eUqFw.useRef)(false);
    const timerRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        editViewRef.current?.focus();
    }, [
        editViewRef
    ]);
    const tryAutoSubmitWhenBlur = (0, $eUqFw.useCallback)((isFormInvalid, onSubmit, formRef)=>{
        if (!isFormInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            onDoNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        onDoNotFocusOnEditButton
    ]);
    /** If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
   *  confirms the value, if the focus is not transferred to the action buttons
   *
   *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
   *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
   *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
   *  `autoSubmitWhenBlur`.
   *
   *  There are two paths here the function can be triggered:
   *
   *  - focus on input first, and then use keyboard to `submit`
   *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save)
   */ const onEditViewWrapperBlur = (0, $eUqFw.useCallback)((isFormInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFormInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /** Gets called when focus is transferred to the editView, or action buttons
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field
                                                        */ 
    const onEditViewWrapperFocus = (0, $eUqFw.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const onCancelClick = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit)
    }, ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
            /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ role: "presentation",
            onKeyDown: (e)=>{
                onKeyDown(e);
                if (e.key === 'Esc' || e.key === 'Escape') onCancel();
            },
            onSubmit: onSubmit,
            ref: formRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
            name: "inlineEdit",
            defaultValue: defaultValue,
            validate: validate,
            isRequired: isRequired,
            key: "edit-view" // used for reset to default value
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($93f00aa807a1b55b$var$EditViewWrapper, {
                onBlur: ()=>{
                    onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                },
                onFocus: onEditViewWrapperFocus
            }, editView({
                ...fieldProps,
                errorMessage: error
            }, editViewRef), !hideActionButtons ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hk8L2.default), {
                cancelButtonLabel: cancelButtonLabel ?? formatMessage((0, $8Ul0j.default).cancelButtonLabel),
                confirmButtonLabel: confirmButtonLabel ?? formatMessage((0, $8Ul0j.default).confirmButtonLabel),
                onMouseDown: onDoNotFocusOnEditButton,
                onCancelClick: onCancelClick
            }) : /** This is to allow Ctrl + Enter to submit without action buttons */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
                hidden: true,
                type: "submit",
                "aria-label": "Submit"
            })))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $93f00aa807a1b55b$var$EditViewWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkx0bf _p12f1osq _kqswh2mm",
            __cmplp.className
        ])
    });
});
var $93f00aa807a1b55b$export$2e2bcd8739ae039 = $93f00aa807a1b55b$var$EditView;

});
parcelRegister("hk8L2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8768653ac0f1c81c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $9nt1B = parcelRequire("9nt1B");

var $jWuk1 = parcelRequire("jWuk1");
const $8768653ac0f1c81c$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8768653ac0f1c81c$var$ButtonsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8768653ac0f1c81c$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": confirmButtonLabel,
        type: "submit",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
            label: confirmButtonLabel,
            size: "small"
        }),
        shouldFitContainer: true,
        onMouseDown: onMouseDown
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8768653ac0f1c81c$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": cancelButtonLabel,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: cancelButtonLabel,
            size: "small"
        }),
        onClick: onCancelClick,
        shouldFitContainer: true,
        onMouseDown: onMouseDown
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8768653ac0f1c81c$var$ButtonsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1pfh12x7 _kqswstnw _152t1osq _rjxpidpf _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $8768653ac0f1c81c$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _2rko1sit _1wybdlk8 _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z",
            __cmplp.className
        ])
    });
});
var $8768653ac0f1c81c$export$2e2bcd8739ae039 = $8768653ac0f1c81c$var$Buttons;

});


parcelRegister("iKcHV", function(module, exports) {

$parcel$export(module.exports, "default", () => $354859a7de9c6823$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8Ul0j = parcelRequire("8Ul0j");
const $354859a7de9c6823$var$DRAG_THRESHOLD = 5;
const $354859a7de9c6823$var$isLinkOrButton = (element)=>element.closest('a') != null || element.closest('button') != null;
const $354859a7de9c6823$var$ReadView = ({ editButtonLabel: editButtonLabel, editButtonRef: editButtonRef, onEdit: onEdit, postReadViewClick: postReadViewClick, readView: readView })=>{
    const startX = (0, $eUqFw.useRef)(0);
    const startY = (0, $eUqFw.useRef)(0);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const mouseHasMovedAfterMouseDown = (0, $eUqFw.useCallback)((event)=>Math.abs(startX.current - event.clientX) >= $354859a7de9c6823$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $354859a7de9c6823$var$DRAG_THRESHOLD, []);
    const onReadViewClick = (0, $eUqFw.useCallback)((event)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const element = event.target;
        /** If a link or button is clicked in the read view, default action should be taken */ if (!$354859a7de9c6823$var$isLinkOrButton(element) && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEdit();
            postReadViewClick();
        }
    }, [
        mouseHasMovedAfterMouseDown,
        onEdit,
        postReadViewClick
    ]);
    const containerProps = (0, $eUqFw.useMemo)(()=>({
            /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embedded in inline-edit is for another day...)
     */ role: 'presentation',
            onClick: onReadViewClick,
            onMouseDown: (e)=>{
                startX.current = e.clientX;
                startY.current = e.clientY;
            }
        }), [
        onReadViewClick
    ]);
    const editButtonProps = (0, $eUqFw.useMemo)(()=>({
            label: editButtonLabel ?? formatMessage((0, $8Ul0j.default).editButtonLabel),
            type: 'button',
            onClick: onEdit,
            ref: editButtonRef
        }), [
        editButtonLabel,
        editButtonRef,
        formatMessage,
        onEdit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, readView({
        containerProps: containerProps,
        editButtonProps: editButtonProps
    }));
};
var $354859a7de9c6823$export$2e2bcd8739ae039 = $354859a7de9c6823$var$ReadView;

});

parcelRegister("3dXZF", function(module, exports) {

$parcel$export(module.exports, "default", () => $41d7033bcd8721a8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hzcvF = parcelRequire("hzcvF");
const $41d7033bcd8721a8$var$useButtonFocusHook = (isEditing)=>{
    const editButtonRef = (0, $eUqFw.useRef)(null);
    const preventFocusOnEditButtonRef = (0, $eUqFw.useRef)(false);
    const prevIsEditing = (0, $hzcvF.usePrevious)(isEditing);
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !isEditing) {
            if (preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        isEditing
    ]);
    const doNotFocusOnEditButton = ()=>{
        preventFocusOnEditButtonRef.current = true;
    };
    return {
        editButtonRef: editButtonRef,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $41d7033bcd8721a8$export$2e2bcd8739ae039 = $41d7033bcd8721a8$var$useButtonFocusHook;

});

parcelRegister("9YNWW", function(module, exports) {

$parcel$export(module.exports, "Form", () => $4a411705b0058cbd$export$a7fed597f4b8afd8);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b7FOu = parcelRequire("b7FOu");
const $4a411705b0058cbd$export$a7fed597f4b8afd8 = ({ cancelButtonLabel: cancelButtonLabel, children: children, confirmButtonLabel: confirmButtonLabel, context: context, hideActionButtons: hideActionButtons, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur })=>{
    const { onCancel: onCancel, onConfirm: onConfirm } = context;
    const wasFocusReceivedSinceLastBlurRef = (0, $eUqFw.useRef)(false);
    const formRef = (0, $eUqFw.useRef)(null);
    /** If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
   *  confirms the value, if the focus is not transferred to the action buttons
   *
   *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
   *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
   *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
   *  `autoSubmitWhenBlur`.
   *
   *  There are two paths here the function can be triggered:
   *
   *  - focus on input first, and then use keyboard to `submit`
   *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save)
   */ const onBlur = (0, $eUqFw.useCallback)(()=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            setTimeout(()=>{
                // Check the form hasn't unmounted before attempting to auto-submit
                !wasFocusReceivedSinceLastBlurRef.current && formRef.current && onConfirm(true);
            }, 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        onConfirm
    ]);
    /** Gets called when focus is transferred to the editView, or action buttons
   *
   * There are three paths here the function can be called:
   *
   * - when a user click the `editView`
   * - when a user use keyboard to tab into `editView`
   * - when a user use keyboard to tab into `submit` when they were on input field
   */ const onFocus = (0, $eUqFw.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const onSubmit = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        onConfirm(false);
    }, [
        onConfirm
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) onSubmit(event);
        if (event.key === 'Esc' || event.key === 'Escape') onCancel(false);
    }, [
        onCancel,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4a411705b0058cbd$var$StyledForm, {
        ref: formRef,
        role: "presentation",
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onSubmit: onSubmit
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b7FOu.FormControls), {
        cancelButtonLabel: cancelButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        context: context,
        hideActionButtons: hideActionButtons
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a411705b0058cbd$var$StyledForm = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1osq _kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b7FOu", function(module, exports) {

$parcel$export(module.exports, "FormControls", () => $6cadb728a04c7162$export$9b13823dba16e7d1);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8Ul0j = parcelRequire("8Ul0j");

var $hk8L2 = parcelRequire("hk8L2");
const $6cadb728a04c7162$export$9b13823dba16e7d1 = ({ cancelButtonLabel: cancelButtonLabel, confirmButtonLabel: confirmButtonLabel, context: { onCancel: onCancel }, hideActionButtons: hideActionButtons })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return !hideActionButtons ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hk8L2.default), {
        cancelButtonLabel: cancelButtonLabel ?? formatMessage((0, $8Ul0j.default).cancelButtonLabel),
        confirmButtonLabel: confirmButtonLabel ?? formatMessage((0, $8Ul0j.default).confirmButtonLabel),
        onCancelClick: ()=>onCancel(false)
    }) : /** This is to allow Ctrl + Enter to submit without action buttons */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        hidden: true,
        type: "submit"
    });
};

});


parcelRegister("9eOMO", function(module, exports) {

$parcel$export(module.exports, "useInlineEdit", () => $3c535bacdf0c25c0$export$4059f16ba5dcb4e1);

var $eUqFw = parcelRequire("eUqFw");

var $hzcvF = parcelRequire("hzcvF");

var $bFzGY = parcelRequire("bFzGY");
const $3c535bacdf0c25c0$var$actionSubject = 'inlineEdit';
const $3c535bacdf0c25c0$export$4059f16ba5dcb4e1 = ({ isEditing: isEditing, onCancel: onCancelOption, onConfirm: onConfirmOption, onEdit: onEditOption })=>{
    const editButtonRef = (0, $eUqFw.useRef)(null);
    const preventFocusOnEditButtonRef = (0, $eUqFw.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const prevIsEditing = (0, $hzcvF.usePrevious)(isEditing);
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !isEditing) {
            if (preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else editButtonRef.current?.focus();
        }
    }, [
        prevIsEditing,
        isEditing
    ]);
    const onCancel = (0, $eUqFw.useCallback)((preventFocusReturn = true)=>{
        preventFocusOnEditButtonRef.current = preventFocusReturn;
        const analyticsEvent = createAnalyticsEvent({
            action: 'canceled',
            actionSubject: $3c535bacdf0c25c0$var$actionSubject
        });
        onCancelOption(analyticsEvent);
    }, [
        createAnalyticsEvent,
        onCancelOption
    ]);
    const onConfirm = (0, $eUqFw.useCallback)((preventFocusReturn = true)=>{
        preventFocusOnEditButtonRef.current = preventFocusReturn;
        const analyticsEvent = createAnalyticsEvent({
            action: 'confirmed',
            actionSubject: $3c535bacdf0c25c0$var$actionSubject
        });
        onConfirmOption(analyticsEvent);
    }, [
        createAnalyticsEvent,
        onConfirmOption
    ]);
    const onEdit = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'focused',
            actionSubject: $3c535bacdf0c25c0$var$actionSubject
        });
        onEditOption(analyticsEvent);
    }, [
        createAnalyticsEvent,
        onEditOption
    ]);
    const context = (0, $eUqFw.useMemo)(()=>({
            onCancel: onCancel,
            onConfirm: onConfirm,
            onEdit: onEdit
        }), [
        onCancel,
        onConfirm,
        onEdit
    ]);
    const refs = (0, $eUqFw.useMemo)(()=>({
            editButton: editButtonRef
        }), []);
    return (0, $eUqFw.useMemo)(()=>({
            context: context,
            refs: refs
        }), [
        context,
        refs
    ]);
};

});

parcelRegister("clnSX", function(module, exports) {

$parcel$export(module.exports, "useInlineEditReadViewContainer", () => $4856125dd0e28f57$export$49374f374d70ab51);

var $eUqFw = parcelRequire("eUqFw");
const $4856125dd0e28f57$var$DRAG_THRESHOLD = 5;
const $4856125dd0e28f57$var$isLinkOrButton = (element)=>element.closest('a') != null || element.closest('button') != null;
const $4856125dd0e28f57$export$49374f374d70ab51 = ({ onEdit: onEdit })=>{
    const startX = (0, $eUqFw.useRef)(0);
    const startY = (0, $eUqFw.useRef)(0);
    const [isEditButtonFocused, setEditButtonFocused] = (0, $eUqFw.useState)(false);
    const mouseHasMovedAfterMouseDown = (0, $eUqFw.useCallback)((event)=>Math.abs(startX.current - event.clientX) >= $4856125dd0e28f57$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $4856125dd0e28f57$var$DRAG_THRESHOLD, []);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        const element = event.target;
        /** If a link or button is clicked in the read view, default action should be taken */ if (element instanceof HTMLElement && !$4856125dd0e28f57$var$isLinkOrButton(element) && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEdit();
        }
    }, [
        mouseHasMovedAfterMouseDown,
        onEdit
    ]);
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        startX.current = event.clientX;
        startY.current = event.clientY;
    }, []);
    const onEditButtonBlur = (0, $eUqFw.useCallback)(()=>setEditButtonFocused(false), []);
    const onEditButtonFocus = (0, $eUqFw.useCallback)(()=>setEditButtonFocused(true), []);
    return {
        isEditButtonFocused: isEditButtonFocused,
        onClick: onClick,
        onMouseDown: onMouseDown,
        onEditButtonBlur: onEditButtonBlur,
        onEditButtonFocus: onEditButtonFocus
    };
};

});


parcelRegister("hBJVp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5df9597e79c2598$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $1ybV0 = parcelRequire("1ybV0");

var $hVQlg = parcelRequire("hVQlg");
/**
 * Popup component to display a validation message for inline editable fields. The message will be displayed when the
 * user focuses the trigger attached to this component (which should be an interactive form field), and hidden when the
 * trigger is blurred.
 *
 * Why do we have a custom popup instead of using an existing `@atlaskit` component? There are a couple of caveats from
 * the existing components which makes them unsuitable for our use case:
 * 1. `@atlaskit/popup` - Creates a focus lock within the popup preventing the user from tab navigating to and from the
 * popup content.
 * 2. `@atlaskit/inline-dialog` - Deprecated in favour of `@atlaskit/popup`.
 * 3. `@atlaskit/tooltip` - Does not allow visibility to be controlled via a prop and attaches to mouseover events,
 * which is undesired.
 */ const $b5df9597e79c2598$var$ValidationPopup = ({ fieldId: fieldId, message: message, placement: placement, fallbackPlacements: fallbackPlacements, trigger: trigger })=>{
    const [isVisuallyHidden, setIsVisuallyHidden] = (0, $eUqFw.useState)(true);
    const wasFocusReceivedSinceLastBlurRef = (0, $eUqFw.useRef)(false);
    const triggerRef = (0, $eUqFw.useRef)();
    const onFocus = ()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
        setIsVisuallyHidden(false);
    };
    const onBlur = ()=>{
        wasFocusReceivedSinceLastBlurRef.current = false;
        setTimeout(()=>{
            if (!wasFocusReceivedSinceLastBlurRef.current) setIsVisuallyHidden(true);
        }, 0);
    };
    const popupContentId = (0, $eUqFw.useMemo)(()=>(0, $1ybV0.ff)('one-issue-table-inline-edit-lite-api-changes') ? `${(0, (/*@__PURE__*/$parcel$interopDefault($hompL)))()}-validation-popup` : `${fieldId ?? ''}-validation-popup`, [
        fieldId
    ]);
    const fieldProps = {
        fieldId: fieldId,
        ref: triggerRef,
        onFocus: onFocus,
        onBlur: onBlur,
        'aria-describedby': isVisuallyHidden ? undefined : popupContentId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, trigger(fieldProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hVQlg.default), {
        id: popupContentId,
        isVisuallyHidden: isVisuallyHidden,
        message: message,
        onFocus: onFocus,
        onBlur: onBlur,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        referenceElement: triggerRef?.current
    }));
};
var $b5df9597e79c2598$export$2e2bcd8739ae039 = $b5df9597e79c2598$var$ValidationPopup;

});
parcelRegister("hVQlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b850e693139082$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lSV8Z = parcelRequire("lSV8Z");
var $hYDGa = parcelRequire("hYDGa");

var $i6BC8 = parcelRequire("i6BC8");

var $lcnyw = parcelRequire("lcnyw");

var $kjXsi = parcelRequire("kjXsi");

var $kcG39 = parcelRequire("kcG39");
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param position - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $09b850e693139082$var$getDirectionFromPlacement = (placement)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    placement.split('-')[0];
// Inverts motion direction
const $09b850e693139082$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
const $09b850e693139082$var$ValidationPopper = ({ id: id, isVisuallyHidden: isVisuallyHidden, message: message, onFocus: onFocus, onBlur: onBlur, placement: placement, fallbackPlacements: fallbackPlacements, referenceElement: referenceElement })=>{
    const updateRef = (0, $eUqFw.useRef)();
    const modifiers = (0, $eUqFw.useMemo)(()=>[
            {
                name: 'flip',
                options: {
                    fallbackPlacements: fallbackPlacements
                }
            }
        ], [
        fallbackPlacements
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        // Since we are applying visually hidden styles instead of unmounting the popup for accessibility reasons,
        // there will be cases where the popup placement is calculated while it's visually hidden (e.g. when a
        // validation occurs on blur). While visually hidden, popup size is 1px x 1px, and this can make Popper
        // think that the popup fits in a placement where it doesn't actually fit, and end up overflowing the
        // viewport. To prevent this from happening, we ask Popper to recompute popup position when it becomes visible.
        !isVisuallyHidden && updateRef.current?.();
    }, [
        isVisuallyHidden
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), {
        appear: true
    }, message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), {
        placement: placement,
        referenceElement: referenceElement,
        strategy: "absolute",
        modifiers: modifiers
    }, ({ ref: ref, style: style, placement: finalPlacement, update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hYDGa.default), {
            entranceDirection: $09b850e693139082$var$invertedDirection[$09b850e693139082$var$getDirectionFromPlacement(finalPlacement)]
        }, ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                // eslint-disable-next-line jira/react/no-style-attribute
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    ...style,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    ...isVisuallyHidden && (0, $kjXsi.visuallyHiddenStyles),
                    zIndex: (0, $lcnyw.layers).layer()
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kcG39.default), {
                ...message,
                // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                id: id,
                onFocus: onFocus,
                onBlur: onBlur,
                "data-testid": "issue-field-validation-popup.ui.validation-popper.popup-content",
                testId: `issue-field-validation-popup.ui.validation-popper.popup-content${isVisuallyHidden ? '-hidden' : ''}`
            })));
    }));
};
var $09b850e693139082$export$2e2bcd8739ae039 = $09b850e693139082$var$ValidationPopper;

});
parcelRegister("kjXsi", function(module, exports) {

$parcel$export(module.exports, "visuallyHiddenStyles", () => $cfcbcec828cf2e62$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $cfcbcec828cf2e62$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $cfcbcec828cf2e62$export$200c8e5d652aa9af);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");
const $cfcbcec828cf2e62$export$8dd524ceb40e3d16 = {
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute'
};
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cfcbcec828cf2e62$var$ScreenReaderTextControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1wqp2jw-0"
})($cfcbcec828cf2e62$export$8dd524ceb40e3d16);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cfcbcec828cf2e62$var$ScreenReaderTextExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});
const $cfcbcec828cf2e62$export$88fad6aa294f111c = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $cfcbcec828cf2e62$var$ScreenReaderTextExperiment, $cfcbcec828cf2e62$var$ScreenReaderTextControl);
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cfcbcec828cf2e62$var$ScreenReaderCaptionControl = /*#__PURE__*/ (0, $kwce8.default).caption.withConfig({
    componentId: "sc-1wqp2jw-1"
})($cfcbcec828cf2e62$export$8dd524ceb40e3d16);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cfcbcec828cf2e62$var$ScreenReaderCaptionExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});
const $cfcbcec828cf2e62$export$200c8e5d652aa9af = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $cfcbcec828cf2e62$var$ScreenReaderCaptionExperiment, $cfcbcec828cf2e62$var$ScreenReaderCaptionControl);

});
parcelRegister("eWeL8", function(module, exports) {

$parcel$export(module.exports, "styledComponentWithCondition", () => $e0c5c7e39a960e0c$export$62d8d8fbf238d6af);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $e0c5c7e39a960e0c$export$62d8d8fbf238d6af = (useCompiled, CompiledComponent, StyledComponent)=>// Couldn't destructure like {innerRef, ...rest} as
    // typescript is suspcious on destructing generics
    ({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });
const $e0c5c7e39a960e0c$export$f5b752428255ba78 = (useCompiled, CompiledComponent, StyledComponent)=>({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });

});


parcelRegister("kcG39", function(module, exports) {

$parcel$export(module.exports, "default", () => $607621fb2da6c316$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $96IgR = parcelRequire("96IgR");

var $5YsMl = parcelRequire("5YsMl");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");
const $607621fb2da6c316$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
const $607621fb2da6c316$var$getIcon = (type)=>{
    switch(type){
        case 'error':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                label: "",
                primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA.R500)})`
            });
        case 'warning':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
                label: "",
                primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y300)})`
            });
        default:
            $607621fb2da6c316$var$assertUnreachable(type);
    }
};
const $607621fb2da6c316$var$PopupContent = ({ className: className, id: id, message: message, onFocus: onFocus, onBlur: onBlur, testId: testId, title: title, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($607621fb2da6c316$var$Content, {
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        role: "alert",
        id: id,
        hasTitle: !!title,
        onFocus: onFocus,
        onBlur: onBlur,
        "data-testid": testId
    }, $607621fb2da6c316$var$getIcon(type), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockEnd: "space.075",
        xcss: $607621fb2da6c316$var$titleStyles
    }, title), message) : message);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $607621fb2da6c316$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasTitle: hasTitle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt4pxbi _vchhusvi _p12f1feq _bfhk1bhr _2rko1sit _16qs8sq4 _1bsb1ns9",
            __cmplp.hasTitle ? "_zulppxbi" : "_4cvr1h6o _zulp12x7",
            __cmplp.className
        ])
    });
});
const $607621fb2da6c316$var$titleStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    fontWeight: 600,
    lineHeight: '24px'
});
var $607621fb2da6c316$export$2e2bcd8739ae039 = $607621fb2da6c316$var$PopupContent;

});



parcelRegister("aHoRv", function(module, exports) {

$parcel$export(module.exports, "EditView", () => $73059937acf06c41$export$280eb2fbab4e5389);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $9YNWW = parcelRequire("9YNWW");

var $cMBk2 = parcelRequire("cMBk2");
const $73059937acf06c41$export$280eb2fbab4e5389 = ({ cancelButtonLabel: cancelButtonLabel, children: children, confirmButtonLabel: confirmButtonLabel, context: context, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupMinWidth: editViewPopupMinWidth, hideActionButtons: hideActionButtons, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur })=>{
    const form = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9YNWW.Form), {
        cancelButtonLabel: cancelButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        context: context,
        hideActionButtons: hideActionButtons,
        keepEditViewOpenOnBlur: keepEditViewOpenOnBlur
    }, children);
    if ((0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && editViewPopup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cMBk2.EditViewPopup), {
        alignBlock: editViewPopupAlignBlock,
        minWidth: editViewPopupMinWidth
    }, form);
    return form;
};

});
parcelRegister("cMBk2", function(module, exports) {

$parcel$export(module.exports, "EditViewPopup", () => $7a1b1d696f6c936b$export$3ce17fd683f703eb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $5iWql = parcelRequire("5iWql");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $2KzVh = parcelRequire("2KzVh");
const $7a1b1d696f6c936b$var$getModifiers = (alignBlock)=>[
        {
            name: 'offset',
            enabled: alignBlock === 'center',
            options: {
                // Use negative offset of half the popper height to vertically center the content
                offset: ({ popper: popper })=>[
                        0,
                        -popper.height / 2
                    ]
            }
        },
        {
            name: 'flip',
            enabled: false
        },
        {
            name: 'computeStyles',
            options: {
                // Prevent use of 3D transforms to avoid creating a new stacking context for fixed position children
                gpuAcceleration: false
            }
        },
        {
            name: 'preventOverflow',
            options: {
                padding: 0,
                rootBoundary: 'viewport',
                // Allow the popup to remain within the clipping parent when overflowing the Y axis
                altAxis: true
            }
        }
    ];
/** Map the provided alignment to the appropriate popper placement. */ const $7a1b1d696f6c936b$var$toPopperPlacement = (alignBlock)=>{
    switch(alignBlock){
        case 'end':
            return 'top-start';
        default:
            return 'bottom-start';
    }
};
/** Map the provided min width breakpoint to a pixel value. */ const $7a1b1d696f6c936b$var$toMinWidth = (minWidth)=>{
    switch(minWidth){
        case 'large':
            return '400px';
        case 'medium':
            return '200px';
        default:
            return '140px';
    }
};
const $7a1b1d696f6c936b$export$3ce17fd683f703eb = ({ alignBlock: alignBlock = 'start', minWidth: minWidth = 'medium', children: children })=>{
    const updateRef = (0, $eUqFw.useRef)();
    const resizeObserver = (0, $eUqFw.useRef)();
    // Cleanup the resize observer when the component is unmounted
    (0, $eUqFw.useEffect)(()=>()=>resizeObserver.current?.disconnect(), []);
    const resizeRef = (0, $eUqFw.useCallback)((el)=>{
        if (el) {
            // Update popup positioning whenever content is resized
            resizeObserver.current = new ResizeObserver(()=>updateRef.current?.());
            resizeObserver.current.observe(el);
        }
    }, []);
    // Ensure a stable ref function is passed through to the popup content
    const memoizedMergeRefs = (0, $eUqFw.useMemo)(()=>(0, $5iWql.default)((0, $2KzVh.mergeRefs)), []);
    const modifiers = (0, $eUqFw.useMemo)(()=>$7a1b1d696f6c936b$var$getModifiers(alignBlock), [
        alignBlock
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7a1b1d696f6c936b$var$Target, {
            ref: ref
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), {
        placement: $7a1b1d696f6c936b$var$toPopperPlacement(alignBlock),
        strategy: "absolute",
        modifiers: modifiers
    }, ({ ref: ref, style: style, update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7a1b1d696f6c936b$var$Content, {
            ref: memoizedMergeRefs(ref, resizeRef),
            minWidth: minWidth,
            /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style
        }, children);
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7a1b1d696f6c936b$var$Target = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbidpf",
            __cmplp.className
        ])
    });
});
const $7a1b1d696f6c936b$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minWidth: minWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_11xim2q": (0, $9t7rW.default)(`max(100%, ${$7a1b1d696f6c936b$var$toMinWidth(__cmplp.minWidth)})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91hi4 _1bsb1ris _p12fkbql _1pby16oo",
            __cmplp.className
        ])
    });
});

});


parcelRegister("9svzR", function(module, exports) {

$parcel$export(module.exports, "default", () => $90e0320f3add235f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $90e0320f3add235f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    confirmButtonLabel: {
        "id": "issue-field-inline-edit-lite.field-inline-edit-lite.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "issue-field-inline-edit-lite.field-inline-edit-lite.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "issue-field-inline-edit-lite.field-inline-edit-lite.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    }
});

});

parcelRegister("bMLK2", function(module, exports) {

$parcel$export(module.exports, "ReadView", () => $b1e69f9e68871427$export$a4b5824ec1e018e1);

var $eUqFw = parcelRequire("eUqFw");

var $clnSX = parcelRequire("clnSX");

var $7gTIL = parcelRequire("7gTIL");
const $b1e69f9e68871427$export$a4b5824ec1e018e1 = ({ children: children, context: context, editButtonLabel: editButtonLabel, editButtonRef: editButtonRef, hideEditButton: hideEditButton, isInvalid: isInvalid, isLoading: isLoading, readViewContainerRef: readViewContainerRef, readViewFitContainerHeight: readViewFitContainerHeight })=>{
    const { isEditButtonFocused: isEditButtonFocused, onClick: onClick, onMouseDown: onMouseDown, onEditButtonBlur: onEditButtonBlur, onEditButtonFocus: onEditButtonFocus } = (0, $clnSX.useInlineEditReadViewContainer)(context);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7gTIL.default), {
        context: context,
        editButtonLabel: editButtonLabel,
        editButtonRef: editButtonRef,
        hideEditButton: hideEditButton,
        isEditButtonFocused: isEditButtonFocused,
        // Highlight the field as invalid to notify the user if there was an error attempting to submit changes.
        isInvalid: isInvalid,
        isLoading: isLoading,
        onClick: onClick,
        onMouseDown: onMouseDown,
        onEditButtonBlur: onEditButtonBlur,
        onEditButtonFocus: onEditButtonFocus,
        readViewFitContainerHeight: readViewFitContainerHeight,
        ref: readViewContainerRef
    }, children);
};

});

parcelRegister("4WtbX", function(module, exports) {

$parcel$export(module.exports, "ReadViewNonEditable", () => $4c117029c4ed4604$export$4efb4956550fac52);

var $eUqFw = parcelRequire("eUqFw");

var $7gTIL = parcelRequire("7gTIL");
const $4c117029c4ed4604$export$4efb4956550fac52 = ({ children: children, hideEditButton: hideEditButton, isLoading: isLoading, readViewFitContainerHeight: readViewFitContainerHeight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7gTIL.default), {
        hideEditButton: hideEditButton,
        isLoading: isLoading,
        readViewFitContainerHeight: readViewFitContainerHeight
    }, children);

});



parcelRegister("eGvP7", function(module, exports) {

$parcel$export(module.exports, "useLabelsCache", () => $95c6ed1d00183766$export$18b2bd971a089d24);

var $eUqFw = parcelRequire("eUqFw");

var $795rA = parcelRequire("795rA");

var $gUUjF = parcelRequire("gUUjF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2qWt2 = parcelRequire("2qWt2");
const $95c6ed1d00183766$var$useRerenderTrigger = ()=>{
    const [token, setSymbol] = (0, $eUqFw.useState)(Symbol('useRerenderTrigger_initial'));
    const refreshToken = (0, $eUqFw.useCallback)(()=>setSymbol(Symbol('useRerenderTrigger_rerender')), []);
    return [
        token,
        refreshToken
    ];
};
const $95c6ed1d00183766$export$18b2bd971a089d24 = (fieldId)=>{
    const labelsCache = (0, $795rA.getLabelsCache)(fieldId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [cachedLabels, setCachedLabels] = (0, $eUqFw.useState)([]);
    const [cacheRefreshToken, refreshCache] = $95c6ed1d00183766$var$useRerenderTrigger();
    const addToCache = (0, $eUqFw.useCallback)((labels)=>{
        Promise.all(labels.map(async (label)=>{
            try {
                const cachedOption = await labelsCache.get(label);
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'labelPickerCache set', {
                    isFromCache: Boolean(cachedOption?.label)
                });
                return label && labelsCache.set(`${label}`, {
                    label: label
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-view.labels.cache.set', error.message);
            }
            return undefined;
        })).then(()=>{
            refreshCache(); // trigger an update of the returned cached labels value
        });
    }, [
        createAnalyticsEvent,
        labelsCache,
        refreshCache
    ]);
    const removeFromCache = (0, $eUqFw.useCallback)((labels)=>{
        Promise.all(labels.map(async (label)=>{
            try {
                const cachedOption = await labelsCache.get(label);
                if (cachedOption) {
                    (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'labelPickerCache removed');
                    return cachedOption && labelsCache.remove(`${cachedOption.label}`);
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-view.labels.cache.remove', error.message);
            }
            return undefined;
        })).then(()=>{
            refreshCache(); // trigger an update of the returned cached labels value
        });
    }, [
        createAnalyticsEvent,
        labelsCache,
        refreshCache
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const getCachedLabels = async ()=>{
            const cachedItems = await labelsCache.getAll();
            const transformedCachedItems = (0, $2qWt2.transformCacheEntries)(cachedItems);
            const labelOptions = (0, $2qWt2.mapCachedItemsToLabelOptions)(transformedCachedItems);
            setCachedLabels(labelOptions);
        };
        getCachedLabels();
    // Having cacheRefreshToken in the deps array allows us to retrigger a loading of the cached values whenever refreshCache is called
    }, [
        cacheRefreshToken,
        labelsCache
    ]);
    return [
        cachedLabels,
        {
            addToCache: addToCache,
            removeFromCache: removeFromCache
        }
    ];
};

});
parcelRegister("2qWt2", function(module, exports) {

$parcel$export(module.exports, "mapCachedItemsToLabelOptions", () => $007d5f1e6033b217$export$9ba85e25262c8a32);
$parcel$export(module.exports, "transformCacheEntries", () => $007d5f1e6033b217$export$64c1e7aa265973f8);

const $007d5f1e6033b217$export$9ba85e25262c8a32 = (items)=>items.map(({ label: label })=>({
            label: label,
            value: label
        }));
const $007d5f1e6033b217$export$64c1e7aa265973f8 = (items)=>items.slice(-1 * (0, $7707d8b66dda11d0$export$f6b2881bc1090cea)).reverse();

});
const $7707d8b66dda11d0$export$ffb1c0893bcc2c13 = 'customfield_';
const $7707d8b66dda11d0$export$f6b2881bc1090cea = 5;



parcelRegister("Lrz9s", function(module, exports) {

$parcel$export(module.exports, "default", () => $837157bbd562a82a$export$2e2bcd8739ae039);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $837157bbd562a82a$var$LabelsEditViewEntryPoint = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("6O4g4")), {
        moduleId: "f49080b6"
    }),
    getPreloadProps: ()=>({})
});
var $837157bbd562a82a$export$2e2bcd8739ae039 = $837157bbd562a82a$var$LabelsEditViewEntryPoint;

});
parcelRegister("6O4g4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('htoe4');
        const value = parcelRequire('4Jz1T');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("htoe4").then(()=>parcelRequire('4Jz1T'));
}

});


parcelRegister("kDarC", function(module, exports) {

$parcel$export(module.exports, "LabelsReadView", () => $58737abe0724d8a4$export$79e9d2357368ec9e);

var $4FPPq = parcelRequire("4FPPq");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $lXabx = parcelRequire("lXabx");

var $cRXCh = parcelRequire("cRXCh");

var $5skho = parcelRequire("5skho");

var $7yTL6 = parcelRequire("7yTL6");
const $58737abe0724d8a4$export$79e9d2357368ec9e = ({ baseSearchUrl: baseSearchUrl, fragmentRef: fragmentRef, isTruncated: isTruncated })=>{
    const data = (0, $iWLL0.useFragment)((0, $4FPPq.default), fragmentRef);
    const { selectedLabelsConnection: labels, fieldId: fieldId } = data;
    if (labels.totalCount !== 0) {
        const labelValues = labels?.edges?.filter(Boolean).map((edge)=>edge.node).filter((label)=>label != null && label.name != null) || [];
        if (labelValues.length !== 0) {
            if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7yTL6.LabelsTruncatedReadView), {
                baseSearchUrl: baseSearchUrl,
                fieldId: fieldId,
                labelValues: labelValues
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($58737abe0724d8a4$var$GroupWithNegativeMarginOffset, null, labelValues.map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXabx.default), {
                    key: label.name,
                    isRemovable: false,
                    text: label.name,
                    href: (0, $5skho.getLabelHref)(fieldId, label.name, baseSearchUrl)
                })));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cRXCh.EmptyFieldText), null);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58737abe0724d8a4$var$GroupWithNegativeMarginOffset = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _1n261g80 _1bah1y6m _18s83l1n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4FPPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2f44577b7a5b174$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f68c112c4e06b3f7e1cea409cbd5cac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b2f44577b7a5b174$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "labels_issueFieldLabelsReadviewFull_LabelsReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            "action": "THROW",
            "path": "selectedLabelsConnection"
        }
    ],
    "type": "JiraLabelsField"
};
$b2f44577b7a5b174$var$node.hash = "7dbf871989626785f282568d738052ba";
var $b2f44577b7a5b174$export$2e2bcd8739ae039 = $b2f44577b7a5b174$var$node;

});

parcelRegister("lXabx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3ff7c9e14de284a$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $co43T = parcelRequire("co43T");

var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $lSV8Z = parcelRequire("lSV8Z");
var $5Dp4O = parcelRequire("5Dp4O");

var $jFsza = parcelRequire("jFsza");

var $i6wnX = parcelRequire("i6wnX");

var $d9W8K = parcelRequire("d9W8K");

var $6aZHE = parcelRequire("6aZHE");

var $gz2Bi = parcelRequire("gz2Bi");

var $keeN7 = parcelRequire("keeN7");
var $c3ff7c9e14de284a$var$TagStatus;
(function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
})($c3ff7c9e14de284a$var$TagStatus || ($c3ff7c9e14de284a$var$TagStatus = {}));
const $c3ff7c9e14de284a$var$packageName = undefined;
const $c3ff7c9e14de284a$var$packageVersion = undefined;
const $c3ff7c9e14de284a$var$defaultBeforeRemoveAction = ()=>true;
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ const $c3ff7c9e14de284a$var$removingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        boxShadow: `0 0 0 2px transparent`,
        outline: 'none'
    }
});
const $c3ff7c9e14de284a$var$RemovableTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $c3ff7c9e14de284a$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $5Q9wj.default), linkComponent: linkComponent }, ref)=>{
    const [status, setStatus] = (0, $eUqFw.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $eUqFw.useState)(false);
    const onAfterRemoveActionWithAnalytics = (0, $co43T.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $c3ff7c9e14de284a$var$packageName,
            packageVersion: $c3ff7c9e14de284a$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $eUqFw.useCallback)(()=>{
        onAfterRemoveActionWithAnalytics(text);
        setStatus("removed");
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    const handleRemoveRequest = (0, $eUqFw.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $eUqFw.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $eUqFw.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $eUqFw.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $eUqFw.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $eUqFw.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $keeN7.default), {
        "aria-label": `${removeButtonLabel} ${text}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    const content = /*#__PURE__*/ (0, $byn9U.jsx)((0, $gz2Bi.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        // Tag background color on hover
        [(0, $jFsza.cssVar).color.background.hover]: $i6wnX.removalHoverBackgroundColors,
        // Tag background color on press
        [(0, $jFsza.cssVar).color.background.active]: $i6wnX.removalActiveBackgroundColors,
        // The tag text on hover of remove button
        [(0, $jFsza.cssVar).color.text.default]: $i6wnX.removalTextColors,
        // 'elemBefore' text on press of remove button
        [(0, $jFsza.cssVar).color.text.active]: $i6wnX.removalTextColors,
        // The tag link text on hover of remove button
        [(0, $jFsza.cssVar).color.text.link]: $i6wnX.removalTextColors
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $lSV8Z.default), null, !(status === "removed") && /*#__PURE__*/ (0, $byn9U.jsx)((0, $5Dp4O.default), null, (motion)=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $d9W8K.default), {
            ref: (0, $1lQG9.default)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            css: [
                status === "removing" && $c3ff7c9e14de284a$var$removingStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === "removing",
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ (0, $byn9U.jsx)((0, $6aZHE.default), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton
        });
    }));
});
var $c3ff7c9e14de284a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c3ff7c9e14de284a$var$RemovableTag);

});
parcelRegister("5Dp4O", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fb4b88a82b6f14c$export$2e2bcd8739ae039);


var $5LHuc = parcelRequire("5LHuc");

var $5bTtn = parcelRequire("5bTtn");

var $hcijx = parcelRequire("hcijx");

var $3WV8S = parcelRequire("3WV8S");

var $lSV8Z = parcelRequire("lSV8Z");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $8fb4b88a82b6f14c$var$ShrinkOut = ({ children: children, duration: duration = (0, $5LHuc.smallDurationMs), onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $hcijx.useElementRef)();
    const exiting = (0, $lSV8Z.useExitingPersistence)();
    const requestAnimationFrame = (0, $5bTtn.useRequestAnimationFrame)();
    const setTimeout = (0, $5bTtn.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $3WV8S.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: (0, $d58b680a02f4d6a4$export$929e5a82286172a6),
                        transitionDuration: `${duration}ms`,
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, duration);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $8fb4b88a82b6f14c$export$2e2bcd8739ae039 = $8fb4b88a82b6f14c$var$ShrinkOut;

});
const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

parcelRegister("hcijx", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $81c15b5f9718dda0$export$ff879f35a69d56b7);

var $eUqFw = parcelRequire("eUqFw");
const $81c15b5f9718dda0$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $eUqFw.useRef)(null);
    const setRef = (0, $eUqFw.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});


parcelRegister("keeN7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4292d770fb9954c5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $je5kZ = parcelRequire("je5kZ");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $jFsza = parcelRequire("jFsza");
const $4292d770fb9954c5$var$removeButtonStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    height: '16px',
    margin: 'space.0',
    padding: 'space.0',
    position: 'absolute',
    insetInlineEnd: 'space.0',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    appearance: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none',
    // Once legacy theming is dropped, this can be changed to 'border.radius'
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    // Once legacy theming is dropped, this can be changed to 'inherit'
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.removeButton.default})`,
    cursor: 'pointer',
    pointerEvents: 'auto',
    ':focus-visible': {
        outlineOffset: 'space.0'
    },
    ':hover': {
        // Once legacy theming is dropped, this can be changed to 'cssVar.color.text.default'
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.removeButton.hover})`
    }
});
const $4292d770fb9954c5$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        xcss: $4292d770fb9954c5$var$removeButtonStyles,
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
        label: "close tag",
        size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4292d770fb9954c5$export$2e2bcd8739ae039 = $4292d770fb9954c5$var$RemoveButton;

});


parcelRegister("5skho", function(module, exports) {

$parcel$export(module.exports, "getLabelHref", () => $0903c8b472821bbf$export$a1200807f331a4bd);

var $8g5hT = parcelRequire("8g5hT");
const $0903c8b472821bbf$var$CUSTOM_FIELD_PREFIX = 'customfield_';
const $0903c8b472821bbf$export$faff4881e53b3cb6 = (fieldId)=>{
    if (fieldId.startsWith($0903c8b472821bbf$var$CUSTOM_FIELD_PREFIX)) {
        const customId = fieldId.substring($0903c8b472821bbf$var$CUSTOM_FIELD_PREFIX.length, fieldId.length);
        return `cf[${customId}]`;
    }
    return fieldId;
};
const $0903c8b472821bbf$export$a1200807f331a4bd = (fieldId, label, baseSearchUrl = '/issues/')=>{
    const jqlEncodedValue = encodeURIComponent(`${$0903c8b472821bbf$export$faff4881e53b3cb6(fieldId)} = ${(0, $8g5hT.toQuotedString)(label)}`);
    return `${baseSearchUrl}?jql=${jqlEncodedValue}`;
};

});

parcelRegister("7yTL6", function(module, exports) {

$parcel$export(module.exports, "LabelsTruncatedReadView", () => $a2cd398332749aa6$export$95d698e57184b56c);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cRXCh = parcelRequire("cRXCh");

var $jqoaM = parcelRequire("jqoaM");
var $e27aD = parcelRequire("e27aD");

var $5skho = parcelRequire("5skho");

var $6u4SB = parcelRequire("6u4SB");
const $a2cd398332749aa6$export$95d698e57184b56c = ({ baseSearchUrl: baseSearchUrl, fieldId: fieldId, labelValues: labelValues })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (labelValues.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cRXCh.EmptyFieldText), null);
    const items = labelValues.map(({ name: name })=>({
            name: name,
            key: name,
            href: (0, $5skho.getLabelHref)(fieldId, name, baseSearchUrl)
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlock: "space.050",
        xcss: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && $a2cd398332749aa6$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jqoaM.default), {
        items: items,
        ItemComponent: (0, $e27aD.TagItem),
        PopupContentWrapper: (0, $e27aD.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $6u4SB.default).showMoreTooltip)
    }));
};
const $a2cd398332749aa6$var$containerStyles = (0, $1ZAYh.xcss)({
    maxWidth: '100%'
});

});
parcelRegister("jqoaM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f45a67ecacecab77$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9Amv1 = parcelRequire("9Amv1");

var $hU7MO = parcelRequire("hU7MO");
const $f45a67ecacecab77$var$ListWithPopup = ({ items: items, ItemComponent: ItemComponent, maxLimit: maxLimit, initialIsOpen: initialIsOpen, ...restProps })=>{
    if (items.length === 0) return null;
    const [firstItem, ...restItems] = items;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ItemComponent, firstItem), restItems.length >= 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hU7MO.default), {
        items: restItems,
        maxLimit: maxLimit,
        ItemComponent: ItemComponent,
        initialIsOpen: initialIsOpen,
        ...restProps
    }));
};
var $f45a67ecacecab77$export$2e2bcd8739ae039 = $f45a67ecacecab77$var$ListWithPopup;

});
parcelRegister("hU7MO", function(module, exports) {

$parcel$export(module.exports, "default", () => $142bd79b47980efc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $kGQen = parcelRequire("kGQen");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
// can be removed when cleaning up extend-popup-cell-with-custom-override-content-and-parameters_obikd
const $142bd79b47980efc$var$MAX_DISPLAYED_AMOUNT = 99;
const $142bd79b47980efc$var$ShowMorePopup = ({ showMoreTooltip: showMoreTooltip, items: items, ItemComponent: ItemComponent, PopupContentWrapper: PopupContentWrapper = (0, $eUqFw.Fragment), maxLimit: maxLimit = 99, OverrideContentComponent: OverrideContentComponent, initialIsOpen: initialIsOpen = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(initialIsOpen);
    if (items.length === 0) return null;
    const list = (0, $1ybV0.ff)('extend-popup-cell-with-custom-override-content-and-parameters_obikd') ? items.slice(0, maxLimit) : items.slice(0, $142bd79b47980efc$var$MAX_DISPLAYED_AMOUNT);
    const onClickTrigger = ()=>{
        setIsOpen(!isOpen);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'listWithPopup');
    };
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $1ybV0.ff)('extend-popup-cell-with-custom-override-content-and-parameters_obikd') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $142bd79b47980efc$var$ContainerDialogStyles
        }, OverrideContentComponent === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PopupContentWrapper, null, list.map(({ key: key, ...item })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ItemComponent, item)))) : OverrideContentComponent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $142bd79b47980efc$var$ContainerDialogStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PopupContentWrapper, null, list.map(({ key: key, ...item })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ItemComponent, item))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom",
        content: content,
        testId: "list-with-popup.ui.show-more-popup",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                key: "triggerLinksDialog",
                content: showMoreTooltip,
                tag: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? $142bd79b47980efc$var$TooltipContainer : 'span'
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: onClickTrigger,
                spacing: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($142bd79b47980efc$var$ItemsCount, null, "+", list.length)))
    });
};
const $142bd79b47980efc$var$TooltipContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ...props,
        ref: ref,
        as: "span",
        xcss: $142bd79b47980efc$var$tooltipContainerStyles
    }));
const $142bd79b47980efc$var$ContainerDialogStyles = (0, $1ZAYh.xcss)({
    width: '240px',
    maxHeight: '220px',
    overflow: 'auto',
    padding: 'space.100',
    border: `2px solid ${`var(--ds-border-focused, ${(0, $PdmhA).B200})`}`
});
const $142bd79b47980efc$var$tooltipContainerStyles = (0, $1ZAYh.xcss)({
    maxWidth: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $142bd79b47980efc$var$ItemsCount = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p4jg8 _vwz4v47k _18zr1b66",
            __cmplp.className
        ])
    });
});
var $142bd79b47980efc$export$2e2bcd8739ae039 = $142bd79b47980efc$var$ShowMorePopup;

});


parcelRegister("e27aD", function(module, exports) {

$parcel$export(module.exports, "TagItem", () => $39ee680b1a7a9c93$export$32a09b7581f7fd80);
$parcel$export(module.exports, "TagItemPopupContentWrapper", () => $39ee680b1a7a9c93$export$c9925310d93bfb2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $9Amv1 = parcelRequire("9Amv1");

var $9jNAz = parcelRequire("9jNAz");

var $1ybV0 = parcelRequire("1ybV0");

var $cXIox = parcelRequire("cXIox");
const $39ee680b1a7a9c93$var$StrikethroughTagLink = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cXIox.default), {
        shouldDisplayStrikethrough: true,
        ...props
    });
const $39ee680b1a7a9c93$export$32a09b7581f7fd80 = ({ name: name, href: href, icon: icon, shouldDisplayStrikethrough: shouldDisplayStrikethrough })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($39ee680b1a7a9c93$var$TagMarginFix, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        elemBefore: icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            appearance: "square",
            size: "xsmall",
            src: icon.url,
            borderColor: "transparent",
            testId: "list-with-popup.ui.tag-item.avatar"
        }) : undefined,
        text: name,
        href: href,
        linkComponent: shouldDisplayStrikethrough ? $39ee680b1a7a9c93$var$StrikethroughTagLink : (0, $cXIox.default)
    }));
const $39ee680b1a7a9c93$export$c9925310d93bfb2 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        shouldWrap: true
    }, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $39ee680b1a7a9c93$var$TagMarginFix = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _18s8r5cr",
            (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && "_p12f1osq _l9z01osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cXIox", function(module, exports) {

$parcel$export(module.exports, "default", () => $f70f5484d5811fed$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bAQOb = parcelRequire("bAQOb");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");
const $f70f5484d5811fed$var$Link = ({ onClick: onClick, wordBreak: wordBreak = true, shouldDisplayStrikethrough: shouldDisplayStrikethrough = false, ...rest })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClickWithAnalytics = (0, $eUqFw.useCallback)((e)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), 'listWithPopup');
        onClick && onClick(e);
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f70f5484d5811fed$var$StyledLink, {
        wordBreak: wordBreak,
        shouldDisplayStrikethrough: shouldDisplayStrikethrough,
        ...rest,
        onClick: onClickWithAnalytics
    });
};
// can be removed when StyledLinkOld is removed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f70f5484d5811fed$var$LinkWrapperOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $kJlBc.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1nmz1hna",
            __cmplp.className
        ])
    });
});
const $f70f5484d5811fed$var$StyledLinkOld = ({ wordBreak: wordBreak = true, ...props })=>wordBreak ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f70f5484d5811fed$var$LinkWrapperOld, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), props);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f70f5484d5811fed$var$StyledLinkNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $kJlBc.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.wordBreak && "_1nmz1hna",
            __cmplp.shouldDisplayStrikethrough && "_4bfu1r81 _1hms1cog _ajmmvv82",
            __cmplp.className
        ])
    });
});
const $f70f5484d5811fed$var$StyledLink = (0, $bAQOb.componentWithFF)('extend-popup-cell-with-custom-override-content-and-parameters_obikd', $f70f5484d5811fed$var$StyledLinkNew, $f70f5484d5811fed$var$StyledLinkOld);
var $f70f5484d5811fed$export$2e2bcd8739ae039 = $f70f5484d5811fed$var$Link;

});


parcelRegister("6u4SB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3af12c1e5025a289$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3af12c1e5025a289$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-labels-readview-full.labels.compact.show-more-tooltip",
        "defaultMessage": "See more labels"
    }
});

});



parcelRegister("duaUt", function(module, exports) {

$parcel$export(module.exports, "useMultiSelectFieldDirtyValueOperations", () => $ce32b704b8c81642$export$484e5e1fabcb3ce2);

var $eUqFw = parcelRequire("eUqFw");
const $ce32b704b8c81642$export$484e5e1fabcb3ce2 = ()=>{
    const [dirtyValue, setDirtyValue] = (0, $eUqFw.useState)([]);
    const [operations, setOperations] = (0, $eUqFw.useState)([]);
    const initializeDirtyValue = (0, $eUqFw.useCallback)((currentValue)=>{
        setDirtyValue(currentValue);
        setOperations([]);
    }, []);
    const onChange = (0, $eUqFw.useCallback)((newValue)=>{
        // todo JIV-13917: compare the new values to previous state. convert in to a discrete combination of add, remove, and set operations.
        // Eg: User adds item A and removes item B -> results in -> [{operation: 'REMOVE', value: ['B']}, {operation: 'ADD', value: ['A']}]
        // Eg: User swaps the order of items A and B to [B,A] -> results in -> [{operation: 'REMOVE', value: ['A', 'B']}, {operation: 'ADD', value: ['B', 'A']}]
        // Eg: User clears the value of the field (using x button) then adds item A -> results in -> [{operation: 'SET', value: []}, {operation: 'ADD', value: ['A']}]
        // Rules:
        // If the user clears the field value, first operation must be SET to []
        // Any permutation of any number of single-value-add events, single-value-remove events or re-ordering events can be simplified down to a single `ADD` and `REMOVE` operation
        //
        // This will end up a fair bit more complex than it is now, but it will allow us to avoid bugs where we accidentally chop off values past the initial page
        setOperations([
            {
                operation: 'SET',
                value: newValue
            }
        ]);
        setDirtyValue(newValue);
    }, []);
    return [
        {
            dirtyValue: dirtyValue,
            operations: operations
        },
        {
            onChange: onChange,
            initializeDirtyValue: initializeDirtyValue
        }
    ];
};

});

parcelRegister("208Ws", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5511b3eb072f398$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a5511b3eb072f398$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "issue-field-labels-inline-edit-view-full.labels.error-title",
        "defaultMessage": "We couldn't set the labels value"
    },
    errorMessage: {
        "id": "issue-field-labels-inline-edit-view-full.labels.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    noValueText: {
        "id": "issue-field-labels-inline-edit-view-full.labels.no-value-text",
        "defaultMessage": "None"
    },
    editButtonLabel: {
        "id": "issue-field-labels-inline-edit-view-full.labels.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    },
    newLabelTooLongError: {
        "id": "issue-field-labels-inline-edit-view-full.labels.new-label-too-long-error",
        "defaultMessage": "Labels can't be more than {maxLength} characters."
    },
    newLabelContainsSpacesError: {
        "id": "issue-field-labels-inline-edit-view-full.labels.new-label-contains-spaces-error",
        "defaultMessage": "Labels can't have spaces."
    },
    maximumNumberOfLabelsExceededError: {
        "id": "issue-field-labels-inline-edit-view-full.labels.maximum-number-of-labels-exceeded-error",
        "defaultMessage": "Can't have more than {maxNumberOfLabels} labels."
    }
});

});

parcelRegister("121wd", function(module, exports) {

$parcel$export(module.exports, "useLabelsValidator", () => $def1f8899a65edb1$export$990e7f2d0da9a96a);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");


var $208Ws = parcelRequire("208Ws");
const $def1f8899a65edb1$export$990e7f2d0da9a96a = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const change = (0, $eUqFw.useCallback)((newValues)=>{
        for(let i = newValues.length - 1; i >= 0; i -= 1){
            const { __isNew__: __isNew__, value: value } = newValues[i];
            if (__isNew__ === true) {
                if (value.includes(' ')) return {
                    type: 'error',
                    message: formatMessage((0, $208Ws.default).newLabelContainsSpacesError)
                };
                if (value.length > (0, $7aad88c5a8987870$export$e85fda072a12fed9)) return {
                    type: 'error',
                    message: formatMessage((0, $208Ws.default).newLabelTooLongError, {
                        maxLength: (0, $7aad88c5a8987870$export$e85fda072a12fed9)
                    })
                };
            }
        }
        if (newValues.length > (0, $7aad88c5a8987870$export$45f4d7adca48db10)) return {
            type: 'warning',
            message: formatMessage((0, $208Ws.default).maximumNumberOfLabelsExceededError, {
                maxNumberOfLabels: (0, $7aad88c5a8987870$export$45f4d7adca48db10)
            })
        };
        return null;
    }, [
        formatMessage
    ]);
    return {
        change: change
    };
};

});
const $7aad88c5a8987870$export$45f4d7adca48db10 = 55;
const $7aad88c5a8987870$export$e85fda072a12fed9 = 255;




parcelRegister("eYS0Z", function(module, exports) {

$parcel$export(module.exports, "IssueViewSingleSelectField", () => $80ee3353f569c5be$export$fd0d3ea1b388893);

var $iyAwt = parcelRequire("iyAwt");

var $5YHwh = parcelRequire("5YHwh");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $4Hwcq = parcelRequire("4Hwcq");

var $9xW5J = parcelRequire("9xW5J");

var $hW84d = parcelRequire("hW84d");

var $8p8vy = parcelRequire("8p8vy");

var $hAmRt = parcelRequire("hAmRt");
const $80ee3353f569c5be$var$transformRelayDataToLegacyShape = (value)=>{
    if (value === null) return null;
    return {
        ari: value.value,
        id: value.optionId,
        value: value.label
    };
};
const $80ee3353f569c5be$export$fd0d3ea1b388893 = ({ area: area, fragmentKey: fragmentKey })=>{
    const issueId = (0, $hJ992.useIssueId)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $8p8vy.useIssueViewFieldUpdateEvents)();
    const [, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldsValuesActions)();
    const data = (0, $iWLL0.useFragment)((0, $5YHwh.default), fragmentKey);
    // Temporary FF to disable prefetching for select customers that experience issue like https://getsupport.atlassian.com/browse/PCS-277464
    // Proper solution will be done under https://jplat.jira.atlassian.cloud/browse/JIV-18302
    if ((0, $1ybV0.ff)('issue-view-disable-fields-prefetch') === false) // Prefetch `fieldOptions` suggestions
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hW84d.useLazyLoadQueryAfterPageLoad)((0, $iyAwt.default), {
        id: data.id,
        first: (0, $4Hwcq.PREFETCH_OPTIONS_COUNT)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hAmRt.IssueViewFieldHeading), {
        area: area,
        fragmentKey: data,
        testId: `issue.issue-view-layout.issue-view-single-select-field.${data.fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9xW5J.SingleSelectInlineEditView), {
        fragmentRef: data,
        onSubmit: (value)=>{
            issueId && fieldChangeRequested(issueId, data.fieldId, $80ee3353f569c5be$var$transformRelayDataToLegacyShape(value));
        },
        onSubmitSucceeded: (value)=>{
            const option = $80ee3353f569c5be$var$transformRelayDataToLegacyShape(value);
            issueId && fieldChanged(issueId, data.fieldId, option);
            setFieldValue(issueKey, data.fieldId, option);
        },
        onSubmitFailed: ()=>issueId && fieldChangeFailed(issueId, data.fieldId),
        spacing: (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i') ? 'compact' : 'default'
    }));
};

});
parcelRegister("iyAwt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5e8951c098d9dc0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2f8df1005650e3306263c3666d6e0c79>>
 * @relayHash a36ca0edc536ede13ce4258ac391b607
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b75d4c24ffa334a2fa8ade5cd79af2b941370d14f5ea169012585b8a174753d
const $f5e8951c098d9dc0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = [
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_prefetchSingleSelectFieldOptionsQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "singleSelect_issueFieldSingleSelectEditviewFull_SingleSelectEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ui_prefetchSingleSelectFieldOptionsQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "optionId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isDisabled"
                                                        },
                                                        v6 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v5 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "main_issueFieldSingleSelectEditviewFull__fieldOptions",
                                    "kind": "LinkedHandle",
                                    "name": "fieldOptions"
                                }
                            ],
                            "type": "JiraSingleSelectField"
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "7b75d4c24ffa334a2fa8ade5cd79af2b941370d14f5ea169012585b8a174753d",
            "metadata": {},
            "name": "ui_prefetchSingleSelectFieldOptionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f5e8951c098d9dc0$var$node.hash = "d11d5054bd3348887bbf8d0ff0b23fd8";
var $f5e8951c098d9dc0$export$2e2bcd8739ae039 = $f5e8951c098d9dc0$var$node;

});

parcelRegister("5YHwh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2e1450f37f0b0eb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<106e9be7134c4265a34218e18d99d5cf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a2e1450f37f0b0eb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_issueViewLayoutFieldHeading_IssueViewFieldHeading"
        },
        {
            "kind": "FragmentSpread",
            "name": "singleSelect_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        }
    ],
    "type": "JiraSingleSelectField"
};
$a2e1450f37f0b0eb$var$node.hash = "f3ac18890640590f218645ad4a4ae4d6";
var $a2e1450f37f0b0eb$export$2e2bcd8739ae039 = $a2e1450f37f0b0eb$var$node;

});

parcelRegister("9xW5J", function(module, exports) {

$parcel$export(module.exports, "SingleSelectInlineEditView", () => $568f3fe637e35304$export$dd40a625fe2da362);

var $5mZJ3 = parcelRequire("5mZJ3");

var $j8MQe = parcelRequire("j8MQe");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7jPhn = parcelRequire("7jPhn");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $646aD = parcelRequire("646aD");

var $6oQPP = parcelRequire("6oQPP");

var $K1Vl8 = parcelRequire("K1Vl8");

var $iwV3u = parcelRequire("iwV3u");

var $aIziS = parcelRequire("aIziS");

var $dJOTt = parcelRequire("dJOTt");
const $568f3fe637e35304$export$dd40a625fe2da362 = ({ fragmentRef: fragmentRef, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, spacing: spacing = 'default' })=>{
    const data = (0, $iWLL0.useFragment)((0, $j8MQe.default), fragmentRef);
    const [commit] = (0, $iWLL0.useMutation)((0, $5mZJ3.default));
    const { id: uniqueFieldId, name: fieldName, fieldOption: fieldOption, fieldConfig: fieldConfig } = data;
    const [isEditing, setIsEditing] = (0, $K1Vl8.useOptionallyControlledEditingState)(false, uniqueFieldId);
    const [errorMessage, setErrorMessage] = (0, $eUqFw.useState)(null);
    const { overriding: overriding } = (0, $646aD.useInlineEditFieldInjections)();
    const isFieldEditable = overriding.overrideIsEditable(fieldConfig?.isEditable ?? false);
    const filterOptionsById = overriding.overrideFieldOptionsFilter(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onCancelRequest = (0, $eUqFw.useCallback)(()=>{
        setErrorMessage(null);
        setIsEditing(false);
    }, [
        setIsEditing
    ]);
    const onEditRequest = (0, $eUqFw.useCallback)(()=>{
        setErrorMessage(null);
        setIsEditing(true);
    }, [
        setIsEditing
    ]);
    const onCommitError = (0, $eUqFw.useCallback)((responseErrors)=>{
        const responseErrorMessage = responseErrors?.[0]?.message || formatMessage((0, $dJOTt.default).failedSave);
        setErrorMessage(responseErrorMessage);
        setIsEditing(true);
        onSubmitFailed?.();
    }, [
        formatMessage,
        setIsEditing,
        onSubmitFailed
    ]);
    const onCommitCompleted = (0, $eUqFw.useCallback)((response, newOption)=>{
        if (!response.jira?.updateSingleSelectField) {
            onCommitError([]);
            return;
        }
        const { success: success, errors: responseErrors } = response.jira.updateSingleSelectField;
        if (!success) {
            onCommitError(responseErrors);
            return;
        }
        onSubmitSucceeded?.(newOption);
    }, [
        onCommitError,
        onSubmitSucceeded
    ]);
    const handleNewValue = (0, $eUqFw.useCallback)((newOption)=>{
        // Clear errors and exit editing mode
        setErrorMessage(null);
        setIsEditing(false); // Execute mutation
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: newOption?.value ?? null
                    }
                }
            },
            onCompleted (response) {
                onCommitCompleted(response, newOption);
            },
            onError (error) {
                onCommitError([
                    {
                        message: error.message
                    }
                ]);
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            optimisticResponse: {
                jira: {
                    updateSingleSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldOption: newOption != null ? {
                                id: newOption?.value,
                                optionId: newOption?.optionId,
                                value: newOption?.label
                            } : null,
                            fieldConfig: {
                                isEditable: true
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldName,
        onCommitCompleted,
        onCommitError,
        setIsEditing,
        uniqueFieldId
    ]);
    const onConfirmRequest = (0, $eUqFw.useCallback)(()=>{
        setIsEditing(false);
    }, [
        setIsEditing
    ]);
    const onChangeRequest = (value)=>{
        handleNewValue(value);
        onSubmit?.(value);
    };
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($568f3fe637e35304$var$ReadViewContainer, {
            "data-testid": "issue-field-single-select-inline-edit-full.ui.single-select.read-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aIziS.SingleSelectReadView), {
            fragmentRef: data
        }));
    const renderEditView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, errorMessage !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $568f3fe637e35304$var$errorMessageWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iwV3u.SingleSelectEditView), {
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            filterOptionsById: filterOptionsById,
            value: fieldOption ? {
                label: fieldOption.value ?? '',
                value: fieldOption.id ?? ''
            } : undefined,
            onChange: onChangeRequest,
            autoFocus: true,
            spacing: spacing,
            ...(0, $1ybV0.ff)('select-field-dropdown-opening-issue_oke9p') ? {
                openMenuOnFocus: true
            } : {}
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($568f3fe637e35304$var$InlineEditContainer, {
        isEditable: isFieldEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        testId: "issue-field-single-select-inline-edit-full.ui.single-select.field-inline-edit-state-less",
        isLabelHidden: true,
        label: fieldName,
        readView: renderReadView,
        editView: renderEditView,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        hideActionButtons: true,
        readViewFitContainerWidth: true,
        onConfirm: onConfirmRequest,
        onCancel: onCancelRequest,
        onEdit: onEditRequest,
        editButtonLabel: formatMessage((0, $dJOTt.default).editButtonLabel, {
            fieldName: fieldName
        }),
        confirmButtonLabel: formatMessage((0, $dJOTt.default).confirmButtonLabel, {
            fieldName: fieldName
        }),
        cancelButtonLabel: formatMessage((0, $dJOTt.default).cancelButtonLabel, {
            fieldName: fieldName
        })
    }));
};
const $568f3fe637e35304$var$ReadViewContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($568f3fe637e35304$var$ReadViewContainerStyles, {
        "data-component-selector": $568f3fe637e35304$var$readViewContainerSelectorName,
        ...props
    });
const $568f3fe637e35304$var$readViewContainerSelectorName = 'jira-issue-view-select-inline-edit-read-view-container';
const $568f3fe637e35304$var$READ_VIEW_CONTAINER_COMPONENT_SELECTOR = `[data-component-selector="${$568f3fe637e35304$var$readViewContainerSelectorName}"]`;
const $568f3fe637e35304$var$nonEditableStyles = {
    [$568f3fe637e35304$var$READ_VIEW_CONTAINER_COMPONENT_SELECTOR]: {
        /* First tag is always mis-aligned so use the container padding to position the field */ paddingLeft: "var(--ds-space-075, 6px)",
        /* Side-by-side style overrides clashing with tags */ '& > div > div > div': {
            padding: 0
        }
    }
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $568f3fe637e35304$var$InlineEditContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _18u0x0bf _19pkx0bf _1gzc1txw _auuz1h6o _6vgs1osq _1rjezwfg _osjgidpf _alyvidpf _pa3x12x7 _2g9bidpf",
            !__cmplp.isEditable && "_mqi112x7 _1fm6idpf _gndiidpf _10hoidpf _hiluidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $568f3fe637e35304$var$ReadViewContainerStyles = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _1nmz1hna _kqswh2mm _vwz48sxn",
            __cmplp.className
        ])
    });
});
const $568f3fe637e35304$var$errorMessageWrapperStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.075'
});

});
parcelRegister("5mZJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b41572661a88bd3b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<64a42f72ca311d07de8b4b087b3db4a5>>
 * @relayHash 8cb16d718b8a652de5bcc691f9ceb179
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0dfa05a481ef015a18bdd0efe193900d020073fe872039fbe9222dc48e073402
const $b41572661a88bd3b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "singleSelect_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "fieldOption",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "optionId"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraFieldConfig",
                                            "kind": "LinkedField",
                                            "name": "fieldConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0dfa05a481ef015a18bdd0efe193900d020073fe872039fbe9222dc48e073402",
            "metadata": {},
            "name": "singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b41572661a88bd3b$var$node.hash = "dde6d33d65044027e5ae40fdf07231ee";
var $b41572661a88bd3b$export$2e2bcd8739ae039 = $b41572661a88bd3b$var$node;

});

parcelRegister("j8MQe", function(module, exports) {

$parcel$export(module.exports, "default", () => $236b5b3c2466f181$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfa8cbe967f5bb5dd27da79d384ad886>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $236b5b3c2466f181$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "singleSelect_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditView",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "FragmentSpread",
                "name": "singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView"
            },
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "optionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectField"
    };
}();
$236b5b3c2466f181$var$node.hash = "8030967bf2f129b5f4d217607e8f5dc1";
var $236b5b3c2466f181$export$2e2bcd8739ae039 = $236b5b3c2466f181$var$node;

});

parcelRegister("iwV3u", function(module, exports) {

$parcel$export(module.exports, "SingleSelectEditView", () => $e821eecc86bcfb7e$export$dbbc0b6b559d9506);

var $44njx = parcelRequire("44njx");

var $jXuTo = parcelRequire("jXuTo");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $4zgIJ = parcelRequire("4zgIJ");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4Hwcq = parcelRequire("4Hwcq");

var $4NcaX = parcelRequire("4NcaX");

var $4bMJ9 = parcelRequire("4bMJ9");

var $2jdHI = parcelRequire("2jdHI");

var $9zItN = parcelRequire("9zItN");

var $38F6k = parcelRequire("38F6k");

var $7KCVv = parcelRequire("7KCVv");
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
const $e821eecc86bcfb7e$var$filterOptions = (option, query)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase());
const $e821eecc86bcfb7e$var$getSuggestionsVariables = (id, queryString, filterOptionsById, first)=>({
        id: id,
        searchBy: queryString || '',
        filterById: filterOptionsById,
        first: first
    });
const $e821eecc86bcfb7e$export$e9ffe3eaa3f3f991 = ({ fieldId: fieldId, fieldOptionsFragmentRef: fieldOptionsFragmentRef, value: value, fieldName: fieldName = '', onChange: onChange, isDisabled: isDisabled = false, isInvalid: isInvalid = false, filterOptionsById: filterOptionsById = null, autoFocus: autoFocus = false, spacing: spacing = 'default', openMenuOnFocus: openMenuOnFocus })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [searchByString, setSearchByString] = (0, $eUqFw.useState)('');
    // vvv --- Relay stuff --- vvv
    const { data: fieldOptionsData, refetch: refetchSuggestions } = (0, $iWLL0.usePaginationFragment)((0, $jXuTo.default), fieldOptionsFragmentRef);
    const [refetchAndPropCallback, isLoading, lastFetchError] = (0, $4bMJ9.useSuspenselessRefetch)((0, $9zItN.default), refetchSuggestions);
    const [debouncedSuggestionsRefetcher] = (0, $2jdHI.default)(refetchAndPropCallback, (0, $4Hwcq.SEARCH_DEBOUNCE_TIMEOUT));
    const [leadingEdgeDebouncedSuggestionsRefetcher] = (0, $2jdHI.default)(refetchAndPropCallback, (0, $4Hwcq.SEARCH_DEBOUNCE_TIMEOUT), {
        leading: true
    });
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        leadingEdgeDebouncedSuggestionsRefetcher($e821eecc86bcfb7e$var$getSuggestionsVariables(fieldId, searchByString, filterOptionsById, (0, $4Hwcq.FRAGMENT_FIELD_OPTIONS_FIRST)));
    }, [
        leadingEdgeDebouncedSuggestionsRefetcher,
        fieldId,
        searchByString,
        filterOptionsById
    ]);
    const onSearchByStringChangeFunction = (0, $eUqFw.useCallback)((newSearchByString)=>{
        setSearchByString(newSearchByString);
        debouncedSuggestionsRefetcher($e821eecc86bcfb7e$var$getSuggestionsVariables(fieldId, newSearchByString, filterOptionsById, (0, $4Hwcq.FRAGMENT_FIELD_OPTIONS_FIRST)));
    }, [
        debouncedSuggestionsRefetcher,
        fieldId,
        filterOptionsById
    ]);
    const options = (0, $eUqFw.useMemo)(()=>lastFetchError === null ? fieldOptionsData?.node?.fieldOptions?.edges?.map((edge)=>edge?.node).filter(Boolean).map(({ label: label, value: optionValue, optionId: optionId, isDisabled: isOptionDisabled })=>({
                label: label ?? '',
                value: optionValue,
                optionId: optionId,
                isDisabled: isOptionDisabled
            })) ?? [] : [
            {
                label: formatMessage((0, $38F6k.default).failedFetch),
                value: '',
                optionId: '',
                isDisabled: true
            }
        ], [
        fieldOptionsData?.node?.fieldOptions?.edges,
        lastFetchError,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), {
        isInvalid: isInvalid,
        isDisabled: isDisabled,
        options: (0, $7KCVv.getOptionsWithoutSelected)(options, value),
        onFocus: onFocus,
        isLoading: isLoading,
        onInputChange: onSearchByStringChangeFunction,
        filterOption: $e821eecc86bcfb7e$var$filterOptions,
        loadingMessage: ()=>formatMessage((0, $38F6k.default).loading),
        noOptionsMessage: ()=>formatMessage((0, $38F6k.default).empty),
        value: value,
        placeholder: formatMessage((0, $38F6k.default).placeholder, {
            fieldName: fieldName
        }),
        onChange: onChange,
        autoFocus: autoFocus,
        menuPosition: "fixed",
        isClearable: true,
        styles: (0, $4NcaX.defaultSelectStyles),
        spacing: spacing,
        openMenuOnFocus: (0, $1ybV0.ff)('select-field-dropdown-opening-issue_oke9p') ? openMenuOnFocus : true
    });
};
const $e821eecc86bcfb7e$export$dbbc0b6b559d9506 = (props)=>{
    const suggestionsData = (0, $iWLL0.useLazyLoadQuery)((0, $44njx.default), {
        id: props.fieldId,
        filterById: props.filterOptionsById
    }, {
        fetchPolicy: 'store-only'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e821eecc86bcfb7e$export$e9ffe3eaa3f3f991, {
        ...props,
        fieldOptionsFragmentRef: suggestionsData
    });
};

});
parcelRegister("44njx", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0c92d9c7b65abda$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8e900ffd34834bc23b51a70d0e7a357f>>
 * @relayHash 5058697198d8a07cbcd16dbed48a1713
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 40e97fb409bce2f7bc7073de0f1dd1e926440b0f988f637a1fd56d39b2ee4578
const $f0c92d9c7b65abda$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterById"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v3 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v4 = {
        "kind": "Literal",
        "name": "searchBy",
        "value": ""
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        },
        v4 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "singleSelect_SingleSelect_suggestionsQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "singleSelect_issueFieldSingleSelectEditviewFull_SingleSelectEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "singleSelect_SingleSelect_suggestionsQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "optionId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isDisabled"
                                                        },
                                                        v7 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v6 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "main_issueFieldSingleSelectEditviewFull__fieldOptions",
                                    "kind": "LinkedHandle",
                                    "name": "fieldOptions"
                                }
                            ],
                            "type": "JiraSingleSelectField"
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "40e97fb409bce2f7bc7073de0f1dd1e926440b0f988f637a1fd56d39b2ee4578",
            "metadata": {},
            "name": "singleSelect_SingleSelect_suggestionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f0c92d9c7b65abda$var$node.hash = "4e33b70da34aeea67c6630a98333d3b5";
var $f0c92d9c7b65abda$export$2e2bcd8739ae039 = $f0c92d9c7b65abda$var$node;

});

parcelRegister("jXuTo", function(module, exports) {

$parcel$export(module.exports, "default", () => $53769eeae8680d68$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<873d12becf3b0afd79628d13378b0567>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $9zItN = parcelRequire("9zItN");
const $53769eeae8680d68$var$node = function() {
    var v0 = [
        "node",
        "fieldOptions"
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filterById"
            },
            {
                "defaultValue": 100,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "id"
            },
            {
                "defaultValue": "",
                "kind": "LocalArgument",
                "name": "searchBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $9zItN.default)
            }
        },
        "name": "singleSelect_issueFieldSingleSelectEditviewFull_SingleSelectEditViewWithFieldOptionsFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "id"
                    }
                ],
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": "fieldOptions",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "filterById",
                                        "variableName": "filterById"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "searchBy",
                                        "variableName": "searchBy"
                                    }
                                ],
                                "concreteType": "JiraOptionConnection",
                                "kind": "LinkedField",
                                "name": "__main_issueFieldSingleSelectEditviewFull__fieldOptions_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraOptionEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": "value",
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    },
                                                    {
                                                        "alias": "label",
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "optionId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isDisabled"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraSingleSelectField"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$53769eeae8680d68$var$node.hash = "486432386804a49898ed5dad76c1f148";
var $53769eeae8680d68$export$2e2bcd8739ae039 = $53769eeae8680d68$var$node;

});
parcelRegister("9zItN", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f369e65e4a02df$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2dd6bcd273ad87694a7c703c86c654e5>>
 * @relayHash a9db3f2f9d36f0fcdf6cd82148289d9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ac325b338576722cf180666afab3d18763b7e18c34cebb0b8c66c5f968064c84
const $85f369e65e4a02df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        },
        {
            "defaultValue": 100,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "searchBy"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v2 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v3 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v4 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v5 = {
        "kind": "Variable",
        "name": "searchBy",
        "variableName": "searchBy"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "singleSelectFieldOptions_singleSelectEditView",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "singleSelect_issueFieldSingleSelectEditviewFull_SingleSelectEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "singleSelectFieldOptions_singleSelectEditView",
            "selections": [
                {
                    "args": [
                        v4 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "optionId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isDisabled"
                                                        },
                                                        v8 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "main_issueFieldSingleSelectEditviewFull__fieldOptions",
                                    "kind": "LinkedHandle",
                                    "name": "fieldOptions"
                                }
                            ],
                            "type": "JiraSingleSelectField"
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "ac325b338576722cf180666afab3d18763b7e18c34cebb0b8c66c5f968064c84",
            "metadata": {},
            "name": "singleSelectFieldOptions_singleSelectEditView",
            "operationKind": "query",
            "text": null
        }
    };
}();
$85f369e65e4a02df$var$node.hash = "486432386804a49898ed5dad76c1f148";
var $85f369e65e4a02df$export$2e2bcd8739ae039 = $85f369e65e4a02df$var$node;

});


parcelRegister("38F6k", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba4df7622567c1a6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ba4df7622567c1a6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    empty: {
        "id": "issue-field-single-select-editview-full.single-select.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-single-select-editview-full.single-select.failed-fetch",
        "defaultMessage": "Search failed."
    },
    loading: {
        "id": "issue-field-single-select-editview-full.single-select.loading",
        "defaultMessage": "Searching..."
    },
    placeholder: {
        "id": "issue-field-single-select-editview-full.single-select.placeholder",
        "defaultMessage": "Select {fieldName}"
    },
    queryError: {
        "id": "issue-field-single-select-editview-full.single-select.query-error",
        "defaultMessage": "Search failed."
    }
});

});

parcelRegister("7KCVv", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithoutSelected", () => $b8fea0e9058e1347$export$5ceedd0cd4688808);
const $b8fea0e9058e1347$export$5ceedd0cd4688808 = (selectOptions, selectedValue)=>selectOptions.filter((option)=>option.label !== selectedValue?.label && option.value !== selectedValue?.value);

});


parcelRegister("aIziS", function(module, exports) {

$parcel$export(module.exports, "SingleSelectReadView", () => $bcc4a206e34648a0$export$68bfa072e694358d);

var $8U9Uq = parcelRequire("8U9Uq");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $cRXCh = parcelRequire("cRXCh");
const $bcc4a206e34648a0$export$68bfa072e694358d = (props)=>{
    const { fragmentRef: fragmentRef } = props;
    const data = (0, $iWLL0.useFragment)((0, $8U9Uq.default), fragmentRef);
    if (!data.fieldOption?.value) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cRXCh.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, data.fieldOption.value);
};

});
parcelRegister("8U9Uq", function(module, exports) {

$parcel$export(module.exports, "default", () => $75d1f110e632230e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4049d631d59296f8d7909feb548be4a6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $75d1f110e632230e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView",
    "selections": [
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "fieldOption",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectField"
};
$75d1f110e632230e$var$node.hash = "6c27b0c3f4b268dcf2e659dd33a134c7";
var $75d1f110e632230e$export$2e2bcd8739ae039 = $75d1f110e632230e$var$node;

});


parcelRegister("dJOTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e52f326a746ef0c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4e52f326a746ef0c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    empty: {
        "id": "issue-field-single-select-inline-edit-full.single-select.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-single-select-inline-edit-full.single-select.failed-fetch",
        "defaultMessage": "Search failed."
    },
    failedSave: {
        "id": "issue-field-single-select-inline-edit-full.single-select.failed-save",
        "defaultMessage": "The value could not be saved"
    },
    reloadIssue: {
        "id": "issue-field-single-select-inline-edit-full.single-select.reload-issue",
        "defaultMessage": "Try reloading the issue."
    },
    confirmButtonLabel: {
        "id": "issue-field-single-select-inline-edit-full.single-select.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "issue-field-single-select-inline-edit-full.single-select.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "issue-field-single-select-inline-edit-full.single-select.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    }
});

});




parcelRegister("eSV6n", function(module, exports) {

$parcel$export(module.exports, "RelayLayoutItemErrorBoundary", () => $de4463c321802dc0$export$5ad04560367dd5f2);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");
const $de4463c321802dc0$var$renderContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
const $de4463c321802dc0$export$5ad04560367dd5f2 = ({ children: children, itemName: itemName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: `${itemName}-relay-layout-item`,
        packageName: "jiraIssueView",
        teamName: "bento",
        render: $de4463c321802dc0$var$renderContent
    }, children);

});

parcelRegister("eZ9k7", function(module, exports) {

$parcel$export(module.exports, "isRelayDataReady", () => $25e85b8f41c050ee$export$6b5d0c84ed5fbeeb);
const $25e85b8f41c050ee$export$6b5d0c84ed5fbeeb = (relayData)=>relayData !== null;

});


parcelRegister("6VJRG", function(module, exports) {

$parcel$export(module.exports, "isSortingPinnedFieldsEnabled", () => $de8acfdc0e312c10$export$cce5c39a2a1dacf1);

var $1ybV0 = parcelRequire("1ybV0");
const $de8acfdc0e312c10$export$cce5c39a2a1dacf1 = ()=>(0, $1ybV0.ff)('issue.details.sorting-pinned-fields', false);
const $de8acfdc0e312c10$export$9c7fa56ed1fa2e15 = ()=>(0, $1ybV0.ff)('parent-field-in-issue-view_x4zn4', false); // </ksayapina>

});

parcelRegister("j1WdQ", function(module, exports) {

$parcel$export(module.exports, "SortableItemList", () => $576802ce8cc44f7c$export$f0da77cdb14ea8e1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1S8jG = parcelRequire("1S8jG");

var $fSMvP = parcelRequire("fSMvP");

var $4c90u = parcelRequire("4c90u");
parcelRequire("eo9PV");
var $9wCS5 = parcelRequire("9wCS5");
parcelRequire("gPx3x");
var $j2oqV = parcelRequire("j2oqV");

var $hPdNw = parcelRequire("hPdNw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7iWCF = parcelRequire("7iWCF");

var $e6iRT = parcelRequire("e6iRT");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $er4nR = parcelRequire("er4nR");

var $aWEAV = parcelRequire("aWEAV");

var $43aLY = parcelRequire("43aLY");
const $576802ce8cc44f7c$export$67c3ad65bb4c1b95 = ({ children: children, draggableId: draggableId, instanceId: instanceId, index: index, reorderItem: reorderItem, numItems: numItems, fieldName: fieldName, registerItem: registerItem })=>{
    const ref = (0, $eUqFw.useRef)(null);
    const { dragState: dragState } = (0, $e6iRT.useSortableItem)({
        draggableId: draggableId,
        index: index,
        ref: ref,
        isReorderEnabled: true,
        instanceId: instanceId
    });
    (0, $eUqFw.useEffect)(()=>{
        const element = ref.current;
        if (!element) return;
        return registerItem({
            draggableId: draggableId,
            element: element
        });
    }, [
        draggableId,
        registerItem
    ]);
    let positionVariant = 'standard';
    if (index === 0) positionVariant = 'first-item';
    else if (index === numItems - 1) positionVariant = 'last-item';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $43aLY.SortableItemContainer), {
        ref: ref,
        testId: "issue-view-layout-templates-item-list.ui.sortable-item-list.draggable-container",
        dragState: dragState,
        fieldName: fieldName,
        positionVariant: positionVariant
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $er4nR.ReorderMenu), {
        itemIndex: index,
        onReorderItem: reorderItem,
        numItems: numItems,
        fieldName: fieldName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($576802ce8cc44f7c$var$FieldContainer, {
        "data-testid": `${(0, $396f2604a25fc189$export$494c91a4923e8fd6)}${draggableId}`
    }, children));
};
const $576802ce8cc44f7c$export$f0da77cdb14ea8e1 = ({ droppableId: instanceId, items: items, onSortItems: onSortItems })=>{
    const itemEntities = items.reduce((acc, curr)=>{
        acc.ids.push(curr.id);
        acc.entities[curr.id] = curr.element;
        acc.fieldNames[curr.id] = curr.fieldName;
        return acc;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {
        ids: [],
        entities: {},
        fieldNames: {}
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [prevIds, setPrevIds] = (0, $eUqFw.useState)(itemEntities.ids);
    const [sortedIds, setSortedIds] = (0, $eUqFw.useState)(itemEntities.ids);
    const encodedIds = itemEntities.ids.join(',');
    const encodedPrevIds = prevIds.join(',');
    (0, $eUqFw.useEffect)(()=>{
        if (encodedIds !== encodedPrevIds) {
            const ids = encodedIds.split(',');
            setPrevIds(ids);
            setSortedIds(ids);
        }
    }, [
        encodedIds,
        encodedPrevIds
    ]);
    const intl = (0, $5JgJ2.default)();
    const { itemRegistry: itemRegistry, registerItem: registerItem } = (0, $7iWCF.useItemRegistry)(); /**
                          * Information about the last action is used for:
                          *
                          * 1. Triggering a post-move flash
                          * 2. Screen reader announcements
                          */ 
    const [lastAction, setLastAction] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (lastAction === null) return;
        if (lastAction.type === 'reorder') {
            const element = itemRegistry.get(lastAction.draggableId);
            if (!element) return;
            (0, $1S8jG.triggerPostMoveFlash)(element);
        }
    }, [
        itemRegistry,
        lastAction
    ]); /**
                                   * Common reorder handler used for both:
                                   *
                                   * - Drops through `pragmatic-drag-and-drop`
                                   * - Reorder menu interactions
                                   */ 
    const reorderItem = (0, $eUqFw.useCallback)(({ indexSource: indexSource, indexDestination: indexDestination })=>{
        if (indexDestination === indexSource) return;
        const draggableId = sortedIds[indexSource]; // Payload for Analytics
        // Added 1 to the indexSource and Destination as analytics requirements
        // required the positions starting from 1 (not 0)
        const payload = {
            initialPinPosition: indexSource + 1,
            newPinPosition: indexDestination + 1,
            fieldName: itemEntities.fieldNames[draggableId]
        };
        const event = createAnalyticsEvent({
            action: 'dropped',
            actionSubject: 'field',
            actionSubjectId: 'pinnedFields'
        });
        (0, $jMP2a.fireUIAnalytics)(event, 'pinnedFields', payload);
        const modifiedIds = (0, $j2oqV.reorder)({
            list: sortedIds,
            startIndex: indexSource,
            finishIndex: indexDestination
        });
        setSortedIds(modifiedIds);
        setLastAction({
            type: 'reorder',
            draggableId: draggableId,
            fieldName: itemEntities.fieldNames[draggableId],
            startPosition: indexSource + 1,
            endPosition: indexDestination + 1,
            numberOfItems: sortedIds.length
        });
        if (onSortItems) onSortItems(sortedIds[indexSource], sortedIds[indexDestination], indexSource > indexDestination);
    }, [
        createAnalyticsEvent,
        itemEntities.fieldNames,
        onSortItems,
        sortedIds
    ]);
    const onDragEnd = (0, $eUqFw.useCallback)(({ source: source, destination: destination })=>{
        if (!destination) return;
        if (!(0, $e6iRT.isSortableItemData)(source.data) || !(0, $e6iRT.isSortableItemData)(destination.data)) return;
        const indexSource = source.data.index;
        const indexDestination = (0, $4c90u.getReorderDestinationIndex)({
            startIndex: indexSource,
            closestEdgeOfTarget: (0, $fSMvP.extractClosestEdge)(destination.data),
            indexOfTarget: destination.data.index,
            axis: 'vertical'
        });
        reorderItem({
            indexSource: indexSource,
            indexDestination: indexDestination
        });
    }, [
        reorderItem
    ]);
    const onDragStart = (0, $eUqFw.useCallback)(({ draggableId: draggableId })=>{
        // When drag starts from the mouse drag (not keyboard) we want to exit the field's edit mode - such as closing the dropdowns, selects etc.
        // The mode will be 'FLUID' if the drag is via the mouse, and the mode is 'SNAP' when dragging is started via keyboard
        if (document.activeElement) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            document.activeElement.blur();
            if ((0, $lO4Or.DEV_SUMMARY_TYPE) === draggableId) // Simulate a click to close the development field popup
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            document.activeElement.click();
        }
    }, []);
    (0, $eUqFw.useEffect)(()=>(0, $9wCS5.monitorForElements)({
            canMonitor ({ source: source }) {
                return (0, $e6iRT.isSortableItemData)(source.data) && source.data.instanceId === instanceId;
            },
            onDragStart ({ source: source }) {
                if (!(0, $e6iRT.isSortableItemData)(source.data)) return;
                onDragStart({
                    draggableId: source.data.draggableId
                });
            },
            onDrop ({ location: location, source: source }) {
                const { dropTargets: dropTargets } = location.current;
                const destination = dropTargets.at(0) ?? null;
                onDragEnd({
                    source: source,
                    destination: destination
                });
            }
        }), [
        instanceId,
        onDragEnd,
        onDragStart
    ]);
    const liveRegion = (0, $eUqFw.useMemo)(()=>{
        if (lastAction) {
            if (lastAction.type === 'reorder') return {
                shouldAnnounce: true,
                message: intl.formatMessage((0, $aWEAV.default).postMoveAnnouncement, lastAction)
            };
        }
        return {
            shouldAnnounce: false,
            message: ''
        };
    }, [
        intl,
        lastAction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($576802ce8cc44f7c$var$SortableItemListContainer, {
        "data-testid": "issue-view-layout-templates-item-list.ui.sortable-item-list.droppable-container"
    }, sortedIds.map((id, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($576802ce8cc44f7c$export$67c3ad65bb4c1b95, {
            key: id,
            draggableId: id,
            instanceId: instanceId,
            index: index,
            reorderItem: reorderItem,
            numItems: sortedIds.length,
            fieldName: itemEntities.fieldNames[id],
            registerItem: registerItem
        }, itemEntities.entities[id]))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hPdNw.AnnouncerV2), {
        shouldAnnounce: liveRegion.shouldAnnounce,
        message: liveRegion.message,
        liveMode: "assertive"
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $576802ce8cc44f7c$var$FieldContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3td1b66 _16jlkb7n _1o9zkb7n _i0dlf1ug _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $576802ce8cc44f7c$var$SortableItemListContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkx0bf _otyrx0bf _18u0xmi2 _2hwxxmi2 _ca0qu2gc _n3tdu2gc _18zrze3t _1e0c1txw _2lx21bp4 _zulpu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1S8jG", function(module, exports) {

$parcel$export(module.exports, "triggerPostMoveFlash", () => $2d0189aad573ccaa$export$f5b5f29328df2633);

var $5LHuc = parcelRequire("5LHuc");
function $2d0189aad573ccaa$export$f5b5f29328df2633(element) {
    element.animate([
        {
            backgroundColor: "var(--ds-background-selected, #E9F2FF)"
        },
        {}
    ], {
        duration: (0, $5LHuc.largeDurationMs),
        /**
     * This is equivalent to the browser default, but we are making it
     * explicit to avoid relying on implicit behavior.
     *
     * This curve is not part of `@atlaskit/motion` but it was an intentional
     * design decision to use this curve.
     */ easing: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)',
        iterations: 1
    });
}

});

parcelRegister("fSMvP", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $2724dbed1c43baeb$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $2724dbed1c43baeb$export$945a571f3b658bf);
const $2724dbed1c43baeb$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $2724dbed1c43baeb$var$uniqueKey = Symbol('closestEdge');
function $2724dbed1c43baeb$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $2724dbed1c43baeb$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$2724dbed1c43baeb$var$uniqueKey]: addClosestEdge
    };
}
function $2724dbed1c43baeb$export$945a571f3b658bf(userData) {
    return userData[$2724dbed1c43baeb$var$uniqueKey] ?? null;
}

});

parcelRegister("4c90u", function(module, exports) {

$parcel$export(module.exports, "getReorderDestinationIndex", () => $aa4edc6717644668$export$846f792f51b92b6e);
function $aa4edc6717644668$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}

});

parcelRegister("eo9PV", function(module, exports) {

$parcel$export(module.exports, "draggable", () => (parcelRequire("9wCS5")).draggable);
$parcel$export(module.exports, "dropTargetForElements", () => (parcelRequire("9wCS5")).dropTargetForElements);
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("9wCS5")).monitorForElements);

var $9wCS5 = parcelRequire("9wCS5");

});
parcelRegister("9wCS5", function(module, exports) {

$parcel$export(module.exports, "dropTargetForElements", () => $713a693c74f5088c$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $713a693c74f5088c$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $713a693c74f5088c$export$c746a5152d4ba26c);

var $74BVL = parcelRequire("74BVL");

var $4PCWk = parcelRequire("4PCWk");

var $jFl9L = parcelRequire("jFl9L");

var $ggbKc = parcelRequire("ggbKc");

var $eDT75 = parcelRequire("eDT75");

var $kb9dc = parcelRequire("kb9dc");



const $713a693c74f5088c$var$draggableRegistry = new WeakMap();
function $713a693c74f5088c$var$addToRegistry(args) {
    $713a693c74f5088c$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $713a693c74f5088c$var$draggableRegistry.delete(args.element);
    };
}
const $713a693c74f5088c$var$adapter = (0, $4PCWk.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
		 * this adapter always gets preference over the text adapter.
		 * `document` is the first `EventTarget` under `window`
		 * https://twitter.com/alexandereardon/status/1604658588311465985
		 */ return (0, $74BVL.bind)(document, {
            type: 'dragstart',
            listener (event) {
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                const entry = $713a693c74f5088c$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                const input = (0, $kb9dc.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    const over = document.elementFromPoint(input.clientX, input.clientY);
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
				 *  **Goal**
				 *  Pass information to other applications
				 *
				 * **Approach**
				 *  Put data into the native data store
				 *
				 *  **What about the native adapter?**
				 *  When the element adapter puts native data into the native data store
				 *  the native adapter is not triggered in the current window,
				 *  but a native adapter in an external window _can_ be triggered
				 *
				 *  **Why bake this into core?**
				 *  This functionality could be pulled out and exposed inside of
				 *  `onGenerateDragPreview`. But decided to make it a part of the
				 *  base API as it felt like a common enough use case and ended
				 *  up being a similar amount of code to include this function as
				 *  it was to expose the hook for it
				 */ const nativeData = entry.getInitialDataForExternal?.(feedback) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
				 *  📱 For Android devices, a drag operation will not start unless
				 * "text/plain" or "text/uri-list" data exists in the native data store
				 * https://twitter.com/alexandereardon/status/1732189803754713424
				 *
				 * Tested on:
				 * Device: Google Pixel 5
				 * Android version: 14 (November 5, 2023)
				 * Chrome version: 120.0
				 */ const { types: types } = event.dataTransfer;
                if ((0, $eDT75.isAndroid)() && !types.includes((0, $559dbbdafee2f66d$export$fd3d00026297c0ad)) && !types.includes((0, $63b7ad043dd75799$export$bc594fb6cfea5e58))) event.dataTransfer.setData((0, $559dbbdafee2f66d$export$fd3d00026297c0ad), (0, $eDT75.androidFallbackText));
                /**
				 * 1. Must set any media type for `iOS15` to work
				 * 2. We are also doing adding data so that the native adapter
				 * can know that the element adapter has handled this drag
				 *
				 * We used to wrap this `setData()` in a `try/catch` for Firefox,
				 * but it looks like that was not needed.
				 *
				 * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
				 *
				 * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
				 * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
				 * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
				 *
				 * // just checking a few more combinations to be super safe
				 *
				 * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
				 * - ✅ Chrome@78 (Oct 2019) on Windows 10
				 * - ✅ Safari@14.1 on macOS Big Sur
				 */ event.dataTransfer.setData((0, $4df75fb0870d0fce$export$c9c4cc54e73b125d), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: entry.getInitialData?.(feedback) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        });
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        $713a693c74f5088c$var$draggableRegistry.get(payload.source.element)?.[eventName]?.(// I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    }
});
const $713a693c74f5088c$export$e7140b68045b5036 = $713a693c74f5088c$var$adapter.dropTarget;
const $713a693c74f5088c$export$59a074bac4c54f54 = $713a693c74f5088c$var$adapter.monitor;
function $713a693c74f5088c$export$c746a5152d4ba26c(args) {
    return (0, $jFl9L.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $713a693c74f5088c$var$adapter.registerUsage(), $713a693c74f5088c$var$addToRegistry(args), (0, $ggbKc.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
}

});
parcelRegister("4PCWk", function(module, exports) {

$parcel$export(module.exports, "makeAdapter", () => $e5ed704461f1a07b$export$2aa3a33160990d96);

var $jlxyb = parcelRequire("jlxyb");

var $buJNg = parcelRequire("buJNg");

var $gItnR = parcelRequire("gItnR");

var $j14G1 = parcelRequire("j14G1");
function $e5ed704461f1a07b$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $j14G1.makeMonitor)();
    const dropTargetAPI = (0, $gItnR.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource?.(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $jlxyb.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $jlxyb.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $buJNg.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("jlxyb", function(module, exports) {

$parcel$export(module.exports, "lifecycle", () => $6868b9e56fe4f659$export$3efdceeb8ca25c51);

var $74BVL = parcelRequire("74BVL");

var $coJJ5 = parcelRequire("coJJ5");

var $fURjR = parcelRequire("fURjR");

var $3olN2 = parcelRequire("3olN2");

var $kb9dc = parcelRequire("kb9dc");

var $9A5IM = parcelRequire("9A5IM");
const $6868b9e56fe4f659$var$globalState = {
    isActive: false
};
function $6868b9e56fe4f659$var$canStart() {
    return !$6868b9e56fe4f659$var$globalState.isActive;
}
function $6868b9e56fe4f659$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $6868b9e56fe4f659$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $6868b9e56fe4f659$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$6868b9e56fe4f659$var$canStart()) return;
    const initial = $6868b9e56fe4f659$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $6868b9e56fe4f659$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $6868b9e56fe4f659$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $9A5IM.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateDropTargets(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $6868b9e56fe4f659$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $kb9dc.getInput)(event);
        const nextDropTargets = getDropTargetsOver({
            target: event.target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $6868b9e56fe4f659$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateDropTargets({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateDropTargets({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $6868b9e56fe4f659$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $74BVL.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $coJJ5.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
					 * At this point we don't know if a drag is being cancelled,
					 * or if a drag is leaving the `window`.
					 *
					 * Both have:
					 *   1. "dragleave" (with `relatedTarget: null`)
					 *   2. "dragend" (a "dragend" can occur when outside the `window`)
					 *
					 * **Clearing drop targets**
					 *
					 * For either case we are clearing the the drop targets
					 *
					 * - cancelling: we clear drop targets in `"dragend"` anyway
					 * - leaving the `window`: we clear the drop targets (to clear stickiness)
					 *
					 * **Leaving the window and finishing the drag**
					 *
					 * _internal drags_
					 *
					 * - The drag continues when the user is outside the `window`
					 *   and can resume if the user drags back over the `window`,
					 *   or end when the user drops in an external `window`.
					 * - We will get a `"dragend"`, or we can listen for other
					 *   events to determine the drag is finished when the user re-enters the `window`).
					 *
					 * _external drags_
					 *
					 * - We conclude the drag operation.
					 * - We have no idea if the user will drag back over the `window`,
					 *   or if the drag ends elsewhere.
					 * - We will create a new drag if the user re-enters the `window`.
					 *
					 * **Not updating `input`**
					 *
					 * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
					 * Workaround: intentionally not updating `input` in "dragleave"
					 * rather than the users current input values
					 * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
					 * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
					 **/ updateDropTargets({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                /** If there are no drop targets, then we will get
					 * a "drop" event if:
					 * - `preventUnhandled()` is being used
					 * - there is an unmanaged drop target (eg another library)
					 * In these cases, it's up to the consumer
					 * to handle the drop if it's not over one of our drop targets
					 * - `preventUnhandled()` will cancel the "drop"
					 * - unmanaged drop targets can handle the "drop" how they want to
					 * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    // not applying our post drop fix as we are not managing the drop
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $6868b9e56fe4f659$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
                // Applying this fix after `dispatch.drop` so that frameworks have the opportunity
                // to update UI in response to a "onDrop".
                if (dragType.startedFrom === 'internal') (0, $3olN2.fixPostDragPointerBug)({
                    current: state.current
                });
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                cancel();
                // Applying this fix after `dispatch.drop` so that frameworks have the opportunity
                // to update UI in response to a "onDrop".
                if (dragType.startedFrom === 'internal') (0, $3olN2.fixPostDragPointerBug)({
                    current: state.current
                });
            }
        },
        ...(0, $fURjR.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $6868b9e56fe4f659$var$getNativeSetDragImage(event)
    });
}
function $6868b9e56fe4f659$var$setDropEffectOnEvent({ event: event, current: current }) {
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = current[0]?.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $6868b9e56fe4f659$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $kb9dc.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $6868b9e56fe4f659$export$3efdceeb8ca25c51 = {
    canStart: $6868b9e56fe4f659$var$canStart,
    start: $6868b9e56fe4f659$var$start
};

});
parcelRegister("coJJ5", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindow", () => $f35fe00a678b780a$export$57d220c74e84a273);

var $enquP = parcelRequire("enquP");

var $Fx8Dp = parcelRequire("Fx8Dp");

var $jivNo = parcelRequire("jivNo");

var $ehWpG = parcelRequire("ehWpG");
function $f35fe00a678b780a$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $Fx8Dp.isSafari)()) return (0, $jivNo.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 * (foreign element)
	 */ if ((0, $enquP.isFirefox)()) return (0, $ehWpG.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is `null` *(standard check)*
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("enquP", function(module, exports) {

$parcel$export(module.exports, "isFirefox", () => $e614166849bdfbc2$export$b7d78993b74f766d);

var $KsGIL = parcelRequire("KsGIL");
const $e614166849bdfbc2$export$b7d78993b74f766d = (0, $KsGIL.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("KsGIL", function(module, exports) {

$parcel$export(module.exports, "once", () => $60659947ef15ccf3$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $60659947ef15ccf3$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("Fx8Dp", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $4c39b3d87a6f2982$export$95df08bae54cb4df);

var $KsGIL = parcelRequire("KsGIL");
const $4c39b3d87a6f2982$export$95df08bae54cb4df = (0, $KsGIL.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("jivNo", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindowInSafari", () => $988fa06fa869765d$export$f21837c338005454);

var $74BVL = parcelRequire("74BVL");

var $Fx8Dp = parcelRequire("Fx8Dp");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
const $988fa06fa869765d$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $988fa06fa869765d$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $Fx8Dp.isSafari)()) return false;
    return dragEnter.hasOwnProperty($988fa06fa869765d$var$symbols.isEnteringWindow);
}
function $988fa06fa869765d$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $Fx8Dp.isSafari)()) return false;
    return dragLeave.hasOwnProperty($988fa06fa869765d$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $Fx8Dp.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $74BVL.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$988fa06fa869765d$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$988fa06fa869765d$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("ehWpG", function(module, exports) {

$parcel$export(module.exports, "isFromAnotherWindow", () => $395b6cf20e8aa0ab$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $395b6cf20e8aa0ab$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $395b6cf20e8aa0ab$export$e46810fef53b5b0e(eventTarget) {
    return $395b6cf20e8aa0ab$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("fURjR", function(module, exports) {

$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $e1eef5448bb32238$export$ac5e5b0daf997b2);
function $e1eef5448bb32238$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("3olN2", function(module, exports) {

$parcel$export(module.exports, "fixPostDragPointerBug", () => $9293f42d869b0ff2$export$23c848971c0ad9ac);

var $74BVL = parcelRequire("74BVL");
/** Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $9293f42d869b0ff2$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
/**
 * Allow the user to continue to interact with the element their pointer is over at the end of the drag.
 * This is important to allow the user to be able to click, drag (etc) after they have finished a drag
 *
 * @returns a `cleanup` function to restore all elements under the users pointer to their original state
 */ function $9293f42d869b0ff2$var$allowPointerEventsOnElementUnderPointer({ current: current }) {
    const underUsersPointer = document.elementFromPoint(current.input.clientX, current.input.clientY);
    if (!(underUsersPointer instanceof HTMLElement)) return null;
    // Debug note: change from 'pointer-events: none' to 'background: green'
    // to get a better sense of what is being achieved
    return $9293f42d869b0ff2$var$setStyle(underUsersPointer, {
        property: 'pointer-events',
        rule: 'auto',
        priority: 'important'
    });
}
function $9293f42d869b0ff2$var$blockPointerEventsOnEverything() {
    const element = document.createElement('style');
    // Adding a data attribute so to make it super clear to consumers
    // (and to our tests) what this temporary style tag is for
    element.setAttribute('pdnd-post-drag-fix', 'true');
    document.head.appendChild(element);
    // Debug note: change from 'pointer-events: none' to 'background: red'
    // to get a better sense of what is being achieved
    element.sheet?.insertRule('* { pointer-events: none !important; }');
    return function cleanup() {
        document.head.removeChild(element);
    };
}
function $9293f42d869b0ff2$export$23c848971c0ad9ac({ current: current }) {
    // Queuing a microtask to give any opportunity for frameworks to update their UI in a microtask
    // Note: react@18 does standard state updates in a microtask
    // We do this so our `atDestination` gets the _actual_ element that is under the users pointer
    // at the end of the drag.
    queueMicrotask(()=>{
        const undoUnderPointer = $9293f42d869b0ff2$var$allowPointerEventsOnElementUnderPointer({
            current: current
        });
        // This will also block pointer-events on the children of the element under the users pointer.
        // This is what we want. If the user drops on a container element we don't want the children
        // of the container to be incorrectly entered into
        const undoGlobalBlock = $9293f42d869b0ff2$var$blockPointerEventsOnEverything();
        function cleanup() {
            unbindEvents();
            undoUnderPointer?.();
            undoGlobalBlock();
        }
        const unbindEvents = (0, $74BVL.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` is more likely to not be impacted by consumers stopping events
            capture: true
        });
    });
}

});

parcelRegister("kb9dc", function(module, exports) {

$parcel$export(module.exports, "getInput", () => $661957bb1ab51692$export$7c112ceec8941e67);
function $661957bb1ab51692$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("9A5IM", function(module, exports) {

$parcel$export(module.exports, "makeDispatch", () => $6674e392a266d08a$export$9f13ecc44e83d682);

var $8yx6O = parcelRequire("8yx6O");
const $6674e392a266d08a$var$scheduleOnDrag = (0, $8yx6O.default)((fn)=>fn());
const $6674e392a266d08a$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $6674e392a266d08a$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $6674e392a266d08a$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $6674e392a266d08a$var$dragStart.flush();
            $6674e392a266d08a$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $6674e392a266d08a$var$scheduleOnDrag(()=>{
                $6674e392a266d08a$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $6674e392a266d08a$var$dragStart.flush();
            $6674e392a266d08a$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});


parcelRegister("buJNg", function(module, exports) {

$parcel$export(module.exports, "register", () => $16255e18a8cdf5a6$export$6503ec6e8aabbaf);
const $16255e18a8cdf5a6$var$ledger = new Map();
function $16255e18a8cdf5a6$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $16255e18a8cdf5a6$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $16255e18a8cdf5a6$var$ledger.set(typeKey, initial);
    return initial;
}
function $16255e18a8cdf5a6$export$6503ec6e8aabbaf(args) {
    const entry = $16255e18a8cdf5a6$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $16255e18a8cdf5a6$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("gItnR", function(module, exports) {

$parcel$export(module.exports, "makeDropTarget", () => $4df313649e179712$export$47d10e7bd9c81890);

var $jFl9L = parcelRequire("jFl9L");

var $ggbKc = parcelRequire("ggbKc");
function $4df313649e179712$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $4df313649e179712$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        return (0, $jFl9L.combine)((0, $ggbKc.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = args.getData?.(feedback) ?? {};
        const dropEffect = args.getDropEffect?.(feedback) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry?.[eventName]?.(// I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry?.onDropTargetChange?.(args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) entry?.onDragLeave?.(args);
            }
            for (const record of payload.location.current.dropTargets){
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry?.onDropTargetChange?.(args);
                entry?.onDragEnter?.(args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $4df313649e179712$var$copyReverse(current);
        const actualCaptureOrdered = $4df313649e179712$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if (parent?.element !== lastParent?.element) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!argsForLast.getIsSticky?.(feedback)) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $4df313649e179712$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("jFl9L", function(module, exports) {

$parcel$export(module.exports, "combine", () => $e825059ee70ef631$export$1be1fc439b849fdf);
function $e825059ee70ef631$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});

parcelRegister("ggbKc", function(module, exports) {

$parcel$export(module.exports, "addAttribute", () => $df9d12eec6804e85$export$5dcb5c23b6ba980a);
function $df9d12eec6804e85$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("j14G1", function(module, exports) {

$parcel$export(module.exports, "makeMonitor", () => $aec9bd094a175c02$export$5dd4ed888d5b12ca);
function $aec9bd094a175c02$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        return function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        };
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) // @ts-expect-error: I cannot get this type working!
        monitor[eventName]?.(payload);
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("eDT75", function(module, exports) {

$parcel$export(module.exports, "isAndroid", () => $773300f3a724036a$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $773300f3a724036a$export$aceb3ed8b7f7bd2c);

var $KsGIL = parcelRequire("KsGIL");
const $773300f3a724036a$export$a11b0059900ceec8 = (0, $KsGIL.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $773300f3a724036a$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $559dbbdafee2f66d$export$fd3d00026297c0ad = 'text/plain';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $63b7ad043dd75799$export$bc594fb6cfea5e58 = 'text/uri-list';

/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $4df75fb0870d0fce$export$c9c4cc54e73b125d = 'application/vnd.pdnd';



parcelRegister("gPx3x", function(module, exports) {

$parcel$export(module.exports, "reorder", () => (parcelRequire("j2oqV")).reorder);

var $j2oqV = parcelRequire("j2oqV");

});
parcelRegister("j2oqV", function(module, exports) {

$parcel$export(module.exports, "reorder", () => $6e81661ae370c059$export$fc77a6137e3f91c);
/**
 * Reorder a provided `list`
 * Returns a new array and does not modify the original array
 */ function $6e81661ae370c059$export$fc77a6137e3f91c({ list: list, startIndex: startIndex, finishIndex: finishIndex }) {
    if (startIndex === -1 || finishIndex === -1) return list;
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(finishIndex, 0, removed);
    return result;
}

});


parcelRegister("hPdNw", function(module, exports) {

$parcel$export(module.exports, "AnnouncerV2", () => $f3fdf175d37cb8cd$export$a43c8a2f4981e0e);

var $eUqFw = parcelRequire("eUqFw");

var $kjXsi = parcelRequire("kjXsi");
const $f3fdf175d37cb8cd$var$NON_BREAKING_SPACE = '\u00A0';
const $f3fdf175d37cb8cd$export$a43c8a2f4981e0e = /*#__PURE__*/ (0, $eUqFw.memo)(({ message: originalMessage, liveMode: liveMode = 'polite', shouldAnnounce: shouldAnnounce = true, testId: testId })=>{
    const previousMessage = (0, $eUqFw.useRef)('');
    const setAlternatePolite = (0, $eUqFw.useRef)(false);
    const addSuffix = (0, $eUqFw.useRef)(false);
    const [oldMessage, setOldMessage] = (0, $eUqFw.useState)('');
    const [newMessage, setNewMessage] = (0, $eUqFw.useState)('');
    (0, $eUqFw.useEffect)(()=>{
        let message = shouldAnnounce ? originalMessage : $f3fdf175d37cb8cd$var$NON_BREAKING_SPACE;
        if (previousMessage.current === message) {
            addSuffix.current = !addSuffix.current;
            if (addSuffix.current) message += $f3fdf175d37cb8cd$var$NON_BREAKING_SPACE;
        }
        setOldMessage(setAlternatePolite.current ? '' : message);
        setNewMessage(setAlternatePolite.current ? message : '');
        if (shouldAnnounce) setAlternatePolite.current = !setAlternatePolite.current;
        previousMessage.current = originalMessage;
    }, [
        originalMessage,
        shouldAnnounce
    ]);
    // 2 aria-live containers needed to prevent bugs in browsers that will stop
    // announcing updates to the same div if these are too repetitive.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, oldMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, newMessage));
});

});

parcelRegister("7iWCF", function(module, exports) {

$parcel$export(module.exports, "useItemRegistry", () => $66e101544112f8d5$export$58aad4857e49d9dc);

var $eUqFw = parcelRequire("eUqFw");
/**
 * Used to collect the `HTMLElement` rendered by each sortable item.
 *
 * This is used for triggering the flash animation after moving an item.
 */ function $66e101544112f8d5$var$createItemRegistry() {
    const itemRegistry = new Map();
    const registerItem = ({ draggableId: draggableId, element: element })=>{
        itemRegistry.set(draggableId, element);
        return ()=>{
            itemRegistry.delete(draggableId);
        };
    };
    return {
        itemRegistry: itemRegistry,
        registerItem: registerItem
    };
}
function $66e101544112f8d5$export$58aad4857e49d9dc() {
    const [instance] = (0, $eUqFw.useState)($66e101544112f8d5$var$createItemRegistry);
    return instance;
}

});

parcelRegister("e6iRT", function(module, exports) {

$parcel$export(module.exports, "isSortableItemData", () => $5eaae2086e349cca$export$18111f3dfa2a2cf5);
$parcel$export(module.exports, "useSortableItem", () => $5eaae2086e349cca$export$8456f75e7ee3d163);

var $eUqFw = parcelRequire("eUqFw");

var $fSMvP = parcelRequire("fSMvP");
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");
parcelRequire("eo9PV");
var $9wCS5 = parcelRequire("9wCS5");
parcelRequire("dxB16");
var $7CaTR = parcelRequire("7CaTR");
parcelRequire("bweg7");
var $jfbwa = parcelRequire("jfbwa");
const $5eaae2086e349cca$var$idleState = {
    type: 'idle'
};
const $5eaae2086e349cca$var$draggingState = {
    type: 'dragging'
};
/**
 * We want to hide the drop indicator if it would display next to the dragging
 * item, because that would be a no-op drop.
 */ function $5eaae2086e349cca$var$getShouldRenderDropIndicator({ edge: edge, sourceIndex: sourceIndex, index: index }) {
    /**
   * Hide drop indicator when dragging over the source item.
   */ if (sourceIndex === index) return false;
    /**
   * Hide drop indicator when over the bottom of the item before.
   */ if (edge === 'bottom' && index === sourceIndex - 1) return false;
    /**
   * Hide drop indicator when over the top of the item after.
   */ if (edge === 'top' && index === sourceIndex + 1) return false;
    return true;
}
function $5eaae2086e349cca$var$isShallowEqual(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    return Object.entries(a).every(([key, value])=>value === b[key]);
}
const $5eaae2086e349cca$var$sortableItemSymbol = Symbol('sortable item');
function $5eaae2086e349cca$export$18111f3dfa2a2cf5(data) {
    return data.symbol === $5eaae2086e349cca$var$sortableItemSymbol;
}
function $5eaae2086e349cca$export$8456f75e7ee3d163({ draggableId: draggableId, index: index, ref: ref, isReorderEnabled: isReorderEnabled, onDragEnd: onDragEnd, instanceId: instanceId }) {
    const [dragState, setDragState] = (0, $eUqFw.useState)($5eaae2086e349cca$var$idleState);
    (0, $eUqFw.useEffect)(()=>{
        if (!isReorderEnabled) return;
        const element = ref.current;
        if (!element) return;
        const data = {
            draggableId: draggableId,
            index: index,
            symbol: $5eaae2086e349cca$var$sortableItemSymbol,
            instanceId: instanceId
        };
        return (0, $jFl9L.combine)((0, $9wCS5.draggable)({
            element: element,
            getInitialData () {
                return data;
            },
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage }) {
                (0, $jfbwa.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $7CaTR.pointerOutsideOfPreview)({
                        x: "var(--ds-space-200, 16px)",
                        y: "var(--ds-space-100, 8px)"
                    }),
                    render ({ container: container }) {
                        setDragState({
                            type: 'preview',
                            container: container
                        });
                    }
                });
            },
            onDragStart () {
                setDragState($5eaae2086e349cca$var$draggingState);
            },
            onDrop () {
                setDragState($5eaae2086e349cca$var$idleState);
                onDragEnd?.();
            }
        }), (0, $9wCS5.dropTargetForElements)({
            element: element,
            getIsSticky () {
                return true;
            },
            canDrop ({ source: source }) {
                return $5eaae2086e349cca$export$18111f3dfa2a2cf5(source.data) && source.data.instanceId === data.instanceId && source.element !== element;
            },
            getData ({ input: input }) {
                return (0, $fSMvP.attachClosestEdge)(data, {
                    element: element,
                    input: input,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            onDrag ({ self: self, source: source }) {
                const edge = (0, $fSMvP.extractClosestEdge)(self.data);
                if (edge === null) {
                    // This branch should never actually execute
                    setDragState($5eaae2086e349cca$var$idleState);
                    return;
                }
                setDragState((current)=>{
                    if (!$5eaae2086e349cca$export$18111f3dfa2a2cf5(source.data)) return current;
                    const proposed = {
                        type: 'dragging-over',
                        edge: edge,
                        shouldRenderDropIndicator: $5eaae2086e349cca$var$getShouldRenderDropIndicator({
                            edge: edge,
                            sourceIndex: source.data.index,
                            index: index
                        })
                    };
                    /**
           * The current state data structure only needs a shallow
           * comparison to check equality.
           *
           * This also lets us use a more lightweight
           * comparison than `lodash.isequal`
           */ if ($5eaae2086e349cca$var$isShallowEqual(current, proposed)) return current;
                    return proposed;
                });
            },
            onDragLeave () {
                setDragState($5eaae2086e349cca$var$idleState);
            },
            onDrop () {
                setDragState($5eaae2086e349cca$var$idleState);
            }
        }));
    }, [
        draggableId,
        index,
        isReorderEnabled,
        onDragEnd,
        ref,
        instanceId
    ]);
    return {
        dragState: dragState
    };
}

});
parcelRegister("3f2za", function(module, exports) {

$parcel$export(module.exports, "combine", () => (parcelRequire("jFl9L")).combine);

var $jFl9L = parcelRequire("jFl9L");

});

parcelRegister("dxB16", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("7CaTR")).pointerOutsideOfPreview);

var $7CaTR = parcelRequire("7CaTR");

});
parcelRegister("7CaTR", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => $d4283004fec21645$export$427e20518819fabc);
function $d4283004fec21645$export$427e20518819fabc(point) {
    return ({ container: container })=>{
        // Only reliable cross browser technique found to push a
        // drag preview away from the cursor is to use transparent borders on the container
        Object.assign(container.style, {
            borderLeft: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        return {
            x: 0,
            y: 0
        };
    };
}

});


parcelRegister("bweg7", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("jfbwa")).setCustomNativeDragPreview);

var $jfbwa = parcelRequire("jfbwa");

});
parcelRegister("jfbwa", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $ec46b73243fa3ce1$export$52d889c66db0f96e);

var $9wCS5 = parcelRequire("9wCS5");

var $Fx8Dp = parcelRequire("Fx8Dp");
/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $ec46b73243fa3ce1$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $ec46b73243fa3ce1$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $ec46b73243fa3ce1$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: 2147483647,
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    const previewOffset = getOffset({
        container: container
    });
    /**
	 * **Problem**
	 * On `Safari@17.1` if a drag preview element has some opacity,
	 * Safari will include elements behind the drag preview element
	 * in the drag preview.
	 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
	 *
	 * **Fix**
	 * We push the drag preview so it is _almost_ completely offscreen so that
	 * there won't be any elements behind the drag preview element.
	 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
	 *
	 * Using `-0.0001` so that any potential "see through" on the drag preview element
	 * is effectively invisible 👻
	 *
	 * **Unsuccessful alternatives**
	 * Setting a background color (eg "white") on the `container`
	 * → Wrecks the opacity of the drag preview element
	 *
	 * Adding a parent element of the `container` with a background color (eg "white")
	 * → Wrecks the opacity of the drag preview element
	 */ if ((0, $Fx8Dp.isSafari)()) /**
		 *  For some frameworks (eg `react@18+` with `ReactDOM.createRoot().render()`) the rendering
		 *  inside the `container` does not occur until after a microtask.
		 *
		 *  Notes:
		 *    - This will run before the browser takes it's picture of the element
		 *    - This will run before the animation frame that removes `container`.
		 **/ queueMicrotask(()=>{
        const rect = container.getBoundingClientRect();
        // We cannot apply this fix if nothing has been rendered into the `container`
        if (rect.width === 0) return;
        container.style.left = `-${rect.width - 0.0001}px`;
    });
    nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $9wCS5.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});



const $396f2604a25fc189$export$494c91a4923e8fd6 = 'issue-view-layout-templates-item-list.ui.sortable-item-list.sortable-item-container-';

parcelRegister("er4nR", function(module, exports) {

$parcel$export(module.exports, "ReorderMenu", () => $d70e12462d5f3535$export$25d8f7d2038f08db);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $4ABC5 = parcelRequire("4ABC5");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aWEAV = parcelRequire("aWEAV");
function $d70e12462d5f3535$export$25d8f7d2038f08db({ itemIndex: itemIndex, onReorderItem: onReorderItem, numItems: numItems, fieldName: fieldName }) {
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        testId: "issue-view-layout-templates-item-list.ui.sortable-item-list.reorder-menu",
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: (0, $7JEyt.default)([
                    "_tzy4iqb6 _9z1rkb7n _edwkkb7n",
                    triggerProps.isSelected && "_tzy4kb7n"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ABC5.DragHandleButtonSmall), {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ref: triggerRef,
                label: intl.formatMessage((0, $aWEAV.default).triggerLabel, {
                    fieldName: fieldName
                }),
                appearance: "subtle",
                ...triggerProps
            }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        testId: "issue-view-layout-templates-item-list.ui.sortable-item-list.reorder-menu.move-up",
        onClick: ()=>{
            onReorderItem({
                indexSource: itemIndex,
                indexDestination: itemIndex - 1
            });
        },
        isDisabled: itemIndex === 0
    }, intl.formatMessage((0, $aWEAV.default).moveUp)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        testId: "issue-view-layout-templates-item-list.ui.sortable-item-list.reorder-menu.move-down",
        onClick: ()=>{
            onReorderItem({
                indexSource: itemIndex,
                indexDestination: itemIndex + 1
            });
        },
        isDisabled: itemIndex === numItems - 1
    }, intl.formatMessage((0, $aWEAV.default).moveDown))));
}
const $d70e12462d5f3535$var$triggerWrapperStyles = null;
const $d70e12462d5f3535$var$isVisibleStyles = null;

});
parcelRegister("4ABC5", function(module, exports) {

$parcel$export(module.exports, "DragHandleButtonSmall", () => $0dea573239f00363$export$81bd0a2e6f324029);

var $eUqFw = parcelRequire("eUqFw");

var $dULIU = parcelRequire("dULIU");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $az1K3 = parcelRequire("az1K3");
const $0dea573239f00363$var$iconSmallStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    marginInline: 'space.negative.050'
});
const $0dea573239f00363$export$81bd0a2e6f324029 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function DragHandleButton({ label: label, ...buttonProps }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $az1K3.DragHandleButtonBase), {
        ref: ref,
        ...buttonProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0dea573239f00363$var$iconSmallStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dULIU))), {
        label: label,
        size: "small"
    })));
});

});
parcelRegister("dULIU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a215862d5b66b800$var$_react = $a215862d5b66b800$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a215862d5b66b800$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a215862d5b66b800$var$DragHandlerIcon = (props)=>/*#__PURE__*/ $a215862d5b66b800$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><circle cx="10" cy="8" r="1"/><circle cx="14" cy="8" r="1"/><circle cx="10" cy="16" r="1"/><circle cx="14" cy="16" r="1"/><circle cx="10" cy="12" r="1"/><circle cx="14" cy="12" r="1"/></g></svg>`
    }, props));
$a215862d5b66b800$var$DragHandlerIcon.displayName = 'DragHandlerIcon';
var $a215862d5b66b800$var$_default = $a215862d5b66b800$var$DragHandlerIcon;
module.exports.default = $a215862d5b66b800$var$_default;

});

parcelRegister("az1K3", function(module, exports) {

$parcel$export(module.exports, "DragHandleButtonBase", () => $d3188c99459da9a3$export$c099c65cfbd84d0a);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $51sCz = parcelRequire("51sCz");
function $d3188c99459da9a3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Cannot use `@atlaskit/button` here because it cancels `mousedown` events
 * which prevents dragging.
 */ const $d3188c99459da9a3$var$buttonStyles = {
    name: "1waumgt",
    styles: "color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius-100, 4px);padding:var(--ds-space-0, 0px);width:max-content;border:none;cursor:grab;display:flex"
};
const $d3188c99459da9a3$var$buttonAppearanceStyles = {
    default: {
        name: "1dab6g1",
        styles: "background-color:var(--ds-background-neutral, #091E420F);&:hover{background-color:var(--ds-background-neutral-hovered, #091E4224);}&:active{background-color:var(--ds-background-neutral-pressed, #091E424F);}"
    },
    subtle: {
        name: "1hy78sx",
        styles: "background-color:var(--ds-background-neutral-subtle, #00000000);&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
    },
    selected: {
        name: "1pi0h5q",
        styles: "background-color:var(--ds-background-selected, #E9F2FF);color:var(--ds-text-selected, #0C66E4)"
    }
};
const $d3188c99459da9a3$export$c099c65cfbd84d0a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function DragHandleButton({ children: children, isSelected: isSelected = false, testId: testId, appearance: appearanceProp = 'default', type: /**
   * Defaulting to `button` instead of `submit` (native default in some cases).
   *
   * A type of `submit` only makes sense in a form context, and isn't very
   * relevant to a drag handle.
   *
   * `@atlaskit/button` also defaults to a type of `button` as well, as it
   * is more semantically appropriate in a wider range of cases.
   */ type = 'button', ...buttonProps }, ref) {
    const appearance = isSelected ? 'selected' : appearanceProp;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), null, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        ref: ref,
        css: [
            $d3188c99459da9a3$var$buttonStyles,
            $d3188c99459da9a3$var$buttonAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        type: type,
        ...buttonProps
    }, children));
});

});


parcelRegister("aWEAV", function(module, exports) {

$parcel$export(module.exports, "default", () => $030e5bbd7b07973b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $030e5bbd7b07973b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    triggerLabel: {
        "id": "issue-view-layout-templates-item-list.sortable-item-list.reorder-menu.trigger-label",
        "defaultMessage": "Reorder \"{fieldName}\" field"
    },
    moveUp: {
        "id": "issue-view-layout-templates-item-list.sortable-item-list.reorder-menu.move-up",
        "defaultMessage": "Move up"
    },
    moveDown: {
        "id": "issue-view-layout-templates-item-list.sortable-item-list.reorder-menu.move-down",
        "defaultMessage": "Move down"
    },
    postMoveAnnouncement: {
        "id": "issue-view-layout-templates-item-list.sortable-item-list.reorder-menu.post-move-announcement",
        "defaultMessage": "You've moved \"{fieldName}\" from position {startPosition} to position {endPosition} of {numberOfItems}"
    }
});

});


parcelRegister("43aLY", function(module, exports) {

$parcel$export(module.exports, "SortableItemContainer", () => $3b41fcf9b955ca91$export$ef4c2cfdad941bad);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $lQboI = parcelRequire("lQboI");

var $52KLM = parcelRequire("52KLM");
const $3b41fcf9b955ca91$var$containerStyles = null;
const $3b41fcf9b955ca91$var$draggingStyles = null;
const $3b41fcf9b955ca91$export$ef4c2cfdad941bad = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, dragState: dragState, fieldName: fieldName, positionVariant: positionVariant = 'standard', testId: testId }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _zulpv77o _1e0c1txw _4cvr1q9y _80om1qgj _19bvv77o _u5f3utpp _1lmgidpf _1pqq1wug _pqaqt94y",
            dragState.type === 'dragging' && "_tzy41ou4"
        ])
    }, children, dragState.type === 'dragging-over' && dragState.shouldRenderDropIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _94n5idpf _1ltvxbgl _1xi2idpf",
            positionVariant === 'first-item' && "_154ir5cr _1pby18b4",
            positionVariant === 'last-item' && "_94n5r5cr"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lQboI.DropIndicator), {
        edge: dragState.edge,
        gap: "var(--ds-space-100, 8px)"
    })), dragState.type === 'preview' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $52KLM.SortableItemDragPreview), {
        fieldName: fieldName
    }), dragState.container)));
const $3b41fcf9b955ca91$var$dropIndicatorContainerStyles = null;
const $3b41fcf9b955ca91$var$firstItemStyles = null;
const $3b41fcf9b955ca91$var$lastItemStyles = null;

});
parcelRegister("lQboI", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $d90e1b559aa188c7$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $d90e1b559aa188c7$export$2e2bcd8739ae039);
/**
 * Spacing tokens don't make a lot of sense for this specific use case,
 * so disabling the linting rule.
 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $fvYC3 = parcelRequire("fvYC3");
const $d90e1b559aa188c7$var$terminalSize = 8;
const $d90e1b559aa188c7$var$lineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    position: 'absolute',
    zIndex: 1,
    // Blocking pointer events to prevent the line from triggering drag events
    // Dragging over the line should count as dragging over the element behind it
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $fvYC3.line).backgroundColor,
    // Terminal
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before': {
        content: '""',
        width: $d90e1b559aa188c7$var$terminalSize,
        height: $d90e1b559aa188c7$var$terminalSize,
        boxSizing: 'border-box',
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        border: `${(0, $fvYC3.line).thickness}px solid ${(0, $fvYC3.line).backgroundColor}`,
        borderRadius: '50%'
    }
});
/**
 * By default, the edge of the terminal will be aligned to the edge of the line.
 *
 * Offsetting the terminal by half its size aligns the middle of the terminal
 * with the edge of the line.
 *
 * We must offset by half the line width in the opposite direction so that the
 * middle of the terminal aligns with the middle of the line.
 *
 * That is,
 *
 * offset = - (terminalSize / 2) + (line.thickness / 2)
 *
 * which simplifies to the following value.
 */ const $d90e1b559aa188c7$var$offsetToAlignTerminalWithLine = ((0, $fvYC3.line).thickness - $d90e1b559aa188c7$var$terminalSize) / 2;
/**
 * We inset the line by half the terminal size,
 * so that the terminal only half sticks out past the item.
 */ const $d90e1b559aa188c7$var$lineOffset = $d90e1b559aa188c7$var$terminalSize / 2;
const $d90e1b559aa188c7$var$orientationStyles = {
    horizontal: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $fvYC3.line).thickness,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: $d90e1b559aa188c7$var$lineOffset,
        right: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // Horizontal indicators have the terminal on the left
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            left: -$d90e1b559aa188c7$var$terminalSize
        }
    }),
    vertical: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $fvYC3.line).thickness,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: $d90e1b559aa188c7$var$lineOffset,
        bottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // Vertical indicators have the terminal at the top
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: -$d90e1b559aa188c7$var$terminalSize
        }
    })
};
const $d90e1b559aa188c7$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $d90e1b559aa188c7$var$edgeStyles = {
    top: /*#__PURE__*/ (0, $byn9U.css)({
        top: 'var(--local-line-offset)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: $d90e1b559aa188c7$var$offsetToAlignTerminalWithLine
        }
    }),
    right: /*#__PURE__*/ (0, $byn9U.css)({
        right: 'var(--local-line-offset)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            right: $d90e1b559aa188c7$var$offsetToAlignTerminalWithLine
        }
    }),
    bottom: /*#__PURE__*/ (0, $byn9U.css)({
        bottom: 'var(--local-line-offset)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            bottom: $d90e1b559aa188c7$var$offsetToAlignTerminalWithLine
        }
    }),
    left: /*#__PURE__*/ (0, $byn9U.css)({
        left: 'var(--local-line-offset)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            left: $d90e1b559aa188c7$var$offsetToAlignTerminalWithLine
        }
    })
};
function $d90e1b559aa188c7$export$62ed72bc21f6b8a6({ edge: edge, gap: gap = '0px' }) {
    /**
   * To clearly communicate the resting place of a draggable item during a drag operation,
   * the drop indicator should be positioned half way between draggable items.
   */ const lineOffset = `calc(-0.5 * (${gap} + ${(0, $fvYC3.line).thickness}px))`;
    const orientation = $d90e1b559aa188c7$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $d90e1b559aa188c7$var$lineStyles,
            $d90e1b559aa188c7$var$orientationStyles[orientation],
            $d90e1b559aa188c7$var$edgeStyles[edge]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            '--local-line-offset': lineOffset
        }
    });
}
var // This default export is intended for usage with React.lazy
$d90e1b559aa188c7$export$2e2bcd8739ae039 = $d90e1b559aa188c7$export$62ed72bc21f6b8a6;

});
parcelRegister("fvYC3", function(module, exports) {

$parcel$export(module.exports, "line", () => $eb1ef4b0dfcaaeec$export$53f1d5ea8de3d7c);
/**
 * Design decisions for the drop indicator's main line
 */ const $eb1ef4b0dfcaaeec$export$53f1d5ea8de3d7c = {
    borderRadius: 0,
    thickness: 2,
    backgroundColor: "var(--ds-border-selected, #0C66E4)"
};

});


parcelRegister("52KLM", function(module, exports) {

$parcel$export(module.exports, "SortableItemDragPreview", () => $c00c67d9df28d969$export$aced9ad3bc266eaa);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");
const $c00c67d9df28d969$var$containerStyles = null;
/**
 * Inlining the text styles instead of using `FieldHeadingTitle`
 * so we can add the truncation styles.
 */ const $c00c67d9df28d969$var$textStyles = null;
const $c00c67d9df28d969$export$aced9ad3bc266eaa = ({ fieldName: fieldName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_vchhusvi _p12f1178 _bfhk1bhr _1yt4u2gc _2rkosqtm",
            "_1wyb1jqr _vwz41clk _k48pni7l _syaz1fxt _1reo15vq _18m915vq _o5721q9c _1bto1l2s"
        ])
    }, fieldName);

});




parcelRegister("dS6jW", function(module, exports) {

$parcel$export(module.exports, "TabView", () => $337766a3029f66fa$export$44c45b2b7f09d2a6);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $aBT3I = parcelRequire("aBT3I");

var $8sN8t = parcelRequire("8sN8t");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $fCdlE = parcelRequire("fCdlE");

var $fxSp7 = parcelRequire("fxSp7");

var $bBKB6 = parcelRequire("bBKB6");

var $gZfrw = parcelRequire("gZfrw");
const $337766a3029f66fa$var$TemplatesTabViewOnboardingSpotlightTarget = 'TemplatesTabViewOnboardingSpotlightTarget';
const $337766a3029f66fa$export$44c45b2b7f09d2a6 = ({ items: items, area: area, issueViewRelayFragment: issueViewRelayFragment })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ value: issueFieldsConfig }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    const [issueFieldsValues] = (0, $kmr29.useFieldsValues)(issueKey);
    const layoutFieldTypes = (0, $lO4Or.getLayoutFieldTypes)();
    const isTabFieldVisible = (0, $eUqFw.useCallback)((item)=>(0, $gZfrw.isTabFieldVisibleUtil)({
            item: item,
            issueFieldsConfig: issueFieldsConfig,
            issueFieldsValues: issueFieldsValues,
            layoutFieldTypes: layoutFieldTypes
        }), [
        issueFieldsConfig,
        issueFieldsValues,
        layoutFieldTypes
    ]);
    const tabArray = (0, $gZfrw.extractTabArray)({
        items: items,
        area: area,
        issueViewRelayFragment: issueViewRelayFragment,
        isTabFieldVisible: isTabFieldVisible
    });
    // This is an edge case and should never happen.
    // However in some situations it's possible that tabArray is empty due to async nature of data we're receiving here.
    // Normally, we'd ignore this cause eventually we get all needed data and tabArray gets the right shape,
    // but in this case we wrap tabs in React.memo to prevent unwanted re-renders. So once it was rendered with 0 tabs, it'll never re-render when the tabs are there.
    if (tabArray.length === 0) return null;
    // If there is just one Tab, we exit early,
    // and display the content normally.
    if (tabArray.length === 1) {
        const oneFoundTab = tabArray[0];
        return oneFoundTab && oneFoundTab.content;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($337766a3029f66fa$var$TabsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bBKB6.TabsSpotlightWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
        name: $337766a3029f66fa$var$TemplatesTabViewOnboardingSpotlightTarget
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fxSp7.StaticTabsSpotlight), {
        tabsContent: tabArray
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBT3I.EngagementSpotlight), {
        engagementId: $337766a3029f66fa$var$TemplatesTabViewOnboardingSpotlightTarget
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (analyticsEvent)=>(0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'TemplatesTabViewOnboarding mounted')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fCdlE.StaticTabs), {
        tabsContent: tabArray
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $337766a3029f66fa$var$TabsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsbu6a3 _1jwa1g80",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fCdlE", function(module, exports) {

$parcel$export(module.exports, "StaticTabs", () => $66f96f747b0b52d7$export$575327eedfc5bc6a);

var $eUqFw = parcelRequire("eUqFw");

var $5dpJB = parcelRequire("5dpJB");
var $c9awd = parcelRequire("c9awd");
var $6xBtK = parcelRequire("6xBtK");
var $emR29 = parcelRequire("emR29");

var $8cU5f = parcelRequire("8cU5f");

var $hJ992 = parcelRequire("hJ992");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $guDlK = parcelRequire("guDlK");

var $3tsjd = parcelRequire("3tsjd");
const $66f96f747b0b52d7$var$TEST_ID = 'issue-view-layout-templates-tab';
const $66f96f747b0b52d7$export$575327eedfc5bc6a = ({ tabsContent: tabsContent })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const [selectedTabId, setSelectedTabId] = (0, $3tsjd.useTabsLocalStorage)(projectKey);
    const onSelect = (0, $eUqFw.useCallback)((selected, selectedIndex)=>{
        const payload = {
            totalTabCount: tabsContent.length,
            selectedTabPosition: selectedIndex + 1
        };
        const event = createAnalyticsEvent({
            action: 'selected',
            actionSubject: 'tab',
            actionSubjectId: 'issueFieldTabs'
        });
        (0, $jMP2a.fireUIAnalytics)(event, 'issueFieldTabs', payload);
        setSelectedTabId(selected.id);
    }, [
        createAnalyticsEvent,
        setSelectedTabId,
        tabsContent.length
    ]);
    const handleChange = (0, $eUqFw.useCallback)((index)=>{
        const selectedTab = tabsContent[index];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onSelect(selectedTab, index);
    }, [
        onSelect,
        tabsContent
    ]);
    const selectedTabIndex = tabsContent.findIndex((tab)=>tab && tab.id === selectedTabId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5dpJB.default), {
        selected: selectedTabIndex === -1 ? 0 : selectedTabIndex,
        onChange: handleChange,
        id: "issue-view-layout-templates-tabs",
        shouldUnmountTabPanelOnChange: true,
        testId: "issue-view-layout-templates-tab-view.ui.static-tabs.tabs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xBtK.default), null, tabsContent.map((tab)=>tab && (tabsContent.length > 2 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            key: tab.id,
            content: tab.label,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9awd.default), {
            testId: `${$66f96f747b0b52d7$var$TEST_ID}-${tab.id}`
        }, tab.label)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9awd.default), {
            testId: `${$66f96f747b0b52d7$var$TEST_ID}-${tab.id}`,
            key: tab.id
        }, tab.label)))), tabsContent.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $emR29.default), {
            key: index
        }, tab?.content)));
};

});
parcelRegister("3tsjd", function(module, exports) {

$parcel$export(module.exports, "useTabsLocalStorage", () => $c6978a8a13e0f451$export$6613c726775956f9);

var $eUqFw = parcelRequire("eUqFw");

var $5ysFK = parcelRequire("5ysFK");
const $c6978a8a13e0f451$export$6613c726775956f9 = (projectKey)=>{
    const keyName = `tabs.state.${projectKey}`;
    const [storedValue, setStoredValue] = (0, $eUqFw.useState)(()=>{
        try {
            return window.localStorage?.getItem(keyName);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (_) {
            return undefined;
        }
    });
    // Required for multiple gets in the case of transitions between already-visited issues in the SPA
    (0, $eUqFw.useEffect)(()=>{
        setStoredValue(window.localStorage?.getItem(keyName));
    }, [
        keyName
    ]);
    const setValue = (value)=>{
        try {
            setStoredValue(value);
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            window.localStorage?.setItem(keyName, value);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $5ysFK.logSafeErrorWithoutCustomerData)(error, 'issue.issue-view-layout-templates.components.tab-view', 'issue.templates.tab-view');
        }
    };
    // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | undefined'.
    return [
        storedValue,
        setValue
    ];
};

});
parcelRegister("5ysFK", function(module, exports) {

$parcel$export(module.exports, "logSafeErrorWithoutCustomerData", () => $4626a7a97ad42c00$export$c77be5886e7f1d9e);

var $gUUjF = parcelRequire("gUUjF");
const $4626a7a97ad42c00$export$b94ad046ae639a1c = (error, location, suffix, message)=>(0, $gUUjF.default).safeErrorWithoutCustomerData(location, message || error.message, error);
const $4626a7a97ad42c00$export$c77be5886e7f1d9e = (error, location, suffix, message)=>(0, $gUUjF.default).safeErrorWithoutCustomerData(location, message || error.message, error);

});



parcelRegister("fxSp7", function(module, exports) {

$parcel$export(module.exports, "StaticTabsSpotlight", () => $e3968966a10808ad$export$52b54c77940b987f);

var $eUqFw = parcelRequire("eUqFw");

var $5dpJB = parcelRequire("5dpJB");
var $c9awd = parcelRequire("c9awd");
var $6xBtK = parcelRequire("6xBtK");
const $e3968966a10808ad$export$52b54c77940b987f = ({ tabsContent: tabsContent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5dpJB.default), {
        id: "issue-view-layout-templates-tabs-spotlight",
        shouldUnmountTabPanelOnChange: true,
        testId: "issue-view-layout-templates-tab-view.ui.static-tabs-spotlight.issue-view-layout-templates-tabs-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xBtK.default), null, tabsContent.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9awd.default), {
            key: index
        }, tab?.label))));

});

parcelRegister("bBKB6", function(module, exports) {

$parcel$export(module.exports, "TabsSpotlightWrapper", () => $723177a4d186f2b2$export$ee620fdb1e1fb346);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $723177a4d186f2b2$export$ee620fdb1e1fb346 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_3um015vq _kqswstnw _1pby1mrw _1bsb1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gZfrw", function(module, exports) {

$parcel$export(module.exports, "isTabFieldVisibleUtil", () => $f87249b12d4d296c$export$96ba561c9e9438d6);
$parcel$export(module.exports, "extractTabArray", () => $f87249b12d4d296c$export$c996569ce7f28370);
/* utils.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bLiXo = parcelRequire("bLiXo");

var $4faf8 = parcelRequire("4faf8");

var $dZWHl = parcelRequire("dZWHl");

var $3DTsn = parcelRequire("3DTsn");

var $g8to1 = parcelRequire("g8to1");
const $f87249b12d4d296c$export$96ba561c9e9438d6 = ({ item: item, issueFieldsConfig: issueFieldsConfig, issueFieldsValues: issueFieldsValues, layoutFieldTypes: layoutFieldTypes })=>{
    const id = (0, $dZWHl.getLayoutItemId)(item);
    /**
   * This ensures that specific JSM fields are always visible
   */ if (item.type === (0, $bLiXo.CUSTOM_ITEM_TYPE)) return true;
    const fieldConfig = issueFieldsConfig && issueFieldsConfig[id];
    if (!fieldConfig) return false;
    const fieldIsEmpty = issueFieldsValues && (issueFieldsValues[id] === null || issueFieldsValues[id] === undefined);
    const forgeCustomFieldType = (0, $4faf8.getForgeFieldType)(fieldConfig) || '';
    if (!fieldConfig.isEditable && fieldIsEmpty) {
        /**
     * This ensures that read-only forge fields with no value are always
     * visible as their value is most likely rendered using value function
     * which is not stored in the issueFieldsValues
     */ if (forgeCustomFieldType) return true;
        return false;
    }
    const { custom: custom, system: system, type: type } = fieldConfig.schema || {};
    const systemType = system !== null ? system : '';
    const fieldType = (0, $g8to1.getAtlassianCustomFieldType)(custom) || forgeCustomFieldType || systemType || type;
    if (fieldType === undefined) return false;
    return Object.values(layoutFieldTypes).includes(fieldType);
};
const $f87249b12d4d296c$export$c996569ce7f28370 = ({ items: items, area: area, issueViewRelayFragment: issueViewRelayFragment, isTabFieldVisible: isTabFieldVisible })=>items.map((tab)=>{
        if (tab.type !== (0, $bLiXo.layoutContainerItemTypes).tab) return null;
        const itemsList = tab.items.nodes.filter((item)=>isTabFieldVisible(item));
        if (itemsList.length !== 0) return {
            id: (0, $dZWHl.getLayoutItemId)(tab),
            label: tab.name,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f87249b12d4d296c$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3DTsn.ItemList), {
                items: itemsList,
                area: area,
                layoutItemsDataFragment: issueViewRelayFragment ?? null
            }))
        };
        return null;
    }).filter((tab)=>tab !== null);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f87249b12d4d296c$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qpxbi _1e0c1txw _2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
});

});




parcelRegister("j1DS9", function(module, exports) {

$parcel$export(module.exports, "default", () => $728d6e9ab0085a19$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iWtAM = parcelRequire("iWtAM");

var $hVEzR = parcelRequire("hVEzR");

var $lJ7QD = parcelRequire("lJ7QD");
const $728d6e9ab0085a19$var$ContextItems = ({ issueViewRelayFragment: issueViewRelayFragment })=>{
    const [items, updateHiddenSecondaryFields] = (0, $hVEzR.useVisibleHiddenItems)((0, $iWtAM.ALWAYS_PRIMARY_AND_VISIBLE)[0, $iWtAM.DEFAULT_TEMPLATE]);
    const onToggleExpanded = (0, $eUqFw.useCallback)(()=>{
        updateHiddenSecondaryFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        items.hiddenItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lJ7QD.default), {
        items: items,
        onToggleExpanded: onToggleExpanded,
        issueViewRelayFragment: issueViewRelayFragment
    });
};
var $728d6e9ab0085a19$export$2e2bcd8739ae039 = $728d6e9ab0085a19$var$ContextItems;

});
parcelRegister("lJ7QD", function(module, exports) {

$parcel$export(module.exports, "default", () => $956c252da546be2a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $8sN8t = parcelRequire("8sN8t");

var $h97Af = parcelRequire("h97Af");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $8411R = parcelRequire("8411R");

var $uo395 = parcelRequire("uo395");

var $bLiXo = parcelRequire("bLiXo");



var $dZWHl = parcelRequire("dZWHl");

var $kdPjr = parcelRequire("kdPjr");


var $3DTsn = parcelRequire("3DTsn");

var $iS4x5 = parcelRequire("iS4x5");
var $2y6PD = parcelRequire("2y6PD");

var $jbrPp = parcelRequire("jbrPp");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $guDlK = parcelRequire("guDlK");

var $kS8l2 = parcelRequire("kS8l2");

var $bwIYX = parcelRequire("bwIYX");

var $cOMss = parcelRequire("cOMss");

var $6YcPr = parcelRequire("6YcPr");

var $5hnwq = parcelRequire("5hnwq");
const $956c252da546be2a$var$SHOW_MORE = 'SHOW_MORE';
const $956c252da546be2a$var$DivWithRef = ({ children: children, registerKey: registerKey })=>{
    const [, { register: register }] = (0, $kS8l2.useGlobalRefStoreActions)();
    const onRef = (0, $eUqFw.useCallback)((ref)=>{
        register(registerKey, ref);
    }, [
        register,
        registerKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: onRef
    }, children);
};
const $956c252da546be2a$export$e198035bfccee6aa = ({ items: items, onToggleExpanded: onToggleExpanded, issueViewRelayFragment: issueViewRelayFragment })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ value: issueFieldsConfig }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, , sortPinnedFields] = (0, $cOMss.isSortingPinnedFieldsEnabled)() ? (0, $uo395.usePinnedFields)(issueKey) : []; // eslint-disable-line react-hooks/rules-of-hooks -- Remove ternary when cleaning isSortingPinnedFieldsEnabled https://hello.atlassian.net/browse/DEE-914
    let application;
    let edition;
    if ((0, $1ybV0.ff)('instrumentation-of-issue-ecosystem-reliability-slo-metrics-rhs_tpmqi')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
        const projectKey = (0, $guDlK.useProjectKey)(issueKey);
        // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
        application = (0, $guDlK.useApplication)(projectKey, true);
        // eslint-disable-next-line react-hooks/rules-of-hooks -- safe to disable as it's only behind an FF check!
        edition = (0, $guDlK.useEdition)(projectKey, true);
    }
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
            action: 'success'
        }), 'onboarding initialized', 'bentoCollapsibleGroup');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSubtitle = (accumulator, item)=>{
        const id = (0, $dZWHl.getLayoutItemId)(item);
        if (!issueFieldsConfig || !issueFieldsConfig[id]) return accumulator;
        if (accumulator.length === 0) return `${issueFieldsConfig[id].title}`;
        return `${accumulator}, ${issueFieldsConfig[id].title}`;
    };
    const additionalPinnedEventAttributes = (0, $bwIYX.useGenerateAdditionalAnalyticsEventAttributes)(items.pinnedFields);
    const additionalContextEventAttributes = (0, $bwIYX.useGenerateAdditionalAnalyticsEventAttributes)(items.visibleItems);
    const additionalContextHiddenAttributes = (0, $bwIYX.useGenerateAdditionalAnalyticsEventAttributes)(items.hiddenItems);
    const hiddenItemsSubtitle = items.hiddenItems.reduce(getSubtitle, '');
    const visibleItemsSubtitle = items.visibleItems.reduce(getSubtitle, '');
    const pinnedItemsSubtitle = items.pinnedFields.reduce(getSubtitle, '');
    const hasPinnedFields = items.pinnedFields.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-items"
    }, !hasPinnedFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($956c252da546be2a$var$DivWithRef, {
        registerKey: (0, $ab3fc2ac1a2f2638$export$efb12103a5e32a1e)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
        name: (0, $ab3fc2ac1a2f2638$export$efb12103a5e32a1e)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2y6PD.PinnedFieldsBanner), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iS4x5.PinnedFieldHighlightWrapper), {
        "data-component-selector": (0, $iS4x5.pinnedFieldHighlightWrapperSelectorName)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "issue-view-layout-templates-views.ui.context.visible-hidden.ui.primary-items"
    }, hasPinnedFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($956c252da546be2a$var$DivWithRef, {
        registerKey: (0, $ab3fc2ac1a2f2638$export$4288bce987c22af4)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
        name: (0, $ab3fc2ac1a2f2638$export$4288bce987c22af4)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: $332dd3e353a5c68d$export$8c06a6d84357e389
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jbrPp.ContextGroup), {
        title: (0, $cOMss.isSortingPinnedFieldsEnabled)() ? formatMessage((0, $5hnwq.default).pinnedFieldsTitle) : formatMessage((0, $5hnwq.default).pinnedFieldsText),
        groupId: "pinned-context-items",
        subTitle: pinnedItemsSubtitle,
        initialOpened: true,
        additionalEventAttributes: additionalPinnedEventAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3DTsn.ItemList), {
        items: items.pinnedFields,
        area: (0, $bLiXo.CONTEXT_AREA),
        layoutItemsDataFragment: issueViewRelayFragment ?? null,
        sortableId: (0, $cOMss.isSortingPinnedFieldsEnabled)() ? (0, $ab2aafcdf11a1361$export$dcd281f501ceae1a) : undefined,
        onSortItems: (0, $cOMss.isSortingPinnedFieldsEnabled)() ? sortPinnedFields : undefined
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: $332dd3e353a5c68d$export$fd068082b2bace69
    }))), items.visibleItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($956c252da546be2a$var$DivWithRef, {
        registerKey: (0, $ab3fc2ac1a2f2638$export$fa5ad81958817beb)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: $332dd3e353a5c68d$export$e166220c4ce2fecc
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jbrPp.ContextGroup), {
        title: formatMessage((0, $5hnwq.default).detailsText),
        groupId: "details-group",
        subTitle: visibleItemsSubtitle,
        initialOpened: true,
        additionalEventAttributes: additionalContextEventAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3DTsn.ItemList), {
        items: items.visibleItems,
        area: (0, $bLiXo.CONTEXT_AREA),
        layoutItemsDataFragment: issueViewRelayFragment ?? null
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: $332dd3e353a5c68d$export$484838e86c8a663c
    }))), items.hiddenItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: $332dd3e353a5c68d$export$f24b11cc15db1e61
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
        name: $956c252da546be2a$var$SHOW_MORE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jbrPp.ContextGroup), {
        title: formatMessage((0, $5hnwq.default).moreFieldsText),
        groupId: "secondary-context-items",
        onChange: onToggleExpanded,
        subTitle: hiddenItemsSubtitle,
        initialOpened: false,
        additionalEventAttributes: additionalContextHiddenAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3DTsn.ItemList), {
        items: items.hiddenItems,
        area: (0, $bLiXo.CONTEXT_AREA),
        layoutItemsDataFragment: issueViewRelayFragment ?? null
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: $332dd3e353a5c68d$export$84bcb5360cf1a9a9
    })), items.apps.contextPanels.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: $332dd3e353a5c68d$export$87b38ef9bc160e8f
    }), (0, $1ybV0.ff)('instrumentation-of-issue-ecosystem-reliability-slo-metrics-rhs_tpmqi') ? (0, $6YcPr.generateContextPanels)(items.apps.contextPanels, issueViewRelayFragment ?? null, application, edition) : (0, $6YcPr.generateContextPanels)(items.apps.contextPanels, issueViewRelayFragment ?? null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: $332dd3e353a5c68d$export$ba0fc47b302982aa
    }))));
};
const $956c252da546be2a$var$VisibleHiddenContextSectionViewInternal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kdPjr.FieldsCompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($956c252da546be2a$export$e198035bfccee6aa, props));
const $956c252da546be2a$var$MemoisedVisibleHiddenContextSectionView = /*#__PURE__*/ (0, $eUqFw.memo)($956c252da546be2a$var$VisibleHiddenContextSectionViewInternal, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
$956c252da546be2a$var$MemoisedVisibleHiddenContextSectionView.displayName = 'MemoisedVisibleHiddenContextSectionView';
var $956c252da546be2a$export$2e2bcd8739ae039 = $956c252da546be2a$var$MemoisedVisibleHiddenContextSectionView;

});
parcelRegister("iS4x5", function(module, exports) {

$parcel$export(module.exports, "pinnedFieldHighlightWrapperSelectorName", () => $23699ca5dfa0d324$export$c6966da474903ec6);
$parcel$export(module.exports, "PinnedFieldHighlightWrapper", () => $23699ca5dfa0d324$export$746b14401cc11653);
$parcel$export(module.exports, "BannerWrapper", () => $23699ca5dfa0d324$export$e529837a22b31a11);
$parcel$export(module.exports, "BannerHeader", () => $23699ca5dfa0d324$export$72e85ab5dabbfb7c);
$parcel$export(module.exports, "BannerMessage", () => $23699ca5dfa0d324$export$5e6c5fe77f34138f);
$parcel$export(module.exports, "BannerButtonContainer", () => $23699ca5dfa0d324$export$ce2aac5a30ee2eb);
$parcel$export(module.exports, "PinUnfilledStyled", () => $23699ca5dfa0d324$export$9434051d7711ef61);
$parcel$export(module.exports, "BannerWrapperRow", () => $23699ca5dfa0d324$export$ec699bcf5cf83862);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $64ypR = parcelRequire("64ypR");

var $lTnLX = parcelRequire("lTnLX");
const $23699ca5dfa0d324$export$c6966da474903ec6 = 'jira-issue-view-layout-templates-pinned-fields-banner-with-grouping-pinned-field-highlight-wrapper';
const $23699ca5dfa0d324$var$PINNED_FIELD_HIGHLIGHT_WRAPPER_COMPONENT_SELECTOR = `[data-component-selector="${$23699ca5dfa0d324$export$c6966da474903ec6}"]`;
const $23699ca5dfa0d324$export$746b14401cc11653 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});
const $23699ca5dfa0d324$export$e529837a22b31a11 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1izznat": (0, $9t7rW.default)((0, $64ypR.animationFadeIn))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _otyru2gc _1yt41x7d _19ith6cr _2rko1l7b _wgukewfl _1eeg1gsj _1ovphwed",
            __cmplp.className
        ])
    });
});
const $23699ca5dfa0d324$export$72e85ab5dabbfb7c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1b66 _otyrpxbi _syaz1fxt _1wybdlk8",
            __cmplp.className
        ])
    });
});
const $23699ca5dfa0d324$export$5e6c5fe77f34138f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr1b66 _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $23699ca5dfa0d324$export$ce2aac5a30ee2eb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
});
const $23699ca5dfa0d324$export$9434051d7711ef61 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lTnLX.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_s7n41ndm",
            __cmplp.className
        ])
    });
});
const $23699ca5dfa0d324$export$ec699bcf5cf83862 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2y6PD", function(module, exports) {

$parcel$export(module.exports, "PinnedFieldsBanner", () => $8a6471db11befe70$export$6618a4478707806b);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $je5kZ = parcelRequire("je5kZ");

var $8cU5f = parcelRequire("8cU5f");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $iS4x5 = parcelRequire("iS4x5");

var $nk2hD = parcelRequire("nk2hD");

var $kk8d8 = parcelRequire("kk8d8");
const $8a6471db11befe70$export$fd9cd8665f50477e = ({ children: children })=>{
    const [isVisible, setIsNotVisible] = (0, $nk2hD.useIsPinnedFieldsBannerVisible)();
    if (!isVisible) return null;
    return children({
        onClick: setIsNotVisible
    });
};
const $8a6471db11befe70$export$6618a4478707806b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ forceRender: forceRender = false }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isVisible, setIsNotVisible] = (0, $nk2hD.useIsPinnedFieldsBannerVisible)();
    if (!isVisible && !forceRender) return null;
    const dismissTooltipLabel = formatMessage((0, $kk8d8.messages).dismissTooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iS4x5.BannerWrapper), {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iS4x5.BannerWrapperRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iS4x5.BannerHeader), null, formatMessage((0, $kk8d8.messages).groupingTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iS4x5.BannerMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $kk8d8.messages).description,
        values: {
            pinnedIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iS4x5.PinUnfilledStyled), null)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iS4x5.BannerButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: dismissTooltipLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        spacing: "none",
        appearance: "subtle",
        onClick: setIsNotVisible,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
            label: dismissTooltipLabel
        }),
        testId: "issue-view-layout-templates-pinned-fields-banner.ui.dismiss-button",
        interactionName: "auto-generated.issue-view-layout-templates-pinned-fields-banner.ui.dismiss-button.button"
    }))));
});

});
parcelRegister("nk2hD", function(module, exports) {

$parcel$export(module.exports, "useIsPinnedFieldsBannerVisible", () => $9627ee5c14db6102$export$c48c538874f8f3a5);

var $eUqFw = parcelRequire("eUqFw");

var $i9pAn = parcelRequire("i9pAn");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $hvEYC = parcelRequire("hvEYC");
const $9627ee5c14db6102$export$c48c538874f8f3a5 = ()=>{
    const [bannerLastInteracted, { setValue: setBannerLastInteracted }] = (0, $i9pAn.useUserPreferencesValue)((0, $ef4d08ed1e68b275$export$285413b3d1e8f822));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClose = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            eventName: 'pinnedFieldsBanner closed',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'pinnedFieldsBanner'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $ef4d08ed1e68b275$export$36b5185bcf7c93de));
        setBannerLastInteracted((0, $ef4d08ed1e68b275$export$f224a3da1f25e3b3));
    }, [
        createAnalyticsEvent,
        setBannerLastInteracted
    ]);
    const onMount = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            eventName: 'pinnedFieldsBanner viewed',
            action: 'viewed',
            actionSubject: 'banner',
            actionSubjectId: 'pinnedFieldsBannerViewed'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $ef4d08ed1e68b275$export$36b5185bcf7c93de));
    }, [
        createAnalyticsEvent
    ]);
    const isVisible = !(0, $hvEYC.isUnixTimestampOlderThanDays)(bannerLastInteracted, (0, $ef4d08ed1e68b275$export$fbad23fb67950544)) && !(bannerLastInteracted === (0, $ef4d08ed1e68b275$export$f224a3da1f25e3b3));
    // Check onMount, if banner has been seen, and how long ago
    (0, $eUqFw.useEffect)(()=>{
        // If initial value is `null`, it's never been seen, we set the last time
        // interacted to current unix timestamp.
        if (bannerLastInteracted === null) setBannerLastInteracted(Date.now().toString());
        // Fire `viewed` Analytics Event
        isVisible && onMount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [
        isVisible,
        onClose
    ];
};

});
const $ef4d08ed1e68b275$export$285413b3d1e8f822 = 'jira.user.issue.pinned-fields-banner.lastinteracted';
const $ef4d08ed1e68b275$export$f224a3da1f25e3b3 = 'jira.user.issue.pinned-fields-banner.user_hidden_action';
const $ef4d08ed1e68b275$export$36b5185bcf7c93de = 'pinnedFieldsBannerDismissSectionMessage';
const $ef4d08ed1e68b275$export$fbad23fb67950544 = 7;

parcelRegister("hvEYC", function(module, exports) {

$parcel$export(module.exports, "isUnixTimestampOlderThanDays", () => $9812e87a7686ab11$export$d7bf08d9aa42422f);

var $d2wNG = parcelRequire("d2wNG");
const $9812e87a7686ab11$export$5f870fcca7ae6a88 = (maybeTimestamp)=>maybeTimestamp !== undefined && maybeTimestamp !== null && !Number.isNaN(Number(maybeTimestamp));
const $9812e87a7686ab11$export$d7bf08d9aa42422f = (possibleTimeStamp, numberOfDays)=>{
    const isTimeStamp = $9812e87a7686ab11$export$5f870fcca7ae6a88(possibleTimeStamp);
    if (!isTimeStamp) return false;
    // @ts-expect-error - TS2345 - Argument of type 'string | false' is not assignable to parameter of type 'string'.
    const timestamp = parseInt(possibleTimeStamp !== null && possibleTimeStamp.toString(), 10);
    if ((0, $d2wNG.default)(new Date(), timestamp) > numberOfDays) return true;
    return false;
};

});


parcelRegister("kk8d8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6242f095b0aa3889$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $6242f095b0aa3889$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue-view-layout-templates-pinned-fields-banner.title",
        "defaultMessage": "Your pinned fields"
    },
    groupingTitle: {
        "id": "issue-view-layout-templates-pinned-fields-banner.grouping-title",
        "defaultMessage": "Pinned fields"
    },
    description: {
        "id": "issue-view-layout-templates-pinned-fields-banner.description",
        "defaultMessage": "Click on the {pinnedIcon} next to a field label to start pinning."
    },
    dismissTooltip: {
        "id": "issue-view-layout-templates-pinned-fields-banner.dismiss-tooltip",
        "defaultMessage": "Hide message"
    }
});

});


parcelRegister("jbrPp", function(module, exports) {

$parcel$export(module.exports, "ContextGroup", () => $c1874e31fd2b90ed$export$26b87dd1959c2465);
$parcel$export(module.exports, "default", () => $c1874e31fd2b90ed$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8sN8t = parcelRequire("8sN8t");

var $hJ992 = parcelRequire("hJ992");

var $cOaZ6 = parcelRequire("cOaZ6");

var $guDlK = parcelRequire("guDlK");

var $1BeH3 = parcelRequire("1BeH3");

var $cVvuK = parcelRequire("cVvuK");
const $c1874e31fd2b90ed$export$26b87dd1959c2465 = ({ onChange: onChange, children: children, subTitle: subTitle, groupId: groupId, title: title, initialOpened: initialOpened, additionalEventAttributes: additionalEventAttributes })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    /**
	 * When groupId is details-group Targeted with DETAILS_PANEL for the spotlight tour
	 * /src/packages/issue/onboarding-modal/src/common/constants.tsx
	 */ const testId = `issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.${groupId}`;
    const contextGroupContainerChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVvuK.ContextGroupContainer), {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOaZ6.CollapsibleGroup), {
        id: groupId,
        projectKey: projectKey,
        title: title,
        onChange: onChange,
        subTitle: subTitle,
        initialOpened: initialOpened,
        additionalEventAttributes: additionalEventAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": `issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.${groupId}`
    }, children)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
        name: testId
    }, contextGroupContainerChildren);
};
var $c1874e31fd2b90ed$export$2e2bcd8739ae039 = (0, $1BeH3.default);

});
parcelRegister("cOaZ6", function(module, exports) {

$parcel$export(module.exports, "CollapsibleGroup", () => $e768e0ff2cd32f5d$export$36287b0242004a4d);
$parcel$export(module.exports, "CollapsibleGroupWithHeaderIcon", () => $e768e0ff2cd32f5d$export$af87ab18ecfff2e7);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $kkgbD = parcelRequire("kkgbD");

var $86Ndv = parcelRequire("86Ndv");

var $5xnoX = parcelRequire("5xnoX");

var $iw0Y6 = parcelRequire("iw0Y6");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $d6g7g = parcelRequire("d6g7g");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7GSu6 = parcelRequire("7GSu6");

var $autRb = parcelRequire("autRb");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $3c5B8 = parcelRequire("3c5B8");

var $dTpRF = parcelRequire("dTpRF");

var $kSuBQ = parcelRequire("kSuBQ");

var $4ityQ = parcelRequire("4ityQ");

var $8EvR4 = parcelRequire("8EvR4");

var $1CHJT = parcelRequire("1CHJT");
const $e768e0ff2cd32f5d$var$TESTID = 'issue-view-layout-group.ui.button';
const $e768e0ff2cd32f5d$export$36287b0242004a4d = ({ children: children, title: title, subTitle: subTitle, onChange: onChange, components: components, projectKey: projectKey, id: id, onConfigButtonClick: onConfigButtonClick, initialOpened: initialOpened, additionalEventAttributes: additionalEventAttributes })=>{
    const CollapsibleGroupRef = (0, $eUqFw.useRef)(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $kSuBQ.useGroupLocalStorage)(projectKey, id, !!initialOpened);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [stickyHeaderPosition, stickyHeaderEnabled] = (0, $7GSu6.useStickyHeader)();
    if (stickyHeaderEnabled === true) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const previousValue = (0, $hzcvF.usePrevious)(isOpen);
        const hasClosed = !(0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(previousValue) && !isOpen && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(isOpen, previousValue);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eUqFw.useEffect)(()=>{
            if (hasClosed) // Wait until group has collapsed
            setTimeout(()=>{
                const refElement = CollapsibleGroupRef.current;
                // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLElement | null | undefined'.
                (0, $autRb.smoothScrollIntoViewIfNeeded)(refElement, {
                    scrollMode: 'if-needed',
                    behavior: (actions)=>actions.forEach(({ el: el, top: top })=>{
                            // eslint-disable-next-line no-param-reassign
                            el.scrollTop = top - (stickyHeaderPosition || 0);
                        }),
                    block: 'start'
                });
            });
        }, [
            hasClosed,
            stickyHeaderPosition
        ]);
    }
    const onHeaderClick = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(!isOpen);
        const openedOrClosed = isOpen ? 'closed' : 'opened';
        const analyticsEvent = createAnalyticsEvent({
            eventName: `bentoCollapsibleGroup ${openedOrClosed}`,
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'bentoCollapsibleGroup'
        });
        const uiAnalytics = {
            groupTitle: title,
            groupState: openedOrClosed,
            ...additionalEventAttributes
        };
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $3ebb2187fb744e2b$export$2f4ad3e3017ae3f6), uiAnalytics);
        if (id.includes('ari:cloud:ecosystem::extension')) (0, $d6g7g.forgeModulesLoadTime).start();
        if (typeof onChange === 'function') onChange(!isOpen);
    }, [
        additionalEventAttributes,
        createAnalyticsEvent,
        id,
        isOpen,
        onChange,
        setIsOpen,
        title
    ]);
    const onConfigButtonClickCallback = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        onConfigButtonClick?.(event);
    }, [
        onConfigButtonClick
    ]);
    const renderHeaderActions = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $4ityQ.default).configure)
        }, typeof onConfigButtonClick === 'function' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dTpRF.ConfigButton), {
            testId: $e768e0ff2cd32f5d$var$TESTID,
            spacing: "compact",
            appearance: "subtle",
            // @ts-expect-error - TS2322 - Type '(event: Event) => void' is not assignable to type '(e: MouseEvent<HTMLElement, MouseEvent>, analyticsEvent: UIAnalyticsEvent) => void'.
            onClick: onConfigButtonClickCallback,
            "data-component-selector": (0, $dTpRF.configButtonSelectorName)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))), {
            label: formatMessage((0, $4ityQ.default).configure),
            size: "small",
            primaryColor: `var(--ds-icon, ${(0, $PdmhA).N90})`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dTpRF.IconWrapper), null, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))), {
            label: "",
            primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N500})`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: "",
            primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N500})`
        }))), [
        formatMessage,
        isOpen,
        onConfigButtonClick,
        onConfigButtonClickCallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GSu6.StickyHeaderTrackerContainer), {
        scope: `group-${id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3c5B8.default), {
        id: id,
        title: title,
        subTitle: subTitle,
        isOpen: isOpen,
        onHeaderClick: onHeaderClick,
        components: components,
        renderHeaderActions: renderHeaderActions,
        stickyHeaderPosition: stickyHeaderPosition,
        // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown> | null' is not assignable to type 'Ref<Props> | undefined'.
        ref: stickyHeaderEnabled === true ? CollapsibleGroupRef : null
    }, children));
};
const $e768e0ff2cd32f5d$export$af87ab18ecfff2e7 = ({ icon: icon, title: title, subtitle: subtitle, status: status, extension: extension, ...rest })=>{
    const components = {
        HeaderRightAligned: (0, $eUqFw.useCallback)(({ children: children, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dTpRF.defaultComponents).HeaderRightAligned, null, !isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8EvR4.Status), {
                status: status,
                extension: extension
            }), children), [
            status,
            extension
        ])
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const name = title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e768e0ff2cd32f5d$export$36287b0242004a4d, {
        ...rest,
        title: title,
        components: components,
        subTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1CHJT.Subtitle), {
            icon: icon,
            label: subtitle,
            name: name
        })
    });
};

});
const $3ebb2187fb744e2b$export$2f4ad3e3017ae3f6 = 'bentoCollapsibleGroup';

parcelRegister("3c5B8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c162f3c3b6801179$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7GSu6 = parcelRequire("7GSu6");

var $jYCXZ = parcelRequire("jYCXZ");

var $dTpRF = parcelRequire("dTpRF");
const $c162f3c3b6801179$var$HEADER_TITLE_DATA_TEST_ID = 'issue-view-layout-group.common.ui.collapsible-group-factory.title';
const $c162f3c3b6801179$var$HeaderComponent = ({ id: id, isOpen: isOpen, subTitle: subTitle, title: title, onToggle: onToggle, renderHeaderActions: renderHeaderActions, stickyHeaderPosition: stickyHeaderPosition, componentsMerged: componentsMerged, innerRef: innerRef })=>{
    const { Title: Title, SubTitle: SubTitle, Header: Header, HeaderRightAligned: HeaderRightAligned } = componentsMerged;
    const testId = id === null || id === undefined ? undefined : {
        'data-testid': `issue-view-layout-group.common.ui.collapsible-group-factory.${id}`
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, {
        "aria-label": title,
        onClick: onToggle,
        tabIndex: 0,
        ...testId,
        stickyHeaderPosition: stickyHeaderPosition,
        ref: innerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Title, {
        "data-testid": $c162f3c3b6801179$var$HEADER_TITLE_DATA_TEST_ID
    }, title), subTitle !== undefined && !isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SubTitle, {
        "aria-hidden": "true"
    }, subTitle), typeof renderHeaderActions === 'function' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeaderRightAligned, {
        isOpen: isOpen
    }, renderHeaderActions()));
};
const $c162f3c3b6801179$export$1add84fae63813f7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, components: components, id: id, isOpen: isOpen, onHeaderClick: onHeaderClick, renderHeaderActions: renderHeaderActions, stickyHeaderPosition: stickyHeaderPosition, subTitle: subTitle, title: title } = props;
    const componentsMerged = {
        ...(0, $dTpRF.defaultComponents),
        ...components
    };
    const { Group: Group, Body: Body } = componentsMerged;
    const didOpenAtLeastOnceRef = (0, $eUqFw.useRef)(false);
    const onToggle = (0, $eUqFw.useCallback)((event)=>{
        // Using `useRef` here instead of `useState` prevents an extra re-render
        // because `useState`'s updater functionc causes a re-render when being
        // updated.
        // See: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/pull-requests/60341/overview?commentId=3695533
        didOpenAtLeastOnceRef.current = true;
        event.preventDefault();
        onHeaderClick?.(event);
    }, // `onHeaderClick` should be a dependency as this is passed from a prop and
    // would otherwise trigger un-necessary re-renders (especially as this is not
    // memoized in the parent component `CollapsibleGroup`).
    [
        onHeaderClick
    ]);
    const headerRef = (0, $eUqFw.useRef)(null);
    const { registerSticky: registerSticky, deregisterSticky: deregisterSticky } = (0, $7GSu6.useStickyHeaderRegistration)();
    (0, $eUqFw.useEffect)(()=>{
        const STICKY_NAME = Symbol('group-header');
        registerSticky(STICKY_NAME, headerRef);
        return ()=>deregisterSticky(STICKY_NAME);
    }, [
        registerSticky,
        deregisterSticky,
        stickyHeaderPosition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYCXZ.default), {
        headerNode: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c162f3c3b6801179$var$HeaderComponent, {
            isOpen: isOpen,
            componentsMerged: componentsMerged,
            id: id,
            onToggle: onToggle,
            renderHeaderActions: renderHeaderActions,
            stickyHeaderPosition: stickyHeaderPosition,
            subTitle: subTitle,
            title: title,
            innerRef: headerRef
        }),
        Group: Group,
        isOpen: isOpen,
        ref: ref
    }, !didOpenAtLeastOnceRef.current && !isOpen || children === undefined ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Body, {
        isOpen: isOpen
    }, children));
});
var $c162f3c3b6801179$export$2e2bcd8739ae039 = $c162f3c3b6801179$export$1add84fae63813f7;

});
parcelRegister("jYCXZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4f3cec7a4113504$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dTpRF = parcelRequire("dTpRF");
const $c4f3cec7a4113504$export$2bee57c15c024503 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ Group: Group = (0, $dTpRF.GroupStyled), Header: Header, headerNode: headerNode, children: children, isOpen: isOpen }, ref)=>// @ts-expect-error - TS2322: Type 'ForwardedRef<HTMLDivElement>' is not assignable to type '(instance: HTMLDivElement | null) => void)
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Group, {
        ref: ref,
        open: isOpen
    }, headerNode !== undefined ? headerNode : Header !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, null), children));
var $c4f3cec7a4113504$export$2e2bcd8739ae039 = $c4f3cec7a4113504$export$2bee57c15c024503;

});
parcelRegister("dTpRF", function(module, exports) {

$parcel$export(module.exports, "configButtonSelectorName", () => $8e09cfc9dbdac634$export$4f8fa83400ed2f17);
$parcel$export(module.exports, "ConfigButton", () => $8e09cfc9dbdac634$export$2a11314f6699854b);
$parcel$export(module.exports, "IconWrapper", () => $8e09cfc9dbdac634$export$be58b4326e23250f);
$parcel$export(module.exports, "GroupStyled", () => $8e09cfc9dbdac634$export$d6c896a2586b1145);
$parcel$export(module.exports, "defaultComponents", () => $8e09cfc9dbdac634$export$71abc632aa29e6fe);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7u4fN = parcelRequire("7u4fN");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");

var $64ypR = parcelRequire("64ypR");

var $jBZ6y = parcelRequire("jBZ6y");
const $8e09cfc9dbdac634$var$groupBorderRadius = (0, $c9TLT.borderRadius) + 1;
const $8e09cfc9dbdac634$export$4f8fa83400ed2f17 = 'jira-issue-view-layout-group-common-ui-config-button';
const $8e09cfc9dbdac634$var$CONFIG_BUTTON_COMPONENT_SELECTOR = `[data-component-selector="${$8e09cfc9dbdac634$export$4f8fa83400ed2f17}"]`;
const $8e09cfc9dbdac634$export$2a11314f6699854b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cagmp _2hwxu2gc _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _ujqd1i6y",
            __cmplp.className
        ])
    });
});
const $8e09cfc9dbdac634$export$be58b4326e23250f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91tcg _otyrr5cr",
            __cmplp.className
        ])
    });
});
const $8e09cfc9dbdac634$var$titleStyledSelectorName = 'jira-issue-view-layout-group-common-ui-title-styled';
const $8e09cfc9dbdac634$export$ae6812c618ba6d69 = `[data-component-selector="${$8e09cfc9dbdac634$var$titleStyledSelectorName}"]`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e09cfc9dbdac634$var$TitleStyledComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "strong", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1gjq _11c81oud _k48p1wq8 _u5f31b66 _o5721q9c _1reo15vq _18m915vq _1bto1l2s _p12f1nrf _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $8e09cfc9dbdac634$var$TitleStyled = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8e09cfc9dbdac634$var$TitleStyledComponent, {
        "data-component-selector": $8e09cfc9dbdac634$var$titleStyledSelectorName,
        ...props
    });
const $8e09cfc9dbdac634$var$subTitleStyledSelectorName = 'jira-issue-view-layout-group-common-ui-sub-title-styled';
const $8e09cfc9dbdac634$export$2dc617aaa320abcb = `[data-component-selector="${$8e09cfc9dbdac634$var$subTitleStyledSelectorName}"]`;
// Issue View Fit and Finish: This 1px change will be kept until the font changes as using space tokens or otherwise misaligns the title and subtitle text
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e09cfc9dbdac634$var$SubTitleStyledComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1 _11c8qk37 _u5f3u2gc _o5721q9c _1reo15vq _18m915vq _1bto1l2s _ca0qt94y _5pff1i6y",
            __cmplp.className
        ])
    });
});
const $8e09cfc9dbdac634$var$SubTitleStyled = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8e09cfc9dbdac634$var$SubTitleStyledComponent, {
        "data-component-selector": $8e09cfc9dbdac634$var$subTitleStyledSelectorName,
        ...props
    });
const $8e09cfc9dbdac634$var$innerPaddingStyle = {
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`,
    boxSizing: 'border-box',
    [`${0, $64ypR.FIELD_HEADING_TITLE_COMPONENT_SELECTOR}, ${0, $64ypR.MULTILINE_FIELD_HEADING_TITLE_COMPONENT_SELECTOR}`]: {
        color: `var(--ds-text-subtle, ${(0, $PdmhA).N500})`
    },
    [(0, $64ypR.FIELD_WRAPPER_COMPONENT_SELECTOR)]: {
        marginBottom: "var(--ds-space-150, 12px)"
    },
    [`> div > ${0, $64ypR.FIELD_WRAPPER_COMPONENT_SELECTOR}:last-child`]: {
        marginBottom: 0
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e09cfc9dbdac634$var$HeadingRightAlignedStyled = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01wug _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $8e09cfc9dbdac634$var$borderStyle = `1px solid ${`var(--ds-border, ${(0, $PdmhA).N40})`}`;
const $8e09cfc9dbdac634$export$d6c896a2586b1145 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "details", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_ahoyl5": (0, $9t7rW.default)($8e09cfc9dbdac634$var$borderStyle)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _otyru2gc _1bzgidpf _y67v1yif _v9e41yif _12xi1yif _anbj1y44 _12gn1y44 _1jl4glyw _1pgpidpf _1apgidpf",
            __cmplp.className
        ])
    });
});
const $8e09cfc9dbdac634$var$InnerBodyPadding = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4125y _vchhusvi _146cjjyb _1rhgjjyb _texlutpp _kkknidpf",
            __cmplp.className
        ])
    });
});
const $8e09cfc9dbdac634$var$SummaryWithPadding = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "summary", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4125y _vchhusvi _146cjjyb _1rhgjjyb _texlutpp _kkknidpf",
            __cmplp.className
        ])
    });
});
const $8e09cfc9dbdac634$var$StyledInnerHeaderPadding = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $8e09cfc9dbdac634$var$SummaryWithPadding, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_ahoyl5": (0, $9t7rW.default)($8e09cfc9dbdac634$var$borderStyle),
            "--_122c6ee": (0, $9t7rW.default)(__cmplp.stickyHeaderPosition, "px"),
            "--_7zohb2": (0, $9t7rW.default)((0, $jBZ6y.issueViewLayers).groupStickyHeader)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _ca0qutpp _n3tdutpp _4t3ickbl _2rko1y44 _x3do1yif _19it1yif _4cvr1h6o _kqsw1if8 _bfhk1bhr _1pby1or5 _2it8glyw _1du212yw _1v3l12yw _19lc12yw _1372tlke _1pjhtlke _d0altlke _3ipitcjq _hnpdtcjq _15hutcjq _1di6tmi0 _q4zta5ev _138p1ihn _w1b81ihn _1vn01ihn",
            __cmplp.stickyHeaderPosition ? "_154i1fa8" : "_154iidpf",
            __cmplp.className
        ])
    });
});
const $8e09cfc9dbdac634$var$InnerHeaderPadding = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $8e09cfc9dbdac634$var$StyledInnerHeaderPadding, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y2mvj3jf _1bg412gs",
            __cmplp.className
        ])
    });
});
const $8e09cfc9dbdac634$export$71abc632aa29e6fe = {
    Title: $8e09cfc9dbdac634$var$TitleStyled,
    SubTitle: $8e09cfc9dbdac634$var$SubTitleStyled,
    HeaderRightAligned: $8e09cfc9dbdac634$var$HeadingRightAlignedStyled,
    Header: $8e09cfc9dbdac634$var$InnerHeaderPadding,
    Body: $8e09cfc9dbdac634$var$InnerBodyPadding,
    Group: $8e09cfc9dbdac634$export$d6c896a2586b1145
};

});



parcelRegister("4ityQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1ebdfa80b8a8cd6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f1ebdfa80b8a8cd6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    arrowRight: {
        "id": "issue-view-layout-group.arrow-right",
        "defaultMessage": "Collapsed"
    },
    arrowDown: {
        "id": "issue-view-layout-group.arrow-down",
        "defaultMessage": "Expanded"
    },
    configure: {
        "id": "issue-view-layout-group.configure",
        "defaultMessage": "Configure"
    }
});

});

parcelRegister("8EvR4", function(module, exports) {

$parcel$export(module.exports, "Status", () => $e33702bcabff7ee7$export$96e9906d6d93a972);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9nkwJ = parcelRequire("9nkwJ");

var $96IgR = parcelRequire("96IgR");

var $ffiyv = parcelRequire("ffiyv");

var $4Bees = parcelRequire("4Bees");

var $PdmhA = parcelRequire("PdmhA");

var $hnzPP = parcelRequire("hnzPP");

var $is86i = parcelRequire("is86i");

var $cKMNR = parcelRequire("cKMNR");
const $e33702bcabff7ee7$var$StatusInner = ({ status: status })=>{
    // entity props is arbitrary so it's possible that it's missing information
    if (!status?.value?.label) return null;
    const { value: value, type: type } = status;
    switch(type){
        case 'badge':
            {
                const num = parseInt(value.label || '', 10);
                if (num >= 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e33702bcabff7ee7$var$StyledStatus, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
                    appearance: "default"
                }, num));
                return null;
            }
        case 'icon':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e33702bcabff7ee7$var$StyledStatus, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
                url: value.label,
                width: 24,
                height: 24
            }));
        case 'lozenge':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e33702bcabff7ee7$var$StyledStatus, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                appearance: value.type
            }, value.label));
        default:
            return null;
    }
};
const $e33702bcabff7ee7$var$DynamicStatus = ({ extension: extension })=>{
    const issueData = (0, $is86i.useForgeUiIssueData)();
    const { properties: properties, error: error, isLoading: isLoading, fetch: fetch } = (0, $cKMNR.useDynamicProperties)(extension, issueData);
    (0, $eUqFw.useEffect)(()=>{
        fetch();
    }, [
        fetch
    ]);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e33702bcabff7ee7$var$StyledStatus, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small",
        testId: "issue-view-layout-group.ui.status.spinner"
    }));
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e33702bcabff7ee7$var$StyledStatus, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: "Error",
        primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA.R300)})`
    }));
    // ensure consistency with static statuses - StatusInner handles edge cases itself, so a typecast is fine
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e33702bcabff7ee7$var$StatusInner, {
        status: properties?.status
    });
};
const $e33702bcabff7ee7$export$96e9906d6d93a972 = ({ status: status, extension: extension })=>{
    const hasDynamicProperties = !!extension?.properties?.dynamicProperties;
    return hasDynamicProperties ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e33702bcabff7ee7$var$DynamicStatus, {
        extension: extension
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e33702bcabff7ee7$var$StatusInner, {
        status: status
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e33702bcabff7ee7$var$StyledStatus = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz15i6 _1e0c1txw _4cvr1h6o _2hwxu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1CHJT", function(module, exports) {

$parcel$export(module.exports, "Subtitle", () => $aa6df277bb49e87c$export$cf345ef34cd72655);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hnzPP = parcelRequire("hnzPP");

var $8uD7Y = parcelRequire("8uD7Y");
const $aa6df277bb49e87c$export$7c6e2c02157bb7d2 = ({ label: label, name: name })=>label === name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa6df277bb49e87c$var$StyledContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        id: "issue.ecosystem.context.rich-context-label",
        defaultMessage: "Open {label}",
        values: {
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa6df277bb49e87c$var$Bold, null, label)
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa6df277bb49e87c$var$StyledContent, null, label);
const $aa6df277bb49e87c$export$f04a61298a47a40f = ({ icon: icon })=>{
    if (!icon) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa6df277bb49e87c$var$StyledIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
        url: icon.url,
        alt: icon.alt,
        width: 24,
        height: 24
    }));
};
const $aa6df277bb49e87c$export$cf345ef34cd72655 = ({ icon: icon, label: label, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa6df277bb49e87c$var$SubtitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa6df277bb49e87c$export$f04a61298a47a40f, {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa6df277bb49e87c$export$7c6e2c02157bb7d2, {
        label: label,
        name: name
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa6df277bb49e87c$var$StyledIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _19pk1b66 _otyr1b66 _18u0u2gc _4t3i1tcg _1bsb1tcg _4cvr1h6o _19bvv77o _u5f3v77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa6df277bb49e87c$var$StyledContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s _16jlkb7n _1o9zkb7n _i0dlf1ug _vwz4zwfg _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa6df277bb49e87c$var$Bold = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa6df277bb49e87c$var$SubtitleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1BeH3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e96d503e1b22597$export$2e2bcd8739ae039);

var $imxJG = parcelRequire("imxJG");
var $0e96d503e1b22597$export$2e2bcd8739ae039 = (0, $imxJG.ChangeBoarding);

});
parcelRegister("imxJG", function(module, exports) {

$parcel$export(module.exports, "ChangeBoarding", () => $f52ff56e7d9bea78$export$38356d6775421b73);

var $eUqFw = parcelRequire("eUqFw");

var $iAwJB = parcelRequire("iAwJB");
var $fY29z = parcelRequire("fY29z");

var $c9TLT = parcelRequire("c9TLT");

var $5ge6s = parcelRequire("5ge6s");

var $5JgJ2 = parcelRequire("5JgJ2");

var $autRb = parcelRequire("autRb");

var $9qxRk = parcelRequire("9qxRk");

var $hJD55 = parcelRequire("hJD55");
const $f52ff56e7d9bea78$export$5c2179b1ccbe9340 = 'context-group-forge-apps-changeboarding';
const $f52ff56e7d9bea78$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $f52ff56e7d9bea78$export$38356d6775421b73 = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const spotlightPulseRef = (0, $eUqFw.useRef)(null);
    const [showSpotlightCard, setShowSpotlightCard] = (0, $eUqFw.useState)(true);
    const [showSpotlightPulse, setShowSpotlightPulse] = (0, $eUqFw.useState)(false);
    const onSpotlightPulseClick = ()=>{
        setShowSpotlightPulse(false);
    };
    const renderSpotlightCard = (stop)=>{
        const hideSpotlight = ()=>{
            setShowSpotlightCard(false);
            stop?.();
        };
        const onShowMeClick = ()=>{
            hideSpotlight();
            setShowSpotlightPulse(true);
            (0, $autRb.smoothScrollIntoViewIfNeeded)(spotlightPulseRef.current, {
                scrollMode: 'always',
                behavior: 'smooth'
            });
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJD55.SpotlightCardContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAwJB.default), {
            heading: formatMessage((0, $9qxRk.default).heading),
            actions: [
                {
                    text: formatMessage((0, $9qxRk.default).showMe),
                    onClick: onShowMeClick
                },
                {
                    text: formatMessage((0, $9qxRk.default).close),
                    onClick: hideSpotlight,
                    appearance: 'subtle'
                }
            ],
            width: 275
        }, formatMessage((0, $9qxRk.default).body)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: spotlightPulseRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fY29z.Pulse), {
        radius: (0, $c9TLT.borderRadius),
        pulse: showSpotlightPulse,
        onClick: onSpotlightPulseClick
    }, children), showSpotlightCard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ge6s.default), {
        messageId: $f52ff56e7d9bea78$export$5c2179b1ccbe9340
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f52ff56e7d9bea78$export$83d026e3dd5706d, null, renderSpotlightCard)));
};
var $f52ff56e7d9bea78$export$2e2bcd8739ae039 = $f52ff56e7d9bea78$export$38356d6775421b73;

});
parcelRegister("9qxRk", function(module, exports) {

$parcel$export(module.exports, "default", () => $153b98a8dcd2fe2f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ $153b98a8dcd2fe2f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "issue-view-layout-templates-views.context.visible-hidden.context-group.change-boarding.heading",
        "defaultMessage": "Show or hide apps"
    },
    body: {
        "id": "issue-view-layout-templates-views.context.visible-hidden.context-group.change-boarding.body",
        "defaultMessage": "Use your apps without hiding other fields. Some apps may not be in groups yet."
    },
    showMe: {
        "id": "issue-view-layout-templates-views.context.visible-hidden.context-group.change-boarding.show-me",
        "defaultMessage": "Show me"
    },
    close: {
        "id": "issue-view-layout-templates-views.context.visible-hidden.context-group.change-boarding.close",
        "defaultMessage": "Close"
    }
});

});

parcelRegister("hJD55", function(module, exports) {

$parcel$export(module.exports, "SpotlightCardContainer", () => $0dd83d51327ab5f2$export$a79032d4c60cf541);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $0dd83d51327ab5f2$export$a79032d4c60cf541 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1xi2xy5q _154i1ejb _1pbyowjs",
            __cmplp.className
        ])
    });
});

});



parcelRegister("cVvuK", function(module, exports) {

$parcel$export(module.exports, "ContextGroupContainer", () => $9ce9435d9606e3dc$export$e95d8ebcaba111b1);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $9ce9435d9606e3dc$export$e95d8ebcaba111b1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyru2gc",
            __cmplp.className
        ])
    });
});

});


parcelRegister("bwIYX", function(module, exports) {

$parcel$export(module.exports, "useGenerateAdditionalAnalyticsEventAttributes", () => $76250a99181400aa$export$3275832b9861f77b);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $dZWHl = parcelRequire("dZWHl");
var $6RRxR = parcelRequire("6RRxR");

var $2Ls45 = parcelRequire("2Ls45");

const $76250a99181400aa$export$1f07cc40b2ec27d3 = (node)=>{
    if (node.children.length) return Array.prototype.every.call(node.children, $76250a99181400aa$export$1f07cc40b2ec27d3);
    return node.innerHTML === '';
};
const $76250a99181400aa$export$a782b5fdac308350 = (secondaryItemIds, fields)=>fields.map((field)=>(0, $dZWHl.getLayoutItemId)(field)).filter((id)=>secondaryItemIds.includes(id));
const $76250a99181400aa$export$94bea7e474f8e8de = (fields)=>{
    const groups = {
        appFieldTypes: [],
        customFieldTypes: [],
        panelItemTypes: [],
        systemFieldTypes: []
    };
    fields.forEach((field)=>{
        const { analytics: analytics } = field;
        switch(analytics.group){
            case 0, $f76cb735e43527c2$export$95b9271ec103000c:
                groups.appFieldTypes.push(analytics.value);
                break;
            case 0, $f76cb735e43527c2$export$1c29733909e6e30d:
                groups.customFieldTypes.push(analytics.value);
                break;
            case 0, $f76cb735e43527c2$export$340512504106afd7:
                groups.panelItemTypes.push(analytics.value);
                break;
            case 0, $f76cb735e43527c2$export$da3a70ed0c0cd302:
                groups.systemFieldTypes.push(analytics.value);
                break;
            default:
                break;
        }
    });
    return groups;
};
const $76250a99181400aa$export$2f9f60b385e98b30 = (fields, numOfFields, numHiddenWhenEmptyItems)=>{
    const { appFieldTypes: appFieldTypes, customFieldTypes: customFieldTypes, panelItemTypes: panelItemTypes, systemFieldTypes: systemFieldTypes } = fields;
    return {
        numHiddenWhenEmptyItems: numHiddenWhenEmptyItems,
        panelItemTypes: panelItemTypes,
        systemFieldTypes: systemFieldTypes,
        customFieldTypes: customFieldTypes,
        appFieldTypes: appFieldTypes,
        numOfFields: numOfFields
    };
};
const $76250a99181400aa$export$3275832b9861f77b = (fields)=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const secondaryItemIds = (0, $6RRxR.useSecondaryItemIds)(issueKey);
    const layoutItemFields = (0, $2Ls45.useLayoutItem)(fields);
    const numHiddenWhenEmptyItems = (0, $eUqFw.useMemo)(()=>$76250a99181400aa$export$a782b5fdac308350(secondaryItemIds, layoutItemFields).length, [
        layoutItemFields,
        secondaryItemIds
    ]);
    const fieldsByGroupType = (0, $eUqFw.useMemo)(()=>$76250a99181400aa$export$94bea7e474f8e8de(layoutItemFields), [
        layoutItemFields
    ]);
    const additionalAnalyticsEvents = (0, $eUqFw.useMemo)(()=>$76250a99181400aa$export$2f9f60b385e98b30(fieldsByGroupType, layoutItemFields.length, numHiddenWhenEmptyItems), [
        fieldsByGroupType,
        layoutItemFields.length,
        numHiddenWhenEmptyItems
    ]);
    return additionalAnalyticsEvents;
};
const $76250a99181400aa$export$e36f6b02bab607db = (node, hasItems, setHasItems)=>(mutationsList)=>{
        mutationsList.forEach((mutation)=>{
            if (mutation.type === 'childList' && node !== null) {
                if (!$76250a99181400aa$export$1f07cc40b2ec27d3(node)) !hasItems && setHasItems(true);
                else if (hasItems) setHasItems(false);
            }
        });
    };

});
parcelRegister("6RRxR", function(module, exports) {

$parcel$export(module.exports, "useSecondaryItemIds", () => $bdfcbc28f872657f$export$dff9680dca38f9a8);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $bLiXo = parcelRequire("bLiXo");

var $dZWHl = parcelRequire("dZWHl");
var $fCyzk = parcelRequire("fCyzk");
const $bdfcbc28f872657f$export$feb4325e7412020e = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [issueLayoutContainers] = (0, $fCyzk.useIssueLayoutContainers)(issueKey);
    const issueLayoutFields = (0, $eUqFw.useMemo)(()=>issueLayoutContainers.reduce((acc, container)=>{
            if (!Array.isArray(container?.items?.nodes) || container.items.nodes.length === 0) return acc;
            const { nodes: nodes } = container.items;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const allItemsFromContainer = nodes.reduce((allItems, item)=>{
                if (item.type === (0, $bLiXo.layoutContainerItemTypes).field) return allItems.concat((0, $dZWHl.getLayoutItemId)(item));
                if (item.type === (0, $bLiXo.layoutContainerItemTypes).tab) return allItems.concat(item.items.nodes.filter((tabItem)=>tabItem.type === (0, $bLiXo.layoutContainerItemTypes).field).map((tabItem)=>(0, $dZWHl.getLayoutItemId)(tabItem)));
                return allItems;
            }, []);
            return acc.concat(allItemsFromContainer);
        }, []), [
        issueLayoutContainers
    ]);
    return [
        {
            issueLayoutFields: issueLayoutFields
        }
    ];
};
const $bdfcbc28f872657f$export$dff9680dca38f9a8 = (issueKey)=>{
    const [secondaryFields] = (0, $fCyzk.useLayoutContainerByType)(issueKey, 'SECONDARY');
    const secondaryItemsIds = (0, $eUqFw.useMemo)(()=>secondaryFields.map((0, $dZWHl.getLayoutItemId)), [
        secondaryFields
    ]);
    return secondaryItemsIds;
};

});

const $f76cb735e43527c2$export$95b9271ec103000c = 'app';
const $f76cb735e43527c2$export$1c29733909e6e30d = 'custom';
const $f76cb735e43527c2$export$340512504106afd7 = 'panel';
const $f76cb735e43527c2$export$da3a70ed0c0cd302 = 'system';


parcelRegister("cOMss", function(module, exports) {

$parcel$export(module.exports, "isSortingPinnedFieldsEnabled", () => $ded8c9bbae41d09b$export$cce5c39a2a1dacf1);

var $1ybV0 = parcelRequire("1ybV0");
const $ded8c9bbae41d09b$export$e6ec1a9a62cbf071 = 'issue.details.sorting-pinned-fields';
const $ded8c9bbae41d09b$export$cce5c39a2a1dacf1 = ()=>(0, $1ybV0.ff)('issue.details.sorting-pinned-fields', false); // </wviveiro>

});

parcelRegister("6YcPr", function(module, exports) {

$parcel$export(module.exports, "generateContextPanels", () => $a9e6453d2ad3f7a7$export$8e48e4dc4614073a);
/* utils.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ciZ8Y = parcelRequire("ciZ8Y");


var $1ybV0 = parcelRequire("1ybV0");

var $bLiXo = parcelRequire("bLiXo");

var $4ceCM = parcelRequire("4ceCM");


var $3DTsn = parcelRequire("3DTsn");

var $jbrPp = parcelRequire("jbrPp");

var $2qZHF = parcelRequire("2qZHF");

var $BW6fk = parcelRequire("BW6fk");
// Required as per JIV-13665 to smooth out loading state with forge
// The numbers below match the loadingComponent height in LazyIssueContext
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a9e6453d2ad3f7a7$var$LoadingContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tkecmky _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $a9e6453d2ad3f7a7$export$8e48e4dc4614073a = (givenContextItems, layoutItemsDataFragment, application, edition)=>{
    if (!givenContextItems || !Array.isArray(givenContextItems) || !givenContextItems.length) return [];
    return givenContextItems.map((contextItem, index)=>{
        const { name: title, icon: icon, status: status, label: subtitle } = contextItem.payload;
        const groupItemWithoutErrorBoundary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $BW6fk.ContextPanelGroup), {
            key: `context-item-${contextItem.id}`,
            groupId: `context-group-${contextItem.id}`,
            title: title,
            icon: icon,
            status: status,
            subtitle: subtitle,
            initialOpened: (0, $ab2aafcdf11a1361$export$e1184c3be46bd7cb),
            extension: contextItem.payload.extension
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a9e6453d2ad3f7a7$var$LoadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3DTsn.ItemList), {
            items: [
                contextItem
            ],
            area: (0, $bLiXo.CONTEXT_AREA),
            layoutItemsDataFragment: layoutItemsDataFragment ?? null
        })));
        let groupItemWithErrorBoundary;
        if ((0, $1ybV0.ff)('instrumentation-of-issue-ecosystem-reliability-slo-metrics-rhs_tpmqi')) groupItemWithErrorBoundary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
            id: "issue-view.context.ecosystem-context-panel",
            onError: (location, error)=>{
                (0, $4ceCM.sendExperienceAnalytics)({
                    experience: 'issueViewContextGroupRender',
                    analyticsSource: 'issueViewContextGroupView',
                    application: application ?? null,
                    edition: edition ?? null,
                    wasExperienceSuccesful: false,
                    action: (0, $99e7a4e4cbcb5db0$export$b48b3d1872522384),
                    additionalAttributes: {
                        location: location,
                        errorMessage: error.message
                    }
                });
            }
        }, groupItemWithoutErrorBoundary, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: ()=>(0, $4ceCM.sendExperienceAnalytics)({
                    experience: 'issueViewContextGroupRender',
                    analyticsSource: 'issueViewContextGroupView',
                    application: application ?? null,
                    edition: edition ?? null,
                    wasExperienceSuccesful: true,
                    action: (0, $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a)
                })
        }));
        const groupItem = (0, $1ybV0.ff)('instrumentation-of-issue-ecosystem-reliability-slo-metrics-rhs_tpmqi') ? // @ts-expect-error "Variable 'groupItemWithErrorBoundary' is used before being assigned." - this is because it doesnt realise it will always be assigned if the ff is on
        groupItemWithErrorBoundary : groupItemWithoutErrorBoundary;
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jbrPp.default), {
            key: "context-item-change-boarding"
        }, groupItem);
        return groupItem;
    });
};

});
parcelRegister("BW6fk", function(module, exports) {

$parcel$export(module.exports, "ContextPanelGroup", () => $0b26976d9a680fe3$export$8975c2a01a0b855);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $fT83w = parcelRequire("fT83w");

var $hJ992 = parcelRequire("hJ992");

var $cOaZ6 = parcelRequire("cOaZ6");

var $guDlK = parcelRequire("guDlK");
const $0b26976d9a680fe3$export$8975c2a01a0b855 = ({ onChange: onChange, children: children, initialOpened: initialOpened, additionalEventAttributes: additionalEventAttributes, title: title, icon: icon, status: status, subtitle: subtitle, groupId: groupId, extension: extension })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b26976d9a680fe3$var$ContextGroupContainer, {
        "data-testid": `issue-view-layout-templates-views.ui.context.visible-hidden.ui.ecosystem-context-group.container.${groupId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOaZ6.CollapsibleGroupWithHeaderIcon), {
        title: extension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fT83w.ExtensionTitle), {
            extensionName: title,
            extensionEnvType: extension.environmentType,
            extensionEnvKey: extension.environmentKey
        }) || title,
        id: groupId,
        projectKey: projectKey,
        onChange: onChange,
        initialOpened: initialOpened,
        additionalEventAttributes: additionalEventAttributes,
        icon: icon,
        subtitle: subtitle,
        status: status,
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": `issue-view-layout-templates-views.ui.context.visible-hidden.ui.ecosystem-context-group.${groupId}`
    }, children)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b26976d9a680fe3$var$ContextGroupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyru2gc",
            __cmplp.className
        ])
    });
});

});


parcelRegister("5hnwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6013106d2182ea2e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6013106d2182ea2e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreFieldsText: {
        "id": "issue-view-layout-templates-views.context.visible-hidden.more-fields-text",
        "defaultMessage": "More fields"
    },
    // TODO: When cleaning up isSortingPinnedFieldsEnabled remove pinnedFieldsText
    pinnedFieldsText: {
        "id": "issue-view-layout-templates-views.context.visible-hidden.pinned-fields-text",
        "defaultMessage": "Pinned fields"
    },
    pinnedFieldsTitle: {
        "id": "issue-view-layout-templates-views.context.visible-hidden.pinned-fields-title",
        "defaultMessage": "Your pinned fields"
    },
    detailsText: {
        "id": "issue-view-layout-templates-views.context.visible-hidden.details-text",
        "defaultMessage": "Details"
    }
});

});



parcelRegister("dSblC", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d39ee061934711$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dmdpA = parcelRequire("dmdpA");

var $5S8lG = parcelRequire("5S8lG");

var $bLiXo = parcelRequire("bLiXo");

var $kln9T = parcelRequire("kln9T");

var $1uomc = parcelRequire("1uomc");

var $NfInV = parcelRequire("NfInV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$26d39ee061934711$export$2e2bcd8739ae039 = ({ issueViewRelayFragment: issueViewRelayFragment })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dmdpA.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $NfInV.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5S8lG.IssueViewDataClassification), {
        issueViewRelayFragment: issueViewRelayFragment ?? null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26d39ee061934711$var$FoundationContentWrapper, {
        "data-testid": "issue-view-layout-templates-default.ui.foundation-content.foundation-content-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kln9T.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26d39ee061934711$var$SummaryFieldWrapper, {
        key: (0, $bLiXo.REACT_KEY_SUMMARY)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1uomc.default), null))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26d39ee061934711$var$FoundationContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _1bsb1osq",
            __cmplp.className
        ])
    });
});
$26d39ee061934711$var$FoundationContentWrapper.displayName = 'FoundationContentWrapper';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26d39ee061934711$var$SummaryFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _p7r11txw _nphskb7n _t1edkb7n _1t3b1wug",
            __cmplp.className
        ])
    });
});
$26d39ee061934711$var$SummaryFieldWrapper.displayName = 'SummaryFieldWrapper';

});
parcelRegister("dmdpA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e315623fa61618ec$export$2e2bcd8739ae039);

var $9FxDL = parcelRequire("9FxDL");
var $e315623fa61618ec$export$2e2bcd8739ae039 = (0, $9FxDL.BlockedAppsIssueInfoBanner);

});
parcelRegister("9FxDL", function(module, exports) {

$parcel$export(module.exports, "BlockedAppsIssueInfoBanner", () => $b3bfc53fa548edc0$export$85de69ff977a9a98);

var $eUqFw = parcelRequire("eUqFw");

var $9dp5m = parcelRequire("9dp5m");

var $fs49D = parcelRequire("fs49D");

var $hJ992 = parcelRequire("hJ992");

var $2Sajo = parcelRequire("2Sajo");

var $guDlK = parcelRequire("guDlK");

var $f8m5c = parcelRequire("f8m5c");

var $fqLyl = parcelRequire("fqLyl");
const $b3bfc53fa548edc0$var$useHasBlockedExtensionsWithDefaultToFalse = ()=>{
    const forge = (0, $2Sajo.useHasBlockedExtensions)() || false;
    const connect = (0, $fqLyl.useHasBlockedConnectApps)() || false;
    return forge || connect;
};
const $b3bfc53fa548edc0$var$useViewBlockedAppsLink = ()=>`${(0, $9dp5m.getATLContextUrl)('id')}/manage-profile/apps`;
const $b3bfc53fa548edc0$var$useLocalStorage = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const [notShowAgain, setNotShowAgain] = (0, $eUqFw.useState)(()=>Boolean(localStorage.getItem(`showBlockedAppsBanner-${projectKey}`)));
    const handleDoNotShowAgain = (0, $eUqFw.useCallback)(()=>{
        localStorage.setItem(`showBlockedAppsBanner-${projectKey}`, 'true');
        setNotShowAgain(true);
    }, [
        projectKey
    ]);
    return [
        notShowAgain,
        handleDoNotShowAgain
    ];
};
const $b3bfc53fa548edc0$export$85de69ff977a9a98 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fs49D.default), {
        getHasBlockedExtensions: $b3bfc53fa548edc0$var$useHasBlockedExtensionsWithDefaultToFalse,
        getViewBlockedAppsLink: $b3bfc53fa548edc0$var$useViewBlockedAppsLink,
        getMainMessage: ()=>(0, $f8m5c.default).appsHaveBeenBlockedByYourAdmin,
        dismissalHandler: $b3bfc53fa548edc0$var$useLocalStorage
    });

});
parcelRegister("fs49D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5297dd6ff9a3454e$export$2e2bcd8739ae039);

var $b0zNM = parcelRequire("b0zNM");

var $5297dd6ff9a3454e$export$2e2bcd8739ae039 = (0, $b0zNM.BaseBlockedAppsInfoBanner);

});
parcelRegister("b0zNM", function(module, exports) {

$parcel$export(module.exports, "BaseBlockedAppsInfoBanner", () => $88d14ea95b079e4c$export$6f20a053b9f11d45);

var $eUqFw = parcelRequire("eUqFw");

var $lRvnl = parcelRequire("lRvnl");
var $cEUHb = parcelRequire("cEUHb");

var $0cdA8 = parcelRequire("0cdA8");

var $bBGpO = parcelRequire("bBGpO");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1rn54 = parcelRequire("1rn54");
const $88d14ea95b079e4c$export$aa7011e13d9716d7 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const hasBlockedExtensions = props.getHasBlockedExtensions();
    const link = props.getViewBlockedAppsLink();
    const [dismissed, onDismiss] = props.dismissalHandler();
    const mainMessage = props.getMainMessage();
    if (!hasBlockedExtensions || dismissed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "information",
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEUHb.default), {
                key: (0, $1rn54.default).learnMore.id,
                href: link
            }, formatMessage((0, $1rn54.default).learnMore)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEUHb.default), {
                key: (0, $1rn54.default).dontShowAgain.id,
                onClick: onDismiss
            }, formatMessage((0, $1rn54.default).dontShowAgain))
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage(mainMessage)));
};
const $88d14ea95b079e4c$export$6f20a053b9f11d45 = (props)=>{
    const getAttributes = (0, $eUqFw.useCallback)((error)=>(0, $bBGpO.createAttributes)({
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "ecosystem-blocked-apps-info-banner",
        packageName: "jiraCommonComponentsBlockedAppsInfoBanner",
        teamName: "smite",
        fallback: "unmount",
        attributes: getAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($88d14ea95b079e4c$export$aa7011e13d9716d7, props));
};

});
parcelRegister("1rn54", function(module, exports) {

$parcel$export(module.exports, "default", () => $b654fb60b3fafb9f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b654fb60b3fafb9f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    learnMore: {
        "id": "common-components-blocked-apps-info-banner.learn-more",
        "defaultMessage": "View blocked apps"
    },
    dontShowAgain: {
        "id": "common-components-blocked-apps-info-banner.dont-show-again",
        "defaultMessage": "Don\u2019t show again"
    }
});

});



parcelRegister("f8m5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $9902a44a55db27eb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9902a44a55db27eb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    appsHaveBeenBlockedByYourAdmin: {
        "id": "blocked-apps-info-banner.apps-have-been-blocked-by-your-admin",
        "defaultMessage": "Can't find something? Some apps are blocked by your admin in this project through a data security policy."
    }
});

});

parcelRegister("fqLyl", function(module, exports) {

$parcel$export(module.exports, "useHasBlockedConnectApps", () => $2b7793934fb25773$export$28084ac35de45a7a);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $hJ992 = parcelRequire("hJ992");

var $guDlK = parcelRequire("guDlK");

var $hnlK2 = parcelRequire("hnlK2");
const $2b7793934fb25773$export$28084ac35de45a7a = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const [hasBlockedApps, setHasBlockedApps] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (!projectKey) return;
        $2b7793934fb25773$export$40f1d90131a12a2({
            projectKey: projectKey
        }).then((response)=>{
            if (typeof response === 'boolean' && response) setHasBlockedApps(true);
        });
    }, [
        projectKey
    ]);
    return hasBlockedApps;
};
async function $2b7793934fb25773$export$40f1d90131a12a2(context) {
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
    const uri = '/rest/atlassian-connect/latest/addon-access';
    const cacheKey = 'projectId' in context ? context.projectId.toString() : context.projectKey;
    try {
        const cachedResult = (0, $hnlK2.perProjectRequestCache).get(cacheKey);
        const now = Date.now();
        const isCacheResultTimePassed = Boolean(cachedResult && (0, $hnlK2.TTL) < now - cachedResult.timestamp);
        if (isCacheResultTimePassed || !cachedResult) {
            const data = await (0, $lRmyA.performPostRequest)(uri, {
                headers: headers,
                body: JSON.stringify({
                    context: context
                })
            });
            (0, $hnlK2.perProjectRequestCache).set(cacheKey, {
                value: data.isAnyAppBlocked,
                timestamp: now
            });
            return data.isAnyAppBlocked;
        }
        return cachedResult.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'getConnectAccessNarrowingInfo',
                packageName: 'jiraBlockedAppsInfoBanner',
                teamName: 'smite'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
}

});
parcelRegister("hnlK2", function(module, exports) {

$parcel$export(module.exports, "TTL", () => $d47648e6ffdf3e6e$export$6ebb1381174e92a7);
$parcel$export(module.exports, "perProjectRequestCache", () => $d47648e6ffdf3e6e$export$7ca239d8e6e750f7);
/** Time to live */ const $d47648e6ffdf3e6e$export$6ebb1381174e92a7 = 60000;
const $d47648e6ffdf3e6e$export$7ca239d8e6e750f7 = new Map();

});




parcelRegister("5S8lG", function(module, exports) {

$parcel$export(module.exports, "IssueViewDataClassification", () => $68838a60f6ae3494$export$ecbce92b60703171);

var $kkpJp = parcelRequire("kkpJp");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");

var $b0VMw = parcelRequire("b0VMw");
const $68838a60f6ae3494$var$IssueViewDataClassificationWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($68838a60f6ae3494$var$IssueViewDataClassificationWrapperStyle, null, children);
const $68838a60f6ae3494$export$ecbce92b60703171 = ({ issueViewRelayFragment: issueViewRelayFragment })=>{
    const dataClassification = (0, $iWLL0.useFragment)((0, $kkpJp.default), issueViewRelayFragment);
    const IssueClassificationBadge = (0, $1ybV0.ff)('issue-view-classification-level-editability_88zal') ? (0, $b0VMw.IssueClassificationBadgeNew) : (0, $b0VMw.IssueClassificationBadgeOld);
    const classificationField = dataClassification?.fields?.edges?.map((edge)=>edge?.node) // nodes constants also "%other" fields. Look for the one we need
    .find((node)=>node?.__typename === 'JiraDataClassificationField') ?? null;
    return classificationField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($68838a60f6ae3494$var$IssueViewDataClassificationWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueClassificationBadge, {
        dataClassificationFragment: classificationField,
        popupZIndex: (0, $c9TLT.layers).modal
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68838a60f6ae3494$var$IssueViewDataClassificationWrapperStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kkpJp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0057b9c280747f43$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8f9e4179a4c23b69abc3b7e281f0c1fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0057b9c280747f43$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueFieldDataClassification_IssueViewDataClassification",
    "selections": [
        {
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fields",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_issueClassificationBadge_IssueClassificationBadgeOld_dataClassificationFragment"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_issueClassificationBadge_IssueClassificationBadgeNew_dataClassificationFragment"
                                        }
                                    ],
                                    "type": "JiraDataClassificationField"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$0057b9c280747f43$var$node.hash = "e74d192b732b6f7431bd7225d6d5a25f";
var $0057b9c280747f43$export$2e2bcd8739ae039 = $0057b9c280747f43$var$node;

});

parcelRegister("b0VMw", function(module, exports) {

$parcel$export(module.exports, "IssueClassificationBadgeNew", () => $9fe25bd046369ac7$export$165f9b495a2da82e);
$parcel$export(module.exports, "IssueClassificationBadgeOld", () => $9fe25bd046369ac7$export$2965c55b61f73829);

var $bymzM = parcelRequire("bymzM");

var $56g25 = parcelRequire("56g25");

var $4DjkM = parcelRequire("4DjkM");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $96IgR = parcelRequire("96IgR");

var $c0jFd = parcelRequire("c0jFd");

var $PdmhA = parcelRequire("PdmhA");

var $chKUp = parcelRequire("chKUp");

var $7ZZxN = parcelRequire("7ZZxN");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $K1Vl8 = parcelRequire("K1Vl8");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $guDlK = parcelRequire("guDlK");

var $3NVTf = parcelRequire("3NVTf");

var $gR4Jk = parcelRequire("gR4Jk");

var $bvfyh = parcelRequire("bvfyh");

var $j7atw = parcelRequire("j7atw");
const $9fe25bd046369ac7$export$af8ebba27f751ad1 = (0, $eo17r.toFlagId)('data-classification-update-sucess-flag');
const $9fe25bd046369ac7$export$bc55a1e4c238098b = (0, $eo17r.toFlagId)('data-classification-update-failure-flag');
const $9fe25bd046369ac7$export$35b223e814ebdb4b = (0, $eo17r.toFlagId)('data-classification-cannot-classify-issue-flag');
const $9fe25bd046369ac7$var$ErrorFetchingClassification = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "medium",
        label: "",
        primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA.R500)})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $bvfyh.messages).couldNotLoadClassificationLevel)));
};
const $9fe25bd046369ac7$export$165f9b495a2da82e = ({ dataClassificationFragment: dataClassificationFragment, popupZIndex: popupZIndex })=>{
    let getPopupState;
    let setPopupState;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [readView, setReadView] = (0, $eUqFw.useState)(true);
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    /**
   * Todo: Replace the constant `DATA_CLASSIFICATION_EDITING_STATE_KEY` with the destructured value from relay response
   * You can refer the file jira/src/packages/issue/fields/platform/date/inline-edit-full/src/ui/date/index.tsx
   * for the implementation of the same. There `uniqueFieldId` is destructured from the relay response.
   */ const [isIssueBeingClassified, setIsIssueBeingClassified] = (0, $K1Vl8.useOptionallyControlledEditingState)(false, (0, $lO4Or.DATA_CLASSIFICATION_TYPE));
    const data = (0, $iWLL0.useFragment)((0, $4DjkM.default), dataClassificationFragment);
    const [commit] = (0, $iWLL0.useMutation)((0, $56g25.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const displayClassificationUpdateFlag = (0, $eUqFw.useCallback)((success, classificationLevel = null)=>{
        if (success) {
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueClassificationSave updatedSuccess');
            if (!classificationLevel) showFlag({
                id: $9fe25bd046369ac7$export$af8ebba27f751ad1,
                title: formatMessage((0, $bvfyh.messages).noClassficationName),
                description: formatMessage((0, $bvfyh.messages).noClassficationDescription, {
                    issueKey: issueKey
                }),
                type: 'success',
                isAutoDismiss: true,
                testId: 'issue-classification-badge.ui.data-classification-success-flag-dismiss'
            });
            else showFlag({
                id: $9fe25bd046369ac7$export$af8ebba27f751ad1,
                title: formatMessage((0, $bvfyh.messages).sucessFlagTitle),
                description: formatMessage((0, $bvfyh.messages).successFlagDescription, {
                    name: classificationLevel?.name,
                    issueKey: issueKey
                }),
                type: 'success',
                isAutoDismiss: true,
                testId: 'issue-classification-badge.ui.data-classification-success-flag-dismiss'
            });
        } else {
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueClassificationSave updatedFailed');
            showFlag({
                id: $9fe25bd046369ac7$export$bc55a1e4c238098b,
                title: formatMessage((0, $bvfyh.messages).errorFlagTitle),
                description: formatMessage((0, $bvfyh.messages).errorFlagDescription),
                type: 'error',
                isAutoDismiss: true,
                testId: 'issue-classification-badge.ui.data-classification-failure-flag-dismiss'
            });
        }
    }, [
        createAnalyticsEvent,
        formatMessage,
        issueKey,
        showFlag
    ]);
    const onCommitCompleted = (0, $eUqFw.useCallback)(// @ts-expect-error: TS7006 Parameter 'response' implicitly has an 'any' type.
    (response)=>{
        if (!response.jira?.updateDataClassificationField) {
            displayClassificationUpdateFlag(false);
            return;
        }
        const { success: success, field: field } = response.jira.updateDataClassificationField;
        const { classificationLevel: classificationLevel } = field || {};
        if (!success) {
            displayClassificationUpdateFlag(false);
            return;
        }
        displayClassificationUpdateFlag(true, classificationLevel);
        setIsIssueBeingClassified(false);
    }, [
        displayClassificationUpdateFlag,
        setIsIssueBeingClassified
    ]);
    /* TODO in https://hello.jira.atlassian.cloud/browse/KEN-112:
   *  - add optimistic response
   *  - Update content in Error Flag
   *  - Add VR and unit tests to edit and read view popup
   * */ const handleSubmit = (0, $eUqFw.useCallback)((classificationDirty, closePopup, setShowUpdateSpinner)=>{
        commit({
            variables: {
                input: {
                    id: data?.id,
                    operation: {
                        operation: 'SET',
                        classificationLevel: classificationDirty.id
                    }
                }
            },
            onCompleted (response) {
                onCommitCompleted(response);
                setShowUpdateSpinner(false);
                setReadView(true);
                closePopup();
            },
            onError () {
                displayClassificationUpdateFlag(false);
                setShowUpdateSpinner(false);
                setReadView(true);
                closePopup();
            }
        });
    }, [
        commit,
        displayClassificationUpdateFlag,
        data?.id,
        onCommitCompleted
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const action = 'viewed';
        const actionSubject = 'classificationField';
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${actionSubject} ${action}`);
    }, [
        createAnalyticsEvent
    ]);
    const { classificationLevel: classificationLevel } = data;
    (0, $eUqFw.useEffect)(()=>{
        if (isIssueBeingClassified && classificationLevel && Object.keys(classificationLevel).length === 0) {
            /**
       * The above condition is used to handle the scenario when `classificationLevel`
       * is an empty object and user has clicked on Classify issue option. In such case
       * we need to show a flag to inform user that issue cannot be classified.
       */ showFlag({
                id: $9fe25bd046369ac7$export$35b223e814ebdb4b,
                title: formatMessage((0, $bvfyh.messages).cannotClassifyIssueTitle),
                description: formatMessage((0, $bvfyh.messages).cannotClassifyIssueDescription),
                type: 'warning',
                isAutoDismiss: true,
                actions: [
                    {
                        content: (0, $bvfyh.messages).refresh,
                        onClick: ()=>window.location.reload()
                    }
                ]
            });
            setIsIssueBeingClassified(false);
        } else if (isIssueBeingClassified) {
            /**
       * Setting the popup state to true always because this is the case when
       * user clicks on Classify issue and there will not be any toggle scenario.
       * Also, if because of any of the dependencies if this code runs twice
       * then popup will again close because of the old toggling condition.
       */ if (getPopupState && setPopupState) setPopupState(true);
            setReadView(false);
        } else if (setPopupState) setPopupState(false);
    }, [
        isIssueBeingClassified,
        classificationLevel,
        showFlag,
        formatMessage,
        getPopupState,
        setPopupState,
        setIsIssueBeingClassified
    ]);
    const { color: color, name: name, guidelines: guidelines } = classificationLevel || {};
    const { isEditable: isEditable } = data?.fieldConfig || {};
    const renderPopupComponent = (0, $eUqFw.useCallback)((closePopup)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
            id: "popup-error-boundary",
            packageName: "atlassian/jira-issue-classification-badge"
        }, readView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7atw.ClassificationReadViewPopup), {
            guideline: guidelines || undefined,
            name: name || undefined,
            onChangeLevelClick: isEditable ? ()=>{
                setReadView(false);
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'classificationReadViewPopupOnChangeButton clicked');
            } : undefined
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gR4Jk.ClassificationEditViewPopup), {
            customHeading: projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT) ? formatMessage((0, $bvfyh.messages).classifyRequest) : formatMessage((0, $bvfyh.messages).classifyIssue),
            onEditCancel: ()=>{
                setReadView(true);
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'classificationEditViewPopupCancelButton clicked');
                /**
       * This is the case when issue currently does NOT have classfication.
       * Then user clicks on Classify issue option in the meatball menu.
       * So EditView popup opens and then user clicks on cancel button.
       * In that case the popup should be closed instead of showing the readview popup.
       */ if (isIssueBeingClassified && !classificationLevel) {
                    closePopup();
                    setIsIssueBeingClassified(false);
                }
            },
            // @ts-expect-error ClassificationSelectOption argument types do not match but this will be fixed when we can import the types from @atlassian/data-classification-level after https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/74374/overview
            onEditSubmit: (classificationDirty, setShowUpdateSpinner)=>{
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'classificationEditViewPopupUpdateButton clicked');
                handleSubmit(classificationDirty, closePopup, setShowUpdateSpinner);
            },
            editViewPopupFragment: data
        })), [
        readView,
        guidelines,
        name,
        isEditable,
        projectType,
        formatMessage,
        data,
        createAnalyticsEvent,
        isIssueBeingClassified,
        classificationLevel,
        setIsIssueBeingClassified,
        handleSubmit
    ]);
    /**
   * This is for removing the data classification badge when user selects
   * No classification and user has not clicked on Classify issue option.
   */ if (!isIssueBeingClassified && !classificationLevel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    /**
   * If classificationLevel is an empty object then it's an error scenario.
   */ if (classificationLevel && Object.keys(classificationLevel).length === 0) {
        (0, $guiFP.default)({
            meta: {
                id: 'classificationLevelEmptyObjectError',
                packageName: 'jiraIssueClassificationBadge'
            },
            error: new Error('classificationLevel is an empty object')
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9fe25bd046369ac7$var$ErrorFetchingClassification, null);
    }
    /**
   * Modify the props based on whether meatball menu was clicked and issue is being explicitly classified(isIssueBeingClassified).
   * @returns {Object} currentName, currentColor, currentTestId, currentTooltip
   */ const getCurrentProps = ()=>{
        let currentName = name || undefined;
        // TODO: update the return type of color in the fragment
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        let currentColor = color?.colorKey;
        let currentTestId = 'issue-classification-badge.ui.data-classification';
        let currentTooltip = formatMessage((0, $bvfyh.messages).classificationLevel, {
            name: name
        });
        // If there's no existing classification and issue is being classified from meatball menu
        if (isIssueBeingClassified && !classificationLevel) {
            currentName = projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT) ? formatMessage((0, $bvfyh.messages).classifyRequest) : formatMessage((0, $bvfyh.messages).classifyIssue);
            currentColor = 'BLUE';
            currentTestId = 'issue-classification-badge.ui.no-classification';
            currentTooltip = undefined;
        }
        return {
            currentName: currentName,
            currentColor: currentColor,
            currentTestId: currentTestId,
            currentTooltip: currentTooltip
        };
    };
    const { currentName: currentName, currentColor: currentColor, currentTestId: currentTestId, currentTooltip: currentTooltip } = getCurrentProps();
    /**
   * This is the initial Classify issue button which is rendered
   * when user clicks on Classify issue in the meat ball menu
   */ if (isIssueBeingClassified && !classificationLevel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NVTf.ClassifyButton), {
        currentName: currentName,
        renderPopupComponent: renderPopupComponent
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $chKUp.default), {
        testId: currentTestId,
        name: currentName,
        color: currentColor,
        guideline: guidelines || undefined,
        popupZIndex: popupZIndex,
        tooltip: currentTooltip,
        onClick: ()=>(0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'classificationField clicked'),
        onPopupShown: ()=>(0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'classificationReadViewPopup viewed'),
        onPopupClose: ()=>{
            setReadView(true);
            setIsIssueBeingClassified(false);
        },
        renderPopupComponent: renderPopupComponent,
        getPopupStateControllers: (isPopupOpen, setPopupOpen)=>{
            getPopupState = isPopupOpen;
            setPopupState = setPopupOpen;
        }
    });
};
const $9fe25bd046369ac7$export$2965c55b61f73829 = ({ dataClassificationFragment: dataClassificationFragment, fallbackClassificationData: fallbackClassificationData, popupZIndex: popupZIndex })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    let classificationField = (0, $iWLL0.useFragment)((0, $bymzM.default), dataClassificationFragment);
    if (!dataClassificationFragment && fallbackClassificationData) classificationField = fallbackClassificationData;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClickAnalytics = ()=>{
        const action = 'clicked';
        const actionSubject = 'classificationField';
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), `${actionSubject} ${action}`);
    };
    const onPopupShownAnalytics = ()=>{
        const action = 'viewed';
        const actionSubject = 'classificationPopup';
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${actionSubject} ${action}`);
    };
    (0, $eUqFw.useEffect)(()=>{
        const action = 'viewed';
        const actionSubject = 'classificationField';
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${actionSubject} ${action}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!classificationField || !('classificationLevel' in classificationField) || !classificationField.classificationLevel) return null;
    const { color: color, name: name, guidelines: guidelines } = classificationField.classificationLevel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $chKUp.default), {
        testId: "issue-classification-badge.ui.data-classification",
        name: name || undefined,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: color?.colorKey,
        guideline: guidelines || undefined,
        popupZIndex: popupZIndex,
        tooltip: formatMessage((0, $bvfyh.messages).classificationLevel, {
            name: name
        }),
        onClick: onClickAnalytics,
        onPopupShown: onPopupShownAnalytics
    });
};
const $9fe25bd046369ac7$export$fa271cdcab5317fa = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('issue-view-classification-level-editability_88zal'), $9fe25bd046369ac7$export$165f9b495a2da82e, $9fe25bd046369ac7$export$2965c55b61f73829);

});
parcelRegister("bymzM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f73348221160b6a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1a35ba3fa0869acda1fdb4635042ae30>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8f73348221160b6a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueClassificationBadge_IssueClassificationBadgeOld_dataClassificationFragment",
    "selections": [
        {
            "concreteType": "JiraClassificationLevel",
            "kind": "LinkedField",
            "name": "classificationLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "colorKey"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "guidelines"
                }
            ]
        }
    ],
    "type": "JiraDataClassificationField"
};
$8f73348221160b6a$var$node.hash = "3635dc15e77182665a88e2994fd97a81";
var $8f73348221160b6a$export$2e2bcd8739ae039 = $8f73348221160b6a$var$node;

});

parcelRegister("56g25", function(module, exports) {

$parcel$export(module.exports, "default", () => $efcdfd822d31547b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<483adc7023cc936afadc51d22ed47c0a>>
 * @relayHash 22a6dcd801565f4eaaa1b44a3046d694
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 904223289e703cafc1823d4260ed098fbfba584faf5e6868ec496ab7ff8da9f7
const $efcdfd822d31547b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraDataClassificationFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateDataClassificationField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraDataClassificationField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldId"
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "classificationLevelSource"
                                },
                                {
                                    "concreteType": "JiraClassificationLevel",
                                    "kind": "LinkedField",
                                    "name": "classificationLevel",
                                    "plural": false,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "JiraColor",
                                            "kind": "LinkedField",
                                            "name": "color",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "colorKey"
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "guideline",
                                            "kind": "ScalarField",
                                            "name": "guidelines"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "definition"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_updateDataClassificationFieldMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_updateDataClassificationFieldMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "904223289e703cafc1823d4260ed098fbfba584faf5e6868ec496ab7ff8da9f7",
            "metadata": {},
            "name": "ui_updateDataClassificationFieldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$efcdfd822d31547b$var$node.hash = "126194a29e36435bded6eaa25bd49470";
var $efcdfd822d31547b$export$2e2bcd8739ae039 = $efcdfd822d31547b$var$node;

});

parcelRegister("4DjkM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ded332a2ce2a110$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<45cb127e82f06cd36cf36818912ebeaf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9ded332a2ce2a110$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueClassificationBadge_IssueClassificationBadgeNew_dataClassificationFragment",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "editViewPopup_issueClassificationBadge_ClassificationEditViewPopup"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        },
        {
            "concreteType": "JiraClassificationLevel",
            "kind": "LinkedField",
            "name": "classificationLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "guidelines"
                },
                {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "colorKey"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraDataClassificationField"
};
$9ded332a2ce2a110$var$node.hash = "397698557a4977790816aba1e30b128d";
var $9ded332a2ce2a110$export$2e2bcd8739ae039 = $9ded332a2ce2a110$var$node;

});

parcelRegister("chKUp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f1b75acd8105991$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $hSQOv = parcelRequire("hSQOv");
var $caLW4 = parcelRequire("caLW4");

var $4q38b = parcelRequire("4q38b");

var $8cU5f = parcelRequire("8cU5f");

var $ir7hA = parcelRequire("ir7hA");

var $aeMpE = parcelRequire("aeMpE");

var $gi16t = parcelRequire("gi16t");

var $g4VuS = parcelRequire("g4VuS");
const $8f1b75acd8105991$var$classificationViewContainerStyles = (0, $caLW4.xcss)({
    width: '330px'
});
function $8f1b75acd8105991$export$2e2bcd8739ae039({ testId: testId, name: name, tooltip: tooltip, tooltipPosition: tooltipPosition, color: color = 'NONE', iconSize: iconSize = 'small', guideline: guideline, isDisabled: isDisabled = false, isPopupDisabled: isPopupDisabled = false, isPopupOpenByDefault: isPopupOpenByDefault = false, getPopupStateControllers: getPopupStateControllers, popupZIndex: popupZIndex, guidelineRepresentation: guidelineRepresentation = 'PLAIN', onPopupShown: onPopupShown, onPopupClose: onPopupClose, onClick: onClick, renderPopupComponent: renderPopupComponent, popupLabel: popupLabel, popupTitleId: popupTitleId, popupRole: popupRole, shouldRenderToParent: shouldRenderToParent }) {
    const { colorMode: colorMode = 'light' } = (0, $4q38b.default)();
    const [isPopupOpen, setIsPopupOpen] = (0, $eUqFw.useState)(isDisabled || isPopupDisabled ? false : isPopupOpenByDefault);
    if (getPopupStateControllers) {
        const getOpenState = ()=>isPopupOpen;
        const setOpenState = (isOpen)=>setIsPopupOpen(isOpen);
        getPopupStateControllers(getOpenState, setOpenState);
    }
    const isIconOnly = !name || name.length === 0;
    const nameTruncated = (name !== null && name !== void 0 ? name : '').substring(0, (0, $aeMpE.nameMaxLength));
    const iconPx = iconSize === 'small' ? 14 : iconSize === 'medium' ? 18 : iconSize === 'large' ? 24 : iconSize === 'xlarge' ? 32 : iconSize === 'xxlarge' ? 40 : 14;
    const handleContainerClicked = ()=>{
        if (isPopupDisabled || isDisabled || !name || name.length === 0 || isIconOnly) return;
        if (onPopupShown) onPopupShown();
        setIsPopupOpen(!isPopupOpen);
    };
    const closePopup = ()=>{
        setIsPopupOpen(false);
    };
    const containerTagType = isPopupDisabled || isIconOnly ? 'span' : 'button';
    const ContainerTag = containerTagType === 'span' ? (0, $g4VuS.ContainerSpan) : (0, $g4VuS.ContainerButton);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        label: popupLabel,
        titleId: popupTitleId,
        role: popupRole,
        shouldRenderToParent: shouldRenderToParent,
        placement: "bottom-start",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: isPopupOpen ? null : tooltip,
                hideTooltipOnClick: true,
                position: tooltipPosition
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContainerTag, (0, $kU09D.default)({
                "data-testid": testId,
                className: isDisabled ? 'disabled' : '',
                disabledColorConfig: (0, $aeMpE.disabledColorConfig)[colorMode],
                colorsConfig: (0, $aeMpE.colorsConfig)[colorMode][color],
                isIconOnly: isIconOnly,
                isPopupDisabled: isPopupDisabled
            }, triggerProps, containerTagType === 'button' ? {
                disabled: isDisabled,
                type: 'button'
            } : {}, {
                onClick: ()=>{
                    if (onClick) onClick();
                    handleContainerClicked();
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gi16t.ClassificationIcon), {
                width: iconPx,
                height: iconPx,
                isDisabled: isDisabled,
                color: (0, $aeMpE.colorsConfig)[colorMode][color].fontColor,
                disabledColorConfig: (0, $aeMpE.disabledColorConfig)[colorMode]
            }), !isIconOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g4VuS.Name), {
                "data-testid": "data-classification-level-name"
            }, nameTruncated))),
        content: ()=>renderPopupComponent ? renderPopupComponent(closePopup) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), {
                padding: "space.250",
                xcss: $8f1b75acd8105991$var$classificationViewContainerStyles,
                role: "dialog",
                "aria-labelledby": "data-classification-read-content-name",
                "aria-describedby": "data-classification-read-content-guideline",
                "aria-modal": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ir7hA.ClassificationView), {
                name: name,
                guideline: guideline,
                guidelineRepresentation: guidelineRepresentation
            })),
        isOpen: isPopupOpen,
        onClose: ()=>{
            if (onPopupClose) onPopupClose();
            closePopup();
        },
        zIndex: popupZIndex
    });
}

});
parcelRegister("hSQOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d05072813f0b7a7a$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $fsr0b = parcelRequire("fsr0b");

var $caLW4 = parcelRequire("caLW4");

var $6VlmD = parcelRequire("6VlmD");
const $d05072813f0b7a7a$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $caLW4.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $byn9U.jsx)(Component, (0, $kU09D.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $d05072813f0b7a7a$var$baseStyles,
            backgroundColor && (0, $fsr0b.backgroundColorStylesMap)[backgroundColor],
            (0, $fsr0b.isSurfaceColorToken)(backgroundColor) && (0, $fsr0b.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $fsr0b.paddingStylesMap).padding[padding],
            paddingBlock && (0, $fsr0b.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $fsr0b.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $fsr0b.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $fsr0b.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $fsr0b.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $fsr0b.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $byn9U.jsx)((0, $6VlmD.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $d05072813f0b7a7a$export$2e2bcd8739ae039 = $d05072813f0b7a7a$export$e71c4d32a2263218;
const $d05072813f0b7a7a$var$baseStyles = (0, $byn9U.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("6VlmD", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", () => $50a8a367105aec1b$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $50a8a367105aec1b$export$1aeb4f6b93c4540d);

var $eUqFw = parcelRequire("eUqFw");
const $50a8a367105aec1b$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $eUqFw.createContext)('elevation.surface');
const $50a8a367105aec1b$export$1aeb4f6b93c4540d = ()=>{
    return (0, $eUqFw.useContext)($50a8a367105aec1b$export$1ca2a26fecb070ae);
};
$50a8a367105aec1b$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("ir7hA", function(module, exports) {

$parcel$export(module.exports, "ClassificationView", () => $d6c065c5dc6bb58b$export$d413367b4cbb5577);

var $eUqFw = parcelRequire("eUqFw");

var $exJuA = parcelRequire("exJuA");

var $hSQOv = parcelRequire("hSQOv");

var $2hniO = parcelRequire("2hniO");

var $4lTFP = parcelRequire("4lTFP");

var $aeMpE = parcelRequire("aeMpE");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d6c065c5dc6bb58b$var$Name = (0, $exJuA.default).h2({
    font: `var(--ds-font-heading-medium, ${(0, $4lTFP.fontFallback).heading.medium})`,
    color: "var(--ds-text, #172B4D)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d6c065c5dc6bb58b$var$Guideline = (0, $exJuA.default).p({
    font: `var(--ds-font-body, ${(0, $4lTFP.fontFallback).body.medium})`,
    color: "var(--ds-text, #172B4D)",
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word'
});
const $d6c065c5dc6bb58b$export$d413367b4cbb5577 = ({ name: name, guideline: guideline, guidelineRepresentation: guidelineRepresentation = 'PLAIN' })=>{
    const nameTruncated = (name !== null && name !== void 0 ? name : '').substring(0, (0, $aeMpE.nameMaxLength));
    const guidelineTruncated = (guideline !== null && guideline !== void 0 ? guideline : '').substring(0, (0, $aeMpE.guidelineMaxLength));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), null, nameTruncated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c065c5dc6bb58b$var$Name, {
        id: "data-classification-read-content-name"
    }, nameTruncated), guideline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), {
        paddingBlockStart: "space.200"
    }, guidelineRepresentation === 'PLAIN' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c065c5dc6bb58b$var$Guideline, {
        id: "data-classification-read-content-guideline"
    }, guidelineTruncated) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2hniO.default), {
        maxHeight: 200,
        truncated: true,
        document: JSON.parse(guideline)
    })));
};

});
parcelRegister("aeMpE", function(module, exports) {

$parcel$export(module.exports, "nameMaxLength", () => $7740c3f4ff5782ea$export$253bdad208569777);
$parcel$export(module.exports, "guidelineMaxLength", () => $7740c3f4ff5782ea$export$e1444e5b0a63d793);
$parcel$export(module.exports, "colorsConfig", () => $7740c3f4ff5782ea$export$fb2992e82b83582a);
$parcel$export(module.exports, "disabledColorConfig", () => $7740c3f4ff5782ea$export$9cdea53b8993b139);

var $3dpxL = parcelRequire("3dpxL");

var $01Bcy = parcelRequire("01Bcy");
const { formatMessage: $7740c3f4ff5782ea$var$formatMessage } = (0, $3dpxL.createIntl)({
    locale: 'en'
});
const $7740c3f4ff5782ea$export$89b67151eed9295a = {
    definition: $7740c3f4ff5782ea$var$formatMessage((0, $01Bcy.messages).noClassification),
    includeIcon: false
};
const $7740c3f4ff5782ea$export$253bdad208569777 = 50;
const $7740c3f4ff5782ea$export$cbc3cef853d1014b = 1000;
const $7740c3f4ff5782ea$export$e1444e5b0a63d793 = 1000;
const $7740c3f4ff5782ea$export$fb2992e82b83582a = {
    light: {
        YELLOW: {
            fontColor: '#693200',
            bgColor: '#FFF5D4',
            bgColorHovered: '#FFE48F',
            bgColorPressed: '#FFC716',
            bgColorFocused: '#FFF5D4'
        },
        ORANGE: {
            fontColor: '#3A2C1F',
            bgColor: '#FFC716',
            bgColorHovered: '#FCA700',
            bgColorPressed: '#FA8700',
            bgColorFocused: '#FCA700'
        },
        RED: {
            fontColor: '#AE2E24',
            bgColor: '#FFECEB',
            bgColorHovered: '#FFD5D2',
            bgColorPressed: '#FD9891',
            bgColorFocused: '#FFECEB'
        },
        RED_BOLD: {
            fontColor: '#FFFFFF',
            bgColor: '#C9372C',
            bgColorHovered: '#AE2E24',
            bgColorPressed: '#5D1F1A',
            bgColorFocused: '#C9372C'
        },
        PURPLE: {
            fontColor: '#352C63',
            bgColor: '#DFD8FD',
            bgColorHovered: '#B8ACF6',
            bgColorPressed: '#9F8FEF',
            bgColorFocused: '#DFD8FD'
        },
        BLUE: {
            fontColor: '#09326C',
            bgColor: '#CCE0FF',
            bgColorHovered: '#85B8FF',
            bgColorPressed: '#579DFF',
            bgColorFocused: '#CCE0FF'
        },
        TEAL: {
            fontColor: '#206A83',
            bgColor: '#E7F9FF',
            bgColorHovered: '#C6EDFB',
            bgColorPressed: '#9DD9EE',
            bgColorFocused: '#E7F9FF'
        },
        GREEN: {
            fontColor: '#164B35',
            bgColor: '#BAF3DB',
            bgColorHovered: '#7EE2B8',
            bgColorPressed: '#4BCE97',
            bgColorFocused: '#BAF3DB'
        },
        GREY: {
            fontColor: '#172B4D',
            bgColor: '#F1F2F4',
            bgColorHovered: '#DCDFE4',
            bgColorPressed: '#B3B9C4',
            bgColorFocused: '#F1F2F4'
        },
        LIME: {
            fontColor: '#4C6B1F',
            bgColor: '#EFFFD6',
            bgColorHovered: '#D3F1A7',
            bgColorPressed: '#B3DF72',
            bgColorFocused: '#EFFFD6'
        },
        // Colors below to be removed soon so they do not have bgColorFocused
        NONE: {
            fontColor: '#172B4D',
            bgColor: 'inherit',
            bgColorHovered: 'rgba(9, 30, 66, 0.06)',
            bgColorPressed: 'rgba(9, 30, 66, 0.14)'
        },
        BLUE_BOLD: {
            fontColor: '#FFFFFF',
            bgColor: '#005C99',
            bgColorHovered: '#007ACC',
            bgColorPressed: '#003D66'
        }
    },
    dark: {
        YELLOW: {
            fontColor: '#FFE48F',
            bgColor: '#3A2C1F',
            bgColorHovered: '#693200',
            bgColorPressed: '#9E4C00',
            bgColorFocused: '#3A2C1F'
        },
        ORANGE: {
            fontColor: '#3A2C1F',
            bgColor: '#FFC716',
            bgColorHovered: '#FCA700',
            bgColorPressed: '#FA8700',
            bgColorFocused: '#FCA700'
        },
        RED: {
            fontColor: '#FD9891',
            bgColor: '#42221F',
            bgColorHovered: '#5D1F1A',
            bgColorPressed: '#AE2E24',
            bgColorFocused: '#42221F'
        },
        RED_BOLD: {
            fontColor: '#1D2125',
            bgColor: '#F87168',
            bgColorHovered: '#FD9891',
            bgColorPressed: '#FFD5D2',
            bgColorFocused: '#F87168'
        },
        PURPLE: {
            fontColor: '#DFD8FD',
            bgColor: '#352C63',
            bgColorHovered: '#5E4DB2',
            bgColorPressed: '#6E5DC6',
            bgColorFocused: '#352C63'
        },
        BLUE: {
            fontColor: '#CCE0FF',
            bgColor: '#09326C',
            bgColorHovered: '#0055CC',
            bgColorPressed: '#0C66E4',
            bgColorFocused: '#09326C'
        },
        TEAL: {
            fontColor: '#9DD9EE',
            bgColor: '#1E3137',
            bgColorHovered: '#164555',
            bgColorPressed: '#206A83',
            bgColorFocused: '#1E3137'
        },
        GREEN: {
            fontColor: '#BAF3DB',
            bgColor: '#164B35',
            bgColorHovered: '#216E4E',
            bgColorPressed: '#1F845A',
            bgColorFocused: '#164B35'
        },
        GREY: {
            fontColor: '#B6C2CF',
            bgColor: '#2C333A',
            bgColorHovered: '#38414A',
            bgColorPressed: '#454F59',
            bgColorFocused: '#2C333A'
        },
        LIME: {
            fontColor: '#B3DF72',
            bgColor: '#28311B',
            bgColorHovered: '#37471F',
            bgColorPressed: '#4C6B1F',
            bgColorFocused: '#28311B'
        },
        // Colors below to be removed soon so they do not have bgColorFocused
        NONE: {
            fontColor: '#B6C2CF',
            bgColor: 'inherit',
            bgColorHovered: 'rgba(161, 189, 217, 0.08)',
            bgColorPressed: 'rgba(166, 197, 226, 0.16)'
        },
        BLUE_BOLD: {
            fontColor: '#161A1D',
            bgColor: '#39A0FF',
            bgColorHovered: '#66B5FF',
            bgColorPressed: '#80C1FF'
        }
    }
};
const $7740c3f4ff5782ea$export$9cdea53b8993b139 = {
    light: {
        fontColor: '#091E42',
        bgColor: 'rgba(9, 30, 66, 0.03)'
    },
    dark: {
        fontColor: '#BFDBF847',
        bgColor: 'rgba(3, 4, 4, 0.26)'
    }
};

});
parcelRegister("01Bcy", function(module, exports) {

$parcel$export(module.exports, "messages", () => $004cf38da7543b2c$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $004cf38da7543b2c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    noClassification: {
        id: 'data-classification-level.no-classification',
        defaultMessage: 'No classification',
        description: 'Text for the no classification option'
    },
    classifyContent: {
        id: 'data-classification-level.edit-popup.classify-content',
        defaultMessage: 'Classify content',
        description: 'Text for the header of the edit popup'
    },
    selectClassification: {
        id: 'data-classification-level.edit-popup.select-classification',
        defaultMessage: 'Select classification',
        description: 'Text for the label of the select dropdown to select a classification'
    },
    updateButton: {
        id: 'data-classification-level.edit-popup.update-button',
        defaultMessage: 'Update',
        description: 'Text for the update button'
    },
    cancelButton: {
        id: 'data-classification-level.edit-popup.cancel-button',
        defaultMessage: 'Cancel',
        description: 'Text for the cancel button'
    },
    changeLevel: {
        id: 'data-classification-level.read-popup.change-level',
        defaultMessage: 'Change level',
        description: 'Text for the button that changes the level of the selected classification'
    }
});

});



parcelRegister("gi16t", function(module, exports) {

$parcel$export(module.exports, "ClassificationIcon", () => $bdbf2ee812da5afc$export$d2e14829910b9b7d);

var $eUqFw = parcelRequire("eUqFw");

var $46xZN = parcelRequire("46xZN");
const $bdbf2ee812da5afc$export$d2e14829910b9b7d = ({ color: color, width: width, height: height, isDisabled: isDisabled, disabledColorConfig: disabledColorConfig })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $46xZN.SvgIcon), {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4507 3.24947C11.7778 3.0101 12.2222 3.0101 12.5493 3.24947L12.6384 3.3145C12.6966 3.35693 12.7816 3.41879 12.8885 3.49621C13.1022 3.6511 13.4029 3.8681 13.7503 4.1163C14.4471 4.61402 15.325 5.23208 16.066 5.72614C16.731 6.16948 17.5184 6.51497 18.1606 6.75285C18.4775 6.87022 18.75 6.95808 18.9416 7.01617C19.0373 7.04516 19.1124 7.06659 19.1622 7.08044C19.1871 7.08736 19.2057 7.09238 19.2174 7.09549L19.2296 7.09873L19.231 7.09909C19.6299 7.20149 19.9142 7.55408 19.9294 7.96562L19 7.99995C19.9294 7.96562 19.9294 7.96545 19.9294 7.96562L19.9294 7.96637L19.9296 7.97092L19.9299 7.9823L19.9311 8.02272C19.9321 8.05733 19.9332 8.10704 19.9342 8.17035C19.9362 8.29692 19.9376 8.47816 19.9354 8.70198C19.931 9.14881 19.912 9.76955 19.8537 10.4665C19.7402 11.8241 19.4681 13.609 18.7732 14.9323C18.0039 16.3974 16.3463 17.7569 15.0203 18.6963C14.3347 19.182 13.6935 19.5855 13.2239 19.8675C12.9887 20.0088 12.7955 20.1202 12.66 20.1969C12.5923 20.2353 12.5389 20.265 12.5018 20.2855L12.4586 20.3092L12.4467 20.3157L12.442 20.3182C12.4419 20.3183 12.4413 20.3186 12 19.4999C11.566 20.3224 11.5658 20.3224 11.5657 20.3223L11.5606 20.3196L11.5484 20.3131L11.5044 20.2895C11.4666 20.269 11.4121 20.2393 11.3429 20.201C11.2047 20.1243 11.0075 20.013 10.7676 19.8718C10.2886 19.5899 9.63465 19.1866 8.93632 18.701C7.58714 17.763 5.89843 16.4025 5.12645 14.9323C4.4427 13.6301 4.19878 11.8354 4.10698 10.4745C4.0597 9.77357 4.05069 9.14709 4.05342 8.69567C4.05479 8.46954 4.05911 8.28624 4.06316 8.15821C4.06518 8.09417 4.06714 8.04388 4.06863 8.00888L4.07046 7.96804L4.07102 7.95657L4.07125 7.95199C4.07126 7.95182 4.07129 7.95125 5.00001 7.99995L4.07129 7.95125C4.09257 7.54532 4.37502 7.20025 4.76872 7.09917C4.7687 7.09917 4.76873 7.09916 4.76872 7.09917L4.7704 7.09873L4.78263 7.09549C4.79429 7.09238 4.81288 7.08736 4.83779 7.08044C4.88765 7.06659 4.96271 7.04516 5.05838 7.01617C5.25004 6.95808 5.52252 6.87022 5.8394 6.75285C6.48161 6.51498 7.26895 6.16948 7.93395 5.72614C8.67504 5.23208 9.55289 4.61402 10.2497 4.1163C10.5971 3.8681 10.8978 3.6511 11.1115 3.49621C11.2184 3.41879 11.3034 3.35693 11.3616 3.3145L11.4507 3.24947ZM5.91345 8.69663C5.91343 8.70005 5.91341 8.70348 5.91339 8.70693C5.91086 9.12508 5.91927 9.70457 5.96277 10.3493C6.05251 11.6797 6.28352 13.135 6.77323 14.0676C7.31396 15.0974 8.65034 16.2369 9.99807 17.1739C10.6482 17.6258 11.2607 18.0038 11.7109 18.2687C11.8151 18.33 11.9104 18.3852 11.9951 18.4336C12.0763 18.3862 12.1671 18.3325 12.2662 18.273C12.7071 18.0082 13.3072 17.6304 13.9451 17.1786C15.2657 16.243 16.5831 15.1025 17.1264 14.0676C17.6371 13.0952 17.89 11.63 18.0002 10.3116C18.0534 9.67538 18.0711 9.10545 18.0754 8.69297C17.9096 8.63851 17.7202 8.57322 17.5146 8.49705C16.8069 8.23492 15.8693 7.83042 15.0343 7.27375C14.2679 6.7628 13.3706 6.13086 12.6692 5.62983C12.4167 5.44946 12.1886 5.2854 12 5.14916C11.8114 5.2854 11.5833 5.44946 11.3308 5.62983C10.6294 6.13086 9.73213 6.7628 8.9657 7.27375C8.1307 7.83042 7.19314 8.23492 6.48544 8.49705C6.27515 8.57494 6.08188 8.64144 5.91345 8.69663ZM12 19.4999L11.5657 20.3223C11.8399 20.467 12.1684 20.4657 12.4413 20.3186L12 19.4999Z",
        fill: isDisabled ? disabledColorConfig.fontColor : color
    }));
};

});
parcelRegister("46xZN", function(module, exports) {

$parcel$export(module.exports, "SvgIcon", () => $2fd217d0c9b93693$export$dbcb8210e8a983ed);

var $exJuA = parcelRequire("exJuA");
const $2fd217d0c9b93693$export$dbcb8210e8a983ed = (0, $exJuA.default).svg((props)=>({
        minWidth: `${props.width}px`,
        minHeight: `${props.height}px`
    }));

});


parcelRegister("g4VuS", function(module, exports) {

$parcel$export(module.exports, "ContainerButton", () => $bb499ec96874b399$export$d7dd774c852ad5aa);
$parcel$export(module.exports, "ContainerSpan", () => $bb499ec96874b399$export$bbad7babde89ffdd);
$parcel$export(module.exports, "Name", () => $bb499ec96874b399$export$c7bd411105e2dec3);

var $exJuA = parcelRequire("exJuA");

var $4lTFP = parcelRequire("4lTFP");
const $bb499ec96874b399$export$d7dd774c852ad5aa = (0, $exJuA.default).button((props)=>({
        display: 'inline-flex',
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        width: 'auto',
        alignItems: 'center',
        padding: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        paddingRight: props.isIconOnly ? "var(--ds-space-025, 2px)" : "var(--ds-space-050, 4px)",
        border: 'none',
        borderRadius: "var(--ds-border-radius, 3px)",
        color: props.colorsConfig.fontColor,
        background: props.colorsConfig.bgColor,
        cursor: 'pointer',
        outline: 0,
        transition: 'background 0.1s ease-out 0s',
        '&:focus-visible': {
            outline: `1px solid ${"var(--ds-border-focused, #388BFF)"}`,
            outlineOffset: "var(--ds-space-025, 2px)",
            background: props.isPopupDisabled || props.isIconOnly ? props.colorsConfig.bgColor : props.colorsConfig.bgColorFocused
        },
        '&:hover': {
            background: props.isPopupDisabled || props.isIconOnly ? props.colorsConfig.bgColor : props.colorsConfig.bgColorHovered
        },
        '&:active': {
            background: props.isPopupDisabled || props.isIconOnly ? props.colorsConfig.bgColor : props.colorsConfig.bgColorPressed
        },
        '&:disabled': {
            cursor: 'default',
            color: props.disabledColorConfig.fontColor,
            background: props.disabledColorConfig.bgColor
        }
    }));
const $bb499ec96874b399$export$bbad7babde89ffdd = (0, $exJuA.default).span((props)=>({
        display: 'inline-flex',
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        width: 'auto',
        alignItems: 'center',
        padding: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        paddingRight: props.isIconOnly ? "var(--ds-space-025, 2px)" : "var(--ds-space-050, 4px)",
        borderRadius: "var(--ds-border-radius, 3px)",
        color: props.colorsConfig.fontColor,
        background: props.colorsConfig.bgColor,
        userSelect: 'none',
        '&.disabled': {
            color: props.disabledColorConfig.fontColor,
            background: props.disabledColorConfig.bgColor
        }
    }));
const $bb499ec96874b399$export$c7bd411105e2dec3 = (0, $exJuA.default).span({
    font: `var(--ds-font-body-small, ${(0, $4lTFP.fontFallback).body.small})`,
    fontWeight: "var(--ds-font-weight-medium, 500)",
    marginLeft: "var(--ds-space-025, 2px)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});


parcelRegister("3NVTf", function(module, exports) {

$parcel$export(module.exports, "ClassifyButton", () => $913788f1a9bd0426$export$bc6ac35b41f0edc6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $3MV1G = parcelRequire("3MV1G");

var $gAJuV = parcelRequire("gAJuV");
const $913788f1a9bd0426$export$9b66a4cdcb10e9e7 = {
    fontColor: '#0C66E4',
    bgColor: '#E9F2FF',
    bgColorHovered: '#99C0FF',
    bgColorPressed: '#66A1FF'
};
const $913788f1a9bd0426$export$bc6ac35b41f0edc6 = ({ renderPopupComponent: renderPopupComponent, currentName: currentName })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $eUqFw.useState)(true);
    const handleContainerClicked = ()=>{
        setIsPopupOpen(!isPopupOpen);
    };
    const closePopup = ()=>{
        setIsPopupOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        placement: "bottom-start",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($913788f1a9bd0426$var$ContainerButton, {
                "data-testid": "issue-classification-badge.ui.classify-button.container-button",
                colorValues: $913788f1a9bd0426$export$9b66a4cdcb10e9e7,
                ...triggerProps,
                onClick: ()=>{
                    handleContainerClicked();
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAJuV.ClassificationIcon), {
                width: 14,
                height: 14,
                color: $913788f1a9bd0426$export$9b66a4cdcb10e9e7.fontColor
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($913788f1a9bd0426$var$Name, {
                "data-testid": "issue-classification-badge.ui.classify-button.name"
            }, currentName)),
        content: ()=>renderPopupComponent(closePopup),
        isOpen: isPopupOpen,
        onClose: ()=>{
            closePopup();
        },
        zIndex: 700
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $913788f1a9bd0426$var$ContainerButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { colorValues: colorValues, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1jjw04l": (0, $9t7rW.default)(__cmplp.colorValues.fontColor),
            "--_1gqvxnl": (0, $9t7rW.default)(__cmplp.colorValues.bgColor),
            "--_1w4grj1": (0, $9t7rW.default)(__cmplp.colorValues.bgColorHovered),
            "--_hcgrh3": (0, $9t7rW.default)(__cmplp.colorValues.bgColorPressed)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _p12f1osq _o5721q9c _1bsb1wug _4cvr1h6o _1yt4v77o _u5f31b66 _19itglyw _2rko1sit _syazrxk4 _11q7ds61 _80omtlke _12ji1r31 _1qu2glyw _12y3idpf _v5641ici _1ygbhkgb _1ah3v77o _19lc1hxb _j6xt1fef",
            __cmplp.className
        ])
    });
});
const $913788f1a9bd0426$var$Name = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81vlj _k48p1wq8 _18u0v77o _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gAJuV", function(module, exports) {

$parcel$export(module.exports, "ClassificationIcon", () => $3a409c595b922446$export$d2e14829910b9b7d);
/* classification-icon.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $3a409c595b922446$export$d2e14829910b9b7d = ({ color: color, width: width, height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3a409c595b922446$var$SvgIcon, {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4507 3.24947C11.7778 3.0101 12.2222 3.0101 12.5493 3.24947L12.6384 3.3145C12.6966 3.35693 12.7816 3.41879 12.8885 3.49621C13.1022 3.6511 13.4029 3.8681 13.7503 4.1163C14.4471 4.61402 15.325 5.23208 16.066 5.72614C16.731 6.16948 17.5184 6.51497 18.1606 6.75285C18.4775 6.87022 18.75 6.95808 18.9416 7.01617C19.0373 7.04516 19.1124 7.06659 19.1622 7.08044C19.1871 7.08736 19.2057 7.09238 19.2174 7.09549L19.2296 7.09873L19.231 7.09909C19.6299 7.20149 19.9142 7.55408 19.9294 7.96562L19 7.99995C19.9294 7.96562 19.9294 7.96545 19.9294 7.96562L19.9294 7.96637L19.9296 7.97092L19.9299 7.9823L19.9311 8.02272C19.9321 8.05733 19.9332 8.10704 19.9342 8.17035C19.9362 8.29692 19.9376 8.47816 19.9354 8.70198C19.931 9.14881 19.912 9.76955 19.8537 10.4665C19.7402 11.8241 19.4681 13.609 18.7732 14.9323C18.0039 16.3974 16.3463 17.7569 15.0203 18.6963C14.3347 19.182 13.6935 19.5855 13.2239 19.8675C12.9887 20.0088 12.7955 20.1202 12.66 20.1969C12.5923 20.2353 12.5389 20.265 12.5018 20.2855L12.4586 20.3092L12.4467 20.3157L12.442 20.3182C12.4419 20.3183 12.4413 20.3186 12 19.4999C11.566 20.3224 11.5658 20.3224 11.5657 20.3223L11.5606 20.3196L11.5484 20.3131L11.5044 20.2895C11.4666 20.269 11.4121 20.2393 11.3429 20.201C11.2047 20.1243 11.0075 20.013 10.7676 19.8718C10.2886 19.5899 9.63465 19.1866 8.93632 18.701C7.58714 17.763 5.89843 16.4025 5.12645 14.9323C4.4427 13.6301 4.19878 11.8354 4.10698 10.4745C4.0597 9.77357 4.05069 9.14709 4.05342 8.69567C4.05479 8.46954 4.05911 8.28624 4.06316 8.15821C4.06518 8.09417 4.06714 8.04388 4.06863 8.00888L4.07046 7.96804L4.07102 7.95657L4.07125 7.95199C4.07126 7.95182 4.07129 7.95125 5.00001 7.99995L4.07129 7.95125C4.09257 7.54532 4.37502 7.20025 4.76872 7.09917C4.7687 7.09917 4.76873 7.09916 4.76872 7.09917L4.7704 7.09873L4.78263 7.09549C4.79429 7.09238 4.81288 7.08736 4.83779 7.08044C4.88765 7.06659 4.96271 7.04516 5.05838 7.01617C5.25004 6.95808 5.52252 6.87022 5.8394 6.75285C6.48161 6.51498 7.26895 6.16948 7.93395 5.72614C8.67504 5.23208 9.55289 4.61402 10.2497 4.1163C10.5971 3.8681 10.8978 3.6511 11.1115 3.49621C11.2184 3.41879 11.3034 3.35693 11.3616 3.3145L11.4507 3.24947ZM5.91345 8.69663C5.91343 8.70005 5.91341 8.70348 5.91339 8.70693C5.91086 9.12508 5.91927 9.70457 5.96277 10.3493C6.05251 11.6797 6.28352 13.135 6.77323 14.0676C7.31396 15.0974 8.65034 16.2369 9.99807 17.1739C10.6482 17.6258 11.2607 18.0038 11.7109 18.2687C11.8151 18.33 11.9104 18.3852 11.9951 18.4336C12.0763 18.3862 12.1671 18.3325 12.2662 18.273C12.7071 18.0082 13.3072 17.6304 13.9451 17.1786C15.2657 16.243 16.5831 15.1025 17.1264 14.0676C17.6371 13.0952 17.89 11.63 18.0002 10.3116C18.0534 9.67538 18.0711 9.10545 18.0754 8.69297C17.9096 8.63851 17.7202 8.57322 17.5146 8.49705C16.8069 8.23492 15.8693 7.83042 15.0343 7.27375C14.2679 6.7628 13.3706 6.13086 12.6692 5.62983C12.4167 5.44946 12.1886 5.2854 12 5.14916C11.8114 5.2854 11.5833 5.44946 11.3308 5.62983C10.6294 6.13086 9.73213 6.7628 8.9657 7.27375C8.1307 7.83042 7.19314 8.23492 6.48544 8.49705C6.27515 8.57494 6.08188 8.64144 5.91345 8.69663ZM12 19.4999L11.5657 20.3223C11.8399 20.467 12.1684 20.4657 12.4413 20.3186L12 19.4999Z",
        fill: color
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a409c595b922446$var$SvgIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9dlk8 _1tkedlk8",
            __cmplp.className
        ])
    });
});

});


parcelRegister("gR4Jk", function(module, exports) {

$parcel$export(module.exports, "ClassificationEditViewPopup", () => $b437e3572662e411$export$df1a42b01f6d3dd1);

var $bzGCv = parcelRequire("bzGCv");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $bLGAZ = parcelRequire("bLGAZ");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $bf8oN = parcelRequire("bf8oN");

var $jzSBT = parcelRequire("jzSBT");
const $b437e3572662e411$var$transformClassification = (classification)=>{
    const color = classification?.color?.colorKey || 'NONE';
    // Type '{ id: string; name: string | undefined; color: Color; guideline: string | undefined; }' is not assignable to type 'Pick<{ label?: string | undefined; color?: Color | undefined; includeIcon?: boolean | undefined; classificationOverride?: ClassificationOption<{}> | undefined; } & Classification, "id" | ... 2 more ... | "classificationOverride"> & Required<...> & Partial<...>'.
    // Property 'definition' is missing in type '{ id: string; name: string | undefined; color: Color; guideline: string | undefined; }' but required in type 'Required<Pick<{ label?: string | undefined; color?: Color | undefined; includeIcon?: boolean | undefined; classificationOverride?: ClassificationOption<{}> | undefined; } & Classification, "definition">>'
    // Possible Solutions : Need to fix the type definition in data-classification-level component or pass in definition as a key in the object(this'll mean modifying the graphQL types as well i.e. ClassificationEditViewPopupData)
    // @ts-expect-error TS2322: Type '{ id: string; name: string | undefined; color: Color; guideline: string | undefined; }' is not assignable to type 'ClassificationOption<{}>'.
    return {
        id: classification?.id,
        name: classification?.name || undefined,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: color,
        definition: ((0, $1ybV0.ff)('dlp-field-selected-value-and-definition-changes_4jiut') ? classification?.definition : classification?.guidelines) || undefined
    };
};
const $b437e3572662e411$var$transformAGGtoSelectOption = (classificationLevels, defaultClassificationLevel, // @ts-expect-error TS7006: Parameter 'formatMessage' implicitly has an 'any' type.
formatMessage)=>{
    const classificationValues = classificationLevels?.edges?.map((edge)=>edge?.node ?? null).filter(Boolean).filter((classification)=>classification && classification.name != null) || [];
    const classificationOptions = classificationValues.map((classification)=>({
            id: classification.id,
            name: classification.name || '',
            definition: ((0, $1ybV0.ff)('dlp-field-selected-value-and-definition-changes_4jiut') ? classification.definition : classification.guidelines) || undefined,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            color: classification.color?.colorKey || 'NONE'
        }));
    if (defaultClassificationLevel) // Project Default Classification option
    classificationOptions.push((0, $jzSBT.getProjectDefaultClassificationOption)(formatMessage((0, $bf8oN.messages).projectDefaultClassficationName), defaultClassificationLevel));
    else // No Classification option
    classificationOptions.push({
        id: undefined,
        definition: formatMessage((0, $bf8oN.messages).noClassificationGuideline),
        color: 'NONE',
        includeIcon: false
    });
    return classificationOptions;
};
const $b437e3572662e411$export$df1a42b01f6d3dd1 = ({ onEditCancel: onEditCancel, onEditSubmit: onEditSubmit, editViewPopupFragment: editViewPopupFragment, customHeading: customHeading })=>{
    const { classificationLevel: classificationLevel, classificationLevels: classificationLevels, defaultClassificationLevel: defaultClassificationLevel, classificationLevelSource: classificationLevelSource } = (0, $iWLL0.useFragment)((0, $bzGCv.default), editViewPopupFragment);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [showUpdateSpinner, setShowUpdateSpinner] = (0, $eUqFw.useState)(false);
    const classificationOptions = $b437e3572662e411$var$transformAGGtoSelectOption(classificationLevels, defaultClassificationLevel, formatMessage);
    const currentClassificationLevel = classificationLevel && $b437e3572662e411$var$transformClassification(classificationLevel);
    const noClassificationAsClassificationOption = {
        name: formatMessage((0, $bf8oN.messages).noClassificationGuideline),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: 'NONE',
        includeIcon: false
    };
    const getSelectedClassification = ()=>{
        if ((0, $1ybV0.ff)('dlp-field-selected-value-and-definition-changes_4jiut') && classificationLevelSource === 'PROJECT') return classificationOptions.slice(-1)[0] || [];
        return currentClassificationLevel;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$9d2de6eebf7462b5),
        sourceName: "classificationEditViewPopup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLGAZ.EditPopup), {
        customHeading: customHeading,
        options: classificationOptions,
        selectedOption: getSelectedClassification() || noClassificationAsClassificationOption,
        onEditCancel: onEditCancel,
        onEditSubmit: (classificationNew)=>{
            setShowUpdateSpinner(true);
            onEditSubmit(classificationNew, setShowUpdateSpinner);
        },
        loading: showUpdateSpinner
    }));
};

});
parcelRegister("bzGCv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab676f315d17a0f2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<77260cf90caa6b53a2f6396d206818f8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ab676f315d17a0f2$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraColor",
            "kind": "LinkedField",
            "name": "color",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorKey"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "guidelines"
        },
        {
            "kind": "ScalarField",
            "name": "definition"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "editViewPopup_issueClassificationBadge_ClassificationEditViewPopup",
        "selections": [
            {
                "concreteType": "JiraClassificationLevel",
                "kind": "LinkedField",
                "name": "classificationLevel",
                "plural": false,
                "selections": v0 /*: any*/ 
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filterByCriteria",
                        "value": {
                            "filterByStatus": [
                                "PUBLISHED"
                            ],
                            "filterByType": [
                                "USER"
                            ]
                        }
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 10
                    }
                ],
                "concreteType": "JiraClassificationLevelConnection",
                "kind": "LinkedField",
                "name": "classificationLevels",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraClassificationLevelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraClassificationLevel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "classificationLevels(filterByCriteria:{\"filterByStatus\":[\"PUBLISHED\"],\"filterByType\":[\"USER\"]},first:10)"
            },
            {
                "kind": "ScalarField",
                "name": "classificationLevelSource"
            },
            {
                "concreteType": "JiraClassificationLevel",
                "kind": "LinkedField",
                "name": "defaultClassificationLevel",
                "plural": false,
                "selections": v0 /*: any*/ 
            }
        ],
        "type": "JiraDataClassificationField"
    };
}();
$ab676f315d17a0f2$var$node.hash = "f3b93a96919d3915c666eafa9904b132";
var $ab676f315d17a0f2$export$2e2bcd8739ae039 = $ab676f315d17a0f2$var$node;

});

parcelRegister("bLGAZ", function(module, exports) {

$parcel$export(module.exports, "EditPopup", () => $89152014a0aa383f$export$646a7c8e1b78fd89);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6zOB7 = parcelRequire("6zOB7");

var $hI5oG = parcelRequire("hI5oG");

var $hSQOv = parcelRequire("hSQOv");
var $1v4bv = parcelRequire("1v4bv");
var $aChL5 = parcelRequire("aChL5");
var $caLW4 = parcelRequire("caLW4");

var $2hZCh = parcelRequire("2hZCh");

var $01Bcy = parcelRequire("01Bcy");
const $89152014a0aa383f$var$popupContainerStyles = (0, $caLW4.xcss)({
    width: '330px',
    padding: 'space.250'
});
const $89152014a0aa383f$export$646a7c8e1b78fd89 = ({ options: options, selectedOption: selectedOption, customHeading: customHeading, loading: loading = false, errorMessage: errorMessage, onEditCancel: onEditCancel, onEditSubmit: onEditSubmit, onChange: onChange })=>{
    const intl = (0, $5JgJ2.default)();
    // This keeps track of the selected classification in the dropdown. selectedOption is the classification that was selected before the edit popup was opened.
    const [selectedClassification, setSelectedClassification] = (0, $eUqFw.useState)(selectedOption);
    const onDropdownChange = (selected)=>{
        setSelectedClassification(selected);
    };
    const onUpdateClick = ()=>{
        selectedClassification && onEditSubmit && onEditSubmit(selectedClassification);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), {
        xcss: $89152014a0aa383f$var$popupContainerStyles,
        role: "dialog",
        "aria-labelledby": "data-classification-edit-content-label",
        "aria-modal": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aChL5.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h500",
        id: "data-classification-edit-content-label"
    }, customHeading || intl.formatMessage((0, $01Bcy.messages).classifyContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2hZCh.DataClassificationDropdown), {
        label: intl.formatMessage((0, $01Bcy.messages).selectClassification),
        options: options,
        value: selectedClassification,
        onChange: onDropdownChange,
        onInputChange: onChange,
        errorMessage: errorMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1v4bv.default), {
        justifyContent: "end",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        onClick: onEditCancel,
        appearance: "subtle"
    }, intl.formatMessage((0, $01Bcy.messages).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        isLoading: loading,
        onClick: onUpdateClick,
        appearance: "primary",
        isDisabled: !selectedClassification || Boolean(errorMessage)
    }, intl.formatMessage((0, $01Bcy.messages).updateButton)))));
};

});
parcelRegister("aChL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bab3a75ffa7de2e$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/styles/no-exported-styles */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caLW4 = parcelRequire("caLW4");

var $1v4bv = parcelRequire("1v4bv");
const $7bab3a75ffa7de2e$var$flexGrowMap = {
    hug: (0, $caLW4.xcss)({
        flexGrow: 0
    }),
    fill: (0, $caLW4.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $7bab3a75ffa7de2e$var$Stack = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $7bab3a75ffa7de2e$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return (0, $byn9U.jsx)((0, $1v4bv.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$7bab3a75ffa7de2e$var$Stack.displayName = 'Stack';
var $7bab3a75ffa7de2e$export$2e2bcd8739ae039 = $7bab3a75ffa7de2e$var$Stack;

});

parcelRegister("2hZCh", function(module, exports) {

$parcel$export(module.exports, "ClassificationLozenge", () => $1aacf709cd0cb4e3$export$f31d135f91971ac4);
$parcel$export(module.exports, "DataClassificationDropdown", () => $1aacf709cd0cb4e3$export$37a6278f2f470b5e);

var $eUqFw = parcelRequire("eUqFw");

var $kd0cS = parcelRequire("kd0cS");

var $hTLlD = parcelRequire("hTLlD");

var $96IgR = parcelRequire("96IgR");

var $1v4bv = parcelRequire("1v4bv");
var $aChL5 = parcelRequire("aChL5");
var $9mScz = parcelRequire("9mScz");
var $caLW4 = parcelRequire("caLW4");

var $jQxSL = parcelRequire("jQxSL");
var $4zgIJ = parcelRequire("4zgIJ");

var $4q38b = parcelRequire("4q38b");

var $8cU5f = parcelRequire("8cU5f");

var $aeMpE = parcelRequire("aeMpE");

var $gi16t = parcelRequire("gi16t");

var $26qwu = parcelRequire("26qwu");
/**
 * The options in the select dropdown are quite customizable, and achieves different use-cases.
 * Options are identified (i.e. how an option in the dropdown is selected) by the "name", "label", and "definition" properties.
 * Typeof "option" prop is "ClassificationOption", which has requires at least one of the properties to exist, therefore it is safe to assume that an option will always be identifiable.
 * Obviously there can be duplicates, but that is a user error.
 *
 * Since only one of these identifying properties is required, there are 7 different combinations of these properties that will render a different option.
 *
 * (1) name
 *    - renders: name with icon (if includeIcon is true) in the icon container
 * (2) name, label
 *    - renders: name with icon (if includeIcon is true) in the icon container, and an inline label outside of the icon container
 * (3) name, definition
 *    - renders: name with icon (if includeIcon is true) in the icon container, and a definition below the icon container
 * (4) name, label, definition
 *    - renders: name with icon (if includeIcon is true) in the icon container, an inline label outside of the icon container, and a definition below the icon container
 * (5) label
 *    - renders: icon container with only an icon, and an inline label outside of the icon container
 *    - note: if includeIcon is false, then the icon container will not render (i.e. only an inline label will render)
 * (6) label, definition
 *    - renders: similar to (5) but with a definition below the icon container
 * (7) definition
 *    - renders: icon container with only an icon (conditionally rendered based on includeIcon), and a definition below the icon container
 *
 * Use cases:
 *    For space/project defaults we don't want to render a name.
 *    Instead we want to render a label: "Use space/project default".
 *    We also want to render a definition defining what the space/project default is.
 *    In this case, we'll use (6).
 *
 *    For resetting a classification (i.e. selecting the "No classification" option), we don't want to render a name or label.
 *    Instead we want to render only a definition and without an icon.
 *    In this case, we'll use (7) and pass in includeIcon={false}.
 */ const $1aacf709cd0cb4e3$var$dangerTextStyles = (0, $caLW4.xcss)({
    color: 'color.text.danger'
});
const $1aacf709cd0cb4e3$var$CustomSingleValue = ({ children: children, ...props })=>{
    var _ref, _ref2, _classificationOverri;
    const { colorMode: colorMode = 'light' } = (0, $4q38b.default)();
    const { data: data } = props;
    const { name: name, nameLabel: nameLabel, definition: definition, color: color = 'NONE', includeIcon: includeIcon = true, classificationOverride: classificationOverride, nameFormatter: nameFormatter } = data || {};
    const inputName = (_ref = (_ref2 = (_classificationOverri = classificationOverride === null || classificationOverride === void 0 ? void 0 : classificationOverride.name) !== null && _classificationOverri !== void 0 ? _classificationOverri : name) !== null && _ref2 !== void 0 ? _ref2 : nameLabel) !== null && _ref !== void 0 ? _ref : definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.ContainerLabel), null, nameFormatter ? nameFormatter(data) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.ContainerIcon), {
        colorsConfig: (0, $aeMpE.colorsConfig)[colorMode][color],
        isIconOnly: includeIcon && !inputName
    }, includeIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gi16t.ClassificationIcon), {
        width: 14,
        height: 14,
        isDisabled: false,
        color: (0, $aeMpE.colorsConfig)[colorMode][color].fontColor,
        disabledColorConfig: (0, $aeMpE.disabledColorConfig)[colorMode]
    }), inputName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.Name), null, inputName))));
};
/**
 * CustomOption component is used to render each option in the dropdown.
 **/ const $1aacf709cd0cb4e3$var$CustomOption = (props)=>{
    const { data: data } = props;
    const { name: name, definition: definition, nameLabel: nameLabel, includeIcon: includeIcon = true, nameFormatter: nameFormatter } = data || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aChL5.default), {
        space: "space.050"
    }, (name || nameLabel || includeIcon) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.ContainerLabel), {
        definitionExists: Boolean(definition)
    }, nameFormatter ? nameFormatter(data) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1aacf709cd0cb4e3$export$f31d135f91971ac4, data), nameLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.NameLabel), null, nameLabel)), definition && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.Definition), null, definition)));
};
const $1aacf709cd0cb4e3$export$f31d135f91971ac4 = (data)=>{
    const { colorMode: colorMode = 'light' } = (0, $4q38b.default)();
    const { name: name, nameLabel: nameLabel, includeIcon: includeIcon = true, color: color = 'NONE' } = data || {};
    // if name and label are both present, trim name to fit nameLabel in the same row
    const shouldTrimBothNameAndLabel = Boolean(name && nameLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.ContainerIcon), {
        colorsConfig: (0, $aeMpE.colorsConfig)[colorMode][color],
        isIconOnly: includeIcon && !name
    }, includeIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gi16t.ClassificationIcon), {
        width: 14,
        height: 14,
        isDisabled: false,
        color: (0, $aeMpE.colorsConfig)[colorMode][color].fontColor,
        disabledColorConfig: (0, $aeMpE.disabledColorConfig)[colorMode]
    }), name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.Name), null, name.substring(0, (0, $aeMpE.nameMaxLength) / (shouldTrimBothNameAndLabel ? 2 : 1))));
};
const $1aacf709cd0cb4e3$export$37a6278f2f470b5e = ({ label: label, options: options, value: value, errorMessage: errorMessage, disabledTooltipMessage: disabledTooltipMessage, isDisabled: isDisabled, onChange: onChange, onInputChange: onInputChange })=>{
    // find selected classification in options
    const onSelectChange = (option)=>{
        // we want to identify the selected option by these properties
        const selectedOption = {
            name: option === null || option === void 0 ? void 0 : option.name,
            definition: option === null || option === void 0 ? void 0 : option.definition,
            label: option === null || option === void 0 ? void 0 : option.nameLabel
        };
        // find corresponding classification in options based on identifying properties
        const selectedClassification = options.find((opt)=>(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))({
                name: opt.name,
                definition: opt.definition,
                label: opt.label
            }, selectedOption));
        if (!selectedOption || !selectedClassification) return;
        if (onChange) onChange(selectedClassification);
    };
    /*
    Since select component requires label & value props in list of options, we'll transform "options" prop to include these values.
  */ const transformToOptionType = (0, $eUqFw.useCallback)((classification)=>{
        var _ref3, _classification$name, _ref4, _ref5;
        return {
            ...(0, (/*@__PURE__*/$parcel$interopDefault($kd0cS)))(classification),
            // either name, label, or definition must exist, so we can safely use ! here
            label: (_ref3 = (_classification$name = classification.name) !== null && _classification$name !== void 0 ? _classification$name : classification.label) !== null && _ref3 !== void 0 ? _ref3 : classification.definition,
            // Asserting this as a string to keep lint happy. This wont be an issue, since CustomOption component will handle scenarios where name is a ReactNode.
            value: (_ref4 = (_ref5 = classification.name) !== null && _ref5 !== void 0 ? _ref5 : classification.label) !== null && _ref4 !== void 0 ? _ref4 : classification.definition,
            nameLabel: classification.label // since label is reserved for an option, we'll use nameLabel
        };
    }, []);
    const transformedOptions = (0, $eUqFw.useMemo)(()=>options.map(transformToOptionType), [
        options,
        transformToOptionType
    ]);
    const renderDropdown = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), {
            "aria-label": "data-classification-select",
            inputId: "data-classification-dropdown-input",
            options: transformedOptions,
            value: !value || errorMessage ? null : transformToOptionType(value),
            onChange: onSelectChange,
            onInputChange: onInputChange,
            isInvalid: Boolean(errorMessage),
            isDisabled: isDisabled,
            components: {
                Option: $1aacf709cd0cb4e3$var$CustomOption,
                SingleValue: $1aacf709cd0cb4e3$var$CustomSingleValue
            },
            styles: {
                option: (baseStyles)=>({
                        ...baseStyles,
                        padding: "var(--ds-space-200, 16px)"
                    }),
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999
                    })
            },
            menuPortalTarget: document.body
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aChL5.default), {
        space: "space.100"
    }, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.DropdownLabel), {
        htmlFor: "data-classification-dropdown-input"
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aChL5.default), {
        space: "space.050"
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: disabledTooltipMessage
    }, renderDropdown()) : renderDropdown(), errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1v4bv.default), {
        alignItems: "center",
        gap: "space.025",
        xcss: $1aacf709cd0cb4e3$var$dangerTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9mScz.default), {
        as: "p",
        size: "small",
        color: "inherit"
    }, errorMessage))));
};

});
parcelRegister("9mScz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d20367bdf32f3bc$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8ynlC = parcelRequire("8ynlC");

var $fsr0b = parcelRequire("fsr0b");

var $6VlmD = parcelRequire("6VlmD");
const $6d20367bdf32f3bc$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $6d20367bdf32f3bc$var$resetStyles = (0, $byn9U.css)({
    margin: 0
});
const $6d20367bdf32f3bc$var$strongStyles = (0, $byn9U.css)({
    fontWeight: 'bold'
});
const $6d20367bdf32f3bc$var$emStyles = (0, $byn9U.css)({
    fontStyle: 'italic'
});
const $6d20367bdf32f3bc$var$textAlignMap = {
    center: (0, $byn9U.css)({
        textAlign: 'center'
    }),
    end: (0, $byn9U.css)({
        textAlign: 'end'
    }),
    start: (0, $byn9U.css)({
        textAlign: 'start'
    })
};
const $6d20367bdf32f3bc$var$truncationStyles = (0, $byn9U.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
const $6d20367bdf32f3bc$var$wordBreakMap = {
    breakAll: (0, $byn9U.css)({
        wordBreak: 'break-all'
    })
};
const $6d20367bdf32f3bc$var$HasTextAncestorContext = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const $6d20367bdf32f3bc$var$useHasTextAncestor = ()=>(0, $eUqFw.useContext)($6d20367bdf32f3bc$var$HasTextAncestorContext);
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $6d20367bdf32f3bc$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $6VlmD.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $fsr0b.inverseColorMap).hasOwnProperty(surface)) return (0, $fsr0b.inverseColorMap)[surface];
    if (colorProp === 'inherit') return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $6d20367bdf32f3bc$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size = 'medium', weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $8ynlC.default)($6d20367bdf32f3bc$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = $6d20367bdf32f3bc$var$useHasTextAncestor();
    const color = $6d20367bdf32f3bc$var$useColor(colorProp, hasTextAncestor);
    const component = (0, $byn9U.jsx)(Component, {
        ref: ref,
        css: [
            $6d20367bdf32f3bc$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $fsr0b.fontStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $fsr0b.textColorStylesMap)[color],
            maxLines && $6d20367bdf32f3bc$var$truncationStyles,
            maxLines === 1 && $6d20367bdf32f3bc$var$wordBreakMap.breakAll,
            align && $6d20367bdf32f3bc$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $fsr0b.fontWeightStylesMap)[weight],
            Component === 'em' && $6d20367bdf32f3bc$var$emStyles,
            Component === 'strong' && $6d20367bdf32f3bc$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $byn9U.jsx)($6d20367bdf32f3bc$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
});
var $6d20367bdf32f3bc$export$2e2bcd8739ae039 = $6d20367bdf32f3bc$var$Text;

});

parcelRegister("26qwu", function(module, exports) {

$parcel$export(module.exports, "DropdownLabel", () => $1880b73576d79ff1$export$bef68440ec6a6159);
$parcel$export(module.exports, "NameLabel", () => $1880b73576d79ff1$export$63077572f44eb437);
$parcel$export(module.exports, "ContainerLabel", () => $1880b73576d79ff1$export$3944a9dffaf20407);
$parcel$export(module.exports, "ContainerIcon", () => $1880b73576d79ff1$export$6d6da6edaddd5876);
$parcel$export(module.exports, "Name", () => $1880b73576d79ff1$export$c7bd411105e2dec3);
$parcel$export(module.exports, "Definition", () => $1880b73576d79ff1$export$cf0290ef4b5a4f61);

var $exJuA = parcelRequire("exJuA");

var $4lTFP = parcelRequire("4lTFP");
const $1880b73576d79ff1$export$bef68440ec6a6159 = (0, $exJuA.default).label({
    font: `var(--ds-font-body, ${(0, $4lTFP.fontFallback).body.medium})`,
    fontWeight: "var(--ds-font-weight-semibold, 600)"
});
const $1880b73576d79ff1$export$63077572f44eb437 = (0, $exJuA.default).span({
    marginLeft: "var(--ds-space-100, 8px)",
    color: "var(--ds-text-subtle, inherit)",
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $1880b73576d79ff1$export$3944a9dffaf20407 = (0, $exJuA.default).div((props)=>({
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        marginBottom: props.definitionExists ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)"
    }));
const $1880b73576d79ff1$export$6d6da6edaddd5876 = (0, $exJuA.default).span((props)=>({
        display: 'inline-flex',
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        width: 'auto',
        alignItems: 'center',
        padding: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        paddingRight: props.isIconOnly ? "var(--ds-space-025, 2px)" : "var(--ds-space-050, 4px)",
        borderRadius: "var(--ds-border-radius, 3px)",
        color: props.colorsConfig.fontColor,
        background: props.colorsConfig.bgColor,
        userSelect: 'none'
    }));
const $1880b73576d79ff1$export$c7bd411105e2dec3 = (0, $exJuA.default).span({
    display: 'flex',
    alignItems: 'center',
    font: `${`var(--ds-font-body-small, ${(0, $4lTFP.fontFallback).body.small})`}, font-weight: ${"var(--ds-font-weight-medium, 500)"}`,
    lineHeight: '14px',
    marginLeft: "var(--ds-space-025, 2px)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $1880b73576d79ff1$export$cf0290ef4b5a4f61 = (0, $exJuA.default).div({
    color: "var(--ds-text-subtle, inherit)",
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    wordWrap: 'break-word'
});

});



parcelRegister("bf8oN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ca5a3c5913706edd$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ca5a3c5913706edd$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    projectDefaultClassficationName: {
        "id": "issue-classification-badge.edit-view-popup.project-default-classfication-name",
        "defaultMessage": "Project default"
    },
    projectDefaultClassficationGuideline: {
        "id": "issue-classification-badge.edit-view-popup.project-default-classfication-guideline",
        "defaultMessage": "The default level is {name}"
    },
    noClassificationGuideline: {
        "id": "issue-classification-badge.edit-view-popup.no-classification-guideline",
        "defaultMessage": "Project default - No classification"
    }
});

});

parcelRegister("jzSBT", function(module, exports) {

$parcel$export(module.exports, "getProjectDefaultClassificationOption", () => $9e09f90100171cc0$export$1f0ddb93897fde19);
/* utils.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2hZCh = parcelRequire("2hZCh");
const $9e09f90100171cc0$export$d890d332bbf5844a = (classifications)=>classifications ? {
        edges: classifications.map((classification)=>({
                node: {
                    id: classification.id,
                    name: classification.name,
                    definition: classification.definition,
                    guidelines: classification.guideline,
                    color: {
                        colorKey: classification.color
                    }
                }
            }))
    } : classifications;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9e09f90100171cc0$var$OverflowWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $9e09f90100171cc0$var$ProjectDefaultTextWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _154i1i6y",
            __cmplp.className
        ])
    });
});
const $9e09f90100171cc0$export$1f0ddb93897fde19 = (message, defaultClassificationLevel)=>{
    const color = typeof defaultClassificationLevel?.color === 'string' ? defaultClassificationLevel?.color : defaultClassificationLevel?.color?.colorKey;
    return {
        id: undefined,
        nameFormatter: (classification)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e09f90100171cc0$var$OverflowWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e09f90100171cc0$var$ProjectDefaultTextWrapper, null, message, " - "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2hZCh.ClassificationLozenge), {
                ...classification,
                name: defaultClassificationLevel?.name || ''
            })),
        // The below lint error is because Color type expects string, whereas the graphQL type expects { colorKey: string }. This has been handled in variable definition for color.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: color || 'NONE',
        definition: ''
    };
};

});


parcelRegister("bvfyh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $433c98e82ae0daf6$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $433c98e82ae0daf6$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    classificationLevel: {
        "id": "issue-classification-badge.classification-level",
        "defaultMessage": "This issue is classified as {name}"
    },
    sucessFlagTitle: {
        "id": "issue-classification-badge.sucess-flag-title",
        "defaultMessage": "Classification level updated"
    },
    successFlagDescription: {
        "id": "issue-classification-badge.success-flag-description",
        "defaultMessage": "The issue {issueKey} is classified as \"{name}\""
    },
    errorFlagTitle: {
        "id": "issue-classification-badge.error-flag-title",
        "defaultMessage": "We couldn't update the classification level"
    },
    errorFlagDescription: {
        "id": "issue-classification-badge.error-flag-description",
        "defaultMessage": "Check your connection and try again."
    },
    noClassficationName: {
        "id": "issue-classification-badge.no-classfication-name",
        "defaultMessage": "Classification level removed"
    },
    noClassficationDescription: {
        "id": "issue-classification-badge.no-classfication-description",
        "defaultMessage": "The issue {issueKey} doesn't have a classification level anymore."
    },
    classifyIssue: {
        "id": "issue-classification-badge.classify-issue",
        "defaultMessage": "Classify issue"
    },
    classifyRequest: {
        "id": "issue-classification-badge.classify-request",
        "defaultMessage": "Classify request"
    },
    couldNotLoadClassificationLevel: {
        "id": "issue-classification-badge.could-not-load-classification-level",
        "defaultMessage": "We couldn't load the classification level."
    },
    cannotClassifyIssueTitle: {
        "id": "issue-classification-badge.cannot-classify-issue-title",
        "defaultMessage": "We can't classify the issue right now"
    },
    cannotClassifyIssueDescription: {
        "id": "issue-classification-badge.cannot-classify-issue-description",
        "defaultMessage": "Check your connection and try again."
    },
    refresh: {
        "id": "issue-classification-badge.refresh",
        "defaultMessage": "Refresh"
    }
});

});

parcelRegister("j7atw", function(module, exports) {

$parcel$export(module.exports, "ClassificationReadViewPopup", () => $406a58d04838990f$export$bcf74afee407166f);

var $eUqFw = parcelRequire("eUqFw");

var $ddwvM = parcelRequire("ddwvM");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4F9cx = parcelRequire("4F9cx");
const $406a58d04838990f$export$bcf74afee407166f = ({ name: name, guideline: guideline, onChangeLevelClick: onChangeLevelClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ddwvM.ReadPopup), {
        name: name,
        guideline: guideline || formatMessage((0, $4F9cx.messages).noGuidelines),
        onChangeLevelClick: onChangeLevelClick
    });
};

});
parcelRegister("ddwvM", function(module, exports) {

$parcel$export(module.exports, "ReadPopup", () => $99f5b56855c9f3ad$export$6d6315f08f93adaa);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7u4fN = parcelRequire("7u4fN");

var $hSQOv = parcelRequire("hSQOv");
var $1v4bv = parcelRequire("1v4bv");
var $caLW4 = parcelRequire("caLW4");

var $ir7hA = parcelRequire("ir7hA");

var $01Bcy = parcelRequire("01Bcy");
const $99f5b56855c9f3ad$var$containerStyles = (0, $caLW4.xcss)({
    width: '330px'
});
const $99f5b56855c9f3ad$export$6d6315f08f93adaa = ({ name: name, guideline: guideline, guidelineRepresentation: guidelineRepresentation = 'PLAIN', onChangeLevelClick: onChangeLevelClick })=>{
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), {
        padding: "space.250",
        xcss: $99f5b56855c9f3ad$var$containerStyles,
        role: "dialog",
        "aria-labelledby": "data-classification-read-content-name",
        "aria-describedby": "data-classification-read-content-guideline",
        "aria-modal": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ir7hA.ClassificationView), {
        name: name,
        guideline: guideline,
        guidelineRepresentation: guidelineRepresentation
    }), Boolean(onChangeLevelClick) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), {
        paddingBlockStart: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1v4bv.default), {
        justifyContent: "end",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onChangeLevelClick
    }, intl.formatMessage((0, $01Bcy.messages).changeLevel)))));
};

});

parcelRegister("4F9cx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dbe0a389879ea210$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $dbe0a389879ea210$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    noGuidelines: {
        "id": "issue-classification-badge.read-view-popup.no-guidelines",
        "defaultMessage": "No guidelines"
    }
});

});




parcelRegister("kln9T", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac711c76f10b01f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $giAhk = parcelRequire("giAhk");

var $0NycV = parcelRequire("0NycV");

var $5G3JL = parcelRequire("5G3JL");

var $3uwfp = parcelRequire("3uwfp");

var $lqalZ = parcelRequire("lqalZ");

var $fokFV = parcelRequire("fokFV");

var $lO4Or = parcelRequire("lO4Or");

var $kJBJf = parcelRequire("kJBJf");

var $3yikB = parcelRequire("3yikB");

var $fYUxn = parcelRequire("fYUxn");
const $ac711c76f10b01f7$var$getFieldOptions = ()=>{
    const fieldOptions = {
        shouldDiscardChangeOnFailure: true,
        onSaveFailureFlagType: (0, $0NycV.EDIT_ISSUE_COLOUR_ERROR)
    };
    return {
        saveField: $3yikB.saveField,
        ...fieldOptions
    };
};
const $ac711c76f10b01f7$var$mapStateToConfig = (state, props)=>{
    const field = (0, $fokFV.fieldSelector)(props.fieldId)(state);
    const isClassicColor = field ? field.schema.custom === (0, $lO4Or.EPIC_COLOR_TYPE) : false;
    return {
        ...$ac711c76f10b01f7$var$getFieldOptions(),
        fieldId: props.fieldId,
        transformFromStateValue: (colorStr)=>(0, $kJBJf.transformFromStateValueClassicSupport)(colorStr, isClassicColor),
        transformToStateValue: (colorStr)=>(0, $kJBJf.transformToStateValueClassicSupport)(colorStr, isClassicColor)
    };
};
const $ac711c76f10b01f7$var$ColorPickerFieldClassicSupport = (0, $5G3JL.flowWithSafeComponent)((0, $giAhk.injectIntlV2), (0, $3uwfp.default)((state, props)=>$ac711c76f10b01f7$var$mapStateToConfig(state, props)))((0, $fYUxn.default));
const $ac711c76f10b01f7$var$MaybeColorPicker = (props)=>{
    /**
   * Epic Color was historically used to hold the color value of the Epic issue type and
   * is still used in Server. This has been migrated to the Issue Color field value and
   * should theoretically have been copied over in the case of Server to Cloud migrations.
   * This logging allows us to discover if there are any issues that contain an Epic Color field value
   * but not an Issue Color field value, which shouldn't happen.
   *  */ if (props.epicColorField && !props.issueColorField) (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.color-picker', 'Issue with epic color but no issue color is being rendered');
    if (props.field) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac711c76f10b01f7$var$ColorPickerFieldClassicSupport, {
        fieldId: props.field.key
    });
    return null;
};
const $ac711c76f10b01f7$var$mapStateToProps = (state)=>({
        field: (0, $kJBJf.colorFieldSelector)(state),
        epicColorField: (0, $kJBJf.epicColorFieldSelector)(state),
        issueColorField: (0, $kJBJf.issueColorFieldSelector)(state)
    });
var $ac711c76f10b01f7$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)($ac711c76f10b01f7$var$mapStateToProps, {}))($ac711c76f10b01f7$var$MaybeColorPicker);

});
parcelRegister("kJBJf", function(module, exports) {

$parcel$export(module.exports, "colorFieldSelector", () => $d3c8cf2a218b9c28$export$28c485ef69e7ea98);
$parcel$export(module.exports, "issueColorFieldSelector", () => $d3c8cf2a218b9c28$export$af8c5bf2ce400052);
$parcel$export(module.exports, "epicColorFieldSelector", () => $d3c8cf2a218b9c28$export$12afc5be9c906619);
$parcel$export(module.exports, "transformFromStateValueClassicSupport", () => $d3c8cf2a218b9c28$export$b6483780e5c88c23);
$parcel$export(module.exports, "transformToStateValueClassicSupport", () => $d3c8cf2a218b9c28$export$2f5aaf187eec2fb7);

var $df4Sl = parcelRequire("df4Sl");

var $lPQPn = parcelRequire("lPQPn");

var $fokFV = parcelRequire("fokFV");

var $ke6cX = parcelRequire("ke6cX");

var $lO4Or = parcelRequire("lO4Or");
const $d3c8cf2a218b9c28$var$currentIssueTypeIdSelector = (0, $df4Sl.createSelector)((0, $fokFV.fieldSelector)((0, $lO4Or.ISSUE_TYPE)), (issueTypeField)=>issueTypeField && issueTypeField.value.id);
const $d3c8cf2a218b9c28$export$1d67dd3d1b76d3fb = (0, $df4Sl.createSelector)((0, $fokFV.fieldByCustomTypeSelector)((0, $lO4Or.COLOR_CF_TYPE)), (0, $fokFV.fieldByCustomTypeSelector)((0, $lO4Or.EPIC_COLOR_TYPE)), (colorField, classicColorField)=>colorField && colorField.key || classicColorField && classicColorField.key);
const $d3c8cf2a218b9c28$export$28c485ef69e7ea98 = (0, $df4Sl.createSelector)((0, $fokFV.fieldByCustomTypeSelector)((0, $lO4Or.COLOR_CF_TYPE)), (issueColorField)=>issueColorField);
const $d3c8cf2a218b9c28$export$af8c5bf2ce400052 = (0, $df4Sl.createSelector)((0, $fokFV.fieldByCustomTypeSelector)((0, $lO4Or.COLOR_CF_TYPE)), (issueColorField)=>issueColorField);
const $d3c8cf2a218b9c28$export$12afc5be9c906619 = (0, $df4Sl.createSelector)((0, $fokFV.fieldByCustomTypeSelector)((0, $lO4Or.EPIC_COLOR_TYPE)), (epicColorField)=>epicColorField);
const $d3c8cf2a218b9c28$export$9a3a0719e6a6890 = (0, $df4Sl.createSelector)($d3c8cf2a218b9c28$var$currentIssueTypeIdSelector, $d3c8cf2a218b9c28$export$1d67dd3d1b76d3fb, (0, $ke6cX.issueTypesSelector), (currentIssueTypeId, colorFieldId, allIssueTypes)=>{
    if (!allIssueTypes) return false;
    const currentIssueType = allIssueTypes.find((issueType)=>issueType.id === currentIssueTypeId);
    if (!currentIssueType || !currentIssueType.fields) return false;
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    return colorFieldId in currentIssueType.fields;
});
const $d3c8cf2a218b9c28$export$b6483780e5c88c23 = (colorStr, isClassicColor = false)=>isClassicColor ? (0, $lPQPn.getValueFromColor)((0, $lPQPn.classicToFrontendColor)(colorStr)) : (0, $lPQPn.getValueFromColor)((0, $lPQPn.toFrontendColor)(colorStr));
const $d3c8cf2a218b9c28$export$2f5aaf187eec2fb7 = (value, isClassicColor = false)=>isClassicColor ? (0, $lPQPn.classicToBackendColor)((0, $lPQPn.getColorFromValue)(value)) : (0, $lPQPn.toBackendColor)((0, $lPQPn.getColorFromValue)(value));
const $d3c8cf2a218b9c28$export$cb172b2468ab5652 = (colorStr)=>(0, $lPQPn.getValueFromColor)((0, $lPQPn.toFrontendColor)(colorStr));
const $d3c8cf2a218b9c28$export$1cfcb95cb8fbddb3 = (value)=>(0, $lPQPn.toBackendColor)((0, $lPQPn.getColorFromValue)(value));

});

parcelRegister("3yikB", function(module, exports) {

$parcel$export(module.exports, "saveField", () => $102b1772cf6f1cd1$export$72a8b15fb4557735);

var $53ciZ = parcelRequire("53ciZ");

var $lRmyA = parcelRequire("lRmyA");

var $jZDJX = parcelRequire("jZDJX");

var $5zSUY = parcelRequire("5zSUY");
const $102b1772cf6f1cd1$export$72a8b15fb4557735 = (saveFieldArguments, state)=>(0, $lRmyA.performPostRequest)(`${saveFieldArguments.baseUrl}/secure/AjaxIssueAction.jspa?decorator=none`, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: (0, $53ciZ.stringify)({
            [saveFieldArguments.fieldId]: saveFieldArguments.value,
            issueId: (0, $jZDJX.idSelector)(state),
            skipScreenCheck: true,
            atl_token: (0, $5zSUY.default)(),
            singleFieldEdit: true
        })
    });
const $102b1772cf6f1cd1$export$9484196f28d39238 = (saveFieldArguments)=>(0, $lRmyA.performPutRequest)(`${saveFieldArguments.baseUrl}/rest/greenhopper/1.0/xboard/issue/update-field.json`, {
        body: JSON.stringify({
            fieldId: saveFieldArguments.fieldId,
            issueIdOrKey: saveFieldArguments.issueKey,
            newValue: saveFieldArguments.value
        })
    });

});

parcelRegister("fYUxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b958591143b6ef74$export$2e2bcd8739ae039);

var $k34g9 = parcelRequire("k34g9");
var $b958591143b6ef74$export$2e2bcd8739ae039 = (0, $k34g9.UnsafeColorPicker);

});
parcelRegister("k34g9", function(module, exports) {

$parcel$export(module.exports, "UnsafeColorPicker", () => $0877588a737ad151$export$23aeefcaa20be353);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $4OYTw = parcelRequire("4OYTw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lPQPn = parcelRequire("lPQPn");

var $3RYPC = parcelRequire("3RYPC");

var $cLelS = parcelRequire("cLelS");
const $0877588a737ad151$export$ef3e25e84f42283d = ({ value: value, palette: palette })=>{
    const colorLabel = palette.filter((color)=>color.value === value)[0].label;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const label = formatMessage((0, $3RYPC.default).readOnlyLabel, {
        color: colorLabel
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cLelS.ReadOnlyColorWrapper), {
        "aria-label": label,
        "data-testid": "issue-view-foundation.color.read-only-color-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0877588a737ad151$var$ReadOnlyColourPickerStyle, {
        selectedColor: value
    }));
};
const $0877588a737ad151$export$23aeefcaa20be353 = (props)=>{
    // static displayName = 'ColorPicker';
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleOnChange = (newColor)=>{
        props.onChange(newColor);
        props.onConfirm();
    };
    const colorPalette = (0, $lPQPn.getDefaultColorPalette)(formatMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0877588a737ad151$var$ColorPickerWrapper // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-testid": "issue.views.issue-base.foundation.color.color-picker-wrapper"
    }, props.isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4OYTw.default), {
        label: formatMessage((0, $3RYPC.default).label),
        popperProps: {
            positionFixed: true,
            modifiers: {
                // @ts-expect-error - TS2322 - Type '{ offset: { offset: string; }; }' is not assignable to type 'readonly Partial<Modifier<string, object>>[]'.
                offset: {
                    offset: '-10 5'
                }
            }
        },
        cols: colorPalette.length / 2,
        selectedColor: props.value,
        palette: colorPalette,
        onChange: handleOnChange
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0877588a737ad151$export$ef3e25e84f42283d, {
        value: props.value,
        palette: colorPalette
    }));
};
// move 2px to the left to align with other components
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0877588a737ad151$var$ColorPickerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01i6y _ca0qu2gc _u5f3u2gc _4t3izwfg _z29hglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0877588a737ad151$var$ReadOnlyColourPickerStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedColor: selectedColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1nvmxum": (0, $9t7rW.default)(__cmplp.selectedColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154it94y _1ltvt94y _1bsb1tcg _4t3i1tcg _2rko1l7b _11q71ake",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4OYTw", function(module, exports) {

$parcel$export(module.exports, "Compact", () => $382b11534fd0f5ad$export$6479582a9c9e50ce);
$parcel$export(module.exports, "default", () => $382b11534fd0f5ad$export$2e2bcd8739ae039);

var $bLB2v = parcelRequire("bLB2v");

var $OYJcz = parcelRequire("OYJcz");

var $16oJQ = parcelRequire("16oJQ");
const { Compact: $382b11534fd0f5ad$export$6479582a9c9e50ce, Standard: $382b11534fd0f5ad$export$d5a1f56087d42b19 } = (0, $OYJcz.Mode);
var $382b11534fd0f5ad$export$2e2bcd8739ae039 = (0, $bLB2v.default);

});
parcelRegister("bLB2v", function(module, exports) {

$parcel$export(module.exports, "default", () => $8910d0c33e53cae6$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $4IBr3 = parcelRequire("4IBr3");

var $9WoFy = parcelRequire("9WoFy");

var $9QjWB = parcelRequire("9QjWB");


var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $4srsX = parcelRequire("4srsX");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $2qhQi = parcelRequire("2qhQi");

var $eooVo = parcelRequire("eooVo");
const $8910d0c33e53cae6$var$defaultPopperProps = {
    strategy: 'fixed',
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        }
    ],
    placement: 'bottom-start'
};
const $8910d0c33e53cae6$var$packageName = "@atlaskit/color-picker";
const $8910d0c33e53cae6$var$packageVersion = "3.2.13";
class $8910d0c33e53cae6$var$ColorPickerWithoutAnalyticsBase extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "createAndFireEventOnAtlaskit", (0, $hM7RE.default)('atlaskit'));
        (0, $5zQU9.default)(this, "state", {
            isTabbing: false
        });
        (0, $5zQU9.default)(this, "changeAnalyticsCaller", ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) return this.createAndFireEventOnAtlaskit({
                action: 'clicked',
                actionSubject: 'color-picker',
                attributes: {
                    componentName: 'color-picker',
                    packageName: $8910d0c33e53cae6$var$packageName,
                    packageVersion: $8910d0c33e53cae6$var$packageVersion
                }
            })(createAnalyticsEvent);
            return undefined;
        });
        (0, $5zQU9.default)(this, "onChangeSelect", (option)=>{
            this.props.onChange(option.value, this.changeAnalyticsCaller());
        });
        (0, $5zQU9.default)(this, "onOptionKeyDown", (value)=>{
            this.props.onChange(value, this.changeAnalyticsCaller());
        });
        (0, $5zQU9.default)(this, "onKeyDown", (e)=>{
            const key = e.key;
            if (key === (0, $c28f278d2c33b2d0$export$10f6869ed0a7d75b)) this.setState({
                isTabbing: true
            });
            else if (key === (0, $c28f278d2c33b2d0$export$b34c7ae3fd8138d2) || key === (0, $c28f278d2c33b2d0$export$1734a06b2397c2a8)) this.setState({
                isTabbing: false
            });
            else if ((0, $XHGTv.getBooleanFF)('platform.color-picker-radio-button-functionality_6hkcy') && key === 'Escape') e.stopPropagation();
        });
        (0, $5zQU9.default)(this, "getFullLabel", (intl, value, label)=>{
            if ((0, $XHGTv.getBooleanFF)('platform.jca11y-1480-inappropriate-label-for-color-picker_76tfe')) {
                if (value && value.label) return intl.formatMessage((0, $eooVo.default).colorPickerAriaLabel, {
                    color: value.label,
                    message: label
                });
                else return label;
            } else return intl.formatMessage((0, $eooVo.default).colorPickerAriaLabelOldFormat, {
                color: value.label,
                message: label
            });
        });
    }
    render() {
        const { palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, cols: cols, popperProps: popperProps = $8910d0c33e53cae6$var$defaultPopperProps, label: label = 'Color picker', selectedColourSwatchSize: selectedColourSwatchSize, showDefaultSwatchColor: showDefaultSwatchColor = true, isDisabledSelectedSwatch: isDisabledSelectedSwatch, intl: intl } = this.props;
        const { options: options, value: value } = (0, $4srsX.getOptions)(palette, selectedColor, showDefaultSwatchColor);
        const fullLabel = this.getFullLabel(intl, value, label);
        return (0, $byn9U.jsx)((0, $4IBr3.default), {
            target: ({ ref: ref, isOpen: isOpen })=>(0, $byn9U.jsx)("div", {
                    css: $8910d0c33e53cae6$var$colorCardWrapperStyles,
                    ref: ref
                }, (0, $byn9U.jsx)((0, $9WoFy.default), (0, $kU09D.default)({}, value, {
                    label: fullLabel,
                    expanded: isOpen
                }, (0, $XHGTv.getBooleanFF)('platform.color-picker-radio-button-functionality_6hkcy') && {
                    swatchSize: selectedColourSwatchSize,
                    isDisabled: isDisabledSelectedSwatch
                }))),
            popperProps: popperProps,
            maxMenuWidth: "auto",
            minMenuWidth: "auto",
            options: options,
            "aria-label": fullLabel,
            value: value,
            components: $9QjWB,
            onChange: this.onChangeSelect,
            searchThreshold: Number.MAX_VALUE,
            cols: cols,
            checkMarkColor: checkMarkColor,
            onKeyDown: this.onKeyDown,
            isTabbing: this.state.isTabbing,
            onOptionKeyDown: this.onOptionKeyDown
        });
    }
}
const $8910d0c33e53cae6$export$2fcf66ed38ff3cf5 = (0, $2qhQi.default)($8910d0c33e53cae6$var$ColorPickerWithoutAnalyticsBase);
var $8910d0c33e53cae6$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'color-picker',
    packageName: $8910d0c33e53cae6$var$packageName,
    packageVersion: $8910d0c33e53cae6$var$packageVersion
})((0, $2jDha.default)()($8910d0c33e53cae6$export$2fcf66ed38ff3cf5));
const $8910d0c33e53cae6$var$colorCardWrapperStyles = (0, $byn9U.css)({
    display: 'inline-block'
});

});
parcelRegister("9WoFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ccaa9ba1dcdf0d$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");
const $73ccaa9ba1dcdf0d$var$ColorCard = ({ value: value, label: label, expanded: expanded, onClick: onClick, swatchSize: swatchSize = 'default', isDisabled: isDisabled })=>{
    const handleMouseDown = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        event.currentTarget.focus();
        if (onClick) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    return (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: label
    }, (0, $byn9U.jsx)("button", (0, $kU09D.default)({}, (0, $XHGTv.getBooleanFF)('platform.color-picker-radio-button-functionality_6hkcy') ? {
        css: [
            $73ccaa9ba1dcdf0d$var$sharedColorContainerStyles,
            swatchSize === 'small' ? $73ccaa9ba1dcdf0d$var$smallColorContainerSize : $73ccaa9ba1dcdf0d$var$defaultColorContainerSize,
            $73ccaa9ba1dcdf0d$var$colorCardButtonStyles,
            expanded && $73ccaa9ba1dcdf0d$var$colorCardButtonFocusedStyles
        ],
        disabled: isDisabled
    } : {
        css: [
            $73ccaa9ba1dcdf0d$var$sharedColorContainerStyles,
            $73ccaa9ba1dcdf0d$var$defaultColorContainerSize,
            $73ccaa9ba1dcdf0d$var$colorCardButtonStyles,
            expanded && $73ccaa9ba1dcdf0d$var$colorCardButtonFocusedStyles
        ]
    }, {
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        "aria-label": label,
        "aria-expanded": expanded,
        "aria-haspopup": true,
        type: "button"
    }), (0, $byn9U.jsx)("span", {
        css: $73ccaa9ba1dcdf0d$var$colorCardWrapperStyles
    }, (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, (0, $XHGTv.getBooleanFF)('platform.color-picker-radio-button-functionality_6hkcy') ? {
        css: [
            $73ccaa9ba1dcdf0d$var$colorCardContentStyles,
            swatchSize === 'small' ? $73ccaa9ba1dcdf0d$var$smallColorCardContentSize : $73ccaa9ba1dcdf0d$var$defaultColorCardContentSize
        ]
    } : {
        css: [
            $73ccaa9ba1dcdf0d$var$colorCardContentStyles,
            $73ccaa9ba1dcdf0d$var$defaultColorCardContentSize
        ]
    }, {
        style: {
            background: value || 'transparent'
        }
    })))));
};
var $73ccaa9ba1dcdf0d$export$2e2bcd8739ae039 = $73ccaa9ba1dcdf0d$var$ColorCard;
const $73ccaa9ba1dcdf0d$var$sharedColorContainerStyles = (0, $byn9U.css)({
    display: 'inline-block',
    position: 'relative',
    border: '2px solid transparent',
    boxSizing: 'border-box',
    borderRadius: '6px',
    transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $PdmhA.N0)})`,
    borderColor: `var(--ds-background-neutral-subtle, ${(0, $PdmhA.N0)})`,
    padding: "var(--ds-space-0, 0px)",
    cursor: 'pointer',
    outline: 'none'
});
const $73ccaa9ba1dcdf0d$var$smallColorContainerSize = (0, $byn9U.css)({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    top: "var(--ds-space-negative-025, -2px)"
});
const $73ccaa9ba1dcdf0d$var$defaultColorContainerSize = (0, $byn9U.css)({
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)"
});
const $73ccaa9ba1dcdf0d$var$colorCardButtonStyles = (0, $byn9U.css)({
    ':hover': {
        borderColor: `var(--ds-background-neutral-subtle, ${(0, $PdmhA.N0)})`
    },
    ':not(:focus):hover, :focus': {
        borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B100)})`,
        outline: 'none'
    }
});
const $73ccaa9ba1dcdf0d$var$colorCardButtonFocusedStyles = (0, $byn9U.css)({
    borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B100)})`,
    outline: 'none'
});
const $73ccaa9ba1dcdf0d$var$colorCardWrapperStyles = (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $73ccaa9ba1dcdf0d$var$colorCardContentStyles = (0, $byn9U.css)({
    borderRadius: "var(--ds-border-radius-100, 3px)",
    boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${(0, $PdmhA.DN600A)})`}`
});
const $73ccaa9ba1dcdf0d$var$smallColorCardContentSize = (0, $byn9U.css)({
    width: "var(--ds-space-200, 16px)",
    height: "var(--ds-space-200, 16px)"
});
const $73ccaa9ba1dcdf0d$var$defaultColorCardContentSize = (0, $byn9U.css)({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)"
});

});

parcelRegister("9QjWB", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $72a870df46fd614c$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "Option", () => $72a870df46fd614c$export$36d18380658d5d20);
$parcel$export(module.exports, "DropdownIndicator", () => $72a870df46fd614c$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "Placeholder", () => $72a870df46fd614c$export$84712d0562a614b8);

var $kU09D = parcelRequire("kU09D");

var $43kuJ = parcelRequire("43kuJ");

var $4srsX = parcelRequire("4srsX");

var $byn9U = parcelRequire("byn9U");
const $72a870df46fd614c$export$d4c4e98c5044dc8 = (props)=>{
    const { selectProps: { cols: cols }, innerRef: innerRef, children: children } = props;
    return (0, $byn9U.jsx)("div", {
        css: $72a870df46fd614c$var$colorPaletteContainerStyles,
        role: "radiogroup",
        style: {
            maxWidth: cols ? (0, $4srsX.getWidth)(cols) : undefined
        },
        ref: innerRef
    }, children);
};
const $72a870df46fd614c$export$36d18380658d5d20 = (props)=>{
    const { data: { value: value, label: label }, selectProps: { checkMarkColor: checkMarkColor, onOptionKeyDown: onOptionKeyDown, isTabbing: isTabbing }, isFocused: isFocused, isSelected: isSelected, innerProps: innerProps } = props;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        css: $72a870df46fd614c$var$colorCardWrapperStyles
    }, innerProps), (0, $byn9U.jsx)((0, $43kuJ.default), {
        label: label,
        value: value,
        checkMarkColor: checkMarkColor,
        isOption: true,
        focused: isFocused,
        selected: isSelected,
        onKeyDown: (value)=>onOptionKeyDown(value),
        isTabbing: isTabbing
    }));
};
const $72a870df46fd614c$export$ec98719d3db7f2e4 = ()=>null;
const $72a870df46fd614c$export$84712d0562a614b8 = ()=>null;
const $72a870df46fd614c$var$colorCardWrapperStyles = (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-025, 2px)",
    height: "var(--ds-space-400, 32px)"
});
const $72a870df46fd614c$var$colorPaletteContainerStyles = (0, $byn9U.css)({
    display: 'flex',
    flexWrap: 'wrap',
    padding: "var(--ds-space-050, 4px)"
});

});
parcelRegister("43kuJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f375708ff5b0f17$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $k9Z3M = parcelRequire("k9Z3M");

var $8cU5f = parcelRequire("8cU5f");


var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");
const $2f375708ff5b0f17$var$ColorCard = (props)=>{
    const { value: value, label: label, selected: selected, focused: focused, checkMarkColor: checkMarkColor = (0, $PdmhA.N0), isTabbing: isTabbing, onClick: onClick, onKeyDown: onKeyDown } = props;
    const ref = (0, $eUqFw.useRef)(null);
    const handleMouseDown = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            onClick(value);
        }
    }, [
        onClick,
        value
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const { key: key } = event;
        if ((isTabbing === undefined || isTabbing) && onKeyDown && (key === (0, $c28f278d2c33b2d0$export$8152f929a25a0ff4) || key === (0, $c28f278d2c33b2d0$export$e51a3576c045c8d5))) {
            event.preventDefault();
            if (isTabbing) event.stopPropagation();
            onKeyDown(value);
        }
    }, [
        isTabbing,
        onKeyDown,
        value
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $XHGTv.getBooleanFF)('platform.color-picker-radio-button-functionality_6hkcy')) {
            const refCurrent = ref.current;
            const handleKeyDown = (e)=>{
                if (e.key === 'Tab') {
                    e.stopPropagation();
                    e.preventDefault();
                }
            };
            refCurrent === null || refCurrent === void 0 || refCurrent.addEventListener('keydown', handleKeyDown);
            return ()=>{
                refCurrent === null || refCurrent === void 0 || refCurrent.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, []);
    return (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: label
    }, (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        css: [
            $2f375708ff5b0f17$var$sharedColorContainerStyles,
            (isTabbing === undefined || isTabbing) && $2f375708ff5b0f17$var$colorCardOptionTabbingStyles,
            focused && !isTabbing && $2f375708ff5b0f17$var$colorCardOptionFocusedStyles
        ],
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyDown: handleKeyDown,
        role: "radio",
        "aria-checked": selected
    }, !(0, $XHGTv.getBooleanFF)('platform.jca11y-1559-dashboard-view-dashboard-remove-duplicate-aria-label_g5i3i') && {
        'aria-label': label
    }, {
        tabIndex: 0
    }, (0, $XHGTv.getBooleanFF)('platform.color-picker-radio-button-functionality_6hkcy') && {
        ref: ref
    }), (0, $byn9U.jsx)("div", {
        css: $2f375708ff5b0f17$var$colorCardWrapperStyles
    }, (0, $byn9U.jsx)("div", {
        css: $2f375708ff5b0f17$var$colorCardContentStyles,
        style: {
            background: value || 'transparent'
        }
    }, selected && (0, $byn9U.jsx)("div", {
        css: $2f375708ff5b0f17$var$colorCardContentCheckMarkStyles
    }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
        primaryColor: checkMarkColor,
        label: ""
    }))))));
};
var $2f375708ff5b0f17$export$2e2bcd8739ae039 = $2f375708ff5b0f17$var$ColorCard;
const $2f375708ff5b0f17$var$colorCardOptionTabbingStyles = (0, $byn9U.css)({
    ':hover, :focus': {
        borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B75)})`
    }
});
const $2f375708ff5b0f17$var$colorCardOptionFocusedStyles = (0, $byn9U.css)({
    borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B75)})`
});
const $2f375708ff5b0f17$var$colorCardContentCheckMarkStyles = (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    margin: '1px'
});
const $2f375708ff5b0f17$var$sharedColorContainerStyles = (0, $byn9U.css)({
    display: 'inline-block',
    position: 'relative',
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)",
    border: '2px solid transparent',
    boxSizing: 'border-box',
    borderRadius: "var(--ds-border-radius-200, 6px)",
    transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $PdmhA.N0)})`,
    borderColor: `var(--ds-background-neutral-subtle, ${(0, $PdmhA.N0)})`,
    padding: "var(--ds-space-0, 0px)",
    cursor: 'pointer',
    outline: 'none'
});
const $2f375708ff5b0f17$var$colorCardWrapperStyles = (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $2f375708ff5b0f17$var$colorCardContentStyles = (0, $byn9U.css)({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: "var(--ds-border-radius-100, 3px)",
    boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${(0, $PdmhA.DN600A)})`}`
});

});
const $c28f278d2c33b2d0$export$64c9b8c6e6a2c6ac = 32;
const $c28f278d2c33b2d0$export$e51a3576c045c8d5 = ' ';
const $c28f278d2c33b2d0$export$8152f929a25a0ff4 = 'Enter';
const $c28f278d2c33b2d0$export$b34c7ae3fd8138d2 = 'ArrowDown';
const $c28f278d2c33b2d0$export$1734a06b2397c2a8 = 'ArrowUp';
const $c28f278d2c33b2d0$export$10f6869ed0a7d75b = 'Tab';


parcelRegister("4srsX", function(module, exports) {

$parcel$export(module.exports, "getWidth", () => $33ef151eb52a2f36$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "getOptions", () => $33ef151eb52a2f36$export$d2312e68e1f5ad00);
// AFP-2532 TODO: Fix automatic suppressions below
// eslint-disable-next-line @atlassian/tangerine/import/entry-points

var $lcnyw = parcelRequire("lcnyw");


var $5iWql = parcelRequire("5iWql");

var $OYJcz = parcelRequire("OYJcz");

var $XHGTv = parcelRequire("XHGTv");
const $33ef151eb52a2f36$export$3c49c185de0c2bfc = (cols, mode)=>{
    const width = cols * ((0, $c28f278d2c33b2d0$export$64c9b8c6e6a2c6ac) + (0, $lcnyw.gridSize)() / 2);
    return mode === (0, $OYJcz.Mode).Standard ? width + (0, $lcnyw.gridSize)() : width;
};
const $33ef151eb52a2f36$export$d2312e68e1f5ad00 = (0, $5iWql.default)((palette, selectedColor, showDefaultSwatchColor)=>{
    let focusedItemIndex = 0;
    let defaultSelectedColor = palette[0];
    if ((0, $XHGTv.getBooleanFF)('platform.color-picker-radio-button-functionality_6hkcy') && !showDefaultSwatchColor) defaultSelectedColor = {
        label: '',
        value: ''
    };
    const value = palette.find((color, index)=>{
        if (color.value === selectedColor) {
            focusedItemIndex = index;
            return true;
        }
        return false;
    }) || defaultSelectedColor;
    return {
        options: palette,
        value: value,
        focusedItemIndex: focusedItemIndex
    };
});

});
parcelRegister("OYJcz", function(module, exports) {

$parcel$export(module.exports, "Mode", () => $0993c6f43d0eeef9$export$9484bbecc3c49a2e);
let $0993c6f43d0eeef9$export$9484bbecc3c49a2e = /*#__PURE__*/ function(Mode) {
    Mode[Mode["Compact"] = 0] = "Compact";
    Mode[Mode["Standard"] = 1] = "Standard";
    return Mode;
}({});

});



parcelRegister("eooVo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7a6a41ccbda1940$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a7a6a41ccbda1940$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    colorPickerAriaLabel: {
        id: 'jira.color-picker.src.color-picker-aria-label',
        defaultMessage: '{color} selected, {message}',
        description: 'This text is used as aria-label text in color picker component'
    },
    colorPickerAriaLabelOldFormat: {
        id: 'jira.color-picker.src.color-picker-aria-label-old-format',
        defaultMessage: `{message}, {color} selected`,
        description: 'This text is used as aria-label text in color picker component'
    }
});

});


parcelRegister("16oJQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cd98a7f13fd59b6$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $OYJcz = parcelRequire("OYJcz");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $43kuJ = parcelRequire("43kuJ");

var $4srsX = parcelRequire("4srsX");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $0cd98a7f13fd59b6$export$4bbfe93c6a14e8e6 = ({ createAnalyticsEvent: createAnalyticsEvent, onChange: onChange, palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, label: label = 'Color picker', cols: cols = 6, mode: mode = (0, $OYJcz.Mode).Standard })=>{
    const createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
    const changeAnalyticsCaller = ()=>{
        if (createAnalyticsEvent) return createAndFireEventOnAtlaskit({
            action: 'clicked',
            actionSubject: 'color-palette-menu',
            attributes: {
                componentName: 'color-picker',
                packageName: "@atlaskit/color-picker",
                packageVersion: "3.2.13"
            }
        })(createAnalyticsEvent);
        return undefined;
    };
    const handleChange = (value)=>{
        onChange(value, changeAnalyticsCaller());
    };
    const { options: options, value: selectedValue } = (0, $4srsX.getOptions)(palette, selectedColor);
    const fullLabel = `${label}, ${selectedValue.label} selected`;
    return (0, $byn9U.jsx)("div", {
        "aria-label": fullLabel,
        role: "radiogroup",
        css: [
            $0cd98a7f13fd59b6$var$colorPaletteMenuStyles,
            mode === (0, $OYJcz.Mode).Standard && $0cd98a7f13fd59b6$var$colorPaletteMenuStandardStyles
        ],
        style: {
            width: `${(0, $4srsX.getWidth)(cols, mode)}px`
        }
    }, (0, $byn9U.jsx)("div", {
        css: [
            $0cd98a7f13fd59b6$var$colorPaletteContainerStyles,
            mode === (0, $OYJcz.Mode).Compact && $0cd98a7f13fd59b6$var$colorPaletteContainerCompactStyles
        ]
    }, options.map(({ label: label, value: value })=>(0, $byn9U.jsx)("div", {
            css: $0cd98a7f13fd59b6$var$colorCardWrapperStyles,
            key: value
        }, (0, $byn9U.jsx)((0, $43kuJ.default), {
            label: label,
            value: value,
            checkMarkColor: checkMarkColor,
            isOption: true,
            selected: value === selectedValue.value,
            onClick: handleChange,
            onKeyDown: handleChange
        })))));
};
var $0cd98a7f13fd59b6$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'color-picker',
    packageName: "@atlaskit/color-picker",
    packageVersion: "3.2.13"
})((0, $2jDha.default)()($0cd98a7f13fd59b6$export$4bbfe93c6a14e8e6));
const $0cd98a7f13fd59b6$var$colorCardWrapperStyles = (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-025, 2px)",
    height: "var(--ds-space-400, 32px)"
});
const $0cd98a7f13fd59b6$var$colorPaletteContainerStyles = (0, $byn9U.css)({
    display: 'flex',
    flexWrap: 'wrap',
    padding: "var(--ds-space-050, 4px)"
});
const $0cd98a7f13fd59b6$var$colorPaletteContainerCompactStyles = (0, $byn9U.css)({
    padding: "var(--ds-space-0, 0)"
});
const $0cd98a7f13fd59b6$var$colorPaletteMenuStyles = (0, $byn9U.css)({
    display: 'flex',
    position: 'relative',
    margin: "var(--ds-space-0, 0)",
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`
});
const $0cd98a7f13fd59b6$var$colorPaletteMenuStandardStyles = (0, $byn9U.css)({
    borderRadius: "var(--ds-border-radius-100, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $PdmhA.N40)}, 0 0 8px ${(0, $PdmhA.N40)}`})`
});

});


parcelRegister("3RYPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3667187591cf7a45$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $3667187591cf7a45$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    readOnlyLabel: {
        "id": "issue.views.issue-base.foundation.read-only-label",
        "defaultMessage": "Read-only Color, {color} selected"
    },
    label: {
        "id": "issue.views.issue-base.foundation.label",
        "defaultMessage": "edit epic color"
    },
    purple: {
        "id": "issue.views.issue-base.foundation.purple",
        "defaultMessage": "purple"
    },
    darkPurple: {
        "id": "issue.views.issue-base.foundation.dark-purple",
        "defaultMessage": "dark purple"
    },
    blue: {
        "id": "issue.views.issue-base.foundation.blue",
        "defaultMessage": "blue"
    },
    darkBlue: {
        "id": "issue.views.issue-base.foundation.dark-blue",
        "defaultMessage": "dark blue"
    },
    green: {
        "id": "issue.views.issue-base.foundation.green",
        "defaultMessage": "green"
    },
    darkGreen: {
        "id": "issue.views.issue-base.foundation.dark-green",
        "defaultMessage": "dark green"
    },
    teal: {
        "id": "issue.views.issue-base.foundation.teal",
        "defaultMessage": "teal"
    },
    darkTeal: {
        "id": "issue.views.issue-base.foundation.dark-teal",
        "defaultMessage": "dark teal"
    },
    yellow: {
        "id": "issue.views.issue-base.foundation.yellow",
        "defaultMessage": "yellow"
    },
    darkYellow: {
        "id": "issue.views.issue-base.foundation.dark-yellow",
        "defaultMessage": "dark yellow"
    },
    orange: {
        "id": "issue.views.issue-base.foundation.orange",
        "defaultMessage": "orange"
    },
    darkOrange: {
        "id": "issue.views.issue-base.foundation.dark-orange",
        "defaultMessage": "dark orange"
    },
    grey: {
        "id": "issue.views.issue-base.foundation.grey",
        "defaultMessage": "grey"
    },
    darkGrey: {
        "id": "issue.views.issue-base.foundation.dark-grey",
        "defaultMessage": "dark grey"
    }
});

});

parcelRegister("cLelS", function(module, exports) {

$parcel$export(module.exports, "ReadOnlyColorWrapper", () => $0c65b7fd1b55bad7$export$9e8e5eba7ecd5eda);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
parcelRequire("35rHW");
const $0c65b7fd1b55bad7$export$9e8e5eba7ecd5eda = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _kqswh2mm _1bsb1ul9 _4t3i1ul9 _19itj1ic _vchhusvi _2rkoi2wt _1h6d3acm _bfhk18uv _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _y2jn194a",
            __cmplp.className
        ])
    });
});

});
parcelRegister("35rHW", function(module, exports) {
(function(global, factory) {
    factory();
})(module.exports, function() {
    'use strict';
    /**
   * https://github.com/WICG/focus-visible
   */ function init() {
        var hadKeyboardEvent = true;
        var hadFocusVisibleRecently = false;
        var hadFocusVisibleRecentlyTimeout = null;
        var inputTypesWhitelist = {
            text: true,
            search: true,
            url: true,
            tel: true,
            email: true,
            password: true,
            number: true,
            date: true,
            month: true,
            week: true,
            time: true,
            datetime: true,
            'datetime-local': true
        };
        /**
     * Helper function for legacy browsers and iframes which sometimes focus
     * elements like document, body, and non-interactive SVG.
     * @param {Element} el
     */ function isValidFocusTarget(el) {
            if (el && el !== document && el.nodeName !== 'HTML' && el.nodeName !== 'BODY' && 'classList' in el && 'contains' in el.classList) return true;
            return false;
        }
        /**
     * Computes whether the given element should automatically trigger the
     * `focus-visible` class being added, i.e. whether it should always match
     * `:focus-visible` when focused.
     * @param {Element} el
     * @return {boolean}
     */ function focusTriggersKeyboardModality(el) {
            var type = el.type;
            var tagName = el.tagName;
            if (tagName == 'INPUT' && inputTypesWhitelist[type] && !el.readOnly) return true;
            if (tagName == 'TEXTAREA' && !el.readOnly) return true;
            if (el.isContentEditable) return true;
            return false;
        }
        /**
     * Add the `focus-visible` class to the given element if it was not added by
     * the author.
     * @param {Element} el
     */ function addFocusVisibleClass(el) {
            if (el.classList.contains('focus-visible')) return;
            el.classList.add('focus-visible');
            el.setAttribute('data-focus-visible-added', '');
        }
        /**
     * Remove the `focus-visible` class from the given element if it was not
     * originally added by the author.
     * @param {Element} el
     */ function removeFocusVisibleClass(el) {
            if (!el.hasAttribute('data-focus-visible-added')) return;
            el.classList.remove('focus-visible');
            el.removeAttribute('data-focus-visible-added');
        }
        /**
     * Treat `keydown` as a signal that the user is in keyboard modality.
     * Apply `focus-visible` to any current active element and keep track
     * of our keyboard modality state with `hadKeyboardEvent`.
     * @param {Event} e
     */ function onKeyDown(e) {
            if (isValidFocusTarget(document.activeElement)) addFocusVisibleClass(document.activeElement);
            hadKeyboardEvent = true;
        }
        /**
     * If at any point a user clicks with a pointing device, ensure that we change
     * the modality away from keyboard.
     * This avoids the situation where a user presses a key on an already focused
     * element, and then clicks on a different element, focusing it with a
     * pointing device, while we still think we're in keyboard modality.
     * @param {Event} e
     */ function onPointerDown(e) {
            hadKeyboardEvent = false;
        }
        /**
     * On `focus`, add the `focus-visible` class to the target if:
     * - the target received focus as a result of keyboard navigation, or
     * - the event target is an element that will likely require interaction
     *   via the keyboard (e.g. a text box)
     * @param {Event} e
     */ function onFocus(e) {
            // Prevent IE from focusing the document or HTML element.
            if (!isValidFocusTarget(e.target)) return;
            if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) addFocusVisibleClass(e.target);
        }
        /**
     * On `blur`, remove the `focus-visible` class from the target.
     * @param {Event} e
     */ function onBlur(e) {
            if (!isValidFocusTarget(e.target)) return;
            if (e.target.classList.contains('focus-visible') || e.target.hasAttribute('data-focus-visible-added')) {
                // To detect a tab/window switch, we look for a blur event followed
                // rapidly by a visibility change.
                // If we don't see a visibility change within 100ms, it's probably a
                // regular focus change.
                hadFocusVisibleRecently = true;
                window.clearTimeout(hadFocusVisibleRecentlyTimeout);
                hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
                    hadFocusVisibleRecently = false;
                    window.clearTimeout(hadFocusVisibleRecentlyTimeout);
                }, 100);
                removeFocusVisibleClass(e.target);
            }
        }
        /**
     * If the user changes tabs, keep track of whether or not the previously
     * focused element had .focus-visible.
     * @param {Event} e
     */ function onVisibilityChange(e) {
            if (document.visibilityState == 'hidden') {
                // If the tab becomes active again, the browser will handle calling focus
                // on the element (Safari actually calls it twice).
                // If this tab change caused a blur on an element with focus-visible,
                // re-apply the class when the user switches back to the tab.
                if (hadFocusVisibleRecently) hadKeyboardEvent = true;
                addInitialPointerMoveListeners();
            }
        }
        /**
     * Add a group of listeners to detect usage of any pointing devices.
     * These listeners will be added when the polyfill first loads, and anytime
     * the window is blurred, so that they are active when the window regains
     * focus.
     */ function addInitialPointerMoveListeners() {
            document.addEventListener('mousemove', onInitialPointerMove);
            document.addEventListener('mousedown', onInitialPointerMove);
            document.addEventListener('mouseup', onInitialPointerMove);
            document.addEventListener('pointermove', onInitialPointerMove);
            document.addEventListener('pointerdown', onInitialPointerMove);
            document.addEventListener('pointerup', onInitialPointerMove);
            document.addEventListener('touchmove', onInitialPointerMove);
            document.addEventListener('touchstart', onInitialPointerMove);
            document.addEventListener('touchend', onInitialPointerMove);
        }
        function removeInitialPointerMoveListeners() {
            document.removeEventListener('mousemove', onInitialPointerMove);
            document.removeEventListener('mousedown', onInitialPointerMove);
            document.removeEventListener('mouseup', onInitialPointerMove);
            document.removeEventListener('pointermove', onInitialPointerMove);
            document.removeEventListener('pointerdown', onInitialPointerMove);
            document.removeEventListener('pointerup', onInitialPointerMove);
            document.removeEventListener('touchmove', onInitialPointerMove);
            document.removeEventListener('touchstart', onInitialPointerMove);
            document.removeEventListener('touchend', onInitialPointerMove);
        }
        /**
     * When the polfyill first loads, assume the user is in keyboard modality.
     * If any event is received from a pointing device (e.g. mouse, pointer,
     * touch), turn off keyboard modality.
     * This accounts for situations where focus enters the page from the URL bar.
     * @param {Event} e
     */ function onInitialPointerMove(e) {
            // Work around a Safari quirk that fires a mousemove on <html> whenever the
            // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
            if (e.target.nodeName.toLowerCase() === 'html') return;
            hadKeyboardEvent = false;
            removeInitialPointerMoveListeners();
        }
        document.addEventListener('keydown', onKeyDown, true);
        document.addEventListener('mousedown', onPointerDown, true);
        document.addEventListener('pointerdown', onPointerDown, true);
        document.addEventListener('touchstart', onPointerDown, true);
        document.addEventListener('focus', onFocus, true);
        document.addEventListener('blur', onBlur, true);
        document.addEventListener('visibilitychange', onVisibilityChange, true);
        addInitialPointerMoveListeners();
        document.body.classList.add('js-focus-visible');
    }
    /**
   * Subscription when the DOM is ready
   * @param {Function} callback
   */ function onDOMReady(callback) {
        var loaded;
        /**
     * Callback wrapper for check loaded state
     */ function load() {
            if (!loaded) {
                loaded = true;
                callback();
            }
        }
        if ([
            'interactive',
            'complete'
        ].indexOf(document.readyState) >= 0) callback();
        else {
            loaded = false;
            document.addEventListener('DOMContentLoaded', load, false);
            window.addEventListener('load', load, false);
        }
    }
    if (typeof document !== 'undefined') onDOMReady(init);
});

});





parcelRegister("1uomc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1064806436e53ae$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $cfw07 = parcelRequire("cfw07");

var $aPEZc = parcelRequire("aPEZc");

var $fkWZT = parcelRequire("fkWZT");

var $lqalZ = parcelRequire("lqalZ");

var $fVCj0 = parcelRequire("fVCj0");

var $lO4Or = parcelRequire("lO4Or");
const $e1064806436e53ae$var$ExperienceTrackedSummaryField = (0, $aPEZc.withExperienceTracking)((0, $cfw07.default));
const $e1064806436e53ae$export$e132102c21670a92 = (props)=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const source = (0, $hJ992.useAnalyticsSource)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fkWZT.ItemBusyWrapperByIssueKey), {
        fieldId: (0, $lO4Or.SUMMARY_TYPE),
        issueKey: issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1064806436e53ae$var$ExperienceTrackedSummaryField, {
        forField: (0, $lO4Or.SUMMARY_TYPE),
        issueKey: issueKey,
        source: source,
        appearance: (0, $4e41f56f0e9d77a8$export$526a1e214ba17198),
        ...props
    }));
};
const $e1064806436e53ae$var$ConnectedExtractedSummaryField = (0, $lqalZ.connect)(null, (dispatch)=>({
        // This is fired after successful update from the API, and fire an action
        // that is picked up by backlog.
        onUpdate: (value)=>dispatch((0, $fVCj0.sweetStateFieldUpdated)((0, $lO4Or.SUMMARY_TYPE), value))
    }))($e1064806436e53ae$export$e132102c21670a92);
var $e1064806436e53ae$export$2e2bcd8739ae039 = $e1064806436e53ae$var$ConnectedExtractedSummaryField;

});
parcelRegister("cfw07", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd662c756312134c$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $f8Yej = parcelRequire("f8Yej");

var $2gGF1 = parcelRequire("2gGF1");


var $JRB5w = parcelRequire("JRB5w");
var $7byHA = parcelRequire("7byHA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dWGNJ = parcelRequire("dWGNJ");

var $6oQPP = parcelRequire("6oQPP");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");


var $4TYQh = parcelRequire("4TYQh");

var $fWeG1 = parcelRequire("fWeG1");

var $llwh5 = parcelRequire("llwh5");
var $BW5n0 = parcelRequire("BW5n0");

var $8OWdW = parcelRequire("8OWdW");

var $rDJ37 = parcelRequire("rDJ37");
var $6gs4E = parcelRequire("6gs4E");
const $cd662c756312134c$export$fd8ebf59dd2b58b6 = 'summaryInlineEdit';
var $cd662c756312134c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    // Dependency Injection
    // More at: https://hello.atlassian.net/wiki/spaces/~agasparin/pages/774678789/Dependency+injection+and+replacement+moving+past+props+and+mocking+imports
    const { onCancel: onCancel, onEdit: onEdit, onEscape: onEscape, onConfirm: onConfirm, onEnter: onEnter, onUpdate: onUpdate, onClick: onClick, url: url, readView: readView, editView: editView, issueKey: issueKey, source: source, onFailure: onFailure, onRenderSuccess: onRenderSuccess, onEditFailure: onEditFailure, appearance: appearance = (0, $4e41f56f0e9d77a8$export$1ff9623b26415f8), showHoverPreviewEnabled: showHoverPreviewEnabled } = props;
    const isMobile = source === (0, $0100842672acae20$export$ce88447986394f2d);
    const [isEditing, setIsEditing] = (0, $eUqFw.useState)(false);
    const [isInvalid, setIsInvalid] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const invalidMessage = isInvalid ? formatMessage((0, $8OWdW.default).errorEmpty) : undefined;
    const editViewRef = (0, $eUqFw.useRef)(); // Store previous value of the field, for error scenario, to notify the parent that we failed
    // and the previous value is being restored.
    const previousValue = (0, $eUqFw.useRef)();
    const onSuccess = (newValue)=>{
        onUpdate && onUpdate(newValue);
    };
    const onFieldFailure = (error)=>{
        // If we get a ValidationError, TypeError, or client fetch error, we don't fire a failure event.
        if (error instanceof (0, $7byHA.ValidationError) || // For invalid data
        error instanceof TypeError || (0, $JRB5w.isClientFetchError)(error) || // For network issues
        (0, $JRB5w.isHttpClientErrorResponse)(error)) return;
        onFailure && onFailure(error, previousValue.current); // Replicating `withEditExperienceTracker`
        isEditing && onEditFailure && onEditFailure((0, $lO4Or.SUMMARY_TYPE), error.message);
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ value: value, error: error, fieldConfig: { value: fieldConfigValue, loading: fieldConfigLoading } }, { saveValue: saveValue, resetError: resetError }] = (0, $fWeG1.useSummaryField)({
        issueKey: (0, $6vrw7.toIssueKey)(issueKey),
        onSuccess: onSuccess,
        onFailure: onFieldFailure
    });
    const label = fieldConfigValue?.title ?? '';
    const [updatedValue, setUpdatedValue] = (0, $eUqFw.useState)(value);
    const isFieldEditable = fieldConfigValue ? fieldConfigValue.isEditable : false;
    (0, $eUqFw.useEffect)(()=>{
        // Replicating `withViewExperienceTracker`
        onRenderSuccess && onRenderSuccess(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (isEditing) {
            // only blur active element on issueKey change
            // if the field is currently being edited
            if (document?.activeElement) // @ts-expect-error - TS2339 - Property 'blur' does not exist on type 'Element'.
            document.activeElement.blur();
            setIsEditing(false);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        issueKey
    ]);
    (0, $eUqFw.useEffect)(()=>{
        previousValue.current = value;
        if (error) setIsEditing(true);
        if (!isEditing) setUpdatedValue(value);
    }, [
        error,
        isEditing,
        value
    ]);
    const save = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        if (updatedValue !== value) {
            saveValue(updatedValue, null, analyticsEvent);
            setIsEditing(false);
        } else setIsEditing(false);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        saveValue,
        updatedValue,
        value
    ]);
    const cancel = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        resetError();
        setIsEditing(false);
        setUpdatedValue(value);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        resetError,
        value
    ]);
    const onCancelRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        if (document && document.activeElement) // @ts-expect-error - TS2339 - Property 'blur' does not exist on type 'Element'.
        document.activeElement.blur();
        setIsInvalid(false);
        cancel(analyticsEvent);
        onCancel && onCancel(analyticsEvent);
    }, [
        onCancel,
        cancel
    ]);
    const onConfirmRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        if (updatedValue === null || updatedValue === '') {
            if (!isInvalid) setIsInvalid(true);
            return;
        }
        if (document && document.activeElement) // @ts-expect-error - TS2339 - Property 'blur' does not exist on type 'Element'.
        document.activeElement.blur();
        save(analyticsEvent);
        onConfirm && onConfirm(analyticsEvent, updatedValue);
    }, [
        isInvalid,
        onConfirm,
        save,
        updatedValue
    ]);
    const onEditRequested = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        setIsEditing(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onEdit && onEdit(analyticsEvent);
    }, [
        onEdit
    ]);
    const onChange = (0, $eUqFw.useCallback)((inputValue)=>{
        resetError();
        const typedValue = inputValue === '' ? null : inputValue.toString();
        if (typedValue !== null) setIsInvalid(false);
        setUpdatedValue(typedValue);
    }, [
        resetError,
        setUpdatedValue
    ]);
    const onEscapeRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onEscape && onEscape(analyticsEvent);
    }, [
        onEscape,
        cancel
    ]);
    const onEnterRequest = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        save(analyticsEvent);
        onEnter && onEnter(analyticsEvent);
    }, [
        onEnter,
        save
    ]);
    const onEnterKeyHandler = (0, $eUqFw.useCallback)(()=>{
        const enterEvent = createAnalyticsEvent((0, $4TYQh.confirmedPayload));
        onConfirmRequest(enterEvent);
    }, [
        createAnalyticsEvent,
        onConfirmRequest
    ]);
    const onEscapeKeyHandler = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        const escapeEvent = createAnalyticsEvent((0, $4TYQh.cancelledPayload));
        onCancelRequest(escapeEvent);
    }, [
        createAnalyticsEvent,
        onCancelRequest
    ]);
    const renderEditView = (0, $eUqFw.useCallback)(()=>{
        if (!isFieldEditable) return null;
        const view = appearance === (0, $4e41f56f0e9d77a8$export$1ff9623b26415f8) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $llwh5.InlineSummaryEdit // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'Ref<"input"> | undefined'.
        ), {
            passedRef: editViewRef,
            defaultValue: updatedValue,
            onChange: onChange,
            isInvalid: isInvalid,
            invalidMessage: invalidMessage
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $BW5n0.SummaryEdit // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'Ref<"h1"> | undefined'.
        ), {
            passedRef: editViewRef,
            defaultValue: updatedValue,
            onChange: onChange,
            isInvalid: isInvalid,
            invalidMessage: invalidMessage
        });
        return editView !== undefined && typeof editView === 'function' ? /*#__PURE__*/ (0, $eUqFw.createElement)(editView, {
            // @ts-expect-error - TS2769 - No overload matches this call.
            passedRef: editViewRef,
            defaultValue: updatedValue,
            onChange: onChange
        }) : // @ts-expect-error - TS2741 - Property 'onBlur' is missing in type '{ children: Element; onEnter: () => void; onEscape: (event: KeyboardEvent) => void; }' but required in type 'Props'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cd662c756312134c$export$ce7ca84868eb7d43, {
            onEnter: onEnterKeyHandler,
            onEscape: onEscapeKeyHandler
        }, view);
    }, [
        isFieldEditable,
        appearance,
        updatedValue,
        onChange,
        isInvalid,
        invalidMessage,
        onEnterKeyHandler,
        onEscapeKeyHandler,
        editView
    ]);
    const renderReadViewOld = ()=>{
        const view = appearance === (0, $4e41f56f0e9d77a8$export$1ff9623b26415f8) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6gs4E.SummaryView), {
            value: value
        });
        return readView !== undefined && typeof readView === 'function' ? /*#__PURE__*/ (0, $eUqFw.createElement)(readView, {
            value: value
        }) : view;
    };
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cd662c756312134c$var$ReadViewContainer, null, renderReadViewOld());
    if (editViewRef.current && isEditing && isInvalid) {
        const foundCurrent = editViewRef.current;
        const foundTextArea = foundCurrent instanceof HTMLElement ? foundCurrent.querySelector('textarea') : undefined;
        const foundArea = appearance === (0, $4e41f56f0e9d77a8$export$1ff9623b26415f8) ? foundCurrent : foundTextArea;
        const foundActiveElement = document ? document.activeElement : null;
        if (foundArea && foundArea !== foundActiveElement) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        foundArea.focus();
    }
    const getEditButtonLabel = ()=>value !== null ? formatMessage((0, $8OWdW.default).extendedEditButtonLabel, {
            inputFieldValue: value
        }) : formatMessage((0, $8OWdW.default).editButtonLabel);
    const summaryInlineEdit = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: error,
        title: (0, $8OWdW.default).errorTitle,
        description: (0, $8OWdW.default).errorMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cd662c756312134c$var$InlineEditContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oQPP.FieldInlineEditStateLess), {
        testId: "issue-field-summary.ui.issue-field-summary-inline-edit",
        defaultValue: updatedValue,
        readView: renderReadView,
        editView: renderEditView,
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onEnter: onEnterRequest,
        onEscape: onEscapeRequest,
        onEdit: onEditRequested,
        readViewFitContainerWidth: !isMobile,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        editButtonLabel: getEditButtonLabel(),
        confirmButtonLabel: formatMessage((0, $2gGF1.default).confirmButtonLabel, {
            fieldName: label
        }),
        cancelButtonLabel: formatMessage((0, $2gGF1.default).cancelButtonLabel, {
            fieldName: label
        })
    })));
    if (appearance === (0, $4e41f56f0e9d77a8$export$526a1e214ba17198)) return summaryInlineEdit;
    return isEditing ? summaryInlineEdit : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $rDJ37.InlineSummaryRead), {
        url: url,
        value: updatedValue,
        setIsEditing: setIsEditing,
        isEditable: isFieldEditable,
        isConfigLoading: fieldConfigLoading,
        onClick: onClick,
        showHoverPreviewEnabled: showHoverPreviewEnabled
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cd662c756312134c$var$ReadViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _vwz4kb7n _p12f1osq _1nmz1hna _ca0q12x7 _n3td12x7 _kqswh2mm _1ltv12x7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cd662c756312134c$var$InlineEditContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _18u0x0bf _19pkx0bf _bhl91osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cd662c756312134c$export$ce7ca84868eb7d43 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $f8Yej.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});
const $4e41f56f0e9d77a8$export$1ff9623b26415f8 = 'INLINE';
const $4e41f56f0e9d77a8$export$526a1e214ba17198 = 'HEADER';
const $4e41f56f0e9d77a8$export$fc311b898bd17f14 = 'issue-field-summary.ui.multiline-inline-summary.ui.read.link-item';
const $4e41f56f0e9d77a8$export$b55f1d8f2dcfc968 = 'issue-field-summary.ui.multiline-inline-summary.ui.multiline-edit--container';
const $4e41f56f0e9d77a8$export$d2b0e7fbc16ad21d = 'Confirm Summary';
const $4e41f56f0e9d77a8$export$8edfe6fec5a09039 = 'Cancel Summary';
const $4e41f56f0e9d77a8$export$49bd7df6c823d405 = 'issue-field-summary.ui.multiline-inline-summary.ui.edit.warning-icon';
const $4e41f56f0e9d77a8$export$1ac6ecb846fa0357 = 'issue-field-summary.ui.multiline-inline-summary.ui.edit.error-icon';
const $4e41f56f0e9d77a8$export$48dddadb3d40e096 = 'issue-field-summary.ui.multiline-inline-summary.ui.read.editor-edit-icon';
const $4e41f56f0e9d77a8$export$54424d2aeb675a3e = 'issue-field-summary.ui.multiline-inline-summary.ui.read.edit-button';
const $4e41f56f0e9d77a8$export$c31071ede2328121 = 'Summary is required';
const $4e41f56f0e9d77a8$export$4e34ff88d30f8b7e = '255 character limit';
const $4e41f56f0e9d77a8$export$a5970424b815e22c = 'issue-field-summary.ui.multiline-inline-summary.ui.multiline-edit';

parcelRegister("4TYQh", function(module, exports) {

$parcel$export(module.exports, "confirmedPayload", () => $4c70bd7d4bb6b64b$export$7e8d444ce1022722);
$parcel$export(module.exports, "cancelledPayload", () => $4c70bd7d4bb6b64b$export$66e7cfebb75c3e4);
/**
 * Since we want to capture the `enter` key press, and confirm the user
 * edit, same way as previous Summary did it, we also need to fire the same
 * event that would have been propagated from InlineEdit.
 *
 * @atlaskit/inline-edit--current/dist/cjs/InlineEditStateless.js.flow:270
 */ const $4c70bd7d4bb6b64b$export$7e8d444ce1022722 = {
    action: 'confirmed',
    actionSubject: 'inlineEdit',
    attributes: {
        componentName: 'inlineEdit'
    }
};
const $4c70bd7d4bb6b64b$export$66e7cfebb75c3e4 = {
    ...$4c70bd7d4bb6b64b$export$7e8d444ce1022722,
    action: 'cancelled'
};

});

parcelRegister("llwh5", function(module, exports) {

$parcel$export(module.exports, "InlineSummaryEdit", () => $5cebe356474ebe69$export$39717bc77f6d6ef7);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5YsMl = parcelRequire("5YsMl");

var $29yDk = parcelRequire("29yDk");

var $cf2Y4 = parcelRequire("cf2Y4");

var $PdmhA = parcelRequire("PdmhA");

var $jyFd9 = parcelRequire("jyFd9");
const $5cebe356474ebe69$export$39717bc77f6d6ef7 = /*#__PURE__*/ (0, $eUqFw.memo)(({ defaultValue: defaultValue, passedRef: passedRef, onChange: onChange, isInvalid: isInvalid, invalidMessage: invalidMessage })=>{
    const onChangeHandler = (0, $eUqFw.useCallback)((event)=>{
        onChange(event.target.value);
    }, [
        onChange
    ]);
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        setIsFocused(true);
    }, []);
    const onBlur = (0, $eUqFw.useCallback)(()=>{
        setIsFocused(false);
    }, []);
    const isCompact = (0, $jyFd9.useIsCompactMode)();
    const warningIcon = isInvalid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        size: "medium",
        primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y300)})`,
        label: ""
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
        content: invalidMessage,
        isOpen: isFocused && !!invalidMessage,
        placement: isCompact === true ? 'auto-start' : 'right'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5cebe356474ebe69$var$InlineEditViewWrapper, {
        isInvalid: isInvalid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        type: "text",
        value: defaultValue === null ? '' : defaultValue,
        onChange: onChangeHandler,
        label: "",
        ref: passedRef,
        appearance: isInvalid ? 'none' : 'subtle',
        onBlur: onBlur,
        onFocus: onFocus,
        isCompact: true,
        autoFocus: true
    }), warningIcon)));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5cebe356474ebe69$var$InlineEditViewWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isInvalid: isInvalid, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zidpf _i0dl1wug _1bah1yb4 _1reo15vq _18m915vq _4cvr1h6o _18u0utpp",
            __cmplp.isInvalid && "_1h6d78r2",
            __cmplp.isInvalid ? "_1dqonqa1" : "_1dqoglyw",
            __cmplp.isInvalid && "_2rko1l7b",
            __cmplp.isInvalid && "_189eyh40",
            __cmplp.className
        ])
    });
});

});

parcelRegister("BW5n0", function(module, exports) {

$parcel$export(module.exports, "SummaryEdit", () => $2ce093aff6a0d689$export$3c9c5c7696f7f8ef);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5YsMl = parcelRequire("5YsMl");

var $29yDk = parcelRequire("29yDk");

var $xeS7R = parcelRequire("xeS7R");

var $PdmhA = parcelRequire("PdmhA");

var $ak9hm = parcelRequire("ak9hm");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jyFd9 = parcelRequire("jyFd9");

var $apoJZ = parcelRequire("apoJZ");

var $bp88D = parcelRequire("bp88D");
const $2ce093aff6a0d689$export$3c9c5c7696f7f8ef = /*#__PURE__*/ (0, $eUqFw.memo)(({ defaultValue: defaultValue, passedRef: passedRef, onChange: onChange, isInvalid: isInvalid, invalidMessage: invalidMessage })=>{
    const testId = 'issue.views.issue-base.foundation.summary.heading.writeable';
    const [openDialog, setOpenDialog] = (0, $eUqFw.useState)(isInvalid);
    const isCompact = (0, $jyFd9.useIsCompactMode)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        setOpenDialog(isInvalid);
    }, [
        isInvalid
    ]);
    const onChangeHandler = (0, $eUqFw.useCallback)((event)=>{
        onChange(event.target.value);
    }, [
        onChange
    ]);
    const onFocusHandler = (0, $eUqFw.useCallback)(()=>{
        if (isInvalid === true) setOpenDialog(true);
    }, [
        isInvalid
    ]);
    const onBlurHandler = (0, $eUqFw.useCallback)(()=>{
        setOpenDialog(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
        content: invalidMessage,
        isOpen: isInvalid === true && openDialog,
        placement: isCompact === true ? 'auto-start' : 'right'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ce093aff6a0d689$var$EditViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apoJZ.SummaryHeadingNew), {
        ref: passedRef,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xeS7R.default), {
        "aria-required": true,
        autoFocus: true,
        "aria-label": formatMessage((0, $bp88D.default).summaryTextareaLabel),
        isInvalid: isInvalid,
        value: defaultValue || '',
        onChange: onChangeHandler,
        onFocus: onFocusHandler,
        onBlur: onBlurHandler,
        minimumRows: 1
    })), isInvalid === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        size: "medium",
        primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y300)})`,
        label: ""
    })));
});
const $2ce093aff6a0d689$export$8525c0a4c4425b9d = /*#__PURE__*/ (0, $eUqFw.memo)(({ defaultValue: defaultValue, passedRef: passedRef, onChange: onChange })=>{
    const testId = 'issue.views.issue-base.foundation.summary.heading.writeable';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apoJZ.SummaryHeading), {
        ref: passedRef,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ak9hm.default), {
        shouldAutoFocus: true,
        value: defaultValue,
        onChange: onChange
    }));
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2ce093aff6a0d689$var$EditViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _vwz4kb7n _p12f1osq _1nmz1hna _kqswh2mm _vr2wstnw _fkqju2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ak9hm", function(module, exports) {

$parcel$export(module.exports, "default", () => $244ae552b834c197$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $jG2Eu = parcelRequire("jG2Eu");

var $6ffQD = parcelRequire("6ffQD");
// Designed to be used as the edit view for AkFieldBase.
// Can be removed once Atlaskit provides a suitable alternative.
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $244ae552b834c197$var$TextAreaWrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-7dl75q-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    textarea: {
        display: 'block',
        width: '100%',
        margin: 0,
        padding: 0,
        border: 'none',
        overflow: 'auto',
        outline: 'none',
        boxShadow: 'none',
        background: 'transparent',
        wordWrap: 'break-word',
        resize: 'none',
        color: 'inherit',
        font: 'inherit',
        lineHeight: 'inherit',
        letterSpacing: 'inherit'
    }
});
class $244ae552b834c197$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isDisabled: false,
            shouldAutoFocus: false,
            onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    constructor(...args){
        super(...args);
        this.onChange = (event)=>this.props.onChange(event.target.value);
        this.render = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($244ae552b834c197$var$TextAreaWrapper, {
                isDisabled: this.props.isDisabled
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ffQD.default), {
                value: this.props.value,
                // @ts-expect-error - TS2769 - No overload matches this call.
                onChange: this.onChange,
                onKeyDown: this.props.onKeyDown,
                disabled: this.props.isDisabled,
                autoFocus: this.props.shouldAutoFocus
            }));
    }
}

});
parcelRegister("6ffQD", function(module, exports) {

$parcel$export(module.exports, "default", () => $48c06fd7a7a666dd$export$2e2bcd8739ae039, (v) => $48c06fd7a7a666dd$export$2e2bcd8739ae039 = v);
var $48c06fd7a7a666dd$export$1e511d4a378977f5;
var $48c06fd7a7a666dd$export$2e2bcd8739ae039;
"use strict";
$48c06fd7a7a666dd$export$1e511d4a378977f5 = true;

var $7hoDU = parcelRequire("7hoDU");
$48c06fd7a7a666dd$export$2e2bcd8739ae039 = $7hoDU.default;

});
parcelRegister("7hoDU", function(module, exports) {
"use strict";
var $54cd3c7446f58fe6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $54cd3c7446f58fe6$var$__assign = module.exports && module.exports.__assign || Object.assign || function(t) {
    for(var s, i = 1, n = arguments.length; i < n; i++){
        s = arguments[i];
        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};
var $54cd3c7446f58fe6$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }
    return t;
};
module.exports.__esModule = true;

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $3m7C8 = parcelRequire("3m7C8");

var $38VFQ = parcelRequire("38VFQ");
var $54cd3c7446f58fe6$var$getLineHeight = $38VFQ;
var $54cd3c7446f58fe6$var$UPDATE = 'autosize:update';
var $54cd3c7446f58fe6$var$DESTROY = 'autosize:destroy';
var $54cd3c7446f58fe6$var$RESIZED = 'autosize:resized';
/**
 * A light replacement for built-in textarea component
 * which automaticaly adjusts its height to match the content
 */ var $54cd3c7446f58fe6$var$TextareaAutosize = /** @class */ function(_super) {
    $54cd3c7446f58fe6$var$__extends(TextareaAutosize, _super);
    function TextareaAutosize() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            lineHeight: null
        };
        _this.dispatchEvent = function(EVENT_TYPE) {
            var event = document.createEvent('Event');
            event.initEvent(EVENT_TYPE, true, false);
            _this.textarea.dispatchEvent(event);
        };
        _this.updateLineHeight = function() {
            _this.setState({
                lineHeight: $54cd3c7446f58fe6$var$getLineHeight(_this.textarea)
            });
        };
        _this.onChange = function(e) {
            var onChange = _this.props.onChange;
            _this.currentValue = e.currentTarget.value;
            onChange && onChange(e);
        };
        _this.saveDOMNodeRef = function(ref) {
            var innerRef = _this.props.innerRef;
            if (innerRef) innerRef(ref);
            _this.textarea = ref;
        };
        _this.getLocals = function() {
            var _a = _this, _b = _a.props, onResize = _b.onResize, maxRows = _b.maxRows, onChange = _b.onChange, style = _b.style, innerRef = _b.innerRef, props = $54cd3c7446f58fe6$var$__rest(_b, [
                "onResize",
                "maxRows",
                "onChange",
                "style",
                "innerRef"
            ]), lineHeight = _a.state.lineHeight, saveDOMNodeRef = _a.saveDOMNodeRef;
            var maxHeight = maxRows && lineHeight ? lineHeight * maxRows : null;
            return $54cd3c7446f58fe6$var$__assign({}, props, {
                saveDOMNodeRef: saveDOMNodeRef,
                style: maxHeight ? $54cd3c7446f58fe6$var$__assign({}, style, {
                    maxHeight: maxHeight
                }) : style,
                onChange: _this.onChange
            });
        };
        return _this;
    }
    TextareaAutosize.prototype.componentDidMount = function() {
        var _this = this;
        var _a = this.props, onResize = _a.onResize, maxRows = _a.maxRows, async = _a.async;
        if (typeof maxRows === 'number') this.updateLineHeight();
        if (typeof maxRows === "number" || async) /*
              the defer is needed to:
                - force "autosize" to activate the scrollbar when this.props.maxRows is passed
                - support StyledComponents (see #71)
            */ setTimeout(function() {
            return $3m7C8(_this.textarea);
        });
        else $3m7C8(this.textarea);
        if (onResize) this.textarea.addEventListener($54cd3c7446f58fe6$var$RESIZED, onResize);
    };
    TextareaAutosize.prototype.componentWillUnmount = function() {
        var onResize = this.props.onResize;
        if (onResize) this.textarea.removeEventListener($54cd3c7446f58fe6$var$RESIZED, onResize);
        this.dispatchEvent($54cd3c7446f58fe6$var$DESTROY);
    };
    TextareaAutosize.prototype.render = function() {
        var _a = this.getLocals(), children = _a.children, saveDOMNodeRef = _a.saveDOMNodeRef, locals = $54cd3c7446f58fe6$var$__rest(_a, [
            "children",
            "saveDOMNodeRef"
        ]);
        return $eUqFw.createElement("textarea", $54cd3c7446f58fe6$var$__assign({}, locals, {
            ref: saveDOMNodeRef
        }), children);
    };
    TextareaAutosize.prototype.componentDidUpdate = function(prevProps) {
        if (this.props.value !== this.currentValue || this.props.rows !== prevProps.rows) this.dispatchEvent($54cd3c7446f58fe6$var$UPDATE);
    };
    TextareaAutosize.defaultProps = {
        rows: 1,
        async: false
    };
    TextareaAutosize.propTypes = {
        rows: $1Qivz.number,
        maxRows: $1Qivz.number,
        onResize: $1Qivz.func,
        innerRef: $1Qivz.func,
        async: $1Qivz.bool
    };
    return TextareaAutosize;
}($eUqFw.Component);
module.exports["default"] = $54cd3c7446f58fe6$var$TextareaAutosize;

});
parcelRegister("3m7C8", function(module, exports) {
/*!
	autosize 4.0.2
	license: MIT
	http://www.jacklmoore.com/autosize
*/ (function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        'module',
        'exports'
    ], factory);
    else {
        var mod;
        factory(module, exports);
    }
})(this, function(module1, exports1) {
    'use strict';
    var map = typeof Map === "function" ? new Map() : function() {
        var keys = [];
        var values = [];
        return {
            has: function has(key) {
                return keys.indexOf(key) > -1;
            },
            get: function get(key) {
                return values[keys.indexOf(key)];
            },
            set: function set(key, value) {
                if (keys.indexOf(key) === -1) {
                    keys.push(key);
                    values.push(value);
                }
            },
            delete: function _delete(key) {
                var index = keys.indexOf(key);
                if (index > -1) {
                    keys.splice(index, 1);
                    values.splice(index, 1);
                }
            }
        };
    }();
    var createEvent = function createEvent(name) {
        return new Event(name, {
            bubbles: true
        });
    };
    try {
        new Event('test');
    } catch (e) {
        // IE does not support `new Event()`
        createEvent = function createEvent(name) {
            var evt = document.createEvent('Event');
            evt.initEvent(name, true, false);
            return evt;
        };
    }
    function assign(ta) {
        if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;
        var heightOffset = null;
        var clientWidth = null;
        var cachedHeight = null;
        function init() {
            var style = window.getComputedStyle(ta, null);
            if (style.resize === 'vertical') ta.style.resize = 'none';
            else if (style.resize === 'both') ta.style.resize = 'horizontal';
            if (style.boxSizing === 'content-box') heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
            else heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
            // Fix when a textarea is not on document body and heightOffset is Not a Number
            if (isNaN(heightOffset)) heightOffset = 0;
            update();
        }
        function changeOverflow(value) {
            // Chrome/Safari-specific fix:
            // When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
            // made available by removing the scrollbar. The following forces the necessary text reflow.
            var width = ta.style.width;
            ta.style.width = '0px';
            // Force reflow:
            /* jshint ignore:start */ ta.offsetWidth;
            /* jshint ignore:end */ ta.style.width = width;
            ta.style.overflowY = value;
        }
        function getParentOverflows(el) {
            var arr = [];
            while(el && el.parentNode && el.parentNode instanceof Element){
                if (el.parentNode.scrollTop) arr.push({
                    node: el.parentNode,
                    scrollTop: el.parentNode.scrollTop
                });
                el = el.parentNode;
            }
            return arr;
        }
        function resize() {
            if (ta.scrollHeight === 0) // If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
            return;
            var overflows = getParentOverflows(ta);
            var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)
            ta.style.height = '';
            ta.style.height = ta.scrollHeight + heightOffset + 'px';
            // used to check if an update is actually necessary on window.resize
            clientWidth = ta.clientWidth;
            // prevents scroll-position jumping
            overflows.forEach(function(el) {
                el.node.scrollTop = el.scrollTop;
            });
            if (docTop) document.documentElement.scrollTop = docTop;
        }
        function update() {
            resize();
            var styleHeight = Math.round(parseFloat(ta.style.height));
            var computed = window.getComputedStyle(ta, null);
            // Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
            var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;
            // The actual height not matching the style height (set via the resize method) indicates that 
            // the max-height has been exceeded, in which case the overflow should be allowed.
            if (actualHeight < styleHeight) {
                if (computed.overflowY === 'hidden') {
                    changeOverflow('scroll');
                    resize();
                    actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
                }
            } else // Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
            if (computed.overflowY !== 'hidden') {
                changeOverflow('hidden');
                resize();
                actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
            }
            if (cachedHeight !== actualHeight) {
                cachedHeight = actualHeight;
                var evt = createEvent('autosize:resized');
                try {
                    ta.dispatchEvent(evt);
                } catch (err) {
                // Firefox will throw an error on dispatchEvent for a detached element
                // https://bugzilla.mozilla.org/show_bug.cgi?id=889376
                }
            }
        }
        var pageResize = function pageResize() {
            if (ta.clientWidth !== clientWidth) update();
        };
        var destroy = (function(style) {
            window.removeEventListener('resize', pageResize, false);
            ta.removeEventListener('input', update, false);
            ta.removeEventListener('keyup', update, false);
            ta.removeEventListener('autosize:destroy', destroy, false);
            ta.removeEventListener('autosize:update', update, false);
            Object.keys(style).forEach(function(key) {
                ta.style[key] = style[key];
            });
            map.delete(ta);
        }).bind(ta, {
            height: ta.style.height,
            resize: ta.style.resize,
            overflowY: ta.style.overflowY,
            overflowX: ta.style.overflowX,
            wordWrap: ta.style.wordWrap
        });
        ta.addEventListener('autosize:destroy', destroy, false);
        // IE9 does not fire onpropertychange or oninput for deletions,
        // so binding to onkeyup to catch most of those events.
        // There is no way that I know of to detect something like 'cut' in IE9.
        if ('onpropertychange' in ta && 'oninput' in ta) ta.addEventListener('keyup', update, false);
        window.addEventListener('resize', pageResize, false);
        ta.addEventListener('input', update, false);
        ta.addEventListener('autosize:update', update, false);
        ta.style.overflowX = 'hidden';
        ta.style.wordWrap = 'break-word';
        map.set(ta, {
            destroy: destroy,
            update: update
        });
        init();
    }
    function destroy(ta) {
        var methods = map.get(ta);
        if (methods) methods.destroy();
    }
    function update(ta) {
        var methods = map.get(ta);
        if (methods) methods.update();
    }
    var autosize = null;
    // Do nothing in Node.js environment and IE8 (or lower)
    if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
        autosize = function autosize(el) {
            return el;
        };
        autosize.destroy = function(el) {
            return el;
        };
        autosize.update = function(el) {
            return el;
        };
    } else {
        autosize = function autosize(el, options) {
            if (el) Array.prototype.forEach.call(el.length ? el : [
                el
            ], function(x) {
                return assign(x, options);
            });
            return el;
        };
        autosize.destroy = function(el) {
            if (el) Array.prototype.forEach.call(el.length ? el : [
                el
            ], destroy);
            return el;
        };
        autosize.update = function(el) {
            if (el) Array.prototype.forEach.call(el.length ? el : [
                el
            ], update);
            return el;
        };
    }
    exports1.default = autosize;
    module1.exports = exports1['default'];
});

});

parcelRegister("38VFQ", function(module, exports) {
// Load in dependencies

var $cg9fL = parcelRequire("cg9fL");
/**
 * Calculate the `line-height` of a given node
 * @param {HTMLElement} node Element to calculate line height of. Must be in the DOM.
 * @returns {Number} `line-height` of the element in pixels
 */ function $249edb4ccaeee725$var$lineHeight(node) {
    // Grab the line-height via style
    var lnHeightStr = $cg9fL(node, 'line-height');
    var lnHeight = parseFloat(lnHeightStr, 10);
    // If the lineHeight did not contain a unit (i.e. it was numeric), convert it to ems (e.g. '2.3' === '2.3em')
    if (lnHeightStr === lnHeight + '') {
        // Save the old lineHeight style and update the em unit to the element
        var _lnHeightStyle = node.style.lineHeight;
        node.style.lineHeight = lnHeightStr + 'em';
        // Calculate the em based height
        lnHeightStr = $cg9fL(node, 'line-height');
        lnHeight = parseFloat(lnHeightStr, 10);
        // Revert the lineHeight style
        if (_lnHeightStyle) node.style.lineHeight = _lnHeightStyle;
        else delete node.style.lineHeight;
    }
    // If the lineHeight is in `pt`, convert it to pixels (4px for 3pt)
    // DEV: `em` units are converted to `pt` in IE6
    // Conversion ratio from https://developer.mozilla.org/en-US/docs/Web/CSS/length
    if (lnHeightStr.indexOf('pt') !== -1) {
        lnHeight *= 4;
        lnHeight /= 3;
    // Otherwise, if the lineHeight is in `mm`, convert it to pixels (96px for 25.4mm)
    } else if (lnHeightStr.indexOf('mm') !== -1) {
        lnHeight *= 96;
        lnHeight /= 25.4;
    // Otherwise, if the lineHeight is in `cm`, convert it to pixels (96px for 2.54cm)
    } else if (lnHeightStr.indexOf('cm') !== -1) {
        lnHeight *= 96;
        lnHeight /= 2.54;
    // Otherwise, if the lineHeight is in `in`, convert it to pixels (96px for 1in)
    } else if (lnHeightStr.indexOf('in') !== -1) lnHeight *= 96;
    else if (lnHeightStr.indexOf('pc') !== -1) lnHeight *= 16;
    // Continue our computation
    lnHeight = Math.round(lnHeight);
    // If the line-height is "normal", calculate by font-size
    if (lnHeightStr === 'normal') {
        // Create a temporary node
        var nodeName = node.nodeName;
        var _node = document.createElement(nodeName);
        _node.innerHTML = '&nbsp;';
        // If we have a text area, reset it to only 1 row
        // https://github.com/twolfson/line-height/issues/4
        if (nodeName.toUpperCase() === 'TEXTAREA') _node.setAttribute('rows', '1');
        // Set the font-size of the element
        var fontSizeStr = $cg9fL(node, 'font-size');
        _node.style.fontSize = fontSizeStr;
        // Remove default padding/border which can affect offset height
        // https://github.com/twolfson/line-height/issues/4
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetHeight
        _node.style.padding = '0px';
        _node.style.border = '0px';
        // Append it to the body
        var body = document.body;
        body.appendChild(_node);
        // Assume the line height of the element is the height
        var height = _node.offsetHeight;
        lnHeight = height;
        // Remove our child from the DOM
        body.removeChild(_node);
    }
    // Return the calculated height
    return lnHeight;
}
// Export lineHeight
module.exports = $249edb4ccaeee725$var$lineHeight;

});
parcelRegister("cg9fL", function(module, exports) {
// This code has been refactored for 140 bytes
// You can see the original here: https://github.com/twolfson/computedStyle/blob/04cd1da2e30fa45844f95f5cb1ac898e9b9ef050/lib/computedStyle.js
var $8ece282db1002d8c$var$computedStyle = function(el, prop, getComputedStyle) {
    getComputedStyle = window.getComputedStyle;
    // In one fell swoop
    return(// If we have getComputedStyle
    (getComputedStyle ? // Query it
    // TODO: From CSS-Query notes, we might need (node, null) for FF
    getComputedStyle(el) : // Otherwise, we are in IE and use currentStyle
    el.currentStyle)[// Switch to camelCase for CSSOM
    // DEV: Grabbed from jQuery
    // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
    // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
    prop.replace(/-(\w)/gi, function(word, letter) {
        return letter.toUpperCase();
    })]);
};
module.exports = $8ece282db1002d8c$var$computedStyle;

});





parcelRegister("apoJZ", function(module, exports) {

$parcel$export(module.exports, "SummaryHeading", () => $880348064fc09c61$export$a150b0d446da443);
$parcel$export(module.exports, "SummaryHeadingNew", () => $880348064fc09c61$export$2ad8fd12ac282e5e);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4lTFP = parcelRequire("4lTFP");
const $880348064fc09c61$var$headerWordWrap = {
    /* Style only for Google Chrome */ '@media screen and (-webkit-min-device-pixel-ratio: 0)': {
        wordBreak: 'break-word'
    },
    /* Style only for Safari */ '@media screen and (-webkit-transition)': {
        wordBreak: 'break-word'
    },
    /* Style only for Mozilla Firefox */ '@-moz-document url-prefix()': {
        overflowWrap: 'anywhere'
    }
};
// Hard coding H700 styles as Compiled cannot evaluate styles in typography
// because it depends on theme from a different API. Normally we would use
// import `Heading from '@atlaskit/heading'` as a workaround
// however it won't work here as it's used in `> textarea`
const $880348064fc09c61$var$summaryTextFontStyles = {
    fontSize: (0, $4lTFP).headingSizes.h700.size,
    lineHeight: `${(0, $4lTFP).headingSizes.h700.lineHeight}px`,
    fontWeight: 500,
    letterSpacing: '-0.01em'
};
const $880348064fc09c61$export$a150b0d446da443 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1tcg _vwz41f4h _k48pbfng _1dyzz5jk _1bsb1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz1fxt _osi5fg65 _mc2h1hna _14fy1hna",
            __cmplp.className
        ])
    });
});
const $880348064fc09c61$export$2ad8fd12ac282e5e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1x4e _1bsb1osq _amjj1tcg _1vsx1f4h _12ribfng _t4yyz5jk _1qnwidpf _p8o2idpf _1y5iidpf _1vbbidpf _jarm1fxt _14kw1hna _1vdp1hna _eczxfg65 _1vsx1vom _pen015vq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bp88D", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5513a6a911f6563$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f5513a6a911f6563$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    summaryTextareaLabel: {
        "id": "issue-field-summary.edit.summary-textarea-label",
        "defaultMessage": "Summary"
    }
});

});


parcelRegister("8OWdW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6275e60df7e079da$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6275e60df7e079da$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorEmpty: {
        "id": "issue-field-summary.error-empty",
        "defaultMessage": "You must specify a summary of the issue."
    },
    errorTitle: {
        "id": "issue-field-summary.error-title",
        "defaultMessage": "We couldn't update the summary"
    },
    errorMessage: {
        "id": "issue-field-summary.error-message",
        "defaultMessage": "You can try again in a few minutes, or refresh the page."
    },
    editButtonLabel: {
        "id": "issue-field-summary.edit-button-label",
        "defaultMessage": "Edit summary"
    },
    extendedEditButtonLabel: {
        "id": "issue-field-summary.extended-edit-button-label",
        "defaultMessage": "{inputFieldValue}- edit summary"
    }
});

});

parcelRegister("rDJ37", function(module, exports) {

$parcel$export(module.exports, "InlineSummaryRead", () => $2911a7c6a6584d73$export$f9ab1ba6ab2e0024);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $dG2h0 = parcelRequire("dG2h0");

var $bfvIT = parcelRequire("bfvIT");

var $cua7B = parcelRequire("cua7B");

var $iJ8Hj = parcelRequire("iJ8Hj");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $l4beU = parcelRequire("l4beU");
const $2911a7c6a6584d73$var$HOVER_CARD_FADE_IN_TIME_MS = 500;
const $2911a7c6a6584d73$export$f9ab1ba6ab2e0024 = ({ value: value, setIsEditing: setIsEditing, url: url, isEditable: isEditable, isConfigLoading: isConfigLoading, isInlineEditEnabled: isInlineEditEnabled = true, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), showHoverPreviewEnabled: showHoverPreviewEnabled = false })=>{
    const displayValue = value === null ? '' : value.toString();
    const [isHovered, setHovered] = (0, $eUqFw.useState)(false);
    const [canOpenHoverCard, setCanOpenHoverCard] = (0, $eUqFw.useState)(true);
    const [editButtonHovered, setEditButtonHovered] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleMouseEnter = (0, $eUqFw.useCallback)(()=>{
        setHovered(true);
    }, []);
    const handleMouseLeave = (0, $eUqFw.useCallback)(()=>{
        setHovered(false);
    }, []);
    const getTooltipMessage = ()=>{
        if (isConfigLoading === undefined || isConfigLoading) return '';
        return !isConfigLoading && isEditable ? formatMessage((0, $l4beU.default).editSummary) : formatMessage((0, $l4beU.default).noPermission);
    };
    const handleClick = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        // We are preventing the default behavior of the element on click event
        // So it can invoke the onClick function without changing the original behavior
        e.preventDefault();
        onClick(e);
    }, [
        onClick
    ]);
    const handleEditButtonHover = (0, $eUqFw.useCallback)(()=>{
        if (showHoverPreviewEnabled) setEditButtonHovered(true);
    }, [
        showHoverPreviewEnabled
    ]);
    const handleEditButtonLeave = (0, $eUqFw.useCallback)(()=>{
        if (showHoverPreviewEnabled) setEditButtonHovered(false);
    }, [
        showHoverPreviewEnabled
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (showHoverPreviewEnabled) {
            if (editButtonHovered) // hiding the hover card if a user hovers on edit button
            setCanOpenHoverCard(false);
            else if (!canOpenHoverCard) {
                const timeout = setTimeout(()=>{
                    // showing the hover card again after a delay if a user moves away from the edit button
                    setCanOpenHoverCard(true);
                }, $2911a7c6a6584d73$var$HOVER_CARD_FADE_IN_TIME_MS);
                return ()=>clearTimeout(timeout);
            }
        }
        // to satisfy consistent return rule
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        canOpenHoverCard,
        showHoverPreviewEnabled,
        editButtonHovered
    ]);
    const editButtonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: getTooltipMessage()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "issue-field-summary.ui.inline-read.edit-button",
        onClick: (e)=>{
            e.stopPropagation();
            // We are preventing the default behavior of the element on click event
            // So preventing the link item's navigation-on-click behaviour from mucking around with the inline edit behaviour.
            e.preventDefault();
            handleMouseLeave();
            isEditable && setIsEditing && setIsEditing(true);
        },
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dG2h0))), {
            size: "medium",
            label: formatMessage((0, $l4beU.default).editSummary),
            primaryColor: !isEditable ? `var(--ds-icon-subtle, ${(0, $PdmhA).N60})` : undefined
        }),
        appearance: isConfigLoading === undefined || isConfigLoading || !isEditable ? 'link' : 'subtle',
        onBlur: handleMouseLeave,
        interactionName: "auto-generated.issue-field-summary.ui.inline-read.edit-button.button"
    }));
    const editButton = showHoverPreviewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        onMouseEnter: handleEditButtonHover,
        onMouseLeave: handleEditButtonLeave
    }, editButtonContent) : editButtonContent;
    const linkItemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bfvIT.default), {
        href: url,
        testId: "issue-field-summary.ui.inline-read.link-item",
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
        cssFn: $2911a7c6a6584d73$export$e514e5ca8a889bf1,
        onClick: handleClick,
        // @ts-expect-error - TS2322 - Type '{ children: string; href: string | undefined; testId: string; cssFn: CSSFn; onClick: (e: any) => void; onMouseOver: () => void; onMouseLeave: () => void; onFocus: () => void; iconAfter: false | Element; tabIndex: string; }' is not assignable to type 'IntrinsicAttributes & LinkItemProps & RefAttributes<HTMLElement>'.
        onMouseOver: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleMouseEnter,
        iconAfter: isInlineEditEnabled && isHovered && editButton,
        tabIndex: "0"
    }, displayValue);
    if (showHoverPreviewEnabled) {
        const issueLink = url?.startsWith('/') ? `${window.location.protocol}//${window.location.hostname}${url}` : url;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJ8Hj.StandaloneHoverCard), {
            url: issueLink || '',
            canOpen: canOpenHoverCard,
            closeOnChildClick: true,
            actionOptions: {
                hide: false,
                exclude: [
                    (0, $cua7B.CardAction).ChangeStatusAction
                ]
            }
        }, linkItemContent);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: displayValue,
        position: "bottom",
        hideTooltipOnMouseDown: true
    }, linkItemContent);
};
const $2911a7c6a6584d73$export$e514e5ca8a889bf1 = (currentStyles)=>({
        ...currentStyles,
        display: 'flex',
        padding: `0 0 1px ${"var(--ds-space-075, 6px)"}`,
        backgroundColor: 'transparent',
        borderTop: '2px solid transparent',
        borderBottom: '2px solid transparent',
        borderLeft: '2px solid transparent',
        borderRight: 'none',
        color: `var(--ds-text, ${(0, $PdmhA).N800})`,
        '&:hover': {
            color: `var(--ds-text, ${(0, $PdmhA).N800})`,
            backgroundColor: 'transparent',
            cursor: 'pointer',
            textDecoration: 'underline'
        },
        '&:focus, &:active': {
            color: `var(--ds-text, ${(0, $PdmhA).N800})`,
            outline: 'none',
            boxShadow: 'none',
            backgroundColor: 'transparent'
        },
        '& [data-item-elem-after]': {
            opacity: '1'
        },
        '& span': {
            flexGrow: 0
        },
        '&[aria-disabled="true"]': {
            cursor: 'not-allowed',
            backgroundColor: 'transparent!important',
            textDecoration: 'none'
        },
        '& [data-item-title]:hover': {
            textDecoration: 'underline'
        },
        '& button': {
            height: '24px',
            width: '24px'
        }
    });

});
parcelRegister("bfvIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5c0ed5cace4346a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bo4OB = parcelRequire("bo4OB");

var $jvM56 = parcelRequire("jvM56");

var $cgrgx = parcelRequire("cgrgx");
/**
 * __Link item__
 *
 * Renders an item wrapped in an anchor tag, useful when you have an item that
 * should change routes using native browser navigation. For SPA transitions use
 * a [custom item](https://atlassian.design/components/side-navigation/examples#custom-item)
 * with the respective router logic.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#link-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $b5c0ed5cace4346a$var$LinkItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, href: href, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $jvM56.overrideStyleFunction)((0, $jvM56.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        ref: ref,
        cssFn: cssOverride,
        href: href,
        ...rest
    });
});
var $b5c0ed5cace4346a$export$2e2bcd8739ae039 = $b5c0ed5cace4346a$var$LinkItem;

});
parcelRegister("jvM56", function(module, exports) {

$parcel$export(module.exports, "overrideStyleFunction", () => $451539d16e759684$export$505cedac1a39aacf);
$parcel$export(module.exports, "baseSideNavItemStyle", () => $451539d16e759684$export$aed216a85ec468ac);
$parcel$export(module.exports, "sectionHeaderSpacingStyles", () => $451539d16e759684$export$a5c27bed78cfecb9);

var $PdmhA = parcelRequire("PdmhA");
const $451539d16e759684$export$505cedac1a39aacf = (baseStyle, newStyle = ()=>({}))=>{
    return (state)=>{
        return [
            baseStyle(state),
            newStyle(state)
        ];
    };
};
const $451539d16e759684$var$defaultStyles = {
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`,
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $PdmhA.N30)})`
    },
    '&:active': {
        color: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
        backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $PdmhA.B50)})`
    }
};
const $451539d16e759684$var$selectedStyles = {
    backgroundColor: `var(--ds-background-selected, ${(0, $PdmhA.N30)})`,
    color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
    ':visited': {
        color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${(0, $PdmhA.N30)})`,
        color: `var(--ds-text-selected, ${(0, $PdmhA.N500)})`
    },
    '&:active': {
        backgroundColor: `var(--ds-background-selected-pressed, ${(0, $PdmhA.B50)})`,
        color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`
    }
};
const $451539d16e759684$export$aed216a85ec468ac = ({ isSelected: isSelected, isDisabled: isDisabled })=>{
    return {
        // This padding is set to ensure that the center of the left icon
        // is approximately center aligned with the horizontal app switcher.
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-100, 8px)",
        borderRadius: "var(--ds-border-radius, 3px)",
        // -- TODO: DELETE THESE COLOR OVERRIDES WHEN CLEANING UP FALLBACK THEMING --
        // Menu and side navigation are now color aligned so they do not need this!
        // See: https://product-fabric.atlassian.net/browse/DSP-1684
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        ...!isDisabled && !isSelected && $451539d16e759684$var$defaultStyles,
        ...!isDisabled && isSelected && $451539d16e759684$var$selectedStyles,
        // -- END TODO --------------------------------------------------------------
        ['& [data-item-elem-before]']: {
            height: '1.5rem',
            width: '1.5rem'
        }
    };
};
const $451539d16e759684$export$a5c27bed78cfecb9 = ()=>{
    return {
        paddingInline: "var(--ds-space-100, 8px)"
    };
};

});

parcelRegister("cgrgx", function(module, exports) {

$parcel$export(module.exports, "NestedContext", () => $859a6debe363fd1f$export$46b2c2071c8c725a);
$parcel$export(module.exports, "useNestedContext", () => $859a6debe363fd1f$export$f24166abe9ed712b);
$parcel$export(module.exports, "useShouldNestedElementRender", () => $859a6debe363fd1f$export$37e8646a1abfc3e6);

var $eUqFw = parcelRequire("eUqFw");
const $859a6debe363fd1f$export$46b2c2071c8c725a = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $859a6debe363fd1f$export$f24166abe9ed712b = ()=>{
    const context = (0, $eUqFw.useContext)($859a6debe363fd1f$export$46b2c2071c8c725a);
    if (!context) {
        let error = '';
        throw new Error(error);
    }
    return context;
};
const $859a6debe363fd1f$export$37e8646a1abfc3e6 = ()=>{
    const context = (0, $eUqFw.useContext)($859a6debe363fd1f$export$46b2c2071c8c725a);
    if (!context) return {
        shouldRender: true
    };
    return {
        shouldRender: context.currentStackId === context.parentId
    };
};

});


parcelRegister("iJ8Hj", function(module, exports) {

$parcel$export(module.exports, "HoverCard", () => $da232d21eb6fc92b$export$57a077cc9fbe653e);
$parcel$export(module.exports, "StandaloneHoverCard", () => $da232d21eb6fc92b$export$f1f63acbe6ed8fb0);
/** @jsx jsx */ 
var $2jDha = parcelRequire("2jDha");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $jb3WS = parcelRequire("jb3WS");

var $kxPGe = parcelRequire("kxPGe");

var $d9XpQ = parcelRequire("d9XpQ");

var $hXWLE = parcelRequire("hXWLE");

const $da232d21eb6fc92b$var$HoverCardWithErrorBoundary = (props)=>{
    const { url: url, id: id, children: children } = props;
    const analytics = (0, $kxPGe.useSmartLinkAnalytics)(url, undefined, id);
    const onError = (0, $eUqFw.useCallback)((error, info)=>{
        analytics.ui.renderFailedEvent({
            display: (0, $hXWLE.CardDisplay).HoverCardPreview,
            id: id,
            error: error,
            errorInfo: info
        });
    }, [
        analytics.ui,
        id
    ]);
    return (0, $byn9U.jsx)((0, $jb3WS.ErrorBoundary), {
        fallback: children,
        onError: onError
    }, (0, $byn9U.jsx)((0, $d9XpQ.HoverCardComponent), props, children));
};
const $da232d21eb6fc92b$var$HoverCardWithoutAnalyticsContext = (0, $2jDha.default)()($da232d21eb6fc92b$var$HoverCardWithErrorBoundary);
const $da232d21eb6fc92b$export$57a077cc9fbe653e = (props)=>{
    return (0, $byn9U.jsx)($da232d21eb6fc92b$var$HoverCardWithoutAnalyticsContext, props);
};
const $da232d21eb6fc92b$export$f1f63acbe6ed8fb0 = (props)=>(0, $byn9U.jsx)($da232d21eb6fc92b$export$57a077cc9fbe653e, props);

});
parcelRegister("jb3WS", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("eUqFw")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("kxPGe", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalytics", () => $ef4efa4ca5d5173b$export$57c7fece972c9472);

var $eUqFw = parcelRequire("eUqFw");

var $cGAGh = parcelRequire("cGAGh");

var $iDnwt = parcelRequire("iDnwt");
var $clDXS = parcelRequire("clDXS");

var $fN0cF = parcelRequire("fN0cF");

var $akLqG = parcelRequire("akLqG");

var $gqldc = parcelRequire("gqldc");

var $iDnwt = parcelRequire("iDnwt");

var $eRE2O = parcelRequire("eRE2O");
const $ef4efa4ca5d5173b$var$applyCommonAttributes = (event, commonAttributes)=>{
    if (event && event.attributes) {
        for (const [key, value] of Object.entries(commonAttributes))if (event.attributes[key] === undefined) event.attributes[key] = value;
    }
    return event;
};
const $ef4efa4ca5d5173b$export$57c7fece972c9472 = (url, _dispatchAnalytics, id, defaultLocation)=>{
    const { dispatchAnalytics: dispatchAnalytics } = (0, $eRE2O.useDispatchAnalytics)(_dispatchAnalytics);
    const defaultId = id || 'NULL';
    // We don't want to trigger a re-render by using useSmartCardState
    const { store: store } = (0, $gqldc.useSmartLinkContext)();
    const state = store ? (0, $cGAGh.getUrl)(store, url) : undefined;
    const details = state ? state.details : undefined;
    const extractedDefinitionId = (0, $akLqG.getDefinitionId)(details);
    const extractedExtensionKey = (0, $akLqG.getExtensionKey)(details);
    const extractedResourceType = (0, $akLqG.getResourceType)(details);
    const extractedSubproduct = (0, $akLqG.getSubproduct)(details);
    const extractedProduct = (0, $akLqG.getProduct)(details);
    const extractedStatusDetails = (0, $akLqG.getStatusDetails)(details);
    const commonAttributes = (0, $eUqFw.useMemo)(()=>({
            id: defaultId,
            definitionId: extractedDefinitionId,
            extensionKey: extractedExtensionKey,
            resourceType: extractedResourceType,
            destinationObjectType: extractedResourceType,
            destinationSubproduct: extractedSubproduct,
            destinationProduct: extractedProduct,
            location: defaultLocation,
            statusDetails: extractedStatusDetails
        }), [
        defaultId,
        extractedDefinitionId,
        extractedExtensionKey,
        extractedResourceType,
        extractedSubproduct,
        extractedProduct,
        defaultLocation,
        extractedStatusDetails
    ]);
    /** Contains all ui analytics events */ const ui = (0, $eUqFw.useMemo)(()=>({
            /**
     * This fires an event that represents when a user clicks on the authentication
     * call to action with no current authenticated account. (i.e. Connect to Preview).
     * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
     * @param definitionId The definitionId of the Smart Link resolver invoked.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @returns
     */ authEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiAuthEvent)({
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
     * This fires an event that represents when a user clicks on the authentication
     * call to action with a forbidden authenticated account. (i.e. Try another account).
     * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
     * @param definitionId The definitionId of the Smart Link resolver invoked.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @returns
     */ authAlternateAccountEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiAuthAlternateAccountEvent)({
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
     * This fires an event that represents when a user
     * click a button.
     * @param data A partial analytics event payload
     */ buttonClickedEvent: (data)=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: data.actionSubjectId,
                    attributes: {
                        ...(0, $iDnwt.context),
                        ...data.attributes
                    },
                    eventType: 'ui'
                }, commonAttributes)),
            /**
     * This fires an event that represents when a user clicks on a Smart Link.
     * @param id The unique ID for this Smart Link.
     * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
     * @param status What status the Smart Link is currently in (e.g. resolved, unresolved)
     * @param definitionId The definitionId of the Smart Link resolver invoked.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @param isModifierKeyPressed Whether a modifier key was pressed when clicking the Smart Link.
     * @param location Where the Smart Link is currently rendered.
     * @param destinationProduct The product the Smart Link is linked to.
     * @returns
     */ cardClickedEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiCardClickedEvent)({
                    id: id,
                    display: display,
                    status: status,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    isModifierKeyPressed: isModifierKeyPressed,
                    location: location,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    actionSubjectId: actionSubjectId
                }), commonAttributes)),
            /**
     * This fires an event that represents when a user dwells their cursor on a Smart Link's iframe.
     * @param id The unique ID for this Smart Link.
     * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
     * @param status What status the Smart Link is currently in (e.g. resolved, unresolved)
     * @param definitionId The definitionId of the Smart Link resolver invoked.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @param location Where the Smart Link is currently rendered.
     * @param destinationProduct The product the Smart Link is linked to.
     * @param dwellTime Total seconds that the user has dwelled on this iframe
     * @param dwellPercentVisible Percentage element was visible at end of dwell
     * @returns
     */ iframeDwelledEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, dwellTime: dwellTime, dwellPercentVisible: dwellPercentVisible })=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiIframeDwelledEvent)({
                    id: id,
                    display: display,
                    status: status,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    location: location,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    dwellTime: dwellTime,
                    dwellPercentVisible: dwellPercentVisible
                }), commonAttributes)),
            /**
     * This fires an event that represents when a user clicks or tabs into a Smart Link's iframe.
     * @param id The unique ID for this Smart Link.
     * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
     * @param status What status the Smart Link is currently in (e.g. resolved, unresolved)
     * @param definitionId The definitionId of the Smart Link resolver invoked.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @param location Where the Smart Link is currently rendered.
     * @param destinationProduct The product the Smart Link is linked to.
     * @returns
     */ iframeFocusedEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct })=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiIframeFocusedEvent)({
                    id: id,
                    display: display,
                    status: status,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    location: location,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct
                }), commonAttributes)),
            /**
     * This fires an event that represents when a user clicks on a Smart Link action.
     * Note: This also starts the UFO smart-link-action-invocation experience.
     * @param id The unique ID for this Smart Link.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @param actionType The type of the action that was clicked, e.g. PreviewAction
     * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
     * @param invokeType @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2681 Internal documentation for deprecation (no external access)}
     * @returns
     */ actionClickedEvent: ({ id: id, actionType: actionType, display: display, extensionKey: overrideExtensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const extensionKey = overrideExtensionKey !== null && overrideExtensionKey !== void 0 ? overrideExtensionKey : extractedExtensionKey;
                dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiActionClickedEvent)({
                    id: id !== null && id !== void 0 ? id : defaultId,
                    actionType: actionType,
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
     * This fires an event that represents when a user clicks on a hover preview's "navigate to link" button.
     * https://product-fabric.atlassian.net/wiki/spaces/EM/pages/3206743323/Analytics+Metrics+-+Hover+Previews
     * @param previewDisplay What format the preview is in.
     * @param definitionId The definitionId of the Smart Link resolver invoked.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @param previewInvokeMethod How the preview was triggered.
     */ hoverCardOpenLinkClickedEvent: ({ previewDisplay: previewDisplay, definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>{
                dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiHoverCardOpenLinkClickedEvent)({
                    id: defaultId,
                    previewDisplay: previewDisplay,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    previewInvokeMethod: previewInvokeMethod
                }), commonAttributes));
            },
            /**
     * This fires an event that represents when a user closed the authentication window without authenticating after opening it.
     * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
     * @param definitionId The definitionId of the Smart Link resolver invoked.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @returns
     */ closedAuthEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiClosedAuthEvent)({
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
     * This fires an event that represents when a user close a modal.
     * @param data A partial analytics event payload
     */ modalClosedEvent: (data)=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes({
                    action: 'closed',
                    actionSubject: 'modal',
                    actionSubjectId: data.actionSubjectId,
                    attributes: {
                        ...(0, $iDnwt.context),
                        ...data.attributes
                    },
                    eventType: 'ui'
                }, commonAttributes)),
            /**
     * This fires an event that represents when a Smart Link was rendered successfully.
     * Note: this fires even if the Smart Link request errored out.
     * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
     * @param id The unique ID for this Smart Link.
     * @param definitionId The definitionId of the Smart Link resolver invoked.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @param canBeDatasource An indicator that shows that a smart link can be converted to a datasource
     */ renderSuccessEvent: ({ display: display, status: status, id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource = false })=>{
                const experienceId = id ? id : defaultId;
                (0, $fN0cF.succeedUfoExperience)('smart-link-rendered', experienceId, {
                    extensionKey: extensionKey,
                    display: display
                });
                // UFO will disregard this if authentication experience has not yet been started
                (0, $fN0cF.succeedUfoExperience)('smart-link-authenticated', experienceId, {
                    display: display
                });
                dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiRenderSuccessEvent)({
                    display: display,
                    status: status,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    canBeDatasource: canBeDatasource
                }), commonAttributes));
            },
            /**
     * This fires an event that represents when a Smart Link renders unsuccessfuly.
     * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
     * @param id The unique ID for this Smart Link.
     * @param error: An error representing why the Smart Link render failed.
     * @param errorInfo: Additional details about the error including the stack trace.
     */ renderFailedEvent: ({ display: display, id: id, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const experienceId = id ? id : defaultId;
                // Start and fail the smart-link-rendered experience. If it has already
                // been started nothing happens.
                (0, $fN0cF.startUfoExperience)('smart-link-rendered', experienceId);
                (0, $fN0cF.failUfoExperience)('smart-link-rendered', experienceId);
                (0, $fN0cF.failUfoExperience)('smart-link-authenticated', experienceId);
                dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiRenderFailedEvent)({
                    display: display,
                    error: error,
                    errorInfo: errorInfo,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
     * This fires an event that represents a hover preview being opened.
     * @param hoverDisplay Whether the hover preview was displayed as a card or embed.
     * @param definitionId The definitionId of the Smart Link resolver invoked.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @param previewInvokeMethod How the preview was triggered.
     * @returns
     */ hoverCardViewedEvent: ({ previewDisplay: previewDisplay, previewInvokeMethod: previewInvokeMethod, id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, status: status })=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiHoverCardViewedEvent)({
                    id: id,
                    previewDisplay: previewDisplay,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    previewInvokeMethod: previewInvokeMethod,
                    status: status
                }), commonAttributes)),
            /**
     * This fires an event that represents a hover preview being dismissed.
     * @param hoverDisplay Whether the hover preview was displayed as a card or embed.
     * @param hoverTime The duration that the user hovered over a Smart Link before the preview was dismissed.
     * @param definitionId The definitionId of the Smart Link resolver invoked.
     * @param extensionKey The extensionKey of the Smart Link resolver invoked.
     * @param previewInvokeMethod How the preview was triggered.
     * @returns
     */ hoverCardDismissedEvent: ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, previewInvokeMethod: previewInvokeMethod, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, status: status })=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiHoverCardDismissedEvent)({
                    previewDisplay: previewDisplay,
                    id: id,
                    hoverTime: hoverTime,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    previewInvokeMethod: previewInvokeMethod,
                    status: status
                }), commonAttributes)),
            /**
     * Fires an event that signifies that a "Learn More" link was clicked on an unauthenticated card
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @param location The location where a link is displayed (jiraWebLinks, confluencePages etc)
     */ learnMoreClickedEvent: ()=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiLearnMoreLinkClickedEvent)(), commonAttributes)),
            /**
     * Fires an event that represent a click was performed on a Status Lozenge
     */ smartLinkLozengeActionClickedEvent: ()=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiSmartLinkStatusLozengeButtonClicked)(), commonAttributes)),
            /**
     * Fires an event that represent a click was performed on a Status Lozenge's dropdown item
     */ smartLinkLozengeActionListItemClickedEvent: ()=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiSmartLinkStatusListItemButtonClicked)(), commonAttributes)),
            /**
     * Fires an event that represent a click was performed on a Status Lozenge open preview button
     */ smartLinkLozengeActionErrorOpenPreviewClickedEvent: ()=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiSmartLinkStatusOpenPreviewButtonClicked)(), commonAttributes)),
            smartLinkServerActionClickedEvent: (props)=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.uiServerActionClicked)(props), commonAttributes))
        }), [
        dispatchAnalytics,
        commonAttributes,
        defaultId,
        extractedExtensionKey
    ]);
    /** Contains all operational analytics events */ const operational = (0, $eUqFw.useMemo)(()=>({
            /**
     * This fires an event that represents an action being successfully invoked.
     * @param id The unique ID for this Smart Link.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @param actionType The type of action invoked, e.g. PreviewAction
     * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
     */ invokeSucceededEvent: ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.invokeSucceededEvent)({
                    id: id !== null && id !== void 0 ? id : defaultId,
                    actionType: actionType,
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
     * This fires an event that represents an action being unsuccessfully invoked.
     * @param id The unique ID for this Smart Link.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @param actionType The type of action invoked, e.g. PreviewAction
     * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
     * @param reason The reason the invocation failed.
     */ invokeFailedEvent: ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.invokeFailedEvent)({
                    id: id !== null && id !== void 0 ? id : defaultId,
                    actionType: actionType,
                    display: display,
                    reason: reason,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
     * This fires an event that represents an account successfully being connected via a Smart Link.
     * @param id The unique ID for this Smart Link.
     * @param definitionId The definitionId of the Smart Link resolver invoked.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     */ connectSucceededEvent: ({ id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const experienceId = id ? id : defaultId;
                (0, $fN0cF.startUfoExperience)('smart-link-authenticated', experienceId, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.connectSucceededEvent)({
                    ...commonAttributes,
                    id: experienceId,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
     * This fires an event that represents an account unsuccessfully being connected.
     * @param id The unique ID for this Smart Link.
     * @param definitionId The definitionId of the Smart Link resolver invoked.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @param reason The reason why the Smart Link connect account failed.
     */ connectFailedEvent: ({ id: id, reason: reason, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const experienceId = id ? id : defaultId;
                (0, $fN0cF.startUfoExperience)('smart-link-authenticated', experienceId, {
                    extensionKey: extensionKey,
                    status: reason
                });
                dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.connectFailedEvent)({
                    ...commonAttributes,
                    id: experienceId,
                    reason: reason,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
     * This fires an event which represents a Smart Link request succeeding or failing based on the status.
     * @param id The unique ID for this Smart Link.
     * @param status The status of the Smart Link.
     * @param definitionId The definitionId of the Smart Link resolver invoked.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @param resourceType The type of resource that was invoked. This is provider specific (e.g. File, PullRequest).
     * @param error An error representing why the Smart Link request failed.
     */ instrument: ({ id: id, status: status, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, error: error })=>{
                const event = (0, $clDXS.instrumentEvent)({
                    ...commonAttributes,
                    id: id,
                    status: status,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    error: error
                });
                if (event) dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes(event, commonAttributes));
            },
            /**
     * This fires an event that represents when a Smart Link renders unsuccessfuly.
     * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
     * @param id The unique ID for this Smart Link.
     * @param error: An error representing why the Smart Link render failed.
     * @param errorInfo: Additional details about the error including the stack trace.
     */ chunkloadFailedEvent: ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.chunkloadFailedEvent)({
                    display: display,
                    error: error,
                    errorInfo: errorInfo,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            }
        }), [
        defaultId,
        commonAttributes,
        dispatchAnalytics
    ]);
    /** Contains all track analytics events */ const track = (0, $eUqFw.useMemo)(()=>({
            /**
     * This fires an event which represents a user connecting their account to view a Smart Link.
     * @param definitionId The definitionId of the Smart Link resolver invoked.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @returns
     */ appAccountConnected: ({ extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.trackAppAccountConnected)({
                    ...commonAttributes,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
     * This fires an event which represents a user starting the Smart Link connect account process.
     * @param location a location where the Smart Link auth action was initiated.
     * @param extensionKey The extensionKey of the Smart Link resolver invoked.
     * @returns
     */ appAccountAuthStarted: ({ extensionKey: extensionKey, location: location })=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.trackAppAccountAuthStarted)({
                    ...commonAttributes,
                    extensionKey: extensionKey,
                    location: location
                }), commonAttributes)),
            /**
     * Removed in EDM-5153: This is an even from an experiment.
     * @deprecated
     */ linkUpdated: ()=>{},
            /**
     * This fires a tracking event before an action invoke api call is made
     */ smartLinkQuickActionStarted: (props)=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.trackSmartLinkQuickActionStarted)({
                    ...commonAttributes,
                    ...props
                }), commonAttributes)),
            /**
     * This fires a tracking event after an action invoke api call is successful
     */ smartLinkQuickActionSuccess: (props)=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.trackSmartLinkQuickActionSuccess)({
                    ...commonAttributes,
                    ...props
                }), commonAttributes)),
            /**
     * This fires a tracking event after an action invoke api call has failed
     */ smartLinkQuickActionFailed: (props)=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.trackSmartLinkQuickActionFailed)({
                    ...commonAttributes,
                    ...props
                }), commonAttributes)),
            /**
     * Fires a track event when we call loadMetadata() to get information for a hover card
     */ hoverCardResolutionStarted: ()=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.trackHoverCardResolutionStarted)({
                    display: 'hoverCardPreview',
                    ...commonAttributes
                }), commonAttributes))
        }), [
        commonAttributes,
        dispatchAnalytics
    ]);
    /** Contains all screen analytics events */ const screen = (0, $eUqFw.useMemo)(()=>({
            /**
     * This fires an event which represents the connect account page being opened.
     * @param definitionId The definitionId of the Smart Link resolver invoked.
     * @param extensionKey The extensionKey of the Smart Link resovler invoked.
     * @returns
     */ authPopupEvent: ({ extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes((0, $iDnwt.screenAuthPopupEvent)({
                    ...commonAttributes,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
     * This fires an event that represents when a user view a modal.
     * @param data A partial analytics event payload
     */ modalViewedEvent: (data)=>dispatchAnalytics($ef4efa4ca5d5173b$var$applyCommonAttributes({
                    action: 'viewed',
                    actionSubject: data.name,
                    attributes: {
                        ...(0, $iDnwt.context),
                        ...data.attributes
                    },
                    eventType: 'screen',
                    name: data.name
                }, commonAttributes))
        }), [
        commonAttributes,
        dispatchAnalytics
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            ui: ui,
            operational: operational,
            track: track,
            screen: screen
        }), [
        ui,
        operational,
        track,
        screen
    ]);
};

});
parcelRegister("clDXS", function(module, exports) {

$parcel$export(module.exports, "instrumentEvent", () => $8fd6725eb9a7dc93$export$860cf9c079ed505);

var $aSzRC = parcelRequire("aSzRC");

var $iDnwt = parcelRequire("iDnwt");
const $8fd6725eb9a7dc93$export$860cf9c079ed505 = ({ id: id, status: status, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, error: error })=>{
    const measure = (0, $aSzRC.getMeasure)(id, status) || {
        duration: undefined
    };
    if (status === 'resolved') {
        const event = (0, $iDnwt.resolvedEvent)({
            id: id,
            extensionKey: extensionKey,
            definitionId: definitionId,
            resourceType: resourceType,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        });
        return {
            ...event,
            attributes: {
                ...event.attributes,
                duration: measure.duration
            }
        };
    } else if ((error === null || error === void 0 ? void 0 : error.type) !== 'ResolveUnsupportedError') {
        const event = (0, $iDnwt.unresolvedEvent)({
            id: id,
            status: status,
            extensionKey: extensionKey,
            definitionId: definitionId,
            resourceType: resourceType,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            error: error
        });
        return {
            ...event,
            attributes: {
                ...event.attributes,
                duration: measure.duration
            }
        };
    }
};

});

parcelRegister("fN0cF", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $b7eb96ffb70622f4$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $b7eb96ffb70622f4$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $b7eb96ffb70622f4$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $b7eb96ffb70622f4$export$4084c0df4a03a6af);

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
const $b7eb96ffb70622f4$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $3yYXq.ExperienceTypes).Experience,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
};
const $b7eb96ffb70622f4$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $3yYXq.ExperienceTypes).Load,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad
};
const $b7eb96ffb70622f4$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $3yYXq.ExperienceTypes).Experience,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
};
const $b7eb96ffb70622f4$var$ufoExperiences = {
    'smart-link-rendered': new (0, $2kFUE.ConcurrentExperience)('smart-link-rendered', $b7eb96ffb70622f4$var$renderExperience),
    'smart-link-authenticated': new (0, $2kFUE.ConcurrentExperience)('smart-link-authenticated', $b7eb96ffb70622f4$var$inlineExperience),
    'smart-link-action-invocation': new (0, $2kFUE.ConcurrentExperience)('smart-link-action-invocation', $b7eb96ffb70622f4$var$inlineExperience),
    'smart-link-ai-summary': new (0, $2kFUE.ConcurrentExperience)('smart-link-ai-summary', $b7eb96ffb70622f4$var$aiExperience)
};
const $b7eb96ffb70622f4$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $b7eb96ffb70622f4$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $b7eb96ffb70622f4$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $b7eb96ffb70622f4$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $b7eb96ffb70622f4$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $b7eb96ffb70622f4$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $b7eb96ffb70622f4$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $b7eb96ffb70622f4$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("akLqG", function(module, exports) {

$parcel$export(module.exports, "getByDefinitionId", () => $7860902502c8db2e$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $7860902502c8db2e$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $7860902502c8db2e$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $7860902502c8db2e$export$218d96312e385949);
$parcel$export(module.exports, "getResourceType", () => $7860902502c8db2e$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getProduct", () => $7860902502c8db2e$export$e2005c9600188ac7);
$parcel$export(module.exports, "getSubproduct", () => $7860902502c8db2e$export$f8fdefc70357968e);
$parcel$export(module.exports, "getServices", () => $7860902502c8db2e$export$a009e3a1163d46fb);
$parcel$export(module.exports, "getStatusDetails", () => $7860902502c8db2e$export$a752a116d184ffbd);
$parcel$export(module.exports, "isFinalState", () => $7860902502c8db2e$export$d590d08942abc17a);
$parcel$export(module.exports, "getCanBeDatasource", () => $7860902502c8db2e$export$ba6d13ab7b87c55c);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $7860902502c8db2e$export$3f9446bb21b945a0);

var $1bNmR = parcelRequire("1bNmR");
const $7860902502c8db2e$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $7860902502c8db2e$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $1bNmR.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $7860902502c8db2e$export$46fa3e7718c82e41 = (details)=>{
    var _details$meta;
    return details === null || details === void 0 ? void 0 : (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.definitionId;
};
const $7860902502c8db2e$export$218d96312e385949 = (details)=>{
    var _details$meta2;
    return details === null || details === void 0 ? void 0 : (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key;
};
const $7860902502c8db2e$export$16c0ebb0de9b767b = (details)=>{
    var _details$meta3;
    return details === null || details === void 0 ? void 0 : (_details$meta3 = details.meta) === null || _details$meta3 === void 0 ? void 0 : _details$meta3.resourceType;
};
const $7860902502c8db2e$export$e2005c9600188ac7 = (details)=>{
    var _details$meta4;
    return details === null || details === void 0 ? void 0 : (_details$meta4 = details.meta) === null || _details$meta4 === void 0 ? void 0 : _details$meta4.product;
};
const $7860902502c8db2e$export$f8fdefc70357968e = (details)=>{
    var _details$meta5;
    return details === null || details === void 0 ? void 0 : (_details$meta5 = details.meta) === null || _details$meta5 === void 0 ? void 0 : _details$meta5.subproduct;
};
const $7860902502c8db2e$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $7860902502c8db2e$export$ac5d414b1ebfab5a = (details)=>details && $7860902502c8db2e$export$cd41ae544cfc2a65(details) && $7860902502c8db2e$export$795910f5f15a9633(details);
const $7860902502c8db2e$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $7860902502c8db2e$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $7860902502c8db2e$export$a752a116d184ffbd = (details)=>{
    var _details$meta6, _details$meta6$reques;
    return details === null || details === void 0 ? void 0 : (_details$meta6 = details.meta) === null || _details$meta6 === void 0 ? void 0 : (_details$meta6$reques = _details$meta6.requestAccess) === null || _details$meta6$reques === void 0 ? void 0 : _details$meta6$reques.accessType;
};
const $7860902502c8db2e$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $7860902502c8db2e$export$66805b16d2a1da7c = (details)=>details === null || details === void 0 ? void 0 : details.datasources;
const $7860902502c8db2e$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $7860902502c8db2e$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $7860902502c8db2e$export$3f9446bb21b945a0 = (details)=>!!(details !== null && details !== void 0 && details.meta.hasScopeOverrides);

});
parcelRegister("1bNmR", function(module, exports) {

$parcel$export(module.exports, "extractVisitUrl", () => $0ddd1cf002863c8b$export$c81497d3681f24f4);
const $0ddd1cf002863c8b$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});


parcelRegister("eRE2O", function(module, exports) {

$parcel$export(module.exports, "useDispatchAnalytics", () => $ad2513e9092a6970$export$5f37699fba0ba807);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $iDnwt = parcelRequire("iDnwt");
const $ad2513e9092a6970$export$5f37699fba0ba807 = (handler)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return {
        dispatchAnalytics: (0, $eUqFw.useMemo)(()=>{
            if (handler) return handler;
            return (payload)=>{
                createAnalyticsEvent(payload).fire((0, $iDnwt.ANALYTICS_CHANNEL));
            };
        }, [
            handler,
            createAnalyticsEvent
        ])
    };
};

});


parcelRegister("d9XpQ", function(module, exports) {

$parcel$export(module.exports, "HoverCardComponent", () => $994a3466a42c6dde$export$e2173dafa6a751bb);

var $kU09D = parcelRequire("kU09D");

var $3MV1G = parcelRequire("3MV1G");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $i8JdB = parcelRequire("i8JdB");

var $1hIp9 = parcelRequire("1hIp9");

var $fMym1 = parcelRequire("fMym1");

var $i7Kae = parcelRequire("i7Kae");

var $fiZFb = parcelRequire("fiZFb");

var $8xp05 = parcelRequire("8xp05");

var $hXWLE = parcelRequire("hXWLE");

var $kYGK0 = parcelRequire("kYGK0");

var $hBQ92 = parcelRequire("hBQ92");

var $7o9uG = parcelRequire("7o9uG");

var $kxPGe = parcelRequire("kxPGe");
const $994a3466a42c6dde$var$HOVER_CARD_SOURCE = 'smartLinkPreviewHoverCard';
const $994a3466a42c6dde$var$FADE_IN_DELAY = 500;
const $994a3466a42c6dde$var$FADE_OUT_DELAY = 300;
const $994a3466a42c6dde$var$RESOLVE_DELAY = 100;
const $994a3466a42c6dde$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', analyticsHandler: analyticsHandler, canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, hidePreviewButton: hidePreviewButton = false, showServerActions: showServerActions, actionOptions: actionOptionsProp, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $8xp05.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false })=>{
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(false);
    const fadeOutTimeoutId = (0, $eUqFw.useRef)();
    const fadeInTimeoutId = (0, $eUqFw.useRef)();
    const resolveTimeOutId = (0, $eUqFw.useRef)();
    const mousePos = (0, $eUqFw.useRef)();
    const popupOffset = (0, $eUqFw.useRef)();
    const parentSpan = (0, $eUqFw.useRef)(null);
    const renderers = (0, $1hIp9.useSmartLinkRenderers)();
    const linkState = (0, $fMym1.useSmartCardState)(url);
    const analytics = (0, $kxPGe.useSmartLinkAnalytics)(url, undefined, id);
    const { loadMetadata: loadMetadata } = (0, $7o9uG.useSmartCardActions)(id, url, analytics);
    const actionOptions = (0, $hBQ92.combineActionOptions)(actionOptionsProp, showServerActions);
    const setMousePosition = (0, $eUqFw.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $8xp05.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $8xp05.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const initHideCard = (0, $eUqFw.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $994a3466a42c6dde$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        };
    }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $eUqFw.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            loadMetadata();
        }, $994a3466a42c6dde$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata
    ]);
    const initShowCard = (0, $eUqFw.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) setIsOpen(true);
            else fadeInTimeoutId.current = setTimeout(()=>{
                setIsOpen(true);
            }, $994a3466a42c6dde$var$FADE_IN_DELAY);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay
    ]);
    const linkActions = (0, $i8JdB.useSmartLinkActions)({
        url: url,
        appearance: (0, $hXWLE.CardDisplay).HoverCardPreview,
        analyticsHandler: analyticsHandler,
        origin: $994a3466a42c6dde$var$HOVER_CARD_SOURCE,
        actionOptions: actionOptions
    });
    const filteredActions = (0, $eUqFw.useMemo)(()=>{
        return hidePreviewButton ? linkActions.filter((action)=>action.id !== 'preview-content') : linkActions;
    }, [
        hidePreviewButton,
        linkActions
    ]);
    const onActionClick = (0, $eUqFw.useCallback)((actionId)=>{
        if (actionId === 'preview-content' || actionId === (0, $hXWLE.ActionName).PreviewAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $eUqFw.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $eUqFw.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $eUqFw.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $eUqFw.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardActions: filteredActions,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id
        };
        return (0, $byn9U.jsx)((0, $kYGK0.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $hXWLE.CardDisplay).HoverCardPreview,
            id: id,
            source: $994a3466a42c6dde$var$HOVER_CARD_SOURCE
        }, (0, $byn9U.jsx)((0, $i7Kae.default), hoverCardContentProps));
    }, [
        initShowCard,
        initHideCard,
        filteredActions,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id
    ]);
    const trigger = (0, $eUqFw.useCallback)((triggerProps)=>(0, $byn9U.jsx)("span", {
            ref: parentSpan
        }, (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, triggerProps, {
            onMouseOver: initShowCard,
            onMouseLeave: initHideCard,
            onMouseMove: setMousePosition,
            onClick: onChildClick,
            onContextMenu: onContextMenuClick,
            "data-testid": "hover-card-trigger-wrapper"
        }), children)), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition
    ]);
    return (0, $byn9U.jsx)((0, $3MV1G.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        popupComponent: (0, $fiZFb.default)
    });
};

});
parcelRegister("i8JdB", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkActions", () => $d34c0cc60b5efefe$export$a95296ded9241771);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $jVUpn = parcelRequire("jVUpn");

var $7o9uG = parcelRequire("7o9uG");

var $kxPGe = parcelRequire("kxPGe");

var $fMym1 = parcelRequire("fMym1");

var $akLqG = parcelRequire("akLqG");
function $d34c0cc60b5efefe$export$a95296ded9241771({ url: url, appearance: appearance, analyticsHandler: analyticsHandler, platform: platform = 'web', origin: origin, actionOptions: actionOptions }) {
    const id = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hompL)))(), []);
    const linkState = (0, $fMym1.useSmartCardState)(url);
    const linkAnalytics = (0, $kxPGe.useSmartLinkAnalytics)(url, analyticsHandler, id);
    const linkActions = (0, $7o9uG.useSmartCardActions)(id, url, linkAnalytics);
    if (linkState.details && !(actionOptions !== null && actionOptions !== void 0 && actionOptions.hide)) {
        const cardProperties = (0, $jVUpn.extractBlockProps)(linkState.details.data, linkState.details.meta, {
            handleInvoke: (opts)=>linkActions.invoke(opts, appearance),
            analytics: linkAnalytics,
            origin: origin,
            extensionKey: (0, $akLqG.getExtensionKey)(linkState.details),
            source: appearance,
            actionOptions: actionOptions
        }, undefined, platform);
        if (cardProperties.actions && cardProperties.actions.length > 0) {
            const cardActions = cardProperties.actions.map((action)=>({
                    id: action.id,
                    text: action.text,
                    invoke: action.promise
                }));
            return cardActions;
        }
    }
    return [];
}

});
parcelRegister("jVUpn", function(module, exports) {

$parcel$export(module.exports, "extractBlockProps", () => $e82f18b7b4afaca1$export$183e15864834a0bd);

var $eFKYn = parcelRequire("eFKYn");
var $3cPWc = parcelRequire("3cPWc");

var $5XeOV = parcelRequire("5XeOV");

var $jsXT6 = parcelRequire("jsXT6");

var $qqqNw = parcelRequire("qqqNw");
var $7GzAt = parcelRequire("7GzAt");
var $gksyw = parcelRequire("gksyw");
var $js7i6 = parcelRequire("js7i6");

var $lbKTa = parcelRequire("lbKTa");
var $lnW6z = parcelRequire("lnW6z");
var $cx2mN = parcelRequire("cx2mN");
var $dlXJJ = parcelRequire("dlXJJ");
var $c8AiI = parcelRequire("c8AiI");
var $gd1O9 = parcelRequire("gd1O9");
var $ebCNT = parcelRequire("ebCNT");
var $a4gSw = parcelRequire("a4gSw");

var $c0qOM = parcelRequire("c0qOM");

var $jz6eD = parcelRequire("jz6eD");

var $9n9Zb = parcelRequire("9n9Zb");

var $5IFe2 = parcelRequire("5IFe2");

var $1adpH = parcelRequire("1adpH");
const $e82f18b7b4afaca1$var$extractBlockIcon = (jsonLd)=>{
    const icon = (0, $jsXT6.extractIcon)(jsonLd);
    if (typeof icon === 'string') return {
        url: icon
    };
    else return {
        icon: icon
    };
};
const $e82f18b7b4afaca1$var$extractBlockDetails = (jsonLd)=>[
        (0, $7GzAt.extractCommentCount)(jsonLd),
        (0, $gksyw.extractProgrammingLanguage)(jsonLd),
        (0, $js7i6.extractSubscriberCount)(jsonLd),
        (0, $qqqNw.extractAttachmentCount)(jsonLd)
    ].filter((detail)=>!!detail);
const $e82f18b7b4afaca1$export$874f983fcd62a981 = (props, jsonLd, opts, platform, meta)=>{
    if (opts) {
        const { handleInvoke: handleInvoke, actionOptions: actionOptions } = opts;
        const actions = (0, $9n9Zb.extractClientActions)(jsonLd, handleInvoke, actionOptions);
        const previewAction = (0, $5IFe2.extractPreviewAction)({
            ...opts,
            viewProps: props,
            jsonLd: jsonLd,
            platform: platform,
            meta: meta
        });
        // The previewAction should always be the last action
        if (previewAction) actions.push(previewAction);
        return actions;
    }
    return [];
};
const $e82f18b7b4afaca1$export$37f7a7348279b273 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') return (0, $cx2mN.extractMembers)(jsonLd);
    else if (jsonLd['@type'] === 'atlassian:Task') {
        const assignedMembers = (0, $dlXJJ.extractPersonAssignedTo)(jsonLd);
        if (assignedMembers) return [
            assignedMembers
        ];
    } else if (jsonLd['@type'] === 'atlassian:SourceCodePullRequest') return (0, $c8AiI.extractPersonCreatedBy)(jsonLd);
    else {
        const updatedBy = (0, $gd1O9.extractPersonUpdatedBy)(jsonLd);
        let updatedByMembers;
        if (updatedBy) updatedByMembers = [
            updatedBy
        ];
        const createdByMembers = (0, $c8AiI.extractPersonCreatedBy)(jsonLd);
        return updatedByMembers || createdByMembers;
    }
};
const $e82f18b7b4afaca1$export$183e15864834a0bd = (jsonLd, meta, opts, renderers, platform)=>{
    const props = {
        link: (0, $lnW6z.extractLink)(jsonLd),
        title: (0, $a4gSw.extractTitle)(jsonLd),
        titleTextColor: (0, $3cPWc.extractTitleTextColor)(jsonLd),
        lozenge: (0, $5XeOV.extractLozenge)(jsonLd),
        icon: $e82f18b7b4afaca1$var$extractBlockIcon(jsonLd),
        context: (0, $ebCNT.extractProvider)(jsonLd),
        details: $e82f18b7b4afaca1$var$extractBlockDetails(jsonLd),
        byline: (0, $eFKYn.extractSummary)(jsonLd) || (0, $c0qOM.extractByline)(jsonLd),
        thumbnail: (0, $lbKTa.extractImage)(jsonLd),
        users: $e82f18b7b4afaca1$export$37f7a7348279b273(jsonLd),
        titlePrefix: (0, $jz6eD.extractTitlePrefix)(jsonLd, renderers, 'block'),
        isTrusted: (0, $1adpH.extractIsTrusted)(meta)
    };
    return {
        ...props,
        actions: $e82f18b7b4afaca1$export$874f983fcd62a981(props, jsonLd, opts, platform, meta)
    };
};

});
parcelRegister("eFKYn", function(module, exports) {

$parcel$export(module.exports, "extractSummary", () => $aae954de572a4df4$export$db5a8500f6b6286e);
/**
 * Return link summary
 */ const $aae954de572a4df4$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof (jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.summary) === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};

});

parcelRegister("3cPWc", function(module, exports) {

$parcel$export(module.exports, "extractTitleTextColor", () => $255ac7daff08b1fe$export$a2afc198e9dada1);

var $4PDkx = parcelRequire("4PDkx");

var $PdmhA = parcelRequire("PdmhA");
const $255ac7daff08b1fe$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $4PDkx.extractorPriorityMap)[b] - (0, $4PDkx.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return `var(--ds-text-danger, ${0, $PdmhA.R500})`;
            default:
                return undefined;
        }
    }
};

});
parcelRegister("4PDkx", function(module, exports) {

$parcel$export(module.exports, "extractorPriorityMap", () => $384a6f0907272a0a$export$e0deaeb4a2dfe2b4);
/**
 * Preference more detailed object types over less detailed ones (like 'Document' or 'Object').
 */ const $384a6f0907272a0a$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});


parcelRegister("5XeOV", function(module, exports) {

$parcel$export(module.exports, "extractLozenge", () => $455df57b5d1866e9$export$e5da155556a77bca);

var $dAT1d = parcelRequire("dAT1d");

var $8TULA = parcelRequire("8TULA");

var $cPDmo = parcelRequire("cPDmo");

var $4yj9H = parcelRequire("4yj9H");

var $89bS7 = parcelRequire("89bS7");
const $455df57b5d1866e9$var$DOC_TYPES = [
    'schema:BlogPosting',
    'schema:TextDigitalDocument',
    'schema:DigitalDocument',
    'schema:PresentationDigitalDocument',
    'schema:SpreadsheetDigitalDocument'
];
const $455df57b5d1866e9$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $4yj9H.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:SourceCodePullRequest')) return (0, $dAT1d.extractState)(jsonLd);
        else if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $8TULA.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $cPDmo.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $455df57b5d1866e9$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        } else if (type.some((types)=>$455df57b5d1866e9$var$DOC_TYPES.includes(types))) {
            const jsonLdDocument = jsonLd;
            const lozengeFromState = (0, $dAT1d.extractState)(jsonLdDocument);
            return lozengeFromState;
        } else if (type.includes('atlassian:Goal')) {
            const jsonLdProject = jsonLd;
            const lozengeFromState = (0, $dAT1d.extractState)(jsonLdProject);
            return lozengeFromState;
        } else if (type.includes('atlassian:Project')) {
            const jsonLdProject = jsonLd;
            const lozengeFromState = (0, $dAT1d.extractState)(jsonLdProject);
            return lozengeFromState;
        } else if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
    }
};
const $455df57b5d1866e9$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $89bS7.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("dAT1d", function(module, exports) {

$parcel$export(module.exports, "extractState", () => $9e5950b9724da22d$export$5e4074cbce6574c7);

var $gIUw1 = parcelRequire("gIUw1");
// Maps accent color short names to their corresponding background and text colors
const $9e5950b9724da22d$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $9e5950b9724da22d$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $gIUw1.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $gIUw1.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $9e5950b9724da22d$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("gIUw1", function(module, exports) {

$parcel$export(module.exports, "isValidAppearance", () => $c2cc98388222192b$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $c2cc98388222192b$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $c2cc98388222192b$export$772610da74ddbc07);
const $c2cc98388222192b$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $c2cc98388222192b$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $c2cc98388222192b$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $c2cc98388222192b$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $c2cc98388222192b$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("8TULA", function(module, exports) {

$parcel$export(module.exports, "extractTag", () => $67af7e748785477c$export$962a8da34cf78a4f);

var $gIUw1 = parcelRequire("gIUw1");
const $67af7e748785477c$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($67af7e748785477c$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $67af7e748785477c$var$extractTagItem(tag);
    }
};
const $67af7e748785477c$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $gIUw1.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("cPDmo", function(module, exports) {

$parcel$export(module.exports, "extractTaskStatus", () => $9578c78e81eb5a6c$export$7698df1946deda72);
const $9578c78e81eb5a6c$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});

parcelRegister("4yj9H", function(module, exports) {

$parcel$export(module.exports, "extractType", () => $b06a91293523bc6e$export$2e9ae379995d99e3);
const $b06a91293523bc6e$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
};

});

parcelRegister("89bS7", function(module, exports) {

$parcel$export(module.exports, "extractTaskType", () => $5ee85f81120ada6c$export$ed3fd59180514d27);

var $amPw7 = parcelRequire("amPw7");
const $5ee85f81120ada6c$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $amPw7.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});
parcelRegister("amPw7", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $8352024242ae3429$export$67f3d92c824fd850);

var $9W7HP = parcelRequire("9W7HP");
const $8352024242ae3429$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $9W7HP.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $9W7HP.extractUrlFromLinkJsonLd)(icon.url);
    }
};

});



parcelRegister("jsXT6", function(module, exports) {

$parcel$export(module.exports, "extractIcon", () => $e2bf164bac49f861$export$64bdf1f5e49e8626);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $iwsIy = parcelRequire("iwsIy");

var $fU2qj = parcelRequire("fU2qj");

var $6VQ7Z = parcelRequire("6VQ7Z");

var $gQa4O = parcelRequire("gQa4O");

var $egbU6 = parcelRequire("egbU6");

var $hiUvC = parcelRequire("hiUvC");

var $4PDkx = parcelRequire("4PDkx");

var $ebCNT = parcelRequire("ebCNT");
var $a4gSw = parcelRequire("a4gSw");
var $amPw7 = parcelRequire("amPw7");

var $i2K6Z = parcelRequire("i2K6Z");

var $2LvZI = parcelRequire("2LvZI");

var $4JDYJ = parcelRequire("4JDYJ");

var $89bS7 = parcelRequire("89bS7");

var $49iYX = parcelRequire("49iYX");
const $e2bf164bac49f861$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type')=>{
    const type = jsonLd['@type'];
    const opts = {
        title: (0, $a4gSw.extractTitle)(jsonLd),
        provider: (0, $ebCNT.extractProvider)(jsonLd),
        fileFormat: (0, $i2K6Z.extractFileFormat)(jsonLd),
        taskType: (0, $89bS7.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $amPw7.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $4PDkx.extractorPriorityMap)[b] - (0, $4PDkx.extractorPriorityMap)[a])[0];
        return $e2bf164bac49f861$var$extractIconByType(highestPriorityType, opts);
    } else return $e2bf164bac49f861$var$extractIconByType(type, opts);
};
/**
 * Extracts an icon based on the given type.
 * 
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $e2bf164bac49f861$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $2LvZI.extractIconFromDocument)(type, opts);
        case 'atlassian:Goal':
            return opts.icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hiUvC))), {
                label: opts.title || 'goal',
                testId: "task-icon"
            });
        case 'atlassian:Project':
            return opts.icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))), {
                label: opts.title || 'project',
                size: "small",
                testId: "project-icon"
            });
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fU2qj))), {
                label: opts.title || 'commit',
                testId: "commit-icon"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6VQ7Z))), {
                label: opts.title || 'pullRequest',
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gQa4O))), {
                label: opts.title || 'reference',
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($egbU6))), {
                label: opts.title || 'repository',
                testId: "repo-icon"
            });
        case 'atlassian:Task':
            return (0, $4JDYJ.extractIconFromTask)(opts);
        default:
            return (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.standardise-smart-link-icon-behaviour') ? $e2bf164bac49f861$var$extractDefaultIcon(opts) : opts.provider && opts.provider.icon;
    }
};
/**
 * Choose which icon to show when the type is not recognized.
 */ const $e2bf164bac49f861$var$extractDefaultIcon = (opts)=>{
    var _opts$provider;
    const { provider: provider } = opts;
    const providerId = provider === null || provider === void 0 ? void 0 : provider.id;
    return (0, $49iYX.prioritiseIcon)({
        providerId: providerId,
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: opts.icon,
        providerIcon: (_opts$provider = opts.provider) === null || _opts$provider === void 0 ? void 0 : _opts$provider.icon
    });
};

});
parcelRegister("fU2qj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b93df738dedd3ac6$var$_react = $b93df738dedd3ac6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b93df738dedd3ac6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b93df738dedd3ac6$var$Commit16Icon = (props)=>/*#__PURE__*/ $b93df738dedd3ac6$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FFAB00" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 9a1 1 0 100-2 1 1 0 000 2zm-.986 1.834a3.001 3.001 0 010-5.668A1.007 1.007 0 017 5V3a1 1 0 112 0v2c0 .057-.005.112-.014.166a3.001 3.001 0 010 5.668c.01.054.014.11.014.166v2a1 1 0 01-2 0v-2c0-.057.005-.112.014-.166z"/></svg>`
    }, props, {
        size: "small"
    }));
$b93df738dedd3ac6$var$Commit16Icon.displayName = 'Commit16Icon';
var $b93df738dedd3ac6$var$_default = $b93df738dedd3ac6$var$Commit16Icon;
module.exports.default = $b93df738dedd3ac6$var$_default;

});

parcelRegister("6VQ7Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50c080749674b039$var$_react = $50c080749674b039$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $50c080749674b039$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $50c080749674b039$var$PullRequest16Icon = (props)=>/*#__PURE__*/ $50c080749674b039$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M6.417 6H9a1 1 0 011 1v1a1 1 0 002 0V7a3 3 0 00-3-3H6.415l.294-.295a1 1 0 10-1.413-1.414l-2.003 2a1 1 0 00.001 1.415l2.002 2.001a.999.999 0 001.414-.002.999.999 0 00-.001-1.413L6.417 6zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm9 14a2 2 0 100-4 2 2 0 000 4z"/></svg>`
    }, props, {
        size: "small"
    }));
$50c080749674b039$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var $50c080749674b039$var$_default = $50c080749674b039$var$PullRequest16Icon;
module.exports.default = $50c080749674b039$var$_default;

});

parcelRegister("gQa4O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c42951abc82b6c35$var$_react = $c42951abc82b6c35$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c42951abc82b6c35$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c42951abc82b6c35$var$Branch16Icon = (props)=>/*#__PURE__*/ $c42951abc82b6c35$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M10 8.732v.28A1.993 1.993 0 018.002 11l-.004 2A3.995 3.995 0 0012 9.007v-.274a2 2 0 10-2 0zm-4-3a2 2 0 10-2 0v4.536a2 2 0 102 0V5.732zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"/></svg>`
    }, props, {
        size: "small"
    }));
$c42951abc82b6c35$var$Branch16Icon.displayName = 'Branch16Icon';
var $c42951abc82b6c35$var$_default = $c42951abc82b6c35$var$Branch16Icon;
module.exports.default = $c42951abc82b6c35$var$_default;

});

parcelRegister("egbU6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a61bcb2b0c01b80b$var$_react = $a61bcb2b0c01b80b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a61bcb2b0c01b80b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a61bcb2b0c01b80b$var$Code16Icon = (props)=>/*#__PURE__*/ $a61bcb2b0c01b80b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554C0" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm2.92 4.72L2.34 7.3a.998.998 0 000 1.414l2.58 2.578a1 1 0 001.414-1.416L4.46 8.006l1.873-1.871A1 1 0 104.92 4.72zm4.792 0a.999.999 0 000 1.415l1.874 1.87-1.873 1.87a1 1 0 101.414 1.416l2.58-2.58a1 1 0 000-1.414L11.126 4.72a.996.996 0 00-.706-.292.995.995 0 00-.708.293z"/></svg>`
    }, props, {
        size: "small"
    }));
$a61bcb2b0c01b80b$var$Code16Icon.displayName = 'Code16Icon';
var $a61bcb2b0c01b80b$var$_default = $a61bcb2b0c01b80b$var$Code16Icon;
module.exports.default = $a61bcb2b0c01b80b$var$_default;

});

parcelRegister("hiUvC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c98ff3a06ace07f2$var$_react = $c98ff3a06ace07f2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c98ff3a06ace07f2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c98ff3a06ace07f2$var$Task16Icon = (props)=>/*#__PURE__*/ $c98ff3a06ace07f2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0114.006 16H1.994A1.995 1.995 0 010 14.006V1.994zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3H4.667zM5 5v6h6V5H5z"/></svg>`
    }, props, {
        size: "small"
    }));
$c98ff3a06ace07f2$var$Task16Icon.displayName = 'Task16Icon';
var $c98ff3a06ace07f2$var$_default = $c98ff3a06ace07f2$var$Task16Icon;
module.exports.default = $c98ff3a06ace07f2$var$_default;

});

parcelRegister("ebCNT", function(module, exports) {

$parcel$export(module.exports, "extractProvider", () => $949786e11a712549$export$a832871718466647);
$parcel$export(module.exports, "extractProviderIcon", () => $949786e11a712549$export$6fb636a2ac885215);

var $eUqFw = parcelRequire("eUqFw");

var $5KT10 = parcelRequire("5KT10");

var $77CtJ = parcelRequire("77CtJ");


var $amPw7 = parcelRequire("amPw7");
var $9W7HP = parcelRequire("9W7HP");
const $949786e11a712549$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $949786e11a712549$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $949786e11a712549$var$extractProviderImage(generator.image)
            };
        }
    }
};
const $949786e11a712549$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $91701787b8fb623d$export$cee224b5de4d6d66)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KT10.ConfluenceIcon), {
            appearance: "brand",
            /* eslint-enable @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/no-deprecated-apis */ size: "xsmall"
        });
        else if (id === (0, $91701787b8fb623d$export$f654d825189934a7)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
            appearance: "brand",
            /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ size: "xsmall"
        });
    }
    if (icon) return (0, $amPw7.extractUrlFromIconJsonLd)(icon);
};
const $949786e11a712549$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $9W7HP.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $9W7HP.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});
const $91701787b8fb623d$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $91701787b8fb623d$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $91701787b8fb623d$export$84a73a0383f58180 = 'JiraTask';
const $91701787b8fb623d$export$c6c83963a9378a67 = 'JiraSubTask';
const $91701787b8fb623d$export$58af3c426c111a6d = 'JiraStory';
const $91701787b8fb623d$export$ac9898a63417219e = 'JiraBug';
const $91701787b8fb623d$export$54db5e3fb12e39cd = 'JiraEpic';
const $91701787b8fb623d$export$2f54a5a217202c85 = 'JiraIncident';
const $91701787b8fb623d$export$d097371052bfc411 = 'JiraServiceRequest';
const $91701787b8fb623d$export$efd9452ad16c6676 = 'JiraChange';
const $91701787b8fb623d$export$2e7e70abb5d81f67 = 'JiraProblem';
const $91701787b8fb623d$export$ce25cfc40b280dbc = 'JiraCustomTaskType';


parcelRegister("a4gSw", function(module, exports) {

$parcel$export(module.exports, "extractTitle", () => $a665721ac2392089$export$b05803156e5015b6);

var $XHGTv = parcelRequire("XHGTv");

var $ieJEX = parcelRequire("ieJEX");

var $4yj9H = parcelRequire("4yj9H");
const $a665721ac2392089$export$b05803156e5015b6 = (jsonLd)=>{
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $ieJEX.extractContext)(jsonLd);
    const type = (0, $4yj9H.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.extractor.improve-bitbucket-file-links') && type.includes('schema:DigitalDocument')) return contextName + name;
    }
    return name;
};

});
parcelRegister("ieJEX", function(module, exports) {

$parcel$export(module.exports, "extractContext", () => $24c906d1ff23560a$export$efdbd45f3e77a161);

var $4yj9H = parcelRequire("4yj9H");

var $amPw7 = parcelRequire("amPw7");
const $24c906d1ff23560a$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $amPw7.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $4yj9H.extractType)(context)
            };
        }
    }
};

});


parcelRegister("i2K6Z", function(module, exports) {

$parcel$export(module.exports, "extractFileFormat", () => $d22c2ec118872ff7$export$f2d65f02f6888b60);
const $d22c2ec118872ff7$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};

});

parcelRegister("2LvZI", function(module, exports) {

$parcel$export(module.exports, "extractIconFromDocument", () => $2038c9f7ef0bff06$export$25c24c7f577936d3);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $42mVw = parcelRequire("42mVw");

var $hC3Rz = parcelRequire("hC3Rz");

var $iIEQk = parcelRequire("iIEQk");

var $kaVAc = parcelRequire("kaVAc");

var $33pqc = parcelRequire("33pqc");

var $nzdI3 = parcelRequire("nzdI3");

var $6MLxR = parcelRequire("6MLxR");

var $49iYX = parcelRequire("49iYX");
const $2038c9f7ef0bff06$export$25c24c7f577936d3 = (type, opts)=>{
    const { provider: provider } = opts;
    const iconFromType = $2038c9f7ef0bff06$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $2038c9f7ef0bff06$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.standardise-smart-link-icon-behaviour')) {
        const providerId = provider === null || provider === void 0 ? void 0 : provider.id;
        return (0, $49iYX.prioritiseIcon)({
            providerId: providerId,
            fileFormatIcon: iconFromFileFormat,
            documentTypeIcon: iconFromType,
            urlIcon: opts.icon,
            providerIcon: iconFromProvider
        });
    }
    // If we encounter a native provider, we privilege the
    // icon generated by its type. Otherwise, we privilege the
    // provider icon, followed by the type & mime type icons.
    if (opts.priority === 'provider') return iconFromProvider || iconFromFileFormat || iconFromType;
    return iconFromFileFormat || iconFromType || opts.icon || iconFromProvider;
};
const $2038c9f7ef0bff06$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $6MLxR.getIconForFileType)(opts.fileFormat);
};
const $2038c9f7ef0bff06$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42mVw))), {
                label: opts.title || 'blog',
                testId: "blog-icon"
            });
        case 'schema:DigitalDocument':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hC3Rz))), {
                label: opts.title || 'file',
                testId: "file-icon"
            });
        case 'schema:TextDigitalDocument':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33pqc))), {
                label: opts.title || 'document',
                testId: "document-icon"
            });
        case 'schema:PresentationDigitalDocument':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iIEQk))), {
                label: opts.title || 'presentation',
                testId: "presentation-icon"
            });
        case 'schema:SpreadsheetDigitalDocument':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kaVAc))), {
                label: opts.title || 'spreadsheet',
                testId: "spreadsheet-icon"
            });
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($nzdI3))), {
                label: opts.title || 'template',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33pqc))), {
                label: opts.title || 'undefinedLink',
                testId: "document-icon"
            });
    }
};

});
parcelRegister("42mVw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f09221b0a539484$var$_react = $2f09221b0a539484$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2f09221b0a539484$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2f09221b0a539484$var$Blog16Icon = (props)=>/*#__PURE__*/ $2f09221b0a539484$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 10-2.37 2.87c-.277.394-.616.815-1.016 1.265a.916.916 0 00-.058 1.147.607.607 0 00.948.043c1.939-2.221 2.77-3.996 2.496-5.325zm7 0a2.5 2.5 0 10-2.37 2.87c-.277.394-.616.815-1.016 1.265a.916.916 0 00-.058 1.147.607.607 0 00.948.043c1.939-2.221 2.77-3.996 2.496-5.325zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"/></svg>`
    }, props, {
        size: "small"
    }));
$2f09221b0a539484$var$Blog16Icon.displayName = 'Blog16Icon';
var $2f09221b0a539484$var$_default = $2f09221b0a539484$var$Blog16Icon;
module.exports.default = $2f09221b0a539484$var$_default;

});

parcelRegister("hC3Rz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $cd28fb6529d0fdb1$var$_react = $cd28fb6529d0fdb1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $cd28fb6529d0fdb1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $cd28fb6529d0fdb1$var$Generic16Icon = (props)=>/*#__PURE__*/ $cd28fb6529d0fdb1$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.333.333 0 00-.093-.231l-2.164-2.25A1.333 1.333 0 008.782 3H8zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0114.006 16H1.994A1.995 1.995 0 010 14.006V1.994z"/></svg>`
    }, props, {
        size: 'small'
    }));
$cd28fb6529d0fdb1$var$Generic16Icon.displayName = 'Generic16Icon';
var $cd28fb6529d0fdb1$var$_default = $cd28fb6529d0fdb1$var$Generic16Icon;
module.exports.default = $cd28fb6529d0fdb1$var$_default;

});

parcelRegister("iIEQk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $da0c049bdbf3c329$var$_react = $da0c049bdbf3c329$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $da0c049bdbf3c329$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $da0c049bdbf3c329$var$Presentation16Icon = (props)=>/*#__PURE__*/ $da0c049bdbf3c329$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270DB" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm10 3a1 1 0 00-1 1v8a1 1 0 002 0V4a1 1 0 00-1-1zM8 6a1 1 0 00-1 1v5a1 1 0 002 0V7a1 1 0 00-1-1zM4 9a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z"/></svg>`
    }, props, {
        size: 'small'
    }));
$da0c049bdbf3c329$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $da0c049bdbf3c329$var$_default = $da0c049bdbf3c329$var$Presentation16Icon;
module.exports.default = $da0c049bdbf3c329$var$_default;

});

parcelRegister("kaVAc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $eb01688efa6942b0$var$_react = $eb01688efa6942b0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $eb01688efa6942b0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $eb01688efa6942b0$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $eb01688efa6942b0$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm2 3a1 1 0 100 2h1a1 1 0 100-2H4zm0 4a1 1 0 100 2h1a1 1 0 100-2H4zm0 4a1 1 0 000 2h1a1 1 0 000-2H4zm5-8a1 1 0 100 2h3a1 1 0 000-2H9zm0 4a1 1 0 100 2h3a1 1 0 000-2H9zm0 4a1 1 0 000 2h3a1 1 0 000-2H9z"/></svg>`
    }, props, {
        size: 'small'
    }));
$eb01688efa6942b0$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $eb01688efa6942b0$var$_default = $eb01688efa6942b0$var$Spreadsheet16Icon;
module.exports.default = $eb01688efa6942b0$var$_default;

});

parcelRegister("33pqc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $23955f1f88135281$var$_react = $23955f1f88135281$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $23955f1f88135281$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $23955f1f88135281$var$Document16Icon = (props)=>/*#__PURE__*/ $23955f1f88135281$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm2 3a1 1 0 100 2h8a1 1 0 000-2H4zm0 4a1 1 0 100 2h8a1 1 0 000-2H4zm0 4a1 1 0 000 2h4a1 1 0 000-2H4z"/></svg>`
    }, props, {
        size: 'small'
    }));
$23955f1f88135281$var$Document16Icon.displayName = 'Document16Icon';
var $23955f1f88135281$var$_default = $23955f1f88135281$var$Document16Icon;
module.exports.default = $23955f1f88135281$var$_default;

});

parcelRegister("nzdI3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $046d781480b548f9$var$_react = $046d781480b548f9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $046d781480b548f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $046d781480b548f9$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $046d781480b548f9$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M18.99 8.99l.01 1.015V19a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768v.521zM12.02 5L12 8.192a.99.99 0 00.994.991h4L12.02 5z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$046d781480b548f9$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $046d781480b548f9$var$_default = $046d781480b548f9$var$DocumentFilledIcon;
module.exports.default = $046d781480b548f9$var$_default;

});

parcelRegister("6MLxR", function(module, exports) {

$parcel$export(module.exports, "isCardWithData", () => $4f0c1b4212865825$export$f287576685db4026);
$parcel$export(module.exports, "isSpecialEvent", () => $4f0c1b4212865825$export$efca2c4705678489);
$parcel$export(module.exports, "getIconForFileType", () => $4f0c1b4212865825$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $4f0c1b4212865825$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $4f0c1b4212865825$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $4f0c1b4212865825$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $4f0c1b4212865825$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $4f0c1b4212865825$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $4f0c1b4212865825$export$a238cfe4a10e6279);
$parcel$export(module.exports, "combineFrameStyle", () => $4f0c1b4212865825$export$666eb6846f461ee6);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $4f0c1b4212865825$export$4470f298c61a79da);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $XHGTv = parcelRequire("XHGTv");

var $iednx = parcelRequire("iednx");
const $4f0c1b4212865825$export$f287576685db4026 = (props)=>!!props.data;
const $4f0c1b4212865825$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($4f0c1b4212865825$export$e6c5ffa684aac4d7() || $4f0c1b4212865825$export$d8de0cd37d316fdf(evt) || $4f0c1b4212865825$export$5b1771037ab7c451(evt));
const $4f0c1b4212865825$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $4f0c1b4212865825$export$d8de0cd37d316fdf = (event)=>event.metaKey || event.ctrlKey;
const $4f0c1b4212865825$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $4f0c1b4212865825$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $4f0c1b4212865825$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $4f0c1b4212865825$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = $4f0c1b4212865825$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label] = icon;
    return label;
};


















































const $4f0c1b4212865825$var$typeToIcon = {
    'text/plain': [
        'Document',
        ()=>Promise.resolve((parcelRequire("33pqc")))
    ],
    'application/vnd.oasis.opendocument.text': [
        'Document',
        ()=>Promise.resolve((parcelRequire("33pqc")))
    ],
    'application/vnd.apple.pages': [
        'Document',
        ()=>Promise.resolve((parcelRequire("33pqc")))
    ],
    'application/vnd.google-apps.document': [
        'Google Doc',
        ()=>(parcelRequire("aWo98"))
    ],
    'application/msword': [
        'Word document',
        ()=>(parcelRequire("5hO6q"))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        'Word document',
        ()=>(parcelRequire("5hO6q"))
    ],
    'application/pdf': [
        'PDF document',
        ()=>(parcelRequire("3kV6m"))
    ],
    'application/vnd.oasis.opendocument.spreadsheet': [
        'Spreadsheet',
        ()=>Promise.resolve((parcelRequire("kaVAc")))
    ],
    'application/vnd.apple.numbers': [
        'Spreadsheet',
        ()=>Promise.resolve((parcelRequire("kaVAc")))
    ],
    'application/vnd.google-apps.spreadsheet': [
        'Google Sheet',
        ()=>(parcelRequire("68kEB"))
    ],
    'application/vnd.ms-excel': [
        'Excel spreadsheet',
        ()=>(parcelRequire("pNNfx"))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        'Excel spreadsheet',
        ()=>(parcelRequire("pNNfx"))
    ],
    'application/vnd.oasis.opendocument.presentation': [
        'Presentation',
        ()=>Promise.resolve((parcelRequire("iIEQk")))
    ],
    'application/vnd.apple.keynote': [
        'Presentation',
        ()=>Promise.resolve((parcelRequire("iIEQk")))
    ],
    'application/vnd.google-apps.presentation': [
        'Google Slide',
        ()=>(parcelRequire("dlbJ3"))
    ],
    'application/vnd.ms-powerpoint': [
        'PowerPoint presentation',
        ()=>(parcelRequire("fqpGs"))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        'PowerPoint presentation',
        ()=>(parcelRequire("fqpGs"))
    ],
    'application/vnd.google-apps.form': [
        'Google Form',
        ()=>(parcelRequire("hgXDP"))
    ],
    'image/png': [
        'Image',
        ()=>Promise.resolve((parcelRequire("cOsqE")))
    ],
    'image/jpeg': [
        'Image',
        ()=>Promise.resolve((parcelRequire("cOsqE")))
    ],
    'image/bmp': [
        'Image',
        ()=>Promise.resolve((parcelRequire("cOsqE")))
    ],
    'image/webp': [
        'Image',
        ()=>Promise.resolve((parcelRequire("cOsqE")))
    ],
    'image/svg+xml': [
        'Image',
        ()=>Promise.resolve((parcelRequire("cOsqE")))
    ],
    'image/gif': [
        'GIF',
        ()=>(parcelRequire("cVIlt"))
    ],
    'audio/midi': [
        'Audio',
        ()=>Promise.resolve((parcelRequire("ax6gr")))
    ],
    'audio/mpeg': [
        'Audio',
        ()=>Promise.resolve((parcelRequire("ax6gr")))
    ],
    'audio/webm': [
        'Audio',
        ()=>Promise.resolve((parcelRequire("ax6gr")))
    ],
    'audio/ogg': [
        'Audio',
        ()=>Promise.resolve((parcelRequire("ax6gr")))
    ],
    'audio/wav': [
        'Audio',
        ()=>Promise.resolve((parcelRequire("ax6gr")))
    ],
    'video/mp4': [
        'Video',
        ()=>Promise.resolve((parcelRequire("8DjS6")))
    ],
    'video/quicktime': [
        'Video',
        ()=>Promise.resolve((parcelRequire("8DjS6")))
    ],
    'video/mov': [
        'Video',
        ()=>Promise.resolve((parcelRequire("8DjS6")))
    ],
    'video/webm': [
        'Video',
        ()=>Promise.resolve((parcelRequire("8DjS6")))
    ],
    'video/ogg': [
        'Video',
        ()=>Promise.resolve((parcelRequire("8DjS6")))
    ],
    'video/x-ms-wmv': [
        'Video',
        ()=>Promise.resolve((parcelRequire("8DjS6")))
    ],
    'video/x-msvideo': [
        'Video',
        ()=>Promise.resolve((parcelRequire("8DjS6")))
    ],
    'application/zip': [
        'Archive',
        ()=>Promise.resolve((parcelRequire("avXTG")))
    ],
    'application/x-tar': [
        'Archive',
        ()=>Promise.resolve((parcelRequire("avXTG")))
    ],
    'application/x-gtar': [
        'Archive',
        ()=>Promise.resolve((parcelRequire("avXTG")))
    ],
    'application/x-7z-compressed': [
        'Archive',
        ()=>Promise.resolve((parcelRequire("avXTG")))
    ],
    'application/x-apple-diskimage': [
        'Archive',
        ()=>Promise.resolve((parcelRequire("avXTG")))
    ],
    'application/vnd.rar': [
        'Archive',
        ()=>Promise.resolve((parcelRequire("avXTG")))
    ],
    'application/dmg': [
        'Executable',
        ()=>(parcelRequire("5KraK"))
    ],
    'text/css': [
        'Source Code',
        ()=>(parcelRequire("3Odf5"))
    ],
    'text/html': [
        'Source Code',
        ()=>(parcelRequire("3Odf5"))
    ],
    'application/javascript': [
        'Source Code',
        ()=>(parcelRequire("3Odf5"))
    ],
    'application/octet-stream': [
        'Binary file',
        ()=>Promise.resolve((parcelRequire("hC3Rz")))
    ],
    'application/invision.prototype': [
        'Prototype',
        ()=>Promise.resolve((parcelRequire("hC3Rz")))
    ],
    // TODO: Figure a way to detect those
    'application/sketch': [
        'Sketch',
        ()=>(parcelRequire("gwQvz"))
    ],
    folder: [
        'Folder',
        ()=>(parcelRequire("5Gpyh"))
    ]
};
const $4f0c1b4212865825$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $4f0c1b4212865825$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $4f0c1b4212865825$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $4f0c1b4212865825$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $4f0c1b4212865825$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $4f0c1b4212865825$export$e772c8ff12451969(interval);
            return $4f0c1b4212865825$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $4f0c1b4212865825$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $4f0c1b4212865825$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $4f0c1b4212865825$export$666eb6846f461ee6 = (frameStyle, isFrameVisible)=>{
    if (frameStyle !== undefined) return frameStyle;
    if (isFrameVisible) return 'show';
};
const $4f0c1b4212865825$export$4470f298c61a79da = (previewUrl, themeState)=>{
    if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.fix-embed-preview-url-query-params')) try {
        const url = new URL(previewUrl);
        if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.enable-theme-state-url')) url.searchParams.append('themeState', (0, $iednx.themeObjectToString)(themeState));
        else {
            var _themeState$colorMode;
            url.searchParams.append('themeMode', (_themeState$colorMode = themeState.colorMode) !== null && _themeState$colorMode !== void 0 ? _themeState$colorMode : '');
        }
        return url.href;
    } catch  {
        return previewUrl;
    }
    if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.enable-theme-state-url')) {
        const themeStateQueryString = encodeURIComponent((0, $iednx.themeObjectToString)(themeState));
        return `${previewUrl}${previewUrl.includes('?') ? '&' : '?'}themeState=${themeStateQueryString}`;
    }
    return `${previewUrl}${previewUrl.includes('?') ? '&' : '?'}themeMode=${themeState.colorMode}`;
};

});
parcelRegister("aWo98", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('f6s74');
        const value = parcelRequire('koIAu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("f6s74").then(()=>parcelRequire('koIAu'));
}

});

parcelRegister("5hO6q", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gnAw0');
        const value = parcelRequire('IXu7C');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gnAw0").then(()=>parcelRequire('IXu7C'));
}

});

parcelRegister("3kV6m", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jD9x7');
        const value = parcelRequire('gZQhT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jD9x7").then(()=>parcelRequire('gZQhT'));
}

});

parcelRegister("68kEB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cXU5K');
        const value = parcelRequire('8o5C6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cXU5K").then(()=>parcelRequire('8o5C6'));
}

});

parcelRegister("pNNfx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3jhqX');
        const value = parcelRequire('iByLo');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3jhqX").then(()=>parcelRequire('iByLo'));
}

});

parcelRegister("dlbJ3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7yNJI');
        const value = parcelRequire('2pi7o');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7yNJI").then(()=>parcelRequire('2pi7o'));
}

});

parcelRegister("fqpGs", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ifX94');
        const value = parcelRequire('3Xmfm');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ifX94").then(()=>parcelRequire('3Xmfm'));
}

});

parcelRegister("hgXDP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3fs5M');
        const value = parcelRequire('7ISrx');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3fs5M").then(()=>parcelRequire('7ISrx'));
}

});

parcelRegister("cVIlt", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('81ele');
        const value = parcelRequire('heDum');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("81ele").then(()=>parcelRequire('heDum'));
}

});

parcelRegister("5KraK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('MsAMf');
        const value = parcelRequire('kRSyE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("MsAMf").then(()=>parcelRequire('kRSyE'));
}

});

parcelRegister("3Odf5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kj99S');
        const value = parcelRequire('cu0Sf');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kj99S").then(()=>parcelRequire('cu0Sf'));
}

});

parcelRegister("gwQvz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1bzA4');
        const value = parcelRequire('dCALS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1bzA4").then(()=>parcelRequire('dCALS'));
}

});

parcelRegister("5Gpyh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hqUNL');
        const value = parcelRequire('bXsFc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hqUNL").then(()=>parcelRequire('bXsFc'));
}

});


parcelRegister("49iYX", function(module, exports) {

$parcel$export(module.exports, "prioritiseIcon", () => $3056ba2a9eb95f41$export$65e47eb22a387a86);

var $590Ns = parcelRequire("590Ns");
const $3056ba2a9eb95f41$var$isConfluenceProvider = (provider)=>provider === (0, $590Ns.CONFLUENCE_GENERATOR_ID);
const $3056ba2a9eb95f41$var$isJiraProvider = (provider)=>provider === (0, $590Ns.JIRA_GENERATOR_ID);
const $3056ba2a9eb95f41$var$isNativeProvider = (provider)=>$3056ba2a9eb95f41$var$isConfluenceProvider(provider) || $3056ba2a9eb95f41$var$isJiraProvider(provider);
function $3056ba2a9eb95f41$export$65e47eb22a387a86({ providerId: providerId, fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    if ($3056ba2a9eb95f41$var$isNativeProvider(providerId)) return fileFormatIcon || documentTypeIcon || urlIcon || providerIcon;
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});
parcelRegister("590Ns", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $3bee6936913c9955$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $3bee6936913c9955$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $3bee6936913c9955$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $3bee6936913c9955$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $3bee6936913c9955$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $3bee6936913c9955$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $3bee6936913c9955$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $3bee6936913c9955$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $3bee6936913c9955$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $3bee6936913c9955$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $3bee6936913c9955$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $3bee6936913c9955$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $3bee6936913c9955$export$fe44ce30fd8d131b);
const $3bee6936913c9955$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $3bee6936913c9955$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $3bee6936913c9955$export$84a73a0383f58180 = 'JiraTask';
const $3bee6936913c9955$export$c6c83963a9378a67 = 'JiraSubTask';
const $3bee6936913c9955$export$58af3c426c111a6d = 'JiraStory';
const $3bee6936913c9955$export$ac9898a63417219e = 'JiraBug';
const $3bee6936913c9955$export$54db5e3fb12e39cd = 'JiraEpic';
const $3bee6936913c9955$export$2f54a5a217202c85 = 'JiraIncident';
const $3bee6936913c9955$export$d097371052bfc411 = 'JiraServiceRequest';
const $3bee6936913c9955$export$efd9452ad16c6676 = 'JiraChange';
const $3bee6936913c9955$export$2e7e70abb5d81f67 = 'JiraProblem';
const $3bee6936913c9955$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $3bee6936913c9955$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider'
];

});



parcelRegister("4JDYJ", function(module, exports) {

$parcel$export(module.exports, "extractIconFromTask", () => $372a604fb7bfe25e$export$321256ed044e3100);

var $eUqFw = parcelRequire("eUqFw");

var $hiUvC = parcelRequire("hiUvC");

var $aJNc8 = parcelRequire("aJNc8");

var $3Fcny = parcelRequire("3Fcny");

var $3YEb9 = parcelRequire("3YEb9");

var $gFrvj = parcelRequire("gFrvj");

var $bJZ7m = parcelRequire("bJZ7m");

var $2NYtj = parcelRequire("2NYtj");

var $fsJVW = parcelRequire("fsJVW");

var $5cywL = parcelRequire("5cywL");

var $590Ns = parcelRequire("590Ns");
const $372a604fb7bfe25e$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const taskLabel = opts.title || 'task';
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hiUvC))), {
        label: taskLabel,
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $590Ns.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $590Ns.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hiUvC))), {
                    label: taskLabel,
                    testId: "jira-task-icon"
                });
            case 0, $590Ns.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aJNc8))), {
                    label: taskLabel,
                    testId: "jira-subtask-icon"
                });
            case 0, $590Ns.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Fcny))), {
                    label: taskLabel,
                    testId: "jira-story-icon"
                });
            case 0, $590Ns.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3YEb9))), {
                    label: taskLabel,
                    testId: "jira-bug-icon"
                });
            case 0, $590Ns.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFrvj))), {
                    label: taskLabel,
                    testId: "jira-epic-icon"
                });
            case 0, $590Ns.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJZ7m))), {
                    label: taskLabel,
                    testId: "jira-incident-icon"
                });
            case 0, $590Ns.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NYtj))), {
                    label: taskLabel,
                    testId: "jira-service-request-icon"
                });
            case 0, $590Ns.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsJVW))), {
                    label: taskLabel,
                    testId: "jira-change-icon"
                });
            case 0, $590Ns.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5cywL))), {
                    label: taskLabel,
                    testId: "jira-problem-icon"
                });
            case 0, $590Ns.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};

});
parcelRegister("aJNc8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $020474b73d22e170$var$_react = $020474b73d22e170$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $020474b73d22e170$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $020474b73d22e170$var$Subtask16Icon = (props)=>/*#__PURE__*/ $020474b73d22e170$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M9 7V4a1 1 0 00-1-1H4a1 1 0 00-1 1v4a1 1 0 001 1h3v3a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H9zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0114.006 16H1.994A1.995 1.995 0 010 14.006V1.994zM9 9h2v2H9V9zM5 5h2v2H5V5z"/></svg>`
    }, props, {
        size: "small"
    }));
$020474b73d22e170$var$Subtask16Icon.displayName = 'Subtask16Icon';
var $020474b73d22e170$var$_default = $020474b73d22e170$var$Subtask16Icon;
module.exports.default = $020474b73d22e170$var$_default;

});

parcelRegister("3Fcny", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2aaecda278f48b77$var$_react = $2aaecda278f48b77$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2aaecda278f48b77$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2aaecda278f48b77$var$Story16Icon = (props)=>/*#__PURE__*/ $2aaecda278f48b77$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 11l-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426L8 11zm0-2.371l2 1.274V5H6v4.902L8 8.63z"/></svg>`
    }, props, {
        size: "small"
    }));
$2aaecda278f48b77$var$Story16Icon.displayName = 'Story16Icon';
var $2aaecda278f48b77$var$_default = $2aaecda278f48b77$var$Story16Icon;
module.exports.default = $2aaecda278f48b77$var$_default;

});

parcelRegister("3YEb9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e5624669878641f$var$_react = $2e5624669878641f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2e5624669878641f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2e5624669878641f$var$Bug16Icon = (props)=>/*#__PURE__*/ $2e5624669878641f$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 12a4 4 0 100-8 4 4 0 000 8z"/></svg>`
    }, props, {
        size: "small"
    }));
$2e5624669878641f$var$Bug16Icon.displayName = 'Bug16Icon';
var $2e5624669878641f$var$_default = $2e5624669878641f$var$Bug16Icon;
module.exports.default = $2e5624669878641f$var$_default;

});

parcelRegister("gFrvj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c225cf658d24b86a$var$_react = $c225cf658d24b86a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c225cf658d24b86a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c225cf658d24b86a$var$Epic16Icon = (props)=>/*#__PURE__*/ $c225cf658d24b86a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554C0" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm9.912 7.767A.486.486 0 0012 7.5a.5.5 0 00-.5-.5H9V3.5a.495.495 0 00-.872-.327l-.002-.001-3.977 4.973-.008.009-.028.036.002.004A.487.487 0 004 8.5a.5.5 0 00.5.5c.028 0 .051-.011.077-.016H7V12.5a.5.5 0 00.5.5c.124 0 .234-.05.321-.124l.004.001.007-.009c.03-.027.051-.059.074-.092l3.934-4.913c.019-.018.031-.039.047-.06l.027-.033-.002-.003z"/></svg>`
    }, props, {
        size: "small"
    }));
$c225cf658d24b86a$var$Epic16Icon.displayName = 'Epic16Icon';
var $c225cf658d24b86a$var$_default = $c225cf658d24b86a$var$Epic16Icon;
module.exports.default = $c225cf658d24b86a$var$_default;

});

parcelRegister("bJZ7m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88c34e63e2df12b5$var$_react = $88c34e63e2df12b5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $88c34e63e2df12b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $88c34e63e2df12b5$var$Incident16Icon = (props)=>/*#__PURE__*/ $88c34e63e2df12b5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M4.785 10h6.43L10.5 8H5.499l-.714 2zM4 11a1 1 0 00-1 1v1h10v-1a1 1 0 00-1-1H4zm1.856-4h4.288L8.942 3.632a1 1 0 00-1.884 0L5.856 7zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"/></svg>`
    }, props, {
        size: "small"
    }));
$88c34e63e2df12b5$var$Incident16Icon.displayName = 'Incident16Icon';
var $88c34e63e2df12b5$var$_default = $88c34e63e2df12b5$var$Incident16Icon;
module.exports.default = $88c34e63e2df12b5$var$_default;

});

parcelRegister("2NYtj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20af10cdef604edb$var$_react = $20af10cdef604edb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $20af10cdef604edb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $20af10cdef604edb$var$Issue16Icon = (props)=>/*#__PURE__*/ $20af10cdef604edb$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm1 4a1 1 0 00-1 1v6a1 1 0 001 1h10a1 1 0 001-1V5a1 1 0 00-1-1H3zm1 2v4h8V6H4z"/></svg>`
    }, props, {
        size: "small"
    }));
$20af10cdef604edb$var$Issue16Icon.displayName = 'Issue16Icon';
var $20af10cdef604edb$var$_default = $20af10cdef604edb$var$Issue16Icon;
module.exports.default = $20af10cdef604edb$var$_default;

});

parcelRegister("fsJVW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b41d19f8b49fa534$var$_react = $b41d19f8b49fa534$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b41d19f8b49fa534$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b41d19f8b49fa534$var$Changes16Icon = (props)=>/*#__PURE__*/ $b41d19f8b49fa534$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FFAB00" fill-rule="evenodd" d="M10.58 7H5.467l.866-.865A1 1 0 104.92 4.72L2.34 7.3a.998.998 0 000 1.414l2.58 2.578a1 1 0 001.414-1.416L5.456 9h5.134l-.877.876a1 1 0 101.414 1.415l2.58-2.58a1 1 0 000-1.414L11.126 4.72a.996.996 0 00-.706-.292.999.999 0 00-.707 1.707l.866.865zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"/></svg>`
    }, props, {
        size: "small"
    }));
$b41d19f8b49fa534$var$Changes16Icon.displayName = 'Changes16Icon';
var $b41d19f8b49fa534$var$_default = $b41d19f8b49fa534$var$Changes16Icon;
module.exports.default = $b41d19f8b49fa534$var$_default;

});

parcelRegister("5cywL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c98db310910faad$var$_react = $3c98db310910faad$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $3c98db310910faad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3c98db310910faad$var$Problem16Icon = (props)=>/*#__PURE__*/ $3c98db310910faad$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M5.968 11.446l5.478-5.478a4 4 0 01-5.478 5.478zm-.796-.618zm-.618-.796a4 4 0 015.478-5.478l-5.478 5.478zm6.274-4.86zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 14A6 6 0 108 2a6 6 0 000 12z"/></svg>`
    }, props, {
        size: "small"
    }));
$3c98db310910faad$var$Problem16Icon.displayName = 'Problem16Icon';
var $3c98db310910faad$var$_default = $3c98db310910faad$var$Problem16Icon;
module.exports.default = $3c98db310910faad$var$_default;

});



parcelRegister("qqqNw", function(module, exports) {

$parcel$export(module.exports, "extractAttachmentCount", () => $04f6ee83591000ca$export$65362ff78a97fd8);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $jUThT = parcelRequire("jUThT");
const $04f6ee83591000ca$export$65362ff78a97fd8 = (jsonLd)=>{
    const attachmentCount = jsonLd['atlassian:attachmentCount'];
    if (attachmentCount) return {
        text: attachmentCount.toString(),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jUThT))), {
            size: "small",
            label: "attachments",
            primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA.N600)})`
        })
    };
};

});

parcelRegister("7GzAt", function(module, exports) {

$parcel$export(module.exports, "extractCommentCount", () => $59880f8aeedd62c4$export$b68822b76d5d51d5);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $d3vNK = parcelRequire("d3vNK");
const $59880f8aeedd62c4$export$b68822b76d5d51d5 = (jsonLd)=>{
    const commentCount = jsonLd['schema:commentCount'];
    if (commentCount) return {
        text: commentCount.toString(),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
            label: "comment-count",
            key: "comments-count-icon",
            size: "small",
            primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA.N600)})`
        })
    };
};

});

parcelRegister("gksyw", function(module, exports) {

$parcel$export(module.exports, "extractProgrammingLanguage", () => $be34aa320821d18a$export$43e54589935a1ff);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $2Q5Ee = parcelRequire("2Q5Ee");
const $be34aa320821d18a$export$43e54589935a1ff = (jsonLd)=>{
    const programmingLanguage = jsonLd['schema:programmingLanguage'];
    if (programmingLanguage) return {
        text: programmingLanguage,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Q5Ee))), {
            size: "small",
            label: "code",
            primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA.N600)})`
        })
    };
};

});
parcelRegister("2Q5Ee", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2114d1ad49e5b359$var$_react = $2114d1ad49e5b359$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2114d1ad49e5b359$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2114d1ad49e5b359$var$CodeIcon = (props)=>/*#__PURE__*/ $2114d1ad49e5b359$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M14.155 4.055a1 1 0 00-1.271.62l-4.83 14.046a1 1 0 001.891.65l4.83-14.045a1 1 0 00-.62-1.271m-6.138 8.21l-2.58-2.501L8.236 7.05a.999.999 0 10-1.392-1.436l-3.54 3.432a1 1 0 000 1.436l3.32 3.219a1 1 0 101.393-1.436m12.219 1.568l-3.32-3.22a.999.999 0 10-1.393 1.437l2.58 2.5-2.799 2.715a.999.999 0 101.392 1.436l3.54-3.432a1 1 0 000-1.436" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$2114d1ad49e5b359$var$CodeIcon.displayName = 'CodeIcon';
var $2114d1ad49e5b359$var$_default = $2114d1ad49e5b359$var$CodeIcon;
module.exports.default = $2114d1ad49e5b359$var$_default;

});


parcelRegister("js7i6", function(module, exports) {

$parcel$export(module.exports, "extractSubscriberCount", () => $e29649b481c97b37$export$8bd03a7beb5badf1);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $4nce6 = parcelRequire("4nce6");
const $e29649b481c97b37$export$8bd03a7beb5badf1 = (jsonLd)=>{
    const subscriberCount = jsonLd['atlassian:subscriberCount'];
    if (subscriberCount) return {
        text: subscriberCount.toString(),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
            size: "small",
            label: "subscribers",
            primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA.N600)})`
        })
    };
};

});

parcelRegister("lbKTa", function(module, exports) {

$parcel$export(module.exports, "extractImage", () => $205a59ce4cd20de1$export$4c753a1297cb9805);

var $9W7HP = parcelRequire("9W7HP");
const $205a59ce4cd20de1$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $9W7HP.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $9W7HP.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});

parcelRegister("lnW6z", function(module, exports) {

$parcel$export(module.exports, "extractLink", () => $798276e7999c5211$export$63f54cf4c5883620);

var $9W7HP = parcelRequire("9W7HP");
const $798276e7999c5211$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $9W7HP.extractUrlFromLinkJsonLd)(url);
    }
};

});

parcelRegister("cx2mN", function(module, exports) {

$parcel$export(module.exports, "extractMembers", () => $f6777de4e93b831a$export$6281d080d62a0719);

var $3gIUj = parcelRequire("3gIUj");
const $f6777de4e93b831a$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $3gIUj.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $3gIUj.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
};

});
parcelRegister("3gIUj", function(module, exports) {

$parcel$export(module.exports, "extractPersonFromJsonLd", () => $2b1bbf71ecf49172$export$c471ae5fddcf1392);

var $amPw7 = parcelRequire("amPw7");
const $2b1bbf71ecf49172$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $amPw7.extractUrlFromIconJsonLd)(person.icon)
        };
    }
};

});


parcelRegister("dlXJJ", function(module, exports) {

$parcel$export(module.exports, "extractPersonAssignedTo", () => $eecb0f85fd3e820f$export$38a0979ebf273662);

var $3gIUj = parcelRequire("3gIUj");
const $eecb0f85fd3e820f$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $3gIUj.extractPersonFromJsonLd)(assignedTo);
};

});

parcelRegister("c8AiI", function(module, exports) {

$parcel$export(module.exports, "extractPersonCreatedBy", () => $62e4f86ca3f5f110$export$a66235cba0c9d11a);

var $3gIUj = parcelRequire("3gIUj");
const $62e4f86ca3f5f110$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $3gIUj.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $3gIUj.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
};

});

parcelRegister("gd1O9", function(module, exports) {

$parcel$export(module.exports, "extractPersonUpdatedBy", () => $20f4bd3f1c7a69fa$export$8a2d1ed7e6f336f0);

var $3gIUj = parcelRequire("3gIUj");
const $20f4bd3f1c7a69fa$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $3gIUj.extractPersonFromJsonLd)(updatedBy);
};

});

parcelRegister("c0qOM", function(module, exports) {

$parcel$export(module.exports, "extractByline", () => $8bda49a4fefe485b$export$1bc5d7728bb194e9);

var $eUqFw = parcelRequire("eUqFw");

var $8M1qS = parcelRequire("8M1qS");

var $9KU0P = parcelRequire("9KU0P");

var $h1sO6 = parcelRequire("h1sO6");
var $dGfXu = parcelRequire("dGfXu");
var $c8AiI = parcelRequire("c8AiI");
var $gd1O9 = parcelRequire("gd1O9");
const $8bda49a4fefe485b$export$1bc5d7728bb194e9 = (jsonLd)=>{
    const updatedAt = (0, $dGfXu.extractDateUpdated)(jsonLd);
    const createdAt = (0, $h1sO6.extractDateCreated)(jsonLd);
    if (updatedAt) {
        const { value: value, unit: unit } = (0, $9KU0P.selectUnit)(new Date(updatedAt).getTime());
        const updatedBy = (0, $gd1O9.extractPersonUpdatedBy)(jsonLd);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "Updated ", updatedBy && `by ${updatedBy.name}`, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8M1qS.default), {
            value: value,
            unit: unit
        }));
    } else if (createdAt) {
        const { value: value, unit: unit } = (0, $9KU0P.selectUnit)(new Date(createdAt).getTime());
        const createdBy = (0, $c8AiI.extractPersonCreatedBy)(jsonLd);
        const createdByPerson = $8bda49a4fefe485b$var$extractFirstPerson(createdBy);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "Created ", createdByPerson && `by ${createdByPerson.name}`, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8M1qS.default), {
            value: value,
            unit: unit
        }));
    }
};
const $8bda49a4fefe485b$var$extractFirstPerson = (persons)=>{
    if (persons && persons.length > 0) return persons.shift();
};

});
parcelRegister("h1sO6", function(module, exports) {

$parcel$export(module.exports, "extractDateCreated", () => $b0559218890d0714$export$e1226a5e0bbbf862);
const $b0559218890d0714$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
};

});

parcelRegister("dGfXu", function(module, exports) {

$parcel$export(module.exports, "extractDateUpdated", () => $172490fac0121aa1$export$7fc2f5e6f9d22ae7);
const $172490fac0121aa1$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
};

});


parcelRegister("jz6eD", function(module, exports) {

$parcel$export(module.exports, "extractTitlePrefix", () => $e3e61f5b1a73576a$export$58d9bc37318dfb32);
const $e3e61f5b1a73576a$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $e3e61f5b1a73576a$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $e3e61f5b1a73576a$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers === null || renderers === void 0 ? void 0 : renderers.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};

});

parcelRegister("9n9Zb", function(module, exports) {

$parcel$export(module.exports, "getActionsFromJsonLd", () => $6d2e0200c6319b86$export$8f031784a3a03b23);
$parcel$export(module.exports, "extractClientActions", () => $6d2e0200c6319b86$export$75be35b463ab3fda);

var $1uLp2 = parcelRequire("1uLp2");

var $10Htb = parcelRequire("10Htb");

var $cua7B = parcelRequire("cua7B");

var $5gRnk = parcelRequire("5gRnk");
const $6d2e0200c6319b86$var$isClientAction = (action)=>[
        'ViewAction',
        'DownloadAction'
    ].indexOf(action['@type']) > -1;
const $6d2e0200c6319b86$var$getClientAction = (jsonLd, action)=>{
    switch(action['@type']){
        case 'ViewAction':
            return (0, $1uLp2.ViewAction)({
                url: jsonLd.url
            });
        case 'DownloadAction':
            return (0, $10Htb.DownloadAction)({
                url: jsonLd['atlassian:downloadUrl']
            });
    }
};
const $6d2e0200c6319b86$var$isActionEnabled = (action, actionOptions)=>{
    switch(action['@type']){
        case 'ViewAction':
            return (0, $5gRnk.canShowAction)((0, $cua7B.CardAction).ViewAction, actionOptions);
        case 'DownloadAction':
            return (0, $5gRnk.canShowAction)((0, $cua7B.CardAction).DownloadAction, actionOptions);
    }
    return true;
};
const $6d2e0200c6319b86$var$getClientActionProps = (jsonLd, action, handler)=>{
    const clientAction = $6d2e0200c6319b86$var$getClientAction(jsonLd, action);
    const clientActionInvokeOpts = {
        type: 'client',
        key: action.identifier,
        action: {
            type: action['@type'],
            promise: clientAction.promise
        }
    };
    // Send client actions through common invocation flow; for analytics
    // and, in future, in order to propagate state changes.
    return {
        ...clientAction,
        promise: ()=>handler(clientActionInvokeOpts)
    };
};
const $6d2e0200c6319b86$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};
function $6d2e0200c6319b86$export$75be35b463ab3fda(jsonLd, handler, actionOptions) {
    const actions = $6d2e0200c6319b86$export$8f031784a3a03b23(jsonLd);
    const clientActions = actions.filter((action)=>$6d2e0200c6319b86$var$isClientAction(action) && $6d2e0200c6319b86$var$isActionEnabled(action, actionOptions));
    const clientActionImpls = clientActions.map((action)=>$6d2e0200c6319b86$var$getClientActionProps(jsonLd, action, handler));
    return clientActionImpls;
}

});
parcelRegister("1uLp2", function(module, exports) {

$parcel$export(module.exports, "ViewAction", () => $116d5cfd3b7d6667$export$a96f88e1928d92fa);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $6D8aU = parcelRequire("6D8aU");

var $6MLxR = parcelRequire("6MLxR");
const $116d5cfd3b7d6667$export$a96f88e1928d92fa = ({ url: url })=>({
        id: 'view-content',
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).view),
        promise: ()=>(0, $6MLxR.openUrl)(url)
    });

});

parcelRegister("10Htb", function(module, exports) {

$parcel$export(module.exports, "DownloadAction", () => $0bc782b23745a842$export$7a2b423858a679ca);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $6D8aU = parcelRequire("6D8aU");

var $6MLxR = parcelRequire("6MLxR");
const $0bc782b23745a842$export$7a2b423858a679ca = ({ url: url })=>({
        id: 'download-content',
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).download),
        promise: ()=>(0, $6MLxR.downloadUrl)(url)
    });

});

parcelRegister("5gRnk", function(module, exports) {

$parcel$export(module.exports, "canShowAction", () => $3d67d99bb20afd90$export$2487b058456cca75);
const $3d67d99bb20afd90$export$2487b058456cca75 = (action, actionOptions)=>{
    var _actionOptions$exclud;
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || (_actionOptions$exclud = actionOptions.exclude) !== null && _actionOptions$exclud !== void 0 && _actionOptions$exclud.includes(action)) return false;
    return true;
};

});


parcelRegister("5IFe2", function(module, exports) {

$parcel$export(module.exports, "extractPreviewAction", () => $42a10a55daf48a8b$export$eba2f3246148e526);

var $cua7B = parcelRequire("cua7B");

var $79s2Z = parcelRequire("79s2Z");

var $fQDHB = parcelRequire("fQDHB");
var $ebCNT = parcelRequire("ebCNT");

var $adl12 = parcelRequire("adl12");

var $hXWLE = parcelRequire("hXWLE");

var $kGerj = parcelRequire("kGerj");

var $5gRnk = parcelRequire("5gRnk");
const $42a10a55daf48a8b$var$getMetadataFromJsonLd = (jsonLd, platform)=>{
    const download = (0, $79s2Z.extractDownloadUrl)(jsonLd);
    const provider = (0, $ebCNT.extractProvider)(jsonLd);
    const preview = (0, $fQDHB.extractPreview)(jsonLd, platform);
    return {
        download: download,
        providerName: provider && provider.text,
        src: preview && preview.src
    };
};
const $42a10a55daf48a8b$var$getMetadataFromResolvedProps = (props)=>({
        /* It's fine for content to be undefined, but src is still needed for the link out, even if it's not the source for the iframing */ link: props.link,
        title: props.title,
        details: props.details,
        icon: props.icon,
        url: props.link,
        byline: props.byline,
        isTrusted: props.isTrusted
    });
const $42a10a55daf48a8b$var$getInvokeOpts = (key, action, source)=>({
        type: 'client',
        key: key,
        // NB: the preview action is invoked from a block card -
        // the actions on the preview state are invoked from the
        // preview card. Hence, we have a `source` for distinguishing
        // between the two.
        source: source || (0, $hXWLE.CardDisplay).EmbedPreview,
        action: {
            type: action,
            promise: ()=>Promise.resolve()
        }
    });
const $42a10a55daf48a8b$export$eba2f3246148e526 = ({ extensionKey: extensionKey = 'empty-object-provider', viewProps: viewProps, jsonLd: jsonLd, handleInvoke: handleInvoke, testId: testId, platform: platform, origin: origin, source: source = 'block', analytics: analytics, meta: meta, actionOptions: actionOptions })=>{
    if (!(0, $5gRnk.canShowAction)((0, $cua7B.CardAction).PreviewAction, actionOptions)) return;
    // Extract metadata from view props & raw JSON-LD.
    const metadataFromJsonLd = $42a10a55daf48a8b$var$getMetadataFromJsonLd(jsonLd, platform);
    const metadataFromViewProps = $42a10a55daf48a8b$var$getMetadataFromResolvedProps(viewProps);
    const metadata = {
        ...metadataFromJsonLd,
        ...metadataFromViewProps
    };
    // Extract preview action only if we have an iframe src.
    if (metadataFromJsonLd.src) {
        // Build action using instrumentation hooks.
        const key = extensionKey;
        const previewAction = (0, $adl12.default)({
            ...metadata,
            analytics: analytics,
            extensionKey: extensionKey,
            origin: origin,
            testId: testId,
            isSupportTheming: (0, $kGerj.extractIsSupportTheming)(meta)
        });
        // Setup props to go through proper Redux 'invocation' flow
        // for analytics, further state management if required in future.
        const previewActionProps = $42a10a55daf48a8b$var$getInvokeOpts(key, 'PreviewAction', source);
        // - Promise invoked by the action invocation handler; open preview.
        previewActionProps.action.promise = previewAction.promise;
        // - Promise invoked on click of `Preview` on block card; trigger above promise.
        previewAction.promise = ()=>handleInvoke(previewActionProps);
        return previewAction;
    }
};

});
parcelRegister("79s2Z", function(module, exports) {

$parcel$export(module.exports, "extractDownloadUrl", () => $534f21456a0d5f36$export$9682e3ac9d184e95);
const $534f21456a0d5f36$export$9682e3ac9d184e95 = (jsonLd)=>{
    if (jsonLd['atlassian:downloadUrl']) return jsonLd['atlassian:downloadUrl'];
};

});

parcelRegister("adl12", function(module, exports) {

$parcel$export(module.exports, "default", () => $76fb6b8b840cb150$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $6D8aU = parcelRequire("6D8aU");

var $70bdc = parcelRequire("70bdc");
var /*
Most of these are optional as we are being fault-tolerant
However src, details, icon, title, and providerName are STRONGLY encouraged
*/ $76fb6b8b840cb150$export$2e2bcd8739ae039 = ({ details: details, ...rest })=>({
        id: 'preview-content',
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).preview_improved),
        promise: ()=>(0, $70bdc.openEmbedModal)({
                providerName: 'Preview',
                showModal: true,
                onClose: ()=>{},
                ...rest
            })
    });

});
parcelRegister("70bdc", function(module, exports) {

$parcel$export(module.exports, "openEmbedModal", () => $51913af2e1476fef$export$7859f96cd8cff034);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $3dpxL = parcelRequire("3dpxL");
const $51913af2e1476fef$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $51913af2e1476fef$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $51913af2e1476fef$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($51913af2e1476fef$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $51913af2e1476fef$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("8fBhP"));
    (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Modal.default, (0, $kU09D.default)({}, props, {
        iframeName: $51913af2e1476fef$var$IFRAME_NAME,
        onClose: (_context)=>{
            if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unmountComponentAtNode(popupMountPoint);
            if (onClose) onClose(_context);
        },
        showModal: true
    }))), popupMountPoint);
}

});
parcelRegister("8fBhP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('dRUyL')
        ]);
        const value = parcelRequire('6mEuM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("dRUyL")
    ]).then(()=>parcelRequire('6mEuM'));
}

});



parcelRegister("hXWLE", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $d14588657724b511$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $d14588657724b511$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $d14588657724b511$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $d14588657724b511$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $d14588657724b511$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $d14588657724b511$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $d14588657724b511$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $d14588657724b511$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $d14588657724b511$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $d14588657724b511$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $d14588657724b511$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $d14588657724b511$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $d14588657724b511$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $d14588657724b511$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $d14588657724b511$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $d14588657724b511$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $d14588657724b511$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $d14588657724b511$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $d14588657724b511$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $d14588657724b511$export$6ca4ef8b3dc2c804);
const $d14588657724b511$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $d14588657724b511$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $d14588657724b511$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $d14588657724b511$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $d14588657724b511$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
let $d14588657724b511$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
let $d14588657724b511$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
let $d14588657724b511$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
let $d14588657724b511$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
let $d14588657724b511$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
let $d14588657724b511$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
let $d14588657724b511$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
let $d14588657724b511$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
let $d14588657724b511$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["Title"] = "Title";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
let $d14588657724b511$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["ViewAction"] = "ViewAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
let $d14588657724b511$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
let $d14588657724b511$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
let $d14588657724b511$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
let $d14588657724b511$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
let $d14588657724b511$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("kGerj", function(module, exports) {

$parcel$export(module.exports, "extractIsSupportTheming", () => $f0e2ee4624ea89c1$export$38d755f52cdf4acb);

var $590Ns = parcelRequire("590Ns");
const $f0e2ee4624ea89c1$export$38d755f52cdf4acb = (meta)=>{
    return Boolean((meta === null || meta === void 0 ? void 0 : meta.key) && (0, $590Ns.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});


parcelRegister("1adpH", function(module, exports) {

$parcel$export(module.exports, "extractIsTrusted", () => $0d912147dcdd9e16$export$4f3ffbb500daac5a);
const $0d912147dcdd9e16$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean((meta === null || meta === void 0 ? void 0 : meta.key) && meta.key !== 'iframely-object-provider');
};

});


parcelRegister("7o9uG", function(module, exports) {

$parcel$export(module.exports, "useSmartCardActions", () => $56122391e4b5e5b4$export$f7c340395f31e832);

var $eUqFw = parcelRequire("eUqFw");

var $5lhyG = parcelRequire("5lhyG");

var $gqldc = parcelRequire("gqldc");

var $6EHO5 = parcelRequire("6EHO5");

var $akLqG = parcelRequire("akLqG");

var $hXWLE = parcelRequire("hXWLE");

var $9r9En = parcelRequire("9r9En");

var $j1VK5 = parcelRequire("j1VK5");
const $56122391e4b5e5b4$export$f7c340395f31e832 = (id, url, analytics)=>{
    const resolveUrl = (0, $9r9En.default)();
    const invokeClientAction = (0, $j1VK5.default)({
        analytics: analytics
    });
    const { store: store } = (0, $gqldc.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $eUqFw.useCallback)(()=>{
        var _getState$url;
        const { details: details, status: status, metadataStatus: metadataStatus } = (_getState$url = getState()[url]) !== null && _getState$url !== void 0 ? _getState$url : {
            status: (0, $hXWLE.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $eUqFw.useCallback)((metadataStatus)=>{
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $eUqFw.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $eUqFw.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $eUqFw.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $akLqG.getDefinitionId)(details);
        if (definitionId) (0, $akLqG.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $eUqFw.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $eUqFw.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $akLqG.getDefinitionId)(details);
        const extensionKey = (0, $akLqG.getExtensionKey)(details);
        const services = (0, $akLqG.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') analytics.ui.authEvent({
            display: appearance,
            definitionId: definitionId,
            extensionKey: extensionKey
        });
        if (status === 'forbidden') analytics.ui.authAlternateAccountEvent({
            display: appearance,
            definitionId: definitionId,
            extensionKey: extensionKey
        });
        if (services.length > 0) {
            analytics.screen.authPopupEvent({
                definitionId: definitionId,
                extensionKey: extensionKey
            });
            (0, $5lhyG.auth)(services[0].url).then(()=>{
                analytics.track.appAccountConnected({
                    definitionId: definitionId,
                    extensionKey: extensionKey
                });
                analytics.operational.connectSucceededEvent({
                    id: id,
                    definitionId: definitionId,
                    extensionKey: extensionKey
                });
                reload();
            }, (err)=>{
                analytics.operational.connectFailedEvent({
                    id: id,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    reason: err.type
                });
                if (err.type === 'auth_window_closed') analytics.ui.closedAuthEvent({
                    display: appearance,
                    definitionId: definitionId,
                    extensionKey: extensionKey
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        analytics.ui,
        analytics.screen,
        analytics.track,
        analytics.operational,
        id,
        reload
    ]);
    const invoke = (0, $eUqFw.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("9r9En", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dee1eff576570ff$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $fN0cF = parcelRequire("fN0cF");

var $6EHO5 = parcelRequire("6EHO5");
var $f9yXU = parcelRequire("f9yXU");
var $4hPjC = parcelRequire("4hPjC");


var $ji7R0 = parcelRequire("ji7R0");

var $hXWLE = parcelRequire("hXWLE");

var $gqldc = parcelRequire("gqldc");
const $6dee1eff576570ff$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, dispatch the resolved action for the card.
    const { store: store, connections: connections, config: config } = (0, $gqldc.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $eUqFw.useCallback)((url, metadataStatus)=>{
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $eUqFw.useCallback)((url, error, response, isMetadataRequest)=>{
        const { details: details } = getState()[url] || {
            status: (0, $hXWLE.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If there's no previous data in the store for this URL, then bail
            // out and let the editor handle fallbacks (returns to a blue link).
            if (!hasData && status !== 'resolved') {
                dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVED), {
                url: url
            }, details));
        // Handle AuthErrors (user did not have access to resource) -
        // Missing AAID in ASAP claims, or missing UserContext, or 403 from downstream
        } else if (error.kind === 'auth') dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVED), {
            url: url
        }, (0, $ji7R0.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $eUqFw.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $eUqFw.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $4hPjC.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $f9yXU.APIError)('fallback', hostname, (0, $c748b5848fe44fc9$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $f9yXU.APIError)('fatal', hostname, (0, $c748b5848fe44fc9$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $f9yXU.APIError)('error', hostname, (0, $c748b5848fe44fc9$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
     * Using unstable_batchedUpdates because this store update happens async and trigers a rerender
     * more info:
     * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
     * https://react-redux.js.org/api/batch
     */ (0, $lEfVV.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $eUqFw.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $hXWLE.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data);
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $fN0cF.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $6dee1eff576570ff$export$2e2bcd8739ae039 = $6dee1eff576570ff$var$useResolve;

});
const $c748b5848fe44fc9$export$297c39c8b9bfca0 = 'resolving';
const $c748b5848fe44fc9$export$b64a888338c24e0e = 'errored';
const $c748b5848fe44fc9$export$677b6edfa0002c70 = 'fallback';
const $c748b5848fe44fc9$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $c748b5848fe44fc9$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $c748b5848fe44fc9$export$338f7d9ccca1975d = 'Error resolving metadata.';

parcelRegister("ji7R0", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $e0b5ca614f07b5ab$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $e0b5ca614f07b5ab$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $e0b5ca614f07b5ab$export$e32193033a594efb);
const $e0b5ca614f07b5ab$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $e0b5ca614f07b5ab$export$2796a804c6e44f63 = ()=>$e0b5ca614f07b5ab$var$emptyData;
const $e0b5ca614f07b5ab$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$e0b5ca614f07b5ab$var$emptyData
        }
    });
const $e0b5ca614f07b5ab$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$e0b5ca614f07b5ab$var$emptyData
        }
    });

});


parcelRegister("j1VK5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddaae6b9f5f68f6d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $aSzRC = parcelRequire("aSzRC");

var $fN0cF = parcelRequire("fN0cF");
const $ddaae6b9f5f68f6d$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $ddaae6b9f5f68f6d$var$useInvokeClientAction = ({ analytics: analytics })=>(0, $eUqFw.useCallback)(async ({ actionType: actionType, actionFn: actionFn, extensionKey: extensionKey, display: display })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $aSzRC.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $fN0cF.startUfoExperience)($ddaae6b9f5f68f6d$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            analytics === null || analytics === void 0 || analytics.ui.actionClickedEvent({
                actionType: actionType,
                display: display
            });
            // Invoke action
            const result = await actionFn();
            $aSzRC.mark(markName, 'resolved');
            (0, $fN0cF.succeedUfoExperience)($ddaae6b9f5f68f6d$var$ACTION_EXPERIENCE_NAME, experienceId);
            analytics === null || analytics === void 0 || analytics.operational.invokeSucceededEvent({
                actionType: actionType,
                display: display
            });
            return result;
        } catch (err) {
            $aSzRC.mark(markName, 'errored');
            (0, $fN0cF.failUfoExperience)($ddaae6b9f5f68f6d$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err === null || err === void 0 ? void 0 : err.message;
            analytics === null || analytics === void 0 || analytics.operational.invokeFailedEvent({
                actionType: actionType,
                display: display,
                reason: reason
            });
        }
    }, [
        analytics === null || analytics === void 0 ? void 0 : analytics.operational,
        analytics === null || analytics === void 0 ? void 0 : analytics.ui
    ]);
var $ddaae6b9f5f68f6d$export$2e2bcd8739ae039 = $ddaae6b9f5f68f6d$var$useInvokeClientAction;

});


parcelRegister("fMym1", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $b7d5fcbe8f1cab83$export$b0444d00ba7313c6);

var $awFmn = parcelRequire("awFmn");

var $gqldc = parcelRequire("gqldc");
const $b7d5fcbe8f1cab83$var$PENDING_STATE = {
    status: 'pending'
};
function $b7d5fcbe8f1cab83$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $gqldc.useSmartLinkContext)();
    const cardState = (0, $awFmn.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState !== null && cardState !== void 0 ? cardState : $b7d5fcbe8f1cab83$var$PENDING_STATE;
}

});


parcelRegister("1hIp9", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkRenderers", () => $0ef9d2cc7b923193$export$c3514c024fefef57);

var $eUqFw = parcelRequire("eUqFw");

var $gqldc = parcelRequire("gqldc");
const $0ef9d2cc7b923193$export$c3514c024fefef57 = ()=>{
    const context = (0, $gqldc.useSmartLinkContext)();
    let renderers = context === null || context === void 0 ? void 0 : context.renderers;
    renderers = (0, $eUqFw.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};

});

parcelRegister("i7Kae", function(module, exports) {

$parcel$export(module.exports, "hoverCardClassName", () => $d31cb0a5ed399f3f$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $d31cb0a5ed399f3f$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $XHGTv = parcelRequire("XHGTv");

var $byn9U = parcelRequire("byn9U");

var $bFzGY = parcelRequire("bFzGY");

var $dmCPj = parcelRequire("dmCPj");

var $eUqFw = parcelRequire("eUqFw");

var $gqldc = parcelRequire("gqldc");

var $hXWLE = parcelRequire("hXWLE");

var $kxPGe = parcelRequire("kxPGe");

var $akLqG = parcelRequire("akLqG");

var $6MLxR = parcelRequire("6MLxR");

var $8xp05 = parcelRequire("8xp05");

var $1GraG = parcelRequire("1GraG");

var $4b8v6 = parcelRequire("4b8v6");

var $32S38 = parcelRequire("32S38");

var $fCoSP = parcelRequire("fCoSP");

var $eZqL0 = parcelRequire("eZqL0");

var $8uD7Y = parcelRequire("8uD7Y");

var $6D8aU = parcelRequire("6D8aU");

var $kyzqi = parcelRequire("kyzqi");

var $fMym1 = parcelRequire("fMym1");

var $b0pSL = parcelRequire("b0pSL");

var $gIGZ8 = parcelRequire("gIGZ8");

var $dB5iy = parcelRequire("dB5iy");
const $d31cb0a5ed399f3f$export$34883cbaea18402d = 'smart-links-hover-preview';
const $d31cb0a5ed399f3f$export$aa00abb0c6c1741e = (url)=>({
        name: (0, $hXWLE.ActionName).CustomAction,
        icon: (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))), {
            label: "copy url",
            size: "medium"
        }),
        iconPosition: 'before',
        onClick: async ()=>await navigator.clipboard.writeText(url),
        tooltipMessage: (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $6D8aU.messages).copy_url_to_clipboard),
        testId: 'hover-card-copy-button'
    });
const $d31cb0a5ed399f3f$var$HoverCardContent = ({ id: id = '', analytics: _analytics, cardActions: cardActions = [], cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions })=>{
    var _linkState$status, _cardState$details;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const defaultAnalytics = (0, $kxPGe.useSmartLinkAnalytics)(url, undefined, id);
    const analytics = _analytics !== null && _analytics !== void 0 ? _analytics : defaultAnalytics;
    const extensionKey = (0, $eUqFw.useMemo)(()=>(0, $akLqG.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $fMym1.useSmartCardState)(url);
    const linkStatus = (_linkState$status = linkState.status) !== null && _linkState$status !== void 0 ? _linkState$status : 'pending';
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $gqldc.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $dB5iy.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $akLqG.getServices)(linkState.details);
    const statusRef = (0, $eUqFw.useRef)(linkStatus);
    const analyticsRef = (0, $eUqFw.useRef)(analytics);
    (0, $eUqFw.useEffect)(()=>{
        /**
     * Must access current analytics object value via ref because its not stable
     * and it can trigger useEffect to re-run below
     */ if (analyticsRef.current !== analytics) analyticsRef.current = analytics;
        if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
    }, [
        analytics,
        linkStatus
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        analyticsRef.current.ui.hoverCardViewedEvent({
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            status: statusRef.current
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            analyticsRef.current.ui.hoverCardDismissedEvent({
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                status: statusRef.current
            });
        };
    }, []);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $6MLxR.isSpecialEvent)(event);
        analytics.ui.cardClickedEvent({
            id: id,
            display: (0, $hXWLE.CardDisplay).HoverCardPreview,
            status: cardState.status,
            isModifierKeyPressed: isModifierKeyPressed,
            actionSubjectId: 'titleGoToLink'
        });
        (0, $kyzqi.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        cardState.status,
        analytics.ui,
        id
    ]);
    const titleActions = (0, $eUqFw.useMemo)(()=>[
            $d31cb0a5ed399f3f$export$aa00abb0c6c1741e(url)
        ], [
        url
    ]);
    const data = (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.data;
    const { subtitle: subtitle } = (0, $1GraG.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        actions: (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign') ? undefined : titleActions,
        maxLines: titleMaxLines,
        overrideCss: (0, $8xp05.titleBlockCss),
        size: (0, $hXWLE.SmartLinkSize).Large,
        position: (0, $hXWLE.SmartLinkPosition).Center,
        subtitle: subtitle
    };
    const flexibleCardProps = {
        appearance: (0, $hXWLE.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        ui: (0, $8xp05.flexibleUiOptions),
        url: url,
        children: null,
        analytics: analytics
    };
    const onClickStopPropagation = (0, $eUqFw.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        if (cardState.metadataStatus === 'pending') return (0, $byn9U.jsx)((0, $4b8v6.default), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services !== null && services !== void 0 && services.length) return (0, $byn9U.jsx)((0, $32S38.default), {
            analytics: analytics,
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return (0, $byn9U.jsx)((0, $b0pSL.default), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') {
            if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign')) return (0, $byn9U.jsx)((0, $eZqL0.default), {
                analytics: analytics,
                cardState: cardState,
                extensionKey: extensionKey,
                flexibleCardProps: flexibleCardProps,
                isAISummaryEnabled: isAISummaryEnabled,
                onActionClick: onActionClick,
                titleBlockProps: titleBlockProps,
                url: url
            });
            return (0, $byn9U.jsx)((0, $fCoSP.default), {
                id: id,
                url: url,
                extensionKey: extensionKey,
                analytics: analytics,
                cardActions: cardActions,
                cardState: cardState,
                flexibleCardProps: flexibleCardProps,
                isAISummaryEnabled: isAISummaryEnabled,
                onActionClick: onActionClick,
                titleBlockProps: titleBlockProps
            });
        }
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? (0, $byn9U.jsx)((0, $gIGZ8.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url
    }, cardView) : null;
};
var $d31cb0a5ed399f3f$export$2e2bcd8739ae039 = $d31cb0a5ed399f3f$var$HoverCardContent;

});
parcelRegister("dmCPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bab72963b78cefe$var$_react = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9bab72963b78cefe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9bab72963b78cefe$var$CopyIcon = (props)=>/*#__PURE__*/ $9bab72963b78cefe$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M10 19h8V8h-8v11zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2.001 2.001 0 018 19.008V7.992z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13H5zm2 0h8V5H7v11z"/></g></svg>`
    }, props));
$9bab72963b78cefe$var$CopyIcon.displayName = 'CopyIcon';
var $9bab72963b78cefe$var$_default = $9bab72963b78cefe$var$CopyIcon;
module.exports.default = $9bab72963b78cefe$var$_default;

});

parcelRegister("8xp05", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $6374cc5d6b5b25b1$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptions", () => $6374cc5d6b5b25b1$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $6374cc5d6b5b25b1$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $6374cc5d6b5b25b1$export$e7cae8c75d768024);
$parcel$export(module.exports, "separatorCss", () => $6374cc5d6b5b25b1$export$a967860c7ee2c3e1);
$parcel$export(module.exports, "HoverCardContainer", () => $6374cc5d6b5b25b1$export$f57be4bd7a4d32ec);
$parcel$export(module.exports, "titleBlockCss", () => $6374cc5d6b5b25b1$export$ec02d9e26e1aed66);
$parcel$export(module.exports, "getTransitionStyles", () => $6374cc5d6b5b25b1$export$cfbcd9a4c0ed32ac);
$parcel$export(module.exports, "popupContainerStyles", () => $6374cc5d6b5b25b1$export$40ef6bd85f8ebb71);
$parcel$export(module.exports, "getPreviewBlockStyles", () => $6374cc5d6b5b25b1$export$190eda52f0eac4c);

var $byn9U = parcelRequire("byn9U");


var $hXWLE = parcelRequire("hXWLE");

var $lcnyw = parcelRequire("lcnyw");

var $XHGTv = parcelRequire("XHGTv");
const $6374cc5d6b5b25b1$export$8245b0eaabf3440c = (0, $lcnyw.layers).modal();
const $6374cc5d6b5b25b1$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    size: (0, $hXWLE.SmartLinkSize).Medium,
    hideHoverCardPreviewButton: false,
    zIndex: $6374cc5d6b5b25b1$export$8245b0eaabf3440c + 1
};
const $6374cc5d6b5b25b1$export$a0a37c997fbcd678 = 24;
const $6374cc5d6b5b25b1$export$337e78d5d001376e = 25;
const $6374cc5d6b5b25b1$export$e7cae8c75d768024 = 10;
const $6374cc5d6b5b25b1$var$blockGap = '0.5rem';
const $6374cc5d6b5b25b1$var$elementGap = '0.5rem';
const $6374cc5d6b5b25b1$export$a967860c7ee2c3e1 = (0, $byn9U.css)({
    '[data-separator] + [data-separator]:before': {
        marginRight: $6374cc5d6b5b25b1$var$elementGap
    }
});
const $6374cc5d6b5b25b1$export$f57be4bd7a4d32ec = (0, $byn9U.css)`
  background: none;
  border-width: 0;
  box-sizing: border-box;
  width: ${(0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-ai-summaries') ? $6374cc5d6b5b25b1$export$337e78d5d001376e : $6374cc5d6b5b25b1$export$a0a37c997fbcd678}rem;

  .${(0, $7542e4d7d8a7eead$export$4b2b7d155f69aed4)} {
    display: none;
  }
`;
const $6374cc5d6b5b25b1$export$ec02d9e26e1aed66 = (0, $byn9U.css)`
  gap: ${$6374cc5d6b5b25b1$var$blockGap};

  ${$6374cc5d6b5b25b1$export$a967860c7ee2c3e1}

  // title and subtitle element group
  [data-smart-element-group] {
    // gap between title and subtitle
    gap: 0.06rem;
    display: flex;
    /* subtitle element group */
    > [data-smart-element-group] {
      > span {
        margin-right: ${$6374cc5d6b5b25b1$var$elementGap};
      }
    }
  }

  [data-smart-element='Title'] {
    font-weight: 600;
  }
`;
const $6374cc5d6b5b25b1$export$cfbcd9a4c0ed32ac = (snippetHeight)=>(0, $byn9U.css)({
        transition: 'height 300ms ease-in-out',
        height: `${snippetHeight}px`
    });
const $6374cc5d6b5b25b1$export$40ef6bd85f8ebb71 = (0, $byn9U.css)({
    borderRadius: "var(--ds-border-radius-200, 8px)",
    backgroundColor: "var(--ds-surface-overlay, white)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px rgba(9, 30, 66, 0.15),0px 0px 1px rgba(9, 30, 66, 0.31))"
});
const $6374cc5d6b5b25b1$export$190eda52f0eac4c = (previewHeight)=>(0, $byn9U.css)(previewHeight ? `height: ${previewHeight}px;` : '', {
        borderTopLeftRadius: "var(--ds-border-radius-200, 8px)",
        borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
        marginBottom: $6374cc5d6b5b25b1$var$blockGap
    });

});
const $7542e4d7d8a7eead$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';


parcelRegister("1GraG", function(module, exports) {

$parcel$export(module.exports, "getMetadata", () => $139eca5c30585a82$export$8548546c0aa631e6);

var $hXWLE = parcelRequire("hXWLE");

var $4yj9H = parcelRequire("4yj9H");

var $efLNK = parcelRequire("efLNK");

var $XHGTv = parcelRequire("XHGTv");
const $139eca5c30585a82$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    var _data$Type$includes, _data$Type;
    const types = data ? (0, $4yj9H.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $hXWLE.ElementName).AuthorGroup,
            (0, $hXWLE.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types !== null && types !== void 0 && types.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $hXWLE.ElementName).AuthorGroup,
                    (0, $hXWLE.ElementName).ModifiedOn,
                    (0, $hXWLE.ElementName).SubscriberCount,
                    (0, $hXWLE.ElementName).State
                ],
                subtitle: [
                    (0, $hXWLE.ElementName).SourceBranch,
                    (0, $hXWLE.ElementName).TargetBranch
                ]
            };
            if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.extractor.improve-bitbucket-file-links') && types !== null && types !== void 0 && types.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $hXWLE.ElementName).LatestCommit,
                    (0, $hXWLE.ElementName).CollaboratorGroup,
                    (0, $hXWLE.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $hXWLE.ElementName).AuthorGroup,
                    (0, $hXWLE.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $efLNK.extractOwnedBy)(data) ? (0, $hXWLE.ElementName).OwnedByGroup : (0, $hXWLE.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $hXWLE.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $hXWLE.ElementName).ReactCount,
                    (0, $hXWLE.ElementName).CommentCount,
                    (0, $hXWLE.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = (_data$Type$includes = data === null || data === void 0 ? void 0 : (_data$Type = data['@type']) === null || _data$Type === void 0 ? void 0 : _data$Type.includes('atlassian:Task')) !== null && _data$Type$includes !== void 0 ? _data$Type$includes : false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $hXWLE.ElementName).AssignedToGroup,
                        (0, $hXWLE.ElementName).State,
                        (0, $hXWLE.ElementName).StoryPoints,
                        (0, $hXWLE.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $hXWLE.ElementName).CollaboratorGroup,
                    (0, $hXWLE.ElementName).State,
                    (0, $hXWLE.ElementName).DueOn
                ],
                secondary: [
                    (0, $hXWLE.ElementName).ReactCount,
                    (0, $hXWLE.ElementName).CommentCount,
                    (0, $hXWLE.ElementName).AttachmentCount,
                    (0, $hXWLE.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $hXWLE.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types !== null && types !== void 0 && types.includes('atlassian:Project')) return {
                primary: [
                    (0, $hXWLE.ElementName).AuthorGroup,
                    (0, $hXWLE.ElementName).ModifiedOn,
                    (0, $hXWLE.ElementName).State,
                    (0, $hXWLE.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $hXWLE.ElementName).AuthorGroup,
                    (0, $hXWLE.ElementName).State,
                    (0, $hXWLE.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $hXWLE.ElementName).AuthorGroup,
                    (0, $hXWLE.ElementName).SentOn
                ],
                tertiary: [
                    (0, $hXWLE.ElementName).ReactCount,
                    (0, $hXWLE.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $hXWLE.ElementName).AuthorGroup,
                    (0, $hXWLE.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $139eca5c30585a82$var$AvatarGroupsWithNamePrefix = [
    (0, $hXWLE.ElementName).AssignedToGroup,
    (0, $hXWLE.ElementName).OwnedByGroup,
    (0, $hXWLE.ElementName).AuthorGroup
];
const $139eca5c30585a82$var$toElementItem = (name)=>{
    const showNamePrefix = $139eca5c30585a82$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $139eca5c30585a82$var$toElementItems = (elementNames)=>{
    if (!(elementNames !== null && elementNames !== void 0 && elementNames.length)) return;
    return elementNames.filter((name)=>name in (0, $hXWLE.ElementName)).map($139eca5c30585a82$var$toElementItem);
};
const $139eca5c30585a82$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $139eca5c30585a82$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign') ? [].concat(metadata.primary, metadata.tertiary) : metadata.primary;
    // `tertiary` should be removed completely during cleanup:
    // https://product-fabric.atlassian.net/browse/EDM-9556
    const tertiary = (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign') ? undefined : metadata.tertiary;
    return {
        subtitle: $139eca5c30585a82$var$toElementItems(metadata.subtitle),
        primary: $139eca5c30585a82$var$toElementItems(primary),
        secondary: $139eca5c30585a82$var$toElementItems(metadata.secondary),
        tertiary: $139eca5c30585a82$var$toElementItems(tertiary)
    };
};

});
parcelRegister("efLNK", function(module, exports) {

$parcel$export(module.exports, "extractCommentCount", () => $a6078bc9acfb8468$export$b68822b76d5d51d5);
$parcel$export(module.exports, "extractDueOn", () => $a6078bc9acfb8468$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $a6078bc9acfb8468$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractReactCount", () => $a6078bc9acfb8468$export$44130aa92252501);
$parcel$export(module.exports, "extractVoteCount", () => $a6078bc9acfb8468$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $a6078bc9acfb8468$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $a6078bc9acfb8468$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $a6078bc9acfb8468$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractCreatedBy", () => $a6078bc9acfb8468$export$69b10d653f96288b);
$parcel$export(module.exports, "extractModifiedBy", () => $a6078bc9acfb8468$export$bcb193c84c865ec9);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $a6078bc9acfb8468$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $a6078bc9acfb8468$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $a6078bc9acfb8468$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractAttachmentCount", () => $a6078bc9acfb8468$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $a6078bc9acfb8468$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $a6078bc9acfb8468$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $a6078bc9acfb8468$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $a6078bc9acfb8468$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractReadTime", () => $a6078bc9acfb8468$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSentOn", () => $a6078bc9acfb8468$export$b592ddecae70b61d);
$parcel$export(module.exports, "extractStoryPoints", () => $a6078bc9acfb8468$export$bdcea84d1550eb9d);

var $dlXJJ = parcelRequire("dlXJJ");
var $c8AiI = parcelRequire("c8AiI");
var $dMa80 = parcelRequire("dMa80");
var $gd1O9 = parcelRequire("gd1O9");
const $a6078bc9acfb8468$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $a6078bc9acfb8468$var$extractValue = (data, key)=>{
    return data === null || data === void 0 ? void 0 : data[key];
};
const $a6078bc9acfb8468$export$b68822b76d5d51d5 = (data)=>$a6078bc9acfb8468$var$extractValue(data, 'schema:commentCount');
const $a6078bc9acfb8468$export$ac56bd7a37249b48 = (data)=>$a6078bc9acfb8468$var$extractValue(data, 'endTime');
const $a6078bc9acfb8468$export$e57334ce4738e29d = (data)=>$a6078bc9acfb8468$var$extractValue(data, 'atlassian:viewCount');
const $a6078bc9acfb8468$export$44130aa92252501 = (data)=>$a6078bc9acfb8468$var$extractValue(data, 'atlassian:reactCount');
const $a6078bc9acfb8468$export$c8bef3d5e550a3a = (data)=>$a6078bc9acfb8468$var$extractValue(data, 'atlassian:voteCount');
const $a6078bc9acfb8468$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $dMa80.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $a6078bc9acfb8468$export$5546969a505305 = (data)=>{
    const person = (0, $dlXJJ.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $a6078bc9acfb8468$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $dlXJJ.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $a6078bc9acfb8468$export$69b10d653f96288b = (data)=>{
    const persons = (0, $c8AiI.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $a6078bc9acfb8468$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $gd1O9.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $a6078bc9acfb8468$export$43e54589935a1ff = (data)=>$a6078bc9acfb8468$var$extractValue(data, 'schema:programmingLanguage');
const $a6078bc9acfb8468$export$949ac6a8325b3fdb = (data)=>$a6078bc9acfb8468$var$extractLinkName(data['atlassian:mergeSource']);
const $a6078bc9acfb8468$export$8bd03a7beb5badf1 = (data)=>$a6078bc9acfb8468$var$extractValue(data, 'atlassian:subscriberCount');
const $a6078bc9acfb8468$export$65362ff78a97fd8 = (data)=>$a6078bc9acfb8468$var$extractValue(data, 'atlassian:attachmentCount');
const $a6078bc9acfb8468$export$29b0ac5d2f9890cf = (data)=>$a6078bc9acfb8468$var$extractLinkName(data['atlassian:mergeDestination']);
const $a6078bc9acfb8468$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $a6078bc9acfb8468$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $a6078bc9acfb8468$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $a6078bc9acfb8468$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $a6078bc9acfb8468$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $a6078bc9acfb8468$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $a6078bc9acfb8468$export$cc4028b2878d0675 = (data)=>{
    return $a6078bc9acfb8468$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $a6078bc9acfb8468$export$b592ddecae70b61d = (data)=>{
    return $a6078bc9acfb8468$var$extractValue(data, 'dateSent');
};
const $a6078bc9acfb8468$export$bdcea84d1550eb9d = (data)=>{
    return $a6078bc9acfb8468$var$extractValue(data, 'atlassian:storyPoints');
};

});
parcelRegister("dMa80", function(module, exports) {

$parcel$export(module.exports, "extractPersonOwnedBy", () => $ce0e432e194a4e67$export$19ee667f3f7a6ec3);

var $3gIUj = parcelRequire("3gIUj");
const $ce0e432e194a4e67$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $3gIUj.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $3gIUj.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
};

});



parcelRegister("4b8v6", function(module, exports) {

$parcel$export(module.exports, "default", () => $30aec88a49363623$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");
parcelRequire("eUqFw");

var $6fjty = parcelRequire("6fjty");

var $8xp05 = parcelRequire("8xp05");

var $dDzVl = parcelRequire("dDzVl");

var $ezIO6 = parcelRequire("ezIO6");

var $kIvR9 = parcelRequire("kIvR9");

var $5vSVw = parcelRequire("5vSVw");
const $30aec88a49363623$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $8xp05.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = (actions === null || actions === void 0 ? void 0 : actions.length) && (actions === null || actions === void 0 ? void 0 : actions.length) > 0 && (0, $byn9U.jsx)((0, $ezIO6.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return (0, $byn9U.jsx)("div", {
        css: (0, $dDzVl.loadingViewContainer),
        "data-testid": testId
    }, (0, $byn9U.jsx)("div", {
        css: (0, $dDzVl.skeletonContainer)
    }, (0, $byn9U.jsx)((0, $kIvR9.default), (0, $kU09D.default)({}, titleBlockProps, {
        overrideCss: (0, $dDzVl.titleBlockStyles),
        testId: `${testId}-title-block`
    }), (0, $byn9U.jsx)((0, $5vSVw.default), {
        render: ()=>(0, $byn9U.jsx)((0, $6fjty.default), null),
        size: size
    }), (0, $byn9U.jsx)("span", {
        css: (0, $dDzVl.getTitleStyles)(lineHeightRem),
        "data-testid": `${testId}-title`
    }, (0, $byn9U.jsx)((0, $6fjty.default), {
        height: lineHeightRem
    })), actionGroup), (0, $byn9U.jsx)((0, $6fjty.default), {
        width: skeletonWidth,
        height: lineHeightRem
    }), (0, $byn9U.jsx)((0, $6fjty.default), {
        width: skeletonWidth,
        height: lineHeightRem * 3
    }), (0, $byn9U.jsx)((0, $6fjty.default), {
        width: skeletonWidth,
        height: lineHeightRem
    })));
};
var $30aec88a49363623$export$2e2bcd8739ae039 = $30aec88a49363623$var$HoverCardLoadingView;

});
parcelRegister("6fjty", function(module, exports) {

$parcel$export(module.exports, "default", () => $48c340465aa27704$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
const $48c340465aa27704$var$LoadingSkeleton = ({ testId: testId, width: width, height: height })=>{
    const animationNameStyles = (0, $byn9U.keyframes)({
        '0%': {
            backgroundPosition: '50% 0'
        },
        '100%': {
            backgroundPosition: '-50% 0'
        }
    });
    const styles = (0, $byn9U.css)({
        width: `${width}rem`,
        height: `${height}rem`,
        borderRadius: '2px',
        userSelect: 'none',
        background: "var(--ds-skeleton-subtle, #f6f7f8)",
        backgroundImage: `linear-gradient( to right, transparent 0%, ${"var(--ds-skeleton, #edeef1)"} 20%, transparent 40%, transparent 100% )`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '280% 100%',
        display: 'inline-block',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        animationName: animationNameStyles,
        animationTimingFunction: 'linear'
    });
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
    return (0, $byn9U.jsx)("span", {
        css: styles,
        "data-testid": testId
    });
};
var $48c340465aa27704$export$2e2bcd8739ae039 = $48c340465aa27704$var$LoadingSkeleton;

});

parcelRegister("dDzVl", function(module, exports) {

$parcel$export(module.exports, "loadingViewContainer", () => $9edac8a512ebc2f9$export$a470e5777446b28);
$parcel$export(module.exports, "skeletonContainer", () => $9edac8a512ebc2f9$export$e39e8873928166f5);
$parcel$export(module.exports, "getTitleStyles", () => $9edac8a512ebc2f9$export$83146cf7d1bec659);
$parcel$export(module.exports, "titleBlockStyles", () => $9edac8a512ebc2f9$export$38125fa6916f5dab);

var $byn9U = parcelRequire("byn9U");
const $9edac8a512ebc2f9$export$a470e5777446b28 = (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: "var(--ds-space-200, 1rem)"
});
const $9edac8a512ebc2f9$export$e39e8873928166f5 = (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space -- needs manual remediation
    gap: '0.625rem',
    alignItems: 'center'
});
const $9edac8a512ebc2f9$export$83146cf7d1bec659 = (height)=>{
    return (0, $byn9U.css)({
        flex: '1 0 auto',
        height: `${height}rem`,
        span: {
            width: '100%'
        }
    });
};
const $9edac8a512ebc2f9$export$38125fa6916f5dab = (0, $byn9U.css)({
    width: '100%',
    gap: "var(--ds-space-100, 0.5rem)"
});

});

parcelRegister("ezIO6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9c7175111d225e2$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $byn9U = parcelRequire("byn9U");

var $bLFgh = parcelRequire("bLFgh");

var $8cU5f = parcelRequire("8cU5f");

var $6OfWd = parcelRequire("6OfWd");

var $hXWLE = parcelRequire("hXWLE");

var $7u4fN = parcelRequire("7u4fN");

var $jG1wZ = parcelRequire("jG1wZ");

var $jvuTK = parcelRequire("jvuTK");

var $6D8aU = parcelRequire("6D8aU");

var $l8O8E = parcelRequire("l8O8E");

var $cpPsK = parcelRequire("cpPsK");

var $aHboL = parcelRequire("aHboL");

const $a9c7175111d225e2$var$styles = (0, $byn9U.css)({
    display: 'inline-flex',
    lineHeight: '1rem',
    '> div': {
        alignItems: 'center',
        'button:focus-visible': {
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        }
    }
});
const $a9c7175111d225e2$var$renderActionItems = (items = [], size = (0, $hXWLE.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>(0, $byn9U.jsx)((0, $cpPsK.default), {
            item: item,
            key: idx,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $a9c7175111d225e2$var$ActionGroup = ({ items: items = [], size: size = (0, $hXWLE.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    const context = (0, $l8O8E.useFlexibleUiContext)();
    const ui = (0, $l8O8E.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const renderableActionItems = (0, $eUqFw.useMemo)(()=>(0, $aHboL.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $eUqFw.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $eUqFw.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $eUqFw.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $a9c7175111d225e2$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $eUqFw.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $jvuTK.sizeToButtonSpacing)[size];
            const moreIcon = (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                label: "more"
            });
            const formatMessage = (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $6D8aU.messages).more_actions);
            return (0, $byn9U.jsx)((0, $6OfWd.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>(0, $byn9U.jsx)((0, $8cU5f.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span"
                    }, (0, $byn9U.jsx)((0, $7u4fN.default), (0, $kU09D.default)({}, props, {
                        spacing: spacing,
                        testId: "action-group-more-button",
                        iconBefore: moreIcon,
                        ref: triggerRef
                    }))),
                testId: "action-group-dropdown",
                zIndex: ui === null || ui === void 0 ? void 0 : ui.zIndex
            }, $a9c7175111d225e2$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui === null || ui === void 0 ? void 0 : ui.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? (0, $byn9U.jsx)("div", {
        css: $a9c7175111d225e2$var$styles,
        className: "actions-button-group",
        "data-action-open": isOpen
    }, (0, $byn9U.jsx)((0, $bLFgh.default), null, actionButtons, moreActionDropdown)) : null;
};
var $a9c7175111d225e2$export$2e2bcd8739ae039 = $a9c7175111d225e2$var$ActionGroup;

});
parcelRegister("jvuTK", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $e338e149463fac70$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $e338e149463fac70$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $e338e149463fac70$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconSizeStyles", () => $e338e149463fac70$export$a5dfadfde90ee066);
$parcel$export(module.exports, "getIconWidth", () => $e338e149463fac70$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $e338e149463fac70$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getLinkLineHeight", () => $e338e149463fac70$export$1826e889cc97649);
$parcel$export(module.exports, "getLinkSizeStyles", () => $e338e149463fac70$export$7c3a25542ae9da0e);
$parcel$export(module.exports, "getMaxLineHeight", () => $e338e149463fac70$export$a681bd062fee88a5);
$parcel$export(module.exports, "getMaxLines", () => $e338e149463fac70$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $e338e149463fac70$export$475c391af8171fec);
$parcel$export(module.exports, "getPrimitivesPaddingSpaceBySize", () => $e338e149463fac70$export$1af10e3728e3a644);
$parcel$export(module.exports, "getTruncateStyles", () => $e338e149463fac70$export$8847c5561c06da49);
$parcel$export(module.exports, "hasWhiteSpace", () => $e338e149463fac70$export$619e376a425cb759);
$parcel$export(module.exports, "openEmbedModalWithFlexibleUiIcon", () => $e338e149463fac70$export$7207d5a516d3bfa8);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");

var $hXWLE = parcelRequire("hXWLE");

var $5vSVw = parcelRequire("5vSVw");

var $70bdc = parcelRequire("70bdc");

var $bYKiA = parcelRequire("bYKiA");
const $e338e149463fac70$export$9d642f65a919fb93 = {
    [(0, $hXWLE.SmartLinkSize).Small]: 'none',
    [(0, $hXWLE.SmartLinkSize).Medium]: 'compact',
    [(0, $hXWLE.SmartLinkSize).Large]: 'compact',
    [(0, $hXWLE.SmartLinkSize).XLarge]: 'default'
};
const $e338e149463fac70$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, descriptor, {
            values: values
        }));
    }
};
const $e338e149463fac70$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $e338e149463fac70$var$getIconDimensionStyles = (value)=>(0, $byn9U.css)({
        height: value,
        minHeight: value,
        maxHeight: value,
        width: value,
        minWidth: value,
        maxWidth: value
    });
const $e338e149463fac70$export$a5dfadfde90ee066 = (width)=>{
    const sizeStyles = $e338e149463fac70$var$getIconDimensionStyles(width);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return (0, $byn9U.css)`
    flex: 0 0 auto;
    ${sizeStyles}
    span,
    svg,
    img {
      ${sizeStyles}
    }
    svg {
      padding: 0;
    }
  `;
};
const $e338e149463fac70$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $hXWLE.SmartLinkSize).XLarge:
            return '2rem';
        case (0, $hXWLE.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $hXWLE.SmartLinkSize).Medium:
            return '1rem';
        case (0, $hXWLE.SmartLinkSize).Small:
        default:
            return '.75rem';
    }
};
const $e338e149463fac70$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $e338e149463fac70$export$1826e889cc97649 = (size)=>{
    switch(size){
        case (0, $hXWLE.SmartLinkSize).XLarge:
            return '1.5rem';
        case (0, $hXWLE.SmartLinkSize).Large:
        case (0, $hXWLE.SmartLinkSize).Medium:
        case (0, $hXWLE.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
const $e338e149463fac70$export$7c3a25542ae9da0e = (size)=>{
    switch(size){
        case (0, $hXWLE.SmartLinkSize).XLarge:
            return (0, $byn9U.css)({
                fontSize: '1.25rem',
                fontWeight: 400,
                letterSpacing: '-0.008em',
                lineHeight: $e338e149463fac70$export$1826e889cc97649(size)
            });
        case (0, $hXWLE.SmartLinkSize).Large:
        case (0, $hXWLE.SmartLinkSize).Medium:
            return (0, $byn9U.css)({
                fontSize: '0.875rem',
                fontWeight: 400,
                letterSpacing: '-0.003em',
                lineHeight: $e338e149463fac70$export$1826e889cc97649(size)
            });
        case (0, $hXWLE.SmartLinkSize).Small:
        default:
            return (0, $byn9U.css)({
                fontSize: '0.75rem',
                fontWeight: 400,
                letterSpacing: '0em',
                lineHeight: $e338e149463fac70$export$1826e889cc97649(size)
            });
    }
};
const $e338e149463fac70$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $hXWLE.SmartLinkSize).XLarge:
        case (0, $hXWLE.SmartLinkSize).Large:
            return 1.75;
        case (0, $hXWLE.SmartLinkSize).Medium:
        case (0, $hXWLE.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $e338e149463fac70$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $e338e149463fac70$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $hXWLE.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $hXWLE.SmartLinkSize).Large:
            return 'space.200';
        case (0, $hXWLE.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $hXWLE.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $e338e149463fac70$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $hXWLE.SmartLinkSize).XLarge:
            return 'space.300';
        case (0, $hXWLE.SmartLinkSize).Large:
            return 'space.250';
        case (0, $hXWLE.SmartLinkSize).Medium:
            return 'space.200';
        case (0, $hXWLE.SmartLinkSize).Small:
        default:
            return 'space.100';
    }
};
const $e338e149463fac70$export$8847c5561c06da49 = (maxLines, lineHeight = '1rem', wordBreak = 'break-word')=>(0, $byn9U.css)({
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        wordBreak: wordBreak,
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        '@supports not (-webkit-line-clamp: 1)': {
            maxHeight: `calc(${maxLines} * ${lineHeight})`
        }
    });
const $e338e149463fac70$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};
const $e338e149463fac70$export$7207d5a516d3bfa8 = ({ linkIcon: linkIcon, ...props })=>{
    const icon = {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5vSVw.default), (0, $kU09D.default)({}, linkIcon, {
            size: (0, $hXWLE.SmartLinkSize).Large
        })),
        isFlexibleUi: true
    };
    return (0, $70bdc.openEmbedModal)({
        ...props,
        icon: icon,
        // Flex should not send origin as block card. It should be able to support
        // its internal parent components like hover card, block card and
        // itself as a standalone. To be investigated and fix in EDM-7520.
        origin: 'smartLinkCard'
    });
};

});
parcelRegister("5vSVw", function(module, exports) {

$parcel$export(module.exports, "default", () => $403a744a7c2f8cc6$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $hUwRB = parcelRequire("hUwRB");

var $byn9U = parcelRequire("byn9U");

var $hXWLE = parcelRequire("hXWLE");

var $h2L5X = parcelRequire("h2L5X");

var $3GGUk = parcelRequire("3GGUk");

var $jvuTK = parcelRequire("jvuTK");
const $403a744a7c2f8cc6$var$getPositionStyles = (position)=>{
    switch(position){
        case (0, $hXWLE.SmartLinkPosition).Center:
            return (0, $byn9U.css)({
                alignSelf: 'center'
            });
        case (0, $hXWLE.SmartLinkPosition).Top:
        default:
            return (0, $byn9U.css)({
                alignSelf: 'flex-start',
                margin: 0
            });
    }
};
const $403a744a7c2f8cc6$var$getIconStyles = (position, width)=>(0, $byn9U.css)($403a744a7c2f8cc6$var$getPositionStyles(position), (0, $jvuTK.getIconSizeStyles)(width));
const $403a744a7c2f8cc6$var$getCustomRenderStyles = (value)=>(0, $byn9U.css)((0, $jvuTK.getTruncateStyles)(1, value), {
        lineHeight: value,
        fontSize: value,
        textAlign: 'center',
        textOverflow: 'clip',
        WebkitBoxOrient: 'unset',
        span: {
            margin: 0,
            padding: 0,
            verticalAlign: 'baseline'
        }
    });
const $403a744a7c2f8cc6$var$renderAtlaskitIcon = (icon, label, testId)=>{
    if (icon) return (0, $byn9U.jsx)((0, $h2L5X.default), {
        icon: icon,
        label: label,
        testId: `${testId}-icon`
    });
};
const $403a744a7c2f8cc6$var$renderDefaultIcon = (label, testId)=>(0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
        label: label,
        testId: `${testId}-default`
    });
const $403a744a7c2f8cc6$var$renderImageIcon = (defaultIcon, url, testId)=>{
    if (url) return (0, $byn9U.jsx)((0, $3GGUk.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param {IconProps} IconProps - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $403a744a7c2f8cc6$var$Icon = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $hXWLE.SmartLinkPosition).Top, overrideCss: overrideCss, render: render, size: size = (0, $hXWLE.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url })=>{
    const element = (0, $eUqFw.useMemo)(()=>{
        const defaultIcon = $403a744a7c2f8cc6$var$renderDefaultIcon(label, testId);
        return overrideIcon || (render === null || render === void 0 ? void 0 : render()) || $403a744a7c2f8cc6$var$renderImageIcon(defaultIcon, url, testId) || $403a744a7c2f8cc6$var$renderAtlaskitIcon(icon, label, testId) || defaultIcon;
    }, [
        overrideIcon,
        icon,
        label,
        render,
        testId,
        url
    ]);
    const width = (0, $jvuTK.getIconWidth)(size);
    const styles = $403a744a7c2f8cc6$var$getIconStyles(position, width);
    const renderStyles = render ? $403a744a7c2f8cc6$var$getCustomRenderStyles(width) : undefined;
    return (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
        css: [
            styles,
            renderStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId
    }, element);
};
var $403a744a7c2f8cc6$export$2e2bcd8739ae039 = $403a744a7c2f8cc6$var$Icon;

});
parcelRegister("h2L5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $c68727b1940a235e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $PdmhA = parcelRequire("PdmhA");

var $fmgFp = parcelRequire("fmgFp");
var $9QlHl = parcelRequire("9QlHl");

var $33pqc = parcelRequire("33pqc");

var $42mVw = parcelRequire("42mVw");

var $hXWLE = parcelRequire("hXWLE");





























































// prettier-ignore
const $c68727b1940a235e$var$importIconMapper = {
    [(0, $hXWLE.IconType).Archive]: ()=>Promise.resolve((parcelRequire("avXTG"))),
    [(0, $hXWLE.IconType).Audio]: ()=>Promise.resolve((parcelRequire("ax6gr"))),
    [(0, $hXWLE.IconType).Code]: ()=>(parcelRequire("3Odf5")),
    [(0, $hXWLE.IconType).Executable]: ()=>(parcelRequire("5KraK")),
    [(0, $hXWLE.IconType).File]: ()=>Promise.resolve((parcelRequire("hC3Rz"))),
    [(0, $hXWLE.IconType).Folder]: ()=>(parcelRequire("5Gpyh")),
    [(0, $hXWLE.IconType).Generic]: ()=>Promise.resolve((parcelRequire("hC3Rz"))),
    [(0, $hXWLE.IconType).GIF]: ()=>(parcelRequire("cVIlt")),
    [(0, $hXWLE.IconType).GoogleDocs]: ()=>(parcelRequire("aWo98")),
    [(0, $hXWLE.IconType).GoogleForms]: ()=>(parcelRequire("hgXDP")),
    [(0, $hXWLE.IconType).GoogleSheets]: ()=>(parcelRequire("68kEB")),
    [(0, $hXWLE.IconType).GoogleSlides]: ()=>(parcelRequire("dlbJ3")),
    [(0, $hXWLE.IconType).Image]: ()=>Promise.resolve((parcelRequire("cOsqE"))),
    [(0, $hXWLE.IconType).MSExcel]: ()=>(parcelRequire("pNNfx")),
    [(0, $hXWLE.IconType).MSPowerpoint]: ()=>(parcelRequire("fqpGs")),
    [(0, $hXWLE.IconType).MSWord]: ()=>(parcelRequire("5hO6q")),
    [(0, $hXWLE.IconType).PDF]: ()=>(parcelRequire("3kV6m")),
    [(0, $hXWLE.IconType).Presentation]: ()=>Promise.resolve((parcelRequire("iIEQk"))),
    [(0, $hXWLE.IconType).Sketch]: ()=>(parcelRequire("gwQvz")),
    [(0, $hXWLE.IconType).Spreadsheet]: ()=>Promise.resolve((parcelRequire("kaVAc"))),
    [(0, $hXWLE.IconType).Template]: ()=>Promise.resolve((parcelRequire("nzdI3"))),
    [(0, $hXWLE.IconType).Video]: ()=>Promise.resolve((parcelRequire("8DjS6"))),
    // Bitbucket icons
    [(0, $hXWLE.IconType).Branch]: ()=>Promise.resolve((parcelRequire("gQa4O"))),
    [(0, $hXWLE.IconType).Commit]: ()=>Promise.resolve((parcelRequire("fU2qj"))),
    [(0, $hXWLE.IconType).Project]: ()=>Promise.resolve((parcelRequire("iwsIy"))),
    [(0, $hXWLE.IconType).PullRequest]: ()=>Promise.resolve((parcelRequire("6VQ7Z"))),
    [(0, $hXWLE.IconType).Repo]: ()=>Promise.resolve((parcelRequire("egbU6"))),
    // Jira icons
    [(0, $hXWLE.IconType).Bug]: ()=>Promise.resolve((parcelRequire("3YEb9"))),
    [(0, $hXWLE.IconType).Change]: ()=>Promise.resolve((parcelRequire("fsJVW"))),
    [(0, $hXWLE.IconType).Epic]: ()=>Promise.resolve((parcelRequire("gFrvj"))),
    [(0, $hXWLE.IconType).Incident]: ()=>Promise.resolve((parcelRequire("bJZ7m"))),
    [(0, $hXWLE.IconType).Problem]: ()=>Promise.resolve((parcelRequire("5cywL"))),
    [(0, $hXWLE.IconType).ServiceRequest]: ()=>Promise.resolve((parcelRequire("2NYtj"))),
    [(0, $hXWLE.IconType).Story]: ()=>Promise.resolve((parcelRequire("3Fcny"))),
    [(0, $hXWLE.IconType).SubTask]: ()=>Promise.resolve((parcelRequire("aJNc8"))),
    [(0, $hXWLE.IconType).Task]: ()=>Promise.resolve((parcelRequire("hiUvC"))),
    // Provider icons
    [(0, $hXWLE.IconType).Confluence]: ()=>Promise.resolve((parcelRequire("fmgFp"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                default: ConfluenceIcon
            })),
    [(0, $hXWLE.IconType).Jira]: ()=>Promise.resolve((parcelRequire("9QlHl"))).then(({ JiraIcon: JiraIcon })=>({
                default: JiraIcon
            })),
    // Fallback icons
    [(0, $hXWLE.IconType).Default]: ()=>Promise.resolve((parcelRequire("hUwRB"))),
    [(0, $hXWLE.IconType).Error]: ()=>Promise.resolve((parcelRequire("96IgR"))),
    [(0, $hXWLE.IconType).Forbidden]: ()=>Promise.resolve((parcelRequire("f4A0J"))),
    // Badge
    [(0, $hXWLE.IconType).Attachment]: ()=>Promise.resolve((parcelRequire("jUThT"))),
    [(0, $hXWLE.IconType).CheckItem]: ()=>Promise.resolve((parcelRequire("eRawo"))),
    [(0, $hXWLE.IconType).Comment]: ()=>Promise.resolve((parcelRequire("d3vNK"))),
    [(0, $hXWLE.IconType).View]: ()=>Promise.resolve((parcelRequire("jHMvH"))),
    [(0, $hXWLE.IconType).React]: ()=>Promise.resolve((parcelRequire("fvQWm"))),
    [(0, $hXWLE.IconType).Vote]: ()=>Promise.resolve((parcelRequire("hL0Qd"))),
    [(0, $hXWLE.IconType).PriorityBlocker]: ()=>(parcelRequire("dwS3h")),
    [(0, $hXWLE.IconType).PriorityCritical]: ()=>(parcelRequire("31xay")),
    [(0, $hXWLE.IconType).PriorityHigh]: ()=>(parcelRequire("i9Yk2")),
    [(0, $hXWLE.IconType).PriorityHighest]: ()=>(parcelRequire("3Ew0R")),
    [(0, $hXWLE.IconType).PriorityLow]: ()=>(parcelRequire("5GRoj")),
    [(0, $hXWLE.IconType).PriorityLowest]: ()=>(parcelRequire("K0fRz")),
    [(0, $hXWLE.IconType).PriorityMajor]: ()=>(parcelRequire("2lHWV")),
    [(0, $hXWLE.IconType).PriorityMedium]: ()=>(parcelRequire("1QjLQ")),
    [(0, $hXWLE.IconType).PriorityMinor]: ()=>(parcelRequire("4B1vJ")),
    [(0, $hXWLE.IconType).PriorityTrivial]: ()=>(parcelRequire("lMNPH")),
    [(0, $hXWLE.IconType).PriorityUndefined]: ()=>(parcelRequire("aH6Tz")),
    [(0, $hXWLE.IconType).ProgrammingLanguage]: ()=>Promise.resolve((parcelRequire("2Q5Ee"))),
    [(0, $hXWLE.IconType).Subscriber]: ()=>Promise.resolve((parcelRequire("4nce6"))),
    [(0, $hXWLE.IconType).SubTasksProgress]: ()=>Promise.resolve((parcelRequire("eyI8O")))
};
const $c68727b1940a235e$var$getIconImportFn = (icon)=>$c68727b1940a235e$var$importIconMapper[icon];
const $c68727b1940a235e$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $c68727b1940a235e$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $hXWLE.IconType).Document:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33pqc))), {
                label: label || 'document',
                testId: testId
            });
        case (0, $hXWLE.IconType).Blog:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42mVw))), {
                label: label || 'blog',
                testId: testId
            });
    }
    const importFn = $c68727b1940a235e$var$getIconImportFn(icon);
    if (!importFn) return null;
    const ImportedIcon = $c68727b1940a235e$var$importIcon(importFn);
    switch(icon){
        case (0, $hXWLE.IconType).Confluence:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmgFp.ConfluenceIcon), {
                appearance: "brand",
                testId: testId
            });
        case (0, $hXWLE.IconType).Jira:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9QlHl.JiraIcon), {
                appearance: "brand",
                testId: testId
            });
        case (0, $hXWLE.IconType).Error:
        case (0, $hXWLE.IconType).Forbidden:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA.R400)})`
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ImportedIcon, {
                label: label,
                testId: testId
            });
    }
};
var $c68727b1940a235e$export$2e2bcd8739ae039 = $c68727b1940a235e$var$AtlaskitIcon;

});
parcelRegister("fmgFp", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $b2e5d6c99737e1de$export$68f3db7f6af48bcb);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $tkrFt = parcelRequire("tkrFt");

var $XHGTv = parcelRequire("XHGTv");

var $4q38b = parcelRequire("4q38b");

var $kbZ06 = parcelRequire("kbZ06");

var $gcXsZ = parcelRequire("gcXsZ");

var $gbb5b = parcelRequire("gbb5b");
const $b2e5d6c99737e1de$var$svg = ({ appearance: appearance, iconGradientStart: iconGradientStart, iconGradientStop: iconGradientStop, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    };
    if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.brand-refresh-update-product-logos_q7coo')) {
        // Currently the user can style the confluence icon using only iconGradientStop and iconGradientStart
        // the following is used to mimic this edge case as these two props aren't used on the new logos
        if (colors.iconColor === 'inherit') colors.iconColor = iconGradientStop;
        if (appearance) colors = (0, $gcXsZ.getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
    } else {
        // Will be fixed upon removal of deprecated iconGradientStart and
        // iconGradientStop props, or with React 18's useId() hook when we update.
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        let id = (0, $tkrFt.uid)({
            iconGradientStart: iconGradientStop
        });
        if (appearance) colors = (0, $gcXsZ.getColorsFromAppearanceOldLogos)(appearance);
        return `
    <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
      <defs>
        <linearGradient x1="60.6779047%" y1="137.626433%" x2="14.341981%" y2="112.08042%" id="${id}-1">
          <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
          <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
        </linearGradient>
        <linearGradient x1="12.3282701%" y1="-53.9760846%" x2="74.1300776%" y2="-33.2553066%" id="${id}-2">
          <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
          <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
        </linearGradient>
      </defs>
      <g stroke="none" stroke-width="1" fill-rule="nonzero">
        <path fill="url(#${id}-1)" d="M5.21454927,22.0245336 C4.97082816,22.4219865 4.69711061,22.8831818 4.46463817,23.2506383 C4.25655728,23.602269 4.36826343,24.0557627 4.71585838,24.2705174 L9.59028054,27.2701618 C9.76138278,27.3758032 9.96774369,27.4083016 10.1630326,27.3603607 C10.3583215,27.3124197 10.5261749,27.1880564 10.6289074,27.015192 C10.8238843,26.6889807 11.0751045,26.2652809 11.3488221,25.8115847 C13.2798432,22.6244625 15.2221129,23.0144163 18.7241978,24.686718 L23.5573748,26.9851956 C23.7404243,27.0723219 23.9509502,27.0816253 24.1409716,27.0109854 C24.3309931,26.9403455 24.4843191,26.7957811 24.5660052,26.61024 L26.8869801,21.3608623 C27.0509607,20.9859459 26.8841076,20.5487907 26.5120245,20.3784788 C25.4921454,19.8985357 23.4636359,18.942399 21.6376024,18.0612535 C15.0683811,14.8741313 9.48529299,15.0841064 5.21454927,22.0245336 Z"></path>
        <path fill="url(#${id}-2)" d="M27.0752616,9.74267061 C27.3190367,9.34512979 27.5928148,8.88383241 27.8253387,8.51629467 C28.0334656,8.1645861 27.9217347,7.71099215 27.5740629,7.4961899 L22.6985622,4.49588177 C22.5250856,4.3802891 22.3113292,4.3421035 22.1085604,4.39048341 C21.9057917,4.43886333 21.7323024,4.56944439 21.6297024,4.75090796 C21.4346824,5.07719147 21.1834066,5.50098499 20.9096284,5.9547816 C18.9781801,9.14260899 17.0354806,8.75256893 13.5326208,7.07989715 L8.71337588,4.78466143 C8.53028584,4.69751579 8.31971336,4.68821035 8.1296499,4.75886591 C7.93958645,4.82952147 7.78622651,4.97411777 7.70452227,5.15969994 L5.38303386,10.4102392 C5.21901692,10.7852385 5.38590698,11.2224905 5.75807237,11.3928401 C6.77817714,11.8728894 8.80713551,12.8292376 10.6335731,13.7105781 C17.2192494,16.8946551 22.8035729,16.6846336 27.0752616,9.74267061 Z"></path>
      </g>
    </svg>`;
    }
};
const $b2e5d6c99737e1de$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $kbZ06.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kbZ06.defaultLogoParams).iconColor, iconGradientStart: iconGradientStart = (0, $kbZ06.defaultLogoParams).iconGradientStart, iconGradientStop: iconGradientStop = (0, $kbZ06.defaultLogoParams).iconGradientStop, textColor: textColor = (0, $kbZ06.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gbb5b.default), {
        appearance: appearance,
        label: label,
        svg: $b2e5d6c99737e1de$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("kbZ06", function(module, exports) {

$parcel$export(module.exports, "defaultLogoParams", () => $eb34272cefb0cf23$export$438460117ae6b7ee);
$parcel$export(module.exports, "sizes", () => $eb34272cefb0cf23$export$c647cb0ee6e282fe);
/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ const $eb34272cefb0cf23$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
const $eb34272cefb0cf23$export$c647cb0ee6e282fe = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $eb34272cefb0cf23$export$31d7044b7540a6d8 = $eb34272cefb0cf23$export$438460117ae6b7ee;

});

parcelRegister("gcXsZ", function(module, exports) {

$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", () => $bccbe52a868a0bef$export$362a25f017e2bc8a);
$parcel$export(module.exports, "getColorsFromAppearance", () => $bccbe52a868a0bef$export$bbacc3980e0f3029);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $PdmhA = parcelRequire("PdmhA");
const $bccbe52a868a0bef$export$362a25f017e2bc8a = (appearance)=>{
    let iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $PdmhA.B400);
            iconGradientStop = (0, $PdmhA.B200);
            iconColor = (0, $PdmhA.B200);
            textColor = `var(--ds-text, ${0, $PdmhA.N800})`;
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $PdmhA.B400);
            break;
        case 'neutral':
            iconGradientStart = (0, $PdmhA.N600);
            iconGradientStop = (0, $PdmhA.N100);
            iconColor = (0, $PdmhA.N100);
            textColor = (0, $PdmhA.N400);
            atlassianLogoTextColor = (0, $PdmhA.N400);
            break;
        case 'inverse':
            iconGradientStart = (0, $PdmhA.N50);
            iconGradientStop = (0, $PdmhA.N0);
            iconColor = (0, $PdmhA.N0);
            textColor = `var(--ds-text-inverse, ${0, $PdmhA.N0})`;
            atlassianLogoTextColor = `var(--ds-text-inverse, ${0, $PdmhA.N0})`;
            break;
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
const $bccbe52a868a0bef$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
    let iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $PdmhA.N0);
            textColor = (0, $PdmhA.N0);
            atlassianLogoTextColor = (0, $PdmhA.N0);
            break;
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
const $bccbe52a868a0bef$export$7818df200941dbbf = (appearance, colorMode)=>{
    let iconColor = $bccbe52a868a0bef$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    let textColor = $bccbe52a868a0bef$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});

parcelRegister("gbb5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc7645334a69956b$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $kbZ06 = parcelRequire("kbZ06");
const $bc7645334a69956b$var$CSS_VAR_COLOR = '--logo-color';
const $bc7645334a69956b$var$CSS_VAR_FILL = '--logo-fill';
const $bc7645334a69956b$var$baseWrapperStyles = (0, $byn9U.css)({
    display: 'inline-block',
    position: 'relative',
    color: `var(${$bc7645334a69956b$var$CSS_VAR_COLOR})`,
    fill: `var(${$bc7645334a69956b$var$CSS_VAR_FILL})`,
    lineHeight: 1,
    userSelect: 'none',
    whiteSpace: 'normal',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '> svg': {
        height: '100%',
        fill: 'inherit'
    }
});
const $bc7645334a69956b$var$stopColorStyles = (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    stop: {
        stopColor: 'currentColor'
    }
});
const $bc7645334a69956b$var$sizeStyles = Object.entries((0, $kbZ06.sizes)).reduce((acc, [key, val])=>{
    acc[key] = (0, $byn9U.css)({
        height: `${val}px`
    });
    return acc;
}, {});
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ const $bc7645334a69956b$var$Wrapper = ({ label: label, svg: svg, size: size, appearance: appearance, iconGradientStart: iconGradientStart, iconGradientStop: iconGradientStop, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
    const shouldApplyStopColor = iconGradientStart === 'inherit' && iconGradientStop === 'inherit' && appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: [
            $bc7645334a69956b$var$baseWrapperStyles,
            shouldApplyStopColor && $bc7645334a69956b$var$stopColorStyles,
            size && $bc7645334a69956b$var$sizeStyles[size]
        ],
        "data-testid": testId,
        style: {
            [$bc7645334a69956b$var$CSS_VAR_COLOR]: iconColor,
            [$bc7645334a69956b$var$CSS_VAR_FILL]: textColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest));
};
var $bc7645334a69956b$export$2e2bcd8739ae039 = $bc7645334a69956b$var$Wrapper;

});


parcelRegister("9QlHl", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", () => $72a9cd2a7b3b8f60$export$c4b5b1f965d8b3eb);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $tkrFt = parcelRequire("tkrFt");

var $XHGTv = parcelRequire("XHGTv");

var $4q38b = parcelRequire("4q38b");

var $kbZ06 = parcelRequire("kbZ06");

var $gcXsZ = parcelRequire("gcXsZ");

var $gbb5b = parcelRequire("gbb5b");
const $72a9cd2a7b3b8f60$var$svg = ({ appearance: appearance, iconGradientStart: iconGradientStart, iconGradientStop: iconGradientStop, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    };
    if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.brand-refresh-update-product-logos_q7coo')) {
        if (appearance) colors = (0, $gcXsZ.getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
    </svg>`;
    } else {
        // Will be fixed upon removal of deprecated iconGradientStart and
        // iconGradientStop props, or with React 18's useId() hook when we update.
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        let id = (0, $tkrFt.uid)({
            iconGradientStart: iconGradientStop
        });
        if (appearance) colors = (0, $gcXsZ.getColorsFromAppearanceOldLogos)(appearance);
        return `<svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
      <defs>
        <linearGradient x1="94.092%" x2="56.535%" y1="6.033%" y2="43.087%" id="${id}">
          <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="18%"></stop>
          <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
        </linearGradient>
      </defs>
      <g stroke="none" stroke-width="1" fill-rule="nonzero">
        <path fill="${colors.iconColor}" d="M26.0406546,5 L14.9983562,5 C14.9983562,6.32163748 15.5233746,7.58914413 16.4579134,8.52368295 C17.3924523,9.45822178 18.6599589,9.98324022 19.9815964,9.98324022 L22.0151159,9.98324022 L22.0151159,11.9465283 C22.0168782,14.6974491 24.2474348,16.9265768 26.9983562,16.9265762 L26.9983562,5.95770152 C26.9983562,5.42877757 26.5695786,5 26.0406546,5 Z"></path>
        <path fill="url(#${id})" d="M20.0420436,11 L9,11 C9.00176139,13.7504065 11.2309666,15.9796117 13.9813731,15.9813731 L16.0154337,15.9813731 L16.0154337,17.9451836 C16.0154337,19.2671728 16.5405919,20.5350167 17.4753794,21.4698042 C18.4101669,22.4045917 19.6780108,22.9297499 21,22.9297499 L21,11.9579564 C21,11.4288917 20.5711083,11 20.0420436,11 Z"></path>
        <path fill="url(#${id})" d="M14.0420436,17 L3,17 C3.00176275,19.7516528 5.23291286,21.9813736 7.98456626,21.9813731 L10.0250133,21.9813731 L10.0250133,23.9451836 C10.0250082,26.6943468 12.2508419,28.9244664 15,28.9297499 L15,17.9579564 C15,17.4288917 14.5711083,17 14.0420436,17 Z"></path>
      </g>
    </svg>`;
    }
};
const $72a9cd2a7b3b8f60$export$c4b5b1f965d8b3eb = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $kbZ06.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $kbZ06.defaultLogoParams).textColor, iconColor: iconColor = (0, $kbZ06.defaultLogoParams).iconColor, iconGradientStart: iconGradientStart = (0, $kbZ06.defaultLogoParams).iconGradientStart, iconGradientStop: iconGradientStop = (0, $kbZ06.defaultLogoParams).iconGradientStop })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gbb5b.default), {
        appearance: appearance,
        label: label,
        svg: $72a9cd2a7b3b8f60$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("dwS3h", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kvwg1');
        const value = parcelRequire('8nY6X');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kvwg1").then(()=>parcelRequire('8nY6X'));
}

});

parcelRegister("31xay", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('yTwnW');
        const value = parcelRequire('eIr2t');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("yTwnW").then(()=>parcelRequire('eIr2t'));
}

});

parcelRegister("i9Yk2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9yvg0');
        const value = parcelRequire('hRYdU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9yvg0").then(()=>parcelRequire('hRYdU'));
}

});

parcelRegister("3Ew0R", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ebVzT');
        const value = parcelRequire('gSFPI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ebVzT").then(()=>parcelRequire('gSFPI'));
}

});

parcelRegister("5GRoj", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('aRCDF');
        const value = parcelRequire('h0cb1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("aRCDF").then(()=>parcelRequire('h0cb1'));
}

});

parcelRegister("K0fRz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9VtCD');
        const value = parcelRequire('k3ak7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9VtCD").then(()=>parcelRequire('k3ak7'));
}

});

parcelRegister("2lHWV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2bZsf');
        const value = parcelRequire('7JgHV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2bZsf").then(()=>parcelRequire('7JgHV'));
}

});

parcelRegister("1QjLQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fNIof');
        const value = parcelRequire('fQ2EI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fNIof").then(()=>parcelRequire('fQ2EI'));
}

});

parcelRegister("4B1vJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hK23s');
        const value = parcelRequire('1psqr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hK23s").then(()=>parcelRequire('1psqr'));
}

});

parcelRegister("lMNPH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('k2MLG');
        const value = parcelRequire('cLW4D');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("k2MLG").then(()=>parcelRequire('cLW4D'));
}

});

parcelRegister("aH6Tz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('l1hYo');
        const value = parcelRequire('eQuyQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("l1hYo").then(()=>parcelRequire('eQuyQ'));
}

});


parcelRegister("3GGUk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2af693e09fb3638a$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cRPaW = parcelRequire("cRPaW");

var $6fjty = parcelRequire("6fjty");
const $2af693e09fb3638a$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, onError: onError, onLoad: onLoad })=>(0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cRPaW))), {
        src: url,
        loading: (0, $byn9U.jsx)((0, $6fjty.default), {
            testId: `${testId}-loading`
        }),
        loaded: (0, $byn9U.jsx)("img", {
            src: url,
            "data-testid": `${testId}-image`
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
var $2af693e09fb3638a$export$2e2bcd8739ae039 = $2af693e09fb3638a$var$ImageIcon;

});
parcelRegister("cRPaW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $95e221a7f9807f92$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eUqFw = parcelRequire("eUqFw");
var $95e221a7f9807f92$var$React = $95e221a7f9807f92$var$_interopRequireWildcard($eUqFw);
function $95e221a7f9807f92$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $95e221a7f9807f92$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $95e221a7f9807f92$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $95e221a7f9807f92$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $95e221a7f9807f92$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $95e221a7f9807f92$var$loaded() {
    return {
        isLoaded: true
    };
}
function $95e221a7f9807f92$var$errored() {
    return {
        isErrored: true
    };
}
function $95e221a7f9807f92$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $95e221a7f9807f92$var$ImageRenderer = function(_React$Component) {
    $95e221a7f9807f92$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $95e221a7f9807f92$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $95e221a7f9807f92$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($95e221a7f9807f92$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($95e221a7f9807f92$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $95e221a7f9807f92$var$_possibleConstructorReturn(_this, _ret);
    }
    $95e221a7f9807f92$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($95e221a7f9807f92$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($95e221a7f9807f92$var$hasPropsChanged(this.props, nextProps)) this.setState($95e221a7f9807f92$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($95e221a7f9807f92$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($95e221a7f9807f92$var$React.Component);
module.exports.default = $95e221a7f9807f92$var$ImageRenderer;

});




parcelRegister("l8O8E", function(module, exports) {

$parcel$export(module.exports, "FlexibleUiContext", () => $f6413cc7ef0ec7b2$export$ca70b164b615de47);
$parcel$export(module.exports, "useFlexibleUiContext", () => $f6413cc7ef0ec7b2$export$61d7957a243df7aa);
$parcel$export(module.exports, "FlexibleUiAnalyticsContext", () => $f6413cc7ef0ec7b2$export$9296fed6018ca95b);
$parcel$export(module.exports, "useFlexibleUiAnalyticsContext", () => $f6413cc7ef0ec7b2$export$80b8dfec38d1d85c);
$parcel$export(module.exports, "FlexibleUiOptionContext", () => $f6413cc7ef0ec7b2$export$f7433dbd6c50e26a);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $f6413cc7ef0ec7b2$export$e6b5ad18b56e8f51);

var $eUqFw = parcelRequire("eUqFw");
const $f6413cc7ef0ec7b2$export$ca70b164b615de47 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $f6413cc7ef0ec7b2$export$61d7957a243df7aa = ()=>(0, $eUqFw.useContext)($f6413cc7ef0ec7b2$export$ca70b164b615de47);
const $f6413cc7ef0ec7b2$export$9296fed6018ca95b = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $f6413cc7ef0ec7b2$export$80b8dfec38d1d85c = ()=>(0, $eUqFw.useContext)($f6413cc7ef0ec7b2$export$9296fed6018ca95b);
const $f6413cc7ef0ec7b2$export$f7433dbd6c50e26a = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $f6413cc7ef0ec7b2$export$e6b5ad18b56e8f51 = ()=>(0, $eUqFw.useContext)($f6413cc7ef0ec7b2$export$f7433dbd6c50e26a);

});

parcelRegister("cpPsK", function(module, exports) {

$parcel$export(module.exports, "default", () => $909fbd4282bb7fd8$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $hWN7x = parcelRequire("hWN7x");
const $909fbd4282bb7fd8$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $eUqFw.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $hWN7x ? $hWN7x[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    return (0, $byn9U.jsx)(Action, (0, $kU09D.default)({
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled
    }, actionProps));
};
var $909fbd4282bb7fd8$export$2e2bcd8739ae039 = $909fbd4282bb7fd8$var$ActionGroupItem;

});
parcelRegister("hWN7x", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("5jLFn")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("4P5HG")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("ix4AV")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("k8P6f")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("1r4M1")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("5AyHd")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("lVMuj")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("k3IxH")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("fI5A1")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("3HQ5i")).default);

var $5jLFn = parcelRequire("5jLFn");

var $4P5HG = parcelRequire("4P5HG");

var $ix4AV = parcelRequire("ix4AV");

var $k8P6f = parcelRequire("k8P6f");

var $1r4M1 = parcelRequire("1r4M1");

var $5AyHd = parcelRequire("5AyHd");

var $lVMuj = parcelRequire("lVMuj");

var $k3IxH = parcelRequire("k3IxH");

var $fI5A1 = parcelRequire("fI5A1");

var $3HQ5i = parcelRequire("3HQ5i");

});
parcelRegister("5jLFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3df3b3aa83705df6$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $hXWLE = parcelRequire("hXWLE");

var $9bgZN = parcelRequire("9bgZN");

var $bJ3dq = parcelRequire("bJ3dq");

var $d6toh = parcelRequire("d6toh");

var $lA7RR = parcelRequire("lA7RR");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $3df3b3aa83705df6$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $hXWLE.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, xcss: xcss, asDropDownItem: asDropDownItem, overrideCss: overrideCss, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon && (0, $byn9U.jsx)((0, $lA7RR.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    });
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return (0, $byn9U.jsx)((0, $9bgZN.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        xcss: xcss,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return (0, $byn9U.jsx)((0, $d6toh.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = (0, $byn9U.jsx)((0, $bJ3dq.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        overrideCss: overrideCss,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? (0, $byn9U.jsx)(Wrapper, null, button) : button;
};
var $3df3b3aa83705df6$export$2e2bcd8739ae039 = $3df3b3aa83705df6$var$Action;

});
parcelRegister("9bgZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6af2532629e0cd78$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $8cU5f = parcelRequire("8cU5f");

var $eUqFw = parcelRequire("eUqFw");

var $lyV8S = parcelRequire("lyV8S");
const $6af2532629e0cd78$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lyV8S.default), (0, $kU09D.default)({}, props, {
        content: content
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lyV8S.default), (0, $kU09D.default)({}, props, {
            content: content,
            tooltipProps: tooltipProps
        })));
var $6af2532629e0cd78$export$2e2bcd8739ae039 = $6af2532629e0cd78$var$ActionStackItem;

});
parcelRegister("lyV8S", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb29193326b2a2b2$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $hSQOv = parcelRequire("hSQOv");
var $6h1SY = parcelRequire("6h1SY");
var $caLW4 = parcelRequire("caLW4");

var $4Bees = parcelRequire("4Bees");

var $eUqFw = parcelRequire("eUqFw");

var $jvuTK = parcelRequire("jvuTK");

var $lA7RR = parcelRequire("lA7RR");
const $fb29193326b2a2b2$var$buttonStyles = (0, $caLW4.xcss)({
    all: 'unset',
    cursor: 'pointer',
    padding: 'space.050',
    width: '100%',
    ':focus:not(:focus-visible)': {
        outline: 'none'
    },
    ':focus': {
        outlineColor: 'color.border.focused',
        // xcss outlineOffset does not support space.negative.025
        // @ts-ignore-next-line TS2322: Type "var(--ds-space-negative-025)" is not assignable to type
        outlineOffset: "var(--ds-space-negative-025, -2px)",
        outlineStyle: 'solid',
        outlineWidth: 'border.width.outline'
    },
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $fb29193326b2a2b2$var$contentStyles = (0, $caLW4.xcss)({
    color: 'color.text',
    // Replace with font token once it becomes stable (currently alpha)
    // font: 'font.body.small',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px'
});
const $fb29193326b2a2b2$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, xcss: xcss })=>{
    const space = spaceOption !== null && spaceOption !== void 0 ? spaceOption : (0, $jvuTK.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lA7RR.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), (0, $kU09D.default)({
        as: "button",
        xcss: [
            $fb29193326b2a2b2$var$buttonStyles,
            xcss
        ]
    }, tooltipProps, {
        onClick: onClick,
        testId: testId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6h1SY.default), {
        alignBlock: "center",
        grow: "fill",
        space: space
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), {
        xcss: $fb29193326b2a2b2$var$contentStyles
    }, content)));
};
var $fb29193326b2a2b2$export$2e2bcd8739ae039 = $fb29193326b2a2b2$var$ActionButton;

});
parcelRegister("lA7RR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb631020aab3716c$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hXWLE = parcelRequire("hXWLE");

var $jvuTK = parcelRequire("jvuTK");
const $fb631020aab3716c$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $hXWLE.SmartLinkSize).XLarge:
        case (0, $hXWLE.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $hXWLE.SmartLinkSize).Medium:
        case (0, $hXWLE.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
const $fb631020aab3716c$var$getIconStyles = (isDisabled)=>(0, $byn9U.css)({
        color: isDisabled ? "var(--ds-text-disabled, #6B778C)" : "var(--ds-icon, #44546F)"
    });
const $fb631020aab3716c$var$stackItemIconSizeStyles = (0, $jvuTK.getIconSizeStyles)('20px');
const $fb631020aab3716c$var$stackItemIconStyles = (0, $byn9U.css)($fb631020aab3716c$var$stackItemIconSizeStyles, {
    display: 'inline-block',
    lineHeight: 0,
    padding: "var(--ds-space-025, 2px)",
    'span,svg,img': {
        lineHeight: 0
    }
});
const $fb631020aab3716c$var$ActionIcon = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>(0, $byn9U.jsx)("span", {
        css: [
            $fb631020aab3716c$var$getIconStyles(isDisabled),
            asStackItemIcon ? $fb631020aab3716c$var$stackItemIconStyles : (0, $jvuTK.getIconSizeStyles)($fb631020aab3716c$var$getIconWidth(size))
        ],
        "data-testid": `${testId}-icon`
    }, icon);
var $fb631020aab3716c$export$2e2bcd8739ae039 = $fb631020aab3716c$var$ActionIcon;

});



parcelRegister("bJ3dq", function(module, exports) {

$parcel$export(module.exports, "default", () => $8896643d33fc392a$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7opLA = parcelRequire("7opLA");

var $8cU5f = parcelRequire("8cU5f");

var $hXWLE = parcelRequire("hXWLE");

var $jvuTK = parcelRequire("jvuTK");
const $8896643d33fc392a$var$getButtonStyle = (size, iconOnly)=>{
    switch(size){
        case (0, $hXWLE.SmartLinkSize).Large:
            return iconOnly ? (0, $byn9U.css)({
                'button, button:hover, button:focus, button:active': {
                    padding: 0,
                    '> span': {
                        margin: 0
                    }
                }
            }) : '';
        case (0, $hXWLE.SmartLinkSize).Small:
            return (0, $byn9U.css)({
                fontSize: '0.75rem',
                fontWeight: 500,
                lineHeight: '1rem',
                'button, button:hover, button:focus, button:active': [
                    {
                        lineHeight: '1rem'
                    },
                    iconOnly ? `
            padding: 0.125rem;
          ` : `
            padding-left: 0.25rem;
            padding-right: 0.25rem;
          `
                ]
            });
        case (0, $hXWLE.SmartLinkSize).XLarge:
        case (0, $hXWLE.SmartLinkSize).Medium:
        default:
            return '';
    }
};
const $8896643d33fc392a$var$ActionButton = ({ appearance: appearance, content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, overrideCss: overrideCss, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eUqFw.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return (0, $byn9U.jsx)("div", {
        css: [
            $8896643d33fc392a$var$getButtonStyle(size, iconOnly),
            overrideCss
        ],
        "data-testid": `${testId}-button-wrapper`
    }, (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltipMessage,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, (0, $byn9U.jsx)((0, $7opLA.default), {
        appearance: appearance,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onButtonClick(onClick),
        spacing: (0, $jvuTK.sizeToButtonSpacing)[size],
        testId: testId,
        href: href,
        "aria-label": ariaLabel
    }, content)));
};
var $8896643d33fc392a$export$2e2bcd8739ae039 = $8896643d33fc392a$var$ActionButton;

});

parcelRegister("d6toh", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a2a2431020b209$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $6MLxR = parcelRequire("6MLxR");
const $98a2a2431020b209$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $6MLxR.handleOnClick)(onClick),
        testId: testId
    }, content);
var $98a2a2431020b209$export$2e2bcd8739ae039 = $98a2a2431020b209$var$ActionDropdownItem;

});


parcelRegister("4P5HG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3830597a40969c55$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $5jLFn = parcelRequire("5jLFn");

var $6D8aU = parcelRequire("6D8aU");

var $8uD7Y = parcelRequire("8uD7Y");

var $jWuk1 = parcelRequire("jWuk1");
const $3830597a40969c55$var$DeleteAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jLFn.default), (0, $kU09D.default)({
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).delete),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).delete)
    }, props));
var $3830597a40969c55$export$2e2bcd8739ae039 = $3830597a40969c55$var$DeleteAction;

});

parcelRegister("ix4AV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7dedf6dea7b9e7c$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $5jLFn = parcelRequire("5jLFn");

var $6D8aU = parcelRequire("6D8aU");

var $8uD7Y = parcelRequire("8uD7Y");

var $bZ1Zi = parcelRequire("bZ1Zi");
const $d7dedf6dea7b9e7c$var$EditAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jLFn.default), (0, $kU09D.default)({
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).edit),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZ1Zi))), {
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).edit)
    }, props));
var $d7dedf6dea7b9e7c$export$2e2bcd8739ae039 = $d7dedf6dea7b9e7c$var$EditAction;

});

parcelRegister("k8P6f", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea9c3156678efb4e$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $6MLxR = parcelRequire("6MLxR");

var $8uD7Y = parcelRequire("8uD7Y");

var $hXWLE = parcelRequire("hXWLE");

var $6D8aU = parcelRequire("6D8aU");

var $5jLFn = parcelRequire("5jLFn");

var $l8O8E = parcelRequire("l8O8E");

var $j1VK5 = parcelRequire("j1VK5");

var $i9nBX = parcelRequire("i9nBX");
const $ea9c3156678efb4e$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    var _context$actions;
    const context = (0, $l8O8E.useFlexibleUiContext)();
    const analytics = (0, $l8O8E.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $j1VK5.default)({
        analytics: analytics
    });
    const data = context === null || context === void 0 ? void 0 : (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $hXWLE.ActionName).DownloadAction];
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (data !== null && data !== void 0 && data.downloadUrl) {
            invoke({
                actionType: (0, $hXWLE.ActionName).DownloadAction,
                actionFn: async ()=>(0, $6MLxR.downloadUrl)(data === null || data === void 0 ? void 0 : data.downloadUrl),
                // These values have already been set in analytics context.
                // We only pass these here for ufo experience.
                display: analytics === null || analytics === void 0 ? void 0 : analytics.display,
                extensionKey: analytics === null || analytics === void 0 ? void 0 : analytics.extensionKey
            });
            if (onClickCallback) onClickCallback();
        }
    }, [
        analytics,
        data === null || data === void 0 ? void 0 : data.downloadUrl,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $6D8aU.messages).download_file : (0, $6D8aU.messages).download;
    const tooltipMessage = isStackItem ? (0, $6D8aU.messages).download_description : (0, $6D8aU.messages).download;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jLFn.default), (0, $kU09D.default)({
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), label),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i9nBX))), {
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage)
    }, data, props)) : null;
};
var $ea9c3156678efb4e$export$2e2bcd8739ae039 = $ea9c3156678efb4e$var$DownloadAction;

});
parcelRegister("i9nBX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d36b61f12f7a705f$var$_react = $d36b61f12f7a705f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d36b61f12f7a705f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d36b61f12f7a705f$var$DownloadIcon = (props)=>/*#__PURE__*/ $d36b61f12f7a705f$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M10.687 17.292a.983.983 0 00-1.397 0 1 1 0 000 1.407l1.964 1.98a1.082 1.082 0 001.538 0l1.919-1.933a1 1 0 000-1.408.983.983 0 00-1.398 0l-1.29 1.3-1.336-1.346z" fill-rule="nonzero"/><path d="M13.001 19.993L13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007z" fill-rule="nonzero"/><path d="M7.938 5.48a4.8 4.8 0 00-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 014.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48z"/></g></svg>`
    }, props));
$d36b61f12f7a705f$var$DownloadIcon.displayName = 'DownloadIcon';
var $d36b61f12f7a705f$var$_default = $d36b61f12f7a705f$var$DownloadIcon;
module.exports.default = $d36b61f12f7a705f$var$_default;

});


parcelRegister("1r4M1", function(module, exports) {

$parcel$export(module.exports, "default", () => $10bc03f894879b61$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $iisnK = parcelRequire("iisnK");

var $XHGTv = parcelRequire("XHGTv");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hXWLE = parcelRequire("hXWLE");

var $6D8aU = parcelRequire("6D8aU");

var $l8O8E = parcelRequire("l8O8E");

var $j6VWz = parcelRequire("j6VWz");

var $5pvAZ = parcelRequire("5pvAZ");

var $jvuTK = parcelRequire("jvuTK");

var $a1cg8 = parcelRequire("a1cg8");


const $10bc03f894879b61$var$importIconMapper = {
    goal: ()=>(parcelRequire("7MTGz")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("7gM3Z")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $10bc03f894879b61$var$getIcon = (stackIconType)=>{
    const importFn = $10bc03f894879b61$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $jvuTK.importIcon)(importFn);
};
const $10bc03f894879b61$var$getIconFF = (iconFFEnabled, defaultIcon)=>{
    if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign')) {
        if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.action-icon-redesign')) return iconFFEnabled;
    }
    return defaultIcon;
};
const $10bc03f894879b61$var$FollowAction = (props)=>{
    var _context$actions;
    const context = (0, $l8O8E.useFlexibleUiContext)();
    const actionData = context === null || context === void 0 ? void 0 : (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $hXWLE.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $6D8aU.messages).follow : (0, $6D8aU.messages).unfollow;
    const projectMessage = value ? (0, $6D8aU.messages).follow_project : (0, $6D8aU.messages).unfollow_project;
    const goalMessage = value ? (0, $6D8aU.messages).follow_goal : (0, $6D8aU.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $6D8aU.messages).follow_project_description : (0, $6D8aU.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $6D8aU.messages).follow_goal_description : (0, $6D8aU.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const icon = value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iisnK))), {
        label: "Follow"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5pvAZ.default), {
        label: "Unfollow"
    });
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $10bc03f894879b61$var$getIcon(stackIconType);
    const stackIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const followIcon = isStackItem ? stackIcon : $10bc03f894879b61$var$getIconFF(stackIcon, icon);
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $a1cg8.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback === null || onErrorCallback === void 0 || onErrorCallback({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), errorMessage),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j6VWz.default), (0, $kU09D.default)({
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), label),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage)
    }, data, props, {
        onError: handleError
    }));
};
var $10bc03f894879b61$export$2e2bcd8739ae039 = $10bc03f894879b61$var$FollowAction;

});
parcelRegister("iisnK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d51fec82b4cf5254$var$_react = $d51fec82b4cf5254$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d51fec82b4cf5254$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d51fec82b4cf5254$var$InviteTeamIcon = (props)=>/*#__PURE__*/ $d51fec82b4cf5254$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><rect x="18" y="5" width="2" height="6" rx="1"/><rect x="16" y="7" width="6" height="2" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0V14z"/><circle cx="11" cy="7" r="4"/></g></svg>`
    }, props));
$d51fec82b4cf5254$var$InviteTeamIcon.displayName = 'InviteTeamIcon';
var $d51fec82b4cf5254$var$_default = $d51fec82b4cf5254$var$InviteTeamIcon;
module.exports.default = $d51fec82b4cf5254$var$_default;

});

parcelRegister("j6VWz", function(module, exports) {

$parcel$export(module.exports, "default", () => $de9b86438372c009$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $jJygp = parcelRequire("jJygp");

var $gM0yE = parcelRequire("gM0yE");

var $9r9En = parcelRequire("9r9En");

var $hWzih = parcelRequire("hWzih");

var $5jLFn = parcelRequire("5jLFn");

var $l8O8E = parcelRequire("l8O8E");
const $de9b86438372c009$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const analytics = (0, $l8O8E.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $jJygp.default)();
    const reload = (0, $9r9En.default)();
    const handleClick = (0, $eUqFw.useCallback)(async ()=>{
        if (action) {
            var _action$action;
            const smartLinkActionType = (_action$action = action.action) === null || _action$action === void 0 ? void 0 : _action$action.actionType;
            try {
                setIsLoading(true);
                analytics === null || analytics === void 0 || analytics.ui.smartLinkServerActionClickedEvent({
                    smartLinkActionType: smartLinkActionType
                });
                analytics === null || analytics === void 0 || analytics.track.smartLinkQuickActionStarted({
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $hWzih.default)(action);
                await invoke(request);
                analytics === null || analytics === void 0 || analytics.track.smartLinkQuickActionSuccess({
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                analytics === null || analytics === void 0 || analytics.track.smartLinkQuickActionFailed({
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $gM0yE.getInvokeFailureReason)(err)
                });
                onErrorCallback === null || onErrorCallback === void 0 || onErrorCallback();
            }
        }
    }, [
        action,
        analytics === null || analytics === void 0 ? void 0 : analytics.track,
        analytics === null || analytics === void 0 ? void 0 : analytics.ui,
        invoke,
        onClick,
        onErrorCallback,
        reload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jLFn.default), (0, $kU09D.default)({}, props, {
        isLoading: isLoading,
        onClick: handleClick
    }));
};
var $de9b86438372c009$export$2e2bcd8739ae039 = $de9b86438372c009$var$ServerAction;

});
parcelRegister("jJygp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5dccc5ac8dbbeea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $imCrQ = parcelRequire("imCrQ");

var $gqldc = parcelRequire("gqldc");
const $e5dccc5ac8dbbeea$var$useInvoke = ()=>{
    const { connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const clientExt = (0, $imCrQ.useSmartLinkClientExtension)(connections.client);
    return (0, $eUqFw.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $e5dccc5ac8dbbeea$export$2e2bcd8739ae039 = $e5dccc5ac8dbbeea$var$useInvoke;

});
parcelRegister("imCrQ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $e90617a456d47f08$export$303ede4eed148855);

var $eUqFw = parcelRequire("eUqFw");

var $5LW2w = parcelRequire("5LW2w");

var $cCvxR = parcelRequire("cCvxR");

var $euvAQ = parcelRequire("euvAQ");
const $e90617a456d47f08$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $euvAQ.useResolverUrl)(cardClient);
    const invoke = (0, $eUqFw.useCallback)(async (data)=>{
        try {
            return await (0, $5LW2w.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $cCvxR.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    const relatedUrls = (0, $eUqFw.useCallback)(async (url)=>{
        return await (0, $5LW2w.request)('get', `${resolverUrl}/related-urls?url=${encodeURIComponent(url)}`, undefined, {
            'Cache-Control': 'private'
        }, [
            200
        ]);
    }, [
        resolverUrl
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            invoke: invoke,
            relatedUrls: relatedUrls
        }), [
        invoke,
        relatedUrls
    ]);
};

});
parcelRegister("euvAQ", function(module, exports) {

$parcel$export(module.exports, "useResolverUrl", () => $56f10bb2820b4284$export$d08617a365fbe694);

var $eUqFw = parcelRequire("eUqFw");

var $dUrSu = parcelRequire("dUrSu");
const $56f10bb2820b4284$export$d08617a365fbe694 = (cardClient)=>(0, $eUqFw.useMemo)(()=>(0, $dUrSu.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});



parcelRegister("gM0yE", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $c3618fce3a37104b$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $c3618fce3a37104b$export$1694272377fa07d8);

var $iDnwt = parcelRequire("iDnwt");
const $c3618fce3a37104b$export$65b3f792dff0bd60 = (err)=>{
    if (!$c3618fce3a37104b$export$1694272377fa07d8(err)) return (0, $iDnwt.TrackQuickActionFailureReason).UnknownError;
    switch(err === null || err === void 0 ? void 0 : err.errorCode){
        case 403:
            return (0, $iDnwt.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $iDnwt.TrackQuickActionFailureReason).UnknownError;
    }
};
const $c3618fce3a37104b$export$1694272377fa07d8 = (err)=>(err === null || err === void 0 ? void 0 : err.message) !== undefined && (err === null || err === void 0 ? void 0 : err.errorCode) !== undefined;

});

parcelRegister("hWzih", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1033b14e08d7008$export$2e2bcd8739ae039);
const $d1033b14e08d7008$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $d1033b14e08d7008$export$2e2bcd8739ae039 = $d1033b14e08d7008$var$createInvokeRequest;

});


parcelRegister("5pvAZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $01044138e36cccbe$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $2ziLQ = parcelRequire("2ziLQ");

var $eUqFw = parcelRequire("eUqFw");
const $01044138e36cccbe$var$UnfollowGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        className: props.className,
        role: "presentation",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 4.66667H11.3333C10.9652 4.66667 10.6667 4.96514 10.6667 5.33333C10.6667 5.70152 10.9652 6 11.3333 6H14C14.3682 6 14.6667 5.70152 14.6667 5.33333C14.6667 4.96514 14.3682 4.66667 14 4.66667Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.33334 9.33333C3.33334 8.59667 3.93468 8 4.67268 8H9.99401C10.734 8 11.3333 8.596 11.3333 9.33733V12.2973C11.3333 14.5673 3.33334 14.5673 3.33334 12.2973V9.33333Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.33334 7.33333C8.8061 7.33333 10 6.13943 10 4.66667C10 3.19391 8.8061 2 7.33334 2C5.86058 2 4.66668 3.19391 4.66668 4.66667C4.66668 6.13943 5.86058 7.33333 7.33334 7.33333Z",
        fill: "currentColor"
    }));
const $01044138e36cccbe$var$UnfollowIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), (0, $kU09D.default)({
        glyph: $01044138e36cccbe$var$UnfollowGlyph
    }, props));
var $01044138e36cccbe$export$2e2bcd8739ae039 = $01044138e36cccbe$var$UnfollowIcon;

});

parcelRegister("a1cg8", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $74b381d3f1d375fe$export$49248678d3914625);

var $6D8aU = parcelRequire("6D8aU");
const $74b381d3f1d375fe$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $6D8aU.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $6D8aU.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $6D8aU.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $6D8aU.messages).unfollow_goal_error;
    return (0, $6D8aU.messages).generic_error_message;
};

});

parcelRegister("7MTGz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lQgN7');
        const value = parcelRequire('ba9ZM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lQgN7").then(()=>parcelRequire('ba9ZM'));
}

});

parcelRegister("7gM3Z", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jqmkY');
        const value = parcelRequire('aqXAH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jqmkY").then(()=>parcelRequire('aqXAH'));
}

});


parcelRegister("5AyHd", function(module, exports) {

$parcel$export(module.exports, "default", () => $411b3a6f14883291$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $cYnD3 = parcelRequire("cYnD3");

var $22LS1 = parcelRequire("22LS1");

var $XHGTv = parcelRequire("XHGTv");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hXWLE = parcelRequire("hXWLE");

var $6D8aU = parcelRequire("6D8aU");

var $l8O8E = parcelRequire("l8O8E");

var $j1VK5 = parcelRequire("j1VK5");

var $jvuTK = parcelRequire("jvuTK");

var $5jLFn = parcelRequire("5jLFn");
const $411b3a6f14883291$var$getIconFF = ()=>{
    if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign')) {
        if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.action-icon-redesign')) return 0, (/*@__PURE__*/$parcel$interopDefault($22LS1));
    }
    return 0, (/*@__PURE__*/$parcel$interopDefault($cYnD3));
};
const $411b3a6f14883291$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    var _context$actions;
    const context = (0, $l8O8E.useFlexibleUiContext)();
    const analytics = (0, $l8O8E.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $j1VK5.default)({
        analytics: analytics
    });
    const data = context === null || context === void 0 ? void 0 : (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $hXWLE.ActionName).PreviewAction];
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (data) invoke({
            actionType: (0, $hXWLE.ActionName).PreviewAction,
            actionFn: async ()=>(0, $jvuTK.openEmbedModalWithFlexibleUiIcon)({
                    download: data === null || data === void 0 ? void 0 : data.downloadUrl,
                    extensionKey: analytics === null || analytics === void 0 ? void 0 : analytics.extensionKey,
                    analytics: analytics,
                    ...data
                }),
            // These values have already been set in analytics context.
            // We only pass these here for ufo experience.
            display: analytics === null || analytics === void 0 ? void 0 : analytics.display,
            extensionKey: analytics === null || analytics === void 0 ? void 0 : analytics.extensionKey
        });
        if (onClickCallback) onClickCallback();
    }, [
        analytics,
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const Icon = isStackItem ? (0, (/*@__PURE__*/$parcel$interopDefault($22LS1))) : $411b3a6f14883291$var$getIconFF();
    const tooltipMessage = isStackItem ? (0, $6D8aU.messages).preview_description : (0, $6D8aU.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jLFn.default), (0, $kU09D.default)({
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).preview_improved),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        hideTooltipOnMouseDown: true
    }, data, props)) : null;
};
var $411b3a6f14883291$export$2e2bcd8739ae039 = $411b3a6f14883291$var$PreviewAction;

});
parcelRegister("cYnD3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $971d6ad91943ad82$var$_react = $971d6ad91943ad82$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $971d6ad91943ad82$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $971d6ad91943ad82$var$VidFullScreenOnIcon = (props)=>/*#__PURE__*/ $971d6ad91943ad82$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6 18h3a1 1 0 010 2H6a2 2 0 01-2-2v-3a1 1 0 012 0v3zm12 2h-3a1 1 0 010-2h3v-3a1 1 0 012 0v3a2 2 0 01-2 2zM6 4h3a1 1 0 110 2H6v3a1 1 0 11-2 0V6a2 2 0 012-2zm12 2h-3a1 1 0 010-2h3a2 2 0 012 2v3a1 1 0 01-2 0V6z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$971d6ad91943ad82$var$VidFullScreenOnIcon.displayName = 'VidFullScreenOnIcon';
var $971d6ad91943ad82$var$_default = $971d6ad91943ad82$var$VidFullScreenOnIcon;
module.exports.default = $971d6ad91943ad82$var$_default;

});

parcelRegister("22LS1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17d0e6b497755428$var$_react = $17d0e6b497755428$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $17d0e6b497755428$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $17d0e6b497755428$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $17d0e6b497755428$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M16.587 6.003H15A1 1 0 0115 4h3.9l.047.001a.975.975 0 01.736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 11-2 0V7.411l-3.309 3.308a.977.977 0 01-1.374-.005l-.032-.032a.976.976 0 01-.005-1.374l3.307-3.305zM7.413 17.997H9A1 1 0 019 20H5.1l-.047-.001a.975.975 0 01-.736-.285l-.032-.032A.977.977 0 014 18.946a1.12 1.12 0 010-.048v-3.896a1 1 0 112 0v1.587l3.309-3.308a.977.977 0 011.374.005l.032.032a.976.976 0 01.005 1.374l-3.307 3.305z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$17d0e6b497755428$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $17d0e6b497755428$var$_default = $17d0e6b497755428$var$MediaServicesActualSizeIcon;
module.exports.default = $17d0e6b497755428$var$_default;

});


parcelRegister("lVMuj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff74888a42a15714$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $5jLFn = parcelRequire("5jLFn");

var $6D8aU = parcelRequire("6D8aU");

var $8uD7Y = parcelRequire("8uD7Y");

var $hUwRB = parcelRequire("hUwRB");

var $l8O8E = parcelRequire("l8O8E");

var $hXWLE = parcelRequire("hXWLE");

var $j1VK5 = parcelRequire("j1VK5");
const $ff74888a42a15714$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    var _context$actions;
    const context = (0, $l8O8E.useFlexibleUiContext)();
    const analytics = (0, $l8O8E.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $j1VK5.default)({
        analytics: analytics
    });
    const data = context === null || context === void 0 ? void 0 : (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $hXWLE.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $eUqFw.useState)((0, $6D8aU.messages).copy_url_to_clipboard);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (data && data.url) invoke({
            actionType: (0, $hXWLE.ActionName).CopyLinkAction,
            actionFn: async ()=>{
                var _data$url;
                await navigator.clipboard.writeText((_data$url = data.url) !== null && _data$url !== void 0 ? _data$url : '');
                setTooltipMessage((0, $6D8aU.messages).copied_url_to_clipboard);
            },
            // These values have already been set in analytics context.
            // We only pass these here for ufo experience.
            display: analytics === null || analytics === void 0 ? void 0 : analytics.display,
            extensionKey: analytics === null || analytics === void 0 ? void 0 : analytics.extensionKey
        });
        if (onClickCallback) onClickCallback();
    }, [
        analytics,
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jLFn.default), (0, $kU09D.default)({
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).copy_url_to_clipboard),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
            label: "copy url",
            size: "medium"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $6D8aU.messages).copy_url_to_clipboard)
    }, data, props)) : null;
};
var $ff74888a42a15714$export$2e2bcd8739ae039 = $ff74888a42a15714$var$CopyLinkAction;

});

parcelRegister("k3IxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9a6a3b15e499a65$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $l8O8E = parcelRequire("l8O8E");

var $hXWLE = parcelRequire("hXWLE");

var $9p1wL = parcelRequire("9p1wL");
const $e9a6a3b15e499a65$var$AISummaryAction = (props)=>{
    var _context$actions;
    const context = (0, $l8O8E.useFlexibleUiContext)();
    const actionData = context === null || context === void 0 ? void 0 : (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $hXWLE.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9p1wL.AISummaryActionComponent), (0, $kU09D.default)({}, actionData, props)) : null;
};
var $e9a6a3b15e499a65$export$2e2bcd8739ae039 = $e9a6a3b15e499a65$var$AISummaryAction;

});
parcelRegister("9p1wL", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $6d87a233634f3f10$export$8eed96bc6d982595);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");


var $9Ll0U = parcelRequire("9Ll0U");

var $gLwaR = parcelRequire("gLwaR");

var $7WiGa = parcelRequire("7WiGa");
const $6d87a233634f3f10$export$8eed96bc6d982595 = (props)=>{
    const { url: url, ari: ari, product: product, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $9Ll0U.useAISummary)({
        url: url,
        ari: ari,
        product: product
    });
    (0, $eUqFw.useEffect)(()=>{
        onLoadingChange === null || onLoadingChange === void 0 || onLoadingChange(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLwaR.CopySummaryAction), (0, $kU09D.default)({}, props, {
        testId: testId,
        content: content
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7WiGa.AISummariseAction), (0, $kU09D.default)({}, props, {
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    }));
};

});
parcelRegister("9Ll0U", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $71b8cdb3373071ff$export$becd8f2eba1bbd96);

var $eUqFw = parcelRequire("eUqFw");

var $jAv2B = parcelRequire("jAv2B");

var $9pcYY = parcelRequire("9pcYY");

var $3GWpI = parcelRequire("3GWpI");

var $fN0cF = parcelRequire("fN0cF");
const $71b8cdb3373071ff$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $71b8cdb3373071ff$export$becd8f2eba1bbd96 = (props)=>{
    var _AISummariesStore$get;
    const { url: url, baseUrl: baseUrl, headers: headers, product: product, ari: ari, envKey: envKey } = props;
    const [state, setState] = (0, $eUqFw.useState)(((_AISummariesStore$get = (0, $jAv2B.AISummariesStore).get(url)) === null || _AISummariesStore$get === void 0 ? void 0 : _AISummariesStore$get.state) || {
        status: 'ready',
        content: ''
    });
    const { fireEvent: fireEvent } = (0, $3GWpI.useAnalyticsEvents)();
    const onStart = (0, $eUqFw.useCallback)((id)=>{
        (0, $fN0cF.startUfoExperience)($71b8cdb3373071ff$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $eUqFw.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $fN0cF.succeedUfoExperience)($71b8cdb3373071ff$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $eUqFw.useCallback)((id, reason)=>{
        /**
     * Errors should only be counted to the SLO if they are not due to acceptable use violations
     * HIPAA content detected or exceeding context length.
     */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $fN0cF.failUfoExperience)($71b8cdb3373071ff$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        var _AISummariesStore$get2;
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $jAv2B.AISummariesStore).get(url)) (0, $jAv2B.AISummariesStore).set(url, new (0, $9pcYY.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            headers: headers,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess,
            product: product,
            envKey: envKey
        }));
        //returns function that calls unsubscribe method
        return (_AISummariesStore$get2 = (0, $jAv2B.AISummariesStore).get(url)) === null || _AISummariesStore$get2 === void 0 ? void 0 : _AISummariesStore$get2.subscribe(setState);
    }, [
        url,
        baseUrl,
        headers,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey
    ]);
    const summariseUrl = ()=>{
        var _AISummariesStore$get3;
        return (_AISummariesStore$get3 = (0, $jAv2B.AISummariesStore).get(url)) === null || _AISummariesStore$get3 === void 0 ? void 0 : _AISummariesStore$get3.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("jAv2B", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $e429753775d729aa$export$6979339b6d41707e);

var $6roQF = parcelRequire("6roQF");
const $e429753775d729aa$var$AI_SUMMARY_CACHE_SIZE = 100;
const $e429753775d729aa$export$6979339b6d41707e = new (0, $6roQF.LRUMap)($e429753775d729aa$var$AI_SUMMARY_CACHE_SIZE);

});

parcelRegister("9pcYY", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $6d9084e83394c449$export$73e4b807d5bd74b6);

var $5zQU9 = parcelRequire("5zQU9");

var $hompL = parcelRequire("hompL");

var $iG3ul = parcelRequire("iG3ul");

var $gFuWD = parcelRequire("gFuWD");

var $lk6ge = parcelRequire("lk6ge");

var $dUrSu = parcelRequire("dUrSu");

var $XHGTv = parcelRequire("XHGTv");
class $6d9084e83394c449$export$73e4b807d5bd74b6 {
    constructor(props){
        var _getXProductHeaderVal;
        (0, $5zQU9.default)(this, "state", {
            content: '',
            status: 'ready'
        });
        (0, $5zQU9.default)(this, "subscribedStateSetters", new Set());
        (0, $5zQU9.default)(this, "getRequestUrl", (envKey, baseUrlOverride)=>{
            const path = 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $dUrSu.getBaseUrl)(envKey);
                return (0, $gFuWD.addPath)(baseUrl, path);
            }
            return (0, $gFuWD.addPath)('/gateway/api/', path);
        });
        (0, $5zQU9.default)(this, "fetchStream", async ()=>{
            const payload = {
                recipient_agent_named_id: 'summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown'
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                ...(0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.ai-summary-service-base-url') && {
                    credentials: 'include'
                }
            };
            const requestURL = (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.ai-summary-service-base-url') ? this.config.requestUrl : '/gateway/api/assist/chat/v1/invoke_agent/stream';
            const response = await fetch(requestURL, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $lk6ge.readStream)(response);
        });
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': ((_getXProductHeaderVal = (0, $gFuWD.getXProductHeaderValue)(props.product)) === null || _getXProductHeaderVal === void 0 ? void 0 : _getXProductHeaderVal.toLowerCase()) || 'confluence',
                ...props.headers
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
        try {
            var _this$onStart, _this$onSuccess;
            (_this$onStart = this.onStart) === null || _this$onStart === void 0 || _this$onStart.call(this, id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                if (chunk.type === 'ERROR') {
                    var _chunk$message;
                    throw new Error(chunk === null || chunk === void 0 ? void 0 : (_chunk$message = chunk.message) === null || _chunk$message === void 0 ? void 0 : _chunk$message.message_template);
                }
            }
            (_this$onSuccess = this.onSuccess) === null || _this$onSuccess === void 0 || _this$onSuccess.call(this, id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            var _this$onError;
            let message = err instanceof Error && this.isExpectedError(err.message) ? err.message : 'UNEXPECTED';
            (_this$onError = this.onError) === null || _this$onError === void 0 || _this$onError.call(this, id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    isExpectedError(value) {
        return typeof value === 'string' && (0, $iG3ul.errorMessages).some((a)=>a === value);
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("iG3ul", function(module, exports) {

$parcel$export(module.exports, "errorMessages", () => $d98edafbda84ae02$export$d8bd0967cb58683);
const $d98edafbda84ae02$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});

parcelRegister("gFuWD", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $c2287aa1e79453df$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $c2287aa1e79453df$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $c2287aa1e79453df$export$ff2962de2b2c930f);
const $c2287aa1e79453df$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $c2287aa1e79453df$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $c2287aa1e79453df$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $c2287aa1e79453df$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $c2287aa1e79453df$export$ff2962de2b2c930f = (product)=>{
    if ($c2287aa1e79453df$var$isJiraProduct(product)) return $c2287aa1e79453df$var$AiMateJiraXProduct[product];
    return product;
};

});

parcelRegister("lk6ge", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $f8605278fad44c3c$export$e45226161c660403);

var $gFuWD = parcelRequire("gFuWD");
async function* $f8605278fad44c3c$export$e45226161c660403(response) {
    const reader = (0, $gFuWD.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});


parcelRegister("3GWpI", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $2b029b1ca4dd266b$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::5fbe35afe0479810b090b1746dd1ae71>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");


var $jM5d4 = parcelRequire("jM5d4");
const $2b029b1ca4dd266b$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireEvent = (0, $eUqFw.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $jM5d4.default)(...params));
        event.fire((0, $034a66a6c038cbbf$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $034a66a6c038cbbf$export$3f072f06b90c3985 = 'media';

parcelRegister("jM5d4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6568a8da89a5cff$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::0d08fdca953a1eb1130683499e509165>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $e6568a8da89a5cff$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $e6568a8da89a5cff$export$2e2bcd8739ae039 = $e6568a8da89a5cff$var$createEventPayload;

});



parcelRegister("gLwaR", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $03265acf8d0826ee$export$cfa1d3eed9a61059);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $dmCPj = parcelRequire("dmCPj");

var $8uD7Y = parcelRequire("8uD7Y");

var $5jLFn = parcelRequire("5jLFn");

var $6D8aU = parcelRequire("6D8aU");

var $3GWpI = parcelRequire("3GWpI");
function $03265acf8d0826ee$export$cfa1d3eed9a61059({ url: url, ari: ari, product: product, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $3GWpI.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $eUqFw.useState)((0, $6D8aU.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $eUqFw.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content !== null && content !== void 0 ? content : '');
        setTooltipMessage((0, $6D8aU.messages).copied_summary_action_description);
        onClickCallback === null || onClickCallback === void 0 || onClickCallback();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jLFn.default), (0, $kU09D.default)({
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).copy_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))), {
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $6D8aU.messages).copy_summary_action_description)
    }, props));
}

});

parcelRegister("7WiGa", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $5c7c7077e11f1cf3$export$75a19de44af58722);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $5jLFn = parcelRequire("5jLFn");

var $9ZtZq = parcelRequire("9ZtZq");

var $6D8aU = parcelRequire("6D8aU");

var $3GWpI = parcelRequire("3GWpI");

var $1Mir7 = parcelRequire("1Mir7");
function $5c7c7077e11f1cf3$export$75a19de44af58722({ url: url, ari: ari, product: product, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $3GWpI.useAnalyticsEvents)();
    const onCompleted = (0, $eUqFw.useCallback)((state)=>{
        if ((state === null || state === void 0 ? void 0 : state.status) === 'error') onErrorCallback === null || onErrorCallback === void 0 || onErrorCallback((0, $1Mir7.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $eUqFw.useCallback)(()=>{
        var _summariseUrl;
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        (_summariseUrl = summariseUrl()) === null || _summariseUrl === void 0 || _summariseUrl.then(onCompleted, onCompleted);
        onClickCallback === null || onClickCallback === void 0 || onClickCallback();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jLFn.default), (0, $kU09D.default)({
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).ai_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ZtZq.default), {
            label: "Summarise with AI"
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).ai_summary_action_description)
    }, props));
}

});
parcelRegister("9ZtZq", function(module, exports) {

$parcel$export(module.exports, "default", () => $746112e488732647$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $746112e488732647$var$AiIcon = (props)=>{
    const iconColor = (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign') ? "var(--ds-icon, #44546F)" : `var(--ds-icon-accent-blue, ${0, $PdmhA.B200})`;
    const textColor = (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign') ? "var(--ds-icon, #44546F)" : `var(--ds-text-accent-blue, ${0, $PdmhA.B400})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg0",
        x1: "21",
        y1: "12",
        x2: "17.5",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.270833",
        stopColor: iconColor,
        color: iconColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: textColor,
        color: textColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg1",
        x1: "12.5",
        y1: "3",
        x2: "12.5",
        y2: "6.5",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.1875",
        stopColor: iconColor,
        color: iconColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: textColor,
        color: textColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg2",
        x1: "6.82996",
        y1: "12",
        x2: "3.32996",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: textColor,
        color: textColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.791667",
        stopColor: iconColor,
        color: iconColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg3",
        x1: "12.5",
        y1: "17",
        x2: "12.5",
        y2: "21",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: textColor,
        color: textColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.802083",
        stopColor: iconColor,
        color: iconColor
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
        fill: "url(#ai_icon_lg0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: "url(#ai_icon_lg1)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: "url(#ai_icon_lg2)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
        fill: "url(#ai_icon_lg3)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: iconColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: iconColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: iconColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: iconColor
    })));
};
var $746112e488732647$export$2e2bcd8739ae039 = $746112e488732647$var$AiIcon;

});

parcelRegister("1Mir7", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $14b89336c56d1290$export$82f46aa4e6535a45);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $dB5iy = parcelRequire("dB5iy");

var $2u7Sj = parcelRequire("2u7Sj");

var $4u2Ht = parcelRequire("4u2Ht");
const $14b89336c56d1290$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $dB5iy.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2u7Sj.default), {
            reason: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, message, {
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4u2Ht.default), {
                        href: url
                    }, chunks)
            }
        })))
    };
};

});
parcelRegister("dB5iy", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $9e62d732b053233e$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $9e62d732b053233e$export$cd2e891d7f87074d);

var $XHGTv = parcelRequire("XHGTv");

var $hXWLE = parcelRequire("hXWLE");

var $6D8aU = parcelRequire("6D8aU");
const $9e62d732b053233e$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>{
    var _response$meta, _response$meta$suppor;
    return Boolean((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-ai-summaries') && isAdminHubAIEnabled && (response === null || response === void 0 ? void 0 : (_response$meta = response.meta) === null || _response$meta === void 0 ? void 0 : (_response$meta$suppor = _response$meta.supportedFeature) === null || _response$meta$suppor === void 0 ? void 0 : _response$meta$suppor.includes('AISummary')));
};
const $9e62d732b053233e$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $6D8aU.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $hXWLE.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $6D8aU.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $6D8aU.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $6D8aU.messages).ai_summary_error_generic,
                url: (0, $hXWLE.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("2u7Sj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cf47deb3e9d444d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3GWpI = parcelRequire("3GWpI");
const $1cf47deb3e9d444d$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $3GWpI.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $1cf47deb3e9d444d$export$2e2bcd8739ae039 = $1cf47deb3e9d444d$var$AIEventErrorViewed;

});

parcelRegister("4u2Ht", function(module, exports) {

$parcel$export(module.exports, "default", () => $343c0efa351ec17b$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $hXWLE = parcelRequire("hXWLE");
const $343c0efa351ec17b$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", (0, $kU09D.default)({
        href: (0, $hXWLE.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer"
    }, props), children);
var $343c0efa351ec17b$export$2e2bcd8739ae039 = $343c0efa351ec17b$var$AILearnMoreAnchor;

});





parcelRegister("fI5A1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ff4b2894978495$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $clDde = parcelRequire("clDde");

var $5jLFn = parcelRequire("5jLFn");

var $l8O8E = parcelRequire("l8O8E");

var $hXWLE = parcelRequire("hXWLE");

var $6D8aU = parcelRequire("6D8aU");

var $gqldc = parcelRequire("gqldc");

const $b6ff4b2894978495$var$AutomationModal = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("lSP7s")));
const $b6ff4b2894978495$var$handleAutomateActionClick = (setIsModalOpen)=>{
    setIsModalOpen(true);
};
const $b6ff4b2894978495$var$handleAutomationActionClose = (setIsModalOpen)=>{
    setIsModalOpen(false);
};
const $b6ff4b2894978495$var$AutomationAction = (props)=>{
    var _ref, _context$actions;
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const smartLinkContext = (0, $gqldc.useSmartLinkContext)();
    const { connections: connections } = smartLinkContext;
    const environment = (_ref = connections.client.envKey) !== null && _ref !== void 0 ? _ref : 'prod';
    const context = (0, $l8O8E.useFlexibleUiContext)();
    const automationActionData = context === null || context === void 0 ? void 0 : (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $hXWLE.ActionName).AutomationAction];
    if (!automationActionData) return null;
    const { baseAutomationUrl: baseAutomationUrl, objectName: objectName, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, modalTitle: modalTitle, modalDescription: modalDescription } = automationActionData;
    const automationActionTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).automation_action_title);
    const automationActionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).automation_action_tooltip);
    const automationActionIconLabel = formatMessage((0, $6D8aU.messages).automation_action_icon_label);
    const automationModalTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), modalTitle);
    const automationModalDescription = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, modalDescription, {
        values: {
            name: objectName,
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks),
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null)
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jLFn.default), (0, $kU09D.default)({
        content: automationActionTitle,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clDde.default), {
            label: automationActionIconLabel
        }),
        testId: "smart-action-automation-action",
        tooltipMessage: automationActionTooltip
    }, automationActionData, props, {
        onClick: ()=>$b6ff4b2894978495$var$handleAutomateActionClick(setIsModalOpen)
    })), isModalOpen && /*#__PURE__*/ // TODO skeleton modal fallback
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b6ff4b2894978495$var$AutomationModal, {
        environment: environment,
        baseAutomationUrl: baseAutomationUrl,
        objectAri: objectAri,
        siteAri: siteAri,
        canManageAutomation: canManageAutomation,
        analyticsSource: analyticsSource,
        modalTitle: automationModalTitle,
        modalDescription: automationModalDescription,
        onClose: ()=>$b6ff4b2894978495$var$handleAutomationActionClose(setIsModalOpen)
    })));
};
var $b6ff4b2894978495$export$2e2bcd8739ae039 = $b6ff4b2894978495$var$AutomationAction;

});
parcelRegister("clDde", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fd5dcfe5f20d738$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $8fd5dcfe5f20d738$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
var $8fd5dcfe5f20d738$export$2e2bcd8739ae039 = $8fd5dcfe5f20d738$var$AutomationManualTriggersGlyph;

});

parcelRegister("lSP7s", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('8PAcp')
        ]);
        const value = parcelRequire('7RBbX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("8PAcp")
    ]).then(()=>parcelRequire('7RBbX'));
}

});


parcelRegister("3HQ5i", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b2dca20a24a7cab$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $5jLFn = parcelRequire("5jLFn");

var $8uD7Y = parcelRequire("8uD7Y");

var $6D8aU = parcelRequire("6D8aU");

var $l8O8E = parcelRequire("l8O8E");

var $63TK2 = parcelRequire("63TK2");
const $2b2dca20a24a7cab$var$ViewRelatedLinksAction = (props)=>{
    var _context$actions;
    const context = (0, $l8O8E.useFlexibleUiContext)();
    const actionData = context === null || context === void 0 ? void 0 : (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions.ViewRelatedLinksAction;
    return actionData ? (0, $byn9U.jsx)((0, $5jLFn.default), (0, $kU09D.default)({
        content: (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $6D8aU.messages).related_links_view_related_urls),
        icon: (0, $byn9U.jsx)((0, $63TK2.default), null),
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link"
    }, props)) : null;
};
var $2b2dca20a24a7cab$export$2e2bcd8739ae039 = $2b2dca20a24a7cab$var$ViewRelatedLinksAction;

});
parcelRegister("63TK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $469e42fa40ee685d$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $jfQfF = parcelRequire("jfQfF");
const $469e42fa40ee685d$var$rotateSvg = (0, $byn9U.css)({
    transform: 'rotate(180deg)',
    display: 'inline-block'
});
/**
 * ChildIssuesIcon but 180 degrees rotated
 */ const $469e42fa40ee685d$var$RelatedLinksActionIcon = ()=>(0, $byn9U.jsx)("span", {
        css: $469e42fa40ee685d$var$rotateSvg
    }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jfQfF))), {
        label: "View recent links..."
    }));
var $469e42fa40ee685d$export$2e2bcd8739ae039 = $469e42fa40ee685d$var$RelatedLinksActionIcon;

});




parcelRegister("aHboL", function(module, exports) {

$parcel$export(module.exports, "getGapSize", () => $7c96c3030e8efe36$export$ff20be09ae01c52e);
$parcel$export(module.exports, "getBaseStyles", () => $7c96c3030e8efe36$export$bff8031d86bb089);
$parcel$export(module.exports, "highlightRemoveStyles", () => $7c96c3030e8efe36$export$1928241a6f267c0d);
$parcel$export(module.exports, "getActionGroupStyles", () => $7c96c3030e8efe36$export$393b0054595c3748);
$parcel$export(module.exports, "filterActionItems", () => $7c96c3030e8efe36$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $7c96c3030e8efe36$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $7c96c3030e8efe36$export$9678d3ca18bd7526);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hXWLE = parcelRequire("hXWLE");

var $4fZpw = parcelRequire("4fZpw");

var $iw7Qh = parcelRequire("iw7Qh");

var $ezIO6 = parcelRequire("ezIO6");

var $9SkfS = parcelRequire("9SkfS");
const $7c96c3030e8efe36$export$f942619ce67b1a41 = {
    [(0, $hXWLE.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).Location]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).Preview]: [
        'block'
    ],
    [(0, $hXWLE.ElementName).Priority]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).Provider]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).Snippet]: [
        'block'
    ],
    [(0, $hXWLE.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).State]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).Title]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $hXWLE.ElementName).VoteCount]: [
        'inline'
    ]
};
const $7c96c3030e8efe36$var$getDirectionStyles = (direction)=>{
    switch(direction){
        case (0, $hXWLE.SmartLinkDirection).Vertical:
            return (0, $byn9U.css)({
                flexDirection: 'column',
                alignItems: 'flex-start'
            });
        case (0, $hXWLE.SmartLinkDirection).Horizontal:
        default:
            return (0, $byn9U.css)({
                flexDirection: 'row',
                alignItems: 'center'
            });
    }
};
const $7c96c3030e8efe36$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $hXWLE.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $hXWLE.SmartLinkSize).Large:
            return 1;
        case (0, $hXWLE.SmartLinkSize).Medium:
            return 0.5;
        case (0, $hXWLE.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $7c96c3030e8efe36$export$bff8031d86bb089 = (direction, size)=>(0, $byn9U.css)({
        alignItems: 'center',
        display: 'flex',
        gap: `${$7c96c3030e8efe36$export$ff20be09ae01c52e(size)}rem`,
        lineHeight: '1rem',
        minWidth: 0,
        overflow: 'hidden'
    }, $7c96c3030e8efe36$var$getDirectionStyles(direction), {
        '&:empty': {
            display: 'none'
        },
        '& > *': {
            minWidth: 0
        },
        '& > [data-fit-to-content]': {
            minWidth: 'fit-content'
        }
    });
const $7c96c3030e8efe36$export$1928241a6f267c0d = (0, $byn9U.css)`
  outline: none !important;
  outline-color: inherit;
  color: inherit;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
const $7c96c3030e8efe36$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $ezIO6.default);
const $7c96c3030e8efe36$var$isElementDisplayValid = (name, display)=>{
    var _ElementDisplaySchema, _ElementDisplaySchema2;
    return (_ElementDisplaySchema = (_ElementDisplaySchema2 = $7c96c3030e8efe36$export$f942619ce67b1a41[name]) === null || _ElementDisplaySchema2 === void 0 ? void 0 : _ElementDisplaySchema2.includes(display)) !== null && _ElementDisplaySchema !== void 0 ? _ElementDisplaySchema : false;
};
const $7c96c3030e8efe36$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $7c96c3030e8efe36$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && ((0, $iw7Qh.isFlexibleUiElement)(node) || node.type === (0, $9SkfS.default));
const $7c96c3030e8efe36$export$393b0054595c3748 = (size)=>{
    if (size === (0, $hXWLE.SmartLinkSize).XLarge) // The biggest height of the action button exceeds the max line-height
    // of the elements causing the action on the block with x-large size to
    // get cut at the bottom.
    return (0, $byn9U.css)({
        maxHeight: '2rem'
    });
};
const $7c96c3030e8efe36$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $hXWLE.ActionName).DeleteAction:
            case (0, $hXWLE.ActionName).EditAction:
            case (0, $hXWLE.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $hXWLE.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if ((context === null || context === void 0 ? void 0 : context.actions) === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $7c96c3030e8efe36$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (child)=>{
        if ($7c96c3030e8efe36$var$isElementOrElementGroup(child) || $7c96c3030e8efe36$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $7c96c3030e8efe36$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $4fZpw[name];
        const typedProps = props;
        if (Element && $7c96c3030e8efe36$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Element, (0, $kU09D.default)({
                key: idx
            }, typedProps));
            if (!$7c96c3030e8efe36$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("4fZpw", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => $3198330816cb7614$export$d3af56c23f9e459b);
$parcel$export(module.exports, "AssignedToGroup", () => $3198330816cb7614$export$fbd18f11bf3a3444);
$parcel$export(module.exports, "AttachmentCount", () => $3198330816cb7614$export$3bc3c9693a40aa);
$parcel$export(module.exports, "AuthorGroup", () => $3198330816cb7614$export$2ae2af4435dd6144);
$parcel$export(module.exports, "ChecklistProgress", () => $3198330816cb7614$export$5742b38fd5cfe410);
$parcel$export(module.exports, "CollaboratorGroup", () => $3198330816cb7614$export$a1e647014985ddb9);
$parcel$export(module.exports, "CommentCount", () => $3198330816cb7614$export$f4c1466e6fdd07b);
$parcel$export(module.exports, "CreatedOn", () => $3198330816cb7614$export$53ced9403d373871);
$parcel$export(module.exports, "CreatedBy", () => $3198330816cb7614$export$db468caedefbb630);
$parcel$export(module.exports, "DueOn", () => $3198330816cb7614$export$fea59459cfa1625b);
$parcel$export(module.exports, "LatestCommit", () => $3198330816cb7614$export$2aa8c58ab6c8ae64);
$parcel$export(module.exports, "LinkIcon", () => $3198330816cb7614$export$69387b41dfc808f7);
$parcel$export(module.exports, "Location", () => $3198330816cb7614$export$18a2be9195644f38);
$parcel$export(module.exports, "ModifiedBy", () => $3198330816cb7614$export$ebbbdcc68d717b7b);
$parcel$export(module.exports, "ModifiedOn", () => $3198330816cb7614$export$a6db3f4240728b58);
$parcel$export(module.exports, "OwnedBy", () => $3198330816cb7614$export$fa04b1f8d953704f);
$parcel$export(module.exports, "OwnedByGroup", () => $3198330816cb7614$export$90e81c873cca1e90);
$parcel$export(module.exports, "Priority", () => $3198330816cb7614$export$300334f671c43555);
$parcel$export(module.exports, "ProgrammingLanguage", () => $3198330816cb7614$export$7904b5485bf997ea);
$parcel$export(module.exports, "Provider", () => $3198330816cb7614$export$2881499e37b75b9a);
$parcel$export(module.exports, "ReactCount", () => $3198330816cb7614$export$f69df2decd5f729e);
$parcel$export(module.exports, "ReadTime", () => $3198330816cb7614$export$77dedcd16f070a20);
$parcel$export(module.exports, "SentOn", () => $3198330816cb7614$export$897b145a1ed39fe5);
$parcel$export(module.exports, "SourceBranch", () => $3198330816cb7614$export$387c3264a8f67d61);
$parcel$export(module.exports, "State", () => $3198330816cb7614$export$7254cc27399e90bd);
$parcel$export(module.exports, "SubscriberCount", () => $3198330816cb7614$export$cfafe90bba8a54db);
$parcel$export(module.exports, "SubTasksProgress", () => $3198330816cb7614$export$d441f34e4c8dd9e7);
$parcel$export(module.exports, "StoryPoints", () => $3198330816cb7614$export$634eef04d1a9a575);
$parcel$export(module.exports, "TargetBranch", () => $3198330816cb7614$export$b5e4199e062b8f44);
$parcel$export(module.exports, "Title", () => $3198330816cb7614$export$f99233281efd08a0);
$parcel$export(module.exports, "ViewCount", () => $3198330816cb7614$export$ae2d8be089b6cfe0);
$parcel$export(module.exports, "VoteCount", () => $3198330816cb7614$export$b080bef6ed7fa75a);
$parcel$export(module.exports, "Preview", () => (parcelRequire("lT9NU")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("b2LxU")).default);

var $kY0Ox = parcelRequire("kY0Ox");

var $hXWLE = parcelRequire("hXWLE");

var $lT9NU = parcelRequire("lT9NU");

var $b2LxU = parcelRequire("b2LxU");
const $3198330816cb7614$export$d3af56c23f9e459b = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).AssignedTo);
const $3198330816cb7614$export$fbd18f11bf3a3444 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).AssignedToGroup);
const $3198330816cb7614$export$3bc3c9693a40aa = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).AttachmentCount);
const $3198330816cb7614$export$2ae2af4435dd6144 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).AuthorGroup);
const $3198330816cb7614$export$5742b38fd5cfe410 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).ChecklistProgress);
const $3198330816cb7614$export$a1e647014985ddb9 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).CollaboratorGroup);
const $3198330816cb7614$export$f4c1466e6fdd07b = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).CommentCount);
const $3198330816cb7614$export$53ced9403d373871 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).CreatedOn);
const $3198330816cb7614$export$db468caedefbb630 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).CreatedBy);
const $3198330816cb7614$export$fea59459cfa1625b = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).DueOn);
const $3198330816cb7614$export$2aa8c58ab6c8ae64 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).LatestCommit);
const $3198330816cb7614$export$69387b41dfc808f7 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).LinkIcon);
const $3198330816cb7614$export$18a2be9195644f38 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).Location);
const $3198330816cb7614$export$ebbbdcc68d717b7b = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).ModifiedBy);
const $3198330816cb7614$export$a6db3f4240728b58 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).ModifiedOn);
const $3198330816cb7614$export$fa04b1f8d953704f = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).OwnedBy);
const $3198330816cb7614$export$90e81c873cca1e90 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).OwnedByGroup);
const $3198330816cb7614$export$300334f671c43555 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).Priority);
const $3198330816cb7614$export$7904b5485bf997ea = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).ProgrammingLanguage);
const $3198330816cb7614$export$2881499e37b75b9a = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).Provider);
const $3198330816cb7614$export$f69df2decd5f729e = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).ReactCount);
const $3198330816cb7614$export$77dedcd16f070a20 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).ReadTime);
const $3198330816cb7614$export$897b145a1ed39fe5 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).SentOn);
const $3198330816cb7614$export$387c3264a8f67d61 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).SourceBranch);
const $3198330816cb7614$export$7254cc27399e90bd = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).State);
const $3198330816cb7614$export$cfafe90bba8a54db = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).SubscriberCount);
const $3198330816cb7614$export$d441f34e4c8dd9e7 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).SubTasksProgress);
const $3198330816cb7614$export$634eef04d1a9a575 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).StoryPoints);
const $3198330816cb7614$export$b5e4199e062b8f44 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).TargetBranch);
const $3198330816cb7614$export$f99233281efd08a0 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).Title);
const $3198330816cb7614$export$ae2d8be089b6cfe0 = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).ViewCount);
const $3198330816cb7614$export$b080bef6ed7fa75a = (0, $kY0Ox.createElement)((0, $hXWLE.ElementName).VoteCount);

});
parcelRegister("kY0Ox", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $f43a0ae63297c297$export$c8a8987d4410bf2d);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");

var $hXWLE = parcelRequire("hXWLE");

var $5vSVw = parcelRequire("5vSVw");

var $daqOq = parcelRequire("daqOq");

var $eG0WP = parcelRequire("eG0WP");

var $l8O8E = parcelRequire("l8O8E");

var $5Nzsk = parcelRequire("5Nzsk");

var $zEmch = parcelRequire("zEmch");

var $9cgKu = parcelRequire("9cgKu");

var $5MKJX = parcelRequire("5MKJX");

var $6D8aU = parcelRequire("6D8aU");

var $aMfel = parcelRequire("aMfel");

var $jrTjF = parcelRequire("jrTjF");
const $f43a0ae63297c297$var$elementMappings = {
    [(0, $hXWLE.ElementName).AttachmentCount]: {
        component: (0, $5Nzsk.default),
        props: {
            icon: (0, $hXWLE.IconType).Attachment
        }
    },
    [(0, $hXWLE.ElementName).AuthorGroup]: {
        component: (0, $zEmch.default)
    },
    [(0, $hXWLE.ElementName).ChecklistProgress]: {
        component: (0, $5Nzsk.default),
        props: {
            icon: (0, $hXWLE.IconType).CheckItem
        }
    },
    [(0, $hXWLE.ElementName).CollaboratorGroup]: {
        component: (0, $zEmch.default)
    },
    [(0, $hXWLE.ElementName).CommentCount]: {
        component: (0, $5Nzsk.default),
        props: {
            icon: (0, $hXWLE.IconType).Comment
        }
    },
    [(0, $hXWLE.ElementName).ViewCount]: {
        component: (0, $5Nzsk.default),
        props: {
            icon: (0, $hXWLE.IconType).View
        }
    },
    [(0, $hXWLE.ElementName).ReactCount]: {
        component: (0, $5Nzsk.default),
        props: {
            icon: (0, $hXWLE.IconType).React
        }
    },
    [(0, $hXWLE.ElementName).VoteCount]: {
        component: (0, $5Nzsk.default),
        props: {
            icon: (0, $hXWLE.IconType).Vote
        }
    },
    [(0, $hXWLE.ElementName).CreatedBy]: {
        component: (0, $5MKJX.default)
    },
    [(0, $hXWLE.ElementName).OwnedBy]: {
        component: (0, $5MKJX.default)
    },
    [(0, $hXWLE.ElementName).AssignedTo]: {
        component: (0, $5MKJX.default)
    },
    [(0, $hXWLE.ElementName).AssignedToGroup]: {
        component: (0, $zEmch.default)
    },
    [(0, $hXWLE.ElementName).OwnedByGroup]: {
        component: (0, $zEmch.default)
    },
    [(0, $hXWLE.ElementName).CreatedOn]: {
        component: (0, $aMfel.default)
    },
    [(0, $hXWLE.ElementName).DueOn]: {
        component: (0, $eG0WP.default)
    },
    [(0, $hXWLE.ElementName).LatestCommit]: {
        component: (0, $5Nzsk.default),
        props: {
            icon: (0, $hXWLE.IconType).Commit
        }
    },
    [(0, $hXWLE.ElementName).LinkIcon]: {
        component: (0, $5vSVw.default)
    },
    [(0, $hXWLE.ElementName).ModifiedBy]: {
        component: (0, $5MKJX.default)
    },
    [(0, $hXWLE.ElementName).ModifiedOn]: {
        component: (0, $aMfel.default)
    },
    [(0, $hXWLE.ElementName).Preview]: {
        component: (0, $9cgKu.default)
    },
    [(0, $hXWLE.ElementName).Priority]: {
        component: (0, $5Nzsk.default)
    },
    [(0, $hXWLE.ElementName).ProgrammingLanguage]: {
        component: (0, $5Nzsk.default),
        props: {
            icon: (0, $hXWLE.IconType).ProgrammingLanguage
        }
    },
    [(0, $hXWLE.ElementName).Provider]: {
        component: (0, $5Nzsk.default)
    },
    [(0, $hXWLE.ElementName).ReadTime]: {
        component: (0, $5MKJX.default)
    },
    [(0, $hXWLE.ElementName).SentOn]: {
        component: (0, $aMfel.default)
    },
    [(0, $hXWLE.ElementName).SourceBranch]: {
        component: (0, $5MKJX.default)
    },
    [(0, $hXWLE.ElementName).State]: {
        component: (0, $eG0WP.default)
    },
    [(0, $hXWLE.ElementName).SubscriberCount]: {
        component: (0, $5Nzsk.default),
        props: {
            icon: (0, $hXWLE.IconType).Subscriber
        }
    },
    [(0, $hXWLE.ElementName).SubTasksProgress]: {
        component: (0, $5Nzsk.default),
        props: {
            icon: (0, $hXWLE.IconType).SubTasksProgress
        }
    },
    [(0, $hXWLE.ElementName).StoryPoints]: {
        component: (0, $jrTjF.default)
    },
    [(0, $hXWLE.ElementName).TargetBranch]: {
        component: (0, $5MKJX.default)
    },
    [(0, $hXWLE.ElementName).Title]: {
        component: (0, $daqOq.default)
    },
    [(0, $hXWLE.ElementName).Location]: {
        component: (0, $daqOq.default),
        props: {
            theme: (0, $hXWLE.SmartLinkInternalTheme).Grey
        }
    }
};
const $f43a0ae63297c297$var$getContextKey = (name)=>{
    // Attempt to predict context prop name in advance to reduce the amount of
    // code run during runtime
    return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
};
const $f43a0ae63297c297$var$getData = (elementName, contextKey, context)=>{
    if (!context) return undefined;
    const data = context[contextKey];
    switch(elementName){
        case (0, $hXWLE.ElementName).AssignedToGroup:
        case (0, $hXWLE.ElementName).AuthorGroup:
        case (0, $hXWLE.ElementName).CollaboratorGroup:
        case (0, $hXWLE.ElementName).OwnedByGroup:
            const AvatarGroupsWithFallback = [
                (0, $hXWLE.ElementName).AssignedToGroup
            ];
            const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
            return $f43a0ae63297c297$var$toAvatarGroupProps(data, showFallbackAvatar);
        case (0, $hXWLE.ElementName).AttachmentCount:
        case (0, $hXWLE.ElementName).ChecklistProgress:
        case (0, $hXWLE.ElementName).CommentCount:
        case (0, $hXWLE.ElementName).ViewCount:
        case (0, $hXWLE.ElementName).ReactCount:
        case (0, $hXWLE.ElementName).VoteCount:
        case (0, $hXWLE.ElementName).ProgrammingLanguage:
        case (0, $hXWLE.ElementName).SubscriberCount:
        case (0, $hXWLE.ElementName).LatestCommit:
        case (0, $hXWLE.ElementName).SubTasksProgress:
            return $f43a0ae63297c297$var$toBadgeProps(data);
        case (0, $hXWLE.ElementName).StoryPoints:
            return $f43a0ae63297c297$var$toAtlaskitBadgeProps(data);
        case (0, $hXWLE.ElementName).CreatedBy:
            return $f43a0ae63297c297$var$toFormattedTextProps((0, $6D8aU.messages).created_by, context.createdBy);
        case (0, $hXWLE.ElementName).AssignedTo:
            return $f43a0ae63297c297$var$toFormattedTextProps((0, $6D8aU.messages).assigned_to, context.assignedTo);
        case (0, $hXWLE.ElementName).OwnedBy:
            return $f43a0ae63297c297$var$toFormattedTextProps((0, $6D8aU.messages).owned_by, context.ownedBy);
        case (0, $hXWLE.ElementName).CreatedOn:
            return $f43a0ae63297c297$var$toDateTimeProps('created', context.createdOn);
        case (0, $hXWLE.ElementName).DueOn:
            return $f43a0ae63297c297$var$toDateLozengeProps(context.dueOn);
        case (0, $hXWLE.ElementName).ModifiedBy:
            return $f43a0ae63297c297$var$toFormattedTextProps((0, $6D8aU.messages).modified_by, context.modifiedBy);
        case (0, $hXWLE.ElementName).ModifiedOn:
            return $f43a0ae63297c297$var$toDateTimeProps('modified', context.modifiedOn);
        case (0, $hXWLE.ElementName).SentOn:
            return $f43a0ae63297c297$var$toDateTimeProps('sent', context.sentOn);
        case (0, $hXWLE.ElementName).ReadTime:
            return $f43a0ae63297c297$var$toFormattedTextProps((0, $6D8aU.messages).read_time, data);
        case (0, $hXWLE.ElementName).SourceBranch:
        case (0, $hXWLE.ElementName).TargetBranch:
            return $f43a0ae63297c297$var$toTextProps(data);
        case (0, $hXWLE.ElementName).Title:
            return $f43a0ae63297c297$var$toLinkProps(context.title, context.url);
        default:
            return typeof data === 'object' ? data : undefined;
    }
};
const $f43a0ae63297c297$var$toAvatarGroupProps = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
const $f43a0ae63297c297$var$toBadgeProps = (label)=>{
    return label ? {
        label: label
    } : undefined;
};
const $f43a0ae63297c297$var$toAtlaskitBadgeProps = (value)=>{
    return value ? {
        value: value
    } : undefined;
};
const $f43a0ae63297c297$var$toDateLozengeProps = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90IgZ.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
const $f43a0ae63297c297$var$toDateTimeProps = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
const $f43a0ae63297c297$var$toFormattedTextProps = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        }
    } : undefined;
};
const $f43a0ae63297c297$var$toLinkProps = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
const $f43a0ae63297c297$var$toTextProps = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
const $f43a0ae63297c297$export$c8a8987d4410bf2d = (name)=>{
    const { component: BaseElement, props: props } = $f43a0ae63297c297$var$elementMappings[name] || {};
    const contextKey = $f43a0ae63297c297$var$getContextKey(name);
    if (!BaseElement) throw Error(`Element ${name} does not exist.`);
    return (overrides)=>{
        const context = (0, $eUqFw.useContext)((0, $l8O8E.FlexibleUiContext));
        const data = $f43a0ae63297c297$var$getData(name, contextKey, context);
        return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BaseElement, (0, $kU09D.default)({}, props, data, overrides, {
            name: name
        })) : null;
    };
};

});
parcelRegister("daqOq", function(module, exports) {

$parcel$export(module.exports, "default", () => $996101e71b5fd5d9$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8cU5f = parcelRequire("8cU5f");

var $hXWLE = parcelRequire("hXWLE");

var $jvuTK = parcelRequire("jvuTK");

var $hnYQo = parcelRequire("hnYQo");
const $996101e71b5fd5d9$var$DEFAULT_MAX_LINES = 2;
const $996101e71b5fd5d9$var$MAXIMUM_MAX_LINES = 2;
const $996101e71b5fd5d9$var$MINIMUM_MAX_LINES = 1;
const $996101e71b5fd5d9$var$containerStyles = (0, $byn9U.css)({
    flex: '1 1 auto'
});
const $996101e71b5fd5d9$var$getThemeStyles = (theme)=>{
    switch(theme){
        case (0, $hXWLE.SmartLinkInternalTheme).Grey:
            // We are being specifc with the CSS selectors to ensure that Confluence overrides
            // do not affect our internal Smart Card styles
            return (0, $byn9U.css)({
                'a&': {
                    color: "var(--ds-text-subtlest, #626F86)",
                    '&:active, &:visited, &:focus, &:hover': {
                        color: "var(--ds-text-subtlest, #626F86)",
                        textDecoration: 'underline'
                    },
                    fontSize: '12px'
                }
            });
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        case (0, $hXWLE.SmartLinkTheme).Black:
            return (0, $byn9U.css)({
                color: "var(--ds-text-subtle, #44546F)",
                ':active': {
                    color: "var(--ds-text, #172B4D)"
                },
                ':hover': {
                    color: "var(--ds-text-subtle, #44546F)",
                    textDecoration: 'underline'
                }
            });
        case (0, $hXWLE.SmartLinkTheme).Link:
        default:
            return (0, $byn9U.css)({
                color: "var(--ds-link, #0C66E4)",
                ':active': {
                    color: "var(--ds-link-pressed, #0055CC)"
                },
                ':hover': {
                    color: "var(--ds-link, #0C66E4)",
                    textDecoration: 'underline'
                }
            });
    }
};
const $996101e71b5fd5d9$var$getAnchorStyles = (size, theme, maxLines, hasSpace)=>{
    const sizeStyles = (0, $jvuTK.getLinkSizeStyles)(size);
    return (0, $byn9U.css)({
        flex: '1 1 auto'
    }, sizeStyles, (0, $jvuTK.getTruncateStyles)(maxLines, (0, $jvuTK.getLinkLineHeight)(size), hasSpace ? 'break-word' : 'break-all'), $996101e71b5fd5d9$var$getThemeStyles(theme));
};
const $996101e71b5fd5d9$var$getMaxLines = (maxLines)=>{
    if (maxLines > $996101e71b5fd5d9$var$MAXIMUM_MAX_LINES) return $996101e71b5fd5d9$var$DEFAULT_MAX_LINES;
    if (maxLines < $996101e71b5fd5d9$var$MINIMUM_MAX_LINES) return $996101e71b5fd5d9$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $996101e71b5fd5d9$var$withTooltip = (trigger, content, testId)=>(0, $byn9U.jsx)((0, $8cU5f.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span"
    }, trigger);
/**
 * A base element that represent an anchor.
 * @internal
 * @param {LinkProps} LinkProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $996101e71b5fd5d9$var$Link = ({ hideTooltip: hideTooltip, maxLines: maxLines = $996101e71b5fd5d9$var$DEFAULT_MAX_LINES, name: name, overrideCss: overrideCss, size: size = (0, $hXWLE.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $hXWLE.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
    const onMouseDown = (0, $hnYQo.useMouseDownEvent)();
    const hasSpace = (0, $eUqFw.useMemo)(()=>text ? (0, $jvuTK.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = (0, $byn9U.jsx)("a", (0, $kU09D.default)({
        css: [
            $996101e71b5fd5d9$var$getAnchorStyles(size, theme, $996101e71b5fd5d9$var$getMaxLines(maxLines), hasSpace),
            overrideCss
        ],
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url
    }, target !== '_self' && {
        target: target
    }), text);
    return (0, $byn9U.jsx)("span", {
        css: $996101e71b5fd5d9$var$containerStyles
    }, hideTooltip || text === undefined ? anchor : $996101e71b5fd5d9$var$withTooltip(anchor, text, testId));
};
var $996101e71b5fd5d9$export$2e2bcd8739ae039 = $996101e71b5fd5d9$var$Link;

});

parcelRegister("eG0WP", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaf5b922dc9c13fb$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ffiyv = parcelRequire("ffiyv");

var $6GfCT = parcelRequire("6GfCT");

var $l8O8E = parcelRequire("l8O8E");
const $aaf5b922dc9c13fb$var$styles = (0, $byn9U.css)({
    display: 'inline-flex',
    lineHeight: 'inherit'
});
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {LozengeProps} LozengeProps - The props necessary for the Lozenge element.
 * @see State
 */ const $aaf5b922dc9c13fb$var$Lozenge = ({ action: action, appearance: appearance = 'default', name: name, overrideCss: overrideCss, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $l8O8E.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? (0, $byn9U.jsx)((0, $6GfCT.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui === null || ui === void 0 ? void 0 : ui.zIndex
    }) : (0, $byn9U.jsx)((0, $ffiyv.default), {
        appearance: appearance,
        style: style,
        testId: `${testId}-lozenge`
    }, text);
    return (0, $byn9U.jsx)("span", {
        css: [
            $aaf5b922dc9c13fb$var$styles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId
    }, lozenge);
};
var $aaf5b922dc9c13fb$export$2e2bcd8739ae039 = $aaf5b922dc9c13fb$var$Lozenge;

});
parcelRegister("6GfCT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dd2c9613f8f1a9b$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $6OfWd = parcelRequire("6OfWd");

var $jLQtw = parcelRequire("jLQtw");

var $k2h64 = parcelRequire("k2h64");

var $7Mpda = parcelRequire("7Mpda");

var $jJygp = parcelRequire("jJygp");

var $7BllE = parcelRequire("7BllE");

var $9MZfO = parcelRequire("9MZfO");

var $9r9En = parcelRequire("9r9En");

var $4ZDXV = parcelRequire("4ZDXV");

var $gM0yE = parcelRequire("gM0yE");

var $l8O8E = parcelRequire("l8O8E");

var $iDnwt = parcelRequire("iDnwt");

var $8cPBc = parcelRequire("8cPBc");

var $lfBjM = parcelRequire("lfBjM");
const $4dd2c9613f8f1a9b$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $4dd2c9613f8f1a9b$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    var _action$update;
    const [selected, setSelected] = (0, $eUqFw.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $eUqFw.useState)(false);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [items, setItems] = (0, $eUqFw.useState)();
    const [errorMessage, setErrorMessage] = (0, $eUqFw.useState)();
    const reload = (0, $9r9En.default)();
    //TODO EDM-6583 Replace usage of useFlexibleUiAnalyticsContext with linking platform analytics context from find team.
    const analytics = (0, $l8O8E.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $jJygp.default)();
    (0, $eUqFw.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, previewData: previewData } = (action === null || action === void 0 ? void 0 : (_action$update = action.update) === null || _action$update === void 0 ? void 0 : _action$update.details) || {};
    const handleOpenChange = (0, $eUqFw.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            analytics === null || analytics === void 0 || analytics.ui.smartLinkLozengeActionClickedEvent();
            analytics === null || analytics === void 0 || analytics.track.smartLinkQuickActionStarted({
                smartLinkActionType: (0, $iDnwt.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action !== null && action !== void 0 && action.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $7BllE.default));
                const validItems = typeof text === 'string' ? $4dd2c9613f8f1a9b$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if ((validItems === null || validItems === void 0 ? void 0 : validItems.length) === 0) {
                    analytics === null || analytics === void 0 || analytics.track.smartLinkQuickActionFailed((0, $8cPBc.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $4ZDXV.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $4ZDXV.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                analytics === null || analytics === void 0 || analytics.track.smartLinkQuickActionFailed((0, $8cPBc.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        analytics,
        invoke,
        isLoaded,
        text
    ]);
    const trigger = (0, $eUqFw.useCallback)((props)=>(0, $byn9U.jsx)((0, $jLQtw.default), (0, $kU09D.default)({}, props, {
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        })), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $eUqFw.useCallback)(async (id, text, appearance)=>{
        try {
            analytics === null || analytics === void 0 || analytics.ui.smartLinkLozengeActionListItemClickedEvent();
            const updateAction = action === null || action === void 0 ? void 0 : action.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $9MZfO.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                analytics === null || analytics === void 0 || analytics.track.smartLinkQuickActionSuccess({
                    smartLinkActionType: (0, $iDnwt.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $gM0yE.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                analytics === null || analytics === void 0 || analytics.track.smartLinkQuickActionFailed((0, $8cPBc.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $4ZDXV.LozengeActionErrorMessages).updateFailed);
                analytics === null || analytics === void 0 || analytics.track.smartLinkQuickActionFailed((0, $8cPBc.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action === null || action === void 0 ? void 0 : action.update,
        analytics,
        invoke,
        linkId,
        reload,
        url
    ]);
    const dropdownItemGroup = (0, $eUqFw.useMemo)(()=>{
        if (errorMessage) return (0, $byn9U.jsx)((0, $k2h64.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            previewData: previewData
        });
        if (items && items.length > 0) return (0, $byn9U.jsx)((0, $lfBjM.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        previewData,
        testId,
        url
    ]);
    return (0, $byn9U.jsx)((0, $6OfWd.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex
    }, dropdownItemGroup);
};
var $4dd2c9613f8f1a9b$export$2e2bcd8739ae039 = (0, $7Mpda.default)($4dd2c9613f8f1a9b$var$LozengeAction);

});
parcelRegister("jLQtw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e64b1c8f1705cc46$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $86Ndv = parcelRequire("86Ndv");

var $jbXBm = parcelRequire("jbXBm");
const $e64b1c8f1705cc46$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $eUqFw.useState)(false);
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $eUqFw.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $eUqFw.useMemo)(()=>(0, $byn9U.jsx)((0, $ffiyv.default), {
            appearance: appearance,
            isBold: isBold
        }, (0, $byn9U.jsx)("span", {
            css: (0, $jbXBm.triggerLozengeStyles)
        }, (0, $byn9U.jsx)("span", null, text), (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: "options",
            size: "medium"
        }))), [
        appearance,
        isBold,
        text
    ]);
    return (0, $byn9U.jsx)("button", (0, $kU09D.default)({
        type: "button"
    }, props, {
        css: (0, $jbXBm.triggerButtonStyles),
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef
    }), lozenge);
};
var $e64b1c8f1705cc46$export$2e2bcd8739ae039 = $e64b1c8f1705cc46$var$LozengeActionTrigger;

});
parcelRegister("jbXBm", function(module, exports) {

$parcel$export(module.exports, "triggerButtonStyles", () => $df8d470391f96b0b$export$ae858546f0bfd05c);
$parcel$export(module.exports, "triggerLozengeStyles", () => $df8d470391f96b0b$export$5717c7336384f3a6);
$parcel$export(module.exports, "dropdownItemGroupStyles", () => $df8d470391f96b0b$export$2c40d814aeff5db);

var $byn9U = parcelRequire("byn9U");
const $df8d470391f96b0b$export$ae858546f0bfd05c = (0, $byn9U.css)({
    all: 'unset',
    backgroundColor: 'transparent',
    color: 'unset',
    cursor: 'pointer',
    fontFamily: 'unset',
    fontSize: 'unset',
    fontStyle: 'unset',
    fontWeight: 'unset',
    fontVariant: 'unset',
    lineHeight: 0,
    padding: 0,
    textTransform: 'unset',
    border: '2px solid transparent',
    margin: "var(--ds-space-025, 2px)",
    "&:focus-visible, &:focus-within, &[aria-expanded='true']": {
        outline: 'none',
        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`,
        borderRadius: '5px'
    }
});
const $df8d470391f96b0b$export$5717c7336384f3a6 = (0, $byn9U.css)({
    alignItems: 'center',
    display: 'flex',
    "span[role='img']": {
        margin: `${"var(--ds-space-negative-050, -4px)"} ${"var(--ds-space-negative-100, -8px)"} ${"var(--ds-space-negative-050, -4px)"} -1px`
    }
});
const $df8d470391f96b0b$export$2c40d814aeff5db = (0, $byn9U.css)({
    maxHeight: '300px',
    overflowY: 'auto',
    button: {
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        minHeight: '28px',
        width: '220px',
        '&:hover': {
            backgroundColor: 'inherit'
        },
        '&:focus, &:focus-visible': {
            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            boxSizing: 'border-box',
            boxShadow: `inset 2px 0 0 ${"var(--ds-border-selected, #0C66E4)"}`,
            outline: 'none'
        }
    }
});

});


parcelRegister("k2h64", function(module, exports) {

$parcel$export(module.exports, "default", () => $e96141a4fc76d9d6$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $PdmhA = parcelRequire("PdmhA");

var $96IgR = parcelRequire("96IgR");

var $eNyrq = parcelRequire("eNyrq");

var $jvuTK = parcelRequire("jvuTK");

var $6D8aU = parcelRequire("6D8aU");

var $l8O8E = parcelRequire("l8O8E");

var $9r9En = parcelRequire("9r9En");
const $e96141a4fc76d9d6$var$MAX_LINE_NUMBER = 8;
const $e96141a4fc76d9d6$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $e96141a4fc76d9d6$var$MAX_LINE_NUMBER, url: url, previewData: previewData })=>{
    const reload = (0, $9r9En.default)();
    const analytics = (0, $l8O8E.useFlexibleUiAnalyticsContext)();
    const isPreviewAvailable = previewData && previewData.src !== undefined;
    const handlePreviewClose = (0, $eUqFw.useCallback)(()=>{
        if (url) reload(url, true);
    }, [
        reload,
        url
    ]);
    const handlePreviewOpen = (0, $eUqFw.useCallback)(()=>{
        if (isPreviewAvailable) {
            analytics === null || analytics === void 0 || analytics.ui.smartLinkLozengeActionErrorOpenPreviewClickedEvent();
            return (0, $jvuTK.openEmbedModalWithFlexibleUiIcon)({
                ...previewData,
                analytics: analytics,
                onClose: handlePreviewClose
            });
        }
    }, [
        analytics,
        handlePreviewClose,
        isPreviewAvailable,
        previewData
    ]);
    const content = (0, $eUqFw.useMemo)(()=>{
        return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("div", {
            css: (0, $eNyrq.contentStyles)
        }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            testId: `${testId}-icon`,
            size: "medium",
            primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA.R500)})`,
            secondaryColor: `var(--ds-background-danger, ${(0, $PdmhA.R50)})`,
            label: 'error'
        }), (0, $byn9U.jsx)("span", {
            css: (0, $eNyrq.textStyles)(maxLineNumber),
            "data-testid": `${testId}-error-message`
        }, typeof errorMessage === 'string' ? errorMessage : (0, $jvuTK.getFormattedMessage)(errorMessage))), isPreviewAvailable ? (0, $byn9U.jsx)("div", {
            css: (0, $eNyrq.linkStyles)
        }, (0, $byn9U.jsx)("a", {
            target: "_blank",
            "data-testid": `${testId}-open-embed`,
            onClick: handlePreviewOpen
        }, (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $6D8aU.messages).open_issue_in_jira))) : null);
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        maxLineNumber,
        testId
    ]);
    return (0, $byn9U.jsx)("span", {
        css: (0, $eNyrq.dropdownItemGroupStyles),
        "data-testid": `${testId}-error-item-group`
    }, (0, $byn9U.jsx)((0, $fEubG.default), null, (0, $byn9U.jsx)((0, $hD6GJ.default), {
        testId: `${testId}-error`
    }, content)));
};
var $e96141a4fc76d9d6$export$2e2bcd8739ae039 = $e96141a4fc76d9d6$var$LozengeActionError;

});
parcelRegister("eNyrq", function(module, exports) {

$parcel$export(module.exports, "dropdownItemGroupStyles", () => $ac605ba04e2fb6c2$export$2c40d814aeff5db);
$parcel$export(module.exports, "contentStyles", () => $ac605ba04e2fb6c2$export$a38ecc1ac2e6fba);
$parcel$export(module.exports, "linkStyles", () => $ac605ba04e2fb6c2$export$4ea5976125a01ffa);
$parcel$export(module.exports, "textStyles", () => $ac605ba04e2fb6c2$export$6a54c24d15b0f6ba);

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $jvuTK = parcelRequire("jvuTK");
const $ac605ba04e2fb6c2$export$2c40d814aeff5db = (0, $byn9U.css)({
    button: {
        width: '220px',
        '&:hover': {
            backgroundColor: 'inherit',
            cursor: 'default'
        }
    }
});
const $ac605ba04e2fb6c2$var$sharedBlockStyles = (0, $byn9U.css)({
    display: 'flex',
    gap: "var(--ds-space-100, 0.5rem)",
    lineHeight: '1rem',
    minWidth: 0,
    overflow: 'hidden',
    flexDirection: 'row',
    alignItems: 'center'
});
const $ac605ba04e2fb6c2$export$a38ecc1ac2e6fba = (0, $byn9U.css)($ac605ba04e2fb6c2$var$sharedBlockStyles, {
    marginTop: "var(--ds-space-025, 2px)",
    alignItems: 'flex-start',
    '> span, > div': {
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        color: `var(--ds-text, ${(0, $PdmhA.N800)})`
    }
});
const $ac605ba04e2fb6c2$export$4ea5976125a01ffa = (0, $byn9U.css)($ac605ba04e2fb6c2$var$sharedBlockStyles, {
    cursor: 'pointer',
    fontSize: '0.875rem',
    marginTop: "var(--ds-space-100, 8px)",
    marginLeft: "var(--ds-space-400, 32px)",
    marginBottom: "var(--ds-space-025, 2px)"
});
const $ac605ba04e2fb6c2$export$6a54c24d15b0f6ba = (maxLines)=>(0, $byn9U.css)({
        lineHeight: '1rem',
        whiteSpace: 'normal'
    }, (0, $jvuTK.getTruncateStyles)(maxLines));

});


parcelRegister("7Mpda", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aa0928e773eacee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jb3WS = parcelRequire("jb3WS");

var $ffiyv = parcelRequire("ffiyv");
const $5aa0928e773eacee$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $eUqFw.useMemo)(()=>{
            var _props$testId;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                appearance: props === null || props === void 0 ? void 0 : props.appearance,
                testId: `${(_props$testId = props === null || props === void 0 ? void 0 : props.testId) !== null && _props$testId !== void 0 ? _props$testId : 'smart-element-lozenge-action'}-fallback`
            }, props === null || props === void 0 ? void 0 : props.text);
        }, [
            props === null || props === void 0 ? void 0 : props.appearance,
            props === null || props === void 0 ? void 0 : props.testId,
            props === null || props === void 0 ? void 0 : props.text
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props));
    };
var $5aa0928e773eacee$export$2e2bcd8739ae039 = $5aa0928e773eacee$var$withErrorBoundary;

});

parcelRegister("7BllE", function(module, exports) {

$parcel$export(module.exports, "default", () => $588c8c6f36e8494d$export$2e2bcd8739ae039);
const $588c8c6f36e8494d$var$extractLozengeActionItems = (response)=>{
    var _response$transitions, _response$transitions2;
    const items = (_response$transitions = response === null || response === void 0 ? void 0 : (_response$transitions2 = response.transitions) === null || _response$transitions2 === void 0 ? void 0 : _response$transitions2.map(({ appearance: appearance, id: id, name: name })=>{
        var _ref;
        return {
            appearance: (_ref = appearance) !== null && _ref !== void 0 ? _ref : 'default',
            id: id,
            text: name
        };
    })) !== null && _response$transitions !== void 0 ? _response$transitions : [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $588c8c6f36e8494d$export$2e2bcd8739ae039 = $588c8c6f36e8494d$var$extractLozengeActionItems;

});

parcelRegister("9MZfO", function(module, exports) {

$parcel$export(module.exports, "default", () => $72081c80e276969c$export$2e2bcd8739ae039);
const $72081c80e276969c$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $72081c80e276969c$export$2e2bcd8739ae039 = $72081c80e276969c$var$createStatusUpdateRequest;

});

parcelRegister("4ZDXV", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $3a2bdc4408140176$export$4f2e371a667ad688);

var $6D8aU = parcelRequire("6D8aU");
const $3a2bdc4408140176$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $6D8aU.messages)['status_change_permission_error']
    },
    unknown: {
        descriptor: (0, $6D8aU.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $6D8aU.messages)['status_change_update_error']
    }
};

});

parcelRegister("8cPBc", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $5f977833b86a9d62$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $5f977833b86a9d62$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $5f977833b86a9d62$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $5f977833b86a9d62$export$618660b8f2aa87e2);

var $iDnwt = parcelRequire("iDnwt");
const $5f977833b86a9d62$export$2a568ff99500df53 = {
    smartLinkActionType: (0, $iDnwt.TrackQuickActionType).StatusUpdate,
    reason: (0, $iDnwt.TrackQuickActionFailureReason).UnknownError,
    step: 'load'
};
const $5f977833b86a9d62$export$2de2d0ccc17b915f = {
    smartLinkActionType: (0, $iDnwt.TrackQuickActionType).StatusUpdate,
    reason: (0, $iDnwt.TrackQuickActionFailureReason).PermissionError,
    step: 'load'
};
const $5f977833b86a9d62$export$c1c05f9d51f7c467 = {
    smartLinkActionType: (0, $iDnwt.TrackQuickActionType).StatusUpdate,
    reason: (0, $iDnwt.TrackQuickActionFailureReason).UnknownError,
    step: 'update'
};
const $5f977833b86a9d62$export$618660b8f2aa87e2 = {
    smartLinkActionType: (0, $iDnwt.TrackQuickActionType).StatusUpdate,
    reason: (0, $iDnwt.TrackQuickActionFailureReason).ValidationError,
    step: 'update'
};

});

parcelRegister("lfBjM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f787f247e439a573$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $jFqkZ = parcelRequire("jFqkZ");

var $jbXBm = parcelRequire("jbXBm");

var $fEubG = parcelRequire("fEubG");
const $f787f247e439a573$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    (0, $byn9U.jsx)("span", {
        css: (0, $jbXBm.dropdownItemGroupStyles),
        "data-testid": `${testId}-item-group`
    }, (0, $byn9U.jsx)((0, $fEubG.default), null, items.map((item, idx)=>(0, $byn9U.jsx)((0, $jFqkZ.default), (0, $kU09D.default)({}, item, {
            key: idx,
            onClick: onClick,
            testId: `${testId}-item-${idx}`
        })))));
var $f787f247e439a573$export$2e2bcd8739ae039 = $f787f247e439a573$var$LozengeActionItemsGroup;

});
parcelRegister("jFqkZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e51646bf48abc65c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $ffiyv = parcelRequire("ffiyv");
const $e51646bf48abc65c$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $eUqFw.useCallback)((e)=>{
        var _e$currentTarget, _e$currentTarget$firs;
        (_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 || (_e$currentTarget$firs = _e$currentTarget.firstElementChild) === null || _e$currentTarget$firs === void 0 || _e$currentTarget$firs.focus();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        onMouseEnter: handleMouseEnter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: appearance
    }, text)));
};
var $e51646bf48abc65c$export$2e2bcd8739ae039 = $e51646bf48abc65c$var$LozengeActionItem;

});




parcelRegister("5Nzsk", function(module, exports) {

$parcel$export(module.exports, "default", () => $438d0824fb7af3fd$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jvuTK = parcelRequire("jvuTK");

var $hXWLE = parcelRequire("hXWLE");

var $6D8aU = parcelRequire("6D8aU");

var $3GGUk = parcelRequire("3GGUk");

var $h2L5X = parcelRequire("h2L5X");
const $438d0824fb7af3fd$var$badgeStyles = (0, $byn9U.css)({
    alignItems: 'center',
    display: 'inline-flex',
    minWidth: 'fit-content'
});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
const $438d0824fb7af3fd$var$iconStyles = (0, $byn9U.css)`
  color: ${"var(--ds-icon-subtle, #626F86)"};
  line-height: 0;
  vertical-align: middle;
  ${(0, $jvuTK.getIconSizeStyles)('1rem')}
  img,
  span,
  svg {
    line-height: 0;
    vertical-align: middle;
  }
`;
const $438d0824fb7af3fd$var$labelStyles = (0, $byn9U.css)({
    color: "var(--ds-text-subtlest, #626F86)",
    fontSize: '0.75rem',
    lineHeight: '1rem',
    paddingLeft: "var(--ds-space-025, 0.125rem)",
    verticalAlign: 'middle'
});
const $438d0824fb7af3fd$var$messageMapper = {
    [(0, $hXWLE.IconType).PriorityBlocker]: (0, $6D8aU.messages).priority_blocker,
    [(0, $hXWLE.IconType).PriorityCritical]: (0, $6D8aU.messages).priority_critical,
    [(0, $hXWLE.IconType).PriorityHigh]: (0, $6D8aU.messages).priority_high,
    [(0, $hXWLE.IconType).PriorityHighest]: (0, $6D8aU.messages).priority_highest,
    [(0, $hXWLE.IconType).PriorityLow]: (0, $6D8aU.messages).priority_low,
    [(0, $hXWLE.IconType).PriorityLowest]: (0, $6D8aU.messages).priority_lowest,
    [(0, $hXWLE.IconType).PriorityMajor]: (0, $6D8aU.messages).priority_major,
    [(0, $hXWLE.IconType).PriorityMedium]: (0, $6D8aU.messages).priority_medium,
    [(0, $hXWLE.IconType).PriorityMinor]: (0, $6D8aU.messages).priority_minor,
    [(0, $hXWLE.IconType).PriorityTrivial]: (0, $6D8aU.messages).priority_trivial,
    [(0, $hXWLE.IconType).PriorityUndefined]: (0, $6D8aU.messages).priority_undefined
};
const $438d0824fb7af3fd$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $438d0824fb7af3fd$var$messageMapper[icon];
        if (descriptor) return (0, $jvuTK.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $438d0824fb7af3fd$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return (0, $byn9U.jsx)((0, $h2L5X.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $438d0824fb7af3fd$var$renderImageIcon = (url, testId)=>{
    if (url) return (0, $byn9U.jsx)((0, $3GGUk.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $438d0824fb7af3fd$var$Badge = ({ icon: icon, label: label, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $438d0824fb7af3fd$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $438d0824fb7af3fd$var$renderAtlaskitIcon(icon, testId) || $438d0824fb7af3fd$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return (0, $byn9U.jsx)("span", {
        css: [
            $438d0824fb7af3fd$var$badgeStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId
    }, (0, $byn9U.jsx)("span", {
        css: $438d0824fb7af3fd$var$iconStyles
    }, badgeIcon), (0, $byn9U.jsx)("span", {
        css: $438d0824fb7af3fd$var$labelStyles,
        "data-testid": `${testId}-label`
    }, formattedMessageOrLabel));
};
var $438d0824fb7af3fd$export$2e2bcd8739ae039 = $438d0824fb7af3fd$var$Badge;

});

parcelRegister("zEmch", function(module, exports) {

$parcel$export(module.exports, "default", () => $06b2930fd06f5496$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4XQdE = parcelRequire("4XQdE");

var $hXWLE = parcelRequire("hXWLE");

var $6D8aU = parcelRequire("6D8aU");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jvuTK = parcelRequire("jvuTK");
const $06b2930fd06f5496$var$MAX_COUNT = 4;
const $06b2930fd06f5496$var$getStyles = (size)=>{
    const styles = (0, $byn9U.css)({
        display: 'inline-flex',
        ul: {
            marginRight: "var(--ds-space-100, 0.5rem)",
            marginTop: 0
        }
    });
    switch(size){
        case (0, $hXWLE.SmartLinkSize).XLarge:
        case (0, $hXWLE.SmartLinkSize).Large:
            // Default AK small size
            return styles;
        case (0, $hXWLE.SmartLinkSize).Medium:
        case (0, $hXWLE.SmartLinkSize).Small:
        default:
            // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
            return (0, $byn9U.css)`
        ${styles}
        li {
          span,
          svg {
            max-height: 1.25rem;
            max-width: 1.25rem;
          }
        }
      `;
    }
};
const $06b2930fd06f5496$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $hXWLE.ElementName).AssignedToGroup:
            return (0, $jvuTK.getFormattedMessageAsString)(intl, (0, $6D8aU.messages).assigned_to, personName);
        case (0, $hXWLE.ElementName).OwnedByGroup:
            return (0, $jvuTK.getFormattedMessageAsString)(intl, (0, $6D8aU.messages).owned_by, personName);
        case (0, $hXWLE.ElementName).AuthorGroup:
            return (0, $jvuTK.getFormattedMessageAsString)(intl, (0, $6D8aU.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {AvatarGroupProps} AvatarGroupProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $06b2930fd06f5496$var$AvatarGroup = ({ items: items = [], maxCount: maxCount = $06b2930fd06f5496$var$MAX_COUNT, name: name, overrideCss: overrideCss, size: size = (0, $hXWLE.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $5JgJ2.default)();
    const data = (0, $eUqFw.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $hXWLE.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $jvuTK.getFormattedMessageAsString)(intl, (0, $6D8aU.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $06b2930fd06f5496$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return (0, $byn9U.jsx)("span", {
        css: [
            $06b2930fd06f5496$var$getStyles(size),
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId
    }, (0, $byn9U.jsx)((0, $4XQdE.default), {
        maxCount: maxCount,
        appearance: "stack",
        size: "small",
        data: data,
        testId: testId
    }));
};
var $06b2930fd06f5496$export$2e2bcd8739ae039 = $06b2930fd06f5496$var$AvatarGroup;

});
parcelRegister("4XQdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6346b768779c72$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $iJlfe = parcelRequire("iJlfe");


var $5Q9wj = parcelRequire("5Q9wj");

var $7PTrT = parcelRequire("7PTrT");

var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $hCcWD = parcelRequire("hCcWD");

var $3Czko = parcelRequire("3Czko");

var $6cUPN = parcelRequire("6cUPN");

var $h5NqH = parcelRequire("h5NqH");

var $5TioN = parcelRequire("5TioN");

var $33ZPs = parcelRequire("33ZPs");

var $bLnyK = parcelRequire("bLnyK");
const $3b6346b768779c72$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $3b6346b768779c72$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $3b6346b768779c72$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $iJlfe.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $5Q9wj.default;
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5TioN.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $lcnyw.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6cUPN.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $h5NqH.default), {
                    onClick: (e)=>e.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8BKky.default), null, data.slice(max).map((avatar, index)=>$3b6346b768779c72$var$getOverrides(overrides).AvatarGroupItem.render((0, $hCcWD.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $3b6346b768779c72$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $33ZPs.default) : (0, $3Czko.default);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
        const callback = avatarData.onClick || onAvatarClick;
        const finalAvatar = $3b6346b768779c72$var$getOverrides(overrides).Avatar.render(avatar, {
            ...avatarData,
            size: size,
            borderColor: borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event, analyticsEvent)=>{
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }, idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
            key: (0, $bLnyK.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $3b6346b768779c72$export$2e2bcd8739ae039 = $3b6346b768779c72$var$AvatarGroup;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("hCcWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ec5414b121adc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");
var $e7PSD = parcelRequire("e7PSD");
var $bo4OB = parcelRequire("bo4OB");

var $jXJS5 = parcelRequire("jXJS5");
const $19ec5414b121adc7$var$AvatarGroupItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { avatar: avatar, onAvatarClick: onAvatarClick, testId: testId, index: index } = props;
    const { href: href, onClick: onClick, ...rest } = avatar;
    const itemRef = (0, $jXJS5.default)();
    const CustomComponent = ({ children: children, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            type: "button",
            ...props
        }, children));
    };
    const AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...rest,
        testId: testId && `${testId}--avatar`,
        borderColor: "transparent",
        size: "small",
        name: ""
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, avatar.name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19ec5414b121adc7$export$2e2bcd8739ae039 = $19ec5414b121adc7$var$AvatarGroupItem;

});
parcelRegister("jXJS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a822a3bf76dc75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6cUPN = parcelRequire("6cUPN");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $47a822a3bf76dc75$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $47a822a3bf76dc75$export$2e2bcd8739ae039 = $47a822a3bf76dc75$var$useRegisterItemWithFocusManager;

});
parcelRegister("6cUPN", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $c9e49b704731182e$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $c9e49b704731182e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $HPlWp = parcelRequire("HPlWp");
const $c9e49b704731182e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic
 */ const $c9e49b704731182e$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eUqFw.useEffect)(()=>{
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $HPlWp.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $HPlWp.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e49b704731182e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $c9e49b704731182e$export$2e2bcd8739ae039 = $c9e49b704731182e$var$FocusManager;

});
parcelRegister("HPlWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2eeb0b24006473e$export$2e2bcd8739ae039);

const $b2eeb0b24006473e$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $b2eeb0b24006473e$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $b2eeb0b24006473e$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement && nextFocusableElement.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement && prevFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("3Czko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f319fa8ea8cddd21$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $f319fa8ea8cddd21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f319fa8ea8cddd21$var$gutter = "var(--ds-space-negative-050, -4px)";
const $f319fa8ea8cddd21$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: 'none !important',
    marginInlineEnd: $f319fa8ea8cddd21$var$gutter,
    marginInlineStart: $f319fa8ea8cddd21$var$gutter
});
const $f319fa8ea8cddd21$var$listItemStyles = {
    name: "3unxte",
    styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
};
const $f319fa8ea8cddd21$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $f319fa8ea8cddd21$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $f319fa8ea8cddd21$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f319fa8ea8cddd21$export$2e2bcd8739ae039 = $f319fa8ea8cddd21$var$Grid;

});

parcelRegister("h5NqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffca550571fe4d8$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $6cUPN = parcelRequire("6cUPN");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $4ffca550571fe4d8$var$PopupAvatarGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, setInitialFocusRef: setInitialFocusRef, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    (0, $eUqFw.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    }));
};
var $4ffca550571fe4d8$export$2e2bcd8739ae039 = $4ffca550571fe4d8$var$PopupAvatarGroup;

});

parcelRegister("5TioN", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bc7348cf05a7b7$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");

var $PdmhA = parcelRequire("PdmhA");
const $80bc7348cf05a7b7$var$FONT_SIZE = {
    xsmall: '0.625rem',
    // 10px
    small: '0.625rem',
    // 10px
    medium: '0.6875rem',
    // 11px
    large: '0.75rem',
    // 12px
    xlarge: '1rem',
    // 16px
    xxlarge: '1rem' // 16px
};
const $80bc7348cf05a7b7$var$buttonActiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-selected, ${(0, $PdmhA.B50)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 ${(0, $eri7S.BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $PdmhA.B300)})`}`,
        color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `scale(${(0, $eri7S.ACTIVE_SCALE_FACTOR)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $PdmhA.N30)})`,
            color: `var(--ds-text-selected, ${(0, $PdmhA.N500)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $PdmhA.B50)})`,
            color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`
        }
    }
});
const $80bc7348cf05a7b7$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA.N20)})`,
        color: `var(--ds-text, ${(0, $PdmhA.N500)})`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $PdmhA.N30)})`,
            color: `var(--ds-text, ${(0, $PdmhA.N500)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $PdmhA.B50)})`,
            color: `var(--ds-text, ${(0, $PdmhA.B400)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:after': {
            display: 'none'
        }
    }
});
const $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT = 99;
const $80bc7348cf05a7b7$var$MoreIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = `var(--ds-border-inverse, ${0, $PdmhA.N0})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iJlfe.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, ({ testId: _, className: className, ref: ref, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("button", {
            type: "submit",
            ...buttonProps,
            ...props,
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                fontSize: $80bc7348cf05a7b7$var$FONT_SIZE[size]
            },
            css: [
                $80bc7348cf05a7b7$var$buttonStyles,
                isActive && $80bc7348cf05a7b7$var$buttonActiveStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, "+", count > $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT ? $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT : count));
});
$80bc7348cf05a7b7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80bc7348cf05a7b7$export$2e2bcd8739ae039 = $80bc7348cf05a7b7$var$MoreIndicator;

});

parcelRegister("33ZPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e31b31f1a588aba$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $lcnyw = parcelRequire("lcnyw");
const $9e31b31f1a588aba$var$gutter = (0, $eri7S.BORDER_WIDTH) * 2 + (0, $lcnyw.gridSize)() / 2;
const $9e31b31f1a588aba$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$listItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $9e31b31f1a588aba$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $9e31b31f1a588aba$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e31b31f1a588aba$export$2e2bcd8739ae039 = $9e31b31f1a588aba$var$Stack;

});

parcelRegister("bLnyK", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $009108df95df64ca$export$b067756944994c79);
const $009108df95df64ca$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});



parcelRegister("9cgKu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b223a071dee35a0$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $3GGUk = parcelRequire("3GGUk");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $6b223a071dee35a0$var$styles = (0, $byn9U.css)({
    aspectRatio: '16 / 9',
    display: 'flex',
    width: '100%',
    height: 'fit-content',
    '@supports not (aspect-ratio: auto)': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space -- needs manual remediation
        paddingTop: '56.25%',
        // 16:9 ratio (9 / 16 = 0.5625)
        height: 0,
        position: 'relative',
        overflow: 'hidden'
    },
    '> img, > span': {
        minHeight: '100%',
        minWidth: '100%',
        maxHeight: '100%',
        maxWidth: '100%',
        objectFit: 'cover',
        objectPosition: 'center center',
        '@supports not (aspect-ratio: auto)': {
            position: 'absolute',
            transform: 'translate(-50%, -50%)',
            left: '50%',
            top: '50%',
            width: 'auto',
            height: 'auto'
        }
    }
});
/**
 * A base element that displays a Media.
 * @internal
 * @param {MediaProps} MediaProps - The props necessary for the Media element.
 * @see Preview
 */ const $6b223a071dee35a0$var$Media = ({ name: name, overrideCss: overrideCss, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return (0, $byn9U.jsx)("div", {
        css: [
            $6b223a071dee35a0$var$styles,
            overrideCss
        ],
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId
    }, (0, $byn9U.jsx)((0, $3GGUk.default), {
        testId: `${testId}-image`,
        url: url,
        onError: onError,
        onLoad: onLoad,
        defaultIcon: null
    }));
};
var $6b223a071dee35a0$export$2e2bcd8739ae039 = $6b223a071dee35a0$var$Media;

});

parcelRegister("5MKJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4365b10f7173972d$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jvuTK = parcelRequire("jvuTK");
const $4365b10f7173972d$var$getStyles = (maxLines)=>(0, $byn9U.css)({
        color: "var(--ds-text-subtlest, #626F86)",
        fontSize: '0.75rem',
        lineHeight: '1rem',
        whiteSpace: 'normal'
    }, (0, $jvuTK.getTruncateStyles)(maxLines));
/**
 * A base element that displays some Text.
 * @internal
 * @param {TextProps} TextProps - The props necessary for the Text element.
 * @see Title
 */ const $4365b10f7173972d$var$Text = ({ content: content, maxLines: maxLines = 1, message: message, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-text' })=>{
    if (!message && !content) return null;
    return (0, $byn9U.jsx)("span", {
        css: [
            $4365b10f7173972d$var$getStyles(maxLines),
            overrideCss
        ],
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId
    }, (0, $jvuTK.getFormattedMessage)(message) || content);
};
var $4365b10f7173972d$export$2e2bcd8739ae039 = $4365b10f7173972d$var$Text;

});

parcelRegister("aMfel", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d8a337caa49da8e$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");
parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $byn9U = parcelRequire("byn9U");

var $jvuTK = parcelRequire("jvuTK");

var $9KU0P = parcelRequire("9KU0P");

var $6D8aU = parcelRequire("6D8aU");
const $7d8a337caa49da8e$var$styles = (0, $byn9U.css)({
    color: "var(--ds-text-subtlest, #626F86)",
    fontSize: '0.75rem',
    lineHeight: '1rem'
}, (0, $jvuTK.getTruncateStyles)(1));
const $7d8a337caa49da8e$var$typeToDescriptorMap = {
    created: {
        relative: (0, $6D8aU.messages).created_on_relative,
        absolute: (0, $6D8aU.messages).created_on_absolute
    },
    modified: {
        relative: (0, $6D8aU.messages).modified_on_relative,
        absolute: (0, $6D8aU.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $6D8aU.messages).sent_on_relative,
        absolute: (0, $6D8aU.messages).sent_on_absolute
    }
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {DateTimeProps} DateTimeProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $7d8a337caa49da8e$var$DateTime = ({ date: date, name: name, overrideCss: overrideCss, type: type, testId: testId = 'smart-element-date-time', text: text })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $5JgJ2.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $9KU0P.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    return (0, $byn9U.jsx)("span", {
        css: [
            $7d8a337caa49da8e$var$styles,
            overrideCss
        ],
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId
    }, text ? `${text} ${context}` : (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $kU09D.default)({}, $7d8a337caa49da8e$var$typeToDescriptorMap[type][typeVariant], {
        values: {
            context: context
        }
    })));
};
var $7d8a337caa49da8e$export$2e2bcd8739ae039 = $7d8a337caa49da8e$var$DateTime;

});

parcelRegister("jrTjF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e28b72962aceeda0$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $9nkwJ = parcelRequire("9nkwJ");

var $byn9U = parcelRequire("byn9U");
const $e28b72962aceeda0$var$badgeStyles = (0, $byn9U.css)({
    alignItems: 'center',
    display: 'inline-flex'
});
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $e28b72962aceeda0$var$AtlaskitBadge = ({ value: value, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return (0, $byn9U.jsx)("span", {
        css: [
            $e28b72962aceeda0$var$badgeStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId
    }, (0, $byn9U.jsx)((0, $9nkwJ.default), null, value));
};
var $e28b72962aceeda0$export$2e2bcd8739ae039 = $e28b72962aceeda0$var$AtlaskitBadge;

});


parcelRegister("lT9NU", function(module, exports) {

$parcel$export(module.exports, "default", () => $fef656deade94b44$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $l8O8E = parcelRequire("l8O8E");

var $hXWLE = parcelRequire("hXWLE");

var $9cgKu = parcelRequire("9cgKu");
const $fef656deade94b44$var$Preview = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props !== null && props !== void 0 ? props : {};
    const context = (0, $eUqFw.useContext)((0, $l8O8E.FlexibleUiContext));
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $hXWLE.MediaType).Image
    } : context === null || context === void 0 ? void 0 : context.preview;
    if (!data) return null;
    return (0, $byn9U.jsx)((0, $9cgKu.default), (0, $kU09D.default)({}, rest, data));
};
var $fef656deade94b44$export$2e2bcd8739ae039 = $fef656deade94b44$var$Preview;

});

parcelRegister("b2LxU", function(module, exports) {

$parcel$export(module.exports, "default", () => $80a4c34471efa523$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $l8O8E = parcelRequire("l8O8E");

var $5MKJX = parcelRequire("5MKJX");
const $80a4c34471efa523$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $80a4c34471efa523$var$getSnippetStyles = (overrideCss)=>(0, $byn9U.css)({
        color: "var(--ds-text, #172B4D)",
        WebkitUserSelect: 'text',
        MozUserSelect: 'text',
        MsUserSelect: 'text',
        userSelect: 'text'
    }, overrideCss);
const $80a4c34471efa523$var$SnippetElement = ({ content: overrideContent, maxLines: maxLines = $80a4c34471efa523$var$SNIPPET_DEFAULT_MAX_LINES, overrideCss: overrideCss, ...props } = {})=>{
    const context = (0, $eUqFw.useContext)((0, $l8O8E.FlexibleUiContext));
    return (0, $byn9U.jsx)((0, $5MKJX.default), (0, $kU09D.default)({
        content: overrideContent !== null && overrideContent !== void 0 ? overrideContent : context === null || context === void 0 ? void 0 : context.snippet,
        maxLines: maxLines,
        overrideCss: $80a4c34471efa523$var$getSnippetStyles(overrideCss)
    }, props));
};
var $80a4c34471efa523$export$2e2bcd8739ae039 = $80a4c34471efa523$var$SnippetElement;

});


parcelRegister("iw7Qh", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $d7b14c7420742b57$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $d7b14c7420742b57$export$df0092b19156b140);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $d7b14c7420742b57$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $d7b14c7420742b57$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $d7b14c7420742b57$export$c0547b4405cae584);

var $eUqFw = parcelRequire("eUqFw");

var $cceVY = parcelRequire("cceVY");
var $1EbMw = parcelRequire("1EbMw");
var $iIBcb = parcelRequire("iIBcb");
var $ieckM = parcelRequire("ieckM");

var $4fZpw = parcelRequire("4fZpw");
const $d7b14c7420742b57$export$3c94e0f4719f5c2a = (children)=>{
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).some((child)=>$d7b14c7420742b57$export$df0092b19156b140(child))) return true;
    return false;
};
const $d7b14c7420742b57$export$b56fc89cf6e7d1e9 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && Object.values($cceVY).some((type)=>type === node.type);
const $d7b14c7420742b57$export$d7fc505bb0bd5756 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && Object.values($4fZpw).some((type)=>type === node.type);
const $d7b14c7420742b57$export$df0092b19156b140 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $1EbMw.default);
const $d7b14c7420742b57$export$c0547b4405cae584 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $iIBcb.default);
const $d7b14c7420742b57$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $ieckM.default);

});
parcelRegister("cceVY", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("ieckM")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("8W7kC")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("iIBcb")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("kkrAF")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("1EbMw")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("kIvR9")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("eIjph")).default);
$parcel$export(module.exports, "RelatedUrlsBlock", () => (parcelRequire("6qazR")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("5nprK")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("fvKlq")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("hHZ9y")).default);

var $ieckM = parcelRequire("ieckM");

var $8W7kC = parcelRequire("8W7kC");

var $iIBcb = parcelRequire("iIBcb");

var $kkrAF = parcelRequire("kkrAF");

var $1EbMw = parcelRequire("1EbMw");

var $kIvR9 = parcelRequire("kIvR9");

var $eIjph = parcelRequire("eIjph");

var $6qazR = parcelRequire("6qazR");

var $5nprK = parcelRequire("5nprK");

var $fvKlq = parcelRequire("fvKlq");

var $hHZ9y = parcelRequire("hHZ9y");

});
parcelRegister("ieckM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4531a15eb8d29a5$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $eIjph = parcelRequire("eIjph");

var $hXWLE = parcelRequire("hXWLE");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $d4531a15eb8d29a5$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', ...props })=>{
    if (status !== (0, $hXWLE.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eIjph.default), (0, $kU09D.default)({}, props, {
        testId: testId
    }));
};
var $d4531a15eb8d29a5$export$2e2bcd8739ae039 = $d4531a15eb8d29a5$var$FooterBlock;

});
parcelRegister("eIjph", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab643a812b48c43a$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $hXWLE = parcelRequire("hXWLE");

var $l8O8E = parcelRequire("l8O8E");

var $4fZpw = parcelRequire("4fZpw");

var $ezIO6 = parcelRequire("ezIO6");

var $kIvR9 = parcelRequire("kIvR9");

var $9SkfS = parcelRequire("9SkfS");

var $aHboL = parcelRequire("aHboL");
const $ab643a812b48c43a$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $hXWLE.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $l8O8E.useFlexibleUiContext)();
    const hasActions = (0, $eUqFw.useMemo)(()=>{
        var _filterActionItems;
        return ((_filterActionItems = (0, $aHboL.filterActionItems)(actions, context)) === null || _filterActionItems === void 0 ? void 0 : _filterActionItems.length) > 0;
    }, [
        actions,
        context
    ]);
    const onDropdownOpenChange = (0, $eUqFw.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIvR9.default), (0, $kU09D.default)({}, props, {
        testId: `${testId}-resolved-view`
    }), !hideProvider && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4fZpw.Provider), {
        testId: `${testId}-provider`
    }), actions && hasActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9SkfS.default), {
        testId: "smart-element-group-actions",
        align: (0, $hXWLE.SmartLinkAlignment).Right,
        direction: (0, $hXWLE.SmartLinkDirection).Horizontal,
        overrideCss: (0, $aHboL.getActionGroupStyles)(size),
        width: (0, $hXWLE.SmartLinkWidth).Flexible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ezIO6.default), {
        onDropdownOpenChange: onDropdownOpenChange,
        items: actions,
        appearance: "default"
    })) : null);
};
var $ab643a812b48c43a$export$2e2bcd8739ae039 = $ab643a812b48c43a$var$FooterBlockResolvedView;

});
parcelRegister("kIvR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f150a0b66772b7f2$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hXWLE = parcelRequire("hXWLE");

var $aHboL = parcelRequire("aHboL");
const $f150a0b66772b7f2$var$getBlockStyles = (direction, size)=>(0, $byn9U.css)`
  ${(0, $aHboL.getBaseStyles)(direction, size)}
  ${0, $aHboL.highlightRemoveStyles}
  justify-content: flex-start;
  [data-separator] + [data-separator]:before {
    content: '•';
    margin-right: ${(0, $aHboL.getGapSize)(size)}rem;
  }
  // Pull request elements: source branch → target branch
  [data-smart-element='${(0, $hXWLE.ElementName).SourceBranch}']
    + [data-smart-element='${(0, $hXWLE.ElementName).TargetBranch}']:before {
    content: '→';
  }
  // Pull request elements: target branch ← source branch
  [data-smart-element='${(0, $hXWLE.ElementName).TargetBranch}']
    + [data-smart-element='${(0, $hXWLE.ElementName).SourceBranch}']:before {
    content: '←';
  }
`;
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $f150a0b66772b7f2$var$Block = ({ children: children, direction: direction = (0, $hXWLE.SmartLinkDirection).Horizontal, size: size = (0, $hXWLE.SmartLinkSize).Medium, testId: testId = 'smart-block', overrideCss: overrideCss, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd })=>{
    (0, $eUqFw.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return (0, $byn9U.jsx)("div", {
        css: [
            $f150a0b66772b7f2$var$getBlockStyles(direction, size),
            overrideCss
        ],
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef
    }, (0, $aHboL.renderChildren)(children, size));
};
var $f150a0b66772b7f2$export$2e2bcd8739ae039 = $f150a0b66772b7f2$var$Block;

});

parcelRegister("9SkfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7308de7483a64179$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $hXWLE = parcelRequire("hXWLE");

var $aHboL = parcelRequire("aHboL");

var $jvuTK = parcelRequire("jvuTK");
const $7308de7483a64179$var$getAlignmentStyles = (align)=>{
    switch(align){
        case (0, $hXWLE.SmartLinkAlignment).Right:
            return (0, $byn9U.css)({
                WebkitBoxAlign: 'end',
                MsFlexAlign: 'end',
                justifyContent: 'flex-end',
                textAlign: 'right'
            });
        case (0, $hXWLE.SmartLinkAlignment).Left:
        default:
            return (0, $byn9U.css)({
                WebkitBoxAlign: 'start',
                MsFlexAlign: 'start',
                justifyContent: 'flex-start',
                textAlign: 'left'
            });
    }
};
const $7308de7483a64179$var$getGapStyles = (size, align)=>{
    const gap = (0, $aHboL.getGapSize)(size);
    if (align === (0, $hXWLE.SmartLinkAlignment).Right) return (0, $byn9U.css)({
        '> span': {
            marginLeft: `${gap}rem`
        },
        '> span:first-child': {
            marginLeft: 'initial'
        }
    });
    return (0, $byn9U.css)({
        '> span': {
            marginRight: `${gap}rem`,
            '&:last-child': {
                marginRight: 'initial'
            }
        }
    });
};
const $7308de7483a64179$var$getHorizontalDirectionStyles = (size, align)=>{
    const lineHeight = (0, $jvuTK.getMaxLineHeight)(size);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return (0, $byn9U.css)`
    display: block;
    vertical-align: middle;
    ${(0, $jvuTK.getTruncateStyles)(1, lineHeight + 'rem')}

    > span, > div {
      vertical-align: middle;

      &[data-smart-element-date-time],
      &[data-smart-element-text] {
        // Show all/wrapped/truncated
        display: inline;
      }
    }

    ${$7308de7483a64179$var$getGapStyles(size, align)}
  `;
};
const $7308de7483a64179$export$91d118d179d992a4 = (direction, size, align, width, position)=>(0, $byn9U.css)((0, $aHboL.getBaseStyles)(direction, size), $7308de7483a64179$var$getAlignmentStyles(align), {
        minWidth: '10%'
    }, width === (0, $hXWLE.SmartLinkWidth).Flexible ? `flex: 1 3;` : '', direction === (0, $hXWLE.SmartLinkDirection).Horizontal ? $7308de7483a64179$var$getHorizontalDirectionStyles(size, align) : '', position === (0, $hXWLE.SmartLinkPosition).Top ? 'align-self: flex-start;' : '');
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $7308de7483a64179$var$ElementGroup = ({ align: align = (0, $hXWLE.SmartLinkAlignment).Left, children: children, overrideCss: overrideCss, direction: direction = (0, $hXWLE.SmartLinkDirection).Horizontal, size: size = (0, $hXWLE.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $hXWLE.SmartLinkWidth).FitToContent, position: position = (0, $hXWLE.SmartLinkPosition).Center })=>(0, $byn9U.jsx)("div", {
        css: [
            $7308de7483a64179$export$91d118d179d992a4(direction, size, align, width, position),
            overrideCss
        ],
        "data-smart-element-group": true,
        "data-testid": testId
    }, (0, $aHboL.renderChildren)(children, size));
var $7308de7483a64179$export$2e2bcd8739ae039 = $7308de7483a64179$var$ElementGroup;

});



parcelRegister("8W7kC", function(module, exports) {

$parcel$export(module.exports, "default", () => $68196d6586ccb6ba$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hXWLE = parcelRequire("hXWLE");

var $aHboL = parcelRequire("aHboL");

var $kIvR9 = parcelRequire("kIvR9");

var $9SkfS = parcelRequire("9SkfS");

var $jvuTK = parcelRequire("jvuTK");
const $68196d6586ccb6ba$var$DEFAULT_MAX_LINES = 2;
const $68196d6586ccb6ba$var$MAXIMUM_MAX_LINES = 2;
const $68196d6586ccb6ba$var$MINIMUM_MAX_LINES = 1;
const $68196d6586ccb6ba$var$getElementGroupStyles = (size, maxLines)=>{
    // MetadataBlock allows metadata elements to be displayed in
    // multiple lines, with maximum of 2 lines.
    // We need the height of the line to be equal on both left and right
    // sides so they line up nicely.
    const lineHeight = (0, $jvuTK.getMaxLineHeight)(size);
    return (0, $byn9U.css)({
        lineHeight: `${lineHeight}rem`
    }, (0, $jvuTK.getTruncateStyles)(maxLines, lineHeight + 'rem'));
};
const $68196d6586ccb6ba$var$getMaxLines = (maxLines)=>{
    if (maxLines > $68196d6586ccb6ba$var$MAXIMUM_MAX_LINES) return $68196d6586ccb6ba$var$DEFAULT_MAX_LINES;
    if (maxLines < $68196d6586ccb6ba$var$MINIMUM_MAX_LINES) return $68196d6586ccb6ba$var$MINIMUM_MAX_LINES;
    return maxLines;
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $68196d6586ccb6ba$var$MetadataBlock = ({ maxLines: maxLines = $68196d6586ccb6ba$var$DEFAULT_MAX_LINES, status: status = (0, $hXWLE.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    if (primary.length === 0 && secondary.length === 0 || status !== (0, $hXWLE.SmartLinkStatus).Resolved) return null;
    const primaryElements = (0, $aHboL.renderElementItems)(primary);
    const secondaryElements = (0, $aHboL.renderElementItems)(secondary);
    const { size: size = (0, $hXWLE.SmartLinkSize).Medium } = blockProps;
    const elementGroupStyles = $68196d6586ccb6ba$var$getElementGroupStyles(size, $68196d6586ccb6ba$var$getMaxLines(maxLines));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIvR9.default), (0, $kU09D.default)({}, blockProps, {
        testId: `${testId}-resolved-view`
    }), primaryElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9SkfS.default), {
        align: (0, $hXWLE.SmartLinkAlignment).Left,
        overrideCss: elementGroupStyles,
        direction: (0, $hXWLE.SmartLinkDirection).Horizontal,
        width: (0, $hXWLE.SmartLinkWidth).Flexible
    }, primaryElements), secondaryElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9SkfS.default), {
        align: (0, $hXWLE.SmartLinkAlignment).Right,
        overrideCss: elementGroupStyles,
        direction: (0, $hXWLE.SmartLinkDirection).Horizontal,
        width: (0, $hXWLE.SmartLinkWidth).Flexible
    }, secondaryElements));
};
var $68196d6586ccb6ba$export$2e2bcd8739ae039 = $68196d6586ccb6ba$var$MetadataBlock;

});

parcelRegister("iIBcb", function(module, exports) {

$parcel$export(module.exports, "default", () => $da09304965c684fd$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");
parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hXWLE = parcelRequire("hXWLE");

var $1tOXH = parcelRequire("1tOXH");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $da09304965c684fd$var$PreviewBlock = ({ status: status = (0, $hXWLE.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    return (0, $byn9U.jsx)((0, $1tOXH.default), (0, $kU09D.default)({}, blockProps, {
        testId: testId,
        overrideUrl: overrideUrl
    }));
};
var $da09304965c684fd$export$2e2bcd8739ae039 = $da09304965c684fd$var$PreviewBlock;

});
parcelRegister("1tOXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $114007d84acfe4c7$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hXWLE = parcelRequire("hXWLE");

var $kIvR9 = parcelRequire("kIvR9");

var $lT9NU = parcelRequire("lT9NU");
/**
 * Due to its placement on the left/right and ignoreContainerPadding prop
 * rely on its parent container styling, css variables are declared in
 * <Container /> to preset the base values for the preview block styling.
 *
 * `--container-padding` is the padding of the Container. This value is based
 *   on size and hidePadding.
 * `--container-gap-left` and `--container-gap-right` are the gap or padding of
 *   the Container depending on whether the container has other preview blocks
 *   with left/right positioning.
 * `--preview-block-width` is the size of the preview image in relation to
 *   the Container width when the placement is left/right.
 * @param placement
 * @param ignoreContainerPadding
 */ const $114007d84acfe4c7$var$getPreviewBlockStyles = (placement, ignoreContainerPadding)=>{
    if (placement === (0, $hXWLE.MediaPlacement).Left || placement === (0, $hXWLE.MediaPlacement).Right) {
        const containerPadding = ignoreContainerPadding ? '0rem' : 'var(--container-padding)';
        // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return (0, $byn9U.css)`
      position: absolute;
      top: ${containerPadding};
      bottom: ${containerPadding};
      width: calc(var(--preview-block-width) - ${containerPadding});

      ${placement === (0, $hXWLE.MediaPlacement).Left ? `left: ${containerPadding};` : ''}
      ${placement === (0, $hXWLE.MediaPlacement).Right ? `right: ${containerPadding};` : ''}

      [data-smart-element-media='image'] {
        aspect-ratio: unset;
        padding-top: unset;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    `;
    }
    if (ignoreContainerPadding) return (0, $byn9U.css)({
        marginLeft: 'calc(var(--container-gap-left) * -1)',
        marginRight: 'calc(var(--container-gap-right) * -1)',
        '&:first-of-type': {
            marginTop: 'calc(var(--container-padding) * -1)'
        },
        '&:last-of-type': {
            marginBottom: 'calc(var(--container-padding) * -1)'
        }
    });
};
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $114007d84acfe4c7$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, overrideCss: overrideCss, placement: placement, testId: testId, overrideUrl: overrideUrl, ...blockProps })=>{
    const [styles, setStyles] = (0, $eUqFw.useState)(overrideCss);
    const updateStyles = (0, $eUqFw.useCallback)(()=>{
        setStyles((0, $byn9U.css)($114007d84acfe4c7$var$getPreviewBlockStyles(placement, ignoreContainerPadding), overrideCss));
    }, [
        ignoreContainerPadding,
        overrideCss,
        placement
    ]);
    (0, $eUqFw.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        overrideCss,
        placement,
        updateStyles
    ]);
    const handleOnLoad = (0, $eUqFw.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $eUqFw.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return (0, $byn9U.jsx)((0, $kIvR9.default), (0, $kU09D.default)({}, blockProps, {
        overrideCss: styles,
        testId: `${testId}-resolved-view`
    }), (0, $byn9U.jsx)((0, $lT9NU.default), {
        onError: handleOnError,
        onLoad: handleOnLoad,
        overrideUrl: overrideUrl
    }));
};
var $114007d84acfe4c7$export$2e2bcd8739ae039 = $114007d84acfe4c7$var$PreviewBlockResolvedView;

});


parcelRegister("kkrAF", function(module, exports) {

$parcel$export(module.exports, "default", () => $eccb13c4bb04de37$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $kIvR9 = parcelRequire("kIvR9");

var $hXWLE = parcelRequire("hXWLE");

var $b2LxU = parcelRequire("b2LxU");

var $jvuTK = parcelRequire("jvuTK");
const $eccb13c4bb04de37$var$DEFAULT_MAX_LINES = 3;
const $eccb13c4bb04de37$var$MAXIMUM_MAX_LINES = 6;
const $eccb13c4bb04de37$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlock} SnippetBlock
 * @see Block
 */ const $eccb13c4bb04de37$var$SnippetBlock = ({ maxLines: maxLines = $eccb13c4bb04de37$var$DEFAULT_MAX_LINES, status: status = (0, $hXWLE.SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, ...blockProps })=>{
    if (status !== (0, $hXWLE.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $jvuTK.getMaxLines)(maxLines, $eccb13c4bb04de37$var$DEFAULT_MAX_LINES, $eccb13c4bb04de37$var$MAXIMUM_MAX_LINES, $eccb13c4bb04de37$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIvR9.default), (0, $kU09D.default)({}, blockProps, {
        testId: `${testId}-${statusTestId}-view`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b2LxU.default), {
        maxLines: snippetMaxLines,
        content: text
    }));
};
var $eccb13c4bb04de37$export$2e2bcd8739ae039 = $eccb13c4bb04de37$var$SnippetBlock;

});

parcelRegister("1EbMw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1332aa79e74ac7ba$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hnYQo = parcelRequire("hnYQo");

var $hXWLE = parcelRequire("hXWLE");

var $bY4Zj = parcelRequire("bY4Zj");

var $e69sa = parcelRequire("e69sa");

var $7DAXi = parcelRequire("7DAXi");

var $ezIO6 = parcelRequire("ezIO6");

var $4fZpw = parcelRequire("4fZpw");
const $1332aa79e74ac7ba$var$getActionStyles = (showOnHover, isOpen)=>{
    if (showOnHover && !isOpen) return (0, $byn9U.css)({
        '.actions-button-group': {
            opacity: 0
        },
        '&:hover .actions-button-group, .actions-button-group:focus-within': {
            opacity: 1
        }
    });
};
const $1332aa79e74ac7ba$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $hXWLE.SmartLinkStatus).Pending:
        case (0, $hXWLE.SmartLinkStatus).Resolving:
            return 0, $7DAXi.default;
        case (0, $hXWLE.SmartLinkStatus).Resolved:
            return 0, $bY4Zj.default;
        case (0, $hXWLE.SmartLinkStatus).Unauthorized:
        case (0, $hXWLE.SmartLinkStatus).Forbidden:
        case (0, $hXWLE.SmartLinkStatus).NotFound:
        case (0, $hXWLE.SmartLinkStatus).Errored:
        case (0, $hXWLE.SmartLinkStatus).Fallback:
        default:
            return 0, $e69sa.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingView
 * @see TitleBlockResolvedView
 * @see TitleBlockErroredView
 */ const $1332aa79e74ac7ba$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, overrideCss: overrideCss, status: status = (0, $hXWLE.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, ...props })=>{
    if (hideRetry && props.retry) delete props.retry;
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $eUqFw.useState)(false);
    const onDropdownOpenChange = (0, $eUqFw.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ezIO6.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const actionStyles = $1332aa79e74ac7ba$var$getActionStyles(showActionOnHover, actionDropdownOpen);
    const combinedCss = (0, $byn9U.css)(actionStyles, overrideCss);
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $hnYQo.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4fZpw.Title), (0, $kU09D.default)({
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: theme
    }, overrideText));
    const Component = $1332aa79e74ac7ba$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, (0, $kU09D.default)({}, props, {
        actionGroup: actionGroup,
        overrideCss: combinedCss,
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        icon: icon
    }));
};
var $1332aa79e74ac7ba$export$2e2bcd8739ae039 = $1332aa79e74ac7ba$var$TitleBlock;

});
parcelRegister("bY4Zj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b692ad1bd826a44$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4fZpw = parcelRequire("4fZpw");

var $kIvR9 = parcelRequire("kIvR9");

var $9SkfS = parcelRequire("9SkfS");

var $hXWLE = parcelRequire("hXWLE");

var $aHboL = parcelRequire("aHboL");
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $8b692ad1bd826a44$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
    const metadataElements = (0, $aHboL.renderElementItems)(metadata);
    const subtitleElements = (0, $aHboL.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIvR9.default), (0, $kU09D.default)({}, blockProps, {
        testId: `${testId}-resolved-view`
    }), !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4fZpw.LinkIcon), {
        overrideIcon: icon,
        position: position
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9SkfS.default), {
        direction: (0, $hXWLE.SmartLinkDirection).Vertical,
        width: (0, $hXWLE.SmartLinkWidth).Flexible,
        overrideCss: (0, $byn9U.css)({
            gap: "var(--ds-space-050, 0.25rem)"
        })
    }, title, subtitleElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9SkfS.default), {
        direction: (0, $hXWLE.SmartLinkDirection).Horizontal
    }, subtitleElements)), metadataElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9SkfS.default), {
        direction: (0, $hXWLE.SmartLinkDirection).Horizontal,
        align: (0, $hXWLE.SmartLinkAlignment).Right,
        position: metadataPosition !== null && metadataPosition !== void 0 ? metadataPosition : (0, $hXWLE.SmartLinkPosition).Center
    }, metadataElements), actionGroup);
};
var $8b692ad1bd826a44$export$2e2bcd8739ae039 = $8b692ad1bd826a44$var$TitleBlockResolvedView;

});

parcelRegister("e69sa", function(module, exports) {

$parcel$export(module.exports, "default", () => $a438f571338d428f$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");
parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $byn9U = parcelRequire("byn9U");

var $4fZpw = parcelRequire("4fZpw");

var $kIvR9 = parcelRequire("kIvR9");

var $hXWLE = parcelRequire("hXWLE");

var $jvuTK = parcelRequire("jvuTK");

var $9SkfS = parcelRequire("9SkfS");
const $a438f571338d428f$var$actionStyles = (0, $byn9U.css)({
    cursor: 'pointer',
    ':hover': {
        color: "var(--ds-text-subtle, #8993A4)",
        textDecoration: 'underline'
    }
});
const $a438f571338d428f$var$getMessageStyles = (size, hasAction)=>{
    const sizeStyles = (0, $jvuTK.getLinkSizeStyles)(size);
    return (0, $byn9U.css)({
        flex: '1 1 auto',
        justifyContent: 'flex-end'
    }, hasAction ? $a438f571338d428f$var$actionStyles : '', sizeStyles, (0, $jvuTK.getTruncateStyles)(1, (0, $jvuTK.getLinkLineHeight)(size)), {
        color: "var(--ds-text-disabled, #6B778C)",
        ':focus': {
            outline: `${"var(--ds-border-focused, #388BFF)"} solid 2px`
        }
    });
};
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $a438f571338d428f$var$TitleBlockErroredView = ({ actionGroup: actionGroup, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const { size: size = (0, $hXWLE.SmartLinkSize).Medium } = blockProps;
    const hasAction = onClick !== undefined;
    return (0, $byn9U.jsx)((0, $kIvR9.default), (0, $kU09D.default)({}, blockProps, {
        testId: `${testId}-errored-view`
    }), !hideIcon && (0, $byn9U.jsx)((0, $4fZpw.LinkIcon), {
        overrideIcon: icon,
        position: position
    }), title, descriptor && (0, $byn9U.jsx)((0, $9SkfS.default), {
        direction: (0, $hXWLE.SmartLinkDirection).Horizontal,
        align: (0, $hXWLE.SmartLinkAlignment).Right
    }, (0, $byn9U.jsx)("span", {
        className: hasAction ? 'has-action' : '',
        css: $a438f571338d428f$var$getMessageStyles(size, hasAction),
        onClick: onClick,
        "data-testid": `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : -1
    }, (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $kU09D.default)({}, descriptor, {
        values: values
    })))), actionGroup);
};
var $a438f571338d428f$export$2e2bcd8739ae039 = $a438f571338d428f$var$TitleBlockErroredView;

});

parcelRegister("7DAXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f8d7848e3f9085$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");
parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $kIvR9 = parcelRequire("kIvR9");

var $hXWLE = parcelRequire("hXWLE");

var $6fjty = parcelRequire("6fjty");

var $jvuTK = parcelRequire("jvuTK");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $58f8d7848e3f9085$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $hXWLE.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $jvuTK.getIconWidth)(size);
    const iconStyles = (0, $jvuTK.getIconSizeStyles)(iconWidth);
    return (0, $byn9U.jsx)((0, $kIvR9.default), (0, $kU09D.default)({}, blockProps, {
        testId: `${testId}-resolving-view`
    }), !hideIcon && (0, $byn9U.jsx)("span", {
        css: iconStyles,
        "data-testid": `${testId}-icon`
    }, (0, $byn9U.jsx)((0, $6fjty.default), {
        testId: `${testId}-icon-loading`
    })), title, actionGroup);
};
var $58f8d7848e3f9085$export$2e2bcd8739ae039 = $58f8d7848e3f9085$var$TitleBlockResolvingView;

});


parcelRegister("6qazR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4acd6036647cbdf4$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");


var $byn9U = parcelRequire("byn9U");

var $bFzGY = parcelRequire("bFzGY");

var $2zTP9 = parcelRequire("2zTP9");

var $eHSCQ = parcelRequire("eHSCQ");

var $cqqZ0 = parcelRequire("cqqZ0");

var $b4c6W = parcelRequire("b4c6W");

var $k421q = parcelRequire("k421q");
/**
 * Represents a block to display related resources of a url
 */ const $4acd6036647cbdf4$var$RelatedUrlsBlock = ({ testId: testId = 'smart-block-related-urls', url: url, renderers: renderers, ...blockProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [loadingRelatedUrls, setLoadingRelatedUrls] = (0, $eUqFw.useState)(true);
    const [err, setErr] = (0, $eUqFw.useState)();
    const [relatedUrls, setRelatedUrls] = (0, $eUqFw.useState)();
    const getRelatedUrls = (0, $2zTP9.default)();
    (0, $eUqFw.useEffect)(()=>{
        const fetchRelatedUrls = async ()=>{
            try {
                var _relUrls$resolvedResu, _relUrls$resolvedResu2;
                const relUrls = await getRelatedUrls(url);
                setRelatedUrls(relUrls);
                /**
         * Fire TrackRelatedLinksLoadedEvent
         */ (0, $k421q.fireRelatedLinksLoadedEvent)(createAnalyticsEvent)({
                    relatedLinksCount: (_relUrls$resolvedResu = (_relUrls$resolvedResu2 = relUrls.resolvedResults) === null || _relUrls$resolvedResu2 === void 0 ? void 0 : _relUrls$resolvedResu2.length) !== null && _relUrls$resolvedResu !== void 0 ? _relUrls$resolvedResu : 0
                });
            } catch (error) {
                setErr(error);
            }
            setLoadingRelatedUrls(false);
        };
        fetchRelatedUrls();
    }, [
        createAnalyticsEvent,
        getRelatedUrls,
        url
    ]);
    if (loadingRelatedUrls) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b4c6W.RelatedUrlsBlockResolvingView), (0, $kU09D.default)({
        testId: `${testId}-resolving-view`
    }, blockProps));
    if (relatedUrls) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cqqZ0.RelatedUrlsResolvedView), (0, $kU09D.default)({
        renderers: renderers,
        overrideCss: (0, $byn9U.css)({
            minHeight: '1.55rem'
        }),
        testId: `${testId}-resolved-view`,
        relatedUrlsResponse: relatedUrls
    }, blockProps));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eHSCQ.RelatedUrlsBlockErroredView), (0, $kU09D.default)({
        err: err,
        testId: `${testId}-errored-view`
    }, blockProps));
};
var $4acd6036647cbdf4$export$2e2bcd8739ae039 = $4acd6036647cbdf4$var$RelatedUrlsBlock;

});
parcelRegister("2zTP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e0a271e387158d7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $imCrQ = parcelRequire("imCrQ");

var $gqldc = parcelRequire("gqldc");
const $1e0a271e387158d7$var$useRelatedUrls = ()=>{
    const { connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const clientExt = (0, $imCrQ.useSmartLinkClientExtension)(connections.client);
    return (0, $eUqFw.useCallback)(async (url)=>{
        return await clientExt.relatedUrls(url);
    }, [
        clientExt
    ]);
};
var $1e0a271e387158d7$export$2e2bcd8739ae039 = $1e0a271e387158d7$var$useRelatedUrls;

});

parcelRegister("eHSCQ", function(module, exports) {

$parcel$export(module.exports, "RelatedUrlsBlockErroredView", () => $ab4f74591fda42d4$export$35d9a5df27ecfbf0);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $6D8aU = parcelRequire("6D8aU");

var $5MKJX = parcelRequire("5MKJX");

var $kIvR9 = parcelRequire("kIvR9");
const $ab4f74591fda42d4$export$35d9a5df27ecfbf0 = ({ testId: testId, ...blockProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIvR9.default), (0, $kU09D.default)({}, blockProps, {
        testId: testId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5MKJX.default), {
        message: {
            descriptor: (0, $6D8aU.messages).generic_error_message
        }
    }));

});

parcelRegister("cqqZ0", function(module, exports) {

$parcel$export(module.exports, "RelatedUrlsResolvedView", () => $90bcd800e848a800$export$743935ead2c9d445);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $6D8aU = parcelRequire("6D8aU");

var $kIvR9 = parcelRequire("kIvR9");

var $7jtvO = parcelRequire("7jtvO");
const $90bcd800e848a800$export$743935ead2c9d445 = ({ relatedUrlsResponse: { resolvedResults: resolvedResults }, renderers: renderers, testId: testId, initializeOpened: initializeOpened, ...blockProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIvR9.default), (0, $kU09D.default)({}, blockProps, {
        testId: testId
    }), resolvedResults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jtvO.default), {
        testId: `${testId}-list`,
        renderers: renderers,
        initializeOpened: initializeOpened,
        title: (0, $6D8aU.messages).last_mentioned_in,
        resolvedResults: resolvedResults
    }));
};

});
parcelRegister("7jtvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $55313341150af640$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $86Ndv = parcelRequire("86Ndv");

var $5xnoX = parcelRequire("5xnoX");

var $hSQOv = parcelRequire("hSQOv");
var $6h1SY = parcelRequire("6h1SY");
var $aChL5 = parcelRequire("aChL5");
var $caLW4 = parcelRequire("caLW4");

var $byn9U = parcelRequire("byn9U");

var $6D8aU = parcelRequire("6D8aU");

var $jvuTK = parcelRequire("jvuTK");

var $5MKJX = parcelRequire("5MKJX");

var $iTzvj = parcelRequire("iTzvj");
const $55313341150af640$var$RelatedUrlList = ({ resolvedResults: resolvedResults, title: title, renderers: renderers, testId: testId, initializeOpened: initializeOpened })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(initializeOpened);
    const chevronClickHandler = (0, $eUqFw.useCallback)(()=>setIsOpen(!isOpen), [
        isOpen
    ]);
    const ChevronComponent = isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv)));
    const intl = (0, $5JgJ2.default)();
    return resolvedResults.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aChL5.default), {
        testId: testId,
        xcss: (0, $caLW4.xcss)({
            width: '100%'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), {
        onClick: chevronClickHandler,
        testId: `${testId}-expand-title`,
        as: "button",
        backgroundColor: "color.background.neutral.subtle",
        "aria-expanded": !!isOpen,
        padding: "space.0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6h1SY.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5MKJX.default), {
        overrideCss: (0, $byn9U.css)({
            fontWeight: "var(--ds-font-weight-medium, 500)"
        }),
        message: {
            descriptor: title
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChevronComponent, {
        label: (0, $jvuTK.getFormattedMessageAsString)(intl, title),
        size: 'medium'
    }))), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iTzvj.default), {
        resolvedResults: resolvedResults,
        testId: testId,
        renderers: renderers
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5MKJX.default), {
        testId: testId,
        message: {
            descriptor: (0, $6D8aU.messages).related_work_items_not_found
        }
    });
};
var $55313341150af640$export$2e2bcd8739ae039 = $55313341150af640$var$RelatedUrlList;

});
parcelRegister("iTzvj", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc18e76504e8dfb1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aChL5 = parcelRequire("aChL5");
var $caLW4 = parcelRequire("caLW4");

var $aw5Sy = parcelRequire("aw5Sy");
var $bFzGY = parcelRequire("bFzGY");

var $bCpFs = parcelRequire("bCpFs");

var $iEjlM = parcelRequire("iEjlM");
const $dc18e76504e8dfb1$var$ResolvedResultsStack = ({ resolvedResults: resolvedResults, testId: testId, renderers: renderers })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        // This event will fire each time the component is loaded
        (0, $iEjlM.fireRelatedLinksViewedEvent)(createAnalyticsEvent)({
            relatedLinksCount: resolvedResults.length
        });
    }, [
        resolvedResults.length,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aChL5.default), {
        space: "space.050",
        testId: `${testId}-items-wrapper`,
        as: "ul",
        xcss: (0, $caLW4.xcss)({
            paddingLeft: 'space.0',
            marginTop: 'space.0'
        })
    }, resolvedResults.map((resolvedResults, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iEjlM.RelatedUrlItemAnalyticsContext), {
            details: resolvedResults,
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bCpFs.default), {
            testId: `${testId}-item`,
            results: resolvedResults,
            renderers: renderers
        }))));
};
const $dc18e76504e8dfb1$var$ResolvedResultsStackWithAnalytics = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            component: 'relatedLinksSection'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dc18e76504e8dfb1$var$ResolvedResultsStack, props));
};
var $dc18e76504e8dfb1$export$2e2bcd8739ae039 = $dc18e76504e8dfb1$var$ResolvedResultsStackWithAnalytics;

});
parcelRegister("bCpFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $875727626285b4ab$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $6h1SY = parcelRequire("6h1SY");

var $bFzGY = parcelRequire("bFzGY");

var $hXWLE = parcelRequire("hXWLE");

var $gnKCv = parcelRequire("gnKCv");

var $5vSVw = parcelRequire("5vSVw");

var $daqOq = parcelRequire("daqOq");

var $kyzqi = parcelRequire("kyzqi");
const $875727626285b4ab$var$RelatedUrlItem = ({ results: results, renderers: renderers, testId: testId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const flexibleDataContext = (0, $eUqFw.useMemo)(()=>(0, $gnKCv.default)({
            response: results,
            renderers: renderers
        }), [
        renderers,
        results
    ]);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        (0, $kyzqi.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6h1SY.default), {
        alignBlock: "center",
        space: "space.050",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5vSVw.default), (0, $kU09D.default)({}, flexibleDataContext === null || flexibleDataContext === void 0 ? void 0 : flexibleDataContext.linkIcon, {
        testId: `${testId}-icon`,
        size: (0, $hXWLE.SmartLinkSize).Small
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $daqOq.default), {
        testId: `${testId}-link`,
        text: flexibleDataContext === null || flexibleDataContext === void 0 ? void 0 : flexibleDataContext.title,
        url: flexibleDataContext === null || flexibleDataContext === void 0 ? void 0 : flexibleDataContext.url,
        size: (0, $hXWLE.SmartLinkSize).Small,
        maxLines: 1,
        onClick: onClick
    }));
};
var $875727626285b4ab$export$2e2bcd8739ae039 = $875727626285b4ab$var$RelatedUrlItem;

});
parcelRegister("gnKCv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bed2f517125016e1$export$2e2bcd8739ae039);

var $eFKYn = parcelRequire("eFKYn");

var $1rRwQ = parcelRequire("1rRwQ");

var $90Km0 = parcelRequire("90Km0");

var $efLNK = parcelRequire("efLNK");

var $Xx6fX = parcelRequire("Xx6fX");

var $1qrFi = parcelRequire("1qrFi");
var $h1sO6 = parcelRequire("h1sO6");
var $dGfXu = parcelRequire("dGfXu");
var $lnW6z = parcelRequire("lnW6z");
var $c8AiI = parcelRequire("c8AiI");
var $dMa80 = parcelRequire("dMa80");
var $a4gSw = parcelRequire("a4gSw");

var $kqOma = parcelRequire("kqOma");

var $3I5bt = parcelRequire("3I5bt");

var $jeta8 = parcelRequire("jeta8");

var $7INSE = parcelRequire("7INSE");

var $7dF5i = parcelRequire("7dF5i");

var $6Qkrf = parcelRequire("6Qkrf");
const $bed2f517125016e1$var$extractFlexibleUiContext = ({ id: id, renderers: renderers, actionOptions: actionOptions, response: response, aiSummaryConfig: aiSummaryConfig } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const url = (0, $lnW6z.extractLink)(data);
    return {
        actions: (0, $1rRwQ.default)(response, url, actionOptions, id, aiSummaryConfig),
        assignedToGroup: (0, $efLNK.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $efLNK.extractAttachmentCount)(data),
        authorGroup: (0, $c8AiI.extractPersonCreatedBy)(data),
        ownedByGroup: (0, $dMa80.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $Xx6fX.extractPersonsUpdatedBy)(data),
        commentCount: (0, $efLNK.extractCommentCount)(data),
        viewCount: (0, $efLNK.extractViewCount)(data),
        reactCount: (0, $efLNK.extractReactCount)(data),
        voteCount: (0, $efLNK.extractVoteCount)(data),
        checklistProgress: (0, $efLNK.extractChecklistProgress)(data),
        createdBy: (0, $efLNK.extractCreatedBy)(data),
        ownedBy: (0, $efLNK.extractOwnedBy)(data),
        assignedTo: (0, $efLNK.extractAssignedTo)(data),
        createdOn: (0, $h1sO6.extractDateCreated)(data),
        dueOn: (0, $efLNK.extractDueOn)(data),
        viewAction: (0, $6Qkrf.extractViewAction)(data, actionOptions),
        latestCommit: (0, $7dF5i.extractLatestCommit)(data),
        linkIcon: (0, $90Km0.extractLinkIcon)(response, renderers),
        location: (0, $efLNK.extractLocation)(data),
        modifiedBy: (0, $efLNK.extractModifiedBy)(data),
        modifiedOn: (0, $dGfXu.extractDateUpdated)(data),
        preview: (0, $jeta8.default)(data),
        priority: (0, $kqOma.default)(data),
        provider: (0, $3I5bt.default)(data),
        programmingLanguage: (0, $efLNK.extractProgrammingLanguage)(data),
        readTime: (0, $efLNK.extractReadTime)(data),
        sentOn: (0, $efLNK.extractSentOn)(data),
        snippet: (0, $eFKYn.extractSummary)(data) || undefined,
        // Explicitly set here to remove an empty string
        sourceBranch: (0, $efLNK.extractSourceBranch)(data),
        state: (0, $7INSE.default)(response, actionOptions, id),
        subscriberCount: (0, $efLNK.extractSubscriberCount)(data),
        subTasksProgress: (0, $efLNK.extractSubTasksProgress)(data),
        storyPoints: (0, $efLNK.extractStoryPoints)(data),
        targetBranch: (0, $efLNK.extractTargetBranch)(data),
        title: (0, $a4gSw.extractTitle)(data) || url,
        url: url,
        ari: (0, $1qrFi.extractAri)(data)
    };
};
var $bed2f517125016e1$export$2e2bcd8739ae039 = $bed2f517125016e1$var$extractFlexibleUiContext;

});
parcelRegister("1rRwQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $10e1d5c289544c01$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $hXWLE = parcelRequire("hXWLE");

var $kQB8r = parcelRequire("kQB8r");

var $2Elol = parcelRequire("2Elol");

var $9MbCN = parcelRequire("9MbCN");

var $8vEzT = parcelRequire("8vEzT");

var $4PIcu = parcelRequire("4PIcu");

var $cxdc8 = parcelRequire("cxdc8");

var $fhT7A = parcelRequire("fhT7A");
const $10e1d5c289544c01$var$extractActions = (response, url, actionOptions, id, aiSummaryConfig)=>{
    const data = response.data;
    const action = {
        [(0, $hXWLE.ActionName).CopyLinkAction]: (0, $4PIcu.extractCopyLinkAction)(data, actionOptions),
        [(0, $hXWLE.ActionName).DownloadAction]: (0, $kQB8r.extractDownloadAction)(data, actionOptions),
        [(0, $hXWLE.ActionName).FollowAction]: (0, $8vEzT.default)(response, actionOptions, id),
        [(0, $hXWLE.ActionName).PreviewAction]: (0, $2Elol.extractPreviewAction)(response, actionOptions),
        [(0, $hXWLE.ActionName).AutomationAction]: (0, $cxdc8.extractAutomationAction)(response),
        [(0, $hXWLE.InternalActionName).AISummaryAction]: (0, $9MbCN.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        ...(0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.enable-view-related-urls-action') ? {
            [(0, $hXWLE.InternalActionName).ViewRelatedLinksAction]: (0, $fhT7A.extractViewRelatedLinksAction)(response)
        } : {}
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};
var $10e1d5c289544c01$export$2e2bcd8739ae039 = $10e1d5c289544c01$var$extractActions;

});
parcelRegister("kQB8r", function(module, exports) {

$parcel$export(module.exports, "extractDownloadAction", () => $f2d578445b351c08$export$e2076b2e4a490ac5);

var $5gRnk = parcelRequire("5gRnk");

var $cua7B = parcelRequire("cua7B");

var $9n9Zb = parcelRequire("9n9Zb");

var $79s2Z = parcelRequire("79s2Z");
const $f2d578445b351c08$export$e2076b2e4a490ac5 = (data, actionOptions)=>{
    if (!(0, $5gRnk.canShowAction)((0, $cua7B.CardAction).DownloadAction, actionOptions)) return;
    const downloadActionExists = (0, $9n9Zb.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) return {
        downloadUrl: (0, $79s2Z.extractDownloadUrl)(data)
    };
    return;
};

});

parcelRegister("2Elol", function(module, exports) {

$parcel$export(module.exports, "extractPreviewAction", () => $1edfe92847b77a34$export$eba2f3246148e526);

var $79s2Z = parcelRequire("79s2Z");

var $lnW6z = parcelRequire("lnW6z");
var $fQDHB = parcelRequire("fQDHB");
var $ebCNT = parcelRequire("ebCNT");
var $a4gSw = parcelRequire("a4gSw");

var $90Km0 = parcelRequire("90Km0");

var $kGerj = parcelRequire("kGerj");

var $cua7B = parcelRequire("cua7B");

var $5gRnk = parcelRequire("5gRnk");
const $1edfe92847b77a34$export$eba2f3246148e526 = (response, actionOptions)=>{
    var _extractPreviewData;
    if (!(0, $5gRnk.canShowAction)((0, $cua7B.CardAction).PreviewAction, actionOptions)) return;
    const data = response.data;
    const meta = response.meta;
    const src = (_extractPreviewData = (0, $fQDHB.extractPreview)(data, 'web')) === null || _extractPreviewData === void 0 ? void 0 : _extractPreviewData.src;
    if (src) {
        var _extractProvider;
        return {
            downloadUrl: (0, $79s2Z.extractDownloadUrl)(data),
            providerName: (_extractProvider = (0, $ebCNT.extractProvider)(data)) === null || _extractProvider === void 0 ? void 0 : _extractProvider.text,
            src: src,
            title: (0, $a4gSw.extractTitle)(data),
            linkIcon: (0, $90Km0.extractLinkIcon)(response),
            url: (0, $lnW6z.extractLink)(data),
            isSupportTheming: (0, $kGerj.extractIsSupportTheming)(meta)
        };
    }
};

});
parcelRegister("90Km0", function(module, exports) {

$parcel$export(module.exports, "extractLinkIcon", () => $68f81217f79208a6$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $68f81217f79208a6$export$bdd29be9b0395931);

var $5MVW2 = parcelRequire("5MVW2");

var $3I5bt = parcelRequire("3I5bt");

var $hXWLE = parcelRequire("hXWLE");

var $j0AYv = parcelRequire("j0AYv");
const $68f81217f79208a6$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $j0AYv.default)(data, renderers);
    return {
        ...(0, $5MVW2.default)(data),
        render: render
    };
};
const $68f81217f79208a6$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $3I5bt.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $hXWLE.SmartLinkStatus).Forbidden:
        case (0, $hXWLE.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $hXWLE.IconType).Forbidden
            };
        case (0, $hXWLE.SmartLinkStatus).NotFound:
            return {
                icon: (0, $hXWLE.IconType).Error
            };
        case (0, $hXWLE.SmartLinkStatus).Errored:
        case (0, $hXWLE.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $hXWLE.IconType).Default
            };
    }
};

});
parcelRegister("5MVW2", function(module, exports) {

$parcel$export(module.exports, "default", () => $436e602a07dffb53$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $590Ns = parcelRequire("590Ns");

var $lKLos = parcelRequire("lKLos");

var $h0gZB = parcelRequire("h0gZB");

var $9S4uh = parcelRequire("9S4uh");

var $3I5bt = parcelRequire("3I5bt");

var $lyiom = parcelRequire("lyiom");

var $89bS7 = parcelRequire("89bS7");

var $a4gSw = parcelRequire("a4gSw");

var $4PDkx = parcelRequire("4PDkx");

var $hXWLE = parcelRequire("hXWLE");

var $49iYX = parcelRequire("49iYX");
const $436e602a07dffb53$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $89bS7.extractTaskType)(data) || {};
    const taskType = id === null || id === void 0 ? void 0 : id.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $436e602a07dffb53$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $4PDkx.extractorPriorityMap)[b] - (0, $4PDkx.extractorPriorityMap)[a])[0] : type;
};
const $436e602a07dffb53$var$isConfluenceProvider = (provider)=>provider === (0, $590Ns.CONFLUENCE_GENERATOR_ID);
const $436e602a07dffb53$var$isJiraProvider = (provider)=>provider === (0, $590Ns.JIRA_GENERATOR_ID);
const $436e602a07dffb53$var$isNativeProvider = (provider)=>$436e602a07dffb53$var$isConfluenceProvider(provider) || $436e602a07dffb53$var$isJiraProvider(provider);
/**
 * Return the icon object given a JSON-LD data object.
 */ const $436e602a07dffb53$var$extractJsonldDataIcon = (data)=>{
    const generator = data.generator;
    const label = (0, $a4gSw.extractTitle)(data);
    const type = $436e602a07dffb53$var$extractType(data);
    const urlIcon = (0, $lyiom.default)(data.icon, label);
    const provider = generator === null || generator === void 0 ? void 0 : generator['@id'];
    const providerIcon = (0, $3I5bt.default)(data);
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            // If we encounter a native provider, we privilege the
            // icon generated by its mime type and document type.
            // Otherwise, we privilege the provider icon,
            // followed by mime type and document type icon.
            const documentData = data;
            const fileFormat = documentData === null || documentData === void 0 ? void 0 : documentData['schema:fileFormat'];
            const fileFormatIcon = (0, $h0gZB.default)(fileFormat);
            const documentTypeIcon = (0, $lKLos.default)(type, label);
            if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.standardise-smart-link-icon-behaviour')) return (0, $49iYX.prioritiseIcon)({
                providerId: provider,
                fileFormatIcon: fileFormatIcon,
                documentTypeIcon: documentTypeIcon,
                urlIcon: urlIcon,
                providerIcon: providerIcon
            });
            return $436e602a07dffb53$var$isNativeProvider(provider) ? fileFormatIcon || documentTypeIcon || urlIcon || providerIcon : providerIcon || fileFormatIcon || documentTypeIcon;
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            if ($436e602a07dffb53$var$isJiraProvider(provider)) {
                const { taskType: taskType, taskIcon: taskIcon } = $436e602a07dffb53$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || urlIcon || providerIcon || {
                    icon: (0, $hXWLE.IconType).Task,
                    label: taskLabel
                } : (0, $9S4uh.default)(taskType, taskLabel);
            }
            return {
                icon: (0, $hXWLE.IconType).Task,
                label: taskLabel
            };
        case 'atlassian:Goal':
            return urlIcon || {
                icon: (0, $hXWLE.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return urlIcon || {
                icon: (0, $hXWLE.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $hXWLE.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $hXWLE.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $hXWLE.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $hXWLE.IconType).Repo,
                label: label || 'Repository'
            };
        default:
            return (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.standardise-smart-link-icon-behaviour') ? $436e602a07dffb53$var$extractDefaultIcon({
                data: data,
                type: type,
                label: label,
                provider: provider,
                urlIcon: urlIcon,
                providerIcon: providerIcon
            }) : providerIcon;
    }
};
var $436e602a07dffb53$export$2e2bcd8739ae039 = $436e602a07dffb53$var$extractJsonldDataIcon;
/**
 * Choose which icon to show when the type is not recognized.
 */ const $436e602a07dffb53$var$extractDefaultIcon = ({ data: data, type: type, label: label, provider: provider, urlIcon: urlIcon, providerIcon: providerIcon })=>{
    const documentData = data;
    const fileFormat = documentData === null || documentData === void 0 ? void 0 : documentData['schema:fileFormat'];
    const fileFormatIcon = (0, $h0gZB.default)(fileFormat);
    const documentTypeIcon = (0, $lKLos.default)(type, label);
    return (0, $49iYX.prioritiseIcon)({
        providerId: provider,
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
};

});
parcelRegister("lKLos", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd62a839f96db784$export$2e2bcd8739ae039);

var $hXWLE = parcelRequire("hXWLE");
const $fd62a839f96db784$var$extractDocumentTypeIcon = (documentType, label)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $hXWLE.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            return {
                icon: (0, $hXWLE.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $hXWLE.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $hXWLE.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $hXWLE.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            return {
                icon: (0, $hXWLE.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $hXWLE.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $fd62a839f96db784$export$2e2bcd8739ae039 = $fd62a839f96db784$var$extractDocumentTypeIcon;

});

parcelRegister("h0gZB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c60f9e22dc4f0bbe$export$2e2bcd8739ae039);

var $hXWLE = parcelRequire("hXWLE");
const $c60f9e22dc4f0bbe$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $hXWLE.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $hXWLE.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $hXWLE.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $hXWLE.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $hXWLE.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $hXWLE.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $hXWLE.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $hXWLE.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $hXWLE.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $hXWLE.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $hXWLE.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $hXWLE.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $hXWLE.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $hXWLE.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $hXWLE.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $hXWLE.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $hXWLE.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $hXWLE.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $hXWLE.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $hXWLE.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $hXWLE.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $hXWLE.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $c60f9e22dc4f0bbe$export$2e2bcd8739ae039 = $c60f9e22dc4f0bbe$var$extractFileFormatIcon;

});

parcelRegister("9S4uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $72fca3546cc820f0$export$2e2bcd8739ae039);

var $hXWLE = parcelRequire("hXWLE");
const $72fca3546cc820f0$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $hXWLE.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $hXWLE.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $hXWLE.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $hXWLE.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $hXWLE.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $hXWLE.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $hXWLE.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $hXWLE.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $hXWLE.IconType).Task,
                label: label
            };
    }
};
var $72fca3546cc820f0$export$2e2bcd8739ae039 = $72fca3546cc820f0$var$extractJiraTaskIcon;

});

parcelRegister("3I5bt", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b39809750b7bf3f$export$2e2bcd8739ae039);

var $590Ns = parcelRequire("590Ns");

var $hXWLE = parcelRequire("hXWLE");

var $lyiom = parcelRequire("lyiom");

var $a4gSw = parcelRequire("a4gSw");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $2b39809750b7bf3f$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator === null || generator === void 0 ? void 0 : generator['@id'];
    const icon = generator === null || generator === void 0 ? void 0 : generator.icon;
    const label = (generator === null || generator === void 0 ? void 0 : generator.name) || (0, $a4gSw.extractTitle)(data);
    if (provider === (0, $590Ns.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $hXWLE.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $590Ns.JIRA_GENERATOR_ID)) return {
        icon: (0, $hXWLE.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $lyiom.default)(icon, label);
};
var $2b39809750b7bf3f$export$2e2bcd8739ae039 = $2b39809750b7bf3f$var$extractProviderIcon;

});
parcelRegister("lyiom", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb0b0a36cda3ad49$export$2e2bcd8739ae039);

var $amPw7 = parcelRequire("amPw7");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $fb0b0a36cda3ad49$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $amPw7.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $fb0b0a36cda3ad49$export$2e2bcd8739ae039 = $fb0b0a36cda3ad49$var$extractUrlIcon;

});



parcelRegister("j0AYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd6ab2d68c565c08$export$2e2bcd8739ae039);
const $dd6ab2d68c565c08$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $dd6ab2d68c565c08$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if ((prefix === null || prefix === void 0 ? void 0 : prefix['@type']) === 'atlassian:Emoji') {
        const emojiId = $dd6ab2d68c565c08$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers === null || renderers === void 0 ? void 0 : renderers.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $dd6ab2d68c565c08$export$2e2bcd8739ae039 = $dd6ab2d68c565c08$var$extractIconRenderer;

});



parcelRegister("9MbCN", function(module, exports) {

$parcel$export(module.exports, "extractAISummaryAction", () => $71e19d2f3da82826$export$e7f7a50a8b8932df);

var $cua7B = parcelRequire("cua7B");

var $5gRnk = parcelRequire("5gRnk");

var $dB5iy = parcelRequire("dB5iy");

var $1qrFi = parcelRequire("1qrFi");
const $71e19d2f3da82826$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $5gRnk.canShowAction)((0, $cua7B.CardAction).AISummaryAction, actionOptions) || !(0, $dB5iy.getIsAISummaryEnabled)(aiSummaryConfig === null || aiSummaryConfig === void 0 ? void 0 : aiSummaryConfig.isAdminHubAIEnabled, response) || !(aiSummaryConfig !== null && aiSummaryConfig !== void 0 && aiSummaryConfig.product) || !url) return;
    return {
        url: url,
        ari: (0, $1qrFi.extractAri)(response.data),
        product: aiSummaryConfig === null || aiSummaryConfig === void 0 ? void 0 : aiSummaryConfig.product
    };
};

});
parcelRegister("1qrFi", function(module, exports) {

$parcel$export(module.exports, "extractAri", () => $719f58b8f5cece0a$export$be18a6294fd426ec);
const $719f58b8f5cece0a$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
};

});


parcelRegister("8vEzT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6320b1e6ef230283$export$2e2bcd8739ae039);

var $lnW6z = parcelRequire("lnW6z");
var $4yj9H = parcelRequire("4yj9H");

var $cCvxR = parcelRequire("cCvxR");

var $akLqG = parcelRequire("akLqG");

var $ebp0K = parcelRequire("ebp0K");

var $cua7B = parcelRequire("cua7B");

var $5gRnk = parcelRequire("5gRnk");
const $6320b1e6ef230283$var$extractFollowAction = (response, actionOptions, id)=>{
    var _action$dataUpdateAct;
    if (!(0, $5gRnk.canShowAction)((0, $cua7B.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $akLqG.getExtensionKey)(response);
    const data = response === null || response === void 0 ? void 0 : response.data;
    const actions = (0, $ebp0K.default)(data);
    const type = (0, $4yj9H.extractType)(data);
    const isProject = type === null || type === void 0 ? void 0 : type.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if ((item === null || item === void 0 ? void 0 : item.name) === 'UpdateAction') {
            var _dataUpdateAction;
            const actionName = item === null || item === void 0 ? void 0 : (_dataUpdateAction = item.dataUpdateAction) === null || _dataUpdateAction === void 0 ? void 0 : _dataUpdateAction.name;
            return actionName === (0, $cCvxR.SmartLinkActionType).FollowEntityAction || actionName === (0, $cCvxR.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $lnW6z.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = (_action$dataUpdateAct = action.dataUpdateAction) === null || _action$dataUpdateAct === void 0 ? void 0 : _action$dataUpdateAct.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $cCvxR.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $6320b1e6ef230283$export$2e2bcd8739ae039 = $6320b1e6ef230283$var$extractFollowAction;

});
parcelRegister("ebp0K", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5357e7466a71c6f$export$2e2bcd8739ae039);
const $a5357e7466a71c6f$var$extractServerAction = (data)=>{
    const actions = data === null || data === void 0 ? void 0 : data['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $a5357e7466a71c6f$export$2e2bcd8739ae039 = $a5357e7466a71c6f$var$extractServerAction;

});


parcelRegister("4PIcu", function(module, exports) {

$parcel$export(module.exports, "extractCopyLinkAction", () => $384e3621dcb6b373$export$5b7ae1fa8fdb83ba);

var $lnW6z = parcelRequire("lnW6z");

var $cua7B = parcelRequire("cua7B");

var $5gRnk = parcelRequire("5gRnk");
const $384e3621dcb6b373$export$5b7ae1fa8fdb83ba = (data, actionOptions)=>{
    if (!(0, $5gRnk.canShowAction)((0, $cua7B.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $lnW6z.extractLink)(data);
    if (!url) return;
    return {
        url: url
    };
};

});

parcelRegister("cxdc8", function(module, exports) {

$parcel$export(module.exports, "extractAutomationAction", () => $9202cd525dd83e99$export$f913cc6abf3ec084);

var $XHGTv = parcelRequire("XHGTv");

var $6D8aU = parcelRequire("6D8aU");
// This action will not be enabled by default for smart cards, which is opposite of the default behavior for actions.
// The AutomationAction will only appear if product/resourceType combination is handled by this function.
const $9202cd525dd83e99$var$getProductData = (meta)=>{
    var _ProductData$product;
    const { tenantId: tenantId } = meta;
    const product = meta.product;
    const resourceType = meta.resourceType;
    const ProductData = {
        'confluence': {
            'page': {
                //TODO extract to server
                siteAri: `ari:cloud:confluence::site/${tenantId}`,
                //TODO Move to AutomationAction
                modalTitle: (0, $6D8aU.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $6D8aU.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return ProductData === null || ProductData === void 0 ? void 0 : (_ProductData$product = ProductData[product]) === null || _ProductData$product === void 0 ? void 0 : _ProductData$product[resourceType];
};
const $9202cd525dd83e99$export$f913cc6abf3ec084 = (response)=>{
    if (!(0, $XHGTv.getBooleanFF)('platform.linking-platfom.smart-card.confluence.page.automation-action_xcdoi') || !response.data) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, "atlassian:ari": objectAri } = data;
    const productData = $9202cd525dd83e99$var$getProductData(meta);
    if (!productData) return undefined;
    return {
        ...productData,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCard'
    };
};

});

parcelRegister("fhT7A", function(module, exports) {

$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $b213338486f2fa72$export$debae7424a0231b9);

var $lnW6z = parcelRequire("lnW6z");
const $b213338486f2fa72$export$debae7424a0231b9 = (response)=>{
    var _response$meta, _response$meta$suppor;
    if (!(response !== null && response !== void 0 && (_response$meta = response.meta) !== null && _response$meta !== void 0 && (_response$meta$suppor = _response$meta.supportedFeature) !== null && _response$meta$suppor !== void 0 && _response$meta$suppor.includes('RelatedLinks'))) return;
    const url = (0, $lnW6z.extractLink)(response.data);
    if (!url) return;
    return {
        url: url
    };
};

});


parcelRegister("Xx6fX", function(module, exports) {

$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $0b2f2fc14b7c563d$export$216e4f6aa7c169b8);

var $cx2mN = parcelRequire("cx2mN");
var $3gIUj = parcelRequire("3gIUj");
const $0b2f2fc14b7c563d$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $cx2mN.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $3gIUj.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});

parcelRegister("kqOma", function(module, exports) {

$parcel$export(module.exports, "default", () => $edfd4c1882046167$export$2e2bcd8739ae039);

var $hXWLE = parcelRequire("hXWLE");

var $amPw7 = parcelRequire("amPw7");
const $edfd4c1882046167$var$priorityMapper = {
    blocker: (0, $hXWLE.IconType).PriorityBlocker,
    critical: (0, $hXWLE.IconType).PriorityCritical,
    high: (0, $hXWLE.IconType).PriorityHigh,
    highest: (0, $hXWLE.IconType).PriorityHighest,
    low: (0, $hXWLE.IconType).PriorityLow,
    lowest: (0, $hXWLE.IconType).PriorityLowest,
    major: (0, $hXWLE.IconType).PriorityMajor,
    medium: (0, $hXWLE.IconType).PriorityMedium,
    minor: (0, $hXWLE.IconType).PriorityMinor,
    trivial: (0, $hXWLE.IconType).PriorityTrivial,
    undefined: (0, $hXWLE.IconType).PriorityUndefined
};
const $edfd4c1882046167$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $edfd4c1882046167$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $amPw7.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $edfd4c1882046167$export$2e2bcd8739ae039 = $edfd4c1882046167$var$extractPriority;

});

parcelRegister("jeta8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e005f22c6ab6d7c4$export$2e2bcd8739ae039);

var $lbKTa = parcelRequire("lbKTa");

var $hXWLE = parcelRequire("hXWLE");
const $e005f22c6ab6d7c4$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $lbKTa.extractImage)(data);
    return url ? {
        type: (0, $hXWLE.MediaType).Image,
        url: url
    } : undefined;
};
var $e005f22c6ab6d7c4$export$2e2bcd8739ae039 = $e005f22c6ab6d7c4$var$extractPreview;

});

parcelRegister("7INSE", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f355b1365d0738$export$2e2bcd8739ae039);

var $5XeOV = parcelRequire("5XeOV");

var $XHGTv = parcelRequire("XHGTv");

var $akLqG = parcelRequire("akLqG");

var $ebp0K = parcelRequire("ebp0K");

var $lnW6z = parcelRequire("lnW6z");

var $2Elol = parcelRequire("2Elol");

var $cua7B = parcelRequire("cua7B");

var $5gRnk = parcelRequire("5gRnk");
const $59f355b1365d0738$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $59f355b1365d0738$var$extractAction = (response, id)=>{
    var _action$dataRetrieval, _action$dataUpdateAct;
    const extensionKey = (0, $akLqG.getExtensionKey)(response);
    const data = response === null || response === void 0 ? void 0 : response.data;
    const actions = (0, $ebp0K.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>(item === null || item === void 0 ? void 0 : item.name) === 'UpdateAction' && (item === null || item === void 0 ? void 0 : item.refField) === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $59f355b1365d0738$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, (_action$dataRetrieval = action.dataRetrievalAction) === null || _action$dataRetrieval === void 0 ? void 0 : _action$dataRetrieval.name);
    const url = (0, $lnW6z.extractLink)(data);
    const previewData = response ? (0, $2Elol.extractPreviewAction)(response) : null;
    const details = {
        id: id,
        url: url,
        previewData: previewData
    };
    const update = $59f355b1365d0738$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, (_action$dataUpdateAct = action.dataUpdateAction) === null || _action$dataUpdateAct === void 0 ? void 0 : _action$dataUpdateAct.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $59f355b1365d0738$var$extractState = (response, actionOptions, id)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $5XeOV.extractLozenge)(response === null || response === void 0 ? void 0 : response.data);
    if (!lozenge) return;
    if (!(0, $5gRnk.canShowAction)((0, $cua7B.CardAction).ChangeStatusAction, actionOptions) || (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.disable-jira-status-action')) return lozenge;
    const action = $59f355b1365d0738$var$extractAction(response, id);
    return {
        ...lozenge,
        action: action
    };
};
var $59f355b1365d0738$export$2e2bcd8739ae039 = $59f355b1365d0738$var$extractState;

});

parcelRegister("7dF5i", function(module, exports) {

$parcel$export(module.exports, "extractLatestCommit", () => $54199dd090dd525c$export$f222392162cff0d8);
const $54199dd090dd525c$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});

parcelRegister("6Qkrf", function(module, exports) {

$parcel$export(module.exports, "extractViewAction", () => $4fb7740cff051a38$export$96c7e3a7e9c64e85);

var $lnW6z = parcelRequire("lnW6z");

var $9n9Zb = parcelRequire("9n9Zb");

var $cua7B = parcelRequire("cua7B");

var $5gRnk = parcelRequire("5gRnk");
const $4fb7740cff051a38$export$96c7e3a7e9c64e85 = (data, actionOptions)=>{
    if (!(0, $5gRnk.canShowAction)((0, $cua7B.CardAction).ViewAction, actionOptions)) return;
    const viewActionExists = (0, $9n9Zb.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (viewActionExists) return {
        viewUrl: (0, $lnW6z.extractLink)(data)
    };
    return undefined;
};

});



parcelRegister("iEjlM", function(module, exports) {

$parcel$export(module.exports, "fireRelatedLinksViewedEvent", () => $d93af8fa27ea0c55$export$b33ea4a8393685d8);
$parcel$export(module.exports, "RelatedUrlItemAnalyticsContext", () => $d93af8fa27ea0c55$export$e88153cb3e6fc3fc);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");

var $jfVIr = parcelRequire("jfVIr");

var $iDnwt = parcelRequire("iDnwt");
const $d93af8fa27ea0c55$var$createUiRelatedLinksViewedEventPayload = ({ relatedLinksCount: relatedLinksCount })=>({
        action: 'viewed',
        actionSubject: 'relatedLinks',
        eventType: 'ui',
        attributes: {
            relatedLinksCount: relatedLinksCount
        }
    });
const $d93af8fa27ea0c55$export$b33ea4a8393685d8 = (createAnalyticsEvent)=>(attributes)=>{
        const payload = $d93af8fa27ea0c55$var$createUiRelatedLinksViewedEventPayload(attributes);
        if (payload) createAnalyticsEvent({
            ...payload
        }).fire((0, $iDnwt.ANALYTICS_CHANNEL));
    };
const $d93af8fa27ea0c55$export$e88153cb3e6fc3fc = (props)=>{
    const { children: children, details: details } = props;
    /**
   * We don't really need the `url` to get the attributes here so set
   * it to an empty string to just make typescript happy
   */ const attributes = (0, $jfVIr.getResolvedAttributes)({
        url: ''
    }, details);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            attributes: attributes,
            component: 'relatedLink'
        }
    }, children);
};

});
parcelRegister("jfVIr", function(module, exports) {

$parcel$export(module.exports, "getResolvedAttributes", () => $ea95fbff36d57274$export$7243431f5325a7b);

var $4hPjC = parcelRequire("4hPjC");

var $kFGtp = parcelRequire("kFGtp");
const $ea95fbff36d57274$export$7243431f5325a7b = (linkDetails, details, linkStatus)=>{
    const status = linkStatus ?? (details && (0, $4hPjC.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $kFGtp.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("kFGtp", function(module, exports) {

$parcel$export(module.exports, "getDisplayCategory", () => $c8d9d9ce9f7c0d20$export$28ddbae335bd80b5);
const $c8d9d9ce9f7c0d20$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});






parcelRegister("b4c6W", function(module, exports) {

$parcel$export(module.exports, "RelatedUrlsBlockResolvingView", () => $80e9766898c48b07$export$50a43430722f62f8);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $6fjty = parcelRequire("6fjty");

var $kIvR9 = parcelRequire("kIvR9");
const $80e9766898c48b07$export$50a43430722f62f8 = ({ testId: testId, ...blockProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIvR9.default), (0, $kU09D.default)({}, blockProps, {
        testId: testId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6fjty.default), {
        height: 1.55,
        width: 22
    }));

});

parcelRegister("k421q", function(module, exports) {

$parcel$export(module.exports, "fireRelatedLinksLoadedEvent", () => $e9b5bfe6e05db099$export$d2852f8792c380fa);

var $iDnwt = parcelRequire("iDnwt");
const $e9b5bfe6e05db099$var$createTrackRelatedLinksLoadedEventPayload = ({ relatedLinksCount: relatedLinksCount })=>({
        action: 'loaded',
        actionSubject: 'relatedLinks',
        eventType: 'track',
        attributes: {
            relatedLinksCount: relatedLinksCount
        }
    });
const $e9b5bfe6e05db099$export$d2852f8792c380fa = (createAnalyticsEvent)=>(attributes)=>{
        const payload = $e9b5bfe6e05db099$var$createTrackRelatedLinksLoadedEventPayload(attributes);
        if (payload) createAnalyticsEvent({
            ...payload
        }).fire((0, $iDnwt.ANALYTICS_CHANNEL));
    };

});


parcelRegister("5nprK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ea2d6de9b88479a$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $ewZsI = parcelRequire("ewZsI");

var $hXWLE = parcelRequire("hXWLE");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $3ea2d6de9b88479a$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
    if (status !== (0, $hXWLE.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewZsI.default), (0, $kU09D.default)({}, props, {
        testId: testId
    }));
};
var $3ea2d6de9b88479a$export$2e2bcd8739ae039 = $3ea2d6de9b88479a$var$AISummaryBlock;

});
parcelRegister("ewZsI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a943baed547e8deb$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hSQOv = parcelRequire("hSQOv");
var $6h1SY = parcelRequire("6h1SY");

var $hXWLE = parcelRequire("hXWLE");

var $ezIO6 = parcelRequire("ezIO6");

var $kIvR9 = parcelRequire("kIvR9");

var $9SkfS = parcelRequire("9SkfS");

var $4qRa7 = parcelRequire("4qRa7");

var $6SC0X = parcelRequire("6SC0X");

var $aHboL = parcelRequire("aHboL");

var $6D8aU = parcelRequire("6D8aU");

var $9Ll0U = parcelRequire("9Ll0U");

var $9ZtZq = parcelRequire("9ZtZq");

var $hFLs4 = parcelRequire("hFLs4");

var $3GWpI = parcelRequire("3GWpI");

var $5BHpz = parcelRequire("5BHpz");

var $2u7Sj = parcelRequire("2u7Sj");


var $byn9U = parcelRequire("byn9U");

var $id245 = parcelRequire("id245");

var $l8O8E = parcelRequire("l8O8E");

var $gqldc = parcelRequire("gqldc");

var $XHGTv = parcelRequire("XHGTv");
const $a943baed547e8deb$export$d5337beb171cc161 = ({ showErrorIndicator: showErrorIndicator, error: error, showTransition: showTransition, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4qRa7.default), {
        isFadeIn: true,
        show: showErrorIndicator,
        showTransition: showTransition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2u7Sj.default), {
        reason: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6SC0X.default), {
        error: error,
        state: "error",
        testId: testId
    }));
const $a943baed547e8deb$export$abb9b28ccbdde43a = ({ showStatusIndicator: showStatusIndicator, metadata: metadata, status: status, testId: testId })=>{
    const metadataElements = (0, $aHboL.renderElementItems)(metadata);
    return showStatusIndicator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6SC0X.default), {
        state: status,
        testId: `${testId}-state-indicator`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9SkfS.default), {
        width: (0, $hXWLE.SmartLinkWidth).FitToContent,
        testId: `${testId}-metadata-group`
    }, metadataElements);
};
const $a943baed547e8deb$var$AISummaryBlockResolvedView = (props)=>{
    const { actions: actions = [], onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $hXWLE.SmartLinkSize).Medium, testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, metadata: metadata, placeholder: placeholder } = props;
    const { fireEvent: fireEvent } = (0, $3GWpI.useAnalyticsEvents)();
    const context = (0, $l8O8E.useFlexibleUiContext)();
    const url = (context === null || context === void 0 ? void 0 : context.url) || '';
    const ari = (context === null || context === void 0 ? void 0 : context.ari) || '';
    const { product: product, connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const { summariseUrl: summariseUrl, state: { content: content, status: status, error: error } } = (0, $9Ll0U.useAISummary)({
        url: url,
        ari: ari,
        product: product,
        envKey: connections.client.envKey,
        baseUrl: connections.client.baseUrlOverride
    });
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $eUqFw.useRef)(status === 'done');
    const isErroredOnMountRef = (0, $eUqFw.useRef)(status === 'error');
    const minHeight = (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign') && isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    (0, $eUqFw.useEffect)(()=>{
        // if the error was apparent on mount and the status is changed to loading we can
        // clear the initial error on mount state
        if (isErroredOnMountRef.current && status === 'loading') isErroredOnMountRef.current = false;
    }, [
        status
    ]);
    const combinedActions = (0, $eUqFw.useMemo)(()=>{
        if (status === 'ready' || status === 'error') {
            const aiAction = {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).ai_summarize),
                name: (0, $hXWLE.ActionName).CustomAction,
                onClick: ()=>{
                    fireEvent('ui.button.clicked.aiSummary', {});
                    fireEvent('track.aiInteraction.initiated', {
                        aiFeatureName: 'Smart Links Summary',
                        proactiveAIGenerated: 0,
                        userGeneratedAI: 1
                    });
                    summariseUrl();
                },
                testId: `${testId}-ai-summary-action`,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ZtZq.default), {
                    label: "AIIcon"
                }),
                /**
         * Enabling feature discovery pulse
         * Cleanup: https://product-fabric.atlassian.net/browse/EDM-9693
         */ wrapper: (0, $id245.default)
            };
            return [
                aiAction,
                ...actions
            ];
        }
        return actions;
    }, [
        actions,
        status,
        testId,
        summariseUrl,
        fireEvent
    ]);
    const onDropdownOpenChange = (0, $eUqFw.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    if (!showAISummary && (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIvR9.default), (0, $kU09D.default)({}, props, {
        direction: (0, $hXWLE.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        overrideCss: (0, $byn9U.css)({
            overflow: 'visible'
        }, props.overrideCss)
    }), status === 'done' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BHpz.default), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4qRa7.default), {
        minHeight: minHeight,
        show: showAISummary,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFLs4.default), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content,
        showIcon: !(0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign') && isSummarisedOnMountRef.current
    })), !(0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6h1SY.default), {
        alignBlock: "center",
        alignInline: "end",
        grow: "fill",
        spread: "space-between",
        testId: `${testId}-footer-metadata`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a943baed547e8deb$export$abb9b28ccbdde43a, {
        metadata: metadata,
        showStatusIndicator: !isSummarisedOnMountRef.current && (status === 'loading' || status === 'done'),
        status: status,
        testId: testId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ezIO6.default), {
        onDropdownOpenChange: onDropdownOpenChange,
        items: combinedActions,
        appearance: "default",
        size: size
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a943baed547e8deb$export$d5337beb171cc161, {
        showErrorIndicator: !isErroredOnMountRef.current && status === 'error',
        showTransition: !isErroredOnMountRef.current,
        error: error,
        testId: `${testId}-error-indicator`
    })));
};
var $a943baed547e8deb$export$2e2bcd8739ae039 = $a943baed547e8deb$var$AISummaryBlockResolvedView;

});
parcelRegister("4qRa7", function(module, exports) {

$parcel$export(module.exports, "default", () => $33a2d40391c2a072$export$2e2bcd8739ae039);

var $hSQOv = parcelRequire("hSQOv");

var $eUqFw = parcelRequire("eUqFw");
const $33a2d40391c2a072$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $eUqFw.useState)(0);
    const ref = (0, $eUqFw.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $eUqFw.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), {
        style: {
            height: height,
            minHeight: minHeight,
            lineHeight: 0,
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            transitionDuration: '0.3s'
        },
        ref: ref
    }, children) : null;
};
var $33a2d40391c2a072$export$2e2bcd8739ae039 = $33a2d40391c2a072$export$6118ed0013927eb2;

});

parcelRegister("6SC0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $5025461eda4108b8$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
parcelRequire("eUqFw");

var $5mygl = parcelRequire("5mygl");

var $db6yZ = parcelRequire("db6yZ");

var $cgM2W = parcelRequire("cgM2W");
const $5025461eda4108b8$var$AIStateIndicator = ({ state: state, appearance: appearance = 'default', testId: testId = 'ai-state-indicator', error: error })=>{
    switch(state){
        case 'error':
            return (0, $byn9U.jsx)((0, $cgM2W.default), {
                appearance: appearance,
                testId: testId,
                error: error
            });
        case 'loading':
            return (0, $byn9U.jsx)((0, $5mygl.default), {
                appearance: appearance,
                testId: testId
            });
        case 'done':
            return (0, $byn9U.jsx)((0, $db6yZ.default), {
                appearance: appearance,
                testId: testId
            });
        default:
            return null;
    }
};
var $5025461eda4108b8$export$2e2bcd8739ae039 = $5025461eda4108b8$var$AIStateIndicator;

});
parcelRegister("5mygl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e7995a6d960e4ab$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hSQOv = parcelRequire("hSQOv");

var $6D8aU = parcelRequire("6D8aU");

var $3wYVv = parcelRequire("3wYVv");

var $iGiEW = parcelRequire("iGiEW");
const $3e7995a6d960e4ab$var$AIStateLoading = ({ appearance: appearance, testId: testId })=>{
    switch(appearance){
        case 'icon-only':
            return null;
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iGiEW.default), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3wYVv.default), {
                    label: "AI",
                    size: "small",
                    testId: `${testId}-loading-icon`
                }),
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), {
                    testId: `${testId}-loading-message`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).ai_summarizing)),
                testId: `${testId}-loading`
            });
    }
};
var $3e7995a6d960e4ab$export$2e2bcd8739ae039 = $3e7995a6d960e4ab$var$AIStateLoading;

});
parcelRegister("3wYVv", function(module, exports) {

$parcel$export(module.exports, "default", () => $29239ef9fc3f995c$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");

var $ckBVH = parcelRequire("ckBVH");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $29239ef9fc3f995c$var$bounce = (0, $byn9U.keyframes)({
    from: {
        transform: 'translateY(0)'
    },
    '16.67%': {
        transform: 'translateY(-2px)'
    },
    '33.33%': {
        transform: 'translateY(0px)'
    }
});
const $29239ef9fc3f995c$var$BASE_DELAY = 400;
const $29239ef9fc3f995c$var$QUEUE_DELAY = 200;
const $29239ef9fc3f995c$var$animationStyles = (0, $byn9U.css)({
    animation: `${$29239ef9fc3f995c$var$bounce} 1.2s linear infinite normal`
});
const $29239ef9fc3f995c$var$firstDelayStyles = (0, $byn9U.css)({
    animationDelay: `${$29239ef9fc3f995c$var$BASE_DELAY + $29239ef9fc3f995c$var$QUEUE_DELAY}ms`
});
const $29239ef9fc3f995c$var$secondDelayStyles = (0, $byn9U.css)({
    animationDelay: `${$29239ef9fc3f995c$var$BASE_DELAY + $29239ef9fc3f995c$var$QUEUE_DELAY * 2}ms`
});
const $29239ef9fc3f995c$var$thirdDelayStyles = (0, $byn9U.css)({
    animationDelay: `${$29239ef9fc3f995c$var$BASE_DELAY + $29239ef9fc3f995c$var$QUEUE_DELAY * 3}ms`
});
/**
 * this icon is theme agnostic, no need for tokens
 */ const $29239ef9fc3f995c$var$AIIconLoading = (props)=>(0, $byn9U.jsx)((0, $ce8OV.default), props, (0, $byn9U.jsx)("circle", {
        css: [
            $29239ef9fc3f995c$var$animationStyles,
            $29239ef9fc3f995c$var$firstDelayStyles
        ],
        cx: "6",
        cy: "12",
        r: "1.5",
        fill: (0, $ckBVH.aiThemeTokens).blue700
    }), (0, $byn9U.jsx)("circle", {
        css: [
            $29239ef9fc3f995c$var$animationStyles,
            $29239ef9fc3f995c$var$secondDelayStyles
        ],
        cx: "12",
        cy: "12",
        r: "1.5",
        fill: (0, $ckBVH.aiThemeTokens).blue600
    }), (0, $byn9U.jsx)("circle", {
        css: [
            $29239ef9fc3f995c$var$animationStyles,
            $29239ef9fc3f995c$var$thirdDelayStyles
        ],
        cx: "17.5",
        cy: "12",
        r: "1.5",
        fill: (0, $ckBVH.aiThemeTokens).blue500
    }));
var $29239ef9fc3f995c$export$2e2bcd8739ae039 = $29239ef9fc3f995c$var$AIIconLoading;

});
parcelRegister("ckBVH", function(module, exports) {

$parcel$export(module.exports, "INNER_BORDER_RADIUS", () => $8fa4c650c1f7a0d7$export$e9d9825cf6898271);
$parcel$export(module.exports, "OUTER_BORDER_RADIUS", () => $8fa4c650c1f7a0d7$export$2a2ad00ed1dae540);
$parcel$export(module.exports, "aiThemeTokens", () => $8fa4c650c1f7a0d7$export$3088ed82e2905d1e);
$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $8fa4c650c1f7a0d7$export$23b7b83c7063ccfe);
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $8fa4c650c1f7a0d7$export$e9d9825cf6898271 = 8;
const $8fa4c650c1f7a0d7$export$2a2ad00ed1dae540 = 10;
const $8fa4c650c1f7a0d7$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $8fa4c650c1f7a0d7$export$23b7b83c7063ccfe = {
    dark: {
        blue: $8fa4c650c1f7a0d7$export$3088ed82e2905d1e.blue800,
        teal: $8fa4c650c1f7a0d7$export$3088ed82e2905d1e.teal500,
        yellow: $8fa4c650c1f7a0d7$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $8fa4c650c1f7a0d7$export$3088ed82e2905d1e.blue600,
        teal: $8fa4c650c1f7a0d7$export$3088ed82e2905d1e.teal300,
        yellow: $8fa4c650c1f7a0d7$export$3088ed82e2905d1e.yellow200
    }
};

});


parcelRegister("iGiEW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d99a9f9dff1de027$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6h1SY = parcelRequire("6h1SY");
var $caLW4 = parcelRequire("caLW4");
const $d99a9f9dff1de027$var$contentStyles = (0, $caLW4.xcss)({
    color: 'color.text.subtle',
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '16px'
});
const $d99a9f9dff1de027$var$AIIndicatorContainer = ({ icon: icon, content: content, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6h1SY.default), {
        alignBlock: "start",
        alignInline: "start",
        space: "space.050",
        xcss: $d99a9f9dff1de027$var$contentStyles,
        testId: testId
    }, icon, content);
};
var $d99a9f9dff1de027$export$2e2bcd8739ae039 = $d99a9f9dff1de027$var$AIIndicatorContainer;

});


parcelRegister("db6yZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $998164c9b11f21e7$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $byn9U = parcelRequire("byn9U");

var $aUqTb = parcelRequire("aUqTb");

var $ffiyv = parcelRequire("ffiyv");

var $hSQOv = parcelRequire("hSQOv");
var $6h1SY = parcelRequire("6h1SY");
var $aChL5 = parcelRequire("aChL5");
var $caLW4 = parcelRequire("caLW4");

var $XHGTv = parcelRequire("XHGTv");

var $6D8aU = parcelRequire("6D8aU");

var $9ZtZq = parcelRequire("9ZtZq");

var $b0CIa = parcelRequire("b0CIa");

var $iGiEW = parcelRequire("iGiEW");

var $4u2Ht = parcelRequire("4u2Ht");
const $998164c9b11f21e7$var$tooltipMsgStyles = (0, $caLW4.xcss)({
    color: 'color.text',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px'
});
const $998164c9b11f21e7$var$iconTooltipLinkStyles = (0, $byn9U.css)({
    color: "var(--ds-text-subtlest, #626F86)",
    '&:link, :visited': {
        color: "var(--ds-text-subtlest, #626F86)"
    },
    '&:hover': {
        color: "var(--ds-text-subtle, #44546F)"
    },
    '&:active': {
        color: "var(--ds-text, #172B4D)"
    },
    textDecoration: 'underline'
});
const $998164c9b11f21e7$var$iconTooltipTitleStyles = (0, $caLW4.xcss)({
    color: 'color.text',
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '16px'
});
const $998164c9b11f21e7$var$iconTooltipDescStyles = (0, $caLW4.xcss)({
    color: 'color.text.subtlest',
    fontSize: '11px',
    fontWeight: '400',
    lineHeight: '14px'
});
const $998164c9b11f21e7$var$iconTooltipTriggerStyles = (0, $caLW4.xcss)({
    verticalAlign: 'bottom'
});
const $998164c9b11f21e7$var$AIStateDone = ({ appearance: appearance, testId: testId })=>{
    const icon = (0, $byn9U.jsx)((0, $9ZtZq.default), {
        label: "AI",
        size: "small",
        testId: `${testId}-done-icon`
    });
    const title = (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-ai-summaries-release-stable') ? (0, $byn9U.jsx)((0, $hSQOv.default), {
        testId: `${testId}-done-message`
    }, (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $6D8aU.messages).ai_summarized)) : (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $byn9U.jsx)((0, $hSQOv.default), {
        testId: `${testId}-done-message`
    }, (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $6D8aU.messages).ai_summarized_abbreviation)), (0, $byn9U.jsx)((0, $hSQOv.default), null, (0, $byn9U.jsx)((0, $ffiyv.default), {
        appearance: "new",
        testId: `${testId}-beta`
    }, (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $6D8aU.messages).beta))));
    switch(appearance){
        case 'icon-only':
            return (0, $byn9U.jsx)((0, $b0CIa.default), {
                content: (0, $byn9U.jsx)((0, $6h1SY.default), {
                    alignBlock: "center",
                    space: "space.100"
                }, (0, $byn9U.jsx)((0, $9ZtZq.default), {
                    label: "AI",
                    size: "medium",
                    testId: `${testId}-done-tooltip-icon`
                }), (0, $byn9U.jsx)((0, $aChL5.default), null, (0, $byn9U.jsx)((0, $6h1SY.default), {
                    alignBlock: "center",
                    alignInline: "start",
                    space: "space.050",
                    xcss: $998164c9b11f21e7$var$iconTooltipTitleStyles
                }, title), (0, $byn9U.jsx)((0, $hSQOv.default), {
                    xcss: $998164c9b11f21e7$var$iconTooltipDescStyles
                }, (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $6D8aU.messages).ai_summarized_info, {
                    values: {
                        a: (chunks)=>(0, $byn9U.jsx)((0, $4u2Ht.default), {
                                css: $998164c9b11f21e7$var$iconTooltipLinkStyles
                            }, chunks)
                    }
                }))))),
                trigger: icon,
                xcss: $998164c9b11f21e7$var$iconTooltipTriggerStyles
            });
        default:
            return (0, $byn9U.jsx)((0, $iGiEW.default), {
                icon: icon,
                content: (0, $byn9U.jsx)((0, $6h1SY.default), {
                    alignBlock: "center",
                    alignInline: "start",
                    space: "space.050"
                }, title, (0, $byn9U.jsx)((0, $b0CIa.default), {
                    content: (0, $byn9U.jsx)((0, $hSQOv.default), {
                        xcss: $998164c9b11f21e7$var$tooltipMsgStyles,
                        testId: `${testId}-done-tooltip`
                    }, (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $6D8aU.messages).ai_summarized_info, {
                        values: {
                            a: (chunks)=>(0, $byn9U.jsx)((0, $4u2Ht.default), null, chunks)
                        }
                    }))),
                    trigger: (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
                        label: "Info",
                        size: "small",
                        testId: `${testId}-done-info`
                    })
                })),
                testId: `${testId}-done`
            });
    }
};
var $998164c9b11f21e7$export$2e2bcd8739ae039 = $998164c9b11f21e7$var$AIStateDone;

});
parcelRegister("aUqTb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f13fdf9f823d771$var$_react = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $7f13fdf9f823d771$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f13fdf9f823d771$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $7f13fdf9f823d771$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 19a7 7 0 110-14 7 7 0 010 14zm0-1.5a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm0-6a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm0-3a1 1 0 110 2 1 1 0 010-2z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$7f13fdf9f823d771$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $7f13fdf9f823d771$var$_default = $7f13fdf9f823d771$var$EditorPanelIcon;
module.exports.default = $7f13fdf9f823d771$var$_default;

});

parcelRegister("b0CIa", function(module, exports) {

$parcel$export(module.exports, "default", () => $803db91285ec723f$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $exJuA = parcelRequire("exJuA");

var $8cU5f = parcelRequire("8cU5f");
var $g3tFP = parcelRequire("g3tFP");

var $hSQOv = parcelRequire("hSQOv");
var $caLW4 = parcelRequire("caLW4");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $803db91285ec723f$var$AIIndicatorTooltipPrimitive = (0, $exJuA.default)((0, $g3tFP.default))({
    borderRadius: "var(--ds-border-radius, 3px)",
    backgroundColor: "var(--ds-surface-raised, white)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px rgba(9, 30, 66, 0.15),0px 0px 1px rgba(9, 30, 66, 0.31))",
    boxSizing: 'content-box',
    padding: "var(--ds-space-200, 16px)",
    maxWidth: '350px'
});
const $803db91285ec723f$var$triggerStyles = (0, $caLW4.xcss)({
    display: 'inline-flex'
});
const $803db91285ec723f$var$AIIndicatorTooltip = ({ content: content, trigger: trigger, xcss: overrideXcss })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        component: $803db91285ec723f$var$AIIndicatorTooltipPrimitive,
        content: content,
        tag: "span"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), (0, $kU09D.default)({
            xcss: [
                $803db91285ec723f$var$triggerStyles,
                overrideXcss
            ]
        }, tooltipProps), trigger));
};
var $803db91285ec723f$export$2e2bcd8739ae039 = $803db91285ec723f$var$AIIndicatorTooltip;

});


parcelRegister("cgM2W", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eec3fac52b01ad3$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $96IgR = parcelRequire("96IgR");

var $hSQOv = parcelRequire("hSQOv");
var $caLW4 = parcelRequire("caLW4");

var $dB5iy = parcelRequire("dB5iy");

var $4u2Ht = parcelRequire("4u2Ht");

var $iGiEW = parcelRequire("iGiEW");
const $8eec3fac52b01ad3$var$contentStyles = (0, $caLW4.xcss)({
    color: 'color.text.subtle',
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '14px'
});
const $8eec3fac52b01ad3$var$FormattedErrorMessage = ({ message: message, url: url })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, message, {
        values: {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4u2Ht.default), {
                    href: url
                }, chunks)
        }
    }));
const $8eec3fac52b01ad3$var$AIStateError = ({ appearance: appearance, testId: testId, error: error })=>{
    const { message: message, url: url } = (0, $dB5iy.getAISummaryErrorMessage)(error);
    switch(appearance){
        case 'icon-only':
            return null;
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iGiEW.default), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                    primaryColor: "var(--ds-icon-danger, #C9372C)",
                    label: "AI",
                    size: "small",
                    testId: `${testId}-error-icon`
                }),
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), {
                    testId: `${testId}-error-message`,
                    xcss: $8eec3fac52b01ad3$var$contentStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8eec3fac52b01ad3$var$FormattedErrorMessage, {
                    message: message,
                    url: url
                })),
                testId: `${testId}-error`
            });
    }
};
var $8eec3fac52b01ad3$export$2e2bcd8739ae039 = $8eec3fac52b01ad3$var$AIStateError;

});


parcelRegister("hFLs4", function(module, exports) {

$parcel$export(module.exports, "default", () => $cddb12f1e3df580d$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $27B3S = parcelRequire("27B3S");

var $byn9U = parcelRequire("byn9U");

var $6SC0X = parcelRequire("6SC0X");

var $lgs87 = parcelRequire("lgs87");
const $cddb12f1e3df580d$var$AITooltipIcon = ()=>(0, $byn9U.jsx)((0, $6SC0X.default), {
        appearance: "icon-only",
        state: "done",
        testId: "ai-tooltip"
    });
const $cddb12f1e3df580d$var$AISummaryCSSStyles = (0, $byn9U.css)({
    fontSize: '0.75rem',
    lineHeight: '1rem',
    wordWrap: 'break-word',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    WebkitUserSelect: 'text',
    MozUserSelect: 'text',
    MsUserSelect: 'text',
    userSelect: 'text'
});
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $cddb12f1e3df580d$var$AISummary = ({ content: content = '', showIcon: showIcon = false, iconComponent: iconComponent, overrideCss: overrideCss, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return (0, $byn9U.jsx)((0, $27B3S.default), {
        "data-testid": testId,
        css: [
            $cddb12f1e3df580d$var$AISummaryCSSStyles,
            overrideCss
        ],
        children: showIcon ? `${content}&nbsp;<Icon />` : content,
        options: {
            forceWrapper: true,
            overrides: {
                Icon: iconComponent !== null && iconComponent !== void 0 ? iconComponent : $cddb12f1e3df580d$var$AITooltipIcon,
                ul: (0, $lgs87.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $cddb12f1e3df580d$export$2e2bcd8739ae039 = $cddb12f1e3df580d$var$AISummary;

});
parcelRegister("27B3S", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b8fbd7df5541f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $18b8fbd7df5541f7$var$n() {
    return $18b8fbd7df5541f7$var$n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var t = arguments[n];
            for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
        return e;
    }, $18b8fbd7df5541f7$var$n.apply(this, arguments);
}
const $18b8fbd7df5541f7$var$t = [
    "children",
    "options"
];
var $18b8fbd7df5541f7$export$e0aa44767d8750d5, $18b8fbd7df5541f7$var$i;
!function(e) {
    e.blockQuote = "0", e.breakLine = "1", e.breakThematic = "2", e.codeBlock = "3", e.codeFenced = "4", e.codeInline = "5", e.footnote = "6", e.footnoteReference = "7", e.gfmTask = "8", e.heading = "9", e.headingSetext = "10", e.htmlBlock = "11", e.htmlComment = "12", e.htmlSelfClosing = "13", e.image = "14", e.link = "15", e.linkAngleBraceStyleDetector = "16", e.linkBareUrlDetector = "17", e.linkMailtoDetector = "18", e.newlineCoalescer = "19", e.orderedList = "20", e.paragraph = "21", e.ref = "22", e.refImage = "23", e.refLink = "24", e.table = "25", e.tableSeparator = "26", e.text = "27", e.textBolded = "28", e.textEmphasized = "29", e.textEscaped = "30", e.textMarked = "31", e.textStrikethroughed = "32", e.unorderedList = "33";
}($18b8fbd7df5541f7$export$e0aa44767d8750d5 || ($18b8fbd7df5541f7$export$e0aa44767d8750d5 = {})), function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($18b8fbd7df5541f7$var$i || ($18b8fbd7df5541f7$var$i = {}));
const $18b8fbd7df5541f7$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, n)=>(e[n.toLowerCase()] = n, e), {
    for: "htmlFor"
}), $18b8fbd7df5541f7$var$o = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $18b8fbd7df5541f7$var$c = [
    "style",
    "script"
], $18b8fbd7df5541f7$var$a = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $18b8fbd7df5541f7$var$s = /mailto:/i, $18b8fbd7df5541f7$var$d = /\n{2,}$/, $18b8fbd7df5541f7$var$u = /^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/, $18b8fbd7df5541f7$var$p = /^ *> ?/gm, $18b8fbd7df5541f7$var$f = /^ {2,}\n/, $18b8fbd7df5541f7$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $18b8fbd7df5541f7$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $18b8fbd7df5541f7$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $18b8fbd7df5541f7$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $18b8fbd7df5541f7$var$k = /^(?:\n *)*\n/, $18b8fbd7df5541f7$var$x = /\r\n?/g, $18b8fbd7df5541f7$var$v = /^\[\^([^\]]+)](:.*)\n/, $18b8fbd7df5541f7$var$b = /^\[\^([^\]]+)]/, $18b8fbd7df5541f7$var$$ = /\f/g, $18b8fbd7df5541f7$var$S = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $18b8fbd7df5541f7$var$w = /^\s*?\[(x|\s)\]/, $18b8fbd7df5541f7$var$C = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $18b8fbd7df5541f7$var$E = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $18b8fbd7df5541f7$var$A = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $18b8fbd7df5541f7$var$O = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i, $18b8fbd7df5541f7$var$T = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $18b8fbd7df5541f7$var$L = /^<!--[\s\S]*?(?:-->)/, $18b8fbd7df5541f7$var$z = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $18b8fbd7df5541f7$var$M = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $18b8fbd7df5541f7$var$I = /^\{.*\}$/, $18b8fbd7df5541f7$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $18b8fbd7df5541f7$var$U = /^<([^ >]+@[^ >]+)>/, $18b8fbd7df5541f7$var$j = /^<([^ >]+:\/[^ >]+)>/, $18b8fbd7df5541f7$var$B = /-([a-z])?/gi, $18b8fbd7df5541f7$var$N = /^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/, $18b8fbd7df5541f7$var$H = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $18b8fbd7df5541f7$var$D = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $18b8fbd7df5541f7$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $18b8fbd7df5541f7$var$_ = /(\[|\])/g, $18b8fbd7df5541f7$var$F = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $18b8fbd7df5541f7$var$W = /\t/g, $18b8fbd7df5541f7$var$G = /^ *\| */, $18b8fbd7df5541f7$var$Z = /(^ *\||\| *$)/g, $18b8fbd7df5541f7$var$q = / *$/, $18b8fbd7df5541f7$var$V = /^ *:-+: *$/, $18b8fbd7df5541f7$var$X = /^ *:-+ *$/, $18b8fbd7df5541f7$var$Q = /^ *-+: *$/, $18b8fbd7df5541f7$var$J = /^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/, $18b8fbd7df5541f7$var$K = /^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/, $18b8fbd7df5541f7$var$Y = /^==((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)==/, $18b8fbd7df5541f7$var$ee = /^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/, $18b8fbd7df5541f7$var$ne = /^\\([^0-9A-Za-z\s])/, $18b8fbd7df5541f7$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $18b8fbd7df5541f7$var$re = /^\n+/, $18b8fbd7df5541f7$var$ie = /^([ \t]*)/, $18b8fbd7df5541f7$var$le = /\\([^\\])/g, $18b8fbd7df5541f7$var$oe = / *\n+$/, $18b8fbd7df5541f7$var$ce = /(?:^|\n)( *)$/, $18b8fbd7df5541f7$var$ae = "(?:\\d+\\.)", $18b8fbd7df5541f7$var$se = "(?:[*+-])";
function $18b8fbd7df5541f7$var$de(e) {
    return "( *)(" + (1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se) + ") +";
}
const $18b8fbd7df5541f7$var$ue = $18b8fbd7df5541f7$var$de(1), $18b8fbd7df5541f7$var$pe = $18b8fbd7df5541f7$var$de(2);
function $18b8fbd7df5541f7$var$fe(e) {
    return new RegExp("^" + (1 === e ? $18b8fbd7df5541f7$var$ue : $18b8fbd7df5541f7$var$pe));
}
const $18b8fbd7df5541f7$var$he = $18b8fbd7df5541f7$var$fe(1), $18b8fbd7df5541f7$var$me = $18b8fbd7df5541f7$var$fe(2);
function $18b8fbd7df5541f7$var$ge(e) {
    return new RegExp("^" + (1 === e ? $18b8fbd7df5541f7$var$ue : $18b8fbd7df5541f7$var$pe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $18b8fbd7df5541f7$var$ye = $18b8fbd7df5541f7$var$ge(1), $18b8fbd7df5541f7$var$ke = $18b8fbd7df5541f7$var$ge(2);
function $18b8fbd7df5541f7$var$xe(e) {
    const n = 1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se;
    return new RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
const $18b8fbd7df5541f7$var$ve = $18b8fbd7df5541f7$var$xe(1), $18b8fbd7df5541f7$var$be = $18b8fbd7df5541f7$var$xe(2);
function $18b8fbd7df5541f7$var$$e(e, n) {
    const t = 1 === n, r = t ? $18b8fbd7df5541f7$var$ve : $18b8fbd7df5541f7$var$be, i = t ? $18b8fbd7df5541f7$var$ye : $18b8fbd7df5541f7$var$ke, l = t ? $18b8fbd7df5541f7$var$he : $18b8fbd7df5541f7$var$me;
    return {
        match (e, n, t) {
            const i = $18b8fbd7df5541f7$var$ce.exec(t);
            return i && (n.list || !n.inline && !n.simple) ? r.exec(e = i[1] + e) : null;
        },
        order: 1,
        parse (e, n, r) {
            const o = t ? +e[2] : void 0, c = e[0].replace($18b8fbd7df5541f7$var$d, "\n").match(i);
            let a = !1;
            return {
                items: c.map(function(e, t) {
                    const i = l.exec(e)[0].length, o = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(o, "").replace(l, ""), d = t === c.length - 1, u = -1 !== s.indexOf("\n\n") || d && a;
                    a = u;
                    const p = r.inline, f = r.list;
                    let h;
                    r.list = !0, u ? (r.inline = !1, h = s.replace($18b8fbd7df5541f7$var$oe, "\n\n")) : (r.inline = !0, h = s.replace($18b8fbd7df5541f7$var$oe, ""));
                    const m = n(h, r);
                    return r.inline = p, r.list = f, m;
                }),
                ordered: t,
                start: o
            };
        },
        render: (n, t, r)=>e(n.ordered ? "ol" : "ul", {
                key: r.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, i) {
                return e("li", {
                    key: i
                }, t(n, r));
            }))
    };
}
const $18b8fbd7df5541f7$var$Se = /^\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $18b8fbd7df5541f7$var$we = /^!\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $18b8fbd7df5541f7$var$Ce = [
    $18b8fbd7df5541f7$var$u,
    $18b8fbd7df5541f7$var$m,
    $18b8fbd7df5541f7$var$g,
    $18b8fbd7df5541f7$var$C,
    $18b8fbd7df5541f7$var$A,
    $18b8fbd7df5541f7$var$E,
    $18b8fbd7df5541f7$var$L,
    $18b8fbd7df5541f7$var$N,
    $18b8fbd7df5541f7$var$ye,
    $18b8fbd7df5541f7$var$ve,
    $18b8fbd7df5541f7$var$ke,
    $18b8fbd7df5541f7$var$be
], $18b8fbd7df5541f7$var$Ee = [
    ...$18b8fbd7df5541f7$var$Ce,
    /^[^\n]+(?:  \n|\n{2,})/,
    $18b8fbd7df5541f7$var$O,
    $18b8fbd7df5541f7$var$M
];
function $18b8fbd7df5541f7$var$Ae(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $18b8fbd7df5541f7$var$Oe(e) {
    return $18b8fbd7df5541f7$var$Q.test(e) ? "right" : $18b8fbd7df5541f7$var$V.test(e) ? "center" : $18b8fbd7df5541f7$var$X.test(e) ? "left" : null;
}
function $18b8fbd7df5541f7$var$Te(e, n, t) {
    const r = t.inTable;
    t.inTable = !0;
    const i = n(e.trim(), t);
    t.inTable = r;
    let l = [
        []
    ];
    return i.forEach(function(e, n) {
        "26" === e.type ? 0 !== n && n !== i.length - 1 && l.push([]) : ("27" !== e.type || null != i[n + 1] && "26" !== i[n + 1].type || (e.text = e.text.replace($18b8fbd7df5541f7$var$q, "")), l[l.length - 1].push(e));
    }), l;
}
function $18b8fbd7df5541f7$var$Le(e, n, t) {
    t.inline = !0;
    const r = $18b8fbd7df5541f7$var$Te(e[1], n, t), i = e[2].replace($18b8fbd7df5541f7$var$Z, "").split("|").map($18b8fbd7df5541f7$var$Oe), l = function(e, n, t) {
        return e.trim().split("\n").map(function(e) {
            return $18b8fbd7df5541f7$var$Te(e, n, t);
        });
    }(e[3], n, t);
    return t.inline = !1, {
        align: i,
        cells: l,
        header: r,
        type: "25"
    };
}
function $18b8fbd7df5541f7$var$ze(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function $18b8fbd7df5541f7$var$Me(e) {
    return function(n, t) {
        return t.inline ? e.exec(n) : null;
    };
}
function $18b8fbd7df5541f7$var$Ie(e) {
    return function(n, t) {
        return t.inline || t.simple ? e.exec(n) : null;
    };
}
function $18b8fbd7df5541f7$var$Re(e) {
    return function(n, t) {
        return t.inline || t.simple ? null : e.exec(n);
    };
}
function $18b8fbd7df5541f7$var$Ue(e) {
    return function(n) {
        return e.exec(n);
    };
}
function $18b8fbd7df5541f7$var$je(e, n, t) {
    if (n.inline || n.simple) return null;
    if (t && !t.endsWith("\n")) return null;
    let r = "";
    e.split("\n").every((e)=>!$18b8fbd7df5541f7$var$Ce.some((n)=>n.test(e)) && (r += e + "\n", e.trim()));
    const i = r.trimEnd();
    return "" == i ? null : [
        r,
        i
    ];
}
function $18b8fbd7df5541f7$var$Be(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return;
    } catch (e) {
        return null;
    }
    return e;
}
function $18b8fbd7df5541f7$var$Ne(e) {
    return e.replace($18b8fbd7df5541f7$var$le, "$1");
}
function $18b8fbd7df5541f7$var$He(e, n, t) {
    const r = t.inline || !1, i = t.simple || !1;
    t.inline = !0, t.simple = !0;
    const l = e(n, t);
    return t.inline = r, t.simple = i, l;
}
function $18b8fbd7df5541f7$var$De(e, n, t) {
    const r = t.inline || !1, i = t.simple || !1;
    t.inline = !1, t.simple = !0;
    const l = e(n, t);
    return t.inline = r, t.simple = i, l;
}
function $18b8fbd7df5541f7$var$Pe(e, n, t) {
    return t.inline = !1, e(n, t);
}
const $18b8fbd7df5541f7$var$_e = (e, n, t)=>({
        children: $18b8fbd7df5541f7$var$He(n, e[1], t)
    });
function $18b8fbd7df5541f7$var$Fe() {
    return {};
}
function $18b8fbd7df5541f7$var$We() {
    return null;
}
function $18b8fbd7df5541f7$var$Ge(...e) {
    return e.filter(Boolean).join(" ");
}
function $18b8fbd7df5541f7$var$Ze(e, n, t) {
    let r = e;
    const i = n.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || t;
}
function $18b8fbd7df5541f7$export$69f434acfbdb0b32(t, r = {}) {
    r.overrides = r.overrides || {}, r.slugify = r.slugify || $18b8fbd7df5541f7$var$Ae, r.namedCodesToUnicode = r.namedCodesToUnicode ? $18b8fbd7df5541f7$var$n({}, $18b8fbd7df5541f7$var$o, r.namedCodesToUnicode) : $18b8fbd7df5541f7$var$o;
    const i = r.createElement || $eUqFw.createElement;
    function d(e, t, ...l) {
        const o = $18b8fbd7df5541f7$var$Ze(r.overrides, `${e}.props`, {});
        return i(function(e, n) {
            const t = $18b8fbd7df5541f7$var$Ze(n, e);
            return t ? "function" == typeof t || "object" == typeof t && "render" in t ? t : $18b8fbd7df5541f7$var$Ze(n, `${e}.component`, e) : e;
        }(e, r.overrides), $18b8fbd7df5541f7$var$n({}, t, o, {
            className: $18b8fbd7df5541f7$var$Ge(null == t ? void 0 : t.className, o.className) || void 0
        }), ...l);
    }
    function Z(n) {
        n = n.replace($18b8fbd7df5541f7$var$S, "");
        let t = !1;
        r.forceInline ? t = !0 : r.forceBlock || (t = !1 === $18b8fbd7df5541f7$var$F.test(n));
        const i = oe(le(t ? n : `${n.trimEnd().replace($18b8fbd7df5541f7$var$re, "")}\n\n`, {
            inline: t
        }));
        for(; "string" == typeof i[i.length - 1] && !i[i.length - 1].trim();)i.pop();
        if (null === r.wrapper) return i;
        const l = r.wrapper || (t ? "span" : "div");
        let o;
        if (i.length > 1 || r.forceWrapper) o = i;
        else {
            if (1 === i.length) return o = i[0], "string" == typeof o ? d("span", {
                key: "outer"
            }, o) : o;
            o = null;
        }
        return $eUqFw.createElement(l, {
            key: "outer"
        }, o);
    }
    function q(n) {
        const t = n.match($18b8fbd7df5541f7$var$a);
        return t ? t.reduce(function(n, t, r) {
            const i = t.indexOf("=");
            if (-1 !== i) {
                const o = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($18b8fbd7df5541f7$var$z) && (e = e.replace($18b8fbd7df5541f7$var$B, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(t.slice(0, i)).trim(), c = function(e) {
                    const n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(t.slice(i + 1).trim()), a = $18b8fbd7df5541f7$var$l[o] || o, s = n[a] = function(e, n) {
                    return "style" === e ? n.split(/;\s?/).reduce(function(e, n) {
                        const t = n.slice(0, n.indexOf(":"));
                        return e[t.replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = n.slice(t.length + 1).trim(), e;
                    }, {}) : "href" === e || "src" === e ? $18b8fbd7df5541f7$var$Be(n) : (n.match($18b8fbd7df5541f7$var$I) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(o, c);
                "string" == typeof s && ($18b8fbd7df5541f7$var$O.test(s) || $18b8fbd7df5541f7$var$M.test(s)) && (n[a] = $eUqFw.cloneElement(Z(s.trim()), {
                    key: r
                }));
            } else "style" !== t && (n[$18b8fbd7df5541f7$var$l[t] || t] = !0);
            return n;
        }, {}) : null;
    }
    const V = [], X = {}, Q = {
        0: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$u),
            order: 1,
            parse: (e, n, t)=>({
                    children: n(e[0].replace($18b8fbd7df5541f7$var$p, ""), t)
                }),
            render: (e, n, t)=>d("blockquote", {
                    key: t.key
                }, n(e.children, t))
        },
        1: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$f),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: (e, n, t)=>d("br", {
                    key: t.key
                })
        },
        2: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$h),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: (e, n, t)=>d("hr", {
                    key: t.key
                })
        },
        3: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, t, r)=>d("pre", {
                    key: r.key
                }, d("code", $18b8fbd7df5541f7$var$n({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        4: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: q(e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: "3"
                })
        },
        5: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, n, t)=>d("code", {
                    key: t.key
                }, e.text)
        },
        6: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$v),
            order: 0,
            parse: (e)=>(V.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $18b8fbd7df5541f7$var$We
        },
        7: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$b),
            order: 1,
            parse: (e)=>({
                    target: `#${r.slugify(e[1])}`,
                    text: e[1]
                }),
            render: (e, n, t)=>d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(e.target)
                }, d("sup", {
                    key: t.key
                }, e.text))
        },
        8: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$w),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, n, t)=>d("input", {
                    checked: e.completed,
                    key: t.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        9: {
            match: $18b8fbd7df5541f7$var$Re(r.enforceAtxHeadings ? $18b8fbd7df5541f7$var$E : $18b8fbd7df5541f7$var$C),
            order: 1,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$He(n, e[2], t),
                    id: r.slugify(e[2]),
                    level: e[1].length
                }),
            render: (e, n, t)=>d(`h${e.level}`, {
                    id: e.id,
                    key: t.key
                }, n(e.children, t))
        },
        10: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$A),
            order: 0,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$He(n, e[1], t),
                    level: "=" === e[2] ? 1 : 2,
                    type: "9"
                })
        },
        11: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$O),
            order: 1,
            parse (e, n, t) {
                const [, r] = e[3].match($18b8fbd7df5541f7$var$ie), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), o = (a = l, $18b8fbd7df5541f7$var$Ee.some((e)=>e.test(a)) ? $18b8fbd7df5541f7$var$Pe : $18b8fbd7df5541f7$var$He);
                var a;
                const s = e[1].toLowerCase(), d = -1 !== $18b8fbd7df5541f7$var$c.indexOf(s), u = {
                    attrs: q(e[2]),
                    noInnerParse: d,
                    tag: d ? s : e[1]
                };
                return t.inAnchor = t.inAnchor || "a" === s, d ? u.text = e[3] : u.children = o(n, l, t), t.inAnchor = !1, u;
            },
            render: (e, t, r)=>d(e.tag, $18b8fbd7df5541f7$var$n({
                    key: r.key
                }, e.attrs), e.text || t(e.children, r))
        },
        13: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$M),
            order: 1,
            parse: (e)=>({
                    attrs: q(e[2] || ""),
                    tag: e[1]
                }),
            render: (e, t, r)=>d(e.tag, $18b8fbd7df5541f7$var$n({}, e.attrs, {
                    key: r.key
                }))
        },
        12: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$L),
            order: 1,
            parse: ()=>({}),
            render: $18b8fbd7df5541f7$var$We
        },
        14: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$we),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $18b8fbd7df5541f7$var$Ne(e[2]),
                    title: e[3]
                }),
            render: (e, n, t)=>d("img", {
                    key: t.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: $18b8fbd7df5541f7$var$Be(e.target)
                })
        },
        15: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$Se),
            order: 3,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$De(n, e[1], t),
                    target: $18b8fbd7df5541f7$var$Ne(e[2]),
                    title: e[3]
                }),
            render: (e, n, t)=>d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(e.target),
                    title: e.title
                }, n(e.children, t))
        },
        16: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$j),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    type: "15"
                })
        },
        17: {
            match: (e, n)=>n.inAnchor ? null : $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$R)(e, n),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: "15"
                })
        },
        18: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$U),
            order: 0,
            parse (e) {
                let n = e[1], t = e[1];
                return $18b8fbd7df5541f7$var$s.test(t) || (t = "mailto:" + t), {
                    children: [
                        {
                            text: n.replace("mailto:", ""),
                            type: "27"
                        }
                    ],
                    target: t,
                    type: "15"
                };
            }
        },
        20: $18b8fbd7df5541f7$var$$e(d, 1),
        33: $18b8fbd7df5541f7$var$$e(d, 2),
        19: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$k),
            order: 3,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: ()=>"\n"
        },
        21: {
            match: $18b8fbd7df5541f7$var$je,
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("p", {
                    key: t.key
                }, n(e.children, t))
        },
        22: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$H),
            order: 0,
            parse: (e)=>(X[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $18b8fbd7df5541f7$var$We
        },
        23: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$D),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, n, t)=>d("img", {
                    key: t.key,
                    alt: e.alt,
                    src: $18b8fbd7df5541f7$var$Be(X[e.ref].target),
                    title: X[e.ref].title
                })
        },
        24: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$P),
            order: 0,
            parse: (e, n, t)=>({
                    children: n(e[1], t),
                    fallbackChildren: n(e[0].replace($18b8fbd7df5541f7$var$_, "\\$1"), t),
                    ref: e[2]
                }),
            render: (e, n, t)=>X[e.ref] ? d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(X[e.ref].target),
                    title: X[e.ref].title
                }, n(e.children, t)) : d("span", {
                    key: t.key
                }, n(e.fallbackChildren, t))
        },
        25: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$N),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Le,
            render: (e, n, t)=>d("table", {
                    key: t.key
                }, d("thead", null, d("tr", null, e.header.map(function(r, i) {
                    return d("th", {
                        key: i,
                        style: $18b8fbd7df5541f7$var$ze(e, i)
                    }, n(r, t));
                }))), d("tbody", null, e.cells.map(function(r, i) {
                    return d("tr", {
                        key: i
                    }, r.map(function(r, i) {
                        return d("td", {
                            key: i,
                            style: $18b8fbd7df5541f7$var$ze(e, i)
                        }, n(r, t));
                    }));
                })))
        },
        26: {
            match: function(e, n) {
                return n.inTable ? (n.inline = !0, $18b8fbd7df5541f7$var$G.exec(e)) : null;
            },
            order: 1,
            parse: function() {
                return {
                    type: "26"
                };
            },
            render: ()=>" | "
        },
        27: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$te),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($18b8fbd7df5541f7$var$T, (e, n)=>r.namedCodesToUnicode[n] ? r.namedCodesToUnicode[n] : e)
                }),
            render: (e)=>e.text
        },
        28: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$J),
            order: 2,
            parse: (e, n, t)=>({
                    children: n(e[2], t)
                }),
            render: (e, n, t)=>d("strong", {
                    key: t.key
                }, n(e.children, t))
        },
        29: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$K),
            order: 3,
            parse: (e, n, t)=>({
                    children: n(e[2], t)
                }),
            render: (e, n, t)=>d("em", {
                    key: t.key
                }, n(e.children, t))
        },
        30: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$ne),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: "27"
                })
        },
        31: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$Y),
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("mark", {
                    key: t.key
                }, n(e.children, t))
        },
        32: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$ee),
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("del", {
                    key: t.key
                }, n(e.children, t))
        }
    };
    !0 === r.disableParsingRawHTML && (delete Q[11], delete Q[13]);
    const le = function(e) {
        let n = Object.keys(e);
        function t(r, i) {
            let l = [], o = "";
            for(; r;){
                let c = 0;
                for(; c < n.length;){
                    const a = n[c], s = e[a], d = s.match(r, i, o);
                    if (d) {
                        const e = d[0];
                        r = r.substring(e.length);
                        const n = s.parse(d, t, i);
                        null == n.type && (n.type = a), l.push(n), o = e;
                        break;
                    }
                    c++;
                }
            }
            return l;
        }
        return n.sort(function(n, t) {
            let r = e[n].order, i = e[t].order;
            return r !== i ? r - i : 1;
        }), function(e, n) {
            return t(function(e) {
                return e.replace($18b8fbd7df5541f7$var$x, "\n").replace($18b8fbd7df5541f7$var$$, "").replace($18b8fbd7df5541f7$var$W, "    ");
            }(e), n);
        };
    }(Q), oe = (ce = function(e, n) {
        return function(t, r, i) {
            const l = e[t.type].render;
            return n ? n(()=>l(t, r, i), t, r, i) : l(t, r, i);
        };
    }(Q, r.renderRule), function e(n, t = {}) {
        if (Array.isArray(n)) {
            const r = t.key, i = [];
            let l = !1;
            for(let r = 0; r < n.length; r++){
                t.key = r;
                const o = e(n[r], t), c = "string" == typeof o;
                c && l ? i[i.length - 1] += o : null !== o && i.push(o), l = c;
            }
            return t.key = r, i;
        }
        return ce(n, e, t);
    });
    var ce;
    const ae = Z(t);
    return V.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, V.map(function(e) {
        return d("div", {
            id: r.slugify(e.identifier),
            key: e.identifier
        }, e.identifier, oe(le(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $18b8fbd7df5541f7$export$2e2bcd8739ae039 = (n)=>{
    let { children: r, options: i } = n, l = function(e, n) {
        if (null == e) return {};
        var t, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)n.indexOf(t = l[r]) >= 0 || (i[t] = e[t]);
        return i;
    }(n, $18b8fbd7df5541f7$var$t);
    return $eUqFw.cloneElement($18b8fbd7df5541f7$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("lgs87", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7b0e99e3a3aec94$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");
parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
const $f7b0e99e3a3aec94$var$listStyles = (0, $byn9U.css)({
    paddingLeft: "var(--ds-space-250, 20px)",
    paddingInlineStart: "var(--ds-space-250, 20px)"
});
const $f7b0e99e3a3aec94$var$UList = ({ children: children, ...props })=>(0, $byn9U.jsx)("ul", (0, $kU09D.default)({
        css: $f7b0e99e3a3aec94$var$listStyles
    }, props), children);
var $f7b0e99e3a3aec94$export$2e2bcd8739ae039 = $f7b0e99e3a3aec94$var$UList;

});


parcelRegister("5BHpz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4152151036933470$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3GWpI = parcelRequire("3GWpI");
const $4152151036933470$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $3GWpI.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $4152151036933470$export$2e2bcd8739ae039 = $4152151036933470$var$AIEventSummaryViewed;

});

parcelRegister("id245", function(module, exports) {

$parcel$export(module.exports, "default", () => $d41b0aef34968951$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $6BD9J = parcelRequire("6BD9J");

var $5BsbE = parcelRequire("5BsbE");
const $d41b0aef34968951$var$LOCAL_STORAGE_CLIENT_KEY = '@atlaskit/smart-card';
const $d41b0aef34968951$var$LOCAL_STORAGE_DISCOVERY_KEY = 'action-discovery-ai-summarise';
const $d41b0aef34968951$var$LOCAL_STORAGE_DISCOVERY_VALUE = 'discovered';
const $d41b0aef34968951$var$LOCAL_STORAGE_DISCOVERY_EXPIRY_IN_MS = 15552000000; // 180 days
const $d41b0aef34968951$var$LOCAL_STORAGE_DISCOVERY_REQUIRED_TIME = 2000;
/**
 * This is a hacky solution to help with the feature discovery.
 * This implementation must be removed once the experiment is completed.
 * Cleanup on https://product-fabric.atlassian.net/browse/EDM-9649
 */ const $d41b0aef34968951$var$FeatureDiscovery = ({ children: children, testId: testId })=>{
    const renderedTime = (0, $eUqFw.useRef)();
    const storageClient = (0, $eUqFw.useMemo)(()=>new (0, $6BD9J.default)($d41b0aef34968951$var$LOCAL_STORAGE_CLIENT_KEY), []);
    const discovered = (0, $eUqFw.useMemo)(()=>storageClient.getItem($d41b0aef34968951$var$LOCAL_STORAGE_DISCOVERY_KEY) === $d41b0aef34968951$var$LOCAL_STORAGE_DISCOVERY_VALUE, [
        storageClient
    ]);
    (0, $eUqFw.useEffect)(()=>{
        renderedTime.current = Date.now();
        return ()=>{
            if (!discovered && renderedTime.current) {
                const duration = Date.now() - renderedTime.current;
                if (duration > $d41b0aef34968951$var$LOCAL_STORAGE_DISCOVERY_REQUIRED_TIME) storageClient.setItemWithExpiry($d41b0aef34968951$var$LOCAL_STORAGE_DISCOVERY_KEY, $d41b0aef34968951$var$LOCAL_STORAGE_DISCOVERY_VALUE, $d41b0aef34968951$var$LOCAL_STORAGE_DISCOVERY_EXPIRY_IN_MS);
            }
        };
    }, [
        storageClient,
        discovered
    ]);
    const component = (0, $eUqFw.useMemo)(()=>{
        if (!discovered) return (0, $byn9U.jsx)("span", {
            css: (0, $5BsbE.getPulseStyles)(),
            "data-testid": `${testId}-discovery`
        }, children);
    }, [
        children,
        discovered,
        testId
    ]);
    return component !== null && component !== void 0 ? component : children;
};
var $d41b0aef34968951$export$2e2bcd8739ae039 = $d41b0aef34968951$var$FeatureDiscovery;

});
parcelRegister("5BsbE", function(module, exports) {

$parcel$export(module.exports, "getPulseStyles", () => $414645c74c5839a8$export$4c553574c9c58dea);

var $byn9U = parcelRequire("byn9U");
const $414645c74c5839a8$export$4c553574c9c58dea = ()=>{
    const color = "var(--ds-border-discovery, #8270DB)";
    const pulseKeyframes = (0, $byn9U.keyframes)({
        to: {
            boxShadow: '0 0 0 7px rgba(0, 0, 0, 0)'
        }
    });
    return (0, $byn9U.css)({
        display: 'inline-flex',
        borderRadius: '3px',
        boxShadow: `0 0 0 0 ${color}`,
        animation: `${pulseKeyframes} 2s cubic-bezier(0.5, 0, 0, 1) 0.25s both 2`
    });
};

});




parcelRegister("fvKlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4adb359849f597c$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $4UwXq = parcelRequire("4UwXq");

var $hXWLE = parcelRequire("hXWLE");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $b4adb359849f597c$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
    if (status !== (0, $hXWLE.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4UwXq.default), (0, $kU09D.default)({}, props, {
        testId: testId
    }));
};
var $b4adb359849f597c$export$2e2bcd8739ae039 = $b4adb359849f597c$var$AIFooterBlock;

});
parcelRegister("4UwXq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3935f50ce0ead2c8$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $kIvR9 = parcelRequire("kIvR9");

var $4fZpw = parcelRequire("4fZpw");

var $hXWLE = parcelRequire("hXWLE");

var $cVbmx = parcelRequire("cVbmx");

var $l8O8E = parcelRequire("l8O8E");
const $3935f50ce0ead2c8$var$AIFooterBlockResolvedView = (props)=>{
    var _context$actions;
    const context = (0, $l8O8E.useFlexibleUiContext)();
    const actionData = context === null || context === void 0 ? void 0 : (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $hXWLE.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIvR9.default), (0, $kU09D.default)({}, props, {
        testId: `${testId}-resolved-view`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4fZpw.Provider), {
        testId: `${testId}-provider`
    }), actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVbmx.AIFooterMetadata), (0, $kU09D.default)({}, actionData, {
        testId: `${testId}-ai-metadata`
    })) : null);
};
var $3935f50ce0ead2c8$export$2e2bcd8739ae039 = $3935f50ce0ead2c8$var$AIFooterBlockResolvedView;

});
parcelRegister("cVbmx", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $96839f3fc7d28c40$export$175228cc2c92b3b6);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");


var $8uD7Y = parcelRequire("8uD7Y");

var $hSQOv = parcelRequire("hSQOv");
var $6h1SY = parcelRequire("6h1SY");

var $9ZtZq = parcelRequire("9ZtZq");

var $zMcD1 = parcelRequire("zMcD1");

var $6D8aU = parcelRequire("6D8aU");

var $9Ll0U = parcelRequire("9Ll0U");
const $96839f3fc7d28c40$export$175228cc2c92b3b6 = ({ testId: testId, url: url, ari: ari, product: product })=>{
    const { state: { status: status } } = (0, $9Ll0U.useAISummary)({
        url: url,
        ari: ari,
        product: product
    });
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6h1SY.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).ai_summarized_info_short),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $zMcD1.InfoIcon), {
            label: "Information",
            size: "small",
            primaryColor: "var(--ds-icon-subtle, #626F86)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ZtZq.default), {
        label: "AI",
        size: "small",
        primaryColor: "var(--ds-icon-subtle, #626F86)"
    }));
};

});
parcelRegister("zMcD1", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $06b8a90c492d8c82$export$2957fc44b3d2481);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $06b8a90c492d8c82$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", (0, $kU09D.default)({
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
        fill: "currentColor"
    }));
const $06b8a90c492d8c82$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), (0, $kU09D.default)({}, props, {
        glyph: $06b8a90c492d8c82$var$CustomGlyph
    }));

});




parcelRegister("hHZ9y", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce45e39345243b46$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $caLW4 = parcelRequire("caLW4");

var $eUqFw = parcelRequire("eUqFw");

var $hXWLE = parcelRequire("hXWLE");

var $l8O8E = parcelRequire("l8O8E");

var $hWN7x = parcelRequire("hWN7x");

var $jvuTK = parcelRequire("jvuTK");

var $a87Vy = parcelRequire("a87Vy");

const $ce45e39345243b46$var$ignoreContainerPaddingStyles = (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    flexGrow: 1,
    width: '100%',
    // We have to find a better way to ignore container padding
    // This has become more and more of a common use case.
    marginLeft: 'calc(var(--container-gap-left) * -1)',
    marginRight: 'calc(var(--container-gap-right) * -1)'
});
const $ce45e39345243b46$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $ce45e39345243b46$var$sort = (a, b)=>{
    let idxA = $ce45e39345243b46$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $ce45e39345243b46$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $ce45e39345243b46$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $ce45e39345243b46$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $ce45e39345243b46$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, testId: testId = 'smart-block-action' })=>{
    const context = (0, $l8O8E.useFlexibleUiContext)();
    const ui = (0, $l8O8E.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $eUqFw.useState)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const onLoadingChange = (0, $eUqFw.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !(ui !== null && ui !== void 0 && ui.hidePadding) ? (0, $jvuTK.getPrimitivesPaddingSpaceBySize)((ui === null || ui === void 0 ? void 0 : ui.size) || (0, $hXWLE.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $eUqFw.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback === null || onClickCallback === void 0 || onClickCallback(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $eUqFw.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $eUqFw.useMemo)(()=>{
        if (!(context !== null && context !== void 0 && context.actions)) return;
        const arr = Object.keys(context.actions);
        arr.sort($ce45e39345243b46$var$sort);
        return arr.map((name)=>{
            const Action = name in $hWN7x ? $hWN7x[name] : undefined;
            return Action ? (0, $byn9U.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                key: name,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size,
                xcss: (0, $caLW4.xcss)({
                    paddingInline: padding
                }),
                hideTooltip: isLoading
            }) : null;
        });
    }, [
        context === null || context === void 0 ? void 0 : context.actions,
        onClick,
        onError,
        padding,
        size,
        spaceInline,
        isLoading,
        onLoadingChange
    ]);
    return actions ? (0, $byn9U.jsx)("div", {
        css: $ce45e39345243b46$var$ignoreContainerPaddingStyles,
        ref: blockRef,
        "data-testid": testId
    }, actions, (0, $byn9U.jsx)((0, $a87Vy.ActionFooter), {
        message: message,
        paddingInline: padding,
        testId: testId
    })) : null;
};
var $ce45e39345243b46$export$2e2bcd8739ae039 = $ce45e39345243b46$var$ActionBlock;

});
parcelRegister("a87Vy", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $7600ccec87034e9c$export$2d2b754ac238f9aa);

var $96IgR = parcelRequire("96IgR");

var $hSQOv = parcelRequire("hSQOv");
var $6h1SY = parcelRequire("6h1SY");
var $caLW4 = parcelRequire("caLW4");

var $eUqFw = parcelRequire("eUqFw");

var $4qRa7 = parcelRequire("4qRa7");
const $7600ccec87034e9c$var$containerStyles = (0, $caLW4.xcss)({
    all: 'unset',
    borderRadius: 'border.radius',
    margin: 'space.100',
    marginBottom: 'space.0',
    lineHeight: '20px',
    padding: 'space.075',
    paddingInline: 'space.100',
    width: '100%',
    ':empty': {
        display: 'none'
    }
});
const $7600ccec87034e9c$var$errorStyles = (0, $caLW4.xcss)({
    backgroundColor: 'color.background.danger'
});
const $7600ccec87034e9c$var$titleStyles = (0, $caLW4.xcss)({
    color: 'color.text.subtle',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '16px'
});
const $7600ccec87034e9c$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                primaryColor: "var(--ds-icon-danger, #C9372C)",
                label: "Error",
                size: "small",
                testId: "action-error-icon"
            });
        default:
            return null;
    }
};
const $7600ccec87034e9c$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), {
        testId: `${testId}-footer`,
        xcss: [
            $7600ccec87034e9c$var$containerStyles,
            message.appearance === 'error' && $7600ccec87034e9c$var$errorStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4qRa7.default), {
        isFadeIn: true,
        show: true,
        showTransition: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6h1SY.default), {
        alignBlock: "start",
        grow: "fill",
        space: "space.050"
    }, message.icon || $7600ccec87034e9c$var$getIcon(message.appearance), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), {
        xcss: $7600ccec87034e9c$var$titleStyles
    }, message.title))));
};

});







parcelRegister("32S38", function(module, exports) {

$parcel$export(module.exports, "default", () => $237b7c1e789cde1f$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $gZRuE = parcelRequire("gZRuE");

var $6D8aU = parcelRequire("6D8aU");

var $kIvR9 = parcelRequire("kIvR9");

var $ebCNT = parcelRequire("ebCNT");

var $e0BK5 = parcelRequire("e0BK5");

var $2gcbj = parcelRequire("2gcbj");

var $ezIO6 = parcelRequire("ezIO6");

var $4fZpw = parcelRequire("4fZpw");

var $hXWLE = parcelRequire("hXWLE");

var $7o9uG = parcelRequire("7o9uG");

var $akLqG = parcelRequire("akLqG");
const $237b7c1e789cde1f$var$HoverCardUnauthorisedView = ({ analytics: analytics, extensionKey: extensionKey, id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    var _cardState$details, _extractProvider;
    const { cardState: cardState } = flexibleCardProps;
    const data = (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.data;
    const providerName = (_extractProvider = (0, $ebCNT.extractProvider)(data)) === null || _extractProvider === void 0 ? void 0 : _extractProvider.text;
    const isProductIntegrationSupported = (0, $akLqG.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $7o9uG.useSmartCardActions)(id, url, analytics);
    const handleAuthorize = (0, $eUqFw.useCallback)(()=>{
        if (authorize) {
            analytics.track.appAccountAuthStarted({
                extensionKey: extensionKey
            });
            authorize((0, $hXWLE.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        extensionKey,
        analytics.track
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>[
            {
                name: (0, $hXWLE.ActionName).CustomAction,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $6D8aU.messages).connect_unauthorised_account_action, {
                    values: {
                        context: providerName
                    }
                })),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gZRuE.default), (0, $kU09D.default)({}, flexibleCardProps, {
        testId: testId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIvR9.default), {
        overrideCss: (0, $e0BK5.titleBlockStyles),
        testId: `${testId}-title`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4fZpw.LinkIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $6D8aU.messages).connect_link_account_card_name, {
        values: {
            context: providerName
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIvR9.default), {
        overrideCss: (0, $e0BK5.mainTextStyles),
        testId: `${testId}-content`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2gcbj.default), {
        providerName: providerName,
        isProductIntegrationSupported: isProductIntegrationSupported,
        analytics: analytics
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIvR9.default), {
        overrideCss: (0, $e0BK5.connectButtonStyles),
        testId: `${testId}-button`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ezIO6.default), {
        items: actions,
        appearance: "primary"
    })));
};
var $237b7c1e789cde1f$export$2e2bcd8739ae039 = $237b7c1e789cde1f$var$HoverCardUnauthorisedView;

});
parcelRegister("gZRuE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5fbd685140ecbcb$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $hXWLE = parcelRequire("hXWLE");

var $h1NLB = parcelRequire("h1NLB");

var $l8O8E = parcelRequire("l8O8E");

var $j9M0G = parcelRequire("j9M0G");

var $6y75I = parcelRequire("6y75I");
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $c5fbd685140ecbcb$var$FlexibleCard = ({ analytics: analytics, appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, renderers: renderers, showAuthTooltip: showAuthTooltip, showHoverPreview: showHoverPreview, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    var _details$meta2;
    const aiSummaryConfig = (0, $6y75I.useAISummaryConfig)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const context = (0, $eUqFw.useMemo)(()=>(0, $j9M0G.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            response: details,
            id: id,
            renderers: renderers,
            actionOptions: actionOptions,
            status: status,
            url: url
        }), [
        aiSummaryConfig,
        details,
        id,
        renderers,
        actionOptions,
        status,
        url
    ]);
    const retry = (0, $j9M0G.getRetryOptions)(url, status, details, onAuthorize);
    const { title: title } = context || {};
    const analyticsContext = (0, $eUqFw.useMemo)(()=>{
        var _details$meta;
        return analytics ? {
            ...analytics,
            display: appearance,
            extensionKey: details === null || details === void 0 ? void 0 : (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.key
        } : undefined;
    }, [
        analytics,
        appearance,
        details === null || details === void 0 ? void 0 : (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key
    ]);
    (0, $eUqFw.useEffect)(()=>{
        switch(status){
            case (0, $hXWLE.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url
                });
                break;
            case (0, $hXWLE.SmartLinkStatus).Errored:
            case (0, $hXWLE.SmartLinkStatus).Fallback:
            case (0, $hXWLE.SmartLinkStatus).Forbidden:
            case (0, $hXWLE.SmartLinkStatus).NotFound:
            case (0, $hXWLE.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l8O8E.FlexibleUiAnalyticsContext).Provider, {
        value: analyticsContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l8O8E.FlexibleUiOptionContext).Provider, {
        value: ui
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l8O8E.FlexibleUiContext).Provider, {
        value: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h1NLB.default), (0, $kU09D.default)({
        testId: testId
    }, ui, {
        onClick: onClick,
        retry: retry,
        showHoverPreview: showHoverPreview,
        actionOptions: actionOptions,
        showAuthTooltip: showAuthTooltip,
        status: status
    }), children))));
};
var $c5fbd685140ecbcb$export$2e2bcd8739ae039 = $c5fbd685140ecbcb$var$FlexibleCard;

});
parcelRegister("h1NLB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6592253e6e76201$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hXWLE = parcelRequire("hXWLE");

var $iw7Qh = parcelRequire("iw7Qh");

var $l8O8E = parcelRequire("l8O8E");

var $6tOxw = parcelRequire("6tOxw");

var $3BSBQ = parcelRequire("3BSBQ");

var $fw3yP = parcelRequire("fw3yP");

var $PdmhA = parcelRequire("PdmhA");

const $c6592253e6e76201$var$elevationStyles = (0, $byn9U.css)({
    border: `1px solid ${`var(--ds-border, ${(0, $PdmhA.N40)})`}`,
    borderRadius: "var(--ds-border-radius-200, 8px)",
    margin: "var(--ds-space-025, 2px)"
});
const $c6592253e6e76201$var$getGap = (size)=>{
    switch(size){
        case (0, $hXWLE.SmartLinkSize).XLarge:
            return '1.25rem';
        case (0, $hXWLE.SmartLinkSize).Large:
            return '1rem';
        case (0, $hXWLE.SmartLinkSize).Medium:
            return '.5rem';
        case (0, $hXWLE.SmartLinkSize).Small:
        default:
            return '.25rem';
    }
};
/**
 * Get container padding based on smart link size
 * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
 * at view/FlexibleCard/components/utils.tsx
 */ const $c6592253e6e76201$var$getPadding = (size)=>{
    switch(size){
        case (0, $hXWLE.SmartLinkSize).XLarge:
            return '1.5rem';
        case (0, $hXWLE.SmartLinkSize).Large:
            return '1.25rem';
        case (0, $hXWLE.SmartLinkSize).Medium:
            return '1rem';
        case (0, $hXWLE.SmartLinkSize).Small:
        default:
            return '.5rem';
    }
};
const $c6592253e6e76201$var$clickableContainerStyles = (0, $byn9U.css)({
    'a, button, .has-action': {
        position: 'relative',
        zIndex: 1
    }
});
const $c6592253e6e76201$var$getContainerPaddingStyles = (size, hidePadding, childrenOptions)=>{
    const padding = hidePadding ? '0rem' : $c6592253e6e76201$var$getPadding(size);
    const gap = $c6592253e6e76201$var$getGap(size);
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = childrenOptions;
    return (0, $byn9U.css)({
        '--container-padding': padding,
        '--container-gap-left': previewOnLeft ? gap : padding,
        '--container-gap-right': previewOnRight ? gap : padding,
        '--preview-block-width': '30%',
        padding: padding
    }, previewOnLeft ? `padding-left: calc(var(--preview-block-width) + ${gap});` : '', previewOnRight ? `padding-right: calc(var(--preview-block-width) + ${gap});` : '');
};
const $c6592253e6e76201$var$getChildrenOptions = (children, context)=>{
    let options = {};
    if ((0, $fw3yP.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child)) {
            if ((0, $iw7Qh.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $hXWLE.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $hXWLE.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $c6592253e6e76201$export$8947b11ec08f5f9d = (size, hideBackground, hideElevation, hidePadding, clickableContainer, childrenOptions)=>{
    const paddingCss = $c6592253e6e76201$var$getContainerPaddingStyles(size, hidePadding, childrenOptions);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return (0, $byn9U.css)`
    display: flex;
    gap: ${$c6592253e6e76201$var$getGap(size)} 0;
    flex-direction: column;
    min-width: 0;
    overflow-x: hidden;
    position: relative;
    ${hideBackground ? '' : `background-color: ${"var(--ds-surface-raised, #FFFFFF)"};`}
    ${paddingCss}
    ${hideElevation ? '' : $c6592253e6e76201$var$elevationStyles}
    ${clickableContainer ? $c6592253e6e76201$var$clickableContainerStyles : ''}
    &:hover ~ .actions-button-group {
      opacity: 1;
    }
    a:focus,
    .has-action:focus {
      outline-offset: -2px;
    }
  `;
};
const $c6592253e6e76201$var$renderChildren = (children, containerSize, containerTheme, status, retry, onClick)=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (child)=>{
        // TODO: EDM-6468: Use useFlexibleUiOptionContext for rendering options inside block/element instead
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child) && (0, $iw7Qh.isFlexibleUiBlock)(child)) {
            const { size: blockSize } = child.props;
            const size = blockSize || containerSize;
            if ((0, $iw7Qh.isFlexibleUiTitleBlock)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                onClick: // @ts-expect-error
                onClick,
                retry: retry,
                size: size,
                status: status,
                theme: containerTheme
            });
            // @ts-expect-error
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                size: size,
                status: status
            });
        }
    });
const $c6592253e6e76201$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).find((child)=>(0, $iw7Qh.isFlexibleUiTitleBlock)(child));
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(block)) return block.props;
};
const $c6592253e6e76201$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { title: title, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $c6592253e6e76201$var$getTitleBlockProps(children) || {};
    return (0, $byn9U.jsx)((0, $6tOxw.default), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || title,
        url: url
    });
};
/**
 * A container is a hidden component that build the Flexible Smart Link.
 * All the Flexible UI components are wrapped inside the container.
 * It inherits the ui props from Card component and applies the custom styling
 * accordingly.
 * @internal
 * @see Block
 */ const $c6592253e6e76201$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hideHoverCardPreviewButton: hideHoverCardPreviewButton = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showAuthTooltip: showAuthTooltip = false, showHoverPreview: showHoverPreview = false, actionOptions: actionOptions, size: size = (0, $hXWLE.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container', theme: theme = (0, $hXWLE.SmartLinkTheme).Link })=>{
    const context = (0, $eUqFw.useContext)((0, $l8O8E.FlexibleUiContext));
    const childrenOptions = $c6592253e6e76201$var$getChildrenOptions(children, context);
    const canShowHoverPreview = showHoverPreview && status === 'resolved';
    // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showAuthTooltip && status === 'unauthorized' && retry !== undefined;
    const container = (0, $byn9U.jsx)("div", {
        css: $c6592253e6e76201$export$8947b11ec08f5f9d(size, hideBackground, hideElevation, hidePadding, clickableContainer, childrenOptions),
        "data-smart-link-container": true,
        "data-testid": testId
    }, clickableContainer ? $c6592253e6e76201$var$getLayeredLink(testId, context, children, onClick) : null, $c6592253e6e76201$var$renderChildren(children, size, theme, status, retry, onClick));
    if (context !== null && context !== void 0 && context.url && (canShowHoverPreview || canShowAuthTooltip)) return (0, $byn9U.jsx)((0, $3BSBQ.default), {
        hideHoverCardPreviewButton: hideHoverCardPreviewButton,
        isHoverPreview: canShowHoverPreview,
        isAuthTooltip: canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url
    }, container);
    return container;
};
var $c6592253e6e76201$export$2e2bcd8739ae039 = $c6592253e6e76201$var$Container;

});
parcelRegister("6tOxw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b7ca7a553e20ae1$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hnYQo = parcelRequire("hnYQo");
const $4b7ca7a553e20ae1$var$styles = (0, $byn9U.css)({
    // Stretch the invisible link over the whole of the post.
    // Hide the link’s text.
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: 'hidden',
    textIndent: '100%',
    whiteSpace: 'nowrap',
    // Needs a heightened specificity to trump other anchor.
    // Stack it under all other links in the post text.
    'a&.layered-link': {
        position: 'absolute',
        zIndex: 0
    },
    // When hovering over the layered link, any hidden action buttons inside
    // the Container should become visible.
    // As actions resides inside blocks and layered link is expected to be
    // on the same level of blocks. That makes the blocks, e.g. TitleBlock,
    // its sibling. Using general sibling combinator here to apply styling to
    // all the siblings of layered link.
    // The general sibling combinator (~) separates two selectors and matches all
    // iterations of the second element, that are following the first element
    // (though not necessarily immediately), and are children of the same parent
    // element.
    '&:hover ~ *': {
        '.actions-button-group': {
            opacity: 1
        }
    }
});
/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */ const $4b7ca7a553e20ae1$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $hnYQo.useMouseDownEvent)();
    return (0, $byn9U.jsx)("a", {
        className: "layered-link",
        css: $4b7ca7a553e20ae1$var$styles,
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target,
        tabIndex: -1 // Hide tab index and let the title link be the link.
    }, text);
};
var $4b7ca7a553e20ae1$export$2e2bcd8739ae039 = $4b7ca7a553e20ae1$var$LayeredLink;

});

parcelRegister("3BSBQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a0f3013fafc9689$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJ8Hj = parcelRequire("iJ8Hj");

var $hXWLE = parcelRequire("hXWLE");
const $2a0f3013fafc9689$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $2a0f3013fafc9689$var$HoverCardControl = ({ children: children, hideHoverCardPreviewButton: hideHoverCardPreviewButton, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $2a0f3013fafc9689$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY })=>{
    const [canOpen, setCanOpen] = (0, $eUqFw.useState)(true);
    const mouseStopTimer = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $eUqFw.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $eUqFw.useCallback)((e)=>{
        var _e$target$closest;
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || ((_e$target$closest = e.target.closest('[data-smart-link-container]')) === null || _e$target$closest === void 0 ? void 0 : _e$target$closest.querySelector('[data-action-open="true"]'));
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $hXWLE.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJ8Hj.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        hidePreviewButton: hideHoverCardPreviewButton,
        actionOptions: actionOptions,
        url: url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        "data-testid": `${testId}-hover-card-wrapper`
    }, children));
};
var $2a0f3013fafc9689$export$2e2bcd8739ae039 = $2a0f3013fafc9689$var$HoverCardControl;

});

parcelRegister("fw3yP", function(module, exports) {

$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $b4bc9b3d6dae499e$export$783c1bf8fee63f80);
/**
 * Returns true if preview data is available in the FlexibleUiDataContext
 * @param context is the FlexibleUiDataContext
 */ const $b4bc9b3d6dae499e$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});


parcelRegister("j9M0G", function(module, exports) {

$parcel$export(module.exports, "getContextByStatus", () => $df24196063a9a032$export$e68aec76e359e401);
$parcel$export(module.exports, "getRetryOptions", () => $df24196063a9a032$export$f3d3482baaff4bf6);

var $hXWLE = parcelRequire("hXWLE");

var $ji7R0 = parcelRequire("ji7R0");

var $hTFR7 = parcelRequire("hTFR7");

var $6D8aU = parcelRequire("6D8aU");

var $gnKCv = parcelRequire("gnKCv");

var $90Km0 = parcelRequire("90Km0");

var $6MLxR = parcelRequire("6MLxR");

var $ebCNT = parcelRequire("ebCNT");

var $3I5bt = parcelRequire("3I5bt");

var $jeta8 = parcelRequire("jeta8");
const $df24196063a9a032$export$e68aec76e359e401 = (params)=>{
    const { response: response, status: status, url: url } = params !== null && params !== void 0 ? params : {};
    switch(status){
        case (0, $hXWLE.SmartLinkStatus).Pending:
        case (0, $hXWLE.SmartLinkStatus).Resolving:
            return {
                title: url,
                url: url
            };
        case (0, $hXWLE.SmartLinkStatus).Resolved:
            return (0, $gnKCv.default)(params);
        case (0, $hXWLE.SmartLinkStatus).Unauthorized:
        case (0, $hXWLE.SmartLinkStatus).Forbidden:
        case (0, $hXWLE.SmartLinkStatus).NotFound:
        case (0, $hXWLE.SmartLinkStatus).Errored:
        case (0, $hXWLE.SmartLinkStatus).Fallback:
        default:
            const preview = (0, $jeta8.default)(response === null || response === void 0 ? void 0 : response.data);
            const linkIcon = (0, $90Km0.extractErrorIcon)(response, status);
            const provider = (0, $3I5bt.default)(response === null || response === void 0 ? void 0 : response.data);
            return {
                linkIcon: linkIcon,
                title: url,
                url: url,
                provider: provider,
                preview: preview
            };
    }
};
const $df24196063a9a032$var$getForbiddenMessageKey = (meta)=>{
    var _meta$requestAccess;
    const accessType = meta === null || meta === void 0 ? void 0 : (_meta$requestAccess = meta.requestAccess) === null || _meta$requestAccess === void 0 ? void 0 : _meta$requestAccess.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return 'join_to_view';
        case 'REQUEST_ACCESS':
            return 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $df24196063a9a032$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    var _response$meta, _access$action, _access$buttonDisable;
    const data = response && response.data || (0, $ji7R0.getEmptyJsonLd)();
    const provider = (0, $ebCNT.extractProvider)(data);
    const context = provider === null || provider === void 0 ? void 0 : provider.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $hXWLE.SmartLinkStatus).Forbidden:
            const meta = (_response$meta = response === null || response === void 0 ? void 0 : response.meta) !== null && _response$meta !== void 0 ? _response$meta : (0, $ji7R0.getForbiddenJsonLd)().meta;
            const access = (0, $hTFR7.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context !== null && context !== void 0 ? context : ''
            });
            const messageKey = $df24196063a9a032$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $6D8aU.messages)[messageKey];
            const retry = onAuthorize || (access === null || access === void 0 ? void 0 : (_access$action = access.action) === null || _access$action === void 0 ? void 0 : _access$action.promise);
            const onClick = retry && !((_access$buttonDisable = access === null || access === void 0 ? void 0 : access.buttonDisabled) !== null && _access$buttonDisable !== void 0 ? _access$buttonDisable : false) ? (0, $6MLxR.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $hXWLE.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $6D8aU.messages).connect_link_account_card_name,
                onClick: (0, $6MLxR.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $hXWLE.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $6D8aU.messages).cannot_find_link
            };
    }
};

});
parcelRegister("hTFR7", function(module, exports) {

$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $d0780a654918db83$export$846c1540a86749e6);

var $6D8aU = parcelRequire("6D8aU");

var $jcviT = parcelRequire("jcviT");

var $husW0 = parcelRequire("husW0");

var $iDnwt = parcelRequire("iDnwt");
const $d0780a654918db83$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    var _jsonLd$requestAccess;
    const requestAccess = jsonLd !== null && jsonLd !== void 0 && jsonLd.requestAccess ? {
        ...jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.requestAccess,
        hostname: (0, $husW0.default)(url)
    } : undefined;
    switch(jsonLd === null || jsonLd === void 0 ? void 0 : (_jsonLd$requestAccess = jsonLd.requestAccess) === null || _jsonLd$requestAccess === void 0 ? void 0 : _jsonLd$requestAccess.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $jcviT.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $iDnwt.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $6D8aU.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $jcviT.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $iDnwt.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $6D8aU.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $jcviT.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $6D8aU.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if ((jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.visibility) === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $jcviT.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $iDnwt.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $6D8aU.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("jcviT", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $dfa76b980ec9f549$export$59f8830fb5467e35);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $6D8aU = parcelRequire("6D8aU");
const $dfa76b980ec9f549$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $6D8aU.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, message, {
            values: values
        })),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("husW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbbbaed0cc3fb028$export$2e2bcd8739ae039);
const $cbbbaed0cc3fb028$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $cbbbaed0cc3fb028$export$2e2bcd8739ae039 = $cbbbaed0cc3fb028$var$extractHostname;

});



parcelRegister("6y75I", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $4c4b6b3173555c19$export$4480af2c00aa7ebe);

var $gqldc = parcelRequire("gqldc");

var $eUqFw = parcelRequire("eUqFw");
const $4c4b6b3173555c19$export$4480af2c00aa7ebe = ()=>{
    const { product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $gqldc.useSmartLinkContext)();
    return (0, $eUqFw.useMemo)(()=>({
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("e0BK5", function(module, exports) {

$parcel$export(module.exports, "connectButtonStyles", () => $a32e579cd85d8532$export$e63cb455d3692ef0);
$parcel$export(module.exports, "titleBlockStyles", () => $a32e579cd85d8532$export$38125fa6916f5dab);
$parcel$export(module.exports, "mainTextStyles", () => $a32e579cd85d8532$export$a8a26925e3db0ef6);

var $byn9U = parcelRequire("byn9U");
const $a32e579cd85d8532$var$blockGap = '0.5rem';
const $a32e579cd85d8532$var$iconGap = '0.5rem';
const $a32e579cd85d8532$var$titleFontWeight = '500';
const $a32e579cd85d8532$export$e63cb455d3692ef0 = (0, $byn9U.css)({
    justifyContent: 'flex-end',
    marginTop: $a32e579cd85d8532$var$blockGap
});
const $a32e579cd85d8532$export$38125fa6916f5dab = (0, $byn9U.css)({
    gap: `${$a32e579cd85d8532$var$blockGap} ${$a32e579cd85d8532$var$iconGap}`,
    a: {
        fontWeight: $a32e579cd85d8532$var$titleFontWeight
    }
});
const $a32e579cd85d8532$export$a8a26925e3db0ef6 = (0, $byn9U.css)({
    marginTop: $a32e579cd85d8532$var$blockGap,
    fontSize: '0.75rem'
});

});

parcelRegister("2gcbj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a568662c8778d9f$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $6D8aU = parcelRequire("6D8aU");

var $hXWLE = parcelRequire("hXWLE");
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $1a568662c8778d9f$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content', analytics: analytics })=>{
    const handleLearnMoreClick = (0, $eUqFw.useCallback)(()=>{
        analytics === null || analytics === void 0 || analytics.ui.learnMoreClickedEvent();
    }, [
        analytics === null || analytics === void 0 ? void 0 : analytics.ui
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $6D8aU.messages).learn_more_about_connecting_account : (0, $6D8aU.messages).learn_more_about_smart_links;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, providerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $6D8aU.messages).connect_unauthorised_account_description, {
        values: {
            context: providerName
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).connect_unauthorised_account_description_no_provider), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: isProductIntegrationSupported ? (0, $hXWLE.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $hXWLE.CONTENT_URL_SECURITY_AND_PERMISSIONS),
        target: "_blank",
        "data-testid": `${testId}-learn-more`,
        onClick: handleLearnMoreClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), learnMoreMessage)));
};
var $1a568662c8778d9f$export$2e2bcd8739ae039 = $1a568662c8778d9f$var$UnauthorisedViewContent;

});


parcelRegister("fCoSP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5edb4f59e1d24f6$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $hXWLE = parcelRequire("hXWLE");

var $5nprK = parcelRequire("5nprK");
var $kIvR9 = parcelRequire("kIvR9");
var $ieckM = parcelRequire("ieckM");
var $8W7kC = parcelRequire("8W7kC");
var $6qazR = parcelRequire("6qazR");
var $kkrAF = parcelRequire("kkrAF");
var $1EbMw = parcelRequire("1EbMw");

var $7U5kD = parcelRequire("7U5kD");

var $gZRuE = parcelRequire("gZRuE");

var $1GraG = parcelRequire("1GraG");

var $04W9S = parcelRequire("04W9S");

var $6D8aU = parcelRequire("6D8aU");

var $8uD7Y = parcelRequire("8uD7Y");

var $XHGTv = parcelRequire("XHGTv");

var $akLqG = parcelRequire("akLqG");

var $9Ll0U = parcelRequire("9Ll0U");

var $1qrFi = parcelRequire("1qrFi");
var $lnW6z = parcelRequire("lnW6z");

var $gqldc = parcelRequire("gqldc");

const $b5edb4f59e1d24f6$export$c2949e393fa25b77 = (cardActions, onActionClick)=>{
    const followAction = {
        hideIcon: true,
        name: (0, $hXWLE.ActionName).FollowAction
    };
    const actions = cardActions.map((action)=>{
        if (action.id === 'preview-content') return {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6D8aU.messages).preview_improved),
            name: (0, $hXWLE.ActionName).CustomAction,
            onClick: ()=>{
                if (onActionClick) onActionClick(action.id);
                return action.invoke();
            },
            testId: action.id,
            appearance: 'primary'
        };
        return {
            content: action.text,
            name: (0, $hXWLE.ActionName).CustomAction,
            onClick: ()=>{
                if (onActionClick) onActionClick(action.id);
                return action.invoke();
            },
            testId: action.id
        };
    });
    return [
        followAction,
        ...actions
    ];
};
//This component encapsulates useAISummary hook under the AI Summary FF 'platform.linking-platform.smart-card.hover-card-ai-summaries'
const $b5edb4f59e1d24f6$var$ConnectedAIBlock = ({ bottomPrimary: bottomPrimary, imagePreview: imagePreview, data: data })=>{
    const dataUrl = data ? (0, $lnW6z.extractLink)(data) : null;
    const dataAri = data ? (0, $1qrFi.extractAri)(data) : null;
    const { product: product, connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const { state: { status: status, content: content } } = (0, $9Ll0U.useAISummary)({
        url: dataUrl || '',
        ari: dataAri || '',
        product: product,
        envKey: connections.client.envKey,
        baseUrl: connections.client.baseUrlOverride
    });
    const showData = status === 'ready' || status === 'error' || // Description & bottom metadata should only disappear when we start getting summary content
    !content && status === 'loading';
    return showData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !imagePreview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kkrAF.default), {
        testId: 'connected-AI',
        status: (0, $hXWLE.SmartLinkStatus).Resolved
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8W7kC.default), {
        primary: bottomPrimary,
        size: (0, $hXWLE.SmartLinkSize).Large,
        overrideCss: (0, $7U5kD.metadataBlockCss),
        maxLines: 1,
        status: (0, $hXWLE.SmartLinkStatus).Resolved
    })) : null;
};
const $b5edb4f59e1d24f6$var$HoverCardResolvedView = ({ flexibleCardProps: flexibleCardProps, titleBlockProps: titleBlockProps, analytics: analytics, cardState: cardState, cardActions: cardActions = [], isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, extensionKey: extensionKey, url: url })=>{
    var _cardState$details;
    const canBeDatasource = (0, $akLqG.getCanBeDatasource)(cardState.details);
    (0, $eUqFw.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        analytics.ui.renderSuccessEvent({
            display: (0, $hXWLE.CardDisplay).HoverCardPreview,
            status: cardState.status,
            canBeDatasource: canBeDatasource
        });
    }, [
        analytics.ui,
        cardState.status,
        canBeDatasource
    ]);
    const footerActions = (0, $eUqFw.useMemo)(()=>$b5edb4f59e1d24f6$export$c2949e393fa25b77(cardActions, onActionClick), [
        cardActions,
        onActionClick
    ]);
    const data = (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.data;
    const { primary: primary, secondary: secondary, tertiary: tertiary } = (0, $eUqFw.useMemo)(()=>{
        return (0, $1GraG.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(0);
    const snippetBlockRef = (0, $eUqFw.useRef)(null);
    const onSnippetRender = (0, $eUqFw.useCallback)(()=>{
        var _snippetBlockRef$curr, _snippetBlockRef$curr2;
        snippetHeight.current = (_snippetBlockRef$curr = (_snippetBlockRef$curr2 = snippetBlockRef.current) === null || _snippetBlockRef$curr2 === void 0 ? void 0 : _snippetBlockRef$curr2.getBoundingClientRect().height) !== null && _snippetBlockRef$curr !== void 0 ? _snippetBlockRef$curr : 0;
    }, []);
    // We want to maintain the height of the HoverCard while summarizing and pass this height to the AISummaryBlock.
    // This approach will prevent any abrupt changes in the height of the HoverCard.
    const connectedAIBlockHeight = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(0);
    const connectedAIBlockRef = (0, $eUqFw.useRef)(null);
    const onConnectedAIBlockRender = (0, $eUqFw.useCallback)(()=>{
        var _connectedAIBlockRef$, _connectedAIBlockRef$2;
        connectedAIBlockHeight.current = (_connectedAIBlockRef$ = (_connectedAIBlockRef$2 = connectedAIBlockRef.current) === null || _connectedAIBlockRef$2 === void 0 ? void 0 : _connectedAIBlockRef$2.getBoundingClientRect().height) !== null && _connectedAIBlockRef$ !== void 0 ? _connectedAIBlockRef$ : 0;
    }, []);
    const imagePreview = (0, $04W9S.default)({
        data: data,
        fallbackElementHeight: snippetHeight.current
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gZRuE.default), flexibleCardProps, imagePreview, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1EbMw.default), (0, $kU09D.default)({}, titleBlockProps, {
        metadataPosition: (0, $hXWLE.SmartLinkPosition).Top
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8W7kC.default), {
        primary: primary,
        secondary: secondary,
        overrideCss: (0, $7U5kD.metadataBlockCss),
        maxLines: 1,
        size: (0, $hXWLE.SmartLinkSize).Medium
    }), isAISummaryEnabled && /*#__PURE__*/ // All custom elements should be contained within a CustomBlock.
    // Flex Container components check whether the direct child is a flex blocks. It removes anything that isn't
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIvR9.default), {
        direction: (0, $hXWLE.SmartLinkDirection).Vertical,
        onRender: onConnectedAIBlockRender,
        blockRef: connectedAIBlockRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5edb4f59e1d24f6$var$ConnectedAIBlock, {
        imagePreview: !!imagePreview,
        bottomPrimary: tertiary,
        data: data
    })), !isAISummaryEnabled && !imagePreview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kkrAF.default), {
        status: (0, $hXWLE.SmartLinkStatus).Resolved
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kkrAF.default), {
        testId: 'hidden-snippet',
        onRender: onSnippetRender,
        blockRef: snippetBlockRef,
        overrideCss: (0, $7U5kD.hiddenSnippetStyles)
    }), !isAISummaryEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8W7kC.default), {
        primary: tertiary,
        size: (0, $hXWLE.SmartLinkSize).Large,
        overrideCss: (0, $7U5kD.metadataBlockCss),
        maxLines: 1,
        status: (0, $hXWLE.SmartLinkStatus).Resolved
    }), (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.enable-hover-card-related-urls') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6qazR.default), {
        url: url,
        size: (0, $hXWLE.SmartLinkSize).Small
    }), isAISummaryEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5nprK.default), {
        metadata: [
            {
                name: (0, $hXWLE.ElementName).Provider
            }
        ],
        actions: footerActions,
        aiSummaryMinHeight: connectedAIBlockHeight.current
    }), !isAISummaryEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ieckM.default), {
        actions: footerActions,
        size: (0, $hXWLE.SmartLinkSize).Large,
        overrideCss: (0, $7U5kD.footerBlockCss)
    }));
};
var $b5edb4f59e1d24f6$export$2e2bcd8739ae039 = $b5edb4f59e1d24f6$var$HoverCardResolvedView;

});
parcelRegister("7U5kD", function(module, exports) {

$parcel$export(module.exports, "metadataBlockCss", () => $5c11e62cf1f9c856$export$6d2a8e6ec8eaf792);
$parcel$export(module.exports, "footerBlockCss", () => $5c11e62cf1f9c856$export$1ede44d22c218cc4);
$parcel$export(module.exports, "hiddenSnippetStyles", () => $5c11e62cf1f9c856$export$a0cfecf316f11fd2);

var $byn9U = parcelRequire("byn9U");

var $8xp05 = parcelRequire("8xp05");
const $5c11e62cf1f9c856$var$elementGap = '0.5rem';
const $5c11e62cf1f9c856$export$6d2a8e6ec8eaf792 = (0, $byn9U.css)`
  gap: 0px;
  /* primary element group */
  [data-smart-element-group]:nth-of-type(1) {
    flex-grow: 7;

    // a separator between text-based element
    ${(0, $8xp05.separatorCss)}

    /* horizontal spacing between elements in group */
    > span {
      margin-right: ${$5c11e62cf1f9c856$var$elementGap};
    }
  }
  /* secondary element group */
  [data-smart-element-group]:nth-of-type(2) {
    flex-grow: 3;
    /* horizontal spacing between elements in group */
    > span {
      margin-left: ${$5c11e62cf1f9c856$var$elementGap};
    }
  }

  [data-smart-element-group] {
    line-height: 1rem;
  }
`;
const $5c11e62cf1f9c856$export$1ede44d22c218cc4 = (0, $byn9U.css)({
    height: '1.5rem'
});
const $5c11e62cf1f9c856$export$a0cfecf316f11fd2 = (0, $byn9U.css)({
    visibility: 'hidden',
    position: 'absolute'
});

});

parcelRegister("04W9S", function(module, exports) {

$parcel$export(module.exports, "default", () => $00ed7ce081611e8c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jeta8 = parcelRequire("jeta8");

var $iIBcb = parcelRequire("iIBcb");

var $8xp05 = parcelRequire("8xp05");
const $00ed7ce081611e8c$var$ImagePreview = ({ data: data, fallbackElementHeight: fallbackElementHeight })=>{
    const transitionStarted = (0, $eUqFw.useRef)(false);
    const previewBlockRef = (0, $eUqFw.useRef)(null);
    const [showPreview, setShowPreview] = (0, $eUqFw.useState)(true);
    const [previewCss, setPreviewCss] = (0, $eUqFw.useState)();
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $eUqFw.useCallback)(()=>{
        var _previewBlockRef$curr;
        previewBlockRef.current && setPreviewCss((0, $8xp05.getPreviewBlockStyles)((_previewBlockRef$curr = previewBlockRef.current) === null || _previewBlockRef$curr === void 0 ? void 0 : _previewBlockRef$curr.getBoundingClientRect().height));
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $eUqFw.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setPreviewCss((0, $8xp05.getTransitionStyles)(fallbackElementHeight));
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $eUqFw.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && data && (0, $jeta8.default)(data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iIBcb.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        overrideCss: previewCss,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender
    }) : null;
};
var $00ed7ce081611e8c$export$2e2bcd8739ae039 = $00ed7ce081611e8c$var$ImagePreview;

});


parcelRegister("eZqL0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae9b849f67026939$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $hXWLE = parcelRequire("hXWLE");

var $akLqG = parcelRequire("akLqG");

var $gZRuE = parcelRequire("gZRuE");

var $hHZ9y = parcelRequire("hHZ9y");
var $fvKlq = parcelRequire("fvKlq");
var $5nprK = parcelRequire("5nprK");
var $8W7kC = parcelRequire("8W7kC");
var $kkrAF = parcelRequire("kkrAF");
var $1EbMw = parcelRequire("1EbMw");

var $1GraG = parcelRequire("1GraG");

var $04W9S = parcelRequire("04W9S");

var $7U5kD = parcelRequire("7U5kD");
const $ae9b849f67026939$var$HoverCardResolvedView = ({ analytics: analytics, cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps })=>{
    var _cardState$details;
    const canBeDatasource = (0, $akLqG.getCanBeDatasource)(cardState.details);
    (0, $eUqFw.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        analytics.ui.renderSuccessEvent({
            display: (0, $hXWLE.CardDisplay).HoverCardPreview,
            status: cardState.status,
            canBeDatasource: canBeDatasource
        });
    }, [
        analytics.ui,
        cardState.status,
        canBeDatasource
    ]);
    const data = (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.data;
    const { primary: primary, secondary: secondary } = (0, $eUqFw.useMemo)(()=>{
        return (0, $1GraG.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(0);
    const snippetBlockRef = (0, $eUqFw.useRef)(null);
    const onSnippetRender = (0, $eUqFw.useCallback)(()=>{
        var _snippetBlockRef$curr, _snippetBlockRef$curr2;
        snippetHeight.current = (_snippetBlockRef$curr = (_snippetBlockRef$curr2 = snippetBlockRef.current) === null || _snippetBlockRef$curr2 === void 0 ? void 0 : _snippetBlockRef$curr2.getBoundingClientRect().height) !== null && _snippetBlockRef$curr !== void 0 ? _snippetBlockRef$curr : 0;
    }, []);
    const imagePreview = (0, $04W9S.default)({
        data: data,
        fallbackElementHeight: snippetHeight.current
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kkrAF.default), {
        status: (0, $hXWLE.SmartLinkStatus).Resolved
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gZRuE.default), flexibleCardProps, imagePreview, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1EbMw.default), (0, $kU09D.default)({}, titleBlockProps, {
        metadataPosition: (0, $hXWLE.SmartLinkPosition).Top
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8W7kC.default), {
        primary: primary,
        secondary: secondary,
        overrideCss: (0, $7U5kD.metadataBlockCss),
        maxLines: 1,
        size: (0, $hXWLE.SmartLinkSize).Medium
    }), isAISummaryEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5nprK.default), {
        aiSummaryMinHeight: aiSummaryMinHeight,
        placeholder: snippet,
        status: (0, $hXWLE.SmartLinkStatus).Resolved
    }) : snippet, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kkrAF.default), {
        testId: "hidden-snippet",
        onRender: onSnippetRender,
        blockRef: snippetBlockRef,
        overrideCss: (0, $7U5kD.hiddenSnippetStyles)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hHZ9y.default), {
        onClick: onActionClick,
        spaceInline: "space.100"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fvKlq.default), null));
};
var $ae9b849f67026939$export$2e2bcd8739ae039 = $ae9b849f67026939$var$HoverCardResolvedView;

});

parcelRegister("b0pSL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8033c57af5e36b62$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $gZRuE = parcelRequire("gZRuE");

var $6D8aU = parcelRequire("6D8aU");

var $kIvR9 = parcelRequire("kIvR9");
var $iIBcb = parcelRequire("iIBcb");

var $7u4fN = parcelRequire("7u4fN");

var $ebCNT = parcelRequire("ebCNT");

var $5smv3 = parcelRequire("5smv3");

var $8xp05 = parcelRequire("8xp05");

var $hTFR7 = parcelRequire("hTFR7");

var $husW0 = parcelRequire("husW0");

var $bFzGY = parcelRequire("bFzGY");
const $8033c57af5e36b62$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    var _cardState$details, _cardState$details2, _extractProvider$text, _extractProvider, _extractRequestAccess;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const data = (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.data;
    const meta = (_cardState$details2 = cardState.details) === null || _cardState$details2 === void 0 ? void 0 : _cardState$details2.meta;
    const product = (_extractProvider$text = (_extractProvider = (0, $ebCNT.extractProvider)(data)) === null || _extractProvider === void 0 ? void 0 : _extractProvider.text) !== null && _extractProvider$text !== void 0 ? _extractProvider$text : '';
    const hostname = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, (0, $husW0.default)(url));
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (_extractRequestAccess = (0, $hTFR7.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    })) !== null && _extractRequestAccess !== void 0 ? _extractRequestAccess : {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gZRuE.default), (0, $kU09D.default)({}, flexibleCardProps, {
        testId: testId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iIBcb.default), {
        ignoreContainerPadding: true,
        overrideCss: (0, $8xp05.getPreviewBlockStyles)(),
        testId: testId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIvR9.default), {
        overrideCss: (0, $5smv3.titleBlockStyles),
        testId: `${testId}-title`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $6D8aU.messages)[titleMessageKey], {
        values: {
            product: product
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIvR9.default), {
        overrideCss: (0, $5smv3.mainTextStyles),
        testId: `${testId}-content`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $6D8aU.messages)[descriptiveMessageKey], {
        values: {
            product: product,
            hostname: hostname
        }
    }))), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIvR9.default), {
        overrideCss: (0, $5smv3.connectButtonStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: `${testId}-button`,
        onClick: action === null || action === void 0 ? void 0 : action.promise,
        appearance: "primary",
        isDisabled: buttonDisabled
    }, action === null || action === void 0 ? void 0 : action.text)));
};
var $8033c57af5e36b62$export$2e2bcd8739ae039 = $8033c57af5e36b62$var$HoverCardForbiddenView;

});
parcelRegister("5smv3", function(module, exports) {

$parcel$export(module.exports, "titleBlockStyles", () => $3f91054cab6726c9$export$38125fa6916f5dab);
$parcel$export(module.exports, "mainTextStyles", () => $3f91054cab6726c9$export$a8a26925e3db0ef6);
$parcel$export(module.exports, "connectButtonStyles", () => $3f91054cab6726c9$export$e63cb455d3692ef0);

var $byn9U = parcelRequire("byn9U");
const $3f91054cab6726c9$var$titleFontWeight = '600';
const $3f91054cab6726c9$export$38125fa6916f5dab = (0, $byn9U.css)({
    justifyContent: 'center',
    fontWeight: $3f91054cab6726c9$var$titleFontWeight,
    marginTop: "var(--ds-space-100, 8px)"
});
const $3f91054cab6726c9$export$a8a26925e3db0ef6 = (0, $byn9U.css)({
    display: 'inline',
    justifyContent: 'center',
    marginTop: "var(--ds-space-0, 0px)",
    fontSize: '0.75rem',
    textAlign: 'center'
});
const $3f91054cab6726c9$export$e63cb455d3692ef0 = (0, $byn9U.css)({
    justifyContent: 'center',
    marginTop: "var(--ds-space-100, 8px)"
});

});


parcelRegister("gIGZ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2c21959fbd67e57$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $8xp05 = parcelRequire("8xp05");

var $iuqLa = parcelRequire("iuqLa");

var $i7Kae = parcelRequire("i7Kae");

var $9Ll0U = parcelRequire("9Ll0U");

var $fMym1 = parcelRequire("fMym1");

var $gqldc = parcelRequire("gqldc");

var $1qrFi = parcelRequire("1qrFi");
var $lnW6z = parcelRequire("lnW6z");

const $c2c21959fbd67e57$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    var _cardState$details;
    const cardState = (0, $fMym1.useSmartCardState)(url);
    const data = cardState === null || cardState === void 0 ? void 0 : (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.data;
    //The data is undefined while the link is resolving.
    const dataUrl = data ? (0, $lnW6z.extractLink)(data) : null;
    const dataAri = data ? (0, $1qrFi.extractAri)(data) : null;
    const { product: product, connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const { state: { status: status } } = (0, $9Ll0U.useAISummary)({
        url: dataUrl || '',
        ari: dataAri || '',
        product: product,
        envKey: connections.client.envKey,
        baseUrl: connections.client.baseUrlOverride
    });
    const [showPrism, setShowPrism] = (0, $eUqFw.useState)(status === 'loading');
    (0, $eUqFw.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        className: (0, $i7Kae.hoverCardClassName),
        css: [
            (0, $8xp05.HoverCardContainer),
            !isAIEnabled ? (0, $8xp05.popupContainerStyles) : undefined
        ],
        "data-testid": testId
    }, props), children);
    return isAIEnabled ? (0, $byn9U.jsx)((0, $iuqLa.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`
    }, container) : container;
};
const $c2c21959fbd67e57$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-ai-summaries')) return (0, $byn9U.jsx)($c2c21959fbd67e57$var$ConnectedAIPrismContainer, (0, $kU09D.default)({
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId
    }, props), children);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        className: (0, $i7Kae.hoverCardClassName),
        css: (0, $8xp05.HoverCardContainer),
        "data-testid": testId
    }, props), children);
};
var $c2c21959fbd67e57$export$2e2bcd8739ae039 = $c2c21959fbd67e57$var$ContentContainer;

});
parcelRegister("iuqLa", function(module, exports) {

$parcel$export(module.exports, "default", () => $d75fc94a80b3af41$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $4q38b = parcelRequire("4q38b");

var $ckBVH = parcelRequire("ckBVH");

var $i5R9j = parcelRequire("i5R9j");

var $8xp05 = parcelRequire("8xp05");
const $d75fc94a80b3af41$var$contentStyles = (0, $byn9U.css)({
    transition: 'box-shadow 0.5s ease'
});
const $d75fc94a80b3af41$var$contentStylesPrismVisible = (0, $byn9U.css)({
    // intentionally set opacity to 0 to remove the shadow with fade out animation
    boxShadow: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    '0px 8px 12px rgba(9, 30, 66, 0),0px 0px 1px rgba(9, 30, 66, 0)'
});
const $d75fc94a80b3af41$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    var _AI_BORDER_PALETTE$co;
    const { colorMode: colorMode = 'light' } = (0, $4q38b.default)();
    return (0, $byn9U.jsx)((0, $i5R9j.default), {
        additionalCss: {
            animatedSvgContainer: (0, $byn9U.css)({
                opacity: isVisible ? 1 : 0,
                transition: 'opacity 0.5s ease'
            })
        },
        palette: (_AI_BORDER_PALETTE$co = (0, $ckBVH.AI_BORDER_PALETTE)[colorMode]) !== null && _AI_BORDER_PALETTE$co !== void 0 ? _AI_BORDER_PALETTE$co : (0, $ckBVH.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId
    }, (0, $byn9U.jsx)("div", {
        css: [
            (0, $8xp05.popupContainerStyles),
            $d75fc94a80b3af41$var$contentStyles,
            isVisible ? $d75fc94a80b3af41$var$contentStylesPrismVisible : undefined
        ]
    }, children));
};
var $d75fc94a80b3af41$export$2e2bcd8739ae039 = $d75fc94a80b3af41$var$AIPrism;

});
parcelRegister("i5R9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2c1ebef6d714c20$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
parcelRequire("eUqFw");

var $9NBgc = parcelRequire("9NBgc");

var $ckBVH = parcelRequire("ckBVH");
const $d2c1ebef6d714c20$var$borderContainerStyles = (0, $byn9U.css)({
    display: 'flex',
    position: 'relative',
    padding: "var(--ds-space-025, 2px)",
    width: 'fit-content'
});
const $d2c1ebef6d714c20$export$a16b2e78d6201b80 = (0, $byn9U.css)({
    borderRadius: (0, $ckBVH.INNER_BORDER_RADIUS),
    flexGrow: 1,
    zIndex: 1 // needs to be more than the svg container at least
});
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $d2c1ebef6d714c20$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, additionalCss: additionalCss })=>(0, $byn9U.jsx)("div", {
        css: [
            $d2c1ebef6d714c20$var$borderContainerStyles,
            additionalCss === null || additionalCss === void 0 ? void 0 : additionalCss.container
        ],
        "data-testid": testId
    }, (0, $byn9U.jsx)((0, $9NBgc.default), {
        palette: palette,
        isMoving: isMoving,
        additionalCss: additionalCss === null || additionalCss === void 0 ? void 0 : additionalCss.animatedSvgContainer
    }), isGlowing && (0, $byn9U.jsx)((0, $9NBgc.default), {
        palette: palette,
        isMoving: isMoving,
        isGlowing: true,
        additionalCss: additionalCss === null || additionalCss === void 0 ? void 0 : additionalCss.animatedSvgContainer
    }), (0, $byn9U.jsx)("div", {
        css: $d2c1ebef6d714c20$export$a16b2e78d6201b80
    }, children, " "));
var $d2c1ebef6d714c20$export$2e2bcd8739ae039 = $d2c1ebef6d714c20$var$AIGlowingBorder;

});
parcelRegister("9NBgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $722597cb821754a6$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $ckBVH = parcelRequire("ckBVH");
let $722597cb821754a6$var$namespaceUUID = 0;
const $722597cb821754a6$var$svgStyles = (0, $byn9U.css)({
    position: 'absolute',
    borderRadius: (0, $ckBVH.OUTER_BORDER_RADIUS)
});
const $722597cb821754a6$var$blurredStyles = (0, $byn9U.css)({
    width: `calc(100% - ${"var(--ds-space-050, 4px)"})`,
    height: `calc(100% - ${"var(--ds-space-050, 4px)"})`,
    top: "var(--ds-space-050, 4px)",
    left: "var(--ds-space-050, 4px)",
    filter: `blur(${"var(--ds-space-100, 8px)"})`,
    // for safari... : https://stackoverflow.com/a/71353198
    backfaceVisibility: 'hidden',
    transform: 'translate3d(0, 0, 0)'
});
const $722597cb821754a6$var$notBlurredStyles = (0, $byn9U.css)({
    left: 0,
    top: 0,
    width: '100%',
    height: '100%'
});
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $722597cb821754a6$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, additionalCss: additionalCss })=>{
    const svgRef = (0, $eUqFw.useRef)(null);
    const namespaceId = (0, $eUqFw.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $722597cb821754a6$var$namespaceUUID;
        $722597cb821754a6$var$namespaceUUID += 1;
    }
    (0, $eUqFw.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg === null || svg === void 0 || svg.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg === null || svg === void 0 || svg.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return (0, $byn9U.jsx)("svg", {
        css: [
            $722597cb821754a6$var$svgStyles,
            isGlowing ? $722597cb821754a6$var$blurredStyles : $722597cb821754a6$var$notBlurredStyles,
            additionalCss
        ],
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, (0, $byn9U.jsx)("defs", null, (0, $byn9U.jsx)("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), (0, $byn9U.jsx)("stop", {
        offset: "0",
        stopColor: palette.blue
    }), (0, $byn9U.jsx)("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), (0, $byn9U.jsx)("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), (0, $byn9U.jsx)("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), (0, $byn9U.jsx)("stop", {
        offset: "1",
        stopColor: palette.blue
    })), (0, $byn9U.jsx)("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), (0, $byn9U.jsx)("stop", {
        offset: "0",
        stopColor: palette.blue
    }), (0, $byn9U.jsx)("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), (0, $byn9U.jsx)("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), (0, $byn9U.jsx)("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), (0, $byn9U.jsx)("stop", {
        offset: "1",
        stopColor: palette.blue
    })), (0, $byn9U.jsx)("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), (0, $byn9U.jsx)("stop", {
        offset: "0",
        stopColor: palette.blue
    }), (0, $byn9U.jsx)("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), (0, $byn9U.jsx)("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), (0, $byn9U.jsx)("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), (0, $byn9U.jsx)("stop", {
        offset: "1",
        stopColor: palette.blue
    })), (0, $byn9U.jsx)("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), (0, $byn9U.jsx)("stop", {
        offset: "0",
        stopColor: palette.blue
    }), (0, $byn9U.jsx)("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), (0, $byn9U.jsx)("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), (0, $byn9U.jsx)("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), (0, $byn9U.jsx)("stop", {
        offset: "1",
        stopColor: palette.blue
    }))), (0, $byn9U.jsx)("g", {
        strokeWidth: "8"
    }, (0, $byn9U.jsx)("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), (0, $byn9U.jsx)("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), (0, $byn9U.jsx)("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), (0, $byn9U.jsx)("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    })));
};
var $722597cb821754a6$export$2e2bcd8739ae039 = $722597cb821754a6$var$AnimatedSvgContainer;

});





parcelRegister("fiZFb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2485e80a2a966fa$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $8xp05 = parcelRequire("8xp05");

var $byn9U = parcelRequire("byn9U");
/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $b2485e80a2a966fa$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, ...props }, ref)=>(0, $byn9U.jsx)("div", (0, $kU09D.default)({
        css: (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-ai-summaries') ? undefined : (0, $8xp05.popupContainerStyles)
    }, props, {
        ref: ref
    }), children));
var $b2485e80a2a966fa$export$2e2bcd8739ae039 = $b2485e80a2a966fa$var$CustomPopupContainer;

});

parcelRegister("kYGK0", function(module, exports) {

$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $f45a90bea04b5792$export$eaff10f7ec59c455);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");

var $jfVIr = parcelRequire("jfVIr");

var $fMym1 = parcelRequire("fMym1");

var $3syEy = parcelRequire("3syEy");
const $f45a90bea04b5792$export$eaff10f7ec59c455 = (props)=>{
    const { children: children, url: url, display: display } = props;
    const { details: details, status: status } = (0, $fMym1.useSmartCardState)(url);
    const attributes = (0, $jfVIr.getResolvedAttributes)({
        url: url
    }, details, status);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3syEy.LinkAnalyticsContext), (0, $kU09D.default)({}, props, {
        display: display
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            attributes: attributes
        }
    }, children));
};

});

parcelRegister("hBQ92", function(module, exports) {

$parcel$export(module.exports, "combineActionOptions", () => $034ef0e400e40a8c$export$2ae4cf79c720146a);

var $cua7B = parcelRequire("cua7B");
const $034ef0e400e40a8c$export$2ae4cf79c720146a = (actionOptions, showServerActions, showActions, platform)=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile' || showServerActions === false && showActions === false) return {
        hide: true
    };
    if (showServerActions && showActions) return {
        hide: false
    };
    let exclude = [];
    if (showServerActions === false) exclude = [
        ...exclude,
        (0, $cua7B.CardAction).FollowAction,
        (0, $cua7B.CardAction).ChangeStatusAction
    ];
    if (showActions === false) exclude = [
        ...exclude,
        (0, $cua7B.CardAction).DownloadAction,
        (0, $cua7B.CardAction).PreviewAction,
        (0, $cua7B.CardAction).ViewAction
    ];
    return {
        hide: false,
        exclude: exclude
    };
};

});



parcelRegister("l4beU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cd2e1a50595c139$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7cd2e1a50595c139$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    editSummary: {
        "id": "issue-field-summary.inline-read.edit-summary",
        "defaultMessage": "Edit Summary"
    },
    noPermission: {
        "id": "issue-field-summary.inline-read.no-permission",
        "defaultMessage": "Contact your admin for the Edit Issues permission to edit this summary"
    }
});

});


parcelRegister("6gs4E", function(module, exports) {

$parcel$export(module.exports, "SummaryView", () => $c57375b3637dfb8b$export$bcc1604b0ad6e68b);

var $eUqFw = parcelRequire("eUqFw");

var $apoJZ = parcelRequire("apoJZ");
const $c57375b3637dfb8b$export$bcc1604b0ad6e68b = ({ value: value })=>{
    const displayValue = value === null ? '' : value.toString();
    const testId = 'issue.views.issue-base.foundation.summary.heading';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apoJZ.SummaryHeading), {
        "data-testid": testId
    }, displayValue);
};

});


parcelRegister("aPEZc", function(module, exports) {

$parcel$export(module.exports, "withExperienceTracking", () => $54d338ab6e3d7a93$export$298bf84fada2f2e0);

var $eUqFw = parcelRequire("eUqFw");

var $1YJkI = parcelRequire("1YJkI");

var $diBcB = parcelRequire("diBcB");

var $kogDC = parcelRequire("kogDC");


const $54d338ab6e3d7a93$export$298bf84fada2f2e0 = (WrappedComponent)=>(props)=>{
        const { forField: forField, issueKey: issueKey, failureEventAttributes: failureEventAttributes, allowList: allowList, ...rest } = props;
        const viewExperienceContext = (0, $eUqFw.useContext)((0, $1YJkI.default));
        const editExperienceContext = (0, $eUqFw.useContext)((0, $kogDC.default));
        const onEditExperienceFailure = editExperienceContext ? editExperienceContext.onFailure : undefined;
        // If context is missing for some reason, still try to render
        if (viewExperienceContext == null) return(// @ts-expect-error - TS2322 - Type '{ onEditFailure: ((field: string) => void) | ((location: string) => void) | undefined; onRenderSuccess?: (() => void) | undefined; issueKey: string; }' is not assignable to type 'PropsWithoutRef<PassedDownProps & T>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            issueKey: issueKey,
            onEditFailure: onEditExperienceFailure,
            ...rest
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $diBcB.default), {
            location: forField,
            experienceContext: viewExperienceContext,
            failureEventAttributes: failureEventAttributes ?? null,
            parentProvidersWhitelist: allowList ?? null
        }, ({ onExperienceSuccess: onExperienceSuccess })=>// @ts-expect-error - TS2322 - Type '{ onEditFailure: ((field: string) => void) | ((location: string) => void) | undefined; onRenderSuccess: (() => void) | (() => void); issueKey: string; }' is not assignable to type 'PropsWithoutRef<PassedDownProps & T>'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                onRenderSuccess: onExperienceSuccess,
                issueKey: issueKey,
                onEditFailure: onEditExperienceFailure,
                ...rest
            }));
    };
var $54d338ab6e3d7a93$export$2e2bcd8739ae039 = $54d338ab6e3d7a93$export$298bf84fada2f2e0;

});


parcelRegister("NfInV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3745cf2339c6a4b2$export$2e2bcd8739ae039);

var $53nVi = parcelRequire("53nVi");
var $3745cf2339c6a4b2$export$2e2bcd8739ae039 = (0, $53nVi.ReadOnlyIssueInfo);

});
parcelRegister("53nVi", function(module, exports) {

$parcel$export(module.exports, "ReadOnlyIssueInfo", () => $1b341e144b47d50d$export$2fedc7d74a5e80dc);

var $eUqFw = parcelRequire("eUqFw");

var $lRvnl = parcelRequire("lRvnl");
var $cEUHb = parcelRequire("cEUHb");

var $7ZZxN = parcelRequire("7ZZxN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $guDlK = parcelRequire("guDlK");


var $guDlK = parcelRequire("guDlK");

var $c7H0g = parcelRequire("c7H0g");

var $kKkx8 = parcelRequire("kKkx8");

var $gMJOC = parcelRequire("gMJOC");

var $akjUW = parcelRequire("akjUW");
const $1b341e144b47d50d$export$8b251419efc915eb = ({ title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h3", null, title);
const $1b341e144b47d50d$export$5c0547b091a4b556 = ({ message: message })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, message);
const $1b341e144b47d50d$export$e25442f75c28ef42 = ({ text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: "/jira/settings/projects/archive"
    }, text));
const $1b341e144b47d50d$export$5e81962abe2b8790 = ({ text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEUHb.default), {
        href: "/sample-link/Archived-Issues"
    }, text);
const $1b341e144b47d50d$export$80ac7d14826d1aae = ({ text: text })=>{
    const { openUnarchiveIssueModal: openUnarchiveIssueModal } = (0, $kKkx8.useUnarchiveIssueModalActions)();
    const issueKey = (0, $hJ992.useIssueKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEUHb.default), {
        href: "#",
        onClick: ()=>{
            openUnarchiveIssueModal(issueKey);
        }
    }, text));
};
const $1b341e144b47d50d$export$2fedc7d74a5e80dc = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isAdminUser = (0, $c7H0g.useIsAdmin)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const projectContext = (0, $guDlK.useProjectContext)(projectKey);
    const isArchived = (0, $hJ992.useIsArchived)();
    if (projectContext?.projectStatus === (0, $5bd9e96e4d7e8aee$export$62113557945f790a) && isArchived) {
        if (!(0, $gMJOC.isIssueUnarchivalButtonEnabled)()) {
            if ((0, $gMJOC.isArchivedIssuesPageLinkEnabled)() && isAdminUser) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
                appearance: "information",
                actions: [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b341e144b47d50d$export$5e81962abe2b8790, {
                        key: "achived-issues-view-link",
                        text: formatMessage((0, $akjUW.default).readOnlyArchivedIssueLinkDefault)
                    })
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b341e144b47d50d$export$8b251419efc915eb, {
                title: formatMessage((0, $akjUW.default).readOnlyArchivedIssueTitle)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b341e144b47d50d$export$5c0547b091a4b556, {
                message: formatMessage((0, $akjUW.default).readOnlyArchivedIssueMessageDefault)
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
                appearance: "information"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b341e144b47d50d$export$8b251419efc915eb, {
                title: formatMessage((0, $akjUW.default).readOnlyArchivedIssueTitle)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b341e144b47d50d$export$5c0547b091a4b556, {
                message: formatMessage((0, $akjUW.default).readOnlyArchivedIssueMessageDefault)
            }));
        }
        if (isAdminUser) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
            appearance: "information",
            actions: [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b341e144b47d50d$export$5e81962abe2b8790, {
                    key: "achived-issues-view-link",
                    text: formatMessage((0, $akjUW.default).readOnlyArchivedIssueLink)
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b341e144b47d50d$export$80ac7d14826d1aae, {
                    key: "restore-archived-issue-button",
                    text: formatMessage((0, $akjUW.default).readOnlyArchivedIssueRestoreLink)
                })
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b341e144b47d50d$export$5c0547b091a4b556, {
            message: formatMessage((0, $akjUW.default).readOnlyArchivedIssueMessageAdminUser)
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
            appearance: "information"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b341e144b47d50d$export$5c0547b091a4b556, {
            message: formatMessage((0, $akjUW.default).readOnlyArchivedIssueMessageNonAdminUser)
        }));
    }
    if (projectContext?.projectStatus !== (0, $5bd9e96e4d7e8aee$export$4ccc35479ba9ad1)) return null;
    const isServiceDeskProject = projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);
    const message = isServiceDeskProject ? formatMessage((0, $akjUW.default).jsmReadOnlyIssueMessage) : formatMessage((0, $akjUW.default).readOnlyIssueMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "information"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b341e144b47d50d$export$8b251419efc915eb, {
        title: formatMessage((0, $akjUW.default).readOnlyIssueTitle)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b341e144b47d50d$export$5c0547b091a4b556, {
        message: message
    }), isAdminUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b341e144b47d50d$export$e25442f75c28ef42, {
        text: formatMessage((0, $akjUW.default).readOnlyIssueLink)
    }) : null);
};

});
parcelRegister("c7H0g", function(module, exports) {

$parcel$export(module.exports, "useIsAdmin", () => $b4b4ffdc2519fb85$export$99a5e4bc80d231ca);

var $gd0Sp = parcelRequire("gd0Sp");
const $b4b4ffdc2519fb85$export$99a5e4bc80d231ca = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.isAdmin || false;
};

});

parcelRegister("kKkx8", function(module, exports) {

$parcel$export(module.exports, "UnarchiveIssueModalStore", () => $9112c57e64e72401$export$15ae11a500a318ea);
$parcel$export(module.exports, "useUnarchiveIssueModalActions", () => $9112c57e64e72401$export$a62f9f14820c45d1);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $bnYpe = parcelRequire("bnYpe");

var $dejEM = parcelRequire("dejEM");
const $9112c57e64e72401$export$15ae11a500a318ea = (0, $a61MH.createStore)({
    initialState: $dejEM.initialState,
    actions: (0, $bnYpe.UnarchiveIssueModalActions),
    name: 'unarchiveIssueModalStore'
});
const $9112c57e64e72401$export$a62f9f14820c45d1 = (0, $ggKAj.createActionsHook)($9112c57e64e72401$export$15ae11a500a318ea);

});
parcelRegister("bnYpe", function(module, exports) {

$parcel$export(module.exports, "UnarchiveIssueModalActions", () => $5ff818d097994f32$export$c18e6ef1c7bdce79);
const $5ff818d097994f32$export$c18e6ef1c7bdce79 = {
    openUnarchiveIssueModal: (issueKey)=>({ setState: setState })=>{
            setState({
                isUnarchiveIssueModalOpen: true,
                issueKey: issueKey
            });
        },
    closeUnarchiveIssueModal: ()=>({ setState: setState })=>{
            setState({
                isUnarchiveIssueModalOpen: false,
                issueKey: null
            });
        }
};

});

parcelRegister("dejEM", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $a9d43a96e80ec5aa$export$d4c72bab9d6cc13a);
const $a9d43a96e80ec5aa$export$d4c72bab9d6cc13a = {
    isUnarchiveIssueModalOpen: false,
    issueKey: null
};

});


parcelRegister("gMJOC", function(module, exports) {

$parcel$export(module.exports, "isArchivedIssuesPageLinkEnabled", () => $245b55ff24df431d$export$c108c03095e0e655);
$parcel$export(module.exports, "isIssueUnarchivalButtonEnabled", () => $245b55ff24df431d$export$16761d1882273343);

var $1ybV0 = parcelRequire("1ybV0");
const $245b55ff24df431d$export$c108c03095e0e655 = ()=>(0, $1ybV0.ff)('enable-archived-issues-page-link', false);
const $245b55ff24df431d$export$16761d1882273343 = ()=>(0, $1ybV0.ff)('issue-unarchival_wdpb9', false);

});

parcelRegister("akjUW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c19c85abace0da66$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c19c85abace0da66$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    readOnlyIssueTitle: {
        "id": "read-only-issue-info.read-only-issue-title",
        "defaultMessage": "This issue can't be edited"
    },
    readOnlyIssueLink: {
        "id": "read-only-issue-info.read-only-issue-link",
        "defaultMessage": "Go to archived projects"
    },
    readOnlyIssueMessage: {
        "id": "read-only-issue-info.read-only-issue-message",
        "defaultMessage": "Because it belongs to an archived project. Jira admins can restore projects from the archive."
    },
    jsmReadOnlyIssueMessage: {
        "id": "read-only-issue-info.jsm-read-only-issue-message",
        "defaultMessage": "Because it belongs to an archived service project. Jira admins can restore service projects from the archive."
    },
    readOnlyArchivedIssueTitle: {
        "id": "read-only-issue-info.read-only-archived-issue-title",
        "defaultMessage": "This issue is archived"
    },
    readOnlyArchivedIssueLink: {
        "id": "read-only-issue-info.read-only-archived-issue-link",
        "defaultMessage": "View in archive"
    },
    readOnlyArchivedIssueLinkDefault: {
        "id": "read-only-issue-info.read-only-archived-issue-link-default",
        "defaultMessage": "Go to archived issues"
    },
    readOnlyArchivedIssueRestoreLink: {
        "id": "read-only-issue-info.read-only-archived-issue-restore-link",
        "defaultMessage": "Restore"
    },
    readOnlyArchivedIssueMessageAdminUser: {
        "id": "read-only-issue-info.read-only-archived-issue-message-admin-user",
        "defaultMessage": "This issue has been archived. Restore to edit or modify the issue."
    },
    readOnlyArchivedIssueMessageNonAdminUser: {
        "id": "read-only-issue-info.read-only-archived-issue-message-non-admin-user",
        "defaultMessage": "This issue has been archived. Reach out to your admin and restore to edit the issue."
    },
    readOnlyArchivedIssueMessageDefault: {
        "id": "read-only-issue-info.read-only-archived-issue-message-default",
        "defaultMessage": "To edit this issue, ask your admin to restore it."
    }
});

});




parcelRegister("hE8iF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad7e76dc39988ae1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gA5p3 = parcelRequire("gA5p3");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad7e76dc39988ae1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad7e76dc39988ae1$var$FoundationContextWrapper, {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "issue.views.issue-base.context.status-and-approvals-wrapper.status-and-approval"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gA5p3.default), {
        key: "STATUS"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad7e76dc39988ae1$var$FoundationContextWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyridpf",
            __cmplp.className
        ])
    });
});
$ad7e76dc39988ae1$var$FoundationContextWrapper.displayName = 'FoundationContextWrapper';

});
parcelRegister("gA5p3", function(module, exports) {

$parcel$export(module.exports, "fieldOptions", () => $8bab81790d7677d4$export$395fed0102dd3c52);
$parcel$export(module.exports, "default", () => $8bab81790d7677d4$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kjXsi = parcelRequire("kjXsi");

var $8Qd0L = parcelRequire("8Qd0L");

var $1YJkI = parcelRequire("1YJkI");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $bAQOb = parcelRequire("bAQOb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");
var $3oTxc = parcelRequire("3oTxc");

var $flhrj = parcelRequire("flhrj");

var $dc3Jc = parcelRequire("dc3Jc");
var $gvoj4 = parcelRequire("gvoj4");

var $5G3JL = parcelRequire("5G3JL");

var $f9RL0 = parcelRequire("f9RL0");

var $j3Krp = parcelRequire("j3Krp");
var $4QRaC = parcelRequire("4QRaC");

var $lqalZ = parcelRequire("lqalZ");

var $jZDJX = parcelRequire("jZDJX");

var $6KjC3 = parcelRequire("6KjC3");

var $fVCj0 = parcelRequire("fVCj0");

var $1DnzP = parcelRequire("1DnzP");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");

var $guDlK = parcelRequire("guDlK");

var $d912E = parcelRequire("d912E");

var $ie6xE = parcelRequire("ie6xE");

var $ee5ao = parcelRequire("ee5ao");

var $evEA8 = parcelRequire("evEA8");

var $2GdcW = parcelRequire("2GdcW");
const $8bab81790d7677d4$export$a11134e1462e763 = ({ isEditable: isEditable, onStatusChanged: onStatusChanged, onEditCancel: onEditCancel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $hJ992.useProjectKey)();
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const experienceContext = (0, $eUqFw.useContext)((0, $1YJkI.default));
    const [statusFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $f9RL0.STATUS)
    });
    const [{ value: resolutionFieldValue, fieldConfig: resolutionFieldConfig }] = (0, $gvoj4.useResolutionField)({
        issueKey: issueKey
    });
    const resolution = resolutionFieldValue?.name;
    const transitionInProgress = (0, $1DnzP.useWorkflowTransitionsTransitionInProgress)();
    const [, workflowTransitionsActions] = (0, $1DnzP.useWorkflowTransitionsActions)();
    const initialValue = (0, $eUqFw.useMemo)(()=>(0, $2GdcW.getStatusInitialValue)(statusFieldValue), [
        statusFieldValue
    ]); // This is needed for JSW's monitoring of Issue Hierarchy in Next-gen projects
    const [sameLevel] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.HIERARCHY_LEVEL_SAME_LEVEL)
    });
    const issueHierarchyLevel = sameLevel?.level;
    const [flaggedFieldKey] = (0, $3oTxc.useSearchCustomFieldKeys)(issueKey, (0, $lO4Or.FLAGGED_CF_TYPE)) || '';
    const [{ value: isIssueFlagged }] = (0, $flhrj.useFlaggedField)({
        issueKey: issueKey,
        fieldKey: flaggedFieldKey
    });
    const [prevIsIssueFlagged] = (0, $eUqFw.useState)(isIssueFlagged);
    const [shouldAnnounce, setShouldAnnounce] = (0, $eUqFw.useState)(false);
    const onStatusSubmitted = (oldValue, newValue, meta, event)=>{
        workflowTransitionsActions.setTransitionInProgress(true);
        (0, $jMP2a.fireTrackAnalytics)(event, 'issueStatus updated', {
            oldValId: oldValue.id,
            oldStatusCategoryId: oldValue.statusCategory.id,
            oldStatusCategoryName: oldValue.statusCategory.name,
            newValId: newValue.id,
            newStatusCategoryId: newValue.statusCategory.id,
            newStatusCategoryName: newValue.statusCategory.name,
            hasScreen: meta.transition.hasScreen,
            isConditional: meta.transition.isConditional,
            issueHierarchyLevel: issueHierarchyLevel
        });
    };
    const onStatusChangeFailure = ()=>{
        workflowTransitionsActions.setTransitionInProgress(false);
    };
    (0, $eUqFw.useEffect)(()=>{
        experienceContext?.consumerCallbacks.onSuccess(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (prevIsIssueFlagged === null && isIssueFlagged !== null || prevIsIssueFlagged !== null && isIssueFlagged === null) setShouldAnnounce(true);
    }, [
        isIssueFlagged,
        prevIsIssueFlagged
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        onError: (location, error)=>{
            experienceContext?.consumerCallbacks.onFailure((0, $lO4Or.STATUS_TYPE), {
                errorMessage: error.message
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8bab81790d7677d4$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8bab81790d7677d4$var$StatusFieldContainer // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-testid": "issue.views.issue-base.foundation.status.status-field-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $evEA8.default), {
        issueKey: issueKey,
        projectType: projectType,
        initialValue: initialValue,
        isEditable: isEditable,
        appearance: "button",
        onSubmit: onStatusSubmitted,
        onSuccess: onStatusChanged,
        onEditCancel: onEditCancel,
        onFailure: onStatusChangeFailure,
        preFetchTransitions: true,
        registerInCommandPalette: true
    })), shouldAnnounce && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        role: "status",
        "aria-live": "polite"
    }, isIssueFlagged ? formatMessage((0, $ee5ao.messages).flagAdded) : formatMessage((0, $ee5ao.messages).flagRemoved)), isIssueFlagged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8bab81790d7677d4$var$StatusComponentWrapper, {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.issue-base.foundation.status.flagged-field-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ie6xE.default), {
        externalId: "issue.status.flagged"
    })), !transitionInProgress && (resolution !== undefined && resolution !== null || resolutionFieldConfig?.isEditable && initialValue.statusCategory.id === (0, $8Qd0L.categoryIdForStatusCategory)((0, $8Qd0L.DONE))) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div" // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-testid": "issue.views.issue-base.foundation.status.resolution"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dc3Jc.ResolutionField), {
        issueKey: issueKey
    })), !transitionInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8bab81790d7677d4$var$StatusComponentWrapper // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-testid": "issue.views.issue-base.foundation.status.actions-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d912E.default), {
        initialStatusValue: initialValue,
        onSubmit: onStatusSubmitted,
        onSuccess: onStatusChanged
    }))));
};
const $8bab81790d7677d4$export$395fed0102dd3c52 = {
    canContainMediaContent: false,
    isOptimistic: false,
    isRichTextField: false,
    shouldSaveDraft: false,
    shouldDiscardChangeOnFailure: false,
    onSaveFailureFlagType: null,
    onSaveSuccessFlagType: null,
    saveField: ()=>Promise.resolve()
}; // FIXME: JIV-17455 should be fully typed
var $8bab81790d7677d4$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $5G3JL.flowWithSafeComponent)(// @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<StateProps & DispatchProps, {}>' is not assignable to parameter of type 'FlowStep<C, ComponentType<ComponentBeingTrackedProps<{ [k in keyof (DistributiveOmit<LibraryManagedAttributes<C, GetProps<C>>, Extract<"isEditable", keyof LibraryManagedAttributes<C, GetProps<C>>> | Extract<...> | Extract<...>> & {} & ConnectPropsMaybeWithoutContext<...>)]: (DistributiveOmit<...> & ... 1 more ... & ...'.
(0, $lqalZ.connect)((state)=>({
        isEditable: (0, $jZDJX.isCompletedLoadingSelector)(state)
    }), (dispatch)=>({
        onStatusChanged: (status, viaDialog)=>{
            /* Ideally we would only dispatch fieldUpdated here, but there are still internal components listening to the changing
               values that fieldSaveSuccess provides for status field. For now, let's fire both */ // @ts-expect-error - TS2554 - Expected 4-5 arguments, but got 3.
            dispatch((0, $fVCj0.fieldSaveSuccess)((0, $f9RL0.STATUS), $8bab81790d7677d4$export$395fed0102dd3c52, status));
            dispatch((0, $fVCj0.fieldUpdated)((0, $f9RL0.STATUS), status, {
                viaDialog: viaDialog
            }));
        },
        onEditCancel: ()=>{
            /* TODO: this is being called twice when the transition dialog is opened and we close it by using the "escape" key.
               This happens because the 'keydown' event is being handled by
               the dialog itself *and* by the AK Select component. This is a bug on AK Select, since it
               should remove that event listener when the component unmounts. I've raised a ticket
               with Atlaskit to fix this: https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6310 */ dispatch((0, $6KjC3.fieldEditCancel)((0, $f9RL0.STATUS), $8bab81790d7677d4$export$395fed0102dd3c52));
        }
    })), // TODO: Temporarily use analytic HoC until new hook based API is ready.
(0, $4QRaC.withViewExperienceTracker)((0, $f9RL0.STATUS)), (0, $j3Krp.withEditExperienceTracker)((0, $f9RL0.STATUS)))($8bab81790d7677d4$export$a11134e1462e763);
const $8bab81790d7677d4$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _ca0qutpp _n3tdn7od _8mocu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8bab81790d7677d4$var$StatusFieldContainerOldWithFitAndFinish = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f3n7od _n3tdu2gc _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $8bab81790d7677d4$var$StatusFieldContainer = (0, $bAQOb.componentWithFF)('issue-view-fit-and-finish-full-page-milestone2_ebk0i', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f3n7od _n3tdutpp _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}), $8bab81790d7677d4$var$StatusFieldContainerOldWithFitAndFinish);
const $8bab81790d7677d4$var$StatusComponentWrapper = (0, $bAQOb.componentWithFF)('issue-view-fit-and-finish-full-page-milestone2_ebk0i', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3tdutpp _1e0c116y _1n261q9c _p12f1osq",
            __cmplp.className
        ])
    });
}), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3tdu2gc _1e0c116y _1n261q9c _p12f1osq",
            __cmplp.className
        ])
    });
}));

});
parcelRegister("3oTxc", function(module, exports) {

$parcel$export(module.exports, "useSearchCustomFieldKeys", () => $ea9d9fcdfafd7d39$export$72e7ef7049519cbe);

var $eUqFw = parcelRequire("eUqFw");

var $8411R = parcelRequire("8411R");
const $ea9d9fcdfafd7d39$export$72e7ef7049519cbe = (issueKey, customFieldType)=>{
    const [{ value: issueFieldsConfig }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    const fieldKeys = (0, $eUqFw.useMemo)(()=>issueFieldsConfig && Object.keys(issueFieldsConfig).filter((key)=>issueFieldsConfig[key].schema?.custom === customFieldType) || [], [
        issueFieldsConfig,
        customFieldType
    ]);
    return fieldKeys;
};

});

parcelRegister("flhrj", function(module, exports) {

$parcel$export(module.exports, "useFlaggedField", () => $15ed6521f0f5a4b6$export$b5507089b5b9494a);

var $5G2eQ = parcelRequire("5G2eQ");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");

var $f1Eld = parcelRequire("f1Eld");
const $15ed6521f0f5a4b6$export$a2b8715397522463 = (baseUrl)=>`${baseUrl}/rest/greenhopper/1.0/xboard/issue/flag/flag.json`;
const $15ed6521f0f5a4b6$export$5e165df1e30a1331 = (baseUrl, issueKey, shouldFlag)=>(0, $5G2eQ.default)($15ed6521f0f5a4b6$export$a2b8715397522463(baseUrl), {
        method: 'POST',
        body: JSON.stringify({
            flag: shouldFlag,
            issueKeys: [
                issueKey
            ],
            commentVisibility: '',
            comment: ''
        })
    }).toPromise()// eslint-disable-next-line @typescript-eslint/no-empty-function
    .then(()=>{});
// @ts-expect-error - TS2304 - Cannot find name 'IssueKey'.
const $15ed6521f0f5a4b6$var$saveField = (issueKey, fieldKey, value, baseUrl)=>$15ed6521f0f5a4b6$export$5e165df1e30a1331(baseUrl, issueKey, (0, $f1Eld.transformFromStateValue)(value));
const $15ed6521f0f5a4b6$export$b5507089b5b9494a = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: (0, $lO4Or.FLAGGED_CF_TYPE),
        initialValue: null,
        saveField: // @ts-expect-error - TS2322 - Type '(issueKey: IssueKey, fieldKey: string, value: FlaggedValue, baseUrl: string) => Promise<void>' is not assignable to type 'SaveField<FlaggedValue, undefined>'.
        $15ed6521f0f5a4b6$var$saveField,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("5G2eQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d9fb25724578ccf$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $fVqUX = parcelRequire("fVqUX");

var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $etaBp = parcelRequire("etaBp");
const $0d9fb25724578ccf$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$0d9fb25724578ccf$export$2e2bcd8739ae039 = (url, options = {})=>(0, $3JafE.Observable).of(url).mergeMap(()=>fetch(url, (0, $6HC1D.merge)((0, $6HC1D.merge)((0, $fVqUX.default), options), (0, $etaBp.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $7byHA.default)(status);
        }
        if (response.status === $0d9fb25724578ccf$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $3JafE.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $3JafE.Observable).of(response.responseText || 'OK');
    });

});

parcelRegister("f1Eld", function(module, exports) {

$parcel$export(module.exports, "transformFromStateValue", () => $051e3dc1ce7c4ad9$export$cb172b2468ab5652);
$parcel$export(module.exports, "transformToStateValue", () => $051e3dc1ce7c4ad9$export$1cfcb95cb8fbddb3);
const $051e3dc1ce7c4ad9$export$cb172b2468ab5652 = (stateValue)=>stateValue ? stateValue.length > 0 : false;
const $051e3dc1ce7c4ad9$export$1cfcb95cb8fbddb3 = (value)=>value ? [
        {
            value: true
        }
    ] : null;

});


parcelRegister("dc3Jc", function(module, exports) {

$parcel$export(module.exports, "ResolutionField", () => $e7c88cc79010c6e9$export$7996ae051bcc8099);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cWMyd = parcelRequire("cWMyd");

var $e7XVM = parcelRequire("e7XVM");

var $gvoj4 = parcelRequire("gvoj4");

var $9HZNY = parcelRequire("9HZNY");
var $4cpwW = parcelRequire("4cpwW");
const $e7c88cc79010c6e9$export$7996ae051bcc8099 = ({ issueKey: issueKey })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onFailure = (0, $eUqFw.useCallback)(()=>{
        showFlag({
            type: 'error',
            title: [
                (0, $e7XVM.default).editResolutionFailedTitle,
                {
                    issueKey: issueKey
                }
            ],
            description: (0, $e7XVM.default).editResolutionFailedDescription
        });
    }, [
        issueKey,
        showFlag
    ]);
    const [{ value: value, fieldConfig: fieldConfig }, { saveValue: saveValue }] = (0, $gvoj4.useResolutionField)({
        issueKey: issueKey,
        onFailure: onFailure
    });
    const { allowedValues: allowedValues = [], isEditable: isEditable = false } = fieldConfig || {};
    const selected = (0, $eUqFw.useMemo)(()=>value ? (0, $cWMyd.mapResolutionOptionToOption)(value) : null, [
        value
    ]);
    const options = (0, $eUqFw.useMemo)(()=>(0, $cWMyd.mapAndFilterResolutionOptions)(value, allowedValues), [
        allowedValues,
        value
    ]);
    const isEditViewEnabled = isEditable && options.length >= 1;
    const onChange = (0, $eUqFw.useCallback)((option)=>{
        const optionExternal = (0, $cWMyd.mapOptionToResolutionOption)(option);
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'select'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'resolutionField');
        saveValue(optionExternal, null, analyticsEvent);
    }, [
        createAnalyticsEvent,
        saveValue
    ]);
    if (fieldConfig === null || fieldConfig === undefined) return null;
    return isEditViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9HZNY.ResolutionEditView), {
        onChange: onChange,
        allowedOptions: options,
        value: selected
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cpwW.ResolutionReadView), {
        value: value,
        isLabelClickEnabled: false
    });
};

});
parcelRegister("cWMyd", function(module, exports) {

$parcel$export(module.exports, "mapOptionToResolutionOption", () => $f9f03c224d6c8eff$export$f915ce0689a595ca);
$parcel$export(module.exports, "mapResolutionOptionToOption", () => $f9f03c224d6c8eff$export$203456290cf27045);
$parcel$export(module.exports, "mapAndFilterResolutionOptions", () => $f9f03c224d6c8eff$export$38929c8b23814052);
const $f9f03c224d6c8eff$export$f915ce0689a595ca = (option)=>({
        id: option.value,
        name: option.label
    });
const $f9f03c224d6c8eff$export$203456290cf27045 = (option)=>({
        value: option.id,
        label: option.name
    });
const $f9f03c224d6c8eff$export$2ad0f62ebcc9982d = (options)=>options.map((option)=>$f9f03c224d6c8eff$export$203456290cf27045(option));
const $f9f03c224d6c8eff$export$38929c8b23814052 = (currentOption, options)=>{
    if (!currentOption) return $f9f03c224d6c8eff$export$2ad0f62ebcc9982d(options);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return options.reduce((resolutionOptions, option)=>{
        if (option.id !== currentOption.id) resolutionOptions.push($f9f03c224d6c8eff$export$203456290cf27045(option));
        return resolutionOptions;
    }, []);
};

});

parcelRegister("e7XVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2b1b2c60eef919c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b2b1b2c60eef919c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    editResolutionFailedTitle: {
        "id": "issue-field-resolution.edit-resolution-failed-title",
        "defaultMessage": "We couldn't update {issueKey}'s resolution"
    },
    editResolutionFailedDescription: {
        "id": "issue-field-resolution.edit-resolution-failed-description",
        "defaultMessage": "Check your connection, then try again."
    }
});

});

parcelRegister("gvoj4", function(module, exports) {

$parcel$export(module.exports, "useResolutionField", () => $c09308392b05bcf0$export$353912a36c67a0c2);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $c09308392b05bcf0$export$353912a36c67a0c2 = ({ issueKey: issueKey, onFailure: onFailure })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, (0, $lO4Or.RESOLUTION_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', (0, $lO4Or.RESOLUTION_TYPE));
    const [{ error: error, value: value, loading: loading }, { resetError: resetError, saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldType: fieldType,
        issueKey: issueKey,
        initialValue: null,
        fieldKey: (0, $lO4Or.RESOLUTION_TYPE),
        onFailure: onFailure
    });
    return [
        {
            error: error,
            value: value,
            loading: loading,
            fieldConfig: fieldConfig
        },
        {
            resetError: resetError,
            saveValue: saveValue
        }
    ];
};

});

parcelRegister("9HZNY", function(module, exports) {

$parcel$export(module.exports, "ResolutionEditView", () => $eca1748f7ec4d67d$export$8c7e2037fa56d285);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $4IBr3 = parcelRequire("4IBr3");

var $cWMyd = parcelRequire("cWMyd");

var $4cpwW = parcelRequire("4cpwW");
const $eca1748f7ec4d67d$export$8c7e2037fa56d285 = ({ value: value = null, allowedOptions: allowedOptions, onChange: onChange, isOpenByDefault: isOpenByDefault = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4IBr3.default), {
        options: allowedOptions || [],
        value: value,
        target: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    label: "open"
                }),
                appearance: "subtle",
                testId: "issue-field-resolution.ui.edit.popover.button",
                interactionName: "auto-generated.issue-field-resolution.ui.edit.popover.button.button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cpwW.ResolutionReadView), {
                value: value ? (0, $cWMyd.mapOptionToResolutionOption)(value) : null,
                isLabelClickEnabled: true
            })),
        // @ts-expect-error - TS2769 - No overload matches this call.
        onChange: onChange,
        isSearchable: false,
        searchThreshold: 99999,
        defaultIsOpen: isOpenByDefault
    });

});
parcelRegister("4cpwW", function(module, exports) {

$parcel$export(module.exports, "ResolutionReadView", () => $2b3e9241a4bbe969$export$dfd4dfe034c38e3f);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $9nt1B = parcelRequire("9nt1B");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3iHmR = parcelRequire("3iHmR");
const $2b3e9241a4bbe969$export$dfd4dfe034c38e3f = ({ value: value, isLabelClickEnabled: isLabelClickEnabled, hideIcon: hideIcon = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const hasResolution = value;
    const resolutionName = value?.name || formatMessage((0, $3iHmR.default).unresolvedResolution);
    const icon = hasResolution && ((0, $1ybV0.ff)('jira.list.field-support-part1') ? !hideIcon : true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
        size: "medium",
        label: resolutionName,
        testId: "issue-field-resolution.ui.read.check-icon",
        primaryColor: `var(--ds-icon-success, ${(0, $PdmhA).G400})`
    }) : null;
    const renderResolutionLabel = (labelName)=>{
        const resolutionStatusLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2b3e9241a4bbe969$var$ResolutionStatusLabel, {
            "data-testid": "issue-field-resolution.ui.read.resolution-status-label",
            isDisabled: !isLabelClickEnabled,
            isDarkText: isLabelClickEnabled || !!hasResolution
        }, labelName);
        return !isLabelClickEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $3iHmR.default).readViewMessage),
            position: "top"
        }, resolutionStatusLabel) : resolutionStatusLabel;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2b3e9241a4bbe969$var$Container, {
        addPadding: !isLabelClickEnabled,
        "data-testid": "issue-field-resolution.ui.read.label"
    }, icon, renderResolutionLabel(resolutionName));
};
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2b3e9241a4bbe969$var$Container = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-6kdpa7-0"
})(({ addPadding: addPadding })=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        padding: addPadding ? `0 ${(0, $c9TLT.gridSize) * 2}px 0 12px` : 0,
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $c9TLT.gridSize) * 4}px`
    }));
const $2b3e9241a4bbe969$var$itemTruncateWidth = (0, $c9TLT.gridSize) * 25;
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2b3e9241a4bbe969$var$ResolutionStatusLabel = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-6kdpa7-1"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.isDarkText ? `var(--ds-text-subtle, ${(0, $PdmhA).N500})` : `var(--ds-text-subtlest, ${(0, $PdmhA).N90})`,
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `${$2b3e9241a4bbe969$var$itemTruncateWidth}px`
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled ? ':hover { cursor: not-allowed; }' : '');

});
parcelRegister("3iHmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4949ab11b370a82a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4949ab11b370a82a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    readViewMessage: {
        "id": "issue-field-resolution.read.read-view-message",
        "defaultMessage": "You cannot edit the resolution field"
    },
    unresolvedResolution: {
        "id": "issue-field-resolution.read.unresolved-resolution",
        "defaultMessage": "Unresolved"
    }
});

});




parcelRegister("d912E", function(module, exports) {

$parcel$export(module.exports, "default", () => $b362f3f4cddb3c17$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1qLTb = parcelRequire("1qLTb");
const $b362f3f4cddb3c17$var$ActionsMenu = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1qLTb.default), props);
var $b362f3f4cddb3c17$export$2e2bcd8739ae039 = $b362f3f4cddb3c17$var$ActionsMenu;

});
parcelRegister("1qLTb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3971aac0de10238e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $jG2Eu = parcelRequire("jG2Eu");

var $eym7N = parcelRequire("eym7N");
var $jVC1s = parcelRequire("jVC1s");

var $c9TLT = parcelRequire("c9TLT");

var $hJ992 = parcelRequire("hJ992");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");

var $6vrw7 = parcelRequire("6vrw7");

var $c7H0g = parcelRequire("c7H0g");
var $gd0Sp = parcelRequire("gd0Sp");

var $50D0V = parcelRequire("50D0V");

var $jsdzI = parcelRequire("jsdzI");

var $72abk = parcelRequire("72abk");

var $13ftU = parcelRequire("13ftU");
const $3971aac0de10238e$var$ActionsMenuComponent = ({ issueKey: issueKey, issueId: issueId, environment: environment, cloudId: cloudId, transitions: transitions, onTransitionStatus: onTransitionStatus, animationEnabled: animationEnabled, baseAutomationUrl: baseAutomationUrl, canManageAutomations: canManageAutomations })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3971aac0de10238e$export$c8223871eecc8f3a, {
        animationEnabled: animationEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVC1s.ManualRulesContainer), {
        env: environment,
        cloudId: cloudId,
        issueIds: issueId ? [
            Number(issueId)
        ] : []
    }, ({ triggerFetch: triggerFetch, initialised: initialised, rules: rules, invokingRuleId: invokingRuleId, invokeRuleOrShowDialog: invokeRuleOrShowDialog })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $13ftU.ActionsMenu), {
            issueKey: issueKey,
            issueId: Number(issueId),
            rules: rules,
            triggerFetch: triggerFetch,
            executeRule: invokeRuleOrShowDialog,
            executingRule: invokingRuleId,
            initialised: initialised,
            transitions: transitions,
            onSelect: onTransitionStatus,
            canManageAutomations: canManageAutomations,
            baseAutomationUrl: baseAutomationUrl
        })));
const $3971aac0de10238e$var$Actions = ({ initialStatusValue: initialStatusValue, onSubmit: onSubmit, onSuccess: onSuccess })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const issueId = (0, $hJ992.useIssueId)();
    const baseUrl = (0, $6vrw7.toBaseUrl)('');
    const projectKey = (0, $hJ992.useProjectKey)();
    const projectId = (0, $guDlK.useProjectId)(projectKey);
    const isSimplified = (0, $guDlK.useIsSimplifiedProject)(projectKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const baseAutomationUrl = (0, $eUqFw.useMemo)(()=>(0, $eym7N.getBaseAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplified
        }), [
        projectKey,
        projectType,
        isSimplified
    ]);
    const isProjectAdmin = (0, $5YYzL.useCanAdministerProject)(projectKey);
    const isGlobalAdmin = (0, $c7H0g.useIsAdmin)();
    const canManageAutomations = isProjectAdmin || isGlobalAdmin;
    const { environment: environment, cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const [animationEnabled, setAnimationEnabled] = (0, $eUqFw.useState)(false);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const onSuccesInternal = (...args)=>{
        setAnimationEnabled(true);
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        onSuccess(...args);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jsdzI.StatusService), {
        appearance: "button",
        projectType: projectType || null,
        issueKey: issueKey,
        issueId: issueId,
        baseUrl: baseUrl,
        onSubmit: onSubmit,
        onSuccess: onSuccesInternal,
        onFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onEditCancel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        initialValue: initialStatusValue
    }, ({ value: statusServiceValue, loading: saving, transitionStatus: transitionStatus })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $72abk.TransitionsQuery), {
            issueKey: issueKey,
            baseUrl: baseUrl,
            status: statusServiceValue,
            isSaving: saving,
            preFetch: true,
            projectType: projectType
        }, ({ data: transitions })=>{
            const loopedTransitions = (0, $50D0V.getLoopedTransitionsForStatus)(transitions, statusServiceValue.id);
            const menuProps = {
                environment: environment,
                cloudId: cloudId,
                projectId: projectId,
                issueKey: issueKey,
                issueId: issueId,
                transitions: loopedTransitions,
                onTransitionStatus: transitionStatus,
                animationEnabled: animationEnabled,
                baseAutomationUrl: baseAutomationUrl,
                canManageAutomations: canManageAutomations
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3971aac0de10238e$var$ActionsMenuComponent, menuProps);
        }));
};
var $3971aac0de10238e$export$2e2bcd8739ae039 = $3971aac0de10238e$var$Actions;
const $3971aac0de10238e$var$fadeInAnimation = /*#__PURE__*/ (0, $kwce8.keyframes)({
    '0%': {
        opacity: 0,
        maxHeight: 0
    },
    '50%': {
        maxHeight: `${(0, $c9TLT.gridSize) * 5}px`
    },
    '100%': {
        opacity: 1
    }
});
const $3971aac0de10238e$export$c8223871eecc8f3a = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1bfbqvr-0"
})((props)=>({
        display: 'inline-flex',
        maxWidth: '100%',
        animationDuration: '0.5s',
        animationIterationCount: 1,
        animationName: props.animationEnabled ? $3971aac0de10238e$var$fadeInAnimation : 'none',
        animationTimingFunction: 'linear',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    }));

});
parcelRegister("eym7N", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $4cd6b2217d481809$export$6123178d3f5fb24d);
$parcel$export(module.exports, "getAutomationRecommendationsUrl", () => $4cd6b2217d481809$export$38f41aa7b608011d);
$parcel$export(module.exports, "getBaseAutomationUrl", () => $4cd6b2217d481809$export$8e479e490e1e69bc);

var $aZaPn = parcelRequire("aZaPn");

var $1ybV0 = parcelRequire("1ybV0");
const $4cd6b2217d481809$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('automation-menu');
const $4cd6b2217d481809$var$getLatestStack = async (cloudId)=>fetch(`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`).then((response)=>response.json()).then((response)=>{
        const stacks = response.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        return stacks.length > 0 ? stacks[0] : null;
    }).catch(()=>null);
const $4cd6b2217d481809$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') {
        if ((0, $1ybV0.ff)('automation.platform.pre-prod.instance')) {
            const stack = await $4cd6b2217d481809$var$getLatestStack(cloudId);
            return stack ?? 'pro';
        }
        return 'pro';
    }
    // Set this manually to your Automation dev stack e.g. devesukmajaya. The full key is: __storejs_automation-menu_automationStack
    const stackOverride = $4cd6b2217d481809$var$localStorage.get('automationStack');
    return stackOverride || 'staging';
};
const $4cd6b2217d481809$export$45ce04a98782e28a = async (env, cloudId, projectId)=>{
    const automationStack = await $4cd6b2217d481809$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${projectId}`;
};
const $4cd6b2217d481809$export$f8e019b45a22d26a = async (env, cloudId, ruleId)=>{
    const automationStack = await $4cd6b2217d481809$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${ruleId}`;
};
const $4cd6b2217d481809$export$38f41aa7b608011d = async ({ env: env, cloudId: cloudId, target: target })=>{
    const automationStack = await $4cd6b2217d481809$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/v1/recommendation/templates?target=${target}`;
};
const $4cd6b2217d481809$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});

parcelRegister("jVC1s", function(module, exports) {

$parcel$export(module.exports, "ManualRulesContainer", () => $1a59ed540c2c626d$export$eb0a81e78d942dba);

var $eUqFw = parcelRequire("eUqFw");

var $7KWVz = parcelRequire("7KWVz");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $huI7r = parcelRequire("huI7r");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $5WDnM = parcelRequire("5WDnM");
const $1a59ed540c2c626d$export$eb0a81e78d942dba = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { env: env, cloudId: cloudId, issueIds: issueIds } = props;
    let automationEnv = env;
    if (env === 'prod') automationEnv = (0, $1ybV0.ff)('automation-dev-helper') ? 'pre-prod' : 'prod';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7KWVz.ManualRulesContainer), {
        site: (0, $huI7r.createAri)({
            resourceOwner: 'jira',
            resourceType: 'site',
            resourceId: cloudId
        }),
        query: {
            objects: issueIds?.map((id)=>(0, $huI7r.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'issue',
                    cloudId: cloudId,
                    resourceId: id.toString()
                }))
        },
        env: automationEnv,
        onInputsModalOpened: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'manualRuleModal',
                action: 'opened'
            });
            const attributes = {
                objectType: 'issue'
            };
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, attributes);
        },
        onRuleInvocationLifecycleStarted: (_, __, userInputs)=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'manualRule',
                action: 'tryInvoke'
            });
            const attributes = {
                objectType: 'issue',
                ruleHasInputs: Boolean(userInputs),
                objectsSelected: issueIds.length
            };
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, attributes);
        },
        onRuleInvocationSuccess: ()=>showFlag({
                type: 'info',
                title: formatMessage((0, $5WDnM.default).successFlag),
                isAutoDismiss: true
            }),
        onRuleInvocationFailure: ()=>showFlag({
                type: 'error',
                title: formatMessage((0, $5WDnM.default).failureFlagTitle),
                description: formatMessage((0, $5WDnM.default).failureFlagDescription),
                isAutoDismiss: true
            })
    }, props.children);
};

});
parcelRegister("7KWVz", function(module, exports) {

$parcel$export(module.exports, "ManualRulesContainer", () => $5a5a8a14c43f3425$export$eb0a81e78d942dba);

var $eUqFw = parcelRequire("eUqFw");


var $dxopF = parcelRequire("dxopF");

var $3bkH1 = parcelRequire("3bkH1");

var $cVYxc = parcelRequire("cVYxc");
const $5a5a8a14c43f3425$export$96513fc6544cb4e5 = (env, site, query)=>{
    const [initialised, setInitialised] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [rules, setRules] = (0, $eUqFw.useState)([]);
    const transformRules = (ruleResponse)=>{
        const rulesUnsorted = Object.values(ruleResponse);
        return rulesUnsorted.sort((rule1, rule2)=>rule1.name.localeCompare(rule2.name));
    };
    const triggerFetch = async ()=>{
        setInitialised(false);
        try {
            const fetchedRules = await (0, $3bkH1.searchManuallyTriggeredRules)(env, site, query);
            setError(null);
            setRules(transformRules(fetchedRules));
        } catch (e) {
            setError(e);
            setRules([]);
        } finally{
            setInitialised(true);
        }
    };
    return [
        triggerFetch,
        initialised,
        error,
        rules
    ];
};
const $5a5a8a14c43f3425$export$eb0a81e78d942dba = (props)=>{
    const { env: env, site: site, query: query, children: children, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed, onRuleInvocationLifecycleStarted: onRuleInvocationLifecycleStarted, onRuleInvocationSuccess: onRuleInvocationSuccess, onRuleInvocationFailure: onRuleInvocationFailure, onRuleInvocationLifecycleDone: onRuleInvocationLifecycleDone } = props;
    // Initial data loading state
    const [triggerFetch, initialised, error, rules] = $5a5a8a14c43f3425$export$96513fc6544cb4e5(env, site, query);
    // We store a rule in state here if and only if a rule has user inputs, and thus
    // we need to preserve state while the input dialog is open.
    const [selectedRule, setSelectedRule] = (0, $eUqFw.useState)(null);
    const clearSelectedRule = ()=>{
        setSelectedRule(null);
    };
    // Value set when a rule is invoking, either from the dialog or without dialog
    const [invokingRuleId, setInvokingRuleId] = (0, $eUqFw.useState)(null);
    // Memoized projection of rules by id
    const rulesById = (0, $eUqFw.useMemo)(()=>rules.reduce((acc, rule)=>({
                // eslint-disable-next-line
                ...acc,
                [rule.id]: rule
            }), {}), [
        rules
    ]);
    const getRule = (id)=>rulesById[id];
    const ruleHasInputs = (rule)=>{
        var _rule$userInputPrompt;
        return (rule === null || rule === void 0 ? void 0 : (_rule$userInputPrompt = rule.userInputPrompts) === null || _rule$userInputPrompt === void 0 ? void 0 : _rule$userInputPrompt.length) > 0;
    };
    const getFailedObjects = (response)=>Object.keys(response).filter((object)=>response[object] !== 'SUCCESS');
    const getSuccessfulObjects = (response)=>Object.keys(response).filter((object)=>response[object] === 'SUCCESS');
    const handleInvocationFailure = (ruleId, successfulObjects, failedObjects)=>{
        if (onRuleInvocationFailure) onRuleInvocationFailure(ruleId, successfulObjects, failedObjects);
    };
    const invokeRule = async (ruleId, objects, userInputs)=>{
        const rule = getRule(ruleId);
        if (rule) {
            setInvokingRuleId(ruleId);
            try {
                if (onRuleInvocationLifecycleStarted) onRuleInvocationLifecycleStarted(ruleId, objects, userInputs);
                const response = await (0, $3bkH1.invokeManuallyTriggeredRule)(env, site, ruleId, objects, userInputs);
                const failedObjects = getFailedObjects(response);
                setInvokingRuleId(null);
                if (failedObjects.length === 0) {
                    if (onRuleInvocationSuccess) onRuleInvocationSuccess(ruleId, objects);
                } else {
                    const successfulObjects = getSuccessfulObjects(response);
                    handleInvocationFailure(ruleId, successfulObjects, failedObjects);
                }
            } catch (e) {
                handleInvocationFailure(ruleId, [], objects);
                setInvokingRuleId(null);
            }
        } else handleInvocationFailure(ruleId, [], objects);
        clearSelectedRule();
        if (onRuleInvocationLifecycleDone) onRuleInvocationLifecycleDone(ruleId, objects);
    };
    const invokeRuleOrShowDialog = (ruleId, objects)=>{
        const rule = getRule(ruleId);
        if (!rule) return handleInvocationFailure(ruleId, [], objects);
        if (ruleHasInputs(rule)) setSelectedRule({
            rule: rule,
            objects: objects
        });
        else invokeRule(ruleId, objects);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children({
        triggerFetch: triggerFetch,
        initialised: initialised,
        error: error,
        rules: rules,
        invokingRuleId: invokingRuleId,
        invokeRuleOrShowDialog: invokeRuleOrShowDialog
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, selectedRule && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVYxc.default), {
        onInputsModalOpened: onInputsModalOpened,
        onInputsModalClosed: onInputsModalClosed,
        clearSelectedRule: clearSelectedRule,
        selectedRule: selectedRule,
        invokeRule: invokeRule
    })));
};

});
parcelRegister("3bkH1", function(module, exports) {

$parcel$export(module.exports, "searchManuallyTriggeredRules", () => $251273600f87a57b$export$11e317ae81dd4223);
$parcel$export(module.exports, "invokeManuallyTriggeredRule", () => $251273600f87a57b$export$9a0eb4136c6b46c);

var $aO1cl = parcelRequire("aO1cl");
const $251273600f87a57b$export$11e317ae81dd4223 = async (env, site, query)=>{
    const url = await (0, $aO1cl.getSearchUrl)(env, site);
    // TODO this will in the new API be a GET request instead, with the above getSearchUrl method
    // constructing a URL with the appropriate query parameters. For now, instead, we pass the
    // destructured query through as a POST body.
    const response = await (0, $aO1cl.performPostRequest)(url, {
        body: JSON.stringify(query)
    });
    return response.reduce((acc, { id: id, name: name, ruleScope: ruleScope, userInputs: userInputs })=>({
            // eslint-disable-next-line
            ...acc,
            [id]: {
                id: id,
                name: name,
                ruleScope: ruleScope,
                userInputPrompts: userInputs
            }
        }), {});
};
const $251273600f87a57b$export$9a0eb4136c6b46c = async (env, site, ruleId, objects, userInputs)=>{
    const url = await (0, $aO1cl.getInvocationUrl)(env, site, ruleId);
    const bodyRaw = {
        objects: objects
    };
    if (userInputs) bodyRaw.userInputs = userInputs;
    return (0, $aO1cl.performPostRequest)(url, {
        body: JSON.stringify(bodyRaw)
    });
};

});
parcelRegister("aO1cl", function(module, exports) {

$parcel$export(module.exports, "getSearchUrl", () => $7ddf80cc60c7a845$export$7d4675b206f57488);
$parcel$export(module.exports, "getInvocationUrl", () => $7ddf80cc60c7a845$export$e62dcf5e32cec4bf);
$parcel$export(module.exports, "performPostRequest", () => $7ddf80cc60c7a845$export$692a4d9808143175);

var $3Hdsq = parcelRequire("3Hdsq");

var $bSv1i = parcelRequire("bSv1i");
const $7ddf80cc60c7a845$export$1cb1c6bd5a8f1613 = (site)=>{
    let cloudId;
    let resourceOwner;
    let resourceType;
    try {
        const ari = (0, $3Hdsq.ResourceIdentifier).parse(site);
        cloudId = ari.cloudId;
        resourceOwner = ari.resourceOwner;
        resourceType = ari.resourceType;
        // Keep backwards compatibility for platform site ARIs
        if (resourceOwner === 'platform') resourceOwner = 'jira';
    } catch (error) {
        throw new Error('Attempted to parse malformed ARI: ' + site);
    }
    if (resourceType !== 'site' || cloudId === undefined) throw new Error('Not a site ARI: ' + site);
    return {
        product: resourceOwner,
        cloudId: cloudId
    };
};
const $7ddf80cc60c7a845$export$7d4675b206f57488 = async (env, site)=>{
    const { product: product, cloudId: cloudId } = $7ddf80cc60c7a845$export$1cb1c6bd5a8f1613(site);
    const automationStack = await (0, $bSv1i.getAutomationStack)(env, cloudId);
    // TODO in the unified API, GET requests as according to Atlassian API standards will destructure the whole query into
    // query parameters as part of the URL. For now, this is considered a POST request instead and thus the query is used
    // later on as the request body.
    return `/gateway/api/automation/internal-api/${product}/${cloudId}/${automationStack}/rest/v1/rules/manual/search`;
};
const $7ddf80cc60c7a845$export$e62dcf5e32cec4bf = async (env, site, ruleId)=>{
    const { product: product, cloudId: cloudId } = $7ddf80cc60c7a845$export$1cb1c6bd5a8f1613(site);
    const automationStack = await (0, $bSv1i.getAutomationStack)(env, cloudId);
    return `/gateway/api/automation/internal-api/${product}/${cloudId}/${automationStack}/rest/v1/rules/manual/invocation/${ruleId}`;
};
const $7ddf80cc60c7a845$var$DEFAULT_HEADER = {
    'Content-Type': 'application/json'
};
const $7ddf80cc60c7a845$var$_performRequest = async (url, method, options = {
    headers: $7ddf80cc60c7a845$var$DEFAULT_HEADER
})=>{
    const response = await fetch(url, {
        ...options,
        method: method
    });
    return response.json();
};
const $7ddf80cc60c7a845$export$4a53ae1be8ec80c7 = async (url, options)=>{
    return $7ddf80cc60c7a845$var$_performRequest(url, 'GET', options);
};
const $7ddf80cc60c7a845$export$692a4d9808143175 = async (url, options)=>{
    return $7ddf80cc60c7a845$var$_performRequest(url, 'POST', options);
};
const $7ddf80cc60c7a845$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
   * Confusing mapping of urls here.
   * Classic Projects - always under /automate
   * Next Gen Projects - under /automation for all project types except JSD
   */ switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});
parcelRegister("3Hdsq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKE23 = parcelRequire("fKE23");

var $bM4ts = parcelRequire("bM4ts");

$fKE23.__exportStar((parcelRequire("XSUjL")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $2b0fd39ee28a6034$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $2b0fd39ee28a6034$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $2b0fd39ee28a6034$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $2b0fd39ee28a6034$var$InvalidAriError;
function $2b0fd39ee28a6034$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $2b0fd39ee28a6034$var$basicCharConstraint = $bM4ts.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $2b0fd39ee28a6034$var$resourceTypeCharConstraints = $bM4ts.pattern(/^[a-z][a-z.-]*$/i);
const $2b0fd39ee28a6034$var$resourceOwnerConstraints = [
    $bM4ts.lengthBetween(3, 255),
    $2b0fd39ee28a6034$var$basicCharConstraint
];
const $2b0fd39ee28a6034$var$resourceTypeConstraints = [
    $bM4ts.lengthBetween(3, 255),
    $2b0fd39ee28a6034$var$resourceTypeCharConstraints
];
const $2b0fd39ee28a6034$var$cloudIdConstraints = [
    $bM4ts.lengthBetween(3, 255)
];
const $2b0fd39ee28a6034$var$siteResourceType = 'site';
const $2b0fd39ee28a6034$var$resourceIdChars = /[\w-._~:@#]/.source;
const $2b0fd39ee28a6034$var$resourceIdConstraints = [
    $bM4ts.pattern(new RegExp(`^${$2b0fd39ee28a6034$var$resourceIdChars}+(/${$2b0fd39ee28a6034$var$resourceIdChars}*)*(;v=${$2b0fd39ee28a6034$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $2b0fd39ee28a6034$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $2b0fd39ee28a6034$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $2b0fd39ee28a6034$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $2b0fd39ee28a6034$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $2b0fd39ee28a6034$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ static parse(ariString) {
        if (!ariString) throw new $2b0fd39ee28a6034$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $2b0fd39ee28a6034$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $2b0fd39ee28a6034$var$InvalidAriError(ariString);
        return new $2b0fd39ee28a6034$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $2b0fd39ee28a6034$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $2b0fd39ee28a6034$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $2b0fd39ee28a6034$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $2b0fd39ee28a6034$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $2b0fd39ee28a6034$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $2b0fd39ee28a6034$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $2b0fd39ee28a6034$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $2b0fd39ee28a6034$var$siteResourceType && !!other.resourceType || $2b0fd39ee28a6034$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $2b0fd39ee28a6034$var$siteResourceType && !!other.resourceType || $2b0fd39ee28a6034$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $2b0fd39ee28a6034$var$siteResourceType && !cloudId) return new $bM4ts.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $bM4ts.validateField(this, 'resourceOwner', $2b0fd39ee28a6034$var$resourceOwnerConstraints),
            $bM4ts.validateField(this, 'resourceType', $2b0fd39ee28a6034$var$resourceTypeConstraints),
            $bM4ts.validateField(this, 'resourceId', $2b0fd39ee28a6034$var$resourceIdConstraints),
            $bM4ts.validateField(this, 'cloudId', $2b0fd39ee28a6034$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $2b0fd39ee28a6034$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $2b0fd39ee28a6034$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $2b0fd39ee28a6034$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $2b0fd39ee28a6034$var$parse(ariString) {
    return $2b0fd39ee28a6034$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $2b0fd39ee28a6034$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $2b0fd39ee28a6034$var$parseEncoded(encodedAriString) {
    return $2b0fd39ee28a6034$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $2b0fd39ee28a6034$var$parseEncoded;

});
parcelRegister("bM4ts", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $M3rLj = parcelRequire("M3rLj");
class $8927a5e15ced8c21$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $8927a5e15ced8c21$var$LengthConstraint;
class $8927a5e15ced8c21$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $8927a5e15ced8c21$var$RegexConstraint;
class $8927a5e15ced8c21$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $8927a5e15ced8c21$var$GeneralValidationError;
class $8927a5e15ced8c21$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $8927a5e15ced8c21$var$ConstraintViolation;
function $8927a5e15ced8c21$var$lengthBetween(min, max) {
    return new $8927a5e15ced8c21$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $8927a5e15ced8c21$var$lengthBetween;
function $8927a5e15ced8c21$var$pattern(regex) {
    return new $8927a5e15ced8c21$var$RegexConstraint(regex);
}
module.exports.pattern = $8927a5e15ced8c21$var$pattern;
function $8927a5e15ced8c21$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($M3rLj.isDefined);
    return violatedConstraints.length > 0 ? new $8927a5e15ced8c21$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $8927a5e15ced8c21$var$validateField;

});
parcelRegister("M3rLj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $0907284485cca5f4$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $0907284485cca5f4$var$isPresent;
function $0907284485cca5f4$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $0907284485cca5f4$var$isDefined;
function $0907284485cca5f4$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $0907284485cca5f4$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $0907284485cca5f4$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $0907284485cca5f4$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $0907284485cca5f4$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $0907284485cca5f4$var$hasValueAtKey;

});


parcelRegister("XSUjL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jN9pX = parcelRequire("jN9pX");
var $0b401a425ffb471a$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($0b401a425ffb471a$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $0b401a425ffb471a$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $0b401a425ffb471a$var$AppFamilyAriError;
class $0b401a425ffb471a$var$NotAppFamilyAriError extends $0b401a425ffb471a$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $0b401a425ffb471a$var$NotAppFamilyAriError;
class $0b401a425ffb471a$var$NotExpectedAppFamilyAriTypeError extends $0b401a425ffb471a$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $0b401a425ffb471a$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $0b401a425ffb471a$var$parseAppAri(ari) {
    return $jN9pX.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $0b401a425ffb471a$var$parseAppAri;
function $0b401a425ffb471a$var$createAppAri(json) {
    return new $jN9pX.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $0b401a425ffb471a$var$createAppAri;

});
parcelRegister("jN9pX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $XSUjL = parcelRequire("XSUjL");

var $3Hdsq = parcelRequire("3Hdsq");

var $bM4ts = parcelRequire("bM4ts");
const $e689e6151d8ceaa8$var$versionPrefix = ';v=';
const $e689e6151d8ceaa8$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $e689e6151d8ceaa8$var$uuidConstraints = [
    $bM4ts.pattern(new RegExp(`^${$e689e6151d8ceaa8$var$uuidRegExpString}$`, 'i'))
];
const $e689e6151d8ceaa8$var$extensionGroupIdConstraints = [
    $bM4ts.pattern(new RegExp(`^(${$e689e6151d8ceaa8$var$uuidRegExpString}|static)$`, 'i'))
];
class $e689e6151d8ceaa8$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $XSUjL.AppFamilyAri.resourceOwner) throw new $XSUjL.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$XSUjL.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $XSUjL.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $XSUjL.NotAppFamilyAriError(ari, `resourceType must be one of ${$XSUjL.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $XSUjL.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($e689e6151d8ceaa8$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($e689e6151d8ceaa8$var$versionPrefix) > versionIndex) throw new $XSUjL.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($e689e6151d8ceaa8$var$versionPrefix);
        const segments = mainResourceId.split('/').map($e689e6151d8ceaa8$var$stripToUndefined);
        if (segments.length > 4) throw new $XSUjL.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $XSUjL.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $XSUjL.AppFamilyAri.extensionGroupResourceType || resourceType === $XSUjL.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $XSUjL.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $XSUjL.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$XSUjL.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $XSUjL.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $XSUjL.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$XSUjL.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $XSUjL.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $XSUjL.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$XSUjL.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $XSUjL.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $XSUjL.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$XSUjL.AppFamilyAri.environmentResourceType}`);
        return new $e689e6151d8ceaa8$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $XSUjL.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $bM4ts.validateField(this, 'environmentId', $e689e6151d8ceaa8$var$uuidConstraints),
            $bM4ts.validateField(this, 'appId', $e689e6151d8ceaa8$var$uuidConstraints),
            $bM4ts.validateField(this, 'extensionGroupId', $e689e6151d8ceaa8$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $3Hdsq.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $XSUjL.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$e689e6151d8ceaa8$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $3Hdsq.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $XSUjL.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $3Hdsq.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $XSUjL.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $3Hdsq.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $XSUjL.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $3Hdsq.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $XSUjL.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $e689e6151d8ceaa8$var$AppFamilyAriImpl;
function $e689e6151d8ceaa8$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});



parcelRegister("bSv1i", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $8a5cccc15f82ce85$export$6123178d3f5fb24d);
const $8a5cccc15f82ce85$var$AUTOMATION_LOCAL_STORAGE_PREFIX = 'automationPlatform';
const $8a5cccc15f82ce85$var$AUTOMATION_LOCAL_STORAGE_STACK = 'automationStack';
const $8a5cccc15f82ce85$var$AUTOMATION_DEV_STACK_URL = 'https://localhost:8082/devStack.json';
const $8a5cccc15f82ce85$var$getAutomationProdStackUrl = (cloudId)=>`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`;
const $8a5cccc15f82ce85$var$getLatestPreProdStack = async (cloudId)=>{
    try {
        const response = await fetch($8a5cccc15f82ce85$var$getAutomationProdStackUrl(cloudId));
        const stacksResponse = await response.json();
        const preProdStacks = stacksResponse.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        const [latestPreProdStack = null] = preProdStacks;
        return latestPreProdStack;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch pre-prod stack from ${$8a5cccc15f82ce85$var$getAutomationProdStackUrl(cloudId)} with error: ${e}`);
        return null;
    }
};
const $8a5cccc15f82ce85$var$_getAutomationKeyFromLocalStorage = (key)=>{
    return window.localStorage.getItem(`${$8a5cccc15f82ce85$var$AUTOMATION_LOCAL_STORAGE_PREFIX}:${key}`);
};
const $8a5cccc15f82ce85$var$getAutomationDevStackFromLocalServer = async ()=>{
    try {
        const devStackResponse = await fetch($8a5cccc15f82ce85$var$AUTOMATION_DEV_STACK_URL);
        const devStack = await devStackResponse.json();
        return devStack.name;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch dev stack from ${$8a5cccc15f82ce85$var$AUTOMATION_DEV_STACK_URL} with error: ${e}`);
        return null;
    }
};
const $8a5cccc15f82ce85$export$48cdb3ba720a47f6 = ()=>$8a5cccc15f82ce85$var$_getAutomationKeyFromLocalStorage($8a5cccc15f82ce85$var$AUTOMATION_LOCAL_STORAGE_STACK);
const $8a5cccc15f82ce85$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') return 'pro';
    if (env === 'pre-prod') {
        const stack = await $8a5cccc15f82ce85$var$getLatestPreProdStack(cloudId);
        return stack !== null && stack !== void 0 ? stack : 'pro';
    }
    // We fetch the dev stack name from local server (barrel webpack dev server) if it's available.
    // However, this requires that devWatch is running locally.
    // To use manual triggers without running devWatch, set the local storage value to your stack name e.g. devltan3. The full key is: automationPlatform:automationStack
    const stackOverride = await $8a5cccc15f82ce85$var$getAutomationDevStackFromLocalServer() || $8a5cccc15f82ce85$export$48cdb3ba720a47f6();
    return stackOverride || 'staging';
};

});



parcelRegister("cVYxc", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a9c3ca44f15adc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $6zOB7 = parcelRequire("6zOB7");

var $lzLxZ = parcelRequire("lzLxZ");
var $7jPhn = parcelRequire("7jPhn");
var $bKkhQ = parcelRequire("bKkhQ");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $aOOoM = parcelRequire("aOOoM");

var $klzXU = parcelRequire("klzXU");

var $1F7hK = parcelRequire("1F7hK");

var $8RGo1 = parcelRequire("8RGo1");

var $esKEN = parcelRequire("esKEN");

var $7aUt4 = parcelRequire("7aUt4");

var $8UBfX = parcelRequire("8UBfX");
const $96a9c3ca44f15adc$var$UserInputForm = (props)=>{
    const { selectedRule: selectedRule, clearSelectedRule: clearSelectedRule, invokeRule: invokeRule, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed } = props;
    const { rule: rule, objects: objects } = selectedRule;
    const { userInputPrompts: userInputPrompts } = rule;
    const getTypeOfInput = (key, prompts)=>{
        var _prompts$find;
        return (_prompts$find = prompts.find(({ variableName: variableName })=>variableName === key)) === null || _prompts$find === void 0 ? void 0 : _prompts$find.inputType;
    };
    const generateInputValue = (inputType, data)=>{
        switch(inputType){
            case (0, $klzXU.UserInputType).DROPDOWN:
                return {
                    inputType: inputType,
                    value: data ? data.value : ''
                };
            case (0, $klzXU.UserInputType).NUMBER:
                return {
                    inputType: inputType,
                    value: Number(data)
                };
            default:
                return {
                    inputType: inputType,
                    value: data
                };
        }
    };
    const handleSubmit = (data)=>{
        const output = Object.entries(data).reduce((acc, [key, value])=>{
            const inputType = getTypeOfInput(key, userInputPrompts);
            if (!inputType) return acc;
            acc[key] = generateInputValue(inputType, value);
            return acc;
        }, {});
        return invokeRule(rule.id, objects, output);
    };
    const handleOpen = ()=>{
        if (onInputsModalOpened) onInputsModalOpened();
    };
    const handleClose = ()=>{
        clearSelectedRule();
        if (onInputsModalClosed) onInputsModalClosed();
    };
    const generateUserInputForm = (inputPrompt)=>{
        switch(inputPrompt.inputType){
            case (0, $klzXU.UserInputType).TEXT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8UBfX.default), {
                    key: inputPrompt.variableName,
                    userInputPrompt: inputPrompt
                });
            case (0, $klzXU.UserInputType).NUMBER:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8RGo1.default), {
                    key: inputPrompt.variableName,
                    userInputPrompt: inputPrompt
                });
            case (0, $klzXU.UserInputType).DROPDOWN:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7aUt4.default), {
                    key: inputPrompt.variableName,
                    userInputPrompt: inputPrompt
                });
            case (0, $klzXU.UserInputType).BOOLEAN:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1F7hK.default), {
                    key: inputPrompt.variableName,
                    userInputPrompt: inputPrompt
                });
            case (0, $klzXU.UserInputType).PARAGRAPH:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $esKEN.default), {
                    key: inputPrompt.variableName,
                    userInputPrompt: inputPrompt
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, (0, $aOOoM.default).errorInputTypeIsNotSupported.defaultMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        "data-testid": "automation-platform.ui.manual-rules-container.manual-triggers-form.modal",
        onClose: handleClose,
        onOpenComplete: handleOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
        onSubmit: handleSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, rule.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, (0, $aOOoM.default).inputRequiredForAction.defaultMessage, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bKkhQ.default), null, userInputPrompts.map(generateUserInputForm))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            appearance: "subtle",
            onClick: handleClose,
            isDisabled: submitting
        }, (0, $aOOoM.default).cancelButtonTitle.defaultMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            appearance: "primary",
            type: "submit",
            isLoading: submitting,
            autoFocus: true
        }, (0, $aOOoM.default).continueButtonTitle.defaultMessage)))));
};
var $96a9c3ca44f15adc$export$2e2bcd8739ae039 = $96a9c3ca44f15adc$var$UserInputForm;

});
parcelRegister("bKkhQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c95da9811468ff1e$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $c95da9811468ff1e$var$formSectionDescriptionStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.100'
});
const $c95da9811468ff1e$var$formSectionWrapperStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.300'
});
const $c95da9811468ff1e$var$FormSectionWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $c95da9811468ff1e$var$formSectionWrapperStyles
    }, children);
};
const $c95da9811468ff1e$var$FormSectionDescription = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $c95da9811468ff1e$var$formSectionDescriptionStyles
    }, children);
};
/**
 * __Form section__.
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $c95da9811468ff1e$var$FormSection = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)($c95da9811468ff1e$var$FormSectionWrapper, null, title && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hI5oG.default), {
        size: "medium"
    }, title), description && /*#__PURE__*/ (0, $byn9U.jsx)($c95da9811468ff1e$var$FormSectionDescription, null, description), children);
};
var $c95da9811468ff1e$export$2e2bcd8739ae039 = $c95da9811468ff1e$var$FormSection;

});

parcelRegister("aOOoM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e05ab02267943c4$export$2e2bcd8739ae039);
const $7e05ab02267943c4$var$messages = {
    successFlag: {
        id: 'automation-platform.common.success-flag',
        defaultMessage: 'Your automation is in progress',
        description: 'Text for a success flag when an automation rule has been triggered'
    },
    failureFlagTitle: {
        id: 'automation-platform.common.failure-flag-title',
        defaultMessage: 'Oops we ran into a problem',
        description: 'Title for an error flag when an automation rule failed to be triggered'
    },
    failureFlagDescription: {
        id: 'automation-platform.common.failure-flag-description',
        defaultMessage: "There was a problem and we couldn't run the automation '{0}'",
        description: 'Description for an error flag when an automation rule failed to be triggered'
    },
    partialFailureFlagDescription: {
        id: 'automation-platform.common.partial-failure-flag-description',
        defaultMessage: "Couldn't run the automation against issues {0}, please ensure you have permission to view these issues",
        description: 'Description for an error flag when some issues failed to invoke because user does not have view permission'
    },
    errorInputMustNotBeEmpty: {
        id: 'automation-platform.common.error-input-must-not-be-empty',
        defaultMessage: 'Input must not be empty',
        description: 'The error message to show the value of a required field is empty'
    },
    errorInputCharacterLimitReached: {
        id: 'automation-platform.common.error-input-character-limit-reached',
        defaultMessage: 'Provided value exceeds the character limit for the field.',
        description: 'The error message to show that the character limit has been reached for the field'
    },
    inputRequiredForAction: {
        id: 'automation-platform.common.input-required-for-action',
        defaultMessage: 'Your input is required to complete this action',
        description: 'The title of the modal for user inputs'
    },
    errorInputTypeIsNotSupported: {
        id: 'automation-platform.common.error-input-type-is-not-supported',
        defaultMessage: 'Input type not supported yet',
        description: 'The error message to show when the type of user input is not recognised'
    },
    errorValueIsNotValidNumber: {
        id: 'automation-platform.common.error-value-is-not-valid-number',
        defaultMessage: 'The value is not a valid number',
        description: 'The error message for when the type of user input is number but the value is not a valid number'
    },
    cancelButtonTitle: {
        id: 'automation-platform.common.cancel-button-title',
        defaultMessage: 'Cancel',
        description: 'The cancel button title'
    },
    continueButtonTitle: {
        id: 'automation-platform.common.continue-button-title',
        defaultMessage: 'Continue',
        description: 'The continue button title'
    }
};
var $7e05ab02267943c4$export$2e2bcd8739ae039 = $7e05ab02267943c4$var$messages;

});

parcelRegister("klzXU", function(module, exports) {

$parcel$export(module.exports, "UserInputType", () => $ed01aac91d0b81c8$export$955ccc93b55d5904);
let $ed01aac91d0b81c8$export$955ccc93b55d5904 = /*#__PURE__*/ function(UserInputType) {
    UserInputType["NUMBER"] = "NUMBER";
    UserInputType["TEXT"] = "TEXT";
    UserInputType["BOOLEAN"] = "BOOLEAN";
    UserInputType["DROPDOWN"] = "DROPDOWN";
    UserInputType["PARAGRAPH"] = "PARAGRAPH";
    return UserInputType;
}({});
const $ed01aac91d0b81c8$export$4b79f735ed858abe = 'business';
const $ed01aac91d0b81c8$export$417275bac62d38d2 = 'software';
const $ed01aac91d0b81c8$export$9c9c9eaf8c092006 = 'service_desk';
const $ed01aac91d0b81c8$export$e9fe9a39cc7f5103 = 'product_discovery';

});

parcelRegister("1F7hK", function(module, exports) {

$parcel$export(module.exports, "default", () => $135f457e7d190ee6$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");


var $bT7k5 = parcelRequire("bT7k5");

var $fq5oV = parcelRequire("fq5oV");
const $135f457e7d190ee6$var$BooleanInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    const { variableName: variableName, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fq5oV.default), {
        name: variableName,
        defaultIsChecked: defaultValue || false
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), (0, $kU09D.default)({}, fieldProps, {
            label: displayName
        })));
};
var $135f457e7d190ee6$export$2e2bcd8739ae039 = $135f457e7d190ee6$var$BooleanInputPrompt;

});
parcelRegister("fq5oV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4e274233a51aeef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4LhB6 = parcelRequire("4LhB6");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $f4e274233a51aeef$var$CheckboxField = (props)=>{
    const { children: children, defaultIsChecked: defaultIsChecked = false, value: value, ...rest } = props;
    // Maintains a memoised list of the default values
    const defaultValue = (0, $eUqFw.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        ...rest,
        defaultValue: defaultValue,
        transform: (event, currentValue)=>event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value)
    }, ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
            fieldProps: {
                ...otherFieldProps,
                isChecked: !!fieldValue.find((v)=>v === value),
                value: value
            },
            ...others
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        ...rest,
        defaultValue: defaultIsChecked,
        transform: (event)=>event.currentTarget.checked
    }, ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
            fieldProps: {
                ...otherFieldProps,
                isChecked: fieldValue,
                value: value
            },
            ...others
        }));
};
$f4e274233a51aeef$var$CheckboxField.defaultProps = {
    defaultIsChecked: false
};
var $f4e274233a51aeef$export$2e2bcd8739ae039 = $f4e274233a51aeef$var$CheckboxField;

});


parcelRegister("8RGo1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6744270f1e04e138$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $cf2Y4 = parcelRequire("cf2Y4");

var $aOOoM = parcelRequire("aOOoM");
let $6744270f1e04e138$export$b8e9cd941e8016ac = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    Errors["INVALID_NUMBER"] = "INVALID_NUMBER";
    return Errors;
}({});
const $6744270f1e04e138$export$c6cbc3bbef9e5a54 = (isRequired, value)=>{
    if (isRequired && !value) return $6744270f1e04e138$export$b8e9cd941e8016ac.EMPTY;
    if (value && Number.isNaN(Number(value))) return $6744270f1e04e138$export$b8e9cd941e8016ac.INVALID_NUMBER;
    return undefined;
};
const $6744270f1e04e138$var$NumberInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const generateErrorMessage = (error)=>{
        switch(error){
            case $6744270f1e04e138$export$b8e9cd941e8016ac.EMPTY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, (0, $aOOoM.default).errorInputMustNotBeEmpty.defaultMessage);
            case $6744270f1e04e138$export$b8e9cd941e8016ac.INVALID_NUMBER:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, (0, $aOOoM.default).errorValueIsNotValidNumber.defaultMessage);
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        key: variableName,
        "aria-required": required,
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: (value)=>$6744270f1e04e138$export$c6cbc3bbef9e5a54(required, value)
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), fieldProps), generateErrorMessage(error)));
};
var $6744270f1e04e138$export$2e2bcd8739ae039 = $6744270f1e04e138$var$NumberInputPrompt;

});

parcelRegister("esKEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a877df585659ea9c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $xeS7R = parcelRequire("xeS7R");

var $aOOoM = parcelRequire("aOOoM");
var $a877df585659ea9c$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    Errors["CHARACTER_LIMIT"] = "CHARACTER_LIMIT";
    return Errors;
}($a877df585659ea9c$var$Errors || {});
const $a877df585659ea9c$var$MAX_PARAGRAPH_CHARACTER_LIMIT = 5000;
const $a877df585659ea9c$var$ParagraphInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>{
        if (required && !value) return $a877df585659ea9c$var$Errors.EMPTY;
        if (value && (value === null || value === void 0 ? void 0 : value.trim().length) === 0) return $a877df585659ea9c$var$Errors.EMPTY;
        if (value && value.length > $a877df585659ea9c$var$MAX_PARAGRAPH_CHARACTER_LIMIT) return $a877df585659ea9c$var$Errors.CHARACTER_LIMIT;
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: validate
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xeS7R.default), fieldProps), error === $a877df585659ea9c$var$Errors.EMPTY && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, (0, $aOOoM.default).errorInputMustNotBeEmpty.defaultMessage), error === $a877df585659ea9c$var$Errors.CHARACTER_LIMIT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, (0, $aOOoM.default).errorInputCharacterLimitReached.defaultMessage)));
};
var $a877df585659ea9c$export$2e2bcd8739ae039 = $a877df585659ea9c$var$ParagraphInputPrompt;

});

parcelRegister("7aUt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $539544e80f0b4b9e$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");


var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $4zgIJ = parcelRequire("4zgIJ");

var $aOOoM = parcelRequire("aOOoM");
var $539544e80f0b4b9e$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    return Errors;
}($539544e80f0b4b9e$var$Errors || {});
const $539544e80f0b4b9e$var$SelectInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>{
        if (required && !value) return $539544e80f0b4b9e$var$Errors.EMPTY;
        return undefined;
    };
    const selectOptions = defaultValue.map((value)=>({
            label: value,
            value: value
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: variableName,
        label: displayName,
        isRequired: required,
        validate: validate
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), (0, $kU09D.default)({
            isClearable: true,
            isSearchable: true,
            options: selectOptions,
            menuPosition: "fixed"
        }, fieldProps)), error === $539544e80f0b4b9e$var$Errors.EMPTY && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, (0, $aOOoM.default).errorInputMustNotBeEmpty.defaultMessage)));
};
var $539544e80f0b4b9e$export$2e2bcd8739ae039 = $539544e80f0b4b9e$var$SelectInputPrompt;

});

parcelRegister("8UBfX", function(module, exports) {

$parcel$export(module.exports, "default", () => $67d07404e95b813f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $cf2Y4 = parcelRequire("cf2Y4");

var $aOOoM = parcelRequire("aOOoM");
var $67d07404e95b813f$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    return Errors;
}($67d07404e95b813f$var$Errors || {});
const $67d07404e95b813f$var$TextInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>required && !value ? $67d07404e95b813f$var$Errors.EMPTY : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: validate
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), fieldProps), error === $67d07404e95b813f$var$Errors.EMPTY && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, (0, $aOOoM.default).errorInputMustNotBeEmpty.defaultMessage)));
};
var $67d07404e95b813f$export$2e2bcd8739ae039 = $67d07404e95b813f$var$TextInputPrompt;

});



parcelRegister("5WDnM", function(module, exports) {

$parcel$export(module.exports, "default", () => $af00b656d7db5a72$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $af00b656d7db5a72$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    successFlag: {
        "id": "automation-platform.common.success-flag",
        "defaultMessage": "Your automation is in progress"
    },
    failureFlagTitle: {
        "id": "automation-platform.common.failure-flag-title",
        "defaultMessage": "Oops we ran into a problem"
    },
    failureFlagDescription: {
        "id": "automation-platform.common.failure-flag-description",
        "defaultMessage": "There was a problem and we couldn't run the automation \"{0}\""
    },
    partialFailureFlagDescription: {
        "id": "automation-platform.common.partial-failure-flag-description",
        "defaultMessage": "Couldn't run the automation against issues \"{0}\", please ensure you have permission to view these issues"
    },
    errorInputMustNotBeEmpty: {
        "id": "automation-platform.common.error-input-must-not-be-empty",
        "defaultMessage": "Input must not be empty"
    },
    errorInputCharacterLimitReached: {
        "id": "automation-platform.common.error-input-character-limit-reached",
        "defaultMessage": "Provided value exceeds the character limit for the field."
    },
    inputRequiredForAction: {
        "id": "automation-platform.common.input-required-for-action",
        "defaultMessage": "Your input is required to complete this action"
    },
    errorInputTypeIsNotSupported: {
        "id": "automation-platform.common.error-input-type-is-not-supported",
        "defaultMessage": "Input type not supported yet"
    },
    errorValueIsNotValidNumber: {
        "id": "automation-platform.common.error-value-is-not-valid-number",
        "defaultMessage": "The value is not a valid number"
    },
    cancelButtonTitle: {
        "id": "automation-platform.common.cancel-button-title",
        "defaultMessage": "Cancel"
    },
    continueButtonTitle: {
        "id": "automation-platform.common.continue-button-title",
        "defaultMessage": "Continue"
    }
});

});


parcelRegister("50D0V", function(module, exports) {

$parcel$export(module.exports, "isOnlyGlobalTransitions", () => $eb8c09ff04a7e642$export$10992041bf7e444a);
$parcel$export(module.exports, "getFilteredOrderedTransitions", () => $eb8c09ff04a7e642$export$707115549202b9e4);
$parcel$export(module.exports, "getLoopedTransitionsForStatus", () => $eb8c09ff04a7e642$export$38146914a8d06579);
$parcel$export(module.exports, "transformOptions", () => $eb8c09ff04a7e642$export$8f4ed8ef83bcbf04);
$parcel$export(module.exports, "getStatusShape", () => $eb8c09ff04a7e642$export$e2dafe47b17b2cfc);

var $5iWql = parcelRequire("5iWql");

var $8Qd0L = parcelRequire("8Qd0L");

var $iccsh = parcelRequire("iccsh");
const $eb8c09ff04a7e642$var$isGlobalSelfTransition = (transition, currentStatusId)=>transition.isGlobal && transition.to.id === currentStatusId;
const $eb8c09ff04a7e642$var$isInitialSelfTransition = (transition, currentStatusId)=>transition.isInitial && transition.to.id === currentStatusId;
const $eb8c09ff04a7e642$var$isLoopedTransitionToSelf = (transition, currentStatusId)=>transition.to.id === currentStatusId && transition.isLooped === true;
const $eb8c09ff04a7e642$var$filterLoopedTransitionsToSelf = (0, $5iWql.default)((transitions, currentStatusId)=>transitions.filter((transition)=>!$eb8c09ff04a7e642$var$isLoopedTransitionToSelf(transition, currentStatusId) && !$eb8c09ff04a7e642$var$isGlobalSelfTransition(transition, currentStatusId) && !((0, $iccsh.isStatusInGicEnabled)() && $eb8c09ff04a7e642$var$isInitialSelfTransition(transition, currentStatusId))));
const $eb8c09ff04a7e642$export$10992041bf7e444a = (transitions)=>transitions.every((t)=>t.isGlobal);
const $eb8c09ff04a7e642$export$707115549202b9e4 = (transitions, currentStatusId)=>$eb8c09ff04a7e642$var$filterLoopedTransitionsToSelf(transitions || [], currentStatusId);
const $eb8c09ff04a7e642$export$38146914a8d06579 = (0, $5iWql.default)((transitions, currentStatusId)=>(transitions || []).filter((transition)=>$eb8c09ff04a7e642$var$isLoopedTransitionToSelf(transition, currentStatusId)));
const $eb8c09ff04a7e642$var$formatOptions = (options)=>options.map((t)=>({
            label: t.to.name,
            value: t.id,
            transition: t
        }));
const $eb8c09ff04a7e642$var$memoizedTranformOptions = (0, $5iWql.default)($eb8c09ff04a7e642$var$formatOptions);
const $eb8c09ff04a7e642$export$8f4ed8ef83bcbf04 = (options)=>$eb8c09ff04a7e642$var$memoizedTranformOptions(options);
const $eb8c09ff04a7e642$export$e2dafe47b17b2cfc = (id, name, category)=>{
    const statusCategoryId = (0, $8Qd0L.StatusCategoryIds)[category] || (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).UNDEFINED];
    return {
        id: id,
        name: name,
        statusCategory: {
            id: statusCategoryId,
            name: name
        }
    };
};

});
parcelRegister("iccsh", function(module, exports) {

$parcel$export(module.exports, "isStatusInGicEnabled", () => $96fedf0b1762860e$export$30cd538422d6ae26);
$parcel$export(module.exports, "isTabularGridFieldsEnabled", () => $96fedf0b1762860e$export$9605b1d5fe0c238b);
$parcel$export(module.exports, "isWorkflowDataServiceHookEnabled", () => $96fedf0b1762860e$export$60184d6d974595a9);
$parcel$export(module.exports, "isFitAndFinishEnabled", () => $96fedf0b1762860e$export$cfa6cc4c08910489);

var $1ybV0 = parcelRequire("1ybV0");
const $96fedf0b1762860e$export$30cd538422d6ae26 = ()=>(0, $1ybV0.ff)('issue.details.gic.add_status_field', false);
const $96fedf0b1762860e$export$455240e4be839479 = 'jsw.uif.tmp.card.tabular.grid';
const $96fedf0b1762860e$export$9605b1d5fe0c238b = ()=>(0, $1ybV0.ff)($96fedf0b1762860e$export$455240e4be839479, false);
const $96fedf0b1762860e$export$60184d6d974595a9 = ()=>(0, $1ybV0.ff)('use-view-workflow-service-hook_8y6bk', false);
const $96fedf0b1762860e$export$cfa6cc4c08910489 = ()=>(0, $1ybV0.ff)('jsw-tanuki-fit-and-finish_hnved'); // </emoore>

});


parcelRegister("jsdzI", function(module, exports) {

$parcel$export(module.exports, "StatusService", () => $d76053b5c4e70df9$export$3e14b51c9a9c5a1a);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");
var $lRmyA = parcelRequire("lRmyA");
var $7byHA = parcelRequire("7byHA");

var $5oIBC = parcelRequire("5oIBC");

var $kmr29 = parcelRequire("kmr29");

var $1a3la = parcelRequire("1a3la");

var $4ceCM = parcelRequire("4ceCM");

var $gZAPr = parcelRequire("gZAPr");

var $1DnzP = parcelRequire("1DnzP");

var $huI7r = parcelRequire("huI7r");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");

var $dWLk9 = parcelRequire("dWLk9");


var $3NyMT = parcelRequire("3NyMT");

var $h0MK3 = parcelRequire("h0MK3");

var $18TMj = parcelRequire("18TMj");

var $8tRzR = parcelRequire("8tRzR");
const $d76053b5c4e70df9$export$7a6a15706decd0f9 = '#issue-workflow-transition-submit';
const $d76053b5c4e70df9$export$582c70653d60fda9 = (selector, event, handler)=>{
    const el = document.querySelector(selector);
    if (el) el.removeEventListener(event, handler);
};
const $d76053b5c4e70df9$export$8e05e1932c4b20b0 = (selector, event, handler)=>{
    $d76053b5c4e70df9$export$582c70653d60fda9(selector, event, handler);
    const el = document.querySelector(selector);
    if (el) el.addEventListener(event, handler);
};
// eslint-disable-next-line jira/react/no-class-components
class $d76053b5c4e70df9$export$be60a1d722248cfa extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onEditCancel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    /**
	 * Lets the consumer control the value of this component. If the consumer passes a `value` prop
	 * it will override the value in state, as long as the component is not in loading state. That's because the component
	 * will only let the consumer know about the new status value once the transition is complete (i.e. loading=false).
	 *
	 * This lifecycle method gets called before every invocation of render().
	 */ static getDerivedStateFromProps(props, state) {
        if (state.loading || !props.value) return null;
        return {
            value: props.value
        };
    }
    constructor(props){
        super(props);
        this.componentDidUpdate = (prevProps)=>{
            // If we receive a new prop that is different to the old one and it is different
            // to our state then trust it and update the state.
            if (this.props.initialValue && prevProps.initialValue && prevProps.initialValue.id !== this.props.initialValue.id && this.props.initialValue.id !== this.state.value.id) this.setState({
                loading: false,
                value: this.props.initialValue
            });
        };
        this.isDialogOpened = false;
        this.isDialogConfirmPressed = false;
        this.onDialogContentReady = ()=>{
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                this.bindDialogFormHandlers();
                this.isDialogOpened = true;
                this.isDialogConfirmPressed = false;
            });
        };
        this.bindDialogFormHandlers = ()=>{
            $d76053b5c4e70df9$export$8e05e1932c4b20b0($d76053b5c4e70df9$export$7a6a15706decd0f9, 'click', this.onClickDialogConfirm);
        };
        this.unbindDialogFormHandlers = ()=>{
            $d76053b5c4e70df9$export$582c70653d60fda9($d76053b5c4e70df9$export$7a6a15706decd0f9, 'click', this.onClickDialogConfirm);
        };
        this.handleBeforeDialogHide = ()=>{
            this.unbindDialogFormHandlers();
            this.isDialogOpened = false;
            this.isDialogConfirmPressed = false;
        };
        this.onClickDialogConfirm = ()=>{
            // Dialog confirm button press will result in either successfull closing of dialog, or error and dialog re-rendering,
            // so we are starting both interactions
            this.isDialogConfirmPressed = true;
        };
        this.resetError = ()=>this.setState({
                error: null
            });
        this.submit = (transition, event)=>{
            const oldValue = this.state.value;
            const newValue = transition.to;
            this.setState({
                loading: true,
                value: newValue
            });
            this.props.onSubmit(oldValue, newValue, {
                transition: transition
            }, event);
        };
        this.success = ({ status: status, event: event, viaDialog: viaDialog = false })=>{
            this.setState({
                loading: false,
                lastSavedValue: status
            });
            this.props.fieldValueActions.setFieldValue(this.props.issueKey, (0, $lO4Or.STATUS_TYPE), status);
            this.props.onSuccess(status, viaDialog, event);
            (0, $jMP2a.fireTrackAnalytics)(event, 'statusField transitioned', 'statusField');
            (0, $4ceCM.sendExperienceAnalytics)((0, $h0MK3.transitionIssueExperienceDescription)(true, 'POST', 'Issue View Status Service', this.props.projectType));
        };
        this.failure = (error, event)=>{
            this.setState({
                error: error,
                loading: false,
                value: this.state.lastSavedValue || this.props.value || this.props.initialValue
            });
            if ((0, $1ybV0.ff)('jira-issue-fields-status-service-on-failure-handler-pass-error_pp4wf')) this.props.onFailure(error);
            else this.props.onFailure();
            const isValidationError = error instanceof (0, $7byHA.ValidationError);
            if (isValidationError) this.props.flagService.showFlag((0, $8tRzR.default)(error.message));
            else this.props.flagService.showFlag((0, $18TMj.default)());
            (0, $jMP2a.fireOperationalAnalytics)(event, 'statusField postTransitionFailed', {
                validationError: isValidationError,
                isClientFetchError: (0, $JRB5w.isClientFetchError)(error)
            });
            if ((0, $gZAPr.default)(error)) (0, $4ceCM.sendExperienceAnalytics)((0, $h0MK3.transitionIssueExperienceDescription)(false, 'POST', 'Issue View Status Service', this.props.projectType, error.message, error.traceId));
            else (0, $4ceCM.sendExperienceAnalytics)((0, $h0MK3.transitionIssueExperienceDescription)(true, 'POST', 'Issue View Status Service', this.props.projectType));
        };
        this.cancel = ()=>{
            // @ts-expect-error - TS2322 - Type 'Status | undefined' is not assignable to type 'Status'.
            this.setState({
                loading: false,
                value: this.props.value || this.props.initialValue
            });
            this.props.onEditCancel();
            this.props.workflowTransitionsActions.setTransitionInProgress(false);
        };
        this.transitionStatus = async (transition, event)=>{
            const { appearance: appearance, issueKey: issueKey, baseUrl: baseUrl, renderIssueTransitionModal: renderIssueTransitionModal } = this.props;
            const newStatus = transition.to;
            this.submit(transition, event);
            try {
                if (transition.hasScreen) {
                    const handleDialogSuccess = ()=>{
                        (0, $jMP2a.fireTrackAnalytics)(event, 'issueTransition success', {
                            triggerPointKey: (0, $3NyMT.ISSUE_TRANSITION_STATUS_FIELD),
                            isModalOpen: true
                        });
                        return this.success({
                            status: newStatus,
                            event: event,
                            viaDialog: true
                        });
                    };
                    const handleDialogCancel = ()=>{
                        (0, $jMP2a.fireTrackAnalytics)(event, 'issueTransition cancel', {
                            triggerPointKey: (0, $3NyMT.ISSUE_TRANSITION_STATUS_FIELD),
                            isModalOpen: true
                        });
                        return this.cancel();
                    };
                    const handleDialogError = ()=>{
                        (0, $jMP2a.fireTrackAnalytics)(event, 'issueTransition failed', {
                            triggerPointKey: (0, $3NyMT.ISSUE_TRANSITION_STATUS_FIELD),
                            isModalOpen: true
                        });
                    };
                    if (renderIssueTransitionModal) {
                        const { issueId: issueId } = this.props;
                        renderIssueTransitionModal({
                            payload: {
                                issueId: issueId,
                                issueKey: issueKey,
                                transitionId: transition.id
                            },
                            triggerPointKey: appearance === 'lozenge' ? 'issue-transition-status-field-trigger' : 'issue-transition-issue-view',
                            onDialogSuccess: handleDialogSuccess,
                            onDialogCancel: handleDialogCancel,
                            onDialogError: handleDialogError,
                            analyticsEvent: event
                        });
                    }
                } else {
                    await (0, $lRmyA.performPostRequest)(`${baseUrl}/rest/api/2/issue/${issueKey}/transitions`, {
                        body: JSON.stringify({
                            transition: transition
                        })
                    });
                    (0, $jMP2a.fireTrackAnalytics)(event, 'issueTransition success', {
                        triggerPointKey: (0, $3NyMT.ISSUE_TRANSITION_STATUS_FIELD),
                        isModalOpen: false
                    });
                    this.success({
                        status: newStatus,
                        event: event
                    });
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $e7647232d7445c32$export$25529a3376b831fd), error);
                (0, $jMP2a.fireTrackAnalytics)(event, 'issueTransition failed', {
                    triggerPointKey: (0, $3NyMT.ISSUE_TRANSITION_STATUS_FIELD),
                    isModalOpen: false
                });
                this.failure(error, event);
            }
        };
        this.api = {
            transitionStatus: this.transitionStatus,
            resetError: this.resetError
        };
        const value = props.value || props.initialValue;
        if (value == null) throw new Error('Either value or initialValue prop is required.');
        this.state = {
            value: value,
            lastSavedValue: value,
            loading: false,
            error: null
        };
    }
    componentDidMount() {
        document.addEventListener('legacyJiraDialogContentReady', this.onDialogContentReady);
        document.addEventListener('legacyJiraDialogBeforeHide', this.handleBeforeDialogHide);
    }
    componentWillUnmount() {
        document.removeEventListener('legacyJiraDialogContentReady', this.onDialogContentReady);
        document.removeEventListener('legacyJiraDialogBeforeHide', this.handleBeforeDialogHide);
        this.unbindDialogFormHandlers();
        this.isDialogOpened = false;
    }
    render() {
        return this.props.children({
            ...this.state,
            ...this.api
        });
    }
}
const $d76053b5c4e70df9$var$StatusServiceForMigrateIssueTransitionEnabled = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d76053b5c4e70df9$var$StatusServiceWithoutAriId, props);
const $d76053b5c4e70df9$var$StatusServiceWithoutAriId = (props)=>{
    const { issueId: issueId } = props;
    const cloudId = (0, $dWLk9.useCloudId)();
    const ariIssueId = issueId ? (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId
    }) : undefined;
    const renderIssueTransitionModal = (0, $1a3la.useOpenIssueTransitionModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d76053b5c4e70df9$export$be60a1d722248cfa, {
        ...props,
        renderIssueTransitionModal: renderIssueTransitionModal,
        issueId: ariIssueId
    });
};
const $d76053b5c4e70df9$var$StatusWithValueService = (props)=>{
    const [, workflowTransitionsActions] = (0, $1DnzP.useWorkflowTransitionsActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kmr29.FieldValueSubscriber), {
        issueKey: props.issueKey,
        fieldKey: (0, $lO4Or.STATUS_TYPE)
    }, (value, fieldValueActions)=>{
        const statusServiceProps = {
            value: // Overrides the value in the store if the consumer really wants to do it
            value,
            ...props,
            fieldValueActions: fieldValueActions,
            workflowTransitionsActions: workflowTransitionsActions
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d76053b5c4e70df9$var$StatusServiceForMigrateIssueTransitionEnabled, statusServiceProps);
    });
};
const $d76053b5c4e70df9$export$3e14b51c9a9c5a1a = (0, $5oIBC.default)($d76053b5c4e70df9$var$StatusWithValueService);

});
parcelRegister("1a3la", function(module, exports) {

$parcel$export(module.exports, "useOpenIssueTransitionModal", () => $2ec6874397d8d50c$export$736bd10472c63b49);
$parcel$export(module.exports, "useTriggerIssueTransitionModal", () => $2ec6874397d8d50c$export$95a1e9702d78f223);

var $eUqFw = parcelRequire("eUqFw");

var $6XOSh = parcelRequire("6XOSh");

var $b3pJg = parcelRequire("b3pJg");
const $2ec6874397d8d50c$export$736bd10472c63b49 = ()=>{
    const { openIssueTransitionModal: openIssueTransitionModalAction } = (0, $b3pJg.useTriggerIssueTransitionModalActions)();
    const { stateGet: { state: { isEnabled: isEnabled = true } = {} } = {} } = (0, $6XOSh.useIssueTransitionLabsOptIn)();
    return (0, $eUqFw.useCallback)((nextState)=>{
        openIssueTransitionModalAction(nextState, isEnabled);
    }, [
        isEnabled,
        openIssueTransitionModalAction
    ]);
};
const $2ec6874397d8d50c$export$95a1e9702d78f223 = ()=>{
    const state = (0, $b3pJg.useTriggerIssueTransitionModalState)();
    const actions = (0, $b3pJg.useTriggerIssueTransitionModalActions)();
    const openIssueTransitionModal = $2ec6874397d8d50c$export$736bd10472c63b49();
    return [
        state,
        {
            ...actions,
            openIssueTransitionModal: openIssueTransitionModal
        }
    ];
};
var $2ec6874397d8d50c$export$2e2bcd8739ae039 = $2ec6874397d8d50c$export$95a1e9702d78f223;

});
parcelRegister("6XOSh", function(module, exports) {

$parcel$export(module.exports, "issueTransitionOptInStatusResource", () => $839ddb0b122518f6$export$5fbcf4d7a6d9c477);
$parcel$export(module.exports, "useIssueTransitionLabsOptIn", () => $839ddb0b122518f6$export$bc11d4816053db5c);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");


var $ZKxj9 = parcelRequire("ZKxj9");
/*
 * API Contract: https://hello.atlassian.net/wiki/spaces/JIE/pages/2983777277/Issue+Transition+Jira+Labs+Toggle+for+Legacy+Experience+Backend+API#API-Contract
 */ const $839ddb0b122518f6$var$fetchGetIssueTransitionOptInState = async ()=>(0, $lRmyA.performGetRequest)((0, $62811791007d8b59$export$466b1c60da56c8ca));
const $839ddb0b122518f6$export$5fbcf4d7a6d9c477 = (0, $3HCkE.createResource)({
    type: (0, $62811791007d8b59$export$eb01e12fc3db65c0),
    getKey: ()=>(0, $62811791007d8b59$export$a964df7bc15d81e),
    getData: async ()=>{
        let issueTransitionOptInStatus = null;
        const isModernIssueTransitionSRBCohort = (0, $1ybV0.ff)('issue-transition-customisation-for-srb_0eyvc');
        const isModernITSRenderEnabled = (0, $1ybV0.ff)('render-modern-issue-transition_cxt0z');
        if (!isModernITSRenderEnabled) return {
            issueTransitionOptInStatus: {
                isEnabled: false,
                expiryTime: -1
            }
        };
        if (isModernIssueTransitionSRBCohort) return {
            issueTransitionOptInStatus: {
                isEnabled: true
            }
        };
        try {
            issueTransitionOptInStatus = await $839ddb0b122518f6$var$fetchGetIssueTransitionOptInState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'issueTransitionOptInStatusResource',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            issueTransitionOptInStatus: issueTransitionOptInStatus ?? (0, $ZKxj9.default)()
        };
    },
    maxAge: Number.MAX_VALUE
});
const $839ddb0b122518f6$var$fetchModifyIssueTransitionOptInState = async (payload)=>(0, $lRmyA.performPutRequest)((0, $62811791007d8b59$export$466b1c60da56c8ca), {
        body: JSON.stringify(payload)
    });
const $839ddb0b122518f6$export$bc11d4816053db5c = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $3HCkE.useResource)($839ddb0b122518f6$export$5fbcf4d7a6d9c477);
    const [issueTransitionLabsOptInState, setIssueTransitionOptInState] = (0, $eUqFw.useState)(()=>{
        if (data?.issueTransitionOptInStatus) return data.issueTransitionOptInStatus;
        return (0, $ZKxj9.default)();
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eUqFw.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $eUqFw.useState)('not started');
    const updateIssueTransitionOptInStatus = (0, $eUqFw.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        try {
            const updatedPreferences = await $839ddb0b122518f6$var$fetchModifyIssueTransitionOptInState(updates);
            setResponseStatusPut('success');
            update(()=>({
                    issueTransitionOptInStatus: updatedPreferences
                }));
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                error: err,
                meta: {
                    id: 'issueTransitionOptInStatusUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.issueTransitionOptInStatus) {
            setResponseStatusGet('success');
            setIssueTransitionOptInState(data.issueTransitionOptInStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.issueTransitionOptInStatus
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionLabsOptInState
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTransitionOptInStatus
        }
    };
};

});
const $62811791007d8b59$export$eb01e12fc3db65c0 = 'issue_transition_opt_in';
const $62811791007d8b59$export$a964df7bc15d81e = 'issue_transition_labs_opt_in_status';
const $62811791007d8b59$export$466b1c60da56c8ca = '/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';
const $62811791007d8b59$export$880a78695d76498e = 8;

parcelRegister("ZKxj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $99072b8c90c9105d$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
const $99072b8c90c9105d$var$FF_POSSIBLE_VALUES = [
    'OFF',
    'BY_DEFAULT_USER_OPT_IN',
    'BY_DEFAULT_USER_OPT_OUT'
];
const $99072b8c90c9105d$var$getDefaultIssueTransitionLabsOptInState = ()=>{
    const isModernITSRenderEnabled = (0, $1ybV0.ff)('render-modern-issue-transition_cxt0z');
    if (!isModernITSRenderEnabled) return {
        isEnabled: false,
        expiryTime: -1
    };
    const isModernIssueTransitionSRBCohort = (0, $1ybV0.ff)('issue-transition-customisation-for-srb_0eyvc');
    if (isModernIssueTransitionSRBCohort) return {
        isEnabled: true
    };
    const isExplicitlyUseTurnedOff = (0, $1ybV0.getMultivariateFeatureFlag)('jira-issue-transition-screen-modernisation-toggle', 'OFF', $99072b8c90c9105d$var$FF_POSSIBLE_VALUES) === 'BY_DEFAULT_USER_OPT_OUT';
    return isExplicitlyUseTurnedOff ? {
        isEnabled: false,
        expiryTime: -1
    } : {
        isEnabled: true
    };
};
var $99072b8c90c9105d$export$2e2bcd8739ae039 = $99072b8c90c9105d$var$getDefaultIssueTransitionLabsOptInState;

});



parcelRegister("gZAPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ca3065112ceebc6$export$2e2bcd8739ae039);


var $7byHA = parcelRequire("7byHA");

var $7byHA = parcelRequire("7byHA");
const $5ca3065112ceebc6$var$errorCases4xx = [
    (0, $1c3fbb431a173cc6$export$9de493bcd9b1d977),
    (0, $1c3fbb431a173cc6$export$a3269a3914b007e3),
    (0, $1c3fbb431a173cc6$export$67d19e9a991baa07),
    (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef),
    (0, $1c3fbb431a173cc6$export$c09e7ea0fc79f34f),
    (0, $1c3fbb431a173cc6$export$5244030134e99)
];
const $5ca3065112ceebc6$var$statusCodeIs4xx = (statusCode)=>$5ca3065112ceebc6$var$errorCases4xx.some((status)=>status === statusCode);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5ca3065112ceebc6$export$2e2bcd8739ae039 = (error)=>{
    const isValidationError = error instanceof (0, $7byHA.ValidationError);
    if (isValidationError) return false;
    const isFetchError = error instanceof (0, $7byHA.default);
    if (isFetchError && !!error.statusCode && $5ca3065112ceebc6$var$statusCodeIs4xx(error.statusCode)) return false;
    if (error.name === (0, $7byHA.TYPE_ERROR_NAME) || error.name === (0, $7byHA.ABORT_ERROR_NAME)) return false;
    return true;
};

});

const $e7647232d7445c32$export$71a8e2ae8cfade56 = 'issue-field.status.fetch-transitions';
const $e7647232d7445c32$export$25529a3376b831fd = 'issue-field.status.post-transition';
const $e7647232d7445c32$export$4bf6353caa97e8e7 = 'issue-field.status.fetch-view-workflow';
const $e7647232d7445c32$export$136fc24ec1bfcefd = 'VIEW_READONLY_WORKFLOW';
const $e7647232d7445c32$export$624e7abc8d9cada5 = 'ADMINISTER';

parcelRegister("3NyMT", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TRANSITION_STATUS_FIELD", () => $0e60a3c1bd6d8239$export$a6eb4c39beb71474);
const $0e60a3c1bd6d8239$export$f048d91ccaf92408 = {
    // Click on status to open dropdown → render transitions as an options in the dropdown
    // With and optional feedback phase is when the opened dropdown has no transitions just yet and renders a spinner
    TIME_TO_RENDER_OPTIONS: 'jira.fe.issue.fields.status.time-to.render-options',
    // Select new status → close dropdown and render updated status
    TIME_TO_APPLY_SELECTED_OPTION: 'jira.fe.issue.fields.status.time-to.reflect-selected',
    // Cancel status change (click outside or press esc) → render current status
    TIME_TO_CANCEL_DROPDOWN: 'jira.fe.issue.fields.status.time-to.cancel-dropdown',
    // Select new status that has a transition screen → open dialog with transition screen form
    TIME_TO_OPEN_TRANSITION_SCREEN: 'jira.fe.issue.fields.status.time-to.open-transition-screen',
    // Submit transition screen without error → submits the transition screen form and closes the dialog
    TIME_TO_CONFIRM_TRANSITION_SCREEN: 'jira.fe.issue.fields.status.time-to.confirm-transition-screen',
    // Canceling the transition screen and closing the dialog
    TIME_TO_CANCEL_TRANSITION_SCREEN: 'jira.fe.issue.fields.status.time-to.cancel-transition-screen',
    // Submit transition screen with error → re-render dialog again with reported error
    TIME_TO_ERROR_TRANSITION_SCREEN: 'jira.fe.issue.fields.status.time-to.error-transition-screen'
};
const $0e60a3c1bd6d8239$export$a6eb4c39beb71474 = 'issue-transition-status-field';

});

parcelRegister("h0MK3", function(module, exports) {

$parcel$export(module.exports, "transitionIssueExperienceDescription", () => $f2b1d6f127fa7cb0$export$1afc7ca514c2b5b9);

var $e91YZ = parcelRequire("e91YZ");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");
const $f2b1d6f127fa7cb0$export$1afc7ca514c2b5b9 = (wasSuccessful, method, analyticsSource, projectType, errorMessage, traceId)=>{
    let application = null;
    let edition = null;
    if (projectType !== null) try {
        const { appEditions: appEditions } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
        application = (0, $eIp1n.getApplicationForProject)(projectType);
        edition = (0, $6WXNs.getEdition)(application, appEditions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // application and edition already default to null.
    }
    // Flow sadly cannot do multiple spreads in one object, and additionalAttributes
    // cannot potentially contain fields as undefined.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const additionalAttributes = {};
    if (errorMessage != null) additionalAttributes.errorMessage = errorMessage;
    if (traceId != null) additionalAttributes.traceId = traceId;
    return {
        experience: 'transitionIssue',
        wasExperienceSuccesful: wasSuccessful,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: {
            ...additionalAttributes,
            method: method
        }
    };
};

});

parcelRegister("18TMj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca0a22ffd09722f$export$2e2bcd8739ae039);

var $6OsMV = parcelRequire("6OsMV");
var $fca0a22ffd09722f$export$2e2bcd8739ae039 = (0, $6OsMV.default);

});
parcelRegister("6OsMV", function(module, exports) {

$parcel$export(module.exports, "default", () => $641181661f869ddb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $641181661f869ddb$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue-field-status.services.flags.transition-failed-error.main.title",
        "defaultMessage": "We couldn't update the status"
    },
    description: {
        "id": "issue-field-status.services.flags.transition-failed-error.main.description",
        "defaultMessage": "Check your network connection, then try reloading the issue."
    }
});
const $641181661f869ddb$var$statusTransitionErrorFlag = ()=>({
        type: 'error',
        title: $641181661f869ddb$var$messages.title,
        description: $641181661f869ddb$var$messages.description,
        isAutoDismiss: true
    });
var $641181661f869ddb$export$2e2bcd8739ae039 = $641181661f869ddb$var$statusTransitionErrorFlag;

});


parcelRegister("8tRzR", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d12d5a2960863b1$export$2e2bcd8739ae039);

var $fwqj3 = parcelRequire("fwqj3");
var $9d12d5a2960863b1$export$2e2bcd8739ae039 = (0, $fwqj3.default);

});
parcelRegister("fwqj3", function(module, exports) {

$parcel$export(module.exports, "default", () => $232ac297f35d8461$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $232ac297f35d8461$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue-field-status.services.flags.validation-error.main.title",
        "defaultMessage": "Transition failed"
    }
});
const $232ac297f35d8461$var$statusTransitionValidationErrorFlag = (description)=>({
        type: 'warning',
        title: $232ac297f35d8461$var$messages.title,
        description: {
            id: 'issue-field.status.services.flags.validation-error.main.description',
            defaultMessage: description
        },
        isAutoDismiss: true
    });
var $232ac297f35d8461$export$2e2bcd8739ae039 = $232ac297f35d8461$var$statusTransitionValidationErrorFlag;

});



parcelRegister("72abk", function(module, exports) {

$parcel$export(module.exports, "TransitionsQuery", () => $bbd56aef1eaf3a51$export$e166c7039d71);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $aR8n6 = parcelRequire("aR8n6");

var $b83fb = parcelRequire("b83fb");
const $bbd56aef1eaf3a51$export$e166c7039d71 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue.fields.status.transitions-query"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "fields.status.transitions-query",
        packageName: "jiraIssueFieldStatus",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b83fb.TransitionsQuery), props)));

});
parcelRegister("b83fb", function(module, exports) {

$parcel$export(module.exports, "getStatusTransitionsUrl", () => $1a9c8436a1e2a24d$export$661439a50b90a96f);
$parcel$export(module.exports, "TransitionsQuery", () => $1a9c8436a1e2a24d$export$e166c7039d71);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $2OdyW = parcelRequire("2OdyW");

var $kmr29 = parcelRequire("kmr29");

var $4ceCM = parcelRequire("4ceCM");

var $3A3OQ = parcelRequire("3A3OQ");

var $gZAPr = parcelRequire("gZAPr");

var $1DnzP = parcelRequire("1DnzP");
var $iibQj = parcelRequire("iibQj");

var $jMP2a = parcelRequire("jMP2a");


var $h0MK3 = parcelRequire("h0MK3");

var $9bjYb = parcelRequire("9bjYb");
const $1a9c8436a1e2a24d$export$661439a50b90a96f = (baseUrl, issueKey)=>`${baseUrl}/rest/api/2/issue/${issueKey}/transitions?sortByOpsBarAndStatus=true`;
const $1a9c8436a1e2a24d$var$enhancedSendExperienceAnalytics = (successful, // @ts-expect-error - TS2304 - Cannot find name 'ProjectType'.
projectType, errorMessage, traceId)=>{
    const description = typeof errorMessage === 'string' ? (0, $h0MK3.transitionIssueExperienceDescription)(successful, 'GET', 'Issue View BaseTransitionsQuery', projectType || null, errorMessage, traceId) : (0, $h0MK3.transitionIssueExperienceDescription)(successful, 'GET', 'Issue View BaseTransitionsQuery', projectType || null);
    (0, $4ceCM.sendExperienceAnalytics)(description);
};
const $1a9c8436a1e2a24d$export$4f5a845fd57540e7 = (props)=>{
    const { status: status, issueKey: issueKey, baseUrl: baseUrl, projectType: projectType, preFetch: preFetch, createAnalyticsEvent: createAnalyticsEvent, isSaving: isSaving } = props;
    const [transitionsState, setTransitionsState] = (0, $1DnzP.useWorkflowTransitionsValue)();
    const isSingletonRequestRef = (0, $eUqFw.useRef)(false);
    const [fieldValues] = (0, $kmr29.useFieldsValues)(issueKey);
    const fetch = (0, $eUqFw.useCallback)(async (event)=>{
        if (transitionsState.loading) return;
        if (isSingletonRequestRef.current) return;
        isSingletonRequestRef.current = true;
        setTransitionsState({
            loading: true,
            error: null
        });
        try {
            const result = await (0, $2OdyW.default)($1a9c8436a1e2a24d$export$661439a50b90a96f(baseUrl, issueKey));
            const data = (0, $9bjYb.filterTransitionsWithDestinationAndCategory)(result.transitions);
            (0, $jMP2a.fireTrackAnalyticsDeferred)(event, 'statusField transitionsFetched', 'statusField', {
                count: data.length
            });
            // Issue Transition SLA
            // @ts-expect-error - TS2554 - Expected 4 arguments, but got 2.
            $1a9c8436a1e2a24d$var$enhancedSendExperienceAnalytics(true, projectType);
            setTransitionsState({
                data: data.map((0, $9bjYb.transformTransitionToStore)),
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $3A3OQ.trackOrLogClientError)((0, $e7647232d7445c32$export$71a8e2ae8cfade56), e.toString(), e);
            // Issue Transition SLA
            if ((0, $gZAPr.default)(e)) $1a9c8436a1e2a24d$var$enhancedSendExperienceAnalytics(false, projectType, `${e.name || ''} ${e.message}`.trim(), e.traceId);
            else // @ts-expect-error - TS2554 - Expected 4 arguments, but got 2.
            $1a9c8436a1e2a24d$var$enhancedSendExperienceAnalytics(true, projectType);
            setTransitionsState({
                data: null,
                loading: false,
                error: e
            });
        }
        isSingletonRequestRef.current = false;
    }, // we want to fetch the transtions whenever any field values change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        baseUrl,
        issueKey,
        projectType,
        setTransitionsState,
        fieldValues
    ]);
    // re-evaluates fetching data again whenever issueKey changes
    // we have to use useMemo instead of useEffect here because useMemo will be invoked before render
    (0, $eUqFw.useMemo)(()=>{
        if (preFetch === true && createAnalyticsEvent) fetch(createAnalyticsEvent({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        issueKey,
        preFetch,
        createAnalyticsEvent,
        setTransitionsState,
        fetch
    ]);
    // We need to clear the "data" list whenever the status object changes, because
    // each status has a different list of transitions associated with it.
    // We could achieve a similar behaviour by using a "key" prop when rendering
    // TransitionQuery, but that causes problems with keeping the focus on the component
    // when the status changes. We are using the full status object as "self-transitions"
    // from one status to itself need to exhibit the same behaviour, and it also fixes a bug
    // with PopupSelect downstream
    (0, $eUqFw.useEffect)(()=>{
        if (isSaving) setTransitionsState({
            data: null
        });
        else if (!isSaving && preFetch === true && createAnalyticsEvent) fetch(createAnalyticsEvent({}));
    }, [
        isSaving,
        status,
        preFetch,
        createAnalyticsEvent,
        setTransitionsState,
        fetch
    ]);
    return props.children({
        ...transitionsState,
        data: transitionsState.data ? transitionsState.data.map((0, $9bjYb.transformTransitionFromStore)) : null,
        fetch: fetch
    });
};
const $1a9c8436a1e2a24d$export$833bdce708ba82a6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iibQj.WorkflowTransitionsStoreContainer), {
        scope: props.issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1a9c8436a1e2a24d$export$4f5a845fd57540e7, props));
const $1a9c8436a1e2a24d$export$e166c7039d71 = (0, $2jDha.default)()($1a9c8436a1e2a24d$export$833bdce708ba82a6);

});
parcelRegister("9bjYb", function(module, exports) {

$parcel$export(module.exports, "filterTransitionsWithDestinationAndCategory", () => $32a07b0da1819f23$export$f27913d8073a7e1);
$parcel$export(module.exports, "transformTransitionToStore", () => $32a07b0da1819f23$export$3482bcbbb2a2b63a);
$parcel$export(module.exports, "transformTransitionFromStore", () => $32a07b0da1819f23$export$1eab4bccf39ab44d);
const $32a07b0da1819f23$export$f27913d8073a7e1 = (transitions = [])=>transitions.filter((transition)=>!!transition.to && !!transition.to.statusCategory);
const $32a07b0da1819f23$export$3482bcbbb2a2b63a = (transition)=>({
        id: parseInt(transition.id, 10),
        name: transition.name,
        hasScreen: transition.hasScreen,
        isGlobal: transition.isGlobal,
        isInitial: transition.isInitial,
        isConditional: transition.isConditional,
        ...typeof transition.isLooped === 'boolean' && {
            isLooped: transition.isLooped
        },
        to: {
            id: parseInt(transition.to.id, 10),
            name: transition.to.name,
            description: '',
            statusCategory: {
                id: transition.to.statusCategory.id
            }
        },
        from: null
    });
const $32a07b0da1819f23$export$1eab4bccf39ab44d = (transition)=>({
        id: String(transition.id),
        name: transition.name,
        hasScreen: transition.hasScreen,
        isGlobal: transition.isGlobal,
        isInitial: transition.isInitial,
        isConditional: transition.isConditional,
        ...typeof transition.isLooped === 'boolean' && {
            isLooped: transition.isLooped
        },
        to: {
            id: String(transition.to.id),
            name: transition.to.name,
            statusCategory: {
                id: transition.to.statusCategory.id
            }
        }
    });

});



parcelRegister("13ftU", function(module, exports) {

$parcel$export(module.exports, "ActionsMenu", () => $46eebd6d10312f66$export$dcd7272559c21ebc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");

var $2ziLQ = parcelRequire("2ziLQ");

var $86Ndv = parcelRequire("86Ndv");

var $8BKky = parcelRequire("8BKky");

var $kdJSi = parcelRequire("kdJSi");

var $dHJ40 = parcelRequire("dHJ40");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cg2TK = parcelRequire("cg2TK");

var $3E1iE = parcelRequire("3E1iE");

var $5vRpv = parcelRequire("5vRpv");
// Component is responsible for triggering the ManualRulesContainer HOC to fetch the rules
// when this mounts. This is how we ensure lazy load behaviour of the menu.
const $46eebd6d10312f66$var$FetchRulesContainer = (props)=>{
    const { triggerFetch: triggerFetch, children: children } = props;
    (0, $eUqFw.useEffect)(()=>{
        triggerFetch();
    // Ignore exhaustive dep here to ensure no call to useEffect on re-render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $46eebd6d10312f66$export$f48224de87d33a65 = ()=>(0, $eUqFw.useState)(false);
const $46eebd6d10312f66$var$ActionsMenuButton = ({ isOpen: isOpen, triggerRef: triggerRef, bntProps: bntProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...bntProps,
        ref: triggerRef,
        appearance: "subtle",
        isSelected: isOpen,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
            size: "medium",
            glyph: (0, $kdJSi.AutomationGlyph),
            label: "",
            secondaryColor: "none"
        }),
        interactionName: "auto-generated.jira-issue-field-status.ui.status-view.actions.actions-menu.button"
    }, formatMessage((0, $3E1iE.default).actions));
};
const $46eebd6d10312f66$export$dcd7272559c21ebc = (props)=>{
    const { transitions: transitions, onSelect: onSelect, rules: rules, executeRule: executeRule, executingRule: executingRule, triggerFetch: triggerFetch, initialised: initialised, issueKey: issueKey, issueId: issueId, baseAutomationUrl: baseAutomationUrl, canManageAutomations: canManageAutomations } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = $46eebd6d10312f66$export$f48224de87d33a65();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...bntProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46eebd6d10312f66$var$ActionsMenuButton, {
                isOpen: isOpen,
                triggerRef: triggerRef,
                bntProps: bntProps
            }),
        isOpen: isOpen,
        onOpenChange: ()=>{
            if (!isOpen) {
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'menu',
                    action: 'opened'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu', {
                    userType: canManageAutomations ? 'admin' : 'endUser'
                });
            }
            setIsOpen(!isOpen);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46eebd6d10312f66$export$b33066c493600138, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46eebd6d10312f66$var$FetchRulesContainer, {
        triggerFetch: triggerFetch
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5vRpv.TransitionsSubMenu), {
        initialised: initialised,
        onSelect: onSelect,
        transitions: transitions,
        canManageAutomations: canManageAutomations
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cg2TK.AutomationSubMenu), {
        initialised: initialised,
        rules: rules,
        transitions: transitions,
        executeRule: executeRule,
        issueKey: issueKey,
        issueId: issueId,
        executingRule: executingRule,
        baseAutomationUrl: baseAutomationUrl,
        canManageAutomations: canManageAutomations
    }))), canManageAutomations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dHJ40.default), {
        baseAutomationUrl: baseAutomationUrl
    })));
};
const $46eebd6d10312f66$export$b33066c493600138 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8BKky.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9nklw _c71l1dft _1reo1wug _18m91wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kdJSi", function(module, exports) {

$parcel$export(module.exports, "AutomationGlyph", () => $d609bfcc752dad25$export$3b6023946faff8bc);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $d609bfcc752dad25$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));

});

parcelRegister("dHJ40", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe2d8e0608c15392$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $gO9Xw = parcelRequire("gO9Xw");

var $fwAIO = parcelRequire("fwAIO");

var $8BKky = parcelRequire("8BKky");

var $jhIaS = parcelRequire("jhIaS");

var $bAQOb = parcelRequire("bAQOb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ffnB3 = parcelRequire("ffnB3");

var $7zijK = parcelRequire("7zijK");

var $boRpX = parcelRequire("boRpX");
const $fe2d8e0608c15392$export$ce87cc6e173806ad = ({ baseAutomationUrl: baseAutomationUrl, hasSeparator: hasSeparator = true })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: hasSeparator
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zijK.default), {
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            }), 'manualRulesActionsMenu.adminFooter.createAutomation', {
                userType: 'admin'
            });
        },
        itemKey: "CREATE_RULE",
        href: `${baseAutomationUrl}#rule/new/__NEW__TRIGGER?componentFilterCriteria=QUICK_ACTIONS`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffnB3.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
            size: "small",
            label: ""
        }))
    }, formatMessage((0, $boRpX.default).createAutomationItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zijK.default), {
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            }), 'manualRulesActionsMenu.adminFooter.manageAutomations', {
                userType: 'admin'
            });
        },
        itemKey: "MANAGE_RULES",
        href: baseAutomationUrl,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffnB3.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
            size: "small",
            glyph: (0, $ffnB3.ManageRulesGlyph),
            label: ""
        }))
    }, formatMessage((0, $boRpX.default).manageAutomationsItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zijK.default), {
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            }), 'manualRulesActionsMenu.adminFooter.auditLog', {
                userType: 'admin'
            });
        },
        itemKey: "AUDIT_LOG",
        href: `${baseAutomationUrl}#tab/audit-log`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffnB3.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fwAIO))), {
            size: "small",
            label: ""
        }))
    }, formatMessage((0, $boRpX.default).auditLogItem)));
};
const $fe2d8e0608c15392$export$1642468014dabf54 = ({ baseAutomationUrl: baseAutomationUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jhIaS.default), {
        baseAutomationUrl: baseAutomationUrl,
        onCreateAutomationFooterLinkClicked: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.adminFooter.createAutomation', {
                userType: 'admin'
            });
        },
        onManageAutomationsFooterLinkClicked: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.adminFooter.manageAutomations', {
                userType: 'admin'
            });
        },
        onAuditLogFooterLinkClicked: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.adminFooter.auditLog', {
                userType: 'admin'
            });
        }
    });
};
var $fe2d8e0608c15392$export$2e2bcd8739ae039 = (0, $bAQOb.componentWithFF)('xpa-1198-consume-afe-footer-and-send-analytics-for-footer-and-empty-state_lzknx', $fe2d8e0608c15392$export$1642468014dabf54, $fe2d8e0608c15392$export$ce87cc6e173806ad);

});
parcelRegister("fwAIO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4d65456e92ed895$var$_react = $b4d65456e92ed895$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b4d65456e92ed895$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b4d65456e92ed895$var$CheckCircleOutlineIcon = (props)=>/*#__PURE__*/ $b4d65456e92ed895$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M12 20a8 8 0 100-16 8 8 0 000 16zm0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" fill-rule="nonzero"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z"/></g></svg>`
    }, props));
$b4d65456e92ed895$var$CheckCircleOutlineIcon.displayName = 'CheckCircleOutlineIcon';
var $b4d65456e92ed895$var$_default = $b4d65456e92ed895$var$CheckCircleOutlineIcon;
module.exports.default = $b4d65456e92ed895$var$_default;

});

parcelRegister("jhIaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0a1def8a4d218cd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $2ziLQ = parcelRequire("2ziLQ");

var $gO9Xw = parcelRequire("gO9Xw");

var $fwAIO = parcelRequire("fwAIO");

var $bo4OB = parcelRequire("bo4OB");
var $8BKky = parcelRequire("8BKky");

var $dgAbw = parcelRequire("dgAbw");

var $b3O7Y = parcelRequire("b3O7Y");
/**
 * baseAutomationUrl - the host url you'd like the create/manage automations links to route to
 * createAutomationComponentFilter - optional category string to apply as a filter when routing
 * the create automation button
 * onCreateAutomationFooterLinkClicked - is called when create automation is clicked
 * onManageAutomationsFooterLinkClicked - is called when manage automations is clicked
 * onAuditLogFooterLinkClicked - is called when audit log is clicked
 * */ const $e0a1def8a4d218cd$var$handleOptionalCallback = (optionalEvent)=>{
    if (optionalEvent) optionalEvent();
};
var $e0a1def8a4d218cd$export$2e2bcd8739ae039 = ({ baseAutomationUrl: baseAutomationUrl, createAutomationComponentFilter: createAutomationComponentFilter, onCreateAutomationFooterLinkClicked: onCreateAutomationFooterLinkClicked, onManageAutomationsFooterLinkClicked: onManageAutomationsFooterLinkClicked, onAuditLogFooterLinkClicked: onAuditLogFooterLinkClicked })=>{
    const componentFilter = createAutomationComponentFilter ? `?componentFilterCriteria=${createAutomationComponentFilter}` : '';
    const createNewRuleUrl = `${baseAutomationUrl}#/rule/new/__NEW__TRIGGER${componentFilter}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: true,
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        onClick: ()=>$e0a1def8a4d218cd$var$handleOptionalCallback(onCreateAutomationFooterLinkClicked),
        href: createNewRuleUrl,
        testId: "create-automation-link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dgAbw.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
            size: "small",
            label: ""
        }))
    }, (0, $b3O7Y.default).createAutomationItem.defaultMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        onClick: ()=>$e0a1def8a4d218cd$var$handleOptionalCallback(onManageAutomationsFooterLinkClicked),
        href: baseAutomationUrl,
        testId: "manage-automations-link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dgAbw.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
            size: "small",
            glyph: (0, $dgAbw.ManageRulesGlyph),
            label: ""
        }))
    }, (0, $b3O7Y.default).manageAutomationsItem.defaultMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        onClick: ()=>{
            $e0a1def8a4d218cd$var$handleOptionalCallback(onAuditLogFooterLinkClicked);
        },
        href: `${baseAutomationUrl}#tab/audit-log`,
        testId: "audit-log-link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dgAbw.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fwAIO))), {
            size: "small",
            label: ""
        }))
    }, (0, $b3O7Y.default).auditLogItem.defaultMessage));
};

});
parcelRegister("dgAbw", function(module, exports) {

$parcel$export(module.exports, "MenuIcon", () => $9a88d68873dfbe18$export$46e1d66043f363e6);
$parcel$export(module.exports, "TriggerIcon", () => $9a88d68873dfbe18$export$1cb264166623d4aa);
$parcel$export(module.exports, "ManualTriggerGlyph", () => $9a88d68873dfbe18$export$4514e29f70245d75);
$parcel$export(module.exports, "ManageRulesGlyph", () => $9a88d68873dfbe18$export$85ca00d4fc5d86c3);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $23NQ5 = parcelRequire("23NQ5");

var $PdmhA = parcelRequire("PdmhA");
const $9a88d68873dfbe18$export$46e1d66043f363e6 = (0, $kwce8.default).div`
	width: 32px;
	height: 32px;
	display: flex;
	justify-content: center;
	align-items: center;
`;
const $9a88d68873dfbe18$export$1cb264166623d4aa = (0, $kwce8.default)($9a88d68873dfbe18$export$46e1d66043f363e6)`
	color: ${$PdmhA.G500};
	background-color: ${$PdmhA.G50};
`;
const $9a88d68873dfbe18$export$4514e29f70245d75 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", (0, $kU09D.default)({}, props, {
        width: 24,
        viewBox: "0 0 24 24"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "m21.192 19.778-4.9498-4.9498c-0.3905-0.3905-1.0237-0.3905-1.4142 0-0.3905 0.3906-0.3905 1.0237 0 1.4143l4.9498 4.9497c0.3905 0.3905 1.0237 0.3905 1.4142 0s0.3905-1.0237 0-1.4142z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "m8.7738 8.1319 11.685 4.305c0.2591 0.0955 0.3917 0.3829 0.2963 0.6421-0.025 0.0679-0.0645 0.1295-0.1156 0.1807l-7.3802 7.3801c-0.1952 0.1953-0.5118 0.1953-0.7071 0-0.0511-0.0512-0.0906-0.1128-0.1156-0.1807l-4.3051-11.685c-0.09546-0.25911 0.03721-0.54656 0.29632-0.64202 0.11157-0.0411 0.23414-0.0411 0.34571 0z",
        clipRule: "evenodd",
        fill: "currentColor",
        fillRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "m4.2218 4.2218c1.9526-1.9526 5.1184-1.9526 7.0711 0 0.5977 0.59776 1.0125 1.3092 1.2443 2.0648 0.1974 0.6437-0.4389 1.1502-1.0873 0.96899l-0.2172-0.06069c-0.3475-0.09709-0.6037-0.38008-0.7563-0.70702-0.1439-0.30836-0.3432-0.59728-0.59773-0.85184-1.1716-1.1716-3.0711-1.1716-4.2426 0-1.1716 1.1716-1.1716 3.0711 0 4.2426 0.2547 0.25469 0.54381 0.45399 0.85236 0.59799 0.32725 0.1527 0.61051 0.4091 0.70752 0.7569l0.06045 0.2168c0.18082 0.6483-0.32561 1.2843-0.96914 1.087-0.75578-0.2317-1.4675-0.6466-2.0654-1.2445-1.9526-1.9526-1.9526-5.1184 0-7.071z",
        clipRule: "evenodd",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9a88d68873dfbe18$export$85ca00d4fc5d86c3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), (0, $kU09D.default)({
        label: "",
        size: "small"
    }, props));
const $9a88d68873dfbe18$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", (0, $kU09D.default)({}, props, {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M10.3789 4.62256C9.99914 4.62173 9.65331 4.84087 9.49192 5.18458L6.11523 12.3762C5.97308 12.679 5.9956 13.0334 6.17494 13.3157C6.35428 13.598 6.66553 13.7691 7 13.7691H8.79182L6.40251 18.1304C6.17135 18.5523 6.28163 19.0798 6.66249 19.3738C7.04335 19.6677 7.58152 19.6408 7.93117 19.3103L16.8269 10.902C17.1178 10.6269 17.2117 10.2023 17.0637 9.83032C16.9157 9.45832 16.5558 9.21418 16.1555 9.21418H14.547L17.0353 6.24031C17.2787 5.94947 17.3319 5.5441 17.1717 5.20034C17.0116 4.85658 16.6671 4.63646 16.2879 4.63562L10.3789 4.62256Z",
        stroke: "currentColor",
        strokeWidth: "1.95489",
        strokeLinejoin: "round"
    }));
const $9a88d68873dfbe18$export$fdd32c4638a0c3ae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", (0, $kU09D.default)({}, props, {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "black",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M10.1838 4.78749C10.2664 4.61167 10.4433 4.49957 10.6375 4.5L17.0011 4.51406C17.1951 4.51449 17.3713 4.62709 17.4532 4.80294C17.5352 4.97879 17.508 5.18614 17.3835 5.33492L13.9446 9.44482H16.8597C17.0645 9.44482 17.2486 9.5697 17.3243 9.76C17.4 9.95029 17.352 10.1675 17.2032 10.3082L7.62319 19.3634C7.44433 19.5324 7.16903 19.5462 6.97421 19.3958C6.77938 19.2454 6.72297 18.9756 6.84122 18.7598L9.86254 13.2448H7C6.82891 13.2448 6.66969 13.1573 6.57795 13.0129C6.48621 12.8685 6.47469 12.6872 6.54741 12.5323L10.1838 4.78749Z",
        fill: "white"
    }));
const $9a88d68873dfbe18$export$9d08b452ddec60a4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", (0, $kU09D.default)({}, props, {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M10.1838 4.78749C10.2664 4.61167 10.4433 4.49957 10.6375 4.5L17.0011 4.51406C17.1951 4.51449 17.3713 4.62709 17.4532 4.80294C17.5352 4.97879 17.508 5.18614 17.3835 5.33492L13.9446 9.44482H16.8597C17.0645 9.44482 17.2486 9.5697 17.3243 9.76C17.4 9.95029 17.352 10.1675 17.2032 10.3082L7.62319 19.3634C7.44433 19.5324 7.16903 19.5462 6.97421 19.3958C6.77938 19.2454 6.72297 18.9756 6.84122 18.7598L9.86254 13.2448H7C6.82891 13.2448 6.66969 13.1573 6.57795 13.0129C6.48621 12.8685 6.47469 12.6872 6.54741 12.5323L10.1838 4.78749Z",
        fill: "black"
    }));

});

parcelRegister("b3O7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $80d6dbd72938aadc$export$2e2bcd8739ae039);
const $80d6dbd72938aadc$var$messages = {
    manageAutomationsItem: {
        id: 'automation-platform.footer.manage-automations-item',
        defaultMessage: 'Manage automations',
        description: 'Label for the manage automations item which is a link to project automation'
    },
    createAutomationItem: {
        id: 'automation-platform.footer.create-automation-item',
        defaultMessage: 'Create automation',
        description: 'Label for the create automation item which is a link to rule creation in project automation'
    },
    auditLogItem: {
        id: 'automation-platform.footer.audit-log-item',
        defaultMessage: 'Audit log',
        description: 'Label for the audit log item which is a link to audit log in project automation'
    }
};
var $80d6dbd72938aadc$export$2e2bcd8739ae039 = $80d6dbd72938aadc$var$messages;

});


parcelRegister("ffnB3", function(module, exports) {

$parcel$export(module.exports, "ManualTriggerGlyph", () => $6d3a9722bc22f5a3$export$4514e29f70245d75);
$parcel$export(module.exports, "ManageRulesGlyph", () => $6d3a9722bc22f5a3$export$85ca00d4fc5d86c3);
$parcel$export(module.exports, "AutomationGlyphBlack", () => $6d3a9722bc22f5a3$export$9d08b452ddec60a4);
$parcel$export(module.exports, "MenuIcon", () => $6d3a9722bc22f5a3$export$46e1d66043f363e6);
$parcel$export(module.exports, "TriggerIcon", () => $6d3a9722bc22f5a3$export$1cb264166623d4aa);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $23NQ5 = parcelRequire("23NQ5");
const $6d3a9722bc22f5a3$export$4514e29f70245d75 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: 24,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "m21.192 19.778-4.9498-4.9498c-0.3905-0.3905-1.0237-0.3905-1.4142 0-0.3905 0.3906-0.3905 1.0237 0 1.4143l4.9498 4.9497c0.3905 0.3905 1.0237 0.3905 1.4142 0s0.3905-1.0237 0-1.4142z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "m8.7738 8.1319 11.685 4.305c0.2591 0.0955 0.3917 0.3829 0.2963 0.6421-0.025 0.0679-0.0645 0.1295-0.1156 0.1807l-7.3802 7.3801c-0.1952 0.1953-0.5118 0.1953-0.7071 0-0.0511-0.0512-0.0906-0.1128-0.1156-0.1807l-4.3051-11.685c-0.09546-0.25911 0.03721-0.54656 0.29632-0.64202 0.11157-0.0411 0.23414-0.0411 0.34571 0z",
        clipRule: "evenodd",
        fill: "currentColor",
        fillRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "m4.2218 4.2218c1.9526-1.9526 5.1184-1.9526 7.0711 0 0.5977 0.59776 1.0125 1.3092 1.2443 2.0648 0.1974 0.6437-0.4389 1.1502-1.0873 0.96899l-0.2172-0.06069c-0.3475-0.09709-0.6037-0.38008-0.7563-0.70702-0.1439-0.30836-0.3432-0.59728-0.59773-0.85184-1.1716-1.1716-3.0711-1.1716-4.2426 0-1.1716 1.1716-1.1716 3.0711 0 4.2426 0.2547 0.25469 0.54381 0.45399 0.85236 0.59799 0.32725 0.1527 0.61051 0.4091 0.70752 0.7569l0.06045 0.2168c0.18082 0.6483-0.32561 1.2843-0.96914 1.087-0.75578-0.2317-1.4675-0.6466-2.0654-1.2445-1.9526-1.9526-1.9526-5.1184 0-7.071z",
        clipRule: "evenodd",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $6d3a9722bc22f5a3$export$85ca00d4fc5d86c3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
        size: "small",
        ...props
    });
const $6d3a9722bc22f5a3$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M10.3789 4.62256C9.99914 4.62173 9.65331 4.84087 9.49192 5.18458L6.11523 12.3762C5.97308 12.679 5.9956 13.0334 6.17494 13.3157C6.35428 13.598 6.66553 13.7691 7 13.7691H8.79182L6.40251 18.1304C6.17135 18.5523 6.28163 19.0798 6.66249 19.3738C7.04335 19.6677 7.58152 19.6408 7.93117 19.3103L16.8269 10.902C17.1178 10.6269 17.2117 10.2023 17.0637 9.83032C16.9157 9.45832 16.5558 9.21418 16.1555 9.21418H14.547L17.0353 6.24031C17.2787 5.94947 17.3319 5.5441 17.1717 5.20034C17.0116 4.85658 16.6671 4.63646 16.2879 4.63562L10.3789 4.62256Z",
        stroke: "currentColor",
        strokeWidth: "1.95489",
        strokeLinejoin: "round"
    }));
const $6d3a9722bc22f5a3$export$fdd32c4638a0c3ae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M10.1838 4.78749C10.2664 4.61167 10.4433 4.49957 10.6375 4.5L17.0011 4.51406C17.1951 4.51449 17.3713 4.62709 17.4532 4.80294C17.5352 4.97879 17.508 5.18614 17.3835 5.33492L13.9446 9.44482H16.8597C17.0645 9.44482 17.2486 9.5697 17.3243 9.76C17.4 9.95029 17.352 10.1675 17.2032 10.3082L7.62319 19.3634C7.44433 19.5324 7.16903 19.5462 6.97421 19.3958C6.77938 19.2454 6.72297 18.9756 6.84122 18.7598L9.86254 13.2448H7C6.82891 13.2448 6.66969 13.1573 6.57795 13.0129C6.48621 12.8685 6.47469 12.6872 6.54741 12.5323L10.1838 4.78749Z",
        fill: "var(--ds-text-inverse, white)"
    }));
const $6d3a9722bc22f5a3$export$9d08b452ddec60a4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M10.1838 4.78749C10.2664 4.61167 10.4433 4.49957 10.6375 4.5L17.0011 4.51406C17.1951 4.51449 17.3713 4.62709 17.4532 4.80294C17.5352 4.97879 17.508 5.18614 17.3835 5.33492L13.9446 9.44482H16.8597C17.0645 9.44482 17.2486 9.5697 17.3243 9.76C17.4 9.95029 17.352 10.1675 17.2032 10.3082L7.62319 19.3634C7.44433 19.5324 7.16903 19.5462 6.97421 19.3958C6.77938 19.2454 6.72297 18.9756 6.84122 18.7598L9.86254 13.2448H7C6.82891 13.2448 6.66969 13.1573 6.57795 13.0129C6.48621 12.8685 6.47469 12.6872 6.54741 12.5323L10.1838 4.78749Z",
        fill: "var(--ds-text, black)"
    }));
const $6d3a9722bc22f5a3$export$46e1d66043f363e6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o _2rko1y44",
            __cmplp.className
        ])
    });
});
const $6d3a9722bc22f5a3$export$1cb264166623d4aa = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $6d3a9722bc22f5a3$export$46e1d66043f363e6, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazawfz _bfhkn7zq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7zijK", function(module, exports) {

$parcel$export(module.exports, "default", () => $761190b697724e5a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bo4OB = parcelRequire("bo4OB");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");
const $761190b697724e5a$var$LinkItemWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('link', {
    onClick: 'clicked'
})(({ createAnalyticsEvent: createAnalyticsEvent, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), otherProps));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$761190b697724e5a$export$2e2bcd8739ae039 = ({ itemKey: itemKey, onClick: onClick, ...otherProps })=>{
    const onClickWithAnalytics = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        onClick && onClick();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'automationMenuLinkItem', {
            itemKey: itemKey
        });
    }, [
        itemKey,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($761190b697724e5a$var$LinkItemWithAnalytics, {
        ...otherProps,
        onClick: onClickWithAnalytics
    });
};

});

parcelRegister("boRpX", function(module, exports) {

$parcel$export(module.exports, "default", () => $11cf9ce483b3dda0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $11cf9ce483b3dda0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    manageAutomationsItem: {
        "id": "automation-platform.footer.manage-automations-item",
        "defaultMessage": "Manage automations"
    },
    createAutomationItem: {
        "id": "automation-platform.footer.create-automation-item",
        "defaultMessage": "Create automation"
    },
    auditLogItem: {
        "id": "automation-platform.footer.audit-log-item",
        "defaultMessage": "Audit log"
    }
});

});


parcelRegister("cg2TK", function(module, exports) {

$parcel$export(module.exports, "AutomationSubMenu", () => $0ad238d58e235e80$export$e5156046660dc32a);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $2ziLQ = parcelRequire("2ziLQ");

var $4Bees = parcelRequire("4Bees");

var $8cU5f = parcelRequire("8cU5f");

var $8qsM5 = parcelRequire("8qsM5");
var $ffnB3 = parcelRequire("ffnB3");

var $5JgJ2 = parcelRequire("5JgJ2");

var $huI7r = parcelRequire("huI7r");

var $g8JvH = parcelRequire("g8JvH");

var $dWLk9 = parcelRequire("dWLk9");

var $bJDnh = parcelRequire("bJDnh");

var $99nZ7 = parcelRequire("99nZ7");
const $0ad238d58e235e80$export$c0117b1abc6c64e3 = (0, $g8JvH.AnalyticsEventToProps)('dropdownItem', {
    onClick: 'clicked'
})((0, $hD6GJ.default));
const $0ad238d58e235e80$export$41fc372f12f35c64 = ({ issueId: issueId, executingRule: executingRule, rules: rules, onExecuteRule: onExecuteRule })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const issueAri = (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ? issueId.toString() : ''
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, rules.map((rule)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            key: rule.id,
            content: rule.name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0ad238d58e235e80$export$c0117b1abc6c64e3, {
            onClick: ()=>onExecuteRule(rule.id, [
                    issueAri
                ]),
            elemBefore: executingRule === rule.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffnB3.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
                size: "small"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffnB3.TriggerIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
                size: "small",
                glyph: (0, $ffnB3.ManualTriggerGlyph),
                label: ""
            }))
        }, rule.name))));
};
const $0ad238d58e235e80$export$e5156046660dc32a = (props)=>{
    const { initialised: initialised, rules: rules, transitions: transitions, baseAutomationUrl: baseAutomationUrl, canManageAutomations: canManageAutomations, executeRule: executeRule, executingRule: executingRule, issueKey: issueKey, issueId: issueId } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const shouldShowRulesList = initialised && rules.length > 0;
    const shouldShowEmptyState = initialised && rules.length === 0 && transitions.length === 0;
    if (!initialised) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bJDnh.Skeleton), null);
    if (shouldShowRulesList) {
        const automationItemGroupProps = canManageAutomations ? {
            title: formatMessage((0, $99nZ7.default).manualRules)
        } : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), automationItemGroupProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0ad238d58e235e80$export$41fc372f12f35c64, {
            rules: rules,
            onExecuteRule: executeRule,
            issueKey: issueKey,
            issueId: issueId,
            executingRule: executingRule
        }));
    }
    if (shouldShowEmptyState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        title: formatMessage((0, $99nZ7.default).manualRules)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8qsM5.ManualRulesEmptyState), {
        baseAutomationUrl: baseAutomationUrl,
        canManageAutomations: canManageAutomations,
        createAutomationComponentFilter: "QUICK_ACTIONS"
    }));
    return null;
};
var $0ad238d58e235e80$export$2e2bcd8739ae039 = $0ad238d58e235e80$export$e5156046660dc32a;

});
parcelRegister("8qsM5", function(module, exports) {

$parcel$export(module.exports, "ManualRulesEmptyState", () => $6699c4a4a2a43b86$export$e17d6e5a8bfa991e);

var $eUqFw = parcelRequire("eUqFw");

var $kznCy = parcelRequire("kznCy");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $6699c4a4a2a43b86$export$e17d6e5a8bfa991e = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { baseAutomationUrl: baseAutomationUrl, createAutomationComponentFilter: createAutomationComponentFilter, canManageAutomations: canManageAutomations } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kznCy.ManualRulesEmptyState), {
        canManageAutomations: canManageAutomations,
        baseAutomationUrl: baseAutomationUrl,
        createAutomationComponentFilter: createAutomationComponentFilter,
        onEmptyStateCreateAutomationButtonClicked: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'button',
                action: 'clicked'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.emptyState.createAutomationButton', {
                userType: 'admin'
            });
        },
        onEmptyStateSeeTemplatesLinkClicked: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'button',
                action: 'clicked'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.emptyState.seeTemplatesLink', {
                userType: 'admin'
            });
        }
    });
};

});
parcelRegister("kznCy", function(module, exports) {

$parcel$export(module.exports, "ManualRulesEmptyState", () => $ef99661d45477a4e$export$e17d6e5a8bfa991e);

var $eUqFw = parcelRequire("eUqFw");

var $fI650 = parcelRequire("fI650");

var $j7Z8H = parcelRequire("j7Z8H");

var $jWrd4 = parcelRequire("jWrd4");

var $j9Zve = parcelRequire("j9Zve");
/**
 * the interface for the properties of @ManualRulesEmptyState
 *
 * @baseAutomationUrl {string} the host url you'd like the create/manage automations links to route to
 * @createAutomationComponentFilter {string} optional category string to apply as a filter to the triggers when routing
 * @canManageAutomations {boolean} indicates whether the user is an administrator and has access to creating automations
 * @onEmptyStateCreateAutomationButtonClicked {() => void} is called when create automation button is clicked
 * @onEmptyStateSeeTemplatesLinkClicked {() => void} is called when see templates link is clicked
 */ const $ef99661d45477a4e$var$handleOptionalCallback = (optionalEvent)=>{
    if (optionalEvent) optionalEvent();
};
const $ef99661d45477a4e$export$e17d6e5a8bfa991e = (props)=>{
    const { baseAutomationUrl: baseAutomationUrl, canManageAutomations: canManageAutomations, createAutomationComponentFilter: createAutomationComponentFilter, onEmptyStateCreateAutomationButtonClicked: onEmptyStateCreateAutomationButtonClicked, onEmptyStateSeeTemplatesLinkClicked: onEmptyStateSeeTemplatesLinkClicked } = props;
    const componentFilter = createAutomationComponentFilter ? `?componentFilterCriteria=${createAutomationComponentFilter}` : '';
    const createNewRuleUrl = `${baseAutomationUrl}#/rule/new/__NEW__TRIGGER${componentFilter}`;
    const automationTemplateLibraryUrl = canManageAutomations ? `${baseAutomationUrl}#/tab/rule-library` : 'https://www.atlassian.com/software/jira/automation-template-library#/rule-list?systemLabelId=all&page=1&pageSize=20&sortKey=name&sortOrder=ASC';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9Zve.ManualRuleEmptyState), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9Zve.EmptyStateIconContainer), null, (0, $j7Z8H.emptyStateIcon)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9Zve.Message), null, (0, $jWrd4.default).emptyStateMessage.defaultMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9Zve.Links), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9Zve.ActionLink), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fI650.default), {
        appearance: "default",
        onClick: ()=>{
            $ef99661d45477a4e$var$handleOptionalCallback(onEmptyStateCreateAutomationButtonClicked);
        },
        href: createNewRuleUrl,
        isDisabled: !canManageAutomations,
        testId: "empty-state-create-automation-button",
        title: canManageAutomations ? undefined : (0, $jWrd4.default).createAutomationsButtonTitle.defaultMessage
    }, (0, $jWrd4.default).addManuallyTriggeredAutomation.defaultMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9Zve.ActionLink), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fI650.default), {
        appearance: "link",
        onClick: ()=>{
            $ef99661d45477a4e$var$handleOptionalCallback(onEmptyStateSeeTemplatesLinkClicked);
        },
        href: automationTemplateLibraryUrl,
        testId: "empty-state-see-templates-link"
    }, (0, $jWrd4.default).seeTemplates.defaultMessage))));
};

});
parcelRegister("j7Z8H", function(module, exports) {

$parcel$export(module.exports, "emptyStateIcon", () => $dece18c397970bda$export$639b28b9524fd6f0);

var $eUqFw = parcelRequire("eUqFw");
const $dece18c397970bda$export$639b28b9524fd6f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
    width: "313",
    height: "215",
    viewBox: "0 0 313 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.296 0.793168C183.809 4.00611 210.17 26.1894 237.711 45.7988C266.71 66.447 301.378 85.3411 307.01 115.226C313.293 148.564 305.832 189.973 268.25 207.848C231.892 225.141 189.127 193.51 146.296 191.668C108.52 190.042 68.5787 214.216 37.4175 197.917C4.57549 180.738 1.18294 145.502 0.153 115.226C-0.911134 83.9451 2.95664 50.6107 31.6423 28.1492C60.6366 5.44611 104.914 -2.75118 146.296 0.793168Z",
    fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
    filter: "url(#filter0_dd_1968_47879)"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
    x: "21",
    y: "15",
    width: "280",
    height: "180",
    rx: "8",
    fill: "var(--ds-surface, white)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
    x: "207",
    y: "46.5",
    width: "77",
    height: "14",
    rx: "2",
    fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
    x: "208",
    y: "47.5",
    width: "12",
    height: "12",
    rx: "4",
    fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    d: "M215 50L213 57",
    stroke: "var(--ds-icon-accent-blue, #1D7AFC)",
    strokeLinecap: "round"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    d: "M215 50L211.5 53.5H216.5L213 57",
    stroke: "var(--ds-icon-accent-blue, #1D7AFC)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
    x: "207",
    y: "46.5",
    width: "77",
    height: "14",
    rx: "2",
    stroke: "var(--ds-border-focused, #388BFF)",
    strokeWidth: "2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
    x: "37",
    y: "45.5",
    width: "155",
    height: "16",
    rx: "3",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
    x: "37",
    y: "71.5",
    width: "155",
    height: "28",
    rx: "3",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
    x: "37",
    y: "109.5",
    width: "17",
    height: "17",
    rx: "8.5",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
    x: "58",
    y: "113.5",
    width: "27",
    height: "9",
    rx: "3",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
    x: "89",
    y: "113.5",
    width: "27",
    height: "9",
    rx: "3",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
    x: "120",
    y: "113.5",
    width: "27",
    height: "9",
    rx: "3",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
    x: "37",
    y: "136.5",
    width: "133",
    height: "9",
    rx: "3",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
    x: "37",
    y: "155.5",
    width: "89",
    height: "9",
    rx: "3",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
    id: "filter0_dd_1968_47879",
    x: "9",
    y: "11",
    width: "304",
    height: "204",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
    stdDeviation: "0.5"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1968_47879"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
    dy: "8"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
    stdDeviation: "6"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.15 0"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1968_47879",
    result: "effect2_dropShadow_1968_47879"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1968_47879",
    result: "shape"
}))));

});

parcelRegister("jWrd4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8488a61c460d865$export$2e2bcd8739ae039);
const $e8488a61c460d865$var$messages = {
    emptyStateMessage: {
        id: 'automation-platform.manual-rules-empty-state.empty-state-message-new',
        defaultMessage: 'Create an automation to perform tasks with the click of a button. Once created, manually triggered automations will appear here.',
        description: 'The message to show when there is no manual rule'
    },
    addManuallyTriggeredAutomation: {
        id: 'automation-platform.manual-rules-empty-state.add-manually-triggered-automation',
        defaultMessage: 'Add manually triggered automation',
        description: 'Link to the page to create automations'
    },
    seeTemplates: {
        id: 'automation-platform.manual-rules-empty-state.see-templates',
        defaultMessage: 'See templates',
        description: 'Link to the page to see the automation templates'
    },
    createAutomationsButtonTitle: {
        id: 'automation-platform.manual-rules-empty-state.create-automations-button-title',
        defaultMessage: 'You must be a project admin to create automations',
        description: 'The title to show for create automations button'
    }
};
var $e8488a61c460d865$export$2e2bcd8739ae039 = $e8488a61c460d865$var$messages;

});

parcelRegister("j9Zve", function(module, exports) {

$parcel$export(module.exports, "ManualRuleEmptyState", () => $df2e90bb1b7965c5$export$5ef19aedb65f813a);
$parcel$export(module.exports, "Message", () => $df2e90bb1b7965c5$export$f69c19e57285b83a);
$parcel$export(module.exports, "Links", () => $df2e90bb1b7965c5$export$b2e089eb3692b073);
$parcel$export(module.exports, "ActionLink", () => $df2e90bb1b7965c5$export$51485461e6c971ae);
$parcel$export(module.exports, "EmptyStateIconContainer", () => $df2e90bb1b7965c5$export$8a3dea5ee464347b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

const $df2e90bb1b7965c5$export$5ef19aedb65f813a = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12fp59q",
            __cmplp.className
        ])
    }));
});
const $df2e90bb1b7965c5$export$f69c19e57285b83a = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_zg8l4jg8 _k48p1nn1 _1wybdlk8 _vwz4gktf _1e0c1txw _4cvr1h6o _y3gn1h6o _18s8g97w _syaz1ddj",
            __cmplp.className
        ])
    }));
});
const $df2e90bb1b7965c5$export$b2e089eb3692b073 = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66 _19pk1mwd _1bah1h6o _1e0c11p5 _y3gn1h6o",
            __cmplp.className
        ])
    }));
});
const $df2e90bb1b7965c5$export$51485461e6c971ae = (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81wmz",
            __cmplp.className
        ])
    }));
});
const $df2e90bb1b7965c5$export$8a3dea5ee464347b = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, (0, $kU09D.default)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ipo3b _1bsb1mjv _18s8v47k",
            __cmplp.className
        ])
    }));
});

});



parcelRegister("bJDnh", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $57a66a9dbd4d6471$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ffnB3 = parcelRequire("ffnB3");
const $57a66a9dbd4d6471$export$9ea727bd75377e4c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57a66a9dbd4d6471$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffnB3.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57a66a9dbd4d6471$var$SkeletonIcon, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57a66a9dbd4d6471$var$SkeletonText, null));
const $57a66a9dbd4d6471$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57a66a9dbd4d6471$export$9ea727bd75377e4c, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57a66a9dbd4d6471$export$9ea727bd75377e4c, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57a66a9dbd4d6471$export$9ea727bd75377e4c, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57a66a9dbd4d6471$export$9ea727bd75377e4c, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57a66a9dbd4d6471$export$9ea727bd75377e4c, null));
var $57a66a9dbd4d6471$export$2e2bcd8739ae039 = $57a66a9dbd4d6471$export$8f31e4c4a37b8e9c;
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57a66a9dbd4d6471$var$SkeletonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s813su _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $57a66a9dbd4d6471$var$SkeletonIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _1e0c1o8l _2rkoyh40 _bfhk1r31 _19itj1ic _tzy4nh7s",
            __cmplp.className
        ])
    });
});
const $57a66a9dbd4d6471$var$shimmer = null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57a66a9dbd4d6471$var$SkeletonText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbp3fh _4t3i7vkz _19pk1b66 _18u0utpp _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk",
            __cmplp.className
        ])
    });
});

});

parcelRegister("99nZ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8258bf7dfffe4184$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8258bf7dfffe4184$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    manualRules: {
        "id": "issue-field-status.status-view.actions.actions-menu.automation-submenu.manual-rules",
        "defaultMessage": "From Automation"
    }
});

});


parcelRegister("3E1iE", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a857a489d8a87d4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1a857a489d8a87d4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    actions: {
        "id": "issue-field-status.status-view.actions.actions-menu.actions",
        "defaultMessage": "Actions"
    },
    manualRules: {
        "id": "issue-field-status.status-view.actions.actions-menu.manual-rules",
        "defaultMessage": "From Automation"
    },
    workflowTransitions: {
        "id": "issue-field-status.status-view.actions.actions-menu.workflow-transitions",
        "defaultMessage": "From Workflow"
    }
});

});

parcelRegister("5vRpv", function(module, exports) {

$parcel$export(module.exports, "TransitionsSubMenu", () => $a1aca6cb0cb6c287$export$d6b4ae7200493213);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g8JvH = parcelRequire("g8JvH");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iAJA5 = parcelRequire("iAJA5");
const $a1aca6cb0cb6c287$export$c0117b1abc6c64e3 = (0, $g8JvH.AnalyticsEventToProps)('dropdownItem', {
    onClick: 'clicked'
})((0, $hD6GJ.default));
const $a1aca6cb0cb6c287$export$d6b4ae7200493213 = ({ initialised: initialised, transitions: transitions, canManageAutomations: canManageAutomations, onSelect: onSelect })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    if (!initialised || transitions.length === 0) return null;
    const onClick = (transition, _, analyticsEvent)=>{
        const localEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdown'
        });
        (0, $jMP2a.fireUIAnalytics)(localEvent, 'loopActionsMenu');
        onSelect(transition, analyticsEvent);
    };
    const transitionItemGroupProps = canManageAutomations ? {
        title: formatMessage((0, $iAJA5.default).workflowTransitions)
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), transitionItemGroupProps, transitions.map((transition)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            key: transition.id,
            content: transition.name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1aca6cb0cb6c287$export$c0117b1abc6c64e3, {
            onClick: (event, analyticsEvent)=>onClick(transition, event, analyticsEvent)
        }, transition.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
        action: "exposed",
        actionSubject: "feature",
        actionSubjectId: "loopActions",
        attributes: {
            controlType: 'menu'
        }
    }));
};
var $a1aca6cb0cb6c287$export$2e2bcd8739ae039 = $a1aca6cb0cb6c287$export$d6b4ae7200493213;

});
parcelRegister("iAJA5", function(module, exports) {

$parcel$export(module.exports, "default", () => $74250044415ae37b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $74250044415ae37b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    workflowTransitions: {
        "id": "issue-field-status.status-view.actions.actions-menu.transitions-submenu.workflow-transitions",
        "defaultMessage": "From Workflow"
    }
});

});





parcelRegister("ie6xE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1ae8b951b2318bb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $8urXR = parcelRequire("8urXR");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7svav = parcelRequire("7svav");

var $7vdrd = parcelRequire("7vdrd");
const $a1ae8b951b2318bb$var$FlaggedField = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const flaggedMsg = formatMessage((0, $7vdrd.messages).flagged);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7svav.default), {
        onClick: onClick,
        name: flaggedMsg,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8urXR))), {
            size: "medium",
            primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA).R300})`,
            label: flaggedMsg
        })
    });
};
$a1ae8b951b2318bb$var$FlaggedField.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $a1ae8b951b2318bb$export$2e2bcd8739ae039 = $a1ae8b951b2318bb$var$FlaggedField;

});
parcelRegister("8urXR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62e6d140d6f5090f$var$_react = $62e6d140d6f5090f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $62e6d140d6f5090f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $62e6d140d6f5090f$var$FlagFilledIcon = (props)=>/*#__PURE__*/ $62e6d140d6f5090f$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.73 5.73 0 002.547-.567 1 1 0 00.563-.9V5.466a.998.998 0 00-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 006 5.466v6.769z" fill="currentColor"/></svg>`
    }, props));
$62e6d140d6f5090f$var$FlagFilledIcon.displayName = 'FlagFilledIcon';
var $62e6d140d6f5090f$var$_default = $62e6d140d6f5090f$var$FlagFilledIcon;
module.exports.default = $62e6d140d6f5090f$var$_default;

});

parcelRegister("7svav", function(module, exports) {

$parcel$export(module.exports, "default", () => $04d799d99716fec1$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $8cU5f = parcelRequire("8cU5f");

var $c9TLT = parcelRequire("c9TLT");
const $04d799d99716fec1$export$2c90d058b4eec296 = (0, $c9TLT.gridSize) * 25;
class $04d799d99716fec1$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    componentDidMount() {
        this.updateOverflow();
    }
    UNSAFE_componentWillReceiveProps() {
        // Reset the state
        this.setState({
            hasOverflow: false
        });
    }
    componentDidUpdate() {
        this.updateOverflow();
    }
    updateOverflow() {
        if (!this.altStatusLabel) return false;
        // @ts-expect-error - TS2339 - Property 'clientWidth' does not exist on type 'Component<any, any, any>'.
        const overflow = this.altStatusLabel.clientWidth >= $04d799d99716fec1$export$2c90d058b4eec296;
        if (overflow !== this.state.hasOverflow) this.setState({
            hasOverflow: overflow
        });
        return overflow;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($04d799d99716fec1$var$Container, {
            onClick: this.props.onClick,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "issue.views.issue-base.foundation.status.alt-view"
        }, this.props.icon, this.state.hasOverflow ? this.renderAltStatusWithTooltip() : this.renderAltStatus());
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasOverflow: false
        };
        // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'HTMLSpanElement | Component<ClassAttributes<HTMLSpanElement> & HTMLAttributes<HTMLSpanElement> & StyledProps, any, any>'.
        this.altStatusLabel = undefined;
        this.renderAltStatus = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($04d799d99716fec1$var$AltStatusLabel, {
                "data-testid": "issue-view-foundation.status.alt-status-field.label",
                ref: (el)=>{
                    // @ts-expect-error - TS2322: Type 'HTMLSpanElement | null' is not assignable to type 'HTMLSpanElement | Component<ClassAttributes<HTMLSpanElement> & HTMLAttributes<HTMLSpanElement> & StyledProps, any, any>'.
                    this.altStatusLabel = el;
                }
            }, this.props.name);
        this.renderAltStatusWithTooltip = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                testId: "issue-view-foundation.status.alt-status-field.label-with-tooltip",
                content: this.props.name,
                position: "bottom"
            }, this.renderAltStatus());
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04d799d99716fec1$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1b66 _1e0c116y _s7n418uv _18u01i6y _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $04d799d99716fec1$var$AltStatusLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _1e0c1o8l _1reo15vq _18m915vq _vwz41tcg _1bto1l2s _o5721q9c _p12fuuw1",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7vdrd", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b5304d8a32618e50$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $b5304d8a32618e50$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    flagged: {
        "id": "issue.status-field.flagged",
        "defaultMessage": "Flagged"
    }
});

});


parcelRegister("ee5ao", function(module, exports) {

$parcel$export(module.exports, "messages", () => $08a659a91f1ba800$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $08a659a91f1ba800$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    label: {
        "id": "issue.title-for-status-field",
        "defaultMessage": "Status"
    },
    flagAdded: {
        "id": "issue.status-for-sr-users-flag-added",
        "defaultMessage": "Flag added"
    },
    flagRemoved: {
        "id": "issue.status-for-sr-users-flag-removed",
        "defaultMessage": "Flag removed"
    }
});

});

parcelRegister("evEA8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e65be6c8d530a477$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $lpHr5 = parcelRequire("lpHr5");

var $eMxRI = parcelRequire("eMxRI");

var $lhz9J = parcelRequire("lhz9J");

var $5Xp4r = parcelRequire("5Xp4r");
const $e65be6c8d530a477$var$StatusWithWrappers = (props)=>{
    const shortcutTriggerRef = (0, $eUqFw.useRef)(0);
    const statusButtonRef = (0, $eUqFw.useRef)(null);
    const [statusDropdownTriggerCount, { resetComponent: resetComponent }] = (0, $lhz9J.useStatusKeyboardShortcutsStore)();
    // Allow the status field to be opened externally via keyboard shortcuts.
    // using ref until the decomposition stream project solution is defined and implemented
    (0, $eUqFw.useEffect)(()=>{
        const shouldStatusShortCutTrigger = statusDropdownTriggerCount > 0 && Number(shortcutTriggerRef.current) < statusDropdownTriggerCount;
        if (shouldStatusShortCutTrigger && statusButtonRef?.current) {
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            statusButtonRef.current.scrollIntoView?.({
                block: 'center'
            });
            /**
			 * ! This is not a recommended pattern and should be avoided.
			 * ! The only reason it is used here is because atlaskit StatusPopup
			 * !   does not have a way to open the list through a props
			 * !   Design system ticket: https://product-fabric.atlassian.net/browse/DSP-836
			 */ // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            statusButtonRef.current?.click();
            shortcutTriggerRef.current = statusDropdownTriggerCount;
        }
    }, [
        statusDropdownTriggerCount
    ]);
    // clean up - reset trigger when we unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>()=>resetComponent((0, $c51eac624bf70214$export$823ced5880c3b947)), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Xp4r.default), {
        id: (0, $eMxRI.STATUS_SPOTLIGHT)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lpHr5.default), {
        ...props,
        statusButtonRef: statusButtonRef
    }));
};
var $e65be6c8d530a477$export$2e2bcd8739ae039 = $e65be6c8d530a477$var$StatusWithWrappers;

});
parcelRegister("lpHr5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "StatusField", () => $e7547dc1fbebf6cf$export$28769ce7cf4b59f9);
$parcel$export(module.exports, "default", () => $e7547dc1fbebf6cf$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $fee69 = parcelRequire("fee69");

var $hzcvF = parcelRequire("hzcvF");

var $8T7GM = parcelRequire("8T7GM");

var $SEaoU = parcelRequire("SEaoU");

var $6vrw7 = parcelRequire("6vrw7");

var $gd0Sp = parcelRequire("gd0Sp");

var $jsdzI = parcelRequire("jsdzI");

var $72abk = parcelRequire("72abk");

var $g6Vr7 = parcelRequire("g6Vr7");

var $3BadD = parcelRequire("3BadD");

var $hKhSq = parcelRequire("hKhSq");

var $8N9iM = parcelRequire("8N9iM");
const $e7547dc1fbebf6cf$export$28769ce7cf4b59f9 = ({ isOptimistic: isOptimistic = true, ContainerContextSubscriber: ContainerContextSubscriber = (0, $SEaoU.ContainerContextSubscriber), ViewWorkflowContextService: ViewWorkflowContextService = (0, $g6Vr7.default), preFetchTransitions: preFetchTransitions = false, projectType: projectType = null, onEditStart: onEditStart = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onEditCancel: onEditCancel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), issueKey: issueKey, issueId: issueId, isEditable: isEditable, initialValue: initialValue, appearance: appearance, value: value, statusButtonRef: statusButtonRefExternal, popperProps: popperProps, registerInCommandPalette: registerInCommandPalette })=>{
    const [isWorkflowModalOpen, setIsWorkflowModalOpen] = (0, $eUqFw.useState)(false);
    const [isWorkflowModalMounted, setisWorkflowModalMounted] = (0, $eUqFw.useState)(false);
    const [issueTypeId, setIssueTypeId] = (0, $eUqFw.useState)((0, $6vrw7.toIssueTypeId)(''));
    const [projectId, setProjectId] = (0, $eUqFw.useState)((0, $6vrw7.toProjectId)(''));
    const previousIsWorkflowModalOpen = (0, $hzcvF.usePrevious)(isWorkflowModalOpen);
    const statusButtonRef = (0, $eUqFw.useRef)(null);
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    (0, $eUqFw.useEffect)(()=>{
        if (previousIsWorkflowModalOpen === true && isWorkflowModalOpen === false) {
            if (statusButtonRef?.current) statusButtonRef.current.focus();
        }
    }, [
        isWorkflowModalOpen,
        previousIsWorkflowModalOpen
    ]);
    const onOpenModal = (0, $eUqFw.useCallback)((issueTypeIdInArgs, projectIdInArgs)=>{
        setIsWorkflowModalOpen(true);
        setIssueTypeId(issueTypeIdInArgs);
        setProjectId(projectIdInArgs);
    }, []);
    const onCloseModal = (0, $eUqFw.useCallback)(()=>{
        setIsWorkflowModalOpen(false);
    }, []);
    const onModalMounted = (0, $eUqFw.useCallback)(()=>{
        setisWorkflowModalMounted(true);
    }, []);
    return !tenantContext ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jsdzI.StatusService), {
        appearance: appearance,
        value: value,
        projectType: projectType,
        initialValue: initialValue,
        issueKey: issueKey,
        issueId: issueId,
        baseUrl: tenantContext.baseUrl,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onEditStart: onEditStart,
        onEditCancel: onEditCancel
    }, ({ value: statusServiceValue, loading: saving, transitionStatus: transitionStatus, error: error, resetError: resetError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $72abk.TransitionsQuery), {
            issueKey: issueKey,
            baseUrl: tenantContext.baseUrl,
            // this will force an empty list of transitions when the status changes
            status: statusServiceValue,
            isSaving: saving,
            preFetch: preFetchTransitions,
            projectType: projectType
        }, ({ data: transitions, loading: loading, fetch: fetch })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewWorkflowContextService, {
                ContainerContextSubscriber: ContainerContextSubscriber,
                baseUrl: tenantContext.baseUrl,
                issueKey: issueKey
            }, (workflowServiceApi)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3BadD.default), {
                    statusButtonRef: statusButtonRefExternal || statusButtonRef,
                    value: statusServiceValue,
                    isEditable: isEditable,
                    isLoading: loading || saving,
                    isSaving: isOptimistic === true ? false : saving,
                    appearance: appearance,
                    transitions: transitions,
                    onOpen: (analyticsEvent)=>{
                        onEditStart();
                        fetch(analyticsEvent);
                        const hasFetchedWorkflowService = workflowServiceApi.data && workflowServiceApi.data.hasPermission !== undefined;
                        if (hasFetchedWorkflowService !== true) workflowServiceApi.fetch();
                        resetError();
                    },
                    onClose: onEditCancel,
                    onChange: transitionStatus,
                    error: error,
                    footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
                        id: "issue-field-view-workflow"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hKhSq.default), {
                        baseUrl: tenantContext.baseUrl,
                        issueKey: issueKey,
                        workflowServiceApi: workflowServiceApi,
                        onOpenModal: onOpenModal,
                        isModalMounted: isWorkflowModalMounted
                    })),
                    popperProps: popperProps,
                    registerInCommandPalette: registerInCommandPalette,
                    onSuccess: onSuccess,
                    onFetch: fetch
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N9iM.default), {
                    onModalMounted: onModalMounted,
                    issueKey: issueKey,
                    issueTypeId: issueTypeId,
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    cloudId: tenantContext.cloudId,
                    projectId: projectId,
                    isOpen: isWorkflowModalOpen,
                    onClose: onCloseModal,
                    scope: workflowServiceApi.data?.isSimplified === true ? (0, $8T7GM.SCOPE_PROJECT) : (0, $8T7GM.SCOPE_GLOBAL)
                }))))));
};
var $e7547dc1fbebf6cf$export$2e2bcd8739ae039 = $e7547dc1fbebf6cf$export$28769ce7cf4b59f9;

});
parcelRegister("8T7GM", function(module, exports) {

$parcel$export(module.exports, "START_NODE_ID", () => $70b075ae0428a910$export$e117396b0784c7cc);
$parcel$export(module.exports, "transitionType", () => $70b075ae0428a910$export$331d6399b2e33350);
$parcel$export(module.exports, "transitionIcon", () => $70b075ae0428a910$export$bb55b5bf71d8edff);
$parcel$export(module.exports, "SCOPE_GLOBAL", () => $70b075ae0428a910$export$9bb188cec3fcc43d);
$parcel$export(module.exports, "SCOPE_PROJECT", () => $70b075ae0428a910$export$54c3a1cc8eb1bc43);
$parcel$export(module.exports, "ALL_OPERATION", () => $70b075ae0428a910$export$d3dc8e33b7258fc5);
$parcel$export(module.exports, "STATUS_CATEGORY_WEIGHTS", () => $70b075ae0428a910$export$8fc40e3c53b7f30e);
$parcel$export(module.exports, "ANY_OPERATION", () => $70b075ae0428a910$export$804f62993e553350);
$parcel$export(module.exports, "errorSeverity", () => $70b075ae0428a910$export$927c560a42a52ce0);

var $8Qd0L = parcelRequire("8Qd0L");
const $70b075ae0428a910$export$e117396b0784c7cc = 'START';
const $70b075ae0428a910$export$331d6399b2e33350 = {
    INITIAL: 'INITIAL',
    GLOBAL: 'GLOBAL',
    DIRECTED: 'DIRECTED'
};
const $70b075ae0428a910$export$bb55b5bf71d8edff = {
    BOLT: 'bolt',
    ERROR: 'error',
    CHECK: 'check',
    CHECK_INACTIVE: 'check_inactive',
    CROSS: 'cross',
    CROSS_INACTIVE: 'cross_inactive'
};
const $70b075ae0428a910$export$9bb188cec3fcc43d = 'GLOBAL';
const $70b075ae0428a910$export$54c3a1cc8eb1bc43 = 'PROJECT';
const $70b075ae0428a910$export$d3dc8e33b7258fc5 = 'ALL';
const $70b075ae0428a910$export$8fc40e3c53b7f30e = {
    [(0, $8Qd0L.TODO)]: 1,
    [(0, $8Qd0L.IN_PROGRESS)]: 2,
    [(0, $8Qd0L.DONE)]: 3,
    [(0, $8Qd0L.UNDEFINED)]: 4
};
const $70b075ae0428a910$export$804f62993e553350 = 'ANY';
const $70b075ae0428a910$export$927c560a42a52ce0 = {
    WARNING: 'WARNING',
    ERROR: 'ERROR'
};

});

parcelRegister("g6Vr7", function(module, exports) {

$parcel$export(module.exports, "default", () => $70e7490019e1bafe$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jBy23 = parcelRequire("jBy23");

var $6vrw7 = parcelRequire("6vrw7");

var $iccsh = parcelRequire("iccsh");

var $gZQrx = parcelRequire("gZQrx");

var $thcE1 = parcelRequire("thcE1");
const $70e7490019e1bafe$export$eaa7a2e07a1c5fcf = (containerContextData, issueProjectKey)=>{
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!containerContextData || !containerContextData.project) return undefined;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const contextProject = containerContextData.project;
    const hasIssueProjectDataInContext = contextProject.key === issueProjectKey;
    if (!hasIssueProjectDataInContext) return undefined;
    return {
        projectId: (0, $6vrw7.toProjectId)(contextProject.id.toString()),
        projectType: contextProject.type,
        isSimplified: contextProject.isSimplified
    };
};
const $70e7490019e1bafe$export$d1183e28fea9e49c = {
    data: undefined,
    loading: false,
    error: undefined,
    fetch: ()=>Promise.resolve()
};
/**
 * Gets projectData from ContainerContextSubscriber or from service
 */ const $70e7490019e1bafe$var$ViewWorkflowContextService = (props)=>{
    const { ViewWorkflowService: ViewWorkflowService, ContainerContextSubscriber: ContainerContextSubscriber, baseUrl: baseUrl, issueKey: issueKey, children: children } = props;
    if ((0, $iccsh.isWorkflowDataServiceHookEnabled)()) // eslint-disable-next-line react-hooks/rules-of-hooks
    return children((0, $gZQrx.useProjectViewWorkflowService)(baseUrl, issueKey));
    // ff use-view-workflow-service-hook_8y6bk cleanup: remove return below and unwrap ff conditional above
    const issueProjectKey = issueKey ? (0, $jBy23.extractProjectKey)(issueKey) : null;
    if (!issueKey || !issueProjectKey) return children({
        ...$70e7490019e1bafe$export$d1183e28fea9e49c
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContainerContextSubscriber, null, ({ data: containerContextData })=>{
        const contextData = $70e7490019e1bafe$export$eaa7a2e07a1c5fcf(containerContextData, issueProjectKey);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewWorkflowService, {
            baseUrl: baseUrl,
            issueKey: issueKey,
            projectKey: contextData ? undefined : issueProjectKey,
            isSimplified: contextData && contextData.isSimplified
        }, ({ data: serviceData, ...serviceProps })=>{
            const data = contextData || serviceData ? {
                ...contextData,
                ...serviceData
            } : undefined;
            return children({
                data: data,
                ...serviceProps
            });
        });
    });
};
$70e7490019e1bafe$var$ViewWorkflowContextService.defaultProps = {
    ViewWorkflowService: (0, $thcE1.ViewWorkflowService)
};
var $70e7490019e1bafe$export$2e2bcd8739ae039 = $70e7490019e1bafe$var$ViewWorkflowContextService;

});
parcelRegister("gZQrx", function(module, exports) {

$parcel$export(module.exports, "useProjectViewWorkflowService", () => $9ce703895fb9b49d$export$aa23574b54bd5f5e);

var $7ZZxN = parcelRequire("7ZZxN");

var $jBy23 = parcelRequire("jBy23");

var $cPEpP = parcelRequire("cPEpP");

var $6vrw7 = parcelRequire("6vrw7");

var $dWLk9 = parcelRequire("dWLk9");

var $bXrMR = parcelRequire("bXrMR");
const $9ce703895fb9b49d$export$d1183e28fea9e49c = {
    data: undefined,
    loading: false,
    error: undefined,
    fetch: ()=>Promise.resolve()
};
const $9ce703895fb9b49d$var$getIssueProjectDataFromContext = (useProjectData, issueProjectKey)=>{
    if (!useProjectData || !useProjectData.data) return undefined;
    const hasIssueProjectDataInContext = useProjectData.data.key === issueProjectKey;
    if (!hasIssueProjectDataInContext) return undefined;
    return {
        projectId: (0, $6vrw7.toProjectId)(useProjectData.data.id.toString()),
        projectType: (0, $7ZZxN.toProjectType)(useProjectData.data.type),
        isSimplified: useProjectData.data.isSimplified
    };
};
const $9ce703895fb9b49d$export$aa23574b54bd5f5e = (baseUrl, issueKey)=>{
    const issueProjectKey = issueKey ? (0, $jBy23.extractProjectKey)(issueKey) : null;
    const useProjectData = (0, $cPEpP.useProject)();
    const projectContextData = $9ce703895fb9b49d$var$getIssueProjectDataFromContext(useProjectData, issueProjectKey);
    const cloudId = (0, $dWLk9.useCloudId)();
    const issueContextData = (0, $bXrMR.useViewWorkflowData)({
        baseUrl: baseUrl,
        projectKey: projectContextData ? undefined : issueProjectKey || undefined,
        issueKey: issueKey,
        isSimplified: projectContextData && projectContextData.isSimplified,
        cloudId: cloudId
    });
    if (!issueKey || !issueProjectKey) return {
        ...$9ce703895fb9b49d$export$d1183e28fea9e49c
    };
    const combinedData = projectContextData || issueContextData.data ? {
        ...projectContextData,
        ...issueContextData.data
    } : undefined;
    return {
        ...issueContextData,
        data: combinedData
    };
};

});
parcelRegister("cPEpP", function(module, exports) {

$parcel$export(module.exports, "useProject", () => $681442ce6e3ade0b$export$51b1383ef8844a7);

var $eUqFw = parcelRequire("eUqFw");

var $eWsAG = parcelRequire("eWsAG");

var $2futN = parcelRequire("2futN");
const $681442ce6e3ade0b$export$51b1383ef8844a7 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2futN.useProjectSidebarNavigation)();
    const project = (0, $eUqFw.useMemo)(()=>data && (0, $eWsAG.extractData)(data), [
        data
    ]);
    return {
        data: project,
        loading: loading,
        error: error
    };
};

});
parcelRegister("2futN", function(module, exports) {

$parcel$export(module.exports, "useProjectSidebarNavigation", () => $e6824b09c7b48982$export$5a85006c180fb373);
$parcel$export(module.exports, "useProjectSidebarConnectNavigation", () => $e6824b09c7b48982$export$2bed15cd7d167db5);
$parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", () => $e6824b09c7b48982$export$a9d05fc2c1d94895);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", () => $e6824b09c7b48982$export$d48e3c3556894533);
$parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", () => $e6824b09c7b48982$export$24a781cd863077aa);
$parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", () => $e6824b09c7b48982$export$e16ecd2512eb0dc7);
$parcel$export(module.exports, "useJiraSoftwareProjectNavigation", () => $e6824b09c7b48982$export$68dc0ecbea8211d2);
$parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", () => $e6824b09c7b48982$export$5cf90b625d0e1248);
$parcel$export(module.exports, "useJiraProductDiscoveryProjectNavigation", () => $e6824b09c7b48982$export$d63d92edebe543d9);

var $eUqFw = parcelRequire("eUqFw");

var $7wRIc = parcelRequire("7wRIc");
var $kKeF6 = parcelRequire("kKeF6");
var $iivTa = parcelRequire("iivTa");
var $cbmC6 = parcelRequire("cbmC6");
var $kXWpU = parcelRequire("kXWpU");

var $3HCkE = parcelRequire("3HCkE");

var $eC4Qa = parcelRequire("eC4Qa");

var $5MpiC = parcelRequire("5MpiC");

var $cLNfQ = parcelRequire("cLNfQ");
const $e6824b09c7b48982$export$5a85006c180fb373 = (customContext)=>{
    const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, $eC4Qa.useInitFetchResource)((0, $5MpiC.useResourceWithCustomRouterContext)((0, $kXWpU.staticProjectSidebarNavigationResource), customContext));
    const memoizedResponse = (0, $eUqFw.useMemo)(()=>navResponse, [
        navResponse
    ]);
    (0, $cLNfQ.useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
    return {
        data: memoizedResponse,
        loading: memoizedResponse != null ? false : loading,
        refresh: refresh,
        clearAll: clearAll,
        error: error,
        ...rest
    };
};
const $e6824b09c7b48982$export$2bed15cd7d167db5 = ()=>(0, $3HCkE.useResource)((0, $cbmC6.staticProjectSidebarConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$a9d05fc2c1d94895 = ()=>(0, $3HCkE.useResource)((0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$d48e3c3556894533 = ()=>(0, $3HCkE.useResource)((0, $iivTa.staticProjectSettingsSidebarConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$24a781cd863077aa = ()=>(0, $3HCkE.useResource)((0, $7wRIc.staticJSMProjectConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$e16ecd2512eb0dc7 = ()=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
    const response = data?.jiraWorkManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $e6824b09c7b48982$export$68dc0ecbea8211d2 = ()=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
    const response = data?.jiraSoftwareNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $e6824b09c7b48982$export$5cf90b625d0e1248 = (customContext)=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373(customContext);
    const response = data?.jiraServiceManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $e6824b09c7b48982$export$d63d92edebe543d9 = ()=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
    const response = data?.jiraProductDiscoveryNavData || null;
    return {
        data: response,
        ...rest
    };
};

});
parcelRegister("7wRIc", function(module, exports) {

$parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", () => $1da568058e8dfab8$export$fab84295e18e9246);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $76v64 = parcelRequire("76v64");
const $1da568058e8dfab8$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $1da568058e8dfab8$export$fab84295e18e9246 = (0, $3HCkE.createResource)({
    type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
    getKey: ({ match: match, query: query })=>$1da568058e8dfab8$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $1da568058e8dfab8$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
        return navInfo;
    },
    maxAge: 300000
});

});
parcelRegister("76v64", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", () => $c603d0485f5d33bd$export$b15f9f5cf6db359e);

var $lRmyA = parcelRequire("lRmyA");
const $c603d0485f5d33bd$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
    if (projectKeyOrId == null) throw new Error('invalid identifier specified');
    return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
};

});


parcelRegister("kKeF6", function(module, exports) {

$parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", () => $5a0ad956b22e7be5$export$b662f3f877add30d);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $76v64 = parcelRequire("76v64");
const $5a0ad956b22e7be5$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $5a0ad956b22e7be5$export$b662f3f877add30d = (0, $3HCkE.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$5a0ad956b22e7be5$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $5a0ad956b22e7be5$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("iivTa", function(module, exports) {

$parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", () => $a5660a56dfe8a855$export$e4bf33528101348c);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $76v64 = parcelRequire("76v64");
const $a5660a56dfe8a855$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $a5660a56dfe8a855$export$e4bf33528101348c = (0, $3HCkE.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$a5660a56dfe8a855$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $a5660a56dfe8a855$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("cbmC6", function(module, exports) {

$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", () => $9d72696b0f8eb1a8$export$b8c6e2666f12f4bb);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $76v64 = parcelRequire("76v64");
const $9d72696b0f8eb1a8$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $9d72696b0f8eb1a8$export$b8c6e2666f12f4bb = (0, $3HCkE.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$9d72696b0f8eb1a8$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $9d72696b0f8eb1a8$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const projectHomeAddonNavInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
        return projectHomeAddonNavInfo;
    },
    maxAge: 300000
});

});

parcelRegister("eC4Qa", function(module, exports) {

$parcel$export(module.exports, "useInitFetchResource", () => $556134fecbd51c63$export$5b98692301d8680);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");
const $556134fecbd51c63$export$5b98692301d8680 = (resource)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, ...rest } = resource;
    (0, $eUqFw.useEffect)(()=>{
        // skip init fetch resource when ff is off
        if (!(0, $1ybV0.ff)('fission-nav4-fetch-from-router_ma0x8')) return;
        if (!data && !loading && !error && refresh) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return {
        data: data,
        loading: loading,
        error: error,
        refresh: refresh,
        ...rest
    };
};

});

parcelRegister("5MpiC", function(module, exports) {

$parcel$export(module.exports, "useResourceWithCustomRouterContext", () => $3bc50c1d0e2e4d98$export$61dad767cf446185);

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");
/**
 * DUMMY_ROUTE needs to be used by default, because `route` must not be undefined, it is required/used internally by RRR, e.g. in findRouterContext() on createRouterContext() call.
 * If `route` is undefined, those will throw runtime exceptions.
 * `project-sidebar-navigation-resource/software-cmp-nav-synchronizer/index.tsx` uses dummy route as well.
 *
 * `route` must include /:paramKey for all `params` passed to the `createRouterContext`, otherwise they will be ignored
 */ const $3bc50c1d0e2e4d98$var$DUMMY_ROUTE = {
    name: 'DUMMY_ROUTE_NAME',
    path: '/projects/:projectKey/dummyroute'
};
const $3bc50c1d0e2e4d98$export$61dad767cf446185 = (resource, customRouterContext)=>{
    let useResourceArgCustomContext;
    if (customRouterContext) {
        // NOTE: params are route-specific. Caller must know
        const { route: route = $3bc50c1d0e2e4d98$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) useResourceArgCustomContext = {
            // NOTE: createRouterContext will throw error if route is undefined; it checks its .path at least. Jfyi, createProjectRouteRouterContext() in JSW uses dummy route, with :projectKey in its path (that resource fetch function uses)
            routerContext: (0, $kJlBc.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    return (0, $3HCkE.useResource)(resource, useResourceArgCustomContext);
};

});

parcelRegister("cLNfQ", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", () => $1154a45446083a64$export$780174995da89d60);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $kXWpU = parcelRequire("kXWpU");

var $kXWpU = parcelRequire("kXWpU");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");
const $1154a45446083a64$export$90dbde7e33e6e21 = ()=>null;
const $1154a45446083a64$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $kJlBc.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/:projectKey/dummyroute',
        component: $1154a45446083a64$export$90dbde7e33e6e21
    }, {
        params: {
            projectKey: projectKey
        }
    }) : undefined;
const $1154a45446083a64$export$19001bab9e4b7f8f = (projectKey)=>{
    const { data: data, update: update } = (0, $3HCkE.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource), {
        routerContext: $1154a45446083a64$export$d647718555c2fdd8(projectKey)
    });
    return {
        data: data,
        update: update
    };
};
const $1154a45446083a64$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $kJlBc.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
        component: $1154a45446083a64$export$90dbde7e33e6e21
    }, {
        params: {
            boardId: `${boardId}`
        }
    }) : undefined;
const $1154a45446083a64$export$e2bb7877e6cec3eb = (boardId)=>{
    const { data: data, update: update } = (0, $3HCkE.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource), {
        routerContext: $1154a45446083a64$export$23dc6491016cabdc(boardId)
    });
    return {
        data: data,
        update: update
    };
};
const $1154a45446083a64$export$780174995da89d60 = (latestNavInfo)=>{
    const [{ match: match, query: query, route: { name: name } }] = (0, $kJlBc.useRouter)();
    const isOnBoardBasedRoute = (0, $kXWpU.getIdentifier)(name, match, query)?.identifierType === 'boardId';
    const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
    const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
    const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
    // explicitly get project data by forcing key to be project
    const { data: projectRouteNavInfo, update: updateProjectRoute } = $1154a45446083a64$export$19001bab9e4b7f8f(pKey);
    // explicitly get board data by forcing key to be board
    const { data: boardRouteNavInfo, update: updateBoardRoute } = $1154a45446083a64$export$e2bb7877e6cec3eb(boardId);
    // if software CMP project or board data is not in sync, then force update
    (0, $eUqFw.useEffect)(()=>{
        if (latestNavInfo != null && isSoftwareCMP) {
            if (isOnBoardBasedRoute && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
        }
    }, [
        isOnBoardBasedRoute,
        latestNavInfo,
        updateProjectRoute,
        updateBoardRoute,
        projectRouteNavInfo,
        boardRouteNavInfo,
        isSoftwareCMP
    ]);
};

});



parcelRegister("bXrMR", function(module, exports) {

$parcel$export(module.exports, "useViewWorkflowData", () => $34326079970e858d$export$d60b63dd0a193e30);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");


var $dhlfE = parcelRequire("dhlfE");
const $34326079970e858d$export$7a2d7e5adacde085 = ()=>'/rest/gira/latest/?operation=nextGenViewWorkflowQuery';
const $34326079970e858d$var$optionsGraphQlQuery = (issueKey, cloudId, projectKey)=>`
    query nextGenViewWorkflowQuery {
        permissions(issueKey:"${issueKey}", keys:["${0, $e7647232d7445c32$export$136fc24ec1bfcefd}", "${0, $e7647232d7445c32$export$624e7abc8d9cada5}"]) {
            key
            havePermission
        }
        ${projectKey ? `project(projectKey: "${projectKey}") {
            projectId
            simplified
            type
        }` : ''}
        jira {
            issueByKey(key: "${issueKey}", cloudId: "${cloudId}") {
                fieldsById(ids: ["issuetype"]) {
                    edges {
                        node {
                            ... on JiraIssueTypeField {
                                fieldId
                                issueType {
                                issueTypeId
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
const $34326079970e858d$export$7fe04353ef301d96 = (baseUrl, issueKey, cloudId, projectKey, isSimplified)=>(0, $2OdyW.default)($34326079970e858d$export$7a2d7e5adacde085(), {
        method: 'POST',
        body: JSON.stringify({
            query: $34326079970e858d$var$optionsGraphQlQuery(issueKey, cloudId, projectKey)
        })
    }).then((data)=>(0, $dhlfE.transform)(data, isSimplified));
const $34326079970e858d$export$d60b63dd0a193e30 = ({ baseUrl: baseUrl, projectKey: projectKey, issueKey: issueKey, isSimplified: isSimplified, cloudId: cloudId })=>{
    const [dataState, setDataState] = (0, $eUqFw.useState)(undefined);
    const [errorState, setErrorState] = (0, $eUqFw.useState)(undefined);
    const [loadingState, setLoadingState] = (0, $eUqFw.useState)(false);
    const fetch = async ()=>{
        request();
        try {
            const dataRes = await $34326079970e858d$export$7fe04353ef301d96(baseUrl, issueKey, cloudId, projectKey, isSimplified);
            success(dataRes);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $e7647232d7445c32$export$4bf6353caa97e8e7), ex);
            failure(ex);
        }
    };
    const request = ()=>{
        setDataState(undefined);
        setErrorState(undefined);
        setLoadingState(true);
    };
    const success = (data)=>{
        setDataState(data);
        setErrorState(undefined);
        setLoadingState(false);
    };
    const failure = (error)=>{
        setDataState(undefined);
        setErrorState(error);
        setLoadingState(false);
    };
    return {
        data: dataState,
        error: errorState,
        loading: loadingState,
        fetch: fetch
    };
};

});
parcelRegister("dhlfE", function(module, exports) {

$parcel$export(module.exports, "transform", () => $323479dc3a12c1eb$export$51186ad6e864892a);

var $7ZZxN = parcelRequire("7ZZxN");

var $6vrw7 = parcelRequire("6vrw7");

// @ts-expect-error - TS7031 - Binding element 'key' implicitly has an 'any' type. | TS7031 - Binding element 'havePermission' implicitly has an 'any' type.
const $323479dc3a12c1eb$var$simplifiedPermissionPredicate = ({ key: key, havePermission: havePermission })=>key === (0, $e7647232d7445c32$export$136fc24ec1bfcefd) && havePermission || key === (0, $e7647232d7445c32$export$624e7abc8d9cada5) && havePermission;
// @ts-expect-error - TS7031 - Binding element 'key' implicitly has an 'any' type. | TS7031 - Binding element 'havePermission' implicitly has an 'any' type.
const $323479dc3a12c1eb$var$classicPermissionPredicate = ({ key: key, havePermission: havePermission })=>key === (0, $e7647232d7445c32$export$136fc24ec1bfcefd) && havePermission;
const $323479dc3a12c1eb$export$51186ad6e864892a = ({ data: data }, isSimplifiedCached)=>{
    if (!data || !data.permissions || !data.jira) return undefined;
    const { permissions: permissions, project: project, jira: jira } = data;
    const isSimplified = project && project.simplified || isSimplifiedCached;
    const permissionPredicate = isSimplified === true ? $323479dc3a12c1eb$var$simplifiedPermissionPredicate : $323479dc3a12c1eb$var$classicPermissionPredicate;
    const issueTypeField = jira.issueByKey?.fieldsById?.edges?.find((edge)=>edge.node?.fieldId === 'issuetype');
    const result = {
        hasPermission: permissions.some(permissionPredicate),
        issueTypeId: (0, $6vrw7.toIssueTypeId)(issueTypeField?.node?.issueType?.issueTypeId ? issueTypeField.node.issueType.issueTypeId : '')
    };
    if (project) {
        result.projectId = (0, $6vrw7.toProjectId)(String(project.projectId));
        result.projectType = (0, $7ZZxN.toProjectType)(project.type);
        result.isSimplified = project.simplified;
    }
    return result;
};

});



parcelRegister("thcE1", function(module, exports) {

$parcel$export(module.exports, "ViewWorkflowService", () => $14939fe4dd5d0b81$export$4318ed1e08552945);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");


var $aSR7x = parcelRequire("aSR7x");
const $14939fe4dd5d0b81$export$7a2d7e5adacde085 = (baseUrl)=>`${baseUrl}/rest/gira/latest/`;
const $14939fe4dd5d0b81$var$optionsGraphQlQuery = (issueKey, projectKey)=>`
    query nextGenViewWorkflowQuery {
        permissions(issueKey:"${issueKey}", keys:["${0, $e7647232d7445c32$export$136fc24ec1bfcefd}", "${0, $e7647232d7445c32$export$624e7abc8d9cada5}"]) {
            key
            havePermission
        }
        viewIssue(issueKey: "${issueKey}") {
            fields {
                ... on IssueTypeField {
                    fieldKey
                    id
                }
            }
        }
        ${projectKey ? `project(projectKey: "${projectKey}") {
            projectId
            simplified
            type
        }` : ''}
    }
`;
const $14939fe4dd5d0b81$export$7fe04353ef301d96 = (baseUrl, issueKey, projectKey, isSimplified)=>(0, $2OdyW.default)($14939fe4dd5d0b81$export$7a2d7e5adacde085(baseUrl), {
        method: 'POST',
        body: JSON.stringify({
            query: $14939fe4dd5d0b81$var$optionsGraphQlQuery(issueKey, projectKey)
        })
    }).then((data)=>(0, $aSR7x.transform)(data, isSimplified));
// ff use-view-workflow-service-hook_8y6bk cleanup: remove ViewWorkflowService and everything in this directory, it is replaced by useViewWorkflowData
// eslint-disable-next-line jira/react/no-class-components
class $14939fe4dd5d0b81$export$4318ed1e08552945 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.fetch = async ()=>{
            const { baseUrl: baseUrl, projectKey: projectKey, issueKey: issueKey, isSimplified: isSimplified } = this.props;
            this.request();
            try {
                const data = await $14939fe4dd5d0b81$export$7fe04353ef301d96(baseUrl, issueKey, projectKey, isSimplified);
                this.success(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (ex) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $e7647232d7445c32$export$4bf6353caa97e8e7), ex);
                this.failure(ex);
            }
        };
        this.request = ()=>{
            this.setState({
                error: undefined,
                loading: true,
                data: undefined
            });
        };
        this.success = (data)=>{
            this.setState({
                loading: false,
                data: data
            });
        };
        this.failure = (error)=>{
            this.setState({
                error: error,
                loading: false
            });
        };
        this.state = {
            data: undefined,
            loading: false,
            error: undefined
        };
    }
    render() {
        return this.props.children({
            ...this.state,
            fetch: this.fetch
        });
    }
}

});
parcelRegister("aSR7x", function(module, exports) {

$parcel$export(module.exports, "transform", () => $5e7d127f35e12e5c$export$51186ad6e864892a);

var $7ZZxN = parcelRequire("7ZZxN");

var $6vrw7 = parcelRequire("6vrw7");

// @ts-expect-error - TS7031 - Binding element 'key' implicitly has an 'any' type. | TS7031 - Binding element 'havePermission' implicitly has an 'any' type.
const $5e7d127f35e12e5c$var$simplifiedPermissionPredicate = ({ key: key, havePermission: havePermission })=>key === (0, $e7647232d7445c32$export$136fc24ec1bfcefd) && havePermission || key === (0, $e7647232d7445c32$export$624e7abc8d9cada5) && havePermission;
// @ts-expect-error - TS7031 - Binding element 'key' implicitly has an 'any' type. | TS7031 - Binding element 'havePermission' implicitly has an 'any' type.
const $5e7d127f35e12e5c$var$classicPermissionPredicate = ({ key: key, havePermission: havePermission })=>key === (0, $e7647232d7445c32$export$136fc24ec1bfcefd) && havePermission;
const $5e7d127f35e12e5c$export$51186ad6e864892a = ({ data: data }, isSimplifiedCached)=>{
    if (!data || !data.permissions || !data.viewIssue) return undefined;
    const { permissions: permissions, project: project, viewIssue: viewIssue } = data;
    const isSimplified = project && project.simplified || isSimplifiedCached;
    const permissionPredicate = isSimplified === true ? $5e7d127f35e12e5c$var$simplifiedPermissionPredicate : $5e7d127f35e12e5c$var$classicPermissionPredicate;
    const issueTypeField = viewIssue.fields.find((field)=>field.fieldKey === 'issuetype');
    const result = {
        hasPermission: permissions.some(permissionPredicate),
        issueTypeId: (0, $6vrw7.toIssueTypeId)(issueTypeField ? issueTypeField.id : '')
    };
    if (project) {
        result.projectId = (0, $6vrw7.toProjectId)(String(project.projectId));
        result.projectType = (0, $7ZZxN.toProjectType)(project.type);
        result.isSimplified = project.simplified;
    }
    return result;
};

});



parcelRegister("3BadD", function(module, exports) {

$parcel$export(module.exports, "StatusView", () => $d882b3ccfb1ea465$export$a11134e1462e763);
$parcel$export(module.exports, "default", () => $d882b3ccfb1ea465$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2vzCR = parcelRequire("2vzCR");

var $jG2Eu = parcelRequire("jG2Eu");

var $4zgIJ = parcelRequire("4zgIJ");
var $4IBr3 = parcelRequire("4IBr3");

var $kNcnV = parcelRequire("kNcnV");

var $f8Yej = parcelRequire("f8Yej");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hzcvF = parcelRequire("hzcvF");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");

var $2GJ4g = parcelRequire("2GJ4g");

var $50D0V = parcelRequire("50D0V");

var $iccsh = parcelRequire("iccsh");

var $99Syk = parcelRequire("99Syk");

var $f3qzK = parcelRequire("f3qzK");

var $5x3wA = parcelRequire("5x3wA");

var $fr49r = parcelRequire("fr49r");

var $dSoqn = parcelRequire("dSoqn");
const $d882b3ccfb1ea465$var$defaultPopperProps = {
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            options: {
                padding: 5,
                rootBoundary: 'document'
            }
        }
    ],
    // makes it work inside modal-dialog
    strategy: 'fixed'
};
const $d882b3ccfb1ea465$export$d5aa018254c8c065 = (0, $g8JvH.AnalyticsEventToProps)('statusField', {
    onOpen: 'openDropdown',
    onChange: 'transitionSelected'
})((0, $4IBr3.default));
const $d882b3ccfb1ea465$export$f35c79a5a21cbec1 = (0, $g8JvH.AnalyticsEventToProps)('statusField', {
    onOpen: 'openDropdown',
    onChange: 'transitionSelected'
})((0, $4zgIJ.default));
const $d882b3ccfb1ea465$export$a11134e1462e763 = ({ forceNoLabels: forceNoLabels = false, isEditable: isEditable = true, isSaving: isSaving = false, isLoading: isLoading, error: error, value: value, transitions: transitions, appearance: appearance, footer: footer, isDefaultSelect: isDefaultSelect = false, selectedTransition: selectedTransition, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onOpen: onOpen = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess, customNoOptionsMessage: customNoOptionsMessage, statusButtonRef: statusButtonRef, popperProps: popperProps, registerInCommandPalette: registerInCommandPalette, onFetch: onFetch, fieldId: fieldId, defaultOpen: // for testing
defaultOpen = false, shouldFitContainer: shouldFitContainer = true })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const childWrapperRef = (0, $eUqFw.useRef)(null);
    const wasChanged = (0, $eUqFw.useRef)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const previousIsSaving = (0, $hzcvF.usePrevious)(isSaving);
    const previousTransitions = (0, $hzcvF.usePrevious)(transitions);
    const previousIsOpen = (0, $hzcvF.usePrevious)(isOpen);
    const wasFetchSuccessful = transitions != null;
    const filteredAndOrderedTransitions = (0, $50D0V.getFilteredOrderedTransitions)(transitions, value.id);
    const isGlobalOnly = (0, $50D0V.isOnlyGlobalTransitions)(filteredAndOrderedTransitions || []);
    const showLabel = !(forceNoLabels || isGlobalOnly);
    const formatTransitionOptionLabel = (0, $eUqFw.useCallback)((option, transitionProps)=>(0, $iccsh.isStatusInGicEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "issue-field-status.ui.status-view.transition"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dSoqn.Transition), {
            transition: option.transition,
            hasLabel: showLabel,
            addTransitionArrowSpacing: transitionProps?.addTransitionArrowSpacing
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dSoqn.Transition), {
            transition: option.transition,
            hasLabel: !isGlobalOnly,
            addTransitionArrowSpacing: transitionProps?.addTransitionArrowSpacing
        }), [
        showLabel,
        isGlobalOnly
    ]);
    // specifically for screen readers
    const getTransitionOptionLabel = (option)=>option.transition.isGlobal ? formatMessage((0, $f3qzK.default).transitionTo, {
            statusName: option.label
        }) : `${option.transition.name} \u{2192} ${option.transition.to.name}`;
    const isOptionDisabled = (option)=>(0, $iccsh.isStatusInGicEnabled)() ? option.transition.isDisabled : false;
    const mergedPopperProps = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))($d882b3ccfb1ea465$var$defaultPopperProps, popperProps), [
        popperProps
    ]);
    // componentWillUpdate
    (0, $eUqFw.useEffect)(()=>{
        if (previousIsSaving === true && isSaving === false) childWrapperRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        childWrapperRef.current.children.length > 0 && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        childWrapperRef.current.children[0].focus();
    }, [
        isOpen,
        isSaving,
        previousIsOpen,
        previousIsSaving,
        previousTransitions,
        transitions
    ]);
    const handleChangeStatus = (0, $eUqFw.useCallback)((transition, analyticsEvent)=>{
        const { hasScreen: hasScreen } = transition;
        wasChanged.current = true;
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'transitionSelectedStatusField', {
            hasScreen: hasScreen
        });
        onChange?.(transition, analyticsEvent);
    }, [
        onChange
    ]);
    const handleChange = (0, $eUqFw.useCallback)((option, action, analyticsEvent)=>{
        handleChangeStatus(option.transition, analyticsEvent);
    }, [
        handleChangeStatus
    ]);
    const handleOpen = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'openDropdownStatusField');
        onOpen?.(analyticsEvent);
        setIsOpen(true);
    }, [
        onOpen
    ]);
    const handleClose = (0, $eUqFw.useCallback)(()=>{
        wasChanged.current = false;
        onClose?.();
        setIsOpen(false);
    }, [
        onClose
    ]);
    const renderLozenge = (0, $eUqFw.useCallback)(({ isEditable: editable, isSaving: saving, error: err, targetRef: targetRef })=>{
        if (saving) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNcnV.default), {
            border: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.WrappedStatusLozenge), {
            targetRef: targetRef,
            status: value,
            error: error
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.WrappedStatusLozenge), {
            ariaLabel: `${value.name} - ${formatMessage((0, $f3qzK.default).changeStatus)}`,
            error: err,
            hasHoverState: true,
            isEditable: editable,
            isOpen: isOpen,
            status: value,
            targetRef: targetRef
        });
    }, [
        error,
        formatMessage,
        isOpen,
        value
    ]);
    const renderButton = (0, $eUqFw.useCallback)(({ isEditable: editable, isSaving: saving, targetRef: targetRef })=>{
        const statusButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fr49r.StatusButton), {
            ariaLabel: `${value.name} - ${formatMessage((0, $f3qzK.default).changeStatus)}`,
            isEditable: editable,
            isOpen: isOpen,
            status: value,
            targetRef: targetRef,
            statusButtonRef: statusButtonRef,
            shouldFitContainer: shouldFitContainer
        });
        return saving ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNcnV.default), null, statusButton) : statusButton;
    }, [
        formatMessage,
        isOpen,
        statusButtonRef,
        value,
        shouldFitContainer
    ]);
    const renderCommandPalette = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $99Syk.CommandPaletteStatusView), {
            transitions: filteredAndOrderedTransitions,
            currentStatus: value,
            onSuccess: onSuccess,
            wasFetchSuccessful: wasFetchSuccessful,
            renderTransition: formatTransitionOptionLabel,
            onFetch: onFetch,
            isLoading: isLoading
        }), [
        filteredAndOrderedTransitions,
        value,
        onSuccess,
        wasFetchSuccessful,
        formatTransitionOptionLabel,
        onFetch,
        isLoading
    ]);
    const renderWithFocusWrapper = (0, $eUqFw.useCallback)(// @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
    (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: childWrapperRef
        }, children), []);
    const renderTarget = (0, $eUqFw.useCallback)(({ isEditable: editable, isSaving: saving, error: err, targetRef: targetRef })=>{
        if (value) {
            if (appearance === 'lozenge') return renderWithFocusWrapper(renderLozenge({
                isEditable: editable,
                isSaving: saving,
                error: err,
                targetRef: targetRef
            }));
            if (appearance === 'button') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderWithFocusWrapper(renderButton({
                isEditable: editable,
                isSaving: saving,
                targetRef: targetRef
            })), registerInCommandPalette && renderCommandPalette());
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null);
    }, [
        appearance,
        registerInCommandPalette,
        renderButton,
        renderCommandPalette,
        renderLozenge,
        renderWithFocusWrapper,
        value
    ]);
    /* This prevents the dropdown from being accessible while saving/not editable,
   * because for the underlying PopupSelect, the `isDisabled` prop only prevents
   * the actual dropdown items from being selectable - the dropdown itself still
   * pops up/down.
   */ if (isSaving || !isEditable) return renderTarget({
        isSaving: isSaving,
        isEditable: isEditable,
        error: error
    });
    const getNoOptionsMessage = ()=>{
        if (customNoOptionsMessage) return customNoOptionsMessage;
        return formatMessage(wasFetchSuccessful ? (0, $f3qzK.default).noPermission : (0, $f3qzK.default).cannotLoadTransitions);
    };
    const statusPopup = isDefaultSelect && selectedTransition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d882b3ccfb1ea465$export$f35c79a5a21cbec1, {
        inputId: fieldId,
        noOptionsMessage: getNoOptionsMessage,
        formatOptionLabel: formatTransitionOptionLabel,
        getOptionLabel: getTransitionOptionLabel,
        options: (0, $50D0V.transformOptions)(filteredAndOrderedTransitions || []),
        isLoading: isLoading,
        isDisabled: !isEditable,
        isOptionDisabled: isOptionDisabled,
        onChange: handleChange,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        value: (0, $50D0V.transformOptions)([
            selectedTransition
        ])[0],
        isSearchable: false,
        onOpen: handleOpen,
        onClose: handleClose,
        closeMenuOnSelect: true,
        components: {
            LoadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5x3wA.LoadingSpinner), null)
        },
        popperProps: mergedPopperProps,
        footer: footer
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d882b3ccfb1ea465$export$d5aa018254c8c065, {
        inputId: fieldId,
        noOptionsMessage: getNoOptionsMessage,
        formatOptionLabel: formatTransitionOptionLabel,
        getOptionLabel: getTransitionOptionLabel,
        options: (0, $50D0V.transformOptions)(filteredAndOrderedTransitions || []),
        target: ({ ref: ref })=>renderTarget({
                isEditable: isEditable,
                isSaving: isSaving,
                error: error,
                targetRef: ref
            }),
        isLoading: isLoading,
        isDisabled: !isEditable,
        isOptionDisabled: isOptionDisabled,
        searchThreshold: 99999,
        onChange: handleChange,
        onOpen: handleOpen,
        onClose: handleClose,
        closeMenuOnSelect: true,
        components: {
            LoadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5x3wA.LoadingSpinner), null)
        },
        popperProps: mergedPopperProps,
        footer: footer,
        defaultIsOpen: defaultOpen
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }, statusPopup);
};
var $d882b3ccfb1ea465$export$2e2bcd8739ae039 = $d882b3ccfb1ea465$export$a11134e1462e763;

});
parcelRegister("kNcnV", function(module, exports) {

$parcel$export(module.exports, "default", () => $615c2b2f32d9571c$export$2e2bcd8739ae039);

var $5oqGi = parcelRequire("5oqGi");
var $615c2b2f32d9571c$export$2e2bcd8739ae039 = (0, $5oqGi.default);

});
parcelRegister("5oqGi", function(module, exports) {

$parcel$export(module.exports, "default", () => $33d7187de9305cdc$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
function $33d7187de9305cdc$export$2e2bcd8739ae039(props) {
    const { border: border, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$BlanketContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$BackgroundContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$Background, {
        border: border
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$ComponentContainer, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$SpinnerContainer, {
        role: "status",
        "aria-label": "Loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null)));
}
$33d7187de9305cdc$export$2e2bcd8739ae039.defaultProps = {
    border: true
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $33d7187de9305cdc$var$BlanketContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c116y _2lx2vrvc _4t3i1wug",
            __cmplp.className
        ])
    });
});
const $33d7187de9305cdc$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltvidpf _4t3i1osq _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _u5f3u2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $33d7187de9305cdc$var$BackgroundContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _4t3i1osq _1bsb1osq _vchhusvi _1yt483op _1reo1wug _18m91wug",
            __cmplp.className
        ])
    });
});
const $33d7187de9305cdc$var$Background = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { border: border, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i1osq _1bsb1osq _vchhusvi _bfhk14n2 _2rko1l7b",
            __cmplp.border ? "_19it1qih" : "_19itglyw",
            __cmplp.className
        ])
    });
});
const $33d7187de9305cdc$var$ComponentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_tzy4sxj9 _16jlkb7n _1o9zkb7n _i0dl1wug",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2GJ4g", function(module, exports) {

$parcel$export(module.exports, "TEST_ID_PREFIX", () => $0211a3ed28924b4c$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $0211a3ed28924b4c$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $0211a3ed28924b4c$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $bbaTG = parcelRequire("bbaTG");

var $2ziLQ = parcelRequire("2ziLQ");

var $PdmhA = parcelRequire("PdmhA");

var $bR5MV = parcelRequire("bR5MV");

var $iccsh = parcelRequire("iccsh");

var $a8LdG = parcelRequire("a8LdG");
const $0211a3ed28924b4c$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $0211a3ed28924b4c$var$CustomChevronDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: (0, $iccsh.isFitAndFinishEnabled)() ? 12 : 13,
        height: (0, $iccsh.isFitAndFinishEnabled)() ? 12 : 13,
        viewBox: "5 5 13 13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $0211a3ed28924b4c$var$EditableLozenge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8LdG.Lozenge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StyledLozengeContentWrapper, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $0211a3ed28924b4c$var$CustomChevronDownGlyph,
        label: ""
    })));
const $0211a3ed28924b4c$export$f72db4ad1e9b3e6d = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StyledLozenge, {
        hasHoverState: hasHoverState,
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StatusContentWrapper, {
        ref: targetRef,
        "data-testid": `${$0211a3ed28924b4c$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$EditableLozenge, null, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8LdG.Lozenge), null, name)));
const $0211a3ed28924b4c$export$69ea4907eefa8e7b = (props)=>{
    const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ref: targetRef,
        appearance: "subtle",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: 'transparent',
                    margin: 0,
                    width: 'auto',
                    height: 'auto',
                    padding: 0,
                    border: `2px solid ${error ? `var(--ds-border-danger, ${(0, $PdmhA).R300})` : 'transparent'}`,
                    borderRadius: '5px',
                    ...isEditable === true ? undefined : {
                        cursor: 'auto'
                    },
                    outline: 0,
                    boxShadow: `0 0 0 2px ${isOpen === true ? `var(--ds-border-focused, ${(0, $PdmhA).B200})` : 'transparent'}`,
                    '& > span': {
                        margin: 0
                    },
                    '&:focus, &:focus-within': {
                        boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $PdmhA).B200})`}`
                    }
                },
                spinnerStyles: spinnerStyles
            };
        },
        interactionName: "auto-generated.jira-issue-field-status.common.ui.status-lozenge.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$export$f72db4ad1e9b3e6d, {
        ...other,
        isEditable: isEditable
    }));
};
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0211a3ed28924b4c$var$StyledLozenge = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "wv585u-0"
})`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>props.isDisabled ? (0, $bR5MV.disabledColor).text : (0, $bR5MV.textColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, $bR5MV.disabledColor).bg : (0, $bR5MV.bgColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, $bR5MV.disabledColor).text : (0, $bR5MV.textHoverColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, $bR5MV.disabledColor).bg : (0, $bR5MV.bgHoverColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && // eslint-disable-next-line jira/compiled/styled-components-usages
    (0, $kwce8.css)({
        pointerEvents: 'none'
    })}}}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0211a3ed28924b4c$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o",
            (0, $iccsh.isTabularGridFieldsEnabled)() ? "_1e0c1bgi" : "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0211a3ed28924b4c$var$StatusContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            (0, $iccsh.isTabularGridFieldsEnabled)() ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bR5MV", function(module, exports) {

$parcel$export(module.exports, "STATUS_THEME_DEFAULT", () => $0bd810462bafa4a2$export$61137dce61763ec3);
$parcel$export(module.exports, "STATUS_THEME_SUCCESS", () => $0bd810462bafa4a2$export$132676d06d92ad48);
$parcel$export(module.exports, "STATUS_THEME_IN_PROGRESS", () => $0bd810462bafa4a2$export$5c1f3b72419aa125);
$parcel$export(module.exports, "statusCategoryToThemeMap", () => $0bd810462bafa4a2$export$d9e35f42afe1e488);
$parcel$export(module.exports, "bgColor", () => $0bd810462bafa4a2$export$7dcbec377a25efc6);
$parcel$export(module.exports, "textColor", () => $0bd810462bafa4a2$export$32f78bffcd82ff28);
$parcel$export(module.exports, "bgHoverColor", () => $0bd810462bafa4a2$export$69fdf3ba928b4c77);
$parcel$export(module.exports, "textHoverColor", () => $0bd810462bafa4a2$export$99ec0cf2cf1b2082);
$parcel$export(module.exports, "disabledColor", () => $0bd810462bafa4a2$export$b70f10fc4a6ba453);

var $PdmhA = parcelRequire("PdmhA");
const $0bd810462bafa4a2$export$61137dce61763ec3 = 'default';
const $0bd810462bafa4a2$export$132676d06d92ad48 = 'success';
const $0bd810462bafa4a2$export$5c1f3b72419aa125 = 'inprogress';
const $0bd810462bafa4a2$export$d9e35f42afe1e488 = {
    '1': $0bd810462bafa4a2$export$61137dce61763ec3,
    '2': $0bd810462bafa4a2$export$61137dce61763ec3,
    '3': $0bd810462bafa4a2$export$132676d06d92ad48,
    '4': $0bd810462bafa4a2$export$5c1f3b72419aa125
};
const $0bd810462bafa4a2$export$7dcbec377a25efc6 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-background-neutral, ${(0, $PdmhA.N40)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-background-success, ${(0, $PdmhA.G50)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-background-information, ${(0, $PdmhA.B50)})`
};
const $0bd810462bafa4a2$export$32f78bffcd82ff28 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-text, ${(0, $PdmhA.N500)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $PdmhA.G500)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $PdmhA.B500)})`
};
const $0bd810462bafa4a2$export$69fdf3ba928b4c77 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-background-neutral-hovered, ${(0, $PdmhA.N70)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-background-success-hovered, ${(0, $PdmhA.G400)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-background-information-hovered, ${(0, $PdmhA.B400)})`
};
const $0bd810462bafa4a2$export$99ec0cf2cf1b2082 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-text, ${(0, $PdmhA.N800)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $PdmhA.N0)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $PdmhA.N0)})`
};
const $0bd810462bafa4a2$export$b70f10fc4a6ba453 = {
    bg: `var(--ds-background-neutral, ${(0, $PdmhA.N40)})`,
    text: `var(--ds-text-disabled, ${(0, $PdmhA.N200)})`
};

});

parcelRegister("a8LdG", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $c24adb58350b577e$export$a31cbe1bf5463979);

var $eUqFw = parcelRequire("eUqFw");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");
const $c24adb58350b577e$var$containerStylesNew = {
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'inline-block',
    // There's no safe equivalent for these tokens at this moment for style attributes.
    // font.body.small is supposed to replace this but is buggy for style attributes as it's a complete `font` shorthand declaration, and the multiword fallback for the CSS variable causes it to be ignored.
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-design-token-usage
    fontSize: "var(--ds-font-size-050, 11px)",
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-design-token-usage
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    fontWeight: 700,
    maxWidth: '100%',
    padding: 0,
    textTransform: 'uppercase',
    verticalAlign: 'top'
};
const $c24adb58350b577e$var$containerStylesOld = {
    borderRadius: $c9TLT.borderRadius,
    boxSizing: 'border-box',
    display: 'inline-block',
    fontSize: '11px',
    fontWeight: 700,
    lineHeight: 1,
    maxWidth: '100%',
    padding: `${"var(--ds-space-025, 2px)"} 0`,
    textTransform: 'uppercase',
    verticalAlign: 'baseline'
};
const $c24adb58350b577e$var$contentStyles = {
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: 200,
    overflow: 'hidden',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%'
};
const $c24adb58350b577e$export$a31cbe1bf5463979 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: (0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? $c24adb58350b577e$var$containerStylesNew : $c24adb58350b577e$var$containerStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: $c24adb58350b577e$var$contentStyles
    }, children));
$c24adb58350b577e$export$a31cbe1bf5463979.displayName = 'Lozenge';

});


parcelRegister("99Syk", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteStatusView", () => $0668685bfe518e32$export$d907a4132fe8618c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bFzGY = parcelRequire("bFzGY");

var $eRawo = parcelRequire("eRawo");

var $ffiyv = parcelRequire("ffiyv");

var $6jiFZ = parcelRequire("6jiFZ");
var $LddR2 = parcelRequire("LddR2");
var $gCtL7 = parcelRequire("gCtL7");

var $9zALC = parcelRequire("9zALC");
var $46gH8 = parcelRequire("46gH8");
var $36mrL = parcelRequire("36mrL");
var $gfXKy = parcelRequire("gfXKy");

var $bT6OI = parcelRequire("bT6OI");

var $fmmnJ = parcelRequire("fmmnJ");
var $dK5FP = parcelRequire("dK5FP");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $3Tszs = parcelRequire("3Tszs");

var $jMP2a = parcelRequire("jMP2a");


var $igSdB = parcelRequire("igSdB");

var $aaWu9 = parcelRequire("aaWu9");

var $hiXJ2 = parcelRequire("hiXJ2");
const $0668685bfe518e32$export$3b70c533639eedc2 = ({ childrenProps: childrenProps, statusViewProps: statusViewProps })=>{
    const { setLoading: setLoading, setChildResult: setChildResult } = childrenProps;
    const { wasFetchSuccessful: wasFetchSuccessful, currentStatus: currentStatus, transitions: transitions, isLoading: isLoading, renderTransition: renderTransition, onSuccess: onSuccess } = statusViewProps;
    const issueKey = (0, $hJ992.useIssueKey)();
    const issueId = (0, $3Tszs.useIssueAri)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { saveStatusField: saveStatusField } = (0, $aaWu9.useSaveStatusField)(issueKey, issueId);
    const loadTransitions = (0, $eUqFw.useCallback)(()=>{
        if (!wasFetchSuccessful) return {
            commands: []
        };
        const transitionCommands = transitions.map((transition)=>({
                id: `${0, $c7e109b9d85e3c97$export$5252a6a6e4e4a774}-${transition.id}`,
                name: transition.name,
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0668685bfe518e32$var$TransitionWrapper, null, renderTransition({
                            transition: transition
                        }, {
                            addTransitionArrowSpacing: true
                        }))
                },
                keywords: (0, $hiXJ2.getTransitionKeywords)(transition),
                primaryAction: {
                    type: (0, $6jiFZ.CommandActionType).PERFORM,
                    perform: ()=>{
                        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueStatus updated', {
                            oldValId: currentStatus.id,
                            oldStatusCategoryId: currentStatus.statusCategory.id,
                            newValId: transition.to.id,
                            newStatusCategoryId: transition.to.statusCategory.id,
                            hasScreen: transition.hasScreen,
                            isConditional: transition.isConditional
                        });
                        saveStatusField(transition, ()=>{
                            onSuccess?.(transition.to, false, createAnalyticsEvent({}));
                        });
                    }
                },
                analytics: {
                    action: 'changeStatus',
                    actionCategory: (0, $9zALC.COMMAND_PALETTE_ISSUE_ACTIONS)
                }
            }));
        const commands = [
            {
                id: `${(0, $c7e109b9d85e3c97$export$5252a6a6e4e4a774)}-${currentStatus.id}-current`,
                name: currentStatus.name,
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0668685bfe518e32$var$TransitionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0668685bfe518e32$var$SelectedStatusContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                            isBold: true
                        }, currentStatus.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0668685bfe518e32$var$CurrentStatusContainer, null, formatMessage((0, $igSdB.messages).currentStatus)))
                }
            },
            ...transitionCommands
        ];
        return {
            commands: commands
        };
    }, [
        createAnalyticsEvent,
        currentStatus.id,
        currentStatus.name,
        currentStatus.statusCategory.id,
        formatMessage,
        onSuccess,
        renderTransition,
        saveStatusField,
        transitions,
        wasFetchSuccessful
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setLoading(isLoading);
    }, [
        isLoading,
        setLoading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setChildResult(loadTransitions());
    }, [
        loadTransitions,
        setChildResult
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LddR2.components).Body, childrenProps);
};
const $0668685bfe518e32$export$d907a4132fe8618c = (props)=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    const subscribeCommands = (0, $dK5FP.useSubscribeCommands)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ expandedCommand: expandedCommand, isOpen: isOpen }] = (0, $gCtL7.useCommandPaletteExpandedCommand)();
    const { onFetch: onFetch } = props;
    const renderChildren = (0, $eUqFw.useCallback)((childrenProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0668685bfe518e32$export$3b70c533639eedc2, {
            childrenProps: childrenProps,
            statusViewProps: props
        }), [
        props
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const statusCommand = {
            id: (0, $c7e109b9d85e3c97$export$5252a6a6e4e4a774),
            name: (0, $1ybV0.ff)('compal-issue-actions-follow-up-improvements_y49xu') ? formatMessage((0, $igSdB.messages).editStatus) : formatMessage((0, $igSdB.messages).changeStatus),
            shortcut: 'd',
            placeholder: formatMessage((0, $igSdB.messages).searchTransition),
            keywords: getKeywords('changeStatusSynonyms'),
            section: (0, $46gH8.getCommandPaletteIssueActionsHeader)(issueKey),
            priority: (0, $36mrL.getCommandPaletteIssueActionsPriority)('STATUS'),
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eRawo))), {
                        label: formatMessage((0, $igSdB.messages).changeStatus)
                    })
            },
            primaryAction: {
                type: (0, $6jiFZ.CommandActionType).COMMAND_LIST,
                fallback: {
                    onNoResults: {
                        label: formatMessage((0, $igSdB.messages).fallbackNoResults)
                    }
                },
                components: {
                    Body: renderChildren,
                    ...(0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r') && {
                        Header: (base)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT6OI.CommandFieldHeader), {
                                ...base,
                                issueKey: issueKey
                            })
                    }
                }
            },
            analytics: {
                action: 'changeStatusMenu'
            }
        };
        const unsubscribe = subscribeCommands((0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).STATUS, [
            statusCommand
        ]);
        return ()=>unsubscribe();
    }, [
        formatMessage,
        getKeywords,
        issueKey,
        renderChildren,
        subscribeCommands
    ]);
    const expandedCommandId = expandedCommand?.id;
    (0, $eUqFw.useEffect)(()=>{
        if (isOpen && expandedCommandId === (0, $c7e109b9d85e3c97$export$5252a6a6e4e4a774) && onFetch) onFetch(createAnalyticsEvent({}));
    }, [
        expandedCommandId,
        isOpen,
        onFetch,
        createAnalyticsEvent
    ]);
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0668685bfe518e32$var$TransitionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _18u01b66 _4t3i1tcg _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0668685bfe518e32$var$SelectedStatusContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0668685bfe518e32$var$CurrentStatusContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1a45",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eRawo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ad0e2d491eada4f5$var$_react = $ad0e2d491eada4f5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ad0e2d491eada4f5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ad0e2d491eada4f5$var$TaskIcon = (props)=>/*#__PURE__*/ $ad0e2d491eada4f5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 01-.993.993H3.993A.994.994 0 013 20.007V3.993zM5 5v14h14V5H5z"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill-rule="nonzero"/></g></svg>`
    }, props));
$ad0e2d491eada4f5$var$TaskIcon.displayName = 'TaskIcon';
var $ad0e2d491eada4f5$var$_default = $ad0e2d491eada4f5$var$TaskIcon;
module.exports.default = $ad0e2d491eada4f5$var$_default;

});

const $c7e109b9d85e3c97$export$5252a6a6e4e4a774 = 'issue-field-status.ui.status-view.command-palette.issue-status';

parcelRegister("igSdB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $aaccf3a6ecd0d922$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $aaccf3a6ecd0d922$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    changeStatus: {
        "id": "issue-field-status.status-view.command-palette.change-status",
        "defaultMessage": "Change status"
    },
    // TODO delete on compal-issue-actions-follow-up-improvements_y49xu cleanup
    editStatus: {
        "id": "issue-field-status.status-view.command-palette.edit-status",
        "defaultMessage": "Edit status"
    },
    searchTransition: {
        "id": "issue-field-status.status-view.command-palette.search-transition",
        "defaultMessage": "Search a status or transition"
    },
    currentStatus: {
        "id": "issue-field-status.status-view.command-palette.current-status",
        "defaultMessage": "Current status"
    },
    fallbackNoResults: {
        "id": "issue-field-status.status-view.command-palette.fallback-no-results",
        "defaultMessage": "No results match your search."
    },
    fallbackError: {
        "id": "issue-field-status.status-view.command-palette.fallback-error",
        "defaultMessage": "We're having trouble loading this data. Wait a few moments, then try again."
    }
});

});

parcelRegister("aaWu9", function(module, exports) {

$parcel$export(module.exports, "useSaveStatusField", () => $4cf7bb6b63008adb$export$c6a3d42f97df89c9);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kmr29 = parcelRequire("kmr29");

var $1a3la = parcelRequire("1a3la");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $ebWv6 = parcelRequire("ebWv6");
const $4cf7bb6b63008adb$export$c6a3d42f97df89c9 = (issueKey, issueId)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ commandPaletteSessionId: commandPaletteSessionId }] = (0, $gCtL7.useCommandPaletteSessionId)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $ebc098a76317be78$export$4420b7468f889692)
    });
    const onSaveSuccessfully = (0, $eUqFw.useCallback)((transition, callback)=>{
        const action = 'commandPalette';
        const actionSubject = 'changeStatus';
        const eventActionAndSubject = `${actionSubject} ${action}`;
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        setFieldValue(issueKey, (0, $ebc098a76317be78$export$4420b7468f889692), transition.to);
        callback?.();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $jMP2a.fireTrackAnalytics)(event, eventActionAndSubject, {
            transitionId: transition.id,
            commandPaletteSessionId: commandPaletteSessionId
        });
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'statusField transitioned', 'statusField');
        showFlag({
            type: 'success',
            title: formatMessage((0, $ebWv6.messages).successFlagMessage)
        });
    }, [
        commandPaletteSessionId,
        createAnalyticsEvent,
        formatMessage,
        issueKey,
        setFieldValue,
        showFlag
    ]);
    const onFailSave = (0, $eUqFw.useCallback)((error)=>{
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'commandPaletteIssueStatus',
                packageName: 'jiraIssueFieldStatus',
                // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                teamName: 'deliveroo'
            }
        });
        showFlag({
            type: 'error',
            title: formatMessage((0, $ebWv6.messages).errorFlagTitle),
            description: formatMessage((0, $ebWv6.messages).errorFlagDescription)
        });
    }, [
        formatMessage,
        showFlag
    ]);
    const openIssueTransitionModal = (0, $1a3la.useOpenIssueTransitionModal)();
    const saveStatusField = (0, $eUqFw.useCallback)(async (transition, callback)=>{
        try {
            if (transition.hasScreen) {
                const handleDialogSuccess = ()=>onSaveSuccessfully(transition, callback);
                const handleDialogError = (err)=>onFailSave(err instanceof Error ? err : new Error('Something went wrong trying to update the status with screen using the command palette'));
                const transitionId = transition.id;
                openIssueTransitionModal({
                    payload: {
                        issueId: issueId,
                        issueKey: issueKey,
                        transitionId: transitionId
                    },
                    triggerPointKey: 'issue-transition-command-palette-status-field-transition',
                    onDialogSuccess: handleDialogSuccess,
                    onDialogError: handleDialogError
                });
            } else {
                await (0, $lRmyA.performPostRequest)(`/rest/api/3/issue/${issueKey}/transitions`, {
                    body: JSON.stringify({
                        transition: transition
                    })
                });
                onSaveSuccessfully(transition, callback);
            }
        } catch (err) {
            const error = err instanceof Error ? err : new Error('Something went wrong trying to update the status using the command palette');
            onFailSave(error);
        }
    }, [
        issueId,
        issueKey,
        onFailSave,
        onSaveSuccessfully,
        openIssueTransitionModal
    ]);
    return {
        saveStatusField: saveStatusField
    };
};

});
parcelRegister("ebWv6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f7580a2b91879afa$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $f7580a2b91879afa$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    successFlagMessage: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.success-flag-message",
        "defaultMessage": "Status updated"
    },
    errorFlagTitle: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-title",
        "defaultMessage": "We couldn\u2019t update the status"
    },
    errorFlagDescription: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-description",
        "defaultMessage": "Wait a few moments, then try again."
    }
});

});


parcelRegister("hiXJ2", function(module, exports) {

$parcel$export(module.exports, "getTransitionKeywords", () => $374b7ef282a2f0ed$export$258538e0d3d46460);
const $374b7ef282a2f0ed$export$258538e0d3d46460 = (transition)=>{
    if (transition.name !== transition.to.name) return `${transition.name} ${transition.to.name}`;
    return transition.name;
};

});


parcelRegister("f3qzK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1612899557cfea6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b1612899557cfea6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noPermission: {
        "id": "issue-field-status.status-view.no-permission",
        "defaultMessage": "You don't have permission to transition this issue"
    },
    cannotLoadTransitions: {
        "id": "issue-field-status.status-view.cannot-load-transitions",
        "defaultMessage": "We couldn't load the statuses and transitions"
    },
    changeStatus: {
        "id": "issue-field-status.status-view.change-status",
        "defaultMessage": "Change status"
    },
    transitionTo: {
        "id": "issue-field-status.status-view.transition-to",
        "defaultMessage": "Transition to {statusName}"
    }
});

});

parcelRegister("5x3wA", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", () => $b8a1cf0cb2a35870$export$b08b517936747730);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
const $b8a1cf0cb2a35870$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b8a1cf0cb2a35870$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8a1cf0cb2a35870$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4u2gc _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fr49r", function(module, exports) {

$parcel$export(module.exports, "StatusButton", () => $c8103b4d0a327bcd$export$517b7ecb2da8e76d);

var $eUqFw = parcelRequire("eUqFw");

var $86Ndv = parcelRequire("86Ndv");

var $8cU5f = parcelRequire("8cU5f");

var $fAI2G = parcelRequire("fAI2G");

var $3xvgo = parcelRequire("3xvgo");
const $c8103b4d0a327bcd$var$getButton = (categoryId)=>{
    switch(categoryId){
        case 2:
            return 0, $3xvgo.ToDoButton;
        case 3:
            return 0, $3xvgo.DoneButton;
        case 4:
            return 0, $3xvgo.InProgressButton;
        default:
            return 0, $3xvgo.DefaultButton;
    }
};
const $c8103b4d0a327bcd$export$517b7ecb2da8e76d = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, status: status, targetRef: targetRef, statusButtonRef: statusButtonRef, shouldFitContainer: shouldFitContainer = true } = props;
    const Button = $c8103b4d0a327bcd$var$getButton(status.statusCategory.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: targetRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "top",
        content: status.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fAI2G.default), {
        status: status
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Button, {
        id: "issue.fields.status-view.status-button",
        ref: statusButtonRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        }),
        testId: "issue-field-status.ui.status-view.status-button.status-button",
        shouldFitContainer: shouldFitContainer
    }, status.name))));
};

});
parcelRegister("fAI2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9e72f26e10429da$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");
// TODO consolidate status id's
const $e9e72f26e10429da$var$DONE_ID = 3; // eslint-disable-next-line jira/react/no-class-components
class $e9e72f26e10429da$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidUpdate(prevProps) {
        if (prevProps.status.statusCategory.id !== this.props.status.statusCategory.id) this.setState({
            shouldShow: this.props.status.statusCategory.id === $e9e72f26e10429da$var$DONE_ID
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9e72f26e10429da$var$PulseContainer, {
            shouldShow: this.state.shouldShow
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldShow: false
        };
    }
}
const $e9e72f26e10429da$var$PulseAnimation = /*#__PURE__*/ (0, $kwce8.keyframes)({
    to: {
        boxShadow: '0 0 0 10px rgba(0, 0, 0, 0)'
    }
});
const $e9e72f26e10429da$var$PulseContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShow: shouldShow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qbqnkm": (0, $9t7rW.default)($e9e72f26e10429da$var$PulseAnimation)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1bsb1osq _2rko1l7b _16qs13jn",
            __cmplp.shouldShow ? "_y44v1upg" : "_y44vglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3xvgo", function(module, exports) {

$parcel$export(module.exports, "DefaultButton", () => $9c0535c8db535606$export$b7c3a2f69225ecf);
$parcel$export(module.exports, "ToDoButton", () => $9c0535c8db535606$export$97f73b7c6e2328e5);
$parcel$export(module.exports, "InProgressButton", () => $9c0535c8db535606$export$8c94aeefd701630d);
$parcel$export(module.exports, "DoneButton", () => $9c0535c8db535606$export$e6559310cd173125);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $9c0535c8db535606$export$b7c3a2f69225ecf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12r2ni7l",
            !__cmplp.isSelected && "_193g10pm _11a410pm _dntbyv3a _cp4gyv3a _5xmd8ldq _11smyv3a",
            __cmplp.className
        ])
    });
});
const $9c0535c8db535606$export$97f73b7c6e2328e5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12r2ni7l",
            !__cmplp.isSelected && "_193guicy _11a4uicy _dntb16l4 _cp4g16l4 _5xmd1psz _11sm16l4",
            __cmplp.className
        ])
    });
});
const $9c0535c8db535606$export$8c94aeefd701630d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12r2ni7l",
            !__cmplp.isSelected && "_193gsxa6 _11a4sxa6 _dntb1gfe _cp4g1gfe _5xmdi36s _11sm1gfe",
            __cmplp.className
        ])
    });
});
const $9c0535c8db535606$export$e6559310cd173125 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12r2ni7l",
            !__cmplp.isSelected && "_193g147y _11a4147y _dntb1gfe _cp4g1gfe _5xmdihng _11sm1gfe",
            __cmplp.className
        ])
    });
});

});


parcelRegister("dSoqn", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $ae69ed3744ea99b9$export$be58926105124dd4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $aUqTb = parcelRequire("aUqTb");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $iccsh = parcelRequire("iccsh");

var $5jCbl = parcelRequire("5jCbl");

var $dRdDe = parcelRequire("dRdDe");
const $ae69ed3744ea99b9$export$be58926105124dd4 = ({ hasLabel: hasLabel, transition: transition, addTransitionArrowSpacing: addTransitionArrowSpacing })=>{
    if ((0, $iccsh.isStatusInGicEnabled)() && transition.isDisabled === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ae69ed3744ea99b9$var$DisabledTransition, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRdDe.TransitionWithoutLabel), {
        transition: transition,
        isDisabled: true
    }), transition.unavailableReasonText != null && transition.unavailableReasonText !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: transition.unavailableReasonText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ae69ed3744ea99b9$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
        label: "",
        primaryColor: `var(--ds-text-disabled, ${(0, $PdmhA).N200})`
    }))));
    return hasLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jCbl.TransitionWithLabel), {
        transition: transition,
        addTransitionArrowSpacing: addTransitionArrowSpacing
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRdDe.TransitionWithoutLabel), {
        transition: transition
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ae69ed3744ea99b9$var$DisabledTransition = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $ae69ed3744ea99b9$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3io7ao _1reoewfl _18m9ewfl _19pkr5cr",
            __cmplp.className
        ])
    });
});
const $ae69ed3744ea99b9$export$7ed12d2a5241e393 = {
    IconWrapper: $ae69ed3744ea99b9$var$IconWrapper
};

});
parcelRegister("5jCbl", function(module, exports) {

$parcel$export(module.exports, "TransitionWithLabel", () => $31534da1e06e6efb$export$20d2722b94f01359);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cSu9v = parcelRequire("cSu9v");

var $4ksts = parcelRequire("4ksts");

var $2GJ4g = parcelRequire("2GJ4g");

var $Pk7Yy = parcelRequire("Pk7Yy");
const $31534da1e06e6efb$var$getLabel = (transition, intl)=>{
    if (transition.isGlobal) {
        if (transition.name !== transition.to.name) return transition.name;
        return intl.formatMessage((0, $Pk7Yy.default).globalTransition);
    }
    return transition.name;
};
const $31534da1e06e6efb$export$20d2722b94f01359 = (props)=>{
    const intl = (0, $4ksts.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31534da1e06e6efb$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31534da1e06e6efb$export$147422f7450ccfac, null, $31534da1e06e6efb$var$getLabel(props.transition, intl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31534da1e06e6efb$export$da4545fe0ca096cf, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31534da1e06e6efb$var$VerticalCenter, {
        addTransitionArrowSpacing: props.addTransitionArrowSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        label: "",
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.StatusLozenge), {
        status: props.transition.to,
        isDisabled: props.isDisabled
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31534da1e06e6efb$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $31534da1e06e6efb$export$147422f7450ccfac = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $31534da1e06e6efb$export$da4545fe0ca096cf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $31534da1e06e6efb$var$VerticalCenter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { addTransitionArrowSpacing: addTransitionArrowSpacing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o",
            __cmplp.addTransitionArrowSpacing ? "_18s8s8vo" : "_19pk1kw7 _2hwx1kw7 _otyr1kw7 _18u01kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("Pk7Yy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca438c42f301b049$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ca438c42f301b049$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    globalTransition: {
        "id": "issue-field-status.status-view.transition.with-label.global-transition",
        "defaultMessage": "Transition to"
    }
});

});


parcelRegister("dRdDe", function(module, exports) {

$parcel$export(module.exports, "TransitionWithoutLabel", () => $3bc4861a1c7d5985$export$4cf2c7e5a408120e);

var $eUqFw = parcelRequire("eUqFw");

var $2GJ4g = parcelRequire("2GJ4g");
const $3bc4861a1c7d5985$export$4cf2c7e5a408120e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.StatusLozenge), {
        status: props.transition.to,
        isDisabled: props.isDisabled
    });

});



parcelRegister("hKhSq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9584ba9a040ef1b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aIecO = parcelRequire("aIecO");

var $gD4xA = parcelRequire("gD4xA");

var $1M8IB = parcelRequire("1M8IB");
class $e9584ba9a040ef1b$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { baseUrl: baseUrl, issueKey: issueKey, isModalMounted: isModalMounted, onOpenModal: onOpenModal, workflowServiceApi: workflowServiceApi } = this.props;
        const { isWorkflowServiceRefetching: isWorkflowServiceRefetching } = this.state;
        const { data: data, loading: loading, error: error, fetch: fetch } = workflowServiceApi;
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aIecO.default), {
            onRetry: (e)=>{
                this.onWorkflowServiceRefetch(e, fetch);
            }
        });
        if (!data) return null;
        const { isSimplified: isSimplified, projectId: projectId, issueTypeId: issueTypeId, hasPermission: hasPermission } = data;
        if (isSimplified === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1M8IB.default), {
            projectId: projectId,
            issueTypeId: issueTypeId,
            isModalMounted: isModalMounted,
            hasPermission: hasPermission,
            isServiceLoading: loading,
            isServiceRefetching: isWorkflowServiceRefetching,
            onOpenModal: onOpenModal
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gD4xA.default), {
            baseUrl: baseUrl,
            issueKey: issueKey,
            hasPermission: hasPermission,
            isServiceLoading: loading,
            isServiceRefetching: isWorkflowServiceRefetching
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isWorkflowServiceRefetching: false
        };
        this.onWorkflowServiceRefetch = async (e, retry)=>{
            e.stopPropagation();
            this.setState({
                isWorkflowServiceRefetching: true
            });
            await retry();
            this.setState({
                isWorkflowServiceRefetching: false
            });
        };
    }
}

});
parcelRegister("aIecO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef6cff4c32f2b822$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bbaTG = parcelRequire("bbaTG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $cHMSy = parcelRequire("cHMSy");
const $ef6cff4c32f2b822$export$edf27be85e5f6da0 = ({ onRetry: onRetry })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onRetryClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'retryViewWorkflowButton'); // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
        onRetry(e);
    }, [
        onRetry
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "viewWorkflowError",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6cff4c32f2b822$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ef6cff4c32f2b822$var$errorMessageWrapperStyles
    }, formatMessage((0, $cHMSy.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6cff4c32f2b822$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        appearance: "link",
        spacing: "none",
        onClick: onRetryClick,
        theme: (currentTheme, theme)=>{
            const buttonTheme = currentTheme(theme);
            return {
                ...buttonTheme,
                buttonStyles: {
                    ...buttonTheme.buttonStyles,
                    alignItems: 'center'
                }
            };
        },
        interactionName: "auto-generated.jira-issue-field-status.common.ui.view-workflow.error.button"
    }, formatMessage((0, $cHMSy.default).tryAgain))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
var $ef6cff4c32f2b822$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $ef6cff4c32f2b822$export$edf27be85e5f6da0;
const $ef6cff4c32f2b822$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ickbl _x3do1on0 _1e0c1txw _4cvr1h6o _1yt4s8vo _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef6cff4c32f2b822$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $ef6cff4c32f2b822$var$errorMessageWrapperStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("cHMSy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6de2ac9633e5bb5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c6de2ac9633e5bb5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "issue-field-status.common.view-workflow.error.error-message",
        "defaultMessage": "Couldn\u2019t find the workflow."
    },
    tryAgain: {
        "id": "issue-field-status.common.view-workflow.error.try-again",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("gD4xA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2cbda2e6b4ce6eb$export$2e2bcd8739ae039);
/* eslint-disable react-hooks/exhaustive-deps, jira/wrm/no-load-bridge */ 
var $eUqFw = parcelRequire("eUqFw");

var $2BvS3 = parcelRequire("2BvS3");

var $14fFu = parcelRequire("14fFu");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $16kIm = parcelRequire("16kIm");

var $bf489 = parcelRequire("bf489");

var $aIecO = parcelRequire("aIecO");

var $1VyIW = parcelRequire("1VyIW");

var $6d2As = parcelRequire("6d2As");

var $8o90a = parcelRequire("8o90a");
const $c2cbda2e6b4ce6eb$export$b5e9eef0cad95164 = ({ isServiceLoading: isServiceLoading, isServiceRefetching: isServiceRefetching, issueKey: issueKey, hasPermission: hasPermission, baseUrl: baseUrl, ClassicViewWorkflowService: ClassicViewWorkflowService = (0, $6d2As.ClassicViewWorkflowServiceWithAnalytics) })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isModalMounted, setIsModalMounted] = (0, $eUqFw.useState)(false);
    const [isLoadingModal, setIsLoadingModal] = (0, $eUqFw.useState)(false);
    const [isRefetching, setIsRefetching] = (0, $eUqFw.useState)(false);
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const isModalMounting = isLoadingModal && !isModalMounted;
    const isDisabled = !hasPermission || isModalMounting;
    // we do not use || isClassicServiceLoading for isLoading because we do not want to show spinner while ClassicViewWorkflowService data loads
    const isLoading = isModalMounting || isServiceRefetching || isRefetching;
    let modalApi;
    (0, $eUqFw.useEffect)(()=>{
        const modalModuleName = 'workflow-designer/view-classic-project-workflow';
        // @ts-expect-error - TS2322 - Type 'Promise<unknown>' is not assignable to type 'Promise<ClassicProjectWorkflowModalApi>'.
        modalApi = (0, $2BvS3.loadBridge)({
            // checking if module was loaded on page load
            name: modalModuleName,
            tentatives: 0,
            shouldLogError: false
        }).catch(()=>{
            (0, $16kIm.asyncWrmRequire)([
                // eslint-disable-next-line jira/wrm/no-wr-prefix
                'wr!com.atlassian.jira.plugins.jira-workflow-designer:view-issue-page-workflow-designer'
            ]); // wrmRequire() does not fire catch() event
            return (0, $2BvS3.loadBridge)({
                name: modalModuleName
            });
        });
    }, []);
    const onClick = (0, $eUqFw.useCallback)((analyticsEvent, pShowFlag, workflowName, currentStepId)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'viewWorkflowTrigger', {
            isSimplifiedProject: false
        });
        if (!modalApi || !workflowName || !currentStepId) return;
        // modal code is being loaded only once, therefore there is no need to reset this to false
        setIsLoadingModal(true);
        setIsRefetching(false);
        modalApi.then((api)=>{
            api.showDialog(workflowName, currentStepId);
            // since there is no way to close Ak dropdown programmatically, this is the only option
            // to avoid dropdown wrong position on View workflow modal opening in Bento modal (BENTO-4660)
            window.dispatchEvent((0, $14fFu.default)('resize'));
            // @ts-expect-error - TS2345 - Argument of type '{ isModalMounted: boolean; }' is not assignable to parameter of type 'SetStateAction<boolean>'.
            setIsModalMounted({
                isModalMounted: true
            });
        }).catch(()=>{
            pShowFlag && pShowFlag((0, $8o90a.default).loadModalError());
            setIsLoadingModal(false);
        });
    }, // @ts-expect-error - TS2454 - Variable 'modalApi' is used before being assigned.
    [
        modalApi,
        setIsModalMounted,
        setIsRefetching,
        setIsLoadingModal
    ]);
    const onRetry = (0, $eUqFw.useCallback)((event, retry)=>{
        event.stopPropagation();
        setIsRefetching(true);
        return retry().then(()=>setIsRefetching(false));
    }, [
        setIsRefetching
    ]);
    const onMount = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    (analyticsEvent)=>{
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'viewWorkflowTrigger mounted', {
            hasViewWorkflowPermission: hasPermission,
            isSimplifiedProject: false
        });
    }, [
        hasPermission
    ]);
    const getTooltipMessage = (0, $eUqFw.useCallback)((isClassicServiceLoading)=>{
        if (isServiceRefetching || isClassicServiceLoading) return formatMessage((0, $1VyIW.default).loading);
        if (!hasPermission) return formatMessage((0, $1VyIW.default).noPermission);
        return '';
    }, [
        formatMessage,
        hasPermission,
        isServiceRefetching
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ClassicViewWorkflowService, {
        issueKey: issueKey,
        baseUrl: baseUrl,
        shouldLoadOnMount: hasPermission
    }, ({ data: data, error: error, loading: isClassicServiceLoading, retry: retry })=>{
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aIecO.default), {
            onRetry: (event)=>{
                onRetry(event, retry);
            }
        });
        const workflowName = data ? data.workflowName : null;
        const currentStepId = data ? data.currentStepId : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bf489.default), {
            onMount: onMount,
            tooltipContent: getTooltipMessage(isServiceLoading || isClassicServiceLoading),
            isDisabled: isDisabled || isClassicServiceLoading,
            isLoading: isLoading,
            isInitialLoading: isServiceLoading || isClassicServiceLoading,
            onClick: (_, analyticsEvent)=>onClick(analyticsEvent, showFlag, workflowName, currentStepId)
        });
    });
};
var $c2cbda2e6b4ce6eb$export$2e2bcd8739ae039 = $c2cbda2e6b4ce6eb$export$b5e9eef0cad95164;

});
parcelRegister("14fFu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9be0b0302f41db4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $c9be0b0302f41db4$export$2e2bcd8739ae039 = (eventType, eventConstructor = 'Event', bubbles = true, cancelable = true)=>{
    const event = document.createEvent(eventConstructor);
    event.initEvent(eventType, bubbles, cancelable);
    return event;
};

});

parcelRegister("16kIm", function(module, exports) {

$parcel$export(module.exports, "asyncWrmRequire", () => $0ab2873dadb9f6da$export$1024fe099ca05f05);
$parcel$export(module.exports, "asyncWrmRequireWithPrefetch", () => $0ab2873dadb9f6da$export$3ca0de203efa570e);
/* eslint-disable jira/wrm/no-load-bridge */ 
var $beITa = parcelRequire("beITa");
var $dPoeR = parcelRequire("dPoeR");
const $0ab2873dadb9f6da$export$1024fe099ca05f05 = (resourcesToRequire)=>(0, $beITa.wrmRequire)(resourcesToRequire);
const $0ab2873dadb9f6da$export$3ca0de203efa570e = (resourcesToRequire, batchUrl)=>(0, $dPoeR.wrmRequireWithPrefetch)(resourcesToRequire, batchUrl);

});

parcelRegister("bf489", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b2bb06be8d06d0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bbaTG = parcelRequire("bbaTG");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $4ksts = parcelRequire("4ksts");

var $2qZHF = parcelRequire("2qZHF");

var $58qPQ = parcelRequire("58qPQ");
const $69b2bb06be8d06d0$var$WithTooltip = ({ content: content, children: children })=>{
    if (content) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        tag: "span",
        content: content
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $69b2bb06be8d06d0$var$ViewWorkflowButton = ({ isDisabled: isDisabled, isLoading: isLoading, isInitialLoading: isInitialLoading, onClick: onClick, onMount: onMount, tooltipContent: tooltipContent })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const isDisabledColor = isDisabled === true && !isInitialLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69b2bb06be8d06d0$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: onMount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69b2bb06be8d06d0$var$WithTooltip, {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69b2bb06be8d06d0$export$d53c836cccbb0d90, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        testId: "issue-field-status.common.ui.view-workflow.button.view-workflow",
        shouldFitContainer: true,
        appearance: "subtle",
        spacing: "none",
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        theme: (currentTheme, theme)=>{
            const buttonTheme = currentTheme(theme);
            return {
                ...buttonTheme,
                buttonStyles: {
                    ...buttonTheme.buttonStyles,
                    alignItems: 'center',
                    textAlign: 'left',
                    color: isDisabledColor ? `var(--ds-text-disabled, ${(0, $PdmhA).N70})` : `var(--ds-text, ${(0, $PdmhA).N900})`,
                    padding: `0 ${"var(--ds-space-150, 12px)"}`
                }
            };
        },
        interactionName: "auto-generated.issue-field-status.common.ui.view-workflow.button.view-workflow.button"
    }, intl.formatMessage((0, $58qPQ.default).viewWorkflow)))));
};
var $69b2bb06be8d06d0$export$2e2bcd8739ae039 // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $69b2bb06be8d06d0$var$ViewWorkflowButton;
const $69b2bb06be8d06d0$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ickbl _x3do1on0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $69b2bb06be8d06d0$export$d53c836cccbb0d90 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _4t3i1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("58qPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $431207a6e4666834$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $431207a6e4666834$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewWorkflow: {
        "id": "issue-field-status.common.view-workflow.button.view-workflow",
        "defaultMessage": "View workflow"
    }
});

});


parcelRegister("1VyIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb93519bdc9b310d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fb93519bdc9b310d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noPermission: {
        "id": "issue-field-status.common.view-workflow.no-permission",
        "defaultMessage": "You don't have permission to view this workflow."
    },
    loading: {
        "id": "issue-field-status.common.view-workflow.loading",
        "defaultMessage": "Looks like your connection is slow. We\u2019re still finding this workflow."
    }
});

});

parcelRegister("6d2As", function(module, exports) {

$parcel$export(module.exports, "ClassicViewWorkflowServiceWithAnalytics", () => $49ff3b2d374c70f7$export$1a80ddaaeea6341b);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $gUUjF = parcelRequire("gUUjF");

var $jMP2a = parcelRequire("jMP2a");

var $jdSRD = parcelRequire("jdSRD");
// eslint-disable-next-line jira/react/no-class-components
class $49ff3b2d374c70f7$var$ClassicViewWorkflowService extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            shouldLoadOnMount: true
        };
    }
    componentDidMount() {
        if (this.props.shouldLoadOnMount === true) this.load();
    }
    onLoading() {
        this.setState({
            data: undefined,
            error: undefined,
            loading: true
        });
    }
    onLoadSucceeded(data) {
        this.setState({
            data: data,
            error: undefined,
            loading: false
        });
    }
    onLoadFailed(error) {
        this.setState({
            data: undefined,
            error: error,
            loading: false
        });
    }
    fireAnalytics() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'requested'
        });
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'classicViewWorkflowData requested');
    }
    render() {
        return this.props.children({
            ...this.state,
            retry: this.load
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            data: undefined,
            error: undefined,
            loading: false
        };
        this.load = async ()=>{
            this.onLoading();
            const { baseUrl: baseUrl, issueKey: issueKey } = this.props;
            try {
                this.fireAnalytics();
                const data = await (0, $jdSRD.getViewWorkflowData)(baseUrl, issueKey);
                this.onLoadSucceeded(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-field.status.classic-view-workflow-service.fetch', 'Failed to fetch classic view workflow data.', {
                    errorReason: error.message && error.message === 'TransformError' ? 'transform' : 'fetch'
                });
                this.onLoadFailed(error);
            }
        };
    }
}
const $49ff3b2d374c70f7$export$1a80ddaaeea6341b = (0, $2jDha.default)()(// @ts-expect-error - TS2345 - Argument of type 'typeof ClassicViewWorkflowService' is not assignable to parameter of type '(((props: WithAnalyticsEventsProps) => ReactElement<any, string | ((props: any) => ReactElement<any, any> | null) | (new (props: any) => Component<any, any, any>)> | null) & typeof ClassicViewWorkflowService) | ((new (props: WithAnalyticsEventsProps) => Component<...>) & typeof ClassicViewWorkflowService)'.
$49ff3b2d374c70f7$var$ClassicViewWorkflowService);

});
parcelRegister("jdSRD", function(module, exports) {

$parcel$export(module.exports, "getViewWorkflowData", () => $d8d339a09b1f2f34$export$fa1a6ac9833b0597);

var $lRmyA = parcelRequire("lRmyA");
const $d8d339a09b1f2f34$var$query = `
query classicViewWorkflowQuery($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        workflow {
            name
            step {
                id
            }
        }
    }
}
`;
const $d8d339a09b1f2f34$export$3361e9be8093ddcc = (response)=>{
    if (response.data && response.data.viewIssue && response.data.viewIssue.workflow) return {
        workflowName: response.data.viewIssue.workflow.name,
        currentStepId: response.data.viewIssue.workflow.step.id
    };
    throw new Error('TransformError');
};
const $d8d339a09b1f2f34$export$fa1a6ac9833b0597 = (baseUrl, issueKey)=>(0, $lRmyA.performPostRequest)(`${baseUrl}/rest/gira/1/`, {
        body: JSON.stringify({
            query: $d8d339a09b1f2f34$var$query,
            variables: {
                issueKey: issueKey
            }
        })
    }).then($d8d339a09b1f2f34$export$3361e9be8093ddcc);

});


parcelRegister("8o90a", function(module, exports) {

$parcel$export(module.exports, "default", () => $3de04be88b22ac00$export$2e2bcd8739ae039);

var $8gQgm = parcelRequire("8gQgm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3de04be88b22ac00$export$2e2bcd8739ae039 = {
    loadModalError: $8gQgm.default
};

});
parcelRegister("8gQgm", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f0b0125e728899f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $5f0b0125e728899f$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue-field-status.view-workflow.classic.flags.errors.load-modal-error.title",
        "defaultMessage": "We couldn't load the workflow"
    },
    description: {
        "id": "issue-field-status.view-workflow.classic.flags.errors.load-modal-error.description",
        "defaultMessage": "Check your connection, then try reloading the page."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5f0b0125e728899f$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $5f0b0125e728899f$var$messages.title,
        description: $5f0b0125e728899f$var$messages.description
    });

});



parcelRegister("1M8IB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24a04c39da424a7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $giAhk = parcelRequire("giAhk");

var $jMP2a = parcelRequire("jMP2a");

var $6vrw7 = parcelRequire("6vrw7");

var $bf489 = parcelRequire("bf489");

var $1VyIW = parcelRequire("1VyIW");
// eslint-disable-next-line jira/react/no-class-components
class $d24a04c39da424a7$var$ViewWorkflowSimplified extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            hasPermission: false
        };
    }
    getTooltipMessage() {
        const { isServiceLoading: isServiceLoading, isServiceRefetching: isServiceRefetching, hasPermission: hasPermission, intl: intl } = this.props;
        if (isServiceLoading || isServiceRefetching) return intl.formatMessage((0, $1VyIW.default).loading);
        if (hasPermission !== true) return intl.formatMessage((0, $1VyIW.default).noPermission);
        return '';
    }
    render() {
        const { isServiceLoading: isServiceLoading, isServiceRefetching: isServiceRefetching, hasPermission: hasPermission, isModalMounted: isModalMounted } = this.props;
        const { isLoadingModal: isLoadingModal } = this.state;
        const isModalMounting = isLoadingModal && !isModalMounted;
        const isDisabled = hasPermission !== true || isModalMounting;
        const isLoading = isServiceRefetching || isModalMounting;
        const tooltipContent = this.getTooltipMessage();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bf489.default), {
            onMount: this.onMount,
            tooltipContent: tooltipContent,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isInitialLoading: isServiceLoading,
            onClick: this.onClick
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isLoadingModal: false
        };
        this.onMount = (analyticsEvent)=>{
            const { hasPermission: hasPermission } = this.props;
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'viewWorkflowTrigger mounted', {
                hasViewWorkflowPermission: hasPermission,
                isSimplifiedProject: true
            });
        };
        this.onClick = (event, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'viewWorkflowTrigger', {
                isSimplifiedProject: true
            });
            this.setState({
                // modal code is being loaded only once, therefore there is no need to reset this to false
                isLoadingModal: true
            });
            const { issueTypeId: issueTypeId = (0, $6vrw7.toIssueTypeId)(''), projectId: projectId = (0, $6vrw7.toProjectId)(''), onOpenModal: onOpenModal } = this.props;
            onOpenModal(issueTypeId, projectId);
        };
    }
}
var $d24a04c39da424a7$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($d24a04c39da424a7$var$ViewWorkflowSimplified);

});


parcelRegister("8N9iM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c08b1e01d93233b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gzBuH = parcelRequire("gzBuH");

var $481Nl = parcelRequire("481Nl");

const $3c08b1e01d93233b$export$de1fcbea0facb135 = (0, $7rh0R.lazy)(()=>(parcelRequire("7U4R2")), {
    moduleId: "./src/packages/issue/workflow-readonly-modal/src/index.tsx"
});
class $3c08b1e01d93233b$export$3d7b4a64bc1f330f extends (0, $eUqFw.Component) {
    static getDerivedStateFromProps(props, state) {
        return {
            shouldMountWorkflow: state.shouldMountWorkflow || props.isOpen
        };
    }
    render() {
        const { issueKey: issueKey, issueTypeId: issueTypeId, baseUrl: baseUrl, locale: locale, cloudId: cloudId, projectId: projectId, isOpen: isOpen, onModalMounted: onModalMounted, onClose: onClose, scope: scope } = this.props;
        const { shouldMountWorkflow: shouldMountWorkflow } = this.state;
        return shouldMountWorkflow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $481Nl.WorkflowReadonlyModalBoundary), {
            packageName: "issue"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gzBuH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazyWait), {
            until: isOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c08b1e01d93233b$export$de1fcbea0facb135, {
            onMounted: onModalMounted,
            issueKey: issueKey,
            issueTypeId: issueTypeId,
            baseUrl: baseUrl,
            locale: locale,
            isOpen: isOpen,
            cloudId: cloudId,
            projectId: projectId,
            onClose: onClose,
            scope: scope
        }))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldMountWorkflow: false
        };
    }
}
var $3c08b1e01d93233b$export$2e2bcd8739ae039 = $3c08b1e01d93233b$export$3d7b4a64bc1f330f;

});
parcelRegister("gzBuH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6303a1693ea37869$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $aTx5K = parcelRequire("aTx5K");
function $6303a1693ea37869$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
    const parentProfilerContext = (0, $eUqFw.useContext)((0, $7rh0R.ProfilerContext));
    const ignoredRLLProfilerContext = (0, $eUqFw.useMemo)(()=>({
            ...parentProfilerContext,
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            placeholderFallBackMounted () {},
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            placeholderFallBackUnmounted () {}
        }), [
        parentProfilerContext
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignore) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, kids);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTx5K.default), {
        ignore: ignore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.ProfilerContext).Provider, {
        value: ignoredRLLProfilerContext
    }, kids));
}

});
parcelRegister("aTx5K", function(module, exports) {

$parcel$export(module.exports, "default", () => $99ad7ab78a19ec4c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jsCXU = parcelRequire("jsCXU");
function $99ad7ab78a19ec4c$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
    const parentContext = (0, $eUqFw.useContext)((0, $jsCXU.default));
    const ignoredInteractionContext = (0, $eUqFw.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, kids);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jsCXU.default).Provider, {
        value: ignoredInteractionContext
    }, kids);
}

});


parcelRegister("481Nl", function(module, exports) {

$parcel$export(module.exports, "WorkflowReadonlyModalBoundary", () => $0a356db52042008d$export$62f00f305552896d);

var $eUqFw = parcelRequire("eUqFw");

var $cyVXS = parcelRequire("cyVXS");

var $dtQl8 = parcelRequire("dtQl8");
const $0a356db52042008d$export$62f00f305552896d = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "workflow-readonly-modal",
        metricKey: (0, $dtQl8.LOAD_START_MARK_KEY),
        packageName: packageName
    }, children);

});
parcelRegister("dtQl8", function(module, exports) {

$parcel$export(module.exports, "LOAD_START_MARK_KEY", () => $0fbc548613b24cfd$export$37312a67c3e314c6);
$parcel$export(module.exports, "LOAD_END_MARK_KEY", () => $0fbc548613b24cfd$export$45d73db12b3f4402);
$parcel$export(module.exports, "DIAGRAM_RENDERING_START_MARK_KEY", () => $0fbc548613b24cfd$export$b251f321d9285754);
$parcel$export(module.exports, "READY_MARK_KEY", () => $0fbc548613b24cfd$export$9ec2b1585f998431);
$parcel$export(module.exports, "ERROR_LOGGER_PATTERN", () => $0fbc548613b24cfd$export$63291eb9eb8d2af2);
$parcel$export(module.exports, "APP_NAME", () => $0fbc548613b24cfd$export$5b6c28c7dca07ad7);
$parcel$export(module.exports, "transitionType", () => $0fbc548613b24cfd$export$331d6399b2e33350);
$parcel$export(module.exports, "WORKFLOW_EXPERIENCE_IDENTIFIER", () => $0fbc548613b24cfd$export$4c39956c777a6352);
$parcel$export(module.exports, "EXPERIENCE_OPENED_START_EVENT", () => $0fbc548613b24cfd$export$ded295b2866c666f);
$parcel$export(module.exports, "EXPERIENCE_OPENED_SUCCESS_EVENT", () => $0fbc548613b24cfd$export$375ec45005c7d160);
const $0fbc548613b24cfd$export$37312a67c3e314c6 = 'WORKFLOW_READONLY_MODAL_LOAD_START_MARK_KEY';
const $0fbc548613b24cfd$export$45d73db12b3f4402 = 'WORKFLOW_READONLY_MODAL_LOAD_END_MARK_KEY';
const $0fbc548613b24cfd$export$b251f321d9285754 = 'DIAGRAM_RENDERING_START_MARK_KEY';
const $0fbc548613b24cfd$export$9ec2b1585f998431 = 'WORKFLOW_READONLY_MODAL_READY_MARK_KEY';
const $0fbc548613b24cfd$export$63291eb9eb8d2af2 = '#workflow-readonly-modal#';
const $0fbc548613b24cfd$export$5b6c28c7dca07ad7 = 'jira.fe.spa.transition.workflow-readonly-modal';
const $0fbc548613b24cfd$export$e117396b0784c7cc = 'START';
const $0fbc548613b24cfd$export$331d6399b2e33350 = {
    INITIAL: 'INITIAL',
    GLOBAL: 'GLOBAL',
    DIRECTED: 'DIRECTED'
};
const $0fbc548613b24cfd$export$54227ee7dff570d1 = {
    CHANGE_ASSIGNEE: 'system:change-assignee',
    UPDATE_FIELD: 'system:update-field'
};
const $0fbc548613b24cfd$export$4c39956c777a6352 = 'workflowBentoModal';
const $0fbc548613b24cfd$export$ded295b2866c666f = 'openedStart';
const $0fbc548613b24cfd$export$375ec45005c7d160 = 'openedSuccess';

});


parcelRegister("7U4R2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('enE0J')
        ]);
        const value = parcelRequire('9uk9j');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("enE0J")
    ]).then(()=>parcelRequire('9uk9j'));
}

});




parcelRegister("2GdcW", function(module, exports) {

$parcel$export(module.exports, "getStatusInitialValue", () => $4b275fd7b9b278c5$export$1ba71d3b9cbf042c);
const $4b275fd7b9b278c5$export$1ba71d3b9cbf042c = (fieldPersistedValue)=>{
    if (fieldPersistedValue == null) return {
        name: '',
        id: '',
        statusCategory: {
            id: 0,
            name: ''
        }
    };
    return {
        name: fieldPersistedValue.name,
        id: fieldPersistedValue.id,
        statusCategory: {
            id: fieldPersistedValue.statusCategory.id,
            name: fieldPersistedValue.statusCategory.name
        }
    };
};

});



parcelRegister("3HVY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9113712eba1ee20$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");
var $8411R = parcelRequire("8411R");

var $2wCUM = parcelRequire("2wCUM");

var $bLiXo = parcelRequire("bLiXo");

var $fCyzk = parcelRequire("fCyzk");

var $1eJhK = parcelRequire("1eJhK");

var $lO4Or = parcelRequire("lO4Or");

var $ca1Gj = parcelRequire("ca1Gj");

var $kKzsy = parcelRequire("kKzsy");

var $8tX77 = parcelRequire("8tX77");

var $6fNpW = parcelRequire("6fNpW");

var $f1lMr = parcelRequire("f1lMr");

var $l7fND = parcelRequire("l7fND");

var $fcMLP = parcelRequire("fcMLP");
const $c9113712eba1ee20$export$23d1bd80ef2b99bd = 'JSM_REQUEST_PANEL';
const $c9113712eba1ee20$export$257ef95cb54e61ed = 'JSM_RISK_IMPROVEMENT_ITEM_ID';
const $c9113712eba1ee20$export$9ba27033cef8d2d0 = 'JSM_PRIMARY_INCIDENT_ITEM_ID';
const $c9113712eba1ee20$export$d50727056a040348 = (itsmPractices)=>itsmPractices?.[0] === (0, $f1lMr.CHANGES);
const $c9113712eba1ee20$var$ContentTemplate = ({ issueViewRelayFragment: issueViewRelayFragment })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [contentItems] = (0, $fCyzk.useLayoutContainerByType)(issueKey, 'CONTENT');
    const [requestPortalItems] = (0, $fCyzk.useLayoutContainerByType)(issueKey, 'REQUEST_PORTAL');
    const [{ value: issueFieldsConfig }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    const requestPanelItems = (0, $fcMLP.addRefsToArrayOfItems)(requestPortalItems, issueFieldsConfig);
    const requestPanel = (0, $l7fND.isProformaHarmonisationFFEnabled)() && // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.PROFORMA_FORMS)
    })[0]?.isHarmonisationEnabled ? [] : [
        {
            id: $c9113712eba1ee20$export$23d1bd80ef2b99bd,
            type: (0, $bLiXo.CUSTOM_ITEM_TYPE),
            item: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6fNpW.default), {
                issueViewRelayFragment: issueViewRelayFragment,
                requestPanelItems: requestPanelItems
            })
        }
    ];
    const [itsmPractices] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.SERVICEDESK_PRACTICES_TYPE)
    });
    const riskImprovementPanel = $c9113712eba1ee20$export$d50727056a040348(itsmPractices) ? [
        {
            id: $c9113712eba1ee20$export$257ef95cb54e61ed,
            type: (0, $bLiXo.CUSTOM_ITEM_TYPE),
            item: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ca1Gj.default), {
                issueKey: issueKey
            })
        }
    ] : [];
    const primaryIncidentPanel = (0, $2wCUM.useIsIssueOfPostIncidentReviewPractice)() ? [
        {
            id: $c9113712eba1ee20$export$9ba27033cef8d2d0,
            type: (0, $bLiXo.CUSTOM_ITEM_TYPE),
            item: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8tX77.AsyncPrimaryIncident), null)
        }
    ] : [];
    /**
	 * For custom field types we wish to inject them into the first tab so that they are rendered correctly
	 * given that the tab view expects only tabs to be appearing in the content section.
	 */ const items = [
        ...requestPanel,
        ...riskImprovementPanel,
        ...(0, $fcMLP.getContentItemsWithLooseItemsInFirstTab)(contentItems, requestPanel, riskImprovementPanel, primaryIncidentPanel),
        ...primaryIncidentPanel
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1eJhK.ContentSectionView), {
        items: items,
        issueViewRelayFragment: issueViewRelayFragment
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKzsy.JsdGettingStartedPanelShouldRender), null));
};
var $c9113712eba1ee20$export$2e2bcd8739ae039 = $c9113712eba1ee20$var$ContentTemplate;

});
parcelRegister("ca1Gj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3208ca764de71ab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $9VPEO = parcelRequire("9VPEO");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $gGtKh = parcelRequire("gGtKh");

var $5ICH8 = parcelRequire("5ICH8");

var $aJrml = parcelRequire("aJrml");

const $3208ca764de71ab6$export$49270e3280e574c1 = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("6Pa0u")), {
    moduleId: "./src/packages/servicedesk/change-management/risk-insights-panel/src/ui/index.tsx"
});
const $3208ca764de71ab6$var$LazyRiskInsightsPanel = ({ issueKey: issueKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "riskInsightsPanel",
        packageName: "jiraServiceDeskRiskInsightsPanel",
        fallback: "unmount",
        teamName: "jenga",
        sendToPrivacyUnsafeSplunk: true
    }, (0, $1ybV0.ff)('enable-risk-insights-platformization_o9hel') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3208ca764de71ab6$var$panelStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "risk-insights-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ICH8.TabsSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3208ca764de71ab6$export$49270e3280e574c1, {
        issueKey: issueKey
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aJrml.PanelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "risk-insights-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
            width: "100%",
            height: "60px"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3208ca764de71ab6$export$49270e3280e574c1, {
        issueKey: issueKey
    }))));
const $3208ca764de71ab6$var$panelStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300'
});
var $3208ca764de71ab6$export$2e2bcd8739ae039 = $3208ca764de71ab6$var$LazyRiskInsightsPanel;

});
parcelRegister("9VPEO", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "Skeleton", () => $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $fdf3dd89d5b95a51$export$d7a54cba636a8cd6);
$parcel$export(module.exports, "SkeletonCompiled", () => $fdf3dd89d5b95a51$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $fdf3dd89d5b95a51$export$e477bb7d17087f28);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");
const $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $kwce8.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $fdf3dd89d5b95a51$var$shimmer = $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec();
const $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $fdf3dd89d5b95a51$var$shimmer,
        animationTimingFunction: 'linear',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `var(--ds-skeleton, ${(0, $PdmhA).N30})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundImage: `linear-gradient( to right, ${`var(--ds-skeleton, ${(0, $PdmhA).N30})`} 10%, ${`var(--ds-skeleton-subtle, ${(0, $PdmhA).N20})`} 30%, ${`var(--ds-skeleton, ${(0, $PdmhA).N30})`} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: '2px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $fdf3dd89d5b95a51$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $fdf3dd89d5b95a51$export$dc84d515085190e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height),
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1kwx _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk _2rkoyh40 _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $fdf3dd89d5b95a51$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5ICH8", function(module, exports) {

$parcel$export(module.exports, "TabsSkeleton", () => $1c5b711209d27e79$export$807fef2beb9debc2);

var $eUqFw = parcelRequire("eUqFw");

var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $9VPEO = parcelRequire("9VPEO");

var $1AGy4 = parcelRequire("1AGy4");
const $1c5b711209d27e79$export$807fef2beb9debc2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        gap: "space.200",
        xcss: $1c5b711209d27e79$var$tabHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "20px",
        width: "96px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "20px",
        width: "72px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "20px",
        width: "84px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "20px",
        width: "72px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "2px",
        width: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $1c5b711209d27e79$var$tabBodyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1AGy4.default), null)));
const $1c5b711209d27e79$var$tabHeaderStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.075'
});
const $1c5b711209d27e79$var$tabBodyStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.200'
});

});
parcelRegister("1AGy4", function(module, exports) {

$parcel$export(module.exports, "default", () => $54787c2cd48d4787$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9VPEO = parcelRequire("9VPEO");

var $5bs93 = parcelRequire("5bs93");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$54787c2cd48d4787$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5bs93.SkeletonWrapper), {
        "data-testid": "risk-insights-panel.common.ui.skeleton.skeleton-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5bs93.SkeletonLineWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "20px",
        width: "30%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5bs93.SkeletonLineWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "20px",
        width: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5bs93.SkeletonLineWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "20px",
        width: "100%"
    }))));

});
parcelRegister("5bs93", function(module, exports) {

$parcel$export(module.exports, "SkeletonWrapper", () => $c2e98fbd665f7b50$export$6069cbe61f690103);
$parcel$export(module.exports, "SkeletonLineWrapper", () => $c2e98fbd665f7b50$export$5c46047d7ec52e5e);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $c2e98fbd665f7b50$export$6069cbe61f690103 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
const $c2e98fbd665f7b50$export$5c46047d7ec52e5e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _otyru2gc",
            __cmplp.className
        ])
    });
});

});



parcelRegister("aJrml", function(module, exports) {

$parcel$export(module.exports, "PanelWrapper", () => $4d08fb8ab030c503$export$f537a9b13aef4d02);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $4d08fb8ab030c503$export$f537a9b13aef4d02 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0x0bf _2hwxx0bf _otyr1ejb",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6Pa0u", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5WaIZ');
        const value = parcelRequire('2AC7K');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5WaIZ").then(()=>parcelRequire('2AC7K'));
}

});


parcelRegister("kKzsy", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $993d872dc7228c2f$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $993d872dc7228c2f$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $993d872dc7228c2f$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $993d872dc7228c2f$export$c7732c55900cf0b9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hfiyN")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanel = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hTkS8")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("c3XjM")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("eTjqX")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $993d872dc7228c2f$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender, null));
$993d872dc7228c2f$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $993d872dc7228c2f$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanel, null));
$993d872dc7228c2f$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $993d872dc7228c2f$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton, null));
$993d872dc7228c2f$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $993d872dc7228c2f$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight, null));
$993d872dc7228c2f$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("hfiyN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kd6Ju');
        const value = parcelRequire('appSk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kd6Ju").then(()=>parcelRequire('appSk'));
}

});

parcelRegister("hTkS8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('5eFqM')
        ]);
        const value = parcelRequire('ddfk6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("5eFqM")
    ]).then(()=>parcelRequire('ddfk6'));
}

});

parcelRegister("c3XjM", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('ahRif')
        ]);
        const value = parcelRequire('1HvEW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("ahRif")
    ]).then(()=>parcelRequire('1HvEW'));
}

});

parcelRegister("eTjqX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('cxrYi')
        ]);
        const value = parcelRequire('f9sDQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("cxrYi")
    ]).then(()=>parcelRequire('f9sDQ'));
}

});


parcelRegister("8tX77", function(module, exports) {

$parcel$export(module.exports, "AsyncPrimaryIncident", () => $efe08cd6af708853$export$daa7385f56261533);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $efe08cd6af708853$var$PrimaryIncidentAsync = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("eY4pn")), {
    moduleId: "./src/packages/servicedesk/post-incident-review/src/ui/primary-incident/index.tsx"
});
const $efe08cd6af708853$export$daa7385f56261533 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "pir-primary-incident",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($efe08cd6af708853$var$PrimaryIncidentAsync, null));

});
parcelRegister("eY4pn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('jm14I')
        ]);
        const value = parcelRequire('bjF35');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("jm14I")
    ]).then(()=>parcelRequire('bjF35'));
}

});


parcelRegister("6fNpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e62cbb7af3d5dfcd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8sN8t = parcelRequire("8sN8t");


var $lNNXV = parcelRequire("lNNXV");

var $8fhdu = parcelRequire("8fhdu");
const $e62cbb7af3d5dfcd$export$9af0c6f6b6bc4fec = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
        name: (0, $ab3fc2ac1a2f2638$export$a446d697df3d6b2c)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fhdu.default), props));
var $e62cbb7af3d5dfcd$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        // Logic from isLoadingSelector in @atlassian/jira-issue-view/src/common/state/selectors/issue-selector
        // @ts-expect-error - TS2339 - Property 'ui' does not exist on type '{}'.
        isIssueViewLoading: state.ui.loadingStage === 'LOADING'
    }), {})($e62cbb7af3d5dfcd$export$9af0c6f6b6bc4fec);

});
parcelRegister("8fhdu", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0eda3bd13d64ea0$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $kwMhr = parcelRequire("kwMhr");
var $9EHc8 = parcelRequire("9EHc8");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $hJ992 = parcelRequire("hJ992");

var $bLiXo = parcelRequire("bLiXo");

var $3DTsn = parcelRequire("3DTsn");


var $guDlK = parcelRequire("guDlK");

var $5yh8X = parcelRequire("5yh8X");

var $kJlBc = parcelRequire("kJlBc");

var $be3PE = parcelRequire("be3PE");

var $5Xp4r = parcelRequire("5Xp4r");

var $k8Knv = parcelRequire("k8Knv");
var $kUcS1 = parcelRequire("kUcS1");

var $fDE9L = parcelRequire("fDE9L");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");


var $lLLr1 = parcelRequire("lLLr1");
var $lr0E1 = parcelRequire("lr0E1");
var $in7qV = parcelRequire("in7qV");

var $a8FBV = parcelRequire("a8FBV");
const $f0eda3bd13d64ea0$var$RequestDetailsPanel = ({ requestPanelItems: requestPanelItems, isIssueViewLoading: isIssueViewLoading, issueViewRelayFragment: issueViewRelayFragment })=>{
    const hasRequestPanelItems = requestPanelItems.length > 0;
    const [isExpanded, setExpanded] = (0, $eUqFw.useState)(true);
    const [data] = (0, $kUcS1.useRequestPanelMetadata)();
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    const requestUrl = data?.requestUrl ?? '';
    const analyticsSource = (0, $hJ992.useAnalyticsSource)();
    const isInServiceDeskQueue = typeof analyticsSource === 'string' ? analyticsSource === (0, $0100842672acae20$export$7063ee6d0035a982) : false;
    const isInServiceDeskReport = typeof analyticsSource === 'string' ? analyticsSource === (0, $0100842672acae20$export$5bd5011b6596a0e7) : false;
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectContext = (0, $guDlK.useProjectContext)(projectKey);
    const helpCenter = ()=>projectContext?.projectStatus !== (0, $5bd9e96e4d7e8aee$export$4ccc35479ba9ad1) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lr0E1.HelpCenter), {
            link: requestUrl
        });
    const detailsHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
        location: "panel-header-expand"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0eda3bd13d64ea0$var$ExpanderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $in7qV.ReporterAndChannel), {
        channel: data?.channel
    }), hasRequestPanelItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLLr1.ContentSectionExpander), {
        isContentExpanded: isExpanded,
        onExpand: ()=>setExpanded(true),
        onCollapse: ()=>setExpanded(false)
    }))), (hasRequestPanelItems && isExpanded || !hasRequestPanelItems) && requestUrl && helpCenter());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.SubExperienceTrackingProvider), {
        location: "requestDetailsPanel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0eda3bd13d64ea0$var$RequestContentContainer, {
        isExpanded: isExpanded,
        hasContentItems: hasRequestPanelItems
    }, isIssueViewLoading === false && (isInServiceDeskQueue || isInServiceDeskReport) && __SPA__ && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.RouterSubscriber), null, ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be3PE.JsmPageInteractiveEvent), {
            metricKey: (0, $k8Knv.getMetricKey)(match && match.params && match.params.practiceType, analyticsSource),
            withMarks: [
                (0, $5yh8X.appBundleReadyMark)
            ],
            metric: (0, $k8Knv.getMetric)(analyticsSource),
            extra: {
                category: match && match.params && (0, $fDE9L.toItsmPractice)(match.params.practiceType)
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Xp4r.default), {
        id: (0, $3192d890a33cd69b$export$e5820f3349d3bcf0)
    }, detailsHeader), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0eda3bd13d64ea0$var$FieldsContainer, {
        hasContentItems: hasRequestPanelItems
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3DTsn.ItemList), {
        items: requestPanelItems,
        area: (0, $bLiXo.CONTENT_REQUEST_AREA),
        layoutItemsDataFragment: issueViewRelayFragment ?? null
    }))));
};
const $f0eda3bd13d64ea0$var$RequestDetailsPanelWithErrorBoundary = (props)=>{
    const { serviceDesk: serviceDeskEdition } = (0, $ab6rA.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "requestDetailsPanel",
        packageName: "jiraServicedeskRequestDetailsPanel",
        attributes: {
            isJsmPremium: serviceDeskEdition === (0, $6WXNs.PREMIUM_EDITION)
        },
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0eda3bd13d64ea0$var$RequestContentContainer, {
                isExpanded: true,
                hasContentItems: false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8FBV.GenericError), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0eda3bd13d64ea0$var$RequestDetailsPanel, props));
};
var $f0eda3bd13d64ea0$export$2e2bcd8739ae039 = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('jsm-issue-view-and-setting-patches_mon1t'), $f0eda3bd13d64ea0$var$RequestDetailsPanelWithErrorBoundary, $f0eda3bd13d64ea0$var$RequestDetailsPanel);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f0eda3bd13d64ea0$var$RequestContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, hasContentItems: hasContentItems, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _otyr1ejb _1e0c1txw _2lx21bp4 _2rko1y44 _19ith6cr _bfhkvuon _1yt4pxbi",
            __cmplp.isExpanded && __cmplp.hasContentItems && "_n3tdidpf",
            __cmplp.className
        ])
    });
});
const $f0eda3bd13d64ea0$var$FieldsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasContentItems: hasContentItems, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.hasContentItems && "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $f0eda3bd13d64ea0$export$7ed12d2a5241e393 = {
    RequestContentContainer: $f0eda3bd13d64ea0$var$RequestContentContainer,
    FieldsContainer: $f0eda3bd13d64ea0$var$FieldsContainer
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f0eda3bd13d64ea0$var$ExpanderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5yh8X", function(module, exports) {

$parcel$export(module.exports, "appBundleReadyMark", () => $b15a1f5ef3252a04$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $b15a1f5ef3252a04$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $b15a1f5ef3252a04$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $b15a1f5ef3252a04$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $b15a1f5ef3252a04$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $b15a1f5ef3252a04$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $b15a1f5ef3252a04$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $b15a1f5ef3252a04$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $b15a1f5ef3252a04$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $b15a1f5ef3252a04$export$4eb8d44ddb14424a);


var $1cNJ6 = parcelRequire("1cNJ6");
const $b15a1f5ef3252a04$export$7e50945a65dd40e = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$ff834eccc35b9089));
const $b15a1f5ef3252a04$export$17cbe723d23101d8 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$86b05e34d462ead8));
const $b15a1f5ef3252a04$export$887fadb22e7c7735 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$d6a604a7d9a390fb));
const $b15a1f5ef3252a04$export$bd099c0a906f4b3f = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$3ae43cc1782d058f));
const $b15a1f5ef3252a04$export$d23ef9e7633e30e7 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$363f6703ffa600be));
const $b15a1f5ef3252a04$export$319da6d901948a6d = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$e87b74567b79c8));
const $b15a1f5ef3252a04$export$f0b6622cdc5c7e4f = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$99fe642459a8b02));
const $b15a1f5ef3252a04$export$37e82663aa1e79a8 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$ab1f5705fc8e0571));
const $b15a1f5ef3252a04$export$21146514eacceb12 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$8c3a9046da692c35));
const $b15a1f5ef3252a04$export$4eb8d44ddb14424a = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$5aa497d1efdcc5bf));

});

parcelRegister("be3PE", function(module, exports) {

$parcel$export(module.exports, "JsmPageInteractiveEvent", () => $695cc37a0df2f37c$export$c4ba40c380ee9a11);

var $eUqFw = parcelRequire("eUqFw");

var $7vf5z = parcelRequire("7vf5z");
const $695cc37a0df2f37c$export$c4ba40c380ee9a11 = (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), args);
$695cc37a0df2f37c$export$c4ba40c380ee9a11.defaultProps = {
    isExpectedToHaveSsr: false,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    withMarks: [],
    extra: {}
};
$695cc37a0df2f37c$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';

});

parcelRegister("k8Knv", function(module, exports) {

$parcel$export(module.exports, "getMetricKey", () => $971b0a1e931a094b$export$cb832de761ecab61);
$parcel$export(module.exports, "getMetric", () => $971b0a1e931a094b$export$ed0dc1178a679c67);


var $f1lMr = parcelRequire("f1lMr");
var $fDE9L = parcelRequire("fDE9L");

var $1CYQ5 = parcelRequire("1CYQ5");
const $971b0a1e931a094b$export$cb832de761ecab61 = (practiceType, analyticsSource)=>{
    if (analyticsSource === (0, $0100842672acae20$export$5bd5011b6596a0e7)) return 'servicedesk.reports.custom.issue';
    const practice = (0, $fDE9L.toItsmPractice)(practiceType);
    return practice !== (0, $f1lMr.NO_CATEGORY) ? `servicedesk.queues.${practice}.issue` : 'servicedesk.queues.issue';
};
const $971b0a1e931a094b$export$ed0dc1178a679c67 = (analyticsSource)=>{
    // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
    if (analyticsSource === (0, $0100842672acae20$export$5bd5011b6596a0e7)) return 0, $1CYQ5.JSMReportsIssueViewLoad;
    // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
    return 0, $1CYQ5.JSMIssueViewLoad;
};

});
parcelRegister("fDE9L", function(module, exports) {

$parcel$export(module.exports, "toItsmPractice", () => $535b295fef57b491$export$1b27246f3c7494c);
$parcel$export(module.exports, "isValidItsmPractice", () => $535b295fef57b491$export$357b94e419749e3d);

var $f1lMr = parcelRequire("f1lMr");
const $535b295fef57b491$export$1b27246f3c7494c = (practiceString)=>{
    switch(practiceString){
        case 'incidents':
            return 0, $f1lMr.INCIDENTS;
        case 'changes':
            return 0, $f1lMr.CHANGES;
        case 'service-requests':
            return 0, $f1lMr.SERVICE_REQUEST;
        case 'problems':
            return 0, $f1lMr.PROBLEMS;
        case 'post-incident-reviews':
            return 0, $f1lMr.POST_INCIDENT_REVIEWS;
        default:
            return 0, $f1lMr.NO_CATEGORY;
    }
};
const $535b295fef57b491$export$357b94e419749e3d = (practiceString)=>{
    switch(practiceString){
        case 0, $f1lMr.INCIDENTS:
        case 0, $f1lMr.CHANGES:
        case 0, $f1lMr.SERVICE_REQUEST:
        case 0, $f1lMr.PROBLEMS:
        case 0, $f1lMr.POST_INCIDENT_REVIEWS:
        case 0, $f1lMr.NO_CATEGORY:
            return true;
        default:
            return false;
    }
};

});

parcelRegister("1CYQ5", function(module, exports) {

$parcel$export(module.exports, "JSMIssueViewLoad", () => $c96fdad5fc5f24f8$export$1e32b6c8e1e31a3d);
$parcel$export(module.exports, "JSMReportsIssueViewLoad", () => $c96fdad5fc5f24f8$export$30ebd3f479793fc1);

var $lEpcX = parcelRequire("lEpcX");
const $c96fdad5fc5f24f8$export$1e32b6c8e1e31a3d = (0, $lEpcX.metrics).pageLoad({
    key: 'service-management.queues.issue'
});
const $c96fdad5fc5f24f8$export$30ebd3f479793fc1 = (0, $lEpcX.metrics).pageLoad({
    key: 'service-management.reports.issue'
});

});


parcelRegister("kUcS1", function(module, exports) {

$parcel$export(module.exports, "useRequestPanelMetadata", () => $2104aa91ac9ea849$export$97b39515246c02f1);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");

var $4ksts = parcelRequire("4ksts");

var $hJ992 = parcelRequire("hJ992");

var $lkTn2 = parcelRequire("lkTn2");

var $aWbXp = parcelRequire("aWbXp");
// Backend returns untranslated prop so we need to translate it here
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter. | TS7006 - Parameter 'intl' implicitly has an 'any' type.
const $2104aa91ac9ea849$var$translateChannel = (channelType, intl)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ unknown: MessageDescriptorV2; anonymousportal: MessageDescriptorV2; deployment: MessageDescriptorV2; jira: MessageDescriptorV2; api: MessageDescriptorV2; email: MessageDescriptorV2; portal: MessageDescriptorV2; }'.
    channelType !== undefined && (0, $aWbXp.default)[channelType] ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ unknown: MessageDescriptorV2; anonymousportal: MessageDescriptorV2; deployment: MessageDescriptorV2; jira: MessageDescriptorV2; api: MessageDescriptorV2; email: MessageDescriptorV2; portal: MessageDescriptorV2; }'.
    intl.formatMessage((0, $aWbXp.default)[channelType]) : undefined;
// @ts-expect-error - TS7006 - Parameter 'intl' implicitly has an 'any' type.
const $2104aa91ac9ea849$var$transformResponse = (response, intl)=>({
        channel: $2104aa91ac9ea849$var$translateChannel(response.channel, intl),
        requestUrl: response.requestUrl,
        csatComment: response.csatComment
    });
const $2104aa91ac9ea849$var$handleFailure = (error)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.request-panel-metadata.fetch', error.message, error);
};
const $2104aa91ac9ea849$export$97b39515246c02f1 = ()=>{
    const [data, setData] = (0, $eUqFw.useState)();
    const [error, setError] = (0, $eUqFw.useState)();
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const issueKey = (0, $hJ992.useIssueKey)();
    const baseUrl = '';
    const intl = (0, $4ksts.useIntlV2)();
    const [, { setCsatComment: setCsatComment }] = (0, $lkTn2.useCsatComment)();
    const fetchMetaDataUrl = (0, $eUqFw.useCallback)(async ()=>{
        try {
            setLoading(true);
            const url = `${baseUrl}/rest/servicedesk/1/servicedesk/request/${issueKey}/request-panel-metadata`;
            const response = await (0, $2OdyW.default)(url, {
                method: 'GET'
            });
            if (response.errors) {
                const err = new Error(response.message);
                // @ts-expect-error - preserve nested errors
                err.errors = response.errors;
                $2104aa91ac9ea849$var$handleFailure(err);
                setError(err);
            } else {
                const transformedResponse = $2104aa91ac9ea849$var$transformResponse(response, intl);
                setData(transformedResponse);
                transformedResponse.csatComment !== undefined ? setCsatComment(transformedResponse.csatComment) : setCsatComment('');
            }
            setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            $2104aa91ac9ea849$var$handleFailure(err);
            setError(err);
            setLoading(false);
        }
    }, [
        baseUrl,
        intl,
        issueKey,
        setCsatComment
    ]);
    (0, $eUqFw.useEffect)(()=>{
        fetchMetaDataUrl();
    }, [
        fetchMetaDataUrl
    ]);
    return [
        data,
        error,
        loading
    ];
};

});
parcelRegister("lkTn2", function(module, exports) {

$parcel$export(module.exports, "useCsatComment", () => $316b539e77933ce5$export$6ca39b9686f0dc39);

var $ggKAj = parcelRequire("ggKAj");

var $ctpI0 = parcelRequire("ctpI0");
const $316b539e77933ce5$export$6ca39b9686f0dc39 = (0, $ggKAj.createHook)((0, $ctpI0.store), {
    selector: (state)=>state.csatComment
});

});
parcelRegister("ctpI0", function(module, exports) {

$parcel$export(module.exports, "store", () => $2daae7fcc1030e87$export$6f57813fe9f31bf9);

var $a61MH = parcelRequire("a61MH");

var $8g9LY = parcelRequire("8g9LY");
const $2daae7fcc1030e87$export$d4c72bab9d6cc13a = {
    csatComment: undefined
};
const $2daae7fcc1030e87$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'request-details-panel',
    initialState: $2daae7fcc1030e87$export$d4c72bab9d6cc13a,
    actions: $8g9LY.actions
});

});
parcelRegister("8g9LY", function(module, exports) {

$parcel$export(module.exports, "actions", () => $9968fc13776e2572$export$e324594224ef24da);
const $9968fc13776e2572$export$e324594224ef24da = {
    setCsatComment: (csatComment)=>({ setState: setState })=>{
            setState({
                csatComment: csatComment
            });
        }
};

});



parcelRegister("aWbXp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6f1cfbdea1e4d41$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b6f1cfbdea1e4d41$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    portal: {
        "id": "servicedesk-request-details-panel-services.services.fetch-panel-metadata.portal",
        "defaultMessage": "Portal"
    },
    email: {
        "id": "servicedesk-request-details-panel-services.services.fetch-panel-metadata.email",
        "defaultMessage": "Email"
    },
    api: {
        "id": "servicedesk-request-details-panel-services.services.fetch-panel-metadata.api",
        "defaultMessage": "API"
    },
    jira: {
        "id": "servicedesk-request-details-panel-services.services.fetch-panel-metadata.jira",
        "defaultMessage": "Jira"
    },
    deployment: {
        "id": "servicedesk-request-details-panel-services.services.fetch-panel-metadata.deployment",
        "defaultMessage": "Deployment"
    },
    anonymousportal: {
        "id": "servicedesk-request-details-panel-services.services.fetch-panel-metadata.anonymousportal",
        "defaultMessage": "Anonymous Portal"
    },
    unknown: {
        "id": "servicedesk-request-details-panel-services.services.fetch-panel-metadata.unknown",
        "defaultMessage": "Unknown"
    }
});

});


const $3192d890a33cd69b$export$e5820f3349d3bcf0 = 'reporter-spotlight';
const $3192d890a33cd69b$export$3ef7e400a3598524 = 'issue.error';

parcelRegister("lLLr1", function(module, exports) {

$parcel$export(module.exports, "ContentSectionExpander", () => $7898cc0a34c6e00c$export$b058d23bce74aa4e);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $eMfO0 = parcelRequire("eMfO0");
const $7898cc0a34c6e00c$export$b058d23bce74aa4e = ({ isContentExpanded: isContentExpanded, onExpand: onExpand, onCollapse: onCollapse })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleExpand = (event, analyticsEvent)=>{
        onExpand && onExpand();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'showRequestDetails');
    };
    const handleCollapse = (event, analyticsEvent)=>{
        onCollapse && onCollapse();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'hideRequestDetails');
    };
    const renderShowDetailsButton = ()=>// @ts-expect-error - TS2322 - Type '{ children: string; externalId: string; appearance: "link"; onClick: (event: SyntheticEvent<Element, Event>, analyticsEvent: UIAnalyticsEventInterface) => void; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            externalId: "showdetailslink.expand",
            appearance: "link",
            onClick: handleExpand
        }, formatMessage((0, $eMfO0.default).showDetails));
    const renderHideDetailsButton = ()=>// @ts-expect-error - TS2322 - Type '{ children: string; externalId: string; appearance: "link"; onClick: (event: SyntheticEvent<Element, Event>, analyticsEvent: UIAnalyticsEventInterface) => void; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            externalId: "showdetailslink.collapse",
            appearance: "link",
            onClick: handleCollapse
        }, formatMessage((0, $eMfO0.default).hideDetails));
    return isContentExpanded ? renderHideDetailsButton() : renderShowDetailsButton();
};

});
parcelRegister("eMfO0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f4298f879e66142$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4f4298f879e66142$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showDetails: {
        "id": "servicedesk-request-details-panel.expander.show-details",
        "defaultMessage": "Show details"
    },
    hideDetails: {
        "id": "servicedesk-request-details-panel.expander.hide-details",
        "defaultMessage": "Hide details"
    }
});

});


parcelRegister("lr0E1", function(module, exports) {

$parcel$export(module.exports, "HelpCenter", () => $9a20cebc4df6bb02$export$93b569af380b484c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4ksts = parcelRequire("4ksts");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");

var $2PG7e = parcelRequire("2PG7e");
const $9a20cebc4df6bb02$export$93b569af380b484c = ({ link: link })=>{
    const onClick = (event, analyticsEvent)=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'viewRequestInHelpCenter');
    const intl = (0, $4ksts.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a20cebc4df6bb02$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a20cebc4df6bb02$var$LinkWithAnalytics, {
        href: link,
        target: "_blank",
        onClick: onClick
    }, intl.formatMessage((0, $2PG7e.default).viewRequest)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9a20cebc4df6bb02$var$Link = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1crf",
            __cmplp.className
        ])
    });
});
const $9a20cebc4df6bb02$var$LinkWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('link', {
    onClick: 'clicked'
})($9a20cebc4df6bb02$var$Link);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9a20cebc4df6bb02$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19bvv47k _18u0pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2PG7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $a201dbe5dedc4ad4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a201dbe5dedc4ad4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewRequest: {
        "id": "servicedesk-request-details-panel.help-center.view-request",
        "defaultMessage": "View request in portal"
    }
});

});


parcelRegister("in7qV", function(module, exports) {

$parcel$export(module.exports, "ReporterAndChannel", () => $6f049e5aa34e8fd2$export$5ce8fbedff41a4d1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5iWql = parcelRequire("5iWql");

var $iJlfe = parcelRequire("iJlfe");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4ksts = parcelRequire("4ksts");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $lO4Or = parcelRequire("lO4Or");

var $1cbJw = parcelRequire("1cbJw");
const $6f049e5aa34e8fd2$var$getAnonymousReporter = (0, $5iWql.default)((intl)=>({
        avatarUrl: '',
        name: intl.formatMessage((0, $1cbJw.default).noReporter)
    }));
const $6f049e5aa34e8fd2$var$getReporter = (0, $5iWql.default)((intl, value)=>{
    const { displayName: displayName, avatarUrls: avatarUrls } = value;
    return {
        /* 48x48 is the avatar size returned from Issue express. We pick this so we could see the actual avatar during
          issue preview mode. */ avatarUrl: avatarUrls && avatarUrls['48x48'] ? avatarUrls['48x48'] : '',
        name: displayName || intl.formatMessage((0, $1cbJw.default).noReporter)
    };
});
const $6f049e5aa34e8fd2$export$5ce8fbedff41a4d1 = ({ channel: channel })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const [reporter] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.REPORTER_TYPE)
    });
    let reporterDetails = $6f049e5aa34e8fd2$var$getAnonymousReporter(intl);
    if (reporter) reporterDetails = $6f049e5aa34e8fd2$var$getReporter(intl, reporter);
    const { name: name, avatarUrl: avatarUrl } = reporterDetails;
    const isChannelNamePresent = channel !== undefined && channel !== '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f049e5aa34e8fd2$var$Container, {
        "data-testId": "servicedesk-request-details-panel.ui.reporter-and-channel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f049e5aa34e8fd2$var$AvatarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: avatarUrl,
        size: "small",
        testId: "servicedesk-request-details-panel.ui.reporter-and-channel.avatar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f049e5aa34e8fd2$var$ReporterNameContainer, null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f049e5aa34e8fd2$var$RequestRaisedContainer, null, intl.formatMessage((0, $1cbJw.default).requestRaised)), isChannelNamePresent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6f049e5aa34e8fd2$var$viaContainerStyles
    }, intl.formatMessage((0, $1cbJw.default).via)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f049e5aa34e8fd2$var$ChannelNameContainer, null, channel)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f049e5aa34e8fd2$var$AvatarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $6f049e5aa34e8fd2$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $6f049e5aa34e8fd2$var$ReporterNameContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l _u5f31b66 _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $6f049e5aa34e8fd2$var$ChannelNameContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l _19bv1b66",
            __cmplp.className
        ])
    });
});
const $6f049e5aa34e8fd2$var$RequestRaisedContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $6f049e5aa34e8fd2$var$viaContainerStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.050'
});

});
parcelRegister("1cbJw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9fdbd0f83a4aa8b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d9fdbd0f83a4aa8b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    requestRaised: {
        "id": "servicedesk-request-details-panel.reporter-and-channel.request-raised",
        "defaultMessage": "raised this request"
    },
    via: {
        "id": "servicedesk-request-details-panel.reporter-and-channel.via",
        "defaultMessage": "via"
    },
    noReporter: {
        "id": "servicedesk-request-details-panel.reporter-and-channel.no-reporter",
        "defaultMessage": "Anonymous"
    }
});

});


parcelRegister("a8FBV", function(module, exports) {

$parcel$export(module.exports, "GenericError", () => $c73c0637b01e336c$export$7d465be8efa67280);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $96IgR = parcelRequire("96IgR");

var $lV9rH = parcelRequire("lV9rH");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7mGqZ = parcelRequire("7mGqZ");
const $c73c0637b01e336c$export$7d465be8efa67280 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c73c0637b01e336c$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $c73c0637b01e336c$var$avatarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c73c0637b01e336c$var$reporterContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c73c0637b01e336c$var$infoContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lV9rH.default), {
        width: "280px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lV9rH.default), {
        width: "80px",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lV9rH.default), {
        width: "80px",
        isShimmering: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c73c0637b01e336c$var$warningMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: "",
        primaryColor: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $7mGqZ.default).errorMessage))));
};
const $c73c0637b01e336c$var$containerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $c73c0637b01e336c$var$avatarContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex'
});
const $c73c0637b01e336c$var$reporterContainerStyles = (0, $1ZAYh.xcss)({
    paddingTop: "var(--ds-space-100, 8px)",
    gap: 'space.100',
    display: 'flex',
    flexDirection: 'column',
    flex: 1
});
const $c73c0637b01e336c$var$infoContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
});
const $c73c0637b01e336c$var$warningMessageStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginTop: "var(--ds-space-200, 16px)",
    alignItems: 'center',
    gap: 'space.100'
});

});
parcelRegister("7mGqZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8d8086bc4263369$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e8d8086bc4263369$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "servicedesk-request-details-panel.generic-error.error-message",
        "defaultMessage": "We couldn't load these details. Try refreshing the page."
    }
});

});




parcelRegister("l7fND", function(module, exports) {

$parcel$export(module.exports, "isProformaHarmonisationFFEnabled", () => $7241632855cb3203$export$5dc774c58824d858);

var $1ybV0 = parcelRequire("1ybV0");
const $7241632855cb3203$export$5dc774c58824d858 = ()=>(0, $1ybV0.ff)('proforma-harmonisation-main_ca6ff', false); // <perFORMers>

});

parcelRegister("fcMLP", function(module, exports) {

$parcel$export(module.exports, "addRefsToArrayOfItems", () => $a00b9d176897f7e5$export$79ccc239fa704a26);
$parcel$export(module.exports, "getContentItemsWithLooseItemsInFirstTab", () => $a00b9d176897f7e5$export$5d7fd8f3efdc8d41);

var $bLiXo = parcelRequire("bLiXo");


var $dZWHl = parcelRequire("dZWHl");

var $g8to1 = parcelRequire("g8to1");

var $lO4Or = parcelRequire("lO4Or");
// We can't directly identify `Affected services`, `Change risk` or `Impact`, but we can
// minimise the number of extra targets by wrapping only 'select' type fields since the above
// all fit that criteria. `Description` fortunately has a custom type to identify it
const $a00b9d176897f7e5$var$fieldsWithGlobalTargets = [
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.DESCRIPTION_TYPE),
    (0, $lO4Or.SERVICE_ENTITY_CF_TYPE)
];
const $a00b9d176897f7e5$export$79ccc239fa704a26 = (items, issueFieldsConfig)=>// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    items.map((item)=>{
        const { type: type, id: id } = (0, $g8to1.fieldTypeHandler)(issueFieldsConfig[(0, $dZWHl.getLayoutItemId)(item)], item);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"description" | "com.atlassian.jira.plugin.system.customfieldtypes:select" | "com.atlassian.jira.plugins.service-entity:service-entity-field-cftype"'.
        if ($a00b9d176897f7e5$var$fieldsWithGlobalTargets.includes(type)) return {
            ...item,
            globalRef: `${0, $ab2aafcdf11a1361$export$2028cf1423b28cf8}${id}`
        };
        return item;
    });
const $a00b9d176897f7e5$export$5d7fd8f3efdc8d41 = (contentItems, requestPanel, riskImprovementPanel, primaryIncidentPanel)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const firstTab = contentItems.find((item)=>item.type === (0, $bLiXo.layoutContainerItemTypes).tab);
    if (!firstTab) return contentItems;
    return [
        {
            ...firstTab,
            items: {
                ...firstTab.items,
                nodes: [
                    ...requestPanel,
                    ...riskImprovementPanel,
                    ...firstTab.items.nodes,
                    ...primaryIncidentPanel
                ]
            }
        },
        ...contentItems.filter((item)=>item !== firstTab)
    ];
};

});


parcelRegister("hqlq1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ec6fa494ebdea12$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8sN8t = parcelRequire("8sN8t");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");
var $8411R = parcelRequire("8411R");

var $2wCUM = parcelRequire("2wCUM");

var $bLiXo = parcelRequire("bLiXo");


var $dZWHl = parcelRequire("dZWHl");

var $iWtAM = parcelRequire("iWtAM");

var $3DTsn = parcelRequire("3DTsn");

var $hVEzR = parcelRequire("hVEzR");

var $lJ7QD = parcelRequire("lJ7QD");

var $jbrPp = parcelRequire("jbrPp");

var $lO4Or = parcelRequire("lO4Or");

var $guDlK = parcelRequire("guDlK");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");

var $kS8l2 = parcelRequire("kS8l2");

var $i2F3o = parcelRequire("i2F3o");

var $5WN84 = parcelRequire("5WN84");

var $dkDhN = parcelRequire("dkDhN");

var $c4hWZ = parcelRequire("c4hWZ");

var $3UTxG = parcelRequire("3UTxG");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8ec6fa494ebdea12$export$2e2bcd8739ae039 = ({ issueViewRelayFragment: issueViewRelayFragment })=>{
    const [items, updateHiddenSecondaryFields] = (0, $hVEzR.useVisibleHiddenItems)((0, $iWtAM.ALWAYS_PRIMARY_AND_VISIBLE)[0, $iWtAM.JSD_TEMPLATE]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const [status] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.STATUS_TYPE)
    });
    const [{ value: issueFieldsConfig }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    const [issueFieldsValues] = (0, $kmr29.useFieldsValues)(issueKey);
    const projectContext = (0, $guDlK.useProjectContext)(projectKey);
    const [sla, error] = (0, $dkDhN.useSlaDetails)();
    const canUseServiceDeskAgentFeatures = (0, $5YYzL.useCanUseServiceDeskAgentFeatures)(projectKey);
    const [, { register: register }] = (0, $kS8l2.useGlobalRefStoreActions)();
    const onRef = (0, $eUqFw.useCallback)((ref)=>{
        register((0, $ab3fc2ac1a2f2638$export$f49830a0e4ffb3f9), ref);
    }, [
        register
    ]);
    const isNextGen = projectContext === undefined ? false : projectContext.isSimplified;
    const itemsWithCsatField = (0, $3UTxG.transformCSAT)(isNextGen, items, status, issueFieldsConfig, issueFieldsValues);
    const itemsWithRefs = (0, $3UTxG.addGlobalRefs)(itemsWithCsatField, issueFieldsConfig);
    const slaIndex = itemsWithRefs.visibleItems.findIndex((item)=>(0, $dZWHl.getLayoutItemId)(item) === (0, $lO4Or.SLA_PANEL_TYPE));
    const slaItem = slaIndex !== -1 && itemsWithRefs.visibleItems.splice(slaIndex, 1);
    // removing loading state from shouldShowSla as it shows a janky flicker behaviour for projects where SLA is not configured.
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    let shouldShowSla = error || sla && sla.goalViews.length !== 0;
    if (!(canUseServiceDeskAgentFeatures || projectContext?.projectStatus === (0, $5bd9e96e4d7e8aee$export$4ccc35479ba9ad1))) shouldShowSla = false;
    const SlaPanel = !!slaItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: onRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jbrPp.ContextGroup), {
        title: formatMessage((0, $c4hWZ.default).slaText),
        groupId: "sla-group",
        initialOpened: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3DTsn.ItemList), {
        items: slaItem,
        area: (0, $bLiXo.CONTEXT_AREA),
        layoutItemsDataFragment: issueViewRelayFragment ?? null
    })));
    const shouldShowCustomerContextPanel = itemsWithRefs.visibleItems.findIndex((item)=>(0, $dZWHl.getLayoutItemId)(item) === (0, $lO4Or.CUSTOMER_CONTEXT_TYPE)) !== -1;
    // Temporary workaround to show a new field for Sentiment without BE changes.
    // TODO NBL-3495 - implement sentiment as a proper custom domain field
    if ((0, $1ybV0.ff)('jsm-sentiment-analysis_1dage')) itemsWithRefs.visibleItems.push({
        type: (0, $bLiXo.layoutContainerItemTypes).field,
        fieldItemId: (0, $lO4Or.SENTIMENT_TYPE)
    });
    const CustomerContextPanel = shouldShowCustomerContextPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jbrPp.ContextGroup), {
        title: formatMessage((0, $c4hWZ.default).customerContextText),
        groupId: "customer-context-group",
        initialOpened: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i2F3o.CustomerServiceIssueViewPanel), null));
    const AsyncIncidentSummaryComponent = (0, $2wCUM.useIsIssueOfPostIncidentReviewPractice)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
        name: (0, $9de389cf3f7379b6$export$2f18a1056f942774)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jbrPp.ContextGroup), {
        groupId: "incident-summary",
        title: formatMessage((0, $c4hWZ.default).incidentSummaryText),
        initialOpened: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WN84.AsyncIncidentSummary), null))) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, Boolean(shouldShowSla) && SlaPanel, CustomerContextPanel, AsyncIncidentSummaryComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lJ7QD.default), {
        items: itemsWithRefs,
        issueViewRelayFragment: issueViewRelayFragment,
        onToggleExpanded: updateHiddenSecondaryFields
    }));
};

});
parcelRegister("i2F3o", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceIssueViewPanel", () => $a51383ca799669cf$export$a66e9703c7fd5513);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");
var $3oTxc = parcelRequire("3oTxc");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ln3W8 = parcelRequire("ln3W8");

var $etR5G = parcelRequire("etR5G");

var $k1N5C = parcelRequire("k1N5C");

var $yQm3X = parcelRequire("yQm3X");
const $a51383ca799669cf$export$a66e9703c7fd5513 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const [reporterFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.REPORTER_TYPE)
    });
    const [organizationsFieldId] = (0, $3oTxc.useSearchCustomFieldKeys)(issueKey, (0, $lO4Or.ORGANIZATIONS_CF_TYPE));
    const [organizationsFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: organizationsFieldId
    });
    const orgCount = organizationsFieldValue ? organizationsFieldValue.length : 0;
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueViewCustomerContext loaded', {
            hasReporter: !!reporterFieldValue,
            orgCount: orgCount
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ln3W8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a51383ca799669cf$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $etR5G.Customer), {
        fieldValue: reporterFieldValue,
        orgCount: orgCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yQm3X.Organizations), {
        fieldValue: organizationsFieldValue
    }), (0, $1ybV0.ff)('products-and-entitlements-details-m2_45b1j') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k1N5C.Entitlement), null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a51383ca799669cf$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt46630 _zulpv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("etR5G", function(module, exports) {

$parcel$export(module.exports, "Customer", () => $808f04282d4f88fb$export$aa093906ffb6389d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");

var $5wuW8 = parcelRequire("5wuW8");

var $dWLk9 = parcelRequire("dWLk9");

var $6uuIf = parcelRequire("6uuIf");

var $l43Kj = parcelRequire("l43Kj");

var $gWf4c = parcelRequire("gWf4c");

var $gxp8W = parcelRequire("gxp8W");

var $41hlC = parcelRequire("41hlC");
const $808f04282d4f88fb$export$aa093906ffb6389d = ({ fieldValue: fieldValue, orgCount: orgCount })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const accountIdRef = (0, $eUqFw.useRef)(fieldValue?.accountId);
    const [queryReference, loadQuery, disposeQuery] = (0, $iWLL0.useQueryLoader)((0, $5wuW8.default));
    const hasQueryReference = !!queryReference;
    // If user changes reporter, we want the details field to close (to match orgs behaviour)
    (0, $eUqFw.useEffect)(()=>{
        if (isOpen && accountIdRef.current !== fieldValue?.accountId) setIsOpen(false);
        if (!isOpen && hasQueryReference) disposeQuery();
        accountIdRef.current = fieldValue?.accountId;
    }, [
        cloudId,
        disposeQuery,
        fieldValue,
        hasQueryReference,
        isOpen,
        loadQuery
    ]);
    const onToggle = ()=>{
        setIsOpen((prev)=>{
            if (!prev && fieldValue?.accountId) loadQuery({
                cloudId: cloudId,
                accountId: fieldValue.accountId,
                useReporterOrganizations: orgCount === 0,
                includePlatformValue: (0, $1ybV0.ff)('csm-shipit-58-user-custom-detail-type_be1zw')
            });
            return !prev;
        });
    };
    if (!fieldValue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($808f04282d4f88fb$var$EmptyStateContainer, {
        "data-testid": "servicedesk-customer-service-issue-view-panel.ui.customer.empty-state-container"
    }, formatMessage((0, $gxp8W.default).emptyState));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "issueViewPanelCustomerDetails",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uuIf.Header), null, formatMessage((0, $gxp8W.default).customer)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l43Kj.ExpandPanel), {
        id: "customer",
        onToggle: onToggle,
        field: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWf4c.CustomerField), {
            value: fieldValue
        }),
        isOpen: isOpen,
        source: "REPORTER_FIELD"
    }, isOpen && queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "servicedesk-customer-service-issue-view-panel.ui.customer.div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $41hlC.PanelView), {
        queryReference: queryReference,
        orgCount: orgCount
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $808f04282d4f88fb$var$EmptyStateContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1 _18s8gx6n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5wuW8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e075ed440bbf28d4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4bdba5388211a278afdaef0199333cd2>>
 * @relayHash e1b268d79fc017a2cbe1faee352f10ba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54bfe96301c1e26557f8caec2c6c4df8f8f9b53d157940c33ae90afa703558cd
const $e075ed440bbf28d4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includePlatformValue"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useReporterOrganizations"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        },
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "context": {
                    "type": "ISSUE"
                }
            }
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "identifier"
            },
            {
                "kind": "ScalarField",
                "name": "message"
            },
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusCode"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ]
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "panelViewCustomerQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v4 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "individualByAccountId",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "details",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "includePlatformValue",
                                                                    "variableName": "includePlatformValue"
                                                                }
                                                            ],
                                                            "kind": "FragmentSpread",
                                                            "name": "detailsView_servicedeskCustomerServiceIssueViewPanel"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "useReporterOrganizations",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceOrganization",
                                                            "kind": "LinkedField",
                                                            "name": "organizations",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "FragmentSpread",
                                                                    "name": "customerOrganizations_servicedeskCustomerServiceIssueViewPanel_CustomerOrganization"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CustomerServiceIndividual"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.individualByAccountId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "panelViewCustomerQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "individualByAccountId",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "details",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceCustomDetailValue",
                                                            "kind": "LinkedField",
                                                            "name": "results",
                                                            "plural": true,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "values"
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailType",
                                                                    "kind": "LinkedField",
                                                                    "name": "type",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "options"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "config",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                                                            "kind": "LinkedField",
                                                                            "name": "styleConfiguration",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "options",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "optionValue"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "style",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "backgroundColour"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "includePlatformValue",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "platformValue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v6 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "accountId"
                                                                                        },
                                                                                        v8 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "avatarUrl"
                                                                                        }
                                                                                    ],
                                                                                    "type": "CustomerServiceUserDetailValue"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "CustomerServiceCustomDetailValues"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "useReporterOrganizations",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "CustomerServiceOrganization",
                                                    "kind": "LinkedField",
                                                    "name": "organizations",
                                                    "plural": true,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceIndividual"
                                },
                                v9 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "54bfe96301c1e26557f8caec2c6c4df8f8f9b53d157940c33ae90afa703558cd",
            "metadata": {},
            "name": "panelViewCustomerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e075ed440bbf28d4$var$node.hash = "58c64706ac233dec992b52ce06d844ce";
var $e075ed440bbf28d4$export$2e2bcd8739ae039 = $e075ed440bbf28d4$var$node;

});

parcelRegister("6uuIf", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $01b6db3008f03519$export$2e0a83ec2e27ecbb);
$parcel$export(module.exports, "Header", () => $01b6db3008f03519$export$8b251419efc915eb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2fy56 = parcelRequire("2fy56");

var $7JmTk = parcelRequire("7JmTk");
const $01b6db3008f03519$export$2e0a83ec2e27ecbb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "hr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _19ith6cr _n7zlglyw _18s81yj3",
            __cmplp.className
        ])
    });
});
const $01b6db3008f03519$export$8b251419efc915eb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _154i1b66 _19pk1b66 _otyrv77o _11c81vlj _syaz1rc1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2fy56", function(module, exports) {

$parcel$export(module.exports, "DetailsView", () => $46dee499ce789a67$export$9e4341e656034b31);

var $bmBH5 = parcelRequire("bmBH5");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $kdPjr = parcelRequire("kdPjr");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $acemj = parcelRequire("acemj");

var $6A4RB = parcelRequire("6A4RB");

var $c7H0g = parcelRequire("c7H0g");

var $6Qy8u = parcelRequire("6Qy8u");

var $4tsLS = parcelRequire("4tsLS");
const $46dee499ce789a67$export$9e4341e656034b31 = ({ entityType: entityType, editDetailsUrl: editDetailsUrl, details: details, entityExperience: entityExperience })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isJiraAdmin = (0, $c7H0g.useIsAdmin)();
    const isCompact = (0, $eUqFw.useContext)((0, $kdPjr.FieldsCompactModeContext));
    const data = (0, $iWLL0.useFragment)((0, $bmBH5.default), details);
    (0, $eUqFw.useEffect)(()=>{
        if (data.__typename === 'CustomerServiceCustomDetailValues') (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueViewCustomerContextExpand loaded', {
            entityType: entityType,
            numberOfCsmDetails: data.results?.length || 0,
            isJiraAdmin: isJiraAdmin
        });
    }, [
        entityType,
        createAnalyticsEvent,
        isJiraAdmin,
        data
    ]);
    if (data.__typename !== 'CustomerServiceCustomDetailValues') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $acemj.ThrowOnQueryError), {
        operationName: "customDetails_servicedeskCustomerServiceIssueViewPanel",
        errorRef: data.__typename === 'QueryError' ? data : undefined
    });
    const { results: results } = data;
    if (results.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4tsLS.EmptyState), {
        context: entityType,
        detailsUrl: editDetailsUrl,
        entityExperience: entityExperience
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $46dee499ce789a67$var$wrapperStyles,
            isCompact && $46dee499ce789a67$var$wrapperCompactStyles
        ]
    }, results.map((customDetailRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6A4RB.ReadOnlyCustomDetail), {
            key: customDetailRef.id,
            customDetailRef: customDetailRef,
            isInline: !isCompact
        })), entityExperience && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Qy8u.ExperienceSuccess), {
        experience: entityExperience
    }));
};
const $46dee499ce789a67$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.050'
});
const $46dee499ce789a67$var$wrapperCompactStyles = (0, $1ZAYh.xcss)({
    gap: 'space.100'
});

});
parcelRegister("bmBH5", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa6f02e8c8530e72$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<81ce581dafb8f67353592dd880fae615>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aa6f02e8c8530e72$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includePlatformValue"
        }
    ],
    "kind": "Fragment",
    "name": "detailsView_servicedeskCustomerServiceIssueViewPanel",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "CustomerServiceCustomDetailValue",
                    "kind": "LinkedField",
                    "name": "results",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "includePlatformValue",
                                    "variableName": "includePlatformValue"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "readOnlyCustomDetail_servicedeskCustomerServiceCustomDetails"
                        }
                    ]
                }
            ],
            "type": "CustomerServiceCustomDetailValues"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                }
            ],
            "type": "QueryError"
        }
    ],
    "type": "CustomerServiceCustomDetailValuesQueryResult",
    "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
};
$aa6f02e8c8530e72$var$node.hash = "48059be6a981b36aeaa290bbf33089ae";
var $aa6f02e8c8530e72$export$2e2bcd8739ae039 = $aa6f02e8c8530e72$var$node;

});

parcelRegister("acemj", function(module, exports) {

$parcel$export(module.exports, "ThrowOnQueryError", () => $2e819f417f46b9ab$export$492fe7d3c1990b95);

var $3eluF = parcelRequire("3eluF");

var $iWLL0 = parcelRequire("iWLL0");
const $2e819f417f46b9ab$export$492fe7d3c1990b95 = ({ operationName: operationName, errorRef: errorRef })=>{
    if (!errorRef) throw new Error(`${operationName}: unexpected typename returned`);
    const { identifier: identifier, message: message, extensions: extensions } = (0, $iWLL0.useFragment)((0, $3eluF.default), errorRef);
    throw new Error(`${operationName}: QueryError; ${JSON.stringify({
        identifier: identifier,
        message: message,
        extensions: extensions
    })}`);
};

});
parcelRegister("3eluF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c12eaeb23be3537$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca329ec06912ae2f0f17db58b630d34c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3c12eaeb23be3537$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "throwOnQueryError_servicedeskCustomerServiceCommon",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "identifier"
        },
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                },
                {
                    "kind": "ScalarField",
                    "name": "errorType"
                }
            ]
        }
    ],
    "type": "QueryError"
};
$3c12eaeb23be3537$var$node.hash = "fa4d32afd4039279d9b1db3545b08588";
var $3c12eaeb23be3537$export$2e2bcd8739ae039 = $3c12eaeb23be3537$var$node;

});


parcelRegister("6A4RB", function(module, exports) {

$parcel$export(module.exports, "ReadOnlyCustomDetail", () => $3f3954079681e10f$export$271d5cc2a91d6f2);

var $1KnKo = parcelRequire("1KnKo");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $8dsLT = parcelRequire("8dsLT");parcelRequire("cwxp5");
var $918ur = parcelRequire("918ur");parcelRequire("25tGU");
var $f8uTO = parcelRequire("f8uTO");parcelRequire("iBREc");
var $7UJWx = parcelRequire("7UJWx");parcelRequire("eWRi7");
var $a713z = parcelRequire("a713z");parcelRequire("9f9QH");
var $gtxgy = parcelRequire("gtxgy");parcelRequire("9qY2o");
var $kLZra = parcelRequire("kLZra");parcelRequire("kZjJO");
var $7pphk = parcelRequire("7pphk");parcelRequire("i9Nba");
var $6agHN = parcelRequire("6agHN");parcelRequire("4H6vd");
var $d5isU = parcelRequire("d5isU");

var $8ihDs = parcelRequire("8ihDs");
const $3f3954079681e10f$export$271d5cc2a91d6f2 = ({ customDetailRef: customDetailRef, isInline: isInline, popup: popup, Layout: Layout = (0, $8ihDs.DefaultLayout), testId: testId })=>{
    const data = (0, $iWLL0.useFragment)((0, $1KnKo.default), customDetailRef);
    const { name: name, value: value, values: values, type: type, config: config } = data;
    const CustomDetailField = (0, $eUqFw.useMemo)(()=>{
        if (type.name === 'USER' && !(0, $1ybV0.ff)('csm-shipit-58-user-custom-detail-type_be1zw')) return null;
        switch(type.name){
            case 'TEXT':
                return 0, $7pphk.TextFieldReadView;
            case 'NUMBER':
                return 0, $a713z.NumberFieldReadView;
            case 'EMAIL':
                return 0, $f8uTO.EmailFieldReadView;
            case 'URL':
                return 0, $6agHN.UrlFieldReadView;
            case 'DATE':
                return 0, $918ur.DateFieldReadView;
            case 'PHONE':
                return 0, $gtxgy.PhoneNumberFieldReadView;
            case 'BOOLEAN':
                return 0, $8dsLT.BooleanFieldReadView;
            case 'SELECT':
                return 0, $kLZra.SingleSelectFieldReadView;
            case 'MULTISELECT':
                return 0, $7UJWx.MultiSelectFieldReadView;
            case 'USER':
                return 0, $d5isU.UserFieldReadView;
            default:
                return null;
        }
    }, [
        type.name
    ]);
    if (!CustomDetailField) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    const formattedOptions = type.options?.map((option)=>{
        const color = config?.styleConfiguration?.options?.find(({ optionValue: optionValue })=>optionValue === option)?.style?.backgroundColour;
        return {
            label: option,
            value: option,
            color: color
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Layout, {
        isInline: isInline,
        popup: popup,
        label: name,
        testId: testId
    }, ({ getValueContainer: getValueContainer })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CustomDetailField, {
            value: value,
            values: values,
            userFieldRef: data,
            formattedOptions: formattedOptions,
            getValueContainer: getValueContainer
        }));
};

});
parcelRegister("1KnKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b65cc583920fdd34$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<812ecb8fd609d37c37d7d7ba809f8c28>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b65cc583920fdd34$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "includePlatformValue"
            }
        ],
        "kind": "Fragment",
        "name": "readOnlyCustomDetail_servicedeskCustomerServiceCustomDetails",
        "selections": [
            {
                "kind": "RequiredField",
                "field": v0 /*: any*/ ,
                "action": "THROW",
                "path": "name"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            },
            {
                "kind": "ScalarField",
                "name": "values"
            },
            {
                "concreteType": "CustomerServiceCustomDetailType",
                "kind": "LinkedField",
                "name": "type",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": v0 /*: any*/ ,
                        "action": "THROW",
                        "path": "type.name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "options"
                    }
                ]
            },
            {
                "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                "kind": "LinkedField",
                "name": "config",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                        "kind": "LinkedField",
                        "name": "styleConfiguration",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                "kind": "LinkedField",
                                "name": "options",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionValue"
                                    },
                                    {
                                        "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                        "kind": "LinkedField",
                                        "name": "style",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "backgroundColour"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "includePlatformValue",
                        "variableName": "includePlatformValue"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "readViewUserField_servicedeskCustomerServiceCustomDetails"
            }
        ],
        "type": "CustomerServiceCustomDetailValue"
    };
}();
$b65cc583920fdd34$var$node.hash = "94616690cd2492225f71e515f870f177";
var $b65cc583920fdd34$export$2e2bcd8739ae039 = $b65cc583920fdd34$var$node;

});

parcelRegister("8dsLT", function(module, exports) {

$parcel$export(module.exports, "BooleanFieldReadView", () => $28c6735ec0d77d74$export$798fe51ed6c338e8);

var $eUqFw = parcelRequire("eUqFw");

var $bT7k5 = parcelRequire("bT7k5");
const $28c6735ec0d77d74$export$798fe51ed6c338e8 = ({ value: value, render: render, getValueContainer: getValueContainer, inInlineEdit: inInlineEdit })=>{
    const ValueContainer = getValueContainer();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ValueContainer, {
        render: render || (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
                isChecked: value === 'true'
            })),
        noBorder: inInlineEdit
    });
};

});

parcelRegister("cwxp5", function(module, exports) {

$parcel$export(module.exports, "DateField", () => $6d80628a474715d4$export$d9781c7894a82487);
$parcel$export(module.exports, "DateFieldReadView", () => (parcelRequire("918ur")).DateFieldReadView);

var $eUqFw = parcelRequire("eUqFw");

var $1iSiO = parcelRequire("1iSiO");

var $5i12b = parcelRequire("5i12b");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $4xHig = parcelRequire("4xHig");

var $cdoT9 = parcelRequire("cdoT9");

var $imJvt = parcelRequire("imJvt");

var $dXhzi = parcelRequire("dXhzi");

var $918ur = parcelRequire("918ur");
const $6d80628a474715d4$export$d9781c7894a82487 = ({ id: id, label: label, value: value, onChange: onChange, getValueContainer: getValueContainer })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isEditing, setIsEditing] = (0, $eUqFw.useState)(false);
    const [currentValue, setCurrentValue] = (0, $eUqFw.useState)(value || '');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const locale = (0, $4xHig.useLocale)();
    const valueForAriaLabel = value || formatMessage((0, $cdoT9.default).noValue);
    (0, $eUqFw.useEffect)(()=>{
        setCurrentValue(()=>value || '');
    }, [
        value
    ]);
    const onChangeWithAnalytics = (newValue)=>{
        if (newValue === value) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dateFieldType'
        });
        onChange({
            value: newValue
        }, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $imJvt.InlineEditContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i12b.default), {
        defaultValue: undefined,
        editButtonLabel: formatMessage((0, $cdoT9.default).editButtonLabel, {
            label: label,
            value: valueForAriaLabel
        }),
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $6d80628a474715d4$var$containerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iSiO.default), {
                ...fieldProps,
                id: id,
                value: currentValue,
                locale: locale,
                onChange: (newValue)=>{
                    setCurrentValue(()=>newValue);
                    onChangeWithAnalytics(newValue);
                },
                spacing: "compact",
                isOpen: isEditing,
                formatDisplayLabel: (v, _)=>formatDate(v),
                onBlur: ()=>setIsEditing(false),
                autoFocus: true,
                placeholder: formatMessage((0, $dXhzi.default).none)
            })),
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $918ur.DateFieldReadView), {
                value: value,
                getValueContainer: getValueContainer,
                inInlineEdit: true
            }),
        readViewFitContainerWidth: true,
        isEditing: isEditing,
        onEdit: ()=>setIsEditing(true),
        hideActionButtons: true,
        onConfirm: ()=>setIsEditing(false)
    }));
};
const $6d80628a474715d4$var$containerStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.negative.025'
});

});
parcelRegister("cdoT9", function(module, exports) {

$parcel$export(module.exports, "default", () => $10f907ecf88062c9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $10f907ecf88062c9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    editButtonLabel: {
        "id": "servicedesk-customer-service-custom-details.common.field.edit-button-label",
        "defaultMessage": "{label}, {value}, select to edit"
    },
    noValue: {
        "id": "servicedesk-customer-service-custom-details.common.field.no-value",
        "defaultMessage": "no value entered"
    }
});

});

parcelRegister("imJvt", function(module, exports) {

$parcel$export(module.exports, "InlineEditContainer", () => $b4dc7e33913c0985$export$9f16bbb9a44c7bf6);
$parcel$export(module.exports, "CheckboxContainer", () => $b4dc7e33913c0985$export$be6fcc6a7e078caa);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $bAQOb = parcelRequire("bAQOb");
const $b4dc7e33913c0985$export$b04be29aa201d4f5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _k48pni7l _1wyb1crf _1i4qfg65",
            __cmplp.className
        ])
    });
});
const $b4dc7e33913c0985$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isInline: isInline, isCheckbox: isCheckbox, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_383es": (0, $9t7rW.default)((()=>{
                let result;
                if (__cmplp.isCheckbox) result = "var(--ds-space-100, 8px)";
                if (__cmplp.isInline) result = "var(--ds-space-200, 16px)";
                return result;
            })())
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _4cvr1h6o _zulp1ejt",
            __cmplp.isInline && "_yv0e1ewe",
            __cmplp.className
        ])
    });
});
const $b4dc7e33913c0985$export$4a6154d13b19148e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8y0tw _vwz4gktf _hpvwidpf",
            __cmplp.className
        ])
    });
});
const $b4dc7e33913c0985$export$5a31b2ecc600b002 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4gktf _hpvwidpf",
            __cmplp.className
        ])
    });
});
const $b4dc7e33913c0985$export$9f16bbb9a44c7bf6 = (0, $bAQOb.componentWithFF)('products-and-entitlements-details-m2_45b1j', $b4dc7e33913c0985$export$5a31b2ecc600b002, $b4dc7e33913c0985$export$4a6154d13b19148e);
const $b4dc7e33913c0985$export$80524f29eebbc409 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s83l1n",
            __cmplp.className
        ])
    });
});
const $b4dc7e33913c0985$export$b28b5de0ab7c770a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8otz2",
            __cmplp.className
        ])
    });
});
const $b4dc7e33913c0985$export$be6fcc6a7e078caa = (0, $bAQOb.componentWithFF)('products-and-entitlements-details-m2_45b1j', $b4dc7e33913c0985$export$b28b5de0ab7c770a, $b4dc7e33913c0985$export$80524f29eebbc409);

});

parcelRegister("dXhzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $be20bf45c3c9beda$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $be20bf45c3c9beda$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    none: {
        "id": "servicedesk-customer-service-custom-details.common.field.value-container.none",
        "defaultMessage": "None"
    }
});

});

parcelRegister("918ur", function(module, exports) {

$parcel$export(module.exports, "DateFieldReadView", () => $cf9b3a6060fb648d$export$5b4bee05cbcd0422);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7pphk = parcelRequire("7pphk");
const $cf9b3a6060fb648d$export$5b4bee05cbcd0422 = ({ value: value, render: render, getValueContainer: getValueContainer, inInlineEdit: inInlineEdit })=>{
    const { formatDate: formatDate } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7pphk.TextFieldReadView), {
        getValueContainer: getValueContainer,
        render: render,
        value: value ? formatDate(value) : null,
        inInlineEdit: inInlineEdit
    });
};

});
parcelRegister("7pphk", function(module, exports) {

$parcel$export(module.exports, "TextFieldReadView", () => $47b9b255d95e3217$export$20fc20fb93c0a9fc);

var $eUqFw = parcelRequire("eUqFw");
const $47b9b255d95e3217$export$20fc20fb93c0a9fc = ({ value: value, render: render, getValueContainer: getValueContainer, inInlineEdit: inInlineEdit })=>{
    const ValueContainer = getValueContainer();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ValueContainer, {
        render: render || (()=>value),
        noBorder: inInlineEdit
    });
};

});



parcelRegister("25tGU", function(module, exports) {

$parcel$export(module.exports, "EmailField", () => $4f1a3a759a993392$export$e78a688765264a0);
$parcel$export(module.exports, "EmailFieldReadView", () => (parcelRequire("f8uTO")).EmailFieldReadView);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kZjJO = parcelRequire("kZjJO");

var $f8uTO = parcelRequire("f8uTO");

var $a0xQ9 = parcelRequire("a0xQ9");
const $4f1a3a759a993392$export$e78a688765264a0 = ({ id: id, label: label, value: value, onChange: onChange, isInline: isInline, getValueContainer: getValueContainer })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZjJO.TextField), {
        id: id,
        label: label,
        value: value,
        onChange: onChange,
        validate: (0, $a0xQ9.validate)(formatMessage),
        isInline: isInline,
        getValueContainer: getValueContainer,
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8uTO.EmailFieldReadView), {
                value: value,
                getValueContainer: getValueContainer,
                inInlineEdit: true
            })
    });
};

});
parcelRegister("kZjJO", function(module, exports) {

$parcel$export(module.exports, "TextField", () => $6dc07f6765e3107a$export$2c73285ae9390cec);
$parcel$export(module.exports, "TextFieldReadView", () => (parcelRequire("7pphk")).TextFieldReadView);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $96IgR = parcelRequire("96IgR");

var $29yDk = parcelRequire("29yDk");

var $5i12b = parcelRequire("5i12b");

var $cf2Y4 = parcelRequire("cf2Y4");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cdoT9 = parcelRequire("cdoT9");

var $imJvt = parcelRequire("imJvt");


var $7pphk = parcelRequire("7pphk");
const $6dc07f6765e3107a$export$2c73285ae9390cec = ({ id: id, label: label, value: value, onChange: onChange, validate: validate, readView: readView, isInline: isInline, getValueContainer: getValueContainer, ...inputProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [currentValue, setCurrentValue] = (0, $eUqFw.useState)(value || '');
    const valueForAriaLabel = value || formatMessage((0, $cdoT9.default).noValue);
    const onConfirmWithChange = (newValue, analyticsEvent)=>{
        const newValueTrimmed = newValue.trim();
        if (value === null && newValueTrimmed === '') return;
        if (newValueTrimmed === value) return;
        onChange({
            value: newValueTrimmed
        }, analyticsEvent);
    };
    (0, $eUqFw.useEffect)(()=>{
        setCurrentValue(()=>value || '');
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $imJvt.InlineEditContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i12b.default), {
        defaultValue: undefined,
        editButtonLabel: formatMessage((0, $cdoT9.default).editButtonLabel, {
            label: label,
            value: valueForAriaLabel
        }),
        validate: validate,
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
                isOpen: fieldProps.isInvalid,
                content: errorMessage,
                placement: "right"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                type: "text",
                ...fieldProps,
                id: id,
                value: currentValue,
                onChange: (event)=>{
                    const newValue = event.currentTarget.value;
                    setCurrentValue(()=>newValue);
                    fieldProps.onChange(newValue);
                },
                onBlur: ()=>{
                    setCurrentValue(()=>currentValue);
                    fieldProps.onChange(currentValue);
                    fieldProps.onBlur();
                },
                autoFocus: true,
                isCompact: true,
                maxLength: (0, $1ybV0.ff)('jsm-csm-public-api-prerequisite-improvements_4obdb') ? (0, $193113a3aeeb11cc$export$a78a6801bd89727e) : (0, $193113a3aeeb11cc$export$6bf4f139c1f7a09e),
                elemAfterInput: fieldProps.isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6dc07f6765e3107a$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                    label: "",
                    primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA).R400})`
                })),
                testId: "servicedesk-customer-service-custom-details.common.ui.field.text-field",
                ...inputProps
            }))),
        readView: readView || (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7pphk.TextFieldReadView), {
                value: value,
                getValueContainer: getValueContainer,
                inInlineEdit: true
            })),
        onConfirm: onConfirmWithChange,
        readViewFitContainerWidth: true
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6dc07f6765e3107a$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f312x7 _vwz41osq",
            __cmplp.className
        ])
    });
});

});
const $193113a3aeeb11cc$export$6bf4f139c1f7a09e = 254;
const $193113a3aeeb11cc$export$a78a6801bd89727e = 255;


parcelRegister("f8uTO", function(module, exports) {

$parcel$export(module.exports, "EmailFieldReadView", () => $868bdea3d9afc599$export$556052dcdd390283);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7pphk = parcelRequire("7pphk");
const $868bdea3d9afc599$export$556052dcdd390283 = ({ render: render, value: value, getValueContainer: getValueContainer, inInlineEdit: inInlineEdit })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7pphk.TextFieldReadView), {
        getValueContainer: getValueContainer,
        render: render || (()=>{
            if (value) {
                if ((0, $1ybV0.ff)('products-and-entitlements-details-m2_45b1j')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    href: `mailto:${value}`,
                    onClick: ()=>{
                        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'customDetailFieldLink clicked', {
                            fieldType: 'EMAIL'
                        });
                    }
                }, value);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    href: `mailto:${value}`
                }, value);
            }
            return null;
        }),
        inInlineEdit: inInlineEdit
    });
};

});

parcelRegister("a0xQ9", function(module, exports) {

$parcel$export(module.exports, "validate", () => $7aac68525be64793$export$a22775fa5e2eebd9);

var $8FLAz = parcelRequire("8FLAz");
const $7aac68525be64793$var$isValidEmailAddress = (email)=>{
    if (!email || typeof email !== 'string') return false;
    return /\S+@\S+\.\S+/.test(email);
};
const $7aac68525be64793$export$a22775fa5e2eebd9 = (formatMessage)=>(currentValue)=>{
        if (currentValue === '') return undefined;
        if (!$7aac68525be64793$var$isValidEmailAddress(currentValue)) return formatMessage((0, $8FLAz.default).invalidEmail);
        return undefined;
    };

});
parcelRegister("8FLAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $59905823274979c2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $59905823274979c2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    invalidEmail: {
        "id": "servicedesk-customer-service-custom-details.common.field.email-field.invalid-email",
        "defaultMessage": "Enter an email address with the format: name@example.com"
    }
});

});



parcelRegister("iBREc", function(module, exports) {

$parcel$export(module.exports, "MultiSelectField", () => $3c1ee3ff08d392d3$export$4efd8d874a0cb609);
$parcel$export(module.exports, "MultiSelectFieldReadView", () => (parcelRequire("7UJWx")).MultiSelectFieldReadView);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6GOwE = parcelRequire("6GOwE");

var $9A7ix = parcelRequire("9A7ix");

var $h42zU = parcelRequire("h42zU");

var $7UJWx = parcelRequire("7UJWx");
const $3c1ee3ff08d392d3$export$4efd8d874a0cb609 = ({ id: id, label: label, values: values, options: options, formattedOptions: formattedOptions, onChange: onChange, isInline: isInline, getValueContainer: getValueContainer })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const palette = (0, $6GOwE.getColorPickerPalette)(formatMessage);
    const mappedOptions = options?.map((value)=>({
            value: value,
            label: value
        })) || [];
    const selectedOption = (0, $1ybV0.ff)('shipit-58-colours-for-detail-fields-in-csm_i6j6e') ? values?.map((value)=>formattedOptions?.find((option)=>option.value === value)).filter(Boolean) || [] : mappedOptions.filter((option)=>values?.includes(option.value));
    const onSelection = (selectedOptions, analyticsEvent)=>{
        const selectedValues = selectedOptions?.map((option)=>option.value) || [];
        if (values?.join(',') === selectedValues.join(',')) return;
        onChange({
            values: selectedValues
        }, analyticsEvent);
    };
    const selectViewStyles = {
        multiValueLabel: (base, { data: data })=>({
                ...base,
                borderTopRightRadius: '0',
                borderBottomRightRadius: '0',
                backgroundColor: palette.find((c)=>c.tag === data.color)?.value
            }),
        multiValueRemove: (base, { data: data })=>({
                ...base,
                backgroundColor: data.color && palette.find((c)=>c.tag === data.color)?.value
            })
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9A7ix.SelectFieldView), {
        isMulti: true,
        id: id,
        label: label,
        closeMenuOnSelect: false,
        blurInputOnSelect: false,
        value: selectedOption,
        valueAsString: values?.join(', '),
        options: (0, $1ybV0.ff)('shipit-58-colours-for-detail-fields-in-csm_i6j6e') ? formattedOptions : mappedOptions,
        styles: (0, $1ybV0.ff)('shipit-58-colours-for-detail-fields-in-csm_i6j6e') ? selectViewStyles : undefined,
        components: (0, $1ybV0.ff)('shipit-58-colours-for-detail-fields-in-csm_i6j6e') ? {
            Option: (0, $h42zU.OptionView)
        } : undefined,
        onSelection: onSelection,
        isInline: isInline,
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7UJWx.MultiSelectFieldReadView), {
                values: values,
                formattedOptions: formattedOptions,
                getValueContainer: getValueContainer,
                inInlineEdit: true
            })
    });
};

});
parcelRegister("6GOwE", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COLOR", () => $c205aedb0e5bf7d6$export$37394b0fa44b998c);
$parcel$export(module.exports, "getTagColor", () => $c205aedb0e5bf7d6$export$5910fd8d2076e68);
$parcel$export(module.exports, "getColorValue", () => $c205aedb0e5bf7d6$export$50c120d4d5566287);
$parcel$export(module.exports, "getColorPickerPalette", () => $c205aedb0e5bf7d6$export$f7ab5913bb87de67);
$parcel$export(module.exports, "getColorTag", () => $c205aedb0e5bf7d6$export$67999c792426c974);
$parcel$export(module.exports, "getRandomColor", () => $c205aedb0e5bf7d6$export$e4369cabd7e84cd9);

var $kcMGw = parcelRequire("kcMGw");
const $c205aedb0e5bf7d6$export$37394b0fa44b998c = 'greyLight';
const $c205aedb0e5bf7d6$var$DEFAULT_COLOR_VALUE = "var(--ds-background-accent-gray-subtler, #EBECF0)";
const $c205aedb0e5bf7d6$var$availableColours = [
    'redLight',
    'orangeLight',
    'yellowLight',
    'greenLight',
    'blueLight',
    'purpleLight',
    $c205aedb0e5bf7d6$export$37394b0fa44b998c,
    'red',
    'orange',
    'yellow',
    'green',
    'blue',
    'purple',
    'grey'
];
const $c205aedb0e5bf7d6$export$5910fd8d2076e68 = (color)=>color && $c205aedb0e5bf7d6$var$availableColours.find((c)=>c === color) || 'greyLight';
const $c205aedb0e5bf7d6$export$50c120d4d5566287 = (formatMessage, colorTag)=>{
    const colorPalette = $c205aedb0e5bf7d6$export$f7ab5913bb87de67(formatMessage);
    const selectedColor = colorPalette.find((c)=>c.tag === colorTag);
    return selectedColor ? selectedColor.value : $c205aedb0e5bf7d6$var$DEFAULT_COLOR_VALUE;
};
const $c205aedb0e5bf7d6$export$67999c792426c974 = (formatMessage, colorValue)=>{
    const colorPalette = $c205aedb0e5bf7d6$export$f7ab5913bb87de67(formatMessage);
    const selectedColor = colorPalette.find((c)=>c.value === colorValue);
    return selectedColor ? selectedColor.tag : $c205aedb0e5bf7d6$export$37394b0fa44b998c;
};
const $c205aedb0e5bf7d6$export$e4369cabd7e84cd9 = (formatMessage)=>{
    const colorPalette = $c205aedb0e5bf7d6$export$f7ab5913bb87de67(formatMessage);
    const randomColor = colorPalette[Math.floor(Math.random() * colorPalette.length)];
    return randomColor;
};
const $c205aedb0e5bf7d6$export$f7ab5913bb87de67 = (formatMessage)=>[
        {
            label: formatMessage((0, $kcMGw.default).lightRed),
            value: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            tag: 'redLight'
        },
        {
            label: formatMessage((0, $kcMGw.default).lightOrange),
            value: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
            tag: 'orangeLight'
        },
        {
            label: formatMessage((0, $kcMGw.default).lightYellow),
            value: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            tag: 'yellowLight'
        },
        {
            label: formatMessage((0, $kcMGw.default).lightGreen),
            value: "var(--ds-background-accent-green-subtler, #BAF3DB)",
            tag: 'greenLight'
        },
        {
            label: formatMessage((0, $kcMGw.default).lightBlue),
            value: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
            tag: 'blueLight'
        },
        {
            label: formatMessage((0, $kcMGw.default).lightPurple),
            value: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
            tag: 'purpleLight'
        },
        {
            label: formatMessage((0, $kcMGw.default).lightGrey),
            value: $c205aedb0e5bf7d6$var$DEFAULT_COLOR_VALUE,
            tag: $c205aedb0e5bf7d6$export$37394b0fa44b998c
        },
        {
            label: formatMessage((0, $kcMGw.default).red),
            value: "var(--ds-background-accent-red-subtle, #F87168)",
            tag: 'red'
        },
        {
            label: formatMessage((0, $kcMGw.default).orange),
            value: "var(--ds-background-accent-orange-subtle, #FEA362)",
            tag: 'orange'
        },
        {
            label: formatMessage((0, $kcMGw.default).yellow),
            value: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
            tag: 'yellow'
        },
        {
            label: formatMessage((0, $kcMGw.default).green),
            value: "var(--ds-background-accent-green-subtle, #4BCE97)",
            tag: 'green'
        },
        {
            label: formatMessage((0, $kcMGw.default).blue),
            value: "var(--ds-background-accent-blue-subtle, #579DFF)",
            tag: 'blue'
        },
        {
            label: formatMessage((0, $kcMGw.default).purple),
            value: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
            tag: 'purple'
        },
        {
            label: formatMessage((0, $kcMGw.default).grey),
            value: "var(--ds-background-accent-gray-subtle, #8590A2)",
            tag: 'grey'
        }
    ];

});
parcelRegister("kcMGw", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c071128cc5fe53$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $34c071128cc5fe53$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    lightRed: {
        "id": "servicedesk-customer-service-common.color-picker-palette.light-red",
        "defaultMessage": "Light red"
    },
    lightOrange: {
        "id": "servicedesk-customer-service-common.color-picker-palette.light-orange",
        "defaultMessage": "Light orange"
    },
    lightYellow: {
        "id": "servicedesk-customer-service-common.color-picker-palette.light-yellow",
        "defaultMessage": "Light yellow"
    },
    lightGreen: {
        "id": "servicedesk-customer-service-common.color-picker-palette.light-green",
        "defaultMessage": "Light green"
    },
    lightBlue: {
        "id": "servicedesk-customer-service-common.color-picker-palette.light-blue",
        "defaultMessage": "Light blue"
    },
    lightPurple: {
        "id": "servicedesk-customer-service-common.color-picker-palette.light-purple",
        "defaultMessage": "Light purple"
    },
    lightGrey: {
        "id": "servicedesk-customer-service-common.color-picker-palette.light-grey",
        "defaultMessage": "Light grey"
    },
    red: {
        "id": "servicedesk-customer-service-common.color-picker-palette.red",
        "defaultMessage": "Red"
    },
    orange: {
        "id": "servicedesk-customer-service-common.color-picker-palette.orange",
        "defaultMessage": "Orange"
    },
    yellow: {
        "id": "servicedesk-customer-service-common.color-picker-palette.yellow",
        "defaultMessage": "Yellow"
    },
    green: {
        "id": "servicedesk-customer-service-common.color-picker-palette.green",
        "defaultMessage": "Green"
    },
    blue: {
        "id": "servicedesk-customer-service-common.color-picker-palette.blue",
        "defaultMessage": "Blue"
    },
    purple: {
        "id": "servicedesk-customer-service-common.color-picker-palette.purple",
        "defaultMessage": "Purple"
    },
    grey: {
        "id": "servicedesk-customer-service-common.color-picker-palette.grey",
        "defaultMessage": "Grey"
    }
});

});


parcelRegister("9A7ix", function(module, exports) {

$parcel$export(module.exports, "SelectFieldView", () => $2d786a60a9c7dab2$export$2073539080b8c707);

var $eUqFw = parcelRequire("eUqFw");

var $5i12b = parcelRequire("5i12b");

var $4zgIJ = parcelRequire("4zgIJ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $cdoT9 = parcelRequire("cdoT9");

var $imJvt = parcelRequire("imJvt");
function $2d786a60a9c7dab2$export$2073539080b8c707({ id: id, value: value, valueAsString: valueAsString, label: label, onSelection: onSelection, readView: readView, closeMenuOnSelect: closeMenuOnSelect = true, ...etc }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isEditing, setIsEditing] = (0, $eUqFw.useState)(false);
    const [currentValue, setCurrentValue] = (0, $eUqFw.useState)(value);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const valueForAriaLabel = valueAsString || formatMessage((0, $cdoT9.default).noValue);
    const onSelectOptionWithAnalytics = (selectedValue)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'selectOption'
        });
        onSelection(selectedValue, analyticsEvent);
    };
    (0, $eUqFw.useEffect)(()=>{
        setCurrentValue(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $imJvt.InlineEditContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i12b.default), {
        isEditing: isEditing,
        defaultValue: undefined,
        editButtonLabel: formatMessage((0, $cdoT9.default).editButtonLabel, {
            label: label,
            value: valueForAriaLabel
        }),
        hideActionButtons: true,
        onEdit: ()=>{
            setIsEditing(true);
        },
        editView: (fieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), {
                ...fieldProps,
                ...etc,
                inputId: id,
                value: currentValue,
                closeMenuOnSelect: closeMenuOnSelect,
                onChange: (newValue)=>{
                    setCurrentValue(newValue);
                    if (closeMenuOnSelect) onSelectOptionWithAnalytics(newValue);
                },
                spacing: "compact",
                isClearable: true,
                autoFocus: true,
                openMenuOnFocus: true,
                onMenuClose: ()=>{
                    if (!closeMenuOnSelect) onSelectOptionWithAnalytics(currentValue);
                    setIsEditing(false);
                }
            }),
        // handled by select
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onConfirm: ()=>{},
        readViewFitContainerWidth: true,
        readView: readView
    }));
}

});

parcelRegister("h42zU", function(module, exports) {

$parcel$export(module.exports, "OptionView", () => $17a340f5571b1ba4$export$36d2e8e15c574765);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $9jNAz = parcelRequire("9jNAz");

var $6GOwE = parcelRequire("6GOwE");
const $17a340f5571b1ba4$export$36d2e8e15c574765 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        testId: "servicedesk-customer-service-custom-details.common.ui.field.select-field.multi.option-view.tag",
        text: props.data.label,
        color: (0, $6GOwE.getTagColor)(props.data.color)
    }));

});

parcelRegister("7UJWx", function(module, exports) {

$parcel$export(module.exports, "MultiSelectFieldReadView", () => $0b471e2aebac57dd$export$469b0a8fa5c6c8b4);

var $eUqFw = parcelRequire("eUqFw");

var $9jNAz = parcelRequire("9jNAz");

var $cAKIH = parcelRequire("cAKIH");

var $1ybV0 = parcelRequire("1ybV0");

var $6GOwE = parcelRequire("6GOwE");
const $0b471e2aebac57dd$export$469b0a8fa5c6c8b4 = ({ render: render, values: values, formattedOptions: formattedOptions, getValueContainer: getValueContainer, inInlineEdit: inInlineEdit })=>{
    const ValueContainer = getValueContainer();
    const formattedValues = values?.map((value)=>{
        const formattedValue = formattedOptions?.find((option)=>option.value === value);
        return {
            label: value,
            color: (0, $6GOwE.getTagColor)(formattedValue?.color)
        };
    }) ?? [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ValueContainer, {
        noVerticalPaddingWhenNotEmpty: true,
        render: render || (()=>{
            if (!values || !values?.length) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cAKIH.default), null, (0, $1ybV0.ff)('shipit-58-colours-for-detail-fields-in-csm_i6j6e') ? formattedValues.map((value, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
                    text: value.label,
                    key: i,
                    color: value.color,
                    testId: "servicedesk-customer-service-custom-details.common.ui.field.select-field.multi.read-view.multi-select-field-read-view-tag"
                })) : values?.map((value, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
                    text: value,
                    key: i,
                    color: "greyLight"
                })));
        }),
        noBorder: inInlineEdit
    });
};

});


parcelRegister("eWRi7", function(module, exports) {

$parcel$export(module.exports, "NumberField", () => $24549e738ca9d559$export$63c5fa0b2fdccd2e);
$parcel$export(module.exports, "NumberFieldReadView", () => (parcelRequire("a713z")).NumberFieldReadView);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kZjJO = parcelRequire("kZjJO");

var $a713z = parcelRequire("a713z");

var $iAUwZ = parcelRequire("iAUwZ");
const $24549e738ca9d559$export$63c5fa0b2fdccd2e = ({ id: id, label: label, value: value, onChange: onChange, isInline: isInline, getValueContainer: getValueContainer })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZjJO.TextField), {
        id: id,
        type: "number",
        step: "any",
        label: label,
        value: value,
        onChange: onChange,
        validate: (0, $iAUwZ.validate)(formatMessage),
        isInline: isInline,
        getValueContainer: getValueContainer,
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a713z.NumberFieldReadView), {
                value: value,
                getValueContainer: getValueContainer,
                inInlineEdit: true
            })
    });
};

});
parcelRegister("a713z", function(module, exports) {

$parcel$export(module.exports, "NumberFieldReadView", () => $742e74923aa1ec10$export$14717bfb50f97612);

var $eUqFw = parcelRequire("eUqFw");

var $7pphk = parcelRequire("7pphk");
const $742e74923aa1ec10$export$14717bfb50f97612 = ({ render: render, value: value, getValueContainer: getValueContainer, inInlineEdit: inInlineEdit })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7pphk.TextFieldReadView), {
        getValueContainer: getValueContainer,
        render: render,
        value: value,
        inInlineEdit: inInlineEdit
    });

});

parcelRegister("iAUwZ", function(module, exports) {

$parcel$export(module.exports, "validate", () => $e6720eb3c3c81ea3$export$a22775fa5e2eebd9);

var $3SZ1u = parcelRequire("3SZ1u");
const $e6720eb3c3c81ea3$export$a22775fa5e2eebd9 = (formatMessage)=>(currentValue)=>{
        if (Number.isNaN(Number(currentValue))) return formatMessage((0, $3SZ1u.default).isNotANumber);
        return undefined;
    };

});
parcelRegister("3SZ1u", function(module, exports) {

$parcel$export(module.exports, "default", () => $c65e238e433cc877$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c65e238e433cc877$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    isNotANumber: {
        "id": "servicedesk-customer-service-custom-details.common.field.number-field.is-not-a-number",
        "defaultMessage": "Enter a number that doesn\u2019t contain spaces, letters or special characters."
    }
});

});



parcelRegister("9f9QH", function(module, exports) {

$parcel$export(module.exports, "PhoneNumberField", () => $22beab552c4b579d$export$522a16be7a55e553);
$parcel$export(module.exports, "PhoneNumberFieldReadView", () => (parcelRequire("gtxgy")).PhoneNumberFieldReadView);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kZjJO = parcelRequire("kZjJO");

var $gtxgy = parcelRequire("gtxgy");

var $PGkJj = parcelRequire("PGkJj");
const $22beab552c4b579d$export$522a16be7a55e553 = ({ id: id, label: label, value: value, onChange: onChange, isInline: isInline, getValueContainer: getValueContainer })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZjJO.TextField), {
        id: id,
        label: label,
        value: value,
        onChange: onChange,
        validate: (0, $PGkJj.validate)(formatMessage),
        isInline: isInline,
        getValueContainer: getValueContainer,
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gtxgy.PhoneNumberFieldReadView), {
                value: value,
                getValueContainer: getValueContainer,
                inInlineEdit: true
            })
    });
};

});
parcelRegister("gtxgy", function(module, exports) {

$parcel$export(module.exports, "PhoneNumberFieldReadView", () => $39db2c0209175eda$export$ccbf36a1c37280de);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");

var $7pphk = parcelRequire("7pphk");

var $PGkJj = parcelRequire("PGkJj");
const $39db2c0209175eda$export$ccbf36a1c37280de = ({ getValueContainer: getValueContainer, render: render, value: value, inInlineEdit: inInlineEdit })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7pphk.TextFieldReadView), {
        getValueContainer: getValueContainer,
        render: render || (()=>{
            if (value) {
                const formattedValue = (0, $PGkJj.formatReadValue)(value);
                if ((0, $1ybV0.ff)('products-and-entitlements-details-m2_45b1j')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    href: `tel:${formattedValue || value}`,
                    onClick: ()=>{
                        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'customDetailFieldLink clicked', {
                            fieldType: 'PHONE'
                        });
                    }
                }, value);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    href: `tel:${formattedValue || value}`
                }, value);
            }
            return null;
        }),
        inInlineEdit: inInlineEdit
    });
};

});
parcelRegister("PGkJj", function(module, exports) {

$parcel$export(module.exports, "validate", () => $df89a15105341db3$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "formatReadValue", () => $df89a15105341db3$export$7ff86f9bff10df25);

var $39gZS = parcelRequire("39gZS");
const $df89a15105341db3$var$phoneNumberRegex = /^\+?[\d ]+$/;
const $df89a15105341db3$var$formatRegex = /\s+/g;
const $df89a15105341db3$export$a22775fa5e2eebd9 = (formatMessage)=>(currentValue)=>{
        if (currentValue === '') return undefined;
        if (!$df89a15105341db3$var$phoneNumberRegex.test(currentValue)) return formatMessage((0, $39gZS.default).invalidPhoneNumber);
        return undefined;
    };
const $df89a15105341db3$export$7ff86f9bff10df25 = (value)=>value?.replaceAll($df89a15105341db3$var$formatRegex, '');

});
parcelRegister("39gZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ba96227663bc411$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7ba96227663bc411$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    invalidPhoneNumber: {
        "id": "servicedesk-customer-service-custom-details.common.field.phone-number-field.invalid-phone-number",
        "defaultMessage": "Enter a valid phone number (e.g. +61 111 111)."
    }
});

});




parcelRegister("9qY2o", function(module, exports) {

$parcel$export(module.exports, "SingleSelectField", () => $2ef3fc604d90e90b$export$1a445157c68b3ac8);
$parcel$export(module.exports, "SingleSelectFieldReadView", () => (parcelRequire("kLZra")).SingleSelectFieldReadView);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $9A7ix = parcelRequire("9A7ix");

var $kLZra = parcelRequire("kLZra");
const $2ef3fc604d90e90b$export$1a445157c68b3ac8 = ({ id: id, label: label, value: value, onChange: onChange, options: options, formattedOptions: formattedOptions, isInline: isInline, getValueContainer: getValueContainer })=>{
    const mappedOptions = options?.map((option)=>({
            label: option,
            value: option
        })) || [];
    const selectedOption = (0, $1ybV0.ff)('shipit-58-colours-for-detail-fields-in-csm_i6j6e') ? formattedOptions?.find((option)=>option.value === value) : mappedOptions.find((option)=>option.value === value);
    const onSelection = (selection, analyticsEvent)=>{
        if (selection?.value === value) return;
        onChange({
            value: selection?.value || ''
        }, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9A7ix.SelectFieldView), {
        id: id,
        isMulti: false,
        label: label,
        value: selectedOption,
        valueAsString: value,
        options: (0, $1ybV0.ff)('shipit-58-colours-for-detail-fields-in-csm_i6j6e') ? formattedOptions : mappedOptions,
        onSelection: onSelection,
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kLZra.SingleSelectFieldReadView), {
                value: value,
                getValueContainer: getValueContainer,
                inInlineEdit: true
            }),
        isInline: isInline
    });
};

});
parcelRegister("kLZra", function(module, exports) {

$parcel$export(module.exports, "SingleSelectFieldReadView", () => $3bbe8cf748999452$export$ca47fb9544dbee74);

var $eUqFw = parcelRequire("eUqFw");
const $3bbe8cf748999452$export$ca47fb9544dbee74 = ({ render: render, value: value, getValueContainer: getValueContainer, inInlineEdit: inInlineEdit })=>{
    const ValueContainer = getValueContainer();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ValueContainer, {
        render: render || (()=>value),
        noBorder: inInlineEdit
    });
};

});


parcelRegister("i9Nba", function(module, exports) {

$parcel$export(module.exports, "UrlField", () => $7313c19938dae62b$export$39403b659adc9685);
$parcel$export(module.exports, "UrlFieldReadView", () => (parcelRequire("6agHN")).UrlFieldReadView);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kZjJO = parcelRequire("kZjJO");

var $6agHN = parcelRequire("6agHN");

var $hKoWb = parcelRequire("hKoWb");
const $7313c19938dae62b$export$39403b659adc9685 = ({ id: id, label: label, value: value, onChange: onChange, isInline: isInline, getValueContainer: getValueContainer })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZjJO.TextField), {
        id: id,
        label: label,
        value: value,
        onChange: onChange,
        validate: (0, $hKoWb.validate)(formatMessage),
        isInline: isInline,
        getValueContainer: getValueContainer,
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6agHN.UrlFieldReadView), {
                value: value,
                getValueContainer: getValueContainer,
                inInlineEdit: true
            })
    });
};

});
parcelRegister("6agHN", function(module, exports) {

$parcel$export(module.exports, "UrlFieldReadView", () => $2fe61ad181925ae0$export$dab08d98a91065cc);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7pphk = parcelRequire("7pphk");
const $2fe61ad181925ae0$export$dab08d98a91065cc = ({ render: render, value: value, getValueContainer: getValueContainer, inInlineEdit: inInlineEdit })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7pphk.TextFieldReadView), {
        getValueContainer: getValueContainer,
        render: render || (()=>{
            if (value) {
                if ((0, $1ybV0.ff)('products-and-entitlements-details-m2_45b1j')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    href: value,
                    onClick: ()=>{
                        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'customDetailFieldLink clicked', {
                            fieldType: 'URL'
                        });
                    },
                    target: "_blank"
                }, value);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    href: value,
                    target: "_blank"
                }, value);
            }
            return null;
        }),
        inInlineEdit: inInlineEdit
    });
};

});

parcelRegister("hKoWb", function(module, exports) {

$parcel$export(module.exports, "validate", () => $fb8c2e7cad6ff0a4$export$a22775fa5e2eebd9);

var $aPMeu = parcelRequire("aPMeu");
const $fb8c2e7cad6ff0a4$export$a22775fa5e2eebd9 = (formatMessage)=>(currentValue)=>{
        if (currentValue === '') return undefined;
        if (!currentValue || !currentValue.startsWith('http:') && !currentValue.startsWith('https:')) return formatMessage((0, $aPMeu.default).invalidUrl);
        return undefined;
    };

});
parcelRegister("aPMeu", function(module, exports) {

$parcel$export(module.exports, "default", () => $63fbac324aa746fb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $63fbac324aa746fb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    invalidUrl: {
        "id": "servicedesk-customer-service-custom-details.common.field.url-field.invalid-url",
        "defaultMessage": "Enter a URL with the format: http://example.com"
    }
});

});



parcelRegister("4H6vd", function(module, exports) {

$parcel$export(module.exports, "UserField", () => $86994c0b38e5e0ac$export$3d1d22e56efa6367);
$parcel$export(module.exports, "UserFieldReadView", () => (parcelRequire("d5isU")).UserFieldReadView);

var $6xzeD = parcelRequire("6xzeD");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $bFzGY = parcelRequire("bFzGY");

var $5i12b = parcelRequire("5i12b");

var $b5IAe = parcelRequire("b5IAe");

var $i9N6e = parcelRequire("i9N6e");

var $guiFP = parcelRequire("guiFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dWLk9 = parcelRequire("dWLk9");

var $cdoT9 = parcelRequire("cdoT9");

var $imJvt = parcelRequire("imJvt");

var $6Sjum = parcelRequire("6Sjum");

var $d5isU = parcelRequire("d5isU");
const $86994c0b38e5e0ac$export$3d1d22e56efa6367 = ({ userFieldRef: userFieldRef, onChange: onChange, getValueContainer: getValueContainer })=>{
    const data = (0, $iWLL0.useFragment)((0, $6xzeD.default), userFieldRef || null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { id: id, name: label, platformValue: platformValue } = data;
    const user = platformValue?.__typename === 'CustomerServiceUserDetailValue' && platformValue.accountId && platformValue.name ? {
        id: platformValue.accountId,
        name: platformValue.name,
        avatarUrl: platformValue.avatarUrl
    } : undefined;
    const [selectedUser, setSelectedUser] = (0, $eUqFw.useState)(user);
    const [isEditing, setIsEditing] = (0, $eUqFw.useState)(false);
    const onChangeWithAnalytics = (selectedOption)=>{
        // Value can be an array if isMulti is enabled, we're narrowing down the typing
        if (Array.isArray(selectedOption)) return;
        setSelectedUser(selectedOption);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'userFieldType'
        });
        onChange({
            value: selectedOption?.id || '',
            ...selectedOption && {
                platformValue: {
                    accountId: selectedOption.id,
                    name: selectedOption.name,
                    avatarUrl: selectedOption.avatarUrl
                }
            }
        }, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $imJvt.InlineEditContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i12b.default), {
        defaultValue: undefined,
        editButtonLabel: formatMessage((0, $cdoT9.default).editButtonLabel, {
            label: label,
            value: user?.name || formatMessage((0, $cdoT9.default).noValue)
        }),
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                id: id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i9N6e.default), {
                ...fieldProps,
                appearance: "compact",
                styles: {
                    control: (style)=>({
                            ...style,
                            height: '32px'
                        })
                },
                width: "100%",
                value: selectedUser,
                fieldId: "user-detail-field",
                includeUsers: true,
                includeTeams: false,
                includeGroups: false,
                isClearable: true,
                productKey: "jira",
                debounceTime: 400,
                siteId: cloudId,
                onChange: onChangeWithAnalytics,
                open: true,
                placeholder: formatMessage((0, $6Sjum.default).searchPlaceholder),
                onError: (e)=>{
                    (0, $guiFP.default)({
                        meta: {
                            id: 'userFieldSmartUserPicker',
                            packageName: 'jiraServicedeskCustomerServiceCustomDetails',
                            teamName: 'boysenberry'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        error: e
                    });
                }
            })),
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d5isU.UserFieldReadView), {
                userFieldRef: data,
                getValueContainer: getValueContainer,
                inInlineEdit: true
            }),
        readViewFitContainerWidth: true,
        isEditing: isEditing,
        onEdit: ()=>setIsEditing(true),
        hideActionButtons: true,
        onConfirm: ()=>setIsEditing(false)
    }));
};

});
parcelRegister("6xzeD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aee0ed91c0ccf26$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bc58f748ca02ef1c881002f1244c2211>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0aee0ed91c0ccf26$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "includePlatformValue"
            }
        ],
        "kind": "Fragment",
        "name": "userField_servicedeskCustomerServiceCustomDetails",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            v0 /*: any*/ ,
            {
                "condition": "includePlatformValue",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "platformValue",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__typename"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                    },
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "avatarUrl"
                                    }
                                ],
                                "type": "CustomerServiceUserDetailValue"
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "includePlatformValue",
                        "variableName": "includePlatformValue"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "readViewUserField_servicedeskCustomerServiceCustomDetails"
            }
        ],
        "type": "CustomerServiceCustomDetailValue"
    };
}();
$0aee0ed91c0ccf26$var$node.hash = "3e38f846626245850708fcf82fe45c9f";
var $0aee0ed91c0ccf26$export$2e2bcd8739ae039 = $0aee0ed91c0ccf26$var$node;

});

parcelRegister("6Sjum", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5cd9720851b4571$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c5cd9720851b4571$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    searchPlaceholder: {
        "id": "servicedesk-customer-service-custom-details.common.field.user-field.search-placeholder-non-final",
        "defaultMessage": "Search for people"
    }
});

});

parcelRegister("d5isU", function(module, exports) {

$parcel$export(module.exports, "UserFieldReadView", () => $4f97014c60d79a2e$export$a4169e09b9924588);

var $j6UCd = parcelRequire("j6UCd");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $iJlfe = parcelRequire("iJlfe");

var $c0jFd = parcelRequire("c0jFd");

var $4HXcS = parcelRequire("4HXcS");
const $4f97014c60d79a2e$export$a4169e09b9924588 = ({ userFieldRef: userFieldRef, render: render, getValueContainer: getValueContainer, inInlineEdit: inInlineEdit })=>{
    const { platformValue: platformValue } = (0, $iWLL0.useFragment)((0, $j6UCd.default), userFieldRef || null);
    const ValueContainer = getValueContainer();
    if (!platformValue || platformValue.__typename !== 'CustomerServiceUserDetailValue' || // BE returns a user with accountId undefined, name 'Unknown user', avatarUrl '.../unknown-user.png' if the user can't be retrieved from identity
    !platformValue.name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ValueContainer, {
        render: render || (()=>null),
        noBorder: inInlineEdit
    });
    const { accountId: accountId, name: name, avatarUrl: avatarUrl } = platformValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ValueContainer, {
        render: render || (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                gap: "space.100",
                alignItems: "center",
                testId: "servicedesk-customer-service-custom-details.common.ui.field.user-field.read-view.user-field"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4HXcS.ProfileCard), {
                accountId: accountId || ''
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                src: avatarUrl || '',
                size: "small"
            })), name)),
        noBorder: inInlineEdit
    });
};

});
parcelRegister("j6UCd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a07ee9baceee7e9c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ee30c7e4cecbe558fd34933fc6ee88b9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a07ee9baceee7e9c$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includePlatformValue"
        }
    ],
    "kind": "Fragment",
    "name": "readViewUserField_servicedeskCustomerServiceCustomDetails",
    "selections": [
        {
            "condition": "includePlatformValue",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "platformValue",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "avatarUrl"
                                }
                            ],
                            "type": "CustomerServiceUserDetailValue"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "CustomerServiceCustomDetailValue"
};
$a07ee9baceee7e9c$var$node.hash = "2a96c1c5d9888be4927b530df7c76fa3";
var $a07ee9baceee7e9c$export$2e2bcd8739ae039 = $a07ee9baceee7e9c$var$node;

});

parcelRegister("4HXcS", function(module, exports) {

$parcel$export(module.exports, "ProfileCard", () => $328a2d82f708e6a5$export$bed540ccfa8743c4);

var $eUqFw = parcelRequire("eUqFw");

var $2NwGr = parcelRequire("2NwGr");

var $gd0Sp = parcelRequire("gd0Sp");
const $328a2d82f708e6a5$export$bed540ccfa8743c4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2NwGr.AsyncProfileCardNext), {
        accountId: props.accountId,
        TenantContextSubscriber: (0, $gd0Sp.TenantContextSubscriber)
    }, props.children);

});



parcelRegister("8ihDs", function(module, exports) {

$parcel$export(module.exports, "DefaultLayout", () => $d0a9323c08dda6b4$export$a6a66093eadb740);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $27KYr = parcelRequire("27KYr");
var $1ZAYh = parcelRequire("1ZAYh");

var $4lTFP = parcelRequire("4lTFP");

var $bAQOb = parcelRequire("bAQOb");

var $7LSr5 = parcelRequire("7LSr5");

var $jKxma = parcelRequire("jKxma");

var $189WW = parcelRequire("189WW");
const $d0a9323c08dda6b4$export$97277a3ba598032a = ({ id: id, label: label, isInline: isInline, children: children, popup: popup, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27KYr.default), {
        templateColumns: isInline ? '1fr 1.5fr' : undefined,
        gap: isInline ? 'space.200' : undefined,
        alignItems: "center",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7LSr5.Label), {
        htmlFor: id
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $189WW.WithPopup), {
        popup: popup
    }, children({
        getValueContainer: ()=>(0, $jKxma.ValueContainer)
    }))));
const $d0a9323c08dda6b4$var$DefaultLayoutNew = ({ id: id, label: label, isInline: isInline, children: children, popup: popup, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d0a9323c08dda6b4$var$wrapperStyles,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $d0a9323c08dda6b4$var$labelStyles,
            isInline && $d0a9323c08dda6b4$var$inlineLabelStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7LSr5.Label), {
        htmlFor: id
    }, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $d0a9323c08dda6b4$var$fieldStyles,
            isInline && $d0a9323c08dda6b4$var$inlineFieldStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $189WW.WithPopup), {
        popup: popup
    }, children({
        getValueContainer: ()=>(0, $jKxma.ValueContainer)
    }))));
const $d0a9323c08dda6b4$export$a6a66093eadb740 = (0, $bAQOb.componentWithFF)('products-and-entitlements-details-m2_45b1j', $d0a9323c08dda6b4$var$DefaultLayoutNew, $d0a9323c08dda6b4$export$97277a3ba598032a);
const $d0a9323c08dda6b4$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
});
const $d0a9323c08dda6b4$var$labelStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.100',
    width: '37%',
    minWidth: '90pt',
    paddingInlineEnd: 'space.150',
    flexGrow: 1
});
const $d0a9323c08dda6b4$var$inlineLabelStyles = (0, $1ZAYh.xcss)({
    maxWidth: '170px',
    paddingBottom: 'space.100'
});
const $d0a9323c08dda6b4$var$fieldStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body, ${(0, $4lTFP.fontFallback).body.medium})`,
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.0',
    paddingRight: 'space.0',
    flexGrow: 1,
    width: 'calc(60% + 16px)',
    marginInline: 'space.negative.100' // 6px padding + 2px border
});
const $d0a9323c08dda6b4$var$inlineFieldStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    paddingRight: 'space.100'
});

});
parcelRegister("7LSr5", function(module, exports) {

$parcel$export(module.exports, "Label", () => $a27b012960d2c67a$export$b04be29aa201d4f5);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");
const $a27b012960d2c67a$export$b04be29aa201d4f5 = ({ htmlFor: htmlFor, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "label",
        htmlFor: htmlFor,
        xcss: (0, $1ybV0.ff)('products-and-entitlements-details-m2_45b1j') ? $a27b012960d2c67a$var$labelStyles : $a27b012960d2c67a$var$oldLabelStyles
    }, children);
const $a27b012960d2c67a$var$oldLabelStyles = (0, $1ZAYh.xcss)({
    fontWeight: 600,
    fontSize: 12,
    overflowWrap: 'anywhere'
});
const $a27b012960d2c67a$var$labelStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    fontWeight: 500,
    fontSize: 12,
    overflowWrap: 'anywhere'
});

});

parcelRegister("jKxma", function(module, exports) {

$parcel$export(module.exports, "ValueContainer", () => $7c71c8a569613a55$export$4dc9f58ad9a1a000);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $84Q0p = parcelRequire("84Q0p");
const $7c71c8a569613a55$export$4dc9f58ad9a1a000 = ({ render: render, noVerticalPadding: noVerticalPadding, noVerticalPaddingWhenNotEmpty: noVerticalPaddingWhenNotEmpty, noBorder: noBorder })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const result = render();
    const isEmpty = !result;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $7c71c8a569613a55$var$styles,
            noVerticalPadding && $7c71c8a569613a55$var$noVerticalPaddingStyles,
            noVerticalPaddingWhenNotEmpty && !isEmpty && $7c71c8a569613a55$var$noVerticalPaddingStyles,
            noBorder && $7c71c8a569613a55$var$noBorderStyles,
            isEmpty && $7c71c8a569613a55$var$emptyStyles
        ],
        "data-testId": "servicedesk-customer-service-custom-details.common.ui.layout.default.value-container.box"
    }, isEmpty ? formatMessage((0, $84Q0p.default).none) : result);
};
// mostly refer to readViewContainerStyles
// from https://atlassian.design/components/inline-edit/examples
const $7c71c8a569613a55$var$lineHeight = Math.ceil((0, $c9TLT.gridSize) * 2 / (0, $c9TLT.fontSize) * 100) / 100;
const $7c71c8a569613a55$var$styles = (0, $1ZAYh.xcss)({
    border: '2px solid transparent',
    margin: 'space.0',
    wordBreak: 'break-word',
    color: 'color.text',
    padding: 'space.075',
    fontSize: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontSize,
    lineHeight: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $7c71c8a569613a55$var$lineHeight
});
const $7c71c8a569613a55$var$noVerticalPaddingStyles = (0, $1ZAYh.xcss)({
    paddingBlock: 'space.0'
});
const $7c71c8a569613a55$var$emptyStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${$7c71c8a569613a55$var$lineHeight}em`,
    color: 'color.text.subtlest'
});
const $7c71c8a569613a55$var$noBorderStyles = (0, $1ZAYh.xcss)({
    border: 'none'
});

});
parcelRegister("84Q0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $e310bf058230f92b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e310bf058230f92b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    none: {
        "id": "servicedesk-customer-service-custom-details.common.layout.value-container.none",
        "defaultMessage": "None"
    }
});

});


parcelRegister("189WW", function(module, exports) {

$parcel$export(module.exports, "WithPopup", () => $522ed477ada54068$export$24dd849210d1c5b4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $522ed477ada54068$export$24dd849210d1c5b4 = ({ popup: popup, children: children })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClick = (event)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const element = event.target;
        /** If a link is clicked in the read view, default action should be taken */ if (element.tagName.toLowerCase() !== 'a') {
            event.preventDefault();
            setIsOpen(!isOpen);
        }
    };
    return popup?.renderContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        placement: "top",
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: popup.renderContent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $522ed477ada54068$var$hoverBoxStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
                ...triggerProps,
                type: "button",
                onClick: onClick,
                className: (0, $7JEyt.default)([
                    "_18s8ze3t _1yt4ze3t _r06hglyw _bfhk18uv _vwz4kb7n _y3gn1kw7 _1bsb1osq _12ji1r31 _1qu2glyw _12y3idpf _19itidpf _2rkoxhq4"
                ])
            }, children))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $522ed477ada54068$var$editButtonStyles = null;
const $522ed477ada54068$var$hoverBoxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius',
    transition: 'background 0.2s',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});

});



parcelRegister("4tsLS", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $6f16bf9beb3fbc7b$export$fddf379e22a74b00);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bFzGY = parcelRequire("bFzGY");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $c7H0g = parcelRequire("c7H0g");

var $6Qy8u = parcelRequire("6Qy8u");

var $dG7In = parcelRequire("dG7In");
const $6f16bf9beb3fbc7b$export$7283c169d4a976c9 = 'servicedesk-customer-service-issue-view-panel.common.ui.details.empty-state.description';
const $6f16bf9beb3fbc7b$var$getDescription = (isJiraAdmin, context)=>{
    if ((0, $1ybV0.ff)('products-and-entitlements-details-m2_45b1j')) {
        if (isJiraAdmin) switch(context){
            case 'CUSTOMER':
                return (0, $dG7In.default).descriptionCustomer;
            case 'ORGANIZATION':
                return (0, $dG7In.default).descriptionOrganization;
            case 'ENTITLEMENT':
                return (0, $dG7In.default).descriptionEntitlement;
            default:
                // This should never return but formatMessage requires a non null value
                return (0, $dG7In.default).descriptionCustomer;
        }
        switch(context){
            case 'CUSTOMER':
                return (0, $dG7In.default).notAdminDescriptionCustomer;
            case 'ORGANIZATION':
                return (0, $dG7In.default).notAdminDescriptionOrganization;
            case 'ENTITLEMENT':
                return (0, $dG7In.default).notAdminDescriptionEntitlement;
            default:
                return (0, $dG7In.default).notAdminDescriptionCustomer;
        }
    }
    if (isJiraAdmin) return context === 'CUSTOMER' ? (0, $dG7In.default).updatedDescriptionCustomer : (0, $dG7In.default).updatedDescriptionOrganization;
    return context === 'CUSTOMER' ? (0, $dG7In.default).notAdminDescriptionCustomer : (0, $dG7In.default).notAdminDescriptionOrganization;
};
const $6f16bf9beb3fbc7b$export$fddf379e22a74b00 = ({ context: context, detailsUrl: detailsUrl, entityExperience: entityExperience })=>{
    const isJiraAdmin = (0, $c7H0g.useIsAdmin)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onLinkClicked = ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createCustomerContextDetails', {
            context: context
        });
    const renderCreateDetailsButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            onClick: onLinkClicked,
            href: detailsUrl,
            "data-testid": "servicedesk-customer-service-issue-view-panel.common.ui.details.empty-state.button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $dG7In.default).updatedCreateDetailsButtonLink));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f16bf9beb3fbc7b$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f16bf9beb3fbc7b$var$Description, {
        "data-testid": $6f16bf9beb3fbc7b$export$7283c169d4a976c9
    }, (0, $1ybV0.ff)('products-and-entitlements-details-m2_45b1j') ? formatMessage($6f16bf9beb3fbc7b$var$getDescription(isJiraAdmin, context), {
        a: (children)=>isJiraAdmin && detailsUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                onClick: onLinkClicked,
                href: detailsUrl,
                "data-testid": "servicedesk-customer-service-issue-view-panel.common.ui.details.empty-state.button"
            }, children) : children
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...$6f16bf9beb3fbc7b$var$getDescription(isJiraAdmin, context),
        values: {
            link: isJiraAdmin && detailsUrl ? renderCreateDetailsButton() : null
        }
    })), entityExperience && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Qy8u.ExperienceSuccess), {
        experience: entityExperience
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f16bf9beb3fbc7b$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81hyr _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _1tke11ux",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f16bf9beb3fbc7b$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _p12fkpet _syaz1rc1 _18s81bpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dG7In", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac794d9d959d6df6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $ac794d9d959d6df6$export$b7a99854475d482b = '{link}';
var $ac794d9d959d6df6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    updatedDescriptionCustomer: {
        "id": "servicedesk-customer-service-issue-view-panel.common.details.empty-state.updated-description-customer",
        "defaultMessage": "To get context on your customers, make sure you\u2019ve {link}."
    },
    updatedDescriptionOrganization: {
        "id": "servicedesk-customer-service-issue-view-panel.common.details.empty-state.updated-description-organization",
        "defaultMessage": "To get context on your customers\u2019 organizations, make sure you\u2019ve {link}."
    },
    updatedDescriptionEntitlement: {
        "id": "servicedesk-customer-service-issue-view-panel.common.details.empty-state.updated-description-entitlement",
        "defaultMessage": "To get context on your customers\u2019 entitlements, make sure you\u2019ve {link}."
    },
    descriptionCustomer: {
        "id": "servicedesk-customer-service-issue-view-panel.common.details.empty-state.description-customer",
        "defaultMessage": "To get context on your customers, make sure you\u2019ve <a>set up detail fields to show on the issue view</a>."
    },
    descriptionOrganization: {
        "id": "servicedesk-customer-service-issue-view-panel.common.details.empty-state.description-organization",
        "defaultMessage": "To get context on your customers\u2019 organizations, make sure you\u2019ve <a>set up detail fields to show on the issue view</a>."
    },
    descriptionEntitlement: {
        "id": "servicedesk-customer-service-issue-view-panel.common.details.empty-state.description-entitlement",
        "defaultMessage": "To get context on your customers\u2019 entitlements, make sure you\u2019ve <a>set up detail fields to show on the issue view</a>."
    },
    notAdminDescriptionCustomer: {
        "id": "servicedesk-customer-service-issue-view-panel.common.details.empty-state.not-admin-description-customer",
        "defaultMessage": "To get more context on your customers here, ask an admin to create customer detail fields."
    },
    notAdminDescriptionOrganization: {
        "id": "servicedesk-customer-service-issue-view-panel.common.details.empty-state.not-admin-description-organization",
        "defaultMessage": "To get more context on your customers\u2019 organizations here, ask an admin to create organization detail fields."
    },
    notAdminDescriptionEntitlement: {
        "id": "servicedesk-customer-service-issue-view-panel.common.details.empty-state.not-admin-description-entitlement",
        "defaultMessage": "To get more context on your customers\u2019 entitlements here, ask an admin to create entitlement detail fields."
    },
    updatedCreateDetailsButtonLink: {
        "id": "servicedesk-customer-service-issue-view-panel.common.details.empty-state.updated-create-details-button-link",
        "defaultMessage": "set up detail fields to show on the issue view"
    }
});

});



parcelRegister("7JmTk", function(module, exports) {

$parcel$export(module.exports, "getProfileUrl", () => $fd23881e93c6059e$export$6d333a56ff392766);
$parcel$export(module.exports, "getEditDetailsUrlByEntityType", () => $fd23881e93c6059e$export$aaf859fb6ac9da88);

var $2U482 = parcelRequire("2U482");
const $fd23881e93c6059e$export$6d333a56ff392766 = (projectKey, context, id)=>`/jira/servicedesk/projects/${projectKey}/${context === 'CUSTOMER' ? 'customers' : 'organizations'}/${id}`;
const $fd23881e93c6059e$export$98f08bc420720a02 = (projectKey, context, id)=>`${$fd23881e93c6059e$export$6d333a56ff392766(projectKey, context, id)}${0, $2U482.EDIT_DETAILS_HASH}`;
const $fd23881e93c6059e$export$aaf859fb6ac9da88 = (projectKey, entityType, id)=>{
    switch(entityType){
        case 'CUSTOMER':
            return `/jira/servicedesk/projects/${projectKey}/customers/${id}${0, $2U482.EDIT_DETAILS_HASH}`;
        case 'ORGANIZATION':
            return `/jira/servicedesk/projects/${projectKey}/organizations/${id}${0, $2U482.EDIT_DETAILS_HASH}`;
        case 'ENTITLEMENT':
            return `/jira/servicedesk/projects/${projectKey}/products${0, $2U482.EDIT_DETAILS_HASH}`;
        default:
            return '';
    }
};

});
parcelRegister("2U482", function(module, exports) {

$parcel$export(module.exports, "ModalLabelFieldError", () => $fe5ef74f363225b3$export$3aff8e5914a05d6b);
$parcel$export(module.exports, "IMPORT_STATUSES", () => $fe5ef74f363225b3$export$1560eff6f5427298);
$parcel$export(module.exports, "IMPORT_MODES", () => $fe5ef74f363225b3$export$ea1e8653c00bb7c0);
$parcel$export(module.exports, "IMPORT_CONTEXTS", () => $fe5ef74f363225b3$export$a40b5e39f928731a);
$parcel$export(module.exports, "EDIT_DETAILS_HASH", () => $fe5ef74f363225b3$export$81a375b3af1c99b5);
const $fe5ef74f363225b3$var$DUPLICATE_LABEL = 'duplicateLabel';
const $fe5ef74f363225b3$var$SPECIAL_CHARACTERS = 'specialCharacters';
const $fe5ef74f363225b3$var$MORE_THAN_ONE_NONSPACE_CHARACTER = 'moreThanOneNonSpaceCharacter';
const $fe5ef74f363225b3$var$RESERVED_LABEL = 'reservedLabel';
const $fe5ef74f363225b3$var$GENERIC_ERROR = 'genericError';
const $fe5ef74f363225b3$var$COLOR_NOT_SAVED_ERROR = 'colorNotSavedError';
const $fe5ef74f363225b3$export$3aff8e5914a05d6b = {
    DUPLICATE_LABEL: $fe5ef74f363225b3$var$DUPLICATE_LABEL,
    SPECIAL_CHARACTERS: $fe5ef74f363225b3$var$SPECIAL_CHARACTERS,
    MORE_THAN_ONE_NONSPACE_CHARACTER: $fe5ef74f363225b3$var$MORE_THAN_ONE_NONSPACE_CHARACTER,
    RESERVED_LABEL: $fe5ef74f363225b3$var$RESERVED_LABEL,
    GENERIC_ERROR: $fe5ef74f363225b3$var$GENERIC_ERROR,
    COLOR_NOT_SAVED_ERROR: $fe5ef74f363225b3$var$COLOR_NOT_SAVED_ERROR
};
const $fe5ef74f363225b3$export$1560eff6f5427298 = {
    PREPARE: 'PREPARE',
    UPLOAD: 'UPLOAD',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETE: 'COMPLETE'
};
const $fe5ef74f363225b3$export$ea1e8653c00bb7c0 = {
    DETAILS_ONLY: 'DETAILS_ONLY',
    ADD_TO_PROJECT: 'ADD_TO_PROJECT'
};
const $fe5ef74f363225b3$export$a40b5e39f928731a = {
    ORGANIZATIONS: 'ORGANIZATIONS',
    CUSTOMERS: 'CUSTOMERS'
};
const $fe5ef74f363225b3$export$81a375b3af1c99b5 = '#editDetails';

});



parcelRegister("l43Kj", function(module, exports) {

$parcel$export(module.exports, "ExpandPanel", () => $a10b51703c6dde83$export$bc7ece1b74773271);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $5xnoX = parcelRequire("5xnoX");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $gfBPf = parcelRequire("gfBPf");
const $a10b51703c6dde83$export$bc7ece1b74773271 = ({ id: id, field: field, isOpen: isOpen, children: children, onToggle: onToggle, source: source })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const controlContentId = `expand-panel-${id}`;
    const openedOrClosed = isOpen ? 'closed' : 'opened';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a10b51703c6dde83$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a10b51703c6dde83$var$FieldContainer, null, field), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: controlContentId,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onClick: (e, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueViewCustomerContextExpand', {
                context: id,
                openedOrClosed: openedOrClosed,
                source: source
            });
            onToggle();
        },
        appearance: "subtle",
        "aria-expanded": isOpen,
        "aria-controls": controlContentId,
        "aria-label": formatMessage(isOpen ? (0, $gfBPf.default).collapse : (0, $gfBPf.default).expand),
        iconBefore: isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        hidden: !isOpen,
        id: controlContentId
    }, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a10b51703c6dde83$var$FieldContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $a10b51703c6dde83$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4t3i1jfw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gfBPf", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbfdbebd0ae299af$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bbfdbebd0ae299af$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    expand: {
        "id": "servicedesk-customer-service-issue-view-panel.common.expand-panel.expand",
        "defaultMessage": "Expand"
    },
    collapse: {
        "id": "servicedesk-customer-service-issue-view-panel.common.expand-panel.collapse",
        "defaultMessage": "Collapse"
    }
});

});


parcelRegister("gWf4c", function(module, exports) {

$parcel$export(module.exports, "CustomerField", () => $df8aeb4938c5f266$export$7b6a5c6bdb6c9379);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bFzGY = parcelRequire("bFzGY");

var $iJlfe = parcelRequire("iJlfe");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $jMP2a = parcelRequire("jMP2a");

var $guDlK = parcelRequire("guDlK");

var $kJlBc = parcelRequire("kJlBc");

var $7JmTk = parcelRequire("7JmTk");

var $erOx3 = parcelRequire("erOx3");
const $df8aeb4938c5f266$export$7b6a5c6bdb6c9379 = ({ value: value })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const profileURL = (0, $7JmTk.getProfileUrl)(projectKey, 'CUSTOMER', value?.accountId || '');
    const onClick = (e)=>{
        e.preventDefault();
        push(profileURL);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'viewCustomerContextProfile', {
            context: 'CUSTOMER'
        });
    };
    const customerName = (0, $1ybV0.ff)('products-and-entitlements-details-m2_45b1j') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        onClick: onClick,
        href: profileURL
    }, value?.displayName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, value?.displayName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df8aeb4938c5f266$var$FieldContainer, {
        "data-testid": "servicedesk-customer-service-issue-view-panel.ui.customer.customer-field.field-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df8aeb4938c5f266$var$AvatarContainer, {
        isNewUI: (0, $1ybV0.ff)('products-and-entitlements-details-m2_45b1j')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        borderColor: "transparent",
        src: value?.avatarUrls && value?.avatarUrls['48x48'],
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df8aeb4938c5f266$var$NameWrapper, null, value ? customerName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $erOx3.default).anonymous))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df8aeb4938c5f266$var$FieldContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ixy5q _4cvr1h6o _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $df8aeb4938c5f266$var$NameWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _vwz4kb7n _1nmz1hna",
            __cmplp.className
        ])
    });
});
const $df8aeb4938c5f266$var$AvatarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNewUI: isNewUI, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _11pjwsi6",
            __cmplp.isNewUI ? "_2hwx12x7" : "_2hwxu2gc",
            __cmplp.isNewUI && "_18u01i6y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("erOx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fec5f4b9d5fea2a$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $9fec5f4b9d5fea2a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    anonymous: {
        "id": "servicedesk-customer-service-issue-view-panel.customer.customer-field.anonymous-non-final",
        "defaultMessage": "Anonymous"
    }
});

});


parcelRegister("gxp8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a6f86207f531f6a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2a6f86207f531f6a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyState: {
        "id": "servicedesk-customer-service-issue-view-panel.customer.empty-state",
        "defaultMessage": "Add a reporter to view customer details"
    },
    customer: {
        "id": "servicedesk-customer-service-issue-view-panel.customer.customer",
        "defaultMessage": "Customer details"
    }
});

});

parcelRegister("41hlC", function(module, exports) {

$parcel$export(module.exports, "PanelView", () => $f887fa91293d631f$export$155ca5d268e0664d);

var $5wuW8 = parcelRequire("5wuW8");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $hJ992 = parcelRequire("hJ992");

var $kdPjr = parcelRequire("kdPjr");

var $guDlK = parcelRequire("guDlK");

var $acemj = parcelRequire("acemj");

var $iWZF5 = parcelRequire("iWZF5");

var $2fy56 = parcelRequire("2fy56");
var $6uuIf = parcelRequire("6uuIf");
var $7JmTk = parcelRequire("7JmTk");

var $9NLaB = parcelRequire("9NLaB");

var $4RPod = parcelRequire("4RPod");
const $f887fa91293d631f$export$5e5d476685b9195c = 'servicedesk-customer-service-issue-view-panel.ui.customer.customer-details.divider';
const $f887fa91293d631f$var$Inner = ({ queryReference: queryReference, orgCount: orgCount })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const { customerService: { individualByAccountId: individualByAccountId } } = (0, $iWLL0.usePreloadedQuery)((0, $5wuW8.default), queryReference);
    if (individualByAccountId.__typename !== 'CustomerServiceIndividual') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $acemj.ThrowOnQueryError), {
        operationName: "panelViewCustomerQuery",
        errorRef: individualByAccountId.__typename === 'QueryError' ? individualByAccountId : undefined
    });
    const { details: details, organizations: organizations } = individualByAccountId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2fy56.DetailsView), {
        entityType: "CUSTOMER",
        editDetailsUrl: (0, $7JmTk.getEditDetailsUrlByEntityType)(projectKey, 'CUSTOMER', individualByAccountId.id),
        details: details,
        entityExperience: (0, $4RPod.customerServiceIssueViewPanelCustomerExperience)
    }), orgCount === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWZF5.CustomerOrganizations), {
        organizations: organizations || []
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uuIf.Divider), {
        "data-testid": $f887fa91293d631f$export$5e5d476685b9195c
    }));
};
const $f887fa91293d631f$export$155ca5d268e0664d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9NLaB.DetailsContainer), {
        context: "CUSTOMER",
        entityExperience: (0, $4RPod.customerServiceIssueViewPanelCustomerExperience)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kdPjr.FieldsCompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f887fa91293d631f$var$Inner, props)));

});
parcelRegister("iWZF5", function(module, exports) {

$parcel$export(module.exports, "CustomerOrganizations", () => $9e7be35c1386d8aa$export$111b7d3b505db82e);

var $6IeDY = parcelRequire("6IeDY");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $k8QAP = parcelRequire("k8QAP");

var $6uuIf = parcelRequire("6uuIf");

var $9H1Az = parcelRequire("9H1Az");

var $kqjx6 = parcelRequire("kqjx6");
const $9e7be35c1386d8aa$export$403930b530965380 = 'servicedesk-customer-service-issue-view-panel.ui.customer.customer-details.customer-organizations.divider';
const $9e7be35c1386d8aa$export$cbac32e0febfbf1e = ({ organization: organization, isLast: isLast })=>{
    const { id: id, name: name } = (0, $iWLL0.useFragment)((0, $6IeDY.default), organization);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9H1Az.Organization), {
        organization: {
            id: id,
            name: name
        },
        isLast: isLast,
        panelSource: "CUSTOMER_ORGANIZATIONS"
    });
};
const $9e7be35c1386d8aa$export$111b7d3b505db82e = ({ organizations: organizations })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const entitlementFieldValue = (0, $k8QAP.useEntitlementFieldValue)();
    if (!organizations || organizations.length === 0) {
        if ((0, $1ybV0.ff)('products-and-entitlements-details-m2_45b1j') && !!entitlementFieldValue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uuIf.Divider), {
            "data-testid": $9e7be35c1386d8aa$export$403930b530965380
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uuIf.Divider), {
        "data-testid": $9e7be35c1386d8aa$export$403930b530965380
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uuIf.Header), null, formatMessage((0, $kqjx6.default).organizationDetailsHeader)), organizations.map((organization, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e7be35c1386d8aa$export$cbac32e0febfbf1e, {
            key: `customer-organization-${index}`,
            organization: organization,
            isLast: index === organizations.length - 1
        })));
};

});
parcelRegister("6IeDY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98d43fc482af543$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<616c17d3cbe85e8dee5f46f82fa45cfe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b98d43fc482af543$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "customerOrganizations_servicedeskCustomerServiceIssueViewPanel_CustomerOrganization",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "CustomerServiceOrganization"
};
$b98d43fc482af543$var$node.hash = "5427227533dd119905fd756c684d2c6f";
var $b98d43fc482af543$export$2e2bcd8739ae039 = $b98d43fc482af543$var$node;

});

parcelRegister("k8QAP", function(module, exports) {

$parcel$export(module.exports, "useEntitlementFieldValue", () => $5859fe72fd317f99$export$b3a261279df9793f);

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");
var $3oTxc = parcelRequire("3oTxc");

var $lO4Or = parcelRequire("lO4Or");
const $5859fe72fd317f99$export$b3a261279df9793f = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [fieldKey] = (0, $3oTxc.useSearchCustomFieldKeys)(issueKey, (0, $lO4Or.ENTITLEMENT_CF_TYPE));
    const [entitlementFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    // useFieldValue returns any,
    // and I don't see a clean way to type it
    // so better evaluate its shape before returning it
    if ((0, $1ybV0.ff)('products-and-entitlements-details-m2_45b1j')) {
        if (entitlementFieldValue?.id && entitlementFieldValue?.product?.id && entitlementFieldValue?.product?.name && entitlementFieldValue?.entity?.__typename && entitlementFieldValue?.entity?.id) return entitlementFieldValue;
    } else if (entitlementFieldValue?.id && entitlementFieldValue?.product?.id && entitlementFieldValue?.product?.name) return entitlementFieldValue;
    return null;
};

});

parcelRegister("9H1Az", function(module, exports) {

$parcel$export(module.exports, "Organization", () => $420b6e78a4b704d1$export$f3a6aa388b70f149);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $gZbW1 = parcelRequire("gZbW1");

var $dWLk9 = parcelRequire("dWLk9");

var $l43Kj = parcelRequire("l43Kj");

var $lpWZg = parcelRequire("lpWZg");

var $hBUr0 = parcelRequire("hBUr0");
const $420b6e78a4b704d1$export$f3a6aa388b70f149 = ({ panelSource: panelSource, organization: organization, isLast: isLast })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [queryReference, loadQuery, disposeQuery] = (0, $iWLL0.useQueryLoader)((0, $gZbW1.default));
    const hasQueryReference = !!queryReference;
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen && hasQueryReference) disposeQuery();
    }, [
        disposeQuery,
        hasQueryReference,
        isOpen
    ]);
    const onToggle = ()=>{
        setIsOpen((prev)=>{
            if (!prev && organization?.id) loadQuery({
                cloudId: cloudId,
                organizationId: organization.id,
                includePlatformValue: (0, $1ybV0.ff)('csm-shipit-58-user-custom-detail-type_be1zw')
            });
            return !prev;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l43Kj.ExpandPanel), {
        onToggle: onToggle,
        field: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lpWZg.OrganizationField), {
            value: organization
        }),
        isOpen: isOpen,
        id: `organization-${organization.id}`,
        source: panelSource
    }, isOpen && queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "servicedesk-customer-service-issue-view-panel.common.ui.organization.div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hBUr0.PanelView), {
        queryReference: queryReference,
        isLast: isLast
    })));
};

});
parcelRegister("gZbW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $18dc2777c85d3604$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9cc90d11fac1680fece7f640b909bbf6>>
 * @relayHash 0ba0ad891cd7e3dafc22c231c5989b20
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7684bef0d76f9c3e68ff98060d4cb536cd4785c01be8251f8b0708a8f0f8f3e7
const $18dc2777c85d3604$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includePlatformValue"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "organizationId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "context": {
                    "type": "ISSUE"
                }
            }
        },
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "identifier"
            },
            {
                "kind": "ScalarField",
                "name": "message"
            },
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusCode"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ]
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "panelViewOrganizationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "details",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "includePlatformValue",
                                                                    "variableName": "includePlatformValue"
                                                                }
                                                            ],
                                                            "kind": "FragmentSpread",
                                                            "name": "detailsView_servicedeskCustomerServiceIssueViewPanel"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.organizationByOrganizationId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "panelViewOrganizationQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "details",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceCustomDetailValue",
                                                            "kind": "LinkedField",
                                                            "name": "results",
                                                            "plural": true,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "values"
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailType",
                                                                    "kind": "LinkedField",
                                                                    "name": "type",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "options"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "config",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                                                            "kind": "LinkedField",
                                                                            "name": "styleConfiguration",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "options",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "optionValue"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "style",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "backgroundColour"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "includePlatformValue",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "platformValue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v5 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "accountId"
                                                                                        },
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "avatarUrl"
                                                                                        }
                                                                                    ],
                                                                                    "type": "CustomerServiceUserDetailValue"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "CustomerServiceCustomDetailValues"
                                                },
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7684bef0d76f9c3e68ff98060d4cb536cd4785c01be8251f8b0708a8f0f8f3e7",
            "metadata": {},
            "name": "panelViewOrganizationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$18dc2777c85d3604$var$node.hash = "c705440ae874108667722298f6744aed";
var $18dc2777c85d3604$export$2e2bcd8739ae039 = $18dc2777c85d3604$var$node;

});

parcelRegister("lpWZg", function(module, exports) {

$parcel$export(module.exports, "OrganizationField", () => $7b400a531f943ead$export$8ad431dc6194deae);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bFzGY = parcelRequire("bFzGY");

var $bKtyL = parcelRequire("bKtyL");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $jMP2a = parcelRequire("jMP2a");

var $guDlK = parcelRequire("guDlK");

var $kJlBc = parcelRequire("kJlBc");

var $7JmTk = parcelRequire("7JmTk");
const $7b400a531f943ead$export$8ad431dc6194deae = ({ value: value })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const profileURL = (0, $7JmTk.getProfileUrl)(projectKey, 'ORGANIZATION', value.id);
    const onClick = (e)=>{
        e.preventDefault();
        push(profileURL);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'viewCustomerContextProfile', {
            context: 'ORGANIZATION'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b400a531f943ead$var$FieldContainer, {
        "data-testid": "servicedesk-customer-service-issue-view-panel.common.ui.organization.organization-field.field-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b400a531f943ead$var$IconSquare, {
        isNewUI: (0, $1ybV0.ff)('products-and-entitlements-details-m2_45b1j')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bKtyL))), {
        primaryColor: "var(--ds-icon, #44546F)",
        size: "small",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b400a531f943ead$var$NameWrapper, null, (0, $1ybV0.ff)('products-and-entitlements-details-m2_45b1j') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        onClick: onClick,
        href: profileURL
    }, value.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, value.name)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7b400a531f943ead$var$FieldContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ixy5q _4cvr1h6o _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $7b400a531f943ead$var$NameWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _vwz4kb7n _1nmz1hna",
            __cmplp.className
        ])
    });
});
const $7b400a531f943ead$var$IconSquare = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNewUI: isNewUI, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ipxbi _1bsbpxbi _1e0c1txw _2rko1y44 _1yt41b66 _bfhk1yrq",
            __cmplp.isNewUI ? "_2hwxu2gc" : "_2hwxutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bKtyL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88daeb8328df15a4$var$_react = $88daeb8328df15a4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $88daeb8328df15a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $88daeb8328df15a4$var$OfficeBuildingFilledIcon = (props)=>/*#__PURE__*/ $88daeb8328df15a4$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8V6z" fill="currentColor" fill-rule="nonzero"/><path fill="inherit" d="M6 10h2v2H6zm0 3h2v2H6z"/><path d="M9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0118.991 21H9V4.995z" fill="currentColor"/><path fill="inherit" d="M12 7h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/></g></svg>`
    }, props));
$88daeb8328df15a4$var$OfficeBuildingFilledIcon.displayName = 'OfficeBuildingFilledIcon';
var $88daeb8328df15a4$var$_default = $88daeb8328df15a4$var$OfficeBuildingFilledIcon;
module.exports.default = $88daeb8328df15a4$var$_default;

});


parcelRegister("hBUr0", function(module, exports) {

$parcel$export(module.exports, "PanelView", () => $849229967abf3da4$export$155ca5d268e0664d);

var $gZbW1 = parcelRequire("gZbW1");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $hJ992 = parcelRequire("hJ992");

var $kdPjr = parcelRequire("kdPjr");

var $guDlK = parcelRequire("guDlK");

var $acemj = parcelRequire("acemj");

var $4RPod = parcelRequire("4RPod");

var $k8QAP = parcelRequire("k8QAP");

var $2fy56 = parcelRequire("2fy56");
var $6uuIf = parcelRequire("6uuIf");
var $7JmTk = parcelRequire("7JmTk");

var $9NLaB = parcelRequire("9NLaB");
const $849229967abf3da4$var$Inner = ({ queryReference: queryReference, isLast: isLast })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const { customerService: { organizationByOrganizationId: organizationByOrganizationId } } = (0, $iWLL0.usePreloadedQuery)((0, $gZbW1.default), queryReference);
    const entitlementFieldValue = (0, $k8QAP.useEntitlementFieldValue)();
    const hasEntitlement = !!entitlementFieldValue;
    const showDivider = !isLast || hasEntitlement;
    if (organizationByOrganizationId.__typename !== 'CustomerServiceOrganization') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $acemj.ThrowOnQueryError), {
        operationName: "panelViewOrganizationQuery",
        errorRef: organizationByOrganizationId.__typename === 'QueryError' ? organizationByOrganizationId : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2fy56.DetailsView), {
        entityType: "ORGANIZATION",
        editDetailsUrl: (0, $7JmTk.getEditDetailsUrlByEntityType)(projectKey, 'ORGANIZATION', organizationByOrganizationId.id),
        details: organizationByOrganizationId.details,
        entityExperience: (0, $4RPod.customerServiceIssueViewPanelOrganizationExperience)
    }), showDivider && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uuIf.Divider), {
        "data-testid": "servicedesk-customer-service-issue-view-panel.common.ui.organization.panel-view.divider"
    }));
};
const $849229967abf3da4$export$155ca5d268e0664d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9NLaB.DetailsContainer), {
        context: "ORGANIZATION",
        entityExperience: (0, $4RPod.customerServiceIssueViewPanelOrganizationExperience)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kdPjr.FieldsCompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($849229967abf3da4$var$Inner, props)));

});
parcelRegister("4RPod", function(module, exports) {

$parcel$export(module.exports, "customerServiceIssueViewPanelCustomerExperience", () => $46c3dbe9c74055f7$export$5565319ef7417f82);
$parcel$export(module.exports, "customerServiceIssueViewPanelOrganizationExperience", () => $46c3dbe9c74055f7$export$c1cee1e33bfa13a2);
$parcel$export(module.exports, "customerServiceIssueViewPanelEntitlementExperience", () => $46c3dbe9c74055f7$export$d158e70d689b5c9b);
$parcel$export(module.exports, "experienceMap", () => $46c3dbe9c74055f7$export$2f9c180da5faf173);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $46c3dbe9c74055f7$export$5565319ef7417f82 = new (0, $kDfSL.UFOExperience)('jsm-cs-issue-view-panel-customer', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $46c3dbe9c74055f7$export$c1cee1e33bfa13a2 = new (0, $kDfSL.UFOExperience)('jsm-cs-issue-view-panel-organization', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $46c3dbe9c74055f7$export$d158e70d689b5c9b = new (0, $kDfSL.UFOExperience)('jsm-cs-issue-view-panel-entitlement', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $46c3dbe9c74055f7$export$2f9c180da5faf173 = {
    CUSTOMER: $46c3dbe9c74055f7$export$5565319ef7417f82,
    ORGANIZATION: $46c3dbe9c74055f7$export$c1cee1e33bfa13a2,
    ENTITLEMENT: $46c3dbe9c74055f7$export$d158e70d689b5c9b
};

});

parcelRegister("9NLaB", function(module, exports) {

$parcel$export(module.exports, "DetailsContainer", () => $fe50226f0e76dd5e$export$2d9f66e60a04069a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $9IbuV = parcelRequire("9IbuV");

var $327x2 = parcelRequire("327x2");
const $fe50226f0e76dd5e$var$LoadingComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fe50226f0e76dd5e$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fe50226f0e76dd5e$var$LoadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        testId: "servicedesk-customer-service-issue-view-panel.common.ui.details-container.spinner"
    })));
const $fe50226f0e76dd5e$export$2d9f66e60a04069a = ({ context: context, children: children, entityExperience: entityExperience })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    entityExperience && (0, $9IbuV.useUFOComponentExperience)(entityExperience);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "DetailsContainer",
        packageName: "jiraServicedeskCustomerServiceIssueViewPanel",
        teamName: "boysenberry",
        sendToPrivacyUnsafeSplunk: true,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $327x2.ErrorState), {
                context: context
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "customer-service-issue-view-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fe50226f0e76dd5e$var$LoadingComponent, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fe50226f0e76dd5e$var$Container, null, children)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fe50226f0e76dd5e$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1y44 _1e0c1txw _2lx21bp4 _zulpv77o _n3tdu2gc",
            __cmplp.className
        ])
    });
});
const $fe50226f0e76dd5e$var$LoadingContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1lit _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("327x2", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $512405a8356ee553$export$c1ed4f415b9e7023);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8M3w4 = parcelRequire("8M3w4");
var $jlyhl = parcelRequire("jlyhl");

var $4RPod = parcelRequire("4RPod");

var $lt8wy = parcelRequire("lt8wy");
const $512405a8356ee553$var$getDescription = (context)=>{
    switch(context){
        case 'CUSTOMER':
            return (0, $lt8wy.default).descriptionCustomer;
        case 'ORGANIZATION':
            return (0, $lt8wy.default).descriptionOrganization;
        case 'ENTITLEMENT':
            return (0, $lt8wy.default).descriptionEntitlement;
        default:
            return (0, $lt8wy.default).descriptionCustomer;
    }
};
const $512405a8356ee553$var$triggerExperience = (context)=>{
    switch(context){
        case 'CUSTOMER':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jlyhl.ExperienceFailure), {
                experience: (0, $4RPod.experienceMap).CUSTOMER
            });
        case 'ORGANIZATION':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jlyhl.ExperienceFailure), {
                experience: (0, $4RPod.experienceMap).ORGANIZATION
            });
        case 'ENTITLEMENT':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jlyhl.ExperienceFailure), {
                experience: (0, $4RPod.experienceMap).ENTITLEMENT
            });
        default:
    }
};
const $512405a8356ee553$export$c1ed4f415b9e7023 = ({ context: context })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8M3w4.DetailsErrorState), {
        description: formatMessage($512405a8356ee553$var$getDescription(context))
    }), $512405a8356ee553$var$triggerExperience(context));
};

});
parcelRegister("8M3w4", function(module, exports) {

$parcel$export(module.exports, "DetailsErrorState", () => $08da2d03ded977ef$export$3dc93ee2b8a3f36c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $220ac = parcelRequire("220ac");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eoDeF = parcelRequire("eoDeF");

var $hkixE = parcelRequire("hkixE");
const $08da2d03ded977ef$export$3dc93ee2b8a3f36c = ({ description: description })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08da2d03ded977ef$var$EmptyStateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $hkixE.default).header),
        description: description,
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($eoDeF))),
        imageWidth: 75,
        testId: "servicedesk-organizations-contacts-common.common.ui.details-error-state.error-state"
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $08da2d03ded977ef$var$EmptyStateContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4zdiv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eoDeF", function(module, exports) {
module.exports = new URL("error-white.e2723ea8.svg", import.meta.url).toString();

});

parcelRegister("hkixE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fedbb3e145fe8d94$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fedbb3e145fe8d94$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "servicedesk-organizations-contacts-common.common.attributes.error-state.header",
        "defaultMessage": "Something went wrong"
    }
});

});


parcelRegister("jlyhl", function(module, exports) {

$parcel$export(module.exports, "ExperienceFailure", () => $2587709c78421de9$export$eed1d73ebdd8c7ab);

var $eUqFw = parcelRequire("eUqFw");
const $2587709c78421de9$export$eed1d73ebdd8c7ab = ({ experience: experience })=>{
    (0, $eUqFw.useEffect)(()=>{
        experience.failure();
    }, [
        experience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};

});

parcelRegister("lt8wy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cebd4200dce29490$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cebd4200dce29490$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    descriptionCustomer: {
        "id": "servicedesk-customer-service-issue-view-panel.common.details.error-state.description-customer",
        "defaultMessage": "We were unable to load customer details. Refresh the page to try again."
    },
    descriptionOrganization: {
        "id": "servicedesk-customer-service-issue-view-panel.common.details.error-state.description-organization",
        "defaultMessage": "We were unable to load organization details. Refresh the page to try again."
    },
    descriptionEntitlement: {
        "id": "servicedesk-customer-service-issue-view-panel.common.details.error-state.description-entitlement",
        "defaultMessage": "We were unable to load entitlement details. Refresh the page to try again."
    }
});

});





parcelRegister("kqjx6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6465a57fc4071432$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6465a57fc4071432$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    organizationDetailsHeader: {
        "id": "servicedesk-customer-service-issue-view-panel.common.customer-organizations.organization-details-header",
        "defaultMessage": "Organization Details"
    }
});

});




parcelRegister("k1N5C", function(module, exports) {

$parcel$export(module.exports, "Entitlement", () => $df3f6a7e3fc39d95$export$7b20d168ba04011b);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");

var $bDFc6 = parcelRequire("bDFc6");

var $dWLk9 = parcelRequire("dWLk9");

var $k8QAP = parcelRequire("k8QAP");

var $6uuIf = parcelRequire("6uuIf");

var $l43Kj = parcelRequire("l43Kj");

var $7B7Gy = parcelRequire("7B7Gy");

var $ky9uU = parcelRequire("ky9uU");

var $1iEXD = parcelRequire("1iEXD");
const $df3f6a7e3fc39d95$export$7b20d168ba04011b = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [queryReference, loadQuery, disposeQuery] = (0, $iWLL0.useQueryLoader)((0, $bDFc6.default));
    const fieldValue = (0, $k8QAP.useEntitlementFieldValue)();
    const idRef = (0, $eUqFw.useRef)(fieldValue?.id);
    const hasQueryReference = !!queryReference;
    (0, $eUqFw.useEffect)(()=>{
        if (isOpen && (!fieldValue || idRef.current !== fieldValue?.id)) setIsOpen(false);
        if (!isOpen && hasQueryReference) disposeQuery();
        idRef.current = fieldValue?.id;
    }, [
        loadQuery,
        disposeQuery,
        fieldValue,
        cloudId,
        isOpen,
        hasQueryReference
    ]);
    const onToggle = ()=>{
        setIsOpen((prev)=>{
            if (!prev && fieldValue) loadQuery({
                cloudId: cloudId,
                entitlementId: fieldValue.id,
                includePlatformValue: (0, $1ybV0.ff)('csm-shipit-58-user-custom-detail-type_be1zw')
            });
            return !prev;
        });
    };
    if (!fieldValue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    const entitlement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "servicedesk-customer-service-issue-view-panel.ui.entitlement.field-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uuIf.Header), null, formatMessage((0, $ky9uU.default).entitlement)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l43Kj.ExpandPanel), {
        id: "entitlement",
        onToggle: onToggle,
        field: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7B7Gy.EntitlementField), {
            name: fieldValue.product.name
        }),
        isOpen: isOpen,
        source: "ENTITLEMENT_FIELD"
    }, isOpen && queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "servicedesk-customer-service-issue-view-panel.ui.entitlement.div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iEXD.PanelView), {
        queryReference: queryReference
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $1ybV0.ff)('products-and-entitlements-details-m2_45b1j') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "issueViewPanelEntitlementDetails",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, entitlement) : entitlement);
};

});
parcelRegister("bDFc6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3b0ac5c55a33af3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<790219fc44685d30bf178136dc4712fd>>
 * @relayHash b1b50043c4eb6f55ccc8dfdce9ea1cac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bc5e7435f30d8461079767e6bc22d474b622e232f10822e152529d9128292693
const $c3b0ac5c55a33af3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entitlementId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includePlatformValue"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "entitlementId",
            "variableName": "entitlementId"
        },
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "context": {
                    "type": "ISSUE"
                }
            }
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "identifier"
            },
            {
                "kind": "ScalarField",
                "name": "message"
            },
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusCode"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ]
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "panelViewEntitlementQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementById",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "details",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "includePlatformValue",
                                                                    "variableName": "includePlatformValue"
                                                                }
                                                            ],
                                                            "kind": "FragmentSpread",
                                                            "name": "detailsView_servicedeskCustomerServiceIssueViewPanel"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CustomerServiceEntitlement"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.entitlementById"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "panelViewEntitlementQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "details",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceCustomDetailValue",
                                                            "kind": "LinkedField",
                                                            "name": "results",
                                                            "plural": true,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "values"
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailType",
                                                                    "kind": "LinkedField",
                                                                    "name": "type",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "options"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "config",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                                                            "kind": "LinkedField",
                                                                            "name": "styleConfiguration",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "options",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "optionValue"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "style",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "backgroundColour"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "includePlatformValue",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "platformValue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "accountId"
                                                                                        },
                                                                                        v5 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "avatarUrl"
                                                                                        }
                                                                                    ],
                                                                                    "type": "CustomerServiceUserDetailValue"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "CustomerServiceCustomDetailValues"
                                                },
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceEntitlement"
                                },
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bc5e7435f30d8461079767e6bc22d474b622e232f10822e152529d9128292693",
            "metadata": {},
            "name": "panelViewEntitlementQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c3b0ac5c55a33af3$var$node.hash = "6ce35b5740415552a059d5b86c24091d";
var $c3b0ac5c55a33af3$export$2e2bcd8739ae039 = $c3b0ac5c55a33af3$var$node;

});

parcelRegister("7B7Gy", function(module, exports) {

$parcel$export(module.exports, "EntitlementField", () => $facfa27ce106c304$export$48549219ad5358dc);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $guDlK = parcelRequire("guDlK");

var $hSXNT = parcelRequire("hSXNT");
var $jT6J2 = parcelRequire("jT6J2");

var $k8QAP = parcelRequire("k8QAP");

var $7JmTk = parcelRequire("7JmTk");
const $facfa27ce106c304$var$getEntityType = (typename)=>{
    switch(typename){
        case 'JiraServiceManagementEntitlementCustomer':
            return 'CUSTOMER';
        case 'JiraServiceManagementEntitlementOrganization':
            return 'ORGANIZATION';
        case 'CustomerServiceIndividual':
            return 'CUSTOMER';
        case 'CustomerServiceOrganization':
            return 'ORGANIZATION';
        default:
            return undefined;
    }
};
const $facfa27ce106c304$export$48549219ad5358dc = ({ name: name })=>{
    const { push: push } = (0, $jT6J2.useRouterPush)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const fieldValue = (0, $k8QAP.useEntitlementFieldValue)();
    if ((0, $1ybV0.ff)('products-and-entitlements-details-m2_45b1j')) {
        const entityType = $facfa27ce106c304$var$getEntityType(fieldValue?.entity?.__typename);
        if (!fieldValue || !fieldValue.entity || !entityType) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
        const { id: id, product: product } = fieldValue;
        const profileURL = `${(0, $7JmTk.getProfileUrl)(projectKey, entityType, fieldValue.entity.id)}?selectedEntitlement=${id}`;
        const onClick = (e)=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'viewCustomerContextProfile', {
                context: 'ENTITLEMENT'
            });
            push(e, profileURL);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.100",
            alignBlock: "center",
            xcss: $facfa27ce106c304$var$containerStyles,
            testId: "servicedesk-customer-service-issue-view-panel.ui.entitlement.entitlement-field.inline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSXNT.LabelIcon), {
            size: "small",
            type: "PRODUCT"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "span",
            xcss: $facfa27ce106c304$var$nameStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            onClick: onClick,
            href: profileURL
        }, product.name)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $facfa27ce106c304$var$containerStyles,
        testId: "servicedesk-customer-service-issue-view-panel.ui.entitlement.entitlement-field.inline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSXNT.LabelIcon), {
        size: "small",
        type: "PRODUCT"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $facfa27ce106c304$var$nameStyles
    }, name));
};
const $facfa27ce106c304$var$containerStyles = (0, $1ZAYh.xcss)({
    overflowWrap: 'anywhere'
});
const $facfa27ce106c304$var$nameStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexWrap: 'wrap',
    lineHeight: 1,
    wordBreak: 'break-word'
});

});
parcelRegister("hSXNT", function(module, exports) {

$parcel$export(module.exports, "LabelIcon", () => $88a66dca9a0a6eb8$export$6722f2abd5aa752a);

var $eUqFw = parcelRequire("eUqFw");

var $2OpmI = parcelRequire("2OpmI");

var $bKtyL = parcelRequire("bKtyL");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");
const $88a66dca9a0a6eb8$export$6722f2abd5aa752a = ({ size: size, type: type, label: label = '', ...etc })=>{
    const Icon = type === 'ORGANIZATION' ? (0, (/*@__PURE__*/$parcel$interopDefault($bKtyL))) : (0, (/*@__PURE__*/$parcel$interopDefault($2OpmI)));
    const iconSize = size === 'large' ? 'large' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $88a66dca9a0a6eb8$var$containerStyles,
            size === 'large' && $88a66dca9a0a6eb8$var$largeStyles,
            size === 'small' && $88a66dca9a0a6eb8$var$smallStyles,
            size === 'xsmall' && $88a66dca9a0a6eb8$var$xsmallStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        primaryColor: `var(--ds-icon, ${(0, $PdmhA).N500})`,
        size: iconSize,
        label: label,
        ...etc
    }));
};
const $88a66dca9a0a6eb8$var$containerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    backgroundColor: 'color.background.neutral'
});
const $88a66dca9a0a6eb8$var$largeStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    padding: 'space.050'
});
const $88a66dca9a0a6eb8$var$smallStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.050',
    padding: 'space.050'
});
const $88a66dca9a0a6eb8$var$xsmallStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.050',
    padding: 'space.025'
});

});
parcelRegister("2OpmI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20c3ed57b318b9b4$var$_react = $20c3ed57b318b9b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $20c3ed57b318b9b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $20c3ed57b318b9b4$var$LabelIcon = (props)=>/*#__PURE__*/ $20c3ed57b318b9b4$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.433 5.428l-4.207.6A2 2 0 005.53 7.727l-.6 4.207a1 1 0 00.281.849l6.895 6.894a.999.999 0 001.414 0l5.657-5.657a1 1 0 000-1.414L12.282 5.71a.998.998 0 00-.849-.283m-.647 5.858A1.666 1.666 0 118.43 8.929a1.666 1.666 0 012.357 2.357" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$20c3ed57b318b9b4$var$LabelIcon.displayName = 'LabelIcon';
var $20c3ed57b318b9b4$var$_default = $20c3ed57b318b9b4$var$LabelIcon;
module.exports.default = $20c3ed57b318b9b4$var$_default;

});


parcelRegister("jT6J2", function(module, exports) {

$parcel$export(module.exports, "useRouterPush", () => $a0e9fb826ea922bf$export$315039e9daf924e5);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");
const $a0e9fb826ea922bf$export$315039e9daf924e5 = ()=>{
    const { push: routerPush } = (0, $kJlBc.useRouterActions)();
    const push = (0, $eUqFw.useCallback)((event, ...pushArgs)=>{
        if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
        event.preventDefault();
        routerPush(...pushArgs);
    }, [
        routerPush
    ]);
    return {
        push: push
    };
};

});


parcelRegister("ky9uU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7557e23bcc6bb9c7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7557e23bcc6bb9c7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    entitlement: {
        "id": "servicedesk-customer-service-issue-view-panel.entitlement.entitlement",
        "defaultMessage": "Entitlement details"
    }
});

});

parcelRegister("1iEXD", function(module, exports) {

$parcel$export(module.exports, "PanelView", () => $726a463823959cd9$export$155ca5d268e0664d);

var $bDFc6 = parcelRequire("bDFc6");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $hJ992 = parcelRequire("hJ992");

var $kdPjr = parcelRequire("kdPjr");

var $guDlK = parcelRequire("guDlK");

var $acemj = parcelRequire("acemj");

var $2fy56 = parcelRequire("2fy56");
var $7JmTk = parcelRequire("7JmTk");

var $9NLaB = parcelRequire("9NLaB");

var $4RPod = parcelRequire("4RPod");
const $726a463823959cd9$var$Inner = ({ queryReference: queryReference })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const { customerService: { entitlementById: entitlementById } } = (0, $iWLL0.usePreloadedQuery)((0, $bDFc6.default), queryReference);
    if (entitlementById.__typename !== 'CustomerServiceEntitlement') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $acemj.ThrowOnQueryError), {
        operationName: "panelViewEntitlementQuery",
        errorRef: entitlementById.__typename === 'QueryError' ? entitlementById : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2fy56.DetailsView), {
        entityType: "ENTITLEMENT",
        editDetailsUrl: (0, $7JmTk.getEditDetailsUrlByEntityType)(projectKey, 'ENTITLEMENT'),
        details: entitlementById.details,
        entityExperience: (0, $4RPod.customerServiceIssueViewPanelEntitlementExperience)
    });
};
const $726a463823959cd9$export$155ca5d268e0664d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9NLaB.DetailsContainer), {
        context: "ENTITLEMENT",
        entityExperience: (0, $4RPod.customerServiceIssueViewPanelEntitlementExperience)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kdPjr.FieldsCompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($726a463823959cd9$var$Inner, props)));

});


parcelRegister("yQm3X", function(module, exports) {

$parcel$export(module.exports, "Organizations", () => $77d99ab757e13909$export$8cdb1b004e612f6c);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6uuIf = parcelRequire("6uuIf");

var $9H1Az = parcelRequire("9H1Az");

var $7NEIP = parcelRequire("7NEIP");
const $77d99ab757e13909$export$8cdb1b004e612f6c = ({ fieldValue: fieldValue })=>{
    const numOrganizations = fieldValue ? fieldValue.length : 0;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return fieldValue && numOrganizations !== 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uuIf.Header), null, formatMessage((0, $7NEIP.default).organizations)), fieldValue.map((org, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9H1Az.Organization), {
            organization: org,
            key: org.id,
            isLast: idx === numOrganizations - 1,
            panelSource: "ORGANIZATIONS_FIELD"
        }))) : null;
};

});
parcelRegister("7NEIP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9609c9a902f29292$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9609c9a902f29292$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    organizations: {
        "id": "servicedesk-customer-service-issue-view-panel.organizations.organizations",
        "defaultMessage": "Organization details"
    }
});

});



parcelRegister("5WN84", function(module, exports) {

$parcel$export(module.exports, "AsyncIncidentSummary", () => $3c8b5617a4b54baa$export$8999e2be5d6c0e3d);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3c8b5617a4b54baa$var$LazyIncidentSummary = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("7CAU1")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/post-incident-review/src/ui/incident-summary/index.tsx"
});
const $3c8b5617a4b54baa$export$8999e2be5d6c0e3d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "servicedesk-pir-incident-summary",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c8b5617a4b54baa$var$LazyIncidentSummary, null));

});
parcelRegister("7CAU1", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('c9k9t');
        const value = parcelRequire('6s1sQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("c9k9t").then(()=>parcelRequire('6s1sQ'));
}

});


const $9de389cf3f7379b6$export$48e1d3fa57b0a2d5 = 'itsmPIRIncidentTour';
const $9de389cf3f7379b6$export$7fbdff570537bda1 = 'incident-review-button';
const $9de389cf3f7379b6$export$38d30b5abe6d2a6d = 'primary-incident-section';
const $9de389cf3f7379b6$export$2f18a1056f942774 = 'incident-summary-section';
const $9de389cf3f7379b6$export$5e3a86f072125886 = 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-post-incident-reviews/';

parcelRegister("dkDhN", function(module, exports) {

$parcel$export(module.exports, "getStatusGroupCode", () => $b6b9c8821e38a7cf$export$557a4ea43a4f56b);
$parcel$export(module.exports, "useSlaDetails", () => $b6b9c8821e38a7cf$export$af3c1ad4fdc0a999);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");
var $2OdyW = parcelRequire("2OdyW");

var $4ksts = parcelRequire("4ksts");

var $hJ992 = parcelRequire("hJ992");

var $cWiVr = parcelRequire("cWiVr");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $4xHig = parcelRequire("4xHig");

var $dQrpX = parcelRequire("dQrpX");
const $b6b9c8821e38a7cf$var$PREFIX = 'issue.sla-panel.sla';
const $b6b9c8821e38a7cf$var$LOG_LOCATION = 'sla-panel.fetch.sla';
const $b6b9c8821e38a7cf$var$TWO_MINUTES_POLLING_INTERVAL = 120000;
const $b6b9c8821e38a7cf$var$getDuration = (startTime)=>Date.now() - startTime;
const $b6b9c8821e38a7cf$var$checkIfBrowserTabFocused = ()=>document && document.visibilityState === 'visible';
const $b6b9c8821e38a7cf$var$toError = (e)=>e instanceof Error ? e : new Error(e);
const $b6b9c8821e38a7cf$export$557a4ea43a4f56b = (error)=>{
    if (error instanceof (0, $7byHA.default)) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        return statusCodeGroup;
    }
    return 'missing-info';
};
const $b6b9c8821e38a7cf$var$handleFailureWithAnalytics = (error, startTime, isFirstLoad, issueKey, wasTabFocusedBeforeApiCall)=>{
    const analyticsFailurePayload = {
        issueKey: issueKey,
        duration: $b6b9c8821e38a7cf$var$getDuration(startTime),
        isFirstLoad: isFirstLoad
    };
    (0, $guiFP.default)({
        meta: {
            id: 'sla-issue-view-fetch',
            teamName: 'bumblebee'
        },
        error: $b6b9c8821e38a7cf$var$toError(error),
        attributes: {
            ...analyticsFailurePayload,
            statusCodeGroup: $b6b9c8821e38a7cf$export$557a4ea43a4f56b(error)
        },
        sendToPrivacyUnsafeSplunk: true
    });
    (0, $gUUjF.default).safeErrorWithoutCustomerData($b6b9c8821e38a7cf$var$LOG_LOCATION, '[FD-4458] SLA_FETCH_REQUEST: Failed to fetch sla data', {
        ...error,
        isFirstLoad: isFirstLoad,
        tabFocusBeforeApiCall: wasTabFocusedBeforeApiCall,
        tabFocusAfterApiCall: $b6b9c8821e38a7cf$var$checkIfBrowserTabFocused()
    });
};
const $b6b9c8821e38a7cf$var$handleSuccessWithAnalytics = (sla, startTime, isFirstLoad, issueKey, wasTabFocusedBeforeApiCall, createAnalyticsEvent)=>{
    const analyticsPayload = {
        issueKey: issueKey,
        numberOfSla: sla.goalViews.length,
        duration: $b6b9c8821e38a7cf$var$getDuration(startTime),
        isFirstLoad: isFirstLoad
    };
    (0, $gUUjF.default).safeInfoWithoutCustomerData($b6b9c8821e38a7cf$var$LOG_LOCATION, 'sla-issue-view-fetch-success', {
        isFirstLoad: isFirstLoad,
        tabFocusBeforeApiCall: wasTabFocusedBeforeApiCall,
        tabFocusAfterApiCall: $b6b9c8821e38a7cf$var$checkIfBrowserTabFocused()
    });
    (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'sla-issue-view-fetch success', $b6b9c8821e38a7cf$var$PREFIX, {
        ...analyticsPayload
    });
};
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
const $b6b9c8821e38a7cf$var$useInterval = (callback, delay)=>{
    const savedCallback = (0, $eUqFw.useRef)(callback);
    // Remember the latest callback.
    (0, $eUqFw.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0, $eUqFw.useEffect)(()=>{
        const tick = ()=>{
            savedCallback.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
        return 0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu));
    }, [
        delay
    ]);
};
const $b6b9c8821e38a7cf$export$9a9f639ff271f05d = (issueKey)=>`/rest/servicedesk/1/servicedesk/sla/issue/${issueKey}`;
const $b6b9c8821e38a7cf$export$af3c1ad4fdc0a999 = ()=>{
    const [data, setData] = (0, $eUqFw.useState)();
    const [error, setError] = (0, $eUqFw.useState)();
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const [isFirstLoad, setIsFirstLoad] = (0, $eUqFw.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const intl = (0, $4ksts.useIntlV2)();
    const userData = (0, $cWiVr.useCurrentUser)();
    const userTimezone = (0, $eUqFw.useRef)((0, $dQrpX.EMPTY_TIMEZONE));
    const locale = (0, $4xHig.useLocale)();
    const fetchSlaDetails = (0, $eUqFw.useCallback)(async ()=>{
        const startTime = Date.now();
        const isTabFocusedBeforeApiCall = $b6b9c8821e38a7cf$var$checkIfBrowserTabFocused();
        try {
            setLoading(true);
            const url = $b6b9c8821e38a7cf$export$9a9f639ff271f05d(issueKey);
            const response = await (0, $2OdyW.default)(url, {
                method: 'GET'
            });
            if (response.errors) {
                $b6b9c8821e38a7cf$var$handleFailureWithAnalytics(response, startTime, isFirstLoad, issueKey, isTabFocusedBeforeApiCall);
                setError(JSON.stringify(response));
            } else {
                $b6b9c8821e38a7cf$var$handleSuccessWithAnalytics(response, startTime, isFirstLoad, issueKey, isTabFocusedBeforeApiCall, createAnalyticsEvent);
                setData((0, $dQrpX.transformSla)(response, userTimezone.current, intl, locale));
                setIsFirstLoad(false);
            }
            setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            $b6b9c8821e38a7cf$var$handleFailureWithAnalytics(err, startTime, isFirstLoad, issueKey, isTabFocusedBeforeApiCall);
            setError(err);
            setLoading(false);
        }
    // If isFirstLoad is a dependency it ends up running the fetch an extra time when it is set to false
    // The alternative is extracting it outside this method but we need to wait for it to complete
    // before updating
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        issueKey
    ]);
    (0, $eUqFw.useEffect)(()=>{
        fetchSlaDetails();
    }, [
        fetchSlaDetails
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'timeZone' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
        const newTimezoneValue = userData?.data?.user?.timeZone || (0, $dQrpX.EMPTY_TIMEZONE);
        if (newTimezoneValue !== (0, $dQrpX.EMPTY_TIMEZONE) && newTimezoneValue !== userTimezone.current) {
            userTimezone.current = newTimezoneValue; // The user timezone value has changed
            if ((0, $1ybV0.ff)('SLA-530-user-Timezone-Bug-FF')) fetchSlaDetails();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userData
    ]);
    // Fetch polls every 2 mins to give live updating. Stop polling if there is an error
    $b6b9c8821e38a7cf$var$useInterval(()=>{
        $b6b9c8821e38a7cf$var$checkIfBrowserTabFocused() && fetchSlaDetails();
    }, error == null ? $b6b9c8821e38a7cf$var$TWO_MINUTES_POLLING_INTERVAL : null);
    return [
        data,
        error,
        loading,
        isFirstLoad
    ];
};

});
parcelRegister("dQrpX", function(module, exports) {

$parcel$export(module.exports, "EMPTY_TIMEZONE", () => $aee71faa5d3857f8$export$77ab596273fc45d);
$parcel$export(module.exports, "getHoverContent", () => $aee71faa5d3857f8$export$c6033f9c203576c4);
$parcel$export(module.exports, "transformSla", () => $aee71faa5d3857f8$export$d515f22ceb25262e);
// Todo clean moment after soaking this change for a while @AAG

var $6wqPF = parcelRequire("6wqPF");
var $3jYzf = parcelRequire("3jYzf");
var $9FEvp = parcelRequire("9FEvp");

var $4p54N = parcelRequire("4p54N");
var $bbmZl = parcelRequire("bbmZl");



var $jwKk8 = parcelRequire("jwKk8");
const $aee71faa5d3857f8$export$77ab596273fc45d = '';
const $aee71faa5d3857f8$export$3d6925841111ef4c = 'America/Toronto';
const $aee71faa5d3857f8$export$1af4c7e47ad72f44 = 'en_US';
const $aee71faa5d3857f8$export$dafe052a131a9692 = {
    timezone: $aee71faa5d3857f8$export$3d6925841111ef4c,
    locale: $aee71faa5d3857f8$export$1af4c7e47ad72f44,
    intl: undefined
};
// convert time in hh:mm format to number of mins
const $aee71faa5d3857f8$var$getMinutes = (timeInHourColonMin)=>{
    const [hours, minutes] = timeInHourColonMin.split(':');
    return +hours * 60 + +minutes;
};
const $aee71faa5d3857f8$var$getTimeRemaining = (timeInHourColonMin)=>{
    const isTimeInMinus = timeInHourColonMin.indexOf('-') === 0;
    if (isTimeInMinus) {
        const timeInHourColonMinIgnoringMinus = timeInHourColonMin.substr(1);
        return -1 * $aee71faa5d3857f8$var$getMinutes(timeInHourColonMinIgnoringMinus);
    }
    return $aee71faa5d3857f8$var$getMinutes(timeInHourColonMin);
};
const $aee71faa5d3857f8$var$getTimeRemainingInMinutes = (timeInHourSpaceMinutes)=>{
    const isTimeInMinus = timeInHourSpaceMinutes.indexOf('-') === 0;
    const absoluteTime = isTimeInMinus ? timeInHourSpaceMinutes.substring(1) : timeInHourSpaceMinutes;
    const [hoursStr = '0', minutesStr = '0'] = absoluteTime.split(':');
    const hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);
    const totalMinutes = hours * 60 + minutes;
    return isTimeInMinus ? -1 * totalMinutes : totalMinutes;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $aee71faa5d3857f8$var$getPercentageOfTimeTaken = (goalTime, remainingTime)=>{
    const goalTimeInMinutes = $aee71faa5d3857f8$var$getTimeRemainingInMinutes(goalTime);
    const remainingTimeInMinutes = $aee71faa5d3857f8$var$getTimeRemainingInMinutes(remainingTime);
    let percentage = (goalTimeInMinutes - remainingTimeInMinutes) / goalTimeInMinutes;
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number'.
    percentage = (percentage * 100).toFixed(2);
    // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
    return Math.round(parseInt(percentage, 10)).toString();
};
const $aee71faa5d3857f8$export$c6033f9c203576c4 = (closed, remainingTime, breachTime, goalTime, goalTimeLong, remainingTimeLong)=>{
    const isTimeInMinus = remainingTimeLong.indexOf('-') === 0;
    let remainingTimeString;
    let timeStatus;
    if (isTimeInMinus) {
        remainingTimeString = remainingTimeLong.substring(1);
        timeStatus = $aee71faa5d3857f8$export$dafe052a131a9692.intl?.formatMessage((0, $jwKk8.default).past);
    } else {
        remainingTimeString = remainingTimeLong;
        timeStatus = $aee71faa5d3857f8$export$dafe052a131a9692.intl?.formatMessage((0, $jwKk8.default).left);
    }
    const getBreachTime = ()=>breachTime || ($aee71faa5d3857f8$export$dafe052a131a9692.intl ? $aee71faa5d3857f8$export$dafe052a131a9692.intl.formatMessage((0, $jwKk8.default).notApplicable) : 'undefined');
    if (closed === true) {
        timeStatus = isTimeInMinus ? $aee71faa5d3857f8$export$dafe052a131a9692.intl?.formatMessage((0, $jwKk8.default).breached) : $aee71faa5d3857f8$export$dafe052a131a9692.intl?.formatMessage((0, $jwKk8.default).met);
        const percentage = $aee71faa5d3857f8$var$getPercentageOfTimeTaken(goalTime, remainingTime);
        const hoverContentCompleted = `${isTimeInMinus ? `-${remainingTimeString}` : remainingTimeString} ${timeStatus ?? ''} ${String.fromCodePoint(0x2022)} ${percentage}% of ${goalTimeLong} ${String.fromCodePoint(0x2022)} ${getBreachTime()}`;
        return hoverContentCompleted;
    }
    const hoverContent = `${remainingTimeString} ${timeStatus ?? ''} ${String.fromCodePoint(0x2022)} ${$aee71faa5d3857f8$export$dafe052a131a9692.intl?.formatMessage((0, $jwKk8.default).due) ?? ''}: ${breachTime}`;
    return hoverContent;
};
const $aee71faa5d3857f8$var$getBreachTimeInLocalString = (breachTimeInEpochMillis)=>{
    if (breachTimeInEpochMillis) {
        const BREACH_DATE = (0, $bbmZl.default)(breachTimeInEpochMillis, $aee71faa5d3857f8$export$dafe052a131a9692.timezone);
        const formattedDate = `${(0, $4p54N.default)(BREACH_DATE, 'yyyy-MM-dd hh:mma ', {
            timeZone: $aee71faa5d3857f8$export$dafe052a131a9692.timezone
        })}GMT${(0, $4p54N.default)(BREACH_DATE, 'xx', {
            timeZone: $aee71faa5d3857f8$export$dafe052a131a9692.timezone
        })}`;
        return formattedDate;
    }
    return '';
};
const $aee71faa5d3857f8$var$getBreachTimeInLocalStringForLocale = (breachTimeInEpochMillis)=>{
    if (breachTimeInEpochMillis) {
        const BREACH_DATE = (0, $bbmZl.default)(breachTimeInEpochMillis, $aee71faa5d3857f8$export$dafe052a131a9692.timezone);
        const formattedDate = `${$aee71faa5d3857f8$export$dafe052a131a9692.intl?.formatDate(breachTimeInEpochMillis, {
            hour12: !$aee71faa5d3857f8$export$afaa259d1ad4dc39(),
            timeZone: $aee71faa5d3857f8$export$dafe052a131a9692.timezone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        })} GMT${(0, $4p54N.default)(BREACH_DATE, 'xxx', {
            timeZone: $aee71faa5d3857f8$export$dafe052a131a9692.timezone
        })}`;
        return formattedDate;
    }
    return '';
};
const $aee71faa5d3857f8$export$afaa259d1ad4dc39 = ()=>{
    let { locale: locale } = $aee71faa5d3857f8$export$dafe052a131a9692;
    if (locale === undefined) locale = 'en_US';
    const localeString = locale.replace('_', '-');
    const dateTimeFormat = new Intl.DateTimeFormat(localeString, {
        hour: 'numeric'
    });
    return !dateTimeFormat.format(0).match(/[A/P]M/);
};
const $aee71faa5d3857f8$var$getDays = (timezone)=>{
    const date = (0, $bbmZl.default)(new Date(), timezone);
    return [
        (0, $3jYzf.default)(date),
        (0, $3jYzf.default)((0, $6wqPF.default)(date, 1)),
        (0, $3jYzf.default)((0, $9FEvp.default)(date, 1))
    ];
};
const $aee71faa5d3857f8$export$146f4bb901e5707f = (receivedDate, timezone, daysArray)=>{
    const [today, tomorrow, yesterday] = daysArray || $aee71faa5d3857f8$var$getDays(timezone);
    // @ts-expect-error - TS7006 - Parameter 'dateOne' implicitly has an 'any' type.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isSame = (dateOne, dateTwo)=>dateOne.getDate() === dateTwo.getDate() && dateOne.getMonth() === dateTwo.getMonth() && dateOne.getFullYear() === dateTwo.getFullYear();
    const isToday = isSame(today, receivedDate);
    const isTomorrow = isSame(tomorrow, receivedDate);
    const isYesterday = isSame(yesterday, receivedDate);
    let defaultDayFormat = (0, $4p54N.default)(receivedDate, 'd MMM');
    if ($aee71faa5d3857f8$export$dafe052a131a9692.intl) {
        isToday && (defaultDayFormat = $aee71faa5d3857f8$export$dafe052a131a9692.intl.formatMessage((0, $jwKk8.default).today));
        isTomorrow && (defaultDayFormat = $aee71faa5d3857f8$export$dafe052a131a9692.intl.formatMessage((0, $jwKk8.default).tomorrow));
        isYesterday && (defaultDayFormat = $aee71faa5d3857f8$export$dafe052a131a9692.intl.formatMessage((0, $jwKk8.default).yesterday));
    }
    return defaultDayFormat;
};
const $aee71faa5d3857f8$export$55b8dadb3fe847df = (receivedDate, timezone, timeInEpochMillis, daysArray)=>{
    const [today, tomorrow, yesterday] = daysArray || $aee71faa5d3857f8$var$getDays(timezone);
    // @ts-expect-error - TS7006 - Parameter 'dateOne' implicitly has an 'any' type.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isSame = (dateOne, dateTwo)=>dateOne.getDate() === dateTwo.getDate() && dateOne.getMonth() === dateTwo.getMonth() && dateOne.getFullYear() === dateTwo.getFullYear();
    const isToday = isSame(today, receivedDate);
    const isTomorrow = isSame(tomorrow, receivedDate);
    const isYesterday = isSame(yesterday, receivedDate);
    let defaultDayFormat = $aee71faa5d3857f8$export$dafe052a131a9692.intl?.formatDate(timeInEpochMillis, {
        timeZone: $aee71faa5d3857f8$export$dafe052a131a9692.timezone,
        day: '2-digit',
        month: 'short'
    });
    if ($aee71faa5d3857f8$export$dafe052a131a9692.intl) {
        isToday && (defaultDayFormat = $aee71faa5d3857f8$export$dafe052a131a9692.intl.formatMessage((0, $jwKk8.default).today));
        isTomorrow && (defaultDayFormat = $aee71faa5d3857f8$export$dafe052a131a9692.intl.formatMessage((0, $jwKk8.default).tomorrow));
        isYesterday && (defaultDayFormat = $aee71faa5d3857f8$export$dafe052a131a9692.intl.formatMessage((0, $jwKk8.default).yesterday));
    }
    return defaultDayFormat;
};
const $aee71faa5d3857f8$var$formatTimeAndDateForLocale = (timeInEpochMillis)=>{
    const { timezone: timezone } = $aee71faa5d3857f8$export$dafe052a131a9692;
    const timeTz = (0, $bbmZl.default)(timeInEpochMillis, timezone);
    return `${$aee71faa5d3857f8$export$55b8dadb3fe847df(timeTz, timezone, timeInEpochMillis)} ${$aee71faa5d3857f8$export$dafe052a131a9692.intl?.formatDate(timeInEpochMillis, {
        hour12: !$aee71faa5d3857f8$export$afaa259d1ad4dc39(),
        timeZone: timezone,
        hour: '2-digit',
        minute: '2-digit'
    })}`;
};
const $aee71faa5d3857f8$export$bf50589cd2c12a72 = (closed, breachTimeInEpochMillis, stopTimeInEpochMillis)=>{
    if (closed && stopTimeInEpochMillis) return $aee71faa5d3857f8$var$formatTimeAndDateForLocale(stopTimeInEpochMillis);
    if (breachTimeInEpochMillis) return $aee71faa5d3857f8$var$formatTimeAndDateForLocale(breachTimeInEpochMillis);
    return '';
};
const $aee71faa5d3857f8$var$transformCompleteGoals = ({ failed: failed, breachTimeInEpochMillis: breachTimeInEpochMillis, remainingTimeLong: remainingTimeLong, startTime: startTime, stopTime: stopTime, goalTimeLong: goalTimeLong, remainingTime: remainingTime, goalTime: goalTime })=>({
        failed: failed,
        remainingTimeLong: remainingTimeLong,
        goalTimeLong: goalTimeLong,
        startTime: startTime,
        stopTime: stopTime,
        remainingTime: remainingTime,
        goalTime: goalTime,
        breachTimeInEpochMillis: $aee71faa5d3857f8$var$getBreachTimeInLocalString(breachTimeInEpochMillis)
    });
const $aee71faa5d3857f8$var$transformGoalView = ({ active: active, paused: paused, closed: closed, failed: failed, remainingTime: remainingTime, remainingTimeLong: remainingTimeLong, goalTimeLong: goalTimeLong, goalTime: goalTime, metricName: metricName, calendarName: calendarName, stopTime: stopTime, completeGoals: completeGoals, breachTimeInEpochMillis: breachTimeInEpochMillis, stopTimeInEpochMillis: stopTimeInEpochMillis, slaDisplayFormat: slaDisplayFormat = (0, $feae9f437bfca243$export$13ecaaf97b049384) })=>{
    const shouldDisplaySlaInNewFormat = slaDisplayFormat === (0, $feae9f437bfca243$export$13ecaaf97b049384);
    let status = (0, $8f398e8176e5defb$export$d1917132a74c7b93);
    // When an Sla is paused due to being outside of working hours, the paused value is false
    if (paused || !active) // @ts-expect-error - TS2322 - Type '"PAUSED"' is not assignable to type '"ONGOING"'.
    status = (0, $8f398e8176e5defb$export$3ad39751a33c16b8);
    // closed
    if (closed) // @ts-expect-error - TS2322 - Type '"COMPLETED"' is not assignable to type '"ONGOING"'.
    status = (0, $8f398e8176e5defb$export$fc332a617fd34192);
    const timeRemainingInMinutes = $aee71faa5d3857f8$var$getTimeRemaining(remainingTime);
    const isBreached = failed || timeRemainingInMinutes < 0;
    const timeInSlaFriendlierFormat = (shouldDisplaySlaInNewFormat && $aee71faa5d3857f8$export$bf50589cd2c12a72(closed, breachTimeInEpochMillis, stopTimeInEpochMillis)).toString();
    const timeRemainingFriendly = shouldDisplaySlaInNewFormat ? timeInSlaFriendlierFormat : remainingTimeLong;
    const breachTimeString = ()=>{
        if (breachTimeInEpochMillis) return $aee71faa5d3857f8$var$getBreachTimeInLocalStringForLocale(breachTimeInEpochMillis);
        return $aee71faa5d3857f8$export$dafe052a131a9692.intl?.formatMessage((0, $jwKk8.default).notApplicable);
    };
    const hoverContent = shouldDisplaySlaInNewFormat ? $aee71faa5d3857f8$export$c6033f9c203576c4(closed, remainingTime, breachTimeString(), goalTime, goalTimeLong, remainingTimeLong) : undefined;
    return {
        isBreached: isBreached,
        timeRemainingInMinutes: timeRemainingInMinutes,
        status: status,
        timeRemainingFriendly: timeRemainingFriendly,
        metricName: metricName,
        goalTime: goalTimeLong,
        calendarName: calendarName,
        stopTime: stopTime,
        previousCycles: shouldDisplaySlaInNewFormat ? completeGoals.map($aee71faa5d3857f8$var$transformCompleteGoals) : completeGoals,
        hoverContent: hoverContent,
        slaDisplayFormat: slaDisplayFormat
    };
};
const $aee71faa5d3857f8$export$d515f22ceb25262e = ({ goalViews: goalViews, hasPreviousCycles: hasPreviousCycles }, timezone, intl, locale)=>{
    if (timezone !== $aee71faa5d3857f8$export$77ab596273fc45d) $aee71faa5d3857f8$export$dafe052a131a9692.timezone = timezone;
    $aee71faa5d3857f8$export$dafe052a131a9692.intl = intl;
    if (locale !== undefined) $aee71faa5d3857f8$export$dafe052a131a9692.locale = locale;
    const transformedGoalViews = goalViews.map($aee71faa5d3857f8$var$transformGoalView);
    return {
        hasPreviousCycles: hasPreviousCycles,
        goalViews: transformedGoalViews
    };
};

});
const $feae9f437bfca243$export$aad60a8e044b5914 = 'OLD_SLA_FORMAT';
const $feae9f437bfca243$export$13ecaaf97b049384 = 'NEW_SLA_FORMAT';

const $8f398e8176e5defb$export$d1917132a74c7b93 = 'ONGOING';
const $8f398e8176e5defb$export$fc332a617fd34192 = 'COMPLETED';
const $8f398e8176e5defb$export$3ad39751a33c16b8 = 'PAUSED';

parcelRegister("jwKk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d0d7cb80c20df77$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1d0d7cb80c20df77$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    past: {
        "id": "sla-panel.past",
        "defaultMessage": "past"
    },
    left: {
        "id": "sla-panel.left",
        "defaultMessage": "left"
    },
    met: {
        "id": "sla-panel.met",
        "defaultMessage": "met"
    },
    breached: {
        "id": "sla-panel.breached",
        "defaultMessage": "breached"
    },
    due: {
        "id": "sla-panel.due",
        "defaultMessage": "Due"
    },
    today: {
        "id": "sla-panel.today",
        "defaultMessage": "Today"
    },
    tomorrow: {
        "id": "sla-panel.tomorrow",
        "defaultMessage": "Tomorrow"
    },
    yesterday: {
        "id": "sla-panel.yesterday",
        "defaultMessage": "Yesterday"
    },
    notApplicable: {
        "id": "sla-panel.not-applicable",
        "defaultMessage": "Breach time not found"
    }
});

});



parcelRegister("c4hWZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a39be2e22bd2323$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4a39be2e22bd2323$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    slaText: {
        "id": "issue-view-layout-templates-servicedesk.context.sla-text",
        "defaultMessage": "SLAs"
    },
    customerContextText: {
        "id": "issue-view-layout-templates-servicedesk.context.customer-context-text",
        "defaultMessage": "Customer"
    },
    incidentSummaryText: {
        "id": "issue-view-layout-templates-servicedesk.context.incident-summary-text",
        "defaultMessage": "Incident Summary"
    }
});

});

parcelRegister("3UTxG", function(module, exports) {

$parcel$export(module.exports, "transformCSAT", () => $d89aa80e4dc07343$export$9008adf254663f7);
$parcel$export(module.exports, "addGlobalRefs", () => $d89aa80e4dc07343$export$1b9202dc9027535a);

var $8Qd0L = parcelRequire("8Qd0L");


var $dZWHl = parcelRequire("dZWHl");

var $g8to1 = parcelRequire("g8to1");

var $lO4Or = parcelRequire("lO4Or");
// We can't directly identify `Affected services`, `Change risk` or `Impact`, but we can
// minimise the number of extra targets by wrapping only 'select' type fields since the above
// all fit that criteria. `Description` fortunately has a custom type to identify it
const $d89aa80e4dc07343$var$fieldsWithGlobalTargets = [
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.DESCRIPTION_TYPE),
    (0, $lO4Or.SERVICE_ENTITY_CF_TYPE)
];
const $d89aa80e4dc07343$export$9008adf254663f7 = (isNextGen, items, // eslint-disable-next-line @typescript-eslint/no-explicit-any
status, // eslint-disable-next-line @typescript-eslint/no-explicit-any
issueFieldsConfig, // eslint-disable-next-line @typescript-eslint/no-explicit-any
issueFieldsValues)=>{
    if (!items) return undefined;
    if (!items.visibleItems || !issueFieldsConfig || !issueFieldsValues || !status) return items;
    if (!isNextGen) return items;
    const CsatField = items.visibleItems.find((item)=>{
        const fieldConfig = issueFieldsConfig[(0, $dZWHl.getLayoutItemId)(item)];
        return fieldConfig?.schema?.custom === (0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE);
    });
    if (CsatField === undefined) return items;
    const itemsWithoutCsatField = items.visibleItems.filter((item)=>{
        const fieldConfig = issueFieldsConfig[(0, $dZWHl.getLayoutItemId)(item)];
        return fieldConfig?.schema?.custom !== (0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE);
    });
    const hasValue = issueFieldsValues[(0, $dZWHl.getLayoutItemId)(CsatField)] !== undefined && issueFieldsValues[(0, $dZWHl.getLayoutItemId)(CsatField)] !== null;
    if (status.statusCategory.id !== (0, $8Qd0L.categoryIdForStatusCategory)((0, $8Qd0L.DONE)) || !hasValue) return {
        ...items,
        visibleItems: itemsWithoutCsatField
    };
    return {
        ...items,
        visibleItems: [
            CsatField,
            ...itemsWithoutCsatField
        ]
    };
};
const $d89aa80e4dc07343$export$79ccc239fa704a26 = (items, issueFieldsConfig)=>{
    if (!items || !issueFieldsConfig) return [];
    return items.map((item)=>{
        const { type: type, id: id } = (0, $g8to1.fieldTypeHandler)(issueFieldsConfig[(0, $dZWHl.getLayoutItemId)(item)], item);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"description" | "com.atlassian.jira.plugin.system.customfieldtypes:select" | "com.atlassian.jira.plugins.service-entity:service-entity-field-cftype"'.
        if ($d89aa80e4dc07343$var$fieldsWithGlobalTargets.includes(type)) return {
            ...item,
            globalRef: `${0, $ab2aafcdf11a1361$export$2028cf1423b28cf8}${id}`
        };
        return item;
    });
};
const $d89aa80e4dc07343$export$1b9202dc9027535a = (items, issueFieldsConfig)=>({
        hiddenItems: $d89aa80e4dc07343$export$79ccc239fa704a26(items?.hiddenItems, issueFieldsConfig),
        pinnedFields: $d89aa80e4dc07343$export$79ccc239fa704a26(items?.pinnedFields, issueFieldsConfig),
        visibleItems: $d89aa80e4dc07343$export$79ccc239fa704a26(items?.visibleItems, issueFieldsConfig),
        apps: {
            contextPanels: $d89aa80e4dc07343$export$79ccc239fa704a26(items?.apps?.contextPanels ?? [], issueFieldsConfig)
        }
    });

});


parcelRegister("f9N5g", function(module, exports) {

$parcel$export(module.exports, "default", () => $076c6c31eb75294f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dmdpA = parcelRequire("dmdpA");

var $5S8lG = parcelRequire("5S8lG");

var $bLiXo = parcelRequire("bLiXo");

var $kln9T = parcelRequire("kln9T");

var $1uomc = parcelRequire("1uomc");

var $jDnEe = parcelRequire("jDnEe");

var $NfInV = parcelRequire("NfInV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$076c6c31eb75294f$export$2e2bcd8739ae039 = ({ issueViewRelayFragment: issueViewRelayFragment })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dmdpA.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $NfInV.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5S8lG.IssueViewDataClassification), {
        issueViewRelayFragment: issueViewRelayFragment ?? null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($076c6c31eb75294f$var$FoundationContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jDnEe.MajorIncidentLozengeWithTooltip), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kln9T.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($076c6c31eb75294f$var$SummaryFieldWrapper, {
        key: (0, $bLiXo.REACT_KEY_SUMMARY)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1uomc.default), null))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $076c6c31eb75294f$var$FoundationContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _1bsb1osq _2lx21bp4",
            __cmplp.className
        ])
    });
});
$076c6c31eb75294f$var$FoundationContentWrapper.displayName = 'FoundationContentWrapper';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $076c6c31eb75294f$var$SummaryFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _p7r11txw _nphskb7n _t1edkb7n _1t3b1wug",
            __cmplp.className
        ])
    });
});
$076c6c31eb75294f$var$SummaryFieldWrapper.displayName = 'SummaryFieldWrapper';

});
parcelRegister("jDnEe", function(module, exports) {

$parcel$export(module.exports, "MajorIncidentLozenge", () => $f204ab5477af9292$export$d005b05e81381a5a);
$parcel$export(module.exports, "MajorIncidentLozengeWithTooltip", () => $f204ab5477af9292$export$1f7421f79cdd882a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ffiyv = parcelRequire("ffiyv");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $2wCUM = parcelRequire("2wCUM");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ak5WI = parcelRequire("ak5WI");

var $bxn6g = parcelRequire("bxn6g");

var $byave = parcelRequire("byave");
const $f204ab5477af9292$export$d005b05e81381a5a = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "removed"
    }, formatMessage((0, $byave.default).lozengeLabel));
};
const $f204ab5477af9292$export$1f7421f79cdd882a = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ value: value }] = (0, $bxn6g.useMajorIncidentField)({
        issueKey: issueKey
    });
    const isIssueOfIncidentsPractice = (0, $2wCUM.useIsIssueOfIncidentsPractice)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const shouldRenderLozenge = isIssueOfIncidentsPractice && value === (0, $ak5WI.MAJOR_INCIDENT);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldRenderLozenge) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'majorIncidentLozenge viewed', {
            action: 'viewed',
            actionSubjectId: 'majorIncidentLozenge',
            teamName: 'jsm-getting-started'
        });
    }, [
        createAnalyticsEvent,
        shouldRenderLozenge
    ]);
    return shouldRenderLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f204ab5477af9292$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $byave.default).tootltipContent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f204ab5477af9292$export$d005b05e81381a5a, null))) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f204ab5477af9292$var$LozengeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ak5WI", function(module, exports) {

$parcel$export(module.exports, "MAJOR_INCIDENT", () => $b33156ee50c454aa$export$f5d2c3c7bebeaa98);
$parcel$export(module.exports, "SPOTLIGHT_ID", () => $b33156ee50c454aa$export$1222b4ae9a94b9ec);

var $eMxRI = parcelRequire("eMxRI");
const $b33156ee50c454aa$export$f5d2c3c7bebeaa98 = 'MAJOR_INCIDENT';
const $b33156ee50c454aa$var$MAJOR_INCIDENT_FIELD_KEY = 'major-incident-field';
const $b33156ee50c454aa$export$1222b4ae9a94b9ec = `${(0, $eMxRI.ISSUE_FIELD_SPOTLIGHT_PREFIX)}${$b33156ee50c454aa$var$MAJOR_INCIDENT_FIELD_KEY}`;

});

parcelRegister("bxn6g", function(module, exports) {

$parcel$export(module.exports, "useMajorIncidentField", () => $e9167a92871f7f8c$export$91517ada3bce1236);

var $gGiWF = parcelRequire("gGiWF");

var $36pXK = parcelRequire("36pXK");
const $e9167a92871f7f8c$export$91517ada3bce1236 = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, onSubmit: onSubmit })=>{
    const { majorIncidentFieldIdKey: fieldKey, fieldType: fieldType } = (0, $36pXK.useMajorIncidentConfig)(issueKey);
    const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        issueKey: issueKey,
        fieldKey: fieldKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onSubmit: onSubmit
    });
    return [
        {
            value: value,
            loading: loading,
            error: error
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("36pXK", function(module, exports) {

$parcel$export(module.exports, "useMajorIncidentConfig", () => $928b6c6acf57b198$export$4fa770b3011492c);

var $eUqFw = parcelRequire("eUqFw");

var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $928b6c6acf57b198$export$4fa770b3011492c = (issueKey)=>{
    const [{ value: fieldConfig }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    const [majorIncidentFieldIdKey, searchUrl, fieldType] = (0, $eUqFw.useMemo)(()=>{
        if (fieldConfig != null) {
            const fieldId = Object.keys(fieldConfig).find((fieldKey)=>fieldConfig[fieldKey].schema.custom === (0, $lO4Or.MAJOR_INCIDENT_CF_TYPE));
            if (fieldId != null) {
                const majorIncidentConfig = fieldConfig[fieldId];
                const { autoCompleteUrl: autoCompleteUrl, schema: { type: type } } = majorIncidentConfig;
                return [
                    fieldId,
                    autoCompleteUrl || '',
                    type
                ];
            }
        }
        return [
            '',
            '',
            'string'
        ];
    }, [
        fieldConfig
    ]);
    return {
        majorIncidentFieldIdKey: majorIncidentFieldIdKey,
        searchUrl: searchUrl,
        fieldType: fieldType
    };
};

});


parcelRegister("byave", function(module, exports) {

$parcel$export(module.exports, "default", () => $652c7d4225abee61$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $652c7d4225abee61$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tootltipContent: {
        "id": "major-incident.major-incident-lozenge.tootltip-content",
        "defaultMessage": "This incident is marked as a major incident to increase visibility."
    },
    lozengeLabel: {
        "id": "major-incident.major-incident-lozenge.lozenge-label",
        "defaultMessage": "MAJOR INCIDENT"
    }
});

});



parcelRegister("mhwN9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a843b8d1d16514f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $gA5p3 = parcelRequire("gA5p3");

var $5Xp4r = parcelRequire("5Xp4r");

var $9lMYk = parcelRequire("9lMYk");
const $0a843b8d1d16514f$var$FoundationContext = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Xp4r.default), {
        id: (0, $ab2aafcdf11a1361$export$988f0f6f6457039a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0a843b8d1d16514f$var$FoundationContextWrapper, {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "issue.views.issue-base.context.status-and-approvals-wrapper.status-and-approval"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gA5p3.default), {
        key: "WRAPPED_STATUS"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9lMYk.default), null)));
var $0a843b8d1d16514f$export$2e2bcd8739ae039 = $0a843b8d1d16514f$var$FoundationContext;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a843b8d1d16514f$var$FoundationContextWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyridpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9lMYk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee41fad89eb79074$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3BIZK = parcelRequire("3BIZK");

var $3HCkE = parcelRequire("3HCkE");

var $ixwgj = parcelRequire("ixwgj");
const $ee41fad89eb79074$var$ApprovalPanelWrapper = ()=>{
    const { data: projectContextData } = (0, $3HCkE.useResource)((0, $ixwgj.projectContextResource));
    return !projectContextData?.isProjectArchived ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3BIZK.ApprovalPanel), null) : null;
};
var $ee41fad89eb79074$export$2e2bcd8739ae039 = $ee41fad89eb79074$var$ApprovalPanelWrapper;

});



parcelRegister("a7Nio", function(module, exports) {

$parcel$export(module.exports, "UiModificationsEntryPoint", () => $e8706e856d9444f6$export$c89b83ae4e6840b3);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $eTZsp = parcelRequire("eTZsp");

var $dta5S = parcelRequire("dta5S");

var $43AAP = parcelRequire("43AAP");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");

var $guDlK = parcelRequire("guDlK");

var $bKI0B = parcelRequire("bKI0B");

var $4OrIf = parcelRequire("4OrIf");

var $4RwL0 = parcelRequire("4RwL0");

var $5GFVu = parcelRequire("5GFVu");

var $ga6yl = parcelRequire("ga6yl");

var $8nrDR = parcelRequire("8nrDR");
const $e8706e856d9444f6$var$UiModificationsEntryPointLoaded = ({ modules: modules })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const project = (0, $guDlK.useProjectContext)(projectKey);
    const analyticsSource = (0, $hJ992.useAnalyticsSource)();
    const [{ value: fieldsConfig }] = (0, $8411R.useIssueFieldConfigWithoutUimOverrides)({
        issueKey: issueKey
    });
    const [issueType] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.ISSUE_TYPE)
    });
    const issueId = (0, $hJ992.useIssueId)();
    (0, $5GFVu.useOverridesStoreCleanup)({
        issueType: issueType,
        issueKey: issueKey
    });
    (0, $ga6yl.useBackgroundRefresh)();
    const issueAdjustmentsContext = (0, $eUqFw.useMemo)(()=>{
        if (issueType && project && issueId) return {
            project: {
                id: project.projectId,
                key: project.projectKey,
                type: project.projectType,
                isSimplified: project.isSimplified
            },
            issueType: {
                id: issueType.id,
                name: issueType.name
            },
            issue: {
                id: issueId,
                key: issueKey
            }
        };
        return null;
    }, [
        issueId,
        issueType,
        project,
        issueKey
    ]);
    const errorFallback = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $43AAP.IssueAdjustmentsErrorHandler), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4OrIf.ErrorFlags), null)), []);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            // null check will be performed later in renderIssueAdjustments
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            issueAdjustmentsContext: issueAdjustmentsContext,
            fieldsCount: (0, $8nrDR.getSupportedFieldsCount)(fieldsConfig),
            viewType: (0, $bKI0B.ISSUE_VIEW_VIEW_TYPE),
            resetFormFieldsCounter: 0,
            modules: modules
        }), [
        issueAdjustmentsContext,
        fieldsConfig,
        modules
    ]);
    const renderIssueAdjustments = ()=>{
        if (!issueAdjustmentsContext) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dta5S.IssueAdjustmentsAsync), {
            containerId: "uiModifications",
            containerPackageName: "jiraUiModificationsViewIssueView",
            runtimeProps: runtimeProps,
            triggerPointKey: analyticsSource,
            errorFallback: errorFallback
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderIssueAdjustments(), issueId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RwL0.FieldsProcessor), {
        issueKey: issueKey,
        fieldsConfig: fieldsConfig,
        issueId: issueId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4OrIf.ErrorFlags), null));
};
const $e8706e856d9444f6$export$c89b83ae4e6840b3 = (props)=>{
    if ((0, $1ybV0.ff)('forge-ui-modifications-killswitch-for-issueview_v3wj9')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "uiModifications",
        packageName: "jiraUiModificationsViewIssueView",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $43AAP.IssueAdjustmentsErrorHandler), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4OrIf.ErrorFlags), null)),
        attributes: (error)=>({
                errorType: (0, $eTZsp.getErrorType)(error),
                viewType: (0, $bKI0B.ISSUE_VIEW_VIEW_TYPE)
            }),
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e8706e856d9444f6$var$UiModificationsEntryPointLoaded, props));
};

});
parcelRegister("dta5S", function(module, exports) {

$parcel$export(module.exports, "IssueAdjustmentsAsync", () => $693f83b59d64c035$export$e2efea28577ab138);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $1ybV0 = parcelRequire("1ybV0");

var $eTZsp = parcelRequire("eTZsp");

var $ig7wC = parcelRequire("ig7wC");

var $5qzmj = parcelRequire("5qzmj");

var $43AAP = parcelRequire("43AAP");

var $8ibkc = parcelRequire("8ibkc");
const $693f83b59d64c035$export$84b9ffa7ecdfad72 = ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $43AAP.IssueAdjustmentsErrorHandler), null);
const $693f83b59d64c035$var$STABLE_EMPTY_OBJECT = {};
const $693f83b59d64c035$export$e2efea28577ab138 = ({ containerId: containerId, containerPackageName: containerPackageName, runtimeProps: runtimeProps, triggerPointKey: triggerPointKey, errorFallback: errorFallback })=>{
    const { issueAdjustmentsContext: issueAdjustmentsContext, modules: modules, viewType: viewType } = runtimeProps;
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $6j4bv.useEntryPoint)((0, $5qzmj.issueAdjustmentsEntryPoint), $693f83b59d64c035$var$STABLE_EMPTY_OBJECT);
    const { setShouldUiModificationsLoad: setShouldUiModificationsLoad } = (0, $ig7wC.useAdjustmentsContextActions)();
    const defaultErrorFallback = $693f83b59d64c035$export$84b9ffa7ecdfad72();
    const hasUiModificationsLoaded = (0, $eUqFw.useRef)(false);
    // NOTE: This killswitch flag can be enabled in an incident to prevent UI modifications from loading
    const shouldUiModificationsLoad = // NOTE: this is configured as a permanent flag that defaults to "false" for all users. It will never be "rolled out".
    // In an incident the default rule in Launch Darkly can be set to "true" to skip mounting the IssueAdjustmentsAsync component.
    // This will stop calls to the internal UI modifications endpoint, reducing load on services like cs-extensions
    // https://app.launchdarkly.com/jira/production/features/killswitch-turn-off-forge-ui-modifications-in-jira/targeting
    !(0, $1ybV0.ff)('killswitch-turn-off-forge-ui-modifications-in-jira', false) && modules?.length > 0 && (0, $8ibkc.isTriggerPointSupported)(viewType, triggerPointKey) && (0, $8ibkc.isProjectTypeSupported)(issueAdjustmentsContext.project, viewType);
    (0, $eUqFw.useEffect)(()=>{
        const hasProjectAndIssueTypeFinishedLoading = issueAdjustmentsContext !== null;
        // issueAdjustmentContext starts out as null so we need to wait until it is populated
        // to know if UI modifications should load or not in this project type.
        // issueAdjustmentContext needs to be a dependency not hasProjectAndIssueTypeFinishedLoading
        // otherwise we don't set the supported status when changing issue types only
        if (hasProjectAndIssueTypeFinishedLoading) setShouldUiModificationsLoad(shouldUiModificationsLoad ? 'yes' : 'no');
        if (shouldUiModificationsLoad && !hasUiModificationsLoaded.current) {
            entryPointActions.load();
            hasUiModificationsLoaded.current = true;
        }
    }, [
        issueAdjustmentsContext,
        shouldUiModificationsLoad,
        setShouldUiModificationsLoad,
        entryPointActions
    ]);
    if (shouldUiModificationsLoad) {
        const containerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: containerId,
            packageName: containerPackageName,
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
            errorFallback: errorFallback || defaultErrorFallback,
            errorAttributes: (error)=>({
                    errorType: (0, $eTZsp.getErrorType)(error),
                    viewType: runtimeProps.viewType
                }),
            runtimeProps: runtimeProps
        });
        const includeTriggerPoint = (0, $1ybV0.ff)('forge-uim-analytic-trg-point', false);
        if (includeTriggerPoint) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
            data: {
                attributes: {
                    triggerPointKey: triggerPointKey
                }
            }
        }, containerContent);
        return containerContent;
    }
    return null;
};
$693f83b59d64c035$export$e2efea28577ab138.displayName = 'IssueAdjustmentsAsync';

});
parcelRegister("5qzmj", function(module, exports) {

$parcel$export(module.exports, "issueAdjustmentsEntryPoint", () => $4036f914a2f30d85$export$4e091e70f9620cd8);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $4036f914a2f30d85$export$4e091e70f9620cd8 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("higp6")), {
        moduleId: "21bdaac4"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("higp6", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('epHFE');
        const value = parcelRequire('4368L');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("epHFE").then(()=>parcelRequire('4368L'));
}

});


parcelRegister("43AAP", function(module, exports) {

$parcel$export(module.exports, "IssueAdjustmentsErrorHandler", () => $09a3d3c2de568eb0$export$68b86a282e98ff70);

var $eUqFw = parcelRequire("eUqFw");

var $fcNlw = parcelRequire("fcNlw");
const $09a3d3c2de568eb0$export$68b86a282e98ff70 = ()=>{
    const { setError: setError, resetError: resetError } = (0, $fcNlw.useIssueAdjustmentsActions)();
    (0, $eUqFw.useEffect)(()=>{
        setError({
            errorCode: 'ERROR_BOUNDARY_HANDLER_ERROR_CODE'
        });
        return ()=>resetError();
    }, [
        setError,
        resetError
    ]);
    return null;
};

});


parcelRegister("4OrIf", function(module, exports) {

$parcel$export(module.exports, "ErrorFlags", () => $753d17d5b7fab173$export$c0a93466e331622a);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $k8Qyf = parcelRequire("k8Qyf");

var $56Q41 = parcelRequire("56Q41");
var $fdDST = parcelRequire("fdDST");
var $fcNlw = parcelRequire("fcNlw");

var $aaAnY = parcelRequire("aaAnY");
const $753d17d5b7fab173$export$acfac52285395871 = ()=>{
    const errorCode = (0, $fdDST.useErrorCode)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const errorFlag = (0, $aaAnY.useErrorFlagConfigOld)({
        errorCode: errorCode
    });
    const { resetError: resetError } = (0, $fcNlw.useIssueAdjustmentsActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (errorFlag) {
            showFlag(errorFlag);
            resetError();
        }
    }, [
        errorFlag,
        resetError,
        showFlag
    ]);
    return null;
};
const $753d17d5b7fab173$export$8d2013100908281b = ()=>{
    const errorProperties = (0, $56Q41.useError)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const errorFlag = (0, $aaAnY.useErrorFlagConfig)(errorProperties);
    const { resetError: resetError } = (0, $fcNlw.useIssueAdjustmentsActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (errorFlag) {
            showFlag(errorFlag);
            resetError();
        }
    }, [
        errorFlag,
        resetError,
        showFlag
    ]);
    return null;
};
const $753d17d5b7fab173$export$c0a93466e331622a = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('forge-ui-modifications-validation-errors-returned-to-app_hdzmw'), $753d17d5b7fab173$export$8d2013100908281b, $753d17d5b7fab173$export$acfac52285395871);

});
parcelRegister("56Q41", function(module, exports) {

$parcel$export(module.exports, "useError", () => $73f0395d1582326f$export$5027865de34f9ec6);

var $ggKAj = parcelRequire("ggKAj");

var $fcNlw = parcelRequire("fcNlw");
const $73f0395d1582326f$export$5027865de34f9ec6 = (0, $ggKAj.createStateHook)((0, $fcNlw.store), {
    selector: (state)=>state.error
});

});

parcelRegister("fdDST", function(module, exports) {

$parcel$export(module.exports, "useErrorCode", () => $c5c48a44155fb4ce$export$23745d1f9ed321fa);

var $ggKAj = parcelRequire("ggKAj");

var $fcNlw = parcelRequire("fcNlw");
const $c5c48a44155fb4ce$export$23745d1f9ed321fa = (0, $ggKAj.createStateHook)((0, $fcNlw.store), {
    selector: (state)=>{
        if (state.error) return state.error.errorCode;
        return null;
    }
});

});

parcelRegister("aaAnY", function(module, exports) {

$parcel$export(module.exports, "useErrorFlagConfigOld", () => $c38aaee348bd334f$export$ba8177a59964cd2d);
$parcel$export(module.exports, "useErrorFlagConfig", () => $c38aaee348bd334f$export$d5cea3ba5dfa9b46);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5r8oO = parcelRequire("5r8oO");
const $c38aaee348bd334f$export$ba8177a59964cd2d = ({ errorCode: errorCode })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const errorFlagConfig = (0, $eUqFw.useMemo)(()=>{
        if (errorCode === null) return null;
        const errorFlagProperties = (0, $5r8oO.getErrorFlagProperties)(errorCode);
        return errorFlagProperties ? {
            type: 'error',
            title: formatMessage(errorFlagProperties.title),
            description: formatMessage(errorFlagProperties.message),
            isAutoDismiss: true
        } : null;
    }, [
        errorCode,
        formatMessage
    ]);
    return errorFlagConfig;
};
const $c38aaee348bd334f$export$d5cea3ba5dfa9b46 = (errorProperties)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const errorFlagConfig = (0, $eUqFw.useMemo)(()=>{
        if (errorProperties === null) return null;
        const { errorCode: errorCode, fieldName: fieldName } = errorProperties;
        const errorFlagProperties = (0, $5r8oO.getErrorFlagProperties)(errorCode);
        return errorFlagProperties ? {
            type: 'error',
            title: formatMessage(errorFlagProperties.title),
            description: formatMessage(errorFlagProperties.message, (0, $1ybV0.ff)('forge-ui-modifications-validation-errors-returned-to-app_hdzmw') ? {
                fieldName: fieldName ?? 'Unknown field'
            } : undefined),
            isAutoDismiss: true
        } : null;
    }, [
        errorProperties,
        formatMessage
    ]);
    return errorFlagConfig;
};

});
parcelRegister("5r8oO", function(module, exports) {

$parcel$export(module.exports, "getErrorFlagProperties", () => $1b43d94aa5e989aa$export$adf6633182b772f5);

var $1ybV0 = parcelRequire("1ybV0");

var $5uNEc = parcelRequire("5uNEc");
const $1b43d94aa5e989aa$export$adf6633182b772f5 = (errorCode)=>{
    const errorCodeToErrorFlagPropertiesMap = {
        ON_BRIDGE_ERROR_ERROR_CODE: (0, $5uNEc.genericUimErrorFlagProperties),
        USE_REGISTER_FIELDS_ERROR_CODE: (0, $5uNEc.genericUimErrorFlagProperties),
        USE_SUBMIT_ERROR_CODE: (0, $5uNEc.applyingUimErrorFlagProperties),
        UIM_FETCH_FAILED_ERROR_CODE: (0, $5uNEc.loadingUimErrorFlagProperties),
        PER_FIELD_HOOK_ERROR_CODE: (0, $1ybV0.ff)('forge-ui-modifications-validation-errors-returned-to-app_hdzmw') ? (0, $5uNEc.perFieldHookErrorFlagProperties) : (0, $5uNEc.genericUimErrorFlagProperties),
        APPLY_BUFFER_CHANGES_ERROR: (0, $5uNEc.applyingUimErrorFlagProperties),
        MULTI_APP_CONFLICT: (0, $5uNEc.multiAppConflictErrorFlagProperties),
        BUFFERING_TIMEOUT: (0, $5uNEc.bufferTimeoutErrorFlagProperties),
        SCOPES_MISSING_ERROR_CODE: (0, $5uNEc.missingScopesUimErrorFlagProperties),
        ERROR_BOUNDARY_HANDLER_ERROR_CODE: (0, $5uNEc.genericUimErrorFlagProperties),
        ON_INIT_FIELDS_INITIALIZATION_TIMEOUT: (0, $5uNEc.loadingUimErrorFlagProperties)
    };
    const errorFlagProperties = errorCodeToErrorFlagPropertiesMap[errorCode];
    if (errorFlagProperties === undefined) return null;
    return errorFlagProperties;
};

});
parcelRegister("5uNEc", function(module, exports) {

$parcel$export(module.exports, "genericUimErrorFlagProperties", () => $f33fc7a55f68ca7f$export$6200921d111c8348);
$parcel$export(module.exports, "applyingUimErrorFlagProperties", () => $f33fc7a55f68ca7f$export$1787dff4b6c957af);
$parcel$export(module.exports, "loadingUimErrorFlagProperties", () => $f33fc7a55f68ca7f$export$eb9d9329e1c48af3);
$parcel$export(module.exports, "missingScopesUimErrorFlagProperties", () => $f33fc7a55f68ca7f$export$5a616f5b59ef1c37);
$parcel$export(module.exports, "perFieldHookErrorFlagProperties", () => $f33fc7a55f68ca7f$export$c7fa585227e1257f);
$parcel$export(module.exports, "multiAppConflictErrorFlagProperties", () => $f33fc7a55f68ca7f$export$73875abfbbb67b2);
$parcel$export(module.exports, "bufferTimeoutErrorFlagProperties", () => $f33fc7a55f68ca7f$export$d55f906b2fe1097);

var $gnyZt = parcelRequire("gnyZt");
const $f33fc7a55f68ca7f$export$6200921d111c8348 = {
    message: (0, $gnyZt.messages).genericUimErrorFlagDescription,
    title: (0, $gnyZt.messages).applyingUimErrorFlagTitle
};
const $f33fc7a55f68ca7f$export$1787dff4b6c957af = {
    message: (0, $gnyZt.messages).applyingUimErrorFlagDescription,
    title: (0, $gnyZt.messages).applyingUimErrorFlagTitle
};
const $f33fc7a55f68ca7f$export$eb9d9329e1c48af3 = {
    message: (0, $gnyZt.messages).genericUimErrorFlagDescription,
    title: (0, $gnyZt.messages).loadingUimErrorFlagTitle
};
const $f33fc7a55f68ca7f$export$5a616f5b59ef1c37 = {
    message: (0, $gnyZt.messages).missingScopesUimErrorFlagDescription,
    title: (0, $gnyZt.messages).missingScopesUimErrorFlagTitle
};
const $f33fc7a55f68ca7f$export$c7fa585227e1257f = {
    message: (0, $gnyZt.messages).perFieldHookErrorFlagDescription,
    title: (0, $gnyZt.messages).perFieldHookErrorFlagTitle
};
const $f33fc7a55f68ca7f$export$73875abfbbb67b2 = {
    message: (0, $gnyZt.messages).multiAppConflictErrorFlagDescription,
    title: (0, $gnyZt.messages).multiAppConflictUimErrorFlagTitle
};
const $f33fc7a55f68ca7f$export$d55f906b2fe1097 = {
    message: (0, $gnyZt.messages).bufferTimeoutFlagDescription,
    title: (0, $gnyZt.messages).bufferTimeoutFlagTitle
};

});
parcelRegister("gnyZt", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7d303ea10ebece9a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $7d303ea10ebece9a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    applyingUimErrorFlagTitle: {
        "id": "ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.applying-uim-error-flag-title",
        "defaultMessage": "There was an error with applying UI modifications."
    },
    applyingUimErrorFlagDescription: {
        "id": "ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.applying-uim-error-flag-description",
        "defaultMessage": "We encountered an error while applying changes made by UI modifications apps."
    },
    genericUimErrorFlagDescription: {
        "id": "ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.generic-uim-error-flag-description",
        "defaultMessage": "We encountered an error while applying changes made by UI modifications apps."
    },
    loadingUimErrorFlagTitle: {
        "id": "ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.loading-uim-error-flag-title",
        "defaultMessage": "We couldn\u2019t load UI modifications."
    },
    missingScopesUimErrorFlagTitle: {
        "id": "ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.missing-scopes-uim-error-flag-title",
        "defaultMessage": "Missing scopes for UI modifications apps"
    },
    missingScopesUimErrorFlagDescription: {
        "id": "ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.missing-scopes-uim-error-flag-description",
        "defaultMessage": "We couldn\u2019t load some of the UI modifications apps for this page, because they don\u2019t have required scopes."
    },
    perFieldHookErrorFlagTitle: {
        "id": "ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.per-field-hook-error-flag-title",
        "defaultMessage": "We had some issues with applying UI modifications."
    },
    perFieldHookErrorFlagDescription: {
        "id": "ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.per-field-hook-error-flag-description",
        "defaultMessage": "We encountered an error while applying UI modifications to \u201C{fieldName}\u201D."
    },
    multiAppConflictUimErrorFlagTitle: {
        "id": "ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.multi-app-conflict-uim-error-flag-title",
        "defaultMessage": "Multiple UI modifications apps conflict."
    },
    multiAppConflictErrorFlagDescription: {
        "id": "ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.multi-app-conflict-error-flag-description",
        "defaultMessage": "Multiple UI modifications apps tried to call the same API method on the same field. All customizations have been dismissed."
    },
    bufferTimeoutFlagTitle: {
        "id": "ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.buffer-timeout-flag-title",
        "defaultMessage": "Some of the UI modifications apps have timed out."
    },
    bufferTimeoutFlagDescription: {
        "id": "ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.buffer-timeout-flag-description",
        "defaultMessage": "Some apps did not apply changes before the timeout and have been dismissed."
    }
});

});





parcelRegister("4RwL0", function(module, exports) {

$parcel$export(module.exports, "FieldsProcessor", () => $60a5d052351711f6$export$7551230378218e2b);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");

var $ig7wC = parcelRequire("ig7wC");

var $dnK1q = parcelRequire("dnK1q");

var $gd2u3 = parcelRequire("gd2u3");

var $j1kKD = parcelRequire("j1kKD");

var $3kVrU = parcelRequire("3kVrU");

var $hs4xt = parcelRequire("hs4xt");

var $6c1W0 = parcelRequire("6c1W0");

var $j9Hm5 = parcelRequire("j9Hm5");

var $chsVw = parcelRequire("chsVw");

var $lu5Yp = parcelRequire("lu5Yp");

var $eY8vu = parcelRequire("eY8vu");

var $DX7su = parcelRequire("DX7su");

var $iSDPL = parcelRequire("iSDPL");

var $i0GKz = parcelRequire("i0GKz");

var $bBj5E = parcelRequire("bBj5E");

var $5PSyq = parcelRequire("5PSyq");

var $acd3W = parcelRequire("acd3W");

var $91l9a = parcelRequire("91l9a");

var $fWeG1 = parcelRequire("fWeG1");

var $3wLKg = parcelRequire("3wLKg");

var $9LOey = parcelRequire("9LOey");

var $lO4Or = parcelRequire("lO4Or");

var $bKI0B = parcelRequire("bKI0B");

var $8ibkc = parcelRequire("8ibkc");

var $3a22H = parcelRequire("3a22H");

var $fFMbe = parcelRequire("fFMbe");

var $2XdOl = parcelRequire("2XdOl");
const $60a5d052351711f6$export$a583f95301adf98f = (0, $5iWql.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
()=>({
        [(0, $lO4Or.SUMMARY_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $fWeG1.useSummaryField),
            saveFnName: 'saveValue'
        }),
        [(0, $lO4Or.DESCRIPTION_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $5PSyq.useDescriptionField),
            saveFnName: 'saveValue'
        }),
        [(0, $lO4Or.ASSIGNEE_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $dnK1q.default),
            saveFnName: 'saveValue'
        }),
        [(0, $lO4Or.PRIORITY_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $iSDPL.usePriorityField),
            saveFnName: 'saveById'
        }),
        [(0, $lO4Or.URL_CF_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $3wLKg.useUrlCustomField),
            saveFnName: 'saveValue'
        }),
        [(0, $lO4Or.TEXT_CF_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $91l9a.useTextCustomField),
            saveFnName: 'saveValue'
        }),
        [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $3kVrU.useCheckboxSelectField),
            saveFnName: 'saveById'
        }),
        [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $5PSyq.useParagraphField),
            saveFnName: 'saveValue'
        }),
        [(0, $lO4Or.SELECT_CF_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $acd3W.useSingleSelectField),
            saveFnName: 'saveValue'
        }),
        [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $acd3W.useMultiSelectField),
            saveFnName: 'saveById'
        }),
        [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $i0GKz.useRadioSelectCustomField),
            saveFnName: 'saveById'
        }),
        [(0, $lO4Or.FIX_VERSIONS_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: function useVersions(props) {
                if ((0, $1ybV0.ff)('forge-ui-modifications-affects-versions-field-support-iv_ff6mj')) // eslint-disable-next-line react-hooks/rules-of-hooks
                return (0, $9LOey.useVersionsFields)({
                    ...props,
                    fieldKey: (0, $lO4Or.FIX_VERSIONS_TYPE)
                });
                // eslint-disable-next-line react-hooks/rules-of-hooks
                return (0, $9LOey.useFixVersionField)(props);
            },
            saveFnName: 'saveById'
        }),
        [(0, $lO4Or.NUMBER_CF_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $eY8vu.useNumberField),
            saveFnName: 'saveValue'
        }),
        [(0, $lO4Or.DATE_CF_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $6c1W0.useDateField),
            saveFnName: 'saveValue'
        }),
        [(0, $lO4Or.LABELS_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $chsVw.useLabelsField),
            saveFnName: 'saveValue'
        }),
        [(0, $lO4Or.DATETIME_CF_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $j9Hm5.useDateTimeField),
            saveFnName: 'saveValue'
        }),
        [(0, $lO4Or.USER_CF_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $gd2u3.useUserCustomField),
            saveFnName: 'saveValue'
        }),
        [(0, $lO4Or.REPORTER_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $bBj5E.useReporterField),
            saveFnName: 'saveValue'
        }),
        [(0, $lO4Or.COMPONENTS_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $hs4xt.useComponentsField),
            saveFnName: 'saveById'
        }),
        [(0, $lO4Or.MULTI_USER_CF_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $lu5Yp.useMultiUserCustomField),
            saveFnName: 'saveValue'
        }),
        [(0, $lO4Or.PARENT_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
            hook: (0, $DX7su.useParentField),
            saveFnName: 'saveById'
        }),
        ...(0, $1ybV0.ff)('ui-modifications-cascading-select-field-support-_bjjiv') ? {
            [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
                // TODO: Remove `as any` from type on ui-modifications-cascading-select-field-support-_bjjiv FF clean up.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
                hook: (0, $j1kKD.useCascadeSelectField),
                saveFnName: 'saveValue'
            })
        } : {},
        ...(0, $1ybV0.ff)('forge-ui-modifications-affects-versions-field-support-iv_ff6mj') ? {
            [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: (0, $2XdOl.adaptIssueViewPerFieldHook)({
                // TODO: Remove `as any` from type on forge-ui-modifications-affects-versions-field-support-iv_ff6mj FF clean up.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
                hook: (0, $9LOey.useVersionsFields),
                saveFnName: 'saveById'
            })
        } : {}
    }));
const $60a5d052351711f6$export$7551230378218e2b = ({ issueKey: issueKey, fieldsConfig: fieldsConfig, issueId: issueId })=>{
    const isEnabled = (0, $ig7wC.useAdjustmentsEnabled)();
    return isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fFMbe.OnChangeHandlerRegistration), {
        fieldsConfig: fieldsConfig
    }), fieldsConfig && Object.entries(fieldsConfig).map(([fieldId, { schema: schema }])=>{
        const fieldType = schema.custom ?? schema.system;
        const isSupported = (0, $8ibkc.isFieldTypeSupported)((0, $bKI0B.ISSUE_VIEW_VIEW_TYPE), fieldType) && !!$60a5d052351711f6$export$a583f95301adf98f()[fieldType];
        if (!isSupported) return null;
        const useField = $60a5d052351711f6$export$a583f95301adf98f()[fieldType];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a22H.FieldProcessor), {
            key: fieldId,
            issueKey: issueKey,
            issueId: issueId,
            useField: useField,
            fieldId: fieldId,
            fieldType: fieldType
        });
    }).filter((x)=>x !== null)) : null;
};

});
parcelRegister("gd2u3", function(module, exports) {

$parcel$export(module.exports, "useUserCustomField", () => $294e349634183d9d$export$44f19b35a6cf5de7);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $294e349634183d9d$export$44f19b35a6cf5de7 = ({ issueKey: issueKey, fieldKey: fieldKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', (0, $lO4Or.USER_CF_TYPE));
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("j1kKD", function(module, exports) {

$parcel$export(module.exports, "useCascadeSelectField", () => $2fbb23d94496e5cf$export$ab11ba43585f9840);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $1geQq = parcelRequire("1geQq");
const $2fbb23d94496e5cf$export$ab11ba43585f9840 = ({ fieldKey: fieldKey, issueId: issueId, issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue })=>{
    const saveField = (0, $1geQq.useSaveCascadeSelectField)(issueId);
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'option-with-child');
    const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldType: fieldType,
        issueId: issueId,
        issueKey: issueKey,
        onSuccess: onSuccess,
        onFailure: onFailure,
        initialValue: initialValue || null,
        fieldKey: fieldKey,
        saveField: saveField
    });
    return [
        {
            value: value,
            loading: loading,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("1geQq", function(module, exports) {

$parcel$export(module.exports, "useSaveCascadeSelectField", () => $7cf33f87eccbc4f7$export$965b12db67dd0032);

var $k1FMR = parcelRequire("k1FMR");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $a9yKi = parcelRequire("a9yKi");

var $7byHA = parcelRequire("7byHA");

var $dWLk9 = parcelRequire("dWLk9");
const $7cf33f87eccbc4f7$export$965b12db67dd0032 = (issueId)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [commit] = (0, $iWLL0.useMutation)((0, $k1FMR.default));
    return (0, $eUqFw.useCallback)(async (_issueKey, fieldKey, value)=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        id: (0, $a9yKi.JiraIssuefieldvalueAri).create({
                            siteId: cloudId,
                            issueId: issueId,
                            fieldId: fieldKey
                        }).toString(),
                        operation: {
                            operation: 'SET',
                            parentOption: value?.parentId,
                            ...value?.childId ? {
                                childOption: value?.childId
                            } : {}
                        }
                    }
                },
                onCompleted (data) {
                    if (!data.jira?.updateCascadingSelectField) {
                        reject(new Error('Error while mutating cascading select'));
                        return;
                    }
                    const { success: success, errors: errors, field: field } = data.jira.updateCascadingSelectField;
                    if (!success || errors?.length) {
                        reject(errors?.[0].message ? new (0, $7byHA.ValidationError)(errors[0].message) : new Error('Error while mutating cascading select'));
                        return;
                    }
                    resolve(field?.cascadingOption && typeof field.cascadingOption.parentOptionValue?.value === 'string' ? {
                        ari: field.cascadingOption.parentOptionValue?.id,
                        id: field.cascadingOption.parentOptionValue?.optionId,
                        value: field.cascadingOption.parentOptionValue?.value,
                        child: typeof field.cascadingOption.childOptionValue?.value === 'string' ? {
                            ari: field.cascadingOption.childOptionValue?.id,
                            id: field.cascadingOption.childOptionValue?.optionId,
                            value: field.cascadingOption.childOptionValue?.value
                        } : null
                    } : null);
                },
                onError: reject
            });
        }), [
        cloudId,
        issueId,
        commit
    ]);
};

});
parcelRegister("k1FMR", function(module, exports) {

$parcel$export(module.exports, "default", () => $578ee48c47dd033b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e56ab2656e0a974c408d441d834cfc87>>
 * @relayHash 29fd4cb1579123e358050f8433d533d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e9dead6d817ca59da95260ff1b1afc6588c9e42e8a9d4f5089bf92a2a5740fca
const $578ee48c47dd033b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "optionId"
        }
    ], v6 = {
        "concreteType": "JiraCascadingOption",
        "kind": "LinkedField",
        "name": "cascadingOption",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "parentOptionValue",
                "plural": false,
                "selections": v5 /*: any*/ 
            },
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "childOptionValue",
                "plural": false,
                "selections": v5 /*: any*/ 
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSaveCascadeSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCascadingSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCascadingSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCascadingSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSaveCascadeSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCascadingSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCascadingSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCascadingSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e9dead6d817ca59da95260ff1b1afc6588c9e42e8a9d4f5089bf92a2a5740fca",
            "metadata": {},
            "name": "useSaveCascadeSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$578ee48c47dd033b$var$node.hash = "31eb55881d99579d2be9c6794238a263";
var $578ee48c47dd033b$export$2e2bcd8739ae039 = $578ee48c47dd033b$var$node;

});

parcelRegister("a9yKi", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAri", () => $c3b9111abe2b905b$export$828c4931ae562af7);

var $dq90x = parcelRequire("dq90x");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/issuefieldvalue/manifest.ts
var $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $dq90x.JiraIssuefieldvalueAriResourceOwner),
    resourceType: (0, $dq90x.JiraIssuefieldvalueAriResourceType),
    resourceIdSlug: "{issueId}/{fieldId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[a-zA-Z0-9_\-]+/
    }
};
// src/jira/issuefieldvalue/index.ts
var $c3b9111abe2b905b$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    get fieldId() {
        return this._fieldId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
            platformQualifier: $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
            resourceType: $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}/${opts.fieldId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId,
                fieldId: opts.fieldId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId,
            fieldId: this.fieldId
        };
    }
};

});
parcelRegister("dq90x", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", () => $969ccd5f0840c244$export$39e9358142fbbc64);
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", () => $969ccd5f0840c244$export$f9e57427271adc95);
// src/jira/issuefieldvalue/types.ts
var $969ccd5f0840c244$export$39e9358142fbbc64 = "jira", $969ccd5f0840c244$export$f9e57427271adc95 = "issuefieldvalue";

});




parcelRegister("3kVrU", function(module, exports) {

$parcel$export(module.exports, "useCheckboxSelectField", () => $5ddb6026d509605f$export$64fe88e084e8ce22);

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $btjMs = parcelRequire("btjMs");
const $5ddb6026d509605f$export$64fe88e084e8ce22 = ({ issueKey: issueKey, initialValue: initialValue = null, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, $btjMs.getFieldType)(fieldConfig.value) || 'array';
    const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, saveById: saveById, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            loading: loading,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};

});

parcelRegister("hs4xt", function(module, exports) {

$parcel$export(module.exports, "useComponentsField", () => $4f90c282b64d4b9f$export$adf68b6acc459cc4);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

const $4f90c282b64d4b9f$export$adf68b6acc459cc4 = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, (0, $ebc098a76317be78$export$98a935eb30de54ab));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'array');
    const [{ loading: loading, value: value, error: error }, { saveById: saveById, saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $ebc098a76317be78$export$98a935eb30de54ab),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            loading: loading,
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};

});

parcelRegister("chsVw", function(module, exports) {

$parcel$export(module.exports, "useLabelsField", () => $422b17732b7d1725$export$64894e54f74d7bc5);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");


var $3qzNZ = parcelRequire("3qzNZ");
const $422b17732b7d1725$export$64894e54f74d7bc5 = ({ fieldKey: // `fieldKey` can be `labels` or `customfield_`
fieldKey, issueId: issueId, issueKey: issueKey, fieldType: fieldType, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue })=>{
    const saveLabelsFieldField = (0, $3qzNZ.useSaveLabelsField)(issueId);
    const saveField = saveLabelsFieldField;
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const labelsFieldType = fieldType || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'array');
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldType: labelsFieldType,
        issueId: issueId,
        issueKey: issueKey,
        onSuccess: onSuccess,
        onFailure: onFailure,
        initialValue: initialValue || null,
        fieldKey: fieldKey || (0, $ebc098a76317be78$export$93605f2a09aa8d26),
        saveField: saveField
    });
    return [
        {
            error: error,
            value: value,
            fieldConfig: fieldConfig
        },
        {
            resetError: resetError,
            saveValue: saveValue
        }
    ];
};

});
parcelRegister("3qzNZ", function(module, exports) {

$parcel$export(module.exports, "useSaveLabelsField", () => $8c72e74753e30ea2$export$212ad40ad2c2a1db);

var $lhgd8 = parcelRequire("lhgd8");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7byHA = parcelRequire("7byHA");

var $dWLk9 = parcelRequire("dWLk9");
/**
 * @deprecated (do not copy/use) TODO: find a way to get ari rather than building it
 * https://jplat.atlassian.net/browse/JIV-13978
 */ const $8c72e74753e30ea2$var$buildId = (cloudId, issueId, fieldKey)=>`ari:cloud:jira:${cloudId}:issuefieldvalue/${issueId}/${fieldKey}`;
const $8c72e74753e30ea2$export$212ad40ad2c2a1db = (issueId)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [commit] = (0, $iWLL0.useMutation)((0, $lhgd8.default));
    return (0, $eUqFw.useCallback)(async (_issueKey, fieldKey, value)=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        id: $8c72e74753e30ea2$var$buildId(cloudId, issueId, fieldKey),
                        operations: [
                            {
                                operation: 'SET',
                                labels: value || []
                            }
                        ]
                    }
                },
                onCompleted (mutationData) {
                    if (mutationData.jira?.updateLabelsField) {
                        const { success: success, errors: responseErrors } = mutationData.jira?.updateLabelsField;
                        if (success) {
                            resolve();
                            return;
                        }
                        if (responseErrors?.length) reject(responseErrors[0].message ? new (0, $7byHA.ValidationError)(responseErrors[0].message) : new Error('Unknown error when mutating labels'));
                    } else reject(new Error('Unknown error when mutating labels'));
                },
                onError (error) {
                    reject(error);
                }
            });
        }), [
        cloudId,
        commit,
        issueId
    ]);
};

});
parcelRegister("lhgd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $25cdafdd920c3753$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c11ab75238f9f278d90a1487bd50f054>>
 * @relayHash d660b7a8b39585d942e3868f452ae2a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8d8f8d6bc107a9af3a9c530285495c2cea39cca04298631ed734969b32b449d2
const $25cdafdd920c3753$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSaveLabelsField_LabelsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSaveLabelsField_LabelsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraLabelConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedLabelsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                },
                                                {
                                                    "concreteType": "JiraLabelEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraLabel",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraFieldConfig",
                                            "kind": "LinkedField",
                                            "name": "fieldConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8d8f8d6bc107a9af3a9c530285495c2cea39cca04298631ed734969b32b449d2",
            "metadata": {},
            "name": "useSaveLabelsField_LabelsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$25cdafdd920c3753$var$node.hash = "8ad20115daf17ea5e9001db36624cdd7";
var $25cdafdd920c3753$export$2e2bcd8739ae039 = $25cdafdd920c3753$var$node;

});



parcelRegister("lu5Yp", function(module, exports) {

$parcel$export(module.exports, "useMultiUserCustomField", () => $41a87322807108ac$export$80bbf5398d3851fe);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $41a87322807108ac$export$80bbf5398d3851fe = ({ issueKey: issueKey, fieldKey: fieldKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', (0, $lO4Or.MULTI_USER_CF_TYPE));
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("i0GKz", function(module, exports) {

$parcel$export(module.exports, "useRadioSelectCustomField", () => $7fd5a0cb283a0593$export$ef02e43cfb758362);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $7fd5a0cb283a0593$export$ef02e43cfb758362 = ({ issueKey: issueKey, fieldKey: fieldKey, onFailure: onFailure, onSuccess: onSuccess })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'schema.type', 'option');
    const options = fieldConfig.value?.allowedValues ?? [];
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError, saveById: saveById }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig,
            options: options
        },
        {
            saveValue: saveValue,
            resetError: resetError,
            saveById: saveById
        }
    ];
};

});

parcelRegister("bBj5E", function(module, exports) {

$parcel$export(module.exports, "useReporterField", () => $2e8f81ed6b967146$export$62a1425ef3dadde5);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");

const $2e8f81ed6b967146$export$62a1425ef3dadde5 = ({ issueKey: issueKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const fieldKey = (0, $ebc098a76317be78$export$45cafdfd629c3ca1);
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', (0, $lO4Or.REPORTER_TYPE));
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("5PSyq", function(module, exports) {

$parcel$export(module.exports, "useParagraphField", () => $54ba5e9dd0d197d8$export$59fd8c2fda30c24e);
$parcel$export(module.exports, "useDescriptionField", () => $54ba5e9dd0d197d8$export$832230e7edbf37aa);

var $lRmyA = parcelRequire("lRmyA");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $btjMs = parcelRequire("btjMs");

var $lO4Or = parcelRequire("lO4Or");

var $7Vbpp = parcelRequire("7Vbpp");
const $54ba5e9dd0d197d8$export$318f67ae7477081f = async (issueKey, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/2/issue/${issueKey}/`, {
        body: JSON.stringify({
            fields: {
                [fieldKey]: newValue
            }
        })
    });
const $54ba5e9dd0d197d8$export$e3951294bacfa318 = (fieldConfig)=>(0, $btjMs.isRichTextSupported)(fieldConfig) ? (0, $7Vbpp.emptyAdfObject) : '';
const $54ba5e9dd0d197d8$var$useRichTextField = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, $btjMs.getFieldType)(fieldConfig.value) || 'string';
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: $54ba5e9dd0d197d8$export$e3951294bacfa318(fieldConfig?.value),
        onSuccess: onSuccess,
        onFailure: onFailure,
        ...!(0, $btjMs.isRichTextSupported)(fieldConfig?.value) ? {
            saveField: $54ba5e9dd0d197d8$export$318f67ae7477081f
        } : {}
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};
const $54ba5e9dd0d197d8$export$59fd8c2fda30c24e = (props)=>$54ba5e9dd0d197d8$var$useRichTextField(props);
const $54ba5e9dd0d197d8$export$832230e7edbf37aa = (props)=>$54ba5e9dd0d197d8$var$useRichTextField({
        ...props,
        fieldKey: (0, $lO4Or.DESCRIPTION_TYPE)
    });

});

parcelRegister("acd3W", function(module, exports) {

$parcel$export(module.exports, "useSingleSelectField", () => $f76affc570fb2705$export$de455e978fcfd3cf);
$parcel$export(module.exports, "useMultiSelectField", () => $f76affc570fb2705$export$a996b308983609cf);

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $btjMs = parcelRequire("btjMs");

var $bbmmE = parcelRequire("bbmmE");
const $f76affc570fb2705$var$useSelectField = ({ issueKey: issueKey, fieldKey: fieldKey, fieldDefaultSchemaType: fieldDefaultSchemaType, onSuccess: onSuccess, onFailure: onFailure, saveField: saveField, fieldType: fieldType, initialValue: initialValue })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const resolvedFieldType = fieldType || (0, $btjMs.getFieldType)(fieldConfig.value) || fieldDefaultSchemaType;
    const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, saveById: saveById, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: resolvedFieldType,
        initialValue: // @ts-expect-error Fix in https://jplat.jira.atlassian.cloud/browse/JIV-17559
        initialValue,
        onSuccess: onSuccess,
        onFailure: onFailure,
        saveField: saveField
    });
    return [
        {
            value: value,
            loading: loading,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};
const $f76affc570fb2705$export$de455e978fcfd3cf = (props)=>{
    const saveSingleSelectField = (0, $bbmmE.useSingleSelectMutation)();
    return $f76affc570fb2705$var$useSelectField({
        ...props,
        saveField: saveSingleSelectField,
        fieldDefaultSchemaType: 'option'
    });
};
const $f76affc570fb2705$export$a996b308983609cf = (props)=>$f76affc570fb2705$var$useSelectField({
        ...props,
        fieldDefaultSchemaType: 'array'
    });

});
parcelRegister("bbmmE", function(module, exports) {

$parcel$export(module.exports, "useSingleSelectMutation", () => $5f37b5f5d09f1a30$export$e568023bd1bde626);

var $fUAEy = parcelRequire("fUAEy");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7byHA = parcelRequire("7byHA");

var $hJ992 = parcelRequire("hJ992");

var $dWLk9 = parcelRequire("dWLk9");

var $cl42p = parcelRequire("cl42p");
function $5f37b5f5d09f1a30$export$e568023bd1bde626() {
    const cloudId = (0, $dWLk9.useCloudId)();
    const issueContextIssueId = (0, $hJ992.useIssueId)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const [commit] = (0, $iWLL0.useMutation)((0, $fUAEy.default));
    return (0, $eUqFw.useCallback)(async (issueKey, fieldId, option)=>{
        const { issueId: issueId, fieldOptionAri: fieldOptionAri } = await (0, $cl42p.fetchMissingIssueAndFieldOptionData)(issueContextIssueId, option, environment, {
            cloudId: cloudId,
            issueKey: issueKey,
            fieldId: fieldId
        });
        return new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        // @todo: we shouldn't be manually constructing ARIs
                        // https://jplat.jira.atlassian.cloud/browse/JIV-16566
                        id: `ari:cloud:jira:${cloudId}:issuefieldvalue/${issueId}/${fieldId}`,
                        operation: {
                            operation: 'SET',
                            id: fieldOptionAri
                        }
                    }
                },
                onCompleted (data) {
                    if (!data.jira?.updateSingleSelectField) {
                        reject(new Error('unknown error occurred'));
                        return;
                    }
                    const { success: success, errors: errors, field: field } = data.jira.updateSingleSelectField;
                    if (!success || errors?.length) {
                        reject(errors?.[0].message ? new (0, $7byHA.ValidationError)(errors[0].message) : new Error('unknown error occurred'));
                        return;
                    }
                    resolve(field?.fieldOption ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    {
                        ari: field.fieldOption.id,
                        value: field.fieldOption.value,
                        id: field.fieldOption.optionId
                    } : null);
                },
                onError: reject
            });
        });
    }, [
        cloudId,
        commit,
        environment,
        issueContextIssueId
    ]);
}

});
parcelRegister("fUAEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e72d3b27d1cd2184$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7735160732824337ac8d363f0c91a06>>
 * @relayHash 396cef6d317a9982d56bae0401d0192f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e79778d8ae574a33e0439f2d59888b0f1b3db2a38ec6c0682cf054fcc665db61
const $e72d3b27d1cd2184$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "fieldOption",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "optionId"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSingleSelectMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSingleSelectMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e79778d8ae574a33e0439f2d59888b0f1b3db2a38ec6c0682cf054fcc665db61",
            "metadata": {},
            "name": "useSingleSelectMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e72d3b27d1cd2184$var$node.hash = "b8d6036932768e6445d7615f80fc6acb";
var $e72d3b27d1cd2184$export$2e2bcd8739ae039 = $e72d3b27d1cd2184$var$node;

});

parcelRegister("cl42p", function(module, exports) {

$parcel$export(module.exports, "fetchMissingIssueAndFieldOptionData", () => $ccddbc32a65dc07a$export$def6f7858b27fc01);

var $9Exgj = parcelRequire("9Exgj");

var $iWLL0 = parcelRequire("iWLL0");
async function $ccddbc32a65dc07a$export$def6f7858b27fc01(issueId, option, environment, vars) {
    const skipFieldOptionAri = option === null || Boolean(option.ari);
    // we have all the data required to make the mutation. if the field option
    // value is null that means we are unsetting so an ari is not required
    if (issueId && skipFieldOptionAri) return {
        issueId: issueId,
        fieldOptionAri: option?.ari ?? null
    };
    const result = await (0, $iWLL0.fetchQuery)(environment, (0, $9Exgj.default), {
        ...vars,
        // @todo: how do we scale when the value is empty for fields with large
        //        amount of options
        // @see https://jplat.jira.atlassian.cloud/browse/JIV-16573
        searchBy: option?.value,
        skipFieldOptionAri: skipFieldOptionAri
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const jiraIssue = result?.jira?.issueByKey;
    if (!jiraIssue?.issueId) throw new Error('failed fetch issue id');
    let ari = option != null ? option?.ari : null;
    if (!skipFieldOptionAri) ari = option ? jiraIssue?.fieldsById?.edges?.[0]?.node?.fieldOptions?.edges?.find((opt)=>opt?.node?.optionId === option.id)?.node?.id : null;
    // ari being null is still valid request as the user will be unsetting it
    // so here we check for undefined only meaning that the query above returned
    // an empty options connection, or we could not match the `optionId` from the
    // nodes in the connection.
    if (ari === undefined) throw new Error('failed to fetch field option ari');
    return {
        issueId: jiraIssue.issueId,
        fieldOptionAri: ari
    };
}

});
parcelRegister("9Exgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9668a277aa11099$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6ed6f2e80602085b4937748ddaf953d>>
 * @relayHash 524d85ce5dded2d9716dceedb13042f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b143065b2371a01a056e06ca6a0f574cd106056b83483283319b3b7d3d180d58
const $c9668a277aa11099$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchBy"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipFieldOptionAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v7 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "ids.0",
                    "variableName": "fieldId"
                }
            ],
            "kind": "ListValue",
            "name": "ids"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "searchBy",
                        "variableName": "searchBy"
                    }
                ],
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v8 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionId"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectField"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "utilsUseSingleSelectMutationMissingIssueAndFieldOptionDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "skipFieldOptionAri",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": v7 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "utilsUseSingleSelectMutationMissingIssueAndFieldOptionDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "skipFieldOptionAri",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": v7 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v9 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b143065b2371a01a056e06ca6a0f574cd106056b83483283319b3b7d3d180d58",
            "metadata": {},
            "name": "utilsUseSingleSelectMutationMissingIssueAndFieldOptionDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c9668a277aa11099$var$node.hash = "9fecb581bfb367efbee5768f0f78cc7a";
var $c9668a277aa11099$export$2e2bcd8739ae039 = $c9668a277aa11099$var$node;

});




parcelRegister("91l9a", function(module, exports) {

$parcel$export(module.exports, "useTextCustomField", () => $e317f21526ba3a70$export$1e71b41e5a5c15c3);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $e317f21526ba3a70$export$1e71b41e5a5c15c3 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'schema.type', 'string');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("3wLKg", function(module, exports) {

$parcel$export(module.exports, "useUrlCustomField", () => $0d8a50c570e9c30f$export$8745adc9879e9e03);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $0d8a50c570e9c30f$export$8745adc9879e9e03 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'schema.type', 'string');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("9LOey", function(module, exports) {

$parcel$export(module.exports, "useFixVersionField", () => $f865b68a7d27d78a$export$a23195a0e4f7a8f4);
$parcel$export(module.exports, "useVersionsFields", () => $f865b68a7d27d78a$export$a9f75e7b9317e72);

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $btjMs = parcelRequire("btjMs");

var $lO4Or = parcelRequire("lO4Or");
const $f865b68a7d27d78a$export$a23195a0e4f7a8f4 = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, (0, $lO4Or.FIX_VERSIONS_TYPE));
    const fieldType = (0, $btjMs.getFieldType)(fieldConfig.value) || 'array';
    const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, saveById: saveById, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $lO4Or.FIX_VERSIONS_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            loading: loading,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};
const $f865b68a7d27d78a$export$a9f75e7b9317e72 = ({ issueKey: issueKey, fieldKey: fieldKey = (0, $lO4Or.AFFECTS_VERSIONS_TYPE), onSuccess: onSuccess, onFailure: onFailure })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, $btjMs.getFieldType)(fieldConfig.value) || 'array';
    const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, saveById: saveById, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            loading: loading,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};

});

parcelRegister("3a22H", function(module, exports) {

$parcel$export(module.exports, "FieldProcessor", () => $e97355aae111514a$export$b20e9e0f6ffd0ce0);

var $eUqFw = parcelRequire("eUqFw");

var $fcNlw = parcelRequire("fcNlw");

var $bFzGY = parcelRequire("bFzGY");

var $RVZVs = parcelRequire("RVZVs");

var $3XxGI = parcelRequire("3XxGI");
const $e97355aae111514a$var$LoadedFieldProcessor = ({ field: field, actions: actions, issueKey: issueKey })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [state, { initializeField: initializeField, clearAppliedValue: clearAppliedValue, setFieldValue: setFieldValue }] = (0, $fcNlw.useAdjustedField)(field.fieldId);
    (0, $3XxGI.useSetOverrides)({
        field: field,
        issueKey: issueKey,
        state: state
    });
    // saveValueRef reasoning: saveValue has no stable reference, and we don't want to invoke our useEffect based on changing ref
    // but still wants to call the latest version of it when needed
    const saveValueRef = (0, $eUqFw.useRef)(actions.saveValue);
    saveValueRef.current = actions.saveValue;
    (0, $eUqFw.useLayoutEffect)(()=>{
        const { metadata: metadata, ...rest } = field;
        initializeField({
            field: rest,
            metadata: {
                fieldRenderer: metadata.renderer
            }
        });
    // Having the deps array empty makes initializeField run only once at component initialization
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (state.value !== undefined) {
            const analyticsEvent = createAnalyticsEvent({});
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            saveValueRef.current(state.value, (0, $RVZVs.changeSource), analyticsEvent);
            // Once we have applied the value, we clear it from the state so we don't apply it again
            // in the future and overwrite whatever the user has changed between now and then
            clearAppliedValue(field.fieldId);
        }
    }, [
        clearAppliedValue,
        createAnalyticsEvent,
        field.fieldId,
        state.value
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // We don't want to update the store when there is an ongoing process of UIM values applying
        const areOngoingUIMChanges = state.value !== undefined;
        if (areOngoingUIMChanges) return;
        /**
		 * Updates formData on the Issue View realtime and background refreshes.
		 */ setFieldValue({
            fieldId: field.fieldId,
            fieldType: field.fieldType,
            fieldValue: field.value
        });
    }, [
        field.fieldId,
        field.fieldType,
        field.value,
        setFieldValue,
        state.value
    ]);
    return null;
};
const $e97355aae111514a$export$b20e9e0f6ffd0ce0 = ({ issueKey: issueKey, issueId: issueId, useField: useField, fieldId: fieldId, fieldType: fieldType })=>{
    const { field: field, actions: actions, loading: loading } = useField({
        issueKey: issueKey,
        fieldId: fieldId,
        fieldType: fieldType,
        issueId: issueId
    });
    return loading === false && field ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e97355aae111514a$var$LoadedFieldProcessor, {
        field: field,
        issueKey: issueKey,
        actions: actions
    }) : null;
};

});
parcelRegister("RVZVs", function(module, exports) {

$parcel$export(module.exports, "UI_MODIFICATIONS_CHANGE", () => $b9addef05eabbab5$export$31bb44274cefc4c0);
$parcel$export(module.exports, "changeSource", () => $b9addef05eabbab5$export$88ad6c23903bf3b0);
const $b9addef05eabbab5$export$31bb44274cefc4c0 = 'uiModificationsChange';
const $b9addef05eabbab5$export$88ad6c23903bf3b0 = {
    source: $b9addef05eabbab5$export$31bb44274cefc4c0
};

});

parcelRegister("3XxGI", function(module, exports) {

$parcel$export(module.exports, "useSetOverrides", () => $dda01c9c0d1cfc62$export$b9d5f20077fe865d);

var $eUqFw = parcelRequire("eUqFw");

var $7TRB4 = parcelRequire("7TRB4");

var $6rkLV = parcelRequire("6rkLV");
const $dda01c9c0d1cfc62$export$b9d5f20077fe865d = ({ field: field, issueKey: issueKey, state: state })=>{
    const { setFieldConfigOverridesValue: setFieldConfigOverridesValue } = (0, $6rkLV.useOverridesStoreActions)();
    const isBusy = (0, $7TRB4.useFieldIsBusy)(field.fieldId);
    (0, $eUqFw.useEffect)(()=>{
        if (state.isReadOnly !== undefined) setFieldConfigOverridesValue(issueKey, field.fieldId, {
            isEditable: !state.isReadOnly
        });
    }, [
        field.fieldId,
        issueKey,
        setFieldConfigOverridesValue,
        state.isReadOnly
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (state.fieldName !== undefined) setFieldConfigOverridesValue(issueKey, field.fieldId, {
            title: state.fieldName
        });
    }, [
        setFieldConfigOverridesValue,
        issueKey,
        field.fieldId,
        state.fieldName
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (state.description !== undefined) setFieldConfigOverridesValue(issueKey, field.fieldId, {
            description: state.description
        });
    }, [
        setFieldConfigOverridesValue,
        issueKey,
        field.fieldId,
        state.description
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (state.allowedValuesOverrides !== undefined) setFieldConfigOverridesValue(issueKey, field.fieldId, {
            allowedValuesOverrides: state.allowedValuesOverrides
        });
    }, [
        setFieldConfigOverridesValue,
        issueKey,
        field.fieldId,
        state.allowedValuesOverrides
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (state.fieldOptionsFilter !== undefined) setFieldConfigOverridesValue(issueKey, field.fieldId, {
            optionsFilter: state.fieldOptionsFilter
        });
    }, [
        setFieldConfigOverridesValue,
        issueKey,
        field.fieldId,
        state.fieldOptionsFilter
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setFieldConfigOverridesValue(issueKey, field.fieldId, {
            isBusy: isBusy
        });
    }, [
        setFieldConfigOverridesValue,
        issueKey,
        field.fieldId,
        isBusy
    ]);
};

});
parcelRegister("7TRB4", function(module, exports) {

$parcel$export(module.exports, "useFieldIsBusy", () => $437ae02f2f2b76eb$export$b4ae28da91c35ed4);

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $3G9wl = parcelRequire("3G9wl");


var $dvQud = parcelRequire("dvQud");
const $437ae02f2f2b76eb$export$ff04c0f3c2623b5f = (fieldId)=>{
    const [isBusy] = (0, $dvQud.useFieldIsProcessingOld)(fieldId);
    const currentUIModificationsConsentStatus = (0, $3G9wl.useUIModificationsConsentStatus)();
    if (currentUIModificationsConsentStatus === (0, $e4bc45ef063f6e5f$export$d67d63332ce3ce38)) return false;
    return isBusy;
};
const $437ae02f2f2b76eb$export$3b3523eb1f597b08 = (fieldId)=>{
    const [isBusyData] = (0, $dvQud.useFieldIsProcessingV2)(fieldId);
    const uimConsentMap = (0, $3G9wl.useUIModificationsConsentStatusForApps)();
    const { isBusy: isBusy, appsIds: appsIds } = isBusyData;
    if (!isBusy) return false;
    return appsIds.some((appId)=>uimConsentMap[appId] !== (0, $e4bc45ef063f6e5f$export$d67d63332ce3ce38));
};
const $437ae02f2f2b76eb$export$b4ae28da91c35ed4 = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw'), $437ae02f2f2b76eb$export$3b3523eb1f597b08, $437ae02f2f2b76eb$export$ff04c0f3c2623b5f);

});
parcelRegister("3G9wl", function(module, exports) {

$parcel$export(module.exports, "useUIModificationsConsentStatus", () => $381349a6fe3e5ee3$export$e2c526d2c1843a0e);
$parcel$export(module.exports, "useUIModificationsConsentStatusForApp", () => $381349a6fe3e5ee3$export$7700bb22109a011e);
$parcel$export(module.exports, "useUIModificationsConsentStatusForApps", () => $381349a6fe3e5ee3$export$2a5a8f1570c161c6);

var $bj4JM = parcelRequire("bj4JM");
var $ggKAj = parcelRequire("ggKAj");

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $ig7wC = parcelRequire("ig7wC");

const $381349a6fe3e5ee3$var$selectOverallConsentStatus = (0, $bj4JM.createSelector)((state)=>state.uiModificationsConsentStatus, (consentMap)=>Object.values(consentMap).includes((0, $e4bc45ef063f6e5f$export$d67d63332ce3ce38)) ? (0, $e4bc45ef063f6e5f$export$d67d63332ce3ce38) : (0, $e4bc45ef063f6e5f$export$45ca911896c5084f));
const $381349a6fe3e5ee3$var$selectConsentStatusDeprecated = (state)=>state.uiModificationsConsentStatusDeprecated;
const $381349a6fe3e5ee3$var$selectUIMConsentStatus = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw'), $381349a6fe3e5ee3$var$selectOverallConsentStatus, $381349a6fe3e5ee3$var$selectConsentStatusDeprecated);
const $381349a6fe3e5ee3$export$e2c526d2c1843a0e = (0, $ggKAj.createStateHook)((0, $ig7wC.store), {
    selector: $381349a6fe3e5ee3$var$selectUIMConsentStatus
});
const $381349a6fe3e5ee3$export$7700bb22109a011e = (0, $ggKAj.createStateHook)((0, $ig7wC.store), {
    selector: (state, { appId: appId })=>state.uiModificationsConsentStatus[appId] || (0, $e4bc45ef063f6e5f$export$39d15f3568f5a72c)
});
const $381349a6fe3e5ee3$export$2a5a8f1570c161c6 = (0, $ggKAj.createStateHook)((0, $ig7wC.store), {
    selector: (state)=>state.uiModificationsConsentStatus
});

});

parcelRegister("dvQud", function(module, exports) {

$parcel$export(module.exports, "useFieldIsProcessingOld", () => $f5c447ce6e9bd7f5$export$ec0aa14c1e4bcb95);
$parcel$export(module.exports, "useFieldIsProcessingV2", () => $f5c447ce6e9bd7f5$export$fd447cdc5de90a78);

var $ldoFd = parcelRequire("ldoFd");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $fcNlw = parcelRequire("fcNlw");
const $f5c447ce6e9bd7f5$export$b58fa93ff3e11506 = (0, $bj4JM.createSelector)((state)=>state.registeredFieldsDeprecated, (state)=>state.error, (_, fieldId)=>fieldId, (registeredChanges, error, fieldId)=>{
    // When there is an error in any part of UI modifications
    // we need to ensure that fields from the Jira view are not blocked by reacting on an error here.
    // e.g. GIC fields will not be blocked anymore when error occurs in one of the decorators.
    if (error) return false;
    return !!Object.values(registeredChanges).find((registeredChange)=>registeredChange?.includes(fieldId));
});
const $f5c447ce6e9bd7f5$export$faa2043a29f9e75e = (0, $bj4JM.createSelector)((state)=>state.registeredFields, (state)=>state.error, (_, fieldId)=>fieldId, (registeredChangesMap, error, fieldId)=>{
    if (error) return {
        isBusy: false,
        appsIds: []
    };
    const appsIds = Object.entries(registeredChangesMap).filter(([_, registeredFields])=>!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(registeredFields) && Object.values(registeredFields).flat().includes(fieldId)).map(([appId])=>appId);
    return {
        isBusy: appsIds.length > 0,
        appsIds: appsIds
    };
});
const $f5c447ce6e9bd7f5$export$ec0aa14c1e4bcb95 = (0, $ggKAj.createHook)((0, $fcNlw.store), {
    selector: $f5c447ce6e9bd7f5$export$b58fa93ff3e11506
});
const $f5c447ce6e9bd7f5$export$fd447cdc5de90a78 = (0, $ggKAj.createHook)((0, $fcNlw.store), {
    selector: $f5c447ce6e9bd7f5$export$faa2043a29f9e75e
});

});




parcelRegister("fFMbe", function(module, exports) {

$parcel$export(module.exports, "OnChangeHandlerRegistration", () => $2ed1eb77b8da5ca6$export$4ef83bcdb0a9c019);

var $eUqFw = parcelRequire("eUqFw");

var $fcNlw = parcelRequire("fcNlw");

var $k3tie = parcelRequire("k3tie");
var $8p8vy = parcelRequire("8p8vy");

var $bKI0B = parcelRequire("bKI0B");

var $8ibkc = parcelRequire("8ibkc");

var $RVZVs = parcelRequire("RVZVs");
const $2ed1eb77b8da5ca6$export$4ef83bcdb0a9c019 = ({ fieldsConfig: fieldsConfig })=>{
    const { processChange: processChange } = (0, $fcNlw.useIssueAdjustmentsActions)();
    const [, { registerEventHandler: registerEventHandler }] = (0, $8p8vy.useIssueViewFieldUpdateEvents)();
    (0, $eUqFw.useEffect)(()=>{
        const unregister = registerEventHandler('onChange', (event)=>{
            if (event.type === (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_REQUESTED && fieldsConfig && fieldsConfig[event.meta.fieldId]) {
                const { schema: schema } = fieldsConfig[event.meta.fieldId];
                const fieldType = schema.custom ?? schema.system;
                const isSupported = (0, $8ibkc.isFieldTypeSupported)((0, $bKI0B.ISSUE_VIEW_VIEW_TYPE), fieldType);
                const eventSourceIsUIM = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                event.meta.additionalProperties?.source === (0, $RVZVs.UI_MODIFICATIONS_CHANGE);
                if (isSupported && !eventSourceIsUIM) processChange({
                    fieldId: event.meta.fieldId,
                    fieldType: fieldType,
                    fieldValue: event.meta.fieldValue,
                    eventType: 'change'
                });
            }
        });
        return unregister;
    }, [
        fieldsConfig,
        registerEventHandler,
        processChange
    ]);
    return null;
};

});

parcelRegister("2XdOl", function(module, exports) {

$parcel$export(module.exports, "adaptIssueViewPerFieldHook", () => $9f9f92db4c3be8c4$export$80baf90f28caa839);

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $eTZsp = parcelRequire("eTZsp");

var $fcNlw = parcelRequire("fcNlw");

var $bFzGY = parcelRequire("bFzGY");

var $h1jSL = parcelRequire("h1jSL");
var $8xsvt = parcelRequire("8xsvt");

var $bKI0B = parcelRequire("bKI0B");
const $9f9f92db4c3be8c4$var$isFieldConfigurationType = (fieldConfig)=>!!fieldConfig && Object.hasOwnProperty.call(fieldConfig, 'loading');
const $9f9f92db4c3be8c4$var$VALIDATION_ERROR = 'VALIDATION_ERROR';
const $9f9f92db4c3be8c4$export$80baf90f28caa839 = ({ hook: hook, saveFnName: saveFnName = 'saveValue' })=>({ issueKey: issueKey, fieldId: fieldId, fieldType: fieldType, issueId: issueId })=>{
        const { setError: setError } = (0, $fcNlw.useIssueAdjustmentsActions)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
        const onFailure = (error)=>{
            const errorType = error instanceof (0, $7byHA.ValidationError) ? $9f9f92db4c3be8c4$var$VALIDATION_ERROR : (0, $eTZsp.getErrorType)(error);
            setError({
                errorCode: 'PER_FIELD_HOOK_ERROR_CODE',
                fieldName: (0, $1ybV0.ff)('forge-ui-modifications-validation-errors-returned-to-app_hdzmw') ? field?.fieldName : undefined
            });
            (0, $h1jSL.fireIAErrorAnalytics)({
                error: error,
                id: 'adaptIssueViewPerFieldHookSaveValue',
                viewType: (0, $bKI0B.ISSUE_VIEW_VIEW_TYPE),
                attributes: {
                    fieldId: fieldId,
                    fieldType: fieldType,
                    errorType: errorType
                },
                event: createAnalyticsEvent({})
            });
        };
        const onSuccess = ()=>{
            (0, $8xsvt.fireTrackAnalytics)(createAnalyticsEvent({}), 'adaptIssueViewPerFieldHookSaveValue success', (0, $bKI0B.ISSUE_VIEW_VIEW_TYPE), {
                fieldId: fieldId,
                fieldType: fieldType,
                saveFnName: saveFnName
            });
        };
        const [{ value: value, fieldConfig: fieldConfig }, actions] = hook({
            issueKey: issueKey,
            issueId: issueId,
            fieldKey: fieldId,
            onFailure: onFailure,
            onSuccess: onSuccess
        });
        let loading;
        let config;
        if ($9f9f92db4c3be8c4$var$isFieldConfigurationType(fieldConfig)) {
            loading = !fieldConfig.value;
            config = fieldConfig.value;
        } else {
            loading = !fieldConfig;
            config = fieldConfig;
        }
        const field = config ? {
            fieldId: fieldId,
            fieldType: fieldType,
            fieldName: config.title,
            description: config.description,
            isReadOnly: !config.isEditable,
            isRequired: config.isRequired,
            value: value,
            isVisible: true,
            metadata: {
                // Keep in mind that renderer string is different in IssueView than in GIC for the same fieldType
                // e.g. for description `atlassian-wiki-renderer` (IV) vs `JiraRichTextField` (GIC)
                renderer: config.schema.renderer ?? undefined
            }
        } : null;
        const saveValue = actions[saveFnName];
        if (!saveValue) throw new Error(`Undefined save function was used for "${fieldType}" hook in adaptIssueViewPerFieldHook: ${saveFnName}`);
        return {
            field: field,
            actions: {
                saveValue: saveValue
            },
            loading: loading
        };
    };

});
parcelRegister("8xsvt", function(module, exports) {

$parcel$export(module.exports, "fireTrackAnalytics", () => $bc30aa630675e759$export$13990ad4625571ed);

var $jMP2a = parcelRequire("jMP2a");

var $3DOEL = parcelRequire("3DOEL");
const $bc30aa630675e759$export$13990ad4625571ed = (event, id, viewType, attributes = {})=>{
    (0, $jMP2a.fireTrackAnalytics)(event, `jiraUiModifications.${id}`, {
        ...attributes,
        viewType: viewType
    });
};
const $bc30aa630675e759$export$c16abba982fdcf2c = (actionSubject, action, viewType, attributes = {})=>(0, $3DOEL.getAnalyticsWebClient)().getInstance().sendTrackEvent({
        action: action,
        actionSubject: `jiraUiModifications.${actionSubject}`,
        source: viewType,
        attributes: {
            ...attributes,
            viewType: viewType
        }
    });

});



parcelRegister("5GFVu", function(module, exports) {

$parcel$export(module.exports, "useOverridesStoreCleanup", () => $a5918ca98b05c2a8$export$2aa6ba7639c42f31);

var $eUqFw = parcelRequire("eUqFw");

var $6rkLV = parcelRequire("6rkLV");
const $a5918ca98b05c2a8$export$2aa6ba7639c42f31 = ({ issueType: issueType, issueKey: issueKey })=>{
    const { resetOverridesStore: resetOverridesStore } = (0, $6rkLV.useOverridesStoreActions)();
    (0, $eUqFw.useEffect)(()=>()=>{
            if (issueType?.id) resetOverridesStore(issueKey);
        }, [
        resetOverridesStore,
        issueType?.id,
        issueKey
    ]);
    return null;
};

});

parcelRegister("ga6yl", function(module, exports) {

$parcel$export(module.exports, "useBackgroundRefresh", () => $f6fbb9763edbd6e8$export$eec456f6a7a8cb94);

var $eUqFw = parcelRequire("eUqFw");

var $fcNlw = parcelRequire("fcNlw");

var $k9hJ7 = parcelRequire("k9hJ7");
const $f6fbb9763edbd6e8$export$eec456f6a7a8cb94 = ()=>{
    const backgroundRefreshLoadingStatus = (0, $k9hJ7.useBackgroundRefreshLoading)();
    const { setExperienceDataIsLoading: setExperienceDataIsLoading } = (0, $fcNlw.useIssueAdjustmentsActions)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        setExperienceDataIsLoading(backgroundRefreshLoadingStatus === 'LOADING');
    }, [
        backgroundRefreshLoadingStatus,
        setExperienceDataIsLoading
    ]);
};

});

parcelRegister("8nrDR", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldsCount", () => $95f78352804a6978$export$11f15170229125b6);

var $bKI0B = parcelRequire("bKI0B");

var $8ibkc = parcelRequire("8ibkc");
const $95f78352804a6978$export$11f15170229125b6 = (fieldsConfig)=>{
    if (!fieldsConfig) return 0;
    return Object.values(fieldsConfig).filter(({ schema: schema })=>{
        const fieldType = schema.custom ?? schema.system;
        return (0, $8ibkc.isFieldTypeSupported)((0, $bKI0B.ISSUE_VIEW_VIEW_TYPE), fieldType);
    }).length;
};

});


parcelRegister("h46em", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec8cb5b9b7778c3b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $ipcjd = parcelRequire("ipcjd");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $7C4za = parcelRequire("7C4za");

var $dZ3Ok = parcelRequire("dZ3Ok");

var $2m7ky = parcelRequire("2m7ky");

var $5b3l6 = parcelRequire("5b3l6");


var $cBTTN = parcelRequire("cBTTN");

var $lIwq2 = parcelRequire("lIwq2");

var $3BpHs = parcelRequire("3BpHs");

var $eFn9t = parcelRequire("eFn9t");

var $cDMTA = parcelRequire("cDMTA");

var $7JYKd = parcelRequire("7JYKd");

var $3PBWj = parcelRequire("3PBWj");

var $lUUR2 = parcelRequire("lUUR2");

var $9vbIS = parcelRequire("9vbIS");

var $22cag = parcelRequire("22cag");

var $hjzLw = parcelRequire("hjzLw");

var $jo88D = parcelRequire("jo88D");

var $fkvsU = parcelRequire("fkvsU");

var $hdX7K = parcelRequire("hdX7K");

var $3PPRL = parcelRequire("3PPRL");

var $dtfgR = parcelRequire("dtfgR");

var $4lL77 = parcelRequire("4lL77");

var $10AzB = parcelRequire("10AzB");

var $lqalZ = parcelRequire("lqalZ");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $8CSFK = parcelRequire("8CSFK");

var $iY7NN = parcelRequire("iY7NN");

var $cFY86 = parcelRequire("cFY86");

var $6gpYd = parcelRequire("6gpYd");

var $gGtKh = parcelRequire("gGtKh");

var $d6f6c = parcelRequire("d6f6c");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");

var $cVWzw = parcelRequire("cVWzw");

var $jK1pm = parcelRequire("jK1pm");

var $ffYQM = parcelRequire("ffYQM");
const $ec8cb5b9b7778c3b$var$DevOpsAppRecommendationContextProvider = (0, $9zysr.componentWithCondition)((0, $3PPRL.isDevOpsAppRecommenderEnabled), (0, $ipcjd.DevOpsAppRecommendationContextProvider), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children));
class $ec8cb5b9b7778c3b$export$4b122c59b371202 extends (0, $eUqFw.Component) {
    static{
        this.displayName = 'ContentItems';
    }
    static{
        this.defaultProps = {
            isComplete: false,
            isCompactMode: false,
            isAnonymousUser: false,
            isEpic: false,
            hasIssueLinksEntity: false,
            hasIssueLinksField: false,
            contentPanels: [],
            additionalWebLinksSections: []
        };
    }
    maybeWrapInSectionWrapper(component) {
        const { isCompactMode: isCompactMode } = this.props;
        if (!component) return component;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hdX7K.IssueSectionWrapper), {
            isCompactMode: isCompactMode
        }, component);
    }
    renderEcosystemContentPanels() {
        const { contentPanels: contentPanels, isCompactMode: isCompactMode } = this.props;
        const panels = contentPanels.map((panel)=>{
            if (panel.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
                const { name: name, appKey: appKey, moduleKey: moduleKey, dateAdded: dateAdded, panelInstanceId: panelInstanceId, extension: extension } = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                panel;
                const panelKey = (0, $7C4za.toForgeKeyWithDate)(appKey, moduleKey, panelInstanceId, dateAdded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4lL77.default), {
                    key: panelKey,
                    panelKey: panelKey,
                    name: name,
                    appKey: appKey,
                    moduleKey: moduleKey,
                    extension: extension,
                    isCompactMode: isCompactMode,
                    externalId: "issue.ecosystem.content-panel.forge"
                });
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dtfgR.default), {
                key: panel.name,
                name: panel.name,
                appKey: panel.appKey,
                moduleKey: panel.moduleKey
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, panels);
    }
    renderEcosystemContentPanelsNew() {
        const { contentPanels: contentPanels, isCompactMode: isCompactMode, projectType: projectType, context: context } = this.props;
        let application = null;
        let edition = null;
        if (projectType) {
            application = (0, $eIp1n.getApplicationForProject)(projectType);
            if (application && context && context.appEditions) edition = (0, $6WXNs.getEdition)(application, context.appEditions);
        }
        const panels = contentPanels.map((panel)=>{
            if (panel.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
                const { name: name, appKey: appKey, moduleKey: moduleKey, dateAdded: dateAdded, panelInstanceId: panelInstanceId, extension: extension } = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                panel;
                const panelKey = (0, $7C4za.toForgeKeyWithDate)(appKey, moduleKey, panelInstanceId, dateAdded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffYQM.EcosystemIssueViewErrorBoundary), {
                    application: application,
                    edition: edition,
                    experience: "issueViewContentItemForgePanel",
                    key: panel.name
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4lL77.default), {
                    key: panelKey,
                    panelKey: panelKey,
                    name: name,
                    appKey: appKey,
                    moduleKey: moduleKey,
                    extension: extension,
                    isCompactMode: isCompactMode,
                    externalId: "issue.ecosystem.content-panel.forge"
                }));
            }
            if ((0, $1ybV0.ff)('hrz-716-integrate-goal-picker-into-issue-view') && panel.moduleKey.includes('linked-goals-content-panel')) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffYQM.EcosystemIssueViewErrorBoundary), {
                application: application,
                edition: edition,
                experience: "issueViewContentItemConnectPanel",
                key: panel.name
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dtfgR.default), {
                key: panel.name,
                name: panel.name,
                appKey: panel.appKey,
                moduleKey: panel.moduleKey
            }));
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, panels);
    }
    renderAdditionalWebLinksSections() {
        const { additionalWebLinksSections: additionalWebLinksSections } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, additionalWebLinksSections.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
            eventName: "additionalWebLinksSections shown",
            componentName: "additionalWebLinksSections"
        }), additionalWebLinksSections.map(({ applicationId: applicationId, applicationName: applicationName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
                key: applicationId
            }, this.maybeWrapInSectionWrapper(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hjzLw.ConnectedView), {
                applicationId: applicationId,
                applicationName: applicationName
            })))));
    }
    render() {
        const { isComplete: isComplete, isCompactMode: isCompactMode, issueKey: issueKey, isEpic: isEpic, isAnonymousUser: isAnonymousUser, hasIssueLinksEntity: hasIssueLinksEntity, shouldRenderChildrenIssues: shouldRenderChildrenIssues, shouldRenderPortfolioChildrenIssues: shouldRenderPortfolioChildrenIssues, shouldRenderSubtasks: shouldRenderSubtasks, isServiceDesk: isServiceDesk, issueViewRelayFragment: issueViewRelayFragment } = this.props;
        const issueLinks = hasIssueLinksEntity ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cDMTA.default), null) : null;
        const subtasks = shouldRenderSubtasks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22cag.default), {
            key: issueKey
        }) : null;
        const childrenIssues = shouldRenderChildrenIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2m7ky.default), {
            key: issueKey
        }) : null;
        const portfolioChildIssues = shouldRenderPortfolioChildrenIssues ? // @ts-expect-error TS274 missing analyticsSource, issueTypes, fetchIssueTypesStatus, onAddChildClick, and 3 more.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUUR2.default), {
            key: issueKey
        }) : null;
        const epicIssues = isEpic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3BpHs.default), {
            key: issueKey
        }) : null;
        const attachments = isComplete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dZ3Ok.default), null) : null;
        const devOpsAppRecommendation = (0, $3PPRL.isDevOpsAppRecommenderEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "devOpsAppRecommendation",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lIwq2.AsyncDevOpsAppRecommendationPanel), null)) : null;
        const designPanel = !isAnonymousUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cBTTN.DesignPanel), null) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "issue-content-items"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hdX7K.ContentItemsWrapper), {
            isCompactMode: isCompactMode
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec8cb5b9b7778c3b$var$DevOpsAppRecommendationContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$e8e23d64897ffb27
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $10AzB.ContentTemplateRenderer), {
            issueViewRelayFragment: issueViewRelayFragment
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$463411fdb916515b
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$54f1396e5ffd4590
        }), this.maybeWrapInSectionWrapper(attachments), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$3975b248e82a7c0a
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$1b794597fcbd5751
        }), this.maybeWrapInSectionWrapper(designPanel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$70d0ea83a1808647
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$ddbcaec2748e8744
        }), this.maybeWrapInSectionWrapper(devOpsAppRecommendation), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$d94a044231640d0
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$9041a7b7e88e361c
        }), this.maybeWrapInSectionWrapper(epicIssues), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$9d129af159277ce6
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$9bd418b55b566599
        }), this.maybeWrapInSectionWrapper(childrenIssues), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$7958fe004adaa3bc
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$3d4e141840f1aac8
        }), this.maybeWrapInSectionWrapper(portfolioChildIssues), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$e60e6a80b7facff4
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$bb43ccf3e3900f2b
        }), this.maybeWrapInSectionWrapper(subtasks), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$403af9cb99ef333c
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$be6a90067f95baab
        }), this.maybeWrapInSectionWrapper(issueLinks), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$723da9c2113b48ac
        }), isServiceDesk && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$2a502f9597423df
        }), this.maybeWrapInSectionWrapper(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eFn9t.IncidentInvestigationPanel), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$9e7166db9066a70c
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$e52e4309fab00924
        }), this.maybeWrapInSectionWrapper(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3PBWj.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$23b5270957de9348
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$2e7ef86bf0b0c538
        }), this.maybeWrapInSectionWrapper(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVWzw.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$ea5c1c1aa5a7d968
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$1f85461152ae6ebe
        }), this.maybeWrapInSectionWrapper(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5b3l6.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$f98414d200c7e4b2
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$e35d17be2cbccdd3
        }), this.maybeWrapInSectionWrapper(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hjzLw.ConnectedView), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$63fc599eb362724d
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$70af08e0a6b3822f
        }), this.renderAdditionalWebLinksSections(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$d393cbfad2346d95
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$90a3abbe8506f4a0
        }), this.maybeWrapInSectionWrapper((0, $1ybV0.ff)('ecosystem_content_panel_lhs_6eptr') ? this.renderEcosystemContentPanelsNew() : this.renderEcosystemContentPanels()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$a004acf8c80d1b41
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$d2d165c326639635
        }), this.maybeWrapInSectionWrapper(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7JYKd.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$90c796d64f08408b
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$8b2039a2b5f6a2a
        }), this.maybeWrapInSectionWrapper(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9vbIS.default), {
            issueKey: issueKey
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f81f1bce6a43965e$export$c11901fec2d15d7d
        })))));
    }
}
const $ec8cb5b9b7778c3b$var$ReduxConnectedView = (0, $lqalZ.connect)((state)=>({
        issueKey: (0, $5JqpU.issueKeySelector)(state),
        contentPanels: (0, $8CSFK.ecosystemAddedContentPanelsSelector)(state),
        isComplete: (0, $jZDJX.isCompletedLoadingSelector)(state),
        isEpic: (0, $jZDJX.isEpicSelector)(state),
        isAnonymousUser: (0, $5JqpU.isAnonymousSelector)(state),
        hasIssueLinksEntity: (0, $cFY86.isIssueLinksEnabledSelector)(state),
        hasIssueLinksField: (0, $fokFV.hasIssueLinksSelector)(state),
        shouldRenderChildrenIssues: (0, $iY7NN.shouldRenderChildPanelSelector)(state),
        shouldRenderSubtasks: (0, $iY7NN.shouldRenderSubtaskPanelSelector)(state),
        shouldRenderPortfolioChildrenIssues: (0, $iY7NN.shouldRenderPortfolioChildPanelSelector)(state),
        additionalWebLinksSections: (0, $6gpYd.additionalWebLinksSectionsSelector)(state),
        isServiceDesk: (0, $jZDJX.isServiceDeskSelector)(state),
        ...(0, $1ybV0.ff)('ecosystem_content_panel_lhs_6eptr') ? {
            projectType: (0, $jZDJX.projectTypeSelector)(state),
            context: (0, $5JqpU.contextSelector)(state)
        } : {}
    }), {})((0, $jo88D.withGICHook)($ec8cb5b9b7778c3b$export$4b122c59b371202));
var $ec8cb5b9b7778c3b$export$2e2bcd8739ae039 = $ec8cb5b9b7778c3b$var$ReduxConnectedView;

});
parcelRegister("ipcjd", function(module, exports) {

$parcel$export(module.exports, "DevOpsAppRecommendationContext", () => $81cbe728052aeab1$export$6353130a987e6e26);
$parcel$export(module.exports, "DevOpsAppRecommendationContextProvider", () => $81cbe728052aeab1$export$615978922e3aa098);

var $eUqFw = parcelRequire("eUqFw");

var $hP2Rw = parcelRequire("hP2Rw");

var $6KiET = parcelRequire("6KiET");

var $gRxol = parcelRequire("gRxol");
var $6j4bv = parcelRequire("6j4bv");

var $dWLk9 = parcelRequire("dWLk9");
const $81cbe728052aeab1$export$6353130a987e6e26 = (0, $gRxol.createUseEntryPointContext)();
const $81cbe728052aeab1$export$615978922e3aa098 = ({ children: children })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const siteAri = (0, $hP2Rw.JiraSiteAri).create({
        siteId: cloudId
    }).toString();
    const entryPointParams = (0, $eUqFw.useMemo)(()=>({
            siteAri: siteAri
        }), [
        siteAri
    ]);
    const entryPointResult = (0, $6j4bv.useEntryPoint)((0, $6KiET.devOpsAppRecommendationPanelEntryPoint), entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81cbe728052aeab1$export$6353130a987e6e26.Provider, {
        value: entryPointResult
    }, children);
};

});
parcelRegister("hP2Rw", function(module, exports) {

$parcel$export(module.exports, "JiraSiteAri", () => $4116b9e0cf8d4078$export$6c0f81f222d09301);

var $5qxKt = parcelRequire("5qxKt");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/site/manifest.ts
var $4116b9e0cf8d4078$var$jiraSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $5qxKt.JiraSiteAriResourceOwner),
    resourceType: (0, $5qxKt.JiraSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9\-]+/
    }
};
// src/jira/site/index.ts
var $4116b9e0cf8d4078$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.resourceIdSegmentValues.siteId;
    }
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4116b9e0cf8d4078$var$jiraSiteAriStaticOpts.qualifier,
            platformQualifier: $4116b9e0cf8d4078$var$jiraSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $4116b9e0cf8d4078$var$jiraSiteAriStaticOpts.resourceOwner,
            resourceType: $4116b9e0cf8d4078$var$jiraSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $4116b9e0cf8d4078$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $4116b9e0cf8d4078$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
};

});
parcelRegister("5qxKt", function(module, exports) {

$parcel$export(module.exports, "JiraSiteAriResourceOwner", () => $5e838ac9aa1e3776$export$b7d590981b504412);
$parcel$export(module.exports, "JiraSiteAriResourceType", () => $5e838ac9aa1e3776$export$886165a991f21644);
// src/jira/site/types.ts
var $5e838ac9aa1e3776$export$b7d590981b504412 = "jira", $5e838ac9aa1e3776$export$886165a991f21644 = "site";

});


parcelRegister("6KiET", function(module, exports) {

$parcel$export(module.exports, "devOpsAppRecommendationPanelEntryPoint", () => $4196c5344a089fe1$export$5535cefc43afb437);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $4196c5344a089fe1$export$5535cefc43afb437 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("8lqcR")), {
        moduleId: "2f17d424"
    }),
    getPreloadProps: ()=>({
            queries: {}
        })
});

});
parcelRegister("8lqcR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('eNmuD'),
            load('h2MrD'),
            load('bYT2S'),
            load('lfPca')
        ]);
        const value = parcelRequire('7ZSqX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("eNmuD"),
        load("h2MrD"),
        load("bYT2S"),
        load("lfPca")
    ]).then(()=>parcelRequire('7ZSqX'));
}

});



parcelRegister("dZ3Ok", function(module, exports) {

$parcel$export(module.exports, "default", () => $eee81e4f943c9d91$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $aR8n6 = parcelRequire("aR8n6");

var $1ybV0 = parcelRequire("1ybV0");

var $kUI0A = parcelRequire("kUI0A");

var $eRitJ = parcelRequire("eRitJ");

var $hJ992 = parcelRequire("hJ992");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $h6cgt = parcelRequire("h6cgt");

var $dLgKj = parcelRequire("dLgKj");

var $cx1N9 = parcelRequire("cx1N9");

var $l3ayD = parcelRequire("l3ayD");
const $eee81e4f943c9d91$export$c129802f229d9594 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ error: error, value: { totalCount: totalCount } }, { refreshAttachments: refreshAttachments }] = (0, $kUI0A.useIssueAttachments)(issueKey);
    const showAttachmentPanel = totalCount > 0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    if (!(0, $1ybV0.ff)('remove-issueattachmentpanel-viewed-event_w282l')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useEffect)(()=>{
        const action = 'viewed';
        const actionSubject = 'issueAttachmentPanel';
        const attributes = {
            showAttachmentPanel: showAttachmentPanel,
            totalAttachmentCount: totalCount,
            approachLimit: (0, $eRitJ.isAttachmentNumberApproachLimit)(totalCount),
            exceedLimit: (0, $eRitJ.isAttachmentNumberExceedLimit)(totalCount)
        };
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        }), `${actionSubject} ${action}`, attributes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!showAttachmentPanel) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eee81e4f943c9d91$var$PanelWrapper, {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.issue-base.content.attachment.panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cx1N9.default), {
        totalCount: totalCount,
        refreshAttachments: refreshAttachments
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3ayD.default), {
        totalCount: totalCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h6cgt.default), {
        attachmentError: error,
        totalCount: totalCount,
        refreshAttachments: refreshAttachments
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dLgKj.default), null));
};
const $eee81e4f943c9d91$var$AttachmentsWithMonitoring = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue.base.content.attachments-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "base.content.attachments-panel",
        /* eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics */ packageName: "jiraIssueView",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eee81e4f943c9d91$export$c129802f229d9594, null)));
var $eee81e4f943c9d91$export$2e2bcd8739ae039 = $eee81e4f943c9d91$var$AttachmentsWithMonitoring;
// Max-width has been added to avoid broken images in the carousel for clients with a huge widescreen
// 1900px was set based on the maximum number of fetched items - 12 items.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eee81e4f943c9d91$var$PanelWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12fd8ac",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h6cgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $990ca082d9c92f67$export$2e2bcd8739ae039);

var $lqalZ = parcelRequire("lqalZ");

var $jZDJX = parcelRequire("jZDJX");

var $8riDc = parcelRequire("8riDc");
var $990ca082d9c92f67$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state)=>({
        isPreview: (0, $jZDJX.isPreviewSelector)(state)
    }), {})((0, $8riDc.default));

});
parcelRegister("8riDc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bec7c1666efd4cdc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eRitJ = parcelRequire("eRitJ");

var $lXghX = parcelRequire("lXghX");
var $3w3hF = parcelRequire("3w3hF");

var $hJ992 = parcelRequire("hJ992");


var $i9pAn = parcelRequire("i9pAn");


var $1tL8D = parcelRequire("1tL8D");

var $cmuhz = parcelRequire("cmuhz");
const $bec7c1666efd4cdc$var$Content = ({ attachmentError: attachmentError, refreshAttachments: refreshAttachments, isPreview: isPreview, totalCount: totalCount })=>{
    const [value] = (0, $i9pAn.useUserPreferencesValue)((0, $e4af19d777b54ab6$export$5530d4ea250d4125));
    const issueKey = (0, $hJ992.useIssueKey)();
    const onErrorClick = (0, $eUqFw.useCallback)(()=>{
        refreshAttachments(issueKey);
    }, [
        issueKey,
        refreshAttachments
    ]);
    if (attachmentError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXghX.default), {
        shouldHideImage: true,
        onClick: onErrorClick
    });
    /**
	 * Film Strip View is from Media component. Media api and Strip View will be broken when JWT token is too long.
	 * Enforce render list view when original Strip View is broken.
	 */ const renderMode = (0, $eRitJ.isAttachmentNumberExceedLimit)(totalCount) ? (0, $f23197a8cbf177f2$export$b7fd448c62b5fb97) : value;
    switch(renderMode){
        case 0, $f23197a8cbf177f2$export$b7fd448c62b5fb97:
            if (isPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3w3hF.default), {
                totalCount: totalCount
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cmuhz.default), null);
        case 0, $f23197a8cbf177f2$export$5a2eee19a0e3c3b1:
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1tL8D.default), null);
    }
};
var $bec7c1666efd4cdc$export$2e2bcd8739ae039 = $bec7c1666efd4cdc$var$Content;

});
parcelRegister("lXghX", function(module, exports) {

$parcel$export(module.exports, "default", () => $344a17babd877e4c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $5JgJ2 = parcelRequire("5JgJ2");

var $avZ3b = parcelRequire("avZ3b");

var $aPqno = parcelRequire("aPqno");
const $344a17babd877e4c$var$AttachmentsError = ({ onClick: onClick, shouldHideImage: shouldHideImage })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const imageUrl = !shouldHideImage ? (0, (/*@__PURE__*/$parcel$interopDefault($avZ3b))) : undefined;
    const errorStatePrimaryAction = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: ()=>onClick(),
        interactionName: "auto-generated.jira-issue-attachments-table.ui.error.button"
    }, formatMessage((0, $aPqno.default).primaryButton));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($344a17babd877e4c$var$StyledEmptyState, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        imageUrl: imageUrl,
        header: formatMessage((0, $aPqno.default).errorStateTitle),
        description: formatMessage((0, $aPqno.default).errorStateDescription),
        primaryAction: errorStatePrimaryAction
    }));
};
$344a17babd877e4c$var$AttachmentsError.defaultProps = {
    shouldHideImage: false
};
var $344a17babd877e4c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $344a17babd877e4c$var$AttachmentsError;
const $344a17babd877e4c$var$StyledEmptyState = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bch1wug _1yb11wug _79pa1wug _1rhw1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("avZ3b", function(module, exports) {
module.exports = new URL("search.e03599e7.svg", import.meta.url).toString();

});

parcelRegister("aPqno", function(module, exports) {

$parcel$export(module.exports, "default", () => $b64fa7c551c15203$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b64fa7c551c15203$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorStateTitle: {
        "id": "issue-attachments-table.error.error-state-title",
        "defaultMessage": "We couldn't load your attachments"
    },
    errorStateDescription: {
        "id": "issue-attachments-table.error.error-state-description",
        "defaultMessage": "Check your network connection, then try reloading your attachments."
    },
    primaryButton: {
        "id": "issue-attachments-table.error.primary-button",
        "defaultMessage": "Reload Attachments"
    }
});

});


parcelRegister("3w3hF", function(module, exports) {

$parcel$export(module.exports, "default", () => $900d8535b76c626a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $PdmhA = parcelRequire("PdmhA");

var $aKP4l = parcelRequire("aKP4l");
const $900d8535b76c626a$var$TableItem = ({ nameTextWidthPercentage: nameTextWidthPercentage, dateAddedWidth: dateAddedWidth })=>{
    const lineHeight = 40;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$SkeletonBox, {
        height: 24,
        minWidth: 24,
        lineHeight: lineHeight,
        borderLeft: 6
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$SkeletonBox, {
        height: 14,
        width: `${nameTextWidthPercentage}%`,
        lineHeight: lineHeight,
        borderLeft: 8,
        borderRight: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$WhiteDiv, {
        width: `${100 - nameTextWidthPercentage}%`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$SkeletonBox, {
        height: 14,
        minWidth: 50,
        lineHeight: lineHeight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$SkeletonBox, {
        height: 14,
        minWidth: dateAddedWidth,
        lineHeight: lineHeight,
        borderLeft: 16
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$SkeletonBox, {
        height: 24,
        minWidth: 24,
        lineHeight: lineHeight,
        borderLeft: 62 + (170 - dateAddedWidth),
        borderRight: 12
    }));
};
const $900d8535b76c626a$var$AttachmentsTableSkeleton = (props)=>{
    const { pageNumber: pageNumber, totalCount: totalCount } = props;
    const remaining = totalCount - (0, $aKP4l.ITEMS_PER_PAGE) * (pageNumber - 1);
    const numberOfRows = Math.min(remaining, (0, $aKP4l.ITEMS_PER_PAGE));
    const tableRowValues = [
        {
            nameTextWidthPercentage: 80,
            dateAddedWidth: 170
        },
        {
            nameTextWidthPercentage: 70,
            dateAddedWidth: 150
        },
        {
            nameTextWidthPercentage: 80,
            dateAddedWidth: 160
        },
        {
            nameTextWidthPercentage: 60,
            dateAddedWidth: 140
        },
        {
            nameTextWidthPercentage: 70,
            dateAddedWidth: 155
        },
        {
            nameTextWidthPercentage: 80,
            dateAddedWidth: 170
        }
    ];
    // this is to make sure there is no added jank from pagination buttons below the table
    const tableBottomPadding = totalCount > 6 ? 55 : 23;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$SkeletonBackground, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$ContainerMask, {
        paddingTop: 0,
        paddingBottom: tableBottomPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$SkeletonBox, {
        height: 14,
        minWidth: 50,
        lineHeight: 26
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$WhiteDiv, {
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$SkeletonBox, {
        height: 14,
        minWidth: 40,
        lineHeight: 26,
        borderLeft: 16
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$SkeletonBox, {
        height: 14,
        minWidth: 100,
        lineHeight: 26,
        borderLeft: 26
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$SkeletonBox, {
        height: 0,
        minWidth: 24,
        lineHeight: 26,
        borderLeft: 144
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$SkeletonBox, {
        height: 2,
        lineHeight: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$ContainerMask, {
        paddingTop: 0,
        paddingBottom: 0
    }, Array.from({
        length: numberOfRows
    }).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$TableItem, {
            ...tableRowValues[index],
            key: `table-item--${index}`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($900d8535b76c626a$var$SkeletonBox, {
        height: 2,
        lineHeight: 2
    })));
};
$900d8535b76c626a$var$AttachmentsTableSkeleton.defaultProps = {
    pageNumber: 1,
    totalCount: (0, $aKP4l.ITEMS_PER_PAGE)
};
var $900d8535b76c626a$export$2e2bcd8739ae039 = $900d8535b76c626a$var$AttachmentsTableSkeleton;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $900d8535b76c626a$var$SkeletonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1e0c1txw _kqswh2mm _oiqe1wug",
            __cmplp.className
        ])
    });
});
const $900d8535b76c626a$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $900d8535b76c626a$var$SkeletonBackground = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhk1yrq _1itkgqqz _12vemgnk _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.className
        ])
    });
});
const $900d8535b76c626a$var$SkeletonBox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minWidth: minWidth, lineHeight: lineHeight, borderRight: borderRight, borderLeft: borderLeft, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`),
            "--_zam2fy": (0, $9t7rW.default)(`${__cmplp.minWidth}px`),
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width),
            "--_1gs25qp": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${(__cmplp.lineHeight - __cmplp.height) / 2}px solid ${`var(--ds-surface, ${(0, $PdmhA).N0})`}`),
            "--_1ly0ujx": (0, $9t7rW.default)(`${__cmplp.borderRight}px solid ${`var(--ds-surface, ${(0, $PdmhA).N0})`}`),
            "--_1r5optz": (0, $9t7rW.default)(`${__cmplp.borderLeft}px solid ${`var(--ds-surface, ${(0, $PdmhA).N0})`}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tke2nrh _1ul9v3iq _1bsb1rkg _x3doagp2 _n7zlagp2 _1s7z11qa _1kl712nm",
            __cmplp.className
        ])
    });
});
const $900d8535b76c626a$var$ContainerMask = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { paddingTop: paddingTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_qmoirf": (0, $9t7rW.default)(`${__cmplp.paddingTop}px solid ${`var(--ds-surface, ${(0, $PdmhA).N0})`}`),
            "--_1bl2t8c": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${__cmplp.paddingBottom}px solid ${`var(--ds-surface, ${(0, $PdmhA).N0})`}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsb1osq _x3do1sgj _n7zlhon3",
            __cmplp.className
        ])
    });
});
const $900d8535b76c626a$var$WhiteDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q7vuon _1bsb1rkg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aKP4l", function(module, exports) {

$parcel$export(module.exports, "ITEMS_PER_PAGE", () => $2cdb0a6eb0debb5c$export$ec93a669a20aa982);
$parcel$export(module.exports, "TABLE_ROW_CLASSNAME", () => $2cdb0a6eb0debb5c$export$11ba373cd2409568);
$parcel$export(module.exports, "ROW_HIGHLIGHT_CLASSNAME", () => $2cdb0a6eb0debb5c$export$342cadd7fce91bbd);
$parcel$export(module.exports, "LIST_VIEW_COLUMN_KEYS", () => $2cdb0a6eb0debb5c$export$22fa2a23dc9bcb);
$parcel$export(module.exports, "WIDTH_TO_HIDE_SIZE_COLUMN", () => $2cdb0a6eb0debb5c$export$a725595659982b5c);
$parcel$export(module.exports, "SIZE_COLUMN_WIDTH", () => $2cdb0a6eb0debb5c$export$4010ac9507820227);
$parcel$export(module.exports, "DATE_COLUMN_WIDTH", () => $2cdb0a6eb0debb5c$export$3999c386e44bf3f6);
$parcel$export(module.exports, "DOWNLOAD_COLUMN_WIDTH", () => $2cdb0a6eb0debb5c$export$3a31a3946b72ac7e);
$parcel$export(module.exports, "DELETE_OR_GOTO_COLUMN_WIDTH", () => $2cdb0a6eb0debb5c$export$61f6befc5d845487);
const $2cdb0a6eb0debb5c$export$ec93a669a20aa982 = 6;
const $2cdb0a6eb0debb5c$export$11ba373cd2409568 = 'jira-issue-view-attachments-table';
const $2cdb0a6eb0debb5c$export$342cadd7fce91bbd = 'media-table-row-highlighted';
const $2cdb0a6eb0debb5c$export$22fa2a23dc9bcb = {
    DATE: 'date',
    DELETE_OR_GOTO: 'deleteOrGoto',
    DOWNLOAD: 'download',
    CUSTOM_DOWNLOAD: 'customDownload',
    FILE: 'file',
    SIZE: 'size'
};
const $2cdb0a6eb0debb5c$export$a725595659982b5c = 430;
const $2cdb0a6eb0debb5c$export$4010ac9507820227 = 66;
const $2cdb0a6eb0debb5c$export$3999c386e44bf3f6 = 188;
const $2cdb0a6eb0debb5c$export$3a31a3946b72ac7e = 48;
const $2cdb0a6eb0debb5c$export$61f6befc5d845487 = 36;

});


const $f23197a8cbf177f2$export$b7fd448c62b5fb97 = 'list-view';
const $f23197a8cbf177f2$export$5a2eee19a0e3c3b1 = 'strip-view';

parcelRegister("1tL8D", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce3f615b8d0f6c66$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $c8Guq = parcelRequire("c8Guq");

var $i9Tiv = parcelRequire("i9Tiv");
var $bc4G4 = parcelRequire("bc4G4");
var $hxQcL = parcelRequire("hxQcL");

var $b3BbA = parcelRequire("b3BbA");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $4ksts = parcelRequire("4ksts");

var $kUI0A = parcelRequire("kUI0A");
var $33J8p = parcelRequire("33J8p");

var $lXghX = parcelRequire("lXghX");

var $hJ992 = parcelRequire("hJ992");

var $7bqJz = parcelRequire("7bqJz");

var $wKt79 = parcelRequire("wKt79");

var $lqalZ = parcelRequire("lqalZ");

var $lSVfs = parcelRequire("lSVfs");

var $khpWz = parcelRequire("khpWz");

var $20th5 = parcelRequire("20th5");

var $hlJEN = parcelRequire("hlJEN");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $gS8e9 = parcelRequire("gS8e9");

var $4Fgnj = parcelRequire("4Fgnj");

var $6y4qx = parcelRequire("6y4qx");

var $kqcDC = parcelRequire("kqcDC");
// defaultImageCardDimensions are copied from @atlaskit/media-card as flow doesn't recognise the export
const $ce3f615b8d0f6c66$var$defaultImageCardDimensions = {
    width: 156,
    height: 125
};
const $ce3f615b8d0f6c66$var$DEBOUNCE_DURATION = 300;
const $ce3f615b8d0f6c66$var$fakeCard = (key)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bc4G4.CardLoading), {
        key: key,
        dimensions: $ce3f615b8d0f6c66$var$defaultImageCardDimensions
    });
const $ce3f615b8d0f6c66$export$334f5ac44f6e5c09 = (props)=>{
    const intl = (0, $4ksts.useIntlV2)();
    const [filmstripOffset, setFilmstripOffset] = (0, $eUqFw.useState)(0);
    const [filmstripStartAt, setFilmstripStartAt] = (0, $eUqFw.useState)(0);
    const [cardOffsets, setCardOffsets] = (0, $eUqFw.useState)([]);
    const [animate, setAnimate] = (0, $eUqFw.useState)(false);
    const { cardCover: cardCover, isMobile: isMobile, isPreview: isPreview, mediaContext: mediaContext, onCardCoverHide: onCardCoverHide, onCardCoverShow: onCardCoverShow, onScrollToComments: onScrollToComments, onScrollToWorklogs: onScrollToWorklogs, viewMediaClientConfig: viewMediaClientConfig, onDeleteAttachment: onDeleteAttachment, canDeleteAttachmentMap: canDeleteAttachmentMap } = props;
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ value: { attachments: attachments, totalCount: totalCount }, meta: { startAt: attachmentStartAt }, error: error }, { refreshAttachments: refreshAttachments }] = (0, $kUI0A.useIssueAttachments)(issueKey);
    // @ts-expect-error - TS7031 - Binding element 'newOffset' implicitly has an 'any' type. | TS7031 - Binding element 'offsets' implicitly has an 'any' type.
    const handleSizeChange = (0, $eUqFw.useCallback)(({ offset: newOffset, offsets: offsets })=>{
        setCardOffsets(offsets);
        setFilmstripOffset(newOffset);
    }, []);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedRefreshAttachments = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(refreshAttachments, $ce3f615b8d0f6c66$var$DEBOUNCE_DURATION), [
        refreshAttachments
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (attachmentStartAt === 0) setFilmstripOffset(0);
    }, [
        attachmentStartAt
    ]);
    const handleScrollChange = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'newAnimate' implicitly has an 'any' type. | TS7031 - Binding element 'newOffset' implicitly has an 'any' type.
    ({ animate: newAnimate, offset: newOffset })=>{
        const newStartAt = cardOffsets.findIndex((cardOffset)=>cardOffset.left > newOffset) - 1;
        setAnimate(newAnimate);
        setFilmstripStartAt(newStartAt);
        setFilmstripOffset(newOffset);
        debouncedRefreshAttachments(issueKey, {
            startAt: newStartAt
        });
    }, [
        cardOffsets,
        debouncedRefreshAttachments,
        issueKey
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const attachmentsArray = attachments || [];
    const items = (0, $eUqFw.useMemo)(()=>attachmentsArray.map((attachment)=>{
            const identifier = {
                mediaItemType: 'file',
                id: attachment.mediaApiFileId,
                attachmentId: attachment.id,
                ...mediaContext.viewContext && mediaContext.viewContext.collection !== null ? {
                    collectionName: mediaContext.viewContext.collection
                } : {}
            };
            const actions = (0, $kqcDC.getActionsForAttachment)(attachment.id, attachment.parentName, attachment.parentId, cardCover, canDeleteAttachmentMap[attachment.id], intl, issueKey, onDeleteAttachment, onCardCoverShow, onCardCoverHide, onScrollToComments, onScrollToWorklogs);
            return {
                identifier: identifier,
                selectable: false,
                actions: actions,
                isLazy: !isMobile,
                hasRestrictedParent: attachment.hasRestrictedParent
            };
        }), [
        attachmentsArray,
        canDeleteAttachmentMap,
        cardCover,
        intl,
        isMobile,
        issueKey,
        mediaContext.viewContext,
        onCardCoverHide,
        onCardCoverShow,
        onDeleteAttachment,
        onScrollToComments,
        onScrollToWorklogs
    ]);
    const getCards = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'visibleItems' implicitly has an 'any' type.
    (visibleItems)=>{
        const attachmentIdentifiers = visibleItems.map(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (item)=>item.identifier);
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type. | TS7006 - Parameter 'index' implicitly has an 'any' type.
        const visibleCards = visibleItems.map((item, index)=>{
            if (isPreview || error) return $ce3f615b8d0f6c66$var$fakeCard(`card-${index}`);
            const isInternalAttachment = item.hasRestrictedParent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i9Tiv.default), {
                key: item.identifier.id,
                mediaClientConfig: viewMediaClientConfig,
                mediaViewerItems: attachmentIdentifiers,
                useInlinePlayer: false,
                dimensions: $ce3f615b8d0f6c66$var$defaultImageCardDimensions,
                shouldOpenMediaViewer: true,
                featureFlags: (0, $6y4qx.mediaFeatureFlags)(),
                titleBoxBgColor: isInternalAttachment ? `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).Y75})` : undefined,
                titleBoxIcon: isInternalAttachment ? 'LockFilledIcon' : undefined,
                shouldEnableDownloadButton: true,
                ...item,
                testId: `issue.views.issue-base.content.attachment.filmstrip-view.attachment-id.${item.identifier.attachmentId}`
            });
        });
        const endFakeCardsCount = totalCount - visibleCards.length - attachmentStartAt;
        const beginningFakeCards = Array.from({
            length: attachmentStartAt
        }).map((_, index)=>$ce3f615b8d0f6c66$var$fakeCard(`card-${index}`));
        const endFakeCards = Array.from({
            length: endFakeCardsCount
        }).map((_, index)=>$ce3f615b8d0f6c66$var$fakeCard(`card-${totalCount - endFakeCardsCount + index}`));
        return [
            ...beginningFakeCards,
            ...visibleCards,
            ...endFakeCards
        ];
    }, [
        attachmentStartAt,
        error,
        isPreview,
        totalCount,
        viewMediaClientConfig
    ] // only recalculate the cards when items changes
    );
    const onClick = (0, $eUqFw.useCallback)(()=>{
        refreshAttachments(issueKey, {
            startAt: filmstripStartAt
        });
    }, [
        filmstripStartAt,
        issueKey,
        refreshAttachments
    ]);
    const overrideCreationDate = (0, $eUqFw.useMemo)(()=>{
        const overrides = {};
        attachments.forEach((attachment)=>{
            overrides[attachment.mediaApiFileId] = attachment.createdDate * 1000;
        });
        return overrides;
    }, [
        attachments
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXghX.default), {
        shouldHideImage: true,
        onClick: onClick
    });
    if ((0, $1ybV0.ff)('override-date-for-attachment-timestamp-in-film-strip_ymajc')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "issue.views.issue-base.content.attachment.filmstrip-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hxQcL.DateOverrideContext).Provider, {
        value: overrideCreationDate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b3BbA.FilmstripView), {
        offset: filmstripOffset,
        animate: animate,
        onSize: handleSizeChange,
        onScroll: handleScrollChange,
        // @ts-expect-error - TS2322 - Type '{ children: readonly any[]; offset: number; animate: boolean; onSize: ({ offset: newOffset, offsets }: any) => void; onScroll: ({ animate: newAnimate, offset: newOffset }: any) => void; mediaClientConfig: MediaClientConfig; featureFlags: { newCardExperience: boolean; folderUploads: boolean; mediaInline: boolean; med...' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<FilmstripView> & Pick<Readonly<FilmstripViewProps> & Readonly<...>, never> & Partial<...> & Partial<...>'.
        mediaClientConfig: viewMediaClientConfig,
        featureFlags: (0, $6y4qx.mediaFeatureFlags)(),
        testId: "issue-view-base.content.attachment.filmstrip-view"
    }, getCards(items))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "issue.views.issue-base.content.attachment.filmstrip-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b3BbA.FilmstripView), {
        offset: filmstripOffset,
        animate: animate,
        onSize: handleSizeChange,
        onScroll: handleScrollChange,
        // @ts-expect-error - TS2322 - Type '{ children: readonly any[]; offset: number; animate: boolean; onSize: ({ offset: newOffset, offsets }: any) => void; onScroll: ({ animate: newAnimate, offset: newOffset }: any) => void; mediaClientConfig: MediaClientConfig; featureFlags: { newCardExperience: boolean; folderUploads: boolean; mediaInline: boolean; med...' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<FilmstripView> & Pick<Readonly<FilmstripViewProps> & Readonly<...>, never> & Partial<...> & Partial<...>'.
        mediaClientConfig: viewMediaClientConfig,
        featureFlags: (0, $6y4qx.mediaFeatureFlags)()
    }, getCards(items)));
};
var $ce3f615b8d0f6c66$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $33J8p.default), (0, $7bqJz.default), (0, $lqalZ.connect)((state)=>({
        mediaContext: (0, $gS8e9.mediaContextSelector)(state),
        isMobile: (0, $5JqpU.isMobileSelector)(state),
        cardCover: (0, $4Fgnj.isCardCoverEnabledSelector)(state) ? (0, $4Fgnj.cardCoverSelector)(state) : null,
        isPreview: (0, $jZDJX.isPreviewSelector)(state)
    }), (dispatch)=>({
        onCardCoverShow: (currentAttachmentId, newAttachmentId)=>{
            dispatch((0, $lSVfs.cardCoverUpdateRequest)(currentAttachmentId, newAttachmentId));
        },
        onCardCoverHide: (currentAttachmentId)=>{
            dispatch((0, $lSVfs.cardCoverUpdateRequest)(currentAttachmentId));
        },
        onScrollToComments: ()=>{
            dispatch((0, $khpWz.scrollToAttachmentComment)());
        },
        onScrollToWorklogs: ()=>{
            dispatch((0, $khpWz.scrollToAttachmentWorklog)());
        },
        onViewRefresh: ()=>{
            dispatch((0, $hlJEN.fetchViewContextRequest)());
        },
        onUploadRefresh: ()=>{
            dispatch((0, $20th5.fetchUploadContextRequest)());
        }
    })), (0, $wKt79.safeComponent)())($ce3f615b8d0f6c66$export$334f5ac44f6e5c09);

});
parcelRegister("i9Tiv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d383f62e156fe368$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $fgQyI = parcelRequire("fgQyI");

var $9Blje = parcelRequire("9Blje");
function $d383f62e156fe368$var$CardSwitcher(props) {
    return (0, $XHGTv.getBooleanFF)('platform.media-experience.cardv2_7zann') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Blje.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fgQyI.default), props);
}
var $d383f62e156fe368$export$2e2bcd8739ae039 = $d383f62e156fe368$var$CardSwitcher;

});
parcelRegister("fgQyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1e11eb9813573ec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $bc4G4 = parcelRequire("bc4G4");
const $b1e11eb9813573ec$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
const $b1e11eb9813573ec$var$CardLoadingWithContext = ()=>{
    const props = (0, $eUqFw.useContext)($b1e11eb9813573ec$var$MediaCardContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bc4G4.CardLoading), props);
};

const $b1e11eb9813573ec$var$MediaCardWithMediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("1mk9s")).then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1e11eb9813573ec$var$CardLoadingWithContext, null)
});
const $b1e11eb9813573ec$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1e11eb9813573ec$var$MediaCardContext.Provider, {
        value: props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1e11eb9813573ec$var$MediaCardWithMediaClient, props));
};
var $b1e11eb9813573ec$export$2e2bcd8739ae039 = $b1e11eb9813573ec$var$CardLoader;

});
parcelRegister("bc4G4", function(module, exports) {

$parcel$export(module.exports, "CardLoading", () => $82647192d4ce1c6c$export$5d25853fd6bdf402);

var $eUqFw = parcelRequire("eUqFw");

var $22XN7 = parcelRequire("22XN7");

var $erOY6 = parcelRequire("erOY6");

var $4Bees = parcelRequire("4Bees");
class $82647192d4ce1c6c$export$5d25853fd6bdf402 extends (0, $eUqFw.Component) {
    render() {
        const { dimensions: dimensionsProp, testId: testId } = this.props;
        const dimensions = (0, $22XN7.getDimensionsWithDefault)(dimensionsProp);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $erOY6.Wrapper), {
            "data-testid": testId || 'media-card-loading',
            "data-test-loading": true,
            dimensions: dimensions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            interactionName: "media-card-loading"
        }));
    }
}

});
parcelRegister("22XN7", function(module, exports) {

$parcel$export(module.exports, "getDimensionsWithDefault", () => $17da25f4d7d6a40b$export$36acad525b1fb57b);
const $17da25f4d7d6a40b$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});

parcelRegister("erOY6", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $a84b1f8c9e1a11a1$export$e6dfd72ab29f8598);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aokC7 = parcelRequire("aokC7");
const $a84b1f8c9e1a11a1$export$e6dfd72ab29f8598 = (props)=>{
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        css: (0, $aokC7.wrapperStyles)({
            dimensions: props.dimensions
        })
    }, props), props.children);
};

});
parcelRegister("aokC7", function(module, exports) {

$parcel$export(module.exports, "wrapperStyles", () => $790c22c42292a440$export$491e6397d7c1480b);

var $byn9U = parcelRequire("byn9U");

var $9PkPI = parcelRequire("9PkPI");

var $PdmhA = parcelRequire("PdmhA");
const $790c22c42292a440$export$491e6397d7c1480b = ({ dimensions: dimensions })=>(0, $byn9U.css)((0, $9PkPI.center), {
        background: `var(--ds-background-neutral, ${(0, $PdmhA.N20)})`,
        color: `var(--ds-icon, ${(0, $PdmhA.N50)})`
    }, (0, $9PkPI.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        width: dimensions.width,
        height: dimensions.height
    });

});
parcelRegister("9PkPI", function(module, exports) {

$parcel$export(module.exports, "ellipsis", () => $727909803a7b6aa7$export$a5b94313d6908893);
$parcel$export(module.exports, "size", () => $727909803a7b6aa7$export$346677f925de839c);
$parcel$export(module.exports, "center", () => $727909803a7b6aa7$export$3481c78889e8fbe8);
$parcel$export(module.exports, "borderRadius", () => $727909803a7b6aa7$export$7a57f79000377ca2);

var $lcnyw = parcelRequire("lcnyw");
const $727909803a7b6aa7$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $727909803a7b6aa7$export$346677f925de839c = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
const $727909803a7b6aa7$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $727909803a7b6aa7$export$d31af2dc8039efd3 = (top = 0, left = 0)=>`
  position: absolute;
  top: ${top}px;
  left: ${left}px;
`;
const $727909803a7b6aa7$export$7a57f79000377ca2 = `
  border-radius: ${(0, $lcnyw.borderRadius)()}px;
`;
const $727909803a7b6aa7$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${(0, $lcnyw.borderRadius)()}px;
  border-bottom-right-radius: ${(0, $lcnyw.borderRadius)()}px;
`;
const $727909803a7b6aa7$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

});




parcelRegister("1mk9s", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('d4IuK')
        ]);
        const value = parcelRequire('hEKAc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("d4IuK")
    ]).then(()=>parcelRequire('hEKAc'));
}

});


parcelRegister("9Blje", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fd81951a6b28f2f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $bc4G4 = parcelRequire("bc4G4");
const $6fd81951a6b28f2f$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
const $6fd81951a6b28f2f$var$CardLoadingWithContext = ()=>{
    const props = (0, $eUqFw.useContext)($6fd81951a6b28f2f$var$MediaCardContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bc4G4.CardLoading), props);
};

const $6fd81951a6b28f2f$var$MediaCardWithMediaClientProvider = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("gNRuU")).then((mod)=>mod.CardWithMediaClientV2),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fd81951a6b28f2f$var$CardLoadingWithContext, null)
});
const $6fd81951a6b28f2f$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fd81951a6b28f2f$var$MediaCardContext.Provider, {
        value: props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fd81951a6b28f2f$var$MediaCardWithMediaClientProvider, props));
};
var $6fd81951a6b28f2f$export$2e2bcd8739ae039 = $6fd81951a6b28f2f$var$CardLoader;

});
parcelRegister("gNRuU", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('3Dnd5')
        ]);
        const value = parcelRequire('9zk6d');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("3Dnd5")
    ]).then(()=>parcelRequire('9zk6d'));
}

});



parcelRegister("hxQcL", function(module, exports) {

$parcel$export(module.exports, "DateOverrideContext", () => $cc5e0382b574e8df$export$5bc85d7cf4a39f3e);

var $eUqFw = parcelRequire("eUqFw");
const $cc5e0382b574e8df$export$5bc85d7cf4a39f3e = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});

parcelRegister("b3BbA", function(module, exports) {

$parcel$export(module.exports, "MediaFilmStripListItemSelector", () => $80ccd1db4f9d4b62$export$9f2ec2b609810bce);
$parcel$export(module.exports, "FilmstripView", () => $80ccd1db4f9d4b62$export$817db220b90d8024);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $1TPo5 = parcelRequire("1TPo5");

var $251Pv = parcelRequire("251Pv");
const $80ccd1db4f9d4b62$var$DURATION_MIN = 0.5;
const $80ccd1db4f9d4b62$var$DURATION_MAX = 1.0;
const $80ccd1db4f9d4b62$var$EXTRA_PADDING = 4;
const $80ccd1db4f9d4b62$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $80ccd1db4f9d4b62$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $80ccd1db4f9d4b62$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        (0, $5zQU9.default)(this, "previousOffset", 0);
        (0, $5zQU9.default)(this, "state", {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        });
        (0, $5zQU9.default)(this, "handleSizeChange", ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        });
        (0, $5zQU9.default)(this, "handleWindowElementChange", (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        });
        (0, $5zQU9.default)(this, "handleBufferElementChange", (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        });
        (0, $5zQU9.default)(this, "handleMutation", (mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        });
        (0, $5zQU9.default)(this, "handleLeftClick", (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                const newOffset = this.getClosestForLeft(this.offset - windowWidth);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        });
        (0, $5zQU9.default)(this, "handleRightClick", (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                const newOffset = this.getClosestForRight(this.offset + windowWidth);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        });
        (0, $5zQU9.default)(this, "handleScroll", (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        });
        (0, $5zQU9.default)(this, "handleTouchStart", (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        });
        (0, $5zQU9.default)(this, "handleTouchEnd", (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        });
        (0, $5zQU9.default)(this, "handleTouchMove", (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        });
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($1TPo5)))(this.handleMutation, 30, true));
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
   * The furthest we can scroll, where the end of the buffer is just in view
   */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $80ccd1db4f9d4b62$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $80ccd1db4f9d4b62$var$DURATION_MAX - $80ccd1db4f9d4b62$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $80ccd1db4f9d4b62$var$DURATION_MAX), $80ccd1db4f9d4b62$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $80ccd1db4f9d4b62$export$ba458cf715b18bd1);
        }
    }
    triggerScrollEvent() {
        if (!this.windowElement) return;
        const event = document.createEvent('MouseEvents');
        event.initEvent('scroll', true, true);
        this.windowElement.dispatchEvent(event);
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $80ccd1db4f9d4b62$var$EXTRA_PADDING) return newOffset - $80ccd1db4f9d4b62$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $80ccd1db4f9d4b62$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $80ccd1db4f9d4b62$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $251Pv.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $251Pv.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
        // trigger a "real" scroll event so lazily loaded cards realize they've been shown
        // note: we have to wait for the transition to end, otherwise the cards not visible when the scroll
        // event is triggered will be forever stuck in the loading screen (due to the lazy load)
        window.setTimeout(()=>this.triggerScrollEvent(), this.transitionDuration * 1000);
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $251Pv.FilmStripViewWrapper), {
            "data-testid": testId
        }, this.renderLeftArrow(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $251Pv.FilmStripListWrapper), {
            ref: this.handleWindowElementChange,
            onWheel: this.handleScroll,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd,
            "data-testid": "filmstrip-list-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $251Pv.FilmStripList), {
            ref: this.handleBufferElementChange,
            style: {
                transform: transform,
                transitionProperty: transitionProperty,
                transitionDuration: transitionDuration
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, $80ccd1db4f9d4b62$var$mapReactChildToReactNode))), this.renderRightArrow());
    }
}
(0, $5zQU9.default)($80ccd1db4f9d4b62$export$817db220b90d8024, "defaultProps", {
    animate: false,
    offset: 0
});
function $80ccd1db4f9d4b62$var$mapReactChildToReactNode(child, index) {
    const key = $80ccd1db4f9d4b62$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $251Pv.FilmStripListItem), {
        key: key,
        index: key
    }, child);
}
function $80ccd1db4f9d4b62$var$isReactElement(child) {
    return !!child.type;
}

});
parcelRegister("1TPo5", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ module.exports = function debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
};

});

parcelRegister("251Pv", function(module, exports) {

$parcel$export(module.exports, "LeftArrow", () => $183d77bd9df29f98$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $183d77bd9df29f98$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $183d77bd9df29f98$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $183d77bd9df29f98$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $183d77bd9df29f98$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $183d77bd9df29f98$export$54cfc70c184c0713);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $gpZWO = parcelRequire("gpZWO");

var $cSu9v = parcelRequire("cSu9v");

var $b3BbA = parcelRequire("b3BbA");

var $PdmhA = parcelRequire("PdmhA");
const $183d77bd9df29f98$var$filmStripViewStyles = (0, $byn9U.css)({
    position: 'relative',
    padding: `${"var(--ds-space-025, 3px)"} 0`,
    borderRadius: '3px',
    '&:hover .arrow': {
        opacity: 1
    },
    '.ellipsed-text': {
        whiteSpace: 'initial'
    }
});
const $183d77bd9df29f98$var$filmStripListWrapperStyles = (0, $byn9U.css)({
    width: 'inherit',
    overflow: 'hidden',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-025, 3px)"}`
});
const $183d77bd9df29f98$var$filmStripListStyles = (0, $byn9U.css)({
    margin: 0,
    padding: 0,
    transitionProperty: 'transform',
    transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
    whiteSpace: 'nowrap',
    display: 'inline-block'
});
const $183d77bd9df29f98$var$filmStripListItemStyles = (0, $byn9U.css)({
    listStyleType: 'none',
    margin: 0,
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    ':first-child': {
        paddingLeft: 0
    },
    display: 'inline-block',
    verticalAlign: 'middle',
    fontSize: 0
});
const $183d77bd9df29f98$var$arrowWrapperStyles = (0, $byn9U.css)({
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N20)})`,
    borderRadius: '100%',
    display: 'flex',
    cursor: 'pointer',
    transition: 'opacity 0.3s',
    boxShadow: "var(--ds-shadow-overlay, 0 1px 6px 0 rgba(0, 0, 0, 0.6))",
    color: "var(--ds-icon, black)",
    width: '30px',
    height: '30px',
    justifyContent: 'center',
    opacity: 0,
    '&:hover': {
        color: "var(--ds-text-subtle, black)",
        backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $PdmhA.N40)})`
    },
    '&:active': {
        color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
        backgroundColor: `var(--ds-background-selected, ${(0, $PdmhA.B50)})`
    },
    svg: {
        height: '30px',
        width: '20px'
    }
});
const $183d77bd9df29f98$var$arrowLeftWrapperStyles = (0, $byn9U.css)($183d77bd9df29f98$var$arrowWrapperStyles, {
    left: "var(--ds-space-100, 8px)",
    svg: {
        paddingRight: "var(--ds-space-025, 2px)"
    }
});
const $183d77bd9df29f98$var$arrowRightWrapperStyles = (0, $byn9U.css)($183d77bd9df29f98$var$arrowWrapperStyles, {
    right: "var(--ds-space-100, 8px)",
    svg: {
        paddingLeft: "var(--ds-space-025, 2px)"
    }
});
const $183d77bd9df29f98$var$shadowStyles = (0, $byn9U.css)({
    position: 'absolute',
    zIndex: 10,
    height: '100%',
    top: 0,
    width: '2px',
    backgroundColor: "var(--ds-border, rgba(0, 0, 0, 0.2))"
});
const $183d77bd9df29f98$var$shadowLeftStyles = (0, $byn9U.css)($183d77bd9df29f98$var$shadowStyles, {
    left: 0
});
const $183d77bd9df29f98$var$shadowRightStyles = (0, $byn9U.css)($183d77bd9df29f98$var$shadowStyles, {
    right: 0
});
const $183d77bd9df29f98$var$ShadowLeft = ({ children: children })=>(0, $byn9U.jsx)("div", {
        css: $183d77bd9df29f98$var$shadowLeftStyles
    }, children);
const $183d77bd9df29f98$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>(0, $byn9U.jsx)("div", {
        css: $183d77bd9df29f98$var$arrowLeftWrapperStyles,
        className: "arrow",
        onClick: onClick
    }, children);
const $183d77bd9df29f98$export$a5ffe38c17bbc0a1 = ({ children: children })=>(0, $byn9U.jsx)("div", {
        css: $183d77bd9df29f98$var$shadowRightStyles
    }, children);
const $183d77bd9df29f98$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>(0, $byn9U.jsx)("div", {
        css: $183d77bd9df29f98$var$arrowRightWrapperStyles,
        className: "arrow",
        onClick: onClick
    }, children);
const $183d77bd9df29f98$export$b39b1b86b48b621f = ({ onClick: onClick })=>(0, $byn9U.jsx)($183d77bd9df29f98$var$ShadowLeft, null, (0, $byn9U.jsx)($183d77bd9df29f98$export$924abd21043fc000, {
        onClick: onClick
    }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gpZWO))), {
        label: "left"
    })));
const $183d77bd9df29f98$export$6208675820d4cc50 = ({ onClick: onClick })=>(0, $byn9U.jsx)($183d77bd9df29f98$export$a5ffe38c17bbc0a1, null, (0, $byn9U.jsx)($183d77bd9df29f98$export$abf07652016c7e56, {
        onClick: onClick
    }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        label: "right"
    })));
const $183d77bd9df29f98$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>(0, $byn9U.jsx)("div", {
        css: $183d77bd9df29f98$var$filmStripViewStyles,
        "data-testid": dataTestId
    }, children);
const $183d77bd9df29f98$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>(0, $byn9U.jsx)("div", {
        css: $183d77bd9df29f98$var$filmStripListWrapperStyles,
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId
    }, children));
const $183d77bd9df29f98$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, style: style }, ref)=>(0, $byn9U.jsx)("ul", {
        css: $183d77bd9df29f98$var$filmStripListStyles,
        ref: ref,
        style: style
    }, children));
const $183d77bd9df29f98$export$54cfc70c184c0713 = ({ children: children, index: index })=>(0, $byn9U.jsx)("li", {
        css: $183d77bd9df29f98$var$filmStripListItemStyles,
        className: (0, $b3BbA.MediaFilmStripListItemSelector),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);

});


parcelRegister("33J8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $50b1774f1bdfc5f0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $5YYzL = parcelRequire("5YYzL");

var $dxcfv = parcelRequire("dxcfv");

var $kUI0A = parcelRequire("kUI0A");


var $lL6mN = parcelRequire("lL6mN");

var $jftLJ = parcelRequire("jftLJ");
const $50b1774f1bdfc5f0$export$dd2adc2e9afba40d = ()=>(0, $eUqFw.useState)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$50b1774f1bdfc5f0$export$2e2bcd8739ae039 = (WrappedComponent, attachmentView = (0, $3632aa17cf69c37b$export$2671699244327210))=>// @ts-expect-error - TS2322 - Type '(props: Config) => JSX.Element' is not assignable to type 'AbstractComponent<Config, any>'.
    (props)=>{
        const issueKey = (0, $hJ992.useIssueKey)();
        const [{ value: { attachments: attachments } }, { deleteAttachment: deleteAttachment }] = (0, $kUI0A.useIssueAttachments)(issueKey);
        const [deletingAttachmentId, setDeletingAttachmentId] = $50b1774f1bdfc5f0$export$dd2adc2e9afba40d();
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        const projectKey = (0, $hJ992.useProjectKey)();
        const [permissions] = (0, $5YYzL.useProjectPermissions)(projectKey);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
        const accountIdLoggedInUser = (0, $dxcfv.useAccountId)();
        const onDeleteAttachment = (0, $eUqFw.useCallback)((event)=>{
            if (deletingAttachmentId !== undefined) {
                event.stopPropagation();
                const analyticsEvent = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'deleteAttachmentConfirm', {
                    view: attachmentView
                });
                deleteAttachment(issueKey, deletingAttachmentId);
                // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
                setDeletingAttachmentId();
            }
        }, [
            createAnalyticsEvent,
            deleteAttachment,
            deletingAttachmentId,
            issueKey,
            setDeletingAttachmentId
        ]);
        const onDismissModal = (0, $eUqFw.useCallback)((event)=>{
            event.stopPropagation();
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            setDeletingAttachmentId();
        }, [
            setDeletingAttachmentId
        ]);
        const canDeleteAttachmentMap = (0, $eUqFw.useMemo)(()=>(0, $jftLJ.getCanDeleteAttachmentMap)({
                attachments: attachments,
                canDeleteAllAttachments: permissions.canDeleteAllAttachments,
                canDeleteOwnAttachments: permissions.canDeleteOwnAttachments,
                accountIdLoggedInUser: accountIdLoggedInUser
            }), [
            accountIdLoggedInUser,
            attachments,
            permissions.canDeleteAllAttachments,
            permissions.canDeleteOwnAttachments
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            onDeleteAttachment: setDeletingAttachmentId,
            canDeleteAttachmentMap: canDeleteAttachmentMap
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, deletingAttachmentId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
            onClose: onDismissModal,
            width: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
            appearance: "danger"
        }, formatMessage((0, $lL6mN.default).confirmationHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, formatMessage((0, $lL6mN.default).confirmationContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "danger",
            onClick: onDeleteAttachment,
            testId: "issue-attachments-base.ui.with-issue-attachments-delete.confirm-button",
            interactionName: "auto-generated.issue-attachments-base.ui.with-issue-attachments-delete.confirm-button.button"
        }, formatMessage((0, $lL6mN.default).confirmationSubmit)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            onClick: onDismissModal,
            testId: "issue-attachments-base.ui.with-issue-attachments-delete.cancel-button",
            interactionName: "auto-generated.issue-attachments-base.ui.with-issue-attachments-delete.cancel-button.button1"
        }, formatMessage((0, $lL6mN.default).confirmationCancel)))))));
    };

});
const $3632aa17cf69c37b$export$2671699244327210 = 'filmStripView';
const $3632aa17cf69c37b$export$fe95a8f0244a32c4 = 'listView';

parcelRegister("lL6mN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8bcd710cfedcbad$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b8bcd710cfedcbad$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    confirmationHeader: {
        "id": "issue-attachments-base.with-issue-attachments-delete.confirmation-header",
        "defaultMessage": "Delete this attachment?"
    },
    confirmationContent: {
        "id": "issue-attachments-base.with-issue-attachments-delete.confirmation-content",
        "defaultMessage": "Once you delete, it's gone for good."
    },
    confirmationCancel: {
        "id": "issue-attachments-base.with-issue-attachments-delete.confirmation-cancel",
        "defaultMessage": "Cancel"
    },
    confirmationSubmit: {
        "id": "issue-attachments-base.with-issue-attachments-delete.confirmation-submit",
        "defaultMessage": "OK"
    }
});

});

parcelRegister("jftLJ", function(module, exports) {

$parcel$export(module.exports, "getCanDeleteAttachmentMap", () => $0276a30460517d6c$export$f49d82ec2e3b0297);

var $7gm9F = parcelRequire("7gm9F");
const $0276a30460517d6c$export$f49d82ec2e3b0297 = ({ attachments: attachments, canDeleteAllAttachments: canDeleteAllAttachments, canDeleteOwnAttachments: canDeleteOwnAttachments, accountIdLoggedInUser: accountIdLoggedInUser })=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    attachments.reduce((acc, attachment)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...acc,
            [attachment.id]: attachment.parentName === (0, $7gm9F.ATTACHMENT_PARENT_ISSUE) && (canDeleteAllAttachments || accountIdLoggedInUser !== null && attachment.author !== null && canDeleteOwnAttachments && attachment.author.accountId === accountIdLoggedInUser)
        }), {});

});


parcelRegister("7bqJz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3471792794d5145a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $eUPCT = parcelRequire("eUPCT");

var $iPhjO = parcelRequire("iPhjO");
const $3471792794d5145a$var$withViewMediaClientConfig = (WrappedComponent)=>{
    const WrappedComponentWithViewMediaClientConfig = (props)=>{
        const { onViewRefresh: onViewRefresh, onUploadRefresh: onUploadRefresh, ...otherProps } = props;
        const { mediaContext: mediaContext } = otherProps;
        const tokenProvider = (0, $iPhjO.useTokenProvider)(mediaContext, onViewRefresh, onUploadRefresh);
        // Return null while waiting for mediaContext server response.
        if (!mediaContext.viewContext) return null;
        const { clientId: clientId, serviceHost: serviceHost } = mediaContext.viewContext;
        const viewMediaClientConfig = {
            authProvider: (0, $eUPCT.createAuthProvider)(tokenProvider, clientId, serviceHost),
            ...(0, $1ybV0.ff)('issue.details.update-media-config-to-sha256') ? {
                useSha256ForUploads: true
            } : {}
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            viewMediaClientConfig: viewMediaClientConfig,
            ...otherProps
        });
    };
    return WrappedComponentWithViewMediaClientConfig;
};
var $3471792794d5145a$export$2e2bcd8739ae039 = $3471792794d5145a$var$withViewMediaClientConfig;

});

parcelRegister("6y4qx", function(module, exports) {

$parcel$export(module.exports, "mediaFeatureFlags", () => $b4fda492b5e75c90$export$250985d9ea13242f);
/**
 * Feature flags should be defined individually in './feature-flags.js'
 * There is processing on that file to automate analytics discovery.
 * We import them here so they can be exported as one value and given to
 * Editor/Renderer/Media components.
 *
 * NOTE: The use of functions vs raw values is intentional. You must use
 * `mediaFeatureFlags()` vs `mediaFeatureFlags` due to the fact that these
 * flags won't be available immediately. This relates to SST and launchdarkly.
 * Otherwise the getters would be executed immediately and blank values
 * will be passed.
 */ 
var $9Nizy = parcelRequire("9Nizy");
const $b4fda492b5e75c90$export$250985d9ea13242f = ()=>({
        mediaInline: (0, $9Nizy.isMediaInlineEnabled)(),
        // TODO: remove after media team clean up securedClipboard: https://product-fabric.atlassian.net/browse/CXP-2664
        securedClipboard: true
    });

});

parcelRegister("kqcDC", function(module, exports) {

$parcel$export(module.exports, "getActionsForAttachment", () => $bac6f620931f1777$export$c639b6c706b05058);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $fEMj1 = parcelRequire("fEMj1");

var $7gm9F = parcelRequire("7gm9F");

var $2gYtT = parcelRequire("2gYtT");

var $6CWKM = parcelRequire("6CWKM");

var $8HbKr = parcelRequire("8HbKr");
const $bac6f620931f1777$var$getDeleteOrGotoActionForAttachment = (attachmentId, attachmentParentName, attachmentParentId, canDeleteAttachment, intl, issueKey, onDeleteAttachment, onScrollToComments, onScrollToWorklogs)=>{
    const deleteMessage = intl.formatMessage((0, $8HbKr.default).delete);
    if (attachmentParentName === (0, $7gm9F.ATTACHMENT_PARENT_ISSUE)) {
        // no permission to delete attachment
        if (!canDeleteAttachment) return [];
        return [
            {
                label: deleteMessage,
                handler: ()=>onDeleteAttachment(attachmentId),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fEMj1))), {
                    label: deleteMessage,
                    testId: `issue.views.issue-base.content.attachment.filmstrip-view.trash-icon.${attachmentId}`
                })
            }
        ];
    }
    // show the goto button as attachment in either commment/workog, customfield, description or envrionment
    return [
        {
            label: intl.formatMessage((0, $8HbKr.default).goto),
            handler: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2gYtT.default), {
                attachmentParent: attachmentParentName,
                attachmentParentId: attachmentParentId,
                attachmentView: (0, $3632aa17cf69c37b$export$2671699244327210),
                onScrollToComments: onScrollToComments,
                onScrollToWorklogs: onScrollToWorklogs,
                issueKey: issueKey,
                // This is a div to match the CardActionButton in the media-card component
                component: "div",
                attachmentId: attachmentId
            })
        }
    ];
};
const $bac6f620931f1777$var$getCardCoverActionForAttachment = (attachmentId, cardCover, intl, onCardCoverShow, onCardCoverHide)=>{
    const idAsNumber = Number(attachmentId);
    const hideMsg = intl.formatMessage((0, $8HbKr.default).hide);
    const showMsg = intl.formatMessage((0, $8HbKr.default).show);
    if (!cardCover || !cardCover.isEnabled || !cardCover.availableAttachmentIds.includes(idAsNumber)) return [];
    if (idAsNumber === cardCover.attachmentId) return [
        {
            label: hideMsg,
            handler: ()=>{
                onCardCoverHide(idAsNumber);
            },
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6CWKM.default), {
                icon: (0, $6CWKM.HIDE_ICON),
                label: hideMsg
            })
        }
    ];
    return [
        {
            label: showMsg,
            handler: ()=>{
                onCardCoverShow(cardCover.attachmentId, idAsNumber);
            },
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6CWKM.default), {
                icon: (0, $6CWKM.SHOW_ICON),
                label: showMsg
            })
        }
    ];
};
const $bac6f620931f1777$export$c639b6c706b05058 = (attachmentId, attachmentParentName, attachmentParentId, cardCover, canDeleteAttachment, intl, issueKey, onDeleteAttachment, onCardCoverShow, onCardCoverHide, onScrollToComments, onScrollToWorklogs)=>[
        ...$bac6f620931f1777$var$getDeleteOrGotoActionForAttachment(attachmentId, attachmentParentName, attachmentParentId, canDeleteAttachment, intl, issueKey, onDeleteAttachment, onScrollToComments, onScrollToWorklogs),
        ...$bac6f620931f1777$var$getCardCoverActionForAttachment(attachmentId, cardCover, intl, onCardCoverShow, onCardCoverHide)
    ];

});
parcelRegister("fEMj1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6600ff3072270d9$var$_react = $b6600ff3072270d9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b6600ff3072270d9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b6600ff3072270d9$var$TrashIcon = (props)=>/*#__PURE__*/ $b6600ff3072270d9$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M5 5a1 1 0 00-1 1v1h16V6a1 1 0 00-1-1H5zm11.15 15H7.845a1 1 0 01-.986-.835L5 8h14l-1.864 11.166a.999.999 0 01-.986.834M9 4.5a.5.5 0 01.491-.5h5.018a.5.5 0 01.491.5V5H9v-.5z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$b6600ff3072270d9$var$TrashIcon.displayName = 'TrashIcon';
var $b6600ff3072270d9$var$_default = $b6600ff3072270d9$var$TrashIcon;
module.exports.default = $b6600ff3072270d9$var$_default;

});

parcelRegister("2gYtT", function(module, exports) {

$parcel$export(module.exports, "GoToButton", () => $edfe57f31ee506ff$export$c6abf05ecb6d0496);
$parcel$export(module.exports, "default", () => $edfe57f31ee506ff$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");

var $jHMvH = parcelRequire("jHMvH");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8411R = parcelRequire("8411R");

var $9WtAE = parcelRequire("9WtAE");
var $4c7sd = parcelRequire("4c7sd");

var $jMP2a = parcelRequire("jMP2a");

var $7gm9F = parcelRequire("7gm9F");


var $aa9N7 = parcelRequire("aa9N7");
// @ts-expect-error - TS7006 - Parameter 'fieldConfig' implicitly has an 'any' type.
const $edfe57f31ee506ff$var$getFieldTitle = (attachmentParent, fieldConfig)=>{
    if (attachmentParent !== (0, $7gm9F.ATTACHMENT_PARENT).customfield) return attachmentParent;
    return fieldConfig && fieldConfig.title || 'custom field';
};
const $edfe57f31ee506ff$export$c6abf05ecb6d0496 = ({ attachmentParent: attachmentParent, attachmentParentId: attachmentParentId, onScrollToComments: onScrollToComments, onScrollToWorklogs: onScrollToWorklogs, attachmentView: attachmentView, issueKey: issueKey, component: component, attachmentId: attachmentId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { setScrollTarget: setScrollTarget }] = (0, $4c7sd.useIssueScroll)();
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, `customfield_${attachmentParentId}`);
    const isDisabled = attachmentParent !== (0, $7gm9F.ATTACHMENT_PARENT).comment && attachmentParent !== (0, $7gm9F.ATTACHMENT_PARENT).worklog;
    const onClick = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        event.stopPropagation();
        event.preventDefault();
        const setAndScrollToTarget = (scrollTargetType, scrollToTargetAction)=>{
            setScrollTarget({
                type: scrollTargetType,
                id: attachmentParentId
            });
            scrollToTargetAction();
        };
        switch(attachmentParent){
            case (0, $7gm9F.ATTACHMENT_PARENT).comment:
                setAndScrollToTarget((0, $9WtAE.SCROLL_TARGET_TYPES).COMMENT, onScrollToComments);
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'gotoComment', {
                    view: attachmentView
                });
                break;
            case (0, $7gm9F.ATTACHMENT_PARENT).worklog:
                setAndScrollToTarget((0, $9WtAE.SCROLL_TARGET_TYPES).WORKLOG, onScrollToWorklogs);
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'gotoWorklog', {
                    view: attachmentView
                });
                break;
            default:
                break;
        }
    }, [
        attachmentParent,
        setScrollTarget,
        attachmentParentId,
        onScrollToComments,
        attachmentView,
        onScrollToWorklogs
    ]);
    const onKeyPress = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter') event.stopPropagation();
    }, []);
    const toolTipContent = (0, $eUqFw.useMemo)(()=>{
        switch(attachmentParent){
            case (0, $7gm9F.ATTACHMENT_PARENT).comment:
                return formatMessage((0, $aa9N7.default).goToComment);
            case (0, $7gm9F.ATTACHMENT_PARENT).worklog:
                return formatMessage((0, $aa9N7.default).goToWorklog);
            default:
                return formatMessage((0, $aa9N7.default).goToField, {
                    field: $edfe57f31ee506ff$var$getFieldTitle(attachmentParent, fieldConfig)
                });
        }
    }, [
        attachmentParent,
        fieldConfig,
        formatMessage
    ]);
    const getButtonHoverColor = ()=>{
        if (isDisabled) return {};
        // since filmstrip action button has its own hover css, we will match the color they use
        return attachmentView === (0, $3632aa17cf69c37b$export$fe95a8f0244a32c4) ? {
            background: `var(--ds-background-neutral-hovered, ${0, $PdmhA.N40})`
        } : {
            background: `var(--ds-background-neutral-hovered, ${0, $PdmhA.N0})`
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: toolTipContent,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        testId: `issue-attachments-base.ui.goto-button.custom-theme-button.${attachmentId}`,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jHMvH))), {
            label: toolTipContent,
            primaryColor: isDisabled ? "var(--ds-icon-disabled, var(--icon-primary-color))" : "var(--ds-icon, var(--icon-primary-color))"
        }),
        onClick: onClick,
        onKeyPress: onKeyPress,
        // @ts-expect-error - TS2322 - Type '(current: (props: ThemeProps) => ThemeTokens, themeProps: ThemeProps) => { accentColor?: string | string[] | undefined; alignContent?: string | string[] | undefined; ... 909 more ...; buttonStyles: { ...; }; }' is not assignable to type '(current: (props: ThemeProps) => ThemeTokens, props: ThemeProps) => ThemeTokens'.
        theme: (current, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    display: 'flex',
                    justifyContent: 'center',
                    '&:hover': getButtonHoverColor(),
                    ...attachmentView === (0, $3632aa17cf69c37b$export$2671699244327210) ? {
                        paddingLeft: '0px',
                        paddingRight: '0px'
                    } : {},
                    margin: '0'
                },
                ...spinnerStyles
            };
        },
        isDisabled: isDisabled,
        component: component,
        interactionName: "auto-generated.jira-issue-attachments-base.ui.goto-button.button"
    }));
};
$edfe57f31ee506ff$export$c6abf05ecb6d0496.defaultProps = {
    component: 'button'
};
var $edfe57f31ee506ff$export$2e2bcd8739ae039 = $edfe57f31ee506ff$export$c6abf05ecb6d0496;

});
parcelRegister("aa9N7", function(module, exports) {

$parcel$export(module.exports, "default", () => $487622ff50673243$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $487622ff50673243$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    goToComment: {
        "id": "issue-attachments-base.goto-button.go-to-comment",
        "defaultMessage": "Go to the comment with this attachment"
    },
    goToWorklog: {
        "id": "issue-attachments-base.goto-button.go-to-worklog",
        "defaultMessage": "Go to the work log entry with this attachment"
    },
    goToField: {
        "id": "issue-attachments-base.goto-button.go-to-field",
        "defaultMessage": "You can find this attachment in the {field} field"
    }
});

});


parcelRegister("6CWKM", function(module, exports) {

$parcel$export(module.exports, "HIDE_ICON", () => $a336666a629bb8d6$export$24b9ce3de06caa2);
$parcel$export(module.exports, "SHOW_ICON", () => $a336666a629bb8d6$export$f8cf4e3a40b7c99d);
$parcel$export(module.exports, "default", () => $a336666a629bb8d6$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $8cU5f = parcelRequire("8cU5f");
const $a336666a629bb8d6$export$24b9ce3de06caa2 = 'hide-icon';
const $a336666a629bb8d6$export$f8cf4e3a40b7c99d = 'show-icon';
const $a336666a629bb8d6$var$hideIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        transform: "translate(3 3)",
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M2 11v5h14v-5H2zM0 1.995C0 .893.893 0 1.995 0h14.01C17.107 0 18 .893 18 1.995v14.01A1.995 1.995 0 0 1 16.005 18H1.995A1.995 1.995 0 0 1 0 16.005V1.995z",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "3",
        y: "12",
        width: "8",
        height: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "13",
        y: "12",
        width: "2",
        height: "2",
        rx: "1"
    })));
const $a336666a629bb8d6$var$showIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        transform: "translate(3 3)",
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M2 11v5h14v-5H2zm0-1V9h14v1-8H2v8zM0 1.995C0 .893.893 0 1.995 0h14.01C17.107 0 18 .893 18 1.995v14.01A1.995 1.995 0 0 1 16.005 18H1.995A1.995 1.995 0 0 1 0 16.005V1.995z",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "3",
        y: "12",
        width: "8",
        height: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "13",
        y: "12",
        width: "2",
        height: "2",
        rx: "1"
    })));
const $a336666a629bb8d6$var$CardCoverIcon = ({ icon: icon, label: label })=>{
    const iconGlyph = icon === $a336666a629bb8d6$export$f8cf4e3a40b7c99d ? $a336666a629bb8d6$var$showIcon : $a336666a629bb8d6$var$hideIcon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "top",
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: iconGlyph,
        label: label,
        size: "small"
    }));
};
var $a336666a629bb8d6$export$2e2bcd8739ae039 = $a336666a629bb8d6$var$CardCoverIcon;

});

parcelRegister("8HbKr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5a5be85565b560e$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $b5a5be85565b560e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    delete: {
        "id": "attachments.delete-attachment-from-attachment-panel",
        "defaultMessage": "Delete"
    },
    goto: {
        "id": "attachments.goto-attachment-from-attachment-panel",
        "defaultMessage": "GoTo"
    },
    show: {
        "id": "attachments.show-on-card",
        "defaultMessage": "Show on card"
    },
    hide: {
        "id": "attachments.hide-on-card",
        "defaultMessage": "Hide on card"
    },
    confirmationHeader: {
        "id": "attachments.confirm-delete-attachment-modal-header",
        "defaultMessage": "Delete this attachment?"
    },
    confirmationContent: {
        "id": "attachments.confirm-delete-attachment-modal-text",
        "defaultMessage": "Once you delete, it's gone for good."
    }
});

});



parcelRegister("cmuhz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9428062bf15a7931$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $fee69 = parcelRequire("fee69");

var $i2ayy = parcelRequire("i2ayy");

var $7bqJz = parcelRequire("7bqJz");

var $lqalZ = parcelRequire("lqalZ");

var $khpWz = parcelRequire("khpWz");

var $20th5 = parcelRequire("20th5");

var $hlJEN = parcelRequire("hlJEN");

var $5JqpU = parcelRequire("5JqpU");

var $gS8e9 = parcelRequire("gS8e9");
const $9428062bf15a7931$export$84d0dd190d551cd1 = ({ viewMediaClientConfig: viewMediaClientConfig, onScrollToWorklogs: onScrollToWorklogs, onScrollToComments: onScrollToComments })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
        id: "issue.details.attachment.list-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9428062bf15a7931$var$Container, {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.issue-base.content.attachment.list-view.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i2ayy.default), {
        shouldHideErrorImage: true,
        viewMediaClientConfig: viewMediaClientConfig,
        onScrollToWorklogs: onScrollToWorklogs,
        onScrollToComments: onScrollToComments
    })));
const $9428062bf15a7931$var$WithMediaConfig = (0, $7bqJz.default)($9428062bf15a7931$export$84d0dd190d551cd1);
const $9428062bf15a7931$var$Connected = (0, $lqalZ.connect)((state)=>({
        issueKey: (0, $5JqpU.issueKeySelector)(state),
        mediaContext: (0, $gS8e9.mediaContextSelector)(state)
    }), {
    onScrollToComments: (0, $khpWz.scrollToAttachmentComment),
    onScrollToWorklogs: (0, $khpWz.scrollToAttachmentWorklog),
    onViewRefresh: (0, $hlJEN.fetchViewContextRequest),
    onUploadRefresh: (0, $20th5.fetchUploadContextRequest)
})($9428062bf15a7931$var$WithMediaConfig);
var $9428062bf15a7931$export$2e2bcd8739ae039 = $9428062bf15a7931$var$Connected;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9428062bf15a7931$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41b66 _1ul9kpet _kqswh2mm _f8001osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i2ayy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a15729a9880e0e34$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dxIU5 = parcelRequire("dxIU5");

var $jG2Eu = parcelRequire("jG2Eu");

var $5iWql = parcelRequire("5iWql");

var $b3xMQ = parcelRequire("b3xMQ");

var $5qTKr = parcelRequire("5qTKr");

var $kjXsi = parcelRequire("kjXsi");

var $7ZZxN = parcelRequire("7ZZxN");

var $4ksts = parcelRequire("4ksts");

var $kUI0A = parcelRequire("kUI0A");
var $33J8p = parcelRequire("33J8p");

var $hJ992 = parcelRequire("hJ992");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $guDlK = parcelRequire("guDlK");

var $4xHig = parcelRequire("4xHig");

var $aKP4l = parcelRequire("aKP4l");

var $7mtz7 = parcelRequire("7mtz7");

var $lXghX = parcelRequire("lXghX");

var $9T569 = parcelRequire("9T569");

var $3w3hF = parcelRequire("3w3hF");

var $eRmNV = parcelRequire("eRmNV");
const $a15729a9880e0e34$var$IssueAttachmentsTable = (props)=>{
    const { viewMediaClientConfig: viewMediaClientConfig, onPreviewOpen: onPreviewOpen = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onPreviewClose: onPreviewClose = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onDeleteAttachment: onDeleteAttachment, canDeleteAttachmentMap: canDeleteAttachmentMap, onScrollToComments: onScrollToComments = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onScrollToWorklogs: onScrollToWorklogs = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isInModal: isInModal = false, shouldHideErrorImage: shouldHideErrorImage = false } = props;
    const intl = (0, $4ksts.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const hasReloadedAttachments = (0, $eUqFw.useRef)(false);
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const [{ error: error, loading: loading, meta: meta, value: value }, actions] = (0, $kUI0A.useIssueAttachments)(issueKey);
    const { orderDirection: orderDirection, orderField: orderField, startAt: startAt } = meta;
    const { attachments: attachments, totalCount: totalCount } = value;
    const { refreshAttachments: refreshAttachments, setOrderDirection: setOrderDirection, setOrderField: setOrderField } = actions;
    const debouncedRefreshAttachments = (0, $5iWql.default)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(refreshAttachments, 50)); // Calculate using startAt instead of manually setting it to prevent data mismatch
    const pageNumber = (0, $eUqFw.useMemo)(()=>Math.ceil((startAt + 1) / (0, $aKP4l.ITEMS_PER_PAGE)), [
        startAt
    ]); // Use separately from pageNumber since fetching can fail
    const [previewPageNumber, setPreviewPageNumber] = (0, $eUqFw.useState)(pageNumber);
    const [width, setWidth] = (0, $eUqFw.useState)(undefined);
    const debouncedSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(setWidth, 100);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        refreshAttachments(issueKey, {
            orderDirection: orderDirection,
            orderField: orderField,
            startAt: (0, $aKP4l.ITEMS_PER_PAGE) * (pageNumber - 1)
        });
    }, [
        issueKey,
        orderDirection,
        orderField,
        pageNumber,
        refreshAttachments
    ]);
    const onSetPage = (0, $eUqFw.useCallback)((newPageNumber)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'setPage',
            actionSubject: 'dynamicTable'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueAttachments', {
            currentPageNumber: previewPageNumber,
            targetPageNumber: newPageNumber
        });
        hasReloadedAttachments.current = true;
        setPreviewPageNumber(newPageNumber);
        debouncedRefreshAttachments(issueKey, {
            orderDirection: orderDirection,
            orderField: orderField,
            startAt: (0, $aKP4l.ITEMS_PER_PAGE) * (newPageNumber - 1)
        });
    }, [
        createAnalyticsEvent,
        debouncedRefreshAttachments,
        issueKey,
        orderDirection,
        orderField,
        previewPageNumber
    ]);
    const onSort = (0, $eUqFw.useCallback)((columnKey, newOrderDirection)=>{
        hasReloadedAttachments.current = true;
        const newOrderField = (0, $eRmNV.getOrderFieldFromColumnKey)(columnKey);
        const analyticsEvent = createAnalyticsEvent({
            action: 'sorted',
            actionSubject: 'dynamicTable'
        });
        setOrderField(newOrderField);
        setOrderDirection(newOrderDirection);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueAttachments', {
            key: columnKey
        });
        debouncedRefreshAttachments(issueKey, {
            orderDirection: newOrderDirection,
            orderField: newOrderField
        });
    }, [
        createAnalyticsEvent,
        debouncedRefreshAttachments,
        issueKey,
        setOrderDirection,
        setOrderField
    ]);
    const locale = (0, $4xHig.useLocale)();
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXghX.default), {
        shouldHideImage: shouldHideErrorImage,
        onClick: onClick
    });
    if (totalCount === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mtz7.default), null);
    const items = (0, $eRmNV.transformAttachments)(attachments || [], totalCount, width, locale, onDeleteAttachment, canDeleteAttachmentMap, onScrollToWorklogs, onScrollToComments, isInModal, issueKey, intl, projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT));
    const columns = (0, $eRmNV.getColumns)(totalCount, width, intl);
    const sortKey = (0, $eRmNV.getColumnKeyFromOrderField)(orderField);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qTKr.WidthObserver), {
        offscreen: true,
        setWidth: (newWidth)=>{
            debouncedSetWidth(newWidth);
        }
    }), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, hasReloadedAttachments.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        "aria-live": "assertive"
    }, intl.formatMessage((0, $9T569.default).loadingAriaLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3w3hF.default), {
        pageNumber: previewPageNumber,
        totalCount: totalCount
    })), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, hasReloadedAttachments.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        "aria-live": "assertive"
    }, intl.formatMessage((0, $9T569.default).loadedAriaLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a15729a9880e0e34$var$RowHighlightWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b3xMQ.default), {
        items: items,
        mediaClientConfig: viewMediaClientConfig,
        columns: columns,
        itemsPerPage: (0, $aKP4l.ITEMS_PER_PAGE),
        totalItems: totalCount || 0,
        pageNumber: pageNumber,
        onSetPage: onSetPage,
        onSort: onSort,
        sortKey: sortKey,
        sortOrder: orderDirection,
        onPreviewOpen: onPreviewOpen,
        onPreviewClose: onPreviewClose,
        rowProps: {
            className: (0, $aKP4l.TABLE_ROW_CLASSNAME)
        }
    }))));
};
var $a15729a9880e0e34$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $33J8p.default)($a15729a9880e0e34$var$IssueAttachmentsTable, (0, $3632aa17cf69c37b$export$fe95a8f0244a32c4));
const $a15729a9880e0e34$var$RowHighlightWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _w86v8jms _wk3g1i68 _1oqu5530 _12narc7j _pa031tzm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b3xMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $80ca2edabc20ad1f$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $2qhQi = parcelRequire("2qhQi");
var $3dpxL = parcelRequire("3dpxL");

var $cYnEr = parcelRequire("cYnEr");

var $c9w1E = parcelRequire("c9w1E");
var $dTbMV = parcelRequire("dTbMV");

var $bUbLp = parcelRequire("bUbLp");

var $6Ia1x = parcelRequire("6Ia1x");

var $2fUwg = parcelRequire("2fUwg");

var $j7YJq = parcelRequire("j7YJq");

var $9WTJE = parcelRequire("9WTJE");

var $j8cie = parcelRequire("j8cie");
var $7nm9r = parcelRequire("7nm9r");
var $lbN4r = parcelRequire("lbN4r");

var $2jDha = parcelRequire("2jDha");
class $80ca2edabc20ad1f$export$d92bcccb56a44ac0 extends (0, $eUqFw.Component) {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            fileInfoState: new Map()
        });
        (0, $5zQU9.default)(this, "subscriptions", []);
        (0, $5zQU9.default)(this, "hasBeenMounted", false);
        (0, $5zQU9.default)(this, "unsubscribe", ()=>{
            this.subscriptions.forEach((subscription)=>subscription.unsubscribe());
            this.subscriptions = [];
        });
        (0, $5zQU9.default)(this, "generateCellValues", (data, identifier)=>{
            const cellValues = [];
            const { columns: columns } = this.props;
            columns.cells.forEach((cell)=>{
                const content = cell.key === (0, $2b1c1c158447240b$export$b03528b1ebec0921) ? (0, $byn9U.jsx)((0, $j7YJq.default), {
                    onClick: this.onDownloadClick(identifier)
                }) : cell.key === (0, $2b1c1c158447240b$export$cde535873d2d8bb6) ? (0, $byn9U.jsx)((0, $9WTJE.default), {
                    onClick: this.onPreviewClick(identifier)
                }) : cell.key && data[cell.key] || '';
                cellValues.push({
                    key: cell.key,
                    content: content
                });
            });
            return cellValues;
        });
        (0, $5zQU9.default)(this, "onDownloadClick", (identifier)=>(event)=>{
                const { id: id, collectionName: collectionName } = identifier;
                event.stopPropagation();
                const { mediaClient: mediaClient } = this.props;
                const { fileInfoState: fileInfoState } = this.state;
                const nameInfo = fileInfoState.get(id);
                mediaClient.file.downloadBinary(id, nameInfo ? nameInfo.fileName : '', collectionName);
            });
        (0, $5zQU9.default)(this, "onPreviewClick", (identifier)=>(event)=>{
                event.stopPropagation();
                this.openPreview(identifier);
            });
        (0, $5zQU9.default)(this, "onSort", (data)=>{
            const { onSort: onSort } = this.props;
            const { key: key, sortOrder: sortOrder, item: item } = data;
            item && item.isSortable && onSort && onSort(key, sortOrder);
        });
        (0, $5zQU9.default)(this, "renderRowValues", (validItemsPerPage, validPageNumber, validTotalItems)=>{
            const { items: items, columns: columns } = this.props;
            const rowValues = items.map((item, index)=>{
                const { data: data, identifier: identifier, rowProps: rowProps } = item;
                return {
                    cells: this.generateCellValues(data, identifier),
                    key: identifier.id,
                    tabIndex: 0,
                    onClick: this.onRowClick(identifier, data, index),
                    onKeyPress: (event)=>{
                        if (event.key === 'Enter') this.onRowEnterKeyPressed(identifier, data, index);
                    },
                    ...rowProps
                };
            });
            return (0, $7nm9r.default)({
                itemsPerPage: validItemsPerPage,
                pageNumber: validPageNumber,
                totalItems: validTotalItems,
                rowValues: rowValues,
                headerCells: columns.cells
            });
        });
        (0, $5zQU9.default)(this, "renderTable", ()=>{
            const { columns: columns, itemsPerPage: itemsPerPage, isLoading: isLoading, pageNumber: pageNumber, onSetPage: onSetPage, totalItems: totalItems, items: items, sortKey: sortKey, sortOrder: sortOrder, highlightedRowIndex: highlightedRowIndex } = this.props;
            const { validItemsPerPage: validItemsPerPage, validPageNumber: validPageNumber, validTotalItems: validTotalItems } = (0, $lbN4r.default)(items.length, itemsPerPage, pageNumber, totalItems);
            const rowsPerPage = validTotalItems <= validItemsPerPage ? undefined : validItemsPerPage;
            return (0, $byn9U.jsx)((0, $cYnEr.default), {
                caption: '',
                head: (0, $j8cie.default)(columns),
                rows: this.renderRowValues(validItemsPerPage, validPageNumber, validTotalItems),
                rowsPerPage: rowsPerPage,
                page: validPageNumber,
                loadingSpinnerSize: "large",
                isLoading: isLoading,
                sortKey: sortKey,
                sortOrder: sortOrder,
                onSort: this.onSort,
                onSetPage: onSetPage,
                isFixedSize: true,
                highlightedRowIndex: highlightedRowIndex
            });
        });
        (0, $5zQU9.default)(this, "openPreview", (identifier)=>{
            const { onPreviewOpen: onPreviewOpen } = this.props;
            this.safeSetState({
                mediaViewerSelectedItem: identifier
            });
            onPreviewOpen && onPreviewOpen();
        });
        (0, $5zQU9.default)(this, "onRowEnterKeyPressed", (identifier, data, index)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, onRowClick: onRowClick } = this.props;
            const ev = createAnalyticsEvent({
                eventType: 'ui',
                action: 'keyPressed',
                actionSubject: 'mediaFile',
                actionSubjectId: 'mediaFileRow'
            });
            ev.fire((0, $2b1c1c158447240b$export$ec1779cb96554e1));
            const shouldPreventDefaultRowClick = onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(data, index);
            if (!shouldPreventDefaultRowClick) this.openPreview(identifier);
        });
        (0, $5zQU9.default)(this, "onRowClick", (identifier, data, index)=>()=>{
                const { createAnalyticsEvent: createAnalyticsEvent, onRowClick: onRowClick } = this.props;
                const ev = createAnalyticsEvent({
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'mediaFile',
                    actionSubjectId: 'mediaFileRow'
                });
                ev.fire((0, $2b1c1c158447240b$export$ec1779cb96554e1));
                const shouldPreventDefaultRowClick = onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(data, index);
                if (!shouldPreventDefaultRowClick) this.openPreview(identifier);
            });
        (0, $5zQU9.default)(this, "safeSetState", (state)=>{
            if (this.hasBeenMounted) this.setState(state);
        });
        (0, $5zQU9.default)(this, "onMediaViewerClose", ()=>{
            const { onPreviewClose: onPreviewClose } = this.props;
            this.safeSetState({
                mediaViewerSelectedItem: undefined
            });
            onPreviewClose && onPreviewClose();
        });
        (0, $5zQU9.default)(this, "renderMediaViewer", ()=>{
            const { mediaViewerSelectedItem: mediaViewerSelectedItem } = this.state;
            const { mediaClient: mediaClient, items: items } = this.props;
            if (!mediaViewerSelectedItem) return null;
            const mediaViewerItems = items.map((item)=>item.identifier);
            const collectionName = (0, $c9w1E.isFileIdentifier)(mediaViewerSelectedItem) && mediaViewerSelectedItem.collectionName || '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal((0, $byn9U.jsx)((0, $6Ia1x.default), {
                mediaClientConfig: mediaClient.config,
                items: mediaViewerItems,
                selectedItem: mediaViewerSelectedItem,
                onClose: this.onMediaViewerClose,
                collectionName: collectionName
            }), document.body);
        });
    }
    componentDidMount() {
        this.hasBeenMounted = true;
        const { items: items, mediaClient: mediaClient } = this.props;
        items.forEach(async (item)=>{
            const { identifier: { id: id, collectionName: collectionName = '' } } = item;
            const subscription = mediaClient.file.getFileState(id, {
                collectionName: collectionName
            }).subscribe({
                next: (fileState)=>{
                    const { fileInfoState: fileInfoState } = this.state;
                    if ((0, $dTbMV.isProcessedFileState)(fileState)) {
                        fileInfoState.set(id, {
                            fileName: fileState.name,
                            id: id
                        });
                        if (this.hasBeenMounted) this.safeSetState({
                            fileInfoState: fileInfoState
                        });
                    }
                }
            });
            this.subscriptions.push(subscription);
        });
    }
    componentWillUnmount() {
        this.hasBeenMounted = false;
        this.unsubscribe();
    }
    render() {
        const content = (0, $byn9U.jsx)("div", {
            css: (0, $2fUwg.mediaTableWrapperStyles)
        }, this.renderTable(), this.renderMediaViewer());
        return this.props.intl ? content : (0, $byn9U.jsx)((0, $3dpxL.default), {
            locale: "en"
        }, content);
    }
}
var $80ca2edabc20ad1f$export$2e2bcd8739ae039 = (0, $bUbLp.withMediaClient)((0, $2jDha.default)()((0, $2qhQi.default)($80ca2edabc20ad1f$export$d92bcccb56a44ac0, {
    enforceContext: false
})));

});
parcelRegister("cYnEr", function(module, exports) {

$parcel$export(module.exports, "default", () => $971d6f4eb820085c$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5Q9wj = parcelRequire("5Q9wj");


var $ddon4 = parcelRequire("ddon4");

var $co66L = parcelRequire("co66L");

var $duoac = parcelRequire("duoac");

var $9Z8nt = parcelRequire("9Z8nt");

var $88KKW = parcelRequire("88KKW");

var $4h26S = parcelRequire("4h26S");

var $kXxkC = parcelRequire("kXxkC");

var $ZMl3T = parcelRequire("ZMl3T");

var $32KsT = parcelRequire("32KsT");
const $971d6f4eb820085c$var$packageName = "@atlaskit/dynamic-table";
const $971d6f4eb820085c$var$packageVersion = "14.17.1";
function $971d6f4eb820085c$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $a36112c484f02420$export$b6abcf7fa1d94f65:
            return 0, $a36112c484f02420$export$1dee026a19752d6b;
        case 0, $a36112c484f02420$export$1dee026a19752d6b:
            return 0, $a36112c484f02420$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
class $971d6f4eb820085c$export$613134f68684a686 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "tableBody", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef());
        (0, $5zQU9.default)(this, "state", {
            isRanking: false
        });
        (0, $5zQU9.default)(this, "onSortHandler", (item)=>()=>{
                const { sortKey: sortKey, sortOrder: sortOrder, onSort: onSort, isRankable: isRankable } = this.props;
                const { key: key } = item;
                if (!key) return;
                if (onSort && isRankable && key === sortKey && sortOrder === (0, $a36112c484f02420$export$b6abcf7fa1d94f65)) {
                    onSort({
                        key: null,
                        sortOrder: null,
                        item: item
                    });
                    return;
                }
                const sortOrderFormatted = key !== sortKey ? (0, $a36112c484f02420$export$1dee026a19752d6b) : $971d6f4eb820085c$var$toggleSortOrder(sortOrder);
                if (onSort) onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrderFormatted
                });
            });
        (0, $5zQU9.default)(this, "onSetPageHandler", (page, event)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) onSetPage(page, event);
        });
        (0, $5zQU9.default)(this, "onRankStartHandler", (params)=>{
            this.setState({
                isRanking: true
            });
            if (this.props.onRankStart) this.props.onRankStart(params);
        });
        (0, $5zQU9.default)(this, "onRankEndHandler", (params)=>{
            this.setState({
                isRanking: false
            });
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        });
        (0, $5zQU9.default)(this, "getSpinnerSize", ()=>{
            const { page: page, rows: rows, rowsPerPage: rowsPerPage, loadingSpinnerSize: loadingSpinnerSize } = this.props;
            if (loadingSpinnerSize) return loadingSpinnerSize;
            return (0, $ddon4.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $a36112c484f02420$export$7b93a10c0fefe3e3) : (0, $a36112c484f02420$export$71dd4c8ecd45e95f);
        });
        (0, $5zQU9.default)(this, "renderEmptyBody", ()=>{
            const { emptyView: emptyView, isLoading: isLoading, testId: testId } = this.props;
            if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $duoac.EmptyViewWithFixedHeight), {
                testId: testId
            });
            return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $duoac.EmptyViewContainer), {
                testId: testId
            }, emptyView);
        });
    }
    UNSAFE_componentWillMount() {
        (0, $ddon4.validateSortKey)(this.props.sortKey, this.props.head);
        (0, $ddon4.assertIsSortable)(this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $ddon4.validateSortKey)(nextProps.sortKey, nextProps.head);
        if (this.props.head !== nextProps.head) (0, $ddon4.assertIsSortable)(nextProps.head);
    }
    render() {
        const { caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, isFixedSize: isFixedSize, page: page, rows: rows, rowsPerPage: rowsPerPage, sortKey: sortKey, sortOrder: sortOrder, isLoading: isLoading, loadingLabel: loadingLabel, isRankable: isRankable, isRankingDisabled: isRankingDisabled, paginationi18n: paginationi18n, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label } = this.props;
        const rowsLength = rows && rows.length;
        let totalPages;
        // set a flag to denote the dynamic table might get only one page of data
        // for paginated data
        let isTotalPagesControlledExternally = false;
        if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
            /**
       * If total number of rows / records have been passed down as prop
       * Then table is being fed paginated data from server or other sources
       * In this case, we want to respect information passed down by server or external source
       * Rather than relying on our computation based on number of rows
       */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
            isTotalPagesControlledExternally = true;
        } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
        totalPages = totalPages < 1 ? 1 : totalPages;
        const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
        const bodyProps = {
            highlightedRowIndex: highlightedRowIndex,
            rows: rows,
            head: head,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rowsPerPage: rowsPerPage,
            page: getPageNumber,
            isFixedSize: isFixedSize || false,
            onPageRowsUpdate: onPageRowsUpdate,
            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
            ref: this.tableBody,
            testId: testId
        };
        const rowsExist = !!rowsLength;
        const spinnerSize = this.getSpinnerSize();
        const emptyBody = this.renderEmptyBody();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kXxkC.default), {
            isLoading: isLoading && rowsExist,
            spinnerSize: spinnerSize,
            targetRef: ()=>this.tableBody.current,
            testId: testId,
            loadingLabel: loadingLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co66L.Table), {
            isFixedSize: isFixedSize,
            "aria-label": label,
            hasDataRow: rowsExist,
            testId: testId,
            isLoading: isLoading
        }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co66L.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $32KsT.default), {
            head: head,
            onSort: this.onSortHandler,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRanking: this.state.isRanking,
            isRankable: isRankable,
            testId: testId
        }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($971d6f4eb820085c$var$TableBody, (0, $kU09D.default)({}, bodyProps, {
            isRankable: this.props.isRankable,
            isRanking: this.state.isRanking,
            onRankStart: this.onRankStartHandler,
            onRankEnd: this.onRankEndHandler,
            isRankingDisabled: isRankingDisabled || isLoading || false
        })))), totalPages <= 1 ? null : /*#__PURE__*/ // only show pagination if there's MORE than 1 page
        (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co66L.PaginationWrapper), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ZMl3T.default), {
            value: getPageNumber,
            onChange: this.onSetPageHandler,
            total: totalPages,
            i18n: paginationi18n,
            isDisabled: isLoading,
            testId: testId
        })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4h26S.default), {
            isLoading: isLoading,
            spinnerSize: (0, $a36112c484f02420$export$7b93a10c0fefe3e3),
            testId: testId,
            loadingLabel: loadingLabel
        }, emptyBody));
    }
}
(0, $5zQU9.default)($971d6f4eb820085c$export$613134f68684a686, "defaultProps", {
    isLoading: false,
    isFixedSize: false,
    rowsPerPage: Infinity,
    onSetPage: (0, $5Q9wj.default),
    onSort: (0, $5Q9wj.default),
    page: 1,
    isRankable: false,
    isRankingDisabled: false,
    onRankStart: (0, $5Q9wj.default),
    onRankEnd: (0, $5Q9wj.default),
    paginationi18n: {
        prev: 'Previous',
        next: 'Next',
        label: 'Pagination',
        pageLabel: 'Page'
    }
});

const $971d6f4eb820085c$var$RankableTableBody = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("5EzMr")));
const $971d6f4eb820085c$var$TableBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Z8nt.default), (0, $kU09D.default)({
        ref: ref
    }, bodyProps));
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $88KKW.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($971d6f4eb820085c$var$RankableTableBody, (0, $kU09D.default)({
        ref: ref
    }, bodyProps, {
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    })))) : nonRankableBody;
});
const $971d6f4eb820085c$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
var $971d6f4eb820085c$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'dynamicTable',
    packageName: $971d6f4eb820085c$var$packageName,
    packageVersion: $971d6f4eb820085c$var$packageVersion
})((0, $2jDha.default)({
    onSort: $971d6f4eb820085c$var$createAndFireEventOnAtlaskit({
        action: 'sorted',
        actionSubject: 'dynamicTable',
        attributes: {
            componentName: 'dynamicTable',
            packageName: $971d6f4eb820085c$var$packageName,
            packageVersion: $971d6f4eb820085c$var$packageVersion
        }
    }),
    onRankEnd: $971d6f4eb820085c$var$createAndFireEventOnAtlaskit({
        action: 'ranked',
        actionSubject: 'dynamicTable',
        attributes: {
            componentName: 'dynamicTable',
            packageName: $971d6f4eb820085c$var$packageName,
            packageVersion: $971d6f4eb820085c$var$packageVersion
        }
    })
})($971d6f4eb820085c$export$613134f68684a686));

});
const $a36112c484f02420$export$1dee026a19752d6b = 'ASC';
const $a36112c484f02420$export$b6abcf7fa1d94f65 = 'DESC';
const $a36112c484f02420$export$71dd4c8ecd45e95f = 'small';
const $a36112c484f02420$export$7b93a10c0fefe3e3 = 'large';
const $a36112c484f02420$export$3843c586a90b9cbf = 0.22;

parcelRegister("ddon4", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $99ef64dc80ba9f49$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $99ef64dc80ba9f49$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $99ef64dc80ba9f49$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $99ef64dc80ba9f49$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $99ef64dc80ba9f49$export$c476bbe5da59992d);
const $99ef64dc80ba9f49$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $99ef64dc80ba9f49$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $99ef64dc80ba9f49$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $99ef64dc80ba9f49$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $99ef64dc80ba9f49$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $99ef64dc80ba9f49$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $99ef64dc80ba9f49$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $99ef64dc80ba9f49$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("co66L", function(module, exports) {

$parcel$export(module.exports, "tableRowCSSVars", () => $904c76d851d16186$export$3b9ea2c10c245fdb);
$parcel$export(module.exports, "Table", () => $904c76d851d16186$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $904c76d851d16186$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $904c76d851d16186$export$3e5e12dc01f20a43);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $8fFiw = parcelRequire("8fFiw");
const $904c76d851d16186$export$3b9ea2c10c245fdb = {
    CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
    CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
    CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
    CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
};
const $904c76d851d16186$var$fixedSizeTableStyles = (0, $byn9U.css)({
    tableLayout: 'fixed'
});
const $904c76d851d16186$var$tableStyles = (0, $byn9U.css)({
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: '0px'
});
const $904c76d851d16186$var$bodyBorder = (0, $byn9U.css)({
    borderBlockEnd: `2px solid ${(0, $8fFiw.tableBorder).borderColor}`
});
const $904c76d851d16186$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return (0, $byn9U.jsx)("table", (0, $kU09D.default)({
        inert: isLoading ? '' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$904c76d851d16186$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, $8fFiw.row).hoverBackground,
            [$904c76d851d16186$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, $8fFiw.row).highlightedBackground,
            [$904c76d851d16186$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, $8fFiw.row).hoverHighlightedBackground,
            [$904c76d851d16186$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, $8fFiw.row).focusOutline
        },
        css: [
            $904c76d851d16186$var$tableStyles,
            isFixedSize && $904c76d851d16186$var$fixedSizeTableStyles,
            hasDataRow && $904c76d851d16186$var$bodyBorder
        ],
        ref: ref
    }, rest, {
        "data-testid": testId && `${testId}--table`
    }), children);
});
const $904c76d851d16186$var$captionStyles = (0, $byn9U.css)({
    font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    marginBlockEnd: "var(--ds-space-100, 8px)",
    willChange: 'transform'
});
const $904c76d851d16186$var$oldCaptionStyles = (0, $byn9U.css)({
    fontWeight: "var(--ds-font-weight-regular, 400)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginBlockStart: 28
});
const $904c76d851d16186$var$newCaptionStyles = (0, $byn9U.css)({
    marginBlockStart: "var(--ds-space-300, 24px)"
});
const $904c76d851d16186$export$32fbfacc5d962e0c = ({ children: children })=>(0, $byn9U.jsx)("caption", {
        css: [
            $904c76d851d16186$var$captionStyles,
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.dynamic-table-typography_7zio6') ? $904c76d851d16186$var$newCaptionStyles : $904c76d851d16186$var$oldCaptionStyles
        ]
    }, children);
const $904c76d851d16186$var$paginationWrapperStyles = (0, $byn9U.css)({
    display: 'flex',
    justifyContent: 'center'
});
const $904c76d851d16186$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>(0, $byn9U.jsx)("div", {
        css: $904c76d851d16186$var$paginationWrapperStyles,
        "data-testid": testId && `${testId}--pagination--container`
    }, children);

});
parcelRegister("8fFiw", function(module, exports) {

$parcel$export(module.exports, "MSThemeColors", () => $601fc255d9b7a295$export$34af08ce45c78352);
$parcel$export(module.exports, "arrow", () => $601fc255d9b7a295$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "row", () => $601fc255d9b7a295$export$120ff0929b202a6d);
$parcel$export(module.exports, "head", () => $601fc255d9b7a295$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tableBorder", () => $601fc255d9b7a295$export$38d703b73e2cf64d);

var $PdmhA = parcelRequire("PdmhA");
const $601fc255d9b7a295$export$34af08ce45c78352 = {
    Background: 'Canvas',
    Text: 'CanvasText',
    SelectedBackground: 'Highlight',
    SelectedText: 'HighlightText'
};
const $601fc255d9b7a295$export$f2120bbfa5450bd2 = {
    defaultColor: `var(--ds-icon-disabled, ${$PdmhA.N40})`,
    selectedColor: `var(--ds-icon-subtle, ${$PdmhA.N300})`
};
const $601fc255d9b7a295$export$120ff0929b202a6d = {
    focusOutline: `var(--ds-border-focused, ${$PdmhA.B100})`,
    highlightedBackground: `var(--ds-background-selected, ${$PdmhA.B50})`,
    hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$PdmhA.N10})`,
    hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$PdmhA.B75})`
};
const $601fc255d9b7a295$export$5fd5031fecdacec3 = {
    textColor: `var(--ds-text-subtlest, ${$PdmhA.N300})`
};
const $601fc255d9b7a295$export$38d703b73e2cf64d = {
    borderColor: `var(--ds-border, ${$PdmhA.N40})`
};

});


parcelRegister("duoac", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $9d20d20eb73760da$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $9d20d20eb73760da$export$381ea436de119582);
/* eslint-disable @repo/internal/react/require-jsdoc */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
const $9d20d20eb73760da$var$fixedHeightStyles = (0, $byn9U.css)({
    height: '9rem'
});
const $9d20d20eb73760da$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>(0, $byn9U.jsx)("div", {
        css: $9d20d20eb73760da$var$fixedHeightStyles,
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`
    }, children);
const $9d20d20eb73760da$var$emptyViewContainerStyles = (0, $byn9U.css)({
    width: '50%',
    margin: 'auto',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    padding: '10px',
    textAlign: 'center'
});
const $9d20d20eb73760da$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return (0, $byn9U.jsx)("div", {
        css: $9d20d20eb73760da$var$emptyViewContainerStyles,
        "data-testid": testId && `${testId}--empty-view-container`
    }, children);
};

});

parcelRegister("9Z8nt", function(module, exports) {

$parcel$export(module.exports, "default", () => $74504f325d22cce4$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $jfkaq = parcelRequire("jfkaq");

var $6htaf = parcelRequire("6htaf");
class $74504f325d22cce4$var$Body extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef
        }, pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6htaf.default), {
                head: head,
                isFixedSize: isFixedSize,
                key: row.key || rowIndex,
                row: row,
                isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                testId: testId
            })));
    }
}
var $74504f325d22cce4$export$2e2bcd8739ae039 = (0, $jfkaq.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($74504f325d22cce4$var$Body, (0, $kU09D.default)({}, props, {
        forwardedRef: ref
    }));
}));

});
parcelRegister("jfkaq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e02f0fcd7cfc5f3f$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");


var $ddon4 = parcelRequire("ddon4");
const $e02f0fcd7cfc5f3f$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        var _head$cells$i;
        if (head.cells[i] && ((_head$cells$i = head.cells[i]) === null || _head$cells$i === void 0 ? void 0 : _head$cells$i.key) === sortKey) {
            var _cells$i;
            return (_cells$i = cells[i]) === null || _cells$i === void 0 ? void 0 : _cells$i.key;
        }
    }
    return undefined;
};
// sort all rows based on sort key and order
const $e02f0fcd7cfc5f3f$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $a36112c484f02420$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $e02f0fcd7cfc5f3f$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $e02f0fcd7cfc5f3f$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $e02f0fcd7cfc5f3f$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        constructor(...args){
            super(...args);
            (0, $5zQU9.default)(this, "state", {
                pageRows: []
            });
        }
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $ddon4.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $e02f0fcd7cfc5f3f$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $ddon4.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, (0, $kU09D.default)({
                pageRows: this.state.pageRows,
                head: head
            }, restProps, {
                ref: forwardedRef
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WithSortedPageRows, (0, $kU09D.default)({}, props, {
            forwardedRef: ref
        }));
    });
}

});

parcelRegister("6htaf", function(module, exports) {

$parcel$export(module.exports, "default", () => $492af40dd0b695a3$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $kv8zW = parcelRequire("kv8zW");

var $gS8Xm = parcelRequire("gS8Xm");
const $492af40dd0b695a3$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gS8Xm.TableBodyRow), (0, $kU09D.default)({}, restRowProps, {
        isHighlighted: isHighlighted
    }, isHighlighted ? {
        'data-ts--dynamic-table--table-row--highlighted': true
    } : null, {
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
    }), cells.map((cell, cellIndex)=>{
        const { content: content, testId: cellTestId, ...restCellProps } = cell;
        const { shouldTruncate: shouldTruncate, width: width } = (head || {
            cells: []
        }).cells[cellIndex] || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kv8zW.TableBodyCell), (0, $kU09D.default)({
            "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`
        }, restCellProps, {
            isFixedSize: isFixedSize,
            key: cellIndex // eslint-disable-line react/no-array-index-key
            ,
            shouldTruncate: shouldTruncate,
            width: width
        }), content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$492af40dd0b695a3$export$2e2bcd8739ae039 = $492af40dd0b695a3$var$Row;

});
parcelRegister("kv8zW", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $eecd5b6f7525589e$export$948e91fcef170792);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $6KKG4 = parcelRequire("6KKG4");
const $eecd5b6f7525589e$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>(0, $byn9U.jsx)("td", (0, $kU09D.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: (0, $6KKG4.getTruncationStyleVars)({
            width: width
        }),
        css: [
            (0, $6KKG4.truncationWidthStyles),
            isFixedSize && shouldTruncate && (0, $6KKG4.fixedSizeTruncateStyles),
            isFixedSize && (0, $6KKG4.overflowTruncateStyles),
            (0, $6KKG4.cellStyles)
        ],
        ref: innerRef
    }, props));

});
parcelRegister("6KKG4", function(module, exports) {

$parcel$export(module.exports, "truncationWidthStyles", () => $4eab3f25b927d952$export$708a733455f59a29);
$parcel$export(module.exports, "fixedSizeTruncateStyles", () => $4eab3f25b927d952$export$616c93ee022c8812);
$parcel$export(module.exports, "overflowTruncateStyles", () => $4eab3f25b927d952$export$7f2cd17defa265d8);
$parcel$export(module.exports, "getTruncationStyleVars", () => $4eab3f25b927d952$export$5e6497a652ae30b5);
$parcel$export(module.exports, "cellStyles", () => $4eab3f25b927d952$export$f7913df521f684e2);

var $byn9U = parcelRequire("byn9U");
const $4eab3f25b927d952$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $4eab3f25b927d952$export$708a733455f59a29 = (0, $byn9U.css)({
    width: `var(${$4eab3f25b927d952$var$CSS_VAR_WIDTH})`
});
const $4eab3f25b927d952$export$616c93ee022c8812 = (0, $byn9U.css)({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $4eab3f25b927d952$export$7f2cd17defa265d8 = (0, $byn9U.css)({
    overflow: 'hidden'
});
const $4eab3f25b927d952$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$4eab3f25b927d952$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
const $4eab3f25b927d952$export$f7913df521f684e2 = (0, $byn9U.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    border: 'none',
    textAlign: 'left',
    '&:first-of-type': {
        paddingLeft: "var(--ds-space-0, 0px)"
    },
    '&:last-child': {
        paddingRight: "var(--ds-space-0, 0px)"
    }
});

});


parcelRegister("gS8Xm", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $c488a310ea21d4a6$export$45f39d9c38b886d5);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $co66L = parcelRequire("co66L");
const $c488a310ea21d4a6$var$rowStyles = (0, $byn9U.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    '&:focus-visible': {
        outline: `2px solid ${`var(--ds-border-focused, ${`var(${(0, $co66L.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
        outlineOffset: `-2px`
    }
});
const $c488a310ea21d4a6$var$rowBackgroundStyles = (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${`var(${(0, $co66L.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
    }
});
const $c488a310ea21d4a6$var$rowHighlightedBackgroundStyles = (0, $byn9U.css)({
    backgroundColor: `var(--ds-background-selected, ${`var(${(0, $co66L.tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${`var(${(0, $co66L.tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
    }
});
const $c488a310ea21d4a6$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
    return (0, $byn9U.jsx)("tr", (0, $kU09D.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        css: [
            $c488a310ea21d4a6$var$rowStyles,
            isHighlighted ? $c488a310ea21d4a6$var$rowHighlightedBackgroundStyles : $c488a310ea21d4a6$var$rowBackgroundStyles
        ]
    }, rest, {
        ref: ref,
        "data-testid": testId
    }), children);
});

});



parcelRegister("88KKW", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $5ed356e50f0f48e3$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");
class $5ed356e50f0f48e3$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("4h26S", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ca62f3577c0786$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");


var $leZHb = parcelRequire("leZHb");
class $31ca62f3577c0786$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $leZHb.Container), {
            testId: testId
        }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $leZHb.ContentsContainer), {
            contentsOpacity: contentsOpacity,
            testId: testId
        }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $leZHb.SpinnerContainer), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        })));
    }
}
(0, $5zQU9.default)($31ca62f3577c0786$export$2e2bcd8739ae039, "defaultProps", {
    isLoading: true,
    spinnerSize: (0, $a36112c484f02420$export$7b93a10c0fefe3e3),
    contentsOpacity: (0, $a36112c484f02420$export$3843c586a90b9cbf),
    loadingLabel: 'Loading table'
});

});
parcelRegister("leZHb", function(module, exports) {

$parcel$export(module.exports, "Container", () => $f76ac33a2702830a$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $f76ac33a2702830a$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $f76ac33a2702830a$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
const $f76ac33a2702830a$export$c335a80381ec61f5 = '--contents-opacity';
const $f76ac33a2702830a$var$containerStyles = (0, $byn9U.css)({
    position: 'relative'
});
const $f76ac33a2702830a$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>(0, $byn9U.jsx)("div", {
        css: $f76ac33a2702830a$var$containerStyles,
        "data-testid": testId && `${testId}--container`
    }, children);
const $f76ac33a2702830a$var$contentsContainerStyles = (0, $byn9U.css)({
    opacity: `var(${$f76ac33a2702830a$export$c335a80381ec61f5})`,
    pointerEvents: 'none'
});
const $f76ac33a2702830a$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>(0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$f76ac33a2702830a$export$c335a80381ec61f5]: contentsOpacity
        },
        css: [
            $f76ac33a2702830a$var$contentsContainerStyles
        ],
        "data-testid": testId && `${testId}--contents--container`
    }, children);
const $f76ac33a2702830a$var$spinnerContainerStyles = (0, $byn9U.css)({
    display: 'flex',
    position: 'absolute',
    inset: 0,
    alignItems: 'center',
    justifyContent: 'center'
});
const $f76ac33a2702830a$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, $byn9U.jsx)("div", {
        css: $f76ac33a2702830a$var$spinnerContainerStyles,
        "data-testid": testId && `${testId}--spinner--container`
    }, children);

});


parcelRegister("kXxkC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4232c4f74454cf6$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");


var $frznW = parcelRequire("frznW");
class $f4232c4f74454cf6$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "spinnerRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef());
        (0, $5zQU9.default)(this, "containerRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef());
        (0, $5zQU9.default)(this, "componentDidMount", ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        });
        (0, $5zQU9.default)(this, "UNSAFE_componentWillReceiveProps", (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        });
        (0, $5zQU9.default)(this, "componentDidUpdate", ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        });
        (0, $5zQU9.default)(this, "componentWillUnmount", ()=>{
            this.detachListeners();
        });
        (0, $5zQU9.default)(this, "getTargetNode", (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef === null || targetRef === void 0 ? void 0 : targetRef();
            return target || this.containerRef.current;
        });
        (0, $5zQU9.default)(this, "hasTargetNode", (nextProps)=>!!this.getTargetNode(nextProps));
        (0, $5zQU9.default)(this, "isVerticallyVisible", (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        });
        (0, $5zQU9.default)(this, "isFullyVerticallyVisible", (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        });
        (0, $5zQU9.default)(this, "handleResize", ()=>{
            this.updateSpinnerPosition();
        });
        (0, $5zQU9.default)(this, "handleScroll", ()=>{
            this.updateSpinnerPosition();
        });
        (0, $5zQU9.default)(this, "translateSpinner", (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        });
        (0, $5zQU9.default)(this, "updateTargetAppearance", ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        });
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        var _this$spinnerRef, _this$containerRef;
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = (_this$spinnerRef = this.spinnerRef) === null || _this$spinnerRef === void 0 ? void 0 : _this$spinnerRef.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = (_this$containerRef = this.containerRef) === null || _this$containerRef === void 0 ? void 0 : _this$containerRef.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frznW.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef
        }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frznW.SpinnerBackdrop), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frznW.SpinnerContainer), {
            ref: this.spinnerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        }))));
    }
}
(0, $5zQU9.default)($f4232c4f74454cf6$export$2e2bcd8739ae039, "defaultProps", {
    isLoading: true,
    spinnerSize: (0, $a36112c484f02420$export$7b93a10c0fefe3e3),
    contentsOpacity: `var(--ds-opacity-loading, ${`${(0, $a36112c484f02420$export$3843c586a90b9cbf)}`})`,
    loadingLabel: 'Loading table'
});

});
parcelRegister("frznW", function(module, exports) {

$parcel$export(module.exports, "Container", () => $b3e4d36087ea335f$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $b3e4d36087ea335f$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $b3e4d36087ea335f$export$a5e06607a5ac6158);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
const $b3e4d36087ea335f$var$containerStyles = (0, $byn9U.css)({
    position: 'relative',
    marginBlockEnd: "var(--ds-space-300, 24px)"
});
const $b3e4d36087ea335f$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        css: $b3e4d36087ea335f$var$containerStyles
    }, rest, {
        "data-testid": testId,
        ref: ref
    }), children));
});
const $b3e4d36087ea335f$var$spinnerBackdropStyles = (0, $byn9U.css)({
    display: 'flex',
    position: 'absolute',
    inset: 0,
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none'
});
const $b3e4d36087ea335f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>(0, $byn9U.jsx)("div", {
        css: $b3e4d36087ea335f$var$spinnerBackdropStyles,
        "data-testid": testId && `${testId}--spinner-backdrop`
    }, children);
const $b3e4d36087ea335f$var$spinnerContainerStyles = (0, $byn9U.css)({
    position: 'relative',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    insetBlockStart: 0
});
const $b3e4d36087ea335f$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children }, ref)=>(0, $byn9U.jsx)("div", {
        css: $b3e4d36087ea335f$var$spinnerContainerStyles,
        ref: ref
    }, children));

});


parcelRegister("ZMl3T", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b9b31ae2b84daff$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $3KPTt = parcelRequire("3KPTt");
class $0b9b31ae2b84daff$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "onChange", (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        });
    }
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KPTt.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n === null || i18n === void 0 ? void 0 : i18n.label,
            nextLabel: i18n === null || i18n === void 0 ? void 0 : i18n.next,
            previousLabel: i18n === null || i18n === void 0 ? void 0 : i18n.prev,
            pageLabel: i18n === null || i18n === void 0 ? void 0 : i18n.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
}

});
parcelRegister("3KPTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d6d0a6ee26c024$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $4DxcJ = parcelRequire("4DxcJ");

var $7X9O4 = parcelRequire("7X9O4");

var $eDUla = parcelRequire("eDUla");

var $1ssgv = parcelRequire("1ssgv");

var $bZ2kD = parcelRequire("bZ2kD");
const $52d6d0a6ee26c024$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: undefined,
    packageVersion: undefined
};
const $52d6d0a6ee26c024$var$paginationMenuStyles = (0, $1ZAYh.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});
const $52d6d0a6ee26c024$var$paginationMenuItemStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.0'
});
function $52d6d0a6ee26c024$var$InnerPagination({ components: components = (0, $1ssgv.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1ssgv.emptyObject), max: max = 7, onChange: onChange = (0, $5Q9wj.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $eDUla.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $2WwAS.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$52d6d0a6ee26c024$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            as: "li",
            xcss: $52d6d0a6ee26c024$var$paginationMenuItemStyles,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7X9O4.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DxcJ.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dXKde))), {
            label: ""
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $52d6d0a6ee26c024$var$paginationMenuStyles
    }, (0, $bZ2kD.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DxcJ.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
            label: ""
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
const $52d6d0a6ee26c024$var$Pagination = /*#__PURE__*/ (0, $eUqFw.forwardRef)($52d6d0a6ee26c024$var$InnerPagination);
var $52d6d0a6ee26c024$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($52d6d0a6ee26c024$var$Pagination);

});
parcelRegister("4DxcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d3c7b4b153b94a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
function $a4d3c7b4b153b94a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("7X9O4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5f9797829cf4ad3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
function $e5f9797829cf4ad3$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("eDUla", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceba78dad21693c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $lkPEe = parcelRequire("lkPEe");
const $ceba78dad21693c3$var$containerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    position: 'relative'
});
function $ceba78dad21693c3$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $ceba78dad21693c3$var$containerStyles,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});

parcelRegister("1ssgv", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $3850a464bb1795dd$export$3f860eba1218f8d3);
const $3850a464bb1795dd$export$3f860eba1218f8d3 = {};

});

parcelRegister("bZ2kD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a954a8bde9a3bed3$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $a954a8bde9a3bed3$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $5iWql.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $a954a8bde9a3bed3$export$2e2bcd8739ae039 = $a954a8bde9a3bed3$var$collapseRange;

});



parcelRegister("32KsT", function(module, exports) {

$parcel$export(module.exports, "default", () => $237599fb680ede38$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $ddon4 = parcelRequire("ddon4");

var $fqrG4 = parcelRequire("fqrG4");

var $frcu1 = parcelRequire("frcu1");

var $7j61g = parcelRequire("7j61g");
class $237599fb680ede38$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    UNSAFE_componentWillMount() {
        (0, $ddon4.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $ddon4.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $frcu1.default) : (0, $7j61g.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fqrG4.Head), (0, $kU09D.default)({}, rest, {
            isRanking: isRanking,
            testId: testId && `${testId}--head`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, cells.map((cell, index)=>{
            const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
            // the API.
            ...restCellProps } = cell;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeadCellComponent, (0, $kU09D.default)({
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                onClick: isSortable ? onSort(cell) : undefined,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width
            }, restCellProps));
        })));
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$237599fb680ede38$export$2e2bcd8739ae039 = $237599fb680ede38$var$TableHead;

});
parcelRegister("fqrG4", function(module, exports) {

$parcel$export(module.exports, "Head", () => $b3aec0e7ddf008ad$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $b3aec0e7ddf008ad$export$4e8024263ace498b);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");


var $8fFiw = parcelRequire("8fFiw");

var $6KKG4 = parcelRequire("6KKG4");
const $b3aec0e7ddf008ad$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $b3aec0e7ddf008ad$var$rankingStyles = (0, $byn9U.css)({
    display: 'block'
});
const $b3aec0e7ddf008ad$var$headStyles = (0, $byn9U.css)({
    borderBlockEnd: `none`
});
const $b3aec0e7ddf008ad$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return (0, $byn9U.jsx)("thead", (0, $kU09D.default)({
        css: [
            $b3aec0e7ddf008ad$var$headStyles,
            isRanking && $b3aec0e7ddf008ad$var$rankingStyles
        ],
        "data-testid": testId
    }, props));
};
const $b3aec0e7ddf008ad$var$headCellBaseStyles = (0, $byn9U.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    borderBlockEnd: `2px solid ${(0, $8fFiw.tableBorder).borderColor}`,
    color: `var(--ds-text-subtlest, ${`var(${$b3aec0e7ddf008ad$var$CSS_VAR_TEXT_COLOR})`})`,
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $PdmhA.B100)})`}`
    }
});
const $b3aec0e7ddf008ad$var$headCellOldStyles = (0, $byn9U.css)({
    fontSize: '0.75rem',
    fontWeight: "var(--ds-font-weight-semibold, 600)"
});
const $b3aec0e7ddf008ad$var$headCellNewStyles = (0, $byn9U.css)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $b3aec0e7ddf008ad$var$onClickStyles = (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $PdmhA.N30A)})`,
        cursor: 'pointer'
    }
});
const $b3aec0e7ddf008ad$var$baseStyles = (0, $byn9U.css)({
    '& > button': {
        padding: "var(--ds-space-0, 0)",
        position: 'relative',
        appearance: 'none',
        background: 'none',
        border: 'none',
        color: 'inherit',
        cursor: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        '&::before, &::after': {
            display: 'block',
            width: 0,
            height: 0,
            position: 'absolute',
            border: '3px solid transparent',
            content: '""',
            insetInlineEnd: "var(--ds-space-negative-100, -8px)"
        },
        '&::before': {
            borderBlockEnd: `3px solid ${(0, $8fFiw.arrow).defaultColor}`,
            insetBlockEnd: "var(--ds-space-100, 8px)"
        },
        '&::after': {
            borderBlockStart: `3px solid ${(0, $8fFiw.arrow).defaultColor}`,
            insetBlockEnd: 0
        }
    },
    '@media (forced-colors: active)': {
        '& > button': {
            '&::before, &::after': {
                border: `3px solid ${(0, $8fFiw.MSThemeColors).Background}`
            },
            '&::before': {
                borderBlockEnd: `3px solid ${(0, $8fFiw.MSThemeColors).Text}`
            },
            '&::after': {
                borderBlockStart: `3px solid ${(0, $8fFiw.MSThemeColors).Text}`
            }
        }
    }
});
const $b3aec0e7ddf008ad$var$ascendingStyles = (0, $byn9U.css)({
    '& > button': {
        '&::before': {
            borderBlockEnd: `3px solid ${(0, $8fFiw.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        '& > button': {
            '&::before': {
                borderBlockEnd: `3px solid ${(0, $8fFiw.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $b3aec0e7ddf008ad$var$descendingStyles = (0, $byn9U.css)({
    '& > button': {
        '&::after': {
            borderBlockStart: `3px solid ${(0, $8fFiw.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        '& > button': {
            '&::after': {
                borderBlockStart: `3px solid ${(0, $8fFiw.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $b3aec0e7ddf008ad$export$4e8024263ace498b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $6KKG4.getTruncationStyleVars)({
            width: width
        }),
        [$b3aec0e7ddf008ad$var$CSS_VAR_TEXT_COLOR]: (0, $8fFiw.head).textColor
    };
    const isASC = sortOrder === (0, $a36112c484f02420$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $a36112c484f02420$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return (0, $byn9U.jsx)(Component, (0, $kU09D.default)({
        "aria-sort": getFormattedSortOrder(),
        style: mergedStyles,
        css: [
            (0, $6KKG4.cellStyles),
            $b3aec0e7ddf008ad$var$headCellBaseStyles,
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.dynamic-table-typography_7zio6') ? $b3aec0e7ddf008ad$var$headCellNewStyles : $b3aec0e7ddf008ad$var$headCellOldStyles,
            onClick && $b3aec0e7ddf008ad$var$onClickStyles,
            (0, $6KKG4.truncationWidthStyles),
            isFixedSize && shouldTruncate && (0, $6KKG4.fixedSizeTruncateStyles),
            isFixedSize && (0, $6KKG4.overflowTruncateStyles),
            isSortable && $b3aec0e7ddf008ad$var$baseStyles,
            isASC && $b3aec0e7ddf008ad$var$ascendingStyles,
            isDESC && $b3aec0e7ddf008ad$var$descendingStyles
        ],
        onClick: onClick,
        ref: ref,
        "data-testid": testId
    }, rest), children);
});

});

parcelRegister("frcu1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3d30f8cb2e386ac$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $1BzJD = parcelRequire("1BzJD");

var $ddon4 = parcelRequire("ddon4");

var $7j61g = parcelRequire("7j61g");
class $b3d30f8cb2e386ac$var$RankableTableHeadCell extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $ddon4.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7j61g.default), (0, $kU09D.default)({
            inlineStyles: inlineStyles
        }, restProps));
    }
}
var $b3d30f8cb2e386ac$export$2e2bcd8739ae039 = (0, $1BzJD.default)($b3d30f8cb2e386ac$var$RankableTableHeadCell);

});
parcelRegister("1BzJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $12b4f762e8f9e9d9$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");
function $12b4f762e8f9e9d9$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        constructor(...args){
            super(...args);
            (0, $5zQU9.default)(this, "state", {
                refWidth: 0,
                refHeight: 0
            });
            (0, $5zQU9.default)(this, "innerRef", (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            });
            (0, $5zQU9.default)(this, "updateDimensions", ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            });
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, (0, $kU09D.default)({
                refWidth: refWidth,
                refHeight: refHeight,
                innerRef: this.innerRef
            }, this.props));
        }
    };
}

});

parcelRegister("7j61g", function(module, exports) {

$parcel$export(module.exports, "default", () => $551efa17fd625ad4$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $fqrG4 = parcelRequire("fqrG4");
const $551efa17fd625ad4$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fqrG4.HeadCell), (0, $kU09D.default)({
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null // string refs must be discarded as LegacyRefs are not compatible with FC forwardRefs
    }, rest, {
        onClick: onClick,
        isSortable: isSortable
    }), isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$551efa17fd625ad4$export$2e2bcd8739ae039 = $551efa17fd625ad4$var$TableHeadCell;

});



parcelRegister("5EzMr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7FyqB');
        const value = parcelRequire('b7Jod');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7FyqB").then(()=>parcelRequire('b7Jod'));
}

});


parcelRegister("c9w1E", function(module, exports) {

$parcel$export(module.exports, "isFileIdentifier", () => $8d8f2af0ddadcbf0$export$7695387cd66cf5b5);
$parcel$export(module.exports, "isDifferentIdentifier", () => $8d8f2af0ddadcbf0$export$5883721593c4e4b1);

var $8CRJm = parcelRequire("8CRJm");
const $8d8f2af0ddadcbf0$export$7695387cd66cf5b5 = (identifier)=>{
    return identifier.mediaItemType === 'file';
};
const $8d8f2af0ddadcbf0$export$2782f2fbff82f0c9 = (identifier)=>{
    return identifier.mediaItemType === 'external-image';
};
const $8d8f2af0ddadcbf0$export$5883721593c4e4b1 = (a, b)=>{
    if ($8d8f2af0ddadcbf0$export$7695387cd66cf5b5(a) && $8d8f2af0ddadcbf0$export$7695387cd66cf5b5(b)) return a.id !== b.id || a.collectionName !== b.collectionName || a.occurrenceKey !== b.occurrenceKey;
    else return !(0, (/*@__PURE__*/$parcel$interopDefault($8CRJm)))(a, b);
};

});
parcelRegister("8CRJm", function(module, exports) {

var $4jDQV = parcelRequire("4jDQV");

var $9fDHT = parcelRequire("9fDHT");

var $4BFNJ = parcelRequire("4BFNJ");

var $cEjMK = parcelRequire("cEjMK");

var $4ryWv = parcelRequire("4ryWv");

var $gdhvW = parcelRequire("gdhvW");
var $647b8d22941e9178$var$getTime = Date.prototype.getTime;
function $647b8d22941e9178$var$deepEqual(actual, expected, options) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? $4BFNJ(actual, expected) : actual === expected) return true;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') return opts.strict ? $4BFNJ(actual, expected) : actual == expected;
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // eslint-disable-next-line no-use-before-define
    return $647b8d22941e9178$var$objEquiv(actual, expected, opts);
}
function $647b8d22941e9178$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $647b8d22941e9178$var$isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $647b8d22941e9178$var$objEquiv(a, b, opts) {
    /* eslint max-statements: [2, 50] */ var i, key;
    if (typeof a !== typeof b) return false;
    if ($647b8d22941e9178$var$isUndefinedOrNull(a) || $647b8d22941e9178$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    if ($9fDHT(a) !== $9fDHT(b)) return false;
    var aIsRegex = $cEjMK(a);
    var bIsRegex = $cEjMK(b);
    if (aIsRegex !== bIsRegex) return false;
    if (aIsRegex || bIsRegex) return a.source === b.source && $4ryWv(a) === $4ryWv(b);
    if ($gdhvW(a) && $gdhvW(b)) return $647b8d22941e9178$var$getTime.call(a) === $647b8d22941e9178$var$getTime.call(b);
    var aIsBuffer = $647b8d22941e9178$var$isBuffer(a);
    var bIsBuffer = $647b8d22941e9178$var$isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    if (typeof a !== typeof b) return false;
    try {
        var ka = $4jDQV(a);
        var kb = $4jDQV(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$647b8d22941e9178$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return true;
}
module.exports = $647b8d22941e9178$var$deepEqual;

});
parcelRegister("4jDQV", function(module, exports) {
'use strict';
var $3247d9b061104208$var$slice = Array.prototype.slice;

var $96nTn = parcelRequire("96nTn");
var $3247d9b061104208$var$origKeys = Object.keys;

var $3247d9b061104208$var$keysShim = $3247d9b061104208$var$origKeys ? function keys(o) {
    return $3247d9b061104208$var$origKeys(o);
} : (parcelRequire("a7WlO"));
var $3247d9b061104208$var$originalKeys = Object.keys;
$3247d9b061104208$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($96nTn(object)) return $3247d9b061104208$var$originalKeys($3247d9b061104208$var$slice.call(object));
            return $3247d9b061104208$var$originalKeys(object);
        };
    } else Object.keys = $3247d9b061104208$var$keysShim;
    return Object.keys || $3247d9b061104208$var$keysShim;
};
module.exports = $3247d9b061104208$var$keysShim;

});
parcelRegister("96nTn", function(module, exports) {
'use strict';
var $6a0735185fec05e3$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $6a0735185fec05e3$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $6a0735185fec05e3$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("a7WlO", function(module, exports) {
'use strict';
var $75f7d21b7a735a78$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $75f7d21b7a735a78$var$has = Object.prototype.hasOwnProperty;
    var $75f7d21b7a735a78$var$toStr = Object.prototype.toString;
    var $75f7d21b7a735a78$var$isArgs = (parcelRequire("96nTn")); // eslint-disable-line global-require
    var $75f7d21b7a735a78$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $75f7d21b7a735a78$var$hasDontEnumBug = !$75f7d21b7a735a78$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $75f7d21b7a735a78$var$hasProtoEnumBug = $75f7d21b7a735a78$var$isEnumerable.call(function() {}, 'prototype');
    var $75f7d21b7a735a78$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $75f7d21b7a735a78$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $75f7d21b7a735a78$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $75f7d21b7a735a78$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$75f7d21b7a735a78$var$excludedKeys['$' + k] && $75f7d21b7a735a78$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $75f7d21b7a735a78$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $75f7d21b7a735a78$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$75f7d21b7a735a78$var$hasAutomationEqualityBug) return $75f7d21b7a735a78$var$equalsConstructorPrototype(o);
        try {
            return $75f7d21b7a735a78$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $75f7d21b7a735a78$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $75f7d21b7a735a78$var$toStr.call(object) === '[object Function]';
        var isArguments = $75f7d21b7a735a78$var$isArgs(object);
        var isString = isObject && $75f7d21b7a735a78$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $75f7d21b7a735a78$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$75f7d21b7a735a78$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $75f7d21b7a735a78$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($75f7d21b7a735a78$var$hasDontEnumBug) {
            var skipConstructor = $75f7d21b7a735a78$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $75f7d21b7a735a78$var$dontEnums.length; ++k)if (!(skipConstructor && $75f7d21b7a735a78$var$dontEnums[k] === 'constructor') && $75f7d21b7a735a78$var$has.call(object, $75f7d21b7a735a78$var$dontEnums[k])) theKeys.push($75f7d21b7a735a78$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $75f7d21b7a735a78$var$keysShim;

});


parcelRegister("9fDHT", function(module, exports) {
'use strict';

var $6bc450c4a7d545b1$var$hasToStringTag = (parcelRequire("6jtVY"))();

var $g94P8 = parcelRequire("g94P8");
var $6bc450c4a7d545b1$var$$toString = $g94P8('Object.prototype.toString');
var $6bc450c4a7d545b1$var$isStandardArguments = function isArguments(value) {
    if ($6bc450c4a7d545b1$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $6bc450c4a7d545b1$var$$toString(value) === '[object Arguments]';
};
var $6bc450c4a7d545b1$var$isLegacyArguments = function isArguments(value) {
    if ($6bc450c4a7d545b1$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $6bc450c4a7d545b1$var$$toString(value) !== '[object Array]' && $6bc450c4a7d545b1$var$$toString(value.callee) === '[object Function]';
};
var $6bc450c4a7d545b1$var$supportsStandardArguments = function() {
    return $6bc450c4a7d545b1$var$isStandardArguments(arguments);
}();
$6bc450c4a7d545b1$var$isStandardArguments.isLegacyArguments = $6bc450c4a7d545b1$var$isLegacyArguments; // for tests
module.exports = $6bc450c4a7d545b1$var$supportsStandardArguments ? $6bc450c4a7d545b1$var$isStandardArguments : $6bc450c4a7d545b1$var$isLegacyArguments;

});
parcelRegister("6jtVY", function(module, exports) {
'use strict';

var $3e6zG = parcelRequire("3e6zG");
module.exports = function hasToStringTagShams() {
    return $3e6zG() && !!Symbol.toStringTag;
};

});
parcelRegister("3e6zG", function(module, exports) {
'use strict';
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("g94P8", function(module, exports) {
'use strict';

var $1weDt = parcelRequire("1weDt");

var $eitbu = parcelRequire("eitbu");
var $bc113a7ded0692de$var$$indexOf = $eitbu($1weDt('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1weDt(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $bc113a7ded0692de$var$$indexOf(name, '.prototype.') > -1) return $eitbu(intrinsic);
    return intrinsic;
};

});
parcelRegister("1weDt", function(module, exports) {
'use strict';
var $11b421f1a315cdc3$var$undefined1;

var $isZAy = parcelRequire("isZAy");

var $hKBjS = parcelRequire("hKBjS");

var $3HHGH = parcelRequire("3HHGH");

var $2Eg3J = parcelRequire("2Eg3J");

var $2L4Ry = parcelRequire("2L4Ry");

var $jKgyW = parcelRequire("jKgyW");

var $49b0v = parcelRequire("49b0v");
var $11b421f1a315cdc3$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $11b421f1a315cdc3$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $11b421f1a315cdc3$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $11b421f1a315cdc3$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($11b421f1a315cdc3$var$$gOPD) try {
    $11b421f1a315cdc3$var$$gOPD({}, '');
} catch (e) {
    $11b421f1a315cdc3$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $11b421f1a315cdc3$var$throwTypeError = function() {
    throw new $jKgyW();
};
var $11b421f1a315cdc3$var$ThrowTypeError = $11b421f1a315cdc3$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $11b421f1a315cdc3$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $11b421f1a315cdc3$var$$gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $11b421f1a315cdc3$var$throwTypeError;
        }
    }
}() : $11b421f1a315cdc3$var$throwTypeError;

var $11b421f1a315cdc3$var$hasSymbols = (parcelRequire("fZcmW"))();

var $11b421f1a315cdc3$var$hasProto = (parcelRequire("17SE1"))();
var $11b421f1a315cdc3$var$getProto = Object.getPrototypeOf || ($11b421f1a315cdc3$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $11b421f1a315cdc3$var$needsEval = {};
var $11b421f1a315cdc3$var$TypedArray = typeof Uint8Array === 'undefined' || !$11b421f1a315cdc3$var$getProto ? undefined : $11b421f1a315cdc3$var$getProto(Uint8Array);
var $11b421f1a315cdc3$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $11b421f1a315cdc3$var$hasSymbols && $11b421f1a315cdc3$var$getProto ? $11b421f1a315cdc3$var$getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $11b421f1a315cdc3$var$needsEval,
    '%AsyncGenerator%': $11b421f1a315cdc3$var$needsEval,
    '%AsyncGeneratorFunction%': $11b421f1a315cdc3$var$needsEval,
    '%AsyncIteratorPrototype%': $11b421f1a315cdc3$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $isZAy,
    '%eval%': eval,
    '%EvalError%': $hKBjS,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $11b421f1a315cdc3$var$$Function,
    '%GeneratorFunction%': $11b421f1a315cdc3$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $11b421f1a315cdc3$var$hasSymbols && $11b421f1a315cdc3$var$getProto ? $11b421f1a315cdc3$var$getProto($11b421f1a315cdc3$var$getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$11b421f1a315cdc3$var$hasSymbols || !$11b421f1a315cdc3$var$getProto ? undefined : $11b421f1a315cdc3$var$getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $3HHGH,
    '%ReferenceError%': $2Eg3J,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$11b421f1a315cdc3$var$hasSymbols || !$11b421f1a315cdc3$var$getProto ? undefined : $11b421f1a315cdc3$var$getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $11b421f1a315cdc3$var$hasSymbols && $11b421f1a315cdc3$var$getProto ? $11b421f1a315cdc3$var$getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $11b421f1a315cdc3$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $2L4Ry,
    '%ThrowTypeError%': $11b421f1a315cdc3$var$ThrowTypeError,
    '%TypedArray%': $11b421f1a315cdc3$var$TypedArray,
    '%TypeError%': $jKgyW,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $49b0v,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
if ($11b421f1a315cdc3$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $11b421f1a315cdc3$var$errorProto = $11b421f1a315cdc3$var$getProto($11b421f1a315cdc3$var$getProto(e));
    $11b421f1a315cdc3$var$INTRINSICS['%Error.prototype%'] = $11b421f1a315cdc3$var$errorProto;
}
var $11b421f1a315cdc3$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $11b421f1a315cdc3$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $11b421f1a315cdc3$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $11b421f1a315cdc3$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $11b421f1a315cdc3$var$getProto) value = $11b421f1a315cdc3$var$getProto(gen.prototype);
    }
    $11b421f1a315cdc3$var$INTRINSICS[name] = value;
    return value;
};
var $11b421f1a315cdc3$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $ehjvj = parcelRequire("ehjvj");

var $kHkNK = parcelRequire("kHkNK");
var $11b421f1a315cdc3$var$$concat = $ehjvj.call(Function.call, Array.prototype.concat);
var $11b421f1a315cdc3$var$$spliceApply = $ehjvj.call(Function.apply, Array.prototype.splice);
var $11b421f1a315cdc3$var$$replace = $ehjvj.call(Function.call, String.prototype.replace);
var $11b421f1a315cdc3$var$$strSlice = $ehjvj.call(Function.call, String.prototype.slice);
var $11b421f1a315cdc3$var$$exec = $ehjvj.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $11b421f1a315cdc3$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $11b421f1a315cdc3$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $11b421f1a315cdc3$var$stringToPath = function stringToPath(string) {
    var first = $11b421f1a315cdc3$var$$strSlice(string, 0, 1);
    var last = $11b421f1a315cdc3$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $2L4Ry('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $2L4Ry('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $11b421f1a315cdc3$var$$replace(string, $11b421f1a315cdc3$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $11b421f1a315cdc3$var$$replace(subString, $11b421f1a315cdc3$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $11b421f1a315cdc3$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($kHkNK($11b421f1a315cdc3$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $11b421f1a315cdc3$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($kHkNK($11b421f1a315cdc3$var$INTRINSICS, intrinsicName)) {
        var value = $11b421f1a315cdc3$var$INTRINSICS[intrinsicName];
        if (value === $11b421f1a315cdc3$var$needsEval) value = $11b421f1a315cdc3$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $jKgyW('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $2L4Ry('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $jKgyW('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $jKgyW('"allowMissing" argument must be a boolean');
    if ($11b421f1a315cdc3$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $2L4Ry('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $11b421f1a315cdc3$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $11b421f1a315cdc3$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $11b421f1a315cdc3$var$$spliceApply(parts, $11b421f1a315cdc3$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $11b421f1a315cdc3$var$$strSlice(part, 0, 1);
        var last = $11b421f1a315cdc3$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $2L4Ry('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($kHkNK($11b421f1a315cdc3$var$INTRINSICS, intrinsicRealName)) value = $11b421f1a315cdc3$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $jKgyW('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($11b421f1a315cdc3$var$$gOPD && i + 1 >= parts.length) {
                var desc = $11b421f1a315cdc3$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $kHkNK(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $11b421f1a315cdc3$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("isZAy", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hKBjS", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("3HHGH", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2Eg3J", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("2L4Ry", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("jKgyW", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("49b0v", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("fZcmW", function(module, exports) {
'use strict';
var $ba3625c5ae4adbe4$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $3e6zG = parcelRequire("3e6zG");
module.exports = function hasNativeSymbols() {
    if (typeof $ba3625c5ae4adbe4$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $ba3625c5ae4adbe4$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $3e6zG();
};

});

parcelRegister("17SE1", function(module, exports) {
'use strict';
var $0d20d523845f1db6$var$test = {
    foo: {}
};
var $0d20d523845f1db6$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $0d20d523845f1db6$var$test
    }).foo === $0d20d523845f1db6$var$test.foo && !(({
        __proto__: null
    }) instanceof $0d20d523845f1db6$var$$Object);
};

});

parcelRegister("ehjvj", function(module, exports) {
'use strict';

var $kw7GN = parcelRequire("kw7GN");
module.exports = Function.prototype.bind || $kw7GN;

});
parcelRegister("kw7GN", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $eefcc2b686d85c77$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $eefcc2b686d85c77$var$toStr = Object.prototype.toString;
var $eefcc2b686d85c77$var$max = Math.max;
var $eefcc2b686d85c77$var$funcType = '[object Function]';
var $eefcc2b686d85c77$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $eefcc2b686d85c77$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $eefcc2b686d85c77$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $eefcc2b686d85c77$var$toStr.apply(target) !== $eefcc2b686d85c77$var$funcType) throw new TypeError($eefcc2b686d85c77$var$ERROR_MESSAGE + target);
    var args = $eefcc2b686d85c77$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $eefcc2b686d85c77$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $eefcc2b686d85c77$var$concatty(args, arguments));
    };
    var boundLength = $eefcc2b686d85c77$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $eefcc2b686d85c77$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("kHkNK", function(module, exports) {
'use strict';
var $f117f58260d3a487$var$call = Function.prototype.call;
var $f117f58260d3a487$var$$hasOwn = Object.prototype.hasOwnProperty;

var $ehjvj = parcelRequire("ehjvj");
/** @type {(o: {}, p: PropertyKey) => p is keyof o} */ module.exports = $ehjvj.call($f117f58260d3a487$var$call, $f117f58260d3a487$var$$hasOwn);

});


parcelRegister("eitbu", function(module, exports) {
'use strict';

var $ehjvj = parcelRequire("ehjvj");

var $1weDt = parcelRequire("1weDt");

var $gIATW = parcelRequire("gIATW");

var $jKgyW = parcelRequire("jKgyW");
var $a689628365f65073$var$$apply = $1weDt('%Function.prototype.apply%');
var $a689628365f65073$var$$call = $1weDt('%Function.prototype.call%');
var $a689628365f65073$var$$reflectApply = $1weDt('%Reflect.apply%', true) || $ehjvj.call($a689628365f65073$var$$call, $a689628365f65073$var$$apply);
var $a689628365f65073$var$$defineProperty = $1weDt('%Object.defineProperty%', true);
var $a689628365f65073$var$$max = $1weDt('%Math.max%');
if ($a689628365f65073$var$$defineProperty) try {
    $a689628365f65073$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $a689628365f65073$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== 'function') throw new $jKgyW('a function is required');
    var func = $a689628365f65073$var$$reflectApply($ehjvj, $a689628365f65073$var$$call, arguments);
    return $gIATW(func, 1 + $a689628365f65073$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $a689628365f65073$var$applyBind = function applyBind() {
    return $a689628365f65073$var$$reflectApply($ehjvj, $a689628365f65073$var$$apply, arguments);
};
if ($a689628365f65073$var$$defineProperty) $a689628365f65073$var$$defineProperty(module.exports, 'apply', {
    value: $a689628365f65073$var$applyBind
});
else module.exports.apply = $a689628365f65073$var$applyBind;

});
parcelRegister("gIATW", function(module, exports) {
'use strict';

var $1weDt = parcelRequire("1weDt");

var $cCdl2 = parcelRequire("cCdl2");

var $c2bd6135d127f933$var$hasDescriptors = (parcelRequire("kjsHT"))();

var $aBzvk = parcelRequire("aBzvk");

var $jKgyW = parcelRequire("jKgyW");
var $c2bd6135d127f933$var$$floor = $1weDt('%Math.floor%');
/** @typedef {(...args: unknown[]) => unknown} Func */ /** @type {<T extends Func = Func>(fn: T, length: number, loose?: boolean) => T} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $jKgyW('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $c2bd6135d127f933$var$$floor(length) !== length) throw new $jKgyW('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $aBzvk) {
        var desc = $aBzvk(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($c2bd6135d127f933$var$hasDescriptors) $cCdl2(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $cCdl2(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("cCdl2", function(module, exports) {
'use strict';

var $92f3615e33016a96$var$hasPropertyDescriptors = (parcelRequire("kjsHT"))();

var $1weDt = parcelRequire("1weDt");
var $92f3615e33016a96$var$$defineProperty = $92f3615e33016a96$var$hasPropertyDescriptors && $1weDt('%Object.defineProperty%', true);
if ($92f3615e33016a96$var$$defineProperty) try {
    $92f3615e33016a96$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $92f3615e33016a96$var$$defineProperty = false;
}

var $2L4Ry = parcelRequire("2L4Ry");

var $jKgyW = parcelRequire("jKgyW");

var $aBzvk = parcelRequire("aBzvk");
/** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $jKgyW('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $jKgyW('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $jKgyW('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $jKgyW('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $jKgyW('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $jKgyW('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$aBzvk && $aBzvk(obj, property);
    if ($92f3615e33016a96$var$$defineProperty) $92f3615e33016a96$var$$defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $2L4Ry('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});
parcelRegister("kjsHT", function(module, exports) {
'use strict';

var $1weDt = parcelRequire("1weDt");
var $ec9bd99a0f456a55$var$$defineProperty = $1weDt('%Object.defineProperty%', true);
var $ec9bd99a0f456a55$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($ec9bd99a0f456a55$var$$defineProperty) try {
        $ec9bd99a0f456a55$var$$defineProperty({}, 'a', {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
$ec9bd99a0f456a55$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$ec9bd99a0f456a55$var$hasPropertyDescriptors()) return null;
    try {
        return $ec9bd99a0f456a55$var$$defineProperty([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $ec9bd99a0f456a55$var$hasPropertyDescriptors;

});

parcelRegister("aBzvk", function(module, exports) {
'use strict';

var $1weDt = parcelRequire("1weDt");
var $7b88e67ec805ca25$var$$gOPD = $1weDt('%Object.getOwnPropertyDescriptor%', true);
if ($7b88e67ec805ca25$var$$gOPD) try {
    $7b88e67ec805ca25$var$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $7b88e67ec805ca25$var$$gOPD = null;
}
module.exports = $7b88e67ec805ca25$var$$gOPD;

});






parcelRegister("4BFNJ", function(module, exports) {
'use strict';

var $7DUGk = parcelRequire("7DUGk");

var $eitbu = parcelRequire("eitbu");

var $dAjEz = parcelRequire("dAjEz");

var $c4ycW = parcelRequire("c4ycW");

var $29zXl = parcelRequire("29zXl");
var $35ab0af6f8ad58df$var$polyfill = $eitbu($c4ycW(), Object);
$7DUGk($35ab0af6f8ad58df$var$polyfill, {
    getPolyfill: $c4ycW,
    implementation: $dAjEz,
    shim: $29zXl
});
module.exports = $35ab0af6f8ad58df$var$polyfill;

});
parcelRegister("7DUGk", function(module, exports) {
'use strict';

var $4jDQV = parcelRequire("4jDQV");
var $590824c046b6e009$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $590824c046b6e009$var$toStr = Object.prototype.toString;
var $590824c046b6e009$var$concat = Array.prototype.concat;

var $cCdl2 = parcelRequire("cCdl2");
var $590824c046b6e009$var$isFunction = function(fn) {
    return typeof fn === 'function' && $590824c046b6e009$var$toStr.call(fn) === '[object Function]';
};

var $590824c046b6e009$var$supportsDescriptors = (parcelRequire("kjsHT"))();
var $590824c046b6e009$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$590824c046b6e009$var$isFunction(predicate) || !predicate()) return;
    }
    if ($590824c046b6e009$var$supportsDescriptors) $cCdl2(object, name, value, true);
    else $cCdl2(object, name, value);
};
var $590824c046b6e009$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $4jDQV(map);
    if ($590824c046b6e009$var$hasSymbols) props = $590824c046b6e009$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$590824c046b6e009$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$590824c046b6e009$var$defineProperties.supportsDescriptors = !!$590824c046b6e009$var$supportsDescriptors;
module.exports = $590824c046b6e009$var$defineProperties;

});

parcelRegister("dAjEz", function(module, exports) {
'use strict';
var $9e3de1e5d12e41fc$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($9e3de1e5d12e41fc$var$numberIsNaN(a) && $9e3de1e5d12e41fc$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("c4ycW", function(module, exports) {
'use strict';

var $dAjEz = parcelRequire("dAjEz");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $dAjEz;
};

});

parcelRegister("29zXl", function(module, exports) {
'use strict';

var $c4ycW = parcelRequire("c4ycW");

var $7DUGk = parcelRequire("7DUGk");
module.exports = function shimObjectIs() {
    var polyfill = $c4ycW();
    $7DUGk(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("cEjMK", function(module, exports) {
'use strict';

var $g94P8 = parcelRequire("g94P8");

var $93589167f76ee330$var$hasToStringTag = (parcelRequire("6jtVY"))();
var $93589167f76ee330$var$has;
var $93589167f76ee330$var$$exec;
var $93589167f76ee330$var$isRegexMarker;
var $93589167f76ee330$var$badStringifier;
if ($93589167f76ee330$var$hasToStringTag) {
    $93589167f76ee330$var$has = $g94P8('Object.prototype.hasOwnProperty');
    $93589167f76ee330$var$$exec = $g94P8('RegExp.prototype.exec');
    $93589167f76ee330$var$isRegexMarker = {};
    var $93589167f76ee330$var$throwRegexMarker = function() {
        throw $93589167f76ee330$var$isRegexMarker;
    };
    $93589167f76ee330$var$badStringifier = {
        toString: $93589167f76ee330$var$throwRegexMarker,
        valueOf: $93589167f76ee330$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $93589167f76ee330$var$badStringifier[Symbol.toPrimitive] = $93589167f76ee330$var$throwRegexMarker;
}
var $93589167f76ee330$var$$toString = $g94P8('Object.prototype.toString');
var $93589167f76ee330$var$gOPD = Object.getOwnPropertyDescriptor;
var $93589167f76ee330$var$regexClass = '[object RegExp]';
module.exports = $93589167f76ee330$var$hasToStringTag ? function isRegex(value) {
    if (!value || typeof value !== 'object') return false;
    var descriptor = $93589167f76ee330$var$gOPD(value, 'lastIndex');
    var hasLastIndexDataProperty = descriptor && $93589167f76ee330$var$has(descriptor, 'value');
    if (!hasLastIndexDataProperty) return false;
    try {
        $93589167f76ee330$var$$exec(value, $93589167f76ee330$var$badStringifier);
    } catch (e) {
        return e === $93589167f76ee330$var$isRegexMarker;
    }
} : function isRegex(value) {
    // In older browsers, typeof regex incorrectly returns 'function'
    if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
    return $93589167f76ee330$var$$toString(value) === $93589167f76ee330$var$regexClass;
};

});

parcelRegister("4ryWv", function(module, exports) {
'use strict';

var $7DUGk = parcelRequire("7DUGk");

var $eitbu = parcelRequire("eitbu");

var $aUQU4 = parcelRequire("aUQU4");

var $4zymb = parcelRequire("4zymb");

var $jTFBq = parcelRequire("jTFBq");
var $33c4c9ea7944020e$var$flagsBound = $eitbu($4zymb());
$7DUGk($33c4c9ea7944020e$var$flagsBound, {
    getPolyfill: $4zymb,
    implementation: $aUQU4,
    shim: $jTFBq
});
module.exports = $33c4c9ea7944020e$var$flagsBound;

});
parcelRegister("aUQU4", function(module, exports) {
'use strict';

var $e4ktJ = parcelRequire("e4ktJ");
var $7f282bd625686fc8$var$$Object = Object;
var $7f282bd625686fc8$var$$TypeError = TypeError;
module.exports = $e4ktJ(function flags() {
    if (this != null && this !== $7f282bd625686fc8$var$$Object(this)) throw new $7f282bd625686fc8$var$$TypeError('RegExp.prototype.flags getter called on non-object');
    var result = '';
    if (this.hasIndices) result += 'd';
    if (this.global) result += 'g';
    if (this.ignoreCase) result += 'i';
    if (this.multiline) result += 'm';
    if (this.dotAll) result += 's';
    if (this.unicode) result += 'u';
    if (this.unicodeSets) result += 'v';
    if (this.sticky) result += 'y';
    return result;
}, 'get flags', true);

});
parcelRegister("e4ktJ", function(module, exports) {
'use strict';

var $cCdl2 = parcelRequire("cCdl2");

var $a3e15302d454ee41$var$hasDescriptors = (parcelRequire("kjsHT"))();

var $a3e15302d454ee41$var$functionsHaveConfigurableNames = (parcelRequire("bfZ33")).functionsHaveConfigurableNames();
var $a3e15302d454ee41$var$$TypeError = TypeError;
module.exports = function setFunctionName(fn, name) {
    if (typeof fn !== 'function') throw new $a3e15302d454ee41$var$$TypeError('`fn` is not a function');
    var loose = arguments.length > 2 && !!arguments[2];
    if (!loose || $a3e15302d454ee41$var$functionsHaveConfigurableNames) {
        if ($a3e15302d454ee41$var$hasDescriptors) $cCdl2(fn, 'name', name, true, true);
        else $cCdl2(fn, 'name', name);
    }
    return fn;
};

});
parcelRegister("bfZ33", function(module, exports) {
'use strict';
var $8320735b390bf40a$var$functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === 'string';
};
var $8320735b390bf40a$var$gOPD = Object.getOwnPropertyDescriptor;
if ($8320735b390bf40a$var$gOPD) try {
    $8320735b390bf40a$var$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $8320735b390bf40a$var$gOPD = null;
}
$8320735b390bf40a$var$functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!$8320735b390bf40a$var$functionsHaveNames() || !$8320735b390bf40a$var$gOPD) return false;
    var desc = $8320735b390bf40a$var$gOPD(function() {}, 'name');
    return !!desc && !!desc.configurable;
};
var $8320735b390bf40a$var$$bind = Function.prototype.bind;
$8320735b390bf40a$var$functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return $8320735b390bf40a$var$functionsHaveNames() && typeof $8320735b390bf40a$var$$bind === 'function' && (function f() {}).bind().name !== '';
};
module.exports = $8320735b390bf40a$var$functionsHaveNames;

});



parcelRegister("4zymb", function(module, exports) {
'use strict';

var $aUQU4 = parcelRequire("aUQU4");

var $7DUGk = parcelRequire("7DUGk");
var $354514dbe85fc84f$require$supportsDescriptors = $7DUGk.supportsDescriptors;
var $354514dbe85fc84f$var$$gOPD = Object.getOwnPropertyDescriptor;
module.exports = function getPolyfill() {
    if ($354514dbe85fc84f$require$supportsDescriptors && /a/mig.flags === 'gim') {
        var descriptor = $354514dbe85fc84f$var$$gOPD(RegExp.prototype, 'flags');
        if (descriptor && typeof descriptor.get === 'function' && typeof RegExp.prototype.dotAll === 'boolean' && typeof RegExp.prototype.hasIndices === 'boolean') {
            /* eslint getter-return: 0 */ var calls = '';
            var o = {};
            Object.defineProperty(o, 'hasIndices', {
                get: function() {
                    calls += 'd';
                }
            });
            Object.defineProperty(o, 'sticky', {
                get: function() {
                    calls += 'y';
                }
            });
            if (calls === 'dy') return descriptor.get;
        }
    }
    return $aUQU4;
};

});

parcelRegister("jTFBq", function(module, exports) {
'use strict';

var $7DUGk = parcelRequire("7DUGk");
var $e7c36cce0cfbc801$require$supportsDescriptors = $7DUGk.supportsDescriptors;

var $4zymb = parcelRequire("4zymb");
var $e7c36cce0cfbc801$var$gOPD = Object.getOwnPropertyDescriptor;
var $e7c36cce0cfbc801$var$defineProperty = Object.defineProperty;
var $e7c36cce0cfbc801$var$TypeErr = TypeError;
var $e7c36cce0cfbc801$var$getProto = Object.getPrototypeOf;
var $e7c36cce0cfbc801$var$regex = /a/;
module.exports = function shimFlags() {
    if (!$e7c36cce0cfbc801$require$supportsDescriptors || !$e7c36cce0cfbc801$var$getProto) throw new $e7c36cce0cfbc801$var$TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
    var polyfill = $4zymb();
    var proto = $e7c36cce0cfbc801$var$getProto($e7c36cce0cfbc801$var$regex);
    var descriptor = $e7c36cce0cfbc801$var$gOPD(proto, 'flags');
    if (!descriptor || descriptor.get !== polyfill) $e7c36cce0cfbc801$var$defineProperty(proto, 'flags', {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};

});


parcelRegister("gdhvW", function(module, exports) {
'use strict';
var $bcdb72371c4de2b2$var$getDay = Date.prototype.getDay;
var $bcdb72371c4de2b2$var$tryDateObject = function tryDateGetDayCall(value) {
    try {
        $bcdb72371c4de2b2$var$getDay.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $bcdb72371c4de2b2$var$toStr = Object.prototype.toString;
var $bcdb72371c4de2b2$var$dateClass = '[object Date]';

var $bcdb72371c4de2b2$var$hasToStringTag = (parcelRequire("6jtVY"))();
module.exports = function isDateObject(value) {
    if (typeof value !== 'object' || value === null) return false;
    return $bcdb72371c4de2b2$var$hasToStringTag ? $bcdb72371c4de2b2$var$tryDateObject(value) : $bcdb72371c4de2b2$var$toStr.call(value) === $bcdb72371c4de2b2$var$dateClass;
};

});



parcelRegister("bUbLp", function(module, exports) {

$parcel$export(module.exports, "withMediaClient", () => $8aae0cb232d24097$export$9f7977d4a2561bee);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $g3pIo = parcelRequire("g3pIo");
const $8aae0cb232d24097$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3pIo.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, (0, $kU09D.default)({}, otherProps, {
                mediaClient: value
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3pIo.MediaClientProvider), {
                clientConfig: mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3pIo.MediaClientContext).Consumer, null, (client)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, (0, $kU09D.default)({}, otherProps, {
                    mediaClient: client
                })))));

});

parcelRegister("6Ia1x", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2ea0a2002990af$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $gjM26 = parcelRequire("gjM26");



class $4e2ea0a2002990af$export$671fb13bdd5ef2c4 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "isMounted", false);
        (0, $5zQU9.default)(this, "state", {
            // Set state value to equal to current static value of this class.
            MediaViewer: $4e2ea0a2002990af$export$671fb13bdd5ef2c4.MediaViewer,
            MediaViewerErrorBoundary: $4e2ea0a2002990af$export$671fb13bdd5ef2c4.MediaViewerErrorBoundary
        });
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.MediaViewer || !this.state.MediaViewerErrorBoundary) try {
            const [mediaClient, mediaViewerModule, mediaViewerErrorBoundaryModule] = await Promise.all([
                (parcelRequire("eSP44")),
                (parcelRequire("6VX1R")),
                (parcelRequire("7PCQq"))
            ]);
            const MediaViewerWithClient = mediaClient.withMediaClient(mediaViewerModule.MediaViewer);
            $4e2ea0a2002990af$export$671fb13bdd5ef2c4.MediaViewer = MediaViewerWithClient;
            $4e2ea0a2002990af$export$671fb13bdd5ef2c4.MediaViewerErrorBoundary = mediaViewerErrorBoundaryModule.default;
            if (this.isMounted) this.setState({
                MediaViewer: MediaViewerWithClient,
                MediaViewerErrorBoundary: $4e2ea0a2002990af$export$671fb13bdd5ef2c4.MediaViewerErrorBoundary
            });
        } catch (error) {
        // TODO [MS-2277]: Add operational error to catch async import error
        }
    }
    componentDidMount() {
        this.isMounted = true;
    }
    componentWillUnmount() {
        this.isMounted = false;
    }
    render() {
        const { MediaViewer: MediaViewer, MediaViewerErrorBoundary: MediaViewerErrorBoundary } = this.state;
        if (!MediaViewer || !MediaViewerErrorBoundary) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjM26.default), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MediaViewerErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MediaViewer, this.props));
    }
}
(0, $5zQU9.default)($4e2ea0a2002990af$export$671fb13bdd5ef2c4, "displayName", 'AsyncMediaViewer');
var $4e2ea0a2002990af$export$2e2bcd8739ae039 = $4e2ea0a2002990af$export$671fb13bdd5ef2c4;

});
parcelRegister("gjM26", function(module, exports) {

$parcel$export(module.exports, "headerAndSidebarBackgroundColor", () => $be13ae01ff8657e9$export$442b7be89436c101);
$parcel$export(module.exports, "default", () => $be13ae01ff8657e9$export$2e2bcd8739ae039);
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $eUqFw = parcelRequire("eUqFw");

var $adQJw = parcelRequire("adQJw");

var $4q38b = parcelRequire("4q38b");
const $be13ae01ff8657e9$export$442b7be89436c101 = '#101214';
const $be13ae01ff8657e9$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adQJw.default), {
        blankedColor: $be13ae01ff8657e9$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $be13ae01ff8657e9$export$2e2bcd8739ae039 = $be13ae01ff8657e9$var$ModalSpinner;

});
parcelRegister("adQJw", function(module, exports) {

$parcel$export(module.exports, "default", () => $77140603256e0786$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lcnyw = parcelRequire("lcnyw");

var $4Bees = parcelRequire("4Bees");

var $exJuA = parcelRequire("exJuA");
const $77140603256e0786$var$overlayZindex = (0, $lcnyw.layers).modal() + 10;
const $77140603256e0786$export$5b927fc1ef8c468b = (0, $exJuA.default).div({
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: $77140603256e0786$var$overlayZindex
});
$77140603256e0786$export$5b927fc1ef8c468b.displayName = 'Blanket';
const $77140603256e0786$export$52b4dfd89a6b3a1b = (0, $exJuA.default).div({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
});
$77140603256e0786$export$52b4dfd89a6b3a1b.displayName = 'SpinnerWrapper';
const $77140603256e0786$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $77140603256e0786$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($77140603256e0786$export$5b927fc1ef8c468b, {
        style: {
            backgroundColor: blankedColor || $77140603256e0786$var$defaultProps.blankedColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($77140603256e0786$export$52b4dfd89a6b3a1b, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large",
        appearance: invertSpinnerColor || $77140603256e0786$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit'
    })));

});


parcelRegister("6VX1R", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('PVx7a');
        const value = parcelRequire('aGrSS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("PVx7a").then(()=>parcelRequire('aGrSS'));
}

});

parcelRegister("7PCQq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('kKQNV')
        ]);
        const value = parcelRequire('eNnN8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("kKQNV")
    ]).then(()=>parcelRequire('eNnN8'));
}

});


parcelRegister("2fUwg", function(module, exports) {

$parcel$export(module.exports, "mediaTableWrapperStyles", () => $1a48d30d73bf99cd$export$24caf5e9feaab1c4);

var $byn9U = parcelRequire("byn9U");
const $1a48d30d73bf99cd$export$86beb3ffd1c7646d = (0, $byn9U.css)`
  display: flex;
  align-content: center;
  align-items: center;
`;
const $1a48d30d73bf99cd$export$ee06c074f85d7036 = (0, $byn9U.css)`
  min-width: 0;
  width: 100%;
  margin-left: ${"var(--ds-space-050, 4px)"};

  span:first-of-type {
    &::first-letter {
      text-transform: capitalize;
    }
  }
`;
const $1a48d30d73bf99cd$export$24caf5e9feaab1c4 = (0, $byn9U.css)`
  tr {
    cursor: pointer;

    td:empty {
      padding: 0;
    }
  }
`;

});

parcelRegister("j7YJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $decdc7cd7683aeeb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $PdmhA = parcelRequire("PdmhA");

var $i9nBX = parcelRequire("i9nBX");

var $bbaTG = parcelRequire("bbaTG");

var $3GbPC = parcelRequire("3GbPC");

const $decdc7cd7683aeeb$var$MediaDownloadButton = (props)=>{
    const { onClick: onClick, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        appearance: "subtle",
        testId: "download-button",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i9nBX))), {
            label: formatMessage((0, $3GbPC.messages).download)
        }),
        onKeyPress: (event)=>event.stopPropagation(),
        onClick: (event, analyticsEvent)=>{
            analyticsEvent.update((payload)=>({
                    ...payload,
                    eventType: 'ui',
                    actionSubjectId: 'mediaTableDownload'
                })).fire((0, $2b1c1c158447240b$export$ec1779cb96554e1));
            onClick(event);
        },
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    minWidth: 'max-content',
                    '&:hover': {
                        background: `var(--ds-background-neutral-hovered, ${0, $PdmhA.N40})`
                    }
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
};
var $decdc7cd7683aeeb$export$2e2bcd8739ae039 = (0, $2qhQi.default)($decdc7cd7683aeeb$var$MediaDownloadButton);

});
parcelRegister("3GbPC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2ade78d4ad27ae28$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2ade78d4ad27ae28$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    click_to_join: {
        id: 'fabric.media.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.media.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    request_access: {
        id: 'fabric.media.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_description: {
        id: 'fabric.media.request_access_description',
        defaultMessage: 'Request access to {context} view this preview.',
        description: 'Allows the user to request access to a product'
    },
    request_access_pending: {
        id: 'fabric.media.request_access_pending',
        defaultMessage: 'Access pending',
        description: 'Allows the user to try an action again with their current account'
    },
    request_access_pending_description: {
        id: 'fabric.media.request_access_pending_description',
        defaultMessage: 'Your access request is pending.',
        description: 'Informs the user that their request to view this content is pending'
    },
    forbidden_description: {
        id: 'fabric.media.forbidden_description',
        defaultMessage: "You don\u2019t have access to this preview. Contact the site admin if you need access.",
        description: 'Informs the user that they cannot view this content.'
    },
    request_denied_description: {
        id: 'fabric.media.request_denied_description',
        defaultMessage: 'Your access request was denied. Contact the site admin if you still need access.',
        description: 'Informs the user that their request to view this content was denied'
    },
    retry: {
        id: 'fabric.media.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    failed_to_load: {
        id: 'fabric.media.failed_to_load',
        defaultMessage: 'Failed to load',
        description: 'We show this message when we have an error loading a file'
    },
    failed_to_upload: {
        id: 'fabric.media.failed_to_upload',
        defaultMessage: 'Failed to upload',
        description: 'We show this message when we have an error uploading a file'
    },
    recent_uploads: {
        id: 'fabric.media.recent_uploads',
        defaultMessage: 'Recent uploads',
        description: 'Title of a section where we show the user recent uploaded files'
    },
    upload_file: {
        id: 'fabric.media.upload_file',
        defaultMessage: 'Upload a file',
        description: 'Call to action that initiates the upload of a file'
    },
    drag_and_drop_your_files: {
        id: 'fabric.media.drag_and_drop_your_files',
        defaultMessage: 'Drag and drop your files anywhere or',
        description: 'Used to describe the area where the user can drag and drop files to upload'
    },
    drag_and_drop_your_files_and_folders: {
        id: 'fabric.media.drag_and_drop_your_files_and_folders',
        defaultMessage: 'Drag and drop your files and folders anywhere or',
        description: 'Used to describe the area where the user can drag and drop files AND folders to upload'
    },
    drop_your_files: {
        id: 'fabric.media.drop_your_files',
        defaultMessage: 'Drop your files to upload',
        description: 'Indicates that the files will be uploaded when the user drops them in the drag and drop area'
    },
    upload: {
        id: 'fabric.media.upload',
        defaultMessage: 'Upload',
        description: 'upload'
    },
    cancel: {
        id: 'fabric.media.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    search_all_gifs: {
        id: 'fabric.media.search_all_gifs',
        defaultMessage: 'Search all the GIFs!',
        description: 'Used as input placeholder to let the user know that they can search for GIF image files'
    },
    cant_retrieve_gifs: {
        id: 'fabric.media.cant_retrieve_gifs',
        defaultMessage: 'Ouch! We could not retrieve any GIFs',
        description: 'Error message when we can not find any GIF images for that text'
    },
    cant_retrieve_files: {
        id: 'fabric.media.cant_retrieve_files',
        defaultMessage: 'Ouch! We could not retrieve any files',
        description: 'Error message when we can not find any files in dropbox/google drive'
    },
    check_your_network: {
        id: 'fabric.media.check_your_network',
        defaultMessage: 'Check your network connection',
        description: 'Error message when network does not work'
    },
    try_again: {
        id: 'fabric.media.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.media.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    no_gifs_found: {
        id: 'fabric.media.no_gifs_found',
        defaultMessage: "Hello? Was it me you're looking for?",
        description: 'Not expected error that happens when searching for GIF images'
    },
    no_gifs_found_suggestion: {
        id: 'fabric.media.no_gifs_found_suggestion',
        defaultMessage: 'We couldn\'t find anything for "{query}"',
        description: 'There are no results for GIFs matching that query'
    },
    load_more_gifs: {
        id: 'fabric.media.load_more_gifs',
        defaultMessage: 'Load more GIFs',
        description: 'Used to load next page of GIF images'
    },
    add_account: {
        id: 'fabric.media.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    unlink_account: {
        id: 'fabric.media.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    upload_file_from: {
        id: 'fabric.media.upload_file_from',
        defaultMessage: 'Upload a file from {name}',
        description: 'Allows to upload a file from different sources'
    },
    connect_to: {
        id: 'fabric.media.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.media.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.media.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.media.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.media.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.media.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    invalid_permissions: {
        id: 'fabric.media.invalid_permissions',
        defaultMessage: 'Restricted link',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.media.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    select_an_avatar: {
        id: 'fabric.media.select_an_avatar',
        defaultMessage: 'Select a default avatar',
        description: 'Shown when the user selects an avatar from a list of avatars'
    },
    upload_an_avatar: {
        id: 'fabric.media.upload_an_avatar',
        defaultMessage: 'Upload an avatar',
        description: 'Indicates that the user can upload a new avatar'
    },
    select_an_avatar_from_all_defaults: {
        id: 'fabric.media.select_an_avatar_from_all_defaults',
        defaultMessage: 'Select from all default options',
        description: 'Announced when user is required to select an avatar from the complete list of default options'
    },
    show_more_avatars_btn_label: {
        id: 'fabric.media.show_more_avatars_btn_label',
        defaultMessage: 'Show more',
        description: 'Button label to show more default avatar options'
    },
    or_select_default_avatars: {
        id: 'fabric.media.or_select_default_avatars',
        defaultMessage: 'Upload a photo or select from some default options',
        description: 'Announced when a user is required to select an avatar by uploading an avatar or selecting from default options'
    },
    loading: {
        id: 'fabric.media.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    loading_file: {
        id: 'fabric.media.loading_file',
        defaultMessage: 'Loading file...',
        description: 'Shown when a file is being fetched'
    },
    save: {
        id: 'fabric.media.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    or: {
        id: 'fabric.media.or',
        defaultMessage: 'or',
        description: 'Just the "or" word'
    },
    upload_photo: {
        id: 'fabric.media.upload_photo',
        defaultMessage: 'Upload a photo',
        description: 'Call to action for the user to upload a new photo'
    },
    default_avatars: {
        id: 'fabric.media.default_avatars',
        defaultMessage: 'Default avatars',
        description: 'Showed above the default avatar list'
    },
    avatar_picker_back_btn_label: {
        id: 'fabric.media.avatar_picker_back_btn_label',
        defaultMessage: 'Go Back',
        description: 'Button text to navigate back to the previous screen'
    },
    drag_and_drop_images_here: {
        id: 'fabric.media.drag_and_drop_images_here',
        defaultMessage: 'Drag and drop your images here',
        description: 'Indicates that the user can drag and drop images in that area'
    },
    alt_text: {
        id: 'fabric.media.alt_text',
        defaultMessage: 'Alt text',
        description: 'Shown above the alt text field'
    },
    alt_text_description: {
        id: 'fabric.media.alt_text',
        defaultMessage: 'How would you describe the selected image to someone with low vision?',
        description: 'Shown below the alt text field'
    },
    image_url_invalid_error: {
        id: 'fabric.media.image_url_invalid_error',
        defaultMessage: 'Could not load image, the url is invalid.',
        description: 'There was an error parsing the image url'
    },
    image_format_invalid_error: {
        id: 'fabric.media.image_format_invalid_error',
        defaultMessage: 'Could not load image, the format is invalid.',
        description: 'The provided image format is not valid'
    },
    image_size_too_large_error: {
        id: 'fabric.media.image_size_too_large_error',
        defaultMessage: 'Image is too large, must be no larger than {MAX_SIZE_MB}Mb',
        description: 'The provided image size is too big'
    },
    something_went_wrong: {
        id: 'fabric.media.something_went_wrong',
        defaultMessage: 'Something went wrong.',
        description: 'Showed when an error happen but we dont have more info about it'
    },
    might_be_a_hiccup: {
        id: 'fabric.media.might_be_a_hiccup',
        defaultMessage: 'It might just be a hiccup.',
        description: 'Used when an unknow error happens, just in a funny way of saying that we dont have more info about it'
    },
    couldnt_generate_preview: {
        id: 'fabric.media.couldnt_generate_preview',
        defaultMessage: "We couldn't generate a preview for this file.",
        description: 'Error case for when the backend cant generate a preview for that file'
    },
    couldnt_generate_encrypted_entry_preview: {
        id: 'fabric.media.couldnt_generate_encrypted_entry_preview',
        defaultMessage: "We can't preview encrypted or password protected files.",
        description: 'Error case for when an entry selected is encrypted'
    },
    cant_preview_file_type: {
        id: 'fabric.media.cant_preview_file_type',
        defaultMessage: "We can't preview this file type.",
        description: 'Error case for when we have no available preview for that file'
    },
    item_not_found_in_list: {
        id: 'fabric.media.item_not_found_in_list',
        defaultMessage: 'The selected item was not found on the list.',
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.media.not_found_title',
        defaultMessage: "Uh oh. We can't find this link!",
        description: 'Error case for when a provided link is not found'
    },
    not_found_description: {
        id: 'fabric.media.not_found_description',
        defaultMessage: "We couldn't find the link. Check the url and try editing or paste again.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    no_pdf_artifacts: {
        id: 'fabric.media.no_pdf_artifacts',
        defaultMessage: 'No PDF artifacts found for this file.',
        description: 'Error case for when we cant preview a PDF file'
    },
    password_protected_pdf: {
        id: 'fabric.media.password_protected_pdf',
        defaultMessage: 'This file is password protected.',
        description: 'Describing that a PDF cannot be viewed because it is protected by password'
    },
    password: {
        id: 'fabric.media.password',
        defaultMessage: 'Password',
        description: 'Description of Password text field.'
    },
    enter_password: {
        id: 'fabric.media.enter_password',
        defaultMessage: 'Enter password',
        description: 'Prompting user to enter the password.'
    },
    incorrect_password: {
        id: 'fabric.media.incorrect_password',
        defaultMessage: 'Incorrect password. Please try again.',
        description: 'Error case for when a wrong password is inputted.'
    },
    submit: {
        id: 'fabric.media.submit',
        defaultMessage: 'Submit',
        description: 'Description for a button to submit the form.'
    },
    give_feedback: {
        id: 'fabric.media.give_feedback',
        defaultMessage: 'Give feedback',
        description: 'Call to action that opens a popup to get feedback from the users'
    },
    try_downloading_file: {
        id: 'fabric.media.try_downloading_file',
        defaultMessage: 'Try downloading the file to view it.',
        description: 'We show this message to allow users to download a file'
    },
    webgl_warning_description: {
        id: 'fabric.media.webgl_warning_description',
        defaultMessage: 'Your browser does not support WebGL. Use a WebGL enabled browser to annotate images.',
        description: 'We show this error message when the browser doesnt support this feature'
    },
    unable_to_annotate_image: {
        id: 'fabric.media.unable_to_annotate_image',
        defaultMessage: "You're unable to annotate this image",
        description: 'If there is an error trying to annotate an image we show this'
    },
    learn_more: {
        id: 'fabric.media.learn_more',
        defaultMessage: 'Learn More',
        description: ''
    },
    accounts: {
        id: 'fabric.media.accounts',
        defaultMessage: 'Accounts',
        description: ''
    },
    actions: {
        id: 'fabric.media.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    error_hint_retry: {
        id: 'fabric.media.error_hint_retry',
        defaultMessage: "Try again and we'll give it another shot.",
        description: 'Generic message that we show if an action failed'
    },
    error_hint_critical: {
        id: 'fabric.media.error_hint_critical',
        defaultMessage: 'If the problem keeps happening contact support.',
        description: 'We show this error message if we cant recover from the action'
    },
    close: {
        id: 'fabric.media.close',
        defaultMessage: 'Close',
        description: ''
    },
    could_not_load_editor: {
        id: 'fabric.media.could_not_load_editor',
        defaultMessage: 'Ouch! We could not load the editor',
        description: 'Error message to communicate that we cant load the editor'
    },
    could_not_save_image: {
        id: 'fabric.media.could_not_save_image',
        defaultMessage: 'Ouch! We could not save the image',
        description: 'Error message to communicate that we cant save an image'
    },
    could_not_load_link: {
        id: 'fabric.media.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    annotate: {
        id: 'fabric.media.annotate',
        defaultMessage: 'Annotate',
        description: ''
    },
    annotate_tool_arrow: {
        id: 'fabric.media.annotate.tool.arrow',
        defaultMessage: 'Arrow',
        description: ''
    },
    annotate_tool_text: {
        id: 'fabric.media.annotate.tool.text',
        defaultMessage: 'Text',
        description: ''
    },
    annotate_tool_shape: {
        id: 'fabric.media.annotate.tool.shape',
        defaultMessage: 'Shape',
        description: ''
    },
    annotate_tool_brush: {
        id: 'fabric.media.annotate.tool.brush',
        defaultMessage: 'Brush',
        description: ''
    },
    annotate_tool_blur: {
        id: 'fabric.media.annotate.tool.blur',
        defaultMessage: 'Blur',
        description: ''
    },
    annotate_tool_line_thickness: {
        id: 'fabric.media.annotate.tool.line.thickness',
        defaultMessage: 'Line thickness',
        description: ''
    },
    annotate_tool_color: {
        id: 'fabric.media.annotate.tool.color',
        defaultMessage: 'Color',
        description: ''
    },
    annotate_confirmation_close_anyway: {
        id: 'fabric.media.annotate.confirmation.close.anyway',
        defaultMessage: 'Close anyway',
        description: ''
    },
    annotate_confirmation_heading: {
        id: 'fabric.media.annotate.confirmation.heading',
        defaultMessage: 'Unsaved changes',
        description: ''
    },
    annotate_confirmation_content: {
        id: 'fabric.media.annotate.confirmation.content',
        defaultMessage: 'You have some unsaved changes. Are you sure you want to leave?',
        description: ''
    },
    drop_your_files_here: {
        id: 'fabric.media.drop_your_files_here',
        defaultMessage: 'Drop your files here',
        description: 'Info message that we show to indicate that the user can drag and drop files'
    },
    share_files_instantly: {
        id: 'fabric.media.share_files_instantly',
        defaultMessage: "We'll share them instantly",
        description: 'It means that we will upload the files you drag and drop automatically'
    },
    insert_files: {
        id: 'fabric.media.insert_files',
        defaultMessage: 'Insert {0, plural, one {a file} other {{0} files}}',
        description: 'Showed when the user selects 1 or more files to insert'
    },
    zoom_out: {
        id: 'fabric.media.zoom_out',
        defaultMessage: 'zoom out',
        description: 'Indicates the user can zoom out a file'
    },
    zoom_in: {
        id: 'fabric.media.zoom_in',
        defaultMessage: 'zoom in',
        description: 'Indicates the user can zoom in a file'
    },
    remove_image: {
        id: 'fabric.media.remove_image',
        defaultMessage: 'Remove image',
        description: 'Allows the user to remove a file'
    },
    play: {
        id: 'fabric.media.play',
        defaultMessage: 'Play',
        description: ''
    },
    pause: {
        id: 'fabric.media.pause',
        defaultMessage: 'Pause',
        description: ''
    },
    disable_fullscreen: {
        id: 'fabric.media.disable_fullscreen',
        defaultMessage: 'disable fullscreen',
        description: 'Hint to let the user know they can disable the fullscreen mode'
    },
    enable_fullscreen: {
        id: 'fabric.media.enable_fullscreen',
        defaultMessage: 'enable fullscreen',
        description: 'Hint to let the user know they can enable the fullscreen mode'
    },
    error_loading_file: {
        id: 'fabric.media.error_loading_file',
        defaultMessage: 'Error loading file',
        description: 'Message showed when we had an error trying to load the file'
    },
    error_generating_preview: {
        id: 'fabric.media.error_generating_preview',
        defaultMessage: 'Error generating preview',
        description: 'Message showed when we had an error trying generate a preview for a file'
    },
    download: {
        id: 'fabric.media.download',
        defaultMessage: 'Download',
        description: ''
    },
    unknown: {
        id: 'fabric.media.unknown',
        defaultMessage: 'unknown',
        description: ''
    },
    document: {
        id: 'fabric.media.document',
        defaultMessage: 'document',
        description: ''
    },
    audio: {
        id: 'fabric.media.audio',
        defaultMessage: 'audio',
        description: ''
    },
    video: {
        id: 'fabric.media.video',
        defaultMessage: 'video',
        description: ''
    },
    image: {
        id: 'fabric.media.image',
        defaultMessage: 'image',
        description: ''
    },
    archive: {
        id: 'fabric.media.archive',
        defaultMessage: 'archive',
        description: ''
    },
    email: {
        id: 'fabric.media.email',
        defaultMessage: 'email',
        description: ''
    },
    text: {
        id: 'fabric.media.text',
        defaultMessage: 'text',
        description: ''
    },
    displayThumbnail: {
        id: 'fabric.media.display_thumbnail',
        defaultMessage: 'Display thumbnail',
        description: 'Display file with as a thumbnail.'
    },
    search: {
        id: 'fabric.media.search',
        defaultMessage: 'search',
        description: ''
    },
    view: {
        id: 'fabric.media.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.media.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.media.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    changeView: {
        id: 'fabric.media.change_view',
        defaultMessage: 'Change view',
        description: 'In the context of a file, it allows the user to select a different way of displaying the file either as inline or a card'
    },
    playbackSpeed: {
        id: 'fabric.media.playback_speed',
        defaultMessage: 'Playback speed',
        description: 'In the context of a video player, it allows user to switch the speed of the video'
    },
    skipBackward: {
        id: 'fabric.media.skip_backward',
        defaultMessage: 'Back 10 seconds',
        description: 'In the context of a video player, it allows user to skip 10 seconds of play time backward.'
    },
    skipForward: {
        id: 'fabric.media.skip_forward',
        defaultMessage: 'Forward 10 seconds',
        description: 'In the context of a video player, it allows user to skip 10 seconds of play time forward.'
    },
    volumeLevelControlAria: {
        id: 'fabric.media.volume_level',
        defaultMessage: 'volume',
        description: 'In the context of a video player and screen reader. Aria label for volume level control'
    },
    volumeMuteButtonAria: {
        id: 'fabric.media.volume_level',
        defaultMessage: 'mute',
        description: 'In the context of a video player and screen reader. Aria label for mute button'
    },
    playbackDefaultSpeed: {
        id: 'fabric.media.playback_default_speed',
        defaultMessage: 'Default',
        description: 'In the context of a video player, it is a value of a default playback speed'
    },
    preview: {
        id: 'fabric.media.preview',
        defaultMessage: 'Preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    creating_preview: {
        id: 'fabric.media.creating_preview',
        defaultMessage: 'Creating preview...',
        description: 'Preview is being created for a media card'
    },
    preview_unavailable: {
        id: 'fabric.media.preview_unavailable',
        defaultMessage: 'Preview unavailable',
        description: 'Preview is unavailable for a media card'
    },
    preview_currently_unavailable: {
        id: 'fabric.media.preview_currently_unavailable',
        defaultMessage: 'Preview currently unavailable',
        description: 'Preview is unavailable for a media card due to a temporary error'
    },
    couldnt_load_file: {
        id: 'fabric.media.couldnt_load_file',
        defaultMessage: "We couldn't load the file.",
        description: 'File is rate limited without metadata'
    },
    error_429: {
        id: 'fabric.media.error_429',
        defaultMessage: 'Error 429',
        description: 'Error 429 is thrown'
    },
    close_and_reopen: {
        id: 'fabric.media.close_and_reopen',
        defaultMessage: 'Try closing this file and reopening.',
        description: 'The preview is rate limited'
    },
    viewer_rateLimited: {
        id: 'fabric.media.viewer_rateLimited',
        defaultMessage: `We're having difficulties loading your file.`,
        description: 'Mediaviewer has been rate limited'
    },
    zip_entry_load_fail: {
        id: 'fabric.media.zip_entry_load_failed',
        defaultMessage: `We couldn't load that zip file item to preview`,
        description: 'Zip entry failed to load'
    },
    file_image_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Image {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded image'
    },
    file_video_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Video {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded video'
    },
    file_audio_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Audio {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded audio'
    },
    file_doc_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Document {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded document'
    },
    file_archive_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Archive {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded archive'
    },
    file_unknown_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'File {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded file'
    },
    open_file_in_viewer: {
        id: 'fabric.media.open_file_in_viewer',
        defaultMessage: 'Open {name}',
        description: 'Shown when user focuses on preview to open the full screen viewer of the file with {name}'
    },
    video_seeker_assistive_text_time_value: {
        id: 'fabric.media.video_seeker_assistive_text_time_value',
        defaultMessage: '{currentTimeHours} {currentTimeMinutes} {currentTimeSeconds} of {videoTotalHours} {videoTotalMinutes} {videoTotalSeconds}',
        description: 'Video time seeker information for screen reader users - final format example: 1 hour 12 minutes 13 seconds of 1 hours 16 minutes 1 second. Units are already translated via Intl.NumberFormat'
    },
    video_seeker_label_assistive_text: {
        id: 'fabric.media.video_seeker_label_assistive_text',
        defaultMessage: 'Seek slider',
        description: 'Video time seek slider aria-label'
    }
});

});

const $2b1c1c158447240b$export$b03528b1ebec0921 = 'download';
const $2b1c1c158447240b$export$cde535873d2d8bb6 = 'preview';
const $2b1c1c158447240b$export$ec1779cb96554e1 = 'media';


parcelRegister("9WTJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $73e4c3b00172b85b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $92QJy = parcelRequire("92QJy");

var $bbaTG = parcelRequire("bbaTG");

var $3GbPC = parcelRequire("3GbPC");

const $73e4c3b00172b85b$var$MediaPreviewButton = (props)=>{
    const { onClick: onClick, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        appearance: "subtle",
        testId: "preview-button",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($92QJy))), {
            label: formatMessage((0, $3GbPC.messages).preview)
        }),
        onKeyPress: (event)=>event.stopPropagation(),
        onClick: (event, analyticsEvent)=>{
            analyticsEvent.update((payload)=>({
                    ...payload,
                    eventType: 'ui',
                    actionSubjectId: 'mediaTablePreview'
                })).fire((0, $2b1c1c158447240b$export$ec1779cb96554e1));
            onClick(event);
        },
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    minWidth: 'max-content'
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
};
var $73e4c3b00172b85b$export$2e2bcd8739ae039 = (0, $2qhQi.default)($73e4c3b00172b85b$var$MediaPreviewButton);

});
parcelRegister("92QJy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $695d34c2a57eb533$var$_react = $695d34c2a57eb533$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $695d34c2a57eb533$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $695d34c2a57eb533$var$EditorFilePreviewIcon = (props)=>/*#__PURE__*/ $695d34c2a57eb533$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 18h3a1 1 0 010 2H6a2 2 0 01-2-2v-3a1 1 0 112 0v3zm12 2h-3a1 1 0 010-2h3v-3a1 1 0 012 0v3a2 2 0 01-2 2zM6 4h3a1 1 0 010 2H6v3a1 1 0 01-2 0V6a2 2 0 012-2zm12 2h-3a1 1 0 110-2h3a2 2 0 012 2v3a1 1 0 01-2 0V6z" fill="currentColor"/><path d="M10.55 12.061l-1.873.337a.998.998 0 01-.718-1.713 1 1 0 01.718-.287h3.7c.316-.08.686.021.957.293.272.271.373.641.293.957v3.7a1 1 0 01-2 0l.337-1.873-2.602 2.603c-.345.344-.94.306-1.33-.084-.391-.39-.429-.986-.084-1.33l2.602-2.603z" fill="currentColor"/></svg>`
    }, props));
$695d34c2a57eb533$var$EditorFilePreviewIcon.displayName = 'EditorFilePreviewIcon';
var $695d34c2a57eb533$var$_default = $695d34c2a57eb533$var$EditorFilePreviewIcon;
module.exports.default = $695d34c2a57eb533$var$_default;

});


parcelRegister("j8cie", function(module, exports) {

$parcel$export(module.exports, "default", () => $ded84ccf936be783$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

const $ded84ccf936be783$var$generateHeadValues = (0, $5iWql.default)((columns)=>({
        cells: columns.cells.map((cell)=>cell.key === (0, $2b1c1c158447240b$export$b03528b1ebec0921) || cell.key === (0, $2b1c1c158447240b$export$cde535873d2d8bb6) ? {
                style: {
                    width: '48px'
                },
                ...cell
            } : cell)
    }));
var $ded84ccf936be783$export$2e2bcd8739ae039 = (0, $5iWql.default)($ded84ccf936be783$var$generateHeadValues);

});

parcelRegister("7nm9r", function(module, exports) {

$parcel$export(module.exports, "default", () => $55ebdd27a5402391$export$2e2bcd8739ae039);
// eslint-disable-next-line import/no-extraneous-dependencies

var $5iWql = parcelRequire("5iWql");
function $55ebdd27a5402391$var$generateEmptyRows(emptyCells, length) {
    const itemsArray = Array.from({
        length: length
    });
    return itemsArray.map(()=>({
            cells: emptyCells
        }));
}
const $55ebdd27a5402391$export$f14ff7ab50aea3f4 = (0, $5iWql.default)((headerCells)=>{
    return headerCells.map((cell)=>({
            key: cell.key,
            content: ''
        }));
});
const $55ebdd27a5402391$export$429ca4350e2810e1 = (0, $5iWql.default)((emptyCells, itemsPerPage, pageNumber)=>{
    if (!itemsPerPage || !pageNumber) return [];
    const itemsCount = (pageNumber - 1) * itemsPerPage;
    return $55ebdd27a5402391$var$generateEmptyRows(emptyCells, itemsCount);
});
const $55ebdd27a5402391$export$3efb9b22f6123712 = (0, $5iWql.default)((emptyCells, rowsLength, itemsPerPage, pageNumber, totalItems)=>{
    if (!itemsPerPage || !pageNumber || !totalItems) return [];
    const rowsDiff = rowsLength > itemsPerPage ? rowsLength - itemsPerPage : 0;
    const itemsCount = (Math.ceil(totalItems / itemsPerPage) - pageNumber) * itemsPerPage - rowsDiff;
    return $55ebdd27a5402391$var$generateEmptyRows(emptyCells, itemsCount);
});
function $55ebdd27a5402391$export$2e2bcd8739ae039({ itemsPerPage: itemsPerPage, pageNumber: pageNumber, totalItems: totalItems, rowValues: rowValues, headerCells: headerCells }) {
    const emptyCells = $55ebdd27a5402391$export$f14ff7ab50aea3f4(headerCells);
    return [
        ...$55ebdd27a5402391$export$429ca4350e2810e1(emptyCells, itemsPerPage, pageNumber),
        ...rowValues,
        ...$55ebdd27a5402391$export$3efb9b22f6123712(emptyCells, rowValues.length, itemsPerPage, pageNumber, totalItems)
    ];
}

});

parcelRegister("lbN4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6d0b074010f094b$export$2e2bcd8739ae039);
// eslint-disable-next-line import/no-extraneous-dependencies

var $5iWql = parcelRequire("5iWql");
const $f6d0b074010f094b$var$DEFAULT_ITEMS_PER_PAGE = 6;
const $f6d0b074010f094b$var$getValidTableProps = (itemsCount, itemsPerPage, pageNumber, totalItems)=>{
    let validItemsPerPage = itemsPerPage || $f6d0b074010f094b$var$DEFAULT_ITEMS_PER_PAGE;
    let validTotalItems = totalItems || itemsCount;
    let validPageNumber = pageNumber || 1;
    if (validItemsPerPage < 0) {
        validItemsPerPage = $f6d0b074010f094b$var$DEFAULT_ITEMS_PER_PAGE;
        // eslint-disable-next-line no-console
        console.warn('Invalid itemsPerPage prop provided to MediaTable. Setting value to default.');
    }
    if (validTotalItems < 0) {
        validTotalItems = itemsCount;
        // eslint-disable-next-line no-console
        console.warn('Invalid totalItems prop provided to MediaTable. Defaulting to length of items array.');
    }
    if (validPageNumber < 0) {
        validPageNumber = 1;
        // eslint-disable-next-line no-console
        console.warn('Invalid pageNumber prop provided to MediaTable. Defaulting to first page.');
    } else {
        const totalPages = Math.ceil(validTotalItems / validItemsPerPage);
        if (validPageNumber > totalPages) {
            validPageNumber = totalPages;
            // eslint-disable-next-line no-console
            console.warn('Invalid pageNumber prop provided to MediaTable. Defaulting to last page.');
        }
    }
    return {
        validPageNumber: validPageNumber,
        validTotalItems: validTotalItems,
        validItemsPerPage: validItemsPerPage
    };
};
var $f6d0b074010f094b$export$2e2bcd8739ae039 = (0, $5iWql.default)($f6d0b074010f094b$var$getValidTableProps);

});


parcelRegister("7mtz7", function(module, exports) {

$parcel$export(module.exports, "default", () => $42c329c7d5e53fd4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gwbAV = parcelRequire("gwbAV");

var $kYiu6 = parcelRequire("kYiu6");
const $42c329c7d5e53fd4$var$NoAttachments = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($gwbAV))),
        header: formatMessage((0, $kYiu6.default).emptyStateTitle),
        description: formatMessage((0, $kYiu6.default).emptyStateDescription)
    });
};
var $42c329c7d5e53fd4$export$2e2bcd8739ae039 = $42c329c7d5e53fd4$var$NoAttachments;

});
parcelRegister("gwbAV", function(module, exports) {
module.exports = new URL("cloud.923d9cf2.svg", import.meta.url).toString();

});

parcelRegister("kYiu6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ee7e4890f3ccae$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e4ee7e4890f3ccae$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyStateTitle: {
        "id": "issue-attachments-table.empty.empty-state-title",
        "defaultMessage": "All your attachments in one place"
    },
    emptyStateDescription: {
        "id": "issue-attachments-table.empty.empty-state-description",
        "defaultMessage": "Attachments can be added to paragraph fields, comments, and worklog entries. When you have attachments on this issue, you can view and download them here."
    }
});

});


parcelRegister("9T569", function(module, exports) {

$parcel$export(module.exports, "default", () => $c330d9d38df7311f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c330d9d38df7311f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    fileName: {
        "id": "issue-attachments-table.file-name",
        "defaultMessage": "Name"
    },
    size: {
        "id": "issue-attachments-table.size",
        "defaultMessage": "Size"
    },
    date: {
        "id": "issue-attachments-table.date",
        "defaultMessage": "Date added"
    },
    delete: {
        "id": "issue-attachments-table.delete",
        "defaultMessage": "Delete or go to"
    },
    download: {
        "id": "issue-attachments-table.download",
        "defaultMessage": "Download"
    },
    loadingAriaLabel: {
        "id": "issue-attachments-table.loading-aria-label",
        "defaultMessage": "loading attachments"
    },
    loadedAriaLabel: {
        "id": "issue-attachments-table.loaded-aria-label",
        "defaultMessage": "Attachments table loaded. Press tab to enter the table"
    },
    internalOnlyLabel: {
        "id": "issue-attachments-table.internal-only-label",
        "defaultMessage": "Internal only"
    }
});

});

parcelRegister("eRmNV", function(module, exports) {

$parcel$export(module.exports, "transformAttachments", () => $572deed89b77dae6$export$92ba544c979493b4);
$parcel$export(module.exports, "getColumns", () => $572deed89b77dae6$export$978e30a0fb8610d8);
$parcel$export(module.exports, "getOrderFieldFromColumnKey", () => $572deed89b77dae6$export$cb5fcf3aa62ca294);
$parcel$export(module.exports, "getColumnKeyFromOrderField", () => $572deed89b77dae6$export$d4db1a080c785cf8);
/* utils.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5iWql = parcelRequire("5iWql");

var $bbaTG = parcelRequire("bbaTG");

var $i9nBX = parcelRequire("i9nBX");

var $3izHV = parcelRequire("3izHV");

var $4bMjD = parcelRequire("4bMjD");

var $PdmhA = parcelRequire("PdmhA");

var $lkPEe = parcelRequire("lkPEe");

var $7gm9F = parcelRequire("7gm9F");
var $2gYtT = parcelRequire("2gYtT");

var $eRitJ = parcelRequire("eRitJ");

var $8K9kM = parcelRequire("8K9kM");

var $aKP4l = parcelRequire("aKP4l");

var $bmGjb = parcelRequire("bmGjb");

var $OxtDd = parcelRequire("OxtDd");

var $9T569 = parcelRequire("9T569");

var $53gpK = parcelRequire("53gpK");
const $572deed89b77dae6$var$createNameCell = (name, mimetype, isInternalComment, { formatMessage: formatMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "aria-label": `${name} ${isInternalComment ? `- ${formatMessage((0, $9T569.default).internalOnlyLabel)}` : ''}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($572deed89b77dae6$var$NoWrap, {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53gpK.default), {
        text: name,
        mediaType: (0, $3izHV.getMediaTypeFromMimeType)(mimetype == null ? '' : mimetype),
        startFixedChars: 3,
        endFixedChars: 4,
        icon: isInternalComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OxtDd.default), null) : undefined
    })));
const $572deed89b77dae6$var$createDeleteOrGoToCell = (attachmentId, attachmentParent, attachmentParentId, canDeleteAttachment, onDeleteAttachment, onScrollToComments, onScrollToWorklogs, isInModal, issueKey)=>{
    if (attachmentParent === (0, $7gm9F.ATTACHMENT_PARENT_ISSUE)) {
        // no permission to delete attachments
        if (!canDeleteAttachment) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($572deed89b77dae6$var$DeleteOrGoToCellWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bmGjb.default), {
            attachmentId: attachmentId,
            onDeleteAttachment: onDeleteAttachment
        }));
    } // don't show goto button if list view is in modal
    if (isInModal) return null;
     // otherwise in COMMENT/WORKLOG or descritpion/custom field
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($572deed89b77dae6$var$DeleteOrGoToCellWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2gYtT.GoToButton), {
        attachmentParent: attachmentParent,
        attachmentParentId: attachmentParentId,
        attachmentView: (0, $3632aa17cf69c37b$export$fe95a8f0244a32c4),
        onScrollToComments: onScrollToComments,
        onScrollToWorklogs: onScrollToWorklogs,
        issueKey: issueKey,
        attachmentId: attachmentId
    }));
}; /**
    * Download button on attachment table is from Media attachment table. The button and media api will
    * be broken when JWT token is too long. This custom download button is a fallback when original button is broken.
    */ 
const $572deed89b77dae6$export$ad1e1bad76389519 = (id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        testId: `issue-attachments-table.ui.custom-download.${id}`,
        appearance: "subtle",
        href: `/rest/api/3/attachment/content/${id}`,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i9nBX))), {
            label: "download"
        }),
        onClick: (event)=>event.stopPropagation(),
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    minWidth: 'max-content',
                    '&:hover': {
                        background: `var(--ds-background-neutral-hovered, ${0, $PdmhA.N40})`
                    }
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
const $572deed89b77dae6$export$3e2500a1407c32f0 = (containerWidth)=>containerWidth === undefined || containerWidth >= (0, $aKP4l.WIDTH_TO_HIDE_SIZE_COLUMN);
const $572deed89b77dae6$export$92ba544c979493b4 = (0, $5iWql.default)((attachments, totalCount, containerWidth, locale, onDeleteAttachment, canDeleteAttachmentMap, onScrollToWorklogs, onScrollToComments, isInModal, issueKey, intl, isJSM)=>{
    const shouldShowSizeColumn = $572deed89b77dae6$export$3e2500a1407c32f0(containerWidth);
    const shouldShowCustomDownload = (0, $eRitJ.isAttachmentNumberApproachLimit)(totalCount);
    return attachments.map((attachment)=>{
        const isInternalAttachment = attachment.hasRestrictedParent;
        const isHighlightEnabled = isInternalAttachment && isJSM;
        return {
            data: {
                file: $572deed89b77dae6$var$createNameCell(attachment.filename, attachment.mimetype, isInternalAttachment, intl),
                date: (0, $8K9kM.formatWithLocale)(new Date(attachment.createdDate * 1000), 'dd MMM yyyy h:mmaaa', locale),
                ...shouldShowSizeColumn ? {
                    size: (0, $4bMjD.toHumanReadableMediaSize)(attachment.filesize)
                } : {},
                deleteOrGoto: $572deed89b77dae6$var$createDeleteOrGoToCell(attachment.id, attachment.parentName, attachment.parentId, canDeleteAttachmentMap[attachment.id], onDeleteAttachment, onScrollToComments, onScrollToWorklogs, isInModal, issueKey),
                ...shouldShowCustomDownload ? {
                    customDownload: $572deed89b77dae6$export$ad1e1bad76389519(attachment.id)
                } : {}
            },
            identifier: {
                mediaItemType: 'file',
                id: attachment.mediaApiFileId
            },
            rowProps: {
                className: isHighlightEnabled ? (0, $aKP4l.ROW_HIGHLIGHT_CLASSNAME) : ''
            }
        };
    });
});
const $572deed89b77dae6$export$978e30a0fb8610d8 = (totalCount, containerWidth, { formatMessage: formatMessage })=>({
        cells: [
            {
                key: (0, $aKP4l.LIST_VIEW_COLUMN_KEYS).FILE,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($572deed89b77dae6$var$NoWrap, null, formatMessage((0, $9T569.default).fileName)),
                isSortable: true
            },
            ...$572deed89b77dae6$export$3e2500a1407c32f0(containerWidth) ? [
                {
                    key: (0, $aKP4l.LIST_VIEW_COLUMN_KEYS).SIZE,
                    content: formatMessage((0, $9T569.default).size),
                    isSortable: true,
                    inlineStyles: {
                        width: `${(0, $aKP4l.SIZE_COLUMN_WIDTH)}px`
                    }
                }
            ] : [],
            {
                key: (0, $aKP4l.LIST_VIEW_COLUMN_KEYS).DATE,
                content: formatMessage((0, $9T569.default).date),
                isSortable: true,
                inlineStyles: {
                    width: `${(0, $aKP4l.DATE_COLUMN_WIDTH)}px`
                }
            },
            {
                key: (0, $aKP4l.LIST_VIEW_COLUMN_KEYS).DELETE_OR_GOTO,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, formatMessage((0, $9T569.default).delete)),
                inlineStyles: {
                    width: `${(0, $aKP4l.DELETE_OR_GOTO_COLUMN_WIDTH)}px`
                },
                width: 10
            },
            {
                key: (0, $eRitJ.isAttachmentNumberApproachLimit)(totalCount) ? (0, $aKP4l.LIST_VIEW_COLUMN_KEYS).CUSTOM_DOWNLOAD : (0, $aKP4l.LIST_VIEW_COLUMN_KEYS).DOWNLOAD,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, formatMessage((0, $9T569.default).download)),
                inlineStyles: {
                    width: `${(0, $aKP4l.DOWNLOAD_COLUMN_WIDTH)}px`
                }
            }
        ]
    });
const $572deed89b77dae6$export$cb5fcf3aa62ca294 = (columnKey)=>{
    switch(columnKey){
        case (0, $aKP4l.LIST_VIEW_COLUMN_KEYS).SIZE:
            return (0, $7gm9F.ORDER_FIELD).FILESIZE;
        case (0, $aKP4l.LIST_VIEW_COLUMN_KEYS).FILE:
            return (0, $7gm9F.ORDER_FIELD).FILENAME;
        default:
            return (0, $7gm9F.ORDER_FIELD).CREATED;
    }
};
const $572deed89b77dae6$export$d4db1a080c785cf8 = (orderField)=>{
    switch(orderField){
        case (0, $7gm9F.ORDER_FIELD).FILESIZE:
            return (0, $aKP4l.LIST_VIEW_COLUMN_KEYS).SIZE;
        case (0, $7gm9F.ORDER_FIELD).FILENAME:
            return (0, $aKP4l.LIST_VIEW_COLUMN_KEYS).FILE;
        case (0, $7gm9F.ORDER_FIELD).CREATED:
            return (0, $aKP4l.LIST_VIEW_COLUMN_KEYS).DATE;
        default:
            // The orderField must be matched
            return undefined;
    }
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $572deed89b77dae6$var$NoWrap = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $572deed89b77dae6$var$DeleteOrGoToCellWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _otyridpf _18u0x0bf _2hwxx0bf _1ul9u6a3 _1cgeidpf _9c8bkb7n _df9okb7n _gs71kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $572deed89b77dae6$export$7ed12d2a5241e393 = {
    NoWrap: $572deed89b77dae6$var$NoWrap
};

});
parcelRegister("4bMjD", function(module, exports) {

$parcel$export(module.exports, "toHumanReadableMediaSize", () => $30cdaafe342086ed$export$9a5a76a6ce88e43d);

var $gRUtg = parcelRequire("gRUtg");
// eslint-disable-next-line no-bitwise
const $30cdaafe342086ed$var$ONE_MEGABYTE_IN_BYTES = 1048576;
function $30cdaafe342086ed$export$9a5a76a6ce88e43d(size) {
    // [MS-967]: Api issue might return string for size
    const parsedSize = parseInt(`${size}`, 10);
    const decimalPlaces = parsedSize < $30cdaafe342086ed$var$ONE_MEGABYTE_IN_BYTES ? 0 : 1;
    return $gRUtg.format(parsedSize, {
        unitSeparator: ' ',
        decimalPlaces: decimalPlaces
    }).toUpperCase();
}

});
parcelRegister("gRUtg", function(module, exports) {
/*!
 * bytes
 * Copyright(c) 2012-2014 TJ Holowaychuk
 * Copyright(c) 2015 Jed Watson
 * MIT Licensed
 */ 'use strict';
/**
 * Module exports.
 * @public
 */ module.exports = $c47d668c1c005307$var$bytes;
module.exports.format = $c47d668c1c005307$var$format;
module.exports.parse = $c47d668c1c005307$var$parse;
/**
 * Module variables.
 * @private
 */ var $c47d668c1c005307$var$formatThousandsRegExp = /\B(?=(\d{3})+(?!\d))/g;
var $c47d668c1c005307$var$formatDecimalsRegExp = /(?:\.0*|(\.[^0]+)0+)$/;
var $c47d668c1c005307$var$map = {
    b: 1,
    kb: 1024,
    mb: 1048576,
    gb: 1073741824,
    tb: Math.pow(1024, 4),
    pb: Math.pow(1024, 5)
};
var $c47d668c1c005307$var$parseRegExp = /^((-|\+)?(\d+(?:\.\d+)?)) *(kb|mb|gb|tb|pb)$/i;
/**
 * Convert the given value in bytes into a string or parse to string to an integer in bytes.
 *
 * @param {string|number} value
 * @param {{
 *  case: [string],
 *  decimalPlaces: [number]
 *  fixedDecimals: [boolean]
 *  thousandsSeparator: [string]
 *  unitSeparator: [string]
 *  }} [options] bytes options.
 *
 * @returns {string|number|null}
 */ function $c47d668c1c005307$var$bytes(value, options) {
    if (typeof value === 'string') return $c47d668c1c005307$var$parse(value);
    if (typeof value === 'number') return $c47d668c1c005307$var$format(value, options);
    return null;
}
/**
 * Format the given value in bytes into a string.
 *
 * If the value is negative, it is kept as such. If it is a float,
 * it is rounded.
 *
 * @param {number} value
 * @param {object} [options]
 * @param {number} [options.decimalPlaces=2]
 * @param {number} [options.fixedDecimals=false]
 * @param {string} [options.thousandsSeparator=]
 * @param {string} [options.unit=]
 * @param {string} [options.unitSeparator=]
 *
 * @returns {string|null}
 * @public
 */ function $c47d668c1c005307$var$format(value, options) {
    if (!Number.isFinite(value)) return null;
    var mag = Math.abs(value);
    var thousandsSeparator = options && options.thousandsSeparator || '';
    var unitSeparator = options && options.unitSeparator || '';
    var decimalPlaces = options && options.decimalPlaces !== undefined ? options.decimalPlaces : 2;
    var fixedDecimals = Boolean(options && options.fixedDecimals);
    var unit = options && options.unit || '';
    if (!unit || !$c47d668c1c005307$var$map[unit.toLowerCase()]) {
        if (mag >= $c47d668c1c005307$var$map.pb) unit = 'PB';
        else if (mag >= $c47d668c1c005307$var$map.tb) unit = 'TB';
        else if (mag >= $c47d668c1c005307$var$map.gb) unit = 'GB';
        else if (mag >= $c47d668c1c005307$var$map.mb) unit = 'MB';
        else if (mag >= $c47d668c1c005307$var$map.kb) unit = 'KB';
        else unit = 'B';
    }
    var val = value / $c47d668c1c005307$var$map[unit.toLowerCase()];
    var str = val.toFixed(decimalPlaces);
    if (!fixedDecimals) str = str.replace($c47d668c1c005307$var$formatDecimalsRegExp, '$1');
    if (thousandsSeparator) str = str.split('.').map(function(s, i) {
        return i === 0 ? s.replace($c47d668c1c005307$var$formatThousandsRegExp, thousandsSeparator) : s;
    }).join('.');
    return str + unitSeparator + unit;
}
/**
 * Parse the string value into an integer in bytes.
 *
 * If no unit is given, it is assumed the value is in bytes.
 *
 * @param {number|string} val
 *
 * @returns {number|null}
 * @public
 */ function $c47d668c1c005307$var$parse(val) {
    if (typeof val === 'number' && !isNaN(val)) return val;
    if (typeof val !== 'string') return null;
    // Test if the string passed is valid
    var results = $c47d668c1c005307$var$parseRegExp.exec(val);
    var floatValue;
    var unit = 'b';
    if (!results) {
        // Nothing could be extracted from the given string
        floatValue = parseInt(val, 10);
        unit = 'b';
    } else {
        // Retrieve the value and the unit
        floatValue = parseFloat(results[1]);
        unit = results[4].toLowerCase();
    }
    if (isNaN(floatValue)) return null;
    return Math.floor($c47d668c1c005307$var$map[unit] * floatValue);
}

});


parcelRegister("bmGjb", function(module, exports) {

$parcel$export(module.exports, "default", () => $28a56ca0bc198ed4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");

var $fEMj1 = parcelRequire("fEMj1");

var $PdmhA = parcelRequire("PdmhA");

var $4ksts = parcelRequire("4ksts");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $aA58Z = parcelRequire("aA58Z");
const $28a56ca0bc198ed4$var$DeleteButton = ({ attachmentId: attachmentId, onDeleteAttachment: onDeleteAttachment })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        event.stopPropagation();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'deleteAttachment');
        onDeleteAttachment(attachmentId);
    }, [
        attachmentId,
        createAnalyticsEvent,
        onDeleteAttachment
    ]);
    const onKeyPress = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter') event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        testId: `issue-attachments-table.ui.delete-button.custom-theme-button.${attachmentId}`,
        appearance: "subtle",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fEMj1))), {
            label: intl.formatMessage((0, $aA58Z.default).delete)
        }),
        onClick: onClick,
        onKeyPress: onKeyPress,
        // @ts-expect-error - TS2322 - Type '(current: (props: ThemeProps) => ThemeTokens, themeProps: ThemeProps) => { accentColor?: string | string[] | undefined; alignContent?: string | string[] | undefined; ... 909 more ...; buttonStyles: { ...; }; }' is not assignable to type '(current: (props: ThemeProps) => ThemeTokens, props: ThemeProps) => ThemeTokens'.
        theme: (current, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    display: 'flex',
                    justifyContent: 'center',
                    '&:hover': {
                        background: `var(--ds-background-neutral-hovered, ${0, $PdmhA.N40})`
                    },
                    margin: '0'
                },
                ...spinnerStyles
            };
        },
        interactionName: "auto-generated.jira-issue-attachments-table.ui.delete-button.button"
    });
};
var $28a56ca0bc198ed4$export$2e2bcd8739ae039 = $28a56ca0bc198ed4$var$DeleteButton;

});
parcelRegister("aA58Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c969c087e246bbb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1c969c087e246bbb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    delete: {
        "id": "issue-attachments-table.delete-button.delete",
        "defaultMessage": "Delete attachment"
    }
});

});


parcelRegister("OxtDd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1764b47ee9a99824$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $f4A0J = parcelRequire("f4A0J");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9T569 = parcelRequire("9T569");
const $1764b47ee9a99824$export$4fe0915af6278d9a = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const internalOnlyLabel = formatMessage((0, $9T569.default).internalOnlyLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: internalOnlyLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1764b47ee9a99824$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4A0J))), {
        testId: "issue-attachments-table.ui.lock-icon.lock-icon",
        primaryColor: `var(--ds-icon, ${(0, $PdmhA).DN80A})`,
        label: internalOnlyLabel
    })));
};
var $1764b47ee9a99824$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $1764b47ee9a99824$export$4fe0915af6278d9a;
const $1764b47ee9a99824$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _ae4v1h6o _4cvr1h6o _u5f31b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("53gpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $cae3dd7e7ad37480$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // TODO: this file is temporary and will be removed as part of BENTO-8784

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eqeVB = parcelRequire("eqeVB");

var $hXzqG = parcelRequire("hXzqG");

var $8cU5f = parcelRequire("8cU5f");
const $cae3dd7e7ad37480$export$2e923ef80ad8608a = ({ mediaType: mediaType, icon: icon, text: text, startFixedChars: startFixedChars, endFixedChars: endFixedChars })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cae3dd7e7ad37480$var$NameCellWrapper, null, mediaType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eqeVB.MediaTypeIcon), {
        type: mediaType
    }), icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cae3dd7e7ad37480$var$TruncateWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: text,
        testId: "issue-attachments-table.ui.name-cell-temporary.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hXzqG.Truncate), {
        text: text,
        startFixedChars: startFixedChars,
        endFixedChars: endFixedChars
    }))));
var $cae3dd7e7ad37480$export$2e2bcd8739ae039 = $cae3dd7e7ad37480$export$2e923ef80ad8608a;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cae3dd7e7ad37480$var$NameCellWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _ae4v1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $cae3dd7e7ad37480$var$TruncateWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9idpf _1bsb1osq _ma9t1dk0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eqeVB", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $a7ff12d042b27ab2$export$be58b4326e23250f);
$parcel$export(module.exports, "MediaTypeIcon", () => $a7ff12d042b27ab2$export$3787195047fd197b);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $exJuA = parcelRequire("exJuA");

var $g10Wy = parcelRequire("g10Wy");

var $5oHa1 = parcelRequire("5oHa1");

var $8i8pd = parcelRequire("8i8pd");

var $htZDA = parcelRequire("htZDA");

var $jn4Q1 = parcelRequire("jn4Q1");

var $gHT17 = parcelRequire("gHT17");

var $cOsqE = parcelRequire("cOsqE");

var $ax6gr = parcelRequire("ax6gr");

var $8DjS6 = parcelRequire("8DjS6");

var $33pqc = parcelRequire("33pqc");

var $avXTG = parcelRequire("avXTG");

var $hC3Rz = parcelRequire("hC3Rz");
const $a7ff12d042b27ab2$export$be58b4326e23250f = (0, $exJuA.default).span({
    display: 'inline-flex'
}, ({ size: size })=>size === 'large' ? `padding: 4px;` : '');
$a7ff12d042b27ab2$export$be58b4326e23250f.displayName = 'IconWrapper';
const $a7ff12d042b27ab2$var$largeIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($g10Wy))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($5oHa1))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($8i8pd))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($htZDA))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($jn4Q1))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($gHT17)))
};
const $a7ff12d042b27ab2$var$smallIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($cOsqE))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($ax6gr))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($8DjS6))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($33pqc))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($avXTG))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($hC3Rz)))
};
const $a7ff12d042b27ab2$var$defaultType = 'unknown';
class $a7ff12d042b27ab2$export$3787195047fd197b extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { type: type, size: size, testId: testId } = this.props;
        const typeWithDefault = type || $a7ff12d042b27ab2$var$defaultType;
        const icons = size === 'large' ? $a7ff12d042b27ab2$var$largeIcons : $a7ff12d042b27ab2$var$smallIcons;
        const Icon = icons[typeWithDefault] || icons[$a7ff12d042b27ab2$var$defaultType];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7ff12d042b27ab2$export$be58b4326e23250f, {
            "data-testid": testId,
            "data-type": type,
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            label: "media-type"
        }));
    }
}
(0, $5zQU9.default)($a7ff12d042b27ab2$export$3787195047fd197b, "defaultProps", {
    type: $a7ff12d042b27ab2$var$defaultType,
    testId: 'file-type-icon',
    size: 'large'
});

});
parcelRegister("g10Wy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ba8d78abd7607be5$var$_react = $ba8d78abd7607be5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ba8d78abd7607be5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ba8d78abd7607be5$var$Image24Icon = (props)=>/*#__PURE__*/ $ba8d78abd7607be5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FFAB00" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm7 17l-1.293-1.293a1 1 0 00-1.414 0L4 19h16v-3.6l-3.295-3.624a1 1 0 00-1.447-.034L10 17zm-3.333-6.667a2.667 2.667 0 100-5.333 2.667 2.667 0 000 5.333z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$ba8d78abd7607be5$var$Image24Icon.displayName = 'Image24Icon';
var $ba8d78abd7607be5$var$_default = $ba8d78abd7607be5$var$Image24Icon;
module.exports.default = $ba8d78abd7607be5$var$_default;

});

parcelRegister("5oHa1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3ee0ac6ef1a39dc8$var$_react = $3ee0ac6ef1a39dc8$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $3ee0ac6ef1a39dc8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3ee0ac6ef1a39dc8$var$Audio24Icon = (props)=>/*#__PURE__*/ $3ee0ac6ef1a39dc8$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm16 6.673V5.619c0-.38-.322-.656-.72-.615l-8.56.886c-.41.043-.72.383-.72.764v6.462A2.8 2.8 0 008.2 13h-.4A2.8 2.8 0 005 15.8v.4A2.8 2.8 0 007.8 19h.4a2.8 2.8 0 002.8-2.8V8.863l6-.62v3.873a2.8 2.8 0 00-.8-.116h-.4a2.8 2.8 0 00-2.8 2.8v.4a2.8 2.8 0 002.8 2.8h.4a2.8 2.8 0 002.8-2.8V6.673z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$3ee0ac6ef1a39dc8$var$Audio24Icon.displayName = 'Audio24Icon';
var $3ee0ac6ef1a39dc8$var$_default = $3ee0ac6ef1a39dc8$var$Audio24Icon;
module.exports.default = $3ee0ac6ef1a39dc8$var$_default;

});

parcelRegister("8i8pd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6096865a1085be43$var$_react = $6096865a1085be43$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6096865a1085be43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6096865a1085be43$var$Video24Icon = (props)=>/*#__PURE__*/ $6096865a1085be43$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1 7.995v8.01c0 .54.446.995.995.995h8.01c.54 0 .995-.446.995-.995v-8.01c0-.54-.446-.995-.995-.995h-8.01C4.455 7 4 7.446 4 7.995zm15.16 7.943c.38.185.84-.066.84-.457V8.52c0-.39-.46-.642-.84-.457L16 9.592v4.817l3.16 1.53z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$6096865a1085be43$var$Video24Icon.displayName = 'Video24Icon';
var $6096865a1085be43$var$_default = $6096865a1085be43$var$Video24Icon;
module.exports.default = $6096865a1085be43$var$_default;

});

parcelRegister("htZDA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $cba4f5002e1f94bd$var$_react = $cba4f5002e1f94bd$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $cba4f5002e1f94bd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $cba4f5002e1f94bd$var$Document24Icon = (props)=>/*#__PURE__*/ $cba4f5002e1f94bd$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1zm0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1zm0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1zm0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$cba4f5002e1f94bd$var$Document24Icon.displayName = 'Document24Icon';
var $cba4f5002e1f94bd$var$_default = $cba4f5002e1f94bd$var$Document24Icon;
module.exports.default = $cba4f5002e1f94bd$var$_default;

});

parcelRegister("jn4Q1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e1a3eb0cdb8e2ad9$var$_react = $e1a3eb0cdb8e2ad9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e1a3eb0cdb8e2ad9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e1a3eb0cdb8e2ad9$var$Archive24Icon = (props)=>/*#__PURE__*/ $e1a3eb0cdb8e2ad9$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm6 3v3h3V3H9zm3 3v3h3V6h-3zM9 9v3h3V9H9zm3 3v3h3v-3h-3zm-3 3v3h3v-3H9zm3 3v3h3v-3h-3z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e1a3eb0cdb8e2ad9$var$Archive24Icon.displayName = 'Archive24Icon';
var $e1a3eb0cdb8e2ad9$var$_default = $e1a3eb0cdb8e2ad9$var$Archive24Icon;
module.exports.default = $e1a3eb0cdb8e2ad9$var$_default;

});

parcelRegister("gHT17", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c29b56bb8069902e$var$_react = $c29b56bb8069902e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c29b56bb8069902e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c29b56bb8069902e$var$Generic24Icon = (props)=>/*#__PURE__*/ $c29b56bb8069902e$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2v-6.995h-2V18H8V6h4v2a2 2 0 002 2h3.5a.5.5 0 00.5-.5V8.213a.5.5 0 00-.145-.352L14.61 4.59A2 2 0 0013.19 4H12zM3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c29b56bb8069902e$var$Generic24Icon.displayName = 'Generic24Icon';
var $c29b56bb8069902e$var$_default = $c29b56bb8069902e$var$Generic24Icon;
module.exports.default = $c29b56bb8069902e$var$_default;

});

parcelRegister("cOsqE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $954034ec6542912b$var$_react = $954034ec6542912b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $954034ec6542912b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $954034ec6542912b$var$Image16Icon = (props)=>/*#__PURE__*/ $954034ec6542912b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FFAB00" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm4.75 11.75l-.543-.543a1 1 0 00-1.414 0L3 13h10v-2.25l-1.795-1.974a1 1 0 00-1.447-.034L6.75 11.75zM4.667 6.333a1.667 1.667 0 100-3.333 1.667 1.667 0 000 3.333z"/></svg>`
    }, props, {
        size: 'small'
    }));
$954034ec6542912b$var$Image16Icon.displayName = 'Image16Icon';
var $954034ec6542912b$var$_default = $954034ec6542912b$var$Image16Icon;
module.exports.default = $954034ec6542912b$var$_default;

});

parcelRegister("ax6gr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7ab1d85c6664da9b$var$_react = $7ab1d85c6664da9b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $7ab1d85c6664da9b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7ab1d85c6664da9b$var$Audio16Icon = (props)=>/*#__PURE__*/ $7ab1d85c6664da9b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm11 4.195v-.753c0-.271-.23-.468-.514-.44l-6.115.634a.565.565 0 00-.514.545v4.616a2 2 0 00-.571-.083H5a2 2 0 00-2 2V11a2 2 0 002 2h.286a2 2 0 002-2V5.76l4.285-.444v2.767A2 2 0 0011 8h-.286a2 2 0 00-2 2v.286a2 2 0 002 2H11a2 2 0 002-2V4.195z"/></svg>`
    }, props, {
        size: 'small'
    }));
$7ab1d85c6664da9b$var$Audio16Icon.displayName = 'Audio16Icon';
var $7ab1d85c6664da9b$var$_default = $7ab1d85c6664da9b$var$Audio16Icon;
module.exports.default = $7ab1d85c6664da9b$var$_default;

});

parcelRegister("8DjS6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $64916155d728965b$var$_react = $64916155d728965b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $64916155d728965b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $64916155d728965b$var$Video16Icon = (props)=>/*#__PURE__*/ $64916155d728965b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm11.37 10.954c.285.138.63-.05.63-.343V5.39c0-.293-.345-.481-.63-.343L11 6.194v3.613l2.37 1.147zM2 5.99v4.018c0 .54.449.991 1.003.991h4.994A.99.99 0 009 10.01V5.99C9 5.452 8.551 5 7.997 5H3.003A.99.99 0 002 5.99z"/></svg>`
    }, props, {
        size: 'small'
    }));
$64916155d728965b$var$Video16Icon.displayName = 'Video16Icon';
var $64916155d728965b$var$_default = $64916155d728965b$var$Video16Icon;
module.exports.default = $64916155d728965b$var$_default;

});

parcelRegister("avXTG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7a7b42f6d77c905a$var$_react = $7a7b42f6d77c905a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $7a7b42f6d77c905a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7a7b42f6d77c905a$var$Archive16Icon = (props)=>/*#__PURE__*/ $7a7b42f6d77c905a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm4 3v2h2V3H6zm2 2v2h2V5H8zM6 7v2h2V7H6zm2 2v2h2V9H8zm-2.307 2v2h2v-2h-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$7a7b42f6d77c905a$var$Archive16Icon.displayName = 'Archive16Icon';
var $7a7b42f6d77c905a$var$_default = $7a7b42f6d77c905a$var$Archive16Icon;
module.exports.default = $7a7b42f6d77c905a$var$_default;

});


parcelRegister("hXzqG", function(module, exports) {

$parcel$export(module.exports, "Truncate", () => $d1336dde52b0d3e8$export$cf4c160b6f7612df);

var $eUqFw = parcelRequire("eUqFw");

var $exJuA = parcelRequire("exJuA");
const $d1336dde52b0d3e8$var$truncateCommonStyles = `
  display: inline-block;
  vertical-align: bottom;
  white-space: nowrap;
  overflow: hidden;
`;
const $d1336dde52b0d3e8$export$79559b74b73162c4 = (0, $exJuA.default).span`
  ${$d1336dde52b0d3e8$var$truncateCommonStyles}
  max-width: calc(100% - ${({ fontSizePX: fontSizePX, endFixedChars: endFixedChars })=>$d1336dde52b0d3e8$var$fontFaceScaleFactor(fontSizePX) * endFixedChars + 1}em);
  min-width: ${({ fontSizePX: fontSizePX, startFixedChars: startFixedChars })=>$d1336dde52b0d3e8$var$fontFaceScaleFactor(fontSizePX) * startFixedChars};
  text-overflow: ellipsis;
`;
const $d1336dde52b0d3e8$export$59f20ffe54d328be = (0, $exJuA.default).span`
  ${$d1336dde52b0d3e8$var$truncateCommonStyles}
  max-width: calc(100% - ${({ fontSizePX: fontSizePX, startFixedChars: startFixedChars })=>$d1336dde52b0d3e8$var$fontFaceScaleFactor(fontSizePX) * startFixedChars});
  position: relative;
`;
const $d1336dde52b0d3e8$export$76bc6de55c805afb = (text, startFixedChars, endFixedChars)=>{
    const minAllowedLength = endFixedChars + startFixedChars;
    if (text.length <= minAllowedLength) // if no truncation return same value for left and right
    return {
        left: text,
        right: text
    };
    const splitAt = text.length - endFixedChars;
    const left = text.substr(0, splitAt);
    const right = text.substr(splitAt);
    return {
        left: left,
        right: right
    };
};
const $d1336dde52b0d3e8$var$fontFaceScaleFactor = (fontSizePX)=>fontSizePX / 11 * 0.46; /* factor for fontSize of 11px */ 
const $d1336dde52b0d3e8$export$cf4c160b6f7612df = ({ text: text, fontSizePX: fontSizePX = 11, startFixedChars: // Must be calibrated with fontSize
startFixedChars = 4, endFixedChars: // 1 char + 3 dots
endFixedChars = 7 // file extension 3/4 chars + a fraction of the name
 })=>{
    const { left: leftStr, right: rightStr } = $d1336dde52b0d3e8$export$76bc6de55c805afb(text, startFixedChars, endFixedChars);
    if (leftStr === rightStr) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d1336dde52b0d3e8$export$79559b74b73162c4, {
        fontSizePX: fontSizePX,
        startFixedChars: startFixedChars,
        endFixedChars: endFixedChars
    }, leftStr), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d1336dde52b0d3e8$export$59f20ffe54d328be, {
        fontSizePX: fontSizePX,
        startFixedChars: startFixedChars,
        endFixedChars: endFixedChars
    }, rightStr));
};

});







parcelRegister("dLgKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $71c2780b5d9f81a5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");

var $5YsMl = parcelRequire("5YsMl");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $kGQen = parcelRequire("kGQen");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $sAGwU = parcelRequire("sAGwU");
var $b0Yte = parcelRequire("b0Yte");
var $kUI0A = parcelRequire("kUI0A");

var $hJ992 = parcelRequire("hJ992");

var $1ik7t = parcelRequire("1ik7t");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $1xtD3 = parcelRequire("1xtD3");
const $71c2780b5d9f81a5$var$Dialog = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ value: { totalCount: totalCountRaw, deletableCount: deletableCountRaw } }, { refreshAttachments: refreshAttachments }] = (0, $kUI0A.useIssueAttachments)(issueKey);
    const [isDialogOpen, { setDeleteAllDialogOpen: setDeleteAllDialogOpen }] = (0, $sAGwU.useDialogStatus)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [{ isDeleting: isDeleting, error: deleteError }, makeDeleteAllRequest] = (0, $b0Yte.useDeleteAllService)(issueKey);
    let deletableCount = 0;
    if ((0, $1ybV0.ff)('issue.details.gira-agg-migration-attachments_ecebe')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [{ value: value }] = (0, $1ik7t.default)(issueKey);
        deletableCount = typeof value === 'number' ? value : 0;
    } else // BE can temporarily return -1, so we safeguard it with `<= 0`
    deletableCount = typeof deletableCountRaw === 'number' ? deletableCountRaw : 0;
    const totalCount = typeof totalCountRaw === 'number' ? totalCountRaw : 0;
    const canDeleteAll = deletableCount === totalCount;
    (0, $eUqFw.useEffect)(()=>{
        if (deleteError) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.attachments.delete-all', deleteError.message || deleteError.toString());
            (0, $guiFP.default)({
                error: deleteError,
                meta: {
                    id: 'deleteAllDialog',
                    // eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics
                    packageName: 'jiraIssueView',
                    teamName: 'bento'
                }
            });
            showFlag({
                type: 'error',
                title: (0, $1xtD3.default).deleteAllFailedNotificationTitle,
                description: [
                    (0, $1xtD3.default).deleteAllFailedNotificationDescription,
                    {
                        issueKey: issueKey
                    }
                ],
                isAutoDismiss: true
            });
        }
    }, [
        deleteError,
        issueKey,
        showFlag
    ]);
    const onDelete = (0, $eUqFw.useCallback)(()=>{
        const didSucceed = makeDeleteAllRequest();
        const analyticsEvent = createAnalyticsEvent({
            action: 'submitted',
            actionSubject: 'form'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'deleteAllAttachmentsDialog', {
            deletableCount: deletableCount
        }); // @ts-expect-error - TS2801 - This condition will always return true since this 'Promise<void>' is always defined.
        if (didSucceed) refreshAttachments(issueKey);
    }, [
        createAnalyticsEvent,
        deletableCount,
        issueKey,
        makeDeleteAllRequest,
        refreshAttachments
    ]);
    const onCancel = (0, $eUqFw.useCallback)(()=>{
        setDeleteAllDialogOpen(false);
        const analyticsEvent = createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'modalDialog'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'deleteAllAttachmentsDialog', {
            deletableCount: deletableCount
        });
    }, [
        createAnalyticsEvent,
        deletableCount,
        setDeleteAllDialogOpen
    ]);
    const getMessage = (0, $eUqFw.useCallback)(()=>{
        if (canDeleteAll) return deletableCount === 1 ? formatMessage((0, $1xtD3.default).deletingAllAttachmentsMessageSingle) : formatMessage((0, $1xtD3.default).deletingAllAttachmentsMessage, {
            deletableCount: deletableCount
        });
        return formatMessage((0, $1xtD3.default).deletingSomeAttachmentsMessage);
    }, [
        canDeleteAll,
        deletableCount,
        formatMessage
    ]);
    if (typeof totalCount !== 'number' || deletableCount === 0 || !isDialogOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "small",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        isMultiline: false,
        appearance: "danger"
    }, formatMessage((0, $1xtD3.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, !canDeleteAll && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($71c2780b5d9f81a5$var$WarningContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y500})`,
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $71c2780b5d9f81a5$var$warningMessageStyles
    }, formatMessage((0, $1xtD3.default).deleteDetailsMessage, {
        nonDeletableCount: totalCount - deletableCount
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, getMessage())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onDelete,
        isDisabled: isDeleting,
        appearance: "danger",
        interactionName: "auto-generated.jira-issue-view-base.content.attachment.delete-all-dialog.button"
    }, isDeleting ? formatMessage((0, $1xtD3.default).deletingButton) : formatMessage((0, $1xtD3.default).deleteButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onCancel,
        appearance: "subtle",
        interactionName: "auto-generated.jira-issue-view-base.content.attachment.delete-all-dialog.button1"
    }, formatMessage((0, $1xtD3.default).cancelButton))))));
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$71c2780b5d9f81a5$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($71c2780b5d9f81a5$var$Dialog);
const $71c2780b5d9f81a5$var$WarningContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk8jms _1e0c1txw _otyrpxbi _1yt4u2gc",
            __cmplp.className
        ])
    });
});
const $71c2780b5d9f81a5$var$warningMessageStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.100'
});

});
parcelRegister("sAGwU", function(module, exports) {

$parcel$export(module.exports, "useDialogStatus", () => $469253c92f995bb3$export$8f85e06563acc5f4);

var $ggKAj = parcelRequire("ggKAj");

var $6tkcD = parcelRequire("6tkcD");
const $469253c92f995bb3$var$getIsDialogOpen = (state)=>state.meta.isDeleteAllDialogOpen;
const $469253c92f995bb3$export$8f85e06563acc5f4 = (0, $ggKAj.createHook)((0, $6tkcD.store), {
    selector: $469253c92f995bb3$var$getIsDialogOpen
});

});

parcelRegister("b0Yte", function(module, exports) {

$parcel$export(module.exports, "useDeleteAllService", () => $3ac078dd8d7ab68a$export$e93c360b1673a98a);

var $eUqFw = parcelRequire("eUqFw");

var $lRmyA = parcelRequire("lRmyA");

var $kUI0A = parcelRequire("kUI0A");

var $sAGwU = parcelRequire("sAGwU");
const $3ac078dd8d7ab68a$export$d4c72bab9d6cc13a = {
    isDeleting: false,
    didDelete: false,
    error: undefined
};
const $3ac078dd8d7ab68a$export$ef1138f2ecde297c = (baseUrl, issueKey)=>`${baseUrl}/rest/api/2/issue/${issueKey}/attachments`;
const $3ac078dd8d7ab68a$export$e93c360b1673a98a = (issueKey)=>{
    const [isDialogOpen, { setDeleteAllDialogOpen: setDeleteAllDialogOpen }] = (0, $sAGwU.useDialogStatus)();
    const [, { refreshAttachments: refreshAttachments }] = (0, $kUI0A.useIssueAttachmentsActions)();
    const [state, setState] = (0, $eUqFw.useState)($3ac078dd8d7ab68a$export$d4c72bab9d6cc13a);
    const baseUrl = '';
    (0, $eUqFw.useEffect)(()=>{
        if (!isDialogOpen) setState($3ac078dd8d7ab68a$export$d4c72bab9d6cc13a);
    }, [
        isDialogOpen
    ]);
    const makeDeleteAllRequest = (0, $eUqFw.useCallback)(async ()=>{
        setState({
            isDeleting: true,
            didDelete: false,
            error: undefined
        });
        try {
            await (0, $lRmyA.performDeleteRequest)($3ac078dd8d7ab68a$export$ef1138f2ecde297c(baseUrl, issueKey));
            setDeleteAllDialogOpen(false);
            refreshAttachments(issueKey);
            setState({
                isDeleting: false,
                didDelete: true,
                error: undefined
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            setState({
                isDeleting: false,
                didDelete: false,
                error: error
            });
        }
    }, [
        baseUrl,
        issueKey,
        refreshAttachments,
        setDeleteAllDialogOpen
    ]);
    return [
        state,
        makeDeleteAllRequest
    ];
};

});

parcelRegister("1ik7t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cf90444e2fb5b7c$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $9sKt4 = parcelRequire("9sKt4");

var $6D0iK = parcelRequire("6D0iK");
const $8cf90444e2fb5b7c$export$540c964c63ff169b = (issueKey)=>{
    const [issueState] = (0, $6D0iK.default)(issueKey);
    const { value: issueData = (0, $9sKt4.emptyIssueData), isReady: isReady = false } = issueState ?? {};
    const { deletableAttachmentsCount: value } = issueData;
    return [
        {
            value: value,
            isReady: isReady
        }
    ];
};
const $8cf90444e2fb5b7c$var$defaultValue = [
    {
        value: undefined,
        isReady: true
    }
];
var $8cf90444e2fb5b7c$export$2e2bcd8739ae039 = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('issue.details.gira-agg-migration-attachments_ecebe'), $8cf90444e2fb5b7c$export$540c964c63ff169b, ()=>$8cf90444e2fb5b7c$var$defaultValue);

});

parcelRegister("1xtD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $01956e2ddc35b3b0$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $01956e2ddc35b3b0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "attachments.delete-all-dialog.heading",
        "defaultMessage": "Delete attachments"
    },
    deleteDetailsMessage: {
        "id": "attachments.delete-all-dialog.delete-details-message",
        "defaultMessage": "You can't delete {nonDeletableCount} of these attachments. Either you don't have permission, or they're in issue fields and comments."
    },
    deletingAllAttachmentsMessage: {
        "id": "attachments.delete-all-dialog.deleting-all-attachments",
        "defaultMessage": "This action will permanently delete all {deletableCount} attachments in the attachments panel."
    },
    deletingAllAttachmentsMessageSingle: {
        "id": "attachments.delete-all-dialog.deleting-all-attachments-single",
        "defaultMessage": "This action will permanently delete the 1 attachment in the attachments panel."
    },
    deletingSomeAttachmentsMessage: {
        "id": "attachments.delete-all-dialog.deleting-some-attachments",
        "defaultMessage": "This action will permanently delete all other attachments in the attachments panel."
    },
    cancelButton: {
        "id": "attachments.delete-all-dialog.cancel-button-label",
        "defaultMessage": "Cancel"
    },
    deleteButton: {
        "id": "attachments.delete-all-dialog.delete-button-label",
        "defaultMessage": "Delete"
    },
    deletingButton: {
        "id": "attachments.delete-all-dialog.deleting-button-label",
        "defaultMessage": "Deleting"
    },
    deleteAllFailedNotificationTitle: {
        "id": "attachments.delete-all-dialog.delete-all-failed-notification-title",
        "defaultMessage": "We couldn\u2019t delete all your attachments"
    },
    deleteAllFailedNotificationDescription: {
        "id": "attachments.delete-all-dialog.delete-all-failed-notification-description",
        "defaultMessage": "We didn\u2019t finish deleting all your attachments for {issueKey}. Check your connection and then try again."
    }
});

});


parcelRegister("cx1N9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d59044822d2b5a36$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9nkwJ = parcelRequire("9nkwJ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iAc02 = parcelRequire("iAc02");

var $f4po5 = parcelRequire("f4po5");

var $6nlQN = parcelRequire("6nlQN");

var $i6wdM = parcelRequire("i6wdM");

var $8Witg = parcelRequire("8Witg");
const $d59044822d2b5a36$export$cda85bac97a53cfd = ({ totalCount: totalCount })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d59044822d2b5a36$var$SectionHeadingWithIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingTitle), {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.issue-base.content.attachment.heading.section-heading-title"
    }, formatMessage((0, $8Witg.default).title, {
        totalCount: ''
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d59044822d2b5a36$var$BadgeWrapper, {
        "data-testid": "issue-view-base.content.attachment.heading.badge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        max: false
    }, totalCount)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6nlQN.default), {
        totalCount: totalCount
    }));
};
const $d59044822d2b5a36$export$a8a3e93435678ff9 = ({ totalCount: totalCount, refreshAttachments: refreshAttachments })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d59044822d2b5a36$export$cda85bac97a53cfd, {
        totalCount: totalCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingIcons), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6wdM.default), {
        refreshAttachments: refreshAttachments
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f4po5.default), null)));
var $d59044822d2b5a36$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d59044822d2b5a36$export$a8a3e93435678ff9;
const $d59044822d2b5a36$var$BadgeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bv1b66",
            __cmplp.className
        ])
    });
});
const $d59044822d2b5a36$var$SectionHeadingWithIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("f4po5", function(module, exports) {

$parcel$export(module.exports, "default", () => $74ae46fbd48301ed$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $81vFI = parcelRequire("81vFI");

var $lqalZ = parcelRequire("lqalZ");

var $1v6Su = parcelRequire("1v6Su");

var $5JqpU = parcelRequire("5JqpU");

var $7SLq9 = parcelRequire("7SLq9");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8Witg = parcelRequire("8Witg");

var $hT217 = parcelRequire("hT217");
const $74ae46fbd48301ed$export$4b2d018160b842d6 = ({ canCreateAttachment: canCreateAttachment, onClick: onClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        onClick();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'addAttachment');
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    if (!canCreateAttachment) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hT217.ButtonWrapper), {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.issue-base.content.attachment.heading.add-attachment.button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $81vFI.default), {
        label: formatMessage((0, $8Witg.default).addAttachmentAriaLabel),
        onClick: handleClick
    }));
};
var $74ae46fbd48301ed$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state)=>({
        canCreateAttachment: !(0, $5JqpU.isServiceDeskSelector)(state) && (0, $7SLq9.canCreateAttachmentsSelector)(state)
    }), {
    onClick: (0, $1v6Su.attachmentPickerPopupOpenSuccess)
})($74ae46fbd48301ed$export$4b2d018160b842d6);

});
parcelRegister("81vFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1b9b9d605525fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $j9fWg = parcelRequire("j9fWg");

var $gO9Xw = parcelRequire("gO9Xw");
function $7e1b9b9d605525fd$export$2e2bcd8739ae039(props) {
    const { label: label, onClick: onClick } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        testId: `issue-view-common-views.button.icon-button.${label}`,
        appearance: "subtle",
        spacing: "compact",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                ...iconProps,
                size: "small"
            }),
        label: label,
        onClick: onClick,
        interactionName: "auto-generated.jira-issue-view-common-views.button.button"
    }));
}
$7e1b9b9d605525fd$export$2e2bcd8739ae039.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};

});

parcelRegister("8Witg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cea09b38c8b6e9a1$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $cea09b38c8b6e9a1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "attachments.heading.title",
        "defaultMessage": "Attachments {totalCount}"
    },
    addAttachmentAriaLabel: {
        "id": "attachments.heading.addAttachmentLabel",
        "defaultMessage": "Add Attachment"
    },
    attachmentsAriaLabel: {
        "id": "attachments.heading.attachmentsLabel",
        "defaultMessage": "More options for attachments"
    }
});

});

parcelRegister("hT217", function(module, exports) {

$parcel$export(module.exports, "ButtonWrapper", () => $8fa20725b2abcd19$export$d53c836cccbb0d90);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8fa20725b2abcd19$export$d53c836cccbb0d90 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u012x7",
            __cmplp.className
        ])
    });
});

});


parcelRegister("6nlQN", function(module, exports) {

$parcel$export(module.exports, "default", () => $de2539a687ac27cc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5YsMl = parcelRequire("5YsMl");

var $3MV1G = parcelRequire("3MV1G");

var $PdmhA = parcelRequire("PdmhA");

var $dnbhd = parcelRequire("dnbhd");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eRitJ = parcelRequire("eRitJ");

var $3Xryo = parcelRequire("3Xryo");
const $de2539a687ac27cc$var$WarningLabel = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($de2539a687ac27cc$var$PopupContent, null, formatMessage((0, $3Xryo.default).warningLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
        href: (0, $eRitJ.ATTACHMENTS_LEARN_ABOUT_LINK)
    }, formatMessage((0, $3Xryo.default).warningLinkLabel)));
};
const $de2539a687ac27cc$export$c3f78ca26cd0c9cb = ({ totalCount: totalCount, defaultIsOpen: defaultIsOpen = false })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(defaultIsOpen);
    if ((0, $eRitJ.isAttachmentNumberApproachLimit)(totalCount) && !(0, $eRitJ.isAttachmentNumberExceedLimit)(totalCount)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: $de2539a687ac27cc$var$WarningLabel,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($de2539a687ac27cc$var$ButtonWithMargin, {
                ...triggerProps,
                testId: "issue.views.issue-base.content.attachment.heading.limit-warning",
                spacing: "none",
                appearance: "subtle-link",
                onClick: ()=>setIsOpen(true),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
                    label: "warning",
                    primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y300})`
                })
            })
    });
    return null;
};
var $de2539a687ac27cc$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $de2539a687ac27cc$export$c3f78ca26cd0c9cb;
const $de2539a687ac27cc$var$PopupContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _p12fp2n4 _1yt4pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $de2539a687ac27cc$var$ButtonWithMargin = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01y44",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dnbhd", function(module, exports) {

$parcel$export(module.exports, "default", () => $92444a2f8aee76e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eGI9v = parcelRequire("eGI9v");

var $kJlBc = parcelRequire("kJlBc");
function $92444a2f8aee76e7$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), rest, children);
}
var $92444a2f8aee76e7$export$2e2bcd8739ae039 = (0, $eGI9v.default)('link', {
    onClick: 'clicked'
})($92444a2f8aee76e7$var$Link);

});

parcelRegister("3Xryo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2f7321c3d70905$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $4e2f7321c3d70905$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    warningLabel: {
        "id": "attachments.heading.title.warning",
        "defaultMessage": "This issue may stop displaying previews and thumbnails if more attachments are added."
    },
    warningLinkLabel: {
        "id": "attachments.heading.title.warning.link",
        "defaultMessage": "Learn about attachments"
    }
});

});


parcelRegister("i6wdM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d659761f6d4c30cd$export$2e2bcd8739ae039);

var $lqalZ = parcelRequire("lqalZ");

var $jZDJX = parcelRequire("jZDJX");

var $a4dIN = parcelRequire("a4dIN");
var $d659761f6d4c30cd$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state)=>({
        isPreview: (0, $jZDJX.isPreviewSelector)(state)
    }), {})((0, $a4dIN.default));

});
parcelRegister("a4dIN", function(module, exports) {

$parcel$export(module.exports, "default", () => $609e50f32179b5db$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $fEubG = parcelRequire("fEubG");

var $jG1wZ = parcelRequire("jG1wZ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $8Witg = parcelRequire("8Witg");

var $aGxay = parcelRequire("aGxay");

var $lPSOf = parcelRequire("lPSOf");

var $jZX5U = parcelRequire("jZX5U");
const $609e50f32179b5db$var$MeatBalls = ({ refreshAttachments: refreshAttachments, isPreview: isPreview, defaultOpen: defaultOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderDropdownMenuButton = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'triggerRef' implicitly has an 'any' type.
    ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "compact",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                size: "small",
                label: formatMessage((0, $8Witg.default).attachmentsAriaLabel)
            }),
            isDisabled: isPreview,
            ref: triggerRef,
            interactionName: "auto-generated.jira-issue-view-base.content.attachment.heading.meatballs.button"
        }), [
        formatMessage,
        isPreview
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        defaultOpen: defaultOpen,
        placement: "bottom-end",
        trigger: renderDropdownMenuButton,
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.content.attachment.heading.meatballs.drop-down"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jZX5U.default), {
        refreshAttachments: refreshAttachments
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lPSOf.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aGxay.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (analyticsEvent)=>(0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'AttachmentListViewOnboarding mounted')
    }));
};
var $609e50f32179b5db$export$2e2bcd8739ae039 = $609e50f32179b5db$var$MeatBalls;

});
parcelRegister("aGxay", function(module, exports) {

$parcel$export(module.exports, "default", () => $05ae56617cfd3e13$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $sAGwU = parcelRequire("sAGwU");
var $kUI0A = parcelRequire("kUI0A");

var $hJ992 = parcelRequire("hJ992");

var $1ik7t = parcelRequire("1ik7t");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $36VQz = parcelRequire("36VQz");
const $05ae56617cfd3e13$var$DeleteAllItem = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setDeleteAllDialogOpen: setDeleteAllDialogOpen }] = (0, $sAGwU.useDialogStatus)();
    let deletableCount;
    if ((0, $1ybV0.ff)('issue.details.gira-agg-migration-attachments_ecebe')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        [{ value: deletableCount }] = (0, $1ik7t.default)(issueKey);
        // BE can temporarily return -1, so we safeguard it with `<= 0`
        if (typeof deletableCount !== 'number' || deletableCount <= 0) return null;
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [{ value: value }] = (0, $kUI0A.useIssueAttachments)(issueKey);
        // BE can temporarily return -1, so we safeguard it with `<= 0`
        if (typeof value.deletableCount !== 'number' || value.deletableCount <= 0) return null;
        deletableCount = value.deletableCount;
    }
    const onClick = ()=>{
        setDeleteAllDialogOpen(true);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'deleteAllAttachmentsDialog', {
            deletableCount: deletableCount
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        key: "delete-all-attachments",
        onClick: onClick,
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.content.attachment.heading.meatballs.delete-all-item.dropdown-item"
    }, formatMessage((0, $36VQz.default).deleteAll));
};
var $05ae56617cfd3e13$export$2e2bcd8739ae039 = $05ae56617cfd3e13$var$DeleteAllItem;

});
parcelRegister("36VQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb5ee6ca09929cb4$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $bb5ee6ca09929cb4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    deleteAll: {
        "id": "attachments.heading.delete-all",
        "defaultMessage": "Delete all"
    }
});

});


parcelRegister("lPSOf", function(module, exports) {

$parcel$export(module.exports, "default", () => $975eaff60a62b757$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9nkwJ = parcelRequire("9nkwJ");

var $hD6GJ = parcelRequire("hD6GJ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aoWBy = parcelRequire("aoWBy");
var $kUI0A = parcelRequire("kUI0A");

var $lqalZ = parcelRequire("lqalZ");

var $5JqpU = parcelRequire("5JqpU");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ixHyb = parcelRequire("ixHyb");
const $975eaff60a62b757$export$9524e33dd8faad4a = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { issueId: issueId, issueKey: issueKey } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    if (!issueId) return null;
    const [{ value: { totalCount: totalCount } }] = // go/jfe-eslint
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kUI0A.useIssueAttachments)(issueKey);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [isDownloading, makeDownloadRequest] = (0, $aoWBy.useDownloadAllService)(issueId, issueKey);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const onClick = (0, $eUqFw.useCallback)(()=>{
        makeDownloadRequest();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'downloadAllAttachments', {
            totalMedia: totalCount
        });
    }, [
        createAnalyticsEvent,
        makeDownloadRequest,
        totalCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        key: "download-all-attachments",
        onClick: onClick,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), null, totalCount),
        isDisabled: isDownloading,
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.content.attachment.heading.meatballs.download-all-item.dropdown-item"
    }, isDownloading ? formatMessage((0, $ixHyb.default).downloading) : formatMessage((0, $ixHyb.default).downloadAll));
});
var $975eaff60a62b757$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state)=>({
        issueId: (0, $5JqpU.issueIdSelector)(state),
        issueKey: (0, $5JqpU.issueKeySelector)(state)
    }), {})($975eaff60a62b757$export$9524e33dd8faad4a);

});
parcelRegister("aoWBy", function(module, exports) {

$parcel$export(module.exports, "useDownloadAllService", () => $f3ca17dd414327db$export$61a870283510534c);

var $eUqFw = parcelRequire("eUqFw");

var $fG8Rc = parcelRequire("fG8Rc");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fAnID = parcelRequire("fAnID");

var $jGRid = parcelRequire("jGRid");
const $f3ca17dd414327db$export$61a870283510534c = (issueId, issueKey)=>{
    const fileName = `${issueKey}_attachments.zip`;
    const [isDownloading, { setIsDownloading: setIsDownloading }] = (0, $jGRid.useDownloadStatus)(issueKey);
    const baseUrl = '';
    const requestUrl = `${baseUrl}/secure/issueAttachments/${issueId}.zip`;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const flagErrorId = (0, $eUqFw.useRef)();
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    let onTryAgainClicked = (0, $eUqFw.useCallback)(()=>{}, []);
    const onDismissFlag = (0, $eUqFw.useCallback)(()=>{
        if (flagErrorId.current) // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string'.
        dismissFlag(flagErrorId.current);
    }, [
        dismissFlag
    ]);
    const onFailure = (0, $eUqFw.useCallback)((error, locationId)=>{
        let statusCode = null;
        let errorMessage = error.toString();
        if (error instanceof (0, $7byHA.default)) {
            statusCode = error.statusCode;
            errorMessage = error.message;
        }
        setIsDownloading(issueKey, false);
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: locationId,
                packageName: 'jiraIssueAttachmentsBase',
                teamName: 'bento'
            }
        });
        (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.attachments.download-all', errorMessage);
        const flagErrorMessage = statusCode === 500 ? (0, $fAnID.default).downloadFailedExceedFileSizeDescription : (0, $fAnID.default).downloadFailedDescription;
        flagErrorId.current = showFlag({
            type: 'error',
            title: (0, $fAnID.default).downloadFailedTitle,
            description: [
                flagErrorMessage,
                {
                    issueKey: issueKey
                }
            ],
            actions: [
                {
                    onClick: onTryAgainClicked,
                    content: (0, $fAnID.default).tryAgain
                }
            ]
        });
    }, [
        issueKey,
        onTryAgainClicked,
        setIsDownloading,
        showFlag
    ]);
    const makeDownloadRequest = (0, $eUqFw.useCallback)(async ()=>{
        setIsDownloading(issueKey, true);
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'downloadAll requested');
        showFlag({
            type: 'success',
            title: (0, $fAnID.default).downloadStartTitle,
            description: (0, $fAnID.default).downloadStartDescription,
            isAutoDismiss: true
        });
        fetch(requestUrl).then((response)=>{
            if (!response.ok) throw new (0, $7byHA.default)(response.status, response.statusText);
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'downloadAll started');
            return response.blob();
        }).then((blob)=>{
            try {
                (0, $fG8Rc.saveAs)(blob, fileName);
                setIsDownloading(issueKey, false);
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'downloadAll completed');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                onFailure(error, 'useDownloadAllService-save-file');
            }
        }).catch((error)=>onFailure(error, 'useDownloadAllService-fetch'));
    }, [
        createAnalyticsEvent,
        fileName,
        issueKey,
        onFailure,
        requestUrl,
        setIsDownloading,
        showFlag
    ]);
    onTryAgainClicked = (0, $eUqFw.useCallback)(()=>{
        makeDownloadRequest();
        onDismissFlag();
    }, [
        makeDownloadRequest,
        onDismissFlag
    ]);
    return [
        isDownloading,
        makeDownloadRequest
    ];
};

});
parcelRegister("fG8Rc", function(module, exports) {
/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */ /*global self */ /*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */ /*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */ var $b6a1a615ff478201$var$saveAs = $b6a1a615ff478201$var$saveAs || function(view) {
    "use strict";
    // IE <10 is explicitly unsupported
    if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) return;
    var doc = view.document, get_URL = function() {
        return view.URL || view.webkitURL || view;
    }, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"), can_use_save_link = "download" in save_link, click = function(node) {
        var event = new MouseEvent("click");
        node.dispatchEvent(event);
    }, is_safari = /constructor/i.test(view.HTMLElement) || view.safari, is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent), throw_outside = function(ex) {
        (view.setImmediate || view.setTimeout)(function() {
            throw ex;
        }, 0);
    }, force_saveable_type = "application/octet-stream", arbitrary_revoke_timeout = 40000 // in ms
    , revoke = function(file) {
        var revoker = function() {
            if (typeof file === "string") get_URL().revokeObjectURL(file);
            else file.remove();
        };
        setTimeout(revoker, arbitrary_revoke_timeout);
    }, dispatch = function(filesaver, event_types, event) {
        event_types = [].concat(event_types);
        var i = event_types.length;
        while(i--){
            var listener = filesaver["on" + event_types[i]];
            if (typeof listener === "function") try {
                listener.call(filesaver, event || filesaver);
            } catch (ex) {
                throw_outside(ex);
            }
        }
    }, auto_bom = function(blob) {
        // prepend BOM for UTF-8 XML and text/* types (including HTML)
        // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
        if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
            String.fromCharCode(0xFEFF),
            blob
        ], {
            type: blob.type
        });
        return blob;
    }, FileSaver = function(blob, name, no_auto_bom) {
        if (!no_auto_bom) blob = auto_bom(blob);
        // First try a.download, then web filesystem, then object URLs
        var filesaver = this, type = blob.type, force = type === force_saveable_type, object_url, dispatch_all = function() {
            dispatch(filesaver, "writestart progress write writeend".split(" "));
        }, fs_error = function() {
            if ((is_chrome_ios || force && is_safari) && view.FileReader) {
                // Safari doesn't allow downloading of blob urls
                var reader = new FileReader();
                reader.onloadend = function() {
                    var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
                    var popup = view.open(url, '_blank');
                    if (!popup) view.location.href = url;
                    url = undefined; // release reference before dispatching
                    filesaver.readyState = filesaver.DONE;
                    dispatch_all();
                };
                reader.readAsDataURL(blob);
                filesaver.readyState = filesaver.INIT;
                return;
            }
            // don't create more object URLs than needed
            if (!object_url) object_url = get_URL().createObjectURL(blob);
            if (force) view.location.href = object_url;
            else {
                var opened = view.open(object_url, "_blank");
                if (!opened) // Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
                view.location.href = object_url;
            }
            filesaver.readyState = filesaver.DONE;
            dispatch_all();
            revoke(object_url);
        };
        filesaver.readyState = filesaver.INIT;
        if (can_use_save_link) {
            object_url = get_URL().createObjectURL(blob);
            setTimeout(function() {
                save_link.href = object_url;
                save_link.download = name;
                click(save_link);
                dispatch_all();
                revoke(object_url);
                filesaver.readyState = filesaver.DONE;
            });
            return;
        }
        fs_error();
    }, FS_proto = FileSaver.prototype, saveAs = function(blob, name, no_auto_bom) {
        return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
    };
    // IE 10+ (native saveAs)
    if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) return function(blob, name, no_auto_bom) {
        name = name || blob.name || "download";
        if (!no_auto_bom) blob = auto_bom(blob);
        return navigator.msSaveOrOpenBlob(blob, name);
    };
    FS_proto.abort = function() {};
    FS_proto.readyState = FS_proto.INIT = 0;
    FS_proto.WRITING = 1;
    FS_proto.DONE = 2;
    FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;
    return saveAs;
}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || module.exports.content);
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window
if (0, module.exports) module.exports.saveAs = $b6a1a615ff478201$var$saveAs;
else if (typeof define !== "undefined" && define !== null && define.amd !== null) define("FileSaver.js", function() {
    return $b6a1a615ff478201$var$saveAs;
});

});

parcelRegister("jGRid", function(module, exports) {

$parcel$export(module.exports, "useDownloadStatus", () => $500953890b0a7e0e$export$812043cbbb815bdb);

var $ggKAj = parcelRequire("ggKAj");

var $grFmB = parcelRequire("grFmB");

var $6tkcD = parcelRequire("6tkcD");
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $500953890b0a7e0e$var$getIssueAttachment = (state, issueKey)=>state.issueAttachments[issueKey] || (0, $grFmB.initialAttachmentState);
const $500953890b0a7e0e$var$getIsDownloading = (state, issueKey)=>$500953890b0a7e0e$var$getIssueAttachment(state, issueKey).isDownloading;
const $500953890b0a7e0e$export$812043cbbb815bdb = (0, $ggKAj.createHook)((0, $6tkcD.store), {
    selector: $500953890b0a7e0e$var$getIsDownloading
});

});


parcelRegister("ixHyb", function(module, exports) {

$parcel$export(module.exports, "default", () => $4419b0280f0521aa$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $4419b0280f0521aa$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    downloadAll: {
        "id": "attachments.heading.download-all",
        "defaultMessage": "Download all"
    },
    downloading: {
        "id": "attachments.heading.downloading",
        "defaultMessage": "Downloading attachments"
    }
});

});


parcelRegister("jZX5U", function(module, exports) {

$parcel$export(module.exports, "default", () => $333280fd3ee8c259$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kUI0A = parcelRequire("kUI0A");

var $eRitJ = parcelRequire("eRitJ");

var $hJ992 = parcelRequire("hJ992");


var $i9pAn = parcelRequire("i9pAn");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $lNzzb = parcelRequire("lNzzb");
const $333280fd3ee8c259$export$d4b3ea4300af687f = /*#__PURE__*/ (0, $eUqFw.memo)(({ refreshAttachments: refreshAttachments })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [value, { setValue: setValue }] = (0, $i9pAn.useUserPreferencesValue)((0, $e4af19d777b54ab6$export$5530d4ea250d4125));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const switchToNewView = (0, $eUqFw.useCallback)((view)=>()=>{
            setValue(view);
            refreshAttachments(issueKey);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'dropdownItem'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'switchAttachmentsView', {
                view: view
            });
        }, [
        createAnalyticsEvent,
        issueKey,
        refreshAttachments,
        setValue
    ]);
    const [{ value: { totalCount: totalCount } }] = (0, $kUI0A.useIssueAttachments)(issueKey);
    /**
   * As per JIV-14783 we wish to hide the switch to strip view button
   * When attachments exceed the limit
   */ if ((0, $eRitJ.isAttachmentNumberExceedLimit)(totalCount)) return null;
    switch(value){
        case 0, $f23197a8cbf177f2$export$b7fd448c62b5fb97:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                onClick: switchToNewView((0, $f23197a8cbf177f2$export$5a2eee19a0e3c3b1))
            }, formatMessage((0, $lNzzb.default).switchToStripView));
        case 0, $f23197a8cbf177f2$export$5a2eee19a0e3c3b1:
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                onClick: switchToNewView((0, $f23197a8cbf177f2$export$b7fd448c62b5fb97))
            }, formatMessage((0, $lNzzb.default).switchToListView));
    }
});
var $333280fd3ee8c259$export$2e2bcd8739ae039 = $333280fd3ee8c259$export$d4b3ea4300af687f;

});
parcelRegister("lNzzb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b33ad011dc69e26d$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $b33ad011dc69e26d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    switchToListView: {
        "id": "attachments.heading.switch-to-listView",
        "defaultMessage": "Switch to list view"
    },
    switchToStripView: {
        "id": "attachments.heading.switch-to-strip-view",
        "defaultMessage": "Switch to strip view"
    }
});

});





parcelRegister("l3ayD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c30cfbf47dc682e6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");
var $cEUHb = parcelRequire("cEUHb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eRitJ = parcelRequire("eRitJ");

var $1Loib = parcelRequire("1Loib");
const $c30cfbf47dc682e6$export$1067e2b8fbde9ea3 = ({ totalCount: totalCount })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if ((0, $eRitJ.isAttachmentNumberExceedLimit)(totalCount)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c30cfbf47dc682e6$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "warning",
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEUHb.default), {
            href: (0, $eRitJ.ATTACHMENTS_LEARN_ABOUT_LINK)
        }, formatMessage((0, $1Loib.default).exceedWarningLinkLabel))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $1Loib.default).exceedWarningLabel))));
    return null;
};
var $c30cfbf47dc682e6$export$2e2bcd8739ae039 = $c30cfbf47dc682e6$export$1067e2b8fbde9ea3;
const $c30cfbf47dc682e6$var$wrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.100'
});

});
parcelRegister("1Loib", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddf501274bb057d2$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $ddf501274bb057d2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    exceedWarningLabel: {
        "id": "attachments.panel.exceed-warning",
        "defaultMessage": "This issue has too many attachments. Thumbnails and previews won\u2019t load."
    },
    exceedWarningLinkLabel: {
        "id": "attachments.panel.exceed-warning.link",
        "defaultMessage": "Learn about attachments"
    }
});

});



parcelRegister("2m7ky", function(module, exports) {

$parcel$export(module.exports, "default", () => $bba2ac3d8b653388$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $0cdA8 = parcelRequire("0cdA8");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $imVNa = parcelRequire("imVNa");parcelRequire("3VVr2");
var $agEEp = parcelRequire("agEEp");
var $3VVr2 = parcelRequire("3VVr2");

var $f9RL0 = parcelRequire("f9RL0");

var $lqalZ = parcelRequire("lqalZ");

var $3rr33 = parcelRequire("3rr33");

var $hHnBv = parcelRequire("hHnBv");

var $1OJS4 = parcelRequire("1OJS4");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $1b2Vj = parcelRequire("1b2Vj");

var $9GGoL = parcelRequire("9GGoL");

var $iY7NN = parcelRequire("iY7NN");

var $75LXB = parcelRequire("75LXB");

var $ke6cX = parcelRequire("ke6cX");

var $lO4Or = parcelRequire("lO4Or");

var $1TrR5 = parcelRequire("1TrR5");

var $jK1pm = parcelRequire("jK1pm");

var $k2UaD = parcelRequire("k2UaD");
const $bba2ac3d8b653388$export$413b1c23ad987cd8 = (props)=>{
    const reduxOnChange = props.onChange;
    const issueKey = (0, $hJ992.useIssueKey)();
    const [currentValue, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $f9RL0.CHILDREN_ISSUES)
    });
    const onChange = (0, $eUqFw.useCallback)((event)=>{
        switch(event.type){
            case (0, $imVNa.ChangeEventTypes).CHILD_ISSUE_ADDED:
                setFieldValue(issueKey, (0, $f9RL0.CHILDREN_ISSUES), currentValue.filter((existingIssue)=>existingIssue.id !== event.meta.childIssue.id).concat({
                    id: event.meta.childIssue.id,
                    key: event.meta.childIssue.issueKey
                }));
                break;
            default:
                break;
        }
        reduxOnChange(event);
    }, [
        currentValue,
        issueKey,
        reduxOnChange,
        setFieldValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "issue-view-child-issues-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "issue.issue-view.activity.child-issues",
        packageName: "jiraChildIssues",
        teamName: "bento",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3VVr2.default), {
        ...props,
        onChange: onChange
    })));
};
const $bba2ac3d8b653388$var$onNavigateToNewIssueMemoized = (0, $5iWql.default)((onNavigateToNewIssueDispatchProp)=>// @ts-expect-error - TS7031 - Binding element 'fromIssueKey' implicitly has an 'any' type. | TS7031 - Binding element 'toIssueKey' implicitly has an 'any' type.
    ({ fromIssueKey: fromIssueKey, toIssueKey: toIssueKey })=>{
        onNavigateToNewIssueDispatchProp && onNavigateToNewIssueDispatchProp({
            fromIssueKey: fromIssueKey,
            toIssueKey: toIssueKey
        });
    });
const $bba2ac3d8b653388$var$ReduxConnectedComponent = (0, $lqalZ.connect)((state)=>({
        childIssuesPanelType: (0, $agEEp.CHILDREN_ISSUES_PANEL),
        parentId: (0, $5JqpU.issueIdSelector)(state),
        customFieldIdRank: (0, $fokFV.customFieldIdSelector)((0, $lO4Or.RANK_CF_TYPE))(state),
        issueTypes: (0, $1b2Vj.supportedChildIssueTypesEntitiesSelector)(state),
        issues: (0, $75LXB.persistedChildrenIssuesSelector)(state),
        supportsIssueCreation: (0, $1b2Vj.supportsChildCreationSelector)(state),
        quickAddClickCount: (0, $iY7NN.childIssueQuickAddClickCountSelector)(state),
        isIssueViewComplete: (0, $jZDJX.isCompletedLoadingSelector)(state),
        messages: $k2UaD.default,
        fetchIssueTypesStatus: (0, $ke6cX.fetchIssueTypesStatusSelector)(state),
        issueHierarchyLevel: (0, $1b2Vj.hierarchyLevelSelector)(state),
        analyticsSource: (0, $5JqpU.analyticsSourceSelector)(state),
        childIssuesLimitUrl: (0, $fokFV.childIssuesLimitUrlSelector)(state)((0, $f9RL0.CHILDREN_ISSUES)),
        hasExceededIssuesLimitAfterLoad: undefined,
        totalChildIssueCount: (0, $9GGoL.totalChildIssueCountSelector)(state)
    }), (dispatch)=>({
        onChange: (event)=>{
            switch(event.type){
                case (0, $imVNa.ChangeEventTypes).CHILD_ISSUE_ADDED:
                    dispatch((0, $hHnBv.childIssueAddSuccess)(event.meta.childIssue, event.meta.fieldsData));
                    break;
                case (0, $imVNa.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED:
                    dispatch((0, $hHnBv.issueChildrenOrderChangeSuccess)(event.meta));
                    break;
                default:
                    break;
            }
        },
        onAddChildClick: ()=>dispatch((0, $hHnBv.childIssuePanelAddClick)()),
        // @ts-expect-error - TS7031 - Binding element 'fromIssueKey' implicitly has an 'any' type. | TS7031 - Binding element 'toIssueKey' implicitly has an 'any' type.
        onNavigateToNewIssueDispatchProp: ({ fromIssueKey: fromIssueKey, toIssueKey: toIssueKey })=>{
            if (!__SPA__) dispatch((0, $1OJS4.navigateToNewIssue)({
                fromIssueKey: fromIssueKey,
                toIssueKey: toIssueKey
            }));
        },
        onEditAssociatedIssue: (issueKey)=>{
            dispatch((0, $3rr33.updateAssociatedIssueRequest)(issueKey));
        }
    }), (stateProps, dispatchProps)=>{
    const { onNavigateToNewIssueDispatchProp: onNavigateToNewIssueDispatchProp, ...restDispatchProps } = dispatchProps;
    return {
        ...stateProps,
        ...restDispatchProps,
        onNavigateToNewIssue: (0, $1TrR5.functionWithFFRedux)($bba2ac3d8b653388$var$onNavigateToNewIssueMemoized(onNavigateToNewIssueDispatchProp), ({ fromIssueKey: fromIssueKey, toIssueKey: toIssueKey })=>{
            onNavigateToNewIssueDispatchProp && onNavigateToNewIssueDispatchProp({
                fromIssueKey: fromIssueKey,
                toIssueKey: toIssueKey
            });
        })
    };
})($bba2ac3d8b653388$export$413b1c23ad987cd8);
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$bba2ac3d8b653388$export$2e2bcd8739ae039 = $bba2ac3d8b653388$var$ReduxConnectedComponent;

});
parcelRegister("imVNa", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $b82bdff938108ed4$export$8db21fc94823e1cc);
const $b82bdff938108ed4$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $b82bdff938108ed4$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $b82bdff938108ed4$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $b82bdff938108ed4$export$8db21fc94823e1cc = {
    [$b82bdff938108ed4$var$CHILD_ISSUE_ADDED]: $b82bdff938108ed4$var$CHILD_ISSUE_ADDED,
    [$b82bdff938108ed4$var$ISSUE_CHILDREN_ORDER_CHANGED]: $b82bdff938108ed4$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$b82bdff938108ed4$var$CHILD_ISSUE_FIELD_UPDATED]: $b82bdff938108ed4$var$CHILD_ISSUE_FIELD_UPDATED
};

});

parcelRegister("3VVr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $16d91bab0b711a7b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CLASSIC_SUBTASKS", () => (parcelRequire("agEEp")).CLASSIC_SUBTASKS);
$parcel$export(module.exports, "CLASSIC_PROJECT_EPIC_CHILDREN", () => (parcelRequire("agEEp")).CLASSIC_PROJECT_EPIC_CHILDREN);
$parcel$export(module.exports, "CLASSIC_PORTFOLIO_CHILDREN", () => (parcelRequire("agEEp")).CLASSIC_PORTFOLIO_CHILDREN);
$parcel$export(module.exports, "CHILDREN_ISSUES_PANEL", () => (parcelRequire("agEEp")).CHILDREN_ISSUES_PANEL);

var $eUqFw = parcelRequire("eUqFw");

var $6fPfJ = parcelRequire("6fPfJ");
var $5Dznp = parcelRequire("5Dznp");

var $lgWZr = parcelRequire("lgWZr");

var $cA8OV = parcelRequire("cA8OV");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $aR8n6 = parcelRequire("aR8n6");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $9m9bG = parcelRequire("9m9bG");

var $hJ992 = parcelRequire("hJ992");

var $8411R = parcelRequire("8411R");
var $kmr29 = parcelRequire("kmr29");

var $eJYCK = parcelRequire("eJYCK");


var $f9RL0 = parcelRequire("f9RL0");

var $c0wh4 = parcelRequire("c0wh4");

var $gGtKh = parcelRequire("gGtKh");

var $5iZBp = parcelRequire("5iZBp");

var $8WuJm = parcelRequire("8WuJm");

var $guDlK = parcelRequire("guDlK");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");
var $6vrw7 = parcelRequire("6vrw7");

var $l1NJl = parcelRequire("l1NJl");

var $dxcfv = parcelRequire("dxcfv");
var $ab6rA = parcelRequire("ab6rA");
var $4xHig = parcelRequire("4xHig");

var $aC0qL = parcelRequire("aC0qL");

var $e2gQc = parcelRequire("e2gQc");
var $ca2LP = parcelRequire("ca2LP");

var $agEEp = parcelRequire("agEEp");

var $eYv0b = parcelRequire("eYv0b");

var $5uIng = parcelRequire("5uIng");

var $ch1Zg = parcelRequire("ch1Zg");

var $7Up5f = parcelRequire("7Up5f");

var $2HCUG = parcelRequire("2HCUG");

var $iBvRb = parcelRequire("iBvRb");

var $4D8Ar = parcelRequire("4D8Ar");

var $9qS4k = parcelRequire("9qS4k");

var $1yFSO = parcelRequire("1yFSO");

var $3xyAb = parcelRequire("3xyAb");

var $imVNa = parcelRequire("imVNa");
class $16d91bab0b711a7b$export$402e0e6a7dd45ba5 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            issues: [],
            issueTypes: [],
            isIssueViewComplete: false
        };
    }
    constructor(props){
        super(props);
        const { issues: issues, parentKey: parentKey, childIssuesPanelType: childIssuesPanelType, associatedIssuesContextActions: associatedIssuesContextActions, fieldValuesActions: fieldValuesActions, fieldConfigActions: fieldConfigActions } = this.props;
        this.store = (0, $ch1Zg.default)((0, $5uIng.default)(associatedIssuesContextActions, fieldValuesActions, fieldConfigActions), parentKey, childIssuesPanelType);
        this.dispatchContext();
        // Dispatch event to make requests to check if full create is required
        this.store.dispatch((0, $7Up5f.requiresFullCreateCheckRequest)());
        this.dispatchEntities();
        if (childIssuesPanelType !== (0, $agEEp.CLASSIC_SUBTASKS)) {
            if (issues.length > 0) this.store.dispatch((0, $iBvRb.fetchDetailsForIssuesRequest)());
        }
        const { fetchIssueTypesStatus: fetchIssueTypesStatus } = props;
        if (fetchIssueTypesStatus) this.store.dispatch((0, $4D8Ar.setFetchIssueTypesStatus)(fetchIssueTypesStatus));
    }
    componentDidMount() {
        const { quickAddClickCount: quickAddClickCount } = this.props;
        if (quickAddClickCount > 0) this.store.dispatch((0, $4D8Ar.showInlineCreate)());
    }
    componentDidUpdate(prevProps) {
        if ((0, $5iZBp.isShallowEqual)(prevProps, this.props)) return;
        const { issues: issues, quickAddClickCount: quickAddClickCount, fetchIssueTypesStatus: fetchIssueTypesStatus, onChange: onChange } = this.props;
        if (quickAddClickCount > prevProps.quickAddClickCount) this.store.dispatch((0, $4D8Ar.showInlineCreate)());
        if (fetchIssueTypesStatus !== prevProps.fetchIssueTypesStatus) this.store.dispatch((0, $4D8Ar.setFetchIssueTypesStatus)(fetchIssueTypesStatus || (0, $79689153693cd31b$export$e0428a74c92c3e81)));
        // realistically we could compare all props read by `dispatchContext` for this if...
        // but at this stage it is safer to compare them one by one and "migrate" as needed :(
        if (prevProps.onChange !== onChange) this.store.dispatch((0, $7Up5f.setOnChange)(onChange));
        if (issues.length || prevProps.issues.length > 0 && issues.length === 0 || fetchIssueTypesStatus !== prevProps.fetchIssueTypesStatus) this.dispatchEntities();
    }
    dispatchEntities() {
        const { issueTypes: issueTypes, issues: issues, epicLinkFieldKey: epicLinkFieldKey, issueHierarchyLevel: issueHierarchyLevel } = this.props;
        this.store.dispatch((0, $iBvRb.setEntities)({
            issueTypes: issueTypes.map((issueType)=>(0, $eYv0b.transformIssueType)(issueType, epicLinkFieldKey)),
            issues: issues,
            issueHierarchyLevel: issueHierarchyLevel
        }));
    }
    dispatchContext() {
        const { supportsIssueCreation: supportsIssueCreation, baseUrl: baseUrl, locale: locale, user: user, parentKey: parentKey, customFieldIdRank: customFieldIdRank, epicLinkFieldKey: epicLinkFieldKey, parentId: parentId, projectId: projectId, projectType: projectType, isSimplifiedProject: isSimplifiedProject, messages: messages, onNavigateToNewIssue: onNavigateToNewIssue, onChange: onChange, childIssuesPanelType: childIssuesPanelType, isIssueViewComplete: isIssueViewComplete, onEditAssociatedIssue: onEditAssociatedIssue } = this.props;
        let application = null;
        let edition = null;
        if (projectType !== null) {
            const { appEditions: appEditions } = this.props;
            application = (0, $eIp1n.getApplicationForProject)(projectType);
            edition = (0, $6WXNs.getEdition)(application, appEditions);
        }
        this.store.dispatch((0, $7Up5f.setContext)({
            baseUrl: baseUrl,
            locale: locale,
            user: user,
            projectId: projectId,
            parentId: parentId,
            parentKey: parentKey,
            customFieldIdRank: customFieldIdRank,
            epicLinkFieldKey: epicLinkFieldKey,
            supportsIssueCreation: supportsIssueCreation,
            messages: messages,
            onNavigateToNewIssue: onNavigateToNewIssue,
            onChange: onChange,
            childIssuesPanelType: childIssuesPanelType,
            isIssueViewComplete: isIssueViewComplete,
            projectType: projectType,
            application: application,
            edition: edition,
            // Optimistically assume full create not needed
            requiresFullCreate: false,
            // if the endpoint doesn't return data quick enough, optimistically assume full create not needed
            requiresFullCreateByIssueType: {},
            onEditAssociatedIssue: onEditAssociatedIssue,
            ...(0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e') ? {
                isSimplifiedProject: isSimplifiedProject
            } : {}
        }));
    }
    render() {
        const { onAddChildClick: onAddChildClick, childIssuesPanelType: childIssuesPanelType, analyticsSource: analyticsSource, issueHierarchyLevel: issueHierarchyLevel, childIssuesLimitUrl: childIssuesLimitUrl, hasExceededIssuesLimitAfterLoad: hasExceededIssuesLimitAfterLoad, totalChildIssueCount: totalChildIssueCount } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJYCK.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "childIssuesPanel",
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
            attributes: {
                childIssuesPanelType: childIssuesPanelType,
                issueHierarchyLevel: issueHierarchyLevel - 1,
                analyticsSource: `issue-view (${analyticsSource})`,
                location: 'jiraChildIssues'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cA8OV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1yFSO.default), {
            onAddChildClick: onAddChildClick,
            sourceName: "childIssuesPanel",
            childIssuesLimitUrl: childIssuesLimitUrl,
            hasExceededIssuesLimitAfterLoad: hasExceededIssuesLimitAfterLoad,
            totalChildIssueCount: totalChildIssueCount
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9m9bG.FlagsDispatcher), {
            mapper: (0, $aC0qL.default)
        }))));
    }
}
const $16d91bab0b711a7b$var$WrappedSortingChildIssuesPanel = (props)=>{
    const { issues: issues } = props;
    const initialRenderRef = (0, $eUqFw.useRef)(true);
    const [, { setSortableIssueIds: setSortableIssueIds }] = (0, $ca2LP.useSortableIssueIds)();
    (0, $eUqFw.useEffect)(()=>{
        if (initialRenderRef.current === true) {
            setSortableIssueIds(issues.map((issue)=>(0, $6vrw7.toIssueId)(issue.id)));
            initialRenderRef.current = false;
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16d91bab0b711a7b$export$402e0e6a7dd45ba5, props);
};
const $16d91bab0b711a7b$export$74db996d011ad30e = {
    [(0, $agEEp.CHILDREN_ISSUES_PANEL)]: (0, $f9RL0.CHILDREN_ISSUES),
    [(0, $agEEp.CLASSIC_PROJECT_EPIC_CHILDREN)]: (0, $f9RL0.EPIC_ISSUES),
    [(0, $agEEp.CLASSIC_SUBTASKS)]: (0, $f9RL0.SUBTASKS),
    [(0, $agEEp.CLASSIC_PORTFOLIO_CHILDREN)]: (0, $f9RL0.PORTFOLIO_CHILD_ISSUES)
};
const $16d91bab0b711a7b$var$WrappedStateRefactorChildIssuesPanelOld = (props)=>{
    const { childIssuesPanelType: childIssuesPanelType, issues: reduxIssues } = props;
    const childIssues = (0, $9qS4k.useChildrenIssuesWithDataOld)($16d91bab0b711a7b$export$74db996d011ad30e[childIssuesPanelType]);
    // make a condition to use data from sweet-state that we've managed to get complete data from it
    const validChildIssues = childIssues.every((issue)=>Boolean(issue.issueSummary));
    // use collection from global redux by default
    let issues = reduxIssues;
    if (childIssues.length > 0 && validChildIssues && reduxIssues.length === childIssues.length && (0, $2HCUG.isWhitelistedPanelForSorting)(childIssuesPanelType)) issues = childIssues.map((issue, idx)=>({
            ...issue,
            // it is cumbersome at this stage to get the estimate field details using
            // just hooks so we copy them over from the Redux issues provided for now.
            // NOTE 1: this is only the case because the internals of this component are not
            // being changed, so all data is being handled by the "root" component
            // instead of where they are used/rendered primarily.
            // NOTE 2: it is not possible to use `useFieldValuesForIssues` as each child issue
            // could belong to a different project configuration.
            estimateFieldId: reduxIssues[idx].estimateFieldId,
            estimateValue: reduxIssues[idx].estimateValue
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16d91bab0b711a7b$var$WrappedSortingChildIssuesPanel, {
        ...props,
        issues: issues
    });
};
const $16d91bab0b711a7b$var$WrappedStateRefactorChildIssuesPanelNew = (props)=>{
    const { childIssuesPanelType: childIssuesPanelType } = props;
    const childIssues = (0, $9qS4k.useChildrenIssuesWithData)($16d91bab0b711a7b$export$74db996d011ad30e[childIssuesPanelType]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16d91bab0b711a7b$var$WrappedSortingChildIssuesPanel, {
        ...props,
        issues: childIssues
    });
};
const $16d91bab0b711a7b$var$WrappedStateRefactorChildIssuesPanel = (0, $9zysr.componentWithCondition)(()=>true, $16d91bab0b711a7b$var$WrappedStateRefactorChildIssuesPanelNew, $16d91bab0b711a7b$var$WrappedStateRefactorChildIssuesPanelOld);
const $16d91bab0b711a7b$var$ChildIssuesPanelWithHooks = (props)=>{
    const { onNavigateToNewIssue: onNavigateToNewIssue } = props;
    const onIssueKeyChange = (0, $hJ992.useOnIssueKeyChange)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $hJ992.useProjectKey)();
    const projectId = (0, $guDlK.useProjectId)(projectKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const isSimplifiedProject = (0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e') ? (0, $guDlK.useIsSimplifiedProject)(projectKey) : undefined;
    const baseUrl = (0, $6vrw7.toBaseUrl)('');
    const user = (0, $dxcfv.useAccountId)();
    const locale = (0, $4xHig.useLocale)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const associatedIssuesContextActions = (0, $lgWZr.useAssociatedIssuesContextActions)();
    const [, fieldValueActions] = (0, $kmr29.useFieldsValuesActions)();
    const [, fieldsConfigActions] = (0, $8411R.useFieldConfigActions)();
    const onNavigateToNewIssueCallback = (0, $eUqFw.useCallback)((args)=>{
        onNavigateToNewIssue(args);
        onIssueKeyChange?.(args);
    }, [
        onIssueKeyChange,
        onNavigateToNewIssue
    ]);
    const childIssueFieldKey = $16d91bab0b711a7b$export$74db996d011ad30e[props.childIssuesPanelType];
    const hasExceededIssuesLimitAfterLoad = childIssueFieldKey ? (0, $c0wh4.useHasExceededChildIssuesLimitAfterLoad)(childIssueFieldKey) : props.hasExceededIssuesLimitAfterLoad;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16d91bab0b711a7b$var$WrappedStateRefactorChildIssuesPanel, {
        ...props,
        onNavigateToNewIssue: onNavigateToNewIssueCallback,
        parentKey: issueKey || (0, $6vrw7.toIssueKey)(''),
        projectId: (0, $6vrw7.toProjectId)(projectId || ''),
        projectType: projectType || null,
        isSimplifiedProject: isSimplifiedProject,
        baseUrl: baseUrl,
        user: user,
        locale: locale,
        appEditions: appEditions,
        associatedIssuesContextActions: associatedIssuesContextActions,
        fieldValuesActions: fieldValueActions,
        fieldConfigActions: fieldsConfigActions,
        hasExceededIssuesLimitAfterLoad: hasExceededIssuesLimitAfterLoad
    });
};
const $16d91bab0b711a7b$var$DecoratedComponent = (props)=>{
    const { childIssuesPanelType: childIssuesPanelType } = props;
    const issueKey = (0, $hJ992.useIssueKey)();
    const renderAiIssueBreakdown = (0, $eUqFw.useMemo)(()=>(0, $1ybV0.ff)('jira-ai-work-breakdown-new-ui_z0inn') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6fPfJ.AiIssueBreakdownEntryPointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Dznp.IssueBreakdownAiContainer), {
            scope: `${issueKey}-${childIssuesPanelType}-issue-breakdown`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16d91bab0b711a7b$var$ChildIssuesPanelWithHooks, props))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3xyAb.IssueBreakdownAiContainer), {
            scope: `${issueKey}-${childIssuesPanelType}-issue-breakdown`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16d91bab0b711a7b$var$ChildIssuesPanelWithHooks, props)), [
        issueKey,
        childIssuesPanelType,
        props
    ]);
    return (0, $1ybV0.ff)('configurable-child-issues-panel_3ht06') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue.issue-view.common.child-issues-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "common.child-issues-panel",
        packageName: "jiraIssueViewCommonViews",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jiraIssueViewCommonViews",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l1NJl.ChildIssuesPanelSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e2gQc.ChildIssuesContainer), {
        scope: `${issueKey}-${childIssuesPanelType}`
    }, renderAiIssueBreakdown)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue.issue-view.common.child-issues-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "common.child-issues-panel",
        packageName: "jiraIssueViewCommonViews",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e2gQc.ChildIssuesContainer), {
        scope: `${issueKey}-${childIssuesPanelType}`
    }, renderAiIssueBreakdown)));
};
var $16d91bab0b711a7b$export$2e2bcd8739ae039 = $16d91bab0b711a7b$var$DecoratedComponent;

});
parcelRegister("6fPfJ", function(module, exports) {

$parcel$export(module.exports, "AiIssueBreakdownEntryPointContext", () => $51f8260141e88ddb$export$268cfe7e46b81d01);
$parcel$export(module.exports, "AiIssueBreakdownEntryPointContextProvider", () => $51f8260141e88ddb$export$ff362b6f62a265ec);

var $eUqFw = parcelRequire("eUqFw");

var $gRxol = parcelRequire("gRxol");
var $6j4bv = parcelRequire("6j4bv");

var $5lcH8 = parcelRequire("5lcH8");
const $51f8260141e88ddb$export$268cfe7e46b81d01 = (0, $gRxol.createUseEntryPointContext)();
const $51f8260141e88ddb$var$EMPTY_ENTRY_POINT_PARAMS = {};
const $51f8260141e88ddb$export$ff362b6f62a265ec = ({ children: children })=>{
    const entryPoint = (0, $6j4bv.useEntryPoint)((0, $5lcH8.AiIssueBreakdownEntryPoint), $51f8260141e88ddb$var$EMPTY_ENTRY_POINT_PARAMS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($51f8260141e88ddb$export$268cfe7e46b81d01.Provider, {
        value: entryPoint
    }, children);
};

});
parcelRegister("5lcH8", function(module, exports) {

$parcel$export(module.exports, "AiIssueBreakdownEntryPoint", () => $daf098a1cd1662ce$export$b07694518e3fbe8f);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $daf098a1cd1662ce$export$b07694518e3fbe8f = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("ew8Gk")).then((module)=>module.AiIssueBreakdownEntryPointComponent), {
        moduleId: "62d891a5"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("ew8Gk", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9oODh');
        const value = parcelRequire('1gBdI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9oODh").then(()=>parcelRequire('1gBdI'));
}

});



parcelRegister("5Dznp", function(module, exports) {

$parcel$export(module.exports, "steps", () => $1b64d80e189f19d8$export$be3f796aed065412);
$parcel$export(module.exports, "reasons", () => $1b64d80e189f19d8$export$653523807df144ac);
$parcel$export(module.exports, "IssueBreakdownAiContainer", () => $1b64d80e189f19d8$export$ac6c39a0dbf8f3e5);
$parcel$export(module.exports, "useIssueBreakdown", () => $1b64d80e189f19d8$export$2d0761b6b6ddada);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $1b64d80e189f19d8$export$be3f796aed065412 = {
    defaultStep: 'defaultStep',
    draftListStep: 'draftListStep',
    errorStep: 'errorStep'
};
const $1b64d80e189f19d8$export$653523807df144ac = {
    accept: 'accept',
    reject: 'reject'
};
const $1b64d80e189f19d8$var$initialState = {
    currentStep: $1b64d80e189f19d8$export$be3f796aed065412.defaultStep,
    retryAttempts: 0,
    suggestedChildIssues: [],
    promptValue: '',
    headerPromptValue: '',
    selectedIssueId: null,
    channelId: null,
    acceptedChildIssues: [],
    rejectedChildIssues: [],
    isStreaming: false,
    clearListWhenAddSuggestion: false,
    status: null
};
const $1b64d80e189f19d8$var$setIssueBreakdownStep = (step)=>({ setState: setState })=>{
        setState({
            currentStep: step
        });
    };
const $1b64d80e189f19d8$var$setSuggestedChildIssues = (suggestedChildIssues)=>({ setState: setState })=>{
        setState({
            suggestedChildIssues: suggestedChildIssues
        });
    };
const $1b64d80e189f19d8$var$setSelectedIssueId = (selectedIssueId)=>({ setState: setState })=>{
        setState({
            selectedIssueId: selectedIssueId
        });
    };
const $1b64d80e189f19d8$var$unselectCurrentId = ()=>({ setState: setState })=>{
        setState({
            selectedIssueId: null
        });
    };
const $1b64d80e189f19d8$var$setChannelId = (channelId)=>({ setState: setState })=>{
        setState({
            channelId: channelId
        });
    };
const $1b64d80e189f19d8$var$resetIssueBreakdownState = ()=>({ setState: setState })=>{
        setState($1b64d80e189f19d8$var$initialState);
    };
const $1b64d80e189f19d8$var$setPromptValue = (promptValue)=>({ setState: setState })=>{
        setState({
            promptValue: promptValue
        });
    };
const $1b64d80e189f19d8$var$setHeaderPromptValue = (headerPromptValue)=>({ setState: setState })=>{
        setState({
            headerPromptValue: headerPromptValue
        });
    };
// remove on jira-ai-work-breakdown-new-ui_z0inn feature flag cleanup
const $1b64d80e189f19d8$var$closeIssueBreakdown = ()=>({ getState: getState })=>{
        const { currentStep: currentStep } = getState();
        switch(currentStep){
            case $1b64d80e189f19d8$export$be3f796aed065412.draftListStep:
            case $1b64d80e189f19d8$export$be3f796aed065412.defaultStep:
            default:
        }
    };
const $1b64d80e189f19d8$var$isIssueBreakdownOpen = ()=>({ getState: getState })=>{
        const { currentStep: currentStep } = getState();
        return currentStep !== $1b64d80e189f19d8$export$be3f796aed065412.defaultStep;
    };
const $1b64d80e189f19d8$var$getSuggestedLength = ()=>({ getState: getState })=>{
        const { suggestedChildIssues: suggestedChildIssues } = getState();
        return suggestedChildIssues.length;
    };
const $1b64d80e189f19d8$var$updateSuggestedResult = ({ channelId: channelId, suggestedChildIssues: suggestedChildIssues })=>({ setState: setState })=>{
        setState({
            channelId: channelId,
            suggestedChildIssues: suggestedChildIssues
        });
    };
const $1b64d80e189f19d8$var$addSuggestedIssue = (newSuggestedIssue)=>({ getState: getState, setState: setState })=>{
        const { suggestedChildIssues: oldIssues, status: status, clearListWhenAddSuggestion: clearListWhenAddSuggestion } = getState();
        const suggestedChildIssues = clearListWhenAddSuggestion ? [
            newSuggestedIssue
        ] : oldIssues.concat(newSuggestedIssue);
        if (status) setState({
            suggestedChildIssues: suggestedChildIssues,
            status: null,
            clearListWhenAddSuggestion: false
        });
        else setState({
            suggestedChildIssues: suggestedChildIssues,
            clearListWhenAddSuggestion: false
        });
    };
const $1b64d80e189f19d8$var$removeSuggestedIssue = (id, reason)=>({ getState: getState, setState: setState })=>{
        const { suggestedChildIssues: suggestedChildIssues, acceptedChildIssues: acceptedChildIssues, rejectedChildIssues: rejectedChildIssues } = getState();
        const removeIdSet = new Set(Array.isArray(id) ? id : [
            id
        ]);
        const initialValue = {
            issues: [],
            removed: []
        };
        const { issues: issues, removed: removed } = suggestedChildIssues.reduce((result, current)=>{
            if (removeIdSet.has(current.id)) {
                const { summary: summary, description: description } = current;
                return Object.assign(result, {
                    removed: result.removed.concat({
                        summary: summary,
                        description: description
                    })
                });
            }
            return Object.assign(result, {
                issues: result.issues.concat(current)
            });
        }, initialValue);
        if (reason === $1b64d80e189f19d8$export$653523807df144ac.accept) setState({
            suggestedChildIssues: issues,
            acceptedChildIssues: acceptedChildIssues.concat(removed)
        });
        else setState({
            suggestedChildIssues: issues,
            rejectedChildIssues: rejectedChildIssues.concat(removed)
        });
    };
const $1b64d80e189f19d8$var$removeAcceptedSuggestedIssue = (id)=>({ getState: getState, setState: setState })=>{
        const { suggestedChildIssues: suggestedChildIssues, acceptedChildIssues: acceptedChildIssues } = getState();
        const removedIssue = suggestedChildIssues.find((item)=>item.id === id);
        if (!removedIssue) return;
        const { summary: summary, description: description } = removedIssue;
        const newAcceptedIssues = acceptedChildIssues.concat({
            summary: summary,
            description: description
        });
        const newIssues = suggestedChildIssues.filter((item)=>item.id !== id);
        setState({
            suggestedChildIssues: newIssues,
            acceptedChildIssues: newAcceptedIssues
        });
    };
const $1b64d80e189f19d8$var$updateStreamingStatus = (isStreaming, status = null)=>({ setState: setState })=>{
        setState({
            isStreaming: isStreaming,
            clearListWhenAddSuggestion: isStreaming,
            status: status
        });
    };
const $1b64d80e189f19d8$var$setStreamingError = ()=>({ setState: setState, getState: getState })=>{
        const { suggestedChildIssues: suggestedChildIssues, promptValue: promptValue } = getState();
        if (suggestedChildIssues.length > 0 || promptValue) // If it's a refine request,
        // for example, after the initial request has succeeded or the user has typed in text
        // then want to keep the channel ID.
        setState({
            currentStep: $1b64d80e189f19d8$export$be3f796aed065412.errorStep
        });
        else // If the initial request fails, we want to start a new one
        setState({
            currentStep: $1b64d80e189f19d8$export$be3f796aed065412.errorStep,
            channelId: null
        });
    };
const $1b64d80e189f19d8$var$incrementRetryCount = ()=>({ getState: getState, setState: setState })=>{
        const { retryAttempts: retryAttempts } = getState();
        setState({
            retryAttempts: retryAttempts + 1
        });
    };
const $1b64d80e189f19d8$export$e324594224ef24da = {
    setIssueBreakdownStep: $1b64d80e189f19d8$var$setIssueBreakdownStep,
    setSuggestedChildIssues: $1b64d80e189f19d8$var$setSuggestedChildIssues,
    setPromptValue: $1b64d80e189f19d8$var$setPromptValue,
    setHeaderPromptValue: $1b64d80e189f19d8$var$setHeaderPromptValue,
    setSelectedIssueId: $1b64d80e189f19d8$var$setSelectedIssueId,
    unselectCurrentId: $1b64d80e189f19d8$var$unselectCurrentId,
    setChannelId: $1b64d80e189f19d8$var$setChannelId,
    resetIssueBreakdownState: $1b64d80e189f19d8$var$resetIssueBreakdownState,
    removeAcceptedSuggestedIssue: $1b64d80e189f19d8$var$removeAcceptedSuggestedIssue,
    updateSuggestedResult: $1b64d80e189f19d8$var$updateSuggestedResult,
    addSuggestedIssue: $1b64d80e189f19d8$var$addSuggestedIssue,
    removeSuggestedIssue: $1b64d80e189f19d8$var$removeSuggestedIssue,
    closeIssueBreakdown: $1b64d80e189f19d8$var$closeIssueBreakdown,
    updateStreamingStatus: $1b64d80e189f19d8$var$updateStreamingStatus,
    setStreamingError: $1b64d80e189f19d8$var$setStreamingError,
    incrementRetryCount: $1b64d80e189f19d8$var$incrementRetryCount,
    isIssueBreakdownOpen: $1b64d80e189f19d8$var$isIssueBreakdownOpen,
    getSuggestedLength: $1b64d80e189f19d8$var$getSuggestedLength
};
const $1b64d80e189f19d8$export$ac6c39a0dbf8f3e5 = (0, $heB5U.createContainer)();
const $1b64d80e189f19d8$var$Store = (0, $a61MH.createStore)({
    initialState: $1b64d80e189f19d8$var$initialState,
    actions: $1b64d80e189f19d8$export$e324594224ef24da,
    name: 'issue-breakdown',
    containedBy: $1b64d80e189f19d8$export$ac6c39a0dbf8f3e5
});
const $1b64d80e189f19d8$export$2d0761b6b6ddada = (0, $ggKAj.createHook)($1b64d80e189f19d8$var$Store);

});

parcelRegister("9m9bG", function(module, exports) {

$parcel$export(module.exports, "FlagsDispatcher", () => $002bf7125eab9f2d$export$9e60e3d40b6e758f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $k8Qyf = parcelRequire("k8Qyf");

var $f5coq = parcelRequire("f5coq");

var $fDZU5 = parcelRequire("fDZU5");
const $002bf7125eab9f2d$export$ab054a1ef92eeb01 = (0, $bAQOb.componentWithFF)('jff.magma.react-redux-upgrade_53sr4', (0, $f5coq.Dispatcher), (0, $fDZU5.Dispatcher));
const $002bf7125eab9f2d$export$9e60e3d40b6e758f = ({ storeKey: storeKey, store: store, mapper: mapper })=>(0, $1ybV0.ff)('jff.magma.react-redux-upgrade_53sr4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f5coq.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $k8Qyf.showFlag),
        dismissFlag: (0, $k8Qyf.dismissFlag)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZU5.Dispatcher), {
        storeKey: storeKey,
        mapper: mapper,
        showFlag: (0, $k8Qyf.showFlag),
        dismissFlag: (0, $k8Qyf.dismissFlag)
    });

});
parcelRegister("f5coq", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $90a680d3c2375734$export$ab054a1ef92eeb01);

var $eUqFw = parcelRequire("eUqFw");

var $52LVQ = parcelRequire("52LVQ");
const $90a680d3c2375734$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $eUqFw.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $eUqFw.useMemo)(()=>(0, $52LVQ.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("52LVQ", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $e7e882b82f21ae65$export$7b259d28468da15b);

var $eUqFw = parcelRequire("eUqFw");

var $3npQj = parcelRequire("3npQj");

var $k8Qyf = parcelRequire("k8Qyf");
const $e7e882b82f21ae65$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $e7e882b82f21ae65$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $k8Qyf.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $k8Qyf.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3npQj.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $e7e882b82f21ae65$export$2bedce6f5250e28d = (action, state, store, result, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $k8Qyf.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') $e7e882b82f21ae65$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    });
    else $e7e882b82f21ae65$export$8a44987212de21b(store, result, showFlag, dismissFlag);
};
const $e7e882b82f21ae65$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $eUqFw.useMemo)(()=>$e7e882b82f21ae65$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const handleAction = (action, state)=>{
            const result = mapper(action, state);
            $e7e882b82f21ae65$export$2bedce6f5250e28d(action, state, store, result, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $e7e882b82f21ae65$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $3npQj.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7e882b82f21ae65$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $e7e882b82f21ae65$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7e882b82f21ae65$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $e7e882b82f21ae65$var$Dispatcher8DefaultStore;
};

});


parcelRegister("fDZU5", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $e6103fd8b956edb1$export$ab054a1ef92eeb01);

var $eUqFw = parcelRequire("eUqFw");

var $czjBe = parcelRequire("czjBe");
class $e6103fd8b956edb1$export$ab054a1ef92eeb01 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            storeKey: 'store'
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.storeKey === state.lastStoreKey) return null;
        return {
            lastStoreKey: props.storeKey,
            DispatcherComponent: (0, $czjBe.createDispatcher)(props.storeKey)
        };
    }
    render() {
        const { DispatcherComponent: DispatcherComponent } = this.state;
        const { storeKey: storeKey, ...dispatcherProps } = this.props;
        return DispatcherComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DispatcherComponent, dispatcherProps);
    }
    constructor(...args){
        super(...args);
        this.state = {
            DispatcherComponent: null
        };
    }
}

});
parcelRegister("czjBe", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $0d9c9210e97a1348$export$7b259d28468da15b);

var $eUqFw = parcelRequire("eUqFw");

var $cllCv = parcelRequire("cllCv");

var $1Qivz = parcelRequire("1Qivz");

var $eo17r = parcelRequire("eo17r");
const $0d9c9210e97a1348$export$7b259d28468da15b = (storeKey)=>// eslint-disable-next-line jira/react/no-class-components
    class Dispatcher extends (0, $eUqFw.Component) {
        static{
            this.contextTypes = {
                [storeKey]: (0, $1Qivz.object).isRequired
            };
        }
        constructor(props, context){
            super(props);
            this.perform = (action, state)=>{
                // handle batch middleware
                if (action.meta && action.meta.batch && Array.isArray(action.payload)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                action.payload.forEach((childAction)=>{
                    if (childAction.type && typeof childAction.type === 'string') this.handleAction(childAction, state);
                });
                else this.handleAction(action, state);
            };
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Context<TState, TAction>'.
            const store = context[storeKey];
            if (!store) throw new Error(`Cannot get store with the key '${storeKey}' from the context.`);
            if (typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
        }
        componentDidMount() {
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            this.context[storeKey].addActionListener(this.perform);
        }
        componentWillUnmount() {
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            this.context[storeKey].removeActionListener(this.perform);
        }
        handleAction(action, state) {
            const { mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = this.props;
            const result = mapper(action, state);
            if (!result) return;
            // @ts-expect-error - TS2339 - Property 'command' does not exist on type 'DismissFlag | Flag'.
            if (result.command === (0, $eo17r.DISMISS_COMMAND)) {
                // @ts-expect-error - TS2322 - Type 'DismissFlag | Flag' is not assignable to type 'DismissFlag'.
                const flag = result;
                if (flag.id) dismissFlag(flag);
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'DismissFlag | Flag'. | TS2339 - Property 'render' does not exist on type 'DismissFlag | Flag'.
            } else if (result.type != null || result.render != null) // @ts-expect-error - TS2345 - Argument of type 'DismissFlag | Flag' is not assignable to parameter of type 'Flag'.
            showFlag(result);
            else {
                // @ts-expect-error - TS2322 - Type 'DismissFlag | Flag' is not assignable to type 'FlagComponent'.
                const FlagComponent = result;
                // go/jfe-eslint
                // eslint-disable-next-line react/no-unstable-nested-components
                const FlagComponentWithProvider = (props)=>// @ts-expect-error - TS2571 - Object is of type 'unknown'.
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cllCv.Provider), {
                        store: this.context[storeKey]
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FlagComponent, props));
                showFlag(FlagComponentWithProvider);
            }
        }
        render() {
            return null;
        }
    };

});



parcelRegister("l1NJl", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesPanelSkeleton", () => $71f61ebcd15605ac$export$dec176b7f32dbec8);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $96Sot = parcelRequire("96Sot");
const $71f61ebcd15605ac$var$customCssStyles = null;
const $71f61ebcd15605ac$var$containerStyles = {
    height: '448px'
};
const $71f61ebcd15605ac$export$dec176b7f32dbec8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($96Sot))),
        containerStyles: $71f61ebcd15605ac$var$containerStyles,
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("96Sot", function(module, exports) {
module.exports = new URL("native-issue-table-skeleton.tpl.32b8869a.svg", import.meta.url).toString();

});


parcelRegister("aC0qL", function(module, exports) {

$parcel$export(module.exports, "default", () => $34f3491c47e4c020$export$2e2bcd8739ae039);

var $iBvRb = parcelRequire("iBvRb");

var $g0sGE = parcelRequire("g0sGE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$34f3491c47e4c020$export$2e2bcd8739ae039 = (action)=>{
    switch(action.type){
        case 0, $iBvRb.LINK_PARENT_FAILURE:
            return {
                type: 'error',
                title: (0, $g0sGE.default).linkParentErrorTitle,
                description: (0, $g0sGE.default).linkParentErrorDescription
            };
        case 0, $iBvRb.REORDER_CHILDREN_FAILED:
            return {
                type: 'error',
                title: (0, $g0sGE.default).reorderErrorTitle,
                description: (0, $g0sGE.default).reorderErrorDescription
            };
        default:
            return undefined;
    }
};

});
parcelRegister("iBvRb", function(module, exports) {

$parcel$export(module.exports, "SET_ENTITIES", () => $f5778d3443e35a12$export$6ff5c7e9ad238d7b);
$parcel$export(module.exports, "setEntities", () => $f5778d3443e35a12$export$3a3eaaf831701b06);
$parcel$export(module.exports, "UPDATE_ISSUE", () => $f5778d3443e35a12$export$d46fd8e9a2a59b28);
$parcel$export(module.exports, "updateIssue", () => $f5778d3443e35a12$export$3bcffab6dd70dbbc);
$parcel$export(module.exports, "CREATE_CHILD_REQUEST", () => $f5778d3443e35a12$export$cde178fa0b730257);
$parcel$export(module.exports, "createChildRequest", () => $f5778d3443e35a12$export$56a83114eed61301);
$parcel$export(module.exports, "CREATE_CHILD_SUCCESS", () => $f5778d3443e35a12$export$6bf3907f9509f743);
$parcel$export(module.exports, "createChildSuccess", () => $f5778d3443e35a12$export$6ac0f43016450864);
$parcel$export(module.exports, "CREATE_CHILD_FAILURE", () => $f5778d3443e35a12$export$3774a7672ce38a05);
$parcel$export(module.exports, "createChildFailure", () => $f5778d3443e35a12$export$d4cd431dc26e3c12);
$parcel$export(module.exports, "LINK_CHILD_SUCCESS", () => $f5778d3443e35a12$export$b40dd0be7a77f0f3);
$parcel$export(module.exports, "linkChildSuccess", () => $f5778d3443e35a12$export$ded81828ca52473a);
$parcel$export(module.exports, "LINKING_ISSUE_FAILURE", () => $f5778d3443e35a12$export$47c6dfa79c4061d8);
$parcel$export(module.exports, "LINKING_ISSUE_RETRY", () => $f5778d3443e35a12$export$fd85926d413f992b);
$parcel$export(module.exports, "linkingIssueRetry", () => $f5778d3443e35a12$export$ca92b776109d5e7d);
$parcel$export(module.exports, "LINKING_ISSUE_RETRY_FAILURE", () => $f5778d3443e35a12$export$c33db15c3b1ab3fb);
$parcel$export(module.exports, "linkingIssueRetryFailure", () => $f5778d3443e35a12$export$a0e1af024aeb6d77);
$parcel$export(module.exports, "CREATE_CHILD_RETRY", () => $f5778d3443e35a12$export$5e3fc100fb741cb0);
$parcel$export(module.exports, "createChildRetry", () => $f5778d3443e35a12$export$8d4df1d2707a600b);
$parcel$export(module.exports, "LINK_PARENT_FAILURE", () => $f5778d3443e35a12$export$4bfb333b7484411e);
$parcel$export(module.exports, "linkParentFailure", () => $f5778d3443e35a12$export$911b287d4216522e);
$parcel$export(module.exports, "CHILD_CREATED_IN_FULL_DIALOG", () => $f5778d3443e35a12$export$a9a4c75ff8c87ff1);
$parcel$export(module.exports, "childCreatedInFullDialog", () => $f5778d3443e35a12$export$7cc6e2003a15927);
$parcel$export(module.exports, "FETCH_SINGLE_CHILD_SUCCESS", () => $f5778d3443e35a12$export$e01e2ee4c55a60c2);
$parcel$export(module.exports, "fetchSingleChildSuccess", () => $f5778d3443e35a12$export$da5e1a7189ae4b18);
$parcel$export(module.exports, "FETCH_GRAPHQL_ISSUE_SUCCESS", () => $f5778d3443e35a12$export$2591bae714c7bcfa);
$parcel$export(module.exports, "fetchGraphqlIssueSuccess", () => $f5778d3443e35a12$export$cf34d76a5f5f76c3);
$parcel$export(module.exports, "CANCEL_OPTIMISTIC_CHILD", () => $f5778d3443e35a12$export$7ba41b0f859cd9de);
$parcel$export(module.exports, "cancelOptimisticChild", () => $f5778d3443e35a12$export$98d5ec7cac55724a);
$parcel$export(module.exports, "FETCH_DETAILS_FOR_ISSUES_REQUEST", () => $f5778d3443e35a12$export$c81d530f36bbff54);
$parcel$export(module.exports, "fetchDetailsForIssuesRequest", () => $f5778d3443e35a12$export$d7bd258f937d3f97);
$parcel$export(module.exports, "FETCH_DETAILS_FOR_ISSUES_SUCCESS", () => $f5778d3443e35a12$export$f06e411231cc9e0f);
$parcel$export(module.exports, "fetchDetailsForIssuesSuccess", () => $f5778d3443e35a12$export$f8212515c1fa259b);
$parcel$export(module.exports, "REORDER_CHILDREN_REQUEST", () => $f5778d3443e35a12$export$1ad8075453e254e8);
$parcel$export(module.exports, "reorderChildrenRequest", () => $f5778d3443e35a12$export$956b72f97bc996b2);
$parcel$export(module.exports, "REORDER_CHILDREN_FAILED", () => $f5778d3443e35a12$export$90fd6e557d95c194);
$parcel$export(module.exports, "reorderChildrenFailed", () => $f5778d3443e35a12$export$7b24762ac1cea786);
$parcel$export(module.exports, "REORDER_CHILDREN_SUCCESS", () => $f5778d3443e35a12$export$114e6969a338330e);
$parcel$export(module.exports, "reorderChildrenSuccess", () => $f5778d3443e35a12$export$e3b2b5621f591898);
$parcel$export(module.exports, "ADD_EXISTING_CHILD_ISSUE_REQUEST", () => $f5778d3443e35a12$export$5998f11ce66975f8);
$parcel$export(module.exports, "addExistingChildIssueRequest", () => $f5778d3443e35a12$export$3cd83357f07e71c2);
const $f5778d3443e35a12$export$6ff5c7e9ad238d7b = 'state.entities.SET_ENTITIES';
const $f5778d3443e35a12$export$3a3eaaf831701b06 = (payload)=>({
        type: $f5778d3443e35a12$export$6ff5c7e9ad238d7b,
        payload: payload
    });
const $f5778d3443e35a12$export$d46fd8e9a2a59b28 = 'state.entities.UPDATE_ISSUE';
const $f5778d3443e35a12$export$3bcffab6dd70dbbc = (payload)=>({
        type: $f5778d3443e35a12$export$d46fd8e9a2a59b28,
        payload: payload
    });
const $f5778d3443e35a12$export$cde178fa0b730257 = 'state.entities.CREATE_CHILD_REQUEST';
const $f5778d3443e35a12$export$56a83114eed61301 = (optimisticUiChildIssue, analyticsEvent)=>({
        type: $f5778d3443e35a12$export$cde178fa0b730257,
        payload: {
            optimisticUiChildIssue: optimisticUiChildIssue
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $f5778d3443e35a12$export$6bf3907f9509f743 = 'state.entities.CREATE_CHILD_SUCCESS';
const $f5778d3443e35a12$export$6ac0f43016450864 = (optimisticId, createdChild, analyticsEvent, usedGlobalCreateDialog = false, additionalAttributes = {})=>({
        type: $f5778d3443e35a12$export$6bf3907f9509f743,
        payload: {
            optimisticId: optimisticId,
            createdChild: createdChild,
            usedGlobalCreateDialog: usedGlobalCreateDialog
        },
        meta: {
            analyticsEvent: analyticsEvent,
            additionalAttributes: additionalAttributes
        }
    });
const $f5778d3443e35a12$export$3774a7672ce38a05 = 'state.entities.CREATE_CHILD_FAILURE';
const $f5778d3443e35a12$export$d4cd431dc26e3c12 = (optimisticId, error)=>({
        type: $f5778d3443e35a12$export$3774a7672ce38a05,
        payload: {
            optimisticId: optimisticId,
            error: error
        }
    });
const $f5778d3443e35a12$export$b40dd0be7a77f0f3 = 'state.entities.LINK_CHILD_SUCCESS';
const $f5778d3443e35a12$export$ded81828ca52473a = (issueId, linkedChild, analyticsEvent)=>({
        type: $f5778d3443e35a12$export$b40dd0be7a77f0f3,
        payload: {
            issueId: issueId,
            linkedChild: linkedChild
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $f5778d3443e35a12$export$47c6dfa79c4061d8 = 'state.entities.LINKING_ISSUE_FAILURE';
const $f5778d3443e35a12$export$6d095d2c37bf917c = (createdChild, optimisticId, error)=>({
        type: $f5778d3443e35a12$export$47c6dfa79c4061d8,
        payload: {
            createdChild: createdChild,
            optimisticId: optimisticId,
            error: error
        }
    });
const $f5778d3443e35a12$export$fd85926d413f992b = 'state.entities.LINKING_ISSUE_RETRY';
const $f5778d3443e35a12$export$ca92b776109d5e7d = (issueId, analyticsEvent)=>({
        type: $f5778d3443e35a12$export$fd85926d413f992b,
        payload: {
            issueId: issueId
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $f5778d3443e35a12$export$c33db15c3b1ab3fb = 'state.entities.LINKING_ISSUE_RETRY_FAILURE';
const $f5778d3443e35a12$export$a0e1af024aeb6d77 = (issueId)=>({
        type: $f5778d3443e35a12$export$c33db15c3b1ab3fb,
        payload: {
            issueId: issueId
        }
    });
const $f5778d3443e35a12$export$5e3fc100fb741cb0 = 'state.entities.CREATE_CHILD_RETRY';
const $f5778d3443e35a12$export$8d4df1d2707a600b = (optimisticId, analyticsEvent)=>({
        type: $f5778d3443e35a12$export$5e3fc100fb741cb0,
        payload: {
            optimisticId: optimisticId
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $f5778d3443e35a12$export$4bfb333b7484411e = 'state.entities.LINK_PARENT_FAILURE';
const $f5778d3443e35a12$export$911b287d4216522e = (optimisticId, error)=>({
        type: $f5778d3443e35a12$export$4bfb333b7484411e,
        payload: {
            optimisticId: optimisticId,
            error: error
        }
    });
const $f5778d3443e35a12$export$a9a4c75ff8c87ff1 = 'state.entities.CHILD_CREATED_IN_FULL_DIALOG';
const $f5778d3443e35a12$export$7cc6e2003a15927 = (optimisticId, createdChild, analyticsEvent)=>({
        type: $f5778d3443e35a12$export$a9a4c75ff8c87ff1,
        payload: {
            optimisticId: optimisticId,
            createdChild: createdChild
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $f5778d3443e35a12$export$e01e2ee4c55a60c2 = 'state.entities.FETCH_SINGLE_CHILD_SUCCESS';
const $f5778d3443e35a12$export$da5e1a7189ae4b18 = (childIssue)=>({
        type: $f5778d3443e35a12$export$e01e2ee4c55a60c2,
        payload: {
            childIssue: childIssue
        }
    });
const $f5778d3443e35a12$export$2591bae714c7bcfa = 'state.entities.FETCH_GRAPHQL_ISSUE_SUCCESS';
const $f5778d3443e35a12$export$cf34d76a5f5f76c3 = (payload)=>({
        type: $f5778d3443e35a12$export$2591bae714c7bcfa,
        payload: payload
    });
const $f5778d3443e35a12$export$7ba41b0f859cd9de = 'state.entities.CANCEL_OPTIMISTIC_CHILD';
const $f5778d3443e35a12$export$98d5ec7cac55724a = (optimisticId)=>({
        type: $f5778d3443e35a12$export$7ba41b0f859cd9de,
        payload: {
            optimisticId: optimisticId
        }
    });
const $f5778d3443e35a12$export$c81d530f36bbff54 = 'state.entities.FETCH_DETAILS_FOR_ISSUES_REQUEST';
const $f5778d3443e35a12$export$d7bd258f937d3f97 = ()=>({
        type: $f5778d3443e35a12$export$c81d530f36bbff54
    });
const $f5778d3443e35a12$export$f06e411231cc9e0f = 'state.entities.FETCH_DETAILS_FOR_ISSUES_SUCCESS';
const $f5778d3443e35a12$export$f8212515c1fa259b = (issues)=>({
        type: $f5778d3443e35a12$export$f06e411231cc9e0f,
        payload: {
            issues: issues
        }
    });
const $f5778d3443e35a12$export$1ad8075453e254e8 = 'state.entities.REORDER_CHILDREN_REQUEST';
const $f5778d3443e35a12$export$956b72f97bc996b2 = (currentOrder, newOrder, currentIndex, newIndex, analyticsEvent)=>({
        type: $f5778d3443e35a12$export$1ad8075453e254e8,
        payload: {
            currentOrder: currentOrder,
            newOrder: newOrder,
            currentIndex: currentIndex,
            newIndex: newIndex
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $f5778d3443e35a12$export$90fd6e557d95c194 = 'state.entities.REORDER_CHILDREN_FAILED';
const $f5778d3443e35a12$export$7b24762ac1cea786 = (originalOrder, newOrder, originalIndex, newIndex)=>({
        type: $f5778d3443e35a12$export$90fd6e557d95c194,
        payload: {
            originalOrder: originalOrder,
            newOrder: newOrder,
            originalIndex: originalIndex,
            newIndex: newIndex
        }
    });
const $f5778d3443e35a12$export$114e6969a338330e = 'state.entities.REORDER_CHILDREN_SUCCESS';
const $f5778d3443e35a12$export$e3b2b5621f591898 = (newOrder)=>({
        type: $f5778d3443e35a12$export$114e6969a338330e,
        payload: {
            newOrder: newOrder
        }
    });
const $f5778d3443e35a12$export$5998f11ce66975f8 = 'state.entities.ADD_EXISTING_CHILD_ISSUE_REQUEST';
const $f5778d3443e35a12$export$3cd83357f07e71c2 = (issue, analyticsEvent)=>({
        type: $f5778d3443e35a12$export$5998f11ce66975f8,
        payload: issue,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });

});

parcelRegister("g0sGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc063d17997f0c57$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $fc063d17997f0c57$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    linkParentErrorTitle: {
        "id": "issue.views.common.child-issues-panel.flags.link-parent-error-title",
        "defaultMessage": "We couldn't link the child issue"
    },
    linkParentErrorDescription: {
        "id": "issue.views.common.child-issues-panel.flags.link-parent-error-description",
        "defaultMessage": "The issue was created but the linking failed. Head over to your board and try again."
    },
    reorderErrorTitle: {
        "id": "issue.views.common.child-issues-panel.flags.reorder-error-title",
        "defaultMessage": "We couldn't reorder those issues"
    },
    reorderErrorDescription: {
        "id": "issue.views.common.child-issues-panel.flags.reorder-error-description",
        "defaultMessage": "Wait a few moments, then give it another try."
    }
});

});


parcelRegister("e2gQc", function(module, exports) {

$parcel$export(module.exports, "useSortableIssueIdsStore", () => $546465a9b7226ac0$export$ca75c39b558050fc);
$parcel$export(module.exports, "useChildIssuesStoreSortBy", () => $546465a9b7226ac0$export$c7b58e1b12ebb090);
$parcel$export(module.exports, "useSortableIssuesActions", () => $546465a9b7226ac0$export$eac3b9336c54de4d);
$parcel$export(module.exports, "ChildIssuesContainer", () => $546465a9b7226ac0$export$dd374b36e04512);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $bAQXx = parcelRequire("bAQXx");
const $546465a9b7226ac0$export$d4c72bab9d6cc13a = {
    sortableIssueIds: [],
    sortBy: null
};
const $546465a9b7226ac0$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'child-issues',
    initialState: $546465a9b7226ac0$export$d4c72bab9d6cc13a,
    actions: $bAQXx
});
const $546465a9b7226ac0$var$getSortableIssueIds = (state)=>state.sortableIssueIds;
const $546465a9b7226ac0$var$getSortBy = (state)=>state.sortBy;
const $546465a9b7226ac0$export$ca75c39b558050fc = (0, $ggKAj.createHook)($546465a9b7226ac0$export$6f57813fe9f31bf9, {
    selector: $546465a9b7226ac0$var$getSortableIssueIds
});
const $546465a9b7226ac0$export$c7b58e1b12ebb090 = (0, $ggKAj.createHook)($546465a9b7226ac0$export$6f57813fe9f31bf9, {
    selector: $546465a9b7226ac0$var$getSortBy
});
const $546465a9b7226ac0$export$eac3b9336c54de4d = (0, $ggKAj.createHook)($546465a9b7226ac0$export$6f57813fe9f31bf9, {
    selector: null
});
const $546465a9b7226ac0$export$dd374b36e04512 = (0, $heB5U.createContainer)($546465a9b7226ac0$export$6f57813fe9f31bf9);

});
parcelRegister("bAQXx", function(module, exports) {

$parcel$export(module.exports, "setSortableIssueIds", () => $8310c2176ea49aec$export$5763ac7f115d9749);
$parcel$export(module.exports, "setSortBy", () => $8310c2176ea49aec$export$4aac69a920b337);
const $8310c2176ea49aec$export$5763ac7f115d9749 = (issueIds)=>({ setState: setState })=>{
        setState({
            sortableIssueIds: issueIds
        });
    };
const $8310c2176ea49aec$export$4aac69a920b337 = (sortBy)=>({ setState: setState })=>{
        setState({
            sortBy: sortBy
        });
    };

});


parcelRegister("ca2LP", function(module, exports) {

$parcel$export(module.exports, "useSortableIssueIds", () => $6f78ce9638d1e999$export$1f09001d531c9e73);
$parcel$export(module.exports, "useChildIssuesSortBy", () => $6f78ce9638d1e999$export$855e41c1ff63fce8);
$parcel$export(module.exports, "useShouldTriggerAiSuggestedIssues", () => $6f78ce9638d1e999$export$bb707452b8f5f214);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $e2gQc = parcelRequire("e2gQc");
const $6f78ce9638d1e999$export$1f09001d531c9e73 = ()=>{
    const [sortableIssueIds, { setSortableIssueIds: setSortableIssueIds }] = (0, $e2gQc.useSortableIssueIdsStore)();
    const setter = (0, $eUqFw.useCallback)((issueIds)=>setSortableIssueIds(issueIds), [
        setSortableIssueIds
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>({
            setSortableIssueIds: setter
        }), [
        setter
    ]);
    return [
        sortableIssueIds,
        actions
    ];
};
const $6f78ce9638d1e999$export$855e41c1ff63fce8 = ()=>{
    const [sortBy, { setSortBy: setSortByStore }] = (0, $e2gQc.useChildIssuesStoreSortBy)();
    const setSortBy = (0, $eUqFw.useCallback)((value)=>{
        setSortByStore(value);
    }, [
        setSortByStore
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>({
            setSortBy: setSortBy
        }), [
        setSortBy
    ]);
    return [
        sortBy,
        actions
    ];
};
const $6f78ce9638d1e999$export$bb707452b8f5f214 = ()=>{
    const [suggestIssue] = (0, $kJlBc.useQueryParam)('suggestIssue');
    const [shouldShowSuggestedAiIssues, setShouldShowSuggestedAiIssues] = (0, $eUqFw.useState)(false);
    // The `?suggestIssue=true` Query Param gets removed the moment `/ai-issue-breakdown/ui/issue-breakdown-button/index.tsx`
    // gets mounted, so we can't rely on it to stay in the URL.
    (0, $eUqFw.useEffect)(()=>{
        if (suggestIssue && suggestIssue === 'true') setShouldShowSuggestedAiIssues(true);
    }, [
        suggestIssue
    ]);
    return shouldShowSuggestedAiIssues;
};

});

parcelRegister("agEEp", function(module, exports) {

$parcel$export(module.exports, "CLASSIC_SUBTASKS", () => $39722621890c8b7b$export$a0a0e1fc254d9015);
$parcel$export(module.exports, "CLASSIC_PROJECT_EPIC_CHILDREN", () => $39722621890c8b7b$export$f87d2fadbed1d0dd);
$parcel$export(module.exports, "CLASSIC_PORTFOLIO_CHILDREN", () => $39722621890c8b7b$export$6a8b3349d8fb3a83);
$parcel$export(module.exports, "CHILDREN_ISSUES_PANEL", () => $39722621890c8b7b$export$81d2ced9fd1c2c0b);
$parcel$export(module.exports, "SORT_OPTION_RANKING", () => $39722621890c8b7b$export$8d9e522e9f62b161);
$parcel$export(module.exports, "SORT_OPTION_RANK", () => $39722621890c8b7b$export$8827211eb20c9339);
$parcel$export(module.exports, "SORT_OPTION_CREATED", () => $39722621890c8b7b$export$8d3797089050aa91);
$parcel$export(module.exports, "SORT_OPTION_KEY", () => $39722621890c8b7b$export$d879b2b7148194b9);
$parcel$export(module.exports, "SORT_OPTION_PRIORITY", () => $39722621890c8b7b$export$5f994e73cb583e5f);
$parcel$export(module.exports, "SORT_OPTION_STATUS", () => $39722621890c8b7b$export$4b4089441b7c58db);
$parcel$export(module.exports, "SORT_OPTION_ASSIGNEE", () => $39722621890c8b7b$export$85182067215efac4);
$parcel$export(module.exports, "DEFAULT_SORTING_OPTION", () => $39722621890c8b7b$export$9d3ba16906a30a36);
$parcel$export(module.exports, "SORTING_OPTIONS", () => $39722621890c8b7b$export$cbd7cec635d908a3);
const $39722621890c8b7b$export$a0a0e1fc254d9015 = 'classicSubtasks';
const $39722621890c8b7b$export$f87d2fadbed1d0dd = 'classicProjectEpicChildren';
const $39722621890c8b7b$export$6a8b3349d8fb3a83 = 'portfolioChildren';
const $39722621890c8b7b$export$81d2ced9fd1c2c0b = 'nextGenChildren';
const $39722621890c8b7b$export$8d9e522e9f62b161 = 'ranking';
const $39722621890c8b7b$export$8827211eb20c9339 = 'rank';
const $39722621890c8b7b$export$8d3797089050aa91 = 'created';
const $39722621890c8b7b$export$d879b2b7148194b9 = 'key';
const $39722621890c8b7b$export$5f994e73cb583e5f = 'priority';
const $39722621890c8b7b$export$4b4089441b7c58db = 'status';
const $39722621890c8b7b$export$85182067215efac4 = 'assignee';
const $39722621890c8b7b$export$9d3ba16906a30a36 = $39722621890c8b7b$export$8d9e522e9f62b161;
const $39722621890c8b7b$export$cbd7cec635d908a3 = [
    $39722621890c8b7b$export$8d9e522e9f62b161,
    $39722621890c8b7b$export$8d3797089050aa91,
    $39722621890c8b7b$export$d879b2b7148194b9,
    $39722621890c8b7b$export$5f994e73cb583e5f,
    $39722621890c8b7b$export$4b4089441b7c58db,
    $39722621890c8b7b$export$85182067215efac4
];

});

parcelRegister("eYv0b", function(module, exports) {

$parcel$export(module.exports, "transformIssueType", () => $280067063eaff7a7$export$96520244689f81c1);
// A collection of issue fields which are marked as `required`
// for the creation of an issue, but are considered as 'provided' since
// the data for these fields is supplied by Jira.
const $280067063eaff7a7$var$providedRequiredFields = [
    'summary',
    'issuetype',
    'parent',
    'project'
];
const $280067063eaff7a7$var$isRequiredFieldProvided = (fieldName)=>$280067063eaff7a7$var$providedRequiredFields.find((providedFieldName)=>fieldName === providedFieldName);
// A field is considered 'unsupported' if not provided by Jira,
// has no default value, and is a `required` field.
// @ts-expect-error - TS2304 - Cannot find name 'FieldMeta'.
const $280067063eaff7a7$var$hasUnsupportedRequiredField = (fields)=>!!Object.keys(fields).find((fieldName)=>!$280067063eaff7a7$var$isRequiredFieldProvided(fieldName) && !fields[fieldName].hasDefaultValue && fields[fieldName].required);
const $280067063eaff7a7$export$96520244689f81c1 = (issueType, epicLinkFieldKey)=>{
    const { fields: fields, ...otherProps } = issueType;
    const hasRequiredField = fields ? $280067063eaff7a7$var$hasUnsupportedRequiredField(fields) : false;
    // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    const hasEpicLinkField = fields ? Object.keys(fields).includes(epicLinkFieldKey) : false;
    return {
        ...otherProps,
        hasRequiredField: hasRequiredField,
        hasEpicLinkField: hasEpicLinkField
    };
};

});

parcelRegister("5uIng", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9b62eae13383d87$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $bUnYV = parcelRequire("bUnYV");

var $aaac6 = parcelRequire("aaac6");

var $i0NEj = parcelRequire("i0NEj");

var $1xQGV = parcelRequire("1xQGV");

var $feTH7 = parcelRequire("feTH7");

var $7zoeo = parcelRequire("7zoeo");

var $jbuyP = parcelRequire("jbuyP");

var $9BfG7 = parcelRequire("9BfG7");

var $10dAv = parcelRequire("10dAv");

var $b5NLl = parcelRequire("b5NLl");

var $alZBl = parcelRequire("alZBl");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a9b62eae13383d87$export$2e2bcd8739ae039 = (associatedIssuesContextActions, fieldsValuesActions, fieldConfigActions)=>(0, $bd1K7.combineEpics)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $1xQGV.default), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $7zoeo.default)(associatedIssuesContextActions, fieldsValuesActions, fieldConfigActions), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $i0NEj.default), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $feTH7.default), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $jbuyP.default), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $aaac6.default), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $alZBl.default), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $b5NLl.default), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $bUnYV.default), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $9BfG7.default)(fieldsValuesActions, associatedIssuesContextActions), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $10dAv.default)(associatedIssuesContextActions, fieldsValuesActions, fieldConfigActions));

});
parcelRegister("bUnYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3314ef32a81dfa93$export$2e2bcd8739ae039);
parcelRequire("l5lul");
parcelRequire("fiQ2m");

var $gUUjF = parcelRequire("gUUjF");

var $6vrw7 = parcelRequire("6vrw7");

var $imVNa = parcelRequire("imVNa");

var $agEEp = parcelRequire("agEEp");

var $2HCUG = parcelRequire("2HCUG");

var $iBvRb = parcelRequire("iBvRb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3314ef32a81dfa93$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $iBvRb.LINK_CHILD_SUCCESS), (0, $iBvRb.REORDER_CHILDREN_REQUEST), (0, $iBvRb.REORDER_CHILDREN_FAILED), (0, $iBvRb.FETCH_GRAPHQL_ISSUE_SUCCESS), (0, $iBvRb.UPDATE_ISSUE)).do((action)=>{
        try {
            const state = store.getState();
            const onChange = (0, $2HCUG.getOnChangeCallback)(state);
            const panelType = (0, $2HCUG.getChildIssuesPanelType)(state);
            switch(action.type){
                case 0, $iBvRb.FETCH_GRAPHQL_ISSUE_SUCCESS:
                    onChange({
                        type: (0, $imVNa.ChangeEventTypes).CHILD_ISSUE_ADDED,
                        meta: {
                            childIssue: action.payload.childIssue,
                            fieldsData: action.payload.fieldsData
                        }
                    });
                    break;
                case 0, $iBvRb.LINK_CHILD_SUCCESS:
                    onChange({
                        type: (0, $imVNa.ChangeEventTypes).CHILD_ISSUE_ADDED,
                        meta: {
                            childIssue: action.payload.linkedChild
                        }
                    });
                    break;
                case 0, $iBvRb.REORDER_CHILDREN_REQUEST:
                    {
                        const { currentOrder: currentOrder, newOrder: optimisticOrder, currentIndex: currentIndex, newIndex: newIndex } = action.payload;
                        const { id: issueId } = currentOrder[currentIndex];
                        const issueIds = issueId ? [
                            (0, $6vrw7.toIssueId)(issueId)
                        ] : [];
                        const isRankAfter = newIndex > currentIndex;
                        const rankId = Number((optimisticOrder[isRankAfter ? newIndex - 1 : newIndex + 1] || {}).id);
                        if (panelType === (0, $agEEp.CHILDREN_ISSUES_PANEL) || panelType === (0, $agEEp.CLASSIC_SUBTASKS)) onChange({
                            type: (0, $imVNa.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED,
                            meta: {
                                issueIds: issueIds,
                                rankId: rankId,
                                isRankAfter: isRankAfter
                            }
                        });
                        break;
                    }
                case 0, $iBvRb.REORDER_CHILDREN_FAILED:
                    {
                        const { originalOrder: currentOrder, originalIndex: currentIndex, newIndex: newIndex } = action.payload;
                        const { id: issueId } = currentOrder[currentIndex];
                        const issueIds = issueId ? [
                            (0, $6vrw7.toIssueId)(issueId)
                        ] : [];
                        const isRankAfter = currentIndex > newIndex;
                        const rankId = Number((currentOrder[isRankAfter ? currentIndex - 1 : currentIndex + 1] || {}).id);
                        if ((panelType === (0, $agEEp.CHILDREN_ISSUES_PANEL) || panelType === (0, $agEEp.CLASSIC_SUBTASKS)) && rankId) onChange({
                            type: (0, $imVNa.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED,
                            meta: {
                                issueIds: issueIds,
                                rankId: rankId,
                                isRankAfter: isRankAfter
                            }
                        });
                        break;
                    }
                case 0, $iBvRb.UPDATE_ISSUE:
                    if (panelType === (0, $agEEp.CLASSIC_SUBTASKS)) onChange({
                        type: (0, $imVNa.ChangeEventTypes).CHILD_ISSUE_FIELD_UPDATED,
                        meta: {
                            childIssueId: action.payload.id
                        }
                    });
                    break;
                default:
                    break;
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.change-notification', 'Failed to call onChange callback', error);
        }
    }).ignoreElements();

});
parcelRegister("2HCUG", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $8d79ec871e477f5a$export$f654b28f82155665);
$parcel$export(module.exports, "getChildIssuesPanelType", () => $8d79ec871e477f5a$export$58f272e135fd4a2a);
$parcel$export(module.exports, "getIsClassicSubtaskPanel", () => $8d79ec871e477f5a$export$362c51097d1ac897);
$parcel$export(module.exports, "getIsClassicProjectEpicPanel", () => $8d79ec871e477f5a$export$df61b3bae2c25541);
$parcel$export(module.exports, "getIsChildrenIssuesPanel", () => $8d79ec871e477f5a$export$cc98fcceda2f1b92);
$parcel$export(module.exports, "getSupportsIssueCreation", () => $8d79ec871e477f5a$export$5d22022f20ecc75);
$parcel$export(module.exports, "getRequiresFullCreateByIssueType", () => $8d79ec871e477f5a$export$5c419da88cdde9ba);
$parcel$export(module.exports, "getIssueTypeWFValidators", () => $8d79ec871e477f5a$export$7be48c18184ffec7);
$parcel$export(module.exports, "getParentKey", () => $8d79ec871e477f5a$export$2e0384ad620a9485);
$parcel$export(module.exports, "getOnEditAssociatedIssue", () => $8d79ec871e477f5a$export$b9241eafc69d2f56);
$parcel$export(module.exports, "getParentId", () => $8d79ec871e477f5a$export$e6e327a97512715e);
$parcel$export(module.exports, "getCustomFieldIdRank", () => $8d79ec871e477f5a$export$b4a1bb130a305ed0);
$parcel$export(module.exports, "getEpicLinkFieldKey", () => $8d79ec871e477f5a$export$72066b419d5854aa);
$parcel$export(module.exports, "getProjectId", () => $8d79ec871e477f5a$export$89040d072f281f85);
$parcel$export(module.exports, "getTitle", () => $8d79ec871e477f5a$export$70d1bf7729efff40);
$parcel$export(module.exports, "getChildTitle", () => $8d79ec871e477f5a$export$6bf60d64df87ed9d);
$parcel$export(module.exports, "getNoValueText", () => $8d79ec871e477f5a$export$5cf7889ebf5af181);
$parcel$export(module.exports, "getOnNavigateToNewIssue", () => $8d79ec871e477f5a$export$4f00588fd185469a);
$parcel$export(module.exports, "getOnChangeCallback", () => $8d79ec871e477f5a$export$cf929e78a123defa);
$parcel$export(module.exports, "getChildIssuesPanelProjectType", () => $8d79ec871e477f5a$export$f5cb43929ffb0af0);
$parcel$export(module.exports, "getIsSimplifiedProject", () => $8d79ec871e477f5a$export$b41c098b7c73fb56);
$parcel$export(module.exports, "getChildIssuesPanelApplication", () => $8d79ec871e477f5a$export$28174589e3e7cc20);
$parcel$export(module.exports, "getChildIssuesPanelEdition", () => $8d79ec871e477f5a$export$9056dd489d9c3df1);
$parcel$export(module.exports, "isWhitelistedPanelForSorting", () => $8d79ec871e477f5a$export$fc2a233dc51b3d65);
$parcel$export(module.exports, "isCompatibleSortingPanel", () => $8d79ec871e477f5a$export$4acf3379abca38c8);

var $df4Sl = parcelRequire("df4Sl");

var $agEEp = parcelRequire("agEEp");

var $hdQ73 = parcelRequire("hdQ73");

var $7xkAf = parcelRequire("7xkAf");
const $8d79ec871e477f5a$export$f654b28f82155665 = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.baseUrl);
const $8d79ec871e477f5a$export$180605366c04f0cd = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.locale);
const $8d79ec871e477f5a$export$58f272e135fd4a2a = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.childIssuesPanelType);
const $8d79ec871e477f5a$export$362c51097d1ac897 = (0, $df4Sl.createSelector)($8d79ec871e477f5a$export$58f272e135fd4a2a, (childIssuesPanelType)=>childIssuesPanelType ? childIssuesPanelType === (0, $agEEp.CLASSIC_SUBTASKS) : false);
const $8d79ec871e477f5a$export$df61b3bae2c25541 = (0, $df4Sl.createSelector)($8d79ec871e477f5a$export$58f272e135fd4a2a, (childIssuesPanelType)=>childIssuesPanelType ? childIssuesPanelType === (0, $agEEp.CLASSIC_PROJECT_EPIC_CHILDREN) : false);
const $8d79ec871e477f5a$export$cc98fcceda2f1b92 = (0, $df4Sl.createSelector)($8d79ec871e477f5a$export$58f272e135fd4a2a, (childIssuesPanelType)=>childIssuesPanelType ? childIssuesPanelType === (0, $agEEp.CHILDREN_ISSUES_PANEL) : false);
const $8d79ec871e477f5a$export$5d22022f20ecc75 = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.supportsIssueCreation);
const $8d79ec871e477f5a$export$f755f1954c0227bf = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.user === null || contextState.user === '');
const $8d79ec871e477f5a$export$5c419da88cdde9ba = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (0, $7xkAf.getSelectedIssueType), (0, $7xkAf.isFetchIssueTypesComplete), $8d79ec871e477f5a$export$f755f1954c0227bf, (context, selectedIssueType, fetchIssueTypesComplete, anonymousUser)=>{
    const requiresFullCreateByIssueType = selectedIssueType?.id && context.requiresFullCreateByIssueType[selectedIssueType.id];
    return anonymousUser || requiresFullCreateByIssueType || !fetchIssueTypesComplete;
});
const $8d79ec871e477f5a$export$7be48c18184ffec7 = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (0, $7xkAf.isFetchIssueTypesComplete), (context, fetchIssueTypesComplete)=>fetchIssueTypesComplete ? context.requiresFullCreateByIssueType : undefined);
const $8d79ec871e477f5a$export$2e0384ad620a9485 = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.parentKey);
const $8d79ec871e477f5a$export$b9241eafc69d2f56 = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.onEditAssociatedIssue);
const $8d79ec871e477f5a$export$e6e327a97512715e = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.parentId);
const $8d79ec871e477f5a$export$b4a1bb130a305ed0 = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.customFieldIdRank);
const $8d79ec871e477f5a$export$72066b419d5854aa = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.epicLinkFieldKey);
const $8d79ec871e477f5a$export$89040d072f281f85 = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.projectId);
const $8d79ec871e477f5a$var$getMessages = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.messages || {});
const $8d79ec871e477f5a$export$70d1bf7729efff40 = (0, $df4Sl.createSelector)($8d79ec871e477f5a$var$getMessages, (messages)=>messages.title);
const $8d79ec871e477f5a$export$6bf60d64df87ed9d = (0, $df4Sl.createSelector)($8d79ec871e477f5a$var$getMessages, (messages)=>messages.titleChildIssues);
const $8d79ec871e477f5a$export$5cf7889ebf5af181 = (0, $df4Sl.createSelector)($8d79ec871e477f5a$var$getMessages, // @ts-expect-error - TS2339 - Property 'noValueText' does not exist on type '{}'.
(messages)=>messages.noValueText || null);
const $8d79ec871e477f5a$export$4f00588fd185469a = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.onNavigateToNewIssue);
const $8d79ec871e477f5a$export$cf929e78a123defa = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.onChange);
const $8d79ec871e477f5a$export$79abb288cd093340 = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.isIssueViewComplete);
const $8d79ec871e477f5a$export$f5cb43929ffb0af0 = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.projectType);
const $8d79ec871e477f5a$export$b41c098b7c73fb56 = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.isSimplifiedProject);
const $8d79ec871e477f5a$export$28174589e3e7cc20 = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.application);
const $8d79ec871e477f5a$export$9056dd489d9c3df1 = (0, $df4Sl.createSelector)((0, $hdQ73.contextSelector), (contextState)=>contextState.edition);
const $8d79ec871e477f5a$export$fc2a233dc51b3d65 = (panelType)=>panelType === (0, $agEEp.CHILDREN_ISSUES_PANEL) || panelType === (0, $agEEp.CLASSIC_PROJECT_EPIC_CHILDREN);
const $8d79ec871e477f5a$export$4acf3379abca38c8 = (0, $df4Sl.createSelector)($8d79ec871e477f5a$export$58f272e135fd4a2a, $8d79ec871e477f5a$export$fc2a233dc51b3d65);

});
parcelRegister("hdQ73", function(module, exports) {

$parcel$export(module.exports, "contextSelector", () => $d392c0cc687f95da$export$c420c9f40402ab6d);
$parcel$export(module.exports, "entitiesSelector", () => $d392c0cc687f95da$export$ccebe5cc5854d0fa);
$parcel$export(module.exports, "uiSelector", () => $d392c0cc687f95da$export$185c0864c82372e3);
const $d392c0cc687f95da$export$c420c9f40402ab6d = (state)=>state.context;
const $d392c0cc687f95da$export$ccebe5cc5854d0fa = (state)=>state.entities;
const $d392c0cc687f95da$export$185c0864c82372e3 = (state)=>state.ui;

});

parcelRegister("7xkAf", function(module, exports) {

$parcel$export(module.exports, "getAddClickCount", () => $09f7a4be8052c147$export$eed45924747949f3);
$parcel$export(module.exports, "getChildPanelView", () => $09f7a4be8052c147$export$c51eccd230709f7a);
$parcel$export(module.exports, "getChildCreateSummary", () => $09f7a4be8052c147$export$2bb2803416fb800a);
$parcel$export(module.exports, "getSelectedIssueType", () => $09f7a4be8052c147$export$9122bf637eb6acc2);
$parcel$export(module.exports, "getHideDone", () => $09f7a4be8052c147$export$6107c714db0feff9);
$parcel$export(module.exports, "isFetchIssueTypesComplete", () => $09f7a4be8052c147$export$41816b36ca49fe1d);

var $df4Sl = parcelRequire("df4Sl");


var $6QyxX = parcelRequire("6QyxX");

var $hdQ73 = parcelRequire("hdQ73");
const $09f7a4be8052c147$export$eed45924747949f3 = (0, $df4Sl.createSelector)((0, $hdQ73.uiSelector), (uiState)=>uiState.addClickCount);
const $09f7a4be8052c147$export$c51eccd230709f7a = (0, $df4Sl.createSelector)((0, $hdQ73.uiSelector), (uiState)=>uiState.childPanelView);
const $09f7a4be8052c147$export$2bb2803416fb800a = (0, $df4Sl.createSelector)((0, $hdQ73.uiSelector), (uiState)=>uiState.childCreateSummary);
const $09f7a4be8052c147$export$9122bf637eb6acc2 = (0, $df4Sl.createSelector)((0, $hdQ73.uiSelector), (0, $6QyxX.getIssueTypes), ({ selectedIssueType: selectedIssueType }, issueTypes)=>// to maintain "single source of truth" return issueType matching selectedIssueType
    selectedIssueType && issueTypes.find((it)=>it.id === selectedIssueType.id) || issueTypes[0]);
const $09f7a4be8052c147$export$6107c714db0feff9 = (0, $df4Sl.createSelector)((0, $hdQ73.uiSelector), (uiState)=>uiState.hideDone);
const $09f7a4be8052c147$var$getFetchIssueTypesStatus = (0, $df4Sl.createSelector)((0, $hdQ73.uiSelector), (uiState)=>uiState.fetchIssueTypesStatus);
const $09f7a4be8052c147$export$41816b36ca49fe1d = (0, $df4Sl.createSelector)($09f7a4be8052c147$var$getFetchIssueTypesStatus, (status)=>status === (0, $79689153693cd31b$export$1e006e11f4ec3452));

});
parcelRegister("6QyxX", function(module, exports) {

$parcel$export(module.exports, "getAllIssues", () => $a8d923206651d50d$export$7d1865fcc78ac59e);
$parcel$export(module.exports, "getCompletedIssues", () => $a8d923206651d50d$export$e20ffa1eb575f585);
$parcel$export(module.exports, "getIncompleteIssues", () => $a8d923206651d50d$export$15e314e1acee6ed8);
$parcel$export(module.exports, "getInProgressIssues", () => $a8d923206651d50d$export$5cd854cfeba74b7f);
$parcel$export(module.exports, "getIssueHierarchyLevel", () => $a8d923206651d50d$export$c9886db3e23d0fc3);
$parcel$export(module.exports, "getIssue", () => $a8d923206651d50d$export$34403cb88b30d33b);
$parcel$export(module.exports, "getRecentlyCreatedIssue", () => $a8d923206651d50d$export$5e1f984a876bd0f4);
$parcel$export(module.exports, "getIssueTypes", () => $a8d923206651d50d$export$4cf4b24b88599615);
$parcel$export(module.exports, "getNextGenChildrenIssueTypesJql", () => $a8d923206651d50d$export$1567f3d9a2fdded3);

var $df4Sl = parcelRequire("df4Sl");

var $8i1R8 = parcelRequire("8i1R8");

var $8Qd0L = parcelRequire("8Qd0L");

var $hdQ73 = parcelRequire("hdQ73");
const $a8d923206651d50d$export$7d1865fcc78ac59e = (0, $df4Sl.createSelector)((0, $hdQ73.entitiesSelector), (entitiesState)=>entitiesState.issues || []);
const $a8d923206651d50d$export$e20ffa1eb575f585 = (0, $df4Sl.createSelector)($a8d923206651d50d$export$7d1865fcc78ac59e, (issues)=>issues.filter((issue)=>issue.statusCategory === (0, $8Qd0L.DONE)));
const $a8d923206651d50d$export$15e314e1acee6ed8 = (0, $df4Sl.createSelector)($a8d923206651d50d$export$7d1865fcc78ac59e, (issues)=>issues.filter((issue)=>issue.statusCategory !== (0, $8Qd0L.DONE)));
const $a8d923206651d50d$export$5cd854cfeba74b7f = (0, $df4Sl.createSelector)($a8d923206651d50d$export$7d1865fcc78ac59e, (issues)=>issues.filter((issue)=>issue.statusCategory === (0, $8Qd0L.IN_PROGRESS)));
const $a8d923206651d50d$export$c9886db3e23d0fc3 = (0, $df4Sl.createSelector)((0, $hdQ73.entitiesSelector), (entitiesState)=>entitiesState.issueHierarchyLevel);
const $a8d923206651d50d$export$34403cb88b30d33b = (id)=>(0, $df4Sl.createSelector)($a8d923206651d50d$export$7d1865fcc78ac59e, (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(issues, (issue)=>issue.id === id));
const $a8d923206651d50d$export$5e1f984a876bd0f4 = (0, $df4Sl.createSelector)((0, $hdQ73.entitiesSelector), (entitiesState)=>entitiesState.recentlyCreatedIssue);
const $a8d923206651d50d$export$4cf4b24b88599615 = (0, $df4Sl.createSelector)((0, $hdQ73.entitiesSelector), (entitiesState)=>entitiesState.issueTypes);
const $a8d923206651d50d$export$1567f3d9a2fdded3 = (0, $df4Sl.createSelector)($a8d923206651d50d$export$4cf4b24b88599615, (issueTypes)=>`issuetype in (${issueTypes.map((issueType)=>issueType.id).join(',')})`);

});




parcelRegister("aaac6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d5aab30e34b6bec$export$2e2bcd8739ae039);
parcelRequire("9u6v2");
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $7iIse = parcelRequire("7iIse");

var $2HCUG = parcelRequire("2HCUG");

var $iBvRb = parcelRequire("iBvRb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1d5aab30e34b6bec$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $iBvRb.CHILD_CREATED_IN_FULL_DIALOG)).mergeMap(({ payload: payload, meta: meta })=>{
        const state = store.getState();
        const { optimisticId: optimisticId, createdChild: createdChild } = payload;
        const isChildrenIssuesPanel = (0, $2HCUG.getIsChildrenIssuesPanel)(state);
        // For non-NextGen issues the child creation is a one-step process, so once the
        // child issue is created, we can dispatch the createChildSuccess action
        if (!isChildrenIssuesPanel) return (0, $3JafE.Observable).of((0, $iBvRb.createChildSuccess)(optimisticId, createdChild, meta.analyticsEvent, true));
        // If the child a NextGen issue, it requires an additional "link to parent" step
        // before we can dispatch createChildSuccess
        // Note: this is temporary (https://hello.atlassian.net/wiki/spaces/JPLAT/pages/376819072/DACI+How+to+create+next-gen+subtasks)
        const baseUrl = (0, $2HCUG.getBaseUrl)(state);
        const projectId = (0, $2HCUG.getProjectId)(state);
        const parentId = (0, $2HCUG.getParentId)(state);
        if (!projectId || !parentId) throw new Error('Attempted to link a child issue without a project or parent issue ID');
        return (0, $3JafE.Observable).from((0, $7iIse.default)(baseUrl, projectId, parentId, createdChild.id)).map(()=>(0, $iBvRb.createChildSuccess)(optimisticId, createdChild, meta.analyticsEvent, true)).catch((error)=>(0, $3JafE.Observable).of((0, $iBvRb.linkParentFailure)(optimisticId, error)));
    });

});
parcelRegister("7iIse", function(module, exports) {

$parcel$export(module.exports, "default", () => $d693cd2846afeba0$export$2e2bcd8739ae039);

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d693cd2846afeba0$export$2e2bcd8739ae039 = (baseUrl, projectId, parentId, childId)=>(0, $lRmyA.performPostRequest)(`${baseUrl}/rest/internal/simplified/1.0/projects/${projectId}/issues/${parentId}/children`, {
        body: JSON.stringify({
            issueIds: [
                childId
            ]
        })
    });

});


parcelRegister("i0NEj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ebc83cd07f36f7f$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("l5lul");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $JRB5w = parcelRequire("JRB5w");

var $7byHA = parcelRequire("7byHA");

var $4ceCM = parcelRequire("4ceCM");

var $2HCUG = parcelRequire("2HCUG");

var $iBvRb = parcelRequire("iBvRb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3ebc83cd07f36f7f$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $iBvRb.CREATE_CHILD_FAILURE), (0, $iBvRb.LINK_PARENT_FAILURE), (0, $iBvRb.LINKING_ISSUE_FAILURE)).do(({ type: type, payload: { error: error } })=>{
        const state = store.getState();
        const childIssuePanelType = (0, $2HCUG.getChildIssuesPanelType)(state) || 'unknown_child';
        const application = (0, $2HCUG.getChildIssuesPanelApplication)(state);
        const edition = (0, $2HCUG.getChildIssuesPanelEdition)(state);
        /*
                SLA Monitoring

                Almost any time these FAILURE actions are sent, we send a createIssue failure event.

                Except: it is possible for an admin to misconfigure their project in such a way that
                the Global Issue Create dialog doesn't handle all required fields, and the Issue Create
                API request still returns a 400 BAD REQUEST. This is "expected", and so we track it
                as a "success" and not a failure.

                Also, any AbortError or TypeError is a result of an operation being cancelled by the
                user (e.g. navigating away from the page before the request is complete) and so we
                do not count these in our frontend SLA events at all.
             */ if (type === (0, $iBvRb.CREATE_CHILD_FAILURE) && error.name === (0, $7byHA.VALIDATION_ERROR_NAME)) (0, $4ceCM.sendExperienceAnalytics)({
            experience: 'createIssue',
            wasExperienceSuccesful: true,
            analyticsSource: childIssuePanelType,
            application: application,
            edition: edition
        });
        else if (error.name !== (0, $7byHA.ABORT_ERROR_NAME) && !(0, $JRB5w.isClientFetchError)(error)) {
            if ((0, $JRB5w.isHttpClientErrorResponse)(error)) return;
            (0, $4ceCM.sendExperienceAnalytics)({
                experience: 'createIssue',
                wasExperienceSuccesful: false,
                analyticsSource: childIssuePanelType,
                application: application,
                edition: edition,
                additionalAttributes: {
                    // @ts-expect-error - TS2339 - Property 'traceId' does not exist on type 'Error | ValidationError'.
                    traceId: error.traceId,
                    errorMessage: `${type} ${error.message}`
                }
            });
        }
    }).switchMap(()=>(0, $3JafE.Observable).empty());

});

parcelRegister("1xQGV", function(module, exports) {

$parcel$export(module.exports, "default", () => $80855d6334cc4a5c$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("9u6v2");
parcelRequire("flmol");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $3rKK4 = parcelRequire("3rKK4");

var $2HCUG = parcelRequire("2HCUG");

var $iBvRb = parcelRequire("iBvRb");
const $80855d6334cc4a5c$var$createChildIssue = (state, optimisticUiChildIssue, analyticsEvent)=>{
    const baseUrl = (0, $2HCUG.getBaseUrl)(state);
    const projectId = (0, $2HCUG.getProjectId)(state);
    const parentIssueId = (0, $2HCUG.getParentId)(state);
    const isClassicSubtaskPanel = (0, $2HCUG.getIsClassicSubtaskPanel)(state);
    const isChildrenIssuesPanel = (0, $2HCUG.getIsChildrenIssuesPanel)(state);
    const isClassicProjectEpicPanel = (0, $2HCUG.getIsClassicProjectEpicPanel)(state);
    if (!projectId || !parentIssueId) throw new Error('Attempted to create a new child issue without a project or parent issue ID');
    const shouldIncludeParentId = isClassicSubtaskPanel || isChildrenIssuesPanel || isClassicProjectEpicPanel;
    const createPayload = {
        fields: {
            project: {
                id: projectId
            },
            issuetype: {
                id: optimisticUiChildIssue.issueTypeId
            },
            summary: optimisticUiChildIssue.issueSummary,
            ...shouldIncludeParentId ? {
                parent: {
                    id: parentIssueId
                }
            } : null
        }
    };
    return (0, $3JafE.Observable).from((0, $3rKK4.default)(baseUrl, createPayload, optimisticUiChildIssue)).mergeMap((createdChild)=>(0, $3JafE.Observable).of((0, $iBvRb.createChildSuccess)(optimisticUiChildIssue.id, createdChild, analyticsEvent))).catch((error)=>(0, $3JafE.Observable).of((0, $iBvRb.createChildFailure)(optimisticUiChildIssue.id, error)));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80855d6334cc4a5c$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $iBvRb.CREATE_CHILD_REQUEST)).mergeMap(({ payload: payload, meta: meta })=>{
        const state = store.getState();
        const { optimisticUiChildIssue: optimisticUiChildIssue } = payload;
        return $80855d6334cc4a5c$var$createChildIssue(state, optimisticUiChildIssue, meta.analyticsEvent);
    });

});
parcelRegister("3rKK4", function(module, exports) {

$parcel$export(module.exports, "default", () => $df90f92820288f8b$export$2e2bcd8739ae039);

var $7kw05 = parcelRequire("7kw05");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$df90f92820288f8b$export$2e2bcd8739ae039 = (baseUrl, createPayload, optimisticUiChildIssue)=>(0, $7kw05.default)(baseUrl, createPayload).then((createdIssue)=>({
            id: createdIssue.id,
            issueKey: createdIssue.key,
            issueLink: `${baseUrl}/browse/${createdIssue.key}`,
            issueSummary: optimisticUiChildIssue.issueSummary,
            issueTypeIconUrl: optimisticUiChildIssue.issueTypeIconUrl,
            issueTypeName: optimisticUiChildIssue.issueTypeName,
            assigneeUrl: optimisticUiChildIssue.assigneeUrl,
            assigneeDisplayName: optimisticUiChildIssue.assigneeDisplayName,
            isLoading: false,
            errorType: undefined
        }));

});
parcelRegister("7kw05", function(module, exports) {

$parcel$export(module.exports, "default", () => $53c9c496e7c71714$export$2e2bcd8739ae039);

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$53c9c496e7c71714$export$2e2bcd8739ae039 = (baseUrl, createPayload)=>(0, $lRmyA.performPostRequest)(`${baseUrl}/rest/api/2/issue`, {
        body: JSON.stringify(createPayload)
    });

});



parcelRegister("feTH7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b7a486c188b6bcb$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $iBvRb = parcelRequire("iBvRb");

var $6QyxX = parcelRequire("6QyxX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b7a486c188b6bcb$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $iBvRb.CREATE_CHILD_RETRY)).map(({ payload: { optimisticId: optimisticId }, meta: meta })=>{
        const state = store.getState();
        const issue = (0, $6QyxX.getIssue)(optimisticId)(state);
        // @ts-expect-error - TS2339 - Property 'isLoading' does not exist on type 'ChildIssue | undefined'. | TS2339 - Property 'hasError' does not exist on type 'ChildIssue | undefined'.
        const { isLoading: isLoading, hasError: hasError, ...issueDetails } = issue;
        // @ts-expect-error - TS2345 - Argument of type '{ id: string; issueId?: string | undefined; issueKey?: string | undefined; issueLink?: string | undefined; assigneeUrl?: string | null | undefined; assigneeDisplayName?: string | null | undefined; ... 17 more ...; updated?: Date | undefined; }' is not assignable to parameter of type 'OptimisticUiChildIssue'.
        return (0, $iBvRb.createChildRequest)(issueDetails, meta.analyticsEvent);
    });

});

parcelRegister("7zoeo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5695d84a3e1dcd01$export$2e2bcd8739ae039);
parcelRequire("9u6v2");
parcelRequire("8jBvP");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("l5lul");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $jUhyG = parcelRequire("jUhyG");

var $gUUjF = parcelRequire("gUUjF");

var $bPG0x = parcelRequire("bPG0x");

var $jBy23 = parcelRequire("jBy23");

var $3AuzW = parcelRequire("3AuzW");

var $bvCGh = parcelRequire("bvCGh");

var $lAi7F = parcelRequire("lAi7F");

var $6zsYX = parcelRequire("6zsYX");

var $6vrw7 = parcelRequire("6vrw7");

var $2HCUG = parcelRequire("2HCUG");

var $iBvRb = parcelRequire("iBvRb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5695d84a3e1dcd01$export$2e2bcd8739ae039 = (associatedIssuesContextActions, fieldsValuesActions, fieldConfigActions)=>(action$, store)=>action$.ofType((0, $iBvRb.CREATE_CHILD_SUCCESS)).do(({ payload: { createdChild: createdChild, usedGlobalCreateDialog: usedGlobalCreateDialog }, meta: meta })=>{
            const state = store.getState();
            // Feature monitoring
            const isClassicSubtask = (0, $2HCUG.getIsClassicSubtaskPanel)(state);
            const additionalAttributes = meta.additionalAttributes ?? {};
            const attributes = {
                action: 'created',
                actionSubjectId: createdChild.id,
                attributes: {
                    isInlineCreatedOnIssue: true,
                    isClassicSubtask: isClassicSubtask,
                    ...additionalAttributes
                }
            };
            (0, $jUhyG.fireTrackAnalytics)(meta.analyticsEvent, attributes);
            /**
                        SLA monitoring

                        Ordinarily the Global Create dialog would fire its own Create Issue SLA events.
                        However in the child issues panel we bind the `issueCreated` event which overrides
                        this default behaviour. So we send the event here in both (global and inline) cases.
                        */ const childIssuePanelType = (0, $2HCUG.getChildIssuesPanelType)(state) || 'unknown_child';
            const application = (0, $2HCUG.getChildIssuesPanelApplication)(state);
            const edition = (0, $2HCUG.getChildIssuesPanelEdition)(state);
            (0, $bPG0x.sendExperienceAnalytics)({
                getExperienceDescription: ()=>({
                        experience: 'createIssue',
                        wasExperienceSuccesful: true,
                        analyticsSource: childIssuePanelType,
                        application: application,
                        edition: edition,
                        additionalAttributes: {
                            isCreated: true,
                            wasCreatedInline: !usedGlobalCreateDialog
                        }
                    })
            });
        }).mergeMap(({ payload: { createdChild: createdChild } })=>{
            const state = store.getState();
            const baseUrl = (0, $2HCUG.getBaseUrl)(state);
            const issueKey = createdChild.issueKey !== undefined && createdChild.issueKey !== null ? (0, $6vrw7.toIssueKey)(createdChild.issueKey) : undefined;
            const projectKey = issueKey !== undefined ? (0, $jBy23.extractProjectKey)(issueKey) : undefined;
            if (!issueKey || !projectKey) {
                const errorMessage = 'Issue or project key missing when handling create child success';
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.create-child-success.missing-key', errorMessage, new Error(errorMessage));
                return (0, $3JafE.Observable).empty();
            }
            const fetchIssueFromGraphQL$ = ()=>(0, $3JafE.Observable).from((0, $3AuzW.fetchIssueGraphQlData)(baseUrl, issueKey, projectKey)).map(({ data: graphqlData })=>{
                    const fieldsData = (0, $6zsYX.getGraphQlFields)(graphqlData);
                    const issue = {
                        id: graphqlData.issue.id,
                        key: issueKey,
                        self: '',
                        fields: Object.values(fieldsData),
                        // Added to satisfy Flow; `transformChild` will not use these fields
                        agile: {},
                        customFields: {
                            textareaAdf: []
                        },
                        systemFields: {}
                    };
                    const transformedData = (0, $lAi7F.transformChild)(issue, (0, $2HCUG.getIsSimplifiedProject)(state));
                    associatedIssuesContextActions && associatedIssuesContextActions.mergeLocalAssociatedIssuesContext({
                        [issueKey]: {
                            estimateFieldId: transformedData.estimateFieldId,
                            isResolved: transformedData.isResolved ?? false
                        }
                    });
                    if (fieldsData && fieldsValuesActions && fieldConfigActions) {
                        const { fieldValues: fieldValues, fieldConfigs: fieldConfigs } = (0, $bvCGh.extractFromObject)(fieldsData);
                        fieldsValuesActions.setIssue(issueKey, fieldValues);
                        fieldConfigActions.setIssueConfig(issueKey, fieldConfigs);
                    }
                    return (0, $iBvRb.fetchGraphqlIssueSuccess)({
                        childIssue: transformedData,
                        fieldsData: fieldsData
                    });
                }).catch((error)=>{
                    (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.create-child-success.fetch-issue-graphql', 'Failed to fetch issue after a successful create', error);
                    return (0, $3JafE.Observable).empty();
                });
            return fetchIssueFromGraphQL$();
        });

});
parcelRegister("3AuzW", function(module, exports) {

$parcel$export(module.exports, "fetchIssueGraphQlData", () => $b2d14194786c0acf$export$eece611cf467b9ce);

var $lEpcX = parcelRequire("lEpcX");

var $2OdyW = parcelRequire("2OdyW");

var $dwyR8 = parcelRequire("dwyR8");
var $kPvBW = parcelRequire("kPvBW");

var $a60Hj = parcelRequire("a60Hj");
const $b2d14194786c0acf$var$ISSUE_GRAPHQL_DATA = 'issue-graphql-data';
const $b2d14194786c0acf$var$timeToFetchIssueGraphQlDataMetric = (0, $lEpcX.metrics).custom({
    key: $b2d14194786c0acf$var$ISSUE_GRAPHQL_DATA
});
const $b2d14194786c0acf$export$eece611cf467b9ce = (baseUrl, issueKey, projectKey)=>{
    if ((0, $a60Hj.isInSample)()) $b2d14194786c0acf$var$timeToFetchIssueGraphQlDataMetric.start();
    const issueGraphqlDataPromise = (0, $2OdyW.default)((0, $dwyR8.getGraphQlUrl)(baseUrl, (0, $kPvBW.IssueViewFetchOperations).INITIAL_GRAPHQL), (0, $dwyR8.getFieldDataOptions)(issueKey, projectKey)).then((response)=>{
        // Best-effort attempt to provide `issueId` and is not guaranteed
        const issueId = response.data?.issue?.id;
        $b2d14194786c0acf$var$timeToFetchIssueGraphQlDataMetric.stop({
            customData: issueId ? {
                issueId: issueId
            } : null
        });
        return response;
    }).catch((error)=>{
        // Cancel the metric and re-throw the error
        $b2d14194786c0acf$var$timeToFetchIssueGraphQlDataMetric.cancel();
        throw error;
    });
    return issueGraphqlDataPromise;
};

});
parcelRegister("dwyR8", function(module, exports) {

$parcel$export(module.exports, "getGraphQlUrl", () => $82ad8876acbb4446$export$5647e6bbf2b3526f);
$parcel$export(module.exports, "getFieldDataOptions", () => $82ad8876acbb4446$export$f2fec0cacdfabaaf);

var $k0k8C = parcelRequire("k0k8C");

var $aAj2A = parcelRequire("aAj2A");
const $82ad8876acbb4446$export$5647e6bbf2b3526f = (baseUrl, operation)=>`${baseUrl}/rest/graphql/1/${(0, $k0k8C.appendOperationQuery)(operation)}`;
const $82ad8876acbb4446$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: (0, $aAj2A.default)(issueKey, projectKey)
        })
    });

});
parcelRegister("aAj2A", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f04a44c8c5fa855$export$2e2bcd8739ae039);
const $2f04a44c8c5fa855$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};
const $2f04a44c8c5fa855$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
const $2f04a44c8c5fa855$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
const $2f04a44c8c5fa855$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
const $2f04a44c8c5fa855$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
const $2f04a44c8c5fa855$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
var // Disable this eslint rule temporarily so we can query for configuration
// eslint-disable-next-line jira/import/no-anonymous-default-export
$2f04a44c8c5fa855$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$2f04a44c8c5fa855$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$2f04a44c8c5fa855$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$2f04a44c8c5fa855$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$2f04a44c8c5fa855$var$getIsHybridAgilityProjectQuery()}
            ${$2f04a44c8c5fa855$var$getAgileQuery()}
        }
        ${$2f04a44c8c5fa855$var$getProjectQuery(projectKey)}
    }`;

});




parcelRegister("jbuyP", function(module, exports) {

$parcel$export(module.exports, "default", () => $8189b75924f49973$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("9u6v2");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $avGAV = parcelRequire("avGAV");

var $2HCUG = parcelRequire("2HCUG");

var $iBvRb = parcelRequire("iBvRb");

var $6QyxX = parcelRequire("6QyxX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8189b75924f49973$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $iBvRb.FETCH_DETAILS_FOR_ISSUES_REQUEST)).switchMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $2HCUG.getBaseUrl)(state);
        const issues = (0, $6QyxX.getAllIssues)(state);
        const issueKeys = issues.map((issue)=>issue.issueKey).filter((issueKey)=>issueKey !== undefined);
        // @ts-expect-error - TS2345 - Argument of type '(string | undefined)[]' is not assignable to parameter of type 'string[]'.
        return (0, $3JafE.Observable).from((0, $avGAV.default)(baseUrl, issueKeys)).map((detailsForIssues)=>(0, $iBvRb.fetchDetailsForIssuesSuccess)(detailsForIssues)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.fetch-details-for-issues', 'Failed to fetch details for issues', error);
            return (0, $3JafE.Observable).empty();
        });
    });

});
parcelRegister("avGAV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9585b0fb86948411$export$2e2bcd8739ae039);

var $blHvU = parcelRequire("blHvU");

var $bWA17 = parcelRequire("bWA17");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9585b0fb86948411$export$2e2bcd8739ae039 = (baseUrl, issueKeys)=>(0, $bWA17.default)(baseUrl, issueKeys).then((issues)=>issues.map(({ id: id, fields: fields })=>({
                id: id,
                assigneeUrl: fields && fields.assignee && (0, $blHvU.transformUser)(fields.assignee).avatarUrl,
                assigneeDisplayName: fields && fields.assignee && (0, $blHvU.transformUser)(fields.assignee).displayName
            })));

});
parcelRegister("bWA17", function(module, exports) {

$parcel$export(module.exports, "default", () => $d897b92e5fbd32ee$export$2e2bcd8739ae039);

var $3b0Pa = parcelRequire("3b0Pa");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d897b92e5fbd32ee$export$2e2bcd8739ae039 = (baseUrl, issueKeys)=>(0, $3b0Pa.fetchBulkIssues)(baseUrl, issueKeys, [
        'assignee'
    ]).toPromise();

});



parcelRegister("9BfG7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d736967697109e0d$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("9u6v2");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $8Y8Vi = parcelRequire("8Y8Vi");

var $f9RL0 = parcelRequire("f9RL0");

var $agEEp = parcelRequire("agEEp");

var $9cSnx = parcelRequire("9cSnx");

var $2HCUG = parcelRequire("2HCUG");

var $iBvRb = parcelRequire("iBvRb");

var $6QyxX = parcelRequire("6QyxX");
const $d736967697109e0d$var$linkNextGenChildIssue = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
issueId, state, // eslint-disable-next-line @typescript-eslint/no-explicit-any
analyticsEvent, fieldsValuesActions, associatedIssuesContextActions)=>{
    const baseUrl = (0, $2HCUG.getBaseUrl)(state);
    const parentIssueId = (0, $2HCUG.getParentId)(state);
    // @ts-expect-error - TS2345 - Type 'ChildIssue | undefined' is not assignable to type 'ChildIssue'.
    const issue = (0, $6QyxX.getIssue)(issueId)(state);
    if (!parentIssueId) throw new Error('Attempted to link a next-gen issue to a parent without issue ID ');
    if (issue?.issueKey) {
        const parentIssueKey = (0, $2HCUG.getParentKey)(state);
        fieldsValuesActions?.setIssue(issue.issueKey, {
            summary: issue.issueSummary,
            issueType: {
                iconUrl: issue.issueTypeIconUrl,
                name: 'issuetype'
            }
        });
        const currentChildren = parentIssueKey && fieldsValuesActions?.getFieldValue(parentIssueKey, (0, $f9RL0.CHILDREN_ISSUES)).filter((existingIssue)=>existingIssue.id !== issue.id) || [];
        parentIssueKey && fieldsValuesActions?.mergeIssue(parentIssueKey, {
            [(0, $f9RL0.CHILDREN_ISSUES)]: [
                ...currentChildren,
                {
                    id: issue.id,
                    key: issue.issueKey
                }
            ]
        });
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $3JafE.Observable).from((0, $9cSnx.nextGenLinkIssue)(baseUrl, parentIssueId, issueId)).map(()=>(0, $iBvRb.linkChildSuccess)(issueId, issue, analyticsEvent)).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.add-existing-issue', 'Failed to link a next-gen issue to a parent', error);
        if (issue.issueKey) associatedIssuesContextActions?.mergeSingleLocalAssociatedIssueContext(issue.issueKey, {
            hasError: true,
            errorType: (0, $8Y8Vi.associatedIssueErrorTypes).linkChild
        });
        return (0, $3JafE.Observable).of((0, $iBvRb.linkingIssueRetryFailure)(issueId));
    });
};
const $d736967697109e0d$var$addExistingChildEpic = (fieldsValuesActions, associatedIssuesContextActions)=>(action$, store)=>action$.ofType((0, $iBvRb.ADD_EXISTING_CHILD_ISSUE_REQUEST)).mergeMap(({ payload: { issueId: issueId }, meta: { analyticsEvent: analyticsEvent } })=>{
            const state = store.getState();
            const panelType = (0, $2HCUG.getChildIssuesPanelType)(state);
            switch(panelType){
                case 0, $agEEp.CHILDREN_ISSUES_PANEL:
                    return $d736967697109e0d$var$linkNextGenChildIssue(issueId, state, analyticsEvent, fieldsValuesActions, associatedIssuesContextActions);
                default:
                    return (0, $3JafE.Observable).empty();
            }
        });
const $d736967697109e0d$var$linkingIssueRetryEpic = (fieldsValuesActions, associatedIssuesContextActions)=>(action$, store)=>action$.ofType((0, $iBvRb.LINKING_ISSUE_RETRY)).mergeMap(({ payload: { issueId: issueId }, meta: { analyticsEvent: analyticsEvent } })=>{
            const state = store.getState();
            const panelType = (0, $2HCUG.getChildIssuesPanelType)(state);
            switch(panelType){
                case 0, $agEEp.CLASSIC_PROJECT_EPIC_CHILDREN:
                    {
                        const baseUrl = (0, $2HCUG.getBaseUrl)(state);
                        const parentIssueId = (0, $2HCUG.getParentId)(state);
                        // @ts-expect-error - TS2345 - Type 'ChildIssue | undefined' is not assignable to type 'ChildIssue'.
                        const issue = (0, $6QyxX.getIssue)(issueId)(state);
                        if (!parentIssueId) throw new Error('Attempted to link a classic issue to an epic without a parent issue ID');
                        return (0, $3JafE.Observable).from((0, $9cSnx.classicEpicLinkIssue)(baseUrl, parentIssueId, issueId)).map(()=>(0, $iBvRb.linkChildSuccess)(issueId, issue, analyticsEvent)).catch((error)=>{
                            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.link-child-issue', 'Failed to link a classic issue to a parent', error);
                            return (0, $3JafE.Observable).of((0, $iBvRb.linkingIssueRetryFailure)(issueId));
                        });
                    }
                case 0, $agEEp.CHILDREN_ISSUES_PANEL:
                    return $d736967697109e0d$var$linkNextGenChildIssue(issueId, state, analyticsEvent, fieldsValuesActions, associatedIssuesContextActions);
                default:
                    return (0, $3JafE.Observable).empty();
            }
        });
const $d736967697109e0d$var$epics = (fieldsValuesActions, associatedIssuesContextActions)=>(0, $bd1K7.combineEpics)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $d736967697109e0d$var$linkingIssueRetryEpic(fieldsValuesActions, associatedIssuesContextActions), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $d736967697109e0d$var$addExistingChildEpic(fieldsValuesActions, associatedIssuesContextActions));
var $d736967697109e0d$export$2e2bcd8739ae039 = $d736967697109e0d$var$epics;

});
parcelRegister("9cSnx", function(module, exports) {

$parcel$export(module.exports, "classicEpicLinkIssue", () => $e681a83e2101ccd8$export$e51e6895b9d58e3e);
$parcel$export(module.exports, "nextGenLinkIssue", () => $e681a83e2101ccd8$export$3c035cbcbc89ca84);

var $lRmyA = parcelRequire("lRmyA");
const $e681a83e2101ccd8$export$e51e6895b9d58e3e = (baseUrl, parentId, issueId)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/greenhopper/1.0/epics/${parentId}/add`, {
        body: JSON.stringify({
            ignoreEpics: true,
            issueKeys: [
                issueId
            ]
        })
    });
const $e681a83e2101ccd8$export$3c035cbcbc89ca84 = (baseUrl, parentId, issueId)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueId}`, {
        body: JSON.stringify({
            fields: {
                parent: {
                    id: parentId
                }
            }
        })
    });

});


parcelRegister("10dAv", function(module, exports) {

$parcel$export(module.exports, "default", () => $684b30070065532e$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("9u6v2");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("l5lul");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $jUhyG = parcelRequire("jUhyG");

var $gUUjF = parcelRequire("gUUjF");

var $jBy23 = parcelRequire("jBy23");

var $3AuzW = parcelRequire("3AuzW");

var $bvCGh = parcelRequire("bvCGh");

var $lAi7F = parcelRequire("lAi7F");

var $6zsYX = parcelRequire("6zsYX");

var $6vrw7 = parcelRequire("6vrw7");

var $2HCUG = parcelRequire("2HCUG");

var $iBvRb = parcelRequire("iBvRb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$684b30070065532e$export$2e2bcd8739ae039 = (associatedIssuesContextActions, fieldsValuesActions, fieldConfigActions)=>(action$, store)=>action$.ofType((0, $iBvRb.LINK_CHILD_SUCCESS)).do(({ payload: { linkedChild: linkedChild }, meta: meta })=>{
            const state = store.getState();
            const panelType = (0, $2HCUG.getChildIssuesPanelType)(state);
            const attributes = {
                action: 'linked',
                actionSubjectId: linkedChild.id,
                attributes: {
                    isInlineChildAdded: true,
                    panelType: panelType
                }
            };
            (0, $jUhyG.fireTrackAnalytics)(meta.analyticsEvent, attributes);
        }).switchMap(({ payload: { linkedChild: linkedChild } })=>{
            const state = store.getState();
            const baseUrl = (0, $2HCUG.getBaseUrl)(state);
            const issueKey = linkedChild.issueKey !== undefined && linkedChild.issueKey !== null ? (0, $6vrw7.toIssueKey)(linkedChild.issueKey) : undefined;
            const projectKey = issueKey !== undefined ? (0, $jBy23.extractProjectKey)(issueKey) : undefined;
            if (!issueKey || !projectKey) {
                const errorMessage = 'Issue or project key missing when handling link child success';
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.link-child-success.missing-key', errorMessage, new Error(errorMessage));
                return (0, $3JafE.Observable).empty();
            }
            return (0, $3JafE.Observable).from((0, $3AuzW.fetchIssueGraphQlData)(baseUrl, issueKey, projectKey)).map(({ data: graphqlData })=>{
                const fieldsData = (0, $6zsYX.getGraphQlFields)(graphqlData);
                const issue = {
                    id: graphqlData.issue.id,
                    key: issueKey,
                    self: '',
                    fields: Object.values(fieldsData),
                    // Added to satisfy Flow; `transformChild` will not use these fields
                    agile: {},
                    customFields: {
                        textareaAdf: []
                    },
                    systemFields: {}
                };
                const transformedData = (0, $lAi7F.transformChild)(issue, (0, $2HCUG.getIsSimplifiedProject)(state));
                associatedIssuesContextActions && associatedIssuesContextActions.mergeLocalAssociatedIssuesContext({
                    [issueKey]: {
                        estimateFieldId: transformedData.estimateFieldId,
                        isResolved: transformedData.isResolved ?? false
                    }
                });
                if (fieldsData && fieldsValuesActions && fieldConfigActions) {
                    const { fieldValues: fieldValues, fieldConfigs: fieldConfigs } = (0, $bvCGh.extractFromObject)(fieldsData);
                    fieldsValuesActions.setIssue(issueKey, fieldValues);
                    fieldConfigActions.setIssueConfig(issueKey, fieldConfigs);
                }
                return (0, $iBvRb.fetchSingleChildSuccess)(issue);
            }).catch((error)=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.link-child-success.fetch-single-issue', 'Failed to fetch single issue after a successful child issue linking', error);
                return (0, $3JafE.Observable).empty();
            });
        });

});

parcelRegister("b5NLl", function(module, exports) {

$parcel$export(module.exports, "default", () => $33b47f41957dbe2a$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $agEEp = parcelRequire("agEEp");

var $2HCUG = parcelRequire("2HCUG");

var $iBvRb = parcelRequire("iBvRb");

var $bygkw = parcelRequire("bygkw");

var $bxXbI = parcelRequire("bxXbI");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$33b47f41957dbe2a$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $iBvRb.REORDER_CHILDREN_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const panelType = (0, $2HCUG.getChildIssuesPanelType)(state);
        switch(panelType){
            case 0, $agEEp.CLASSIC_SUBTASKS:
                return (0, $bxXbI.default)(state, action.payload);
            case 0, $agEEp.CHILDREN_ISSUES_PANEL:
                return (0, $bygkw.default)(state, action.payload, action.meta);
            default:
                return (0, $3JafE.Observable).empty();
        }
    });

});
parcelRegister("bygkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f45e3e23f388247e$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("3wBUP");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $hTLlD = parcelRequire("hTLlD");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $jMP2a = parcelRequire("jMP2a");

var $5CqW1 = parcelRequire("5CqW1");

var $zUtxy = parcelRequire("zUtxy");

var $A8Y38 = parcelRequire("A8Y38");

var $aQMTF = parcelRequire("aQMTF");

var $2HCUG = parcelRequire("2HCUG");

var $iBvRb = parcelRequire("iBvRb");
const $f45e3e23f388247e$var$onFailure = ({ error: error, currentOrder: currentOrder, optimisticOrder: optimisticOrder, currentIndex: currentIndex, newIndex: newIndex })=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.reorder-children', 'Failed to reorder children', error);
    return (0, $3JafE.Observable).of((0, $iBvRb.reorderChildrenFailed)(currentOrder, optimisticOrder, currentIndex, newIndex));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f45e3e23f388247e$export$2e2bcd8739ae039 = (state, reorderActionPayload, reorderActionMeta)=>{
    const baseUrl = (0, $2HCUG.getBaseUrl)(state);
    const parentId = (0, $2HCUG.getParentId)(state);
    const customFieldId = (0, $2HCUG.getCustomFieldIdRank)(state);
    const { currentOrder: currentOrder, newOrder: optimisticOrder, currentIndex: currentIndex, newIndex: newIndex } = reorderActionPayload;
    if (!parentId) return $f45e3e23f388247e$var$onFailure({
        error: new Error('Attempted to reorder children without parentId'),
        currentOrder: currentOrder,
        optimisticOrder: optimisticOrder,
        currentIndex: currentIndex,
        newIndex: newIndex
    });
    if (!customFieldId) return $f45e3e23f388247e$var$onFailure({
        error: new Error('Attempted to reorder children without customFieldId'),
        currentOrder: currentOrder,
        optimisticOrder: optimisticOrder,
        currentIndex: currentIndex,
        newIndex: newIndex
    });
    const { analyticsEvent: analyticsEvent } = reorderActionMeta;
    const { id: issueId } = currentOrder[currentIndex];
    const issueIds = issueId ? [
        +issueId
    ] : [];
    const isRankAfter = newIndex > currentIndex;
    const rankId = Number((optimisticOrder[isRankAfter ? newIndex - 1 : newIndex + 1] || {}).id);
    if (!rankId) return $f45e3e23f388247e$var$onFailure({
        error: new Error('Attempted to reorder children without rankId'),
        currentOrder: currentOrder,
        optimisticOrder: optimisticOrder,
        currentIndex: currentIndex,
        newIndex: newIndex
    });
    const reorderChildren$ = isRankAfter ? (0, $A8Y38.default)(baseUrl, customFieldId, issueIds, rankId) : (0, $aQMTF.default)(baseUrl, customFieldId, issueIds, rankId);
    return reorderChildren$.switchMap(()=>(0, $zUtxy.default)(baseUrl, parentId)).flatMap((serverSubtasks = [])=>{
        const serverOrderIds = serverSubtasks.map(({ id: id })=>id);
        const optimisticOrderIds = optimisticOrder.map(({ id: id })=>id);
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'issueRank updated', {
            numIssues: 1,
            previousIssueIndex: currentIndex,
            currentIssueIndex: newIndex,
            isRankAfter: isRankAfter
        });
        // Server order matches what we are showing, return success action (but this will not change state)
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(serverOrderIds, optimisticOrderIds)) return (0, $3JafE.Observable).of((0, $iBvRb.reorderChildrenSuccess)(optimisticOrder));
        // Issues are the same, just different order, update our order to match what is returned by the server
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))([
            ...serverOrderIds
        ].sort(), [
            ...optimisticOrderIds
        ].sort())) {
            // @ts-expect-error - TS2322 - Type '(ChildIssue | undefined)[]' is not assignable to type 'ChildIssue[]'.
            const differentOrder = serverOrderIds.map((id)=>optimisticOrder.find((issue)=>issue.id === id));
            return (0, $3JafE.Observable).of((0, $iBvRb.reorderChildrenSuccess)(differentOrder));
        }
        // Server has a different set of issues, update what we have
        const newOrder = serverSubtasks.map((serverIssue)=>{
            const { id: id } = serverIssue;
            const existingIssue = optimisticOrder.find((issue)=>issue.id === id) || {};
            return {
                ...existingIssue,
                ...(0, $5CqW1.default)(serverIssue, baseUrl)
            };
        });
        return (0, $3JafE.Observable).of((0, $iBvRb.reorderChildrenSuccess)(newOrder), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $iBvRb.fetchDetailsForIssuesRequest)());
    }).catch((error)=>$f45e3e23f388247e$var$onFailure({
            error: error,
            currentOrder: currentOrder,
            optimisticOrder: optimisticOrder,
            currentIndex: currentIndex,
            newIndex: newIndex
        }));
};

});
parcelRegister("5CqW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $248cce3e81d20a6d$export$2e2bcd8739ae039);

var $8Qd0L = parcelRequire("8Qd0L");

var $lV5H0 = parcelRequire("lV5H0");

var $blHvU = parcelRequire("blHvU");

var $6vrw7 = parcelRequire("6vrw7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$248cce3e81d20a6d$export$2e2bcd8739ae039 = (childIssueFromServer, baseUrl)=>{
    const { id: id, key: key, fields: fields } = childIssueFromServer;
    return {
        id: id,
        issueKey: key,
        issueLink: (0, $lV5H0.getIssueHtmlUrl)((0, $6vrw7.toBaseUrl)(baseUrl), (0, $6vrw7.toIssueKey)(key)),
        issueSummary: fields.summary,
        issueTypeIconUrl: fields.issuetype.iconUrl,
        issueTypeName: fields.issuetype.name,
        issuePriorityUrl: fields.priority && fields.priority.iconUrl || undefined,
        issuePriorityName: fields.priority && fields.priority.name || undefined,
        issuePrioritySequence: fields.priority && fields.priority.sequence || undefined,
        statusCategory: (0, $8Qd0L.statusCategoryForId)(fields.status.statusCategory.id),
        statusCategoryId: fields.status.statusCategory.id,
        statusName: fields.status.name,
        statusId: fields.status.id,
        assigneeUrl: fields.assignee && (0, $blHvU.transformUser)(fields.assignee).avatarUrl,
        assigneeDisplayName: fields.assignee && (0, $blHvU.transformUser)(fields.assignee).displayName,
        isLoading: false,
        errorType: undefined
    };
};

});

parcelRegister("zUtxy", function(module, exports) {

$parcel$export(module.exports, "default", () => $101aca71513887dd$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $lO4Or = parcelRequire("lO4Or");

var $fzRVu = parcelRequire("fzRVu");
const $101aca71513887dd$var$transformResponseToChildren = (response)=>{
    if (!response || !response.data || !response.data.issue) return [];
    const childrenIssues = response.data.issue.fields.find((field)=>field.key === (0, $lO4Or.CHILDREN_ISSUES));
    if (childrenIssues && childrenIssues.value) return childrenIssues.value.map(// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'key' implicitly has an 'any' type. | TS7031 - Binding element 'self' implicitly has an 'any' type. | TS7031 - Binding element 'assignee' implicitly has an 'any' type. | TS7031 - Binding element 'issuetype' implicitly has an 'any' type. | TS7031 - Binding element 'priority' implicitly has an 'any' type. | TS7031 - Binding element 'summary' implicitly has an 'any' type. | TS7031 - Binding element 'status' implicitly has an 'any' type.
    ({ id: id, key: key, self: self, fields: { assignee: assignee, issuetype: issuetype, priority: priority, summary: summary, status: status } })=>({
            id: id,
            key: key,
            self: self,
            fields: {
                issueType: issuetype,
                priority: priority,
                status: status,
                summary: summary,
                assignee: assignee
            }
        }));
    return [];
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$101aca71513887dd$export$2e2bcd8739ae039 = (baseUrl, parentId)=>(0, $fzRVu.fetchChildren)(baseUrl, parentId).map($101aca71513887dd$var$transformResponseToChildren);

});
parcelRegister("fzRVu", function(module, exports) {

$parcel$export(module.exports, "fetchChildren", () => $2b925a3cf337668a$export$c4ff0a3824da3ed4);

var $ejLgE = parcelRequire("ejLgE");

var $aiRd8 = parcelRequire("aiRd8");
const $2b925a3cf337668a$export$5647e6bbf2b3526f = (baseUrl)=>`${baseUrl}/rest/graphql/1/`;
const $2b925a3cf337668a$var$getChildrenGraphqlQuery = (parentId)=>(0, $ejLgE.gqlTagRest)`query childrenQuery {
      issue(issueIdOrKey: "${parentId}", latestVersion: true, screen:"view", fields:"subtasks") {
        fields {
          key
          value
        }
      }
    }`;
const $2b925a3cf337668a$export$c4ff0a3824da3ed4 = (baseUrl, parentId)=>(0, $aiRd8.default)($2b925a3cf337668a$export$5647e6bbf2b3526f(baseUrl), {
        method: 'POST',
        body: JSON.stringify({
            query: $2b925a3cf337668a$var$getChildrenGraphqlQuery(parentId)
        })
    });

});


parcelRegister("A8Y38", function(module, exports) {

$parcel$export(module.exports, "default", () => $26aaf09d2fe115ec$export$2e2bcd8739ae039);

var $84teX = parcelRequire("84teX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$26aaf09d2fe115ec$export$2e2bcd8739ae039 = (baseUrl, customFieldId, issueIds, rankAfterId)=>(0, $84teX.default)(baseUrl, customFieldId, issueIds, rankAfterId);

});
parcelRegister("84teX", function(module, exports) {

$parcel$export(module.exports, "default", () => $57208b653c85d5d0$export$2e2bcd8739ae039);

var $5G2eQ = parcelRequire("5G2eQ");
const $57208b653c85d5d0$export$b33bd00367d146dc = (baseUrl)=>`${baseUrl}/rest/greenhopper/1.0/api/rank/after`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$57208b653c85d5d0$export$2e2bcd8739ae039 = (baseUrl, customFieldId, issueIds, rankAfterId)=>(0, $5G2eQ.default)($57208b653c85d5d0$export$b33bd00367d146dc(baseUrl), {
        method: 'PUT',
        body: JSON.stringify({
            customFieldId: customFieldId,
            issueIds: issueIds,
            rankAfterId: rankAfterId
        })
    });

});


parcelRegister("aQMTF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9fbf631c58e1fa$export$2e2bcd8739ae039);

var $efIA5 = parcelRequire("efIA5");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ba9fbf631c58e1fa$export$2e2bcd8739ae039 = (baseUrl, customFieldId, issueIds, rankBeforeId)=>(0, $efIA5.default)(baseUrl, customFieldId, issueIds, rankBeforeId);

});
parcelRegister("efIA5", function(module, exports) {

$parcel$export(module.exports, "default", () => $547cdf051b33edef$export$2e2bcd8739ae039);

var $5G2eQ = parcelRequire("5G2eQ");
const $547cdf051b33edef$export$c3989986eef9bdd3 = (baseUrl)=>`${baseUrl}/rest/greenhopper/1.0/api/rank/before`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$547cdf051b33edef$export$2e2bcd8739ae039 = (baseUrl, customFieldId, issueIds, rankBeforeId)=>(0, $5G2eQ.default)($547cdf051b33edef$export$c3989986eef9bdd3(baseUrl), {
        method: 'PUT',
        body: JSON.stringify({
            customFieldId: customFieldId,
            issueIds: issueIds,
            rankBeforeId: rankBeforeId
        })
    });

});



parcelRegister("bxXbI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37c8a0b8e9330be$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("9u6v2");
parcelRequire("3wBUP");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $hTLlD = parcelRequire("hTLlD");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $5CqW1 = parcelRequire("5CqW1");

var $3S6iw = parcelRequire("3S6iw");

var $gGJ1Y = parcelRequire("gGJ1Y");

var $2HCUG = parcelRequire("2HCUG");

var $iBvRb = parcelRequire("iBvRb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f37c8a0b8e9330be$export$2e2bcd8739ae039 = (state, reorderActionPayload)=>{
    const baseUrl = (0, $2HCUG.getBaseUrl)(state);
    const parentId = (0, $2HCUG.getParentId)(state);
    if (!parentId) throw new Error('Attempted to reorder subtasks without parentId');
    const { currentOrder: currentOrder, newOrder: optimisticOrder, currentIndex: currentIndex, newIndex: newIndex } = reorderActionPayload;
    return (0, $3JafE.Observable).from((0, $3S6iw.default)(baseUrl, parentId, currentIndex, newIndex)).switchMap(()=>(0, $gGJ1Y.default)(baseUrl, parentId)).flatMap((serverSubtasks = [])=>{
        // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type.
        const serverOrderIds = serverSubtasks.map(({ id: id })=>id);
        const optimisticOrderIds = optimisticOrder.map(({ id: id })=>id);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(serverOrderIds, optimisticOrderIds)) // Server order matches what we are showing
        // Return success action (but this will not change state)
        return (0, $3JafE.Observable).of((0, $iBvRb.reorderChildrenSuccess)(optimisticOrder));
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(serverOrderIds.slice().sort(), optimisticOrderIds.slice().sort())) {
            // Issues are the same, just different order
            // Update our order to match what is returned by the server
            // @ts-expect-error - TS7006 - Parameter 'id' implicitly has an 'any' type.
            const differentOrder = serverOrderIds.map((id)=>optimisticOrder.find((issue)=>issue.id === id));
            return (0, $3JafE.Observable).of((0, $iBvRb.reorderChildrenSuccess)(differentOrder));
        }
        // Server has a different set of issues, update what we have
        // @ts-expect-error - TS7006 - Parameter 'serverIssue' implicitly has an 'any' type.
        const newOrder = serverSubtasks.map((serverIssue)=>{
            const { id: id } = serverIssue;
            const existingIssue = optimisticOrder.find((issue)=>issue.id === id) || {};
            return {
                ...existingIssue,
                ...(0, $5CqW1.default)(serverIssue, baseUrl)
            };
        });
        return (0, $3JafE.Observable).of((0, $iBvRb.reorderChildrenSuccess)(newOrder), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $iBvRb.fetchDetailsForIssuesRequest)());
    }).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.reorder-subtask', 'Failed to reorder subtasks', error);
        // Reordering failed, put order back to current order
        // Will also show error flag
        return (0, $3JafE.Observable).of((0, $iBvRb.reorderChildrenFailed)(currentOrder, optimisticOrder, currentIndex, newIndex));
    });
};

});
parcelRegister("3S6iw", function(module, exports) {

$parcel$export(module.exports, "default", () => $79c08e7808a3f99f$export$2e2bcd8739ae039);

var $7EhAs = parcelRequire("7EhAs");

var $5zSUY = parcelRequire("5zSUY");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$79c08e7808a3f99f$export$2e2bcd8739ae039 = (baseUrl, parentId, currentIndex, newIndex)=>{
    const url = `${baseUrl}/secure/MoveSubtask.jspa?id=${parentId}&currentSubTaskSequence=${currentIndex}&subTaskSequence=${newIndex}&atl_token=${(0, $5zSUY.default)() || ''}`;
    return fetch(url).then((response)=>{
        if (!response.ok) return response.text().then((str)=>{
            throw new (0, $7EhAs.default)(response.status, str);
        });
        // MoveIssueLink.jspa will return 200 and redirect to /browse/<issue-key> which will return raw HTML
        // So return 'null' instead as we don't care about the response
        return null;
    });
};

});

parcelRegister("gGJ1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c4b8dba9ccfa1d3$export$2e2bcd8739ae039);

var $gnMQ7 = parcelRequire("gnMQ7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2c4b8dba9ccfa1d3$export$2e2bcd8739ae039 = (baseUrl, parentId)=>(0, $gnMQ7.default)(baseUrl, parentId).then((response)=>{
        const fields = response && response.fields;
        return fields && fields.subtasks || [];
    });

});
parcelRegister("gnMQ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $96d42884f25d8c53$export$2e2bcd8739ae039);

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$96d42884f25d8c53$export$2e2bcd8739ae039 = (baseUrl, parentId)=>(0, $lRmyA.performGetRequest)(`${baseUrl}/rest/api/2/issue/${parentId}?fields=subtasks`);

});




parcelRegister("alZBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a35a4746e3cd3e$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $7Up5f = parcelRequire("7Up5f");

var $2HCUG = parcelRequire("2HCUG");

var $1Eu9B = parcelRequire("1Eu9B");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$04a35a4746e3cd3e$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $7Up5f.REQUIRES_FULL_CREATE_CHECK)).switchMap(()=>{
        const state = store.getState();
        const projectId = (0, $2HCUG.getProjectId)(state);
        if (!projectId) return (0, $3JafE.Observable).of((0, $7Up5f.requiresFullCreateCheckFailed)());
        return (0, $1Eu9B.default)(projectId);
    });

});
parcelRegister("7Up5f", function(module, exports) {

$parcel$export(module.exports, "SET_CONTEXT", () => $16285497b4f97a06$export$4bc4e62e7d72b94b);
$parcel$export(module.exports, "setContext", () => $16285497b4f97a06$export$2f04de43fe27971a);
$parcel$export(module.exports, "SET_IS_ISSUE_VIEW_COMPLETE", () => $16285497b4f97a06$export$7906e119740223d7);
$parcel$export(module.exports, "REQUIRES_FULL_CREATE_CHECK", () => $16285497b4f97a06$export$11f9caff9aa53e6a);
$parcel$export(module.exports, "requiresFullCreateCheckRequest", () => $16285497b4f97a06$export$8ad448f541bd5099);
$parcel$export(module.exports, "REQUIRES_FULL_CREATE_CHECK_SUCCESS", () => $16285497b4f97a06$export$fe5c3e6a90862d04);
$parcel$export(module.exports, "requiresFullCreateCheckByIssueTypeSuccess", () => $16285497b4f97a06$export$be54c5b4f726a6c4);
$parcel$export(module.exports, "REQUIRES_FULL_CREATE_CHECK_FAILED", () => $16285497b4f97a06$export$4a904833093be872);
$parcel$export(module.exports, "requiresFullCreateCheckFailed", () => $16285497b4f97a06$export$ad6ee95a5a7f3bc6);
$parcel$export(module.exports, "SET_ONCHANGE", () => $16285497b4f97a06$export$72f058c6cfbb696e);
$parcel$export(module.exports, "setOnChange", () => $16285497b4f97a06$export$fb48ec7ce2339254);
const $16285497b4f97a06$export$4bc4e62e7d72b94b = 'state.context.SET_CONTEXT';
const $16285497b4f97a06$export$2f04de43fe27971a = (payload)=>({
        type: $16285497b4f97a06$export$4bc4e62e7d72b94b,
        payload: payload
    });
const $16285497b4f97a06$export$7906e119740223d7 = 'state.context.SET_IS_ISSUE_VIEW_COMPLETE';
const $16285497b4f97a06$export$ce1edafd23575c54 = (payload)=>({
        type: $16285497b4f97a06$export$7906e119740223d7,
        payload: payload
    });
const $16285497b4f97a06$export$11f9caff9aa53e6a = 'state.context.REQUIRES_FULL_CREATE_CHECK';
const $16285497b4f97a06$export$8ad448f541bd5099 = ()=>({
        type: $16285497b4f97a06$export$11f9caff9aa53e6a
    });
const $16285497b4f97a06$export$fe5c3e6a90862d04 = 'state.context.REQUIRES_FULL_CREATE_CHECK_SUCCESS';
const $16285497b4f97a06$export$be54c5b4f726a6c4 = (requiresFullCreateByIssueType)=>({
        type: $16285497b4f97a06$export$fe5c3e6a90862d04,
        payload: {
            requiresFullCreateByIssueType: requiresFullCreateByIssueType
        }
    });
const $16285497b4f97a06$export$4a904833093be872 = 'state.context.REQUIRES_FULL_CREATE_CHECK_FAILED';
const $16285497b4f97a06$export$ad6ee95a5a7f3bc6 = ()=>({
        type: $16285497b4f97a06$export$4a904833093be872
    });
const $16285497b4f97a06$export$72f058c6cfbb696e = 'state.context.SET_ONCHANGE';
const $16285497b4f97a06$export$fb48ec7ce2339254 = (payload)=>({
        type: $16285497b4f97a06$export$72f058c6cfbb696e,
        payload: payload
    });

});

parcelRegister("1Eu9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd045c73f5aea9d$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("9u6v2");
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $3A3OQ = parcelRequire("3A3OQ");

var $15DgX = parcelRequire("15DgX");

var $7Up5f = parcelRequire("7Up5f");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcd045c73f5aea9d$export$2e2bcd8739ae039 = (projectId)=>(0, $3JafE.Observable).from((0, $15DgX.default)(projectId)).map((result)=>(0, $7Up5f.requiresFullCreateCheckByIssueTypeSuccess)(result)).catch((error)=>{
        (0, $3A3OQ.trackOrLogClientError)('issue.views.common.child-issues-panel.has-validators-on-issue-types', 'Failed to check if project has validators by issue type', error);
        return (0, $3JafE.Observable).of((0, $7Up5f.requiresFullCreateCheckFailed)());
    });

});
parcelRegister("15DgX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a307aefca87a7b4$export$2e2bcd8739ae039);

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5a307aefca87a7b4$export$2e2bcd8739ae039 = (projectId)=>(0, $lRmyA.performGetRequest)(`/rest/internal/2/project/${projectId}/hasValidatorsByIssueType`);

});




parcelRegister("ch1Zg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc33b076409daf1$export$2e2bcd8739ae039);

var $8FRHo = parcelRequire("8FRHo");

var $gUpXz = parcelRequire("gUpXz");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5fc33b076409daf1$export$2e2bcd8739ae039 = (rootEpic, parentKey, panelType)=>(0, $8FRHo.default)({
        appName: `${parentKey}-child-issues-panel-${panelType}`,
        rootReducer: $gUpXz.default,
        rootEpic: rootEpic
    });

});
parcelRegister("gUpXz", function(module, exports) {

$parcel$export(module.exports, "default", () => $84fd98b02839b0d5$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $fxeFp = parcelRequire("fxeFp");

var $hJes2 = parcelRequire("hJes2");

var $19Z6v = parcelRequire("19Z6v");
var $84fd98b02839b0d5$export$2e2bcd8739ae039 = (0, $huRi7.combineReducers)({
    context: $fxeFp.default,
    ui: $19Z6v.default,
    entities: $hJes2.default
});

});
parcelRegister("fxeFp", function(module, exports) {

$parcel$export(module.exports, "default", () => $90adaf9172f4bb5e$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $ao0hp = parcelRequire("ao0hp");

var $6vrw7 = parcelRequire("6vrw7");

var $7Up5f = parcelRequire("7Up5f");
const $90adaf9172f4bb5e$var$defaultState = {
    baseUrl: (0, $6vrw7.toBaseUrl)(''),
    locale: (0, $ao0hp.defaultLocale),
    user: null,
    childIssuesPanelType: null,
    supportsIssueCreation: false,
    requiresFullCreate: false,
    requiresFullCreateByIssueType: {},
    parentKey: null,
    customFieldIdRank: null,
    epicLinkFieldKey: null,
    parentId: null,
    projectId: null,
    messages: null,
    onNavigateToNewIssue: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    isIssueViewComplete: false,
    projectType: null,
    application: null,
    edition: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onEditAssociatedIssue: ()=>{}
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$90adaf9172f4bb5e$export$2e2bcd8739ae039 = (state = $90adaf9172f4bb5e$var$defaultState, action)=>{
    switch(action.type){
        case 0, $7Up5f.SET_CONTEXT:
            return {
                ...state,
                ...action.payload
            };
        case 0, $7Up5f.SET_ONCHANGE:
            return {
                ...state,
                onChange: action.payload
            };
        case 0, $7Up5f.REQUIRES_FULL_CREATE_CHECK_SUCCESS:
            return {
                ...state,
                ...action.payload
            };
        case 0, $7Up5f.REQUIRES_FULL_CREATE_CHECK_FAILED:
            return {
                ...state,
                requiresFullCreate: true,
                requiresFullCreateByIssueType: {}
            };
        case 0, $7Up5f.SET_IS_ISSUE_VIEW_COMPLETE:
            return {
                ...state,
                isIssueViewComplete: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("hJes2", function(module, exports) {

$parcel$export(module.exports, "default", () => $03490355e7da7e6f$export$2e2bcd8739ae039);

var $8i1R8 = parcelRequire("8i1R8");

var $1ybV0 = parcelRequire("1ybV0");

var $8Y8Vi = parcelRequire("8Y8Vi");

var $iBvRb = parcelRequire("iBvRb");
const $03490355e7da7e6f$var$defaultState = {
    issues: [],
    issueTypes: [],
    issueHierarchyLevel: undefined,
    recentlyCreatedIssue: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$03490355e7da7e6f$export$2e2bcd8739ae039 = (state = $03490355e7da7e6f$var$defaultState, action)=>{
    switch(action.type){
        case 0, $iBvRb.SET_ENTITIES:
            {
                const { issueTypes: issueTypes, issues: issues, issueHierarchyLevel: issueHierarchyLevel } = action.payload;
                return {
                    ...state,
                    issues: issues,
                    issueTypes: issueTypes,
                    issueHierarchyLevel: issueHierarchyLevel
                };
            }
        case 0, $iBvRb.UPDATE_ISSUE:
            return state;
        case 0, $iBvRb.CREATE_CHILD_REQUEST:
            {
                const optimisticChild = {
                    ...action.payload.optimisticUiChildIssue,
                    isLoading: true,
                    errorType: undefined
                };
                return {
                    ...state,
                    issues: state.issues.filter((issue)=>issue.id !== optimisticChild.id).concat(optimisticChild)
                };
            }
        case 0, $iBvRb.CREATE_CHILD_SUCCESS:
            {
                const { optimisticId: optimisticId, createdChild: createdChild } = action.payload;
                return (0, $1ybV0.ff)('configurable-child-issues-panel_3ht06') ? {
                    ...state,
                    recentlyCreatedIssue: {
                        issueId: createdChild.issueId || '',
                        issueKey: createdChild.issueKey || ''
                    },
                    issues: state.issues.filter((issue)=>issue.id !== optimisticId).concat(createdChild)
                } : {
                    ...state,
                    issues: state.issues.filter((issue)=>issue.id !== optimisticId).concat(createdChild)
                };
            }
        case 0, $iBvRb.FETCH_SINGLE_CHILD_SUCCESS:
            {
                const { childIssue: childIssue } = action.payload;
                return {
                    ...state,
                    issues: state.issues.map((issue)=>issue.id === childIssue.id ? childIssue : issue)
                };
            }
        case 0, $iBvRb.FETCH_GRAPHQL_ISSUE_SUCCESS:
            {
                const { childIssue: childIssue } = action.payload;
                return {
                    ...state,
                    issues: state.issues.map((issue)=>issue.id === childIssue.id ? childIssue : issue)
                };
            }
        case 0, $iBvRb.CREATE_CHILD_FAILURE:
            {
                const { optimisticId: optimisticId, error: error } = action.payload;
                return {
                    ...state,
                    issues: state.issues.map((issue)=>{
                        if (issue.id === optimisticId) return {
                            ...issue,
                            error: error,
                            errorType: (0, $8Y8Vi.associatedIssueErrorTypes).createChild,
                            isLoading: false
                        };
                        return issue;
                    })
                };
            }
        case 0, $iBvRb.LINKING_ISSUE_FAILURE:
            {
                const { optimisticId: optimisticId, createdChild: createdChild } = action.payload;
                return {
                    ...state,
                    issues: state.issues.filter((issue)=>issue.id !== optimisticId).concat({
                        ...createdChild,
                        errorType: (0, $8Y8Vi.associatedIssueErrorTypes).linkChild,
                        isLoading: false
                    })
                };
            }
        case 0, $iBvRb.CREATE_CHILD_RETRY:
            {
                const { optimisticId: optimisticId } = action.payload;
                return {
                    ...state,
                    issues: state.issues.map((issue)=>{
                        if (issue.id === optimisticId) return {
                            ...issue,
                            errorType: undefined,
                            isLoading: true
                        };
                        return issue;
                    })
                };
            }
        case 0, $iBvRb.LINKING_ISSUE_RETRY:
            {
                const { issueId: issueId } = action.payload;
                return {
                    ...state,
                    issues: state.issues.map((issue)=>{
                        if (issue.id === issueId) return {
                            ...issue,
                            errorType: undefined,
                            isLoading: true
                        };
                        return issue;
                    })
                };
            }
        case 0, $iBvRb.LINKING_ISSUE_RETRY_FAILURE:
            {
                const { issueId: issueId } = action.payload;
                return {
                    ...state,
                    issues: state.issues.map((issue)=>{
                        if (issue.id === issueId) return {
                            ...issue,
                            errorType: (0, $8Y8Vi.associatedIssueErrorTypes).linkChild,
                            isLoading: false
                        };
                        return issue;
                    })
                };
            }
        // For LINK_PARENT_FAILURE: Can't easily offer retry to link,
        // so remove child row from issues list (will pop up a flag instead)
        case 0, $iBvRb.LINK_PARENT_FAILURE:
        case 0, $iBvRb.CANCEL_OPTIMISTIC_CHILD:
            {
                const { optimisticId: optimisticId } = action.payload;
                return {
                    ...state,
                    issues: state.issues.filter((issue)=>issue.id !== optimisticId)
                };
            }
        case 0, $iBvRb.FETCH_DETAILS_FOR_ISSUES_SUCCESS:
            {
                const { issues: issues } = action.payload;
                return {
                    ...state,
                    issues: state.issues.map((issue)=>({
                            ...issue,
                            ...(0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(issues, (issueWithDetails)=>issueWithDetails.id === issue.id)
                        }))
                };
            }
        case 0, $iBvRb.REORDER_CHILDREN_REQUEST:
        case 0, $iBvRb.REORDER_CHILDREN_SUCCESS:
            {
                const { newOrder: newOrder } = action.payload;
                return {
                    ...state,
                    issues: newOrder
                };
            }
        case 0, $iBvRb.REORDER_CHILDREN_FAILED:
            {
                const { originalOrder: originalOrder } = action.payload;
                return {
                    ...state,
                    issues: originalOrder
                };
            }
        case 0, $iBvRb.ADD_EXISTING_CHILD_ISSUE_REQUEST:
            {
                const child = {
                    id: action.payload.issueId,
                    issueKey: action.payload.issueKey,
                    issueSummary: action.payload.issueSummary,
                    issueTypeIconUrl: action.payload.issueTypeIconUrl,
                    assigneeUrl: null,
                    assigneeDisplayName: null,
                    isLoading: true,
                    errorType: undefined
                };
                return {
                    ...state,
                    // The intention is to show the new added issue at the bottom of the list if it's already a child of the current issue.
                    issues: state.issues.filter((issue)=>issue.id !== child.id).concat(child)
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("19Z6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a8bd4720c511714$export$2e2bcd8739ae039);


var $4D8Ar = parcelRequire("4D8Ar");
const $3a8bd4720c511714$var$defaultState = {
    addClickCount: 0,
    hideDone: false,
    selectedIssueType: null,
    childPanelView: (0, $4D8Ar.CHILD_PANEL_VIEWS).InlineCreate,
    childCreateSummary: '',
    fetchIssueTypesStatus: (0, $79689153693cd31b$export$e0428a74c92c3e81)
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3a8bd4720c511714$export$2e2bcd8739ae039 = (state = $3a8bd4720c511714$var$defaultState, action)=>{
    switch(action.type){
        case 0, $4D8Ar.SHOW_INLINE_CREATE:
            return {
                ...state,
                addClickCount: state.addClickCount + 1
            };
        case 0, $4D8Ar.HIDE_ADD_CHILD_ISSUE:
            return {
                ...state,
                addClickCount: 0,
                childPanelView: (0, $4D8Ar.CHILD_PANEL_VIEWS).InlineCreate,
                childCreateSummary: ''
            };
        case 0, $4D8Ar.SET_CHILD_PANEL_VIEW:
            return {
                ...state,
                // @ts-expect-error - TS2339 - Property 'view' does not exist on type '{ type: "state.ui.SET_CHILD_PANEL_VIEW"; view: string; } | { type: string; payload: FetchIssueTypesStatusState; }'.
                childPanelView: action.view
            };
        case 0, $4D8Ar.SET_CHILD_CREATE_SUMMARY:
            return {
                ...state,
                // @ts-expect-error - TS2339 - Property 'summary' does not exist on type '{ type: "state.ui.SET_CHILD_CREATE_SUMMARY"; summary: string; } | { type: string; payload: FetchIssueTypesStatusState; }'.
                childCreateSummary: action.summary
            };
        case 0, $4D8Ar.TOGGLE_HIDE_DONE:
            return {
                ...state,
                hideDone: !state.hideDone
            };
        case 0, $4D8Ar.SELECTED_ISSUE_TYPE_CHANGED:
            return {
                ...state,
                // @ts-expect-error - TS2322 - Type 'FetchIssueTypesStatusState | ChildIssueType' is not assignable to type 'ChildIssueType | null'.
                selectedIssueType: action.payload
            };
        case 0, $4D8Ar.SET_FETCH_ISSUE_TYPES_STATUS:
            return {
                ...state,
                fetchIssueTypesStatus: action.payload
            };
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            action;
            return state;
    }
};

});
parcelRegister("4D8Ar", function(module, exports) {

$parcel$export(module.exports, "SHOW_INLINE_CREATE", () => $e8d09529173bd6e0$export$aedc88716849b09d);
$parcel$export(module.exports, "showInlineCreate", () => $e8d09529173bd6e0$export$e21bcad34d98588b);
$parcel$export(module.exports, "HIDE_ADD_CHILD_ISSUE", () => $e8d09529173bd6e0$export$7e7e34d67d20f471);
$parcel$export(module.exports, "hideAddChildIssue", () => $e8d09529173bd6e0$export$e98004722e858eaf);
$parcel$export(module.exports, "SET_CHILD_PANEL_VIEW", () => $e8d09529173bd6e0$export$255c2674d2c029a8);
$parcel$export(module.exports, "CHILD_PANEL_VIEWS", () => $e8d09529173bd6e0$export$12c7b36016c70ee5);
$parcel$export(module.exports, "setChildPanelView", () => $e8d09529173bd6e0$export$2f50b33f6ec7d8cc);
$parcel$export(module.exports, "SET_CHILD_CREATE_SUMMARY", () => $e8d09529173bd6e0$export$dccc9c56d8960fce);
$parcel$export(module.exports, "setChildCreateSummary", () => $e8d09529173bd6e0$export$c2e49d97bf739a27);
$parcel$export(module.exports, "TOGGLE_HIDE_DONE", () => $e8d09529173bd6e0$export$4afca1f9886a5e5e);
$parcel$export(module.exports, "toggleHideDone", () => $e8d09529173bd6e0$export$6a5a86b429b01cee);
$parcel$export(module.exports, "SELECTED_ISSUE_TYPE_CHANGED", () => $e8d09529173bd6e0$export$64db7e478390882d);
$parcel$export(module.exports, "selectedIssueTypeChanged", () => $e8d09529173bd6e0$export$665d401a739df722);
$parcel$export(module.exports, "SET_FETCH_ISSUE_TYPES_STATUS", () => $e8d09529173bd6e0$export$fccdb586e917187a);
$parcel$export(module.exports, "setFetchIssueTypesStatus", () => $e8d09529173bd6e0$export$4e831a1392ac2182);
const $e8d09529173bd6e0$export$aedc88716849b09d = 'state.ui.SHOW_INLINE_CREATE';
const $e8d09529173bd6e0$export$e21bcad34d98588b = ()=>({
        type: $e8d09529173bd6e0$export$aedc88716849b09d
    });
const $e8d09529173bd6e0$export$7e7e34d67d20f471 = 'state.ui.HIDE_ADD_CHILD_ISSUE';
const $e8d09529173bd6e0$export$e98004722e858eaf = ()=>({
        type: $e8d09529173bd6e0$export$7e7e34d67d20f471
    });
const $e8d09529173bd6e0$export$255c2674d2c029a8 = 'state.ui.SET_CHILD_PANEL_VIEW';
const $e8d09529173bd6e0$export$12c7b36016c70ee5 = Object.freeze({
    InlineCreate: 'InlineCreate',
    AddExistingIssue: 'AddExistingIssue'
});
const $e8d09529173bd6e0$export$2f50b33f6ec7d8cc = (view)=>({
        type: $e8d09529173bd6e0$export$255c2674d2c029a8,
        view: view
    });
const $e8d09529173bd6e0$export$dccc9c56d8960fce = 'state.ui.SET_CHILD_CREATE_SUMMARY';
const $e8d09529173bd6e0$export$c2e49d97bf739a27 = (summary)=>({
        type: $e8d09529173bd6e0$export$dccc9c56d8960fce,
        summary: summary
    });
const $e8d09529173bd6e0$export$4afca1f9886a5e5e = 'state.ui.TOGGLE_HIDE_DONE';
const $e8d09529173bd6e0$export$6a5a86b429b01cee = ()=>({
        type: $e8d09529173bd6e0$export$4afca1f9886a5e5e
    });
const $e8d09529173bd6e0$export$64db7e478390882d = 'state.ui.SELECTED_ISSUE_TYPE_CHANGED';
const $e8d09529173bd6e0$export$665d401a739df722 = (payload)=>({
        type: $e8d09529173bd6e0$export$64db7e478390882d,
        payload: payload
    });
const $e8d09529173bd6e0$export$fccdb586e917187a = 'state.ui.SET_FETCH_ISSUE_TYPES_STATUS';
const $e8d09529173bd6e0$export$4e831a1392ac2182 = (payload)=>({
        type: $e8d09529173bd6e0$export$fccdb586e917187a,
        payload: payload
    });

});




parcelRegister("9qS4k", function(module, exports) {

$parcel$export(module.exports, "useChildrenIssuesWithDataOld", () => $28051c991c105a18$export$130d5c8fa11b45af);
$parcel$export(module.exports, "useChildrenIssuesWithData", () => $28051c991c105a18$export$e41e9636a642f705);

var $lgWZr = parcelRequire("lgWZr");

var $8Qd0L = parcelRequire("8Qd0L");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $f9RL0 = parcelRequire("f9RL0");
const $28051c991c105a18$var$isEpicOrTMPChildIssues = (childrenIssuesFieldKey)=>childrenIssuesFieldKey === (0, $f9RL0.EPIC_ISSUES) || childrenIssuesFieldKey === (0, $f9RL0.CHILDREN_ISSUES);
const $28051c991c105a18$export$130d5c8fa11b45af = (childrenIssuesFieldKey)=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [childrenIssues] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: childrenIssuesFieldKey
    });
    // @ts-expect-error - TS7006 - Parameter 'issue' implicitly has an 'any' type.
    const childrenIssuesRefs = (childrenIssues || []).map((issue)=>({
            key: issue.key,
            id: issue.id
        }));
    // @ts-expect-error - TS7006 - Parameter 'data' implicitly has an 'any' type.
    const allChildrenIssuesKeys = childrenIssuesRefs.map((data)=>data.key);
    const [allSummaryData] = (0, $kmr29.useFieldValuesForIssues)({
        issueKeys: allChildrenIssuesKeys,
        fieldKey: (0, $f9RL0.SUMMARY)
    });
    const [allTimeTrackingData] = (0, $kmr29.useFieldValuesForIssues)({
        issueKeys: allChildrenIssuesKeys,
        fieldKey: (0, $f9RL0.TIME_TRACKING)
    });
    const [allAssigneeData] = (0, $kmr29.useFieldValuesForIssues)({
        issueKeys: allChildrenIssuesKeys,
        fieldKey: (0, $f9RL0.ASSIGNEE)
    });
    const [allPriorityData] = (0, $kmr29.useFieldValuesForIssues)({
        issueKeys: allChildrenIssuesKeys,
        fieldKey: (0, $f9RL0.PRIORITY)
    });
    const [allIssueTypeData] = (0, $kmr29.useFieldValuesForIssues)({
        issueKeys: allChildrenIssuesKeys,
        fieldKey: (0, $f9RL0.ISSUE_TYPE)
    });
    const [allStatusData] = (0, $kmr29.useFieldValuesForIssues)({
        issueKeys: allChildrenIssuesKeys,
        fieldKey: (0, $f9RL0.STATUS)
    });
    const [allCreatedTimeData] = (0, $kmr29.useFieldValuesForIssues)({
        issueKeys: allChildrenIssuesKeys,
        fieldKey: (0, $f9RL0.CREATED)
    });
    const [allUpdatedTimeData] = (0, $kmr29.useFieldValuesForIssues)({
        issueKeys: allChildrenIssuesKeys,
        fieldKey: (0, $f9RL0.UPDATED)
    });
    // @ts-expect-error - TS7006 - Parameter 'data' implicitly has an 'any' type. | TS7006 - Parameter 'idx' implicitly has an 'any' type.
    return childrenIssuesRefs.map((data, idx)=>({
            assigneeDisplayName: allAssigneeData[idx]?.displayName,
            assigneeUrl: allAssigneeData[idx]?.avatarUrls?.['48x48'],
            created: allCreatedTimeData[idx] && new Date(allCreatedTimeData[idx]),
            id: data.id,
            isLoading: false,
            issueKey: data.key,
            issueLink: `/browse/${data.key}`,
            issuePriorityName: allPriorityData[idx]?.name,
            issuePriorityUrl: allPriorityData[idx]?.iconUrl,
            issueSummary: allSummaryData[idx],
            issueTimeTracking: allTimeTrackingData[idx],
            issueTypeIconUrl: allIssueTypeData[idx]?.iconUrl,
            issueTypeName: allIssueTypeData[idx]?.name,
            statusCategory: (0, $8Qd0L.statusCategoryForId)(allStatusData[idx]?.statusCategory?.id),
            statusCategoryId: allStatusData[idx]?.statusCategory?.id,
            statusId: allStatusData[idx]?.id,
            statusName: allStatusData[idx]?.name,
            updated: allUpdatedTimeData[idx] && new Date(allUpdatedTimeData[idx])
        }));
};
const $28051c991c105a18$export$e41e9636a642f705 = (childrenIssuesFieldKey)=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [associatedIssuesContextMap] = (0, $lgWZr.useLocalAssociatedIssuesContext)();
    const [childrenIssues] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: childrenIssuesFieldKey
    });
    const { allChildrenIssuesRefs: allChildrenIssuesRefs, allChildrenIssuesKeys: allChildrenIssuesKeys, estimateFieldId: estimateFieldId } = (childrenIssues || []).reduce((accumulator, issue)=>{
        if (accumulator.estimateFieldId === '' && associatedIssuesContextMap[issue.key]?.estimateFieldId) accumulator.estimateFieldId = associatedIssuesContextMap[issue.key].estimateFieldId || '';
        accumulator.allChildrenIssuesRefs.push({
            key: issue.key,
            id: issue.id
        });
        accumulator.allChildrenIssuesKeys.push(issue.key);
        return accumulator;
    }, {
        allChildrenIssuesRefs: [],
        allChildrenIssuesKeys: [],
        estimateFieldId: ''
    });
    const [fieldValues] = (0, $kmr29.useMultiFieldValuesForIssues)({
        issueKeys: allChildrenIssuesKeys,
        fieldKeys: [
            (0, $f9RL0.SUMMARY),
            (0, $f9RL0.TIME_TRACKING),
            (0, $f9RL0.PRIORITY),
            (0, $f9RL0.ISSUE_TYPE),
            (0, $f9RL0.STATUS),
            (0, $f9RL0.CREATED),
            (0, $f9RL0.UPDATED),
            (0, $f9RL0.ASSIGNEE),
            estimateFieldId
        ]
    });
    return allChildrenIssuesRefs.flatMap(({ key: childIssueKey, id: id })=>{
        const childIssueFieldValue = fieldValues[childIssueKey];
        if (childIssueFieldValue == null || childIssueFieldValue[0, $f9RL0.SUMMARY] == null) return [];
        return {
            assigneeDisplayName: childIssueFieldValue[0, $f9RL0.ASSIGNEE]?.displayName,
            assigneeUrl: childIssueFieldValue[0, $f9RL0.ASSIGNEE]?.avatarUrls?.['48x48'],
            created: childIssueFieldValue[0, $f9RL0.CREATED] && new Date(childIssueFieldValue[0, $f9RL0.CREATED]),
            id: id,
            isLoading: false,
            issueKey: childIssueKey,
            issueLink: `/browse/${childIssueKey}`,
            issuePriorityName: childIssueFieldValue[0, $f9RL0.PRIORITY]?.name,
            issuePriorityUrl: childIssueFieldValue[0, $f9RL0.PRIORITY]?.iconUrl,
            issuePrioritySequence: childIssueFieldValue[0, $f9RL0.PRIORITY]?.sequence,
            issueSummary: childIssueFieldValue[0, $f9RL0.SUMMARY],
            issueTimeTracking: childIssueFieldValue[0, $f9RL0.TIME_TRACKING],
            issueTypeIconUrl: childIssueFieldValue[0, $f9RL0.ISSUE_TYPE]?.iconUrl,
            issueTypeName: childIssueFieldValue[0, $f9RL0.ISSUE_TYPE]?.name,
            statusCategory: (0, $8Qd0L.statusCategoryForId)(childIssueFieldValue[0, $f9RL0.STATUS]?.statusCategory?.id),
            statusCategoryId: childIssueFieldValue[0, $f9RL0.STATUS]?.statusCategory?.id,
            statusId: childIssueFieldValue[0, $f9RL0.STATUS]?.id,
            statusName: childIssueFieldValue[0, $f9RL0.STATUS]?.name,
            updated: childIssueFieldValue[0, $f9RL0.UPDATED] && new Date(childIssueFieldValue[0, $f9RL0.UPDATED]),
            isResolved: associatedIssuesContextMap[childIssueKey]?.isResolved,
            hasError: associatedIssuesContextMap[childIssueKey]?.hasError,
            errorType: associatedIssuesContextMap[childIssueKey]?.errorType,
            ...$28051c991c105a18$var$isEpicOrTMPChildIssues(childrenIssuesFieldKey) ? {
                estimateFieldId: associatedIssuesContextMap[childIssueKey]?.estimateFieldId,
                estimateValue: childIssueFieldValue[estimateFieldId]
            } : {}
        };
    });
};

});

parcelRegister("1yFSO", function(module, exports) {

$parcel$export(module.exports, "default", () => $773baa9f2a55d2ce$export$2e2bcd8739ae039);

var $eGI9v = parcelRequire("eGI9v");

var $1ybV0 = parcelRequire("1ybV0");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $2HCUG = parcelRequire("2HCUG");

var $iBvRb = parcelRequire("iBvRb");

var $6QyxX = parcelRequire("6QyxX");

var $4D8Ar = parcelRequire("4D8Ar");

var $7xkAf = parcelRequire("7xkAf");

var $9nfad = parcelRequire("9nfad");

var $j4v5w = parcelRequire("j4v5w");

var $aYDPW = parcelRequire("aYDPW");

var $hSvgM = parcelRequire("hSvgM");

var $945jA = parcelRequire("945jA");

var $hbtxV = parcelRequire("hbtxV");
var $773baa9f2a55d2ce$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)(// @ts-expect-error - Argument of type '<T extends ComponentType<any>, Props = ComponentPropsWithRef<T>>(WrappedComponent: T) => FC<Omit<{ [K in keyof Props]: K extends "onFullDialogCreate" | "onSuggestedChildIssueCreateSuccess" ? (...args: [......]) => ReturnType<...> : Props[K]; }, keyof WithAnalyticsEventsProps>>' is not assignable to parameter of type 'FlowStep<T, ComponentType<Matching<({ Heading: ConnectedComponent<typeof Heading, { childIssuesLimitStatus: ChildIssuesLimitStatus; sourceName?: string | undefined; onAddChildClick: AddChildEventHandler | undefined; issueHierarchyLevel: number | undefined; context?: Context<...> | undefined; store?: Store<...> | und...'.
(0, $eGI9v.default)('childIssuePanelInlineCreate', {
    onFullDialogCreate: 'onFullDialogCreate',
    onSuggestedChildIssueCreateSuccess: 'onSuggestedChildIssueCreateSuccess'
}), (0, $lqalZ.connect)((state)=>{
    if (!state) // Monitoring has shown that state can be `undefined` but we have
    // not been able to replicate it.
    return {
        Heading: $j4v5w.default,
        InlineCreate: $aYDPW.default,
        Issues: $hSvgM.default,
        ProgressSummary: $945jA.default,
        AddExistingIssue: $9nfad.default,
        childPanelView: (0, $4D8Ar.CHILD_PANEL_VIEWS).InlineCreate,
        allIssues: [],
        incompleteIssues: [],
        addClickCount: 0,
        noValueText: null
    };
    return {
        Heading: $j4v5w.default,
        InlineCreate: $aYDPW.default,
        Issues: $hSvgM.default,
        ProgressSummary: $945jA.default,
        AddExistingIssue: $9nfad.default,
        childPanelView: (0, $7xkAf.getChildPanelView)(state),
        allIssues: (0, $6QyxX.getAllIssues)(state),
        incompleteIssues: (0, $6QyxX.getIncompleteIssues)(state),
        addClickCount: (0, $7xkAf.getAddClickCount)(state),
        noValueText: (0, $2HCUG.getNoValueText)(state),
        childIssuesPanelType: (0, $2HCUG.getChildIssuesPanelType)(state),
        issueHierarchyLevel: (0, $6QyxX.getIssueHierarchyLevel)(state),
        epicLinkFieldKey: (0, $2HCUG.getEpicLinkFieldKey)(state),
        parentIssueKey: (0, $2HCUG.getParentKey)(state),
        baseUrl: (0, $2HCUG.getBaseUrl)(state),
        // getIssueTypes only gets the issue types available for child issues
        childIssueTypes: (0, $6QyxX.getIssueTypes)(state),
        ...(0, $1ybV0.ff)('jira-ai-work-breakdown-new-ui_z0inn') ? {
            issueTypeWithWorkflowValidators: (0, $2HCUG.getIssueTypeWFValidators)(state)
        } : undefined
    };
}, {
    onFullDialogCreate: (optimisticId, childIssue, analyticsEvent)=>(0, $iBvRb.childCreatedInFullDialog)(optimisticId, childIssue, analyticsEvent),
    onSuggestedChildIssueCreateSuccess: (createdChild, additionalAttributes, analyticsEvent)=>(0, $iBvRb.createChildSuccess)(createdChild.id, createdChild, analyticsEvent, false, additionalAttributes)
}))((0, $hbtxV.ChildIssuesPanel));

});
parcelRegister("9nfad", function(module, exports) {

$parcel$export(module.exports, "default", () => $5244859da857d286$export$2e2bcd8739ae039);

var $eGI9v = parcelRequire("eGI9v");
var $8un0w = parcelRequire("8un0w");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $2HCUG = parcelRequire("2HCUG");

var $iBvRb = parcelRequire("iBvRb");

var $6QyxX = parcelRequire("6QyxX");

var $4D8Ar = parcelRequire("4D8Ar");

var $7xkAf = parcelRequire("7xkAf");

var $iiKti = parcelRequire("iiKti");
var $5244859da857d286$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $eGI9v.default)('button', {
    onAdd: 'clicked',
    onCancel: 'clicked',
    onCreate: 'clicked'
}), (0, $8un0w.default)({
    onAdd: 'addExistingChildIssueRequest',
    onCancel: 'hideAddExistingChildIssue',
    onCreate: 'switchToCreateChildIssue'
}), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ addClickCount: number; initialValue: string; issueKey: string | null; jql: string; projectId: string | null; } & { onAdd: (issue: any, analyticsEvent: any) => { type: "state.entities.ADD_EXISTING_CHILD_ISSUE_REQUEST"; payload: { ...; }; meta: { ...; }; }; onCancel: () => { ...; ...' is not assignable to parameter of type 'FlowStep<WithUIAnalyticsEvent<PropsWithoutRef<Omit<{ [K in keyof Props]: K extends "onAdd" | "onCancel" | "onCreate" ? (...args: [...Parameters<Props[K]>, UIAnalyticsEvent]) => ReturnType<...> : Props[K]; }, keyof WithAnalyticsEventsProps>>, { ...; }>, ConnectedComponent<...>>'.
(0, $lqalZ.connect)((state)=>({
        addClickCount: (0, $7xkAf.getAddClickCount)(state),
        initialValue: (0, $7xkAf.getChildCreateSummary)(state),
        issueKey: (0, $2HCUG.getParentKey)(state),
        jql: (0, $6QyxX.getNextGenChildrenIssueTypesJql)(state),
        projectId: (0, $2HCUG.getProjectId)(state)
    }), (dispatch)=>({
        // @ts-expect-error - TS7006 - Parameter 'issue' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
        onAdd: (issue, analyticsEvent)=>dispatch((0, $iBvRb.addExistingChildIssueRequest)(issue, analyticsEvent)),
        onCancel: ()=>dispatch((0, $4D8Ar.hideAddChildIssue)()),
        onCreate: (inputValue)=>{
            dispatch((0, $4D8Ar.setChildCreateSummary)(inputValue));
            dispatch((0, $4D8Ar.setChildPanelView)((0, $4D8Ar.CHILD_PANEL_VIEWS).InlineCreate));
        }
    })))((0, $iiKti.default));

});
parcelRegister("iiKti", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4603b37bfc5c13f$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gtzuR = parcelRequire("gtzuR");

var $7u4fN = parcelRequire("7u4fN");

var $f8Yej = parcelRequire("f8Yej");

var $4ksts = parcelRequire("4ksts");

var $jlGoX = parcelRequire("jlGoX");

var $autRb = parcelRequire("autRb");

var $hzcvF = parcelRequire("hzcvF");

var $sPq0T = parcelRequire("sPq0T");
const $e4603b37bfc5c13f$export$bfa3a4c19902779f = ({ issueKey: issueKey, initialValue: initialValue = '', jql: jql, projectId: projectId, addClickCount: addClickCount, onAdd: onAdd, onCancel: onCancel, onCreate: onCreate })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const [selectedIssue, setSelectedIssue] = (0, $eUqFw.useState)();
    const [isDisabled, setIsDisabled] = (0, $eUqFw.useState)(true);
    const previousAddClickCount = (0, $hzcvF.usePrevious)(addClickCount);
    const childContainer = (0, $eUqFw.useRef)(null);
    const issuePicker = (0, $eUqFw.useRef)(null);
    const focusPicker = (0, $eUqFw.useCallback)(()=>{
        issuePicker.current?.focus?.();
    }, []);
    const resetPicker = (0, $eUqFw.useCallback)(()=>{
        issuePicker.current?.reset();
    }, []);
    const onAddClicked = (0, $eUqFw.useCallback)(()=>{
        if (selectedIssue) {
            onAdd(selectedIssue);
            resetPicker();
        }
    }, [
        onAdd,
        resetPicker,
        selectedIssue
    ]);
    const handleOnChange = (0, $eUqFw.useCallback)((issue)=>{
        setSelectedIssue(issue);
        setIsDisabled(false);
    }, []);
    const onClearClicked = (0, $eUqFw.useCallback)(()=>{
        setSelectedIssue(undefined);
        setIsDisabled(true);
    }, []);
    const onCancelClicked = (0, $eUqFw.useCallback)(()=>{
        onClearClicked();
        onCancel();
    }, [
        onCancel,
        onClearClicked
    ]); // AK Select Component's select on enter behaviour is broken if we use EnterEscapeHandler to handle enter key,
    // So we have to handle it separately here
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter')) {
            onAddClicked();
            event.stopPropagation();
        }
    }, [
        onAddClicked
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $autRb.smoothScrollIntoCenterIfNeeded)(childContainer.current);
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (addClickCount !== previousAddClickCount) {
            (0, $autRb.smoothScrollIntoCenterIfNeeded)(childContainer.current);
            focusPicker();
        }
    }, [
        addClickCount,
        focusPicker,
        previousAddClickCount
    ]);
    if (!issueKey || !projectId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
        onEscape: onCancelClicked
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        onKeyDown: onKeyDown,
        ref: childContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jlGoX.default), {
        ref: issuePicker,
        initialValue: initialValue,
        issueKey: issueKey,
        projectId: projectId,
        jql: jql,
        onChange: handleOnChange,
        onClear: onClearClicked,
        intl: intl,
        onCreate: onCreate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4603b37bfc5c13f$var$ButtonsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4603b37bfc5c13f$var$StyledButton, {
        appearance: "primary",
        onClick: onAddClicked,
        isDisabled: isDisabled
    }, intl.formatMessage((0, $sPq0T.default).childLinkButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4603b37bfc5c13f$var$StyledButton, {
        appearance: "subtle",
        onClick: onCancelClicked
    }, intl.formatMessage((0, $sPq0T.default).childCancelButton)))));
};
var $e4603b37bfc5c13f$export$2e2bcd8739ae039 // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $e4603b37bfc5c13f$export$bfa3a4c19902779f;
const $e4603b37bfc5c13f$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01a66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4603b37bfc5c13f$var$ButtonsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jlGoX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cd4d78d5c3b7d67$export$2e2bcd8739ae039);

var $k8hhD = parcelRequire("k8hhD");
var $9cd4d78d5c3b7d67$export$2e2bcd8739ae039 = (0, $k8hhD.default);

});
parcelRegister("k8hhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bed9a56dfb214da$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $1EOkb = parcelRequire("1EOkb");

var $3NCZx = parcelRequire("3NCZx");
parcelRequire("gLLZt");
var $7nzO5 = parcelRequire("7nzO5");

var $gd0Sp = parcelRequire("gd0Sp");

var $llswQ = parcelRequire("llswQ");

var $9AGg6 = parcelRequire("9AGg6");

var $7ztfK = parcelRequire("7ztfK");
class $6bed9a56dfb214da$export$f351965c159f435d extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            initialValue: ''
        };
    }
    focus() {
        this.akSelect?.focus();
    }
    reset() {
        // Unfortunately, this is what we found in order to clear the select value.
        this.akSelect?.select?.clearValue();
        // The reason for doing a blur then focus is because AK button doesn't get the focus on clicking.
        this.akSelect?.blur();
        this.akSelect?.focus();
    }
    render() {
        const { initialValue: initialValue, issueKey: issueKey, projectId: projectId, jql: jql, intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: { baseUrl: baseUrl } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $llswQ.default), {
                labels: {
                    recentIssues: intl.formatMessage((0, $7ztfK.default).defaultRecentIssues),
                    matchingIssues: intl.formatMessage((0, $7ztfK.default).defaultMatchingIssues)
                },
                baseUrl: baseUrl,
                issueKey: issueKey,
                projectId: projectId,
                jql: jql,
                initialValue: initialValue
            }, ({ loadOptions: loadOptions, options: options, isLoading: isLoading, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1EOkb.default), {
                    ref: this.onSetSelectRef,
                    styles: (0, $7nzO5.defaultSelectStyles),
                    isLoading: isLoading,
                    formatOptionLabel: this.formatOptionLabel,
                    options: options,
                    defaultInputValue: initialValue,
                    autoFocus: true,
                    allowCreateWhileLoading: true,
                    defaultOptions: true,
                    onCreateOption: this.onCreate,
                    placeholder: intl.formatMessage((0, $7ztfK.default).defaultPlaceholder),
                    components: {
                        SingleValue: $9AGg6.SingleValue
                    },
                    // @ts-expect-error - TS7006 - Parameter 'issueOption' implicitly has an 'any' type. | TS7006 - Parameter 'actionObject' implicitly has an 'any' type.
                    onChange: (issueOption, actionObject)=>this.onChange(issueOption, actionObject, loadOptions),
                    onInputChange: this.onInputChange(loadOptions),
                    onBlur: ()=>this.onBlur(loadOptions),
                    isClearable: true,
                    filterOption: this.filterOption,
                    noOptionsMessage: ()=>this.renderNoOptionsMessage(error),
                    openMenuOnFocus: true
                })));
    }
    constructor(...args){
        super(...args);
        this.onBlur = (loadOptions)=>{
            loadOptions('');
        };
        this.onChange = (issueOption, { action: action }, loadOptions)=>{
            switch(action){
                case 'select-option':
                    {
                        const { issueId: issueId, issueKey: issueKey, summary: summary, imageUrl: imageUrl } = issueOption;
                        this.props.onChange && this.props.onChange({
                            issueId: issueId,
                            issueKey: issueKey,
                            issueSummary: summary,
                            issueTypeIconUrl: imageUrl
                        });
                        loadOptions('');
                        break;
                    }
                case 'clear':
                    this.props.onClear && this.props.onClear();
                    break;
                default:
                    break;
            }
        };
        this.onCreate = (inputValue)=>{
            this.props.onCreate && this.props.onCreate(inputValue);
        };
        this.onInputChange = (loadOptions)=>(input, { action: action })=>{
                if (action === 'input-change') loadOptions(input);
            };
        this.onSetSelectRef = (ref)=>{
            this.akSelect = ref;
        };
        this.formatOptionLabel = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        option, { context: context })=>{
            const isNewOption = option.__isNew__;
            if (isNewOption) {
                const label = this.props.intl.formatMessage((0, $7ztfK.default).createIssue, {
                    value: option.value
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9AGg6.CreateIssueOption), {
                    label: label
                });
            }
            if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9AGg6.IssueOption), {
                imageUrl: option.imageUrl,
                issueKey: option.issueKey,
                summary: option.summary
            });
            return option.label;
        };
        this.filterOption = ()=>true;
        this.renderNoOptionsMessage = (error)=>{
            if (!error) return undefined;
            const { intl: intl } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NCZx.default), {
                description: intl.formatMessage((0, $7ztfK.default).defaultFailedLoadingIssues),
                imageWidth: 56,
                isSubtle: true
            });
        };
    }
}
var $6bed9a56dfb214da$export$2e2bcd8739ae039 = $6bed9a56dfb214da$export$f351965c159f435d;

});
parcelRegister("llswQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fe3de12a1d1e285$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6GXx9 = parcelRequire("6GXx9");

var $2OdyW = parcelRequire("2OdyW");

var $fO0l8 = parcelRequire("fO0l8");

var $gO9xj = parcelRequire("gO9xj");
class $7fe3de12a1d1e285$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            initialValue: ''
        };
    }
    componentDidMount() {
        this.fetchData(this.props.initialValue);
    }
    render() {
        const { children: children } = this.props;
        const { options: options, isLoading: isLoading, error: error } = this.state;
        return children({
            options: options,
            isLoading: isLoading,
            error: error,
            loadOptions: this.debouncedFetchData
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            options: [],
            isLoading: false,
            error: null
        };
        this.fetchData = (inputValue)=>{
            const { issueKey: issueKey, projectId: projectId, jql: jql, labels: labels } = this.props;
            const matchingIssue = (0, $6GXx9.default)(inputValue, window.location.host);
            const query = matchingIssue || inputValue;
            this.setState({
                isLoading: true,
                error: null
            });
            return (0, $2OdyW.default)(`/rest/api/3/issue/picker?currentIssueKey=${issueKey}&currentProjectId=${projectId}&showSubTasks=true&showSubTaskParent=true&currentJQL=${jql}&query=${query}`).then((results)=>{
                this.setState({
                    options: (0, $gO9xj.transformOptions)(results, labels),
                    isLoading: false
                });
                return results;
            }).catch((error)=>{
                this.setState({
                    isLoading: false,
                    options: [],
                    error: error
                });
                return [];
            });
        };
        this.debouncedFetchData = (0, $fO0l8.default)(this.fetchData, 300);
    }
}

});
parcelRegister("6GXx9", function(module, exports) {

$parcel$export(module.exports, "ISSUEKEY_REGEX", () => $2bd12f0fe8e9dce1$export$b52c9cee589449a8);
$parcel$export(module.exports, "default", () => $2bd12f0fe8e9dce1$export$2e2bcd8739ae039);

var $k4nIh = parcelRequire("k4nIh");
const $2bd12f0fe8e9dce1$export$b52c9cee589449a8 = '([A-Z][A-Z0-9_]+-\\d+)';
var /**
 * Returns the issue key if the URL is a valid full page Jira issue URL. It may also include a trailing
 * hash fragment. A matching URL must look like:
 * <host><baseurl>/browse/<issuekey><#hash?>
 * e.g. https://my-jira-instance.atlassian.net/browse/FOO-123#xyz
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$2bd12f0fe8e9dce1$export$2e2bcd8739ae039 = (url, host)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, {});
    const isMatchingProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    const isMatchingHost = parsedUrl.host === host;
    const matches = parsedUrl.pathname.match(new RegExp(`^\\/browse\\/${$2bd12f0fe8e9dce1$export$b52c9cee589449a8}\\/?$`));
    const issueKey = matches && matches.length > 1 ? matches[1] : null;
    return isMatchingProtocol && isMatchingHost && issueKey || null;
};

});

parcelRegister("gO9xj", function(module, exports) {

$parcel$export(module.exports, "transformOptions", () => $60b78c4da4e5bf27$export$8f4ed8ef83bcbf04);

var $lyOYo = parcelRequire("lyOYo");

var $6vrw7 = parcelRequire("6vrw7");
const $60b78c4da4e5bf27$export$8f4ed8ef83bcbf04 = ({ sections: sections }, labels)=>{
    const historySearch = sections[0];
    const currentSearch = sections[1];
    const historySearchIssues = historySearch.issues;
    const currentSearchissues = currentSearch ? currentSearch.issues : [];
    const issues = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
        ...historySearchIssues,
        ...currentSearchissues
    ], 'key');
    return [
        {
            label: currentSearch ? labels.matchingIssues : labels.recentIssues,
            options: issues.map((issue)=>({
                    issueId: (0, $6vrw7.toIssueId)(String(issue.id)),
                    value: issue.key,
                    issueKey: issue.key,
                    summary: issue.summaryText,
                    imageUrl: issue.img
                }))
        }
    ];
};

});


parcelRegister("9AGg6", function(module, exports) {

$parcel$export(module.exports, "CreateIssueOption", () => $518950d45cf2cffb$export$39c2758d2fa09a8f);
$parcel$export(module.exports, "IssueOption", () => $518950d45cf2cffb$export$e3339d36fc322bcf);
$parcel$export(module.exports, "SingleValue", () => $518950d45cf2cffb$export$1949dac661ba6e3a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $gO9Xw = parcelRequire("gO9Xw");

var $jQxSL = parcelRequire("jQxSL");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");
const $518950d45cf2cffb$var$IssueCard = ({ imageUrl: imageUrl, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($518950d45cf2cffb$var$IssueCardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($518950d45cf2cffb$var$IconContainer, null, (0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($518950d45cf2cffb$var$Img, {
        src: imageUrl,
        alt: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: imageUrl,
        alt: ""
    })), children);
const $518950d45cf2cffb$export$39c2758d2fa09a8f = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($518950d45cf2cffb$var$IssueCardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
        label: "",
        size: "small",
        primaryColor: `var(--ds-icon-brand, ${(0, $PdmhA).B400})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        isSelected: false,
        interactionName: "auto-generated.jira-issue-picker.ui.issue-cards.button"
    }, label));
const $518950d45cf2cffb$export$e3339d36fc322bcf = ({ imageUrl: imageUrl, issueKey: issueKey, summary: summary })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($518950d45cf2cffb$var$IssueCard, {
        imageUrl: imageUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($518950d45cf2cffb$var$IssueDescription, null, issueKey, " ", summary));
const $518950d45cf2cffb$var$SelectedValue = ({ imageUrl: imageUrl, issueKey: issueKey, summary: summary })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($518950d45cf2cffb$var$IssueCard, {
        imageUrl: imageUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($518950d45cf2cffb$var$IssueDescription, null, `${issueKey} ${summary}`));
const $518950d45cf2cffb$export$1949dac661ba6e3a = ({ children: children, ...props })=>// @ts-expect-error - TS2740 - Type '{ children: Element; data: PlainIssueOptionType; }' is missing the following properties from type 'CommonProps<PlainIssueOptionType, false, GroupTypeBase<PlainIssueOptionType>>': clearValue, cx, getStyles, getValue, and 8 more.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($518950d45cf2cffb$var$SelectedValue, {
        imageUrl: props.data.imageUrl,
        issueKey: props.data.issueKey,
        summary: props.data.summary
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $518950d45cf2cffb$var$IssueCardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $518950d45cf2cffb$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _1bsb7vkz _4t3i7vkz",
            __cmplp.className
        ])
    });
});
const $518950d45cf2cffb$var$Img = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $518950d45cf2cffb$var$IssueDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7ztfK", function(module, exports) {

$parcel$export(module.exports, "default", () => $86c8b4f7b83cb89a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $86c8b4f7b83cb89a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    defaultPlaceholder: {
        "id": "issue-picker.default-placeholder",
        "defaultMessage": "Search by issue key or summary"
    },
    defaultRecentIssues: {
        "id": "issue-picker.default-recent-issues",
        "defaultMessage": "Recent Issues"
    },
    defaultMatchingIssues: {
        "id": "issue-picker.default-matching-issues",
        "defaultMessage": "Matching Issues"
    },
    defaultFailedLoadingIssues: {
        "id": "issue-picker.default-failed-loading-issues",
        "defaultMessage": "Failed to load issues"
    },
    createIssue: {
        "id": "issue-picker.create-issue",
        "defaultMessage": "Create an issue for {value}"
    }
});

});



parcelRegister("sPq0T", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe90164551f7c84f$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $fe90164551f7c84f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    childLinkButton: {
        "id": "issue.views.common.child-issues-panel.add-existing-issue.child-link-button",
        "defaultMessage": "Add"
    },
    childCancelButton: {
        "id": "issue.views.common.child-issues-panel.add-existing-issue.child-cancel-button",
        "defaultMessage": "Cancel"
    }
});

});



parcelRegister("j4v5w", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eb0efc1c525c151$export$2e2bcd8739ae039);

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $2HCUG = parcelRequire("2HCUG");

var $6QyxX = parcelRequire("6QyxX");

var $2eRcj = parcelRequire("2eRcj");

var $ks1v5 = parcelRequire("ks1v5");

var $4qws5 = parcelRequire("4qws5");

var $HGqcL = parcelRequire("HGqcL");

var $ibfcm = parcelRequire("ibfcm");
var $3eb0efc1c525c151$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        Title: $HGqcL.default,
        Meatballs: $ks1v5.default,
        AddChild: $2eRcj.default,
        SortByMenu: $4qws5.default,
        allIssues: (0, $6QyxX.getAllIssues)(state),
        supportsIssueCreation: (0, $2HCUG.getSupportsIssueCreation)(state),
        isSortingAvailable: (0, $2HCUG.isCompatibleSortingPanel)(state)
    }), {}))((0, $ibfcm.default));

});
parcelRegister("2eRcj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7de57142a3cd7c5$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $eGI9v = parcelRequire("eGI9v");
var $8un0w = parcelRequire("8un0w");

var $lqalZ = parcelRequire("lqalZ");

var $2HCUG = parcelRequire("2HCUG");

var $4D8Ar = parcelRequire("4D8Ar");

var $3t1NL = parcelRequire("3t1NL");
var $a7de57142a3cd7c5$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $eGI9v.default)('button', {
    onClick: 'clicked'
}), (0, $8un0w.default)({
    onClick: 'showChildIssuesInlineCreate'
}), (0, $lqalZ.connect)((state)=>({
        isClassicSubtaskPanel: (0, $2HCUG.getIsClassicSubtaskPanel)(state)
    }), (dispatch, props)=>({
        onClick: (...args)=>{
            dispatch((0, $4D8Ar.showInlineCreate)());
            props.onClick(...args);
        }
    })))((0, $3t1NL.AddChild));

});
parcelRegister("3t1NL", function(module, exports) {

$parcel$export(module.exports, "AddChild", () => $ec1a445d8c453737$export$5fd93af9704b3891);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $5JgJ2 = parcelRequire("5JgJ2");

var $81vFI = parcelRequire("81vFI");

var $ihNM6 = parcelRequire("ihNM6");
const $ec1a445d8c453737$export$5fd93af9704b3891 = ({ isClassicSubtaskPanel: isClassicSubtaskPanel = false, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const label = isClassicSubtaskPanel ? (0, $ihNM6.default).createSubtaskLabel : (0, $ihNM6.default).createChildLabel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        prefixOverride: "issue",
        id: "Safe(AddChild)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ec1a445d8c453737$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $81vFI.default), {
        onClick: onClick,
        label: formatMessage(label)
    })));
};
const $ec1a445d8c453737$var$buttonWrapperStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.075'
});

});
parcelRegister("ihNM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5206b628f7a284ca$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $5206b628f7a284ca$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createChildLabel: {
        "id": "issue.views.common.child-issues-panel.heading.add-child.create-child-label",
        "defaultMessage": "Create child"
    },
    createSubtaskLabel: {
        "id": "issue.views.common.child-issues-panel.heading.add-child.create-subtask-label",
        "defaultMessage": "Create subtask"
    }
});

});



parcelRegister("ks1v5", function(module, exports) {

$parcel$export(module.exports, "default", () => $38317218cec68ac6$export$2e2bcd8739ae039);

var $eGI9v = parcelRequire("eGI9v");
var $8un0w = parcelRequire("8un0w");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $2HCUG = parcelRequire("2HCUG");

var $6QyxX = parcelRequire("6QyxX");

var $4D8Ar = parcelRequire("4D8Ar");

var $7xkAf = parcelRequire("7xkAf");

var $loysi = parcelRequire("loysi");
var // FIXME: JIV-17455 should be fully typed
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$38317218cec68ac6$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $eGI9v.default)('item', {
    onBulkEditClicked: 'clicked',
    onViewInSearchClicked: 'clicked',
    onHideDoneClicked: 'clicked'
}), (0, $8un0w.default)({
    // @ts-expect-error - TS7006 - Parameter 'issueCount' implicitly has an 'any' type.
    onBulkEditClicked: (issueCount)=>({
            name: 'bulkEdit',
            issueCount: issueCount
        }),
    // @ts-expect-error - TS7006 - Parameter 'issueCount' implicitly has an 'any' type.
    onViewInSearchClicked: (issueCount)=>({
            name: 'viewInSearch',
            issueCount: issueCount
        }),
    // @ts-expect-error - TS7006 - Parameter 'totalIssues' implicitly has an 'any' type. | TS7006 - Parameter 'incompleteIssues' implicitly has an 'any' type. | TS7006 - Parameter 'hideDone' implicitly has an 'any' type.
    onHideDoneClicked: (totalIssues, incompleteIssues, hideDone)=>({
            name: 'toggleHideDone',
            totalIssues: totalIssues,
            incompleteIssues: incompleteIssues,
            hideDone: hideDone
        })
}), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ baseUrl: string; childIssuesPanelType: ChildIssuesPanelType | null; parentKey: string | null; hideDone: boolean; allIssues: ChildIssue[]; incompleteIssues: ChildIssue[]; } & { ...; }, {}>' is not assignable to parameter of type 'FlowStep<WithUIAnalyticsEvent<PropsWithoutRef<Omit<{ [K in keyof Props]: K extends "onBulkEditClicked" | "onViewInSearchClicked" | "onHideDoneClicked" ? (...args: [...Parameters<Props[K]>, UIAnalyticsEvent]) => ReturnType<...> : Props[K]; }, keyof WithAnalyticsEventsProps>>, { ...; }>, ConnectedComponent<...>>'.
(0, $lqalZ.connect)((state)=>({
        baseUrl: (0, $2HCUG.getBaseUrl)(state),
        childIssuesPanelType: (0, $2HCUG.getChildIssuesPanelType)(state),
        parentKey: (0, $2HCUG.getParentKey)(state),
        hideDone: (0, $7xkAf.getHideDone)(state),
        allIssues: (0, $6QyxX.getAllIssues)(state),
        incompleteIssues: (0, $6QyxX.getIncompleteIssues)(state)
    }), {
    onHideDoneClicked: (0, $4D8Ar.toggleHideDone)
}))((0, $loysi.Meatballs));

});
parcelRegister("loysi", function(module, exports) {

$parcel$export(module.exports, "Meatballs", () => $a95385759bd136a4$export$8e357490a4a1908a);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8blac = parcelRequire("8blac");

var $j9fWg = parcelRequire("j9fWg");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $9mc6u = parcelRequire("9mc6u");
var $5ro4T = parcelRequire("5ro4T");
var $fEubG = parcelRequire("fEubG");

var $jG1wZ = parcelRequire("jG1wZ");

var $8cU5f = parcelRequire("8cU5f");

var $gUUjF = parcelRequire("gUUjF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");


var $i9pAn = parcelRequire("i9pAn");

var $6azHZ = parcelRequire("6azHZ");

var $bFzGY = parcelRequire("bFzGY");

var $guDlK = parcelRequire("guDlK");

var $kJlBc = parcelRequire("kJlBc");

var $1jlsP = parcelRequire("1jlsP");

var $a7wEh = parcelRequire("a7wEh");

var $ca2LP = parcelRequire("ca2LP");

var $6vqrr = parcelRequire("6vqrr");

var $bD9AZ = parcelRequire("bD9AZ");
const $a95385759bd136a4$var$testId = 'issue.views.common.child-issues-panel.heading.meatballs.dropdown.trigger-button';
const $a95385759bd136a4$export$8e357490a4a1908a = ({ childIssuesLimitStatus: childIssuesLimitStatus, childIssuesPanelType: childIssuesPanelType, parentKey: parentKey, hideDone: hideDone = false, allIssues: allIssues, incompleteIssues: incompleteIssues, onHideDoneClicked: onHideDoneClicked, onBulkEditClicked: onBulkEditClicked, onViewInSearchClicked: onViewInSearchClicked })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const [sortByValue] = (0, $ca2LP.useChildIssuesSortBy)();
    const [hideDonePreference, { setValue: setHideDonePreference }] = (0, $i9pAn.useUserPreferencesValue)((0, $e4af19d777b54ab6$export$4c9f7f9f8a4000e1));
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const isSimplifiedProject = (0, $guDlK.useIsSimplifiedProject)(projectKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onBulkEditClickedAnalytics = (0, $eUqFw.useCallback)((issueCount)=>(analyticsEvent)=>{
            onBulkEditClicked(issueCount, analyticsEvent);
        }, [
        onBulkEditClicked
    ]);
    const onViewInSearchClickedAnalytics = (0, $eUqFw.useCallback)((issueCount)=>(analyticsEvent)=>{
            onViewInSearchClicked(issueCount, analyticsEvent);
        }, [
        onViewInSearchClicked
    ]);
    const onHideDoneClickedWithMyPreferences = (0, $eUqFw.useCallback)(()=>{
        // myPreferences can only be set as a string, not as a boolean
        const hasHideDonePreference = hideDonePreference === 'true';
        setHideDonePreference(String(!hasHideDonePreference));
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'item',
            attributes: {
                childIssuesPanelType: childIssuesPanelType,
                totalIssues: allIssues.length,
                incompleteIssues: incompleteIssues.length,
                hideDone: !hasHideDonePreference
            }
        });
        onHideDoneClicked(allIssues.length, incompleteIssues.length, !hasHideDonePreference, analyticsEvent);
    }, [
        allIssues.length,
        childIssuesPanelType,
        createAnalyticsEvent,
        hideDonePreference,
        incompleteIssues.length,
        onHideDoneClicked,
        setHideDonePreference
    ]);
    const isWithinLimitOnInitialLoad = (0, $eUqFw.useMemo)(()=>!(0, $a7wEh.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus), [
        childIssuesLimitStatus
    ]);
    const isHideDoneCheckboxVisible = (0, $eUqFw.useMemo)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(incompleteIssues) && incompleteIssues.length !== allIssues.length && isWithinLimitOnInitialLoad, [
        allIssues.length,
        isWithinLimitOnInitialLoad,
        incompleteIssues
    ]);
    const viewInSearchLink = (0, $eUqFw.useMemo)(()=>{
        // These values will never be missing when the FF is enabled, this check is to satisfy TS
        if (projectType === undefined || isSimplifiedProject === undefined) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.child-issues-panel', 'Missing project, type, or isSimplified when generating search link');
            return '';
        }
        return (0, $1jlsP.generateViewInSearchLink)(projectKey, projectType, isSimplifiedProject, parentKey, childIssuesPanelType, (0, $a7wEh.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus), sortByValue);
    }, [
        childIssuesLimitStatus,
        childIssuesPanelType,
        isSimplifiedProject,
        parentKey,
        projectKey,
        projectType,
        sortByValue
    ]);
    const onViewInSearchClickedCallback = (0, $eUqFw.useCallback)((visibleIssuesCount)=>(event, analyticsEvent)=>{
            onViewInSearchClickedAnalytics(visibleIssuesCount)(analyticsEvent); // Ignore cmd or ctrl clicks - allow user to open in new tab
            if (!event.metaKey && !event.ctrlKey) {
                event.preventDefault();
                push(viewInSearchLink);
            }
        }, [
        push,
        onViewInSearchClickedAnalytics,
        viewInSearchLink
    ]);
    const renderHideDoneCheckbox = (0, $eUqFw.useCallback)(()=>{
        const hasExceededLimitAfterLoad = (0, $a7wEh.hasExceededIssuesLimitAfterLoad)(childIssuesLimitStatus);
        const dropdownItemCheckbox = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9mc6u.default), {
            id: "hideDone",
            key: "hideDone",
            onClick: onHideDoneClickedWithMyPreferences,
            isSelected: hideDonePreference === 'true',
            isDisabled: hasExceededLimitAfterLoad
        }, formatMessage((0, $6vqrr.default).hideDone));
        return isHideDoneCheckboxVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ro4T.default), {
            title: formatMessage((0, $6vqrr.default).filter),
            id: "child-issues-panel-checkbox-group"
        }, hasExceededLimitAfterLoad ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $6vqrr.default).disabledHideDone),
            position: "top"
        }, dropdownItemCheckbox) : dropdownItemCheckbox) : null;
    }, [
        childIssuesLimitStatus,
        formatMessage,
        hideDonePreference,
        isHideDoneCheckboxVisible,
        onHideDoneClickedWithMyPreferences
    ]);
    const childIssuesLimit = (0, $hJ992.useChildIssuesLimit)();
    const childIssuesLimitExceededAnalyticsCount = (0, $6azHZ.getChildIssuesLimitExceededAnalyticsCount)(childIssuesLimit);
    const renderedActionLinks = (0, $eUqFw.useMemo)(()=>{
        const visibleIssues = hideDone ? incompleteIssues : allIssues;
        const visibleIssuesCount = (0, $a7wEh.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus) ? childIssuesLimitExceededAnalyticsCount : visibleIssues.length;
        const bulkEditLink = (0, $bD9AZ.generateBulkEditLink)(parentKey, childIssuesPanelType, (0, $a7wEh.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus), sortByValue || undefined);
        const actionsTitle = isHideDoneCheckboxVisible ? formatMessage((0, $6vqrr.default).actions) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
            testId: "issue-view-common-views.child-issues-panel.heading.meatballs.dropdown-item-group",
            title: actionsTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default // @ts-expect-error Type '(analyticsEvent: AnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>) => void'.
        ), {
            onClick: onBulkEditClickedAnalytics(visibleIssuesCount),
            href: bulkEditLink,
            "data-testid": "issue.views.common.child-issues-panel.heading.meatballs.bulk-edit-dropdown-item"
        }, formatMessage((0, $6vqrr.default).bulkEdit)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default // @ts-expect-error - TS2769 - No overload matches this call.
        ), {
            onClick: onViewInSearchClickedCallback(visibleIssuesCount),
            href: viewInSearchLink,
            "data-testid": "issue.views.common.child-issues-panel.heading.meatballs.view-in-search-dropdown-item"
        }, formatMessage((0, $6vqrr.default).search)));
    }, [
        allIssues,
        childIssuesLimitStatus,
        childIssuesLimitExceededAnalyticsCount,
        childIssuesPanelType,
        formatMessage,
        hideDone,
        incompleteIssues,
        isHideDoneCheckboxVisible,
        onBulkEditClickedAnalytics,
        onViewInSearchClickedCallback,
        parentKey,
        sortByValue,
        viewInSearchLink
    ]);
    const renderDropdownTriggerButton = (0, $eUqFw.useCallback)(({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))),
            UNSAFE_size: "small",
            label: formatMessage((0, $6vqrr.default).tooltip),
            ref: triggerRef,
            interactionName: "auto-generated.jira-issue-view-common-views.child-issues-panel.view.heading.meatballs.button"
        }), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a95385759bd136a4$var$ButtonWrapper, {
        "data-testid": $a95385759bd136a4$var$testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        placement: "bottom-end",
        trigger: renderDropdownTriggerButton
    }, renderHideDoneCheckbox(), renderedActionLinks));
};
var $a95385759bd136a4$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a95385759bd136a4$export$8e357490a4a1908a;
const $a95385759bd136a4$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1qqmotz2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9mc6u", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdd85e99771c9c60$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $8jcoK = parcelRequire("8jcoK");

var $bULPy = parcelRequire("bULPy");

var $caOPr = parcelRequire("caOPr");

var $4lVNM = parcelRequire("4lVNM");

var $h1Q9j = parcelRequire("h1Q9j");

var $2fFJv = parcelRequire("2fFJv");
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $bdd85e99771c9c60$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $5Q9wj.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $2fFJv;
    const [selected, setSelected] = (0, $4lVNM.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $eUqFw.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $h1Q9j.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jcoK.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $caOPr.default), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        ...rest
    }, children));
};
var $bdd85e99771c9c60$export$2e2bcd8739ae039 = $bdd85e99771c9c60$var$DropdownItemCheckbox;

});
parcelRegister("caOPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f70ae4045f17c28$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");

var $PdmhA = parcelRequire("PdmhA");
/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ const $0f70ae4045f17c28$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $PdmhA.B400})` : `var(--ds-background-input, ${0, $PdmhA.N10})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $PdmhA.N10})` : 'transparent'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2",
        stroke: checked ? `var(--ds-border-selected, ${0, $PdmhA.B400})` : `var(--ds-border-input, ${0, $PdmhA.N100})`,
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    })));
};
var $0f70ae4045f17c28$export$2e2bcd8739ae039 = $0f70ae4045f17c28$var$CheckboxIcon;

});

parcelRegister("4lVNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f55dd9044769050$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b9WHI = parcelRequire("b9WHI");

var $7mYCs = parcelRequire("7mYCs");
/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $4f55dd9044769050$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $eUqFw.useContext)((0, $7mYCs.SelectionStoreContext));
    const groupId = (0, $eUqFw.useContext)((0, $b9WHI.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $eUqFw.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $eUqFw.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $4f55dd9044769050$export$2e2bcd8739ae039 = $4f55dd9044769050$var$useCheckboxState;

});
parcelRegister("b9WHI", function(module, exports) {

$parcel$export(module.exports, "CheckboxGroupContext", () => $7d37fbf6df8e3733$export$baf37c4be89255b8);

var $eUqFw = parcelRequire("eUqFw");
const $7d37fbf6df8e3733$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $eUqFw.createContext)('');

});



parcelRegister("5ro4T", function(module, exports) {

$parcel$export(module.exports, "default", () => $fafa29b0633a61e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jFtVs = parcelRequire("jFtVs");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");

var $b9WHI = parcelRequire("b9WHI");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ const $fafa29b0633a61e7$var$DropdownItemCheckboxGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, overrides: overrides, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const uid = (0, $jFtVs.useUID)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b9WHI.CheckboxGroupContext).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children));
};
var $fafa29b0633a61e7$export$2e2bcd8739ae039 = $fafa29b0633a61e7$var$DropdownItemCheckboxGroup;

});

parcelRegister("1jlsP", function(module, exports) {

$parcel$export(module.exports, "generateViewInSearchLink", () => $0de05bf246b3d4c3$export$d93c4c90817c96e8);

var $1tT5P = parcelRequire("1tT5P");

var $crniS = parcelRequire("crniS");
const $0de05bf246b3d4c3$export$d93c4c90817c96e8 = (projectKey, projectType, isSimplifiedProject, parentKey, childIssuesPanelType, hasExceededIssuesLimitInitialLoad, sortByValue = null)=>`${(0, $crniS.generateNinBasePath)()}?${(0, $1tT5P.generateChildIssuesJQL)(parentKey, childIssuesPanelType, hasExceededIssuesLimitInitialLoad, sortByValue || undefined)}`;

});
parcelRegister("1tT5P", function(module, exports) {

$parcel$export(module.exports, "generateChildIssuesJQL", () => $9de92648a7a1ec42$export$1d901f8ae5a6a569);

var $1ybV0 = parcelRequire("1ybV0");

var $agEEp = parcelRequire("agEEp");
const $9de92648a7a1ec42$export$75859f394155a563 = (sortByValue)=>{
    if (!sortByValue) return encodeURIComponent(' ORDER BY rank');
    switch(sortByValue){
        case 0, $agEEp.SORT_OPTION_STATUS:
            return encodeURIComponent(' ORDER BY statusCategory, status asc, rank');
        case 0, $agEEp.SORT_OPTION_PRIORITY:
        case 0, $agEEp.SORT_OPTION_KEY:
        case 0, $agEEp.SORT_OPTION_ASSIGNEE:
        case 0, $agEEp.SORT_OPTION_CREATED:
            return encodeURIComponent(` ORDER BY ${sortByValue}, rank`);
        case 0, $agEEp.SORT_OPTION_RANKING:
        default:
            return encodeURIComponent(' ORDER BY rank');
    }
};
// different between parent and parent link jql is that parent refers to subtasks/next gen child issues
// parent link refers to portfolio children issues
const $9de92648a7a1ec42$var$generateParentJQL = (parentKey)=>`${encodeURIComponent(`parent=${parentKey}`)}`;
const $9de92648a7a1ec42$var$generateParentLinkJQL = (parentKey)=>`${encodeURIComponent(`"Parent Link"=${parentKey}`)}`;
const $9de92648a7a1ec42$var$generateEpicLinkJQL = (parentKey)=>`${encodeURIComponent(`"Epic Link"=${parentKey}`)}`;
const $9de92648a7a1ec42$var$generateOverLimitJQL = (parentKey, sortByValue)=>(0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e') ? `jql=${$9de92648a7a1ec42$var$generateParentJQL(parentKey)}${$9de92648a7a1ec42$export$75859f394155a563(sortByValue)}` : `jql=${$9de92648a7a1ec42$var$generateParentJQL(parentKey)} OR ${$9de92648a7a1ec42$var$generateEpicLinkJQL(parentKey)} OR ${$9de92648a7a1ec42$var$generateParentLinkJQL(parentKey)}${$9de92648a7a1ec42$export$75859f394155a563(sortByValue)}`;
// Non-system epics do not support Epic Link: https://hello.atlassian.net/wiki/spaces/~888416081/pages/2366083841/System+and+Non-system+epic+issue+types
// To search for their children, we have to additionally use Parent Link
// Once https://team.atlassian.com/project/ATLAS-15331 is complete, both should be replaced with the Parent JQL
// The work to replace it is tracked at https://hello.atlassian.net/browse/JPO-23454
const $9de92648a7a1ec42$var$generateJQLForCMPParentAtHierarchyLevelOne = (parentKey, sortByValue)=>`jql=${$9de92648a7a1ec42$var$generateEpicLinkJQL(parentKey)} OR ${$9de92648a7a1ec42$var$generateParentLinkJQL(parentKey)}${$9de92648a7a1ec42$export$75859f394155a563(sortByValue)}`;
const $9de92648a7a1ec42$export$1d901f8ae5a6a569 = (parentKey, childIssuesPanelType, hasExceededIssuesLimitInitialLoad, sortByValue)=>{
    if (hasExceededIssuesLimitInitialLoad && childIssuesPanelType !== (0, $agEEp.CHILDREN_ISSUES_PANEL)) return $9de92648a7a1ec42$var$generateOverLimitJQL(parentKey, sortByValue);
    switch(childIssuesPanelType){
        case 0, $agEEp.CLASSIC_PORTFOLIO_CHILDREN:
            return `jql=${$9de92648a7a1ec42$var$generateParentLinkJQL(parentKey)}${$9de92648a7a1ec42$export$75859f394155a563(sortByValue)}`;
        case 0, $agEEp.CLASSIC_PROJECT_EPIC_CHILDREN:
            return $9de92648a7a1ec42$var$generateJQLForCMPParentAtHierarchyLevelOne(parentKey, sortByValue);
        case 0, $agEEp.CLASSIC_SUBTASKS:
        case 0, $agEEp.CHILDREN_ISSUES_PANEL:
        default:
            return `jql=${$9de92648a7a1ec42$var$generateParentJQL(parentKey)}${$9de92648a7a1ec42$export$75859f394155a563(sortByValue)}`;
    }
};

});

parcelRegister("crniS", function(module, exports) {

$parcel$export(module.exports, "generateNinBasePath", () => $8309bbdfd70991a7$export$47d9a807c1277671);
const $8309bbdfd70991a7$export$ddaf187654250a8d = '/issues/';
const $8309bbdfd70991a7$export$47d9a807c1277671 = ()=>$8309bbdfd70991a7$export$ddaf187654250a8d;

});


parcelRegister("a7wEh", function(module, exports) {

$parcel$export(module.exports, "hasExceededIssuesLimitAfterLoad", () => $ce243ea31519d5cc$export$29bd5f79d7a90777);
$parcel$export(module.exports, "hasExceededIssuesLimitInitialLoad", () => $ce243ea31519d5cc$export$730caf8c50e5c851);

var $4Xcha = parcelRequire("4Xcha");
const $ce243ea31519d5cc$export$29bd5f79d7a90777 = (childIssueLimitStatus)=>childIssueLimitStatus === (0, $4Xcha.EXCEEDED_LIMIT_AFTER_LOAD);
const $ce243ea31519d5cc$export$730caf8c50e5c851 = (childIssueLimitStatus)=>childIssueLimitStatus === (0, $4Xcha.EXCEEDED_LIMIT_INITIAL_LOAD);

});

parcelRegister("6vqrr", function(module, exports) {

$parcel$export(module.exports, "default", () => $60cbc5506d3b09cf$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $60cbc5506d3b09cf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    actions: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.actions",
        "defaultMessage": "Actions"
    },
    filter: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.filter",
        "defaultMessage": "Filter"
    },
    summaryDisplay: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.summary-display",
        "defaultMessage": "Summary display"
    },
    bulkEdit: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.bulk-edit",
        "defaultMessage": "Bulk edit"
    },
    hideDone: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.hide-done",
        "defaultMessage": "Hide done"
    },
    search: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.search",
        "defaultMessage": "View in search"
    },
    showStoryPoints: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.show-story-points",
        "defaultMessage": "Show total story points"
    },
    tooltip: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.tooltip",
        "defaultMessage": "Issue actions"
    },
    disabledHideDone: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.disabled-hide-done",
        "defaultMessage": "To filter more than 100 child issues, select ... -> View in Search"
    },
    disabledShowStoryPoints: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.disabled-show-story-points",
        "defaultMessage": "Add some story point values to your children issues to view story point progress"
    }
});

});

parcelRegister("bD9AZ", function(module, exports) {

$parcel$export(module.exports, "generateBulkEditLink", () => $505e26115717816e$export$d9a3bf30975d0075);

var $1tT5P = parcelRequire("1tT5P");
const $505e26115717816e$var$BULK_EDIT_URL = '/secure/views/bulkedit/BulkEdit1!default.jspa?reset=true&new=true';
const $505e26115717816e$export$d9a3bf30975d0075 = (parentKey, childIssuesPanelType, hasExceededIssuesLimitInitialLoad, sortByValue)=>`${$505e26115717816e$var$BULK_EDIT_URL}&${(0, $1tT5P.generateChildIssuesJQL)(parentKey, childIssuesPanelType, hasExceededIssuesLimitInitialLoad, sortByValue)}`;

});



parcelRegister("4qws5", function(module, exports) {

$parcel$export(module.exports, "default", () => $742402c4d3fa917e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $df4Sl = parcelRequire("df4Sl");

var $lqalZ = parcelRequire("lqalZ");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $ca2LP = parcelRequire("ca2LP");

var $6QyxX = parcelRequire("6QyxX");

var $aHOku = parcelRequire("aHOku");
const $742402c4d3fa917e$export$413b1c23ad987cd8 = ({ allIssueIds: allIssueIds, childIssuesLimitStatus: childIssuesLimitStatus })=>{
    const [sortByValue, { setSortBy: setSortBy }] = (0, $ca2LP.useChildIssuesSortBy)();
    const [, { setSortableIssueIds: setSortableIssueIds }] = (0, $ca2LP.useSortableIssueIds)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onSelect = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
    (value)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdown'
        }), 'childIssuesSortBy', {
            selection: value
        });
        setSortableIssueIds(allIssueIds);
        setSortBy(value);
    }, [
        allIssueIds,
        createAnalyticsEvent,
        setSortBy,
        setSortableIssueIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aHOku.SortByMenu), {
        sortedBy: sortByValue,
        // @ts-expect-error - TS2322 - Type '(value: any) => void' is not assignable to type '(selection: SortingOption, event: UIAnalyticsEventInterface) => Promise<undefined> | undefined'.
        onSelect: onSelect,
        childIssuesLimitStatus: childIssuesLimitStatus
    });
};
const $742402c4d3fa917e$var$toIssueIds = (0, $df4Sl.createSelector)((0, $6QyxX.getAllIssues), (issues)=>issues.map((issue)=>(0, $6vrw7.toIssueId)(issue.id)));
const $742402c4d3fa917e$var$ReduxConnectedComponent = (0, $lqalZ.connect)((state)=>({
        allIssueIds: $742402c4d3fa917e$var$toIssueIds(state)
    }), {})($742402c4d3fa917e$export$413b1c23ad987cd8);
var $742402c4d3fa917e$export$2e2bcd8739ae039 = $742402c4d3fa917e$var$ReduxConnectedComponent;

});
parcelRegister("aHOku", function(module, exports) {

$parcel$export(module.exports, "SortByMenu", () => $b42f62bba1ec7880$export$9c87b266b3462029);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $86Ndv = parcelRequire("86Ndv");

var $8cU5f = parcelRequire("8cU5f");

var $7uIWw = parcelRequire("7uIWw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $8411R = parcelRequire("8411R");

var $f9RL0 = parcelRequire("f9RL0");

var $g8JvH = parcelRequire("g8JvH");

var $a7wEh = parcelRequire("a7wEh");

var $agEEp = parcelRequire("agEEp");

var $1OPEV = parcelRequire("1OPEV");

var $9rcY3 = parcelRequire("9rcY3");
const $b42f62bba1ec7880$export$c0117b1abc6c64e3 = (0, $g8JvH.AnalyticsEventToProps)('dropdownItem', {
    onClick: 'clicked'
})((0, $hD6GJ.default));
const $b42f62bba1ec7880$var$optionsWithoutDefault = (0, $agEEp.SORTING_OPTIONS).filter((sortingOption)=>sortingOption !== (0, $agEEp.DEFAULT_SORTING_OPTION));
const $b42f62bba1ec7880$var$DEFAULT_OPTION_LABEL = 'defaultOptionLabel';
const $b42f62bba1ec7880$export$9c87b266b3462029 = (props)=>{
    const { sortedBy: sortedBy, onSelect: onSelect, childIssuesLimitStatus: childIssuesLimitStatus } = props;
    const options = $b42f62bba1ec7880$var$optionsWithoutDefault;
    const defaultOption = (0, $agEEp.DEFAULT_SORTING_OPTION);
    let availableSortingOptions = options;
    const issueKey = (0, $hJ992.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false); // we only want to allow filter by priority if we have `allowedValues` in context
    const [{ value: priorityField }] = (0, $8411R.useFieldConfig)(issueKey, (0, $f9RL0.PRIORITY));
    if (!priorityField || !priorityField.allowedValues || priorityField.allowedValues.length <= 1) availableSortingOptions = options.filter((option)=>option !== (0, $agEEp.SORT_OPTION_PRIORITY));
    const optionLabels = (0, $eUqFw.useMemo)(()=>{
        const labelsMap = new Map();
        const defaultOptionName = formatMessage((0, $1OPEV.default)[0, $agEEp.DEFAULT_SORTING_OPTION]);
        const defaultOptionLabel = formatMessage((0, $1OPEV.default).defaultOptionLabel, {
            option: defaultOptionName
        });
        labelsMap.set((0, $agEEp.DEFAULT_SORTING_OPTION), defaultOptionName);
        labelsMap.set($b42f62bba1ec7880$var$DEFAULT_OPTION_LABEL, defaultOptionLabel);
        availableSortingOptions.forEach((sortOption)=>{
            labelsMap.set(sortOption, formatMessage((0, $1OPEV.default)[sortOption]));
        });
        return labelsMap;
    }, [
        availableSortingOptions,
        formatMessage
    ]);
    const otherOptions = (0, $eUqFw.useMemo)(()=>availableSortingOptions.filter((option)=>option !== sortedBy), [
        availableSortingOptions,
        sortedBy
    ]);
    const hasExceededLimitAfterLoad = (0, $a7wEh.hasExceededIssuesLimitAfterLoad)(childIssuesLimitStatus);
    const button = (0, $eUqFw.useCallback)(// @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    ({ triggerRef: triggerRef, ...triggerProps } = {})=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9rcY3.StyledButton), {
            ...triggerProps,
            appearance: "subtle",
            isSelected: isOpen,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: ""
            }),
            testId: "issue.views.common.child-issues-panel.heading.sort-by-menu.trigger-button",
            isDisabled: hasExceededLimitAfterLoad,
            ref: triggerRef,
            interactionName: "auto-generated.issue.views.common.child-issues-panel.heading.sort-by-menu.trigger-button.button",
            spacing: "compact"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9rcY3.LabelWrapper), null, formatMessage((0, $1OPEV.default).sortByLabel, {
            // label should read just "sort by" whenever the default option is to be used
            option: sortedBy !== null && sortedBy !== defaultOption ? optionLabels.get(sortedBy)?.toLowerCase() : ''
        }))), [
        defaultOption,
        formatMessage,
        hasExceededLimitAfterLoad,
        isOpen,
        optionLabels,
        sortedBy
    ]);
    if ((0, $a7wEh.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus)) return null;
    if (hasExceededLimitAfterLoad) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $1OPEV.default).exceededChildIssuesLimit),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7uIWw.default), {
        isDisabled: hasExceededLimitAfterLoad
    }, button()));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: button,
        isOpen: isOpen,
        onOpenChange: ()=>{
            setIsOpen(!isOpen);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b42f62bba1ec7880$var$DropdownGroupWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, otherOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b42f62bba1ec7880$export$c0117b1abc6c64e3, {
            key: option,
            "data-testId": `issue.views.common.child-issues-panel.heading.sort-by-menu.option-${option}`,
            onClick: (event, analyticsEvent)=>onSelect(option, analyticsEvent)
        }, optionLabels.get(option))), sortedBy && sortedBy !== defaultOption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9rcY3.DefaultOptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b42f62bba1ec7880$export$c0117b1abc6c64e3, {
        key: defaultOption,
        "data-testId": "issue.views.common.child-issues-panel.heading.sort-by-menu.default-option" // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
        ,
        onClick: (event, analyticsEvent)=>onSelect(defaultOption, analyticsEvent)
    }, optionLabels.get($b42f62bba1ec7880$var$DEFAULT_OPTION_LABEL))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b42f62bba1ec7880$var$DropdownGroupWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91lit",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7uIWw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c23000ce719f2bef$export$2e2bcd8739ae039);

var $kwce8 = parcelRequire("kwce8");
/**
 * When the @atlaskit/button component is disabled it prevents mouse events being fired for the button, which prevents
 * tooltips showing https://atlassian.design/components/button/usage#disabled-buttons.
 * When you require a disabled button to show a tooltip on hover then the button should be wrapped in this element.
 */ // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c23000ce719f2bef$var$DisabledButtonWithTooltip = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "yhjexx-0"
})({
    display: 'inline-flex'
}, (props)=>props.isDisabled ? // eslint-disable-next-line jira/compiled/styled-components-usages
    (0, $kwce8.css)({
        cursor: 'not-allowed',
        // Disable pointer events for the button element which means 'event.preventDefault()' will not be
        // called from AK. This allows pointer events to bubble from our wrapping span element.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> button': {
            pointerEvents: 'none'
        }
    }) : '');
var // eslint-disable-next-line jira/styled/no-styled-export
$c23000ce719f2bef$export$2e2bcd8739ae039 = $c23000ce719f2bef$var$DisabledButtonWithTooltip;

});

parcelRegister("1OPEV", function(module, exports) {

$parcel$export(module.exports, "default", () => $473aa061a4e0bb16$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $473aa061a4e0bb16$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sortByLabel: {
        "id": "issue.views.common.child-issues-panel.heading.sort-by.label",
        "defaultMessage": "Order by {option}"
    },
    created: {
        "id": "issue.views.common.child-issues-panel.heading.created.label",
        "defaultMessage": "Created"
    },
    key: {
        "id": "issue.views.common.child-issues-panel.heading.key.label",
        "defaultMessage": "Key"
    },
    priority: {
        "id": "issue.views.common.child-issues-panel.heading.priority.label",
        "defaultMessage": "Priority"
    },
    status: {
        "id": "issue.views.common.child-issues-panel.heading.status.label",
        "defaultMessage": "Status"
    },
    assignee: {
        "id": "issue.views.common.child-issues-panel.heading.assignee.label",
        "defaultMessage": "Assignee"
    },
    ranking: {
        "id": "issue.views.common.child-issues-panel.heading.ranking.label",
        "defaultMessage": "Rank"
    },
    defaultOptionLabel: {
        "id": "issue.views.common.child-issues-panel.heading.default-option.label",
        "defaultMessage": "{option} (default)"
    },
    exceededChildIssuesLimit: {
        "id": "issue.views.common.child-issues-panel.heading.sort-by.exceeded-child-issues-limit",
        "defaultMessage": "To order more than 100 child issues, select \xB7\xB7\xB7 > View in search."
    }
});

});

parcelRegister("9rcY3", function(module, exports) {

$parcel$export(module.exports, "LabelWrapper", () => $0c26c3371a2b6333$export$147422f7450ccfac);
$parcel$export(module.exports, "DefaultOptionWrapper", () => $0c26c3371a2b6333$export$98a02e9d246f2af);
$parcel$export(module.exports, "StyledButton", () => $0c26c3371a2b6333$export$2d5d2ba3c7c8c40b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $0c26c3371a2b6333$export$147422f7450ccfac = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f312x7",
            __cmplp.className
        ])
    });
});
const $0c26c3371a2b6333$export$98a02e9d246f2af = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_x3do1l7n _1yt4swc3 _1tjq1y58",
            __cmplp.className
        ])
    });
});
const $0c26c3371a2b6333$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg",
            __cmplp.className
        ])
    });
});

});



parcelRegister("HGqcL", function(module, exports) {

$parcel$export(module.exports, "default", () => $05c606399f09942f$export$2e2bcd8739ae039);

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $2HCUG = parcelRequire("2HCUG");

var $5VeUH = parcelRequire("5VeUH");
var $05c606399f09942f$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        title: (0, $2HCUG.getTitle)(state),
        titleChildIssues: (0, $2HCUG.getChildTitle)(state)
    }), {}))((0, $5VeUH.Title));

});
parcelRegister("5VeUH", function(module, exports) {

$parcel$export(module.exports, "Title", () => $0b2b09fd1dae22e7$export$f99233281efd08a0);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $iAc02 = parcelRequire("iAc02");

var $guDlK = parcelRequire("guDlK");

var $f1b6Y = parcelRequire("f1b6Y");
const $0b2b09fd1dae22e7$var$testId = 'issue.views.common.child-issues-panel.heading.title';
const $0b2b09fd1dae22e7$export$f99233281efd08a0 = ({ title: title = (0, $f1b6Y.default).title, titleChildIssues: titleChildIssues })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const isSimplified = (0, $guDlK.useIsSimplifiedProject)(projectKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingTitle), {
        "data-testid": $0b2b09fd1dae22e7$var$testId
    }, projectType === 'software' && !isSimplified && titleChildIssues ? formatMessage(titleChildIssues) : formatMessage(title));
};

});
parcelRegister("f1b6Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $c12a1905172c1744$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $c12a1905172c1744$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue.views.common.child-issues-panel.heading.title.title",
        "defaultMessage": "Child issues"
    }
});

});



parcelRegister("ibfcm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d351fad1ccd09ff2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aBT3I = parcelRequire("aBT3I");

var $1U6Rx = parcelRequire("1U6Rx");
var $8sN8t = parcelRequire("8sN8t");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5c3AR = parcelRequire("5c3AR");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $iAc02 = parcelRequire("iAc02");

var $6yplV = parcelRequire("6yplV");

var $a7wEh = parcelRequire("a7wEh");

var $4YTD2 = parcelRequire("4YTD2");

var $daDVt = parcelRequire("daDVt");
function $d351fad1ccd09ff2$export$2e2bcd8739ae039(props) {
    const { Title: Title, Meatballs: Meatballs, AddChild: AddChild, SortByMenu: SortByMenu, supportsIssueCreation: supportsIssueCreation, allIssues: allIssues, onAddChildClick: onAddChildClick, sourceName: sourceName, isSortingAvailable: isSortingAvailable, childIssuesLimitStatus: childIssuesLimitStatus, issueHierarchyLevel: issueHierarchyLevel } = props;
    const isMeatballMenuEnabled = (0, $a7wEh.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus) || allIssues.length > 0;
    const isAiEnabled = (0, $daDVt.useIsAiEnabled)();
    const isAiOptInEnabled = (0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hJ992.useIsAiOptInEnabled)() : false;
    const isAnonymousUser = (0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $6yplV.useIsAnonymous)() : false;
    const renderIssueBreakdownButton = (0, $eUqFw.useMemo)(()=>{
        const AIBreakdownButton = (0, $1ybV0.ff)('jira-ai-work-breakdown-new-ui_z0inn') ? (0, $5c3AR.IssueBreakdownButton) : (0, $4YTD2.IssueBreakdownButton);
        if ((0, $1ybV0.ff)('jira-ai-work-breakdown-onboarding')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1U6Rx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sN8t.default), {
            name: "suggestIssuesSpotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AIBreakdownButton, {
            issueHierarchyLevel: issueHierarchyLevel
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBT3I.EngagementSpotlight), {
            engagementId: "suggestIssuesSpotlight"
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AIBreakdownButton, {
            issueHierarchyLevel: issueHierarchyLevel
        });
    }, [
        issueHierarchyLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("label", {
        htmlFor: sourceName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Title, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingIcons), null, isSortingAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SortByMenu, {
        childIssuesLimitStatus: childIssuesLimitStatus
    }), isMeatballMenuEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Meatballs, {
        childIssuesLimitStatus: childIssuesLimitStatus
    }) : null, supportsIssueCreation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AddChild, {
        onClick: onAddChildClick
    }) : null, (0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') && !isAnonymousUser && supportsIssueCreation && isAiEnabled && isAiOptInEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d351fad1ccd09ff2$var$issueBreakdownButtonStyles
    }, renderIssueBreakdownButton) : null));
}
const $d351fad1ccd09ff2$var$issueBreakdownButtonStyles = (0, $1ZAYh.xcss)({
    marginLeft: "var(--ds-space-075, 6px)"
});
$d351fad1ccd09ff2$export$2e2bcd8739ae039.defaultProps = {
    isSortingAvailable: false,
    supportsIssueCreation: false,
    allIssues: []
};

});
parcelRegister("5c3AR", function(module, exports) {

$parcel$export(module.exports, "IssueBreakdownButton", () => $5ed77a704a59045f$export$c8fabf04379fa2f7);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $8cU5f = parcelRequire("8cU5f");

var $78led = parcelRequire("78led");

var $l3Qg0 = parcelRequire("l3Qg0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $5gJbo = parcelRequire("5gJbo");

var $9D3Vo = parcelRequire("9D3Vo");

var $kJlBc = parcelRequire("kJlBc");

var $5Dznp = parcelRequire("5Dznp");

var $6fPfJ = parcelRequire("6fPfJ");

var $9q3sJ = parcelRequire("9q3sJ");
const $5ed77a704a59045f$var$SUGGEST_ISSUE_QUERY = 'suggestIssue';
const $5ed77a704a59045f$var$queryParams = {
    [$5ed77a704a59045f$var$SUGGEST_ISSUE_QUERY]: 'true'
};
const $5ed77a704a59045f$export$c8fabf04379fa2f7 = ({ issueHierarchyLevel: issueHierarchyLevel })=>{
    const [{ currentStep: currentStep }, { setIssueBreakdownStep: setIssueBreakdownStep, updateStreamingStatus: updateStreamingStatus }] = (0, $5Dznp.useIssueBreakdown)();
    const { entryPointActions: entryPointActions } = (0, $eUqFw.useContext)((0, $6fPfJ.AiIssueBreakdownEntryPointContext));
    const triggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions, true);
    const isSelected = currentStep !== (0, $5Dznp.steps).defaultStep;
    const isModal = (0, $hJ992.useIsModal)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const { push: push, replace: replace } = (0, $kJlBc.useRouterActions)();
    const fullIssueUrl = (0, $9D3Vo.createFullIssueUrl)('', issueKey);
    const query = new URLSearchParams($5ed77a704a59045f$var$queryParams);
    const urlWithQuery = `${fullIssueUrl}?${query}`;
    // Redirect to full issue page when on the modal view
    const onModalClick = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        if ((0, $5gJbo.isLeftClickOnly)(event)) push(urlWithQuery);
        else window.open(urlWithQuery, '_blank');
    }, [
        push,
        urlWithQuery
    ]);
    // Toggle to open/close issue breakdown
    const onFullViewClick = (0, $eUqFw.useCallback)(()=>{
        if (!isSelected) {
            setIssueBreakdownStep((0, $5Dznp.steps).draftListStep);
            updateStreamingStatus(true);
        }
    }, [
        isSelected,
        setIssueBreakdownStep,
        updateStreamingStatus
    ]);
    // If the query string contains suggestIssue=true
    // Start the issue suggesting when mount the component
    (0, $eUqFw.useEffect)(()=>{
        if (!isModal && !isSelected) {
            const params = new URLSearchParams(window.location.search);
            const shouldSuggest = params.has($5ed77a704a59045f$var$SUGGEST_ISSUE_QUERY, $5ed77a704a59045f$var$queryParams[$5ed77a704a59045f$var$SUGGEST_ISSUE_QUERY]);
            if (shouldSuggest) {
                setIssueBreakdownStep((0, $5Dznp.steps).draftListStep);
                replace(fullIssueUrl);
                updateStreamingStatus(true);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const commonProps = {
        ref: triggerRef,
        spacing: 'compact',
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78led.AiIcon), {
            size: "medium",
            label: ""
        }),
        interactionName: 'auto-generated.ai-work-breakdown.ui.issue-breakdown-button.button.button',
        testId: 'ai-work-breakdown.ui.issue-breakdown-button.button'
    };
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueNameForFormatting = {
        issueType: issueHierarchyLevel && issueHierarchyLevel > 0 ? 'issues' : 'tasks'
    };
    const buttonLabel = formatMessage((0, $9q3sJ.default).buttonLabel, issueNameForFormatting);
    const buttonDefaultTooltip = formatMessage((0, $9q3sJ.default).buttonDefaultTooltipContent, issueNameForFormatting);
    const buttonModalViewTooltip = formatMessage((0, $9q3sJ.default).buttonModalViewTooltipContent, issueNameForFormatting);
    if (isModal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: buttonModalViewTooltip,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5ed77a704a59045f$var$IssueBreakdownButtonStyled, {
        ...commonProps,
        onClick: onModalClick,
        href: urlWithQuery
    }, buttonLabel));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: buttonDefaultTooltip,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5ed77a704a59045f$var$IssueBreakdownButtonStyled, {
        ...commonProps,
        isSelected: isSelected,
        onClick: onFullViewClick
    }, buttonLabel));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $5ed77a704a59045f$var$IssueBreakdownButtonStyled = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaznoz8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("78led", function(module, exports) {

$parcel$export(module.exports, "AiIcon", () => $c929eac1624d8a26$export$762da6f7f5ace732);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");
const $c929eac1624d8a26$export$762da6f7f5ace732 = (props)=>{
    let iconAccentBlueB200;
    let textAccentBlueB400;
    if (props.isDisabled && (0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u')) {
        iconAccentBlueB200 = `var(--ds-text-subtlest, ${(0, $PdmhA).N200})`;
        textAccentBlueB400 = `var(--ds-text-subtlest, ${(0, $PdmhA).N200})`;
    } else if (props.isDisabled) {
        iconAccentBlueB200 = `var(--ds-icon-accent-gray, ${(0, $PdmhA).N300})`;
        textAccentBlueB400 = `var(--ds-text-accent-gray, ${(0, $PdmhA).N300})`;
    } else {
        iconAccentBlueB200 = `var(--ds-icon-accent-blue, ${(0, $PdmhA).B200})`;
        textAccentBlueB400 = `var(--ds-text-accent-blue, ${(0, $PdmhA).B400})`;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg0",
        x1: "21",
        y1: "12",
        x2: "17.5",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.270833",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg1",
        x1: "12.5",
        y1: "3",
        x2: "12.5",
        y2: "6.5",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.1875",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg2",
        x1: "6.82996",
        y1: "12",
        x2: "3.32996",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.791667",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg3",
        x1: "12.5",
        y1: "17",
        x2: "12.5",
        y2: "21",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.802083",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
        fill: props.isDisabled && (0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u') ? `var(--ds-text-subtlest, ${(0, $PdmhA).N200})` : 'url(#ai_icon_lg0)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: props.isDisabled && (0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u') ? `var(--ds-text-subtlest, ${(0, $PdmhA).N200})` : 'url(#ai_icon_lg1)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: props.isDisabled && (0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u') ? `var(--ds-text-subtlest, ${(0, $PdmhA).N200})` : 'url(#ai_icon_lg2)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
        fill: props.isDisabled && (0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u') ? `var(--ds-text-subtlest, ${(0, $PdmhA).N200})` : 'url(#ai_icon_lg3)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: iconAccentBlueB200
    })));
};

});

parcelRegister("9q3sJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbbb6186f5e4547e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dbbb6186f5e4547e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    buttonLabel: {
        "id": "ai-work-breakdown.button-label",
        "defaultMessage": "Suggest {issueType, select, tasks {subtasks} issues {child issues} other {child issues}}"
    },
    buttonDefaultTooltipContent: {
        "id": "ai-work-breakdown.button-default-tooltip-content",
        "defaultMessage": "Ask Atlassian Intelligence to suggest {issueType, select, tasks {subtasks} issues {child issues} other {child issues}} for you."
    },
    buttonModalViewTooltipContent: {
        "id": "ai-work-breakdown.button-modal-view-tooltip-content",
        "defaultMessage": "Ask Atlassian Intelligence to suggest {issueType, select, tasks {subtasks} issues {child issues} other {child issues}} for you. This will open in a full page view."
    },
    placeholderTextNonFinal: {
        "id": "ai-work-breakdown.placeholder-text-non-final",
        "defaultMessage": "Tell us how you want your issues generated, or hit Enter."
    },
    footerTextDraftList: {
        "id": "ai-work-breakdown.footer-text-draft-list",
        "defaultMessage": "Ask AI to refine suggestions."
    },
    footerTextPromptNonFinal: {
        "id": "ai-work-breakdown.footer-text-prompt-non-final",
        "defaultMessage": "Powered by Atlassian Intelligence"
    },
    labelCancel: {
        "id": "ai-work-breakdown.label-cancel",
        "defaultMessage": "Cancel"
    },
    labelStop: {
        "id": "ai-work-breakdown.label-stop",
        "defaultMessage": "Stop"
    },
    acceptAll: {
        "id": "ai-work-breakdown.accept-all",
        "defaultMessage": "Accept all"
    },
    labelEscNonFinal: {
        "id": "ai-work-breakdown.label-esc-non-final",
        "defaultMessage": "Esc"
    },
    successFlagTitle: {
        "id": "ai-work-breakdown.success-flag-title",
        "defaultMessage": "Issues successfully created"
    },
    successFlagDescription: {
        "id": "ai-work-breakdown.success-flag-description",
        "defaultMessage": "Your issues have been successfully created"
    },
    errorFlagTitleOnItemNonFinal: {
        "id": "ai-work-breakdown.error-flag-title-on-item-non-final",
        "defaultMessage": "Project or issue ID was not provided."
    },
    errorFlagDescriptionNonFinal: {
        "id": "ai-work-breakdown.error-flag-description-non-final",
        "defaultMessage": "Please try again later."
    },
    statusRetrievingSourceContextNonFinal: {
        "id": "ai-work-breakdown.status-retrieving-source-context-non-final",
        "defaultMessage": "Atlassian Intelligence is reading the parent issue..."
    },
    statusRefiningSuggestedIssuesNonFinal: {
        "id": "ai-work-breakdown.status-refining-suggested-issues-non-final",
        "defaultMessage": "Atlassian Intelligence is refining suggestions..."
    },
    statusSuggestingInitialIssuesNonFinal: {
        "id": "ai-work-breakdown.status-suggesting-initial-issues-non-final",
        "defaultMessage": "Atlassian Intelligence is generating suggestions..."
    },
    statusRemovingDuplicateIssuesNonFinal: {
        "id": "ai-work-breakdown.status-removing-duplicate-issues-non-final",
        "defaultMessage": "Atlassian Intelligence is removing duplicates..."
    },
    statusReformatingIssuesNonFinal: {
        "id": "ai-work-breakdown.status-reformating-issues-non-final",
        "defaultMessage": "Atlassian Intelligence is writing descriptions..."
    },
    statusGeneratingDefaultMessageNonFinal: {
        "id": "ai-work-breakdown.status-generating-default-message-non-final",
        "defaultMessage": "Generating issue suggestions"
    }
});

});


parcelRegister("4YTD2", function(module, exports) {

$parcel$export(module.exports, "IssueBreakdownButton", () => $079019d688c78676$export$c8fabf04379fa2f7);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $8cU5f = parcelRequire("8cU5f");

var $78led = parcelRequire("78led");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $5gJbo = parcelRequire("5gJbo");

var $9D3Vo = parcelRequire("9D3Vo");

var $kJlBc = parcelRequire("kJlBc");

var $3xyAb = parcelRequire("3xyAb");

var $5IHDa = parcelRequire("5IHDa");
const $079019d688c78676$var$SUGGEST_ISSUE_QUERY = 'suggestIssue';
const $079019d688c78676$var$queryParams = {
    [$079019d688c78676$var$SUGGEST_ISSUE_QUERY]: 'true'
};
const $079019d688c78676$export$c8fabf04379fa2f7 = ({ issueHierarchyLevel: issueHierarchyLevel })=>{
    const [{ currentStep: currentStep }, { setIssueBreakdownStep: setIssueBreakdownStep, closeIssueBreakdown: closeIssueBreakdown }] = (0, $3xyAb.useIssueBreakdown)();
    const isSelected = currentStep !== (0, $3xyAb.steps).defaultStep;
    const isModal = (0, $hJ992.useIsModal)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const { push: push, replace: replace } = (0, $kJlBc.useRouterActions)();
    const fullIssueUrl = (0, $9D3Vo.createFullIssueUrl)('', issueKey);
    const query = new URLSearchParams($079019d688c78676$var$queryParams);
    const urlWithQuery = `${fullIssueUrl}?${query}`;
    // Redirect to full issue page when on the modal view
    const onModalClick = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        if ((0, $5gJbo.isLeftClickOnly)(event)) push(urlWithQuery);
        else window.open(urlWithQuery, '_blank');
    }, [
        push,
        urlWithQuery
    ]);
    // Toggle to open/close issue breakdown
    const onFullViewClick = (0, $eUqFw.useCallback)(()=>{
        if (isSelected) closeIssueBreakdown();
        else setIssueBreakdownStep((0, $3xyAb.steps).promptInputStep);
    }, [
        closeIssueBreakdown,
        isSelected,
        setIssueBreakdownStep
    ]);
    // If the query string contains suggestIssue=true
    // Start the issue suggesting when mount the component
    (0, $eUqFw.useEffect)(()=>{
        if (!isModal && !isSelected) {
            const params = new URLSearchParams(window.location.search);
            const shouldSuggest = params.has($079019d688c78676$var$SUGGEST_ISSUE_QUERY, $079019d688c78676$var$queryParams[$079019d688c78676$var$SUGGEST_ISSUE_QUERY]);
            if (shouldSuggest) {
                setIssueBreakdownStep((0, $3xyAb.steps).promptInputStep);
                replace(fullIssueUrl);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const commonProps = {
        spacing: 'compact',
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78led.AiIcon), {
            size: "medium",
            label: ""
        }),
        interactionName: 'auto-generated.issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-button.button.button',
        testId: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-button.button'
    };
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueNameForFormatting = {
        issueType: issueHierarchyLevel && issueHierarchyLevel > 0 ? 'issues' : 'tasks'
    };
    const buttonLabel = formatMessage((0, $5IHDa.default).buttonLabel, issueNameForFormatting);
    const buttonDefaultTooltip = formatMessage((0, $5IHDa.default).buttonDefaultTooltipContent, issueNameForFormatting);
    const buttonModalViewTooltip = formatMessage((0, $5IHDa.default).buttonModalViewTooltipContent, issueNameForFormatting);
    if (isModal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: buttonModalViewTooltip,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($079019d688c78676$var$IssueBreakdownButtonStyled, {
        ...commonProps,
        onClick: onModalClick,
        href: urlWithQuery
    }, buttonLabel));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: buttonDefaultTooltip,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($079019d688c78676$var$IssueBreakdownButtonStyled, {
        ...commonProps,
        isSelected: isSelected,
        onClick: onFullViewClick
    }, buttonLabel));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $079019d688c78676$var$IssueBreakdownButtonStyled = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaznoz8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3xyAb", function(module, exports) {

$parcel$export(module.exports, "steps", () => $fdc99da597ac0001$export$be3f796aed065412);
$parcel$export(module.exports, "reasons", () => $fdc99da597ac0001$export$653523807df144ac);
$parcel$export(module.exports, "DEFAULT_SELECTED_ISSUE_INDEX", () => $fdc99da597ac0001$export$d355f24dbbcc075e);
$parcel$export(module.exports, "IssueBreakdownAiContainer", () => $fdc99da597ac0001$export$ac6c39a0dbf8f3e5);
$parcel$export(module.exports, "useIssueBreakdown", () => $fdc99da597ac0001$export$2d0761b6b6ddada);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $fdc99da597ac0001$export$be3f796aed065412 = {
    defaultStep: 'defaultStep',
    promptInputStep: 'promptInputStep',
    draftListStep: 'draftListStep',
    errorStep: 'errorStep'
};
const $fdc99da597ac0001$export$653523807df144ac = {
    accept: 'accept',
    reject: 'reject'
};
const $fdc99da597ac0001$export$d355f24dbbcc075e = 0;
const $fdc99da597ac0001$var$initialState = {
    currentStep: $fdc99da597ac0001$export$be3f796aed065412.defaultStep,
    retryAttempts: 0,
    suggestedChildIssues: [],
    promptValue: '',
    issueTypeIds: [],
    headerPromptValue: '',
    selectedIssueIndex: null,
    channelId: null,
    acceptedChildIssues: [],
    rejectedChildIssues: [],
    isDiscardSuggestionsModalOpen: false,
    isStreaming: false,
    clearListWhenAddSuggestion: false,
    status: null
};
const $fdc99da597ac0001$var$setIssueBreakdownStep = (step)=>({ setState: setState })=>{
        setState({
            currentStep: step
        });
    };
const $fdc99da597ac0001$var$setSuggestedChildIssues = (suggestedChildIssues)=>({ setState: setState })=>{
        setState({
            suggestedChildIssues: suggestedChildIssues
        });
    };
const $fdc99da597ac0001$var$setSelectedIssueIndex = (selectedIssueIndex)=>({ setState: setState })=>{
        setState({
            selectedIssueIndex: selectedIssueIndex
        });
    };
const $fdc99da597ac0001$var$unselectCurrentIndex = ()=>({ setState: setState })=>{
        setState({
            selectedIssueIndex: null
        });
    };
const $fdc99da597ac0001$var$setChannelId = (channelId)=>({ setState: setState })=>{
        setState({
            channelId: channelId
        });
    };
const $fdc99da597ac0001$var$resetIssueBreakdownState = ()=>({ setState: setState })=>{
        setState($fdc99da597ac0001$var$initialState);
    };
const $fdc99da597ac0001$var$setPromptValue = (promptValue)=>({ setState: setState })=>{
        setState({
            promptValue: promptValue
        });
    };
const $fdc99da597ac0001$var$setIssueTypeIds = (issueTypeIds)=>({ setState: setState })=>{
        setState({
            issueTypeIds: issueTypeIds
        });
    };
const $fdc99da597ac0001$var$setHeaderPromptValue = (headerPromptValue)=>({ setState: setState })=>{
        setState({
            headerPromptValue: headerPromptValue
        });
    };
const $fdc99da597ac0001$var$openDiscardSuggestionsModal = ()=>({ setState: setState })=>{
        setState({
            isDiscardSuggestionsModalOpen: true
        });
    };
const $fdc99da597ac0001$var$closeDiscardSuggestionsModal = ()=>({ setState: setState })=>{
        setState({
            isDiscardSuggestionsModalOpen: false
        });
    };
const $fdc99da597ac0001$var$closeIssueBreakdown = ()=>({ getState: getState, setState: setState })=>{
        const { currentStep: currentStep } = getState();
        switch(currentStep){
            case $fdc99da597ac0001$export$be3f796aed065412.draftListStep:
                setState({
                    isDiscardSuggestionsModalOpen: true
                });
                break;
            case $fdc99da597ac0001$export$be3f796aed065412.promptInputStep:
                setState($fdc99da597ac0001$var$initialState);
                break;
            case $fdc99da597ac0001$export$be3f796aed065412.defaultStep:
            default:
        }
    };
const $fdc99da597ac0001$var$isIssueBreakdownOpen = ()=>({ getState: getState })=>{
        const { currentStep: currentStep } = getState();
        return currentStep !== $fdc99da597ac0001$export$be3f796aed065412.defaultStep;
    };
const $fdc99da597ac0001$var$getSuggestedLength = ()=>({ getState: getState })=>{
        const { suggestedChildIssues: suggestedChildIssues } = getState();
        return suggestedChildIssues.length;
    };
const $fdc99da597ac0001$var$updateSuggestedResult = ({ channelId: channelId, suggestedChildIssues: suggestedChildIssues, selectedIssueIndex: selectedIssueIndex = $fdc99da597ac0001$export$d355f24dbbcc075e })=>({ setState: setState })=>{
        setState({
            channelId: channelId,
            suggestedChildIssues: suggestedChildIssues,
            selectedIssueIndex: selectedIssueIndex
        });
    };
const $fdc99da597ac0001$var$addSuggestedIssue = (newSuggestedIssue)=>({ getState: getState, setState: setState })=>{
        const { suggestedChildIssues: oldIssues, status: status, clearListWhenAddSuggestion: clearListWhenAddSuggestion } = getState();
        const suggestedChildIssues = clearListWhenAddSuggestion ? [
            newSuggestedIssue
        ] : oldIssues.concat(newSuggestedIssue);
        if (status) setState({
            suggestedChildIssues: suggestedChildIssues,
            status: null,
            clearListWhenAddSuggestion: false
        });
        else setState({
            suggestedChildIssues: suggestedChildIssues,
            clearListWhenAddSuggestion: false
        });
    };
const $fdc99da597ac0001$var$removeCurrentSuggestedChildIssue = (reason)=>({ setState: setState, getState: getState })=>{
        const { selectedIssueIndex: selectedIssueIndex, suggestedChildIssues: suggestedChildIssues, acceptedChildIssues: acceptedChildIssues, rejectedChildIssues: rejectedChildIssues } = getState();
        if (selectedIssueIndex === null) return;
        const selectedIssue = suggestedChildIssues[selectedIssueIndex];
        const newState = {
            selectedIssueIndex: selectedIssueIndex % (suggestedChildIssues.length - 1),
            suggestedChildIssues: suggestedChildIssues.filter((_item, index)=>index !== selectedIssueIndex)
        };
        switch(reason){
            case $fdc99da597ac0001$export$653523807df144ac.accept:
                setState({
                    ...newState,
                    acceptedChildIssues: acceptedChildIssues.concat({
                        summary: selectedIssue.summary,
                        description: selectedIssue.description
                    })
                });
                break;
            case $fdc99da597ac0001$export$653523807df144ac.reject:
            default:
                setState({
                    ...newState,
                    rejectedChildIssues: rejectedChildIssues.concat({
                        summary: selectedIssue.summary,
                        description: selectedIssue.description
                    })
                });
                break;
        }
    };
const $fdc99da597ac0001$var$updateStreamingStatus = (isStreaming, status = null)=>({ setState: setState })=>{
        setState({
            isStreaming: isStreaming,
            clearListWhenAddSuggestion: isStreaming,
            status: status
        });
    };
const $fdc99da597ac0001$var$setStreamingError = ()=>({ setState: setState, getState: getState })=>{
        const { suggestedChildIssues: suggestedChildIssues, promptValue: promptValue } = getState();
        if (suggestedChildIssues.length > 0 || promptValue) // If it's a refine request,
        // for example, after the initial request has succeeded or the user has typed in text
        // then want to keep the channel ID.
        setState({
            currentStep: $fdc99da597ac0001$export$be3f796aed065412.errorStep
        });
        else // If the initial request fails, we want to start a new one
        setState({
            currentStep: $fdc99da597ac0001$export$be3f796aed065412.errorStep,
            channelId: null
        });
    };
const $fdc99da597ac0001$var$incrementRetryCount = ()=>({ getState: getState, setState: setState })=>{
        const { retryAttempts: retryAttempts } = getState();
        setState({
            retryAttempts: retryAttempts + 1
        });
    };
const $fdc99da597ac0001$export$e324594224ef24da = {
    setIssueBreakdownStep: $fdc99da597ac0001$var$setIssueBreakdownStep,
    setSuggestedChildIssues: $fdc99da597ac0001$var$setSuggestedChildIssues,
    setPromptValue: $fdc99da597ac0001$var$setPromptValue,
    setIssueTypeIds: $fdc99da597ac0001$var$setIssueTypeIds,
    setHeaderPromptValue: $fdc99da597ac0001$var$setHeaderPromptValue,
    setSelectedIssueIndex: $fdc99da597ac0001$var$setSelectedIssueIndex,
    unselectCurrentIndex: $fdc99da597ac0001$var$unselectCurrentIndex,
    setChannelId: $fdc99da597ac0001$var$setChannelId,
    resetIssueBreakdownState: $fdc99da597ac0001$var$resetIssueBreakdownState,
    removeCurrentSuggestedChildIssue: $fdc99da597ac0001$var$removeCurrentSuggestedChildIssue,
    updateSuggestedResult: $fdc99da597ac0001$var$updateSuggestedResult,
    addSuggestedIssue: $fdc99da597ac0001$var$addSuggestedIssue,
    openDiscardSuggestionsModal: $fdc99da597ac0001$var$openDiscardSuggestionsModal,
    closeDiscardSuggestionsModal: $fdc99da597ac0001$var$closeDiscardSuggestionsModal,
    closeIssueBreakdown: $fdc99da597ac0001$var$closeIssueBreakdown,
    updateStreamingStatus: $fdc99da597ac0001$var$updateStreamingStatus,
    setStreamingError: $fdc99da597ac0001$var$setStreamingError,
    incrementRetryCount: $fdc99da597ac0001$var$incrementRetryCount,
    isIssueBreakdownOpen: $fdc99da597ac0001$var$isIssueBreakdownOpen,
    getSuggestedLength: $fdc99da597ac0001$var$getSuggestedLength
};
const $fdc99da597ac0001$export$ac6c39a0dbf8f3e5 = (0, $heB5U.createContainer)();
const $fdc99da597ac0001$var$Store = (0, $a61MH.createStore)({
    initialState: $fdc99da597ac0001$var$initialState,
    actions: $fdc99da597ac0001$export$e324594224ef24da,
    name: 'issue-breakdown',
    containedBy: $fdc99da597ac0001$export$ac6c39a0dbf8f3e5
});
const $fdc99da597ac0001$export$2d0761b6b6ddada = (0, $ggKAj.createHook)($fdc99da597ac0001$var$Store);

});

parcelRegister("5IHDa", function(module, exports) {

$parcel$export(module.exports, "default", () => $08bc0e256a5f6996$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $08bc0e256a5f6996$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    buttonLabel: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.button-label",
        "defaultMessage": "Suggest {issueType, select, tasks {subtasks} issues {child issues} other {child issues}}"
    },
    buttonDefaultTooltipContent: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.button-default-tooltip-content",
        "defaultMessage": "Ask Atlassian Intelligence to suggest {issueType, select, tasks {subtasks} issues {child issues} other {child issues}} for you."
    },
    buttonModalViewTooltipContent: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.button-modal-view-tooltip-content",
        "defaultMessage": "Ask Atlassian Intelligence to suggest {issueType, select, tasks {subtasks} issues {child issues} other {child issues}} for you. This will open in a full page view."
    },
    placeholderTextNonFinal: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.placeholder-text-non-final",
        "defaultMessage": "Tell us how you want your issues generated, or hit Enter."
    },
    footerTextDraftList: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.footer-text-draft-list",
        "defaultMessage": "Ask AI to refine suggestions."
    },
    footerTextPromptNonFinal: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.footer-text-prompt-non-final",
        "defaultMessage": "Powered by Atlassian Intelligence"
    },
    footerTextIsWorking: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.footer-text-is-working",
        "defaultMessage": "Atlassian Intelligence is working..."
    },
    labelCancel: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.label-cancel",
        "defaultMessage": "Cancel"
    },
    labelStop: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.label-stop",
        "defaultMessage": "Stop"
    },
    labelEscNonFinal: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.label-esc-non-final",
        "defaultMessage": "Esc"
    },
    successFlagTitle: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.success-flag-title",
        "defaultMessage": "Issues successfully created"
    },
    successFlagDescription: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.success-flag-description",
        "defaultMessage": "Your issues have been successfully created"
    },
    errorFlagTitleOnItemNonFinal: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.error-flag-title-on-item-non-final",
        "defaultMessage": "Project or issue ID was not provided."
    },
    errorFlagDescriptionNonFinal: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.error-flag-description-non-final",
        "defaultMessage": "Please try again later."
    },
    statusRetrievingSourceContextNonFinal: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.status-retrieving-source-context-non-final",
        "defaultMessage": "Atlassian Intelligence is reading the parent issue..."
    },
    statusRefiningSuggestedIssuesNonFinal: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.status-refining-suggested-issues-non-final",
        "defaultMessage": "Atlassian Intelligence is refining suggestions..."
    },
    statusSuggestingInitialIssuesNonFinal: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.status-suggesting-initial-issues-non-final",
        "defaultMessage": "Atlassian Intelligence is generating suggestions..."
    },
    statusRemovingDuplicateIssuesNonFinal: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.status-removing-duplicate-issues-non-final",
        "defaultMessage": "Atlassian Intelligence is removing duplicates..."
    },
    statusReformatingIssuesNonFinal: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.status-reformating-issues-non-final",
        "defaultMessage": "Atlassian Intelligence is writing descriptions..."
    }
});

});


parcelRegister("daDVt", function(module, exports) {

$parcel$export(module.exports, "useHideDoneChildIssues", () => $d7d6e6bf6efcdf14$export$25b90030957fcfd3);
$parcel$export(module.exports, "getIsSubtaskCreateEnabled", () => $d7d6e6bf6efcdf14$export$fe88f9a1f24669a4);
$parcel$export(module.exports, "useIsAiEnabled", () => $d7d6e6bf6efcdf14$export$742ce7b41314d513);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $ldoFd = parcelRequire("ldoFd");

var $7ZZxN = parcelRequire("7ZZxN");

var $hJ992 = parcelRequire("hJ992");


var $i9pAn = parcelRequire("i9pAn");

var $guDlK = parcelRequire("guDlK");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");

var $agEEp = parcelRequire("agEEp");
const $d7d6e6bf6efcdf14$export$25b90030957fcfd3 = (allIssues, incompleteIssues)=>{
    const [hideDonePreference] = (0, $i9pAn.useUserPreferencesValue)((0, $e4af19d777b54ab6$export$4c9f7f9f8a4000e1));
    const completedIssuesCount = (0, $eUqFw.useMemo)(()=>allIssues.length - incompleteIssues.length, [
        allIssues.length,
        incompleteIssues.length
    ]);
    const shouldShowHideDoneInfoIcon = (0, $eUqFw.useMemo)(()=>{
        const hasIncompleteIssues = !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(incompleteIssues);
        return completedIssuesCount > 0 && hasIncompleteIssues && hideDonePreference === 'true';
    }, [
        hideDonePreference,
        completedIssuesCount,
        incompleteIssues
    ]);
    return {
        shouldShowHideDoneInfoIcon: shouldShowHideDoneInfoIcon,
        completedIssuesCount: completedIssuesCount
    };
};
const $d7d6e6bf6efcdf14$var$getIsNextgenSubtask = (childIssuesPanelType, issueHierarchyLevel)=>childIssuesPanelType === (0, $agEEp.CHILDREN_ISSUES_PANEL) ? !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(issueHierarchyLevel) && issueHierarchyLevel === 0 : false;
const $d7d6e6bf6efcdf14$export$fe88f9a1f24669a4 = (childIssuesPanelType, issueHierarchyLevel)=>$d7d6e6bf6efcdf14$var$getIsNextgenSubtask(childIssuesPanelType, issueHierarchyLevel) || childIssuesPanelType === (0, $agEEp.CLASSIC_SUBTASKS) || childIssuesPanelType === (0, $agEEp.CLASSIC_PORTFOLIO_CHILDREN);
const $d7d6e6bf6efcdf14$export$742ce7b41314d513 = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    if (!appEditions) return false;
    switch(projectType){
        case 0, $7ZZxN.CORE_PROJECT:
            return appEditions.core === (0, $6WXNs.PREMIUM_EDITION);
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return appEditions.software === (0, $6WXNs.PREMIUM_EDITION);
        default:
            return false;
    }
};

});



parcelRegister("aYDPW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0872eb4e2c68be2$export$2e2bcd8739ae039);

var $eGI9v = parcelRequire("eGI9v");
var $8un0w = parcelRequire("8un0w");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $2HCUG = parcelRequire("2HCUG");

var $iBvRb = parcelRequire("iBvRb");

var $6QyxX = parcelRequire("6QyxX");

var $4D8Ar = parcelRequire("4D8Ar");

var $7xkAf = parcelRequire("7xkAf");

var $9yYZP = parcelRequire("9yYZP");

var $kmVvu = parcelRequire("kmVvu");
var $a0872eb4e2c68be2$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $eGI9v.default)('button', {
    onSubmitClickAnalytics: 'clicked',
    onCancelClickAnalytics: 'clicked',
    onAddExistingClickAnalytics: 'clicked'
}), (0, $eGI9v.default)('keyboardShortcut', {
    onEnterKeyPressedAnalytics: 'pressed',
    onEscapeKeyPressedAnalytics: 'pressed'
}), (0, $eGI9v.default)('childIssuePanelInlineCreate', {
    onSubmit: 'onSubmit',
    onFullDialogCreate: 'onFullDialogCreate'
}), (0, $8un0w.default)({
    onSubmitClickAnalytics: 'createChildIssue',
    onCancelClickAnalytics: 'hideChildIssueInlineCreate',
    onEnterKeyPressedAnalytics: 'confirmChildIssueCreate',
    onEscapeKeyPressedAnalytics: 'cancelChildIssueCreate',
    onAddExistingClickAnalytics: 'addExistingChildClick'
}), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ ChildTypesSelect: ConnectedComponent<ComponentType<WithIntlProps<Pick<{ issueTypes: ChildIssueType[]; isDisabled?: boolean | undefined; } & Intl & { selectedIssueType: ChildIssueType; onChange: (arg1: ChildIssueType) => void; defaultMenuIsOpen?: boolean | undefined; }, "intl" | ...' is not assignable to parameter of type 'FlowStep<WithUIAnalyticsEvent<PropsWithoutRef<Omit<{ [K in keyof PropsWithRef<Omit<{ [K in keyof PropsWithRef<Omit<{ [K in keyof Props]: K extends "onSubmitClickAnalytics" | "onCancelClickAnalytics" | "onAddExistingClickAnalytics" ? (...args: [...Parameters<Props[K]>, UIAnalyticsEvent]) => ReturnType<...> : Props[K]...'.
(0, $lqalZ.connect)((state)=>({
        ChildTypesSelect: $9yYZP.default,
        baseUrl: (0, $2HCUG.getBaseUrl)(state),
        issues: (0, $6QyxX.getAllIssues)(state),
        addClickCount: (0, $7xkAf.getAddClickCount)(state),
        issueTypes: (0, $6QyxX.getIssueTypes)(state),
        selectedIssueType: (0, $7xkAf.getSelectedIssueType)(state),
        projectId: (0, $2HCUG.getProjectId)(state),
        parentIssueId: (0, $2HCUG.getParentId)(state),
        parentIssueKey: (0, $2HCUG.getParentKey)(state),
        epicLinkFieldKey: (0, $2HCUG.getEpicLinkFieldKey)(state),
        childIssuesPanelType: (0, $2HCUG.getChildIssuesPanelType)(state),
        requiresFullCreate: (0, $2HCUG.getRequiresFullCreateByIssueType)(state),
        summary: (0, $7xkAf.getChildCreateSummary)(state),
        issueHierarchyLevel: (0, $6QyxX.getIssueHierarchyLevel)(state)
    }), {
    onCancel: (0, $4D8Ar.hideAddChildIssue),
    onAddExistingIssue: ()=>(0, $4D8Ar.setChildPanelView)((0, $4D8Ar.CHILD_PANEL_VIEWS).AddExistingIssue),
    onChangeSummary: (summary)=>(0, $4D8Ar.setChildCreateSummary)(summary),
    onSubmit: (optimisticUiChildIssue, analyticsEvent)=>(0, $iBvRb.createChildRequest)(optimisticUiChildIssue, analyticsEvent),
    onFullDialogCreate: (optimisticId, childIssue, analyticsEvent)=>(0, $iBvRb.childCreatedInFullDialog)(optimisticId, childIssue, analyticsEvent)
}))((0, $kmVvu.default));

});
parcelRegister("9yYZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa5a13a1d5973723$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $6QyxX = parcelRequire("6QyxX");

var $4D8Ar = parcelRequire("4D8Ar");

var $7xkAf = parcelRequire("7xkAf");

var $fwdea = parcelRequire("fwdea");
var $fa5a13a1d5973723$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $giAhk.injectIntlV2), // @ts-expect-error([Part of upgrade 4.9-5.4]) - Type instantiation is excessively deep and possibly infinite.
(0, $lqalZ.connect)((state)=>({
        selectedIssueType: (0, $7xkAf.getSelectedIssueType)(state),
        issueTypes: (0, $6QyxX.getIssueTypes)(state)
    }), {
    onChange: (0, $4D8Ar.selectedIssueTypeChanged)
}))((0, $fwdea.default));

});
parcelRegister("fwdea", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb7ea47260ad42e2$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4zgIJ = parcelRequire("4zgIJ");

var $hnzPP = parcelRequire("hnzPP");

var $1ybV0 = parcelRequire("1ybV0");

var $gLLZt = parcelRequire("gLLZt");
var $7nzO5 = parcelRequire("7nzO5");

var $52Iro = parcelRequire("52Iro");

var $g4hxa = parcelRequire("g4hxa");
const $eb7ea47260ad42e2$var$selectStyles = {
    singleValue: (baseStyles)=>({
            ...baseStyles,
            // item is already vertically aligned because of `align-items: center` in parent. With `position: absolute` select does not have width == content width
            position: 'static',
            transform: 'none'
        })
};
const $eb7ea47260ad42e2$var$getOptionLabel = (option)=>option.name;
const $eb7ea47260ad42e2$var$getOptionValue = (option)=>option.id;
const $eb7ea47260ad42e2$var$formatOptionLabel = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb7ea47260ad42e2$var$OptionLabelAndIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
        url: option.iconUrl,
        title: option.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb7ea47260ad42e2$var$OptionLabelContainer, null, option.name));
class $eb7ea47260ad42e2$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            issueTypes: []
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage }, issueTypes: issueTypes, selectedIssueType: selectedIssueType, isDisabled: isDisabled = false, defaultMenuIsOpen: defaultMenuIsOpen } = this.props;
        return(// @ts-expect-error  Type '{ styles: AkSelectStyles; options: ChildIssueType[]; value: ChildIssueType; getOptionLabel: (option: Option) => string; getOptionValue: (option: Option) => string; ... 5 more ...; filterOption: (option: OptionToFilter, inputValue: string) => boolean; }' is not assignable to type 'IntrinsicAttributes & (IntrinsicClassAttributes<{ components: Partial<SelectComponents<ChildIssueType, false, GroupBase<ChildIssueType>>>; ... 23 more ...; UNSAFE_componentWillUpdate?(nextProps: Readonly<...>, nextState: Readonly<...>, nextContext: any): void; }> & (Readonly<...> & Readonly<...>))
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), {
            ...(0, $gLLZt.defaultSelectProps),
            ...(0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e') ? {
                isDisabled: isDisabled
            } : {},
            styles: (0, $52Iro.mergeReactSelectStyles)((0, $7nzO5.defaultSelectStyles), $eb7ea47260ad42e2$var$selectStyles),
            options: issueTypes,
            value: selectedIssueType,
            getOptionLabel: $eb7ea47260ad42e2$var$getOptionLabel,
            getOptionValue: $eb7ea47260ad42e2$var$getOptionValue,
            formatOptionLabel: $eb7ea47260ad42e2$var$formatOptionLabel,
            onChange: this.onChange,
            placeholder: formatMessage((0, $g4hxa.default).typesPlaceholder),
            defaultMenuIsOpen: defaultMenuIsOpen,
            "aria-label": formatMessage((0, $g4hxa.default).issueTypeSelectorLabel)
        }));
    }
    constructor(...args){
        super(...args);
        this.onChange = (selectedOption, actionMeta)=>{
            if (actionMeta.action === 'select-option' && selectedOption != null) this.props.onChange(selectedOption);
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eb7ea47260ad42e2$var$OptionLabelAndIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $eb7ea47260ad42e2$var$OptionLabelContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bvu2gc _1e0c1o8l _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("g4hxa", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d5d4480762a7f23$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $0d5d4480762a7f23$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    typesPlaceholder: {
        "id": "issue.views.common.child-issues-panel.inline-create.child-types-select.types-placeholder",
        "defaultMessage": "Issue type"
    },
    issueTypeSelectorLabel: {
        "id": "issue.views.common.child-issues-panel.inline-create.child-types-select.issue-type-selector-label",
        "defaultMessage": "Select issue type"
    }
});

});



parcelRegister("kmVvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $22a8f8ead271403c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8blac = parcelRequire("8blac");

var $ldoFd = parcelRequire("ldoFd");

var $27QuD = parcelRequire("27QuD");

var $7u4fN = parcelRequire("7u4fN");

var $5YsMl = parcelRequire("5YsMl");

var $29yDk = parcelRequire("29yDk");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $cf2Y4 = parcelRequire("cf2Y4");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $hFmdR = parcelRequire("hFmdR");

var $f8Yej = parcelRequire("f8Yej");

var $2ijRB = parcelRequire("2ijRB");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $4Xcha = parcelRequire("4Xcha");

var $autRb = parcelRequire("autRb");

var $grmb7 = parcelRequire("grmb7");

var $ctR9z = parcelRequire("ctR9z");


var $hzcvF = parcelRequire("hzcvF");

var $kS8l2 = parcelRequire("kS8l2");

var $7LoO9 = parcelRequire("7LoO9");

var $gYYP4 = parcelRequire("gYYP4");

var $6PrhQ = parcelRequire("6PrhQ");

var $5CqW1 = parcelRequire("5CqW1");

var $agEEp = parcelRequire("agEEp");

var $ab9U1 = parcelRequire("ab9U1");

var $72QB4 = parcelRequire("72QB4");
const $22a8f8ead271403c$var$MAX_SUMMARY_LENGTH = 255;
const $22a8f8ead271403c$var$isSummaryTooLong = (summary)=>{
    const trimmedSummary = (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(summary);
    return trimmedSummary.length > $22a8f8ead271403c$var$MAX_SUMMARY_LENGTH;
};
const $22a8f8ead271403c$var$isCreatingChildIssueAllowed = (selectedIssueType)=>{
    // Currently, in an Epic only project selectedIssueType is coming as undefined
    if (!selectedIssueType) return false;
    return true;
};
const $22a8f8ead271403c$var$isPrimaryButtonDisabled = (summary, selectedIssueType)=>{
    if (!$22a8f8ead271403c$var$isCreatingChildIssueAllowed(selectedIssueType)) return true;
    const trimmedSummary = (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(summary);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(trimmedSummary) || $22a8f8ead271403c$var$isSummaryTooLong(summary);
};
const $22a8f8ead271403c$var$isTextFieldInvalid = (summary, selectedIssueType)=>{
    if (!$22a8f8ead271403c$var$isCreatingChildIssueAllowed(selectedIssueType)) return true;
    return $22a8f8ead271403c$var$isSummaryTooLong(summary);
};
const $22a8f8ead271403c$var$testId = 'issue.views.common.child-issues-panel.inline-create.add-child-trigger-button';
const $22a8f8ead271403c$export$bff74f82b631e3d3 = ({ addClickCount: addClickCount = 0, requiresFullCreate: requiresFullCreate = false, parentIssueKey: parentIssueKey, epicLinkFieldKey: epicLinkFieldKey = null, issueTypes: issueTypes, ChildTypesSelect: ChildTypesSelect, childIssuesPanelType: childIssuesPanelType, baseUrl: baseUrl, projectId: projectId, parentIssueId: parentIssueId, selectedIssueType: selectedIssueType, summary: summary, inputId: inputId, openIssueCreateModal: openIssueCreateModal, onSubmit: onSubmit, onCancel: onCancel, onFullDialogCreate: onFullDialogCreate, onChangeSummary: onChangeSummary, onAddExistingIssue: onAddExistingIssue, onSubmitClickAnalytics: onSubmitClickAnalytics, onCancelClickAnalytics: onCancelClickAnalytics, onEnterKeyPressedAnalytics: onEnterKeyPressedAnalytics, onEscapeKeyPressedAnalytics: onEscapeKeyPressedAnalytics, onAddExistingClickAnalytics: onAddExistingClickAnalytics, issueHierarchyLevel: issueHierarchyLevel })=>{
    const childContainer = (0, $eUqFw.useRef)(null);
    const createSubtaskButtonRef = (0, $kS8l2.useGlobalRef)('quick-add-items.create-subtask')[0];
    const fieldContainer = (0, $gYYP4.default)('child-issue-inline-create-type-tracing');
    const createIssueFormFactory = (0, $eUqFw.useRef)(null);
    const { showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull } = (0, $7LoO9.useStorageEnforcement)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const reset = (0, $eUqFw.useCallback)(()=>{
        onChangeSummary('');
    }, [
        onChangeSummary
    ]);
    const closeAndReset = (0, $eUqFw.useCallback)(()=>{
        reset();
        onCancel();
    }, [
        onCancel,
        reset
    ]);
    const resetAndFocus = (0, $eUqFw.useCallback)(()=>{
        reset();
        fieldContainer.current?.focus();
    }, [
        reset,
        fieldContainer
    ]);
    const isNextgenSubtask = (0, $eUqFw.useCallback)(()=>childIssuesPanelType === (0, $agEEp.CHILDREN_ISSUES_PANEL) ? !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(issueHierarchyLevel) && issueHierarchyLevel === 0 : false, [
        childIssuesPanelType,
        issueHierarchyLevel
    ]);
    const subtaskCreateEnabled = (0, $eUqFw.useCallback)(()=>isNextgenSubtask() || childIssuesPanelType === (0, $agEEp.CLASSIC_SUBTASKS) || childIssuesPanelType === (0, $agEEp.CLASSIC_PORTFOLIO_CHILDREN), [
        isNextgenSubtask,
        childIssuesPanelType
    ]);
    const createChild = (0, $eUqFw.useCallback)(()=>{
        const optimisticId = `OPTIMISTIC_CHILD_${Date.now()}`; // If full create is required, we check if modern GIC is enabled and window.IssueCreate is defined
        // If full create is not required, we don't need to check for GIC or windows.issueCreate and the child issue will simply be submitted
        const isWRMRemovalConditionMet = (0, $6PrhQ.isModernGICEnabledForSubtask)() && window.IssueCreate && window.IssueCreate.Visibility.isEnabled || !selectedIssueType?.hasRequiredField && !requiresFullCreate;
        const isWRMRemoved = isWRMRemovalConditionMet ? true : typeof createIssueFormFactory.current === 'function';
        const canCreateChild = !$22a8f8ead271403c$var$isPrimaryButtonDisabled(summary, selectedIssueType) && isWRMRemoved;
        if (canCreateChild && selectedIssueType) {
            const optimisticChild = {
                id: optimisticId,
                issueSummary: summary,
                issueTypeId: `${selectedIssueType.id}`,
                issueTypeIconUrl: `${selectedIssueType.iconUrl}`,
                issueTypeName: `${selectedIssueType.name}`,
                assigneeUrl: null,
                assigneeDisplayName: null
            };
            if (selectedIssueType.hasRequiredField || requiresFullCreate) {
                const creatingIssueInClassicProjectEpic = childIssuesPanelType === (0, $agEEp.CLASSIC_PROJECT_EPIC_CHILDREN);
                const payload = {
                    pid: projectId,
                    issueType: selectedIssueType && selectedIssueType.id,
                    fields: {
                        issuetype: selectedIssueType.id,
                        summary: summary || '',
                        ...creatingIssueInClassicProjectEpic && epicLinkFieldKey ? {
                            [epicLinkFieldKey]: parentIssueKey
                        } : {}
                    },
                    customFieldsToPreserveOnFormRecreation: [
                        ...creatingIssueInClassicProjectEpic && epicLinkFieldKey ? [
                            epicLinkFieldKey
                        ] : []
                    ],
                    ...childIssuesPanelType === (0, $agEEp.CLASSIC_SUBTASKS) || isNextgenSubtask() ? {
                        parentIssueId: parentIssueId
                    } : {}
                };
                if ((0, $6PrhQ.isModernGICEnabledForSubtask)() && window.IssueCreate && window.IssueCreate.Visibility.isEnabled) {
                    const { pid: pid, issueType: issueType, fields: payloadFields } = payload;
                    const epicField = creatingIssueInClassicProjectEpic && epicLinkFieldKey && parentIssueKey ? {
                        epic: {
                            fieldId: epicLinkFieldKey,
                            fieldValue: parentIssueKey
                        }
                    } : null; // @ts-expect-error - TS2345 - Argument of type '{ prefilledFields: { epic?: { fieldId: string; fieldValue: string; } | undefined; pid: string; parentId: string; issuetype: string; summary: string; }; }' is not assignable to parameter of type 'OldGICPayload'.
                    const newPayload = (0, $grmb7.transformGICPayload)({
                        prefilledFields: {
                            pid: pid,
                            parentId: parentIssueId,
                            issuetype: issueType,
                            summary: payloadFields.summary,
                            ...epicField
                        }
                    });
                    const triggerSource = creatingIssueInClassicProjectEpic ? (0, $33ffe55cb7bcdadc$export$7e9cfd1f59e60910) : (0, $33ffe55cb7bcdadc$export$708499dcd016e5e9);
                    openIssueCreateModal?.({
                        payload: newPayload,
                        fieldsToAddInPublishedData: [
                            epicLinkFieldKey
                        ],
                        isSubTaskCreationOpen: subtaskCreateEnabled(),
                        triggerPointKey: triggerSource,
                        callbackPayload: {
                            id: (0, $4Xcha.GIC_CALLBACK_PAYLOAD_INLINE_CREATE_ID),
                            data: {
                                optimisticId: optimisticId,
                                parentIssueKey: parentIssueKey,
                                childIssuesPanelType: childIssuesPanelType
                            }
                        }
                    });
                } else {
                    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                    const createIssueForm = createIssueFormFactory.current?.(payload); // This overrides the monolith frontend's JQuery event watcher that sends GASv3 events.
                    // So we manually send the Create Issue SLA event in the create-child-success epic.
                    createIssueForm?.bind('issueCreated', (e, data)=>{
                        if (!creatingIssueInClassicProjectEpic || // @ts-expect-error - TS2538 - Type 'null' cannot be used as an index type.
                        data.createdIssueDetails.fields[epicLinkFieldKey] === parentIssueKey) onFullDialogCreate(optimisticId, (0, $5CqW1.default)(data.createdIssueDetails, baseUrl));
                        resetAndFocus();
                    });
                    createIssueForm?.asDialog({
                        id: childIssuesPanelType === (0, $agEEp.CLASSIC_SUBTASKS) ? 'create-subtask-dialog' : 'create-issue-dialog'
                    }).show();
                }
            } else {
                onSubmit(optimisticChild);
                resetAndFocus();
                showEnforcementIfStorageIsFull({
                    touchpoint: 'child-issues-panel'
                });
            }
        }
    }, [
        baseUrl,
        childIssuesPanelType,
        epicLinkFieldKey,
        onFullDialogCreate,
        onSubmit,
        openIssueCreateModal,
        parentIssueId,
        parentIssueKey,
        projectId,
        requiresFullCreate,
        resetAndFocus,
        selectedIssueType,
        summary,
        isNextgenSubtask,
        subtaskCreateEnabled,
        showEnforcementIfStorageIsFull
    ]);
    const onSubmitClicked = (0, $eUqFw.useCallback)(()=>{
        createChild();
        onSubmitClickAnalytics();
    }, [
        createChild,
        onSubmitClickAnalytics
    ]);
    const onCancelClicked = (0, $eUqFw.useCallback)(()=>{
        closeAndReset();
        onCancelClickAnalytics();
    }, [
        closeAndReset,
        onCancelClickAnalytics
    ]);
    const onCancelKeyPress = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') createSubtaskButtonRef?.focus();
    }, [
        createSubtaskButtonRef
    ]);
    const onEnterPressed = (0, $eUqFw.useCallback)(()=>{
        createChild();
        onEnterKeyPressedAnalytics();
    }, [
        createChild,
        onEnterKeyPressedAnalytics
    ]);
    const onEscPressed = (0, $eUqFw.useCallback)(()=>{
        closeAndReset();
        onEscapeKeyPressedAnalytics();
    }, [
        closeAndReset,
        onEscapeKeyPressedAnalytics
    ]);
    const onUpdateChildSummary = (0, $eUqFw.useCallback)((e)=>{
        onChangeSummary(e.target.value);
    }, [
        onChangeSummary
    ]);
    const onAddExisting = (0, $eUqFw.useCallback)(()=>{
        onAddExistingIssue();
        onAddExistingClickAnalytics();
    }, [
        onAddExistingClickAnalytics,
        onAddExistingIssue
    ]);
    const [childIssuesPanelTypeInState] = (0, $eUqFw.useState)(()=>childIssuesPanelType);
    const previousAddClickCount = (0, $hzcvF.usePrevious)(addClickCount);
    (0, $eUqFw.useEffect)(()=>{
        (0, $autRb.smoothScrollIntoCenterIfNeeded)(childContainer.current);
        fieldContainer.current?.focus({
            preventScroll: true
        });
    }, [
        childIssuesPanelTypeInState,
        fieldContainer
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (previousAddClickCount !== undefined && addClickCount !== previousAddClickCount) {
            (0, $autRb.smoothScrollIntoCenterIfNeeded)(childContainer.current);
            fieldContainer.current?.focus({
                preventScroll: true
            });
        }
    }, [
        addClickCount,
        previousAddClickCount,
        fieldContainer
    ]);
    const summaryTooLongMessage = $22a8f8ead271403c$var$isSummaryTooLong(summary) ? formatMessage((0, $72QB4.default).summaryTooLong) : '';
    const cannotCreateChildIssueMessage = formatMessage((0, $72QB4.default).cannotCreateChildIssue);
    const getInlineDialogContent = ()=>{
        if (!$22a8f8ead271403c$var$isCreatingChildIssueAllowed(selectedIssueType)) return cannotCreateChildIssueMessage;
        return summaryTooLongMessage;
    };
    const addExistingIssueButton = (0, $eUqFw.useMemo)(()=>{
        switch(childIssuesPanelType){
            case 0, $agEEp.CHILDREN_ISSUES_PANEL:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                    content: formatMessage((0, $72QB4.default).addExistingIssuePlaceholder)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ab9U1.AddExistingIssueButton), {
                    onClick: onAddExisting
                }, formatMessage((0, $72QB4.default).addExistingIssuePlaceholder)));
            case 0, $agEEp.CLASSIC_PORTFOLIO_CHILDREN:
            case 0, $agEEp.CLASSIC_PROJECT_EPIC_CHILDREN:
            case 0, $agEEp.CLASSIC_SUBTASKS:
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null);
        }
    }, [
        childIssuesPanelType,
        formatMessage,
        onAddExisting
    ]);
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    (0, $eUqFw.useEffect)(()=>subscribe?.((0, $dNWQB.GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, async (payload)=>{
            if (payload.callbackPayload?.id !== (0, $4Xcha.GIC_CALLBACK_PAYLOAD_INLINE_CREATE_ID)) return;
            const callbackData = payload.callbackPayload?.data;
            const isEpicEqualToParent = (epicLinkFieldKey && payload.createdIssueData.createdIssueDetails.fields[epicLinkFieldKey]) === parentIssueKey;
            if (callbackData.parentIssueKey !== parentIssueKey || callbackData.childIssuesPanelType !== childIssuesPanelType) return;
            if (subtaskCreateEnabled() || isEpicEqualToParent) resetAndFocus();
        }), [
        subscribe,
        resetAndFocus,
        subtaskCreateEnabled,
        epicLinkFieldKey,
        parentIssueKey,
        childIssuesPanelType
    ]);
    const childTypeSelect = (0, $eUqFw.useMemo)(()=>{
        if ((0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChildTypesSelect, {
            isDisabled: issueTypes.length <= 1
        });
        return issueTypes.length > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChildTypesSelect, null) : null;
    }, [
        ChildTypesSelect,
        issueTypes.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: childContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22a8f8ead271403c$var$WrapperDiv, null, childTypeSelect, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22a8f8ead271403c$var$FieldTextWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
        onEnter: onEnterPressed,
        onEscape: onEscPressed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
        content: getInlineDialogContent(),
        isOpen: $22a8f8ead271403c$var$isTextFieldInvalid(summary, selectedIssueType),
        placement: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        id: inputId,
        value: summary,
        placeholder: formatMessage((0, $72QB4.default).summaryPlaceholder),
        onChange: onUpdateChildSummary,
        isInvalid: $22a8f8ead271403c$var$isTextFieldInvalid(summary, selectedIssueType),
        shouldFitContainer: true,
        "aria-label": formatMessage((0, $72QB4.default).summaryTextFieldLabel),
        ref: fieldContainer,
        elemAfterInput: $22a8f8ead271403c$var$isTextFieldInvalid(summary, selectedIssueType) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $22a8f8ead271403c$var$warningWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            size: "medium",
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y300)})`,
            label: "",
            testId: "issue-view-common-views.child-issues-panel.inline-create.invalid-textfield-warning-icon"
        })) : null,
        isDisabled: !$22a8f8ead271403c$var$isCreatingChildIssueAllowed(selectedIssueType)
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22a8f8ead271403c$var$ButtonsContainer, null, addExistingIssueButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22a8f8ead271403c$var$ButtonsRightSide, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22a8f8ead271403c$var$StyledButton, {
        appearance: "primary",
        onClick: onSubmitClicked,
        isDisabled: $22a8f8ead271403c$var$isPrimaryButtonDisabled(summary, selectedIssueType),
        "data-testId": $22a8f8ead271403c$var$testId
    }, formatMessage((0, $72QB4.default).childCreateButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22a8f8ead271403c$var$StyledButton, {
        appearance: "subtle",
        onClick: onCancelClicked,
        onKeyPress: onCancelKeyPress,
        testId: "issue.views.common.child-issues-panel.inline-create.styled-button"
    }, formatMessage((0, $72QB4.default).childCancelButton)))));
};
var $22a8f8ead271403c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $2ijRB.default)((0, $6PrhQ.isModernGICEnabledForSubtask), // @ts-expect-error - TS2345 - Argument of type 'ComponentType<Record<any, any>>' is not assignable to parameter of type 'AbstractComponent<Props, any>'. | TS2345 - Argument of type '(props: Props & DefaultProps) => ReactElement<any, string | JSXElementConstructor<any>>' is not assignable to parameter of type 'ComponentType<Record<any, any>>'.
(0, $hFmdR.AnalyticsSubject)('issue')((0, $ctR9z.withNewGICProvider)($22a8f8ead271403c$export$bff74f82b631e3d3)), (0, $hFmdR.AnalyticsSubject)('issue')($22a8f8ead271403c$export$bff74f82b631e3d3));
const $22a8f8ead271403c$var$WrapperDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _bfhk1gi7 _1bsb1osq _zulpv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $22a8f8ead271403c$var$FieldTextWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $22a8f8ead271403c$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01a66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $22a8f8ead271403c$var$ButtonsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $22a8f8ead271403c$var$ButtonsRightSide = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bahesu3 _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $22a8f8ead271403c$var$warningWrapperStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.negative.050',
    marginRight: 'space.050'
});

});
parcelRegister("27QuD", function(module, exports) {

var $TLr3n = parcelRequire("TLr3n");

var $2cjNq = parcelRequire("2cjNq");

var $8SGvQ = parcelRequire("8SGvQ");

var $1qE1i = parcelRequire("1qE1i");

var $3Muqa = parcelRequire("3Muqa");

var $aSldm = parcelRequire("aSldm");

var $1uqnh = parcelRequire("1uqnh");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $18c4f43cd593e3cf$var$trim(string, chars, guard) {
    string = $1uqnh(string);
    if (string && (guard || chars === undefined)) return $2cjNq(string);
    if (!string || !(chars = $TLr3n(chars))) return string;
    var strSymbols = $aSldm(string), chrSymbols = $aSldm(chars), start = $3Muqa(strSymbols, chrSymbols), end = $1qE1i(strSymbols, chrSymbols) + 1;
    return $8SGvQ(strSymbols, start, end).join('');
}
module.exports = $18c4f43cd593e3cf$var$trim;

});
parcelRegister("1qE1i", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $10a7434ada2e55c3$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && $jkhuN(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $10a7434ada2e55c3$var$charsEndIndex;

});

parcelRegister("3Muqa", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $2c0d73c17288fd42$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && $jkhuN(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $2c0d73c17288fd42$var$charsStartIndex;

});


parcelRegister("dNWQB", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $21eb2e23e0bf69c0$export$876003a5b887f37e);
const $21eb2e23e0bf69c0$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("2gOs4", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $c9d12900db50c35b$export$e3ff72f196296fcc);

var $jcERi = parcelRequire("jcERi");
const $c9d12900db50c35b$var$GICLifeCycleEventsService = new (0, $jcERi.PubSubHub)();
const $c9d12900db50c35b$export$e3ff72f196296fcc = ()=>({
        ...$c9d12900db50c35b$var$GICLifeCycleEventsService
    });

});
parcelRegister("jcERi", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $a1db2e8ca1046c74$export$e3607828f8f2c01e);
class $a1db2e8ca1046c74$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("grmb7", function(module, exports) {

$parcel$export(module.exports, "generateDefaultValues", () => $ac2928cb7824ba77$export$300f392f5922240);
$parcel$export(module.exports, "extractEventAttributes", () => $ac2928cb7824ba77$export$1e69307ca1d0a0a);
$parcel$export(module.exports, "transformGICPayload", () => $ac2928cb7824ba77$export$db3a4d24608ba186);

var $8blac = parcelRequire("8blac");

var $k4nIh = parcelRequire("k4nIh");

var $1ybV0 = parcelRequire("1ybV0");

var $cOaQi = parcelRequire("cOaQi");
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const $ac2928cb7824ba77$var$mergePrefilled = (oldPayload, newPayload)=>{
    if (newPayload !== null && newPayload !== undefined) // @ts-expect-error - TS2698 - Spread types may only be created from object types. | TS2698 - Spread types may only be created from object types.
    return {
        ...oldPayload,
        ...newPayload
    };
    return oldPayload;
};
const $ac2928cb7824ba77$var$returnActualValue = (value)=>Array.isArray(value) ? value[0] : value;
// @ts-expect-error - TS7023 - 'mergeFormat' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions. | TS7006 - Parameter 'format' implicitly has an 'any' type.
const $ac2928cb7824ba77$var$mergeFormat = (format, finalKey, finalValue)=>{
    // Ideally format can be object or string
    // Format will only contain 1 object having single key/value where value can be null or an object
    // go inside and wherever we find first null, replace the same with the value.
    // some of the mutation use fieldId whereas other uses like priorityId
    // so whichever key has value === ID will replace the same with the proper mutationKey
    if (typeof format === 'string') {
        if (format === 'ID') return finalKey;
        return format;
    }
    // recursively goes inside to find the null and key param and replace with the corresponding values
    // Also checks for array like labels
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(format).reduce((accumulator, currentKey)=>{
        const currentValue = format[currentKey];
        if (Array.isArray(currentValue)) {
            const mappedValue = Array.isArray(finalValue) ? finalValue : [
                finalValue
            ];
            return {
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...accumulator,
                [currentKey]: mappedValue.map((val)=>$ac2928cb7824ba77$var$mergeFormat(currentValue[0], finalKey, val))
            };
        }
        return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...accumulator,
            [currentKey]: currentValue === null ? $ac2928cb7824ba77$var$returnActualValue(finalValue) : $ac2928cb7824ba77$var$mergeFormat(format[currentKey], finalKey, finalValue)
        };
    }, {});
};
const $ac2928cb7824ba77$export$300f392f5922240 = (otherFields)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const defaultValues = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldIds = [];
    Object.keys(otherFields).forEach((mutationKey)=>{
        const mutationValue = otherFields[mutationKey];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
        if ((0, $cOaQi.FIELD_MAPPER_MUTATION_GROUP)[mutationKey]) {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
            const mutationGroup = (0, $cOaQi.FIELD_MAPPER_MUTATION_GROUP)[mutationKey];
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly singleLineTextFields: { readonly value: { readonly fieldId: "ID"; readonly text: null; }; readonly type: "array"; }; readonly epicLinkField: { readonly value: { readonly fieldId: "ID"; readonly epicLink: { readonly issueKey: null; }; }; readonly type: "object"; }; ... 7 more ...; readonly components: { .....'.
            const { type: type = null, value: depth = null } = (0, $cOaQi.FORMATTER)[mutationGroup];
            let pattern = null;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(mutationValue) && depth && type) {
                if (!Array.isArray(mutationValue) && typeof mutationValue === 'object') {
                    const { fieldId: fieldId, fieldValue: fieldValue } = mutationValue;
                    // If fieldValue is different from the key like custom fields
                    pattern = $ac2928cb7824ba77$var$mergeFormat(depth, fieldId || mutationKey, fieldValue);
                    fieldIds.push(fieldId || mutationKey);
                } else {
                    // same as key like summary etc.
                    pattern = $ac2928cb7824ba77$var$mergeFormat(depth, mutationKey, mutationValue);
                    fieldIds.push(mutationKey);
                }
            }
            // merge mutations based on type as some mutations are object whereas others are arrays
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(pattern)) {
                if (type === 'array') (defaultValues[mutationGroup] = defaultValues[mutationGroup] || []).push(pattern);
                else if (type === 'object') defaultValues[mutationGroup] = pattern;
            }
        }
    });
    return {
        defaultValues: defaultValues,
        fieldIds: fieldIds
    };
};
const $ac2928cb7824ba77$export$1e69307ca1d0a0a = (trigger)=>{
    const anchor = trigger.nodeName === 'A' ? trigger : trigger.querySelector('a');
    if (anchor) {
        const href = anchor.getAttribute('href');
        // @ts-expect-error - TS2769 - No overload matches this call. | TS7006 - Parameter 'qs' implicitly has an 'any' type.
        const { query: query } = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(href, (qs)=>new URLSearchParams(qs));
        const returnData = {
            prefilledFields: {}
        };
        // If data attributes exist, we will prefer those over the query params.
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const pid = anchor.getAttribute('data-pid') || query.get('pid');
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const issuetype = anchor.getAttribute('data-issue-type') || query.get('issuetype');
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const requestype = anchor.getAttribute('data-itsm-category') || query.get('itsmCategory');
        if (pid) // @ts-expect-error - TS2339 - Property 'pid' does not exist on type '{}'.
        returnData.prefilledFields.pid = pid;
        if (issuetype) // @ts-expect-error - TS2339 - Property 'issuetype' does not exist on type '{}'.
        returnData.prefilledFields.issuetype = issuetype;
        if (requestype) // @ts-expect-error - TS2339 - Property 'requestype' does not exist on type '{}'.
        returnData.prefilledFields.requestype = requestype;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(returnData.prefilledFields)) // @ts-expect-error - TS2322 - Type '{ prefilledFields: {}; }' is not assignable to type 'OldGICPayload'.
        return returnData;
        return {};
    }
    return {};
};
const $ac2928cb7824ba77$export$70cb7a42e309786 = (payload = {})=>{
    const { prefilledFields: gicPreFilledFields, target: target = null } = payload;
    let prefilledFields = gicPreFilledFields;
    if (target) {
        const newPayload = $ac2928cb7824ba77$export$1e69307ca1d0a0a(target);
        prefilledFields = $ac2928cb7824ba77$var$mergePrefilled(gicPreFilledFields, newPayload.prefilledFields);
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(prefilledFields)) {
        const { fieldsToRetain: fieldsToRetain = [], pid: pid, issuetype: issuetype, requestype: requestype, additionalContext: additionalContext, statusId: statusId, ...otherFields } = prefilledFields;
        const outputPayload = {};
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(pid) && pid !== 'undefined') outputPayload.project = {
            projectId: $ac2928cb7824ba77$var$returnActualValue(pid)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(issuetype)) outputPayload.issueType = {
            issueTypeId: $ac2928cb7824ba77$var$returnActualValue(issuetype)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(requestype)) outputPayload.requestType = {
            key: $ac2928cb7824ba77$var$returnActualValue(requestype)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(otherFields.parentId)) outputPayload.parentId = {
            parentId: $ac2928cb7824ba77$var$returnActualValue(otherFields.parentId)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(statusId)) outputPayload.status = {
            statusId: statusId
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(additionalContext)) outputPayload.additionalContext = additionalContext;
        // for other fields
        if (Object.keys(otherFields).length > 0) {
            const { parentId: parentId, ...otherFieldsWithoutParent } = otherFields;
            const { defaultValues: defaultValues, fieldIds: fieldIds } = $ac2928cb7824ba77$export$300f392f5922240((0, $1ybV0.ff)('parent-field-in-gic_d3b3n') && parentId !== undefined && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(parentId) ? {
                parent: parentId,
                ...otherFieldsWithoutParent
            } : otherFieldsWithoutParent);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(defaultValues)) outputPayload.defaultValues = defaultValues;
            outputPayload.customFieldsToPreserveOnFormRecreation = [
                ...fieldsToRetain,
                ...fieldIds
            ];
        }
        return outputPayload;
    }
    return null;
};
const $ac2928cb7824ba77$export$db3a4d24608ba186 = $ac2928cb7824ba77$export$70cb7a42e309786;

});
parcelRegister("cOaQi", function(module, exports) {

$parcel$export(module.exports, "FORMATTER", () => $5043ffa756a0131b$export$92cfe806f4f0ae2f);
$parcel$export(module.exports, "FIELD_MAPPER_MUTATION_GROUP", () => $5043ffa756a0131b$export$6669905e89f27d17);
const $5043ffa756a0131b$export$92cfe806f4f0ae2f = {
    singleLineTextFields: {
        value: {
            fieldId: 'ID',
            text: null
        },
        type: 'array'
    },
    epicLinkField: {
        value: {
            fieldId: 'ID',
            epicLink: {
                issueKey: null
            }
        },
        type: 'object'
    },
    sprintsField: {
        value: {
            fieldId: 'ID',
            sprints: [
                {
                    sprintId: null
                }
            ]
        },
        type: 'object'
    },
    priority: {
        value: {
            priorityId: 'ID'
        },
        type: 'object'
    },
    datePickerFields: {
        value: {
            fieldId: 'ID',
            date: {
                formattedDate: null
            }
        },
        type: 'array'
    },
    dateTimePickerFields: {
        value: {
            fieldId: 'ID',
            dateTime: {
                formattedDateTime: null
            }
        },
        type: 'array'
    },
    labelsFields: {
        value: {
            fieldId: 'ID',
            labels: [
                {
                    name: null
                }
            ]
        },
        type: 'array'
    },
    singleSelectUserPickerFields: {
        value: {
            fieldId: 'ID',
            user: {
                accountId: null
            }
        },
        type: 'array'
    },
    multipleVersionPickerFields: {
        value: {
            fieldId: 'ID',
            versions: [
                {
                    versionId: null
                }
            ]
        },
        type: 'array'
    },
    components: {
        value: {
            componentId: null
        },
        type: 'array'
    },
    parentField: {
        value: {
            issueId: null
        },
        type: 'object'
    }
};
const $5043ffa756a0131b$export$6669905e89f27d17 = {
    summary: 'singleLineTextFields',
    epic: 'epicLinkField',
    epicName: 'singleLineTextFields',
    duedate: 'datePickerFields',
    startdate: 'datePickerFields',
    plannedStartDate: 'dateTimePickerFields',
    plannedEndDate: 'dateTimePickerFields',
    labels: 'labelsFields',
    sprint: 'sprintsField',
    assignee: 'singleSelectUserPickerFields',
    reporter: 'singleSelectUserPickerFields',
    fixVersions: 'multipleVersionPickerFields',
    components: 'components',
    parent: 'parentField'
};

});


parcelRegister("7LoO9", function(module, exports) {

$parcel$export(module.exports, "useStorageEnforcement", () => $f0de573d65b66ce1$export$fa2c25e1ed13a1a8);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $hJ992 = parcelRequire("hJ992");

var $bNe1g = parcelRequire("bNe1g");


var $7YYuY = parcelRequire("7YYuY");

var $lXjME = parcelRequire("lXjME");
const $f0de573d65b66ce1$var$MODAL_COOLDOWN_MS = 86400000; // 1 day in ms
const $f0de573d65b66ce1$export$fa2c25e1ed13a1a8 = ()=>{
    const [currentState, { setIsOpen: setEnforceStorageModalIsOpen }] = (0, $lXjME.useEnforceStorageModal)();
    const issueViewMode = (0, $hJ992.useViewMode)();
    const { data: projectContextData } = (0, $bNe1g.useProjectContext)();
    const isInJSWProject = projectContextData?.projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
    const openModalIfNotOnCooldown = (0, $eUqFw.useCallback)((touchpoint)=>{
        const isOnCooldown = Date.now() - ((0, $7YYuY.localStorage).get((0, $815b5650076b1618$export$ed785d2382d0101d)) || 0) < $f0de573d65b66ce1$var$MODAL_COOLDOWN_MS;
        if (isOnCooldown) {
            if (currentState.isOpen === 'pending') // Reset pending state if modal is on cooldown when it should be shown
            setEnforceStorageModalIsOpen({
                isOpen: 'closed',
                touchpoint: undefined
            });
        } else setEnforceStorageModalIsOpen({
            isOpen: 'open',
            touchpoint: touchpoint
        });
    }, [
        setEnforceStorageModalIsOpen,
        currentState.isOpen
    ]);
    const showEnforcementIfStorageIsFull = (0, $eUqFw.useCallback)(({ delayShow: delayShow = false, shouldOnlyShowInJSWContext: shouldOnlyShowInJSWContext = true, touchpoint: touchpoint })=>{
        if (shouldOnlyShowInJSWContext && !isInJSWProject) return;
        // Issue view use case is checked internally here rather than passed in, to avoid polluting consumer code
        if (delayShow || issueViewMode === (0, $935e771f19f8ea28$export$98c0ebc22792f04)) setEnforceStorageModalIsOpen({
            isOpen: 'pending',
            touchpoint: touchpoint
        });
        else openModalIfNotOnCooldown(touchpoint);
    }, [
        isInJSWProject,
        issueViewMode,
        setEnforceStorageModalIsOpen,
        openModalIfNotOnCooldown
    ]);
    // Used to show enforcement modal after modals are dismissed, to avoid modal on modal UX
    const showEnforcementIfPendingToShow = (0, $eUqFw.useCallback)(()=>{
        if (currentState.isOpen === 'pending') // Use the trigger from created the JSW issue
        openModalIfNotOnCooldown(currentState.touchpoint);
    }, [
        currentState.isOpen,
        openModalIfNotOnCooldown,
        currentState.touchpoint
    ]);
    return {
        showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull,
        showEnforcementIfPendingToShow: showEnforcementIfPendingToShow
    };
};

});
const $815b5650076b1618$export$b8b9d90f9e5bd72b = 'jira-enforce-storage-limits';
const $815b5650076b1618$export$8f56a4ad6e1486ea = 10;
const $815b5650076b1618$export$ed785d2382d0101d = 'lastStorageEnforcement';

parcelRegister("7YYuY", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $79189cfebd980a86$export$c2ed3351cac403d1);

var $aZaPn = parcelRequire("aZaPn");
const $79189cfebd980a86$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('enforce-storage-limits');

});

parcelRegister("lXjME", function(module, exports) {

$parcel$export(module.exports, "useEnforceStorageModal", () => $2d9caf4f19990d1a$export$56beb4c2629d6615);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $erKBL = parcelRequire("erKBL");
const $2d9caf4f19990d1a$var$initialState = {
    isOpen: 'closed',
    touchpoint: undefined
};
const $2d9caf4f19990d1a$var$store = (0, $a61MH.createStore)({
    name: 'jsw-enforce-storage-limit-modal',
    initialState: $2d9caf4f19990d1a$var$initialState,
    actions: $erKBL.actions
});
const $2d9caf4f19990d1a$export$56beb4c2629d6615 = (0, $ggKAj.createHook)($2d9caf4f19990d1a$var$store);

});
parcelRegister("erKBL", function(module, exports) {

$parcel$export(module.exports, "actions", () => $31c22c176c15a4e6$export$e324594224ef24da);

var $fvtbN = parcelRequire("fvtbN");
const $31c22c176c15a4e6$export$e324594224ef24da = {
    setIsOpen: $fvtbN.setIsOpen
};

});
parcelRegister("fvtbN", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $9702937a09b78fa4$export$dcf23146e0a40195);
const $9702937a09b78fa4$export$dcf23146e0a40195 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };

});




parcelRegister("6PrhQ", function(module, exports) {

$parcel$export(module.exports, "isModernGICEnabledForSubtask", () => $db2fade13c955d48$export$dbaf42ba39b66293);
$parcel$export(module.exports, "isCustomMessageForLinkingWithoutPermissionsEnabled", () => $db2fade13c955d48$export$3068bf83bd6f9396);

var $1ybV0 = parcelRequire("1ybV0");
const $db2fade13c955d48$export$9ba0da55e7f403e1 = ()=>(0, $1ybV0.ff)('project.config.pce.modern.global-subtask-issue-create-trigger', false);
const $db2fade13c955d48$export$67305b99ef59566c = ()=>(0, $1ybV0.ff)('project.config.pce.modern.global-issue-create.trigger', false);
const $db2fade13c955d48$export$dbaf42ba39b66293 = ()=>$db2fade13c955d48$export$67305b99ef59566c() && $db2fade13c955d48$export$9ba0da55e7f403e1();
const $db2fade13c955d48$export$3068bf83bd6f9396 = ()=>(0, $1ybV0.ff)('issue.details.custom-message-for-linking-with-no-permissions_k7qsn', false);
const $db2fade13c955d48$export$bff466c504f395b3 = ()=>(0, $1ybV0.ff)('issue-update-analytics-events-on-issue-view', false);
const $db2fade13c955d48$export$b5be9eaa7fce369 = ()=>(0, $1ybV0.ff)('configurable-child-issues-panel_3ht06', false);
const $db2fade13c955d48$export$8ae318aca0fced97 = ()=>(0, $1ybV0.ff)('whiteboard-unlink-permissions_3ze8p', false);

});

parcelRegister("ab9U1", function(module, exports) {

$parcel$export(module.exports, "AddExistingIssueButton", () => $e36634630fe6ed74$export$9474a3654cef375);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $dsroq = parcelRequire("dsroq");
const $e36634630fe6ed74$export$9474a3654cef375 = (props)=>{
    const { children: children, onClick: onClick } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
            label: ""
        }),
        isSelected: false,
        onClick: onClick,
        testId: "issue-view-common-views.child-issues-panel.inline-create.add-existing-issue-button",
        interactionName: "auto-generated.jira-issue-view-common-views.child-issues-panel.view.inline-create.add-existing-issue-button.button"
    }, children);
};
$e36634630fe6ed74$export$9474a3654cef375.displayName = 'AddExistingIssueButton';

});

parcelRegister("72QB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b35631ae48d7711$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $0b35631ae48d7711$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    summaryLabel: {
        "id": "issue.views.common.child-issues-panel.inline-create.summary-label",
        "defaultMessage": "Child summary"
    },
    summaryPlaceholder: {
        "id": "issue.views.common.child-issues-panel.inline-create.summary-placeholder",
        "defaultMessage": "What needs to be done?"
    },
    summaryTextFieldLabel: {
        "id": "issue.views.common.child-issues-panel.inline-create.summary-text-field-label",
        "defaultMessage": "What needs to be done?"
    },
    summaryTooLong: {
        "id": "issue.views.common.child-issues-panel.inline-create.summary-too-long",
        "defaultMessage": "Summary must be less than 255 characters."
    },
    childCreateButton: {
        "id": "issue.views.common.child-issues-panel.inline-create.child-create-button",
        "defaultMessage": "Create"
    },
    childCancelButton: {
        "id": "issue.views.common.child-issues-panel.inline-create.child-cancel-button",
        "defaultMessage": "Cancel"
    },
    addExistingIssuePlaceholder: {
        "id": "issue.views.common.child-issues-panel.inline-create.add-existing-issue-placeholder",
        "defaultMessage": "Choose an existing issue"
    },
    cannotCreateChildIssue: {
        "id": "issue.views.common.child-issues-panel.inline-create.cannot-create-child-issue",
        "defaultMessage": "We can't create child issues. This project only allows you to create epics."
    }
});

});



parcelRegister("hSvgM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6765f1bd54e9fe9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $eGI9v = parcelRequire("eGI9v");
var $8un0w = parcelRequire("8un0w");

var $1ybV0 = parcelRequire("1ybV0");

var $4ksts = parcelRequire("4ksts");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $1TrR5 = parcelRequire("1TrR5");

var $6vrw7 = parcelRequire("6vrw7");

var $ca2LP = parcelRequire("ca2LP");
var $e2gQc = parcelRequire("e2gQc");

var $2HCUG = parcelRequire("2HCUG");

var $iBvRb = parcelRequire("iBvRb");

var $6QyxX = parcelRequire("6QyxX");

var $7xkAf = parcelRequire("7xkAf");

var $e30BK = parcelRequire("e30BK");
const $a6765f1bd54e9fe9$export$f36edb964ab3dd49 = (props)=>{
    const { allIssues: allIssues, onReorderChildren: onReorderChildren } = props;
    const [, { setSortableIssueIds: setSortableIssueIds }] = (0, $e2gQc.useSortableIssuesActions)();
    const enhancedOnReorderChildren = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    (...args)=>{
        setSortableIssueIds(allIssues.map((issue)=>(0, $6vrw7.toIssueId)(issue.id)));
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        onReorderChildren(...args);
    }, [
        allIssues,
        onReorderChildren,
        setSortableIssueIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e30BK.IssuesList), {
        ...props,
        onReorderChildren: enhancedOnReorderChildren
    });
};
const $a6765f1bd54e9fe9$var$ConnectedIssuesList = (props)=>{
    const intl = (0, $4ksts.useIntlV2)();
    const [sortByValue] = (0, $ca2LP.useChildIssuesSortBy)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a6765f1bd54e9fe9$export$f36edb964ab3dd49, {
        ...props,
        sortBy: sortByValue,
        intl: intl
    });
};
const $a6765f1bd54e9fe9$var$mapStateToProps = (state)=>({
        allIssues: (0, $6QyxX.getAllIssues)(state),
        incompleteIssues: (0, $6QyxX.getIncompleteIssues)(state),
        hideDone: (0, $7xkAf.getHideDone)(state),
        parentKey: (0, $2HCUG.getParentKey)(state),
        projectType: (0, $2HCUG.getChildIssuesPanelProjectType)(state),
        isSimplifiedProject: (0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e') ? (0, $2HCUG.getIsSimplifiedProject)(state) : undefined,
        isClassicSubtaskPanel: (0, $2HCUG.getIsClassicSubtaskPanel)(state),
        isChildrenIssuesPanel: (0, $2HCUG.getIsChildrenIssuesPanel)(state),
        onNavigateToNewIssue: (0, $2HCUG.getOnNavigateToNewIssue)(state),
        shouldDisplayWorklogGraph: (0, $2HCUG.getIsClassicSubtaskPanel)(state) || (0, $2HCUG.getIsChildrenIssuesPanel)(state) && (0, $6QyxX.getIssueHierarchyLevel)(state) === 0,
        onEditAssociatedIssue: (0, $2HCUG.getOnEditAssociatedIssue)(state)
    });
const $a6765f1bd54e9fe9$var$mapDispatchToProps = {
    onInlineErrorCancel: (0, $iBvRb.cancelOptimisticChild),
    onInlineErrorCreateRetry: (0, $iBvRb.createChildRetry),
    onInlineErrorLinkingRetry: (0, $iBvRb.linkingIssueRetry),
    onReorderChildren: (0, $iBvRb.reorderChildrenRequest),
    onEditIssue: (0, $iBvRb.updateIssue)
};
const $a6765f1bd54e9fe9$var$onEditIssueFactory = (0, $5iWql.default)((onEditIssue, onEditAssociatedIssue)=>(payload)=>{
        onEditIssue(payload);
        onEditAssociatedIssue?.(payload.issueKey);
    });
const $a6765f1bd54e9fe9$var$mergePropsOld = (stateProps, dispatchProps, ownProps)=>({
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        onEditIssue: (payload)=>{
            dispatchProps.onEditIssue(payload);
            stateProps.onEditAssociatedIssue?.(payload.issueKey);
        }
    });
const $a6765f1bd54e9fe9$var$mergePropsNew = (stateProps, dispatchProps, ownProps)=>({
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        onEditIssue: $a6765f1bd54e9fe9$var$onEditIssueFactory(dispatchProps.onEditIssue, stateProps.onEditAssociatedIssue)
    });
const $a6765f1bd54e9fe9$var$ReduxConnectedView = (0, $5G3JL.flowWithSafeComponent)((0, $eGI9v.default)('button', {
    onInlineErrorCancel: 'clicked',
    onInlineErrorCreateRetry: 'clicked'
}), (0, $eGI9v.default)('inlineIssue', {
    onNavigateToNewIssue: 'clicked',
    onReorderChildren: 'dragged'
}), (0, $8un0w.default)({
    onInlineErrorCancel: 'cancelInlineErrorCreate',
    onInlineErrorCreateRetry: 'retryInlineErrorCreate',
    onNavigateToNewIssue: 'navigateToNewIssue',
    onReorderChildren: 'reorderChildren'
}), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ onEditIssue: (payload: ChildIssue) => void; onInlineErrorCancel: (optimisticId: string) => { type: "state.entities.CANCEL_OPTIMISTIC_CHILD"; payload: { optimisticId: string; }; }; ... 16 more ...; sortBy: SortingOption | null; }, Props>' is not assignable to parameter of type 'FlowStep<WithUIAnalyticsEvent<PropsWithoutRef<Omit<{ [K in keyof PropsWithRef<Omit<{ [K in keyof Props]: K extends "onInlineErrorCreateRetry" | "onInlineErrorCancel" ? (...args: [...Parameters<Props[K]>, UIAnalyticsEvent]) => ReturnType<...> : Props[K]; }, keyof WithAnalyticsEventsProps>>]: K extends "onNavigateToNe...'.
(0, $lqalZ.connect)($a6765f1bd54e9fe9$var$mapStateToProps, $a6765f1bd54e9fe9$var$mapDispatchToProps, (0, $1TrR5.functionWithFFRedux)($a6765f1bd54e9fe9$var$mergePropsNew, $a6765f1bd54e9fe9$var$mergePropsOld)))($a6765f1bd54e9fe9$var$ConnectedIssuesList);
var $a6765f1bd54e9fe9$export$2e2bcd8739ae039 = $a6765f1bd54e9fe9$var$ReduxConnectedView;

});
parcelRegister("e30BK", function(module, exports) {

$parcel$export(module.exports, "IssuesList", () => $a0d0f7753c374f4e$export$f0e0d2b9b78901da);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $jG2Eu = parcelRequire("jG2Eu");

var $bwbFz = parcelRequire("bwbFz");

var $hFmdR = parcelRequire("hFmdR");

var $1ybV0 = parcelRequire("1ybV0");


var $i9pAn = parcelRequire("i9pAn");

var $ca2LP = parcelRequire("ca2LP");

var $agEEp = parcelRequire("agEEp");

var $6PQVo = parcelRequire("6PQVo");

var $01TIX = parcelRequire("01TIX");
const $a0d0f7753c374f4e$export$e9e38206b130e511 = ({ allIssues: allIssues, incompleteIssues: incompleteIssues, sortBy: sortBy, hasExceededChildIssuesLimitOnLoadOrAfter: hasExceededChildIssuesLimitOnLoadOrAfter, isSimplifiedProject: isSimplifiedProject, isClassicSubtaskPanel: isClassicSubtaskPanel, ...props })=>{
    const [hideDonePreference] = (0, $i9pAn.useUserPreferencesValue)((0, $e4af19d777b54ab6$export$4c9f7f9f8a4000e1));
    const [sortableIssueIds] = (0, $ca2LP.useSortableIssueIds)();
    const [oldIssuesFromAll, newIssuesFromAll] = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($bwbFz)))(allIssues, (issue)=>sortableIssueIds.includes(issue.id)), [
        allIssues,
        sortableIssueIds
    ]);
    const [oldIssuesFromIncomplete, newIssuesFromIncomplete] = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($bwbFz)))(incompleteIssues, (issue)=>sortableIssueIds.includes(issue.id)), [
        incompleteIssues,
        sortableIssueIds
    ]);
    const sortingFn = (0, $eUqFw.useMemo)(()=>{
        switch(sortBy){
            case 0, $agEEp.SORT_OPTION_CREATED:
                return 0, $01TIX.sortIssuesByCreated;
            case 0, $agEEp.SORT_OPTION_KEY:
                return 0, $01TIX.sortIssuesByKey;
            case 0, $agEEp.SORT_OPTION_STATUS:
                return 0, $01TIX.sortIssuesByStatus;
            case 0, $agEEp.SORT_OPTION_ASSIGNEE:
                return 0, $01TIX.sortIssuesByAssignee;
            case 0, $agEEp.SORT_OPTION_PRIORITY:
                return 0, $01TIX.sortIssuesByPriority;
            case 0, $agEEp.SORT_OPTION_RANKING:
            default:
                return (issues)=>issues;
        }
    }, [
        sortBy
    ]);
    const sortedAllIssues = (0, $eUqFw.useMemo)(()=>sortingFn(oldIssuesFromAll), [
        oldIssuesFromAll,
        sortingFn
    ]);
    const sortedIncompleteIssues = (0, $eUqFw.useMemo)(()=>sortingFn(oldIssuesFromIncomplete), [
        oldIssuesFromIncomplete,
        sortingFn
    ]);
    // Company Managed Projects do not currently support reranking as
    // the rank custom field is specially always loaded for TMP but not for CMP.
    // Without the rank custom field id we cannot rerank CMP issues
    const restrictReordering = (0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e') && !isSimplifiedProject && !isClassicSubtaskPanel || hasExceededChildIssuesLimitOnLoadOrAfter || sortBy !== null && sortBy !== (0, $agEEp.SORT_OPTION_RANKING);
    //  show hidden done issues if all child issues/subtasks are done
    //  otherwise we'll have an empty child issues panel
    const hasIncompleteIssues = !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(incompleteIssues);
    const shouldHideDone = hasIncompleteIssues && hideDonePreference === 'true';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6PQVo.Issues), {
        ...props,
        isSimplifiedProject: isSimplifiedProject,
        isClassicSubtaskPanel: isClassicSubtaskPanel,
        allIssues: [
            ...sortedAllIssues,
            ...newIssuesFromAll
        ],
        incompleteIssues: [
            ...sortedIncompleteIssues,
            ...newIssuesFromIncomplete
        ],
        restrictReordering: restrictReordering,
        hasExceededChildIssuesLimitOnLoadOrAfter: hasExceededChildIssuesLimitOnLoadOrAfter,
        hideDone: shouldHideDone
    });
};
$a0d0f7753c374f4e$export$e9e38206b130e511.defaultProps = {
    isClassicSubtaskPanel: false,
    isChildrenIssuesPanel: false,
    shouldDisplayWorklogGraph: false,
    allIssues: [],
    incompleteIssues: [],
    projectType: null,
    onReorderChildren: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onEditIssue: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    hasExceededChildIssuesLimitOnLoadOrAfter: false
};
const $a0d0f7753c374f4e$export$f0e0d2b9b78901da = (0, $hFmdR.AnalyticsSubject)('issue')($a0d0f7753c374f4e$export$e9e38206b130e511);

});
parcelRegister("6PQVo", function(module, exports) {

$parcel$export(module.exports, "Issues", () => $fe279324e61e7d40$export$1cb51167b20548a0);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $hTLlD = parcelRequire("hTLlD");

var $jG2Eu = parcelRequire("jG2Eu");

var $aml13 = parcelRequire("aml13");

var $1ybV0 = parcelRequire("1ybV0");

var $bJKxA = parcelRequire("bJKxA");

var $gQylF = parcelRequire("gQylF");

var $4Xcha = parcelRequire("4Xcha");

var $8Y8Vi = parcelRequire("8Y8Vi");

var $5gJbo = parcelRequire("5gJbo");

var $f9RL0 = parcelRequire("f9RL0");

var $9XfZZ = parcelRequire("9XfZZ");

var $6vrw7 = parcelRequire("6vrw7");

var $yyqSx = parcelRequire("yyqSx");

var $5xRy0 = parcelRequire("5xRy0");

var $1wVY9 = parcelRequire("1wVY9");

var $apQla = parcelRequire("apQla");

var $6bPqk = parcelRequire("6bPqk");

var $dkwhp = parcelRequire("dkwhp");

var $41Paw = parcelRequire("41Paw");
// eslint-disable-next-line jira/react/no-class-components
class $fe279324e61e7d40$var$IssuesInternal extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isClassicSubtaskPanel: false,
            isChildrenIssuesPanel: false,
            shouldDisplayWorklogGraph: false,
            allIssues: [],
            incompleteIssues: [],
            projectType: null,
            restrictReordering: false,
            onReorderChildren: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onEditIssue: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    inlineErrorMessage(id, errorType, error) {
        const { intl: intl, onInlineErrorCreateRetry: onInlineErrorCreateRetry, onInlineErrorLinkingRetry: onInlineErrorLinkingRetry, onInlineErrorCancel: onInlineErrorCancel, isClassicSubtaskPanel: isClassicSubtaskPanel } = this.props;
        switch(errorType){
            case (0, $8Y8Vi.associatedIssueErrorTypes).linkChild:
                return (0, $5xRy0.renderInlineMessage)(intl, intl.formatMessage((0, $apQla.default).linkIssueErrorTitle), intl.formatMessage((0, $apQla.default).linkIssueErrorBody), (e, analyticsEvent)=>onInlineErrorLinkingRetry(id, analyticsEvent), ()=>onInlineErrorCancel(id));
            case (0, $8Y8Vi.associatedIssueErrorTypes).createChild:
            default:
                {
                    const errorTitle = isClassicSubtaskPanel ? (0, $apQla.default).createSubtaskErrorTitle : (0, $apQla.default).createChildErrorTitle;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(error)) {
                        const errorMessages = error.message ? error.message.split('; ') : [];
                        // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2339 - Property 'errors' does not exist on type 'Error | ValidationError'.
                        const fieldErrorMessages = error.errors?.length ? error.errors.map(({ field: field, error: errorMessage })=>field === (0, $f9RL0.ASSIGNEE) && errorMessage === (0, $4Xcha.DEFAULT_ASSIGNEE_PERMISSION_ERROR_MESSAGE) ? (0, $4Xcha.DEFAULT_ASSIGNEE_PERMISSION_ERROR_MESSAGE_FE) : errorMessage) : [];
                        const allErrors = [
                            ...errorMessages,
                            ...fieldErrorMessages
                        ];
                        if (allErrors.length) {
                            const limitToTwoErrorMessages = allErrors.slice(0, 2);
                            return (0, $5xRy0.renderInlineMessage)(intl, intl.formatMessage(errorTitle), limitToTwoErrorMessages, (e, analyticsEvent)=>onInlineErrorCreateRetry(id, analyticsEvent), ()=>onInlineErrorCancel(id));
                        }
                    }
                    return (0, $5xRy0.renderInlineMessage)(intl, intl.formatMessage(errorTitle), intl.formatMessage((0, $apQla.default).createErrorBody), (e, analyticsEvent)=>onInlineErrorCreateRetry(id, analyticsEvent), ()=>onInlineErrorCancel(id));
                }
        }
    }
    renderIssueLineCardGroup({ groupId: groupId, issues: issues, projectType: projectType, isReorderEnabled: isReorderEnabled, isInteractive: isInteractive, onEditIssue: onEditIssue, shouldDisplayWorklogGraph: shouldDisplayWorklogGraph, restrictedReorderingMessage: restrictedReorderingMessage }) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQylF.ItemLineCardGroup), {
            items: issues,
            onOrderChange: this.onOrderChange,
            groupId: groupId,
            isReorderEnabled: isReorderEnabled,
            isInteractive: isInteractive,
            onClick: this.onChildIssueClick
        }, ({ isHovering: isHovering, isActive: isActive, isFocused: isFocused, isDragging: isDragging, item: issue, isReorderMenuOpen: isReorderMenuOpen, reorderMenu: reorderMenu })=>{
            const handleEdit = (updatedFields)=>onEditIssue && onEditIssue({
                    ...issue,
                    ...updatedFields
                });
            const handleClick = (event)=>this.onChildIssueClick({
                    ...issue
                }, event);
            const { id: id, issueKey: issueKey, issueLink: issueLink, issueTypeIconUrl: issueTypeIconUrl, issueTypeName: issueTypeName, issuePriorityUrl: issuePriorityUrl, issuePriorityName: issuePriorityName, issueSummary: issueSummary, statusCategory: statusCategory, statusCategoryId: statusCategoryId, statusId: statusId, statusName: statusName, assigneeUrl: assigneeUrl, assigneeDisplayName: assigneeDisplayName, isLoading: isLoading, errorInlineMessage: errorInlineMessage, hasError: hasError, estimateFieldId: estimateFieldId, issueTimeTracking: issueTimeTracking, isResolved: isResolved } = issue;
            const additionalItems = [];
            if (shouldDisplayWorklogGraph && issueTimeTracking?.timeSpentSeconds !== undefined && issueTimeTracking.timeSpentSeconds > 0) additionalItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkwhp.default), {
                issueTimeTracking: issueTimeTracking,
                statusCategory: issue.statusCategory
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1wVY9.default), {
                id: (0, $6vrw7.toIssueId)(id),
                issueKey: (0, $6vrw7.toIssueKey)(issueKey ?? ''),
                issueLink: issueLink,
                issueTypeIconUrl: issueTypeIconUrl,
                issueTypeName: issueTypeName,
                issuePriorityUrl: issuePriorityUrl,
                issuePriorityName: issuePriorityName,
                issueSummary: issueSummary,
                statusCategory: statusCategory,
                statusCategoryId: statusCategoryId,
                statusId: statusId,
                statusName: statusName,
                assigneeUrl: assigneeUrl,
                assigneeDisplayName: assigneeDisplayName,
                isLoading: isLoading,
                errorInlineMessage: errorInlineMessage,
                hasError: hasError,
                estimateFieldId: estimateFieldId,
                isHovering: isHovering,
                isActive: isActive,
                /**
							 * Ensures the reorder menu stays visible while it is open.
							 */ isFocused: isFocused || isReorderMenuOpen,
                isDraggable: isReorderEnabled,
                isDragging: isDragging,
                isInteractive: isInteractive,
                projectType: projectType,
                onEdit: handleEdit,
                onClick: handleClick,
                restrictedReorderingMessage: restrictedReorderingMessage,
                additionalItems: additionalItems,
                shouldDisplayDevOpsData: true,
                isInlineEditEnabled: true,
                isResolved: isResolved,
                reorderMenu: reorderMenu
            });
        });
    }
    render() {
        const { allIssues: allIssues, incompleteIssues: incompleteIssues, hideDone: hideDone, isClassicSubtaskPanel: isClassicSubtaskPanel, isChildrenIssuesPanel: isChildrenIssuesPanel, isSimplifiedProject: isSimplifiedProject, projectType: projectType, onEditIssue: onEditIssue, shouldDisplayWorklogGraph: shouldDisplayWorklogGraph, intl: { formatMessage: formatMessage }, restrictReordering: restrictReordering = false, hasExceededChildIssuesLimitOnLoadOrAfter: hasExceededChildIssuesLimitOnLoadOrAfter } = this.props;
        const hasMultipleIssues = allIssues.length > 1;
        const hasLoadingIssues = allIssues.filter((issue)=>issue.isLoading).length > 0;
        const canReorderIssues = (isChildrenIssuesPanel || isClassicSubtaskPanel) && !hideDone && hasMultipleIssues && !hasLoadingIssues && !restrictReordering;
        const issuesToRender = hideDone ? incompleteIssues : allIssues;
        const issues = issuesToRender.map((issue)=>{
            const dragPreview = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6bPqk.DragPreview), {
                iconUrl: issue.issueTypeIconUrl,
                issueKey: issue.issueKey
            });
            const name = issue.issueSummary ?? '';
            const type = issue.issueTypeName ?? '';
            return issue.errorType ? {
                ...issue,
                errorInlineMessage: this.inlineErrorMessage(issue.id, issue.errorType, issue.error),
                dragPreview: dragPreview,
                name: name,
                type: type
            } : {
                ...issue,
                dragPreview: dragPreview,
                name: name,
                type: type
            };
        });
        const containerProps = {
            'data-testid': 'issue.issue-view.views.common.child-issues-panel.issues-container'
        };
        const reorderingMessageProps = (isChildrenIssuesPanel || isClassicSubtaskPanel) && hasMultipleIssues && restrictReordering && !((0, $1ybV0.ff)('jira-issue-view_child-issue-panel-standardisation_76s8e') && !isSimplifiedProject && isChildrenIssuesPanel) && {
            restrictedReorderingMessage: hasExceededChildIssuesLimitOnLoadOrAfter ? formatMessage((0, $apQla.default).restrictedReorderingExceededLimitMessage) : formatMessage((0, $apQla.default).restrictedReorderingMessage)
        };
        const issueIds = issues.map((issue)=>issue.id);
        const SmartCardProviderFF = (0, $1ybV0.ff)('platform.linking-platform.smart-card.hover-card-ai-summaries') ? (0, $9XfZZ.SmartCardProviderWithAIHooks) : (0, $aml13.SmartCardProvider);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SmartCardProviderFF, null, (0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $41Paw.Container), containerProps, this.renderIssueLineCardGroup({
            groupId: 'child-issues-panel',
            issues: issues,
            projectType: projectType,
            isReorderEnabled: canReorderIssues,
            onEditIssue: onEditIssue,
            shouldDisplayWorklogGraph: shouldDisplayWorklogGraph,
            ...reorderingMessageProps
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bJKxA.AsyncDevOpsSummaryContainer), {
            issueIds: issueIds,
            location: "issue_view_child_issues_list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $41Paw.Container), containerProps, this.renderIssueLineCardGroup({
            groupId: 'child-issues-panel',
            issues: issues,
            projectType: projectType,
            isReorderEnabled: canReorderIssues,
            onEditIssue: onEditIssue,
            shouldDisplayWorklogGraph: shouldDisplayWorklogGraph,
            ...reorderingMessageProps
        }))));
    }
    constructor(...args){
        super(...args);
        this.onChildIssueClick = (issue, event)=>{
            if ((0, $5gJbo.isMiddleClick)(event)) return;
            const nextIssueKey = issue.issueKey;
            if (typeof nextIssueKey === 'string' && (0, $5gJbo.isLeftClickOnly)(event)) this.props.onNavigateToNewIssue({
                fromIssueKey: this.props.parentKey,
                toIssueKey: nextIssueKey
            });
            else if (typeof nextIssueKey === 'string' && (0, $5gJbo.isCmdOrCtrlClick)(event)) window.open(issue.issueLink, '_blank');
        };
        this.onOrderChange = (optimisticNewOrder, reorderedIssue, currentIssueIndex, newIssueIndex, analyticsEvent)=>{
            this.props.onReorderChildren(this.props.allIssues, optimisticNewOrder, currentIssueIndex, newIssueIndex, analyticsEvent);
        };
    }
}
const $fe279324e61e7d40$export$1cb51167b20548a0 = /*#__PURE__*/ (0, $eUqFw.memo)($fe279324e61e7d40$var$IssuesInternal, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
$fe279324e61e7d40$export$1cb51167b20548a0.displayName = 'Issues';

});
parcelRegister("bJKxA", function(module, exports) {

$parcel$export(module.exports, "AsyncDevOpsSummaryContainer", () => $423af9fcb3ca5a9a$export$2e058f9366fb05a1);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $4S1E9 = parcelRequire("4S1E9");

var $9aFRj = parcelRequire("9aFRj");

const $423af9fcb3ca5a9a$var$LazyDevOpsSummaryContainer = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("diHmj")).then((module)=>module.DevOpsSummaryContainer), {
    moduleId: "./src/packages/issue/dev-ops-summary/src/ui/dev-ops-summary-container/index.tsx"
});
const $423af9fcb3ca5a9a$export$2e058f9366fb05a1 = (props)=>{
    const onFail = (0, $9aFRj.useDevOpsSummaryExperienceFail)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFRj.DevOpsSummaryExperienceStart), {
        location: props.location
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4S1E9.ErrorBoundary), {
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children),
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "dev-ops-summary-container",
        fallback: props.children || null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($423af9fcb3ca5a9a$var$LazyDevOpsSummaryContainer, props))));
};

});
parcelRegister("4S1E9", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $21c992e560346c94$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

const $21c992e560346c94$export$e926676385687eaf = ({ children: children, fallback: fallback })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "deliverySummary",
        fallback: fallback,
        packageName: (0, $bae02e12d7dde283$export$b8b9d90f9e5bd72b),
        teamName: (0, $bae02e12d7dde283$export$d57b6b390e78d90f)
    }, children);

});
const $bae02e12d7dde283$export$6bc465585d114926 = 'devOpsSummary';
const $bae02e12d7dde283$export$b8b9d90f9e5bd72b = 'jira.issue.dev-ops-summary';
const $bae02e12d7dde283$export$d57b6b390e78d90f = 'fusion-solaris';


parcelRegister("9aFRj", function(module, exports) {

$parcel$export(module.exports, "DevOpsSummaryExperienceStart", () => $afa049eb2b3ba82a$export$fd060328a0daa59e);
$parcel$export(module.exports, "DevOpsSummaryExperienceSuccess", () => $afa049eb2b3ba82a$export$97033ec52245180f);
$parcel$export(module.exports, "useDevOpsSummaryExperienceFail", () => $afa049eb2b3ba82a$export$c2d9e27b39717bf5);
$parcel$export(module.exports, "DevOpsSummaryExperienceFail", () => $afa049eb2b3ba82a$export$153e5becce18b6b9);

var $eUqFw = parcelRequire("eUqFw");

var $bDhRl = parcelRequire("bDhRl");
var $fDZ6r = parcelRequire("fDZ6r");
var $4qhD6 = parcelRequire("4qhD6");
const $afa049eb2b3ba82a$export$52919046b94109dc = 'issueDevOpsSummaryIcons';
const $afa049eb2b3ba82a$export$fd060328a0daa59e = ({ location: location })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
        experience: $afa049eb2b3ba82a$export$52919046b94109dc,
        experienceId: location,
        analyticsSource: location
    });
const $afa049eb2b3ba82a$export$97033ec52245180f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: $afa049eb2b3ba82a$export$52919046b94109dc
    });
const $afa049eb2b3ba82a$export$c2d9e27b39717bf5 = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $afa049eb2b3ba82a$export$52919046b94109dc
    });
const $afa049eb2b3ba82a$export$153e5becce18b6b9 = ({ location: location, error: error })=>{
    const onFail = $afa049eb2b3ba82a$export$c2d9e27b39717bf5();
    (0, $eUqFw.useEffect)(()=>{
        onFail(location, error);
    }, [
        location,
        error,
        onFail
    ]);
    return null;
};

});

parcelRegister("diHmj", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dpKea');
        const value = parcelRequire('3qrTp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dpKea").then(()=>parcelRequire('3qrTp'));
}

});


parcelRegister("gQylF", function(module, exports) {

$parcel$export(module.exports, "ItemLineCardGroup", () => $99f18ae8c4bb172d$export$c208b3dc2844374f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $gmZvv = parcelRequire("gmZvv");

var $1S8jG = parcelRequire("1S8jG");

var $fSMvP = parcelRequire("fSMvP");

var $4c90u = parcelRequire("4c90u");
parcelRequire("eo9PV");
var $9wCS5 = parcelRequire("9wCS5");
parcelRequire("gPx3x");
var $j2oqV = parcelRequire("j2oqV");

var $hPdNw = parcelRequire("hPdNw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7iWCF = parcelRequire("7iWCF");

var $e6iRT = parcelRequire("e6iRT");

var $bFzGY = parcelRequire("bFzGY");

var $4kVDa = parcelRequire("4kVDa");

var $at9QE = parcelRequire("at9QE");
function $99f18ae8c4bb172d$export$c208b3dc2844374f({ groupId: instanceId, items: items, isReorderEnabled: isReorderEnabled = false, isInteractive: isInteractive = true, isVariableHeightCards: isVariableHeightCards = false, onOrderChange: onOrderChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), testId: testId, children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { itemRegistry: itemRegistry, registerItem: registerItem } = (0, $7iWCF.useItemRegistry)();
    const [lastAction, setLastAction] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (lastAction === null) return;
        if (lastAction.type === 'reorder') {
            const element = itemRegistry.get(lastAction.draggableId);
            if (!element) return;
            (0, $1S8jG.triggerPostMoveFlash)(element);
        }
    }, [
        itemRegistry,
        lastAction
    ]);
    const onReorderItem = (0, $eUqFw.useCallback)(({ startIndex: startIndex, finishIndex: finishIndex })=>{
        const itemsCopy = (0, $j2oqV.reorder)({
            /**
       * Casting from `readonly Item[]` to mutable `Item[]` because
       * the `reorder` util does not mark the input as `readonly`,
       * but it does not mutate the list (so this is still safe).
       */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            list: items,
            startIndex: startIndex,
            finishIndex: finishIndex
        });
        const analyticsEvent = createAnalyticsEvent({
            action: 'updated',
            actionSubject: 'issueRank'
        });
        setLastAction({
            type: 'reorder',
            draggableId: items[startIndex].id,
            itemName: items[startIndex].issueSummary ?? '',
            startPosition: startIndex + 1,
            endPosition: finishIndex + 1,
            numberOfItems: items.length
        });
        onOrderChange(itemsCopy, items[startIndex], startIndex, finishIndex, analyticsEvent);
    }, [
        createAnalyticsEvent,
        items,
        onOrderChange
    ]);
    (0, $eUqFw.useEffect)(()=>(0, $9wCS5.monitorForElements)({
            canMonitor ({ source: source }) {
                return (0, $e6iRT.isSortableItemData)(source.data) && source.data.instanceId === instanceId;
            },
            onDrop ({ source: source, location: location }) {
                const destination = location.current.dropTargets[0];
                if (!destination) return;
                if (!(0, $e6iRT.isSortableItemData)(destination.data) || !(0, $e6iRT.isSortableItemData)(source.data)) return;
                const closestEdgeOfTarget = (0, $fSMvP.extractClosestEdge)(destination.data);
                const startIndex = source.data.index;
                const finishIndex = (0, $4c90u.getReorderDestinationIndex)({
                    startIndex: startIndex,
                    indexOfTarget: destination.data.index,
                    closestEdgeOfTarget: closestEdgeOfTarget,
                    axis: 'vertical'
                });
                onReorderItem({
                    startIndex: startIndex,
                    finishIndex: finishIndex
                });
            }
        }), [
        createAnalyticsEvent,
        instanceId,
        items,
        onOrderChange,
        onReorderItem
    ]);
    const intl = (0, $5JgJ2.default)();
    const liveRegion = (0, $eUqFw.useMemo)(()=>{
        if (lastAction?.type === 'reorder') return {
            shouldAnnounce: true,
            message: intl.formatMessage((0, $at9QE.default).postMoveAnnouncement, lastAction)
        };
        return {
            shouldAnnounce: false,
            message: ''
        };
    }, [
        intl,
        lastAction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($99f18ae8c4bb172d$var$Container, {
        "data-testid": testId
    }, items.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
            key: item.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kVDa.ItemLineCard), {
            item: item,
            index: index,
            numItems: items.length,
            isReorderEnabled: isReorderEnabled,
            isInteractive: isInteractive,
            isVariableHeight: isVariableHeightCards,
            onClick: onClick,
            onReorderItem: onReorderItem,
            setItemInRegistry: registerItem,
            testId: testId ? `${testId}.item--${item.id}` : undefined,
            instanceId: instanceId
        }, children)))), isReorderEnabled && /**
     * Only rendering this if reordering is enabled to avoid DOM bloat.
     *
     * Portalling to avoid a layout issue. It was causing the body scroll
     * container for the issue view to grow and have dead space.
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gmZvv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hPdNw.AnnouncerV2), {
        shouldAnnounce: liveRegion.shouldAnnounce,
        message: liveRegion.message,
        liveMode: "assertive"
    })));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $99f18ae8c4bb172d$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16qs1os1 _11q7ed01 _2rko1l7b _1yt4ze3t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4kVDa", function(module, exports) {

$parcel$export(module.exports, "ItemLineCard", () => $6af2a36ca1e44d89$export$352f186d0c910a6e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $lQboI = parcelRequire("lQboI");

var $e6iRT = parcelRequire("e6iRT");

var $c5oSq = parcelRequire("c5oSq");
const $6af2a36ca1e44d89$export$352f186d0c910a6e = ({ onReorderItem: // eslint-disable-next-line @typescript-eslint/no-empty-function
onReorderItem = ()=>{}, isReorderEnabled: isReorderEnabled = false, isInteractive: isInteractive = true, isVariableHeight: isVariableHeight = false, item: item, onClick: onClickProp, index: index, children: children, testId: testId, setItemInRegistry: setItemInRegistry, numItems: numItems, instanceId: instanceId })=>{
    const { isFocused: isFocused, isPressed: isPressed, isHovering: isHovering, onClick: onClick, onDragEnd: onDragEnd, onFocusIn: onFocusIn, onFocusOut: onFocusOut, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp } = $6af2a36ca1e44d89$var$useCardInteractionState({
        item: item,
        onClickProp: onClickProp
    });
    const ref = (0, $eUqFw.useRef)(null);
    const draggableId = item.id;
    const { dragState: dragState } = (0, $e6iRT.useSortableItem)({
        draggableId: draggableId,
        index: index,
        ref: ref,
        isReorderEnabled: isReorderEnabled,
        onDragEnd: onDragEnd,
        instanceId: instanceId
    });
    const isDragging = dragState.type === 'dragging';
    // Dragging should also count as an active state for consumers
    const isActive = isPressed || isDragging;
    (0, $eUqFw.useEffect)(()=>{
        const element = ref.current;
        if (!element) return;
        return setItemInRegistry({
            draggableId: draggableId,
            element: element
        });
    }, [
        draggableId,
        setItemInRegistry
    ]);
    const [isReorderMenuOpen, setIsReorderMenuOpen] = (0, $eUqFw.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        /**
   * React's `onFocus` and `onBlur` behave like the `focusin` and `focusout` events.
   * They bubble up.
   */ onFocus: onFocusIn,
        onBlur: onFocusOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        "data-testid": testId,
        className: (0, $7JEyt.default)([
            "_11q7txrc _1e0c1txw _kqswh2mm _1yt4h8dc _n7zl1l7n _80om1wug _1rcd1sit _1wp91sit _49cv1sit _99931sit _1ragglyw _19lc14ae _9oik18uv _1bnxglyw _jf4cnqa1 _j6xt1l7b",
            isInteractive && "_80omtlke",
            !isVariableHeight && "_4t3i1jfw",
            !isReorderEnabled && "_y7iw3acm",
            isDragging && "_tzy41ou4"
        ])
    }, children({
        isHovering: isHovering,
        isActive: isActive,
        isFocused: isFocused,
        isDragging: isDragging,
        item: item,
        isReorderMenuOpen: isReorderMenuOpen,
        reorderMenu: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c5oSq.ReorderMenu), {
            itemIndex: index,
            onReorderItem: onReorderItem,
            numItems: numItems,
            itemName: item.issueSummary ?? '',
            itemType: item.issueTypeName ?? '',
            setIsOpen: setIsReorderMenuOpen
        })
    }), dragState.type === 'dragging-over' && dragState.shouldRenderDropIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lQboI.DropIndicator), {
        edge: dragState.edge,
        gap: "1px"
    }), dragState.type === 'preview' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(item?.dragPreview ?? item.id, dragState.container));
};
const $6af2a36ca1e44d89$var$isMiddleClick = (event)=>event.button === 1;
function $6af2a36ca1e44d89$var$useCardInteractionState({ item: item, onClickProp: onClickProp }) {
    /**
   * Not using a union for this state because it is passed down to the
   * consumer, so there are no guarantees around how this state is being
   * used.
   *
   * It could be refactored to use a union but would require checking all
   * usage.
   */ const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    const [isHovering, setIsHovering] = (0, $eUqFw.useState)(false);
    const [isPressed, setIsPressed] = (0, $eUqFw.useState)(false);
    const onFocusIn = ()=>{
        setIsFocused(true);
    };
    const onFocusOut = ()=>{
        setIsFocused(false);
    };
    const propagateClick = (event)=>{
        onClickProp(item, event);
    };
    const onDragEnd = (0, $eUqFw.useCallback)(()=>{
        setIsPressed(false);
    }, []);
    const onMouseEnter = ()=>{
        setIsHovering(true);
    };
    const onMouseLeave = ()=>{
        setIsHovering(false);
        setIsPressed(false);
    };
    const onMouseDown = (event)=>{
        if ($6af2a36ca1e44d89$var$isMiddleClick(event)) propagateClick(event);
        setIsPressed(true);
    };
    const onMouseUp = ()=>{
        setIsPressed(false);
    };
    const onClick = (event)=>{
        if (event.defaultPrevented === true) /**
       * Originally used for dealing with `react-beautiful-dnd` but also
       * required so that clicking the status lozenge doesn't count as
       * a click on the card.
       *
       * Ideally interactive content would not be a DOM child of the card,
       * which is also interactive.
       */ return;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (!event.currentTarget.contains(event.target)) /**
       * This is to ignore clicks on portalled elements (such as dropdown
       * menu items)
       */ return;
        if (!$6af2a36ca1e44d89$var$isMiddleClick(event)) propagateClick(event);
    };
    return {
        isFocused: isFocused,
        isPressed: isPressed,
        isHovering: isHovering,
        onDragEnd: onDragEnd,
        onFocusIn: onFocusIn,
        onFocusOut: onFocusOut,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onClick: onClick
    };
}
const $6af2a36ca1e44d89$var$cardStyles = null;
const $6af2a36ca1e44d89$var$interactiveStyles = null;
const $6af2a36ca1e44d89$var$fixedHeightStyles = null;
const $6af2a36ca1e44d89$var$notDraggableStyles = null;
const $6af2a36ca1e44d89$var$draggingStyles = null;

});
parcelRegister("c5oSq", function(module, exports) {

$parcel$export(module.exports, "ReorderMenu", () => $a17f1341e55d7102$export$25d8f7d2038f08db);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $jqHVa = parcelRequire("jqHVa");

var $5JgJ2 = parcelRequire("5JgJ2");

var $e2qzo = parcelRequire("e2qzo");
const $a17f1341e55d7102$var$preventDefault = (event)=>event.preventDefault();
function $a17f1341e55d7102$export$25d8f7d2038f08db({ itemIndex: itemIndex, onReorderItem: onReorderItem, numItems: numItems, itemName: itemName, itemType: itemType, setIsOpen: setIsOpen }) {
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        testId: "issue-item-line-card.ui.item-line-card.reorder-menu.reorder-menu",
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>{
            setIsOpen(triggerProps.isSelected ?? false);
            return(/**
       * Cancelling events here so that clicks on the trigger
       * don't trigger the card's `onClick()` propagation.
       *
       * Ideally we would not nest interactive components,
       * but this is already the existing behavior.
       */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a17f1341e55d7102$var$TriggerWrapper, {
                onClick: $a17f1341e55d7102$var$preventDefault
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jqHVa.DragHandleButton // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ), {
                ref: triggerRef,
                label: intl.formatMessage((0, $e2qzo.default).triggerLabel, {
                    itemName: itemName,
                    itemType: itemType
                }),
                appearance: "subtle",
                ...triggerProps
            })));
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        testId: "issue-item-line-card.ui.item-line-card.reorder-menu.move-up",
        onClick: ()=>{
            onReorderItem({
                startIndex: itemIndex,
                finishIndex: itemIndex - 1
            });
        },
        isDisabled: itemIndex === 0
    }, intl.formatMessage((0, $e2qzo.default).moveUp)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        testId: "issue-item-line-card.ui.item-line-card.reorder-menu.move-down",
        onClick: ()=>{
            onReorderItem({
                startIndex: itemIndex,
                finishIndex: itemIndex + 1
            });
        },
        isDisabled: itemIndex === numItems - 1
    }, intl.formatMessage((0, $e2qzo.default).moveDown))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a17f1341e55d7102$var$TriggerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8r5cr",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jqHVa", function(module, exports) {

$parcel$export(module.exports, "DragHandleButton", () => $58393086a682bcaa$export$4c99a519d851f90c);

var $eUqFw = parcelRequire("eUqFw");

var $dULIU = parcelRequire("dULIU");

var $az1K3 = parcelRequire("az1K3");
const $58393086a682bcaa$export$4c99a519d851f90c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function DragHandleButton({ label: label, ...buttonProps }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $az1K3.DragHandleButtonBase), {
        ref: ref,
        ...buttonProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dULIU))), {
        label: label
    }));
});

});

parcelRegister("e2qzo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4073ff88b8bf8ce8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4073ff88b8bf8ce8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    triggerLabel: {
        "id": "issue-item-line-card.item-line-card.reorder-menu.trigger-label",
        "defaultMessage": "Reorder \"{itemName}\" {itemType}"
    },
    moveUp: {
        "id": "issue-item-line-card.item-line-card.reorder-menu.move-up",
        "defaultMessage": "Move up"
    },
    moveDown: {
        "id": "issue-item-line-card.item-line-card.reorder-menu.move-down",
        "defaultMessage": "Move down"
    }
});

});



parcelRegister("at9QE", function(module, exports) {

$parcel$export(module.exports, "default", () => $39e941a5ebc9010b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $39e941a5ebc9010b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    postMoveAnnouncement: {
        "id": "issue-item-line-card.post-move-announcement",
        "defaultMessage": "You've moved \"{itemName}\" from position {startPosition} to position {endPosition} of {numberOfItems}"
    }
});

});


parcelRegister("yyqSx", function(module, exports) {

$parcel$export(module.exports, "isDevopsFeatureDisabledInFedRamp", () => $d7ad054dfd872773$export$18bfef4995ec57b7);

var $4K830 = parcelRequire("4K830");

var $6goyu = parcelRequire("6goyu");
const $d7ad054dfd872773$export$18bfef4995ec57b7 = ()=>(0, $6goyu.isDisableDevopsFeaturesInFedRampEnvEnabled)() && (0, $4K830.isFedRamp)();

});
parcelRegister("6goyu", function(module, exports) {

$parcel$export(module.exports, "isDisableDevopsFeaturesInFedRampEnvEnabled", () => $0bb8681ee65fdabd$export$a803c452d83c73b6);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $1ybV0 = parcelRequire("1ybV0");
const $0bb8681ee65fdabd$export$a803c452d83c73b6 = ()=>(0, $1ybV0.ff)('core-x-fedramp-m1-disable-devops-features_ag5zy');

});


parcelRegister("5xRy0", function(module, exports) {

$parcel$export(module.exports, "renderInlineMessage", () => $6df25e2541aa7684$export$fba6ba0119d86ee3);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $jOdsB = parcelRequire("jOdsB");

var $6PrhQ = parcelRequire("6PrhQ");

var $hTaKC = parcelRequire("hTaKC");

var $ltHKI = parcelRequire("ltHKI");
const $6df25e2541aa7684$export$fba6ba0119d86ee3 = (intl, headerMessage, contentMessage, onRetryClick, onCancelClick, userHasPermissionToLink)=>{
    const RetryButtonOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onRetryClick,
        interactionName: "auto-generated.jira-issue-view-common-views.issue-line-card.view.inline-message.button"
    }, intl.formatMessage((0, $hTaKC.default).retry));
    const RetryButtonNew = userHasPermissionToLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltHKI.InlineMessageRightButtonPadding), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onRetryClick,
        interactionName: "auto-generated.jira-issue-view-common-views.issue-line-card.view.inline-message.button1"
    }, intl.formatMessage((0, $hTaKC.default).retry))) : null;
    const cancelButtonOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltHKI.InlineMessageButtonPadding), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onCancelClick,
        interactionName: "auto-generated.jira-issue-view-common-views.issue-line-card.view.inline-message.button2"
    }, intl.formatMessage((0, $hTaKC.default).cancel)));
    const cancelButtonNew = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onCancelClick,
        interactionName: "auto-generated.jira-issue-view-common-views.issue-line-card.view.inline-message.button3"
    }, intl.formatMessage((0, $hTaKC.default).cancel));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jOdsB.default), {
        appearance: "warning",
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltHKI.InlineMessageHeading), null, headerMessage), Array.isArray(contentMessage) ? contentMessage.map((message, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltHKI.InlineMessageText), {
            key: idx
        }, message)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltHKI.InlineMessageText), null, contentMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltHKI.InlineMessageButtonsWrapper), null, (0, $6PrhQ.isCustomMessageForLinkingWithoutPermissionsEnabled)() ? RetryButtonNew : RetryButtonOld, (0, $6PrhQ.isCustomMessageForLinkingWithoutPermissionsEnabled)() ? cancelButtonNew : cancelButtonOld)));
};

});
parcelRegister("jOdsB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ceaa73c399a515a$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $bbaTG = parcelRequire("bbaTG");

var $29yDk = parcelRequire("29yDk");

var $etCs9 = parcelRequire("etCs9");

var $XHGTv = parcelRequire("XHGTv");

var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");

var $PdmhA = parcelRequire("PdmhA");

var $kDL8j = parcelRequire("kDL8j");
function $2ceaa73c399a515a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2ceaa73c399a515a$var$rootStyles = {
    name: "ssyr0c",
    styles: "display:inline-block;max-width:100%;&:focus{outline:1px solid;}&:hover{[data-ds--inline-message--icon]{color:var(--icon-accent-color);}[data-ds--inline-message--button]{text-decoration:underline;}}"
};
const $2ceaa73c399a515a$var$iconColor = (appearance)=>{
    switch(appearance){
        case 'connectivity':
            return `var(--ds-icon-brand, ${0, $PdmhA.B300})`;
        case 'confirmation':
            return `var(--ds-icon-success, ${0, $PdmhA.G200})`;
        case 'info':
            return `var(--ds-icon-discovery, ${0, $PdmhA.P200})`;
        case 'warning':
            return `var(--ds-icon-warning, ${0, $PdmhA.Y200})`;
        case 'error':
            return `var(--ds-icon-danger, ${0, $PdmhA.R300})`;
    }
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $2ceaa73c399a515a$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', type: type = 'connectivity', appearance: appearance, children: children, testId: testId, iconLabel: iconLabel })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const toggleDialog = (0, $eUqFw.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $eUqFw.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    if (!appearance) appearance = type;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $2ceaa73c399a515a$var$rootStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            '--icon-accent-color': $2ceaa73c399a515a$var$iconColor(appearance)
        },
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $etCs9.UNSAFE_LAYERING), {
        isDisabled: (0, $XHGTv.getBooleanFF)('platform.design-system-team.inline-message-layering_wfp1p') ? !isOpen : true
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $29yDk.default), {
        onClose: onCloseDialog,
        content: children,
        isOpen: isOpen,
        placement: placement,
        testId: testId && `${testId}--inline-dialog`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bbaTG.default), {
        "data-ds--inline-message--button": true,
        appearance: "subtle-link",
        onClick: toggleDialog,
        spacing: "none",
        testId: testId && `${testId}--button`,
        "aria-expanded": isOpen
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kDL8j.default), {
        isOpen: isOpen,
        appearance: appearance,
        label: iconLabel
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.100"
    }, title && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        weight: "medium",
        testId: testId && `${testId}--title`
    }, title), secondaryText && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        weight: "medium",
        color: "color.text.subtlest",
        maxLines: 1,
        testId: testId && `${testId}--text`
    }, secondaryText)))))));
};
var $2ceaa73c399a515a$export$2e2bcd8739ae039 = $2ceaa73c399a515a$var$InlineMessage;

});
parcelRegister("kDL8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b39338dc4e2b071$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $kAPh5 = parcelRequire("kAPh5");
function $2b39338dc4e2b071$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2b39338dc4e2b071$var$iconColor = (appearance)=>{
    switch(appearance){
        case 'connectivity':
            return `var(--ds-icon-brand, ${0, $PdmhA.B400})`;
        case 'confirmation':
            return `var(--ds-icon-success, ${0, $PdmhA.G300})`;
        case 'info':
            return `var(--ds-icon-discovery, ${0, $PdmhA.P300})`;
        case 'warning':
            return `var(--ds-icon-warning, ${0, $PdmhA.Y300})`;
        case 'error':
            return `var(--ds-icon-danger, ${0, $PdmhA.R400})`;
    }
};
const $2b39338dc4e2b071$var$iconWrapperStyles = {
    name: "kw6wgo",
    styles: "display:flex;align-items:center;flex:0 0 auto;color:var(--icon-color)"
};
const $2b39338dc4e2b071$var$iconColorStyles = {
    name: "1iy94md",
    styles: "color:var(--icon-accent-color)"
};
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $2b39338dc4e2b071$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $kAPh5.typesMapping);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-ds--inline-message--icon": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            '--icon-color': $2b39338dc4e2b071$var$iconColor(appearance)
        },
        css: [
            $2b39338dc4e2b071$var$iconWrapperStyles,
            isOpen && $2b39338dc4e2b071$var$iconColorStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        size: "medium"
    }));
};
var $2b39338dc4e2b071$export$2e2bcd8739ae039 = $2b39338dc4e2b071$var$SelectedIcon;

});
parcelRegister("kAPh5", function(module, exports) {

$parcel$export(module.exports, "typesMapping", () => $6da7ad19346443c2$export$4d111645c0b39d5d);

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $5YsMl = parcelRequire("5YsMl");
const $6da7ad19346443c2$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($96IgR))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("hTaKC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3fd59906ae25f7f$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $e3fd59906ae25f7f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    retry: {
        "id": "issue.issue-line-card-retry",
        "defaultMessage": "Try again"
    },
    cancel: {
        "id": "issue.issue-line-card-cancel",
        "defaultMessage": "Cancel"
    }
});

});

parcelRegister("ltHKI", function(module, exports) {

$parcel$export(module.exports, "InlineMessageHeading", () => $d5169371a22a7a95$export$2289cf12c67e305b);
$parcel$export(module.exports, "InlineMessageText", () => $d5169371a22a7a95$export$db5af7e9da8d892a);
$parcel$export(module.exports, "InlineMessageButtonsWrapper", () => $d5169371a22a7a95$export$51bc55f292bc03f0);
$parcel$export(module.exports, "InlineMessageButtonPadding", () => $d5169371a22a7a95$export$5ae8d38b23be74d8);
$parcel$export(module.exports, "InlineMessageRightButtonPadding", () => $d5169371a22a7a95$export$42ac02b9749adfc3);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5169371a22a7a95$var$InlineMessageHeadingComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});
const $d5169371a22a7a95$export$2289cf12c67e305b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: "h1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5169371a22a7a95$var$InlineMessageHeadingComponent, props));
const $d5169371a22a7a95$export$db5af7e9da8d892a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});
const $d5169371a22a7a95$export$51bc55f292bc03f0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1y6m",
            __cmplp.className
        ])
    });
});
const $d5169371a22a7a95$export$5ae8d38b23be74d8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $d5169371a22a7a95$export$42ac02b9749adfc3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1wVY9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7296b911a731715$export$2e2bcd8739ae039);

var $grEPR = parcelRequire("grEPR");
var $e7296b911a731715$export$2e2bcd8739ae039 = (0, $grEPR.default);

});
parcelRegister("grEPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f7fb63df0b466fb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kIDby = parcelRequire("kIDby");

var $hJ992 = parcelRequire("hJ992");

var $a0FBb = parcelRequire("a0FBb");
const $9f7fb63df0b466fb$var$IssueLineCardWithHover = (props)=>{
    const { onEdit: onEdit, issueLink: issueLink, isDragging: isDragging = false, isRemote: isRemote } = props;
    const isFullIssueView = (0, $hJ992.useIsFullPageIssueView)();
    const isEmbedView = (0, $hJ992.useIsEmbedPageIssueView)();
    const isModal = (0, $hJ992.useIsModal)();
    const normalizedIssueLink = issueLink?.startsWith('/') ? `${window.location.protocol}//${window.location.hostname}${issueLink}` : issueLink;
    const reloadSmartLink = (0, $kIDby.useSmartLinkReload)({
        url: normalizedIssueLink || ''
    });
    /**
	 * Hiding preview when dragging because it obscures other items.
	 */ const shouldShowHoverPreview = !isDragging && !isRemote && (isFullIssueView || isModal || isEmbedView);
    const handleEdit = (0, $eUqFw.useCallback)((updatedFields)=>{
        if (onEdit) onEdit(updatedFields);
        if (shouldShowHoverPreview) reloadSmartLink();
    }, [
        onEdit,
        reloadSmartLink,
        shouldShowHoverPreview
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a0FBb.default), {
        ...props,
        onEdit: handleEdit,
        showHoverPreviewEnabled: shouldShowHoverPreview
    });
};
var $9f7fb63df0b466fb$export$2e2bcd8739ae039 = $9f7fb63df0b466fb$var$IssueLineCardWithHover;

});
parcelRegister("kIDby", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkReload", () => $f1565018d89fd81f$export$a2e9b4862ddcda9d);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $7o9uG = parcelRequire("7o9uG");

var $kxPGe = parcelRequire("kxPGe");
function $f1565018d89fd81f$export$a2e9b4862ddcda9d({ url: url, analyticsHandler: analyticsHandler }) {
    const id = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hompL)))(), []);
    const linkAnalytics = (0, $kxPGe.useSmartLinkAnalytics)(url, analyticsHandler, id);
    const linkActions = (0, $7o9uG.useSmartCardActions)(id, url, linkAnalytics);
    return linkActions.reload;
}

});

parcelRegister("a0FBb", function(module, exports) {

$parcel$export(module.exports, "default", () => $571f02d8d51097ab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $8Qd0L = parcelRequire("8Qd0L");

var $c9TLT = parcelRequire("c9TLT");

var $k2YJN = parcelRequire("k2YJN");

var $6rkLV = parcelRequire("6rkLV");

var $9jNcP = parcelRequire("9jNcP");

var $lO4Or = parcelRequire("lO4Or");

var $yyqSx = parcelRequire("yyqSx");

var $ac4LI = parcelRequire("ac4LI");

var $8Mamx = parcelRequire("8Mamx");
var $9MbFj = parcelRequire("9MbFj");

var $jGWLi = parcelRequire("jGWLi");

var $f3LuK = parcelRequire("f3LuK");

var $fbGz1 = parcelRequire("fbGz1");

var $98vOP = parcelRequire("98vOP");

var $aWMJA = parcelRequire("aWMJA");

var $hSTXl = parcelRequire("hSTXl");

var $9eJsf = parcelRequire("9eJsf");

var $4pk7m = parcelRequire("4pk7m");

var $efAF9 = parcelRequire("efAF9");

var $11skS = parcelRequire("11skS");
const { statusCategoryForId: $571f02d8d51097ab$var$statusCategoryForId } = (0, $8Qd0L);
const $571f02d8d51097ab$var$testIdSelectors = {
    card: 'issue-line-card.card-container'
};
const $571f02d8d51097ab$var$IssueLineCard = /*#__PURE__*/ (0, $eUqFw.memo)(({ additionalItems: additionalItems, assigneeDisplayName: assigneeDisplayName, assigneeUrl: assigneeUrl, canRemove: canRemove = true, errorInlineMessage: errorInlineMessage, estimateFieldId: estimateFieldId, globalId: globalId, hasError: hasError = false, id: id, isActive: isActive = false, isDraggable: isDraggable = false, isFocused: isFocused = false, isHovering: isHovering = false, isInlineEditEnabled: isInlineEditEnabled = false, isInteractive: isInteractive = true, isLoading: isLoading = false, isRemote: isRemote = false, isResolved: isResolved, issueKey: issueKey, issueLink: issueLink, issuePriorityName: issuePriorityName, issuePriorityUrl: issuePriorityUrl, issueSummary: issueSummary, issueTypeIconUrl: issueTypeIconUrl, issueTypeIcon: issueTypeIcon, issueTypeName: issueTypeName, onDelete: onDelete = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onEdit: onEdit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onHandleUserClickAnalytics: onHandleUserClickAnalytics, projectType: projectType, remoteServerHostname: remoteServerHostname, reorderMenu: reorderMenu, restrictedReorderingMessage: restrictedReorderingMessage = '', shouldDisplayDevOpsData: shouldDisplayDevOpsData = false, showHoverPreviewEnabled: showHoverPreviewEnabled = false, statusCategory: statusCategory, statusCategoryId: statusCategoryId, statusId: statusId, statusName: statusName, subtitle: subtitle })=>{
    const [hasAssigneeFieldConfig] = (0, $6rkLV.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.ASSIGNEE_TYPE)
    });
    const [hasSummaryFieldConfig] = (0, $6rkLV.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.SUMMARY_TYPE)
    });
    const [hasStoryPointFieldConfig] = (0, $6rkLV.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: estimateFieldId || ''
    });
    const hoverTimeoutId = (0, $eUqFw.useRef)(null);
    const [hasHovered, setHasHovered] = (0, $eUqFw.useState)(false);
    const isActionVisible = !isActive && (isHovering || isFocused);
    const shouldShowRemoveAction = isActive || isHovering || isFocused;
    const handleEditSummary = (0, $eUqFw.useCallback)((summary)=>{
        onEdit({
            issueSummary: summary || undefined
        });
    }, [
        onEdit
    ]);
    const handleEditAssignee = (0, $eUqFw.useCallback)((assignee)=>{
        onEdit({
            assigneeDisplayName: assignee?.displayName,
            assigneeUrl: assignee?.avatarUrls?.['16x16']
        });
    }, [
        onEdit
    ]);
    const handleEditStatus = (0, $eUqFw.useCallback)((status)=>onEdit({
            statusId: status.id,
            statusName: status.name,
            statusCategory: $571f02d8d51097ab$var$statusCategoryForId(status.statusCategory.id),
            statusCategoryId: status.statusCategory.id
        }), [
        onEdit
    ]);
    const handleOnMouseEnter = (0, $eUqFw.useCallback)(()=>{
        if (hoverTimeoutId.current) // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(hoverTimeoutId.current);
        // delay rendering interactive elements to avoid unnecessary render when scrolling
        hoverTimeoutId.current = setTimeout(()=>{
            setHasHovered(true);
        }, 200);
    }, [
        setHasHovered
    ]);
    const handleOnMouseLeave = (0, $eUqFw.useCallback)(()=>{
        if (hoverTimeoutId.current) {
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(hoverTimeoutId.current);
            hoverTimeoutId.current = null;
            setHasHovered(false);
        }
    }, [
        setHasHovered
    ]);
    const handleOnFocus = (0, $eUqFw.useCallback)(()=>{
        setHasHovered(true);
    }, [
        setHasHovered
    ]);
    const canEditStoryPoint = isInlineEditEnabled && (hasStoryPointFieldConfig || hasHovered);
    const estimateComponent = estimateFieldId !== undefined && canEditStoryPoint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f3LuK.Estimate), {
        issueKey: issueKey,
        estimateFieldId: estimateFieldId
    }) : estimateFieldId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSTXl.ReadOnlyEstimate), {
        issueKey: issueKey,
        estimateFieldId: estimateFieldId
    });
    const card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($571f02d8d51097ab$var$Card, {
        isFocused: isFocused,
        isHovering: isHovering,
        onMouseEnter: handleOnMouseEnter,
        onMouseLeave: handleOnMouseLeave,
        onFocus: handleOnFocus,
        "data-testid": $571f02d8d51097ab$var$testIdSelectors.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNcP.IssueType), {
        issueTypeName: issueTypeName,
        issueTypeIconUrl: issueTypeIconUrl,
        issueTypeIcon: issueTypeIcon,
        isDraggable: isDraggable,
        isActionVisible: isActionVisible,
        restrictedReorderingMessage: restrictedReorderingMessage,
        onHandleUserClickAnalytics: onHandleUserClickAnalytics,
        reorderMenu: reorderMenu
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fbGz1.IssueKey), {
        issueKey: issueKey,
        issueLink: issueLink,
        hideTooltipOnMouseDown: isDraggable,
        remoteServerHostname: remoteServerHostname,
        statusCategory: statusCategory,
        showHoverPreviewEnabled: showHoverPreviewEnabled,
        isResolved: isResolved
    }), isInlineEditEnabled && (hasSummaryFieldConfig || hasHovered) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11skS.Summary), {
        issueKey: issueKey,
        onClick: onClick,
        issueLink: issueLink,
        onUpdate: handleEditSummary,
        showHoverPreviewEnabled: showHoverPreviewEnabled
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9eJsf.SummaryReadOnly), {
        onClick: onClick,
        value: issueSummary,
        isInlineEditEnabled: isInlineEditEnabled,
        issueLink: issueLink,
        showHoverPreviewEnabled: showHoverPreviewEnabled
    }), additionalItems?.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($571f02d8d51097ab$var$AdditionalItemWrapper, {
            "data-testid": "issue-line-card.ui.additional-item-wrapper",
            key: index
        }, item)), shouldDisplayDevOpsData && !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k2YJN.AsyncDeliverySummary), {
        issueId: id,
        zIndexForPopup: (0, $c9TLT.layers).modal
    }), issuePriorityUrl != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aWMJA.Priority), {
        issuePriorityUrl: issuePriorityUrl,
        issuePriorityName: issuePriorityName,
        hideTooltipOnMouseDown: isDraggable
    }), estimateComponent, isInlineEditEnabled && (hasAssigneeFieldConfig || hasHovered) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Mamx.InteractiveAssignee), {
        issueKey: issueKey,
        onUpdate: handleEditAssignee
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9MbFj.ReadOnlyAssignee), {
        assigneeDisplayName: assigneeDisplayName,
        assigneeUrl: assigneeUrl,
        hideTooltipOnMouseDown: isDraggable
    }), statusCategory !== undefined && statusName !== undefined && statusId !== undefined && statusCategoryId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $efAF9.Status), {
        hideTooltipOnMouseDown: isDraggable,
        isInteractive: isInteractive,
        isRemote: isRemote,
        issueKey: issueKey,
        projectType: projectType,
        statusCategoryId: statusCategoryId,
        statusId: statusId,
        statusName: statusName,
        onEditStatus: handleEditStatus
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $98vOP.LoadingSpinner), null), (hasError || errorInlineMessage) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jGWLi.Error), {
        errorInlineMessage: errorInlineMessage
    }), onDelete !== (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) && !isLoading && !hasError && canRemove && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4pk7m.RemoveButton), {
        issueKey: issueKey,
        isRemote: isRemote,
        shouldShowRemoveAction: shouldShowRemoveAction,
        globalId: globalId,
        onDelete: onDelete
    }));
    return subtitle != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($571f02d8d51097ab$var$MultiLineCardContainer, {
        "data-testid": "issue-line-card.ui.multi-line-card-container"
    }, card, subtitle) : card;
});
var $571f02d8d51097ab$export$2e2bcd8739ae039 = $571f02d8d51097ab$var$IssueLineCard;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $571f02d8d51097ab$var$Card = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $ac4LI.FlexContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $571f02d8d51097ab$var$AdditionalItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $ac4LI.FlexContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f31y44",
            __cmplp.className
        ])
    });
});
const $571f02d8d51097ab$var$MultiLineCardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $571f02d8d51097ab$var$Card, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2lx21bp4 _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $571f02d8d51097ab$export$7ed12d2a5241e393 = {
    Card: $571f02d8d51097ab$var$Card,
    AdditionalItemWrapper: $571f02d8d51097ab$var$AdditionalItemWrapper,
    MultiLineCardContainer: $571f02d8d51097ab$var$MultiLineCardContainer
};

});
parcelRegister("k2YJN", function(module, exports) {

$parcel$export(module.exports, "AsyncDeliverySummary", () => $d011301ec1ce4709$export$57089ad313ee0432);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $4S1E9 = parcelRequire("4S1E9");

var $9aFRj = parcelRequire("9aFRj");

const $d011301ec1ce4709$var$LazyDeliverySummary = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("Mj1Mq")).then((module)=>module.DeliverySummary), {
    moduleId: "./src/packages/issue/dev-ops-summary/src/ui/delivery-summary/index.tsx"
});
const $d011301ec1ce4709$export$57089ad313ee0432 = (props)=>{
    const onFail = (0, $9aFRj.useDevOpsSummaryExperienceFail)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4S1E9.ErrorBoundary), {
        fallback: "unmount",
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "delivery-summary",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d011301ec1ce4709$var$LazyDeliverySummary, props)));
};

});
parcelRegister("Mj1Mq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dgimr');
        const value = parcelRequire('fcCje');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dgimr").then(()=>parcelRequire('fcCje'));
}

});


parcelRegister("9jNcP", function(module, exports) {

$parcel$export(module.exports, "IssueType", () => $2b5e88f1c48d0c5e$export$dce4ecf18820e992);

var $eUqFw = parcelRequire("eUqFw");

var $dULIU = parcelRequire("dULIU");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $hnzPP = parcelRequire("hnzPP");

var $4ksts = parcelRequire("4ksts");

var $6UKxR = parcelRequire("6UKxR");

var $ePtuQ = parcelRequire("ePtuQ");
const $2b5e88f1c48d0c5e$export$dce4ecf18820e992 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueTypeName: issueTypeName, issueTypeIconUrl: issueTypeIconUrl, isDraggable: isDraggable, isActionVisible: isActionVisible, restrictedReorderingMessage: restrictedReorderingMessage, onHandleUserClickAnalytics: onHandleUserClickAnalytics, reorderMenu: reorderMenu, issueTypeIcon: issueTypeIcon })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const title = intl.formatMessage((0, $6UKxR.default).issueTypeTitle, {
        issueTypeName: issueTypeName
    });
    const hasValidRestrictedMessage = restrictedReorderingMessage !== '';
    const tooltipContent = issueTypeName || '';
    const action = reorderMenu || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dULIU))), {
        label: "",
        primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA.N300)})`
    });
    // Using an intermediate div(TypeIconContainer) since AKTooltip needs an element to bind to
    // We aren't wrapping just ListIcon or AsyncIcon since AKTooltip is stateful
    // and we don't want it to unmount as the mouseHover changes
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: !isDraggable && hasValidRestrictedMessage ? String(restrictedReorderingMessage) : tooltipContent,
        hideTooltipOnMouseDown: isDraggable,
        position: "top",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "issue-line-card.issue-type.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ePtuQ.TypeIconContainer), {
        onClick: ()=>onHandleUserClickAnalytics?.('typeIcon'),
        "data-testid": "issue-line-card-issue-type.issue-type",
        isActionVisible: isDraggable && isActionVisible,
        isRestricted: hasValidRestrictedMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ePtuQ.InnerIconContainer), null, issueTypeIcon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
        alt: title,
        url: issueTypeIconUrl
    })), isDraggable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ePtuQ.InnerActionContainer), null, action)));
});

});
parcelRegister("6UKxR", function(module, exports) {

$parcel$export(module.exports, "default", () => $25d5b1ca8c4ea3c1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $25d5b1ca8c4ea3c1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueTypeTitle: {
        "id": "issue-line-card-issue-type.issue-type-title",
        "defaultMessage": "Issue type: {issueTypeName}"
    }
});

});

parcelRegister("ePtuQ", function(module, exports) {

$parcel$export(module.exports, "TypeIconContainer", () => $8c1aa63402006a29$export$7c6a427e0041cef8);
$parcel$export(module.exports, "InnerIconContainer", () => $8c1aa63402006a29$export$50e7a20632ac4b91);
$parcel$export(module.exports, "InnerActionContainer", () => $8c1aa63402006a29$export$cef004ee3f680209);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gELY9 = parcelRequire("gELY9");
const $8c1aa63402006a29$export$f2a139e5d18b9882 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $gELY9.FlexContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80om1qgj",
            __cmplp.className
        ])
    });
});
const $8c1aa63402006a29$export$c41c6e4e73f730b7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $gELY9.FlexContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80om13gf _16l4105o",
            __cmplp.className
        ])
    });
});
const $8c1aa63402006a29$export$7c6a427e0041cef8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActionVisible: isActionVisible, isRestricted: isRestricted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _1e0c11p5 _1lmc1n2u _4cvr1h6o _6a6z1h6o _otawkb7n _a8tgkb7n",
            __cmplp.isActionVisible ? "_1telkb7n" : "_1telidpf",
            __cmplp.isRestricted && "_80om13gf _16l4105o",
            __cmplp.className
        ])
    });
});
const $8c1aa63402006a29$export$50e7a20632ac4b91 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_nd5l1n2u _1e0c116y _tzy41y4k _lcxvglyw",
            __cmplp.className
        ])
    });
});
const $8c1aa63402006a29$export$cef004ee3f680209 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_nd5l1n2u _1e0c116y _4cvr1h6o _1bah1h6o _tzy41aa5",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gELY9", function(module, exports) {

$parcel$export(module.exports, "FlexContainer", () => $92613433e8effc89$export$124d4c7bf7db9715);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $92613433e8effc89$export$124d4c7bf7db9715 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $92613433e8effc89$export$6ca3a7bb21565c7a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $92613433e8effc89$export$124d4c7bf7db9715, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bvftgi",
            __cmplp.className
        ])
    });
});

});



parcelRegister("ac4LI", function(module, exports) {

$parcel$export(module.exports, "FlexContainer", () => $949855bfe9edea00$export$124d4c7bf7db9715);
$parcel$export(module.exports, "PaddedFlexContainer", () => $949855bfe9edea00$export$6ca3a7bb21565c7a);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $949855bfe9edea00$export$124d4c7bf7db9715 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $949855bfe9edea00$export$6ca3a7bb21565c7a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $949855bfe9edea00$export$124d4c7bf7db9715, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bv1b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8Mamx", function(module, exports) {

$parcel$export(module.exports, "InteractiveAssignee", () => $36187964a988e0f3$export$2546f68de581f3ef);

var $eUqFw = parcelRequire("eUqFw");

var $44OBN = parcelRequire("44OBN");

var $ac4LI = parcelRequire("ac4LI");

var $eS0Iq = parcelRequire("eS0Iq");
const $36187964a988e0f3$export$2546f68de581f3ef = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, onUpdate: onUpdate })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ac4LI.PaddedFlexContainer), {
        role: "button",
        onClick: (0, $eS0Iq.preventDefault),
        onFocus: (0, $eS0Iq.stopPropagation)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $44OBN.default), {
        issueKey: issueKey,
        onUpdate: onUpdate
    })));

});
parcelRegister("44OBN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $039e754c77d59929$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dWGNJ = parcelRequire("dWGNJ");

var $8411R = parcelRequire("8411R");

var $g8JvH = parcelRequire("g8JvH");


var $2F5m4 = parcelRequire("2F5m4");

var $dnK1q = parcelRequire("dnK1q");

var $jiyBi = parcelRequire("jiyBi");

var $be89W = parcelRequire("be89W");
const $039e754c77d59929$var$AssigneePickerEditWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('assigneePickerEdit', {
    onChange: 'changed'
})((0, $jiyBi.default));
const $039e754c77d59929$var$AssigneeField = ({ issueKey: issueKey, onChange: onChange, onUpdate: onUpdate, onFailure: onFailure, onSubmit: onSubmit, ...rest })=>{
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, (0, $ebc098a76317be78$export$e18419056f3d184a));
    const [{ value: value, error: error }, { saveValue: saveValue }] = (0, $dnK1q.default)({
        issueKey: issueKey,
        onSuccess: onUpdate,
        onFailure: onFailure,
        onSubmit: onSubmit
    });
    const { autoCompleteUrl: autoCompleteUrl, isEditable: isEditable = false } = fieldConfig || {};
    const handleOnChange = (0, $eUqFw.useCallback)((updatedValue, action, analyticsEvent)=>{
        onChange?.(updatedValue, action);
        saveValue(updatedValue, null, analyticsEvent);
    }, [
        onChange,
        saveValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: error,
        title: (0, $be89W.default).errorTitle,
        description: (0, $be89W.default).errorMessage
    }), isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($039e754c77d59929$var$AssigneePickerEditWithAnalytics, {
        autoCompleteUrl: autoCompleteUrl,
        value: value,
        // @ts-expect-error - TS2322 - Type '(updatedValue: UserValue, action: ActionTypes, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type '((updatedValue: UserValue, action?: ActionTypes | undefined) => void) & ((updatedValue: UserValue, action: ActionTypes, analyticsEvent: UIAnalyticsEventInterface) => void)'.
        onChange: handleOnChange,
        ...rest
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2F5m4.AssigneePickerView), {
        value: value
    }));
};
var $039e754c77d59929$export$2e2bcd8739ae039 = $039e754c77d59929$var$AssigneeField;

});
parcelRegister("2F5m4", function(module, exports) {

$parcel$export(module.exports, "AssigneePickerView", () => $c90269d4d7f5a9b6$export$7df43f1214c1ab94);
$parcel$export(module.exports, "AvatarWrapper", () => $c90269d4d7f5a9b6$export$f7513421c53ce141);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $8cU5f = parcelRequire("8cU5f");

var $4ksts = parcelRequire("4ksts");


var $6cPKE = parcelRequire("6cPKE");

var $lOBpe = parcelRequire("lOBpe");
const $c90269d4d7f5a9b6$export$7df43f1214c1ab94 = ({ value: value })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const unassigned = (0, $6cPKE.getUnassignedUser)(intl);
    const user = value || unassigned;
    const assigneeName = user.accountId === (0, $7a4a7348bcf111f0$export$bdab9bfb39981463) ? user.displayName : intl.formatMessage((0, $lOBpe.default).assigneeTooltip, {
        name: user.displayName
    });
    const avatarUrl = (0, $6cPKE.getUserAvatarUrl)(user);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c90269d4d7f5a9b6$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: assigneeName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        testId: "issue-field-assignee.common.ui.read-view.popover.avatar",
        size: "small",
        src: avatarUrl,
        name: assigneeName,
        borderColor: "transparent"
    })));
};
var $c90269d4d7f5a9b6$export$2e2bcd8739ae039 // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $c90269d4d7f5a9b6$export$7df43f1214c1ab94;
const $c90269d4d7f5a9b6$export$f7513421c53ce141 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1f4h _4t3i1f4h _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _80om73ad",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6cPKE", function(module, exports) {

$parcel$export(module.exports, "getUnassignedUser", () => $c06f6916b7f49c06$export$42c5a0b65ef9ee80);
$parcel$export(module.exports, "getAutomaticUserOption", () => $c06f6916b7f49c06$export$8d7a63500893c8c);
$parcel$export(module.exports, "getInvitePeopleOption", () => $c06f6916b7f49c06$export$84a82764cf0a696e);
$parcel$export(module.exports, "getUserOptionFromUser", () => $c06f6916b7f49c06$export$16086438354dcc85);
$parcel$export(module.exports, "getUserFromUserOption", () => $c06f6916b7f49c06$export$78a8bcc5bd21caa2);
$parcel$export(module.exports, "getUserAvatarUrl", () => $c06f6916b7f49c06$export$7d801d84202c7743);
$parcel$export(module.exports, "getUserShape", () => $c06f6916b7f49c06$export$322b6ab8c29a006e);

var $51p9V = parcelRequire("51p9V");

var $43MEA = parcelRequire("43MEA");

const $c06f6916b7f49c06$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>({
        accountId: (0, $7a4a7348bcf111f0$export$bdab9bfb39981463),
        displayName: formatMessage((0, $51p9V.default).unassignedOption),
        avatarUrls: {}
    });
const $c06f6916b7f49c06$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
        accountId: (0, $7a4a7348bcf111f0$export$f5d5f6bb902f1027),
        displayName: formatMessage((0, $51p9V.default).automaticOption),
        avatarUrls: {}
    });
const $c06f6916b7f49c06$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
        accountId: (0, $7a4a7348bcf111f0$export$d875316cb0cd94f7),
        displayName: formatMessage(isAdmin ? (0, $51p9V.default).invitePeopleOptionAdmin : (0, $51p9V.default).invitePeopleOption),
        avatarUrls: {
            '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($43MEA)))
        }
    });
const $c06f6916b7f49c06$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
        id: accountId || '',
        name: displayName,
        avatarUrl: avatarUrls['48x48'],
        // @ts-expect-error Will be part of JIV-13488; `user.emailAddress` returned by the REST API can be null depending on their privacy settings
        byline: emailAddress
    });
const $c06f6916b7f49c06$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        accountId: id,
        displayName: name,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });
const $c06f6916b7f49c06$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
const $c06f6916b7f49c06$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });

});
parcelRegister("43MEA", function(module, exports) {
module.exports = new URL("add.6dea82c4.png", import.meta.url).toString();

});


parcelRegister("lOBpe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb938cefd9e1b7a1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fb938cefd9e1b7a1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    assigneeTooltip: {
        "id": "issue-field-assignee.common.read-view.popover.assignee-tooltip",
        "defaultMessage": "Assignee: {name}"
    }
});

});


parcelRegister("jiyBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $35e07f6ef957559b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $dxIU5 = parcelRequire("dxIU5");

var $PdmhA = parcelRequire("PdmhA");

var $1gejj = parcelRequire("1gejj");

var $4ksts = parcelRequire("4ksts");


var $hiBi9 = parcelRequire("hiBi9");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");


var $2F5m4 = parcelRequire("2F5m4");

var $6cPKE = parcelRequire("6cPKE");

var $b5qOz = parcelRequire("b5qOz");

var $51p9V = parcelRequire("51p9V");

var $dRJbT = parcelRequire("dRJbT");

var $aE92Z = parcelRequire("aE92Z");
const $35e07f6ef957559b$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
const $35e07f6ef957559b$var$ACTION_SUBJECT = 'assigneePicker';
const $35e07f6ef957559b$var$AssigneeFieldOptionsLoadExperience = new (0, $kDfSL.UFOExperience)('assignee-picker.field-options-load', {
    type: (0, $12kyE.ExperienceTypes).Operation,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'assignee-picker.field-options-load'
});
const $35e07f6ef957559b$var$AssigneePickerEdit = ({ actionSubject: actionSubject, shouldPreloadAssignToMe: shouldPreloadAssignToMe = false, autoCompleteUrl: autoCompleteUrl, value: value = null, onFocus: onFocus, onBlur: onBlur, onChange: onChange, searchDebounceTimeout: searchDebounceTimeout = $35e07f6ef957559b$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, enablePeopleInvite: enablePeopleInvite = true, popupPlacement: popupPlacement = 'auto', isEligibleForInviteAndAssign: isEligibleForInviteAndAssign, suggestedEmailDomain: suggestedEmailDomain, onInviteAndAssignOption: onInviteAndAssignOption, onOpen: onOpen, onClose: onClose })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const self = (0, $eUqFw.useRef)({
        previousQuery: undefined
    }).current;
    const [{ data: users, loading: loading, error: error }, fetchUsers] = (0, $aE92Z.default)(autoCompleteUrl || '');
    const [assigneeValue, assigneeOptions] = (0, $dRJbT.useAssigneeOptions)(value, users, intl, shouldPreloadAssignToMe, self.previousQuery, enablePeopleInvite, true, suggestedEmailDomain, isEligibleForInviteAndAssign);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { openDrawer: openDrawer }] = (0, $hiBi9.useInvitePeopleDrawer)();
    (0, $eUqFw.useEffect)(()=>{
        if (loading) {
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: actionSubject ?? $35e07f6ef957559b$var$ACTION_SUBJECT,
                action: 'loading'
            }), 'assigneeOptions loading');
            $35e07f6ef957559b$var$AssigneeFieldOptionsLoadExperience.start();
        }
        if (error) {
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: actionSubject ?? $35e07f6ef957559b$var$ACTION_SUBJECT,
                action: 'failed'
            }), 'assigneeOptions failed');
            $35e07f6ef957559b$var$AssigneeFieldOptionsLoadExperience.failure();
        }
        if (users.length) {
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: actionSubject ?? $35e07f6ef957559b$var$ACTION_SUBJECT,
                action: 'loaded'
            }), 'assigneeOptions loaded');
            $35e07f6ef957559b$var$AssigneeFieldOptionsLoadExperience.success();
        }
    }, [
        loading,
        error,
        users,
        createAnalyticsEvent,
        actionSubject
    ]);
    const handleSearch = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((query)=>{
            query !== self.previousQuery && fetchUsers(query);
            self.previousQuery = query;
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: actionSubject ?? $35e07f6ef957559b$var$ACTION_SUBJECT,
                action: 'searched'
            }));
        }, searchDebounceTimeout), // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        fetchUsers,
        searchDebounceTimeout,
        self.previousQuery
    ]);
    const handleOnFocus = (0, $eUqFw.useCallback)((sessionId)=>{
        onFocus?.(sessionId);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: actionSubject ?? $35e07f6ef957559b$var$ACTION_SUBJECT,
            action: 'focused'
        }));
        if (!users || !users.length) fetchUsers();
    }, [
        onFocus,
        users,
        createAnalyticsEvent,
        actionSubject,
        fetchUsers
    ]);
    const handleOnBlur = (0, $eUqFw.useCallback)((sessionId)=>{
        onBlur?.(sessionId);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: actionSubject ?? $35e07f6ef957559b$var$ACTION_SUBJECT,
            action: 'blurred'
        }));
        self.previousQuery = undefined;
    }, [
        actionSubject,
        createAnalyticsEvent,
        onBlur,
        self
    ]);
    const handleOnChange = (0, $eUqFw.useCallback)((updatedValue, action)=>{
        if (!updatedValue || Array.isArray(updatedValue)) return;
        if (isEligibleForInviteAndAssign && updatedValue.id === (0, $1199e142050a1a33$export$898547b9297d1a3a)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            onInviteAndAssignOption?.(updatedValue, action);
            return;
        }
        if ((0, $b5qOz.isInviteFromAssignEnabled)() && enablePeopleInvite && updatedValue.id === (0, $7a4a7348bcf111f0$export$d875316cb0cd94f7)) {
            openDrawer(createAnalyticsEvent ?? null, {
                inviteFlow: 'assignee'
            });
            onChange?.(value, action);
            return;
        }
        const newValue = updatedValue.id === (0, $7a4a7348bcf111f0$export$bdab9bfb39981463) ? null : users.find(({ accountId: accountId })=>accountId === updatedValue.id) || (0, $6cPKE.getUserFromUserOption)(updatedValue);
        onChange?.(newValue, action);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: actionSubject ?? $35e07f6ef957559b$var$ACTION_SUBJECT,
            action: 'changed'
        }));
    }, [
        isEligibleForInviteAndAssign,
        enablePeopleInvite,
        users,
        onChange,
        createAnalyticsEvent,
        actionSubject,
        onInviteAndAssignOption,
        openDrawer,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1gejj.PopupUserPicker), {
        fieldId: null,
        placeholder: intl.formatMessage((0, $51p9V.default).searchForAssignee),
        isLoading: loading,
        options: assigneeOptions,
        target: ({ ref: ref, isOpen: isOpen })=>/*
                  onClick is being used here as a workaround. onOpen should be being passed to the PopupUserPicker
                  but there is a bug with the atlaskit component, where the onOpen function is being called when the
                  popup is closed.
              */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35e07f6ef957559b$var$AvatarButton, {
                innerRef: ref,
                active: isOpen,
                onClick: onOpen
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2F5m4.AssigneePickerView), {
                value: value
            })),
        value: assigneeValue,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        onChange: handleOnChange,
        onInputChange: handleSearch,
        placement: popupPlacement,
        onClose: onClose
    });
};
var $35e07f6ef957559b$export$2e2bcd8739ae039 = $35e07f6ef957559b$var$AssigneePickerEdit;
// color taken from the old AK avatar component where hover over effect is still supported (without dummy href or onClick)
const $35e07f6ef957559b$var$AVATAR_SHADE_COLOR = 'rgba(9, 30, 66, 0.36)'; // This variable is only used as a fallback to a token so there is no need to convert it to a token
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $35e07f6ef957559b$var$AvatarButton = /*#__PURE__*/ (0, $kwce8.default).button.withConfig({
    componentId: "sc-1nlgjye-0"
})((props)=>({
        /* button css reset */ display: 'block',
        background: 'transparent',
        border: 0,
        outline: 0,
        padding: 0,
        margin: 0,
        borderRadius: '50%',
        boxShadow: '0 0 0 2px transparent',
        '& > div': {
            cursor: 'pointer'
        },
        'span:first-of-type::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            opacity: props.active ? 1 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: props.active ? `var(--ds-interaction-pressed, ${$35e07f6ef957559b$var$AVATAR_SHADE_COLOR})` : 'transparent'
        },
        '&:active': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: '0 0 0 2px transparent !important'
        },
        '&:focus, &:focus-within': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $PdmhA).B200})`}`
        },
        '&:hover span:first-of-type::after': {
            opacity: 1,
            backgroundColor: `var(--ds-interaction-hovered, ${$35e07f6ef957559b$var$AVATAR_SHADE_COLOR})`
        }
    }));

});
parcelRegister("1gejj", function(module, exports) {

$parcel$export(module.exports, "PopupUserPicker", () => $0eb262d4ae951d98$export$3687c7ed123b6b2b);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $2jDha = parcelRequire("2jDha");

var $4IBr3 = parcelRequire("4IBr3");

var $eUqFw = parcelRequire("eUqFw");

var $cSqUf = parcelRequire("cSqUf");

var $9KdAH = parcelRequire("9KdAH");

var $4GoxG = parcelRequire("4GoxG");

var $5YsND = parcelRequire("5YsND");
class $0eb262d4ae951d98$export$c87d8f24e24a8ae2 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            flipped: false
        });
        (0, $5zQU9.default)(this, "handleFlipStyle", (data)=>{
            const { flipped: flipped, styles: { transform: transform }, popper: { height: height } } = data;
            this.setState({
                flipped: flipped
            });
            if (!flipped) return data;
            data.styles.transform = transform + `translate(0, ${height}px) translate(0, -100%)`;
            return data;
        });
    }
    render() {
        const { target: target, popupTitle: popupTitle, boundariesElement: boundariesElement, isMulti: isMulti, offset: offset, placement: placement, rootBoundary: rootBoundary, shouldFlip: shouldFlip, styles: styles } = this.props;
        const width = this.props.width;
        const selectStyles = (0, $9KdAH.getPopupStyles)(width, isMulti, styles);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5YsND.BaseUserPickerWithoutAnalytics), (0, $kU09D.default)({}, this.props, {
            SelectComponent: (0, $4IBr3.default),
            width: width,
            styles: selectStyles,
            components: (0, $cSqUf.getPopupComponents)(!!popupTitle),
            pickerProps: (0, $4GoxG.getPopupProps)(width, target, this.handleFlipStyle, boundariesElement, offset, placement, rootBoundary, shouldFlip, popupTitle)
        }));
    }
}
(0, $5zQU9.default)($0eb262d4ae951d98$export$c87d8f24e24a8ae2, "defaultProps", {
    boundariesElement: 'viewport',
    width: 300,
    isMulti: false,
    offset: [
        0,
        0
    ],
    placement: 'auto',
    rootBoundary: 'viewport',
    shouldFlip: true
});
const $0eb262d4ae951d98$export$3687c7ed123b6b2b = (0, $2jDha.default)()($0eb262d4ae951d98$export$c87d8f24e24a8ae2);

});
parcelRegister("4GoxG", function(module, exports) {

$parcel$export(module.exports, "getPopupProps", () => $368e1f43f5d687c4$export$4adcaee797a284b3);

var $5iWql = parcelRequire("5iWql");
const $368e1f43f5d687c4$export$4adcaee797a284b3 = (0, $5iWql.default)((width, target, onFlip, boundariesElement, offset, placement, rootBoundary, shouldFlip, popupTitle)=>({
        searchThreshold: -1,
        controlShouldRenderValue: true,
        minMenuWidth: width,
        maxMenuWidth: width,
        autoFocus: false,
        target: target,
        popupTitle: popupTitle,
        popperProps: {
            placement: placement || 'auto',
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: offset
                    }
                },
                {
                    name: 'handleFlipStyle',
                    enabled: true,
                    order: 910,
                    fn: (data)=>onFlip(data)
                },
                {
                    name: 'preventOverflow',
                    options: {
                        rootBoundary: rootBoundary,
                        boundary: boundariesElement
                    }
                },
                {
                    name: 'flip',
                    enabled: shouldFlip
                }
            ]
        }
    }));

});


parcelRegister("b5qOz", function(module, exports) {

$parcel$export(module.exports, "INVITE_FROM_ASSIGN", () => $2ebcd2dcd5becbb5$export$d304132d091ca1ac);
$parcel$export(module.exports, "getInviteFromAssignCohort", () => $2ebcd2dcd5becbb5$export$dfa2a595c2323732);
$parcel$export(module.exports, "isInviteFromAssignEnabled", () => $2ebcd2dcd5becbb5$export$cdd5c612352d7bf0);
/**
 * Feature flags convention: go/frontend-feature-flags. Please ensure integration tests are still working afterwards.
 */ 
var $1Iui1 = parcelRequire("1Iui1");

var $1ybV0 = parcelRequire("1ybV0");
const $2ebcd2dcd5becbb5$export$d304132d091ca1ac = 'invite.from.assign';
const $2ebcd2dcd5becbb5$export$dfa2a595c2323732 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)($2ebcd2dcd5becbb5$export$d304132d091ca1ac, (0, $1Iui1.NOT_ENROLLED), [
        (0, $1Iui1.NOT_ENROLLED),
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.VARIATION)
    ]);
const $2ebcd2dcd5becbb5$export$cdd5c612352d7bf0 = ()=>$2ebcd2dcd5becbb5$export$dfa2a595c2323732() === (0, $1Iui1.VARIATION);

});

parcelRegister("dRJbT", function(module, exports) {

$parcel$export(module.exports, "useAssigneeOptions", () => $256397ae5b7d05ee$export$1eb7ccf9fc55d2e8);

var $eUqFw = parcelRequire("eUqFw");

var $9ZJqc = parcelRequire("9ZJqc");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $c7H0g = parcelRequire("c7H0g");

var $lGLse = parcelRequire("lGLse");


var $6cPKE = parcelRequire("6cPKE");

var $b5qOz = parcelRequire("b5qOz");

var $51p9V = parcelRequire("51p9V");
const $256397ae5b7d05ee$var$fireInviteFromAssignExposureEvent = (createAnalyticsEvent, suggestionsCount, isAdmin)=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'exposed';
    const actionSubject = 'feature';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: 'assignee',
        flagKey: (0, $b5qOz.INVITE_FROM_ASSIGN),
        value: (0, $b5qOz.getInviteFromAssignCohort)(),
        userRole: isAdmin ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField'
    };
    (0, $jMP2a.fireOperationalAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
const $256397ae5b7d05ee$var$fireInviteItemRendererEvent = (createAnalyticsEvent, suggestionsCount, isAdmin, isInviteAndAssignFromBoard = false)=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'rendered';
    const actionSubject = 'inviteItem';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: 'assignee',
        userRole: isAdmin ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField',
        ...isInviteAndAssignFromBoard && {
            isInviteAndAssignFromBoard: true
        }
    };
    (0, $jMP2a.fireUIAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
const $256397ae5b7d05ee$export$1eb7ccf9fc55d2e8 = (value, users, intl, shouldPreloadAssignToMe, search, enablePeopleInvite, enableAutomaticOption, suggestedEmailDomain, isEligibleForInviteAndAssign)=>{
    const [exposureEventTriggered, setExposureEventTriggered] = (0, $eUqFw.useState)(false);
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const unassigned = (0, $6cPKE.getUnassignedUser)(intl);
    const automaticOption = (0, $6cPKE.getAutomaticUserOption)(intl);
    const valueOption = (0, $6cPKE.getUserOptionFromUser)(value || unassigned);
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const loggedInUserOption = loggedInUser ? {
        ...(0, $6cPKE.getUserOptionFromUser)(loggedInUser),
        publicName: intl.formatMessage((0, $51p9V.default).assignToMe)
    } : null;
    const isInvalidSearch = search === undefined || search === '';
    // show unassigned option if value is defined and no search or unassigned display name match the search
    const showUnassigned = isInvalidSearch ? Boolean(value?.accountId) : unassigned.displayName.toLowerCase().startsWith((search || '').toLowerCase());
    let showAutomaticOption = false;
    if (enableAutomaticOption === true) showAutomaticOption = isInvalidSearch ? Boolean(value?.accountId !== (0, $7a4a7348bcf111f0$export$f5d5f6bb902f1027)) : automaticOption.displayName.toLowerCase().startsWith((search || '').toLowerCase());
    const isLoggedInUserCurrentValue = loggedInUserOption !== null && valueOption.id === loggedInUserOption.id;
    const isLoggedInUserMatchSearch = users.some((user)=>loggedInUserOption !== null && user.accountId === loggedInUserOption.id);
    const showAssignToMeOnInit = !isLoggedInUserCurrentValue && (shouldPreloadAssignToMe || isLoggedInUserMatchSearch);
    const showAssignToMe = isInvalidSearch ? showAssignToMeOnInit : isLoggedInUserMatchSearch;
    const userOptions = users.filter((user)=>// remove selected user (value) from users list when search is not defined
        (!isInvalidSearch || user.accountId !== valueOption.id) && // remove logged in user (is already added in 2nd position above)
        !(loggedInUserOption !== null && user.accountId === loggedInUserOption.id)).map((0, $6cPKE.getUserOptionFromUser));
    const invitePeopleOptions = [];
    if (enablePeopleInvite === true && !isInvalidSearch && userOptions.length < 3) {
        if (!exposureEventTriggered) {
            setExposureEventTriggered(true);
            $256397ae5b7d05ee$var$fireInviteFromAssignExposureEvent(createAnalyticsEvent, userOptions.length, isAdmin);
        }
        if (isEligibleForInviteAndAssign) {
            invitePeopleOptions.push((0, $9ZJqc.getInviteAndAssignPeopleOption)(intl.formatMessage, search, suggestedEmailDomain));
            $256397ae5b7d05ee$var$fireInviteItemRendererEvent(createAnalyticsEvent, userOptions.length, isAdmin, true);
        } else if ((0, $b5qOz.isInviteFromAssignEnabled)()) {
            $256397ae5b7d05ee$var$fireInviteItemRendererEvent(createAnalyticsEvent, userOptions.length, isAdmin);
            invitePeopleOptions.push((0, $6cPKE.getUserOptionFromUser)((0, $6cPKE.getInvitePeopleOption)(intl, isAdmin)));
        }
    }
    const options = [
        ...showUnassigned ? [
            (0, $6cPKE.getUserOptionFromUser)(unassigned)
        ] : [],
        ...showAutomaticOption ? [
            (0, $6cPKE.getUserOptionFromUser)(automaticOption)
        ] : [],
        ...showAssignToMe && loggedInUserOption !== null ? [
            loggedInUserOption
        ] : [],
        ...userOptions,
        ...invitePeopleOptions
    ];
    return [
        valueOption,
        options
    ];
};

});

parcelRegister("aE92Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $49c15bb5f3c640bd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
const $49c15bb5f3c640bd$var$useUsersQuery = (autoCompleteUrl)=>{
    const [users, setUsers] = (0, $eUqFw.useState)([]);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const currentQuery = (0, $eUqFw.useRef)('');
    const fetchUsers = (0, $eUqFw.useCallback)(// @ts-expect-error - TS2345 - Argument of type '(query?: string | undefined) => Promise<void> | Promise<never[]>' is not assignable to parameter of type 'FetchUsers'.
    (query = '')=>{
        if ([
            '',
            null,
            undefined
        ].includes(autoCompleteUrl)) return Promise.resolve([]);
        const usersFetchUrl = `${autoCompleteUrl || ''}${query}`;
        setLoading(true);
        currentQuery.current = query;
        if (error) setError(undefined);
        return (0, $2OdyW.default)(usersFetchUrl).then((response)=>{
            if (query === currentQuery.current) setUsers(response);
        }).catch((err)=>{
            if (query === currentQuery.current) setError(err);
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.assigne', 'Failed to fetch users', err);
        }).finally(()=>setLoading(false));
    }, [
        autoCompleteUrl,
        error
    ]);
    return [
        {
            data: users,
            error: error,
            loading: loading
        },
        fetchUsers
    ];
};
var $49c15bb5f3c640bd$export$2e2bcd8739ae039 = $49c15bb5f3c640bd$var$useUsersQuery;

});


parcelRegister("be89W", function(module, exports) {

$parcel$export(module.exports, "default", () => $580e4121e86e5a57$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$580e4121e86e5a57$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "issue-field-assignee.popover.error-title",
        "defaultMessage": "We couldn't update the assignee"
    },
    errorMessage: {
        "id": "issue-field-assignee.popover.error-message",
        "defaultMessage": "You can try again in a few minutes, or refresh the page."
    }
});

});


parcelRegister("eS0Iq", function(module, exports) {

$parcel$export(module.exports, "preventDefault", () => $db6ce44a0b67f858$export$fa3b29edae795ef4);
$parcel$export(module.exports, "stopPropagation", () => $db6ce44a0b67f858$export$51134cce184326b9);
$parcel$export(module.exports, "isLeftClickOnly", () => $db6ce44a0b67f858$export$27f1841767effbd2);
$parcel$export(module.exports, "shouldDisplayStrikethrough", () => $db6ce44a0b67f858$export$1e1e848245d3a6f7);

var $8Qd0L = parcelRequire("8Qd0L");
const $db6ce44a0b67f858$export$fa3b29edae795ef4 = (e)=>e.preventDefault();
const $db6ce44a0b67f858$export$51134cce184326b9 = (e)=>e.stopPropagation();
const $db6ce44a0b67f858$var$isLeftClick = (event)=>event.button === 0;
const $db6ce44a0b67f858$export$27f1841767effbd2 = (event)=>$db6ce44a0b67f858$var$isLeftClick(event) && !(event.metaKey || event.ctrlKey);
const { DONE: $db6ce44a0b67f858$var$DONE } = (0, $8Qd0L);
const $db6ce44a0b67f858$export$1e1e848245d3a6f7 = (isResolved, statusCategory)=>{
    if (isResolved !== undefined) return isResolved;
    // In JSW, the strikethrough must now only depend on resolution. However we have to keep
    // this logic because there is a consumer of issue-line-card in JSM that displays
    // the strikethrough based on status src/packages/servicedesk/post-incident-review/src/ui/primary-incident/index.tsx
    return statusCategory === $db6ce44a0b67f858$var$DONE;
};

});


parcelRegister("9MbFj", function(module, exports) {

$parcel$export(module.exports, "ReadOnlyAssignee", () => $62b5d9a2f1dc7e2b$export$e8baec2ba80d601d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $8cU5f = parcelRequire("8cU5f");

var $ac4LI = parcelRequire("ac4LI");
const $62b5d9a2f1dc7e2b$export$e8baec2ba80d601d = /*#__PURE__*/ (0, $eUqFw.memo)(({ assigneeUrl: assigneeUrl, assigneeDisplayName: assigneeDisplayName, hideTooltipOnMouseDown: hideTooltipOnMouseDown })=>// We are disabling tooltip in AK Avatar, to use this instance
    // of AKTooltip since it is a stateful component.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ac4LI.PaddedFlexContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62b5d9a2f1dc7e2b$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: assigneeDisplayName || '',
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        name: assigneeDisplayName || '',
        src: assigneeUrl || '',
        size: "small",
        testId: "issue-line-card.ui.assignee.read-only-assignee"
    })))));
const $62b5d9a2f1dc7e2b$export$f7513421c53ce141 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1f4h _4t3i1f4h _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _80om73ad",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jGWLi", function(module, exports) {

$parcel$export(module.exports, "Error", () => $478753c6238aea58$export$edf27be85e5f6da0);

var $eUqFw = parcelRequire("eUqFw");

var $ac4LI = parcelRequire("ac4LI");

var $eS0Iq = parcelRequire("eS0Iq");
const $478753c6238aea58$var$onErrorDialogMouseDown = (e)=>{
    (0, $eS0Iq.preventDefault)(e);
    (0, $eS0Iq.stopPropagation)(e);
};
const $478753c6238aea58$export$edf27be85e5f6da0 = /*#__PURE__*/ (0, $eUqFw.memo)(({ errorInlineMessage: errorInlineMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ac4LI.PaddedFlexContainer), {
        onClick: (0, $eS0Iq.stopPropagation),
        onMouseDown: $478753c6238aea58$var$onErrorDialogMouseDown
    }, errorInlineMessage));

});

parcelRegister("f3LuK", function(module, exports) {

$parcel$export(module.exports, "Estimate", () => $660f02bf83287834$export$f24de3004fef8471);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");


var $87GQt = parcelRequire("87GQt");
var $6UA3n = parcelRequire("6UA3n");
var $eY8vu = parcelRequire("eY8vu");

var $eS0Iq = parcelRequire("eS0Iq");

const $660f02bf83287834$export$88b57365e3a3cb92 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("1Vqi3")), {
    moduleId: "./src/packages/issue/fields/number/src/index.tsx"
});
const $660f02bf83287834$export$f24de3004fef8471 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, estimateFieldId: estimateFieldId })=>{
    const [{ value: value }] = (0, $eY8vu.useNumberField)({
        issueKey: issueKey,
        fieldKey: estimateFieldId
    });
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6UA3n.NumberView), {
        isEditable: true,
        value: value
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($660f02bf83287834$export$42a852a2b6b56249, {
        "data-testid": "issue-line-card.ui.estimate.estimate-field",
        role: "button",
        onClick: (0, $eS0Iq.stopPropagation),
        onFocus: (0, $eS0Iq.stopPropagation)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $87GQt.IssueNumberFieldBoundary), {
        packageName: "issue",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($660f02bf83287834$export$88b57365e3a3cb92, {
        issueKey: issueKey,
        fieldKey: estimateFieldId,
        fieldFocusStyle: (0, $ada2d6cf4ae575cf$export$797ed91ebb8db1c5),
        fieldEditStyle: (0, $ada2d6cf4ae575cf$export$1ff9623b26415f8)
    })));
});
const $660f02bf83287834$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bv1b66 _1la1idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fbGz1", function(module, exports) {

$parcel$export(module.exports, "IssueKey", () => $3851fefa21777681$export$40bed7a29c3b629);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cua7B = parcelRequire("cua7B");

var $iJ8Hj = parcelRequire("iJ8Hj");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $duc4i = parcelRequire("duc4i");

var $kJlBc = parcelRequire("kJlBc");

var $eS0Iq = parcelRequire("eS0Iq");

var $dWwMk = parcelRequire("dWwMk");
const $3851fefa21777681$var$DATA_TEST_ID = 'issue.issue-view.views.common.issue-line-card.issue-line-card-view.key';
const $3851fefa21777681$export$2bc99a5bedb85504 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, issueLink: issueLink, remoteServerHostname: remoteServerHostname, statusCategory: statusCategory, hideTooltipOnMouseDown: hideTooltipOnMouseDown, showHoverPreviewEnabled: showHoverPreviewEnabled, isResolved: isResolved })=>{
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const intl = (0, $5JgJ2.default)();
    const toolTipContent = remoteServerHostname === undefined ? null : remoteServerHostname;
    const handleLinkKeyClick = (0, $eUqFw.useCallback)((e)=>{
        e.preventDefault();
        if (issueLink != null && (0, $eS0Iq.isLeftClickOnly)(e)) push(issueLink);
        else window.open(issueLink, '_blank');
    }, [
        issueLink,
        push
    ]);
    const label = (0, $1ybV0.ff)('jca11y-1432-view-and-edit-issues-bug-track-board-issue-view-full-view-strikethrough-done-status-of-the-issue-is-not-announced-by-screen-reader_hfmug') ? intl.formatMessage((0, $dWwMk.default).issueKeyWithResolution, {
        issueKey: issueKey,
        isResolved: isResolved
    }) : undefined;
    const keyContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3851fefa21777681$export$cd0f44441c3b7719, {
        "data-testid": $3851fefa21777681$var$DATA_TEST_ID,
        href: issueLink,
        shouldDisplayStrikethrough: (0, $eS0Iq.shouldDisplayStrikethrough)(isResolved, statusCategory),
        onClick: handleLinkKeyClick,
        "aria-label": label,
        draggable: false
    }, issueKey);
    if (showHoverPreviewEnabled) {
        const normalizedIssueLink = issueLink?.startsWith('/') ? `${window.location.protocol}//${window.location.hostname}${issueLink}` : issueLink;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJ8Hj.StandaloneHoverCard), {
            url: normalizedIssueLink || '',
            closeOnChildClick: true,
            actionOptions: {
                hide: false,
                exclude: [
                    (0, $cua7B.CardAction).ChangeStatusAction
                ]
            }
        }, keyContent);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: toolTipContent,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        position: "bottom"
    }, keyContent);
});
const $3851fefa21777681$export$32d888492f9f4a1 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, issueLink: issueLink, remoteServerHostname: remoteServerHostname, hideTooltipOnMouseDown: hideTooltipOnMouseDown, showHoverPreviewEnabled: showHoverPreviewEnabled, isResolved: isResolved, statusCategory: statusCategory })=>{
    const intl = (0, $5JgJ2.default)();
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const tooltipContent = remoteServerHostname === undefined ? null : remoteServerHostname;
    const handleLinkKeyClick = (0, $eUqFw.useCallback)((e)=>{
        e.preventDefault();
        if (issueLink != null && (0, $eS0Iq.isLeftClickOnly)(e)) push(issueLink);
        else window.open(issueLink, '_blank');
    }, [
        issueLink,
        push
    ]);
    const label = (0, $1ybV0.ff)('jca11y-1432-view-and-edit-issues-bug-track-board-issue-view-full-view-strikethrough-done-status-of-the-issue-is-not-announced-by-screen-reader_hfmug') ? intl.formatMessage((0, $dWwMk.default).issueKeyWithResolution, {
        issueKey: issueKey,
        isResolved: isResolved
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $duc4i.default), {
        issueKey: issueKey,
        issueLink: issueLink,
        tooltipContent: tooltipContent,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        showHoverPreviewEnabled: showHoverPreviewEnabled,
        isResolved: isResolved,
        statusCategory: statusCategory,
        onClick: handleLinkKeyClick,
        testId: $3851fefa21777681$var$DATA_TEST_ID,
        label: label
    });
});
const $3851fefa21777681$export$40bed7a29c3b629 = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('issue-view-a11y-for-issue-key-strikethrough_3xavq'), $3851fefa21777681$export$32d888492f9f4a1, $3851fefa21777681$export$2bc99a5bedb85504);
var $3851fefa21777681$export$2e2bcd8739ae039 // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $3851fefa21777681$export$40bed7a29c3b629;
const $3851fefa21777681$export$cd0f44441c3b7719 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldDisplayStrikethrough: shouldDisplayStrikethrough, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _18u0u2gc _syaz1y58 _k48pbfng _1wyb1crf _o5721q9c",
            __cmplp.shouldDisplayStrikethrough ? "_4bfu18uv _1hms1911 _ajmmnqa1" : "_4bfu18uv _1hmsglyw _ajmmnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("duc4i", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db0674fe0bbdbf9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cua7B = parcelRequire("cua7B");

var $iJ8Hj = parcelRequire("iJ8Hj");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $27ydI = parcelRequire("27ydI");

var $co12F = parcelRequire("co12F");
const $9db0674fe0bbdbf9$export$40bed7a29c3b629 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, issueLink: issueLink, statusCategory: statusCategory, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, showHoverPreviewEnabled: showHoverPreviewEnabled, isResolved: isResolved, tooltipContent: tooltipContent, label: label, testId: testId, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getDefaultLabel = ()=>isResolved ? formatMessage((0, $co12F.default).label, {
            issueKey: issueKey
        }) : undefined;
    const renderKeyContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9db0674fe0bbdbf9$var$Key, {
            "data-testid": testId,
            href: issueLink,
            shouldDisplayStrikethrough: (0, $27ydI.shouldDisplayStrikethrough)(isResolved, statusCategory),
            onClick: onClick,
            "aria-label": label ?? getDefaultLabel(),
            role: (0, $1ybV0.ff)('jca11y-1432-view-and-edit-issues-bug-track-board-issue-view-full-view-strikethrough-done-status-of-the-issue-is-not-announced-by-screen-reader_hfmug') ? 'link' : undefined,
            draggable: false
        }, issueKey);
    if (showHoverPreviewEnabled) {
        const normalizedIssueLink = issueLink?.startsWith('/') ? `${window.location.protocol}//${window.location.hostname}${issueLink}` : issueLink;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJ8Hj.StandaloneHoverCard), {
            url: normalizedIssueLink || '',
            closeOnChildClick: true,
            actionOptions: {
                hide: false,
                exclude: [
                    (0, $cua7B.CardAction).ChangeStatusAction
                ]
            }
        }, renderKeyContent());
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipContent,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        position: "bottom"
    }, renderKeyContent());
});
var $9db0674fe0bbdbf9$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $9db0674fe0bbdbf9$export$40bed7a29c3b629;
const $9db0674fe0bbdbf9$var$Key = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldDisplayStrikethrough: shouldDisplayStrikethrough, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _18u0u2gc _syaz1y58 _k48pbfng _1wyb1crf _o5721q9c",
            __cmplp.shouldDisplayStrikethrough ? "_4bfu18uv _1hms1911 _ajmmnqa1" : "_4bfu18uv _1hmsglyw _ajmmnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("27ydI", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayStrikethrough", () => $efd04ed94f1a5b80$export$1e1e848245d3a6f7);

var $8Qd0L = parcelRequire("8Qd0L");
const { DONE: $efd04ed94f1a5b80$var$DONE } = (0, $8Qd0L);
const $efd04ed94f1a5b80$export$1e1e848245d3a6f7 = (isResolved, statusCategory)=>{
    if (isResolved !== undefined) return isResolved;
    // In JSW, the strikethrough must now only depend on resolution. However we have to keep
    // this logic because there is a consumer of issue-line-card in JSM that displays
    // the strikethrough based on status src/packages/servicedesk/post-incident-review/src/ui/primary-incident/index.tsx
    return statusCategory === $efd04ed94f1a5b80$var$DONE;
};

});

parcelRegister("co12F", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e46f51a99d7c522$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4e46f51a99d7c522$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "issue-key-with-resolution.label",
        "defaultMessage": "{issueKey} resolved"
    }
});

});


parcelRegister("dWwMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $93c01d192bdd9a7e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $93c01d192bdd9a7e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueKeyWithResolution: {
        "id": "issue-line-card.issue-key.issue-key-with-resolution",
        "defaultMessage": "{issueKey} is {isResolved, select, \n            true {done}\n            false {not done}\n            other {}\n        }"
    }
});

});


parcelRegister("98vOP", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", () => $dfb68a95860d36b4$export$b08b517936747730);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $ac4LI = parcelRequire("ac4LI");
const $dfb68a95860d36b4$export$b08b517936747730 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ac4LI.PaddedFlexContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small"
    })));

});

parcelRegister("aWMJA", function(module, exports) {

$parcel$export(module.exports, "Priority", () => $69336f7c180f5fec$export$300334f671c43555);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $hnzPP = parcelRequire("hnzPP");

var $4ksts = parcelRequire("4ksts");

var $ac4LI = parcelRequire("ac4LI");

var $gg9n6 = parcelRequire("gg9n6");
const $69336f7c180f5fec$var$priorityIconSize = 20;
const $69336f7c180f5fec$export$300334f671c43555 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issuePriorityUrl: issuePriorityUrl, issuePriorityName: issuePriorityName, hideTooltipOnMouseDown: hideTooltipOnMouseDown })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const title = intl.formatMessage((0, $gg9n6.default).issuePriorityTitle, {
        issuePriorityName: issuePriorityName
    });
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
        alt: title,
        url: issuePriorityUrl,
        width: $69336f7c180f5fec$var$priorityIconSize,
        height: $69336f7c180f5fec$var$priorityIconSize
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: issuePriorityName || '',
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ac4LI.FlexContainer), {
        "data-testid": "issue-line-card.ui.priority.priority"
    }, icon));
});

});
parcelRegister("gg9n6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3ca297e0f788d64$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d3ca297e0f788d64$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issuePriorityTitle: {
        "id": "issue-line-card.priority.issue-priority-title",
        "defaultMessage": "Priority: {issuePriorityName}"
    }
});

});


parcelRegister("hSTXl", function(module, exports) {

$parcel$export(module.exports, "ReadOnlyEstimate", () => $b613a6e8793d4db2$export$b6d3b49e19a9fbb0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kmr29 = parcelRequire("kmr29");

var $5St1r = parcelRequire("5St1r");
parcelRequire("87GQt");
var $6UA3n = parcelRequire("6UA3n");

var $7vU0J = parcelRequire("7vU0J");

var $eS0Iq = parcelRequire("eS0Iq");
const $b613a6e8793d4db2$export$b6d3b49e19a9fbb0 = ({ issueKey: issueKey, estimateFieldId: estimateFieldId })=>{
    const [estimateValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: estimateFieldId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b613a6e8793d4db2$var$Container, {
        "data-testid": "issue-line-card.ui.read-only-estimate.readonly-estimate-field",
        role: "button",
        onClick: (0, $eS0Iq.stopPropagation),
        onFocus: (0, $eS0Iq.stopPropagation)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vU0J.LozengeChildNumberFieldContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5St1r.ReadViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6UA3n.NumberView), {
        isEditable: false,
        value: estimateValue
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b613a6e8793d4db2$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bv1b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9eJsf", function(module, exports) {

$parcel$export(module.exports, "SummaryReadOnly", () => $4c5a56fac917b843$export$ffead3d9b7196c7d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $rDJ37 = parcelRequire("rDJ37");
const $4c5a56fac917b843$export$ffead3d9b7196c7d = ({ value: value, isInlineEditEnabled: isInlineEditEnabled, issueLink: issueLink, onClick: onClick, showHoverPreviewEnabled: showHoverPreviewEnabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c5a56fac917b843$export$b13648308b87115, {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "issue.issue-view.views.common.issue-line-card.issue-line-card-view.summary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $rDJ37.InlineSummaryRead), {
        onClick: onClick,
        isEditable: false,
        value: value ?? null,
        isInlineEditEnabled: isInlineEditEnabled,
        url: issueLink,
        showHoverPreviewEnabled: showHoverPreviewEnabled
    }));
const $4c5a56fac917b843$export$b13648308b87115 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _2hwxpxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4pk7m", function(module, exports) {

$parcel$export(module.exports, "RemoveButton", () => $4a4aa495f3d89948$export$4e9d5ce1e6c22a94);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $je5kZ = parcelRequire("je5kZ");

var $8cU5f = parcelRequire("8cU5f");

var $4ksts = parcelRequire("4ksts");

var $8OCX2 = parcelRequire("8OCX2");
const $4a4aa495f3d89948$export$4e9d5ce1e6c22a94 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, globalId: globalId, isRemote: isRemote, shouldShowRemoveAction: shouldShowRemoveAction, onDelete: onDelete })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const deleteButtonAction = (0, $eUqFw.useCallback)((e)=>{
        e.stopPropagation();
        if (issueKey != null) onDelete(issueKey, globalId);
    }, [
        globalId,
        issueKey,
        onDelete
    ]);
    const deleteButtonTooltipContent = shouldShowRemoveAction ? intl.formatMessage(isRemote ? (0, $8OCX2.default).remoteLinkDeleteLinkTooltip : (0, $8OCX2.default).issueLinkDeleteLinkTooltip) : '';
    /* A container surrounding the button is needed as tabbing from issue line card without an
   *  intermediary always 'existent' container results in tabbing to 'nothing'/the body div
   *  as the tab event occurs before the close button is chosen as the next node to tab into
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: deleteButtonTooltipContent,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4a4aa495f3d89948$export$63f62d64edac44c, {
        show: shouldShowRemoveAction,
        "data-testid": "issue-line-card.ui.remove-button.delete-link-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "issue-line-card.ui.remove-button",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
            label: deleteButtonTooltipContent
        }),
        onClick: deleteButtonAction,
        appearance: "subtle",
        spacing: "none"
    })));
});
const $4a4aa495f3d89948$export$63f62d64edac44c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbzwfg _4t3i1osq _18u0v77o _2hwxx0bf _1e0c1txw _4cvr1h6o",
            __cmplp.show ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8OCX2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b228a429961f9be9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b228a429961f9be9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    remoteLinkDeleteLinkTooltip: {
        "id": "issue-line-card.remove-button.remote-link-delete-link-tooltip",
        "defaultMessage": "Unlink remote issue"
    },
    issueLinkDeleteLinkTooltip: {
        "id": "issue-line-card.remove-button.issue-link-delete-link-tooltip",
        "defaultMessage": "Unlink issue"
    }
});

});


parcelRegister("efAF9", function(module, exports) {

$parcel$export(module.exports, "Status", () => $271e940a7d74503e$export$96e9906d6d93a972);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $4ksts = parcelRequire("4ksts");

var $lpHr5 = parcelRequire("lpHr5");

var $8WuJm = parcelRequire("8WuJm");

var $ac4LI = parcelRequire("ac4LI");

var $eS0Iq = parcelRequire("eS0Iq");

var $ag1kP = parcelRequire("ag1kP");
const $271e940a7d74503e$export$96e9906d6d93a972 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, statusName: statusName, statusId: statusId, statusCategoryId: statusCategoryId, isRemote: isRemote, isInteractive: isInteractive, hideTooltipOnMouseDown: hideTooltipOnMouseDown, projectType: projectType, onEditStatus: onEditStatus })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const tooltipContent = isRemote === true && isInteractive !== true ? intl.formatMessage((0, $ag1kP.default).remoteIssueUneditableStatusTooltip) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ac4LI.PaddedFlexContainer), {
        onClick: (0, $eS0Iq.preventDefault),
        "data-testid": "issue-line-card.ui.status.status-field-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipContent,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "childIssuesPanel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lpHr5.default), {
        isEditable: isInteractive,
        appearance: "lozenge",
        issueKey: issueKey,
        projectType: projectType,
        initialValue: {
            id: statusId,
            name: statusName,
            statusCategory: {
                id: statusCategoryId
            }
        },
        onSuccess: onEditStatus
    }))));
});

});
parcelRegister("ag1kP", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ed11da371e0593c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2ed11da371e0593c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    remoteIssueUneditableStatusTooltip: {
        "id": "issue-line-card.status.remote-issue-uneditable-status-tooltip",
        "defaultMessage": "Remote issue can't be transitioned here. Select to view the issue, then change the status."
    }
});

});


parcelRegister("11skS", function(module, exports) {

$parcel$export(module.exports, "Summary", () => $cd0de22240dc699b$export$46453a0401d6cd1a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cfw07 = parcelRequire("cfw07");
const $cd0de22240dc699b$export$46453a0401d6cd1a = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, onClick: onClick, issueLink: issueLink, onUpdate: onUpdate, showHoverPreviewEnabled: showHoverPreviewEnabled })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClick = (e)=>{
        // We're trusting the summary component to handle all of its own click events.
        // So preventing the line card's navigation-on-click behaviour from mucking around with the inline edit behaviour.
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cd0de22240dc699b$export$16ad35933fd504b, {
        onClick: handleClick,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "issue.issue-view.views.common.issue-line-card.issue-line-card-view.summary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cfw07.default), {
        issueKey: issueKey,
        onClick: onClick,
        appearance: (0, $4e41f56f0e9d77a8$export$1ff9623b26415f8),
        url: issueLink,
        onUpdate: onUpdate,
        showHoverPreviewEnabled: showHoverPreviewEnabled
    }));
});
const $cd0de22240dc699b$export$16ad35933fd504b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _18u0u2gc _1ul9idpf _2hwxpxbi",
            __cmplp.className
        ])
    });
});

});




parcelRegister("apQla", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c6430ced62b7268$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $0c6430ced62b7268$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createChildErrorTitle: {
        "id": "issue.views.common.child-issues-panel.issues.create-child-error-title",
        "defaultMessage": "We couldn't create the child issue"
    },
    createSubtaskErrorTitle: {
        "id": "issue.views.common.child-issues-panel.issues.create-subtask-error-title",
        "defaultMessage": "We couldn't create the subtask"
    },
    createErrorBody: {
        "id": "issue.views.common.child-issues-panel.issues.create-error-body",
        "defaultMessage": "Check your connection, then give it another try"
    },
    linkIssueErrorTitle: {
        "id": "issue.views.common.child-issues-panel.issues.link-issue-error-title",
        "defaultMessage": "We couldn't link the child issue"
    },
    linkIssueErrorBody: {
        "id": "issue.views.common.child-issues-panel.issues.link-issue-error-body",
        "defaultMessage": "Check your connection, then give it another try"
    },
    restrictedReorderingMessage: {
        "id": "issue.views.common.child-issues-panel.issues.restricted-reordering-message",
        "defaultMessage": "To order these issues manually, choose 'Order by rank'"
    },
    restrictedReorderingExceededLimitMessage: {
        "id": "issue.views.common.child-issues-panel.issues.restricted-reordering-exceeded-limit-message",
        "defaultMessage": "To order more than 100 child issues, select ... -> View in search"
    }
});

});

parcelRegister("6bPqk", function(module, exports) {

$parcel$export(module.exports, "DragPreview", () => $648be5d2f2b5dd75$export$905ab40ac2179daa);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
function $648be5d2f2b5dd75$export$905ab40ac2179daa({ iconUrl: iconUrl, issueKey: issueKey }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($648be5d2f2b5dd75$var$Container, null, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: iconUrl,
        /**
     * This preview won't be read by assistive technology,
     * so can be treated as purely decorative.
     */ alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($648be5d2f2b5dd75$var$Key, null, issueKey));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $648be5d2f2b5dd75$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71bhr _2rkoglpi _1e0c1txw _4cvr1h6o _1yt4u2gc _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $648be5d2f2b5dd75$var$Key = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1y58 _k48pbfng _1wyb1crf _o5721q9c",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dkwhp", function(module, exports) {

$parcel$export(module.exports, "default", () => $416a6a7ee4aceffa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8Qd0L = parcelRequire("8Qd0L");

var $8mSXg = parcelRequire("8mSXg");

var $6bhHe = parcelRequire("6bhHe");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$416a6a7ee4aceffa$export$2e2bcd8739ae039 = ({ issueTimeTracking: issueTimeTracking, statusCategory: statusCategory })=>{
    const [config] = (0, $6bhHe.useTimeTrackingConfiguration)();
    const { remainingEstimateSeconds: remainingEstimateSeconds, originalEstimateSeconds: originalEstimateSeconds, timeSpentSeconds: timeSpentSeconds } = issueTimeTracking;
    const value = {
        loggedTime: timeSpentSeconds,
        remainingTime: remainingEstimateSeconds
    };
    const estimatedTime = originalEstimateSeconds;
    const isDone = statusCategory === (0, $8Qd0L).DONE;
    return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($416a6a7ee4aceffa$export$b1569cb93f9fcc1f, {
        "data-testid": "issue.views.common.issue-line-card.issue-line-card.mini-time-log-graph"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8mSXg.default), {
        value: value,
        estimatedTime: estimatedTime,
        config: config,
        isDone: isDone,
        isCompact: true,
        shouldHighlightOnHover: true
    })));
};
const $416a6a7ee4aceffa$export$b1569cb93f9fcc1f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ylp _kqswh2mm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("41Paw", function(module, exports) {

$parcel$export(module.exports, "Container", () => $c353a19652edc4d4$export$42a852a2b6b56249);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $c353a19652edc4d4$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _otyru2gc _u5f3v77o",
            __cmplp.className
        ])
    });
});

});


parcelRegister("01TIX", function(module, exports) {

$parcel$export(module.exports, "sortIssuesByCreated", () => $a570d98356dac2b7$export$f98c246157e8809c);
$parcel$export(module.exports, "sortIssuesByKey", () => $a570d98356dac2b7$export$75bc2191a1c5e544);
$parcel$export(module.exports, "sortIssuesByStatus", () => $a570d98356dac2b7$export$b12b96dc5456b2e);
$parcel$export(module.exports, "sortIssuesByAssignee", () => $a570d98356dac2b7$export$653d72ce77c114f5);
$parcel$export(module.exports, "sortIssuesByPriority", () => $a570d98356dac2b7$export$200919e667fbb916);

var $8Qd0L = parcelRequire("8Qd0L");
const $a570d98356dac2b7$export$f98c246157e8809c = (issues)=>[
        ...issues
    ].sort((a, b)=>{
        if (a.created === undefined) return 1;
        if (b.created === undefined) return -1;
        // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        return b.created - a.created;
    });
const $a570d98356dac2b7$export$75bc2191a1c5e544 = (issues)=>[
        ...issues
    ].sort((a, b)=>{
        const [aKey = '', aIndex = 0] = (a.issueKey || '').split('-');
        const [bKey = '', bIndex = 0] = (b.issueKey || '').split('-');
        // @ts-expect-error - TS2345 - Argument of type 'string | 0' is not assignable to parameter of type 'string'. | TS2345 - Argument of type 'string | 0' is not assignable to parameter of type 'string'.
        return aKey.localeCompare(bKey) || parseInt(aIndex, 10) - parseInt(bIndex, 10);
    });
const $a570d98356dac2b7$var$STATUS_SORT_ORDER = {
    [(0, $8Qd0L.UNDEFINED)]: 0,
    [(0, $8Qd0L.TODO)]: 1,
    [(0, $8Qd0L.IN_PROGRESS)]: 2,
    [(0, $8Qd0L.DONE)]: 3
};
const $a570d98356dac2b7$var$getStatusSortOrder = (statusCategory)=>{
    const categoryName = statusCategory == null ? (0, $8Qd0L.UNDEFINED) : statusCategory;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly UNDEFINED: 0; readonly TODO: 1; readonly IN_PROGRESS: 2; readonly DONE: 3; }'.
    return $a570d98356dac2b7$var$STATUS_SORT_ORDER[categoryName] || 0;
};
const $a570d98356dac2b7$export$b12b96dc5456b2e = (issues)=>[
        ...issues
    ].sort((a, b)=>$a570d98356dac2b7$var$getStatusSortOrder(a.statusCategory) - $a570d98356dac2b7$var$getStatusSortOrder(b.statusCategory) || (a.statusName || '').localeCompare(b.statusName || ''));
const $a570d98356dac2b7$export$653d72ce77c114f5 = (issues)=>[
        ...issues
    ].sort((a, b)=>{
        if (a.assigneeDisplayName === '' || a.assigneeDisplayName == null) return 1;
        if (b.assigneeDisplayName === '' || b.assigneeDisplayName == null) return -1;
        return a.assigneeDisplayName.localeCompare(b.assigneeDisplayName);
    });
// this is to ensure issues where priority is empty are placed last
const $a570d98356dac2b7$var$getPriorityValue = (priorityOrder, priorityName)=>{
    // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
    const index = priorityOrder.indexOf(priorityName);
    return index >= 0 ? index : Number.MAX_SAFE_INTEGER;
};
const $a570d98356dac2b7$export$1828c302333b42d8 = (issues, priorityOrder)=>[
        ...issues
    ].sort((a, b)=>$a570d98356dac2b7$var$getPriorityValue(priorityOrder, a.issuePriorityName) - $a570d98356dac2b7$var$getPriorityValue(priorityOrder, b.issuePriorityName));
const $a570d98356dac2b7$export$200919e667fbb916 = (issues)=>[
        ...issues
    ].sort((a, b)=>(a.issuePrioritySequence || Number.MAX_SAFE_INTEGER) - (b.issuePrioritySequence || Number.MAX_SAFE_INTEGER));

});



parcelRegister("945jA", function(module, exports) {

$parcel$export(module.exports, "default", () => $271fac15b91bd16e$export$2e2bcd8739ae039);

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $2HCUG = parcelRequire("2HCUG");

var $6QyxX = parcelRequire("6QyxX");

var $f1vQz = parcelRequire("f1vQz");
var $271fac15b91bd16e$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>{
    const totalIssues = (0, $6QyxX.getAllIssues)(state);
    const inProgressIssues = (0, $6QyxX.getInProgressIssues)(state);
    const completedIssues = (0, $6QyxX.getCompletedIssues)(state);
    return {
        isClassicSubtaskPanel: (0, $2HCUG.getIsClassicSubtaskPanel)(state),
        totalIssueCount: totalIssues.length,
        inProgressIssueCount: inProgressIssues.length,
        completedIssueCount: completedIssues.length
    };
}, {}))((0, $f1vQz.ProgressSummaryView));

});
parcelRegister("f1vQz", function(module, exports) {

$parcel$export(module.exports, "ProgressSummaryView", () => $14233fbd3d2955f2$export$d71da7c107cf4a34);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bcuy0 = parcelRequire("bcuy0");
var $dFSe7 = parcelRequire("dFSe7");

var $8uD7Y = parcelRequire("8uD7Y");
var $4ksts = parcelRequire("4ksts");

var $gjn7l = parcelRequire("gjn7l");

var $hzBjf = parcelRequire("hzBjf");
const $14233fbd3d2955f2$var$CLASSIC_SUBTASK_PANEL_TOOLTIP = {
    remainingTooltip: (0, $gjn7l.default).todoSubtasksSegmentTooltipText,
    completedTooltip: (0, $gjn7l.default).completedSubtasksSegmentTooltipText,
    inProgressTooltip: (0, $gjn7l.default).inProgressSubtasksSegmentTooltipText
};
const $14233fbd3d2955f2$var$CHILD_ISSUE_PANEL_TOOLTIP = {
    remainingTooltip: (0, $gjn7l.default).todoIssuesSegmentTooltipText,
    completedTooltip: (0, $gjn7l.default).completedIssuesSegmentTooltipText,
    inProgressTooltip: (0, $gjn7l.default).inProgressIssuesSegmentTooltipText
};
const $14233fbd3d2955f2$export$d71da7c107cf4a34 = (props)=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const { isClassicSubtaskPanel: isClassicSubtaskPanel, totalIssueCount: totalIssueCount, inProgressIssueCount: inProgressIssueCount, completedIssueCount: completedIssueCount } = props;
    // Note: on rare occasions, it is possible for todoIssueCount to include issues with UNDEFINED status category.
    const todoIssueCount = totalIssueCount - inProgressIssueCount - completedIssueCount;
    // Math.floor instead of Math.round so we don't incorrectly show 100% Done when we're only at 99.5%.
    const completionPercentage = Math.floor(completedIssueCount / totalIssueCount * 100);
    const { remainingTooltip: remainingTooltip, completedTooltip: completedTooltip, inProgressTooltip: inProgressTooltip } = isClassicSubtaskPanel ? $14233fbd3d2955f2$var$CLASSIC_SUBTASK_PANEL_TOOLTIP : $14233fbd3d2955f2$var$CHILD_ISSUE_PANEL_TOOLTIP;
    const progressElementCompleted = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dFSe7.default), {
        value: completedIssueCount,
        color: (0, $hzBjf.DONE_SEGMENT_COLOR),
        tooltipContent: formatMessage(completedTooltip, {
            completedIssueCount: completedIssueCount,
            totalIssueCount: totalIssueCount
        })
    });
    const progressElementInProgress = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dFSe7.default), {
        value: inProgressIssueCount,
        color: (0, $hzBjf.IN_PROGRESS_SEGMENT_COLOR_HIGHER_CONTRAST),
        tooltipContent: formatMessage(inProgressTooltip, {
            inProgressIssueCount: inProgressIssueCount,
            totalIssueCount: totalIssueCount
        })
    });
    const progressBarContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($14233fbd3d2955f2$var$ProgressBarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcuy0.default), {
        sum: totalIssueCount,
        backgroundColor: (0, $hzBjf.TODO_SEGMENT_COLOR_HIGHER_CONTRAST),
        remainingTooltipContent: formatMessage(remainingTooltip, {
            todoIssueCount: todoIssueCount,
            totalIssueCount: totalIssueCount
        }),
        height: 8
    }, progressElementCompleted, progressElementInProgress));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($14233fbd3d2955f2$var$ProgressSummaryContainer, null, progressBarContainer, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($14233fbd3d2955f2$var$CompletionPercentageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $gjn7l.default).completionPercentageText,
        values: {
            completionPercentage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($14233fbd3d2955f2$var$PercentageValueContainer, null, completionPercentage)
        }
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $14233fbd3d2955f2$var$ProgressSummaryContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _16jlcs5v",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $14233fbd3d2955f2$var$ProgressBarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _19pku2gc _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $14233fbd3d2955f2$var$CompletionPercentageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0pxbi _2hwxv77o _1o9zidpf _syaz1wmz",
            __cmplp.className
        ])
    });
}); // Fixed width span is used to contain the actual completion percentage value. This will ensure the progress bar width
const $14233fbd3d2955f2$var$PercentageValueContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _1bsb1tcg _y3gnusic",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bcuy0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5e2a577faa3e6f5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");

var $dFSe7 = parcelRequire("dFSe7");
class $d5e2a577faa3e6f5$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            children: null,
            sum: 0,
            remainingTooltipContent: '',
            // TODO: Use tokens for colors
            backgroundColor: (0, $PdmhA).N30,
            height: 10
        };
    }
    validateElementsAndCalculateElementsWidth() {
        const { children: children } = this.props;
        let sumOfElementsValues = 0;
        const validatedElements = [];
        (0, $eUqFw.Children).map(children, (child)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const childEl = child;
            if (childEl.props.value && childEl.props.value > 0) {
                sumOfElementsValues += childEl.props.value;
                validatedElements.push(childEl);
            }
        });
        return {
            validatedElements: validatedElements,
            elementsSum: sumOfElementsValues
        };
    }
    render() {
        const { children: children, remainingTooltipContent: remainingTooltipContent, sum: sum, backgroundColor: backgroundColor, height: height, borderRadius: borderRadius, tooltipHoverPadding: tooltipHoverPadding } = this.props;
        if (!children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5e2a577faa3e6f5$var$ProgressWrapper, {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "common.components.progress-bar.progress-wrapper",
            backgroundColor: backgroundColor,
            elementsGrow: 0,
            elementsHeight: height,
            // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number'.
            borderRadius: borderRadius
        });
        const { validatedElements: validatedElements, elementsSum: elementsSum } = this.validateElementsAndCalculateElementsWidth();
        const remaining = sum - elementsSum;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5e2a577faa3e6f5$var$ProgressWrapper, {
            ...this.props,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "common.components.progress-bar.progress-wrapper",
            backgroundColor: remaining > 0 ? backgroundColor : 'transparent',
            elementsHeight: height,
            // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number'.
            borderRadius: borderRadius,
            tooltipHoverPadding: tooltipHoverPadding,
            role: "status",
            ariaLive: "polite"
        }, validatedElements, remaining > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dFSe7.default), {
            value: remaining,
            tooltipContent: remainingTooltipContent,
            color: backgroundColor,
            tooltipHoverPadding: tooltipHoverPadding
        }));
    }
}
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5e2a577faa3e6f5$var$ProgressWrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1750df9-0"
})`width:100%;height:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.elementsHeight}px;display:flex;${({ borderRadius: borderRadius, elementsHeight: elementsHeight, tooltipHoverPadding: tooltipHoverPadding })=>!tooltipHoverPadding && `border-radius: ${borderRadius || elementsHeight / 2}px;
        overflow: hidden;
    `} & > div{${({ borderRadius: borderRadius, elementsHeight: elementsHeight })=>{
    const radius = `${borderRadius || elementsHeight / 2}px`;
    return `
                &:first-child {
                    border-top-left-radius: ${radius};
                    border-bottom-left-radius: ${radius};
                }
                &:last-child {
                    border-top-right-radius: ${radius};
                    border-bottom-right-radius: ${radius};
                }
                &:not(:last-child) {
                    margin-right: 2px;
                }
                &:last-child {
                    margin-right: 0;
                }
            `;
}}}`;
$d5e2a577faa3e6f5$var$ProgressWrapper.displayName = 'ProgressWrapper';

});
parcelRegister("dFSe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $82fb7c5bc6b12ae1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $8cU5f = parcelRequire("8cU5f");
const $82fb7c5bc6b12ae1$var$SingleElementWithTooltip = (props)=>{
    const { value: value, tooltipContent: tooltipContent, color: color, position: position, tooltipHoverPadding: tooltipHoverPadding } = props;
    const TooltipTag = (0, $eUqFw.useMemo)(()=>// FIXME: Fix that by extracting the forwarded component
        // eslint-disable-next-line react/no-unstable-nested-components
        /*#__PURE__*/ (0, $eUqFw.forwardRef)((tagProps, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82fb7c5bc6b12ae1$var$SingleElement, {
                elementGrow: value,
                color: color,
                // @ts-expect-error - TS2322 - Type '((instance: unknown) => void) | MutableRefObject<unknown> | null' is not assignable to type '((instance: any) => void) | RefObject<HTMLElement | SVGElement | Component<{}, {}, any>> | undefined'.
                innerRef: ref,
                tooltipHoverPadding: tooltipHoverPadding,
                ...tagProps,
                ...typeof tooltipContent === 'string' ? {
                    role: 'button',
                    'aria-label': tooltipContent,
                    alt: tooltipContent,
                    tabIndex: 0
                } : {}
            })), [
        color,
        value,
        tooltipContent,
        tooltipHoverPadding
    ]);
    return(// @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'keyof IntrinsicElements | ComponentType<AllHTMLAttributes<HTMLElement> & { ref: Ref<HTMLElement>; }> | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipContent,
        position: position,
        tag: TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null)));
};
class $82fb7c5bc6b12ae1$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            value: 0,
            tooltipContent: ''
        };
    }
    render() {
        const { value: value, tooltipContent: tooltipContent, color: color } = this.props;
        const hasTooltipContent = Boolean(tooltipContent);
        if (hasTooltipContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82fb7c5bc6b12ae1$var$SingleElementWithTooltip, {
            ...this.props,
            tooltipContent: tooltipContent
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82fb7c5bc6b12ae1$var$SingleElement, {
            elementGrow: value,
            color: color,
            alt: tooltipContent
        });
    }
}
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82fb7c5bc6b12ae1$var$SingleElement = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-234u1k-0"
})`flex-grow:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.elementGrow};height:100%;min-width:5px;background-color:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.color};div{height:100%;width:100%;${({ tooltipHoverPadding: tooltipHoverPadding })=>tooltipHoverPadding && `padding-block: ${tooltipHoverPadding}px;
            margin-top: -${tooltipHoverPadding}px;`}}`;
$82fb7c5bc6b12ae1$var$SingleElement.displayName = 'SingleElement';

});


parcelRegister("gjn7l", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c66fb812573e1cc$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $6c66fb812573e1cc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    completionPercentageText: {
        "id": "issue.views.common.child-issues-panel.progress-summary.completion-percentage-text",
        "defaultMessage": "{completionPercentage}% Done"
    },
    todoIssuesSegmentTooltipText: {
        "id": "issue.views.common.child-issues-panel.progress-summary.todo-issues-segment-tooltip-text",
        "defaultMessage": "To Do: {todoIssueCount} of {totalIssueCount} issues"
    },
    todoSubtasksSegmentTooltipText: {
        "id": "issue.views.common.child-issues-panel.progress-summary.todo-subtasks-segment-tooltip-text",
        "defaultMessage": "To Do: {todoIssueCount} of {totalIssueCount} subtasks"
    },
    inProgressIssuesSegmentTooltipText: {
        "id": "issue.views.common.child-issues-panel.progress-summary.in-progress-issues-segment-tooltip-text",
        "defaultMessage": "In Progress: {inProgressIssueCount} of {totalIssueCount} issues"
    },
    inProgressSubtasksSegmentTooltipText: {
        "id": "issue.views.common.child-issues-panel.progress-summary.in-progress-subtasks-segment-tooltip-text",
        "defaultMessage": "In Progress: {inProgressIssueCount} of {totalIssueCount} subtasks"
    },
    completedIssuesSegmentTooltipText: {
        "id": "issue.views.common.child-issues-panel.progress-summary.completed-issues-segment-tooltip-text",
        "defaultMessage": "Done: {completedIssueCount} of {totalIssueCount} issues"
    },
    completedSubtasksSegmentTooltipText: {
        "id": "issue.views.common.child-issues-panel.progress-summary.completed-subtasks-segment-tooltip-text",
        "defaultMessage": "Done: {completedIssueCount} of {totalIssueCount} subtasks"
    }
});

});

parcelRegister("hzBjf", function(module, exports) {

$parcel$export(module.exports, "TODO_SEGMENT_COLOR_HIGHER_CONTRAST", () => $6b379bb2018fe0bd$export$ffab47bcf4a11d42);
$parcel$export(module.exports, "IN_PROGRESS_SEGMENT_COLOR_HIGHER_CONTRAST", () => $6b379bb2018fe0bd$export$14dbcc9140a368ac);
$parcel$export(module.exports, "DONE_SEGMENT_COLOR", () => $6b379bb2018fe0bd$export$53b2ee28ea173ab6);

var $PdmhA = parcelRequire("PdmhA");
const $6b379bb2018fe0bd$export$ffab47bcf4a11d42 = `var(--ds-border, ${(0, $PdmhA).N30})`;
const $6b379bb2018fe0bd$export$14dbcc9140a368ac = `var(--ds-border-information, ${(0, $PdmhA).B200})`;
const $6b379bb2018fe0bd$export$53b2ee28ea173ab6 = `var(--ds-border-success, ${(0, $PdmhA).G300})`;

});



parcelRegister("hbtxV", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesPanel", () => $313b34b423be6118$export$402e0e6a7dd45ba5);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5Dznp = parcelRequire("5Dznp");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $4Xcha = parcelRequire("4Xcha");

var $6azHZ = parcelRequire("6azHZ");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $5CqW1 = parcelRequire("5CqW1");

var $a7wEh = parcelRequire("a7wEh");

var $ca2LP = parcelRequire("ca2LP");

var $4D8Ar = parcelRequire("4D8Ar");

var $7ZyzP = parcelRequire("7ZyzP");
var $jy8O8 = parcelRequire("jy8O8");

var $3xyAb = parcelRequire("3xyAb");

var $hudGC = parcelRequire("hudGC");

var $idb9k = parcelRequire("idb9k");

var $4It9Q = parcelRequire("4It9Q");

var $3KfwU = parcelRequire("3KfwU");

var $daDVt = parcelRequire("daDVt");
// Only show progress summary when there are at least two child issues (or subtasks).
const $313b34b423be6118$var$PROGRESS_SUMMARY_MIN_ISSUE_COUNT = 2;
const $313b34b423be6118$export$402e0e6a7dd45ba5 = ({ hasExceededIssuesLimitAfterLoad: hasExceededIssuesLimitAfterLoad, totalChildIssueCount: totalChildIssueCount, addClickCount: addClickCount = 0, Heading: Heading, Issues: Issues, InlineCreate: InlineCreate, ProgressSummary: ProgressSummary, AddExistingIssue: AddExistingIssue, allIssues: allIssues, childPanelView: childPanelView, sourceName: sourceName, childIssuesLimitUrl: childIssuesLimitUrl, onAddChildClick: onAddChildClick, childIssuesPanelType: childIssuesPanelType, issueHierarchyLevel: issueHierarchyLevel, epicLinkFieldKey: epicLinkFieldKey, parentIssueKey: parentIssueKey, baseUrl: baseUrl, childIssueTypes: childIssueTypes, issueTypeWithWorkflowValidators: issueTypeWithWorkflowValidators, onFullDialogCreate: onFullDialogCreate, onSuggestedChildIssueCreateSuccess: onSuggestedChildIssueCreateSuccess, incompleteIssues: incompleteIssues })=>{
    const initialTotalChildIssueCount = (0, $eUqFw.useRef)(totalChildIssueCount);
    const childIssuesLimitStatus = (0, $eUqFw.useMemo)(()=>{
        if (childIssuesLimitUrl) return 0, $4Xcha.EXCEEDED_LIMIT_INITIAL_LOAD;
        if (hasExceededIssuesLimitAfterLoad) return 0, $4Xcha.EXCEEDED_LIMIT_AFTER_LOAD;
        return 0, $4Xcha.WITHIN_LIMIT;
    }, [
        childIssuesLimitUrl,
        hasExceededIssuesLimitAfterLoad
    ]);
    const shouldTriggerAiSuggestedIssues = (0, $ca2LP.useShouldTriggerAiSuggestedIssues)();
    const hasIssues = (0, $eUqFw.useMemo)(()=>allIssues.length > 0, [
        allIssues.length
    ]);
    const hasExceededChildIssuesLimitInitialLoad = (0, $eUqFw.useMemo)(()=>(0, $a7wEh.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus), [
        childIssuesLimitStatus
    ]);
    const hasExceededChildIssuesLimitAfterLoad = (0, $eUqFw.useMemo)(()=>(0, $a7wEh.hasExceededIssuesLimitAfterLoad)(childIssuesLimitStatus), [
        childIssuesLimitStatus
    ]);
    const hasContent = hasExceededChildIssuesLimitInitialLoad || hasIssues || addClickCount > 0 || shouldTriggerAiSuggestedIssues;
    const childIssuesLimit = (0, $hJ992.useChildIssuesLimit)();
    const approachingLimitCutOff = childIssuesLimit - 1;
    const startedBelowTheCutoff = !hasExceededChildIssuesLimitInitialLoad && initialTotalChildIssueCount.current < approachingLimitCutOff;
    const isNowAtTheCutoff = totalChildIssueCount === approachingLimitCutOff;
    const isApproachingLimit = startedBelowTheCutoff && isNowAtTheCutoff;
    const { shouldShowHideDoneInfoIcon: shouldShowHideDoneInfoIcon, completedIssuesCount: completedIssuesCount } = (0, $daDVt.useHideDoneChildIssues)(allIssues, incompleteIssues);
    const [sortByValue] = (0, $ca2LP.useChildIssuesSortBy)();
    const renderIssues = (0, $eUqFw.useMemo)(()=>{
        const progressSummary = !hasExceededChildIssuesLimitInitialLoad && allIssues.length >= $313b34b423be6118$var$PROGRESS_SUMMARY_MIN_ISSUE_COUNT ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProgressSummary, null) : null;
        return allIssues.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($313b34b423be6118$var$ProgressSummaryWithHideDoneIconContainer, null, progressSummary, shouldShowHideDoneInfoIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KfwU.HideDoneIconWithToolTip), {
            completedChildIssuesCount: completedIssuesCount
        })), (0, $1ybV0.ff)('configurable-child-issues-panel_3ht06') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4It9Q.ConfigurableChildIssuesPanel), {
            recentlyCreatedIssue: undefined
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Issues, {
            hasExceededChildIssuesLimitOnLoadOrAfter: hasExceededChildIssuesLimitAfterLoad || hasExceededChildIssuesLimitInitialLoad
        })) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldShowHideDoneInfoIcon,
        completedIssuesCount,
        allIssues.length,
        incompleteIssues.length,
        hasExceededChildIssuesLimitInitialLoad,
        hasExceededChildIssuesLimitAfterLoad,
        sortByValue
    ]);
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    const isSubtaskCreateEnabled = (0, $daDVt.getIsSubtaskCreateEnabled)(childIssuesPanelType, issueHierarchyLevel);
    (0, $eUqFw.useEffect)(()=>subscribe?.((0, $dNWQB.GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, async (payload)=>{
            if (payload.callbackPayload?.id !== (0, $4Xcha.GIC_CALLBACK_PAYLOAD_INLINE_CREATE_ID)) return;
            const { createdIssueDetails: createdIssueDetails } = payload.createdIssueData;
            const callbackData = payload.callbackPayload?.data;
            if (callbackData.parentIssueKey !== parentIssueKey || callbackData.childIssuesPanelType !== childIssuesPanelType) return;
            if (isSubtaskCreateEnabled || (epicLinkFieldKey && createdIssueDetails.fields[epicLinkFieldKey]) === parentIssueKey || callbackData?.parentIssueKey === parentIssueKey) onFullDialogCreate(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            callbackData.optimisticId, (0, $5CqW1.default)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            createdIssueDetails, baseUrl));
        }), [
        subscribe,
        baseUrl,
        epicLinkFieldKey,
        onFullDialogCreate,
        parentIssueKey,
        childIssuesPanelType,
        isSubtaskCreateEnabled
    ]);
    const useIssueBreakdown = (0, $1ybV0.ff)('jira-ai-work-breakdown-new-ui_z0inn') ? (0, $5Dznp.useIssueBreakdown) : (0, $3xyAb.useIssueBreakdown);
    const [{ currentStep: currentStep }, { closeIssueBreakdown: closeIssueBreakdown, isIssueBreakdownOpen: isIssueBreakdownOpen }] = (0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    useIssueBreakdown() : [
        {
            currentStep: 'defaultStep'
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        {
            closeIssueBreakdown: ()=>{},
            isIssueBreakdownOpen: ()=>false
        }
    ];
    const isAiOptInEnabled = (0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hJ992.useIsAiOptInEnabled)() : false;
    const renderCreate = (0, $eUqFw.useMemo)(()=>{
        const isAiEnabledAndOpen = (0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') && isAiOptInEnabled && isIssueBreakdownOpen();
        // Create panel should not render if AI issue create is open
        if (isAiEnabledAndOpen) return;
        if (addClickCount > 0) switch(childPanelView){
            case (0, $4D8Ar.CHILD_PANEL_VIEWS).InlineCreate:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InlineCreate, {
                    inputId: sourceName
                });
            case (0, $4D8Ar.CHILD_PANEL_VIEWS).AddExistingIssue:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AddExistingIssue, null);
            default:
                return null;
        }
        return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        addClickCount,
        childPanelView,
        sourceName,
        currentStep,
        isIssueBreakdownOpen
    ]);
    const onAddChildClickWithAiBreakdownEnabled = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        if (isAiOptInEnabled) closeIssueBreakdown();
        onAddChildClick && onAddChildClick(e, analyticsEvent);
    }, [
        isAiOptInEnabled,
        closeIssueBreakdown,
        onAddChildClick
    ]);
    const childIssuesLimitExceededAnalyticsCount = (0, $6azHZ.getChildIssuesLimitExceededAnalyticsCount)(childIssuesLimit);
    const renderAIWorkBreakdown = (0, $eUqFw.useMemo)(()=>{
        if (childIssueTypes.length === 0) return null;
        // killswitch
        if (!(0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl')) return null;
        if ((0, $1ybV0.ff)('jira-ai-work-breakdown-new-ui_z0inn')) {
            const childIssueTypeWithWFValidator = childIssueTypes.map((issueType)=>({
                    ...issueType,
                    hasWorkflowValidators: issueTypeWithWorkflowValidators && issueTypeWithWorkflowValidators[issueType.id] || false
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jy8O8.AiIssueBreakdownEntryPointContainer), {
                onCreate: onSuggestedChildIssueCreateSuccess,
                childIssueTypes: childIssueTypeWithWFValidator,
                isSubTaskCreationOpen: isSubtaskCreateEnabled,
                issueHierarchyLevel: issueHierarchyLevel
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ZyzP.AiIssueBreakdown), {
            onCreate: onSuggestedChildIssueCreateSuccess,
            childIssueTypes: childIssueTypes,
            isSubTaskCreationOpen: isSubtaskCreateEnabled,
            issueHierarchyLevel: issueHierarchyLevel
        });
    }, [
        childIssueTypes,
        issueTypeWithWorkflowValidators,
        isSubtaskCreateEnabled,
        issueHierarchyLevel,
        onSuggestedChildIssueCreateSuccess
    ]);
    return hasContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            childCount: hasExceededChildIssuesLimitInitialLoad ? childIssuesLimitExceededAnalyticsCount : allIssues.length,
            isChildIssuesLimitPanelDisplayed: hasExceededChildIssuesLimitInitialLoad
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        actionSubjectId: sourceName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Heading, {
        onAddChildClick: (0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') ? onAddChildClickWithAiBreakdownEnabled : onAddChildClick,
        sourceName: sourceName,
        childIssuesLimitStatus: childIssuesLimitStatus,
        issueHierarchyLevel: issueHierarchyLevel
    }), hasExceededChildIssuesLimitInitialLoad && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idb9k.ChildIssuesLimitPanel), {
        hasExceededIssuesLimitInitialLoad: hasExceededChildIssuesLimitInitialLoad
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hudGC.ChildIssuesLimitFlag), {
        isApproachingLimit: isApproachingLimit,
        childIssuesLimitStatus: childIssuesLimitStatus
    }), renderIssues, renderCreate, renderAIWorkBreakdown) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $313b34b423be6118$var$ProgressSummaryWithHideDoneIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7ZyzP", function(module, exports) {

$parcel$export(module.exports, "AiIssueBreakdown", () => $fbe6d9b56775c50e$export$fc560f6b89dab5a7);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $hJ992 = parcelRequire("hJ992");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $4ceCM = parcelRequire("4ceCM");

var $4Xcha = parcelRequire("4Xcha");

var $eJpse = parcelRequire("eJpse");

var $ctR9z = parcelRequire("ctR9z");

var $3koWU = parcelRequire("3koWU");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $guDlK = parcelRequire("guDlK");

var $3IgVu = parcelRequire("3IgVu");

var $23KeM = parcelRequire("23KeM");

var $3xyAb = parcelRequire("3xyAb");

var $66NsZ = parcelRequire("66NsZ");

var $1pxPJ = parcelRequire("1pxPJ");

var $9DK1a = parcelRequire("9DK1a");

var $gkTkz = parcelRequire("gkTkz");
const $fbe6d9b56775c50e$export$4dface15d86304a4 = ()=>(0, $eUqFw.useState)(false);
const $fbe6d9b56775c50e$export$fc560f6b89dab5a7 = ({ onCreate: onCreate, childIssueTypes: childIssueTypes, isSubTaskCreationOpen: isSubTaskCreationOpen, issueHierarchyLevel: issueHierarchyLevel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isLoading, setIsLoading] = $fbe6d9b56775c50e$export$4dface15d86304a4();
    const [{ currentStep: currentStep, suggestedChildIssues: suggestedChildIssues, promptValue: promptValue, selectedIssueIndex: selectedIssueIndex }, { setIssueBreakdownStep: setIssueBreakdownStep, setPromptValue: setPromptValue, setIssueTypeIds: setIssueTypeIds, setHeaderPromptValue: setHeaderPromptValue, resetIssueBreakdownState: resetIssueBreakdownState, updateSuggestedResult: updateSuggestedResult, removeCurrentSuggestedChildIssue: removeCurrentSuggestedChildIssue, unselectCurrentIndex: unselectCurrentIndex, updateStreamingStatus: updateStreamingStatus, getSuggestedLength: getSuggestedLength }] = (0, $3xyAb.useIssueBreakdown)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const parentIssueId = (0, $hJ992.useIssueId)() || '';
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const edition = (0, $guDlK.useEdition)(projectKey, true);
    const projectType = (0, $guDlK.useProjectType)(projectKey) || null;
    const projectId = (0, $guDlK.useProjectId)(projectKey);
    const application = (0, $guDlK.useApplication)(projectKey, true);
    const isIssueModalView = (0, $hJ992.useIsModal)();
    const [{ isModalOpen: isModalOpen, minimizableModalView: minimizableModalView }, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    const [selectedIssueType, setSelectedIssueType] = (0, $eUqFw.useState)();
    const [{ data: defaultStatus }, fetchDefaultStatus] = (0, $23KeM.useDefaultStatus)();
    const [{ data: defaultPriority }, fetchDefaultPriority] = (0, $3IgVu.useDefaultPriority)();
    /**
	 * Only close issue create modal for draft list step in case mini modal is in use elsewhere.
	 */ const closeIssueBreakdownModal = (0, $eUqFw.useCallback)(()=>{
        const isAiView = minimizableModalView === 'ai-enabled' || minimizableModalView === 'ai-enabled-minimized';
        if (isModalOpen && isAiView) closeIssueCreateModal(false);
    }, [
        closeIssueCreateModal,
        isModalOpen,
        minimizableModalView
    ]);
    const unselectAndCloseCurrentIssue = (0, $eUqFw.useCallback)(()=>{
        closeIssueBreakdownModal();
        unselectCurrentIndex();
    }, [
        closeIssueBreakdownModal,
        unselectCurrentIndex
    ]);
    const openIssueBreakdownCreateModal = (0, $eUqFw.useCallback)((childIssue)=>{
        if (!projectId || !parentIssueId) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.issue-view-services.src.child-issues.use-fetched-suggested-child-issuses', 'Error fetching suggested child issues, parentIssueId or projectId not');
            return;
        }
        openIssueCreateModal((0, $gkTkz.getIssueCreateModalPayload)({
            childIssue: childIssue,
            projectId: projectId,
            parentIssueId: parentIssueId,
            childIssueTypes: childIssueTypes,
            isSubTaskCreationOpen: isSubTaskCreationOpen
        }));
    }, [
        childIssueTypes,
        isSubTaskCreationOpen,
        openIssueCreateModal,
        parentIssueId,
        projectId
    ]);
    const onFetchSuggestedIssuesSuccess = (0, $eUqFw.useCallback)((response)=>{
        setIsLoading(false);
        setIssueBreakdownStep((0, $3xyAb.steps).draftListStep);
        setPromptValue(''); // clear the prompt if fetching was successful
        const suggestedChildIssuesData = response.suggestedChildIssues;
        if (suggestedChildIssuesData.length > 0) {
            updateSuggestedResult(response);
            const selectedIssue = suggestedChildIssuesData[0, $3xyAb.DEFAULT_SELECTED_ISSUE_INDEX];
            openIssueBreakdownCreateModal(selectedIssue);
        }
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiIssueBreakdown suggested', {
            suggestedChildIssues: response.suggestedChildIssues.length
        });
    }, [
        setIsLoading,
        setIssueBreakdownStep,
        setPromptValue,
        createAnalyticsEvent,
        updateSuggestedResult,
        openIssueBreakdownCreateModal
    ]);
    const onStreamComplete = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiIssueBreakdown suggested', {
            suggestedChildIssues: getSuggestedLength()
        });
        (0, $4ceCM.sendExperienceAnalytics)({
            experience: 'aiIssueBreakdown',
            wasExperienceSuccesful: true,
            analyticsSource: 'jiraSuggestedChildIssue',
            application: application ?? null,
            edition: edition ?? null
        });
    }, [
        application,
        createAnalyticsEvent,
        edition,
        getSuggestedLength
    ]);
    const onFetchSuggestedIssuesFailure = (0, $eUqFw.useCallback)(()=>{
        setIssueBreakdownStep('errorStep');
        setIsLoading(false);
    }, [
        setIsLoading,
        setIssueBreakdownStep
    ]);
    const { cancelFetchSuggestedChildIssues: cancelFetchSuggestedChildIssues, isFetchingSuggestedChildIssues: isFetchingSuggestedChildIssues } = (0, $eJpse.useFetchSuggestedChildIssues)(onFetchSuggestedIssuesSuccess, onFetchSuggestedIssuesFailure);
    /**
	 * Reset and close issue breakdown whenever it is cancelled.
	 */ const cancelIssueBreakdown = (0, $eUqFw.useCallback)(()=>{
        if (isLoading) {
            cancelFetchSuggestedChildIssues();
            setIsLoading(false);
        }
        if (isLoading || suggestedChildIssues.length <= 1) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiIssueBreakdown cancelled', {});
        else (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiIssueBreakdown discardedAll', {});
        closeIssueBreakdownModal();
        resetIssueBreakdownState();
    }, [
        cancelFetchSuggestedChildIssues,
        closeIssueBreakdownModal,
        isLoading,
        resetIssueBreakdownState,
        setIsLoading,
        createAnalyticsEvent,
        suggestedChildIssues.length
    ]);
    const onSubmitFetchSuggestedChildIssues = (0, $eUqFw.useCallback)((submittedIssueTypeIds)=>{
        if (isFetchingSuggestedChildIssues) return;
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction initiated', {
            aiFeatureName: 'intelligentWorkBreakdown',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1,
            edition: edition
        });
        // Only change the header prompt if there's a prompt value
        if (promptValue) setHeaderPromptValue(promptValue);
        submittedIssueTypeIds && setIssueTypeIds(submittedIssueTypeIds);
        updateStreamingStatus(true);
        currentStep !== (0, $3xyAb.steps).draftListStep && setIssueBreakdownStep((0, $3xyAb.steps).draftListStep);
        setSelectedIssueType(submittedIssueTypeIds?.[0]);
    }, [
        createAnalyticsEvent,
        currentStep,
        edition,
        isFetchingSuggestedChildIssues,
        promptValue,
        setHeaderPromptValue,
        setIssueBreakdownStep,
        setIssueTypeIds,
        updateStreamingStatus
    ]);
    const openNextSuggestedIssue = (0, $eUqFw.useCallback)(()=>{
        const hasNoSuggestions = suggestedChildIssues.length <= 1;
        const isNoIssueSelected = selectedIssueIndex === null;
        if (hasNoSuggestions || isNoIssueSelected) {
            cancelIssueBreakdown();
            return;
        }
        const nextChildIssueIndex = (selectedIssueIndex + 1) % suggestedChildIssues.length;
        openIssueBreakdownCreateModal(suggestedChildIssues[nextChildIssueIndex]);
    }, [
        cancelIssueBreakdown,
        openIssueBreakdownCreateModal,
        selectedIssueIndex,
        suggestedChildIssues
    ]);
    const onSubmitCreateIssue = (0, $eUqFw.useCallback)((childIssue, wasFormDirty)=>{
        // Just emitting event on create for now
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiIssueBreakdown created', {
            wasFormDirty: wasFormDirty
        });
        openNextSuggestedIssue();
        removeCurrentSuggestedChildIssue((0, $3xyAb.reasons).accept);
        onCreate(childIssue, {
            wasFormDirty: wasFormDirty,
            wasIwbUsed: true
        });
    }, [
        createAnalyticsEvent,
        onCreate,
        removeCurrentSuggestedChildIssue,
        openNextSuggestedIssue
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // When the parent issue has just 1 issue type in the hierarchy below it,
        // then clicking the Suggest issues button directly starts suggesting issues
        if (childIssueTypes.length === 1 && currentStep === (0, $3xyAb.steps).promptInputStep) {
            const issueTypeId = childIssueTypes.map((item)=>item.id);
            onSubmitFetchSuggestedChildIssues(issueTypeId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        childIssueTypes.length,
        currentStep,
        (0, $jMP2a.fireTrackAnalytics)
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // When user selects the child issue, trigger getting the default status
        selectedIssueType && fetchDefaultStatus(selectedIssueType);
        selectedIssueType && fetchDefaultPriority(selectedIssueType);
    }, [
        selectedIssueType,
        fetchDefaultStatus,
        fetchDefaultPriority
    ]);
    (0, $eUqFw.useEffect)(()=>subscribe?.((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_ALL_SUGGESTED_ISSUES, async ()=>{
            cancelIssueBreakdown();
        }), [
        cancelIssueBreakdown,
        subscribe
    ]);
    (0, $eUqFw.useEffect)(()=>subscribe?.((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES, async ()=>{
            selectedIssueIndex !== null && openIssueBreakdownCreateModal(suggestedChildIssues[selectedIssueIndex]);
        }), [
        suggestedChildIssues,
        openIssueBreakdownCreateModal,
        subscribe,
        selectedIssueIndex
    ]);
    (0, $eUqFw.useEffect)(()=>subscribe?.((0, $dNWQB.GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, async (payload)=>{
            if (payload.callbackPayload?.id !== (0, $4Xcha.GIC_CALLBACK_PAYLOAD_AI_BREAKDOWN_CREATE_ID) || !payload.createdIssueData) return;
            const wasFormDirty = payload.callbackPayload.data?.wasFormDirty ?? false;
            onSubmitCreateIssue(payload.createdIssueData, Boolean(wasFormDirty));
        }), [
        onSubmitCreateIssue,
        subscribe
    ]);
    (0, $eUqFw.useEffect)(()=>subscribe?.((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_SUGGESTED_ISSUE, async ()=>{
            if (selectedIssueIndex !== null) {
                openNextSuggestedIssue();
                removeCurrentSuggestedChildIssue((0, $3xyAb.reasons).reject);
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiIssueBreakdown discarded', {});
            }
        }), [
        closeIssueCreateModal,
        onSubmitCreateIssue,
        removeCurrentSuggestedChildIssue,
        openNextSuggestedIssue,
        selectedIssueIndex,
        subscribe,
        suggestedChildIssues,
        createAnalyticsEvent
    ]);
    const mounted = (0, $3koWU.useIsMounted)();
    /**
	 * When leaving a page (on unmount) we need to close issue breakdown and reset its state
	 */ (0, $eUqFw.useEffect)(()=>()=>{
            if (!mounted.current) unselectAndCloseCurrentIssue();
        }, [
        mounted,
        unselectAndCloseCurrentIssue
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (currentStep === (0, $3xyAb.steps).promptInputStep) // When the prompt is shown, we meassure the experience being served
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiIssueBreakdown served', {});
    }, [
        currentStep,
        createAnalyticsEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Auto trigger GIC dialog using first item after streaming complete
        if (currentStep === (0, $3xyAb.steps).draftListStep && selectedIssueIndex != null && !isModalOpen) openIssueBreakdownCreateModal(suggestedChildIssues[selectedIssueIndex]);
    }, [
        currentStep,
        isModalOpen,
        openIssueBreakdownCreateModal,
        selectedIssueIndex,
        suggestedChildIssues
    ]);
    if (isIssueModalView) return null;
    switch(currentStep){
        case (0, $3xyAb.steps).promptInputStep:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9DK1a.IssueBreakdownPrompt), {
                isLoading: isLoading,
                onSubmit: onSubmitFetchSuggestedChildIssues,
                onCancel: cancelIssueBreakdown,
                childIssueTypes: childIssueTypes,
                issueHierarchyLevel: issueHierarchyLevel
            });
        case (0, $3xyAb.steps).draftListStep:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $66NsZ.IssueBreakdownDraftList), {
                isLoading: isLoading,
                projectType: projectType,
                childIssueTypes: childIssueTypes,
                defaultStatus: defaultStatus,
                defaultPriority: defaultPriority,
                items: suggestedChildIssues,
                onSubmit: onSubmitFetchSuggestedChildIssues,
                onChangePrompt: setPromptValue,
                onDiscard: cancelIssueBreakdown,
                onClickItem: openIssueBreakdownCreateModal,
                onFocusPrompt: unselectAndCloseCurrentIssue,
                onStreamComplete: onStreamComplete,
                issueHierarchyLevel: issueHierarchyLevel
            });
        case (0, $3xyAb.steps).errorStep:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1pxPJ.IssueBreakdownError), {
                onRetry: onSubmitFetchSuggestedChildIssues,
                onCancel: cancelIssueBreakdown,
                issueHierarchyLevel: issueHierarchyLevel
            });
        case (0, $3xyAb.steps).defaultStep:
        default:
            return null;
    }
};

});
parcelRegister("eJpse", function(module, exports) {

$parcel$export(module.exports, "useFetchSuggestedChildIssues", () => $3ee382876459fc9e$export$5038739d1a550c87);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $6UQkz = parcelRequire("6UQkz");

var $dWLk9 = parcelRequire("dWLk9");
const $3ee382876459fc9e$export$5038739d1a550c87 = (onSuccess, onFailure)=>{
    const requestSignal = (0, $eUqFw.useRef)(null);
    const [isFetchingSuggestedChildIssues, setIsFetchingSuggestedChildIssue] = (0, $eUqFw.useState)(false);
    const cloudId = (0, $dWLk9.useCloudId)();
    const cancelFetchSuggestedChildIssues = (0, $eUqFw.useCallback)(()=>{
        if (requestSignal.current && isFetchingSuggestedChildIssues) {
            requestSignal.current.abort();
            setIsFetchingSuggestedChildIssue(false);
        }
    }, [
        isFetchingSuggestedChildIssues
    ]);
    const triggerFetchSuggestedChildIssues = (0, $eUqFw.useCallback)(async (params)=>{
        if (!params.parentIssueId) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.issue-view-services.src.child-issues.use-fetched-suggested-child-issuses', 'Error fetching suggested child issues');
            onFailure?.();
            return;
        }
        // If there's currently a request signal, abort so we can set a new one
        if (requestSignal.current) requestSignal.current.abort();
        try {
            requestSignal.current = new AbortController();
            setIsFetchingSuggestedChildIssue(true);
            const response = await (0, $6UQkz.fetchSuggestedChildIssuesData)(cloudId, params, requestSignal.current.signal);
            onSuccess?.(response);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.name === 'AbortError') return;
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.issue-view-services.src.child-issues.use-fetched-suggested-child-issuses', 'Error fetching suggested child issues', error instanceof Error ? error : undefined);
            onFailure?.();
        } finally{
            setIsFetchingSuggestedChildIssue(false);
        }
    }, [
        cloudId,
        onFailure,
        onSuccess
    ]);
    return {
        triggerFetchSuggestedChildIssues: triggerFetchSuggestedChildIssues,
        cancelFetchSuggestedChildIssues: cancelFetchSuggestedChildIssues,
        isFetchingSuggestedChildIssues: isFetchingSuggestedChildIssues
    };
};

});
parcelRegister("6UQkz", function(module, exports) {

$parcel$export(module.exports, "fetchSuggestedChildIssuesData", () => $62409481de277c47$export$d0caf56f20fdafa2);

var $huI7r = parcelRequire("huI7r");

var $kXzsJ = parcelRequire("kXzsJ");

const $62409481de277c47$export$6a075df0541b0173 = ()=>`
    query IssueBreakdownDataFetcher($issueTypeIds:[ID!], $parentIssueIdAri: ID!, $channelId: String, $additionalContext: String, $acceptedChildIssues: [JiraSuggestedIssueInput], $rejectedChildIssues: [JiraSuggestedIssueInput]) {
        jira  { 
            issueById(id: $parentIssueIdAri) {
                suggestedChildIssues(issueTypeIds:$issueTypeIds, channelId:$channelId, additionalContext: $additionalContext, acceptedChildIssues: $acceptedChildIssues, rejectedChildIssues: $rejectedChildIssues) {
                    channelId,
                    error,
                    suggestedChildIssues {
                        summary
                        description
                        issueTypeId
                    }
                }
            }
        }
    }
`;
const $62409481de277c47$export$d0caf56f20fdafa2 = async (cloudId, { channelId: channelId, parentIssueId: parentIssueId, additionalContext: additionalContext, acceptedChildIssues: acceptedChildIssues, rejectedChildIssues: rejectedChildIssues, issueTypeIds: issueTypeIds }, signal)=>{
    const parentIssueIdAri = (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        resourceType: 'issue',
        resourceId: parentIssueId,
        cloudId: cloudId
    });
    const { data: data, errors: errors } = await (0, $kXzsJ.getClient)('').query({
        operationName: 'IssueBreakdownDataFetcher',
        query: $62409481de277c47$export$6a075df0541b0173(),
        variables: {
            parentIssueIdAri: parentIssueIdAri,
            issueTypeIds: issueTypeIds,
            channelId: channelId,
            additionalContext: additionalContext,
            acceptedChildIssues: acceptedChildIssues,
            rejectedChildIssues: rejectedChildIssues
        },
        signal: signal
    });
    const dataError = data?.jira?.issueById?.suggestedChildIssues?.error;
    // GraphQL Response Error
    if (errors != null && errors.length > 0) {
        const [{ message: message }] = errors;
        throw new Error(message);
    }
    // AIMate data error, no more suggestions, not enough information
    // see: SuggestedChildIssuesError
    if (dataError) throw new Error(dataError);
    return {
        error: null,
        suggestedChildIssues: data?.jira?.issueById?.suggestedChildIssues?.suggestedChildIssues || [],
        channelId: data?.jira?.issueById?.suggestedChildIssues?.channelId || ''
    };
};

});


parcelRegister("3IgVu", function(module, exports) {

$parcel$export(module.exports, "useDefaultPriority", () => $038525f7810f9788$export$2f1951e3ee265106);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $lRmyA = parcelRequire("lRmyA");

var $hJ992 = parcelRequire("hJ992");

var $guDlK = parcelRequire("guDlK");
const $038525f7810f9788$var$getCreateMeta = async (projectIdOrKey, issueTypeId)=>{
    const resp = await (0, $lRmyA.performGetRequest)(`/rest/api/3/issue/createmeta/${projectIdOrKey}/issuetypes/${issueTypeId}`);
    return resp;
};
const $038525f7810f9788$export$6c4c9b3e84687e41 = ()=>(0, $eUqFw.useState)();
const $038525f7810f9788$export$2f1951e3ee265106 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const [defaultPriority, setDefaultPriority] = (0, $eUqFw.useState)();
    const [issueType, setIssueType] = $038525f7810f9788$export$6c4c9b3e84687e41();
    const fetchCreateMetaService = (0, $eUqFw.useCallback)((issueTypeId)=>$038525f7810f9788$var$getCreateMeta(projectKey, issueTypeId), [
        projectKey
    ]);
    const { loading: loading, error: error, data: data, fetch: fetchCreateMeta } = (0, $eEzyV.useService)(fetchCreateMetaService);
    const fetchDefaultPriority = (0, $eUqFw.useCallback)((issueTypeId)=>{
        if (!loading && issueTypeId !== issueType) {
            fetchCreateMeta(issueTypeId);
            setIssueType(issueTypeId);
        }
    }, [
        loading,
        issueType,
        fetchCreateMeta,
        setIssueType
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (data && Array.isArray(data.fields)) {
            const priorityField = data.fields.find((field)=>field.hasDefaultValue && field.fieldId === 'priority');
            // Set default priority, for given issue type, if there is none, it's none
            setDefaultPriority(priorityField?.defaultValue ?? undefined);
        }
    }, [
        data
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: defaultPriority
        },
        fetchDefaultPriority
    ];
};

});

parcelRegister("23KeM", function(module, exports) {

$parcel$export(module.exports, "useDefaultStatus", () => $d3eed6b419793279$export$a08fe3abeeb30ead);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $lRmyA = parcelRequire("lRmyA");

var $hJ992 = parcelRequire("hJ992");

var $guDlK = parcelRequire("guDlK");

var $gd0Sp = parcelRequire("gd0Sp");
const $d3eed6b419793279$var$getTransitions = async (cloudId, projectId, issueTypeId)=>{
    const resp = await (0, $lRmyA.performPostRequest)(`/gateway/api/jira/project-configuration/query/${cloudId}/2/transition/initial`, {
        body: JSON.stringify({
            projectId: projectId,
            issueTypeId: issueTypeId.toString()
        })
    });
    return resp;
};
const $d3eed6b419793279$export$6c4c9b3e84687e41 = ()=>(0, $eUqFw.useState)();
const $d3eed6b419793279$export$a08fe3abeeb30ead = ()=>{
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectId = (0, $guDlK.useProjectId)(projectKey);
    const [defaultStatus, setDefaultStatus] = (0, $eUqFw.useState)();
    const [issueType, setIssueType] = $d3eed6b419793279$export$6c4c9b3e84687e41();
    const fetchTransitionsService = (0, $eUqFw.useCallback)((issueTypeId)=>$d3eed6b419793279$var$getTransitions(cloudId, projectId ?? '', issueTypeId), [
        cloudId,
        projectId
    ]);
    const { loading: loading, error: error, data: data, fetch: fetchTransitions } = (0, $eEzyV.useService)(fetchTransitionsService);
    const fetchDefaultStatus = (0, $eUqFw.useCallback)((issueTypeId)=>{
        if (!loading && issueTypeId !== issueType) {
            fetchTransitions(issueTypeId);
            setIssueType(issueTypeId);
        }
    }, [
        loading,
        issueType,
        fetchTransitions,
        setIssueType
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (data && Array.isArray(data)) {
            const initialTransition = data.find((transition)=>transition.isInitial === true);
            // Set default transition, for given issue type, if there is none, it's none
            setDefaultStatus(initialTransition?.to ?? undefined);
        }
    }, [
        data
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: defaultStatus
        },
        fetchDefaultStatus
    ];
};

});

parcelRegister("66NsZ", function(module, exports) {

$parcel$export(module.exports, "IssueBreakdownDraftList", () => $b97fd6fad13d4744$export$7037e455f49403b2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8ydpf = parcelRequire("8ydpf");
var $b1T1Z = parcelRequire("b1T1Z");
var $78led = parcelRequire("78led");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $a0FBb = parcelRequire("a0FBb");

var $iRiA2 = parcelRequire("iRiA2");

var $1G0W2 = parcelRequire("1G0W2");

var $3xyAb = parcelRequire("3xyAb");

var $5IHDa = parcelRequire("5IHDa");

var $gkTkz = parcelRequire("gkTkz");

var $5W9m5 = parcelRequire("5W9m5");

var $jjzCA = parcelRequire("jjzCA");

var $j1edI = parcelRequire("j1edI");

var $2RZ3q = parcelRequire("2RZ3q");

var $13nDu = parcelRequire("13nDu");

var $3ZzRs = parcelRequire("3ZzRs");

var $bmXGb = parcelRequire("bmXGb");

var $l7Gqy = parcelRequire("l7Gqy");
const $b97fd6fad13d4744$export$7037e455f49403b2 = ({ onSubmit: onSubmit, onDiscard: onDiscard, onClickItem: onClickItem, onChangePrompt: onChangePrompt, onFocusPrompt: onFocusPrompt, onStreamComplete: onStreamComplete, isLoading: isLoading, items: items = [], projectType: projectType, defaultStatus: defaultStatus, defaultPriority: defaultPriority, childIssueTypes: childIssueTypes, issueHierarchyLevel: issueHierarchyLevel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ selectedIssueIndex: selectedIssueIndex, headerPromptValue: headerPromptValue, isStreaming: isStreaming, status: status }, { setSelectedIssueIndex: setSelectedIssueIndex, updateStreamingStatus: updateStreamingStatus, openDiscardSuggestionsModal: openDiscardSuggestionsModal }] = (0, $3xyAb.useIssueBreakdown)();
    const handleOnStop = (0, $eUqFw.useCallback)(()=>{
        if (items.length > 0) {
            updateStreamingStatus(false);
            onStreamComplete?.();
        } else onDiscard();
    }, [
        items.length,
        onDiscard,
        onStreamComplete,
        updateStreamingStatus
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            // Prevents issue modal from closing
            if (isStreaming) handleOnStop();
            else openDiscardSuggestionsModal();
        }
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            event.preventDefault();
            event.stopPropagation();
            const nextItemIndex = (0, $l7Gqy.getNextItemIndex)(items.length, selectedIssueIndex, event.key);
            if (nextItemIndex != null) {
                setSelectedIssueIndex(nextItemIndex);
                onClickItem(items[nextItemIndex]);
            }
        }
    }, [
        isStreaming,
        handleOnStop,
        openDiscardSuggestionsModal,
        items,
        selectedIssueIndex,
        setSelectedIssueIndex,
        onClickItem
    ]);
    const fieldRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        const { current: current } = fieldRef;
        if (isStreaming && current) current.focus({
            preventScroll: true
        });
    }, [
        isStreaming
    ]);
    const renderItems = (0, $eUqFw.useMemo)(()=>items.map((item, index)=>{
            const { summary: summary, issueTypeId: issueTypeId } = item;
            const selectedIssueType = (0, $gkTkz.getSelectedIssueType)(childIssueTypes, issueTypeId.toString());
            const statusProps = defaultStatus && {
                statusCategory: defaultStatus.name,
                statusId: defaultStatus.id,
                statusCategoryId: defaultStatus.statusCategory.id,
                statusName: defaultStatus.name
            };
            const priorityProps = defaultPriority && {
                issuePriorityUrl: defaultPriority.iconUrl,
                issuePriorityName: defaultPriority.name
            };
            const itemLineCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b97fd6fad13d4744$var$ItemLineCard, {
                isSelected: selectedIssueIndex === index,
                onClick: ()=>{
                    onClickItem(item);
                    setSelectedIssueIndex(index);
                },
                "data-testid": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-draft-list.item-line-card"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a0FBb.default), {
                id: "",
                issueKey: "",
                issueSummary: summary,
                isInlineEditEnabled: false,
                isInteractive: false,
                projectType: projectType,
                issueTypeName: selectedIssueType?.name,
                issueTypeIconUrl: selectedIssueType?.iconUrl,
                ...statusProps,
                ...priorityProps
            })));
            return itemLineCard;
        }), [
        items,
        childIssueTypes,
        defaultStatus,
        defaultPriority,
        selectedIssueIndex,
        projectType,
        onClickItem,
        setSelectedIssueIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ref: fieldRef,
        xcss: $b97fd6fad13d4744$var$promptContainerStyles,
        tabIndex: -1,
        onKeyDown: handleKeyDown
    }, (0, $1ybV0.ff)('navigation-blocker-for-ai-work-breakdown_tb7cx') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1G0W2.NavigationBlocker), {
        shouldModalBeShown: ()=>items.length > 0,
        customModalText: (0, $3ZzRs.default)
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ydpf.default), {
        shouldFitContainer: true,
        isShadow: true,
        spacing: "none",
        isLoading: isLoading || isStreaming,
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-draft-list.ai-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1edI.Header), {
        value: headerPromptValue,
        issueHierarchyLevel: issueHierarchyLevel
    }), renderItems, isStreaming && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iRiA2.IssueBreakdownLineSkeleton), null), isStreaming && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bmXGb.SubscribeToIssueBreakdown), {
        onComplete: onStreamComplete
    }), !isStreaming && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b97fd6fad13d4744$var$ActionsSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5W9m5.FeedbackForm), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b97fd6fad13d4744$var$Spacer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $13nDu.DiscardSuggestions), {
        onDiscard: onDiscard
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b97fd6fad13d4744$var$FooterSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78led.AiIcon), {
        size: "medium",
        label: ""
    }), isStreaming ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b97fd6fad13d4744$var$FooterText, {
        "data-testid": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-draft-list.issue-breakdown-footer-brand-text"
    }, formatMessage((0, $l7Gqy.getLoadingStatusMessage)(status))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b97fd6fad13d4744$var$Spacer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-draft-list.discard-suggestions-button-suggestions-button",
        type: "button",
        onClick: handleOnStop,
        interactionName: "auto-generated.issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-draft-list.discard-suggestions.discard-suggestions-button-suggestions-button.button"
    }, formatMessage((0, $5IHDa.default).labelStop), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b97fd6fad13d4744$var$EscText, null, formatMessage((0, $5IHDa.default).labelEscNonFinal)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b97fd6fad13d4744$var$FooterText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RZ3q.InputPrompt), {
        placeholder: formatMessage((0, $5IHDa.default).footerTextDraftList),
        onChange: onChangePrompt,
        onFocus: onFocusPrompt,
        onSubmit: onSubmit,
        isDisabled: isLoading
    }))), (0, $1ybV0.ff)('jira-ai-work-breakdown-disclaimer-update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1T1Z.AiFooter), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jjzCA.Footer), null)));
};
const $b97fd6fad13d4744$var$promptContainerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.200',
    marginBottom: 'space.200',
    border: 0,
    outline: 'none' // remove focus highlight
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b97fd6fad13d4744$var$ActionsSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1yt4utpp _zulpv77o _x3doqjrk",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b97fd6fad13d4744$var$FooterText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz131l _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b97fd6fad13d4744$var$FooterSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1yt4utpp _zulpv77o _x3do1ljb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b97fd6fad13d4744$var$Spacer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b97fd6fad13d4744$var$ItemLineCard = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q7txrc _2rko1l7b _1e0c1txw _kqswh2mm _1yt4119w _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tlgkglyw _19lc14ae _9oik18uv _1bnxglyw _jf4cnqa1",
            (__cmplp.isSelected ?? false) && "_11q729zg _4bfu18uv _1hmsglyw _ajmmnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b97fd6fad13d4744$var$EscText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkosqtm _1yt41b66 _syaz1gjq _11q7m7j4 _k48p1nn1 _18u012x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8ydpf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f44c422da244e149$export$2e2bcd8739ae039);
$parcel$export(module.exports, "defaultComponents", () => $f44c422da244e149$export$71abc632aa29e6fe);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4q38b = parcelRequire("4q38b");

var $bKxX9 = parcelRequire("bKxX9");
let $f44c422da244e149$var$namespaceUUID = 0;
// We don't yet have design system tokens representing the AI prism colour palette. We should replace this with
// equivalent tokens when available
const $f44c422da244e149$var$oldPalette = {
    dark: {
        blue: '#0055CC',
        // Blue 800
        teal: '#37B4C3',
        // Teal 500
        yellow: '#CF9F02'
    },
    light: {
        blue: '#1D7AFC',
        // Blue 600
        teal: '#8BDBE5',
        // Teal 300
        yellow: '#F8E6A0'
    }
};
const $f44c422da244e149$var$newPalette = {
    dark: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    },
    light: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    }
};
const $f44c422da244e149$var$AnimatedSvgContainer = ({ isLoading: isLoading, isBlurred: isBlurred, isShadow: isShadow, isBorderGrey: isBorderGrey })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const svgRef = (0, $eUqFw.useRef)(null);
    const namespaceId = (0, $eUqFw.useRef)();
    const palette = (0, $bKxX9.ff)('platform.ai-compliance-changes_wvov4') ? $f44c422da244e149$var$newPalette : $f44c422da244e149$var$oldPalette;
    const paletteForTheme = colorMode === 'dark' ? palette.dark : palette.light;
    if (namespaceId.current === undefined) {
        namespaceId.current = $f44c422da244e149$var$namespaceUUID;
        $f44c422da244e149$var$namespaceUUID += 1;
    }
    (0, $eUqFw.useEffect)(()=>{
        if (isLoading) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f44c422da244e149$var$SvgContainer, {
        isBlurred: isBlurred,
        isShadow: isShadow,
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), (0, $bKxX9.ff)('platform.ai-compliance-changes_wvov4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.25",
        stopColor: (0, $bKxX9.ff)('platform.ai-compliance-changes_wvov4') ? paletteForTheme.blue : paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), (0, $bKxX9.ff)('platform.ai-compliance-changes_wvov4') && isBorderGrey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        stroke: "var(--ds-background-accent-gray-subtler, #DFE1E6)",
        d: "M0 0h24v24H0Z",
        vectorEffect: "non-scaling-stroke"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    }))));
};
const $f44c422da244e149$var$AIContainer = ({ children: children, isLoading: isLoading, isShadow: isShadow = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', testId: testId, isBorderGrey: isBorderGrey, components: { ContainerComponent: ContainerComponent = $f44c422da244e149$var$Container, ContentComponent: ContentComponent = $f44c422da244e149$var$Content } = {}, ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContainerComponent, {
        ref: ref,
        "data-testid": testId,
        shouldFitContainer: shouldFitContainer
    }, (0, $bKxX9.ff)('platform.ai-compliance-changes_wvov4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f44c422da244e149$var$AnimatedSvgContainer, {
        isShadow: isShadow,
        isLoading: isLoading,
        isBorderGrey: isBorderGrey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f44c422da244e149$var$AnimatedSvgContainer, {
        isShadow: isShadow,
        isLoading: isLoading
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f44c422da244e149$var$AnimatedSvgContainer, {
        isLoading: isLoading,
        isBlurred: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContentComponent, {
        spacing: spacing
    }, children));
var $f44c422da244e149$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f44c422da244e149$var$AIContainer;
const $f44c422da244e149$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainer: shouldFitContainer, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm _1yt4v77o _1pbyb4wl",
            __cmplp.shouldFitContainer ? "_1bsb1wug" : "_1bsb1ns9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f44c422da244e149$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q7vuon _2rkoi2wt _16jlkb7n _1pbyb4wl _1bsb1osq",
            __cmplp.spacing === 'default' && "_1yt4u2gc",
            __cmplp.className
        ])
    });
});
const $f44c422da244e149$export$71abc632aa29e6fe = {
    ContainerComponent: $f44c422da244e149$var$Container,
    ContentComponent: $f44c422da244e149$var$Content
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f44c422da244e149$var$SvgContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isShadow: isShadow, isBlurred: isBlurred, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _2rkoftgi",
            __cmplp.isShadow ? "_16qs1ifw" : "_16qsglyw",
            __cmplp.isBlurred ? "_1bsb5cnj _4t3i5cnj _154iu2gc _1ltvu2gc _kdam7b89" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("b1T1Z", function(module, exports) {

$parcel$export(module.exports, "AiFooter", () => $e80e9ed6b38fd2dc$export$915814a2dcce5cf0);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $3EqqU = parcelRequire("3EqqU");
var $5ARvW = parcelRequire("5ARvW");

var $PdmhA = parcelRequire("PdmhA");

var $lkPEe = parcelRequire("lkPEe");

var $bAQOb = parcelRequire("bAQOb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $78led = parcelRequire("78led");

var $bodCx = parcelRequire("bodCx");

var $2BmDo = parcelRequire("2BmDo");
const $e80e9ed6b38fd2dc$var$AiFooterOld = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $e80e9ed6b38fd2dc$var$footerStyle,
        spread: "space-between",
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bodCx.AiInformationIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        spacing: "none",
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        rel: "noopener",
        target: "_blank",
        testId: "atlassian-intelligence.common.ui.ai-footer.disclaimer-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "p",
        xcss: $e80e9ed6b38fd2dc$var$linkStyle
    }, formatMessage((0, $2BmDo.default).disclaimerText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        testId: "atlassian-intelligence.common.ui.ai-footer.beta-lozenge",
        appearance: "new"
    }, formatMessage((0, $2BmDo.default).betaLozenge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $e80e9ed6b38fd2dc$var$spacerStyle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "p",
        xcss: $e80e9ed6b38fd2dc$var$textStyle
    }, formatMessage((0, $2BmDo.default).aiText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78led.AiIcon), {
        isDisabled: true,
        size: "small",
        label: ""
    }));
};
const $e80e9ed6b38fd2dc$var$AiFooterNew = ({ testId: testId, footerSpace: footerSpace, disclaimer: disclaimer, attribution: attribution, isBeta: isBeta = true })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // Render conditions based on media queries
    // empty if <= xs
    // short text if <= sm size
    // long text if >= sm size
    const renderAttributionText = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
            below: "xs",
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, formatMessage((0, $2BmDo.default).longAttributionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3EqqU.Hide), {
            below: "xs",
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
            below: "sm",
            as: "span"
        }, formatMessage((0, $2BmDo.default).shortAttributionText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3EqqU.Hide), {
            below: "sm",
            as: "span"
        }, formatMessage((0, $2BmDo.default).longAttributionText)))), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        testId: testId,
        xcss: $e80e9ed6b38fd2dc$var$footerStyle,
        spread: "space-between",
        alignBlock: "center",
        space: footerSpace ?? 'space.050'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bodCx.AiInformationIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        spacing: "none",
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        rel: "noopener",
        target: "_blank",
        testId: "atlassian-intelligence.common.ui.ai-footer.disclaimer-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $e80e9ed6b38fd2dc$var$linkStyle
    }, disclaimer ?? formatMessage((0, $2BmDo.default).disclaimerText))), isBeta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        testId: "atlassian-intelligence.common.ui.ai-footer.beta-lozenge",
        appearance: "new"
    }, formatMessage((0, $2BmDo.default).betaLozenge)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $e80e9ed6b38fd2dc$var$spacerStyle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $e80e9ed6b38fd2dc$var$textStyle
    }, attribution ?? renderAttributionText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78led.AiIcon), {
        isDisabled: true,
        size: "small",
        label: ""
    }));
};
const $e80e9ed6b38fd2dc$export$915814a2dcce5cf0 = (0, $bAQOb.componentWithFF)('jira-ai-footer-disclaimer-update', $e80e9ed6b38fd2dc$var$AiFooterNew, $e80e9ed6b38fd2dc$var$AiFooterOld);
const $e80e9ed6b38fd2dc$var$spacerStyle = (0, $1ZAYh.xcss)({
    flexGrow: 1
});
const $e80e9ed6b38fd2dc$var$footerStyle = (0, $1ZAYh.xcss)({
    borderTop: `1px solid ${`var(--ds-border, ${(0, $PdmhA).N40})`}`,
    paddingInline: 'space.150',
    paddingBlock: 'space.150'
});
const $e80e9ed6b38fd2dc$var$textStyle = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest',
    margin: 'space.0',
    padding: 'space.0',
    display: 'flex',
    alignItems: 'center'
});
const $e80e9ed6b38fd2dc$var$linkStyle = (0, $1ZAYh.xcss)({
    textDecoration: 'none',
    fontWeight: 'normal',
    color: 'color.text.subtlest'
});

});
parcelRegister("3EqqU", function(module, exports) {

$parcel$export(module.exports, "Hide", () => $695e689479cb6363$export$bed28288a051538);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $1ZAYh = parcelRequire("1ZAYh");

var $9SiaN = parcelRequire("9SiaN");
const $695e689479cb6363$var$hideAboveQueries = (0, $9SiaN.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $695e689479cb6363$var$hideBelowQueries = (0, $9SiaN.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $695e689479cb6363$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1ZAYh.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $byn9U.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $695e689479cb6363$var$hideAboveQueries[above],
            below && $695e689479cb6363$var$hideBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});
parcelRegister("9SiaN", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $1d5ed0ecf6688fbc$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $1d5ed0ecf6688fbc$export$b2a4e2b0c6417297);

var $byn9U = parcelRequire("byn9U");

var $gnQiH = parcelRequire("gnQiH");

var $4Ywu9 = parcelRequire("4Ywu9");
const $1d5ed0ecf6688fbc$export$918f8818cfbbeb2c = (input)=>{
    return (0, $gnQiH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $4Ywu9.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $1d5ed0ecf6688fbc$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $gnQiH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $4Ywu9.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("gnQiH", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $8ce21554f3c8bfb7$export$2d293d9871c38e91);
const $8ce21554f3c8bfb7$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '109.99rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $8ce21554f3c8bfb7$export$2d293d9871c38e91 = Object.keys($8ce21554f3c8bfb7$export$e5ee4fe8b989fd09);
const $8ce21554f3c8bfb7$export$b7ed752a57b4177b = $8ce21554f3c8bfb7$export$2d293d9871c38e91[0];

});



parcelRegister("5ARvW", function(module, exports) {

$parcel$export(module.exports, "Show", () => $c749d80f6b8dab23$export$f6a3d19be20f5819);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $1ZAYh = parcelRequire("1ZAYh");

var $9SiaN = parcelRequire("9SiaN");
function $c749d80f6b8dab23$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c749d80f6b8dab23$var$showAboveQueries = (0, $9SiaN.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $c749d80f6b8dab23$var$showBelowQueries = (0, $9SiaN.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $c749d80f6b8dab23$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $c749d80f6b8dab23$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1ZAYh.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $byn9U.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $c749d80f6b8dab23$var$defaultHiddenStyles,
            above && $c749d80f6b8dab23$var$showAboveQueries[above],
            below && $c749d80f6b8dab23$var$showBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});

parcelRegister("bodCx", function(module, exports) {

$parcel$export(module.exports, "AiInformationIcon", () => $9c0f32b60e1e6f15$export$3f046409b85d8b0c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $2ziLQ = parcelRequire("2ziLQ");

var $c0jFd = parcelRequire("c0jFd");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lG96T = parcelRequire("lG96T");
const $9c0f32b60e1e6f15$var$InfoIconSvg = ()=>{
    const fillColor = (0, $1ybV0.ff)('jira-ai-work-breakdown-disclaimer-update') ? `var(--ds-text-subtlest, ${(0, $PdmhA).N200})` : '#44546F';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15ZM9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z",
        fill: fillColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.25 8.25C8.25 7.83579 8.58579 7.5 9 7.5C9.41421 7.5 9.75 7.83579 9.75 8.25V12C9.75 12.4142 9.41421 12.75 9 12.75C8.58579 12.75 8.25 12.4142 8.25 12V8.25Z",
        fill: fillColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.75 6C9.75 6.41421 9.41421 6.75 9 6.75C8.58579 6.75 8.25 6.41421 8.25 6C8.25 5.58579 8.58579 5.25 9 5.25C9.41421 5.25 9.75 5.58579 9.75 6Z",
        fill: fillColor
    }));
};
const $9c0f32b60e1e6f15$export$3f046409b85d8b0c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if ((0, $1ybV0.ff)('jira-ai-work-breakdown-disclaimer-update')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        label: "atlassian-intelligence-info-icon",
        size: "small",
        glyph: $9c0f32b60e1e6f15$var$InfoIconSvg,
        primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N500})`,
        testId: "atlassian-intelligence.common.ui.ai-information-icon.atlassian-intelligence-info-icon"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "top",
        content: formatMessage((0, $lG96T.default).atlassianIntelligenceInformation, {
            link: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    appearance: "subtle-link",
                    spacing: "none",
                    href: "https://www.atlassian.com/trust/atlassian-intelligence",
                    rel: "noopener noreferrer",
                    target: "_blank"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9c0f32b60e1e6f15$var$LearnMoreWrapper, null, chunks))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        label: "atlassian-intelligence-info-icon",
        size: "small",
        glyph: $9c0f32b60e1e6f15$var$InfoIconSvg,
        primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N500})`,
        testId: "atlassian-intelligence.common.ui.ai-information-icon.atlassian-intelligence-info-icon"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9c0f32b60e1e6f15$var$LearnMoreWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz15cr _4bfu18uv _1hms8stv _ajmmnqa1 _k48p1nn1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lG96T", function(module, exports) {

$parcel$export(module.exports, "default", () => $30b543ef42419291$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $30b543ef42419291$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    atlassianIntelligenceInformation: {
        "id": "atlassian-intelligence.common.ai-information-icon.atlassian-intelligence-information",
        "defaultMessage": "The quality, accuracy, and reliability of information generated by Atlassian Intelligence may vary. <link>Learn more</link>"
    }
});

});


parcelRegister("2BmDo", function(module, exports) {

$parcel$export(module.exports, "default", () => $3478f613fde023cc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3478f613fde023cc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    betaLozenge: {
        "id": "atlassian-intelligence.common.ai-footer.beta-lozenge",
        "defaultMessage": "Beta"
    },
    disclaimerText: {
        "id": "atlassian-intelligence.common.ai-footer.disclaimer-text",
        "defaultMessage": "Content quality may vary"
    },
    // Remove aiText when cleaning up jira-ai-footer-disclaimer-update
    aiText: {
        "id": "atlassian-intelligence.common.ai-footer.ai-text",
        "defaultMessage": "Powered by Atlassian Intelligence"
    },
    shortAttributionText: {
        "id": "atlassian-intelligence.common.ai-footer.short-attribution-text",
        "defaultMessage": "Powered by AI"
    },
    longAttributionText: {
        "id": "atlassian-intelligence.common.ai-footer.long-attribution-text",
        "defaultMessage": "Powered by Atlassian Intelligence"
    }
});

});


parcelRegister("iRiA2", function(module, exports) {

$parcel$export(module.exports, "IssueBreakdownSkeleton", () => $2a77d2b373b706d5$export$c433f5fbbcdcd4bd);
$parcel$export(module.exports, "IssueBreakdownLineSkeleton", () => $2a77d2b373b706d5$export$6c4c21368486ae99);
/* issue-breakdown.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $jGmkc = parcelRequire("jGmkc");

var $iQCTi = parcelRequire("iQCTi");
const $2a77d2b373b706d5$var$svgStyles = null;
const $2a77d2b373b706d5$export$c433f5fbbcdcd4bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iQCTi))),
        containerStyles: {
            height: '7em'
        },
        className: (0, $7JEyt.default)([
            "_t6vd1x4e _hr4j1x4e"
        ])
    });
const $2a77d2b373b706d5$export$6c4c21368486ae99 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jGmkc))),
        containerStyles: {
            height: '3.4em'
        },
        className: (0, $7JEyt.default)([
            "_t6vd1x4e _hr4j1x4e"
        ])
    });

});
parcelRegister("jGmkc", function(module, exports) {
module.exports = new URL("issue-breakdown-line.tpl.93dbb47e.svg", import.meta.url).toString();

});

parcelRegister("iQCTi", function(module, exports) {
module.exports = new URL("issue-breakdown.tpl.bf971f77.svg", import.meta.url).toString();

});


parcelRegister("1G0W2", function(module, exports) {

$parcel$export(module.exports, "NavigationBlocker", () => $5f067262a2fc51b3$export$735100ebd3c32c8f);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $bk5GO = parcelRequire("bk5GO");
const $5f067262a2fc51b3$export$735100ebd3c32c8f = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { registerBlock: registerBlock } = (0, $kJlBc.useRouterActions)();
    const { shouldModalBeShown: shouldModalBeShown, customModalText: customModalText } = props;
    const promiseInfo = (0, $eUqFw.useRef)({
        resolve: ()=>{}
    });
    const [showModal, setShowModal] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        const unregister = registerBlock(()=>{
            /*
			 * This will run whenever the user tries to navigate away. This will show the styled modal.
			 * */ if (shouldModalBeShown()) return new Promise((resolve)=>{
                /*
					 * Note that using useState instead of useRef to store the promise
					 * does not work. Not really sure why.
					 * */ promiseInfo.current = {
                    resolve: resolve
                };
                setShowModal(true);
            });
            else return true;
        });
        return ()=>{
            unregister();
        };
    }, [
        registerBlock,
        shouldModalBeShown
    ]);
    (0, $eUqFw.useEffect)(()=>{
        /*
		 * The beforeunload listener will trigger when the user tries to close the browser tab or refresh the page. The styled modal won't work for this.
		 * */ const handleBeforeUnload = (event)=>{
            if (shouldModalBeShown()) {
                event.preventDefault();
                event.returnValue = true;
            } else return undefined;
        };
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('beforeunload', handleBeforeUnload);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        return ()=>window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [
        shouldModalBeShown
    ]);
    let title = formatMessage((0, $bk5GO.navigationBlockerDefaultMessages).navigationBlockModalTitle);
    let body = formatMessage((0, $bk5GO.navigationBlockerDefaultMessages).navigationBlockModalBody);
    let goBackButton = formatMessage((0, $bk5GO.navigationBlockerDefaultMessages).navigationBlockGoBackButton);
    let continueButton = formatMessage((0, $bk5GO.navigationBlockerDefaultMessages).navigationBlockContinueButton);
    if (customModalText) {
        title = formatMessage(customModalText.navigationBlockModalTitle);
        body = formatMessage(customModalText.navigationBlockModalBody);
        goBackButton = formatMessage(customModalText.navigationBlockGoBackButton);
        continueButton = formatMessage(customModalText.navigationBlockContinueButton);
    }
    return showModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: ()=>{
            setShowModal(false);
            promiseInfo.current.resolve(false);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: 'warning'
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        autoFocus: true,
        onClick: ()=>{
            setShowModal(false);
            promiseInfo.current.resolve(false);
        }
    }, goBackButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "warning",
        onClick: ()=>{
            setShowModal(false);
            promiseInfo.current.resolve(true);
        }
    }, continueButton))) : null;
};

});
parcelRegister("bk5GO", function(module, exports) {

$parcel$export(module.exports, "navigationBlockerDefaultMessages", () => $b52fead72ebdaca6$export$31174e5fae1d5173);

var $90IgZ = parcelRequire("90IgZ");
const $b52fead72ebdaca6$export$31174e5fae1d5173 = (0, $90IgZ.defineMessages)({
    navigationBlockModalTitle: {
        defaultMessage: "Your changes won\u2019t be saved",
        description: 'Title of modal shown when user is about to navigate away from the page',
        id: 'routing-utils.ui.navigation-blocker.navigation-block-modal-title'
    },
    navigationBlockModalBody: {
        defaultMessage: "We won\u2019t be able to save your data if you move away from this page",
        description: 'Body of modal shown when user is about to navigate away from the page',
        id: 'routing-utils.ui.navigation-blocker.navigation-block-modal-body'
    },
    navigationBlockGoBackButton: {
        defaultMessage: 'Go back',
        description: 'Text in button that will cancel the attempt at navigating away',
        id: 'routing-utils.ui.navigation-blocker.navigation-block-go-back-button'
    },
    navigationBlockContinueButton: {
        defaultMessage: 'Discard',
        description: 'Text in button that will discard the unsaved changes and continue navigating away',
        id: 'routing-utils.ui.navigation-blocker.navigation-block-continue-button'
    }
});

});


parcelRegister("gkTkz", function(module, exports) {

$parcel$export(module.exports, "getIssueCreateModalPayload", () => $c3f706b7327ee85b$export$3f51de4567818783);
$parcel$export(module.exports, "getSelectedIssueType", () => $c3f706b7327ee85b$export$9122bf637eb6acc2);

var $8Eye5 = parcelRequire("8Eye5");
var $5RBN8 = parcelRequire("5RBN8");

var $eZmml = parcelRequire("eZmml");

var $4Xcha = parcelRequire("4Xcha");

const $c3f706b7327ee85b$export$b2281bea954e3f04 = {
    minimizableModalView: 'ai-enabled',
    displayCreateAnotherIssueToggle: false,
    disableProjectDropdown: true
};
const $c3f706b7327ee85b$export$3f51de4567818783 = (data)=>{
    const { childIssue: childIssue, projectId: projectId, childIssueTypes: childIssueTypes, parentIssueId: parentIssueId, isSubTaskCreationOpen: isSubTaskCreationOpen } = data;
    const { summary: summary, description: description, issueTypeId: issueTypeId } = childIssue;
    const triggerPointKey = isSubTaskCreationOpen ? (0, $33ffe55cb7bcdadc$export$c5afabb7a17e802) : (0, $33ffe55cb7bcdadc$export$e1c8789144c4c810);
    const descriptionAdf = {
        adfValue: description ? (0, $8Eye5.doc)((0, $5RBN8.paragraph)(description)) : (0, $eZmml.getEmptyADF)()
    };
    return {
        ...$c3f706b7327ee85b$export$b2281bea954e3f04,
        payload: {
            project: {
                projectId: projectId
            },
            issueType: {
                issueTypeId: issueTypeId.toString()
            },
            issueTypes: childIssueTypes.map(({ id: id })=>id).join(', '),
            defaultValues: {
                singleLineTextFields: [
                    {
                        fieldId: 'summary',
                        text: summary
                    }
                ],
                richTextFields: [
                    {
                        fieldId: 'description',
                        richText: descriptionAdf
                    }
                ],
                parentField: {
                    issueId: parentIssueId
                }
            },
            // parentId is needed for subtask creation, parentField needed for child issues
            parentId: {
                parentId: parentIssueId
            }
        },
        callbackPayload: {
            id: (0, $4Xcha.GIC_CALLBACK_PAYLOAD_AI_BREAKDOWN_CREATE_ID),
            data: {
                wasFormDirty: false
            }
        },
        triggerPointKey: triggerPointKey,
        isSubTaskCreationOpen: isSubTaskCreationOpen
    };
};
const $c3f706b7327ee85b$export$9122bf637eb6acc2 = (childIssueTypes, issueTypeId)=>childIssueTypes.find(({ id: id })=>id === issueTypeId) || undefined;
const $c3f706b7327ee85b$export$8e55f0fefed9d1dc = (childIssueTypes)=>childIssueTypes.map((issueType)=>Number(issueType.id));

});

parcelRegister("5W9m5", function(module, exports) {

$parcel$export(module.exports, "FeedbackForm", () => $39ed1d2bf7a30673$export$ce859c56062f484c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $fvQWm = parcelRequire("fvQWm");

var $ffiyv = parcelRequire("ffiyv");

var $PdmhA = parcelRequire("PdmhA");

var $eLaLL = parcelRequire("eLaLL");

var $irg9D = parcelRequire("irg9D");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $guDlK = parcelRequire("guDlK");


var $75KG1 = parcelRequire("75KG1");
const $39ed1d2bf7a30673$export$ce859c56062f484c = ({ isDisabled: isDisabled = false })=>{
    const [isFeedbackDisabled, setIsFeedbackDisabled] = (0, $eUqFw.useState)(isDisabled);
    const [wasFeedbackSent, setWasFeedbackSent] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleFeedbackSent = (0, $eUqFw.useCallback)((wasSent)=>{
        setWasFeedbackSent(wasSent);
        setIsFeedbackDisabled(wasSent);
    }, []);
    const getSentiment = (0, $eUqFw.useCallback)((isPositive)=>isPositive ? 'good' : 'bad', []);
    const getFeedbackContext = (0, $eUqFw.useCallback)((isPositive)=>({
            entrypointId: (0, $77e74bb72ad76d10$export$25dc0a1e75f58d8f),
            feedbackCollectorId: (0, $77e74bb72ad76d10$export$2efe57de19370995),
            feedbackContext: [
                {
                    id: 'sentiment',
                    value: getSentiment(isPositive)
                },
                {
                    id: 'product',
                    value: projectType ?? ''
                },
                {
                    id: 'ai-experience',
                    value: 'issue-ai-intelligent-work-breakdown'
                }
            ],
            // Doing this allows for feedback to be reenabled if cancel button is clicked on feedback form
            onSubmit () {
                handleFeedbackSent(true);
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiIssueBreakdownFeedback submitted', {
                    sentiment: getSentiment(isPositive)
                });
            },
            onClose () {
                handleFeedbackSent(false);
            }
        }), [
        createAnalyticsEvent,
        handleFeedbackSent,
        projectType,
        getSentiment
    ]);
    const handleOnClick = (0, $eUqFw.useCallback)((isPositive)=>{
        if (!isFeedbackDisabled) {
            setIsFeedbackDisabled(true);
            openFeedbackCollector(getFeedbackContext(isPositive));
            const eventName = isPositive ? 'aiIssueBreakdownLikeButton' : 'aiIssueBreakdownDislikeButton';
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${eventName} clicked`, {});
        }
        // disable hover pop-up of feedback button
        return true;
    }, [
        createAnalyticsEvent,
        getFeedbackContext,
        isFeedbackDisabled,
        openFeedbackCollector
    ]);
    const likeButton = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fvQWm))), {
            primaryColor: isFeedbackDisabled ? `var(--ds-icon-disabled, ${0, $PdmhA.N70})` : `var(--ds-icon-subtle, ${0, $PdmhA.N200})`,
            size: "medium",
            label: formatMessage((0, $75KG1.default).feedbackIconLabel)
        }), [
        formatMessage,
        isFeedbackDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($39ed1d2bf7a30673$var$FormContainer, {
        "data-testid": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.common.feedback-form.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($39ed1d2bf7a30673$var$FeedbackGroup, null, wasFeedbackSent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.common.feedback-form.beta-lozenge",
        appearance: "success"
    }, formatMessage((0, $75KG1.default).feedbackSentLozenge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($39ed1d2bf7a30673$var$ButtonStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eLaLL.FeedbackButton), {
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.common.feedback-form.like-button",
        isDisabled: isFeedbackDisabled,
        isPositive: true,
        iconBefore: likeButton,
        onClick: ()=>handleOnClick(true),
        appearance: "subtle",
        tooltipContent: formatMessage((0, $75KG1.default).tooltipLike),
        spacing: "compact"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($39ed1d2bf7a30673$var$ButtonStyle, {
        isDislike: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eLaLL.FeedbackButton), {
        isDisabled: isFeedbackDisabled,
        isPositive: false,
        iconBefore: likeButton,
        onClick: ()=>handleOnClick(false),
        appearance: "subtle",
        tooltipContent: formatMessage((0, $75KG1.default).tooltipDislike),
        spacing: "compact",
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.common.feedback-form.dislike-button"
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $39ed1d2bf7a30673$var$FormContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulp1b66 _13lin7od _qrwqn7od _mrkb130s _1o0z130s _4cvr1h6o _1bah1yb4 _syazjjyb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $39ed1d2bf7a30673$var$FeedbackGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $39ed1d2bf7a30673$var$ButtonStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDislike: isDislike, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71l1ejb",
            (__cmplp.isDislike ?? false) && "_t9ec1sub",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eLaLL", function(module, exports) {

$parcel$export(module.exports, "FeedbackButton", () => $64c9bc19ff22ee7d$export$116fedbe5e2e2bd8);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $3MV1G = parcelRequire("3MV1G");

var $8cU5f = parcelRequire("8cU5f");

var $bFzGY = parcelRequire("bFzGY");

var $4QtBR = parcelRequire("4QtBR");

var $kQ2mc = parcelRequire("kQ2mc");

var $2tFzl = parcelRequire("2tFzl");
const $64c9bc19ff22ee7d$export$116fedbe5e2e2bd8 = ({ appearance: appearance, children: children, iconBefore: iconBefore, isErrorReport: isErrorReport, isDisabled: isDisabled, isPositive: isPositive, isSelected: isSelected, label: label, onClick: onClick, onSubmit: onSubmit, offset: offset, placement: placement, spacing: spacing, testId: testId, tooltipContent: tooltipContent })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [submittedPrompt] = (0, $4QtBR.useSubmittedPrompt)();
    const [feedbackContext] = (0, $4QtBR.useResponseFeedbackContext)();
    const { onSubmitFeedback: onSubmitFeedback } = (0, $kQ2mc.useFeedbackService)(submittedPrompt, feedbackContext);
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'submitted',
            actionSubject: 'feedback'
        });
        // Prevent opening of the popup if the click event has been explicity handled by the parent
        const handled = onClick(event);
        if (handled) return;
        setIsOpen(true);
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const handleSubmit = (0, $eUqFw.useCallback)(async (data, isPositiveFeedback)=>{
        await onSubmitFeedback(data, isPositiveFeedback);
        onSubmit && onSubmit();
    }, [
        onSubmit,
        onSubmitFeedback
    ]);
    const handleClose = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: handleClose,
        placement: placement,
        offset: offset,
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2tFzl.FeedbackPopupContent), {
                isErrorReport: isErrorReport,
                isPositive: isPositive,
                onClose: handleClose,
                onSubmit: handleSubmit,
                setInitialFocusRef: setInitialFocusRef
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: tooltipContent ?? null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                "aria-label": label,
                appearance: appearance,
                spacing: spacing,
                iconBefore: iconBefore,
                onClick: handleClick,
                isSelected: isSelected,
                isDisabled: isDisabled,
                testId: testId
            }, children))
    });
};

});
parcelRegister("4QtBR", function(module, exports) {

$parcel$export(module.exports, "PromptContainer", () => $dcb2bd1b244cae22$export$f996e810bab47dad);
$parcel$export(module.exports, "usePromptActions", () => $dcb2bd1b244cae22$export$b69cbf7f2fd4c7ba);
$parcel$export(module.exports, "useResponseFeedbackContext", () => $dcb2bd1b244cae22$export$7737761958d6bb6c);
$parcel$export(module.exports, "usePromptResponse", () => $dcb2bd1b244cae22$export$775e0e2ce513f8e7);
$parcel$export(module.exports, "usePrompt", () => $dcb2bd1b244cae22$export$fc7731b33eb53a93);
$parcel$export(module.exports, "useSubmittedPrompt", () => $dcb2bd1b244cae22$export$80b178470b13c8ae);
$parcel$export(module.exports, "usePromptIsLoading", () => $dcb2bd1b244cae22$export$912d74d2ad112159);
$parcel$export(module.exports, "usePromptIsSubmitted", () => $dcb2bd1b244cae22$export$20b39be031988e7a);
$parcel$export(module.exports, "useScopedId", () => $dcb2bd1b244cae22$export$1f910160e5ac22b);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $hompL = parcelRequire("hompL");

var $5t21L = parcelRequire("5t21L");
const $dcb2bd1b244cae22$var$initialState = {
    idPrefix: '',
    isLoading: false,
    isSubmitted: false,
    prompt: '',
    response: undefined,
    submittedPrompt: '',
    cancellable: undefined
};
const $dcb2bd1b244cae22$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    initialState: $dcb2bd1b244cae22$var$initialState,
    actions: $5t21L.actions
});
const $dcb2bd1b244cae22$export$f996e810bab47dad = (0, $heB5U.createContainer)($dcb2bd1b244cae22$export$390f32400eaf98c9, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                idPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))()
            });
        }
});
const $dcb2bd1b244cae22$export$b69cbf7f2fd4c7ba = (0, $ggKAj.createActionsHook)($dcb2bd1b244cae22$export$390f32400eaf98c9);
const $dcb2bd1b244cae22$export$7737761958d6bb6c = (0, $ggKAj.createHook)($dcb2bd1b244cae22$export$390f32400eaf98c9, {
    selector: (state)=>state.response?.additionalFeedbackContext
});
const $dcb2bd1b244cae22$var$usePromptResponseGeneric = (0, $ggKAj.createHook)($dcb2bd1b244cae22$export$390f32400eaf98c9, {
    selector: (state)=>state.response
});
function $dcb2bd1b244cae22$export$775e0e2ce513f8e7() {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return $dcb2bd1b244cae22$var$usePromptResponseGeneric();
}
const $dcb2bd1b244cae22$export$fc7731b33eb53a93 = (0, $ggKAj.createHook)($dcb2bd1b244cae22$export$390f32400eaf98c9, {
    selector: (state)=>state.prompt
});
const $dcb2bd1b244cae22$export$80b178470b13c8ae = (0, $ggKAj.createHook)($dcb2bd1b244cae22$export$390f32400eaf98c9, {
    selector: (state)=>state.submittedPrompt
});
const $dcb2bd1b244cae22$export$912d74d2ad112159 = (0, $ggKAj.createHook)($dcb2bd1b244cae22$export$390f32400eaf98c9, {
    selector: (state)=>state.isLoading
});
const $dcb2bd1b244cae22$export$20b39be031988e7a = (0, $ggKAj.createHook)($dcb2bd1b244cae22$export$390f32400eaf98c9, {
    selector: (state)=>state.isSubmitted
});
const $dcb2bd1b244cae22$var$getScopedId = (state, idSuffix)=>`${state.idPrefix}_${idSuffix}`;
const $dcb2bd1b244cae22$export$1f910160e5ac22b = (0, $ggKAj.createHook)($dcb2bd1b244cae22$export$390f32400eaf98c9, {
    selector: $dcb2bd1b244cae22$var$getScopedId
});

});
parcelRegister("5t21L", function(module, exports) {

$parcel$export(module.exports, "actions", () => $df7842c2df3fa903$export$e324594224ef24da);
function $df7842c2df3fa903$var$onHandlePrompt(nextPrompt) {
    return async (_, { onPrompt: onPrompt })=>{
        try {
            return await onPrompt(nextPrompt);
        } catch (e) {
            // Ignore errors as this is expected to be handled in the consumer
            return undefined;
        }
    };
}
const $df7842c2df3fa903$export$e324594224ef24da = {
    onUpdate (prompt) {
        return ({ setState: setState })=>{
            // Update input prompt
            setState({
                prompt: prompt
            });
        };
    },
    onSubmit (nextPrompt) {
        return async ({ getState: getState, setState: setState, dispatch: dispatch }, { onPromptSuccess: onPromptSuccess })=>{
            // Set loading state
            setState({
                isLoading: true,
                isSubmitted: true,
                submittedPrompt: nextPrompt
            });
            const { cancellable: cancellable } = getState();
            // Cancel any in-flight requests
            if (cancellable) cancellable();
            const cancellablePromise = new Promise((resolve, reject)=>{
                // Allow this request to be cancelled
                setState({
                    cancellable: reject
                });
            });
            try {
                const nextResponse = await Promise.race([
                    dispatch($df7842c2df3fa903$var$onHandlePrompt(nextPrompt)),
                    cancellablePromise
                ]);
                nextResponse?.type === 'success' && onPromptSuccess && onPromptSuccess(nextResponse.payload);
                // Set successful response into state
                setState({
                    isLoading: false,
                    response: nextResponse
                });
            } catch (e) {
            // Pending promise was cancelled
            }
        };
    }
};

});


parcelRegister("kQ2mc", function(module, exports) {

$parcel$export(module.exports, "useFeedbackService", () => $8258ff91181694d2$export$fdeb51de8e2ac66d);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $9Anw5 = parcelRequire("9Anw5");

var $lGLse = parcelRequire("lGLse");

var $hFkS5 = parcelRequire("hFkS5");
const $8258ff91181694d2$var$FEEDBACK_ENDPOINT = '/gateway/api/feedback-collector-api/feedback';
const $8258ff91181694d2$var$REQUEST_TYPE = '594';
const $8258ff91181694d2$var$EMBED_KEY = 'a64ab7a8-2ce8-4942-884d-0f3090ef971e';
const $8258ff91181694d2$var$MAX_SUMMARY_LENGTH = 100;
// The custom fields for consent are defined in this file: src/packages/platform/ui/help-panel/src/services/feedback/index.tsx
// HOWEVER, they are not exported and as this feedback collector is expected to be a temporary solution the change hasn't been
// made to export them.
const $8258ff91181694d2$var$CONTACT_FIELD_ID = 'customfield_10043';
const $8258ff91181694d2$var$CONTACT_TRUE_VALUE = '10109';
const $8258ff91181694d2$var$CONTACT_FALSE_VALUE = '10111';
const $8258ff91181694d2$var$RESEARCH_FIELD_ID = 'customfield_10044';
const $8258ff91181694d2$var$RESEARCH_TRUE_VALUE = '10110';
const $8258ff91181694d2$var$RESEARCH_FALSE_VALUE = '10112';
const $8258ff91181694d2$var$FEEDBACK_SUBMITTED_FLAG = {
    id: (0, $eo17r.toFlagId)('atlassian-intelligence.ui.prompt-response.feedback.submitted'),
    type: 'success',
    title: (0, $hFkS5.default).feedbackSubmittedFlagTitle,
    description: (0, $hFkS5.default).feedbackSubmittedFlagDescription
};
const $8258ff91181694d2$var$normalizeTextForSummary = (feedbackText)=>{
    if (!feedbackText.length) return '<no summary>';
    const singleLineFeedbackText = feedbackText.replace(/\n/g, ' ');
    return singleLineFeedbackText.length > $8258ff91181694d2$var$MAX_SUMMARY_LENGTH ? `${singleLineFeedbackText.substring(0, $8258ff91181694d2$var$MAX_SUMMARY_LENGTH)}...` : singleLineFeedbackText;
};
const $8258ff91181694d2$var$getFeedbackFieldsWithConsent = ({ data: data, feedbackContext: feedbackContext, isPositive: isPositive, emailAddress: emailAddress, displayName: displayName })=>{
    const { feedbackText: feedbackText, contactConsentPrompt: contactConsentPrompt, researchConsentPrompt: researchConsentPrompt } = data;
    return [
        {
            id: 'summary',
            value: `[${isPositive ? '+' : '-'}] ${$8258ff91181694d2$var$normalizeTextForSummary(feedbackText)}`
        },
        {
            id: 'description',
            value: feedbackText
        },
        {
            id: 'email',
            value: emailAddress ?? 'do-not-reply@atlassian.com'
        },
        {
            id: 'customfield_10045',
            value: displayName ?? 'unknown'
        },
        {
            id: 'aaidOrHash',
            value: ''
        },
        {
            id: 'customfield_10047',
            value: feedbackContext
        },
        {
            id: $8258ff91181694d2$var$CONTACT_FIELD_ID,
            value: [
                {
                    id: contactConsentPrompt ? $8258ff91181694d2$var$CONTACT_TRUE_VALUE : $8258ff91181694d2$var$CONTACT_FALSE_VALUE
                }
            ]
        },
        {
            id: $8258ff91181694d2$var$RESEARCH_FIELD_ID,
            value: [
                {
                    id: researchConsentPrompt ? $8258ff91181694d2$var$RESEARCH_TRUE_VALUE : $8258ff91181694d2$var$RESEARCH_FALSE_VALUE
                }
            ]
        }
    ];
};
const $8258ff91181694d2$var$normalizeFeedbackContext = (feedbackContext)=>feedbackContext.map(({ id: id, value: value })=>`${id}: ${value}`).join('\n');
const $8258ff91181694d2$var$removeName = (prompt, name)=>prompt.replace(new RegExp(name, 'gi'), 'XXX');
const $8258ff91181694d2$var$removeNames = (prompt, userFullname)=>userFullname.split(' ').reduce((acc, name)=>name === '' ? acc : $8258ff91181694d2$var$removeName(acc, name), prompt);
const $8258ff91181694d2$var$removeEmailAddresses = (prompt)=>prompt.replace(new RegExp('([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\\.[a-zA-Z0-9_-]+)', 'gi'), 'XXX@XXX.XXX');
const $8258ff91181694d2$var$removePII = (prompt, userFullname)=>$8258ff91181694d2$var$removeEmailAddresses($8258ff91181694d2$var$removeNames(prompt, userFullname));
const $8258ff91181694d2$export$fdeb51de8e2ac66d = (prompt, additionalFeedbackContext)=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const onSubmitFeedback = (0, $eUqFw.useCallback)(async (data, isPositive)=>{
        if (!data.feedbackText && !data.sharePrompt) {
            showFlag($8258ff91181694d2$var$FEEDBACK_SUBMITTED_FLAG);
            // Do nothing, probably the user just wanted to send a thumbs up / thumbs down rating
            return Promise.resolve();
        }
        const feedbackContext = [
            {
                id: 'Location',
                value: (0, $9Anw5.default)(window?.location?.href ?? '')
            },
            {
                id: 'Screen Resolution',
                value: `${window?.screen?.width ?? 'unknown'} x ${window?.screen?.height ?? 'unknown'}`
            },
            {
                id: 'User-Agent',
                value: `${window?.navigator?.userAgent ?? 'unknown'}`
            },
            {
                id: 'Rating',
                value: isPositive ? 'Thumbs up' : 'Thumbs down'
            }
        ];
        if (data.sharePrompt && prompt) feedbackContext.push({
            id: 'Prompt',
            value: $8258ff91181694d2$var$removePII(prompt, loggedInUser?.displayName ?? '')
        });
        if (additionalFeedbackContext?.length && data.sharePrompt) feedbackContext.push(...additionalFeedbackContext);
        try {
            await fetch($8258ff91181694d2$var$FEEDBACK_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    data: btoa(JSON.stringify({
                        feedback: {
                            requestType: $8258ff91181694d2$var$REQUEST_TYPE,
                            embedKey: $8258ff91181694d2$var$EMBED_KEY,
                            fields: $8258ff91181694d2$var$getFeedbackFieldsWithConsent({
                                data: data,
                                feedbackContext: $8258ff91181694d2$var$normalizeFeedbackContext(feedbackContext),
                                isPositive: isPositive,
                                emailAddress: loggedInUser?.emailAddress,
                                displayName: loggedInUser?.displayName
                            })
                        }
                    }))
                })
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'onFeedbackSubmit',
                    packageName: 'jiraAtlassianIntelligence',
                    teamName: 'gravity-ai'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
        }
        showFlag($8258ff91181694d2$var$FEEDBACK_SUBMITTED_FLAG);
        return Promise.resolve();
    }, [
        loggedInUser?.displayName,
        loggedInUser?.emailAddress,
        prompt,
        showFlag,
        additionalFeedbackContext
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            onSubmitFeedback: onSubmitFeedback
        }), [
        onSubmitFeedback
    ]);
};

});
parcelRegister("hFkS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb69c0485790c263$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bb69c0485790c263$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    feedbackSubmittedFlagTitle: {
        "id": "atlassian-intelligence.services.feedback.feedback-submitted-flag-title",
        "defaultMessage": "Thank you for sharing your query"
    },
    feedbackSubmittedFlagDescription: {
        "id": "atlassian-intelligence.services.feedback.feedback-submitted-flag-description",
        "defaultMessage": "Your valuable feedback helps us continually improve our products."
    }
});

});


parcelRegister("2tFzl", function(module, exports) {

$parcel$export(module.exports, "FeedbackPopupContent", () => $d95e622ad6ef7a19$export$9ca94f39d69b2936);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $bT7k5 = parcelRequire("bT7k5");

var $hI5oG = parcelRequire("hI5oG");

var $jWuk1 = parcelRequire("jWuk1");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $xeS7R = parcelRequire("xeS7R");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $44XPJ = parcelRequire("44XPJ");
const $d95e622ad6ef7a19$var$FEEDBACK_TEXT_FIELD = 'feedback-text';
const $d95e622ad6ef7a19$var$SHARE_PROMPT_CHECKBOX = 'share-prompt';
const $d95e622ad6ef7a19$var$CONTACT_CONSENT_PROMPT_CHECKBOX = 'contact-consent-prompt';
const $d95e622ad6ef7a19$var$RESEARCH_CONSENT_PROMT_CHECKBOX = 'research-consent-prompt';
// The height of the text area should be 160px - there is a 12px combined padding and here we have 148px height
const $d95e622ad6ef7a19$var$MAX_TEXTAREA_HEIGHT = '148px';
const $d95e622ad6ef7a19$var$MIN_TEXTAREA_ROWS = 7;
const $d95e622ad6ef7a19$export$9ca94f39d69b2936 = ({ isErrorReport: isErrorReport, isPositive: isPositive, onClose: onClose, onSubmit: onSubmit, setInitialFocusRef: setInitialFocusRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [submitting, setSubmitting] = (0, $eUqFw.useState)(false);
    const handleOnSubmit = async (event)=>{
        event.preventDefault();
        if (!submitting) {
            setSubmitting(true);
            if (isErrorReport) await onSubmit({
                feedbackText: '',
                sharePrompt: true,
                contactConsentPrompt: false,
                researchConsentPrompt: false
            }, isPositive);
            else {
                const data = new FormData(event.currentTarget);
                const feedbackText = data.get($d95e622ad6ef7a19$var$FEEDBACK_TEXT_FIELD)?.toString() ?? '';
                const sharePrompt = data.get($d95e622ad6ef7a19$var$SHARE_PROMPT_CHECKBOX) === $d95e622ad6ef7a19$var$SHARE_PROMPT_CHECKBOX;
                const contactConsentPrompt = data.get($d95e622ad6ef7a19$var$CONTACT_CONSENT_PROMPT_CHECKBOX) === $d95e622ad6ef7a19$var$CONTACT_CONSENT_PROMPT_CHECKBOX;
                const researchConsentPrompt = data.get($d95e622ad6ef7a19$var$RESEARCH_CONSENT_PROMT_CHECKBOX) === $d95e622ad6ef7a19$var$RESEARCH_CONSENT_PROMT_CHECKBOX;
                await onSubmit({
                    feedbackText: feedbackText,
                    sharePrompt: sharePrompt,
                    contactConsentPrompt: contactConsentPrompt,
                    researchConsentPrompt: researchConsentPrompt
                }, isPositive);
            }
            setSubmitting(false);
            onClose();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: "space.300",
        xcss: $d95e622ad6ef7a19$var$containerStyles,
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.feedback-popup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
        onSubmit: handleOnSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium"
    }, formatMessage((0, $44XPJ.default).heading)), !isErrorReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": formatMessage((0, $44XPJ.default).close),
        appearance: "subtle",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            size: "medium",
            label: formatMessage((0, $44XPJ.default).close)
        }),
        onClick: onClose,
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.close-button"
    }))), isErrorReport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, formatMessage((0, $44XPJ.default).errorReportDescription)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockEnd: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, formatMessage((0, $44XPJ.default).textAreaHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d95e622ad6ef7a19$var$textAreaContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xeS7R.default), {
        name: $d95e622ad6ef7a19$var$FEEDBACK_TEXT_FIELD,
        appearance: "none",
        minimumRows: $d95e622ad6ef7a19$var$MIN_TEXTAREA_ROWS,
        maxHeight: $d95e622ad6ef7a19$var$MAX_TEXTAREA_HEIGHT // This keeps the text area at a constant height alongside min rows
        ,
        "aria-label": formatMessage((0, $44XPJ.default).textAreaHeader),
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.text-area",
        ref: (0, $1ybV0.ff)('jnlis-223-feedback-collector-autofocus_5d8tz') ? setInitialFocusRef : undefined
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        name: $d95e622ad6ef7a19$var$SHARE_PROMPT_CHECKBOX,
        value: $d95e622ad6ef7a19$var$SHARE_PROMPT_CHECKBOX,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $d95e622ad6ef7a19$var$subtleTextStyles
        }, formatMessage((0, $44XPJ.default).shareQueryPromptJnlis612)),
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.share-prompt-checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        name: $d95e622ad6ef7a19$var$CONTACT_CONSENT_PROMPT_CHECKBOX,
        value: $d95e622ad6ef7a19$var$CONTACT_CONSENT_PROMPT_CHECKBOX,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $d95e622ad6ef7a19$var$subtleTextStyles
        }, formatMessage((0, $44XPJ.default).contactConsentPromptJnlis612, {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                    target: "_blank"
                }, chunks)
        })),
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.contact-consent-prompt-checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        name: $d95e622ad6ef7a19$var$RESEARCH_CONSENT_PROMT_CHECKBOX,
        value: $d95e622ad6ef7a19$var$RESEARCH_CONSENT_PROMT_CHECKBOX,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $d95e622ad6ef7a19$var$subtleTextStyles
        }, formatMessage((0, $44XPJ.default).researchConsentPromptJnlis612)),
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.research-consent-prompt-checkbox"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignInline: "end"
    }, isErrorReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        type: "button",
        onClick: onClose
    }, formatMessage((0, $44XPJ.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        type: "submit",
        appearance: "primary",
        isLoading: submitting,
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.submit-button"
    }, formatMessage(isErrorReport ? (0, $44XPJ.default).shareQuery : (0, $44XPJ.default).sendFeedback))))));
};
const $d95e622ad6ef7a19$var$containerStyles = (0, $1ZAYh.xcss)({
    width: '448px',
    borderRadius: 'border.radius'
});
const $d95e622ad6ef7a19$var$textAreaContainerStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.input',
    borderRadius: 'border.radius.100',
    padding: 'space.075',
    border: `2px solid ${`var(--ds-border-input, ${(0, $PdmhA).N30})`}`,
    marginBottom: "var(--ds-space-200, 16px)"
});
const $d95e622ad6ef7a19$var$subtleTextStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    fontSize: '14px',
    lineHeight: "var(--ds-space-250, 20px)"
});

});
parcelRegister("44XPJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a4c0eec65529e80$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4a4c0eec65529e80$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorReportDescription: {
        "id": "atlassian-intelligence.common.feedback-button.feedback-popup-content.error-report-description",
        "defaultMessage": "Share your query to help us improve search results."
    },
    shareQuery: {
        "id": "atlassian-intelligence.common.feedback-button.feedback-popup-content.share-query",
        "defaultMessage": "Share Query"
    },
    cancel: {
        "id": "atlassian-intelligence.common.feedback-button.feedback-popup-content.cancel",
        "defaultMessage": "Cancel"
    },
    /* eslint-disable jira/i18n/id-named-by-package */ heading: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.heading",
        "defaultMessage": "Help us improve Atlassian Intelligence"
    },
    close: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.close",
        "defaultMessage": "Close"
    },
    sendFeedback: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.send-feedback",
        "defaultMessage": "Send feedback"
    },
    contactConsentPrompt: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.contact-consent-prompt",
        "defaultMessage": "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <link>Atlassian Privacy Policy</link>."
    },
    researchConsentPrompt: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.research-consent-prompt",
        "defaultMessage": "I'd like to participate in product research."
    },
    textAreaHeader: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.text-area-header",
        "defaultMessage": "How was your search experience?"
    },
    shareQueryPromptJnlis612: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.share-query-prompt-jnlis-612",
        "defaultMessage": "Include my search query and response in my feedback"
    },
    contactConsentPromptJnlis612: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.contact-consent-prompt-jnlis-612",
        "defaultMessage": "Atlassian can contact me to learn more about this feedback and I acknowledge the <link>Atlassian Privacy Policy</link>"
    },
    researchConsentPromptJnlis612: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.research-consent-prompt-jnlis-612",
        "defaultMessage": "I want to participate in Atlassian\u2019s product research"
    }
});

});



parcelRegister("irg9D", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $8d3d8a971c5329dd$export$4be696be8a3bff13);
$parcel$export(module.exports, "useFeedbackCollectorActions", () => $8d3d8a971c5329dd$export$dfb2ee2d9e73fa48);
$parcel$export(module.exports, "FeedbackActionsSubscriber", () => $8d3d8a971c5329dd$export$c35dbf16ebe9df04);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
const $8d3d8a971c5329dd$export$d4c72bab9d6cc13a = {
    isFeedbackCollectorOpen: false,
    entrypointId: undefined,
    email: undefined,
    additionalFields: undefined,
    feedbackTitle: undefined,
    feedbackContext: undefined,
    feedbackCollectorId: undefined,
    // default value of this prop is true so making sure inititally it is true
    showTypeField: true,
    submitButtonLabel: undefined,
    canBeContactedLabel: undefined,
    summaryPlaceholder: undefined,
    feedbackGroupLabels: undefined,
    onClose: undefined,
    feedbackTitleDetails: undefined,
    triggerRef: undefined,
    renderCustomContent: undefined
};
const $8d3d8a971c5329dd$export$e324594224ef24da = {
    openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
            // Reset to initial state to clear any leftover state
            dispatch($8d3d8a971c5329dd$export$e324594224ef24da.resetFeedbackCollectorState());
            setState({
                ...feedbackCollectorProps,
                isFeedbackCollectorOpen: true
            });
        },
    closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
            const { triggerRef: triggerRef } = getState();
            if (triggerRef) // Unfortunately we need a setTimeout here to delay the execution cycle because modal is yet to be closed
            setTimeout(()=>triggerRef.current?.focus(), 50);
            setState({
                isFeedbackCollectorOpen: false,
                triggerRef: undefined
            });
        },
    resetFeedbackCollectorState: ()=>({ setState: setState })=>{
            setState({
                ...$8d3d8a971c5329dd$export$d4c72bab9d6cc13a
            });
        },
    updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
            setState({
                renderCustomContent: updatedCustomRenderContent
            });
        },
    updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
            setState({
                additionalFields: updatedAdditionalFields
            });
        }
};
const $8d3d8a971c5329dd$var$Store = (0, $a61MH.createStore)({
    name: 'feedback-collector',
    initialState: $8d3d8a971c5329dd$export$d4c72bab9d6cc13a,
    actions: $8d3d8a971c5329dd$export$e324594224ef24da
});
const $8d3d8a971c5329dd$export$4be696be8a3bff13 = (0, $ggKAj.createHook)($8d3d8a971c5329dd$var$Store);
const $8d3d8a971c5329dd$export$dfb2ee2d9e73fa48 = (0, $ggKAj.createActionsHook)($8d3d8a971c5329dd$var$Store);
const $8d3d8a971c5329dd$export$c35dbf16ebe9df04 = (0, $dYfll.createSubscriber)($8d3d8a971c5329dd$var$Store, {
    selector: null
});

});

const $77e74bb72ad76d10$export$25dc0a1e75f58d8f = '54736f0e-415b-4b1f-b9ad-88042b17120b';
const $77e74bb72ad76d10$export$2efe57de19370995 = 'ddac4251-3a49-462d-8a6b-f602fe8ac06a';

parcelRegister("75KG1", function(module, exports) {

$parcel$export(module.exports, "default", () => $818a45dfca61be3a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $818a45dfca61be3a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    feedbackSentLozenge: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.common.feedback-form.feedback-sent-lozenge",
        "defaultMessage": "Feedback Sent"
    },
    feedbackIconLabel: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.common.feedback-form.feedback-icon-label",
        "defaultMessage": "Feedback Icon"
    },
    tooltipLike: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.common.feedback-form.tooltip-like",
        "defaultMessage": "Good response"
    },
    tooltipDislike: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.common.feedback-form.tooltip-dislike",
        "defaultMessage": "Bad response"
    }
});

});


parcelRegister("jjzCA", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $7ec622a6624449ca$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $ffiyv = parcelRequire("ffiyv");

var $bodCx = parcelRequire("bodCx");

var $5JgJ2 = parcelRequire("5JgJ2");

var $71caB = parcelRequire("71caB");

var $1EDo6 = parcelRequire("1EDo6");
const $7ec622a6624449ca$export$a06f1c675e846f6f = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7ec622a6624449ca$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bodCx.AiInformationIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        spacing: "none",
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        rel: "noopener noreferrer",
        target: "_blank",
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.common.footer.info-message"
    }, formatMessage((0, $1EDo6.default).infoText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.common.footer.beta-lozenge",
        appearance: "new"
    }, formatMessage((0, $1EDo6.default).betaLozenge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7ec622a6624449ca$var$FooterSectionSpacer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7ec622a6624449ca$var$FooterText, null, formatMessage((0, $1EDo6.default).aiText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $71caB.AiIcon), {
        label: ""
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7ec622a6624449ca$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1yt4utpp _zulpv77o _x3do1ljb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7ec622a6624449ca$var$FooterText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7ec622a6624449ca$var$FooterSectionSpacer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("71caB", function(module, exports) {

$parcel$export(module.exports, "AiIcon", () => $25902ce60ab38859$export$762da6f7f5ace732);

var $eUqFw = parcelRequire("eUqFw");
const $25902ce60ab38859$export$762da6f7f5ace732 = ({ color: color = "var(--ds-icon, #626F86)", size: size = 16, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: `0 0 ${size} ${size}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4468 8.00016C11.4468 7.63197 11.7453 7.3335 12.1134 7.3335H13.3334C13.7016 7.3335 14.0001 7.63197 14.0001 8.00016C14.0001 8.36835 13.7016 8.66683 13.3334 8.66683H12.1134C11.7453 8.66683 11.4468 8.36835 11.4468 8.00016Z",
        fill: color
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.99992 2C8.36811 2 8.66659 2.29848 8.66659 2.66667V3.88667C8.66659 4.25486 8.36811 4.55333 7.99992 4.55333C7.63173 4.55333 7.33325 4.25486 7.33325 3.88667V2.66667C7.33325 2.29848 7.63173 2 7.99992 2Z",
        fill: color
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 8.00016C2 7.63197 2.29848 7.3335 2.66667 7.3335H3.88667C4.25486 7.3335 4.55333 7.63197 4.55333 8.00016C4.55333 8.36835 4.25486 8.66683 3.88667 8.66683H2.66667C2.29848 8.66683 2 8.36835 2 8.00016Z",
        fill: color
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.99992 11.4468C8.36811 11.4468 8.66659 11.7453 8.66659 12.1134V13.3334C8.66659 13.7016 8.36811 14.0001 7.99992 14.0001C7.63173 14.0001 7.33325 13.7016 7.33325 13.3334V12.1134C7.33325 11.7453 7.63173 11.4468 7.99992 11.4468Z",
        fill: color
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.52851 9.52876C9.78886 9.26841 10.211 9.26841 10.4713 9.52876L13.138 12.1954C13.3983 12.4558 13.3983 12.8779 13.138 13.1382C12.8776 13.3986 12.4555 13.3986 12.1952 13.1382L9.52851 10.4716C9.26816 10.2112 9.26816 9.78911 9.52851 9.52876Z",
        fill: color
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.138 2.86177C13.3983 3.12212 13.3983 3.54423 13.138 3.80458L10.4713 6.47124C10.211 6.73159 9.78886 6.73159 9.52851 6.47124C9.26816 6.21089 9.26816 5.78878 9.52851 5.52843L12.1952 2.86177C12.4555 2.60142 12.8776 2.60142 13.138 2.86177Z",
        fill: color
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.86201 2.86177C3.12236 2.60142 3.54447 2.60142 3.80482 2.86177L6.47149 5.52843C6.73183 5.78878 6.73183 6.21089 6.47149 6.47124C6.21114 6.73159 5.78903 6.73159 5.52868 6.47124L2.86201 3.80458C2.60166 3.54423 2.60166 3.12212 2.86201 2.86177Z",
        fill: color
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.47149 9.52876C6.73183 9.78911 6.73183 10.2112 6.47149 10.4716L3.80482 13.1382C3.54447 13.3986 3.12236 13.3986 2.86201 13.1382C2.60166 12.8779 2.60166 12.4558 2.86201 12.1954L5.52868 9.52876C5.78903 9.26841 6.21114 9.26841 6.47149 9.52876Z",
        fill: color
    }));

});

parcelRegister("1EDo6", function(module, exports) {

$parcel$export(module.exports, "default", () => $80a965c1bfa47991$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $80a965c1bfa47991$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    betaLozenge: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.common.footer.beta-lozenge",
        "defaultMessage": "Beta"
    },
    infoText: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.common.footer.info-text",
        "defaultMessage": "Content quality may vary"
    },
    aiText: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.common.footer.ai-text",
        "defaultMessage": "Powered by Atlassian Intelligence"
    }
});

});


parcelRegister("j1edI", function(module, exports) {

$parcel$export(module.exports, "Header", () => $16b05c446c422da4$export$8b251419efc915eb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dl0RD = parcelRequire("dl0RD");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jfn7G = parcelRequire("jfn7G");
const $16b05c446c422da4$export$8b251419efc915eb = ({ value: value, issueHierarchyLevel: issueHierarchyLevel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderValue = (0, $eUqFw.useMemo)(()=>value || formatMessage((0, $jfn7G.default).defaultPrompt, {
            issueType: issueHierarchyLevel && issueHierarchyLevel > 0 ? 'issues' : 'tasks'
        }), [
        formatMessage,
        issueHierarchyLevel,
        value
    ]);
    // Using Code component as Tag truncates text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16b05c446c422da4$var$HeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dl0RD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16b05c446c422da4$var$PromptValue, {
        "data-testid": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.common.header.value"
    }, renderValue)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16b05c446c422da4$var$HeaderContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4utpp _n7zl1ljb",
            __cmplp.className
        ])
    });
});
const $16b05c446c422da4$var$PromptValue = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ect41ha4 _1wybdlk8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jfn7G", function(module, exports) {

$parcel$export(module.exports, "default", () => $f49ecd352a2b1880$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f49ecd352a2b1880$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    defaultPrompt: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.common.header.default-prompt",
        "defaultMessage": "Suggest {issueType, select, tasks {subtasks} issues {child issues} other {child issues}}"
    }
});

});


parcelRegister("2RZ3q", function(module, exports) {

$parcel$export(module.exports, "InputPrompt", () => $9b04b96dfcdb4f67$export$9dbc846a601e7a53);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cf2Y4 = parcelRequire("cf2Y4");

var $autRb = parcelRequire("autRb");
const $9b04b96dfcdb4f67$export$9dbc846a601e7a53 = ({ onChange: onChange, onFocus: onFocus, onSubmit: onSubmit, value: value, placeholder: placeholder, testId: testId, isDisabled: isDisabled = false, autoFocus: autoFocus = false })=>{
    const handleOnChange = (0, $eUqFw.useCallback)((event)=>{
        onChange?.(event.target.value);
    }, [
        onChange
    ]);
    const handleOnKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape') return; // We expect Esc to propagate from input field
        event.stopPropagation();
        if (event.key === 'Enter') onSubmit();
    }, [
        onSubmit
    ]);
    const fieldRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        const { current: current } = fieldRef;
        if (autoFocus && current) {
            (0, $autRb.smoothScrollIntoCenterIfNeeded)(current);
            current.focus({
                preventScroll: true
            });
        }
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b04b96dfcdb4f67$var$InputContainer, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ref: fieldRef,
        onChange: handleOnChange,
        onKeyDown: handleOnKeyDown,
        onFocus: onFocus,
        width: "100%",
        appearance: "none",
        maxLength: 300,
        placeholder: placeholder,
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.common.input-prompt",
        /**
     * We're letting "Textfield" handle it's own state and only update the
     * IssueBreakdownAiContainer store on the changes. That way
     * updates to the value don't cause re-renders and jumps of the caret.
     */ defaultValue: value,
        isDisabled: isDisabled,
        isCompact: true
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b04b96dfcdb4f67$var$InputContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("13nDu", function(module, exports) {

$parcel$export(module.exports, "DiscardSuggestions", () => $a828f301ea0562d8$export$1207edf3dc352675);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6zOB7 = parcelRequire("6zOB7");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3xyAb = parcelRequire("3xyAb");

var $f5u71 = parcelRequire("f5u71");
const $a828f301ea0562d8$export$1207edf3dc352675 = ({ onDiscard: onDiscard })=>{
    const [{ isDiscardSuggestionsModalOpen: isDiscardSuggestionsModalOpen }, { openDiscardSuggestionsModal: openDiscardSuggestionsModal, closeDiscardSuggestionsModal: closeDiscardSuggestionsModal }] = (0, $3xyAb.useIssueBreakdown)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onDiscardClick = (0, $eUqFw.useCallback)(()=>{
        onDiscard();
        closeDiscardSuggestionsModal();
    }, [
        closeDiscardSuggestionsModal,
        onDiscard
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a828f301ea0562d8$var$ButtonsRightSide, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a828f301ea0562d8$var$StyledButton, {
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-draft-list.discard-suggestions.discard-suggestions-button",
        type: "button",
        appearance: "subtle",
        onClick: openDiscardSuggestionsModal
    }, formatMessage((0, $f5u71.default).labelDiscardSuggestions))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isDiscardSuggestionsModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-draft-list.discard-suggestions.modal",
        onClose: closeDiscardSuggestionsModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "warning",
        isMultiline: true
    }, formatMessage((0, $f5u71.default).warningTitleModal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), {
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-draft-list.discard-suggestions.body"
    }, formatMessage((0, $f5u71.default).warningBodyModal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "subtle",
        "aria-label": formatMessage((0, $f5u71.default).labelCancelModal),
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-draft-list.discard-suggestions.cancel-button",
        onClick: closeDiscardSuggestionsModal
    }, formatMessage((0, $f5u71.default).labelCancelModal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "warning",
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-draft-list.discard-suggestions.discard-button",
        "aria-label": formatMessage((0, $f5u71.default).labelDiscardModal),
        onClick: onDiscardClick
    }, formatMessage((0, $f5u71.default).labelDiscardModal))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a828f301ea0562d8$var$ButtonsRightSide = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bahesu3 _1e0c1txw _18s8u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a828f301ea0562d8$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $6zOB7.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("f5u71", function(module, exports) {

$parcel$export(module.exports, "default", () => $6248546c3a833440$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6248546c3a833440$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    labelDiscardSuggestions: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.discard-suggestions.label-discard-suggestions",
        "defaultMessage": "Discard and close"
    },
    labelDiscardModal: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.discard-suggestions.label-discard-modal",
        "defaultMessage": "Discard"
    },
    labelCancelModal: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.discard-suggestions.label-cancel-modal",
        "defaultMessage": "Cancel"
    },
    warningTitleModal: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.discard-suggestions.warning-title-modal",
        "defaultMessage": "Are you sure you want to discard all suggestions?"
    },
    warningBodyModal: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.discard-suggestions.warning-body-modal",
        "defaultMessage": "You're going to lose all suggestions if you continue."
    }
});

});


parcelRegister("3ZzRs", function(module, exports) {

$parcel$export(module.exports, "default", () => $940d82dc040b733d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $940d82dc040b733d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    navigationBlockModalTitle: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.navigation-block-modal-title",
        "defaultMessage": "Generated Issues will be lost"
    },
    navigationBlockModalBody: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.navigation-block-modal-body",
        "defaultMessage": "Any changes made to this form will be lost if you leave this page without saving."
    },
    navigationBlockGoBackButton: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.navigation-block-go-back-button",
        "defaultMessage": "Cancel"
    },
    navigationBlockContinueButton: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.navigation-block-continue-button",
        "defaultMessage": "Continue"
    }
});

});

parcelRegister("bmXGb", function(module, exports) {

$parcel$export(module.exports, "SubscribeToIssueBreakdown", () => $cf5a49fe0f67ec6f$export$119d3461ccdfcbea);

var $eUqFw = parcelRequire("eUqFw");

var $hLh1o = parcelRequire("hLh1o");

var $3xyAb = parcelRequire("3xyAb");
const $cf5a49fe0f67ec6f$export$119d3461ccdfcbea = ({ onComplete: onComplete })=>{
    const [{ channelId: channelId, headerPromptValue: headerPromptValue, acceptedChildIssues: acceptedChildIssues, rejectedChildIssues: rejectedChildIssues, issueTypeIds: issueTypeIds }, { updateStreamingStatus: updateStreamingStatus, setStreamingError: setStreamingError, setChannelId: setChannelId, addSuggestedIssue: addSuggestedIssue, setSelectedIssueIndex: setSelectedIssueIndex }] = (0, $3xyAb.useIssueBreakdown)();
    const onNextStatus = (0, $eUqFw.useCallback)((data)=>{
        if (data.status === 'COMPLETE') {
            updateStreamingStatus(false);
            onComplete?.();
            setSelectedIssueIndex(0);
        } else {
            updateStreamingStatus(true, data.status);
            data.channelId && setChannelId(data.channelId);
        }
    }, [
        onComplete,
        setChannelId,
        setSelectedIssueIndex,
        updateStreamingStatus
    ]);
    const onNextSuggestion = (0, $eUqFw.useCallback)(({ summary: summary, description: description, issueTypeId: issueTypeId })=>{
        addSuggestedIssue({
            summary: summary,
            description: description,
            issueTypeId: issueTypeId
        });
    }, [
        addSuggestedIssue
    ]);
    const onSuggestionError = (0, $eUqFw.useCallback)(()=>{
        setStreamingError();
    }, [
        setStreamingError
    ]);
    const onError = (0, $eUqFw.useCallback)(()=>{
        setStreamingError();
    }, [
        setStreamingError
    ]);
    const onTimeout = (0, $eUqFw.useCallback)(()=>{
        setStreamingError();
    }, [
        setStreamingError
    ]);
    const query = {
        channelId: channelId,
        additionalContext: headerPromptValue,
        acceptedChildIssues: acceptedChildIssues,
        rejectedChildIssues: rejectedChildIssues,
        issueTypeIds: issueTypeIds
    };
    const params = {
        query: query,
        onNextStatus: onNextStatus,
        onNextSuggestion: onNextSuggestion,
        onSuggestionError: onSuggestionError,
        onError: onError,
        onTimeout: onTimeout
    };
    (0, $hLh1o.useIssueBreakdownSubscription)(params);
    return null;
};

});
parcelRegister("hLh1o", function(module, exports) {

$parcel$export(module.exports, "useIssueBreakdownSubscription", () => $838bb526108a3dbc$export$6cf329cbb9de2410);

var $93vjn = parcelRequire("93vjn");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $2Shq0 = parcelRequire("2Shq0");
var $lSeXP = parcelRequire("lSeXP");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $4ceCM = parcelRequire("4ceCM");

var $guDlK = parcelRequire("guDlK");

var $dWLk9 = parcelRequire("dWLk9");

var $bg8Xq = parcelRequire("bg8Xq");
const $838bb526108a3dbc$var$SUBSCRIPTION_TIMEOUT = 120000; // 120s timeout
const $838bb526108a3dbc$export$6cf329cbb9de2410 = (params)=>{
    const { query: query, onNextSuggestion: onNextSuggestion, onNextStatus: onNextStatus, onSuggestionError: onSuggestionError, onError: onError, onTimeout: onTimeout } = params;
    const { issueTypeIds: issueTypeStringIds, acceptedChildIssues: acceptedChildIssues = [], rejectedChildIssues: rejectedChildIssues = [], additionalContext: additionalContext, channelId: channelId } = query;
    const siteId = (0, $dWLk9.useCloudId)();
    const issueId = (0, $hJ992.useIssueId)() || '';
    const sourceIssueId = (0, $2Shq0.JiraIssueAri).create({
        issueId: issueId,
        siteId: siteId
    }).toString();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const application = (0, $guDlK.useApplication)(projectKey, true);
    const edition = (0, $guDlK.useEdition)(projectKey, true);
    const sendErrorMetrics = (0, $eUqFw.useCallback)((error)=>{
        const experience = 'aiIssueBreakdown';
        const analyticsSource = 'jiraSuggestedChildIssue';
        switch(error){
            // Success cases for expected error
            case (0, $bg8Xq.subscriptionErrors).notEnoughInformation:
            case (0, $bg8Xq.subscriptionErrors).noFurtherSuggestions:
            case (0, $bg8Xq.subscriptionErrors).unethicalContent:
                (0, $4ceCM.sendExperienceAnalytics)({
                    experience: experience,
                    wasExperienceSuccesful: true,
                    analyticsSource: analyticsSource,
                    application: application ?? null,
                    edition: edition ?? null,
                    additionalAttributes: {
                        error: error
                    }
                });
                break;
            // Unsuccessful cases for unexpected errors
            case (0, $bg8Xq.subscriptionErrors).communicationsFailures:
            default:
                (0, $4ceCM.sendExperienceAnalytics)({
                    experience: experience,
                    wasExperienceSuccesful: false,
                    analyticsSource: analyticsSource,
                    application: application ?? null,
                    edition: edition ?? null,
                    additionalAttributes: {
                        error: error ?? (0, $bg8Xq.subscriptionErrors).unclassified
                    }
                });
        }
    }, [
        application,
        edition
    ]);
    const timeoutRef = (0, $eUqFw.useRef)();
    const resetTimeout = (0, $eUqFw.useCallback)(()=>{
        if ((0, $1ybV0.ff)('iwb-subscription-timeout_g05rq')) {
            if (onTimeout) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(()=>onTimeout?.(), $838bb526108a3dbc$var$SUBSCRIPTION_TIMEOUT);
            }
        }
    }, [
        onTimeout
    ]);
    if ((0, $1ybV0.ff)('iwb-subscription-timeout_g05rq')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useEffect)(()=>{
        resetTimeout();
        return ()=>clearTimeout(timeoutRef.current);
    }, [
        resetTimeout
    ]);
    (0, $iWLL0.useSubscription)((0, $eUqFw.useMemo)(()=>({
            subscription: (0, $93vjn.default),
            variables: {
                channelId: channelId,
                additionalContext: additionalContext,
                sourceIssueId: sourceIssueId,
                excludeSimilarIssues: acceptedChildIssues.concat(rejectedChildIssues),
                issueTypeIds: issueTypeStringIds?.map((issueTypeId)=>(0, $lSeXP.JiraIssueTypeAri).create({
                        siteId: siteId,
                        issueTypeId: issueTypeId
                    }).toString())
            },
            onNext: (data)=>{
                resetTimeout();
                const subscriptionData = data?.jira?.onSuggestedChildIssue;
                // onNext is called with undefined data when the subscription is first established
                if (!subscriptionData) return;
                const { __typename: __typename } = subscriptionData;
                if (__typename === 'JiraSuggestedChildIssueStatus') {
                    const { status: status } = subscriptionData;
                    onNextStatus?.({
                        status: status,
                        channelId: subscriptionData.channelId
                    });
                    return;
                }
                if (__typename === 'JiraSuggestedIssue') {
                    const { summary: summary, description: description, issueTypeId: issueTypeId } = subscriptionData;
                    const suggestion = {
                        summary: summary || '',
                        description: description || '',
                        issueTypeId: (issueTypeId || '').split('issue-type/').at(-1) || ''
                    };
                    onNextSuggestion?.(suggestion);
                    return;
                }
                if (__typename === 'JiraSuggestedChildIssueError') {
                    const { error: error } = subscriptionData;
                    sendErrorMetrics(error);
                    onSuggestionError?.(error);
                }
            },
            onError: onError
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        sourceIssueId
    ]));
};

});
parcelRegister("93vjn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8436df548d61a713$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9e99e1fbe9a6b66d2fd0a655ca1c212>>
 * @relayHash 903fb2ec9f5c8898995222d6cac65bd8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1da15cf236373bb2495fdf6295d8e4feee7ba6cf999bb82faa737d9d50833d6e
const $8436df548d61a713$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "additionalContext"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "channelId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "excludeSimilarIssues"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueTypeIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceIssueId"
    }, v5 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "additionalContext",
                            "variableName": "additionalContext"
                        },
                        {
                            "kind": "Variable",
                            "name": "channelId",
                            "variableName": "channelId"
                        },
                        {
                            "kind": "Variable",
                            "name": "excludeSimilarIssues",
                            "variableName": "excludeSimilarIssues"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueTypeIds",
                            "variableName": "issueTypeIds"
                        },
                        {
                            "kind": "Variable",
                            "name": "sourceIssueId",
                            "variableName": "sourceIssueId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "onSuggestedChildIssue",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "summary"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                }
                            ],
                            "type": "JiraSuggestedIssue"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "channelId"
                                }
                            ],
                            "type": "JiraSuggestedChildIssueStatus"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "error"
                                }
                            ],
                            "type": "JiraSuggestedChildIssueError"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueBreakdownSubscription",
            "selections": v5 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueBreakdownSubscription",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "id": "1da15cf236373bb2495fdf6295d8e4feee7ba6cf999bb82faa737d9d50833d6e",
            "metadata": {},
            "name": "issueBreakdownSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$8436df548d61a713$var$node.hash = "cee363799ea6d781699bb631f0927768";
var $8436df548d61a713$export$2e2bcd8739ae039 = $8436df548d61a713$var$node;

});

parcelRegister("bg8Xq", function(module, exports) {

$parcel$export(module.exports, "subscriptionErrors", () => $e4524ceab9239ff3$export$5291dab057c2e4a4);
const $e4524ceab9239ff3$export$5291dab057c2e4a4 = {
    notEnoughInformation: 'NOT_ENOUGH_INFORMATION',
    noFurtherSuggestions: 'NO_FURTHER_SUGGESTIONS',
    unethicalContent: 'UNETHICAL_CONTENT',
    communicationsFailures: 'COMMUNICATIONS_FAILURES',
    unclassified: 'UNCLASSIFIED'
};

});



parcelRegister("l7Gqy", function(module, exports) {

$parcel$export(module.exports, "getLoadingStatusMessage", () => $cb4c5dcdd0a81a64$export$5af3d21ff0cd32f4);
$parcel$export(module.exports, "getNextItemIndex", () => $cb4c5dcdd0a81a64$export$a1ea1532ab230011);

var $5IHDa = parcelRequire("5IHDa");
const $cb4c5dcdd0a81a64$export$5af3d21ff0cd32f4 = (status)=>{
    switch(status){
        case 'REFINING_SUGGESTED_ISSUES':
            return (0, $5IHDa.default).statusRefiningSuggestedIssuesNonFinal;
        case 'REMOVING_DUPLICATE_ISSUES':
            return (0, $5IHDa.default).statusRemovingDuplicateIssuesNonFinal;
        case 'RETRIEVING_SOURCE_CONTEXT':
            return (0, $5IHDa.default).statusRetrievingSourceContextNonFinal;
        case 'SUGGESTING_INITIAL_ISSUES':
            return (0, $5IHDa.default).statusSuggestingInitialIssuesNonFinal;
        case 'REFORMATTING_ISSUES':
            return (0, $5IHDa.default).statusReformatingIssuesNonFinal;
        default:
            return (0, $5IHDa.default).footerTextIsWorking;
    }
};
const $cb4c5dcdd0a81a64$export$a1ea1532ab230011 = (length, selectedIndex, key)=>{
    if (length === 0) return null;
    if (selectedIndex == null) return 0;
    const increment = key === 'ArrowUp' ? -1 : 1;
    const nextIndex = (length + selectedIndex + increment) % length;
    return nextIndex;
};

});


parcelRegister("1pxPJ", function(module, exports) {

$parcel$export(module.exports, "IssueBreakdownError", () => $f51fd8d98cac06ee$export$8328c88575dd2cfb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8ydpf = parcelRequire("8ydpf");
var $b1T1Z = parcelRequire("b1T1Z");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3xyAb = parcelRequire("3xyAb");

var $jjzCA = parcelRequire("jjzCA");

var $j1edI = parcelRequire("j1edI");

var $cqSSs = parcelRequire("cqSSs");
const $f51fd8d98cac06ee$var$MAX_RETRY = 2;
const $f51fd8d98cac06ee$export$8328c88575dd2cfb = ({ onRetry: onRetry, onCancel: onCancel, issueHierarchyLevel: issueHierarchyLevel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ issueTypeIds: issueTypeIds, headerPromptValue: headerPromptValue, retryAttempts: retryAttempts }, { incrementRetryCount: incrementRetryCount }] = (0, $3xyAb.useIssueBreakdown)();
    const handleRetry = (0, $eUqFw.useCallback)(()=>{
        onRetry(issueTypeIds);
        incrementRetryCount();
    }, [
        incrementRetryCount,
        issueTypeIds,
        onRetry
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            // Prevents issue modal from closing
            onCancel();
        }
    }, [
        onCancel
    ]);
    const shouldShowRetry = retryAttempts < $f51fd8d98cac06ee$var$MAX_RETRY;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ydpf.default), {
        shouldFitContainer: true,
        isShadow: true,
        spacing: "none",
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-error.ai-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1edI.Header), {
        value: headerPromptValue,
        issueHierarchyLevel: issueHierarchyLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f51fd8d98cac06ee$var$errorTextContainerStyles
    }, formatMessage((0, $cqSSs.default).genericErrorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f51fd8d98cac06ee$var$FooterSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f51fd8d98cac06ee$var$FooterSectionSpacer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-error.cancel-esc-button",
        type: "button",
        onClick: onCancel,
        interactionName: "auto-generated.issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-prompt.cancel-esc-button.button"
    }, formatMessage((0, $cqSSs.default).labelCancel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f51fd8d98cac06ee$var$EscText, null, formatMessage((0, $cqSSs.default).labelEsc))), shouldShowRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-error.retry-button",
        type: "button",
        onClick: handleRetry,
        appearance: "primary",
        interactionName: "auto-generated.issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-prompt.cancel-esc-button.button"
    }, formatMessage((0, $cqSSs.default).labelRetry))), (0, $1ybV0.ff)('jira-ai-work-breakdown-disclaimer-update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1T1Z.AiFooter), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jjzCA.Footer), null)));
};
const $f51fd8d98cac06ee$var$errorTextContainerStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.300',
    paddingLeft: 'space.200',
    paddingBottom: 'space.300',
    paddingRight: 'space.200',
    gap: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f51fd8d98cac06ee$var$FooterSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasBorder: hasBorder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1yt4utpp _zulputpp",
            (__cmplp.hasBorder ?? false) && "_x3do1ljb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f51fd8d98cac06ee$var$FooterSectionSpacer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f51fd8d98cac06ee$var$EscText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkosqtm _1yt41b66 _syaz1gjq _11q7m7j4 _k48p1nn1 _18u012x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cqSSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c70fc28aac5fa35$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8c70fc28aac5fa35$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    genericErrorMessage: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-error.generic-error-message",
        "defaultMessage": "Atlassian Intelligence (AI) isn\u2019t responding. Try again later."
    },
    labelRetry: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-error.label-retry",
        "defaultMessage": "Retry"
    },
    labelCancel: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-error.label-cancel",
        "defaultMessage": "Cancel"
    },
    labelEsc: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-error.label-esc",
        "defaultMessage": "Esc"
    },
    footerTextIsWorking: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-error.footer-text-is-working",
        "defaultMessage": "Atlassian Intelligence is working..."
    }
});

});


parcelRegister("9DK1a", function(module, exports) {

$parcel$export(module.exports, "IssueBreakdownPrompt", () => $830f8764497f862f$export$1848a6fe66bc6e60);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $8ydpf = parcelRequire("8ydpf");
var $78led = parcelRequire("78led");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $autRb = parcelRequire("autRb");

var $iRiA2 = parcelRequire("iRiA2");

var $5IHDa = parcelRequire("5IHDa");

var $71caB = parcelRequire("71caB");

var $5W9m5 = parcelRequire("5W9m5");

var $j1edI = parcelRequire("j1edI");

var $iItQp = parcelRequire("iItQp");
const $830f8764497f862f$export$1848a6fe66bc6e60 = ({ onSubmit: onSubmit, onCancel: onCancel, isLoading: isLoading, childIssueTypes: childIssueTypes, issueHierarchyLevel: issueHierarchyLevel })=>{
    const [hasSubmitted, setHasSubmitted] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onIssueTypeButtonClick = (0, $eUqFw.useCallback)((issueType)=>{
        onSubmit([
            issueType.id
        ]);
        setHasSubmitted(true);
    }, [
        onSubmit
    ]); // Necessary for scrolling now that input is no longer on prompt step
    const fieldRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        const { current: current } = fieldRef;
        if (current) {
            (0, $autRb.smoothScrollIntoCenterIfNeeded)(current);
            current.focus({
                preventScroll: true
            });
        }
    }, []);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation(); // Prevents issue modal from closing
            onCancel();
        }
    }, [
        onCancel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ref: fieldRef,
        xcss: $830f8764497f862f$var$promptContainerStyles,
        tabIndex: -1,
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ydpf.default), {
        shouldFitContainer: true,
        isShadow: true,
        spacing: "none",
        isLoading: isLoading,
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-prompt.ai-container"
    }, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1edI.Header), {
        issueHierarchyLevel: issueHierarchyLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iRiA2.IssueBreakdownSkeleton), null)), !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iItQp.IssueTypeOptions), {
        childIssueTypes: childIssueTypes,
        onIssueTypeButtonClick: onIssueTypeButtonClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($830f8764497f862f$var$FooterSection, {
        hasBorder: isLoading
    }, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78led.AiIcon), {
        size: "medium",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($830f8764497f862f$var$FooterText, {
        "data-testid": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-prompt.issue-breakdown-footer-brand-text"
    }, formatMessage((0, $5IHDa.default).footerTextIsWorking))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($830f8764497f862f$var$FooterSectionSpacer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-prompt.cancel-esc-button",
        type: "button",
        onClick: onCancel,
        interactionName: "auto-generated.issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-prompt.cancel-esc-button.button"
    }, !isLoading ? formatMessage((0, $5IHDa.default).labelCancel) : formatMessage((0, $5IHDa.default).labelStop), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($830f8764497f862f$var$EscText, null, formatMessage((0, $5IHDa.default).labelEscNonFinal)))), (0, $1ybV0.ff)('jira-ai-work-breakdown-disclaimer-update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $830f8764497f862f$var$footerStyle,
        spread: "space-between",
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($830f8764497f862f$var$FooterSectionSpacer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($830f8764497f862f$var$FooterText, {
        "data-testid": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-prompt.issue-breakdown-footer-brand-text"
    }, formatMessage((0, $5IHDa.default).footerTextPromptNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78led.AiIcon), {
        isDisabled: true,
        size: "small",
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($830f8764497f862f$var$FooterSection, {
        hasBorder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($830f8764497f862f$var$FooterSectionSpacer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($830f8764497f862f$var$FooterText, {
        "data-testid": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.issue-breakdown-prompt.issue-breakdown-footer-brand-text"
    }, formatMessage((0, $5IHDa.default).footerTextPromptNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $71caB.AiIcon), {
        label: ""
    })), hasSubmitted && !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5W9m5.FeedbackForm), null)));
};
const $830f8764497f862f$var$promptContainerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.200',
    marginBottom: 'space.200',
    border: 0,
    outline: 'none' // remove focus highlight
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $830f8764497f862f$var$FooterText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $830f8764497f862f$var$FooterSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasBorder: hasBorder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1yt4utpp _zulputpp",
            (__cmplp.hasBorder ?? false) && "_x3do1ljb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $830f8764497f862f$var$FooterSectionSpacer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $830f8764497f862f$var$EscText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkosqtm _1yt41b66 _syaz1gjq _11q7m7j4 _k48p1nn1 _18u012x7",
            __cmplp.className
        ])
    });
});
const $830f8764497f862f$var$footerStyle = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderTop: `1px solid ${`var(--ds-border, ${(0, $PdmhA).N40})`}`,
    paddingInline: 'space.150',
    paddingBlock: 'space.150'
});

});
parcelRegister("iItQp", function(module, exports) {

$parcel$export(module.exports, "IssueTypeOptions", () => $f94dfa6ddf46266a$export$3ab07187ef9245f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $27KYr = parcelRequire("27KYr");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Ywu9 = parcelRequire("4Ywu9");

var $hnzPP = parcelRequire("hnzPP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jyFd9 = parcelRequire("jyFd9");

var $hKjW7 = parcelRequire("hKjW7");
const $f94dfa6ddf46266a$export$3ab07187ef9245f = ({ childIssueTypes: childIssueTypes, onIssueTypeButtonClick: onIssueTypeButtonClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isCompact = (0, $jyFd9.useIsCompactMode)();
    const renderIssueTypeOptions = (0, $eUqFw.useMemo)(()=>childIssueTypes.map((childIssueType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f94dfa6ddf46266a$var$IssueTypeButton, {
                "data-testid": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.common.issue-type-options.issue-type-button",
                key: childIssueType.name,
                onClick: ()=>onIssueTypeButtonClick(childIssueType)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                direction: "row",
                columnGap: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
                url: childIssueType.iconUrl,
                title: childIssueType.name
            }), ' ', childIssueType.name))), [
        childIssueTypes,
        onIssueTypeButtonClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "issue-view-common-views.child-issues-panel.ai-issue-breakdown.ui.common.issue-type-options"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f94dfa6ddf46266a$var$IssueTypeOptionsHeader, null, formatMessage((0, $hKjW7.default).issueTypeOptionsHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f94dfa6ddf46266a$var$issueTypeOptionsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27KYr.default), {
        alignItems: "center",
        rowGap: "space.150",
        columnGap: "space.150",
        xcss: isCompact ? $f94dfa6ddf46266a$var$compactGridOptions : $f94dfa6ddf46266a$var$responsiveGridOptions
    }, renderIssueTypeOptions)));
};
const $f94dfa6ddf46266a$var$issueTypeOptionsContainerStyles = (0, $1ZAYh.xcss)({
    padding: 'space.200'
});
const $f94dfa6ddf46266a$var$compactGridOptions = (0, $1ZAYh.xcss)({
    [(0, $4Ywu9.media).above.xxs]: {
        gridTemplateColumns: 'repeat(1, 1fr)'
    }
});
const $f94dfa6ddf46266a$var$responsiveGridOptions = (0, $1ZAYh.xcss)({
    [(0, $4Ywu9.media).above.xxs]: {
        gridTemplateColumns: 'repeat(1, 1fr)'
    },
    [(0, $4Ywu9.media).above.md]: {
        gridTemplateColumns: 'repeat(2, 1fr)'
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f94dfa6ddf46266a$var$IssueTypeButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19it2vdh _4t3i1jfw _2rko1b66 _1yt4coea _11q7glyw _1wybdlk8 _80omtlke _19lc14ae",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f94dfa6ddf46266a$var$IssueTypeOptionsHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz131l _k48p19lj _1wybdlk8 _19pkpxbi _18u0pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hKjW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fbdd01e30e5c417$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4fbdd01e30e5c417$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueTypeOptionsHeader: {
        "id": "issue-view-common-views.child-issues-panel.ai-issue-breakdown.common.issue-type-options.issue-type-options-header",
        "defaultMessage": "Ask AI to suggest child issues. Select an issue type:"
    }
});

});




parcelRegister("jy8O8", function(module, exports) {

$parcel$export(module.exports, "AiIssueBreakdownEntryPointContainer", () => $bb7780773b969887$export$191ce15e25539c05);

var $eUqFw = parcelRequire("eUqFw");

var $6fPfJ = parcelRequire("6fPfJ");

var $1HzcR = parcelRequire("1HzcR");



var $4YTD2 = parcelRequire("4YTD2");


var $7ZyzP = parcelRequire("7ZyzP");
const $bb7780773b969887$export$191ce15e25539c05 = ({ onCreate: onCreate, childIssueTypes: childIssueTypes, isSubTaskCreationOpen: isSubTaskCreationOpen, issueHierarchyLevel: issueHierarchyLevel })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $eUqFw.useContext)((0, $6fPfJ.AiIssueBreakdownEntryPointContext));
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            onCreate: onCreate,
            childIssueTypes: childIssueTypes,
            isSubTaskCreationOpen: isSubTaskCreationOpen,
            issueHierarchyLevel: issueHierarchyLevel
        }), [
        onCreate,
        childIssueTypes,
        isSubTaskCreationOpen,
        issueHierarchyLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jiraAIWorkBreakdownEntryPointContainer",
        packageName: "jiraAIWorkBreakdown",
        teamName: "crocs",
        fallback: null,
        runtimeProps: runtimeProps
    });
};

});

parcelRegister("hudGC", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesLimitFlag", () => $6062ce1a08aff296$export$4fdf3bfcb198a412);

var $eUqFw = parcelRequire("eUqFw");

var $4GEic = parcelRequire("4GEic");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $kPvBW = parcelRequire("kPvBW");

var $8411R = parcelRequire("8411R");

var $i9pAn = parcelRequire("i9pAn");

var $4Xcha = parcelRequire("4Xcha");

var $f9RL0 = parcelRequire("f9RL0");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $a7wEh = parcelRequire("a7wEh");

var $gIR6L = parcelRequire("gIR6L");

var $ksbDj = parcelRequire("ksbDj");

var $6HoCR = parcelRequire("6HoCR");
const $6062ce1a08aff296$export$a7bb072605d6094c = 'issue.views.common.child-issues-panel.child-issues-limit-flag';
const $6062ce1a08aff296$var$LEARN_MORE_LINK_TEST_ID = `${$6062ce1a08aff296$export$a7bb072605d6094c}.learn-more-link`;
const $6062ce1a08aff296$export$45f30691d690262e = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// @ts-expect-error - TS2322 - Type '((instance: ButtonLinkWithShortcutIconProps | null) => void) | MutableRefObject<ButtonLinkWithShortcutIconProps | null> | null' is not assignable to type '{ current: HTMLElement | null; } | ((arg1: HTMLElement | null) => unknown) | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ksbDj.ButtonLinkWithShortcutIcon), {
        ...props,
        innerRef: ref,
        testId: $6062ce1a08aff296$var$LEARN_MORE_LINK_TEST_ID
    }));
const $6062ce1a08aff296$export$5881677fb314e6d9 = (0, $eo17r.toFlagId)('child-issues-limit-flag');
const $6062ce1a08aff296$var$ANALYTICS_SOURCE_NAME = 'childIssuesLimitFlag';
const $6062ce1a08aff296$export$4fdf3bfcb198a412 = ({ isApproachingLimit: isApproachingLimit = false, childIssuesLimitStatus: childIssuesLimitStatus })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const childIssuesLimitHelp = (0, $gIR6L.useChildIssuesLimitHelp)();
    const { showFlag: showFlag, dismissFlag: dismissFlag, hasFlag: hasFlag } = (0, $k8Qyf.useFlagsService)();
    const onLearnMoreLinkClick = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'learnMore');
        if (childIssuesLimitHelp.type === (0, $4Xcha.IN_PRODUCT_HELP)) childIssuesLimitHelp.openInProductHelp();
    }, [
        childIssuesLimitHelp
    ]);
    // Ensure the flag is no longer displayed after the user dismisses it the first time
    const [isDismissed, { setValue: setValue }] = (0, $i9pAn.useUserPreferencesValue)((0, $kPvBW.CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED));
    const onDismissed = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'close');
        setValue((0, $4Xcha.DISMISSED));
        dismissFlag($6062ce1a08aff296$export$5881677fb314e6d9);
    }, [
        dismissFlag,
        setValue
    ]);
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ value: fieldConfig, loading: loading }] = (0, $8411R.useFieldConfig)(issueKey, (0, $f9RL0.TIME_TRACKING));
    const hasTimetracking = Boolean(fieldConfig);
    const childIssuesLimit = (0, $hJ992.useChildIssuesLimit)();
    const withTimeTrackingDescription = formatMessage((0, $6HoCR.default).withTimetrackingDescription, {
        limit: childIssuesLimit
    });
    const withoutTimeTrackingDescription = formatMessage((0, $6HoCR.default).withoutTimetrackingDescription, {
        limit: childIssuesLimit
    });
    const title = formatMessage((0, $6HoCR.default).title, {
        limit: childIssuesLimit
    });
    const description = hasTimetracking ? withTimeTrackingDescription : withoutTimeTrackingDescription;
    (0, $eUqFw.useEffect)(()=>{
        if (!loading && // isDismissed is null when users have not dismissed the onboarding
        // it will be set to `dismissed` when the user dismisses via the X button.
        isDismissed !== (0, $4Xcha.DISMISSED) && !hasFlag?.($6062ce1a08aff296$export$5881677fb314e6d9) && (isApproachingLimit || (0, $a7wEh.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus))) showFlag({
            id: $6062ce1a08aff296$export$5881677fb314e6d9,
            render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
                    sourceName: $6062ce1a08aff296$var$ANALYTICS_SOURCE_NAME,
                    sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
                    actionSubjectId: $6062ce1a08aff296$var$ANALYTICS_SOURCE_NAME
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4GEic.default), {
                    id: (0, $eo17r.fromFlagId)($6062ce1a08aff296$export$5881677fb314e6d9),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
                        primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y200)})`,
                        label: ""
                    }),
                    title: title,
                    description: description,
                    onDismissed: (_, analyticsEvent)=>{
                        onDismissed(analyticsEvent);
                    },
                    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<HTMLElement & RefAttributes<ButtonLinkWithShortcutIconProps>>' is not assignable to type 'ComponentType<CustomThemeButtonProps> | undefined'.
                    linkComponent: $6062ce1a08aff296$export$45f30691d690262e,
                    actions: [
                        {
                            content: formatMessage((0, $6HoCR.default).learnMoreLink),
                            ...childIssuesLimitHelp.type === (0, $4Xcha.HREF) ? {
                                href: childIssuesLimitHelp.href,
                                onClick: onLearnMoreLinkClick,
                                target: '_blank'
                            } : {
                                onClick: onLearnMoreLinkClick
                            }
                        }
                    ],
                    testId: $6062ce1a08aff296$export$a7bb072605d6094c
                }))
        });
    }, [
        childIssuesLimitHelp.href,
        childIssuesLimitHelp.type,
        childIssuesLimitStatus,
        description,
        formatMessage,
        hasFlag,
        isApproachingLimit,
        isDismissed,
        loading,
        onDismissed,
        onLearnMoreLinkClick,
        showFlag,
        title
    ]);
    return null;
};
$6062ce1a08aff296$export$4fdf3bfcb198a412.displayName = 'ChildIssuesLimitFlag';

});
parcelRegister("gIR6L", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimitHelp", () => $19b358e320b4d542$export$78fc5e43e3c95b5);

var $eUqFw = parcelRequire("eUqFw");

var $3QLcd = parcelRequire("3QLcd");

var $hJ992 = parcelRequire("hJ992");

var $4Xcha = parcelRequire("4Xcha");

var $guDlK = parcelRequire("guDlK");
const $19b358e320b4d542$export$78fc5e43e3c95b5 = ()=>{
    // What's going on here?
    // The `useHelpPanelLink` returns a function that is not currently wrapped in
    // a `useCallback` this causes unnecessary re-renders.
    // I have notified the team that owns it and have put this `useRef` workaround
    // in place for the time being.
    const openInProductHelp = (0, $eUqFw.useRef)((0, $3QLcd.useHelpPanelLink)());
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const isModal = (0, $hJ992.useIsModal)();
    const openInProductHelpCb = (0, $eUqFw.useCallback)(()=>{
        if (projectType !== undefined) openInProductHelp.current?.((0, $4Xcha.IN_PRODUCT_HELP_ARTICLE_IDS)[projectType] || '');
    }, [
        openInProductHelp,
        projectType
    ]);
    const isInProductHelp = Boolean(openInProductHelp.current && projectType !== undefined && (0, $4Xcha.IN_PRODUCT_HELP_ARTICLE_IDS)[projectType] && !isModal);
    if (!isInProductHelp) return {
        type: (0, $4Xcha.HREF),
        href: (0, $4Xcha.WHAT_ARE_ISSUE_TYPES_URL)
    };
    const articleId = projectType !== undefined && (0, $4Xcha.IN_PRODUCT_HELP_ARTICLE_IDS)[projectType] ? (0, $4Xcha.IN_PRODUCT_HELP_ARTICLE_IDS)[projectType] : '';
    return {
        type: (0, $4Xcha.IN_PRODUCT_HELP),
        articleId: articleId,
        href: (0, $4Xcha.WHAT_ARE_ISSUE_TYPES_URL),
        openInProductHelp: openInProductHelpCb
    };
};

});
parcelRegister("3QLcd", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $82adde900735644c$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $82adde900735644c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $bbdYy = parcelRequire("bbdYy");

var $zcJ0y = parcelRequire("zcJ0y");

var $1ybV0 = parcelRequire("1ybV0");

var $f2Poq = parcelRequire("f2Poq");

var $1zRTT = parcelRequire("1zRTT");

var $bUi2Q = parcelRequire("bUi2Q");
const $82adde900735644c$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $1zRTT.useHelpPanelActions)();
    const isIphEnabled = (0, $1ybV0.ff)('iph.enabled') && !(0, $zcJ0y.isIE11)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $f2Poq.HELP_PANEL_ID), (0, $f2Poq.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $bbdYy.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $bbdYy.ARTICLE_TYPE)[type]
            }
        });
    };
    return isIphEnabled ? handleOnClick : undefined;
};
const $82adde900735644c$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, ...props })=>{
    const onOpenInProductHelpArticle = $82adde900735644c$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $bbdYy.ARTICLE_TYPE)[type]);
    };
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        onClick: handleOnClick
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallbackComponent);
};
var $82adde900735644c$export$2e2bcd8739ae039 = $82adde900735644c$var$HelpPanelLink;

});
parcelRegister("bbdYy", function(module, exports) {

$parcel$export(module.exports, "ARTICLE_TYPE", () => $823b900fea2e703d$export$a72bfd9b1e5592c8);
let $823b900fea2e703d$export$a72bfd9b1e5592c8 = /*#__PURE__*/ function(ARTICLE_TYPE) {
    ARTICLE_TYPE["HELP_ARTICLE"] = "HELP_ARTICLE";
    ARTICLE_TYPE["WHATS_NEW"] = "WHATS_NEW";
    return ARTICLE_TYPE;
}({});

});

parcelRegister("f2Poq", function(module, exports) {

$parcel$export(module.exports, "HELP_PANEL_VERSION", () => $482b44340b421724$export$c43c7444da662fa1);
$parcel$export(module.exports, "HELP_PANEL_ID", () => $482b44340b421724$export$e99efa3985fa3c26);
$parcel$export(module.exports, "HELP_PANEL_WIDTH", () => $482b44340b421724$export$23aa6670f346c214);

var $c9TLT = parcelRequire("c9TLT");
const $482b44340b421724$export$c43c7444da662fa1 = '1';
const $482b44340b421724$export$e99efa3985fa3c26 = 'helpPanel';
const $482b44340b421724$export$23aa6670f346c214 = (0, $c9TLT.gridSize) * 46;

});

parcelRegister("1zRTT", function(module, exports) {

$parcel$export(module.exports, "useHelpPanel", () => $6594f144c6f69b94$export$3fe94d66377a53b8);
$parcel$export(module.exports, "useHelpPanelActions", () => $6594f144c6f69b94$export$c61f56f4797e22db);

var $ggKAj = parcelRequire("ggKAj");
var $dYfll = parcelRequire("dYfll");

var $kEkov = parcelRequire("kEkov");
const $6594f144c6f69b94$export$3fe94d66377a53b8 = (0, $ggKAj.createHook)((0, $kEkov.default));
const $6594f144c6f69b94$export$c61f56f4797e22db = (0, $ggKAj.createHook)((0, $kEkov.default), {
    selector: null
});
const $6594f144c6f69b94$export$513717a84f55db1a = (0, $dYfll.createSubscriber)((0, $kEkov.default), {
    displayName: 'HelpPanelSubscriber'
});
const $6594f144c6f69b94$export$5f4de38bd79f4446 = (0, $dYfll.createSubscriber)((0, $kEkov.default), {
    displayName: 'HelpPanelActionsSubscriber',
    selector: null
});

});
parcelRegister("kEkov", function(module, exports) {

$parcel$export(module.exports, "default", () => $4af29a8a37667189$export$2e2bcd8739ae039);

var $a61MH = parcelRequire("a61MH");

var $89bO2 = parcelRequire("89bO2");

var $47e0j = parcelRequire("47e0j");
const $4af29a8a37667189$var$iphStorage = (0, $89bO2.createSessionStorageProvider)('iph');
const $4af29a8a37667189$var$initialState = {
    navigationData: {
        // @ts-expect-error - TS2322 - Type '"HELP_ARTICLE"' is not assignable to type 'ARTICLE_TYPE'.
        articleId: {
            id: '',
            type: 'HELP_ARTICLE'
        },
        history: $4af29a8a37667189$var$iphStorage.get('history') || []
    },
    releaseNotesNotifications: 100
};
var $4af29a8a37667189$export$2e2bcd8739ae039 = (0, $a61MH.createStore)({
    name: 'help-panel',
    initialState: $4af29a8a37667189$var$initialState,
    actions: $47e0j
});

});
parcelRegister("47e0j", function(module, exports) {

$parcel$export(module.exports, "setNavigationData", () => $a35d570ea28382ca$export$ab1b80f40ca898ed);
$parcel$export(module.exports, "setReleaseNotesNotifications", () => $a35d570ea28382ca$export$cdabe01d01a8da1e);

var $89bO2 = parcelRequire("89bO2");
const $a35d570ea28382ca$var$iphStorage = (0, $89bO2.createSessionStorageProvider)('iph');
const $a35d570ea28382ca$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            navigationData: {
                articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                history: navigationData.history ? navigationData.history : currentState.navigationData.history
            }
        });
        $a35d570ea28382ca$var$iphStorage.set('history', []);
    };
const $a35d570ea28382ca$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
        setState({
            releaseNotesNotifications: releaseNotesNotifications
        });
    };

});



parcelRegister("bUi2Q", function(module, exports) {

$parcel$export(module.exports, "useActiveRightSidebarState", () => $09e77c9f3f7f26ec$export$ba763ab7661c3103);
$parcel$export(module.exports, "useRightSidebarState", () => $09e77c9f3f7f26ec$export$d1828e7f46a4960b);
$parcel$export(module.exports, "useRightSidebarController", () => $09e77c9f3f7f26ec$export$ebe5e907fb0bb63a);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");

var $hqpfO = parcelRequire("hqpfO");

var $53ucm = parcelRequire("53ucm");
const $09e77c9f3f7f26ec$var$useActiveRightSidebar = (0, $ggKAj.createHook)((0, $53ucm.layoutStore), {
    selector: (state)=>{
        const rightSidebarState = (0, $hqpfO.selectCurrentRightSidebar)(state.content.rightSidebar);
        if (!rightSidebarState) return null;
        return {
            ...rightSidebarState,
            shouldRender: !state.isChromeless
        };
    }
});
const $09e77c9f3f7f26ec$export$ba763ab7661c3103 = ()=>{
    const [rightSidebar] = $09e77c9f3f7f26ec$var$useActiveRightSidebar();
    return rightSidebar;
};
const $09e77c9f3f7f26ec$var$useRightSidebar = (0, $ggKAj.createHook)((0, $53ucm.layoutStore), {
    selector: (state)=>state.content.rightSidebar
});
const $09e77c9f3f7f26ec$export$d1828e7f46a4960b = ()=>{
    const [rightSidebarState] = $09e77c9f3f7f26ec$var$useRightSidebar();
    return rightSidebarState;
};
const $09e77c9f3f7f26ec$export$ebe5e907fb0bb63a = ()=>{
    const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, $53ucm.useLayoutStoreActions)();
    return (0, $eUqFw.useMemo)(()=>({
            setRightSidebarState: setRightSidebarState,
            closeRightSidebar: closeRightSidebar,
            openRightSidebar: openRightSidebar,
            closeCurrentRightSidebar: closeCurrentRightSidebar,
            closeAllRightSidebar: closeAllRightSidebar,
            minimiseRightSidebar: minimiseRightSidebar
        }), [
        closeAllRightSidebar,
        closeCurrentRightSidebar,
        closeRightSidebar,
        openRightSidebar,
        setRightSidebarState,
        minimiseRightSidebar
    ]);
};

});
parcelRegister("hqpfO", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $bea3cfbec26c4bd1$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $bea3cfbec26c4bd1$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $bea3cfbec26c4bd1$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $bea3cfbec26c4bd1$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $bea3cfbec26c4bd1$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $bea3cfbec26c4bd1$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $bea3cfbec26c4bd1$export$c8dafe074328c4ca);

var $hTLlD = parcelRequire("hTLlD");
const $bea3cfbec26c4bd1$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $bea3cfbec26c4bd1$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $bea3cfbec26c4bd1$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $bea3cfbec26c4bd1$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $bea3cfbec26c4bd1$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $bea3cfbec26c4bd1$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $bea3cfbec26c4bd1$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});

parcelRegister("53ucm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $775b7b0f5d2674bd$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $775b7b0f5d2674bd$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $775b7b0f5d2674bd$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $775b7b0f5d2674bd$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $775b7b0f5d2674bd$export$99e05a60cac05e86);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $3roBA = parcelRequire("3roBA");
const $775b7b0f5d2674bd$export$539e68c09584883a = 240;
const $775b7b0f5d2674bd$export$b92df8810d2fcd01 = 0;
const $775b7b0f5d2674bd$var$initialState = {
    isChromeless: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $775b7b0f5d2674bd$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $775b7b0f5d2674bd$export$b8cdfd44cddaf07 = (0, $a61MH.createStore)({
    initialState: $775b7b0f5d2674bd$var$initialState,
    actions: $3roBA.actions,
    name: 'JiraLayoutStore'
});
const $775b7b0f5d2674bd$export$6136bc3b9858cff4 = (0, $ggKAj.createHook)($775b7b0f5d2674bd$export$b8cdfd44cddaf07, {
    selector: null
});
const $775b7b0f5d2674bd$var$detailPanelWidthStore = (0, $a61MH.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $775b7b0f5d2674bd$export$95fd7b6da3b9bbb0 = (0, $ggKAj.createHook)($775b7b0f5d2674bd$var$detailPanelWidthStore);
const $775b7b0f5d2674bd$export$99e05a60cac05e86 = (0, $ggKAj.createActionsHook)($775b7b0f5d2674bd$var$detailPanelWidthStore);

});
parcelRegister("3roBA", function(module, exports) {

$parcel$export(module.exports, "actions", () => $7de3ed8fccc77236$export$e324594224ef24da);

var $3OanE = parcelRequire("3OanE");

var $gDr9R = parcelRequire("gDr9R");

var $aoZTG = parcelRequire("aoZTG");

var $f9nrb = parcelRequire("f9nrb");

var $hqpfO = parcelRequire("hqpfO");
const $7de3ed8fccc77236$export$e324594224ef24da = {
    setIsChromeless: // global
    $aoZTG.setIsChromeless,
    showBanner: // banner
    $3OanE.showBanner,
    dismissCurrentBanner: $3OanE.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $f9nrb.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $hqpfO.setRightSidebarState,
    openRightSidebar: $hqpfO.openRightSidebar,
    closeRightSidebar: $hqpfO.closeRightSidebar,
    closeAllRightSidebar: $hqpfO.closeAllRightSidebar,
    closeCurrentRightSidebar: $hqpfO.closeCurrentRightSidebar,
    minimiseRightSidebar: $hqpfO.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $gDr9R.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $gDr9R.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $gDr9R.removeBottomRightCornerPortal
};

});
parcelRegister("3OanE", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $1ca96d140cb009a0$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $1ca96d140cb009a0$export$a45bccc0cc9ac424);
const $1ca96d140cb009a0$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $1ca96d140cb009a0$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($1ca96d140cb009a0$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("gDr9R", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $ce70661c3da7d088$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $ce70661c3da7d088$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $ce70661c3da7d088$export$928bf7e228ce06d2);
const $ce70661c3da7d088$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $ce70661c3da7d088$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $ce70661c3da7d088$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("aoZTG", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $1199e64f89ce3554$export$1998c4816ad37edb);
const $1199e64f89ce3554$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("f9nrb", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $a9b20025b1de3529$export$3e0fd2d894ef83c8);
const $a9b20025b1de3529$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});






parcelRegister("ksbDj", function(module, exports) {

$parcel$export(module.exports, "ButtonLinkWithShortcutIcon", () => $4b61c90e65255e3f$export$f92a39b994ea74fd);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $23NQ5 = parcelRequire("23NQ5");
const $4b61c90e65255e3f$export$f92a39b994ea74fd = ({ href: href, innerRef: innerRef, testId: testId, target: target, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        appearance: "link",
        href: href,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactChild | undefined'.
        iconAfter: target === '_blank' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
            label: "",
            size: "small",
            testId: "issue-view-common-views.child-issues-panel.button-link-with-shortcut-icon"
        }) : null,
        target: target,
        testId: testId,
        interactionName: "auto-generated.jira-issue-view-common-views.child-issues-panel.view.button-link-with-shortcut-icon.button"
    });

});

parcelRegister("6HoCR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a74cf269decb299b$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $a74cf269decb299b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    titleOld: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.title",
        "defaultMessage": "Best practice: Limit child issues to 100"
    },
    withoutTimetrackingDescriptionOld: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.without-timetracking-description",
        "defaultMessage": "The issue view can only display up to 100 child issues. If you add more, you'll have to view them in search."
    },
    withTimetrackingDescriptionOld: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.with-timetracking-description",
        "defaultMessage": "The issue view can only display up to 100 child issues. If you add more, you'll have to view them in search and won't be able to include them in time tracking."
    },
    title: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.title-with-limit",
        "defaultMessage": "Best practice: Limit child issues to {limit}"
    },
    withoutTimetrackingDescription: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.without-timetracking-description-with-limit",
        "defaultMessage": "The issue view can only display up to {limit} child issues. If you add more, you'll have to view them in search."
    },
    withTimetrackingDescription: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.with-timetracking-description-with-limit",
        "defaultMessage": "The issue view can only display up to {limit} child issues. If you add more, you'll have to view them in search and won't be able to include them in time tracking."
    },
    learnMoreLink: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.learn-more-link",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("idb9k", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesLimitPanel", () => $a1afa2f369e89d93$export$6bf3a50103fe3fac);

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $2HCUG = parcelRequire("2HCUG");

var $6izLT = parcelRequire("6izLT");
const $a1afa2f369e89d93$export$6bf3a50103fe3fac = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state, props)=>{
    // FIXME: JIV-17455 can be null
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const childIssuesPanelType = (0, $2HCUG.getChildIssuesPanelType)(state);
    return {
        childIssuesPanelType: childIssuesPanelType,
        hasExceededIssuesLimitInitialLoad: props.hasExceededIssuesLimitInitialLoad
    };
}, {}))((0, $6izLT.ChildIssuesLimitPanel));

});
parcelRegister("6izLT", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesLimitPanel", () => $fddade31998d0eef$export$6bf3a50103fe3fac);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $gUUjF = parcelRequire("gUUjF");

var $3QLcd = parcelRequire("3QLcd");

var $8uD7Y = parcelRequire("8uD7Y");
var $4ksts = parcelRequire("4ksts");

var $hJ992 = parcelRequire("hJ992");

var $8411R = parcelRequire("8411R");

var $4Xcha = parcelRequire("4Xcha");

var $6azHZ = parcelRequire("6azHZ");

var $f9RL0 = parcelRequire("f9RL0");

var $jMP2a = parcelRequire("jMP2a");

var $guDlK = parcelRequire("guDlK");

var $kJlBc = parcelRequire("kJlBc");

var $1jlsP = parcelRequire("1jlsP");

var $gIR6L = parcelRequire("gIR6L");

var $ksbDj = parcelRequire("ksbDj");

var $ke0QY = parcelRequire("ke0QY");

var $hO46J = parcelRequire("hO46J");
const $fddade31998d0eef$var$TEST_ID = 'issue.views.common.child-issues-panel.child-issues-limit-panel';
const $fddade31998d0eef$var$LEARN_MORE_LINK_TEST_ID = `${$fddade31998d0eef$var$TEST_ID}.learn-more-link`;
const $fddade31998d0eef$export$a57d58e1d3aa81a7 = `${$fddade31998d0eef$var$TEST_ID}.view-in-search-button`;
const $fddade31998d0eef$export$6bf3a50103fe3fac = ({ hasExceededIssuesLimitInitialLoad: hasExceededIssuesLimitInitialLoad, childIssuesPanelType: childIssuesPanelType })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const isModal = (0, $hJ992.useIsModal)();
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, (0, $f9RL0.TIME_TRACKING));
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const isSimplifiedProject = (0, $guDlK.useIsSimplifiedProject)(projectKey);
    const hasTimetracking = Boolean(fieldConfig);
    const childIssuesLimit = (0, $hJ992.useChildIssuesLimit)();
    const onInProductHelpLinkClicked = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'learnMoreAboutChildIssues', {
            issueCount: (0, $6azHZ.getChildIssuesLimitExceededAnalyticsCount)(childIssuesLimit)
        });
    }, [
        childIssuesLimit
    ]);
    const childIssuesLimitHelp = (0, $gIR6L.useChildIssuesLimitHelp)();
    const viewInSearchLink = (0, $eUqFw.useMemo)(()=>{
        // These values will never be missing when the FF is enabled, this check is to satisfy flow
        if (projectKey === undefined || projectType === undefined || isSimplifiedProject === undefined) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.child-issues-panel.child-issues-limit-panel', 'Missing project key, type, or isSimplified when generating search link');
            return '';
        }
        return (0, $1jlsP.generateViewInSearchLink)(projectKey, projectType, isSimplifiedProject, issueKey, childIssuesPanelType, hasExceededIssuesLimitInitialLoad);
    }, [
        childIssuesPanelType,
        hasExceededIssuesLimitInitialLoad,
        isSimplifiedProject,
        issueKey,
        projectKey,
        projectType
    ]);
    const onViewInSearchClicked = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'viewInSearch', {
            issueCount: (0, $6azHZ.getChildIssuesLimitExceededAnalyticsCount)(childIssuesLimit)
        }); // Ignore cmd or ctrl clicks - allow user to open in new tab
        if (!event.metaKey && !event.ctrlKey) {
            event.preventDefault();
            push(viewInSearchLink);
        }
    }, [
        childIssuesLimit,
        push,
        viewInSearchLink
    ]);
    const fallbackComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ksbDj.ButtonLinkWithShortcutIcon), {
        href: childIssuesLimitHelp.href,
        onClick: onInProductHelpLinkClicked,
        target: "_blank",
        testId: $fddade31998d0eef$var$LEARN_MORE_LINK_TEST_ID
    }, formatMessage((0, $hO46J.default).learnMoreAboutChildIssuesLink));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fddade31998d0eef$var$ChildrenLimitPanelContainer, {
        "data-testid": $fddade31998d0eef$var$TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fddade31998d0eef$var$ImgContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fddade31998d0eef$var$FileCabinetImg, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ke0QY))),
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fddade31998d0eef$var$DescriptionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h4", null, formatMessage((0, $hO46J.default).childIssuesLimitTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fddade31998d0eef$var$LimitDescription, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...hasTimetracking ? (0, $hO46J.default).withTimetrackingChildIssuesLimitDescription : (0, $hO46J.default).withoutTimetrackingChildIssuesLimitDescription,
        values: {
            learnMoreLink: childIssuesLimitHelp.type === (0, $4Xcha.IN_PRODUCT_HELP) && !isModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
                appearance: "link",
                spacing: "none",
                articleId: childIssuesLimitHelp.articleId,
                fallbackComponent: fallbackComponent,
                onClick: onInProductHelpLinkClicked,
                testId: $fddade31998d0eef$var$LEARN_MORE_LINK_TEST_ID
            }, formatMessage((0, $hO46J.default).learnMoreAboutChildIssuesLink)) : fallbackComponent,
            limit: childIssuesLimit
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "default",
        href: viewInSearchLink,
        onClick: onViewInSearchClicked,
        testId: $fddade31998d0eef$export$a57d58e1d3aa81a7,
        interactionName: "auto-generated.jira-issue-view-common-views.child-issues-panel.view.child-issues-limit-panel.button"
    }, formatMessage((0, $hO46J.default).viewInSearchButton))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fddade31998d0eef$var$ChildrenLimitPanelContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16qs1bpa _1e0c1txw _4cvr1h6o _1yt4u2gc _bfhkhp5a _2rko1l7b _19pkutpp _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fddade31998d0eef$var$FileCabinetImg = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb189y _4t3ivbgk",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fddade31998d0eef$var$ImgContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _18u0pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fddade31998d0eef$var$DescriptionContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8pxbi _1nmz1hna _16jl1406 _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fddade31998d0eef$var$LimitDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ect41wi2 _18s81bpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ke0QY", function(module, exports) {
module.exports = new URL("file-cabinet.6e6312c2.svg", import.meta.url).toString();

});

parcelRegister("hO46J", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f48830a94fc1449$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $8f48830a94fc1449$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewInSearchButton: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.view-in-search-button",
        "defaultMessage": "View in search"
    },
    withTimetrackingChildIssuesLimitDescription: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.with-timetracking-child-issues-limit-description-with-limit",
        "defaultMessage": "The issue view can only display up to {limit} child issues. You can still add and bulk edit them from here, but you'll have to view them in search and won't be able to include them in time tracking. {learnMoreLink}"
    },
    withoutTimetrackingChildIssuesLimitDescription: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.without-timetracking-child-issues-limit-description-with-limit",
        "defaultMessage": "The issue view can only display up to {limit} child issues. You can still add and bulk edit them from here, but you'll have to view them in search. {learnMoreLink}"
    },
    childIssuesLimitTitle: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.child-issues-limit-title",
        "defaultMessage": "View child issues in search"
    },
    learnMoreAboutChildIssuesLink: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.learn-more-about-child-issues-link",
        "defaultMessage": "Learn more about child issues"
    }
});

});



parcelRegister("4It9Q", function(module, exports) {

$parcel$export(module.exports, "ConfigurableChildIssuesPanel", () => $a04fd72d1c0ae11a$export$e75bb3c4f0092e4c);

var $hJRvw = parcelRequire("hJRvw");

var $fxiKl = parcelRequire("fxiKl");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $hJ992 = parcelRequire("hJ992");

var $4qoRl = parcelRequire("4qoRl");


var $i9pAn = parcelRequire("i9pAn");

var $lqalZ = parcelRequire("lqalZ");

var $8iViP = parcelRequire("8iViP");
var $a4IeB = parcelRequire("a4IeB");

var $amu7D = parcelRequire("amu7D");

var $9t3Ir = parcelRequire("9t3Ir");

var $dWLk9 = parcelRequire("dWLk9");

var $ca2LP = parcelRequire("ca2LP");

var $agEEp = parcelRequire("agEEp");

var $6QyxX = parcelRequire("6QyxX");

var $aRwQR = parcelRequire("aRwQR");

var $4VIzz = parcelRequire("4VIzz");
const $a04fd72d1c0ae11a$export$e75bb3c4f0092e4c = ({ recentlyCreatedIssue: recentlyCreatedIssue })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const hideDone = (0, $i9pAn.useUserPreferencesValue)((0, $e4af19d777b54ab6$export$4c9f7f9f8a4000e1));
    const recentlyCreatedIssueKeyRef = (0, $eUqFw.useRef)('');
    const [sortByValue] = (0, $ca2LP.useChildIssuesSortBy)();
    const sortField = (0, $eUqFw.useMemo)(()=>!sortByValue || sortByValue === (0, $agEEp.SORT_OPTION_RANKING) ? (0, $agEEp.SORT_OPTION_RANK) : sortByValue, [
        sortByValue
    ]);
    const newJQL = (0, $eUqFw.useRef)(`parent = ${issueKey} ${hideDone[0] === 'true' ? '& status!=done ' : ''} ORDER BY ${sortField} ASC`);
    const attributes = (0, $eUqFw.useMemo)(()=>({
            cloudId: cloudId,
            issueSearchInput: {
                jql: newJQL.current
            },
            amountOfColumns: 13,
            namespace: 'ISSUE_NAVIGATOR',
            options: {},
            fieldSetIds: [
                'issuekey',
                'summary'
            ],
            shouldQueryFieldSetsById: true,
            isEditableReadsEnabled: false,
            filterId: undefined,
            first: 10
        }), [
        newJQL,
        cloudId
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = (0, $iWLL0.usePreloadedQuery)((0, $fxiKl.default), {
        kind: 'PreloadedQuery',
        environment: (0, $amu7D.default),
        fetchKey: 'issue',
        fetchPolicy: 'store-or-network',
        name: 'issueViewCommon',
        variables: attributes,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        dispose: ()=>{},
        isDisposed: false
    });
    const [results, refetch] = (0, $iWLL0.useRefetchableFragment)((0, $hJRvw.default), data);
    const issues = results.jira.issueSearchStable;
    const columns = results.jira.fieldSetsById;
    const { isLoading: isLoading, refetchWithoutSuspending: refetchWithoutSuspending } = (0, $4VIzz.useLoadingState)(attributes, refetch, (0, $9t3Ir.default));
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    (0, $eUqFw.useEffect)(()=>{
        if (!recentlyCreatedIssue?.issueKey) return;
        if (recentlyCreatedIssueKeyRef.current !== recentlyCreatedIssue.issueKey) refetch(attributes, {
            fetchPolicy: 'store-and-network',
            onComplete: ()=>{
                recentlyCreatedIssueKeyRef.current = recentlyCreatedIssue.issueKey;
                const flagId = (0, $eo17r.fromFlagId)(new Date().getTime().toString());
                showFlag({
                    id: flagId,
                    render: (flagProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4qoRl.SuccessFlag), {
                            issueDiscoveryUrl: `/browse/${recentlyCreatedIssue.issueKey}`,
                            issueList: [
                                {
                                    issueId: Number(recentlyCreatedIssue.issueId),
                                    issueKey: recentlyCreatedIssue.issueKey
                                }
                            ],
                            flagKey: flagProps.key,
                            id: flagId
                        })
                });
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        recentlyCreatedIssue?.issueKey
    ]);
    const onPageChange = (0, $eUqFw.useCallback)((cursor)=>{
        refetchWithoutSuspending({
            after: cursor
        }, {
            fetchPolicy: 'store-or-network'
        });
    }, [
        refetchWithoutSuspending
    ]);
    const [columnNames, setColumnNames] = (0, $eUqFw.useState)([
        'issuekey',
        'summary'
    ]);
    const onSortChange = (0, $eUqFw.useCallback)((field, direction)=>{
        newJQL.current = `parent = ${issueKey} ${hideDone[0] === 'true' ? '& status!=done ' : ''} ORDER BY ${field} ${direction}`;
        refetchWithoutSuspending({
            issueSearchInput: {
                jql: newJQL.current
            }
        }, {
            fetchPolicy: 'store-or-network'
        }, {
            fieldSetIds: columnNames
        });
    }, [
        newJQL,
        refetchWithoutSuspending,
        hideDone,
        issueKey,
        columnNames
    ]);
    // , changeType: any, optimisticFieldSets: any
    const onColumnsChange = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (columnIds)=>{
        setColumnNames(columnIds);
        refetchWithoutSuspending({
            fieldSetIds: columnIds
        });
    }, [
        refetchWithoutSuspending
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8iViP.default), {
        issues: issues,
        sortField: sortField,
        sortDirection: (0, $a4IeB.SORT_DESC),
        columns: columns,
        onPageChange: onPageChange,
        onSortChange: onSortChange,
        loading: isLoading,
        onColumnsChange: onColumnsChange,
        useColumnLoader: (0, $aRwQR.useColumnLoader)
    });
};
const $a04fd72d1c0ae11a$export$813feba8f86de331 = (0, $lqalZ.connect)((state)=>({
        recentlyCreatedIssue: (0, $6QyxX.getRecentlyCreatedIssue)(state)
    }))($a04fd72d1c0ae11a$export$e75bb3c4f0092e4c);

});
parcelRegister("hJRvw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1458e9908d8964eb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ead6f515bb4cd1a66954d2faf76c93d2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $9t3Ir = parcelRequire("9t3Ir");
const $1458e9908d8964eb$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "isEditableReadsEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $9t3Ir.default)
            }
        },
        "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanel",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "after",
                                        "variableName": "after"
                                    },
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "first",
                                        "variableName": "first"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "issueSearchInput",
                                        "variableName": "issueSearchInput"
                                    }
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "issueSearchStable",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "pageSize",
                                                "variableName": "first"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "ui_nativeIssueTable_NativeIssueTable_issues"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.issueSearchStable"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "fieldSetIds",
                                        "variableName": "fieldSetIds"
                                    }
                                ],
                                "concreteType": "JiraIssueSearchFieldSetConnection",
                                "kind": "LinkedField",
                                "name": "fieldSetsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ui_nativeIssueTable_NativeIssueTable_columns"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.fieldSetsById"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$1458e9908d8964eb$var$node.hash = "70ad453e9aa2c3d242657996c0f30d65";
var $1458e9908d8964eb$export$2e2bcd8739ae039 = $1458e9908d8964eb$var$node;

});
parcelRegister("9t3Ir", function(module, exports) {

$parcel$export(module.exports, "default", () => $e68325ab421e6995$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<718b67bcdf1e3602e1163ecabcd08a5b>>
 * @relayHash 58dcfe18245e6acffebc4bf6e229bba8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c535dfd986c9cff235c5bb1c1a53eec2d98bec4a5b2f8f213dc4990ebe0cd19b

var $dbXJb = parcelRequire("dbXJb");

var $kpHqV = parcelRequire("kpHqV");

var $fae96 = parcelRequire("fae96");

var $jYNxR = parcelRequire("jYNxR");

var $fY4Nv = parcelRequire("fY4Nv");

var $dyQWd = parcelRequire("dyQWd");
const $e68325ab421e6995$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isEditableReadsEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "key"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = {
        "kind": "Variable",
        "name": "fieldSetIds",
        "variableName": "fieldSetIds"
    }, v15 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v16 = {
        "kind": "ScalarField",
        "name": "type"
    }, v17 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = [
        v20 /*: any*/ ,
        v13 /*: any*/ 
    ], v22 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v23 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lazyIsEditableInIssueView"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "text"
    }, v25 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v26 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v13 /*: any*/ 
        ]
    }, v27 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v28 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v29 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "small"
                            }
                        ]
                    },
                    v20 /*: any*/ ,
                    v13 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v30 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v24 /*: any*/ ,
            v13 /*: any*/ 
        ]
    }, v31 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v32 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraIssueField"
                                                },
                                                v13 /*: any*/ ,
                                                {
                                                    "condition": "isEditableReadsEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEditableInIssueView"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAffectedServiceConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedAffectedServicesConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAffectedService",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "serviceId"
                                                                                },
                                                                                v20 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraAffectedServicesField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraCmdbObjectConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedCmdbObjectsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraCmdbObject",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "objectId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "label"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "avatar",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "url48"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "QueryError",
                                                                    "kind": "LinkedField",
                                                                    "name": "errors",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "message"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraCMDBField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraComponentConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedComponentsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraComponentEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraComponent",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v21 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraComponentsField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "date"
                                                        },
                                                        v20 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ 
                                                    ],
                                                    "type": "JiraDatePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dateTime"
                                                        }
                                                    ],
                                                    "type": "JiraDateTimePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraEpic",
                                                            "kind": "LinkedField",
                                                            "name": "epic",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "summary"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "color"
                                                                },
                                                                v13 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraEpicLinkField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "renderedFieldHtml"
                                                        }
                                                    ],
                                                    "type": "JiraFallbackField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v23 /*: any*/ 
                                                    ],
                                                    "type": "JiraSingleLineTextField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatusCategory",
                                                            "kind": "LinkedField",
                                                            "name": "statusCategory",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusCategoryField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusId"
                                                                },
                                                                v26 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraLabelConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedLabelsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraLabelEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraLabel",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v20 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v28 /*: any*/ 
                                                            ],
                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                        },
                                                        v20 /*: any*/ ,
                                                        v23 /*: any*/ 
                                                    ],
                                                    "type": "JiraLabelsField"
                                                },
                                                v29 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssue",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v30 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "ids",
                                                                                    "value": [
                                                                                        "issuetype",
                                                                                        "summary"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                v29 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                v13 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"summary\"])"
                                                                        }
                                                                    ]
                                                                },
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraColorField",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueColorField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraColor",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "color",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "colorKey"
                                                                                        },
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueTypeField",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueTypeField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        v20 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v30 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraParentIssueField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v20 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcpriorityinlineeditrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v23 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraPriorityField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "large"
                                                                        }
                                                                    ]
                                                                },
                                                                v13 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraProjectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraResolution",
                                                            "kind": "LinkedField",
                                                            "name": "resolution",
                                                            "plural": false,
                                                            "selections": v21 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraResolutionField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcsprintinlineeditrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedSprintsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprintEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprint",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v21 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcsprintinlineeditrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedSprintsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprintEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprint",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v13 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "sprintId"
                                                                                        },
                                                                                        v20 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "state"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "endDate"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v20 /*: any*/ ,
                                                                v23 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "accountId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "picture"
                                                                },
                                                                v20 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcuserinlineeditrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountStatus"
                                                                        }
                                                                    ]
                                                                },
                                                                v22 /*: any*/ ,
                                                                v23 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraVersionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedVersionsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersion",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v21 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraMultipleVersionPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraRichText",
                                                            "kind": "LinkedField",
                                                            "name": "richText",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraADF",
                                                                    "kind": "LinkedField",
                                                                    "name": "adfValue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                            "kind": "LinkedField",
                                                                            "name": "convertedPlainText",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "plainText"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraRichTextField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraServiceManagementRequestType",
                                                            "kind": "LinkedField",
                                                            "name": "requestType",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v31 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementRequestTypeField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinkConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "hasNextPage"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "webUrl"
                                                                                        },
                                                                                        v12 /*: any*/ ,
                                                                                        {
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "ids",
                                                                                                    "value": [
                                                                                                        "statusCategory"
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldsById",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                },
                                                                                                                v13 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                        },
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "relationName"
                                                                                },
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinkConnection(first:1000)"
                                                        }
                                                    ],
                                                    "type": "JiraIssueLinkField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v33 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ], v34 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_main_ConfigurableChildIssuesPanelQuery_IssueTableRefetchableQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanel"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcstatusinlineeditrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcpriorityinlineeditrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcsprintinlineeditrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcuserinlineeditrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ui_main_ConfigurableChildIssuesPanelQuery_IssueTableRefetchableQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "after",
                                    "variableName": "after"
                                },
                                v11 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueId"
                                                },
                                                {
                                                    "condition": "shouldQueryFieldSetsById",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                v14 /*: any*/ ,
                                                                v15 /*: any*/ 
                                                            ],
                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSetsById",
                                                            "plural": false,
                                                            "selections": v32 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldQueryFieldSetsById",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "filterId",
                                                                    "variableName": "filterId"
                                                                },
                                                                v15 /*: any*/ ,
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "namespace",
                                                                    "variableName": "namespace"
                                                                },
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "viewId",
                                                                    "variableName": "viewId"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSetsForIssueSearchView",
                                                            "plural": false,
                                                            "selections": v32 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "childIssues",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "activeProjectsOnly",
                                                                                    "value": true
                                                                                },
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "first",
                                                                                    "value": 10
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "issues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v28 /*: any*/ 
                                                                            ],
                                                                            "storageKey": "issues(activeProjectsOnly:true,first:10)"
                                                                        }
                                                                    ],
                                                                    "type": "JiraChildIssuesWithinLimit"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v18 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "pageSize",
                                            "variableName": "first"
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": v33 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": v33 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": v33 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                v11 /*: any*/ ,
                                v14 /*: any*/ 
                            ],
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                v28 /*: any*/ ,
                                {
                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jqlTerm"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isSortable"
                                                },
                                                {
                                                    "concreteType": "JiraFieldType",
                                                    "kind": "LinkedField",
                                                    "name": "fieldType",
                                                    "plural": false,
                                                    "selections": [
                                                        v34 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c535dfd986c9cff235c5bb1c1a53eec2d98bec4a5b2f8f213dc4990ebe0cd19b",
            "metadata": {},
            "name": "ui_main_ConfigurableChildIssuesPanelQuery_IssueTableRefetchableQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider": (0, $dbXJb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcstatusinlineeditrelayprovider": (0, $fY4Nv.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider": (0, $kpHqV.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcpriorityinlineeditrelayprovider": (0, $fae96.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcsprintinlineeditrelayprovider": (0, $jYNxR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcuserinlineeditrelayprovider": (0, $dyQWd.default)
            }
        }
    };
}();
$e68325ab421e6995$var$node.hash = "70ad453e9aa2c3d242657996c0f30d65";
var $e68325ab421e6995$export$2e2bcd8739ae039 = $e68325ab421e6995$var$node;

});
parcelRegister("dbXJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $97fcddf57bcced87$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$97fcddf57bcced87$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('child-issues-total-count-performance-experiment_mt1zj');
    }
};

});

parcelRegister("kpHqV", function(module, exports) {

$parcel$export(module.exports, "default", () => $42eb06e33900abe2$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42eb06e33900abe2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf');
    }
};

});

parcelRegister("fae96", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddcc60e3c845a391$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ddcc60e3c845a391$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('nin-priority-inline-edit');
    }
};

});

parcelRegister("jYNxR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d10a9cee8ea1900b$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d10a9cee8ea1900b$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('one-issue-table-sprint-inline-edit');
    }
};

});

parcelRegister("fY4Nv", function(module, exports) {

$parcel$export(module.exports, "default", () => $06f51cd3cb5fdd9e$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$06f51cd3cb5fdd9e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf');
    }
};

});

parcelRegister("dyQWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9c12eaf5698074c$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c9c12eaf5698074c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('nin-single-user-inline-edit_orj2c');
    }
};

});



parcelRegister("fxiKl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a43491c0d3e6cdd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6f6b93e83e4365a622d5320a55f164d0>>
 * @relayHash b4165b614e106c3d39545a20abbc7384
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6659633d0f1ddc03be50d1fb58729925053661a7f2fdfee759be3607514c293c

var $dbXJb = parcelRequire("dbXJb");

var $kpHqV = parcelRequire("kpHqV");

var $fae96 = parcelRequire("fae96");

var $jYNxR = parcelRequire("jYNxR");

var $fY4Nv = parcelRequire("fY4Nv");

var $dyQWd = parcelRequire("dyQWd");
const $9a43491c0d3e6cdd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isEditableReadsEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "key"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = {
        "kind": "Variable",
        "name": "fieldSetIds",
        "variableName": "fieldSetIds"
    }, v15 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v16 = {
        "kind": "ScalarField",
        "name": "type"
    }, v17 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = [
        v20 /*: any*/ ,
        v13 /*: any*/ 
    ], v22 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v23 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lazyIsEditableInIssueView"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "text"
    }, v25 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v26 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v13 /*: any*/ 
        ]
    }, v27 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v28 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v29 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "small"
                            }
                        ]
                    },
                    v20 /*: any*/ ,
                    v13 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v30 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v24 /*: any*/ ,
            v13 /*: any*/ 
        ]
    }, v31 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v32 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraIssueField"
                                                },
                                                v13 /*: any*/ ,
                                                {
                                                    "condition": "isEditableReadsEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEditableInIssueView"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAffectedServiceConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedAffectedServicesConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAffectedService",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "serviceId"
                                                                                },
                                                                                v20 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraAffectedServicesField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraCmdbObjectConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedCmdbObjectsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraCmdbObject",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "objectId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "label"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "avatar",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "url48"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "QueryError",
                                                                    "kind": "LinkedField",
                                                                    "name": "errors",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "message"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraCMDBField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraComponentConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedComponentsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraComponentEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraComponent",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v21 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraComponentsField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "date"
                                                        },
                                                        v20 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ 
                                                    ],
                                                    "type": "JiraDatePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dateTime"
                                                        }
                                                    ],
                                                    "type": "JiraDateTimePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraEpic",
                                                            "kind": "LinkedField",
                                                            "name": "epic",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "summary"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "color"
                                                                },
                                                                v13 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraEpicLinkField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "renderedFieldHtml"
                                                        }
                                                    ],
                                                    "type": "JiraFallbackField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v23 /*: any*/ 
                                                    ],
                                                    "type": "JiraSingleLineTextField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatusCategory",
                                                            "kind": "LinkedField",
                                                            "name": "statusCategory",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusCategoryField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusId"
                                                                },
                                                                v26 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraLabelConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedLabelsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraLabelEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraLabel",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v20 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v28 /*: any*/ 
                                                            ],
                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                        },
                                                        v20 /*: any*/ ,
                                                        v23 /*: any*/ 
                                                    ],
                                                    "type": "JiraLabelsField"
                                                },
                                                v29 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssue",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v30 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "ids",
                                                                                    "value": [
                                                                                        "issuetype",
                                                                                        "summary"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                v29 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                v13 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"summary\"])"
                                                                        }
                                                                    ]
                                                                },
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraColorField",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueColorField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraColor",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "color",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "colorKey"
                                                                                        },
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueTypeField",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueTypeField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        v20 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v30 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraParentIssueField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v20 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcpriorityinlineeditrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v23 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraPriorityField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "large"
                                                                        }
                                                                    ]
                                                                },
                                                                v13 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraProjectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraResolution",
                                                            "kind": "LinkedField",
                                                            "name": "resolution",
                                                            "plural": false,
                                                            "selections": v21 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraResolutionField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcsprintinlineeditrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedSprintsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprintEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprint",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v21 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcsprintinlineeditrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedSprintsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprintEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprint",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v13 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "sprintId"
                                                                                        },
                                                                                        v20 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "state"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "endDate"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v20 /*: any*/ ,
                                                                v23 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "accountId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "picture"
                                                                },
                                                                v20 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcuserinlineeditrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountStatus"
                                                                        }
                                                                    ]
                                                                },
                                                                v22 /*: any*/ ,
                                                                v23 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraVersionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedVersionsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersion",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v21 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraMultipleVersionPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraRichText",
                                                            "kind": "LinkedField",
                                                            "name": "richText",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraADF",
                                                                    "kind": "LinkedField",
                                                                    "name": "adfValue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                            "kind": "LinkedField",
                                                                            "name": "convertedPlainText",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "plainText"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraRichTextField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraServiceManagementRequestType",
                                                            "kind": "LinkedField",
                                                            "name": "requestType",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v31 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementRequestTypeField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinkConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "hasNextPage"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "webUrl"
                                                                                        },
                                                                                        v12 /*: any*/ ,
                                                                                        {
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "ids",
                                                                                                    "value": [
                                                                                                        "statusCategory"
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldsById",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                },
                                                                                                                v13 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                        },
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "relationName"
                                                                                },
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinkConnection(first:1000)"
                                                        }
                                                    ],
                                                    "type": "JiraIssueLinkField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v33 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ], v34 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_main_ConfigurableChildIssuesPanelQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanel"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v10 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v9 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcstatusinlineeditrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcpriorityinlineeditrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcsprintinlineeditrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcuserinlineeditrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ui_main_ConfigurableChildIssuesPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "after",
                                    "variableName": "after"
                                },
                                v11 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueId"
                                                },
                                                {
                                                    "condition": "shouldQueryFieldSetsById",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                v14 /*: any*/ ,
                                                                v15 /*: any*/ 
                                                            ],
                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSetsById",
                                                            "plural": false,
                                                            "selections": v32 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldQueryFieldSetsById",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "filterId",
                                                                    "variableName": "filterId"
                                                                },
                                                                v15 /*: any*/ ,
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "namespace",
                                                                    "variableName": "namespace"
                                                                },
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "viewId",
                                                                    "variableName": "viewId"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSetsForIssueSearchView",
                                                            "plural": false,
                                                            "selections": v32 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "childIssues",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "activeProjectsOnly",
                                                                                    "value": true
                                                                                },
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "first",
                                                                                    "value": 10
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "issues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v28 /*: any*/ 
                                                                            ],
                                                                            "storageKey": "issues(activeProjectsOnly:true,first:10)"
                                                                        }
                                                                    ],
                                                                    "type": "JiraChildIssuesWithinLimit"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v18 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "pageSize",
                                            "variableName": "first"
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": v33 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": v33 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": v33 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                v11 /*: any*/ ,
                                v14 /*: any*/ 
                            ],
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                v28 /*: any*/ ,
                                {
                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jqlTerm"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isSortable"
                                                },
                                                {
                                                    "concreteType": "JiraFieldType",
                                                    "kind": "LinkedField",
                                                    "name": "fieldType",
                                                    "plural": false,
                                                    "selections": [
                                                        v34 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6659633d0f1ddc03be50d1fb58729925053661a7f2fdfee759be3607514c293c",
            "metadata": {},
            "name": "ui_main_ConfigurableChildIssuesPanelQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider": (0, $dbXJb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcstatusinlineeditrelayprovider": (0, $fY4Nv.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider": (0, $kpHqV.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcpriorityinlineeditrelayprovider": (0, $fae96.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcsprintinlineeditrelayprovider": (0, $jYNxR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcuserinlineeditrelayprovider": (0, $dyQWd.default)
            }
        }
    };
}();
$9a43491c0d3e6cdd$var$node.hash = "da40ec6a1c4b8b15123e5efe9935f30c";
var $9a43491c0d3e6cdd$export$2e2bcd8739ae039 = $9a43491c0d3e6cdd$var$node;

});

parcelRegister("4qoRl", function(module, exports) {

$parcel$export(module.exports, "SuccessFlag", () => $c00e9b87b1664321$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "default", () => $c00e9b87b1664321$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aWvIp = parcelRequire("aWvIp");

var $PdmhA = parcelRequire("PdmhA");


var $cCFSU = parcelRequire("cCFSU");
var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6Vonl = parcelRequire("6Vonl");

var $cJGZN = parcelRequire("cJGZN");


var $94TZV = parcelRequire("94TZV");
const $c00e9b87b1664321$export$93bd4963a1d00fd5 = (props)=>{
    const { flagKey: flagKey, id: id, issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, successFlagParams: successFlagParams } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const getDynamicFlagType = ()=>{
        if (successFlagParams) {
            const { isRankable: isRankable, isWorkMode: isWorkMode, canManageSprints: canManageSprints, boardType: boardType } = successFlagParams;
            if (isRankable && isWorkMode) {
                if (boardType === (0, $a74d63b8166671c7$export$4498412e32a31fb6) && canManageSprints) return 0, $43f1e8ead7a5a2a9$export$407f3b8bfd90ad8d;
                if (boardType === (0, $a74d63b8166671c7$export$b4e9cdb19cfa0abb)) return 0, $43f1e8ead7a5a2a9$export$256b368007db542a;
            }
        }
        return 0, $43f1e8ead7a5a2a9$export$858ff9c1b12e1d84;
    };
    const getDefaultFlagTitle = ()=>{
        const areMultipleIssuesCreated = issueList.length > 1;
        return areMultipleIssuesCreated ? formatMessage((0, $94TZV.default).multiplesIssuesCreatedSuccessFlagTitle, {
            issueCount: issueList.length
        }) : formatMessage((0, $94TZV.default).createSuccessFlagTitle, {
            issueKey: issueList[0].issueKey
        });
    };
    const FlagConfigs = {
        Default: ()=>({
                flagTitle: getDefaultFlagTitle(),
                flagDescription: '',
                flagActions: (0, $cJGZN.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        IssuesNotInSprint: (issuesWithNoSprint, issuesExcludingEpics, sprints)=>({
                flagTitle: formatMessage((0, $94TZV.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                    issueCount: issuesExcludingEpics.length
                }),
                flagDescription: formatMessage((0, $94TZV.default).issueCreatedNoSprintSuccessFlagDescription, {
                    issueKey: issuesWithNoSprint[0].issueKey,
                    issueCount: issuesExcludingEpics.length
                }),
                flagActions: (0, $cJGZN.getNewScrumIssuesWithNoSprintsActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl,
                    issuesWithNoSprint: issuesWithNoSprint,
                    sprints: sprints
                })
            }),
        IssuesNotInSprintMoreThanTwoActiveSprints: (issuesWithNoSprint, issuesExcludingEpics)=>({
                flagTitle: formatMessage((0, $94TZV.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                    issueCount: issuesExcludingEpics.length
                }),
                flagDescription: formatMessage((0, $94TZV.default).issueCreatedNoSprintSuccessFlagDescription, {
                    issueKey: issuesWithNoSprint[0].issueKey,
                    issueCount: issuesExcludingEpics.length
                }),
                flagActions: (0, $cJGZN.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        MultipleIssuesSomeNoSprint: ()=>({
                flagTitle: formatMessage((0, $94TZV.default).multiplesIssuesCreatedSomeNoSprintSuccessFlagTitle),
                flagDescription: formatMessage((0, $94TZV.default).multiplesIssuesCreatedSomeNoSprintSuccessFlagDescription),
                flagActions: (0, $cJGZN.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        HiddenScrumIssues: (issues, isFiltered)=>({
                flagTitle: formatMessage((0, $94TZV.default).createdHiddenIssueSuccessFlagTitle, {
                    issueCount: issues.length
                }),
                flagDescription: formatMessage((0, $94TZV.default).scrumCreatedHiddenIssueSuccessFlagDescription, {
                    issueCount: issues.length
                }),
                flagActions: (0, $cJGZN.getHiddenIssuesActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl,
                    isFiltered: isFiltered
                })
            }),
        IssuesInBacklog: (issues)=>({
                flagTitle: formatMessage((0, $94TZV.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                    issueCount: issues.length
                }),
                flagDescription: formatMessage((0, $94TZV.default).issueCreatedInBacklogSuccessFlagDescription, {
                    issueKey: issues[0].issueKey,
                    issueCount: issues.length
                }),
                flagActions: (0, $cJGZN.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        MultipleIssuesSomeInBacklog: ()=>({
                flagTitle: formatMessage((0, $94TZV.default).multiplesIssuesCreatedSomeInBacklogSuccessFlagTitle),
                flagDescription: formatMessage((0, $94TZV.default).multiplesIssuesCreatedSomeInBacklogSuccessFlagDescription),
                flagActions: (0, $cJGZN.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        HiddenKanbanIssues: (issues, isFiltered)=>({
                flagTitle: formatMessage((0, $94TZV.default).createdHiddenIssueSuccessFlagTitle, {
                    issueCount: issues.length
                }),
                flagDescription: formatMessage((0, $94TZV.default).kanbanCreatedHiddenIssueSuccessFlagDescription, {
                    issueCount: issues.length
                }),
                flagActions: (0, $cJGZN.getHiddenIssuesActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl,
                    isFiltered: isFiltered
                })
            })
    };
    const getFlagContent = ()=>{
        if (successFlagParams) {
            if (getDynamicFlagType() === (0, $43f1e8ead7a5a2a9$export$407f3b8bfd90ad8d)) {
                const { issues: issues, isFiltered: isFiltered, invalidIssuesKeys: invalidIssuesKeys, issuesWithNoSprint: issuesWithNoSprint, issuesExcludingEpics: issuesExcludingEpics, sprints: sprints } = successFlagParams;
                if (issuesWithNoSprint.length > 0) {
                    if (issuesWithNoSprint.length === issuesExcludingEpics.length) {
                        if (sprints.length > 2) return FlagConfigs.IssuesNotInSprintMoreThanTwoActiveSprints(issuesWithNoSprint, issuesExcludingEpics);
                        return FlagConfigs.IssuesNotInSprint(issuesWithNoSprint, issuesExcludingEpics, sprints);
                    }
                    return FlagConfigs.MultipleIssuesSomeNoSprint();
                }
                if (invalidIssuesKeys.length > 0) return FlagConfigs.HiddenScrumIssues(issues, isFiltered);
            } else if (getDynamicFlagType() === (0, $43f1e8ead7a5a2a9$export$256b368007db542a)) {
                const { kanbanIssuesInBacklog: kanbanIssuesInBacklog, invalidIssuesKeys: invalidIssuesKeys, issues: issues, isFiltered: isFiltered } = successFlagParams;
                if (kanbanIssuesInBacklog.length > 0) {
                    if (kanbanIssuesInBacklog.length === issues.length) return FlagConfigs.IssuesInBacklog(issues);
                    return FlagConfigs.MultipleIssuesSomeInBacklog();
                }
                if (invalidIssuesKeys.length > 0) return FlagConfigs.HiddenKanbanIssues(issues, isFiltered);
            }
        }
        return FlagConfigs.Default();
    };
    const { flagTitle: flagTitle, flagDescription: flagDescription, flagActions: flagActions } = getFlagContent();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-issue-key": issueList.map((issue)=>issue.issueKey).join(','),
        "data-testid": (0, $43f1e8ead7a5a2a9$export$2e4c8b336846b593)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
            primaryColor: `var(--ds-icon-success, ${(0, $PdmhA.G300)})`,
            label: "Success"
        }),
        id: (0, $eo17r.fromFlagId)(id),
        key: flagKey,
        title: flagTitle,
        description: flagDescription,
        actions: flagActions,
        onDismissed: ()=>{
            dismissFlag(id);
        }
    }));
};
const $c00e9b87b1664321$var$SuccessFlagWithContext = (props)=>{
    const { id: id } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Vonl.AddToSprintActionStatesContainer), {
        scope: id.valueOf(),
        key: id.valueOf()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c00e9b87b1664321$export$93bd4963a1d00fd5, props));
};
var $c00e9b87b1664321$export$2e2bcd8739ae039 = $c00e9b87b1664321$var$SuccessFlagWithContext;

});
// Backend types
const $a74d63b8166671c7$export$9a958daafd9a03ed = 'agility-board';
const $a74d63b8166671c7$export$de6b9ed6cd36bad1 = 'core-board';
const $a74d63b8166671c7$export$b4e9cdb19cfa0abb = 'kanban';
const $a74d63b8166671c7$export$4498412e32a31fb6 = 'scrum';

parcelRegister("cCFSU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59aa209343f0b13$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5L0Jp = parcelRequire("5L0Jp");

var $kQ0RL = parcelRequire("kQ0RL");
const $f59aa209343f0b13$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $f59aa209343f0b13$export$2e2bcd8739ae039 = $f59aa209343f0b13$var$AkFlag;

});

parcelRegister("6Vonl", function(module, exports) {

$parcel$export(module.exports, "AddToSprintActionStatesContainer", () => $f28006145f6a48f2$export$4ae31d89b87a513);
$parcel$export(module.exports, "useAddToSprintFlagActionStateController", () => $f28006145f6a48f2$export$dc7fffa2c4559368);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $f28006145f6a48f2$var$initialState = {
    addToSprintCTAsEnabled: true
};
const $f28006145f6a48f2$var$actions = {
    disableOtherAddToSprintCTAs: ()=>({ setState: setState })=>{
            setState({
                addToSprintCTAsEnabled: false
            });
        }
};
const $f28006145f6a48f2$var$Store = (0, $a61MH.createStore)({
    initialState: $f28006145f6a48f2$var$initialState,
    actions: $f28006145f6a48f2$var$actions,
    name: 'SuccessFlagAddToSprintActionStateController'
});
const $f28006145f6a48f2$export$4ae31d89b87a513 = (0, $heB5U.createContainer)($f28006145f6a48f2$var$Store);
const $f28006145f6a48f2$export$dc7fffa2c4559368 = (0, $ggKAj.createHook)($f28006145f6a48f2$var$Store);

});

parcelRegister("cJGZN", function(module, exports) {

$parcel$export(module.exports, "getDefaultFlagActions", () => $97fbb1036aaa8ee6$export$6de10317e135f24);
$parcel$export(module.exports, "getNewScrumIssuesWithNoSprintsActions", () => $97fbb1036aaa8ee6$export$882355824d3fc905);
$parcel$export(module.exports, "getHiddenIssuesActions", () => $97fbb1036aaa8ee6$export$f5c2849658ba2a03);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $4ksts = parcelRequire("4ksts");

var $fqKjL = parcelRequire("fqKjL");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6Vonl = parcelRequire("6Vonl");


var $fFpUU = parcelRequire("fFpUU");
const $97fbb1036aaa8ee6$export$f2011725fe81878a = (issueList, issueDiscoveryUrl)=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireViewIssueAnalyticsEvent = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $d1b814c754593185$export$71ce489a3b20fc93), {
            isNewGIC: true
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        content: formatMessage((0, $fFpUU.default).viewIssueCta, {
            issueCount: issueList.length
        }),
        href: issueDiscoveryUrl,
        onClick: fireViewIssueAnalyticsEvent
    };
};
const $97fbb1036aaa8ee6$var$CopyLinkCta = (issueDiscoveryUrl)=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isCopied, setCopied] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const copyToClipboard = (0, $eUqFw.useCallback)(async ()=>{
        try {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            });
            if ((0, $1ybV0.ff)('gic-correctly-handle-errors-when-copying-issue-links-to-clipboard_qcl4x')) await navigator.clipboard.writeText(`${window.location.origin}${issueDiscoveryUrl}`);
            else navigator.clipboard.writeText(`${window.location.origin}${issueDiscoveryUrl}`);
            setCopied(true);
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $d1b814c754593185$export$3a43d61edae693a9)); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'copyToClipboard',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        issueDiscoveryUrl
    ]);
    return {
        content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($97fbb1036aaa8ee6$var$ActionSuccess, null, formatMessage((0, $fFpUU.default).linkCopied)) : formatMessage((0, $fFpUU.default).copyLinkCta),
        onClick: copyToClipboard
    };
};
const $97fbb1036aaa8ee6$var$ClearFiltersCta = ()=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [isCompleted, setIsCompleted] = (0, $eUqFw.useState)(false);
    const clearFiltersAction = (0, $eUqFw.useCallback)(()=>{
        (0, $fqKjL.successFlagClearFiltersAction).start();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        const { GH: GH } = window;
        setIsLoading(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $d1b814c754593185$export$bc715896f18417a3), {
            isNewGIC: true
        });
        GH.WorkController.clearFilters().done(()=>{
            (0, $fqKjL.successFlagClearFiltersAction).stop();
            setIsCompleted(true);
            setIsLoading(false);
        }).fail(()=>{
            (0, $fqKjL.successFlagClearFiltersAction).stop();
            (0, $guiFP.default)({
                meta: {
                    id: 'clearFilters',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        createAnalyticsEvent
    ]);
    if (isLoading) return {
        content: formatMessage((0, $fFpUU.default).clearFiltersCtaLoading)
    };
    if (isCompleted) return {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($97fbb1036aaa8ee6$var$ActionSuccess, null, formatMessage((0, $fFpUU.default).clearFiltersCtaCompleted))
    };
    return {
        content: formatMessage((0, $fFpUU.default).clearFiltersCta),
        onClick: clearFiltersAction
    };
};
const $97fbb1036aaa8ee6$export$54ce82bbc60a8f6e = (issuesWithNoSprint, totalCreatedIssuesCount, sprint)=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [isCompleted, setIsCompleted] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ addToSprintCTAsEnabled: addToSprintCTAsEnabled }, { disableOtherAddToSprintCTAs: disableOtherAddToSprintCTAs }] = (0, $6Vonl.useAddToSprintFlagActionStateController)();
    const addToSprintAction = (0, $eUqFw.useCallback)(()=>{
        (0, $fqKjL.successFlagAddToSprintAction).start();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        const { GH: GH } = window;
        disableOtherAddToSprintCTAs();
        setIsLoading(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $d1b814c754593185$export$31bef7c6ffa89efa), {
            isNewGIC: true
        });
        GH.WorkController.addNewIssuesToSprintFromJFE(sprint, issuesWithNoSprint).done(()=>{
            (0, $fqKjL.successFlagAddToSprintAction).stop();
            setIsCompleted(true);
            setIsLoading(false);
        }).fail(()=>{
            (0, $fqKjL.successFlagAddToSprintAction).stop();
            (0, $guiFP.default)({
                meta: {
                    id: 'addToSprint',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        createAnalyticsEvent,
        sprint,
        issuesWithNoSprint,
        disableOtherAddToSprintCTAs
    ]);
    if (isLoading) return [
        {
            content: formatMessage((0, $fFpUU.default).addIssuesToSprintCtaLoading)
        }
    ];
    if (isCompleted) return [
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($97fbb1036aaa8ee6$var$ActionSuccess, null, formatMessage((0, $fFpUU.default).addIssuesToSprintCtaCompleted))
        }
    ];
    if (addToSprintCTAsEnabled) return [
        {
            content: formatMessage((0, $fFpUU.default).addAllIssuesToSprintCta, {
                sprintName: sprint.name
            }),
            onClick: addToSprintAction
        }
    ];
    return [];
};
const $97fbb1036aaa8ee6$var$getAddToSprintsCtas = (issuesWithNoSprint, issueList, sprints)=>{
    const editableSprints = sprints.filter((sprint)=>sprint.canUpdateSprint);
    const totalCreatedIssuesCount = issueList.length;
    let ctaList = [];
    editableSprints.forEach((sprint)=>{
        ctaList = ctaList.concat($97fbb1036aaa8ee6$export$54ce82bbc60a8f6e(issuesWithNoSprint, totalCreatedIssuesCount, sprint));
    });
    return ctaList;
};
const $97fbb1036aaa8ee6$export$6de10317e135f24 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl })=>[
        $97fbb1036aaa8ee6$export$f2011725fe81878a(issueList, issueDiscoveryUrl),
        $97fbb1036aaa8ee6$var$CopyLinkCta(issueDiscoveryUrl)
    ];
const $97fbb1036aaa8ee6$export$882355824d3fc905 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, issuesWithNoSprint: issuesWithNoSprint, sprints: sprints })=>{
    const ctaList = $97fbb1036aaa8ee6$var$getAddToSprintsCtas(issuesWithNoSprint, issueList, sprints);
    ctaList.push($97fbb1036aaa8ee6$export$f2011725fe81878a(issueList, issueDiscoveryUrl));
    return ctaList;
};
const $97fbb1036aaa8ee6$export$f5c2849658ba2a03 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, isFiltered: isFiltered })=>{
    const ctaList = [
        $97fbb1036aaa8ee6$export$f2011725fe81878a(issueList, issueDiscoveryUrl)
    ];
    if (isFiltered) ctaList.push($97fbb1036aaa8ee6$var$ClearFiltersCta());
    return ctaList;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97fbb1036aaa8ee6$var$ActionSuccess = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazocqs",
            __cmplp.className
        ])
    });
});

});
const $d1b814c754593185$export$71ce489a3b20fc93 = 'viewIssues';
const $d1b814c754593185$export$3a43d61edae693a9 = 'copyLink';
const $d1b814c754593185$export$31bef7c6ffa89efa = 'addToSprint';
const $d1b814c754593185$export$bc715896f18417a3 = 'clearFilters';

parcelRegister("fFpUU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a3c8d911e2cb871$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3a3c8d911e2cb871$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewIssueCta: {
        "id": "issue-create.modal.success-flag.actions.view-issue-cta",
        "defaultMessage": "View {issueCount, plural, one {issue} other {issues}}"
    },
    copyLinkCta: {
        "id": "issue-create.modal.success-flag.actions.copy-link-cta",
        "defaultMessage": "Copy link"
    },
    linkCopied: {
        "id": "issue-create.modal.success-flag.actions.link-copied",
        "defaultMessage": "Copied"
    },
    addAllIssuesToSprintCta: {
        "id": "issue-create.modal.success-flag.actions.add-all-issues-to-sprint-cta",
        "defaultMessage": "Add to {sprintName}"
    },
    clearFiltersCta: {
        "id": "issue-create.modal.success-flag.actions.clear-filters-cta",
        "defaultMessage": "Clear filters"
    },
    clearFiltersCtaLoading: {
        "id": "issue-create.modal.success-flag.actions.clear-filters-cta-loading",
        "defaultMessage": "Clearing..."
    },
    clearFiltersCtaCompleted: {
        "id": "issue-create.modal.success-flag.actions.clear-filters-cta-completed",
        "defaultMessage": "Filters cleared"
    },
    addIssuesToSprintCtaLoading: {
        "id": "issue-create.modal.success-flag.actions.add-issues-to-sprint-cta-loading",
        "defaultMessage": "Adding..."
    },
    addIssuesToSprintCtaCompleted: {
        "id": "issue-create.modal.success-flag.actions.add-issues-to-sprint-cta-completed",
        "defaultMessage": "Added to sprint"
    }
});

});


const $43f1e8ead7a5a2a9$export$2e4c8b336846b593 = 'jira-issue-create.modal.create-form.success-flag';
const $43f1e8ead7a5a2a9$export$407f3b8bfd90ad8d = 'cmp-scrum-flag';
const $43f1e8ead7a5a2a9$export$256b368007db542a = 'cmp-kanban-flag';
const $43f1e8ead7a5a2a9$export$858ff9c1b12e1d84 = 'default-success-flag';

parcelRegister("94TZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2396a99e948b466$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d2396a99e948b466$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.create-success-flag-title",
        "defaultMessage": "You've created \"{issueKey}\" issue"
    },
    multiplesIssuesCreatedSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-success-flag-title",
        "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# issues}}"
    },
    issueCreatedNoSprintOrInBacklogSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.issue-created-no-sprint-or-in-backlog-success-flag-title",
        "defaultMessage": "{issueCount, plural, one {Issue} other {Issues}} added to the backlog"
    },
    issueCreatedNoSprintSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.issue-created-no-sprint-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {Your issue {issueKey} has} other {Your issues have}} been created and added to the backlog."
    },
    multiplesIssuesCreatedSomeNoSprintSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-title",
        "defaultMessage": "Issues added to sprint(s) and backlog"
    },
    multiplesIssuesCreatedSomeNoSprintSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-description",
        "defaultMessage": "Some of your issues weren't added to a sprint."
    },
    createdHiddenIssueSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.created-hidden-issue-success-flag-title",
        "defaultMessage": "{issueCount, plural, one {Issue} other {Issues}} created but not visible"
    },
    scrumCreatedHiddenIssueSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.scrum-created-hidden-issue-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the issue was added to a different sprint, it may not be visible} other {If the board has active filters, or the issues were added to a different sprint, they may not be visible}}."
    },
    issueCreatedInBacklogSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.issue-created-in-backlog-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {Your issue {issueKey} has been created, but isn't on the board} other {Your issues have been created, but aren't on the board}}."
    },
    multiplesIssuesCreatedSomeInBacklogSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-title",
        "defaultMessage": "Issues added to board and backlog"
    },
    multiplesIssuesCreatedSomeInBacklogSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-description",
        "defaultMessage": "Your issues have been created, but some aren't on the board."
    },
    kanbanCreatedHiddenIssueSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.kanban-created-hidden-issue-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the issue wasn't added to the board, it may not be visible} other {If the board has active filters, or the issues weren't added to the board, they may not be visible}}."
    }
});

});


parcelRegister("8iViP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $338c9943ee8183cd$export$2e2bcd8739ae039);

var $5OlVz = parcelRequire("5OlVz");

var $eWtPV = parcelRequire("eWtPV");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $iBFrS = parcelRequire("iBFrS");

var $9Amv1 = parcelRequire("9Amv1");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $532yW = parcelRequire("532yW");

var $iKU9K = parcelRequire("iKU9K");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $2U8YO = parcelRequire("2U8YO");

var $a4IeB = parcelRequire("a4IeB");

var $gCtmO = parcelRequire("gCtmO");

var $hlomJ = parcelRequire("hlomJ");

var $7bJW5 = parcelRequire("7bJW5");

var $59JiB = parcelRequire("59JiB");

var $lyeLC = parcelRequire("lyeLC");

var $e9kDw = parcelRequire("e9kDw");

var $ep6rZ = parcelRequire("ep6rZ");

var $gek7b = parcelRequire("gek7b");

var $iPiat = parcelRequire("iPiat");

var $fGsEG = parcelRequire("fGsEG");

var $fpoU0 = parcelRequire("fpoU0");
const $338c9943ee8183cd$var$NativeIssueTable = ({ issues: issues, columns: columns, columnWidthOverrides: columnWidthOverrides, components: components, loading: loading = false, selectedRow: selectedRow = null, eventHandlers: eventHandlers, hasInlineEditing: hasInlineEditing = true, onSelectedRowChange: onSelectedRowChange, onPageChange: onPageChange, sortField: sortField, sortDirection: sortDirection = (0, $a4IeB.SORT_ASC), onReady: onReady, onSortChange: onSortChange, onColumnsChange: onColumnsChange, onColumnResize: onColumnResize, onRestoreDefaultColumns: onRestoreDefaultColumns, issueSearchBaseUrl: issueSearchBaseUrl = '/issues', useColumnLoader: useColumnLoader, isColumnPickerLoading: isColumnPickerLoading, issueCreateProjectKey: issueCreateProjectKey })=>{
    const scrollContainerRef = (0, $eUqFw.useRef)(null);
    const tableRef = (0, $eUqFw.useRef)(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issuesData = (0, $iWLL0.useFragment)((0, $eWtPV.default), issues); /* eslint-disable jira/relay/must-colocate-fragment-spreads */ 
    const columnsData = (0, $iWLL0.useFragment)((0, $5OlVz.default), columns); /* eslint-enable jira/relay/must-colocate-fragment-spreads */ 
    const isInitialDataLoaded = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && !loading && !isInitialDataLoaded.current) isInitialDataLoaded.current = true;
    }, [
        loading
    ]);
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>{
        const issueTableNumberOfColumns = columnsData.totalCount;
        const issueTableFieldTypesSet = new Set();
        columnsData.edges.map((edge)=>edge?.node.type).filter((0, $7bJW5.isNonNullish)).forEach(issueTableFieldTypesSet.add, issueTableFieldTypesSet);
        const issueTableFieldTypes = Array.from(issueTableFieldTypesSet).sort();
        return {
            issueTableNumberOfColumns: issueTableNumberOfColumns,
            issueTableFieldTypes: issueTableFieldTypes
        };
    }, [
        columnsData.edges,
        columnsData.totalCount
    ]);
    const canViewColumnConfiguration = useColumnLoader !== undefined;
    const canEditColumnConfiguration = onColumnsChange !== undefined;
    const isColumnResizingEnabled = (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && onColumnResize != null;
    const hasFixedTableLayout = (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && isColumnResizingEnabled;
    const onColumnPickerChange = (0, $eUqFw.useCallback)((columnIds)=>{
        if (onColumnsChange && columnIds) onColumnsChange(columnIds, (0, $a4IeB.MODIFY_COLUMNS));
    }, [
        onColumnsChange
    ]);
    const getHeaderCellForNoColumnConfig = (0, $eUqFw.useCallback)(()=>(0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCtmO.ContentContainer), {
            isIconPersistent: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCtmO.ColumnName), {
            "aria-label": formatMessage((0, $fGsEG.default).columnHeaderIssueActions)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCtmO.HeaderCell), {
            scope: "col",
            alignRight: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCtmO.ContentContainer), {
            isIconPersistent: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCtmO.ColumnName), null, formatMessage((0, $fGsEG.default).columnHeaderIssueActions)))), [
        formatMessage
    ]);
    const mappedColumns = (0, $eUqFw.useMemo)(()=>{
        const columnConfig = (0, $fpoU0.getColumnConfig)(formatMessage);
        const columnsWithConfig = [];
        columnsData.edges.map((edge)=>edge?.node).filter((0, $7bJW5.isNonNullish)).forEach((node)=>{
            const { fieldSetId: fieldSetId, type: type, displayName: displayName, jqlTerm: jqlTerm, isSortable: isSortable } = node;
            const baseConfig = {
                id: fieldSetId,
                type: type,
                title: displayName ?? '',
                jqlTerm: jqlTerm,
                fieldTypeDisplayName: '',
                isSortable: isSortable ?? undefined,
                currentSorting: jqlTerm === sortField ? sortDirection : (0, $a4IeB.SORT_NONE),
                onSortOrderChanged: onSortChange,
                ...!(0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && {
                    // added with inline editing, removed with resizable columns
                    shouldResizeWithTable: true
                },
                ...(0, $1ybV0.ff)('com.atlassian.rm.jpo.deprecate-parent-link-nin') && type === (0, $a4IeB.COLUMN_TYPE_PARENT_LINK) && {
                    warningText: formatMessage((0, $fGsEG.default).deprecatedParentLinkMessage, {
                        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
                    })
                },
                ...(0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && {
                    // TODO EM-6714: Update to also check for value from API
                    customWidth: columnWidthOverrides?.[fieldSetId]
                }
            };
            if ((0, $7bJW5.isKnownColumnType)(type)) {
                const getColumnTypeConfig = columnConfig[type];
                const knownColumnTypeConfig = getColumnTypeConfig();
                if ((0, $1ybV0.ff)('nin-resizable-columns_8z4eo')) {
                    // Prepare for removing `width` and `shouldResizeWithTable` from default
                    // column configs, can be cleaned up with nin-resizable-columns_8z4eo
                    delete knownColumnTypeConfig.width;
                    delete knownColumnTypeConfig.shouldResizeWithTable;
                }
                columnsWithConfig.push({
                    ...baseConfig,
                    ...knownColumnTypeConfig,
                    isSortable: knownColumnTypeConfig.isSortable ?? true
                });
            } else columnsWithConfig.push({
                ...baseConfig,
                defaultWidth: (0, $a4IeB.DEFAULT_COLUMN_WIDTH),
                ...!(0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && {
                    width: (0, $a4IeB.DEFAULT_COLUMN_WIDTH)
                }
            });
        });
        const MaybeColumnPickerCell = (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? (0, $eUqFw.Fragment) : $338c9943ee8183cd$var$ColumnPickerCell;
        const customHeader = canViewColumnConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MaybeColumnPickerCell, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKU9K.default), {
            columns: columnsData,
            components: components?.columnPicker,
            onChange: canEditColumnConfiguration ? onColumnPickerChange : undefined,
            onRestoreDefaultColumns: onRestoreDefaultColumns,
            useColumnLoader: useColumnLoader,
            isLoading: isColumnPickerLoading
        })) : getHeaderCellForNoColumnConfig();
        columnsWithConfig.push({
            id: (0, $a4IeB.COLUMN_ID_MEATBALL_MENU),
            type: (0, $a4IeB.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS,
            title: '',
            fieldTypeDisplayName: '',
            jqlTerm: '',
            // TODO: inline custom header wrapper when cleaning up jsv-one-issue-table-spreadsheet-ui_ygrnf
            customHeader: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                alignInline: "end"
            }, customHeader) : customHeader,
            ...columnConfig[(0, $a4IeB.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]()
        });
        return columnsWithConfig;
    }, [
        canEditColumnConfiguration,
        canViewColumnConfiguration,
        columnsData,
        columnWidthOverrides,
        components?.columnPicker,
        formatMessage,
        getHeaderCellForNoColumnConfig,
        isColumnPickerLoading,
        onColumnPickerChange,
        onRestoreDefaultColumns,
        onSortChange,
        sortDirection,
        sortField,
        useColumnLoader
    ]);
    const handleOnColumnsChange = (0, $eUqFw.useCallback)((newColumns)=>{
        if (onColumnsChange) {
            const columnsWithoutMeatball = newColumns.filter(({ id: id })=>Boolean(id) && id !== (0, $a4IeB.COLUMN_ID_MEATBALL_MENU));
            const columnIds = columnsWithoutMeatball.map(({ id: id })=>id);
            const edges = columnsWithoutMeatball.map(({ id: id, type: type, title: title, jqlTerm: jqlTerm, isSortable: isSortable, fieldTypeDisplayName: fieldTypeDisplayName })=>({
                    node: {
                        fieldSetId: id,
                        type: type ?? null,
                        displayName: title,
                        jqlTerm: jqlTerm ?? null,
                        isSortable: isSortable ?? null,
                        fieldType: fieldTypeDisplayName ? {
                            displayName: fieldTypeDisplayName
                        } : null
                    }
                }));
            const optimisticFieldSets = {
                totalCount: columnsData.totalCount,
                edges: edges
            };
            onColumnsChange(columnIds, (0, $a4IeB.REORDER_COLUMNS), optimisticFieldSets);
        }
    }, [
        columnsData.totalCount,
        onColumnsChange
    ]);
    const handleOnResizeColumn = (0, $eUqFw.useCallback)((fieldSetId, newWidth)=>{
        if (onColumnResize) {
            // Collect custom widths from the mapped columns object
            const mappedColumnWidths = mappedColumns.reduce((acc, column)=>{
                if (column.customWidth != null && column.customWidth !== column.defaultWidth) acc[column.id] = column.customWidth;
                return acc;
            }, {}); // Update or remove the new width from the custom widths object
            if (newWidth != null) mappedColumnWidths[fieldSetId] = newWidth;
            else delete mappedColumnWidths[fieldSetId];
            onColumnResize(mappedColumnWidths);
        }
    }, [
        onColumnResize,
        mappedColumns
    ]);
    const issueKeys = (0, $eUqFw.useMemo)(()=>issuesData?.edges?.map((edge)=>edge?.node?.key ?? ''), [
        issuesData?.edges
    ]);
    const tableInjectedProps = (0, $eUqFw.useMemo)(()=>({
            ...eventHandlers,
            issueSearchBaseUrl: issueSearchBaseUrl
        }), [
        eventHandlers,
        issueSearchBaseUrl
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $1ybV0.ff)('nin.page-load-instrumentation-fix') && onReady && onReady();
    }, [
        onReady
    ]);
    const conditionalOnColumnsChange = canEditColumnConfiguration ? handleOnColumnsChange : undefined;
    (0, $eUqFw.useEffect)(()=>{
        const scrollableElement = scrollContainerRef.current;
        if (scrollableElement) return (0, $iBFrS.autoScrollForElements)({
            element: scrollableElement,
            // Don't allow scroll for column resizing because the calculations are be based on
            // mouse position and the mouse doesn't actually move when the autoScroll occurs.
            ...(0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && {
                canScroll: ({ source: source })=>source.data.operation !== (0, $a4IeB.COLUMN_OPERATION_RESIZE)
            }
        });
    }, []); // Show the skeleton if we are loading on initial render as we may only have partial row data
    if ((0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && loading && !isInitialDataLoaded.current) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hlomJ.IssueTableSkeleton), null);
    const enableRowDragging = (0, $1ybV0.ff)('jsw.enable-nin-rank-dnd') && sortField?.toLowerCase() === 'rank'; // TODO: inline footer component when cleaning up jsv-one-issue-table-spreadsheet-ui_ygrnf
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ep6rZ.default), {
        Footer: components?.Footer,
        IssueCount: components?.IssueCount,
        issues: issuesData,
        issueCreateProjectKey: issueCreateProjectKey,
        onPageChange: onPageChange
    });
    const MaybeMainContainer = (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? $338c9943ee8183cd$var$MainContainer : (0, $eUqFw.Fragment);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "nativeIssueTable",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MaybeMainContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($338c9943ee8183cd$var$ScrollContainer, {
        ref: scrollContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9kDw.LazyEditabilityLoaderContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59JiB.SelectedRowContainer), {
        selectedRowIndex: selectedRow,
        amountOfRows: issuesData?.edges?.length ?? 0,
        onRowChange: onSelectedRowChange,
        onPageChange: onPageChange,
        issues: issuesData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iPiat.default), {
        issueKeys: issueKeys,
        onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $532yW.ColumnPickerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gek7b.default), {
        issueResults: issuesData,
        columns: mappedColumns,
        canViewColumnConfiguration: canViewColumnConfiguration,
        canEditColumnConfiguration: canEditColumnConfiguration,
        hasInlineEditing: hasInlineEditing,
        hasFixedTableLayout: hasFixedTableLayout,
        isColumnResizingEnabled: isColumnResizingEnabled,
        loading: loading,
        tableInjectedProps: tableInjectedProps,
        onColumnsChange: conditionalOnColumnsChange,
        onResizeColumn: handleOnResizeColumn,
        enableRowDragging: enableRowDragging,
        NoColumns: components?.NoColumns,
        NoIssues: components?.NoIssues,
        tableRef: tableRef
    })))), !(0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && footer), (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && footer), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "nativeIssueTable"
    }));
    return (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2U8YO.ScrollStateContextProvider), {
        scrollRef: scrollContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lyeLC.TableSizeProvider), {
        tableRef: tableRef
    }, content)) : content;
};
var $338c9943ee8183cd$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $338c9943ee8183cd$var$NativeIssueTable;
const $338c9943ee8183cd$var$ColumnPickerCell = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $gCtmO.HeaderCellWithBorder), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1xi2idpf _kqsw1if8 _1e0cdav6 _bfhkvuon _ca0qze3t _u5f3ze3t _n3tdze3t _19bv12x7 _29hz1wug _bhl91ns9 _hc7q15vq _njtz15vq _ogwtv77o _6tin1b66 _1cezv77o _m3zkv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $338c9943ee8183cd$var$ScrollContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm _2lx21bp4 _1n261q9c _1reo1wug _18m91wug",
            (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? "_ouuo1ylp" : "_4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $338c9943ee8183cd$var$MainContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _1h6d1fzn _1dqonqa1 _189et94y _2rkopd34 _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5OlVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $bde9afacd43dc00e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e0359f8c546c648b53474f5abd4b2e63>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bde9afacd43dc00e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_nativeIssueTable_NativeIssueTable_columns",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "totalCount"
            },
            "action": "THROW",
            "path": "totalCount"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueSearchFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "fieldSetId"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.fieldSetId"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "type"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.type"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.displayName"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "jqlTerm"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.jqlTerm"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSortable"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "edges.node"
                    }
                ]
            },
            "action": "THROW",
            "path": "edges"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueTableColumnPicker_ColumnConfig"
        }
    ],
    "type": "JiraIssueSearchFieldSetConnection"
};
$bde9afacd43dc00e$var$node.hash = "14f12b862a152994d0f65a3e29b8d07c";
var $bde9afacd43dc00e$export$2e2bcd8739ae039 = $bde9afacd43dc00e$var$node;

});

parcelRegister("eWtPV", function(module, exports) {

$parcel$export(module.exports, "default", () => $458c2f8dee67f92b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a61e7ec70c1efd9631a1c7f99c479b2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $458c2f8dee67f92b$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "pageSize",
            "variableName": "pageSize"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "pageSize"
            }
        ],
        "kind": "Fragment",
        "name": "ui_nativeIssueTable_NativeIssueTable_issues",
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isInlineEditingEnabled",
                        "variableName": "isInlineEditingEnabled"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "issueTable_nativeIssueTable"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "footerRenderer_nativeIssueTable"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "selectedRowState_nativeIssueTable_SelectedRowContainer"
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$458c2f8dee67f92b$var$node.hash = "86c11d164cdcaa91fa61282de59e2e0d";
var $458c2f8dee67f92b$export$2e2bcd8739ae039 = $458c2f8dee67f92b$var$node;

});

parcelRegister("iBFrS", function(module, exports) {

$parcel$export(module.exports, "autoScrollForElements", () => $2bdf60adda54f012$export$4b66ee8317094cdb);
parcelRequire("eo9PV");
var $9wCS5 = parcelRequire("9wCS5");

var $5dz2w = parcelRequire("5dz2w");
const $2bdf60adda54f012$var$api = (0, $5dz2w.makeApi)({
    monitor: (0, $9wCS5.monitorForElements)
});
const $2bdf60adda54f012$export$4b66ee8317094cdb = $2bdf60adda54f012$var$api.autoScroll;
const $2bdf60adda54f012$export$c9168f41de61f525 = $2bdf60adda54f012$var$api.autoScrollWindow;

});
parcelRegister("5dz2w", function(module, exports) {

$parcel$export(module.exports, "makeApi", () => $247b873d90531327$export$b8fa21320a811083);
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");

var $2bJOS = parcelRequire("2bJOS");

var $b8ruP = parcelRequire("b8ruP");

var $b2gaW = parcelRequire("b2gaW");
function $247b873d90531327$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        return (0, $jFl9L.combine)((0, $b8ruP.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        return ()=>windowRegistry.delete(unique);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $b2gaW.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $2bJOS.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}

});
parcelRegister("2bJOS", function(module, exports) {

$parcel$export(module.exports, "getScheduler", () => $8b7edb6fc42851b3$export$5cff7ac265db316a);

var $lOu8O = parcelRequire("lOu8O");
// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $8b7edb6fc42851b3$var$schedulers = new Map();
function $8b7edb6fc42851b3$export$5cff7ac265db316a(monitor) {
    const scheduler = $8b7edb6fc42851b3$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $8b7edb6fc42851b3$var$makeScheduler(monitor);
    $8b7edb6fc42851b3$var$schedulers.set(monitor, created);
    return created;
}
function $8b7edb6fc42851b3$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = document.elementFromPoint(latestArgs.location.current.input.clientX, latestArgs.location.current.input.clientY);
        (0, $lOu8O.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $lOu8O.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}

});
parcelRegister("lOu8O", function(module, exports) {

$parcel$export(module.exports, "markAndGetEngagement", () => $b8e95e7998ef0be7$export$8c764c3f2fc3d2d2);
$parcel$export(module.exports, "clearUnusedEngagements", () => $b8e95e7998ef0be7$export$991e77dd347f3df1);
$parcel$export(module.exports, "clearEngagementHistory", () => $b8e95e7998ef0be7$export$13ae770ed39b71ea);
const $b8e95e7998ef0be7$var$ledger = new Map();
const $b8e95e7998ef0be7$var$requested = new Set();
function $b8e95e7998ef0be7$export$8c764c3f2fc3d2d2(element) {
    $b8e95e7998ef0be7$export$1cb7cbb266b6f6fa(element);
    const entry = $b8e95e7998ef0be7$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $b8e95e7998ef0be7$var$ledger.set(element, fresh);
    return fresh;
}
function $b8e95e7998ef0be7$export$1cb7cbb266b6f6fa(element) {
    $b8e95e7998ef0be7$var$requested.add(element);
}
function $b8e95e7998ef0be7$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $b8e95e7998ef0be7$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $b8e95e7998ef0be7$var$ledger.forEach((_, element)=>{
        if (!$b8e95e7998ef0be7$var$requested.has(element)) $b8e95e7998ef0be7$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $b8e95e7998ef0be7$var$requested.clear();
}
function $b8e95e7998ef0be7$export$13ae770ed39b71ea() {
    $b8e95e7998ef0be7$var$ledger.clear();
}

});


parcelRegister("b8ruP", function(module, exports) {

$parcel$export(module.exports, "selector", () => $4f53e0cf4f3db8df$export$aea217a45095ce11);
$parcel$export(module.exports, "addScrollableAttribute", () => $4f53e0cf4f3db8df$export$4ec12fb57dfebd53);
const $4f53e0cf4f3db8df$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $4f53e0cf4f3db8df$export$aea217a45095ce11 = `[${$4f53e0cf4f3db8df$export$4b152ab55cad4fd6}="true"]`;
function $4f53e0cf4f3db8df$export$4ec12fb57dfebd53(element) {
    element.setAttribute($4f53e0cf4f3db8df$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($4f53e0cf4f3db8df$export$4b152ab55cad4fd6);
}

});

parcelRegister("b2gaW", function(module, exports) {

$parcel$export(module.exports, "tryScroll", () => $1d3eba3ce2467b62$export$233199807749476d);

var $igc9Q = parcelRequire("igc9Q");

var $lOu8O = parcelRequire("lOu8O");

var $b8ruP = parcelRequire("b8ruP");

var $lbLMz = parcelRequire("lbLMz");
function $1d3eba3ce2467b62$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $1d3eba3ce2467b62$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$1d3eba3ce2467b62$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $b8ruP.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $1d3eba3ce2467b62$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $lOu8O.markAndGetEngagement)(element);
    const config = (0, $igc9Q.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $lbLMz.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $1d3eba3ce2467b62$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $lOu8O.markAndGetEngagement)(element);
        const config = (0, $igc9Q.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $lbLMz.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $1d3eba3ce2467b62$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $1d3eba3ce2467b62$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$1d3eba3ce2467b62$var$isScrollingAvailable(remainder)) return;
    $1d3eba3ce2467b62$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}

});
parcelRegister("igc9Q", function(module, exports) {

$parcel$export(module.exports, "getInternalConfig", () => $66fbafc1c093817a$export$e96028ec7ff9d079);
const $66fbafc1c093817a$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 300,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $66fbafc1c093817a$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $66fbafc1c093817a$export$e96028ec7ff9d079(provided) {
    return {
        ...$66fbafc1c093817a$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $66fbafc1c093817a$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}

});

parcelRegister("lbLMz", function(module, exports) {

$parcel$export(module.exports, "getScrollBy", () => $6e8faf33c307118e$export$6cfa6dfe6898b98f);

var $e6EBw = parcelRequire("e6EBw");

var $9knKV = parcelRequire("9knKV");

var $ik6Wv = parcelRequire("ik6Wv");

var $jqf1q = parcelRequire("jqf1q");

var $B7xXV = parcelRequire("B7xXV");

var $kMdkl = parcelRequire("kMdkl");
function $6e8faf33c307118e$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $6e8faf33c307118e$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $6e8faf33c307118e$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $9knKV.edges).reduce((map, edge)=>{
        const hitbox = (0, $ik6Wv.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $9knKV.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $B7xXV.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $kMdkl.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $e6EBw.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $jqf1q.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $jqf1q.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $jqf1q.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $jqf1q.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("e6EBw", function(module, exports) {

$parcel$export(module.exports, "canScrollOnEdge", () => $3e6125aba6075bda$export$ccd6d9407403fcad);
const $3e6125aba6075bda$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};

});

parcelRegister("9knKV", function(module, exports) {

$parcel$export(module.exports, "edges", () => $0502d94573f152b7$export$4544a00f8eb65eb2);
$parcel$export(module.exports, "edgeAxisLookup", () => $0502d94573f152b7$export$7fc144124ccf8292);
const $0502d94573f152b7$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $0502d94573f152b7$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};

});

parcelRegister("ik6Wv", function(module, exports) {

$parcel$export(module.exports, "getOverElementHitbox", () => $3dbe4989a882188b$export$b9a449c20abb0e9);

var $br1pC = parcelRequire("br1pC");

var $cKmqq = parcelRequire("cKmqq");
function $3dbe4989a882188b$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $br1pC.axisLookup)[axis];
        const side = (0, $cKmqq.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $3dbe4989a882188b$export$b9a449c20abb0e9 = {
    top: $3dbe4989a882188b$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $3dbe4989a882188b$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $3dbe4989a882188b$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $3dbe4989a882188b$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};

});
parcelRegister("br1pC", function(module, exports) {

$parcel$export(module.exports, "axisLookup", () => $673eff0f7ee04f30$export$42e42cdab35a2b96);
const $673eff0f7ee04f30$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $673eff0f7ee04f30$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $673eff0f7ee04f30$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $673eff0f7ee04f30$var$vertical,
        crossAxis: $673eff0f7ee04f30$var$horizontal
    },
    horizontal: {
        mainAxis: $673eff0f7ee04f30$var$horizontal,
        crossAxis: $673eff0f7ee04f30$var$vertical
    }
};

});

parcelRegister("cKmqq", function(module, exports) {

$parcel$export(module.exports, "mainAxisSideLookup", () => $d8562d1d605931b4$export$a45c0cd714a4dbaa);
const $d8562d1d605931b4$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};

});


parcelRegister("jqf1q", function(module, exports) {

$parcel$export(module.exports, "getScrollChange", () => $bdfe01e15b6de5db$export$470a2ff46db8cee8);

var $br1pC = parcelRequire("br1pC");

var $gbi1O = parcelRequire("gbi1O");

var $cKmqq = parcelRequire("cKmqq");
// We want a consistent scroll speed across devices, regardless of framerate
function $bdfe01e15b6de5db$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $bdfe01e15b6de5db$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $br1pC.axisLookup)[axis];
    const side = (0, $cKmqq.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $gbi1O.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $gbi1O.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $bdfe01e15b6de5db$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $bdfe01e15b6de5db$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $bdfe01e15b6de5db$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $gbi1O.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $cKmqq.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}

});
parcelRegister("gbi1O", function(module, exports) {

$parcel$export(module.exports, "getPercentageInRange", () => $694f9e529fce8a4a$export$1a29de000a332d74);
function $694f9e529fce8a4a$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}

});


parcelRegister("B7xXV", function(module, exports) {

$parcel$export(module.exports, "isAxisAllowed", () => $838c24923fe49251$export$7120fdbd90bd1292);
function $838c24923fe49251$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}

});

parcelRegister("kMdkl", function(module, exports) {

$parcel$export(module.exports, "isWithin", () => $76ef8eaf125506fe$export$cda7a9d4399bf2e3);
function $76ef8eaf125506fe$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}

});





parcelRegister("532yW", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerContainer", () => $80222f4587dd1d1e$export$e1286e1cb3fa0dec);
$parcel$export(module.exports, "useColumnPickerOpenState", () => $80222f4587dd1d1e$export$81588ffe8d9d4add);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $80222f4587dd1d1e$export$e1286e1cb3fa0dec = (0, $heB5U.createContainer)();
const $80222f4587dd1d1e$var$Store = (0, $a61MH.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'ColumnPickerOpenState',
    containedBy: $80222f4587dd1d1e$export$e1286e1cb3fa0dec
});
const $80222f4587dd1d1e$export$81588ffe8d9d4add = (0, $ggKAj.createHook)($80222f4587dd1d1e$var$Store);

});

parcelRegister("iKU9K", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ab2efedb434f0bd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $6OfWd = parcelRequire("6OfWd");

var $0cdA8 = parcelRequire("0cdA8");

var $cBaEp = parcelRequire("cBaEp");

var $gGtKh = parcelRequire("gGtKh");

var $8EpG7 = parcelRequire("8EpG7");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ab2efedb434f0bd$var$ColumnConfig = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("6Aj6C")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/issue-table/column-picker/src/ui/main.tsx"
});
const $2ab2efedb434f0bd$var$ErrorFallback = ({ onRetry: onRetry })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8EpG7.default), {
                ...props,
                ref: triggerRef
            }),
        placement: "bottom-end",
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cBaEp.ErrorState), {
        onRetry: onRetry,
        pageAction: "columnPicker"
    }));
const $2ab2efedb434f0bd$var$AsyncColumnConfig = (props)=>{
    const [resetCaughtError, setResetCaughtError] = (0, $eUqFw.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraIssueTableColumnPicker",
        id: "unhandled",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ab2efedb434f0bd$var$ErrorFallback, {
                onRetry: ()=>setResetCaughtError(error)
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-column-config",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8EpG7.PickerButtonFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ab2efedb434f0bd$var$ColumnConfig, props)));
};
var $2ab2efedb434f0bd$export$2e2bcd8739ae039 = $2ab2efedb434f0bd$var$AsyncColumnConfig;

});
parcelRegister("cBaEp", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $ef7ae4cf716abcda$export$c1ed4f415b9e7023);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $96IgR = parcelRequire("96IgR");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $b1nxp = parcelRequire("b1nxp");

var $i90il = parcelRequire("i90il");
const $ef7ae4cf716abcda$var$BOX_HEIGHT = (0, $c9TLT.gridSize) * 18;
const $ef7ae4cf716abcda$var$ERROR_ICON_BOX_WRAPPER_HEIGHT = (0, $c9TLT.gridSize) * 9;
const $ef7ae4cf716abcda$var$ICON_SIZE = (0, $c9TLT.gridSize) * 9;
const $ef7ae4cf716abcda$export$c1ed4f415b9e7023 = (props)=>{
    const { pageAction: pageAction, onRetry: onRetry, description: description, role: role } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClick = ()=>{
        onRetry();
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${pageAction}Retry clicked`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i90il.StyledBox), {
        height: $ef7ae4cf716abcda$var$BOX_HEIGHT,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i90il.StyledBox), {
        height: $ef7ae4cf716abcda$var$ERROR_ICON_BOX_WRAPPER_HEIGHT,
        iconSize: $ef7ae4cf716abcda$var$ICON_SIZE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        primaryColor: `var(--ds-icon, ${(0, $PdmhA).N500})`,
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i90il.StyledText), null, description !== undefined ? description : formatMessage((0, $b1nxp.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClick,
        appearance: "link",
        testId: "issue-navigator-actions-common.ui.error.button"
    }, formatMessage((0, $b1nxp.default).retryMessage)));
};

});
parcelRegister("b1nxp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a45599fd1dabaf44$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $a45599fd1dabaf44$var$messages = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-actions-common.error.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "issue-navigator-actions-common.error.retry-message",
        "defaultMessage": "Click to retry"
    }
});
var $a45599fd1dabaf44$export$2e2bcd8739ae039 = $a45599fd1dabaf44$var$messages;

});

parcelRegister("i90il", function(module, exports) {

$parcel$export(module.exports, "StyledBox", () => $1347616a23ba87bb$export$d675f139b342d51a);
$parcel$export(module.exports, "StyledText", () => $1347616a23ba87bb$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $hI5oG = parcelRequire("hI5oG");
const $1347616a23ba87bb$export$d675f139b342d51a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $9t7rW.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _18s8dq2u",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});
const $1347616a23ba87bb$var$StyledTextComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $1347616a23ba87bb$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1347616a23ba87bb$var$StyledTextComponent, props));

});


parcelRegister("8EpG7", function(module, exports) {

$parcel$export(module.exports, "PickerButtonFallback", () => $3b8389e4cd1b6462$export$d2ed0044a1cffec6);
$parcel$export(module.exports, "default", () => $3b8389e4cd1b6462$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $28ybo = parcelRequire("28ybo");

var $86Ndv = parcelRequire("86Ndv");

var $fUQgT = parcelRequire("fUQgT");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hbCF4 = parcelRequire("hbCF4");
const $3b8389e4cd1b6462$var$PickerButtonOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, isLoading: isLoading = false, isSelected: isSelected = false }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "bottom",
        content: formatMessage((0, $hbCF4.default).tooltipText),
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3b8389e4cd1b6462$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        testId: "issue-table-column-picker.ui.column-picker.picker-button.picker-button",
        "aria-label": formatMessage((0, $hbCF4.default).columnPickerButtonText),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3b8389e4cd1b6462$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: formatMessage((0, $hbCF4.default).chevronDownIconText),
            size: "medium"
        })),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($28ybo))), {
            label: formatMessage((0, $hbCF4.default).boardIconText),
            size: "medium"
        }),
        isDisabled: isLoading,
        onClick: onClick,
        ref: ref,
        spacing: "none",
        "aria-haspopup": "true",
        "aria-expanded": isSelected,
        isSelected: isSelected
    })));
});
const $3b8389e4cd1b6462$var$PickerButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, isLoading: isLoading = false, isSelected: isSelected = false }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const iconColor = isSelected ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon, #44546F)";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "bottom",
        content: formatMessage((0, $hbCF4.default).tooltipText),
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        testId: "issue-table-column-picker.ui.column-picker.picker-button.picker-button",
        "aria-label": formatMessage((0, $hbCF4.default).tooltipText),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fUQgT))), {
            label: "",
            size: "medium",
            primaryColor: iconColor
        }),
        isDisabled: isLoading,
        onClick: onClick,
        ref: ref,
        "aria-haspopup": "true",
        "aria-expanded": isSelected,
        isSelected: isSelected
    }));
});
const $3b8389e4cd1b6462$export$d2ed0044a1cffec6 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!(0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3b8389e4cd1b6462$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        "aria-label": formatMessage((0, $hbCF4.default).columnPickerButtonText),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3b8389e4cd1b6462$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: formatMessage((0, $hbCF4.default).chevronDownIconText),
            size: "medium"
        })),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($28ybo))), {
            label: formatMessage((0, $hbCF4.default).boardIconText),
            size: "medium"
        }),
        isDisabled: true,
        spacing: "none"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        "aria-label": formatMessage((0, $hbCF4.default).tooltipText),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fUQgT))), {
            label: "",
            size: "medium"
        }),
        isDisabled: true
    });
};
var $3b8389e4cd1b6462$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $bAQOb.componentWithFF)('jsv-one-issue-table-spreadsheet-ui_ygrnf', $3b8389e4cd1b6462$var$PickerButton, $3b8389e4cd1b6462$var$PickerButtonOld);
const $3b8389e4cd1b6462$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8r5cr",
            __cmplp.className
        ])
    });
}); // using div instead of composition styled(button) because innerRef is needed instead of ref, but this causes troubles with placement of picker popup
const $3b8389e4cd1b6462$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kewe1b66 _1uaqgrf3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("28ybo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18e6d81a18ae6069$var$_react = $18e6d81a18ae6069$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $18e6d81a18ae6069$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $18e6d81a18ae6069$var$BoardIcon = (props)=>/*#__PURE__*/ $18e6d81a18ae6069$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18zM2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0120.01 20H3.99A1.994 1.994 0 012 18.006V5.994z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
    }, props));
$18e6d81a18ae6069$var$BoardIcon.displayName = 'BoardIcon';
var $18e6d81a18ae6069$var$_default = $18e6d81a18ae6069$var$BoardIcon;
module.exports.default = $18e6d81a18ae6069$var$_default;

});

parcelRegister("fUQgT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b964a2018cb4a0d7$var$_react = $b964a2018cb4a0d7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b964a2018cb4a0d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b964a2018cb4a0d7$var$PreferencesIcon = (props)=>/*#__PURE__*/ $b964a2018cb4a0d7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 11-5.999.001A3 3 0 0111 8zM9 8a1 1 0 10-1.999-.001A1 1 0 009 8zm10 8a3 3 0 11-5.999.001A3 3 0 0119 16zm-2 0a1 1 0 10-1.999-.001A1 1 0 0017 16z"/></g></svg>`
    }, props));
$b964a2018cb4a0d7$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $b964a2018cb4a0d7$var$_default = $b964a2018cb4a0d7$var$PreferencesIcon;
module.exports.default = $b964a2018cb4a0d7$var$_default;

});

parcelRegister("hbCF4", function(module, exports) {

$parcel$export(module.exports, "default", () => $69e09c66d25e635e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $69e09c66d25e635e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tooltipText: {
        "id": "issue-table-column-picker.column-picker.picker-button.tooltip-text",
        "defaultMessage": "Configure columns"
    },
    columnPickerButtonText: {
        "id": "issue-table-column-picker.column-picker.picker-button.column-picker-button-text",
        "defaultMessage": "Column picker menu"
    },
    chevronDownIconText: {
        "id": "issue-table-column-picker.column-picker.picker-button.chevron-down-icon-text",
        "defaultMessage": "Chevron down icon"
    },
    boardIconText: {
        "id": "issue-table-column-picker.column-picker.picker-button.board-icon-text",
        "defaultMessage": "board icon"
    }
});

});


parcelRegister("6Aj6C", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('dtVnU')
        ]);
        const value = parcelRequire('lGmvz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("dtVnU")
    ]).then(()=>parcelRequire('lGmvz'));
}

});


parcelRegister("2U8YO", function(module, exports) {

$parcel$export(module.exports, "useScrollState", () => $93b1ae720a2f9e16$export$98084ad349e2edae);
$parcel$export(module.exports, "ScrollStateContextProvider", () => $93b1ae720a2f9e16$export$7cc0055278d35041);
/*!
 * Adding too many scroll listeners adds overhead to both the initial
 * "bootstrap" phase, when the listeners are added, and all scroll events.
 *
 * Some virtualisation use-cases such as boards may have a large number of
 * virtual lists instances. Sharing a scroll element through context avoids
 * attaching one listener per list.
 */ 
var $eUqFw = parcelRequire("eUqFw");
const $93b1ae720a2f9e16$export$50b6b7783d156e1b = 200;
const $93b1ae720a2f9e16$var$INITIAL_SCROLL_STATE = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    scrollTop: 0,
    scrollLeft: 0,
    isScrolling: false,
    scrollElement: null
};
const $93b1ae720a2f9e16$var$ScrollStateContext = /*#__PURE__*/ (0, $eUqFw.createContext)($93b1ae720a2f9e16$var$INITIAL_SCROLL_STATE);
const $93b1ae720a2f9e16$export$98084ad349e2edae = ()=>(0, $eUqFw.useContext)($93b1ae720a2f9e16$var$ScrollStateContext);
const $93b1ae720a2f9e16$var$attachResizeObserver = (callback, targetEl)=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!targetEl) return ()=>{};
    let resizeObserver = null;
    // SSR fix. Do not instantiate for SSR
    if (typeof ResizeObserver !== 'undefined') resizeObserver = new ResizeObserver(()=>callback());
    // When mounting our listener, if its the Window object, treat it as such.
    // This can happen in Storybook but not in any other scenario
    if (targetEl instanceof Window) targetEl.addEventListener('resize', callback);
    else resizeObserver?.observe(targetEl);
    return ()=>{
        // Cleanup the resize callback we have attached
        if (targetEl instanceof Window) targetEl.removeEventListener('resize', callback);
        else resizeObserver?.disconnect();
    };
};
/**
 * Listens for scroll events on the `HTMLElement` `scrollRef.current` and updates a state
 * variable with the scroll state, which is returned.
 */ const $93b1ae720a2f9e16$var$useElementScrollState = (scrollRef)=>{
    const [scrollState, setScrollState] = (0, $eUqFw.useState)($93b1ae720a2f9e16$var$INITIAL_SCROLL_STATE);
    (0, $eUqFw.useEffect)(()=>{
        const targetEl = scrollRef.current;
        if (!targetEl) return undefined;
        let clearScrollingTimeoutId;
        const onScroll = ()=>{
            setScrollState((state)=>({
                    ...state,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: true
                }));
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                setScrollState((state)=>({
                        ...state,
                        scrollTop: targetEl.scrollTop,
                        scrollLeft: targetEl.scrollLeft,
                        isScrolling: false
                    }));
            }, $93b1ae720a2f9e16$export$50b6b7783d156e1b);
        };
        const onResize = ()=>{
            setScrollState((state)=>({
                    ...state,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    height: targetEl.clientHeight,
                    width: targetEl.clientWidth,
                    scrollHeight: targetEl.scrollHeight,
                    scrollWidth: targetEl.scrollWidth,
                    isScrolling: true
                }));
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                setScrollState((state)=>({
                        ...state,
                        scrollTop: targetEl.scrollTop,
                        scrollLeft: targetEl.scrollLeft,
                        isScrolling: false
                    }));
            }, $93b1ae720a2f9e16$export$50b6b7783d156e1b);
        };
        // We want to know when the scroll element/container itself resizes as this impacts
        // the number of rows we show
        const cleanupResizeObserver = $93b1ae720a2f9e16$var$attachResizeObserver(onResize, targetEl);
        targetEl.addEventListener('scroll', onScroll);
        setScrollState({
            height: targetEl.clientHeight,
            width: targetEl.clientWidth,
            scrollHeight: targetEl.scrollHeight,
            scrollWidth: targetEl.scrollWidth,
            scrollTop: targetEl.scrollTop,
            scrollLeft: targetEl.scrollLeft,
            isScrolling: false,
            scrollElement: targetEl
        });
        return ()=>{
            targetEl.removeEventListener('scroll', onScroll);
            cleanupResizeObserver();
            clearTimeout(clearScrollingTimeoutId);
        };
    }, [
        scrollRef
    ]);
    return scrollState;
};
const $93b1ae720a2f9e16$export$7cc0055278d35041 = ({ scrollRef: scrollRef, children: children })=>{
    const scrollState = $93b1ae720a2f9e16$var$useElementScrollState(scrollRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($93b1ae720a2f9e16$var$ScrollStateContext.Provider, {
        value: scrollState
    }, children);
};

});

parcelRegister("a4IeB", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $842e422340bc7efd$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $842e422340bc7efd$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SORT_ASC", () => $842e422340bc7efd$export$88956207daf9a17e);
$parcel$export(module.exports, "SORT_DESC", () => $842e422340bc7efd$export$bc14f97913aaf2a);
$parcel$export(module.exports, "SORT_NONE", () => $842e422340bc7efd$export$9c424bf3e8ffe64e);
$parcel$export(module.exports, "MODIFY_COLUMNS", () => $842e422340bc7efd$export$1f921c78ce6d243c);
$parcel$export(module.exports, "REORDER_COLUMNS", () => $842e422340bc7efd$export$83371d6c41a974aa);
$parcel$export(module.exports, "MOVE_COLUMN_FIRST", () => $842e422340bc7efd$export$957d455bb65919d8);
$parcel$export(module.exports, "MOVE_COLUMN_LEFT", () => $842e422340bc7efd$export$2082861c970802b0);
$parcel$export(module.exports, "MOVE_COLUMN_RIGHT", () => $842e422340bc7efd$export$21847d308b0769ad);
$parcel$export(module.exports, "MOVE_COLUMN_LAST", () => $842e422340bc7efd$export$c32913bc261af82d);
$parcel$export(module.exports, "BORDER_WIDTH", () => $842e422340bc7efd$export$e2bd4c1faded7921);
$parcel$export(module.exports, "getDragIconSize", () => $842e422340bc7efd$export$d5120333bf67ced2);
$parcel$export(module.exports, "getMarginBetweenHeaders", () => $842e422340bc7efd$export$a3c854b50595c804);
$parcel$export(module.exports, "COLUMN_ID_MEATBALL_MENU", () => $842e422340bc7efd$export$de4c02b525d877fa);
$parcel$export(module.exports, "MAX_COLUMNS", () => $842e422340bc7efd$export$7ec4af037f372df4);
$parcel$export(module.exports, "KNOWN_COLUMN_TYPES", () => $842e422340bc7efd$export$bbc2e8c301f97f97);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $842e422340bc7efd$export$1adf7afff96bbf16);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH", () => $842e422340bc7efd$export$5575b9e0ed3ff59f);
$parcel$export(module.exports, "DEFAULT_COLUMN_WIDTH", () => $842e422340bc7efd$export$7c3f559e2ca95fa);
$parcel$export(module.exports, "MAXIMUM_COLUMN_WIDTH", () => $842e422340bc7efd$export$e1a42c2fefb5af25);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_LONG", () => $842e422340bc7efd$export$bfe09a9186b98f8f);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SHORT", () => $842e422340bc7efd$export$f2540f34b796306d);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SUMMARY", () => $842e422340bc7efd$export$954afb0fcf5a326);
$parcel$export(module.exports, "getPriorityWidth", () => $842e422340bc7efd$export$39f6b55fa6b34323);
$parcel$export(module.exports, "COLUMN_OPERATION_REORDER", () => $842e422340bc7efd$export$93758649595b2d58);
$parcel$export(module.exports, "COLUMN_OPERATION_RESIZE", () => $842e422340bc7efd$export$cad8c6a0b6e78898);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_FULL_HEIGHT", () => $842e422340bc7efd$export$754b76ac8fa63350);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_HEADER_ONLY", () => $842e422340bc7efd$export$fa5c7dad7ee16383);

var $1ybV0 = parcelRequire("1ybV0");
const $842e422340bc7efd$export$b8b9d90f9e5bd72b = 'jiraNativeIssueTable';
const $842e422340bc7efd$export$d57b6b390e78d90f = 'empanada';
const $842e422340bc7efd$export$88956207daf9a17e = 'ASC';
const $842e422340bc7efd$export$bc14f97913aaf2a = 'DESC';
const $842e422340bc7efd$export$9c424bf3e8ffe64e = 'NONE';
const $842e422340bc7efd$export$1f921c78ce6d243c = 'MODIFY_COLUMNS';
const $842e422340bc7efd$export$83371d6c41a974aa = 'REORDER_COLUMNS';
const $842e422340bc7efd$export$957d455bb65919d8 = 'MOVE_COLUMN_FIRST';
const $842e422340bc7efd$export$2082861c970802b0 = 'MOVE_COLUMN_LEFT';
const $842e422340bc7efd$export$21847d308b0769ad = 'MOVE_COLUMN_RIGHT';
const $842e422340bc7efd$export$c32913bc261af82d = 'MOVE_COLUMN_LAST';
const $842e422340bc7efd$export$e2bd4c1faded7921 = '1px';
const $842e422340bc7efd$export$cdb7fd9d999c7168 = 40;
const $842e422340bc7efd$export$88e6c5bab2ff80e8 = 40;
const $842e422340bc7efd$export$d5120333bf67ced2 = ()=>"var(--ds-space-300, 24px)";
const $842e422340bc7efd$export$a3c854b50595c804 = ()=>"var(--ds-space-050, 4px)";
const $842e422340bc7efd$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $842e422340bc7efd$export$7ec4af037f372df4 = 500;
const $842e422340bc7efd$export$bbc2e8c301f97f97 = {
    ASSIGNEE: 'assignee',
    DESCRIPTION: 'description',
    ENVIRONMENT: 'environment',
    ISSUE_KEY: 'issuekey',
    ISSUE_OPERATIONS: '__issuetable_internal_meatball',
    STATUS: 'status',
    SUMMARY: 'summary',
    ISSUE_TYPE: 'issuetype',
    RESOLUTION: 'resolution',
    PARENT: 'parent',
    LABELS: 'labels',
    COMPONENTS: 'components',
    FIX_VERSIONS: 'fixVersions',
    STATUS_CATEGORY: 'statusCategory',
    PROJECT: 'project',
    READ_ONLY: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
    SPRINT: 'com.pyxis.greenhopper.jira:gh-sprint',
    TEXT: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
    EPIC_LINK: 'com.pyxis.greenhopper.jira:gh-epic-link',
    CREATED: 'created',
    RESOLUTION_DATE: 'resolutiondate',
    TEXT_AREA: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
    UPDATED: 'updated',
    DUE_DATE: 'duedate',
    REPORTER: 'reporter',
    CREATOR: 'creator',
    PRIORITY: 'priority',
    AFFECTS_VERSIONS: 'versions',
    REQUEST_TYPE: 'com.atlassian.servicedesk:vp-origin'
};
const $842e422340bc7efd$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $842e422340bc7efd$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $842e422340bc7efd$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $842e422340bc7efd$export$5575b9e0ed3ff59f = 69; // 2 x 8px cell padding + 2 x 24px icon size + 4px gap + 1px border
const $842e422340bc7efd$export$7c3f559e2ca95fa = 170;
const $842e422340bc7efd$export$e1a42c2fefb5af25 = 999;
const $842e422340bc7efd$export$bfe09a9186b98f8f = 400;
const $842e422340bc7efd$export$f2540f34b796306d = 300;
const $842e422340bc7efd$export$954afb0fcf5a326 = 450;
const $842e422340bc7efd$var$COLUMN_WIDTH_PRIORITY_DEFAULT = 42;
const $842e422340bc7efd$var$COLUMN_WIDTH_PRIORITY_SPREADSHEET = 72;
const $842e422340bc7efd$var$COLUMN_WIDTH_PRIORITY_INLINE_EDIT = 140;
const $842e422340bc7efd$export$39f6b55fa6b34323 = ()=>{
    if ((0, $1ybV0.ff)('nin-priority-inline-edit')) return $842e422340bc7efd$var$COLUMN_WIDTH_PRIORITY_INLINE_EDIT;
    if ((0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf')) return $842e422340bc7efd$var$COLUMN_WIDTH_PRIORITY_SPREADSHEET;
    return $842e422340bc7efd$var$COLUMN_WIDTH_PRIORITY_DEFAULT;
};
const $842e422340bc7efd$export$93758649595b2d58 = 'reorder';
const $842e422340bc7efd$export$cad8c6a0b6e78898 = 'resize';
const $842e422340bc7efd$export$754b76ac8fa63350 = 'FULL_HEIGHT';
const $842e422340bc7efd$export$fa5c7dad7ee16383 = 'HEADER_ONLY';

});

parcelRegister("gCtmO", function(module, exports) {

$parcel$export(module.exports, "HeaderCellWithBorder", () => $5d153bb1f3648ade$export$37450e7ed1f57346);
$parcel$export(module.exports, "ColumnName", () => $5d153bb1f3648ade$export$42921065636a7c55);
$parcel$export(module.exports, "SortIcon", () => $5d153bb1f3648ade$export$72820c4f313d7b94);
$parcel$export(module.exports, "HeaderCell", () => $5d153bb1f3648ade$export$efcbfab786023e1a);
$parcel$export(module.exports, "ContentContainer", () => $5d153bb1f3648ade$export$9d2b4227a95687cc);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");
const $5d153bb1f3648ade$export$cdb7fd9d999c7168 = 4.5 * (0, $c9TLT.gridSize);
const $5d153bb1f3648ade$export$2201de8a772882a7 = 3.5 * (0, $c9TLT.gridSize);
const $5d153bb1f3648ade$export$37450e7ed1f57346 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16qs1rfu _4t3i14no _vchhusvi",
            __cmplp.className
        ])
    });
});
const $5d153bb1f3648ade$export$42921065636a7c55 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _vwz47vkz",
            (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && "_1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $5d153bb1f3648ade$export$72820c4f313d7b94 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIconPersistent: isIconPersistent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66 _2hwx1i6y _v5641w7c _vwz47vkz",
            __cmplp.isIconPersistent ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $5d153bb1f3648ade$export$efcbfab786023e1a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $5d153bb1f3648ade$export$37450e7ed1f57346, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1n9uhxp": (0, $9t7rW.default)(__cmplp.columnWidth, "px"),
            "--_1yo9r5p": (0, $9t7rW.default)(__cmplp.minColumnWidth, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1yt4u8be _s7n4nkob",
            __cmplp.columnWidth && "_1bsb14et",
            __cmplp.minColumnWidth && "_1ul9oixm",
            __cmplp.alignRight && "_y3gnusic",
            __cmplp.className
        ])
    });
});
const $5d153bb1f3648ade$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIconPersistent: isIconPersistent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _o5721q9c _4t3i1f4h _k48pbfng _2rko1l7b",
            __cmplp.isIconPersistent && "_bfhkhri9",
            (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? "_1yt41nxw" : "_syaz10s3 _1yt4h8dc",
            (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && "_p12f1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hlomJ", function(module, exports) {

$parcel$export(module.exports, "IssueTableSkeleton", () => $9b0846c29dcc68be$export$32020b6a5557f03e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $29WMc = parcelRequire("29WMc");
const $9b0846c29dcc68be$export$32020b6a5557f03e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b0846c29dcc68be$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29WMc.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b0846c29dcc68be$var$SkeletonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("29WMc", function(module, exports) {

$parcel$export(module.exports, "NativeIssueTableSkeleton", () => $789c5663e6a91d78$export$309a6db85e3f2aaa);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $fiuSs = parcelRequire("fiuSs");
const $789c5663e6a91d78$var$customCssStyles = null;
const $789c5663e6a91d78$var$containerStyles = {
    height: '448px'
};
const $789c5663e6a91d78$export$309a6db85e3f2aaa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fiuSs))),
        containerStyles: $789c5663e6a91d78$var$containerStyles,
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("fiuSs", function(module, exports) {
module.exports = new URL("native-issue-table-skeleton.tpl.e6209376.svg", import.meta.url).toString();

});



parcelRegister("7bJW5", function(module, exports) {

$parcel$export(module.exports, "isNonNullish", () => $4f9fbe5afd688ed1$export$70573498ee17fe1d);
$parcel$export(module.exports, "isKnownColumnType", () => $4f9fbe5afd688ed1$export$e8280bcdc1c3f84);
$parcel$export(module.exports, "getProjectKeyFromIssueKey", () => $4f9fbe5afd688ed1$export$defe38779a6b81d2);
$parcel$export(module.exports, "escapeBackslashes", () => $4f9fbe5afd688ed1$export$fbd15c27bb7e257c);

var $1ybV0 = parcelRequire("1ybV0");

var $a4IeB = parcelRequire("a4IeB");
function $4f9fbe5afd688ed1$export$70573498ee17fe1d(value) {
    return value != null;
}
function $4f9fbe5afd688ed1$export$e8280bcdc1c3f84(value) {
    // remove if statement when cleanup nin-support-request-type-field_ajjpk ff
    if ((0, $a4IeB.KNOWN_COLUMN_TYPES).REQUEST_TYPE === value && !(0, $1ybV0.ff)('nin-support-request-type-field_ajjpk')) return false;
    return value !== undefined && Object.values((0, $a4IeB.KNOWN_COLUMN_TYPES)).includes(value);
}
function $4f9fbe5afd688ed1$export$defe38779a6b81d2(issueKey) {
    return issueKey.split('-')[0];
}
const $4f9fbe5afd688ed1$export$fbd15c27bb7e257c = (text)=>text.replace(/\\/g, '\\\\');

});

parcelRegister("59JiB", function(module, exports) {

$parcel$export(module.exports, "SelectedRowContainer", () => $b44ea745549f4dad$export$613ab77d2c52b90d);
$parcel$export(module.exports, "useSelectedRow", () => $b44ea745549f4dad$export$11a86b67953bcc50);
$parcel$export(module.exports, "useIsSelected", () => $b44ea745549f4dad$export$fb40a80c530e5f2b);
$parcel$export(module.exports, "useIsFocused", () => $b44ea745549f4dad$export$a774b9356e1b793);

var $kNGhK = parcelRequire("kNGhK");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $dYib0 = parcelRequire("dYib0");
const $b44ea745549f4dad$var$initialState = {
    selectedRowIndex: null,
    amountOfRows: 0,
    focusedRowIndex: null
};
const $b44ea745549f4dad$var$Store = (0, $a61MH.createStore)({
    initialState: $b44ea745549f4dad$var$initialState,
    actions: $dYib0.default,
    name: 'selectedRowState'
});
const $b44ea745549f4dad$export$42a852a2b6b56249 = (0, $heB5U.createContainer)($b44ea745549f4dad$var$Store, {
    onInit: ()=>({ setState: setState }, { selectedRowIndex: selectedRowIndex = null, amountOfRows: amountOfRows = 0 })=>{
            setState({
                selectedRowIndex: selectedRowIndex,
                amountOfRows: amountOfRows
            });
        },
    onUpdate: ()=>({ setState: setState, getState: getState }, { selectedRowIndex: newRowIndex, amountOfRows: newAmountOfRows })=>{
            const { selectedRowIndex: selectedRowIndex, amountOfRows: amountOfRows } = getState();
            selectedRowIndex !== newRowIndex && setState({
                selectedRowIndex: newRowIndex ?? null
            });
            amountOfRows !== newAmountOfRows && setState({
                amountOfRows: newAmountOfRows ?? 0
            });
        }
});
const $b44ea745549f4dad$export$613ab77d2c52b90d = ({ issues: issues, onPageChange: onPageChange, ...props })=>{
    // eslint-disable-next-line jira/relay/query-restriction
    const data = (0, $iWLL0.useFragment)((0, $kNGhK.default), issues);
    const cursors = data?.pageCursors?.around;
    const currentPageIndex = (0, $eUqFw.useMemo)(()=>cursors?.findIndex((cursor)=>cursor?.isCurrent) ?? -1, [
        cursors
    ]);
    const onNextPage = (0, $eUqFw.useCallback)(()=>{
        if (onPageChange && currentPageIndex > -1) {
            const nextPage = cursors?.[currentPageIndex + 1];
            if (nextPage && nextPage.cursor != null) onPageChange(nextPage.cursor, false);
        }
    }, [
        currentPageIndex,
        cursors,
        onPageChange
    ]);
    const onPreviousPage = (0, $eUqFw.useCallback)(()=>{
        if (onPageChange && currentPageIndex > 0) {
            const previousPage = cursors?.[currentPageIndex - 1];
            if (previousPage && previousPage.cursor != null) onPageChange(previousPage.cursor, true);
        }
    }, [
        currentPageIndex,
        cursors,
        onPageChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b44ea745549f4dad$export$42a852a2b6b56249, {
        ...props,
        onNextPage: onNextPage,
        onPreviousPage: onPreviousPage
    });
};
const $b44ea745549f4dad$export$11a86b67953bcc50 = (0, $ggKAj.createHook)($b44ea745549f4dad$var$Store, {
    selector: (state)=>state.selectedRowIndex
});
const $b44ea745549f4dad$export$fb40a80c530e5f2b = (0, $ggKAj.createHook)($b44ea745549f4dad$var$Store, {
    selector: (state, { selectedRowIndex: selectedRowIndex })=>state.selectedRowIndex === selectedRowIndex
});
const $b44ea745549f4dad$export$a774b9356e1b793 = (0, $ggKAj.createHook)($b44ea745549f4dad$var$Store, {
    selector: (state, { selectedRowIndex: selectedRowIndex })=>state.focusedRowIndex === selectedRowIndex
});
const $b44ea745549f4dad$export$7b16b18429291a5c = (0, $ggKAj.createHook)($b44ea745549f4dad$var$Store, {
    selector: null
});
const $b44ea745549f4dad$export$f8ee25964657042a = (0, $ggKAj.createHook)($b44ea745549f4dad$var$Store, {
    selector: (state)=>state.amountOfRows
});

});
parcelRegister("kNGhK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d90bff90a987a639$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<265080814ecd631281ae6eee14697c64>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d90bff90a987a639$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageSize"
        }
    ],
    "kind": "Fragment",
    "name": "selectedRowState_nativeIssueTable_SelectedRowContainer",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "maxCursors",
                    "value": 7
                },
                {
                    "kind": "Variable",
                    "name": "pageSize",
                    "variableName": "pageSize"
                }
            ],
            "concreteType": "JiraPageCursors",
            "kind": "LinkedField",
            "name": "pageCursors",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraPageCursor",
                    "kind": "LinkedField",
                    "name": "around",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "cursor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isCurrent"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$d90bff90a987a639$var$node.hash = "b4c5eb2520f4352cc18991bec7028f79";
var $d90bff90a987a639$export$2e2bcd8739ae039 = $d90bff90a987a639$var$node;

});

parcelRegister("dYib0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7199813596af00f$export$2e2bcd8739ae039);
const $d7199813596af00f$var$actions = {
    setSelectedRow: (rowIndex)=>({ getState: getState, setState: setState }, { onRowChange: onRowChange })=>{
            const { selectedRowIndex: selectedRowIndex, amountOfRows: amountOfRows } = getState();
            if (selectedRowIndex !== rowIndex && amountOfRows > 0) {
                setState({
                    selectedRowIndex: rowIndex,
                    focusedRowIndex: rowIndex
                });
                onRowChange && onRowChange(rowIndex);
            }
        },
    resetFocus: ()=>({ getState: getState, setState: setState })=>{
            const { focusedRowIndex: focusedRowIndex } = getState();
            focusedRowIndex !== null && setState({
                focusedRowIndex: null
            });
        },
    setAmountOfRows: (newAmountOfRows)=>({ setState: setState, getState: getState })=>{
            const { amountOfRows: amountOfRows } = getState();
            amountOfRows !== newAmountOfRows && setState({
                amountOfRows: newAmountOfRows
            });
        },
    selectNextRow: ()=>({ getState: getState, dispatch: dispatch }, { onNextPage: onNextPage })=>{
            const { amountOfRows: amountOfRows, selectedRowIndex: selectedRowIndex } = getState();
            if (amountOfRows === 0) return;
            // edge case: we have only blank issues in the list, we want to make it key accessible
            if (selectedRowIndex === null) dispatch($d7199813596af00f$var$actions.setSelectedRow(0));
            else if (selectedRowIndex < amountOfRows - 1) dispatch($d7199813596af00f$var$actions.setSelectedRow(selectedRowIndex + 1));
            else if (selectedRowIndex === amountOfRows - 1 && onNextPage) onNextPage();
        },
    selectPrevRow: ()=>({ getState: getState, dispatch: dispatch }, { onPreviousPage: onPreviousPage })=>{
            const { selectedRowIndex: selectedRowIndex, amountOfRows: amountOfRows } = getState();
            if (amountOfRows === 0) return;
            // edge case: we have only one blank issues in the list, we want to make it key accessible
            if (selectedRowIndex === null) dispatch($d7199813596af00f$var$actions.setSelectedRow(0));
            else if (selectedRowIndex > 0) dispatch($d7199813596af00f$var$actions.setSelectedRow(selectedRowIndex - 1));
            else if (selectedRowIndex === 0 && onPreviousPage) onPreviousPage();
        }
};
var $d7199813596af00f$export$2e2bcd8739ae039 = $d7199813596af00f$var$actions;

});


parcelRegister("lyeLC", function(module, exports) {

$parcel$export(module.exports, "TableSizeProvider", () => $cd30c94ec98433e0$export$d5a5e307b6cc4da8);
$parcel$export(module.exports, "useTableSize", () => $cd30c94ec98433e0$export$95b939e430a260c);

var $eUqFw = parcelRequire("eUqFw");

var $3NMXU = parcelRequire("3NMXU");
const $cd30c94ec98433e0$var$TableSizeContext = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $3NMXU.DEFAULT_SIZE));
const $cd30c94ec98433e0$export$d5a5e307b6cc4da8 = ({ children: children, tableRef: tableRef })=>{
    const tableSize = (0, $3NMXU.useElementSize)(tableRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cd30c94ec98433e0$var$TableSizeContext.Provider, {
        value: tableSize
    }, children);
};
const $cd30c94ec98433e0$export$95b939e430a260c = ()=>(0, $eUqFw.useContext)($cd30c94ec98433e0$var$TableSizeContext);

});
parcelRegister("3NMXU", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_SIZE", () => $e207dd03dc715dfb$export$e4c0458e30711294);
$parcel$export(module.exports, "useElementSize", () => $e207dd03dc715dfb$export$2b86bedf890eab8);

var $eUqFw = parcelRequire("eUqFw");
const $e207dd03dc715dfb$export$e4c0458e30711294 = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0
};
const $e207dd03dc715dfb$export$2b86bedf890eab8 = (elementRef)=>{
    const [size, setSize] = (0, $eUqFw.useState)($e207dd03dc715dfb$export$e4c0458e30711294);
    (0, $eUqFw.useEffect)(()=>{
        const element = elementRef.current;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                setSize({
                    height: element.clientHeight,
                    width: element.clientWidth,
                    scrollHeight: element.scrollHeight,
                    scrollWidth: element.scrollWidth
                });
            });
            resizeObserver.observe(element);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        elementRef
    ]);
    return size;
};

});


parcelRegister("e9kDw", function(module, exports) {

$parcel$export(module.exports, "LazyEditabilityLoaderContainer", () => $98c8607fedd215aa$export$9e924386fdd64f6e);
$parcel$export(module.exports, "useLazyLoadEditability", () => $98c8607fedd215aa$export$9b127efb5c6c57e8);

var $eUqFw = parcelRequire("eUqFw");

var $1l2Nv = parcelRequire("1l2Nv");

var $iWLL0 = parcelRequire("iWLL0");

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $a9yKi = parcelRequire("a9yKi");

var $1ybV0 = parcelRequire("1ybV0");

var $3z7b2 = parcelRequire("3z7b2");

const $98c8607fedd215aa$var$initialState = {
    loader: null
};
const $98c8607fedd215aa$var$Container = (0, $heB5U.createContainer)();
const $98c8607fedd215aa$var$Store = (0, $a61MH.createStore)({
    containedBy: $98c8607fedd215aa$var$Container,
    initialState: $98c8607fedd215aa$var$initialState,
    actions: $3z7b2.actions,
    handlers: {
        onInit: ()=>({ setState: setState }, { environment: environment })=>{
                setState({
                    loader: new (0, (/*@__PURE__*/$parcel$interopDefault($1l2Nv)))((0, $3z7b2.batchIsEditableInIssueViewFactory)(environment), {
                        maxBatchSize: (0, $115521f7d2b080ad$export$fba142522eb62862)
                    })
                });
            }
    }
});
const $98c8607fedd215aa$export$9e924386fdd64f6e = ({ children: children, isGlobal: isGlobal })=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98c8607fedd215aa$var$Container, {
        isGlobal: isGlobal,
        environment: environment
    }, children);
};
const $98c8607fedd215aa$export$ceb1f4a193b695d1 = (0, $ggKAj.createActionsHook)($98c8607fedd215aa$var$Store);
const $98c8607fedd215aa$export$9b127efb5c6c57e8 = (id, isEditable)=>{
    const { load: load } = $98c8607fedd215aa$export$ceb1f4a193b695d1();
    (0, $eUqFw.useEffect)(()=>{
        const executeLoad = async ()=>{
            // If there is no editability information for the issue field then queue a request to lazily fetch this data
            // We need to explicitly check the ID is an ARI to ignore fields for optimistically created issues, which
            // are initialised as a UUID.
            if (id != null && isEditable === undefined && (!(0, $1ybV0.ff)('jsv-one-issue-table-issue-create') || (0, $a9yKi.JiraIssuefieldvalueAri).check(id))) load(id);
        };
        executeLoad();
    }, [
        isEditable,
        load,
        id
    ]);
};

});
parcelRegister("1l2Nv", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $0f99ec2102c35890$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $0f99ec2102c35890$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $0f99ec2102c35890$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $0f99ec2102c35890$var$getValidCacheKeyFn(options);
        this._cacheMap = $0f99ec2102c35890$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $0f99ec2102c35890$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $0f99ec2102c35890$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$0f99ec2102c35890$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $0f99ec2102c35890$var$enqueuePostPromiseJob = typeof $2fFJv === 'object' && typeof $2fFJv.nextTick === 'function' ? function(fn) {
    if (!$0f99ec2102c35890$var$resolvedPromise) $0f99ec2102c35890$var$resolvedPromise = Promise.resolve();
    $0f99ec2102c35890$var$resolvedPromise.then(function() {
        $2fFJv.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $0f99ec2102c35890$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $0f99ec2102c35890$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $0f99ec2102c35890$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $0f99ec2102c35890$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $0f99ec2102c35890$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$0f99ec2102c35890$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $0f99ec2102c35890$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $0f99ec2102c35890$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $0f99ec2102c35890$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $0f99ec2102c35890$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $0f99ec2102c35890$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $0f99ec2102c35890$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $0f99ec2102c35890$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $0f99ec2102c35890$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $0f99ec2102c35890$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $0f99ec2102c35890$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $0f99ec2102c35890$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $0f99ec2102c35890$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $0f99ec2102c35890$var$DataLoader;

});

parcelRegister("3z7b2", function(module, exports) {

$parcel$export(module.exports, "batchIsEditableInIssueViewFactory", () => $fc67ebfd44d460b6$export$781008fa22e0792);
$parcel$export(module.exports, "actions", () => $fc67ebfd44d460b6$export$e324594224ef24da);

var $kxyAR = parcelRequire("kxyAR");

var $iWLL0 = parcelRequire("iWLL0");

var $guiFP = parcelRequire("guiFP");

var $a4IeB = parcelRequire("a4IeB");

const $fc67ebfd44d460b6$export$781008fa22e0792 = (environment)=>async (fieldIds)=>{
        const isEditableMap = new Map();
        const promise = (0, $iWLL0.fetchQuery)(environment, (0, $kxyAR.default), {
            ids: fieldIds,
            first: (0, $115521f7d2b080ad$export$fba142522eb62862)
        }).toPromise();
        try {
            const data = await promise;
            (0, $iWLL0.commitLocalUpdate)(environment, (store)=>{
                data?.jira?.issueFieldsByIds?.edges?.map((edge)=>edge?.node).filter(Boolean).forEach(({ __id: __id, id: id, isEditableInIssueView: isEditableInIssueView })=>{
                    isEditableMap.set(id, isEditableInIssueView ?? null);
                    // Set whether issue fields are editable as a new client-only field on the matching node in the Relay
                    // store
                    store.get(__id)?.setValue(isEditableInIssueView ?? null, 'lazyIsEditableInIssueView');
                });
            });
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'lazyEditabilityLoader',
                    packageName: (0, $a4IeB.PACKAGE_NAME),
                    teamName: (0, $a4IeB.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        // Ensure input argument order is preserved when returning batch results as required by the dataloader
        return fieldIds.map((id)=>isEditableMap.get(id) ?? null);
    };
const $fc67ebfd44d460b6$export$e324594224ef24da = {
    load: (fieldId)=>({ getState: getState })=>{
            const { loader: loader } = getState();
            return loader ? loader.load(fieldId) : Promise.resolve(null);
        }
};

});
parcelRegister("kxyAR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7dc527b5011b0f3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d8228d06ebe8452bee095ff8f5594dc9>>
 * @relayHash e0b6440748f83639ae3e7c7c2d3fe93e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24fe88e198b2feee72f5134490dbe0d574f365abdcf6a8e568c8988963268c89
const $f7dc527b5011b0f3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ids"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "ids"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isEditableInIssueView"
    }, v5 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "actions_LazyLoadEditabilityQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "issueFieldsByIds",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "actions_LazyLoadEditabilityQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "issueFieldsByIds",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "24fe88e198b2feee72f5134490dbe0d574f365abdcf6a8e568c8988963268c89",
            "metadata": {},
            "name": "actions_LazyLoadEditabilityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f7dc527b5011b0f3$var$node.hash = "271711cb2a483cec7c4f662a4b4db511";
var $f7dc527b5011b0f3$export$2e2bcd8739ae039 = $f7dc527b5011b0f3$var$node;

});

const $115521f7d2b080ad$export$fba142522eb62862 = 500;



parcelRegister("ep6rZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $beb86edafd164c21$export$2e2bcd8739ae039);

var $21Jud = parcelRequire("21Jud");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $6j4bv = parcelRequire("6j4bv");

var $l3Qg0 = parcelRequire("l3Qg0");

var $1ybV0 = parcelRequire("1ybV0");

var $2KzVh = parcelRequire("2KzVh");

var $dWLk9 = parcelRequire("dWLk9");

var $5og2Q = parcelRequire("5og2Q");

var $9K2wg = parcelRequire("9K2wg");

var $clBik = parcelRequire("clBik");

var $eGOui = parcelRequire("eGOui");

var $iOc0X = parcelRequire("iOc0X");

var $fXEyC = parcelRequire("fXEyC");
/**
 * Render the table footer, composing together the default IssueCount and Pagination UI elements.
 */ const $beb86edafd164c21$var$FooterRenderer = ({ Footer: Footer, IssueCount: IssueCount, issues: issues, onPageChange: onPageChange, issueCreateProjectKey: issueCreateProjectKey })=>{
    const data = (0, $iWLL0.useFragment)((0, $21Jud.default), issues);
    let start;
    let center;
    let end;
    // Only render issue count and pagination controls if onPageChange is provided
    if (onPageChange) {
        center = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clBik.default), {
            issues: data,
            IssueCount: IssueCount
        });
        end = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fXEyC.PaginationControls), {
            issues: data,
            onPageChange: (after)=>onPageChange(after, false)
        });
    }
    if ((0, $1ybV0.ff)('jsv-one-issue-table-issue-create')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isCreating, setIsCreating] = (0, $eUqFw.useState)(false);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const cloudId = (0, $dWLk9.useCloudId)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $9K2wg.default), {
            cloudId: cloudId,
            projectKey: issueCreateProjectKey ?? ''
        });
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const buttonTrigger = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const focusReturnRef = (0, $eUqFw.useRef)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const buttonRef = (0, $2KzVh.default)(focusReturnRef, buttonTrigger);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const onIssueCreateClose = (0, $eUqFw.useCallback)((isKeyboard)=>{
            setIsCreating(false);
            if (isKeyboard) requestAnimationFrame(()=>{
                focusReturnRef.current?.focus();
            });
        }, []);
        if (issueCreateProjectKey) start = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eGOui.IssueCreateButton), {
            ref: buttonRef,
            onClick: ()=>setIsCreating(true)
        });
        if (isCreating) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iOc0X.IssueCreateFooter), {
            contextFieldsSubject: entryPointReferenceSubject,
            onClose: onIssueCreateClose
        });
    }
    const hasIssues = (data.totalIssueSearchResultCount ?? 0) > 0;
    const hasIssueConnectionControls = hasIssues && !!onPageChange;
    const hasControlsToDisplay = hasIssueConnectionControls || (0, $1ybV0.ff)('jsv-one-issue-table-issue-create') && start;
    // Hide the footer if we have no issues UNLESS the consumer has provided a custom footer component, in which case
    // the consumer becomes responsible for when the footer should be shown/hidden.
    if (!hasControlsToDisplay && !Footer) return null;
    const FooterToRender = Footer ?? (0, $5og2Q.Footer);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FooterToRender, {
        start: start,
        center: center,
        end: end
    });
};
var $beb86edafd164c21$export$2e2bcd8739ae039 = $beb86edafd164c21$var$FooterRenderer;

});
parcelRegister("21Jud", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bdb5248b7eec0bf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47d021b2566d9f743df716b1e33ff3c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4bdb5248b7eec0bf$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageSize"
        }
    ],
    "kind": "Fragment",
    "name": "footerRenderer_nativeIssueTable",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_nativeIssueTable_IssueCountRenderer"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "pageSize",
                    "variableName": "pageSize"
                }
            ],
            "kind": "FragmentSpread",
            "name": "paginationControls_nativeIssueTable"
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        }
    ],
    "type": "JiraIssueConnection"
};
$4bdb5248b7eec0bf$var$node.hash = "26574b834daacc44cd107c10c087a7fb";
var $4bdb5248b7eec0bf$export$2e2bcd8739ae039 = $4bdb5248b7eec0bf$var$node;

});

parcelRegister("5og2Q", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $99d3214e2e1df43d$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ybV0 = parcelRequire("1ybV0");

var $2U8YO = parcelRequire("2U8YO");

var $lyeLC = parcelRequire("lyeLC");
const $99d3214e2e1df43d$export$a06f1c675e846f6f = (props)=>{
    const { start: start = $99d3214e2e1df43d$var$SpacerElement, center: center = $99d3214e2e1df43d$var$SpacerElement, end: end = $99d3214e2e1df43d$var$SpacerElement } = props;
    let hasShadow = false;
    if ((0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { height: containerHeight, scrollTop: scrollTop } = (0, $2U8YO.useScrollState)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { height: tableHeight } = (0, $lyeLC.useTableSize)();
        // Scroll measurements are fractional, while height measurements are integer, so we need to round before comparing
        hasShadow = containerHeight < tableHeight && Math.round(scrollTop) < tableHeight - containerHeight;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($99d3214e2e1df43d$var$FooterContainer, {
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: hasShadow
    }, start, center, end);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $99d3214e2e1df43d$var$FooterContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasShadow: hasShadow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c _kqsw1if8 _1ltvidpf",
            (0, $1ybV0.ff)('jsv-one-issue-table-sticky-compact-footer_657cf') ? "_94n5idpf _bfhkvuon _1yt4xtwq" : "_1yt4w688",
            (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? "_x3doi319 _1yt41b66" : "_x3do1on0",
            (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && __cmplp.hasShadow && "_16qsahas",
            __cmplp.className
        ])
    });
});
const $99d3214e2e1df43d$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $99d3214e2e1df43d$var$SpacerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($99d3214e2e1df43d$export$d7a54cba636a8cd6, null);

});

parcelRegister("9K2wg", function(module, exports) {

$parcel$export(module.exports, "default", () => $27a7c5734a6462fa$export$2e2bcd8739ae039);

var $7Un5O = parcelRequire("7Un5O");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $27a7c5734a6462fa$var$ContextFieldsEntryPoint = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("jyS6H"))), {
        moduleId: "59f2d965"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>({
            queries: {
                projectData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $7Un5O.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        })
});
var $27a7c5734a6462fa$export$2e2bcd8739ae039 = $27a7c5734a6462fa$var$ContextFieldsEntryPoint;

});
parcelRegister("7Un5O", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cec40ae0023ea38$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab8c78dbca93c8c90c7eaf6038fc23f3>>
 * @relayHash 4843fe4d8b06427be53fd4aa7a21171a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 351c39fdc011095705e76e6555dc2d4dc96d6b4fcf623d50c320db9176ab094e
const $2cec40ae0023ea38$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "351c39fdc011095705e76e6555dc2d4dc96d6b4fcf623d50c320db9176ab094e",
        "metadata": {},
        "name": "contextFields_projectDataQuery",
        "operationKind": "query",
        "text": null
    }
};
var $2cec40ae0023ea38$export$2e2bcd8739ae039 = $2cec40ae0023ea38$var$node;

});

parcelRegister("jyS6H", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ContextFields", () => $82369248ab8ecc6f$export$e8b46166fd454754);
$parcel$export(module.exports, "ContextFieldsFallback", () => $82369248ab8ecc6f$export$9351bc81cc746e38);
$parcel$export(module.exports, "default", () => $82369248ab8ecc6f$export$2e2bcd8739ae039);

var $aXYlR = parcelRequire("aXYlR");

var $rKcLB = parcelRequire("rKcLB");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $hzcvF = parcelRequire("hzcvF");

var $3ZANc = parcelRequire("3ZANc");

var $atT66 = parcelRequire("atT66");
const $82369248ab8ecc6f$export$e8b46166fd454754 = ({ project: project })=>{
    const data = (0, $iWLL0.useFragment)((0, $rKcLB.default), project);
    const { onChangeProject: onChangeProject } = (0, $3ZANc.useIssueCreateActions)();
    const { id: id, key: key, name: name, avatar: avatar } = data;
    const prevProjectId = (0, $hzcvF.usePrevious)(id);
    if (id !== prevProjectId) // Update our form data with our default project
    onChangeProject({
        id: id,
        key: key,
        name: name,
        avatar: avatar ? {
            large: avatar.large
        } : null
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atT66.IssueTypeDropdown), {
        project: data
    });
};
const $82369248ab8ecc6f$export$9351bc81cc746e38 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atT66.IssueTypeDropdown), {
        project: null
    });
const $82369248ab8ecc6f$var$ContextFieldsEntryPoint = ({ queries: { projectData: projectData } })=>{
    const data = (0, $iWLL0.usePreloadedQuery)((0, $aXYlR.default), projectData);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82369248ab8ecc6f$export$e8b46166fd454754, {
        project: data.jira.jiraProjectByKey
    });
};
var $82369248ab8ecc6f$export$2e2bcd8739ae039 = $82369248ab8ecc6f$var$ContextFieldsEntryPoint;

});
parcelRegister("aXYlR", function(module, exports) {

$parcel$export(module.exports, "default", () => $52748e0ea3373c1b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<383a1481fb6c7ac650567f3da9829f88>>
 * @relayHash 4843fe4d8b06427be53fd4aa7a21171a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 351c39fdc011095705e76e6555dc2d4dc96d6b4fcf623d50c320db9176ab094e

var $cNy9K = parcelRequire("cNy9K");
const $52748e0ea3373c1b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "contextFields_projectDataQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "contextFields_nativeIssueTable"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "contextFields_projectDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueTypeId"
                                                        },
                                                        v3 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "issueTypes(first:1000)"
                                },
                                {
                                    "args": v4 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "issueTypeDropdown_issueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "issueTypes"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "351c39fdc011095705e76e6555dc2d4dc96d6b4fcf623d50c320db9176ab094e",
            "metadata": {},
            "name": "contextFields_projectDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$52748e0ea3373c1b$var$node.hash = "6bfdf6f9aeca54b87b93f89dbda451b5";
(0, $cNy9K.PreloadableQueryRegistry).set($52748e0ea3373c1b$var$node.params.id, $52748e0ea3373c1b$var$node);
var $52748e0ea3373c1b$export$2e2bcd8739ae039 = $52748e0ea3373c1b$var$node;

});

parcelRegister("rKcLB", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa2adb6483375d41$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5cefbf52e768c8549a1b55d3db3b52cc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aa2adb6483375d41$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "contextFields_nativeIssueTable",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "issueTypeDropdown_nativeIssueTable"
        }
    ],
    "type": "JiraProject"
};
$aa2adb6483375d41$var$node.hash = "9140ebfd8c443c84e46abee9f914332e";
var $aa2adb6483375d41$export$2e2bcd8739ae039 = $aa2adb6483375d41$var$node;

});

parcelRegister("3ZANc", function(module, exports) {

$parcel$export(module.exports, "IssueCreateFormContainer", () => $17afc0dc4832b5b9$export$671a4290b74930a3);
$parcel$export(module.exports, "useIssueCreateSummary", () => $17afc0dc4832b5b9$export$1912dac8d3721bf1);
$parcel$export(module.exports, "useIssueCreateActions", () => $17afc0dc4832b5b9$export$ee1687bbd99f8e54);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $2NFZu = parcelRequire("2NFZu");
const $17afc0dc4832b5b9$export$671a4290b74930a3 = (0, $heB5U.createContainer)();
const $17afc0dc4832b5b9$var$initialState = {
    project: null,
    issueType: null,
    summary: ''
};
const $17afc0dc4832b5b9$var$Store = (0, $a61MH.createStore)({
    containedBy: $17afc0dc4832b5b9$export$671a4290b74930a3,
    initialState: $17afc0dc4832b5b9$var$initialState,
    actions: $2NFZu.actions
});
const $17afc0dc4832b5b9$export$417f59b7deee1007 = (0, $ggKAj.createHook)($17afc0dc4832b5b9$var$Store, {
    selector: ({ project: project })=>project
});
const $17afc0dc4832b5b9$export$5e4eba133ae8ea0c = (0, $ggKAj.createHook)($17afc0dc4832b5b9$var$Store, {
    selector: ({ issueType: issueType })=>issueType
});
const $17afc0dc4832b5b9$export$1912dac8d3721bf1 = (0, $ggKAj.createHook)($17afc0dc4832b5b9$var$Store, {
    selector: ({ summary: summary })=>summary
});
const $17afc0dc4832b5b9$export$ee1687bbd99f8e54 = (0, $ggKAj.createActionsHook)($17afc0dc4832b5b9$var$Store);

});
parcelRegister("2NFZu", function(module, exports) {

$parcel$export(module.exports, "actions", () => $15f6cea11898649b$export$e324594224ef24da);
const $15f6cea11898649b$export$e324594224ef24da = {
    onChangeProject: (project)=>({ setState: setState })=>setState({
                project: project
            }),
    onChangeIssueType: (issueType)=>({ setState: setState })=>setState({
                issueType: issueType
            }),
    onChangeSummary: (summary)=>({ setState: setState })=>setState({
                summary: summary
            }),
    resetSummary: ()=>({ setState: setState })=>setState({
                summary: ''
            })
};

});


parcelRegister("atT66", function(module, exports) {

$parcel$export(module.exports, "IssueTypeDropdown", () => $42715f3e83c976fe$export$16aea7aa4bac227f);

var $k1DM7 = parcelRequire("k1DM7");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6vSE3 = parcelRequire("6vSE3");

var $hzcvF = parcelRequire("hzcvF");

var $hKVJF = parcelRequire("hKVJF");

var $3ZANc = parcelRequire("3ZANc");

var $7oI0Q = parcelRequire("7oI0Q");
const $42715f3e83c976fe$var$issueTypeToOption = (id, name, avatar)=>({
        label: name,
        value: id,
        avatar: avatar
    });
const $42715f3e83c976fe$export$16aea7aa4bac227f = ({ project: project })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: data, refetch: refetch } = (0, $iWLL0.usePaginationFragment)((0, $k1DM7.default), project);
    const isDisabled = project === null;
    const projectId = data?.id ?? '';
    const issueTypes = data?.issueTypes;
    const issueTypeIdMap = (0, $eUqFw.useMemo)(()=>issueTypes?.edges?.map((edge)=>edge?.node).filter(Boolean).reduce((result, node)=>{
            // eslint-disable-next-line no-param-reassign
            result[node.id] = {
                id: node.id,
                issueTypeId: node.issueTypeId,
                name: node.name,
                avatar: node.avatar ? {
                    small: node.avatar.small
                } : null
            };
            return result;
        }, {}) ?? {}, [
        issueTypes?.edges
    ]);
    const { onChangeIssueType: onChangeIssueType } = (0, $3ZANc.useIssueCreateActions)();
    // TODO EM-7312 We should be sourcing default issue type from the API
    const defaultIssueType = issueTypes?.edges?.[0]?.node;
    const [value, setValue] = (0, $eUqFw.useState)(()=>defaultIssueType ? $42715f3e83c976fe$var$issueTypeToOption(defaultIssueType.id, defaultIssueType.name, defaultIssueType.avatar) : null);
    const defaultValue = (0, $eUqFw.useRef)(value);
    const prevIssueType = (0, $hzcvF.usePrevious)(defaultValue.current);
    if (defaultValue.current && defaultValue.current !== prevIssueType) {
        // Update our form data with our default issue type
        const issueType = issueTypeIdMap[defaultValue.current.value];
        issueType && onChangeIssueType(issueType);
    }
    const handleChange = (0, $eUqFw.useCallback)((option)=>{
        const issueType = option ? issueTypeIdMap[option.value] : null;
        if (issueType) {
            setValue(option);
            onChangeIssueType(issueType);
        }
    }, [
        issueTypeIdMap,
        onChangeIssueType
    ]);
    const onGetRefetchVariables = (0, $eUqFw.useCallback)(()=>({
            id: projectId
        }), [
        projectId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $42715f3e83c976fe$var$issueTypeDropdownStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6vSE3.IssueTypeEditViewWithIssueTypeConnection), {
        isDisabled: isDisabled,
        issueTypesFragmentRef: issueTypes ?? null,
        menuPosition: "fixed",
        onChange: handleChange,
        onRefetch: refetch,
        onGetRefetchVariables: onGetRefetchVariables,
        refetchQuery: (0, $hKVJF.default),
        value: value,
        spacing: "compact",
        stopPropagationOfMenuEscape: true,
        label: formatMessage((0, $7oI0Q.default).dropdownLabel)
    }));
};
const $42715f3e83c976fe$var$issueTypeDropdownStyles = (0, $1ZAYh.xcss)({
    flexShrink: 0,
    width: '170px'
});

});
parcelRegister("k1DM7", function(module, exports) {

$parcel$export(module.exports, "default", () => $79eaf05e07d2183f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f5c10d19896a9e190a238a6222dbf7d9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $hKVJF = parcelRequire("hKVJF");
const $79eaf05e07d2183f$var$node = function() {
    var v0 = [
        "issueTypes"
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "defaultValue": 1000,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $hKVJF.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "issueTypeDropdown_nativeIssueTable",
        "selections": [
            v1 /*: any*/ ,
            {
                "alias": "issueTypes",
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "__issueTypeDropdown_issueTypes_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "issueTypeId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    {
                                        "concreteType": "JiraAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "small"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef"
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraProject"
    };
}();
$79eaf05e07d2183f$var$node.hash = "c5c98d71daeef54d559020a1ba77544f";
var $79eaf05e07d2183f$export$2e2bcd8739ae039 = $79eaf05e07d2183f$var$node;

});
parcelRegister("hKVJF", function(module, exports) {

$parcel$export(module.exports, "default", () => $cccec9afd84009d9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<16918485b45e960346b42843c20b8167>>
 * @relayHash 510e65d36bbf6b19bf04f0b68975e040
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b80109f35d6ad9bae6388d4cce43d7afddb1791938370f8cb29e7b04ad19930
const $cccec9afd84009d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": 1000,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "issueTypeDropdown_SearchRefetchQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "issueTypeDropdown_nativeIssueTable"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "issueTypeDropdown_SearchRefetchQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueTypeId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                }
                                                            ]
                                                        },
                                                        v3 /*: any*/ ,
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v2 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "issueTypeDropdown_issueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "issueTypes"
                                }
                            ],
                            "type": "JiraProject"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4b80109f35d6ad9bae6388d4cce43d7afddb1791938370f8cb29e7b04ad19930",
            "metadata": {},
            "name": "issueTypeDropdown_SearchRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cccec9afd84009d9$var$node.hash = "c5c98d71daeef54d559020a1ba77544f";
var $cccec9afd84009d9$export$2e2bcd8739ae039 = $cccec9afd84009d9$var$node;

});


parcelRegister("6vSE3", function(module, exports) {

$parcel$export(module.exports, "IssueTypeEditViewWithIssueTypeConnection", () => $eb41b4df9cd1fdf4$export$139e4bfeb055992c);
$parcel$export(module.exports, "IssueTypeEditView", () => $eb41b4df9cd1fdf4$export$83fe9ca9fdf41761);

var $7KjFQ = parcelRequire("7KjFQ");

var $9hLhl = parcelRequire("9hLhl");

var $60L32 = parcelRequire("60L32");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $4zgIJ = parcelRequire("4zgIJ");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4Hwcq = parcelRequire("4Hwcq");

var $4NcaX = parcelRequire("4NcaX");
var $g6sIQ = parcelRequire("g6sIQ");

var $4bMJ9 = parcelRequire("4bMJ9");

var $2jdHI = parcelRequire("2jdHI");

var $hqNvJ = parcelRequire("hqNvJ");

var $6CJCc = parcelRequire("6CJCc");
const $eb41b4df9cd1fdf4$export$6a277fd8285f68cf = ({ queryFragmentRef: queryFragmentRef, fieldId: fieldId, filterOptionsById: filterOptionsById = null, ...props })=>{
    const { data: issueTypesSearchData, refetch: refetchSuggestions } = (0, $iWLL0.usePaginationFragment)((0, $60L32.default), queryFragmentRef);
    const onGetRefetchVariables = (0, $eUqFw.useCallback)((searchBy)=>({
            id: fieldId,
            searchBy: searchBy,
            filterById: filterOptionsById
        }), [
        fieldId,
        filterOptionsById
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb41b4df9cd1fdf4$export$139e4bfeb055992c, {
        ...props,
        issueTypesFragmentRef: issueTypesSearchData.node?.issueTypes ?? null,
        onGetRefetchVariables: onGetRefetchVariables,
        refetchQuery: (0, $hqNvJ.default),
        onRefetch: refetchSuggestions
    });
};
const $eb41b4df9cd1fdf4$export$139e4bfeb055992c = ({ autoFocus: autoFocus = false, issueTypesFragmentRef: issueTypesFragmentRef, onChange: onChange, onGetRefetchVariables: onGetRefetchVariables, value: value, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, isInvalid: isInvalid, isDisabled: isDisabled = false, inputId: inputId, menuPosition: menuPosition, refetchQuery: refetchQuery, onRefetch: onRefetch, openMenuOnFocus: openMenuOnFocus, spacing: spacing, stopPropagationOfMenuEscape: stopPropagationOfMenuEscape, label: label })=>{
    const [menuIsOpen, setMenuIsOpen] = (0, $eUqFw.useState)(autoFocus);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getNoOptionsMessage = (0, $eUqFw.useCallback)(()=>noOptionsMessage ?? formatMessage((0, $6CJCc.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $eUqFw.useCallback)(()=>loadingMessage ?? formatMessage((0, $6CJCc.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const placeholderMessage = formatMessage((0, $6CJCc.default).placeholder); // #region Relay
    // suggestions fragment with pagination and refetch
    const data = (0, $iWLL0.useFragment)((0, $9hLhl.default), issueTypesFragmentRef); // #endregion
    // #region Common state (might be handy for other components)
    const [searchByString, setSearchByString] = (0, $eUqFw.useState)(''); // #endregion
    // #region Debounced suspensless refetch helpers
    const [searchSuspenselessRefetch, isLoading, lastFetchError] = (0, $4bMJ9.useSuspenselessRefetch)(refetchQuery, onRefetch);
    const [searchDebouncedSuspenselessRefetch] = (0, $2jdHI.default)(searchSuspenselessRefetch, (0, $4Hwcq.SEARCH_DEBOUNCE_TIMEOUT));
    (0, $eUqFw.useEffect)(()=>{
        if (autoFocus) searchSuspenselessRefetch(onGetRefetchVariables(searchByString));
    }, [
        searchSuspenselessRefetch,
        autoFocus,
        searchByString,
        onGetRefetchVariables
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (stopPropagationOfMenuEscape && menuIsOpen && e.key === 'Escape') e.stopPropagation();
    }, [
        menuIsOpen,
        stopPropagationOfMenuEscape
    ]); // #region Common callbacks for the selector
    const openMenu = ()=>setMenuIsOpen(true);
    const closeMenu = ()=>setMenuIsOpen(false);
    const onSelectFocus = (0, $eUqFw.useCallback)(()=>{
        searchSuspenselessRefetch(onGetRefetchVariables(searchByString));
    }, [
        searchSuspenselessRefetch,
        searchByString,
        onGetRefetchVariables
    ]);
    const onSearchByStringChangeFunction = (0, $eUqFw.useCallback)((newSearchByString)=>{
        setSearchByString(newSearchByString);
        searchDebouncedSuspenselessRefetch(onGetRefetchVariables(newSearchByString || ''));
    }, [
        onGetRefetchVariables,
        searchDebouncedSuspenselessRefetch
    ]); // #endregion
    // #region Transform options data from relay to AK Select
    const defaultFailedOption = (0, $eUqFw.useMemo)(()=>({
            label: formatMessage((0, $6CJCc.default).failedFetch),
            value: '',
            avatar: {
                small: ''
            }
        }), [
        formatMessage
    ]);
    const renderOption = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb41b4df9cd1fdf4$var$OptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb41b4df9cd1fdf4$var$ImgSpan, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
            src: option.avatar?.small || '',
            alt: option.label,
            width: 2 * (0, $c9TLT.gridSize),
            height: 2 * (0, $c9TLT.gridSize)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, option.label));
    const selectFieldOptions = (0, $eUqFw.useMemo)(()=>{
        // checks for query errors
        if (lastFetchError != null) return [
            defaultFailedOption
        ];
        return data?.edges?.map((edge)=>edge?.node).filter(Boolean).map(({ label: optionLabel, value: optionValue, avatar: avatar })=>({
                label: optionLabel ?? '',
                value: optionValue,
                avatar: avatar
            })) ?? [];
    }, [
        lastFetchError,
        data,
        defaultFailedOption
    ]); // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), {
        "aria-label": label,
        formatOptionLabel: renderOption,
        styles: (0, $4NcaX.defaultSelectStyles),
        value: value,
        options: selectFieldOptions,
        menuIsOpen: menuIsOpen,
        placeholder: placeholderMessage,
        noOptionsMessage: getNoOptionsMessage,
        loadingMessage: getLoadingMessage,
        filterOption: (0, $g6sIQ.filterOptionByLabelAndFilterValues),
        onInputChange: onSearchByStringChangeFunction,
        onChange: onChange,
        openMenuOnFocus: openMenuOnFocus,
        onFocus: onSelectFocus,
        onKeyDown: onKeyDown,
        autoFocus: autoFocus,
        isInvalid: isInvalid,
        isDisabled: isDisabled,
        isLoading: isLoading && menuIsOpen,
        inputId: inputId,
        menuPosition: menuPosition,
        onMenuOpen: openMenu,
        onMenuClose: closeMenu,
        spacing: spacing
    });
};
const $eb41b4df9cd1fdf4$export$83fe9ca9fdf41761 = (props)=>{
    const suggestionsData = (0, $iWLL0.useLazyLoadQuery)((0, $7KjFQ.default), {
        id: props.fieldId,
        filterById: props.filterOptionsById
    }, {
        fetchPolicy: 'store-only'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb41b4df9cd1fdf4$export$6a277fd8285f68cf, {
        ...props,
        queryFragmentRef: suggestionsData
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eb41b4df9cd1fdf4$var$OptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eb41b4df9cd1fdf4$var$ImgSpan = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7KjFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0829308652914b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfa9b261ee662a6f57fc80f1429c11c9>>
 * @relayHash 29e5738373d98b44824fad02a3d3cd14
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e50d5efb3e493597a605e3f7eb0d92c3151c4aaeb3ec7b9f8a450d447af2ab54
const $a0829308652914b0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterById"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v3 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v4 = {
        "kind": "Literal",
        "name": "searchBy",
        "value": ""
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        v4 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueType_issueTypeSearchQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueType_issueTypeSearchQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v6 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "issueType_issueFieldIssueTypeEditviewFull_issueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "issueTypes"
                                }
                            ],
                            "type": "JiraIssueTypeField"
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "e50d5efb3e493597a605e3f7eb0d92c3151c4aaeb3ec7b9f8a450d447af2ab54",
            "metadata": {},
            "name": "issueType_issueTypeSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a0829308652914b0$var$node.hash = "a9ae551cfa917838f44cb5ad82166383";
var $a0829308652914b0$export$2e2bcd8739ae039 = $a0829308652914b0$var$node;

});

parcelRegister("9hLhl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ee7bd64bbb7a717$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4e0227129a9b0594353e8c68d9a88930>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ee7bd64bbb7a717$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef",
    "selections": [
        {
            "concreteType": "JiraIssueTypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "value",
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "alias": "label",
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "small"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueTypeConnection"
};
$6ee7bd64bbb7a717$var$node.hash = "a3043f504a0b36b603fb3665ac2ae823";
var $6ee7bd64bbb7a717$export$2e2bcd8739ae039 = $6ee7bd64bbb7a717$var$node;

});

parcelRegister("60L32", function(module, exports) {

$parcel$export(module.exports, "default", () => $11813bd2578cc398$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<92d1e3360b2d69683e70b781460fce34>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $hqNvJ = parcelRequire("hqNvJ");
const $11813bd2578cc398$var$node = function() {
    var v0 = [
        "node",
        "issueTypes"
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filterById"
            },
            {
                "defaultValue": 1000,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "id"
            },
            {
                "defaultValue": "",
                "kind": "LocalArgument",
                "name": "searchBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $hqNvJ.default)
            }
        },
        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "id"
                    }
                ],
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": "issueTypes",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "filterById",
                                        "variableName": "filterById"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "searchBy",
                                        "variableName": "searchBy"
                                    }
                                ],
                                "concreteType": "JiraIssueTypeConnection",
                                "kind": "LinkedField",
                                "name": "__issueType_issueFieldIssueTypeEditviewFull_issueTypes_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueTypeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            },
                                            {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v1 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef"
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraIssueTypeField"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$11813bd2578cc398$var$node.hash = "54c04d4f507b644a10ef1cc8b3c0fc09";
var $11813bd2578cc398$export$2e2bcd8739ae039 = $11813bd2578cc398$var$node;

});
parcelRegister("hqNvJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e884c8842af212ef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2fb7462fc58470e5f932ba5f158f8a16>>
 * @relayHash 53b193ba86b71b4b505947ef99d7bce3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ddf0f50c9d8d9f30aa48671b2fc60b8934c2cf6d1edc9897ed54f296df319cd4
const $e884c8842af212ef$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        },
        {
            "defaultValue": 1000,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "searchBy"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v2 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v3 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v4 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v5 = {
        "kind": "Variable",
        "name": "searchBy",
        "variableName": "searchBy"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "issueType_SearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "issueType_SearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v4 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "issueType_issueFieldIssueTypeEditviewFull_issueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "issueTypes"
                                }
                            ],
                            "type": "JiraIssueTypeField"
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "ddf0f50c9d8d9f30aa48671b2fc60b8934c2cf6d1edc9897ed54f296df319cd4",
            "metadata": {},
            "name": "issueType_SearchRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e884c8842af212ef$var$node.hash = "54c04d4f507b644a10ef1cc8b3c0fc09";
var $e884c8842af212ef$export$2e2bcd8739ae039 = $e884c8842af212ef$var$node;

});


parcelRegister("6CJCc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cd25b368f035d56$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8cd25b368f035d56$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    empty: {
        "id": "issue-field-issue-type-editview-full.issue-type.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-issue-type-editview-full.issue-type.failed-fetch",
        "defaultMessage": "Search failed."
    },
    loading: {
        "id": "issue-field-issue-type-editview-full.issue-type.loading",
        "defaultMessage": "Searching..."
    },
    placeholder: {
        "id": "issue-field-issue-type-editview-full.issue-type.placeholder",
        "defaultMessage": "Select Issue Type"
    }
});

});


parcelRegister("7oI0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $71b1b6bc9c3b5ec5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $71b1b6bc9c3b5ec5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    dropdownLabel: {
        "id": "native-issue-table.common.issue-create-form.context-fields.issue-type-dropdown.dropdown-label",
        "defaultMessage": "Issue type"
    }
});

});




parcelRegister("clBik", function(module, exports) {

$parcel$export(module.exports, "default", () => $c71e3ef251f701a6$export$2e2bcd8739ae039);

var $byurs = parcelRequire("byurs");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $iqSod = parcelRequire("iqSod");
const $c71e3ef251f701a6$var$IssueCountRenderer = ({ issues: issues, IssueCount: IssueCount = (0, $iqSod.IssueCount) })=>{
    const data = (0, $iWLL0.useFragment)((0, $byurs.default), issues);
    const startIssueRange = data.issueNavigatorPageInfo?.firstIssuePosition ?? 0;
    const endIssueRange = data.issueNavigatorPageInfo?.lastIssuePosition ?? 0;
    const total = data.totalIssueSearchResultCount ?? 0;
    const countExceedsMaxResults = !!data.isCappingIssueSearchResult;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueCount, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange,
        total: total,
        countExceedsMaxResults: countExceedsMaxResults
    });
};
var $c71e3ef251f701a6$export$2e2bcd8739ae039 = $c71e3ef251f701a6$var$IssueCountRenderer;

});
parcelRegister("byurs", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c022ce58e83bae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<35ccc65b518c43aa26a837fbb85d9d7e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $67c022ce58e83bae$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_nativeIssueTable_IssueCountRenderer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        },
        {
            "concreteType": "JiraIssueNavigatorPageInfo",
            "kind": "LinkedField",
            "name": "issueNavigatorPageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "firstIssuePosition"
                },
                {
                    "kind": "ScalarField",
                    "name": "lastIssuePosition"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$67c022ce58e83bae$var$node.hash = "178c5569a8b7d626dbb883809268743a";
var $67c022ce58e83bae$export$2e2bcd8739ae039 = $67c022ce58e83bae$var$node;

});

parcelRegister("iqSod", function(module, exports) {

$parcel$export(module.exports, "IssueCount", () => $1f03ee41ff156a6d$export$542fba90cc9c1bd1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ahpyr = parcelRequire("ahpyr");
const $1f03ee41ff156a6d$export$542fba90cc9c1bd1 = ({ startIssueRange: startIssueRange, endIssueRange: endIssueRange, total: total, countExceedsMaxResults: countExceedsMaxResults })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f03ee41ff156a6d$var$IssueCountContainer, {
        "data-testid": "native-issue-table.ui.footer-renderer.issue-count-renderer.issue-count.issue-count"
    }, total <= 0 ? formatMessage((0, $ahpyr.default).issueRangeUnknown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange
    }) : formatMessage((0, $ahpyr.default).issueRangeKnown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange,
        totalNumberIssues: countExceedsMaxResults ? `${total}+` : total
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f03ee41ff156a6d$var$IssueCountContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _1bah1h6o _k48pni7l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ahpyr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4af996d3276bcc9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b4af996d3276bcc9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueRangeKnown: {
        "id": "native-issue-table.footer-renderer.issue-count-renderer.issue-count.issue-range-known",
        "defaultMessage": "{startIssueRange}-{endIssueRange} of {totalNumberIssues}"
    },
    issueRangeUnknown: {
        "id": "native-issue-table.footer-renderer.issue-count-renderer.issue-count.issue-range-unknown",
        "defaultMessage": "{startIssueRange}-{endIssueRange}"
    }
});

});



parcelRegister("eGOui", function(module, exports) {

$parcel$export(module.exports, "IssueCreateButton", () => $660cf01c5577b860$export$8047302ff7d7386b);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $gO9Xw = parcelRequire("gO9Xw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hYWrM = parcelRequire("hYWrM");
const $660cf01c5577b860$export$8047302ff7d7386b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $660cf01c5577b860$var$createButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ref: ref,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
            label: "",
            size: "small"
        }),
        onClick: onClick,
        // We can't apply padding to the parent as that affects calculation of the base flex size of the
        // item. So we need to apply margin to the child instead https://www.w3.org/TR/css-flexbox-1/#line-sizing.
        /* eslint-disable-next-line jira/react/no-style-attribute */ style: $660cf01c5577b860$var$buttonStyles
    }, formatMessage((0, $hYWrM.default).createButton)));
});
const $660cf01c5577b860$var$createButtonContainerStyles = (0, $1ZAYh.xcss)({
    flex: 1
});
const $660cf01c5577b860$var$buttonStyles = {
    marginLeft: "var(--ds-space-300, 24px)"
};

});
parcelRegister("hYWrM", function(module, exports) {

$parcel$export(module.exports, "default", () => $44eb1fc96a72860c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $44eb1fc96a72860c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createButton: {
        "id": "native-issue-table.footer-renderer.issue-create-button.create-button",
        "defaultMessage": "Create"
    }
});

});


parcelRegister("iOc0X", function(module, exports) {

$parcel$export(module.exports, "IssueCreateFooter", () => $5ca330e06a0f0254$export$e3ef2bbdafbe53d8);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $gRrmL = parcelRequire("gRrmL");

var $3ZANc = parcelRequire("3ZANc");
const $5ca330e06a0f0254$export$e3ef2bbdafbe53d8 = ({ contextFieldsSubject: contextFieldsSubject, onClose: onClose })=>{
    const issueCreateFooterRef = (0, $eUqFw.useRef)(null);
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape') onClose(true);
    }, [
        onClose
    ]);
    const onClickOutside = (0, $eUqFw.useCallback)((event)=>{
        const clickInside = event.target instanceof Node && (issueCreateFooterRef.current?.contains(event.target) ?? false);
        !clickInside && onClose(false);
    }, [
        onClose
    ]);
    (0, $eUqFw.useEffect)(()=>{
        document.body.addEventListener('click', onClickOutside, true);
        return ()=>document.body.removeEventListener('click', onClickOutside, true);
    }, [
        onClickOutside
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlock: (0, $1ybV0.ff)('jsv-one-issue-table-sticky-compact-footer_657cf') ? 'space.075' : 'space.200',
        xcss: [
            $5ca330e06a0f0254$var$footerStyles,
            !(0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && $5ca330e06a0f0254$var$borderStyles,
            (0, $1ybV0.ff)('jsv-one-issue-table-sticky-compact-footer_657cf') && $5ca330e06a0f0254$var$stickyCompactFooterStyles
        ],
        onKeyDown: onKeyDown,
        ref: issueCreateFooterRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ZANc.IssueCreateFormContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gRrmL.default), {
        contextFieldsSubject: contextFieldsSubject
    })));
};
const $5ca330e06a0f0254$var$footerStyles = (0, $1ZAYh.xcss)({
    position: 'sticky',
    left: '0'
});
const $5ca330e06a0f0254$var$borderStyles = (0, $1ZAYh.xcss)({
    borderColor: 'color.border',
    borderTopWidth: 'border.width.outline',
    borderTopStyle: 'solid'
});
const $5ca330e06a0f0254$var$stickyCompactFooterStyles = (0, $1ZAYh.xcss)({
    bottom: '0',
    backgroundColor: 'elevation.surface'
});

});
parcelRegister("gRrmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $df8adb2486d02ac8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1HzcR = parcelRequire("1HzcR");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3ZANc = parcelRequire("3ZANc");

var $a4IeB = parcelRequire("a4IeB");

var $jyS6H = parcelRequire("jyS6H");

var $2FddW = parcelRequire("2FddW");

var $loOOv = parcelRequire("loOOv");
const $df8adb2486d02ac8$var$runtimeProps = {};
const $df8adb2486d02ac8$var$IssueCreateForm = ({ contextFieldsSubject: contextFieldsSubject })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { resetSummary: resetSummary } = (0, $3ZANc.useIssueCreateActions)();
    const onSubmit = (0, $eUqFw.useCallback)(()=>{
        // TODO EM-6706 Commit mutation
        resetSummary();
    }, [
        resetSummary
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "form",
        paddingInlineStart: "space.300",
        paddingInlineEnd: "space.100",
        xcss: $df8adb2486d02ac8$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: contextFieldsSubject,
        id: "async-issue-create-context-fields",
        packageName: (0, $a4IeB.PACKAGE_NAME),
        teamName: (0, $a4IeB.TEAM_NAME),
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jyS6H.ContextFieldsFallback), null),
        runtimeProps: $df8adb2486d02ac8$var$runtimeProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $loOOv.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $df8adb2486d02ac8$var$actionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onSubmit
    }, formatMessage((0, $2FddW.default).createButton))));
};
const $df8adb2486d02ac8$var$containerStyles = (0, $1ZAYh.xcss)({
    alignItems: 'center',
    display: 'flex',
    gap: 'space.200'
});
const $df8adb2486d02ac8$var$actionStyles = (0, $1ZAYh.xcss)({
    flexShrink: 0,
    marginRight: 'space.0'
});
var $df8adb2486d02ac8$export$2e2bcd8739ae039 = $df8adb2486d02ac8$var$IssueCreateForm;

});
parcelRegister("2FddW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d282ca49c7c17d8f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d282ca49c7c17d8f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createButton: {
        "id": "native-issue-table.common.issue-create-form.create-button",
        "defaultMessage": "Create"
    }
});

});

parcelRegister("loOOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e9969a33da8db3c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3ZANc = parcelRequire("3ZANc");

var $eFs4F = parcelRequire("eFs4F");
const $5e9969a33da8db3c$var$Summary = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [value, { onChangeSummary: onChangeSummary }] = (0, $3ZANc.useIssueCreateSummary)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e9969a33da8db3c$var$Textarea, {
        autoFocus: true,
        "aria-label": formatMessage((0, $eFs4F.default).summaryLabel),
        placeholder: formatMessage((0, $eFs4F.default).summaryPlaceholder),
        maxLength: 255,
        value: value,
        onChange: (event)=>onChangeSummary(event.target.value),
        rows: 1
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e9969a33da8db3c$var$Textarea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "textarea", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkvuon _19itglyw _syaz1fxt _16jlkb7n _1o9zkb7n _i0dlf1ug _ect41wi2 _1wybdlk8 _vwz41f4h _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu2glyw _12y31o36 _14zgglyw _1idr1wmz",
            __cmplp.className
        ])
    });
});
var $5e9969a33da8db3c$export$2e2bcd8739ae039 = $5e9969a33da8db3c$var$Summary;

});
parcelRegister("eFs4F", function(module, exports) {

$parcel$export(module.exports, "default", () => $81a53e552e089793$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $81a53e552e089793$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    summaryPlaceholder: {
        "id": "native-issue-table.common.issue-create-form.summary.summary-placeholder",
        "defaultMessage": "What needs to be done?"
    },
    summaryLabel: {
        "id": "native-issue-table.common.issue-create-form.summary.summary-label",
        "defaultMessage": "Summary"
    }
});

});




parcelRegister("fXEyC", function(module, exports) {

$parcel$export(module.exports, "PaginationControls", () => $e92abe069b926f63$export$ff17519edeb6015d);

var $6d373 = parcelRequire("6d373");

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $3KPTt = parcelRequire("3KPTt");

var $8cU5f = parcelRequire("8cU5f");

var $7uIWw = parcelRequire("7uIWw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dR5AO = parcelRequire("dR5AO");
const $e92abe069b926f63$var$getFirstPage = (data)=>{
    if (data?.pageCursors?.first) return data?.pageCursors.first.pageNumber;
    if (data?.pageCursors?.around?.length) return data?.pageCursors.around[0]?.pageNumber;
    return undefined;
};
const $e92abe069b926f63$var$getLastPage = (data)=>{
    if (data?.pageCursors?.last) return data?.pageCursors.last.pageNumber;
    if (data?.pageCursors?.around?.length) return data?.pageCursors.around[data?.pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $e92abe069b926f63$var$getPageCursor = (data, page)=>{
    const { first: first, last: last, around: around } = data?.pageCursors ?? {};
    if (page === first?.pageNumber) return first?.cursor ?? undefined;
    if (page === last?.pageNumber) return last?.cursor ?? undefined;
    return around?.find((pageCursor)=>page === pageCursor?.pageNumber)?.cursor ?? undefined;
};
const $e92abe069b926f63$export$ff17519edeb6015d = ({ issues: issues, onPageChange: onPageChange })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $6d373.default), issues);
    const [optimisticCurrentPage, setOptimisticCurrentPage] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        // Clear our optimistically set page number whenever fragment data changes.
        setOptimisticCurrentPage(null);
    }, [
        data
    ]);
    const pages = (0, $eUqFw.useMemo)(()=>{
        const firstPage = $e92abe069b926f63$var$getFirstPage(data) ?? 1;
        const lastPage = $e92abe069b926f63$var$getLastPage(data) ?? 1;
        return Array(lastPage - firstPage + 1).fill(undefined).map((_, i)=>firstPage + i);
    }, [
        data
    ]);
    const currentPage = optimisticCurrentPage ?? data?.pageCursors?.around?.find((pageCursor)=>pageCursor?.isCurrent)?.pageNumber ?? 1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onChange = (0, $eUqFw.useCallback)((_, page)=>{
        if (page === currentPage || optimisticCurrentPage !== null) return;
        const pageCursorToFetch = $e92abe069b926f63$var$getPageCursor(data, page);
        if (pageCursorToFetch != null) {
            setOptimisticCurrentPage(page);
            onPageChange(pageCursorToFetch);
            const attributes = {
                currentPage: currentPage,
                nextPage: page,
                randomAccess: Math.abs(page - currentPage) > 1,
                isLastPage: page === pages.length
            };
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'pageNumber'
            }), 'issueTablePagination', attributes);
        }
    }, [
        createAnalyticsEvent,
        currentPage,
        data,
        onPageChange,
        optimisticCurrentPage,
        pages.length
    ]); // Disable the pagination buttons while the selected page is optimistically rendered as we may not have page cursors
    // readily available for pages rendered on the UI.
    const OptimisticDisabledButtonRenderer = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ 'aria-label': ariaLabel, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            ref: ref,
            ...props,
            "aria-label": !ariaLabel && props.page ? formatMessage((0, $dR5AO.default).pageButtonPrefix, {
                page: props.page
            }) : ariaLabel,
            disabled: props.disabled || optimisticCurrentPage !== null
        }), [
        formatMessage,
        optimisticCurrentPage
    ]);
    const OptimisticDisabledButtonRendererWithTooltip = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ 'aria-label': ariaLabel, ...props }, ref)=>props.disabled && optimisticCurrentPage == null && data?.isCappingIssueSearchResult ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $dR5AO.default).disabledButtonTooltip),
            position: "top-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e92abe069b926f63$var$FullHeightDisabledButton, {
            tabIndex: 0,
            isDisabled: true,
            "aria-label": formatMessage((0, $dR5AO.default).disabledButtonTooltip),
            "data-testid": "native-issue-table.ui.footer-renderer.pagination-controls.full-height-disabled-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            ref: ref,
            ...props,
            "aria-label": ariaLabel
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            ref: ref,
            ...props,
            "aria-label": ariaLabel,
            disabled: props.disabled || optimisticCurrentPage !== null
        }), [
        optimisticCurrentPage,
        data?.isCappingIssueSearchResult,
        formatMessage
    ]);
    const components = (0, $eUqFw.useMemo)(()=>{
        const OptimisticDisabledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(OptimisticDisabledButtonRenderer);
        const OptimisticDisabledButtonWithTooltip = /*#__PURE__*/ (0, $eUqFw.forwardRef)(OptimisticDisabledButtonRendererWithTooltip);
        return {
            Page: OptimisticDisabledButton,
            Previous: OptimisticDisabledButton,
            Next: OptimisticDisabledButtonWithTooltip
        };
    }, [
        OptimisticDisabledButtonRenderer,
        OptimisticDisabledButtonRendererWithTooltip
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e92abe069b926f63$var$PaginationContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KPTt.default), {
        testId: "native-issue-table.ui.footer-renderer.pagination-controls.pagination-controls",
        components: components,
        pages: pages,
        onChange: onChange,
        selectedIndex: currentPage - 1,
        max: 7,
        nextLabel: formatMessage((0, $dR5AO.default).nextButton),
        previousLabel: formatMessage((0, $dR5AO.default).prevButton)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e92abe069b926f63$var$FullHeightDisabledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7uIWw.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e92abe069b926f63$var$PaginationContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6d373", function(module, exports) {

$parcel$export(module.exports, "default", () => $64df45e33fa091fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3901018953637bca59dab12c8fc72e0d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $64df45e33fa091fe$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "pageSize"
            }
        ],
        "kind": "Fragment",
        "name": "paginationControls_nativeIssueTable",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isCappingIssueSearchResult"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    },
                    {
                        "kind": "Variable",
                        "name": "pageSize",
                        "variableName": "pageSize"
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "first",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$64df45e33fa091fe$var$node.hash = "f6c43af42ef3986e51936f79243f5544";
var $64df45e33fa091fe$export$2e2bcd8739ae039 = $64df45e33fa091fe$var$node;

});

parcelRegister("dR5AO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3aec61067151aa9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a3aec61067151aa9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    nextButton: {
        "id": "native-issue-table.footer-renderer.pagination-controls.next-button",
        "defaultMessage": "Next page"
    },
    prevButton: {
        "id": "native-issue-table.footer-renderer.pagination-controls.prev-button",
        "defaultMessage": "Previous page"
    },
    pageButtonPrefix: {
        "id": "native-issue-table.footer-renderer.pagination-controls.page-button-prefix",
        "defaultMessage": "Page {page}"
    },
    disabledButtonTooltip: {
        "id": "native-issue-table.footer-renderer.pagination-controls.disabled-button-tooltip",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
    }
});

});



parcelRegister("gek7b", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc626a63e1b6296a$export$2e2bcd8739ae039);

var $d5VB8 = parcelRequire("d5VB8");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $a4IeB = parcelRequire("a4IeB");

var $8IlP5 = parcelRequire("8IlP5");

var $hlomJ = parcelRequire("hlomJ");

var $3FOuV = parcelRequire("3FOuV");

var $4BDK1 = parcelRequire("4BDK1");

var $cG7qK = parcelRequire("cG7qK");

var $8Y1mi = parcelRequire("8Y1mi");

var $7a1df = parcelRequire("7a1df");

var $6abVn = parcelRequire("6abVn");
const $bc626a63e1b6296a$var$IssueTable = ({ columns: columns, NoIssues: NoIssues, canViewColumnConfiguration: canViewColumnConfiguration, canEditColumnConfiguration: canEditColumnConfiguration, hasInlineEditing: hasInlineEditing, hasFixedTableLayout: hasFixedTableLayout, isColumnResizingEnabled: isColumnResizingEnabled, issueResults: issueResults, loading: loading, NoColumns: NoColumns, onColumnsChange: onColumnsChange, onResizeColumn: onResizeColumn, enableRowDragging: enableRowDragging, tableInjectedProps: tableInjectedProps, tableRef: tableRef })=>{
    const isInitialDataLoaded = (0, $eUqFw.useRef)(false); // TODO: delete `isInitialDataLoaded` and effect when cleaning up jsv-one-issue-table-spreadsheet-ui_ygrnf
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && !loading && !isInitialDataLoaded.current) isInitialDataLoaded.current = true;
    }, [
        loading
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueResultsData = (0, $iWLL0.useFragment)((0, $d5VB8.default), issueResults); // Show the skeleton if we are loading on initial render as we may only have partial row data
    if (!(0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && loading && !isInitialDataLoaded.current) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hlomJ.IssueTableSkeleton), null);
    if (!(0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && !issueResultsData.edges?.length) return loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hlomJ.IssueTableSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Y1mi.default), {
        NoIssues: NoIssues
    });
    const hasColumnConfiguration = canViewColumnConfiguration && canEditColumnConfiguration;
    const showNoIssues = !issueResultsData.edges?.length;
    const showNoColumns = columns.length === 0 || columns.length === 1 && columns[0].id === (0, $a4IeB.COLUMN_ID_MEATBALL_MENU);
    let tableHeader;
    if ((0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf')) tableHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3FOuV.Header), {
        columns: columns,
        canViewColumnConfiguration: canViewColumnConfiguration,
        canEditColumnConfiguration: canEditColumnConfiguration,
        hasFixedTableLayout: hasFixedTableLayout,
        isColumnResizingEnabled: isColumnResizingEnabled,
        resizeHandleType: showNoIssues || showNoColumns ? (0, $a4IeB.COLUMN_RESIZE_HANDLE_HEADER_ONLY) : (0, $a4IeB.COLUMN_RESIZE_HANDLE_FULL_HEIGHT),
        onColumnsChange: onColumnsChange,
        onResizeColumn: onResizeColumn,
        tableRef: tableRef
    });
    else tableHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6abVn.default), {
        columns: columns,
        hasColumnConfiguration: hasColumnConfiguration,
        onColumnsChange: onColumnsChange,
        tableRef: tableRef
    });
    if ((0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && showNoIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc626a63e1b6296a$var$Table, {
        hasFixedTableLayout: hasFixedTableLayout,
        "aria-label": formatMessage((0, $4BDK1.default).issuesTableLabel),
        ref: tableRef
    }, tableHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Y1mi.default), {
        NoIssues: NoIssues,
        isLoading: loading
    }));
    if (showNoColumns) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && canViewColumnConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc626a63e1b6296a$var$Table, {
        hasFixedTableLayout: hasFixedTableLayout,
        "aria-label": formatMessage((0, $4BDK1.default).issuesTableLabel),
        ref: tableRef
    }, tableHeader), !(0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && hasColumnConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc626a63e1b6296a$var$Table, {
        hasFixedTableLayout: hasFixedTableLayout,
        "aria-label": formatMessage((0, $4BDK1.default).issuesTableLabel),
        ref: tableRef
    }, tableHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cG7qK.default), {
        NoColumns: NoColumns,
        hasColumnConfiguration: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? canViewColumnConfiguration : hasColumnConfiguration,
        isLoading: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? loading : undefined
    }), !(0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8IlP5.Overlay), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc626a63e1b6296a$var$Table, {
        hasFixedTableLayout: hasFixedTableLayout,
        "aria-label": formatMessage((0, $4BDK1.default).issuesTableLabel),
        ref: tableRef
    }, tableHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7a1df.default), {
        issueResults: issueResultsData,
        columns: columns,
        tableInjectedProps: tableInjectedProps,
        hasInlineEditing: hasInlineEditing,
        hasFixedTableLayout: hasFixedTableLayout,
        enableRowDragging: enableRowDragging
    }), loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc626a63e1b6296a$var$TableFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8IlP5.Overlay), null)))) : null);
};
var $bc626a63e1b6296a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $bc626a63e1b6296a$var$IssueTable;
const $bc626a63e1b6296a$var$Table = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "table", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasFixedTableLayout: hasFixedTableLayout, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3it94y _kqswh2mm _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && "_yq5h18uv _btyzidpf",
            (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && __cmplp.hasFixedTableLayout && "_1kqm1n9t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bc626a63e1b6296a$var$TableFooter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "tfoot", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itglyw _p4liidpf _owipidpf _6autidpf _1pqwidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d5VB8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2fd43753685f647$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ae03de70928d08fd83765531e5324846>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a2fd43753685f647$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "issueTable_nativeIssueTable",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "tableBody_nativeIssueTable"
        }
    ],
    "type": "JiraIssueConnection"
};
$a2fd43753685f647$var$node.hash = "9f271a5e81f5f6fa93322fb8bc1ec67f";
var $a2fd43753685f647$export$2e2bcd8739ae039 = $a2fd43753685f647$var$node;

});

parcelRegister("8IlP5", function(module, exports) {

$parcel$export(module.exports, "Overlay", () => $cac703787c61adcf$export$c6fdb837b070b4ff);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $cac703787c61adcf$export$c6fdb837b070b4ff = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _bfhksu0j _tzy4txnc _1sb2b3bt",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3FOuV", function(module, exports) {

$parcel$export(module.exports, "Header", () => $5abd110eba0daafb$export$8b251419efc915eb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1S8jG = parcelRequire("1S8jG");

var $fSMvP = parcelRequire("fSMvP");

var $4c90u = parcelRequire("4c90u");
parcelRequire("eo9PV");
var $9wCS5 = parcelRequire("9wCS5");
parcelRequire("gPx3x");
var $j2oqV = parcelRequire("j2oqV");

var $kjXsi = parcelRequire("kjXsi");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2U8YO = parcelRequire("2U8YO");

var $a4IeB = parcelRequire("a4IeB");

var $lyeLC = parcelRequire("lyeLC");

var $j4sIy = parcelRequire("j4sIy");

var $daw3r = parcelRequire("daw3r");
/**
 * Runs a flash animation on the background color of the column that has been reordered,
 * in order to highlight where the column has moved to.
 */ const $5abd110eba0daafb$var$triggerColumnFlash = (table, index)=>{
    const columnCellsSelector = `th:nth-of-type(${index + 1}), td:nth-of-type(${index + 1})`;
    Array.from(table.querySelectorAll(columnCellsSelector)).filter((element)=>element instanceof HTMLElement).forEach((element)=>(0, $1S8jG.triggerPostMoveFlash)(element));
};
const $5abd110eba0daafb$export$8b251419efc915eb = /*#__PURE__*/ (0, $eUqFw.memo)(({ columns: columns, canViewColumnConfiguration: canViewColumnConfiguration, canEditColumnConfiguration: canEditColumnConfiguration, hasFixedTableLayout: hasFixedTableLayout, isColumnResizingEnabled: isColumnResizingEnabled, resizeHandleType: resizeHandleType, onColumnsChange: onColumnsChange, onResizeColumn: onResizeColumn, tableRef: tableRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)(); // Unique identifier for the header of this particular issue table instance
    const [instanceId] = (0, $eUqFw.useState)(()=>Symbol('pdnd-issue-table-header'));
    const [lastReorderOperation, setLastReorderOperation] = (0, $eUqFw.useState)(null);
    const [screenReaderMessage, setScreenReaderMessage] = (0, $eUqFw.useState)('');
    const reorderColumn = (0, $eUqFw.useCallback)(({ startIndex: startIndex, indexOfTarget: indexOfTarget, closestEdgeOfTarget: closestEdgeOfTarget = null, analyticsAttributes: analyticsAttributes = {} })=>{
        const finishIndex = (0, $4c90u.getReorderDestinationIndex)({
            axis: 'horizontal',
            startIndex: startIndex,
            indexOfTarget: indexOfTarget,
            closestEdgeOfTarget: closestEdgeOfTarget
        });
        if (startIndex === finishIndex) return;
        const newColumns = (0, $j2oqV.reorder)({
            list: columns,
            startIndex: startIndex,
            finishIndex: finishIndex
        });
        onColumnsChange?.(newColumns);
        setLastReorderOperation({
            finishIndex: finishIndex
        });
        setScreenReaderMessage(formatMessage((0, $daw3r.default).movedColumn, {
            column: columns[startIndex]?.title,
            previousPosition: startIndex + 1,
            position: finishIndex + 1,
            // TODO: EM-7165 update to columns.length when excluding column picker
            total: columns.length - 1
        }));
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'reordered',
            actionSubject: 'columns'
        }), 'issueTable', analyticsAttributes);
    }, [
        columns,
        createAnalyticsEvent,
        formatMessage,
        onColumnsChange
    ]);
    // We use an object for lastReorderOperation so we can trigger the column flash
    // if the finish index is the same as the previous reorder operation.
    (0, $eUqFw.useEffect)(()=>{
        const table = tableRef?.current;
        if (table && lastReorderOperation !== null) $5abd110eba0daafb$var$triggerColumnFlash(table, lastReorderOperation.finishIndex);
    }, [
        lastReorderOperation,
        tableRef
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!canEditColumnConfiguration) return;
        return (0, $9wCS5.monitorForElements)({
            canMonitor ({ source: source }) {
                // Only monitor this particular instance id
                // (i.e. prevent monitoring entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId;
            },
            onDrop ({ source: source, location: location }) {
                const [destination] = location.current.dropTargets;
                if (!destination) return;
                const startIndex = columns.findIndex((column)=>column.id === source.data.id);
                if (startIndex === -1) return;
                const indexOfTarget = columns.findIndex((column)=>column.id === destination.data.id);
                if (indexOfTarget === -1) return;
                const closestEdgeOfTarget = (0, $fSMvP.extractClosestEdge)(destination.data);
                reorderColumn({
                    startIndex: startIndex,
                    indexOfTarget: indexOfTarget,
                    closestEdgeOfTarget: closestEdgeOfTarget,
                    analyticsAttributes: {
                        operation: 'drop'
                    }
                });
            }
        });
    }, [
        columns,
        canEditColumnConfiguration,
        instanceId,
        reorderColumn,
        tableRef
    ]);
    const onMoveColumn = (index, position)=>{
        if (canEditColumnConfiguration && onColumnsChange !== undefined) switch(position){
            case 0, $a4IeB.MOVE_COLUMN_FIRST:
                if (index > 0) reorderColumn({
                    startIndex: index,
                    indexOfTarget: 0,
                    closestEdgeOfTarget: 'left',
                    analyticsAttributes: {
                        operation: 'move-first'
                    }
                });
                break;
            case 0, $a4IeB.MOVE_COLUMN_LEFT:
                if (index > 0) reorderColumn({
                    startIndex: index,
                    indexOfTarget: index - 1,
                    closestEdgeOfTarget: 'left',
                    analyticsAttributes: {
                        operation: 'move-left'
                    }
                });
                break;
            case 0, $a4IeB.MOVE_COLUMN_RIGHT:
                // TODO: EM-7165 change this to `columns.length - 1` when excluding column picker
                if (index < columns.length - 2) reorderColumn({
                    startIndex: index,
                    indexOfTarget: index + 1,
                    closestEdgeOfTarget: 'right',
                    analyticsAttributes: {
                        operation: 'move-right'
                    }
                });
                break;
            case 0, $a4IeB.MOVE_COLUMN_LAST:
                // TODO: EM-7165 change this to `columns.length - 1` when excluding column picker
                if (index < columns.length - 2) reorderColumn({
                    startIndex: index,
                    // TODO: EM-7165 change this to `columns.length - 1` when excluding column picker
                    indexOfTarget: columns.length - 2,
                    closestEdgeOfTarget: 'right',
                    analyticsAttributes: {
                        operation: 'move-last'
                    }
                });
                break;
            default:
                throw new Error(`Unexpected target column position ${position}`);
        }
    };
    const onRemoveColumn = (index)=>{
        if (canEditColumnConfiguration && onColumnsChange !== undefined) {
            const newColumns = [
                ...columns
            ];
            newColumns.splice(index, 1);
            onColumnsChange(newColumns);
        }
    };
    const { scrollTop: scrollTop, scrollLeft: scrollLeft, width: containerWidth } = (0, $2U8YO.useScrollState)();
    const { width: tableWidth } = (0, $lyeLC.useTableSize)();
    const hasShadowBottom = scrollTop > 0; // Scroll measurements are fractional, while width measurements are integer, so we need to round before comparing
    const hasShadowLeft = containerWidth < tableWidth && Math.round(scrollLeft) < tableWidth - containerWidth;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderCaption), {
        "aria-live": "assertive",
        "data-testid": "native-issue-table.ui.issue-table.header.screen-reader-caption"
    }, screenReaderMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5abd110eba0daafb$var$StickyHeader, {
        hasShadow: hasShadowBottom
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, columns.map((column, index)=>// TODO: EM-7165 – refactor column picker logic, separating it from regular columns
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: column.id
        }, // Empty cell to fill remainig space if if configured columns are not wide enough to fill the table
        (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && hasFixedTableLayout && column.id === (0, $a4IeB.COLUMN_ID_MEATBALL_MENU) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5abd110eba0daafb$var$EmptyHeaderCell, {
            "aria-hidden": true
        }), column.customHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j4sIy.HeaderCellContainer), {
            isCustom: true,
            scope: "col",
            columnWidth: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? column.customWidth ?? column.defaultWidth : column.width,
            // read as the column title when a user is navigating between columns in the table content.
            "aria-label": column.title,
            isSticky: canViewColumnConfiguration,
            hasShadow: canViewColumnConfiguration && hasShadowLeft
        }, column.customHeader) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j4sIy.HeaderCell), {
            column: column,
            hasColumnConfiguration: canEditColumnConfiguration,
            instanceId: instanceId,
            isColumnResizingEnabled: isColumnResizingEnabled,
            isFirst: index === 0,
            isLast: index === columns.length - 2,
            resizeHandleType: resizeHandleType,
            tableRef: tableRef,
            onMoveColumn: (position)=>onMoveColumn(index, position),
            onRemoveColumn: ()=>onRemoveColumn(index),
            onResizeColumn: onResizeColumn
        }))))));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5abd110eba0daafb$var$StickyHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "thead", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasShadow: hasShadow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _154iidpf _1pbykb7n",
            __cmplp.hasShadow && "_16qs1fgp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5abd110eba0daafb$var$EmptyHeaderCell = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $j4sIy.BaseHeaderCellContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_t6vdidpf _hr4jidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j4sIy", function(module, exports) {

$parcel$export(module.exports, "HeaderCell", () => $7cb5ff268e3bf264$export$efcbfab786023e1a);
$parcel$export(module.exports, "HeaderCellContainer", () => $7cb5ff268e3bf264$export$429fd509d8532e18);
$parcel$export(module.exports, "BaseHeaderCellContainer", () => $7cb5ff268e3bf264$export$1a5749dbc389de48);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $lEfVV = parcelRequire("lEfVV");

var $fSMvP = parcelRequire("fSMvP");

var $loClp = parcelRequire("loClp");
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");
parcelRequire("eo9PV");
var $9wCS5 = parcelRequire("9wCS5");
parcelRequire("cbxSN");
var $iYy22 = parcelRequire("iYy22");
parcelRequire("bweg7");
var $jfbwa = parcelRequire("jfbwa");
parcelRequire("jTs7k");
var $1xLt0 = parcelRequire("1xLt0");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $hzcvF = parcelRequire("hzcvF");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2U8YO = parcelRequire("2U8YO");

var $a4IeB = parcelRequire("a4IeB");

var $exPVl = parcelRequire("exPVl");

var $idSWn = parcelRequire("idSWn");

var $cbt50 = parcelRequire("cbt50");

var $93C6o = parcelRequire("93C6o");
const $7cb5ff268e3bf264$var$DRAG_PREVIEW_MAX_WIDTH = 260;
// ensure that the resize handle displays above subsequent header cells, but that a sticky cell will display above the
// resize handle. Improper z-index may cause the resize handle to render _above_ the column picker.
const $7cb5ff268e3bf264$var$RESIZE_HANDLE_Z_INDEX = 1;
const $7cb5ff268e3bf264$var$STICKY_CELL_Z_INDEX = $7cb5ff268e3bf264$var$RESIZE_HANDLE_Z_INDEX + 1;
const $7cb5ff268e3bf264$export$efcbfab786023e1a = ({ column: column, hasColumnConfiguration: hasColumnConfiguration, instanceId: instanceId, isColumnResizingEnabled: isColumnResizingEnabled, isFirst: isFirst, isLast: isLast, resizeHandleType: resizeHandleType = (0, $a4IeB.COLUMN_RESIZE_HANDLE_FULL_HEIGHT), tableRef: tableRef, onMoveColumn: onMoveColumnProp, onRemoveColumn: onRemoveColumn, onResizeColumn: onResizeColumnProp })=>{
    const headerCellContainerRef = (0, $eUqFw.useRef)(null);
    const headerCellActionsTriggerRef = (0, $eUqFw.useRef)(null);
    const resizeHandleRef = (0, $eUqFw.useRef)(null);
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eUqFw.useState)(false);
    const [state, setState] = (0, $eUqFw.useState)({
        type: 'idle'
    });
    const [dropEdge, setDropEdge] = (0, $eUqFw.useState)(null);
    const { height: height } = (0, $2U8YO.useScrollState)();
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            fieldType: column.type
        }), [
        column.type
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onMouseEnter = (0, $eUqFw.useCallback)((event)=>{
        if ((0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && event.target === resizeHandleRef.current) // prevent showing "hovered" state when only the resize handle is hovered
        return;
        setIsHovered(true);
    }, []);
    const onMouseLeave = (0, $eUqFw.useCallback)(()=>{
        setIsHovered(false);
    }, []);
    // #region Column reordering
    const onMoveColumn = (0, $eUqFw.useCallback)((position)=>{
        onMoveColumnProp(position);
        setIsHovered(false);
    }, [
        onMoveColumnProp
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const headerCellContainer = headerCellContainerRef.current;
        if (!hasColumnConfiguration || !headerCellContainer) return;
        return (0, $jFl9L.combine)((0, $9wCS5.draggable)({
            element: headerCellContainer,
            getInitialData () {
                return {
                    operation: (0, $a4IeB.COLUMN_OPERATION_REORDER),
                    id: column.id,
                    instanceId: instanceId
                };
            },
            onDragStart () {
                setState({
                    type: 'reordering'
                });
            },
            onDrop () {
                setState({
                    type: 'idle'
                });
            },
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage }) {
                const headerCellWidth = headerCellContainer.getBoundingClientRect().width;
                (0, $jfbwa.setCustomNativeDragPreview)({
                    getOffset () {
                        return {
                            x: 20,
                            y: 20
                        };
                    },
                    render ({ container: container }) {
                        // Cause a React re-render to create portal synchronously
                        setState({
                            type: 'preview',
                            container: container,
                            previewWidth: Math.min(headerCellWidth, $7cb5ff268e3bf264$var$DRAG_PREVIEW_MAX_WIDTH)
                        });
                        // Cause a React re-render to remove portal on cleanup
                        return ()=>setState({
                                type: 'reordering'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        }), (0, $9wCS5.dropTargetForElements)({
            element: headerCellContainer,
            canDrop ({ source: source }) {
                // Only allow drops from the same instance id
                // (i.e. prevent dropping entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId;
            },
            getData ({ input: input, element: element }) {
                const data = {
                    id: column.id,
                    instanceId: instanceId
                };
                return (0, $fSMvP.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'left',
                        'right'
                    ]
                });
            },
            onDrag ({ self: self }) {
                const closestEdge = (0, $fSMvP.extractClosestEdge)(self.data);
                if (!closestEdge) return;
                setDropEdge(closestEdge);
            },
            onDragLeave () {
                setDropEdge(null);
            },
            onDrop () {
                setDropEdge(null);
            }
        }), (0, $9wCS5.monitorForElements)({
            canMonitor ({ source: source }) {
                // Only monitor this particular instance id
                // (i.e. prevent monitoring entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId;
            },
            onDrag () {
                // Close the dropdown menu when a drag starts on any column
                setIsDropdownOpen(false);
            }
        }));
    }, [
        column.id,
        hasColumnConfiguration,
        instanceId
    ]);
    // #endregion
    // #region Column resizing
    const [componentColumnWidth, setComponentColumnWidth] = (0, $eUqFw.useState)(column.customWidth ?? column.defaultWidth);
    const prevColumnConfigCustomWidth = (0, $hzcvF.usePreviousWithInitial)(column.customWidth);
    const [isResizePopupOpen, setIsResizePopupOpen] = (0, $eUqFw.useState)(false);
    const onResizeColumn = (0, $eUqFw.useCallback)((width, resizeMethod)=>{
        if (width === componentColumnWidth) // Skip state updates if column width has not changed
        return;
        setComponentColumnWidth(width);
        onResizeColumnProp(column.id, width === column.defaultWidth ? undefined : width);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'column'
        }), 'issueTable', {
            ...analyticsAttributes,
            resizeMethod: resizeMethod,
            columnWidth: width
        });
    }, [
        analyticsAttributes,
        column.id,
        column.defaultWidth,
        componentColumnWidth,
        createAnalyticsEvent,
        onResizeColumnProp
    ]);
    // Header actions callbacks
    const onResizeColumnAction = (0, $eUqFw.useCallback)(()=>{
        setIsResizePopupOpen(true);
    }, []);
    const onResetColumnWidthAction = (0, $eUqFw.useCallback)(()=>{
        onResizeColumn(column.defaultWidth, 'reset');
    }, [
        onResizeColumn,
        column.defaultWidth
    ]);
    // Resize popup callbacks
    const onChangeResizePopup = (0, $eUqFw.useCallback)((width)=>{
        (0, $93C6o.setCssResizingWidth)(headerCellContainerRef.current, width);
    }, []);
    const onCloseResizePopup = (0, $eUqFw.useCallback)((event, overrideKeyboardCheck)=>{
        setIsResizePopupOpen(false);
        (0, $93C6o.clearCssResizingWidth)(headerCellContainerRef.current);
        // Focus header cell actions trigger if the resize popup was closed by keyboard
        // navigation or an override was requested
        //
        // `event.detail` docs: https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
        // (click count is 0 when using keyboard to activate a button)
        if (overrideKeyboardCheck === true || event && event.detail === 0) requestAnimationFrame(()=>headerCellActionsTriggerRef.current?.focus());
    }, []);
    const onSubmitResizePopup = (0, $eUqFw.useCallback)((width)=>{
        onResizeColumn(width, 'popup');
        // No event available from form submission. We will re-focus the actions
        // trigger because submit can't be triggerd by clicking outside of popup,
        // so don't have to worry about stealing focus from what the user clicked
        onCloseResizePopup(undefined, true);
    }, [
        onResizeColumn,
        onCloseResizePopup
    ]);
    // Resize handle callbacks
    const onMouseEnterResizeHandle = (0, $eUqFw.useCallback)((event)=>{
        // prevent showing the drag & drop/reorder hover effect when resizing
        setIsHovered(false);
        event.stopPropagation();
    }, []);
    const onMouseLeaveResizeHandle = (0, $eUqFw.useCallback)((event)=>{
        // restore header hover state if mouse exits into the header element
        if (state.type !== 'resizing' && (event.relatedTarget === headerCellContainerRef.current || event.relatedTarget instanceof Node && headerCellContainerRef.current?.contains(event.relatedTarget))) setIsHovered(true);
    }, [
        state.type
    ]);
    // Update column width state if a change is made in the column config
    (0, $eUqFw.useEffect)(()=>{
        if (prevColumnConfigCustomWidth !== column.customWidth && componentColumnWidth !== column.customWidth && column.customWidth != null) setComponentColumnWidth(column.customWidth);
    }, [
        column.customWidth,
        componentColumnWidth,
        prevColumnConfigCustomWidth
    ]);
    // Creates draggable resize handle
    (0, $eUqFw.useEffect)(()=>{
        const resizeHandle = resizeHandleRef.current;
        if (!(0, $1ybV0.ff)('nin-resizable-columns_8z4eo') || !resizeHandle || isResizePopupOpen) return;
        return (0, $9wCS5.draggable)({
            element: resizeHandle,
            getInitialData () {
                return {
                    operation: (0, $a4IeB.COLUMN_OPERATION_RESIZE),
                    id: column.id
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // we will be moving the line to indicate a drag
                // we can disable the native drag preview
                (0, $iYy22.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // we don't want any native drop animation for when the user
                // does not drop on a drop target. we want the drag to finish immediately
                (0, $1xLt0.preventUnhandled).start();
            },
            onDragStart () {
                setState({
                    type: 'resizing'
                });
                // Disable pointer events on the table while dragging in order to prevent buggy hover states in chrome
                // https://issues.chromium.org/issues/41129937#comment43
                (0, $93C6o.disableCssPointerEvents)(tableRef?.current);
            },
            onDrag ({ location: location }) {
                (0, $93C6o.setCssResizingWidth)(headerCellContainerRef.current, (0, $93C6o.getProposedWidth)({
                    initialWidth: componentColumnWidth,
                    location: location
                }));
            },
            onDrop ({ location: location }) {
                (0, $1xLt0.preventUnhandled).stop();
                setState({
                    type: 'idle'
                });
                onResizeColumn((0, $93C6o.getProposedWidth)({
                    initialWidth: componentColumnWidth,
                    location: location
                }), 'drag-and-drop');
                // Re-enable pointer events to restore normal behaviour
                // https://issues.chromium.org/issues/41129937#comment43
                (0, $93C6o.enableCssPointerEvents)(tableRef?.current);
                (0, $93C6o.clearCssResizingWidth)(headerCellContainerRef.current);
            }
        });
    }, [
        isResizePopupOpen,
        column.id,
        componentColumnWidth,
        tableRef,
        onResizeColumn
    ]);
    // #endregion
    // #region Render
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb5ff268e3bf264$export$429fd509d8532e18, {
        ref: headerCellContainerRef,
        scope: "col",
        columnWidth: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? componentColumnWidth : column.width,
        minColumnWidth: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && !isColumnResizingEnabled ? column.customWidth : undefined,
        isDraggable: hasColumnConfiguration,
        isHovered: isHovered,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        // aria-label is added to prevent the extra accessibility hints in the header cell from being
        // read as the column title when a user is navigating between columns in the table content.
        "aria-label": column.title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        spread: "space-between",
        xcss: state.type === 'reordering' && $7cb5ff268e3bf264$var$reorderingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        space: "space.050",
        xcss: $7cb5ff268e3bf264$var$overflowHiddenStyles
    }, column.warningText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $exPVl.default), {
        tooltip: column.warningText
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb5ff268e3bf264$var$Title, null, column.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idSWn.HeaderCellActions), {
        column: column,
        currentColumnWidth: componentColumnWidth,
        hasColumnConfiguration: hasColumnConfiguration,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isHeaderCellHovered: isHovered,
        isFirst: isFirst,
        isLast: isLast,
        isOpen: isDropdownOpen,
        triggerRef: headerCellActionsTriggerRef,
        onMoveColumn: onMoveColumn,
        onOpenChange: setIsDropdownOpen,
        onRemoveColumn: onRemoveColumn,
        onResizeColumn: onResizeColumnAction,
        onResetColumnWidth: onResetColumnWidthAction
    })), (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && isColumnResizingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cbt50.ResizePopup), {
        columnTitle: column.title,
        initialWidth: componentColumnWidth,
        placement: "bottom-start",
        isOpen: isResizePopupOpen,
        trigger: $7cb5ff268e3bf264$var$resizePopupTarget,
        onChange: onChangeResizePopup,
        onCancel: onCloseResizePopup,
        onSubmit: onSubmitResizePopup
    }), !isResizePopupOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb5ff268e3bf264$var$ResizeHandle, {
        ref: resizeHandleRef,
        height: resizeHandleType === (0, $a4IeB.COLUMN_RESIZE_HANDLE_FULL_HEIGHT) ? height : undefined,
        isResizing: state.type === 'resizing',
        onMouseEnter: onMouseEnterResizeHandle,
        onMouseLeave: onMouseLeaveResizeHandle,
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.resize-handle"
    })), dropEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb5ff268e3bf264$var$DropTarget, {
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.drop-target",
        height: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $loClp.DropIndicator), {
        edge: dropEdge,
        gap: (0, $a4IeB.BORDER_WIDTH)
    })), state.type === 'preview' && /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb5ff268e3bf264$var$DragPreview, {
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.drag-preview",
        height: height,
        width: state.previewWidth
    }), state.container)));
// #endregion
};
// #region Styles
/**
 * Invisible element to attach resizing popup to - the intermediate component is required to allow
 * passing the ref while blocking the other props from being passed to the underlying div.
 *
 * This is because the other props are intended for a trigger button, but we are only using this
 * for positioning pourposes.
 */ const $7cb5ff268e3bf264$var$resizePopupTarget = ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb5ff268e3bf264$var$ResizePopupTargetDiv, {
        ref: ref
    });
const $7cb5ff268e3bf264$var$ResizePopupTargetDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbidpf _4t3iidpf _kqswstnw _1ltvidpf _94n517m2",
            __cmplp.className
        ])
    });
});
const $7cb5ff268e3bf264$var$reorderingStyles = (0, $1ZAYh.xcss)({
    opacity: 0.4
});
// Add overflow: hidden to the inline div so that the title can collapse its width if needed
// and give space to the right-hand side icons (sort/actions)
const $7cb5ff268e3bf264$var$overflowHiddenStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden'
});
const $7cb5ff268e3bf264$export$1a5749dbc389de48 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkqbzx _1h6d1fzn _1dqonqa1 _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _1rcdpd34 _4x86pd34 _1nd4idpf",
            __cmplp.className
        ])
    });
});
const $7cb5ff268e3bf264$export$429fd509d8532e18 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $7cb5ff268e3bf264$export$1a5749dbc389de48, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1so474g": (0, $9t7rW.default)(__cmplp.columnWidth != null ? `${__cmplp.columnWidth}px` : 'auto'),
            "--_19bvh75": (0, $9t7rW.default)(__cmplp.minColumnWidth != null ? `${__cmplp.minColumnWidth}px` : 'auto'),
            "--_1n9uhxp": (0, $9t7rW.default)(__cmplp.columnWidth, "px"),
            "--_150yz49": (0, $9t7rW.default)((0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? $7cb5ff268e3bf264$var$STICKY_CELL_Z_INDEX : undefined)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _vchhusvi _syaz1dyx _k48pbfng _4t3i1ylp _c71l1ylp _1tke1ylp _1rjcze3t _18zru2gc _s7n4nkob _o5721q9c _1lhcu2gc _1o59u2gc",
            (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? "_1276baal _1bsbdva2 _142idise _1ul9qagj" : "_1bsb14et _p12f14et _1ul914et",
            __cmplp.isDraggable && __cmplp.isHovered && "_d0al1qgj _irr3108i",
            __cmplp.isCustom && !(0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && "_p12fglyw",
            __cmplp.isSticky && "_kqsw1if8 _1xi2idpf _1pby1b45",
            __cmplp.hasShadow && "_16qs1paq _t6vd1aa3",
            __cmplp.className
        ])
    });
});
const $7cb5ff268e3bf264$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _u5f31b66",
            __cmplp.className
        ])
    });
});
const $7cb5ff268e3bf264$var$ResizeHandle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isResizing: isResizing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10ib6lf": (0, $9t7rW.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1y1m1ntv _1bsbyh40 _18zr1b66 _kqswstnw _154ize3t _1xi213c4 _80omuf7j _1pbykb7n",
            __cmplp.isResizing ? "_bfhk1yqz" : "_bfhk18uv",
            __cmplp.height != null ? "_4t3it1jn" : "_4t3i1osq",
            !__cmplp.isResizing && "_irr37jlr",
            __cmplp.className
        ])
    });
});
const $7cb5ff268e3bf264$var$DropTarget = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154ize3t _1ltvze3t _4t3i2nrh _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $7cb5ff268e3bf264$var$DragPreview = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`),
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i2nrh _c71l1kxc _1bsb1hdq _1h6d1p6i _1dqonqa1 _2rkoiti9 _189e1bk5 _bfhk7wq0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("loClp", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $fc57283f6cd57fbe$export$62ed72bc21f6b8a6);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $fvYC3 = parcelRequire("fvYC3");
const $fc57283f6cd57fbe$var$lineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    position: 'absolute',
    zIndex: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $fvYC3.line).backgroundColor,
    content: '""',
    pointerEvents: 'none'
});
const $fc57283f6cd57fbe$var$edgeStyles = {
    top: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $fvYC3.line).thickness,
        top: 'var(--local-line-offset)',
        right: 0,
        left: 0
    }),
    right: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $fvYC3.line).thickness,
        top: 0,
        right: 'var(--local-line-offset)',
        bottom: 0
    }),
    bottom: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $fvYC3.line).thickness,
        right: 0,
        bottom: 'var(--local-line-offset)',
        left: 0
    }),
    left: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $fvYC3.line).thickness,
        top: 0,
        bottom: 0,
        left: 'var(--local-line-offset)'
    })
};
function $fc57283f6cd57fbe$export$62ed72bc21f6b8a6({ edge: edge, gap: gap = '0px' }) {
    /**
   * To clearly communicate the resting place of a draggable item during a drag operation,
   * the drop indicator should be positioned half way between draggable items.
   */ const lineOffset = `calc(-0.5 * (${gap} + ${(0, $fvYC3.line).thickness}px))`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fc57283f6cd57fbe$var$lineStyles,
            edge && $fc57283f6cd57fbe$var$edgeStyles[edge]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            '--local-line-offset': lineOffset
        }
    });
}
var // This default export is intended for usage with React.lazy
$fc57283f6cd57fbe$export$2e2bcd8739ae039 = $fc57283f6cd57fbe$export$62ed72bc21f6b8a6;

});

parcelRegister("cbxSN", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("iYy22")).disableNativeDragPreview);

var $iYy22 = parcelRequire("iYy22");

});
parcelRegister("iYy22", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => $f96526f07b5b7d85$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $f96526f07b5b7d85$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $f96526f07b5b7d85$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $f96526f07b5b7d85$var$tinyTransparentImage) nativeSetDragImage($f96526f07b5b7d85$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("jTs7k", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("1xLt0")).preventUnhandled);

var $1xLt0 = parcelRequire("1xLt0");

});
parcelRegister("1xLt0", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => $6e73835b1fb5a057$export$453c0582481cc59d);

var $74BVL = parcelRequire("74BVL");

var $fURjR = parcelRequire("fURjR");
function $6e73835b1fb5a057$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $6e73835b1fb5a057$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $6e73835b1fb5a057$var$start() {
    $6e73835b1fb5a057$var$cleanup();
    $6e73835b1fb5a057$var$unbindEvents = (0, $74BVL.bindAll)(window, [
        {
            type: 'dragover',
            listener: $6e73835b1fb5a057$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $6e73835b1fb5a057$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $6e73835b1fb5a057$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $6e73835b1fb5a057$var$cleanup
        },
        ...(0, $fURjR.getBindingsForBrokenDrags)({
            onDragEnd: $6e73835b1fb5a057$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $6e73835b1fb5a057$var$cleanup() {
    $6e73835b1fb5a057$var$unbindEvents?.();
    $6e73835b1fb5a057$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $6e73835b1fb5a057$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $6e73835b1fb5a057$var$cleanup();
}
const $6e73835b1fb5a057$export$453c0582481cc59d = {
    start: $6e73835b1fb5a057$var$start,
    stop: $6e73835b1fb5a057$var$stop
};

});


parcelRegister("exPVl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c7bc1aedcc4f067$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fPRX1 = parcelRequire("fPRX1");
const $1c7bc1aedcc4f067$var$WarningIndicator = ({ tooltip: tooltip })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1c7bc1aedcc4f067$var$WarningIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: formatMessage((0, $fPRX1.default).warningLabel),
        primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y400})`,
        size: "small"
    })));
};
var $1c7bc1aedcc4f067$export$2e2bcd8739ae039 = $1c7bc1aedcc4f067$var$WarningIndicator;
const $1c7bc1aedcc4f067$var$HEADER_CELL_HEIGHT = 3.5 * (0, $c9TLT.gridSize); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1c7bc1aedcc4f067$var$WarningIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxv77o _4t3i1f4h _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fPRX1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a899e497af554401$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a899e497af554401$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    warningLabel: {
        "id": "native-issue-table.common.warning-indicator.warning-label",
        "defaultMessage": "Warning"
    }
});

});


parcelRegister("idSWn", function(module, exports) {

$parcel$export(module.exports, "HeaderCellActions", () => $8b6ed234c788819f$export$1d48fcee1df11ffa);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $a4IeB = parcelRequire("a4IeB");

var $73lNt = parcelRequire("73lNt");

var $3zPUI = parcelRequire("3zPUI");
const $8b6ed234c788819f$export$1d48fcee1df11ffa = ({ column: column, currentColumnWidth: currentColumnWidth, hasColumnConfiguration: hasColumnConfiguration, isColumnResizingEnabled: isColumnResizingEnabled, isHeaderCellHovered: isHeaderCellHovered, isFirst: isFirst, isLast: isLast, isOpen: isOpen, triggerRef: triggerRef = null, onMoveColumn: onMoveColumn, onOpenChange: onOpenChange, onRemoveColumn: onRemoveColumn, onResizeColumn: onResizeColumn, onResetColumnWidth: onResetColumnWidth })=>{
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        setIsFocused(true);
    }, []);
    const onBlur = (0, $eUqFw.useCallback)(()=>{
        setIsFocused(false);
    }, []);
    const isSortable = column.onSortOrderChanged !== undefined && column.isSortable;
    if (!isSortable && !hasColumnConfiguration && !isColumnResizingEnabled) return null;
    const isMoreActionsVisible = isHeaderCellHovered || isOpen || isFocused;
    const isSorted = column.currentSorting === (0, $a4IeB.SORT_ASC) || column.currentSorting === (0, $a4IeB.SORT_DESC);
    const isSortVisible = isMoreActionsVisible || isSorted;
    const isSortOnlyAction = isSortable && !hasColumnConfiguration && !isColumnResizingEnabled;
    // Header actions width must be static when column resizing is disabled to prevent column widths shifting as the
    // user hovers the table header
    const isStaticWidth = !isColumnResizingEnabled;
    const sortButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $8b6ed234c788819f$var$baseStyles,
            !isSortVisible && $8b6ed234c788819f$var$hiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3zPUI.SortButton), {
        column: column,
        onFocus: onFocus,
        onBlur: onBlur
    }));
    const moreActionsButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $8b6ed234c788819f$var$baseStyles,
            !isMoreActionsVisible && $8b6ed234c788819f$var$hiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $73lNt.MoreActions), {
        column: column,
        currentColumnWidth: currentColumnWidth,
        hasColumnConfiguration: hasColumnConfiguration,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isFirst: isFirst,
        isLast: isLast,
        isOpen: isOpen,
        triggerRef: triggerRef,
        onMoveColumn: onMoveColumn,
        onOpenChange: onOpenChange,
        onRemoveColumn: onRemoveColumn,
        onResizeColumn: onResizeColumn,
        onResetColumnWidth: onResetColumnWidth,
        onFocus: onFocus,
        onBlur: onBlur
    }));
    if (isSortOnlyAction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: [
            $8b6ed234c788819f$var$containerStyles,
            isStaticWidth && $8b6ed234c788819f$var$singleButtonWidth
        ]
    }, sortButton);
    if (!isSortable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: [
            $8b6ed234c788819f$var$containerStyles,
            isStaticWidth && $8b6ed234c788819f$var$singleButtonWidth
        ]
    }, moreActionsButton);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: [
            $8b6ed234c788819f$var$containerStyles,
            // Animate between single and all button width when sorted (only when in a dynamic layout)
            !isStaticWidth && isSorted && $8b6ed234c788819f$var$singleButtonWidth,
            (isStaticWidth || isMoreActionsVisible) && $8b6ed234c788819f$var$allButtonsWidth
        ]
    }, sortButton, moreActionsButton);
};
const $8b6ed234c788819f$var$containerStyles = (0, $1ZAYh.xcss)({
    // Allow container to shrink below fixed widths when no buttons are visible which allows column text to occupy
    // available space
    flexBasis: 0,
    gap: 'space.050',
    transition: 'width .25s'
});
const $8b6ed234c788819f$var$singleButtonWidth = (0, $1ZAYh.xcss)({
    width: '24px'
});
const $8b6ed234c788819f$var$allButtonsWidth = (0, $1ZAYh.xcss)({
    width: '52px'
});
const $8b6ed234c788819f$var$baseStyles = (0, $1ZAYh.xcss)({
    transition: 'opacity .25s'
});
const $8b6ed234c788819f$var$hiddenStyles = (0, $1ZAYh.xcss)({
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: 'space.negative.025',
    overflow: 'hidden',
    padding: 'space.0',
    opacity: 0,
    position: 'absolute',
    pointerEvents: 'none'
});

});
parcelRegister("73lNt", function(module, exports) {

$parcel$export(module.exports, "MoreActions", () => $db988e9b9b80f9a8$export$f2f44eb5b71ba65f);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $fEubG = parcelRequire("fEubG");

var $2Q6JG = parcelRequire("2Q6JG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2KzVh = parcelRequire("2KzVh");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $a4IeB = parcelRequire("a4IeB");

var $iNttM = parcelRequire("iNttM");

var $jLDlt = parcelRequire("jLDlt");
const $db988e9b9b80f9a8$export$f2f44eb5b71ba65f = ({ column: column, currentColumnWidth: currentColumnWidth, hasColumnConfiguration: hasColumnConfiguration, isColumnResizingEnabled: isColumnResizingEnabled, isFirst: isFirst, isLast: isLast, isOpen: isOpen, triggerRef: triggerRef = null, onMoveColumn: onMoveColumn, onOpenChange: onOpenChange, onRemoveColumn: onRemoveColumn, onResizeColumn: onResizeColumn, onResetColumnWidth: onResetColumnWidth, onFocus: onFocus, onBlur: onBlur })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const sortAsc = (0, $eUqFw.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $a4IeB.SORT_ASC));
    }, [
        column
    ]);
    const sortDesc = (0, $eUqFw.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $a4IeB.SORT_DESC));
    }, [
        column
    ]);
    const handleOnOpenChange = (0, $eUqFw.useCallback)(({ isOpen: newIsOpen })=>{
        if (newIsOpen) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        }), 'issueTableHeaderActions');
        onOpenChange(newIsOpen);
    }, [
        createAnalyticsEvent,
        onOpenChange
    ]);
    const isSortable = column.onSortOrderChanged !== undefined && column.isSortable;
    const triggerLabel = formatMessage((0, $jLDlt.default).columnActions, {
        column: column.title
    });
    // Ensure a stable ref function is passed through to the trigger button
    const memoizedMergeRefs = (0, $eUqFw.useMemo)(()=>(0, $5iWql.default)((0, $2KzVh.mergeRefs)), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        placement: "bottom-start",
        trigger: ({ triggerRef: dropdownTriggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: triggerLabel,
                delay: 0,
                ignoreTooltipPointerEvents: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $db988e9b9b80f9a8$var$triggerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                ref: memoizedMergeRefs(dropdownTriggerRef, triggerRef),
                appearance: "subtle",
                spacing: "compact",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Q6JG))), {
                    label: triggerLabel,
                    size: "small"
                }),
                onFocus: onFocus,
                onBlur: onBlur
            })))
    }, isSortable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, column.currentSorting !== (0, $a4IeB.SORT_ASC) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iNttM.ActionItem), {
        actionType: "sortAsc",
        onClick: sortAsc
    }, column.ascText ?? false ? formatMessage((0, $jLDlt.default).sortCustom, {
        sortDescription: column.ascText
    }) : formatMessage((0, $jLDlt.default).sortAsc)), column.currentSorting !== (0, $a4IeB.SORT_DESC) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iNttM.ActionItem), {
        actionType: "sortDesc",
        onClick: sortDesc
    }, column.descText ?? false ? formatMessage((0, $jLDlt.default).sortCustom, {
        sortDescription: column.descText
    }) : formatMessage((0, $jLDlt.default).sortDesc))), hasColumnConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        hasSeparator: isSortable
    }, !isFirst && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iNttM.ActionItem), {
        actionType: "moveColumnFirst",
        onClick: ()=>onMoveColumn((0, $a4IeB.MOVE_COLUMN_FIRST))
    }, formatMessage((0, $jLDlt.default).moveFirst)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iNttM.ActionItem), {
        actionType: "moveColumnLeft",
        onClick: ()=>onMoveColumn((0, $a4IeB.MOVE_COLUMN_LEFT))
    }, formatMessage((0, $jLDlt.default).moveLeft))), !isLast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iNttM.ActionItem), {
        actionType: "moveColumnRight",
        onClick: ()=>onMoveColumn((0, $a4IeB.MOVE_COLUMN_RIGHT))
    }, formatMessage((0, $jLDlt.default).moveRight)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iNttM.ActionItem), {
        actionType: "moveColumnLast",
        onClick: ()=>onMoveColumn((0, $a4IeB.MOVE_COLUMN_LAST))
    }, formatMessage((0, $jLDlt.default).moveLast))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iNttM.ActionItem), {
        actionType: "removeColumn",
        onClick: onRemoveColumn
    }, formatMessage((0, $jLDlt.default).removeColumn))), isColumnResizingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        hasSeparator: isSortable || hasColumnConfiguration
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iNttM.ActionItem), {
        actionType: "resizeColumn",
        onClick: onResizeColumn
    }, formatMessage((0, $jLDlt.default).resizeColumn)), currentColumnWidth != null && currentColumnWidth !== column.defaultWidth && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iNttM.ActionItem), {
        actionType: "resetColumnWidth",
        onClick: onResetColumnWidth
    }, formatMessage((0, $jLDlt.default).resetColumnWidth))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null));
};
const $db988e9b9b80f9a8$var$triggerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    height: '24px',
    width: '24px'
});

});
parcelRegister("2Q6JG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2115a9ad5e333463$var$_react = $2115a9ad5e333463$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2115a9ad5e333463$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2115a9ad5e333463$var$MoreVerticalIcon = (props)=>/*#__PURE__*/ $2115a9ad5e333463$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><circle cx="12" cy="19" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="5" r="2"/></g></svg>`
    }, props));
$2115a9ad5e333463$var$MoreVerticalIcon.displayName = 'MoreVerticalIcon';
var $2115a9ad5e333463$var$_default = $2115a9ad5e333463$var$MoreVerticalIcon;
module.exports.default = $2115a9ad5e333463$var$_default;

});

parcelRegister("iNttM", function(module, exports) {

$parcel$export(module.exports, "ActionItem", () => $3a3e7f2e31e01103$export$ac06cb4ab481cfab);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $3a3e7f2e31e01103$export$ac06cb4ab481cfab = ({ actionType: actionType, children: children, onClick: onClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleOnClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'issueTableHeaderActions', {
            actionType: actionType
        });
        onClick();
    }, [
        actionType,
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: handleOnClick
    }, children);
};

});

parcelRegister("jLDlt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fea5bc8e31f1bb8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0fea5bc8e31f1bb8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    columnActions: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.column-actions",
        "defaultMessage": "More actions for {column}"
    },
    sortAsc: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-asc",
        "defaultMessage": "Sort in ascending order"
    },
    sortDesc: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-desc",
        "defaultMessage": "Sort in descending order"
    },
    sortCustom: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-custom",
        "defaultMessage": "Sort {sortDescription}"
    },
    moveFirst: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-first",
        "defaultMessage": "Move column to the first position"
    },
    moveLeft: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-left",
        "defaultMessage": "Move column to the left"
    },
    moveRight: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-right",
        "defaultMessage": "Move column to the right"
    },
    moveLast: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-last",
        "defaultMessage": "Move column to the last position"
    },
    removeColumn: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.remove-column",
        "defaultMessage": "Remove column"
    },
    resizeColumn: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.resize-column",
        "defaultMessage": "Resize column"
    },
    resetColumnWidth: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.reset-column-width",
        "defaultMessage": "Reset column width"
    }
});

});


parcelRegister("3zPUI", function(module, exports) {

$parcel$export(module.exports, "SortButton", () => $ae493a6a29120fa8$export$e464399b18ba2124);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $9SdpV = parcelRequire("9SdpV");

var $hL0Qd = parcelRequire("hL0Qd");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $a4IeB = parcelRequire("a4IeB");

var $2125q = parcelRequire("2125q");
const $ae493a6a29120fa8$var$useAccessibleLabel = ({ ascText: ascText, currentSorting: currentSorting, descText: descText, title: title })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const labelSuffix = (0, $eUqFw.useMemo)(()=>{
        switch(currentSorting){
            case 0, $a4IeB.SORT_ASC:
                return ascText ?? false ? formatMessage((0, $2125q.default).sortedTooltip, {
                    sortDescription: ascText
                }) : formatMessage((0, $2125q.default).sortedDefaultAscendingTooltip);
            case 0, $a4IeB.SORT_DESC:
                return descText ?? false ? formatMessage((0, $2125q.default).sortedTooltip, {
                    sortDescription: descText
                }) : formatMessage((0, $2125q.default).sortedDefaultDescendingTooltip);
            default:
                return ascText ?? false ? formatMessage((0, $2125q.default).sortPromptTooltip, {
                    sortDescription: ascText
                }) : formatMessage((0, $2125q.default).sortPromptDefaultTooltip);
        }
    }, [
        ascText,
        currentSorting,
        descText,
        formatMessage
    ]);
    return (0, $eUqFw.useMemo)(()=>`${title} \u{2022} ${labelSuffix}`, [
        labelSuffix,
        title
    ]);
};
const $ae493a6a29120fa8$export$e464399b18ba2124 = ({ column: column, onFocus: onFocus, onBlur: onBlur })=>{
    const label = $ae493a6a29120fa8$var$useAccessibleLabel(column);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClick = (0, $eUqFw.useCallback)(()=>{
        const nextDirection = column.currentSorting === (0, $a4IeB.SORT_ASC) ? (0, $a4IeB.SORT_DESC) : (0, $a4IeB.SORT_ASC);
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const attributes = {
            fieldType: column.type,
            sortOrder: nextDirection
        };
        (0, $jMP2a.fireUIAnalytics)(event, 'sortOrderChange', attributes);
        column.onSortOrderChanged?.(column.jqlTerm, nextDirection);
    }, [
        column,
        createAnalyticsEvent
    ]);
    const Icon = column.currentSorting === (0, $a4IeB.SORT_DESC) ? (0, (/*@__PURE__*/$parcel$interopDefault($9SdpV))) : (0, (/*@__PURE__*/$parcel$interopDefault($hL0Qd)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label,
        delay: 0,
        ignoreTooltipPointerEvents: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            label: label,
            size: "small"
        }),
        isSelected: column.currentSorting !== (0, $a4IeB.SORT_NONE),
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    }));
};

});
parcelRegister("9SdpV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $730390946cb60768$var$_react = $730390946cb60768$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $730390946cb60768$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $730390946cb60768$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $730390946cb60768$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11 6v9.586l-3.793-3.793a.999.999 0 00-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A.993.993 0 0012 19a.993.993 0 00.707-.293l5.5-5.499a1 1 0 10-1.414-1.415L13 15.586V6a1 1 0 00-2 0z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$730390946cb60768$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $730390946cb60768$var$_default = $730390946cb60768$var$ArrowDownIcon;
module.exports.default = $730390946cb60768$var$_default;

});

parcelRegister("hL0Qd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ced77a83dab807a4$var$_react = $ced77a83dab807a4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ced77a83dab807a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ced77a83dab807a4$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $ced77a83dab807a4$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.293 5.293l-5.5 5.499a1.002 1.002 0 000 1.415.999.999 0 001.414 0L11 8.414V18a1 1 0 002 0V8.414l3.793 3.793a1 1 0 101.414-1.415l-5.5-5.499A.993.993 0 0012 5a.993.993 0 00-.707.293z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$ced77a83dab807a4$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $ced77a83dab807a4$var$_default = $ced77a83dab807a4$var$ArrowUpIcon;
module.exports.default = $ced77a83dab807a4$var$_default;

});

parcelRegister("2125q", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ceae17d45fe601b$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $9ceae17d45fe601b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sortedTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-tooltip",
        "defaultMessage": "Sorted {sortDescription}"
    },
    sortPromptTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sort-prompt-tooltip",
        "defaultMessage": "Sort {sortDescription}"
    },
    sortPromptDefaultTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sort-prompt-default-tooltip",
        "defaultMessage": "Sort in ascending order"
    },
    sortedDefaultAscendingTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-default-ascending-tooltip",
        "defaultMessage": "Sorted in ascending order"
    },
    sortedDefaultDescendingTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-default-descending-tooltip",
        "defaultMessage": "Sorted in descending order"
    }
});

});



parcelRegister("cbt50", function(module, exports) {

$parcel$export(module.exports, "ResizePopup", () => $37092842a0bc76d2$export$8ddf8c84a74a26df);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $lzLxZ = parcelRequire("lzLxZ");
var $95Az2 = parcelRequire("95Az2");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $hiKMx = parcelRequire("hiKMx");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $a4IeB = parcelRequire("a4IeB");

var $6yZZK = parcelRequire("6yZZK");
const $37092842a0bc76d2$var$ResizePopupContent = ({ columnTitle: columnTitle, initialWidth: initialWidth, onChange: onChange, onCancel: onCancel, onSubmit: onSubmit, setInitialFocusRef: setInitialFocusRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingInline: "space.200",
        xcss: $37092842a0bc76d2$var$PopupContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
        onSubmit: ({ width: width })=>onSubmit(Math.min(Math.max((0, $a4IeB.MINIMUM_COLUMN_WIDTH), width), (0, $a4IeB.MAXIMUM_COLUMN_WIDTH)))
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $95Az2.default), {
            label: formatMessage((0, $6yZZK.default).columnWidthLabel, {
                columnTitle: columnTitle
            }),
            name: "width",
            defaultValue: initialWidth
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hiKMx.default), {
                ...fieldProps,
                ref: setInitialFocusRef,
                min: (0, $a4IeB.MINIMUM_COLUMN_WIDTH),
                max: (0, $a4IeB.MAXIMUM_COLUMN_WIDTH),
                step: 5,
                onChange: (value)=>{
                    onChange(value);
                    fieldProps.onChange(value);
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.100",
            alignInline: "end",
            xcss: $37092842a0bc76d2$var$FormFooterStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            onClick: onCancel
        }, formatMessage((0, $6yZZK.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            type: "submit",
            appearance: "primary"
        }, formatMessage((0, $6yZZK.default).save))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null));
};
const $37092842a0bc76d2$export$8ddf8c84a74a26df = ({ columnTitle: columnTitle, initialWidth: initialWidth, placement: placement, isOpen: isOpen, trigger: trigger, onChange: onChange, onCancel: onCancelProp, onSubmit: onSubmit })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onCancel = (0, $eUqFw.useCallback)((event, analyticsEventParam)=>{
        const analyticsEvent = analyticsEventParam ?? createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'cancelColumnResize');
        onCancelProp(event);
    }, [
        onCancelProp,
        createAnalyticsEvent
    ]);
    const PopupContent = (0, $eUqFw.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($37092842a0bc76d2$var$ResizePopupContent, {
            columnTitle: columnTitle,
            initialWidth: initialWidth,
            onChange: onChange,
            onCancel: onCancel,
            onSubmit: onSubmit,
            setInitialFocusRef: setInitialFocusRef
        }), [
        columnTitle,
        initialWidth,
        onChange,
        onSubmit,
        onCancel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        placement: placement,
        isOpen: isOpen,
        onClose: onCancel,
        trigger: trigger,
        content: PopupContent
    });
};
const $37092842a0bc76d2$var$PopupContentStyles = (0, $1ZAYh.xcss)({
    fontWeight: 'normal',
    marginBlock: 'space.200'
});
const $37092842a0bc76d2$var$FormFooterStyles = (0, $1ZAYh.xcss)({
    marginTop: "var(--ds-space-100, 8px)"
});

});
parcelRegister("95Az2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21d0f3e403942a0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4LhB6 = parcelRequire("4LhB6");
/**
 * __Range field__
 *
 * A range field is where a user can submit a range input as a part of a form.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 */ const $d21d0f3e403942a0$var$RangeField = (props)=>{
    const { children: children, ...strippedProps } = props;
    // isInvalid and isRequired are specifically invalid for range inputs
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        ...strippedProps,
        transform: Number
    }, ({ fieldProps: { isInvalid: isInvalid, isRequired: isRequired, ...fieldProps }, ...rest })=>children({
            fieldProps: fieldProps,
            ...rest
        })));
};
var $d21d0f3e403942a0$export$2e2bcd8739ae039 = $d21d0f3e403942a0$var$RangeField;

});

parcelRegister("hiKMx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c6347ac3b199d22$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $khYWN = parcelRequire("khYWN");
const $5c6347ac3b199d22$var$snapToStep = (value, min, step)=>{
    // Normalise the value to allow for division properly with different min values
    const adjustedValue = value - min;
    // Find the number of steps the value covers
    const numSteps = Math.round(adjustedValue / step);
    // Convert numSteps back into original range
    return numSteps * step + min;
};
const $5c6347ac3b199d22$var$getRoundedPercentValue = (value, min, max, step)=>{
    let percent = '0';
    if (min < max && value > min) {
        const snappedValue = $5c6347ac3b199d22$var$snapToStep(value, min, step);
        percent = ((snappedValue - min) / (max - min) * 100).toFixed(2);
    }
    return percent;
};
const $5c6347ac3b199d22$var$noop = (0, $5Q9wj.default);
var $5c6347ac3b199d22$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Range(props, ref) {
    const { isDisabled: isDisabled = false, defaultValue: defaultValue = 50, max: max = 100, min: min = 0, onChange: onChange = $5c6347ac3b199d22$var$noop, step: step = 1, value: propsValue, testId: testId, ...rest } = props;
    const spreadProps = {
        max: max,
        min: min,
        step: step,
        ref: ref,
        ...rest
    };
    const [value, setValue] = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const handleChange = (0, $eUqFw.useCallback)((e)=>{
        const newValue = Number(e.target.value);
        setValue(newValue);
        // Note use of newValue to ensure up=to-date value is used
        onChange(newValue);
    }, [
        onChange
    ]);
    const renderValue = propsValue !== undefined ? propsValue : value;
    const valuePercent = $5c6347ac3b199d22$var$getRoundedPercentValue(renderValue, min, max, step);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $khYWN.Input), {
        type: "range",
        disabled: isDisabled,
        onChange: handleChange,
        value: renderValue,
        valuePercent: valuePercent,
        "data-testid": testId,
        ...spreadProps
    });
});

});
parcelRegister("khYWN", function(module, exports) {

$parcel$export(module.exports, "Input", () => $90027d628ac25e5d$export$f5b8910cec6cf069);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cyT4g = parcelRequire("cyT4g");
const $90027d628ac25e5d$var$VAR_THUMB_BORDER_COLOR = '--thumb-border';
const $90027d628ac25e5d$var$VAR_THUMB_SHADOW = '--thumb-shadow';
const $90027d628ac25e5d$var$VAR_THUMB_BACKGROUND_COLOR = '--thumb-bg';
const $90027d628ac25e5d$var$VAR_TRACK_BACKGROUND_COLOR = '--track-bg';
const $90027d628ac25e5d$var$VAR_TRACK_FOREGROUND_COLOR = '--track-fg';
const $90027d628ac25e5d$var$VAR_TRACK_FOREGROUND_WIDTH = '--track-fg-width';
const $90027d628ac25e5d$var$sliderThumbStyles = {
    boxSizing: 'border-box',
    width: $cyT4g.thumb.size,
    height: $cyT4g.thumb.size,
    border: 'none',
    background: `var(${$90027d628ac25e5d$var$VAR_THUMB_BACKGROUND_COLOR}, ${$cyT4g.thumb.background.default})`,
    // adapted from @atlaskit/focus-ring
    outline: `solid 2px var(${$90027d628ac25e5d$var$VAR_THUMB_BORDER_COLOR})`,
    outlineOffset: '2px',
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    boxShadow: `var(${$90027d628ac25e5d$var$VAR_THUMB_SHADOW})`,
    cursor: 'pointer',
    // Different implicit behavior across browsers -> making it explicit.
    transition: `background-color ${$cyT4g.transitionDuration} ease-in-out`
};
const $90027d628ac25e5d$var$sliderTrackStyles = {
    borderRadius: $cyT4g.track.borderRadius,
    border: 0,
    cursor: 'pointer',
    height: $cyT4g.track.height,
    width: '100%',
    transition: `background-color ${$cyT4g.transitionDuration} ease-in-out`
};
// Styles are split per browser as they are implemented differently
// Cannot consolidate as Chrome & Firefox don't recognise styles if they are grouped
// with CSS selectors they don't recognise, e.g. &::-ms-thumb
const $90027d628ac25e5d$var$browserStyles = {
    webkit: /*#__PURE__*/ (0, $byn9U.css)({
        WebkitAppearance: 'none',
        // Hides the slider so that custom slider can be made
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::-webkit-slider-thumb': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$90027d628ac25e5d$var$sliderThumbStyles,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            marginBlockStart: -($cyT4g.thumb.size - $cyT4g.track.height) / 2,
            WebkitAppearance: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::-webkit-slider-runnable-track': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$90027d628ac25e5d$var$sliderTrackStyles,
            /**
       * Webkit does not have separate properties for the background/foreground like firefox.
       * Instead we use background layering:
       * - The gray background is a simple background color.
       * - The blue foreground is a 'gradient' (to create a color block) that is sized to the progress.
       *
       * Individual properties have been used over the `background` shorthand for readability.
       */ backgroundColor: `var(${$90027d628ac25e5d$var$VAR_TRACK_BACKGROUND_COLOR})`,
            backgroundImage: `linear-gradient(var(${$90027d628ac25e5d$var$VAR_TRACK_FOREGROUND_COLOR}), var(${$90027d628ac25e5d$var$VAR_TRACK_FOREGROUND_COLOR}))`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: `var(${$90027d628ac25e5d$var$VAR_TRACK_FOREGROUND_WIDTH}) 100%`,
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '[dir="rtl"] &': {
                backgroundPosition: 'right'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::-webkit-slider-thumb, ::-webkit-slider-runnable-track': {
                cursor: 'not-allowed'
            }
        }
    }),
    firefox: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '::-moz-range-thumb': $90027d628ac25e5d$var$sliderThumbStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::-moz-focus-outer': {
            border: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::-moz-range-progress': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$90027d628ac25e5d$var$sliderTrackStyles,
            background: `var(${$90027d628ac25e5d$var$VAR_TRACK_FOREGROUND_COLOR})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::-moz-range-track': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$90027d628ac25e5d$var$sliderTrackStyles,
            background: `var(${$90027d628ac25e5d$var$VAR_TRACK_BACKGROUND_COLOR})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::-moz-range-thumb, ::-moz-range-progress, ::-moz-range-track': {
                cursor: 'not-allowed'
            }
        }
    })
};
const $90027d628ac25e5d$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    // Has a fixed width by default
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: $cyT4g.input.height,
    // Otherwise thumb will collide with previous box element
    background: 'transparent',
    // Otherwise white
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':disabled': {
        cursor: 'not-allowed',
        opacity: "var(--ds-opacity-disabled, 0.4)"
    }
});
const $90027d628ac25e5d$var$themeStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [$90027d628ac25e5d$var$VAR_THUMB_SHADOW]: $cyT4g.thumb.boxShadow.default,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [$90027d628ac25e5d$var$VAR_TRACK_BACKGROUND_COLOR]: $cyT4g.track.background.default,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [$90027d628ac25e5d$var$VAR_TRACK_FOREGROUND_COLOR]: $cyT4g.track.foreground.default,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover:not(:disabled)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [$90027d628ac25e5d$var$VAR_THUMB_BACKGROUND_COLOR]: $cyT4g.thumb.background.hovered,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [$90027d628ac25e5d$var$VAR_TRACK_BACKGROUND_COLOR]: $cyT4g.track.background.hovered,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [$90027d628ac25e5d$var$VAR_TRACK_FOREGROUND_COLOR]: $cyT4g.track.foreground.hovered
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active:not(:disabled)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [$90027d628ac25e5d$var$VAR_THUMB_BACKGROUND_COLOR]: $cyT4g.thumb.background.pressed
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [$90027d628ac25e5d$var$VAR_THUMB_BORDER_COLOR]: $cyT4g.thumb.borderColor.focused
    }
});
const $90027d628ac25e5d$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { valuePercent: valuePercent, style: style, ...strippedProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...strippedProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // We are creating a css variable to control the "progress" portion of the range input
            // This avoids us needing to create a new css class for each new percentage value
            [$90027d628ac25e5d$var$VAR_TRACK_FOREGROUND_WIDTH]: `${valuePercent}%`
        },
        ref: ref,
        css: [
            $90027d628ac25e5d$var$baseStyles,
            $90027d628ac25e5d$var$browserStyles.webkit,
            $90027d628ac25e5d$var$browserStyles.firefox,
            $90027d628ac25e5d$var$themeStyles
        ]
    });
});
$90027d628ac25e5d$export$f5b8910cec6cf069.displayName = 'InputRange';

});
parcelRegister("cyT4g", function(module, exports) {

$parcel$export(module.exports, "transitionDuration", () => $4fc7129362011f3e$export$3105270315df0e7);
$parcel$export(module.exports, "input", () => $4fc7129362011f3e$export$b7e3ae3d7c15e42e);
$parcel$export(module.exports, "thumb", () => $4fc7129362011f3e$export$becc9140d0e846f8);
$parcel$export(module.exports, "track", () => $4fc7129362011f3e$export$6b2a7d5132615086);

var $PdmhA = parcelRequire("PdmhA");
const $4fc7129362011f3e$export$3105270315df0e7 = '0.2s';
const $4fc7129362011f3e$export$b7e3ae3d7c15e42e = {
    height: 40
};
const $4fc7129362011f3e$export$becc9140d0e846f8 = {
    size: 16,
    borderWidth: 2,
    background: {
        default: `var(--ds-background-neutral-bold, ${(0, $PdmhA.B400)})`,
        hovered: `var(--ds-background-neutral-bold-hovered, ${(0, $PdmhA.B300)})`,
        pressed: `var(--ds-background-neutral-bold-pressed, ${(0, $PdmhA.B200)})`
    },
    borderColor: {
        default: 'transparent',
        focused: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`
    },
    boxShadow: {
        default: `var(--ds-UNSAFE-transparent, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`,
        disabled: `var(--ds-shadow-raised, ${`0 0 1px ${(0, $PdmhA.N60A)}`})`
    }
};
const $4fc7129362011f3e$export$6b2a7d5132615086 = {
    height: 4,
    /**
   * borderRadius >= height / 2 to create a pill shape.
   * Using '50%' creates an ellipse.
   */ borderRadius: 2,
    background: {
        default: `var(--ds-background-neutral, ${(0, $PdmhA.N30)})`,
        hovered: `var(--ds-background-neutral-hovered, ${(0, $PdmhA.N40)})`
    },
    foreground: {
        default: `var(--ds-background-neutral-bold, ${(0, $PdmhA.B400)})`,
        hovered: `var(--ds-background-neutral-bold-hovered, ${(0, $PdmhA.B300)})`
    }
};

});



parcelRegister("6yZZK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b39ff30adb9d4c2f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b39ff30adb9d4c2f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    columnWidthLabel: {
        "id": "native-issue-table.issue-table.header.header-cell.resize-popup.column-width-label",
        "defaultMessage": "Column width - {columnTitle}"
    },
    cancel: {
        "id": "native-issue-table.issue-table.header.header-cell.resize-popup.cancel",
        "defaultMessage": "Cancel"
    },
    save: {
        "id": "native-issue-table.issue-table.header.header-cell.resize-popup.save",
        "defaultMessage": "Save"
    }
});

});


parcelRegister("93C6o", function(module, exports) {

$parcel$export(module.exports, "setCssResizingWidth", () => $0a717c2a5c1f22a0$export$7bda7a969edeaaf9);
$parcel$export(module.exports, "clearCssResizingWidth", () => $0a717c2a5c1f22a0$export$c418ab97f3e5c176);
$parcel$export(module.exports, "disableCssPointerEvents", () => $0a717c2a5c1f22a0$export$b0074a660e898e0);
$parcel$export(module.exports, "enableCssPointerEvents", () => $0a717c2a5c1f22a0$export$1b5de7c0486b5e41);
$parcel$export(module.exports, "getProposedWidth", () => $0a717c2a5c1f22a0$export$39e6ff87d188b0e6);

var $a4IeB = parcelRequire("a4IeB");
const $0a717c2a5c1f22a0$var$CSS_RESIZING_WIDTH_PROPERTY = '--local-resizing-width';
const $0a717c2a5c1f22a0$export$7bda7a969edeaaf9 = (container, width)=>{
    container?.style.setProperty($0a717c2a5c1f22a0$var$CSS_RESIZING_WIDTH_PROPERTY, `${width}px`);
};
const $0a717c2a5c1f22a0$export$c418ab97f3e5c176 = (container)=>{
    container?.style.removeProperty($0a717c2a5c1f22a0$var$CSS_RESIZING_WIDTH_PROPERTY);
};
const $0a717c2a5c1f22a0$export$b0074a660e898e0 = (container)=>{
    container?.style.setProperty('pointer-events', 'none');
};
const $0a717c2a5c1f22a0$export$1b5de7c0486b5e41 = (container)=>{
    container?.style.removeProperty('pointer-events');
};
const $0a717c2a5c1f22a0$export$39e6ff87d188b0e6 = ({ initialWidth: initialWidth, location: location })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    const proposedWidth = initialWidth + diffX;
    // ensure we don't go below the min allowed width
    return Math.min(Math.max((0, $a4IeB.MINIMUM_COLUMN_WIDTH), proposedWidth), (0, $a4IeB.MAXIMUM_COLUMN_WIDTH));
};

});


parcelRegister("daw3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d2fb1c8841ba11a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1d2fb1c8841ba11a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    movedColumn: {
        "id": "native-issue-table.issue-table.header.moved-column",
        "defaultMessage": "You\u2019ve moved {column} from {previousPosition} to {position} of {total}."
    }
});

});


parcelRegister("4BDK1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f54838bedfdb3f1e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f54838bedfdb3f1e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issuesTableLabel: {
        "id": "native-issue-table.issue-table.issues-table-label",
        "defaultMessage": "Issues"
    }
});

});

parcelRegister("cG7qK", function(module, exports) {

$parcel$export(module.exports, "default", () => $41ec8980b57eabb0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $gyaWd = parcelRequire("gyaWd");

var $d6f6c = parcelRequire("d6f6c");

var $6baW2 = parcelRequire("6baW2");

var $8IlP5 = parcelRequire("8IlP5");

var $dclWz = parcelRequire("dclWz");
const $41ec8980b57eabb0$var$NoColumnsRenderer = ({ NoColumns: NoColumns = (0, $6baW2.NoColumns), hasColumnConfiguration: hasColumnConfiguration, isLoading: isLoading = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41ec8980b57eabb0$var$NoColumnsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NoColumns, {
        defaultNoColumnsGlyph: (0, $1ybV0.ff)('em-enghealth-consolidate-jfe-assets') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $41ec8980b57eabb0$var$ImageWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gyaWd.default), {
            alt: ""
        })) : (0, (/*@__PURE__*/$parcel$interopDefault($dclWz))),
        hasColumnConfiguration: hasColumnConfiguration
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8IlP5.Overlay), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "nativeIssueTableNoColumns"
    }));
var $41ec8980b57eabb0$export$2e2bcd8739ae039 = $41ec8980b57eabb0$var$NoColumnsRenderer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $41ec8980b57eabb0$var$NoColumnsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _16jlkb7n _1o9zkb7n _i0dlf1ug",
            (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? "_kqsw1if8 _1ltvidpf _1rjcxncg" : "_n3tdxncg",
            __cmplp.className
        ])
    });
});
const $41ec8980b57eabb0$var$ImageWrapperStyles = (0, $1ZAYh.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("gyaWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f352d69c1b682860$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $9TZf5 = parcelRequire("9TZf5");

var $7XfGh = parcelRequire("7XfGh");

var $5deuu = parcelRequire("5deuu");
const $f352d69c1b682860$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5deuu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($7XfGh))
});
var $f352d69c1b682860$export$2e2bcd8739ae039 = $f352d69c1b682860$var$Illustration;
// for advanced use only
const $f352d69c1b682860$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("7XfGh", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("5deuu", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});


parcelRegister("6baW2", function(module, exports) {

$parcel$export(module.exports, "NoColumns", () => $8db98c71e6dd45e0$export$a0e9f6d02eee4aa4);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $532yW = parcelRequire("532yW");

var $jMP2a = parcelRequire("jMP2a");

var $kIdhg = parcelRequire("kIdhg");
const $8db98c71e6dd45e0$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ isOpen: isOpen }, actions] = (0, $532yW.useColumnPickerOpenState)();
    const onOpenColumnPicker = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton');
        if (!isOpen) actions.open();
    }, [
        isOpen,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $kIdhg.default).noColumnsHeaderText),
        description: formatMessage((0, $kIdhg.default).noColumnsDescriptionText),
        imageUrl: !(0, $1ybV0.ff)('em-enghealth-consolidate-jfe-assets') && typeof defaultNoColumnsGlyph === 'string' ? defaultNoColumnsGlyph : undefined,
        testId: "native-issue-table.common.ui.components.no-columns.no-columns",
        primaryAction: hasColumnConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            onClick: onOpenColumnPicker
        }, formatMessage((0, $kIdhg.default).configureColumns)) : undefined,
        renderImage: ()=>(0, $1ybV0.ff)('em-enghealth-consolidate-jfe-assets') && /*#__PURE__*/ (0, $eUqFw.isValidElement)(defaultNoColumnsGlyph) ? defaultNoColumnsGlyph : undefined
    });
};

});
parcelRegister("kIdhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $50d96196bc902630$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $50d96196bc902630$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noColumnsHeaderText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-header-text",
        "defaultMessage": "Configure your columns"
    },
    noColumnsDescriptionText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-description-text",
        "defaultMessage": "You haven't configured any columns yet. Add fields as columns to see search results and their information."
    },
    configureColumns: {
        "id": "native-issue-table.issue-table.no-columns.configure-columns",
        "defaultMessage": "Configure columns"
    }
});

});


parcelRegister("dclWz", function(module, exports) {
module.exports = new URL("generic-empty-state.7d871e1a.svg", import.meta.url).toString();

});


parcelRegister("8Y1mi", function(module, exports) {

$parcel$export(module.exports, "default", () => $27b99259d87caf0b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $hgbp4 = parcelRequire("hgbp4");

var $d6f6c = parcelRequire("d6f6c");

var $8IlP5 = parcelRequire("8IlP5");

var $2Ns4V = parcelRequire("2Ns4V");

var $bE7Nx = parcelRequire("bE7Nx");
const $27b99259d87caf0b$var$NoIssuesRenderer = ({ NoIssues: NoIssues = (0, $bE7Nx.NoIssues), isLoading: isLoading = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($27b99259d87caf0b$var$EmptyIssuesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NoIssues, {
        defaultNoIssuesGlyph: (0, $1ybV0.ff)('em-enghealth-consolidate-jfe-assets') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $27b99259d87caf0b$var$ImageWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hgbp4.default), {
            alt: ""
        })) : (0, (/*@__PURE__*/$parcel$interopDefault($2Ns4V)))
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8IlP5.Overlay), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "nativeIssueTableNoResults"
    }));
var $27b99259d87caf0b$export$2e2bcd8739ae039 = $27b99259d87caf0b$var$NoIssuesRenderer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $27b99259d87caf0b$var$EmptyIssuesContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _16jlkb7n _1o9zkb7n _i0dlf1ug _mezj18pt",
            (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? "_kqsw1if8 _1ltvidpf _1rjcxncg" : "_n3tdxncg",
            __cmplp.className
        ])
    });
});
const $27b99259d87caf0b$var$ImageWrapperStyles = (0, $1ZAYh.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("hgbp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d2ebe01d4784a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("e9Rfo")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $9TZf5 = parcelRequire("9TZf5");

var $i647H = parcelRequire("i647H");

var $e9Rfo = parcelRequire("e9Rfo");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $d2d2ebe01d4784a8$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($e9Rfo)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($i647H))
});
var $d2d2ebe01d4784a8$export$2e2bcd8739ae039 = $d2d2ebe01d4784a8$var$Illustration;
// for advanced use only
const $d2d2ebe01d4784a8$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("i647H", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("e9Rfo", function(module, exports) {
module.exports = new URL("search-no-results.10b14394.svg", import.meta.url).toString();

});


parcelRegister("2Ns4V", function(module, exports) {
module.exports = new URL("no-issues-glyph.3f423090.svg", import.meta.url).toString();

});

parcelRegister("bE7Nx", function(module, exports) {

$parcel$export(module.exports, "NoIssues", () => $ccd057db58765d4f$export$a7a61a727a1d891b);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4JlcR = parcelRequire("4JlcR");
const $ccd057db58765d4f$export$a7a61a727a1d891b = ({ defaultNoIssuesGlyph: defaultNoIssuesGlyph })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $4JlcR.default).emptyIssues),
        imageUrl: !(0, $1ybV0.ff)('em-enghealth-consolidate-jfe-assets') && typeof defaultNoIssuesGlyph === 'string' ? defaultNoIssuesGlyph : undefined,
        renderImage: ()=>(0, $1ybV0.ff)('em-enghealth-consolidate-jfe-assets') && /*#__PURE__*/ (0, $eUqFw.isValidElement)(defaultNoIssuesGlyph) ? defaultNoIssuesGlyph : undefined,
        testId: "native-issue-table.ui.issue-table.no-issues-renderer.no-issues.empty-state"
    });
};

});
parcelRegister("4JlcR", function(module, exports) {

$parcel$export(module.exports, "default", () => $413298d2caaa5f04$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $413298d2caaa5f04$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyIssues: {
        "id": "native-issue-table.issue-table.empty-issues.empty-issues",
        "defaultMessage": "There are no issues"
    }
});

});



parcelRegister("7a1df", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4a18bcdb44ed678$export$2e2bcd8739ae039);

var $fyS49 = parcelRequire("fyS49");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $8WuJm = parcelRequire("8WuJm");

var $jY5J7 = parcelRequire("jY5J7");
const $d4a18bcdb44ed678$var$TableBody = ({ issueResults: issueResults, columns: columns, tableInjectedProps: tableInjectedProps, hasInlineEditing: hasInlineEditing, hasFixedTableLayout: hasFixedTableLayout, enableRowDragging: enableRowDragging })=>{
    const issueResultsData = (0, $iWLL0.useFragment)((0, $fyS49.default), issueResults);
    const renderRow = (0, $eUqFw.useCallback)((index)=>{
        const issueRow = issueResultsData?.edges?.[index];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            key: issueRow?.node?.key || index,
            attributes: {
                rowIndex: index,
                tableRowNumber: index
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jY5J7.default), {
            rowIndex: index,
            fragment: issueRow?.node ?? null,
            columns: columns,
            tableInjectedProps: tableInjectedProps,
            hasInlineEditing: hasInlineEditing,
            hasFixedTableLayout: hasFixedTableLayout,
            enableRowDragging: enableRowDragging,
            issuesConnectionId: issueResultsData.__id
        }));
    }, [
        columns,
        enableRowDragging,
        hasInlineEditing,
        hasFixedTableLayout,
        issueResultsData.__id,
        issueResultsData?.edges,
        tableInjectedProps
    ]);
    const rows = (0, $eUqFw.useMemo)(()=>issueResultsData?.edges?.map((_, index)=>renderRow(index)) ?? [], [
        issueResultsData?.edges,
        renderRow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4a18bcdb44ed678$var$StyledTableBody, null, rows);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d4a18bcdb44ed678$var$StyledTableBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "tbody", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n7zlglyw",
            (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && "_1reo15vq",
            __cmplp.className
        ])
    });
});
var $d4a18bcdb44ed678$export$2e2bcd8739ae039 = $d4a18bcdb44ed678$var$TableBody;

});
parcelRegister("fyS49", function(module, exports) {

$parcel$export(module.exports, "default", () => $af19185414520d5c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<23b1f52b25ef19ddb5f94a03ea09ed17>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $af19185414520d5c$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "tableBody_nativeIssueTable",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isInlineEditingEnabled",
                                    "variableName": "isInlineEditingEnabled"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "row_nativeIssueTable"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$af19185414520d5c$var$node.hash = "902195cc42e20c6ee5be26f1dab91b32";
var $af19185414520d5c$export$2e2bcd8739ae039 = $af19185414520d5c$var$node;

});

parcelRegister("jY5J7", function(module, exports) {

$parcel$export(module.exports, "default", () => $abbbc34f7c1b4d77$export$2e2bcd8739ae039);

var $hglja = parcelRequire("hglja");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $a4IeB = parcelRequire("a4IeB");

var $59JiB = parcelRequire("59JiB");

var $ckQE5 = parcelRequire("ckQE5");

var $aVjZe = parcelRequire("aVjZe");

var $BY6fA = parcelRequire("BY6fA");

var $fg9pv = parcelRequire("fg9pv");

var $6S1XJ = parcelRequire("6S1XJ");
const $abbbc34f7c1b4d77$var$scrollOptionsOld = {
    behavior: (0, $6S1XJ.scrollToMiddle),
    block: 'nearest',
    inline: 'nearest'
};
const $abbbc34f7c1b4d77$var$Row = ({ rowIndex: rowIndex, fragment: fragment, columns: columns, tableInjectedProps: tableInjectedProps, hasInlineEditing: hasInlineEditing, hasFixedTableLayout: hasFixedTableLayout, enableRowDragging: enableRowDragging, issuesConnectionId: issuesConnectionId })=>{
    const [isSelected, { setSelectedRow: setSelectedRow }] = (0, $59JiB.useIsSelected)({
        selectedRowIndex: rowIndex
    });
    const [isFocused, { resetFocus: resetFocus }] = (0, $59JiB.useIsFocused)({
        selectedRowIndex: rowIndex
    });
    const tableRowRef = (0, $eUqFw.useRef)(null);
    const issueRowData = (0, $iWLL0.useFragment)((0, $hglja.default), fragment);
    const { dropIndicator: dropIndicator } = (0, $fg9pv.useDraggableTableRow)({
        ref: tableRowRef,
        enableRowDragging: enableRowDragging,
        issueId: issueRowData?.id,
        issuesConnectionId: issuesConnectionId
    });
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - We are using instance properties on the underlying class component which are not exposed as a valid ref type. We should remove our dependency on this ref as it's not typesafe.
        const tableRowElement = tableRowRef.current?.node?.current;
        if (isFocused && tableRowElement) {
            if (!tableRowElement.querySelector(':focus')) tableRowElement.focus();
        }
    }, [
        isFocused
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Explicitly reset our internal state to track which row is focused. We do this to prevent the DOM element being re-focused unintentionally when the component is re-rendered.
        if (isFocused) resetFocus();
    }, [
        isFocused,
        resetFocus
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const focusCurrentRow = (0, $eUqFw.useCallback)(()=>setSelectedRow(rowIndex), [
        rowIndex,
        setSelectedRow
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        const clickAnalytics = createAnalyticsEvent({});
        const actionSubjectId = issueRowData ? 'issueRow' : 'blankRow';
        (0, $jMP2a.fireUIAnalytics)(clickAnalytics, 'rowItem clicked', actionSubjectId);
    }, [
        createAnalyticsEvent,
        issueRowData
    ]);
    const cellBorder = (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useMemo)(()=>[
            $abbbc34f7c1b4d77$var$cellBorderStyles,
            rowIndex === 0 && $abbbc34f7c1b4d77$var$firstRowCellBorderStyles
        ], [
        rowIndex
    ]) : undefined;
    const rowContent = issueRowData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVjZe.IssueRow), {
        issue: issueRowData,
        columns: columns,
        tableInjectedProps: tableInjectedProps,
        hasInlineEditing: hasInlineEditing,
        hasFixedTableLayout: hasFixedTableLayout,
        cellBorder: cellBorder
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ckQE5.default), {
        numColumns: columns.length,
        isSelected: isSelected,
        hasFixedTableLayout: hasFixedTableLayout,
        cellBorder: cellBorder
    });
    if ((0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eUqFw.useLayoutEffect)(()=>{
            // Scroll the table row into view (if needed - block: nearest) when it becomes selected
            if (isSelected) tableRowRef.current?.scrollIntoView({
                block: 'nearest'
            });
        }, [
            isSelected
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abbbc34f7c1b4d77$var$StyledTableRow // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        , {
            "data-testid": "native-issue-table.ui.issue-row",
            "aria-selected": isSelected,
            role: "row",
            active: isSelected,
            onFocus: focusCurrentRow,
            onClick: onClick,
            tabIndex: -1,
            ref: tableRowRef
        }, rowContent, dropIndicator);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $BY6fA.StyledScrollIntoViewIfNeeded // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    ), {
        "data-testid": "native-issue-table.ui.issue-row",
        elementType: "tr",
        "aria-selected": isSelected,
        role: "row",
        active: isSelected,
        onFocus: focusCurrentRow,
        onClick: onClick,
        options: $abbbc34f7c1b4d77$var$scrollOptionsOld,
        tabIndex: -1,
        ref: tableRowRef
    }, rowContent, dropIndicator);
};
var $abbbc34f7c1b4d77$export$2e2bcd8739ae039 = $abbbc34f7c1b4d77$var$Row;
const $abbbc34f7c1b4d77$var$cellBorderStyles = (0, $1ZAYh.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTopWidth: (0, $a4IeB.BORDER_WIDTH),
    borderBottomWidth: '0',
    borderLeftWidth: '0',
    borderRightWidth: (0, $a4IeB.BORDER_WIDTH),
    ':last-of-type': {
        borderRightWidth: '0'
    }
});
const $abbbc34f7c1b4d77$var$firstRowCellBorderStyles = (0, $1ZAYh.xcss)({
    borderTopWidth: '0'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $abbbc34f7c1b4d77$var$StyledTableRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1ylp _nt751r31 _49pcglyw _1hvw1o36",
            (0, $1ybV0.ff)('jsw.enable-nin-rank-dnd') ? "_kqswh2mm" : "_kqswpfqs",
            __cmplp.active && "_16qs1ahy",
            __cmplp.active ? "_bfhk29zg" : "_bfhkvuon",
            __cmplp.active ? "_irr329zg" : "_irr3108i",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hglja", function(module, exports) {

$parcel$export(module.exports, "default", () => $65c3aaae2edc62ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bd32e8f1b331d9ef4ca0c335597ba534>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $65c3aaae2edc62ca$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "row_nativeIssueTable",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "issueRow_nativeIssueTable_IssueRowWithFragments_issue"
        }
    ],
    "type": "JiraIssue"
};
$65c3aaae2edc62ca$var$node.hash = "35ed9b417cbc07970ff9e635442e6db9";
var $65c3aaae2edc62ca$export$2e2bcd8739ae039 = $65c3aaae2edc62ca$var$node;

});

parcelRegister("ckQE5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f34210d42b49494$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");

var $jVgJ8 = parcelRequire("jVgJ8");

var $iBh7j = parcelRequire("iBh7j");
const $5f34210d42b49494$var$BlankIssueRow = ({ numColumns: numColumns, isSelected: isSelected, hasFixedTableLayout: hasFixedTableLayout, cellBorder: cellBorder })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // Extra column added to account for the blank spacer column added to the table
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVgJ8.TableCell), {
        colSpan: numColumns + ((0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && hasFixedTableLayout ? 1 : 0),
        border: cellBorder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5f34210d42b49494$var$Text, {
        isSelected: isSelected
    }, formatMessage((0, $iBh7j.default).blankRowText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "blankIssue"
    }));
};
var $5f34210d42b49494$export$2e2bcd8739ae039 = $5f34210d42b49494$var$BlankIssueRow;
const $5f34210d42b49494$var$textColorActiveState = `var(--ds-text-selected, ${(0, $PdmhA).N400})`;
const $5f34210d42b49494$var$textColor = `var(--ds-text, ${(0, $PdmhA).N200})`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f34210d42b49494$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ebr96o": (0, $9t7rW.default)($5f34210d42b49494$var$textColorActiveState),
            "--_srel9g": (0, $9t7rW.default)($5f34210d42b49494$var$textColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bv1b66 _80om73ad",
            __cmplp.isSelected ? "_syaz1c3g" : "_syaz1u00",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jVgJ8", function(module, exports) {

$parcel$export(module.exports, "TableCell", () => $6f6b1c728ec2a061$export$1e4baea7053fc0e3);

var $eUqFw = parcelRequire("eUqFw");

var $hbMki = parcelRequire("hbMki");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");
const $6f6b1c728ec2a061$export$1e4baea7053fc0e3 = ({ children: children, border: border, spacing: spacing, columnWidth: columnWidth, isFlexWidth: isFlexWidth, ...htmlAttributes })=>{
    const baseStyles = (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? $6f6b1c728ec2a061$var$redesignBaseStyles : $6f6b1c728ec2a061$var$oldBaseStyles;
    const maxWidthStyles = columnWidth && !isFlexWidth ? $6f6b1c728ec2a061$var$getMaxWidthStyles(columnWidth) : undefined;
    const defaultSpacingStyles = (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? $6f6b1c728ec2a061$var$redesignSpacingStyles : $6f6b1c728ec2a061$var$oldSpacingStyles;
    const spacingStyles = spacing !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($hbMki)))(spacing) : [
        defaultSpacingStyles
    ];
    const borderStyles = (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && border !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($hbMki)))(border) : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "td",
        xcss: [
            baseStyles,
            (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && $6f6b1c728ec2a061$var$relativeStyles,
            !(0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && maxWidthStyles,
            ...spacingStyles,
            ...borderStyles
        ],
        ...htmlAttributes
    }, children);
};
const $6f6b1c728ec2a061$var$oldBaseStyles = (0, $1ZAYh.xcss)({
    borderSpacing: 0,
    border: 'none',
    // Cross-browser CSS hack to allow inline editable fields to fill the entire space of their `td`. The
    // preferred long-term solution is to adopt a flexbox layout, but until then, please do extensive
    // cross-browser testing before you update this rule.
    height: '100%'
});
const $6f6b1c728ec2a061$var$redesignBaseStyles = (0, $1ZAYh.xcss)({
    background: 'inherit',
    // Cross-browser CSS hack to allow inline editable fields to fill the entire space of their `td`. The
    // preferred long-term solution is to adopt a flexbox layout, but until then, please do extensive
    // cross-browser testing before you update this rule.
    height: '100%'
});
const $6f6b1c728ec2a061$var$relativeStyles = (0, $1ZAYh.xcss)({
    position: 'relative'
});
const $6f6b1c728ec2a061$var$oldSpacingStyles = (0, $1ZAYh.xcss)({
    padding: 'space.100',
    ':first-of-type': {
        paddingLeft: 'space.100'
    },
    ':last-of-type': {
        paddingRight: 'space.100'
    }
});
const $6f6b1c728ec2a061$var$redesignSpacingStyles = (0, $1ZAYh.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    ':first-of-type': {
        paddingLeft: 'space.100'
    },
    ':last-of-type': {
        paddingRight: 'space.100'
    }
});
const $6f6b1c728ec2a061$var$getMaxWidthStyles = (columnWidth)=>(0, $1ZAYh.xcss)({
        maxWidth: `${columnWidth}px`
    });

});

parcelRegister("iBh7j", function(module, exports) {

$parcel$export(module.exports, "default", () => $1667145e6f869d09$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1667145e6f869d09$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    blankRow: {
        "id": "native-issue-table.issue-row.blank-row.blank-row",
        "defaultMessage": "We can't display this issue"
    },
    blankRowText: {
        "id": "native-issue-table.row.blank-row.blank-row-text",
        "defaultMessage": "This issue cannot be opened because it may have been deleted or you do not have access to it"
    },
    tooltip: {
        "id": "native-issue-table.issue-row.blank-row.tooltip",
        "defaultMessage": "Either this issue has been deleted, or you don\u2019t have access to it."
    }
});

});


parcelRegister("aVjZe", function(module, exports) {

$parcel$export(module.exports, "IssueRow", () => $e9e8ce9a1c171499$export$29013dcb6d1b879d);

var $cLYu8 = parcelRequire("cLYu8");

var $2RM2w = parcelRequire("2RM2w");

var $eUqFw = parcelRequire("eUqFw");

var $hbMki = parcelRequire("hbMki");

var $iWLL0 = parcelRequire("iWLL0");

var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $6vrw7 = parcelRequire("6vrw7");

var $a4IeB = parcelRequire("a4IeB");

var $cfHEO = parcelRequire("cfHEO");
var $eTokS = parcelRequire("eTokS");
var $UfnGc = parcelRequire("UfnGc");
var $6ZTXj = parcelRequire("6ZTXj");
var $kog7M = parcelRequire("kog7M");
var $bq081 = parcelRequire("bq081");
var $66dbi = parcelRequire("66dbi");
var $6cTPi = parcelRequire("6cTPi");
var $fFkd8 = parcelRequire("fFkd8");
var $eF3lG = parcelRequire("eF3lG");
var $gHSFC = parcelRequire("gHSFC");
var $4cCSJ = parcelRequire("4cCSJ");
var $7mkbk = parcelRequire("7mkbk");
var $bUGU0 = parcelRequire("bUGU0");
var $bqOB5 = parcelRequire("bqOB5");
var $3wjH8 = parcelRequire("3wjH8");
var $itPYJ = parcelRequire("itPYJ");
var $dRNCA = parcelRequire("dRNCA");
var $fwttk = parcelRequire("fwttk");
var $6ydPH = parcelRequire("6ydPH");
var $7O70U = parcelRequire("7O70U");
var $hVevm = parcelRequire("hVevm");
var $ahMdE = parcelRequire("ahMdE");
var $7jOpZ = parcelRequire("7jOpZ");

var $jVgJ8 = parcelRequire("jVgJ8");

var $7bJW5 = parcelRequire("7bJW5");

var $1UfY8 = parcelRequire("1UfY8");
const $e9e8ce9a1c171499$export$b1e360b45a7ed518 = ({ issue: issue, columns: columns, tableInjectedProps: tableInjectedProps, hasInlineEditing: hasInlineEditing, hasFixedTableLayout: hasFixedTableLayout, cellBorder: cellBorder })=>{
    const issueData = (0, $iWLL0.useFragment)((0, $2RM2w.default), issue);
    const fieldSets = (0, $iWLL0.useFragment)((0, $cLYu8.default), issueData.fieldSetsById ?? issueData.fieldSetsForIssueSearchView ?? null);
    const columnConfigByIdMap = (0, $eUqFw.useMemo)(()=>{
        const result = new Map();
        columns.forEach((columnConfig)=>{
            result.set(columnConfig.id, columnConfig);
        });
        return result;
    }, [
        columns
    ]);
    const fieldElementByIdMap = (0, $eUqFw.useMemo)(()=>{
        // Map all issue fields into their respective cell type keyed by fieldSetId. This will be used as a lookup when
        // mapping table columns in the row.
        const result = new Map();
        const projectKey = (0, $7bJW5.getProjectKeyFromIssueKey)(issueData.key);
        fieldSets?.edges?.map((edge)=>edge?.node).filter((0, $7bJW5.isNonNullish)).forEach((fieldSet)=>{
            // @ts-expect-error - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | null'.
            const columnConfig = columnConfigByIdMap.get(fieldSet.fieldSetId);
            if (!fieldSet.fieldSetId || !columnConfig) return;
            // Handle Collapsed Fields on a single issue (rare) by simply rendering a node for each field.
            const fieldElements = [];
            // Allow td spacing to be configured for the given field type
            let spacing;
            fieldSet.fields?.edges?.forEach((fieldEdge)=>{
                switch(fieldEdge?.node?.__typename){
                    case 'JiraAffectedServicesField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cfHEO.AffectedServicesCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraCMDBField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eTokS.CmdbObjectsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraComponentsField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $UfnGc.ComponentsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            jqlTerm: columnConfig.jqlTerm,
                            projectKey: projectKey
                        }));
                        break;
                    case 'JiraDatePickerField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ZTXj.DateCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        if (fieldEdge.node.fieldId === (0, $a4IeB.KNOWN_COLUMN_TYPES).DUE_DATE) spacing = $e9e8ce9a1c171499$var$noSpacingStyles;
                        break;
                    case 'JiraDateTimePickerField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ZTXj.DateCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isRequired: fieldEdge.node.type === (0, $a4IeB.KNOWN_COLUMN_TYPES).CREATED || fieldEdge.node.type === (0, $a4IeB.KNOWN_COLUMN_TYPES).UPDATED
                        }));
                        break;
                    case 'JiraEpicLinkField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kog7M.EpicLinkCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraFallbackField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bq081.FallbackCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        if ((0, $1ybV0.ff)('nin-resizable-columns_8z4eo')) spacing = $e9e8ce9a1c171499$var$noSpacingStyles;
                        break;
                    case 'JiraIssueTypeField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mkbk.IssueTypeCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraLabelsField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bUGU0.LabelsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            jqlTerm: columnConfig.jqlTerm
                        }));
                        if (fieldEdge.node.fieldId === (0, $a4IeB.KNOWN_COLUMN_TYPES).LABELS) spacing = $e9e8ce9a1c171499$var$noSpacingStyles;
                        break;
                    case 'JiraMultipleVersionPickerField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jOpZ.VersionsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            jqlTerm: columnConfig.jqlTerm,
                            projectKey: projectKey
                        }));
                        break;
                    case 'JiraParentIssueField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bqOB5.ParentCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraPriorityField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $itPYJ.PriorityCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        if ((0, $1ybV0.ff)('nin-priority-inline-edit')) spacing = $e9e8ce9a1c171499$var$noSpacingStyles;
                        break;
                    case 'JiraProjectField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRNCA.ProjectCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isRequired: fieldEdge.node.type === (0, $a4IeB.KNOWN_COLUMN_TYPES).PROJECT
                        }));
                        break;
                    case 'JiraResolutionField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ydPH.ResolutionCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraRichTextField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7O70U.RichTextCell), {
                            issueKey: issueData.key,
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        if ((0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf')) spacing = $e9e8ce9a1c171499$var$noSpacingStyles;
                        break;
                    case 'JiraSingleLineTextField':
                        if (fieldEdge.node.type === (0, $a4IeB.KNOWN_COLUMN_TYPES).ISSUE_KEY) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $66dbi.IssueKeyCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
                            }));
                            if ((0, $1ybV0.ff)('nin-resizable-columns_8z4eo')) spacing = $e9e8ce9a1c171499$var$noSpacingStyles;
                        } else if (fieldEdge.node.type === (0, $a4IeB.KNOWN_COLUMN_TYPES).SUMMARY) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cCSJ.IssueSummaryCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                issueKey: issueData.key,
                                onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
                            }));
                            spacing = $e9e8ce9a1c171499$var$noSpacingStyles;
                        } else {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3wjH8.PlainTextCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node
                            }));
                            if ((0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf')) spacing = $e9e8ce9a1c171499$var$noSpacingStyles;
                        }
                        break;
                    case 'JiraSingleSelectUserPickerField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ahMdE.UserCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            projectKey: projectKey
                        }));
                        if ((0, $1ybV0.ff)('nin-single-user-inline-edit_orj2c') && (fieldEdge.node.fieldId === 'assignee' || fieldEdge.node.fieldId === 'reporter')) spacing = $e9e8ce9a1c171499$var$noSpacingStyles;
                        break;
                    case 'JiraSprintField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hVevm.SprintCell), {
                            key: fieldEdge.node.fieldId,
                            projectKey: (0, $6vrw7.toProjectKey)(projectKey),
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            jqlTerm: columnConfig.jqlTerm
                        }));
                        if ((0, $1ybV0.ff)('one-issue-table-sprint-inline-edit')) spacing = $e9e8ce9a1c171499$var$noSpacingStyles;
                        break;
                    case 'JiraStatusCategoryField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eF3lG.IssueStatusCategoryCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraStatusField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gHSFC.IssueStatusCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            hasInlineEditing: hasInlineEditing,
                            issueKey: issueData.key,
                            issueId: issueData.issueId,
                            onUpdateCache: tableInjectedProps.onUpdateCache
                        }));
                        break;
                    case 'JiraServiceManagementRequestTypeField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fwttk.RequestTypeCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraIssueLinkField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6cTPi.IssueLinksCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            issueKey: issueData.key
                        }));
                        break;
                    default:
                        break;
                }
            });
            if (fieldElements.length) result.set(fieldSet.fieldSetId, {
                cellElement: fieldElements,
                spacing: spacing
            });
        });
        // Always include the Issue Operations meatball menu cell.
        result.set((0, $a4IeB.COLUMN_ID_MEATBALL_MENU), {
            cellElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fFkd8.IssueOperations), {
                key: (0, $a4IeB.COLUMN_ID_MEATBALL_MENU),
                issueId: Number(issueData.issueId),
                issueKey: issueData.key,
                onIssueRefetch: tableInjectedProps.onIssueRefetch,
                onIssueDelete: tableInjectedProps.onIssueDelete
            })
        });
        return result;
    }, [
        columnConfigByIdMap,
        fieldSets?.edges,
        hasInlineEditing,
        issueData,
        tableInjectedProps.issueSearchBaseUrl,
        tableInjectedProps.onIssueRefetch,
        tableInjectedProps.onIssueDelete,
        tableInjectedProps.onIssueLinkSelected,
        tableInjectedProps.onUpdateCache
    ]);
    const cellBorderWithNoInlineBordersStyles = (0, $eUqFw.useMemo)(()=>{
        if (cellBorder === undefined) return $e9e8ce9a1c171499$var$noInlineBordersStyles;
        return [
            ...(0, (/*@__PURE__*/$parcel$interopDefault($hbMki)))(cellBorder),
            $e9e8ce9a1c171499$var$noInlineBordersStyles
        ];
    }, [
        cellBorder
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, columns.map(({ id: id, type: type, width: width, shouldResizeWithTable: shouldResizeWithTable })=>{
        const field = fieldElementByIdMap.get(id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: id
        }, // TODO: EM-7165 – Update the extra filler cell logic when refactoring the column picker column
        // Empty cell to fill remainig space if configured columns are not wide enough to fill the table
        (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && hasFixedTableLayout && id === (0, $a4IeB.COLUMN_ID_MEATBALL_MENU) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVgJ8.TableCell), {
            border: cellBorderWithNoInlineBordersStyles,
            "aria-hidden": true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UfY8.default), {
            type: type,
            cellElement: field?.cellElement,
            spacing: field?.spacing,
            columnWidth: width,
            isFlexWidth: !!shouldResizeWithTable,
            border: cellBorder
        }));
    }));
};
const $e9e8ce9a1c171499$var$noSpacingStyles = (0, $1ZAYh.xcss)({
    padding: 'space.0'
});
const $e9e8ce9a1c171499$var$noInlineBordersStyles = (0, $1ZAYh.xcss)({
    borderLeftWidth: '0',
    borderRightWidth: '0'
});
const $e9e8ce9a1c171499$export$29013dcb6d1b879d = /*#__PURE__*/ (0, $eUqFw.memo)($e9e8ce9a1c171499$export$b1e360b45a7ed518);

});
parcelRegister("cLYu8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0def48fc455364a6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a06facddcd56e7c31e43885ac6eb80b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0def48fc455364a6$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "type"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isEditableReadsEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSetsForIssueSearchView",
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "fieldSetId"
                            },
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                    },
                                                    v0 /*: any*/ ,
                                                    {
                                                        "condition": "isEditableReadsEnabled",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "isEditableInIssueView"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "affectedServices_nativeIssueTable_AffectedServicesCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "cmdbObjects_nativeIssueTable_CmdbObjectsCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "components_nativeIssueTable_ComponentsCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "date_nativeIssueTable_DateCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "epicLink_nativeIssueTable_EpicLinkCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "fallback_nativeIssueTable_FallbackCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "issueKey_nativeIssueTable_IssueKeyCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "issueStatusCategory_nativeIssueTable_IssueStatusCategoryCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "issueStatus_nativeIssueTable_IssueStatusCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "issueSummary_nativeIssueTable_IssueSummaryCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "labels_nativeIssueTable_LabelsCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "issueType_nativeIssueTable_IssueTypeCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "parent_nativeIssueTable_ParentCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "priority_nativeIssueTable_PriorityCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "project_nativeIssueTable_ProjectCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "resolution_nativeIssueTable_ResolutionCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "sprint_nativeIssueTable_SprintCell"
                                                    },
                                                    {
                                                        "args": v1 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "user_nativeIssueTable_UserCell_fieldRef"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "versions_nativeIssueTable_VersionsCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "plainText_nativeIssueTable_PlainTextCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "richText_nativeIssueTable_RichTextCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "requestType_nativeIssueTable_RequestTypeCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "issueLinks_nativeIssueTable_IssueLinksCell"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$0def48fc455364a6$var$node.hash = "7759fd10379f94fe100a0676bd68bfce";
var $0def48fc455364a6$export$2e2bcd8739ae039 = $0def48fc455364a6$var$node;

});

parcelRegister("2RM2w", function(module, exports) {

$parcel$export(module.exports, "default", () => $5571ad274c57ad43$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<14419a6372a567f7d9e22229bf5ba3aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5571ad274c57ad43$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSetsForIssueSearchView"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "name": "issueRow_nativeIssueTable_IssueRowWithFragments_issue",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "issueId"
            },
            {
                "condition": "shouldQueryFieldSetsById",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetIds",
                                    "variableName": "fieldSetIds"
                                },
                                v0 /*: any*/ 
                            ],
                            "concreteType": "JiraIssueFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        "action": "THROW",
                        "path": "fieldSetsById"
                    }
                ]
            },
            {
                "condition": "shouldQueryFieldSetsById",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "filterId",
                                    "variableName": "filterId"
                                },
                                v0 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "namespace",
                                    "variableName": "namespace"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewId",
                                    "variableName": "viewId"
                                }
                            ],
                            "concreteType": "JiraIssueFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsForIssueSearchView",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        "action": "THROW",
                        "path": "fieldSetsForIssueSearchView"
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "childIssues",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "activeProjectsOnly",
                                                "value": true
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 10
                                            }
                                        ],
                                        "concreteType": "JiraIssueConnection",
                                        "kind": "LinkedField",
                                        "name": "issues",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "totalCount"
                                            }
                                        ],
                                        "storageKey": "issues(activeProjectsOnly:true,first:10)"
                                    }
                                ],
                                "type": "JiraChildIssuesWithinLimit"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssue"
    };
}();
$5571ad274c57ad43$var$node.hash = "cb55e8ab8687e07c241360c85510346c";
var $5571ad274c57ad43$export$2e2bcd8739ae039 = $5571ad274c57ad43$var$node;

});

parcelRegister("cfHEO", function(module, exports) {

$parcel$export(module.exports, "AffectedServicesCell", () => $66668d420d975d3b$export$e6c0da3971931bb1);

var $87FDU = parcelRequire("87FDU");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jqoaM = parcelRequire("jqoaM");
var $e27aD = parcelRequire("e27aD");

var $7bJW5 = parcelRequire("7bJW5");

var $2qXcq = parcelRequire("2qXcq");

var $cWDTh = parcelRequire("cWDTh");
const $66668d420d975d3b$export$e6c0da3971931bb1 = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $87FDU.default), fieldRef);
    const affectedServices = data.selectedAffectedServicesConnection?.edges;
    const filteredAffectedServices = affectedServices?.map((edge)=>edge?.node?.name != null ? {
            key: edge.node.serviceId,
            name: edge.node.name
        } : null).filter((0, $7bJW5.isNonNullish)) ?? [];
    if (!affectedServices || affectedServices.length !== filteredAffectedServices.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "affectedServices",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jqoaM.default), {
        items: filteredAffectedServices,
        ItemComponent: (0, $e27aD.TagItem),
        PopupContentWrapper: (0, $e27aD.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $cWDTh.default).triggerButton)
    });
});

});
parcelRegister("87FDU", function(module, exports) {

$parcel$export(module.exports, "default", () => $53785f93b0189ed1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3588ea039c9febd14e0e88de5d01bbc2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $53785f93b0189ed1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "affectedServices_nativeIssueTable_AffectedServicesCell",
    "selections": [
        {
            "concreteType": "JiraAffectedServiceConnection",
            "kind": "LinkedField",
            "name": "selectedAffectedServicesConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraAffectedServiceEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraAffectedService",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "serviceId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraAffectedServicesField"
};
$53785f93b0189ed1$var$node.hash = "ce0f961052b6620f6333f7806e16524e";
var $53785f93b0189ed1$export$2e2bcd8739ae039 = $53785f93b0189ed1$var$node;

});

parcelRegister("2qXcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f83d4dd41e13bf13$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $guiFP = parcelRequire("guiFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $a4IeB = parcelRequire("a4IeB");

var $bUP6Q = parcelRequire("bUP6Q");
const $f83d4dd41e13bf13$var$ErrorCell = ({ cellType: cellType, reason: reason, errorInfo: errorInfo })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>setIsHovered(true), []);
    const onMouseLeave = (0, $eUqFw.useCallback)(()=>setIsHovered(false), []);
    const iconColor = isHovered ? `var(--ds-icon, ${(0, $PdmhA).N500})` : `var(--ds-icon-subtle, ${(0, $PdmhA).N200})`;
    const message = formatMessage((0, $bUP6Q.default).tooltip);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        const sendAnalytics = ()=>{
            const error = new Error(`Failed to render cell data for the ${cellType} cell type. Reason: ${reason}`);
            (0, $guiFP.default)({
                meta: {
                    id: 'errorCell',
                    packageName: (0, $a4IeB.PACKAGE_NAME),
                    teamName: (0, $a4IeB.TEAM_NAME)
                },
                error: error,
                errorInfo: // @ts-expect-error([Part of upgrade 4.9-5.4]) - Type 'React.ErrorInfo | undefined' is not assignable to type 'ErrorInfo | undefined'.
                errorInfo,
                event: createAnalyticsEvent({}),
                attributes: {
                    cellType: cellType
                },
                sendToPrivacyUnsafeSplunk: true
            });
        };
        const sendAnalyticsDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(sendAnalytics);
        sendAnalyticsDebounced();
        // Cancel any debounced events on unmount. This prevents sending an error event when the cell was mounted
        // due to an intermediary render. We've observed this when new columns are committed to the Relay store
        // in a separate render before issue field sets are aligned.
        return ()=>{
            sendAnalyticsDebounced.cancel();
        };
    // Only fire on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: message,
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "native-issue-table.common.error-cell.tooltip-target",
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        primaryColor: iconColor,
        label: message
    })));
};
var $f83d4dd41e13bf13$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($f83d4dd41e13bf13$var$ErrorCell);

});
parcelRegister("bUP6Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $08d4064b88c4efe7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $08d4064b88c4efe7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tooltip: {
        "id": "native-issue-table.common.error-cell.tooltip",
        "defaultMessage": "We couldn\u2019t load this field\u2019s details. Refresh and try again."
    }
});

});


parcelRegister("cWDTh", function(module, exports) {

$parcel$export(module.exports, "default", () => $5765779690fd7ccb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5765779690fd7ccb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.affected-services.trigger-button",
        "defaultMessage": "See more affected services"
    }
});

});


parcelRegister("eTokS", function(module, exports) {

$parcel$export(module.exports, "CmdbObjectsCell", () => $ca35fd0353a31a3e$export$eebc6db46b17b7b3);

var $lv7X3 = parcelRequire("lv7X3");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jqoaM = parcelRequire("jqoaM");
var $e27aD = parcelRequire("e27aD");

var $7bJW5 = parcelRequire("7bJW5");

var $2qXcq = parcelRequire("2qXcq");

var $4bGil = parcelRequire("4bGil");

var $aim1d = parcelRequire("aim1d");
const $ca35fd0353a31a3e$var$CELL_TYPE = 'cmdbObjects';
const $ca35fd0353a31a3e$export$eebc6db46b17b7b3 = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $lv7X3.default), fieldRef);
    const errors = data?.selectedCmdbObjectsConnection?.errors?.map((error)=>error?.message);
    if (errors?.length) // At time of writing, these errors are not wired up on the issue backend. However we will maintain this
    // logging so that it is present if/when it is wired up so we can get error information immediately.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: $ca35fd0353a31a3e$var$CELL_TYPE,
        reason: `Errors present: ${errors.length} - ${errors.join(', ')}; Edges present: ${data?.selectedCmdbObjectsConnection?.edges?.length}`
    });
    const objects = data?.selectedCmdbObjectsConnection?.edges;
    const filteredObjects = objects?.map((edge)=>edge?.node?.label != null ? {
            key: edge.node.objectId || 'missingId',
            name: edge.node.label,
            href: (0, $4bGil.createObjectDetailUrl)(edge.node.objectId || ''),
            icon: {
                url: edge.node.avatar?.url48 ?? undefined
            }
        } : null).filter((0, $7bJW5.isNonNullish)) ?? [];
    if (!objects || objects.length !== filteredObjects.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: $ca35fd0353a31a3e$var$CELL_TYPE,
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jqoaM.default), {
        items: filteredObjects,
        ItemComponent: (0, $e27aD.TagItem),
        PopupContentWrapper: (0, $e27aD.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $aim1d.default).triggerButton)
    });
});

});
parcelRegister("lv7X3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2557fab2dfeaa0e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c0eaaacddaa5f58fdd3b9026b365a8c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f2557fab2dfeaa0e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cmdbObjects_nativeIssueTable_CmdbObjectsCell",
    "selections": [
        {
            "concreteType": "JiraCmdbObjectConnection",
            "kind": "LinkedField",
            "name": "selectedCmdbObjectsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraCmdbObjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraCmdbObject",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "objectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "label"
                                },
                                {
                                    "concreteType": "JiraCmdbAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "url48"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraCMDBField"
};
$f2557fab2dfeaa0e$var$node.hash = "5af90ecd29a8714b7b5b735e02462fc4";
var $f2557fab2dfeaa0e$export$2e2bcd8739ae039 = $f2557fab2dfeaa0e$var$node;

});

parcelRegister("4bGil", function(module, exports) {

$parcel$export(module.exports, "createObjectDetailUrl", () => $1c8b91760dea514e$export$51e4229f2c7d3866);
// Hardcoded values from @atlassian/jira-servicedesk-insight-urls
const $1c8b91760dea514e$var$ASSETS_ROUTE_PREFIX = '/jira/servicedesk/assets';
const $1c8b91760dea514e$export$51e4229f2c7d3866 = (objectId)=>`${$1c8b91760dea514e$var$ASSETS_ROUTE_PREFIX}/object/${objectId}`;

});

parcelRegister("aim1d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d20f5850b895e02$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3d20f5850b895e02$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.cmdb-objects.trigger-button",
        "defaultMessage": "See more assets"
    }
});

});


parcelRegister("UfnGc", function(module, exports) {

$parcel$export(module.exports, "ComponentsCell", () => $894dfc06fe51584a$export$fafea088ac1dbc41);

var $gEHm2 = parcelRequire("gEHm2");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $ehDeP = parcelRequire("ehDeP");
var $k85ht = parcelRequire("k85ht");
var $lmIUR = parcelRequire("lmIUR");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jqoaM = parcelRequire("jqoaM");
var $e27aD = parcelRequire("e27aD");

var $7bJW5 = parcelRequire("7bJW5");

var $2qXcq = parcelRequire("2qXcq");

var $iflfC = parcelRequire("iflfC");
/**
 * Expected JQL Output: `project = ${projectKey} AND ${jqlTerm} = ${name}`
 */ const $894dfc06fe51584a$var$getLinkJql = (projectKey, jqlTerm, name)=>{
    const jast = (0, $ehDeP.default).jast((0, $ehDeP.default).query((0, $ehDeP.default).compoundClause((0, $ehDeP.default).compoundOperator((0, $e5bc650799ce4838$export$6d6d48d210d3ca97)), [
        (0, $ehDeP.default).terminalClause((0, $ehDeP.default).field('project'), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_EQUALS)), (0, $ehDeP.default).valueOperand(projectKey)),
        (0, $ehDeP.default).terminalClause((0, $ehDeP.default).field((0, $7bJW5.escapeBackslashes)(jqlTerm)), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_EQUALS)), (0, $ehDeP.default).valueOperand((0, $7bJW5.escapeBackslashes)(name)))
    ])));
    return (0, $lmIUR.print)(jast, {
        operatorCase: (0, $1ybV0.ff)('nin-better-jql-builder-basic_m0m6q') ? 'upper' : undefined
    });
};
const $894dfc06fe51584a$export$fafea088ac1dbc41 = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { selectedComponentsConnection: selectedComponentsConnection } = (0, $iWLL0.useFragment)((0, $gEHm2.default), fieldRef);
    const components = selectedComponentsConnection?.edges;
    const filteredComponents = (0, $eUqFw.useMemo)(()=>components?.map((edge)=>edge?.node?.name != null ? {
                key: edge.node.name,
                name: edge.node.name,
                href: `${issueSearchBaseUrl}?jql=${encodeURIComponent($894dfc06fe51584a$var$getLinkJql(projectKey, jqlTerm, edge.node.name))}`
            } : null).filter((0, $7bJW5.isNonNullish)) ?? [], [
        components,
        issueSearchBaseUrl,
        projectKey,
        jqlTerm
    ]);
    if (!components || components.length !== filteredComponents.length || !projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "components",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jqoaM.default), {
        items: filteredComponents,
        ItemComponent: (0, $e27aD.TagItem),
        PopupContentWrapper: (0, $e27aD.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $iflfC.default).triggerButton)
    });
});

});
parcelRegister("gEHm2", function(module, exports) {

$parcel$export(module.exports, "default", () => $19507d62e8b6c5c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<06b95ecd5b3cd1c98301d2dde4afcd52>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $19507d62e8b6c5c3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "components_nativeIssueTable_ComponentsCell",
    "selections": [
        {
            "concreteType": "JiraComponentConnection",
            "kind": "LinkedField",
            "name": "selectedComponentsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraComponentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraComponent",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraComponentsField"
};
$19507d62e8b6c5c3$var$node.hash = "28de007d874f95f617e402ac3a635758";
var $19507d62e8b6c5c3$export$2e2bcd8739ae039 = $19507d62e8b6c5c3$var$node;

});

const $e5bc650799ce4838$export$6d6d48d210d3ca97 = 'and';
const $e5bc650799ce4838$export$7b8f0a728d79a753 = 'or';

parcelRegister("ehDeP", function(module, exports) {

$parcel$export(module.exports, "internalCreators", () => $b9828d20df20ab04$export$64d991963cfb5532);
$parcel$export(module.exports, "default", () => $b9828d20df20ab04$export$2e2bcd8739ae039);

var $bdxrq = parcelRequire("bdxrq");

var $6PZUx = parcelRequire("6PZUx");

var $1tKLQ = parcelRequire("1tKLQ");

var $1l80e = parcelRequire("1l80e");

var $2H3zB = parcelRequire("2H3zB");

var $kDZbK = parcelRequire("kDZbK");

var $dnbob = parcelRequire("dnbob");

var $bfn5R = parcelRequire("bfn5R");

var $eD0Hy = parcelRequire("eD0Hy");

var $1uxra = parcelRequire("1uxra");

var $5eoHT = parcelRequire("5eoHT");

var $3T5iU = parcelRequire("3T5iU");

var $8Tr0t = parcelRequire("8Tr0t");

var $1R1xk = parcelRequire("1R1xk");

var $eHzms = parcelRequire("eHzms");

var $i2yZF = parcelRequire("i2yZF");

var $3fSGD = parcelRequire("3fSGD");

var $jvsC0 = parcelRequire("jvsC0");

var $bdP2p = parcelRequire("bdP2p");

var $1Rz9E = parcelRequire("1Rz9E");

var $5o1cq = parcelRequire("5o1cq");

var $4VxAa = parcelRequire("4VxAa");
const $b9828d20df20ab04$export$64d991963cfb5532 = {
    query: (0, $1Rz9E.queryInternal),
    compoundClause: (0, $6PZUx.compoundClauseInternal),
    compoundOperator: (0, $1tKLQ.compoundOperatorInternal),
    terminalClause: (0, $5o1cq.terminalClauseInternal),
    notClause: (0, $1uxra.notClauseInternal),
    notClauseOperator: (0, $5eoHT.notClauseOperatorInternal),
    predicate: (0, $3fSGD.predicateInternal),
    predicateOperator: (0, $jvsC0.predicateOperatorInternal),
    field: (0, $1l80e.fieldInternal),
    property: (0, $bdP2p.propertyInternal),
    operator: (0, $3T5iU.operatorInternal),
    valueOperand: (0, $4VxAa.valueOperandInternal),
    keywordOperand: (0, $bfn5R.keywordOperandInternal),
    functionOperand: (0, $2H3zB.functionOperandInternal),
    functionString: (0, $kDZbK.functionStringInternal),
    argument: (0, $bdxrq.argumentInternal),
    listOperand: (0, $eD0Hy.listOperandInternal),
    orderBy: (0, $8Tr0t.orderByInternal),
    orderByOperator: (0, $i2yZF.orderByOperatorInternal),
    orderByField: (0, $eHzms.orderByFieldInternal),
    orderByDirection: (0, $1R1xk.orderByDirectionInternal)
};
var $b9828d20df20ab04$export$2e2bcd8739ae039 = {
    jast: $dnbob.jast,
    query: $1Rz9E.query,
    compoundClause: $6PZUx.compoundClause,
    compoundOperator: $1tKLQ.compoundOperator,
    terminalClause: $5o1cq.terminalClause,
    notClause: $1uxra.notClause,
    notClauseOperator: $5eoHT.notClauseOperator,
    predicate: $3fSGD.predicate,
    predicateOperator: $jvsC0.predicateOperator,
    field: $1l80e.field,
    property: $bdP2p.property,
    operator: $3T5iU.operator,
    valueOperand: $4VxAa.valueOperand,
    keywordOperand: $bfn5R.keywordOperand,
    functionOperand: $2H3zB.functionOperand,
    functionString: $kDZbK.functionString,
    argument: $bdxrq.argument,
    listOperand: $eD0Hy.listOperand,
    orderBy: $8Tr0t.orderBy,
    orderByOperator: $i2yZF.orderByOperator,
    orderByField: $eHzms.orderByField,
    orderByDirection: $1R1xk.orderByDirection,
    byText: {
        argument: (0, $bdxrq.argumentByText),
        valueOperand: (0, $4VxAa.valueOperandByText)
    }
};

});
parcelRegister("bdxrq", function(module, exports) {

$parcel$export(module.exports, "argument", () => $07ff9cf8710db9a9$export$6ea29ee575e3f5ff);
$parcel$export(module.exports, "argumentInternal", () => $07ff9cf8710db9a9$export$5b341d50fa5bcdd5);
$parcel$export(module.exports, "argumentByText", () => $07ff9cf8710db9a9$export$84c43d23f51170cb);

var $g2nfy = parcelRequire("g2nfy");
var $tI64Y = parcelRequire("tI64Y");

var $8vd0B = parcelRequire("8vd0B");
function $07ff9cf8710db9a9$var$acceptArgument(visitor) {
    return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
}
function $07ff9cf8710db9a9$var$enterNode(listener) {
    listener.enterArgument && listener.enterArgument(this);
}
function $07ff9cf8710db9a9$var$exitNode(listener) {
    listener.exitArgument && listener.exitArgument(this);
}
const $07ff9cf8710db9a9$export$6ea29ee575e3f5ff = (value)=>$07ff9cf8710db9a9$export$5b341d50fa5bcdd5(value, (0, $tI64Y.sanitiseJqlString)(value));
const $07ff9cf8710db9a9$export$84c43d23f51170cb = (text)=>$07ff9cf8710db9a9$export$5b341d50fa5bcdd5((0, $g2nfy.normaliseJqlString)(text), text);
const $07ff9cf8710db9a9$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $07ff9cf8710db9a9$var$acceptArgument,
        enterNode: $07ff9cf8710db9a9$var$enterNode,
        exitNode: $07ff9cf8710db9a9$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});
parcelRegister("g2nfy", function(module, exports) {

$parcel$export(module.exports, "normaliseJqlString", () => $33fc07f8fcdc6596$export$cecf78a779acc0ff);
const $33fc07f8fcdc6596$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $33fc07f8fcdc6596$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $33fc07f8fcdc6596$export$b86601123607fee5 = (maybeQuotedString)=>$33fc07f8fcdc6596$export$7a0b99b892e0dda8(maybeQuotedString) || $33fc07f8fcdc6596$export$d5efd6512db694fd(maybeQuotedString);
const $33fc07f8fcdc6596$export$cecf78a779acc0ff = (maybeQuotedString)=>{
    if ($33fc07f8fcdc6596$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};

});

parcelRegister("tI64Y", function(module, exports) {

$parcel$export(module.exports, "sanitiseJqlString", () => $67c602023b602b57$export$3eb9033c48208278);

var $e1vfz = parcelRequire("e1vfz");
// Derived from JQLLexer#VALID_UNQUOTED_CHARS
const $67c602023b602b57$var$CHARS_TO_QUOTE = new RegExp(`[\\s${(0, (/*@__PURE__*/$parcel$interopDefault($e1vfz)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
const $67c602023b602b57$export$3eb9033c48208278 = (jqlString)=>{
    if ($67c602023b602b57$var$CHARS_TO_QUOTE.test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
    return jqlString;
};

});
parcelRegister("e1vfz", function(module, exports) {

var $1uqnh = parcelRequire("1uqnh");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $a359664a3c663e8b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $a359664a3c663e8b$var$reHasRegExpChar = RegExp($a359664a3c663e8b$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $a359664a3c663e8b$var$escapeRegExp(string) {
    string = $1uqnh(string);
    return string && $a359664a3c663e8b$var$reHasRegExpChar.test(string) ? string.replace($a359664a3c663e8b$var$reRegExpChar, '\\$&') : string;
}
module.exports = $a359664a3c663e8b$var$escapeRegExp;

});


parcelRegister("8vd0B", function(module, exports) {

$parcel$export(module.exports, "noChildren", () => $bdd25090ea4701e8$export$470bef71e654b804);
$parcel$export(module.exports, "assignParent", () => $bdd25090ea4701e8$export$a4685923af2913a);
const $bdd25090ea4701e8$export$470bef71e654b804 = ()=>[];
const $bdd25090ea4701e8$export$a4685923af2913a = (node)=>{
    node.getChildren().forEach((child)=>{
        child.parent = node;
    });
};

});


parcelRegister("6PZUx", function(module, exports) {

$parcel$export(module.exports, "compoundClause", () => $21944f207531c2fe$export$ab714e56a32c25f2);
$parcel$export(module.exports, "compoundClauseInternal", () => $21944f207531c2fe$export$cd65eed8c10b0911);


var $6Ijjg = parcelRequire("6Ijjg");

var $8vd0B = parcelRequire("8vd0B");
function $21944f207531c2fe$var$acceptCompoundClause(visitor) {
    return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
}
function $21944f207531c2fe$var$enterNode(listener) {
    listener.enterCompoundClause && listener.enterCompoundClause(this);
}
function $21944f207531c2fe$var$exitNode(listener) {
    listener.exitCompoundClause && listener.exitCompoundClause(this);
}
function $21944f207531c2fe$var$getChildren() {
    return [
        this.operator,
        ...this.clauses
    ];
}
const $21944f207531c2fe$export$ab714e56a32c25f2 = (operator, clauses)=>{
    return $21944f207531c2fe$export$cd65eed8c10b0911(operator, clauses);
};
const $21944f207531c2fe$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$2d205682cc545947),
        clauseType: (0, $35634e4e5a46f5ae$export$7a58b23488ea076b),
        operator: operator,
        clauses: clauses,
        position: position,
        accept: $21944f207531c2fe$var$acceptCompoundClause,
        enterNode: $21944f207531c2fe$var$enterNode,
        exitNode: $21944f207531c2fe$var$exitNode,
        getChildren: $21944f207531c2fe$var$getChildren,
        parent: null,
        appendClause: $6Ijjg.appendClause,
        remove: $6Ijjg.remove,
        removeClause: $6Ijjg.removeClause,
        replace: $6Ijjg.replace,
        replaceClause: $6Ijjg.replaceClause
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
const $35634e4e5a46f5ae$export$7a58b23488ea076b = 'compound';
const $35634e4e5a46f5ae$export$ae56b4ef248a2b6a = 'terminal';
const $35634e4e5a46f5ae$export$e356b89f8c8d2fcb = 'not';

const $4dac9dd1966bb7dd$export$98dda21ec825792 = 'query';
const $4dac9dd1966bb7dd$export$2d205682cc545947 = 'clause';
const $4dac9dd1966bb7dd$export$d2f212d8ddbc8d1d = 'operand';
const $4dac9dd1966bb7dd$export$da0f73edded4a63d = 'order_by';

parcelRegister("6Ijjg", function(module, exports) {

$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);


var $8vd0B = parcelRequire("8vd0B");
function appendClause(clause) {
    let clausesToAppend = [
        clause
    ];
    // If the clause to append is compound with a matching operator then we flatten it into the current clause
    if (clause.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
    this.clauses.push(...clausesToAppend);
    (0, $8vd0B.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    this.clauses = this.clauses.filter((val)=>val !== clause);
    if (this.clauses.length === 1) this.replace(this.clauses[0]);
    else if (this.clauses.length === 0) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    this.clauses = this.clauses.map((child)=>{
        return child === clause ? nextClause : child;
    });
    (0, $8vd0B.assignParent)(this);
}

});


parcelRegister("1tKLQ", function(module, exports) {

$parcel$export(module.exports, "compoundOperator", () => $41689cae7add497a$export$84bb3ebbba491aee);
$parcel$export(module.exports, "compoundOperatorInternal", () => $41689cae7add497a$export$63c33bc3fe74fee6);

var $8vd0B = parcelRequire("8vd0B");
function $41689cae7add497a$var$acceptCompoundOperator(visitor) {
    return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
}
function $41689cae7add497a$var$enterNode(listener) {
    listener.enterCompoundOperator && listener.enterCompoundOperator(this);
}
function $41689cae7add497a$var$exitNode(listener) {
    listener.exitCompoundOperator && listener.exitCompoundOperator(this);
}
const $41689cae7add497a$export$84bb3ebbba491aee = (value)=>$41689cae7add497a$export$63c33bc3fe74fee6(value, []);
const $41689cae7add497a$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
        value: value,
        positions: operatorPositions,
        position: null,
        accept: $41689cae7add497a$var$acceptCompoundOperator,
        enterNode: $41689cae7add497a$var$enterNode,
        exitNode: $41689cae7add497a$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("1l80e", function(module, exports) {

$parcel$export(module.exports, "field", () => $ca7da08f64c6e9e4$export$e0f35d825088c098);
$parcel$export(module.exports, "fieldInternal", () => $ca7da08f64c6e9e4$export$2193f8c541622b6);

var $tI64Y = parcelRequire("tI64Y");

var $8vd0B = parcelRequire("8vd0B");
function $ca7da08f64c6e9e4$var$acceptField(visitor) {
    return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
}
function $ca7da08f64c6e9e4$var$enterNode(listener) {
    listener.enterField && listener.enterField(this);
}
function $ca7da08f64c6e9e4$var$exitNode(listener) {
    listener.exitField && listener.exitField(this);
}
function $ca7da08f64c6e9e4$var$getChildren() {
    return this.properties ? [
        ...this.properties
    ] : [];
}
const $ca7da08f64c6e9e4$export$e0f35d825088c098 = (value, properties)=>{
    return $ca7da08f64c6e9e4$export$2193f8c541622b6(value, (0, $tI64Y.sanitiseJqlString)(value), properties);
};
const $ca7da08f64c6e9e4$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
    const node = {
        text: text,
        value: value,
        properties: properties,
        position: position,
        accept: $ca7da08f64c6e9e4$var$acceptField,
        enterNode: $ca7da08f64c6e9e4$var$enterNode,
        exitNode: $ca7da08f64c6e9e4$var$exitNode,
        getChildren: $ca7da08f64c6e9e4$var$getChildren,
        parent: null
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});

parcelRegister("2H3zB", function(module, exports) {

$parcel$export(module.exports, "functionOperand", () => $40b2ef8348f4cf32$export$4f981b0e83488ce);
$parcel$export(module.exports, "functionOperandInternal", () => $40b2ef8348f4cf32$export$c1f2ce91dc05872a);


var $8vd0B = parcelRequire("8vd0B");
function $40b2ef8348f4cf32$var$acceptFunctionOperand(visitor) {
    return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
}
function $40b2ef8348f4cf32$var$enterNode(listener) {
    listener.enterFunctionOperand && listener.enterFunctionOperand(this);
}
function $40b2ef8348f4cf32$var$exitNode(listener) {
    listener.exitFunctionOperand && listener.exitFunctionOperand(this);
}
function $40b2ef8348f4cf32$var$getChildren() {
    return [
        this.function,
        ...this.arguments
    ];
}
const $40b2ef8348f4cf32$export$4f981b0e83488ce = (functionString, args = [])=>$40b2ef8348f4cf32$export$c1f2ce91dc05872a(functionString, args);
const $40b2ef8348f4cf32$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$d2f212d8ddbc8d1d),
        operandType: (0, $807962b43ef03b56$export$19c7c729db381f9d),
        function: functionString,
        arguments: args,
        position: position,
        accept: $40b2ef8348f4cf32$var$acceptFunctionOperand,
        enterNode: $40b2ef8348f4cf32$var$enterNode,
        exitNode: $40b2ef8348f4cf32$var$exitNode,
        getChildren: $40b2ef8348f4cf32$var$getChildren,
        parent: null
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
const $807962b43ef03b56$export$38accfc5a5d1c113 = 'value';
const $807962b43ef03b56$export$f6049126fd97001f = 'keyword';
const $807962b43ef03b56$export$19c7c729db381f9d = 'function';
const $807962b43ef03b56$export$fabec4aebba3f4df = 'list';
const $807962b43ef03b56$export$1c46dca02aac24dd = 'empty';


parcelRegister("kDZbK", function(module, exports) {

$parcel$export(module.exports, "functionString", () => $4a79528e6e143f86$export$4e1bb9a7ff8d0ef9);
$parcel$export(module.exports, "functionStringInternal", () => $4a79528e6e143f86$export$7aa9944588b7a69f);

var $tI64Y = parcelRequire("tI64Y");

var $8vd0B = parcelRequire("8vd0B");
function $4a79528e6e143f86$var$acceptFunctionString(visitor) {
    return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
}
function $4a79528e6e143f86$var$enterNode(listener) {
    listener.enterFunction && listener.enterFunction(this);
}
function $4a79528e6e143f86$var$exitNode(listener) {
    listener.exitFunction && listener.exitFunction(this);
}
const $4a79528e6e143f86$export$4e1bb9a7ff8d0ef9 = (value)=>$4a79528e6e143f86$export$7aa9944588b7a69f(value, (0, $tI64Y.sanitiseJqlString)(value));
const $4a79528e6e143f86$export$7aa9944588b7a69f = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $4a79528e6e143f86$var$acceptFunctionString,
        enterNode: $4a79528e6e143f86$var$enterNode,
        exitNode: $4a79528e6e143f86$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("dnbob", function(module, exports) {

$parcel$export(module.exports, "jast", () => $b5aa2ed089d54434$export$b9e70a00f479ff43);
const $b5aa2ed089d54434$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
        query: query,
        represents: represents,
        errors: errors
    });

});

parcelRegister("bfn5R", function(module, exports) {

$parcel$export(module.exports, "keywordOperand", () => $33ccff7643df2fc3$export$2edd4971ed69f2ce);
$parcel$export(module.exports, "keywordOperandInternal", () => $33ccff7643df2fc3$export$7cc55480b054047b);


var $8vd0B = parcelRequire("8vd0B");
function $33ccff7643df2fc3$var$acceptKeywordOperand(visitor) {
    return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
}
function $33ccff7643df2fc3$var$enterNode(listener) {
    listener.enterKeywordOperand && listener.enterKeywordOperand(this);
}
function $33ccff7643df2fc3$var$exitNode(listener) {
    listener.exitKeywordOperand && listener.exitKeywordOperand(this);
}
const $33ccff7643df2fc3$export$2edd4971ed69f2ce = ()=>$33ccff7643df2fc3$export$7cc55480b054047b((0, $807962b43ef03b56$export$1c46dca02aac24dd));
const $33ccff7643df2fc3$export$7cc55480b054047b = (value, position = null)=>({
        type: (0, $4dac9dd1966bb7dd$export$d2f212d8ddbc8d1d),
        operandType: (0, $807962b43ef03b56$export$f6049126fd97001f),
        value: value,
        position: position,
        accept: $33ccff7643df2fc3$var$acceptKeywordOperand,
        enterNode: $33ccff7643df2fc3$var$enterNode,
        exitNode: $33ccff7643df2fc3$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("eD0Hy", function(module, exports) {

$parcel$export(module.exports, "listOperand", () => $c8986a6d4d679671$export$769866c3e9d41d50);
$parcel$export(module.exports, "listOperandInternal", () => $c8986a6d4d679671$export$663c7831528c984b);


var $7IFnF = parcelRequire("7IFnF");

var $8vd0B = parcelRequire("8vd0B");
function $c8986a6d4d679671$var$acceptListOperand(visitor) {
    return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
}
function $c8986a6d4d679671$var$enterNode(listener) {
    listener.enterListOperand && listener.enterListOperand(this);
}
function $c8986a6d4d679671$var$exitNode(listener) {
    listener.exitListOperand && listener.exitListOperand(this);
}
function $c8986a6d4d679671$var$getChildren() {
    return [
        ...this.values
    ];
}
const $c8986a6d4d679671$export$769866c3e9d41d50 = (values)=>$c8986a6d4d679671$export$663c7831528c984b(values);
const $c8986a6d4d679671$export$663c7831528c984b = (values, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$d2f212d8ddbc8d1d),
        operandType: (0, $807962b43ef03b56$export$fabec4aebba3f4df),
        values: values,
        position: position,
        accept: $c8986a6d4d679671$var$acceptListOperand,
        enterNode: $c8986a6d4d679671$var$enterNode,
        exitNode: $c8986a6d4d679671$var$exitNode,
        getChildren: $c8986a6d4d679671$var$getChildren,
        parent: null,
        appendOperand: $7IFnF.appendOperand
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("7IFnF", function(module, exports) {

$parcel$export(module.exports, "appendOperand", () => $f8f36eb1e6c645ee$export$d94c54f1aee177c4);


var $8vd0B = parcelRequire("8vd0B");
function $f8f36eb1e6c645ee$export$d94c54f1aee177c4(operand) {
    this.values.push(...operand.operandType === (0, $807962b43ef03b56$export$fabec4aebba3f4df) ? operand.values : [
        operand
    ]);
    (0, $8vd0B.assignParent)(this);
}

});


parcelRegister("1uxra", function(module, exports) {

$parcel$export(module.exports, "notClause", () => $1553b96d0b936df5$export$b4734a9fedb4d44e);
$parcel$export(module.exports, "notClauseInternal", () => $1553b96d0b936df5$export$b25621824fea4548);


var $3nho4 = parcelRequire("3nho4");

var $8vd0B = parcelRequire("8vd0B");

var $5eoHT = parcelRequire("5eoHT");
function $1553b96d0b936df5$var$acceptNotClause(visitor) {
    return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
}
function $1553b96d0b936df5$var$enterNode(listener) {
    listener.enterNotClause && listener.enterNotClause(this);
}
function $1553b96d0b936df5$var$exitNode(listener) {
    listener.exitNotClause && listener.exitNotClause(this);
}
function $1553b96d0b936df5$var$getChildren() {
    return [
        this.operator,
        this.clause
    ];
}
const $1553b96d0b936df5$export$b4734a9fedb4d44e = (clause)=>{
    return $1553b96d0b936df5$export$b25621824fea4548(clause, (0, $5eoHT.notClauseOperator)());
};
const $1553b96d0b936df5$export$b25621824fea4548 = (clause, operator, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$2d205682cc545947),
        clauseType: (0, $35634e4e5a46f5ae$export$e356b89f8c8d2fcb),
        clause: clause,
        operator: operator,
        position: position,
        accept: $1553b96d0b936df5$var$acceptNotClause,
        enterNode: $1553b96d0b936df5$var$enterNode,
        exitNode: $1553b96d0b936df5$var$exitNode,
        getChildren: $1553b96d0b936df5$var$getChildren,
        parent: null,
        remove: $3nho4.remove,
        removeClause: $3nho4.removeClause,
        replace: $3nho4.replace,
        replaceClause: $3nho4.replaceClause
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("3nho4", function(module, exports) {

$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);

var $8vd0B = parcelRequire("8vd0B");
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    if (this.clause === clause) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    if (this.clause === clause) {
        this.clause = nextClause;
        (0, $8vd0B.assignParent)(this);
    }
}

});

parcelRegister("5eoHT", function(module, exports) {

$parcel$export(module.exports, "notClauseOperator", () => $f538dc12d855c47e$export$d2cd8239f99c13d3);
$parcel$export(module.exports, "notClauseOperatorInternal", () => $f538dc12d855c47e$export$1b15a32bb57b9020);

var $k85ht = parcelRequire("k85ht");

var $8vd0B = parcelRequire("8vd0B");
function $f538dc12d855c47e$var$acceptNotClauseOperator(visitor) {
    return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
}
function $f538dc12d855c47e$var$enterNode(listener) {
    listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
}
function $f538dc12d855c47e$var$exitNode(listener) {
    listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
}
const $f538dc12d855c47e$export$d2cd8239f99c13d3 = ()=>$f538dc12d855c47e$export$1b15a32bb57b9020();
const $f538dc12d855c47e$export$1b15a32bb57b9020 = (position = null)=>({
        value: (0, $k85ht.CLAUSE_OPERATOR_NOT),
        position: position,
        accept: $f538dc12d855c47e$var$acceptNotClauseOperator,
        enterNode: $f538dc12d855c47e$var$enterNode,
        exitNode: $f538dc12d855c47e$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});
parcelRegister("k85ht", function(module, exports) {

$parcel$export(module.exports, "CLAUSE_OPERATOR_NOT", () => $e007b5b5543cc378$export$c6c71ceedb15cda9);
$parcel$export(module.exports, "OPERATOR_EQUALS", () => $e007b5b5543cc378$export$466517a888d00195);
$parcel$export(module.exports, "OPERATOR_NOT_EQUALS", () => $e007b5b5543cc378$export$6d0d8810623974a5);
$parcel$export(module.exports, "OPERATOR_GT", () => $e007b5b5543cc378$export$bcbb090ab3c498b3);
$parcel$export(module.exports, "OPERATOR_LT", () => $e007b5b5543cc378$export$4bf1a4aa659c6ea4);
$parcel$export(module.exports, "OPERATOR_GT_EQUALS", () => $e007b5b5543cc378$export$83ce674214a54b2a);
$parcel$export(module.exports, "OPERATOR_LT_EQUALS", () => $e007b5b5543cc378$export$9629fd1727ef62ee);
$parcel$export(module.exports, "OPERATOR_IN", () => $e007b5b5543cc378$export$c4e3fb55e320e979);
$parcel$export(module.exports, "OPERATOR_NOT_IN", () => $e007b5b5543cc378$export$f9857532eaa24ddc);
$parcel$export(module.exports, "OPERATOR_LIKE", () => $e007b5b5543cc378$export$221595834b8766ab);
$parcel$export(module.exports, "OPERATOR_NOT_LIKE", () => $e007b5b5543cc378$export$fcefabf94a9bffbf);
$parcel$export(module.exports, "OPERATOR_IS", () => $e007b5b5543cc378$export$4feeb3f4ff56bcef);
$parcel$export(module.exports, "OPERATOR_IS_NOT", () => $e007b5b5543cc378$export$d08d969a0da27188);
$parcel$export(module.exports, "OPERATOR_WAS", () => $e007b5b5543cc378$export$8f907e179985256d);
$parcel$export(module.exports, "OPERATOR_WAS_IN", () => $e007b5b5543cc378$export$cc7b9d0b3ee23193);
$parcel$export(module.exports, "OPERATOR_WAS_NOT_IN", () => $e007b5b5543cc378$export$585d3c004af078bb);
$parcel$export(module.exports, "OPERATOR_WAS_NOT", () => $e007b5b5543cc378$export$123eaa9ccc2d9445);
$parcel$export(module.exports, "OPERATOR_CHANGED", () => $e007b5b5543cc378$export$15f5b446ba8c941e);
$parcel$export(module.exports, "EQUALS_OPERATORS", () => $e007b5b5543cc378$export$643c6101f3fc8547);
$parcel$export(module.exports, "LIKE_OPERATORS", () => $e007b5b5543cc378$export$329664c9cf18cca6);
$parcel$export(module.exports, "COMPARISON_OPERATORS", () => $e007b5b5543cc378$export$1b167a3705885a8b);
$parcel$export(module.exports, "IN_OPERATORS", () => $e007b5b5543cc378$export$f25cf16c2270312f);
$parcel$export(module.exports, "IS_OPERATORS", () => $e007b5b5543cc378$export$eb58cfffe4a6b805);
$parcel$export(module.exports, "WAS_OPERATORS", () => $e007b5b5543cc378$export$c22a981f581de218);
$parcel$export(module.exports, "WAS_IN_OPERATORS", () => $e007b5b5543cc378$export$6d08c4699bb75284);
$parcel$export(module.exports, "CHANGED_OPERATORS", () => $e007b5b5543cc378$export$b7dc214eef214c1c);
$parcel$export(module.exports, "OPERATORS", () => $e007b5b5543cc378$export$184799fc79ccac89);
$parcel$export(module.exports, "LIST_OPERATORS", () => $e007b5b5543cc378$export$77c793736847e030);
const $e007b5b5543cc378$export$c6c71ceedb15cda9 = 'not';
const $e007b5b5543cc378$export$466517a888d00195 = '=';
const $e007b5b5543cc378$export$6d0d8810623974a5 = '!=';
const $e007b5b5543cc378$export$bcbb090ab3c498b3 = '>';
const $e007b5b5543cc378$export$4bf1a4aa659c6ea4 = '<';
const $e007b5b5543cc378$export$83ce674214a54b2a = '>=';
const $e007b5b5543cc378$export$9629fd1727ef62ee = '<=';
const $e007b5b5543cc378$export$c4e3fb55e320e979 = 'in';
const $e007b5b5543cc378$export$f9857532eaa24ddc = 'not in';
const $e007b5b5543cc378$export$221595834b8766ab = '~';
const $e007b5b5543cc378$export$fcefabf94a9bffbf = '!~';
const $e007b5b5543cc378$export$4feeb3f4ff56bcef = 'is';
const $e007b5b5543cc378$export$d08d969a0da27188 = 'is not';
const $e007b5b5543cc378$export$8f907e179985256d = 'was';
const $e007b5b5543cc378$export$cc7b9d0b3ee23193 = 'was in';
const $e007b5b5543cc378$export$585d3c004af078bb = 'was not in';
const $e007b5b5543cc378$export$123eaa9ccc2d9445 = 'was not';
const $e007b5b5543cc378$export$15f5b446ba8c941e = 'changed';
const $e007b5b5543cc378$export$643c6101f3fc8547 = [
    $e007b5b5543cc378$export$466517a888d00195,
    $e007b5b5543cc378$export$6d0d8810623974a5
];
const $e007b5b5543cc378$export$329664c9cf18cca6 = [
    $e007b5b5543cc378$export$221595834b8766ab,
    $e007b5b5543cc378$export$fcefabf94a9bffbf
];
const $e007b5b5543cc378$export$1b167a3705885a8b = [
    $e007b5b5543cc378$export$4bf1a4aa659c6ea4,
    $e007b5b5543cc378$export$bcbb090ab3c498b3,
    $e007b5b5543cc378$export$9629fd1727ef62ee,
    $e007b5b5543cc378$export$83ce674214a54b2a
];
const $e007b5b5543cc378$export$f25cf16c2270312f = [
    $e007b5b5543cc378$export$c4e3fb55e320e979,
    $e007b5b5543cc378$export$f9857532eaa24ddc
];
const $e007b5b5543cc378$export$eb58cfffe4a6b805 = [
    $e007b5b5543cc378$export$4feeb3f4ff56bcef,
    $e007b5b5543cc378$export$d08d969a0da27188
];
const $e007b5b5543cc378$export$c22a981f581de218 = [
    $e007b5b5543cc378$export$8f907e179985256d,
    $e007b5b5543cc378$export$123eaa9ccc2d9445
];
const $e007b5b5543cc378$export$6d08c4699bb75284 = [
    $e007b5b5543cc378$export$cc7b9d0b3ee23193,
    $e007b5b5543cc378$export$585d3c004af078bb
];
const $e007b5b5543cc378$export$b7dc214eef214c1c = [
    $e007b5b5543cc378$export$15f5b446ba8c941e
];
const $e007b5b5543cc378$export$184799fc79ccac89 = [
    ...$e007b5b5543cc378$export$643c6101f3fc8547,
    ...$e007b5b5543cc378$export$329664c9cf18cca6,
    ...$e007b5b5543cc378$export$1b167a3705885a8b,
    ...$e007b5b5543cc378$export$f25cf16c2270312f,
    ...$e007b5b5543cc378$export$eb58cfffe4a6b805,
    ...$e007b5b5543cc378$export$c22a981f581de218,
    ...$e007b5b5543cc378$export$6d08c4699bb75284,
    ...$e007b5b5543cc378$export$b7dc214eef214c1c
];
const $e007b5b5543cc378$export$77c793736847e030 = [
    $e007b5b5543cc378$export$c4e3fb55e320e979,
    $e007b5b5543cc378$export$f9857532eaa24ddc,
    $e007b5b5543cc378$export$cc7b9d0b3ee23193,
    $e007b5b5543cc378$export$585d3c004af078bb
];

});



parcelRegister("3T5iU", function(module, exports) {

$parcel$export(module.exports, "operator", () => $7c07e8aa040a847b$export$dbd72860f701d4f3);
$parcel$export(module.exports, "operatorInternal", () => $7c07e8aa040a847b$export$649025bc60ab9c3b);

var $8vd0B = parcelRequire("8vd0B");
function $7c07e8aa040a847b$var$acceptOperator(visitor) {
    return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
}
function $7c07e8aa040a847b$var$enterNode(listener) {
    listener.enterOperator && listener.enterOperator(this);
}
function $7c07e8aa040a847b$var$exitNode(listener) {
    listener.exitOperator && listener.exitOperator(this);
}
const $7c07e8aa040a847b$export$dbd72860f701d4f3 = (value)=>$7c07e8aa040a847b$export$649025bc60ab9c3b(value, value);
const $7c07e8aa040a847b$export$649025bc60ab9c3b = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $7c07e8aa040a847b$var$acceptOperator,
        enterNode: $7c07e8aa040a847b$var$enterNode,
        exitNode: $7c07e8aa040a847b$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("8Tr0t", function(module, exports) {

$parcel$export(module.exports, "orderBy", () => $c827a275c8f59b6f$export$f18af21d6f4dafd8);
$parcel$export(module.exports, "orderByInternal", () => $c827a275c8f59b6f$export$e4eb1fa6bc8465c1);


var $1lC8l = parcelRequire("1lC8l");

var $8vd0B = parcelRequire("8vd0B");

var $i2yZF = parcelRequire("i2yZF");
function $c827a275c8f59b6f$var$acceptOrderBy(visitor) {
    return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
}
function $c827a275c8f59b6f$var$enterNode(listener) {
    listener.enterOrderBy && listener.enterOrderBy(this);
}
function $c827a275c8f59b6f$var$exitNode(listener) {
    listener.exitOrderBy && listener.exitOrderBy(this);
}
function $c827a275c8f59b6f$var$getChildren() {
    return [
        this.operator,
        ...this.fields
    ];
}
const $c827a275c8f59b6f$export$f18af21d6f4dafd8 = (fields)=>{
    return $c827a275c8f59b6f$export$e4eb1fa6bc8465c1(fields, (0, $i2yZF.orderByOperator)());
};
const $c827a275c8f59b6f$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$da0f73edded4a63d),
        operator: operator,
        fields: fields,
        position: position,
        accept: $c827a275c8f59b6f$var$acceptOrderBy,
        enterNode: $c827a275c8f59b6f$var$enterNode,
        exitNode: $c827a275c8f59b6f$var$exitNode,
        getChildren: $c827a275c8f59b6f$var$getChildren,
        parent: null,
        prependOrderField: $1lC8l.prependOrderField,
        setOrderDirection: $1lC8l.setOrderDirection,
        replace: $1lC8l.replace,
        replaceOrderField: $1lC8l.replaceOrderField,
        remove: $1lC8l.remove,
        removeOrderField: $1lC8l.removeOrderField
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("1lC8l", function(module, exports) {

$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceOrderField", () => replaceOrderField);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeOrderField", () => removeOrderField);

var $8vd0B = parcelRequire("8vd0B");
function prependOrderField(orderField) {
    this.fields.unshift(orderField);
    (0, $8vd0B.assignParent)(this);
}
function setOrderDirection(orderDirection) {
    if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
}
function replace(nextOrderBy) {
    if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
}
function replaceOrderField(orderByField, nextOrderByField) {
    this.fields = this.fields.map((child)=>{
        return child === orderByField ? nextOrderByField : child;
    });
    (0, $8vd0B.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeOrderBy();
}
function removeOrderField(orderByField) {
    this.fields = this.fields.filter((field)=>field !== orderByField);
    if (this.fields.length === 0) this.remove();
}

});

parcelRegister("i2yZF", function(module, exports) {

$parcel$export(module.exports, "orderByOperator", () => $fa7d19490b4ecf54$export$c7307b67924c61ea);
$parcel$export(module.exports, "orderByOperatorInternal", () => $fa7d19490b4ecf54$export$739e30af23a08da0);


var $8vd0B = parcelRequire("8vd0B");
function $fa7d19490b4ecf54$var$acceptOrderByOperator(visitor) {
    return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
}
function $fa7d19490b4ecf54$var$enterNode(listener) {
    listener.enterOrderByOperator && listener.enterOrderByOperator(this);
}
function $fa7d19490b4ecf54$var$exitNode(listener) {
    listener.exitOrderByOperator && listener.exitOrderByOperator(this);
}
const $fa7d19490b4ecf54$export$c7307b67924c61ea = ()=>$fa7d19490b4ecf54$export$739e30af23a08da0();
const $fa7d19490b4ecf54$export$739e30af23a08da0 = (position = null)=>({
        value: (0, $e28fa7cc527af49f$export$ca51f5fd60a74517),
        position: position,
        accept: $fa7d19490b4ecf54$var$acceptOrderByOperator,
        enterNode: $fa7d19490b4ecf54$var$enterNode,
        exitNode: $fa7d19490b4ecf54$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});
const $e28fa7cc527af49f$export$ca51f5fd60a74517 = 'ORDER BY';
const $e28fa7cc527af49f$export$6d60017b9e092e73 = 'ASC';
const $e28fa7cc527af49f$export$2ea27ea5f2121899 = 'DESC';



parcelRegister("1R1xk", function(module, exports) {

$parcel$export(module.exports, "orderByDirection", () => $21aa5b2783962a5d$export$864d934efed3ccaa);
$parcel$export(module.exports, "orderByDirectionInternal", () => $21aa5b2783962a5d$export$8c65cac1a7852d1f);

var $8vd0B = parcelRequire("8vd0B");
function $21aa5b2783962a5d$var$acceptOrderByDirection(visitor) {
    return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
}
function $21aa5b2783962a5d$var$enterNode(listener) {
    listener.enterOrderByDirection && listener.enterOrderByDirection(this);
}
function $21aa5b2783962a5d$var$exitNode(listener) {
    listener.exitOrderByDirection && listener.exitOrderByDirection(this);
}
const $21aa5b2783962a5d$export$864d934efed3ccaa = (value)=>$21aa5b2783962a5d$export$8c65cac1a7852d1f(value);
const $21aa5b2783962a5d$export$8c65cac1a7852d1f = (value, position = null)=>({
        value: value,
        position: position,
        accept: $21aa5b2783962a5d$var$acceptOrderByDirection,
        enterNode: $21aa5b2783962a5d$var$enterNode,
        exitNode: $21aa5b2783962a5d$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("eHzms", function(module, exports) {

$parcel$export(module.exports, "orderByField", () => $d06d39ae8044bfe9$export$942df63e5e3d3899);
$parcel$export(module.exports, "orderByFieldInternal", () => $d06d39ae8044bfe9$export$661a7786e3d15926);

var $7dx7z = parcelRequire("7dx7z");

var $8vd0B = parcelRequire("8vd0B");
function $d06d39ae8044bfe9$var$acceptOrderByField(visitor) {
    return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
}
function $d06d39ae8044bfe9$var$enterNode(listener) {
    listener.enterOrderByField && listener.enterOrderByField(this);
}
function $d06d39ae8044bfe9$var$exitNode(listener) {
    listener.exitOrderByField && listener.exitOrderByField(this);
}
function $d06d39ae8044bfe9$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.direction) children.push(this.direction);
    return children;
}
const $d06d39ae8044bfe9$export$942df63e5e3d3899 = (field, direction)=>$d06d39ae8044bfe9$export$661a7786e3d15926(field, direction);
const $d06d39ae8044bfe9$export$661a7786e3d15926 = (field, direction, position = null)=>{
    const node = {
        field: field,
        direction: direction,
        position: position,
        accept: $d06d39ae8044bfe9$var$acceptOrderByField,
        enterNode: $d06d39ae8044bfe9$var$enterNode,
        exitNode: $d06d39ae8044bfe9$var$exitNode,
        getChildren: $d06d39ae8044bfe9$var$getChildren,
        parent: null,
        setOrderDirection: $7dx7z.setOrderDirection,
        replace: $7dx7z.replace,
        remove: $7dx7z.remove
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("7dx7z", function(module, exports) {

$parcel$export(module.exports, "setOrderDirection", () => $6807a3abf64eb81e$export$b596730931a09703);
$parcel$export(module.exports, "replace", () => $6807a3abf64eb81e$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "remove", () => $6807a3abf64eb81e$export$cd7f480d6b8286c3);

var $8vd0B = parcelRequire("8vd0B");
function $6807a3abf64eb81e$export$b596730931a09703(orderDirection) {
    this.direction = orderDirection;
    (0, $8vd0B.assignParent)(this);
}
function $6807a3abf64eb81e$export$77ad94ebf1c2b9ed(orderByField) {
    if (this.parent) this.parent.replaceOrderField(this, orderByField);
}
function $6807a3abf64eb81e$export$cd7f480d6b8286c3() {
    if (this.parent) this.parent.removeOrderField(this);
}

});


parcelRegister("3fSGD", function(module, exports) {

$parcel$export(module.exports, "predicate", () => $462e396b7fd5655b$export$5fc51e445ce24faf);
$parcel$export(module.exports, "predicateInternal", () => $462e396b7fd5655b$export$a767a27ad05a38a2);

var $8vd0B = parcelRequire("8vd0B");
function $462e396b7fd5655b$var$acceptPredicate(visitor) {
    return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
}
function $462e396b7fd5655b$var$enterNode(listener) {
    listener.enterPredicate && listener.enterPredicate(this);
}
function $462e396b7fd5655b$var$exitNode(listener) {
    listener.exitPredicate && listener.exitPredicate(this);
}
function $462e396b7fd5655b$var$getChildren() {
    const children = [
        this.operator
    ];
    if (this.operand) children.push(this.operand);
    return children;
}
const $462e396b7fd5655b$export$5fc51e445ce24faf = (operator, operand)=>$462e396b7fd5655b$export$a767a27ad05a38a2(operator, operand);
const $462e396b7fd5655b$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
    const node = {
        operator: operator,
        operand: operand,
        position: position,
        accept: $462e396b7fd5655b$var$acceptPredicate,
        enterNode: $462e396b7fd5655b$var$enterNode,
        exitNode: $462e396b7fd5655b$var$exitNode,
        getChildren: $462e396b7fd5655b$var$getChildren,
        parent: null
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});

parcelRegister("jvsC0", function(module, exports) {

$parcel$export(module.exports, "predicateOperator", () => $887e537fbec545f7$export$5419b7f16910ea62);
$parcel$export(module.exports, "predicateOperatorInternal", () => $887e537fbec545f7$export$c69d893689716768);

var $8vd0B = parcelRequire("8vd0B");
function $887e537fbec545f7$var$acceptPredicateOperator(visitor) {
    return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
}
function $887e537fbec545f7$var$enterNode(listener) {
    listener.enterPredicateOperator && listener.enterPredicateOperator(this);
}
function $887e537fbec545f7$var$exitNode(listener) {
    listener.exitPredicateOperator && listener.exitPredicateOperator(this);
}
const $887e537fbec545f7$export$5419b7f16910ea62 = (value)=>$887e537fbec545f7$export$c69d893689716768(value, value);
const $887e537fbec545f7$export$c69d893689716768 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $887e537fbec545f7$var$acceptPredicateOperator,
        enterNode: $887e537fbec545f7$var$enterNode,
        exitNode: $887e537fbec545f7$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("bdP2p", function(module, exports) {

$parcel$export(module.exports, "property", () => $f08fc38c9f10e3ce$export$d541bacb2bda4494);
$parcel$export(module.exports, "propertyInternal", () => $f08fc38c9f10e3ce$export$1cbd90994fef1fad);

var $8vd0B = parcelRequire("8vd0B");
function $f08fc38c9f10e3ce$var$acceptProperty(visitor) {
    return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
}
function $f08fc38c9f10e3ce$var$enterNode(listener) {
    listener.enterProperty && listener.enterProperty(this);
}
function $f08fc38c9f10e3ce$var$exitNode(listener) {
    listener.exitProperty && listener.exitProperty(this);
}
function $f08fc38c9f10e3ce$var$getChildren() {
    const children = [];
    if (this.key) children.push(this.key);
    if (this.path) return children.concat(this.path);
    return children;
}
const $f08fc38c9f10e3ce$export$d541bacb2bda4494 = (key, path = [])=>$f08fc38c9f10e3ce$export$1cbd90994fef1fad(key, path);
const $f08fc38c9f10e3ce$export$1cbd90994fef1fad = (key, path, position = null)=>{
    const node = {
        key: key,
        path: path,
        position: position,
        accept: $f08fc38c9f10e3ce$var$acceptProperty,
        enterNode: $f08fc38c9f10e3ce$var$enterNode,
        exitNode: $f08fc38c9f10e3ce$var$exitNode,
        getChildren: $f08fc38c9f10e3ce$var$getChildren,
        parent: null
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});

parcelRegister("1Rz9E", function(module, exports) {

$parcel$export(module.exports, "query", () => $107f0c7ef22c6060$export$2fa187e846a241c4);
$parcel$export(module.exports, "queryInternal", () => $107f0c7ef22c6060$export$bc2d6e2e1fd9014);


var $kqYul = parcelRequire("kqYul");

var $8vd0B = parcelRequire("8vd0B");
/**
 * AstNode accept functions. We define them outside of the creator function so the same function reference is returned
 * when a creator is invoked multiple times (which is helpful when testing for equality of AST objects).
 */ function $107f0c7ef22c6060$var$acceptQuery(visitor) {
    return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
}
function $107f0c7ef22c6060$var$enterNode(listener) {
    listener.enterQuery && listener.enterQuery(this);
}
function $107f0c7ef22c6060$var$exitNode(listener) {
    listener.exitQuery && listener.exitQuery(this);
}
function $107f0c7ef22c6060$var$getChildren() {
    const children = [];
    if (this.where) children.push(this.where);
    if (this.orderBy) children.push(this.orderBy);
    return children;
}
const $107f0c7ef22c6060$export$2fa187e846a241c4 = (where, orderBy)=>$107f0c7ef22c6060$export$bc2d6e2e1fd9014(where, orderBy);
const $107f0c7ef22c6060$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$98dda21ec825792),
        where: where,
        orderBy: orderBy,
        position: position,
        accept: $107f0c7ef22c6060$var$acceptQuery,
        enterNode: $107f0c7ef22c6060$var$enterNode,
        exitNode: $107f0c7ef22c6060$var$exitNode,
        getChildren: $107f0c7ef22c6060$var$getChildren,
        parent: null,
        appendClause: $kqYul.appendClause,
        prependOrderField: $kqYul.prependOrderField,
        setOrderDirection: $kqYul.setOrderDirection,
        removeClause: $kqYul.removeClause,
        replaceClause: $kqYul.replaceClause,
        replaceOrderBy: $kqYul.replaceOrderBy,
        removeOrderBy: $kqYul.removeOrderBy
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("kqYul", function(module, exports) {

$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replaceOrderBy", () => replaceOrderBy);
$parcel$export(module.exports, "replaceClause", () => replaceClause);
$parcel$export(module.exports, "removeOrderBy", () => removeOrderBy);

var $ehDeP = parcelRequire("ehDeP");

var $8vd0B = parcelRequire("8vd0B");
function appendClause(clause, compoundOperatorValue) {
    if (!this.where) this.where = clause;
    else {
        const nextCompoundOperator = (0, $ehDeP.default).compoundOperator(compoundOperatorValue);
        const nextClause = (0, $ehDeP.default).compoundClause(nextCompoundOperator, []);
        // Append previous and new clause which will flatten compound clauses with matching operators.
        nextClause.appendClause(this.where);
        nextClause.appendClause(clause);
        this.where = nextClause;
    }
    (0, $8vd0B.assignParent)(this);
}
function prependOrderField(orderField) {
    if (!this.orderBy) {
        this.orderBy = (0, $ehDeP.default).orderBy([
            orderField
        ]);
        (0, $8vd0B.assignParent)(this);
    } else this.orderBy.prependOrderField(orderField);
}
function setOrderDirection(orderDirection) {
    if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
}
function removeClause(clause) {
    if (this.where === clause) this.where = undefined;
}
function replaceOrderBy(orderBy) {
    if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
    else {
        this.orderBy = orderBy;
        (0, $8vd0B.assignParent)(this);
    }
}
function replaceClause(clause, nextClause) {
    if (this.where === clause) {
        this.where = nextClause;
        (0, $8vd0B.assignParent)(this);
    }
}
function removeOrderBy() {
    this.orderBy = undefined;
}

});


parcelRegister("5o1cq", function(module, exports) {

$parcel$export(module.exports, "terminalClause", () => $ca791fbc90fc759d$export$2627cbe08dd86b00);
$parcel$export(module.exports, "terminalClauseInternal", () => $ca791fbc90fc759d$export$cc08e43598d091fc);


var $iKO2u = parcelRequire("iKO2u");

var $8vd0B = parcelRequire("8vd0B");
function $ca791fbc90fc759d$var$acceptTerminalClause(visitor) {
    return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
}
function $ca791fbc90fc759d$var$enterNode(listener) {
    listener.enterTerminalClause && listener.enterTerminalClause(this);
}
function $ca791fbc90fc759d$var$exitNode(listener) {
    listener.exitTerminalClause && listener.exitTerminalClause(this);
}
function $ca791fbc90fc759d$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.operator) children.push(this.operator);
    if (this.operand) children.push(this.operand);
    return children.concat(this.predicates);
}
const $ca791fbc90fc759d$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
    return $ca791fbc90fc759d$export$cc08e43598d091fc(field, operator, operand, predicates);
};
const $ca791fbc90fc759d$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$2d205682cc545947),
        clauseType: (0, $35634e4e5a46f5ae$export$ae56b4ef248a2b6a),
        field: field,
        operator: operator,
        operand: operand,
        predicates: predicates,
        position: position,
        accept: $ca791fbc90fc759d$var$acceptTerminalClause,
        enterNode: $ca791fbc90fc759d$var$enterNode,
        exitNode: $ca791fbc90fc759d$var$exitNode,
        getChildren: $ca791fbc90fc759d$var$getChildren,
        parent: null,
        setOperator: $iKO2u.setOperator,
        setOperand: $iKO2u.setOperand,
        appendOperand: $iKO2u.appendOperand,
        remove: $iKO2u.remove,
        replace: $iKO2u.replace
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("iKO2u", function(module, exports) {

$parcel$export(module.exports, "setOperator", () => setOperator);
$parcel$export(module.exports, "setOperand", () => setOperand);
$parcel$export(module.exports, "appendOperand", () => appendOperand);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replace", () => replace);


var $ehDeP = parcelRequire("ehDeP");

var $8vd0B = parcelRequire("8vd0B");
function setOperator(operator) {
    this.operator = operator;
    (0, $8vd0B.assignParent)(this);
}
function setOperand(operand) {
    this.operand = operand;
    (0, $8vd0B.assignParent)(this);
}
function appendOperand(operand) {
    if (this.operand) {
        if (this.operand.operandType === (0, $807962b43ef03b56$export$fabec4aebba3f4df)) this.operand.appendOperand(operand);
        else this.setOperand((0, $ehDeP.default).listOperand([
            this.operand,
            ...operand.operandType === (0, $807962b43ef03b56$export$fabec4aebba3f4df) ? operand.values : [
                operand
            ]
        ]));
    } else this.setOperand(operand);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}

});


parcelRegister("4VxAa", function(module, exports) {

$parcel$export(module.exports, "valueOperand", () => $097471b9dc7f0edf$export$2b6e4d2ed8d53bf3);
$parcel$export(module.exports, "valueOperandInternal", () => $097471b9dc7f0edf$export$79c37d97caac8627);
$parcel$export(module.exports, "valueOperandByText", () => $097471b9dc7f0edf$export$3ac9155bde56a45f);


var $g2nfy = parcelRequire("g2nfy");
var $tI64Y = parcelRequire("tI64Y");

var $8vd0B = parcelRequire("8vd0B");
function $097471b9dc7f0edf$var$acceptValueOperand(visitor) {
    return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
}
function $097471b9dc7f0edf$var$enterNode(listener) {
    listener.enterValueOperand && listener.enterValueOperand(this);
}
function $097471b9dc7f0edf$var$exitNode(listener) {
    listener.exitValueOperand && listener.exitValueOperand(this);
}
const $097471b9dc7f0edf$export$2b6e4d2ed8d53bf3 = (value)=>$097471b9dc7f0edf$export$79c37d97caac8627(value, (0, $tI64Y.sanitiseJqlString)(value));
const $097471b9dc7f0edf$export$3ac9155bde56a45f = (text)=>$097471b9dc7f0edf$export$79c37d97caac8627((0, $g2nfy.normaliseJqlString)(text), text);
const $097471b9dc7f0edf$export$79c37d97caac8627 = (value, text, position = null)=>({
        type: (0, $4dac9dd1966bb7dd$export$d2f212d8ddbc8d1d),
        operandType: (0, $807962b43ef03b56$export$38accfc5a5d1c113),
        text: text,
        value: value,
        position: position,
        accept: $097471b9dc7f0edf$var$acceptValueOperand,
        enterNode: $097471b9dc7f0edf$var$enterNode,
        exitNode: $097471b9dc7f0edf$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});


parcelRegister("lmIUR", function(module, exports) {

$parcel$export(module.exports, "print", () => $a9625f5ea61b2ada$export$c2d084dc44961371);

var $8dloj = parcelRequire("8dloj");

var $8VPLp = parcelRequire("8VPLp");

var $gGtGU = parcelRequire("gGtGU");
const $a9625f5ea61b2ada$export$c2d084dc44961371 = (jast, options = {})=>{
    return (0, $gGtGU.printDocToString)((0, $8VPLp.printAstToDoc)(jast, (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(options, [
        'operatorCase'
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(options, [
        'printWidth'
    ]));
};

});
parcelRegister("8VPLp", function(module, exports) {

$parcel$export(module.exports, "printAstToDoc", () => $d301c3605dc18477$export$f0ef38932978952);


var $6RWCB = parcelRequire("6RWCB");

var $6l51o = parcelRequire("6l51o");
const $d301c3605dc18477$var$formatOperator = (operator, operatorCase)=>{
    switch(operatorCase){
        case 'lower':
            return operator.toLowerCase();
        case 'upper':
            return operator.toUpperCase();
        case 'preserve':
            return operator;
    }
};
class $d301c3605dc18477$export$27a275559a5c8102 extends (0, $6RWCB.AbstractJastVisitor) {
    constructor({ operatorCase: operatorCase } = {}){
        super();
        this.operatorCase = operatorCase || 'preserve';
    }
    visitArgument(argument) {
        return argument.text;
    }
    /**
	 * Visit each of the provided nodes and form a new array with each `Doc` joined by the provided separator.
	 */ joinNodes(nodes, separator) {
        const docs = [];
        nodes.forEach((node)=>{
            if (separator !== undefined && docs.length > 0) docs.push(separator);
            docs.push(node.accept(this));
        });
        return docs;
    }
    visitCompoundClause(compoundClause) {
        const operatorDoc = compoundClause.operator.accept(this);
        const clauseDocs = [];
        compoundClause.clauses.forEach((clause)=>{
            if (clauseDocs.length > 0) clauseDocs.push((0, $6l51o.ifBreak)((0, $6l51o.newLine)(), ' '), operatorDoc, ' ');
            // Wrap nested compound clauses in parentheses
            if (clause.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
            else clauseDocs.push(clause.accept(this));
        });
        return (0, $6l51o.group)(clauseDocs);
    }
    visitCompoundOperator(compoundOperator) {
        return $d301c3605dc18477$var$formatOperator(compoundOperator.value, this.operatorCase);
    }
    visitField(field) {
        const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
        return (0, $6l51o.group)([
            field.text,
            ...propertyDocs
        ]);
    }
    visitFunction(functionString) {
        return functionString.text;
    }
    visitFunctionOperand(functionOperand) {
        const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
        return (0, $6l51o.group)([
            functionOperand.function.accept(this),
            '(',
            ...argumentDocs,
            ')'
        ]);
    }
    visitKeywordOperand(keywordOperand) {
        return keywordOperand.value;
    }
    visitListOperand(listOperand) {
        const operandDocs = this.joinNodes(listOperand.values, ', ');
        return (0, $6l51o.group)([
            '(',
            ...operandDocs,
            ')'
        ]);
    }
    visitOperator(operator) {
        return $d301c3605dc18477$var$formatOperator(operator.text, this.operatorCase);
    }
    visitOrderBy(orderBy) {
        const fieldDocs = this.joinNodes(orderBy.fields, ', ');
        return (0, $6l51o.group)([
            orderBy.operator.accept(this),
            ' ',
            ...fieldDocs
        ]);
    }
    visitOrderByDirection(orderByDirection) {
        return orderByDirection.value;
    }
    visitOrderByField(orderByField) {
        const docs = [
            orderByField.field.accept(this)
        ];
        if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
        return (0, $6l51o.group)(docs);
    }
    visitOrderByOperator(orderByOperator) {
        return $d301c3605dc18477$var$formatOperator(orderByOperator.value, this.operatorCase);
    }
    visitPredicate(predicate) {
        const docs = [
            predicate.operator.accept(this)
        ];
        if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
        return (0, $6l51o.group)(docs);
    }
    visitPredicateOperator(predicateOperator) {
        return $d301c3605dc18477$var$formatOperator(predicateOperator.text, this.operatorCase);
    }
    visitProperty(property) {
        const docs = [];
        if (property.key) docs.push('[', property.key.accept(this), ']');
        if (property.path) {
            const pathDocs = this.joinNodes(property.path, ' ');
            docs.push(...pathDocs);
        }
        return (0, $6l51o.group)(docs);
    }
    visitQuery(query) {
        if (query.where && query.orderBy) return (0, $6l51o.group)([
            query.where.accept(this),
            (0, $6l51o.ifBreak)((0, $6l51o.newLine)(), ' '),
            query.orderBy.accept(this)
        ]);
        else if (query.where) return query.where.accept(this);
        else if (query.orderBy) return query.orderBy.accept(this);
        return '';
    }
    visitTerminalClause(terminalClause) {
        const docs = [
            terminalClause.field.accept(this)
        ];
        if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
        if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
        terminalClause.predicates.forEach((predicate)=>{
            docs.push(' ', predicate.accept(this));
        });
        return (0, $6l51o.group)(docs);
    }
    visitValueOperand(valueOperand) {
        return valueOperand.text;
    }
    visitNotClause(notClause) {
        const clauseDocs = [];
        // Wrap nested compound clauses in parentheses
        if (notClause.clause.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
        else clauseDocs.push(notClause.clause.accept(this));
        return (0, $6l51o.group)([
            notClause.operator.accept(this),
            ' ',
            ...clauseDocs
        ]);
    }
    visitNotClauseOperator(notClauseOperator) {
        return notClauseOperator.value;
    }
    visitChildren() {
        throw new Error('Required visit method not implemented for node');
    }
    defaultResult() {
        return '';
    }
}
const $d301c3605dc18477$export$f0ef38932978952 = (jast, options)=>{
    const astToDocVisitor = new $d301c3605dc18477$export$27a275559a5c8102(options);
    return jast.query ? jast.query.accept(astToDocVisitor) : '';
};

});
parcelRegister("6RWCB", function(module, exports) {

$parcel$export(module.exports, "AbstractJastVisitor", () => $17ed1e3c7a9e2333$export$51be62b46ee668fd);
class $17ed1e3c7a9e2333$export$51be62b46ee668fd {
    /**
	 * The default implementation calls AstNode#accept on the specified node.
	 * @param node
	 */ visit(node) {
        return node.accept(this);
    }
    /**
	 * The default implementation initializes the aggregate result to defaultResult(). Before visiting each child, it
	 * calls shouldVisitNextChild; if the result is false no more children are visited and the current aggregate result is
	 * returned. After visiting a child, the aggregate result is updated by calling aggregateResult with the previous
	 * aggregate result and the result of visiting the child.
	 */ visitChildren(node) {
        let result = this.defaultResult();
        const children = node.getChildren();
        for(let i = 0; i < children.length; i++){
            if (!this.shouldVisitNextChild(node, result)) break;
            const childResult = children[i].accept(this);
            result = this.aggregateResult(result, childResult);
        }
        return result;
    }
    /**
	 * Aggregates the results of visiting multiple children of a node.
	 *
	 * The default implementation returns `nextResult`, meaning
	 * {@link #visitChildren} will return the result of the last child visited
	 * (or return the initial value if the node has no children).
	 *
	 * @param aggregate The previous aggregate value. In the default
	 * implementation, the aggregate value is initialized to
	 * {@link #defaultResult}, which is passed as the `aggregate` argument
	 * to this method after the first child node is visited.
	 * @param nextResult The result of the immediately preceeding call to visit
	 * a child node.
	 *
	 * @returns The updated aggregate result.
	 */ aggregateResult(aggregate, nextResult) {
        return nextResult;
    }
    /**
	 * This method is called before visiting each child in
	 * {@link #visitChildren}. When the method is first called\ `currentResult`
	 * will be the initial value (in the default implementation, the initial value
	 * is returned by a call to {@link #defaultResult}).
	 *
	 * The default implementation always returns `true`, indicating that
	 * `visitChildren` should only return after all children are visited.
	 * One reason to override this method is to provide a "short circuit"
	 * evaluation option for situations where the result of visiting a single
	 * child has the potential to determine the result of the visit operation as
	 * a whole.
	 *
	 * @param node The {@link AstNode} whose children are currently being
	 * visited.
	 * @param currentResult The current aggregate result of the children visited
	 * to the current point.
	 *
	 * @returns `true` to continue visiting children. Otherwise return
	 * `false` to stop visiting children and immediately return the
	 * current aggregate result from {@link #visitChildren}.
	 */ shouldVisitNextChild(node, currentResult) {
        return true;
    }
}

});

parcelRegister("6l51o", function(module, exports) {

$parcel$export(module.exports, "group", () => $505bf572d8c2f20e$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "ifBreak", () => $505bf572d8c2f20e$export$1db8e61901dcb0fa);
$parcel$export(module.exports, "newLine", () => $505bf572d8c2f20e$export$dc84f6841f96b7da);
const $505bf572d8c2f20e$export$e5e25fbcc1f7affe = (contents)=>{
    return {
        type: 'group',
        contents: contents
    };
};
const $505bf572d8c2f20e$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
    return {
        type: 'if-break',
        breakContents: breakContents,
        flatContents: flatContents
    };
};
const $505bf572d8c2f20e$export$dc84f6841f96b7da = ()=>{
    return {
        type: 'new-line'
    };
};

});


parcelRegister("gGtGU", function(module, exports) {

$parcel$export(module.exports, "printDocToString", () => $1adbb8b7e9dc2aa6$export$316fc7e94b95b118);
const $1adbb8b7e9dc2aa6$var$computeFlatWidth = (doc)=>{
    if (typeof doc === 'string') return doc.length;
    if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $1adbb8b7e9dc2aa6$var$computeFlatWidth(innerDoc), 0);
    switch(doc.type){
        case 'group':
            return $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc.contents);
        case 'if-break':
            return $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc.flatContents);
        case 'new-line':
            // TODO This probably represents a bug as we don't expect new lines in the flat path
            return 0;
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $1adbb8b7e9dc2aa6$var$printDoc = (doc, context)=>{
    if (typeof doc === 'string') return {
        result: doc,
        endIndex: context.startIndex + doc.length
    };
    switch(doc.type){
        case 'group':
            return $1adbb8b7e9dc2aa6$var$printGroup(doc, context);
        case 'if-break':
            return $1adbb8b7e9dc2aa6$var$printIfBreak(doc, context);
        case 'new-line':
            return $1adbb8b7e9dc2aa6$var$printNewLine();
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $1adbb8b7e9dc2aa6$var$printGroup = (doc, context)=>{
    const docWidth = context.startIndex + $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc);
    const breakContents = context.printWidth !== null && docWidth > context.printWidth;
    return doc.contents.reduce((agg, innerDoc)=>{
        const innerContext = {
            ...context,
            startIndex: agg.endIndex,
            breakContents: breakContents
        };
        const output = $1adbb8b7e9dc2aa6$var$printDoc(innerDoc, innerContext);
        return {
            result: agg.result + output.result,
            endIndex: output.endIndex
        };
    }, {
        result: '',
        endIndex: context.startIndex
    });
};
const $1adbb8b7e9dc2aa6$var$printIfBreak = (doc, context)=>{
    if (context.breakContents) return $1adbb8b7e9dc2aa6$var$printDoc(doc.breakContents, context);
    return $1adbb8b7e9dc2aa6$var$printDoc(doc.flatContents, context);
};
const $1adbb8b7e9dc2aa6$var$printNewLine = ()=>{
    return {
        result: '\n',
        // Reset our end index as a new line is being output.
        endIndex: 0
    };
};
// TODO Tweak this number with design
const $1adbb8b7e9dc2aa6$var$defaultPrintWidth = 100;
const $1adbb8b7e9dc2aa6$export$316fc7e94b95b118 = (doc, options = {})=>{
    const { printWidth: printWidth = $1adbb8b7e9dc2aa6$var$defaultPrintWidth } = options;
    const output = $1adbb8b7e9dc2aa6$var$printDoc(doc, {
        printWidth: printWidth,
        startIndex: 0,
        breakContents: false
    });
    return output.result;
};

});


parcelRegister("iflfC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b86c9802dc311999$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b86c9802dc311999$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.components.trigger-button",
        "defaultMessage": "See more components"
    }
});

});


parcelRegister("6ZTXj", function(module, exports) {

$parcel$export(module.exports, "DateCell", () => $a701bba12097bb91$export$64a69967f353bb7c);

var $knak0 = parcelRequire("knak0");

var $9LvXk = parcelRequire("9LvXk");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3xcI8 = parcelRequire("3xcI8");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $90IgZ = parcelRequire("90IgZ");

var $1hW8D = parcelRequire("1hW8D");

var $e9kDw = parcelRequire("e9kDw");

var $a4IeB = parcelRequire("a4IeB");

var $2qXcq = parcelRequire("2qXcq");
const $a701bba12097bb91$var$parseDate = (dateString)=>{
    if (dateString !== null && dateString !== '') {
        const date = (0, $3xcI8.default)(dateString);
        if (date.toString() !== 'Invalid Date') return date;
    }
    return null;
};
const $a701bba12097bb91$var$formattedDate = (dateString)=>{
    const date = $a701bba12097bb91$var$parseDate(dateString);
    if (!date) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90IgZ.FormattedDate), {
        value: date,
        year: "numeric",
        month: "short",
        day: "numeric"
    });
};
const $a701bba12097bb91$export$64a69967f353bb7c = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef, isRequired: isRequired })=>{
    const data = (0, $iWLL0.useFragment)(/* eslint-disable jira/relay/graphql-naming */ (0, $9LvXk.default), fieldRef);
    if (data.__typename === 'JiraDatePickerField' && data.fieldId === (0, $a4IeB.KNOWN_COLUMN_TYPES).DUE_DATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a701bba12097bb91$export$976ea8051f04575, {
        fieldRef: data
    });
    let date = null;
    if (data.__typename === 'JiraDatePickerField') date = data.date ?? null;
    else if (data.__typename === 'JiraDateTimePickerField') date = data.dateTime ?? null;
    if (isRequired && date == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "date",
        reason: "Missing required fields"
    });
    return (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a701bba12097bb91$var$wrapperStyles
    }, $a701bba12097bb91$var$formattedDate(date)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a701bba12097bb91$var$Wrapper, null, $a701bba12097bb91$var$formattedDate(date));
});
const $a701bba12097bb91$export$976ea8051f04575 = ({ fieldRef: fieldRef })=>{
    const data = (0, $iWLL0.useFragment)((0, $knak0.default), fieldRef); // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $e9kDw.useLazyLoadEditability)(data.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1hW8D.DateInlineEditViewWithIsEditable), {
        spacing: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? 'default' : undefined,
        editViewPopup: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo'),
        editViewPopupAlignBlock: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? 'center' : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a701bba12097bb91$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1i4q1hna",
            __cmplp.className
        ])
    });
});
const $a701bba12097bb91$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});
parcelRegister("knak0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d538c7f8fbb5644b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5348679d88409840cbc084cca6cb2abb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d538c7f8fbb5644b$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "date_nativeIssueTable_DateInlineEditCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraDatePickerField"
};
$d538c7f8fbb5644b$var$node.hash = "d355ad73c106c22099e54f46482d082c";
var $d538c7f8fbb5644b$export$2e2bcd8739ae039 = $d538c7f8fbb5644b$var$node;

});

parcelRegister("9LvXk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3942aab367801a3b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4f7957eb15e09b3ca778fbe5b6cecfb8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3942aab367801a3b$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "date_nativeIssueTable_DateCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "date"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "date_nativeIssueTable_DateInlineEditCell_fieldRef"
                }
            ],
            "type": "JiraDatePickerField"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "dateTime"
                }
            ],
            "type": "JiraDateTimePickerField"
        }
    ],
    "type": "JiraIssueField",
    "abstractKey": "__isJiraIssueField"
};
$3942aab367801a3b$var$node.hash = "7b89423f51f8c1066484f850cdda0694";
var $3942aab367801a3b$export$2e2bcd8739ae039 = $3942aab367801a3b$var$node;

});

parcelRegister("1hW8D", function(module, exports) {

$parcel$export(module.exports, "DateInlineEditViewWithIsEditable", () => $9ddf22400700f1a4$export$af387cb7b19f78a3);

var $6BgFP = parcelRequire("6BgFP");

var $iUbpV = parcelRequire("iUbpV");

var $67xZo = parcelRequire("67xZo");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $dMfuH = parcelRequire("dMfuH");

var $80RiQ = parcelRequire("80RiQ");

var $iQYHK = parcelRequire("iQYHK");

var $lt1uI = parcelRequire("lt1uI");

var $2iJOI = parcelRequire("2iJOI");
const $9ddf22400700f1a4$export$af387cb7b19f78a3 = (props)=>{
    const { spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, isEditing: isEditingProp = false, isEditable: isFieldEditable, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, fragmentRef: fragmentRef, readViewFitContainerHeight: readViewFitContainerHeight } = props;
    const data = (0, $iWLL0.useFragment)((0, $67xZo.default), fragmentRef);
    const [commit] = (0, $iWLL0.useMutation)((0, $iUbpV.default));
    const { id: uniqueFieldId, name: name, fieldConfig: fieldConfig } = data;
    const isFieldRequired = fieldConfig?.isRequired ?? false;
    const validator = (0, $2iJOI.useDateValidator)(name, isFieldRequired);
    const initialValue = data.date ?? null;
    const [updatedValue, setUpdatedValue] = (0, $eUqFw.useState)(initialValue);
    const handleSubmit = (0, $eUqFw.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        date: value,
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateDateField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateDateField: {
                        success: true,
                        errors: null,
                        field: {
                            date: value,
                            id: uniqueFieldId
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $iQYHK.useFieldInlineEditActions)({
        fieldId: uniqueFieldId,
        fieldName: name,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: isEditingProp,
        updatedValue: updatedValue,
        validator: validator
    });
    const renderReadView = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80RiQ.DateReadView), {
            fragmentRef: data
        }), [
        data
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? spacing : undefined,
            value: updatedValue,
            onChange: handleChange,
            isInvalid: !!invalidMessage,
            autoFocus: true
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lt1uI.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $dMfuH.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: name,
        hasUnsubmittedChanges: hasServerValidationError,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        invalidMessage: invalidMessage,
        hideActionButtons: true
    });
};
const $9ddf22400700f1a4$export$d1623660a0dc5b59 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $iWLL0.useFragment)((0, $6BgFP.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9ddf22400700f1a4$export$af387cb7b19f78a3, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("6BgFP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b63618139b37c945$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c7e4c91cc0608cf472bd3e81527b427>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b63618139b37c945$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "date_issueFieldDateInlineEditFull_DateInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraDatePickerField"
};
$b63618139b37c945$var$node.hash = "0548aa5d7a0a6ecdbe8581123c90487f";
var $b63618139b37c945$export$2e2bcd8739ae039 = $b63618139b37c945$var$node;

});

parcelRegister("iUbpV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c5b062499a61d3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3544f4fde4e58c3db63548472c851999>>
 * @relayHash 3f73c046ded86edefc83912b3cd5e2d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f4e94696fd29cf731c3234b50dbf74d91aa220d3c9064bbb1beb198ce6b790f4
const $d9c5b062499a61d3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "date"
    }, v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "date_issueFieldDate_DateField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraDatePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "date_issueFieldDate_DateField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraDatePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                },
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f4e94696fd29cf731c3234b50dbf74d91aa220d3c9064bbb1beb198ce6b790f4",
            "metadata": {},
            "name": "date_issueFieldDate_DateField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d9c5b062499a61d3$var$node.hash = "3265ff9f0b11e3ed4bac45dff405280d";
var $d9c5b062499a61d3$export$2e2bcd8739ae039 = $d9c5b062499a61d3$var$node;

});

parcelRegister("67xZo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2aa7f111641e8e1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<28170aba1b79ca6c952dfc3c42c379b5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b2aa7f111641e8e1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "date_issueFieldDateReadviewFull_DateReadView"
        },
        {
            "kind": "ScalarField",
            "name": "date"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        }
    ],
    "type": "JiraDatePickerField"
};
$b2aa7f111641e8e1$var$node.hash = "888605ab2705bc81c402809f625fe0c5";
var $b2aa7f111641e8e1$export$2e2bcd8739ae039 = $b2aa7f111641e8e1$var$node;

});

parcelRegister("dMfuH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c27aa61eabb57500$export$2e2bcd8739ae039);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $c27aa61eabb57500$var$DateEditViewEntryPoint = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("6cI1F")), {
        moduleId: "652b5c22"
    }),
    getPreloadProps: ()=>({})
});
var $c27aa61eabb57500$export$2e2bcd8739ae039 = $c27aa61eabb57500$var$DateEditViewEntryPoint;

});
parcelRegister("6cI1F", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('7Xdfs')
        ]);
        const value = parcelRequire('jfqr6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("7Xdfs")
    ]).then(()=>parcelRequire('jfqr6'));
}

});


parcelRegister("80RiQ", function(module, exports) {

$parcel$export(module.exports, "DateReadView", () => $117e0cca4b9e5cd6$export$c663acc1a0b7c5a9);

var $ugnlA = parcelRequire("ugnlA");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $cRXCh = parcelRequire("cRXCh");

var $6v322 = parcelRequire("6v322");
const $117e0cca4b9e5cd6$export$c663acc1a0b7c5a9 = ({ fragmentRef: fragmentRef })=>{
    const { formatDateOnly: formatDateOnly } = (0, $6v322.useDateTimeFormatter)();
    const data = (0, $iWLL0.useFragment)((0, $ugnlA.default), fragmentRef);
    const { date: date } = data || {};
    if (!date) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cRXCh.EmptyFieldText), null);
    return (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $117e0cca4b9e5cd6$var$dateReadViewStyles
    }, formatDateOnly(date)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatDateOnly(date));
};
const $117e0cca4b9e5cd6$var$dateReadViewStyles = (0, $1ZAYh.xcss)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});
parcelRegister("ugnlA", function(module, exports) {

$parcel$export(module.exports, "default", () => $25b30825acae0704$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<95b885d98116415e04b7330ebc0d66c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $25b30825acae0704$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "date_issueFieldDateReadviewFull_DateReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "date"
        }
    ],
    "type": "JiraDatePickerField"
};
$25b30825acae0704$var$node.hash = "d7db56777519dc6f4756e8e006032b0d";
var $25b30825acae0704$export$2e2bcd8739ae039 = $25b30825acae0704$var$node;

});


parcelRegister("2iJOI", function(module, exports) {

$parcel$export(module.exports, "useDateValidator", () => $f47d5fac95757910$export$bb028423d75e7237);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jx7MN = parcelRequire("jx7MN");
const $f47d5fac95757910$export$bb028423d75e7237 = (fieldName, isRequired)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const submit = (0, $eUqFw.useCallback)((value)=>{
        if (isRequired && (!value || value.trim().length === 0)) return {
            type: 'error',
            message: formatMessage((0, $jx7MN.messages).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        submit: submit
    };
};

});
parcelRegister("jx7MN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c7dfe3301052ed20$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c7dfe3301052ed20$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    requiredErrorMessage: {
        "id": "issue-field-date-inline-edit-full.date.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});

});




parcelRegister("kog7M", function(module, exports) {

$parcel$export(module.exports, "EpicLinkCell", () => $306018082896d9eb$export$6c1071448075813f);

var $6eGmS = parcelRequire("6eGmS");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lPQPn = parcelRequire("lPQPn");
var $tgbCK = parcelRequire("tgbCK");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2qXcq = parcelRequire("2qXcq");

var $dOu5P = parcelRequire("dOu5P");
const $306018082896d9eb$var$getLozengeThemes = (0, $lPQPn.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $306018082896d9eb$var$getLozengeThemeByColor = (color = (0, $tgbCK.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $306018082896d9eb$var$getLozengeThemes[color] ?? $306018082896d9eb$var$getLozengeThemes[0, $tgbCK.DEFAULT_EPIC_COLOR]; // type assertion is fine as the record key is of type Color
const $306018082896d9eb$var$findColor = (color)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys((0, $tgbCK.MAP_COLOR_TO_AK_COLOR)).find((key)=>(0, $tgbCK.MAP_COLOR_TO_AK_COLOR)[key] === color);
const $306018082896d9eb$export$6c1071448075813f = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { epic: epic } = (0, $iWLL0.useFragment)((0, $6eGmS.default), fieldRef);
    if (!epic) return null;
    if (epic.key == null || epic.summary == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "epicLink",
        reason: "Missing required fields"
    });
    const epicColor = (0, $lPQPn.asColor)(epic.color);
    const tagColor = (0, $tgbCK.MAP_COLOR_TO_AK_COLOR)[epicColor];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($306018082896d9eb$var$TagWrapper, {
        href: `/browse/${epic.key}`,
        "aria-label": `${formatMessage((0, $dOu5P.default).epicTitle)} ${epic.summary}`,
        style: $306018082896d9eb$var$getLozengeThemeByColor($306018082896d9eb$var$findColor(tagColor)),
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'tableIssueLink');
        }
    }, epic.summary);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $306018082896d9eb$var$TagWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _s7n4nkob _vwz4kb7n _1yt41b66 _1wybdlk8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c _2rko1l7b _9oik18uv _1bnx8stv _jf4cnqa1",
            (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? "_p12f1osq _vchhusvi" : "_p12fmgvx",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6eGmS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c311326c49d75576$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cbbefe241979b3de7277fee2ab84498c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c311326c49d75576$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "epicLink_nativeIssueTable_EpicLinkCell",
    "selections": [
        {
            "concreteType": "JiraEpic",
            "kind": "LinkedField",
            "name": "epic",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "kind": "ScalarField",
                    "name": "color"
                }
            ]
        }
    ],
    "type": "JiraEpicLinkField"
};
$c311326c49d75576$var$node.hash = "0d48d484eeec312fafb57f96f453cf0f";
var $c311326c49d75576$export$2e2bcd8739ae039 = $c311326c49d75576$var$node;

});

parcelRegister("dOu5P", function(module, exports) {

$parcel$export(module.exports, "default", () => $feb80197c12e23be$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $feb80197c12e23be$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    epicTitle: {
        "id": "native-issue-table.common.issue-cells.epic-link.epic-title",
        "defaultMessage": "Click to visit"
    }
});

});


parcelRegister("bq081", function(module, exports) {

$parcel$export(module.exports, "FallbackCell", () => $9e61d320203f0459$export$de9d519be820a473);

var $665cO = parcelRequire("665cO");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $2qXcq = parcelRequire("2qXcq");
const $9e61d320203f0459$export$de9d519be820a473 = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef })=>{
    const { renderedFieldHtml: renderedFieldHtml, type: type } = (0, $iWLL0.useFragment)((0, $665cO.default), fieldRef);
    if (renderedFieldHtml == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "fallback",
        reason: "Missing required fields"
    });
    switch(type){
        case 'thumbnail':
            return (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e61d320203f0459$var$AttachmentFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.attachment-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.div" // eslint-disable-next-line react/no-danger
                ,
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
        case 'progress':
        case 'aggregateprogress':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e61d320203f0459$var$ProgressFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.progress-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
        case 'com.atlassian.servicedesk:sd-request-feedback':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e61d320203f0459$var$SatisfactionFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.satisfaction-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
        case 'com.atlassian.servicedesk:sd-sla-field':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e61d320203f0459$var$SlaFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.sla-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
        default:
            return (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e61d320203f0459$var$FallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.div",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.div" // eslint-disable-next-line react/no-danger
                ,
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
    }
});
/**
 * Disabling selector eslint rules because we must provide the fallback style overrides this way due
 * to the markup and base styles coming from the monolith.
 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9e61d320203f0459$var$FallbackContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1osq _1rjc1b66 _18zru2gc _1reo15vq _18m915vq _1bto1l2s _bna71wug _rtys1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9e61d320203f0459$var$AttachmentFallbackContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $9e61d320203f0459$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bna71wug _19l3uuw1 _mezj1wug _rtys1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9e61d320203f0459$var$ProgressFallbackContainerOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4idpf _1lms18uv _xu7xt94y _19jqt94y _iv7lt94y _18m0t94y",
            __cmplp.className
        ])
    });
});
const $9e61d320203f0459$var$ProgressFallbackContainer = (0, $bAQOb.componentWithFF)('nin-resizable-columns_8z4eo', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $9e61d320203f0459$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4idpf _1lms18uv _xu7xt94y _19jqt94y _iv7lt94y _18m0t94y",
            __cmplp.className
        ])
    });
}), $9e61d320203f0459$var$ProgressFallbackContainerOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9e61d320203f0459$var$SatisfactionFallbackContainerOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_nmi71a22 _17go1wmz",
            __cmplp.className
        ])
    });
});
const $9e61d320203f0459$var$SatisfactionFallbackContainer = (0, $bAQOb.componentWithFF)('nin-resizable-columns_8z4eo', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $9e61d320203f0459$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_nmi71a22 _17go1wmz",
            __cmplp.className
        ])
    });
}), $9e61d320203f0459$var$SatisfactionFallbackContainerOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9e61d320203f0459$var$SlaFallbackContainerOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1kss1txw _1v441h6o _1xngu2gc _1fecusic _ftqct9kd _i95ccmb5 _c4xn1g39 _1mf81gkm _10kuuco0 _m1to1g39 _g3h8g380",
            __cmplp.className
        ])
    });
});
const $9e61d320203f0459$var$SlaFallbackContainer = (0, $bAQOb.componentWithFF)('nin-resizable-columns_8z4eo', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $9e61d320203f0459$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1kss1txw _1v441h6o _1xngu2gc _1fecusic _1op7t9kd _i95ccmb5 _c4xn1g39 _1mf81gkm _10kuuco0 _m1to1g39 _g3h8g380",
            __cmplp.className
        ])
    });
}), $9e61d320203f0459$var$SlaFallbackContainerOld);

});
parcelRegister("665cO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2d32a31aa833df0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04fe6cbd7f86be0b3c73e9e2564fcb5e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e2d32a31aa833df0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "fallback_nativeIssueTable_FallbackCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "renderedFieldHtml"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        }
    ],
    "type": "JiraFallbackField"
};
$e2d32a31aa833df0$var$node.hash = "ae1cf9566abe8a4e7439b5ee75c25916";
var $e2d32a31aa833df0$export$2e2bcd8739ae039 = $e2d32a31aa833df0$var$node;

});


parcelRegister("66dbi", function(module, exports) {

$parcel$export(module.exports, "IssueKeyCell", () => $5254a7459875655b$export$a6c835c7dffd9abf);

var $oSKKN = parcelRequire("oSKKN");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $BY6fA = parcelRequire("BY6fA");

var $2qXcq = parcelRequire("2qXcq");

var $7ih9H = parcelRequire("7ih9H");

var $6Zxhw = parcelRequire("6Zxhw");
const $5254a7459875655b$export$a6c835c7dffd9abf = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef, onIssueLinkSelected: onIssueLinkSelected })=>{
    const { text: issueKey } = (0, $iWLL0.useFragment)((0, $oSKKN.default), fieldRef);
    if (!issueKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "issueKey",
        reason: "Missing required fields"
    });
    return (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlock: "space.050",
        paddingInline: "space.100",
        xcss: $5254a7459875655b$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Zxhw.default), {
        href: `/browse/${issueKey}`,
        onClick: (e)=>{
            // Use default browser event handling when a modifier key is pressed during the click event
            const isModifierKeyUsed = e.ctrlKey || e.shiftKey || e.metaKey;
            const handled = !isModifierKeyUsed && onIssueLinkSelected !== undefined && onIssueLinkSelected(issueKey);
            if (handled) e.preventDefault();
        }
    }, issueKey))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5254a7459875655b$var$CellWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Zxhw.default), {
        href: `/browse/${issueKey}`,
        onClick: (e)=>{
            // Use default browser event handling when a modifier key is pressed during the click event
            const isModifierKeyUsed = e.ctrlKey || e.shiftKey || e.metaKey;
            const handled = !isModifierKeyUsed && onIssueLinkSelected !== undefined && onIssueLinkSelected(issueKey);
            if (handled) e.preventDefault();
        },
        "data-component-selector": (0, $BY6fA.issueKeySelector)
    }, issueKey)));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5254a7459875655b$var$CellWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7ih9H.TableCellFocusBox), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1wyb1crf _k48pni7l",
            __cmplp.className
        ])
    });
});
const $5254a7459875655b$var$wrapperStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});

});
parcelRegister("oSKKN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e886b4bd4d9a6a29$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74d3deefdac5962eb45a88362c8f3290>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e886b4bd4d9a6a29$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueKey_nativeIssueTable_IssueKeyCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "text"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$e886b4bd4d9a6a29$var$node.hash = "a94d2309a04ef9d6df8816eb57bf6f4b";
var $e886b4bd4d9a6a29$export$2e2bcd8739ae039 = $e886b4bd4d9a6a29$var$node;

});

parcelRegister("BY6fA", function(module, exports) {

$parcel$export(module.exports, "issueKeySelector", () => $4483a525c01f1335$export$d22bc6271070f453);
$parcel$export(module.exports, "StyledScrollIntoViewIfNeeded", () => $4483a525c01f1335$export$60cfc95f0a48937f);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gZWc9 = parcelRequire("gZWc9");

var $1ybV0 = parcelRequire("1ybV0");
const $4483a525c01f1335$export$d22bc6271070f453 = 'jira-native-issue-table-issue-key';
// Cleanup issueKeyComponentSelector with jsv-one-issue-table-spreadsheet-ui_ygrnf
const $4483a525c01f1335$var$issueKeyComponentSelector = `[data-component-selector="${$4483a525c01f1335$export$d22bc6271070f453}"]`;
const $4483a525c01f1335$export$60cfc95f0a48937f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $gZWc9.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1ylp _nt751r31 _49pcglyw _1hvw1o36 _1ez5x15o _t9gfaq80",
            (0, $1ybV0.ff)('jsw.enable-nin-rank-dnd') ? "_kqswh2mm" : "_kqswpfqs",
            __cmplp.active && "_16qs1ahy",
            __cmplp.active && "_bfhk29zg",
            __cmplp.active ? "_r3y8x15o" : "_r3y86iba",
            __cmplp.active ? "_14nn1osq" : "_14nnidpf",
            __cmplp.active ? "_irr329zg" : "_irr31dko",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gZWc9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5ff7c24d3cd4e5f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
function $c5ff7c24d3cd4e5f$var$isElement(el) {
    return el != null && typeof el === 'object' && (el.nodeType === 1 || el.nodeType === 11);
}
function $c5ff7c24d3cd4e5f$var$canOverflow(overflow, skipOverflowHiddenElements) {
    if (skipOverflowHiddenElements && overflow === 'hidden') return false;
    return overflow !== 'visible' && overflow !== 'clip';
}
function $c5ff7c24d3cd4e5f$var$isScrollable(el, skipOverflowHiddenElements) {
    if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
        var style = getComputedStyle(el, null);
        return $c5ff7c24d3cd4e5f$var$canOverflow(style.overflowY, skipOverflowHiddenElements) || $c5ff7c24d3cd4e5f$var$canOverflow(style.overflowX, skipOverflowHiddenElements);
    }
    return false;
}
function $c5ff7c24d3cd4e5f$var$alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
    if (elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd || elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd) return 0;
    if (elementEdgeStart < scrollingEdgeStart && elementSize < scrollingSize || elementEdgeEnd > scrollingEdgeEnd && elementSize > scrollingSize) return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
    if (elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize || elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize) return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
    return 0;
}
var $c5ff7c24d3cd4e5f$var$compute = function(target, options) {
    var scrollMode = options.scrollMode, block = options.block, inline = options.inline, boundary = options.boundary, skipOverflowHiddenElements = options.skipOverflowHiddenElements;
    var checkBoundary = typeof boundary === 'function' ? boundary : function(node) {
        return node !== boundary;
    };
    if (!$c5ff7c24d3cd4e5f$var$isElement(target)) throw new TypeError('Invalid target');
    var scrollingElement = document.scrollingElement || document.documentElement;
    var frames = [];
    var cursor = target;
    while($c5ff7c24d3cd4e5f$var$isElement(cursor) && checkBoundary(cursor)){
        cursor = cursor.parentNode || cursor.host;
        if (cursor === scrollingElement) {
            frames.push(cursor);
            break;
        }
        if (cursor === document.body && $c5ff7c24d3cd4e5f$var$isScrollable(cursor) && !$c5ff7c24d3cd4e5f$var$isScrollable(document.documentElement)) continue;
        if ($c5ff7c24d3cd4e5f$var$isScrollable(cursor, skipOverflowHiddenElements)) frames.push(cursor);
    }
    var viewportWidth = window.visualViewport ? visualViewport.width : innerWidth;
    var viewportHeight = window.visualViewport ? visualViewport.height : innerHeight;
    var viewportX = window.scrollX || pageXOffset;
    var viewportY = window.scrollY || pageYOffset;
    var _target$getBoundingCl = target.getBoundingClientRect(), targetHeight = _target$getBoundingCl.height, targetWidth = _target$getBoundingCl.width, targetTop = _target$getBoundingCl.top, targetRight = _target$getBoundingCl.right, targetBottom = _target$getBoundingCl.bottom, targetLeft = _target$getBoundingCl.left;
    var targetBlock = block === 'start' || block === 'nearest' ? targetTop : block === 'end' ? targetBottom : targetTop + targetHeight / 2;
    var targetInline = inline === 'center' ? targetLeft + targetWidth / 2 : inline === 'end' ? targetRight : targetLeft;
    var computations = [];
    for(var index = 0; index < frames.length; index++){
        var frame = frames[index];
        var _frame$getBoundingCli = frame.getBoundingClientRect(), _height = _frame$getBoundingCli.height, _width = _frame$getBoundingCli.width, _top = _frame$getBoundingCli.top, right = _frame$getBoundingCli.right, bottom = _frame$getBoundingCli.bottom, _left = _frame$getBoundingCli.left;
        if (scrollMode === 'if-needed' && targetTop >= 0 && targetLeft >= 0 && targetBottom <= viewportHeight && targetRight <= viewportWidth && targetTop >= _top && targetBottom <= bottom && targetLeft >= _left && targetRight <= right) return computations;
        var frameStyle = getComputedStyle(frame);
        var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
        var borderTop = parseInt(frameStyle.borderTopWidth, 10);
        var borderRight = parseInt(frameStyle.borderRightWidth, 10);
        var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
        var blockScroll = 0;
        var inlineScroll = 0;
        var scrollbarWidth = 'offsetWidth' in frame ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight : 0;
        var scrollbarHeight = 'offsetHeight' in frame ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom : 0;
        if (scrollingElement === frame) {
            if (block === 'start') blockScroll = targetBlock;
            else if (block === 'end') blockScroll = targetBlock - viewportHeight;
            else if (block === 'nearest') blockScroll = $c5ff7c24d3cd4e5f$var$alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - viewportHeight / 2;
            if (inline === 'start') inlineScroll = targetInline;
            else if (inline === 'center') inlineScroll = targetInline - viewportWidth / 2;
            else if (inline === 'end') inlineScroll = targetInline - viewportWidth;
            else inlineScroll = $c5ff7c24d3cd4e5f$var$alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
            blockScroll = Math.max(0, blockScroll + viewportY);
            inlineScroll = Math.max(0, inlineScroll + viewportX);
        } else {
            if (block === 'start') blockScroll = targetBlock - _top - borderTop;
            else if (block === 'end') blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
            else if (block === 'nearest') blockScroll = $c5ff7c24d3cd4e5f$var$alignNearest(_top, bottom, _height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - (_top + _height / 2) + scrollbarHeight / 2;
            if (inline === 'start') inlineScroll = targetInline - _left - borderLeft;
            else if (inline === 'center') inlineScroll = targetInline - (_left + _width / 2) + scrollbarWidth / 2;
            else if (inline === 'end') inlineScroll = targetInline - right + borderRight + scrollbarWidth;
            else inlineScroll = $c5ff7c24d3cd4e5f$var$alignNearest(_left, right, _width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
            var scrollLeft = frame.scrollLeft, scrollTop = frame.scrollTop;
            blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, frame.scrollHeight - _height + scrollbarHeight));
            inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, frame.scrollWidth - _width + scrollbarWidth));
            targetBlock += scrollTop - blockScroll;
            targetInline += scrollLeft - inlineScroll;
        }
        computations.push({
            el: frame,
            top: blockScroll,
            left: inlineScroll
        });
    }
    return computations;
};
function $c5ff7c24d3cd4e5f$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $c5ff7c24d3cd4e5f$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $c5ff7c24d3cd4e5f$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($c5ff7c24d3cd4e5f$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $c5ff7c24d3cd4e5f$var$scrollIntoView(target, options) {
    if ($c5ff7c24d3cd4e5f$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior($c5ff7c24d3cd4e5f$var$compute(target, options));
    var computeOptions = $c5ff7c24d3cd4e5f$var$getOptions(options);
    return $c5ff7c24d3cd4e5f$var$defaultBehavior($c5ff7c24d3cd4e5f$var$compute(target, computeOptions), computeOptions.behavior);
}
var $c5ff7c24d3cd4e5f$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $c5ff7c24d3cd4e5f$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $c5ff7c24d3cd4e5f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $c5ff7c24d3cd4e5f$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $c5ff7c24d3cd4e5f$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $c5ff7c24d3cd4e5f$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $c5ff7c24d3cd4e5f$var$ScrollIntoViewIfNeeded = function(_PureComponent) {
    $c5ff7c24d3cd4e5f$var$inherits(ScrollIntoViewIfNeeded, _PureComponent);
    function ScrollIntoViewIfNeeded() {
        $c5ff7c24d3cd4e5f$var$classCallCheck(this, ScrollIntoViewIfNeeded);
        var _this = $c5ff7c24d3cd4e5f$var$possibleConstructorReturn(this, (ScrollIntoViewIfNeeded.__proto__ || Object.getPrototypeOf(ScrollIntoViewIfNeeded)).call(this));
        _this.handleScrollIntoViewIfNeeded = function() {
            var options = _this.props.options;
            var node = _this.node.current;
            $c5ff7c24d3cd4e5f$var$scrollIntoView(node, options);
        };
        _this.node = (0, $eUqFw.createRef)();
        return _this;
    }
    $c5ff7c24d3cd4e5f$var$createClass(ScrollIntoViewIfNeeded, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var active = this.props.active;
                if (active) this.handleScrollIntoViewIfNeeded();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(_ref) {
                var active = _ref.active;
                var isNowActive = this.props.active;
                if (!active && isNowActive) this.handleScrollIntoViewIfNeeded();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, active = _props.active, elementType = _props.elementType, children = _props.children, options = _props.options, wrapperProps = $c5ff7c24d3cd4e5f$var$objectWithoutProperties(_props, [
                    'active',
                    'elementType',
                    'children',
                    'options'
                ]);
                return (0, $eUqFw.createElement)(elementType, $c5ff7c24d3cd4e5f$var$_extends({
                    ref: this.node
                }, wrapperProps), children);
            }
        }
    ]);
    return ScrollIntoViewIfNeeded;
}((0, $eUqFw.PureComponent));
$c5ff7c24d3cd4e5f$var$ScrollIntoViewIfNeeded.propTypes = {
    active: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node.isRequired,
    elementType: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    // this shape should mirror the scroll-into-view-if-needed options
    options: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        behavior: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
                'auto',
                'smooth',
                'instant'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
        ]),
        block: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
            'center',
            'end',
            'nearest',
            'start'
        ]),
        inline: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
            'center',
            'end',
            'nearest',
            'start'
        ]),
        scrollMode: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
            'always',
            'if-needed'
        ]),
        boundary: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
            // eslint-disable-next-line no-undef
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).instanceOf(Element),
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
        ]),
        skipOverflowHiddenElements: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool
    })
};
$c5ff7c24d3cd4e5f$var$ScrollIntoViewIfNeeded.defaultProps = {
    active: true,
    elementType: 'div',
    options: {
        behavior: 'smooth',
        scrollMode: 'if-needed'
    }
};
var $c5ff7c24d3cd4e5f$export$2e2bcd8739ae039 = $c5ff7c24d3cd4e5f$var$ScrollIntoViewIfNeeded;

});


parcelRegister("7ih9H", function(module, exports) {

$parcel$export(module.exports, "TableCellFocusBox", () => $ed130899ca840d20$export$1ff6cd33d382d19d);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ybV0 = parcelRequire("1ybV0");
const $ed130899ca840d20$export$1ff6cd33d382d19d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itglyw _19h61l7b _1u6l2jkb _102s1r31 _yi8hglyw _h79h1o36",
            (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? "_1mour5cr _195gx0bf _1rjc1b66 _18zru2gc" : "_18s8x0bf _1yt4u2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6Zxhw", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f109c116347f7d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");
const $58f109c116347f7d$var$TableCellLink = ({ onClick: onClick, ...rest })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClickWithAnalytics = (0, $eUqFw.useCallback)((e)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), 'tableIssueLink');
        onClick && onClick(e);
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($58f109c116347f7d$var$StyledLink, {
        ...rest,
        onClick: onClickWithAnalytics
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58f109c116347f7d$var$StyledLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $kJlBc.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1nmz1hna",
            __cmplp.innerFocusOutline && "_1ah31i6y",
            __cmplp.className
        ])
    });
});
var $58f109c116347f7d$export$2e2bcd8739ae039 = $58f109c116347f7d$var$TableCellLink;

});


parcelRegister("6cTPi", function(module, exports) {

$parcel$export(module.exports, "IssueLinksCell", () => $3a263be42cb338ab$export$75aa2ccc20dd7954);

var $96Led = parcelRequire("96Led");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $dtaN9 = parcelRequire("dtaN9");

var $ehDeP = parcelRequire("ehDeP");
var $k85ht = parcelRequire("k85ht");
var $lmIUR = parcelRequire("lmIUR");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jqoaM = parcelRequire("jqoaM");
var $e27aD = parcelRequire("e27aD");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $2qXcq = parcelRequire("2qXcq");

var $giJER = parcelRequire("giJER");
const $3a263be42cb338ab$var$getLinkJql = (issueKey)=>{
    const jast = (0, $ehDeP.default).jast((0, $ehDeP.default).query((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field('issue'), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_IN)), (0, $ehDeP.default).functionOperand((0, $ehDeP.default).functionString('linkedIssues'), [
        (0, $ehDeP.default).argument(issueKey)
    ]))));
    return (0, $lmIUR.print)(jast, {
        operatorCase: 'upper'
    });
}; /**
    * @param issueLinks - An object containing issue information, and the relationship name
    * @returns An array that groups issueLinks by relationship. A relationship could be "blocks", "is blocked by", "relates to", etc.
    */ 
const $3a263be42cb338ab$export$4efba20e7d8d22ac = (issueLinks)=>{
    const relationshipGroupings = {};
    issueLinks.forEach(({ key: key, name: name, href: href, relationName: relationName, shouldDisplayStrikethrough: shouldDisplayStrikethrough })=>{
        if (relationName) {
            if (!relationshipGroupings[relationName]) relationshipGroupings[relationName] = {
                key: relationName,
                issues: []
            };
            relationshipGroupings[relationName].issues.push({
                key: key,
                name: name,
                href: href,
                shouldDisplayStrikethrough: shouldDisplayStrikethrough
            });
        }
    });
    return Object.values(relationshipGroupings);
};
const $3a263be42cb338ab$export$f5c82a537c5611ea = (relationships)=>{
    relationships.forEach((relationship)=>relationship.issues.sort((a, b)=>a.name.localeCompare(b.name)));
    relationships.sort((a, b)=>a.key.localeCompare(b.key));
};
const $3a263be42cb338ab$export$75aa2ccc20dd7954 = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, issueKey: issueKey, initialIsOpen: initialIsOpen = false, accordionInitialIsOpen: accordionInitialIsOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)(); // the first:1000 is max that frontend is allowed to request. BE may override this upper limit and return lesser items.
    const data = (0, $iWLL0.useFragment)((0, $96Led.default), fieldRef);
    const issueLinks = data?.issueLinkConnection?.edges;
    const filteredIssueLinks = (0, $eUqFw.useMemo)(()=>issueLinks?.map((edge)=>edge?.node?.issue?.key != null ? {
                key: edge.node.issue?.key || 'missingId',
                name: edge.node.issue?.key,
                href: edge.node.issue?.webUrl || '',
                relationName: edge.node.relationName,
                shouldDisplayStrikethrough: edge.node.issue?.fieldsById?.edges?.[0]?.node?.statusCategory?.statusCategoryId === '3' || false
            } : null).filter(Boolean) ?? [], [
        issueLinks
    ]); // JIS doesn't return exact total count of issueLinks, but we do know whether there are unfetched items
    const maxIssueLinksReached = data?.issueLinkConnection?.pageInfo?.hasNextPage === true || false;
    const issueLinksGroupedByRelationship = (0, $eUqFw.useMemo)(()=>{
        const groupedByRelationship = $3a263be42cb338ab$export$4efba20e7d8d22ac(filteredIssueLinks);
        $3a263be42cb338ab$export$f5c82a537c5611ea(groupedByRelationship);
        return groupedByRelationship;
    }, [
        filteredIssueLinks
    ]);
    if (!issueLinks || issueLinks.length !== filteredIssueLinks.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "issueLinks",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jqoaM.default), {
        items: filteredIssueLinks,
        maxLimit: filteredIssueLinks.length,
        initialIsOpen: initialIsOpen,
        ItemComponent: (0, $e27aD.TagItem),
        PopupContentWrapper: (0, $e27aD.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $giJER.default).triggerButton),
        OverrideContentComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "issueLinks",
            sourceType: (0, $41ea3621645e2acc$export$cae2783c9279926),
            attributes: {
                maxIssueLinksReached: maxIssueLinksReached
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, issueLinksGroupedByRelationship.map((relationship)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3a263be42cb338ab$var$Accordion, {
                key: relationship.key,
                header: relationship.key,
                length: relationship.issues.length,
                initialIsOpen: accordionInitialIsOpen
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e27aD.TagItemPopupContentWrapper), null, relationship.issues.map((issue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e27aD.TagItem), {
                    name: issue.name,
                    href: issue.href,
                    key: issue.key,
                    shouldDisplayStrikethrough: issue.shouldDisplayStrikethrough
                }))))), maxIssueLinksReached && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3a263be42cb338ab$var$RedirectButtonComponent, {
            issueKey: issueKey,
            issueSearchBaseUrl: issueSearchBaseUrl
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null))
    }));
});
const $3a263be42cb338ab$var$RedirectButtonComponent = ({ issueKey: issueKey, issueSearchBaseUrl: issueSearchBaseUrl })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3a263be42cb338ab$var$ShowMoreLink, {
        href: `${issueSearchBaseUrl}?jql=${encodeURIComponent($3a263be42cb338ab$var$getLinkJql(issueKey))}`,
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'issueLinksSeeAllIssues');
        }
    }, formatMessage((0, $giJER.default).showMoreLink));
};
const $3a263be42cb338ab$var$Accordion = /*#__PURE__*/ (0, $eUqFw.memo)(({ header: header, children: children, length: length, initialIsOpen: initialIsOpen = false })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(initialIsOpen);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            xcss: (0, $1ZAYh.xcss)({
                transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                transition: 'transform 0.1s ease-out',
                alignItems: 'center'
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            label: ""
        })),
        onClick: (e, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueLinksAccordion', {
                action: isOpen ? 'closed' : 'opened'
            });
            setIsOpen(!isOpen);
        },
        // https://atlassian.design/components/button/button-new/examples#custom-buttons
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            textAlign: 'left'
        },
        "aria-expanded": isOpen
    }, `${header} (${length})`), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockEnd: "space.050"
    }, children));
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a263be42cb338ab$var$ShowMoreLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $kJlBc.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0pxbi _2hwxpxbi _vwz41ejb _k48pbfng",
            __cmplp.className
        ])
    });
});

});
parcelRegister("96Led", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e2d3164e3f4cb1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b15f2c46b1a801ab72fc075a9f84003e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $61e2d3164e3f4cb1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueLinks_nativeIssueTable_IssueLinksCell",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraIssueLinkConnection",
            "kind": "LinkedField",
            "name": "issueLinkConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        }
                    ]
                },
                {
                    "concreteType": "JiraIssueLinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueLink",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "webUrl"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "ids",
                                                    "value": [
                                                        "statusCategory"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCategoryId"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraStatusCategoryField"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "relationName"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "issueLinkConnection(first:1000)"
        }
    ],
    "type": "JiraIssueLinkField"
};
$61e2d3164e3f4cb1$var$node.hash = "65d10b85a6176f5587524197d270987b";
var $61e2d3164e3f4cb1$export$2e2bcd8739ae039 = $61e2d3164e3f4cb1$var$node;

});

parcelRegister("giJER", function(module, exports) {

$parcel$export(module.exports, "default", () => $d874cb9a49e30b0d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d874cb9a49e30b0d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.issue-links.trigger-button",
        "defaultMessage": "See more"
    },
    showMoreLink: {
        "id": "native-issue-table.common.issue-cells.issue-links.show-more-link",
        "defaultMessage": "Go to all linked issues"
    }
});

});


parcelRegister("fFkd8", function(module, exports) {

$parcel$export(module.exports, "IssueOperations", () => $8ccdf1bbe8b0789d$export$125bc3f55de1b4bd);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ybV0 = parcelRequire("1ybV0");

var $kZQwR = parcelRequire("kZQwR");

const $8ccdf1bbe8b0789d$export$125bc3f55de1b4bd = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, issueId: issueId, onIssueRefetch: onIssueRefetch, onIssueDelete: onIssueDelete })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8ccdf1bbe8b0789d$var$ButtonWrapper, {
        "data-component-selector": (0, $4633c24ba18b0431$export$914b5aeee27f05a0)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZQwR.default), {
        issueId: issueId,
        issueKey: issueKey,
        onIssueRefetch: onIssueRefetch,
        onIssueDelete: onIssueDelete
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ccdf1bbe8b0789d$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhktxrc _2rko1y44 _1bsb1ns9 _18u01wug",
            !(0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') && "_2hwxutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kZQwR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1325c862cd4e13f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");

var $jG1wZ = parcelRequire("jG1wZ");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $gGtKh = parcelRequire("gGtKh");

var $jhhg7 = parcelRequire("jhhg7");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a1325c862cd4e13f$var$MeatballMenu = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("43gdt")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/issue-operations/meatball-menu/src/ui/index.tsx"
});
const $a1325c862cd4e13f$var$Fallback = ({ onRetry: onRetry })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, ...props })=>{
            let iconColor;
            if ((0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf')) iconColor = isSelected ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon-subtle, #626F86)";
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: "",
                    size: "medium",
                    primaryColor: iconColor
                }),
                ref: triggerRef,
                isSelected: isSelected
            });
        },
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jhhg7.ErrorState), {
        onRetry: onRetry
    }));
const $a1325c862cd4e13f$var$AsyncMeatballMenu = (props)=>{
    const [resetCaughtError, setResetCaughtError] = (0, $eUqFw.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorIssueOperations",
        id: "async-meatball-menu",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1325c862cd4e13f$var$Fallback, {
                onRetry: ()=>setResetCaughtError(error)
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-meatball-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                label: "",
                size: "medium"
            }),
            isDisabled: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1325c862cd4e13f$var$MeatballMenu, props)));
};
var $a1325c862cd4e13f$export$2e2bcd8739ae039 = $a1325c862cd4e13f$var$AsyncMeatballMenu;

});
parcelRegister("jhhg7", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $5634635eed63d085$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7u4fN = parcelRequire("7u4fN");

var $96IgR = parcelRequire("96IgR");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ddGF3 = parcelRequire("ddGF3");

var $b3PFx = parcelRequire("b3PFx");
const $5634635eed63d085$export$c1ed4f415b9e7023 = ({ onRetry: onRetry })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5634635eed63d085$var$DropdownItemsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5634635eed63d085$var$StyledBox, {
        height: (0, $c9TLT.gridSize) * 9,
        iconSize: (0, $c9TLT.gridSize) * 9
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        testId: "issue-navigator-issue-operations.common.ui.error-state.error-icon",
        primaryColor: `var(--ds-icon, ${(0, $PdmhA).N500})`,
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b3PFx.StyledText), null, formatMessage((0, $ddGF3.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onRetry,
        appearance: "link"
    }, formatMessage((0, $ddGF3.default).retryMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5634635eed63d085$var$DropdownItemsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _1tket9kd _1ul9p3fh _p12fp3fh _c71leo28 _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $5634635eed63d085$var$StyledBox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`),
            "--_1kpj8xj": (0, $9t7rW.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i2nrh _1bah1h6o",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ddGF3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9a9a9e1fbd6586a$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $a9a9a9e1fbd6586a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.retry-message",
        "defaultMessage": "Click to retry"
    }
});

});

parcelRegister("b3PFx", function(module, exports) {

$parcel$export(module.exports, "StyledText", () => $0b1b9ae264dc1e64$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b1b9ae264dc1e64$var$StyledTextComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $0b1b9ae264dc1e64$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b1b9ae264dc1e64$var$StyledTextComponent, props));

});


parcelRegister("43gdt", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('daci0')
        ]);
        const value = parcelRequire('3KGho');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("daci0")
    ]).then(()=>parcelRequire('3KGho'));
}

});


const $4633c24ba18b0431$export$914b5aeee27f05a0 = 'jira-native-issue-table-issue-row-button-wrapper';
const $4633c24ba18b0431$export$123e6bfb1c4dd78f = `[data-component-selector="${$4633c24ba18b0431$export$914b5aeee27f05a0}"]`;


parcelRegister("eF3lG", function(module, exports) {

$parcel$export(module.exports, "IssueStatusCategoryCell", () => $101e2435b84e660d$export$663286ccb241374c);

var $1CABD = parcelRequire("1CABD");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $d16Lt = parcelRequire("d16Lt");

var $2qXcq = parcelRequire("2qXcq");
const $101e2435b84e660d$export$663286ccb241374c = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef })=>{
    const { statusCategory: statusCategory } = (0, $iWLL0.useFragment)((0, $1CABD.default), fieldRef);
    const { name: name } = statusCategory;
    const statusCategoryId = parseInt(statusCategory.statusCategoryId, 10);
    if (Number.isNaN(statusCategoryId) || statusCategoryId === -1 || !name?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "statusCategory",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $101e2435b84e660d$var$alignmentFixStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d16Lt.StatusLozenge), {
        value: {
            id: '',
            name: name,
            statusCategory: {
                id: statusCategoryId
            }
        }
    }));
});
// Status lozenges have a 2px invisible border around them to keep them in the same place if they enter an "error" state (where a border colour is added).
// Refer to: src/packages/issue/fields/status/src/common/ui/status-lozenge/main.tsx
const $101e2435b84e660d$var$alignmentFixStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.negative.025'
});

});
parcelRegister("1CABD", function(module, exports) {

$parcel$export(module.exports, "default", () => $fadc2e8dae5fef12$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ea56737eacf62204e5cc47ea8a38de4e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fadc2e8dae5fef12$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueStatusCategory_nativeIssueTable_IssueStatusCategoryCell",
    "selections": [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "statusCategoryId"
                }
            ]
        }
    ],
    "type": "JiraStatusCategoryField"
};
$fadc2e8dae5fef12$var$node.hash = "01c5fef6394b4cc6d50a5e2f02db1620";
var $fadc2e8dae5fef12$export$2e2bcd8739ae039 = $fadc2e8dae5fef12$var$node;

});

parcelRegister("d16Lt", function(module, exports) {

$parcel$export(module.exports, "StatusLozenge", () => $ff16a2437ea95212$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeWithDropdownIndicator", () => $ff16a2437ea95212$export$9f5070a985b0679b);

var $eUqFw = parcelRequire("eUqFw");

var $2GJ4g = parcelRequire("2GJ4g");
const $ff16a2437ea95212$export$f72db4ad1e9b3e6d = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false
    });
};
const $ff16a2437ea95212$export$9f5070a985b0679b = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        shouldShowDropdownIndication: true
    });
};

});


parcelRegister("gHSFC", function(module, exports) {

$parcel$export(module.exports, "IssueStatusCell", () => $9b8adf81361f0516$export$58e0df5bb69dbb83);

var $dSHgs = parcelRequire("dSHgs");

var $5tgbq = parcelRequire("5tgbq");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $6nWxr = parcelRequire("6nWxr");
var $d16Lt = parcelRequire("d16Lt");

var $6vrw7 = parcelRequire("6vrw7");

var $2qXcq = parcelRequire("2qXcq");

var $iABGR = parcelRequire("iABGR");
const $9b8adf81361f0516$export$58e0df5bb69dbb83 = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef, hasInlineEditing: hasInlineEditing, issueKey: issueKey, onUpdateCache: onUpdateCache, issueId: issueId })=>{
    const data = (0, $iWLL0.useFragment)(/* eslint-disable jira/relay/graphql-naming */ (0, $5tgbq.default), /* eslint-enable jira/relay/graphql-naming */ fieldRef);
    // We need an intermediary fragment as we have 2 include conditions pre-ff rollout: 1. FF; 2. Consumer query
    // variable. Once FF is cleaned up this can be inlined into the above fragment.
    const inlineEditData = (0, $iWLL0.useFragment)((0, $dSHgs.default), // Data will always be defined even when our fragment has been conditionally skipped. We need an additional
    // FF check to make sure we're not attempting to look up a non-existent fragment which leads to an invariant
    // violation.
    (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? data : null);
    const { status: status } = data;
    const [value, setValue] = (0, $eUqFw.useState)(status);
    (0, $eUqFw.useEffect)(()=>{
        setValue(status);
    }, [
        status
    ]);
    if (value?.statusCategory?.statusCategoryId === undefined || !value?.name?.length || !value?.statusId?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "status",
        reason: "Missing required fields"
    });
    const onSuccess = (newStatus)=>{
        const transformedStatus = (0, $iABGR.toJiraStatusField)(newStatus);
        setValue(transformedStatus);
        onUpdateCache && onUpdateCache(issueKey, 'status', transformedStatus);
    };
    let isEditable;
    if ((0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf')) // If the property does not exist in fragment data then we know it has been conditionally excluded because
    // inline editing is disabled. In future this should follow the same design/deferred loading strategy of
    // other inline editable fields, however this would require a larger effort to decompose the status field.
    isEditable = inlineEditData && typeof inlineEditData.id === 'string';
    else isEditable = hasInlineEditing;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9b8adf81361f0516$var$alignmentFixStyles
    }, isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6nWxr.AsyncIssueStatusField), {
        issueKey: (0, $6vrw7.toIssueKey)(issueKey),
        issueId: issueId && (0, $6vrw7.toIssueId)(issueId),
        appearance: "lozenge",
        value: (0, $iABGR.toStatusValue)(value),
        onSuccess: onSuccess
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d16Lt.StatusLozenge), {
        value: (0, $iABGR.toStatusValue)(value)
    }));
});
// Status lozenges have a 2px invisible border around them to keep them in the same place if they enter an "error" state (where a border colour is added).
// Refer to: src/packages/issue/fields/status/src/common/ui/status-lozenge/main.tsx
const $9b8adf81361f0516$var$alignmentFixStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.negative.025'
});

});
parcelRegister("dSHgs", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c36cc5d5f7d647c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d4bd7332657f5e9a5cc25dfb09c46ffd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5c36cc5d5f7d647c$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "issueStatus_nativeIssueTable_IssueStatusCell_isEditableInIssueView",
    "selections": [
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ],
    "type": "JiraStatusField"
};
$5c36cc5d5f7d647c$var$node.hash = "90b4510b5676de561f64f2f42ad4418e";
var $5c36cc5d5f7d647c$export$2e2bcd8739ae039 = $5c36cc5d5f7d647c$var$node;

});

parcelRegister("5tgbq", function(module, exports) {

$parcel$export(module.exports, "default", () => $543068a6dffc8634$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<001023cde9de948d7864241ba9c6f701>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $543068a6dffc8634$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcstatusinlineeditrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "issueStatus_nativeIssueTable_IssueStatusCell",
    "selections": [
        {
            "concreteType": "JiraStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "statusId"
                },
                {
                    "concreteType": "JiraStatusCategory",
                    "kind": "LinkedField",
                    "name": "statusCategory",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCategoryId"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcstatusinlineeditrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "issueStatus_nativeIssueTable_IssueStatusCell_isEditableInIssueView"
                }
            ]
        }
    ],
    "type": "JiraStatusField"
};
$543068a6dffc8634$var$node.hash = "b561447fc88a5145b403ea27826107e7";
var $543068a6dffc8634$export$2e2bcd8739ae039 = $543068a6dffc8634$var$node;

});

parcelRegister("6nWxr", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueStatusField", () => $525e34d5896b7f0a$export$ddd324b06f34200);
$parcel$export(module.exports, "IssueStatusFieldBoundary", () => $525e34d5896b7f0a$export$dba9e9c892560f60);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $d16Lt = parcelRequire("d16Lt");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $525e34d5896b7f0a$var$AsyncLazyIssueStatusField = (0, $7rh0R.lazy)(()=>Promise.resolve((parcelRequire("lpHr5"))), {
    moduleId: "./src/packages/issue/fields/status/src/ui/main.tsx"
});
const $525e34d5896b7f0a$export$ddd324b06f34200 = (props)=>{
    const { initialValue: initialValue, value: value } = props;
    const errorProps = {
        initialValue: initialValue,
        value: value
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-field-status",
        packageName: "jira-issue-field-status",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d16Lt.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-status-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d16Lt.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($525e34d5896b7f0a$var$AsyncLazyIssueStatusField, props)));
};
const $525e34d5896b7f0a$export$dba9e9c892560f60 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-status-field",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-status-field-boundary",
        fallback: fallback
    }, children));

});

parcelRegister("iABGR", function(module, exports) {

$parcel$export(module.exports, "toJiraStatusField", () => $75a2f5398bd00b9f$export$54bbdde829b87b5c);
$parcel$export(module.exports, "toStatusValue", () => $75a2f5398bd00b9f$export$2950d85c450ec19d);
const $75a2f5398bd00b9f$export$54bbdde829b87b5c = (statusValue)=>({
        statusId: statusValue.id,
        name: statusValue.name,
        statusCategory: {
            statusCategoryId: `${statusValue.statusCategory.id}`
        }
    });
const $75a2f5398bd00b9f$export$2950d85c450ec19d = (jiraStatusField)=>({
        id: jiraStatusField.statusId,
        name: jiraStatusField.name ?? '',
        statusCategory: {
            id: parseInt(jiraStatusField.statusCategory?.statusCategoryId ?? '', 10)
        }
    });

});


parcelRegister("4cCSJ", function(module, exports) {

$parcel$export(module.exports, "IssueSummaryCell", () => $dfd343e8f3ff4d89$export$4da280f2973efc5c);

var $fJdaZ = parcelRequire("fJdaZ");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $jouY5 = parcelRequire("jouY5");

var $e9kDw = parcelRequire("e9kDw");

var $2qXcq = parcelRequire("2qXcq");

var $6Zxhw = parcelRequire("6Zxhw");
const $dfd343e8f3ff4d89$export$4da280f2973efc5c = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef, issueKey: issueKey, onIssueLinkSelected: onIssueLinkSelected })=>{
    const data = (0, $iWLL0.useFragment)((0, $fJdaZ.default), /* eslint-enable jira/relay/graphql-naming */ fieldRef);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $e9kDw.useLazyLoadEditability)(data.id, isEditable);
    const renderCustomReadView = (text)=>{
        if (!text) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
            cellType: "summary",
            reason: "Missing required fields"
        });
        // TODO: inline content when cleaning up jsv-one-issue-table-spreadsheet-ui_ygrnf
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Zxhw.default), {
            innerFocusOutline: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf'),
            href: `/browse/${issueKey}`,
            onClick: (e)=>{
                // Use default browser event handling when a modifier key is pressed during the click event
                const isModifierKeyUsed = e.ctrlKey || e.shiftKey || e.metaKey;
                const handled = !isModifierKeyUsed && onIssueLinkSelected !== undefined && onIssueLinkSelected(issueKey);
                if (handled) e.preventDefault();
            }
        }, text);
        // Span is necessary here to ensure only link text is clickable for multiline summaries, rather than the
        // entire content box.
        return (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "span",
            xcss: $dfd343e8f3ff4d89$var$textOverflowStyles
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, content);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jouY5.SingleLineTextInlineEditViewWithIsEditable), {
        spacing: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? 'default' : undefined,
        editViewPopup: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo'),
        editViewPopupAlignBlock: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? 'center' : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        isRequired: true,
        maxLength: 255,
        readViewFitContainerHeight: true,
        renderCustomReadView: renderCustomReadView,
        hideEditButton: false
    });
});
const $dfd343e8f3ff4d89$var$textOverflowStyles = (0, $1ZAYh.xcss)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word'
});

});
parcelRegister("fJdaZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f84abbba4a6a718$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4225a6474e7d4d1e385263fcf18cac81>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f84abbba4a6a718$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "issueSummary_nativeIssueTable_IssueSummaryCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$6f84abbba4a6a718$var$node.hash = "fe8b2efee546119c5221ed6d1d5b2120";
var $6f84abbba4a6a718$export$2e2bcd8739ae039 = $6f84abbba4a6a718$var$node;

});

parcelRegister("jouY5", function(module, exports) {

$parcel$export(module.exports, "SingleLineTextInlineEditViewWithIsEditable", () => $71f0bd94b2cb02c4$export$f267c8aeb8112733);

var $8yi5G = parcelRequire("8yi5G");

var $2cwf9 = parcelRequire("2cwf9");

var $3GWcS = parcelRequire("3GWcS");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iQYHK = parcelRequire("iQYHK");

var $lt1uI = parcelRequire("lt1uI");

var $8KG91 = parcelRequire("8KG91");

var $2tL94 = parcelRequire("2tL94");

var $hzEzF = parcelRequire("hzEzF");

var $lecRR = parcelRequire("lecRR");
const $71f0bd94b2cb02c4$export$f267c8aeb8112733 = ({ spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isFieldEditable, isEditing: startWithEditViewOpen, isRequired: isRequired = false, hideEditButton: hideEditButton, maxLength: maxLength, onCancel: onCancel, onEdit: onEdit, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, renderCustomReadView: renderCustomReadView })=>{
    // #region Relay
    const data = (0, $iWLL0.useFragment)((0, $3GWcS.default), fragmentRef);
    const { id: uniqueFieldId, text: text, name: fieldName } = data;
    const [commit] = (0, $iWLL0.useMutation)((0, $2cwf9.default));
    // #endregion
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cancelButtonLabel = formatMessage((0, $hzEzF.default).cancelButtonLabel, {
        fieldName: fieldName
    });
    const confirmButtonLabel = formatMessage((0, $hzEzF.default).confirmButtonLabel, {
        fieldName: fieldName
    });
    const editButtonLabel = formatMessage((0, $hzEzF.default).editButtonLabel, {
        fieldName: fieldName
    });
    // #region Common state
    const initialValue = text ?? '';
    const [updatedValue, setUpdatedValue] = (0, $eUqFw.useState)(initialValue);
    // #endregion
    const validator = (0, $lecRR.useSingleLineTextValidator)(fieldName, isRequired, maxLength);
    /**
   * This will execute the GraphQL mutation.
   */ const handleSubmit = (0, $eUqFw.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        text: value,
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateSingleLineTextField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateSingleLineTextField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            text: value
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $iQYHK.useFieldInlineEditActions)({
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        initialValue: initialValue,
        updatedValue: updatedValue,
        validator: validator
    });
    const onChange = (0, $eUqFw.useCallback)((event)=>{
        handleChange(event.target.value);
    }, [
        handleChange
    ]);
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2tL94.SingleLineTextReadView), {
            fragmentRef: data,
            renderCustomReadView: renderCustomReadView
        });
    // #endregion
    // #region Edit view
    const getEditViewProps = ({ fieldId: fieldId, ...fieldProps })=>({
            ...fieldProps,
            spacing: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? spacing : undefined,
            inputId: fieldId,
            value: updatedValue,
            onChange: onChange,
            isInvalid: !!invalidMessage,
            autoFocus: true
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lt1uI.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "large",
        editViewEntryPoint: (0, $8KG91.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        hideEditButton: hideEditButton,
        invalidMessage: invalidMessage ?? undefined,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        cancelButtonLabel: (0, $1ybV0.ff)('nin-priority-inline-edit') ? undefined : cancelButtonLabel,
        confirmButtonLabel: (0, $1ybV0.ff)('nin-priority-inline-edit') ? undefined : confirmButtonLabel,
        editButtonLabel: (0, $1ybV0.ff)('nin-priority-inline-edit') ? undefined : editButtonLabel,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit
    });
};
const $71f0bd94b2cb02c4$export$ad603a514b680587 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $iWLL0.useFragment)((0, $8yi5G.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($71f0bd94b2cb02c4$export$f267c8aeb8112733, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("8yi5G", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bb91573f0768f21$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5603fda12586c734accd519f63ebd761>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3bb91573f0768f21$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleLineTextField"
};
$3bb91573f0768f21$var$node.hash = "834bf98c01966c210bc0a4f6e9f0f4a7";
var $3bb91573f0768f21$export$2e2bcd8739ae039 = $3bb91573f0768f21$var$node;

});

parcelRegister("2cwf9", function(module, exports) {

$parcel$export(module.exports, "default", () => $785ccac05ca96c1c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f87bbae0df7928fcb860f8d696c8c51>>
 * @relayHash 029277561796d9f13acaef1dbb085ee8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6baebfa2f37e676d26595f29fc232725ad41353c9fcd04168be34a6b616f152
const $785ccac05ca96c1c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSingleLineTextFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateSingleLineTextField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraSingleLineTextField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "text"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "singleLineText_issueFieldSingleLineText_SingleLineTextField_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "singleLineText_issueFieldSingleLineText_SingleLineTextField_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a6baebfa2f37e676d26595f29fc232725ad41353c9fcd04168be34a6b616f152",
            "metadata": {},
            "name": "singleLineText_issueFieldSingleLineText_SingleLineTextField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$785ccac05ca96c1c$var$node.hash = "7910ed923271af0f6fe2fd325e2358de";
var $785ccac05ca96c1c$export$2e2bcd8739ae039 = $785ccac05ca96c1c$var$node;

});

parcelRegister("3GWcS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c514023272a08e50$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11119a36d9ae1e5ca9d88647770b7ba8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c514023272a08e50$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextReadviewFull_SingleLineTextReadView"
        },
        {
            "kind": "ScalarField",
            "name": "text"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$c514023272a08e50$var$node.hash = "74b3b1d0f4c945c24e06698b00d25032";
var $c514023272a08e50$export$2e2bcd8739ae039 = $c514023272a08e50$var$node;

});

parcelRegister("8KG91", function(module, exports) {

$parcel$export(module.exports, "default", () => $0be48b7060fd477b$export$2e2bcd8739ae039);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $0be48b7060fd477b$var$SingleLineTextEditViewEntryPoint = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("b8AYK")), {
        moduleId: "c6bbf997"
    }),
    getPreloadProps: ()=>({})
});
var $0be48b7060fd477b$export$2e2bcd8739ae039 = $0be48b7060fd477b$var$SingleLineTextEditViewEntryPoint;

});
parcelRegister("b8AYK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3Aw5y');
        const value = parcelRequire('gCrXv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3Aw5y").then(()=>parcelRequire('gCrXv'));
}

});


parcelRegister("2tL94", function(module, exports) {

$parcel$export(module.exports, "SingleLineTextReadView", () => $b4b7ef92ae80f881$export$5a145b2225896aea);

var $78G9e = parcelRequire("78G9e");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $cRXCh = parcelRequire("cRXCh");
const $b4b7ef92ae80f881$export$5a145b2225896aea = ({ fragmentRef: fragmentRef, renderFieldContentWrapper: FieldContentWrapper, renderCustomReadView: renderCustomReadView })=>{
    const { text: text = null, fieldId: fieldId } = (0, $iWLL0.useFragment)((0, $78G9e.default), fragmentRef);
    const getReadView = (0, $eUqFw.useCallback)(()=>{
        if (renderCustomReadView) return renderCustomReadView(text);
        if (!text) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cRXCh.EmptyFieldText), null);
        const testId = `issue.views.field.single-line-text.read-view.${fieldId}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b4b7ef92ae80f881$var$ReadViewContainer, {
            "data-testid": testId
        }, text);
    }, [
        renderCustomReadView,
        fieldId,
        text
    ]);
    if (FieldContentWrapper) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldContentWrapper, null, getReadView());
    return getReadView();
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4b7ef92ae80f881$var$ReadViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _vwz48sxn _1nmz1hna _kqswh2mm _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("78G9e", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6bb243f9f3015c7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<28cc3f1e512619502f58cc6e1fc159db>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d6bb243f9f3015c7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineText_issueFieldSingleLineTextReadviewFull_SingleLineTextReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "text"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$d6bb243f9f3015c7$var$node.hash = "5f51bd1526b02ac7cd91c57eec827a2f";
var $d6bb243f9f3015c7$export$2e2bcd8739ae039 = $d6bb243f9f3015c7$var$node;

});


parcelRegister("hzEzF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa0a0917fd99bb4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4aa0a0917fd99bb4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    confirmButtonLabel: {
        "id": "issue-field-single-line-text-inline-edit-full.single-line-text.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "issue-field-single-line-text-inline-edit-full.single-line-text.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "issue-field-single-line-text-inline-edit-full.single-line-text.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    },
    maxLengthErrorMessage: {
        "id": "issue-field-single-line-text-inline-edit-full.single-line-text.max-length-error-message",
        "defaultMessage": "{maxLength} character limit"
    },
    requiredErrorMessage: {
        "id": "issue-field-single-line-text-inline-edit-full.single-line-text.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});

});

parcelRegister("lecRR", function(module, exports) {

$parcel$export(module.exports, "useSingleLineTextValidator", () => $691633b22d6a360e$export$6955d95abfe9109c);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hzEzF = parcelRequire("hzEzF");
const $691633b22d6a360e$export$6955d95abfe9109c = (fieldName, isRequired, maxLength)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const change = (0, $eUqFw.useCallback)((value)=>{
        if (maxLength && maxLength > 0 && value.length > maxLength) return {
            type: 'error',
            message: formatMessage((0, $hzEzF.default).maxLengthErrorMessage, {
                maxLength: maxLength
            })
        };
        return null;
    }, [
        formatMessage,
        maxLength
    ]);
    const submit = (0, $eUqFw.useCallback)((value)=>{
        if (isRequired && value.trim().length === 0) return {
            type: 'error',
            message: formatMessage((0, $hzEzF.default).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        change: change,
        submit: submit
    };
};

});



parcelRegister("7mkbk", function(module, exports) {

$parcel$export(module.exports, "IssueTypeCell", () => $d366230c090f09b8$export$75b44b408924c851);

var $bhn0w = parcelRequire("bhn0w");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1ogoj = parcelRequire("1ogoj");
const $d366230c090f09b8$export$75b44b408924c851 = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef })=>{
    const { issueType: issueType } = (0, $iWLL0.useFragment)((0, $bhn0w.default), fieldRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ogoj.IconCell), {
        iconUrl: issueType?.avatar?.small,
        name: issueType?.name,
        showErrorIconWhenEmpty: true
    });
});

});
parcelRegister("bhn0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7c53a434f173fde$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7bfcee0dfb23a2020dec682786ec47f8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a7c53a434f173fde$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueType_nativeIssueTable_IssueTypeCell",
    "selections": [
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "small"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraIssueTypeField"
};
$a7c53a434f173fde$var$node.hash = "e81709c5f121dd64c1bf41498bda4ae0";
var $a7c53a434f173fde$export$2e2bcd8739ae039 = $a7c53a434f173fde$var$node;

});

parcelRegister("1ogoj", function(module, exports) {

$parcel$export(module.exports, "IconCell", () => $1120e22bdf27f57d$export$5ffd26a2d6f7e2d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");

var $2qXcq = parcelRequire("2qXcq");
const $1120e22bdf27f57d$export$5ffd26a2d6f7e2d = /*#__PURE__*/ (0, $eUqFw.memo)(({ name: name, iconUrl: iconUrl, showErrorIconWhenEmpty: showErrorIconWhenEmpty })=>{
    if (!name?.length || !iconUrl?.length) return showErrorIconWhenEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "icon",
        reason: "Missing required fields"
    }) : null; // aka an empty cell
    return(// @ts-expect-error Incompatible ref type in tooltip (AK needs "HTMLElement", Compiled provides "HTMLDivElement" somehow these are not compatible in Typescript)
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: name,
        tag: $1120e22bdf27f57d$var$AlignmentFix
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        height: "16",
        width: "16",
        src: iconUrl,
        alt: name
    })));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1120e22bdf27f57d$var$AlignmentFix = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("bUGU0", function(module, exports) {

$parcel$export(module.exports, "LabelsCell", () => $1684e843baa6f4f3$export$b1db1ca9063ebfb8);

var $8Etba = parcelRequire("8Etba");

var $1ePtq = parcelRequire("1ePtq");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $ehDeP = parcelRequire("ehDeP");
var $k85ht = parcelRequire("k85ht");
var $lmIUR = parcelRequire("lmIUR");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g0FAB = parcelRequire("g0FAB");

var $jqoaM = parcelRequire("jqoaM");
var $e27aD = parcelRequire("e27aD");

var $e9kDw = parcelRequire("e9kDw");

var $a4IeB = parcelRequire("a4IeB");

var $7bJW5 = parcelRequire("7bJW5");

var $2qXcq = parcelRequire("2qXcq");

var $h2JSk = parcelRequire("h2JSk");
/**
 * Expected JQL Output: `${jqlTerm} = ${name}`
 */ const $1684e843baa6f4f3$var$getLinkJql = (jqlTerm, name)=>{
    const jast = (0, $ehDeP.default).jast((0, $ehDeP.default).query((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field((0, $7bJW5.escapeBackslashes)(jqlTerm)), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_EQUALS)), (0, $ehDeP.default).valueOperand((0, $7bJW5.escapeBackslashes)(name)))));
    return (0, $lmIUR.print)(jast, {
        operatorCase: (0, $1ybV0.ff)('nin-better-jql-builder-basic_m0m6q') ? 'upper' : undefined
    });
};
const $1684e843baa6f4f3$export$b1db1ca9063ebfb8 = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    /* eslint-disable jira/relay/graphql-naming */ const data = (0, $iWLL0.useFragment)((0, $1ePtq.default), fieldRef);
    /* eslint-enable jira/relay/graphql-naming */ if (data.fieldId === (0, $a4IeB.KNOWN_COLUMN_TYPES).LABELS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1684e843baa6f4f3$export$194e7ceec6d29085, {
        fieldRef: data,
        issueSearchBaseUrl: issueSearchBaseUrl
    });
    const labels = data.selectedLabelsConnection?.edges;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const filteredLabels = (0, $eUqFw.useMemo)(()=>labels?.map((edge)=>edge?.node?.name != null ? {
                key: edge.node.name,
                name: edge.node.name,
                href: `${issueSearchBaseUrl}?jql=${encodeURIComponent($1684e843baa6f4f3$var$getLinkJql(jqlTerm, edge.node.name))}`
            } : null).filter((0, $7bJW5.isNonNullish)) ?? [], [
        labels,
        issueSearchBaseUrl,
        jqlTerm
    ]);
    if (!labels || labels.length !== filteredLabels.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "labels",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jqoaM.default), {
        items: filteredLabels,
        ItemComponent: (0, $e27aD.TagItem),
        PopupContentWrapper: (0, $e27aD.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $h2JSk.default).triggerButton)
    });
});
const $1684e843baa6f4f3$export$194e7ceec6d29085 = ({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl })=>{
    const data = (0, $iWLL0.useFragment)((0, $8Etba.default), fieldRef);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $e9kDw.useLazyLoadEditability)(data.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g0FAB.LabelsInlineEditViewWithIsEditable), {
        spacing: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? 'default' : undefined,
        baseSearchUrl: issueSearchBaseUrl,
        editViewPopup: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo'),
        editViewPopupAlignBlock: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? 'center' : undefined,
        fragmentRef: data,
        isTruncated: true,
        isEditable: isEditable ?? false,
        menuShouldScrollIntoView: false,
        readViewFitContainerHeight: true
    });
};

});
parcelRegister("8Etba", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8116909549b6cbc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c754341dad174530bae6ae2b0ad9010>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b8116909549b6cbc$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "labels_nativeIssueTable_LabelsInlineEditCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraLabelsField"
};
$b8116909549b6cbc$var$node.hash = "49c05ad05b361adda4504ccab382a01c";
var $b8116909549b6cbc$export$2e2bcd8739ae039 = $b8116909549b6cbc$var$node;

});

parcelRegister("1ePtq", function(module, exports) {

$parcel$export(module.exports, "default", () => $40dfb9f349ab9316$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<14a01d21f77762b8bf6dc1773a908d06>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $40dfb9f349ab9316$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "labels_nativeIssueTable_LabelsCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraLabelConnection",
            "kind": "LinkedField",
            "name": "selectedLabelsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraLabelEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraLabel",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedLabelsConnection(first:1000)"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "labels_nativeIssueTable_LabelsInlineEditCell_fieldRef"
        }
    ],
    "type": "JiraLabelsField"
};
$40dfb9f349ab9316$var$node.hash = "4d3abd4e5894c74a98fcfca725bffcab";
var $40dfb9f349ab9316$export$2e2bcd8739ae039 = $40dfb9f349ab9316$var$node;

});

parcelRegister("h2JSk", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f32ac20a6ea1109$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8f32ac20a6ea1109$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.labels.trigger-button",
        "defaultMessage": "See more labels"
    }
});

});


parcelRegister("bqOB5", function(module, exports) {

$parcel$export(module.exports, "ParentCell", () => $c108f351119b3449$export$d5a4cc78f8c5a2cd);

var $cdAIc = parcelRequire("cdAIc");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $2m2yd = parcelRequire("2m2yd");

var $92Rqo = parcelRequire("92Rqo");

var $2qXcq = parcelRequire("2qXcq");

var $7ih9H = parcelRequire("7ih9H");

var $bY3KG = parcelRequire("bY3KG");
const $c108f351119b3449$export$d5a4cc78f8c5a2cd = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef })=>{
    const data = (0, $iWLL0.useFragment)((0, $cdAIc.default), fieldRef);
    /* eslint-enable relay/unused-fields */ const { parentIssue: parentIssue } = data;
    if (!parentIssue) return null;
    if ((0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf')) {
        if (parentIssue.key == null || parentIssue.summaryField?.text == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
            cellType: "parent",
            reason: "Missing required fields"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $92Rqo.ParentReadView), {
            fragmentRef: data
        });
    }
    const summaryField = parentIssue?.fieldsById?.edges?.find((edge)=>edge?.node?.fieldId === 'summary')?.node;
    const issueType = parentIssue?.fieldsById?.edges?.find((edge)=>edge?.node?.fieldId === 'issuetype')?.node?.issueType;
    if (parentIssue?.key == null || summaryField?.text == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "parent",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c108f351119b3449$var$StyledDiv, null, issueType?.name != null && issueType?.avatar?.small != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2m2yd.default), {
        value: {
            name: issueType.name,
            iconUrl: issueType.avatar.small
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bY3KG.StyledLink), {
        href: `/browse/${parentIssue.key}`
    }, summaryField.text));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c108f351119b3449$var$StyledDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7ih9H.TableCellFocusBox), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt _1e0c1txw _4cvr1h6o _tkqh1txw _dvzt1h6o _j7aj78py",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cdAIc", function(module, exports) {

$parcel$export(module.exports, "default", () => $67397775970e599f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e4e3dfdf55ca5a6fa3754420f5d16995>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $67397775970e599f$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "text"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "parent_nativeIssueTable_ParentCell",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraSingleLineTextField",
                                "kind": "LinkedField",
                                "name": "summaryField",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "issuetype",
                                            "summary"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraAvatar",
                                                                        "kind": "LinkedField",
                                                                        "name": "avatar",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "small"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "name"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": v0 /*: any*/ ,
                                                        "type": "JiraSingleLineTextField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"issuetype\",\"summary\"])"
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "parent_issueFieldParentReadviewFull_ParentReadView"
                    }
                ]
            }
        ],
        "type": "JiraParentIssueField"
    };
}();
$67397775970e599f$var$node.hash = "e9c64431688deaaeef9da35f41c83439";
var $67397775970e599f$export$2e2bcd8739ae039 = $67397775970e599f$var$node;

});

parcelRegister("2m2yd", function(module, exports) {

$parcel$export(module.exports, "default", () => $940b09b5ceb267fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");
const $940b09b5ceb267fc$var$IssueTypePickerReadOnly = ({ value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $940b09b5ceb267fc$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: value.name,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        height: "16",
        width: "16",
        src: value.iconUrl,
        alt: value.name
    })));
var $940b09b5ceb267fc$export$2e2bcd8739ae039 = $940b09b5ceb267fc$var$IssueTypePickerReadOnly;
const $940b09b5ceb267fc$var$wrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.050'
});

});

parcelRegister("92Rqo", function(module, exports) {

$parcel$export(module.exports, "ParentReadView", () => $30ff9a79674f8b15$export$72990b9b43fe6c69);

var $7PhZ8 = parcelRequire("7PhZ8");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cRXCh = parcelRequire("cRXCh");

var $kDzKU = parcelRequire("kDzKU");

var $kl1W4 = parcelRequire("kl1W4");
const $30ff9a79674f8b15$export$72990b9b43fe6c69 = ({ fragmentRef: fragmentRef, disableClickAction: disableClickAction, emptyText: emptyText, onClick: onClick })=>{
    const { parentIssue: parentIssue } = (0, $iWLL0.useFragment)((0, $7PhZ8.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!parentIssue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cRXCh.EmptyFieldText), {
        emptyText: emptyText
    });
    const issueType = parentIssue.issueTypeField?.issueType;
    const label = `${parentIssue.key} ${parentIssue.summaryField?.text ?? ''}`;
    const iconUrl = issueType?.avatar?.xsmall;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        space: "space.100",
        xcss: $30ff9a79674f8b15$var$containerStyles
    }, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30ff9a79674f8b15$var$Icon, {
        src: iconUrl,
        alt: formatMessage((0, $kDzKU.default).icon, {
            issueType: issueType?.name ?? ''
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kl1W4.Summary), {
        disableClickAction: disableClickAction,
        issueKey: parentIssue.key,
        label: label,
        colorKey: parentIssue.issueColorField?.color?.colorKey,
        onClick: onClick
    })));
};
const $30ff9a79674f8b15$var$containerStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $30ff9a79674f8b15$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f7vkz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7PhZ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d0d66da361318d1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eee6ea3a8b3b25ed9fa4c9e85d091d71>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2d0d66da361318d1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "parent_issueFieldParentReadviewFull_ParentReadView",
    "selections": [
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "parentIssue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "JiraColorField",
                    "kind": "LinkedField",
                    "name": "issueColorField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraColor",
                            "kind": "LinkedField",
                            "name": "color",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "colorKey"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraIssueTypeField",
                    "kind": "LinkedField",
                    "name": "issueTypeField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "xsmall"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraSingleLineTextField",
                    "kind": "LinkedField",
                    "name": "summaryField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "text"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraParentIssueField"
};
$2d0d66da361318d1$var$node.hash = "f9cdc2acd2c426037f13d9ef6280fd67";
var $2d0d66da361318d1$export$2e2bcd8739ae039 = $2d0d66da361318d1$var$node;

});

parcelRegister("kDzKU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9446df507065fb93$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9446df507065fb93$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    icon: {
        "id": "issue-field-parent-readview-full.parent.icon",
        "defaultMessage": "{issueType} icon"
    }
});

});

parcelRegister("kl1W4", function(module, exports) {

$parcel$export(module.exports, "Summary", () => $153902b46765a18a$export$46453a0401d6cd1a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lPQPn = parcelRequire("lPQPn");

var $kJlBc = parcelRequire("kJlBc");

var $jmc5s = parcelRequire("jmc5s");
const $153902b46765a18a$export$46453a0401d6cd1a = ({ disableClickAction: disableClickAction, onClick: onClick, label: label, colorKey: colorKey, issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const lozengeTheme = (0, $eUqFw.useMemo)(()=>colorKey ? (0, $lPQPn.getLozengeThemeByColor)((0, $lPQPn.asColor)(colorKey)) : undefined, [
        colorKey
    ]);
    if (disableClickAction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($153902b46765a18a$var$WrapperNoClick, {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: lozengeTheme
    }, label);
    if (onClick != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($153902b46765a18a$var$ButtonText, {
        onClick: onClick,
        style: lozengeTheme
    }, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($153902b46765a18a$var$LinkText, {
        "data-testid": "issue-field-parent-readview-full.ui.parent.summary.view-link",
        href: `/browse/${issueKey}`,
        "aria-label": formatMessage((0, $jmc5s.default).parentTitle, {
            label: label
        }),
        style: lozengeTheme
    }, label);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $153902b46765a18a$var$LinkText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $kJlBc.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _80omtlke _vwz47vkz _4t3i7vkz _p12f1osq _2rko1l7b _1yt4u49m _1wybdlk8 _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $153902b46765a18a$var$ButtonText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _19itglyw _11q7glyw _syaz1kw7 _11c81kw7 _12ji1r31 _1qu21kw7 _12y31o36 _80omtlke _4t3igktf _p12f1osq _2rko1l7b _1yt4u49m _1wybdlk8 _vwz47vkz _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $153902b46765a18a$var$WrapperNoClick = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _1e0c1ule _vwz47vkz _4t3i7vkz _2rko1l7b _1yt4u49m _1wybdlk8 _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jmc5s", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e06efea500595d1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3e06efea500595d1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    parentTitle: {
        "id": "issue-field-parent-readview-full.parent.summary.parent-title",
        "defaultMessage": "Click to visit {label}"
    }
});

});



parcelRegister("bY3KG", function(module, exports) {

$parcel$export(module.exports, "StyledLink", () => $1c0f713f4714f044$export$9048d548939551ee);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6Zxhw = parcelRequire("6Zxhw");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1c0f713f4714f044$var$StyledLinkStylesWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1km41fxt _h5vpcj1k _1jeaqfx8 _19s31e54 _l4cw1tcg _1rg815vq _1yoo15vq _1o1716l4 _rlyh16l4",
            __cmplp.className
        ])
    });
});
const $1c0f713f4714f044$export$9048d548939551ee = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1c0f713f4714f044$var$StyledLinkStylesWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Zxhw.default), props));

});


parcelRegister("3wjH8", function(module, exports) {

$parcel$export(module.exports, "PlainTextCell", () => $548ca1815cd860b9$export$4e4b42df80bf4dce);

var $hxlwT = parcelRequire("hxlwT");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $jRa2u = parcelRequire("jRa2u");
const $548ca1815cd860b9$export$4e4b42df80bf4dce = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false })=>{
    const { text: text } = (0, $iWLL0.useFragment)((0, $hxlwT.default), fieldRef);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(shouldOpenOnFirstRender);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRa2u.TruncatedTextWithPopup), {
        isOpen: isOpen,
        onSetIsOpen: setIsOpen,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, text),
        triggerText: text ?? null
    });
});

});
parcelRegister("hxlwT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f47276966b63948$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ccbf7038bc249ef39dd9bef68841a377>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3f47276966b63948$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "plainText_nativeIssueTable_PlainTextCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "text"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$3f47276966b63948$var$node.hash = "f3885c34c9bef325f41889fe211cc3d3";
var $3f47276966b63948$export$2e2bcd8739ae039 = $3f47276966b63948$var$node;

});

parcelRegister("jRa2u", function(module, exports) {

$parcel$export(module.exports, "TruncatedTextWithPopup", () => $e76877951272841d$export$a81ef5b6e801751b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3MV1G = parcelRequire("3MV1G");

var $kGQen = parcelRequire("kGQen");

var $1ybV0 = parcelRequire("1ybV0");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $d6f6c = parcelRequire("d6f6c");

var $jQcwQ = parcelRequire("jQcwQ");
const $e76877951272841d$export$a81ef5b6e801751b = /*#__PURE__*/ (0, $eUqFw.memo)(({ triggerText: triggerText, content: content, triggerRefCallback: triggerRefCallback, onSetIsOpen: onSetIsOpen, isOpen: isOpen })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    if (!triggerText) return null;
    const onClick = ()=>{
        onSetIsOpen(!isOpen);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'truncatedTextWithPopupButton');
    };
    const trigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e76877951272841d$var$TruncatedTextContainer, {
            onClick: onClick,
            ...triggerProps,
            ref: (element)=>{
                triggerRefCallback && triggerRefCallback(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref(element);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e76877951272841d$var$TruncatedText, null, triggerText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.Popup), {
        isOpen: isOpen,
        onClose: ()=>onSetIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
                sourceName: "TruncatedTextPopUpContent",
                sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
            }, content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null)),
        trigger: trigger,
        placement: "bottom",
        popupComponent: (0, $jQcwQ.PopupContainer)
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e76877951272841d$var$TruncatedTextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80omtlke _1e0c1ule _11q7glyw _19itglyw _vchhusvi _1wybdlk8 _vwz4gktf _syaz1fxt _6sshglyw _uus9ynhg _nt751r31 _49pcglyw _1hvw1o36 _7ehi2jkb",
            (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? "_4t3i1osq _1bsb1osq _1rjc1b66 _18zru2gc _19lck6hx" : "_18s8x0bf _1yt4u2gc _2rkoi2wt _1dbzet05",
            __cmplp.className
        ])
    });
});
const $e76877951272841d$var$TruncatedText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h _1e0ccj1k _1reo15vq _18m915vq _1bto1l2s _sudp1e54 _1yyjcs5v _1nmz1hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jQcwQ", function(module, exports) {

$parcel$export(module.exports, "PopupContainer", () => $89e7c855e48c9a09$export$cca08eed9de89ba9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $lcnyw = parcelRequire("lcnyw");
// Workaround for https://github.com/atlassian-labs/compiled/issues/1200
const $89e7c855e48c9a09$var$layerValue = (0, $lcnyw.layers).layer;
/**
 * Styling the container itself removes the need for an additional nested `<div>`,
 * containing our custom styles, in the Popup content. Having an extra `<div>`
 * introduces problems with autofocus when popup is opened.
 *
 * Unfortunately the base PopupContainer styles are not exported from atlaskit,
 * so they had to be copy + pasted and extended with our custom styles.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89e7c855e48c9a09$var$StyledPopupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _vchhusvi _1pby1nn1 _16jlkb7n _1o9zkb7n _i0dl1wug _bfhk1bhr _2rko1sit _16qs1mxi _1reo1wug _18m91wug _1bsbdgin _c71l1kdj _1tke12am _1yt4u2gc _19it24b2 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});
const $89e7c855e48c9a09$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($89e7c855e48c9a09$var$StyledPopupContainer, {
        ...props,
        ref: ref
    }));

});



parcelRegister("itPYJ", function(module, exports) {

$parcel$export(module.exports, "PriorityCell", () => $512cb1c4fe4b1bdd$export$b526cf238a0a0ab3);

var $7CZ2Y = parcelRequire("7CZ2Y");

var $93INW = parcelRequire("93INW");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $7lwYT = parcelRequire("7lwYT");

var $e9kDw = parcelRequire("e9kDw");

var $1ogoj = parcelRequire("1ogoj");
const $512cb1c4fe4b1bdd$export$b526cf238a0a0ab3 = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef })=>{
    const priorityField = (0, $iWLL0.useFragment)(/* eslint-disable jira/relay/graphql-naming */ (0, $93INW.default), fieldRef);
    const { priority: priority } = priorityField;
    return (0, $1ybV0.ff)('nin-priority-inline-edit') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($512cb1c4fe4b1bdd$var$PriorityCellInternal, {
        fieldRef: priorityField
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($512cb1c4fe4b1bdd$var$PriorityCellInternOld, {
        priority: priority
    });
});
const $512cb1c4fe4b1bdd$var$PriorityCellInternOld = ({ priority: priority })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ogoj.IconCell), {
        iconUrl: priority?.iconUrl,
        name: priority?.name,
        showErrorIconWhenEmpty: false
    });
const $512cb1c4fe4b1bdd$var$PriorityCellInternal = ({ fieldRef: fieldRef })=>{
    const data = (0, $iWLL0.useFragment)((0, $7CZ2Y.default), fieldRef);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $e9kDw.useLazyLoadEditability)(data.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7lwYT.PriorityInlineEditViewIsEditable), {
        spacing: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? 'default' : undefined,
        editViewPopup: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo'),
        editViewPopupAlignBlock: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? 'center' : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true
    });
};

});
parcelRegister("7CZ2Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $760de3ab21ec59b4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e91efb2011196c12c342b0d00dda9b1d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $760de3ab21ec59b4$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "priority_nativeIssueTable_PriorityCellInternal_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraPriorityField"
};
$760de3ab21ec59b4$var$node.hash = "70d6128677fa86cfa20e2a0021106159";
var $760de3ab21ec59b4$export$2e2bcd8739ae039 = $760de3ab21ec59b4$var$node;

});

parcelRegister("93INW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6d8d3ceb53c1fcf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9c5920d5c64cf7d2a4bfc4c42545752d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a6d8d3ceb53c1fcf$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcpriorityinlineeditrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "priority_nativeIssueTable_PriorityCell",
    "selections": [
        {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcpriorityinlineeditrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "priority_nativeIssueTable_PriorityCellInternal_fieldRef"
                }
            ]
        }
    ],
    "type": "JiraPriorityField"
};
$a6d8d3ceb53c1fcf$var$node.hash = "29fcba618b61ab9cfc7738cee73c3760";
var $a6d8d3ceb53c1fcf$export$2e2bcd8739ae039 = $a6d8d3ceb53c1fcf$var$node;

});

parcelRegister("7lwYT", function(module, exports) {

$parcel$export(module.exports, "PriorityInlineEditViewIsEditable", () => $2e0144a8e7692100$export$90b66d052260aa39);

var $js3Id = parcelRequire("js3Id");

var $6nnS5 = parcelRequire("6nnS5");

var $dHTJ4 = parcelRequire("dHTJ4");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $iQYHK = parcelRequire("iQYHK");

var $lt1uI = parcelRequire("lt1uI");

var $jbrNM = parcelRequire("jbrNM");

var $758nl = parcelRequire("758nl");
const $2e0144a8e7692100$var$isEqualPriority = (a, b)=>a?.value === b?.value;
const $2e0144a8e7692100$export$90b66d052260aa39 = ({ spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isCompact: isCompact, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, isEditable: isFieldEditable, readViewFitContainerHeight: readViewFitContainerHeight })=>{
    // #region Relay
    const data = (0, $iWLL0.useFragment)((0, $dHTJ4.default), fragmentRef);
    const { id: uniqueFieldId, name: fieldName, priority: priority } = data;
    const [commit] = (0, $iWLL0.useMutation)((0, $6nnS5.default));
    // #endregion
    const initialValue = (0, $eUqFw.useMemo)(()=>priority ? {
            label: priority.name ?? '',
            value: priority.id,
            iconUrl: priority.iconUrl ?? ''
        } : null, [
        priority
    ]);
    // #region Common state
    const [updatedValue, setUpdatedValue] = (0, $eUqFw.useState)(initialValue);
    const handleSubmit = (0, $eUqFw.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(option);
        if (option?.value != null) commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updatePriorityField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updatePriorityField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            priority: {
                                id: option.value,
                                iconUrl: option.iconUrl,
                                name: option.label
                            }
                        }
                    }
                }
            }
        });
    }, [
        onSubmit,
        commit,
        uniqueFieldId
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $iQYHK.useFieldInlineEditActions)({
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        initialValue: initialValue,
        isValueEqual: $2e0144a8e7692100$var$isEqualPriority,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue
    });
    const renderReadView = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $758nl.PriorityReadView), {
            fragmentRef: data,
            isCompact: isCompact
        }), [
        data,
        isCompact
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? spacing : undefined,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            openMenuOnFocus: true
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lt1uI.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $jbrNM.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $2e0144a8e7692100$export$934d144304ae7d88 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $iWLL0.useFragment)((0, $js3Id.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2e0144a8e7692100$export$90b66d052260aa39, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("js3Id", function(module, exports) {

$parcel$export(module.exports, "default", () => $43825f1ffbfff678$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aa62d4fc64bc2c74e04363ef91ec33f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $43825f1ffbfff678$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraPriorityField"
};
$43825f1ffbfff678$var$node.hash = "a5f9582db120fe1c7d1ede5d19fc0614";
var $43825f1ffbfff678$export$2e2bcd8739ae039 = $43825f1ffbfff678$var$node;

});

parcelRegister("6nnS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c486640abff307d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb32ad0218f1234eb10ceea6afef44da>>
 * @relayHash afc6cf650d76ec77ae6c4e967b74c46b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e85774926933c84980d45da86dae031162c7414ce78af28e54effc3c4a04a2fa
const $1c486640abff307d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraPriority",
        "kind": "LinkedField",
        "name": "priority",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "priority_issueFieldPriority_PriorityField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPriorityFieldPayload",
                            "kind": "LinkedField",
                            "name": "updatePriorityField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraPriorityField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "priority_issueFieldPriority_PriorityField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPriorityFieldPayload",
                            "kind": "LinkedField",
                            "name": "updatePriorityField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraPriorityField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e85774926933c84980d45da86dae031162c7414ce78af28e54effc3c4a04a2fa",
            "metadata": {},
            "name": "priority_issueFieldPriority_PriorityField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$1c486640abff307d$var$node.hash = "e0f2a7894e2dd7cf045761e8324c5c39";
var $1c486640abff307d$export$2e2bcd8739ae039 = $1c486640abff307d$var$node;

});

parcelRegister("dHTJ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b830f66c04e33d58$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7687d6a038a81bd5a15174dd6aca676d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b830f66c04e33d58$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "priority_issueFieldPriorityReadviewFull_PriorityReadView"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            }
        ],
        "type": "JiraPriorityField"
    };
}();
$b830f66c04e33d58$var$node.hash = "5c87c8c190fde008c7c6d3bde3e475a1";
var $b830f66c04e33d58$export$2e2bcd8739ae039 = $b830f66c04e33d58$var$node;

});

parcelRegister("jbrNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f18f8ab4ee69fa5c$export$2e2bcd8739ae039);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $f18f8ab4ee69fa5c$var$PriorityEditViewEntryPoint = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("dQNG4")), {
        moduleId: "079c16d8"
    }),
    getPreloadProps: ()=>({})
});
var $f18f8ab4ee69fa5c$export$2e2bcd8739ae039 = $f18f8ab4ee69fa5c$var$PriorityEditViewEntryPoint;

});
parcelRegister("dQNG4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dQT0a');
        const value = parcelRequire('iBBBM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dQT0a").then(()=>parcelRequire('iBBBM'));
}

});


parcelRegister("758nl", function(module, exports) {

$parcel$export(module.exports, "PriorityReadView", () => $48c54fe6657a2c43$export$9ff40693dcfb2eb3);

var $9WH4g = parcelRequire("9WH4g");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $hnzPP = parcelRequire("hnzPP");

var $cRXCh = parcelRequire("cRXCh");
const $48c54fe6657a2c43$export$9ff40693dcfb2eb3 = ({ fragmentRef: fragmentRef, isCompact: isCompact })=>{
    const data = (0, $iWLL0.useFragment)((0, $9WH4g.default), fragmentRef);
    const value = data.priority;
    if (isCompact && (!value?.name || !value?.iconUrl)) return null;
    if (!value?.name || !value?.iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cRXCh.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($48c54fe6657a2c43$var$Wrapper, {
        "data-testid": "issue-field-priority-readview-full.ui.priority.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
        url: value.iconUrl,
        alt: isCompact ? value.name : undefined
    }), !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($48c54fe6657a2c43$var$Text, null, value.name));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $48c54fe6657a2c43$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4t3igktf _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $48c54fe6657a2c43$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9WH4g", function(module, exports) {

$parcel$export(module.exports, "default", () => $2866c6c1eac646d5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac973913f9060bb519739c5dc997ac7d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2866c6c1eac646d5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priority_issueFieldPriorityReadviewFull_PriorityReadView",
    "selections": [
        {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                }
            ]
        }
    ],
    "type": "JiraPriorityField"
};
$2866c6c1eac646d5$var$node.hash = "332bda8ea012bca1bc3e1ad5426cb13a";
var $2866c6c1eac646d5$export$2e2bcd8739ae039 = $2866c6c1eac646d5$var$node;

});




parcelRegister("dRNCA", function(module, exports) {

$parcel$export(module.exports, "ProjectCell", () => $f112f95a678da5f4$export$a0acc7707bde1d3);

var $j7DDp = parcelRequire("j7DDp");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $aA1aH = parcelRequire("aA1aH");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2qXcq = parcelRequire("2qXcq");
const $f112f95a678da5f4$export$a0acc7707bde1d3 = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef, isRequired: isRequired })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { project: project } = (0, $iWLL0.useFragment)((0, $j7DDp.default), fieldRef);
    if (!isRequired && project == null) return null;
    if (project == null || project.name == null || project.key == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "project",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f112f95a678da5f4$var$AlignmentFix, {
        hasAvatar: Boolean(project.avatar?.large)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aA1aH.ProjectReadView), {
        value: {
            key: project.key,
            name: project.name,
            avatarUrls: {
                '48x48': project.avatar?.large ?? ''
            }
        },
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'tableIssueLink');
        }
    }));
});
// The Project component has a 4px padding plus the avatar inside has a 2px invisible border that we have to account for
// Refer to: src/packages/issue/fields/project/src/ui/view/main.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f112f95a678da5f4$var$AlignmentFix = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasAvatar: hasAvatar, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1j10ze3t",
            __cmplp.hasAvatar ? "_18u01i6y" : "_18u0ze3t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j7DDp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2018eb5f7d12fd4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d4391b734baea4c914f9e60292024f8f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b2018eb5f7d12fd4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "project_nativeIssueTable_ProjectCell",
    "selections": [
        {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "large"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraProjectField"
};
$b2018eb5f7d12fd4$var$node.hash = "c851920165e477cda5ca7d8297976e75";
var $b2018eb5f7d12fd4$export$2e2bcd8739ae039 = $b2018eb5f7d12fd4$var$node;

});


parcelRegister("fwttk", function(module, exports) {

$parcel$export(module.exports, "RequestTypeCell", () => $fc14ddba104e7662$export$f5707174b12c16a9);

var $2WGJx = parcelRequire("2WGJx");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $2qXcq = parcelRequire("2qXcq");
const $fc14ddba104e7662$var$REQUEST_TYPE_IMAGE_SIZE = 16;
const $fc14ddba104e7662$export$f5707174b12c16a9 = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef })=>{
    const { requestType: requestType } = (0, $iWLL0.useFragment)((0, $2WGJx.default), fieldRef);
    if (!requestType) return null;
    if (!requestType.name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "requestType",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        space: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? 'space.100' : undefined
    }, requestType?.avatar?.xsmall && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? $fc14ddba104e7662$var$imageContainerStyles : $fc14ddba104e7662$var$imageContainerStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: requestType.avatar.xsmall,
        width: $fc14ddba104e7662$var$REQUEST_TYPE_IMAGE_SIZE,
        alt: ""
    })), (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $fc14ddba104e7662$var$textOverflowStyles
    }, requestType.name) : requestType.name);
});
const $fc14ddba104e7662$var$imageContainerStylesOld = (0, $1ZAYh.xcss)({
    marginInlineEnd: 'space.075',
    display: 'inline',
    height: `${$fc14ddba104e7662$var$REQUEST_TYPE_IMAGE_SIZE}px`
});
const $fc14ddba104e7662$var$imageContainerStyles = (0, $1ZAYh.xcss)({
    display: 'inline',
    height: `${$fc14ddba104e7662$var$REQUEST_TYPE_IMAGE_SIZE}px`
});
const $fc14ddba104e7662$var$textOverflowStyles = (0, $1ZAYh.xcss)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word'
});

});
parcelRegister("2WGJx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69abf3809d0932c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e711fe99884e965a8947360643fa4d6a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a69abf3809d0932c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "requestType_nativeIssueTable_RequestTypeCell",
    "selections": [
        {
            "concreteType": "JiraServiceManagementRequestType",
            "kind": "LinkedField",
            "name": "requestType",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "xsmall"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraServiceManagementRequestTypeField"
};
$a69abf3809d0932c$var$node.hash = "e6355f63f017fb970ee2b3c6b04144d9";
var $a69abf3809d0932c$export$2e2bcd8739ae039 = $a69abf3809d0932c$var$node;

});


parcelRegister("6ydPH", function(module, exports) {

$parcel$export(module.exports, "ResolutionCell", () => $4f98857103a7e50a$export$8b67413bfec99fe);

var $9iMLz = parcelRequire("9iMLz");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jYgDq = parcelRequire("jYgDq");
const $4f98857103a7e50a$export$8b67413bfec99fe = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { resolution: resolution } = (0, $iWLL0.useFragment)((0, $9iMLz.default), fieldRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f98857103a7e50a$var$Cell, null, resolution?.name ?? formatMessage((0, $jYgDq.default).unresolved));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f98857103a7e50a$var$Cell = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9iMLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $506fc88e6aa6c7d6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c735683ae8c3dfc9825b7e9760388a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $506fc88e6aa6c7d6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "resolution_nativeIssueTable_ResolutionCell",
    "selections": [
        {
            "concreteType": "JiraResolution",
            "kind": "LinkedField",
            "name": "resolution",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraResolutionField"
};
$506fc88e6aa6c7d6$var$node.hash = "f08df2df05baaf8922c9554fb39bd5f7";
var $506fc88e6aa6c7d6$export$2e2bcd8739ae039 = $506fc88e6aa6c7d6$var$node;

});

parcelRegister("jYgDq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c5af18ff897730f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6c5af18ff897730f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unresolved: {
        "id": "native-issue-table.common.issue-cells.resolution.unresolved",
        "defaultMessage": "Unresolved"
    }
});

});


parcelRegister("7O70U", function(module, exports) {

$parcel$export(module.exports, "RichTextCell", () => $759a1dd6fe6ce84a$export$b77590c339790c17);

var $16G1n = parcelRequire("16G1n");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $4Bees = parcelRequire("4Bees");

var $6j4bv = parcelRequire("6j4bv");

var $l3Qg0 = parcelRequire("l3Qg0");

var $1HzcR = parcelRequire("1HzcR");

var $dWLk9 = parcelRequire("dWLk9");

var $a4IeB = parcelRequire("a4IeB");

var $jRa2u = parcelRequire("jRa2u");

var $hVf7s = parcelRequire("hVf7s");

var $iI0Al = parcelRequire("iI0Al");
const $759a1dd6fe6ce84a$var$runtimeProps = {};
const $759a1dd6fe6ce84a$export$b77590c339790c17 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, fieldRef: fieldRef, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false })=>{
    const { richText: richText, fieldId: fieldId } = (0, $iWLL0.useFragment)((0, $16G1n.default), fieldRef);
    const plainText = richText?.adfValue?.convertedPlainText?.plainText || '';
    const cloudId = (0, $dWLk9.useCloudId)();
    const entryPointParams = (0, $eUqFw.useMemo)(()=>({
            fieldId: fieldId,
            issueKey: issueKey,
            cloudId: cloudId
        }), [
        fieldId,
        cloudId,
        issueKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $iI0Al.richTextPopUpContentEntryPoint), entryPointParams);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(shouldOpenOnFirstRender);
    const triggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRa2u.TruncatedTextWithPopup), {
        triggerText: plainText,
        triggerRefCallback: triggerRef,
        isOpen: isOpen,
        onSetIsOpen: setIsOpen,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "rich-text-popup-content",
            packageName: (0, $a4IeB.PACKAGE_NAME),
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hVf7s.ErrorState), null),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
                size: "medium"
            }),
            runtimeProps: $759a1dd6fe6ce84a$var$runtimeProps
        })
    });
});

});
parcelRegister("16G1n", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa60191e323c75a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc385d44d13ca1facbbd3007cb97d173>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8fa60191e323c75a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "richText_nativeIssueTable_RichTextCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "concreteType": "JiraRichText",
            "kind": "LinkedField",
            "name": "richText",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraADF",
                    "kind": "LinkedField",
                    "name": "adfValue",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraAdfToConvertedPlainText",
                            "kind": "LinkedField",
                            "name": "convertedPlainText",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "plainText"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraRichTextField"
};
$8fa60191e323c75a$var$node.hash = "1a0c9dec8a75d610560982a633e52c7e";
var $8fa60191e323c75a$export$2e2bcd8739ae039 = $8fa60191e323c75a$var$node;

});

parcelRegister("hVf7s", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $dbbbe244a94fdec7$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $96IgR = parcelRequire("96IgR");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $armAz = parcelRequire("armAz");

var $lAcHt = parcelRequire("lAcHt");
const $dbbbe244a94fdec7$export$c1ed4f415b9e7023 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dbbbe244a94fdec7$var$StyledBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        primaryColor: `var(--ds-icon, ${(0, $PdmhA).N500})`,
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lAcHt.StyledText), null, formatMessage((0, $armAz.default).errorMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dbbbe244a94fdec7$var$StyledBox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _1tkeqkoa _1bah1h6o _18s8174b _w8l5t9kd _1752t9kd",
            __cmplp.className
        ])
    });
});

});
parcelRegister("armAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4969d59ed34a41d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $b4969d59ed34a41d$var$messages = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "native-issue-table.common.issue-cells.rich-text.error-state.error-message",
        "defaultMessage": "Something went wrong. Close and re-open this modal to try again."
    }
});
var $b4969d59ed34a41d$export$2e2bcd8739ae039 = $b4969d59ed34a41d$var$messages;

});

parcelRegister("lAcHt", function(module, exports) {

$parcel$export(module.exports, "StyledText", () => $a0240773be663341$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a0240773be663341$var$StyledTextComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $a0240773be663341$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0240773be663341$var$StyledTextComponent, props));

});


parcelRegister("iI0Al", function(module, exports) {

$parcel$export(module.exports, "richTextPopUpContentEntryPoint", () => $8d8cf3a0181d8b37$export$6c4574991456a42);

var $ySNgq = parcelRequire("ySNgq");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $8d8cf3a0181d8b37$export$6c4574991456a42 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("k8PPN")), {
        moduleId: "e30443a3"
    }),
    getPreloadProps: ({ issueKey: issueKey, fieldId: fieldId, cloudId: cloudId })=>({
            queries: {
                richTextContent: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $ySNgq.default,
                    variables: {
                        issueKey: issueKey,
                        fieldId: fieldId,
                        cloudId: cloudId
                    }
                }
            },
            extraProps: {
                issueKey: issueKey
            }
        })
});

});
parcelRegister("ySNgq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1a0dca2d2f85486$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c2c716a7797d9a059c8b95939e0d77b9>>
 * @relayHash adc73b9c1253142f5ef8cb9f6818aa5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f507009c4ed6301683b3bda837b1afe12c22a08d38124b8056f009c724c8dc0
const $c1a0dca2d2f85486$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5f507009c4ed6301683b3bda837b1afe12c22a08d38124b8056f009c724c8dc0",
        "metadata": {},
        "name": "ui_RichTextPopUpContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c1a0dca2d2f85486$export$2e2bcd8739ae039 = $c1a0dca2d2f85486$var$node;

});

parcelRegister("k8PPN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2Mbmm')
        ]);
        const value = parcelRequire('aIyed');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2Mbmm")
    ]).then(()=>parcelRequire('aIyed'));
}

});



parcelRegister("hVevm", function(module, exports) {

$parcel$export(module.exports, "SprintCell", () => $c98c47397e8f6852$export$a092d4418bd765b8);

var $gaGeP = parcelRequire("gaGeP");

var $j84ug = parcelRequire("j84ug");

var $g53LI = parcelRequire("g53LI");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $ehDeP = parcelRequire("ehDeP");
var $k85ht = parcelRequire("k85ht");
var $lmIUR = parcelRequire("lmIUR");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9YDUP = parcelRequire("9YDUP");

var $jqoaM = parcelRequire("jqoaM");
var $6pzUl = parcelRequire("6pzUl");

var $eBHAy = parcelRequire("eBHAy");

var $e9kDw = parcelRequire("e9kDw");

var $7bJW5 = parcelRequire("7bJW5");

var $2qXcq = parcelRequire("2qXcq");

var $gOuHz = parcelRequire("gOuHz");
/**
 * Expected JQL Output: `${jqlTerm} = ${name}`
 */ const $c98c47397e8f6852$var$getLinkJql = (jqlTerm, name)=>{
    const jast = (0, $ehDeP.default).jast((0, $ehDeP.default).query((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field((0, $7bJW5.escapeBackslashes)(jqlTerm)), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_EQUALS)), (0, $ehDeP.default).valueOperand((0, $7bJW5.escapeBackslashes)(name)))));
    return (0, $lmIUR.print)(jast, {
        operatorCase: (0, $1ybV0.ff)('nin-better-jql-builder-basic_m0m6q') ? 'upper' : undefined
    });
};
/**
 * Expected JQL Output: `${jqlTerm} = ${sprintId}`
 */ const $c98c47397e8f6852$var$getSprintJql = (jqlTerm, sprintId)=>{
    const jast = (0, $ehDeP.default).jast((0, $ehDeP.default).query((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field((0, $7bJW5.escapeBackslashes)(jqlTerm)), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_EQUALS)), (0, $ehDeP.default).valueOperand(String(sprintId)))));
    return (0, $lmIUR.print)(jast, {
        operatorCase: (0, $1ybV0.ff)('nin-better-jql-builder-basic_m0m6q') ? 'upper' : undefined
    });
};
const $c98c47397e8f6852$export$a092d4418bd765b8 = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef, projectKey: projectKey, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm })=>{
    const data = (0, $iWLL0.useFragment)(/* eslint-disable jira/relay/graphql-naming */ (0, $g53LI.default), fieldRef);
    if ((0, $1ybV0.ff)('one-issue-table-sprint-inline-edit')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c98c47397e8f6852$var$SprintCellInternal, {
        fieldRef: data,
        issueSearchBaseUrl: issueSearchBaseUrl,
        jqlTerm: jqlTerm,
        projectKey: projectKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c98c47397e8f6852$var$SprintCellInternalOld, {
        fieldRef: data,
        issueSearchBaseUrl: issueSearchBaseUrl,
        jqlTerm: jqlTerm
    });
});
const $c98c47397e8f6852$var$SprintCellInternal = ({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm, projectKey: projectKey })=>{
    const data = (0, $iWLL0.useFragment)((0, $j84ug.default), fieldRef);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $e9kDw.useLazyLoadEditability)(data.id, isEditable);
    const [restrictSprints, { onRestrictSprints: onRestrictSprints }] = (0, $eBHAy.useRestrictSprints)();
    const getUrl = (0, $eUqFw.useCallback)((sprintId)=>{
        const jql = $c98c47397e8f6852$var$getSprintJql(jqlTerm, sprintId);
        return `${issueSearchBaseUrl}?jql=${encodeURIComponent(jql)}`;
    }, [
        issueSearchBaseUrl,
        jqlTerm
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9YDUP.SprintInlineEditViewIsEditable), {
        spacing: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? 'default' : undefined,
        editViewPopup: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo'),
        editViewPopupAlignBlock: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? 'center' : undefined,
        fragmentRef: data,
        getUrl: getUrl,
        isEditable: isEditable ?? false,
        onRestrictSprints: onRestrictSprints,
        projectKey: projectKey,
        readViewFitContainerHeight: true,
        restrictSprints: restrictSprints
    });
};
const $c98c47397e8f6852$var$SprintCellInternalOld = ({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { selectedSprintsConnection: selectedSprintsConnection } = (0, $iWLL0.useFragment)((0, $gaGeP.default), fieldRef);
    const sprints = selectedSprintsConnection?.edges;
    const filteredSprints = (0, $eUqFw.useMemo)(()=>sprints?.map((edge)=>edge?.node?.name != null ? {
                key: edge.node.name,
                name: edge.node.name,
                href: `${issueSearchBaseUrl}?jql=${encodeURIComponent($c98c47397e8f6852$var$getLinkJql(jqlTerm, edge.node.name))}`
            } : null).filter((0, $7bJW5.isNonNullish)) ?? [], [
        sprints,
        issueSearchBaseUrl,
        jqlTerm
    ]);
    if (!sprints || sprints.length !== filteredSprints.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "sprint",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jqoaM.default), {
        items: filteredSprints,
        ItemComponent: (0, $6pzUl.LinkItem),
        PopupContentWrapper: (0, $6pzUl.LinkItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $gOuHz.default).triggerButton)
    });
};

});
parcelRegister("gaGeP", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e697fdebff034c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<75ac5fe45807377ad77c7105a2dd996e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $61e697fdebff034c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "sprint_nativeIssueTable_SprintCellInternalOld_fieldRef",
    "selections": [
        {
            "concreteType": "JiraSprintConnection",
            "kind": "LinkedField",
            "name": "selectedSprintsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSprintEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraSprintField"
};
$61e697fdebff034c$var$node.hash = "02a5a5467a90c8816d7f1ee9623768a7";
var $61e697fdebff034c$export$2e2bcd8739ae039 = $61e697fdebff034c$var$node;

});

parcelRegister("j84ug", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee4d073948bd32c9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f4d8e4229848753e3c70c3f952d9ad8e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ee4d073948bd32c9$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "sprint_nativeIssueTable_SprintCellInternal_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSprintField"
};
$ee4d073948bd32c9$var$node.hash = "d2616cd039bf05900b4ff95c6613dce2";
var $ee4d073948bd32c9$export$2e2bcd8739ae039 = $ee4d073948bd32c9$var$node;

});

parcelRegister("g53LI", function(module, exports) {

$parcel$export(module.exports, "default", () => $28615375c51d7fbd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f8061546fb8862cf3b8a768bcf98a622>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $28615375c51d7fbd$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcsprintinlineeditrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "sprint_nativeIssueTable_SprintCell",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcsprintinlineeditrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "sprint_nativeIssueTable_SprintCellInternalOld_fieldRef"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcsprintinlineeditrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "sprint_nativeIssueTable_SprintCellInternal_fieldRef"
                }
            ]
        }
    ],
    "type": "JiraSprintField"
};
$28615375c51d7fbd$var$node.hash = "014f403450995cac6b170d3902c83117";
var $28615375c51d7fbd$export$2e2bcd8739ae039 = $28615375c51d7fbd$var$node;

});

parcelRegister("9YDUP", function(module, exports) {

$parcel$export(module.exports, "SprintInlineEditViewIsEditable", () => $c9922a34e9476cd4$export$e7a88b03161da897);

var $dBj1S = parcelRequire("dBj1S");

var $6LlYP = parcelRequire("6LlYP");

var $dQWRW = parcelRequire("dQWRW");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iQYHK = parcelRequire("iQYHK");

var $lt1uI = parcelRequire("lt1uI");

var $5LoKD = parcelRequire("5LoKD");

var $cy7Q3 = parcelRequire("cy7Q3");
var $7xRib = parcelRequire("7xRib");

var $huXpk = parcelRequire("huXpk");

var $liZDn = parcelRequire("liZDn");
const $c9922a34e9476cd4$var$isEqualSprint = (a, b)=>a?.value === b?.value;
const $c9922a34e9476cd4$export$e7a88b03161da897 = ({ spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, getUrl: getUrl, isEditable: isFieldEditable, isEditing: startWithEditViewOpen, onRestrictSprints: onRestrictSprints, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, projectKey: projectKey, readViewFitContainerHeight: readViewFitContainerHeight, restrictSprints: restrictSprints })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // #region Relay
    const data = (0, $iWLL0.useFragment)((0, $dQWRW.default), fragmentRef);
    const { id: uniqueFieldId, name: fieldName, selectedSprintsConnection: selectedSprintsConnection } = data;
    const [commit] = (0, $iWLL0.useMutation)((0, $6LlYP.default));
    const sprintEdges = (0, $eUqFw.useMemo)(()=>selectedSprintsConnection?.edges?.filter(Boolean) ?? [], [
        selectedSprintsConnection?.edges
    ]);
    const initialValue = (0, $eUqFw.useMemo)(()=>{
        const sprintNodes = sprintEdges.map(({ node: node })=>node).filter(Boolean);
        const currentSprint = (0, $cy7Q3.findActiveOrFutureSprint)(sprintNodes);
        return currentSprint && (0, $cy7Q3.isObjectWithSprintState)(currentSprint) ? {
            value: currentSprint.id,
            label: currentSprint.name ?? '',
            state: currentSprint.state,
            sprintId: currentSprint.sprintId
        } : null;
    }, [
        sprintEdges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eUqFw.useState)(initialValue);
    const handleSubmit = (0, $eUqFw.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(option);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value ?? null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateSprintField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: (0, $liZDn.toOptimisticResponse)(uniqueFieldId, option, sprintEdges)
        });
    }, [
        commit,
        onSubmit,
        sprintEdges,
        uniqueFieldId
    ]);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $iQYHK.useFieldInlineEditActions)({
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        initialValue: initialValue,
        isValueEqual: $c9922a34e9476cd4$var$isEqualSprint,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue
    });
    const cancelButtonLabel = formatMessage((0, $huXpk.default).cancelButtonLabel, {
        fieldName: fieldName
    });
    const confirmButtonLabel = formatMessage((0, $huXpk.default).confirmButtonLabel, {
        fieldName: fieldName
    });
    const editButtonLabel = formatMessage((0, $huXpk.default).editButtonLabel, {
        fieldName: fieldName
    });
    const renderReadView = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7xRib.SprintReadView), {
            fragmentRef: data,
            getUrl: getUrl
        }), [
        data,
        getUrl
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? spacing : undefined,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            projectKey: projectKey,
            onRestrictSprints: onRestrictSprints,
            restrictSprints: restrictSprints
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lt1uI.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $5LoKD.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        cancelButtonLabel: (0, $1ybV0.ff)('nin-priority-inline-edit') ? undefined : cancelButtonLabel,
        confirmButtonLabel: (0, $1ybV0.ff)('nin-priority-inline-edit') ? undefined : confirmButtonLabel,
        editButtonLabel: (0, $1ybV0.ff)('nin-priority-inline-edit') ? undefined : editButtonLabel
    });
};
const $c9922a34e9476cd4$export$c035f6dfde6d5d50 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $iWLL0.useFragment)((0, $dBj1S.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9922a34e9476cd4$export$e7a88b03161da897, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("dBj1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8647d41a1dd4f8d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<37eab354ffef704063d36bf755f8ce5b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a8647d41a1dd4f8d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSprintField"
};
$a8647d41a1dd4f8d$var$node.hash = "aba26260bac1c5d276c6291d7046e952";
var $a8647d41a1dd4f8d$export$2e2bcd8739ae039 = $a8647d41a1dd4f8d$var$node;

});

parcelRegister("6LlYP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d6676b04338d904$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d38c11cbcc28d051d2caaff8b2100e27>>
 * @relayHash fe046116013b2c3336c51bcbbb0fadff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41bae81fc0a3022641c80d39ea76c8cb98023eb98fecc3699abf8ef4138c4e7
const $7d6676b04338d904$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sprint_issueFieldSprint_SprintField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSprintFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSprintField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSprintField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "sprint_issueFieldSprintReadviewFull_SprintReadView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sprint_issueFieldSprint_SprintField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSprintFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSprintField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSprintField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "JiraSprintConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedSprintsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSprintEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSprint",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "sprintId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "endDate"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e41bae81fc0a3022641c80d39ea76c8cb98023eb98fecc3699abf8ef4138c4e7",
            "metadata": {},
            "name": "sprint_issueFieldSprint_SprintField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$7d6676b04338d904$var$node.hash = "10015ae363c37285aaa230e388ba466f";
var $7d6676b04338d904$export$2e2bcd8739ae039 = $7d6676b04338d904$var$node;

});

parcelRegister("dQWRW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a66ddbcd6e35549$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a32ece2a66f28e90b45d9eff8211fe7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5a66ddbcd6e35549$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "sprint_issueFieldSprintReadviewFull_SprintReadView"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSprintField"
    };
}();
$5a66ddbcd6e35549$var$node.hash = "7c447e71390d8966a39b5ca8a65fd592";
var $5a66ddbcd6e35549$export$2e2bcd8739ae039 = $5a66ddbcd6e35549$var$node;

});

parcelRegister("5LoKD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6393e6ff58993e9$export$2e2bcd8739ae039);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $e6393e6ff58993e9$var$SprintEditViewEntryPoint = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("eKP7w")), {
        moduleId: "8d561192"
    }),
    getPreloadProps: ()=>({})
});
var $e6393e6ff58993e9$export$2e2bcd8739ae039 = $e6393e6ff58993e9$var$SprintEditViewEntryPoint;

});
parcelRegister("eKP7w", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('f0QPk')
        ]);
        const value = parcelRequire('hau8p');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("f0QPk")
    ]).then(()=>parcelRequire('hau8p'));
}

});


parcelRegister("cy7Q3", function(module, exports) {

$parcel$export(module.exports, "getRapidViewUrl", () => $f46eebadf84b6f57$export$e6c9132cef5ee76f);
$parcel$export(module.exports, "findActiveOrFutureSprint", () => $f46eebadf84b6f57$export$d53a51166e1544ba);
$parcel$export(module.exports, "isClosedSprint", () => $f46eebadf84b6f57$export$7494fd835c1a1b3);
$parcel$export(module.exports, "filterClosedSprints", () => $f46eebadf84b6f57$export$af48278faaf4e92d);
$parcel$export(module.exports, "isObjectWithSprintState", () => $f46eebadf84b6f57$export$9ba6a679066a1e8c);

var $aJ90T = parcelRequire("aJ90T");
const $f46eebadf84b6f57$export$e6c9132cef5ee76f = (sprintId)=>`/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
const $f46eebadf84b6f57$export$d2fec4e2fc5f065a = (state)=>(sprint)=>sprint.state != null && sprint.state.toUpperCase() === state.toUpperCase();
const $f46eebadf84b6f57$export$fb6b70a9c996212b = (sprints, state)=>sprints.find($f46eebadf84b6f57$export$d2fec4e2fc5f065a(state));
const $f46eebadf84b6f57$export$d53a51166e1544ba = (value)=>{
    const activeSprint = $f46eebadf84b6f57$export$fb6b70a9c996212b(value, (0, $aJ90T.ACTIVE_SPRINT_STATE));
    if (activeSprint) return activeSprint;
    const futureSprint = $f46eebadf84b6f57$export$fb6b70a9c996212b(value, (0, $aJ90T.FUTURE_SPRINT_STATE));
    if (futureSprint) return futureSprint;
    return null;
};
const $f46eebadf84b6f57$export$7494fd835c1a1b3 = $f46eebadf84b6f57$export$d2fec4e2fc5f065a((0, $aJ90T.CLOSED_SPRINT_STATE));
const $f46eebadf84b6f57$export$af48278faaf4e92d = (value)=>value.filter($f46eebadf84b6f57$export$7494fd835c1a1b3);
const $f46eebadf84b6f57$export$9ba6a679066a1e8c = (val)=>val.state ? val.state in (0, $aJ90T.SPRINT_STATES) : false;

});
parcelRegister("aJ90T", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_SPRINT_STATE", () => $d6857bb95b01f76c$export$3ebc9911a79d714f);
$parcel$export(module.exports, "FUTURE_SPRINT_STATE", () => $d6857bb95b01f76c$export$863e42082c6bde5);
$parcel$export(module.exports, "CLOSED_SPRINT_STATE", () => $d6857bb95b01f76c$export$86cdef09a89e8c4b);
$parcel$export(module.exports, "SPRINT_STATES", () => $d6857bb95b01f76c$export$73a0206a4dc59760);
const $d6857bb95b01f76c$export$3ebc9911a79d714f = 'ACTIVE';
const $d6857bb95b01f76c$export$863e42082c6bde5 = 'FUTURE';
const $d6857bb95b01f76c$export$86cdef09a89e8c4b = 'CLOSED';
const $d6857bb95b01f76c$export$73a0206a4dc59760 = {
    ACTIVE: $d6857bb95b01f76c$export$3ebc9911a79d714f,
    CLOSED: $d6857bb95b01f76c$export$86cdef09a89e8c4b,
    FUTURE: $d6857bb95b01f76c$export$863e42082c6bde5
};

});


parcelRegister("7xRib", function(module, exports) {

$parcel$export(module.exports, "SprintReadView", () => $23fdd08814f5915d$export$ea735e24cb7dd13);

var $5OeqJ = parcelRequire("5OeqJ");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kFGm5 = parcelRequire("kFGm5");

var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $k2rpK = parcelRequire("k2rpK");

var $cy7Q3 = parcelRequire("cy7Q3");

var $5CS8O = parcelRequire("5CS8O");

var $6E3CP = parcelRequire("6E3CP");
const $23fdd08814f5915d$export$ea735e24cb7dd13 = ({ fragmentRef: fragmentRef, shouldHideSprintLink: shouldHideSprintLink = false, shouldHideClosedSprintsLinks: shouldHideClosedSprintsLinks = false, placeholder: placeholder, onSprintClick: onSprintClick, getUrl: getUrl = (0, $cy7Q3.getRapidViewUrl) })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const placeholderMessage = placeholder || formatMessage((0, $k2rpK.default).emptyFieldText);
    const { selectedSprintsConnection: selectedSprintsConnection } = (0, $iWLL0.useFragment)((0, $5OeqJ.default), fragmentRef);
    const sprints = (0, $eUqFw.useMemo)(()=>selectedSprintsConnection?.edges?.filter(Boolean).map(({ node: node })=>node).filter(Boolean).filter((0, $cy7Q3.isObjectWithSprintState)).map((node)=>({
                id: node.id,
                sprintId: parseInt(node.sprintId, 10),
                name: node.name,
                state: node.state,
                endDate: node.endDate ?? undefined
            })) ?? [], [
        selectedSprintsConnection?.edges
    ]);
    const value = (0, $eUqFw.useMemo)(()=>{
        const currentSprint = (0, $cy7Q3.findActiveOrFutureSprint)(sprints);
        if (!currentSprint) return null;
        const sprintOption = {
            label: currentSprint.name,
            value: currentSprint.id,
            href: getUrl(currentSprint.sprintId),
            state: currentSprint.state
        }; // If in backlog, use onSprintClick instead of href
        return onSprintClick ? (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(sprintOption, 'href') : sprintOption;
    }, [
        getUrl,
        onSprintClick,
        sprints
    ]);
    const closedSprints = (0, $eUqFw.useMemo)(()=>(0, $cy7Q3.filterClosedSprints)(sprints)?.map((closedSprint)=>({
                id: closedSprint.sprintId,
                name: closedSprint.name,
                href: getUrl(closedSprint.sprintId),
                endDate: formatDate(closedSprint.endDate, {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                })
            })), [
        formatDate,
        getUrl,
        sprints
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($23fdd08814f5915d$var$ReadWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6E3CP.default), {
        value: value,
        shouldHideSprintLink: shouldHideSprintLink,
        placeholder: placeholderMessage,
        onClick: onSprintClick
    }), closedSprints.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5CS8O.default), {
        closedSprints: closedSprints,
        shouldHideLinks: shouldHideClosedSprintsLinks
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23fdd08814f5915d$var$ReadWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq",
            (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && "_1n261g80 _zulpu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5OeqJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $32618b0df1b95f99$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0ee21c1a385c649c86345ac0a88a0470>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $32618b0df1b95f99$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "sprint_issueFieldSprintReadviewFull_SprintReadView",
    "selections": [
        {
            "concreteType": "JiraSprintConnection",
            "kind": "LinkedField",
            "name": "selectedSprintsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSprintEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "sprintId"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    "action": "THROW",
                                    "path": "selectedSprintsConnection.edges.node.name"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    "action": "THROW",
                                    "path": "selectedSprintsConnection.edges.node.state"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraSprintField"
};
$32618b0df1b95f99$var$node.hash = "94ae9fbf007cadd0e44b60b0777f74f2";
var $32618b0df1b95f99$export$2e2bcd8739ae039 = $32618b0df1b95f99$var$node;

});

parcelRegister("5CS8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cb48199a8975d7d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7u4fN = parcelRequire("7u4fN");

var $29yDk = parcelRequire("29yDk");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $7ZOT7 = parcelRequire("7ZOT7");
const $7cb48199a8975d7d$var$ClosedSprintsView = (props)=>{
    const { shouldHideLinks: shouldHideLinks = false, closedSprints: closedSprints } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isDialogOpen, setIsDialogOpen] = (0, $eUqFw.useState)(false);
    const handleButtonClick = (0, $eUqFw.useCallback)((e)=>{
        setIsDialogOpen(!isDialogOpen);
        e.stopPropagation();
    }, [
        isDialogOpen
    ]);
    const handleDialogClose = (0, $eUqFw.useCallback)((data)=>{
        setIsDialogOpen(data.isOpen);
    }, []);
    const handleDialogClick = (0, $eUqFw.useCallback)((e)=>{
        e.stopPropagation();
    }, []);
    const handleDialogMouseDown = (0, $eUqFw.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
    }, []);
    const closedSprintsLabel = (0, $eUqFw.useMemo)(()=>{
        const numberOfClosedSprints = closedSprints.length;
        return numberOfClosedSprints > 0 ? formatMessage((0, $7ZOT7.default).closedSprintsLabel, {
            count: numberOfClosedSprints
        }) : null;
    }, [
        closedSprints,
        formatMessage
    ]);
    const renderInlineDialogContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "issue-field-sprint-readview-full.ui.sprint.closed-sprints.view-closed-sprint-inline-dialog-content-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb48199a8975d7d$var$Title, null, closedSprintsLabel), closedSprints.map((sprint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb48199a8975d7d$var$ItemContainer, {
                key: sprint.name,
                "data-testid": `issue-field-sprint-readview-full.ui.sprint.closed-sprints.closed-sprint-item-${sprint.id}`
            }, shouldHideLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb48199a8975d7d$var$NameSpan, null, sprint.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb48199a8975d7d$var$NameLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), {
                href: sprint.href
            }, sprint.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb48199a8975d7d$var$NoWrapDate, null, sprint.endDate))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb48199a8975d7d$var$Container, {
        onClick: handleDialogClick,
        onMouseDown: handleDialogMouseDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
        content: renderInlineDialogContent(),
        isOpen: isDialogOpen,
        onClose: handleDialogClose,
        placement: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: handleButtonClick,
        spacing: "none",
        isSelected: isDialogOpen,
        testId: "issue-field-sprint-readview-full.ui.sprint.closed-sprints.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb48199a8975d7d$var$ClosedSprintsCount, null, `+${closedSprints.length}`))));
};
var $7cb48199a8975d7d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
 = $7cb48199a8975d7d$var$ClosedSprintsView;
const $7cb48199a8975d7d$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? "_p12f1osq" : "_18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7cb48199a8975d7d$var$ClosedSprintsCount = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_d67xew": (0, $9t7rW.default)((0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && 'normal')
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41b66 _k48povdo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7cb48199a8975d7d$var$ItemContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _1e0c1txw _1bah1yb4 _p12f1mjv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7cb48199a8975d7d$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pbfng",
            __cmplp.className
        ])
    });
});
const $7cb48199a8975d7d$var$nameStyles = `
    margin-right: ${"var(--ds-space-300, 24px)"};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $7cb48199a8975d7d$var$NameLinkContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1ejb _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $7cb48199a8975d7d$var$NameSpan = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1ejb _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $7cb48199a8975d7d$var$NoWrapDate = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7ZOT7", function(module, exports) {

$parcel$export(module.exports, "default", () => $40d23a6a3042843f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $40d23a6a3042843f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    closedSprintsLabel: {
        "id": "issue-field-sprint-readview-full.sprint.closed-sprints.closed-sprints-label",
        "defaultMessage": "{count} completed {count, plural, one {sprint} other {sprints}}"
    }
});

});


parcelRegister("6E3CP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c7bfbf4b90bfdbf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bnRYt = parcelRequire("bnRYt");

var $kJlBc = parcelRequire("kJlBc");
const $6c7bfbf4b90bfdbf$var$SprintContent = (props)=>{
    const { value: value, onClick: onClick, placeholder: placeholder, shouldHideSprintLink: shouldHideSprintLink = false } = props;
    const renderSprintContent = ()=>{
        if (shouldHideSprintLink) return value && value.label;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), {
            "data-testid": "issue-field-sprint-readview-full.ui.sprint.sprint-content.view-sprint-content-link",
            href: value?.href,
            onClick: onClick
        }, value && value.label);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c7bfbf4b90bfdbf$var$Ellipsis, {
        "data-testid": "issue-field-sprint-readview-full.ui.sprint.sprint-content.view-sprint-content"
    }, value ? renderSprintContent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bnRYt.default), null, placeholder));
};
var $6c7bfbf4b90bfdbf$export$2e2bcd8739ae039 = $6c7bfbf4b90bfdbf$var$SprintContent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c7bfbf4b90bfdbf$var$Ellipsis = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bnRYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6993693052c67cc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a6993693052c67cc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1",
            __cmplp.className
        ])
    });
});

});



parcelRegister("huXpk", function(module, exports) {

$parcel$export(module.exports, "default", () => $48339a96ff601fdd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $48339a96ff601fdd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    confirmButtonLabel: {
        "id": "issue-field-sprint-inline-edit-full.sprint.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "issue-field-sprint-inline-edit-full.sprint.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "issue-field-sprint-inline-edit-full.sprint.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    }
});

});

parcelRegister("liZDn", function(module, exports) {

$parcel$export(module.exports, "toOptimisticResponse", () => $ca8a432812b044d4$export$79353fa5e28d43d8);

var $cy7Q3 = parcelRequire("cy7Q3");
const $ca8a432812b044d4$export$79353fa5e28d43d8 = (fieldId, option, previousEdges)=>{
    // Previously closed sprints should still be displayed for the updated field
    const selectedSprints = previousEdges.filter((edge)=>edge?.node && (0, $cy7Q3.isClosedSprint)(edge.node));
    if (option) selectedSprints.unshift({
        node: {
            id: option.value,
            name: option.label,
            state: option.state,
            sprintId: option.sprintId,
            endDate: null
        }
    });
    return {
        jira: {
            updateSprintField: {
                success: true,
                errors: null,
                field: {
                    id: fieldId,
                    selectedSprintsConnection: {
                        edges: selectedSprints
                    }
                }
            }
        }
    };
};

});


parcelRegister("6pzUl", function(module, exports) {

$parcel$export(module.exports, "LinkItem", () => $39c66756c864bd1e$export$532cb6865ebe8946);
$parcel$export(module.exports, "LinkItemPopupContentWrapper", () => $39c66756c864bd1e$export$1045507195652b03);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $9Amv1 = parcelRequire("9Amv1");

var $1ybV0 = parcelRequire("1ybV0");

var $cXIox = parcelRequire("cXIox");
const $39c66756c864bd1e$export$532cb6865ebe8946 = ({ name: name, href: href, icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($39c66756c864bd1e$var$ItemWrapper, {
        hasIcon: Boolean(icon)
    }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "square",
        size: "xsmall",
        src: icon.url,
        borderColor: "transparent",
        testId: "list-with-popup.ui.link-item.avatar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($39c66756c864bd1e$var$TruncatedLink, {
        href: href,
        wordBreak: false
    }, name));
const $39c66756c864bd1e$export$1045507195652b03 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        shouldWrap: true
    }, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $39c66756c864bd1e$var$TruncatedLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $cXIox.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _vwz4kb7n _1e0c1o8l _s7n4nkob _1yt4swc3 _o5721q9c _1guj1r31 _pbhaglyw _11ow1o36",
            (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? "_vchhusvi _p12f1osq" : "_p12fuuw1",
            __cmplp.className
        ])
    });
});
const $39c66756c864bd1e$var$ItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasIcon: hasIcon, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19h61l7b _1u6l1vt6",
            __cmplp.hasIcon && "_18u01i6y _1e0c116y _4cvr1h6o",
            (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eBHAy", function(module, exports) {

$parcel$export(module.exports, "useRestrictSprints", () => $e3f9fd58f4e8d58f$export$8fafa660b00d922);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $aStU7 = parcelRequire("aStU7");
const $e3f9fd58f4e8d58f$var$initialState = {
    restrictSprints: (0, $aStU7.getSharedRestrictSprintsValueFromLocalStorage)()
};
const $e3f9fd58f4e8d58f$var$actions = {
    onRestrictSprints: (restrictSprints)=>({ setState: setState })=>{
            (0, $aStU7.setSharedRestrictSprintsValueInLocalStorage)(restrictSprints);
            setState({
                restrictSprints: restrictSprints
            });
        }
};
const $e3f9fd58f4e8d58f$var$RestrictSprintsStore = (0, $a61MH.createStore)({
    initialState: $e3f9fd58f4e8d58f$var$initialState,
    actions: $e3f9fd58f4e8d58f$var$actions
});
const $e3f9fd58f4e8d58f$export$8fafa660b00d922 = (0, $ggKAj.createHook)($e3f9fd58f4e8d58f$var$RestrictSprintsStore, {
    selector: (state)=>state.restrictSprints
});

});
parcelRegister("aStU7", function(module, exports) {

$parcel$export(module.exports, "getSharedRestrictSprintsValueFromLocalStorage", () => $936aa651e1931041$export$7186d1e916f1211c);
$parcel$export(module.exports, "setSharedRestrictSprintsValueInLocalStorage", () => $936aa651e1931041$export$4e2f56cec9369837);
// Helper functions to get the checkbox value in sprint edit component from local storage
const $936aa651e1931041$var$SHARED_RESTRICT_SPRINTS_CACHE_KEY = 'edit_sprint_cache_value';
const $936aa651e1931041$var$getRestrictSprintsValueFromLocalStorage = (key)=>{
    const value = window.localStorage?.getItem(key);
    try {
        return value ? JSON.parse(value) : true;
    } catch  {
        return true;
    }
};
const $936aa651e1931041$var$setRestrictSprintsValueInLocalStorage = (key, value)=>{
    try {
        window.localStorage.setItem(key, String(value));
    } catch  {
    // do nothing
    }
};
const $936aa651e1931041$export$7186d1e916f1211c = ()=>$936aa651e1931041$var$getRestrictSprintsValueFromLocalStorage($936aa651e1931041$var$SHARED_RESTRICT_SPRINTS_CACHE_KEY);
const $936aa651e1931041$export$4e2f56cec9369837 = (value)=>$936aa651e1931041$var$setRestrictSprintsValueInLocalStorage($936aa651e1931041$var$SHARED_RESTRICT_SPRINTS_CACHE_KEY, value);

});


parcelRegister("gOuHz", function(module, exports) {

$parcel$export(module.exports, "default", () => $792949c9cff74ca4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $792949c9cff74ca4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.sprint.trigger-button",
        "defaultMessage": "See more sprints"
    }
});

});


parcelRegister("ahMdE", function(module, exports) {

$parcel$export(module.exports, "UserCell", () => $9384886b3e39efd7$export$dc0ef711c0db7c30);

var $gqzbq = parcelRequire("gqzbq");

var $5gti0 = parcelRequire("5gti0");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $iJlfe = parcelRequire("iJlfe");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hxs6P = parcelRequire("hxs6P");

var $itIq0 = parcelRequire("itIq0");

var $70VQk = parcelRequire("70VQk");

var $2NwGr = parcelRequire("2NwGr");

var $6vrw7 = parcelRequire("6vrw7");

var $gd0Sp = parcelRequire("gd0Sp");

var $e9kDw = parcelRequire("e9kDw");

var $a4IeB = parcelRequire("a4IeB");

var $4mcuU = parcelRequire("4mcuU");

var $2qXcq = parcelRequire("2qXcq");

var $g9Rct = parcelRequire("g9Rct");
const $9384886b3e39efd7$export$afb022e5bfe0b377 = (accountId)=>(children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2NwGr.AsyncProfileCardNext), {
            accountId: accountId ?? '',
            TenantContextSubscriber: (0, $gd0Sp.TenantContextSubscriber),
            actions: [
                (0, $2f37035f7aaf1787$export$23cedd3261bd8015)
            ]
        }, children);
const $9384886b3e39efd7$export$dc0ef711c0db7c30 = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $5gti0.default), fieldRef);
    if ((0, $1ybV0.ff)('nin-single-user-inline-edit_orj2c') && (data.fieldId === 'assignee' || data.fieldId === 'reporter')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9384886b3e39efd7$export$df3d80016052952c, {
        fieldRef: data,
        projectKey: projectKey
    });
    const { type: type, user: user } = data;
    const { name: name, accountId: accountId, picture: picture } = user ?? {};
    const displayText = name ?? formatMessage(type !== (0, $a4IeB.KNOWN_COLUMN_TYPES).ASSIGNEE ? (0, $g9Rct.default).anonymous : (0, $g9Rct.default).unassigned);
    if (user != null && (name == null || accountId == null)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "user",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4mcuU.ConditionalWrapper), {
        condition: accountId !== undefined,
        renderWrapper: $9384886b3e39efd7$export$afb022e5bfe0b377(accountId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9384886b3e39efd7$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: picture,
        size: "small",
        borderColor: "transparent",
        name: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9384886b3e39efd7$var$Text, null, displayText)));
});
const $9384886b3e39efd7$export$df3d80016052952c = ({ fieldRef: fieldRef, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $gqzbq.default), fieldRef); // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $e9kDw.useLazyLoadEditability)(data.id, isEditable);
    switch(data.fieldId){
        case 'assignee':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hxs6P.AssigneeInlineEditViewWithIsEditable), {
                spacing: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? 'default' : undefined,
                editViewPopup: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo'),
                editViewPopupAlignBlock: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? 'center' : undefined,
                fragmentRef: data,
                isEditable: isEditable ?? false,
                readViewFitContainerHeight: true,
                projectKey: (0, $6vrw7.toProjectKey)(projectKey)
            });
        case 'reporter':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $itIq0.ReporterInlineEditViewWithIsEditable), {
                spacing: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? 'default' : undefined,
                editViewPopup: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo'),
                editViewPopupAlignBlock: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? 'center' : undefined,
                fragmentRef: data,
                isEditable: isEditable ?? false,
                readViewFitContainerHeight: true
            });
        default:
            {
                const noneOptionLabel = data.fieldId === 'creator' ? formatMessage((0, $g9Rct.default).anonymous) : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $70VQk.SingleUserPickerInlineEditViewWithIsEditable), {
                    spacing: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? 'default' : undefined,
                    editViewPopup: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo'),
                    editViewPopupAlignBlock: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? 'center' : undefined,
                    fragmentRef: data,
                    isEditable: isEditable ?? false,
                    readViewFitContainerHeight: true,
                    noneOptionLabel: noneOptionLabel
                });
            }
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9384886b3e39efd7$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bvu2gc _1reo15vq _1bto1l2s _o5721q9c _y3gn1e5h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9384886b3e39efd7$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _80om73ad _18u01i6y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gqzbq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c489a7c56beffe42$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<51281952c53ea8a9049c9fb9163738de>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c489a7c56beffe42$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "user_nativeIssueTable_UserCellInternal_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "kind": "FragmentSpread",
            "name": "reporter_issueFieldReporterInlineEditFull_ReporterInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$c489a7c56beffe42$var$node.hash = "70c9b5cc4f6637fc8553932c9c90dc8f";
var $c489a7c56beffe42$export$2e2bcd8739ae039 = $c489a7c56beffe42$var$node;

});

parcelRegister("5gti0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ffb6606d7f9c6e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9197c2cee859c6c6206532e1505b6dc9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7ffb6606d7f9c6e8$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcuserinlineeditrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "user_nativeIssueTable_UserCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcuserinlineeditrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "user_nativeIssueTable_UserCellInternal_fieldRef"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$7ffb6606d7f9c6e8$var$node.hash = "949652047f7da38438119861077ff21c";
var $7ffb6606d7f9c6e8$export$2e2bcd8739ae039 = $7ffb6606d7f9c6e8$var$node;

});

parcelRegister("hxs6P", function(module, exports) {

$parcel$export(module.exports, "AssigneeInlineEditViewWithIsEditable", () => $b17b2d4c5cb87d24$export$e07ee235d4f5b512);

var $2SR4q = parcelRequire("2SR4q");

var $fWa0s = parcelRequire("fWa0s");

var $dq51X = parcelRequire("dq51X");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $8cU5f = parcelRequire("8cU5f");

var $2gGF1 = parcelRequire("2gGF1");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $52LDy = parcelRequire("52LDy");

var $iQYHK = parcelRequire("iQYHK");

var $lt1uI = parcelRequire("lt1uI");

var $7XtsK = parcelRequire("7XtsK");


var $7Desk = parcelRequire("7Desk");
const $b17b2d4c5cb87d24$var$isEqualUser = (a, b)=>a?.id === b?.id;
const $b17b2d4c5cb87d24$export$e07ee235d4f5b512 = ({ spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditing: startWithEditViewOpen = false, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, portalElement: portalElement, onCancel: onCancel, onEdit: onEdit, isDisabledTooltipShown: isDisabledTooltipShown = false, projectKey: projectKey, isEditable: isFieldEditable, readViewFitContainerHeight: readViewFitContainerHeight })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // #region Relay
    const data = (0, $iWLL0.useFragment)((0, $dq51X.default), fragmentRef);
    const { id: uniqueFieldId, name: fieldName, user: user, fieldConfig: fieldConfig } = data;
    const isFieldRequired = fieldConfig?.isRequired ?? false;
    const [commit] = (0, $iWLL0.useMutation)((0, $fWa0s.default));
    // #endregion
    const initialValue = user ?? null;
    const [updatedValue, setUpdatedValue] = (0, $eUqFw.useState)(initialValue);
    const handleSubmit = (0, $eUqFw.useCallback)((newUser, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newUser);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: newUser?.id ?? null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateSingleSelectUserPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateSingleSelectUserPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            user: newUser ? {
                                id: newUser.id,
                                accountId: newUser.accountId,
                                accountStatus: newUser.accountStatus,
                                name: newUser.name,
                                picture: newUser.picture,
                                __typename: 'AtlassianAccountUser'
                            } : null
                        }
                    }
                }
            }
        });
    }, [
        commit,
        uniqueFieldId,
        onSubmit
    ]);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $iQYHK.useFieldInlineEditActions)({
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        initialValue: initialValue,
        isValueEqual: $b17b2d4c5cb87d24$var$isEqualUser,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitSucceeded: onSubmitSucceeded,
        onSubmitFailed: onSubmitFailed,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue
    });
    // #region Read view
    const renderReadView = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7XtsK.SingleUserPickerWithProfileCardReadView), {
            fragmentRef: data,
            emptyUserLabel: formatMessage((0, $7Desk.default).unassignedOption),
            profileCardAction: (0, $2f37035f7aaf1787$export$6bef782d14a92db8)
        }), [
        data,
        formatMessage
    ]);
    // #endregion
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            spacing: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? spacing : undefined,
            appearance: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? undefined : 'compact',
            projectKey: projectKey,
            fetchSuggestionsOnMount: false,
            portalElement: portalElement,
            enablePeopleInvite: true,
            includeNoneOption: !isFieldRequired,
            isClearable: !isFieldRequired,
            menuPosition: 'fixed'
        });
    const editButtonLabel = formatMessage((0, $2gGF1.default).extendedEditButtonLabel, {
        inputFieldValue: initialValue?.name ?? formatMessage((0, $7Desk.default).unassignedOption),
        fieldName: fieldName
    });
    const inlineEditElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lt1uI.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $52LDy.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        readView: renderReadView,
        hideActionButtons: true,
        editButtonLabel: editButtonLabel,
        cancelButtonLabel: (0, $1ybV0.ff)('nin-priority-inline-edit') ? undefined : formatMessage((0, $2gGF1.default).cancelButtonLabel, {
            fieldName: fieldName
        }),
        confirmButtonLabel: (0, $1ybV0.ff)('nin-priority-inline-edit') ? undefined : formatMessage((0, $2gGF1.default).confirmButtonLabel, {
            fieldName: fieldName
        }),
        readViewFitContainerHeight: readViewFitContainerHeight
    });
    return isDisabledTooltipShown && !isFieldEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $2gGF1.default).disabledReporterTooltip, {
            fieldName: fieldName
        }),
        position: "mouse"
    }, inlineEditElement) : inlineEditElement;
};
const $b17b2d4c5cb87d24$export$9f32fa927ad908e5 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $iWLL0.useFragment)((0, $2SR4q.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b17b2d4c5cb87d24$export$e07ee235d4f5b512, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("2SR4q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b30d810e6da7aee$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9ea929c7ab7c075bed623095bf805b7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2b30d810e6da7aee$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$2b30d810e6da7aee$var$node.hash = "93c1d9e2338da6a23190803216172e69";
var $2b30d810e6da7aee$export$2e2bcd8739ae039 = $2b30d810e6da7aee$var$node;

});

parcelRegister("fWa0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc449adc5a0d2c78$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b39cd9f658428d36a2512486ab8d72b4>>
 * @relayHash bec7df53ca83812b5cc78b45964f54a4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 286e9b8dd8f6f20eb2141d25ad97826dc8ef0bc66a72d8e575785c70c03d8023
const $cc449adc5a0d2c78$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "286e9b8dd8f6f20eb2141d25ad97826dc8ef0bc66a72d8e575785c70c03d8023",
            "metadata": {},
            "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$cc449adc5a0d2c78$var$node.hash = "62cbc1d7150c21a456232c86f0554a51";
var $cc449adc5a0d2c78$export$2e2bcd8739ae039 = $cc449adc5a0d2c78$var$node;

});

parcelRegister("dq51X", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cc606399139948f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2cef51a18d89ffacf5d4a9efde6474f6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4cc606399139948f$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerWithProfileCardReadView_fragmentRef"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accountStatus"
                    },
                    v0 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectUserPickerField"
    };
}();
$4cc606399139948f$var$node.hash = "2d7904d380a0231e34453d12f13808c0";
var $4cc606399139948f$export$2e2bcd8739ae039 = $4cc606399139948f$var$node;

});

parcelRegister("52LDy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca06f1d4581c1e4b$export$2e2bcd8739ae039);

var $k4PEC = parcelRequire("k4PEC");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $ca06f1d4581c1e4b$var$AssigneeEditViewEntryPoint = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("jIg4e")), {
        moduleId: "3f5ced6e"
    }),
    getPreloadProps: ()=>({
            queries: {
                rootData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $k4PEC.default,
                    variables: {}
                }
            }
        })
});
var $ca06f1d4581c1e4b$export$2e2bcd8739ae039 = $ca06f1d4581c1e4b$var$AssigneeEditViewEntryPoint;

});
parcelRegister("k4PEC", function(module, exports) {

$parcel$export(module.exports, "default", () => $92f7025beae06b38$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c3533b181da4fe930f227b215516895>>
 * @relayHash c0a99e60ca7db3e867b3bb2039798d28
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 06cc27c43b93217b220d59a67c5b60e54cc82db33ba6e684ea3f67b1f62fb4a0
const $92f7025beae06b38$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "06cc27c43b93217b220d59a67c5b60e54cc82db33ba6e684ea3f67b1f62fb4a0",
        "metadata": {},
        "name": "assigneeEditView_rootQuery",
        "operationKind": "query",
        "text": null
    }
};
var $92f7025beae06b38$export$2e2bcd8739ae039 = $92f7025beae06b38$var$node;

});

parcelRegister("jIg4e", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hTLbS');
        const value = parcelRequire('2bTfi');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hTLbS").then(()=>parcelRequire('2bTfi'));
}

});


parcelRegister("7XtsK", function(module, exports) {

$parcel$export(module.exports, "SingleUserPickerWithProfileCardReadView", () => $edadb30887e67266$export$2f1ab379ffebbded);

var $61lOp = parcelRequire("61lOp");

var $67PMU = parcelRequire("67PMU");

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $iJlfe = parcelRequire("iJlfe");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2NwGr = parcelRequire("2NwGr");

var $guv6m = parcelRequire("guv6m");
const $edadb30887e67266$export$65db1532781bc51 = ({ fragmentRef: fragmentRef, emptyUserLabel: emptyUserLabel = null })=>{
    const data = (0, $iWLL0.useFragment)((0, $67PMU.default), fragmentRef);
    const intl = (0, $5JgJ2.default)();
    const { formatMessage: formatMessage } = intl;
    const { name: name = emptyUserLabel ?? formatMessage((0, $guv6m.default).anonymousOption), picture: picture, accountStatus: accountStatus } = data?.user || {};
    return(// We use our own container element rather than an AvatarItem as we've observed hydration bugs with SSR+Emotion
    // when this component is wrapped in an async profile card, and this approach is the path of least friction.
    // Further context here https://atlassian.slack.com/archives/C060GTVV988/p1712624943348969.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($edadb30887e67266$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        as: (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') ? $edadb30887e67266$var$AvatarAlignmentFix : undefined,
        src: picture,
        name: name,
        size: "small",
        borderColor: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($edadb30887e67266$var$Text, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, name), data?.user && accountStatus !== 'active' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($edadb30887e67266$var$UserStatus, null, `(${formatMessage((0, $guv6m.default).deactivated)})`))));
};
const $edadb30887e67266$export$2f1ab379ffebbded = ({ fragmentRef: fragmentRef, emptyUserLabel: emptyUserLabel, profileCardAction: profileCardAction })=>{
    const data = (0, $iWLL0.useFragment)((0, $61lOp.default), fragmentRef);
    const accountId = data?.user?.accountId || null;
    const actions = (0, $eUqFw.useMemo)(()=>profileCardAction ? [
            (0, $2f37035f7aaf1787$export$23cedd3261bd8015),
            profileCardAction
        ] : [
            (0, $2f37035f7aaf1787$export$23cedd3261bd8015)
        ], [
        profileCardAction
    ]);
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2NwGr.AsyncProfileCardNext), {
        accountId: accountId,
        actions: actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($edadb30887e67266$export$65db1532781bc51, {
        fragmentRef: data,
        emptyUserLabel: emptyUserLabel
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($edadb30887e67266$export$65db1532781bc51, {
        fragmentRef: data,
        emptyUserLabel: emptyUserLabel
    });
};
/**
 * Component to pass for "as" prop of Avatar. It reverses the 2px margin added in the Avatar
 * component when a transparent border is used.
 *
 * Done using div + css because styled components are not compatible with Avatar's types.
 */ const $edadb30887e67266$var$AvatarAlignmentFix = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ...props,
        ref: ref,
        className: (0, $7JEyt.default)([
            "_18s81i6y"
        ])
    }));
const $edadb30887e67266$var$avatarAlignmentStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $edadb30887e67266$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            (0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && "_zulpu2gc _p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $edadb30887e67266$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            !(0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && "_bozgu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $edadb30887e67266$var$UserStatus = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _18u0v77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("61lOp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9df21e9f7f2bcc0f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb191c3deee3f900ca748d7c13f3caea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9df21e9f7f2bcc0f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerWithProfileCardReadView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef"
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$9df21e9f7f2bcc0f$var$node.hash = "8f7503b9cf9a18309ee04d1c9f93f83a";
var $9df21e9f7f2bcc0f$export$2e2bcd8739ae039 = $9df21e9f7f2bcc0f$var$node;

});

parcelRegister("67PMU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e103c911c7155547$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ddc2cadf7150eb840bac96328f39a8a6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e103c911c7155547$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "kind": "ScalarField",
                    "name": "accountStatus"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$e103c911c7155547$var$node.hash = "83f7121fa6b0005e4cbdae4ef31fe6bb";
var $e103c911c7155547$export$2e2bcd8739ae039 = $e103c911c7155547$var$node;

});

parcelRegister("guv6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $be4d3dae0fb1dc04$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $be4d3dae0fb1dc04$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    deactivated: {
        "id": "issue-field-single-user-picker-readview-full.single-user-picker.deactivated",
        "defaultMessage": "Deactivated"
    },
    anonymousOption: {
        "id": "issue-field-single-user-picker-readview-full.single-user-picker.anonymous-option",
        "defaultMessage": "Anonymous"
    }
});

});


parcelRegister("7Desk", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d3a760c21631c09$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9d3a760c21631c09$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee-inline-edit-full.assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    assignToMe: {
        "id": "issue-field-assignee-inline-edit-full.assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    }
});

});


parcelRegister("itIq0", function(module, exports) {

$parcel$export(module.exports, "ReporterInlineEditViewWithIsEditable", () => $2e083873f7b1d4c2$export$f3ca6190158a888f);

var $iQykF = parcelRequire("iQykF");

var $1eY21 = parcelRequire("1eY21");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $70VQk = parcelRequire("70VQk");


var $3GdvR = parcelRequire("3GdvR");
const $2e083873f7b1d4c2$export$f3ca6190158a888f = ({ fragmentRef: fragmentRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $1eY21.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $70VQk.SingleUserPickerInlineEditViewWithIsEditable), {
        ...props,
        fragmentRef: data,
        noneOptionLabel: formatMessage((0, $3GdvR.default).anonymous),
        profileCardAction: (0, $2f37035f7aaf1787$export$6b36f20db7a18a86)
    });
};
const $2e083873f7b1d4c2$export$981d7f2f0ffb0beb = ({ fragmentRef: fragmentRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $iQykF.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $70VQk.SingleUserPickerInlineEditView), {
        ...props,
        fragmentRef: data,
        noneOptionLabel: formatMessage((0, $3GdvR.default).anonymous),
        profileCardAction: (0, $2f37035f7aaf1787$export$6b36f20db7a18a86)
    });
};

});
parcelRegister("iQykF", function(module, exports) {

$parcel$export(module.exports, "default", () => $095d30b22f884ee4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e444162d4db31fe2d8cf9ce3d49c500a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $095d30b22f884ee4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "reporter_issueFieldReporterInlineEditFull_ReporterInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditView_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$095d30b22f884ee4$var$node.hash = "bd02fa384b206ea57830ba99674f24b9";
var $095d30b22f884ee4$export$2e2bcd8739ae039 = $095d30b22f884ee4$var$node;

});

parcelRegister("1eY21", function(module, exports) {

$parcel$export(module.exports, "default", () => $f540b14f4d781451$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fb86f10febd7873bf5fcf89f85958c48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f540b14f4d781451$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "reporter_issueFieldReporterInlineEditFull_ReporterInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$f540b14f4d781451$var$node.hash = "75550b2f1743d8a0b6176f6ded3b5c91";
var $f540b14f4d781451$export$2e2bcd8739ae039 = $f540b14f4d781451$var$node;

});

parcelRegister("70VQk", function(module, exports) {

$parcel$export(module.exports, "SingleUserPickerInlineEditViewWithIsEditable", () => $87ba0e13ebb0e1a7$export$c143582b21f1a708);
$parcel$export(module.exports, "SingleUserPickerInlineEditView", () => $87ba0e13ebb0e1a7$export$f182346570197b8);

var $edlkb = parcelRequire("edlkb");

var $dz5vK = parcelRequire("dz5vK");

var $1oN5W = parcelRequire("1oN5W");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $2gGF1 = parcelRequire("2gGF1");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iQYHK = parcelRequire("iQYHK");

var $lt1uI = parcelRequire("lt1uI");

var $7XtsK = parcelRequire("7XtsK");

var $qzL40 = parcelRequire("qzL40");

var $j1D6h = parcelRequire("j1D6h");

var $dG1gX = parcelRequire("dG1gX");
const $87ba0e13ebb0e1a7$var$isEqualUser = (a, b)=>a?.id === b?.id;
const $87ba0e13ebb0e1a7$export$c143582b21f1a708 = ({ spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditing: startWithEditViewOpen = false, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, onCancel: onCancel, onEdit: onEdit, isEditable: isFieldEditable, readViewFitContainerHeight: readViewFitContainerHeight, noneOptionLabel: noneOptionLabel, profileCardAction: profileCardAction })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $1oN5W.default), fragmentRef);
    const { id: uniqueFieldId, name: fieldName, user: user, fieldConfig: fieldConfig } = data;
    const isFieldRequired = fieldConfig?.isRequired ?? false;
    const [commit] = (0, $iWLL0.useMutation)((0, $dz5vK.default));
    const initialValue = user ?? null;
    const [updatedValue, setUpdatedValue] = (0, $eUqFw.useState)(initialValue);
    const handleSubmit = (0, $eUqFw.useCallback)((newUser, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newUser);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: newUser?.id ?? null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateSingleSelectUserPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateSingleSelectUserPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            user: newUser ? {
                                id: newUser.id,
                                accountId: newUser.accountId,
                                accountStatus: newUser.accountStatus,
                                name: newUser.name,
                                picture: newUser.picture,
                                __typename: 'AtlassianAccountUser'
                            } : null
                        }
                    }
                }
            }
        });
    }, [
        commit,
        uniqueFieldId,
        onSubmit
    ]);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $iQYHK.useFieldInlineEditActions)({
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        initialValue: initialValue,
        isValueEqual: $87ba0e13ebb0e1a7$var$isEqualUser,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitSucceeded: onSubmitSucceeded,
        onSubmitFailed: onSubmitFailed,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue
    });
    // #region Read view
    const finalNoneOptionLabel = noneOptionLabel ?? formatMessage((0, $dG1gX.default).noneOption);
    const renderReadView = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7XtsK.SingleUserPickerWithProfileCardReadView), {
            fragmentRef: data,
            emptyUserLabel: finalNoneOptionLabel,
            profileCardAction: profileCardAction
        }), [
        data,
        profileCardAction,
        finalNoneOptionLabel
    ]);
    // #endregion
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            autoFocus: true,
            value: updatedValue ? (0, $qzL40.transformAggToUserOption)(updatedValue) : null,
            onChange: handleChangeAndConfirm,
            onClear: ()=>handleChangeAndConfirm(null),
            spacing: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? spacing : undefined,
            appearance: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? undefined : 'compact',
            noneOptionLabel: finalNoneOptionLabel,
            includeNoneOption: !isFieldRequired,
            isClearable: !isFieldRequired,
            menuPosition: 'fixed'
        });
    const editButtonLabel = formatMessage((0, $2gGF1.default).extendedEditButtonLabel, {
        inputFieldValue: initialValue?.name ?? finalNoneOptionLabel,
        fieldName: fieldName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lt1uI.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $j1D6h.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        readView: renderReadView,
        hideActionButtons: true,
        editButtonLabel: editButtonLabel,
        cancelButtonLabel: (0, $1ybV0.ff)('nin-priority-inline-edit') ? undefined : formatMessage((0, $2gGF1.default).cancelButtonLabel, {
            fieldName: fieldName
        }),
        confirmButtonLabel: (0, $1ybV0.ff)('nin-priority-inline-edit') ? undefined : formatMessage((0, $2gGF1.default).confirmButtonLabel, {
            fieldName: fieldName
        }),
        readViewFitContainerHeight: readViewFitContainerHeight
    });
};
const $87ba0e13ebb0e1a7$export$f182346570197b8 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $iWLL0.useFragment)((0, $edlkb.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($87ba0e13ebb0e1a7$export$c143582b21f1a708, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("edlkb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe7e8e9e2f46fca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ece559cc75651d75622d9b47e5f4a4ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2fe7e8e9e2f46fca$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$2fe7e8e9e2f46fca$var$node.hash = "d6afe351b35e0beb2951194f3010ad16";
var $2fe7e8e9e2f46fca$export$2e2bcd8739ae039 = $2fe7e8e9e2f46fca$var$node;

});

parcelRegister("dz5vK", function(module, exports) {

$parcel$export(module.exports, "default", () => $30b20635908d84ef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<08007f396db418a9d13cbce15739952a>>
 * @relayHash b249572b29f7cf45d6d7890c57510aed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8768a3b7a61167cb3f57c1ea183973ef7e13af793cc24d86f169fda9c41a20dd
const $30b20635908d84ef$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "singleUserPicker_issueFieldSingleUser_SingleUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "singleUserPicker_issueFieldSingleUser_SingleUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8768a3b7a61167cb3f57c1ea183973ef7e13af793cc24d86f169fda9c41a20dd",
            "metadata": {},
            "name": "singleUserPicker_issueFieldSingleUser_SingleUserPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$30b20635908d84ef$var$node.hash = "bd06a0600bf6d9530e408c77f4b2739a";
var $30b20635908d84ef$export$2e2bcd8739ae039 = $30b20635908d84ef$var$node;

});

parcelRegister("1oN5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7855345cda2a055$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a31bc30c0d4559ca76b3d89499f5d4d3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b7855345cda2a055$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerWithProfileCardReadView_fragmentRef"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accountStatus"
                    },
                    v0 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectUserPickerField"
    };
}();
$b7855345cda2a055$var$node.hash = "0975d1f79e46379d02c5475688cabb41";
var $b7855345cda2a055$export$2e2bcd8739ae039 = $b7855345cda2a055$var$node;

});

parcelRegister("qzL40", function(module, exports) {

$parcel$export(module.exports, "transformAggToUserOption", () => $9a568491ca73a001$export$e466b9791a3fee63);
const $9a568491ca73a001$export$e466b9791a3fee63 = (user)=>({
        avatarUrl: user.picture,
        id: user.id,
        accountId: user.accountId,
        name: user.name,
        active: user.accountStatus === 'active',
        byline: user.email ?? undefined
    });

});

parcelRegister("j1D6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $527eefb46be9b4cc$export$2e2bcd8739ae039);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $527eefb46be9b4cc$var$SingleUserPickerEditViewEntryPoint = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("eBjyt")), {
        moduleId: "9f05df27"
    }),
    getPreloadProps: ()=>({})
});
var $527eefb46be9b4cc$export$2e2bcd8739ae039 = $527eefb46be9b4cc$var$SingleUserPickerEditViewEntryPoint;

});
parcelRegister("eBjyt", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jWEZv');
        const value = parcelRequire('8i735');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jWEZv").then(()=>parcelRequire('8i735'));
}

});


parcelRegister("dG1gX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62f8cababddefac9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $62f8cababddefac9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noneOption: {
        "id": "issue-field-single-user-picker-inline-edit-full.single-user-picker.none-option",
        "defaultMessage": "None"
    }
});

});


parcelRegister("3GdvR", function(module, exports) {

$parcel$export(module.exports, "default", () => $dadf175d7786dea2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dadf175d7786dea2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    anonymous: {
        "id": "issue-field-reporter-inline-edit-full.reporter.anonymous",
        "defaultMessage": "Anonymous"
    }
});

});


parcelRegister("4mcuU", function(module, exports) {

$parcel$export(module.exports, "ConditionalWrapper", () => $9295b7604d6f45de$export$39aecc95f0365819);

var $eUqFw = parcelRequire("eUqFw");
const $9295b7604d6f45de$export$39aecc95f0365819 = ({ children: children, condition: condition, renderWrapper: renderWrapper })=>condition ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);

});

parcelRegister("g9Rct", function(module, exports) {

$parcel$export(module.exports, "default", () => $1eb154ede7cb880c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1eb154ede7cb880c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unassigned: {
        "id": "native-issue-table.common.issue-cells.user.unassigned",
        "defaultMessage": "Unassigned"
    },
    anonymous: {
        "id": "native-issue-table.common.issue-cells.user.anonymous",
        "defaultMessage": "Anonymous"
    }
});

});


parcelRegister("7jOpZ", function(module, exports) {

$parcel$export(module.exports, "VersionsCell", () => $9e8576dda12ed2b2$export$77526ce3d3d3b8ba);

var $j0usH = parcelRequire("j0usH");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $ehDeP = parcelRequire("ehDeP");
var $k85ht = parcelRequire("k85ht");
var $lmIUR = parcelRequire("lmIUR");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jqoaM = parcelRequire("jqoaM");
var $e27aD = parcelRequire("e27aD");

var $7bJW5 = parcelRequire("7bJW5");

var $2qXcq = parcelRequire("2qXcq");

var $aMNEm = parcelRequire("aMNEm");
/**
 * Expected JQL Output: `project = ${projectKey} AND ${jqlTerm} = ${name}`
 */ const $9e8576dda12ed2b2$var$getLinkJql = (projectKey, jqlTerm, name)=>{
    const jast = (0, $ehDeP.default).jast((0, $ehDeP.default).query((0, $ehDeP.default).compoundClause((0, $ehDeP.default).compoundOperator((0, $e5bc650799ce4838$export$6d6d48d210d3ca97)), [
        (0, $ehDeP.default).terminalClause((0, $ehDeP.default).field('project'), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_EQUALS)), (0, $ehDeP.default).valueOperand(projectKey)),
        (0, $ehDeP.default).terminalClause((0, $ehDeP.default).field((0, $7bJW5.escapeBackslashes)(jqlTerm)), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_EQUALS)), (0, $ehDeP.default).valueOperand((0, $7bJW5.escapeBackslashes)(name)))
    ])));
    return (0, $lmIUR.print)(jast, {
        operatorCase: (0, $1ybV0.ff)('nin-better-jql-builder-basic_m0m6q') ? 'upper' : undefined
    });
};
const $9e8576dda12ed2b2$export$77526ce3d3d3b8ba = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, projectKey: projectKey, jqlTerm: jqlTerm })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { name: fieldName, selectedVersionsConnection: selectedVersionsConnection } = (0, $iWLL0.useFragment)((0, $j0usH.default), fieldRef);
    const versions = selectedVersionsConnection?.edges;
    const filteredVersions = (0, $eUqFw.useMemo)(()=>versions?.map((edge)=>edge?.node?.name != null ? {
                key: edge.node.name,
                name: edge.node.name,
                href: `${issueSearchBaseUrl}?jql=${encodeURIComponent($9e8576dda12ed2b2$var$getLinkJql(projectKey, jqlTerm, edge.node.name))}`
            } : null).filter((0, $7bJW5.isNonNullish)) ?? [], [
        versions,
        issueSearchBaseUrl,
        projectKey,
        jqlTerm
    ]);
    if (!versions || versions.length !== filteredVersions.length || !projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: "versions",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jqoaM.default), {
        items: filteredVersions,
        ItemComponent: (0, $e27aD.TagItem),
        PopupContentWrapper: (0, $e27aD.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $aMNEm.default).triggerButtonGeneric, {
            fieldName: fieldName
        })
    });
});

});
parcelRegister("j0usH", function(module, exports) {

$parcel$export(module.exports, "default", () => $accb9de16e5d6657$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<422d1c77c9ecbf3070621cc54e31d0bc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $accb9de16e5d6657$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "versions_nativeIssueTable_VersionsCell",
        "selections": [
            v0 /*: any*/ ,
            {
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    };
}();
$accb9de16e5d6657$var$node.hash = "56f60cdf44500ce5fad5ee491fa776bb";
var $accb9de16e5d6657$export$2e2bcd8739ae039 = $accb9de16e5d6657$var$node;

});

parcelRegister("aMNEm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3b0d2a57cb6dc6d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d3b0d2a57cb6dc6d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    triggerButtonGeneric: {
        "id": "native-issue-table.common.issue-cells.versions.trigger-button-generic",
        "defaultMessage": "See more versions for \u2018{fieldName}\u2018"
    }
});

});


parcelRegister("1UfY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e2765ced8c9ea07$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $8WuJm = parcelRequire("8WuJm");

var $a4IeB = parcelRequire("a4IeB");

var $2qXcq = parcelRequire("2qXcq");

var $jVgJ8 = parcelRequire("jVgJ8");
const $2e2765ced8c9ea07$var$DefaultFallbackComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
const $2e2765ced8c9ea07$var$IssueRowCellErrorFallback = ({ type: type, columnWidth: columnWidth, isFlexWidth: isFlexWidth, border: border })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVgJ8.TableCell), {
        columnWidth: columnWidth,
        isFlexWidth: isFlexWidth,
        border: border
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qXcq.default), {
        cellType: type,
        reason: "Unhandled error"
    }));
const $2e2765ced8c9ea07$var$IssueRowCell = ({ type: type, cellElement: cellElement, border: border, spacing: spacing, columnWidth: columnWidth, isFlexWidth: isFlexWidth, FallbackComponent: FallbackComponent = $2e2765ced8c9ea07$var$DefaultFallbackComponent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            fieldType: type
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: (0, $a4IeB.PACKAGE_NAME),
        teamName: (0, $a4IeB.TEAM_NAME),
        id: "issueRowCellUnhandled",
        sendToPrivacyUnsafeSplunk: true,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2e2765ced8c9ea07$var$IssueRowCellErrorFallback, {
                type: type,
                columnWidth: columnWidth,
                isFlexWidth: isFlexWidth,
                border: border
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVgJ8.TableCell), {
        spacing: spacing,
        columnWidth: columnWidth,
        isFlexWidth: isFlexWidth,
        border: border
    }, cellElement ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FallbackComponent, null))));
var $2e2765ced8c9ea07$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($2e2765ced8c9ea07$var$IssueRowCell);

});


parcelRegister("fg9pv", function(module, exports) {

$parcel$export(module.exports, "useDraggableTableRow", () => $7332b62573bcdb43$export$f87ab24ec74f8aa9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $fSMvP = parcelRequire("fSMvP");
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");
parcelRequire("eo9PV");
var $9wCS5 = parcelRequire("9wCS5");

var $kSH1K = parcelRequire("kSH1K");
const $7332b62573bcdb43$var$PLATFORM_ISSUE_TABLE_ROW = Symbol('PLATFORM_ISSUE_TABLE_ROW');
// TODO: use shared component from https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/pull-requests/106327/diff#local-conf%2Ftsconfigs%2F%40atlassian-jira-software-drop-indicator%2Ftsconfig.app.json
// using <td> is highly questionable and due to the table layout / DOM nesting validation
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7332b62573bcdb43$var$DropIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { edge: edge, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltvze3t _1bsb1osq _4t3iyh40 _1pbykb7n _1yt4ze3t _1e0c1txw _1bahesu3 _4cvr1h6o _bfhk1r2e _lcxvglyw _1kt9b3bt _1cs8stnw _kfgtidpf _1mp4idpf _1auk1i6y _qnecr5cr _1pq8156q _4k1c156q _1n1jj0d6",
            __cmplp.edge === 'top' && "_154ize3t",
            __cmplp.edge === 'bottom' && "_94n5ze3t",
            __cmplp.className
        ])
    });
});
const $7332b62573bcdb43$export$f87ab24ec74f8aa9 = ({ ref: ref, enableRowDragging: enableRowDragging, issueId: issueId, issuesConnectionId: issuesConnectionId })=>{
    const onDrop = (0, $kSH1K.useOnDrop)(issuesConnectionId);
    const [dropState, setDropState] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        const tableRowElement = ref.current;
        if (!tableRowElement) return;
        if (!enableRowDragging) return;
        if (issueId == null) return;
        return (0, $jFl9L.combine)((0, $9wCS5.draggable)({
            element: tableRowElement,
            getInitialData () {
                return {
                    type: $7332b62573bcdb43$var$PLATFORM_ISSUE_TABLE_ROW,
                    issueId: issueId
                };
            }
        }), (0, $9wCS5.dropTargetForElements)({
            element: tableRowElement,
            getData ({ input: input, element: element }) {
                const data = {
                    type: $7332b62573bcdb43$var$PLATFORM_ISSUE_TABLE_ROW,
                    issueId: issueId
                };
                return (0, $fSMvP.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            canDrop (args) {
                return args.source.data.type === $7332b62573bcdb43$var$PLATFORM_ISSUE_TABLE_ROW;
            },
            onDragEnter (args) {
                if (args.source.data.type !== $7332b62573bcdb43$var$PLATFORM_ISSUE_TABLE_ROW) return;
                const edge = (0, $fSMvP.extractClosestEdge)(args.self.data);
                if (!edge) return;
                setDropState({
                    edge: edge
                });
            },
            onDragLeave () {
                setDropState(null);
            },
            onDrop (args) {
                if (args.source.data.type !== $7332b62573bcdb43$var$PLATFORM_ISSUE_TABLE_ROW) return;
                const edge = (0, $fSMvP.extractClosestEdge)(args.self.data);
                const sourceIssueId = args.source.data.issueId;
                const targetIssueId = args.self.data.issueId;
                const dropOperation = {
                    sourceIssueId: String(sourceIssueId),
                    targetIssueId: String(targetIssueId),
                    edge: edge === 'top' ? 'top' : 'bottom'
                };
                setDropState(null);
                onDrop(dropOperation);
            }
        }));
    }, [
        enableRowDragging,
        issueId,
        onDrop,
        ref
    ]);
    return {
        dropState: dropState,
        dropIndicator: dropState?.edge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7332b62573bcdb43$var$DropIndicator, {
            edge: dropState.edge
        })
    };
};

});
parcelRegister("kSH1K", function(module, exports) {

$parcel$export(module.exports, "useOnDrop", () => $492932dafdf8f8a7$export$2bb79709b1ac493e);

var $4E1Nh = parcelRequire("4E1Nh");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");
const $492932dafdf8f8a7$export$764700da65a4eaae = ({ store: store, issuesConnectionId: issuesConnectionId, dropOperation: dropOperation })=>{
    const connection = store.get(issuesConnectionId);
    const edges = connection?.getLinkedRecords('edges');
    if (!connection || !edges) return;
    const sourceEdge = edges.find((edge)=>edge?.getLinkedRecord('node')?.getValue('id') === dropOperation.sourceIssueId);
    if (!sourceEdge) return;
    const edgesWithoutSource = edges.filter((edge)=>edge?.getLinkedRecord('node')?.getValue('id') !== dropOperation.sourceIssueId);
    const targetEdgeIndex = edgesWithoutSource.findIndex((edge)=>edge?.getLinkedRecord('node')?.getValue('id') === dropOperation.targetIssueId);
    edgesWithoutSource.splice(targetEdgeIndex + (dropOperation.edge === 'top' ? 0 : 1), 0, sourceEdge);
    connection?.setLinkedRecords(edgesWithoutSource, 'edges');
};
const $492932dafdf8f8a7$export$2bb79709b1ac493e = (issuesConnectionId)=>{
    const [runMutation] = (0, $iWLL0.useMutation)((0, $4E1Nh.default));
    const onDrop = (0, $eUqFw.useCallback)((dropOperation)=>{
        runMutation({
            variables: {
                rankInput: {
                    issues: [
                        dropOperation.sourceIssueId
                    ],
                    relativeToIssue: dropOperation.targetIssueId,
                    edge: dropOperation.edge === 'top' ? 'TOP' : 'BOTTOM'
                }
            },
            optimisticUpdater: (store)=>{
                $492932dafdf8f8a7$export$764700da65a4eaae({
                    store: store,
                    dropOperation: dropOperation,
                    issuesConnectionId: issuesConnectionId
                });
            },
            updater: (store, response)=>{
                if (response?.jira?.rankIssues?.success) $492932dafdf8f8a7$export$764700da65a4eaae({
                    store: store,
                    dropOperation: dropOperation,
                    issuesConnectionId: issuesConnectionId
                });
            }
        });
    }, [
        issuesConnectionId,
        runMutation
    ]);
    return onDrop;
};

});
parcelRegister("4E1Nh", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f31dcef9fd4b99$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<197facd87026469d8e8814938333f78a>>
 * @relayHash f56659a91edb3c53df0efb891f9ae234
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7f248788b8871797d3b9023c6108bd7847c909c8ea58b7e9c168164749318b47
const $43f31dcef9fd4b99$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "rankInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "rankInput",
            "variableName": "rankInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useOnDrop_issueTableRow_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRankMutationPayload",
                            "kind": "LinkedField",
                            "name": "rankIssues",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useOnDrop_issueTableRow_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRankMutationPayload",
                            "kind": "LinkedField",
                            "name": "rankIssues",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7f248788b8871797d3b9023c6108bd7847c909c8ea58b7e9c168164749318b47",
            "metadata": {},
            "name": "useOnDrop_issueTableRow_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$43f31dcef9fd4b99$var$node.hash = "f5872de9c00676cc10d47e5c338fc26b";
var $43f31dcef9fd4b99$export$2e2bcd8739ae039 = $43f31dcef9fd4b99$var$node;

});



parcelRegister("6S1XJ", function(module, exports) {

$parcel$export(module.exports, "scrollToMiddle", () => $abcf69cc8098b352$export$6507690ca27f4578);
// cleanup with jsv-one-issue-table-spreadsheet-ui_ygrnf
/* eslint-disable no-param-reassign */ const $abcf69cc8098b352$export$6507690ca27f4578 = (actions)=>{
    actions.forEach(({ el: el, top: top })=>{
        if (el.scrollTop === top) return;
        const halfVisibleHeight = el.clientHeight / 2;
        if (el.scrollTop > top) el.scrollTop = top - halfVisibleHeight;
        else el.scrollTop = top + halfVisibleHeight;
    });
}; /* eslint-enable no-param-reassign */ 

});



parcelRegister("6abVn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a68d2ca37e0869d1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1S8jG = parcelRequire("1S8jG");

var $fSMvP = parcelRequire("fSMvP");

var $4c90u = parcelRequire("4c90u");
parcelRequire("eo9PV");
var $9wCS5 = parcelRequire("9wCS5");
parcelRequire("gPx3x");
var $j2oqV = parcelRequire("j2oqV");

var $kjXsi = parcelRequire("kjXsi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $a4IeB = parcelRequire("a4IeB");

var $5QdQ5 = parcelRequire("5QdQ5");

var $doqfp = parcelRequire("doqfp");
function $a68d2ca37e0869d1$var$extractIndex(data) {
    const { index: index } = data;
    if (typeof index !== 'number') return null;
    return index;
}
function $a68d2ca37e0869d1$var$setStyle(el, property, value) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, value, 'important');
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $a68d2ca37e0869d1$var$isHtmlElement(value) {
    return value instanceof HTMLElement;
} /**
   * Set the style of a table column to indicate its being dragged.
   * Since Compiled doesn't support dynamic selectors, this approach is used to avoid re-rendering the table cells.
   *
   * @returns an array of `cleanup` functions to restore the `style` property of each cell to its original state
   */ 
function $a68d2ca37e0869d1$export$beda47c60d6caf6a(table, columnIndex) {
    return Array.from(table.querySelectorAll(`td:nth-child(${columnIndex + 1})`)).filter($a68d2ca37e0869d1$var$isHtmlElement).map((element)=>$a68d2ca37e0869d1$var$setStyle(element, 'opacity', '0.4'));
} /**
   * Runs a flash animation on the background color of the column that has been reordered,
   * in order to highlight where the column has moved to.
   */ 
function $a68d2ca37e0869d1$var$triggerColumnFlash(table, columnIndex) {
    const columnCellsSelector = `th:nth-child(${columnIndex + 1}), td:nth-child(${columnIndex + 1})`;
    Array.from(table.querySelectorAll(columnCellsSelector)).filter($a68d2ca37e0869d1$var$isHtmlElement).forEach((element)=>(0, $1S8jG.triggerPostMoveFlash)(element));
}
const $a68d2ca37e0869d1$export$f850895b287ef28e = /*#__PURE__*/ (0, $eUqFw.memo)(({ columns: columns, hasColumnConfiguration: hasColumnConfiguration, onColumnsChange: onColumnsChange, tableRef: tableRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const tableHeadRef = (0, $eUqFw.useRef)(null); // The clean up functions to restore the `style` property of each cell to its original state
    // are stored in a ref rather than in the useEffect closure as a new drag can start
    // before the column reorder is complete, causing the cleanup functions to be lost.
    const styleCleanupFnsRef = (0, $eUqFw.useRef)([]);
    const [instanceId] = (0, $eUqFw.useState)(()=>Symbol('instance-id'));
    const [screenReaderMessage, setScreenReaderMessage] = (0, $eUqFw.useState)('');
    const [lastReorderOperation, setLastReorderOperation] = (0, $eUqFw.useState)(null); // Height of the visible part of the table (i.e. excluding content outside the scroll area)
    // This is used to calculate the height of the column preview image we display while dragging
    const [visibleTableHeight, setVisibleTableHeight] = (0, $eUqFw.useState)(0);
    const totalColumns = columns.length;
    const isDraggable = hasColumnConfiguration && totalColumns > 2;
    const totalColumnsExcludingMenu = columns.filter(({ id: id })=>Boolean(id) && id !== (0, $a4IeB.COLUMN_ID_MEATBALL_MENU)).length;
    const reorderColumn = (0, $eUqFw.useCallback)(({ startIndex: startIndex, indexOfTarget: indexOfTarget, closestEdgeOfTarget: closestEdgeOfTarget = null })=>{
        const finishIndex = (0, $4c90u.getReorderDestinationIndex)({
            axis: 'horizontal',
            startIndex: startIndex,
            indexOfTarget: indexOfTarget,
            closestEdgeOfTarget: closestEdgeOfTarget
        });
        if (startIndex === finishIndex) return;
        const newColumns = (0, $j2oqV.reorder)({
            list: columns,
            startIndex: startIndex,
            finishIndex: finishIndex
        });
        onColumnsChange?.(newColumns);
        setLastReorderOperation({
            finishIndex: finishIndex
        });
        setScreenReaderMessage(formatMessage((0, $5QdQ5.default).dndMoved, {
            column: columns[startIndex]?.title,
            previousPosition: startIndex + 1,
            position: finishIndex + 1,
            total: totalColumnsExcludingMenu
        }));
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'reordered',
            actionSubject: 'columns'
        }), 'issueTable');
    }, [
        columns,
        createAnalyticsEvent,
        formatMessage,
        onColumnsChange,
        totalColumnsExcludingMenu
    ]);
    (0, $eUqFw.useEffect)(()=>(0, $9wCS5.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.instanceId === instanceId;
            },
            onGenerateDragPreview () {
                const tableRect = tableRef?.current?.getBoundingClientRect();
                const tableHeadRect = tableHeadRef.current?.getBoundingClientRect();
                if (tableRect && tableHeadRect) // We calculate the height this way rather than using `tableRect.height` because the table head is sticky
                // and when the table is scrolled, this prevents the drag preview from overflowing the table.
                setVisibleTableHeight(tableRect.bottom - tableHeadRect.top);
                else setVisibleTableHeight(0);
            },
            onDragStart ({ source: source }) {
                const columnIndex = $a68d2ca37e0869d1$var$extractIndex(source.data);
                const table = tableRef?.current;
                if (columnIndex === null || !table) return;
                styleCleanupFnsRef.current = $a68d2ca37e0869d1$export$beda47c60d6caf6a(table, columnIndex);
            },
            onDrop ({ location: location, source: source }) {
                styleCleanupFnsRef.current.forEach((fn)=>fn());
                styleCleanupFnsRef.current.length = 0;
                const destination = location.current.dropTargets[0];
                if (!destination) return;
                const indexOfTarget = $a68d2ca37e0869d1$var$extractIndex(destination.data);
                const startIndex = $a68d2ca37e0869d1$var$extractIndex(source.data);
                if (indexOfTarget === null || startIndex === null) return;
                const closestEdgeOfTarget = (0, $fSMvP.extractClosestEdge)(destination.data);
                reorderColumn({
                    startIndex: startIndex,
                    indexOfTarget: indexOfTarget,
                    closestEdgeOfTarget: closestEdgeOfTarget
                });
            }
        }), [
        columns,
        instanceId,
        reorderColumn,
        tableRef
    ]);
    // We use an object for lastReorderOperation so we can trigger the column flash
    // if the finish index is the same as the previous reorder operation.
    (0, $eUqFw.useEffect)(()=>{
        const table = tableRef?.current;
        if (!table || lastReorderOperation === null) return;
        $a68d2ca37e0869d1$var$triggerColumnFlash(table, lastReorderOperation.finishIndex);
    }, [
        lastReorderOperation,
        tableRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderCaption), {
        "aria-live": "assertive" // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        ,
        "data-testid": "native-issue-table.ui.issue-table.table-header.screen-reader-caption"
    }, screenReaderMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a68d2ca37e0869d1$var$TableHead, {
        ref: tableHeadRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, columns.map((column, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: column.id
        }, column.customHeader !== undefined ? column.customHeader : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $doqfp.default), {
            column: column,
            index: index,
            instanceId: instanceId,
            isDraggable: isDraggable,
            reorderColumn: reorderColumn,
            totalColumns: totalColumns,
            totalColumnsExcludingMenu: totalColumnsExcludingMenu,
            visibleTableHeight: visibleTableHeight
        }))))));
});
var $a68d2ca37e0869d1$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a68d2ca37e0869d1$export$f850895b287ef28e;
const $a68d2ca37e0869d1$var$TableHead = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "thead", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _154iidpf _1pbykb7n _bfhkvuon _19itglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5QdQ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ad8fc9000a782c1$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $3ad8fc9000a782c1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    dndFocused: {
        "id": "native-issue-table.issue-table.table-header.dnd-focused",
        "defaultMessage": "{column} can be moved. Make sure your screen reader isn\u2019t in browse mode, press the spacebar to grab it and the arrow keys to move it."
    },
    dndPicked: {
        "id": "native-issue-table.issue-table.table-header.dnd-picked",
        "defaultMessage": "{column} grabbed. Current position is {position} of {total}. Use the arrow keys to move, spacebar to drop, escape to cancel."
    },
    dndMoved: {
        "id": "native-issue-table.issue-table.table-header.dnd-moved",
        "defaultMessage": "You\u2019ve moved {column} from {previousPosition} to {position} of {total}."
    },
    dndReturned: {
        "id": "native-issue-table.issue-table.table-header.dnd-returned",
        "defaultMessage": "You\u2019ve moved {column} back to its original position {position} of {total}."
    },
    dndDropped: {
        "id": "native-issue-table.issue-table.table-header.dnd-dropped",
        "defaultMessage": "You\u2019ve dropped {column}. Final position is {position} of {total}."
    }
});

});

parcelRegister("doqfp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a71e0525b4dd14a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gCtmO = parcelRequire("gCtmO");

var $kIC5O = parcelRequire("kIC5O");

var $jaJFT = parcelRequire("jaJFT");
const $7a71e0525b4dd14a$export$9e1517a3035b3e5c = ({ column: column, index: index, instanceId: instanceId, isDraggable: isDraggable, reorderColumn: reorderColumn, totalColumns: totalColumns, totalColumnsExcludingMenu: totalColumnsExcludingMenu, visibleTableHeight: visibleTableHeight = 0 })=>{
    const headerRef = (0, $eUqFw.useRef)(null);
    const { isSortable: doesColumnAllowSorting = true, onSortOrderChanged: onSortOrderChanged, shouldResizeWithTable: shouldResizeWithTable, width: width } = column;
    const isSortable = onSortOrderChanged !== undefined && doesColumnAllowSorting;
    const columnWidth = shouldResizeWithTable === true ? undefined : width;
    const isInteractive = isDraggable || isSortable;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCtmO.HeaderCell), {
        scope: "col",
        columnWidth: columnWidth,
        minColumnWidth: width,
        ref: headerRef,
        // read as the column title when a user is navigating between columns in the table content.
        "aria-label": column.title
    }, isInteractive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIC5O.default), {
        column: column,
        headerRef: headerRef,
        index: index,
        instanceId: instanceId,
        isDraggable: isDraggable,
        isSortable: isSortable,
        reorderColumn: reorderColumn,
        totalColumns: totalColumns,
        totalColumnsExcludingMenu: totalColumnsExcludingMenu,
        visibleTableHeight: visibleTableHeight
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jaJFT.default), {
        column: column
    }));
};
var $7a71e0525b4dd14a$export$2e2bcd8739ae039 = $7a71e0525b4dd14a$export$9e1517a3035b3e5c;

});
parcelRegister("kIC5O", function(module, exports) {

$parcel$export(module.exports, "default", () => $c32e1b52a075a7f0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $lEfVV = parcelRequire("lEfVV");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $dULIU = parcelRequire("dULIU");

var $fSMvP = parcelRequire("fSMvP");

var $loClp = parcelRequire("loClp");
parcelRequire("eo9PV");
var $9wCS5 = parcelRequire("9wCS5");
parcelRequire("bweg7");
var $jfbwa = parcelRequire("jfbwa");

var $8cU5f = parcelRequire("8cU5f");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $a4IeB = parcelRequire("a4IeB");

var $4mcuU = parcelRequire("4mcuU");

var $9eMIF = parcelRequire("9eMIF");

var $gCtmO = parcelRequire("gCtmO");

var $exPVl = parcelRequire("exPVl");


var $7aQIg = parcelRequire("7aQIg");
const $c32e1b52a075a7f0$var$idleState = {
    type: 'idle'
};
const $c32e1b52a075a7f0$var$draggingState = {
    type: 'dragging'
};
function $c32e1b52a075a7f0$var$getColumnType(index, totalColumns) {
    if (index === 0) return 'first';
    if (index === totalColumns - 1) return 'last';
    return 'middle';
}
const $c32e1b52a075a7f0$var$DRAG_PREVIEW_MAX_WIDTH = 260;
const $c32e1b52a075a7f0$export$24a742478055e9ed = ({ column: column, headerRef: headerRef, index: index, instanceId: instanceId, isDraggable: isDraggable, isSortable: isSortable, reorderColumn: reorderColumn, totalColumns: totalColumns, totalColumnsExcludingMenu: totalColumnsExcludingMenu, visibleTableHeight: visibleTableHeight })=>{
    if (!isDraggable && !isSortable) throw new Error('InteractiveTableHeaderCellContent should only be rendered for interactive header cells');
    const intl = (0, $5JgJ2.default)();
    const [state, setState] = (0, $eUqFw.useState)($c32e1b52a075a7f0$var$idleState);
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = (0, $eUqFw.useState)(false);
    const draggableRef = (0, $eUqFw.useRef)(null);
    const dropTargetRef = (0, $eUqFw.useRef)(null);
    const { ascText: ascText, currentSorting: sortOrder = (0, $a4IeB.SORT_NONE), descText: descText, id: id, jqlTerm: jqlTerm, type: type, onSortOrderChanged: onSortOrderChanged, title: title, warningText: warningText } = column;
    const isFirstColumn = index === 0;
    const isLastColumn = index === totalColumnsExcludingMenu - 1; // Detect whether we should render a drop target
    (0, $eUqFw.useEffect)(()=>(0, $9wCS5.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.instanceId === instanceId && source.data.id !== id;
            },
            onDragStart () {
                setState({
                    type: 'drop-target',
                    closestEdge: null
                });
            },
            onDrop () {
                setState($c32e1b52a075a7f0$var$idleState);
            }
        }), [
        id,
        instanceId
    ]); // Dynamically create a drop target after drag starts. We're making the drop target the full height
    // of the table so that a column can be reordered by dragging anywhere on the edge of the column.
    (0, $eUqFw.useEffect)(()=>{
        if (state.type !== 'drop-target') return;
        const dropTarget = dropTargetRef.current;
        if (!dropTarget) return;
        return (0, $9wCS5.dropTargetForElements)({
            element: dropTarget,
            getData ({ input: input, element: element }) {
                const data = {
                    id: id,
                    index: index
                };
                return (0, $fSMvP.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'left',
                        'right'
                    ]
                });
            },
            canDrop ({ source: source }) {
                return source.data.instanceId === instanceId && source.data.id !== id;
            },
            onDrag ({ self: self }) {
                setState((current)=>{
                    if (current.type !== 'drop-target') return current;
                    const closestEdge = (0, $fSMvP.extractClosestEdge)(self.data);
                    if (current.closestEdge === closestEdge) return current;
                    return {
                        type: 'drop-target',
                        closestEdge: closestEdge
                    };
                });
            },
            onDragLeave () {
                setState({
                    type: 'drop-target',
                    closestEdge: null
                });
            },
            onDrop () {
                setState($c32e1b52a075a7f0$var$idleState);
            }
        });
    }, [
        id,
        index,
        instanceId,
        state.type
    ]);
    // Set up the draggable element
    (0, $eUqFw.useEffect)(()=>{
        if (!isDraggable) return;
        const header = headerRef.current;
        const element = draggableRef.current;
        if (!header || !element) return;
        return (0, $9wCS5.draggable)({
            element: element,
            getInitialData () {
                return {
                    id: id,
                    index: index,
                    instanceId: instanceId
                };
            },
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage }) {
                const headerWidth = header.getBoundingClientRect().width;
                const previewWidth = Math.min(headerWidth, $c32e1b52a075a7f0$var$DRAG_PREVIEW_MAX_WIDTH);
                (0, $jfbwa.setCustomNativeDragPreview)({
                    // Position the drag preview over the top of the column
                    getOffset: ()=>({
                            x: 0,
                            y: 20
                        }),
                    render: ({ container: container })=>{
                        // Cause a `react` re-render to create the portal synchronously
                        setState({
                            type: 'preview',
                            container: container,
                            previewWidth: previewWidth
                        }); // Cause a `react` re-render to remove the portal
                        return ()=>setState($c32e1b52a075a7f0$var$draggingState);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart () {
                setState($c32e1b52a075a7f0$var$draggingState);
            },
            onDrop () {
                setState($c32e1b52a075a7f0$var$idleState);
            }
        });
    }, [
        headerRef,
        id,
        index,
        instanceId,
        isDraggable
    ]);
    // Close the dropdown menu when a drag starts on any column
    (0, $eUqFw.useEffect)(()=>{
        if (state.type !== 'idle') setIsDropdownMenuOpen(false);
    }, [
        state.type
    ]);
    const { getIcon: getIcon, getNextState: getNextState, getTooltipSuffix: getTooltipSuffix, isIconPersistent: isIconPersistent } = (0, $9eMIF.getSortOrderConfig)({
        sortOrder: sortOrder,
        intl: intl
    });
    const tooltipContent = (0, $eUqFw.useMemo)(()=>`${title} \u{2022} ${getTooltipSuffix({
            ascText: ascText,
            descText: descText
        })}`, [
        ascText,
        descText,
        getTooltipSuffix,
        title
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleSortClick = (0, $eUqFw.useCallback)(()=>{
        const nextState = getNextState();
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(event, 'button clicked', 'sortOrderChange', {
            fieldType: type,
            sortOrder: nextState
        });
        if (onSortOrderChanged && jqlTerm != null) // TODO EM-5150 Ideally API should be providing aliases alongside jqlTerm
        // TODO In future we should remove this type restriction and allow any string value as column id.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onSortOrderChanged(jqlTerm, nextState);
    }, [
        getNextState,
        createAnalyticsEvent,
        type,
        onSortOrderChanged,
        jqlTerm
    ]);
    const withSortButton = (0, $eUqFw.useCallback)((children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c32e1b52a075a7f0$var$SortButton, {
            isDraggable: isDraggable,
            isDragging: state.type === 'dragging',
            onClick: handleSortClick
        }, children)), [
        handleSortClick,
        isDraggable,
        state.type,
        tooltipContent
    ]);
    const moveLeft = (0, $eUqFw.useCallback)(()=>{
        reorderColumn({
            startIndex: index,
            indexOfTarget: index - 1
        });
    }, [
        reorderColumn,
        index
    ]);
    const moveRight = (0, $eUqFw.useCallback)(()=>{
        reorderColumn({
            startIndex: index,
            indexOfTarget: index + 1
        });
    }, [
        reorderColumn,
        index
    ]);
    const onDropdownMenuOpenChange = (0, $eUqFw.useCallback)(({ isOpen: isOpen })=>{
        setIsDropdownMenuOpen(isOpen);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c32e1b52a075a7f0$var$CellContentContainer, {
        "data-component-selector": (0, $760d9ef88e4736c6$export$b9a6eed0cc1043b4),
        isDropdownMenuOpen: isDropdownMenuOpen,
        isDraggable: isDraggable,
        isSortable: isSortable,
        isIconPersistent: isIconPersistent,
        ref: draggableRef
    }, isDraggable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        isOpen: isDropdownMenuOpen,
        onOpenChange: onDropdownMenuOpenChange,
        testId: `native-issue-table.ui.issue-table.table-header-old.table-header-cell.interactive.${id}-reorder-menu`,
        trigger: ({ testId: testId, triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c32e1b52a075a7f0$var$DragHandleButton, {
                ...triggerProps,
                "data-testid": testId,
                ref: triggerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c32e1b52a075a7f0$var$DragHandleIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dULIU))), {
                label: intl.formatMessage((0, $7aQIg.default).reorderColumn, {
                    title: title
                }),
                size: "medium",
                primaryColor: "var(--ds-icon-subtle, #626F86)"
            })))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        isDisabled: isFirstColumn,
        onClick: moveLeft
    }, intl.formatMessage((0, $7aQIg.default).moveLeft)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        isDisabled: isLastColumn,
        onClick: moveRight
    }, intl.formatMessage((0, $7aQIg.default).moveRight)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4mcuU.ConditionalWrapper), {
        condition: isSortable,
        renderWrapper: withSortButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c32e1b52a075a7f0$var$CellContent, null, warningText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $exPVl.default), {
        tooltip: warningText
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCtmO.ColumnName), null, title), isSortable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCtmO.SortIcon), {
        "data-component-selector": (0, $760d9ef88e4736c6$export$e31c29a7432f4dab),
        isIconPersistent: isIconPersistent
    }, getIcon())))), state.type === 'drop-target' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c32e1b52a075a7f0$var$DropTarget, {
        ref: dropTargetRef,
        height: visibleTableHeight,
        columnType: $c32e1b52a075a7f0$var$getColumnType(index, totalColumns),
        "data-testid": `native-issue-table.ui.issue-table.table-header-old.table-header-cell.interactive.${id}-drop-target`
    }, state.closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $loClp.DropIndicator), {
        edge: state.closestEdge
    })), state.type === 'preview' && /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c32e1b52a075a7f0$var$DragPreview, {
        height: visibleTableHeight,
        width: state.previewWidth,
        "data-testid": `native-issue-table.ui.issue-table.table-header-old.table-header-cell.interactive.${id}-drag-preview`
    }), state.container));
};
var $c32e1b52a075a7f0$export$2e2bcd8739ae039 // Pragmatic DnD experience styles
 = $c32e1b52a075a7f0$export$24a742478055e9ed;
const $c32e1b52a075a7f0$var$buttonHeight = '28px';
const $c32e1b52a075a7f0$var$dragHandleOpacityCssVar = '--drag-handle-opacity';
const $c32e1b52a075a7f0$var$dragHandleWidthCssVar = '--drag-handle-width';
const $c32e1b52a075a7f0$var$dragHandleStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c32e1b52a075a7f0$var$CellContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDraggable: isDraggable, isDropdownMenuOpen: isDropdownMenuOpen, isSortable: isSortable, isIconPersistent: isIconPersistent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_q9jdxo": (0, $9t7rW.default)((0, $a4IeB.getDragIconSize)()),
            "--_kum4z7": (0, $9t7rW.default)((0, $a4IeB.getMarginBetweenHeaders)())
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1hd1idpf _4un3ftgi _1e0c116y _4cvr1h6o _2hwx1mp7 _k48pbfng _2rkoiti9 _v564pzo7 _19j9t94y _ch92t94y _1gs61erp _hyzr1erp _10j7166n _irr3166n",
            __cmplp.isDraggable || __cmplp.isDropdownMenuOpen ? "_110y18de _189718de" : "_110y1mp7 _18971mp7",
            __cmplp.isDraggable && !__cmplp.isSortable && "_u5f3u2gc _80om1qgj",
            __cmplp.isIconPersistent && "_bfhk166n",
            __cmplp.isDropdownMenuOpen && "_1hd1t94y _4un31erp _bfhk166n _2hwx18de",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c32e1b52a075a7f0$var$DragHandleButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_q9jdxo": (0, $9t7rW.default)((0, $a4IeB.getDragIconSize)())
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1f4h _13lisqtm _mrkbsqtm _qrwqidpf _1o0zidpf _1yt4ze3t _19itglyw _80om1qgj _1e0c1txw _4cvr1h6o _1bsbiuip _tzy44dsi _1reo15vq _18m915vq _v564go9e _y2mv1ekn _ymio1r31 _ypr0glyw _zcxs1o36 _19lvkb7n _hq7jkb7n _qu2i1erp _ykhm1erp _irr3166n _1di61dty",
            __cmplp.isSelected ? "_bfhk1dty" : "_bfhk18uv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c32e1b52a075a7f0$var$DragHandleIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c32e1b52a075a7f0$var$SortButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDraggable: isDraggable, isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qze3t _n3tdze3t _4t3i1f4h _u5f3u2gc _19itglyw _13liidpf _mrkbidpf _qrwqsqtm _1o0zsqtm _80omtlke _syaz10s3 _bfhk18uv _k48p1kw7 _y2mv1ekn _ymio1r31 _ypr0glyw _zcxs1o36 _hfrpkb7n _tqqmkb7n _11hy6ebc _dklq6ebc",
            __cmplp.isDraggable ? "_19bvze3t" : "_19bvu2gc",
            __cmplp.isDragging && "_tzy41ou4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c32e1b52a075a7f0$var$CellContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c32e1b52a075a7f0$var$DropTarget = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { columnType: columnType, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _4t3i2nrh",
            __cmplp.columnType === 'first' ? "_1ltvt94y" : "_1ltvidpf",
            __cmplp.columnType === 'last' ? "_1xi2t94y" : "_1xi2idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c32e1b52a075a7f0$var$DragPreview = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`),
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i2nrh _c71l1kxc _1bsb1hdq _1h6d1p6i _1dqonqa1 _2rkoiti9 _189e1bk5 _bfhk7wq0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9eMIF", function(module, exports) {

$parcel$export(module.exports, "getSortOrderConfig", () => $9fad8e0d7c6e71af$export$c7e04842b898e372);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $9SdpV = parcelRequire("9SdpV");

var $hL0Qd = parcelRequire("hL0Qd");

var $PdmhA = parcelRequire("PdmhA");

var $2125q = parcelRequire("2125q");

var $a4IeB = parcelRequire("a4IeB");
// TODO: delete this file when cleaning up jsv-one-issue-table-spreadsheet-ui_ygrnf
const $9fad8e0d7c6e71af$var$getSortOrderConfigs = (0, $5iWql.default)(({ formatMessage: formatMessage })=>({
        [(0, $a4IeB.SORT_ASC)]: {
            getNextState: ()=>(0, $a4IeB.SORT_DESC),
            getIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hL0Qd))), {
                    label: formatMessage((0, $2125q.default).sortedDefaultAscendingTooltip),
                    size: "small"
                }),
            isIconPersistent: true,
            getTooltipSuffix: ({ ascText: ascText })=>ascText ?? false ? formatMessage((0, $2125q.default).sortedTooltip, {
                    sortDescription: ascText
                }) : formatMessage((0, $2125q.default).sortedDefaultAscendingTooltip)
        },
        [(0, $a4IeB.SORT_DESC)]: {
            getNextState: ()=>(0, $a4IeB.SORT_ASC),
            getIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9SdpV))), {
                    label: formatMessage((0, $2125q.default).sortedDefaultDescendingTooltip),
                    size: "small"
                }),
            isIconPersistent: true,
            getTooltipSuffix: ({ descText: descText })=>descText ?? false ? formatMessage((0, $2125q.default).sortedTooltip, {
                    sortDescription: descText
                }) : formatMessage((0, $2125q.default).sortedDefaultDescendingTooltip)
        },
        [(0, $a4IeB.SORT_NONE)]: {
            getNextState: ()=>(0, $a4IeB.SORT_ASC),
            getIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hL0Qd))), {
                    label: formatMessage((0, $2125q.default).sortPromptDefaultTooltip),
                    size: "small",
                    primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N60})`
                }),
            isIconPersistent: false,
            getTooltipSuffix: ({ ascText: ascText })=>ascText ?? false ? formatMessage((0, $2125q.default).sortPromptTooltip, {
                    sortDescription: ascText
                }) : formatMessage((0, $2125q.default).sortPromptDefaultTooltip)
        }
    }));
const $9fad8e0d7c6e71af$export$c7e04842b898e372 = ({ sortOrder: sortOrder, intl: intl })=>$9fad8e0d7c6e71af$var$getSortOrderConfigs(intl)[sortOrder];

});

const $760d9ef88e4736c6$export$e31c29a7432f4dab = 'jira-native-issue-table-sort-icon';
const $760d9ef88e4736c6$export$b9a6eed0cc1043b4 = 'jira-native-issue-table-header-cell-content';

parcelRegister("7aQIg", function(module, exports) {

$parcel$export(module.exports, "default", () => $a213881b25286555$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $a213881b25286555$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    reorderColumn: {
        "id": "native-issue-table.issue-table.table-header.table-header-cell.column-actions",
        "defaultMessage": "Reorder {title} column"
    },
    moveLeft: {
        "id": "native-issue-table.issue-table.table-header.table-header-cell.move-left",
        "defaultMessage": "Move left"
    },
    moveRight: {
        "id": "native-issue-table.issue-table.table-header.table-header-cell.move-right",
        "defaultMessage": "Move right"
    },
    warningLabel: {
        "id": "native-issue-table.issue-table.table-header.dnd-focused",
        "defaultMessage": "Warning"
    }
});

});


parcelRegister("jaJFT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b053e4c640daff6d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $a4IeB = parcelRequire("a4IeB");

var $9eMIF = parcelRequire("9eMIF");

var $gCtmO = parcelRequire("gCtmO");

var $exPVl = parcelRequire("exPVl");
const $b053e4c640daff6d$var$ReadOnlyTableHeaderCellContent = ({ column: column })=>{
    const intl = (0, $5JgJ2.default)();
    const { currentSorting: sortOrder = (0, $a4IeB.SORT_NONE), title: title, warningText: warningText } = column;
    const { getIcon: getIcon, isIconPersistent: isIconPersistent } = (0, $9eMIF.getSortOrderConfig)({
        sortOrder: sortOrder,
        intl: intl
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCtmO.ContentContainer), {
        isIconPersistent: isIconPersistent
    }, warningText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $exPVl.default), {
        tooltip: warningText
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCtmO.ColumnName), null, title), isIconPersistent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCtmO.SortIcon), {
        isIconPersistent: isIconPersistent
    }, getIcon()));
};
var $b053e4c640daff6d$export$2e2bcd8739ae039 = $b053e4c640daff6d$var$ReadOnlyTableHeaderCellContent;

});




parcelRegister("iPiat", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b98ca8332e198fb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9aFSa = parcelRequire("9aFSa");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $59JiB = parcelRequire("59JiB");
const $6b98ca8332e198fb$var$KeyboardShortcuts = ({ issueKeys: issueKeys = [], onIssueLinkSelected: onIssueLinkSelected })=>{
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const [selectedRowIndex, { selectNextRow: selectNextRow, selectPrevRow: selectPrevRow }] = (0, $59JiB.useSelectedRow)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const keyMap = (0, $eUqFw.useMemo)(()=>{
        const navigateToIssue = (issueKey)=>{
            push(`/browse/${issueKey}`);
        };
        return {
            arrowup: {
                callback: (e)=>{
                    if ((0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf')) // Prevent native browser scrolling as we provide auto-scroll functionality via react-scroll-into-view-if-needed
                    e?.preventDefault();
                    selectPrevRow();
                }
            },
            arrowdown: {
                callback: (e)=>{
                    if ((0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf')) // Prevent native browser scrolling as we provide auto-scroll functionality via react-scroll-into-view-if-needed
                    e?.preventDefault();
                    selectNextRow();
                }
            },
            k: {
                callback: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'rowItem pressed', 'navigateRowUp', {
                        rowIndex: selectedRowIndex,
                        keyPressed: 'k'
                    });
                    selectPrevRow();
                }
            },
            j: {
                callback: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'rowItem pressed', 'navigateRowDown', {
                        rowIndex: selectedRowIndex,
                        keyPressed: 'j'
                    });
                    selectNextRow();
                }
            },
            o: {
                callback: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'tableIssueLink', {
                        fieldType: 'unknown',
                        keyPressed: 'o',
                        tableRowNumber: selectedRowIndex,
                        keyboardShortcut: true
                    });
                    if (typeof selectedRowIndex === 'number') {
                        const issueKey = issueKeys[selectedRowIndex];
                        if (typeof issueKey === 'string' && issueKey.length > 0) {
                            const handled = onIssueLinkSelected !== undefined && onIssueLinkSelected(issueKey);
                            if (!handled) navigateToIssue(issueKey);
                        }
                    }
                }
            },
            z: {
                callback: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'tableIssueLink', {
                        fieldType: 'unknown',
                        keyPressed: 'z',
                        tableRowNumber: selectedRowIndex,
                        keyboardShortcut: true
                    });
                    if (typeof selectedRowIndex === 'number') {
                        const issueKey = issueKeys[selectedRowIndex];
                        if (typeof issueKey === 'string' && issueKey.length > 0) {
                            const handled = onIssueLinkSelected !== undefined && onIssueLinkSelected(issueKey);
                            if (!handled) navigateToIssue(issueKey);
                        }
                    }
                }
            }
        };
    }, [
        push,
        selectPrevRow,
        selectNextRow,
        createAnalyticsEvent,
        selectedRowIndex,
        issueKeys,
        onIssueLinkSelected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: keyMap
    });
};
var $6b98ca8332e198fb$export$2e2bcd8739ae039 = $6b98ca8332e198fb$var$KeyboardShortcuts;

});

parcelRegister("fGsEG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a8a1c890c13289d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3a8a1c890c13289d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    columnHeaderIssueType: {
        "id": "native-issue-table.column-header-issue-type",
        "defaultMessage": "Type"
    },
    columnHeaderIssueKey: {
        "id": "native-issue-table.column-header-issue-key",
        "defaultMessage": "Key"
    },
    columnHeaderIssueSummary: {
        "id": "native-issue-table.column-header-issue-summary",
        "defaultMessage": "Summary"
    },
    columnHeaderIssueAssignee: {
        "id": "native-issue-table.column-header-issue-assignee",
        "defaultMessage": "Assignee"
    },
    columnHeaderIssueReporter: {
        "id": "native-issue-table.column-header-issue-reporter",
        "defaultMessage": "Reporter"
    },
    columnHeaderIssuePriority: {
        "id": "native-issue-table.column-header-issue-priority",
        "defaultMessage": "P"
    },
    columnHeaderIssueStatus: {
        "id": "native-issue-table.column-header-issue-status",
        "defaultMessage": "Status"
    },
    columnHeaderIssueResolution: {
        "id": "native-issue-table.column-header-issue-resolution",
        "defaultMessage": "Resolution"
    },
    columnHeaderIssueCreatedDate: {
        "id": "native-issue-table.column-header-issue-created-date",
        "defaultMessage": "Created"
    },
    columnHeaderIssueUpdatedDate: {
        "id": "native-issue-table.column-header-issue-updated-date",
        "defaultMessage": "Updated"
    },
    columnHeaderIssueDueDate: {
        "id": "native-issue-table.column-header-issue-due-date",
        "defaultMessage": "Due"
    },
    columnHeaderIssueActions: {
        "id": "native-issue-table.column-header-issue-actions",
        "defaultMessage": "More actions"
    },
    aToZOrder: {
        "id": "native-issue-table.a-to-z-order",
        "defaultMessage": "A \u279E Z"
    },
    zToAOrder: {
        "id": "native-issue-table.z-to-a-order",
        "defaultMessage": "Z \u279E A"
    },
    oldestToNewestOrder: {
        "id": "native-issue-table.oldest-to-newest-order",
        "defaultMessage": "oldest \u279E newest"
    },
    newestToOldestOrder: {
        "id": "native-issue-table.newest-to-oldest-order",
        "defaultMessage": "newest \u279E oldest"
    },
    reorderColumnsErrorTitle: {
        "id": "native-issue-table.reorder-columns-error-title",
        "defaultMessage": "We couldn't reorder your columns"
    },
    reorderColumnsErrorDescription: {
        "id": "native-issue-table.reorder-columns-error-description",
        "defaultMessage": "Refresh and try again."
    },
    deprecatedEpicLinkMessage: {
        "id": "native-issue-table.deprecated-epic-link-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>."
    },
    deprecatedParentLinkMessage: {
        "id": "native-issue-table.deprecated-parent-link-message",
        "defaultMessage": "<strong>Parent Link</strong> is replaced by <strong>Parent</strong>."
    }
});

});

parcelRegister("fpoU0", function(module, exports) {

$parcel$export(module.exports, "getColumnConfig", () => $e676901d3c610e7c$export$38a3f9395eadb298);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");

var $a4IeB = parcelRequire("a4IeB");

var $fGsEG = parcelRequire("fGsEG");
const $e676901d3c610e7c$export$38a3f9395eadb298 = (0, $5iWql.default)((formatMessage)=>({
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).ASSIGNEE]: ()=>({
                defaultWidth: (0, $a4IeB.DEFAULT_COLUMN_WIDTH),
                width: (0, $a4IeB.DEFAULT_COLUMN_WIDTH),
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).aToZOrder),
                descText: formatMessage((0, $fGsEG.default).zToAOrder)
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).CREATED]: ()=>({
                defaultWidth: 126,
                width: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? 126 : 106,
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).oldestToNewestOrder),
                descText: formatMessage((0, $fGsEG.default).newestToOldestOrder)
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).UPDATED]: ()=>({
                defaultWidth: 130,
                width: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? 130 : 106,
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).oldestToNewestOrder),
                descText: formatMessage((0, $fGsEG.default).newestToOldestOrder)
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).DUE_DATE]: ()=>({
                defaultWidth: 140,
                // remove width with nin-resizable-columns_8z4eo
                width: 134,
                ascText: formatMessage((0, $fGsEG.default).oldestToNewestOrder),
                descText: formatMessage((0, $fGsEG.default).newestToOldestOrder)
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).RESOLUTION_DATE]: ()=>({
                defaultWidth: 106,
                width: 106,
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).oldestToNewestOrder),
                descText: formatMessage((0, $fGsEG.default).newestToOldestOrder)
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).PRIORITY]: ()=>({
                defaultWidth: (0, $a4IeB.getPriorityWidth)(),
                width: (0, $a4IeB.getPriorityWidth)(),
                // remove width with nin-resizable-columns_8z4eo
                ...!(0, $1ybV0.ff)('nin-priority-inline-edit') && {
                    // Overrides title from the server's displayName from "Priority" to "P" as per designs
                    title: formatMessage((0, $fGsEG.default).columnHeaderIssuePriority)
                },
                shouldResizeWithTable: false
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).ISSUE_KEY]: ()=>({
                defaultWidth: 96,
                width: 96,
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).aToZOrder),
                descText: formatMessage((0, $fGsEG.default).zToAOrder)
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]: ()=>({
                title: '',
                defaultWidth: 48,
                width: 48,
                // remove width with nin-resizable-columns_8z4eo
                isSortable: false,
                shouldResizeWithTable: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf')
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).STATUS]: ()=>({
                defaultWidth: 140,
                width: 140 // remove width with nin-resizable-columns_8z4eo
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).SUMMARY]: ()=>({
                defaultWidth: (0, $a4IeB.COLUMN_WIDTH_TEXT_SUMMARY),
                width: (0, $a4IeB.COLUMN_WIDTH_TEXT_SUMMARY),
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).aToZOrder),
                descText: formatMessage((0, $fGsEG.default).zToAOrder)
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).ISSUE_TYPE]: ()=>({
                // Overrides title from the server's displayName from "Issue Type" to "Type" as per designs
                title: formatMessage((0, $fGsEG.default).columnHeaderIssueType),
                defaultWidth: 101,
                width: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? 101 : 66,
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).aToZOrder),
                descText: formatMessage((0, $fGsEG.default).zToAOrder),
                shouldResizeWithTable: false
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).RESOLUTION]: ()=>({
                defaultWidth: 106,
                width: 106 // remove width with nin-resizable-columns_8z4eo
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).REPORTER]: ()=>({
                defaultWidth: (0, $a4IeB.DEFAULT_COLUMN_WIDTH),
                width: (0, $a4IeB.DEFAULT_COLUMN_WIDTH),
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).aToZOrder),
                descText: formatMessage((0, $fGsEG.default).zToAOrder)
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).CREATOR]: ()=>({
                defaultWidth: (0, $a4IeB.DEFAULT_COLUMN_WIDTH),
                width: (0, $a4IeB.DEFAULT_COLUMN_WIDTH),
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).aToZOrder),
                descText: formatMessage((0, $fGsEG.default).zToAOrder)
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).SPRINT]: ()=>({
                defaultWidth: (0, $a4IeB.DEFAULT_COLUMN_WIDTH),
                width: (0, $a4IeB.DEFAULT_COLUMN_WIDTH // remove width with nin-resizable-columns_8z4eo
                )
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).PARENT]: ()=>({
                defaultWidth: (0, $a4IeB.COLUMN_WIDTH_TEXT_SUMMARY),
                width: (0, $a4IeB.COLUMN_WIDTH_TEXT_SUMMARY),
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).aToZOrder),
                descText: formatMessage((0, $fGsEG.default).zToAOrder)
            }),
        // Labels renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
        // <Tag/> has a maxWidth of 180px with 4px of padding either side
        // And we need to accound for 5px & 8px for left and right padding on our cell respectively
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).LABELS]: ()=>({
                defaultWidth: 201,
                width: 201,
                // remove width with nin-resizable-columns_8z4eo
                shouldResizeWithTable: false
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).COMPONENTS]: ()=>({
                defaultWidth: (0, $a4IeB.DEFAULT_COLUMN_WIDTH),
                width: (0, $a4IeB.DEFAULT_COLUMN_WIDTH // remove width with nin-resizable-columns_8z4eo
                )
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).FIX_VERSIONS]: ()=>({
                defaultWidth: (0, $a4IeB.DEFAULT_COLUMN_WIDTH),
                width: (0, $a4IeB.DEFAULT_COLUMN_WIDTH // remove width with nin-resizable-columns_8z4eo
                )
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).STATUS_CATEGORY]: ()=>({
                defaultWidth: 140,
                width: 140 // remove width with nin-resizable-columns_8z4eo
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).PROJECT]: ()=>({
                defaultWidth: (0, $a4IeB.DEFAULT_COLUMN_WIDTH),
                width: (0, $a4IeB.DEFAULT_COLUMN_WIDTH),
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).aToZOrder),
                descText: formatMessage((0, $fGsEG.default).zToAOrder)
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).EPIC_LINK]: ()=>({
                // EpicLink renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
                // <Tag/> has a maxWidth of 180px with 4px of padding either side
                // And we need to account for 5px & 8px for left and right padding on our cell respectively
                defaultWidth: 201,
                width: 201,
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).aToZOrder),
                descText: formatMessage((0, $fGsEG.default).zToAOrder),
                ...(0, $1ybV0.ff)('com.atlassian.rm.jpo.deprecate-epic-link-nin') && {
                    warningText: formatMessage((0, $fGsEG.default).deprecatedEpicLinkMessage, {
                        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
                    })
                }
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).DESCRIPTION]: ()=>({
                defaultWidth: (0, $a4IeB.COLUMN_WIDTH_TEXT_LONG),
                width: (0, $a4IeB.COLUMN_WIDTH_TEXT_LONG),
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).aToZOrder),
                descText: formatMessage((0, $fGsEG.default).zToAOrder)
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).ENVIRONMENT]: ()=>({
                defaultWidth: (0, $a4IeB.COLUMN_WIDTH_TEXT_LONG),
                width: (0, $a4IeB.COLUMN_WIDTH_TEXT_LONG),
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).aToZOrder),
                descText: formatMessage((0, $fGsEG.default).zToAOrder)
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).TEXT_AREA]: ()=>({
                defaultWidth: (0, $a4IeB.COLUMN_WIDTH_TEXT_LONG),
                width: (0, $a4IeB.COLUMN_WIDTH_TEXT_LONG),
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).aToZOrder),
                descText: formatMessage((0, $fGsEG.default).zToAOrder)
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).TEXT]: ()=>({
                defaultWidth: (0, $a4IeB.COLUMN_WIDTH_TEXT_SHORT),
                width: (0, $a4IeB.COLUMN_WIDTH_TEXT_SHORT),
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).aToZOrder),
                descText: formatMessage((0, $fGsEG.default).zToAOrder)
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).READ_ONLY]: ()=>({
                defaultWidth: (0, $a4IeB.COLUMN_WIDTH_TEXT_SHORT),
                width: (0, $a4IeB.COLUMN_WIDTH_TEXT_SHORT),
                // remove width with nin-resizable-columns_8z4eo
                ascText: formatMessage((0, $fGsEG.default).aToZOrder),
                descText: formatMessage((0, $fGsEG.default).zToAOrder)
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).AFFECTS_VERSIONS]: ()=>({
                defaultWidth: (0, $a4IeB.DEFAULT_COLUMN_WIDTH),
                width: (0, $a4IeB.DEFAULT_COLUMN_WIDTH // remove width with nin-resizable-columns_8z4eo
                )
            }),
        [(0, $a4IeB.KNOWN_COLUMN_TYPES).REQUEST_TYPE]: ()=>({
                defaultWidth: 251,
                width: 251,
                // remove width with nin-resizable-columns_8z4eo
                isSortable: false
            })
    }));

});


parcelRegister("aRwQR", function(module, exports) {

$parcel$export(module.exports, "useColumnLoader", () => $378b7b2e95b631da$export$6dc2ac601f90aafc);

var $hW73v = parcelRequire("hW73v");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $aIxxL = parcelRequire("aIxxL");

var $amu7D = parcelRequire("amu7D");

var $dWLk9 = parcelRequire("dWLk9");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $378b7b2e95b631da$var$mapColumnPickerOptions = (data)=>{
    const options = data.jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.map(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (edge)=>({
            optionType: 'option',
            cursor: edge.cursor,
            value: edge.node.fieldSetId,
            label: edge.node.displayName
        }));
    return {
        options: options,
        totalCount: data.jira.issueSearchViewByNamespaceAndViewId.fieldSets.totalCount,
        endCursor: data.jira.issueSearchViewByNamespaceAndViewId.fieldSets.pageInfo.endCursor
    };
};
const $378b7b2e95b631da$export$6dc2ac601f90aafc = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const environment = (0, $amu7D.default);
    return (0, $eUqFw.useMemo)(()=>(0, $aIxxL.createDebouncedColumnLoader)(async (search, renderInitialValues, endCursor)=>{
            const cursor = endCursor;
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const data = await (0, $iWLL0.fetchQuery)(environment, (0, $hW73v.default), {
                    cloudId: cloudId,
                    namespace: 'ISSUE_NAVIGATOR',
                    first: 25,
                    after: cursor,
                    filter: {
                        searchString: search,
                        fieldSetSelectedState: 'ALL'
                    }
                }).toPromise();
                return $378b7b2e95b631da$var$mapColumnPickerOptions(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                return {
                    options: [
                        {
                            optionType: 'error',
                            error: error,
                            onRetry: ()=>undefined
                        }
                    ],
                    totalCount: 0
                };
            }
        }), [
        environment,
        cloudId
    ]);
};

});
parcelRegister("hW73v", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9d9a074f418b189$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<46776904579882bbd813738aa49b0642>>
 * @relayHash b9cf4b171e22923a16ac0f89aedfe3f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c155c1b708ada466d10a0aef2cc9865e9b049be1525660c7e87a9a115452517c
const $a9d9a074f418b189$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "namespace",
            "variableName": "namespace"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "args": [
            {
                "kind": "Variable",
                "name": "after",
                "variableName": "after"
            },
            {
                "kind": "Variable",
                "name": "filter",
                "variableName": "filter"
            },
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
            }
        ],
        "concreteType": "JiraIssueSearchFieldSetConnection",
        "kind": "LinkedField",
        "name": "fieldSets",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "totalCount"
            },
            {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "endCursor"
                    }
                ]
            },
            {
                "concreteType": "JiraIssueSearchFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "cursor"
                    },
                    {
                        "concreteType": "JiraIssueSearchFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "fieldSetId"
                            },
                            v6 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "type"
                            },
                            {
                                "concreteType": "JiraFieldType",
                                "kind": "LinkedField",
                                "name": "fieldType",
                                "plural": false,
                                "selections": [
                                    v6 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "columnConfigurabilityfetchColumnPickerConfigureableChildIssuesPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssueSearchView",
                            "kind": "LinkedField",
                            "name": "issueSearchViewByNamespaceAndViewId",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "columnConfigurabilityfetchColumnPickerConfigureableChildIssuesPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssueSearchView",
                            "kind": "LinkedField",
                            "name": "issueSearchViewByNamespaceAndViewId",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c155c1b708ada466d10a0aef2cc9865e9b049be1525660c7e87a9a115452517c",
            "metadata": {},
            "name": "columnConfigurabilityfetchColumnPickerConfigureableChildIssuesPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a9d9a074f418b189$var$node.hash = "3d1328a1ab83ad6fbd72932a00cf8a36";
var $a9d9a074f418b189$export$2e2bcd8739ae039 = $a9d9a074f418b189$var$node;

});

parcelRegister("aIxxL", function(module, exports) {

$parcel$export(module.exports, "MAX_COLUMNS", () => $b078fb111bae5b9f$export$7ec4af037f372df4);
$parcel$export(module.exports, "createDebouncedColumnLoader", () => $b078fb111bae5b9f$export$a6cff24b97727de1);

var $5oamh = parcelRequire("5oamh");

var $PACdv = parcelRequire("PACdv");
const $b078fb111bae5b9f$export$b8b9d90f9e5bd72b = 'jiraIssueTableColumnHeader';
const $b078fb111bae5b9f$export$d57b6b390e78d90f = 'empanada';
const $b078fb111bae5b9f$export$7ec4af037f372df4 = 500;
const $b078fb111bae5b9f$export$a6cff24b97727de1 = (0, $5oamh.createGenericDebouncableDataLoader);

});
parcelRegister("5oamh", function(module, exports) {

$parcel$export(module.exports, "createGenericDebouncableDataLoader", () => $44c3b46c69e4d46d$export$ea63a11564958c9e);

var $dxIU5 = parcelRequire("dxIU5");
const $44c3b46c69e4d46d$export$ea63a11564958c9e = (dataLoader)=>{
    const debouncedDataLoader = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((search, enableFullList, endCursor, cb)=>dataLoader(search, enableFullList, endCursor).then((data)=>{
            cb(data);
            return data;
        }), 500);
    return (search, enableFullList, endCursor, cb)=>{
        // No need to debounce When no search string is provided.
        // We want the initial list displaying as quickly as possible when a user reopens the dropdown.
        // It will be cached by the GraphQL client and debouncing will show an unneccessary spinner.
        if (!search) {
            debouncedDataLoader.cancel();
            return dataLoader(search, enableFullList, endCursor).then((data)=>{
                cb(data);
                return data;
            });
        }
        return debouncedDataLoader(search, enableFullList, endCursor, cb);
    };
};
var $44c3b46c69e4d46d$export$2e2bcd8739ae039 = $44c3b46c69e4d46d$export$ea63a11564958c9e;

});

parcelRegister("PACdv", function(module, exports) {

$parcel$export(module.exports, "components", () => $7fc1301f004ca79d$export$9b5ac10f59f76296);

var $eNBUj = parcelRequire("eNBUj");
const $7fc1301f004ca79d$export$9b5ac10f59f76296 = {
    NoOptionsMessage: $eNBUj.default
};

});
parcelRegister("eNBUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $666689ae855bc618$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $96IgR = parcelRequire("96IgR");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");

var $4EqNx = parcelRequire("4EqNx");
/**
 * Custom message to show when no options are visible in the column picker. This allows additional help text/content to
 * be rendered using the children prop.
 */ const $666689ae855bc618$var$NoOptionsMessage = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($666689ae855bc618$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($666689ae855bc618$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($666689ae855bc618$var$StyledTitle, null, formatMessage((0, $4EqNx.default).title)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        actionSubject: "emptyState",
        action: "viewed",
        actionSubjectId: "columnPicker"
    }));
};
var $666689ae855bc618$export$2e2bcd8739ae039 = $666689ae855bc618$var$NoOptionsMessage;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $666689ae855bc618$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _1e0c1txw _2lx21bp4 _4cvr1h6o _18s81gzt",
            __cmplp.className
        ])
    });
});
const $666689ae855bc618$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyru2gc _w8l5t9kd _1752t9kd",
            __cmplp.className
        ])
    });
});
const $666689ae855bc618$var$StyledTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4EqNx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3788bf9c7aa987cf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3788bf9c7aa987cf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue-table-column-picker.column-picker.no-options-message.title",
        "defaultMessage": "We couldn\u2019t find the field you\u2019re looking for."
    }
});

});





parcelRegister("4VIzz", function(module, exports) {

$parcel$export(module.exports, "useLoadingState", () => $5d2df1bfd0b5bbf5$export$30e29c90a67638af);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $amu7D = parcelRequire("amu7D");
function $5d2df1bfd0b5bbf5$export$30e29c90a67638af(attributes, refetch, query) {
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const refetchWithoutSuspending = (0, $eUqFw.useCallback)((variables)=>{
        setIsLoading(true);
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        let disposable = {
            dispose: ()=>{}
        };
        const combinedVariables = {
            ...attributes,
            ...variables
        };
        (0, $iWLL0.fetchQuery)((0, $amu7D.default), query, combinedVariables).subscribe({
            complete: ()=>{
                setIsLoading(false);
                disposable = refetch(combinedVariables, {
                    fetchPolicy: 'store-only'
                });
            }
        });
        return disposable;
    }, [
        refetch,
        attributes,
        query
    ]);
    return {
        isLoading: isLoading,
        refetchWithoutSuspending: refetchWithoutSuspending
    };
}

});


parcelRegister("3KfwU", function(module, exports) {

$parcel$export(module.exports, "HideDoneIconWithToolTip", () => $d2c3ca38d03a3627$export$3b6bd60b0a496586);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $aUqTb = parcelRequire("aUqTb");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gbn6E = parcelRequire("gbn6E");
const $d2c3ca38d03a3627$export$3b6bd60b0a496586 = ({ completedChildIssuesCount: completedChildIssuesCount })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const TooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $gbn6E.default).hideDoneTooltipHiddenIssues, {
        completedChildIssuesCount: completedChildIssuesCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), formatMessage((0, $gbn6E.default).hideDoneTooltipHowToShow));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: TooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d2c3ca38d03a3627$var$HideDoneInfoIconButton, {
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
        primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N700})`,
        label: formatMessage((0, $gbn6E.default).hideDoneIconLabel, {
            completedChildIssuesCount: completedChildIssuesCount
        }),
        size: "large"
    })));
};
// Currently using line version of the Editor Info Icon
// as global info icon only has filled and no line version.
// https://product-fabric.atlassian.net/browse/DSP-11293
// Width changes is necessary here since editor icon is smaller
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d2c3ca38d03a3627$var$HideDoneInfoIconButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsb1ul9 _19lcglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gbn6E", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f9b8281ae8ffe2b$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $0f9b8281ae8ffe2b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    hideDoneTooltipHiddenIssues: {
        "id": "issue.views.common.child-issues-panel.hide-done-icon.tooltip.hidden-issues-info",
        "defaultMessage": "{completedChildIssuesCount, plural, one {# Done issue is hidden} other {# Done issues are hidden}}. "
    },
    hideDoneTooltipHowToShow: {
        "id": "issue.views.common.child-issues-panel.hide-done-icon.tooltip.how-to-show-info",
        "defaultMessage": "To show, go to (\u2022\u2022\u2022)"
    },
    hideDoneIconLabel: {
        "id": "issue.views.common.child-issues-panel.hide-done-icon.label",
        "defaultMessage": "Hide done information - {completedChildIssuesCount, plural, one {# Done issue is hidden} other {# Done issues are hidden}}. To show, go to (\u2022\u2022\u2022)"
    }
});

});





parcelRegister("9GGoL", function(module, exports) {

$parcel$export(module.exports, "totalChildIssueCountSelector", () => $39508fcd5b331eea$export$4e3aa6eaa4b24f1c);

var $df4Sl = parcelRequire("df4Sl");

var $4Xcha = parcelRequire("4Xcha");

var $f9RL0 = parcelRequire("f9RL0");

var $fokFV = parcelRequire("fokFV");

var $75LXB = parcelRequire("75LXB");

var $dv9do = parcelRequire("dv9do");
const $39508fcd5b331eea$export$4e3aa6eaa4b24f1c = (0, $df4Sl.createSelector)((0, $dv9do.subtaskEntitiesSelector), (0, $75LXB.persistedChildrenIssuesSelector), (subtasks, childrenIssues)=>subtasks.length + childrenIssues.length);
const $39508fcd5b331eea$export$abefa88df936477c = (0, $df4Sl.createSelector)((0, $dv9do.subtaskEntitiesSelector), (0, $75LXB.persistedChildrenIssuesSelector), (0, $fokFV.childIssuesLimitUrlSelector), (subtasks, childrenIssues, getChildIssuesLimitUrl)=>{
    const getHasExceededChildIssuesLimitAfterLoad = (fieldId)=>{
        const hasExceededChildIssuesLimitOnLoad = Boolean(getChildIssuesLimitUrl(fieldId));
        return !hasExceededChildIssuesLimitOnLoad && subtasks.length + childrenIssues.length > (0, $4Xcha.getChildIssuesLimit)();
    };
    return getHasExceededChildIssuesLimitAfterLoad;
});
const $39508fcd5b331eea$export$5bba33cb9f3cecbb = (0, $df4Sl.createSelector)((0, $fokFV.fieldsSelector), (fields)=>Boolean(fields?.[0, $f9RL0.SUBTASKS]?.issueLimitUrl) || Boolean(fields?.[0, $f9RL0.CHILDREN_ISSUES]?.issueLimitUrl) || Boolean(fields?.[0, $f9RL0.EPIC_ISSUES]?.issueLimitUrl) || Boolean(fields?.[0, $f9RL0.PORTFOLIO_CHILD_ISSUES]?.issueLimitUrl));
const $39508fcd5b331eea$export$9084216b80a87270 = (0, $df4Sl.createSelector)($39508fcd5b331eea$export$abefa88df936477c, (getHasExceededChildIssuesLimitAfterLoad)=>getHasExceededChildIssuesLimitAfterLoad((0, $f9RL0.SUBTASKS)) || getHasExceededChildIssuesLimitAfterLoad((0, $f9RL0.CHILDREN_ISSUES)) || getHasExceededChildIssuesLimitAfterLoad((0, $f9RL0.PORTFOLIO_CHILD_ISSUES)) || getHasExceededChildIssuesLimitAfterLoad((0, $f9RL0.EPIC_ISSUES)));

});

parcelRegister("iY7NN", function(module, exports) {

$parcel$export(module.exports, "subtaskQuickAddClickCountSelector", () => $14d3d6ef23147193$export$bb14d3e4fe7781da);
$parcel$export(module.exports, "issueInEpicQuickAddClickCountSelector", () => $14d3d6ef23147193$export$1f0be279d28d3952);
$parcel$export(module.exports, "childIssueQuickAddClickCountSelector", () => $14d3d6ef23147193$export$2787392f3c2d840);
$parcel$export(module.exports, "shouldRenderChildPanelSelector", () => $14d3d6ef23147193$export$3329cdb7642bc847);
$parcel$export(module.exports, "shouldRenderSubtaskPanelSelector", () => $14d3d6ef23147193$export$3c8305c392f2d322);
$parcel$export(module.exports, "shouldRenderPortfolioChildPanelSelector", () => $14d3d6ef23147193$export$48fb9123d98c558a);

var $df4Sl = parcelRequire("df4Sl");

var $f9RL0 = parcelRequire("f9RL0");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");
const $14d3d6ef23147193$var$childPanelSelector = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.childPanel);
const $14d3d6ef23147193$export$bb14d3e4fe7781da = (0, $df4Sl.createSelector)($14d3d6ef23147193$var$childPanelSelector, (childPanel)=>childPanel.subtaskQuickAddClickCount);
const $14d3d6ef23147193$export$1f0be279d28d3952 = (0, $df4Sl.createSelector)($14d3d6ef23147193$var$childPanelSelector, (childPanel)=>childPanel.issueInEpicQuickAddClickCount);
const $14d3d6ef23147193$export$2787392f3c2d840 = (0, $df4Sl.createSelector)($14d3d6ef23147193$var$childPanelSelector, (childPanel)=>childPanel.childIssueQuickAddClickCount);
/**
 * We should render the particular create issues UI if there are already some sort of sub-issues (i.e. the field is non-empty) or the field is empty but the user has clicked create issue
 * If childIssueLimitUrl for the respective panel is present, we will also render the panel even though the values in the field will be empty, since we want to show the new child issue limit panel
 */ const $14d3d6ef23147193$var$renderChildIssuesPanelFunc = (doesFieldExistOnIssue, doesFieldHaveValues, createIssueClickCount, childIssueLimitUrl)=>Boolean(childIssueLimitUrl((0, $f9RL0.CHILDREN_ISSUES))) || doesFieldHaveValues || doesFieldExistOnIssue && createIssueClickCount > 0;
/**
 * We should render the particular create issues UI if there are already some sort of sub-issues (i.e. the field is non-empty) or the field is empty but the user has clicked create issue
 * If childIssueLimitUrl for the respective panel is present, we will also render the panel even though the values in the field will be empty, since we want to show the new child issue limit panel
 */ const $14d3d6ef23147193$var$renderSubtasksPanelFunc = (doesFieldExistOnIssue, doesFieldHaveValues, createIssueClickCount, childIssueLimitUrl)=>Boolean(childIssueLimitUrl((0, $f9RL0.SUBTASKS))) || doesFieldHaveValues || doesFieldExistOnIssue && createIssueClickCount > 0;
const $14d3d6ef23147193$export$3329cdb7642bc847 = (0, $df4Sl.createSelector)((0, $fokFV.hasChildrenIssuesSelector), (0, $fokFV.hasChildrenIssueValuesSelector), $14d3d6ef23147193$export$2787392f3c2d840, (0, $fokFV.childIssuesLimitUrlSelector), $14d3d6ef23147193$var$renderChildIssuesPanelFunc);
const $14d3d6ef23147193$export$3c8305c392f2d322 = (0, $df4Sl.createSelector)((0, $fokFV.hasSubtasksSelector), (0, $fokFV.hasSubtasksValuesSelector), $14d3d6ef23147193$export$bb14d3e4fe7781da, (0, $fokFV.childIssuesLimitUrlSelector), $14d3d6ef23147193$var$renderSubtasksPanelFunc);
const $14d3d6ef23147193$export$48fb9123d98c558a = (0, $df4Sl.createSelector)((0, $fokFV.hasPortfolioChildIssuesSelector), (0, $fokFV.hasPortfolioChildIssueValuesSelector), $14d3d6ef23147193$export$2787392f3c2d840, (0, $fokFV.childIssuesLimitUrlSelector), $14d3d6ef23147193$var$renderSubtasksPanelFunc);

});

parcelRegister("k2UaD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9845b1b4e4602f6$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $c9845b1b4e4602f6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue.children-issues.title",
        "defaultMessage": "Child issues"
    }
});

});


parcelRegister("5b3l6", function(module, exports) {

$parcel$export(module.exports, "default", () => $83fbe7090dcbb494$export$2e2bcd8739ae039);

var $2jDha = parcelRequire("2jDha");

var $eGI9v = parcelRequire("eGI9v");

var $9zysr = parcelRequire("9zysr");

var $5G3JL = parcelRequire("5G3JL");

var $8Bhia = parcelRequire("8Bhia");

var $lqalZ = parcelRequire("lqalZ");

var $a0kZP = parcelRequire("a0kZP");

var $6ySNE = parcelRequire("6ySNE");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $9D3Vo = parcelRequire("9D3Vo");

var $dOXkm = parcelRequire("dOXkm");

var $iyeap = parcelRequire("iyeap");

var $igGhc = parcelRequire("igGhc");

var $9Nizy = parcelRequire("9Nizy");

var $ftJ4S = parcelRequire("ftJ4S");

var $l3ios = parcelRequire("l3ios");
const $83fbe7090dcbb494$export$138741318ed9a8fd = (0, $9zysr.componentWithCondition)(()=>(0, $8Bhia.isConfluenceContentFunctionalComponentEnabled)(), (0, $ftJ4S.default), (0, $l3ios.ConfluenceContentView));
var $83fbe7090dcbb494$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $2jDha.default)(), (0, $eGI9v.default)('ItemLineCardGroup', {
    onMentionedPageClicked: 'clicked',
    onLinkedPageClicked: 'clicked',
    onLinkedWhiteboardClicked: 'clicked'
}), (0, $eGI9v.default)('DeleteConfluencePage', {
    onDeleteConfluencePageLink: 'clicked'
}), // @ts-expect-error - HoC types don't quite align with the latest React typings here.
(0, $lqalZ.connect)((state)=>({
        isCreateLinkedPageOpened: (0, $iyeap.isCreateLinkedPageOpenedSelector)(state),
        linkedPages: (0, $iyeap.linkedConfluencePagesPagesSelector)(state),
        linkedPagesCachedCount: (0, $iyeap.linkedConfluencePagesCountSelector)(state),
        linkedWhiteboards: (0, $iyeap.linkedConfluenceWhiteboardsWhiteboardsSelector)(state),
        linkedWhiteboardsCachedCount: (0, $iyeap.linkedConfluenceWhiteboardsCountSelector)(state),
        licensedProducts: (0, $5JqpU.licensedProductsSelector)(state),
        mentionedPages: (0, $iyeap.mentionedConfluencePagesPagesSelector)(state),
        mentionedPagesCachedCount: (0, $iyeap.mentionedConfluencePagesCountSelector)(state),
        isConfluencePageLinksEnabled: (0, $iyeap.isConfluencePageLinksEnabledSelector)(state),
        canLinkConfluencePage: (0, $dOXkm.canLinkConfluencePageSelector)(state),
        systemConfluenceAppLinkUrl: (0, $dOXkm.systemConfluenceAppLinkSelector)(state)?.baseUrl,
        ...(0, $9Nizy.isConfluencePageDummyLinkExperiment)() ? {
            projectType: (0, $jZDJX.projectTypeSelector)(state),
            issueType: (0, $9D3Vo.issueTypeSelector)(state),
            tenantHasConfluenceAppLinks: (0, $dOXkm.hasConfluenceAppLinks)(state),
            projectName: (0, $igGhc.projectNameSelector)(state)
        } : {}
    }), {
    onAuthenticateApplink: (0, $a0kZP.applinkAuthenticationRequest),
    onDeleteConfluencePageLink: (0, $6ySNE.deleteConfluencePageLinkRequest),
    onAddButtonClicked: (0, $6ySNE.linkConfluencePageClicked)
}))($83fbe7090dcbb494$export$138741318ed9a8fd);

});
parcelRegister("ftJ4S", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4fd90fe11b045ee$export$2e2bcd8739ae039);
/* confluence-content.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $27nAz = parcelRequire("27nAz");

var $7ZZxN = parcelRequire("7ZZxN");

var $e91YZ = parcelRequire("e91YZ");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $8uD7Y = parcelRequire("8uD7Y");

var $9oEBG = parcelRequire("9oEBG");

var $kGJTW = parcelRequire("kGJTW");
var $bx1oo = parcelRequire("bx1oo");

var $coSdD = parcelRequire("coSdD");

var $7qm3W = parcelRequire("7qm3W");

var $iAc02 = parcelRequire("iAc02");

var $8Bhia = parcelRequire("8Bhia");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");

var $9Nizy = parcelRequire("9Nizy");

var $ksiXg = parcelRequire("ksiXg");

var $7NqS9 = parcelRequire("7NqS9");

var $1dOAy = parcelRequire("1dOAy");

var $bB2FQ = parcelRequire("bB2FQ");

var $3ZcUw = parcelRequire("3ZcUw");

var $eUd7S = parcelRequire("eUd7S");
const $b4fd90fe11b045ee$var$LINKED_PAGES_GROUP_ID = 'linked-confluence-pages';
const $b4fd90fe11b045ee$var$LINKED_WHITEBOARDS_GROUP_ID = 'linked-confluence-whiteboards';
const $b4fd90fe11b045ee$var$MENTIONED_PAGES_GROUP_ID = 'mentioned-confluence-pages';
const $b4fd90fe11b045ee$var$ConfluenceContent = ({ isCreateLinkedPageOpened: isCreateLinkedPageOpened, isConfluencePageLinksEnabled: isConfluencePageLinksEnabled = false, canLinkConfluencePage: canLinkConfluencePage, linkedPages: linkedPages, linkedPagesCachedCount: linkedPagesCachedCount = 0, linkedWhiteboards: linkedWhiteboards, linkedWhiteboardsCachedCount: linkedWhiteboardsCachedCount = 0, systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl, licensedProducts: licensedProducts, mentionedPages: mentionedPages, mentionedPagesCachedCount: mentionedPagesCachedCount = 0, onLinkedPageClicked: onLinkedPageClicked, onLinkedWhiteboardClicked: onLinkedWhiteboardClicked, onMentionedPageClicked: onMentionedPageClicked, onAuthenticateApplink: onAuthenticateApplink, onDeleteConfluencePageLink: onDeleteConfluencePageLink, onAddButtonClicked: onAddButtonClicked, projectType: projectType, issueType: issueType, tenantHasConfluenceAppLinks: tenantHasConfluenceAppLinks, projectName: projectName })=>{
    const isIssueTypeEligibleForPlaceholderTemplate = (0, $eUqFw.useMemo)(()=>issueType ? (0, $ksiXg.ELIGIBLE_ISSUE_TYPES).includes(issueType.name.toLowerCase()) : false, [
        issueType
    ]);
    const hasLinkedPages = (0, $eUqFw.useMemo)(()=>linkedPages && linkedPages.length > 0, [
        linkedPages
    ]);
    const hasMentionedPages = (0, $eUqFw.useMemo)(()=>mentionedPages && mentionedPages.length > 0, [
        mentionedPages
    ]);
    const hasLinkedWhiteboards = (0, $eUqFw.useMemo)(()=>linkedWhiteboards && linkedWhiteboards.length > 0, [
        linkedWhiteboards
    ]);
    const shouldShowConfluenceContent = (0, $eUqFw.useMemo)(()=>isCreateLinkedPageOpened || hasLinkedPages || hasMentionedPages || (0, $8Bhia.isWhiteboardStandaloneEnabled)() && hasLinkedWhiteboards, [
        hasLinkedPages,
        hasLinkedWhiteboards,
        hasMentionedPages,
        isCreateLinkedPageOpened
    ]);
    const totalContentCount = (0, $eUqFw.useMemo)(()=>{
        /*
          In order to display a preview for linked & mentioned confluence
          content, we need to exclude the count of app linked content if
          any. When the user dosn't have access to confluence in the current
          site, but has access to an applinked site, then we still want to show
          the applinked content to the user. The links to be displayed are
          contained with the 'pages' or the 'whiteboards' array selector. The
          length of these arrays should be subtracted from the cached count,
          because cached count would have the total number of all links,
          including the applinked ones.
           For a scenario where these arrays are empty, we display the cached
          count as is. (Unless there are any config errors with the applinks, the
          array must have links to the app-linked content).
          */ const linkedPagesCount = linkedPages?.length ?? 0;
        const mentionedPagesCount = mentionedPages?.length ?? 0;
        const linkedWhiteboardsCount = linkedWhiteboards?.length ?? 0;
        const totalCount = linkedPagesCachedCount - linkedPagesCount + (mentionedPagesCachedCount - mentionedPagesCount) + (linkedWhiteboardsCachedCount - linkedWhiteboardsCount);
        return totalCount < 0 ? 0 : totalCount;
    }, [
        linkedPages?.length,
        linkedPagesCachedCount,
        linkedWhiteboards?.length,
        linkedWhiteboardsCachedCount,
        mentionedPages?.length,
        mentionedPagesCachedCount
    ]);
    const [embedConfluenceConfig] = (0, $79xbN.UNSAFE_noExposureExp)('platform_embed-conf_jira-issue_cross-join_exp');
    const embedConfluenceCohort = embedConfluenceConfig.get('cohort', 'not-enrolled');
    const confluenceContentPreviewDetails = (0, $eUqFw.useMemo)(()=>{
        const { permitted: permitted } = (0, $9oEBG.getLocalStorageData)('userConfluenceAccess');
        const tenantHasConfluence = !!licensedProducts?.[(0, $e91YZ.LICENSED_PRODUCTS).CONFLUENCE];
        const canCrossJoin = tenantHasConfluence && !permitted && totalContentCount > 0;
        const eligibleForLinkedPageCrossJoinExperiment = (0, $8Bhia.isCrossJoinContentPreviewEnabled)() && canCrossJoin;
        const showContentPreview = eligibleForLinkedPageCrossJoinExperiment && (0, $1ybV0.ff)('platform_embed-conf_jira-issue_create_cross-join') && embedConfluenceCohort === 'experiment';
        return {
            showContentPreview: showContentPreview,
            eligibleForLinkedPageCrossJoinExperiment: eligibleForLinkedPageCrossJoinExperiment
        };
    }, [
        embedConfluenceCohort,
        licensedProducts,
        totalContentCount
    ]);
    const hasAnyLinkedPageLoaded = (0, $eUqFw.useMemo)(()=>linkedPages && linkedPages.length > 0, [
        linkedPages
    ]);
    const hasAnyMentionedPageLoaded = (0, $eUqFw.useMemo)(()=>mentionedPages && mentionedPages.length > 0, [
        mentionedPages
    ]);
    const { showContentPreview: showContentPreview, eligibleForLinkedPageCrossJoinExperiment: eligibleForLinkedPageCrossJoinExperiment } = confluenceContentPreviewDetails;
    if (isConfluencePageLinksEnabled && (shouldShowConfluenceContent || eligibleForLinkedPageCrossJoinExperiment)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (shouldShowConfluenceContent || showContentPreview) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b4fd90fe11b045ee$var$StyledSectionHeading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingTitle), null, (0, $8Bhia.isWhiteboardStandaloneEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        id: "issue.details.confluence-content.heading.non-final",
        defaultMessage: "Confluence content"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        id: "issue.details.confluence-pages.heading",
        defaultMessage: "Confluence pages"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingIcons), null, canLinkConfluencePage && hasLinkedPages && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1dOAy.default), {
        onClick: onAddButtonClicked
    }))), !(0, $8Bhia.isWhiteboardStandaloneEnabled)() && hasLinkedPages && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b4fd90fe11b045ee$var$GroupContainer, null, linkedPages ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qm3W.Container), null, hasAnyLinkedPageLoaded && linkedPages && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGJTW.ConfluencePageLineCardGroup), {
        groupId: $b4fd90fe11b045ee$var$LINKED_PAGES_GROUP_ID,
        pages: linkedPages,
        onClick: onLinkedPageClicked,
        onAuthenticateApplink: onAuthenticateApplink,
        onDeleteConfluencePageLink: onDeleteConfluencePageLink,
        systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $coSdD.default), {
        itemCount: linkedPagesCachedCount
    })), (0, $8Bhia.isWhiteboardStandaloneEnabled)() && (hasLinkedPages || hasLinkedWhiteboards) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b4fd90fe11b045ee$var$GroupContainer, null, (linkedPages || linkedWhiteboards) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qm3W.Container), null, hasAnyLinkedPageLoaded && linkedPages && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGJTW.ConfluencePageLineCardGroup), {
        groupId: $b4fd90fe11b045ee$var$LINKED_PAGES_GROUP_ID,
        pages: linkedPages,
        onClick: onLinkedPageClicked,
        onAuthenticateApplink: onAuthenticateApplink,
        onDeleteConfluencePageLink: onDeleteConfluencePageLink,
        systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl
    }), hasLinkedWhiteboards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bx1oo.ConfluenceWhiteboardLineCardGroup), {
        groupId: $b4fd90fe11b045ee$var$LINKED_WHITEBOARDS_GROUP_ID,
        whiteboards: linkedWhiteboards ?? [],
        onClick: onLinkedWhiteboardClicked,
        systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl
    })), !linkedPages && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $coSdD.default), {
        itemCount: linkedPagesCachedCount
    }), !linkedWhiteboards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $coSdD.default), {
        itemCount: linkedWhiteboardsCachedCount
    })), hasMentionedPages && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b4fd90fe11b045ee$var$GroupContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h3",
        level: "h200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        id: "issue.details.confluence-pages.mentioned-on",
        defaultMessage: "mentioned on"
    })), !mentionedPages && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $coSdD.default), {
        itemCount: mentionedPagesCachedCount
    }), mentionedPages && (0, $8Bhia.isFitAndFinishFullPageMilestone2)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b4fd90fe11b045ee$var$containerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qm3W.Container), null, hasAnyMentionedPageLoaded && mentionedPages && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGJTW.ConfluencePageLineCardGroup), {
        groupId: $b4fd90fe11b045ee$var$MENTIONED_PAGES_GROUP_ID,
        pages: mentionedPages,
        onClick: onMentionedPageClicked,
        onAuthenticateApplink: onAuthenticateApplink,
        onDeleteConfluencePageLink: onDeleteConfluencePageLink,
        systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl
    }))), mentionedPages && !(0, $8Bhia.isFitAndFinishFullPageMilestone2)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qm3W.Container), null, hasAnyMentionedPageLoaded && mentionedPages && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGJTW.ConfluencePageLineCardGroup), {
        groupId: $b4fd90fe11b045ee$var$MENTIONED_PAGES_GROUP_ID,
        pages: mentionedPages,
        onClick: onMentionedPageClicked,
        onAuthenticateApplink: onAuthenticateApplink,
        onDeleteConfluencePageLink: onDeleteConfluencePageLink,
        systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl
    }))), eligibleForLinkedPageCrossJoinExperiment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUd7S.LinkedMentionedContentPreview), {
        contentCount: totalContentCount
    }), isCreateLinkedPageOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bB2FQ.default), null));
    if ((0, $9Nizy.isConfluencePageDummyLinkExperiment)() && projectType === (0, $7ZZxN.SOFTWARE_PROJECT) && isIssueTypeEligibleForPlaceholderTemplate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "confluencePlaceholderTemplate",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            experiment: 'placeholderTemplateContextual'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "confluence-dummy-link-experiment",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7NqS9.ConfluenceDummyLinkProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27nAz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ZcUw.default), {
        issueType: issueType,
        tenantHasConfluenceAppLinks: tenantHasConfluenceAppLinks,
        projectName: projectName
    })))));
    return null;
};
$b4fd90fe11b045ee$var$ConfluenceContent.defaultProps = {
    isConfluencePageLinksEnabled: false,
    linkedPagesCachedCount: 0,
    linkedWhiteboardsCachedCount: 0,
    mentionedPagesCachedCount: 0
};
var $b4fd90fe11b045ee$export$2e2bcd8739ae039 = $b4fd90fe11b045ee$var$ConfluenceContent;
const $b4fd90fe11b045ee$var$StyledSectionHeading = (0, $bAQOb.componentWithFF)('issue-view-fit-and-finish-full-page-milestone2_ebk0i', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $iAc02.SectionHeading), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3tdu2gc",
            __cmplp.className
        ])
    });
}), (0, $iAc02.SectionHeading));
const $b4fd90fe11b045ee$var$containerWrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: "var(--ds-space-100, 8px)"
}); // 1px padding to the right to be aligned with the add comment box because of the shadow around it
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $b4fd90fe11b045ee$var$GroupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81bpf _u5f3v77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kGJTW", function(module, exports) {

$parcel$export(module.exports, "ConfluencePageLineCardGroup", () => $cc1e2d0db98d4308$export$f3499410ad10b2c3);

var $eUqFw = parcelRequire("eUqFw");

var $aml13 = parcelRequire("aml13");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eq2dV = parcelRequire("eq2dV");


var $9XfZZ = parcelRequire("9XfZZ");

var $bNe1g = parcelRequire("bNe1g");

var $h49rE = parcelRequire("h49rE");

var $ivuMa = parcelRequire("ivuMa");

var $gCzJf = parcelRequire("gCzJf");

var $cYOrS = parcelRequire("cYOrS");

var $c0iAM = parcelRequire("c0iAM");

var $1Rvlg = parcelRequire("1Rvlg");
const $cc1e2d0db98d4308$var$isPageError = (page)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    page.error !== undefined;
const $cc1e2d0db98d4308$export$f3499410ad10b2c3 = ({ pages: pages, onClick: onClick, onAuthenticateApplink: onAuthenticateApplink, onDeleteConfluencePageLink: onDeleteConfluencePageLink, systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const trackEmbeddedConfluence = (0, $eq2dV.useEmbeddedPageTracking)();
    const projectContext = (0, $bNe1g.useProjectContext)();
    const { onDeleteClick: onDeleteClick, onConfirmDelete: onConfirmDelete, onCancelDelete: onCancelDelete, modalOpen: modalOpen } = (0, $gCzJf.useConfirmationModalState)(onDeleteConfluencePageLink);
    const currentHostname = window?.location?.hostname || '';
    const isLinkedPagesBugFixEnabled = (0, $1ybV0.ff)('linked-pages-embedded-bug-fix');
    const isAppLinkAuthError = (0, $eUqFw.useCallback)((page)=>$cc1e2d0db98d4308$var$isPageError(page) && page.error === (0, $b7817a5fa36c8dd6$export$d1fe0e8f550fe68d) && page.repairLink?.href !== undefined && onAuthenticateApplink !== undefined, [
        onAuthenticateApplink
    ]);
    const smartCardProviderProduct = (0, $9XfZZ.useSmartCardProductType)();
    const isAIFeatureEnabled = (0, $9XfZZ.useSmartCardIsAIEnabled)();
    /**
   * Returns either the url contained in the link or the authentication url for a failed applink
   * @param page is the confluence page to be connected
   */ const getHrefForSmartCard = (0, $eUqFw.useCallback)((page)=>{
        if (isAppLinkAuthError(page)) return page.repairLink ? page.repairLink.href : page.link.href;
        return $cc1e2d0db98d4308$var$isPageError(page) ? page.link.href : page.href;
    }, [
        isAppLinkAuthError
    ]);
    const getPageWithHostname = (0, $eUqFw.useCallback)((page)=>{
        if ($cc1e2d0db98d4308$var$isPageError(page)) return page;
        return (0, $cYOrS.getContentWithHostname)({
            content: page,
            systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl,
            currentHostname: currentHostname
        });
    }, [
        currentHostname,
        systemConfluenceAppLinkUrl
    ]);
    const loadConfluenceInNewTab = (0, $eUqFw.useCallback)((page)=>{
        if ($cc1e2d0db98d4308$var$isPageError(page)) return false;
        return (0, $cYOrS.shouldLoadConfluenceInNewTab)({
            content: page,
            systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl,
            currentHostname: currentHostname
        });
    }, [
        currentHostname,
        systemConfluenceAppLinkUrl
    ]);
    /**
   * Returns an authenticate function for failed applinks or a passed onClick function for all other cases
   * @param page is the confluence page to be connected
   */ const onClickSmartCard = (0, $eUqFw.useCallback)((page)=>isAppLinkAuthError(page) ? ()=>onAuthenticateApplink(getHrefForSmartCard(page)) : onClick, [
        isAppLinkAuthError,
        onAuthenticateApplink,
        getHrefForSmartCard,
        onClick
    ]);
    const onClickConfluencePage = (0, $eUqFw.useCallback)((page)=>(event)=>{
            if (!isLinkedPagesBugFixEnabled) event.preventDefault();
            trackEmbeddedConfluence({
                action: 'clicked',
                eventName: 'openLinkedConfluencePage',
                projectType: projectContext.data?.projectType
            });
            return onClickSmartCard(page)?.(event);
        }, [
        isLinkedPagesBugFixEnabled,
        trackEmbeddedConfluence,
        projectContext.data?.projectType,
        onClickSmartCard
    ]);
    /**
   * Returns a title for the passed confluence page. If the page is a failed remote app link,
   * an error message will be shown to the user
   * @param page is the confluence page to be connected
   */ const getTitleForSmartLink = (0, $eUqFw.useCallback)((page)=>{
        if (isAppLinkAuthError(page)) return formatMessage((0, $1Rvlg.default).connectToConfluenceToAuthenticate);
        return !$cc1e2d0db98d4308$var$isPageError(page) && page.href !== page.title ? page.title : undefined;
    }, [
        isAppLinkAuthError,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), (0, $1ybV0.ff)('platform.linking-platform.smart-card.hover-card-ai-summaries') && {
        product: smartCardProviderProduct,
        isAdminHubAIEnabled: isAIFeatureEnabled
    }, pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h49rE.default), {
            key: page.id,
            analyticsLocation: (0, $ivuMa.JiraSmartLinkLocations).CONFLUENCE_PAGES,
            url: getHrefForSmartCard(page),
            onClick: onClickConfluencePage(page),
            canDelete: true,
            onDeleteClick: onDeleteClick,
            text: getTitleForSmartLink(page),
            linkId: $cc1e2d0db98d4308$var$isPageError(page) ? page.link.globalId : page.globalId,
            smartLinkId: page.id,
            page: isLinkedPagesBugFixEnabled ? getPageWithHostname(page) : page,
            loadConfluenceInNewTab: isLinkedPagesBugFixEnabled ? loadConfluenceInNewTab(page) : false
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0iAM.ConfirmationModal), {
        modalOpen: modalOpen,
        onCancelDelete: onCancelDelete,
        onConfirmDelete: onConfirmDelete
    }));
};

});
parcelRegister("h49rE", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ec047909be8c30$export$2e2bcd8739ae039);

var $lqalZ = parcelRequire("lqalZ");

var $hficN = parcelRequire("hficN");

var $b6hsq = parcelRequire("b6hsq");
var $19ec047909be8c30$export$2e2bcd8739ae039 = (0, $lqalZ.connect)(null, (dispatch, { linkId: linkId })=>({
        onCreateWebLinkRetry: ()=>{
            dispatch((0, $hficN.createWebLinkRetry)(linkId));
        },
        onCreateWebLinkCancel: ()=>{
            dispatch((0, $hficN.deleteOptimisticWebLink)(linkId));
        },
        onDeleteWebLinkRetry: ()=>{
            dispatch((0, $hficN.deleteWebLinkRequest)(linkId));
        },
        onDeleteWebLinkCancel: ()=>{
            dispatch((0, $hficN.cancelFailedWebLinkDeletion)(linkId));
        }
    }))((0, $b6hsq.default));

});
parcelRegister("b6hsq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a01f40ca4cf20af$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $kHLYt = parcelRequire("kHLYt");

var $aw5Sy = parcelRequire("aw5Sy");

var $5YsMl = parcelRequire("5YsMl");

var $llwDE = parcelRequire("llwDE");

var $aml13 = parcelRequire("aml13");

var $hXWLE = parcelRequire("hXWLE");
var $hHQdC = parcelRequire("hHQdC");
var $cua7B = parcelRequire("cua7B");
var $1EbMw = parcelRequire("1EbMw");

var $PdmhA = parcelRequire("PdmhA");
var $lcnyw = parcelRequire("lcnyw");

var $1ybV0 = parcelRequire("1ybV0");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $hJ992 = parcelRequire("hJ992");


var $4KQLw = parcelRequire("4KQLw");

var $lBV2M = parcelRequire("lBV2M");

var $ggm5u = parcelRequire("ggm5u");

var $9XfZZ = parcelRequire("9XfZZ");

var $gixeT = parcelRequire("gixeT");

var $ivuMa = parcelRequire("ivuMa");

var $k4pGb = parcelRequire("k4pGb");

var $fOdJx = parcelRequire("fOdJx");
const $6a01f40ca4cf20af$var$getErrorFlagConfiguration = (id, title, onRetry, onCancel)=>({
        id: id,
        title: title,
        description: (0, $gixeT.default).errorBody,
        type: 'warning',
        isAutoDismiss: true,
        actions: [
            {
                content: (0, $gixeT.default).retryAction,
                onClick: onRetry
            },
            {
                content: (0, $gixeT.default).cancelAction,
                onClick: onCancel
            }
        ]
    });
const $6a01f40ca4cf20af$var$SmartLinkContent = (props)=>{
    const { analyticsLocation: analyticsLocation, canDelete: canDelete, isCreateFailed: isCreateFailed, isCreateFailedLimitExceeded: isCreateFailedLimitExceeded, deleteFailed: deleteFailed, linkId: linkId, smartLinkId: smartLinkId, text: text, url: url, onClick: onClick, onCreateWebLinkRetry: onCreateWebLinkRetry, onCreateWebLinkCancel: onCreateWebLinkCancel, onDeleteClick: onDeleteClick, onDeleteWebLinkRetry: onDeleteWebLinkRetry, onDeleteWebLinkCancel: onDeleteWebLinkCancel, loadConfluenceInNewTab: loadConfluenceInNewTab, page: page, whiteboard: whiteboard } = props;
    const { entryPointActions: pageEntryPointActions, entryPoint: pageEntrypoint } = (0, $4KQLw.useEmbeddedPageModalEntryPoint)(page, (0, $1b2c5e0fcb49d7fc$export$2e6ff5d53a830129));
    const { entryPointActions: whiteboardEntryPointActions, entryPoint: whiteboardEntryPoint } = (0, $lBV2M.useEmbeddedWhiteboardModalEntryPoint)(whiteboard, (0, $1b2c5e0fcb49d7fc$export$2e6ff5d53a830129));
    const entryPoint = pageEntrypoint || whiteboardEntryPoint;
    const entryPointActions = pageEntryPointActions || whiteboardEntryPointActions;
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const linkAnalytics = (0, $llwDE.useSmartLinkLifecycleAnalytics)();
    const isCreateFailedOld = (0, $eUqFw.useRef)(false);
    const isCreateFailedLimitExceededOld = (0, $eUqFw.useRef)(false);
    const deleteFailedOld = (0, $eUqFw.useRef)(false);
    const isLinkedPagesBugFixEnabled = (0, $1ybV0.ff)('linked-pages-embedded-bug-fix');
    const isFullIssueView = (0, $hJ992.useIsFullPageIssueView)();
    const isModalView = (0, $hJ992.useIsModal)();
    const isEmbedView = (0, $hJ992.useIsEmbedPageIssueView)();
    const [_, { openModal: openModal, setFieldType: setFieldType }] = (0, $ggm5u.useHardLimitsContactAdminModal)();
    const shouldShowHoverPreview = isFullIssueView || isModalView || isEmbedView;
    const analyticsData = {
        attributes: {
            location: analyticsLocation
        }
    };
    const showErrorFlag = (0, $eUqFw.useCallback)((title, onRetry, onCancel)=>{
        const flagId = (0, $eo17r.toFlagId)((0, $kHLYt.generate)());
        const dismissAndRetry = ()=>{
            dismissFlag(flagId);
            onRetry();
        };
        const dismissAndCancel = ()=>{
            dismissFlag(flagId);
            onCancel();
        };
        showFlag($6a01f40ca4cf20af$var$getErrorFlagConfiguration(flagId, title, dismissAndRetry, dismissAndCancel));
    }, [
        showFlag,
        dismissFlag
    ]);
    const showErrorLimitExceededFlag = (0, $eUqFw.useCallback)(()=>{
        const flagId = (0, $eo17r.toFlagId)((0, $kHLYt.generate)());
        showFlag({
            id: flagId,
            title: (0, $gixeT.default).linksPerIssueLimitExceededTitle,
            description: (0, $gixeT.default).linksPerIssueLimitExceededDescription,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
                label: "warning",
                primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y300})`
            }),
            type: 'warning',
            actions: [
                {
                    content: (0, $gixeT.default).linksPerIssueLimitExceededNotifyAdminLink,
                    onClick: ()=>{
                        dismissFlag(flagId);
                        if ((0, $1ybV0.ff)('hard-limits-modal-admin_wo9xn')) {
                            openModal();
                            setFieldType('remoteIssueLinks');
                        } else window.open('/jira/contact-administrator');
                    }
                }
            ]
        });
    }, [
        showFlag,
        openModal,
        setFieldType,
        dismissFlag
    ]);
    const showCreateErrorFlag = (0, $eUqFw.useCallback)(()=>showErrorFlag((0, $gixeT.default).createErrorHeading, ()=>{
            isCreateFailedOld.current = false;
            onCreateWebLinkRetry();
        }, onCreateWebLinkCancel), [
        onCreateWebLinkRetry,
        onCreateWebLinkCancel,
        showErrorFlag
    ]);
    const showDeleteErrorFlag = (0, $eUqFw.useCallback)(()=>showErrorFlag((0, $gixeT.default).deleteErrorHeading, onDeleteWebLinkRetry, onDeleteWebLinkCancel), [
        onDeleteWebLinkRetry,
        onDeleteWebLinkCancel,
        showErrorFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // On FF cleanup, of `issue.details.display-flag-on-optimistic-weblinks-error`
        // failed to create, and failed to create due to limit
        // flags reside in jira/src/packages/issue/issue-view-base/src/content/web-links/index.tsx
        // so need to be reomved here.
        if ((0, $1ybV0.ff)('issue.details.display-flag-on-optimistic-weblinks-error')) return;
        if (!isCreateFailedOld.current && isCreateFailed) {
            showCreateErrorFlag();
            isCreateFailedOld.current = true;
        }
    }, [
        isCreateFailed,
        showCreateErrorFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, $1ybV0.ff)('issue.details.hard-limits.issue-weblinks-limit')) return;
        if ((0, $1ybV0.ff)('issue.details.display-flag-on-optimistic-weblinks-error')) return;
        if (!isCreateFailedLimitExceededOld.current && isCreateFailedLimitExceeded) {
            showErrorLimitExceededFlag();
            isCreateFailedLimitExceededOld.current = true;
        }
    }, [
        isCreateFailedLimitExceeded,
        showErrorLimitExceededFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!deleteFailedOld.current && deleteFailed) {
            showDeleteErrorFlag();
            deleteFailedOld.current = true;
        }
    }, [
        deleteFailed,
        showDeleteErrorFlag
    ]);
    const sendDeletedEvent = (0, $eUqFw.useCallback)(()=>{
        linkAnalytics?.linkDeleted({
            url: url,
            smartLinkId: linkId
        }, null, {
            ...(0, $ivuMa.smartLinksAttributes),
            location: analyticsLocation
        });
    }, [
        url,
        linkId,
        analyticsLocation,
        linkAnalytics
    ]);
    const cardOnclick = (0, $eUqFw.useCallback)((event)=>{
        if (!isLinkedPagesBugFixEnabled) entryPointActions?.load();
        else if (isLinkedPagesBugFixEnabled && !loadConfluenceInNewTab && (page || whiteboard)) {
            event.preventDefault();
            entryPointActions?.load();
        }
        onClick?.(event);
    }, [
        entryPointActions,
        isLinkedPagesBugFixEnabled,
        loadConfluenceInNewTab,
        onClick,
        page,
        whiteboard
    ]);
    const onDeleteCallback = (0, $eUqFw.useCallback)(()=>{
        onDeleteClick(linkId);
        sendDeletedEvent();
    }, [
        linkId,
        onDeleteClick,
        sendDeletedEvent
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>canDelete ? [
            {
                name: (0, $hXWLE.ActionName).DeleteAction,
                onClick: onDeleteCallback,
                hideContent: true
            }
        ] : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [], [
        canDelete,
        onDeleteCallback
    ]);
    const smartLink = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hHQdC.Card), {
            id: linkId,
            key: smartLinkId,
            appearance: "block",
            url: url,
            ui: (0, $fOdJx.default),
            onClick: cardOnclick,
            placeholder: " ",
            showHoverPreview: shouldShowHoverPreview,
            showAuthTooltip: shouldShowHoverPreview,
            actionOptions: {
                hide: false,
                exclude: [
                    (0, $cua7B.CardAction).ChangeStatusAction
                ]
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1EbMw.default), {
            // https://product-fabric.atlassian.net/browse/EDM-3980 fix this override type
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            overrideCss: (0, $k4pGb.styleOverrides),
            position: (0, $hXWLE.SmartLinkPosition).Center,
            metadata: [
                {
                    name: (0, $hXWLE.ElementName).ModifiedOn
                },
                {
                    name: (0, $hXWLE.ElementName).State
                },
                {
                    name: (0, $hXWLE.ElementName).AuthorGroup,
                    size: (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i') ? (0, $hXWLE.SmartLinkSize).Large : undefined
                }
            ],
            text: text,
            actions: actions,
            showActionOnHover: true,
            maxLines: 1,
            anchorTarget: "_blank",
            hideTitleTooltip: shouldShowHoverPreview
        })), [
        linkId,
        smartLinkId,
        url,
        cardOnclick,
        shouldShowHoverPreview,
        text,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a01f40ca4cf20af$var$CardWrapper, null, smartLink), entryPoint);
};
const $6a01f40ca4cf20af$var$SmartLinkContentWithSmartCardProvider = (props)=>{
    const smartCardProviderProduct = (0, $9XfZZ.useSmartCardProductType)();
    const isAIFeatureEnabled = (0, $9XfZZ.useSmartCardIsAIEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), (0, $1ybV0.ff)('platform.linking-platform.smart-card.hover-card-ai-summaries') && {
        product: smartCardProviderProduct,
        isAdminHubAIEnabled: isAIFeatureEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a01f40ca4cf20af$var$SmartLinkContent, props));
};
var $6a01f40ca4cf20af$export$2e2bcd8739ae039 = $6a01f40ca4cf20af$var$SmartLinkContentWithSmartCardProvider;
const $6a01f40ca4cf20af$var$animationNameStyles = /*#__PURE__*/ (0, $kwce8.keyframes)({
    '0%': {
        backgroundPosition: '-300px 0'
    },
    '100%': {
        backgroundPosition: '1000px 0'
    }
});
const $6a01f40ca4cf20af$var$loadingShimmer = `
  animation-duration: 1.2s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${$6a01f40ca4cf20af$var$animationNameStyles};
  animation-timing-function: linear;
  background-color: ${`var(--ds-background-neutral, ${(0, $PdmhA).N30})`};
  background-image: linear-gradient(
      to right,
      ${`var(--ds-background-neutral, ${(0, $PdmhA).N30})`} 10%,
      ${`var(--ds-background-neutral-subtle, ${(0, $PdmhA).N20})`} 30%,
      ${`var(--ds-background-neutral, ${(0, $PdmhA).N30})`} 50%
  );
  background-repeat: no-repeat;
  border-radius: 4px;
`;
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a01f40ca4cf20af$var$CardWrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1qybnka-0"
})`&:last-child{${(0, $lcnyw.noFocusRing)};border-bottom-color:transparent;}&:hover{background:${`var(--ds-background-neutral-subtle-hovered, ${(0, $PdmhA).N30})`};text-decoration:none;}border-bottom:1px solid ${`var(--ds-border, ${(0, $PdmhA).N30})`};box-shadow:none;background:${`var(--ds-background-neutral-subtle, ${(0, $PdmhA).N0})`};padding:0 ${"var(--ds-space-075, 6px)"};margin:0 ${"var(--ds-space-025, 2px)"};border-radius:3px;.smart-link-loading-placeholder{margin-left:-0.5rem;height:20px;border-bottom:solid ${`var(--ds-background-neutral-subtle, ${(0, $PdmhA).N0})`} 10px;border-top:solid ${`var(--ds-background-neutral-subtle, ${(0, $PdmhA).N0})`} 10px;border-left:solid ${`var(--ds-background-neutral-subtle, ${(0, $PdmhA).N0})`} 14px;border-right:solid ${`var(--ds-background-neutral-subtle, ${(0, $PdmhA).N0})`} 14px;width:calc(100% + -1rem);display:block;${$6a01f40ca4cf20af$var$loadingShimmer}}`;

});
parcelRegister("kHLYt", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hpfs8"));

});
parcelRegister("hpfs8", function(module, exports) {
'use strict';

var $65vow = parcelRequire("65vow");

var $2OSrw = parcelRequire("2OSrw");

var $2d1Ll = parcelRequire("2d1Ll");

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var $cac0c20fc2eeacc1$var$clusterWorkerId = (parcelRequire("ayyu4")) || 0;
/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */ function $cac0c20fc2eeacc1$var$seed(seedValue) {
    $65vow.seed(seedValue);
    return module.exports;
}
/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */ function $cac0c20fc2eeacc1$var$worker(workerId) {
    $cac0c20fc2eeacc1$var$clusterWorkerId = workerId;
    return module.exports;
}
/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */ function $cac0c20fc2eeacc1$var$characters(newCharacters) {
    if (newCharacters !== undefined) $65vow.characters(newCharacters);
    return $65vow.shuffled();
}
/**
 * Generate unique id
 * Returns string id
 */ function $cac0c20fc2eeacc1$var$generate() {
    return $2OSrw($cac0c20fc2eeacc1$var$clusterWorkerId);
}
// Export all other functions as properties of the generate function
module.exports = $cac0c20fc2eeacc1$var$generate;
module.exports.generate = $cac0c20fc2eeacc1$var$generate;
module.exports.seed = $cac0c20fc2eeacc1$var$seed;
module.exports.worker = $cac0c20fc2eeacc1$var$worker;
module.exports.characters = $cac0c20fc2eeacc1$var$characters;
module.exports.isValid = $2d1Ll;

});
parcelRegister("65vow", function(module, exports) {
'use strict';

var $7x6JO = parcelRequire("7x6JO");
var $46eb8ffb0f48314e$var$ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var $46eb8ffb0f48314e$var$alphabet;
var $46eb8ffb0f48314e$var$previousSeed;
var $46eb8ffb0f48314e$var$shuffled;
function $46eb8ffb0f48314e$var$reset() {
    $46eb8ffb0f48314e$var$shuffled = false;
}
function $46eb8ffb0f48314e$var$setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if ($46eb8ffb0f48314e$var$alphabet !== $46eb8ffb0f48314e$var$ORIGINAL) {
            $46eb8ffb0f48314e$var$alphabet = $46eb8ffb0f48314e$var$ORIGINAL;
            $46eb8ffb0f48314e$var$reset();
        }
        return;
    }
    if (_alphabet_ === $46eb8ffb0f48314e$var$alphabet) return;
    if (_alphabet_.length !== $46eb8ffb0f48314e$var$ORIGINAL.length) throw new Error('Custom alphabet for shortid must be ' + $46eb8ffb0f48314e$var$ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    var unique = _alphabet_.split('').filter(function(item, ind, arr) {
        return ind !== arr.lastIndexOf(item);
    });
    if (unique.length) throw new Error('Custom alphabet for shortid must be ' + $46eb8ffb0f48314e$var$ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    $46eb8ffb0f48314e$var$alphabet = _alphabet_;
    $46eb8ffb0f48314e$var$reset();
}
function $46eb8ffb0f48314e$var$characters(_alphabet_) {
    $46eb8ffb0f48314e$var$setCharacters(_alphabet_);
    return $46eb8ffb0f48314e$var$alphabet;
}
function $46eb8ffb0f48314e$var$setSeed(seed) {
    $7x6JO.seed(seed);
    if ($46eb8ffb0f48314e$var$previousSeed !== seed) {
        $46eb8ffb0f48314e$var$reset();
        $46eb8ffb0f48314e$var$previousSeed = seed;
    }
}
function $46eb8ffb0f48314e$var$shuffle() {
    if (!$46eb8ffb0f48314e$var$alphabet) $46eb8ffb0f48314e$var$setCharacters($46eb8ffb0f48314e$var$ORIGINAL);
    var sourceArray = $46eb8ffb0f48314e$var$alphabet.split('');
    var targetArray = [];
    var r = $7x6JO.nextValue();
    var characterIndex;
    while(sourceArray.length > 0){
        r = $7x6JO.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}
function $46eb8ffb0f48314e$var$getShuffled() {
    if ($46eb8ffb0f48314e$var$shuffled) return $46eb8ffb0f48314e$var$shuffled;
    $46eb8ffb0f48314e$var$shuffled = $46eb8ffb0f48314e$var$shuffle();
    return $46eb8ffb0f48314e$var$shuffled;
}
/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */ function $46eb8ffb0f48314e$var$lookup(index) {
    var alphabetShuffled = $46eb8ffb0f48314e$var$getShuffled();
    return alphabetShuffled[index];
}
function $46eb8ffb0f48314e$var$get() {
    return $46eb8ffb0f48314e$var$alphabet || $46eb8ffb0f48314e$var$ORIGINAL;
}
module.exports = {
    get: $46eb8ffb0f48314e$var$get,
    characters: $46eb8ffb0f48314e$var$characters,
    seed: $46eb8ffb0f48314e$var$setSeed,
    lookup: $46eb8ffb0f48314e$var$lookup,
    shuffled: $46eb8ffb0f48314e$var$getShuffled
};

});
parcelRegister("7x6JO", function(module, exports) {
'use strict';
// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)
var $57c0d77552ad4453$var$seed = 1;
/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */ function $57c0d77552ad4453$var$getNextValue() {
    $57c0d77552ad4453$var$seed = ($57c0d77552ad4453$var$seed * 9301 + 49297) % 233280;
    return $57c0d77552ad4453$var$seed / 233280.0;
}
function $57c0d77552ad4453$var$setSeed(_seed_) {
    $57c0d77552ad4453$var$seed = _seed_;
}
module.exports = {
    nextValue: $57c0d77552ad4453$var$getNextValue,
    seed: $57c0d77552ad4453$var$setSeed
};

});


parcelRegister("2OSrw", function(module, exports) {
'use strict';

var $lu4fN = parcelRequire("lu4fN");
parcelRequire("65vow");
// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var $20da7b7c8d36468d$var$REDUCE_TIME = 1567752802062;
// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var $20da7b7c8d36468d$var$version = 7;
// Counter is used when shortid is called multiple times in one second.
var $20da7b7c8d36468d$var$counter;
// Remember the last time shortid was called in case counter is needed.
var $20da7b7c8d36468d$var$previousSeconds;
/**
 * Generate unique id
 * Returns string id
 */ function $20da7b7c8d36468d$var$build(clusterWorkerId) {
    var str = '';
    var seconds = Math.floor((Date.now() - $20da7b7c8d36468d$var$REDUCE_TIME) * 0.001);
    if (seconds === $20da7b7c8d36468d$var$previousSeconds) $20da7b7c8d36468d$var$counter++;
    else {
        $20da7b7c8d36468d$var$counter = 0;
        $20da7b7c8d36468d$var$previousSeconds = seconds;
    }
    str = str + $lu4fN($20da7b7c8d36468d$var$version);
    str = str + $lu4fN(clusterWorkerId);
    if ($20da7b7c8d36468d$var$counter > 0) str = str + $lu4fN($20da7b7c8d36468d$var$counter);
    str = str + $lu4fN(seconds);
    return str;
}
module.exports = $20da7b7c8d36468d$var$build;

});
parcelRegister("lu4fN", function(module, exports) {
'use strict';

var $65vow = parcelRequire("65vow");

var $7daI6 = parcelRequire("7daI6");

var $kBuh4 = parcelRequire("kBuh4");
function $fa3fb30a71d62940$var$generate(number) {
    var loopCounter = 0;
    var done;
    var str = '';
    while(!done){
        str = str + $kBuh4($7daI6, $65vow.get(), 1);
        done = number < Math.pow(16, loopCounter + 1);
        loopCounter++;
    }
    return str;
}
module.exports = $fa3fb30a71d62940$var$generate;

});
parcelRegister("7daI6", function(module, exports) {
'use strict';
var $54020e23c6d7c9e9$var$crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto
var $54020e23c6d7c9e9$var$randomByte;
if (!$54020e23c6d7c9e9$var$crypto || !$54020e23c6d7c9e9$var$crypto.getRandomValues) $54020e23c6d7c9e9$var$randomByte = function(size) {
    var bytes = [];
    for(var i = 0; i < size; i++)bytes.push(Math.floor(Math.random() * 256));
    return bytes;
};
else $54020e23c6d7c9e9$var$randomByte = function(size) {
    return $54020e23c6d7c9e9$var$crypto.getRandomValues(new Uint8Array(size));
};
module.exports = $54020e23c6d7c9e9$var$randomByte;

});

parcelRegister("kBuh4", function(module, exports) {
// This file replaces `format.js` in bundlers like webpack or Rollup,
// according to `browser` config in `package.json`.
module.exports = function(random, alphabet, size) {
    // We can’t use bytes bigger than the alphabet. To make bytes values closer
    // to the alphabet, we apply bitmask on them. We look for the closest
    // `2 ** x - 1` number, which will be bigger than alphabet size. If we have
    // 30 symbols in the alphabet, we will take 31 (00011111).
    // We do not use faster Math.clz32, because it is not available in browsers.
    var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    // Bitmask is not a perfect solution (in our example it will pass 31 bytes,
    // which is bigger than the alphabet). As a result, we will need more bytes,
    // than ID size, because we will refuse bytes bigger than the alphabet.
    // Every hardware random generator call is costly,
    // because we need to wait for entropy collection. This is why often it will
    // be faster to ask for few extra bytes in advance, to avoid additional calls.
    // Here we calculate how many random bytes should we call in advance.
    // It depends on ID length, mask / alphabet size and magic number 1.6
    // (which was selected according benchmarks).
    // -~f => Math.ceil(f) if n is float number
    // -~i => i + 1 if n is integer number
    var step = -~(1.6 * mask * size / alphabet.length);
    var id = '';
    while(true){
        var bytes = random(step);
        // Compact alternative for `for (var i = 0; i < step; i++)`
        var i = step;
        while(i--){
            // If random byte is bigger than alphabet even after bitmask,
            // we refuse it by `|| ''`.
            id += alphabet[bytes[i] & mask] || '';
            // More compact than `id.length + 1 === size`
            if (id.length === +size) return id;
        }
    }
};

});



parcelRegister("2d1Ll", function(module, exports) {
'use strict';

var $65vow = parcelRequire("65vow");
function $19be29b228f8ca37$var$isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6) return false;
    var nonAlphabetic = new RegExp('[^' + $65vow.get().replace(/[|\\{}()[\]^$+*?.-]/g, '\\$&') + ']');
    return !nonAlphabetic.test(id);
}
module.exports = $19be29b228f8ca37$var$isShortId;

});

parcelRegister("ayyu4", function(module, exports) {
'use strict';
module.exports = 0;

});



parcelRegister("llwDE", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkLifecycleAnalytics", () => $340af5fe00343844$export$612752b1e088a45e);
$parcel$export(module.exports, "useDatasourceLifecycleAnalytics", () => $340af5fe00343844$export$c82e48d9fd97c55b);

var $eUqFw = parcelRequire("eUqFw");

var $hM7RE = parcelRequire("hM7RE");
var $bFzGY = parcelRequire("bFzGY");

var $gqldc = parcelRequire("gqldc");


var $eXQlt = parcelRequire("eXQlt");

var $dhzMF = parcelRequire("dhzMF");

var $lBiiB = parcelRequire("lBiiB");

const $340af5fe00343844$export$612752b1e088a45e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { store: store, connections: { client: client } } = (0, $gqldc.useSmartLinkContext)();
    return (0, $eUqFw.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $dhzMF.runWhenIdle)(()=>{
                        (0, $hM7RE.default)((0, $1cd66c27a1c46167$export$85183a312807388d))((0, $eXQlt.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $dhzMF.runWhenIdle)(async ()=>{
                        const { default: fireEvent } = await (parcelRequire("03dMb"));
                        fireEvent(action, createAnalyticsEvent, client, store)(...args);
                    });
                } catch (error) {
                    (0, $hM7RE.default)((0, $1cd66c27a1c46167$export$85183a312807388d))((0, $eXQlt.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            linkCreated: factory('created'),
            linkUpdated: factory('updated'),
            linkDeleted: factory('deleted')
        };
    }, [
        client,
        store,
        createAnalyticsEvent
    ]);
};

const $340af5fe00343844$export$c82e48d9fd97c55b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { getDatasourceData: getDatasourceData } = (0, $lBiiB.useDatasourceClientExtension)();
    return (0, $eUqFw.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $dhzMF.runWhenIdle)(()=>{
                        (0, $hM7RE.default)((0, $1cd66c27a1c46167$export$85183a312807388d))((0, $eXQlt.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $dhzMF.runWhenIdle)(async ()=>{
                        const { fireDatasourceEvent: fireDatasourceEvent } = await (parcelRequire("03dMb"));
                        fireDatasourceEvent(action, createAnalyticsEvent, getDatasourceData)(...args);
                    });
                } catch (error) {
                    (0, $hM7RE.default)((0, $1cd66c27a1c46167$export$85183a312807388d))((0, $eXQlt.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            datasourceCreated: factory('created'),
            datasourceUpdated: factory('updated'),
            datasourceDeleted: factory('deleted')
        };
    }, [
        createAnalyticsEvent,
        getDatasourceData
    ]);
};

});
const $1cd66c27a1c46167$export$85183a312807388d = 'media';

parcelRegister("eXQlt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5616125ddd397a66$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::51cee2198a185514f1983d14f57a5d9a>>
 * @codegenCommand yarn workspace @atlaskit/link-analytics run codegen-analytics
 */ function $5616125ddd397a66$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $5616125ddd397a66$export$2e2bcd8739ae039 = $5616125ddd397a66$var$createEventPayload;

});

parcelRegister("dhzMF", function(module, exports) {

$parcel$export(module.exports, "runWhenIdle", () => $ee58ca096fc2cd66$export$51d09170c61ebe04);
/* eslint-disable compat/compat */ const $ee58ca096fc2cd66$export$51d09170c61ebe04 = (callback)=>window.requestIdleCallback ? window.requestIdleCallback(callback, {
        timeout: 5000
    }) : window.requestAnimationFrame(callback);

});

parcelRegister("lBiiB", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE", () => $3ff0a76e45113e93$export$5e074c0b68e2ce03);
$parcel$export(module.exports, "useDatasourceClientExtension", () => $3ff0a76e45113e93$export$7d812bb756889442);

var $eUqFw = parcelRequire("eUqFw");

var $6roQF = parcelRequire("6roQF");

var $gqldc = parcelRequire("gqldc");

var $5LW2w = parcelRequire("5LW2w");

var $XHGTv = parcelRequire("XHGTv");

var $euvAQ = parcelRequire("euvAQ");
const $3ff0a76e45113e93$var$URL_RESPONSE_CACHE_SIZE = 50;
const $3ff0a76e45113e93$export$f82fcd766a8daa7f = new (0, $6roQF.LRUMap)($3ff0a76e45113e93$var$URL_RESPONSE_CACHE_SIZE);
const $3ff0a76e45113e93$export$40b1dd31340bd5c2 = new (0, $6roQF.LRUMap)($3ff0a76e45113e93$var$URL_RESPONSE_CACHE_SIZE);
const $3ff0a76e45113e93$export$5e074c0b68e2ce03 = 20;
const $3ff0a76e45113e93$export$7d812bb756889442 = ()=>{
    const { connections: { client: client } } = (0, $gqldc.useSmartLinkContext)();
    const resolverUrl = (0, $euvAQ.useResolverUrl)(client);
    const cachedRequest = async (datasourceId, data, url, lruMap, force)=>{
        const cacheKeyData = {
            ...data,
            // Sort fields to use cached version of response regardless of the order
            ...'fields' in data ? {
                fields: [
                    ...data.fields || []
                ].sort()
            } : {}
        };
        const cacheKey = JSON.stringify({
            datasourceId: datasourceId,
            cacheKeyData: cacheKeyData
        });
        if (force) lruMap.delete(cacheKey);
        let responsePromise = lruMap.get(cacheKey);
        if (responsePromise) return responsePromise;
        const headers = (0, $XHGTv.getBooleanFF)('platform.linking-platform.datasource.add-timezone-header') ? {
            /**
					 * This header exist to enable the backend to process relative time, eg: "today", with respect to user timezone.
					 * eg: used in "confluence-object-provider" to process confluence SLLV requests to filter data for relative time.
					 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
        } : undefined;
        try {
            responsePromise = (0, $5LW2w.request)('post', url, data, headers, [
                200,
                201,
                202,
                203,
                204
            ]);
            lruMap.set(cacheKey, responsePromise);
            return await responsePromise;
        } catch (e) {
            lruMap.delete(cacheKey);
            throw e;
        }
    };
    const getDatasourceDetails = (0, $eUqFw.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $3ff0a76e45113e93$export$f82fcd766a8daa7f, force), [
        resolverUrl
    ]);
    const getDatasourceData = (0, $eUqFw.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/data`, $3ff0a76e45113e93$export$40b1dd31340bd5c2, force), [
        resolverUrl
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData
        }), [
        getDatasourceDetails,
        getDatasourceData
    ]);
};

});

parcelRegister("03dMb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4URh9');
        const value = parcelRequire('amB4r');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4URh9").then(()=>parcelRequire('amB4r'));
}

});


parcelRegister("hHQdC", function(module, exports) {

$parcel$export(module.exports, "Card", () => $ce3ef558701caae7$export$60332b2344f7fe41);

var $eUqFw = parcelRequire("eUqFw");

var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $91sWg = parcelRequire("91sWg");

var $7cTTN = parcelRequire("7cTTN");

var $6MLxR = parcelRequire("6MLxR");

var $iDnwt = parcelRequire("iDnwt");

var $2qhQi = parcelRequire("2qhQi");
var $3dpxL = parcelRequire("3dpxL");
class $ce3ef558701caae7$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const content = (0, $6MLxR.isCardWithData)(this.props) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $91sWg.CardWithDataRenderer), this.props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cTTN.CardWithURLRenderer), this.props);
        return this.props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
            locale: "en"
        }, content);
    }
}
const $ce3ef558701caae7$export$60332b2344f7fe41 = (0, $1ngde.default)((0, $iDnwt.context))((0, $2jDha.default)()((0, $2qhQi.default)($ce3ef558701caae7$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("91sWg", function(module, exports) {

$parcel$export(module.exports, "CardWithDataRenderer", () => $691aa7acbbf7f8fd$export$9d0e69e8740e5c1c);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

class $691aa7acbbf7f8fd$export$9d0e69e8740e5c1c extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static moduleImporter(target) {
        (parcelRequire("gFqMs")).then((module)=>{
            $691aa7acbbf7f8fd$export$9d0e69e8740e5c1c.CardContent = module.CardWithDataContent;
            target.forceUpdate();
        });
    }
    componentDidMount() {
        if ($691aa7acbbf7f8fd$export$9d0e69e8740e5c1c.CardContent === null) (this.props.importer || $691aa7acbbf7f8fd$export$9d0e69e8740e5c1c.moduleImporter)(this);
    }
    render() {
        const { id: id, appearance: appearance, data: data, isSelected: isSelected, onClick: onClick, onResolve: onResolve, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle } = this.props;
        if (!data) throw new Error('@atlaskit/smart-cards: you are trying to render a card with data, but does not provide any');
        if ($691aa7acbbf7f8fd$export$9d0e69e8740e5c1c.CardContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($691aa7acbbf7f8fd$export$9d0e69e8740e5c1c.CardContent, {
            id: id,
            inlinePreloaderStyle: inlinePreloaderStyle,
            appearance: appearance,
            data: data,
            isSelected: isSelected,
            onClick: onClick,
            onResolve: onResolve,
            testId: testId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-card-with-data": true
        });
    }
}
(0, $5zQU9.default)($691aa7acbbf7f8fd$export$9d0e69e8740e5c1c, "CardContent", null);

});
parcelRegister("gFqMs", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2dMJD')
        ]);
        const value = parcelRequire('8Wy6X');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2dMJD")
    ]).then(()=>parcelRequire('8Wy6X'));
}

});


parcelRegister("7cTTN", function(module, exports) {

$parcel$export(module.exports, "CardWithURLRenderer", () => $53f503c83f41b1bb$export$e00a7788e30dc998);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $aSzRC = parcelRequire("aSzRC");

var $jb3WS = parcelRequire("jb3WS");

var $kxPGe = parcelRequire("kxPGe");

var $9J0yZ = parcelRequire("9J0yZ");

var $6MLxR = parcelRequire("6MLxR");

var $iw7Qh = parcelRequire("iw7Qh");

const $53f503c83f41b1bb$var$LazyCardWithUrlContent = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(0, $6MLxR.importWithRetry)(()=>(parcelRequire("ki4Uz"))));
function $53f503c83f41b1bb$export$e00a7788e30dc998(props) {
    const [id] = (0, $eUqFw.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))());
    (0, $eUqFw.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $aSzRC.clearMarks)(id);
            (0, $aSzRC.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, isFrameVisible: isFrameVisible, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, showActions: showActions, showServerActions: showServerActions, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, showAuthTooltip: showAuthTooltip, analyticsEvents: analyticsEvents, placeholder: placeholder, fallbackComponent: fallbackComponent, useLegacyBlockCard: useLegacyBlockCard } = props;
    const analytics = (0, $kxPGe.useSmartLinkAnalytics)(url !== null && url !== void 0 ? url : '', undefined, id);
    const isFlexibleUi = (0, $iw7Qh.isFlexibleUiCard)(children);
    const errorHandler = (0, $eUqFw.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') analytics.operational.chunkloadFailedEvent({
            display: appearance,
            error: error,
            errorInfo: errorInfo
        });
        else if (error.name !== 'APIError') analytics.ui.renderFailedEvent({
            display: isFlexibleUi ? 'flexible' : appearance,
            id: id,
            error: error,
            errorInfo: errorInfo
        });
        onError && onError({
            status: 'errored',
            url: url !== null && url !== void 0 ? url : '',
            err: error
        });
    }, [
        analytics.operational,
        analytics.ui,
        appearance,
        id,
        onError,
        url,
        isFlexibleUi
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent !== null && fallbackComponent !== void 0 ? fallbackComponent : defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FallbackComponent, null);
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        isFrameVisible: isFrameVisible,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        showActions: showActions,
        showServerActions: showServerActions,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        showAuthTooltip: showAuthTooltip,
        analyticsEvents: analyticsEvents,
        placeholder: placeholder,
        useLegacyBlockCard: useLegacyBlockCard
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9J0yZ.LoadingCardLink), cardWithUrlProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53f503c83f41b1bb$var$LazyCardWithUrlContent, cardWithUrlProps, children)));
}

});
parcelRegister("9J0yZ", function(module, exports) {

$parcel$export(module.exports, "LoadingCardLink", () => $7148c0e32119da1f$export$1ca0544321134ad6);

var $eUqFw = parcelRequire("eUqFw");

var $a1QBs = parcelRequire("a1QBs");

const $7148c0e32119da1f$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1QBs.CardLinkView), {
        key: 'lazy-render-key',
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        className: (0, $7542e4d7d8a7eead$export$4b2b7d155f69aed4),
        placeholder: placeholder
    });
};

});
parcelRegister("a1QBs", function(module, exports) {

$parcel$export(module.exports, "CardLinkView", () => $74d2cd45e9bd36dd$export$ce508304ed2dd145);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $akOVH = parcelRequire("akOVH");
class $74d2cd45e9bd36dd$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $akOVH.Frame), (0, $kU09D.default)({
            withoutBackground: true
        }, this.props), this.props.placeholder || this.props.link);
    }
}

});
parcelRegister("akOVH", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $7863473559018e96$export$b89a827e9254211a);

var $eUqFw = parcelRequire("eUqFw");

var $7ph6o = parcelRequire("7ph6o");

var $hnYQo = parcelRequire("hnYQo");
const $7863473559018e96$export$b89a827e9254211a = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered } = props;
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $eUqFw.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $hnYQo.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = link || onClick ? (0, $7ph6o.WrapperAnchor) : (0, $7ph6o.WrapperSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        className: className,
        ref: ref,
        isHovered: isHovered
    }, children);
});

});
parcelRegister("7ph6o", function(module, exports) {

$parcel$export(module.exports, "WrapperAnchor", () => $56482252853be12b$export$6e4bde711df5c2ab);
$parcel$export(module.exports, "WrapperSpan", () => $56482252853be12b$export$8b5c95e985c4ec9a);

var $exJuA = parcelRequire("exJuA");

var $PdmhA = parcelRequire("PdmhA");
const $56482252853be12b$var$selectedStyles = {
    cursor: 'pointer',
    boxShadow: `0 0 0 2px ${`var(--ds-border-selected, ${(0, $PdmhA.B100)})`}`,
    outline: 'none',
    userSelect: 'none',
    '&, :hover, :focus, :active': {
        textDecoration: 'none'
    },
    '&:hover': {
        border: `1px solid ${`var(--ds-border, ${(0, $PdmhA.N40)})`}`
    }
};
const $56482252853be12b$var$isInteractive = ({ isInteractive: isInteractive })=>{
    if (isInteractive) return {
        ':active': {
            backgroundColor: `var(--ds-background-selected, ${0, $PdmhA.B50})`
        },
        ':focus': $56482252853be12b$var$selectedStyles
    };
    return undefined;
};
const $56482252853be12b$var$isSelected = ({ isSelected: isSelected })=>{
    if (isSelected) return $56482252853be12b$var$selectedStyles;
    else return {
        userSelect: 'text'
    };
};
const $56482252853be12b$var$hoveredStyles = {
    borderColor: `var(--ds-border-accent-blue, ${(0, $PdmhA.B200)})`
};
const $56482252853be12b$var$activeHoveredFocusedStyles = (props)=>{
    if (props.withoutBackground) return undefined;
    return {
        textDecoration: 'none'
    };
};
const $56482252853be12b$var$hoveredWihBorderStyles = (props)=>({
        ...$56482252853be12b$var$hoveredStyles,
        ...$56482252853be12b$var$activeHoveredFocusedStyles(props)
    });
/*
  Inline smart cards should have the following layout:
  ------------------------------------
  | icon | title | action OR lozenge |
  ------------------------------------
  The aim is to ensure (1) all children are
  in line with each other, (2) are vertically
  centered.
*/ // NB: `padding` consistent with @mentions.
// NB: `display: inline` required for `box-decoration-break` to work.
// NB: `box-decoration-break` required for retaining properties (border-radius) on wrap.
const $56482252853be12b$var$baseWrapperStyles = (props)=>({
        lineHeight: '22px',
        padding: `${"var(--ds-space-025, 2px)"} 0px`,
        ...props.withoutBackground ? {
            paddingLeft: 0,
            marginLeft: "var(--ds-space-negative-025, -2px)"
        } : undefined,
        display: 'inline',
        boxDecorationBreak: 'clone',
        borderRadius: "var(--ds-border-radius-100, 4px)",
        color: `var(--ds-link, ${0, $PdmhA.B400})`,
        ...props.withoutBackground ? undefined : {
            backgroundColor: "var(--ds-surface-raised, white)"
        },
        ...$56482252853be12b$var$isSelected(props),
        ...props.withoutBackground ? undefined : {
            border: `1px solid ${`var(--ds-border, ${0, $PdmhA.N40})`}`
        },
        '&:hover': $56482252853be12b$var$hoveredStyles,
        '&, :hover, :focus, :active': $56482252853be12b$var$activeHoveredFocusedStyles(props),
        transition: '0.1s all ease-in-out',
        MozUserSelect: 'none',
        // -moz-user-select
        ...props.isHovered ? $56482252853be12b$var$hoveredWihBorderStyles(props) : undefined
    });
const $56482252853be12b$export$6e4bde711df5c2ab = (0, $exJuA.default).a((props)=>({
        ...$56482252853be12b$var$baseWrapperStyles(props),
        ...$56482252853be12b$var$isInteractive(props)
    }));
$56482252853be12b$export$6e4bde711df5c2ab.displayName = 'WrapperAnchor';
const $56482252853be12b$export$8b5c95e985c4ec9a = (0, $exJuA.default).span((props)=>({
        ...$56482252853be12b$var$baseWrapperStyles(props)
    }));
$56482252853be12b$export$8b5c95e985c4ec9a.displayName = 'WrapperSpan';

});




parcelRegister("ki4Uz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('aIjUo')
        ]);
        const value = parcelRequire('aR82M');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("aIjUo")
    ]).then(()=>parcelRequire('aR82M'));
}

});



parcelRegister("4KQLw", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPageModalEntryPoint", () => $278829163bd2d69a$export$7d3389f410b6e013);

var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $7aWIX = parcelRequire("7aWIX");
var $ekwSm = parcelRequire("ekwSm");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fIYY5 = parcelRequire("fIYY5");

var $eq2dV = parcelRequire("eq2dV");

var $dMGT3 = parcelRequire("dMGT3");

var $4YFgD = parcelRequire("4YFgD");
const $278829163bd2d69a$var$entryPointParams = {};
const $278829163bd2d69a$export$7d3389f410b6e013 = (page, embeddedConfluenceSource)=>{
    const parentProduct = (0, $dMGT3.useParentProduct)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const isPageError = !page || page.error;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $fIYY5.embeddedConfluencePageModalEntrypoint), $278829163bd2d69a$var$entryPointParams);
    const fireAnalyticsEvent = (0, $eq2dV.useEmbeddedPageTracking)();
    const themeState = (0, $4q38b.default)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const confluencePage = page;
    const pageHref = confluencePage?.href;
    let hostname = (0, $4YFgD.isValidUrl)(pageHref) ? new URL(pageHref)?.hostname : '';
    if ((0, $1ybV0.ff)('linked-pages-embedded-bug-fix')) hostname = confluencePage?.hostname ?? '';
    const onPageAction = (0, $eUqFw.useCallback)((action, eventName)=>{
        fireAnalyticsEvent({
            action: action,
            eventName: eventName,
            embeddedConfluenceSource: embeddedConfluenceSource
        });
    }, [
        fireAnalyticsEvent,
        embeddedConfluenceSource
    ]);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            eventName: 'closeLinkedConfluencePage',
            embeddedConfluenceSource: embeddedConfluenceSource
        });
        entryPointActions.unload();
    }, [
        fireAnalyticsEvent,
        entryPointActions,
        embeddedConfluenceSource
    ]);
    const { locale: locale } = (0, $5JgJ2.default)();
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            locale: locale,
            hostname: hostname,
            hasFooterLogo: false,
            isOpen: true,
            modalTitle: confluencePage?.title,
            navigationPolicy: undefined,
            onClose: onClose,
            onPageAction: onPageAction,
            parentProduct: parentProduct,
            spaceKey: (0, $ekwSm.parseUrl)(pageHref)?.spaceKey,
            themeState: themeState,
            url: pageHref,
            mode: (0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            embeddedConfluenceSource: embeddedConfluenceSource,
            contentId: (0, $ekwSm.parseUrl)(pageHref)?.contentId,
            allowedFeatures: {
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-comments',
                    'page-reactions',
                    'inline-comments',
                    'non-licensed-share'
                ]
            }
        }), [
        locale,
        hostname,
        confluencePage?.title,
        onClose,
        onPageAction,
        parentProduct,
        pageHref,
        themeState,
        embeddedConfluenceSource
    ]);
    return !isPageError ? {
        entryPointActions: entryPointActions,
        entryPoint: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "epModalEntrypointContainer",
            packageName: "@atlassian/jira-issue-create-confluence-content",
            teamName: "confluence-better-together",
            runtimeProps: runtimeProps
        })
    } : {
        ref: undefined,
        entryPoint: null
    };
};

});
parcelRegister("7aWIX", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", () => $539704f46610c472$export$816ef638e478449a);
let $539704f46610c472$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});

});

parcelRegister("ekwSm", function(module, exports) {

$parcel$export(module.exports, "parsePageProps", () => $a6ec6f63f1398335$export$41eb0a358b69a9df);
$parcel$export(module.exports, "parseUrl", () => $a6ec6f63f1398335$export$7a5253c0f62e0150);

var $78Ywx = parcelRequire("78Ywx");

var $1d3eD = parcelRequire("1d3eD");

var $iednx = parcelRequire("iednx");

var $lWF3P = parcelRequire("lWF3P");

var $2UirS = parcelRequire("2UirS");

var $7aWIX = parcelRequire("7aWIX");

var $airGM = parcelRequire("airGM");
function $a6ec6f63f1398335$export$41eb0a358b69a9df(props) {
    let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, ...passThroughProps } = props;
    const parsedAllowedFeatures = $a6ec6f63f1398335$export$350c411f568eceb9(allowedFeatures);
    if (!url) return {
        contentId: contentId,
        hostname: hostname,
        parentProduct: parentProduct,
        spaceKey: spaceKey,
        protocol: 'https:',
        mode: mode !== null && mode !== void 0 ? mode : (0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        ...passThroughProps
    };
    const parsedProps = $a6ec6f63f1398335$export$7a5253c0f62e0150(url);
    if (!parsedProps) return {
        hostname: hostname,
        contentId: contentId,
        spaceKey: spaceKey,
        parentProduct: parentProduct,
        mode: mode,
        protocol: 'https:',
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        ...passThroughProps
    };
    const themeStateParsedObject = parsedProps.themeState ? (0, $iednx.themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
    // If the props are explicity passed in along with URL, those passed-in props will be overriding the URL-extract props.
    contentId = contentId || parsedProps.contentId;
    parentProduct = parentProduct || parsedProps.parentProduct;
    hostname = hostname || parsedProps.hostname || window.location.hostname;
    spaceKey = spaceKey || parsedProps.spaceKey;
    draftShareId = draftShareId || parsedProps.draftShareId;
    hash = hash || parsedProps.hash;
    themeState = themeState || themeStateParsedObject;
    let modeFromUrl;
    switch(parsedProps.route){
        case (0, $airGM.VIEW_PAGE).name:
        case (0, $airGM.VIEW_BLOG).name:
        case (0, $airGM.VIEW_BLOG_DATE_LEGACY).name:
            modeFromUrl = (0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
            break;
        case (0, $airGM.EDIT_PAGE_EMBED).name:
        case (0, $airGM.EDIT_PAGE_V2).name:
            modeFromUrl = (0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
    }
    return {
        allowedFeatures: $a6ec6f63f1398335$export$350c411f568eceb9(allowedFeatures),
        contentId: contentId,
        draftShareId: draftShareId,
        hash: hash,
        hostname: hostname,
        mode: mode || modeFromUrl,
        parentProduct: parentProduct,
        protocol: parsedProps.protocol,
        spaceKey: spaceKey,
        themeState: themeState,
        ...passThroughProps
    };
}
function $a6ec6f63f1398335$export$7a5253c0f62e0150(url) {
    if (!url) return null;
    const matchedRoute = $a6ec6f63f1398335$var$findAndMatchRoute((0, $lWF3P.namedRoutes), url);
    if (!matchedRoute) return null;
    const { routeName: routeName, ...match } = matchedRoute;
    return {
        route: routeName,
        hostname: match.host,
        protocol: match.protocol,
        contentId: match.params.contentId || '',
        spaceKey: match.params.spaceKey || '',
        hash: match.hash,
        // EP currently supports only 1 parent product, no more than 1 parent product should be passed in
        parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
        draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
        themeState: match.query.themeState
    };
}
function $a6ec6f63f1398335$var$findAndMatchRoute(routes, url) {
    for (const routeName of Object.keys(routes)){
        const pattern = routes[routeName].pattern;
        const match = $a6ec6f63f1398335$var$matchUrl(pattern, url);
        if (match) return {
            routeName: routeName,
            ...match
        };
    }
}
function $a6ec6f63f1398335$var$matchUrl(pattern, url) {
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($78Ywx))).parse(url, true);
    const pathname = parsed.pathname || '';
    let match = (0, $1d3eD.default)(pathname, {
        path: pattern,
        exact: true
    });
    // some of our routes need query params to match
    if (!match) match = (0, $1d3eD.default)(`${pathname}${parsed.search}`, {
        path: pattern,
        exact: true
    });
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match && match.params) for (const [key, value] of Object.entries(match.params))decodedParams[key] = value;
    return {
        url: url,
        protocol: (parsed === null || parsed === void 0 ? void 0 : parsed.protocol) || 'https:',
        host: (parsed === null || parsed === void 0 ? void 0 : parsed.host) || '',
        pathname: pathname,
        search: parsed.search || '',
        hash: parsed.hash || '',
        pattern: pattern,
        params: decodedParams,
        query: parsed.query || ''
    };
}
function $a6ec6f63f1398335$export$350c411f568eceb9(allowedFeatures) {
    let parsedAllowedFeatures = {
        view: allowedFeatures === null || allowedFeatures === void 0 ? void 0 : allowedFeatures.view,
        edit: allowedFeatures === null || allowedFeatures === void 0 ? void 0 : allowedFeatures.edit
    };
    if (!(allowedFeatures !== null && allowedFeatures !== void 0 && allowedFeatures.view)) parsedAllowedFeatures.view = [
        ...(0, $2UirS.DEFAULT_ALLOWED_FEATURES).view,
        'edit'
    ];
    else if (Array.isArray(allowedFeatures === null || allowedFeatures === void 0 ? void 0 : allowedFeatures.view)) parsedAllowedFeatures.view = [
        ...allowedFeatures === null || allowedFeatures === void 0 ? void 0 : allowedFeatures.view,
        'edit'
    ];
    return parsedAllowedFeatures;
}

});
parcelRegister("lWF3P", function(module, exports) {

$parcel$export(module.exports, "namedRoutes", () => $ff9edd9002414ffc$export$d4971375353d0454);
$parcel$export(module.exports, "EMBEDDED_PARENT_PRODUCTS", () => $ff9edd9002414ffc$export$5c59aa0922e65f1a);

var $airGM = parcelRequire("airGM");

var $kOuXf = parcelRequire("kOuXf");

var $7aWIX = parcelRequire("7aWIX");

var $98kGC = parcelRequire("98kGC");

var $1PfWo = parcelRequire("1PfWo");

var $ckNTf = parcelRequire("ckNTf");

var $5Xnsi = parcelRequire("5Xnsi");

var $kWeDu = parcelRequire("kWeDu");

var $ahuUa = parcelRequire("ahuUa");
const $ff9edd9002414ffc$export$d4971375353d0454 = $airGM;
const $ff9edd9002414ffc$export$5c59aa0922e65f1a = {
    JSM_PORTAL: 'JSM-Portal',
    JSM: 'JSM'
};

});
parcelRegister("airGM", function(module, exports) {

$parcel$export(module.exports, "EDIT_PAGE_EMBED", () => $77f1104885700104$export$e63a462ee45b57cf);
$parcel$export(module.exports, "EDIT_PAGE_V2", () => $77f1104885700104$export$7b1285e36c635f1f);
$parcel$export(module.exports, "SPACE_OVERVIEW", () => $77f1104885700104$export$65b723bb995d4fb6);
$parcel$export(module.exports, "VIEW_PAGE", () => $77f1104885700104$export$9257b5b55c8e2555);
$parcel$export(module.exports, "VIEW_BLOG", () => $77f1104885700104$export$91f49e7b30a9d34);
$parcel$export(module.exports, "VIEW_BLOG_DATE_LEGACY", () => $77f1104885700104$export$bd2c9bb170b3681d);
const $77f1104885700104$export$e63a462ee45b57cf = {
    name: 'EDIT_PAGE_EMBED',
    pattern: '/wiki/spaces/:spaceKey/:contentType(pages)/edit-embed/:contentId(\\d+)/:contentSlug?'
};
const $77f1104885700104$export$7b1285e36c635f1f = {
    name: 'EDIT_PAGE_V2',
    pattern: '/wiki/spaces/:spaceKey/:contentType(pages)/edit-v2/:contentId(\\d+)/:contentSlug?'
};
const $77f1104885700104$export$65b723bb995d4fb6 = {
    name: 'SPACE_OVERVIEW',
    pattern: '/wiki/spaces/:spaceKey/overview'
};
const $77f1104885700104$export$9257b5b55c8e2555 = {
    name: 'VIEW_PAGE',
    pattern: '/wiki/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?'
};
const $77f1104885700104$export$91f49e7b30a9d34 = {
    name: 'VIEW_BLOG',
    pattern: '/wiki/spaces/:spaceKey/blog/:contentId(\\d+)/:contentSlug?'
};
const $77f1104885700104$export$bd2c9bb170b3681d = {
    name: 'VIEW_BLOG_DATE_LEGACY',
    pattern: '/wiki/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?'
};

});

parcelRegister("kOuXf", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $f2707d1a4aec2a39$export$a06f1c675e846f6f);

var $exJuA = parcelRequire("exJuA");

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $5VUtK = parcelRequire("5VUtK");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $cM7F5 = parcelRequire("cM7F5");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2707d1a4aec2a39$var$Container = (0, $exJuA.default).div({
    fontSize: 12,
    height: 52,
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N300)})`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderTop: `2px solid ${`var(--ds-border, ${(0, $PdmhA.N30A)})`}`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2707d1a4aec2a39$var$ContentWrapper = (0, $exJuA.default).div({
    height: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2707d1a4aec2a39$var$LogoWrapper = (0, $exJuA.default).div({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: `0px 0px 0px ${"var(--ds-space-100, 8px)"}`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2707d1a4aec2a39$var$Link = (0, $exJuA.default).a({
    '&, &:focus, &:active, &:hover': {
        color: 'inherit',
        outline: 'none',
        boxShadow: 'none',
        textDecoration: 'none'
    }
});
const $f2707d1a4aec2a39$export$a06f1c675e846f6f = ({ url: url, linkTooltip: linkTooltip, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f2707d1a4aec2a39$var$Container, {
        "data-testid": "footer-container"
    }, url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f2707d1a4aec2a39$var$ContentAction, {
        tooltipText: linkTooltip,
        href: url
    }, ({ isHovered: isHovered })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f2707d1a4aec2a39$var$Content, {
            isHovered: isHovered,
            label: label
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f2707d1a4aec2a39$var$Content, {
        label: label
    }));
const $f2707d1a4aec2a39$var$Content = ({ isHovered: isHovered, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f2707d1a4aec2a39$var$ContentWrapper, null, label, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f2707d1a4aec2a39$var$LogoWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5VUtK.ConfluenceLogo), {
        appearance: isHovered ? 'brand' : 'neutral',
        size: "xsmall"
    })));
const $f2707d1a4aec2a39$var$ContentAction = ({ children: children, tooltipText: tooltipText, href: href })=>{
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'confluenceFooter',
            source: 'embeddedConfluenceViewPageScreen',
            eventType: 'ui'
        }).fire((0, $cM7F5.ANALYTICS_CHANNEL));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f2707d1a4aec2a39$var$Link, {
        href: href,
        target: "_blank",
        onMouseEnter: ()=>{
            setIsHovered(true);
        },
        onMouseLeave: ()=>{
            setIsHovered(false);
        },
        onClick: handleClick,
        "data-testid": "link"
    }, children({
        isHovered: isHovered
    })));
};

});
parcelRegister("5VUtK", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLogo", () => $451e1620f53f3b0a$export$1b2e4fe6ef471556);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $tkrFt = parcelRequire("tkrFt");

var $XHGTv = parcelRequire("XHGTv");

var $4q38b = parcelRequire("4q38b");

var $kbZ06 = parcelRequire("kbZ06");

var $gcXsZ = parcelRequire("gcXsZ");

var $gbb5b = parcelRequire("gbb5b");
const $451e1620f53f3b0a$var$svg = ({ appearance: appearance, iconGradientStart: iconGradientStart, iconGradientStop: iconGradientStop, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor
    };
    if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.brand-refresh-update-product-logos_q7coo')) {
        // Currently the user can style the confluence icon using only iconGradientStop and iconGradientStart
        // the following is used to mimic this edge case as these two props aren't used on the new logos
        if (colors.iconColor === 'inherit') colors.iconColor = iconGradientStop;
        if (appearance) colors = (0, $gcXsZ.getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 180 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098"/>
      <path fill="${colors.textColor}" d="M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227"/>
    </svg>
    `;
    } else {
        // Will be fixed upon removal of deprecated iconGradientStart and
        // iconGradientStop props, or with React 18's useId() hook when we update.
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        let id = (0, $tkrFt.uid)({
            iconGradientStart: iconGradientStop
        });
        if (appearance) colors = (0, $gcXsZ.getColorsFromAppearanceOldLogos)(appearance);
        return `<svg viewBox="0 0 158 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
    <defs>
      <linearGradient x1="99.140087%" y1="112.745465%" x2="33.8589812%" y2="37.7675389%" id="${id}-1">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
      <linearGradient x1="14.1838118%" y1="5.80047897%" x2="61.141783%" y2="70.9663868%" id="${id}-2">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g stroke="none" stroke-width="1" fill-rule="nonzero">
      <path fill="${colors.textColor}" fill-rule="evenodd" d="M45.312,20.984 C44.064,21.608 42.66,22.024 40.866,22.024 C36.81,22.024 34.34,19.424 34.34,15.498 C34.34,11.572 36.732,8.92 40.736,8.92 C42.712,8.92 44.064,9.336 45.286,10.116 L45.286,7.854 C44.064,6.97 42.4,6.658 40.736,6.658 C35.172,6.658 32,10.298 32,15.498 C32,20.88 35.172,24.26 40.788,24.26 C42.556,24.26 44.246,23.948 45.312,23.246 L45.312,20.984 Z M53.918,24.26 C50.018,24.26 47.73,21.374 47.73,17.474 C47.73,13.574 50.018,10.74 53.918,10.74 C57.792,10.74 60.054,13.574 60.054,17.474 C60.054,21.374 57.792,24.26 53.918,24.26 Z M53.918,12.82 C51.136,12.82 49.914,15.004 49.914,17.474 C49.914,19.944 51.136,22.18 53.918,22.18 C56.674,22.18 57.87,19.944 57.87,17.474 C57.87,15.004 56.674,12.82 53.918,12.82 Z M73.704,16.382 C73.704,12.794 71.988,10.74 68.998,10.74 C67.256,10.74 65.722,11.598 64.89,13.132 L64.89,11 L62.654,11 L62.654,24 L64.89,24 L64.89,16.772 C64.89,14.146 66.32,12.768 68.4,12.768 C70.532,12.768 71.468,13.808 71.468,16.148 L71.468,24 L73.704,24 L73.704,16.382 Z M79.918,9.622 C79.918,8.452 80.594,7.646 81.972,7.646 C82.492,7.646 82.986,7.698 83.376,7.776 L83.376,5.722 C82.986,5.618 82.544,5.514 81.868,5.514 C79.086,5.514 77.734,7.152 77.734,9.57 L77.734,11 L75.628,11 L75.628,13.08 L77.734,13.08 L77.734,24 L79.918,24 L79.918,13.08 L83.272,13.08 L83.272,11 L79.918,11 L79.918,9.622 Z M90.318,23.974 L90.318,21.972 C90.058,21.998 89.902,21.998 89.668,21.998 C88.706,21.998 87.926,21.582 87.926,20.412 L87.926,5.566 L85.69,5.566 L85.69,20.672 C85.69,23.064 87.042,24.078 89.174,24.078 C89.746,24.078 90.136,24.026 90.318,23.974 Z M92.216,18.618 C92.216,22.206 93.932,24.26 96.922,24.26 C98.664,24.26 100.198,23.402 101.03,21.868 L101.03,24 L103.266,24 L103.266,11 L101.03,11 L101.03,18.228 C101.03,20.854 99.6,22.232 97.52,22.232 C95.388,22.232 94.452,21.192 94.452,18.852 L94.452,11 L92.216,11 L92.216,18.618 Z M116.89,23.48 C115.824,24.052 114.186,24.26 112.86,24.26 C107.998,24.26 105.866,21.452 105.866,17.474 C105.866,13.548 108.05,10.74 112.002,10.74 C116.006,10.74 117.618,13.522 117.618,17.474 L117.618,18.488 L108.128,18.488 C108.44,20.698 109.87,22.128 112.938,22.128 C114.446,22.128 115.72,21.842 116.89,21.426 L116.89,23.48 Z M111.898,12.768 C109.532,12.768 108.336,14.302 108.102,16.564 L115.356,16.564 C115.226,14.146 114.134,12.768 111.898,12.768 Z M131.32,16.382 C131.32,12.794 129.604,10.74 126.614,10.74 C124.872,10.74 123.338,11.598 122.506,13.132 L122.506,11 L120.27,11 L120.27,24 L122.506,24 L122.506,16.772 C122.506,14.146 123.936,12.768 126.016,12.768 C128.148,12.768 129.084,13.808 129.084,16.148 L129.084,24 L131.32,24 L131.32,16.382 Z M143.618,21.66 C142.812,21.946 141.98,22.128 140.654,22.128 C137.248,22.128 135.844,19.996 135.844,17.474 C135.844,14.952 137.222,12.82 140.602,12.82 C141.824,12.82 142.708,13.054 143.54,13.444 L143.54,11.364 C142.526,10.896 141.616,10.74 140.446,10.74 C135.818,10.74 133.66,13.548 133.66,17.474 C133.66,21.452 135.818,24.26 140.446,24.26 C141.642,24.26 142.838,24.078 143.618,23.662 L143.618,21.66 Z M156.41,23.48 C155.344,24.052 153.706,24.26 152.38,24.26 C147.518,24.26 145.386,21.452 145.386,17.474 C145.386,13.548 147.57,10.74 151.522,10.74 C155.526,10.74 157.138,13.522 157.138,17.474 L157.138,18.488 L147.648,18.488 C147.96,20.698 149.39,22.128 152.458,22.128 C153.966,22.128 155.24,21.842 156.41,21.426 L156.41,23.48 Z M151.418,12.768 C149.052,12.768 147.856,14.302 147.622,16.564 L154.876,16.564 C154.746,14.146 153.654,12.768 151.418,12.768 Z"></path>
      <path fill="url(#${id}-1)" d="M0.85465057,21.7022581 C0.61090057,22.0783871 0.33715057,22.5148387 0.10465057,22.8625806 C-0.10345498,23.195346 0.00826440879,23.6245091 0.35590057,23.8277419 L5.23090057,26.6664516 C5.40202309,26.7664253 5.60840847,26.7971801 5.80372052,26.7518112 C5.99903257,26.7064423 6.16690583,26.5887513 6.26965057,26.4251613 C6.46465057,26.1164516 6.71590057,25.7154839 6.98965057,25.286129 C8.92090057,22.27 10.8634006,22.6390323 14.3659006,24.2216129 L19.1996506,26.3967742 C19.3827218,26.4792261 19.5932727,26.4880304 19.7833166,26.4211804 C19.9733605,26.3543303 20.1267047,26.2175221 20.2084006,26.0419355 L22.5296506,21.0741935 C22.6936507,20.7193919 22.5267777,20.3056906 22.1546506,20.1445161 C21.1346506,19.6903226 19.1059006,18.7854839 17.2796506,17.9516129 C10.7096506,14.9354839 5.12590057,15.1341935 0.85465057,21.7022581 Z"></path>
      <path fill="url(#${id}-2)" d="M22.7130274,10.4325806 C22.9567774,10.0564516 23.2305274,9.62 23.4630274,9.27225806 C23.6711329,8.93949274 23.5594135,8.51032964 23.2117774,8.30709677 L18.3367774,5.4683871 C18.1633186,5.35902032 17.9495842,5.32289142 17.7468362,5.36866556 C17.5440883,5.4144397 17.3706168,5.53798759 17.2680274,5.70967742 C17.0730274,6.0183871 16.8217774,6.41935484 16.5480274,6.84870968 C14.6167774,9.86483871 12.6742774,9.49580645 9.17177736,7.91322581 L4.35302736,5.7416129 C4.16995613,5.65916098 3.95940527,5.65035674 3.76936133,5.71720675 C3.5793174,5.78405675 3.42597321,5.92086501 3.34427736,6.09645161 L1.02302736,11.0641935 C0.85902727,11.4189952 1.02590019,11.8326965 1.39802736,11.993871 C2.41802736,12.4480645 4.44677736,13.3529032 6.27302736,14.1867742 C12.8580274,17.1993548 18.4417774,17.0006452 22.7130274,10.4325806 Z"></path>
    </g>
  </svg>`;
    }
};
const $451e1620f53f3b0a$export$1b2e4fe6ef471556 = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $kbZ06.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kbZ06.defaultLogoParams).iconColor, iconGradientStart: iconGradientStart = (0, $kbZ06.defaultLogoParams).iconGradientStart, iconGradientStop: iconGradientStop = (0, $kbZ06.defaultLogoParams).iconGradientStop, textColor: textColor = (0, $kbZ06.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gbb5b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        svg: $451e1620f53f3b0a$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("cM7F5", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $0266733ebe31eb79$export$85183a312807388d);

var $amwsa = parcelRequire("amwsa");
const $0266733ebe31eb79$export$85183a312807388d = 'embeddedConfluence';

});
parcelRegister("amwsa", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", () => $78b521fc1daa8c05$export$e955abb82869dc84);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $dyOUT = parcelRequire("dyOUT");

var $iax1c = parcelRequire("iax1c");

var $cM7F5 = parcelRequire("cM7F5");
const $78b521fc1daa8c05$export$e955abb82869dc84 = (experienceTracker)=>{
    const unsubscribeRef = (0, $eUqFw.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    if (!unsubscribeRef.current && experienceTracker) unsubscribeRef.current = experienceTracker.subscribe((event)=>{
        if (event.name.startsWith((0, $dyOUT.EXPERIENCE_NAME_PREFIX))) // Fire the analytic event to dedicated ANALYTICS_CHANNEL channel for EP analytics.
        createAnalyticsEvent((0, $iax1c.createExperienceTrackerAnalyticsEventPayload)(event)).fire((0, $cM7F5.ANALYTICS_CHANNEL));
    });
    (0, $eUqFw.useEffect)(()=>unsubscribeRef.current, []);
};

});
parcelRegister("dyOUT", function(module, exports) {

$parcel$export(module.exports, "EXPERIENCE_NAME_PREFIX", () => $9df5f256601a53be$export$b9fadc635fed6276);
$parcel$export(module.exports, "ExperienceNames", () => $9df5f256601a53be$export$312b1a9f1141bdaa);
$parcel$export(module.exports, "ExperienceReasons", () => $9df5f256601a53be$export$db5add30a8721c38);
const $9df5f256601a53be$export$b9fadc635fed6276 = 'embedded-confluence/';
let $9df5f256601a53be$export$312b1a9f1141bdaa = /*#__PURE__*/ function(ExperienceNames) {
    ExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
    ExperienceNames["CC_VIEW_PAGE"] = "view-page";
    ExperienceNames["EDIT_PAGE"] = "embedded-confluence/edit-page";
    ExperienceNames["CC_EDIT_PAGE_EMBED"] = "edit-page-embed";
    ExperienceNames["WHITEBOARD"] = "embedded-confluence/whiteboard";
    ExperienceNames["CC_WHITEBOARD"] = "whiteboard-page";
    ExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
    ExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
    ExperienceNames["PAGE_NOT_FOUND"] = "not-found";
    return ExperienceNames;
}({});
let $9df5f256601a53be$export$db5add30a8721c38 = /*#__PURE__*/ function(ExperienceReasons) {
    ExperienceReasons["UNABLE_TO_DISPLAY_CONTENT"] = "Unable to display page content";
    ExperienceReasons["STORAGE_ACCESS_ERROR"] = "Error when obtaining Storage access";
    ExperienceReasons["STORAGE_ACCESS_NOT_SUPPORTED"] = "Storage access API is not supported";
    ExperienceReasons["STORAGE_ACCESS_REJECTED"] = "Storage access is rejected";
    return ExperienceReasons;
}({});

});

parcelRegister("iax1c", function(module, exports) {

$parcel$export(module.exports, "createExperienceTrackerAnalyticsEventPayload", () => $d3a2c5ef69af3a75$export$9c05e7ef9f2c8895);
const $d3a2c5ef69af3a75$export$9c05e7ef9f2c8895 = (event)=>({
        // Events should match the schema defined here:
        // https://hello.atlassian.net/wiki/spaces/BIZOPS/pages/387788554/Analytics+Event+Schema+for+SLA
        source: 'ui',
        actionSubject: 'ui',
        action: event.action,
        eventType: 'operational',
        attributes: $d3a2c5ef69af3a75$var$createExperienceTrackerAnalyticsAttributes(event)
    });
function $d3a2c5ef69af3a75$var$createExperienceTrackerAnalyticsAttributes(event) {
    const { action: action, name: name, id: id, attributes: experienceAttributes, ...rest } = event;
    const attributes = {
        ...experienceAttributes,
        ...rest,
        task: name,
        taskId: id
    };
    if (attributes.error) {
        let error;
        if (typeof attributes.error === 'string') error = new Error(attributes.error);
        else error = attributes.error;
        delete attributes.error;
        attributes.errorName = error.name;
        if (!attributes.traceId && error.traceId) attributes.traceId = error.traceId;
        attributes.errorMessage = error.message;
    }
    attributes.browserInfo = window.navigator.userAgent;
    // Matches the analytics-web-client's apdex event
    attributes.isActiveTab = document.visibilityState === 'visible';
    return attributes;
}

});




parcelRegister("98kGC", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_CONTENT_TYPE", () => $6a64e84be8df5601$export$942a5fac9b8c9dc2);
let $6a64e84be8df5601$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});

});

parcelRegister("1PfWo", function(module, exports) {

$parcel$export(module.exports, "TemplateType", () => $1546eb655c502653$export$fd0446c06165ed92);
let $1546eb655c502653$export$fd0446c06165ed92 = /*#__PURE__*/ function(TemplateType) {
    TemplateType["RETRO"] = "simple-retrospective";
    return TemplateType;
}({});

});

parcelRegister("ckNTf", function(module, exports) {

$parcel$export(module.exports, "useFooter", () => $8fae0d6f8c1b49d0$export$d07da6ac6fc160b0);

var $eUqFw = parcelRequire("eUqFw");

var $dyOUT = parcelRequire("dyOUT");

var $lWF3P = parcelRequire("lWF3P");
const $8fae0d6f8c1b49d0$export$d07da6ac6fc160b0 = ({ experienceTracker: experienceTracker, hasFooter: hasFooter, hasFooterLogo: hasFooterLogo, parentProduct: parentProduct, standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const [footerUrl, setFooterUrl] = (0, $eUqFw.useState)(standaloneConfluenceUrl);
    (0, $eUqFw.useEffect)(()=>{
        setFooterUrl(standaloneConfluenceUrl);
    }, [
        standaloneConfluenceUrl
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = experienceTracker.subscribe((event)=>{
            const { name: name, action: action } = event;
            if (name === (0, $dyOUT.ExperienceNames).PAGE_NOT_FOUND && action === 'taskStart') setFooterUrl(standaloneConfluenceUrl ? `${new URL(standaloneConfluenceUrl).origin}/wiki/home` : standaloneConfluenceUrl);
        });
        return ()=>unsubscribe();
    }, [
        experienceTracker,
        standaloneConfluenceUrl
    ]);
    /**
   * Currently footer is hidden for the JSM Portal view which passes
   * hasFooterLogo prop as false and shown for all other views
   *
   * JSM portal view will provide "JSM-Portal" as the parent product eventually
   * However, team is still testing this product type for Atlassian and anonymous users so the "JSM-Portal" parentProduct is being feature-flagged
   * We need to support these two parent product keys to keep backward compatibile for the time being.
   *
   * Clean-up task in backlog: https://hello.atlassian.net/browse/CBT-1278 to remove "JSM" from the logic
   */ const showFooter = (0, $eUqFw.useMemo)(()=>!!hasFooter && !((parentProduct === (0, $lWF3P.EMBEDDED_PARENT_PRODUCTS).JSM_PORTAL || parentProduct === (0, $lWF3P.EMBEDDED_PARENT_PRODUCTS).JSM) && !hasFooterLogo), [
        parentProduct,
        hasFooterLogo,
        hasFooter
    ]);
    return {
        showFooter: showFooter,
        footerUrl: footerUrl
    };
};

});

parcelRegister("5Xnsi", function(module, exports) {

$parcel$export(module.exports, "useUrl", () => $4564a82e1ef13687$export$305222dff575c4e3);

var $eUqFw = parcelRequire("eUqFw");

var $iednx = parcelRequire("iednx");

var $98kGC = parcelRequire("98kGC");
var $7aWIX = parcelRequire("7aWIX");

var $2UirS = parcelRequire("2UirS");

var $5JgJ2 = parcelRequire("5JgJ2");
const $4564a82e1ef13687$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $iednx.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $4564a82e1ef13687$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, protocol: protocol, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $eUqFw.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $eUqFw.useMemo)(()=>allowedFeatures === 'all' ? (0, $2UirS.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    .filter((feature)=>feature !== 'edit').join('.') : features;
    const { locale: locale } = (0, $5JgJ2.default)();
    const queryParams = (0, $eUqFw.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $4564a82e1ef13687$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        return `?${new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery,
            ...contentConfiguration === null || contentConfiguration === void 0 ? void 0 : contentConfiguration.queryParams
        }).toString()}`;
    }, [
        contentConfiguration,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            ...$4564a82e1ef13687$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams
    ]);
};
const $4564a82e1ef13687$var$CONTEXT_PATH = '/wiki/spaces';
const $4564a82e1ef13687$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $4564a82e1ef13687$var$constructUrl(mode = (0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams }) {
    var _contentTypeUrl$conte;
    if (!contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $4564a82e1ef13687$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $4564a82e1ef13687$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$4564a82e1ef13687$var$CONTEXT_PATH}`;
    let base;
    const pageUrl = {
        [(0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $98kGC.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $98kGC.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $98kGC.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = (_contentTypeUrl$conte = contentTypeUrl[contentType]) === null || _contentTypeUrl$conte === void 0 ? void 0 : _contentTypeUrl$conte[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $4564a82e1ef13687$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}

});
parcelRegister("2UirS", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ALLOWED_FEATURES", () => $21df1f446c0a6a54$export$a33327ada3a6ee4a);
$parcel$export(module.exports, "getAllowedFeatures", () => $21df1f446c0a6a54$export$3207c60940c4a9b0);

var $98kGC = parcelRequire("98kGC");
var $7aWIX = parcelRequire("7aWIX");
let $21df1f446c0a6a54$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $21df1f446c0a6a54$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        'template-browser',
        'inline-comments'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $21df1f446c0a6a54$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $21df1f446c0a6a54$var$pageAllowedFeatures = {
    [(0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $21df1f446c0a6a54$export$a3fda3dcee62e1cc.edit,
    [(0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $21df1f446c0a6a54$export$a3fda3dcee62e1cc.view
};
const $21df1f446c0a6a54$var$blogPostAllowedFeatures = {
    [(0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $21df1f446c0a6a54$export$a3fda3dcee62e1cc.edit,
    [(0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $21df1f446c0a6a54$export$a3fda3dcee62e1cc.view
};
const $21df1f446c0a6a54$var$whiteboardAllowedFeatures = {
    [(0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $21df1f446c0a6a54$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $21df1f446c0a6a54$export$a3fda3dcee62e1cc.whiteboard
};
const $21df1f446c0a6a54$var$contentTypeAllowedFeatures = {
    [(0, $98kGC.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $21df1f446c0a6a54$var$pageAllowedFeatures,
    [(0, $98kGC.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $21df1f446c0a6a54$var$blogPostAllowedFeatures,
    [(0, $98kGC.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $21df1f446c0a6a54$var$whiteboardAllowedFeatures
};
const $21df1f446c0a6a54$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $7aWIX.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>{
    var _contentTypeAllowedFe, _contentTypeAllowedFe2;
    return (_contentTypeAllowedFe = (_contentTypeAllowedFe2 = $21df1f446c0a6a54$var$contentTypeAllowedFeatures[contentType]) === null || _contentTypeAllowedFe2 === void 0 ? void 0 : _contentTypeAllowedFe2[mode]) !== null && _contentTypeAllowedFe !== void 0 ? _contentTypeAllowedFe : [];
};

});


parcelRegister("kWeDu", function(module, exports) {

$parcel$export(module.exports, "useContentSize", () => $f3e493d042b89585$export$7e7123f55b1139c9);

var $eUqFw = parcelRequire("eUqFw");
const $f3e493d042b89585$var$MESSAGE_TYPE = 'contentSize';
const $f3e493d042b89585$export$7e7123f55b1139c9 = (isHeightSetFromContent)=>{
    // The initial height is arbitrarily set to 1000
    const [height, setHeight] = (0, $eUqFw.useState)(1000);
    (0, $eUqFw.useEffect)(()=>{
        if (!isHeightSetFromContent) return;
        const contentSizeHandler = (postMessage)=>{
            const data = postMessage.data;
            if (data.type === $f3e493d042b89585$var$MESSAGE_TYPE && data.height) setHeight(data.height);
        };
        window.addEventListener('message', contentSizeHandler);
        return ()=>{
            window.removeEventListener('message', contentSizeHandler);
        };
    }, [
        isHeightSetFromContent
    ]);
    return {
        height: height
    };
};

});

parcelRegister("ahuUa", function(module, exports) {

$parcel$export(module.exports, "PageLoadValidation", () => $77c377027e154749$export$3b0759108d92fe77);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $eBcad = parcelRequire("eBcad");

var $iLsDN = parcelRequire("iLsDN");

var $jBSQ0 = parcelRequire("jBSQ0");

var $5Xnsi = parcelRequire("5Xnsi");

var $kJg0O = parcelRequire("kJg0O");
const $77c377027e154749$var$noop = ()=>{};
const $77c377027e154749$export$3b0759108d92fe77 = (props)=>{
    const { standaloneConfluenceUrl: standaloneConfluenceUrl, embeddedConfluenceUrl: embeddedConfluenceUrl } = (0, $5Xnsi.useUrl)(props);
    const isEmbeddedUrlOnSameDomain = embeddedConfluenceUrl ? window.location.origin === new URL(embeddedConfluenceUrl).origin : false;
    return isEmbeddedUrlOnSameDomain ? props.children({
        handleIframeOnLoad: $77c377027e154749$var$noop,
        handleContentLoadStarted: $77c377027e154749$var$noop,
        handleIframeUnload: $77c377027e154749$var$noop,
        navigationPolicy: props.navigationPolicy
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($77c377027e154749$var$CrossDomainErrorValidation, (0, $kU09D.default)({
        key: embeddedConfluenceUrl || props.contentId,
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl,
        allowedFeatures: props.allowedFeatures
    }, props));
};
const $77c377027e154749$var$CrossDomainErrorValidation = ({ allowedFeatures: allowedFeatures, children: children, contentId: contentId, embeddedConfluenceUrl: embeddedConfluenceUrl, navigationPolicy: navigationPolicy, parentProduct: parentProduct, spaceKey: spaceKey, standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const { state: state, dispatch: dispatch } = (0, $kJg0O.useValidationState)();
    const { iframeLoaded: iframeLoaded, contentLoadStarted: contentLoadStarted, shouldAskStorageAccess: shouldAskStorageAccess, shouldAskToLogin: shouldAskToLogin, redirectedToLogin: redirectedToLogin, iframeUnloaded: iframeUnloaded } = state;
    const isLoginFlowDisabled = (0, $eUqFw.useMemo)(()=>{
        var _allowedFeatures$incl;
        return (_allowedFeatures$incl = allowedFeatures === null || allowedFeatures === void 0 ? void 0 : allowedFeatures.includes('disable-login-flow')) !== null && _allowedFeatures$incl !== void 0 ? _allowedFeatures$incl : false;
    }, [
        allowedFeatures
    ]);
    const reloadEP = (0, $eUqFw.useCallback)(()=>{
        dispatch({
            subject: (0, $kJg0O.Subjects).CONTENT_LOAD,
            status: (0, $kJg0O.LoadingStatus).RELOAD_EP
        });
    }, [
        dispatch
    ]);
    const failToLoad = (0, $eUqFw.useMemo)(()=>iframeLoaded && !contentLoadStarted || /*
  If anonymous access is permitted globally but restricted on a content's parent space,
  the iframe will attempt a login redirect which we intercept.
  To avoid an error in the iframe, we need to wait for the iframe window to unload
  before unmouting the Iframe component.
  */ iframeUnloaded && redirectedToLogin, [
        contentLoadStarted,
        iframeLoaded,
        iframeUnloaded,
        redirectedToLogin
    ]);
    const pageNavigationPolicy = (0, $eUqFw.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                // modifiy the navigationPolicy to intercept login redirects
                // so that login can be handled outside of the iframe
                if (url.includes('/login?application=confluence')) {
                    dispatch({
                        subject: (0, $kJg0O.Subjects).CONTENT_LOAD,
                        status: (0, $kJg0O.LoadingStatus).REDIRECTED_TO_LOGIN
                    });
                    return;
                }
                return navigationPolicy !== null && navigationPolicy !== void 0 && navigationPolicy.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy === null || navigationPolicy === void 0 ? void 0 : navigationPolicy.shimUrl,
            domainNamesToReplace: navigationPolicy === null || navigationPolicy === void 0 ? void 0 : navigationPolicy.domainNamesToReplace
        }), [
        navigationPolicy,
        dispatch
    ]);
    const handleIframeOnLoad = (0, $eUqFw.useCallback)(()=>{
        dispatch({
            subject: (0, $kJg0O.Subjects).CONTENT_LOAD,
            status: (0, $kJg0O.LoadingStatus).IFRAME_LOADED
        });
    }, [
        dispatch
    ]);
    const handleContentLoadStarted = (0, $eUqFw.useCallback)(()=>{
        dispatch({
            subject: (0, $kJg0O.Subjects).CONTENT_LOAD,
            status: (0, $kJg0O.LoadingStatus).CONTENT_LOAD_STARTED
        });
    }, [
        dispatch
    ]);
    const handleIframeUnload = (0, $eUqFw.useCallback)(()=>{
        dispatch({
            subject: (0, $kJg0O.Subjects).CONTENT_LOAD,
            status: (0, $kJg0O.LoadingStatus).IFRAME_UNLOADED
        });
    }, [
        dispatch
    ]);
    if (!failToLoad) return children({
        handleIframeOnLoad: handleIframeOnLoad,
        handleContentLoadStarted: handleContentLoadStarted,
        handleIframeUnload: handleIframeUnload,
        navigationPolicy: pageNavigationPolicy,
        redirectedToLogin: redirectedToLogin
    });
    if (!isLoginFlowDisabled) {
        if (shouldAskStorageAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jBSQ0.StorageAccessPage), {
            url: embeddedConfluenceUrl,
            contentId: contentId,
            spaceKey: spaceKey,
            parentProduct: parentProduct
        });
        if (shouldAskToLogin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLsDN.LoginPage), {
            contentId: contentId,
            reloadEP: reloadEP,
            spaceKey: spaceKey,
            url: embeddedConfluenceUrl
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eBcad.ErrorScreen), {
        standaloneConfluenceUrl: standaloneConfluenceUrl
    });
};

});
parcelRegister("eBcad", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", () => $aa0df4d6d82882cf$export$42f84e610f279c31);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $exJuA = parcelRequire("exJuA");

var $bbaTG = parcelRequire("bbaTG");

var $5VUtK = parcelRequire("5VUtK");

var $23NQ5 = parcelRequire("23NQ5");

var $7dprT = parcelRequire("7dprT");
var $1xrmr = parcelRequire("1xrmr");

var $dyOUT = parcelRequire("dyOUT");

var $dDhJG = parcelRequire("dDhJG");

var $fAOvT = parcelRequire("fAOvT");
const $aa0df4d6d82882cf$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES = 'https://support.atlassian.com/atlassian-account/docs/login-issues-related-to-browser-cookies/';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa0df4d6d82882cf$var$Container = (0, $exJuA.default).div({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    fontSize: 'medium',
    height: '500px',
    justifyContent: 'space-around',
    margin: 'auto',
    position: 'relative',
    textAlign: 'center'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa0df4d6d82882cf$var$StyledLoginPageIconSVG = (0, $exJuA.default)((0, $dDhJG.LoginToConfluenceIcon))({
    '&&': {
        marginTop: "var(--ds-space-300, 24px)"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa0df4d6d82882cf$var$ParagraphLogin = (0, $exJuA.default).p({
    '': {
        fontSize: 'x-large',
        marginTop: "var(--ds-space-300, 24px)"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa0df4d6d82882cf$var$ButtonLoginToConfluenceNewTab = (0, $exJuA.default)((0, $bbaTG.default))({
    '&&': {
        fontWeight: 500,
        marginTop: "var(--ds-space-300, 24px)",
        marginBottom: "var(--ds-space-150, 12px)"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa0df4d6d82882cf$var$StyledParagraph = (0, $exJuA.default).p({
    '': {
        marginTop: "var(--ds-space-150, 12px)"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa0df4d6d82882cf$var$StyledLink = (0, $exJuA.default).a({
    '': {
        display: 'block'
    }
});
const $aa0df4d6d82882cf$export$42f84e610f279c31 = ({ standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const experienceTracker = (0, $eUqFw.useContext)((0, $1xrmr.ExperienceTrackerContext));
    const experience = (0, $eUqFw.useContext)((0, $7dprT.ExperienceContext));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        experienceTracker.abort({
            name: experience,
            reason: (0, $dyOUT.ExperienceReasons).UNABLE_TO_DISPLAY_CONTENT
        });
    }, [
        experience,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa0df4d6d82882cf$var$Container, {
        "data-testid": "error-screen-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5VUtK.ConfluenceLogo), {
        appearance: "brand",
        size: "xlarge"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa0df4d6d82882cf$var$StyledLoginPageIconSVG, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa0df4d6d82882cf$var$ParagraphLogin, null, formatMessage((0, $fAOvT.default).paragraphLogin)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa0df4d6d82882cf$var$ButtonLoginToConfluenceNewTab, {
        appearance: "primary",
        "aria-label": formatMessage((0, $fAOvT.default).buttonLoginToConfluenceNewTab),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
            label: "",
            size: "medium"
        }),
        href: standaloneConfluenceUrl !== null && standaloneConfluenceUrl !== void 0 ? standaloneConfluenceUrl : '',
        target: "_blank"
    }, formatMessage((0, $fAOvT.default).buttonLoginToConfluenceNewTab)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa0df4d6d82882cf$var$StyledParagraph, null, formatMessage((0, $fAOvT.default).paragraphAlreadyLoggedIn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa0df4d6d82882cf$var$StyledParagraph, null, formatMessage((0, $fAOvT.default).paragraphStillHavingTrouble, {
        link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa0df4d6d82882cf$var$StyledLink, {
            href: $aa0df4d6d82882cf$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES,
            target: "_blank",
            "aria-label": formatMessage((0, $fAOvT.default).linkAriaLabel)
        }, formatMessage((0, $fAOvT.default).linkTroubleshootingText))
    })));
};

});
parcelRegister("7dprT", function(module, exports) {

$parcel$export(module.exports, "ExperienceContext", () => $1955547f7acc0a54$export$fb99266658f5da06);

var $eUqFw = parcelRequire("eUqFw");
const $1955547f7acc0a54$var$defaultExperienceContextValue = undefined;
const $1955547f7acc0a54$export$fb99266658f5da06 = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($1955547f7acc0a54$var$defaultExperienceContextValue);

});

parcelRegister("dDhJG", function(module, exports) {

$parcel$export(module.exports, "LoginToConfluenceIcon", () => $9eccacd831341b62$export$ae31f6824db63a1c);

var $eUqFw = parcelRequire("eUqFw");
const $9eccacd831341b62$export$ae31f6824db63a1c = ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        width: "148",
        height: "160",
        viewBox: "0 0 148 160",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_499_12980)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "147.652",
        height: "160",
        transform: "translate(0.174194)",
        fill: "var(--ds-icon-inverse, white)",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M90.3627 138.196C90.4862 138.281 90.9631 138.59 91.4435 138.436C91.6734 138.36 91.8243 138.206 92.0268 137.993C92.2944 137.715 92.4625 137.437 92.562 137.245L93.557 137.465C93.6325 137.482 93.7183 137.455 93.7594 137.386C93.8246 137.283 93.78 137.153 93.6737 137.108L92.7438 136.734C92.6718 136.707 92.5929 136.703 92.5208 136.731L91.6253 137.046L90.3558 137.52L90.3627 138.196Z",
        fill: "var(--ds-icon-accent-yellow, #72594B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M93.2825 137.273L93.7526 137.492C93.8384 137.534 93.8864 137.63 93.8624 137.722C93.8384 137.825 93.7354 137.894 93.6291 137.873L92.411 137.647L91.6974 138.004L91.7969 137.427L92.5414 137.084L93.2825 137.273Z",
        fill: "var(--ds-icon-accent-yellow, #72594B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M93.7457 138.22C93.708 138.312 93.6051 138.357 93.5124 138.326C93.2757 138.22 93.0355 138.11 92.7988 138.004C92.4419 137.99 92.0851 137.973 91.7283 137.959L91.8175 137.578L92.9223 137.582L93.66 137.973C93.7457 138.021 93.7835 138.127 93.7457 138.22Z",
        fill: "var(--ds-icon-accent-yellow, #72594B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M93.1281 138.642C93.0767 138.697 92.9943 138.7 92.936 138.655L92.4247 138.257C92.2257 138.209 92.0302 138.161 91.8312 138.113C91.8655 138.014 91.9032 137.911 91.9375 137.811C92.1949 137.87 92.4556 137.931 92.713 137.99L93.1281 138.45C93.1796 138.504 93.1796 138.59 93.1281 138.642Z",
        fill: "var(--ds-icon-accent-yellow, #72594B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.7",
        d: "M132.434 20.5211L60.2655 23.3826V136.799L132.434 139.664V44.1953V20.5211Z",
        fill: "url(#paint0_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M147.826 44.9982H121.774V46.1167H147.826V44.9982Z",
        fill: "url(#paint1_linear_499_12980)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M147.826 47.9763H121.774V49.0948H147.826V47.9763Z",
        fill: "url(#paint2_linear_499_12980)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M141.564 50.951H121.774V52.0696H141.564V50.951Z",
        fill: "url(#paint3_linear_499_12980)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M82.238 0H56.186V1.11852H82.238V0Z",
        fill: "url(#paint4_linear_499_12980)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M82.238 2.97815H56.186V4.09667H82.238V2.97815Z",
        fill: "url(#paint5_linear_499_12980)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M75.9763 5.95288H56.186V7.0714H75.9763V5.95288Z",
        fill: "url(#paint6_linear_499_12980)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.7",
        d: "M138.058 26.0039L65.889 22.6929V136.11L138.058 132.799V47.2249V26.0039Z",
        fill: "url(#paint7_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M139.286 108.401L118.151 103.576C117.746 103.484 117.485 103.052 117.571 102.609L122.052 79.5694C122.138 79.1268 122.536 78.8455 122.94 78.9381L144.076 83.7622C144.481 83.8548 144.741 84.2871 144.656 84.7297L140.175 107.769C140.089 108.208 139.691 108.493 139.286 108.401Z",
        fill: "url(#paint8_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M119.791 101.72L123.75 81.3536L142.436 85.6149L138.476 105.985L119.791 101.72Z",
        fill: "var(--ds-icon-inverse, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M122.813 97.2153L128.169 93.4069L131.652 99.2328L122.813 97.2153Z",
        fill: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M125.912 97.9221L132.866 92.978L137.389 100.54L125.912 97.9221Z",
        fill: "var(--ds-background-accent-blue-subtlest, #CCE0FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M130.421 88.2318C130.435 87.3034 129.754 86.5407 128.902 86.5283C128.049 86.5158 127.347 87.2583 127.333 88.1868C127.32 89.1152 128 89.8779 128.853 89.8903C129.705 89.9028 130.407 89.1603 130.421 88.2318Z",
        fill: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M46.2531 49.0468L28.5798 55.9261C28.2401 56.0564 27.8421 55.8712 27.6878 55.5109L19.6248 36.6264C19.4704 36.2627 19.6179 35.8647 19.9576 35.7309L37.6309 28.8517C37.9706 28.7213 38.3686 28.9066 38.523 29.2668L46.586 48.1513C46.7404 48.515 46.5928 48.9164 46.2531 49.0468Z",
        fill: "url(#paint9_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M28.8577 53.7782L21.728 37.0862L37.353 31.0029L44.4827 47.6984L28.8577 53.7782Z",
        fill: "var(--ds-background-accent-yellow-subtlest, #FFFAE5)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M35.4488 43.9346H31.2698V48.1136H35.4488V43.9346Z",
        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M34.8141 35.8716L33.4142 40.6099L38.7254 38.7983L34.8141 35.8716Z",
        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M29.6298 42.0365C30.4614 41.1853 30.4147 39.7911 29.5256 38.9225C28.6364 38.0538 27.2415 38.0397 26.4099 38.8909C25.5783 39.7421 25.625 41.1363 26.5141 42.005C27.4033 42.8736 28.7982 42.8878 29.6298 42.0365Z",
        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.7",
        d: "M124.872 12.64L49.6259 22.6929V136.11L124.872 146.163V39.1722V12.64Z",
        fill: "url(#paint10_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M94.0374 10.6705L42.3109 22.6929V136.11L117.557 153.292V34.6295L94.0374 10.6705Z",
        fill: "url(#paint11_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M79.1715 90.5898L79.1198 91.8823L109.851 93.1125L109.903 91.82L79.1715 90.5898Z",
        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M47.6972 89.3282L47.6455 90.6207L79.1207 91.8807L79.1725 90.5882L47.6972 89.3282Z",
        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M47.704 92.8613L47.6342 94.1528L109.838 97.5169L109.908 96.2253L47.704 92.8613Z",
        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M71.0629 97.9737L70.9751 99.2642L109.831 101.909L109.919 100.618L71.0629 97.9737Z",
        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M47.7211 96.3936L47.6332 97.6841L70.9859 99.2758L71.0739 97.9853L47.7211 96.3936Z",
        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M47.723 99.9274L47.6171 101.216L94.2916 105.052L94.3976 103.763L47.723 99.9274Z",
        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M42.3109 91.2761L60.2759 95.7056C61.4664 96.0006 62.7291 95.8257 63.7961 95.2184C64.8632 94.6111 66.1224 94.4395 67.3164 94.7312L67.7899 94.8478L67.8791 94.4807L69.7078 94.9302C69.9514 94.9919 70.1813 94.786 70.147 94.5356L70.0098 93.4754C69.9892 93.3279 69.8828 93.2078 69.7387 93.1735L68.2839 92.8166L68.3594 92.5147L67.7178 92.3569C66.6267 92.0892 65.6661 91.4442 65.0004 90.5384L64.9181 90.4286C64.2525 89.5228 63.2918 88.8812 62.2007 88.6102L45.2033 84.4209L42.9148 83.8547C42.9148 83.8547 42.9148 83.8547 42.9148 83.8582L42.3109 83.7106V91.2761Z",
        fill: "var(--ds-background-accent-gray-subtle, #6C798F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M75.5989 27.5788L47.6736 32.9175V28.5326L75.5989 22.7067V27.5788Z",
        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M84.4022 32.8103L47.093 38.827L47.2989 40.1039L84.6082 34.0873L84.4022 32.8103Z",
        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M84.4182 36.8671L47.1039 42.3507L47.292 43.6305L84.6063 38.1469L84.4182 36.8671Z",
        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M75.6704 42.0758L47.1106 45.8759L47.2812 47.1582L75.8411 43.3581L75.6704 42.0758Z",
        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M60.7905 75.4418V84.1979L47.6702 83.9851V75.6614L60.7905 75.4418Z",
        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
        strokeWidth: "3.1142",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M60.7905 66.6859V75.4419L47.6702 75.6615V67.3412L60.7905 66.6859Z",
        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
        strokeWidth: "3.1142",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M60.7905 57.9298V66.6858L47.6702 67.3412V59.0209L60.7905 57.9298Z",
        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
        strokeWidth: "3.1142",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M60.7905 49.1772V57.9298L47.6702 59.0209V50.7006L60.7905 49.1772Z",
        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
        strokeWidth: "3.1142",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M75.3519 47.4857V56.7221L60.7905 57.9298V49.1772L75.3519 47.4857Z",
        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
        strokeWidth: "3.1142",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M91.6115 45.5986V55.3737L75.3518 56.7221V47.4857L91.6115 45.5986Z",
        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
        strokeWidth: "3.1142",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M109.878 43.4748V53.8571L91.6116 55.3737V45.5986L109.878 43.4748Z",
        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
        strokeWidth: "3.1142",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M109.879 53.8571V84.9939L60.7905 84.1979V57.9298L109.879 53.8571Z",
        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
        strokeWidth: "3.1142",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M109.879 74.6116L91.6116 74.9204L75.3519 75.1948L60.7905 75.4419",
        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
        strokeWidth: "3.1142",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M109.879 64.2326L91.6116 65.1453L75.3519 65.9584L60.7905 66.6858",
        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
        strokeWidth: "3.1142",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M91.6116 84.6954V74.9203V65.1453V55.3737",
        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
        strokeWidth: "3.1142",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M75.3518 84.4312V75.1948V65.9584V56.722",
        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
        strokeWidth: "3.1142",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M94.0374 10.6705L101.28 46.024L117.557 34.6295L94.0374 10.6705Z",
        fill: "url(#paint12_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M53.8528 13.7208L47.2858 15.1858C46.4829 15.3642 45.8345 16.3043 45.8345 17.2822V23.6262C45.8345 24.604 46.4864 25.2525 47.2858 25.0741L48.9087 24.7138L50.1267 26.5288C50.3429 26.8514 50.7958 26.7519 51.0119 26.3298L52.2299 23.9727L53.8528 23.6125C54.6557 23.434 55.3042 22.4939 55.3042 21.5161V15.1687C55.3042 14.1908 54.6557 13.5423 53.8528 13.7208Z",
        fill: "url(#paint13_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M53.1976 13.8683L46.6305 15.3333C45.8277 15.5117 45.1792 16.4518 45.1792 17.4297V23.7737C45.1792 24.7516 45.8311 25.4 46.6305 25.2216L48.2534 24.8613L49.4714 26.6764C49.6876 26.9989 50.1405 26.8994 50.3566 26.4774L51.5747 24.1202L53.1976 23.76C54.0004 23.5816 54.6489 22.6415 54.6489 21.6636V15.3127C54.6523 14.3349 54.0004 13.6864 53.1976 13.8683Z",
        fill: "url(#paint14_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M105.302 76.9652L98.5595 77.4181C97.7361 77.473 97.067 78.3102 97.067 79.2881V85.6321C97.067 86.6099 97.7361 87.3579 98.5595 87.303L100.224 87.1898L101.476 89.1901C101.699 89.5469 102.162 89.516 102.385 89.1283L103.637 86.9599L105.302 86.8467C106.125 86.7918 106.794 85.9546 106.794 84.9767V78.6327C106.794 77.6583 106.125 76.9103 105.302 76.9652Z",
        fill: "url(#paint15_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M104.632 77.0099L97.8904 77.4628C97.067 77.5177 96.3979 78.3548 96.3979 79.3327V85.6767C96.3979 86.6545 97.067 87.4025 97.8904 87.3476L99.5545 87.2344L100.807 89.2347C101.03 89.5915 101.493 89.5606 101.716 89.1729L102.968 87.0045L104.632 86.8913C105.456 86.8364 106.125 85.9992 106.125 85.0214V78.6773C106.122 77.7029 105.456 76.955 104.632 77.0099Z",
        fill: "url(#paint16_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M94.1334 142.388L113.55 146.139V119.318L94.1334 117.369V142.388Z",
        fill: "var(--ds-background-accent-gray-subtle, #6C798F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M48.1231 128.537L63.8029 131.564C64.1461 131.629 64.4617 131.368 64.4617 131.018V107.313C64.4617 107.028 64.2456 106.788 63.9608 106.76L48.2809 105.189C47.9549 105.155 47.6702 105.412 47.6702 105.741V127.992C47.6736 128.259 47.8623 128.486 48.1231 128.537ZM49.1078 106.942L63.0275 108.339V123.501V129.728L58.1314 128.784L49.5641 127.131L49.1078 127.041V106.942Z",
        fill: "var(--ds-icon-inverse, #FAFBFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M66.4312 132.071L84.7392 135.605C85.0823 135.67 85.398 135.41 85.398 135.06V109.413C85.398 109.128 85.1818 108.888 84.8971 108.86L66.589 107.025C66.2631 106.99 65.9783 107.248 65.9783 107.577V131.526C65.9817 131.793 66.1704 132.02 66.4312 132.071ZM67.4159 118.766V108.781L83.9638 110.442V121.332V133.773L69.2103 130.925L67.4159 130.579V118.766Z",
        fill: "var(--ds-icon-inverse, #FAFBFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M54.92 121.349L59.6514 127.141L63.0275 123.501V108.339L49.1078 106.942V127.041L49.5641 127.131L54.92 121.349Z",
        fill: "var(--ds-icon-inverse, #FAFBFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M54.92 121.349L59.6514 127.141L63.0275 123.501V108.339L49.1078 106.942V127.041L49.5641 127.131L54.92 121.349Z",
        fill: "url(#paint17_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M73.8628 125.902L81.219 117.966L83.9638 121.325V110.439L67.4159 108.778V118.766L67.7453 118.409L73.8628 125.902Z",
        fill: "var(--ds-icon-inverse, #FAFBFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M73.8628 125.902L81.219 117.966L83.9638 121.325V110.439L67.4159 108.778V118.766L67.7453 118.409L73.8628 125.902Z",
        fill: "url(#paint18_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M49.5641 127.131L58.1314 128.784L49.5641 127.131Z",
        fill: "var(--ds-icon, #253858)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M59.6514 127.141L54.92 121.349L49.5641 127.131L58.1314 128.784L59.6514 127.141Z",
        fill: "var(--ds-icon, #253858)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M69.2103 130.922L67.4159 130.575L69.2103 130.922Z",
        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M73.8628 125.902L67.7453 118.409L67.4159 118.766V130.575L69.2103 130.922L73.8628 125.902Z",
        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M58.1315 128.784L63.0276 129.728L58.1315 128.784Z",
        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M58.1315 128.784L63.0276 129.728V123.501L59.6514 127.141L58.1315 128.784Z",
        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M69.2103 130.922L83.9638 133.77L69.2103 130.922Z",
        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M73.8628 125.902L69.2103 130.922L83.9638 133.77V121.325L81.219 117.966L73.8628 125.902Z",
        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M87.3125 129.824C87.4464 129.8 87.9404 129.694 88.1429 129.292C88.2389 129.1 88.2355 128.908 88.2286 128.644C88.2218 128.301 88.1497 128.023 88.0914 127.837L88.8565 127.343C88.9148 127.306 88.9492 127.234 88.9354 127.165C88.9114 127.059 88.8016 127.007 88.7056 127.045L87.8855 127.398C87.8238 127.426 87.7723 127.474 87.7449 127.535L87.3812 128.301L86.8837 129.398L87.3125 129.824Z",
        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M88.5614 127.402L88.9937 127.244C89.0726 127.213 89.1653 127.247 89.2099 127.319C89.2613 127.402 89.2373 127.508 89.1584 127.559L88.2492 128.187L88.0262 128.863L87.7277 128.438L87.9781 127.755L88.5614 127.402Z",
        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M89.45 127.704C89.4843 127.786 89.45 127.879 89.3711 127.92C89.1549 128.002 88.9354 128.084 88.7192 128.167C88.4859 128.383 88.2526 128.599 88.0193 128.815L87.834 128.52L88.5305 127.827L89.2407 127.604C89.3265 127.58 89.4191 127.621 89.45 127.704Z",
        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M89.3333 128.359C89.3368 128.424 89.2887 128.479 89.2235 128.489L88.6505 128.561C88.4962 128.654 88.3418 128.75 88.1874 128.846C88.1462 128.76 88.105 128.675 88.0638 128.589C88.2628 128.462 88.4653 128.338 88.6643 128.211L89.2167 128.239C89.2784 128.239 89.3299 128.294 89.3333 128.359Z",
        fill: "var(--ds-icon-accent-yellow, #72594B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M78.4398 136.71C79.7779 136.213 81.2052 135.739 82.7183 135.31C83.2536 135.159 83.7785 135.019 84.3001 134.888C84.5848 134.247 84.825 133.728 84.9863 133.379C85.4597 132.363 85.7171 131.872 86.3106 130.63C86.568 130.088 86.7738 129.649 86.9042 129.368C87.1581 129.491 87.412 129.615 87.6659 129.738C87.4841 130.96 87.1238 132.486 86.393 134.126C86.0602 134.878 85.6965 135.544 85.3397 136.123C84.8524 136.47 83.3634 137.509 81.9772 138.031C81.7233 138.127 81.3322 138.257 80.8278 138.288C80.399 138.316 79.8568 138.347 79.3422 138.031C78.6079 137.578 78.4604 136.83 78.4398 136.71Z",
        fill: "url(#paint19_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M91.0009 111.708L86.5851 136.686C86.5062 137.132 86.7979 137.561 87.2439 137.647L107.563 141.637C108.019 141.726 108.461 141.424 108.54 140.965L113.296 114.069C113.382 113.592 113.042 113.146 112.558 113.098L91.9033 111.025C91.471 110.981 91.0764 111.279 91.0009 111.708ZM107.298 139.867L106.598 139.729L88.1188 136.099L89.4501 128.565L92.2498 112.727L111.748 114.683L107.298 139.867Z",
        fill: "var(--ds-icon-inverse, #FAFBFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M89.4535 128.568L93.2414 134.363L99.4584 128.808L106.598 139.733L107.298 139.87L111.752 114.69L92.2532 112.734L89.4535 128.568ZM102.231 117.918C103.397 117.918 104.149 118.996 103.915 120.323C103.682 121.651 102.546 122.729 101.38 122.729C100.213 122.729 99.4619 121.651 99.6952 120.323C99.9285 118.996 101.064 117.918 102.231 117.918Z",
        fill: "var(--ds-icon-inverse, #FAFBFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M89.4535 128.568L93.2414 134.363L99.4584 128.808L106.598 139.733L107.298 139.87L111.752 114.69L92.2532 112.734L89.4535 128.568ZM102.231 117.918C103.397 117.918 104.149 118.996 103.915 120.323C103.682 121.651 102.546 122.729 101.38 122.729C100.213 122.729 99.4619 121.651 99.6952 120.323C99.9285 118.996 101.064 117.918 102.231 117.918Z",
        fill: "url(#paint20_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M106.598 139.729L88.1222 136.103L106.598 139.729Z",
        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M93.2413 134.36L89.4534 128.568L88.1222 136.103L106.598 139.729L99.4584 128.805L93.2413 134.36Z",
        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
        fill: "var(--ds-icon-inverse, #FAFBFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
        fill: "url(#paint21_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
        fill: "url(#paint22_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M28.1132 148.904C43.5435 148.904 56.0522 147.858 56.0522 146.567C56.0522 145.277 43.5435 144.231 28.1132 144.231C12.6829 144.231 0.174194 145.277 0.174194 146.567C0.174194 147.858 12.6829 148.904 28.1132 148.904Z",
        fill: "url(#paint23_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M43.3951 146.149C43.1481 146.149 42.9147 145.998 42.8221 145.754L29.6435 111.015C29.5234 110.699 29.6812 110.346 30.0003 110.226C30.3159 110.106 30.6693 110.264 30.7894 110.579L43.9681 145.319C44.0882 145.634 43.9303 145.988 43.6112 146.108C43.5426 146.135 43.4671 146.149 43.3951 146.149Z",
        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M54.8514 146.149C54.6044 146.149 54.371 145.998 54.2784 145.754L41.0998 111.015C40.9797 110.699 41.1375 110.346 41.4566 110.226C41.7722 110.106 42.1256 110.264 42.2457 110.579L55.4244 145.319C55.5445 145.634 55.3866 145.988 55.0675 146.108C54.9989 146.135 54.9234 146.149 54.8514 146.149Z",
        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M43.3642 115.866H31.908C31.5717 115.866 31.2972 115.592 31.2972 115.256C31.2972 114.92 31.5717 114.645 31.908 114.645H43.3642C43.7005 114.645 43.975 114.92 43.975 115.256C43.975 115.592 43.7005 115.866 43.3642 115.866Z",
        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M45.265 120.879H33.8087C33.4725 120.879 33.198 120.605 33.198 120.269C33.198 119.932 33.4725 119.658 33.8087 119.658H45.265C45.6012 119.658 45.8757 119.932 45.8757 120.269C45.8757 120.605 45.6047 120.879 45.265 120.879Z",
        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M47.1659 125.892H35.7096C35.3734 125.892 35.0989 125.618 35.0989 125.281C35.0989 124.945 35.3734 124.671 35.7096 124.671H47.1659C47.5021 124.671 47.7766 124.945 47.7766 125.281C47.7766 125.618 47.5055 125.892 47.1659 125.892Z",
        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M49.07 130.905H37.6138C37.2775 130.905 37.0031 130.63 37.0031 130.294C37.0031 129.958 37.2775 129.683 37.6138 129.683H49.07C49.4063 129.683 49.6808 129.958 49.6808 130.294C49.6808 130.63 49.4063 130.905 49.07 130.905Z",
        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M50.9709 135.918H39.5147C39.1784 135.918 38.9039 135.643 38.9039 135.307C38.9039 134.971 39.1784 134.696 39.5147 134.696H50.9709C51.3072 134.696 51.5816 134.971 51.5816 135.307C51.5816 135.643 51.3072 135.918 50.9709 135.918Z",
        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M52.8717 140.927H41.4154C41.0792 140.927 40.8047 140.652 40.8047 140.316C40.8047 139.98 41.0792 139.705 41.4154 139.705H52.8717C53.2079 139.705 53.4824 139.98 53.4824 140.316C53.4824 140.652 53.2114 140.927 52.8717 140.927Z",
        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M24.5484 146.149C24.4763 146.149 24.4043 146.135 24.3322 146.108C24.0166 145.988 23.8587 145.634 23.9754 145.319L37.154 110.579C37.2741 110.264 37.6275 110.106 37.9432 110.226C38.2588 110.346 38.4167 110.699 38.3 111.015L25.1214 145.754C25.0253 145.998 24.7954 146.149 24.5484 146.149Z",
        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.0921 146.149C13.02 146.149 12.948 146.135 12.8759 146.108C12.5603 145.988 12.4024 145.634 12.5191 145.319L25.6978 110.579C25.8178 110.264 26.1712 110.106 26.4869 110.226C26.8026 110.346 26.9604 110.699 26.8437 111.015L13.6616 145.754C13.569 145.998 13.3391 146.149 13.0921 146.149Z",
        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M42.6025 111.283H25.5536C24.8091 111.283 24.2052 110.679 24.2052 109.934C24.2052 109.19 24.8091 108.586 25.5536 108.586H42.6025C43.347 108.586 43.9509 109.19 43.9509 109.934C43.9509 110.679 43.347 111.283 42.6025 111.283Z",
        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M42.6025 111.283H39.2915C38.547 111.283 37.9431 110.679 37.9431 109.934C37.9431 109.19 38.547 108.586 39.2915 108.586H42.6025C43.347 108.586 43.9509 109.19 43.9509 109.934C43.9509 110.679 43.347 111.283 42.6025 111.283Z",
        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M36.0355 115.866H24.5792C24.243 115.866 23.9685 115.592 23.9685 115.256C23.9685 114.92 24.243 114.645 24.5792 114.645H36.0355C36.3717 114.645 36.6462 114.92 36.6462 115.256C36.6462 115.592 36.3717 115.866 36.0355 115.866Z",
        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M34.1347 120.879H22.6785C22.3422 120.879 22.0677 120.605 22.0677 120.269C22.0677 119.932 22.3422 119.658 22.6785 119.658H34.1347C34.471 119.658 34.7455 119.932 34.7455 120.269C34.7455 120.605 34.471 120.879 34.1347 120.879Z",
        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M32.2339 125.892H20.7742C20.4379 125.892 20.1635 125.618 20.1635 125.281C20.1635 124.945 20.4379 124.671 20.7742 124.671H32.2304C32.5667 124.671 32.8412 124.945 32.8412 125.281C32.8412 125.618 32.5701 125.892 32.2339 125.892Z",
        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M30.3297 130.905H18.8734C18.5372 130.905 18.2627 130.63 18.2627 130.294C18.2627 129.958 18.5372 129.683 18.8734 129.683H30.3297C30.6659 129.683 30.9404 129.958 30.9404 130.294C30.9404 130.63 30.6694 130.905 30.3297 130.905Z",
        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M28.4288 135.918H16.9725C16.6363 135.918 16.3618 135.643 16.3618 135.307C16.3618 134.971 16.6363 134.696 16.9725 134.696H28.4288C28.765 134.696 29.0395 134.971 29.0395 135.307C29.0395 135.643 28.7685 135.918 28.4288 135.918Z",
        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M26.528 140.927H15.0718C14.7355 140.927 14.4611 140.652 14.4611 140.316C14.4611 139.98 14.7355 139.705 15.0718 139.705H26.528C26.8643 139.705 27.1388 139.98 27.1388 140.316C27.1388 140.652 26.8643 140.927 26.528 140.927Z",
        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M40.2832 79.2538C42.033 79.6003 43.7829 79.9503 45.5327 80.2968C47.5605 80.4787 49.5882 80.6571 51.616 80.8389C51.6125 81.1443 51.6057 81.4497 51.6022 81.755C49.8558 81.906 47.8967 81.9815 45.7626 81.9197C43.4158 81.8511 41.2851 81.6246 39.4152 81.3296C39.7034 80.6365 39.9916 79.9434 40.2832 79.2538Z",
        fill: "var(--ds-background-accent-teal-subtle, #00C7E5)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M67.5497 93.7637L67.9408 94.0553L69.3784 92.1339L68.8501 91.7394C67.9511 91.0669 67.3164 90.0993 67.0556 89.0048L67.0247 88.871C66.764 87.7765 66.1292 86.8124 65.2303 86.1365L30.6248 60.2492C29.0019 59.0346 26.6996 59.3674 25.4851 60.9903C24.2705 62.6132 24.6033 64.9154 26.2262 66.13L60.6876 91.9143C61.6723 92.6486 62.8972 92.9814 64.1186 92.8407C65.3401 92.6966 66.5684 93.0294 67.5497 93.7637Z",
        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M47.7216 82.2113C47.104 80.3311 46.4281 77.775 45.9066 75.8158C45.3679 73.7778 44.8979 72.052 44.4724 70.611L41.7825 68.5969C42.5579 70.7585 43.4294 74.0386 44.0298 76.3133C44.4278 77.8127 44.7778 79.1199 45.0969 80.2488L47.7216 82.2113Z",
        fill: "var(--ds-icon-brand, #0065FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31.8119 61.1344C34.9513 71.3349 36.6531 73.3455 38.3 73.1053C39.7754 72.8892 40.1631 70.9129 40.5748 68.8234C40.6297 68.5386 40.6983 68.1886 40.7772 67.8421L39.0857 66.576C38.9279 67.1387 38.8009 67.7769 38.6671 68.446C38.5196 69.2008 38.2588 70.5217 37.9878 71.057C37.552 70.6418 36.461 69.0636 34.495 63.1416L31.8119 61.1344Z",
        fill: "var(--ds-icon-brand, #0065FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M49.324 74.2376C49.1525 78.8249 48.8849 81.4257 48.6378 82.8941L50.3533 84.1774C50.7239 82.6094 51.019 79.9949 51.2145 75.6512L49.324 74.2376Z",
        fill: "var(--ds-icon-brand, #0065FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M70.2362 94.6901L70.5209 93.6608C70.5621 93.5201 70.5072 93.3657 70.3905 93.2765L69.1931 92.381L68.1672 93.75L69.6769 94.8788C69.8793 95.0332 70.1675 94.9337 70.2362 94.6901Z",
        fill: "var(--ds-icon-brand, #0065FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M29.1598 105.645C28.9573 105.711 28.6828 105.824 28.3946 106.023C28.103 106.218 27.8971 106.431 27.7599 106.596C27.8045 106.719 27.856 106.846 27.9143 106.973C28.2368 107.673 28.676 108.198 29.0774 108.572C29.5852 108.575 30.093 108.579 30.6008 108.582C30.6077 108.538 30.6077 108.493 30.6008 108.459C30.5356 108.068 29.846 107.92 29.8048 107.913C29.7327 107.759 29.6195 107.467 29.6229 107.083C29.6229 106.706 29.7362 106.417 29.8082 106.266C29.5921 106.061 29.3759 105.851 29.1598 105.645Z",
        fill: "var(--ds-icon, #344563)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M35.1091 84.3146C36.7729 84.3146 38.1216 82.9659 38.1216 81.3021C38.1216 79.6384 36.7729 78.2897 35.1091 78.2897C33.4454 78.2897 32.0967 79.6384 32.0967 81.3021C32.0967 82.9659 33.4454 84.3146 35.1091 84.3146Z",
        fill: "var(--ds-icon, #253858)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M36.0046 85.6938C37.0202 84.8429 39.3739 85.2409 40.0842 86.4521C40.8253 87.7147 39.7548 89.8145 38.4784 92.2814C38.125 92.9608 37.5863 93.9558 35.1572 97.8329C33.8088 99.9841 33.5309 100.382 32.68 101.768C31.4585 103.755 30.515 105.391 29.918 106.448C29.4822 106.242 29.0465 106.04 28.6073 105.834C29.242 104.348 29.7087 103.124 30.014 102.29C30.6591 100.526 30.9233 99.5758 31.6163 98.0696C32.0727 97.078 32.505 96.2992 32.7897 95.8085C33.0608 95.0057 33.3319 94.1891 33.596 93.3622C34.1107 91.753 34.591 90.1679 35.0337 88.6171C35.0028 88.2705 34.9993 87.6907 35.2224 87.0319C35.3047 86.778 35.538 86.0815 36.0046 85.6938Z",
        fill: "var(--ds-background-accent-teal-subtle, #00B8D9)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M38.523 106.716C38.4646 106.929 38.4098 107.155 38.3617 107.399C38.3 107.725 38.2588 108.033 38.2382 108.315C38.2279 108.459 38.3411 108.582 38.4852 108.582C39.5351 108.579 40.585 108.572 41.6349 108.569C41.6452 108.442 41.6349 108.274 41.532 108.15C41.4051 108.003 41.2163 108.013 40.9933 107.975C40.9933 107.975 40.3414 107.869 39.8233 107.361C39.6964 107.237 39.518 107.025 39.3842 106.685C39.096 106.695 38.8078 106.706 38.523 106.716Z",
        fill: "var(--ds-icon, #344563)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M37.902 84.4107C38.0015 84.3832 39.0857 84.1156 39.9538 84.7126C40.7258 85.241 41.086 86.2771 41.0345 90.1577C41.0071 92.0893 40.887 94.1823 40.5508 97.3217C40.2969 99.6822 40.1768 100.235 39.9881 102.334C39.8131 104.283 39.7273 105.882 39.6827 106.942C39.1612 106.973 38.6362 107.004 38.1147 107.032C37.7716 105.083 37.5452 103.436 37.3976 102.17C37.2432 100.869 37.1815 100.08 37.2913 99.1093C37.4217 97.9667 37.7682 96.8105 37.8025 96.6972C37.878 96.4502 37.9535 96.2203 38.0255 96.0145C37.9294 95.4895 37.7716 94.6729 37.5452 93.6779C37.2673 92.4393 37.0202 91.3482 36.6222 89.9792C35.9532 87.677 35.6787 87.4368 35.8434 86.682C36.0458 85.7659 36.7663 84.7092 37.902 84.4107Z",
        fill: "var(--ds-background-accent-teal-subtle, #00C7E5)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M41.2335 76.1109C41.3399 76.4231 41.5595 77.0613 41.2918 77.8161C41.2164 78.0289 40.9659 78.6396 40.3963 78.9518C40.3071 78.9999 40.1081 79.1096 39.8199 79.144C39.7273 79.1543 39.4253 79.192 39.2641 79.1028C38.6431 78.7665 39.3464 76.1212 40.2419 75.459C40.4684 75.2943 40.6228 75.3115 40.6605 75.3183C40.9796 75.3767 41.1374 75.8399 41.2335 76.1109Z",
        fill: "var(--ds-icon, #253858)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M35.1091 87.2653C35.4419 87.5226 36.7663 88.497 38.6706 88.3838C40.2866 88.2877 41.3674 87.4677 41.7276 87.1692C41.5904 86.9565 41.3948 86.6202 41.2404 86.1776C41.134 85.8654 40.7463 84.6302 41.1787 83.275C41.3845 82.6265 41.5869 82.5544 41.5972 82.0535C41.6007 81.827 41.5595 81.7241 41.261 80.6365C41.0414 79.8405 41.0345 79.789 40.9591 79.6861C40.887 79.5866 40.5439 79.1646 39.271 79.1028C37.854 79.0307 36.6325 79.5077 35.8468 79.9194C35.936 80.8801 36.0733 81.6521 36.183 82.1942C36.4267 83.3985 36.6428 83.9097 36.4061 84.6233C36.2928 84.963 36.1968 84.9905 35.8159 85.711C35.4728 86.356 35.2464 86.9016 35.1091 87.2653Z",
        fill: "var(--ds-background-accent-teal-subtle, #79E2F2)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M41.1684 77.106C41.1547 77.13 41.117 77.1574 41.0449 77.2158C40.9831 77.2638 40.9282 77.2981 40.8871 77.3221C40.8871 77.4285 40.8836 77.5417 40.8768 77.6584C40.8631 77.8848 40.8356 78.0907 40.8013 78.2794C40.6435 78.3206 40.4239 78.3686 40.1563 78.396C39.8818 78.4235 39.4666 78.4647 38.9794 78.348C38.7804 78.3 38.4888 78.2313 38.228 78.0495C37.6996 77.679 37.2364 76.7869 37.5864 75.9394C37.9501 75.0611 39.1167 74.6836 39.8372 74.9993C39.9298 75.0405 40.3999 75.2463 40.5954 75.6992C40.6812 75.8948 40.6366 75.9188 40.7739 76.2516C40.8082 76.3306 40.8493 76.4335 40.918 76.5639C41.0861 76.8727 41.2199 76.9996 41.1684 77.106Z",
        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M38.1216 77.4971C38.2074 77.6412 38.3515 77.9362 38.372 78.3377C38.3961 78.77 38.2657 79.0959 38.1936 79.2503C38.4853 79.4425 38.7838 79.6483 39.0857 79.8576C39.518 80.163 39.9297 80.4649 40.3243 80.7669C40.1493 80.3208 39.9778 79.8782 39.8028 79.4322C39.7994 79.2881 39.8062 79.1303 39.8199 78.9621C39.8405 78.7494 39.8714 78.5573 39.9092 78.3891C39.3122 78.0906 38.7186 77.7921 38.1216 77.4971Z",
        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M35.8777 69.9248C35.9772 69.8424 36.3409 69.5165 36.3238 69.0807C36.3135 68.8714 36.2174 68.7136 36.087 68.494C35.9155 68.2092 35.7233 68.0068 35.5861 67.8799L35.9944 67.101C36.0253 67.0393 36.0218 66.9638 35.9738 66.9157C35.9052 66.8368 35.7851 66.8471 35.7233 66.926L35.2018 67.6122C35.1606 67.6637 35.1435 67.7289 35.1469 67.7941L35.315 69.7738L35.8777 69.9248Z",
        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M35.7714 67.2897L36.0596 66.9501C36.1145 66.8883 36.2037 66.8711 36.2758 66.9089C36.3581 66.9535 36.389 67.053 36.3478 67.1353L35.8812 68.096L36.015 68.7719L35.5587 68.5592L35.442 67.8627L35.7714 67.2897Z",
        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M36.6669 67.1182C36.7321 67.1697 36.7492 67.2657 36.7012 67.3378C36.5571 67.5128 36.4164 67.6843 36.2723 67.8593C36.1797 68.1509 36.087 68.446 35.9944 68.7377L35.6993 68.5764L35.9532 67.6603L36.4473 67.1354C36.5022 67.0702 36.5983 67.0633 36.6669 67.1182Z",
        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M36.8762 67.7254C36.9105 67.7803 36.8968 67.849 36.8453 67.8867L36.3993 68.2229C36.3135 68.3773 36.2277 68.5283 36.1454 68.6827C36.0699 68.6312 35.9944 68.5763 35.9189 68.5249C36.0287 68.3224 36.1351 68.12 36.2449 67.921L36.7218 67.6808C36.7733 67.65 36.8453 67.6705 36.8762 67.7254Z",
        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M35.5587 68.9949C35.5072 68.9949 35.3116 69.3346 35.2773 69.29L34.7421 68.0651C34.6837 67.9896 34.6975 67.8833 34.7695 67.825C34.845 67.7666 34.9514 67.7804 35.0097 67.8524L35.6925 68.717C35.7508 68.7925 35.7371 68.8989 35.665 68.9572C35.6341 68.9847 35.5964 68.9949 35.5587 68.9949Z",
        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M40.0224 76.5982C39.8474 76.8143 39.7548 76.7079 39.5867 76.9001C39.2298 77.3015 39.5901 77.8162 39.2573 78.1867C39.0995 78.3651 38.9416 78.2416 38.8113 78.4132C38.6225 78.6671 38.9245 78.9518 38.8113 79.391C38.7255 79.7204 38.4407 80.0223 38.125 80.1081C37.7442 80.2145 37.5726 79.94 37.2879 80.0464C36.8796 80.2008 37.0546 80.8664 36.6531 81.2644C36.1247 81.7893 34.8964 81.8339 34.0936 81.182C33.2907 80.5301 33.2495 79.4596 33.4245 78.8009C33.5961 78.1456 34.0661 77.5794 34.5945 77.2706C35.14 76.9516 35.4694 77.0716 35.9944 76.6359C36.2311 76.4403 36.2551 76.4403 36.6806 75.785C36.8761 75.4796 37.2295 74.9375 37.7854 74.6287C38.4235 74.2753 39.0754 74.3645 39.3499 74.3989C39.693 74.4469 40.3484 74.5327 40.5714 74.9821C40.592 75.0233 40.7395 75.339 40.6091 75.5929C40.5679 75.6752 40.5268 75.6855 40.4479 75.7713C40.1631 76.0663 40.2489 76.3202 40.0224 76.5982Z",
        fill: "var(--ds-icon, #253858)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M38.1216 80.7943C37.7236 79.0548 37.3256 77.3152 36.9276 75.5757C36.6909 73.5548 36.4507 71.5339 36.2139 69.5096C35.9086 69.5233 35.6032 69.537 35.3013 69.5508C35.2018 71.3006 35.1812 73.2597 35.3047 75.3904C35.442 77.7338 35.7267 79.8576 36.0767 81.7207C36.756 81.4119 37.4388 81.1031 38.1216 80.7943Z",
        fill: "var(--ds-background-accent-teal-subtle, #79E2F2)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M72.9364 160C81.113 160 87.7414 159.161 87.7414 158.127C87.7414 157.092 81.113 156.253 72.9364 156.253C64.7599 156.253 58.1315 157.092 58.1315 158.127C58.1315 159.161 64.7599 160 72.9364 160Z",
        fill: "url(#paint24_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M77.5306 136.604C78.5198 136.604 79.3216 135.802 79.3216 134.813C79.3216 133.824 78.5198 133.022 77.5306 133.022C76.5415 133.022 75.7396 133.824 75.7396 134.813C75.7396 135.802 76.5415 136.604 77.5306 136.604Z",
        fill: "var(--ds-icon, #253858)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M69.2892 157.228C71.5571 157.444 74.9333 157.66 77.2012 157.876C77.3865 157.866 78.2271 157.794 78.7417 157.125C79.0848 156.682 79.1191 156.192 79.1397 155.872C79.1877 155.176 78.9613 154.534 78.8412 154.202C78.8103 154.112 78.7829 154.04 78.7623 153.992C77.9217 151.889 77.5237 151.144 77.0948 150.026C76.4086 148.235 76.6659 148.307 76.2096 147.384C75.7258 146.406 74.8509 145.229 73.1491 144.159C72.933 144.461 72.655 144.907 72.4011 145.483C72.209 145.919 71.9757 146.451 71.9105 147.137C71.8762 147.497 71.8796 147.981 72.1061 148.842C72.2193 149.275 72.583 150.537 73.6981 152.284C74.0858 152.891 74.645 153.68 75.4136 154.538C74.5524 154.332 73.6432 154.14 72.6859 153.972C71.9585 153.841 70.1401 153.735 69.4607 153.649C69.4024 154.84 69.3441 156.034 69.2892 157.228Z",
        fill: "url(#paint25_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M73.3208 143.932C73.0634 144.245 72.7272 144.715 72.4356 145.336C72.0582 146.145 71.5847 147.164 71.8969 148.348C71.9484 148.547 72.1679 149.71 73.2419 150.252C73.5644 150.414 73.8526 150.554 74.1957 150.681C74.1957 150.681 74.8716 150.928 75.6642 151.059C77.3179 151.333 79.7883 151.021 79.9496 151C79.4315 151.446 78.8894 151.951 78.3404 152.524C77.6062 153.285 76.9851 154.03 76.4636 154.723C77.5684 155.402 78.6732 156.082 79.778 156.765C80.5534 155.941 81.3597 155.015 82.1729 153.982C83.1164 152.781 83.9261 151.618 84.6158 150.527C84.6741 150.328 84.7908 149.844 84.6055 149.299C84.2727 148.324 83.2811 148.015 83.1747 147.984C81.9567 147.659 80.7387 147.333 79.5207 147.01C78.6183 146.773 77.7125 146.537 76.8101 146.3C76.1617 145.936 75.472 145.511 74.7618 145.017C74.2403 144.656 73.76 144.289 73.3208 143.932Z",
        fill: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M79.2805 143.325C78.8585 143.747 78.4433 144.166 78.0796 144.619C77.7434 145.041 77.3591 145.61 77.0263 146.358C76.3881 146.169 75.623 145.885 74.7995 145.449C74.0962 145.078 73.5129 144.68 73.0428 144.317C73.4752 143.562 73.7908 142.917 74.0035 142.443C74.4358 141.486 74.5422 141.061 74.9368 140.296C75.3211 139.544 75.7225 138.964 76.021 138.577C76.021 138.577 76.8513 137.345 77.4483 136.885C77.4689 136.868 77.86 136.569 77.86 136.569L79.6888 138.264C79.8535 138.415 79.9701 138.607 80.0319 138.824C80.0593 139.218 80.1245 139.829 80.3167 140.556C80.5019 141.27 80.6323 141.431 80.574 141.785C80.4951 142.234 80.2172 142.388 79.2805 143.325Z",
        fill: "url(#paint26_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M79.6201 138.748C79.6201 138.669 79.6098 138.57 79.5824 138.456C79.5481 138.319 79.5 138.209 79.4554 138.131C79.4486 137.829 79.4863 137.352 79.7299 136.851C79.8123 136.686 79.9015 136.545 79.9907 136.425L78.7315 135.626L77.86 136.569L78.2992 137.091C78.5805 137.427 78.8104 137.805 79.0231 138.185C79.0609 138.254 79.1089 138.323 79.1672 138.395C79.3285 138.59 79.5103 138.693 79.6201 138.748Z",
        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M82.8796 158.734C82.8796 158.734 82.6257 158.226 81.9258 157.962C81.2705 157.715 80.9033 158.013 80.0867 157.705C79.8603 157.619 79.3182 157.413 79.2873 157.053C79.2702 156.864 79.404 156.696 79.5069 156.596C78.9682 156.264 78.4295 155.931 77.8909 155.598C77.8909 155.598 77.4723 156.089 77.2458 157.077C77.016 158.065 77.1052 159.033 77.1052 159.033L82.8796 158.734Z",
        fill: "var(--ds-icon, #253858)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M69.4128 154.562C69.2 154.486 68.9015 154.407 68.5378 154.387C68.109 154.363 67.7556 154.428 67.5154 154.493C67.6286 155.643 67.7418 156.792 67.8585 157.941C67.8585 157.979 67.8516 158.24 68.0575 158.429C68.2153 158.573 68.3972 158.586 68.4486 158.59C68.9804 158.542 69.5123 158.49 70.0406 158.442C70.0029 158.37 69.9343 158.257 69.821 158.147C69.4574 157.794 69.0696 157.886 68.8981 157.574C68.8055 157.406 68.826 157.217 68.8363 157.152C68.8569 156.967 68.9393 156.84 69.0045 156.737C69.0628 156.648 69.1623 156.511 69.327 156.384C69.3579 155.776 69.3853 155.169 69.4128 154.562Z",
        fill: "var(--ds-icon, #253858)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M78.7624 135.694L80.2823 136.655C80.4916 136.786 80.7421 136.834 80.9857 136.782C81.195 136.738 81.3837 136.621 81.5209 136.456L82.0905 135.76L82.3066 135.918C82.389 135.979 82.5056 135.918 82.5022 135.815L82.4782 135.125L82.6017 134.758C82.7595 134.288 82.8144 133.787 82.7664 133.293C82.7012 132.641 82.3512 132.047 81.8126 131.673C81.2224 131.265 80.4745 131.162 79.7951 131.395L79.6613 131.443C79.5138 131.495 79.3765 131.577 79.2564 131.68C78.6148 132.253 78.3609 133.142 78.5977 133.969L78.7383 134.452L78.7624 135.694Z",
        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M90.3627 138.196C90.4862 138.282 90.9631 138.59 91.4435 138.436C91.6734 138.36 91.8243 138.206 92.0268 137.993C92.2944 137.715 92.4625 137.437 92.562 137.245L93.557 137.465C93.6325 137.482 93.7183 137.455 93.7594 137.386C93.8246 137.283 93.78 137.153 93.6737 137.108L92.7438 136.734C92.6718 136.707 92.5929 136.703 92.5208 136.731L91.6253 137.046L90.3558 137.52L90.3627 138.196Z",
        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M93.2825 137.273L93.7526 137.492C93.8384 137.534 93.8864 137.63 93.8624 137.722C93.8384 137.825 93.7354 137.894 93.6291 137.873L92.411 137.647L91.6974 138.004L91.7969 137.427L92.5414 137.084L93.2825 137.273Z",
        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M93.7457 138.22C93.708 138.312 93.6051 138.357 93.5124 138.326C93.2757 138.22 93.0355 138.11 92.7988 138.004C92.4419 137.99 92.0851 137.973 91.7283 137.959L91.8175 137.578L92.9223 137.582L93.66 137.973C93.7457 138.021 93.7835 138.127 93.7457 138.22Z",
        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M93.1281 138.642C93.0767 138.697 92.9943 138.7 92.936 138.655L92.4247 138.257C92.2257 138.209 92.0302 138.161 91.8312 138.113C91.8655 138.014 91.9032 137.911 91.9375 137.811C92.1949 137.87 92.4556 137.932 92.713 137.99L93.1281 138.45C93.1796 138.505 93.1796 138.59 93.1281 138.642Z",
        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M77.8566 136.58C79.3114 137.249 80.8176 138.01 82.3616 138.879C82.9071 139.184 83.4355 139.493 83.9502 139.801C84.6844 139.52 85.2883 139.301 85.6966 139.153C86.8803 138.728 87.4738 138.546 88.9355 138.031C89.5702 137.808 90.0849 137.623 90.4108 137.506C90.5137 137.805 90.6167 138.107 90.7196 138.405C89.6011 139.228 88.1017 140.148 86.2181 140.869C85.3569 141.198 84.5403 141.435 83.7923 141.61C83.4629 141.555 82.7939 141.435 82.0219 141.243C81.4283 141.095 80.5809 140.872 79.6133 140.443C78.9168 140.134 77.9527 139.623 76.9165 138.782C77.2253 138.048 77.541 137.314 77.8566 136.58Z",
        fill: "url(#paint27_linear_499_12980)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M78.2649 132.733C78.1757 133.317 78.4845 133.619 78.5908 134.799C78.6286 135.2 78.6251 135.533 78.6183 135.749C79.0677 135.458 79.3525 135.135 79.5138 134.919C79.6819 134.693 79.7986 134.538 79.8878 134.288C80.073 133.766 79.9427 133.368 80.2 133.217C80.224 133.204 80.3269 133.142 80.4196 133.18C80.6735 133.282 80.4127 133.948 80.7078 134.226C80.9994 134.5 81.6547 134.233 81.9944 134.096C82.3856 133.938 82.7767 133.78 82.9071 133.413C83.0512 133.011 82.7973 132.596 82.6841 132.408C82.1694 131.56 80.8141 130.665 79.5618 131.2C78.9579 131.454 78.3712 132.044 78.2649 132.733Z",
        fill: "var(--ds-icon, #253858)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M90.4519 33.2228L117.557 34.6295L94.0374 10.6705L90.4519 33.2228Z",
        fill: "url(#paint28_linear_499_12980)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint0_linear_499_12980",
        x1: "50.6701",
        y1: "127.204",
        x2: "144.895",
        y2: "32.9795",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.2415",
        stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFF)",
        stopOpacity: "0.7585"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.4317",
        stopColor: "var(--ds-background-accent-blue-bolder, #59A1FF)",
        stopOpacity: "0.5683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6043",
        stopColor: "var(--ds-background-accent-blue-subtle, #6AABFF)",
        stopOpacity: "0.3957"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.7666",
        stopColor: "var(--ds-background-accent-blue-subtle, #81B8FF)",
        stopOpacity: "0.2334"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9202",
        stopColor: "var(--ds-background-accent-blue-subtlest, #9FC9FF)",
        stopOpacity: "0.0798"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint1_linear_499_12980",
        x1: "121.776",
        y1: "45.5575",
        x2: "147.826",
        y2: "45.5575",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.208",
        stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
        stopOpacity: "0.792"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.3719",
        stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
        stopOpacity: "0.6281"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5207",
        stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
        stopOpacity: "0.4793"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6606",
        stopColor: "var(--ds-background-accent-blue-subtlest, #81B4F6)",
        stopOpacity: "0.3394"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.7942",
        stopColor: "var(--ds-background-accent-blue-subtlest, #A0C2F0)",
        stopOpacity: "0.2058"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9214",
        stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
        stopOpacity: "0.0786"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint2_linear_499_12980",
        x1: "121.776",
        y1: "48.5346",
        x2: "147.826",
        y2: "48.5346",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.208",
        stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
        stopOpacity: "0.792"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.3719",
        stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
        stopOpacity: "0.6281"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5207",
        stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
        stopOpacity: "0.4793"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6606",
        stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
        stopOpacity: "0.3394"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.7942",
        stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
        stopOpacity: "0.2058"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9214",
        stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
        stopOpacity: "0.0786"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint3_linear_499_12980",
        x1: "121.776",
        y1: "51.5113",
        x2: "141.565",
        y2: "51.5113",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.208",
        stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
        stopOpacity: "0.792"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.3719",
        stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
        stopOpacity: "0.6281"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5207",
        stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
        stopOpacity: "0.4793"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6606",
        stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
        stopOpacity: "0.3394"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.7942",
        stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
        stopOpacity: "0.2058"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9214",
        stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
        stopOpacity: "0.0786"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint4_linear_499_12980",
        x1: "56.1854",
        y1: "0.55854",
        x2: "82.2361",
        y2: "0.55854",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.208",
        stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
        stopOpacity: "0.792"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.3719",
        stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
        stopOpacity: "0.6281"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5207",
        stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
        stopOpacity: "0.4793"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6606",
        stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
        stopOpacity: "0.3394"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.7942",
        stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
        stopOpacity: "0.2058"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9214",
        stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
        stopOpacity: "0.0786"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint5_linear_499_12980",
        x1: "56.1854",
        y1: "3.53525",
        x2: "82.2361",
        y2: "3.53525",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.208",
        stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
        stopOpacity: "0.792"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.3719",
        stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
        stopOpacity: "0.6281"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5207",
        stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
        stopOpacity: "0.4793"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6606",
        stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
        stopOpacity: "0.3394"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.7942",
        stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
        stopOpacity: "0.2058"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9214",
        stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
        stopOpacity: "0.0786"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint6_linear_499_12980",
        x1: "56.1854",
        y1: "6.51231",
        x2: "75.9746",
        y2: "6.51231",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.208",
        stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
        stopOpacity: "0.792"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.3719",
        stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
        stopOpacity: "0.6281"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5207",
        stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
        stopOpacity: "0.4793"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6606",
        stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
        stopOpacity: "0.3394"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.7942",
        stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
        stopOpacity: "0.2058"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9214",
        stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
        stopOpacity: "0.0786"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint7_linear_499_12980",
        x1: "54.7482",
        y1: "124.969",
        x2: "145.885",
        y2: "33.833",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-blue-bolder, #2684FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.3613",
        stopColor: "var(--ds-background-accent-blue-subtle, #2986FF)",
        stopOpacity: "0.6387"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6457",
        stopColor: "var(--ds-background-accent-blue-subtle, #338CFF)",
        stopOpacity: "0.3543"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9031",
        stopColor: "var(--ds-background-accent-blue-subtle, #4495FF)",
        stopOpacity: "0.0969"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint8_linear_499_12980",
        x1: "132.434",
        y1: "109.023",
        x2: "129.764",
        y2: "78.307",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.7911",
        stopColor: "var(--ds-background-accent-blue-subtle, #66A3FF)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint9_linear_499_12980",
        x1: "23.785",
        y1: "51.7314",
        x2: "42.402",
        y2: "33.1132",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.2089",
        stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint10_linear_499_12980",
        x1: "42.596",
        y1: "129.08",
        x2: "141.953",
        y2: "29.7225",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.208",
        stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
        stopOpacity: "0.792"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.3719",
        stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
        stopOpacity: "0.6281"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5207",
        stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
        stopOpacity: "0.4793"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6606",
        stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
        stopOpacity: "0.3394"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.7942",
        stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
        stopOpacity: "0.2058"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9214",
        stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
        stopOpacity: "0.0786"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint11_linear_499_12980",
        x1: "37.0626",
        y1: "130.862",
        x2: "125.647",
        y2: "42.2776",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-gray-subtlest, #DEEBFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6383",
        stopColor: "var(--ds-background-accent-gray-subtlest, #EBF1FA)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint12_linear_499_12980",
        x1: "94.0388",
        y1: "28.347",
        x2: "117.556",
        y2: "28.347",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-gray-subtle, #6E7C93)",
        stopOpacity: "0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-background-accent-gray-subtle, #6C798F)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint13_linear_499_12980",
        x1: "50.5705",
        y1: "26.7136",
        x2: "49.861",
        y2: "13.9285",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.2629",
        stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6568",
        stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.7051",
        stopColor: "var(--ds-background-accent-yellow-subtle, #FFC607)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.7745",
        stopColor: "var(--ds-background-accent-yellow-subtle, #FFCA1A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.8568",
        stopColor: "var(--ds-background-accent-yellow-subtler, #FFD239)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9483",
        stopColor: "var(--ds-background-accent-yellow-subtler, #FFDC64)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint14_linear_499_12980",
        x1: "45.5246",
        y1: "24.8807",
        x2: "54.0025",
        y2: "13.9733",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.321",
        stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.766",
        stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint15_linear_499_12980",
        x1: "101.929",
        y1: "89.445",
        x2: "103.151",
        y2: "76.738",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.2629",
        stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6568",
        stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.7051",
        stopColor: "var(--ds-background-accent-yellow-subtle, #FFC607)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.7745",
        stopColor: "var(--ds-background-accent-yellow-subtle, #FFCA1A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.8568",
        stopColor: "var(--ds-background-accent-yellow-subtler, #FFD239)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9483",
        stopColor: "var(--ds-background-accent-yellow-subtler, #FFDC64)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint16_linear_499_12980",
        x1: "96.7524",
        y1: "86.8327",
        x2: "105.46",
        y2: "77.236",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.321",
        stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.766",
        stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint17_linear_499_12980",
        x1: "46.7436",
        y1: "124.678",
        x2: "85.5786",
        y2: "85.843",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.1228",
        stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.286",
        stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.4263",
        stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5367",
        stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6033",
        stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint18_linear_499_12980",
        x1: "55.645",
        y1: "135.098",
        x2: "94.1816",
        y2: "96.5612",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.1228",
        stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.286",
        stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.4263",
        stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5367",
        stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6033",
        stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint19_linear_499_12980",
        x1: "82.9016",
        y1: "129.529",
        x2: "83.3365",
        y2: "138.118",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint20_linear_499_12980",
        x1: "66.7271",
        y1: "153.359",
        x2: "112.794",
        y2: "115.971",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.1228",
        stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.286",
        stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.4263",
        stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5367",
        stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6033",
        stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint21_linear_499_12980",
        x1: "64.8985",
        y1: "150.541",
        x2: "110.859",
        y2: "113.239",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.1228",
        stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.286",
        stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.4263",
        stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5367",
        stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6033",
        stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint22_linear_499_12980",
        x1: "99.6982",
        y1: "120.33",
        x2: "103.749",
        y2: "121.161",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.766",
        stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint23_linear_499_12980",
        x1: "0.174194",
        y1: "146.568",
        x2: "56.0521",
        y2: "146.568",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-icon, #091E42)",
        stopOpacity: "0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-icon, #091E42)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint24_linear_499_12980",
        x1: "58.1309",
        y1: "158.125",
        x2: "87.7433",
        y2: "158.125",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-icon, #091E42)",
        stopOpacity: "0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-icon, #091E42)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint25_linear_499_12980",
        x1: "78.6253",
        y1: "150.658",
        x2: "68.697",
        y2: "151.584",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.452",
        stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint26_linear_499_12980",
        x1: "79.3893",
        y1: "142.265",
        x2: "75.8395",
        y2: "140.601",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.3539",
        stopColor: "var(--ds-background-accent-yellow-subtle, #FFB500)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.7017",
        stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint27_linear_499_12980",
        x1: "76.9238",
        y1: "139.183",
        x2: "90.7241",
        y2: "138.741",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.7262",
        stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint28_linear_499_12980",
        x1: "90.4515",
        y1: "22.6491",
        x2: "117.556",
        y2: "22.6491",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.0346",
        stopColor: "var(--ds-icon-inverse, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.3965",
        stopColor: "var(--ds-background-accent-gray-subtlest, #F7F7F8)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9604",
        stopColor: "var(--ds-background-accent-gray-subtlest, #E1E3E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_499_12980"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "147.652",
        height: "160",
        fill: "var(--ds-icon-inverse, white)",
        transform: "translate(0.174194)"
    }))));

});

parcelRegister("fAOvT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5a166b40b1da910$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $b5a166b40b1da910$var$messages = (0, $90IgZ.defineMessages)({
    buttonLoginToConfluenceNewTab: {
        id: 'embedded.confluence.generic-error-page.login-to-confluence-button',
        description: 'The text inside the login to Confluence button',
        defaultMessage: 'Log in to Confluence'
    },
    paragraphLogin: {
        id: 'embedded.confluence.need-to-log-in-paragraph',
        description: 'The text inside embedded confluence that tell user they need to be logged in to view this page',
        defaultMessage: 'You need to be logged in to view this page'
    },
    paragraphAlreadyLoggedIn: {
        id: 'embedded.confluence.already-logged-in-paragraph',
        description: 'The text inside embedded confluence that asks the user if they have logged in and refresh if so.',
        defaultMessage: 'Already logged in? Try refreshing.'
    },
    paragraphStillHavingTrouble: {
        id: 'embedded.confluence.still-having-trouble-paragraph',
        description: 'The text inside embedded confluence that asks the user if still having trouble and how they can enable third party cookies if so.',
        defaultMessage: 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}'
    },
    linkTroubleshootingText: {
        id: 'embedded.confluence.troubleshooting-link-text',
        description: 'the name of the placeholder {link} used in embedded.confluence.still-having-trouble-paragraph. Please translate these two as a single sentence',
        defaultMessage: 'refer to this troubleshooting guide.'
    },
    linkAriaLabel: {
        id: 'embedded.confluence.troubleshooting-link.aria-label',
        description: 'The aria label for troubleshooting link.',
        defaultMessage: 'troubleshooting guide link'
    },
    loginAriaLabel: {
        id: 'embedded.confluence.login-page.login-button.aria-label',
        description: 'The aria label for login button',
        defaultMessage: 'Login Button'
    },
    loginText: {
        id: 'embedded.confluence.login-page.login-text',
        description: 'Text to display before login button',
        defaultMessage: 'You need to be logged in to view this page'
    },
    loginButton: {
        id: 'embedded.confluence.login-page.login-button',
        description: 'The label for login button',
        defaultMessage: 'Log in to Confluence'
    },
    refreshBanner: {
        id: 'embedded.confluence.login-page.refresh-page-banner',
        description: 'The banner displayed prompting a user to refresh the page',
        defaultMessage: 'After logging in, this page should refresh automatically. If not, you can click here to refresh'
    },
    refreshBannerLink: {
        id: 'embedded.confluence.login-page.refresh-page-banner-refresh-link',
        description: 'A link to refresh the page',
        defaultMessage: 'Refresh page'
    }
});
var $b5a166b40b1da910$export$2e2bcd8739ae039 = $b5a166b40b1da910$var$messages;

});


parcelRegister("iLsDN", function(module, exports) {

$parcel$export(module.exports, "LoginPage", () => $da92d5471572e95b$export$f14c0e3f98d164c0);

var $hSQOv = parcelRequire("hSQOv");
var $caLW4 = parcelRequire("caLW4");

var $eUqFw = parcelRequire("eUqFw");

var $exJuA = parcelRequire("exJuA");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6zOB7 = parcelRequire("6zOB7");

var $5VUtK = parcelRequire("5VUtK");

var $lojJ5 = parcelRequire("lojJ5");

var $dDhJG = parcelRequire("dDhJG");

var $dyOUT = parcelRequire("dyOUT");

var $589ZO = parcelRequire("589ZO");

var $fAOvT = parcelRequire("fAOvT");
const $da92d5471572e95b$var$SUCCESS_URL_SUFFIX = '/wiki/embed/login-confirmation';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da92d5471572e95b$var$StyledParentDiv = (0, $exJuA.default).div({
    '': {
        display: 'inline-grid',
        alignItems: 'center',
        justifyItems: 'center',
        marginTop: "var(--ds-space-1000, 80px)"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da92d5471572e95b$var$StyledConfluenceIcon = (0, $exJuA.default)((0, $dDhJG.LoginToConfluenceIcon))({
    marginTop: "var(--ds-space-250, 20px)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da92d5471572e95b$var$StyledConfluenceLoginText = (0, $exJuA.default).h2({
    '': {
        marginTop: "var(--ds-space-250, 20px)"
    }
});
const $da92d5471572e95b$var$buttonWrapperStyles = (0, $caLW4.xcss)({
    marginTop: 'space.400'
});
const $da92d5471572e95b$var$fadeIn = (0, $byn9U.keyframes)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da92d5471572e95b$var$RefreshBannerFade = (0, $exJuA.default).div({
    padding: "var(--ds-space-250, 20px)",
    animation: `${$da92d5471572e95b$var$fadeIn} 3s`
});
const $da92d5471572e95b$export$f14c0e3f98d164c0 = ({ contentId: contentId, reloadEP: reloadEP, spaceKey: spaceKey, url: url })=>{
    const { locale: locale, formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const loginUrl = (0, $eUqFw.useMemo)(()=>{
        var _window, _window$location;
        const origin = url ? new URL(url).origin : (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin;
        return `${origin}/login?application=confluence&dest-url=${encodeURIComponent(`${$da92d5471572e95b$var$SUCCESS_URL_SUFFIX}?locale=${locale}`)}`;
    }, [
        url,
        locale
    ]);
    const handleClick = ()=>{
        $da92d5471572e95b$var$openLoginPopup(loginUrl);
        setDisplayRefreshBanner(!displayRefreshBanner);
    };
    const [displayRefreshBanner, setDisplayRefreshBanner] = (0, $eUqFw.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da92d5471572e95b$var$StyledParentDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lojJ5.ExperienceStart), {
        name: (0, $dyOUT.ExperienceNames).LOGIN_PAGE,
        id: `${spaceKey}-${contentId}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5VUtK.ConfluenceLogo), {
        size: "large",
        appearance: "brand"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da92d5471572e95b$var$StyledConfluenceIcon, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da92d5471572e95b$var$StyledConfluenceLoginText, null, formatMessage((0, $fAOvT.default).loginText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSQOv.default), {
        xcss: $da92d5471572e95b$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        testId: "login-button",
        "aria-label": formatMessage((0, $fAOvT.default).loginAriaLabel),
        appearance: "primary",
        onClick: handleClick
    }, formatMessage((0, $fAOvT.default).loginButton))), displayRefreshBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da92d5471572e95b$var$RefreshBannerFade, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $589ZO.default), {
        reloadEP: reloadEP,
        title: formatMessage((0, $fAOvT.default).refreshBanner),
        actionLabel: formatMessage((0, $fAOvT.default).refreshBannerLink)
    })));
};
function $da92d5471572e95b$var$openLoginPopup(loginUrl) {
    const windowFeatures = 'popup=yes,left=100,top=100,width=640,height=640';
    window.open(loginUrl, '_blank', windowFeatures);
}

});
parcelRegister("lojJ5", function(module, exports) {

$parcel$export(module.exports, "ExperienceStart", () => $dd355715d10e594d$export$f20b867e738a222c);

var $eUqFw = parcelRequire("eUqFw");

var $1xrmr = parcelRequire("1xrmr");
function $dd355715d10e594d$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $eUqFw.useContext)((0, $1xrmr.ExperienceTrackerContext));
    const wasCalledRef = (0, $eUqFw.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}

});

parcelRegister("589ZO", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bc57413790f3594$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4GEic = parcelRequire("4GEic");

var $aWvIp = parcelRequire("aWvIp");

var $PdmhA = parcelRequire("PdmhA");
const $3bc57413790f3594$var$RefreshBanner = ({ reloadEP: reloadEP, title: title, actionLabel: actionLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4GEic.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
            primaryColor: `var(--ds-icon-information, ${(0, $PdmhA.B300)})`,
            label: "Info"
        }),
        id: "refreshBanner",
        title: title,
        actions: [
            {
                content: actionLabel,
                onClick: reloadEP
            }
        ]
    });
var $3bc57413790f3594$export$2e2bcd8739ae039 = $3bc57413790f3594$var$RefreshBanner;

});


parcelRegister("jBSQ0", function(module, exports) {

$parcel$export(module.exports, "StorageAccessPage", () => $e46c02ae81135664$export$64a8a56a2c35628c);

var $eUqFw = parcelRequire("eUqFw");

var $lojJ5 = parcelRequire("lojJ5");

var $dyOUT = parcelRequire("dyOUT");

var $4hhoq = parcelRequire("4hhoq");

var $5JgJ2 = parcelRequire("5JgJ2");
const $e46c02ae81135664$export$64a8a56a2c35628c = ({ contentId: contentId, spaceKey: spaceKey, url: url, parentProduct: parentProduct })=>{
    const { locale: locale } = (0, $5JgJ2.default)();
    const iframeRef = (0, $eUqFw.useRef)(null);
    const src = (0, $eUqFw.useMemo)(()=>{
        const path = `/wiki/embed/storage-access?parentProduct=${parentProduct}&locale=${locale}`;
        const origin = url ? new URL(url).origin : window.location.origin;
        return [
            origin,
            path
        ].join('');
    }, [
        locale,
        parentProduct,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lojJ5.ExperienceStart), {
        name: (0, $dyOUT.ExperienceNames).STORAGE_ACCESS_PAGE,
        id: `${spaceKey}-${contentId}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4hhoq.StyledIframe), {
        "data-testid": "storage-access-page-iframe",
        src: src,
        ref: iframeRef
    }));
};

});
parcelRegister("4hhoq", function(module, exports) {

$parcel$export(module.exports, "StyledIframe", () => $31d63dd394169456$export$d99176fc999c3da2);
$parcel$export(module.exports, "Iframe", () => $31d63dd394169456$export$5137ec99f248330b);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $exJuA = parcelRequire("exJuA");

var $3aWvc = parcelRequire("3aWvc");

var $1d34b = parcelRequire("1d34b");
const $31d63dd394169456$export$d99176fc999c3da2 = (0, $exJuA.default).iframe({
    border: 'none',
    width: '100%',
    height: '100%'
});
const $31d63dd394169456$export$5137ec99f248330b = ({ src: src, onLoad: onLoad, onUnload: onUnload, onContentLoadStarted: onContentLoadStarted, ...passThroughProps })=>{
    (0, $eUqFw.useEffect)(()=>{
        const handler = (e)=>{
            if (e.data.type === 'windowUnload') onUnload === null || onUnload === void 0 || onUnload();
        };
        window.addEventListener('message', handler);
        return ()=>{
            window.removeEventListener('message', handler);
        };
    }, [
        onUnload
    ]);
    (0, $1d34b.useHostOffsetOverride)();
    const channel = (0, $3aWvc.useIframeCommunicationChannel)(src, {
        ...passThroughProps,
        onContentLoadStarted: onContentLoadStarted
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31d63dd394169456$export$d99176fc999c3da2, (0, $kU09D.default)({
        title: "confluence-article-iframe",
        "data-testid": "confluence-page-iframe",
        name: channel.name,
        src: src,
        onLoad: onLoad,
        allow: "autoplay; fullscreen; encrypted-media; clipboard-write",
        allowFullScreen: true
    }, passThroughProps));
};

});
parcelRegister("3aWvc", function(module, exports) {

$parcel$export(module.exports, "useIframeCommunicationChannel", () => $24ffaf94635eb44f$export$c745b3af35ea8585);

var $eUqFw = parcelRequire("eUqFw");

var $2vuY2 = parcelRequire("2vuY2");

var $1xrmr = parcelRequire("1xrmr");

function $24ffaf94635eb44f$var$defineModule(name, module) {
    (0, (/*@__PURE__*/$parcel$interopDefault($2vuY2))).defineModule(name, module);
}
const $24ffaf94635eb44f$var$useExperienceForwardingModule = ()=>{
    const experienceTrackerRef = (0, $eUqFw.useRef)();
    const experienceTracker = (0, $eUqFw.useContext)((0, $1xrmr.ExperienceTrackerContext));
    if (experienceTrackerRef.current !== experienceTracker) {
        $24ffaf94635eb44f$var$defineModule((0, $e321577f756f44db$export$b75934a6b56fd9ba), {
            start (options) {
                experienceTracker.start(options);
            },
            abort (options) {
                experienceTracker.abort(options);
            },
            succeed (options) {
                experienceTracker.succeed(options);
            },
            fail (options) {
                experienceTracker.fail(options);
            }
        });
        experienceTrackerRef.current = experienceTracker;
    }
};
const $24ffaf94635eb44f$var$usePassThroughPropsModule = (props)=>{
    const { onContentLoadStarted: onContentLoadStarted, ...passThroughProps } = props;
    const dispatchPropsUpdated = (0, $eUqFw.useCallback)(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($2vuY2))).dispatch((0, $e321577f756f44db$export$78cada8c8749e264), {
            addon_key: (0, $e321577f756f44db$export$ab9998995666ebe3)
        }, {
            message: JSON.stringify(passThroughProps)
        });
    /**
     * Disable react-hooks/exhaustive-deps linting, the dependency has passThroughProps spreading on its keys and values
     * This should be able to handle any changes to the `passThroughProps` would recall the effect function.
     **/ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...Object.keys(passThroughProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...Object.values(passThroughProps)
    ]);
    const dispatchPropsUpdatedRef = (0, $eUqFw.useRef)();
    if (dispatchPropsUpdatedRef.current !== dispatchPropsUpdated) {
        var _passThroughProps$nav;
        $24ffaf94635eb44f$var$defineModule((0, $e321577f756f44db$export$45b0adb7f9689286), {
            getProps: ()=>{
                onContentLoadStarted === null || onContentLoadStarted === void 0 || onContentLoadStarted();
                dispatchPropsUpdated();
            },
            navigationPolicyNavigate: (_passThroughProps$nav = passThroughProps.navigationPolicy) === null || _passThroughProps$nav === void 0 ? void 0 : _passThroughProps$nav.navigate
        });
        dispatchPropsUpdatedRef.current = dispatchPropsUpdated;
    }
    (0, $eUqFw.useEffect)(dispatchPropsUpdated, [
        dispatchPropsUpdated
    ]);
};
function $24ffaf94635eb44f$export$c745b3af35ea8585(iframeSrc, passThroughProps) {
    var _channelRef$current;
    const channelRef = (0, $eUqFw.useRef)();
    $24ffaf94635eb44f$var$useExperienceForwardingModule();
    $24ffaf94635eb44f$var$usePassThroughPropsModule(passThroughProps);
    if (((_channelRef$current = channelRef.current) === null || _channelRef$current === void 0 ? void 0 : _channelRef$current.src) !== iframeSrc) channelRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($2vuY2))).create({
        addon_key: (0, $e321577f756f44db$export$ab9998995666ebe3),
        key: (0, $e321577f756f44db$export$ab9998995666ebe3),
        url: iframeSrc,
        options: {
            globalOptions: {},
            // `hostFrameOffset` - Offset number specified to find iframe's host frame, it will be `window.top` if not specified.
            // Since EP frame can be embedded by middle layer frame(s), we set `hostFrameOffset` to 1 to ensure EP iframe's direct parent is the host frame.
            hostFrameOffset: 1,
            hostOrigin: window.location.origin
        }
    });
    return channelRef.current;
}

});
parcelRegister("2vuY2", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _util = _dereq_("./util");
                var _util2 = _interopRequireDefault(_util);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var PostMessage = function() {
                    function PostMessage(data) {
                        _classCallCheck(this, PostMessage);
                        var d = data || {};
                        this._registerListener(d.listenOn);
                    }
                    _createClass(PostMessage, [
                        {
                            key: "_registerListener",
                            value: function _registerListener(listenOn) {
                                if (!listenOn || !listenOn.addEventListener) listenOn = window;
                                listenOn.addEventListener("message", _util2.default._bind(this, this._receiveMessage), false);
                            }
                        },
                        {
                            key: "_receiveMessage",
                            value: function _receiveMessage(event) {
                                var handler = this._messageHandlers[event.data.type], extensionId = event.data.eid, reg = void 0;
                                if (extensionId && this._registeredExtensions) reg = this._registeredExtensions[extensionId];
                                if (!handler || !this._checkOrigin(event, reg)) return false;
                                handler.call(this, event, reg);
                            }
                        }
                    ]);
                    return PostMessage;
                }();
                exports.default = PostMessage;
                module1.exports = exports["default"];
            },
            {
                "./util": 2
            }
        ],
        2: [
            function(_dereq_, module1, exports) {
                "use strict";
                var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function(obj) {
                    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                };
                var LOG_PREFIX = "[Simple-XDM] ";
                var nativeBind = Function.prototype.bind;
                var util = {
                    locationOrigin: function locationOrigin() {
                        if (!window.location.origin) return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                        else return window.location.origin;
                    },
                    randomString: function randomString() {
                        return Math.floor(Math.random() * 1000000000).toString(16);
                    },
                    isString: function isString(str) {
                        return typeof str === "string" || str instanceof String;
                    },
                    argumentsToArray: function argumentsToArray(arrayLike) {
                        return Array.prototype.slice.call(arrayLike);
                    },
                    argumentNames: function argumentNames(fn) {
                        return fn.toString().replace(/((\/\/.*$)|(\/\*[^]*?\*\/))/mg, '') // strip comments
                        .replace(/[^(]+\(([^)]*)[^]+/, '$1') // get signature
                        .match(/([^\s,]+)/g) || [];
                    },
                    hasCallback: function hasCallback(args) {
                        var length = args.length;
                        return length > 0 && typeof args[length - 1] === 'function';
                    },
                    error: function error(msg) {
                        if (window.console && window.console.error) {
                            var outputError = [];
                            if (typeof msg === "string") {
                                outputError.push(LOG_PREFIX + msg);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments, 1));
                            } else {
                                outputError.push(LOG_PREFIX);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments));
                            }
                            window.console.error.apply(null, outputError);
                        }
                    },
                    warn: function warn(msg) {
                        if (window.console) console.warn(LOG_PREFIX + msg);
                    },
                    log: function log(msg) {
                        if (window.console) window.console.log(LOG_PREFIX + msg);
                    },
                    _bind: function _bind(thisp, fn) {
                        if (nativeBind && fn.bind === nativeBind) return fn.bind(thisp);
                        return function() {
                            return fn.apply(thisp, arguments);
                        };
                    },
                    throttle: function throttle(func, wait, context) {
                        var previous = 0;
                        return function() {
                            var now = Date.now();
                            if (now - previous > wait) {
                                previous = now;
                                func.apply(context, arguments);
                            }
                        };
                    },
                    each: function each(list, iteratee) {
                        var length;
                        var key;
                        if (list) {
                            length = list.length;
                            if (length != null && typeof list !== 'function') {
                                key = 0;
                                while(key < length){
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                    key += 1;
                                }
                            } else {
                                for(key in list)if (list.hasOwnProperty(key)) {
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                }
                            }
                        }
                    },
                    extend: function extend(dest) {
                        var args = arguments;
                        var srcs = [].slice.call(args, 1, args.length);
                        srcs.forEach(function(source) {
                            if ((typeof source === "undefined" ? "undefined" : _typeof(source)) === "object") Object.getOwnPropertyNames(source).forEach(function(name) {
                                dest[name] = source[name];
                            });
                        });
                        return dest;
                    },
                    sanitizeStructuredClone: function sanitizeStructuredClone(object) {
                        var whiteList = [
                            Boolean,
                            String,
                            Date,
                            RegExp,
                            Blob,
                            File,
                            FileList,
                            ArrayBuffer
                        ];
                        var blackList = [
                            Error,
                            Node
                        ];
                        var warn = util.warn;
                        var visitedObjects = [];
                        function _clone(value) {
                            if (typeof value === 'function') {
                                warn("A function was detected and removed from the message.");
                                return null;
                            }
                            if (blackList.some(function(t) {
                                if (value instanceof t) {
                                    warn(t.name + " object was detected and removed from the message.");
                                    return true;
                                }
                                return false;
                            })) return {};
                            if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' && whiteList.every(function(t) {
                                return !(value instanceof t);
                            })) {
                                var newValue = void 0;
                                if (Array.isArray(value)) newValue = value.map(function(element) {
                                    return _clone(element);
                                });
                                else {
                                    if (visitedObjects.indexOf(value) > -1) {
                                        warn("A circular reference was detected and removed from the message.");
                                        return null;
                                    }
                                    visitedObjects.push(value);
                                    newValue = {};
                                    for(var name in value)if (value.hasOwnProperty(name)) {
                                        var clonedValue = _clone(value[name]);
                                        if (clonedValue !== null) newValue[name] = clonedValue;
                                    }
                                    visitedObjects.pop();
                                }
                                return newValue;
                            }
                            return value;
                        }
                        return _clone(object);
                    },
                    getOrigin: function getOrigin(url, base) {
                        // everything except IE11
                        if (typeof URL === 'function') try {
                            return new URL(url, base).origin;
                        } catch (e) {}
                        // ie11 + safari 10
                        var doc = document.implementation.createHTMLDocument('');
                        if (base) {
                            var baseElement = doc.createElement('base');
                            baseElement.href = base;
                            doc.head.appendChild(baseElement);
                        }
                        var anchorElement = doc.createElement('a');
                        anchorElement.href = url;
                        doc.body.appendChild(anchorElement);
                        var origin = anchorElement.protocol + '//' + anchorElement.hostname;
                        //ie11, only include port if referenced in initial URL
                        if (url.match(/\/\/[^/]+:[0-9]+\//)) origin += anchorElement.port ? ':' + anchorElement.port : '';
                        return origin;
                    }
                };
                exports.default = util;
                module1.exports = exports["default"];
            },
            {}
        ],
        3: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _xdmrpc = _dereq_('./xdmrpc');
                var _xdmrpc2 = _interopRequireDefault(_xdmrpc);
                var _util = _dereq_('../common/util');
                var _util2 = _interopRequireDefault(_util);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var Connect = function() {
                    function Connect() {
                        _classCallCheck(this, Connect);
                        this._xdm = new _xdmrpc2.default();
                    }
                    /**
   * Send a message to iframes matching the targetSpec. This message is added to
   *  a message queue for delivery to ensure the message is received if an iframe
   *  has not yet loaded
   *
   * @param type The name of the event type
   * @param targetSpec The spec to match against extensions when sending this event
   * @param event The event payload
   * @param callback A callback to be executed when the remote iframe calls its callback
   */ _createClass(Connect, [
                        {
                            key: 'dispatch',
                            value: function dispatch(type, targetSpec, event, callback) {
                                this._xdm.queueEvent(type, targetSpec, event, callback);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: 'broadcast',
                            value: function broadcast(type, targetSpec, event) {
                                this._xdm.dispatch(type, targetSpec, event, null, null);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: '_createId',
                            value: function _createId(extension) {
                                if (!extension.addon_key || !extension.key) throw Error('Extensions require addon_key and key');
                                return extension.addon_key + '__' + extension.key + '__' + _util2.default.randomString();
                            }
                        },
                        {
                            key: 'create',
                            value: function create(extension, initCallback, unloadCallback) {
                                var extension_id = this.registerExtension(extension, initCallback, unloadCallback);
                                var options = extension.options || {};
                                var data = {
                                    extension_id: extension_id,
                                    api: this._xdm.getApiSpec(extension.addon_key),
                                    origin: _util2.default.locationOrigin(),
                                    options: options
                                };
                                return {
                                    id: extension_id,
                                    name: JSON.stringify(data),
                                    src: extension.url
                                };
                            }
                        },
                        {
                            key: 'registerRequestNotifier',
                            value: function registerRequestNotifier(callback) {
                                this._xdm.registerRequestNotifier(callback);
                            }
                        },
                        {
                            key: 'registerExtension',
                            value: function registerExtension(extension, initCallback, unloadCallback) {
                                var extension_id = this._createId(extension);
                                this._xdm.registerExtension(extension_id, {
                                    extension: extension,
                                    initCallback: initCallback,
                                    unloadCallback: unloadCallback
                                });
                                return extension_id;
                            }
                        },
                        {
                            key: 'registerKeyListener',
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.registerKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: 'unregisterKeyListener',
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.unregisterKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: 'registerClickHandler',
                            value: function registerClickHandler(callback) {
                                this._xdm.registerClickHandler(callback);
                            }
                        },
                        {
                            key: 'unregisterClickHandler',
                            value: function unregisterClickHandler() {
                                this._xdm.unregisterClickHandler();
                            }
                        },
                        {
                            key: 'defineModule',
                            value: function defineModule(moduleName, module1, options) {
                                this._xdm.defineAPIModule(module1, moduleName, options);
                            }
                        },
                        {
                            key: 'isModuleDefined',
                            value: function isModuleDefined(moduleName) {
                                return this._xdm.isAPIModuleDefined(moduleName);
                            }
                        },
                        {
                            key: 'defineGlobals',
                            value: function defineGlobals(module1) {
                                this._xdm.defineAPIModule(module1);
                            }
                        },
                        {
                            key: 'getExtensions',
                            value: function getExtensions(filter) {
                                return this._xdm.getRegisteredExtensions(filter);
                            }
                        },
                        {
                            key: 'unregisterExtension',
                            value: function unregisterExtension(filter) {
                                return this._xdm.unregisterExtension(filter);
                            }
                        },
                        {
                            key: 'returnsPromise',
                            value: function returnsPromise(wrappedMethod) {
                                wrappedMethod.returnsPromise = true;
                            }
                        },
                        {
                            key: 'setFeatureFlagGetter',
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._xdm.setFeatureFlagGetter(getBooleanFeatureFlag);
                            }
                        },
                        {
                            key: 'registerExistingExtension',
                            value: function registerExistingExtension(extension_id, data) {
                                return this._xdm.registerExtension(extension_id, data);
                            }
                        }
                    ]);
                    return Connect;
                }();
                exports.default = Connect;
                module1.exports = exports['default'];
            },
            {
                "../common/util": 2,
                "./xdmrpc": 5
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _connect = _dereq_('./connect');
                var _connect2 = _interopRequireDefault(_connect);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                exports.default = new _connect2.default();
                module1.exports = exports['default'];
            },
            {
                "./connect": 3
            }
        ],
        5: [
            function(_dereq_, module1, exports) {
                'use strict';
                var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function(obj) {
                    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                };
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _util = _dereq_('../common/util');
                var _util2 = _interopRequireDefault(_util);
                var _postmessage = _dereq_('../common/postmessage');
                var _postmessage2 = _interopRequireDefault(_postmessage);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _possibleConstructorReturn(self, call) {
                    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                } /**
  * Postmessage format:
  *
  * Initialization
  * --------------
  * {
  *   type: 'init',
  *   eid: 'my-addon__my-module-xyz'  // the extension identifier, unique across iframes
  * }
  *
  * Request
  * -------
  * {
  *   type: 'req',
  *   eid: 'my-addon__my-module-xyz',  // the extension identifier, unique for iframe
  *   mid: 'xyz',  // a unique message identifier, required for callbacks
  *   mod: 'cookie',  // the module name
  *   fn: 'read',  // the method name
  *   args: [arguments]  // the method arguments
  * }
  *
  * Response
  * --------
  * {
  *   type: 'resp'
  *   eid: 'my-addon__my-module-xyz',  // the extension identifier, unique for iframe
  *   mid: 'xyz',  // a unique message identifier, obtained from the request
  *   args: [arguments]  // the callback arguments
  * }
  *
  * Event
  * -----
  * {
  *   type: 'evt',
  *   etyp: 'some-event',
  *   evnt: { ... }  // the event data
  *   mid: 'xyz', // a unique message identifier for the event
  * }
  **/ 
                var VALID_EVENT_TIME_MS = 30000; //30 seconds
                var XDMRPC = function(_PostMessage) {
                    _inherits(XDMRPC, _PostMessage);
                    _createClass(XDMRPC, [
                        {
                            key: '_padUndefinedArguments',
                            value: function _padUndefinedArguments(array, length) {
                                return array.length >= length ? array : array.concat(new Array(length - array.length));
                            }
                        }
                    ]);
                    function XDMRPC(config) {
                        _classCallCheck(this, XDMRPC);
                        config = config || {};
                        var _this = _possibleConstructorReturn(this, (XDMRPC.__proto__ || Object.getPrototypeOf(XDMRPC)).call(this, config));
                        _this._registeredExtensions = config.extensions || {};
                        _this._registeredAPIModules = {};
                        _this._registeredAPIModules._globals = {};
                        _this._pendingCallbacks = {};
                        _this._keycodeCallbacks = {};
                        _this._clickHandler = null;
                        _this._pendingEvents = {};
                        _this._messageHandlers = {
                            init: _this._handleInit,
                            req: _this._handleRequest,
                            resp: _this._handleResponse,
                            broadcast: _this._handleBroadcast,
                            event_query: _this._handleEventQuery,
                            key_triggered: _this._handleKeyTriggered,
                            addon_clicked: _this._handleAddonClick,
                            get_host_offset: _this._getHostOffset,
                            unload: _this._handleUnload,
                            sub: _this._handleSubInit
                        };
                        return _this;
                    }
                    _createClass(XDMRPC, [
                        {
                            key: '_verifyAPI',
                            value: function _verifyAPI(event, reg) {
                                var untrustedTargets = event.data.targets;
                                if (!untrustedTargets) return;
                                var trustedSpec = this.getApiSpec();
                                var tampered = false;
                                function check(trusted, untrusted) {
                                    Object.getOwnPropertyNames(untrusted).forEach(function(name) {
                                        if (_typeof(untrusted[name]) === 'object' && trusted[name]) check(trusted[name], untrusted[name]);
                                        else if (untrusted[name] === 'parent' && trusted[name]) tampered = true;
                                    });
                                }
                                check(trustedSpec, untrustedTargets);
                                event.source.postMessage({
                                    type: 'api_tamper',
                                    tampered: tampered
                                }, reg.extension.url);
                            }
                        },
                        {
                            key: '_handleInit',
                            value: function _handleInit(event, reg) {
                                event.source.postMessage({
                                    type: 'init_received'
                                }, reg.extension.url);
                                this._registeredExtensions[reg.extension_id].source = event.source;
                                if (reg.initCallback) {
                                    reg.initCallback(event.data.eid);
                                    delete reg.initCallback;
                                }
                                if (event.data.targets) this._verifyAPI(event, reg);
                            }
                        },
                        {
                            key: '_handleSubInit',
                            value: function _handleSubInit(event, reg) {
                                var blocked = reg.extension.options.noSub || this._getBooleanFeatureFlag && this._getBooleanFeatureFlag('com.atlassian.connect.resolve_inner_iframe_url');
                                var data = event.data;
                                if (blocked) _util2.default.error("Sub-Extension requested by [" + reg.extension.addon_key + "] but feature is disabled");
                                else this.registerExtension(data.ext.id, {
                                    extension: data.ext
                                });
                                if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                                    sub: data.ext,
                                    type: data.type,
                                    addon_key: reg.extension.addon_key,
                                    key: reg.extension.key,
                                    extension_id: reg.extension_id,
                                    blocked: blocked
                                });
                            }
                        },
                        {
                            key: '_getHostOffset',
                            value: function _getHostOffset(event, _window) {
                                var hostWindow = event.source;
                                var hostFrameOffset = null;
                                var windowReference = _window || window; // For testing
                                if (windowReference === windowReference.top && typeof windowReference.getHostOffsetFunctionOverride === 'function') hostFrameOffset = windowReference.getHostOffsetFunctionOverride(hostWindow);
                                if (typeof hostFrameOffset !== 'number') {
                                    hostFrameOffset = 0;
                                    // Find the closest frame that has the same origin as event source
                                    while(!this._hasSameOrigin(hostWindow)){
                                        // Climb up the iframe tree 1 layer
                                        hostFrameOffset++;
                                        hostWindow = hostWindow.parent;
                                    }
                                }
                                event.source.postMessage({
                                    hostFrameOffset: hostFrameOffset
                                }, event.origin);
                            }
                        },
                        {
                            key: '_hasSameOrigin',
                            value: function _hasSameOrigin(window1) {
                                if (window1 === window1.top) return true;
                                try {
                                    // Try set & read a variable on the given window
                                    // If we can successfully read the value then it means the given window has the same origin
                                    // as the window that is currently executing the script
                                    var testVariableName = 'test_var_' + Math.random().toString(16).substr(2);
                                    window1[testVariableName] = true;
                                    return window1[testVariableName];
                                } catch (e) {
                                // A exception will be thrown if the windows doesn't have the same origin
                                }
                                return false;
                            }
                        },
                        {
                            key: '_handleResponse',
                            value: function _handleResponse(event) {
                                var data = event.data;
                                var pendingCallback = this._pendingCallbacks[data.mid];
                                if (pendingCallback) {
                                    delete this._pendingCallbacks[data.mid];
                                    pendingCallback.apply(window, data.args);
                                }
                            }
                        },
                        {
                            key: 'registerRequestNotifier',
                            value: function registerRequestNotifier(cb) {
                                this._registeredRequestNotifier = cb;
                            }
                        },
                        {
                            key: '_handleRequest',
                            value: function _handleRequest(event, reg) {
                                function sendResponse() {
                                    var args = _util2.default.sanitizeStructuredClone(_util2.default.argumentsToArray(arguments));
                                    event.source.postMessage({
                                        mid: event.data.mid,
                                        type: 'resp',
                                        forPlugin: true,
                                        args: args
                                    }, reg.extension.url);
                                }
                                var data = event.data;
                                var module1 = this._registeredAPIModules[data.mod];
                                var extension = this.getRegisteredExtensions(reg.extension)[0];
                                if (module1) {
                                    var fnName = data.fn;
                                    if (data._cls) {
                                        var Cls = module1[data._cls];
                                        var ns = data.mod + '-' + data._cls + '-';
                                        sendResponse._id = data._id;
                                        if (fnName === 'constructor') {
                                            if (!Cls._construct) {
                                                Cls.constructor.prototype._destroy = function() {
                                                    delete this._context._proxies[ns + this._id];
                                                };
                                                Cls._construct = function() {
                                                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                                    var inst = new (Function.prototype.bind.apply(Cls.constructor, [
                                                        null
                                                    ].concat(args)))();
                                                    var callback = args[args.length - 1];
                                                    inst._id = callback._id;
                                                    inst._context = callback._context;
                                                    inst._context._proxies[ns + inst._id] = inst;
                                                    return inst;
                                                };
                                            }
                                            module1 = Cls;
                                            fnName = '_construct';
                                        } else module1 = extension._proxies[ns + data._id];
                                    }
                                    var method = module1[fnName];
                                    if (method) {
                                        var methodArgs = data.args;
                                        var padLength = method.length - 1;
                                        if (fnName === '_construct') padLength = module1.constructor.length - 1;
                                        sendResponse._context = extension;
                                        methodArgs = this._padUndefinedArguments(methodArgs, padLength);
                                        methodArgs.push(sendResponse);
                                        var promiseResult = method.apply(module1, methodArgs);
                                        if (method.returnsPromise) {
                                            if (!((typeof promiseResult === 'undefined' ? 'undefined' : _typeof(promiseResult)) === 'object' || typeof promiseResult === 'function') || typeof promiseResult.then !== 'function') sendResponse('Defined module method did not return a promise.');
                                            else promiseResult.then(function(result) {
                                                sendResponse(undefined, result);
                                            }).catch(function(err) {
                                                err = err instanceof Error ? err.message : err;
                                                sendResponse(err);
                                            });
                                        }
                                        if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                                            module: data.mod,
                                            fn: data.fn,
                                            type: data.type,
                                            addon_key: reg.extension.addon_key,
                                            key: reg.extension.key,
                                            extension_id: reg.extension_id
                                        });
                                    }
                                }
                            }
                        },
                        {
                            key: '_handleBroadcast',
                            value: function _handleBroadcast(event, reg) {
                                var event_data = event.data;
                                var targetSpec = function targetSpec(r) {
                                    return r.extension.addon_key === reg.extension.addon_key && r.extension_id !== reg.extension_id;
                                };
                                this.dispatch(event_data.etyp, targetSpec, event_data.evnt, null, null);
                            }
                        },
                        {
                            key: '_handleKeyTriggered',
                            value: function _handleKeyTriggered(event, reg) {
                                var eventData = event.data;
                                var keycodeEntry = this._keycodeKey(eventData.keycode, eventData.modifiers, reg.extension_id);
                                var listeners = this._keycodeCallbacks[keycodeEntry];
                                if (listeners) listeners.forEach(function(listener) {
                                    listener.call(null, {
                                        addon_key: reg.extension.addon_key,
                                        key: reg.extension.key,
                                        extension_id: reg.extension_id,
                                        keycode: eventData.keycode,
                                        modifiers: eventData.modifiers
                                    });
                                }, this);
                            }
                        },
                        {
                            key: 'defineAPIModule',
                            value: function defineAPIModule(module1, moduleName) {
                                moduleName = moduleName || '_globals';
                                this._registeredAPIModules[moduleName] = _util2.default.extend({}, this._registeredAPIModules[moduleName] || {}, module1);
                                return this._registeredAPIModules;
                            }
                        },
                        {
                            key: 'isAPIModuleDefined',
                            value: function isAPIModuleDefined(moduleName) {
                                return typeof this._registeredAPIModules[moduleName] !== 'undefined';
                            }
                        },
                        {
                            key: '_pendingEventKey',
                            value: function _pendingEventKey(targetSpec, time) {
                                var key = targetSpec.addon_key || 'global';
                                if (targetSpec.key) key = key + '@@' + targetSpec.key;
                                key = key + '@@' + time;
                                return key;
                            }
                        },
                        {
                            key: 'queueEvent',
                            value: function queueEvent(type, targetSpec, event, callback) {
                                var loaded_frame, targets = this._findRegistrations(targetSpec);
                                loaded_frame = targets.some(function(target) {
                                    return target.registered_events !== undefined;
                                }, this);
                                if (loaded_frame) this.dispatch(type, targetSpec, event, callback);
                                else {
                                    this._cleanupInvalidEvents();
                                    var time = new Date().getTime();
                                    this._pendingEvents[this._pendingEventKey(targetSpec, time)] = {
                                        type: type,
                                        targetSpec: targetSpec,
                                        event: event,
                                        callback: callback,
                                        time: time,
                                        uid: _util2.default.randomString()
                                    };
                                }
                            }
                        },
                        {
                            key: '_cleanupInvalidEvents',
                            value: function _cleanupInvalidEvents() {
                                var _this2 = this;
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this2._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    if (!eventIsValid) delete _this2._pendingEvents[index];
                                });
                            }
                        },
                        {
                            key: '_handleEventQuery',
                            value: function _handleEventQuery(message, extension) {
                                var _this3 = this;
                                var executed = {};
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this3._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    var isSameTarget = !element.targetSpec || _this3._findRegistrations(element.targetSpec).length !== 0;
                                    if (isSameTarget && element.targetSpec.key) isSameTarget = element.targetSpec.addon_key === extension.extension.addon_key && element.targetSpec.key === extension.extension.key;
                                    if (eventIsValid && isSameTarget) {
                                        executed[index] = element;
                                        element.targetSpec = element.targetSpec || {};
                                        _this3.dispatch(element.type, element.targetSpec, element.event, element.callback, message.source);
                                    } else if (!eventIsValid) delete _this3._pendingEvents[index];
                                });
                                this._registeredExtensions[extension.extension_id].registered_events = message.data.args;
                                return executed;
                            }
                        },
                        {
                            key: '_handleUnload',
                            value: function _handleUnload(event, reg) {
                                if (!reg) return;
                                if (reg.extension_id && this._registeredExtensions[reg.extension_id]) delete this._registeredExtensions[reg.extension_id].source;
                                if (reg.unloadCallback) reg.unloadCallback(event.data.eid);
                            }
                        },
                        {
                            key: 'dispatch',
                            value: function dispatch(type, targetSpec, event, callback, source) {
                                function sendEvent(reg, evnt) {
                                    if (reg.source && reg.source.postMessage) {
                                        var mid;
                                        if (callback) {
                                            mid = _util2.default.randomString();
                                            this._pendingCallbacks[mid] = callback;
                                        }
                                        reg.source.postMessage({
                                            type: 'evt',
                                            mid: mid,
                                            etyp: type,
                                            evnt: evnt
                                        }, reg.extension.url);
                                    }
                                }
                                var registrations = this._findRegistrations(targetSpec || {});
                                registrations.forEach(function(reg) {
                                    if (source && !reg.source) reg.source = source;
                                    if (reg.source) _util2.default._bind(this, sendEvent)(reg, event);
                                }, this);
                            }
                        },
                        {
                            key: '_findRegistrations',
                            value: function _findRegistrations(targetSpec) {
                                var _this4 = this;
                                if (this._registeredExtensions.length === 0) {
                                    _util2.default.error('no registered extensions', this._registeredExtensions);
                                    return [];
                                }
                                var keys = Object.getOwnPropertyNames(targetSpec);
                                var registrations = Object.getOwnPropertyNames(this._registeredExtensions).map(function(key) {
                                    return _this4._registeredExtensions[key];
                                });
                                if (targetSpec instanceof Function) return registrations.filter(targetSpec);
                                else return registrations.filter(function(reg) {
                                    return keys.every(function(key) {
                                        return reg.extension[key] === targetSpec[key];
                                    });
                                });
                            }
                        },
                        {
                            key: 'registerExtension',
                            value: function registerExtension(extension_id, data) {
                                data._proxies = {};
                                data.extension_id = extension_id;
                                this._registeredExtensions[extension_id] = data;
                            }
                        },
                        {
                            key: '_keycodeKey',
                            value: function _keycodeKey(key, modifiers, extension_id) {
                                var code = key;
                                if (modifiers) {
                                    if (typeof modifiers === "string") modifiers = [
                                        modifiers
                                    ];
                                    modifiers.sort();
                                    modifiers.forEach(function(modifier) {
                                        code += '$$' + modifier;
                                    }, this);
                                }
                                return code + '__' + extension_id;
                            }
                        },
                        {
                            key: 'registerKeyListener',
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                if (typeof modifiers === "string") modifiers = [
                                    modifiers
                                ];
                                var reg = this._registeredExtensions[extension_id];
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                if (!this._keycodeCallbacks[keycodeEntry]) {
                                    this._keycodeCallbacks[keycodeEntry] = [];
                                    reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'add'
                                    }, reg.extension.url);
                                }
                                this._keycodeCallbacks[keycodeEntry].push(callback);
                            }
                        },
                        {
                            key: 'unregisterKeyListener',
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                var potentialCallbacks = this._keycodeCallbacks[keycodeEntry];
                                var reg = this._registeredExtensions[extension_id];
                                if (potentialCallbacks) {
                                    if (callback) {
                                        var index = potentialCallbacks.indexOf(callback);
                                        this._keycodeCallbacks[keycodeEntry].splice(index, 1);
                                    } else delete this._keycodeCallbacks[keycodeEntry];
                                    if (reg.source && reg.source.postMessage) reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'remove'
                                    }, reg.extension.url);
                                }
                            }
                        },
                        {
                            key: 'registerClickHandler',
                            value: function registerClickHandler(callback) {
                                if (typeof callback !== 'function') throw new Error('callback must be a function');
                                if (this._clickHandler !== null) throw new Error('ClickHandler already registered');
                                this._clickHandler = callback;
                            }
                        },
                        {
                            key: '_handleAddonClick',
                            value: function _handleAddonClick(event, reg) {
                                if (typeof this._clickHandler === 'function') this._clickHandler({
                                    addon_key: reg.extension.addon_key,
                                    key: reg.extension.key,
                                    extension_id: reg.extension_id
                                });
                            }
                        },
                        {
                            key: 'unregisterClickHandler',
                            value: function unregisterClickHandler() {
                                this._clickHandler = null;
                            }
                        },
                        {
                            key: 'getApiSpec',
                            value: function getApiSpec(addonKey) {
                                var _this5 = this;
                                function getModuleDefinition(mod) {
                                    return Object.getOwnPropertyNames(mod).reduce(function(accumulator, memberName) {
                                        var member = mod[memberName];
                                        switch(typeof member === 'undefined' ? 'undefined' : _typeof(member)){
                                            case 'function':
                                                accumulator[memberName] = {
                                                    args: _util2.default.argumentNames(member),
                                                    returnsPromise: member.returnsPromise || false
                                                };
                                                break;
                                            case 'object':
                                                if (member.hasOwnProperty('constructor')) accumulator[memberName] = getModuleDefinition(member);
                                                break;
                                        }
                                        return accumulator;
                                    }, {});
                                }
                                return Object.getOwnPropertyNames(this._registeredAPIModules).reduce(function(accumulator, moduleName) {
                                    var module1 = _this5._registeredAPIModules[moduleName];
                                    if (typeof module1.addonKey === 'undefined' || module1.addonKey === addonKey) accumulator[moduleName] = getModuleDefinition(module1);
                                    return accumulator;
                                }, {});
                            }
                        },
                        {
                            key: '_originEqual',
                            value: function _originEqual(url, origin) {
                                function strCheck(str) {
                                    return typeof str === 'string' && str.length > 0;
                                }
                                var urlOrigin = _util2.default.getOrigin(url);
                                // check strings are strings and they contain something
                                if (!strCheck(url) || !strCheck(origin) || !strCheck(urlOrigin)) return false;
                                return origin === urlOrigin;
                            }
                        },
                        {
                            key: '_checkOrigin',
                            value: function _checkOrigin(event, reg) {
                                var no_source_types = [
                                    'init'
                                ];
                                var isNoSourceType = reg && !reg.source && no_source_types.indexOf(event.data.type) > -1;
                                var sourceTypeMatches = reg && event.source === reg.source;
                                var hasExtensionUrl = reg && this._originEqual(reg.extension.url, event.origin);
                                var isValidOrigin = hasExtensionUrl && (isNoSourceType || sourceTypeMatches);
                                // get_host_offset fires before init
                                if (event.data.type === 'get_host_offset' && window === window.top) isValidOrigin = true;
                                // check undefined for chromium (Issue 395010)
                                if (event.data.type === 'unload' && (sourceTypeMatches || event.source === undefined)) isValidOrigin = true;
                                return isValidOrigin;
                            }
                        },
                        {
                            key: 'getRegisteredExtensions',
                            value: function getRegisteredExtensions(filter) {
                                if (filter) return this._findRegistrations(filter);
                                return this._registeredExtensions;
                            }
                        },
                        {
                            key: 'unregisterExtension',
                            value: function unregisterExtension(filter) {
                                var registrations = this._findRegistrations(filter);
                                if (registrations.length !== 0) registrations.forEach(function(registration) {
                                    var _this6 = this;
                                    var keys = Object.keys(this._pendingEvents);
                                    keys.forEach(function(index) {
                                        var element = _this6._pendingEvents[index];
                                        var targetSpec = element.targetSpec || {};
                                        if (targetSpec.addon_key === registration.extension.addon_key && targetSpec.key === registration.extension.key) delete _this6._pendingEvents[index];
                                    });
                                    delete this._registeredExtensions[registration.extension_id];
                                }, this);
                            }
                        },
                        {
                            key: 'setFeatureFlagGetter',
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._getBooleanFeatureFlag = getBooleanFeatureFlag;
                            }
                        }
                    ]);
                    return XDMRPC;
                }(_postmessage2.default);
                exports.default = XDMRPC;
                module1.exports = exports['default'];
            },
            {
                "../common/postmessage": 1,
                "../common/util": 2
            }
        ]
    }, {}, [
        4
    ])(4);
});

});

const $e321577f756f44db$export$ab9998995666ebe3 = 'embedded-confluence-iframe';
const $e321577f756f44db$export$45b0adb7f9689286 = 'passThroughProps';
const $e321577f756f44db$export$78cada8c8749e264 = 'propsUpdated';
const $e321577f756f44db$export$b75934a6b56fd9ba = 'experienceForwarding';


parcelRegister("1d34b", function(module, exports) {

$parcel$export(module.exports, "useHostOffsetOverride", () => $0e196246886900fe$export$db5957f3934e2c38);

var $eUqFw = parcelRequire("eUqFw");
function $0e196246886900fe$var$isSameOrigin(targetWindow, currentWindow = window) {
    let isSameOrigin;
    try {
        isSameOrigin = (targetWindow === null || targetWindow === void 0 ? void 0 : targetWindow.location.origin) === (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.location.origin);
    } catch (e) {
        // catch the DOM exception, mark the resolution to "false"
        isSameOrigin = false;
    }
    return isSameOrigin;
}
const $0e196246886900fe$export$28f1b4bd74242643 = (hostWindow, offset = 0)=>{
    let currentWindow = hostWindow;
    let hostFrameOffset = 0;
    while(currentWindow !== window.top){
        hostFrameOffset += 1;
        currentWindow = currentWindow.parent;
    }
    return hostFrameOffset - offset;
};
const $0e196246886900fe$var$attachHostOffsetOverride = (window1)=>{
    if (window1.top) {
        if ($0e196246886900fe$var$isSameOrigin(window1.top)) {
            const containerDepth = $0e196246886900fe$export$28f1b4bd74242643(window1);
            // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
            window1.top.getHostOffsetFunctionOverride = (hostWindow)=>$0e196246886900fe$export$28f1b4bd74242643(hostWindow, containerDepth + 1);
        }
    }
};
const $0e196246886900fe$var$detachHostOffsetOverride = ()=>{
    if (window.top) {
        if ($0e196246886900fe$var$isSameOrigin(window.top)) // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
        delete window.top.getHostOffsetFunctionOverride;
    }
};
function $0e196246886900fe$export$db5957f3934e2c38() {
    (0, $eUqFw.useEffect)(()=>{
        $0e196246886900fe$var$attachHostOffsetOverride(window);
        return ()=>{
            $0e196246886900fe$var$detachHostOffsetOverride();
        };
    }, []);
}

});



parcelRegister("kJg0O", function(module, exports) {

$parcel$export(module.exports, "Subjects", () => $f1746e4462a14270$export$29953e2fb702813a);
$parcel$export(module.exports, "LoadingStatus", () => $f1746e4462a14270$export$19d37de7e9a4af59);
$parcel$export(module.exports, "useValidationState", () => $f1746e4462a14270$export$1faa35b5a06780c0);

var $eUqFw = parcelRequire("eUqFw");

var $1xrmr = parcelRequire("1xrmr");

var $dyOUT = parcelRequire("dyOUT");
let $f1746e4462a14270$export$29953e2fb702813a = /*#__PURE__*/ function(Subjects) {
    Subjects["STORAGE_ACCESS"] = "storage-access";
    Subjects["LOGIN_CONFIRMATION"] = "login-confirmation";
    Subjects["CONTENT_LOAD"] = "content-load";
    return Subjects;
}({});
let $f1746e4462a14270$export$19d37de7e9a4af59 = /*#__PURE__*/ function(LoadingStatus) {
    LoadingStatus["IFRAME_LOADED"] = "iframe-loaded";
    LoadingStatus["IFRAME_UNLOADED"] = "iframe-unloaded";
    LoadingStatus["CONTENT_LOAD_STARTED"] = "content-load-started";
    LoadingStatus["REDIRECTED_TO_LOGIN"] = "redirected-to-login";
    LoadingStatus["RELOAD_EP"] = "reload-ep";
    return LoadingStatus;
}({});
let $f1746e4462a14270$export$12bf62de6f1fdb01 = /*#__PURE__*/ function(StorageAccessStatus) {
    StorageAccessStatus["GRANTED"] = "granted";
    StorageAccessStatus["REJECTED"] = "rejected";
    StorageAccessStatus["NOT_SUPPORTED"] = "not-supported";
    StorageAccessStatus["ERROR"] = "error";
    return StorageAccessStatus;
}({});
let $f1746e4462a14270$export$889a6bd688f4360e = /*#__PURE__*/ function(UserLoginStatus) {
    UserLoginStatus["SUCCESS"] = "success";
    return UserLoginStatus;
}({});
/* NOTE: (Refer this table for understanding the behavior
  on different browsers: https://hello.atlassian.net/wiki/spaces/~288141084/pages/2154391293/Conditions+to+load+EP)
*/ function $f1746e4462a14270$var$pageLoadValidationReducer(state, action) {
    //NOTE: We assume that storage access and user login is required at the load of the PageLoadValidation component
    switch(action.subject){
        case $f1746e4462a14270$export$29953e2fb702813a.STORAGE_ACCESS:
            switch(action.status){
                case $f1746e4462a14270$export$12bf62de6f1fdb01.GRANTED:
                    /*If storage access is granted, refresh app, if user is logged in, try to load EP. If not, load Login CTA
           */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskStorageAccess: false
                    };
                case $f1746e4462a14270$export$12bf62de6f1fdb01.REJECTED:
                    /*If storage access is reject, it could mean either of the two things:
          1. (For Safari): User has storage access but may not be logged in, Try loggin user in
          2. (For Firefox, Edge): User may be logged in but storage access is not yet granted by the browser
          In both these case, ask user to login.
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskStorageAccess: false,
                        shouldAskToLogin: true
                    };
                case $f1746e4462a14270$export$12bf62de6f1fdb01.NOT_SUPPORTED:
                    /* This case is specific for Chrome where storage access is not supported. 
          So we can skip asking for storage access and direct user to the Login CTA. 
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskToLogin: true,
                        shouldAskStorageAccess: false
                    };
                case $f1746e4462a14270$export$12bf62de6f1fdb01.ERROR:
                    /** To catch any other errors while requesting storage access */ return {
                        ...state
                    };
            }
            break;
        case $f1746e4462a14270$export$29953e2fb702813a.LOGIN_CONFIRMATION:
            switch(action.status){
                case $f1746e4462a14270$export$889a6bd688f4360e.SUCCESS:
                    /*
          If user has logged in, it means that storage access is granted. Refresh app, Try loading EP
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskToLogin: false,
                        iframeUnloaded: false,
                        redirectedToLogin: false
                    };
            }
            break;
        case $f1746e4462a14270$export$29953e2fb702813a.CONTENT_LOAD:
            //These states are set only when the user has navigated throught the storage access and login flows. So try to load EP
            switch(action.status){
                case $f1746e4462a14270$export$19d37de7e9a4af59.IFRAME_LOADED:
                    return {
                        ...state,
                        iframeLoaded: true
                    };
                case $f1746e4462a14270$export$19d37de7e9a4af59.CONTENT_LOAD_STARTED:
                    return {
                        ...state,
                        contentLoadStarted: true
                    };
                case $f1746e4462a14270$export$19d37de7e9a4af59.IFRAME_UNLOADED:
                    return {
                        ...state,
                        iframeUnloaded: true
                    };
                case $f1746e4462a14270$export$19d37de7e9a4af59.REDIRECTED_TO_LOGIN:
                    return {
                        ...state,
                        redirectedToLogin: true
                    };
                case $f1746e4462a14270$export$19d37de7e9a4af59.RELOAD_EP:
                    return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false
                    };
            }
            break;
    }
}
const $f1746e4462a14270$export$1faa35b5a06780c0 = ()=>{
    const initialState = {
        iframeLoaded: false,
        contentLoadStarted: false,
        shouldAskStorageAccess: true,
        shouldAskToLogin: true,
        redirectedToLogin: false,
        iframeUnloaded: false
    };
    const [state, dispatch] = (0, $eUqFw.useReducer)($f1746e4462a14270$var$pageLoadValidationReducer, initialState);
    const experienceTracker = (0, $eUqFw.useContext)((0, $1xrmr.ExperienceTrackerContext));
    const messageListener = (0, $eUqFw.useCallback)((messageEvent)=>{
        var _messageEvent$data;
        const { subject: subject, result: result } = (_messageEvent$data = messageEvent.data) !== null && _messageEvent$data !== void 0 ? _messageEvent$data : {};
        if (!subject || !result) return;
        switch(subject){
            case $f1746e4462a14270$export$29953e2fb702813a.STORAGE_ACCESS:
                switch(result){
                    case $f1746e4462a14270$export$12bf62de6f1fdb01.GRANTED:
                        experienceTracker.succeed({
                            name: (0, $dyOUT.ExperienceNames).STORAGE_ACCESS_PAGE
                        });
                        dispatch({
                            subject: $f1746e4462a14270$export$29953e2fb702813a.STORAGE_ACCESS,
                            status: $f1746e4462a14270$export$12bf62de6f1fdb01.GRANTED
                        });
                        break;
                    case $f1746e4462a14270$export$12bf62de6f1fdb01.REJECTED:
                        experienceTracker.abort({
                            name: (0, $dyOUT.ExperienceNames).STORAGE_ACCESS_PAGE,
                            reason: (0, $dyOUT.ExperienceReasons).STORAGE_ACCESS_REJECTED
                        });
                        dispatch({
                            subject: $f1746e4462a14270$export$29953e2fb702813a.STORAGE_ACCESS,
                            status: $f1746e4462a14270$export$12bf62de6f1fdb01.REJECTED
                        });
                        break;
                    case $f1746e4462a14270$export$12bf62de6f1fdb01.NOT_SUPPORTED:
                        experienceTracker.abort({
                            name: (0, $dyOUT.ExperienceNames).STORAGE_ACCESS_PAGE,
                            reason: (0, $dyOUT.ExperienceReasons).STORAGE_ACCESS_NOT_SUPPORTED
                        });
                        dispatch({
                            subject: $f1746e4462a14270$export$29953e2fb702813a.STORAGE_ACCESS,
                            status: $f1746e4462a14270$export$12bf62de6f1fdb01.NOT_SUPPORTED
                        });
                        break;
                    case $f1746e4462a14270$export$12bf62de6f1fdb01.ERROR:
                        experienceTracker.fail({
                            name: (0, $dyOUT.ExperienceNames).STORAGE_ACCESS_PAGE,
                            error: new Error((0, $dyOUT.ExperienceReasons).STORAGE_ACCESS_ERROR)
                        });
                        dispatch({
                            subject: $f1746e4462a14270$export$29953e2fb702813a.STORAGE_ACCESS,
                            status: $f1746e4462a14270$export$12bf62de6f1fdb01.ERROR
                        });
                        break;
                }
                break;
            case $f1746e4462a14270$export$29953e2fb702813a.LOGIN_CONFIRMATION:
                switch(result){
                    case $f1746e4462a14270$export$889a6bd688f4360e.SUCCESS:
                        experienceTracker.succeed({
                            name: (0, $dyOUT.ExperienceNames).LOGIN_PAGE
                        });
                        dispatch({
                            subject: $f1746e4462a14270$export$29953e2fb702813a.LOGIN_CONFIRMATION,
                            status: $f1746e4462a14270$export$889a6bd688f4360e.SUCCESS
                        });
                        break;
                }
                break;
        }
    }, [
        experienceTracker
    ]);
    (0, $eUqFw.useEffect)(()=>{
        window.addEventListener('message', messageListener);
        return ()=>window.removeEventListener('message', messageListener);
    }, [
        messageListener
    ]);
    return {
        state: state,
        dispatch: dispatch
    };
};

});




parcelRegister("fIYY5", function(module, exports) {

$parcel$export(module.exports, "embeddedConfluencePageModalEntrypoint", () => $b33110d33a996a0f$export$2798102ac94287d0);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $b33110d33a996a0f$export$2798102ac94287d0 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("87FEz")), {
        moduleId: "73170883"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("87FEz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dc3cS');
        const value = parcelRequire('5LXtr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dc3cS").then(()=>parcelRequire('5LXtr'));
}

});


parcelRegister("dMGT3", function(module, exports) {

$parcel$export(module.exports, "useParentProduct", () => $e70d73b8efede62e$export$1b09c6e3737c8eb7);

var $bNe1g = parcelRequire("bNe1g");

var $ls5tj = parcelRequire("ls5tj");
const $e70d73b8efede62e$export$1b09c6e3737c8eb7 = ()=>{
    const { data: data } = (0, $bNe1g.useProjectContext)();
    const projectType = data?.projectType;
    return (0, $ls5tj.getParentProduct)(projectType);
};

});


parcelRegister("lBV2M", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedWhiteboardModalEntryPoint", () => $cc2f43a1057aca61$export$12cf726c4fc1a29b);

var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $1ybV0 = parcelRequire("1ybV0");

var $h8Xfk = parcelRequire("h8Xfk");

var $eq2dV = parcelRequire("eq2dV");

var $dMGT3 = parcelRequire("dMGT3");

var $64PSE = parcelRequire("64PSE");
const $cc2f43a1057aca61$var$entryPointParams = {};
const $cc2f43a1057aca61$export$12cf726c4fc1a29b = (whiteboard, embeddedConfluenceSource)=>{
    const parentProduct = (0, $dMGT3.useParentProduct)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $h8Xfk.embeddedWhiteboardModalEntrypoint), $cc2f43a1057aca61$var$entryPointParams);
    const fireAnalyticsEvent = (0, $eq2dV.useEmbeddedPageTracking)();
    const themeState = (0, $4q38b.default)();
    const hostname = (0, $1ybV0.ff)('linked-pages-embedded-bug-fix') && whiteboard?.hostname ? whiteboard.hostname : '';
    const spaceKey = whiteboard?.href ? (0, $64PSE.getSpaceKey)(whiteboard.href) : '';
    const onClose = (0, $eUqFw.useCallback)(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            eventName: 'closeLinkedConfluenceWhiteboard',
            embeddedConfluenceSource: embeddedConfluenceSource
        });
        entryPointActions.unload();
    }, [
        fireAnalyticsEvent,
        entryPointActions,
        embeddedConfluenceSource
    ]);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            parentProduct: parentProduct,
            hostname: hostname,
            themeState: themeState,
            embeddedConfluenceSource: embeddedConfluenceSource,
            spaceKey: spaceKey,
            onClose: onClose,
            isOpen: true,
            modalTitle: whiteboard?.title ?? '',
            url: whiteboard?.href ?? '',
            contentId: whiteboard?.whiteboardId ?? ''
        }), [
        parentProduct,
        hostname,
        themeState,
        embeddedConfluenceSource,
        spaceKey,
        onClose,
        whiteboard?.title,
        whiteboard?.href,
        whiteboard?.whiteboardId
    ]);
    return whiteboard ? {
        entryPointActions: entryPointActions,
        entryPoint: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "embeddedWhiteboardModalEntrypointContainer",
            packageName: "@atlassian/jira-issue-create-confluence-content",
            teamName: "confluence-better-together",
            runtimeProps: runtimeProps
        })
    } : {
        entryPointActions: undefined,
        entryPoint: null
    };
};

});
parcelRegister("h8Xfk", function(module, exports) {

$parcel$export(module.exports, "embeddedWhiteboardModalEntrypoint", () => $a91b0ae1a94a4a6b$export$652b3f11839af9e6);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $a91b0ae1a94a4a6b$export$652b3f11839af9e6 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("9WLmP")), {
        moduleId: "d273fc0f"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9WLmP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ePKgJ');
        const value = parcelRequire('44aek');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ePKgJ").then(()=>parcelRequire('44aek'));
}

});



parcelRegister("gixeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f926afa5463aae2$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $0f926afa5463aae2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createErrorHeading: {
        "id": "issue-view.views.common.web-link-line-card-group.line-card.error-message.create-error-heading",
        "defaultMessage": "We couldn't create the web link"
    },
    deleteErrorHeading: {
        "id": "issue-view.views.common.web-link-line-card-group.line-card.error-message.delete-error-heading",
        "defaultMessage": "We couldn't delete the web link"
    },
    errorBody: {
        "id": "issue-view.views.common.web-link-line-card-group.line-card.error-message.create-error-body",
        "defaultMessage": "Wait a few moments, then give it another try."
    },
    retryAction: {
        "id": "issue-view.views.common.web-link-line-card-group.line-card.error-message.retry-action",
        "defaultMessage": "Try again"
    },
    cancelAction: {
        "id": "issue-view.views.common.web-link-line-card-group.line-card.error-message.cancel-action",
        "defaultMessage": "Cancel"
    },
    linksPerIssueLimitExceededTitle: {
        "id": "issue-view.views.common.web-link-line-card-group.line-card.links-per-issue-limit-exceeded-title",
        "defaultMessage": "We couldn\u2019t add the link"
    },
    linksPerIssueLimitExceededDescription: {
        "id": "issue-view.views.common.web-link-line-card-group.line-card.links-per-issue-limit-exceeded-description",
        "defaultMessage": "We can\u2019t add any more links to this issue as the limit has been reached."
    },
    linksPerIssueLimitExceededNotifyAdminLink: {
        "id": "issue-view.views.common.web-link-line-card-group.line-card.links-per-issue-limit-exceeded.contact-administrator",
        "defaultMessage": "Notify your admin"
    }
});

});

parcelRegister("ivuMa", function(module, exports) {

$parcel$export(module.exports, "JiraSmartLinkLocations", () => $012fe1a5fa9e3dc9$export$ad0d0ff48289368);
$parcel$export(module.exports, "smartLinksAttributes", () => $012fe1a5fa9e3dc9$export$8ec497a12f3bd789);
$parcel$export(module.exports, "webLinksAnalyticAttributes", () => $012fe1a5fa9e3dc9$export$55e4bf1e8ce419ee);
$parcel$export(module.exports, "confluencePagesAnalyticAttributes", () => $012fe1a5fa9e3dc9$export$98952af4131505f9);
const $012fe1a5fa9e3dc9$export$ad0d0ff48289368 = {
    JIRA_WEB_LINKS: 'jiraWebLinks',
    CONFLUENCE_PAGES: 'jiraLinkedConfluencePages',
    CONFLUENCE_WHITEBOARDS: 'jiraLinkedConfluenceWhiteboards'
};
const $012fe1a5fa9e3dc9$export$8ec497a12f3bd789 = {
    display: 'flexible'
};
const $012fe1a5fa9e3dc9$export$55e4bf1e8ce419ee = {
    ...$012fe1a5fa9e3dc9$export$8ec497a12f3bd789,
    location: $012fe1a5fa9e3dc9$export$ad0d0ff48289368.JIRA_WEB_LINKS
};
const $012fe1a5fa9e3dc9$export$98952af4131505f9 = {
    ...$012fe1a5fa9e3dc9$export$8ec497a12f3bd789,
    location: $012fe1a5fa9e3dc9$export$ad0d0ff48289368.CONFLUENCE_PAGES
};
const $012fe1a5fa9e3dc9$export$f4a14133926e5db2 = {
    ...$012fe1a5fa9e3dc9$export$8ec497a12f3bd789,
    location: $012fe1a5fa9e3dc9$export$ad0d0ff48289368.CONFLUENCE_WHITEBOARDS
};

});

parcelRegister("k4pGb", function(module, exports) {

$parcel$export(module.exports, "styleOverrides", () => $129b050bdd0f627e$export$7760cfd2da451bdc);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $129b050bdd0f627e$export$7aa1a90f3da71737 = (value)=>(0, $kwce8.css)`height:${value};min-height:${value};max-height:${value};width:${value};min-width:${value};max-width:${value};`;
const $129b050bdd0f627e$var$avatarSizeStyles = $129b050bdd0f627e$export$7aa1a90f3da71737('24px');
// eslint-disable-next-line jira/compiled/styled-components-usages
const $129b050bdd0f627e$var$highlightRemovalStyles = /*#__PURE__*/ (0, $kwce8.css)({
    boxShadow: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    outline: 'none !important',
    outlineColor: 'inherit',
    color: 'inherit',
    WebkitTapHighlightColor: 'transparent',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    MsUserSelect: 'none',
    userSelect: 'none'
});
const $129b050bdd0f627e$export$7760cfd2da451bdc = /*#__PURE__*/ (0, $kwce8.css)`height:40px;gap:${"var(--ds-space-100, 8px)"};cursor:pointer;[data-smart-element-avatar-group]{${$129b050bdd0f627e$var$avatarSizeStyles} div,span,img,svg{${$129b050bdd0f627e$var$avatarSizeStyles}}span{margin:0;}}[data-smart-element-link]{${$129b050bdd0f627e$var$highlightRemovalStyles}}`;

});

parcelRegister("fOdJx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f65dd5650b494ea$export$2e2bcd8739ae039);

var $hXWLE = parcelRequire("hXWLE");
const $9f65dd5650b494ea$var$uiOptions = {
    size: (0, $hXWLE.SmartLinkSize).Medium,
    hidePadding: true,
    hideElevation: true,
    theme: (0, $hXWLE.SmartLinkTheme).Black,
    clickableContainer: true,
    hideBackground: true
};
var $9f65dd5650b494ea$export$2e2bcd8739ae039 = $9f65dd5650b494ea$var$uiOptions;

});



parcelRegister("gCzJf", function(module, exports) {

$parcel$export(module.exports, "useConfirmationModalState", () => $175ecbae3221a199$export$c01d77fc205b5d2e);

var $eUqFw = parcelRequire("eUqFw");
const $175ecbae3221a199$export$c01d77fc205b5d2e = (handleDelete)=>{
    const [modalOpen, setModalOpen] = (0, $eUqFw.useState)(false);
    const [linkToDeleteId, setLinkToDeleteId] = (0, $eUqFw.useState)(null);
    const onConfirmDelete = (0, $eUqFw.useCallback)(()=>{
        if (linkToDeleteId != null) handleDelete(linkToDeleteId);
        setModalOpen(false);
        setLinkToDeleteId(null);
    }, [
        handleDelete,
        linkToDeleteId
    ]);
    const onDeleteClick = (0, $eUqFw.useCallback)((id)=>{
        setModalOpen(true);
        setLinkToDeleteId(id);
    }, []);
    const onCancelDelete = (0, $eUqFw.useCallback)(()=>{
        setModalOpen(false);
        setLinkToDeleteId(null);
    }, []);
    return {
        onDeleteClick: onDeleteClick,
        onConfirmDelete: onConfirmDelete,
        onCancelDelete: onCancelDelete,
        modalOpen: modalOpen
    };
};

});

parcelRegister("cYOrS", function(module, exports) {

$parcel$export(module.exports, "shouldLoadConfluenceInNewTab", () => $5d344c2c9bf7e614$export$f6b61940fcddcf18);
$parcel$export(module.exports, "getContentWithHostname", () => $5d344c2c9bf7e614$export$76991dc3f4559aac);

var $fEdG4 = parcelRequire("fEdG4");
var $2XxeS = parcelRequire("2XxeS");
const $5d344c2c9bf7e614$export$f6b61940fcddcf18 = ({ content: content, systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl = '', currentHostname: currentHostname })=>{
    const contentHref = content?.href;
    const hostname = (0, $fEdG4.getHostnameFromUrl)(contentHref);
    const systemHostName = (0, $fEdG4.getHostnameFromUrl)(systemConfluenceAppLinkUrl);
    // When Confluence is not on the same tenant and one of the hosts is a custom domain, render new tab
    return systemHostName !== hostname && ((0, $2XxeS.isCustomDomain)(currentHostname) || (0, $2XxeS.isCustomDomain)(hostname));
};
const $5d344c2c9bf7e614$export$76991dc3f4559aac = ({ content: content, systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl = '', currentHostname: currentHostname })=>{
    const contentHref = content?.href;
    const hostname = (0, $fEdG4.getHostnameFromUrl)(contentHref);
    const systemHostName = (0, $fEdG4.getHostnameFromUrl)(systemConfluenceAppLinkUrl);
    // If content is not on the same tenant, and custom domain is not enabled, we need to pass the hostname
    if (systemHostName !== hostname && !((0, $2XxeS.isCustomDomain)(currentHostname) || (0, $2XxeS.isCustomDomain)(hostname))) return {
        ...content,
        hostname: hostname
    };
    return content;
};

});

parcelRegister("c0iAM", function(module, exports) {

$parcel$export(module.exports, "ConfirmationModal", () => $a2d2bb3d5b01d0e4$export$1f33f980da756c46);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $8uD7Y = parcelRequire("8uD7Y");
const $a2d2bb3d5b01d0e4$export$1f33f980da756c46 = ({ modalOpen: modalOpen, onCancelDelete: onCancelDelete, onConfirmDelete: onConfirmDelete, title: title, description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, modalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        testId: "issue-view-common-views.confluence-content-line-card.ui.confirmation-modal",
        onClose: onCancelDelete,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "danger"
    }, title || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        id: "issue.details.confluence-pages.delete-confirmation-modal.title",
        defaultMessage: "Delete the Confluence page link?"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, description || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        id: "issue.details.confluence-pages.delete-confirmation-modal.content",
        defaultMessage: "You can add the page later again if you need to."
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "danger",
        onClick: onConfirmDelete,
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.common.confluence-page-line-card.confirm-button",
        interactionName: "auto-generated.issue.views.common.confluence-page-line-card.confirm-button.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        id: "issue.details.confluence-pages.delete-confirmation-modal.confirmation-text",
        defaultMessage: "Delete"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onCancelDelete,
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.common.confluence-page-line-card.cancel-button",
        interactionName: "auto-generated.issue.views.common.confluence-page-line-card.cancel-button.button1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        id: "issue.details.confluence-pages.delete-confirmation-modal.cancellation-text",
        defaultMessage: "Cancel"
    }))))));

});

parcelRegister("1Rvlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $32809ebf9583ca22$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $32809ebf9583ca22$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    connectToConfluenceToAuthenticate: {
        "id": "issue.issue-view.confluence-pages.connect-to-app-link",
        "defaultMessage": "Authenticate with Confluence to see this page"
    }
});

});


parcelRegister("bx1oo", function(module, exports) {

$parcel$export(module.exports, "ConfluenceWhiteboardLineCardGroup", () => $e2f82ae24ad29382$export$bedbc6d8e4cac9fd);

var $eUqFw = parcelRequire("eUqFw");

var $aml13 = parcelRequire("aml13");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eq2dV = parcelRequire("eq2dV");

var $6XLyv = parcelRequire("6XLyv");

var $3Tszs = parcelRequire("3Tszs");

var $lqalZ = parcelRequire("lqalZ");

var $aMhhi = parcelRequire("aMhhi");

var $bNe1g = parcelRequire("bNe1g");

var $h49rE = parcelRequire("h49rE");

var $ivuMa = parcelRequire("ivuMa");

var $gCzJf = parcelRequire("gCzJf");

var $cYOrS = parcelRequire("cYOrS");

var $c0iAM = parcelRequire("c0iAM");

var $fkkLh = parcelRequire("fkkLh");
const $e2f82ae24ad29382$export$10d7c7136fcb13ed = ({ whiteboards: whiteboards, systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl, onClick: onClick, onDeleteConfluenceWhiteboardLinkSuccess: onDeleteConfluenceWhiteboardLinkSuccess })=>{
    const trackEmbeddedConfluence = (0, $eq2dV.useEmbeddedPageTracking)();
    const projectContext = (0, $bNe1g.useProjectContext)();
    const issueAri = (0, $3Tszs.useIssueAri)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { unlinkIssueFromWhiteboard: unlinkIssueFromWhiteboard } = (0, $6XLyv.useWhiteboardIssueLinking)({
        issueAri: issueAri
    });
    const currentHostname = window?.location?.hostname || '';
    const isLinkedWhiteboardBugFixEnabled = (0, $1ybV0.ff)('linked-whiteboards-embedded-bug-fix');
    const onDeleteConfluenceWhiteboard = (0, $eUqFw.useCallback)(async (id)=>{
        const embeddedConfluenceSource = 'issueViewLinkedWhiteboards';
        try {
            await unlinkIssueFromWhiteboard(id, undefined);
            trackEmbeddedConfluence({
                action: 'success',
                eventName: 'deleteWhiteboardLink',
                projectType: projectContext.data?.projectType,
                eventType: 'operational',
                embeddedConfluenceSource: embeddedConfluenceSource
            });
            onDeleteConfluenceWhiteboardLinkSuccess(id);
        } catch (error) {
            if ((0, $1ybV0.ff)('whiteboard-unlink-permissions_3ze8p') && error instanceof Error && error.message?.includes('permission')) showFlag({
                key: (0, $eo17r.toFlagId)('deleteConfluenceWhiteboardLinkPermissionFailed'),
                type: 'error',
                title: formatMessage((0, $fkkLh.default).deleteConfluenceWhiteboardLinkFailedTitle),
                description: formatMessage((0, $fkkLh.default).deleteConfluenceWhiteboardLinkPermissionFailedDescription)
            });
            else {
                (0, $guiFP.default)({
                    meta: {
                        id: 'deleteWhiteboardLink',
                        teamName: 'bento'
                    },
                    attributes: {
                        embeddedConfluenceSource: embeddedConfluenceSource,
                        projectType: projectContext.data?.projectType
                    },
                    error: new Error(`Failed to delete Confluence whiteboard link, received error: ${error}`)
                });
                showFlag({
                    key: (0, $eo17r.toFlagId)('deleteConfluenceWhiteboardLinkFailed'),
                    type: 'error',
                    title: formatMessage((0, $fkkLh.default).deleteConfluenceWhiteboardLinkFailedTitle),
                    description: formatMessage((0, $fkkLh.default).deleteConfluenceWhiteboardLinkFailedDescription)
                });
            }
        }
    }, [
        formatMessage,
        onDeleteConfluenceWhiteboardLinkSuccess,
        showFlag,
        unlinkIssueFromWhiteboard,
        projectContext.data?.projectType,
        trackEmbeddedConfluence
    ]);
    const { onDeleteClick: onDeleteClick, onConfirmDelete: onConfirmDelete, onCancelDelete: onCancelDelete, modalOpen: modalOpen } = (0, $gCzJf.useConfirmationModalState)(onDeleteConfluenceWhiteboard);
    const onClickConfluenceWhiteboard = (0, $eUqFw.useCallback)((event)=>{
        if (!isLinkedWhiteboardBugFixEnabled) event.preventDefault();
        trackEmbeddedConfluence({
            action: 'clicked',
            eventName: 'openLinkedConfluenceWhiteboard',
            projectType: projectContext.data?.projectType
        });
        return onClick?.(event);
    }, [
        isLinkedWhiteboardBugFixEnabled,
        trackEmbeddedConfluence,
        projectContext.data?.projectType,
        onClick
    ]);
    const getWhiteboardWithHostname = (0, $eUqFw.useCallback)((whiteboard)=>(0, $cYOrS.getContentWithHostname)({
            content: whiteboard,
            systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl,
            currentHostname: currentHostname
        }), [
        currentHostname,
        systemConfluenceAppLinkUrl
    ]);
    const loadConfluenceInNewTab = (0, $eUqFw.useCallback)((whiteboard)=>(0, $cYOrS.shouldLoadConfluenceInNewTab)({
            content: whiteboard,
            systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl,
            currentHostname: currentHostname
        }), [
        currentHostname,
        systemConfluenceAppLinkUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), null, whiteboards.map((whiteboard)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h49rE.default), {
            key: whiteboard.id,
            analyticsLocation: (0, $ivuMa.JiraSmartLinkLocations).CONFLUENCE_WHITEBOARDS,
            url: whiteboard.href,
            onClick: onClickConfluenceWhiteboard,
            canDelete: true,
            onDeleteClick: onDeleteClick,
            text: whiteboard.title || '',
            linkId: whiteboard.id,
            smartLinkId: whiteboard.id,
            whiteboard: isLinkedWhiteboardBugFixEnabled ? getWhiteboardWithHostname(whiteboard) : whiteboard,
            loadConfluenceInNewTab: isLinkedWhiteboardBugFixEnabled ? loadConfluenceInNewTab(whiteboard) : false
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0iAM.ConfirmationModal), {
        modalOpen: modalOpen,
        onCancelDelete: onCancelDelete,
        onConfirmDelete: onConfirmDelete,
        title: formatMessage((0, $fkkLh.default).deleteConfirmationModalTitle),
        description: formatMessage((0, $fkkLh.default).deleteConfirmationModalDescription)
    }));
};
const $e2f82ae24ad29382$export$bedbc6d8e4cac9fd = (0, $lqalZ.connect)(null, {
    onDeleteConfluenceWhiteboardLinkSuccess: (0, $aMhhi.deleteConfluenceWhiteboardLinkSuccess)
})($e2f82ae24ad29382$export$10d7c7136fcb13ed);

});
parcelRegister("fkkLh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e870d33a48092c53$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e870d33a48092c53$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    deleteConfluenceWhiteboardLinkFailedTitle: {
        "id": "issue-view-common-views.confluence-content-line-card.confluence-whiteboard-line-card-group-view.delete-confluence-whiteboard-link-failed-title",
        "defaultMessage": "We couldn't remove the Confluence whiteboard link"
    },
    deleteConfluenceWhiteboardLinkFailedDescription: {
        "id": "issue-view-common-views.confluence-content-line-card.confluence-whiteboard-line-card-group-view.delete-confluence-whiteboard-link-failed-description",
        "defaultMessage": "Check your connection, then give it another try."
    },
    deleteConfluenceWhiteboardLinkPermissionFailedDescription: {
        "id": "issue-view-common-views.confluence-content-line-card.confluence-whiteboard-line-card-group-view.delete-confluence-whiteboard-link-permission-failed-description",
        "defaultMessage": "You don't have the permissions to perform this action"
    },
    deleteConfirmationModalTitle: {
        "id": "issue-view-common-views.confluence-content-line-card.confluence-whiteboard-line-card-group-view.delete-confirmation-modal-title",
        "defaultMessage": "Delete the Confluence whiteboard link?"
    },
    deleteConfirmationModalDescription: {
        "id": "issue-view-common-views.confluence-content-line-card.confluence-whiteboard-line-card-group-view.delete-confirmation-modal-description",
        "defaultMessage": "You can add the whiteboard later again if you need to."
    }
});

});


parcelRegister("coSdD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a11b6e8dc7acb8ec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iqjbc = parcelRequire("iqjbc");

var $hJ992 = parcelRequire("hJ992");

var $2xN2s = parcelRequire("2xN2s");

var $iMstM = parcelRequire("iMstM");

var $3o7jb = parcelRequire("3o7jb");

var $c75Wq = parcelRequire("c75Wq");
const $a11b6e8dc7acb8ec$var$ItemLineCardGroup = ({ itemCount: itemCount, paddingTopInPixels: paddingTopInPixels = 0, paddingBottomInPixels: paddingBottomInPixels = 0 })=>{
    const isModal = (0, $hJ992.useIsModal)();
    const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($iqjbc)))(itemCount).map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c75Wq.default), {
            isModal: isModal,
            key: index,
            fontSize: 20,
            lineHeight: 41,
            intrusion: 0
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3o7jb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMstM.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xN2s.default), {
        isModal: isModal,
        paddingTop: paddingTopInPixels,
        paddingBottom: paddingBottomInPixels
    }, getItems));
};
var $a11b6e8dc7acb8ec$export$2e2bcd8739ae039 = $a11b6e8dc7acb8ec$var$ItemLineCardGroup;

});
parcelRegister("iqjbc", function(module, exports) {

var $doiuZ = parcelRequire("doiuZ");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $d699885de2b5454c$var$range = $doiuZ();
module.exports = $d699885de2b5454c$var$range;

});
parcelRegister("doiuZ", function(module, exports) {

var $iVCWR = parcelRequire("iVCWR");

var $3P7i5 = parcelRequire("3P7i5");

var $d0d5X = parcelRequire("d0d5X");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $9bfbddb9d5847b3e$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $3P7i5(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $d0d5X(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $d0d5X(end);
        step = step === undefined ? start < end ? 1 : -1 : $d0d5X(step);
        return $iVCWR(start, end, step, fromRight);
    };
}
module.exports = $9bfbddb9d5847b3e$var$createRange;

});
parcelRegister("iVCWR", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $dc7bc3319622b4d0$var$nativeCeil = Math.ceil, $dc7bc3319622b4d0$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $dc7bc3319622b4d0$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $dc7bc3319622b4d0$var$nativeMax($dc7bc3319622b4d0$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $dc7bc3319622b4d0$var$baseRange;

});




parcelRegister("7qm3W", function(module, exports) {

$parcel$export(module.exports, "Container", () => $8041d0b17318a45d$export$42a852a2b6b56249);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");
const $8041d0b17318a45d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $kwce8.default).ul.withConfig({
    componentId: "c3rlkw-0"
})({
    boxShadow: `var(--ds-shadow-raised, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    `0 1px 1px ${(0, $PdmhA).N50A}, 0 0 1px 1px ${(0, $PdmhA).N40A}`})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-surface-raised, ${(0, $PdmhA).N10})`,
    borderRadius: '3px',
    padding: `${"var(--ds-space-025, 2px)"} 0`,
    width: '100%'
});

});

parcelRegister("ksiXg", function(module, exports) {

$parcel$export(module.exports, "ELIGIBLE_ISSUE_TYPES", () => $5d86b588551e5c14$export$14886fac06dcdbbf);
$parcel$export(module.exports, "USER_PROPERTY_DUMMY_LINK", () => $5d86b588551e5c14$export$f47fbad0e0275cb3);
$parcel$export(module.exports, "WAC_LINK", () => $5d86b588551e5c14$export$e5878965c6b450ed);
$parcel$export(module.exports, "DATA_PRIVACY_LINK", () => $5d86b588551e5c14$export$aefe1c8741b24a28);
$parcel$export(module.exports, "confluencePlaceholderTemplates", () => $5d86b588551e5c14$export$2333ff8a55ab0831);

var $fMg29 = parcelRequire("fMg29");
const $5d86b588551e5c14$export$14886fac06dcdbbf = [
    'bug',
    'story',
    'epic'
];
const $5d86b588551e5c14$export$f47fbad0e0275cb3 = 'hasDismissedConfluenceDummyLink';
const $5d86b588551e5c14$export$e5878965c6b450ed = 'https://www.atlassian.com/software/confluence/templates';
const $5d86b588551e5c14$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';
const $5d86b588551e5c14$export$2333ff8a55ab0831 = {
    story: {
        name: (0, $fMg29.default).productRequirementsTemplateName,
        url: 'https://www.atlassian.com/software/confluence/templates/product-requirements',
        suggestedIssueType: 'story',
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint'
    },
    epic: {
        name: (0, $fMg29.default).projectPlanTemplateName,
        url: 'https://www.atlassian.com/software/confluence/templates/project-plan',
        suggestedIssueType: 'epic',
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint'
    },
    bug: {
        name: (0, $fMg29.default).knownErrorsTemplateName,
        url: 'https://www.atlassian.com/software/confluence/templates/itsm-known-errors',
        suggestedIssueType: 'bug',
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-blueprint'
    }
};

});
parcelRegister("fMg29", function(module, exports) {

$parcel$export(module.exports, "default", () => $db6fdfb67eb8e666$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $db6fdfb67eb8e666$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    productRequirementsTemplateName: {
        "id": "confluence-placeholder-template.product-requirements-template-name",
        "defaultMessage": "Product requirements"
    },
    projectPlanTemplateName: {
        "id": "confluence-placeholder-template.project-plan-template-name",
        "defaultMessage": "Project plan"
    },
    knownErrorsTemplateName: {
        "id": "confluence-placeholder-template.known-errors-template-name",
        "defaultMessage": "Known errors"
    },
    privacyPolicy: {
        "id": "confluence-placeholder-template.generic-templates.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    dismissFlagTitle: {
        "id": "confluence-placeholder-template.dismiss-flag-title",
        "defaultMessage": "Thanks for letting us know"
    },
    dismissFlagDescription: {
        "id": "confluence-placeholder-template.dismiss-flag-description",
        "defaultMessage": "You won't be seeing this here anymore"
    },
    reasonsModalTitle: {
        "id": "confluence-placeholder-template.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "confluence-placeholder-template.reasons-modal-explanation",
        "defaultMessage": "We think <strong>Confluence</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOne: {
        "id": "confluence-placeholder-template.reasons-modal-bullet-one",
        "defaultMessage": "the size of your team"
    },
    reasonsModalBulletTwo: {
        "id": "confluence-placeholder-template.reasons-modal-bullet-two",
        "defaultMessage": "your existing Atlassian products"
    }
});

});


parcelRegister("7NqS9", function(module, exports) {

$parcel$export(module.exports, "useConfluenceDummyLinkContext", () => $30e531fbacaf5f33$export$6706d3022ccab515);
$parcel$export(module.exports, "ConfluenceDummyLinkProvider", () => $30e531fbacaf5f33$export$5fe3b320512ee86);

var $eUqFw = parcelRequire("eUqFw");
const $30e531fbacaf5f33$var$ConfluenceDummyLinkContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isEpModalOpen: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsEpModalOpen: ()=>{},
    activePageUrl: '',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setActivePageUrl: ()=>{},
    embeddedConfluenceSource: ''
});
const $30e531fbacaf5f33$export$6706d3022ccab515 = ()=>(0, $eUqFw.useContext)($30e531fbacaf5f33$var$ConfluenceDummyLinkContext);
const $30e531fbacaf5f33$export$5fe3b320512ee86 = ({ children: children, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView' })=>{
    const [isEpModalOpen, setIsEpModalOpen] = (0, $eUqFw.useState)(false);
    const [activePageUrl, setActivePageUrl] = (0, $eUqFw.useState)('');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30e531fbacaf5f33$var$ConfluenceDummyLinkContext.Provider, {
        value: {
            isEpModalOpen: isEpModalOpen,
            setIsEpModalOpen: setIsEpModalOpen,
            activePageUrl: activePageUrl,
            setActivePageUrl: setActivePageUrl,
            embeddedConfluenceSource: embeddedConfluenceSource
        }
    }, children);
};

});

parcelRegister("1dOAy", function(module, exports) {

$parcel$export(module.exports, "default", () => $42a93f7f3b4ee5f1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $90IgZ = parcelRequire("90IgZ");
var $4ksts = parcelRequire("4ksts");

var $81vFI = parcelRequire("81vFI");
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ const $42a93f7f3b4ee5f1$var$messages = (0, $90IgZ.defineMessages)({
    label: {
        "id": "issue.confluence-links-add-label",
        "defaultMessage": "Link a Confluence Page"
    }
});
const $42a93f7f3b4ee5f1$export$6d88ebe453be59d7 = (props)=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($42a93f7f3b4ee5f1$var$RightSideContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $81vFI.default), {
        label: formatMessage($42a93f7f3b4ee5f1$var$messages.label),
        onClick: props.onClick
    }));
};
var $42a93f7f3b4ee5f1$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $42a93f7f3b4ee5f1$export$6d88ebe453be59d7;
const $42a93f7f3b4ee5f1$var$RightSideContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bB2FQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fdf973814be3d8$export$2e2bcd8739ae039);

var $eGI9v = parcelRequire("eGI9v");
var $8un0w = parcelRequire("8un0w");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $a0kZP = parcelRequire("a0kZP");

var $6ySNE = parcelRequire("6ySNE");

var $aMhhi = parcelRequire("aMhhi");

var $gbvII = parcelRequire("gbvII");

var $dOXkm = parcelRequire("dOXkm");

var $iyeap = parcelRequire("iyeap");

var $3T7E1 = parcelRequire("3T7E1");

var $6vrw7 = parcelRequire("6vrw7");

var $lD9QT = parcelRequire("lD9QT");
const $59fdf973814be3d8$var$connectedProps = {
    onCancelClickAnalytics: 'cancelLinkConfluencePage',
    onEscapeKeyPressedAnalytics: 'cancelLinkConfluencePage'
};
const $59fdf973814be3d8$var$ConfluencePageCreateLink = (0, $5G3JL.flowWithSafeComponent)((0, $eGI9v.default)('button', {
    onSubmitClickAnalytics: 'clicked',
    onCancelClickAnalytics: 'clicked'
}), (0, $eGI9v.default)('keyboardShortcut', {
    onEnterKeyPressedAnalytics: 'pressed',
    onEscapeKeyPressedAnalytics: 'pressed'
}), (0, $eGI9v.default)('confluencePagesCreateLinkView', {
    onSubmit: 'onSubmit'
}), (0, $8un0w.default)($59fdf973814be3d8$var$connectedProps), (0, $eGI9v.default)('recentlyVisitedPages', {
    onSelectAnalytics: 'selected'
}), (0, $8un0w.default)({
    onSelectAnalytics: 'selectConfluencePage'
}), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ linkedPagesCount: number; linkedWhiteboardsCount: number; errorMessage: string; isInvalid: boolean; isLoading: boolean | undefined; createLinkClickedCount: number; recentlyViewedPages: ConfluencePage[]; confluenceAppLinks: ConfluenceAppLink[]; linkedPages: (ConfluencePage | Fail...' is not assignable to parameter of type 'FlowStep<WithUIAnalyticsEvent<PropsWithoutRef<Omit<{ [K in keyof PropsWithRef<PropsWithoutRef<Omit<{ [K in keyof PropsWithRef<Omit<{ [K in keyof PropsWithRef<Omit<{ [K in keyof Props]: K extends "onSubmitClickAnalytics" | "onCancelClickAnalytics" ? (...args: [...Parameters<Props[K]>, UIAnalyticsEvent]) => ReturnType...'.
(0, $lqalZ.connect)((state)=>({
        linkedPagesCount: (0, $iyeap.linkedConfluencePagesCountSelector)(state),
        linkedWhiteboardsCount: (0, $iyeap.linkedConfluenceWhiteboardsCountSelector)(state),
        errorMessage: (0, $iyeap.createLinkedPageErrorMessageSelector)(state),
        isInvalid: (0, $iyeap.isCreateLinkedPageInvalidSelector)(state),
        isLoading: (0, $iyeap.isCreateLinkedPageLoadingSelector)(state) || (0, $iyeap.isCreateLinkedWhiteboardLoadingSelector)(state),
        createLinkClickedCount: (0, $iyeap.createLinkedPageClickedCountSelector)(state),
        recentlyViewedPages: (0, $3T7E1.recentlyVisitedConfluencePagesSelector)(state),
        confluenceAppLinks: (0, $dOXkm.confluenceAppLinksSelector)(state),
        linkedPages: (0, $iyeap.linkedConfluencePagesPagesSelector)(state),
        mentionedPages: (0, $iyeap.mentionedConfluencePagesPagesSelector)(state),
        repairLink: (0, $iyeap.createLinkedPageRepairLinkSelector)(state)
    }), (dispatch)=>({
        onInvalidLinkModified: ()=>dispatch((0, $6ySNE.createConfluencePageLinkModified)()),
        onCancel: ()=>dispatch((0, $6ySNE.linkConfluencePageClosed)()),
        onSubmit: (link, triggerInviteExperiment, analyticsEvent)=>dispatch((0, $6ySNE.createConfluencePageLinkRequest)((0, $6vrw7.toHref)(link), analyticsEvent, triggerInviteExperiment)),
        requestRecentlyViewedPages: ()=>dispatch((0, $gbvII.fetchRecentlyVisitedConfluencePagesRequest)()),
        onAuthenticateApplink: (href)=>dispatch((0, $a0kZP.applinkAuthenticationRequest)(href)),
        onCreateWhiteboardLinkRequest: ()=>dispatch((0, $aMhhi.confluenceWhiteboardLinkRequest)()),
        onCreateWhiteboardLinkRequestFailed: ()=>dispatch((0, $aMhhi.confluenceWhiteboardLinkRequestFailed)()),
        onFetchConfluenceWhiteboardSuccess: (whiteboard)=>dispatch((0, $aMhhi.fetchConfluenceWhiteboardSuccess)(whiteboard))
    })))((0, $lD9QT.default));
var $59fdf973814be3d8$export$2e2bcd8739ae039 = $59fdf973814be3d8$var$ConfluencePageCreateLink;

});
parcelRegister("3T7E1", function(module, exports) {

$parcel$export(module.exports, "recentlyVisitedConfluencePagesSelector", () => $9461174c427f7508$export$747b29aec3f1aaa1);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");

var $iyeap = parcelRequire("iyeap");
const $9461174c427f7508$export$747b29aec3f1aaa1 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), // @ts-expect-error - TS2769 - No overload matches this call.
(0, $iyeap.linkedConfluencePagesPagesSelector), (0, $iyeap.mentionedConfluencePagesPagesSelector), (ui, linkedPages = [], mentionedPages = [])=>{
    const recentPages = ui.recentlyVisitedConfluencePages || [];
    const linkedPageHrefs = linkedPages.concat(mentionedPages).map((page)=>page.href);
    return recentPages.filter((page)=>!linkedPageHrefs.includes(page.href));
});

});

parcelRegister("lD9QT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0344e1e96f6511c5$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $8blac = parcelRequire("8blac");

var $27QuD = parcelRequire("27QuD");

var $7u4fN = parcelRequire("7u4fN");

var $llwDE = parcelRequire("llwDE");

var $aml13 = parcelRequire("aml13");

var $2Shq0 = parcelRequire("2Shq0");

var $f8Yej = parcelRequire("f8Yej");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9OlhM = parcelRequire("9OlhM");

var $hJ992 = parcelRequire("hJ992");

var $eq2dV = parcelRequire("eq2dV");

var $9MHPS = parcelRequire("9MHPS");

var $6XLyv = parcelRequire("6XLyv");

var $autRb = parcelRequire("autRb");

var $ivuMa = parcelRequire("ivuMa");

var $hzcvF = parcelRequire("hzcvF");

var $gd0Sp = parcelRequire("gd0Sp");

var $6wbGr = parcelRequire("6wbGr");

var $1gVNw = parcelRequire("1gVNw");

var $arNwV = parcelRequire("arNwV");

var $fCgoa = parcelRequire("fCgoa");

var $5VzE4 = parcelRequire("5VzE4");

var $bXTvM = parcelRequire("bXTvM");
const $0344e1e96f6511c5$export$8aea33bc635080c2 = ()=>(0, $eUqFw.useState)(()=>true);
const $0344e1e96f6511c5$export$84431a38900233c7 = ({ isInvalid: isInvalid, isLoading: isLoading, linkedPagesCount: linkedPagesCount, linkedWhiteboardsCount: linkedWhiteboardsCount, errorMessage: errorMessage, createLinkClickedCount: createLinkClickedCount, recentlyViewedPages: recentlyViewedPages, requestRecentlyViewedPages: requestRecentlyViewedPages, confluenceAppLinks: confluenceAppLinks, linkedPages: linkedPages, mentionedPages: mentionedPages, repairLink: repairLink, onSubmit: onSubmit, onCancel: onCancel, onInvalidLinkModified: onInvalidLinkModified, onSubmitClickAnalytics: onSubmitClickAnalytics, onCancelClickAnalytics: onCancelClickAnalytics, onEnterKeyPressedAnalytics: onEnterKeyPressedAnalytics, onEscapeKeyPressedAnalytics: onEscapeKeyPressedAnalytics, onSelectAnalytics: onSelectAnalytics, onAuthenticateApplink: onAuthenticateApplink, onCreateWhiteboardLinkRequest: onCreateWhiteboardLinkRequest, onCreateWhiteboardLinkRequestFailed: onCreateWhiteboardLinkRequestFailed, onFetchConfluenceWhiteboardSuccess: onFetchConfluenceWhiteboardSuccess })=>{
    const [requestRecentlyViewedState] = (0, $eUqFw.useState)(requestRecentlyViewedPages);
    const [isDisabled, setIsDisabled] = $0344e1e96f6511c5$export$8aea33bc635080c2();
    const [isAutoFocusable, setIsAutoFocusable] = (0, $eUqFw.useState)(true);
    const [link, setLink] = (0, $eUqFw.useState)(()=>'');
    const [, setShowList] = (0, $eUqFw.useState)(()=>false); // using previous values for properties passed down into functions which
    // were using prevProps
    const prevCreateLinkClickedCount = (0, $hzcvF.usePrevious)(createLinkClickedCount);
    const prevIsLoading = (0, $hzcvF.usePrevious)(isLoading);
    const prevLinkedPagesCount = (0, $hzcvF.usePrevious)(linkedPagesCount);
    const prevLinkedWhiteboardsCount = (0, $hzcvF.usePrevious)(linkedWhiteboardsCount);
    const childContainer = (0, $eUqFw.useRef)(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const cloudId = (0, $gd0Sp.useTenantContext)().cloudId;
    const issueId = (0, $hJ992.useIssueId)();
    const issueAri = (0, $eUqFw.useMemo)(()=>(0, $2Shq0.JiraIssueAri).create({
            siteId: cloudId,
            issueId: issueId || ''
        }).toString(), [
        cloudId,
        issueId
    ]);
    const linkIssueToWhiteboard = (0, $6XLyv.useWhiteboardIssueLinking)({
        issueAri: issueAri
    }).linkIssueToWhiteboard;
    const fetchConfluenceWhiteboard = (0, $9MHPS.useConfluenceWhiteboard)().fetchConfluenceWhiteboard;
    const fireAnalyticsEvent = (0, $eq2dV.useEmbeddedPageTracking)();
    const linkAnalytics = (0, $llwDE.useSmartLinkLifecycleAnalytics)();
    const triggerInviteExperiment = (0, $9OlhM.useInviteOnCreateLink)(link);
    const sendSmartLinkCreatedEvent = (0, $eUqFw.useCallback)(()=>{
        linkAnalytics?.linkCreated({
            url: link
        }, null, (0, $ivuMa.confluencePagesAnalyticAttributes));
    }, [
        link,
        linkAnalytics
    ]);
    const handleSubmit = (0, $eUqFw.useCallback)(async ()=>{
        const shouldSubmit = !isDisabled && !isLoading;
        if (!shouldSubmit) return;
        if ((0, $bXTvM.isWhiteboardContentTypeFromUrl)(link)) {
            onCreateWhiteboardLinkRequest();
            const embeddedConfluenceSource = 'issueViewCreateLink';
            try {
                const whiteboardAri = (0, $bXTvM.createConfluenceWhiteboardAri)({
                    siteId: cloudId,
                    whiteboardId: (0, $bXTvM.getWhiteboardIdFromUrl)(link) ?? ''
                });
                await linkIssueToWhiteboard(whiteboardAri);
                fireAnalyticsEvent({
                    action: 'success',
                    eventName: 'linkIssueToWhiteboard',
                    embeddedConfluenceSource: embeddedConfluenceSource,
                    eventType: 'operational'
                });
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'linkIssueToWhiteboard',
                        teamName: 'bento',
                        packageName: 'jiraIssueViewBase'
                    },
                    attributes: {
                        embeddedConfluenceSource: embeddedConfluenceSource
                    },
                    error: new Error(`Failed to link Confluence whiteboard to Jira issue: ${error}`)
                });
                if (error instanceof Error && error?.message === 'You do not have permission to ingest this relationship') showFlag({
                    key: (0, $eo17r.toFlagId)('linkWhiteboardFailed'),
                    type: 'error',
                    title: formatMessage((0, $5VzE4.default).linkCrossOriginWhiteboardFailedTitle),
                    description: formatMessage((0, $5VzE4.default).linkCrossOriginWhiteboardFailedDescription)
                });
                onCreateWhiteboardLinkRequestFailed();
            }
            const whiteboard = await (0, $bXTvM.getWhiteboard)({
                fetchConfluenceWhiteboard: fetchConfluenceWhiteboard,
                cloudId: cloudId,
                link: link,
                embeddedConfluenceSource: embeddedConfluenceSource
            });
            fireAnalyticsEvent({
                action: 'success',
                eventName: 'fetchConfluenceWhiteboard',
                embeddedConfluenceSource: embeddedConfluenceSource,
                eventType: 'operational'
            });
            sendSmartLinkCreatedEvent();
            if (whiteboard) onFetchConfluenceWhiteboardSuccess(whiteboard);
        } else {
            onSubmit(link, triggerInviteExperiment);
            sendSmartLinkCreatedEvent();
        }
    }, [
        isDisabled,
        isLoading,
        link,
        onSubmit,
        sendSmartLinkCreatedEvent,
        triggerInviteExperiment,
        cloudId,
        linkIssueToWhiteboard,
        fetchConfluenceWhiteboard,
        onFetchConfluenceWhiteboardSuccess,
        onCreateWhiteboardLinkRequest,
        onCreateWhiteboardLinkRequestFailed,
        fireAnalyticsEvent,
        formatMessage,
        showFlag
    ]);
    const onChange = (0, $eUqFw.useCallback)((linkOnChange)=>{
        // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string | undefined'.
        const trimmedLink = (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(linkOnChange);
        setIsDisabled((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(trimmedLink));
        setLink(trimmedLink);
        if (isInvalid) onInvalidLinkModified();
    }, [
        isInvalid,
        onInvalidLinkModified,
        setIsDisabled
    ]);
    const resetAndFocus = (0, $eUqFw.useCallback)(()=>{
        setIsDisabled(true);
        setLink('');
        setShowList(false);
    }, [
        setIsDisabled
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (childContainer.current !== undefined) // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLElement | null'.
        (0, $autRb.smoothScrollIntoCenterIfNeeded)(childContainer.current); // fetch recently viewed confluence pages
        requestRecentlyViewedState;
    }, [
        requestRecentlyViewedState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (prevCreateLinkClickedCount !== undefined && createLinkClickedCount !== prevCreateLinkClickedCount && childContainer.current !== undefined) {
            // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLElement | null'.
            (0, $autRb.smoothScrollIntoCenterIfNeeded)(childContainer.current);
            setIsAutoFocusable(true);
        } else setIsAutoFocusable(false);
        const shouldResetAndFocus = prevLinkedPagesCount !== undefined && prevLinkedWhiteboardsCount !== undefined && prevIsLoading !== undefined && (linkedWhiteboardsCount > prevLinkedWhiteboardsCount || linkedPagesCount > prevLinkedPagesCount) && !isLoading && prevIsLoading === true;
        if (shouldResetAndFocus) resetAndFocus();
    }, [
        createLinkClickedCount,
        isLoading,
        linkedPagesCount,
        prevCreateLinkClickedCount,
        prevIsLoading,
        prevLinkedPagesCount,
        resetAndFocus,
        linkedWhiteboardsCount,
        prevLinkedWhiteboardsCount
    ]);
    const onSubmitClicked = (0, $eUqFw.useCallback)(()=>{
        handleSubmit();
        onSubmitClickAnalytics();
    }, [
        onSubmitClickAnalytics,
        handleSubmit
    ]);
    const onCancelClicked = (0, $eUqFw.useCallback)(()=>{
        if (!isLoading) {
            setIsDisabled(true);
            setLink('');
            setShowList(false);
            onCancel();
        }
        onCancelClickAnalytics();
    }, [
        isLoading,
        onCancel,
        onCancelClickAnalytics,
        setIsDisabled
    ]);
    const onEnterPressed = (0, $eUqFw.useCallback)(()=>{
        handleSubmit();
        onEnterKeyPressedAnalytics();
    }, [
        onEnterKeyPressedAnalytics,
        handleSubmit
    ]);
    const onEscPressed = (0, $eUqFw.useCallback)(()=>{
        if (!isLoading) {
            setIsDisabled(true);
            setLink('');
            setShowList(false);
            onCancel();
        }
        onEscapeKeyPressedAnalytics();
    }, [
        isLoading,
        onCancel,
        onEscapeKeyPressedAnalytics,
        setIsDisabled
    ]);
    const options = recentlyViewedPages.map((page)=>({
            label: page.title,
            value: page.href,
            data: page,
            page: page
        }));
    let validationState = isInvalid ? 'error' : 'default';
    let validationMessage = isInvalid ? formatMessage((0, $fCgoa.default)(errorMessage)) : undefined; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onClickAuth = (e)=>{
        e.preventDefault();
        if (repairLink) onAuthenticateApplink(repairLink);
    };
    if (isInvalid && repairLink) {
        validationState = 'warning'; // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
        validationMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
            componentsMapping: {
                link: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                        href: repairLink,
                        onClick: onClickAuth,
                        target: "_blank" /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ ,
                        "data-testid": "issue.views.issue-base.content.confluence-pages.create-link.auth"
                    }, children)
            },
            message: (0, $fCgoa.default)((0, $1gVNw.CreateLinkError).UNAUTHORIZED_PROMPT).defaultMessage
        });
    }
    return(// @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: childContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
        onEscape: onEscPressed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6wbGr.default), {
        recentOptions: options,
        onChange: onChange,
        isAutoFocusable: isAutoFocusable,
        validationMessage: validationMessage,
        validationState: validationState,
        onSelect: onSelectAnalytics,
        onEnter: onEnterPressed,
        link: link,
        isLoading: isLoading,
        confluenceAppLinks: confluenceAppLinks || [],
        linkedPages: linkedPages || [],
        mentionedPages: mentionedPages || []
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0344e1e96f6511c5$var$ButtonsContainer, null, (0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-pages', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0344e1e96f6511c5$var$MenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $arNwV.CreateConfluenceContentMenu), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0344e1e96f6511c5$var$ButtonGroupWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0344e1e96f6511c5$var$StyledButton, {
        appearance: "primary",
        onClick: onSubmitClicked,
        isDisabled: isDisabled,
        isLoading: isLoading,
        testId: "issue.views.issue-base.content.confluence-pages.create-link.link"
    }, formatMessage((0, $5VzE4.default).linkButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0344e1e96f6511c5$var$StyledButton, {
        appearance: "subtle",
        onClick: onCancelClicked,
        testId: "issue.views.issue-base.content.confluence-pages.create-link.cancel"
    }, formatMessage((0, $5VzE4.default).cancelButton))))));
};
const $0344e1e96f6511c5$var$ConfluencePageCreateLinkViewWithSmartCardProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0344e1e96f6511c5$export$84431a38900233c7, props));
var $0344e1e96f6511c5$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $0344e1e96f6511c5$var$ConfluencePageCreateLinkViewWithSmartCardProvider;
const $0344e1e96f6511c5$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01a66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0344e1e96f6511c5$var$ButtonsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_vsu5of": (0, $9t7rW.default)((0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-pages', false) ? 'space-between' : 'flex-end')
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _1e0c1txw _1bahih9w",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0344e1e96f6511c5$var$MenuWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0344e1e96f6511c5$var$ButtonGroupWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3x4sL", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $88ddecd12f0773cd$export$200d7bd7633253ce);

var $eUqFw = parcelRequire("eUqFw");

var $dO2kc = parcelRequire("dO2kc");

var $6nVYw = parcelRequire("6nVYw");
const $88ddecd12f0773cd$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eUqFw.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $6nVYw.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $6nVYw.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $6nVYw.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $dO2kc.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $dO2kc.MalformedMessageError)) {
                (0, $dO2kc.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $dO2kc.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("dO2kc", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $1a42e2705665fc85$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $1a42e2705665fc85$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $1a42e2705665fc85$export$40d900e818b9630e);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

const $1a42e2705665fc85$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $1a42e2705665fc85$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $guiFP.default)({
            meta: {
                packageName: packageName,
                id: (0, $376af31d5cd90f0d$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $376af31d5cd90f0d$export$f3390a0e172fee41)}`;
        (0, $gUUjF.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $1a42e2705665fc85$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $376af31d5cd90f0d$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("6nVYw", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $ec16d76793463e9e$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $ec16d76793463e9e$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $ec16d76793463e9e$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $ec16d76793463e9e$export$d5170904651e91b1);

const $ec16d76793463e9e$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $ec16d76793463e9e$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$d5170904651e91b1 = (letter)=>letter === (0, $a86f32165c278403$export$a10c567c3288a6b4);

});
const $a86f32165c278403$export$a10c567c3288a6b4 = '}';



parcelRegister("9OlhM", function(module, exports) {

$parcel$export(module.exports, "useInvitePromptExperiment", () => $f6f6665809f41402$export$e0cc717650dc286b);
$parcel$export(module.exports, "useInviteOnCreateLink", () => $f6f6665809f41402$export$90eafb1d75365ab4);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");


var $dWLk9 = parcelRequire("dWLk9");
var $gd0Sp = parcelRequire("gd0Sp");

var $eeXze = parcelRequire("eeXze");

var $3sudU = parcelRequire("3sudU");

var $3AxvH = parcelRequire("3AxvH");

var $NHjLT = parcelRequire("NHjLT");

var $jaOn1 = parcelRequire("jaOn1");

var $lo9pc = parcelRequire("lo9pc");

var $4tmxg = parcelRequire("4tmxg");

var $hc9fz = parcelRequire("hc9fz");

var $6Dw6K = parcelRequire("6Dw6K");

var $codfX = parcelRequire("codfX");

var $iAekE = parcelRequire("iAekE");

var $h7mRL = parcelRequire("h7mRL");

var $94ERq = parcelRequire("94ERq");
const $f6f6665809f41402$export$e0cc717650dc286b = (flagKey, createIssueProjectKey)=>{
    const canInvite = (0, $4tmxg.useCanInvite)();
    const getInvitees = (0, $NHjLT.useInvitees)(createIssueProjectKey);
    const showInvitePromptFlag = (0, $h7mRL.useInvitePromptFlag)();
    const showSuccessFlag = (0, $94ERq.useInviteSuccessFlag)();
    const showErrorFlag = (0, $iAekE.useInviteErrorFlag)();
    const inviteUsers = (0, $lo9pc.useInviteUsers)();
    const { getOptOutStatus: getOptOutStatus, setOptOutStatus: setOptOutStatus, incrementViewCount: incrementViewCount, shouldShowOptOutOption: shouldShowOptOutOption } = (0, $hc9fz.useOptOut)();
    const fireFeatureExposed = (0, $3sudU.useFeatureExposed)(flagKey);
    const fireFeatureExposedV3 = (0, $3sudU.useFeatureExposed)((0, $3AxvH.INVITE_PROMPT_ON_LINK_INSERT_V3));
    const cloudId = (0, $dWLk9.useCloudId)();
    const openInviteModal = (0, $eeXze.default)();
    return (0, $eUqFw.useCallback)(async (continueUrl, data, source = (0, $3AxvH.SOURCE).ISSUE_VIEW)=>{
        try {
            (0, $codfX.invitePromptOnLinkInsertExperience).start();
            const { tenantId: tenantId, product: product, name: name } = data;
            const attributes = {
                source: source,
                product: product,
                isSameSite: tenantId === cloudId
            };
            const hasOptedOut = await getOptOutStatus();
            if (hasOptedOut) {
                fireFeatureExposed((0, $3sudU.IneligibilityReasons).OPTED_OUT, attributes);
                return;
            }
            const canInviteToProduct = await canInvite(tenantId, product);
            if (!canInviteToProduct) {
                fireFeatureExposed((0, $3sudU.IneligibilityReasons).MISSING_INVITE_CAPABILITY, attributes);
                return;
            }
            // V3 only works with V1 of AIOLI
            const enableThirtyInvitees = (0, $3AxvH.isInviteOnLinkInsertV3Enabled)() && (0, $1ybV0.ff)('aioli-v3-allow-30-users-from-core-invites', false);
            const inviteesLimit = flagKey === (0, $3AxvH.INVITE_PROMPT_ON_LINK_INSERT) && enableThirtyInvitees ? 30 : 10;
            const users = await getInvitees(tenantId, product, inviteesLimit);
            if (users.length === 0) {
                fireFeatureExposed((0, $3sudU.IneligibilityReasons).NO_ELIGIBLE_INVITEES, attributes);
                return;
            }
            const targetPageLabel = name || await (0, $jaOn1.getPageTitle)(continueUrl);
            fireFeatureExposed((0, $3sudU.IneligibilityReasons).ELIGIBLE, attributes);
            if (!(0, $3AxvH.isExperimentEnabled)(flagKey)) return;
            let shouldOpenCoreInvites = false;
            if (users.length > 3 && flagKey === (0, $3AxvH.INVITE_PROMPT_ON_LINK_INSERT)) {
                shouldOpenCoreInvites = (0, $3AxvH.isInviteOnLinkInsertV3Enabled)(true);
                fireFeatureExposedV3((0, $3sudU.IneligibilityReasons).ELIGIBLE, attributes);
            }
            const onOpenCoreInvites = ()=>{
                if (shouldOpenCoreInvites) openInviteModal(continueUrl, data, users);
            };
            showInvitePromptFlag({
                targetPageLabel: targetPageLabel,
                product: product,
                users: users,
                allowOptOut: await shouldShowOptOutOption(),
                onSubmit: async (getRecaptchaToken)=>{
                    try {
                        const recaptchaToken = await getRecaptchaToken('v1_invitations_invite').catch(()=>undefined);
                        await inviteUsers({
                            continueUrl: continueUrl,
                            users: users,
                            tenantId: tenantId,
                            product: product
                        }, recaptchaToken);
                        showSuccessFlag({
                            users: users,
                            product: product
                        });
                    } catch  {
                        showErrorFlag();
                    }
                },
                onDismiss: incrementViewCount,
                onOptOut: setOptOutStatus,
                shouldOpenCoreInvites: shouldOpenCoreInvites,
                onOpenCoreInvites: onOpenCoreInvites
            });
            (0, $codfX.invitePromptOnLinkInsertExperience).success();
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useInvitePromptExperiment',
                    packageName: 'jiraInvitePromptOnLinkInsert'
                },
                error: error
            });
            (0, $codfX.invitePromptOnLinkInsertExperience).failure();
        }
    }, [
        canInvite,
        cloudId,
        fireFeatureExposed,
        fireFeatureExposedV3,
        flagKey,
        getInvitees,
        getOptOutStatus,
        incrementViewCount,
        inviteUsers,
        openInviteModal,
        setOptOutStatus,
        shouldShowOptOutOption,
        showErrorFlag,
        showInvitePromptFlag,
        showSuccessFlag
    ]);
};
const $f6f6665809f41402$export$90eafb1d75365ab4 = (link)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const cloudName = (0, $gd0Sp.useTenantContext)()?.cloudName;
    const triggerInviteExperiment = $f6f6665809f41402$export$e0cc717650dc286b((0, $3AxvH.INVITE_PROMPT_ON_LINK_INSERT_V2));
    return (0, $eUqFw.useCallback)(()=>{
        if ((0, $6Dw6K.isConfluenceLink)(link, cloudName)) triggerInviteExperiment(link, {
            tenantId: cloudId,
            product: (0, $2edfd53057852e41$export$c811f21c9ad05dc2)
        }, (0, $3AxvH.SOURCE).CREATE_LINK);
    }, [
        cloudId,
        cloudName,
        link,
        triggerInviteExperiment
    ]);
};

});
parcelRegister("eeXze", function(module, exports) {

$parcel$export(module.exports, "default", () => $d035599d32cd3ff8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $Gz4Lz = parcelRequire("Gz4Lz");

var $82rJa = parcelRequire("82rJa");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hiBi9 = parcelRequire("hiBi9");

var $bFzGY = parcelRequire("bFzGY");

var $6Dw6K = parcelRequire("6Dw6K");

var $hvkzj = parcelRequire("hvkzj");
const $d035599d32cd3ff8$var$useOpenInvitePeopleModal = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const addFlag = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'appearance' implicitly has an 'any' type.
    ({ appearance: appearance, ...flagProps })=>{
        if (appearance === 'success' || appearance === 'normal') // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Gz4Lz.default), {
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'warning') // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82rJa.default), {
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'error') // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y2Y8.default), {
                ...flagProps,
                ...serviceProps
            }));
    }, [
        showFlag
    ]);
    const [, { openDrawer: openDrawer }] = (0, $hiBi9.useInvitePeopleDrawer)();
    return (0, $eUqFw.useCallback)((insertedLink, { name: name, product: product, tenantId: tenantId }, invitees)=>{
        openDrawer(createAnalyticsEvent ?? null, {
            inviteFlow: 'inviteLinkInsert',
            analyticsSource: 'inviteLinkInsert'
        }, undefined, {
            continueUrl: insertedLink,
            experimental_formTitleByline: name ? formatMessage((0, $hvkzj.messages).coreInvitesTitleByline, {
                title: name
            }) : undefined,
            experimental_userPickerByline: formatMessage((0, $hvkzj.messages).coreInvitesUserPickerByline, {
                productDisplayName: (0, $6Dw6K.getProductDisplayName)(product)
            }),
            experimentalFeatures: {
                invitePromptOnLinkV3: true,
                inviteThirdPartyTeams: 'variation'
            },
            initialInvitees: invitees,
            showFlag: addFlag,
            source: 'inviteLinkInsert',
            subProduct: (0, $6Dw6K.getCoreInviteSubProduct)(product),
            resourceAri: (0, $6Dw6K.getSiteAri)(tenantId, product),
            maxNumberOfInputs: (0, $1ybV0.ff)('aioli-v3-allow-30-users-from-core-invites', false) ? 30 : 10
        });
    }, [
        addFlag,
        createAnalyticsEvent,
        formatMessage,
        openDrawer
    ]);
};
var $d035599d32cd3ff8$export$2e2bcd8739ae039 = $d035599d32cd3ff8$var$useOpenInvitePeopleModal;

});
parcelRegister("6Dw6K", function(module, exports) {

$parcel$export(module.exports, "isConfluenceLink", () => $37a6fcf55dd47405$export$313baaa1c3261c49);
$parcel$export(module.exports, "getAllLinks", () => $37a6fcf55dd47405$export$776644da31ab517e);
$parcel$export(module.exports, "getAllProductLinks", () => $37a6fcf55dd47405$export$577f918d7821fd77);
$parcel$export(module.exports, "generateId", () => $37a6fcf55dd47405$export$567fc7097e064344);
$parcel$export(module.exports, "clampString", () => $37a6fcf55dd47405$export$96ce25bdd1856c70);
$parcel$export(module.exports, "getProductDisplayName", () => $37a6fcf55dd47405$export$44fea6589b7ddc92);
$parcel$export(module.exports, "getSiteAri", () => $37a6fcf55dd47405$export$792aeacb7990bc6);
$parcel$export(module.exports, "getCoreInviteSubProduct", () => $37a6fcf55dd47405$export$dcec5226018a2c73);
$parcel$export(module.exports, "useCurrentProduct", () => $37a6fcf55dd47405$export$495654df2a5da4a0);

var $fkCu1 = parcelRequire("fkCu1");

var $2futN = parcelRequire("2futN");

var $huI7r = parcelRequire("huI7r");

const $37a6fcf55dd47405$export$69caceff42c0da80 = {
    [(0, $2edfd53057852e41$export$c811f21c9ad05dc2)]: 'Confluence',
    [(0, $2edfd53057852e41$export$db515c8cec1e6f79)]: 'Jira',
    [(0, $2edfd53057852e41$export$202f50ee62667e32)]: 'Jira Product Discovery',
    [(0, $2edfd53057852e41$export$c8c1c8c3f8ddba61)]: 'Jira Service Management',
    [(0, $2edfd53057852e41$export$1346c9aa3cbb477d)]: 'Jira'
};
const $37a6fcf55dd47405$var$getProductFromSubproduct = (subproduct)=>{
    switch(subproduct){
        case 'software':
        case 'jira_software':
            return 0, $2edfd53057852e41$export$1346c9aa3cbb477d;
        case 'servicedesk':
        case 'jira_service_management':
            return 0, $2edfd53057852e41$export$c8c1c8c3f8ddba61;
        case 'core':
        case 'jira_work_management':
            return 0, $2edfd53057852e41$export$db515c8cec1e6f79;
        case 'polaris':
        case 'jira_product_discovery':
            return 0, $2edfd53057852e41$export$202f50ee62667e32;
        default:
            return null;
    }
};
const $37a6fcf55dd47405$export$313baaa1c3261c49 = (url, cloudName)=>{
    if (!url || !cloudName) return false;
    const regex = new RegExp(`^https?://${cloudName}.atlassian.net/wiki`);
    return regex.test(url);
};
const $37a6fcf55dd47405$export$776644da31ab517e = (doc)=>{
    const links = new Set();
    const handleLink = (link)=>{
        link && links.add(link);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSmartLink = (node)=>handleLink(node.attrs?.url);
    (0, $fkCu1.traverse)(doc, {
        text: (node)=>{
            if ((node.marks || []).some((mark)=>mark.type === 'link')) handleLink(node.text);
        },
        inlineCard: handleSmartLink,
        blockCard: handleSmartLink,
        embedCard: handleSmartLink
    });
    return links;
};
const $37a6fcf55dd47405$var$getSmartLinkData = (details)=>{
    if (!details) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { name: name } = details.data;
    const { tenantId: tenantId, subproduct: subproduct } = details.meta;
    let { product: product } = details.meta;
    if (tenantId) {
        product = product === 'jira' ? $37a6fcf55dd47405$var$getProductFromSubproduct(subproduct) : product;
        if (!Object.keys($37a6fcf55dd47405$export$69caceff42c0da80).includes(product)) return;
        return {
            name: name,
            tenantId: tenantId,
            product: product
        };
    }
};
const $37a6fcf55dd47405$export$577f918d7821fd77 = (doc, store, cloudId, cloudName)=>{
    const links = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSmartLink = (node)=>{
        // Check URL is on the ADF node
        const { url: url } = node?.attrs;
        if (!url) return;
        // Check URL is in the Smart Links Store
        const details = store.getState()[url]?.details;
        const linkdata = $37a6fcf55dd47405$var$getSmartLinkData(details);
        if (linkdata) links[url] = linkdata;
    };
    const handleRawConfluenceLink = (url)=>{
        if ($37a6fcf55dd47405$export$313baaa1c3261c49(url, cloudName)) links[url] = {
            tenantId: cloudId,
            product: (0, $2edfd53057852e41$export$c811f21c9ad05dc2)
        };
    };
    (0, $fkCu1.traverse)(doc, {
        text: (node)=>{
            if ((node.marks || []).some((mark)=>mark.type === 'link')) handleRawConfluenceLink(node.text);
        },
        inlineCard: handleSmartLink,
        blockCard: handleSmartLink,
        embedCard: handleSmartLink
    });
    return links;
};
let $37a6fcf55dd47405$var$id = 0;
const $37a6fcf55dd47405$export$567fc7097e064344 = ()=>{
    $37a6fcf55dd47405$var$id += 1;
    return String($37a6fcf55dd47405$var$id);
};
const $37a6fcf55dd47405$export$96ce25bdd1856c70 = (string, maxLength)=>{
    if (string.length > maxLength) return string.slice(0, maxLength).concat('...');
    return string;
};
const $37a6fcf55dd47405$export$44fea6589b7ddc92 = (product)=>$37a6fcf55dd47405$export$69caceff42c0da80[product];
const $37a6fcf55dd47405$export$792aeacb7990bc6 = (tenantId, product)=>(0, $huI7r.createAri)({
        resourceOwner: product,
        resourceType: 'site',
        resourceId: tenantId
    }).toString();
const $37a6fcf55dd47405$export$dcec5226018a2c73 = (product)=>{
    switch(product){
        case 0, $2edfd53057852e41$export$db515c8cec1e6f79:
        case 0, $2edfd53057852e41$export$202f50ee62667e32:
        case 0, $2edfd53057852e41$export$c8c1c8c3f8ddba61:
        case 0, $2edfd53057852e41$export$1346c9aa3cbb477d:
            return product.replace('jira-', '');
        default:
            return undefined;
    }
};
const $37a6fcf55dd47405$export$495654df2a5da4a0 = ()=>{
    const { data: data } = (0, $2futN.useProjectSidebarNavigation)();
    return $37a6fcf55dd47405$var$getProductFromSubproduct(data?.projectType) || (0, $2edfd53057852e41$export$1346c9aa3cbb477d);
};

});

parcelRegister("hvkzj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $957c099cdc439706$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $957c099cdc439706$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    coreInvitesTitleByline: {
        "id": "invite-prompt-on-link-insert.common.use-invite-people-modal.core-invites-title-byline",
        "defaultMessage": "to access {title}"
    },
    coreInvitesUserPickerByline: {
        "id": "invite-prompt-on-link-insert.common.use-invite-people-modal.core-invites-user-picker-byline",
        "defaultMessage": "These people don't have access to {productDisplayName}"
    }
});

});


parcelRegister("3sudU", function(module, exports) {

$parcel$export(module.exports, "IneligibilityReasons", () => $8f91be790f3ac023$export$e5ad17c39dfb6a42);
$parcel$export(module.exports, "useFeatureExposed", () => $8f91be790f3ac023$export$700e85d1c81b218b);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $8f91be790f3ac023$export$e5ad17c39dfb6a42 = {
    OPTED_OUT: 'opted-out',
    NO_ELIGIBLE_INVITEES: 'no-eligible-invitees',
    MISSING_INVITE_CAPABILITY: 'missing-invite-capability',
    ELIGIBLE: 'eligible'
};
const $8f91be790f3ac023$export$700e85d1c81b218b = (flagKey)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((ineligibilityReason, attributes)=>{
        const isIneligible = ineligibilityReason !== $8f91be790f3ac023$export$e5ad17c39dfb6a42.ELIGIBLE;
        // eslint-disable-next-line jira/ff/static-feature-flags
        const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)(flagKey);
        const cohort = isIneligible ? 'not-enrolled' : expConfig.get('cohort', 'not-enrolled');
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
            flagKey: flagKey,
            cohort: cohort,
            ineligibilityReason: ineligibilityReason,
            ...attributes
        });
    }, [
        createAnalyticsEvent,
        flagKey
    ]);
};

});

parcelRegister("3AxvH", function(module, exports) {

$parcel$export(module.exports, "INVITE_PROMPT_ON_LINK_INSERT", () => $45a4e6eebfb087c9$export$4212fcd2a914820a);
$parcel$export(module.exports, "INVITE_PROMPT_ON_LINK_INSERT_V2", () => $45a4e6eebfb087c9$export$6da7477ef7936f33);
$parcel$export(module.exports, "INVITE_PROMPT_ON_LINK_INSERT_V3", () => $45a4e6eebfb087c9$export$77fdb497fdef89d2);
$parcel$export(module.exports, "SOURCE", () => $45a4e6eebfb087c9$export$83c8d7110915321e);
$parcel$export(module.exports, "isExperimentEnabled", () => $45a4e6eebfb087c9$export$336b018592dc9972);
$parcel$export(module.exports, "isInviteOnLinkInsertV3Enabled", () => $45a4e6eebfb087c9$export$bbac70b4535f5e90);

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");
const $45a4e6eebfb087c9$export$4212fcd2a914820a = 'invite_prompt_on_link_insert';
const $45a4e6eebfb087c9$export$6da7477ef7936f33 = 'invite_prompt_on_link_insert_v2';
const $45a4e6eebfb087c9$export$77fdb497fdef89d2 = 'invite_prompt_on_link_insert_v3';
const $45a4e6eebfb087c9$export$83c8d7110915321e = {
    ISSUE_VIEW: 'issue-view',
    CREATE_ISSUE: 'create-issue',
    CREATE_LINK: 'create-link'
};
const $45a4e6eebfb087c9$export$336b018592dc9972 = (flagKey)=>// eslint-disable-next-line jira/ff/static-feature-flags
    (0, $79xbN.expValEquals)(flagKey, 'cohort', 'variation');
const $45a4e6eebfb087c9$export$bbac70b4535f5e90 = (shouldFireExposure = false)=>{
    if (!(0, $1ybV0.ff)('statsig-guard-invite-prompt-on-link-insert-v-3', false)) return false;
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig, fireExposure] = (0, $79xbN.UNSAFE_noExposureExp)('invite_prompt_on_link_insert_v3');
    const cohort = expConfig.get('cohort', 'not-enrolled');
    if (shouldFireExposure) fireExposure();
    return cohort === 'variation';
};

});

parcelRegister("NHjLT", function(module, exports) {

$parcel$export(module.exports, "useInvitees", () => $1514dc8ffad58a49$export$e2a3b21407d97a53);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $guDlK = parcelRequire("guDlK");

var $dWLk9 = parcelRequire("dWLk9");

var $6Dw6K = parcelRequire("6Dw6K");

var $3AxvH = parcelRequire("3AxvH");

var $4hvuU = parcelRequire("4hvuU");

var $kut51 = parcelRequire("kut51");
const $1514dc8ffad58a49$export$e2a3b21407d97a53 = (createIssueProjectKey)=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const currentProjectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectKey = createIssueProjectKey || currentProjectKey;
    const currentProduct = (0, $6Dw6K.useCurrentProduct)();
    const cloudId = (0, $dWLk9.useCloudId)();
    return (0, $eUqFw.useCallback)((tenantId, destinationProduct, inviteesLimit = 10)=>$1514dc8ffad58a49$export$31f1797930c2d46c(tenantId, destinationProduct, currentProduct, cloudId, projectKey, inviteesLimit), [
        cloudId,
        currentProduct,
        projectKey
    ]);
};
const $1514dc8ffad58a49$export$31f1797930c2d46c = async (tenantId, destinationProduct, currentProduct, cloudId, projectKey, inviteesLimit = 10)=>{
    const isInvitingToCurrentProduct = tenantId === cloudId && destinationProduct === currentProduct;
    if (isInvitingToCurrentProduct) return [];
    const projectAssignees = await (0, $4hvuU.getProjectAssignees)(projectKey);
    if (projectAssignees.length === 0) return [];
    const accountIds = projectAssignees.map(({ id: id })=>id);
    const [usersWithoutAccessToCurrentProduct, usersWithoutAccessToDestinationProduct] = await Promise.all([
        (0, $kut51.getUsersWithoutProductAccess)(cloudId, currentProduct, accountIds),
        (0, $kut51.getUsersWithoutProductAccess)(tenantId, destinationProduct, accountIds)
    ]);
    const potentialInvitees = projectAssignees.filter(({ id: id })=>!usersWithoutAccessToCurrentProduct.includes(id)).filter(({ id: id })=>usersWithoutAccessToDestinationProduct.includes(id));
    const invitees = !(0, $3AxvH.isInviteOnLinkInsertV3Enabled)() && (0, $1ybV0.ff)('invite-aaid-within-org') ? potentialInvitees : potentialInvitees.filter(({ email: email })=>!!email);
    return invitees.slice(0, inviteesLimit);
};

});
parcelRegister("4hvuU", function(module, exports) {

$parcel$export(module.exports, "getProjectAssignees", () => $28bc119511f71ec1$export$b49ddf91eddfcea9);

var $2OdyW = parcelRequire("2OdyW");
const $28bc119511f71ec1$var$getAssigneesUrl = (projectKey)=>`/rest/api/3/user/search/query?query=is assignee of ${projectKey}&maxResults=50`;
const $28bc119511f71ec1$export$b49ddf91eddfcea9 = async (projectKey)=>{
    const users = await (0, $2OdyW.default)($28bc119511f71ec1$var$getAssigneesUrl(projectKey));
    return users.values.filter(({ active: active })=>active).map(({ accountId: accountId, emailAddress: emailAddress, displayName: displayName, avatarUrls: avatarUrls })=>({
            id: accountId,
            email: emailAddress,
            name: displayName || '',
            avatar: avatarUrls['48x48'] || avatarUrls['32x32'] || avatarUrls['24x24'] || Object.values(avatarUrls).pop() || ''
        }));
};

});

parcelRegister("kut51", function(module, exports) {

$parcel$export(module.exports, "getUsersWithoutProductAccess", () => $d749ed04d16223f1$export$7121af075bd652a4);

var $2OdyW = parcelRequire("2OdyW");
const $d749ed04d16223f1$var$getInviteesUrl = '/gateway/api/growth/invite-on-link-insert/get-invitees';
const $d749ed04d16223f1$export$7121af075bd652a4 = (cloudId, product, accountIds)=>(0, $2OdyW.default)($d749ed04d16223f1$var$getInviteesUrl, {
        method: 'POST',
        body: JSON.stringify({
            cloudId: cloudId,
            product: product,
            accountIds: accountIds
        })
    });

});


parcelRegister("jaOn1", function(module, exports) {

$parcel$export(module.exports, "getPageTitle", () => $9adca1c2f8986df3$export$23286240952da4c9);

var $2OdyW = parcelRequire("2OdyW");
const $9adca1c2f8986df3$var$resolverUrl = '/gateway/api/object-resolver/resolve';
const $9adca1c2f8986df3$export$23286240952da4c9 = async (resourceUrl)=>{
    try {
        const response = await (0, $2OdyW.default)($9adca1c2f8986df3$var$resolverUrl, {
            method: 'POST',
            body: JSON.stringify({
                resourceUrl: resourceUrl
            })
        });
        return response.data?.name;
    } catch  {
        return undefined;
    }
};

});

parcelRegister("lo9pc", function(module, exports) {

$parcel$export(module.exports, "useInviteUsers", () => $8ef25a6f6b1222c1$export$6162654a9c7a7b9a);

var $eUqFw = parcelRequire("eUqFw");

var $jkH4Q = parcelRequire("jkH4Q");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6Dw6K = parcelRequire("6Dw6K");

var $4S2A8 = parcelRequire("4S2A8");

var $128HT = parcelRequire("128HT");
const $8ef25a6f6b1222c1$var$RECAPTCHA_VALIDATION_ERROR = 'ValidationError';
const $8ef25a6f6b1222c1$export$6162654a9c7a7b9a = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(async ({ users: users, continueUrl: continueUrl, tenantId: tenantId, product: product }, recaptchaToken)=>{
        try {
            const origin = new (0, $jkH4Q.default)({
                product: (0, $128HT.getOriginProduct)(product)
            });
            const continueUrlWithOrigin = origin.addToUrl(continueUrl);
            const originAttributes = origin.toAnalyticsAttributes({
                hasGeneratedId: true
            });
            const isInviteWithinOrg = (0, $1ybV0.ff)('invite-aaid-within-org');
            const invite = isInviteWithinOrg ? (0, $4S2A8.inviteWithinOrg) : (0, $4S2A8.inviteUsers);
            const inviteApiResponse = await invite({
                users: users,
                continueUrl: continueUrlWithOrigin,
                recaptchaToken: recaptchaToken,
                tenantId: tenantId,
                product: product
            });
            const response = (0, $128HT.handleInviteUsersSuccessResponse)(inviteApiResponse);
            [
                ...response.invited,
                ...response.accessRequested
            ].forEach((invited)=>{
                const resourceAri = (0, $6Dw6K.getSiteAri)(tenantId, product);
                const result = invited.results[resourceAri];
                const userId = invited.id;
                const analyticsAttributes = {
                    ...originAttributes,
                    userId: userId,
                    products: [
                        product
                    ],
                    inviteResult: [
                        {
                            resourceAri: resourceAri,
                            status: result
                        }
                    ],
                    integration: 'invitePromptOnLink',
                    isInviteWithinOrg: isInviteWithinOrg
                };
                if (result === 'INVITED') (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'user invited', userId, analyticsAttributes);
                else if (result === 'INVITED_PENDING_APPROVAL') (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'productAccess requested', userId, analyticsAttributes);
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'promptOnLinkInvite succeeded', {
                invited: response.invited.length,
                requested: response.accessRequested.length,
                errored: response.error.length
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: error.statusCode === 400 && error.name === $8ef25a6f6b1222c1$var$RECAPTCHA_VALIDATION_ERROR ? 'useInviteUsers-recaptcha' : 'useInviteUsers',
                    packageName: 'jiraInvitePromptOnLinkInsert'
                },
                error: error
            });
            throw error;
        }
    }, [
        createAnalyticsEvent
    ]);
};

});
parcelRegister("4S2A8", function(module, exports) {

$parcel$export(module.exports, "inviteUsers", () => $4433eb7ef708b0d5$export$da08225bbae46b1);
$parcel$export(module.exports, "inviteWithinOrg", () => $4433eb7ef708b0d5$export$a106ce8e40b3d224);

var $lRmyA = parcelRequire("lRmyA");

var $6Dw6K = parcelRequire("6Dw6K");

const $4433eb7ef708b0d5$export$da08225bbae46b1 = async ({ users: users, continueUrl: continueUrl, recaptchaToken: recaptchaToken, tenantId: tenantId, product: product })=>{
    const resources = [
        (0, $6Dw6K.getSiteAri)(tenantId, product)
    ];
    const response = await (0, $lRmyA.performPostRequest)((0, $5e73a293ce667688$export$ff111916f5a23b5a), {
        headers: {
            'Content-Type': 'application/json',
            ...recaptchaToken ? {
                'G-Recaptcha-Token': recaptchaToken
            } : {}
        },
        body: JSON.stringify({
            continueUrl: continueUrl,
            resources: resources,
            users: users.map(({ email: email })=>({
                    email: email
                }))
        })
    });
    return response;
};
const $4433eb7ef708b0d5$export$a106ce8e40b3d224 = async ({ users: users, continueUrl: continueUrl, tenantId: tenantId, product: product })=>{
    const resources = [
        (0, $6Dw6K.getSiteAri)(tenantId, product)
    ];
    const response = await (0, $lRmyA.performPostRequest)((0, $5e73a293ce667688$export$f87741d20d2a10fb), {
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            continueUrl: continueUrl,
            resources: resources,
            userIds: users.map(({ id: id })=>id),
            cloudId: tenantId,
            experience: 'invite-on-link-insert'
        })
    });
    return response;
};

});
const $5e73a293ce667688$export$ff111916f5a23b5a = '/gateway/api/invitations/invite';
const $5e73a293ce667688$export$f87741d20d2a10fb = '/gateway/api/growth/groot-invite-within-org/invite';


parcelRegister("128HT", function(module, exports) {

$parcel$export(module.exports, "getRecaptchaSiteKey", () => $2e22da079b3b9bd1$export$f6c02f8ff560b96f);
$parcel$export(module.exports, "handleInviteUsersSuccessResponse", () => $2e22da079b3b9bd1$export$bf7ed6f1f1b884e);
$parcel$export(module.exports, "getOriginProduct", () => $2e22da079b3b9bd1$export$e4853a500db4c6bf);


const $2e22da079b3b9bd1$export$f6c02f8ff560b96f = (environment)=>{
    switch(environment){
        case 'prod':
            return 0, $812813ba71586c24$export$2c2f58a9d84da733;
        case 'staging':
            return 0, $812813ba71586c24$export$cd719d3567d9b31d;
        default:
            return 0, $812813ba71586c24$export$34c3413ecdf1b634;
    }
};
const $2e22da079b3b9bd1$export$bf7ed6f1f1b884e = (response)=>response.reduce((accumulator, userResponse)=>{
        const user = {
            id: userResponse.id,
            email: userResponse.email
        };
        Object.keys(userResponse.results).forEach((resource)=>{
            switch(userResponse.results[resource]){
                case 'INVITED':
                case 'USER_EXISTS':
                    accumulator.invited.push({
                        ...user,
                        results: userResponse.results
                    });
                    break;
                case 'INVITED_PENDING_APPROVAL':
                case 'PENDING_INVITE_EXISTS':
                    accumulator.accessRequested.push({
                        ...user,
                        results: userResponse.results
                    });
                    break;
                case 'NOT_INVITED':
                case 'ERROR':
                    accumulator.error.push({
                        ...user,
                        error: userResponse.errorReasons[resource]
                    });
                    break;
                default:
                    throw new Error('Unexpected return type from invite user response');
            }
        });
        return accumulator;
    }, {
        invited: [],
        accessRequested: [],
        error: []
    });
const $2e22da079b3b9bd1$export$e4853a500db4c6bf = (product)=>{
    switch(product){
        case 0, $2edfd53057852e41$export$1346c9aa3cbb477d:
        case 0, $2edfd53057852e41$export$c8c1c8c3f8ddba61:
        case 0, $2edfd53057852e41$export$db515c8cec1e6f79:
        case 0, $2edfd53057852e41$export$202f50ee62667e32:
            return 'jira';
        default:
            return product;
    }
};

});
const $812813ba71586c24$export$2c2f58a9d84da733 = '6LfOcIYhAAAAADBS5OnBllme06dW9vyW4Zgowiru';
const $812813ba71586c24$export$cd719d3567d9b31d = '6LebaYYhAAAAAKFQt-KH6vVkTJQqwZddT-HJCIM3';
const $812813ba71586c24$export$34c3413ecdf1b634 = '6Le_DxYiAAAAABV8BsFSj3AmZf3OkP9Fh9lfbZOZ';



parcelRegister("4tmxg", function(module, exports) {

$parcel$export(module.exports, "useCanInvite", () => $2d41802e21ddeb06$export$4fa512abf5d2ba5e);

var $eUqFw = parcelRequire("eUqFw");

var $2OdyW = parcelRequire("2OdyW");

var $huI7r = parcelRequire("huI7r");
const $2d41802e21ddeb06$export$4fa512abf5d2ba5e = ()=>(0, $eUqFw.useCallback)((cloudId, product)=>$2d41802e21ddeb06$export$39ebdf2aa7e6d740(cloudId, product), []);
const $2d41802e21ddeb06$export$8a4a12ca67f0b223 = (cloudId)=>`/gateway/api/v3/invitations/capabilities?resource=ari:cloud:platform::site/${cloudId}`;
const $2d41802e21ddeb06$export$39ebdf2aa7e6d740 = async (cloudId, product)=>{
    const capabilities = await (0, $2OdyW.default)($2d41802e21ddeb06$export$8a4a12ca67f0b223(cloudId));
    const capability = capabilities.find((cap)=>{
        const ari = (0, $huI7r.getAriConfig)(cap.resourceARI);
        return ari.resourceOwner === product;
    });
    if (!capability) return false;
    return capability.directInvite?.mode === 'ANYONE' || capability.invitePendingApproval?.mode === 'ANYONE';
};

});

parcelRegister("hc9fz", function(module, exports) {

$parcel$export(module.exports, "useOptOut", () => $f0a3e6c42dfc021c$export$7f94797c6e99faf3);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $dxcfv = parcelRequire("dxcfv");

var $hWZxL = parcelRequire("hWZxL");
const $f0a3e6c42dfc021c$var$INVITE_PROMPT_ON_LINK_INSERT_VIEW = 'invite-prompt-on-link-insert-view';
const $f0a3e6c42dfc021c$var$INVITE_PROMPT_ON_LINK_INSERT_OPT_OUT = 'invite-prompt-on-link-insert-opt-out';
const $f0a3e6c42dfc021c$var$MAX_VIEW_COUNT = 2;
const $f0a3e6c42dfc021c$var$shouldShowOptOutOption = async (accountId)=>{
    if (!accountId) return false;
    const viewCount = await $f0a3e6c42dfc021c$var$getViewCount(accountId);
    return viewCount >= $f0a3e6c42dfc021c$var$MAX_VIEW_COUNT;
};
const $f0a3e6c42dfc021c$var$incrementViewCount = async (accountId)=>{
    if (!accountId) return;
    const viewCount = await $f0a3e6c42dfc021c$var$getViewCount(accountId);
    if (viewCount < $f0a3e6c42dfc021c$var$MAX_VIEW_COUNT) try {
        await (0, $hWZxL.setUserProperty)({
            accountId: accountId,
            propertyKey: $f0a3e6c42dfc021c$var$INVITE_PROMPT_ON_LINK_INSERT_VIEW,
            propertyValue: viewCount + 1
        });
    // TODO: shall we fire an event here to record the user has viewed the flag?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'incrementViewCount',
                packageName: 'jiraInvitePromptOnLinkInsert'
            },
            error: error
        });
    }
};
const $f0a3e6c42dfc021c$var$getViewCount = async (accountId)=>(await (0, $hWZxL.getUserProperty)({
        accountId: accountId,
        propertyKey: $f0a3e6c42dfc021c$var$INVITE_PROMPT_ON_LINK_INSERT_VIEW,
        defaultValue: 0
    })).value;
const $f0a3e6c42dfc021c$var$getOptOutInvitePrompt = async (accountId)=>{
    if (!accountId) return false;
    return (await (0, $hWZxL.getUserProperty)({
        accountId: accountId,
        propertyKey: $f0a3e6c42dfc021c$var$INVITE_PROMPT_ON_LINK_INSERT_OPT_OUT,
        defaultValue: false
    })).value;
};
const $f0a3e6c42dfc021c$var$setOptOutInvitePrompt = async (accountId)=>{
    if (!accountId) return;
    try {
        await (0, $hWZxL.setUserProperty)({
            accountId: accountId,
            propertyKey: $f0a3e6c42dfc021c$var$INVITE_PROMPT_ON_LINK_INSERT_OPT_OUT,
            propertyValue: true
        });
    // TODO: shall we fire an event here to record the user has opted out?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'setOptOutInvitePrompt',
                packageName: 'jiraInvitePromptOnLinkInsert'
            },
            error: error
        });
    }
};
const $f0a3e6c42dfc021c$export$7f94797c6e99faf3 = ()=>{
    const accountId = (0, $dxcfv.useAccountId)();
    return (0, $eUqFw.useMemo)(()=>({
            shouldShowOptOutOption: ()=>$f0a3e6c42dfc021c$var$shouldShowOptOutOption(accountId),
            incrementViewCount: ()=>$f0a3e6c42dfc021c$var$incrementViewCount(accountId),
            getOptOutStatus: ()=>$f0a3e6c42dfc021c$var$getOptOutInvitePrompt(accountId),
            setOptOutStatus: ()=>$f0a3e6c42dfc021c$var$setOptOutInvitePrompt(accountId)
        }), [
        accountId
    ]);
};

});
parcelRegister("hWZxL", function(module, exports) {

$parcel$export(module.exports, "setUserProperty", () => $406ec895657cfded$export$ba821ce5e177c7ef);
$parcel$export(module.exports, "getUserProperty", () => $406ec895657cfded$export$b3126db2ef6e34ed);

var $lRmyA = parcelRequire("lRmyA");
const $406ec895657cfded$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $406ec895657cfded$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $406ec895657cfded$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $lRmyA.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw new Error(`Saving ${propertyKey} user property failed. Error: ${error}`);
    }
};
const $406ec895657cfded$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $406ec895657cfded$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await (0, $lRmyA.performGetRequest)(url);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};

});


parcelRegister("codfX", function(module, exports) {

$parcel$export(module.exports, "invitePromptOnLinkInsertExperience", () => $93366d77c0732a4c$export$adb25c37e478fcbe);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $93366d77c0732a4c$export$adb25c37e478fcbe = new (0, $kDfSL.UFOExperience)('invite-prompt-on-link-insert', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("iAekE", function(module, exports) {

$parcel$export(module.exports, "useInviteErrorFlag", () => $6c353f4fb7ab217f$export$e6d35b1c4e81af0e);

var $eUqFw = parcelRequire("eUqFw");

var $8vPhU = parcelRequire("8vPhU");
var $kQ0RL = parcelRequire("kQ0RL");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6Dw6K = parcelRequire("6Dw6K");

var $01Ijb = parcelRequire("01Ijb");
const $6c353f4fb7ab217f$export$e6d35b1c4e81af0e = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagService)();
    return (0, $eUqFw.useCallback)(()=>{
        const id = `error-${(0, $6Dw6K.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $8vPhU.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c353f4fb7ab217f$export$92c0939d1a977673, {
                    ...props,
                    id: id,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $6c353f4fb7ab217f$var$JIRA_SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $6c353f4fb7ab217f$export$92c0939d1a977673 = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.ErrorFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage((0, $01Ijb.messages).title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $01Ijb.messages).description))),
        actions: [
            {
                content: formatMessage((0, $01Ijb.messages).action),
                href: $6c353f4fb7ab217f$var$JIRA_SUPPORT_LINK,
                target: '_blank'
            }
        ]
    });
};

});
parcelRegister("01Ijb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $490567766fce628a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $490567766fce628a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "invite-prompt-on-link-insert.invite-error-flag.title",
        "defaultMessage": "Something went wrong"
    },
    description: {
        "id": "invite-prompt-on-link-insert.invite-error-flag.description",
        "defaultMessage": "Try inviting your teammates again. If the problem persists, contact support."
    },
    action: {
        "id": "invite-prompt-on-link-insert.invite-error-flag.action",
        "defaultMessage": "Contact support"
    }
});

});


parcelRegister("h7mRL", function(module, exports) {

$parcel$export(module.exports, "useInvitePromptFlag", () => $7dba77502abc6172$export$ce7c2ea6d33a7cf4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8vPhU = parcelRequire("8vPhU");
var $kQ0RL = parcelRequire("kQ0RL");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6Dw6K = parcelRequire("6Dw6K");

var $aa1dQ = parcelRequire("aa1dQ");

var $cBUBp = parcelRequire("cBUBp");

var $8EYjY = parcelRequire("8EYjY");
const $7dba77502abc6172$export$ce7c2ea6d33a7cf4 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(({ targetPageLabel: targetPageLabel, product: product, users: users, allowOptOut: allowOptOut, onSubmit: onSubmit, onDismiss: onDismiss, onOptOut: onOptOut, shouldOpenCoreInvites: shouldOpenCoreInvites, onOpenCoreInvites: onOpenCoreInvites })=>{
        const id = `invite-${(0, $6Dw6K.generateId)()}`;
        const dismissTheFlag = ()=>dismissFlag((0, $8vPhU.dismissFlag)(id));
        const attributes = {
            invitees: users.length,
            renderedPageTitle: !!targetPageLabel,
            allowOptOut: allowOptOut
        };
        const submit = async (getRecaptchaToken)=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'addPeopleButtonInviteOnLinkInsert', attributes);
            await onSubmit(getRecaptchaToken);
            dismissTheFlag();
        };
        const openCoreInvites = ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'selectPeopleButtonInviteOnLinkInsert', attributes);
            onOpenCoreInvites();
            dismissTheFlag();
        };
        const optOut = ()=>{
            dismissTheFlag();
            onOptOut();
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'optOutButtonInviteOnLinkInsert', attributes);
        };
        const dismiss = ()=>{
            dismissTheFlag();
            onDismiss();
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', 'inviteOnLinkInsert', attributes);
        };
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'flag shown', 'inviteOnLinkInsert', attributes);
        showFlag({
            id: id,
            isLowPriority: true,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dba77502abc6172$export$d6bef3efd7271258, {
                    ...props,
                    id: id,
                    users: users,
                    targetPageLabel: targetPageLabel,
                    onDismiss: dismiss,
                    onSubmit: submit,
                    onOptOut: allowOptOut ? optOut : undefined,
                    product: product,
                    shouldOpenCoreInvites: shouldOpenCoreInvites,
                    onOpenCoreInvites: openCoreInvites
                })
        });
    }, [
        createAnalyticsEvent,
        dismissFlag,
        showFlag
    ]);
};
const $7dba77502abc6172$export$d6bef3efd7271258 = ({ users: users, onSubmit: onSubmit, onDismiss: onDismiss, onOptOut: onOptOut, targetPageLabel: targetPageLabel, product: product, shouldOpenCoreInvites: shouldOpenCoreInvites, onOpenCoreInvites: onOpenCoreInvites, ...props })=>{
    const { isRecaptchaLoaded: isRecaptchaLoaded, getRecaptchaToken: getRecaptchaToken, recaptchaLoadErrorReason: recaptchaLoadErrorReason } = (0, $8EYjY.useRecaptcha)();
    const isInviteDisabled = !isRecaptchaLoaded && recaptchaLoadErrorReason === undefined;
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const productDisplayName = (0, $6Dw6K.getProductDisplayName)(product);
    const handleOnSubmit = (0, $eUqFw.useCallback)(async ()=>{
        setIsLoading(true);
        await onSubmit(getRecaptchaToken);
    }, [
        onSubmit,
        getRecaptchaToken
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const optOutEnabled = onOptOut !== undefined;
    const customFlagFooterProps = (0, $eUqFw.useMemo)(()=>({
            // Workaround to achieve primary button + avatars in the footer.
            //
            // How this works:
            // We pass a dummy `action` that gets displayed in the Flag's footer
            // by the custom `linkComponent`. The component displays our actual footer.
            // This way, we don't occupy the limited space inside `description`.
            //
            // Why not use `actions` normally?
            // Because our Avatar Group is not an action, and even our Submit button
            // should be bold & blue (appearance="primary") which is not supported
            // by the AK Flag.
            //
            // Why not put this in `description`?
            // Because that one has a max height equivalent to 5 lines of text,
            // and our footer is taller than 2, causing an unwanted scrollbar
            // to show.
            actions: [
                {
                    content: '',
                    // Replace with lodash/noop
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    onClick: ()=>{}
                }
            ],
            linkComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !shouldOpenCoreInvites && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8EYjY.RecaptchaTerms), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dba77502abc6172$var$ButtonsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dba77502abc6172$var$ButtonItem, {
                    optOutEnabled: optOutEnabled
                }, shouldOpenCoreInvites ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    appearance: "primary",
                    spacing: "compact",
                    onClick: onOpenCoreInvites
                }, formatMessage((0, $cBUBp.messages).selectPeopleButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
                    appearance: "primary",
                    onClick: handleOnSubmit,
                    spacing: "compact",
                    isDisabled: isInviteDisabled,
                    isLoading: isLoading
                }, formatMessage((0, $cBUBp.messages).addPeopleButton, {
                    inviteeCount: users.length
                }))), optOutEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dba77502abc6172$var$ButtonItem, {
                    optOutEnabled: optOutEnabled
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    appearance: "subtle-link",
                    onClick: onOptOut,
                    spacing: "compact",
                    isDisabled: isLoading
                }, formatMessage((0, $cBUBp.messages).dismiss, {})))))
        }), [
        onOptOut,
        optOutEnabled,
        handleOnSubmit,
        users,
        formatMessage,
        isInviteDisabled,
        isLoading,
        shouldOpenCoreInvites,
        onOpenCoreInvites
    ]);
    const maxLength = 20;
    const clampedTargetPageLabel = (0, $6Dw6K.clampString)(targetPageLabel || '', maxLength);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.InfoFlag), {
        ...props,
        ...customFlagFooterProps,
        onDismissed: onDismiss,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $7dba77502abc6172$var$avatarsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aa1dQ.FlagCompatibleAvatarGroup), {
            data: users.map((user)=>({
                    name: user.name,
                    src: user.avatar,
                    appearance: 'circle',
                    size: 'medium'
                })),
            boundariesElement: "scrollParent"
        })), formatMessage((0, $cBUBp.messages).titleGeneric, {
            inviteeCount: users.length,
            displayName: users[0].name,
            productDisplayName: productDisplayName
        })),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dba77502abc6172$var$MainContentContainer, null, targetPageLabel ? formatMessage((0, $cBUBp.messages).descriptionWithPageTitleGeneric, {
            strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks.join('')),
            inviteeCount: users.length,
            title: clampedTargetPageLabel,
            productDisplayName: productDisplayName
        }) : formatMessage((0, $cBUBp.messages).descriptionWithoutPageTitleGeneric, {
            inviteeCount: users.length,
            productDisplayName: productDisplayName
        }))
    });
};
const $7dba77502abc6172$var$avatarsContainerStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.negative.025',
    // Aligns avatars with the rest of the text
    marginTop: 'space.negative.025',
    marginBottom: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7dba77502abc6172$var$MainContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0ccj1k _1yyj11wp _sudp1e54 _1reo15vq _18m915vq _18s8ze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7dba77502abc6172$var$ButtonsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2hwxmgjw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7dba77502abc6172$var$ButtonItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { optOutEnabled: optOutEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.optOutEnabled ? "_p12f1lit" : "_p12fsb0t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aa1dQ", function(module, exports) {

$parcel$export(module.exports, "FlagCompatibleAvatarGroup", () => $ad3c4cb8bc523c66$export$29beada2d5f93289);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4XQdE = parcelRequire("4XQdE");
const $ad3c4cb8bc523c66$export$29beada2d5f93289 = ({ data: data, ...props })=>{
    const { data: customData, overrides: customOverrides } = (0, $eUqFw.useMemo)(()=>$ad3c4cb8bc523c66$export$bc55c1ff86d63c4d({
            data: data
        }), [
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        maxCount: 999,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        tooltipPosition: "top",
        // Prevents the More popup. XXX: The popup has the wrong zIndex and displays under the flag
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onMoreClick: ()=>{},
        ...props
    });
};
const $ad3c4cb8bc523c66$var$MAX_AVATARS_FEATURED = 5;
const $ad3c4cb8bc523c66$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED = 99;
const $ad3c4cb8bc523c66$var$OVERFLOW_USER_MARKER = '$$$overflow-user-marker';
const $ad3c4cb8bc523c66$export$bc55c1ff86d63c4d = ({ data: users })=>{
    const overflows = users.length > $ad3c4cb8bc523c66$var$MAX_AVATARS_FEATURED;
    const lastFeaturedUser = $ad3c4cb8bc523c66$var$MAX_AVATARS_FEATURED - 1;
    const featuredUsers = users.slice(0, lastFeaturedUser);
    const overflowUsers = users.slice(lastFeaturedUser);
    const overflowMarkerDummyUser = $ad3c4cb8bc523c66$export$1b8d8867a2d1ffbd(overflowUsers);
    const processedUsers = overflows ? [
        ...featuredUsers,
        overflowMarkerDummyUser
    ] : users;
    const overrides = {
        Avatar: {
            render: (AvatarComponent, avatarProps)=>{
                if (avatarProps.name === overflowMarkerDummyUser.name && avatarProps.key === overflowMarkerDummyUser.key) return $ad3c4cb8bc523c66$var$renderAvatarWithOverflowCount(AvatarComponent, avatarProps, overflowUsers.length);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AvatarComponent, avatarProps);
            }
        }
    };
    return {
        overrides: overrides,
        data: processedUsers
    };
};
const $ad3c4cb8bc523c66$export$1b8d8867a2d1ffbd = (overflowUsers)=>({
        name: overflowUsers.map((u)=>u.name).join(', '),
        key: $ad3c4cb8bc523c66$var$OVERFLOW_USER_MARKER
    });
const $ad3c4cb8bc523c66$var$renderAvatarWithOverflowCount = (AvatarComponent, avatarProps, overflowCount)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AvatarComponent, {
        name: avatarProps.name,
        appearance: avatarProps.appearance,
        size: avatarProps.size,
        borderColor: avatarProps.borderColor,
        stackIndex: 0
    }, (avatarChildrenProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad3c4cb8bc523c66$var$AvatarOverflowCountContainer, avatarChildrenProps, `+${Math.min(overflowCount, $ad3c4cb8bc523c66$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED)}`));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad3c4cb8bc523c66$var$AvatarOverflowCountContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkj6p2 _syaz1ktl _y3gn1s23 _k48p124r",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cBUBp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1b7f42f074d2ba44$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1b7f42f074d2ba44$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    addPeopleButton: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.add-people-button",
        "defaultMessage": "{inviteeCount, plural, one {Add # person} other {Add # people}}"
    },
    dismiss: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.dismiss",
        "defaultMessage": "Don't show again"
    },
    titleGeneric: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.title-generic",
        "defaultMessage": "{inviteeCount, plural, one {{displayName} needs access to {productDisplayName}} other {People need access to {productDisplayName}}}"
    },
    descriptionWithoutPageTitleGeneric: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.description-without-page-title-generic",
        "defaultMessage": "{inviteeCount, plural, one {Invite 1 person who needs access to collaborate with you.} other {Invite people who need access to collaborate with you.}}"
    },
    descriptionWithPageTitleGeneric: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.description-with-page-title-generic",
        "defaultMessage": "{inviteeCount, plural, one {Invite 1 person who needs access to collaborate with you on <strong>{title}</strong>.} other {Invite people who need access to collaborate with you on <strong>{title}</strong>.}}"
    },
    selectPeopleButton: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.select-people-button",
        "defaultMessage": "Select people"
    }
});

});

parcelRegister("8EYjY", function(module, exports) {

$parcel$export(module.exports, "useRecaptcha", () => $8435994fb5671e15$export$f7242fdfba1703e8);
$parcel$export(module.exports, "RecaptchaTerms", () => $8435994fb5671e15$export$f393864b6f4d4337);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ccE3R = parcelRequire("ccE3R");
var $65Cy1 = parcelRequire("65Cy1");

var $3e9vj = parcelRequire("3e9vj");

var $128HT = parcelRequire("128HT");
const $8435994fb5671e15$export$f7242fdfba1703e8 = ()=>{
    const environment = (0, $3e9vj.useEnvironment)();
    return (0, $65Cy1.useInvisibleRecaptcha)({
        siteKey: (0, $128HT.getRecaptchaSiteKey)(environment),
        displayBadge: false,
        analyticsChannel: 'jira',
        analyticsSource: 'inviteOnLinkInsert'
    });
};
const $8435994fb5671e15$export$f393864b6f4d4337 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8435994fb5671e15$var$RecaptchaContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ccE3R.default), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8435994fb5671e15$var$RecaptchaContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb19bv _syaz1rc1 _19pk12x7 _otyr1b66",
            __cmplp.className
        ])
    });
});

});


parcelRegister("94ERq", function(module, exports) {

$parcel$export(module.exports, "useInviteSuccessFlag", () => $1ee7b642921c554b$export$c323779e5ddf45d0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8vPhU = parcelRequire("8vPhU");
var $kQ0RL = parcelRequire("kQ0RL");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6Dw6K = parcelRequire("6Dw6K");

var $4nJFz = parcelRequire("4nJFz");
const $1ee7b642921c554b$export$c323779e5ddf45d0 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagService)();
    return (0, $eUqFw.useCallback)(({ users: users, product: product })=>{
        const id = `success-${(0, $6Dw6K.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $8vPhU.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ee7b642921c554b$export$6c436beee6e5593, {
                    ...props,
                    id: id,
                    users: users,
                    onDismiss: dismiss,
                    product: product
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $1ee7b642921c554b$export$6c436beee6e5593 = ({ users: users, onDismiss: onDismiss, product: product, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const maxLength = 25;
    const invitedEmail = (0, $6Dw6K.clampString)(users[0]?.email || users[0].name, maxLength);
    const productDisplayName = (0, $6Dw6K.getProductDisplayName)(product);
    const customFlagFooterProps = (0, $eUqFw.useMemo)(()=>({
            actions: [
                {
                    content: '',
                    // Replace with lodash/noop
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    onClick: ()=>{}
                }
            ],
            linkComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ee7b642921c554b$var$FooterParagraph, null, formatMessage((0, $4nJFz.messages).additionalInfoGeneric, {
                    productDisplayName: productDisplayName
                }))
        }), [
        formatMessage,
        productDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.SuccessFlag), {
        ...props,
        ...customFlagFooterProps,
        onDismissed: onDismiss,
        title: formatMessage((0, $4nJFz.messages).title, {
            inviteeCount: users.length
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $4nJFz.messages).descriptionGeneric, {
            strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks.join('')),
            inviteeCount: users.length,
            email: invitedEmail,
            productDisplayName: productDisplayName
        }))
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ee7b642921c554b$var$FooterParagraph = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazjjyb _t9ec1gty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4nJFz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $17bbccf2d88ab8c2$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $17bbccf2d88ab8c2$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "invite-prompt-on-link-insert.invite-success-flag.title",
        "defaultMessage": "{inviteeCount, plural, one {Invite successfully sent} other {Invites successfully sent}}"
    },
    dismiss: {
        "id": "invite-prompt-on-link-insert.invite-success-flag.dismiss",
        "defaultMessage": "Ok, got it"
    },
    descriptionGeneric: {
        "id": "invite-prompt-on-link-insert.invite-success-flag.description-generic",
        "defaultMessage": "{inviteeCount, plural, one {We emailed <strong>{email}</strong> inviting them to {productDisplayName}.} other {We emailed <strong># people</strong> inviting them to {productDisplayName}.}}"
    },
    additionalInfoGeneric: {
        "id": "invite-prompt-on-link-insert.invite-success-flag.additional-info-generic",
        "defaultMessage": "Some people might need your admin's approval before they can join {productDisplayName}."
    }
});

});



parcelRegister("6wbGr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f8111dde2239926$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lBMPF = parcelRequire("lBMPF");

var $jBBmJ = parcelRequire("jBBmJ");

var $5EhQN = parcelRequire("5EhQN");

var $jwsfc = parcelRequire("jwsfc");

var $2u5WE = parcelRequire("2u5WE");

var $i5ULy = parcelRequire("i5ULy");

var $quOC4 = parcelRequire("quOC4");
const $0f8111dde2239926$var$SINGLE_COLUMN_MAX_WIDTH = 480;
const $0f8111dde2239926$var$transformAppLinkForSelect = (confluenceAppLinks)=>{
    const remoteLinks = confluenceAppLinks.map((item)=>(0, $jBBmJ.transformAppLink)(item));
    return [
        ...remoteLinks
    ];
};
const $0f8111dde2239926$var$ConfluenceSearchGroupView = (props)=>{
    const { linkedPages: linkedPages, mentionedPages: mentionedPages, recentOptions: recentOptions, validationState: validationState, validationMessage: validationMessage, onSelect: onSelect, onEnter: onEnter, isAutoFocusable: isAutoFocusable, link: link, confluenceAppLinks: confluenceAppLinks, isLoading: isLoading, onChange: onChange, containerWidth: containerWidth } = props;
    const [appId, setAppId] = (0, $eUqFw.useState)(confluenceAppLinks.length > 0 ? confluenceAppLinks[0].id : '');
    const [spaceKey, setSpaceKey] = (0, $eUqFw.useState)('');
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onSpaceKeyChange = (newSpaceKey)=>{
        setSpaceKey(newSpaceKey); //  SpaceKey;
    };
    const isCompact = containerWidth !== undefined ? containerWidth <= $0f8111dde2239926$var$SINGLE_COLUMN_MAX_WIDTH : false;
    const showConfluenceAppLinkSelect = confluenceAppLinks.length > 1;
    const confluenceAppLinksForSelect = $0f8111dde2239926$var$transformAppLinkForSelect(confluenceAppLinks);
    const [confluenceAppLink, setConfluenceAppLink] = (0, $eUqFw.useState)();
    const onConfluenceAppLinkChange = (item)=>{
        setAppId(item.fullObject.id);
        setConfluenceAppLink(item);
        setSpaceKey('');
    };
    const searchContainer = (0, $eUqFw.useRef)(null);
    const focusOnSearchInput = ()=>{
        if (searchContainer.current instanceof HTMLElement) {
            const input = searchContainer.current.querySelector('input');
            if (input !== null) input.focus();
        }
    };
    (0, $eUqFw.useEffect)(()=>{
        if (isAutoFocusable) focusOnSearchInput();
    }, [
        isAutoFocusable
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "confluence-search" /* eslint-disable-next-line jira/js/package-name-enforcer-for-error-boundary */ ,
        packageName: "jiraIssueViewConfluence",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0f8111dde2239926$var$AddContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0f8111dde2239926$var$InputsContainer, {
        isCompact: isCompact
    }, showConfluenceAppLinkSelect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0f8111dde2239926$var$SelectContainer, {
        isCompact: isCompact
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2u5WE.default), {
        selectItems: confluenceAppLinksForSelect,
        value: confluenceAppLink,
        containerWidth: containerWidth,
        onChange: onConfluenceAppLinkChange,
        selectType: "ConfluenceAppLinksSelect"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0f8111dde2239926$var$SelectContainer, {
        isCompact: isCompact
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $quOC4.default), {
        onSpaceKeyChange: onSpaceKeyChange,
        spaceKey: spaceKey,
        appId: appId,
        isCompact: isCompact
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0f8111dde2239926$var$ConfluenceSearchContainer, {
        ref: searchContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jwsfc.default), {
        appId: appId,
        spaceKey: spaceKey,
        linkedPages: linkedPages,
        mentionedPages: mentionedPages,
        recentOptions: recentOptions,
        labels: {
            recentPages: formatMessage((0, $5EhQN.default).defaultRecentPages),
            matchingPages: formatMessage((0, $5EhQN.default).defaultMatchingPages)
        }
    }, ({ fetchSuggestions: fetchSuggestions, options: options, loading: isLoadingOptions, error: error, type: type, clearState: clearSearchState })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i5ULy.default), {
            spaceKey: spaceKey,
            isLoading: isLoading,
            isLoadingOptions: isLoadingOptions,
            options: options,
            onChange: onChange,
            validationState: validationState,
            validationMessage: validationMessage,
            onSelect: onSelect,
            onEnter: onEnter,
            link: link,
            fetchSuggestions: fetchSuggestions,
            optionsError: error,
            resultType: type,
            clearSearchState: clearSearchState
        }))))));
};
var $0f8111dde2239926$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $lBMPF.default)($0f8111dde2239926$var$ConfluenceSearchGroupView);
const $0f8111dde2239926$var$AddContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81bpf _u5f3v77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f8111dde2239926$var$InputsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompact: isCompact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1b1v _ae4v1fhb _1mizu2gc",
            __cmplp.isCompact ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.isCompact ? "_1yp8idpf" : "_1yp8u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f8111dde2239926$var$SelectContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompact: isCompact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9bv7e",
            __cmplp.isCompact ? "_p12fglyw" : "_p12fuuw1",
            __cmplp.isCompact ? "_1bsb1osq" : "_1bsb1q0g",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f8111dde2239926$var$ConfluenceSearchContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _i0dl1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jBBmJ", function(module, exports) {

$parcel$export(module.exports, "transformAppLink", () => $1b11abee0775953d$export$ab47f9615d08a5bd);
const $1b11abee0775953d$export$ab47f9615d08a5bd = (item)=>({
        label: `${item.name}`,
        value: item.id,
        fullObject: item
    });

});

parcelRegister("5EhQN", function(module, exports) {

$parcel$export(module.exports, "default", () => $72412cd14838522f$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $72412cd14838522f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    defaultRecentPages: {
        "id": "issue.views.confluence-search-view.default-recent-view",
        "defaultMessage": "Recently visited"
    },
    defaultMatchingPages: {
        "id": "issue.views.confluence-search-view.default-matching-pages",
        "defaultMessage": "Matching pages"
    }
});

});

parcelRegister("jwsfc", function(module, exports) {

$parcel$export(module.exports, "default", () => $03c42fc19daa8f6d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $hTLlD = parcelRequire("hTLlD");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6CBle = parcelRequire("6CBle");
const $03c42fc19daa8f6d$export$3a3072dd741f354b = 300;
const $03c42fc19daa8f6d$var$DEFAULT_COUNTER = {
    value: 0,
    input: ''
};
// @ts-expect-error - TS7006 - Parameter 'options' implicitly has an 'any' type. | TS7006 - Parameter 'resolve' implicitly has an 'any' type. | TS7006 - Parameter 'reject' implicitly has an 'any' type.
const $03c42fc19daa8f6d$var$searchCall = (options, resolve, reject)=>{
    const { inputValue: inputValue, appId: appId, spaceKey: spaceKey } = options;
    const modifiedSpaceKey = spaceKey !== '' ? `"${spaceKey}"` : ''; // Wrap spaceKey into quotes if spaceKey is passed otherwise it will fail for special characters in spaceKey
    (0, $lRmyA.performGetRequest)((0, $6CBle.getSearchUrl)(inputValue, appId, modifiedSpaceKey)).then(resolve).catch(reject);
};
const $03c42fc19daa8f6d$var$debouncedFetch = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))($03c42fc19daa8f6d$var$searchCall, $03c42fc19daa8f6d$export$3a3072dd741f354b, {
    leading: false
});
const $03c42fc19daa8f6d$var$ConfluenceSearchService = (props)=>{
    const { appId: appId, spaceKey: spaceKey = '', children: children, recentOptions: recentOptions, labels: labels, linkedPages: linkedPages, mentionedPages: mentionedPages } = props;
    const recentTransformedOption = (0, $6CBle.transformRecentOptions)(recentOptions, labels.recentPages, spaceKey);
    // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
    const [state, dispatch] = (0, $eUqFw.useReducer)((0, $6CBle.confluenceSearchReducer), {
        loading: false,
        options: recentTransformedOption,
        error: null,
        type: 'recent'
    });
    const counter = (0, $eUqFw.useRef)($03c42fc19daa8f6d$var$DEFAULT_COUNTER);
    (0, $eUqFw.useEffect)(()=>{
        // Recent has been changed
        // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'. | TS2339 - Property 'options' does not exist on type 'never'.
        if (state.type === 'recent' && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(state.options, recentTransformedOption)) // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
        dispatch({
            type: 'SEARCH_API_RESET',
            payload: {
                options: recentTransformedOption
            }
        });
    // @ts-expect-error - TS2339 - Property 'options' does not exist on type 'never'. | TS2339 - Property 'type' does not exist on type 'never'.
    }, [
        recentTransformedOption,
        state.options,
        state.type
    ]);
    const { loading: loading, error: error, type: type, options: options } = state;
    const clearState = (0, $eUqFw.useCallback)(()=>{
        // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
        dispatch({
            type: 'SEARCH_API_CLEAR',
            payload: {
                options: []
            }
        });
        counter.current = $03c42fc19daa8f6d$var$DEFAULT_COUNTER;
    }, []);
    const handleResponse = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'response' implicitly has an 'any' type.
    (response, currentCounter)=>{
        if (currentCounter === counter.current.value) {
            const filteredRecent = (0, $6CBle.getFilteredRecentOptions)(recentOptions, counter.current.input, spaceKey);
            const searchResults = (0, $6CBle.transformSearchOptions)(response.result, labels.matchingPages, linkedPages, mentionedPages, filteredRecent);
            // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
            dispatch({
                type: 'SEARCH_API_DONE',
                payload: {
                    options: (0, $6CBle.mergeResponse)(filteredRecent, searchResults)
                }
            });
        }
    }, [
        labels.matchingPages,
        linkedPages,
        mentionedPages,
        recentOptions,
        spaceKey
    ]);
    const handleError = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'fetchError' implicitly has an 'any' type.
    (fetchError, currentCounter)=>{
        (0, $guiFP.default)({
            error: fetchError,
            meta: {
                id: 'getConfluenceSearchService',
                // eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics
                packageName: 'jiraIssueView',
                teamName: 'bento'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        if (currentCounter === counter.current.value) {
            const filteredRecent = (0, $6CBle.getFilteredRecentOptions)(recentOptions, counter.current.input, spaceKey);
            const searchResults = (0, $6CBle.transformSearchOptions)([], labels.matchingPages);
            const mergedOptions = (0, $6CBle.mergeResponse)(filteredRecent, searchResults);
            counter.current = $03c42fc19daa8f6d$var$DEFAULT_COUNTER;
            // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
            dispatch({
                type: 'SEARCH_API_ERROR',
                payload: {
                    options: mergedOptions,
                    error: // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '1' and '0' have no overlap.
                    mergedOptions.length === 0 || mergedOptions[0].options.length === 0 ? fetchError : null
                }
            });
        }
    }, [
        labels.matchingPages,
        recentOptions,
        spaceKey
    ]);
    const fetchSuggestions = (0, $eUqFw.useCallback)((inputValue)=>{
        counter.current.value += 1;
        counter.current.input = inputValue;
        const currentCounter = counter.current.value;
        if (inputValue && inputValue !== '') {
            // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
            dispatch({
                type: 'SEARCH_API_LOADING',
                payload: {
                    options: (0, $6CBle.transformSearchOptions)([], labels.matchingPages)
                }
            });
            $03c42fc19daa8f6d$var$debouncedFetch({
                inputValue: inputValue,
                appId: appId,
                spaceKey: spaceKey
            }, // @ts-expect-error - TS7006 - Parameter 'response' implicitly has an 'any' type.
            (response)=>handleResponse(response, currentCounter), // @ts-expect-error - TS7006 - Parameter 'err' implicitly has an 'any' type.
            (err)=>handleError(err, currentCounter));
            return;
        }
        if (currentCounter === counter.current.value) {
            counter.current = $03c42fc19daa8f6d$var$DEFAULT_COUNTER;
            // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
            dispatch({
                type: 'SEARCH_API_RESET',
                payload: {
                    options: recentTransformedOption
                }
            });
        }
    }, [
        appId,
        handleError,
        handleResponse,
        labels.matchingPages,
        recentTransformedOption,
        spaceKey
    ]);
    return children({
        fetchSuggestions: fetchSuggestions,
        loading: loading,
        error: error,
        type: type,
        options: options,
        clearState: clearState
    });
};
var $03c42fc19daa8f6d$export$2e2bcd8739ae039 = $03c42fc19daa8f6d$var$ConfluenceSearchService;

});
parcelRegister("6CBle", function(module, exports) {

$parcel$export(module.exports, "getSearchUrl", () => $168af329f94cf65d$export$7d4675b206f57488);
$parcel$export(module.exports, "transformRecentOptions", () => $168af329f94cf65d$export$90759bd5f86c0ba9);
$parcel$export(module.exports, "transformSearchOptions", () => $168af329f94cf65d$export$9da73aef62981cce);
$parcel$export(module.exports, "confluenceSearchReducer", () => $168af329f94cf65d$export$519fb7889e4b3fa0);
$parcel$export(module.exports, "getFilteredRecentOptions", () => $168af329f94cf65d$export$13ee64baf68547bc);
$parcel$export(module.exports, "mergeResponse", () => $168af329f94cf65d$export$b5f90e451f59a584);

var $cEc3i = parcelRequire("cEc3i");

var $3ElT9 = parcelRequire("3ElT9");

var $6vrw7 = parcelRequire("6vrw7");
const $168af329f94cf65d$export$31ecae7225aecec6 = 20;
const $168af329f94cf65d$var$SUPPORTED_CONTENT_TYPES = [
    'blogpost',
    'page'
];
const $168af329f94cf65d$var$filterRecentResults = (0, $cEc3i.c)();
const $168af329f94cf65d$export$7d4675b206f57488 = (query, appId, spaceKey = '')=>`/rest/confluenceIssueLink/1/confluence/search?query=${query}&appId=${appId}&spaceKey=${spaceKey}&maxResults=${$168af329f94cf65d$export$31ecae7225aecec6}&_=${Date.now()}`;
const $168af329f94cf65d$export$90759bd5f86c0ba9 = (options, label, spaceKey)=>{
    const filteredOptions = options.filter((option)=>{
        if (spaceKey) return option.page.spaceKey === spaceKey;
        return true;
    });
    return [
        {
            label: label,
            options: filteredOptions
        }
    ];
};
const $168af329f94cf65d$export$9da73aef62981cce = (options, label, linkedPages = [], mentionPages = [], filteredRecent = [])=>{
    const recentPages = filteredRecent.map((option)=>option.page);
    const linkedPageHrefs = linkedPages.concat(recentPages, mentionPages)// @ts-expect-error - TS2339 - Property 'href' does not exist on type 'FailedRemoteLink | ConfluencePage'.
    .map((page)=>page.href || '');
    return [
        {
            label: label,
            options: options.filter((page)=>$168af329f94cf65d$var$SUPPORTED_CONTENT_TYPES.includes(page.type)).map((option)=>{
                const page = {
                    id: (0, $6vrw7.toConfluencePageId)(option.id.toString()),
                    globalId: (0, $6vrw7.toRemoteLinkGlobalId)(''),
                    href: (0, $6vrw7.toHref)(option.url),
                    title: option.title,
                    type: (0, $3ElT9.toConfluencePageType)(option.type),
                    space: option.spaceName !== undefined ? option.spaceName : '',
                    lastModified: option.lastModified !== undefined ? new Date(option.lastModified).getTime() : 0
                };
                return {
                    label: option.title,
                    value: option.url,
                    page: page,
                    data: page
                };
            }).filter((option)=>!linkedPageHrefs.includes(option.page.href))
        }
    ];
};
const $168af329f94cf65d$export$519fb7889e4b3fa0 = (state, action)=>{
    const { type: type, payload: payload = {} } = action;
    const { options: options = [], error: error = null } = payload;
    const currentState = {
        loading: false,
        options: options,
        error: error,
        type: 'search'
    };
    switch(type){
        case 'SEARCH_API_LOADING':
            // @ts-expect-error - TS2322 - Type '{ loading: true; options: Options; error: Error | null; type: string; }' is not assignable to type 'State'.
            return {
                ...currentState,
                loading: true
            };
        case 'SEARCH_API_DONE':
        case 'SEARCH_API_ERROR':
            // @ts-expect-error - TS2322 - Type '{ loading: boolean; options: Options; error: Error | null; type: string; }' is not assignable to type 'State'.
            return currentState;
        case 'SEARCH_API_CLEAR':
            // @ts-expect-error - TS2322 - Type '{ options: []; loading: boolean; error: Error | null; type: string; }' is not assignable to type 'State'.
            return {
                ...currentState,
                options: []
            };
        case 'SEARCH_API_RESET':
            return {
                ...currentState,
                type: 'recent'
            };
        default:
            return state;
    }
};
const $168af329f94cf65d$export$13ee64baf68547bc = (allRecent, input, spaceKey)=>allRecent.filter((option)=>{
        if (spaceKey) // @ts-expect-error - TS2345 - Argument of type 'SelectOption' is not assignable to parameter of type 'Option'.
        return option.page.spaceKey === spaceKey ? $168af329f94cf65d$var$filterRecentResults(option, input) : false;
        // @ts-expect-error - TS2345 - Argument of type 'SelectOption' is not assignable to parameter of type 'Option'.
        return $168af329f94cf65d$var$filterRecentResults(option, input);
    });
const $168af329f94cf65d$export$b5f90e451f59a584 = (recent, search)=>{
    if (search && search.length > 0 && recent.length > 0) {
        const { options: options, label: label } = search[0];
        return [
            {
                label: label,
                options: [
                    ...recent,
                    ...options
                ].slice(0, $168af329f94cf65d$export$31ecae7225aecec6)
            }
        ];
    }
    return search;
};

});


parcelRegister("2u5WE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ecc4e993c8d0127$export$2e2bcd8739ae039);

var $kdkji = parcelRequire("kdkji");

var $lqalZ = parcelRequire("lqalZ");

var $a0kZP = parcelRequire("a0kZP");
var $8ecc4e993c8d0127$export$2e2bcd8739ae039 = (0, $lqalZ.connect)(()=>({}), {
    onAuthenticateAppLink: (0, $a0kZP.applinkAuthenticationRequest)
})((0, $kdkji.AppLinksSelect));

});
parcelRegister("kdkji", function(module, exports) {

$parcel$export(module.exports, "AppLinksSelect", () => $369724f5412f25dc$export$82eac1a4409ef26a);
$parcel$export(module.exports, "default", () => $369724f5412f25dc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $aR8n6 = parcelRequire("aR8n6");

var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("gLLZt");
var $7nzO5 = parcelRequire("7nzO5");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $1CESf = parcelRequire("1CESf");

var $3EBqK = parcelRequire("3EBqK");

var $8e08R = parcelRequire("8e08R");
const $369724f5412f25dc$var$customSelectStyle = {
    ...(0, $7nzO5.defaultSelectStyles),
    // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'state' implicitly has an 'any' type.
    menu: (base, state)=>{
        const defaultMenu = (0, $7nzO5.defaultSelectStyles).menu ? (0, $7nzO5.defaultSelectStyles).menu(base, state) : {};
        return {
            ...defaultMenu,
            minWidth: state.selectProps.containerWidth || 'auto'
        };
    },
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    option: (...args)=>{
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        const defaultOption = (0, $7nzO5.defaultSelectStyles).option ? (0, $7nzO5.defaultSelectStyles).option(...args) : {};
        return {
            ...defaultOption,
            overflow: 'initial'
        };
    }
};
const $369724f5412f25dc$export$82eac1a4409ef26a = (props)=>{
    const { selectType: selectType } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const formatOptionLabel = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1CESf.AppLinkOption), {
            value: option,
            onAuthenticateAppLink: props.onAuthenticateAppLink,
            selectType: selectType
        });
    const getNumAppLinksRequiringAuth = ()=>props.selectItems.filter((item)=>item.fullObject.requireCredentials).length;
    const sendMenuAnalytics = (analyticsEvent, action)=>{
        analyticsEvent && (0, $jMP2a.fireUIAnalytics)(analyticsEvent, `issueView.${selectType} ${action}`, selectType, {
            numAppLinks: props.selectItems.length - 1,
            numAppLinksRequiringAuth: getNumAppLinksRequiringAuth()
        });
    };
    const onChange = (option, analyticsEvent)=>{
        props.onChange(option);
        analyticsEvent && (0, $jMP2a.fireUIAnalytics)(analyticsEvent, `issueView.${selectType} changed`, selectType, {
            appLinkId: option.fullObject.id
        });
    };
    const { selectItems: selectItems, value: value, containerWidth: containerWidth } = props;
    const selectAriaLabel = selectType === 'JiraAppLinksSelect' ? formatMessage((0, $3EBqK.messages).jiraInstanceSelectorAriaLabel) : formatMessage((0, $3EBqK.messages).confluenceInstanceSelectorAriaLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        packageName: "jiraIssueViewCommonViews",
        id: selectType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8e08R.SelectWithAnalytics), {
        "aria-label": selectAriaLabel,
        placeholder: formatMessage((0, $3EBqK.messages).placeholderText),
        options: selectItems,
        value: value,
        // @ts-expect-error - TS7006 - Parameter 'option' implicitly has an 'any' type. | TS7006 - Parameter 'actionMeta' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
        onChange: (option, actionMeta, analyticsEvent)=>onChange(option, analyticsEvent),
        formatOptionLabel: formatOptionLabel,
        // @ts-expect-error - TS7006 - Parameter 'option' implicitly has an 'any' type.
        isOptionDisabled: (option)=>option.fullObject.requireCredentials,
        styles: $369724f5412f25dc$var$customSelectStyle,
        // @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
        onMenuOpen: (analyticsEvent)=>sendMenuAnalytics(analyticsEvent, 'opened'),
        // @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
        onMenuClose: (analyticsEvent)=>sendMenuAnalytics(analyticsEvent, 'closed'),
        containerWidth: containerWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (analyticsEvent)=>{
            analyticsEvent && (0, $jMP2a.fireUIAnalytics)(analyticsEvent, `issueView.${selectType} mounted`, selectType, {
                numAppLinks: selectItems.length - 1,
                numAppLinksRequiringAuth: getNumAppLinksRequiringAuth()
            });
        }
    })));
};
var $369724f5412f25dc$export$2e2bcd8739ae039 = $369724f5412f25dc$export$82eac1a4409ef26a;

});
parcelRegister("1CESf", function(module, exports) {

$parcel$export(module.exports, "AppLinkOption", () => $8b53d2872b50dc3b$export$596cec4a4bebdab);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $f4A0J = parcelRequire("f4A0J");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $55mDm = parcelRequire("55mDm");
const $8b53d2872b50dc3b$export$596cec4a4bebdab = ({ value: value, onAuthenticateAppLink: onAuthenticateAppLink, selectType: selectType })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleClick = (e, analyticsEvent)=>{
        e.preventDefault();
        if (onAuthenticateAppLink) {
            onAuthenticateAppLink(value.fullObject.authUrl, analyticsEvent);
            analyticsEvent && (0, $jMP2a.fireUIAnalytics)(analyticsEvent, selectType, {
                appLinkId: value.fullObject.id
            });
        }
    };
    if (value.fullObject.requireCredentials) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: value.fullObject.baseUrl,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8b53d2872b50dc3b$var$StyledAppLink, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, value.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        spacing: "none",
        appearance: "link",
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4A0J))), {
            size: "small",
            label: ""
        }),
        interactionName: "auto-generated.jira-issue-view-common-views.app-link.app-link-option.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $55mDm.messages).remoteLinkAuthText)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: value.fullObject.baseUrl,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8b53d2872b50dc3b$var$StyledAppLink, null, value.label));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8b53d2872b50dc3b$var$StyledAppLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulputpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("55mDm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a02031a63aba2747$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $a02031a63aba2747$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    remoteLinkAuthText: {
        "id": "issues.issue-links.app-link-option.auth-required-nonfinal",
        "defaultMessage": "Authenticate to search"
    }
});

});


parcelRegister("3EBqK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c44859905e0aba11$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $c44859905e0aba11$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    jiraInstanceSelectorAriaLabel: {
        "id": "issues.issue-links.app-link-select.jira-instance-selector-aria-label",
        "defaultMessage": "Select Jira instance"
    },
    confluenceInstanceSelectorAriaLabel: {
        "id": "issues.issue-links.app-link-select.confluence-instance-selector-aria-label",
        "defaultMessage": "Select Confluence instance"
    },
    placeholderText: {
        "id": "issues.issue-links.app-link-select.placeholder",
        "defaultMessage": "Select application link"
    }
});

});

parcelRegister("8e08R", function(module, exports) {

$parcel$export(module.exports, "SelectWithAnalytics", () => $be2775a37278b339$export$f35c79a5a21cbec1);

var $2jDha = parcelRequire("2jDha");

var $4zgIJ = parcelRequire("4zgIJ");
const $be2775a37278b339$export$f35c79a5a21cbec1 = (0, $2jDha.default)({
    onMenuOpen: {
        action: 'opened',
        component: 'select'
    },
    onMenuClose: {
        action: 'closed',
        component: 'select'
    }
})((0, $4zgIJ.default));

});



parcelRegister("i5ULy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebcc493ace2af3be$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/react/no-style-attribute */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jXQ07 = parcelRequire("jXQ07");

var $4ksts = parcelRequire("4ksts");

var $3MCZY = parcelRequire("3MCZY");

var $51Cjn = parcelRequire("51Cjn");
const $ebcc493ace2af3be$export$2967f59ec63f650b = (error, type, formatMessage)=>{
    if (error || type === 'search') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $51Cjn.default).noResultOptionsMessage));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $51Cjn.default).noRecentOptionsMessage));
};
const $ebcc493ace2af3be$export$406c7ee80bb6929f = (props)=>{
    const { innerProps: innerProps, getStyles: getStyles, options: options } = props; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const group = getStyles('group', props); // The @atlaskit/select will export GroupHeadingProps, so for now we just use any as the temporary type
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const groupHeading = getStyles('groupHeading', props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebcc493ace2af3be$var$MainContainer, innerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebcc493ace2af3be$var$Group // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        group
    }, options.length > 0 ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebcc493ace2af3be$var$Label, {
        style: groupHeading
    }, options[0]?.label) : null));
};
const $ebcc493ace2af3be$var$ConfluenceSearchSelect = (props)=>{
    const filterOption = ()=>true;
    const { spaceKey: spaceKey, isLoading: isLoading, isLoadingOptions: isLoadingOptions, options: options, onChange: onChange, validationState: validationState, validationMessage: validationMessage, onSelect: onSelect, onEnter: onEnter, link: link, fetchSuggestions: fetchSuggestions, optionsError: optionsError, resultType: resultType, clearSearchState: clearSearchState } = props;
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const onInputChange = (0, $eUqFw.useCallback)((input)=>{
        if (!(0, $jXQ07.default)(input)) fetchSuggestions(input);
        else clearSearchState();
    }, [
        clearSearchState,
        fetchSuggestions
    ]);
    const onPageSelect = (0, $eUqFw.useCallback)(()=>{
        onSelect && onSelect();
        fetchSuggestions('');
    }, [
        fetchSuggestions,
        onSelect
    ]);
    const clearSuggestions = (0, $eUqFw.useCallback)(()=>{
        fetchSuggestions('');
    }, [
        fetchSuggestions
    ]); // @ts-expect-error - TS7006 - Parameter 'input' implicitly has an 'any' type.
    const isValidNewOption = (0, $eUqFw.useCallback)((input)=>(0, $jXQ07.default)(input), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MCZY.default), {
        options: options,
        onChange: onChange,
        intl: (0, $4ksts.useIntlV2)(),
        validationMessage: validationMessage,
        validationState: validationState,
        onSelect: onPageSelect,
        onEnter: onEnter,
        link: link,
        isLoading: isLoading,
        isLoadingOptions: isLoadingOptions,
        filterOption: filterOption,
        onInputChange: onInputChange,
        customComponents: {
            LoadingMessageComponent: $ebcc493ace2af3be$export$406c7ee80bb6929f
        },
        onBlur: clearSuggestions,
        onMenuClose: clearSuggestions,
        isValidNewOption: isValidNewOption,
        noOptionsMessage: ()=>$ebcc493ace2af3be$export$2967f59ec63f650b(optionsError, resultType, formatMessage),
        additionalProps: {
            error: optionsError,
            type: resultType,
            spaceKey: spaceKey
        }
    });
};
var $ebcc493ace2af3be$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $ebcc493ace2af3be$var$ConfluenceSearchSelect;
const $ebcc493ace2af3be$var$MainContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1k99 _syaz1ecl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ebcc493ace2af3be$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ebcc493ace2af3be$var$Group = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bahv2br _1n261q9c _4t3i5cnj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3MCZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8163a46f4a2c983$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gXoeb = parcelRequire("gXoeb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e8163a46f4a2c983$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gXoeb.default), props);

});
parcelRegister("gXoeb", function(module, exports) {

$parcel$export(module.exports, "default", () => $94232b165058afad$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gtzuR = parcelRequire("gtzuR");

var $1EOkb = parcelRequire("1EOkb");
var $cEc3i = parcelRequire("cEc3i");

var $4NcaX = parcelRequire("4NcaX");

var $gJA1m = parcelRequire("gJA1m");

var $6vrw7 = parcelRequire("6vrw7");

var $bnhan = parcelRequire("bnhan");

var $ki30r = parcelRequire("ki30r");

var $hRmhi = parcelRequire("hRmhi");
const $94232b165058afad$export$9f6451bf6a3cb21f = (props)=>{
    const { innerProps: innerProps, innerRef: innerRef, getStyles: getStyles, data: data, selectProps: selectProps } = props;
    const style = getStyles('option', props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94232b165058afad$var$OptionContainer, {
        /* eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ...innerProps,
        ref: innerRef
    }, !data.page ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bnhan.default), {
        href: (0, $6vrw7.toHref)(props.value)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ki30r.default), {
        key: `item_key-${data.page.href}`,
        ...data,
        selectProps: selectProps
    })));
};
class $94232b165058afad$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isLoading: false,
            isLoadingOptions: false,
            link: undefined
        };
    }
    render() {
        const { value: value } = this.state;
        const { options: options, intl: { formatMessage: formatMessage }, link: link, isLoading: isLoading, isLoadingOptions: isLoadingOptions, filterOption: filterOption = (0, $cEc3i.c)(), customComponents: customComponents = {}, additionalProps: additionalProps = {}, validationState: validationState, validationMessage: validationMessage } = this.props;
        const loading = isLoading || isLoadingOptions; // warning isn't a valid in Atlaskit Select yet, fall back to 'error'.
        // TODO: https://jdog.jira-dev.com/browse/BENTO-11817
        const sanitisedValidationState = validationState === 'warning' ? 'error' : validationState || 'default';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJA1m.default), {
            validationState: this.props.validationState || 'default',
            validationMessage: validationMessage || null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1EOkb.default), {
            isClearable: true,
            isDisabled: isLoading,
            filterOption: filterOption,
            isLoading: loading,
            onChange: this.handleChange,
            value: link === '' || !value ? null : value,
            components: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                Option: $94232b165058afad$export$9f6451bf6a3cb21f,
                ...customComponents
            },
            options: options,
            placeholder: formatMessage((0, $hRmhi.default).enterOrSelectConfluenceLink),
            validationState: sanitisedValidationState,
            getOptionLabel: (option)=>option.page ? option.page.href : option.value,
            maxMenuHeight: 256,
            autoFocus: true,
            menuPlacement: "auto",
            minMenuHeight: 256,
            styles: (0, $4NcaX.defaultSelectStyles),
            onKeyDown: this.onKeyDown,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            noOptionsMessage: ()=>formatMessage((0, $hRmhi.default).noOptionsMessage),
            isValidNewOption: this.isValidNewOption,
            additionalProps: additionalProps,
            onInputChange: this.onInputChange,
            onBlur: this.onBlur,
            ...this.props.noOptionsMessage ? {
                noOptionsMessage: this.props.noOptionsMessage
            } : null
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isMenuOpen: false,
            value: undefined
        };
        this.onKeyDown = (event)=>{
            switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter'):
                    // only report enter event when menu is closed.
                    if (this.props.onEnter && !this.state.isMenuOpen) {
                        this.props.onEnter();
                        event.stopPropagation();
                    }
                    break;
                default:
                    break;
            }
        };
        this.onMenuOpen = ()=>{
            const { onMenuOpen: onMenuOpen } = this.props;
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isMenuOpen: true
            });
        };
        this.onInputChange = (input, { action: action })=>{
            const { onInputChange: onInputChange } = this.props;
            if (action === 'input-change') onInputChange && onInputChange(input);
        };
        this.onBlur = ()=>{
            const { onBlur: onBlur } = this.props;
            onBlur && onBlur();
        };
        this.onMenuClose = ()=>{
            this.setState({
                isMenuOpen: false
            });
            const { onMenuClose: onMenuClose } = this.props;
            if (onMenuClose) onMenuClose();
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ;
        this.handleChange = (newValue)=>{
            if (newValue && newValue.page) this.props.onSelect && this.props.onSelect();
            this.setState({
                value: newValue
            });
            this.props.onChange(newValue ? newValue.value : null);
        };
        this.isValidNewOption = (inputValue)=>{
            const { isValidNewOption: isValidNewOption } = this.props;
            return isValidNewOption && isValidNewOption(inputValue);
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94232b165058afad$var$OptionContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1a70",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bnhan", function(module, exports) {

$parcel$export(module.exports, "default", () => $db7faf0304fa0a18$export$2e2bcd8739ae039);

var $6PwRY = parcelRequire("6PwRY");
var $db7faf0304fa0a18$export$2e2bcd8739ae039 = (0, $6PwRY.default);

});
parcelRegister("6PwRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f271886d34b366a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1hj1Z = parcelRequire("1hj1Z");

var $PdmhA = parcelRequire("PdmhA");

var $4xwq2 = parcelRequire("4xwq2");
function $3f271886d34b366a$export$2e2bcd8739ae039(props) {
    const { href: href, onSelect: onSelect } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f271886d34b366a$var$PageItemContainer, {
        onClick: ()=>onSelect && onSelect(href)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f271886d34b366a$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1hj1Z))), {
        label: "",
        size: "medium",
        primaryColor: `var(--ds-text-brand, ${(0, $PdmhA).B200})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f271886d34b366a$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f271886d34b366a$var$TitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.Ellipsis), null, href))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f271886d34b366a$var$PageItemContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1u1b",
            __cmplp.className
        ])
    });
});
const $3f271886d34b366a$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxpxbi _vwz4kb7n",
            __cmplp.className
        ])
    });
});
const $3f271886d34b366a$var$ContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $3f271886d34b366a$var$TitleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz41xfb _1wybdlk8 _k48pbfng",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1hj1Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ee62423733c0c3b$var$_react = $0ee62423733c0c3b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $0ee62423733c0c3b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0ee62423733c0c3b$var$LinkFilledIcon = (props)=>/*#__PURE__*/ $0ee62423733c0c3b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M11.75 16.15l.548-.537a.585.585 0 000-.838.61.61 0 00-.854 0l-.574.564c-.564.553-1.483.662-2.101.168a1.482 1.482 0 01-.119-2.223l1.694-1.663a1.543 1.543 0 012.156 0l.647.635.853-.839-.646-.635a2.775 2.775 0 00-3.863 0l-1.694 1.664a2.659 2.659 0 00.208 3.979c1.104.884 2.738.715 3.746-.275" fill="inherit"/><path d="M12.25 7.85l-.547.537a.585.585 0 000 .838.61.61 0 00.853 0l.574-.564c.564-.553 1.483-.662 2.101-.168.71.57.75 1.603.119 2.223l-1.694 1.663a1.543 1.543 0 01-2.156 0l-.647-.635-.853.839.646.635a2.775 2.775 0 003.863 0l1.695-1.664a2.659 2.659 0 00-.209-3.979c-1.104-.884-2.738-.715-3.746.275" fill="inherit"/></g></svg>`
    }, props));
$0ee62423733c0c3b$var$LinkFilledIcon.displayName = 'LinkFilledIcon';
var $0ee62423733c0c3b$var$_default = $0ee62423733c0c3b$var$LinkFilledIcon;
module.exports.default = $0ee62423733c0c3b$var$_default;

});



parcelRegister("ki30r", function(module, exports) {

$parcel$export(module.exports, "default", () => $8721de8394cd9eda$export$2e2bcd8739ae039);

var $4j4yr = parcelRequire("4j4yr");
var $8721de8394cd9eda$export$2e2bcd8739ae039 = (0, $4j4yr.default);

});
parcelRegister("4j4yr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5836017f9c107da4$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8NKHs = parcelRequire("8NKHs");

var $2Hips = parcelRequire("2Hips");

var $90IgZ = parcelRequire("90IgZ");
var $1IqwQ = parcelRequire("1IqwQ");
var $4ksts = parcelRequire("4ksts");

var $3ElT9 = parcelRequire("3ElT9");

var $4xwq2 = parcelRequire("4xwq2");

var $8jK4y = parcelRequire("8jK4y");

var $7nmKH = parcelRequire("7nmKH");
const $5836017f9c107da4$export$9eb62eb25c3e4939 = ({ page: page, parent: parent })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const { lastModified: lastModified = 0, space: space } = page || {};
    const withUpdatedLabel = (formattedDate)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $8jK4y.default).updated), " ", formattedDate);
    const { additionalProps: additionalProps = {} } = parent || {}; // @ts-expect-error - TS2339 - Property 'type' does not exist on type '{}'. | TS2339 - Property 'spaceKey' does not exist on type '{}'.
    const { type: type = 'search', spaceKey: spaceKey = '' } = additionalProps;
    let relativeTime = null;
    const spaceComponent = spaceKey === '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.Ellipsis), null, space) : null;
    if (type !== 'recent') {
        if (lastModified > 0) {
            // @ts-expect-error - TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            const daysElapsed = (Date.now() - new Date(lastModified)) / 86400000;
            if (daysElapsed < 8) relativeTime = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.Ellipsis), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1IqwQ.FormattedRelativeV2), {
                value: lastModified
            }, withUpdatedLabel));
            else relativeTime = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.Ellipsis), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90IgZ.FormattedDate), {
                year: "numeric",
                month: "short",
                day: "2-digit",
                value: lastModified
            }, withUpdatedLabel));
        } else relativeTime = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.Ellipsis), null, formatMessage((0, $8jK4y.default).recent));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, spaceComponent, spaceComponent !== null && relativeTime !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7nmKH.DotWrapper), null, "\u2022") : null, relativeTime);
};
function $5836017f9c107da4$export$2e2bcd8739ae039(props) {
    if (!props.page) return null;
    const { title: title, type: type, href: href } = props.page;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5836017f9c107da4$var$PageItemContainer, {
        onClick: ()=>props.onSelect && props.onSelect(href)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5836017f9c107da4$var$IconContainer, null, type === (0, $3ElT9.CONFLUENCE_BLOGPOST) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8NKHs))), {
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Hips))), {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5836017f9c107da4$var$ContentContainerWithEllipsis, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7nmKH.TitleWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.Ellipsis), null, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7nmKH.SpaceWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5836017f9c107da4$export$9eb62eb25c3e4939, {
        page: props.page,
        parent: props.selectProps
    }))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5836017f9c107da4$var$PageItemContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1u1b",
            __cmplp.className
        ])
    });
});
const $5836017f9c107da4$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _vwz4kb7n",
            __cmplp.className
        ])
    });
});
const $5836017f9c107da4$var$ContentContainerWithEllipsis = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8NKHs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66871ffa75b3aecf$var$_react = $66871ffa75b3aecf$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $66871ffa75b3aecf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $66871ffa75b3aecf$var$Blog24Icon = (props)=>/*#__PURE__*/ $66871ffa75b3aecf$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 10-3.046 3.94c-.473.836-1.096 1.778-1.87 2.827a1.168 1.168 0 00.102 1.506.85.85 0 001.298-.092c2.675-3.68 3.847-6.407 3.516-8.18zm8.895 0a3.5 3.5 0 10-3.046 3.94c-.473.836-1.096 1.778-1.87 2.827a1.168 1.168 0 00.102 1.506.85.85 0 001.298-.092c2.675-3.68 3.847-6.407 3.516-8.18zM3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3z"/></svg>`
    }, props, {
        size: "medium"
    }));
$66871ffa75b3aecf$var$Blog24Icon.displayName = 'Blog24Icon';
var $66871ffa75b3aecf$var$_default = $66871ffa75b3aecf$var$Blog24Icon;
module.exports.default = $66871ffa75b3aecf$var$_default;

});

parcelRegister("2Hips", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f6de0aa289aeab3$var$_react = $1f6de0aa289aeab3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $1f6de0aa289aeab3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1f6de0aa289aeab3$var$Page24Icon = (props)=>/*#__PURE__*/ $1f6de0aa289aeab3$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1zm0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1zm0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1zm0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1z"/></svg>`
    }, props, {
        size: "medium"
    }));
$1f6de0aa289aeab3$var$Page24Icon.displayName = 'Page24Icon';
var $1f6de0aa289aeab3$var$_default = $1f6de0aa289aeab3$var$Page24Icon;
module.exports.default = $1f6de0aa289aeab3$var$_default;

});

parcelRegister("8jK4y", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc89b7f9b6694ca$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $ddc89b7f9b6694ca$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    updated: {
        "id": "issue.views.confluence-pages.link-list.page-item.updated",
        "defaultMessage": "Updated"
    },
    recent: {
        "id": "issue.views.confluence-pages.link-list.page-item.recent",
        "defaultMessage": "Recently viewed"
    }
});

});

parcelRegister("7nmKH", function(module, exports) {

$parcel$export(module.exports, "TitleWrapper", () => $da15922aa5cf24bc$export$585a3b23e887288b);
$parcel$export(module.exports, "SpaceWrapper", () => $da15922aa5cf24bc$export$30d85e96e785900a);
$parcel$export(module.exports, "DotWrapper", () => $da15922aa5cf24bc$export$ca7610dbcf1dc3cd);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $da15922aa5cf24bc$export$585a3b23e887288b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz414rt _1wybdlk8 _k48pbfng",
            __cmplp.className
        ])
    });
});
const $da15922aa5cf24bc$export$7ae66460d9d697f4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1crf _syaz1wmz",
            __cmplp.className
        ])
    });
});
const $da15922aa5cf24bc$export$30d85e96e785900a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1skh _vwz41ef6 _syaz1wmz _1e0c1txw _2lx2vrvc _1bah1y6m",
            __cmplp.className
        ])
    });
});
const $da15922aa5cf24bc$export$ca7610dbcf1dc3cd = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _18s8otz2",
            __cmplp.className
        ])
    });
});

});



parcelRegister("hRmhi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7bdd647fb9cc23e$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $b7bdd647fb9cc23e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    enterOrSelectConfluenceLink: {
        "id": "issue.views.confluence-pages.link.selector.placeholder",
        "defaultMessage": "Search pages or paste in a link"
    },
    noOptionsMessage: {
        "id": "issue.views.confluence-pages.link.selector.noOptionsMessage",
        "defaultMessage": "No recently visited pages"
    }
});

});



parcelRegister("51Cjn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a366c2d97d6dcaf9$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $a366c2d97d6dcaf9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noRecentOptionsMessage: {
        "id": "issue.views.confluence-search-view.noOptionsMessage",
        "defaultMessage": "No recently visited pages"
    },
    noResultOptionsMessage: {
        "id": "issue.views.confluence-search-view.noResultOptionsMessage",
        "defaultMessage": "We can't find any pages matching your search"
    }
});

});


parcelRegister("quOC4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a57b6a3cd39c2d87$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jQxSL = parcelRequire("jQxSL");
var $4zgIJ = parcelRequire("4zgIJ");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("gLLZt");
var $7nzO5 = parcelRequire("7nzO5");

var $4xwq2 = parcelRequire("4xwq2");

var $fWM87 = parcelRequire("fWM87");

var $2ZqQZ = parcelRequire("2ZqQZ");
const $a57b6a3cd39c2d87$var$customSelectStyle = (isCompact)=>({
        ...(0, $7nzO5.defaultSelectStyles),
        // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'state' implicitly has an 'any' type.
        menu: (base, state)=>{
            const defaultMenu = (0, $7nzO5.defaultSelectStyles).menu ? (0, $7nzO5.defaultSelectStyles).menu(base, state) : {};
            return {
                ...defaultMenu,
                minWidth: isCompact ? 'auto' : '140%'
            };
        }
    });
const $a57b6a3cd39c2d87$export$1949dac661ba6e3a = ({ children: children, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: data } = props;
    return(// @ts-expect-error - TS2740 - Type '{ children: Element; data: Option; }' is missing the following properties from type 'CommonProps<Option, false, GroupTypeBase<Option>>': clearValue, cx, getStyles, getValue, and 8 more.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: data.label,
        position: "top"
    }, data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, data.label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), null, formatMessage((0, $2ZqQZ.default).filterBySpace)))));
};
const $a57b6a3cd39c2d87$export$45dc5da6473e02cb = (props)=>{
    const { innerProps: innerProps, innerRef: innerRef, getStyles: getStyles, data: data } = props;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const style = getStyles('option', props);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { label: label } = data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a57b6a3cd39c2d87$var$OptionContainer, {
        /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ...innerProps,
        ref: innerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.Ellipsis), null, label)));
};
const $a57b6a3cd39c2d87$var$filterOption = ()=>true;
const $a57b6a3cd39c2d87$var$ConfluenceSpaceSelect = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { appId: appId, onSpaceKeyChange: onSpaceKeyChange, spaceKey: spaceKey, isCompact: isCompact } = props;
    const [{ loading: loading, spaces: spaces, isFilteredResult: isFilteredResult }, { fetchSpaces: fetchSpaces, filterSpaces: filterSpaces }] = (0, $fWM87.default)({
        appId: appId
    });
    const { filtered: filtered } = spaces;
    (0, $eUqFw.useEffect)(()=>{
        fetchSpaces();
    }, [
        fetchSpaces
    ]);
    const onChange = (0, $eUqFw.useCallback)((newValue)=>{
        if (newValue && newValue.space) onSpaceKeyChange(newValue.value);
        else onSpaceKeyChange('');
    }, [
        onSpaceKeyChange
    ]);
    const onInputChange = (0, $eUqFw.useCallback)((// @ts-expect-error - TS7006 - Parameter 'input' implicitly has an 'any' type.
    input, { action: action })=>{
        if (action === 'input-change') filterSpaces(input);
    }, [
        filterSpaces
    ]);
    const onMenuClose = (0, $eUqFw.useCallback)(()=>{
        filterSpaces(''); // reset search
    }, [
        filterSpaces
    ]);
    const label = formatMessage(!isFilteredResult ? (0, $2ZqQZ.default).allSpaces : (0, $2ZqQZ.default).matchingSpaces);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), {
        options: [
            {
                label: label,
                options: filtered
            }
        ],
        onInputChange: onInputChange,
        onChange: onChange,
        onMenuClose: onMenuClose,
        filterOption: $a57b6a3cd39c2d87$var$filterOption,
        value: filtered.find((elem)=>elem.value === spaceKey),
        isClearable: true,
        placeholder: formatMessage((0, $2ZqQZ.default).filterBySpace),
        isLoading: loading,
        maxMenuHeight: 256,
        minMenuHeight: 256,
        components: {
            SingleValue: $a57b6a3cd39c2d87$export$1949dac661ba6e3a,
            // @ts-expect-error - TS2322 - Type '(props: JSX.LibraryManagedAttributes<typeof components.Option, ComponentProps<typeof components.Option>>) => JSX.Element' is not assignable to type 'ComponentType<OptionProps<Option, boolean, GroupTypeBase<Option>>> | undefined'.
            Option: $a57b6a3cd39c2d87$export$45dc5da6473e02cb
        },
        styles: $a57b6a3cd39c2d87$var$customSelectStyle(isCompact)
    });
};
var $a57b6a3cd39c2d87$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a57b6a3cd39c2d87$var$ConfluenceSpaceSelect;
const $a57b6a3cd39c2d87$var$OptionContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fWM87", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e70c23aaef65345$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $f8TMb = parcelRequire("f8TMb");
const $9e70c23aaef65345$export$3a3072dd741f354b = 300;
const $9e70c23aaef65345$var$useConfluenceSpaceService = (props)=>{
    const { renderOptionsLimit: renderOptionsLimit = 25, appId: appId } = props;
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [spaces, setSpaces] = (0, $eUqFw.useState)({
        filtered: [],
        overall: []
    });
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [isFilteredResult, setIsFilteredResult] = (0, $eUqFw.useState)(false);
    const fetchSpaces = (0, $eUqFw.useCallback)(async ()=>{
        try {
            setLoading(true);
            const response = await (0, $lRmyA.performGetRequest)((0, $f8TMb.getSpaceUrl)(appId));
            if (response.spaces) {
                const transformedSpaces = (0, $f8TMb.transformSpaces)(response.spaces);
                setSpaces((0, $f8TMb.filteredResponse)(transformedSpaces, renderOptionsLimit));
            }
            setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setLoading(false);
            (0, $guiFP.default)({
                error: err,
                meta: {
                    id: 'getConfluenceSpaceService',
                    // eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics
                    packageName: 'jiraIssueView',
                    teamName: 'bento'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setError(err);
        }
    }, [
        appId,
        renderOptionsLimit
    ]);
    const filterSpaces = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((query)=>{
            const { overall: overall } = spaces;
            setIsFilteredResult(query !== '');
            setSpaces((0, $f8TMb.filteredResponse)(overall, renderOptionsLimit, query));
        }, $9e70c23aaef65345$export$3a3072dd741f354b, {
            leading: false
        }), [
        renderOptionsLimit,
        spaces
    ]);
    return [
        {
            loading: loading,
            spaces: spaces,
            error: error,
            isFilteredResult: isFilteredResult
        },
        {
            fetchSpaces: fetchSpaces,
            filterSpaces: filterSpaces
        }
    ];
};
var $9e70c23aaef65345$export$2e2bcd8739ae039 = $9e70c23aaef65345$var$useConfluenceSpaceService;

});
parcelRegister("f8TMb", function(module, exports) {

$parcel$export(module.exports, "getSpaceUrl", () => $f8d97ddaac65a376$export$3b339b277f9d309a);
$parcel$export(module.exports, "transformSpaces", () => $f8d97ddaac65a376$export$dc5c998cf3a66ad3);
$parcel$export(module.exports, "filteredResponse", () => $f8d97ddaac65a376$export$ebf169a01afbf9a5);

var $cEc3i = parcelRequire("cEc3i");
const $f8d97ddaac65a376$export$3b339b277f9d309a = (appId)=>`/rest/confluenceIssueLink/1/confluence/space?appId=${appId}&_=${Date.now()}`;
const $f8d97ddaac65a376$export$dc5c998cf3a66ad3 = (options)=>options.map((option)=>({
            label: option.name,
            value: option.key,
            data: option,
            space: option
        }));
const $f8d97ddaac65a376$export$ebf169a01afbf9a5 = (options, renderOptionsLimit, query = '')=>{
    const filterRecentResults = (0, $cEc3i.c)();
    // @ts-expect-error - TS2345 - Argument of type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/issue/issue-view/src/views/issue-base/content/confluence-content/create-link/confluence-search-view/services/spaces/types").Option' is not assignable to parameter of type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/@types/react-select/src/filters").Option'.
    const filtered = options.filter((option)=>filterRecentResults(option, query));
    return {
        filtered: filtered.slice(0, renderOptionsLimit),
        overall: options
    };
};

});


parcelRegister("2ZqQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $823d3a4e2cf6d5f1$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $823d3a4e2cf6d5f1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterBySpace: {
        "id": "issue.views.confluence-search-view.filter-space",
        "defaultMessage": "Filter by space"
    },
    allSpaces: {
        "id": "issue.views.confluence-search-view.all-space",
        "defaultMessage": "All spaces"
    },
    matchingSpaces: {
        "id": "issue.views.confluence-search-view.matching-space",
        "defaultMessage": "Matching spaces"
    }
});

});



parcelRegister("1gVNw", function(module, exports) {

$parcel$export(module.exports, "CreateLinkError", () => $693cbe776b97fc00$export$1f80f8e38012a95c);
const $693cbe776b97fc00$export$1f80f8e38012a95c = {
    DUPLICATE: 'addconfluencelink.error.duplicate',
    FORBIDDEN: 'addconfluencelink.error.page.forbidden',
    ISSUE_ID_INVALID: 'addconfluencelink.error.issueId.invalid',
    NO_MATCHING_APP_LINK: 'addconfluencelink.error.no.matching.app.link',
    PAGE_ID_NOT_FOUND: 'addconfluencelink.error.pageid.notfound',
    UNAUTHORIZED: 'addconfluencelink.error.page.unauthorized',
    UNAUTHORIZED_PROMPT: 'addconfluencelink.error.page.unauthorized-prompt',
    URL_INVALID: 'addconfluencelink.error.url.invalid',
    URL_REQUIRED: 'addconfluencelink.error.url.required'
};

});

parcelRegister("arNwV", function(module, exports) {

$parcel$export(module.exports, "CreateConfluenceContentMenu", () => $f821569e825f071d$export$988cc6caaf667bdd);

var $eUqFw = parcelRequire("eUqFw");

var $3555e = parcelRequire("3555e");

var $cGCxH = parcelRequire("cGCxH");
var $2D6D5 = parcelRequire("2D6D5");
var $9Hi6E = parcelRequire("9Hi6E");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");


var $4Efjz = parcelRequire("4Efjz");

var $8PPG1 = parcelRequire("8PPG1");

var $8N8dV = parcelRequire("8N8dV");

var $6luwQ = parcelRequire("6luwQ");

var $bFzGY = parcelRequire("bFzGY");
const $f821569e825f071d$export$988cc6caaf667bdd = ()=>{
    const { entryPointActions: confluenceContentMenuActions, entryPointReferenceSubject: confluenceContentMenuSubject } = (0, $6j4bv.useEntryPoint)((0, $6luwQ.createConfluenceContentMenuEntrypoint), {});
    const confluenceAccessOld = (0, $4Efjz.useUserHasConfluenceAccess)((0, $1b2c5e0fcb49d7fc$export$d3566448206b58e), (0, $1ybV0.ff)('confluence-admin-product-controls')).hasAccess;
    const confluenceAccessNew = (0, $1ybV0.ff)('confluence-admin-product-controls') ? (0, $9Hi6E.useUserHasConfluenceAccess)((0, $1b2c5e0fcb49d7fc$export$d3566448206b58e), !(0, $1ybV0.ff)('confluence-admin-product-controls')).hasAccess : confluenceAccessOld;
    const confluenceAccess = (0, $1ybV0.ff)('confluence-admin-product-controls') ? confluenceAccessNew : confluenceAccessOld;
    const tenantHasConfluence = (0, $3555e.useTenantHasConfluence)();
    const isCrossSellEnabled = (0, $1ybV0.ff)('confluence-admin-product-controls') ? (0, $2D6D5.useIsCrossSellEnabled)((0, $cGCxH.ConfluenceFeatureKeys).CREATE_MENU_TOP_ACTIONS) : false;
    const [, embedConfluenceAAFireExposureEvent] = (0, $79xbN.UNSAFE_noExposureExp)('platform_embed-conf_jira-issue_cross-join_exp_aa');
    const [embedConfluenceConfig] = (0, $79xbN.UNSAFE_noExposureExp)('platform_embed-conf_jira-issue_cross-join_exp');
    const embedConfluenceCohort = embedConfluenceConfig.get('cohort', 'not-enrolled');
    const [, confluenceContentCrossflowAAFireExposureEvent] = (0, $79xbN.UNSAFE_noExposureExp)('jira_create_confluence_content_crossflow_aa');
    const [confluenceContentCrossflowConfig, confluenceContentCrossflowFireExposureEvent] = (0, $79xbN.UNSAFE_noExposureExp)('jira_create_confluence_content_crossflow');
    const confluenceContentCrossflowCohort = confluenceContentCrossflowConfig.get('cohort', 'not-enrolled');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // Embedded Confluence cross-join experiment begins
    (0, $eUqFw.useEffect)(()=>{
        if (!confluenceAccess && tenantHasConfluence) // expose feature to enrolled cohort for Calibration experiment
        embedConfluenceAAFireExposureEvent();
        if (!tenantHasConfluence) {
            // expose feature to enrolled cohort for Calibration experiment
            confluenceContentCrossflowAAFireExposureEvent();
            if ((0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-content-crossflow')) confluenceContentCrossflowFireExposureEvent();
        }
    }, [
        confluenceAccess,
        tenantHasConfluence,
        createAnalyticsEvent,
        embedConfluenceAAFireExposureEvent,
        confluenceContentCrossflowAAFireExposureEvent,
        confluenceContentCrossflowFireExposureEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const shouldRenderForCrossJoin = tenantHasConfluence && (0, $1ybV0.ff)('platform_embed-conf_jira-issue_create_cross-join') && embedConfluenceCohort === 'experiment';
        const shouldRenderForCrossFlow = !tenantHasConfluence && (0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-content-crossflow') && confluenceContentCrossflowCohort === 'experiment';
        if ((0, $1ybV0.ff)('confluence-admin-product-controls')) {
            if (confluenceAccess || (shouldRenderForCrossJoin || shouldRenderForCrossFlow) && isCrossSellEnabled) confluenceContentMenuActions.load();
        } else if (confluenceAccess || tenantHasConfluence && (0, $1ybV0.ff)('platform_embed-conf_jira-issue_create_cross-join') && embedConfluenceCohort === 'experiment' || !tenantHasConfluence && (0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-content-crossflow') && confluenceContentCrossflowCohort === 'experiment') confluenceContentMenuActions.load();
    }, [
        confluenceAccess,
        confluenceContentMenuActions,
        tenantHasConfluence,
        isCrossSellEnabled,
        embedConfluenceCohort,
        confluenceContentCrossflowCohort
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: confluenceContentMenuSubject,
        id: "confluenceContentMenuEntryPointContainer",
        packageName: "@atlassian/jira-issue-create-confluence-content",
        teamName: "confluence-better-together",
        runtimeProps: {
            appearance: 'link',
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PPG1.CreatePageMenuItem), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N8dV.CreateWhiteboardMenuItem), null)),
            hasConfluenceAccess: confluenceAccess,
            cacheOnlyAccessStatus: true,
            embeddedConfluenceSource: (0, $1b2c5e0fcb49d7fc$export$d3566448206b58e)
        }
    });
};

});

parcelRegister("fCgoa", function(module, exports) {

$parcel$export(module.exports, "default", () => $67dc3c42cfb44b7b$export$2e2bcd8739ae039);

var $1gVNw = parcelRequire("1gVNw");

var $5VzE4 = parcelRequire("5VzE4");
const $67dc3c42cfb44b7b$var$errorMap = {
    [(0, $1gVNw.CreateLinkError).DUPLICATE]: (0, $5VzE4.default).duplicateErrorText,
    [(0, $1gVNw.CreateLinkError).FORBIDDEN]: (0, $5VzE4.default).forbiddenErrorText,
    [(0, $1gVNw.CreateLinkError).ISSUE_ID_INVALID]: (0, $5VzE4.default).issueIdErrorText,
    [(0, $1gVNw.CreateLinkError).NO_MATCHING_APP_LINK]: (0, $5VzE4.default).noMatchingApplinkErrorText,
    [(0, $1gVNw.CreateLinkError).PAGE_ID_NOT_FOUND]: (0, $5VzE4.default).pageIdNotFoundErrorText,
    [(0, $1gVNw.CreateLinkError).UNAUTHORIZED]: (0, $5VzE4.default).unauthorizedErrorText,
    [(0, $1gVNw.CreateLinkError).UNAUTHORIZED_PROMPT]: (0, $5VzE4.default).unauthorizedErrorPrompt,
    [(0, $1gVNw.CreateLinkError).URL_INVALID]: (0, $5VzE4.default).urlInvalidErrorText,
    [(0, $1gVNw.CreateLinkError).URL_REQUIRED]: (0, $5VzE4.default).urlRequiredErrorText
};
var // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "addconfluencelink.error.duplicate": MessageDescriptorV2; readonly "addconfluencelink.error.page.forbidden": MessageDescriptorV2; ... 6 more ...; readonly "addconfluencelink.error.url.required": MessageDescriptorV2; }'.
// eslint-disable-next-line jira/import/no-anonymous-default-export
$67dc3c42cfb44b7b$export$2e2bcd8739ae039 = (errorMessage)=>$67dc3c42cfb44b7b$var$errorMap[errorMessage] || (0, $5VzE4.default).genericErrorText;

});
parcelRegister("5VzE4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8639dfd3c81fa54a$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $8639dfd3c81fa54a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    fieldLabel: {
        "id": "issue.views.confluence-pages.link.label",
        "defaultMessage": "Search pages or paste in a link"
    },
    fieldPlaceholder: {
        "id": "issue.views.confluence-pages.link.placeholder",
        "defaultMessage": "Search pages or paste in a link"
    },
    genericErrorText: {
        "id": "issue.views.confluence-pages.link.error.generic",
        "defaultMessage": "We're having trouble. Check your connection and try again."
    },
    duplicateErrorText: {
        "id": "issue.views.confluence-pages.link.error.duplicate",
        "defaultMessage": "That page is already linked to this issue."
    },
    forbiddenErrorText: {
        "id": "issue.views.confluence-pages.link.error.forbidden",
        "defaultMessage": "You don't have permission to link to Confluence pages."
    },
    issueIdErrorText: {
        "id": "issue.views.confluence-pages.link.error.issue-id",
        "defaultMessage": "We're having trouble. Check your connection and try again."
    },
    noMatchingApplinkErrorText: {
        "id": "issue.views.confluence-pages.link.error.no-matching-app-link",
        "defaultMessage": "You don't have an application link set up for that Confluence site."
    },
    pageIdNotFoundErrorText: {
        "id": "issue.views.confluence-pages.link.error.page-id-not-found",
        "defaultMessage": "We can't find that page. It might be deleted or restricted."
    },
    unauthorizedErrorText: {
        "id": "issue.views.confluence-pages.link.error.unauthorized",
        "defaultMessage": "You need to authorize this pages' Confluence site."
    },
    unauthorizedErrorPrompt: {
        "id": "issue.views.confluence-pages.link.error.unauthorized-prompt",
        "defaultMessage": "Unable to link the Confluence page. You don't have permission or need to {linkStart}authenticate{linkEnd}"
    },
    urlInvalidErrorText: {
        "id": "issue.views.confluence-pages.link.error.url-invalid",
        "defaultMessage": "That URL doesn't look right. Try entering it again."
    },
    urlRequiredErrorText: {
        "id": "issue.views.confluence-pages.link.error.url-required",
        "defaultMessage": "That URL doesn't look right. Try entering it again."
    },
    linkButton: {
        "id": "issue.views.confluence-pages.link.link-button",
        "defaultMessage": "Link"
    },
    cancelButton: {
        "id": "issue.views.confluence-pages.link.cancel-button",
        "defaultMessage": "Cancel"
    },
    linkCrossOriginWhiteboardFailedTitle: {
        "id": "issue.views.confluence-content.whiteboard-link-failed-title",
        "defaultMessage": "We couldn't link this whiteboard"
    },
    linkCrossOriginWhiteboardFailedDescription: {
        "id": "issue.views.confluence-content.whiteboard-link-failed-description",
        "defaultMessage": "We can't link a whiteboard from a Confluence site with a different domain"
    }
});

});


parcelRegister("bXTvM", function(module, exports) {

$parcel$export(module.exports, "createConfluenceWhiteboardAri", () => $b255a30521c3591f$export$1ed467acfe81522d);
$parcel$export(module.exports, "isWhiteboardContentTypeFromUrl", () => $b255a30521c3591f$export$80fc0ff8ee1c3f11);
$parcel$export(module.exports, "getWhiteboardIdFromUrl", () => $b255a30521c3591f$export$fa20a0d1cb591988);
$parcel$export(module.exports, "getWhiteboard", () => $b255a30521c3591f$export$8a896f3b93aa42c0);

var $78Ywx = parcelRequire("78Ywx");

var $f9JLO = parcelRequire("f9JLO");

var $1d3eD = parcelRequire("1d3eD");

var $guiFP = parcelRequire("guiFP");

var $3ElT9 = parcelRequire("3ElT9");
const $b255a30521c3591f$export$1ed467acfe81522d = ({ siteId: siteId, whiteboardId: whiteboardId })=>`ari:cloud:confluence:${siteId}:whiteboard/${whiteboardId}`;
const $b255a30521c3591f$var$matchUrl = (path, pattern)=>{
    const keys = [];
    const regexp = (0, (/*@__PURE__*/$parcel$interopDefault($f9JLO)))(pattern, keys);
    const result = regexp.exec(path);
    if (!result) return false;
    return true;
};
const $b255a30521c3591f$export$80fc0ff8ee1c3f11 = (url)=>{
    const pattern = '/wiki/spaces/:spaceKey/whiteboard/:contentId(\\d+)';
    const urlObject = new URL(url);
    const path = urlObject.pathname;
    return $b255a30521c3591f$var$matchUrl(path, pattern);
};
const $b255a30521c3591f$export$fa20a0d1cb591988 = (url)=>{
    const pattern = '/wiki/spaces/:spaceKey/whiteboard/:contentId(\\d+)';
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($78Ywx))).parse(url, true);
    const pathname = parsed.pathname ?? '';
    const match = (0, $1d3eD.default)(pathname, {
        path: pattern,
        exact: true
    });
    return match?.params.contentId;
};
const $b255a30521c3591f$export$8a896f3b93aa42c0 = async ({ fetchConfluenceWhiteboard: fetchConfluenceWhiteboard, cloudId: cloudId, link: link, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const whiteboardAri = $b255a30521c3591f$export$1ed467acfe81522d({
        siteId: cloudId,
        whiteboardId: $b255a30521c3591f$export$fa20a0d1cb591988(link) ?? ''
    });
    try {
        const confluenceWhiteboardData = await fetchConfluenceWhiteboard(whiteboardAri);
        const whiteboard = {
            whiteboardId: confluenceWhiteboardData.whiteboardId,
            href: `${confluenceWhiteboardData.links?.base}${confluenceWhiteboardData.links?.webUi}`,
            author: confluenceWhiteboardData.author,
            title: confluenceWhiteboardData.title,
            id: confluenceWhiteboardData.id,
            type: (0, $3ElT9.CONFLUENCE_WHITEBOARD)
        };
        return whiteboard;
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'fetchConfluenceWhiteboard',
                teamName: 'bento',
                packageName: 'jiraIssueViewBase'
            },
            attributes: {
                embeddedConfluenceSource: embeddedConfluenceSource
            },
            error: new Error(`Failed to fetch Confluence whiteboard: ${error}`)
        });
        return undefined;
    }
};

});



parcelRegister("3ZcUw", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d5dcbd8365ea23$export$2e2bcd8739ae039);

var $7rh0R = parcelRequire("7rh0R");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $46d5dcbd8365ea23$var$DummyConfluenceLinkViewLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("67sSO")).then((module)=>module.DummyConfluenceLinkView), {
    moduleId: "./src/packages/issue/issue-view-base/src/content/confluence-placeholder-template-experiment/confluence-dummy-link/dummy-confluence-link-view.tsx"
});
var $46d5dcbd8365ea23$export$2e2bcd8739ae039 = $46d5dcbd8365ea23$var$DummyConfluenceLinkViewLazy;

});
parcelRegister("67sSO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('5nG2g')
        ]);
        const value = parcelRequire('heaF9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("5nG2g")
    ]).then(()=>parcelRequire('heaF9'));
}

});


parcelRegister("eUd7S", function(module, exports) {

$parcel$export(module.exports, "LinkedMentionedContentPreview", () => $a17c95c85306848a$export$19fa86762789d3f4);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");


var $1ZcLe = parcelRequire("1ZcLe");

var $jMP2a = parcelRequire("jMP2a");
const $a17c95c85306848a$var$entryPointParams = {};
const $a17c95c85306848a$export$19fa86762789d3f4 = ({ contentCount: contentCount })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $1ZcLe.linkedMentionedContentPreviewEntrypoint), $a17c95c85306848a$var$entryPointParams);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, embedConfluenceBentoAAfireExposureEvent] = (0, $79xbN.UNSAFE_noExposureExp)('platform_embed-conf_bento_linked_crossjoin_exp_aa');
    const [embedConfluenceBentoConfig, embedConfluenceBentofireExposureEvent] = (0, $79xbN.UNSAFE_noExposureExp)('platform_embed-conf_bento_linked_crossjoin_exp');
    const embedConfluenceBentoCohort = embedConfluenceBentoConfig.get('cohort', 'not-enrolled');
    (0, $eUqFw.useEffect)(()=>{
        // Fire exposure events
        if ((0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.linked-page-cross-join')) embedConfluenceBentofireExposureEvent();
        createAnalyticsEvent && (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
            flagKey: 'platform_embed-conf_bento_linked_crossjoin_exp',
            value: embedConfluenceBentoCohort,
            embeddedConfluenceSource: 'jiraIssueViewLinkedMentionedPage'
        });
        embedConfluenceBentoAAfireExposureEvent();
        // If enrolled in experiment cohort, display the content preview
        if ((0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.linked-page-cross-join') && embedConfluenceBentoCohort === 'experiment') entryPointActions.load();
    }, [
        createAnalyticsEvent,
        embedConfluenceBentoAAfireExposureEvent,
        embedConfluenceBentoCohort,
        embedConfluenceBentofireExposureEvent,
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "linkedMentionedContentPreviewEntrypointContainer",
        packageName: "@atlassian/jira-issue-create-confluence-content",
        teamName: "confluence-better-together",
        runtimeProps: {
            contentCount: contentCount,
            embeddedConfluenceSource: (0, $1b2c5e0fcb49d7fc$export$2e6ff5d53a830129)
        }
    });
};

});
parcelRegister("1ZcLe", function(module, exports) {

$parcel$export(module.exports, "linkedMentionedContentPreviewEntrypoint", () => $dd3c9cc3f93389d4$export$decf608783ea1b30);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $dd3c9cc3f93389d4$export$decf608783ea1b30 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("aIrNu")), {
        moduleId: "694f87c5"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aIrNu", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('e2tTE');
        const value = parcelRequire('32xjz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("e2tTE").then(()=>parcelRequire('32xjz'));
}

});




parcelRegister("l3ios", function(module, exports) {

$parcel$export(module.exports, "ConfluenceContentView", () => $1f42a15a262630c2$export$138741318ed9a8fd);
/* confluence-content-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $27nAz = parcelRequire("27nAz");

var $7ZZxN = parcelRequire("7ZZxN");

var $e91YZ = parcelRequire("e91YZ");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $8uD7Y = parcelRequire("8uD7Y");

var $9oEBG = parcelRequire("9oEBG");

var $kGJTW = parcelRequire("kGJTW");
var $bx1oo = parcelRequire("bx1oo");

var $coSdD = parcelRequire("coSdD");

var $7qm3W = parcelRequire("7qm3W");

var $iAc02 = parcelRequire("iAc02");

var $8Bhia = parcelRequire("8Bhia");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");

var $9Nizy = parcelRequire("9Nizy");

var $ksiXg = parcelRequire("ksiXg");

var $7NqS9 = parcelRequire("7NqS9");

var $1dOAy = parcelRequire("1dOAy");

var $bB2FQ = parcelRequire("bB2FQ");

var $3ZcUw = parcelRequire("3ZcUw");

var $eUd7S = parcelRequire("eUd7S");
const $1f42a15a262630c2$var$LINKED_PAGES_GROUP_ID = 'linked-confluence-pages';
const $1f42a15a262630c2$var$LINKED_WHITEBOARDS_GROUP_ID = 'linked-confluence-whiteboards';
const $1f42a15a262630c2$var$MENTIONED_PAGES_GROUP_ID = 'mentioned-confluence-pages';
class $1f42a15a262630c2$export$138741318ed9a8fd extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isConfluencePageLinksEnabled: false,
            linkedPagesCachedCount: 0,
            linkedWhiteboardsCachedCount: 0,
            mentionedPagesCachedCount: 0
        };
    }
    isIssueTypeEligibleForPlaceholderTemplate() {
        return this.props.issueType ? (0, $ksiXg.ELIGIBLE_ISSUE_TYPES).includes(this.props.issueType.name.toLowerCase()) : false;
    }
    shouldShowConfluenceContent() {
        return this.props.isCreateLinkedPageOpened || this.hasLinkedPages() || this.hasMentionedPages() || (0, $8Bhia.isWhiteboardStandaloneEnabled)() && this.hasLinkedWhiteboards();
    }
    getConfluenceContentPreviewDetails() {
        const { permitted: permitted } = (0, $9oEBG.getLocalStorageData)('userConfluenceAccess');
        const tenantHasConfluence = !!this.props.licensedProducts?.[(0, $e91YZ.LICENSED_PRODUCTS).CONFLUENCE];
        const totalConfluenceContentCount = this.getTotalContentCount();
        const canCrossJoin = tenantHasConfluence && !permitted && totalConfluenceContentCount > 0;
        const eligibleForLinkedPageCrossJoinExperiment = (0, $8Bhia.isCrossJoinContentPreviewEnabled)() && canCrossJoin;
        const [embedConfluenceConfig] = (0, $79xbN.UNSAFE_noExposureExp)('platform_embed-conf_jira-issue_cross-join_exp');
        const embedConfluenceCohort = embedConfluenceConfig.get('cohort', 'not-enrolled');
        const showContentPreview = eligibleForLinkedPageCrossJoinExperiment && (0, $1ybV0.ff)('platform_embed-conf_jira-issue_create_cross-join') && embedConfluenceCohort === 'experiment'; // enrolled in the test/experiment cohort
        return {
            showContentPreview: showContentPreview,
            eligibleForLinkedPageCrossJoinExperiment: eligibleForLinkedPageCrossJoinExperiment,
            totalConfluenceContentCount: totalConfluenceContentCount
        };
    }
    hasLinkedPages() {
        return this.props.linkedPages && this.props.linkedPages.length > 0;
    }
    hasMentionedPages() {
        return this.props.mentionedPages && this.props.mentionedPages.length > 0;
    }
    hasAnyLinkedPageLoaded() {
        return this.props.linkedPages && this.props.linkedPages.length > 0;
    }
    hasAnyMentionedPageLoaded() {
        return this.props.mentionedPages && this.props.mentionedPages.length > 0;
    }
    renderLinkedPagesAndWhiteboards() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f42a15a262630c2$var$GroupContainer, null, (this.props.linkedPages || this.props.linkedWhiteboards) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qm3W.Container), null, this.renderLinkedPagesIfAny(), this.renderLinkedWhiteboardsIfAny()), !this.props.linkedPages && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $coSdD.default), {
            itemCount: this.props.linkedPagesCachedCount ?? 0
        }), !this.props.linkedWhiteboards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $coSdD.default), {
            itemCount: this.props.linkedWhiteboardsCachedCount ?? 0
        }));
    }
    renderLinkedPages() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f42a15a262630c2$var$GroupContainer, null, this.props.linkedPages ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qm3W.Container), null, this.renderLinkedPagesIfAny()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $coSdD.default), {
            itemCount: this.props.linkedPagesCachedCount ?? 0
        }));
    }
    renderMentionedPage() {
        return (0, $8Bhia.isFitAndFinishFullPageMilestone2)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $1f42a15a262630c2$var$containerWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qm3W.Container), null, this.renderMentionedPagesIfAny())) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qm3W.Container), null, this.renderMentionedPagesIfAny());
    }
    renderMentionedPages() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f42a15a262630c2$var$GroupContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
            as: "h3",
            level: "h200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            id: "issue.details.confluence-pages.mentioned-on",
            defaultMessage: "mentioned on"
        })), this.props.mentionedPages ? this.renderMentionedPage() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $coSdD.default), {
            itemCount: this.props.mentionedPagesCachedCount ?? 0
        }));
    }
    renderCreateLinkedPage() {
        return this.props.isCreateLinkedPageOpened ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bB2FQ.default), null) : null;
    }
    renderConfluenceContentFragment({ totalConfluenceContentCount: totalConfluenceContentCount, showContentPreview: showContentPreview, eligibleForLinkedPageCrossJoinExperiment: eligibleForLinkedPageCrossJoinExperiment }) {
        const shouldDisplayHeading = this.shouldShowConfluenceContent() || showContentPreview;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldDisplayHeading && this.renderHeading(), !(0, $8Bhia.isWhiteboardStandaloneEnabled)() && this.hasLinkedPages() && this.renderLinkedPages(), (0, $8Bhia.isWhiteboardStandaloneEnabled)() && (this.hasLinkedPages() || this.hasLinkedWhiteboards()) && this.renderLinkedPagesAndWhiteboards(), this.hasMentionedPages() && this.renderMentionedPages(), eligibleForLinkedPageCrossJoinExperiment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUd7S.LinkedMentionedContentPreview), {
            contentCount: totalConfluenceContentCount
        }), this.renderCreateLinkedPage());
    }
    renderConfluenceDummyLink() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "confluencePlaceholderTemplate",
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
            attributes: {
                experiment: 'placeholderTemplateContextual'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "confluence-dummy-link-experiment",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7NqS9.ConfluenceDummyLinkProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27nAz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ZcUw.default), {
            issueType: this.props.issueType,
            tenantHasConfluenceAppLinks: this.props.tenantHasConfluenceAppLinks,
            projectName: this.props.projectName
        })))));
    }
    getTotalContentCount() {
        /* In order to display a preview for linked & mentioned confluence content,
              we need to exclude the count of app linked content if any. When the user dosn't have
              access to confluence in the current site, but has access to an applinked site, then
              we still want to show the applinked content to the user. The links to be displayed are contained with the
              'pages' or the 'whiteboards' array selector. The length of these arrays should be subtracted from the cached count,
              because cached count would have the total number of all links, including the applinked ones.
               For a scenario where these arrays are empty, we display the cahced count as is. (Unless there are
              any config errors with the applinks, the array must have links to the app-linked content).
          */ const { linkedPagesCachedCount: linkedPagesCachedCount = 0, mentionedPagesCachedCount: mentionedPagesCachedCount = 0, linkedWhiteboardsCachedCount: linkedWhiteboardsCachedCount = 0, linkedPages: linkedPages, linkedWhiteboards: linkedWhiteboards, mentionedPages: mentionedPages } = this.props;
        const linkedPagesCount = linkedPages?.length ?? 0;
        const mentionedPagesCount = mentionedPages?.length ?? 0;
        const linkedWhiteboardsCount = linkedWhiteboards?.length ?? 0;
        const totalCount = linkedPagesCachedCount - linkedPagesCount + (mentionedPagesCachedCount - mentionedPagesCount) + (linkedWhiteboardsCachedCount - linkedWhiteboardsCount);
        return totalCount < 0 ? 0 : totalCount;
    }
    render() {
        const { showContentPreview: showContentPreview, totalConfluenceContentCount: totalConfluenceContentCount, eligibleForLinkedPageCrossJoinExperiment: eligibleForLinkedPageCrossJoinExperiment } = this.getConfluenceContentPreviewDetails();
        if (this.props.isConfluencePageLinksEnabled && (this.shouldShowConfluenceContent() || eligibleForLinkedPageCrossJoinExperiment)) return this.renderConfluenceContentFragment({
            totalConfluenceContentCount: totalConfluenceContentCount,
            showContentPreview: showContentPreview,
            eligibleForLinkedPageCrossJoinExperiment: eligibleForLinkedPageCrossJoinExperiment
        });
        if ((0, $9Nizy.isConfluencePageDummyLinkExperiment)() && this.props?.projectType === (0, $7ZZxN.SOFTWARE_PROJECT) && this.isIssueTypeEligibleForPlaceholderTemplate()) return this.renderConfluenceDummyLink();
        return null;
    }
    constructor(...args){
        super(...args);
        this.hasLinkedWhiteboards = ()=>this.props.linkedWhiteboards && this.props.linkedWhiteboards.length > 0 /*
                                                                                                         *  The mentioned page count is a cached value that
                                                                                                         *  may be out of date, so use the actual fetched
                                                                                                         *  pages' count once this is available.
                                                                                                         */ ;
        this.renderHeading = ()=>{
            const { canLinkConfluencePage: canLinkConfluencePage, onAddButtonClicked: onAddButtonClicked } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f42a15a262630c2$var$StyledSectionHeading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingTitle), null, (0, $8Bhia.isWhiteboardStandaloneEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                id: "issue.details.confluence-content.heading.non-final",
                defaultMessage: "Confluence content"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                id: "issue.details.confluence-pages.heading",
                defaultMessage: "Confluence pages"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingIcons), null, canLinkConfluencePage && this.hasLinkedPages() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1dOAy.default), {
                onClick: onAddButtonClicked
            })));
        };
        this.renderLinkedPagesIfAny = ()=>this.hasAnyLinkedPageLoaded() && this.props.linkedPages ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGJTW.ConfluencePageLineCardGroup), {
                groupId: $1f42a15a262630c2$var$LINKED_PAGES_GROUP_ID,
                pages: this.props.linkedPages,
                onClick: this.props.onLinkedPageClicked,
                onAuthenticateApplink: this.props.onAuthenticateApplink,
                onDeleteConfluencePageLink: this.props.onDeleteConfluencePageLink,
                systemConfluenceAppLinkUrl: this.props.systemConfluenceAppLinkUrl
            }) : null;
        this.renderLinkedWhiteboardsIfAny = ()=>this.hasLinkedWhiteboards() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bx1oo.ConfluenceWhiteboardLineCardGroup), {
                groupId: $1f42a15a262630c2$var$LINKED_WHITEBOARDS_GROUP_ID,
                whiteboards: this.props.linkedWhiteboards || [],
                onClick: this.props.onLinkedWhiteboardClicked,
                systemConfluenceAppLinkUrl: this.props.systemConfluenceAppLinkUrl
            }) : null;
        this.renderMentionedPagesIfAny = ()=>this.hasAnyMentionedPageLoaded() && this.props.mentionedPages ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGJTW.ConfluencePageLineCardGroup), {
                groupId: $1f42a15a262630c2$var$MENTIONED_PAGES_GROUP_ID,
                pages: this.props.mentionedPages,
                onClick: this.props.onMentionedPageClicked,
                onAuthenticateApplink: this.props.onAuthenticateApplink,
                onDeleteConfluencePageLink: this.props.onDeleteConfluencePageLink,
                systemConfluenceAppLinkUrl: this.props.systemConfluenceAppLinkUrl
            }) : null;
    }
}
// 1px padding to the right to be aligned with the add comment box because of the shadow around it
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f42a15a262630c2$var$GroupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81bpf _u5f3v77o",
            __cmplp.className
        ])
    });
});
const $1f42a15a262630c2$var$StyledSectionHeading = (0, $bAQOb.componentWithFF)('issue-view-fit-and-finish-full-page-milestone2_ebk0i', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $iAc02.SectionHeading), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3tdu2gc",
            __cmplp.className
        ])
    });
}), (0, $iAc02.SectionHeading));
const $1f42a15a262630c2$var$containerWrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: "var(--ds-space-100, 8px)"
});

});


const $f81f1bce6a43965e$export$e8e23d64897ffb27 = 'DESCRIPTION_BEGIN_MARK';
const $f81f1bce6a43965e$export$463411fdb916515b = 'DESCRIPTION_END_MARK';
const $f81f1bce6a43965e$export$54f1396e5ffd4590 = 'ATTACHMENTS_BEGIN_MARK';
const $f81f1bce6a43965e$export$3975b248e82a7c0a = 'ATTACHMENTS_END_MARK';
const $f81f1bce6a43965e$export$9041a7b7e88e361c = 'EPICS_BEGIN_MARK';
const $f81f1bce6a43965e$export$9d129af159277ce6 = 'EPICS_END_MARK';
const $f81f1bce6a43965e$export$9bd418b55b566599 = 'CHILDREN_ISSUES_BEGIN_MARK';
const $f81f1bce6a43965e$export$7958fe004adaa3bc = 'CHILDREN_ISSUES_END_MARK';
const $f81f1bce6a43965e$export$1b794597fcbd5751 = 'DESIGNS_BEGIN_MARK';
const $f81f1bce6a43965e$export$70d0ea83a1808647 = 'DESIGNS_END_MARK';
const $f81f1bce6a43965e$export$3d4e141840f1aac8 = 'PORTFOLIO_CHILD_ISSUES_BEGIN_MARK';
const $f81f1bce6a43965e$export$e60e6a80b7facff4 = 'PORTFOLIO_CHILD_ISSUES_END_MARK';
const $f81f1bce6a43965e$export$bb43ccf3e3900f2b = 'SUBTASKS_BEGIN_MARK';
const $f81f1bce6a43965e$export$403af9cb99ef333c = 'SUBTASKS_END_MARK';
const $f81f1bce6a43965e$export$be6a90067f95baab = 'ISSUE_LINKS_BEGIN_MARK';
const $f81f1bce6a43965e$export$723da9c2113b48ac = 'ISSUE_LINKS_END_MARK';
const $f81f1bce6a43965e$export$2a502f9597423df = 'INCIDENT_INVESTIGATIONS_BEGIN_MARK';
const $f81f1bce6a43965e$export$9e7166db9066a70c = 'INCIDENT_INVESTIGATIONS_END_MARK';
const $f81f1bce6a43965e$export$e52e4309fab00924 = 'OBJECT_RELATED_REQUESTS_BEGIN_MARK';
const $f81f1bce6a43965e$export$23b5270957de9348 = 'OBJECT_RELATED_REQUESTS_END_MARK';
const $f81f1bce6a43965e$export$2e7ef86bf0b0c538 = 'SMART_RELATED_ISSUES_BEGIN_MARK';
const $f81f1bce6a43965e$export$ea5c1c1aa5a7d968 = 'SMART_RELATED_ISSUES_END_MARK';
const $f81f1bce6a43965e$export$1f85461152ae6ebe = 'CONFLUENCE_PAGES_BEGIN_MARK';
const $f81f1bce6a43965e$export$f98414d200c7e4b2 = 'CONFLUENCE_PAGES_END_MARK';
const $f81f1bce6a43965e$export$e35d17be2cbccdd3 = 'WEB_LINKS_BEGIN_MARK';
const $f81f1bce6a43965e$export$63fc599eb362724d = 'WEB_LINKS_END_MARK';
const $f81f1bce6a43965e$export$70af08e0a6b3822f = 'ADDITIONAL_WEB_LINKS_BEGIN_MARK';
const $f81f1bce6a43965e$export$d393cbfad2346d95 = 'ADDITIONAL_WEB_LINKS_END_MARK';
const $f81f1bce6a43965e$export$90a3abbe8506f4a0 = 'ECOSYSTEM_CONTENT_BEGIN_MARK';
const $f81f1bce6a43965e$export$a004acf8c80d1b41 = 'ECOSYSTEM_CONTENT_END_MARK';
const $f81f1bce6a43965e$export$d2d165c326639635 = 'LINKED_ALERTS_BEGIN_MARK';
const $f81f1bce6a43965e$export$90c796d64f08408b = 'LINKED_ALERTS_END_MARK';
const $f81f1bce6a43965e$export$8b2039a2b5f6a2a = 'PROFORMA_FORMS_BEGIN_MARK';
const $f81f1bce6a43965e$export$c11901fec2d15d7d = 'PROFORMA_FORMS_END_MARK';
const $f81f1bce6a43965e$export$ddbcaec2748e8744 = 'DEV_OPS_APP_RECOMMENDATIONS_BEGIN_MARK_KEY';
const $f81f1bce6a43965e$export$d94a044231640d0 = 'DEV_OPS_APP_RECOMMENDATIONS_END_MARK_KEY';

parcelRegister("cBTTN", function(module, exports) {

$parcel$export(module.exports, "DesignPanel", () => $bda62eaea11bd4f2$export$bdcd5eaaed8e77e1);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $lAZav = parcelRequire("lAZav");

var $dDUFm = parcelRequire("dDUFm");

var $3Tszs = parcelRequire("3Tszs");

var $huI7r = parcelRequire("huI7r");

var $dWLk9 = parcelRequire("dWLk9");

var $jK1pm = parcelRequire("jK1pm");
const $bda62eaea11bd4f2$export$bdcd5eaaed8e77e1 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const issueId = (0, $hJ992.useIssueId)();
    const issueAri = (0, $3Tszs.useIssueAri)();
    const siteAri = (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        resourceType: 'site',
        resourceId: cloudId
    });
    const entryPointParams = (0, $eUqFw.useMemo)(()=>({
            siteAri: siteAri,
            issueAri: issueAri,
            cloudId: cloudId
        }), [
        siteAri,
        issueAri,
        cloudId
    ]);
    const isUpdateSchemaEnabled = (0, $1ybV0.ff)('issue-view-designs-improved-schema');
    const { entryPointActions: newEntryPointActions, entryPointReferenceSubject: newEntryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $dDUFm.designPanelEntryPoint), entryPointParams);
    const { entryPointActions: legacyEntryPointActions, entryPointReferenceSubject: legacyEntryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $lAZav.designPanelEntryPointLegacy), entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        if (issueId) {
            if (isUpdateSchemaEnabled) newEntryPointActions.load();
            else legacyEntryPointActions.load();
        }
    }, [
        isUpdateSchemaEnabled,
        issueId,
        legacyEntryPointActions,
        newEntryPointActions
    ]);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            isExpanded: true
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "jiraIssueDesignPanel"
    }, isUpdateSchemaEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: newEntryPointReferenceSubject,
        id: "jiraIssueDesignPanel",
        packageName: "jiraIssueViewBase",
        errorFallback: "unmount",
        teamName: "mdt-zora",
        runtimeProps: runtimeProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: legacyEntryPointReferenceSubject,
        id: "jiraIssueDesignPanel",
        packageName: "jiraIssueViewBase",
        errorFallback: "unmount",
        teamName: "mdt-zora",
        runtimeProps: runtimeProps
    }));
};

});
parcelRegister("lAZav", function(module, exports) {

$parcel$export(module.exports, "designPanelEntryPointLegacy", () => $ec53f1fa80fe1711$export$92d6a890b602d3ac);

var $6p6cz = parcelRequire("6p6cz");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $ec53f1fa80fe1711$export$92d6a890b602d3ac = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("8Fjer")), {
        moduleId: "e1887244"
    }),
    getPreloadProps: ({ siteAri: siteAri, issueAri: issueAri, cloudId: cloudId })=>({
            queries: {
                designPanel: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6p6cz.default,
                    variables: {
                        siteAri: siteAri,
                        issueAri: issueAri,
                        cloudId: cloudId
                    }
                }
            },
            extraProps: {
                issueAri: issueAri
            }
        })
});

});
parcelRegister("6p6cz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2c75ff61fa8ddb3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<949d2aaa284cf03259e0d0b95101a5b4>>
 * @relayHash 2cae7491af53456249f8f30c1d13de78
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d17c91eb6f04d9bc3c1dc61ca25e1badc12e44fdd3e75e8ed9f67cfffbb959ff
const $e2c75ff61fa8ddb3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d17c91eb6f04d9bc3c1dc61ca25e1badc12e44fdd3e75e8ed9f67cfffbb959ff",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "devOps",
                        "ariGraph",
                        "relationships"
                    ]
                }
            ]
        },
        "name": "ui_DesignPanelOldQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e2c75ff61fa8ddb3$export$2e2bcd8739ae039 = $e2c75ff61fa8ddb3$var$node;

});

parcelRegister("8Fjer", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('56lPV')
        ]);
        const value = parcelRequire('kHwGn');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("56lPV")
    ]).then(()=>parcelRequire('kHwGn'));
}

});


parcelRegister("dDUFm", function(module, exports) {

$parcel$export(module.exports, "designPanelEntryPoint", () => $1ab9320f5a06b4dd$export$f3de142f38df5adc);

var $eBM0D = parcelRequire("eBM0D");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $1ab9320f5a06b4dd$export$f3de142f38df5adc = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("6WUnT")), {
        moduleId: "3f12c58c"
    }),
    getPreloadProps: ({ siteAri: siteAri, issueAri: issueAri, cloudId: cloudId })=>({
            queries: {
                designPanel: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $eBM0D.default,
                    variables: {
                        siteAri: siteAri,
                        issueAri: issueAri,
                        cloudId: cloudId
                    }
                }
            },
            extraProps: {
                issueAri: issueAri
            }
        })
});

});
parcelRegister("eBM0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaed95d1b675f009$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1b2470973d3312cddcb9a5763dbbf96c>>
 * @relayHash 1716f57cf42e2ced529fc33ecdd14534
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9fd7850fb2af841c7b2778ff02a681aa7e9300493fb5fde26a389fa80dff292
const $eaed95d1b675f009$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c9fd7850fb2af841c7b2778ff02a681aa7e9300493fb5fde26a389fa80dff292",
        "metadata": {},
        "name": "ui_DesignPanelQuery",
        "operationKind": "query",
        "text": null
    }
};
var $eaed95d1b675f009$export$2e2bcd8739ae039 = $eaed95d1b675f009$var$node;

});

parcelRegister("6WUnT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('ffCWN')
        ]);
        const value = parcelRequire('bHtZk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("ffCWN")
    ]).then(()=>parcelRequire('bHtZk'));
}

});



parcelRegister("lIwq2", function(module, exports) {

$parcel$export(module.exports, "AsyncDevOpsAppRecommendationPanel", () => $2b3efe18cf193528$export$fc5e1ee7d63c7600);

var $eUqFw = parcelRequire("eUqFw");

var $ipcjd = parcelRequire("ipcjd");

var $1HzcR = parcelRequire("1HzcR");
const $2b3efe18cf193528$var$runtimeProps = {};
const $2b3efe18cf193528$export$fc5e1ee7d63c7600 = ()=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $eUqFw.useContext)((0, $ipcjd.DevOpsAppRecommendationContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "devOpsAppRecommendationsPanel",
        packageName: "jiraIssueViewBase",
        errorFallback: "unmount",
        teamName: "open-toolchain-arc",
        runtimeProps: $2b3efe18cf193528$var$runtimeProps
    });
};

});

parcelRegister("3BpHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d241baf8864943$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $6rkLV = parcelRequire("6rkLV");

var $imVNa = parcelRequire("imVNa");parcelRequire("3VVr2");
var $agEEp = parcelRequire("agEEp");
var $3VVr2 = parcelRequire("3VVr2");

var $f9RL0 = parcelRequire("f9RL0");

var $lqalZ = parcelRequire("lqalZ");

var $3rr33 = parcelRequire("3rr33");

var $hHnBv = parcelRequire("hHnBv");

var $1OJS4 = parcelRequire("1OJS4");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $1b2Vj = parcelRequire("1b2Vj");

var $9GGoL = parcelRequire("9GGoL");

var $iY7NN = parcelRequire("iY7NN");

var $75LXB = parcelRequire("75LXB");

var $kZlOa = parcelRequire("kZlOa");

var $ke6cX = parcelRequire("ke6cX");

var $1TrR5 = parcelRequire("1TrR5");

var $lFAHQ = parcelRequire("lFAHQ");
const $88d241baf8864943$export$413b1c23ad987cd8 = (props)=>{
    const reduxOnChange = props.onChange;
    const issueKey = (0, $hJ992.useIssueKey)();
    const [currentValue, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $f9RL0.EPIC_ISSUES)
    });
    const [{ issuetype: issuetype }] = (0, $6rkLV.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const { issueHierarchyLevel: issueHierarchyLevel, issueTypes: issueTypes } = props;
    // Only retrieve issue types that have hierarchy level less than the parent issue type
    // issueTypesForClassicProjectEpicSelector already selects non-subtask issues
    const childIssueTypes = (0, $eUqFw.useMemo)(()=>{
        if (!(0, $1ybV0.ff)('issue.details.issue-type-select-hierarchy-fix')) return [];
        // allowedValues contains hierarchyLevel but issueTypes from Redux state does not
        const issueTypesWithHierarchy = issuetype.allowedValues;
        // Need to merge since issueTypes contains fields property which is needed for requiredFields
        const mergedIssueTypes = issueTypes.map((issueType)=>{
            const issueTypeWithHierarchy = issueTypesWithHierarchy.find((withHierarchy)=>withHierarchy?.id === issueType.id);
            return {
                ...issueType,
                hierarchyLevel: issueTypeWithHierarchy?.hierarchyLevel ?? undefined
            };
        });
        return mergedIssueTypes.filter((issueType)=>issueType.hierarchyLevel < issueHierarchyLevel);
    }, [
        issuetype.allowedValues,
        issueHierarchyLevel,
        issueTypes
    ]);
    const onChange = (0, $eUqFw.useCallback)((event)=>{
        switch(event.type){
            case (0, $imVNa.ChangeEventTypes).CHILD_ISSUE_ADDED:
                setFieldValue(issueKey, (0, $f9RL0.EPIC_ISSUES), currentValue.concat({
                    id: event.meta.childIssue.id,
                    key: event.meta.childIssue.issueKey
                }));
                break;
            default:
                break;
        }
        reduxOnChange(event);
    }, [
        currentValue,
        issueKey,
        reduxOnChange,
        setFieldValue
    ]);
    if ((0, $1ybV0.ff)('issue.details.issue-type-select-hierarchy-fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3VVr2.default), {
        ...props,
        onChange: onChange,
        issueTypes: childIssueTypes
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3VVr2.default), {
        ...props,
        onChange: onChange
    });
};
const $88d241baf8864943$var$onNavigateToNewIssueMemoized = (0, $5iWql.default)((onNavigateToNewIssueDispatchProp)=>// @ts-expect-error - TS7031 - Binding element 'fromIssueKey' implicitly has an 'any' type. | TS7031 - Binding element 'toIssueKey' implicitly has an 'any' type.
    ({ fromIssueKey: fromIssueKey, toIssueKey: toIssueKey })=>{
        onNavigateToNewIssueDispatchProp && onNavigateToNewIssueDispatchProp({
            fromIssueKey: fromIssueKey,
            toIssueKey: toIssueKey
        });
    });
const $88d241baf8864943$var$ReduxConnectedComponent = (0, $lqalZ.connect)((state)=>({
        childIssuesPanelType: (0, $agEEp.CLASSIC_PROJECT_EPIC_CHILDREN),
        parentId: (0, $5JqpU.issueIdSelector)(state),
        epicLinkFieldKey: (0, $jZDJX.epicLinkFieldKeySelector)(state),
        issueTypes: (0, $ke6cX.issueTypesForClassicProjectEpicSelector)(state),
        issues: (0, $75LXB.persistedChildrenIssuesSelector)(state),
        messages: $lFAHQ.default,
        quickAddClickCount: (0, $iY7NN.issueInEpicQuickAddClickCountSelector)(state),
        supportsIssueCreation: (0, $kZlOa.canCreateIssuesInEpicSelector)(state),
        isIssueViewComplete: (0, $jZDJX.isCompletedLoadingSelector)(state),
        fetchIssueTypesStatus: (0, $ke6cX.fetchIssueTypesStatusSelector)(state),
        issueHierarchyLevel: (0, $1b2Vj.hierarchyLevelSelector)(state),
        childIssuesLimitUrl: (0, $fokFV.childIssuesLimitUrlSelector)(state)((0, $f9RL0.EPIC_ISSUES)),
        hasExceededIssuesLimitAfterLoad: undefined,
        totalChildIssueCount: (0, $9GGoL.totalChildIssueCountSelector)(state)
    }), (dispatch)=>({
        onChange: (event)=>{
            switch(event.type){
                case (0, $imVNa.ChangeEventTypes).CHILD_ISSUE_ADDED:
                    dispatch((0, $hHnBv.childIssueAddSuccess)(event.meta.childIssue, event.meta.fieldsData));
                    break;
                default:
                    break;
            }
        },
        onAddChildClick: ()=>dispatch((0, $hHnBv.childIssuePanelAddClick)()),
        // @ts-expect-error - TS7031 - Binding element 'fromIssueKey' implicitly has an 'any' type. | TS7031 - Binding element 'toIssueKey' implicitly has an 'any' type.
        onNavigateToNewIssueDispatchProp: ({ fromIssueKey: fromIssueKey, toIssueKey: toIssueKey })=>{
            if (!__SPA__) dispatch((0, $1OJS4.navigateToNewIssue)({
                fromIssueKey: fromIssueKey,
                toIssueKey: toIssueKey
            }));
        },
        onEditAssociatedIssue: (issueKey)=>{
            dispatch((0, $3rr33.updateAssociatedIssueRequest)(issueKey));
        }
    }), (stateProps, dispatchProps)=>{
    const { onNavigateToNewIssueDispatchProp: onNavigateToNewIssueDispatchProp, ...restDispatchProps } = dispatchProps;
    return {
        ...stateProps,
        ...restDispatchProps,
        onNavigateToNewIssue: (0, $1TrR5.functionWithFFRedux)($88d241baf8864943$var$onNavigateToNewIssueMemoized(onNavigateToNewIssueDispatchProp), ({ fromIssueKey: fromIssueKey, toIssueKey: toIssueKey })=>{
            onNavigateToNewIssueDispatchProp && onNavigateToNewIssueDispatchProp({
                fromIssueKey: fromIssueKey,
                toIssueKey: toIssueKey
            });
        })
    };
})($88d241baf8864943$export$413b1c23ad987cd8);
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$88d241baf8864943$export$2e2bcd8739ae039 = $88d241baf8864943$var$ReduxConnectedComponent;

});
parcelRegister("lFAHQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $aadc318a997e5cbf$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $aadc318a997e5cbf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue.epic-issues-title",
        "defaultMessage": "Issues in this epic"
    },
    titleChildIssues: {
        "id": "issue.epic-issues-title-child-issues",
        "defaultMessage": "Child issues"
    }
});

});


parcelRegister("eFn9t", function(module, exports) {

$parcel$export(module.exports, "IncidentInvestigationPanel", () => $16f8924e79e84af5$export$6c362a2f4fd2784);

var $9uSE8 = parcelRequire("9uSE8");

var $5G3JL = parcelRequire("5G3JL");

var $f9RL0 = parcelRequire("f9RL0");

var $lqalZ = parcelRequire("lqalZ");

var $cn1uL = parcelRequire("cn1uL");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $6Wyw2 = parcelRequire("6Wyw2");

var $lA0N8 = parcelRequire("lA0N8");
const $16f8924e79e84af5$export$6c362a2f4fd2784 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        issueSummary: (0, $fokFV.fieldEditingAdfValueSelector)((0, $f9RL0.ISSUE_SUMMARY))(state),
        issueDescription: (0, $fokFV.fieldEditingAdfValueSelector)((0, $f9RL0.DESCRIPTION))(state),
        impactedServices: (0, $lA0N8.serviceEntitySelector)(state),
        issueKey: (0, $5JqpU.issueKeySelector)(state),
        // FIXME: JIV-17455. This field can be null
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        issueId: (0, $5JqpU.issueIdSelector)(state),
        projectKey: (0, $5JqpU.projectKeySelector)(state),
        projectId: (0, $jZDJX.projectIdSelector)(state),
        isIncidentInvestigationModalVisible: (0, $6Wyw2.isInvestigateIncidentModalOpenedSelector)(state)
    }), {
    onCloseIncidentInvestigationModal: (0, $cn1uL.investigateIncidentModalClosed)
}))((0, $9uSE8.default));

});
parcelRegister("9uSE8", function(module, exports) {

$parcel$export(module.exports, "default", () => $06f9801c10e5570a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $2wCUM = parcelRequire("2wCUM");

var $gGtKh = parcelRequire("gGtKh");

var $f1lMr = parcelRequire("f1lMr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $06f9801c10e5570a$var$IncidentInvestigationPanel = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("duLZY")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/incident-management/issue-view/incident-investigation/src/main.tsx"
});
const $06f9801c10e5570a$var$AsyncIncidentInvestigationPanel = (props)=>{
    const [practices] = (0, $2wCUM.usePracticesFieldValue)({
        issueKey: props.issueKey
    });
    const isIncident = (0, $eUqFw.useMemo)(()=>Array.isArray(practices) && practices.includes((0, $f1lMr.INCIDENTS)), [
        practices
    ]);
    if (isIncident) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "servicedesk-incident-management-issue-view-incident-investigation",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($06f9801c10e5570a$var$IncidentInvestigationPanel, props));
    return null;
};
var $06f9801c10e5570a$export$2e2bcd8739ae039 = $06f9801c10e5570a$var$AsyncIncidentInvestigationPanel;

});
parcelRegister("duLZY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6SBR3');
        const value = parcelRequire('d8pOQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6SBR3").then(()=>parcelRequire('d8pOQ'));
}

});


parcelRegister("6Wyw2", function(module, exports) {

$parcel$export(module.exports, "isInvestigateIncidentModalOpenedSelector", () => $830a8ed48540c027$export$80042e486458ebd4);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $830a8ed48540c027$export$80042e486458ebd4 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (uiState)=>uiState.investigateIncident.showInvestigateIncidentModal);

});

parcelRegister("lA0N8", function(module, exports) {

$parcel$export(module.exports, "serviceEntitySelector", () => $300088fd946418ae$export$bb117739cbdedd05);

var $df4Sl = parcelRequire("df4Sl");

var $lO4Or = parcelRequire("lO4Or");

var $fokFV = parcelRequire("fokFV");
const $300088fd946418ae$export$4d242a757c919e6b = (0, $fokFV.fieldByCustomTypeSelector)((0, $lO4Or.SERVICE_ENTITY_CF_TYPE));
const $300088fd946418ae$export$bb117739cbdedd05 = (0, $df4Sl.createSelector)($300088fd946418ae$export$4d242a757c919e6b, (field)=>field && field.value);

});


parcelRegister("cDMTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5783be8436ffcf5c$export$2e2bcd8739ae039);

var $8nrDO = parcelRequire("8nrDO");

var $2jDha = parcelRequire("2jDha");

var $hFmdR = parcelRequire("hFmdR");
var $jUhyG = parcelRequire("jUhyG");

var $h7bH5 = parcelRequire("h7bH5");

var $tHNWK = parcelRequire("tHNWK");

var $1ybV0 = parcelRequire("1ybV0");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $a0kZP = parcelRequire("a0kZP");

var $3rr33 = parcelRequire("3rr33");

var $49xWy = parcelRequire("49xWy");

var $02hYD = parcelRequire("02hYD");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $cFY86 = parcelRequire("cFY86");

var $ddnuS = parcelRequire("ddnuS");

var $6vrw7 = parcelRequire("6vrw7");

var $fnw26 = parcelRequire("fnw26");
const $5783be8436ffcf5c$var$linkedIssueCreatedAnalyticsAction = 'created';
const $5783be8436ffcf5c$var$IssueLinksViewWithStore = (0, $lqalZ.connect)((state)=>({
        canAddIssueLinks: (0, $ddnuS.canAddIssueLinksSelector)(state),
        hasLinks: (0, $cFY86.hasCombinedIssueLinksSelector)(state),
        issueLinks: (0, $cFY86.combinedLinksSelector)(state),
        // FIXME: missing transformIssueLinkTypes? this is serious!
        // FIXME: JIV-17455 should be fully typed
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
        issueLinkTypes: (0, $ddnuS.issueLinkTypesSelector)(state),
        baseUrl: (0, $5JqpU.baseUrlSelector)(state),
        issueKey: (0, $5JqpU.issueKeySelector)(state),
        externalId: 'issue.issue-links',
        displayAddIssueLinks: (0, $cFY86.shouldDisplayAddLinksSelector)(state),
        // FIXME: JIV-17455 should be fully typed
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        projectType: (0, $jZDJX.projectTypeSelector)(state),
        isIssueViewComplete: (0, $jZDJX.isCompletedLoadingSelector)(state)
    }), (dispatch)=>({
        onAuthenticateApplink: (href, analyticsEvent)=>dispatch((0, $a0kZP.applinkAuthenticationRequest)(href, analyticsEvent)),
        deleteLinkedIssue: ({ linkId: linkId, globalId: globalId }, application, edition, analyticsEvent)=>{
            if (globalId !== undefined) dispatch((0, $02hYD.deleteRemoteLinkedIssueRequest)(globalId, application, edition, analyticsEvent));
            else dispatch((0, $49xWy.deleteLinkedIssueRequest)(linkId, application, edition, analyticsEvent));
        },
        cancelLinkedIssue: (optimisticId, isRemote)=>{
            if (isRemote) dispatch((0, $02hYD.saveRemoteLinkedIssueCancel)(optimisticId));
            else dispatch((0, $49xWy.saveLinkedIssueCancel)(optimisticId));
        },
        retryLinkedIssue: (optimisticId, isRemote, requestAnalyticsEvent, maybeAnalyticsEventOrPostAnalyticsEvent, onSuccess, onError, analyticsEvent)=>{
            if ((0, $1ybV0.ff)('corex-operandi-issue-view-additional-logging_l6hj8')) {
                if (isRemote) dispatch((0, $02hYD.saveRemoteLinkedIssueRetry)(optimisticId, requestAnalyticsEvent, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                analyticsEvent, onSuccess, onError));
                else dispatch((0, $49xWy.saveLinkedIssueRetry)(optimisticId, requestAnalyticsEvent, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                analyticsEvent, onSuccess, onError, maybeAnalyticsEventOrPostAnalyticsEvent));
            } else // eslint-disable-next-line no-lonely-if
            if (isRemote) dispatch((0, $02hYD.saveRemoteLinkedIssueRetry)(optimisticId, requestAnalyticsEvent, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            maybeAnalyticsEventOrPostAnalyticsEvent, onSuccess, onError));
            else dispatch((0, $49xWy.saveLinkedIssueRetry)(optimisticId, requestAnalyticsEvent, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            maybeAnalyticsEventOrPostAnalyticsEvent, onSuccess, onError));
        },
        onIssueLinkAddClick: ()=>dispatch((0, $49xWy.addIssueLinkClick)()),
        onIssueLinkAddClosed: ()=>dispatch((0, $49xWy.closeAddIssueLink)()),
        onMountCreatePermissionFetching: ()=>dispatch((0, $49xWy.fetchCreateLinkedIssuePermissionRequest)())
    }))((0, $fnw26.default));
const $5783be8436ffcf5c$var$IssueLinksViewWithLinkActions = (0, $tHNWK.default)($5783be8436ffcf5c$var$IssueLinksViewWithStore);
const $5783be8436ffcf5c$var$fireLinkedIssueCreatedTrackAnalytics = ({ issueLinks: issueLinks, linkedIssues: linkedIssues }, analyticsEvent)=>{
    const issueLinkId = (0, (/*@__PURE__*/$parcel$interopDefault($8nrDO)))(issueLinks)[0];
    // issueLinkId would be undefined when the newly created linked issue is not actually linked to the current
    // issue.
    if (issueLinkId !== undefined) {
        const issueLink = issueLinks[issueLinkId];
        const linkedIssue = linkedIssues[issueLink.linkedIssueKey];
        const analyticsAttributes = {
            action: $5783be8436ffcf5c$var$linkedIssueCreatedAnalyticsAction,
            actionSubjectId: linkedIssue.id,
            attributes: {
                linkTypeName: (0, $h7bH5.safeLinkTypeName)(issueLink.typeName),
                linkTypeId: issueLink.typeId,
                issueLinkId: issueLinkId
            }
        };
        (0, $jUhyG.fireTrackAnalytics)(analyticsEvent, analyticsAttributes);
    }
};
var // FIXME:JIV-17455 - this should be strongly typed
$5783be8436ffcf5c$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $2jDha.default)({
    deleteLinkedIssue: {
        action: 'deleted'
    },
    onAuthenticateApplink: {
        action: 'authenticate'
    }
}), (0, $hFmdR.AnalyticsSubject)('linkedIssue'), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ issueId: string; } & { onLinkedIssueCreated: (newIssueLinks: IssueLinks, maybeAnalyticsEventOrPostAnalyticsEvent: UIAnalyticsEvent, analyticsEvent?: UIAnalyticsEvent | undefined) => void; onEditIssue: (issueKey: string) => void; }, {}>' is not assignable to parameter of type 'FlowStep<ContextResult<ForwardRefExoticComponent<PropsWithoutRef<LibraryManagedAttributes<Component, Omit<Props, keyof WithAnalyticsEventsProps>>> & RefAttributes<...>>, PropsWithoutRef<...> & RefAttributes<...>>, ConnectedComponent<...>>'.
(0, $lqalZ.connect)((state)=>({
        issueId: (0, $6vrw7.toIssueId)(String((0, $5JqpU.issueIdSelector)(state)))
    }), (dispatch)=>({
        onLinkedIssueCreated: (newIssueLinks, maybeAnalyticsEventOrPostAnalyticsEvent, analyticsEvent)=>{
            dispatch((0, $49xWy.createLinkedIssueSuccess)(newIssueLinks));
            if ((0, $1ybV0.ff)('corex-operandi-issue-view-additional-logging_l6hj8')) {
                Object.entries(newIssueLinks.issueLinks).forEach(([optimisticId, issueLink])=>{
                    dispatch((0, $49xWy.saveLinkedIssueSuccess)(optimisticId, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    analyticsEvent, issueLink.linkedIssueKey, maybeAnalyticsEventOrPostAnalyticsEvent));
                });
                dispatch((0, $49xWy.closeAddIssueLink)());
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $5783be8436ffcf5c$var$fireLinkedIssueCreatedTrackAnalytics(newIssueLinks, analyticsEvent);
            } else {
                Object.keys(newIssueLinks.issueLinks).forEach((optimisticId)=>{
                    dispatch((0, $49xWy.saveLinkedIssueSuccess)(optimisticId, maybeAnalyticsEventOrPostAnalyticsEvent));
                });
                dispatch((0, $49xWy.closeAddIssueLink)());
                $5783be8436ffcf5c$var$fireLinkedIssueCreatedTrackAnalytics(newIssueLinks, maybeAnalyticsEventOrPostAnalyticsEvent);
            }
        },
        onEditIssue: (issueKey)=>{
            dispatch((0, $3rr33.updateAssociatedIssueRequest)(issueKey));
        }
    })))($5783be8436ffcf5c$var$IssueLinksViewWithLinkActions);

});
parcelRegister("fnw26", function(module, exports) {

$parcel$export(module.exports, "default", () => $f48ac642e2fd52ce$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $illlw = parcelRequire("illlw");

var $8blac = parcelRequire("8blac");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $aml13 = parcelRequire("aml13");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $hFmdR = parcelRequire("hFmdR");
var $jPfP5 = parcelRequire("jPfP5");

var $kGQen = parcelRequire("kGQen");

var $8HuAw = parcelRequire("8HuAw");

var $0cdA8 = parcelRequire("0cdA8");


var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $8uD7Y = parcelRequire("8uD7Y");
var $4ksts = parcelRequire("4ksts");

var $hJ992 = parcelRequire("hJ992");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $bJKxA = parcelRequire("bJKxA");

var $gQylF = parcelRequire("gQylF");

var $4ceCM = parcelRequire("4ceCM");


var $5gJbo = parcelRequire("5gJbo");

var $5xRy0 = parcelRequire("5xRy0");

var $iAc02 = parcelRequire("iAc02");

var $9XfZZ = parcelRequire("9XfZZ");


var $lO4Or = parcelRequire("lO4Or");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");

var $guDlK = parcelRequire("guDlK");

var $6vrw7 = parcelRequire("6vrw7");

var $yyqSx = parcelRequire("yyqSx");

var $jK1pm = parcelRequire("jK1pm");

var $9Nizy = parcelRequire("9Nizy");

var $2GFZH = parcelRequire("2GFZH");

var $1nrwm = parcelRequire("1nrwm");

var $e9WdP = parcelRequire("e9WdP");

var $9iFfI = parcelRequire("9iFfI");

var $avHv0 = parcelRequire("avHv0");

var $hHZBg = parcelRequire("hHZBg");
const $f48ac642e2fd52ce$var$loadedIssueLinksCount = (issueLinks = {})=>issueLinks ? Object.keys(issueLinks).reduce((totalLinksCount, typeName)=>issueLinks[typeName].length + totalLinksCount, 0) : 0;
const $f48ac642e2fd52ce$var$getIssueIdsForDevSummaries = (issueLinks)=>Object.values(issueLinks).flatMap((issueLinksGroup)=>issueLinksGroup // The `@atlassian/jira-issue-dev-ops-summary` package used for fetching/rendering
        // dev summary info doesn't support multiple cloud IDs. So ignore remote links here.
        .filter((issueLink)=>!issueLink.isRemote).map((issueLink)=>issueLink.linkedIssue.id));
const $f48ac642e2fd52ce$var$ConfirmationModal = ({ confirmActionText: confirmActionText, contentMessage: contentMessage, externalId: externalId, headerMessage: headerMessage, onConfirm: onConfirm, onCancel: onCancel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPfP5.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "small",
        onClose: onCancel,
        testId: externalId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "warning"
    }, headerMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, contentMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "warning",
        onClick: onConfirm,
        testId: "issue.views.issue-base.content.issue-links.confirm-button",
        interactionName: "auto-generated.issue.views.issue-base.content.issue-links.confirm-button.button"
    }, confirmActionText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onCancel,
        testId: "issue.views.issue-base.content.issue-links.cancel-button",
        interactionName: "auto-generated.issue.views.issue-base.content.issue-links.cancel-button.button1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        id: "issue.views.issue-base.content.issue-links.cancel-button-text",
        defaultMessage: "Cancel"
    }))))));
const $f48ac642e2fd52ce$export$cec27bfb61bfc748 = (0, $hFmdR.AnalyticsSource)('removeLinkedIssue', (0, $41ea3621645e2acc$export$1171103ea9083ffa))($f48ac642e2fd52ce$var$ConfirmationModal);
const $f48ac642e2fd52ce$export$ba3a99fe2b92c78d = ({ issueLinks: issueLinks = null, issueLinkTypes: issueLinkTypes = [], isIssueViewComplete: isIssueViewComplete = false, onIssueLinkClicked: onIssueLinkClicked = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onIssueLinkRendered: onIssueLinkRendered = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onIssueLinkAddClick: onIssueLinkAddClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onIssueLinkAddClosed: onIssueLinkAddClosed = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onRemoveIssueLinkInitiated: onRemoveIssueLinkInitiated = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onMountCreatePermissionFetching: onMountCreatePermissionFetching, displayAddIssueLinks: displayAddIssueLinks, createAnalyticsEvent: createAnalyticsEvent, onAuthenticateApplink: onAuthenticateApplink, linkActions: linkActions, deleteLinkedIssue: deleteLinkedIssue, canAddIssueLinks: canAddIssueLinks, hasLinks: hasLinks, retryLinkedIssue: retryLinkedIssue, cancelLinkedIssue: cancelLinkedIssue, projectType: projectType, baseUrl: baseUrl, issueKey: issueKey, onLinkedIssueCreated: onLinkedIssueCreated, issueId: issueId, onEditIssue: onEditIssue })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const [state, setState] = (0, $eUqFw.useState)({
        hasDeleteModal: false,
        groupId: null,
        issueKey: null,
        globalId: undefined
    });
    (0, $eUqFw.useEffect)(()=>{
        if (hasLinks) // no need to dispatch fetch request if no links
        // @ts-expect-error - TS2345 - Argument of type 'IssueLink | null' is not assignable to parameter of type '{} | undefined'.
        onIssueLinkRendered($f48ac642e2fd52ce$var$loadedIssueLinksCount(issueLinks));
        onMountCreatePermissionFetching(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    (0, $eUqFw.useEffect)(()=>subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, async (payload)=>{
            if (payload.callbackPayload?.id !== (0, $33ffe55cb7bcdadc$export$f90eec3841adf619) && payload.callbackPayload?.id !== (0, $33ffe55cb7bcdadc$export$718822a309bffada)) return;
            const { createdIssueDetails: createdIssueDetails } = payload.createdIssueData;
            const { sourceIssueId: sourceIssueId, baseUrl: callbackPayloadBaseUrl } = payload.callbackPayload.data;
            if (issueId !== sourceIssueId) return;
            const analyticsEvent = createAnalyticsEvent({
                action: 'created'
            });
            if ((0, $1ybV0.ff)('corex-operandi-issue-view-additional-logging_l6hj8')) onLinkedIssueCreated?.((0, $e9WdP.default)(createdIssueDetails, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            sourceIssueId, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            callbackPayloadBaseUrl), createAnalyticsEvent({
                action: 'linkedToProject'
            }), analyticsEvent);
            else onLinkedIssueCreated?.((0, $e9WdP.default)(createdIssueDetails, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            sourceIssueId, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            callbackPayloadBaseUrl), analyticsEvent);
        }), [
        subscribe,
        onLinkedIssueCreated,
        createAnalyticsEvent,
        issueId
    ]);
    const handleOnIssueClickNew = (0, $eUqFw.useCallback)((// @ts-expect-error - TS2322 - Type '{}' is not assignable to type 'LinkedIssue'.
    { id: id, issueKey: lIssueKey, issueLink: issueLink, remoteIssueLinkError: remoteIssueLinkError, projectType: targetProjectType = null, isRemote: isRemote } = {}, event)=>{
        if (lIssueKey) {
            const isIssueNeedAuth = remoteIssueLinkError?.error === (0, $b7817a5fa36c8dd6$export$d1fe0e8f550fe68d);
            if (onIssueLinkClicked) // @ts-expect-error - TS2345 - Argument of type 'IssueLink | null' is not assignable to parameter of type '{} | undefined'.
            onIssueLinkClicked(id, targetProjectType, $f48ac642e2fd52ce$var$loadedIssueLinksCount(issueLinks));
            if ((0, $5gJbo.isLeftClickOnly)(event)) {
                if (isIssueNeedAuth) {
                    const repairLinkHref = remoteIssueLinkError?.repairLink?.href;
                    if (repairLinkHref && onAuthenticateApplink) onAuthenticateApplink((0, $6vrw7.toHref)(repairLinkHref));
                } else issueLink && (0, $8HuAw.default)(issueLink, event.metaKey, linkActions.push);
            }
            if ((0, $5gJbo.isMiddleClick)(event) || (0, $5gJbo.isCmdOrCtrlClick)(event)) !isIssueNeedAuth && issueLink && window.open(issueLink, '_blank');
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'card'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueLinkedCard', {
                clickedIssueId: id,
                // @ts-expect-error - TS2345 - Argument of type 'IssueLink | null' is not assignable to parameter of type '{} | undefined'.
                linkedIssuesCount: $f48ac642e2fd52ce$var$loadedIssueLinksCount(issueLinks),
                issueNeedsAuthentication: isIssueNeedAuth,
                isRemote: isRemote
            });
        }
    }, [
        createAnalyticsEvent,
        issueLinks,
        linkActions.push,
        onAuthenticateApplink,
        onIssueLinkClicked
    ]);
    const getLinkByGroupAndIssueKey = (0, $eUqFw.useCallback)((groupId, lIssueKey, globalId)=>(issueLinks && groupId && issueLinks[groupId] || []).find((issueLink)=>issueLink.linkedIssueKey === lIssueKey && issueLink.globalId === globalId), [
        issueLinks
    ]);
    const flattenedIssueLinks = (0, $eUqFw.useCallback)(()=>issueLinks ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.keys(issueLinks).reduce(// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        (acc, curr)=>[
                ...acc,
                ...issueLinks[curr]
            ], []) : [], [
        issueLinks
    ]);
    const modalClosedStateChanges = (0, $eUqFw.useCallback)(()=>{
        setState((oldState)=>({
                ...oldState,
                groupId: null,
                issueKey: null,
                hasDeleteModal: false,
                globalId: undefined
            }));
    }, []);
    const handleOnDeleteConfirm = (0, $eUqFw.useCallback)((groupId, lIssueKey, globalId)=>{
        const linkToDelete = getLinkByGroupAndIssueKey(groupId, lIssueKey, globalId);
        if (linkToDelete) {
            const deleteLinkId = linkToDelete.id;
            deleteLinkedIssue({
                linkId: deleteLinkId,
                globalId: globalId
            }, undefined, undefined);
            const indexOfDeletedLink = flattenedIssueLinks().findIndex((link)=>link.id === deleteLinkId && link.globalId === globalId);
            onRemoveIssueLinkInitiated(indexOfDeletedLink);
        }
        modalClosedStateChanges();
    }, [
        deleteLinkedIssue,
        flattenedIssueLinks,
        getLinkByGroupAndIssueKey,
        modalClosedStateChanges,
        onRemoveIssueLinkInitiated
    ]);
    const handleOnDeleteCancel = (0, $eUqFw.useCallback)(()=>{
        modalClosedStateChanges();
    }, [
        modalClosedStateChanges
    ]);
    const getRemovalConfirmationText = (0, $eUqFw.useCallback)((lIssueKey)=>({
            confirmationHeader: intl.formatMessage((0, $avHv0.default).removeIssueLinkHeader, {
                issueKey: lIssueKey
            }),
            confirmationContent: intl.formatMessage((0, $avHv0.default).removeIssueLinkContent)
        }), [
        intl
    ]);
    const handleOnDeleteAction = (0, $eUqFw.useCallback)((groupId, lIssueKey, globalId)=>{
        // @ts-expect-error - TS2345 - Argument of type '(oldState: { hasDeleteModal: boolean; groupId: null; issueKey: null; globalId: undefined; }) => { groupId: string; issueKey: string; globalId: string | undefined; hasDeleteModal: true; }' is not assignable to parameter of type 'SetStateAction<{ hasDeleteModal: boolean; groupId: null; issueKey: null; globalId: undefined; }>'.
        setState((oldState)=>({
                ...oldState,
                groupId: groupId,
                issueKey: lIssueKey,
                globalId: globalId,
                hasDeleteModal: true
            }));
        const linkToDelete = getLinkByGroupAndIssueKey(groupId, lIssueKey, globalId);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'linkedIssueCardDeleteButton', {
            issueLinkToDeleteId: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(linkToDelete, [
                'linkedIssue',
                'id'
            ]),
            isRemote: !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(globalId)
        });
    }, [
        createAnalyticsEvent,
        getLinkByGroupAndIssueKey
    ]);
    const renderDeleteConfirmationModal = (0, $eUqFw.useCallback)(()=>{
        const { groupId: groupId, issueKey: sIssueKey, globalId: globalId } = state;
        const texts = getRemovalConfirmationText(sIssueKey);
        const { confirmationHeader: confirmationHeader, confirmationContent: confirmationContent } = texts;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f48ac642e2fd52ce$export$cec27bfb61bfc748, {
            onCancel: handleOnDeleteCancel,
            onConfirm: ()=>handleOnDeleteConfirm(groupId, sIssueKey, globalId),
            headerMessage: confirmationHeader,
            contentMessage: confirmationContent,
            confirmActionText: intl.formatMessage((0, $avHv0.default).removeIssueLinkButton),
            externalId: "issue.issueLinks.delete"
        });
    }, [
        getRemovalConfirmationText,
        handleOnDeleteCancel,
        handleOnDeleteConfirm,
        intl,
        state
    ]);
    const renderIssueLinkInlineMessage = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (id, isRemote, userHasPermissionToLink = true)=>{
        let inlineContentMessage = (0, $avHv0.default).issueLinkFailureContent;
        if ((0, $9Nizy.isCustomMessageForLinkingWithoutPermissionsEnabled)()) inlineContentMessage = userHasPermissionToLink ? (0, $avHv0.default).issueLinkFailureContent : (0, $avHv0.default).issueLinkNoPermissionFailureContent;
        return (0, $5xRy0.renderInlineMessage)(intl, intl.formatMessage((0, $avHv0.default).issueLinkFailureHeader), intl.formatMessage(inlineContentMessage), (event, analyticsEvent)=>(0, $1ybV0.ff)('corex-operandi-issue-view-additional-logging_l6hj8') ? retryLinkedIssue(id, isRemote, createAnalyticsEvent({
                action: 'succeeded',
                isRemote: isRemote
            }), createAnalyticsEvent({
                action: 'linkedToProject'
            }), (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), analyticsEvent.update({
                isRemote: isRemote
            })) : retryLinkedIssue(id, isRemote, createAnalyticsEvent({
                action: 'succeeded',
                isRemote: isRemote
            }), analyticsEvent.update({
                isRemote: isRemote
            }), (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))), ()=>cancelLinkedIssue(id, isRemote), (0, $9Nizy.isCustomMessageForLinkingWithoutPermissionsEnabled)() && userHasPermissionToLink);
    }, [
        cancelLinkedIssue,
        createAnalyticsEvent,
        intl,
        retryLinkedIssue
    ]);
    const renderLineCardGroup = (0, $eUqFw.useCallback)((issues, name)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), null, (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f48ac642e2fd52ce$var$ItemLineCardGroupWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQylF.ItemLineCardGroup), {
            items: issues,
            groupId: name,
            isInteractive: isIssueViewComplete,
            onClick: handleOnIssueClickNew
        }, ({ isHovering: isHovering, isActive: isActive, isFocused: isFocused, item: issue })=>{
            const handleClick = (event)=>handleOnIssueClickNew({
                    ...issue
                }, event);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9iFfI.IssueLinkLineCard), {
                isHovering: isHovering,
                isActive: isActive,
                isFocused: isFocused,
                issue: issue,
                groupId: name,
                isInteractive: isIssueViewComplete,
                onDelete: (groupId, lIssueKey, globalId)=>handleOnDeleteAction(groupId, (0, $6vrw7.toIssueKey)(lIssueKey), globalId),
                onClick: handleClick,
                canAddIssueLinks: canAddIssueLinks,
                projectType: projectType,
                onEditIssue: onEditIssue
            });
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQylF.ItemLineCardGroup), {
            items: issues,
            groupId: name,
            isInteractive: isIssueViewComplete,
            onClick: handleOnIssueClickNew
        }, ({ isHovering: isHovering, isActive: isActive, isFocused: isFocused, item: issue })=>{
            const handleClick = (event)=>handleOnIssueClickNew({
                    ...issue
                }, event);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9iFfI.IssueLinkLineCard), {
                isHovering: isHovering,
                isActive: isActive,
                isFocused: isFocused,
                issue: issue,
                groupId: name,
                isInteractive: isIssueViewComplete,
                onDelete: (groupId, lIssueKey, globalId)=>handleOnDeleteAction(groupId, (0, $6vrw7.toIssueKey)(lIssueKey), globalId),
                onClick: handleClick,
                canAddIssueLinks: canAddIssueLinks,
                projectType: projectType,
                onEditIssue: onEditIssue
            });
        })), [
        canAddIssueLinks,
        handleOnDeleteAction,
        handleOnIssueClickNew,
        isIssueViewComplete,
        onEditIssue,
        projectType
    ]);
    const renderGroup = (0, $eUqFw.useCallback)((name, links)=>{
        const issues = links.map((link)=>{
            const errorInlineMessageOld = renderIssueLinkInlineMessage(link.id, !!link.isRemote);
            const errorInlineMessageNew = renderIssueLinkInlineMessage(link.id, !!link.isRemote, (0, $hHZBg.getUserHasPermissionToLink)(link.error));
            const errorInlineMessage = (0, $9Nizy.isCustomMessageForLinkingWithoutPermissionsEnabled)() ? errorInlineMessageNew : errorInlineMessageOld;
            return {
                ...link.linkedIssue,
                projectType: link.linkedIssue.projectType || null,
                isLoading: link.isLoading || false,
                hasError: link.hasError,
                errorInlineMessage: link.hasError ? errorInlineMessage : undefined,
                id: link.globalId || link.linkedIssue.id,
                isRemote: link.isRemote,
                globalId: link.isRemote ? link.globalId : undefined,
                remoteServerHostname: link.isRemote ? link.remoteServerHostname : undefined,
                remoteIssueLinkError: link.isRemote ? link.remoteIssueLinkError : undefined
            };
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f48ac642e2fd52ce$var$GroupContainer, {
            key: name,
            "data-testid": "issue.views.issue-base.content.issue-links.group-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f48ac642e2fd52ce$var$RelationshipHeading // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        , {
            "data-testid": "issue.issue-view.views.issue-base.content.issue-links.issue-links-view.relationship-heading"
        }, name), renderLineCardGroup(issues, name));
    }, [
        renderIssueLinkInlineMessage,
        renderLineCardGroup
    ]);
    const renderHeading = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f48ac642e2fd52ce$var$StyledSectionHeading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f48ac642e2fd52ce$var$Label, {
            htmlFor: (0, $lO4Or.ISSUE_LINK_SEARCH)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            id: "issue.issue-links-heading",
            defaultMessage: "Linked issues"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingIcons), null, canAddIssueLinks && hasLinks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1nrwm.default), {
            onClick: onIssueLinkAddClick
        }))), [
        canAddIssueLinks,
        hasLinks,
        onIssueLinkAddClick
    ]);
    const renderExistingLinks = (0, $eUqFw.useCallback)(()=>{
        const renderedGroups = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, issueLinks && Object.keys(issueLinks).sort().map((group)=>renderGroup(group, issueLinks[group])));
        return (0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() ? renderedGroups : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bJKxA.AsyncDevOpsSummaryContainer), {
            issueIds: $f48ac642e2fd52ce$var$getIssueIdsForDevSummaries(issueLinks ?? {}),
            location: "issue_view_linked_issues_list"
        }, renderedGroups);
    }, [
        issueLinks,
        renderGroup
    ]);
    const renderAddIssueLink = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f48ac642e2fd52ce$var$AddContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GFZH.default), {
            issueLinkTypes: issueLinkTypes,
            baseUrl: baseUrl,
            issueKey: issueKey,
            onClose: onIssueLinkAddClosed,
            issueLinks: issueLinks
        }))), [
        baseUrl,
        issueKey,
        issueLinkTypes,
        issueLinks,
        onIssueLinkAddClosed
    ]);
    const displayIssueLinks = hasLinks && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(issueLinks);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "issue-view-linked-issues"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "issue.issue-view.activity.linked-issues",
        packageName: "jiraLinkedIssues",
        teamName: "bento",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "linkedIssues",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            location: 'jiraLinkedIssues'
        }
    }, displayIssueLinks || displayAddIssueLinks ? renderHeading() : null, displayIssueLinks ? renderExistingLinks() : null, displayAddIssueLinks ? renderAddIssueLink() : null, state.hasDeleteModal ? renderDeleteConfirmationModal() : null)));
};
const $f48ac642e2fd52ce$export$2219fb7c04f3c8ee = ({ issueLinks: issueLinks = null, issueLinkTypes: issueLinkTypes = [], isIssueViewComplete: isIssueViewComplete = false, onIssueLinkClicked: onIssueLinkClicked = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onIssueLinkRendered: onIssueLinkRendered = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onIssueLinkAddClick: onIssueLinkAddClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onIssueLinkAddClosed: onIssueLinkAddClosed = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onRemoveIssueLinkInitiated: onRemoveIssueLinkInitiated = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onMountCreatePermissionFetching: onMountCreatePermissionFetching, displayAddIssueLinks: displayAddIssueLinks, createAnalyticsEvent: createAnalyticsEvent, onAuthenticateApplink: onAuthenticateApplink, linkActions: linkActions, deleteLinkedIssue: deleteLinkedIssue, canAddIssueLinks: canAddIssueLinks, hasLinks: hasLinks, retryLinkedIssue: retryLinkedIssue, cancelLinkedIssue: cancelLinkedIssue, projectType: projectType, baseUrl: baseUrl, issueKey: issueKey, onLinkedIssueCreated: onLinkedIssueCreated, issueId: issueId, onEditIssue: onEditIssue })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const [state, setState] = (0, $eUqFw.useState)({
        hasDeleteModal: false,
        groupId: null,
        issueKey: null,
        globalId: undefined
    });
    const linkedIssueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(linkedIssueKey);
    const application = (0, $guDlK.useApplication)(projectKey, true);
    const edition = (0, $guDlK.useEdition)(projectKey, true);
    const smartCardProviderProduct = (0, $9XfZZ.useSmartCardProductType)();
    const isAIFeatureEnabled = (0, $9XfZZ.useSmartCardIsAIEnabled)();
    (0, $eUqFw.useEffect)(()=>{
        if (hasLinks) // no need to dispatch fetch request if no links
        // @ts-expect-error - TS2345 - Argument of type 'IssueLink | null' is not assignable to parameter of type '{} | undefined'.
        onIssueLinkRendered($f48ac642e2fd52ce$var$loadedIssueLinksCount(issueLinks));
        onMountCreatePermissionFetching(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    (0, $eUqFw.useEffect)(()=>subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, async (payload)=>{
            if (payload.callbackPayload?.id !== (0, $33ffe55cb7bcdadc$export$f90eec3841adf619) && payload.callbackPayload?.id !== (0, $33ffe55cb7bcdadc$export$718822a309bffada)) return;
            const { createdIssueDetails: createdIssueDetails } = payload.createdIssueData;
            const { sourceIssueId: sourceIssueId, baseUrl: callbackPayloadBaseUrl } = payload.callbackPayload.data;
            if (issueId !== sourceIssueId) return;
            const analyticsEvent = createAnalyticsEvent({
                action: 'created'
            });
            if ((0, $1ybV0.ff)('corex-operandi-issue-view-additional-logging_l6hj8')) onLinkedIssueCreated?.((0, $e9WdP.default)(createdIssueDetails, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            sourceIssueId, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            callbackPayloadBaseUrl), createAnalyticsEvent({
                action: 'linkedToProject'
            }), analyticsEvent);
            else onLinkedIssueCreated?.((0, $e9WdP.default)(createdIssueDetails, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            sourceIssueId, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            callbackPayloadBaseUrl), analyticsEvent);
        }), [
        subscribe,
        onLinkedIssueCreated,
        createAnalyticsEvent,
        issueId
    ]);
    const handleOnIssueClickNew = (0, $eUqFw.useCallback)((// @ts-expect-error - TS2322 - Type '{}' is not assignable to type 'LinkedIssue'.
    { id: id, issueKey: lIssueKey, issueLink: issueLink, remoteIssueLinkError: remoteIssueLinkError, projectType: targetProjectType = null, isRemote: isRemote } = {}, event)=>{
        if ((0, $1ybV0.ff)('ken-524-fix-middle-click-issue-for-linked-issues_x1hgl') && (0, $5gJbo.isMiddleClick)(event)) return;
        if (lIssueKey) {
            const isIssueNeedAuth = remoteIssueLinkError?.error === (0, $b7817a5fa36c8dd6$export$d1fe0e8f550fe68d);
            if (onIssueLinkClicked) // @ts-expect-error - TS2345 - Argument of type 'IssueLink | null' is not assignable to parameter of type '{} | undefined'.
            onIssueLinkClicked(id, targetProjectType, $f48ac642e2fd52ce$var$loadedIssueLinksCount(issueLinks));
            if ((0, $5gJbo.isLeftClickOnly)(event)) {
                if (isIssueNeedAuth) {
                    const repairLinkHref = remoteIssueLinkError?.repairLink?.href;
                    if (repairLinkHref && onAuthenticateApplink) onAuthenticateApplink((0, $6vrw7.toHref)(repairLinkHref));
                } else issueLink && (0, $8HuAw.default)(issueLink, event.metaKey, linkActions.push);
            }
            if ((0, $5gJbo.isMiddleClick)(event) || (0, $5gJbo.isCmdOrCtrlClick)(event)) !isIssueNeedAuth && issueLink && window.open(issueLink, '_blank');
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'card'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueLinkedCard', {
                clickedIssueId: id,
                // @ts-expect-error - TS2345 - Argument of type 'IssueLink | null' is not assignable to parameter of type '{} | undefined'.
                linkedIssuesCount: $f48ac642e2fd52ce$var$loadedIssueLinksCount(issueLinks),
                issueNeedsAuthentication: isIssueNeedAuth,
                isRemote: isRemote
            });
        }
    }, [
        createAnalyticsEvent,
        issueLinks,
        linkActions.push,
        onAuthenticateApplink,
        onIssueLinkClicked
    ]);
    const getLinkByGroupAndIssueKey = (0, $eUqFw.useCallback)((groupId, lIssueKey, globalId)=>(issueLinks && groupId && issueLinks[groupId] || []).find((issueLink)=>issueLink.linkedIssueKey === lIssueKey && issueLink.globalId === globalId), [
        issueLinks
    ]);
    const flattenedIssueLinks = (0, $eUqFw.useCallback)(()=>issueLinks ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.keys(issueLinks).reduce(// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        (acc, curr)=>[
                ...acc,
                ...issueLinks[curr]
            ], []) : [], [
        issueLinks
    ]);
    const modalClosedStateChanges = (0, $eUqFw.useCallback)(()=>{
        setState((oldState)=>({
                ...oldState,
                groupId: null,
                issueKey: null,
                hasDeleteModal: false,
                globalId: undefined
            }));
    }, []);
    const handleOnDeleteConfirm = (0, $eUqFw.useCallback)((groupId, lIssueKey, globalId)=>{
        const linkToDelete = getLinkByGroupAndIssueKey(groupId, lIssueKey, globalId);
        if (linkToDelete) {
            const deleteLinkId = linkToDelete.id;
            deleteLinkedIssue({
                linkId: deleteLinkId,
                globalId: globalId
            }, application, edition);
            const indexOfDeletedLink = flattenedIssueLinks().findIndex((link)=>link.id === deleteLinkId && link.globalId === globalId);
            onRemoveIssueLinkInitiated(indexOfDeletedLink);
        }
        modalClosedStateChanges();
    }, [
        application,
        deleteLinkedIssue,
        edition,
        flattenedIssueLinks,
        getLinkByGroupAndIssueKey,
        modalClosedStateChanges,
        onRemoveIssueLinkInitiated
    ]);
    const handleOnDeleteCancel = (0, $eUqFw.useCallback)(()=>{
        modalClosedStateChanges();
    }, [
        modalClosedStateChanges
    ]);
    const getRemovalConfirmationText = (0, $eUqFw.useCallback)((lIssueKey)=>({
            confirmationHeader: intl.formatMessage((0, $avHv0.default).removeIssueLinkHeader, {
                issueKey: lIssueKey
            }),
            confirmationContent: intl.formatMessage((0, $avHv0.default).removeIssueLinkContent)
        }), [
        intl
    ]);
    const handleOnDeleteAction = (0, $eUqFw.useCallback)((groupId, lIssueKey, globalId)=>{
        // @ts-expect-error - TS2345 - Argument of type '(oldState: { hasDeleteModal: boolean; groupId: null; issueKey: null; globalId: undefined; }) => { groupId: string; issueKey: string; globalId: string | undefined; hasDeleteModal: true; }' is not assignable to parameter of type 'SetStateAction<{ hasDeleteModal: boolean; groupId: null; issueKey: null; globalId: undefined; }>'.
        setState((oldState)=>({
                ...oldState,
                groupId: groupId,
                issueKey: lIssueKey,
                globalId: globalId,
                hasDeleteModal: true
            }));
        const linkToDelete = getLinkByGroupAndIssueKey(groupId, lIssueKey, globalId);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'linkedIssueCardDeleteButton', {
            issueLinkToDeleteId: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(linkToDelete, [
                'linkedIssue',
                'id'
            ]),
            isRemote: !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(globalId)
        });
    }, [
        createAnalyticsEvent,
        getLinkByGroupAndIssueKey
    ]);
    const renderDeleteConfirmationModal = (0, $eUqFw.useCallback)(()=>{
        const { groupId: groupId, issueKey: sIssueKey, globalId: globalId } = state;
        const texts = getRemovalConfirmationText(sIssueKey);
        const { confirmationHeader: confirmationHeader, confirmationContent: confirmationContent } = texts;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f48ac642e2fd52ce$export$cec27bfb61bfc748, {
            onCancel: handleOnDeleteCancel,
            onConfirm: ()=>handleOnDeleteConfirm(groupId, sIssueKey, globalId),
            headerMessage: confirmationHeader,
            contentMessage: confirmationContent,
            confirmActionText: intl.formatMessage((0, $avHv0.default).removeIssueLinkButton),
            externalId: "issue.issueLinks.delete"
        });
    }, [
        getRemovalConfirmationText,
        handleOnDeleteCancel,
        handleOnDeleteConfirm,
        intl,
        state
    ]);
    const onSuccess = (0, $eUqFw.useCallback)(()=>{
        (0, $4ceCM.sendExperienceAnalytics)({
            wasExperienceSuccesful: true,
            action: (0, $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a),
            analyticsSource: 'jiraLinkedIssues',
            experience: 'addLinkedIssue',
            application: application ?? null,
            edition: edition ?? null
        });
    }, [
        application,
        edition
    ]);
    const onError = (0, $eUqFw.useCallback)(()=>{
        (0, $4ceCM.sendExperienceAnalytics)({
            wasExperienceSuccesful: false,
            action: (0, $99e7a4e4cbcb5db0$export$b48b3d1872522384),
            analyticsSource: 'jiraLinkedIssues',
            experience: 'addLinkedIssue',
            application: application ?? null,
            edition: edition ?? null
        });
    }, [
        application,
        edition
    ]);
    const renderIssueLinkInlineMessage = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (id, isRemote, userHasPermissionToLink = true)=>{
        let inlineContentMessage = (0, $avHv0.default).issueLinkFailureContent;
        if ((0, $9Nizy.isCustomMessageForLinkingWithoutPermissionsEnabled)()) inlineContentMessage = userHasPermissionToLink ? (0, $avHv0.default).issueLinkFailureContent : (0, $avHv0.default).issueLinkNoPermissionFailureContent;
        return (0, $5xRy0.renderInlineMessage)(intl, intl.formatMessage((0, $avHv0.default).issueLinkFailureHeader), intl.formatMessage(inlineContentMessage), (event, analyticsEvent)=>(0, $1ybV0.ff)('corex-operandi-issue-view-additional-logging_l6hj8') ? retryLinkedIssue(id, isRemote, createAnalyticsEvent({
                action: 'succeeded',
                isRemote: isRemote
            }), createAnalyticsEvent({
                action: 'linkedToProject'
            }), onSuccess, onError, analyticsEvent.update({
                isRemote: isRemote
            })) : retryLinkedIssue(id, isRemote, createAnalyticsEvent({
                action: 'succeeded',
                isRemote: isRemote
            }), analyticsEvent.update({
                isRemote: isRemote
            }), onSuccess, onError), ()=>cancelLinkedIssue(id, isRemote), (0, $9Nizy.isCustomMessageForLinkingWithoutPermissionsEnabled)() && userHasPermissionToLink);
    }, [
        cancelLinkedIssue,
        createAnalyticsEvent,
        intl,
        onError,
        onSuccess,
        retryLinkedIssue
    ]);
    const renderLineCardGroup = (0, $eUqFw.useCallback)((issues, name)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), (0, $1ybV0.ff)('platform.linking-platform.smart-card.hover-card-ai-summaries') && {
            product: smartCardProviderProduct,
            isAdminHubAIEnabled: isAIFeatureEnabled
        }, (0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f48ac642e2fd52ce$var$ItemLineCardGroupWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQylF.ItemLineCardGroup), {
            items: issues,
            groupId: name,
            isInteractive: isIssueViewComplete,
            onClick: handleOnIssueClickNew
        }, ({ isHovering: isHovering, isActive: isActive, isFocused: isFocused, item: issue })=>{
            const handleClick = (event)=>handleOnIssueClickNew({
                    ...issue
                }, event);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9iFfI.IssueLinkLineCard), {
                isHovering: isHovering,
                isActive: isActive,
                isFocused: isFocused,
                issue: issue,
                groupId: name,
                isInteractive: isIssueViewComplete,
                onDelete: (groupId, lIssueKey, globalId)=>handleOnDeleteAction(groupId, (0, $6vrw7.toIssueKey)(lIssueKey), globalId),
                onClick: handleClick,
                canAddIssueLinks: canAddIssueLinks,
                projectType: projectType,
                onEditIssue: onEditIssue
            });
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQylF.ItemLineCardGroup), {
            items: issues,
            groupId: name,
            isInteractive: isIssueViewComplete,
            onClick: handleOnIssueClickNew
        }, ({ isHovering: isHovering, isActive: isActive, isFocused: isFocused, item: issue })=>{
            const handleClick = (event)=>handleOnIssueClickNew({
                    ...issue
                }, event);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9iFfI.IssueLinkLineCard), {
                isHovering: isHovering,
                isActive: isActive,
                isFocused: isFocused,
                issue: issue,
                groupId: name,
                isInteractive: isIssueViewComplete,
                onDelete: (groupId, lIssueKey, globalId)=>handleOnDeleteAction(groupId, (0, $6vrw7.toIssueKey)(lIssueKey), globalId),
                onClick: handleClick,
                canAddIssueLinks: canAddIssueLinks,
                projectType: projectType,
                onEditIssue: onEditIssue
            });
        })), [
        canAddIssueLinks,
        handleOnDeleteAction,
        handleOnIssueClickNew,
        isIssueViewComplete,
        onEditIssue,
        projectType,
        smartCardProviderProduct,
        isAIFeatureEnabled
    ]);
    const renderGroup = (0, $eUqFw.useCallback)((name, links)=>{
        const issues = links.map((link)=>{
            const errorInlineMessageOld = renderIssueLinkInlineMessage(link.id, !!link.isRemote);
            const errorInlineMessageNew = renderIssueLinkInlineMessage(link.id, !!link.isRemote, (0, $hHZBg.getUserHasPermissionToLink)(link.error));
            const errorInlineMessage = (0, $9Nizy.isCustomMessageForLinkingWithoutPermissionsEnabled)() ? errorInlineMessageNew : errorInlineMessageOld;
            return {
                ...link.linkedIssue,
                projectType: link.linkedIssue.projectType || null,
                isLoading: link.isLoading || false,
                hasError: link.hasError,
                errorInlineMessage: link.hasError ? errorInlineMessage : undefined,
                id: link.globalId || link.linkedIssue.id,
                isRemote: link.isRemote,
                globalId: link.isRemote ? link.globalId : undefined,
                remoteServerHostname: link.isRemote ? link.remoteServerHostname : undefined,
                remoteIssueLinkError: link.isRemote ? link.remoteIssueLinkError : undefined
            };
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f48ac642e2fd52ce$var$GroupContainer, {
            key: name,
            "data-testid": "issue.views.issue-base.content.issue-links.group-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f48ac642e2fd52ce$var$RelationshipHeading // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        , {
            "data-testid": "issue.issue-view.views.issue-base.content.issue-links.issue-links-view.relationship-heading"
        }, name), renderLineCardGroup(issues, name));
    }, [
        renderIssueLinkInlineMessage,
        renderLineCardGroup
    ]);
    const renderHeading = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f48ac642e2fd52ce$var$Label, {
            htmlFor: (0, $lO4Or.ISSUE_LINK_SEARCH)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            id: "issue.issue-links-heading",
            defaultMessage: "Linked issues"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingIcons), null, canAddIssueLinks && hasLinks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1nrwm.default), {
            onClick: onIssueLinkAddClick
        }))), [
        canAddIssueLinks,
        hasLinks,
        onIssueLinkAddClick
    ]);
    const renderExistingLinks = (0, $eUqFw.useCallback)(()=>{
        const renderedGroups = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, issueLinks && Object.keys(issueLinks).sort().map((group)=>renderGroup(group, issueLinks[group])));
        return (0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() ? renderedGroups : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bJKxA.AsyncDevOpsSummaryContainer), {
            issueIds: $f48ac642e2fd52ce$var$getIssueIdsForDevSummaries(issueLinks ?? {}),
            location: "issue_view_linked_issues_list"
        }, renderedGroups);
    }, [
        issueLinks,
        renderGroup
    ]);
    const renderAddIssueLink = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f48ac642e2fd52ce$var$AddContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GFZH.default), {
            issueLinkTypes: issueLinkTypes,
            baseUrl: baseUrl,
            issueKey: issueKey,
            onClose: onIssueLinkAddClosed,
            issueLinks: issueLinks,
            onAddSuccess: onSuccess,
            onAddError: onError
        }))), [
        baseUrl,
        issueKey,
        issueLinkTypes,
        issueLinks,
        onError,
        onIssueLinkAddClosed,
        onSuccess
    ]);
    const displayIssueLinks = hasLinks && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(issueLinks);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "issue-view-linked-issues"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "issue.issue-view.activity.linked-issues",
        packageName: "jiraLinkedIssues",
        teamName: "bento",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "linkedIssues",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            location: 'jiraLinkedIssues'
        }
    }, displayIssueLinks || displayAddIssueLinks ? renderHeading() : null, displayIssueLinks ? renderExistingLinks() : null, displayAddIssueLinks ? renderAddIssueLink() : null, state.hasDeleteModal ? renderDeleteConfirmationModal() : null)));
};
$f48ac642e2fd52ce$export$2219fb7c04f3c8ee.displayName = 'IssueLinksView';
$f48ac642e2fd52ce$export$ba3a99fe2b92c78d.displayName = 'IssueLinksViewOld';
var $f48ac642e2fd52ce$export$2e2bcd8739ae039 = (0, $bAQOb.componentWithFF)('analytics_event_for_deletion_of_linked_issue_1ufi8', $f48ac642e2fd52ce$export$2219fb7c04f3c8ee, $f48ac642e2fd52ce$export$ba3a99fe2b92c78d);
const $f48ac642e2fd52ce$var$RelationshipHeading = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h3",
        level: "h200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": props['data-testid']
    }, props.children));
const $f48ac642e2fd52ce$var$GroupContainer = (0, $bAQOb.componentWithFF)('issue-view-fit-and-finish-full-page-milestone2_ebk0i', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81bpf _u5f3v77o _17diu2gc",
            __cmplp.className
        ])
    });
}), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81bpf _u5f3v77o",
            __cmplp.className
        ])
    });
})); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f48ac642e2fd52ce$var$AddContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81bpf _u5f3v77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f48ac642e2fd52ce$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _n3tdv77o",
            __cmplp.className
        ])
    });
});
const $f48ac642e2fd52ce$var$StyledSectionHeading = (0, $bAQOb.componentWithFF)('issue-view-fit-and-finish-full-page-milestone2_ebk0i', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $iAc02.SectionHeading), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3tdu2gc",
            __cmplp.className
        ])
    });
}), (0, $iAc02.SectionHeading)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f48ac642e2fd52ce$var$ItemLineCardGroupWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2GFZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a6f0f54649e5b05$export$2e2bcd8739ae039);

var $2jDha = parcelRequire("2jDha");

var $1ybV0 = parcelRequire("1ybV0");

var $giAhk = parcelRequire("giAhk");

var $5G3JL = parcelRequire("5G3JL");

var $lBMPF = parcelRequire("lBMPF");

var $lqalZ = parcelRequire("lqalZ");

var $fp55Q = parcelRequire("fp55Q");

var $49xWy = parcelRequire("49xWy");

var $02hYD = parcelRequire("02hYD");

var $cFY86 = parcelRequire("cFY86");

var $e23rU = parcelRequire("e23rU");

var $kS8l2 = parcelRequire("kS8l2");

var $5WrET = parcelRequire("5WrET");
var // FIXME: JIV-17455 should be fully typed
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$6a6f0f54649e5b05$export$2e2bcd8739ae039 // cast to ComponentType as flowWithSafeComponent strips types
 = (0, $5G3JL.flowWithSafeComponent)(// @ts-expect-error - Argument of type '<C extends ComponentType<any>>(WrappedComponent: C, options?: InjectIntlOptions | undefined) => ComponentType<WithIntlProps<LibraryManagedAttributes<C, ComponentProps<C>>>>' is not assignable to parameter of type 'FlowStep<C, ComponentType<WithAnalyticsEventsProps> & (ComponentClass<WithIntlProps<LibraryManagedAttributes<C, ComponentProps<C>>>, any> | FunctionComponent<...>)>'.
(0, $giAhk.injectIntlV2), (0, $2jDha.default)({
    onAdd: {
        action: 'added'
    },
    onAddRemote: {
        action: 'added',
        isRemote: true
    }
}), // eslint-disable-next-line @atlassian/eng-health/code-evolution/ts-migration-4.9-5.4
// @ts-expect-error([Part of upgrade 4.9-5.4]) - Type instantiation is excessively deep and possibly infinite.
(0, $lqalZ.connect)((state)=>({
        isOpenedFromJsmSimilarIssues: (0, $cFY86.isOpenedFromJsmSimilarIssuesSelector)(state),
        quickAddClickedCount: (0, $cFY86.quickAddClickedCountSelector)(state),
        quickAddClickedIssue: (0, $cFY86.quickAddClickedIssueSelector)(state),
        canCreateLinkedIssue: (0, $cFY86.canCreateLinkedIssueSelector)(state),
        canLinkRemoteIssues: (0, $e23rU.canLinkJiraRemoteIssuesSelector)(state),
        jiraAppLinksFetchStatus: (0, $e23rU.jiraAppLinksFetchStatusSelector)(state),
        jiraAppLinks: (0, $e23rU.jiraAppLinksSelector)(state)
    }), (dispatch)=>({
        onAdd: (issueLinks, requestAnalyticsEvent, maybeAnalyticEventOrPostAnalyticsEvent, onAddSuccess, onAddError, analyticsEvent)=>dispatch((0, $1ybV0.ff)('corex-operandi-issue-view-additional-logging_l6hj8') ? (0, $49xWy.saveLinkedIssueRequest)(issueLinks, requestAnalyticsEvent, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            analyticsEvent, onAddSuccess, onAddError, maybeAnalyticEventOrPostAnalyticsEvent) : (0, $49xWy.saveLinkedIssueRequest)(issueLinks, requestAnalyticsEvent, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            analyticsEvent, onAddSuccess, onAddError)),
        onAddRemote: (saveRemoteIssueLinkPayload, requestAnalyticsEvent, onAddSuccess, onAddError, analyticsEvent)=>dispatch((0, $02hYD.saveRemoteLinkedIssueRequest)(saveRemoteIssueLinkPayload, requestAnalyticsEvent, analyticsEvent.update({
                withReciprocalLink: Boolean(saveRemoteIssueLinkPayload.createReciprocalLink)
            }), onAddSuccess, onAddError)),
        fetchJiraAppLinks: ()=>dispatch((0, $fp55Q.fetchJiraAppLinks)()),
        onClearRelatedIssueLink: ()=>dispatch((0, $49xWy.clearRelatedIssueLink)())
    })), (0, $lBMPF.default), (0, $kS8l2.withGlobalRef)('linkIssueRef', 'quick-add-items.link-issue'))(// FIXME: JIV-17455 should be fully typed
// @ts-expect-error TS2345: Argument of type 'typeof AddIssueLinkView' is not assignable to parameter
(0, $5WrET.AddIssueLinkView));

});
parcelRegister("e23rU", function(module, exports) {

$parcel$export(module.exports, "jiraAppLinksFetchStatusSelector", () => $c6eb49872bdc4d80$export$cf3ffdfde66ee31d);
$parcel$export(module.exports, "canLinkJiraRemoteIssuesSelector", () => $c6eb49872bdc4d80$export$b9e5e8abc1179711);
$parcel$export(module.exports, "jiraAppLinksSelector", () => $c6eb49872bdc4d80$export$6a6be800202cc2a9);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");

var $7FqHc = parcelRequire("7FqHc");

var $cFY86 = parcelRequire("cFY86");
const $c6eb49872bdc4d80$export$e00f73045526ff3a = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.jiraAppLinks || {
        status: 'NOT_LOADED',
        remoteLinks: []
    });
const $c6eb49872bdc4d80$export$cf3ffdfde66ee31d = (0, $df4Sl.createSelector)($c6eb49872bdc4d80$export$e00f73045526ff3a, (linksState)=>linksState.status);
const $c6eb49872bdc4d80$export$b9e5e8abc1179711 = (0, $df4Sl.createSelector)((0, $cFY86.isIssueLinksEnabledSelector), (0, $7FqHc.canLinkIssuesSelector), (hasJiraAppLinksInTenant, isIssueLinksEnabled)=>hasJiraAppLinksInTenant && isIssueLinksEnabled);
const $c6eb49872bdc4d80$export$6a6be800202cc2a9 = (0, $df4Sl.createSelector)($c6eb49872bdc4d80$export$e00f73045526ff3a, (linksState)=>linksState.remoteLinks);

});

parcelRegister("5WrET", function(module, exports) {

$parcel$export(module.exports, "AddIssueLinkView", () => $5657beafb926d55b$export$5c3e16dfe4f9bae8);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8blac = parcelRequire("8blac");

var $jG2Eu = parcelRequire("jG2Eu");

var $70s4u = parcelRequire("70s4u");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");

var $4Bees = parcelRequire("4Bees");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");

var $df0tC = parcelRequire("df0tC");
var $autRb = parcelRequire("autRb");

var $jBBmJ = parcelRequire("jBBmJ");

var $gbMaY = parcelRequire("gbMaY");

var $jMP2a = parcelRequire("jMP2a");

var $cwx4v = parcelRequire("cwx4v");

var $j2QSO = parcelRequire("j2QSO");

var $8nOlD = parcelRequire("8nOlD");

var $lWHDQ = parcelRequire("lWHDQ");

var $7DmGr = parcelRequire("7DmGr");

var $d9JfY = parcelRequire("d9JfY");

var $lyQ51 = parcelRequire("lyQ51");

var $V3piY = parcelRequire("V3piY");

var $7ffsx = parcelRequire("7ffsx");

const $5657beafb926d55b$var$SINGLE_COLUMN_MAX_WIDTH = 480;
const $5657beafb926d55b$var$getInitialSearchState = ()=>({
        newIssueLinks: [],
        isDisabled: true,
        invalidSelections: [],
        invalidSelectionsWithReason: []
    });
const $5657beafb926d55b$var$getInvalidIssuesMessage = (intl, issueKeys)=>{
    if (issueKeys.length === 1) return intl.formatMessage((0, $V3piY.default).invalidIssue, {
        issueKey: issueKeys[0]
    });
    if (issueKeys.length === 2) return intl.formatMessage((0, $V3piY.default).twoInvalidIssues, {
        issueKeys: issueKeys.join(', ')
    });
    if (issueKeys.length >= 3) return intl.formatMessage((0, $V3piY.default).multipleInvalidIssues, {
        firstTwoIssueKeys: issueKeys.slice(0, 2).join(', '),
        countRemainingIssues: issueKeys.length - 2
    });
    return '';
};
const $5657beafb926d55b$export$82f46aa4e6535a45 = (intl, invalidSelections)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(invalidSelections)) return undefined;
    let errorKey = invalidSelections[0].reason;
    if (invalidSelections.some(({ reason: reason })=>reason === (0, $5025063a7edaf260$export$80a99984a7da603c))) errorKey = (0, $5025063a7edaf260$export$80a99984a7da603c);
    else if (invalidSelections.some(({ reason: reason })=>reason === (0, $5025063a7edaf260$export$a7ec8aa501c1ea5c))) errorKey = (0, $5025063a7edaf260$export$a7ec8aa501c1ea5c);
    const invalidSelectionsForErrorKey = invalidSelections.filter((invalid)=>invalid.reason === errorKey);
    const jiraAppLinkName = invalidSelectionsForErrorKey.filter((invalidSelection)=>invalidSelection?.jiraAppLink?.requireCredentials || false).map((invalidSelection)=>invalidSelection?.jiraAppLink?.name).pop();
    switch(errorKey){
        case 0, $5025063a7edaf260$export$94ada27c17e90824:
            return intl.formatMessage((0, $V3piY.default).selfLinkInvalidIssue, {
                issueKey: invalidSelections[0].value
            });
        case 0, $5025063a7edaf260$export$67034f5c471ab313:
            return intl.formatMessage((0, $V3piY.default).otherAppLink);
        case 0, $5025063a7edaf260$export$a7ec8aa501c1ea5c:
            return jiraAppLinkName ? intl.formatMessage((0, $V3piY.default).unauthenticatedAppLinkWithSiteName, {
                appLinkName: jiraAppLinkName
            }) : intl.formatMessage((0, $V3piY.default).unauthenticatedAppLink);
        case 0, $5025063a7edaf260$export$80a99984a7da603c:
            return $5657beafb926d55b$var$getInvalidIssuesMessage(intl, invalidSelectionsForErrorKey.map((invalid)=>invalid.value));
        default:
            return undefined;
    }
};
const $5657beafb926d55b$export$1ad7cbaaf8a17c3e = (jiraAppLinks)=>{
    const remoteLinks = jiraAppLinks.map((item)=>(0, $jBBmJ.transformAppLink)(item));
    return [
        (0, $8nOlD.LOCAL_JIRA_APP_LINK),
        ...remoteLinks
    ];
}; // eslint-disable-next-line jira/react/no-class-components
class $5657beafb926d55b$export$5c3e16dfe4f9bae8 extends (0, $eUqFw.Component) {
    static{
        this.isLinkedIssueInComponentState = (componentStateIssueLinks, reduxStateIssueLink)=>{
            // no Issue Links in Redux means the component state is up-to-date
            if (!reduxStateIssueLink) return true;
            return componentStateIssueLinks.some((issueLink)=>issueLink.appLinkId === undefined && issueLink.id === reduxStateIssueLink?.id);
        };
    }
    static{
        this.displayName = 'AddIssueLinkView';
    }
    static{
        this.defaultProps = {
            issueLinks: null,
            quickAddClickedCount: 0,
            containerWidth: null,
            onAdd: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onAddRemote: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    constructor(props){
        super(props);
        this.getInitialState = ()=>({
                issueLinkType: this.transformIssueLinkTypesForSelect()[0],
                jiraAppLink: (0, $8nOlD.LOCAL_JIRA_APP_LINK),
                createReciprocalLink: true,
                ...$5657beafb926d55b$var$getInitialSearchState()
            });
        this.isLocalJira = (jiraAppLink)=>jiraAppLink.value === (0, $8nOlD.LOCAL_JIRA_APP_LINK).value;
        this.getRemoteAppLink = ()=>{
            const { jiraAppLink: jiraAppLink } = this.state;
            return this.isLocalJira(jiraAppLink) ? undefined : jiraAppLink.fullObject;
        };
        this.onIssueLinkTypeChange = (item)=>this.setState({
                issueLinkType: item
            });
        this.onJiraAppLinkChange = (item, setIsLinkingToLocalJira)=>{
            const isLinkingToLocalJira = this.isLocalJira(item);
            setIsLinkingToLocalJira(isLinkingToLocalJira);
            this.setState({
                jiraAppLink: item,
                createReciprocalLink: !isLinkingToLocalJira,
                ...$5657beafb926d55b$var$getInitialSearchState()
            });
        };
        this.getInvalidSelectionForIssuesWithDifferentAppLinks = (newIssueLinks)=>{
            if (newIssueLinks.some((value)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(value.issueLink.fullObject)) && newIssueLinks.some((value)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(value.appLink) && value.appLink.fullObject.baseUrl !== this.state.jiraAppLink.fullObject.baseUrl)) return {
                value: '',
                reason: (0, $5025063a7edaf260$export$67034f5c471ab313)
            };
            return undefined;
        };
        this.getInvalidSelectionForUnauthenticatedAppLink = (newIssueLinks)=>{
            const unauthenticatedIssueLink = newIssueLinks.filter((value)=>value.appLink?.fullObject?.requireCredentials).shift();
            if (unauthenticatedIssueLink) return {
                value: unauthenticatedIssueLink.issueKey,
                jiraAppLink: unauthenticatedIssueLink?.appLink?.fullObject,
                reason: (0, $5025063a7edaf260$export$a7ec8aa501c1ea5c)
            };
            return undefined;
        };
        this.getInvalidSelectionForSelfLink = (newIssueLinks)=>{
            if (newIssueLinks.some((issueLink)=>this.props.issueKey === issueLink.issueKey)) return {
                value: this.props.issueKey,
                reason: (0, $5025063a7edaf260$export$94ada27c17e90824)
            };
            return undefined;
        } /** creates NewIssueLinkWrapper out of the new issue links handling issue keys and urls */ ;
        this.getNewIssueLinksWrapperFrom = (newIssueLinks)=>{
            const { jiraAppLinks: jiraAppLinks } = this.props;
            const jiraAppLinksForSelect = $5657beafb926d55b$export$1ad7cbaaf8a17c3e(jiraAppLinks);
            return newIssueLinks.map((issueLink)=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(issueLink.fullObject)) {
                    const issueLinkUrl = (0, $df0tC.parseIssueUrl)(issueLink.value);
                    const selectedAppLink = issueLinkUrl && jiraAppLinksForSelect.filter((appLink)=>appLink.fullObject.baseUrl === issueLinkUrl.host).shift();
                    return {
                        issueLink: issueLink,
                        issueKey: selectedAppLink && issueLinkUrl ? issueLinkUrl.issueKey : issueLink.value,
                        appLink: selectedAppLink
                    };
                }
                return {
                    issueLink: issueLink,
                    issueKey: issueLink.value
                };
            });
        };
        this.getCommonAppLinkFromIssueCandidates = (issueLinksWrapper)=>issueLinksWrapper.length === 1 && issueLinksWrapper[0].appLink?.fullObject?.requireCredentials === false && issueLinksWrapper[0].appLink;
        this.onIssueSearchChange = (newIssueLinks)=>{
            const submitServerRequests = [];
            const formattedValues = this.getNewIssueLinksWrapperFrom(newIssueLinks); // currentInvalid is used to address one error at a time
            const currentInvalid = this.getInvalidSelectionForIssuesWithDifferentAppLinks(formattedValues) || this.getInvalidSelectionForUnauthenticatedAppLink(formattedValues) || this.getInvalidSelectionForSelfLink(formattedValues);
            const newSelectedAppLink = this.getCommonAppLinkFromIssueCandidates(formattedValues) || this.state.jiraAppLink;
            const updatedIssueLinks = formattedValues.map((issueLinkWrapper)=>{
                const { issueLink: issueLink, issueKey: issueKey, appLink: appLink } = issueLinkWrapper;
                const canBeValidatedInAppLink = (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(appLink) || appLink.fullObject.baseUrl === newSelectedAppLink.fullObject.baseUrl;
                if (!issueLink.fullObject && canBeValidatedInAppLink) {
                    if (!currentInvalid || currentInvalid.value !== issueKey) submitServerRequests.push(()=>this.query$.next({
                            queryIssueKey: issueKey,
                            remoteAppLink: this.isLocalJira(newSelectedAppLink) ? undefined : newSelectedAppLink.fullObject
                        }));
                }
                return {
                    ...issueLink,
                    value: canBeValidatedInAppLink ? issueKey : issueLink.value,
                    content: canBeValidatedInAppLink ? issueKey : issueLink.content,
                    tag: {
                        elemBefore: issueLink.elemBefore
                    }
                };
            });
            const isDisabled = !!(currentInvalid || (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(newIssueLinks));
            this.setState({
                newIssueLinks: updatedIssueLinks,
                isDisabled: isDisabled,
                invalidSelectionsWithReason: currentInvalid && [
                    currentInvalid
                ] || [],
                jiraAppLink: newSelectedAppLink
            });
            submitServerRequests.map((request)=>request()); // submit after setState incase this is a synchronous call
        } /* returns the update invalid selection list that only contains values still present in the user selections */ ;
        this.updateInvalidSelections = (selectionValues)=>{
            const issueKeyValues = selectionValues ? selectionValues.map((v)=>v.value) : [];
            return this.state.invalidSelections.filter((i)=>issueKeyValues.includes(i));
        };
        this.onCreateReciprocalLinkChange = (_, analyticsEvent)=>{
            const newState = !this.state.createReciprocalLink;
            this.setState({
                createReciprocalLink: newState
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'createReciprocalLink', {
                isChecked: newState
            });
        };
        this.onShowReciprocalLinkTooltip = (analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'createReciprocalLink');
        };
        this.onSave = (_, analyticsEvent)=>{
            const { issueLinkType: issueLinkType, newIssueLinks: newIssueLinks, jiraAppLink: jiraAppLink, createReciprocalLink: createReciprocalLink } = this.state;
            const { issueLinks: issueLinks, isOpenedFromJsmSimilarIssues: isOpenedFromJsmSimilarIssues } = this.props;
            const isLinkingLocalIssue = this.isLocalJira(jiraAppLink);
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'addLinkedIssueButton', {
                isRemote: !isLinkingLocalIssue,
                newLinkedIssueIds: newIssueLinks.map((newIssue)=>newIssue.id),
                isOpenedFromJsmSimilarIssues: isOpenedFromJsmSimilarIssues
            });
            if (issueLinkType && newIssueLinks && newIssueLinks.length > 0) {
                if (isLinkingLocalIssue) this.saveLocalIssueLink(issueLinkType, newIssueLinks, issueLinks);
                else this.saveRemoteIssueLink(issueLinkType, newIssueLinks, jiraAppLink, issueLinks, createReciprocalLink);
            }
        };
        this.saveLocalIssueLink = (issueLinkType, newIssueLinks, issueLinks)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, isOpenedFromJsmSimilarIssues: isOpenedFromJsmSimilarIssues, onAddError: onAddError, onAddSuccess: onAddSuccess } = this.props;
            const issueLinkTypeName = issueLinkType.fullObject && issueLinkType.fullObject.label;
            const existingIssueLinks = issueLinks && issueLinks[issueLinkTypeName] || [];
            const existingIssueKeys = existingIssueLinks.filter((link)=>!link.isRemote).map((link)=>link.linkedIssueKey);
            newIssueLinks.map((issueLink)=>{
                if (!issueLink.fullObject) return {
                    ...issueLink,
                    fullObject: {
                        key: issueLink.value
                    }
                };
                return issueLink;
            }).filter((issueLink)=>!existingIssueKeys.includes(issueLink.fullObject.key)).forEach((issueLink, index)=>{
                const optimisticId = `OPTIMISTIC_LINKED_ISSUE_${Date.now()}_${index}`;
                if ((0, $1ybV0.ff)('corex-operandi-issue-view-additional-logging_l6hj8')) this.props.onAdd({
                    optimisticId: optimisticId,
                    linkedIssueKey: issueLink.fullObject.key,
                    issueLinkType: issueLinkType.fullObject,
                    issueLinks: (0, $7ffsx.transformIssueLink)(optimisticId, issueLinkType.fullObject, issueLink.fullObject, this.props.baseUrl),
                    isOpenedFromJsmSimilarIssues: isOpenedFromJsmSimilarIssues
                }, createAnalyticsEvent({
                    action: 'succeeded',
                    isOpenedFromJsmSimilarIssues: isOpenedFromJsmSimilarIssues
                }), createAnalyticsEvent({
                    action: 'linkedToProject'
                }), onAddSuccess, onAddError);
                else // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
                this.props.onAdd({
                    optimisticId: optimisticId,
                    linkedIssueKey: issueLink.fullObject.key,
                    issueLinkType: issueLinkType.fullObject,
                    issueLinks: (0, $7ffsx.transformIssueLink)(optimisticId, issueLinkType.fullObject, issueLink.fullObject, this.props.baseUrl),
                    isOpenedFromJsmSimilarIssues: isOpenedFromJsmSimilarIssues
                }, createAnalyticsEvent({
                    action: 'succeeded',
                    isOpenedFromJsmSimilarIssues: isOpenedFromJsmSimilarIssues
                }), onAddSuccess, onAddError);
            });
            this.props.onClose();
        };
        this.saveRemoteIssueLink = (issueLinkType, newIssueLinks, jiraAppLink, issueLinks, createReciprocalLink)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, onAddError: onAddError, onAddSuccess: onAddSuccess } = this.props;
            const existingIssueGlobalIds = issueLinks ? Object.keys(issueLinks) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .reduce(// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            (acc, curr)=>[
                    ...acc,
                    ...issueLinks[curr]
                ], []).filter((link)=>link.isRemote).map((link)=>link.globalId) : [];
            newIssueLinks.filter((issueLink)=>issueLink.fullObject) // invalid remoteIssueLink
            .map((issueLink, index)=>(0, $7ffsx.transformSaveRemoteIssueLinkPayload)(index, issueLink, jiraAppLink.fullObject, issueLinkType, createReciprocalLink)).filter((saveRemoteIssueLinkPayload)=>!saveRemoteIssueLinkPayload.globalId || !existingIssueGlobalIds.includes(saveRemoteIssueLinkPayload.globalId)).forEach((payload)=>{
                // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
                this.props.onAddRemote(payload, createAnalyticsEvent({
                    action: 'succeeded',
                    isRemote: true,
                    withReciprocalLink: Boolean(payload.createReciprocalLink)
                }), onAddSuccess, onAddError);
            });
            this.props.onClose();
        };
        this.onCancelKeyPress = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                const linkIssueButton = this.props.linkIssueRef;
                linkIssueButton?.focus();
            }
        };
        this.handleUpdate = ({ issue: issue, results: results })=>{
            // This validation happens after the pre-validations before searching for issues.
            // When there is no result for the current issue, it means that the issue is invalid.
            // The invalid issue is concatenated to the current list of invalid selections.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(results)) this.setState((currentState)=>{
                const newIssueLinks = currentState.newIssueLinks.slice();
                const isDisabled = true;
                const invalidSelectionsWithReason = [
                    ...currentState.invalidSelectionsWithReason,
                    {
                        value: issue,
                        reason: (0, $5025063a7edaf260$export$80a99984a7da603c)
                    }
                ];
                return {
                    newIssueLinks: newIssueLinks,
                    isDisabled: isDisabled,
                    invalidSelectionsWithReason: invalidSelectionsWithReason
                };
            });
            else {
                const validServerIssueLink = results.map((val)=>({
                        ...val,
                        tag: {
                            elemBefore: val.elemBefore
                        }
                    })).pop();
                if (!validServerIssueLink) return;
                this.setState((currentState)=>{
                    const newIssueLinks = currentState.newIssueLinks.map((link)=>link.value.toLowerCase() === validServerIssueLink.value.toLowerCase() ? validServerIssueLink : link);
                    return {
                        newIssueLinks: newIssueLinks
                    };
                });
            }
        };
        this.transformIssueLinkTypesForSelect = ()=>this.props.issueLinkTypes.map((item)=>({
                    label: item.label,
                    value: item.id + item.direction,
                    fullObject: item
                }));
        this.addLinkContainerRef = (ref)=>{
            this.addLinkContainer = ref;
        };
        this.renderLoading = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null);
        this.state = this.getInitialState();
        this.query$ = new (0, $70s4u.Subject)();
        this.subscription = this.query$.flatMap(({ queryIssueKey: queryIssueKey, remoteAppLink: remoteAppLink })=>(0, $d9JfY.fetchPossibleIssues)(props.baseUrl, props.issueKey, queryIssueKey, remoteAppLink).map((results)=>({
                    issue: queryIssueKey,
                    results: results
                }))).subscribe(this.handleUpdate);
    }
    static getDerivedStateFromProps(nextProps, state) {
        // The redux store can make a request to add a linked issue to the unsubmitted issue-links in component state.
        // The code below pulls any such requested linked issue from redux into the component state.
        // When converting to a functional component please consider managing the unsubmitted links via a sweet state store instead of component state.
        if (!$5657beafb926d55b$export$5c3e16dfe4f9bae8.isLinkedIssueInComponentState(state.newIssueLinks, nextProps.quickAddClickedIssue)) return {
            isDisabled: false,
            newIssueLinks: [
                ...state.newIssueLinks,
                {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    content: nextProps.quickAddClickedIssue.value,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: nextProps.quickAddClickedIssue.id,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    value: nextProps.quickAddClickedIssue.value,
                    elemBefore: null,
                    fullObject: nextProps.quickAddClickedIssue?.fullObject,
                    filterValues: [],
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    iconUrl: nextProps.quickAddClickedIssue.iconUrl,
                    appLinkId: undefined
                }
            ]
        };
        return null;
    }
    componentDidMount() {
        if (this.addLinkContainer) (0, $autRb.smoothScrollIntoCenterIfNeeded)(this.addLinkContainer);
        if (this.props.canLinkRemoteIssues && (this.props.jiraAppLinksFetchStatus === 'NOT_LOADED' || this.props.jiraAppLinksFetchStatus === 'ERROR')) this.props.fetchJiraAppLinks();
    }
    componentDidUpdate(prevProps) {
        if (this.addLinkContainer && prevProps.quickAddClickedCount !== this.props.quickAddClickedCount) (0, $autRb.smoothScrollIntoCenterIfNeeded)(this.addLinkContainer);
         // The redux store can make a request to add a linked issue to the unsubmitted issue-links in component state.
        // This checks if that issue has been picked up and clears out that part of the redux store if it has been.
        if ($5657beafb926d55b$export$5c3e16dfe4f9bae8.isLinkedIssueInComponentState(this.state.newIssueLinks, this.props.quickAddClickedIssue)) this.props.onClearRelatedIssueLink();
    }
    componentWillUnmount() {
        this.subscription.unsubscribe();
    }
    renderFullAddForm() {
        const { intl: intl, baseUrl: baseUrl, issueKey: issueKey, containerWidth: containerWidth, onClose: onClose, canCreateLinkedIssue: canCreateLinkedIssue, canLinkRemoteIssues: canLinkRemoteIssues, jiraAppLinks: jiraAppLinks } = this.props;
        const { jiraAppLink: jiraAppLink, issueLinkType: issueLinkType, newIssueLinks: newIssueLinks, isDisabled: isDisabled, invalidSelectionsWithReason: invalidSelectionsWithReason } = this.state;
        const issueLinkTypeSelectItems = this.transformIssueLinkTypesForSelect();
        const jiraAppLinkSelectItems = $5657beafb926d55b$export$1ad7cbaaf8a17c3e(jiraAppLinks); /**
                                                                                  * This is different to the "global" Bento `isCompact` mode. This looks at its own
                                                                                  * `containerWidth` & can be put into compact mode even when the rest of Bento is not.
                                                                                  */ 
        const isCompact = Boolean(containerWidth && containerWidth <= $5657beafb926d55b$var$SINGLE_COLUMN_MAX_WIDTH);
        const hasJiraAppLinks = jiraAppLinkSelectItems.length > 1;
        const shouldShowCreateLinkedIssueButton = this.isLocalJira(this.state.jiraAppLink) && canCreateLinkedIssue;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.addLinkContainerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5657beafb926d55b$var$InputsContainer, {
            isCompact: isCompact
        }, canLinkRemoteIssues && hasJiraAppLinks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5657beafb926d55b$var$SelectContainer, {
            isCompact: isCompact
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gbMaY.IssueLinkLocalitySubscriber), null, (_, { setIsLinkingToLocalJira: setIsLinkingToLocalJira })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j2QSO.default), {
                selectItems: jiraAppLinkSelectItems,
                value: jiraAppLink,
                onChange: (e)=>this.onJiraAppLinkChange(e, setIsLinkingToLocalJira),
                containerWidth: containerWidth || undefined,
                selectType: "JiraAppLinksSelect"
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5657beafb926d55b$var$SelectContainer, {
            isCompact: isCompact,
            "data-testid": "issue.views.issue-base.content.issue-links.add.select-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwx4v.IssueLinkTypeSelect), {
            selectItems: issueLinkTypeSelectItems,
            selectedItem: issueLinkType,
            onChange: this.onIssueLinkTypeChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5657beafb926d55b$var$IssueSearchContainer // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        , {
            "data-testid": "issue.views.issue-base.content.issue-links.add.issue-search-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lyQ51.default), {
            value: newIssueLinks,
            baseUrl: baseUrl,
            issueKey: issueKey,
            onChange: this.onIssueSearchChange,
            remoteAppLink: this.getRemoteAppLink(),
            invalidMessage: $5657beafb926d55b$export$82f46aa4e6535a45(intl, invalidSelectionsWithReason),
            debounceFetchSuggestionsTime: (0, $8nOlD.ISSUE_SEARCH_DEBOUNCE_TIME),
            issueLinkType: this.state.issueLinkType
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5657beafb926d55b$var$ButtonsContainer, null, !this.isLocalJira(this.state.jiraAppLink) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7DmGr.CreateReciprocalLink), {
            isChecked: this.state.createReciprocalLink,
            onChange: this.onCreateReciprocalLinkChange,
            onShow: this.onShowReciprocalLinkTooltip
        }), shouldShowCreateLinkedIssueButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5657beafb926d55b$var$CreateLinkedIssueButtonContainer // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        , {
            "data-testid": "issue.issue-view.views.issue-base.content.issue-links.add.issue-links-add-view.create-linked-issue"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWHDQ.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div" // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        , {
            "data-testid": "issue.issue-view.views.issue-base.content.issue-links.add.issue-links-add-view.link-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            onClick: this.onSave,
            isDisabled: isDisabled,
            interactionName: "auto-generated.jira-issue-view-base.content.issue-links.add.button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            id: "issue.issue-links-add-button-label",
            defaultMessage: "Link"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            onClick: onClose,
            onKeyPress: this.onCancelKeyPress,
            testId: "issue.views.issue-base.content.issue-links.add.button",
            interactionName: "auto-generated.issue.views.issue-base.content.issue-links.add.button.button1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            id: "issue.issue-links-cancel-button-label",
            defaultMessage: "Cancel"
        })))));
    }
    render() {
        if (this.props.canLinkRemoteIssues && (this.props.jiraAppLinksFetchStatus === 'LOADING' || this.props.jiraAppLinksFetchStatus === 'NOT_LOADED')) return this.renderLoading();
        return this.renderFullAddForm();
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5657beafb926d55b$var$InputsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompact: isCompact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1b1v _ae4v1fhb _1mizu2gc",
            __cmplp.isCompact ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.isCompact ? "_1yp8idpf" : "_1yp8u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5657beafb926d55b$var$IssueSearchContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _i0dl1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5657beafb926d55b$var$ButtonsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _1e0c1txw _1n261g80 _1bahesu3 _18u01wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5657beafb926d55b$var$CreateLinkedIssueButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _18u0xmi2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5657beafb926d55b$var$SelectContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompact: isCompact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9bv7e",
            __cmplp.isCompact ? "_p12fglyw" : "_p12fuuw1",
            __cmplp.isCompact ? "_1bsb1osq" : "_1bsb1q0g",
            __cmplp.className
        ])
    });
});

});
parcelRegister("df0tC", function(module, exports) {

$parcel$export(module.exports, "parseIssueUrl", () => $f87c0ab6acb1cb35$export$e79a9506e3e136b5);

var $8blac = parcelRequire("8blac");

var $k8Ehj = parcelRequire("k8Ehj");
const $f87c0ab6acb1cb35$var$BROWSE_PATH = /\/browse\/((?:\w+)-(?:\d+))/;
const $f87c0ab6acb1cb35$var$extractIssueKeyFromPath = (path)=>{
    const match = path.match($f87c0ab6acb1cb35$var$BROWSE_PATH);
    return match && match[1].match((0, $k8Ehj.ISSUE_KEY_REGEXP)) && match[1] || '';
};
const $f87c0ab6acb1cb35$export$e79a9506e3e136b5 = (url)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(url)) return null;
    try {
        const parsedURL = new URL(url);
        const host = parsedURL.origin;
        const issueKey = $f87c0ab6acb1cb35$var$extractIssueKeyFromPath(parsedURL.pathname);
        return !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(issueKey) ? {
            host: host,
            issueKey: issueKey
        } : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
};

});
parcelRegister("k8Ehj", function(module, exports) {

$parcel$export(module.exports, "ISSUE_KEY_REGEXP", () => $43737284383bbfd5$export$6dda5bc2b5fbf210);
$parcel$export(module.exports, "getCurrentHostPattern", () => $43737284383bbfd5$export$47e10df7c3c19b6b);
$parcel$export(module.exports, "stripUrlToIssueKey", () => $43737284383bbfd5$export$1f3c6284caef177b);
// If the full URL supplied matches the Jira view issue pattern for the specified site then strip the URL
// to just the issue key. If the URL does not match the pattern then return it unchanged.

var $6vrw7 = parcelRequire("6vrw7");
const $43737284383bbfd5$var$ISSUE_BROWSE_PATH = 'browse/';
const $43737284383bbfd5$export$6dda5bc2b5fbf210 = /^(([A-Z][A-Z0-9]+)-([0-9]+))($|\?.*)/;
const $43737284383bbfd5$export$47e10df7c3c19b6b = ()=>{
    if (window.location.port !== '') return (0, $6vrw7.toBaseUrl)(`${window.location.protocol}//${window.location.hostname}:${window.location.port}`);
    return (0, $6vrw7.toBaseUrl)(`${window.location.protocol}//${window.location.hostname}`);
};
const $43737284383bbfd5$export$1f3c6284caef177b = (baseUrl, candidateUrl)=>{
    let baseUrlPath = baseUrl;
    if (baseUrlPath === undefined || candidateUrl === undefined) return candidateUrl || '';
    if (!baseUrlPath.endsWith('/')) baseUrlPath += '/';
    baseUrlPath += $43737284383bbfd5$var$ISSUE_BROWSE_PATH;
    if (candidateUrl.indexOf(baseUrlPath) !== 0) return candidateUrl;
    const candidatePath = candidateUrl.slice(baseUrlPath.length);
    const match = candidatePath.match($43737284383bbfd5$export$6dda5bc2b5fbf210);
    if (match === null) return candidateUrl;
    return match[1] || ''; // issue key is at index 1 (first capture group)
};

});


parcelRegister("gbMaY", function(module, exports) {

$parcel$export(module.exports, "useIssueLinkLocality", () => $397ef65f3ee0f004$export$692ca616d048312d);
$parcel$export(module.exports, "IssueLinkLocalitySubscriber", () => $397ef65f3ee0f004$export$21d40cf1e11325d6);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
const $397ef65f3ee0f004$var$initialState = {
    isLinkingToLocalJira: true
};
const $397ef65f3ee0f004$var$actions = {
    setIsLinkingToLocalJira: (isLinkingToLocalJira)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                isLinkingToLocalJira: isLinkingToLocalJira
            });
        }
};
const $397ef65f3ee0f004$var$Store = (0, $a61MH.createStore)({
    initialState: $397ef65f3ee0f004$var$initialState,
    actions: $397ef65f3ee0f004$var$actions,
    name: 'issue-link-locality'
});
const $397ef65f3ee0f004$export$692ca616d048312d = (0, $ggKAj.createHook)($397ef65f3ee0f004$var$Store);
const $397ef65f3ee0f004$export$21d40cf1e11325d6 = (0, $dYfll.createSubscriber)($397ef65f3ee0f004$var$Store);

});

parcelRegister("cwx4v", function(module, exports) {

$parcel$export(module.exports, "IssueLinkTypeSelect", () => $a2fc17bde77674cd$export$5a71f3911a7d87cb);

var $eUqFw = parcelRequire("eUqFw");

var $4zgIJ = parcelRequire("4zgIJ");

var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("gLLZt");
var $7nzO5 = parcelRequire("7nzO5");

var $l6dE0 = parcelRequire("l6dE0");
const $a2fc17bde77674cd$export$5a71f3911a7d87cb = (props)=>{
    const { selectItems: selectItems, selectedItem: selectedItem, onChange: onChange } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zgIJ.default), {
        "aria-label": formatMessage((0, $l6dE0.default).typeSelectAriaLabel),
        options: selectItems,
        defaultValue: selectedItem,
        styles: (0, $7nzO5.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '(arg1: SelectItemType) => void' is not assignable to type '(value: SelectItemType | null, action: ActionMeta<SelectItemType>) => void'.
        onChange: onChange
    });
};
$a2fc17bde77674cd$export$5a71f3911a7d87cb.defaultProps = {
    selectedItem: null
};

});
parcelRegister("l6dE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29c7d8d856a04ef$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b29c7d8d856a04ef$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    typeSelectAriaLabel: {
        "id": "issue-view-base.content.issue-links.issue-links-type.type-select-aria-label",
        "defaultMessage": "Select an action for your linked issues"
    }
});

});


parcelRegister("j2QSO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b960df6d27413750$export$2e2bcd8739ae039);

var $kdkji = parcelRequire("kdkji");

var $lqalZ = parcelRequire("lqalZ");

var $a0kZP = parcelRequire("a0kZP");
var $b960df6d27413750$export$2e2bcd8739ae039 = (0, $lqalZ.connect)(()=>({}), {
    onAuthenticateAppLink: (0, $a0kZP.applinkAuthenticationRequest)
})((0, $kdkji.default));

});

parcelRegister("8nOlD", function(module, exports) {

$parcel$export(module.exports, "LOCAL_JIRA_APP_LINK", () => $b0cdb69f06cd6701$export$f5521d607d0370f0);
$parcel$export(module.exports, "ISSUE_SEARCH_DEBOUNCE_TIME", () => $b0cdb69f06cd6701$export$60ec5d4db45a8d20);

var $k8Ehj = parcelRequire("k8Ehj");

var $6vrw7 = parcelRequire("6vrw7");
const $b0cdb69f06cd6701$export$3907e3dc3fa1a24b = 'local';
const $b0cdb69f06cd6701$export$12fa6ad7493f32fb = 'Local';
const $b0cdb69f06cd6701$export$f5521d607d0370f0 = {
    label: $b0cdb69f06cd6701$export$12fa6ad7493f32fb,
    value: $b0cdb69f06cd6701$export$3907e3dc3fa1a24b,
    fullObject: {
        id: $b0cdb69f06cd6701$export$3907e3dc3fa1a24b,
        name: $b0cdb69f06cd6701$export$12fa6ad7493f32fb,
        baseUrl: (0, $k8Ehj.getCurrentHostPattern)(),
        authUrl: (0, $6vrw7.toHref)(''),
        requireCredentials: false
    }
};
const $b0cdb69f06cd6701$export$60ec5d4db45a8d20 = 500;

});

parcelRegister("lWHDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $489d7f68b652fa73$export$2e2bcd8739ae039);

var $8nrDO = parcelRequire("8nrDO");

var $eGI9v = parcelRequire("eGI9v");
var $jUhyG = parcelRequire("jUhyG");

var $h7bH5 = parcelRequire("h7bH5");

var $1ybV0 = parcelRequire("1ybV0");

var $giAhk = parcelRequire("giAhk");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $49xWy = parcelRequire("49xWy");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $6vrw7 = parcelRequire("6vrw7");

var $bEkXY = parcelRequire("bEkXY");
const $489d7f68b652fa73$var$linkedIssueCreatedAnalyticsAction = 'created';
const $489d7f68b652fa73$var$fireLinkedIssueCreatedTrackAnalytics = ({ issueLinks: issueLinks, linkedIssues: linkedIssues }, analyticsEvent)=>{
    const issueLinkId = (0, (/*@__PURE__*/$parcel$interopDefault($8nrDO)))(issueLinks)[0];
    // issueLinkId would be undefined when the newly created linked issue is not actually linked to the current
    // issue.
    if (issueLinkId !== undefined) {
        const issueLink = issueLinks[issueLinkId];
        const linkedIssue = linkedIssues[issueLink.linkedIssueKey];
        const analyticsAttributes = {
            action: $489d7f68b652fa73$var$linkedIssueCreatedAnalyticsAction,
            actionSubjectId: linkedIssue.id,
            attributes: {
                linkTypeName: (0, $h7bH5.safeLinkTypeName)(issueLink.typeName),
                linkTypeId: issueLink.typeId,
                issueLinkId: issueLinkId
            }
        };
        (0, $jUhyG.fireTrackAnalytics)(analyticsEvent, analyticsAttributes);
    }
};
var $489d7f68b652fa73$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $giAhk.injectIntlV2), // @ts-expect-error - Argument of type '<T extends ComponentType<any>, Props = ComponentPropsWithRef<T>>(WrappedComponent: T) => FC<Omit<{ [K in keyof Props]: K extends "onLinkedIssueCreated" ? (...args: [......]) => ReturnType<...> : Props[K]; }, keyof WithAnalyticsEventsProps>>' is not assignable to parameter of type 'FlowStep<ComponentType<WithIntlProps<LibraryManagedAttributes<C, ComponentProps<C>>>>, FC<Omit<{ [K in keyof (PropsWithoutRef<...> & RefAttributes<...>)]: K extends "onLinkedIssueCreated" ? (...args: [......]) => ReturnType<...> : (PropsWithoutRef<...> & RefAttributes<...>)[K]; } | { [K in keyof PropsWithRef<...>]: ...'.
(0, $eGI9v.default)('createLinkedIssueButton', {
    onLinkedIssueCreated: $489d7f68b652fa73$var$linkedIssueCreatedAnalyticsAction
}), // @ts-expect-error - Type instantiation is excessively deep and possibly infinite.
(0, $lqalZ.connect)((state)=>({
        baseUrl: (0, $5JqpU.baseUrlSelector)(state),
        sourceIssueKey: (0, $5JqpU.issueKeySelector)(state),
        sourceIssueId: (0, $6vrw7.toIssueId)(String((0, $5JqpU.issueIdSelector)(state))),
        projectType: (0, $jZDJX.projectTypeSelector)(state)
    }), (dispatch)=>({
        onLinkedIssueCreated: (newIssueLinks, analyticOrMaybePostAnalytic, analyticsEvent)=>{
            dispatch((0, $49xWy.createLinkedIssueSuccess)(newIssueLinks));
            if ((0, $1ybV0.ff)('corex-operandi-issue-view-additional-logging_l6hj8')) {
                Object.entries(newIssueLinks.issueLinks).forEach(([optimisticId, issueLink])=>{
                    dispatch((0, $49xWy.saveLinkedIssueSuccess)(optimisticId, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    analyticsEvent, issueLink.linkedIssueKey, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    analyticOrMaybePostAnalytic));
                });
                dispatch((0, $49xWy.closeAddIssueLink)());
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $489d7f68b652fa73$var$fireLinkedIssueCreatedTrackAnalytics(newIssueLinks, analyticsEvent);
            } else {
                Object.keys(newIssueLinks.issueLinks).forEach((optimisticId)=>{
                    dispatch((0, $49xWy.saveLinkedIssueSuccess)(optimisticId, analyticOrMaybePostAnalytic));
                });
                dispatch((0, $49xWy.closeAddIssueLink)());
                $489d7f68b652fa73$var$fireLinkedIssueCreatedTrackAnalytics(newIssueLinks, analyticOrMaybePostAnalytic);
            }
        }
    })))((0, $bEkXY.default));

});
parcelRegister("bEkXY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f60133f3eade612$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $gO9Xw = parcelRequire("gO9Xw");

var $iMMQz = parcelRequire("iMMQz");

var $2BvS3 = parcelRequire("2BvS3");

var $7ZZxN = parcelRequire("7ZZxN");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $ctR9z = parcelRequire("ctR9z");


var $9Nizy = parcelRequire("9Nizy");

var $7oMrz = parcelRequire("7oMrz");

var $e9WdP = parcelRequire("e9WdP");
const $0f60133f3eade612$export$c63f561360bafed1 = 'issue.views.issue-base-content.issue-links.add.create-linked-issue-button.view';
// eslint-disable-next-line jira/react/no-class-components
class $0f60133f3eade612$var$CreateLinkedIssueButton extends (0, $eUqFw.Component) {
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            interactionName: "create-linked-issue-button-click",
            spacing: "compact",
            onClick: this.onCreateLinkedIssueClick,
            appearance: "link",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                label: "",
                size: "small"
            }),
            /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.issue-base.content.issue-links.add.create-linked-issue-button.create-linked-issue-button"
        }, formatMessage((0, $7oMrz.default).createLinkedIssueButtonLabel));
    }
    constructor(...args){
        super(...args);
        this.showCreateLinkedIssueDialog = async ()=>{
            const { baseUrl: baseUrl, sourceIssueId: sourceIssueId, sourceIssueKey: sourceIssueKey, onLinkedIssueCreated: onLinkedIssueCreated, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            this.showLoadingIndicator();
            try {
                // eslint-disable-next-line jira/wrm/no-load-bridge
                const wrmRequire = await (0, $2BvS3.loadBridge)({
                    name: 'wrm/require'
                });
                await new Promise((resolve)=>{
                    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                    wrmRequire(// eslint-disable-next-line jira/wrm/no-wr-prefix
                    'wr!com.atlassian.jira.jira-quick-edit-plugin:create-linked-issue', resolve);
                });
                // eslint-disable-next-line jira/wrm/no-load-bridge
                const createLinkedIssueDialog = await (0, $2BvS3.loadBridge)({
                    name: 'quick-edit/create-linked-issue/create-linked-issue-dialog'
                });
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                createLinkedIssueDialog.show({
                    sourceIssueId: sourceIssueId,
                    sourceIssueKey: sourceIssueKey
                }).getQuickForm()// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type. | TS7031 - Binding element 'createdIssueDetails' implicitly has an 'any' type.
                .bind('issueCreated', (event, { createdIssueDetails: createdIssueDetails })=>{
                    if ((0, $1ybV0.ff)('corex-operandi-issue-view-additional-logging_l6hj8')) onLinkedIssueCreated((0, $e9WdP.default)(createdIssueDetails, sourceIssueId, baseUrl), createAnalyticsEvent({
                        action: 'linkedToProject'
                    }));
                    else // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
                    onLinkedIssueCreated((0, $e9WdP.default)(createdIssueDetails, sourceIssueId, baseUrl));
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                this.hideLoadingIndicator();
                (0, $gUUjF.default).safeErrorWithoutCustomerData($0f60133f3eade612$export$c63f561360bafed1, error);
            }
        };
        this.onCreateLinkedIssueClick = (event, analyticsEvent)=>{
            if (this.props.currentIssueCreateVisibility === true) this.props.openIssueCreateModal?.({
                payload: {
                    customFieldsToPreserveOnFormRecreation: [
                        'issuelinks'
                    ],
                    defaultValues: {
                        issueLinks: {
                            linkedIssueKeys: [
                                this.props.sourceIssueKey
                            ]
                        }
                    },
                    ...(0, $9Nizy.isCreateLinkedIssueTriggerPointEnabled)() && {
                        additionalContext: {
                            linkedIssue: {
                                sourceIssueId: this.props.sourceIssueId
                            }
                        }
                    }
                },
                triggerPointKey: (0, $33ffe55cb7bcdadc$export$f90eec3841adf619),
                ...(0, $9Nizy.isCreateLinkedIssueTriggerPointEnabled)() && {
                    isCreateLinkedIssue: true,
                    isModalLoadInContext: true
                },
                callbackPayload: {
                    id: (0, $33ffe55cb7bcdadc$export$f90eec3841adf619),
                    data: {
                        sourceIssueId: this.props.sourceIssueId,
                        baseUrl: this.props.baseUrl
                    }
                }
            });
            else this.showCreateLinkedIssueDialog();
            (0, $iMMQz.fireUiAnalytics)(analyticsEvent, {
                name: 'createLinkedIssue'
            });
        };
        this.showLoadingIndicator = async ()=>{
            try {
                // eslint-disable-next-line jira/wrm/no-load-bridge
                const loadingIndicator = await (0, $2BvS3.loadBridge)({
                    name: 'quick-edit/util/loading-indicator',
                    wrmKeys: 'wrc!com.atlassian.jira.jira-quick-edit-plugin:loading-indicator'
                });
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                loadingIndicator.showLoadingIndicator();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData($0f60133f3eade612$export$c63f561360bafed1, error);
            }
        };
        this.hideLoadingIndicator = async ()=>{
            try {
                // eslint-disable-next-line jira/wrm/no-load-bridge
                const loadingIndicator = await (0, $2BvS3.loadBridge)({
                    name: 'quick-edit/util/loading-indicator',
                    wrmKeys: 'wrc!com.atlassian.jira.jira-quick-edit-plugin:loading-indicator'
                });
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                loadingIndicator.hideLoadingIndicator();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData($0f60133f3eade612$export$c63f561360bafed1, error);
            }
        };
    }
}
const $0f60133f3eade612$var$CreateLinkedIssueWithNewGIC = (0, $ctR9z.withNewGICProvider)($0f60133f3eade612$var$CreateLinkedIssueButton);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0f60133f3eade612$export$2e2bcd8739ae039 = (props)=>{
    if ((0, $9Nizy.isModernGlobalIssueCreateTriggerEnabled)() && (0, $9Nizy.isCreateLinkedIssueTriggerPointEnabled)() || props.projectType === (0, $7ZZxN.SOFTWARE_PROJECT)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0f60133f3eade612$var$CreateLinkedIssueWithNewGIC, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0f60133f3eade612$var$CreateLinkedIssueButton, props);
};

});
parcelRegister("7oMrz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca2e32fed5f5863d$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $ca2e32fed5f5863d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createLinkedIssueButtonLabel: {
        "id": "issue.linked-issue-create.button-label",
        "defaultMessage": "Create linked issue"
    }
});

});

parcelRegister("e9WdP", function(module, exports) {

$parcel$export(module.exports, "default", () => $881ed1228bcaff2b$export$2e2bcd8739ae039);

var $8i1R8 = parcelRequire("8i1R8");

var $illlw = parcelRequire("illlw");

var $03XEB = parcelRequire("03XEB");

var $lV5H0 = parcelRequire("lV5H0");

var $6vrw7 = parcelRequire("6vrw7");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $881ed1228bcaff2b$var$getLinkDirectionFromSourceIssue = (linkToSourceIssue)=>linkToSourceIssue.outwardIssue ? (0, $03XEB.INWARD_LINK_DIRECTION) : (0, $03XEB.OUTWARD_LINK_DIRECTION);
const $881ed1228bcaff2b$var$normalizeCreatedLinkedIssue = (createdLinkedIssue, sourceIssueId)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let linkDetails = {};
    // Check if there is actually a link between the created issue and the source issue (i.e current issue)
    const linkToSourceIssue = (0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))((0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(createdLinkedIssue, [
        'fields',
        'issuelinks'
    ]), (issueLink)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(issueLink.outwardIssue || issueLink.inwardIssue, 'id') === sourceIssueId);
    if (linkToSourceIssue !== undefined) {
        // The Link direction returned from the endpoint is from the created linked issue's perspective, we need to flip
        // it to get the direction from the source issue's perspective.
        const linkDirectionFromSourceIssue = $881ed1228bcaff2b$var$getLinkDirectionFromSourceIssue(linkToSourceIssue);
        linkDetails = {
            issueLink: {
                id: linkToSourceIssue.id,
                direction: linkDirectionFromSourceIssue,
                linkType: {
                    id: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(linkToSourceIssue, [
                        'type',
                        'id'
                    ], ''),
                    label: linkDirectionFromSourceIssue === (0, $03XEB.INWARD_LINK_DIRECTION) ? (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(linkToSourceIssue, [
                        'type',
                        'inward'
                    ], '') : (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(linkToSourceIssue, [
                        'type',
                        'outward'
                    ], '')
                }
            }
        };
    }
    // @ts-expect-error - TS2741 - Property 'issueLink' is missing in type '{ id: string; key: string; summary: string; issueTypeIconUrl: string; }' but required in type 'NormalizedCreatedLinkedIssue'.
    return {
        id: (0, $6vrw7.toIssueId)(createdLinkedIssue.id),
        key: (0, $6vrw7.toIssueKey)(createdLinkedIssue.key),
        summary: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(createdLinkedIssue, [
            'fields',
            'summary'
        ], ''),
        issueTypeIconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(createdLinkedIssue, [
            'fields',
            'issuetype',
            'iconUrl'
        ], ''),
        ...linkDetails
    };
};
var // Transform the created linked issue from the data shape returned from backend, to the data shape which is compatible
// with the issue view's state
// eslint-disable-next-line jira/import/no-anonymous-default-export
$881ed1228bcaff2b$export$2e2bcd8739ae039 = (serverCreatedLinkedIssue, sourceIssueId, baseUrl)=>{
    const createdLinkedIssue = $881ed1228bcaff2b$var$normalizeCreatedLinkedIssue(serverCreatedLinkedIssue, sourceIssueId);
    // return empty when the newly created linked issue is not even linked to the current issue.
    if (createdLinkedIssue.issueLink === undefined) return {
        issueLinks: {},
        linkedIssues: {}
    };
    const { issueLink: issueLink } = createdLinkedIssue;
    return {
        issueLinks: {
            [`${issueLink.id}`]: {
                id: issueLink.id,
                linkedIssueKey: createdLinkedIssue.key,
                direction: issueLink.direction,
                typeName: issueLink.linkType.label,
                typeId: issueLink.linkType.id
            }
        },
        linkedIssues: {
            [`${createdLinkedIssue.key}`]: {
                id: createdLinkedIssue.id,
                issueKey: createdLinkedIssue.key,
                issueLink: (0, $lV5H0.getIssueHtmlUrl)(baseUrl, createdLinkedIssue.key),
                issueSummary: createdLinkedIssue.summary,
                issueTypeIconUrl: createdLinkedIssue.issueTypeIconUrl
            }
        }
    };
};

});



parcelRegister("7DmGr", function(module, exports) {

$parcel$export(module.exports, "CreateReciprocalLink", () => $c61b7d1e68452bae$export$d5aa0ddd655d7082);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bT7k5 = parcelRequire("bT7k5");

var $jgrQL = parcelRequire("jgrQL");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dm3J1 = parcelRequire("dm3J1");
const $c61b7d1e68452bae$export$d5aa0ddd655d7082 = ({ isChecked: isChecked, onChange: onChange, onShow: onShow })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c61b7d1e68452bae$var$CreateReciprocalLinkCheckboxContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: isChecked,
        onChange: onChange,
        label: formatMessage((0, $dm3J1.default).createReciprocalLinkCheckboxLabel),
        name: "create-reciprocal-link"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $dm3J1.default).createReciprocalLinkCheckboxTooltip),
        onShow: onShow,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jgrQL))), {
        size: "medium",
        label: ""
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c61b7d1e68452bae$var$CreateReciprocalLinkCheckboxContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jgrQL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0651d627acb5549$var$_react = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e0651d627acb5549$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e0651d627acb5549$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $e0651d627acb5549$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm0-8.5a1 1 0 00-1 1V15a1 1 0 002 0v-2.5a1 1 0 00-1-1zm0-1.125a1.375 1.375 0 100-2.75 1.375 1.375 0 000 2.75z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$e0651d627acb5549$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $e0651d627acb5549$var$_default = $e0651d627acb5549$var$EditorInfoIcon;
module.exports.default = $e0651d627acb5549$var$_default;

});

parcelRegister("dm3J1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9269ed4189d7583$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $f9269ed4189d7583$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createReciprocalLinkCheckboxLabel: {
        "id": "issue.create-reciprocal-link.checkbox-label",
        "defaultMessage": "Create reciprocal link"
    },
    createReciprocalLinkCheckboxTooltip: {
        "id": "issue.create-reciprocal-link.checkbox-tooltip",
        "defaultMessage": "Jira will create a link from the issue on the remote Jira instance back to this issue"
    }
});

});


parcelRegister("d9JfY", function(module, exports) {

$parcel$export(module.exports, "fetchPossibleIssues", () => $9108661a60fc4447$export$65bb92e6d854407e);
$parcel$export(module.exports, "fetchIssueSuggestions", () => $9108661a60fc4447$export$e19ca69e6ae29a6b);

var $eUqFw = parcelRequire("eUqFw");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $aiRd8 = parcelRequire("aiRd8");

var $lV5H0 = parcelRequire("lV5H0");

var $6vrw7 = parcelRequire("6vrw7");
const $9108661a60fc4447$var$JIRA_ISSUE_KEY_REGEX = /^([A-Z][A-Z0-9]+)-([0-9]+)$/i;
const $9108661a60fc4447$var$looksLikeIssueKey = (query)=>{
    if (query) {
        const parsedGroups = $9108661a60fc4447$var$JIRA_ISSUE_KEY_REGEX.exec(query);
        return !!(parsedGroups && parsedGroups.length === 3);
    }
    return false;
};
const $9108661a60fc4447$var$transformIssueSuggestionItems = (filterValue, remoteAppLink)=>// @ts-expect-error - TS2741 - Property 'sections' is missing in type '{}' but required in type 'IssueHistorySearchResults'.
    ({ sections: sections = [] } = {})=>{
        const { baseUrl: baseUrl = (0, $6vrw7.toBaseUrl)(''), id: appLinkId } = remoteAppLink || {};
        return sections.map((section)=>section.issues).filter((issues)=>!!issues) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((flatten, current)=>flatten.concat(current.map((issue)=>({
                    content: `${issue.key} ${issue.summaryText}`,
                    value: issue.key,
                    id: issue.id ? issue.id.toString() : '',
                    elemBefore: /*#__PURE__*/ (0, $eUqFw.createElement)('img', {
                        src: `${baseUrl}${issue.img}`,
                        width: 16,
                        height: 16
                    }),
                    fullObject: issue,
                    // Allows us to force all items returned by the endpoint to be displayed.
                    filterValues: [
                        filterValue
                    ],
                    iconUrl: `${baseUrl}${issue.img}`,
                    appLinkId: appLinkId
                }))), []) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((uniq, current)=>uniq.findIndex((item)=>item.value === current.value) < 0 ? [
                ...uniq,
                current
            ] : uniq, []);
    };
const $9108661a60fc4447$var$fetchMatchingIssues = (baseUrl, issueKey, queryIssueKey, remoteAppLink)=>{
    const queryUrl = remoteAppLink === undefined ? (0, $lV5H0.getAllIssuesHistoryUrl)(baseUrl, issueKey, queryIssueKey) : (0, $lV5H0.getRemoteAllIssuesHistoryUrl)(baseUrl, queryIssueKey, remoteAppLink.id);
    return (0, $aiRd8.default)(queryUrl);
};
const $9108661a60fc4447$export$65bb92e6d854407e = (baseUrl, issueKey, queryIssueKey, remoteAppLink)=>{
    if ($9108661a60fc4447$var$looksLikeIssueKey(queryIssueKey)) return $9108661a60fc4447$var$fetchMatchingIssues(baseUrl, issueKey, (0, $6vrw7.toIssueKey)(queryIssueKey), remoteAppLink).map($9108661a60fc4447$var$transformIssueSuggestionItems(queryIssueKey, remoteAppLink)).catch(()=>(0, $3JafE.Observable).of([]));
    return (0, $3JafE.Observable).of([]);
};
const $9108661a60fc4447$export$e19ca69e6ae29a6b = (baseUrl, issueKey, query, remoteAppLink)=>{
    const queryUrl = remoteAppLink === undefined ? (0, $lV5H0.getUnresolvedIssueHistoryUrlForLinking)(baseUrl, issueKey, query) : (0, $lV5H0.getRemoteUnresolvedIssueHistoryUrlForLinking)(baseUrl, query, remoteAppLink.id);
    return (0, $aiRd8.default)(queryUrl).map($9108661a60fc4447$var$transformIssueSuggestionItems(query, remoteAppLink));
};

});

parcelRegister("lyQ51", function(module, exports) {

$parcel$export(module.exports, "default", () => $f032cb168c8261be$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("flmol");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kDIIr = parcelRequire("kDIIr");

var $gLLZt = parcelRequire("gLLZt");

var $k8Ehj = parcelRequire("k8Ehj");

var $lO4Or = parcelRequire("lO4Or");

var $d9JfY = parcelRequire("d9JfY");

var $aa7Aq = parcelRequire("aa7Aq");
const $f032cb168c8261be$export$26bbfdef50e34adf = (option, remoteAppLinkId)=>{
    /* react-select will put the whole option in ['data'] property for filterOption()
   * https://github.com/JedWatson/react-select/blob/397e95337f54074cf0705cb5b06ce8951be72f2a/packages/react-select/src/Select.js#L1309
   */ const isIssueSuggestionOption = Boolean(option.data && option.data.fullObject);
    if (isIssueSuggestionOption) {
        const issueAppLinkId = option.data?.appLinkId;
        return issueAppLinkId === remoteAppLinkId;
    }
    return true;
};
const $f032cb168c8261be$export$fbd6c3d59c63ff09 = ({ value: value, issueKey: issueKey, baseUrl: baseUrl, remoteAppLink: remoteAppLink, invalidMessage: invalidMessage, onChange: onChange, debounceFetchSuggestionsTime: debounceFetchSuggestionsTime = 0, issueLinkType: issueLinkType, portalElement: portalElement })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const additionalAnalyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            isRemote: remoteAppLink !== undefined
        }), [
        remoteAppLink
    ]);
    /**
   * To convert link pasted to Select search field (e.g. `https://jdog.jira-dev.com/browse/CS2-2`) to the issue key (e.g. `CS2-2`)
   *
   * To make Select field display value that matches the search we actually issued (`CS2-2`).
   * This will have an effect of visually reducing a matching issue URL to just the issue key.
   */ const stripQueryValueToIssueKey = (0, $eUqFw.useCallback)((queryValue)=>{
        const selectedAppLinkHost = remoteAppLink === undefined ? (0, $k8Ehj.getCurrentHostPattern)() : remoteAppLink.baseUrl;
        return (0, $k8Ehj.stripUrlToIssueKey)(selectedAppLinkHost, queryValue);
    }, [
        remoteAppLink
    ]);
    const filterIssueOptions = (0, $eUqFw.useCallback)((option, inputValue)=>// @ts-expect-error - TS2345 - Argument of type 'OptionToFilter' is not assignable to parameter of type '{ data?: { fullObject?: any; appLinkId?: string | undefined; } | undefined; }'.
        $f032cb168c8261be$export$26bbfdef50e34adf(option, remoteAppLink?.id) && (0, $kDIIr.filterOptionByLabelAndFilterValues)(option, inputValue), [
        remoteAppLink?.id
    ]);
    const handleOnChange = (0, $eUqFw.useCallback)((selectedValues, actionMeta)=>{
        if (!actionMeta || !actionMeta.action) return;
        onChange(selectedValues);
    }, [
        onChange
    ]);
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const handleOnDataRequest = (0, $eUqFw.useCallback)((_)=>{}, []);
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const handleOnDataLoaded = (0, $eUqFw.useCallback)((_)=>{}, []);
    const fetchSuggestions = (0, $eUqFw.useCallback)((query)=>{
        const heading = formatMessage((0, $aa7Aq.default).openIssues);
        const noSuggestionsMessage = formatMessage((0, $aa7Aq.default).noHistoryResults);
        // @ts-expect-error - TS2322 - Type 'Promise<{ heading: string; items: IssueLinkSuggestion[]; }[] | readonly [{ readonly items: readonly [{ readonly content: string; readonly isDisabled: true; readonly value: ""; }]; }]>' is not assignable to type 'Promise<ServerSuggestions>'.
        return (0, $d9JfY.fetchIssueSuggestions)(baseUrl, issueKey, query, remoteAppLink).map((items)=>{
            if (items.length) // items variable is of type IssueLinkSuggestions but must be coerced to become SelectValueShape
            // union of 2 types produces necessary overlap, excess types cause flow problems
            return [
                {
                    heading: heading,
                    items: items
                }
            ];
            return [
                {
                    items: [
                        {
                            content: noSuggestionsMessage,
                            isDisabled: true,
                            value: ''
                        }
                    ]
                }
            ];
        }).toPromise();
    }, [
        baseUrl,
        formatMessage,
        issueKey,
        remoteAppLink
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLLZt.default), {
        ariaLabel: formatMessage((0, $aa7Aq.default).searchAriaLabel, {
            linkType: issueLinkType.label
        }),
        fieldId: (0, $lO4Or.ISSUE_LINK_SEARCH),
        classNamePrefix: "issue-links-search",
        value: value,
        fetchSuggestions: fetchSuggestions,
        debounceFetchSuggestionsTime: debounceFetchSuggestionsTime,
        onChangeMulti: handleOnChange,
        canCreateNewItem: true,
        // @ts-expect-error - TS2322 - Type '(inputValue: string) => string' is not assignable to type '(arg1: string) => ReactElement<any, string | JSXElementConstructor<any>>'.
        formatCreateLabel: (inputValue)=>`${inputValue} (${formatMessage((0, $aa7Aq.default).exactKey)})`,
        placeholder: formatMessage((0, $aa7Aq.default).searchPlaceholder),
        invalidMessage: invalidMessage,
        changeQueryValue: stripQueryValueToIssueKey,
        isMulti: true,
        autoFocus: true,
        errorMessagePosition: "bottom",
        onDataLoaded: handleOnDataLoaded,
        onDataRequest: handleOnDataRequest,
        inputId: (0, $lO4Or.ISSUE_LINK_SEARCH),
        additionalAnalyticsProps: additionalAnalyticsAttributes,
        filterOption: filterIssueOptions,
        portalElement: portalElement,
        spacing: "default"
    });
};
var $f032cb168c8261be$export$2e2bcd8739ae039 = $f032cb168c8261be$export$fbd6c3d59c63ff09;

});
parcelRegister("aa7Aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc4bc3eaaec0aaaf$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $cc4bc3eaaec0aaaf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    searchAriaLabel: {
        "id": "issue.issue-links-search-aria-label",
        "defaultMessage": "Current issue {linkType}..., search issues"
    },
    searchPlaceholder: {
        "id": "issue.issue-links-search-placeholder",
        "defaultMessage": "Search for issues"
    },
    openIssues: {
        "id": "issue.issue-links-search-open-issues",
        "defaultMessage": "Open Issues"
    },
    exactKey: {
        "id": "issue.issue-links-exact-key",
        "defaultMessage": "Exact key"
    },
    noHistoryResults: {
        "id": "issue.issue-link-no-history-results",
        "defaultMessage": "Type to search for an issue summary or key"
    }
});

});


parcelRegister("V3piY", function(module, exports) {

$parcel$export(module.exports, "default", () => $99f3612cee6c9c47$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $99f3612cee6c9c47$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    selfLinkInvalidIssue: {
        "id": "issue.issue-link-invalid-self-link",
        "defaultMessage": "Can't link the issue {issueKey} to itself."
    },
    unauthenticatedAppLink: {
        "id": "issue.unauthenticated-app-link",
        "defaultMessage": "Unauthenticated site. Try authenticating before, then link again."
    },
    unauthenticatedAppLinkWithSiteName: {
        "id": "issue.unauthenticated-app-link-with-site-name",
        "defaultMessage": "Unauthenticated site. Try authenticating the site {appLinkName}, then link again."
    },
    invalidIssue: {
        "id": "issue.issue-link-invalid-issue",
        "defaultMessage": "Can't find {issueKey}. Try searching for another issue key, or in another site."
    },
    twoInvalidIssues: {
        "id": "issue.issue-link-two-invalid-issues",
        "defaultMessage": "Can't find {issueKeys}. Try searching for other issue keys or in another site."
    },
    multipleInvalidIssues: {
        "id": "issue.issue-link-multiple-invalid-issues",
        "defaultMessage": "Can\u2019t find {firstTwoIssueKeys} and {countRemainingIssues} other {countRemainingIssues, plural, one {issue} other {issues}}. Try searching for other issue keys or in another site."
    },
    otherAppLink: {
        "id": "issue.other-applink",
        "defaultMessage": "We can only link issues from one site at a time. Try linking issues from one site first."
    }
});

});

const $5025063a7edaf260$export$80a99984a7da603c = 'invalid';
const $5025063a7edaf260$export$a7ec8aa501c1ea5c = 'unauthenticated';
const $5025063a7edaf260$export$94ada27c17e90824 = 'self_link';
const $5025063a7edaf260$export$67034f5c471ab313 = 'other_applink';



parcelRegister("1nrwm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9c494316e14989e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $giAhk = parcelRequire("giAhk");

var $81vFI = parcelRequire("81vFI");

var $eVt0g = parcelRequire("eVt0g");
function $f9c494316e14989e$export$d81b478935cf8074(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f9c494316e14989e$var$RightSideContainer // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-testid": "issue.views.issue-base.content.issue-links.add.add-button.right-side-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $81vFI.default), {
        label: props.intl.formatMessage((0, $eVt0g.default).label),
        onClick: props.onClick
    }));
}
$f9c494316e14989e$export$d81b478935cf8074.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $f9c494316e14989e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($f9c494316e14989e$export$d81b478935cf8074);
const $f9c494316e14989e$var$RightSideContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eVt0g", function(module, exports) {

$parcel$export(module.exports, "default", () => $90a7e54916a01ae9$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $90a7e54916a01ae9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "issue.issue-links-add-label",
        "defaultMessage": "Link an issue"
    }
});

});


parcelRegister("9iFfI", function(module, exports) {

$parcel$export(module.exports, "IssueLinkLineCard", () => $1b22efa4f7f3cdc9$export$faa8d0c8fee129f4);

var $eUqFw = parcelRequire("eUqFw");

var $lgWZr = parcelRequire("lgWZr");

var $aR8n6 = parcelRequire("aR8n6");

var $7ORi9 = parcelRequire("7ORi9");

var $1wVY9 = parcelRequire("1wVY9");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");
const $1b22efa4f7f3cdc9$export$faa8d0c8fee129f4 = ({ isHovering: isHovering, isActive: isActive, isFocused: isFocused, issue: issue, groupId: groupId, isInteractive: isInteractive, onDelete: onDelete, canAddIssueLinks: canAddIssueLinks, projectType: projectType, onClick: onClick, onEditIssue: onEditIssue })=>{
    const getAttributes = (0, $eUqFw.useCallback)(()=>({
            projectType: projectType,
            groupId: groupId,
            linkedIssueId: issue.id,
            isRemote: issue.isRemote || false,
            hasError: issue.hasError || false,
            errorType: issue.errorType || '',
            remoteIssueLinkError: issue.remoteIssueLinkError && issue.remoteIssueLinkError.error ? issue.remoteIssueLinkError.error : 'NONE'
        }), [
        projectType,
        groupId,
        issue
    ]);
    const [localAssociatedIssuesContext] = (0, $lgWZr.useLocalAssociatedIssuesContext)();
    const [remoteAssociatedIssuesContext] = (0, $lgWZr.useRemoteAssociatedIssuesContext)();
    const buildMountEvent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: (analyticsEvent)=>(0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'issueView.IssueLinkLineCard loaded', 'IssueLinkLineCard', getAttributes())
        });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleUserClickAnalytics = (0, $eUqFw.useCallback)((actionSubjectId)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'issueView.IssueLinkLineCard'
        });
        const attributes = getAttributes();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
    }, [
        createAnalyticsEvent,
        getAttributes
    ]);
    const handleEditIssue = (0, $eUqFw.useCallback)(()=>{
        if (issue.issueKey) onEditIssue?.((0, $6vrw7.toIssueKey)(issue.issueKey));
    }, [
        issue.issueKey,
        onEditIssue
    ]);
    const renderCard = ()=>{
        const handleDelete = (issueKey, globalId)=>onDelete && onDelete(groupId, issueKey, globalId);
        if (issue.remoteIssueLinkError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ORi9.RemoteIssueLineCardError), {
            issueTypeIconUrl: issue.issueTypeIconUrl,
            issueTypeName: issue.issueTypeName,
            issueKey: issue.issueKey,
            remoteServerHostname: issue.remoteServerHostname,
            globalId: issue.globalId,
            isHovering: isHovering,
            isFocused: isFocused,
            issueLink: issue.issueLink,
            error: issue.remoteIssueLinkError.error,
            handleUserClickAnalytics: handleUserClickAnalytics,
            canRemove: canAddIssueLinks,
            // @ts-expect-error - TS2774 - This condition will always return true since this function is always defined. Did you mean to call it instead?
            onDelete: onDelete && handleDelete
        });
        const canChangeStatus = isInteractive && !issue.remoteServerHostname;
        const { id: id, issueKey: issueKey, issueLink: issueLink, issueTypeIconUrl: issueTypeIconUrl, issueTypeName: issueTypeName, issuePriorityUrl: issuePriorityUrl, issuePriorityName: issuePriorityName, issueSummary: issueSummary, statusCategory: statusCategory, statusCategoryId: statusCategoryId, statusId: statusId, statusName: statusName, assigneeUrl: assigneeUrl, assigneeDisplayName: assigneeDisplayName, isLoading: isLoading, errorInlineMessage: errorInlineMessage, hasError: hasError, estimateFieldId: estimateFieldId, isRemote: isRemote, globalId: globalId, remoteServerHostname: remoteServerHostname } = issue;
        let isResolved;
        if (isRemote) isResolved = globalId ? remoteAssociatedIssuesContext[globalId]?.isResolved : false;
        else isResolved = issueKey ? localAssociatedIssuesContext[issueKey]?.isResolved : false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1wVY9.default), {
            id: (0, $6vrw7.toIssueId)(id),
            issueKey: (0, $6vrw7.toIssueKey)(issueKey ?? ''),
            issueLink: issueLink,
            issueTypeIconUrl: issueTypeIconUrl,
            issueTypeName: issueTypeName,
            issuePriorityUrl: issuePriorityUrl,
            issuePriorityName: issuePriorityName,
            issueSummary: issueSummary,
            statusCategory: statusCategory,
            statusCategoryId: statusCategoryId,
            statusId: statusId,
            statusName: statusName,
            assigneeUrl: assigneeUrl,
            assigneeDisplayName: assigneeDisplayName,
            isLoading: isLoading,
            errorInlineMessage: errorInlineMessage,
            hasError: hasError,
            estimateFieldId: estimateFieldId,
            isRemote: isRemote,
            globalId: globalId,
            remoteServerHostname: remoteServerHostname,
            isHovering: isHovering,
            isActive: isActive,
            isFocused: isFocused,
            isInteractive: canChangeStatus,
            // @ts-expect-error - TS2774 - This condition will always return true since this function is always defined. Did you mean to call it instead?
            onDelete: onDelete && handleDelete,
            canRemove: canAddIssueLinks,
            projectType: projectType,
            onHandleUserClickAnalytics: handleUserClickAnalytics,
            isInlineEditEnabled: false,
            shouldDisplayDevOpsData: true,
            onClick: onClick,
            isResolved: isResolved,
            onEdit: handleEditIssue
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "IssueLinkLineCard",
        /* eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics */ packageName: "jiraIssueView",
        attributes: getAttributes()
    }, renderCard(), buildMountEvent());
};

});
parcelRegister("7ORi9", function(module, exports) {

$parcel$export(module.exports, "RemoteIssueLineCardError", () => $c4728a21f6d5e019$export$49aca4b2b56a9e6c);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $je5kZ = parcelRequire("je5kZ");

var $96IgR = parcelRequire("96IgR");

var $f4A0J = parcelRequire("f4A0J");

var $23NQ5 = parcelRequire("23NQ5");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $hnzPP = parcelRequire("hnzPP");

var $5JgJ2 = parcelRequire("5JgJ2");


var $6RzXk = parcelRequire("6RzXk");

var $6vrw7 = parcelRequire("6vrw7");

var $8Yug5 = parcelRequire("8Yug5");

var $55c56 = parcelRequire("55c56");

var $lf7T9 = parcelRequire("lf7T9");
const $c4728a21f6d5e019$var$authSummaryLinkStartTag = '{tagStart}';
const $c4728a21f6d5e019$var$authSummaryLinkEndTag = '{tagEnd}';
const $c4728a21f6d5e019$export$49aca4b2b56a9e6c = ({ issueKey: issueKey, isHovering: isHovering, isFocused: isFocused, issueLink: issueLink, issueTypeIconUrl: issueTypeIconUrl, issueTypeName: issueTypeName, canRemove: canRemove, globalId: globalId, remoteServerHostname: remoteServerHostname, error: error, handleUserClickAnalytics: handleUserClickAnalytics, onDelete: onDelete })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderedIcon = (0, $eUqFw.useMemo)(()=>{
        if (error === (0, $b7817a5fa36c8dd6$export$d1fe0e8f550fe68d)) {
            const title = (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(issueTypeName) ? issueTypeName : formatMessage((0, $55c56.default).issueTypeTitle, {
                issueTypeName: issueTypeName
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: issueTypeName || '',
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lf7T9.FlexContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
                alt: title,
                url: issueTypeIconUrl
            })));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lf7T9.ErrorIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            label: "Issue link loading error",
            primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA).R300})`
        }));
    }, [
        error,
        formatMessage,
        issueTypeIconUrl,
        issueTypeName
    ]);
    const renderedText = (0, $eUqFw.useMemo)(()=>{
        switch(error){
            case 0, $b7817a5fa36c8dd6$export$d1fe0e8f550fe68d:
                return(// @ts-expect-error - TS2741 - Property 'color' is missing in type '{ children: Element; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { color: string; }, any>>'.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lf7T9.ErrorText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                    content: formatMessage((0, $55c56.default).remoteLinkAuthTooltip, {
                        remoteServerHostname: remoteServerHostname
                    }),
                    position: "bottom"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lf7T9.AuthErrorTextInner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4A0J))), {
                    label: "",
                    size: "small",
                    primaryColor: `var(--ds-icon-brand, ${(0, $PdmhA).B400})`
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6RzXk.FormattedReactMessage), {
                    message: formatMessage((0, $55c56.default).remoteLinkAuthSummary, {
                        tagStart: $c4728a21f6d5e019$var$authSummaryLinkStartTag,
                        tagEnd: $c4728a21f6d5e019$var$authSummaryLinkEndTag
                    }),
                    openingTag: $c4728a21f6d5e019$var$authSummaryLinkStartTag,
                    closingTag: $c4728a21f6d5e019$var$authSummaryLinkEndTag,
                    Component: (linkProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lf7T9.AuthActionText), {
                            onClick: ()=>{
                                handleUserClickAnalytics('errorCard.authenticationLink');
                            }
                        }, linkProps.children)
                })))));
            case 0, $b7817a5fa36c8dd6$export$37b67b9fa9f77199:
                return(// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lf7T9.ErrorText), {
                    color: "red"
                }, formatMessage((0, $55c56.default).remoteLinkMissingApplink)));
            default:
                return(// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lf7T9.ErrorText), {
                    color: "red"
                }, formatMessage((0, $55c56.default).remoteLinkGeneralError)));
        }
    }, [
        error,
        formatMessage,
        handleUserClickAnalytics,
        remoteServerHostname
    ]);
    const openIssueLink = (0, $eUqFw.useCallback)((event)=>{
        if (issueLink !== undefined) window.open(issueLink, '_blank');
        handleUserClickAnalytics('errorCard.linkIcon');
        event.stopPropagation();
    }, [
        handleUserClickAnalytics,
        issueLink
    ]);
    const renderedLinkButton = (0, $eUqFw.useMemo)(()=>{
        const buttonIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $55c56.default).remoteLinkOpenLinkTooltip),
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lf7T9.ShortCutIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
            label: "Open remote issue",
            size: "small"
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Yug5.LineCardHiddenButton), {
            show: isHovering || isFocused,
            icon: buttonIcon,
            onClick: openIssueLink
        });
    }, [
        formatMessage,
        isFocused,
        isHovering,
        openIssueLink
    ]);
    const handleDelete = (0, $eUqFw.useCallback)((event)=>{
        // Check issueKey or globalId for flowType
        if (issueKey != null && globalId != null) onDelete && onDelete((0, $6vrw7.toIssueKey)(issueKey), globalId);
        event.stopPropagation();
    }, [
        globalId,
        issueKey,
        onDelete
    ]);
    const renderedDeleteButton = (0, $eUqFw.useMemo)(()=>{
        if (!canRemove || !onDelete) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Yug5.LineCardHiddenButton), {
            show: isHovering || isFocused,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: formatMessage((0, $55c56.default).remoteLinkDeleteLinkTooltip),
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
                label: "Remove issue link"
            })),
            onClick: handleDelete
        });
    }, [
        canRemove,
        formatMessage,
        handleDelete,
        isFocused,
        isHovering,
        onDelete
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lf7T9.Card), null, renderedIcon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lf7T9.Key), {
        onClick: ()=>handleUserClickAnalytics('errorCard.issueKey')
    }, issueKey), renderedText, renderedLinkButton, renderedDeleteButton);
};
var $c4728a21f6d5e019$export$2e2bcd8739ae039 = $c4728a21f6d5e019$export$49aca4b2b56a9e6c;

});
parcelRegister("6RzXk", function(module, exports) {

$parcel$export(module.exports, "FormattedReactMessage", () => $81016b8c7b92ab7c$export$20942ce5ea74ad18);

var $eUqFw = parcelRequire("eUqFw");

var $6bYiA = parcelRequire("6bYiA");

var $6ZTsa = parcelRequire("6ZTsa");

var $avawr = parcelRequire("avawr");
const $81016b8c7b92ab7c$export$20942ce5ea74ad18 = (props)=>{
    const { message: message, openingTag: openingTag, closingTag: closingTag, Component: Component } = props;
    const startIndex = message.indexOf(openingTag);
    const endIndex = message.indexOf(closingTag);
    if (startIndex === -1 || endIndex === -1 || startIndex > endIndex) {
        (0, $avawr.logError)((0, $6bYiA.PACKAGE_NAME), (0, $6ZTsa.toErrorId)('formatReactMessage'), (0, $6ZTsa.toErrorMessage)(`Malformed message: "${message}"`));
        // message is malformed, so let's return original message stripped off any tags
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, message.replace(openingTag, '').replace(closingTag, ''));
    }
    const parts = message.split(openingTag);
    if (parts.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, message.replace(closingTag, ''));
    const before = parts[0];
    const [children, after] = parts[1].split(closingTag);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, before, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null, children), after);
};

});

parcelRegister("8Yug5", function(module, exports) {

$parcel$export(module.exports, "LineCardHiddenButton", () => $d47c09b10f630178$export$b25c964b109f51e1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $d47c09b10f630178$export$b25c964b109f51e1 = (props)=>{
    const { show: show, onClick: onClick, icon: icon } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d47c09b10f630178$var$LineCardHiddenButtonContainer, {
        show: show,
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.common.line-card-hidden-button.line-card-hidden-button-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d47c09b10f630178$var$LineCardHiddenButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        // @ts-expect-error - TS2322 - Type 'ReactNode' is not assignable to type 'ReactChild | undefined'.
        iconBefore: icon,
        appearance: "subtle",
        onClick: onClick,
        spacing: "none",
        interactionName: "auto-generated.jira-issue-view-common-views.line-card-hidden-button.button"
    })));
};
// css transform is a "clever" way of hiding the element while still letting it be focusable
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d47c09b10f630178$var$LineCardHiddenButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _18u0v77o _2hwxx0bf",
            __cmplp.show ? "_t9ec1h7a" : "_t9ec1u4m",
            __cmplp.className
        ])
    });
});
const $d47c09b10f630178$var$LineCardHiddenButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _s7n4nkob _19pku2gc _1bsbzwfg _4t3i1tcg _18u0u2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("55c56", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac8f3d9ebc9e4d2f$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $ac8f3d9ebc9e4d2f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueTypeTitle: {
        "id": "issues.issue-links.remote-issue-link-error.issue-type.title",
        "defaultMessage": "Issue type: {issueTypeName}"
    },
    remoteLinkAuthSummary: {
        "id": "issues.issue-links.remote-issue-link-error.auth-required.summary",
        "defaultMessage": "{tagStart}Authenticate{tagEnd} to see additional information"
    },
    remoteLinkGeneralError: {
        "id": "issues.issue-links.remote-issue-link-error.general-error",
        "defaultMessage": "Failed to load remote issue"
    },
    remoteLinkMissingApplink: {
        "id": "issues.issue-links.remote-issue-link-error.missing-applink",
        "defaultMessage": "Failed to load remote issue because remote site is not linked"
    },
    remoteLinkAuthTooltip: {
        "id": "issues.issue-links.remote-issue-link-error.auth-required.tooltip",
        "defaultMessage": "Authenticate to {remoteServerHostname}"
    },
    remoteLinkOpenLinkTooltip: {
        "id": "issues.issue-links.remote-issue-link-error.link-button.tooltip",
        "defaultMessage": "Open link in a new tab"
    },
    remoteLinkDeleteLinkTooltip: {
        "id": "issues.issue-links.remote-issue-link-error.delete-button.tooltip",
        "defaultMessage": "Unlink remote issue"
    }
});

});

parcelRegister("lf7T9", function(module, exports) {

$parcel$export(module.exports, "FlexContainer", () => $1228475066479821$export$124d4c7bf7db9715);
$parcel$export(module.exports, "Card", () => $1228475066479821$export$60332b2344f7fe41);
$parcel$export(module.exports, "Key", () => $1228475066479821$export$cd0f44441c3b7719);
$parcel$export(module.exports, "ErrorIconContainer", () => $1228475066479821$export$90993d2d9550d725);
$parcel$export(module.exports, "ErrorText", () => $1228475066479821$export$7f714e6c560938e5);
$parcel$export(module.exports, "AuthErrorTextInner", () => $1228475066479821$export$1d82f8597aa0b93a);
$parcel$export(module.exports, "AuthActionText", () => $1228475066479821$export$8ab2b777145697cf);
$parcel$export(module.exports, "ShortCutIconContainer", () => $1228475066479821$export$e61db03ca59470c);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $1228475066479821$export$124d4c7bf7db9715 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $1228475066479821$export$60332b2344f7fe41 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $1228475066479821$export$124d4c7bf7db9715, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $1228475066479821$export$cd0f44441c3b7719 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _18u01b66 _syaz1ifp _k48pni7l _1wyb1crf _o5721q9c _1q5t1r31 _1dit1r31 _q1at1r31 _9nxe1r31 _1ohyglyw _ksodglyw _q4asglyw _tpgfglyw _1r9x1o36 _4hz81o36 _dlvh1o36 _12gr1o36 _9h8h1ifp _30l31ifp _ysv71ifp _10531ifp",
            __cmplp.className
        ])
    });
});
const $1228475066479821$export$90993d2d9550d725 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0r5cr",
            __cmplp.className
        ])
    });
});
const $1228475066479821$export$7f714e6c560938e5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bvu2gc _o5721q9c _1reo15vq _18m915vq _1bto1l2s _16jlkb7n",
            __cmplp.color === 'red' ? "_syaz1ick" : "_syaz1kw7",
            __cmplp.className
        ])
    });
});
const $1228475066479821$export$1d82f8597aa0b93a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _1e0c1ule",
            __cmplp.className
        ])
    });
});
const $1228475066479821$export$8ab2b777145697cf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1vl3 _4bfu18uv _1hms8stv _ajmmnqa1",
            __cmplp.className
        ])
    });
});
const $1228475066479821$export$f31ef83ed9c8995f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1s4m _1bsb1ylp _4t3i7vkz _2rko1l7b _18u0pxbi _2hwx1b66",
            __cmplp.className
        ])
    });
});
const $1228475066479821$export$e61db03ca59470c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg _1yt41b66 _vchhusvi",
            __cmplp.className
        ])
    });
});

});



parcelRegister("avHv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d8284c45fff35fa$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $8d8284c45fff35fa$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removeIssueLinkHeader: {
        "id": "issues.confirm-delete-issuelink-modal-header",
        "defaultMessage": "Remove the link to {issueKey}?"
    },
    removeIssueLinkContent: {
        "id": "issues.confirm-delete-issuelink-modal-text",
        "defaultMessage": "You can add it again later if you need to."
    },
    removeIssueLinkButton: {
        "id": "issues.conirm-delete-issue-link-confirm-btn-text",
        "defaultMessage": "Remove"
    },
    issueLinkFailureHeader: {
        "id": "issue.issue-links-failure-header",
        "defaultMessage": "We couldn't link the issue"
    },
    issueLinkFailureContent: {
        "id": "issue.issue-links-failure-content",
        "defaultMessage": "Wait a few moments, then give it another try."
    },
    issueLinkNoPermissionFailureContent: {
        "id": "issue.issue-links-no-permission-failure-content",
        "defaultMessage": "You don't have permission to link this issue. Please contact your Jira administrator for assistance."
    }
});

});

parcelRegister("hHZBg", function(module, exports) {

$parcel$export(module.exports, "getUserHasPermissionToLink", () => $47369363a3b2b8cc$export$54d0d4caa4a994a3);
const $47369363a3b2b8cc$export$54d0d4caa4a994a3 = (error)=>error?.statusCode !== 401;

});



parcelRegister("7JYKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $917476d9601651bc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $hJ992 = parcelRequire("hJ992");

var $cZZo6 = parcelRequire("cZZo6");

var $guDlK = parcelRequire("guDlK");


var $guDlK = parcelRequire("guDlK");
const $917476d9601651bc$export$1bbc720207e8a465 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const isServiceDesk = projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);
    const projectContext = (0, $guDlK.useProjectContext)(projectKey);
    const isProjectArchived = projectContext?.projectStatus === (0, $5bd9e96e4d7e8aee$export$4ccc35479ba9ad1);
    return isServiceDesk && !isProjectArchived ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cZZo6.AsyncLinkedAlertsViewModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cZZo6.AsyncLinkedAlertsLinkModal), null)) : null;
};
var $917476d9601651bc$export$2e2bcd8739ae039 = $917476d9601651bc$export$1bbc720207e8a465;

});

parcelRegister("3PBWj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb59d204f1888861$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9VPEO = parcelRequire("9VPEO");

var $0cdA8 = parcelRequire("0cdA8");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");
var $3oTxc = parcelRequire("3oTxc");

var $gGtKh = parcelRequire("gGtKh");

var $lO4Or = parcelRequire("lO4Or");

var $eI3Sy = parcelRequire("eI3Sy");

var $f1lMr = parcelRequire("f1lMr");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fb59d204f1888861$var$ObjectRelatedRequestsPanel = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [affectedServicesFieldId] = (0, $3oTxc.useSearchCustomFieldKeys)(issueKey, (0, $lO4Or.SERVICE_ENTITY_CF_TYPE));
    const [affectedServices] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: affectedServicesFieldId
    });
    // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type.
    const serviceIds = affectedServices?.map(({ id: id })=>id) ?? [];
    const [itsmPractices] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.SERVICEDESK_PRACTICES_TYPE)
    });
    const changeOrIncident = itsmPractices?.[0] === (0, $f1lMr.INCIDENTS) ? (0, $f1lMr.INCIDENTS) : null;
    if (!affectedServicesFieldId || serviceIds.length === 0 || changeOrIncident == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "AsyncObjectRelatedRequestsPanel",
        packageName: "jiraIssueViewBase",
        fallback: "unmount",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "object-related-requests-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
            width: "100%",
            height: "60px"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI3Sy.default), {
        affectedServicesFieldId: affectedServicesFieldId,
        itsmPractice: changeOrIncident,
        serviceIds: serviceIds
    })));
});
var $fb59d204f1888861$export$2e2bcd8739ae039 = $fb59d204f1888861$var$ObjectRelatedRequestsPanel;

});
parcelRegister("eI3Sy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c3b1e7547a5a30$export$2e2bcd8739ae039);

var $7rh0R = parcelRequire("7rh0R");

const $c8c3b1e7547a5a30$var$AsyncObjectRelatedRequestsPanel = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("fsfnY")), {
    moduleId: "./src/packages/servicedesk/change-management/object-related-requests-panel/src/ui/index.tsx"
});
var $c8c3b1e7547a5a30$export$2e2bcd8739ae039 = $c8c3b1e7547a5a30$var$AsyncObjectRelatedRequestsPanel;

});
parcelRegister("fsfnY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2I6kH');
        const value = parcelRequire('b1Law');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2I6kH").then(()=>parcelRequire('b1Law'));
}

});



parcelRegister("lUUR2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46f75f79164af37$export$2e2bcd8739ae039);

var $5G3JL = parcelRequire("5G3JL");

var $imVNa = parcelRequire("imVNa");parcelRequire("3VVr2");
var $agEEp = parcelRequire("agEEp");
var $3VVr2 = parcelRequire("3VVr2");

var $f9RL0 = parcelRequire("f9RL0");

var $lqalZ = parcelRequire("lqalZ");

var $3rr33 = parcelRequire("3rr33");

var $hHnBv = parcelRequire("hHnBv");

var $1OJS4 = parcelRequire("1OJS4");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $1b2Vj = parcelRequire("1b2Vj");

var $9GGoL = parcelRequire("9GGoL");

var $75LXB = parcelRequire("75LXB");

var $bluq3 = parcelRequire("bluq3");
var $c46f75f79164af37$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
        childIssuesPanelType: (0, $agEEp.CLASSIC_PORTFOLIO_CHILDREN),
        baseUrl: (0, $5JqpU.baseUrlSelector)(state),
        locale: (0, $5JqpU.localeSelector)(state),
        user: (0, $5JqpU.accountIdloggedInUserSelector)(state),
        // FIXME: JIV-17455 this field can be null
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        projectId: (0, $jZDJX.projectIdSelector)(state),
        projectType: (0, $jZDJX.projectTypeSelector)(state),
        parentKey: (0, $5JqpU.issueKeySelector)(state),
        // FIXME: JIV-17455 this field can be null
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        parentId: (0, $5JqpU.issueIdSelector)(state),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        issues: (0, $75LXB.persistedChildrenIssuesSelector)(state),
        isIssueViewComplete: (0, $jZDJX.isCompletedLoadingSelector)(state),
        // FIXME: JIV-17455 provide correct defaults
        issueHierarchyLevel: (0, $1b2Vj.hierarchyLevelSelector)(state) || 0,
        childIssuesLimitUrl: (0, $fokFV.childIssuesLimitUrlSelector)(state)((0, $f9RL0.PORTFOLIO_CHILD_ISSUES)),
        messages: $bluq3.default,
        supportsIssueCreation: false,
        hasExceededIssuesLimitAfterLoad: undefined,
        totalChildIssueCount: (0, $9GGoL.totalChildIssueCountSelector)(state)
    }), (dispatch)=>({
        // @ts-expect-error - TS7031 - Binding element 'fromIssueKey' implicitly has an 'any' type. | TS7031 - Binding element 'toIssueKey' implicitly has an 'any' type.
        onNavigateToNewIssue: ({ fromIssueKey: fromIssueKey, toIssueKey: toIssueKey })=>{
            if (!__SPA__) dispatch((0, $1OJS4.navigateToNewIssue)({
                fromIssueKey: fromIssueKey,
                toIssueKey: toIssueKey
            }));
        },
        onChange: (event)=>{
            switch(event.type){
                case (0, $imVNa.ChangeEventTypes).CHILD_ISSUE_ADDED:
                    dispatch((0, $hHnBv.childIssueAddSuccess)(event.meta.childIssue));
                    break;
                default:
                    break;
            }
        },
        onEditAssociatedIssue: (issueKey)=>{
            dispatch((0, $3rr33.updateAssociatedIssueRequest)(issueKey));
        }
    })))((0, $3VVr2.default));

});
parcelRegister("bluq3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dd332bda8f8140a$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $1dd332bda8f8140a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue.portfolio-child-issues.title",
        "defaultMessage": "Child issues"
    }
});

});


parcelRegister("9vbIS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9e53451d4825593$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $dWGNJ = parcelRequire("dWGNJ");

var $autRb = parcelRequire("autRb");

var $81vFI = parcelRequire("81vFI");

var $iAc02 = parcelRequire("iAc02");

var $jMP2a = parcelRequire("jMP2a");

var $fq6rr = parcelRequire("fq6rr");

var $9NrAh = parcelRequire("9NrAh");

var $5YYzL = parcelRequire("5YYzL");

var $6vrw7 = parcelRequire("6vrw7");

var $kAv7I = parcelRequire("kAv7I");
const $b9e53451d4825593$export$fd8ebf59dd2b58b6 = 'summaryInlineEdit';
const $b9e53451d4825593$export$90579598bcaff5dc = ({ issueKey: issueKey })=>{
    const projectKey = (0, $hJ992.useProjectKey)();
    const isProjectAdmin = (0, $5YYzL.useCanAdministerProject)(projectKey);
    const formsContainer = (0, $eUqFw.useRef)(null);
    const [panelAddFormButtonClickedCount, setPanelAddFormButtonClickedCount] = (0, $eUqFw.useState)(0);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ value: { hasIssueForms: hasIssueForms, issueViewAddFormButtonClickedCount: issueViewAddFormButtonClickedCount }, fieldConfig: fieldConfig, error: error }, { resetAddFormButtonCount: resetAddFormButtonCount }] = (0, $fq6rr.useForms)({
        issueKey: (0, $6vrw7.toIssueKey)(issueKey)
    });
    const isFormsEditable = fieldConfig?.value?.isEditable || false;
    (0, $eUqFw.useEffect)(()=>{
        if (issueViewAddFormButtonClickedCount > 0) (0, $autRb.smoothScrollIntoCenterIfNeeded)(formsContainer.current);
    }, [
        issueViewAddFormButtonClickedCount
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // close Add Form dropdown panel if issue key is changed
        resetAddFormButtonCount();
    }, [
        issueKey,
        resetAddFormButtonCount
    ]);
    const shouldShowFormsPanel = issueViewAddFormButtonClickedCount > 0 ? true : hasIssueForms === true;
    const onClickAddIconButton = (_, analyticsEvent)=>{
        setPanelAddFormButtonClickedCount(panelAddFormButtonClickedCount + 1);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'addFormIcon');
    };
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: error,
        title: (0, $kAv7I.default).useFormsErrorTitle,
        description: (0, $kAv7I.default).useFormsErrorMessage
    });
    return shouldShowFormsPanel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: formsContainer,
        "data-testid": "issue.views.issue-base.content.proforma-forms"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingTitle), null, formatMessage((0, $kAv7I.default).attachedFormsHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingIcons), null, isFormsEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $81vFI.default), {
        label: formatMessage((0, $kAv7I.default).addFormIconLabel),
        onClick: onClickAddIconButton
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b9e53451d4825593$var$ProformaFormsViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9NrAh.ProformaFormsViewLazy), {
        canEditIssues: isFormsEditable,
        isProjectAdmin: isProjectAdmin,
        panelAddFormButtonClickedCount: issueViewAddFormButtonClickedCount + panelAddFormButtonClickedCount
    }))) : null;
};
const $b9e53451d4825593$export$be756451b1a9295b = ({ issueKey: issueKey })=>/*
 * We want any Proforma errors to be caught here and not crash the whole issue view page.
 * JSErrorBoundary will show a generic "please refresh the page" message in the same place
 * the Proforma forms normally would show.
 * */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "ProformaFormsPanelViewBoundary",
        packageName: "jiraIssueViewBase" // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
        ,
        teamName: "jsm-request-intake" // jsm-request-intake, not Bento
        ,
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.issue-base.content.proforma-forms.dependency-line"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b9e53451d4825593$export$90579598bcaff5dc, {
        issueKey: issueKey
    }));
var $b9e53451d4825593$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($b9e53451d4825593$export$be756451b1a9295b);
const $b9e53451d4825593$var$ProformaFormsViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qu2gc _n3td1jfw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9NrAh", function(module, exports) {

$parcel$export(module.exports, "ProformaFormsViewLazy", () => $793dc89cc029cf5d$export$d8ab0915e9c44daa);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $793dc89cc029cf5d$var$LazyProformaForms = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("elV2B")).then((module)=>module.ConnectedProformaFormsView), {
    ssr: false,
    moduleId: "./src/packages/proforma/issue-view/src/index.tsx"
});
const $793dc89cc029cf5d$export$d8ab0915e9c44daa = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jira-proforma-panel-in-issue-view",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($793dc89cc029cf5d$var$LazyProformaForms, props));

});
parcelRegister("elV2B", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2EY1I');
        const value = parcelRequire('fn0qe');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2EY1I").then(()=>parcelRequire('fn0qe'));
}

});


parcelRegister("kAv7I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5145050569c2fad$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $c5145050569c2fad$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    attachedFormsHeader: {
        "id": "issue-view.forms-panel.attached-forms-header",
        "defaultMessage": "Attached forms"
    },
    heading: {
        "id": "issue-view.forms-panel.heading",
        "defaultMessage": "Forms"
    },
    useFormsErrorTitle: {
        "id": "issue-view.forms-panel.proforma.error",
        "defaultMessage": "Error loading forms"
    },
    useFormsErrorMessage: {
        "id": "issue-view.forms-panel.proforma.error-message",
        "defaultMessage": "Please try refreshing the page"
    },
    addFormIconLabel: {
        "id": "issue-view.forms-panel.proforma.add-form-icon-label",
        "defaultMessage": "Add form"
    }
});

});


parcelRegister("22cag", function(module, exports) {

$parcel$export(module.exports, "default", () => $2de0704ea57e4e84$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $imVNa = parcelRequire("imVNa");parcelRequire("3VVr2");
var $agEEp = parcelRequire("agEEp");
var $3VVr2 = parcelRequire("3VVr2");

var $f9RL0 = parcelRequire("f9RL0");

var $lqalZ = parcelRequire("lqalZ");

var $3rr33 = parcelRequire("3rr33");

var $hHnBv = parcelRequire("hHnBv");

var $1OJS4 = parcelRequire("1OJS4");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $1b2Vj = parcelRequire("1b2Vj");

var $9GGoL = parcelRequire("9GGoL");

var $iY7NN = parcelRequire("iY7NN");

var $ke6cX = parcelRequire("ke6cX");

var $6Fp9G = parcelRequire("6Fp9G");

var $dv9do = parcelRequire("dv9do");

var $1TrR5 = parcelRequire("1TrR5");

var $4fcgY = parcelRequire("4fcgY");
const $2de0704ea57e4e84$export$413b1c23ad987cd8 = (props)=>{
    const reduxOnChange = props.onChange;
    const issueKey = (0, $hJ992.useIssueKey)();
    const [currentValue, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $f9RL0.SUBTASKS)
    });
    const onChange = (0, $eUqFw.useCallback)((event)=>{
        switch(event.type){
            case (0, $imVNa.ChangeEventTypes).CHILD_ISSUE_ADDED:
                setFieldValue(issueKey, (0, $f9RL0.SUBTASKS), currentValue.concat({
                    id: event.meta.childIssue.id,
                    key: event.meta.childIssue.issueKey
                }));
                break;
            default:
                break;
        }
        reduxOnChange(event);
    }, [
        currentValue,
        issueKey,
        reduxOnChange,
        setFieldValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3VVr2.default), {
        ...props,
        onChange: onChange
    });
};
const $2de0704ea57e4e84$var$onNavigateToNewIssueMemoized = (0, $5iWql.default)((onNavigateToNewIssueDispatchProp)=>// @ts-expect-error - TS7031 - Binding element 'fromIssueKey' implicitly has an 'any' type. | TS7031 - Binding element 'toIssueKey' implicitly has an 'any' type.
    ({ fromIssueKey: fromIssueKey, toIssueKey: toIssueKey })=>{
        onNavigateToNewIssueDispatchProp && onNavigateToNewIssueDispatchProp({
            fromIssueKey: fromIssueKey,
            toIssueKey: toIssueKey
        });
    });
const $2de0704ea57e4e84$var$ReduxConnectedComponent = (0, $lqalZ.connect)((state)=>({
        childIssuesPanelType: (0, $agEEp.CLASSIC_SUBTASKS),
        parentId: (0, $5JqpU.issueIdSelector)(state),
        issueTypes: (0, $6Fp9G.subtaskTypesSelector)(state),
        issues: (0, $dv9do.subtaskEntitiesSelector)(state),
        childIssuesLimitUrl: (0, $fokFV.childIssuesLimitUrlSelector)(state)((0, $f9RL0.SUBTASKS)),
        messages: $4fcgY.default,
        supportsIssueCreation: (0, $dv9do.canCreateSubtaskSelector)(state),
        quickAddClickCount: (0, $iY7NN.subtaskQuickAddClickCountSelector)(state),
        isIssueViewComplete: (0, $jZDJX.isCompletedLoadingSelector)(state),
        fetchIssueTypesStatus: (0, $ke6cX.fetchIssueTypesStatusSelector)(state),
        issueHierarchyLevel: (0, $1b2Vj.hierarchyLevelSelector)(state),
        hasExceededIssuesLimitAfterLoad: undefined,
        totalChildIssueCount: (0, $9GGoL.totalChildIssueCountSelector)(state)
    }), (dispatch)=>({
        onChange: (event)=>{
            switch(event.type){
                case (0, $imVNa.ChangeEventTypes).CHILD_ISSUE_ADDED:
                    dispatch((0, $hHnBv.subtaskAddSuccess)(event.meta.childIssue, event.meta.fieldsData));
                    break;
                case (0, $imVNa.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED:
                    dispatch((0, $hHnBv.issueChildrenOrderChangeSuccess)(event.meta));
                    break;
                case (0, $imVNa.ChangeEventTypes).CHILD_ISSUE_FIELD_UPDATED:
                    dispatch((0, $hHnBv.childIssueFieldUpdate)(event.meta.childIssueId));
                    break;
                default:
                    break;
            }
        },
        onAddChildClick: ()=>dispatch((0, $hHnBv.childIssuePanelAddClick)()),
        // @ts-expect-error - TS7031 - Binding element 'fromIssueKey' implicitly has an 'any' type. | TS7031 - Binding element 'toIssueKey' implicitly has an 'any' type.
        onNavigateToNewIssueDispatchProp: ({ fromIssueKey: fromIssueKey, toIssueKey: toIssueKey })=>{
            if (!__SPA__) dispatch((0, $1OJS4.navigateToNewIssue)({
                fromIssueKey: fromIssueKey,
                toIssueKey: toIssueKey
            }));
        },
        onEditAssociatedIssue: (issueKey)=>{
            dispatch((0, $3rr33.updateAssociatedIssueRequest)(issueKey));
        }
    }), (stateProps, dispatchProps)=>{
    const { onNavigateToNewIssueDispatchProp: onNavigateToNewIssueDispatchProp, ...restDispatchProps } = dispatchProps;
    return {
        ...stateProps,
        ...restDispatchProps,
        onNavigateToNewIssue: (0, $1TrR5.functionWithFFRedux)($2de0704ea57e4e84$var$onNavigateToNewIssueMemoized(onNavigateToNewIssueDispatchProp), ({ fromIssueKey: fromIssueKey, toIssueKey: toIssueKey })=>{
            onNavigateToNewIssueDispatchProp && onNavigateToNewIssueDispatchProp({
                fromIssueKey: fromIssueKey,
                toIssueKey: toIssueKey
            });
        })
    };
})($2de0704ea57e4e84$export$413b1c23ad987cd8);
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$2de0704ea57e4e84$export$2e2bcd8739ae039 = $2de0704ea57e4e84$var$ReduxConnectedComponent;

});
parcelRegister("4fcgY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d21ce2e9f22345e$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $9d21ce2e9f22345e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue.subtasks-heading",
        "defaultMessage": "Subtasks"
    },
    createSubtaskErrorHeader: {
        "id": "issue.subtask-error-header",
        "defaultMessage": "We couldn't create the subtask"
    },
    createSubtaskErrorContent: {
        "id": "issue.subtask-error-content",
        "defaultMessage": "Wait a few moments, then give it another try."
    }
});

});


parcelRegister("hjzLw", function(module, exports) {

$parcel$export(module.exports, "ConnectedView", () => $8d17572f1b34c949$export$e612ec082dda38);

var $eUqFw = parcelRequire("eUqFw");

var $kn6GU = parcelRequire("kn6GU");

var $c8Guq = parcelRequire("c8Guq");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");

var $8un0w = parcelRequire("8un0w");

var $fee69 = parcelRequire("fee69");

var $bKxX9 = parcelRequire("bKxX9");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $4ksts = parcelRequire("4ksts");

var $ggm5u = parcelRequire("ggm5u");

var $lqalZ = parcelRequire("lqalZ");

var $hficN = parcelRequire("hficN");

var $6gpYd = parcelRequire("6gpYd");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kOs8y = parcelRequire("kOs8y");

var $4O1bt = parcelRequire("4O1bt");
const $8d17572f1b34c949$export$90091b93f6cf4241 = 10;
const $8d17572f1b34c949$export$1adf7b57879ce28c = 50;
const $8d17572f1b34c949$export$3ff310010d738144 = (props)=>{
    const intl = (0, $4ksts.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [currentPage, setCurrentPage] = (0, $eUqFw.useState)(0);
    const [_, { openModal: openHardLimitsModal, setFieldType: setHardLimitsFieldType }] = (0, $ggm5u.useHardLimitsContactAdminModal)();
    const webLinkAddedFlagId = 'webLinkAddedFlag';
    const { links: links, onDeleteOptimisticWebLink: onDeleteOptimisticWebLink, onCreateWebLinkRetry: onCreateWebLinkRetry } = props;
    const onShowMore = (0, $eUqFw.useCallback)(()=>{
        setCurrentPage(currentPage + 1);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'webLinksShowMore', {
            currentPage: currentPage
        });
    }, [
        createAnalyticsEvent,
        currentPage
    ]);
    const maxResults = $8d17572f1b34c949$export$90091b93f6cf4241 + currentPage * $8d17572f1b34c949$export$1adf7b57879ce28c;
    const slicedLinks = (0, $eUqFw.useMemo)(()=>links.slice(0, maxResults), [
        links,
        maxResults
    ]);
    const nextPageCount = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($kn6GU)))(links.length - maxResults, 0, $8d17572f1b34c949$export$1adf7b57879ce28c), [
        links.length,
        maxResults
    ]);
    const persistedLinksCount = links.filter(// @ts-expect-error - TS2339 - Property 'isCreating' does not exist on type 'WebLink'. | TS2339 - Property 'isCreating' does not exist on type 'WebLink'.
    (link)=>link.isCreating == null || !link.isCreating).length;
    const linksLengthRef = (0, $eUqFw.useRef)(persistedLinksCount);
    const { showFlag: showFlag, dismissFlag: dismissFlag, hasFlag: hasFlag } = (0, $k8Qyf.useFlagsService)();
    /**
   * When the limit of links per issue is exceeded, we should remove any optimistic feedback, the
   * optimistic link, and show correct flag.
   */ const showErrorLimitExceededFlag = (0, $eUqFw.useCallback)((linkId)=>{
        dismissFlag(webLinkAddedFlagId);
        onDeleteOptimisticWebLink(linkId);
        const flagId = (0, $eo17r.toFlagId)(`${linkId}-linksPerIssueLimitExceeded`);
        if (hasFlag && hasFlag(flagId)) return;
        showFlag({
            id: flagId,
            title: (0, $kOs8y.messages).linksPerIssueLimitExceededTitle,
            description: (0, $kOs8y.messages).linksPerIssueLimitExceededDescription,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
                label: "warning",
                primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y300})`
            }),
            type: 'warning',
            actions: [
                {
                    content: (0, $kOs8y.messages).linksPerIssueLimitExceededNotifyAdminLink,
                    onClick: ()=>{
                        openHardLimitsModal();
                        setHardLimitsFieldType('remoteIssueLinks');
                        dismissFlag(flagId);
                    }
                }
            ]
        });
    }, [
        showFlag,
        hasFlag,
        openHardLimitsModal,
        setHardLimitsFieldType,
        dismissFlag,
        onDeleteOptimisticWebLink
    ]);
    /**
   * Failure to create the optimistic link should offer retry and cancel.
   */ const showErrorCreatingFlag = (0, $eUqFw.useCallback)((linkId)=>{
        dismissFlag(webLinkAddedFlagId);
        const flagId = (0, $eo17r.toFlagId)(`${linkId}-failedCreating`);
        if (hasFlag && hasFlag(flagId)) return;
        showFlag({
            id: flagId,
            title: (0, $kOs8y.messages).createErrorHeading,
            description: (0, $kOs8y.messages).createErrorBody,
            type: 'warning',
            actions: [
                {
                    content: (0, $kOs8y.messages).retryAction,
                    onClick: ()=>{
                        onCreateWebLinkRetry(linkId);
                        dismissFlag(flagId);
                    }
                },
                {
                    content: (0, $kOs8y.messages).cancelAction,
                    onClick: ()=>{
                        onDeleteOptimisticWebLink(linkId);
                        dismissFlag(flagId);
                    }
                }
            ],
            onDismissed: ()=>{
                onDeleteOptimisticWebLink(linkId);
            }
        });
    }, [
        showFlag,
        hasFlag,
        dismissFlag,
        onDeleteOptimisticWebLink,
        onCreateWebLinkRetry,
        webLinkAddedFlagId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Retried link creation should still not dispaly
        // the optimistic "we've added a link" flag
        let shouldDispatchOptimisticFeedback = true;
        if ((0, $bKxX9.ff)('issue.details.display-flag-on-optimistic-weblinks-error')) links.forEach((link)=>{
            if ('isCreateFailedLimitExceeded' in link && link.isCreateFailedLimitExceeded) {
                showErrorLimitExceededFlag(link.id);
                shouldDispatchOptimisticFeedback = false;
            }
            if ('isCreateFailed' in link && link.isCreateFailed) {
                showErrorCreatingFlag(link.id);
                shouldDispatchOptimisticFeedback = false;
            }
        });
        if (linksLengthRef.current > 0 && persistedLinksCount > $8d17572f1b34c949$export$90091b93f6cf4241 && persistedLinksCount > linksLengthRef.current) {
            if ((0, $bKxX9.ff)('issue.details.display-flag-on-optimistic-weblinks-error') && !shouldDispatchOptimisticFeedback) return;
            showFlag({
                id: webLinkAddedFlagId,
                type: 'success',
                title: (0, $kOs8y.messages).webLinkAddedFlagTitle,
                description: (0, $kOs8y.messages).webLinkAddedFlagDescription
            });
        }
        linksLengthRef.current = persistedLinksCount;
    }, [
        persistedLinksCount,
        showFlag,
        webLinkAddedFlagId,
        links,
        showErrorLimitExceededFlag,
        showErrorCreatingFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4O1bt.WebLinksView), {
        ...props,
        intl: intl,
        links: slicedLinks,
        nextPageCount: nextPageCount,
        onShowMore: onShowMore
    });
};
const $8d17572f1b34c949$export$ac90a5534d384989 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $8un0w.default)({
    onAddButtonClicked: 'addWebLink'
}), (0, $lqalZ.connect)((state, props)=>{
    const { applicationId: applicationId } = props;
    return {
        isCreateWebLinkOpened: (0, $6gpYd.isCreateWebLinkOpenedSelector)(state),
        links: (0, $6gpYd.webLinksWithApplicationIdSelector)(state, applicationId),
        canAddWebLinks: (0, $6gpYd.canAddWebLinksSelector)(state)
    };
}, {
    onAddButtonClicked: (0, $hficN.showCreateWebLinkForm),
    onDeleteOptimisticWebLink: (0, $hficN.deleteOptimisticWebLink),
    onCreateWebLinkRetry: (0, $hficN.createWebLinkRetry)
}))($8d17572f1b34c949$export$3ff310010d738144);
const $8d17572f1b34c949$export$e612ec082dda38 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
        id: "^web-links-general-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8d17572f1b34c949$export$ac90a5534d384989, props));

});
parcelRegister("kn6GU", function(module, exports) {

var $1ImyS = parcelRequire("1ImyS");

var $7kP6w = parcelRequire("7kP6w");
/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */ function $ed4b255301b8301f$var$clamp(number, lower, upper) {
    if (upper === undefined) {
        upper = lower;
        lower = undefined;
    }
    if (upper !== undefined) {
        upper = $7kP6w(upper);
        upper = upper === upper ? upper : 0;
    }
    if (lower !== undefined) {
        lower = $7kP6w(lower);
        lower = lower === lower ? lower : 0;
    }
    return $1ImyS($7kP6w(number), lower, upper);
}
module.exports = $ed4b255301b8301f$var$clamp;

});
parcelRegister("1ImyS", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $13fb66c0c405b8c7$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $13fb66c0c405b8c7$var$baseClamp;

});


parcelRegister("kOs8y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $855e75634fb9da5c$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $855e75634fb9da5c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "issue.details.web-links.heading",
        "defaultMessage": "Web links"
    },
    showMoreLabel: {
        "id": "issue.details.web-links.show-more-label",
        "defaultMessage": "{nextPageCount, plural, one {Show {nextPageCount} more} other {Show {nextPageCount} more}}"
    },
    webLinkAddedFlagTitle: {
        "id": "issue.details.web-links.web-link-added-flag-title",
        "defaultMessage": "We\u2019ve added your web link"
    },
    webLinkAddedFlagDescription: {
        "id": "issue.details.web-links.web-link-added-flag-description",
        "defaultMessage": "If you can\u2019t find the web link, go to the issue\u2019s web links section and select Show more."
    },
    linksPerIssueLimitExceededTitle: {
        "id": "issue.details.web-links.links-per-issue-limit-exceeded-title",
        "defaultMessage": "We couldn\u2019t add the link"
    },
    linksPerIssueLimitExceededDescription: {
        "id": "issue.details.web-links.links-per-issue-limit-exceeded-description",
        "defaultMessage": "We can\u2019t add any more links to this issue as the limit has been reached."
    },
    linksPerIssueLimitExceededNotifyAdminLink: {
        "id": "issue.details.web-links.links-per-issue-limit-exceeded.contact-administrator",
        "defaultMessage": "Notify your admin"
    },
    createErrorHeading: {
        "id": "issue.details.web-links.error-message.create-error-heading",
        "defaultMessage": "We couldn't create the web link"
    },
    createErrorBody: {
        "id": "issue.details.web-links.error-message.create-error-body",
        "defaultMessage": "Wait a few moments, then give it another try."
    },
    retryAction: {
        "id": "issue.details.web-links.error-message.retry-action",
        "defaultMessage": "Try again"
    },
    cancelAction: {
        "id": "issue.details.web-links.line-card.error-message.cancel-action",
        "defaultMessage": "Cancel"
    }
});
var $855e75634fb9da5c$export$2e2bcd8739ae039 = $855e75634fb9da5c$export$defe85febe8b728c;

});

parcelRegister("4O1bt", function(module, exports) {

$parcel$export(module.exports, "WebLinksView", () => $685690920ec019b7$export$95693d3041fa8f1e);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $1ybV0 = parcelRequire("1ybV0");

var $87Kv4 = parcelRequire("87Kv4");

var $iAc02 = parcelRequire("iAc02");

var $aDvCM = parcelRequire("aDvCM");

var $gDZxA = parcelRequire("gDZxA");

var $kOs8y = parcelRequire("kOs8y");
class $685690920ec019b7$export$95693d3041fa8f1e extends (0, $eUqFw.Component) {
    renderHeading() {
        const { intl: intl, isCreateWebLinkOpened: isCreateWebLinkOpened, onAddButtonClicked: onAddButtonClicked, links: links, canAddWebLinks: canAddWebLinks, applicationName: applicationName, applicationId: applicationId } = this.props;
        const hasWebLinks = Boolean(links && links.length);
        const isGenericSection = applicationId === undefined || applicationId === null || applicationId?.trim() === '';
        return isCreateWebLinkOpened || hasWebLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingTitle), null, !isGenericSection ? applicationName : intl.formatMessage((0, $kOs8y.messages).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingIcons), null, canAddWebLinks && isGenericSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aDvCM.default), {
            onClick: onAddButtonClicked
        }))) : null;
    }
    renderLineCards() {
        const { links: links, canAddWebLinks: canAddWebLinks } = this.props;
        const hasLinks = links && links.length > 0;
        let renderedLinks = links;
        if (hasLinks && (0, $1ybV0.ff)('trello.card.integration.patch', false)) {
            const { applicationName: applicationName } = this.props;
            if (applicationName === 'Trello') renderedLinks = links.map((link)=>{
                const newLink = {
                    ...link
                };
                delete newLink.linkText;
                newLink.href = newLink.href.replace(/\/c\/([^/]+)\/.+/, '/c/$1');
                return newLink;
            });
        }
        return hasLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($685690920ec019b7$var$GroupContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $87Kv4.default), {
            links: renderedLinks,
            canDelete: canAddWebLinks
        })) : null;
    }
    renderCreateLinkView() {
        const { applicationId: applicationId, isCreateWebLinkOpened: isCreateWebLinkOpened } = this.props;
        const isGenericSection = applicationId === undefined || applicationId === null || applicationId?.trim() === '';
        return isGenericSection && isCreateWebLinkOpened ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gDZxA.default), null) : null;
    }
    renderShowMore() {
        const { onShowMore: onShowMore, nextPageCount: nextPageCount, intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($685690920ec019b7$var$ShowMoreButton, {
            appearance: "link",
            onClick: onShowMore,
            testId: "issue.views.issue-base.content.web-links.show-more-link"
        }, intl.formatMessage((0, $kOs8y.messages).showMoreLabel, {
            nextPageCount: nextPageCount
        }));
    }
    render() {
        const { applicationId: applicationId, nextPageCount: nextPageCount } = this.props;
        const scopeIdentifier = typeof applicationId === 'string' ? applicationId : 'generic'; // Extend to support preview mode: BENTO-5005
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": `issue.views.issue-base.content.web-links.top-container.scope-${scopeIdentifier}`
        }, this.renderHeading(), this.renderLineCards(), nextPageCount > 0 && this.renderShowMore(), this.renderCreateLinkView());
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $685690920ec019b7$var$GroupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81bpf _u5f3v77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $685690920ec019b7$var$ShowMoreButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1b66 _19bvgrf3 _u5f3grf3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $685690920ec019b7$export$7ed12d2a5241e393 = {
    ShowMoreButton: $685690920ec019b7$var$ShowMoreButton
};

});
parcelRegister("87Kv4", function(module, exports) {

$parcel$export(module.exports, "default", () => $706afbb7dc97e109$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $eGI9v = parcelRequire("eGI9v");

var $fee69 = parcelRequire("fee69");

var $lqalZ = parcelRequire("lqalZ");

var $hficN = parcelRequire("hficN");

var $dKDgR = parcelRequire("dKDgR");
const $706afbb7dc97e109$export$ac90a5534d384989 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $eGI9v.default)('webLinkCard', {
    onClick: 'clicked',
    onDelete: 'deleted'
}), (0, $lqalZ.connect)(null, {
    onDelete: (0, $hficN.deleteWebLinkRequest)
}))((0, $dKDgR.default));
const $706afbb7dc97e109$export$e612ec082dda38 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
        id: "^web-links-card-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($706afbb7dc97e109$export$ac90a5534d384989, props));
var $706afbb7dc97e109$export$2e2bcd8739ae039 = $706afbb7dc97e109$export$e612ec082dda38;

});
parcelRegister("dKDgR", function(module, exports) {

$parcel$export(module.exports, "default", () => $787be13a5d2bc63f$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $aml13 = parcelRequire("aml13");

var $1ybV0 = parcelRequire("1ybV0");

var $9XfZZ = parcelRequire("9XfZZ");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $h49rE = parcelRequire("h49rE");

var $ivuMa = parcelRequire("ivuMa");

var $7qm3W = parcelRequire("7qm3W");

var $e2oK3 = parcelRequire("e2oK3");
const $787be13a5d2bc63f$var$WebLinkLineCardGroup = (props)=>{
    const [deleteModalOpen, setDeleteModalOpen] = (0, $eUqFw.useState)(false);
    const [deleteLinkId, setDeleteLinkId] = (0, $eUqFw.useState)(null);
    const smartCardProviderProduct = (0, $9XfZZ.useSmartCardProductType)();
    const isAIFeatureEnabled = (0, $9XfZZ.useSmartCardIsAIEnabled)();
    const openDeleteModal = (id)=>{
        setDeleteModalOpen(true);
        setDeleteLinkId(id);
    };
    const openDeleteModalCallback = (0, $eUqFw.useCallback)((id)=>openDeleteModal(id), []);
    const closeDeleteModal = ()=>{
        setDeleteModalOpen(false);
        setDeleteLinkId(null);
    };
    const onDeleteConfirm = ()=>{
        if (deleteLinkId) props.onDelete(deleteLinkId);
        closeDeleteModal();
    };
    const onDeleteCancel = closeDeleteModal;
    const { canDelete: canDelete } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($787be13a5d2bc63f$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (analyticsEvent)=>(0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'webLinkLineCardGroup rendered', {
                linkCount: props.links.length
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qm3W.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), (0, $1ybV0.ff)('platform.linking-platform.smart-card.hover-card-ai-summaries') && {
        product: smartCardProviderProduct,
        isAdminHubAIEnabled: isAIFeatureEnabled
    }, props.links.map((link)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h49rE.default), {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            key: link.smartLinkId || link.id,
            analyticsLocation: (0, $ivuMa.JiraSmartLinkLocations).JIRA_WEB_LINKS,
            linkId: link.id,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            smartLinkId: link.smartLinkId || link.id,
            isCreateFailed: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            link.isCreateFailed || false,
            isCreateFailedLimitExceeded: (0, $1ybV0.ff)('issue.details.hard-limits.issue-weblinks-limit') && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            link.isCreateFailedLimitExceeded || false,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            deleteFailed: link.deleteFailed,
            canDelete: canDelete,
            onDeleteClick: openDeleteModalCallback,
            url: link.href,
            text: link.linkText !== undefined && link.href !== link.linkText ? link.linkText : undefined,
            onClick: props.onClick
        })))), deleteModalOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e2oK3.default), {
        onDelete: onDeleteConfirm,
        onCancel: onDeleteCancel
    }) : null);
};
var $787be13a5d2bc63f$export$2e2bcd8739ae039 = $787be13a5d2bc63f$var$WebLinkLineCardGroup;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $787be13a5d2bc63f$var$StyledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_q8c9hloo",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e2oK3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a911ed2308394233$export$2e2bcd8739ae039);

var $cPElk = parcelRequire("cPElk");
var $a911ed2308394233$export$2e2bcd8739ae039 = (0, $cPElk.DeleteModal);

});
parcelRegister("cPElk", function(module, exports) {

$parcel$export(module.exports, "DeleteModal", () => $d7031d397e50376a$export$73392e09138fecd6);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $jPfP5 = parcelRequire("jPfP5");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dH1SZ = parcelRequire("dH1SZ");
const $d7031d397e50376a$export$73392e09138fecd6 = ({ onDelete: onDelete, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const headerMessage = formatMessage((0, $dH1SZ.messages).headerMessage);
    const contentMessage = formatMessage((0, $dH1SZ.messages).contentMessage);
    const confirmActionText = formatMessage((0, $dH1SZ.messages).confirmActionText);
    const cancelActionText = formatMessage((0, $dH1SZ.messages).cancelActionText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPfP5.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onCancel,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "danger"
    }, headerMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, contentMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: onDelete,
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.common.web-link-line-card-group.delete-modal.confirm-button",
        interactionName: "auto-generated.issue.views.common.web-link-line-card-group.delete-modal.confirm-button.button"
    }, confirmActionText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: onCancel,
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.common.web-link-line-card-group.delete-modal.cancel-button",
        interactionName: "auto-generated.issue.views.common.web-link-line-card-group.delete-modal.cancel-button.button1"
    }, cancelActionText)))));
};
var $d7031d397e50376a$export$2e2bcd8739ae039 = $d7031d397e50376a$export$73392e09138fecd6;

});
parcelRegister("dH1SZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $621b790abe377813$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $621b790abe377813$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    headerMessage: {
        "id": "issue.details.web-links.delete-confirmation-modal.title",
        "defaultMessage": "Delete the web link?"
    },
    contentMessage: {
        "id": "issue.details.web-links.delete-confirmation-modal.content",
        "defaultMessage": "You can add the link later again if you need to."
    },
    confirmActionText: {
        "id": "issue.details.web-links.delete-confirmation-modal.confirmation-text",
        "defaultMessage": "Delete"
    },
    cancelActionText: {
        "id": "issue.details.web-links.delete-confirmation-modal.cancellation-text",
        "defaultMessage": "Cancel"
    }
});
var $621b790abe377813$export$2e2bcd8739ae039 = $621b790abe377813$export$defe85febe8b728c;

});





parcelRegister("aDvCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cb861648cbb1687$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4ksts = parcelRequire("4ksts");

var $81vFI = parcelRequire("81vFI");

var $eWtYW = parcelRequire("eWtYW");
const $9cb861648cbb1687$var$AddButton = ({ onClick: onClick })=>{
    const intl = (0, $4ksts.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9cb861648cbb1687$var$RightSideContainer, {
        "data-testId": "issue.views.issue-base.content.web-links.add-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $81vFI.default), {
        label: intl.formatMessage((0, $eWtYW.messages).label),
        onClick: onClick
    }));
};
var $9cb861648cbb1687$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $9cb861648cbb1687$var$AddButton;
const $9cb861648cbb1687$var$RightSideContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eWtYW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $175af9892962509a$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $175af9892962509a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    label: {
        "id": "issue.web-links-add-label",
        "defaultMessage": "Link to a web page"
    }
});

});


parcelRegister("gDZxA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d966266a956c2580$export$2e2bcd8739ae039);

var $eGI9v = parcelRequire("eGI9v");
var $8un0w = parcelRequire("8un0w");

var $5G3JL = parcelRequire("5G3JL");

var $lqalZ = parcelRequire("lqalZ");

var $hficN = parcelRequire("hficN");

var $6gpYd = parcelRequire("6gpYd");

var $6vrw7 = parcelRequire("6vrw7");

var $9xYsA = parcelRequire("9xYsA");
const $d966266a956c2580$var$analyticsProps = {
    onCancel: 'webLinkCancel'
};
var $d966266a956c2580$export$2e2bcd8739ae039 = (0, $5G3JL.flowWithSafeComponent)((0, $eGI9v.default)('button', {
    onSubmit: 'clicked',
    onCancel: 'clicked'
}), (0, $8un0w.default)($d966266a956c2580$var$analyticsProps), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ linkedPagesCount: number; createLinkClickedCount: number; } & { onCancel: () => { type: "HIDE_CREATE_WEB_LINK_FORM"; }; onSubmit: (link: string, linkText: string, iconUrl: string) => { ...; }; }, {}>' is not assignable to parameter of type 'FlowStep<WithUIAnalyticsEvent<PropsWithoutRef<Omit<{ [K in keyof Props]: K extends "onSubmit" | "onCancel" ? (...args: [...Parameters<Props[K]>, UIAnalyticsEvent]) => ReturnType<Props[K]> : Props[K]; }, keyof WithAnalyticsEventsProps>>, { ...; }>, ConnectedComponent<...>>'.
(0, $lqalZ.connect)((state)=>({
        linkedPagesCount: (0, $6gpYd.webLinksCountSelector)(state),
        createLinkClickedCount: (0, $6gpYd.createWebLinkClickedCountSelector)(state)
    }), (dispatch)=>({
        onCancel: ()=>dispatch((0, $hficN.hideCreateWebLinkForm)()),
        onSubmit: (link, linkText, iconUrl)=>dispatch((0, $hficN.createWebLinkRequest)((0, $6vrw7.toHref)(link), linkText, iconUrl))
    })))((0, $9xYsA.default));

});
parcelRegister("9xYsA", function(module, exports) {

$parcel$export(module.exports, "default", () => $869d31ed4fa2fdda$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8blac = parcelRequire("8blac");

var $llwDE = parcelRequire("llwDE");

var $aml13 = parcelRequire("aml13");

var $f8Yej = parcelRequire("f8Yej");

var $5JgJ2 = parcelRequire("5JgJ2");

var $autRb = parcelRequire("autRb");

var $ivuMa = parcelRequire("ivuMa");

var $hzcvF = parcelRequire("hzcvF");

var $hh4Ra = parcelRequire("hh4Ra");

var $9P6NK = parcelRequire("9P6NK");

var $eyDV5 = parcelRequire("eyDV5");

var $aS2CG = parcelRequire("aS2CG");
const $869d31ed4fa2fdda$export$a1176d166defe27f = ({ linkedPagesCount: linkedPagesCount, createLinkClickedCount: createLinkClickedCount, onSubmit: onSubmit, onCancel: onCancel })=>{
    const [href, setHref] = (0, $eUqFw.useState)('');
    const [linkText, setLinkText] = (0, $eUqFw.useState)('');
    const [isDisabled, setIsDisabled] = (0, $eUqFw.useState)(true);
    const [isHrefValid, setisHrefValid] = (0, $eUqFw.useState)(true);
    const linkAnalytics = (0, $llwDE.useSmartLinkLifecycleAnalytics)();
    // using previous values for properties passed down into functions which
    // were using prevProps
    const prevCreateLinkClickedCount = (0, $hzcvF.usePrevious)(createLinkClickedCount);
    const prevLinkedPagesCount = (0, $hzcvF.usePrevious)(linkedPagesCount);
    const childContainer = (0, $eUqFw.useRef)(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const focusOnInput = ()=>{
        if (childContainer.current !== null) {
            const input = childContainer.current.querySelector('input');
            if (input !== null) input.focus({
                preventScroll: true
            });
        }
    };
    const updateDisabledState = (0, $eUqFw.useCallback)((ref)=>{
        const isDisabledLocal = (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(ref) || !(0, $hh4Ra.validateUrl)(ref);
        setIsDisabled(isDisabledLocal);
    }, []);
    const mounted = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (!mounted.current) {
            mounted.current = true;
            (0, $autRb.smoothScrollIntoCenterIfNeeded)(childContainer.current);
            updateDisabledState(href);
        } else {
            if (createLinkClickedCount !== prevCreateLinkClickedCount) {
                (0, $autRb.smoothScrollIntoCenterIfNeeded)(childContainer.current);
                focusOnInput();
            }
            if (prevLinkedPagesCount !== undefined && linkedPagesCount > prevLinkedPagesCount) {
                setHref('');
                setisHrefValid(true);
                setLinkText('');
                setIsDisabled(true);
                focusOnInput();
            }
        }
    }, [
        createLinkClickedCount,
        href,
        linkedPagesCount,
        prevCreateLinkClickedCount,
        prevLinkedPagesCount,
        updateDisabledState
    ]);
    const onHrefChange = (0, $eUqFw.useCallback)((e)=>{
        const hrefFromEvent = e.target.value;
        updateDisabledState(hrefFromEvent);
        setHref(hrefFromEvent);
        setisHrefValid((0, $hh4Ra.validateUrl)(hrefFromEvent));
    }, [
        updateDisabledState
    ]);
    const onLinkTextChange = (0, $eUqFw.useCallback)((e)=>{
        // there is a character limit on the endpoint of 255 for the title
        const linkTextFromEvent = e.target.value.slice(0, 255);
        if (linkTextFromEvent !== linkText) {
            updateDisabledState(href);
            setLinkText(linkTextFromEvent);
        }
    }, [
        href,
        linkText,
        updateDisabledState
    ]);
    const sendSmartLinkCreatedEvent = (0, $eUqFw.useCallback)((url)=>{
        const details = {
            url: url
        };
        linkAnalytics?.linkCreated(details, null, (0, $ivuMa.webLinksAnalyticAttributes));
    }, [
        linkAnalytics
    ]);
    const handleOnSubmit = (0, $eUqFw.useCallback)(()=>{
        const trimmedHref = href.trim();
        const httpHref = (0, $hh4Ra.prependHttp)(trimmedHref);
        const iconUrl = (0, $hh4Ra.getFavIconUrl)(httpHref);
        onSubmit(httpHref, (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(linkText.trim()) ? httpHref : linkText.trim(), iconUrl);
        sendSmartLinkCreatedEvent(httpHref);
    }, [
        href,
        linkText,
        onSubmit,
        sendSmartLinkCreatedEvent
    ]);
    const closeAndReset = ()=>{
        setHref('');
        setisHrefValid(true);
        setLinkText('');
        setIsDisabled(true);
        onCancel();
    };
    const onEnter = isDisabled ? null : handleOnSubmit;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: childContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
        onEscape: closeAndReset,
        onEnter: onEnter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9P6NK.default), {
        href: href,
        linkText: linkText,
        isHrefValid: isHrefValid,
        onHrefChange: onHrefChange,
        onLinkTextChange: onLinkTextChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($869d31ed4fa2fdda$var$ButtonsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aS2CG.StyledButton), {
        appearance: "primary",
        onClick: handleOnSubmit,
        isDisabled: isDisabled,
        testId: "issue.views.issue-base.content.web-links.create-link.submit-button"
    }, formatMessage((0, $eyDV5.default).linkButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aS2CG.StyledButton), {
        appearance: "subtle",
        onClick: closeAndReset,
        testId: "issue.views.issue-base.content.web-links.create-link.cancel-button"
    }, formatMessage((0, $eyDV5.default).cancelButton))));
};
const $869d31ed4fa2fdda$var$WebLinkCreateLinkViewWithSmartCardProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($869d31ed4fa2fdda$export$a1176d166defe27f, props));
var $869d31ed4fa2fdda$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $869d31ed4fa2fdda$var$WebLinkCreateLinkViewWithSmartCardProvider;
const $869d31ed4fa2fdda$var$ButtonsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hh4Ra", function(module, exports) {

$parcel$export(module.exports, "getFavIconUrl", () => $db6d9107bb48b676$export$be8832f860ab7aa0);
$parcel$export(module.exports, "validateUrl", () => $db6d9107bb48b676$export$52213319c01858f);
$parcel$export(module.exports, "prependHttp", () => $db6d9107bb48b676$export$b9a79b9e9f921305);

var $k4nIh = parcelRequire("k4nIh");

var $6vrw7 = parcelRequire("6vrw7");
const $db6d9107bb48b676$var$FALLBACK_HOST_NAME = 'null';
const $db6d9107bb48b676$export$be8832f860ab7aa0 = (href)=>{
    const { origin: origin } = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(href.trim(), $db6d9107bb48b676$var$FALLBACK_HOST_NAME);
    const iconUrl = origin === $db6d9107bb48b676$var$FALLBACK_HOST_NAME ? '' : `${origin}/favicon.ico`;
    return (0, $6vrw7.toHref)(iconUrl);
};
const $db6d9107bb48b676$export$52213319c01858f = (url)=>{
    const sanitisedUrl = url.trim();
    // Obtain the protocol that precedes ://
    const urlMatch = sanitisedUrl.match(/^.+:\/\//);
    const protocol = urlMatch ? urlMatch[0] : urlMatch;
    const minUrlLength = 2;
    // Only allow no-protocol AND http:// AND https:// protocols as valid url links
    if (![
        null,
        'http://',
        'https://'
    ].includes(protocol)) return false;
    // Check the URL length (characters after protocol is minUrlLength or greater).
    if (sanitisedUrl.length < minUrlLength + (protocol?.length || 0)) return false;
    return true;
};
const $db6d9107bb48b676$export$b9a79b9e9f921305 = (url)=>{
    // Check if the URL already starts with http:// OR https://
    if (/^https?:\/\//.test(url)) return url;
    return `http://${url}`;
};

});

parcelRegister("9P6NK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c31e4e7c87388aef$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $96IgR = parcelRequire("96IgR");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eYM9c = parcelRequire("eYM9c");

var $dZpFC = parcelRequire("dZpFC");

var $gjWQx = parcelRequire("gjWQx");
const $c31e4e7c87388aef$var$URL_PLACEHOLDER = 'https://www.example.com';
const $c31e4e7c87388aef$export$43661d6e0d58287b = (props)=>{
    const [isHrefFocused, setIsHrefFocused] = (0, $eUqFw.useState)(true);
    const { href: href, linkText: linkText, onHrefChange: onHrefChange, onLinkTextChange: onLinkTextChange, isHrefValid: isHrefValid } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjWQx.TextFieldsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjWQx.HrefFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYM9c.InlineField), {
        value: href,
        headingText: formatMessage((0, $dZpFC.default).url),
        autoFocus: true,
        placeholder: $c31e4e7c87388aef$var$URL_PLACEHOLDER,
        onChange: onHrefChange,
        onBlur: ()=>{
            setIsHrefFocused(false);
        },
        onFocus: ()=>setIsHrefFocused(true),
        isInvalid: !isHrefValid,
        testId: "issue.views.issue-base.content.web-links.create-link.inline-fields.url"
    }), !isHrefValid && !isHrefFocused && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c31e4e7c87388aef$var$ErrorContainer, {
        colour: `var(--ds-text-danger, ${(0, $PdmhA).R400})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: formatMessage((0, $dZpFC.default).errorIconLabel),
        role: "presentation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjWQx.ErrorLabel), null, formatMessage((0, $dZpFC.default).invalidUrlMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjWQx.LinkTextFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYM9c.InlineField), {
        value: linkText,
        headingText: formatMessage((0, $dZpFC.default).linkText),
        autoFocus: false,
        placeholder: formatMessage((0, $dZpFC.default).linkTextPlaceholder),
        onChange: onLinkTextChange,
        testId: "issue.views.issue-base.content.web-links.create-link.inline-fields.text"
    })));
};
var $c31e4e7c87388aef$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $c31e4e7c87388aef$export$43661d6e0d58287b;
const $c31e4e7c87388aef$var$ErrorContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { colour: colour, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1mvk55v": (0, $9t7rW.default)(__cmplp.colour)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _syazt84y _1e0c1txw _19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eYM9c", function(module, exports) {

$parcel$export(module.exports, "InlineField", () => $c0cc13ee24ca633b$export$f30174d63e654145);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jFtVs = parcelRequire("jFtVs");

var $6ROLN = parcelRequire("6ROLN");

var $cf2Y4 = parcelRequire("cf2Y4");

var $gYYP4 = parcelRequire("gYYP4");
const $c0cc13ee24ca633b$export$f30174d63e654145 = ({ headingText: headingText, ...TextfieldProps })=>{
    const typeInstrumentationRef = (0, $gYYP4.default)('create-web-link-inline-field-type-tracing');
    const uid = (0, $jFtVs.useUID)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c0cc13ee24ca633b$var$TextFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ROLN.Label), {
        htmlFor: uid
    }, headingText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        id: uid,
        ref: typeInstrumentationRef,
        ...TextfieldProps
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c0cc13ee24ca633b$var$TextFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dZpFC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2709c4dde58518d$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $b2709c4dde58518d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    url: {
        "id": "issue.views.web-links.addLink.label.url",
        "defaultMessage": "URL"
    },
    linkText: {
        "id": "issue.views.web-links.addLink.label.linkText",
        "defaultMessage": "Link text"
    },
    linkTextPlaceholder: {
        "id": "issue.views.web-links.addLink.label.linkTextPlaceholder",
        "defaultMessage": "Add a description..."
    },
    invalidUrlMessage: {
        "id": "issue.views.web-links.addLink.label.invalidUrlMessage",
        "defaultMessage": "Enter a valid URL starting with http:// or https://"
    },
    errorIconLabel: {
        "id": "issue.views.web-links.addLink.label.errorIcon",
        "defaultMessage": "Error icon"
    }
});

});

parcelRegister("gjWQx", function(module, exports) {

$parcel$export(module.exports, "TextFieldsWrapper", () => $59bbfea4f4399179$export$5248c577fbdf684a);
$parcel$export(module.exports, "HrefFieldWrapper", () => $59bbfea4f4399179$export$dae17c618bcafb83);
$parcel$export(module.exports, "LinkTextFieldWrapper", () => $59bbfea4f4399179$export$9771ad722ed3d50c);
$parcel$export(module.exports, "ErrorLabel", () => $59bbfea4f4399179$export$e7a98f51c6efe634);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $59bbfea4f4399179$export$5248c577fbdf684a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkpxbi _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $59bbfea4f4399179$export$dae17c618bcafb83 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $59bbfea4f4399179$export$9771ad722ed3d50c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $59bbfea4f4399179$export$e7a98f51c6efe634 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});


parcelRegister("eyDV5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ae193d050e991b8$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $2ae193d050e991b8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    linkButton: {
        "id": "issue.views.web-links.link.link-button",
        "defaultMessage": "Link"
    },
    cancelButton: {
        "id": "issue.views.web-links.link.cancel-button",
        "defaultMessage": "Cancel"
    }
});

});

parcelRegister("aS2CG", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $7287c96f95ab5b8e$export$2d5d2ba3c7c8c40b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $7287c96f95ab5b8e$export$8f61661844809585 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $7287c96f95ab5b8e$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01a66",
            __cmplp.className
        ])
    });
});

});





parcelRegister("jo88D", function(module, exports) {

$parcel$export(module.exports, "withGICHook", () => $eb570c95949e3de5$export$f9023df7ec428196);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");
parcelRequire("3VVr2");
var $agEEp = parcelRequire("agEEp");

var $ca2LP = parcelRequire("ca2LP");

var $ctR9z = parcelRequire("ctR9z");

var $guDlK = parcelRequire("guDlK");
const $eb570c95949e3de5$export$f9023df7ec428196 = (ContentItemsComponent)=>(props)=>{
        const [{ isModalOpen: isModalOpen, callbackPayload: callbackPayload }] = (0, $ctR9z.useTriggerIssueCreateModal)();
        const { childIssuesPanelType: childIssuesPanelType } = callbackPayload?.data || {};
        const getRenderComponentValue = (0, $eUqFw.useCallback)(()=>{
            if (!isModalOpen) return false;
            switch(childIssuesPanelType){
                case 0, $agEEp.CHILDREN_ISSUES_PANEL:
                case 0, $agEEp.CLASSIC_SUBTASKS:
                case 0, $agEEp.CLASSIC_PORTFOLIO_CHILDREN:
                    return childIssuesPanelType;
                default:
                    return false;
            }
        }, [
            childIssuesPanelType,
            isModalOpen
        ]);
        const [renderChildComponent, setRenderChildComponent] = (0, $eUqFw.useState)(getRenderComponentValue());
        (0, $eUqFw.useEffect)(()=>{
            const newRenderChildValue = getRenderComponentValue();
            if (newRenderChildValue !== false) setRenderChildComponent(newRenderChildValue);
        }, [
            getRenderComponentValue
        ]);
        const projectKey = (0, $hJ992.useProjectKey)();
        const isSimplifiedProject = (0, $guDlK.useIsSimplifiedProject)(projectKey);
        const shouldSuggestAiIssues = !props.isEpic ? (0, $ca2LP.useShouldTriggerAiSuggestedIssues)() : false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContentItemsComponent, {
            ...props,
            shouldRenderSubtasks: props.shouldRenderSubtasks || renderChildComponent === (0, $agEEp.CLASSIC_SUBTASKS) || !isSimplifiedProject && shouldSuggestAiIssues,
            shouldRenderChildrenIssues: props.shouldRenderChildrenIssues || renderChildComponent === (0, $agEEp.CHILDREN_ISSUES_PANEL) || isSimplifiedProject && shouldSuggestAiIssues,
            shouldRenderPortfolioChildrenIssues: props.shouldRenderPortfolioChildrenIssues || renderChildComponent === (0, $agEEp.CLASSIC_PORTFOLIO_CHILDREN)
        });
    };

});

parcelRegister("hdX7K", function(module, exports) {

$parcel$export(module.exports, "IssueSectionWrapper", () => $30981ebee2802ed2$export$950f99289559148e);
$parcel$export(module.exports, "ContentItemsWrapper", () => $30981ebee2802ed2$export$ef1638905e8ef2c8);
$parcel$export(module.exports, "CollapsedSectionWrapper", () => $30981ebee2802ed2$export$7806ed28d6a71699);
/* issue-layout.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bAQOb = parcelRequire("bAQOb");
const $30981ebee2802ed2$export$950f99289559148e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompactMode: isCompactMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isCompactMode ? "_19pkv47k" : "_19pk1jfw",
            __cmplp.className
        ])
    });
});
const $30981ebee2802ed2$export$ef1638905e8ef2c8 = (0, $bAQOb.componentWithFF)('issue-view-fit-and-finish-full-page-milestone2_ebk0i', /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompactMode: isCompactMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !__cmplp.isCompactMode && "_19pkpxbi",
            __cmplp.className
        ])
    });
}), /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompactMode: isCompactMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !__cmplp.isCompactMode && "_19pku2gc",
            __cmplp.className
        ])
    });
}));
const $30981ebee2802ed2$export$7806ed28d6a71699 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompactMode: isCompactMode, isPanelCollapsed: isPanelCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isCompactMode || __cmplp.isPanelCollapsed ? "_otyrpxbi" : "_otyr1jfw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dtfgR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b427b5b12414233$export$2e2bcd8739ae039);
/* content-panel-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $hI5oG = parcelRequire("hI5oG");
parcelRequire("eo4Zu");
var $14gc1 = parcelRequire("14gc1");

var $adX4B = parcelRequire("adX4B");

var $4lxPQ = parcelRequire("4lxPQ");

var $jLerq = parcelRequire("jLerq");

var $1ybV0 = parcelRequire("1ybV0");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $eyYNo = parcelRequire("eyYNo");

var $autRb = parcelRequire("autRb");

var $duMa0 = parcelRequire("duMa0");

var $iAc02 = parcelRequire("iAc02");

var $2V7AK = parcelRequire("2V7AK");

var $lqalZ = parcelRequire("lqalZ");

var $lWUtg = parcelRequire("lWUtg");

var $bCaZl = parcelRequire("bCaZl");

var $8CSFK = parcelRequire("8CSFK");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $9Gbnl = parcelRequire("9Gbnl");
/* eslint-disable jira/i18n/id-named-by-package */ const $0b427b5b12414233$var$messages = (0, $90IgZ.defineMessages)({
    actions: {
        "id": "issue.content.ecosystem-panels.meatballs.actions",
        "defaultMessage": "Actions"
    },
    hide: {
        "id": "issue.content.ecosystem-panels.meatballs.hide",
        "defaultMessage": "Hide {appName}"
    },
    collapse: {
        "id": "issue.content.ecosystem-panels.collapse-content",
        "defaultMessage": "hide"
    },
    expand: {
        "id": "issue.content.ecosystem-panels.expand-content",
        "defaultMessage": "show"
    }
});
const $0b427b5b12414233$var$EMPTY_PANEL = {
    appKey: '',
    moduleKey: '',
    name: '',
    showByDefault: false,
    type: '',
    options: {}
};
const $0b427b5b12414233$export$461b8c2ef570a414 = ({ isSelected: isSelected = false, unSelectContentPanel: unSelectContentPanel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), removeContentPanel: removeContentPanel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), name: name, appKey: appKey, moduleKey: moduleKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const contentPanelContainer = (0, $eUqFw.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const refreshedOn = (0, $eyYNo.useOnDemandIssueRefreshTime)();
    const contentPanel = (0, $2V7AK.useEcosystemContentPanel)(appKey, moduleKey);
    const setupConnectHost = (host)=>{
        if (host) host.onIframeUnload(({ extension: extension })=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            host.destroy(extension.id);
        });
    };
    const [connectHost, setConnectHost] = (0, $eUqFw.useState)(()=>{
        setupConnectHost(window.connectHost);
        return window.connectHost;
    });
    const [isCollapsed, setIsCollapsed] = (0, $eUqFw.useState)((0, $lWUtg.getCollapsedPanels)().includes((0, $duMa0.removeTimestamp)(`${appKey}_${moduleKey}`, 10)));
    (0, $eUqFw.useEffect)(()=>{
        if (!connectHost) (0, $4lxPQ.withConnectHost)((host)=>{
            setupConnectHost(host);
            setConnectHost(host);
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (isSelected) {
            (0, $autRb.smoothScrollIntoCenterIfNeeded)(contentPanelContainer.current);
            unSelectContentPanel(`${appKey}_${moduleKey}`);
        }
    }, [
        appKey,
        isSelected,
        moduleKey,
        unSelectContentPanel
    ]);
    const handleRemoveContentPanel = (0, $eUqFw.useCallback)(()=>{
        removeContentPanel(`${appKey}_${moduleKey}`);
    }, [
        appKey,
        moduleKey,
        removeContentPanel
    ]);
    const toggleCollapsedState = (0, $eUqFw.useCallback)(()=>{
        setIsCollapsed((collapsedVal)=>{
            const contentPanelKey = (0, $duMa0.removeTimestamp)(`${appKey}_${moduleKey}`, 10);
            if (collapsedVal) (0, $lWUtg.unsetCollapsedPanel)(contentPanelKey);
            else (0, $lWUtg.setCollapsedPanel)(contentPanelKey);
            return !collapsedVal;
        });
    }, [
        appKey,
        moduleKey
    ]);
    const meatBallMenu = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Gbnl.MeatBallMenu), {
            testId: "issue-view-ecosystem.connect.meat-ball-menu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
            title: formatMessage($0b427b5b12414233$var$messages.actions)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            onClick: handleRemoveContentPanel,
            testId: "issue-view-ecosystem.connect.dropdown-item-hide"
        }, formatMessage($0b427b5b12414233$var$messages.hide, {
            appName: name
        })))), [
        formatMessage,
        handleRemoveContentPanel,
        name
    ]);
    const { options: options, options: { url: url, origin: origin }, showByDefault: showByDefault } = // during issue transition "backwards" Redux store is restored "instantly" creating a possibility for panel data not being yet in sweet-state
    // we default to an "empty object" to prevent errors
    /// FIXME: use sweet-state for higher selection or bailout early in the parent component
    contentPanel || $0b427b5b12414233$var$EMPTY_PANEL;
    const header = (0, $eUqFw.useMemo)(()=>{
        if (!showByDefault) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b427b5b12414233$var$LeftAligned, {
            "data-component-selector": $0b427b5b12414233$var$leftAlignedSelectorName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
            size: "xsmall",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b427b5b12414233$var$TitleH2, null, name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b427b5b12414233$var$RightAligned, null, meatBallMenu));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b427b5b12414233$var$LeftAligned, {
            "data-component-selector": $0b427b5b12414233$var$leftAlignedSelectorName,
            clickable: true,
            onClick: toggleCollapsedState
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
            size: "xsmall",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b427b5b12414233$var$TitleH2, null, name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b427b5b12414233$var$Hint, {
            alwaysShow: isCollapsed
        }, isCollapsed ? formatMessage($0b427b5b12414233$var$messages.expand) : formatMessage($0b427b5b12414233$var$messages.collapse))), showByDefault ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b427b5b12414233$var$RightAligned, null, meatBallMenu));
    }, [
        showByDefault,
        formatMessage,
        isCollapsed,
        meatBallMenu,
        name,
        toggleCollapsedState
    ]);
    const connectIframeProvider = new (0, $adX4B.default)({
        isAutoresizeBugfixEnabled: true
    }); // If url contains the JWT, valid the JWT before loading the Iframe
    const isJwtExpired = url && connectHost && connectHost.hasJwt?.(url) && connectHost.isJwtExpired?.(url);
    (0, $eUqFw.useEffect)(()=>{
        if (isJwtExpired) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'ConnectIframe expired', {
            location: 'ContentPanel'
        });
    }, [
        isJwtExpired,
        createAnalyticsEvent
    ]);
    const issueId = (0, $hJ992.useIssueId)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const hasCorrectIssueInformation = (0, $2V7AK.useIsEcosystemDataLoadedFor)(issueKey);
    const connectKeyIssueId = `connect-iFrame-${origin}-${issueId}-${refreshedOn}`;
    const connectKeyIssueKey = `connect-iFrame-${origin}-${issueKey}-${refreshedOn}`;
    if ((0, $1ybV0.ff)('issue.details.connect-iframe-analytics')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eUqFw.useEffect)(()=>{
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'ConnectContentPanel loaded');
        }, [
            createAnalyticsEvent
        ]); // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eUqFw.useEffect)(()=>{
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'ConnectContentPanel updated');
        }, [
            connectKeyIssueKey,
            createAnalyticsEvent
        ]);
    } // there is a situation when during SPA transition:
    // - issueId is yet undefined
    // - contentPanel is different between states, including not yet being present
    const renderUnblocked = contentPanel && connectHost && Boolean(issueId) && hasCorrectIssueInformation;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: contentPanelContainer,
        "data-testid": `issue-view-ecosystem.connect.content-panel.${appKey}__${moduleKey}`
    }, header, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b427b5b12414233$var$Container, {
        isCollapsed: isCollapsed && showByDefault
    }, renderUnblocked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $14gc1.ConnectIframe // @TODO JIV-17989 replace connectKeyIssueId with connectKeyIssueKey
    ), {
        key: connectKeyIssueId,
        connectHost: connectHost,
        appKey: appKey,
        moduleKey: moduleKey,
        url: url,
        options: connectIframeProvider.convertConnectOptions(options),
        connectIframeProvider: connectIframeProvider,
        width: "100%",
        height: "100%" // @ts-expect-error - TS2322 - Type '() => JSX.Element' is not assignable to type 'new () => PureComponent<{ failedCallback: Function; }, {}, any>'.
        ,
        timeoutIndicator: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jLerq.EcosystemTimeoutViewAsync), {
                appName: contentPanel.name,
                appKey: appKey
            })
    })));
};
var $0b427b5b12414233$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state, ownProps)=>({
        isSelected: (0, $8CSFK.selectedContentPanelSelector)(ownProps.appKey, ownProps.moduleKey)(state)
    }), (dispatch)=>({
        unSelectContentPanel: (addonModuleKey)=>{
            dispatch((0, $bCaZl.contentPanelUnselect)(addonModuleKey));
        },
        removeContentPanel: (addonModuleKey)=>{
            dispatch((0, $bCaZl.removeContentPanelRequest)(addonModuleKey));
        }
    }))($0b427b5b12414233$export$461b8c2ef570a414);
const $0b427b5b12414233$var$leftAlignedSelectorName = 'jira-issue-view-issue-base-ecosystem-left-aligned';
const $0b427b5b12414233$var$LEFT_ALIGNED_COMPONENT_SELECTOR = `[data-component-selector="${$0b427b5b12414233$var$leftAlignedSelectorName}"]`; // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b427b5b12414233$var$Hint = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { alwaysShow: alwaysShow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1y58 _18u012x7 _8nu01nu9",
            __cmplp.alwaysShow ? "_1e0c1nu9" : "_1e0cglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b427b5b12414233$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCollapsed: isCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _v564cxtv _1ke8ftgi _1suq18uv _aaynrg55 _155a19bv",
            __cmplp.isCollapsed ? "_c71lidpf" : "_c71l19kl",
            __cmplp.isCollapsed ? "_18m915vq" : "_18m91wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b427b5b12414233$var$TitleH2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _syaz1fxt _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b427b5b12414233$var$LeftAligned = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { clickable: clickable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4t3izwfg",
            __cmplp.clickable ? "_80omtlke" : "_80om1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b427b5b12414233$var$RightAligned = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _2lx21sbv _1n261g80 _pof3u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lWUtg", function(module, exports) {

$parcel$export(module.exports, "getCollapsedPanels", () => $bdb1dcc50a351ae3$export$10f6a04e9cdd5331);
$parcel$export(module.exports, "setCollapsedPanel", () => $bdb1dcc50a351ae3$export$32482a43044868e4);
$parcel$export(module.exports, "unsetCollapsedPanel", () => $bdb1dcc50a351ae3$export$3f9a002525b0d94);

var $aZaPn = parcelRequire("aZaPn");

var $gUUjF = parcelRequire("gUUjF");
const $bdb1dcc50a351ae3$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('issue-ecosystem');
const $bdb1dcc50a351ae3$var$COLLAPSED_PANELS = 'collapsed-panels';
const $bdb1dcc50a351ae3$var$LOG_LOCATION = 'issue.ecosystem.local-storage';
const $bdb1dcc50a351ae3$export$10f6a04e9cdd5331 = ()=>{
    try {
        return $bdb1dcc50a351ae3$var$localStorage.get($bdb1dcc50a351ae3$var$COLLAPSED_PANELS) || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData($bdb1dcc50a351ae3$var$LOG_LOCATION, `getCollapsedPanels failed: ${error}`, error);
        return [];
    }
};
const $bdb1dcc50a351ae3$export$32482a43044868e4 = (contentPanelKey)=>{
    const storedKeys = $bdb1dcc50a351ae3$export$10f6a04e9cdd5331();
    try {
        $bdb1dcc50a351ae3$var$localStorage.set($bdb1dcc50a351ae3$var$COLLAPSED_PANELS, [
            ...storedKeys,
            contentPanelKey
        ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData($bdb1dcc50a351ae3$var$LOG_LOCATION, `setCollapsedPanel failed: ${error}`, error);
    }
};
const $bdb1dcc50a351ae3$export$3f9a002525b0d94 = (contentPanelKey)=>{
    const storedKeys = $bdb1dcc50a351ae3$export$10f6a04e9cdd5331();
    try {
        $bdb1dcc50a351ae3$var$localStorage.set($bdb1dcc50a351ae3$var$COLLAPSED_PANELS, storedKeys.filter((key)=>key !== contentPanelKey));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData($bdb1dcc50a351ae3$var$LOG_LOCATION, `unsetCollapsedPanel failed: ${error}`, error);
    }
};

});

parcelRegister("9Gbnl", function(module, exports) {

$parcel$export(module.exports, "MeatBallMenu", () => $aae204e4da4f2bc6$export$b2902e71fd2ed55f);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");

var $jG1wZ = parcelRequire("jG1wZ");

var $4Bees = parcelRequire("4Bees");
const $aae204e4da4f2bc6$export$b2902e71fd2ed55f = ({ children: children, isLoading: isLoading = false, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                iconBefore: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
                    size: "small",
                    testId: "issue-view-ecosystem.common.spinner"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    size: "small",
                    label: "More actions for system-app-tester"
                }),
                appearance: "subtle",
                spacing: "compact",
                testId: testId,
                ref: triggerRef,
                interactionName: "auto-generated.jira-issue-view-ecosystem.common.button"
            })
    }, children));

});


parcelRegister("4lL77", function(module, exports) {

$parcel$export(module.exports, "default", () => $95f0d38bade2bd43$export$2e2bcd8739ae039);
/* content-panel-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $5syGA = parcelRequire("5syGA");

var $gdPSX = parcelRequire("gdPSX");

var $ejygw = parcelRequire("ejygw");

var $cjwhP = parcelRequire("cjwhP");

var $fT83w = parcelRequire("fT83w");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eyYNo = parcelRequire("eyYNo");

var $hdX7K = parcelRequire("hdX7K");

var $autRb = parcelRequire("autRb");

var $iAc02 = parcelRequire("iAc02");

var $lqalZ = parcelRequire("lqalZ");

var $bCaZl = parcelRequire("bCaZl");

var $i7QJO = parcelRequire("i7QJO");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $8QKSg = parcelRequire("8QKSg");

var $9Gbnl = parcelRequire("9Gbnl");

var $bDeRj = parcelRequire("bDeRj");
const $95f0d38bade2bd43$export$b52183d5cfb26dc9 = ({ actions: actions })=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (actions.length === 0) return null;
    const actionsWithLoading = actions.map((action)=>({
            ...action,
            onClick: ()=>{
                setIsLoading(true);
                return action.onClick().finally(()=>{
                    setIsLoading(false);
                });
            }
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Gbnl.MeatBallMenu), {
        testId: "issue-view-ecosystem.forge.meat-ball-menu",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        title: formatMessage((0, $bDeRj.default).title)
    }, actionsWithLoading.map((action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            onClick: action.onClick,
            key: action.key
        }, action.text))));
};
const $95f0d38bade2bd43$export$a8ddbd4c701695a0 = ({ name: name, extension: { environmentType: environmentType, environmentKey: environmentKey }, actions: actions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($95f0d38bade2bd43$var$LeftAligned, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAc02.SectionHeadingTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fT83w.ExtensionTitle), {
        extensionName: name,
        extensionEnvType: environmentType,
        extensionEnvKey: environmentKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($95f0d38bade2bd43$var$RightAligned, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($95f0d38bade2bd43$export$b52183d5cfb26dc9, {
        actions: actions
    })));
const $95f0d38bade2bd43$export$1e37f7692d27ab64 = ({ extensionData: extensionData, source: source, onRemove: onRemove, appKey: appKey, moduleKey: moduleKey, issueKey: issueKey, isNewToIssue: isNewToIssue, name: name, isPanelCollapsed: isPanelCollapsed, ...restProps })=>{
    const { extension: extension, panelKey: panelKey, isJustAdded: isJustAdded, isCompactMode: isCompactMode, removeFromJustAdded: removeFromJustAdded, removeFromNewPanels: removeFromNewPanels, updatePanel: updatePanel, userCanSaveIssuePanel: userCanSaveIssuePanel } = restProps;
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        if (isJustAdded && wrapperRef && wrapperRef.current) {
            (0, $autRb.smoothScrollIntoCenterIfNeeded)(wrapperRef.current);
            removeFromJustAdded(panelKey);
        }
    }, [
        isJustAdded,
        panelKey,
        removeFromJustAdded
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            if (isNewToIssue) removeFromNewPanels(panelKey);
        }, [
        isNewToIssue,
        panelKey,
        removeFromNewPanels
    ]);
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            source: source,
            isNewToIssue: isNewToIssue
        }), [
        isNewToIssue,
        source
    ]);
    const [customActions, setCustomActions] = (0, $eUqFw.useState)([]);
    const removeAction = (0, $eUqFw.useMemo)(()=>({
            onClick: ()=>{
                (0, $gdPSX.fireUiRemoveClickedEvent)(source);
                onRemove(panelKey);
                return Promise.resolve();
            },
            text: formatMessage((0, $bDeRj.default).remove),
            key: 'internal__remove-action'
        }), [
        formatMessage,
        onRemove,
        panelKey,
        source
    ]);
    const setPanelCollapse = (0, $eUqFw.useCallback)((collapsed)=>{
        (0, $gdPSX.fireUiCollapseExpandClickedEvent)(source, {
            collapsed: collapsed
        });
        if (collapsed) setCustomActions([]);
        updatePanel({
            issueKey: issueKey,
            panelKey: panelKey,
            collapsed: collapsed
        });
        return Promise.resolve();
    }, [
        issueKey,
        panelKey,
        source,
        updatePanel
    ]);
    const expandAction = (0, $eUqFw.useMemo)(()=>({
            onClick: ()=>setPanelCollapse(false),
            text: formatMessage((0, $bDeRj.default).expand),
            key: 'internal__expand-action'
        }), [
        formatMessage,
        setPanelCollapse
    ]);
    const collapseAction = (0, $eUqFw.useMemo)(()=>({
            onClick: ()=>setPanelCollapse(true),
            text: formatMessage((0, $bDeRj.default).collapse),
            key: 'internal__collapse-action'
        }), [
        formatMessage,
        setPanelCollapse
    ]);
    const changeCollapseAction = isPanelCollapsed ? expandAction : collapseAction;
    const actions = [
        // based on docs we show only up to 5 custom actions
        ...customActions.slice(0, 5).map((action)=>({
                ...action,
                onClick: ()=>{
                    (0, $gdPSX.fireUiActionClickedEvent)(source);
                    return action.onClick();
                }
            })),
        ...!userCanSaveIssuePanel ? [] : [
            changeCollapseAction,
            removeAction
        ]
    ];
    const extendedExtensionData = (0, $eUqFw.useMemo)(()=>({
            ...extensionData,
            isNewToIssue: isNewToIssue
        }), [
        isNewToIssue,
        extensionData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: wrapperRef,
        "data-testid": "issue-view-ecosystem.forge.issue-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hdX7K.CollapsedSectionWrapper), {
        isCompactMode: isCompactMode,
        isPanelCollapsed: isPanelCollapsed && userCanSaveIssuePanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($95f0d38bade2bd43$export$a8ddbd4c701695a0, {
        actions: actions,
        extension: extension,
        name: name
    }), (!isPanelCollapsed || !userCanSaveIssuePanel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "status",
        "aria-live": "polite",
        "aria-atomic": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cjwhP.AsyncIssuePanel), {
        extensionData: extendedExtensionData,
        extension: extension,
        localId: panelKey,
        setCustomActions: setCustomActions,
        analyticsAttributes: analyticsAttributes
    }))));
};
const $95f0d38bade2bd43$export$276c87319b08f9f9 = (props)=>{
    const refreshedOn = (0, $eyYNo.useOnDemandIssueRefreshTime)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ejygw.ViewAnalyticsWrapper), {
        key: refreshedOn,
        attributes: {
            source: props.source,
            isNewToIssue: props.isNewToIssue,
            isPanelCollapsed: props.isPanelCollapsed,
            userCanSaveIssuePanel: props.userCanSaveIssuePanel,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($95f0d38bade2bd43$export$1e37f7692d27ab64, props));
};
var $95f0d38bade2bd43$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $lqalZ.connect)((state, ownProps)=>({
        isJustAdded: (0, $8QKSg.forgeJustAddedPanelSelector)(ownProps.panelKey)(state),
        issueKey: (0, $5JqpU.issueKeySelector)(state),
        refreshedOn: (0, $jZDJX.entitiesRefreshedOnSelector)(state),
        extensionData: (0, $8QKSg.forgeIssueDataSelector)(state),
        isNewToIssue: (0, $8QKSg.isForgePanelNewToIssueSelector)(state, ownProps.panelKey),
        source: (0, $5JqpU.analyticsSourceSelector)(state),
        isPanelCollapsed: (0, $8QKSg.forgeIsCollapsedPanelSelector)(state, ownProps.panelKey),
        userCanSaveIssuePanel: (0, $8QKSg.forgeUserCanSaveIssuePanelSelector)(state)
    }), (dispatch)=>({
        removeFromJustAdded: (key)=>{
            dispatch((0, $bCaZl.contentPanelUnselect)(key));
        },
        removeFromNewPanels: (key)=>{
            dispatch((0, $i7QJO.forgeNewIssuePanelUntrack)(key));
        },
        onRemove: (key)=>{
            dispatch((0, $bCaZl.removeContentPanelRequest)(key));
        },
        updatePanel: (payload)=>{
            dispatch((0, $i7QJO.forgeIssuePanelUpdateRequest)(payload));
        }
    }))($95f0d38bade2bd43$export$276c87319b08f9f9);
const $95f0d38bade2bd43$var$LeftAligned = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { clickable: clickable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4t3izwfg",
            __cmplp.clickable ? "_80omtlke" : "_80om1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95f0d38bade2bd43$var$RightAligned = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _2lx21sbv _1n261g80 _pof3u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ejygw", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $4bcaad42fd5d8972$export$c794eb4124961145);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");
const $4bcaad42fd5d8972$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.ISSUE_PANEL_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });

});

parcelRegister("cjwhP", function(module, exports) {

$parcel$export(module.exports, "AsyncIssuePanel", () => $d9414be9ad425d82$export$890515c7b7741b8e);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $1boRu = parcelRequire("1boRu");

var $2Rqjr = parcelRequire("2Rqjr");

var $2vJHJ = parcelRequire("2vJHJ");

var $gGtKh = parcelRequire("gGtKh");

var $aIPS7 = parcelRequire("aIPS7");

var $8Nthx = parcelRequire("8Nthx");
const $d9414be9ad425d82$var$skeletonConfig = [
    {
        width: 100
    },
    {
        width: 75
    }
];

const $d9414be9ad425d82$export$a744b209bbf68ac7 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>(parcelRequire("72ZWj")), {
    ssr: false,
    moduleId: "./src/packages/forge/forge-ui-async/src/ui/issue-panel/index.tsx"
}));
const $d9414be9ad425d82$export$6b0fa56fb1c2c0cf = (props)=>{
    const { extension: extension, extensionData: extensionData, setCustomActions: setCustomActions, ...restProps } = props;
    const loadingComponent = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Nthx.Skeleton), {
            skeletonConfig: $d9414be9ad425d82$var$skeletonConfig
        }), []);
    const extensionDataValue = (0, $eUqFw.useMemo)(()=>({
            ...extensionData,
            type: (0, $2Rqjr.ISSUE_PANEL_MODULE)
        }), [
        extensionData
    ]);
    const extraProps = (0, $eUqFw.useMemo)(()=>({
            loadingComponent: loadingComponent,
            module: (0, $2Rqjr.ISSUE_PANEL_MODULE),
            extensionData: extensionDataValue,
            extension: extension,
            contextToken: (0, $2Rqjr.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extension,
        extensionDataValue,
        loadingComponent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-panel",
        fallback: loadingComponent
    }, (0, $2vJHJ.isCustomUIExtension)(extension) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aIPS7.LazyIssueViewIframe), {
        ...restProps,
        ...extraProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9414be9ad425d82$export$a744b209bbf68ac7, {
        ...props,
        ...extraProps
    }));
};
const $d9414be9ad425d82$export$890515c7b7741b8e = $d9414be9ad425d82$export$6b0fa56fb1c2c0cf;

});
parcelRegister("72ZWj", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3nIGN');
        const value = parcelRequire('7J5Ie');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3nIGN").then(()=>parcelRequire('7J5Ie'));
}

});


parcelRegister("bDeRj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d73cf8b18aec218b$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $d73cf8b18aec218b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue.content.ecosystem.forge.panel.actions.title",
        "defaultMessage": "Actions"
    },
    remove: {
        "id": "issue.content.ecosystem.forge.panel.actions.remove",
        "defaultMessage": "Remove"
    },
    collapse: {
        "id": "issue.content.ecosystem.forge.panel.actions.collapse",
        "defaultMessage": "Collapse"
    },
    expand: {
        "id": "issue.content.ecosystem.forge.panel.actions.expand",
        "defaultMessage": "Expand"
    }
});

});


parcelRegister("cVWzw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5feff85e4551b09b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $0cdA8 = parcelRequire("0cdA8");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $2wCUM = parcelRequire("2wCUM");

var $lO4Or = parcelRequire("lO4Or");

var $8WuJm = parcelRequire("8WuJm");

var $guDlK = parcelRequire("guDlK");


var $6vrw7 = parcelRequire("6vrw7");

var $dWLk9 = parcelRequire("dWLk9");

var $5LZUd = parcelRequire("5LZUd");

var $b0MK5 = parcelRequire("b0MK5");

var $iXqdc = parcelRequire("iXqdc");
const $5feff85e4551b09b$var$hasValue = (x)=>x !== null && x !== undefined;
const $5feff85e4551b09b$var$hasStringValue = (str)=>$5feff85e4551b09b$var$hasValue(str) && str !== '';
const $5feff85e4551b09b$var$isRequiredAttributesPresent = (issueId, projectId, projectKey, baseUrl, cloudId)=>{
    if ($5feff85e4551b09b$var$hasStringValue(projectId) && projectId !== (0, $6vrw7.toProjectId)('') && $5feff85e4551b09b$var$hasValue(issueId) && issueId !== (0, $6vrw7.toIssueId)('') && $5feff85e4551b09b$var$hasStringValue(cloudId)) return {
        issueId: issueId,
        projectId: projectId,
        projectKey: projectKey,
        baseUrl: baseUrl,
        cloudId: cloudId
    };
    return undefined;
};
const $5feff85e4551b09b$var$RelatedIssuesPanel = ()=>{
    const sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
    const issueId = (0, $hJ992.useIssueId)();
    const projectKey = (0, $hJ992.useProjectKey)();
    const projectId = (0, $6vrw7.toProjectId)((0, $guDlK.useProjectId)(projectKey) || '');
    const projectStatus = (0, $guDlK.useProjectStatus)(projectKey);
    const cloudId = (0, $dWLk9.useCloudId)();
    const baseUrl = (0, $6vrw7.toBaseUrl)('');
    const issueKey = (0, $hJ992.useIssueKey)();
    const [similarIssuesTypeFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.SIMILAR_ISSUES_TYPE)
    });
    const isIssueOfIncidentPractice = (0, $2wCUM.useIsIssueOfIncidentsPractice)();
    const validatedProps = $5feff85e4551b09b$var$isRequiredAttributesPresent(issueId, projectId, projectKey, baseUrl, cloudId);
    const isProjectArchived = projectStatus === (0, $5bd9e96e4d7e8aee$export$4ccc35479ba9ad1);
    return !!similarIssuesTypeFieldValue && validatedProps !== undefined && !isProjectArchived ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "relatedIssuesPanel",
        packageName: "issueSmartRelatedIssuesPanel",
        fallback: "unmount",
        teamName: "itsm-grimlock"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5LZUd.Container), validatedProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "RelatedIssuesPanel",
        attributes: {
            smartSessionId: sessionId
        }
    }, isIssueOfIncidentPractice ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iXqdc.default), {
        sessionId: sessionId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b0MK5.default), {
        sessionId: sessionId
    })))) : null;
};
var $5feff85e4551b09b$export$2e2bcd8739ae039 = $5feff85e4551b09b$var$RelatedIssuesPanel;

});
parcelRegister("5LZUd", function(module, exports) {

$parcel$export(module.exports, "Container", () => $769a645be7afd31c$export$42a852a2b6b56249);
$parcel$export(module.exports, "useRelatedIssuesForIssue", () => $769a645be7afd31c$export$eebc85c7fd74e8f);
$parcel$export(module.exports, "useRelatedIncidentsForIssue", () => $769a645be7afd31c$export$4b20a6b6b7d9d303);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $6vrw7 = parcelRequire("6vrw7");

var $35lgY = parcelRequire("35lgY");

var $6YU3V = parcelRequire("6YU3V");

var $1RZvC = parcelRequire("1RZvC");
// fields to hydrate issue line card contents
const $769a645be7afd31c$var$FIELDS = [
    'summary',
    'issuetype'
];
const $769a645be7afd31c$export$d4c72bab9d6cc13a = {
    data: {},
    similarIncidentData: {
        suggestionId: '',
        similarIssues: []
    },
    isLoading: false,
    error: undefined,
    baseUrl: (0, $6vrw7.toBaseUrl)(''),
    issueId: (0, $6vrw7.toIssueId)(''),
    projectId: (0, $6vrw7.toProjectId)(''),
    projectKey: (0, $6vrw7.toProjectKey)(''),
    cloudId: (0, $6vrw7.toCloudId)(''),
    status: (0, $35lgY.OPEN)
};
const $769a645be7afd31c$var$fetchSimilarIssuesForStatus = async (status, sessionId, state, createAnalyticsEvent, queryText)=>{
    const { projectId: projectId, issueId: issueId, cloudId: cloudId, projectKey: projectKey, baseUrl: baseUrl } = state;
    // if queryText is null (shouldn't resolve to null since it's based on issue summary)
    // FRS will fallback to relying on issueId for hydration
    const context = {
        projectId: projectId,
        issueId: issueId,
        sessionId: sessionId,
        cloudId: cloudId,
        queryText: queryText
    };
    const jql = (0, $1RZvC.buildJql)(status);
    const filter = {
        jql: jql,
        fields: $769a645be7afd31c$var$FIELDS,
        projectKey: projectKey,
        columnTypesAsJson: $769a645be7afd31c$var$FIELDS
    };
    const res = await (0, $6YU3V.fetchSimilarIssues)(context, baseUrl, filter, createAnalyticsEvent);
    return (0, $1RZvC.transformResponseToSimilarIssues)(res);
};
const $769a645be7afd31c$var$checkResultsNeedFetching = ({ data: data, isLoading: isLoading, status: status })=>{
    // don't fetch if loading
    if (isLoading === false) // fetch if data is not populated
    return data[status] === undefined;
    return false;
};
const $769a645be7afd31c$export$1abdb16a7d9e573a = (sessionId, createAnalyticsEvent, queryText)=>async ({ getState: getState, setState: setState })=>{
        const prevState = getState();
        // predicate prevents flickering by skipping if results are already present
        if ($769a645be7afd31c$var$checkResultsNeedFetching(prevState)) {
            setState({
                isLoading: true,
                error: undefined
            });
            try {
                const { status: status } = prevState;
                let newStatus = status;
                const [openTransformedIssues, resolvedTransformedIssues] = await Promise.all([
                    $769a645be7afd31c$var$fetchSimilarIssuesForStatus((0, $35lgY.OPEN), sessionId, prevState, createAnalyticsEvent, queryText),
                    $769a645be7afd31c$var$fetchSimilarIssuesForStatus((0, $35lgY.RESOLVED), sessionId, prevState, createAnalyticsEvent, queryText)
                ]);
                if (openTransformedIssues.length === 0 && resolvedTransformedIssues.length > 0) newStatus = (0, $35lgY.RESOLVED);
                setState({
                    data: {
                        [(0, $35lgY.OPEN)]: openTransformedIssues,
                        [(0, $35lgY.RESOLVED)]: resolvedTransformedIssues
                    },
                    isLoading: false,
                    error: undefined,
                    status: newStatus
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                // enable users to re-fetch if responds with error
                (0, $6YU3V.fetchSimilarIssues).cache?.clear?.();
                setState({
                    isLoading: false,
                    error: error
                });
            }
        }
    };
const $769a645be7afd31c$export$ca5a628aa5e0c40f = (createAnalyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        try {
            const state = getState();
            const { issueId: issueId, projectId: projectId } = state;
            const similarIncidents = await (0, $6YU3V.fetchSimilarIncidents)(issueId, projectId, createAnalyticsEvent);
            // get serviceIds from affected services list
            const serviceIds = similarIncidents.similarIssues.flatMap((currentSimilarIncident)=>currentSimilarIncident && currentSimilarIncident.affectedServices && currentSimilarIncident.affectedServices.map((service)=>service.id)).filter((a)=>a);
            // fetch service names and create a map
            const serviceNames = await (0, $6YU3V.fetchServiceNames)(serviceIds, createAnalyticsEvent);
            const serviceNamesMap = serviceNames.services.reduce((acc, obj)=>{
                acc[obj.id] = obj.name;
                return acc;
            }, {});
            // populate service names in affected services
            const newSimilarIncidents = similarIncidents.similarIssues.map((currentSimilarIncident)=>({
                    ...currentSimilarIncident,
                    ...currentSimilarIncident.affectedServices ? {
                        affectedServices: currentSimilarIncident.affectedServices.map((service)=>({
                                id: service.id,
                                name: serviceNamesMap[service.id]
                            }))
                    } : []
                }));
            setState({
                similarIncidentData: {
                    suggestionId: similarIncidents.suggestionId,
                    similarIssues: newSimilarIncidents
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                similarIncidentData: {
                    suggestionId: '',
                    similarIssues: []
                }
            });
        }
    };
const $769a645be7afd31c$export$198c611c039c3192 = (status)=>({ getState: getState, setState: setState })=>{
        const { status: oldStatus } = getState();
        if (status !== oldStatus) setState({
            status: status
        });
    };
const $769a645be7afd31c$var$setContext = ()=>({ setState: setState }, updatedState)=>{
        setState(updatedState);
    };
const $769a645be7afd31c$var$actions = {
    fetchRelatedIssuesForIssue: $769a645be7afd31c$export$1abdb16a7d9e573a,
    setContext: $769a645be7afd31c$var$setContext,
    setIssueStatus: $769a645be7afd31c$export$198c611c039c3192,
    fetchRelatedIncidentsForIssue: $769a645be7afd31c$export$ca5a628aa5e0c40f
};
const $769a645be7afd31c$var$store = (0, $a61MH.createStore)({
    name: 'FetchRelatedIssuesForIssue',
    initialState: $769a645be7afd31c$export$d4c72bab9d6cc13a,
    actions: $769a645be7afd31c$var$actions
});
const $769a645be7afd31c$export$42a852a2b6b56249 = (0, $heB5U.createContainer)($769a645be7afd31c$var$store, {
    onInit: $769a645be7afd31c$var$actions.setContext
});
const $769a645be7afd31c$export$eebc85c7fd74e8f = (0, $ggKAj.createHook)($769a645be7afd31c$var$store);
const $769a645be7afd31c$export$4b20a6b6b7d9d303 = (0, $ggKAj.createHook)($769a645be7afd31c$var$store, {
    selector: (state)=>({
            similarIncidentData: state.similarIncidentData
        })
});

});
parcelRegister("35lgY", function(module, exports) {

$parcel$export(module.exports, "RESOLVED", () => $1895c7b3353bb840$export$483989a9813b3c0d);
$parcel$export(module.exports, "OPEN", () => $1895c7b3353bb840$export$bb29a81b503a982c);
$parcel$export(module.exports, "FEEDBACK_COLLECTOR_LOCATION", () => $1895c7b3353bb840$export$74189cec821240a6);
$parcel$export(module.exports, "FEEDBACK_COLLECTOR_ID", () => $1895c7b3353bb840$export$2efe57de19370995);
$parcel$export(module.exports, "FEEDBACK_GROUP_ID", () => $1895c7b3353bb840$export$14b33d63628336c2);
$parcel$export(module.exports, "BENTO_FEEDBACK_TYPE_FIELD_ID", () => $1895c7b3353bb840$export$815803e0786fdc39);
$parcel$export(module.exports, "BENTO_FEEDBACK_TYPE_BUG", () => $1895c7b3353bb840$export$131dabc473b11184);
$parcel$export(module.exports, "BENTO_FEEDBACK_TYPE_OTHER", () => $1895c7b3353bb840$export$f2fed90b87336ee6);
$parcel$export(module.exports, "SESSION_ID", () => $1895c7b3353bb840$export$b30f4cb52c088a26);
$parcel$export(module.exports, "TENANT_CLOUD_ID", () => $1895c7b3353bb840$export$70b7c7fcf0e8fdda);
$parcel$export(module.exports, "SIMILAR_INCIDENTS_FEEDBACK_COLLECTOR_ID", () => $1895c7b3353bb840$export$5f22329fabcdb5d7);
$parcel$export(module.exports, "DEFAULT_SIMILAR_INCIDENTS_CARD", () => $1895c7b3353bb840$export$3b2b73e31aeba21c);
$parcel$export(module.exports, "MAX_SIMILAR_INCIDENTS_CARD", () => $1895c7b3353bb840$export$c8ba7dd5af3fd5db);
$parcel$export(module.exports, "LIKE", () => $1895c7b3353bb840$export$d5aaa418e77045c1);
$parcel$export(module.exports, "DISLIKE", () => $1895c7b3353bb840$export$e109975eb3f44259);
const $1895c7b3353bb840$export$483989a9813b3c0d = 'RESOLVED';
const $1895c7b3353bb840$export$bb29a81b503a982c = 'OPEN';
const $1895c7b3353bb840$export$74189cec821240a6 = 'jsm.issue-view';
const $1895c7b3353bb840$export$2efe57de19370995 = 'bento-similar-requests-panel';
const $1895c7b3353bb840$export$14b33d63628336c2 = 'jira-servicedesk-related-issues';
const $1895c7b3353bb840$export$815803e0786fdc39 = 'customfield_10065';
const $1895c7b3353bb840$export$131dabc473b11184 = {
    id: '10161'
};
const $1895c7b3353bb840$export$f2fed90b87336ee6 = {
    id: '10160'
};
const $1895c7b3353bb840$export$b30f4cb52c088a26 = 'sessionId';
const $1895c7b3353bb840$export$70b7c7fcf0e8fdda = 'tenantCloudId';
const $1895c7b3353bb840$export$5f22329fabcdb5d7 = 'bento-similar-incidents-panel';
const $1895c7b3353bb840$export$3b2b73e31aeba21c = 3;
const $1895c7b3353bb840$export$c8ba7dd5af3fd5db = 5;
const $1895c7b3353bb840$export$d5aaa418e77045c1 = 'like';
const $1895c7b3353bb840$export$e109975eb3f44259 = 'dislike';

});

parcelRegister("6YU3V", function(module, exports) {

$parcel$export(module.exports, "fetchSimilarIssues", () => $fef97f40f44dafb8$export$cbb0358dc9e070e9);
$parcel$export(module.exports, "fetchSimilarIncidents", () => $fef97f40f44dafb8$export$6ad9e26cdc8bc8d);
$parcel$export(module.exports, "fetchServiceNames", () => $fef97f40f44dafb8$export$fcaf7c4423e66ded);

var $jqvCZ = parcelRequire("jqvCZ");

var $8uNQc = parcelRequire("8uNQc");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $1RZvC = parcelRequire("1RZvC");
const $fef97f40f44dafb8$export$e546623b4b104f5f = 15;
const $fef97f40f44dafb8$export$cbb0358dc9e070e9 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((context, baseUrl, filter, createAnalyticsEvent)=>{
    const startTime = (0, $8uNQc.default).now();
    const FIREBOLT_URL = '/gateway/api/firebolt/1/similarissues/issue/project';
    // hardcoding estimatedTotalIssues for now, to remove when field is made optional in FRS.
    return (0, $2OdyW.default)(FIREBOLT_URL, {
        body: JSON.stringify({
            context: {
                subProduct: 'serviceDesk',
                product: 'jira',
                sessionId: context.sessionId,
                containerId: context.projectId,
                objectId: context.issueId,
                queryText: context.queryText,
                principalId: 'context',
                tenantId: context.cloudId
            },
            filter: filter,
            limit: $fef97f40f44dafb8$export$e546623b4b104f5f,
            estimatedTotalIssues: 1000
        }),
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST'
    }).then((response)=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fetchRelatedIssues succeeded', {
            elapsedTimeMilli: Math.floor((0, $8uNQc.default).now() - startTime),
            results: (0, $1RZvC.transformResponseForAnalytics)(response),
            resultsSize: response.issues.length
        });
        return response;
    }).catch((error)=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fetchRelatedIssues failed', {
            elapsedTimeMilli: Math.floor((0, $8uNQc.default).now() - startTime),
            traceId: error.traceId,
            statusCode: error.statusCode
        });
        throw error;
    });
}, (context, baseUrl, filter)=>`${context.issueId} - ${context.queryText ?? ''} - ${filter.jql}`);
const $fef97f40f44dafb8$export$6ad9e26cdc8bc8d = (issueId, projectId, createAnalyticsEvent)=>{
    const SIMIMLAR_INCIDENTS_URL = `/gateway/api/firebolt/1/similarissues/incidents/${issueId}?projectId=${projectId}`;
    const startTime = (0, $8uNQc.default).now();
    return (0, $2OdyW.default)(SIMIMLAR_INCIDENTS_URL).then((response)=>response).catch((error)=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fetchSimilarIncidents failed', {
            elapsedTimeMilli: Math.floor((0, $8uNQc.default).now() - startTime),
            traceId: error.traceId,
            statusCode: error.statusCode
        });
        throw error;
    });
};
const $fef97f40f44dafb8$export$fcaf7c4423e66ded = (ids, createAnalyticsEvent)=>{
    const SERVICE_URL = '/rest/service-registry-api/service';
    const startTime = (0, $8uNQc.default).now();
    return (0, $2OdyW.default)(SERVICE_URL, {
        method: 'POST',
        body: JSON.stringify({
            ids: ids
        })
    }).then((response)=>response).catch((error)=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fetchServiceNames failed', {
            elapsedTimeMilli: Math.floor((0, $8uNQc.default).now() - startTime),
            traceId: error.traceId,
            statusCode: error.statusCode
        });
        throw error;
    });
};

});
parcelRegister("1RZvC", function(module, exports) {

$parcel$export(module.exports, "transformResponseToSimilarIssues", () => $f2ae5e0858b46aba$export$5c81f425abad3d31);
$parcel$export(module.exports, "transformResponseForAnalytics", () => $f2ae5e0858b46aba$export$c60612884338fe82);
$parcel$export(module.exports, "buildJql", () => $f2ae5e0858b46aba$export$4e07a927e22bed0a);
$parcel$export(module.exports, "getTopFiveDistances", () => $f2ae5e0858b46aba$export$7a08ce7a4a105f1c);
$parcel$export(module.exports, "getTopFiveCrossEncoderScores", () => $f2ae5e0858b46aba$export$d1d26856f939ec27);

var $35lgY = parcelRequire("35lgY");
const $f2ae5e0858b46aba$var$OPEN_JQL = 'statusCategory != Done';
const $f2ae5e0858b46aba$var$RESOLVED_JQL = 'statusCategory = Done';
const $f2ae5e0858b46aba$export$5c81f425abad3d31 = (response)=>response.issues.map((rawIssue, idx)=>({
            id: rawIssue.id,
            issueKey: rawIssue.key,
            issueLink: rawIssue.self,
            issueTypeIconUrl: rawIssue.fields.issuetype.iconUrl,
            issueTypeName: rawIssue.fields.issuetype.name,
            issueSummary: rawIssue.fields.summary,
            position: idx,
            distance: rawIssue.distance,
            crossEncoderScore: rawIssue.crossEncoderScore
        }));
const $f2ae5e0858b46aba$export$c60612884338fe82 = (response)=>response.issues.map((rawIssue)=>({
            id: rawIssue.id
        }));
const $f2ae5e0858b46aba$export$4e07a927e22bed0a = (issueStatus)=>issueStatus === (0, $35lgY.OPEN) ? $f2ae5e0858b46aba$var$OPEN_JQL : $f2ae5e0858b46aba$var$RESOLVED_JQL;
const $f2ae5e0858b46aba$export$7a08ce7a4a105f1c = (similarIssues)=>similarIssues ? similarIssues.slice(0, 5).map((issue)=>issue.distance) : [];
const $f2ae5e0858b46aba$export$d1d26856f939ec27 = (similarIssues)=>similarIssues ? similarIssues.slice(0, 5).map((issue)=>issue.crossEncoderScore) : [];

});



parcelRegister("b0MK5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac08dcc66057c60a$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8WuJm = parcelRequire("8WuJm");
var $bFzGY = parcelRequire("bFzGY");

var $dircn = parcelRequire("dircn");
var $5LZUd = parcelRequire("5LZUd");

var $1RZvC = parcelRequire("1RZvC");

var $46Pqp = parcelRequire("46Pqp");

var $2dIAV = parcelRequire("2dIAV");

var $148qc = parcelRequire("148qc");

var $a2ZZm = parcelRequire("a2ZZm");
const $ac08dcc66057c60a$export$37613cb554e3f337 = ({ sessionId: sessionId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isExpanded, setExpanded] = (0, $eUqFw.useState)(false);
    const [hasClickedSentiment, setHasClickedSentiment] = (0, $eUqFw.useState)(false);
    const queryText = (0, $dircn.useQueryText)();
    const [{ data: data, status: status }, { fetchRelatedIssuesForIssue: fetchRelatedIssuesForIssue }] = (0, $5LZUd.useRelatedIssuesForIssue)();
    (0, $eUqFw.useEffect)(()=>{
        if (isExpanded) fetchRelatedIssuesForIssue(sessionId, createAnalyticsEvent, queryText);
    }, [
        createAnalyticsEvent,
        fetchRelatedIssuesForIssue,
        isExpanded,
        sessionId,
        queryText
    ]);
    const renderPanelBody = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a2ZZm.default), {
            sessionId: sessionId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac08dcc66057c60a$var$FieldsContainer, {
            "data-testid": "smart-related-issues-panel.ui.fields-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $148qc.default), {
            sessionId: sessionId
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $46Pqp.RelatedIssuesFeedbackSentiment), {
            sessionId: sessionId,
            hasClickedSentiment: hasClickedSentiment,
            setHasClickedSentiment: setHasClickedSentiment,
            openIssuesDistance: (0, $1RZvC.getTopFiveDistances)(data.OPEN),
            resolvedIssuesDistance: (0, $1RZvC.getTopFiveDistances)(data.RESOLVED),
            openIssuesCrossEncoderScore: (0, $1RZvC.getTopFiveCrossEncoderScores)(data.OPEN),
            resolvedIssuesCrossEncoderScore: (0, $1RZvC.getTopFiveCrossEncoderScores)(data.RESOLVED)
        }));
    const renderRelatedIssues = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2dIAV.default), {
            sessionId: sessionId,
            onExpand: ()=>setExpanded(true),
            onCollapse: ()=>setExpanded(false),
            isExpanded: isExpanded
        }), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac08dcc66057c60a$var$PanelBody, null, renderPanelBody()));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            selectedStatusFilter: status
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac08dcc66057c60a$var$RelatedIssuesContainer, {
        isExpanded: isExpanded
    }, renderRelatedIssues()));
};
var $ac08dcc66057c60a$export$2e2bcd8739ae039 = $ac08dcc66057c60a$export$37613cb554e3f337;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ac08dcc66057c60a$var$RelatedIssuesContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, hasContentItems: hasContentItems, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isExpanded && __cmplp.hasContentItems && "_n3tdidpf",
            __cmplp.className
        ])
    });
});
const $ac08dcc66057c60a$var$PanelBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr1ejb _1e0c1txw _2lx21bp4 _mrkb1y44 _1o0z1y44 _n7zlh6cr _1kl7h6cr _1s7zh6cr _bfhkvuon _1yt4u2gc",
            __cmplp.className
        ])
    });
});
const $ac08dcc66057c60a$var$FieldsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dircn", function(module, exports) {

$parcel$export(module.exports, "useQueryText", () => $5da8eed71283dc18$export$203a6cb8e692a2e1);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

const $5da8eed71283dc18$var$MAX_ISSUE_TEXT_LENGTH = 10000;
const $5da8eed71283dc18$export$203a6cb8e692a2e1 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [queryText, setQueryText] = (0, $eUqFw.useState)();
    const [description] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $ebc098a76317be78$export$d5bc879e3b748593)
    });
    const [summaryValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $ebc098a76317be78$export$e7cf1830fe735d1f)
    });
    (0, $eUqFw.useEffect)(()=>{
        const parseContent = async ()=>{
            setQueryText(`${summaryValue}`.substring(0, $5da8eed71283dc18$var$MAX_ISSUE_TEXT_LENGTH));
        };
        parseContent();
    }, [
        summaryValue,
        description
    ]);
    return queryText;
};

});

parcelRegister("46Pqp", function(module, exports) {

$parcel$export(module.exports, "RelatedIssuesFeedbackSentiment", () => $4d450aeda8e4c049$export$768ddc93d9eaaf8e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $35lgY = parcelRequire("35lgY");

var $hiKXE = parcelRequire("hiKXE");
var $5LZUd = parcelRequire("5LZUd");

var $5QNxz = parcelRequire("5QNxz");
const $4d450aeda8e4c049$export$370223a756895966 = 'smart-related-issues-panel.ui.feedback-sentiment.smart';
const $4d450aeda8e4c049$export$768ddc93d9eaaf8e = ({ sessionId: sessionId, hasClickedSentiment: hasClickedSentiment, setHasClickedSentiment: setHasClickedSentiment, openIssuesDistance: openIssuesDistance, resolvedIssuesDistance: resolvedIssuesDistance, openIssuesCrossEncoderScore: openIssuesCrossEncoderScore, resolvedIssuesCrossEncoderScore: resolvedIssuesCrossEncoderScore })=>{
    const [{ isLoading: isLoading, error: error, data: data }] = (0, $5LZUd.useRelatedIssuesForIssue)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { openRelatedIssuesFeedback: openRelatedIssuesFeedback } = (0, $hiKXE.useRelatedIssuesFeedbackCollector)(sessionId);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // Only show sentiment buttons when the results have loaded without error AND there are >0 results.
    const totalRelatedIssueCount = (data[0, $35lgY.OPEN]?.length ?? 0) + (data[0, $35lgY.RESOLVED]?.length ?? 0);
    if (isLoading || error || totalRelatedIssueCount === 0) return null;
    if (hasClickedSentiment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4d450aeda8e4c049$export$11e47300b051cf64, null, formatMessage((0, $5QNxz.default).thanksForYourFeedback), ' ', formatMessage((0, $5QNxz.default).toImproveFutureResultsWithPlaceholder, {
        tellUsMore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            spacing: "none",
            "data-testId": "smart-related-issues-panel.ui.feedback-sentiment.smart.feedback-collector",
            onClick: openRelatedIssuesFeedback,
            interactionName: "auto-generated.jira-smart-related-issues-panel.ui.feedback-sentiment.button"
        }, formatMessage((0, $5QNxz.default).tellUsMore))
    }));
    const onButtonClick = (wereResultsRelevant, openIssuesDistances, resolvedIssuesDistances, openIssuesCrossEncoderScores, resolvedIssuesCrossEncoderScores)=>{
        setHasClickedSentiment(true);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'relatedIssuesSentiment clicked', {
            wereResultsRelevant: wereResultsRelevant,
            openIssuesDistances: openIssuesDistances,
            resolvedIssuesDistances: resolvedIssuesDistances,
            openIssuesCrossEncoderScores: openIssuesCrossEncoderScores,
            resolvedIssuesCrossEncoderScores: resolvedIssuesCrossEncoderScores
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4d450aeda8e4c049$export$11e47300b051cf64, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $5QNxz.default).areTheseRelevant)), [
        'yes',
        'no'
    ].map((buttonId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            key: buttonId,
            spacing: "compact",
            onClick: ()=>onButtonClick(buttonId === 'yes', openIssuesDistance, resolvedIssuesDistance, openIssuesCrossEncoderScore, resolvedIssuesCrossEncoderScore),
            "data-testId": `${$4d450aeda8e4c049$export$370223a756895966}.${buttonId}`,
            "aria-label": formatMessage((0, $5QNxz.default)[`${buttonId}AriaLabel`]),
            interactionName: "auto-generated.jira-smart-related-issues-panel.ui.feedback-sentiment.button1"
        }, formatMessage((0, $5QNxz.default)[buttonId]))));
};
const $4d450aeda8e4c049$export$11e47300b051cf64 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tke1tcg _1kho1b66 _19m41b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hiKXE", function(module, exports) {

$parcel$export(module.exports, "useRelatedIssuesFeedbackCollector", () => $76d1dc3cad418e61$export$e65759cb34913c12);

var $eUqFw = parcelRequire("eUqFw");

var $1c02D = parcelRequire("1c02D");
var $irg9D = parcelRequire("irg9D");

var $2wCUM = parcelRequire("2wCUM");

var $dWLk9 = parcelRequire("dWLk9");

var $35lgY = parcelRequire("35lgY");
const $76d1dc3cad418e61$export$e65759cb34913c12 = (sessionId)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const isIssueOfIncidentPractice = (0, $2wCUM.useIsIssueOfIncidentsPractice)();
    const openRelatedIssuesFeedback = (0, $eUqFw.useCallback)(()=>{
        const feedbackPayload = {
            entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_ISSUE_VIEW),
            feedbackGroupId: (0, $35lgY.FEEDBACK_GROUP_ID),
            feedbackCollectorId: isIssueOfIncidentPractice ? (0, $35lgY.SIMILAR_INCIDENTS_FEEDBACK_COLLECTOR_ID) : (0, $35lgY.FEEDBACK_COLLECTOR_ID),
            // @ts-expect-error typeFieldId not defined in platform FeedbackCollectorProps type
            typeFieldId: (0, $35lgY.BENTO_FEEDBACK_TYPE_FIELD_ID),
            typeBugDefaultValue: (0, $35lgY.BENTO_FEEDBACK_TYPE_BUG),
            typeCommentDefaultValue: (0, $35lgY.BENTO_FEEDBACK_TYPE_OTHER),
            typeSuggestionDefaultValue: (0, $35lgY.BENTO_FEEDBACK_TYPE_OTHER),
            typeQuestionDefaultValue: (0, $35lgY.BENTO_FEEDBACK_TYPE_OTHER),
            feedbackContext: [
                {
                    id: (0, $1c02D.EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
                    value: (0, $35lgY.FEEDBACK_COLLECTOR_LOCATION)
                },
                {
                    id: (0, $1c02D.EntryKeys).FEEDBACK_COLLECTOR_ID,
                    value: isIssueOfIncidentPractice ? (0, $35lgY.SIMILAR_INCIDENTS_FEEDBACK_COLLECTOR_ID) : (0, $35lgY.FEEDBACK_COLLECTOR_ID)
                },
                {
                    id: (0, $35lgY.TENANT_CLOUD_ID),
                    value: cloudId
                },
                {
                    id: (0, $35lgY.SESSION_ID),
                    value: sessionId
                }
            ]
        };
        openFeedbackCollector(feedbackPayload);
    }, [
        openFeedbackCollector,
        sessionId,
        cloudId,
        isIssueOfIncidentPractice
    ]);
    return {
        openRelatedIssuesFeedback: openRelatedIssuesFeedback
    };
};

});
parcelRegister("1c02D", function(module, exports) {

$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", () => $ccbba0a7f0f3304b$export$baea5c8192e79adc);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", () => $ccbba0a7f0f3304b$export$4eda1e3a4a311d13);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", () => $ccbba0a7f0f3304b$export$5fb38521eb7ad63c);
$parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", () => $ccbba0a7f0f3304b$export$345c45dd28f28a32);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", () => $ccbba0a7f0f3304b$export$8962f2e618411469);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", () => $ccbba0a7f0f3304b$export$7d7f2319141db3c5);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", () => $ccbba0a7f0f3304b$export$4725635e6fe1907a);
$parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", () => $ccbba0a7f0f3304b$export$3a50f2efd6cfd6f3);
$parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", () => $ccbba0a7f0f3304b$export$b4de0744c1fd450d);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", () => $ccbba0a7f0f3304b$export$1a7c42187130faf9);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", () => $ccbba0a7f0f3304b$export$e84c34a7e1dbcf78);
$parcel$export(module.exports, "EntryKeys", () => $ccbba0a7f0f3304b$export$12d01b6c311a909a);
// Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
const $ccbba0a7f0f3304b$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
const $ccbba0a7f0f3304b$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
const $ccbba0a7f0f3304b$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
const $ccbba0a7f0f3304b$export$4a288e389131b3de = 'b6176efc-e703-426b-b4f8-3e43ce4aa0db';
const $ccbba0a7f0f3304b$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
const $ccbba0a7f0f3304b$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
const $ccbba0a7f0f3304b$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
const $ccbba0a7f0f3304b$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
const $ccbba0a7f0f3304b$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $ccbba0a7f0f3304b$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
const $ccbba0a7f0f3304b$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
const $ccbba0a7f0f3304b$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
const $ccbba0a7f0f3304b$export$12d01b6c311a909a = Object.freeze({
    CLOUD_ID: 'cloud-id',
    OPT_OUT: 'Opt-out',
    REASON: 'reason',
    FEELING: 'feeling',
    IS_ADMIN: 'is-admin',
    IS_SITE_ADMIN: 'is-site-admin',
    IS_PROJECT_SETTINGS: 'is-project-settings',
    INLINE_FEEDBACK_ID: 'inlineFeedbackId',
    IS_JSD_EVALUATOR: 'is-jsd-evaluator',
    IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
    SUPPORTED_PROJECT_TYPES: 'supported-project-types',
    FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
    FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
    FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
    LOCATION: 'Location',
    PROJECT_TYPE: 'project-type',
    BOARD_TYPE: 'board-type',
    REFERER: 'Referer',
    ROUTE_GROUP: 'route-group',
    ROUTE_NAME: 'route-name',
    USER_AGENT: 'User-Agent',
    SCREEN_RESOLUTION: 'Screen Resolution',
    SOURCE: 'Source',
    SUB_PRODUCT: 'Sub-product',
    JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
    JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
    DEPLOYMENT_PROVIDERS: 'deployment-providers',
    JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
    VERSION_CONTROL_PROVIDERS: 'version-control-providers',
    DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
    CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
    SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
    INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
    IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
    FEEDBACK_GROUP_ID: 'feedback-group-id',
    EDITION: 'edition',
    ENV: 'environment'
});

});


parcelRegister("5QNxz", function(module, exports) {

$parcel$export(module.exports, "default", () => $808438e8996d7f66$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $808438e8996d7f66$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    areTheseRelevant: {
        "id": "smart-related-issues-panel.feedback-sentiment.are-these-relevant",
        "defaultMessage": "Are these results relevant?"
    },
    yes: {
        "id": "smart-related-issues-panel.feedback-sentiment.yes",
        "defaultMessage": "Yes"
    },
    no: {
        "id": "smart-related-issues-panel.feedback-sentiment.no",
        "defaultMessage": "No"
    },
    thanksForYourFeedback: {
        "id": "smart-related-issues-panel.feedback-sentiment.thanks-for-your-feedback",
        "defaultMessage": "Thanks for your feedback!"
    },
    tellUsMore: {
        "id": "smart-related-issues-panel.feedback-sentiment.tell-us-more",
        "defaultMessage": "Tell us more"
    },
    toImproveFutureResultsWithPlaceholder: {
        "id": "smart-related-issues-panel.feedback-sentiment.to-improve-future-results-with-placeholder",
        "defaultMessage": "{tellUsMore} to improve future results."
    },
    yesAriaLabel: {
        "id": "smart-related-issues-panel.feedback-sentiment.yes-aria-label",
        "defaultMessage": "Yes"
    },
    noAriaLabel: {
        "id": "smart-related-issues-panel.feedback-sentiment.no-aria-label",
        "defaultMessage": "No"
    }
});

});


parcelRegister("2dIAV", function(module, exports) {

$parcel$export(module.exports, "default", () => $6838cdd5ef1c0c66$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bLFgh = parcelRequire("bLFgh");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iAc02 = parcelRequire("iAc02");

var $KG9m4 = parcelRequire("KG9m4");

var $5XEBC = parcelRequire("5XEBC");
const $6838cdd5ef1c0c66$var$PanelHeader = ({ onExpand: onExpand, onCollapse: onCollapse, isExpanded: isExpanded })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleHeaderClick = ()=>isExpanded ? onCollapse() : onExpand();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6838cdd5ef1c0c66$var$HeaderWrapper, {
        onClick: handleHeaderClick,
        isExpanded: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6838cdd5ef1c0c66$var$HeaderTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, formatMessage((0, $5XEBC.default).title)), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6838cdd5ef1c0c66$export$9cbca4161ff10154, null, formatMessage((0, $5XEBC.default).description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $KG9m4.default), {
        isContentExpanded: isExpanded,
        onExpand: onExpand,
        onCollapse: onCollapse
    })));
};
var $6838cdd5ef1c0c66$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $6838cdd5ef1c0c66$var$PanelHeader;
const $6838cdd5ef1c0c66$var$HeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1yb4 _4cvr1h6o _19pk1k9i _otyr11di _2rko1y44 _19ith6cr _bfhkvuon _1yt4pxbi _2it8glyw _nt75194a _1du212yw _1v3l12yw _19lc12yw _1372tlke _1pjhtlke _d0altlke _1di6tmi0 _q4zta5ev",
            __cmplp.isExpanded && "_mrkbidpf _1o0zidpf _otyridpf",
            __cmplp.className
        ])
    });
});
const $6838cdd5ef1c0c66$var$HeaderTextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $iAc02.SectionHeading), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _1ul9idpf _oo1iglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $6838cdd5ef1c0c66$export$9cbca4161ff10154 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _18s814rb _1bto1l2s _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("KG9m4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a3c5ed0f4ad6a17$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $5xnoX = parcelRequire("5xnoX");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $hFfgr = parcelRequire("hFfgr");
const $7a3c5ed0f4ad6a17$var$ContentSectionExpander = ({ isContentExpanded: isContentExpanded, onExpand: onExpand, onCollapse: onCollapse })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleExpand = (event, analyticsEvent)=>{
        onExpand();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'showRelatedIssues');
    };
    const handleCollapse = (event, analyticsEvent)=>{
        onCollapse();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'hideRelatedIssues');
    };
    const renderShowIssuesButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            "aria-label": formatMessage((0, $hFfgr.default).newShow),
            appearance: "subtle-link",
            // @TODO JIV-16016 migrate data-test-id
            "data-test-id": "smart-related-issues-panel.ui.header.expander.expand-button",
            spacing: "default",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: "",
                size: "large"
            }),
            onClick: handleExpand,
            interactionName: "auto-generated.jira-smart-related-issues-panel.ui.header.expander.button"
        });
    const renderHideIssuesButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            "aria-label": formatMessage((0, $hFfgr.default).hide),
            appearance: "subtle-link",
            spacing: "default",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))), {
                label: "",
                size: "large"
            }),
            onClick: handleCollapse,
            interactionName: "auto-generated.jira-smart-related-issues-panel.ui.header.expander.button1"
        });
    return isContentExpanded ? renderHideIssuesButton() : renderShowIssuesButton();
};
var $7a3c5ed0f4ad6a17$export$2e2bcd8739ae039 = $7a3c5ed0f4ad6a17$var$ContentSectionExpander;

});
parcelRegister("hFfgr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c9f79e42e48efc1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6c9f79e42e48efc1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    show: {
        "id": "smart-related-issues-panel.header.expander.show",
        "defaultMessage": "Show"
    },
    newShow: {
        "id": "smart-related-issues-panel.header.expander.new-show",
        "defaultMessage": "Similar requests expandable section"
    },
    hide: {
        "id": "smart-related-issues-panel.header.expander.hide",
        "defaultMessage": "Hide"
    }
});

});


parcelRegister("5XEBC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6acd00dfc19a1679$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6acd00dfc19a1679$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    whatIsThis: {
        "id": "smart-related-issues-panel.header.what-is-this",
        "defaultMessage": "What is this?"
    },
    feedback: {
        "id": "smart-related-issues-panel.header.feedback",
        "defaultMessage": "Give feedback"
    },
    hideSimilarRequests: {
        "id": "smart-related-issues-panel.header.hide-similar-requests",
        "defaultMessage": "Hide similar requests"
    },
    hideSimilarRequestsHover: {
        "id": "smart-related-issues-panel.header.hide-similar-requests-hover",
        "defaultMessage": "Your project admin can disable this feature in the project settings"
    },
    title: {
        "id": "smart-related-issues-panel.header.title",
        "defaultMessage": "Similar requests"
    },
    description: {
        "id": "smart-related-issues-panel.header.description",
        "defaultMessage": "Results with a similar summary and description"
    }
});

});


parcelRegister("148qc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bcab253b0ea7628$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gQylF = parcelRequire("gQylF");

var $5gJbo = parcelRequire("5gJbo");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dircn = parcelRequire("dircn");
var $5LZUd = parcelRequire("5LZUd");

var $cG43M = parcelRequire("cG43M");

var $1auvT = parcelRequire("1auvT");

var $cT4kl = parcelRequire("cT4kl");

var $ijb9H = parcelRequire("ijb9H");

var $lUWtP = parcelRequire("lUWtP");
const $6bcab253b0ea7628$export$15e2337b15d89c0c = 5;
const $6bcab253b0ea7628$var$IssueLineCardGroup = ({ sessionId: sessionId })=>{
    const [showMoreExpanded, setShowMoreExpanded] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const queryText = (0, $dircn.useQueryText)();
    const [{ data: relatedIssues, isLoading: isLoading, error: error, status: status }, { fetchRelatedIssuesForIssue: fetchRelatedIssuesForIssue }] = (0, $5LZUd.useRelatedIssuesForIssue)();
    const handleClick = (issue, event)=>{
        if (issue !== null && issue !== undefined) {
            const path = `/browse/${issue.issueKey}`;
            // If onClick/handleClick is fired from a component underneath this component,
            // for example an <a> element, we preventDefault to stop the native link opening
            // behaviour, since that is managed here via window.open
            event.preventDefault();
            if ((0, $5gJbo.isMiddleClick)(event) || (0, $5gJbo.isCmdOrCtrlClick)(event)) {
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'relatedIssue clicked', {
                    newTabOpened: true,
                    position: issue.position,
                    relatedIssueId: issue.id
                });
                window.open(path, '_blank');
            } else {
                // normal click
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'relatedIssue clicked', {
                    newTabOpened: false,
                    position: issue.position,
                    relatedIssueId: issue.id
                });
                window.location.assign(path);
            }
        }
    };
    const handleTryAgain = ()=>{
        fetchRelatedIssuesForIssue(sessionId, createAnalyticsEvent, queryText);
    };
    const issues = relatedIssues[status];
    const isInitialState = !isLoading && issues === undefined && error === undefined;
    // // when the panel is first opened, there are no issues hence load in this case too
    if (isLoading || isInitialState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUWtP.default), null);
    if (issues) {
        if (issues.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cT4kl.default), null);
        const displayedIssues = showMoreExpanded ? issues : issues.slice(0, $6bcab253b0ea7628$export$15e2337b15d89c0c);
        const renderShowMoreIfIssuesOverflow = ()=>issues.length > $6bcab253b0ea7628$export$15e2337b15d89c0c && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijb9H.default), {
                isShowMoreExpanded: showMoreExpanded,
                onExpand: ()=>setShowMoreExpanded(true),
                issuesLength: issues.length
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6bcab253b0ea7628$var$FlexContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6bcab253b0ea7628$var$CardGroupContainer, {
            isExpanded: showMoreExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQylF.ItemLineCardGroup), {
            items: displayedIssues,
            groupId: sessionId,
            onClick: handleClick
        }, ({ item: issue })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1auvT.default), issue)), renderShowMoreIfIssuesOverflow()));
    }
    // if all conditions not met above, return error
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cG43M.default), {
        onTryAgain: handleTryAgain
    });
};
var $6bcab253b0ea7628$export$2e2bcd8739ae039 = $6bcab253b0ea7628$var$IssueLineCardGroup;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6bcab253b0ea7628$var$FlexContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $6bcab253b0ea7628$var$CardGroupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $6bcab253b0ea7628$var$FlexContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _1bsb1osq _c71lp3fh _q841glyw _1v52glyw _4jw6idpf",
            __cmplp.isExpanded && "_18m915zi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cG43M", function(module, exports) {

$parcel$export(module.exports, "default", () => $06e2292da7213f40$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $96IgR = parcelRequire("96IgR");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $4ksts = parcelRequire("4ksts");

var $lbJqf = parcelRequire("lbJqf");
const $06e2292da7213f40$var$ErrorFeedback = ({ onTryAgain: onTryAgain, useIntl: useIntl = (0, $4ksts.useIntlV2) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const renderErrorIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $06e2292da7213f40$var$errorIconWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            label: "error",
            primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA.R300)})`
        }));
    const renderTryAgainLink = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            onClick: onTryAgain,
            interactionName: "auto-generated.jira-smart-related-issues-panel.ui.issue-line-card-group.error-feedback.button"
        }, formatMessage((0, $lbJqf.default).tryAgainLink));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($06e2292da7213f40$var$ErrorFeedbackContainer, null, renderErrorIcon(), formatMessage((0, $lbJqf.default).errorMessage), renderTryAgainLink());
};
var $06e2292da7213f40$export$2e2bcd8739ae039 = $06e2292da7213f40$var$ErrorFeedback;
const $06e2292da7213f40$var$errorIconWrapperStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06e2292da7213f40$var$ErrorFeedbackContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lbJqf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9da83412b6fe9fc6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9da83412b6fe9fc6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "smart-related-issues-panel.issue-line-card-group.error-feedback.error-message",
        "defaultMessage": "We couldn't load any similar requests."
    },
    tryAgainLink: {
        "id": "smart-related-issues-panel.issue-line-card-group.error-feedback.try-again-link",
        "defaultMessage": "Try again?"
    }
});

});


parcelRegister("1auvT", function(module, exports) {

$parcel$export(module.exports, "default", () => $24537bb1ca49b0b8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hUwRB = parcelRequire("hUwRB");

var $8cU5f = parcelRequire("8cU5f");

var $hnzPP = parcelRequire("hnzPP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lqalZ = parcelRequire("lqalZ");

var $gbMaY = parcelRequire("gbMaY");

var $49xWy = parcelRequire("49xWy");

var $a4k1u = parcelRequire("a4k1u");
const $24537bb1ca49b0b8$var$IssueLineCard = ({ id: id, issueTypeIconUrl: issueTypeIconUrl, issueTypeName: issueTypeName, issueKey: issueKey, issueSummary: issueSummary, onAddIssueLinkClick: onAddIssueLinkClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const title = formatMessage((0, $a4k1u.messages).issueTypeName, {
        issueTypeName: issueTypeName
    });
    // We only want the JSM Similar Issues panel's "Link" button to show up if the standard
    // Jira linking panel dropdown has a local Jira instance selected. This is because the JSM
    // Similar Issues panel just shows related issues from the same instance, so we only want to
    // offer linking if the same instance is selected.
    const [{ isLinkingToLocalJira: isLinkingToLocalJira }] = (0, $gbMaY.useIssueLinkLocality)();
    const issueLink = `/browse/${issueKey}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($24537bb1ca49b0b8$var$StyledIssueButton, {
        appearance: "link",
        href: issueLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
            alt: title,
            url: issueTypeIconUrl
        })
    }, issueKey, " ", issueSummary), isLinkingToLocalJira && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $a4k1u.messages).issueLinkingButton),
        position: "left"
    }, ({ ref: ref, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($24537bb1ca49b0b8$var$StyledLinkingButton, {
            ref: ref,
            appearance: "subtle",
            spacing: "compact",
            ...tooltipProps,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
                label: ""
            }),
            "aria-label": formatMessage((0, $a4k1u.messages).issueLinkingButtonAriaLabel),
            onClick: (event)=>{
                event.stopPropagation(); // to not 'click' the panel beneath the button
                onAddIssueLinkClick({
                    id: id,
                    iconUrl: issueTypeIconUrl,
                    value: issueKey,
                    fullObject: {
                        id: Number(id),
                        key: issueKey,
                        keyHtml: issueKey,
                        img: issueTypeIconUrl,
                        summary: issueSummary,
                        summaryText: issueSummary // if not specified- other links re-render on add
                    }
                });
            }
        })));
};
var $24537bb1ca49b0b8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $lqalZ.connect)(null, {
    onAddIssueLinkClick: (0, $49xWy.addIssueLinkClick)
})($24537bb1ca49b0b8$var$IssueLineCard);
const $24537bb1ca49b0b8$var$StyledIssueButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});
$24537bb1ca49b0b8$var$StyledIssueButton.displayName = 'StyledIssueButton'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $24537bb1ca49b0b8$var$StyledLinkingButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01wug _1wpz1h6o",
            __cmplp.className
        ])
    });
});
$24537bb1ca49b0b8$var$StyledLinkingButton.displayName = 'StyledLinkingButton';

});
parcelRegister("a4k1u", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f6200d928f420aa9$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $f6200d928f420aa9$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issueTypeName: {
        "id": "smart-related-issues-panel.issue-line-card-group.issue-line-card.issue-type-name",
        "defaultMessage": "{issueTypeName}"
    },
    issueLinkingButton: {
        "id": "smart-related-issues-panel.issue-line-card-group.issue-line-card.issue-linking-button",
        "defaultMessage": "Link issue"
    },
    issueLinkingButtonAriaLabel: {
        "id": "smart-related-issues-panel.issue-line-card-group.issue-line-card.issue-linking-button-aria-label",
        "defaultMessage": "Link issue"
    }
});

});


parcelRegister("cT4kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $efb6c3a1c996540d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $2bv8J = parcelRequire("2bv8J");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $4ksts = parcelRequire("4ksts");

var $hJ992 = parcelRequire("hJ992");

var $e6jgF = parcelRequire("e6jgF");
const $efb6c3a1c996540d$var$NoIssuesFeedback = ({ useIntl: useIntl = (0, $4ksts.useIntlV2) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const baseUrl = '';
    const projectKey = (0, $hJ992.useProjectKey)();
    const redirectUrl = `${baseUrl}/jira/servicedesk/projects/${projectKey}/issues`;
    const renderErrorIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $efb6c3a1c996540d$var$infoIconWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
            label: "info",
            primaryColor: `var(--ds-text-information, ${(0, $PdmhA.B500)})`
        }));
    const renderTryAgainLink = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            target: "_blank",
            href: redirectUrl,
            interactionName: "auto-generated.jira-smart-related-issues-panel.ui.issue-line-card-group.no-issues-feedback.button"
        }, formatMessage((0, $e6jgF.default).searchLink));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($efb6c3a1c996540d$var$NoIssuesFeedbackContainer, null, renderErrorIcon(), formatMessage((0, $e6jgF.default).errorMessage), renderTryAgainLink());
};
var $efb6c3a1c996540d$export$2e2bcd8739ae039 = $efb6c3a1c996540d$var$NoIssuesFeedback;
const $efb6c3a1c996540d$var$infoIconWrapperStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efb6c3a1c996540d$var$NoIssuesFeedbackContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e6jgF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a612b3a4085ac4ce$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a612b3a4085ac4ce$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "smart-related-issues-panel.issue-line-card-group.no-issues-feedback.error-message",
        "defaultMessage": "We couldn't find any similar requests."
    },
    searchLink: {
        "id": "smart-related-issues-panel.issue-line-card-group.no-issues-feedback.search-link",
        "defaultMessage": "Search instead?"
    }
});

});


parcelRegister("ijb9H", function(module, exports) {

$parcel$export(module.exports, "default", () => $287e3cab4b48df07$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $fipS7 = parcelRequire("fipS7");
const $287e3cab4b48df07$var$ShowMoreExpander = ({ issuesLength: issuesLength, isShowMoreExpanded: isShowMoreExpanded, onExpand: onExpand })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleExpand = (event, analyticsEvent)=>{
        onExpand();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'showMoreRelatedIssues', {
            issuesLength: issuesLength
        });
    };
    const renderShowMoreIssuesButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($287e3cab4b48df07$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            onClick: handleExpand,
            interactionName: "auto-generated.jira-smart-related-issues-panel.ui.issue-line-card-group.show-more.button"
        }, formatMessage((0, $fipS7.default).show)));
    return isShowMoreExpanded ? null : renderShowMoreIssuesButton();
};
var $287e3cab4b48df07$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $287e3cab4b48df07$var$ShowMoreExpander;
const $287e3cab4b48df07$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81bpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fipS7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ede7165dc02cef23$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ede7165dc02cef23$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    show: {
        "id": "smart-related-issues-panel.issue-line-card-group.show-more.show",
        "defaultMessage": "Show more"
    }
});

});


parcelRegister("lUWtP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9356a8aca42e4c1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $9VPEO = parcelRequire("9VPEO");
const $e9356a8aca42e4c1$var$LoadingSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $e9356a8aca42e4c1$var$loadingWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9356a8aca42e4c1$var$LineItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "6%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "90%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9356a8aca42e4c1$var$LineItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "6%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "90%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9356a8aca42e4c1$var$LineItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "6%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "90%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9356a8aca42e4c1$var$LineItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "6%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "90%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9356a8aca42e4c1$var$LineItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "6%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "90%"
    })));
var $e9356a8aca42e4c1$export$2e2bcd8739ae039 = $e9356a8aca42e4c1$var$LoadingSkeleton;
const $e9356a8aca42e4c1$var$loadingWrapperStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e9356a8aca42e4c1$var$LineItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1yb4 _otyru2gc",
            __cmplp.className
        ])
    });
});

});


parcelRegister("a2ZZm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6514000f9ad9ad9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $35lgY = parcelRequire("35lgY");

var $dircn = parcelRequire("dircn");
var $5LZUd = parcelRequire("5LZUd");

var $arMK7 = parcelRequire("arMK7");

var $4TCDT = parcelRequire("4TCDT");
const $d6514000f9ad9ad9$var$IssueStatusButton = ({ buttonKey: buttonKey, name: name, isDisabled: isDisabled, isSelected: isSelected, onSelectIssueStatusItem: onSelectIssueStatusItem, formatMessage: formatMessage })=>{
    const getAriaLabel = (key)=>{
        if (key === (0, $35lgY.OPEN)) return formatMessage((0, $arMK7.default).openAriaLabel);
        if (key === (0, $35lgY.RESOLVED)) return formatMessage((0, $arMK7.default).resolvedAriaLabel);
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6514000f9ad9ad9$var$StyledStatusButton, {
        spacing: "compact",
        key: buttonKey,
        isDisabled: isDisabled,
        isSelected: isSelected && !isDisabled,
        onClick: (_, analyticsEvent)=>onSelectIssueStatusItem(buttonKey, analyticsEvent, 'IssueStatusButton'),
        "aria-label": getAriaLabel(buttonKey)
    }, name);
};
const $d6514000f9ad9ad9$var$StatusTabs = ({ sessionId: sessionId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ data: data, status: status, isLoading: isLoading, error: error }, { fetchRelatedIssuesForIssue: fetchRelatedIssuesForIssue, setIssueStatus: setIssueStatus }] = (0, $5LZUd.useRelatedIssuesForIssue)();
    const hasOpenIssues = (data.OPEN?.length ?? 0) > 0;
    const hasResolvedIssues = (data.RESOLVED?.length ?? 0) > 0;
    const isInitialState = !isLoading && data[0, $35lgY.OPEN] === undefined && data[0, $35lgY.RESOLVED] === undefined && error === undefined;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const queryText = (0, $dircn.useQueryText)();
    const handleSelectIssueStatusItem = (selectedStatus, analyticsEvent, subject)=>{
        if (status !== selectedStatus) {
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, subject, {
                selectedStatusFilter: selectedStatus
            });
            setIssueStatus(selectedStatus);
            fetchRelatedIssuesForIssue(sessionId, createAnalyticsEvent, queryText);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6514000f9ad9ad9$var$TabContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6514000f9ad9ad9$var$ShowTextContainer, null, formatMessage((0, $arMK7.default).filterBy)), isLoading || isInitialState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TCDT.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6514000f9ad9ad9$var$IssueStatusButton, {
        buttonKey: (0, $35lgY.OPEN),
        name: formatMessage((0, $arMK7.default).open),
        isSelected: (0, $35lgY.OPEN) === status,
        onSelectIssueStatusItem: handleSelectIssueStatusItem,
        isDisabled: !hasOpenIssues,
        formatMessage: formatMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6514000f9ad9ad9$var$IssueStatusButton, {
        buttonKey: (0, $35lgY.RESOLVED),
        name: formatMessage((0, $arMK7.default).resolved),
        isSelected: (0, $35lgY.RESOLVED) === status,
        onSelectIssueStatusItem: handleSelectIssueStatusItem,
        isDisabled: !hasResolvedIssues,
        formatMessage: formatMessage
    })));
};
var $d6514000f9ad9ad9$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d6514000f9ad9ad9$var$StatusTabs;
const $d6514000f9ad9ad9$var$StyledStatusButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4f4df _18s8f4df",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d6514000f9ad9ad9$var$TabContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _19pku2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d6514000f9ad9ad9$var$ShowTextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _1ul9idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("arMK7", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd4d48586e66038a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bd4d48586e66038a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterBy: {
        "id": "smart-related-issues-panel.status-tabs.filter-by",
        "defaultMessage": "Show:"
    },
    open: {
        "id": "smart-related-issues-panel.status-tabs.open",
        "defaultMessage": "Open"
    },
    resolved: {
        "id": "smart-related-issues-panel.status-tabs.resolved",
        "defaultMessage": "Resolved"
    },
    openAriaLabel: {
        "id": "smart-related-issues-panel.status-tabs.open-aria-label",
        "defaultMessage": "Show open issues"
    },
    resolvedAriaLabel: {
        "id": "smart-related-issues-panel.status-tabs.resolved-aria-label",
        "defaultMessage": "Show resolved issues"
    }
});

});

parcelRegister("4TCDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $58be523cd176c4d4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $9VPEO = parcelRequire("9VPEO");
const $58be523cd176c4d4$var$LoadingSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($58be523cd176c4d4$var$LineItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "24px",
        width: "48px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $58be523cd176c4d4$var$skeletonDividerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "24px",
        width: "48px"
    }));
var $58be523cd176c4d4$export$2e2bcd8739ae039 = $58be523cd176c4d4$var$LoadingSkeleton;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58be523cd176c4d4$var$LineItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66 _1e0c1txw _2lx2vrvc _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $58be523cd176c4d4$var$skeletonDividerStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.100'
});

});



parcelRegister("iXqdc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f5f7c74aa9bbb1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $35lgY = parcelRequire("35lgY");

var $5LZUd = parcelRequire("5LZUd");

var $aWJLE = parcelRequire("aWJLE");

var $1xABo = parcelRequire("1xABo");

var $gr7Z2 = parcelRequire("gr7Z2");

var $9GNwT = parcelRequire("9GNwT");

var $dAy2A = parcelRequire("dAy2A");
const $c8f5f7c74aa9bbb1$export$ddbb72651944dc57 = ({ sessionId: sessionId, defaultExpanded: defaultExpanded })=>{
    const [isExpanded, setExpanded] = (0, $eUqFw.useState)(Boolean(defaultExpanded));
    const [showMore, setShowMore] = (0, $eUqFw.useState)(false);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ similarIncidentData: similarIncidentData }, { fetchRelatedIncidentsForIssue: fetchRelatedIncidentsForIssue }] = (0, $5LZUd.useRelatedIncidentsForIssue)();
    (0, $eUqFw.useEffect)(()=>{
        async function fetchData() {
            await fetchRelatedIncidentsForIssue(createAnalyticsEvent);
            setIsLoading(false);
        }
        if (isExpanded) fetchData();
    }, [
        fetchRelatedIncidentsForIssue,
        createAnalyticsEvent,
        isExpanded
    ]);
    const handleShowMore = ()=>{
        setShowMore(true);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'showMoreButton clicked', {
            suggestionId: similarIncidentData.suggestionId
        });
    };
    const renderSimilarIncidentsBody = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, similarIncidentData && similarIncidentData.similarIssues.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c8f5f7c74aa9bbb1$var$FieldsContainer, {
            "data-testid": "smart-related-issues-panel.ui.similar-incidents.similar-incidents-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), similarIncidentData.similarIssues.slice(0, (0, $35lgY.DEFAULT_SIMILAR_INCIDENTS_CARD)).map((curr, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9GNwT.default), {
                suggestionId: similarIncidentData.suggestionId,
                currentIncident: curr,
                rank: index,
                key: index
            })), showMore && similarIncidentData.similarIssues.slice((0, $35lgY.DEFAULT_SIMILAR_INCIDENTS_CARD), (0, $35lgY.MAX_SIMILAR_INCIDENTS_CARD)).map((curr, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9GNwT.default), {
                suggestionId: similarIncidentData.suggestionId,
                currentIncident: curr,
                rank: index,
                key: index
            })), !showMore && similarIncidentData.similarIssues.length > 3 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            onClick: handleShowMore,
            interactionName: "auto-generated.jira-smart-related-issues-panel.ui.similar-incidents.button"
        }, formatMessage((0, $gr7Z2.default).showMoreButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aWJLE.default), {
            sessionId: sessionId,
            suggestionId: similarIncidentData.suggestionId
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c8f5f7c74aa9bbb1$var$FieldsContainer, {
            "data-testid": "smart-related-issues-panel.ui.similar-incidents.similar-incidents-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, " ", formatMessage((0, $gr7Z2.default).noSimilarIncidents), " ")));
    const renderSimilarIncidents = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1xABo.default), {
            sessionId: sessionId,
            onExpand: ()=>setExpanded(true),
            onCollapse: ()=>{
                setShowMore(false);
                setExpanded(false);
            },
            isExpanded: isExpanded
        }), isExpanded && isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAy2A.default), null), isExpanded && !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c8f5f7c74aa9bbb1$var$PanelBody, null, renderSimilarIncidentsBody()));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c8f5f7c74aa9bbb1$var$SimilarIncidentsContainer, null, renderSimilarIncidents());
};
var $c8f5f7c74aa9bbb1$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $c8f5f7c74aa9bbb1$export$ddbb72651944dc57;
const $c8f5f7c74aa9bbb1$var$SimilarIncidentsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c8f5f7c74aa9bbb1$var$PanelBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr1ejb _1e0c1txw _2lx21bp4 _mrkb1y44 _1o0z1y44 _n7zlh6cr _1kl7h6cr _1s7zh6cr _bfhkvuon _19bvu2gc _u5f3u2gc _n3tdu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c8f5f7c74aa9bbb1$var$FieldsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aWJLE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f487034e3409fe85$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hiKXE = parcelRequire("hiKXE");

var $la2bN = parcelRequire("la2bN");
const $f487034e3409fe85$export$ba15e66552bb5dac = (props)=>{
    const [feedbackGiven, setFeedbackGiven] = (0, $eUqFw.useState)(false);
    const { openRelatedIssuesFeedback: openRelatedIssuesFeedback } = (0, $hiKXE.useRelatedIssuesFeedbackCollector)(props.sessionId);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const feedbackFlow = (event, feedback)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'similarIncidentOverallFeedback clicked', {
            isHelpful: feedback,
            suggestionId: props.suggestionId
        });
        setFeedbackGiven(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f487034e3409fe85$var$FeedbackWrapper, null, !feedbackGiven ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, " ", formatMessage((0, $la2bN.default).areTheseRelevant), "\xa0\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        label: formatMessage((0, $la2bN.default).yes),
        onClick: (e)=>feedbackFlow(e, formatMessage((0, $la2bN.default).yes)),
        interactionName: "auto-generated.jira-smart-related-issues-panel.ui.similar-incidents.feedback.button"
    }, formatMessage((0, $la2bN.default).yes)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        label: formatMessage((0, $la2bN.default).no),
        onClick: (e)=>feedbackFlow(e, formatMessage((0, $la2bN.default).no)),
        interactionName: "auto-generated.jira-smart-related-issues-panel.ui.similar-incidents.feedback.button1"
    }, formatMessage((0, $la2bN.default).no)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $la2bN.default).thanksForFeedback), "\xa0", formatMessage((0, $la2bN.default).toImproveFutureResultsWithPlaceholder, {
        tellUsMore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            spacing: "none",
            onClick: openRelatedIssuesFeedback,
            interactionName: "auto-generated.jira-smart-related-issues-panel.ui.similar-incidents.feedback.button2"
        }, formatMessage((0, $la2bN.default).tellUsMore), "\xa0")
    })));
};
var $f487034e3409fe85$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f487034e3409fe85$export$ba15e66552bb5dac;
const $f487034e3409fe85$var$FeedbackWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _vwz4zwfg _ca0qpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("la2bN", function(module, exports) {

$parcel$export(module.exports, "default", () => $be8636d6336f3f7c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $be8636d6336f3f7c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    areTheseRelevant: {
        "id": "smart-related-issues-panel.similar-incidents.feedback.are-these-relevant",
        "defaultMessage": "Are these results relevant?"
    },
    tellUsMore: {
        "id": "smart-related-issues-panel.similar-incidents.feedback.tell-us-more",
        "defaultMessage": "Tell us more"
    },
    toImproveFutureResultsWithPlaceholder: {
        "id": "smart-related-issues-panel.similar-incidents.feedback.to-improve-future-results-with-placeholder",
        "defaultMessage": "{tellUsMore} to improve future results."
    },
    thanksForFeedback: {
        "id": "smart-related-issues-panel.similar-incidents.feedback.thanks-for-feedback",
        "defaultMessage": "Thanks for your feedback! "
    },
    yes: {
        "id": "smart-related-issues-panel.similar-incidents.feedback.yes",
        "defaultMessage": "Yes"
    },
    no: {
        "id": "smart-related-issues-panel.similar-incidents.feedback.no",
        "defaultMessage": "No"
    }
});

});


parcelRegister("1xABo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cb6292d23b8e1b7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bLFgh = parcelRequire("bLFgh");

var $ffiyv = parcelRequire("ffiyv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iAc02 = parcelRequire("iAc02");

var $sAUNc = parcelRequire("sAUNc");

var $l7qBM = parcelRequire("l7qBM");

var $5yXRi = parcelRequire("5yXRi");
const $7cb6292d23b8e1b7$var$SimilarIncidentsPanelHeader = ({ onExpand: onExpand, onCollapse: onCollapse, isExpanded: isExpanded })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleHeaderClick = ()=>isExpanded ? onCollapse() : onExpand();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb6292d23b8e1b7$var$HeaderWrapper, {
        onClick: handleHeaderClick,
        isExpanded: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb6292d23b8e1b7$var$HeaderTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5yXRi.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb6292d23b8e1b7$var$HeaderTitle, null, "\xa0\xa0", formatMessage((0, $l7qBM.default).title), "\xa0\xa0\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "new"
    }, formatMessage((0, $l7qBM.default).new)), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cb6292d23b8e1b7$var$HeaderDescription, null, formatMessage((0, $l7qBM.default).description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sAUNc.default), {
        isContentExpanded: isExpanded,
        onExpand: onExpand,
        onCollapse: onCollapse
    })));
};
var $7cb6292d23b8e1b7$export$2e2bcd8739ae039 = $7cb6292d23b8e1b7$var$SimilarIncidentsPanelHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7cb6292d23b8e1b7$var$HeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1yb4 _4cvr1h6o _19pk1k9i _otyr11di _2rko1y44 _19ith6cr _bfhkvuon _1yt4pxbi _2it8glyw _nt75194a _1du212yw _1v3l12yw _19lc12yw _1372tlke _1pjhtlke _d0altlke _1di6tmi0 _q4zta5ev",
            __cmplp.isExpanded && "_mrkbidpf _1o0zidpf _otyridpf",
            __cmplp.className
        ])
    });
});
const $7cb6292d23b8e1b7$var$HeaderTextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $iAc02.SectionHeading), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _1ul9idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7cb6292d23b8e1b7$var$HeaderTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7cb6292d23b8e1b7$var$HeaderDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _18s814rb _1bto1l2s _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("sAUNc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfc70239fe3430fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $5xnoX = parcelRequire("5xnoX");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $lmY8Y = parcelRequire("lmY8Y");
const $bfc70239fe3430fd$var$ContentSectionExpander = ({ isContentExpanded: isContentExpanded, onExpand: onExpand, onCollapse: onCollapse })=>{
    const handleExpand = (event, analyticsEvent)=>{
        onExpand();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'showSimilarIncidents', {
            similarIncidentsPanel: true
        });
    };
    const handleCollapse = (event, analyticsEvent)=>{
        onCollapse();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'hideSimilarIncidents');
    };
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderShowIssuesButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            "aria-label": formatMessage((0, $lmY8Y.default).show),
            appearance: "subtle-link",
            spacing: "default",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: "ChevronDownIcon",
                size: "large"
            }),
            onClick: handleExpand,
            interactionName: "auto-generated.jira-smart-related-issues-panel.ui.similar-incidents.header.expander.button"
        });
    const renderHideIssuesButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            "aria-label": formatMessage((0, $lmY8Y.default).hide),
            appearance: "subtle-link",
            spacing: "default",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))), {
                label: "ChevronUpIcon",
                size: "large"
            }),
            onClick: handleCollapse,
            interactionName: "auto-generated.jira-smart-related-issues-panel.ui.similar-incidents.header.expander.button1"
        });
    return isContentExpanded ? renderHideIssuesButton() : renderShowIssuesButton();
};
var $bfc70239fe3430fd$export$2e2bcd8739ae039 = $bfc70239fe3430fd$var$ContentSectionExpander;

});
parcelRegister("lmY8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce216dfd9f0f5411$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ce216dfd9f0f5411$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    show: {
        "id": "smart-related-issues-panel.similar-incidents.header.expander.show",
        "defaultMessage": "Show"
    },
    hide: {
        "id": "smart-related-issues-panel.similar-incidents.header.expander.hide",
        "defaultMessage": "Hide"
    }
});

});


parcelRegister("l7qBM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b10782c14eb28a55$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b10782c14eb28a55$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    whatIsThis: {
        "id": "smart-related-issues-panel.similar-incidents.header.what-is-this",
        "defaultMessage": "What is this?"
    },
    feedback: {
        "id": "smart-related-issues-panel.similar-incidents.header.feedback",
        "defaultMessage": "Give feedback"
    },
    new: {
        "id": "smart-related-issues-panel.similar-incidents.header.new",
        "defaultMessage": "New"
    },
    title: {
        "id": "smart-related-issues-panel.similar-incidents.header.title",
        "defaultMessage": "Similar incidents"
    },
    description: {
        "id": "smart-related-issues-panel.similar-incidents.header.description",
        "defaultMessage": "Incidents from the past that may help in investigating and resolving this incident"
    },
    modalTitle: {
        "id": "smart-related-issues-panel.similar-incidents.header.modal-title",
        "defaultMessage": "What are similar incidents?"
    },
    modalClose: {
        "id": "smart-related-issues-panel.similar-incidents.header.modal-close",
        "defaultMessage": "Close"
    },
    modalDescriptionFirst: {
        "id": "smart-related-issues-panel.similar-incidents.header.modal-description-first",
        "defaultMessage": "We\u2019ll show you incidents from the past that are similar to the one you\u2019re viewing, so you can use information from them to investigate and resolve the incident faster."
    },
    mmodalDescriptionSecond: {
        "id": "smart-related-issues-panel.similar-incidents.header.mmodal-description-second",
        "defaultMessage": "We use algorithms that look for underlying categories and semantic similarities in the summary and description fields of past incidents from the project, and finally show you the top 5 results."
    }
});

});

parcelRegister("5yXRi", function(module, exports) {

$parcel$export(module.exports, "default", () => $28269f66023a6772$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $PdmhA = parcelRequire("PdmhA");
const $28269f66023a6772$var$CustomGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_486_1511)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15.2654 7.508L11.3102 6.044L9.83335 1.20356C9.77646 1.01689 9.60358 0.888889 9.40846 0.888889C9.21335 0.888889 9.04046 1.01689 8.98357 1.20356L7.50713 6.044L3.55157 7.508C3.37691 7.57289 3.26135 7.73867 3.26135 7.92489C3.26135 8.11067 3.37691 8.27733 3.55157 8.34178L7.50491 9.80533L8.98224 14.7933C9.03824 14.9818 9.21158 15.1111 9.40846 15.1111C9.60491 15.1111 9.77869 14.9818 9.83469 14.7929L11.312 9.80489L15.2658 8.34133C15.4396 8.27733 15.5556 8.11111 15.5556 7.92489C15.5556 7.73911 15.4396 7.57289 15.2654 7.508Z",
        fill: `var(--ds-icon-accent-purple, ${(0, $PdmhA).P400})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.37646 12.3973L5.34801 12.0169L4.94801 10.5502C4.89557 10.3564 4.72001 10.2222 4.51957 10.2222C4.31912 10.2222 4.14357 10.3564 4.09068 10.5498L3.69068 12.0164L2.66268 12.3969C2.48801 12.4613 2.37246 12.628 2.37246 12.8138C2.37246 12.9996 2.48801 13.1662 2.66268 13.2307L3.68535 13.6098L4.08846 15.2196C4.13824 15.4169 4.31557 15.5556 4.51957 15.5556C4.72357 15.5556 4.9009 15.4169 4.95068 15.2191L5.35379 13.6093L6.37646 13.2302C6.55112 13.1662 6.66668 12.9996 6.66668 12.8138C6.66668 12.628 6.55112 12.4613 6.37646 12.3973ZM4.44846 2.76933L3.39779 2.38044L3.00846 1.32933C2.94401 1.15466 2.77779 1.03911 2.59157 1.03911C2.40579 1.03911 2.23957 1.15466 2.17468 1.32933L1.78579 2.38044L0.73468 2.76933C0.560014 2.83422 0.444458 3.00044 0.444458 3.18622C0.444458 3.372 0.560014 3.53866 0.73468 3.60311L1.78579 3.992L2.17468 5.04311C2.23957 5.21777 2.40579 5.33333 2.59157 5.33333C2.77735 5.33333 2.94357 5.21777 3.00846 5.04311L3.39735 3.992L4.44846 3.60311C4.62312 3.53822 4.73868 3.372 4.73868 3.18622C4.73868 3.00044 4.62312 2.83422 4.44846 2.76933Z",
        fill: `var(--ds-icon-accent-purple, ${(0, $PdmhA).P400})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_486_1511"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        fill: `var(--ds-icon, ${(0, $PdmhA).N100})`
    }))));
const $28269f66023a6772$var$SparklesIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $28269f66023a6772$var$CustomGlyph,
        label: ""
    });
var $28269f66023a6772$export$2e2bcd8739ae039 = $28269f66023a6772$var$SparklesIcon;

});


parcelRegister("gr7Z2", function(module, exports) {

$parcel$export(module.exports, "default", () => $985848f7fbbf981f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $985848f7fbbf981f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showMoreButton: {
        "id": "smart-related-issues-panel.similar-incidents.show-more-button",
        "defaultMessage": "View More"
    },
    noSimilarIncidents: {
        "id": "smart-related-issues-panel.similar-incidents.no-similar-incidents",
        "defaultMessage": "There are no similar incidents for this issue."
    }
});

});

parcelRegister("9GNwT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3264646556e8c0f6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6R0C9 = parcelRequire("6R0C9");
var $iJlfe = parcelRequire("iJlfe");

var $9nkwJ = parcelRequire("9nkwJ");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $dJBxy = parcelRequire("dJBxy");

var $ajCg0 = parcelRequire("ajCg0");

var $fvQWm = parcelRequire("fvQWm");

var $aOw1G = parcelRequire("aOw1G");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $xeS7R = parcelRequire("xeS7R");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $35lgY = parcelRequire("35lgY");

var $vvoMA = parcelRequire("vvoMA");

var $18hnU = parcelRequire("18hnU");
const $3264646556e8c0f6$var$getIssueUri = (issueKey)=>`/browse/${issueKey}`;
const $3264646556e8c0f6$export$19395d2b7f2024c9 = (props)=>{
    const [expanded, setExpanded] = (0, $eUqFw.useState)(Boolean(props.defaultExpanded));
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [message, setMessage] = (0, $eUqFw.useState)('');
    const [hasVoted, setHasVoted] = (0, $eUqFw.useState)({
        hasVotedLike: false,
        hasVotedDislike: false
    });
    const affectedServicesFirstThree = props.currentIncident && props.currentIncident.affectedServices && props.currentIncident.affectedServices.slice(0, 3) || [];
    const analyticsEventData = {
        suggestionId: props.suggestionId,
        rank: props.rank + 1 || 0,
        createdAt: props.currentIncident.createdAt,
        priority: props.currentIncident.priority.id,
        isPirPresent: props.currentIncident.pir && props.currentIncident.pir.length > 0 || false,
        relevanceScore: props.currentIncident.relevanceScore,
        similarityScore: props.currentIncident.similarityScore,
        affectedServices: props.currentIncident.affectedServices && props.currentIncident.affectedServices.length || 0
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const closeModal = ()=>{
        setIsOpen(false);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'similarIncidentFeedbackModalSubmit clicked', {
            issueId: props.currentIncident.id,
            reason: message,
            ...analyticsEventData
        });
    };
    const expand = (event, analyticsEvent)=>{
        if (!expanded) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'similarIncidentCardExpanded', {
            issueId: props.currentIncident.id,
            ...analyticsEventData
        });
        setExpanded(!expanded);
    };
    const vote = (input, reason)=>{
        input === (0, $35lgY.LIKE) ? (setHasVoted({
            hasVotedLike: true,
            hasVotedDislike: false
        }), (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'similarIncidentPositive clicked', {
            issueId: props.currentIncident.id,
            isHelpful: true,
            ...analyticsEventData
        })) : (setHasVoted({
            hasVotedLike: false,
            hasVotedDislike: true
        }), (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'similarIncidentNegative clicked', {
            issueId: props.currentIncident.id,
            isHelpful: false,
            reason: reason,
            ...analyticsEventData
        }));
    };
    const handleLinkClick = (event, type)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), `similarIncident${type}Link clicked`, {
            issueId: props.currentIncident.id,
            ...analyticsEventData
        });
    };
    const getServiceName = ()=>{
        const extractServiceNames = props.currentIncident.affectedServices.slice(3).map((item)=>item.name);
        const tooltipContent = extractServiceNames.join(', ');
        return tooltipContent;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$SimilarIncidentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$SimilarIncidentCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$IncidentIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dJBxy))), {
        label: "IncidentIcon"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$IncidentLinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$KeyButton, {
        onClick: (e)=>handleLinkClick(e, 'HotKey'),
        appearance: "link",
        href: $3264646556e8c0f6$var$getIssueUri(props.currentIncident.key)
    }, props.currentIncident.key), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$IncidentDateItem, null, formatDate(props.currentIncident.createdAt, {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: props.currentIncident.summary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$IncidentTitleSpan, null, " ", props.currentIncident.summary, " ")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$IncidentIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$TypeIcon, {
        src: props.currentIncident && props.currentIncident.priority && props.currentIncident.priority.iconUrl || ''
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$AvatarSpan, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: props.currentIncident && props.currentIncident.assignee && props.currentIncident.assignee.displayName || formatMessage((0, $18hnU.default).none)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6R0C9.default), {
        avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            src: props.currentIncident && props.currentIncident.assignee && props.currentIncident.assignee.avatarUrls && props.currentIncident.assignee.avatarUrls['48x48'] || ''
        }),
        secondaryText: props.currentIncident && props.currentIncident.assignee && props.currentIncident.assignee.displayName || formatMessage((0, $18hnU.default).none)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$ButtonIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: ()=>{
            vote((0, $35lgY.LIKE));
        },
        iconBefore: hasVoted.hasVotedLike ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $18hnU.default).helpful)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $vvoMA.default), {
            label: "LikeFilledIcon",
            size: "medium"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $18hnU.default).helpful)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fvQWm))), {
            label: "LikeIcon"
        })),
        appearance: "subtle",
        interactionName: "auto-generated.jira-smart-related-issues-panel.ui.similar-incidents.similar-incident-card.button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...btnProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$InvertButton, {
                ...btnProps,
                iconBefore: hasVoted.hasVotedDislike ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                    content: formatMessage((0, $18hnU.default).notHelpful)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $vvoMA.default), {
                    label: "DislikeFilledIcon",
                    size: "medium"
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                    content: formatMessage((0, $18hnU.default).notHelpful)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fvQWm))), {
                    label: "DislikeIcon"
                })),
                ref: triggerRef,
                appearance: "subtle"
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: ()=>{
            vote((0, $35lgY.DISLIKE), (0, $18hnU.default).dropdownMessagesfirstItem.defaultMessage);
        }
    }, formatMessage((0, $18hnU.default).dropdownMessagesfirstItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: ()=>{
            vote((0, $35lgY.DISLIKE), (0, $18hnU.default).dropdownMessageSecondItem.defaultMessage);
        }
    }, formatMessage((0, $18hnU.default).dropdownMessageSecondItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: ()=>{
            vote((0, $35lgY.DISLIKE), (0, $18hnU.default).dropdownMessagesThirdItem.defaultMessage);
        }
    }, formatMessage((0, $18hnU.default).dropdownMessagesThirdItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: ()=>{
            setIsOpen(true);
            vote((0, $35lgY.DISLIKE), (0, $18hnU.default).dropdownMessagesFourthItem.defaultMessage);
        }
    }, formatMessage((0, $18hnU.default).dropdownMessagesFourthItem)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$IncidentIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ajCg0))), {
            label: "DropdownIcon"
        }),
        appearance: "subtle",
        onClick: expand,
        interactionName: "auto-generated.jira-smart-related-issues-panel.ui.similar-incidents.similar-incident-card.button1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: closeModal,
        width: "400px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $18hnU.default).dislikeModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$ModalContentBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$OtherOptionDiv, null, formatMessage((0, $18hnU.default).dropdownMessagesFourthItem), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$IncidentIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ajCg0))), {
        label: "dropdownIcon"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xeS7R.default), {
        resize: "none",
        maxHeight: "80px",
        placeholder: formatMessage((0, $18hnU.default).textAreaPlaceHolder),
        onChange: (e)=>setMessage(e.target.value)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: closeModal,
        appearance: "subtle-link",
        interactionName: "auto-generated.jira-smart-related-issues-panel.ui.similar-incidents.similar-incident-card.button2"
    }, formatMessage((0, $18hnU.default).dislikeModalCloseButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: closeModal,
        appearance: "primary",
        autoFocus: true,
        interactionName: "auto-generated.jira-smart-related-issues-panel.ui.similar-incidents.similar-incident-card.button3"
    }, formatMessage((0, $18hnU.default).dislikeModalSubmitButton))))))), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$ExtendPanel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$ExtendPanelElement, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$ExtendPanelHeader, null, formatMessage((0, $18hnU.default).affectedServices)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$ExtendPanelItem, null, affectedServicesFirstThree.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$ServiceName, null, formatMessage((0, $18hnU.default).none)), affectedServicesFirstThree.length > 0 && affectedServicesFirstThree.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$ServiceName, {
            key: index
        }, `${affectedServicesFirstThree[index].name},`, "\xa0")), props.currentIncident.affectedServices && props.currentIncident.affectedServices.length > 3 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: getServiceName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), null, `+${props.currentIncident.affectedServices.length - (0, $35lgY.DEFAULT_SIMILAR_INCIDENTS_CARD)} More`)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$ExtendPanelElement, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$ExtendPanelHeader, null, formatMessage((0, $18hnU.default).pir)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$ExtendPanelItem, null, props.currentIncident && props.currentIncident.pir.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3264646556e8c0f6$var$ViewPIRButton, {
        appearance: "link",
        onClick: (e)=>handleLinkClick(e, 'Pir'),
        href: $3264646556e8c0f6$var$getIssueUri(props.currentIncident.pir[0].key)
    }, formatMessage((0, $18hnU.default).viewPir)) || formatMessage((0, $18hnU.default).none))))));
};
var $3264646556e8c0f6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3264646556e8c0f6$export$19395d2b7f2024c9;
const $3264646556e8c0f6$var$SimilarIncidentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _n3tdu2gc _ca0qu2gc _n7zl13y8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$SimilarIncidentCard = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3ickbl _1e0c1txw _2lx2vrvc _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$IncidentIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$ButtonIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1ul9ys9h _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$IncidentLinkWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1ul9ys9h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$KeyButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wybdlk8 _k48p1nn1 _y3gn1e5h _ca0q1y44 _4t3izwfg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$IncidentDateItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1wyb1skh _syaz1wmz _19pkidpf _18u0v77o _k48p1nn1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$IncidentTitleSpan = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _k48p1nn1 _4cvr1h6o _y3gn1e5h _vwz4ckbl _1bsb7ivc _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$AvatarSpan = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbbv7e _vwz4myb0 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$ExtendPanel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3ivbgk _bfhk10p6 _1e0c1txw _2lx2vrvc _ca0qutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$ExtendPanelElement = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _18u0u2gc _2lx21bp4 _1yt4yg4n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$ExtendPanelHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1wyb1crf _k48pni7l _syaz1rr7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$ExtendPanelItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1n261g80 _1wybdlk8 _k48p1nn1 _1bsbpu96",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$ViewPIRButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1bs0 _ca0qyh40 _19bvidpf _y3gn1e5h _18u01n1a _1bsbys9h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$TypeIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i7vkz _1bsb7vkz _2hwxv77o _s7n4nkob _1e0c116y _n3td1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$InvertButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_t9ecg123",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$ModalContentBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4t3ibv7e _2lx21bp4 _19bv1ejb _u5f31ejb _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$OtherOptionDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1ylp _19bvu2gc _u5f3u2gc _vwz41ylp _bfhk1hxd _1e0c1txw _1wybdlk8 _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3264646556e8c0f6$var$ServiceName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i7vkz _1wybdlk8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dJBxy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ffc990e67b4a90e$var$_react = $9ffc990e67b4a90e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9ffc990e67b4a90e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9ffc990e67b4a90e$var$Incident24Icon = (props)=>/*#__PURE__*/ $9ffc990e67b4a90e$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M8.829 12l-.906 3h8.154l-.906-3H8.83zm.604-2h5.134l-1.61-5.332a1 1 0 00-1.914 0L9.433 10zM17 17H6a1 1 0 00-1 1v2h14v-2a1 1 0 00-1-1h-1zM3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3z"/></svg>`
    }, props, {
        size: "medium"
    }));
$9ffc990e67b4a90e$var$Incident24Icon.displayName = 'Incident24Icon';
var $9ffc990e67b4a90e$var$_default = $9ffc990e67b4a90e$var$Incident24Icon;
module.exports.default = $9ffc990e67b4a90e$var$_default;

});

parcelRegister("vvoMA", function(module, exports) {

$parcel$export(module.exports, "default", () => $eab7593b0301bd5d$export$2e2bcd8739ae039);
// This file is temporary and eventually this icon will be in atlaskit

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $PdmhA = parcelRequire("PdmhA");
const $eab7593b0301bd5d$var$likeIconFilled = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        id: "like-filled-a",
        d: "M4.00029867,12.0000031 L4.00029867,19.0000031 C3.99379083,19.2619469 4.0938648,19.5154845 4.27800285,19.7035645 C4.46214091,19.8916445 4.71487577,19.9984685 4.97933941,20.0000031 L5.99875297,20.0000031 L5.99875297,11.0000031 L4.97933941,11.0000031 C4.71487577,11.0015345 4.46214091,11.1083586 4.27800285,11.2964386 C4.0938648,11.4845186 3.99379083,11.7380562 4.00029867,12.0000031 Z M19.2814088,11.0400031 C18.7031035,10.3648275 17.8537454,9.97663317 16.959972,9.97900342 L14.3256459,9.97900342 C14.3660187,9.79800348 14.4063915,9.61900354 14.4366711,9.4470036 C14.9514245,6.5130046 14.4366711,5.44700497 13.9320109,4.85300517 C13.4705845,4.31076256 12.7907146,3.99849428 12.0748615,4 C10.5305357,4.05274499 9.2630356,5.22781051 9.10745966,6.75100452 C8.71382472,8.59000389 8.6532655,8.75100384 8.13851212,9.47600359 L7.37142865,10.5650032 C7.13702441,10.900368 7.01037109,11.2980817 7.00807332,11.7060028 L7.00807332,17.9790007 C7.0094101,18.5107601 7.22390249,19.0202137 7.60436426,19.3952867 C7.98482603,19.7703597 8.50009148,19.9803277 9.03680723,19.9790426 L16.2837274,19.9790426 C17.7690249,19.9867984 19.0398298,18.9240081 19.2814088,17.4720009 L19.9576535,13.4720022 C20.1064636,12.6021375 19.8588502,11.7116379 19.2814088,11.0400031 Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("use", {
        fill: "currentColor",
        xlinkHref: "#like-filled-a"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "inherit",
        d: "M17.2829545,17.140001 C17.2013522,17.6232979 16.7783039,17.9768163 16.2837274,17.9750077 L9.03680723,17.9750077 L9.03680723,11.7060028 L9.8038907,10.6170032 C10.5252697,9.572607 10.9727451,8.36664508 11.105914,7.1080044 C11.1422788,6.56547046 11.3606605,5.89943888 12.0748615,6.00000478 C12.7890625,6.10057068 12.6501741,7.91600412 12.4382168,9.10000372 C12.2228565,10.0810361 11.9326853,11.0444672 11.5702013,11.9820027 L16.959972,11.9740027 C17.2574249,11.9729101 17.5402185,12.1018688 17.7328364,12.3264423 C17.9254544,12.5510157 18.0082813,12.848334 17.9591992,13.1390023 L17.2829545,17.140001 Z"
    })));
const $eab7593b0301bd5d$var$LikeIconFilled = ({ size: size, label: label, secondaryColor: secondaryColor = `var(--ds-icon-subtle, ${(0, $PdmhA).N700})` })=>// @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => JSX.Element' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $eab7593b0301bd5d$var$likeIconFilled,
        size: size,
        label: label,
        secondaryColor: secondaryColor
    });
var $eab7593b0301bd5d$export$2e2bcd8739ae039 = $eab7593b0301bd5d$var$LikeIconFilled;

});

parcelRegister("18hnU", function(module, exports) {

$parcel$export(module.exports, "default", () => $484e09589dca4995$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $484e09589dca4995$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noAssignee: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.no-assignee",
        "defaultMessage": "None Assigned"
    },
    showMoreButton: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.show-more-button",
        "defaultMessage": "Show More"
    },
    affectedServices: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.affected-services",
        "defaultMessage": "Affected services"
    },
    pir: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.pir",
        "defaultMessage": "PIR"
    },
    viewPir: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.view-pir",
        "defaultMessage": "View PIR"
    },
    helpful: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.helpful",
        "defaultMessage": "Helpful"
    },
    notHelpful: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.not-helpful",
        "defaultMessage": "Not helpful"
    },
    noSimilarIncidents: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.no-similar-incidents",
        "defaultMessage": "There are no similar incidents for this issue."
    },
    dropdownMessagesfirstItem: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.dropdown-messagesfirst-item",
        "defaultMessage": "Not relevant"
    },
    dropdownMessageSecondItem: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.dropdown-message-second-item",
        "defaultMessage": "Not informative"
    },
    dropdownMessagesThirdItem: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.dropdown-messages-third-item",
        "defaultMessage": "Not recent enough"
    },
    dropdownMessagesFourthItem: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.dropdown-messages-fourth-item",
        "defaultMessage": "Other"
    },
    textAreaPlaceHolder: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.text-area-place-holder",
        "defaultMessage": "Tell us why this wasn\u2019t helpful?"
    },
    dislikeModalTitle: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.dislike-modal-title",
        "defaultMessage": "Didn\u2019t find this helpful?"
    },
    none: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.none",
        "defaultMessage": "None"
    },
    dislikeModalCloseButton: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.dislike-modal-close-button",
        "defaultMessage": "Close"
    },
    dislikeModalSubmitButton: {
        "id": "smart-related-issues-panel.similar-incidents.similar-incident-card.dislike-modal-submit-button",
        "defaultMessage": "Submit"
    }
});

});


parcelRegister("dAy2A", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bf4b6ebaa2c7f5b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $9VPEO = parcelRequire("9VPEO");
const $0bf4b6ebaa2c7f5b$var$LoadingSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0bf4b6ebaa2c7f5b$var$loadingWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bf4b6ebaa2c7f5b$var$LineItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "6%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "90%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bf4b6ebaa2c7f5b$var$LineItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "6%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "90%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bf4b6ebaa2c7f5b$var$LineItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "6%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "90%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bf4b6ebaa2c7f5b$var$LineItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "6%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "90%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bf4b6ebaa2c7f5b$var$LineItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "6%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "16px",
        width: "90%"
    })));
var $0bf4b6ebaa2c7f5b$export$2e2bcd8739ae039 = $0bf4b6ebaa2c7f5b$var$LoadingSkeleton;
const $0bf4b6ebaa2c7f5b$var$loadingWrapperStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0bf4b6ebaa2c7f5b$var$LineItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1yb4 _otyru2gc",
            __cmplp.className
        ])
    });
});

});



parcelRegister("ffYQM", function(module, exports) {

$parcel$export(module.exports, "EcosystemIssueViewErrorBoundary", () => $c35f65de096042e6$export$a87d9c2e5f382055);

var $eUqFw = parcelRequire("eUqFw");

var $hfAQS = parcelRequire("hfAQS");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $4ceCM = parcelRequire("4ceCM");
const $c35f65de096042e6$export$a87d9c2e5f382055 = ({ children: children, application: application, edition: edition, experience: experience })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue.issue-view.issue-base.content.ecosystem-issue-view-error-boundary",
        onError: ()=>{
            (0, $4ceCM.sendExperienceAnalytics)({
                experience: experience,
                wasExperienceSuccesful: false,
                analyticsSource: 'issueViewEcosystemErrorBoundary',
                application: application,
                edition: edition
            });
        }
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfAQS.MountEvent), {
        onMount: ()=>{
            (0, $4ceCM.sendExperienceAnalytics)({
                experience: experience,
                wasExperienceSuccesful: true,
                analyticsSource: 'issueViewEcosystemErrorBoundary',
                application: application,
                edition: edition
            });
        }
    }));

});
parcelRegister("hfAQS", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $c8f06c61e2483d6a$export$2c6963927dbc68f1);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");
class $c8f06c61e2483d6a$var$MountEventComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $c8f06c61e2483d6a$var$MountEventComponentWithHOC = (0, $2jDha.default)()($c8f06c61e2483d6a$var$MountEventComponent);
const $c8f06c61e2483d6a$export$2c6963927dbc68f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c8f06c61e2483d6a$var$MountEventComponentWithHOC, props);

});



parcelRegister("9mxRp", function(module, exports) {

$parcel$export(module.exports, "HEADER_BREADCRUMBS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$eb0ef5297b0cdc23);
$parcel$export(module.exports, "HEADER_BREADCRUMBS_END_MARK_KEY", () => $3849cfed910e9285$export$9c0a7052eb43d49c);
$parcel$export(module.exports, "HEADER_ACTIONS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$ff64d9f93169b1f0);
$parcel$export(module.exports, "HEADER_ACTIONS_END_MARK_KEY", () => $3849cfed910e9285$export$e696e07345d019c7);
$parcel$export(module.exports, "ISSUE_NAME_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$39f2c7a88d6952c7);
$parcel$export(module.exports, "ISSUE_NAME_END_MARK_KEY", () => $3849cfed910e9285$export$6b38db117e6a59c3);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$e4ec603cd2ae64c3);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_END_MARK_KEY", () => $3849cfed910e9285$export$485e8138df2fade3);
$parcel$export(module.exports, "CONTENT_ITEMS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$37c39403f63dfe50);
$parcel$export(module.exports, "CONTENT_ITEMS_END_MARK_KEY", () => $3849cfed910e9285$export$bcac34901554ce05);
$parcel$export(module.exports, "ACTIVITY_FEED_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$cfd354167a2170f3);
$parcel$export(module.exports, "ACTIVITY_FEED_END_MARK_KEY", () => $3849cfed910e9285$export$e20857c483438d46);
$parcel$export(module.exports, "FOOTNOTE_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$2f7e8d259a68175d);
$parcel$export(module.exports, "FOOTNOTE_END_MARK_KEY", () => $3849cfed910e9285$export$8c4857e697bb9a6b);
$parcel$export(module.exports, "ISSUE_STATUS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$6669013ba0004c0);
$parcel$export(module.exports, "ISSUE_STATUS_END_MARK_KEY", () => $3849cfed910e9285$export$ff2ebe781d7bd44e);
$parcel$export(module.exports, "defaultRatioRightColumn", () => $3849cfed910e9285$export$7fec582ac43ca9da);
$parcel$export(module.exports, "getIssueContainerMaxWidth", () => $3849cfed910e9285$export$c76181843186885);
const $3849cfed910e9285$export$eb0ef5297b0cdc23 = 'HEADER_BREADCRUMBS_BEGIN_MARK';
const $3849cfed910e9285$export$9c0a7052eb43d49c = 'HEADER_BREADCRUMBS_END_MARK';
const $3849cfed910e9285$export$ff64d9f93169b1f0 = 'HEADER_ACTIONS_BEGIN_MARK';
const $3849cfed910e9285$export$e696e07345d019c7 = 'HEADER_ACTIONS_END_MARK';
const $3849cfed910e9285$export$39f2c7a88d6952c7 = 'ISSUE_NAME_BEGIN_MARK';
const $3849cfed910e9285$export$6b38db117e6a59c3 = 'ISSUE_NAME_END_MARK';
const $3849cfed910e9285$export$e4ec603cd2ae64c3 = 'QUICK_ADD_ITEMS_BEGIN_MARK';
const $3849cfed910e9285$export$485e8138df2fade3 = 'QUICK_ADD_ITEMS_END_MARK';
const $3849cfed910e9285$export$37c39403f63dfe50 = 'CONTENT_ITEMS_BEGIN_MARK';
const $3849cfed910e9285$export$bcac34901554ce05 = 'CONTENT_ITEMS_END_MARK';
const $3849cfed910e9285$export$cfd354167a2170f3 = 'ACTIVITY_FEED_BEGIN_MARK';
const $3849cfed910e9285$export$e20857c483438d46 = 'ACTIVITY_FEED_END_MARK';
const $3849cfed910e9285$export$2f7e8d259a68175d = 'FOOTNOTE_BEGIN_MARK';
const $3849cfed910e9285$export$8c4857e697bb9a6b = 'FOOTNOTE_END_MARK';
const $3849cfed910e9285$export$6669013ba0004c0 = 'ISSUE_STATUS_BEGIN_MARK';
const $3849cfed910e9285$export$ff2ebe781d7bd44e = 'ISSUE_STATUS_END_MARK';
const $3849cfed910e9285$export$7fec582ac43ca9da = 0.35;
const $3849cfed910e9285$export$c76181843186885 = ()=>1680;

});

parcelRegister("kkcIQ", function(module, exports) {

$parcel$export(module.exports, "getLayoutStyle", () => $ad036e702d0c8113$export$e0a8fab6f4af8558);
$parcel$export(module.exports, "getSidebarRatio", () => $ad036e702d0c8113$export$af01a0cb9725feae);
$parcel$export(module.exports, "useSidebarResize", () => $ad036e702d0c8113$export$2b2f4a1c1ea66396);
$parcel$export(module.exports, "HighlightActionsWrapper", () => $ad036e702d0c8113$export$950a4faaa58cd47);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $7xfWN = parcelRequire("7xfWN");

var $hJ992 = parcelRequire("hJ992");


var $i9pAn = parcelRequire("i9pAn");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $9mxRp = parcelRequire("9mxRp");
const $ad036e702d0c8113$export$4bfef09edd5764de = {
    modal: 'modal',
    embedded: 'embedded',
    full: 'full'
};
const $ad036e702d0c8113$export$e0a8fab6f4af8558 = (isModal, issueMaxWidth)=>{
    if (isModal === true) return $ad036e702d0c8113$export$4bfef09edd5764de.modal;
    if (issueMaxWidth !== (0, $9mxRp.getIssueContainerMaxWidth)()) return $ad036e702d0c8113$export$4bfef09edd5764de.embedded;
    return $ad036e702d0c8113$export$4bfef09edd5764de.full;
};
const $ad036e702d0c8113$var$getStoredValues = (str)=>{
    if (str === null || str === '') return {};
    try {
        return JSON.parse(str);
    } catch  {
        return {};
    }
};
const $ad036e702d0c8113$export$af01a0cb9725feae = (layoutStyle, storedValue)=>{
    const storedValues = $ad036e702d0c8113$var$getStoredValues(storedValue);
    const r = storedValues[layoutStyle] ?? (0, $9mxRp.defaultRatioRightColumn);
    return !Number.isNaN(r) && Number.isFinite(r) && r >= 0 && r <= 1 ? r : (0, $9mxRp.defaultRatioRightColumn);
};
const $ad036e702d0c8113$export$2b2f4a1c1ea66396 = (layoutStyle)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [sidebarRatio, { setValue: setValue }] = (0, $i9pAn.useUserPreferencesValue)((0, $e4af19d777b54ab6$export$a274dca8eb47fc4a));
    const ratio = (0, $eUqFw.useMemo)(()=>$ad036e702d0c8113$export$af01a0cb9725feae(layoutStyle, sidebarRatio), [
        sidebarRatio,
        layoutStyle
    ]);
    const onSaveRatio = (0, $eUqFw.useCallback)((newRatio, isReset = false)=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, `sidebar ${isReset ? 'reset' : 'dragged'}`, 'issueDetails', {
            sidebarRatio: newRatio
        });
        const storedValues = $ad036e702d0c8113$var$getStoredValues(sidebarRatio);
        setValue(JSON.stringify({
            ...storedValues,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [layoutStyle]: newRatio
        })).catch(()=>{}); // Ignore if server-side resize state update fails, this state is not critical;
    }, [
        setValue,
        createAnalyticsEvent,
        layoutStyle,
        sidebarRatio
    ]);
    const onResetRatio = (0, $eUqFw.useCallback)((newRatio)=>{
        onSaveRatio(newRatio, true);
    }, [
        onSaveRatio
    ]);
    return [
        ratio,
        onSaveRatio,
        onResetRatio
    ];
};
const $ad036e702d0c8113$export$950a4faaa58cd47 = ({ children: children, scope: scope })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    if (!(0, $1ybV0.ff)('feature.reading-aid-in-issue-description', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7xfWN.HighlightActionsProvider), {
        scope: `${scope}.${issueKey}`
    }, children);
};

});
parcelRegister("7xfWN", function(module, exports) {

$parcel$export(module.exports, "HighlightActionsProvider", () => $64b264cd5e39d560$export$8b383aca014c1850);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $ecq0C = parcelRequire("ecq0C");

var $icJ7m = parcelRequire("icJ7m");

var $eQTGy = parcelRequire("eQTGy");

var $9jpEc = parcelRequire("9jpEc");
const $64b264cd5e39d560$var$EMPTY_OBJECT = {};
const $64b264cd5e39d560$export$44ba498dd896882a = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $9jpEc.asyncTargetEntryPoint), $64b264cd5e39d560$var$EMPTY_OBJECT);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira.highlight.actions.popup.target",
        packageName: "jiraHighlightActions",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: $64b264cd5e39d560$var$EMPTY_OBJECT
    });
};
const $64b264cd5e39d560$export$85585c22030ede4e = ()=>{
    const { highlightEnabled: highlightEnabled } = (0, $icJ7m.useIsHighlightEnabled)();
    // FIXME: eager loading of PopupTarget may reduce TTI with feature never being used
    // suppress loading based on performed action.
    // this should be based on "begining" of the action, not the end, so the code will be mostly ready when needed
    // const triggerPosition = Boolean(useTriggerPosition());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ecq0C.HighlightActionsErrorBoundary), {
        id: "highlight-actions-popup-target-async"
    }, highlightEnabled /* && triggerPosition */  ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64b264cd5e39d560$export$44ba498dd896882a, null) : null);
};
const $64b264cd5e39d560$export$8b383aca014c1850 = ({ scope: scope, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icJ7m.HighlightActionsContainer), {
        scope: scope
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eQTGy.TargetContainer), {
        scope: scope
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64b264cd5e39d560$export$85585c22030ede4e, null)));

});
parcelRegister("ecq0C", function(module, exports) {

$parcel$export(module.exports, "HighlightActionsErrorBoundary", () => $8fe22b37335ffc8c$export$5e0c5615e9802c40);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");
const $8fe22b37335ffc8c$export$5e0c5615e9802c40 = ({ id: id, children: children, fallback: fallback, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        packageName: "jiraHighlightActions",
        fallback: fallback || 'unmount',
        teamName: "crocs",
        onError: onError
    }, children);

});

parcelRegister("eQTGy", function(module, exports) {

$parcel$export(module.exports, "TargetContainer", () => $a846b0b2a506528b$export$646527cf18b0864e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $icJ7m = parcelRequire("icJ7m");
const $a846b0b2a506528b$export$646527cf18b0864e = ({ scope: scope, children: children })=>{
    const ref = (0, $eUqFw.useRef)(null);
    (0, $icJ7m.useSetHighlightContainerRef)(ref);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a846b0b2a506528b$var$Container, {
        ref: ref,
        "data-testid": `highlight-actions.ui.target.container.${scope}`
    }, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a846b0b2a506528b$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9jpEc", function(module, exports) {

$parcel$export(module.exports, "asyncTargetEntryPoint", () => $4381c16159076105$export$fafab32ad4c37764);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $4381c16159076105$export$fafab32ad4c37764 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("5GnXd")), {
        moduleId: "3be6e4f3"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5GnXd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('g4oaF')
        ]);
        const value = parcelRequire('gXzsd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("g4oaF")
    ]).then(()=>parcelRequire('gXzsd'));
}

});





parcelRegister("dH6nC", function(module, exports) {

$parcel$export(module.exports, "IssueBodyContainer", () => $eb812fd5ce4c9cb4$export$46594a4d90cdead9);
$parcel$export(module.exports, "IssueBodyContainerDropzone", () => $eb812fd5ce4c9cb4$export$273d33d325b64486);
/* issue-view.styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $eb812fd5ce4c9cb4$export$46594a4d90cdead9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $eb812fd5ce4c9cb4$export$273d33d325b64486 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { attachmentHover: attachmentHover, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _4t3i1osq _vchhusvi _1bsb1osq",
            __cmplp.attachmentHover ? "_19it1tg7" : "_19itex4c",
            __cmplp.attachmentHover && "_bfhkuzct",
            __cmplp.attachmentHover && "_1o2w4jg8",
            __cmplp.attachmentHover && "_tzy47u59",
            __cmplp.attachmentHover && "_1pbyb4wl",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iJSW3", function(module, exports) {

$parcel$export(module.exports, "MaybePrefetchFieldSuggestions", () => $b50485ddfe932a26$export$488c1518e3422e8f);

var $ijapY = parcelRequire("ijapY");

var $keeZR = parcelRequire("keeZR");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $hW84d = parcelRequire("hW84d");

var $lO4Or = parcelRequire("lO4Or");

var $cWiVr = parcelRequire("cWiVr");

var $2HyJi = parcelRequire("2HyJi");
const $b50485ddfe932a26$export$1782d5699f97ddd6 = ({ issueViewRelayFragment: issueViewRelayFragment })=>{
    const getAriForFieldId = (0, $eUqFw.useCallback)((fieldId)=>{
        const field = issueViewRelayFragment?.fields?.edges?.find((edge)=>edge?.node && 'fieldId' in edge.node && edge.node.fieldId === fieldId)?.node;
        return field && 'id' in field ? field.id : undefined;
    }, [
        issueViewRelayFragment
    ]);
    (0, $hW84d.useLazyLoadQueryAfterPageLoad)((0, $keeZR.default), {
        labelsFieldAri: getAriForFieldId((0, $lO4Or.LABELS_TYPE)),
        first: 50
    });
    return null;
};
const $b50485ddfe932a26$export$488c1518e3422e8f = ({ issueViewRelayFragment: issueViewRelayFragment })=>{
    const currentUserData = (0, $cWiVr.useCurrentUser)();
    const currentUserAccountId = currentUserData?.data?.user?.accountId;
    const fieldsData = (0, $iWLL0.useFragment)((0, $ijapY.default), // @ts-expect-error - No overload matches this call.
    issueViewRelayFragment);
    if (fieldsData) {
        const labelsData = issueViewRelayFragment?.fields?.edges?.find((edge)=>edge?.node && 'fieldId' in edge.node && edge.node.fieldId === 'labels')?.node;
        const labelsFieldIsNotEmpty = !!(labelsData && 'selectedLabelsConnection' in labelsData && labelsData.selectedLabelsConnection?.edges?.length);
        const statusData = fieldsData.status?.edges;
        const statusCategoryId = statusData && statusData[0] ? statusData[0].node?.status?.statusCategory?.statusCategoryId : undefined;
        const reporterData = fieldsData.reporter?.edges;
        const reporterAccountId = reporterData && reporterData[0] ? reporterData[0].node?.user?.accountId : undefined;
        const assigneeData = fieldsData.assignee?.edges;
        const assigneeAccountId = assigneeData && assigneeData[0] ? assigneeData[0].node?.user?.accountId : undefined;
        const shouldPrefetchLabelsSuggestions = (0, $2HyJi.shouldPrefetchLabelsSuggestionsUtil)(labelsFieldIsNotEmpty, statusCategoryId, reporterAccountId, assigneeAccountId, currentUserAccountId);
        return shouldPrefetchLabelsSuggestions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b50485ddfe932a26$export$1782d5699f97ddd6, {
            issueViewRelayFragment: issueViewRelayFragment
        }) : null;
    }
    return null;
};

});
parcelRegister("ijapY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e125a7193e21c1e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1fc75daa9ce2f0888b1c9907fb559918>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7e125a7193e21c1e$var$node = function() {
    var v0 = [
        {
            "concreteType": "JiraIssueFieldEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "accountId"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraSingleSelectUserPickerField"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "prefetchFieldSuggestions_issueView_MaybePrefetchFieldSuggestions",
        "selections": [
            {
                "alias": "status",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "ids",
                        "value": [
                            "status"
                        ]
                    }
                ],
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fieldsById",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "JiraStatus",
                                                "kind": "LinkedField",
                                                "name": "status",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraStatusCategory",
                                                        "kind": "LinkedField",
                                                        "name": "statusCategory",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "statusCategoryId"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "JiraStatusField"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "fieldsById(ids:[\"status\"])"
            },
            {
                "alias": "reporter",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "ids",
                        "value": [
                            "reporter"
                        ]
                    }
                ],
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fieldsById",
                "plural": false,
                "selections": v0 /*: any*/ ,
                "storageKey": "fieldsById(ids:[\"reporter\"])"
            },
            {
                "alias": "assignee",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "ids",
                        "value": [
                            "assignee"
                        ]
                    }
                ],
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fieldsById",
                "plural": false,
                "selections": v0 /*: any*/ ,
                "storageKey": "fieldsById(ids:[\"assignee\"])"
            }
        ],
        "type": "JiraIssue"
    };
}();
$7e125a7193e21c1e$var$node.hash = "e39bf73746b3b6b0cdd0481b31104c8f";
var $7e125a7193e21c1e$export$2e2bcd8739ae039 = $7e125a7193e21c1e$var$node;

});

parcelRegister("keeZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $96505c001779980a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a61bba731158f70d8e0cef1f1eee752d>>
 * @relayHash 8f24b0a55ab6fe89f5c8bc1fa327d7c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9c5b7aee18c39f13d4f88772b857edb6c4c96ea985683347abb9a3f432ef5b1
const $96505c001779980a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "labelsFieldAri"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "labelsFieldAri"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = [
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        },
        {
            "kind": "Literal",
            "name": "suggested",
            "value": true
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "prefetchFieldSuggestionsQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewWithSuggestionsFragment_suggestionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "prefetchFieldSuggestionsQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraLabelConnection",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraLabelEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraLabel",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v5 /*: any*/ ,
                                    "filters": [
                                        "suggested",
                                        "searchBy"
                                    ],
                                    "handle": "connection",
                                    "key": "labels_issueFieldLabelsEditviewFull_LabelsEditViewWithSuggestionsFragmentSearch__labels",
                                    "kind": "LinkedHandle",
                                    "name": "labels"
                                }
                            ],
                            "type": "JiraLabelsField"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d9c5b7aee18c39f13d4f88772b857edb6c4c96ea985683347abb9a3f432ef5b1",
            "metadata": {},
            "name": "prefetchFieldSuggestionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$96505c001779980a$var$node.hash = "75911a5d3598b5c20c07849689228da3";
var $96505c001779980a$export$2e2bcd8739ae039 = $96505c001779980a$var$node;

});

parcelRegister("2HyJi", function(module, exports) {

$parcel$export(module.exports, "shouldPrefetchLabelsSuggestionsUtil", () => $f8dc02dfa222eb0d$export$5dba2d26415f2360);
const $f8dc02dfa222eb0d$export$5dba2d26415f2360 = (labelsFieldIsNotEmpty, statusCategoryId, reporterAccountId, assigneeAccountId, currentUserAccountId)=>{
    const hasToDoOrInProgressStatus = statusCategoryId?.toString() === '4' || statusCategoryId?.toString() === '2';
    if (currentUserAccountId) return !labelsFieldIsNotEmpty && hasToDoOrInProgressStatus && (reporterAccountId === currentUserAccountId || assigneeAccountId === currentUserAccountId);
    return false;
};

});


parcelRegister("4HWIa", function(module, exports) {

$parcel$export(module.exports, "RenderCommandPaletteHeader", () => $2615b291f182e29a$export$a3e9cc7cfab64f62);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $h2IaY = parcelRequire("h2IaY");
var $6Ao31 = parcelRequire("6Ao31");

var $9zALC = parcelRequire("9zALC");
var $46gH8 = parcelRequire("46gH8");

var $70Z2O = parcelRequire("70Z2O");

var $hnzPP = parcelRequire("hnzPP");

var $bAQOb = parcelRequire("bAQOb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8xsZc = parcelRequire("8xsZc");

var $fWeG1 = parcelRequire("fWeG1");

var $koHQK = parcelRequire("koHQK");
const $2615b291f182e29a$var$RenderCommandPaletteHeaderOld = ({ issueKey: issueKey })=>{
    const [{ value: summary }] = (0, $fWeG1.useSummaryField)({
        issueKey: issueKey
    });
    const [{ value: issueType }] = (0, $8xsZc.useIssueTypeField)({
        issueKey: issueKey
    });
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueTypeIconUrl = issueType?.iconUrl;
    const issueTypeName = issueType?.name;
    const renderName = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2615b291f182e29a$var$CompalSectionHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2615b291f182e29a$var$IssueActionLabel, null, formatMessage((0, $koHQK.messages).issueActions)), !!issueTypeIconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2615b291f182e29a$var$IssueIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
            url: issueTypeIconUrl,
            alt: issueTypeName
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h2IaY.TruncateWithTooltipOnHover), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2615b291f182e29a$var$IssueSummaryContainer, null, issueKey, " ", summary)));
    const sectionId = (0, $46gH8.getCommandPaletteIssueActionsHeader)(issueKey);
    (0, $6Ao31.useRegisterCommandSections)({
        [sectionId]: {
            renderName: renderName,
            priority: (0, $9zALC.COMMAND_PALETTE_SECTIONS_PRIORITY).issueActions,
            actionCategory: (0, $9zALC.COMMAND_PALETTE_ISSUE_ACTIONS)
        }
    }, [
        issueKey,
        summary,
        issueTypeIconUrl
    ]);
    return null;
};
const $2615b291f182e29a$var$RenderCommandPaletteHeaderNew = ({ issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderName = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $2615b291f182e29a$var$issueActionsLabelStyles
        }, formatMessage((0, $koHQK.messages).issueActions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $70Z2O.IssueTag), {
            issueKey: issueKey
        }));
    const sectionId = (0, $46gH8.getCommandPaletteIssueActionsHeader)(issueKey);
    (0, $6Ao31.useRegisterCommandSections)({
        [sectionId]: {
            renderName: renderName,
            priority: (0, $9zALC.COMMAND_PALETTE_SECTIONS_PRIORITY).issueActions,
            actionCategory: (0, $9zALC.COMMAND_PALETTE_ISSUE_ACTIONS)
        }
    }, [
        issueKey
    ]);
    return null;
};
const $2615b291f182e29a$export$a3e9cc7cfab64f62 = (0, $bAQOb.componentWithFF)('compal-issue-actions-very-high-priority_f5w5r', $2615b291f182e29a$var$RenderCommandPaletteHeaderNew, $2615b291f182e29a$var$RenderCommandPaletteHeaderOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2615b291f182e29a$var$IssueActionLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2615b291f182e29a$var$IssueIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1o9zidpf _18u012x7 _2hwx1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2615b291f182e29a$var$CompalSectionHeaderContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $2615b291f182e29a$var$IssueSummaryContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1crf",
            __cmplp.className
        ])
    });
});
const $2615b291f182e29a$var$issueActionsLabelStyles = (0, $1ZAYh.xcss)({
    fontSize: '14px',
    color: 'color.text.subtlest',
    // @ts-expect-error - TS2353 - Object literal may only specify known properties, and 'textWrap' does not exist in type 'SafeCSSObject'.
    textWrap: 'nowrap'
});

});
parcelRegister("6Ao31", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandSections", () => $0604517059fb0bc8$export$24e75e2bcad1489a);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");
const $0604517059fb0bc8$export$24e75e2bcad1489a = (sections, deps = [])=>{
    const { registerSections: registerSections, unregisterSections: unregisterSections } = (0, $gCtL7.useActionsCommandPalette)();
    const ids = Object.keys(sections);
    (0, $eUqFw.useEffect)(()=>{
        registerSections(sections);
        return ()=>{
            unregisterSections(sections);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ...deps,
        registerSections,
        unregisterSections,
        ids.toString()
    ]);
};

});

parcelRegister("koHQK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a6eda6a3ec60e0cd$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a6eda6a3ec60e0cd$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issueActions: {
        "id": "issue.issue-view.issue-details.register-command-palette-header.issue-actions",
        "defaultMessage": "Issue actions"
    }
});

});


parcelRegister("4v4ZA", function(module, exports) {

$parcel$export(module.exports, "default", () => $12020deecb798000$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $1ybV0 = parcelRequire("1ybV0");

var $8iMV3 = parcelRequire("8iMV3");

var $f9RL0 = parcelRequire("f9RL0");

var $1vsSU = parcelRequire("1vsSU");

var $gA5p3 = parcelRequire("gA5p3");

var $lqalZ = parcelRequire("lqalZ");

var $277q1 = parcelRequire("277q1");

var $lkPj1 = parcelRequire("lkPj1");

var $8CSFK = parcelRequire("8CSFK");

var $8QKSg = parcelRequire("8QKSg");

var $fVCj0 = parcelRequire("fVCj0");

var $8BPY4 = parcelRequire("8BPY4");

var $isrrj = parcelRequire("isrrj");

var $8WuJm = parcelRequire("8WuJm");

var $eikwq = parcelRequire("eikwq");
const $12020deecb798000$var$RegisterShortcutsDialog = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-register-shortcuts-dialog",
        packageName: "issue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "dotDialog",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eikwq.default), props)));
var $12020deecb798000$export$2e2bcd8739ae039 = (0, $lqalZ.connect)((state)=>({
        ...(0, $isrrj.quickAddItemsPermissionsSelector)(state),
        ecosystemActions: !(0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? (0, $8CSFK.ecosystemOperationsSelector)(state) : undefined,
        forgeIssueActions: (0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? (0, $8QKSg.forgeIssueActionsSelector)(state) : undefined,
        hasParent: (0, $8BPY4.hasParentIssueSelector)(state)
    }), (dispatch)=>({
        ...(0, $1vsSU.actionDispatchToProps)(dispatch),
        onChangeWorkflow: (transition, viaDialog)=>{
            // @ts-expect-error - TS2554 - Expected 4-5 arguments, but got 3.
            dispatch((0, $fVCj0.fieldSaveSuccess)((0, $f9RL0.STATUS), (0, $gA5p3.fieldOptions), transition.to));
            dispatch((0, $fVCj0.fieldUpdated)((0, $f9RL0.STATUS), transition.to, {
                viaDialog: viaDialog
            }));
        },
        onAddComment: ()=>{
            dispatch((0, $277q1.setSelectedActivityItem)((0, $8iMV3.commentActivityItem)));
            dispatch((0, $lkPj1.addCommentFormExpand)());
        }
    }))($12020deecb798000$var$RegisterShortcutsDialog);

});
parcelRegister("8BPY4", function(module, exports) {

$parcel$export(module.exports, "hasParentIssueSelector", () => $f5624485e6c10614$export$66b58e5e4db7ba63);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $f5624485e6c10614$export$66b58e5e4db7ba63 = (0, $df4Sl.createSelector)((0, $jZDJX.parentIssueEntitySelector), (parentIssue)=>Boolean(parentIssue && parentIssue.id));

});

parcelRegister("eikwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0486d97228f826c2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $cEXxp = parcelRequire("cEXxp");
var $fNhwb = parcelRequire("fNhwb");

var $gcjRs = parcelRequire("gcjRs");

var $3vrDE = parcelRequire("3vrDE");

var $i6k2Y = parcelRequire("i6k2Y");

var $4CPxR = parcelRequire("4CPxR");

var $5OaGg = parcelRequire("5OaGg");

var $lO4Or = parcelRequire("lO4Or");

var $fq6rr = parcelRequire("fq6rr");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");

var $6vrw7 = parcelRequire("6vrw7");

var $7uVYl = parcelRequire("7uVYl");

var $NywdJ = parcelRequire("NywdJ");

var $bIIvG = parcelRequire("bIIvG");
const $0486d97228f826c2$var$FIELDS_SHORTCUTS_KEY = 'fields';
const $0486d97228f826c2$var$ISSUE_ACTIONS_SHORTCUTS_KEY = 'issueActions';
const $0486d97228f826c2$var$ISSUE_WORKFLOW_SHORTCUTS_KEY = 'workflow';
const $0486d97228f826c2$var$RegisterShortcutsDialogHelper = ({ canCreateAttachment: canCreateAttachment, shouldShowCreateSubtaskButton: shouldShowCreateSubtaskButton, shouldShowIssueInEpicButton: shouldShowIssueInEpicButton, canCreateIssueLink: canCreateIssueLink, canEditIssues: canEditIssues, onAddAttachmentClick: onAddAttachmentClick, onCreateSubtaskClick: onCreateSubtaskClick, onCreateIssueInEpicClick: onCreateIssueInEpicClick, onChildCreateClick: onChildCreateClick, supportsChildCreation: supportsChildCreation, isServiceDesk: isServiceDesk, isAnonymousUser: isAnonymousUser, canLinkConfluencePage: canLinkConfluencePage, onLinkConfluencePageClick: onLinkConfluencePageClick, onInvestigateIncidentClick: onInvestigateIncidentClick, canAddWebLinks: canAddWebLinks, onAddWebLinkClick: onAddWebLinkClick, onAddIssueLinkClick: onAddIssueLinkClick, onChangeWorkflow: onChangeWorkflow, onAddComment: onAddComment, ecosystemActions: ecosystemActions, forgeIssueActions: forgeIssueActions, hasParent: hasParent, practices: practices, onClose: onClose, onIssueDeleteSuccess: onIssueDeleteSuccess })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueId = (0, $hJ992.useIssueId)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const [permissions] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const [incidentManagement] = (0, $kmr29.useFieldValue)({
        fieldKey: (0, $lO4Or.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
        issueKey: issueKey
    });
    const hasIssue = !!issueKey && !!issueId;
    const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }, { registerShortcuts: registerShortcuts, setShortcutsLoading: setShortcutsLoading, setHasError: setHasError, setHeader: setHeader, dropShortcutsByKeys: dropShortcutsByKeys }] = (0, $7uVYl.useShortcuts)();
    const { onAssignToMeLinkClick: onAssignToMeLinkClick, onAddCommentLinkClick: onAddCommentLinkClick, onWorkflowSelected: onWorkflowSelected } = (0, $bIIvG.useClickActions)({
        onChangeWorkflow: onChangeWorkflow,
        onAddComment: onAddComment
    });
    const [{ value: { hasProjectForms: hasProjectForms } }, { onClickAddFormButton: onClickAddFormButton }] = (0, $fq6rr.useForms)({
        issueKey: (0, $6vrw7.toIssueKey)(issueKey)
    });
    const shouldShowProformaForms = hasProjectForms === true;
    const [, { openLinkAlertsModal: onLinkAlertsClick }] = (0, $5OaGg.useLinkAlertsModalActions)();
    const addToIssueActions = (0, $3vrDE.useAddToIssueActions)((0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? forgeIssueActions ?? [] : ecosystemActions ?? []);
    const issueManipulationActions = (0, $i6k2Y.useIssueManipulationActions)(hasParent, onIssueDeleteSuccess, onClose);
    const [{ value: currentStatus }] = (0, $fNhwb.useStatusField)({
        issueKey: issueKey
    });
    const registerIssueViewShortcuts = (0, $eUqFw.useCallback)(async ()=>{
        const quickAddItemList = (0, $4CPxR.default)({
            formatMessage: formatMessage,
            canCreateAttachment: canCreateAttachment,
            canEditIssues: canEditIssues,
            shouldShowCreateSubtaskButton: shouldShowCreateSubtaskButton,
            shouldShowIssueInEpicButton: shouldShowIssueInEpicButton,
            canCreateIssueLink: canCreateIssueLink,
            onAddAttachmentClick: onAddAttachmentClick,
            onCreateSubtaskClick: onCreateSubtaskClick,
            onCreateIssueInEpicClick: onCreateIssueInEpicClick,
            onChildCreateClick: onChildCreateClick,
            supportsChildCreation: supportsChildCreation,
            isServiceDesk: isServiceDesk,
            isAnonymousUser: isAnonymousUser,
            canLinkConfluencePage: canLinkConfluencePage,
            onLinkConfluencePageClick: onLinkConfluencePageClick,
            onInvestigateIncidentClick: onInvestigateIncidentClick,
            incidentManagement: incidentManagement,
            onLinkAlertsClick: onLinkAlertsClick,
            canAddWebLinks: canAddWebLinks,
            onAddWebLinkClick: onAddWebLinkClick,
            onAddIssueLinkClick: onAddIssueLinkClick,
            practices: practices
        });
        const quickAddActions = (0, $bIIvG.quickAddItemsToShortcutOptions)(quickAddItemList);
        const canEdit = permissions.canEditIssues;
        const extraActions = (0, $bIIvG.getExtraActions)({
            onAddCommentLinkClick: onAddCommentLinkClick,
            onAssignToMeLinkClick: onAssignToMeLinkClick,
            onClickAddFormButton: onClickAddFormButton,
            shouldShowProformaForms: shouldShowProformaForms,
            formatMessage: formatMessage,
            canEdit: canEdit
        });
        const issueActions = {
            key: $0486d97228f826c2$var$ISSUE_ACTIONS_SHORTCUTS_KEY,
            label: formatMessage((0, $NywdJ.default).issueActionsSectionLabel),
            isLoaded: true,
            weight: 2,
            options: [
                ...quickAddActions,
                ...extraActions,
                ...addToIssueActions,
                ...issueManipulationActions
            ]
        };
        const result = await (0, $cEXxp.getStatusTransitions)(issueKey);
        const issueWorkflow = {
            key: $0486d97228f826c2$var$ISSUE_WORKFLOW_SHORTCUTS_KEY,
            label: formatMessage((0, $NywdJ.default).issueWorkflowsSectionLabel),
            isLoaded: true,
            weight: 3,
            options: result ? (0, $bIIvG.transitionItemsToShortcutOptions)(result.transitions, currentStatus, onWorkflowSelected) : []
        };
        if (!result) setHasError(true);
        // @ts-expect-error - TS2322 - Type '{ key: string; label: string; isLoaded: boolean; weight: number; options: (ShortcutOption | { key: string; label: string; onClick: (() => void) | undefined; })[]; }' is not assignable to type 'OptionGroupType'.
        registerShortcuts([
            issueActions,
            issueWorkflow
        ]);
    }, [
        formatMessage,
        canCreateAttachment,
        canEditIssues,
        shouldShowCreateSubtaskButton,
        shouldShowIssueInEpicButton,
        canCreateIssueLink,
        onAddAttachmentClick,
        onCreateSubtaskClick,
        onCreateIssueInEpicClick,
        onChildCreateClick,
        supportsChildCreation,
        isServiceDesk,
        isAnonymousUser,
        canLinkConfluencePage,
        onLinkConfluencePageClick,
        onInvestigateIncidentClick,
        incidentManagement,
        issueManipulationActions,
        onLinkAlertsClick,
        canAddWebLinks,
        onAddWebLinkClick,
        onAddIssueLinkClick,
        onAddCommentLinkClick,
        onAssignToMeLinkClick,
        issueKey,
        addToIssueActions,
        currentStatus,
        onWorkflowSelected,
        registerShortcuts,
        setHasError,
        onClickAddFormButton,
        shouldShowProformaForms,
        permissions.canEditIssues,
        practices
    ]);
    (0, $eUqFw.useEffect)(()=>()=>dropShortcutsByKeys([
                $0486d97228f826c2$var$FIELDS_SHORTCUTS_KEY,
                $0486d97228f826c2$var$ISSUE_ACTIONS_SHORTCUTS_KEY,
                $0486d97228f826c2$var$ISSUE_WORKFLOW_SHORTCUTS_KEY
            ]), [
        dropShortcutsByKeys
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasIssue && isShortcutsDialogVisible) {
            setHeader(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gcjRs.default), null), issueKey);
            setShortcutsLoading(true);
            registerIssueViewShortcuts();
        }
        return ()=>{
            setHeader(null);
        };
    }, [
        hasIssue,
        isShortcutsDialogVisible,
        registerIssueViewShortcuts,
        setShortcutsLoading,
        setHeader,
        issueKey
    ]);
    return null;
};
var $0486d97228f826c2$export$2e2bcd8739ae039 = $0486d97228f826c2$var$RegisterShortcutsDialogHelper;

});
parcelRegister("cEXxp", function(module, exports) {

$parcel$export(module.exports, "getStatusTransitions", () => $c0759e400216af8d$export$6f3da53546b3f0c0);

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
const $c0759e400216af8d$export$6f3da53546b3f0c0 = async (issueKey)=>{
    try {
        return await (0, $2OdyW.default)(`/rest/api/2/issue/${issueKey}/transitions?sortByOpsBarAndStatus=true`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.status-field.fetch-transitions', error.toString());
        return null;
    }
};

});

parcelRegister("fNhwb", function(module, exports) {

$parcel$export(module.exports, "useStatusField", () => $b2ab706ab24c8887$export$2ebd1e0190d60bd9);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

const $b2ab706ab24c8887$export$2ebd1e0190d60bd9 = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, (0, $ebc098a76317be78$export$4420b7468f889692));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'scheme.type', (0, $ebc098a76317be78$export$4420b7468f889692));
    const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $ebc098a76317be78$export$4420b7468f889692),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            loading: loading,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("gcjRs", function(module, exports) {

$parcel$export(module.exports, "default", () => $02ae7c9956a46838$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");

var $hnzPP = parcelRequire("hnzPP");

var $hJ992 = parcelRequire("hJ992");

var $8xsZc = parcelRequire("8xsZc");
const $02ae7c9956a46838$var$Header = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ value: fieldType }] = (0, $8xsZc.useIssueTypeField)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02ae7c9956a46838$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: fieldType?.name || '',
        position: "left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
        alt: fieldType?.name || '',
        url: fieldType?.iconUrl
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02ae7c9956a46838$var$IssueKey, null, issueKey));
};
var $02ae7c9956a46838$export$2e2bcd8739ae039 = $02ae7c9956a46838$var$Header;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02ae7c9956a46838$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1yt41530 _vchhusvi",
            __cmplp.className
        ])
    });
});
const $02ae7c9956a46838$var$IssueKey = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s819aj _syaz1wmz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3vrDE", function(module, exports) {

$parcel$export(module.exports, "addToIssueDropdownGroup", () => $d3927b570f19e0b2$export$419a95c6d2d27d5f);
$parcel$export(module.exports, "useAddToIssueActions", () => $d3927b570f19e0b2$export$fc0dcfd6c6f34570);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");


var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $8411R = parcelRequire("8411R");
var $3oTxc = parcelRequire("3oTxc");

var $flhrj = parcelRequire("flhrj");

var $j7TnS = parcelRequire("j7TnS");

var $f9RL0 = parcelRequire("f9RL0");

var $lO4Or = parcelRequire("lO4Or");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");

var $6bhHe = parcelRequire("6bhHe");

var $7A6jb = parcelRequire("7A6jb");
var $1WMUd = parcelRequire("1WMUd");
var $dflws = parcelRequire("dflws");

var $26Hln = parcelRequire("26Hln");

var $gMSNh = parcelRequire("gMSNh");
var $3AsUA = parcelRequire("3AsUA");
var $dDkKQ = parcelRequire("dDkKQ");

var $63rsD = parcelRequire("63rsD");
const $d3927b570f19e0b2$export$419a95c6d2d27d5f = (actions, onClick)=>({
        name: '',
        key: 'AddToIssueDropdownGroup',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        items: actions.reduce((itemsArray, { Component: Component, label: label, key: key })=>{
            if (Component) itemsArray.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                label: label,
                key: key,
                itemKey: key,
                onClick: onClick
            }));
            return itemsArray;
        }, [])
    });
const $d3927b570f19e0b2$export$fc0dcfd6c6f34570 = (forgeIssueActions)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const source = (0, $hJ992.useAnalyticsSource)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $hJ992.useProjectKey)();
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const { issueActions: issueActions } = (0, $guDlK.useProjectConfiguration)(projectKey);
    const [permissions] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const [timeTrackingFieldConfigData] = (0, $8411R.useFieldConfig)(issueKey, (0, $lO4Or.TIME_TRACKING_TYPE));
    const timeTrackingFieldConfig = timeTrackingFieldConfigData.value;
    const [timeTrackingConfig] = (0, $6bhHe.useTimeTrackingConfiguration)();
    const [fieldKey] = (0, $3oTxc.useSearchCustomFieldKeys)(issueKey, (0, $lO4Or.FLAGGED_CF_TYPE));
    const [{ value: isFlagged }] = (0, $flhrj.useFlaggedField)({
        issueKey: issueKey,
        fieldKey: fieldKey || ''
    });
    const [{ value: connectOperations }] = (0, $j7TnS.default)(issueKey);
    const shouldShowFlag = (0, $eUqFw.useMemo)(()=>permissions.canEditIssues && !!issueActions?.includes((0, $f9RL0.FLAG_ACTIONS)), [
        permissions,
        issueActions
    ]);
    const canLogTime = (0, $eUqFw.useMemo)(()=>source !== (0, $0100842672acae20$export$ce88447986394f2d) && permissions.canLogWork && !!timeTrackingFieldConfig && timeTrackingConfig.isTimeTrackingEnabled, [
        source,
        permissions,
        timeTrackingFieldConfig,
        timeTrackingConfig
    ]);
    const canClassifyIssue = (0, $hJ992.useIsClassifyEditEnabled)();
    const items = (0, $eUqFw.useMemo)(()=>[
            ...canLogTime ? [
                {
                    Component: (0, $63rsD.LogWork),
                    DialogComponent: (0, $63rsD.LogWorkButtonItem),
                    label: formatMessage((0, $63rsD.label)),
                    key: 'logWork'
                }
            ] : [],
            ...shouldShowFlag ? [
                {
                    Component: (0, $3AsUA.default),
                    DialogComponent: (0, $dDkKQ.default),
                    label: formatMessage(isFlagged ? (0, $gMSNh.removeFlagLabel) : (0, $gMSNh.addFlagLabel)),
                    key: 'flagIssue'
                }
            ] : [],
            ...(0, $1ybV0.ff)('issue-view-classification-level-editability_88zal') && canClassifyIssue ? [
                {
                    Component: (0, $7A6jb.ClassifyIssue),
                    DialogComponent: (0, $1WMUd.ClassifyIssueButtonItem),
                    label: projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT) ? formatMessage((0, $dflws.classifyRequestLabel)) : formatMessage((0, $dflws.classifyIssueLabel)),
                    key: 'classifyIssue'
                }
            ] : [],
            ...(0, $26Hln.getEcosystemItems)({
                ecosystemActions: (0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? [
                    ...forgeIssueActions,
                    ...connectOperations
                ] : forgeIssueActions
            })
        ], [
        canLogTime,
        canClassifyIssue,
        forgeIssueActions,
        connectOperations,
        isFlagged,
        formatMessage,
        shouldShowFlag,
        projectType
    ]);
    return items;
};

});
parcelRegister("j7TnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0088ae7053b508dc$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $9sKt4 = parcelRequire("9sKt4");

var $6D0iK = parcelRequire("6D0iK");
const $0088ae7053b508dc$export$2994a663090c3db5 = (issueKey)=>{
    const [issueState] = (0, $6D0iK.default)(issueKey);
    const { value: issueData = (0, $9sKt4.emptyIssueData), isReady: isReady = false } = issueState ?? {};
    const { operations: value = [] } = issueData;
    return [
        {
            value: value,
            isReady: isReady
        }
    ];
};
const $0088ae7053b508dc$var$defaultValue = [
    {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: [],
        isReady: true
    }
];
var $0088ae7053b508dc$export$2e2bcd8739ae039 = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w'), $0088ae7053b508dc$export$2994a663090c3db5, ()=>$0088ae7053b508dc$var$defaultValue);

});

parcelRegister("7A6jb", function(module, exports) {

$parcel$export(module.exports, "ClassifyIssue", () => $c24e9d1a12f854a6$export$7c77b7437bc4cd10);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $1ybV0 = parcelRequire("1ybV0");

var $K1Vl8 = parcelRequire("K1Vl8");

var $lO4Or = parcelRequire("lO4Or");
const $c24e9d1a12f854a6$export$7c77b7437bc4cd10 = ({ onClick: onClick, label: label, itemKey: itemKey })=>{
    /**
	 * Todo: Replace the constant `DATA_CLASSIFICATION_EDITING_STATE_KEY` with the destructured value from relay response
	 */ const [, setIsIssueClassified] = (0, $K1Vl8.useOptionallyControlledEditingState)(false, (0, $lO4Or.DATA_CLASSIFICATION_TYPE));
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        if ((0, $1ybV0.ff)('issue-view-classification-level-editability_88zal')) setIsIssueClassified(true);
        onClick?.(itemKey);
    }, [
        setIsIssueClassified,
        onClick,
        itemKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        key: "clone",
        onClick: handleClick
    }, label);
};

});

parcelRegister("1WMUd", function(module, exports) {

$parcel$export(module.exports, "ClassifyIssueButtonItem", () => $630b89538d533e96$export$cfadde0853b68615);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");

var $1ybV0 = parcelRequire("1ybV0");

var $K1Vl8 = parcelRequire("K1Vl8");

var $lO4Or = parcelRequire("lO4Or");
const $630b89538d533e96$export$cfadde0853b68615 = ({ onClick: onClick, label: label, setDropdownItemRef: setDropdownItemRef, itemKey: itemKey, isSelected: isSelected = false })=>{
    /**
	 * Todo: Replace the constant `DATA_CLASSIFICATION_EDITING_STATE_KEY` with the destructured value from relay response
	 */ const [, setIsIssueClassified] = (0, $K1Vl8.useOptionallyControlledEditingState)(false, (0, $lO4Or.DATA_CLASSIFICATION_TYPE));
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        if ((0, $1ybV0.ff)('issue-view-classification-level-editability_88zal')) setIsIssueClassified(true);
        onClick?.(itemKey);
    }, [
        setIsIssueClassified,
        onClick,
        itemKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        key: "classifyIssue",
        isSelected: isSelected,
        ref: setDropdownItemRef,
        role: "menuitem",
        onClick: handleClick
    }, label);
};

});

parcelRegister("dflws", function(module, exports) {

$parcel$export(module.exports, "classifyIssueLabel", () => $51e06975d956118d$export$d78a9672920a6fed);
$parcel$export(module.exports, "classifyRequestLabel", () => $51e06975d956118d$export$64dfa7e010dfe01e);

var $1WMUd = parcelRequire("1WMUd");

var $7A6jb = parcelRequire("7A6jb");

var $Xa3jz = parcelRequire("Xa3jz");
const $51e06975d956118d$export$d78a9672920a6fed = (0, $Xa3jz.default).classifyIssue;
const $51e06975d956118d$export$64dfa7e010dfe01e = (0, $Xa3jz.default).classifyRequest;

});
parcelRegister("Xa3jz", function(module, exports) {

$parcel$export(module.exports, "default", () => $abe14744b3946d25$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $abe14744b3946d25$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    classifyIssue: {
        "id": "issue.classify",
        "defaultMessage": "Classify issue"
    },
    classifyRequest: {
        "id": "request.classify",
        "defaultMessage": "Classify request"
    }
});

});


parcelRegister("26Hln", function(module, exports) {

$parcel$export(module.exports, "getEcosystemItems", () => $4d1a43116838cf93$export$649a42adfd570b76);

var $8aFlo = parcelRequire("8aFlo");
const $4d1a43116838cf93$export$649a42adfd570b76 = ({ ecosystemActions: ecosystemActions })=>ecosystemActions.map((0, $8aFlo.getEcosystemAction)).filter((ecosystemOperation)=>ecosystemOperation.isAllowed) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((dropdownItemList, item)=>{
        // @ts-expect-error - TS2774 - This condition will always return true since this function is always defined. Did you mean to call it instead?
        if (item.component) {
            const componentIssueAction = item;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const ActionItem = componentIssueAction.component;
            const { key: key, label: label } = componentIssueAction;
            dropdownItemList.push({
                Component: ActionItem,
                DialogComponent: componentIssueAction.dialogComponent,
                label: label,
                key: key
            });
        }
        return dropdownItemList;
    }, []);

});
parcelRegister("8aFlo", function(module, exports) {

$parcel$export(module.exports, "getEcosystemAction", () => $5e7976f874ea0b66$export$71c674c9733aa56d);

var $fkvsU = parcelRequire("fkvsU");

var $aMZNu = parcelRequire("aMZNu");

var $a0rVW = parcelRequire("a0rVW");
const $5e7976f874ea0b66$export$71c674c9733aa56d = (action)=>{
    // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'Action | EcosystemOperation'.
    if (action.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const forgeAction = action;
        return (0, $a0rVW.getForgeAction)(forgeAction);
    }
    // @ts-expect-error - TS2345 - Argument of type 'Action | EcosystemOperation' is not assignable to parameter of type 'EcosystemOperation'.
    return (0, $aMZNu.getConnectAction)(action);
};

});
parcelRegister("aMZNu", function(module, exports) {

$parcel$export(module.exports, "getConnectAction", () => $4e03b61c66d55e29$export$77e03915f22dda6b);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $bULPy = parcelRequire("bULPy");

var $4lxPQ = parcelRequire("4lxPQ");

var $ciZ8Y = parcelRequire("ciZ8Y");
const $4e03b61c66d55e29$var$CONNECT_APP_ACTION_TYPE = 'connectApp';
// eslint-disable-next-line jira/react/no-class-components
class $4e03b61c66d55e29$var$EcosystemWebItem extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            styleClass: null,
            tooltip: null
        };
    }
    render() {
        const { id: id, linkText: linkText, tooltip: tooltip } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            key: id,
            onClick: this.clickEcosystemModalLinkRef,
            title: tooltip || undefined,
            ref: this.setEcosystemModalLinkRef
        }, linkText);
    }
    constructor(...args){
        super(...args);
        this.setEcosystemModalLinkRef = (element)=>{
            this.ecosystemModalLinkRef = element;
        };
        this.clickEcosystemModalLinkRef = ()=>{
            this.props.onClick?.(this.props.itemKey, undefined, {
                actionType: $4e03b61c66d55e29$var$CONNECT_APP_ACTION_TYPE
            });
            // we need to capture element as it will be null when the callback is called
            // due to dropdown close on click/action
            const targetElement = this.ecosystemModalLinkRef;
            if (!targetElement) return;
            // if this isn't a connect web item, we still need to navigate to the href
            if (!(0, $4lxPQ.isConnectDialogWebItem)(this.props.styleClass || '')) {
                window.location.href = this.props.href;
                return;
            }
            // delegate action to connectjs
            (0, $4lxPQ.withConnectHost)((connectHost)=>{
                const performAction = ()=>{
                    connectHost.triggerWebItem(targetElement, this.props.styleClass || '', this.props.href, 'click');
                };
                // put a delay in between to let MeatballMenu close and return focus
                // so the potential Dialog will be able to focus self properly
                // the delay is small enough to not be noticeable by the user
                setTimeout(performAction, 16);
            });
        // in case of error thrown it will be caught by Sentry
        };
    }
}
const $4e03b61c66d55e29$export$f9b7dd973727edf9 = ({ id: id, linkText: linkText, href: href, styleClass: styleClass, setDropdownItemRef: setDropdownItemRef, onClick: onClick, itemKey: itemKey })=>{
    const ecosystemModalLinkRef = (0, $eUqFw.useRef)(null);
    const clickEcosystemModalLinkRef = ()=>{
        onClick?.(itemKey, undefined, {
            actionType: $4e03b61c66d55e29$var$CONNECT_APP_ACTION_TYPE
        });
        ecosystemModalLinkRef.current?.click();
    };
    const renderEcosystemModalLink = (linkHref, linkStyleClass)=>// eslint-disable-next-line jsx-a11y/anchor-has-content
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            href: linkHref,
            ref: ecosystemModalLinkRef,
            ...linkStyleClass && {
                className: linkStyleClass
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        key: id,
        onClick: clickEcosystemModalLinkRef,
        ref: setDropdownItemRef
    }, linkText, renderEcosystemModalLink(href, styleClass));
};
const $4e03b61c66d55e29$export$77e03915f22dda6b = (ecosystemAction)=>({
        component: (shortcutProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
                packageName: "issue",
                id: "connect-items"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e03b61c66d55e29$var$EcosystemWebItem, {
                href: ecosystemAction.url,
                linkText: ecosystemAction.name,
                styleClass: ecosystemAction.styleClass,
                id: ecosystemAction.name,
                tooltip: ecosystemAction.tooltip,
                ...shortcutProps
            })),
        dialogComponent: (shortcutProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
                packageName: "issue",
                id: "connect-items"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e03b61c66d55e29$export$f9b7dd973727edf9, {
                href: ecosystemAction.url,
                linkText: ecosystemAction.name,
                styleClass: ecosystemAction.styleClass || null,
                tooltip: ecosystemAction.tooltip || null,
                id: ecosystemAction.name,
                ...shortcutProps
            })),
        eventName: ecosystemAction.name,
        key: ecosystemAction.name,
        isAllowed: true,
        label: ecosystemAction.name
    });

});

parcelRegister("a0rVW", function(module, exports) {

$parcel$export(module.exports, "getForgeAction", () => $3fda3a2384e93e0d$export$708f367d296d1bbc);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $bULPy = parcelRequire("bULPy");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $1boRu = parcelRequire("1boRu");

var $5syGA = parcelRequire("5syGA");

var $2oduq = parcelRequire("2oduq");

var $lLuxg = parcelRequire("lLuxg");

var $fT83w = parcelRequire("fT83w");

var $5G3JL = parcelRequire("5G3JL");

var $6nYhF = parcelRequire("6nYhF");

var $lqalZ = parcelRequire("lqalZ");

var $i7QJO = parcelRequire("i7QJO");

var $5JqpU = parcelRequire("5JqpU");
const $3fda3a2384e93e0d$export$eedb54654d2233da = ({ onClick: onClick, execForgeAction: execForgeAction, source: source, setDropdownItemRef: setDropdownItemRef, itemKey: itemKey, label: label, isSelected: isSelected, ...action })=>{
    const handleOnClick = (0, $eUqFw.useCallback)(()=>{
        (0, $2oduq.fireUiTriggerClickedEvent)(source);
        execForgeAction(action);
        onClick?.(itemKey);
    }, [
        source,
        execForgeAction,
        onClick,
        action,
        itemKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        key: action.id,
        onClick: handleOnClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fT83w.ExtensionTitle), {
        extensionName: action.title,
        extensionEnvType: action.extension.environmentType,
        extensionEnvKey: action.extension.environmentKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: {
            source: source,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(action.extension)
        }
    }));
};
const $3fda3a2384e93e0d$export$4bfd32eebd72596c = ({ onClick: onClick, execForgeAction: execForgeAction, source: source, setDropdownItemRef: setDropdownItemRef, itemKey: itemKey, label: label, isSelected: isSelected = false, ...action })=>{
    const handleOnClick = (0, $eUqFw.useCallback)(()=>{
        (0, $2oduq.fireUiTriggerClickedEvent)(source);
        execForgeAction(action);
        onClick?.(itemKey);
    }, [
        source,
        execForgeAction,
        onClick,
        action,
        itemKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        key: action.id,
        isSelected: isSelected,
        onClick: handleOnClick,
        role: "menuitem",
        ref: setDropdownItemRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fT83w.ExtensionTitle), {
        extensionName: action.title,
        extensionEnvType: action.extension.environmentType,
        extensionEnvKey: action.extension.environmentKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: {
            source: source,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(action.extension)
        }
    }));
};
const $3fda3a2384e93e0d$export$8a0c6254eed6c71f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLuxg.TriggerAnalyticsWrapper), {
        attributes: {
            source: props.source,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3fda3a2384e93e0d$export$eedb54654d2233da, props));
const $3fda3a2384e93e0d$var$getForgeViewConnectedWithStore = (Component)=>(0, $5G3JL.flowWithSafeComponent)((0, $lqalZ.connect)((state)=>({
            source: (0, $5JqpU.analyticsSourceSelector)(state)
        }), {
        execForgeAction: (0, $i7QJO.forgeIssueActionExec)
    }))((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLuxg.TriggerAnalyticsWrapper), {
            attributes: {
                source: props.source,
                ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props)));
const $3fda3a2384e93e0d$var$ForgeActionViewConnectedWithoutStore = $3fda3a2384e93e0d$var$getForgeViewConnectedWithStore($3fda3a2384e93e0d$export$eedb54654d2233da);
const $3fda3a2384e93e0d$export$97e3ce6fa1dc03ce = (0, $6nYhF.withStoreForIssueViewShortcutActions_DO_NOT_USE)($3fda3a2384e93e0d$var$ForgeActionViewConnectedWithoutStore);
const $3fda3a2384e93e0d$var$ForgeActionButtonItemViewConnectedWithoutStore = $3fda3a2384e93e0d$var$getForgeViewConnectedWithStore($3fda3a2384e93e0d$export$4bfd32eebd72596c);
const $3fda3a2384e93e0d$export$c820bc16cf89d102 = (0, $6nYhF.withStoreForIssueViewShortcutActions_DO_NOT_USE)($3fda3a2384e93e0d$var$ForgeActionButtonItemViewConnectedWithoutStore);
const $3fda3a2384e93e0d$export$708f367d296d1bbc = (props)=>({
        component: (shortcutProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
                packageName: "issue",
                id: "forge-items"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3fda3a2384e93e0d$export$97e3ce6fa1dc03ce, {
                ...props,
                ...shortcutProps
            })),
        dialogComponent: (shortcutProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
                packageName: "issue",
                id: "forge-items"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3fda3a2384e93e0d$export$c820bc16cf89d102, {
                ...props,
                ...shortcutProps
            })),
        eventName: props.id,
        key: props.id,
        isAllowed: true,
        label: props.title
    });

});
parcelRegister("2oduq", function(module, exports) {

$parcel$export(module.exports, "fireUiTriggerClickedEvent", () => $d0de2e5d37916cdf$export$cc0cc6563e35ae9);

var $2Rqjr = parcelRequire("2Rqjr");

var $8XU7c = parcelRequire("8XU7c");

var $cYWDh = parcelRequire("cYWDh");

var $d6g7g = parcelRequire("d6g7g");

var $hRcYT = parcelRequire("hRcYT");
const $d0de2e5d37916cdf$var$triggerEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.ISSUE_ACTION_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER)
});
const $d0de2e5d37916cdf$export$cc0cc6563e35ae9 = (source, attributes)=>{
    (0, $d6g7g.forgeModulesLoadTime).start({
        startTime: performance.now()
    });
    return (0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).CLICKED, {
        id: $d0de2e5d37916cdf$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};

});

parcelRegister("lLuxg", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $1400ba5ebb1b726a$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $1400ba5ebb1b726a$export$e1a79e3d472c925a);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");
const $1400ba5ebb1b726a$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.ISSUE_ACTION_MODULE),
        ...props
    });
const $1400ba5ebb1b726a$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.ISSUE_ACTION_MODULE),
        moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
        ...props
    });

});




parcelRegister("gMSNh", function(module, exports) {

$parcel$export(module.exports, "addFlagLabel", () => $d8c33e25f202f462$export$560ab5f419995db1);
$parcel$export(module.exports, "removeFlagLabel", () => $d8c33e25f202f462$export$b07408f14716d1d8);

var $lIROr = parcelRequire("lIROr");

var $3AsUA = parcelRequire("3AsUA");

var $dDkKQ = parcelRequire("dDkKQ");
const $d8c33e25f202f462$export$560ab5f419995db1 = (0, $lIROr.default).addFlag;
const $d8c33e25f202f462$export$b07408f14716d1d8 = (0, $lIROr.default).removeFlag;

});
parcelRegister("lIROr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f543f5697bb93b52$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $f543f5697bb93b52$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addFlag: {
        "id": "issue.flag.add",
        "defaultMessage": "Add flag"
    },
    removeFlag: {
        "id": "issue.flag.remove",
        "defaultMessage": "Remove flag"
    },
    addFlagFailedTitle: {
        "id": "issue.server-error-when-add-flag-title",
        "defaultMessage": "We couldn't flag this issue"
    },
    addFlagFailedDescription: {
        "id": "issue.server-error-when-add-flag-description",
        "defaultMessage": "Check your connection and try adding the flag again."
    },
    removeFlagFailedTitle: {
        "id": "issue.server-error-when-remove-flag-title",
        "defaultMessage": "We couldn't remove the flag from this issue"
    },
    removeFlagFailedDescription: {
        "id": "issue.server-error-when-remove-flag-description",
        "defaultMessage": "Check your connection and try removing the flag again."
    }
});

});

parcelRegister("3AsUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f359422db5dd27d6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $ao2Je = parcelRequire("ao2Je");
const $f359422db5dd27d6$export$a1eb4e1e97b48ae = ({ onClick: onClick, itemKey: itemKey, label: label })=>{
    const toggleFlag = (0, $ao2Je.default)(itemKey, onClick);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        key: "flagIssue",
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.issue-base.foundation.issue-actions.add-to-issue-dropdown-group.flag.flag-issue-action-view",
        onClick: toggleFlag
    }, label);
};
var $f359422db5dd27d6$export$2e2bcd8739ae039 = $f359422db5dd27d6$export$a1eb4e1e97b48ae;

});
parcelRegister("ao2Je", function(module, exports) {

$parcel$export(module.exports, "default", () => $44a41c2b743d7ff5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $k8Qyf = parcelRequire("k8Qyf");

var $hJ992 = parcelRequire("hJ992");

var $3oTxc = parcelRequire("3oTxc");

var $f1Eld = parcelRequire("f1Eld");
var $flhrj = parcelRequire("flhrj");

var $lO4Or = parcelRequire("lO4Or");

var $lIROr = parcelRequire("lIROr");
const $44a41c2b743d7ff5$var$useToggleFlag = (itemKey, onClick)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const onFailure = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'failedValue' implicitly has an 'any' type.
    (_, failedValue)=>{
        showFlag({
            type: 'error',
            title: failedValue ? (0, $lIROr.default).addFlagFailedTitle : (0, $lIROr.default).removeFlagFailedTitle,
            description: failedValue ? (0, $lIROr.default).addFlagFailedDescription : (0, $lIROr.default).removeFlagFailedDescription
        });
    }, [
        showFlag
    ]);
    const [fieldKey] = (0, $3oTxc.useSearchCustomFieldKeys)(issueKey, (0, $lO4Or.FLAGGED_CF_TYPE));
    const [{ value: isFlagged }, { saveValue: saveValue }] = (0, $flhrj.useFlaggedField)({
        issueKey: issueKey,
        fieldKey: fieldKey || '',
        onFailure: // @ts-expect-error - TS2322 - Type '(_: any, failedValue: any) => void' is not assignable to type '(arg1: Error) => void'.
        onFailure
    });
    return (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({});
        const newValue = (0, $f1Eld.transformToStateValue)(!isFlagged);
        saveValue(newValue, null, analyticsEvent);
        onClick?.(itemKey);
    }, [
        onClick,
        itemKey,
        saveValue,
        isFlagged,
        createAnalyticsEvent
    ]);
};
var $44a41c2b743d7ff5$export$2e2bcd8739ae039 = $44a41c2b743d7ff5$var$useToggleFlag;

});


parcelRegister("dDkKQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7838176fa8449aef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");

var $ao2Je = parcelRequire("ao2Je");
const $7838176fa8449aef$export$a1eb4e1e97b48ae = ({ onClick: onClick, itemKey: itemKey, label: label, setDropdownItemRef: setDropdownItemRef, isSelected: isSelected = false })=>{
    const toggleFlag = (0, $ao2Je.default)(itemKey, onClick);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        key: "flagIssue",
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.issue-base.foundation.issue-actions.add-to-issue-dropdown-group.flag.button-item",
        onClick: toggleFlag,
        isSelected: isSelected,
        ref: setDropdownItemRef,
        role: "menuitem"
    }, label);
};
var $7838176fa8449aef$export$2e2bcd8739ae039 = $7838176fa8449aef$export$a1eb4e1e97b48ae;

});


parcelRegister("63rsD", function(module, exports) {

$parcel$export(module.exports, "LogWork", () => $bd0063c055cc21c1$export$b97f8968d057fa6e);
$parcel$export(module.exports, "label", () => $bd0063c055cc21c1$export$1237798dc640739a);
$parcel$export(module.exports, "LogWorkButtonItem", () => $bd0063c055cc21c1$export$d29b7069415679cc);


var $6nYhF = parcelRequire("6nYhF");

var $hJjah = parcelRequire("hJjah");

var $lqalZ = parcelRequire("lqalZ");

var $9Y7ra = parcelRequire("9Y7ra");

var $GmaBf = parcelRequire("GmaBf");

var $35BzU = parcelRequire("35BzU");
const $bd0063c055cc21c1$var$connectToProps = (Component)=>(0, $lqalZ.connect)(null, (dispatch)=>({
            onLogTimeClick: ()=>{
                dispatch((0, $9Y7ra.openModal)((0, $0577deea918816be$export$b4c759f3741816e), null));
            }
        }))(Component);
const $bd0063c055cc21c1$export$b97f8968d057fa6e = (0, $6nYhF.withStoreForIssueViewShortcutActions_DO_NOT_USE)(// @ts-expect-error - TS2345 - Argument of type 'ComponentClass<Omit<ShortcutComponentProps & DispatchProps, "onLogTimeClick">> & { ...; }' is not assignable to parameter of type 'ComponentType<ShortcutComponentProps>'.
$bd0063c055cc21c1$var$connectToProps((0, $35BzU.LogWorkView)));
const $bd0063c055cc21c1$export$1237798dc640739a = (0, $hJjah.default).logWork;
const $bd0063c055cc21c1$export$d29b7069415679cc = (0, $6nYhF.withStoreForIssueViewShortcutActions_DO_NOT_USE)(// @ts-expect-error - TS2345 - Argument of type 'ComponentClass<Omit<ShortcutComponentProps & DispatchProps, "onLogTimeClick">> & { ...; }' is not assignable to parameter of type 'ComponentType<ShortcutComponentProps>'.
$bd0063c055cc21c1$var$connectToProps((0, $GmaBf.default)));

});
parcelRegister("GmaBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $aca65bffb283c590$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");
const $aca65bffb283c590$var$LogWorkButtonItem = ({ onLogTimeClick: onLogTimeClick, onClick: onClick, label: label, setDropdownItemRef: setDropdownItemRef, itemKey: itemKey, isSelected: isSelected = false })=>{
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        onLogTimeClick();
        onClick?.(itemKey);
    }, [
        onLogTimeClick,
        onClick,
        itemKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        key: "LogTimeActionView",
        onClick: handleClick,
        isSelected: isSelected,
        ref: setDropdownItemRef,
        role: "menuitem"
    }, label);
};
var $aca65bffb283c590$export$2e2bcd8739ae039 = $aca65bffb283c590$var$LogWorkButtonItem;

});

parcelRegister("35BzU", function(module, exports) {

$parcel$export(module.exports, "LogWorkView", () => $8eb3793b6c35d540$export$7a3b9e799bdf73c8);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");
const $8eb3793b6c35d540$export$7a3b9e799bdf73c8 = ({ onLogTimeClick: onLogTimeClick, onClick: onClick, label: label, itemKey: itemKey })=>{
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        onLogTimeClick();
        onClick?.(itemKey);
    }, [
        onLogTimeClick,
        onClick,
        itemKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        key: "LogTimeActionView",
        onClick: handleClick
    }, label);
};

});



parcelRegister("i6k2Y", function(module, exports) {

$parcel$export(module.exports, "issueManipulationDropdownGroup", () => $493b14d3a1452f73$export$e680b1ddc1f7dccf);
$parcel$export(module.exports, "useIssueManipulationActions", () => $493b14d3a1452f73$export$a33903dac2f83f0c);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $f9RL0 = parcelRequire("f9RL0");

var $lO4Or = parcelRequire("lO4Or");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");

var $c7H0g = parcelRequire("c7H0g");

var $1Vru5 = parcelRequire("1Vru5");
var $6Syon = parcelRequire("6Syon");

var $3W5kM = parcelRequire("3W5kM");

var $8SpIs = parcelRequire("8SpIs");
var $3ue4i = parcelRequire("3ue4i");
var $6RtNu = parcelRequire("6RtNu");

var $iVFzN = parcelRequire("iVFzN");
var $77oQM = parcelRequire("77oQM");
var $f92LB = parcelRequire("f92LB");

var $9oMzQ = parcelRequire("9oMzQ");

var $aWisG = parcelRequire("aWisG");

var $inAok = parcelRequire("inAok");
var $lH1Mh = parcelRequire("lH1Mh");
var $dmwPX = parcelRequire("dmwPX");

var $bfBV8 = parcelRequire("bfBV8");
var $9oMqb = parcelRequire("9oMqb");
const $493b14d3a1452f73$export$e680b1ddc1f7dccf = (actions, onClick)=>({
        name: '',
        key: 'IssueManipulationDropdownGroup',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        items: actions.reduce((itemsArray, { Component: Component, label: label, key: key })=>{
            if (Component) itemsArray.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                label: label,
                key: key,
                itemKey: key,
                onClick: onClick
            }));
            return itemsArray;
        }, [])
    });
const $493b14d3a1452f73$export$a33903dac2f83f0c = (hasParent, onIssueDeleteSuccess, onClose)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $hJ992.useProjectKey)();
    const [parentLevel] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.HIERARCHY_LEVEL_ABOVE)
    });
    const [issueType] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: 'issuetype'
    });
    const [subtasks] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $f9RL0.SUBTASKS)
    });
    const isSimplifiedProject = (0, $guDlK.useIsSimplifiedProject)(projectKey);
    const issueTypes = (0, $guDlK.useProjectIssueTypes)(projectKey);
    const isSubtask = issueType?.subtask;
    const [permissions] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const isAdminUser = (0, $c7H0g.useIsAdmin)();
    const isArchived = (0, $hJ992.useIsArchived)();
    const ArchiveIssueWrap = (0, $eUqFw.useMemo)(()=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Syon.default), {
                ...props,
                onIssueDeleteSuccess: onIssueDeleteSuccess,
                onClose: onClose
            }), [
        onIssueDeleteSuccess,
        onClose
    ]);
    const ArchiveIssueButtonItemWrap = (0, $eUqFw.useMemo)(()=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Vru5.default), {
                ...props,
                onIssueDeleteSuccess: onIssueDeleteSuccess,
                onClose: onClose
            }), [
        onClose,
        onIssueDeleteSuccess
    ]);
    const shouldShowLinkToParent = (0, $eUqFw.useMemo)(()=>{
        const hasParentLevelName = !!parentLevel?.name;
        const hasParentLevelIssueTypes = parentLevel?.issueTypeIds.length > 0;
        return hasParentLevelName && permissions.canEditIssues && hasParentLevelIssueTypes && isSimplifiedProject;
    }, [
        isSimplifiedProject,
        parentLevel,
        permissions
    ]);
    const shouldShowConvertToSubtask = (0, $eUqFw.useMemo)(()=>{
        const hasSubtasks = subtasks?.length > 0;
        const hasSubtaskTypes = (issueTypes || []).filter((type)=>type.subtask).length > 0;
        return !isSubtask && !hasSubtasks && hasSubtaskTypes && !isSimplifiedProject;
    }, [
        subtasks,
        issueTypes,
        isSubtask,
        isSimplifiedProject
    ]);
    const shouldShowConvertToIssue = (0, $eUqFw.useMemo)(()=>isSubtask && !isSimplifiedProject, [
        isSubtask,
        isSimplifiedProject
    ]);
    const shouldShowArchiveIssue = (0, $1ybV0.ff)('issue-unarchival_wdpb9') && !isArchived && isAdminUser;
    const shouldShowUnarchiveIssue = (0, $1ybV0.ff)('issue-unarchival_wdpb9') && isArchived && isAdminUser && !isSubtask;
    const items = (0, $eUqFw.useMemo)(()=>[
            ...shouldShowLinkToParent ? [
                {
                    Component: (0, $aWisG.default),
                    DialogComponent: (0, $aWisG.LinkToParentButtonItem),
                    label: formatMessage(hasParent ? (0, $aWisG.changeParentLevelLabel) : (0, $aWisG.addToParentLevelLabel)),
                    key: 'linkToParent'
                }
            ] : [],
            ...shouldShowConvertToSubtask ? [
                {
                    Component: (0, $f92LB.default),
                    DialogComponent: (0, $iVFzN.default),
                    label: formatMessage((0, $77oQM.convertToSubtaskLabel)),
                    key: 'convertToSubtask'
                }
            ] : [],
            ...shouldShowConvertToIssue ? [
                {
                    Component: (0, $6RtNu.default),
                    DialogComponent: (0, $8SpIs.default),
                    label: formatMessage((0, $3ue4i.convertToIssueLabel)),
                    key: 'convertToIssue'
                }
            ] : [],
            ...permissions.canMoveIssue ? [
                {
                    Component: (0, $inAok.default),
                    DialogComponent: (0, $lH1Mh.default),
                    label: formatMessage((0, $dmwPX.moveIssueLabel)),
                    key: 'moveIssue'
                }
            ] : [],
            ...permissions.canCloneIssue ? [
                {
                    Component: (0, $3W5kM.default),
                    DialogComponent: (0, $3W5kM.CloneIssueButtonItem),
                    label: formatMessage((0, $3W5kM.cloneIssueLabel)),
                    key: 'cloneIssue'
                }
            ] : [],
            ...shouldShowArchiveIssue ? [
                {
                    Component: ArchiveIssueWrap,
                    DialogComponent: ArchiveIssueButtonItemWrap,
                    label: formatMessage((0, $6Syon.archiveIssueLabel)),
                    key: 'archiveIssue'
                }
            ] : [],
            ...permissions.canDeleteIssue ? [
                {
                    Component: (0, $9oMzQ.default),
                    DialogComponent: (0, $9oMzQ.DeleteIssueButtonItem),
                    label: formatMessage((0, $9oMzQ.deleteIssueLabel)),
                    key: 'deleteIssue'
                }
            ] : [],
            ...shouldShowUnarchiveIssue ? [
                {
                    Component: (0, $bfBV8.default),
                    DialogComponent: (0, $9oMqb.default),
                    label: formatMessage((0, $bfBV8.unarchiveIssueLabel)),
                    key: 'unarchiveIssue'
                }
            ] : []
        ], [
        shouldShowLinkToParent,
        formatMessage,
        hasParent,
        shouldShowConvertToSubtask,
        shouldShowConvertToIssue,
        permissions,
        shouldShowArchiveIssue,
        ArchiveIssueWrap,
        ArchiveIssueButtonItemWrap,
        shouldShowUnarchiveIssue
    ]);
    return items;
};

});
parcelRegister("1Vru5", function(module, exports) {

$parcel$export(module.exports, "default", () => $de3c2869d9ed9d15$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");

var $5JgJ2 = parcelRequire("5JgJ2");

var $c1nhO = parcelRequire("c1nhO");

var $hJ992 = parcelRequire("hJ992");

var $iMHW7 = parcelRequire("iMHW7");
const $de3c2869d9ed9d15$var$ArchiveIssueButtonItem = ({ onClick: onClick, setDropdownItemRef: setDropdownItemRef, itemKey: itemKey, isSelected: isSelected = false, onIssueDeleteSuccess: onIssueDeleteSuccess, onClose: onClose })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const issueId = (0, $hJ992.useIssueId)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { openArchiveIssueModal: openArchiveIssueModal } = (0, $c1nhO.useArchiveIssueModalActions)();
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        const onIssueArchiveSuccess = ()=>{
            if (issueKey && issueId) onIssueDeleteSuccess?.({
                issueKey: issueKey,
                issueId: issueId
            });
        };
        openArchiveIssueModal({
            issueKey: issueKey,
            issueId: issueId,
            onIssueArchiveSuccess: onIssueArchiveSuccess,
            onCloseIssueViewModal: onClose
        });
        onClick?.(itemKey);
    }, [
        openArchiveIssueModal,
        issueKey,
        issueId,
        onClose,
        onClick,
        itemKey,
        onIssueDeleteSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        key: "archive",
        isSelected: isSelected,
        ref: setDropdownItemRef,
        role: "menuitem",
        onClick: handleClick
    }, formatMessage((0, $iMHW7.default).archiveIssue));
};
var $de3c2869d9ed9d15$export$2e2bcd8739ae039 = $de3c2869d9ed9d15$var$ArchiveIssueButtonItem;

});
parcelRegister("c1nhO", function(module, exports) {

$parcel$export(module.exports, "ArchiveIssueModalStore", () => $75533eed75557d4a$export$c5cad849002b274b);
$parcel$export(module.exports, "useArchiveIssueModalActions", () => $75533eed75557d4a$export$b7e685898567f722);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $3XTqs = parcelRequire("3XTqs");

var $lTatv = parcelRequire("lTatv");
const $75533eed75557d4a$export$c5cad849002b274b = (0, $a61MH.createStore)({
    initialState: $lTatv.initialState,
    actions: (0, $3XTqs.ArchiveIssueModalActions),
    name: 'archiveIssueModalStore'
});
const $75533eed75557d4a$export$b7e685898567f722 = (0, $ggKAj.createActionsHook)($75533eed75557d4a$export$c5cad849002b274b);

});
parcelRegister("3XTqs", function(module, exports) {

$parcel$export(module.exports, "ArchiveIssueModalActions", () => $870f3d628d60d18a$export$69579d834733fb34);
const $870f3d628d60d18a$export$69579d834733fb34 = {
    openArchiveIssueModal: ({ issueKey: issueKey, issueId: issueId, onIssueArchiveSuccess: onIssueArchiveSuccess, onCloseIssueViewModal: onCloseIssueViewModal })=>({ setState: setState })=>{
            setState({
                isArchiveIssueModalOpen: true,
                issueKey: issueKey,
                issueId: issueId,
                onIssueArchiveSuccess: onIssueArchiveSuccess,
                onCloseIssueViewModal: onCloseIssueViewModal
            });
        },
    closeArchiveIssueModal: ()=>({ setState: setState })=>{
            setState({
                isArchiveIssueModalOpen: false,
                issueKey: null,
                issueId: null,
                onIssueArchiveSuccess: null,
                onCloseIssueViewModal: null
            });
        }
};

});

parcelRegister("lTatv", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $fb7fb4605c1c5da6$export$d4c72bab9d6cc13a);
const $fb7fb4605c1c5da6$export$d4c72bab9d6cc13a = {
    isArchiveIssueModalOpen: false,
    issueKey: null,
    issueId: null,
    onIssueArchiveSuccess: null,
    onCloseIssueViewModal: null
};

});


parcelRegister("iMHW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb374dcd14cf5707$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fb374dcd14cf5707$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    archive: {
        "id": "issue-view-foundation.issue-actions.issue-manipulation-dropdown-group.archive-issue.archive",
        "defaultMessage": "Archive"
    },
    archiveIssue: {
        "id": "issue-view-foundation.issue-actions.issue-manipulation-dropdown-group.archive-issue.archive-issue",
        "defaultMessage": "Archive issue"
    }
});

});


parcelRegister("6Syon", function(module, exports) {

$parcel$export(module.exports, "archiveIssueLabel", () => $1fa296cf9f8d2d2e$export$d8b4a9b299092b6f);
$parcel$export(module.exports, "default", () => $1fa296cf9f8d2d2e$export$2e2bcd8739ae039);

var $1Vru5 = parcelRequire("1Vru5");

var $477jW = parcelRequire("477jW");

var $iMHW7 = parcelRequire("iMHW7");
const $1fa296cf9f8d2d2e$export$d8b4a9b299092b6f = (0, $iMHW7.default).archive;
var $1fa296cf9f8d2d2e$export$2e2bcd8739ae039 = (0, $477jW.default);

});
parcelRegister("477jW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0a401b6fd995eb8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $c1nhO = parcelRequire("c1nhO");

var $hJ992 = parcelRequire("hJ992");
const $a0a401b6fd995eb8$var$ArchiveIssue = ({ onClick: onClick, label: label, itemKey: itemKey, onIssueDeleteSuccess: onIssueDeleteSuccess, onClose: onClose })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const issueId = (0, $hJ992.useIssueId)();
    const { openArchiveIssueModal: openArchiveIssueModal } = (0, $c1nhO.useArchiveIssueModalActions)();
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        const onIssueArchiveSuccess = ()=>{
            if (issueKey && issueId) onIssueDeleteSuccess?.({
                issueKey: issueKey,
                issueId: issueId
            });
        };
        openArchiveIssueModal({
            issueKey: issueKey,
            issueId: issueId,
            onIssueArchiveSuccess: onIssueArchiveSuccess,
            onCloseIssueViewModal: onClose
        });
        onClick?.(itemKey);
    }, [
        openArchiveIssueModal,
        issueKey,
        issueId,
        onClose,
        onClick,
        itemKey,
        onIssueDeleteSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        key: "archive",
        onClick: handleClick
    }, label);
};
var $a0a401b6fd995eb8$export$2e2bcd8739ae039 = $a0a401b6fd995eb8$var$ArchiveIssue;

});


parcelRegister("3W5kM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24ebb01226ed546$export$2e2bcd8739ae039);
$parcel$export(module.exports, "cloneIssueLabel", () => $c24ebb01226ed546$export$e4913061d17c4958);
$parcel$export(module.exports, "CloneIssueButtonItem", () => $c24ebb01226ed546$export$9a14ea825e620196);

var $6nYhF = parcelRequire("6nYhF");

var $lqalZ = parcelRequire("lqalZ");

var $10phJ = parcelRequire("10phJ");

var $8RIw3 = parcelRequire("8RIw3");

var $e6eA9 = parcelRequire("e6eA9");

var $hmanR = parcelRequire("hmanR");
const $c24ebb01226ed546$var$connectToProps = (Component)=>(0, $lqalZ.connect)(null, (dispatch)=>({
            onCloneItemClick: ()=>{
                dispatch((0, $10phJ.showCloneModal)());
            }
        }))(Component);
var $c24ebb01226ed546$export$2e2bcd8739ae039 = (0, $6nYhF.withStoreForIssueViewShortcutActions_DO_NOT_USE)(// @ts-expect-error - TS2345 - Argument of type 'ComponentClass<Omit<ShortcutComponentProps & StateProps & DispatchProps, "onCloneItemClick">, any> & { ...; }' is not assignable to parameter of type 'ComponentType<ShortcutComponentProps>'.
$c24ebb01226ed546$var$connectToProps((0, $e6eA9.default)));
const $c24ebb01226ed546$export$e4913061d17c4958 = (0, $hmanR.default).clone;
const $c24ebb01226ed546$export$9a14ea825e620196 = (0, $6nYhF.withStoreForIssueViewShortcutActions_DO_NOT_USE)(// @ts-expect-error - TS2345 - Argument of type 'ComponentClass<Omit<ShortcutComponentProps & StateProps & DispatchProps, "onCloneItemClick">, any> & { ...; }' is not assignable to parameter of type 'ComponentType<ShortcutComponentProps>'.
$c24ebb01226ed546$var$connectToProps((0, $8RIw3.default)));

});
parcelRegister("8RIw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4d5f9824d841a3a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");
const $e4d5f9824d841a3a$var$CloneIssueButtonItem = ({ onCloneItemClick: onCloneItemClick, onClick: onClick, label: label, setDropdownItemRef: setDropdownItemRef, itemKey: itemKey, isSelected: isSelected = false })=>{
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        onCloneItemClick();
        onClick?.(itemKey);
    }, [
        onCloneItemClick,
        onClick,
        itemKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        key: "clone",
        isSelected: isSelected,
        ref: setDropdownItemRef,
        role: "menuitem",
        onClick: handleClick
    }, label);
};
var $e4d5f9824d841a3a$export$2e2bcd8739ae039 = $e4d5f9824d841a3a$var$CloneIssueButtonItem;

});

parcelRegister("e6eA9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ee830d7bf15789a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");
const $5ee830d7bf15789a$var$CloneIssue = ({ onCloneItemClick: onCloneItemClick, onClick: onClick, label: label, itemKey: itemKey })=>{
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        onCloneItemClick();
        onClick?.(itemKey);
    }, [
        onCloneItemClick,
        onClick,
        itemKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        key: "clone",
        onClick: handleClick
    }, label);
};
var $5ee830d7bf15789a$export$2e2bcd8739ae039 = $5ee830d7bf15789a$var$CloneIssue;

});

parcelRegister("hmanR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fc7b519f3315bfc$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $7fc7b519f3315bfc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    clone: {
        "id": "issue.clone",
        "defaultMessage": "Clone"
    }
});

});


parcelRegister("8SpIs", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d2383c0279071ac$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");

var $1fpU6 = parcelRequire("1fpU6");
const $1d2383c0279071ac$var$ConvertToIssueButtonItem = ({ onClick: onClick, label: label, setDropdownItemRef: setDropdownItemRef, itemKey: itemKey, isSelected: isSelected = false })=>{
    const handleClick = (0, $1fpU6.default)(itemKey, onClick);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        isSelected: isSelected,
        ref: setDropdownItemRef,
        role: "menuitem",
        key: "convert-to-issue",
        onClick: handleClick
    }, label);
};
var $1d2383c0279071ac$export$2e2bcd8739ae039 = $1d2383c0279071ac$var$ConvertToIssueButtonItem;

});
parcelRegister("1fpU6", function(module, exports) {

$parcel$export(module.exports, "default", () => $49742fd235bb9002$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");
const $49742fd235bb9002$var$useConvertToIssue = (itemKey, onClick)=>{
    const issueId = (0, $hJ992.useIssueId)();
    const href = `/secure/ConvertSubTask.jspa?id=${issueId || ''}`;
    return (0, $eUqFw.useCallback)(()=>{
        onClick?.(itemKey);
        window.location.assign(href);
    }, [
        onClick,
        itemKey,
        href
    ]);
};
var $49742fd235bb9002$export$2e2bcd8739ae039 = $49742fd235bb9002$var$useConvertToIssue;

});


parcelRegister("3ue4i", function(module, exports) {

$parcel$export(module.exports, "convertToIssueLabel", () => $0f9ff3c5f685e38d$export$1fe5ba0d58960bed);

var $i1Kl5 = parcelRequire("i1Kl5");

var $6RtNu = parcelRequire("6RtNu");

var $8SpIs = parcelRequire("8SpIs");
const $0f9ff3c5f685e38d$export$1fe5ba0d58960bed = (0, $i1Kl5.default).convertToIssue;

});
parcelRegister("i1Kl5", function(module, exports) {

$parcel$export(module.exports, "default", () => $97c6c071c6b09f20$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $97c6c071c6b09f20$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    convertToIssue: {
        "id": "issue.convert-to-issue",
        "defaultMessage": "Convert to Issue"
    }
});

});

parcelRegister("6RtNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $42a394be4f1358f5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $1fpU6 = parcelRequire("1fpU6");
const $42a394be4f1358f5$var$ConvertToIssue = ({ onClick: onClick, label: label, itemKey: itemKey })=>{
    const handleClick = (0, $1fpU6.default)(itemKey, onClick);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        key: "convert-to-issue",
        onClick: handleClick
    }, label);
};
var $42a394be4f1358f5$export$2e2bcd8739ae039 = $42a394be4f1358f5$var$ConvertToIssue;

});


parcelRegister("iVFzN", function(module, exports) {

$parcel$export(module.exports, "default", () => $73474e031d5f7c52$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");

var $lTL0O = parcelRequire("lTL0O");
const $73474e031d5f7c52$var$ConvertToSubtaskButtonItem = ({ onClick: onClick, label: label, setDropdownItemRef: setDropdownItemRef, itemKey: itemKey, isSelected: isSelected = false })=>{
    const handleClick = (0, $lTL0O.default)(itemKey, onClick);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        isSelected: isSelected,
        ref: setDropdownItemRef,
        role: "menuitem",
        key: "convert-to-subtask",
        onClick: handleClick
    }, label);
};
var $73474e031d5f7c52$export$2e2bcd8739ae039 = $73474e031d5f7c52$var$ConvertToSubtaskButtonItem;

});
parcelRegister("lTL0O", function(module, exports) {

$parcel$export(module.exports, "default", () => $762abfc736bbe314$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");
const $762abfc736bbe314$var$useConvertToSubtask = (itemKey, onClick)=>{
    const issueId = (0, $hJ992.useIssueId)();
    const href = `/secure/ConvertIssue.jspa?id=${issueId || ''}`;
    return (0, $eUqFw.useCallback)(()=>{
        onClick?.(itemKey);
        window.location.assign(href);
    }, [
        onClick,
        itemKey,
        href
    ]);
};
var $762abfc736bbe314$export$2e2bcd8739ae039 = $762abfc736bbe314$var$useConvertToSubtask;

});


parcelRegister("77oQM", function(module, exports) {

$parcel$export(module.exports, "convertToSubtaskLabel", () => $9061abe31e39c315$export$b9e1970cbf6adc31);

var $6IbF6 = parcelRequire("6IbF6");

var $f92LB = parcelRequire("f92LB");

var $iVFzN = parcelRequire("iVFzN");
const $9061abe31e39c315$export$b9e1970cbf6adc31 = (0, $6IbF6.default).convertToSubtask;

});
parcelRegister("6IbF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a83220e25260a6f$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $8a83220e25260a6f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    convertToSubtask: {
        "id": "issue.convert-to-subtask",
        "defaultMessage": "Convert to Subtask"
    }
});

});

parcelRegister("f92LB", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8c9918d3ed8299$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $lTL0O = parcelRequire("lTL0O");
const $5f8c9918d3ed8299$var$ConvertToSubtask = ({ onClick: onClick, label: label, itemKey: itemKey })=>{
    const handleClick = (0, $lTL0O.default)(itemKey, onClick);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        key: "convert-to-subtask",
        onClick: handleClick
    }, label);
};
var $5f8c9918d3ed8299$export$2e2bcd8739ae039 = $5f8c9918d3ed8299$var$ConvertToSubtask;

});


parcelRegister("9oMzQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $075a85c7f4a8a969$export$2e2bcd8739ae039);
$parcel$export(module.exports, "deleteIssueLabel", () => $075a85c7f4a8a969$export$b70fd2e795dd4a1f);
$parcel$export(module.exports, "DeleteIssueButtonItem", () => $075a85c7f4a8a969$export$82fece256a5a86e9);

var $6nYhF = parcelRequire("6nYhF");

var $lqalZ = parcelRequire("lqalZ");

var $lXPVG = parcelRequire("lXPVG");

var $ddP21 = parcelRequire("ddP21");

var $c5pQw = parcelRequire("c5pQw");

var $dfrRC = parcelRequire("dfrRC");
const $075a85c7f4a8a969$var$connectToProps = (Component)=>(0, $lqalZ.connect)(null, (dispatch)=>({
            onDeleteIssueClick: ()=>{
                dispatch((0, $lXPVG.openDeleteIssueModal)());
            }
        }))(Component);
var $075a85c7f4a8a969$export$2e2bcd8739ae039 = (0, $6nYhF.withStoreForIssueViewShortcutActions_DO_NOT_USE)(// @ts-expect-error - TS2345 - Argument of type 'ComponentClass<Omit<ShortcutComponentProps & StateProps & DispatchProps, "onDeleteIssueClick">, any> & { ...; }' is not assignable to parameter of type 'ComponentType<ShortcutComponentProps>'.
$075a85c7f4a8a969$var$connectToProps((0, $c5pQw.default)));
const $075a85c7f4a8a969$export$b70fd2e795dd4a1f = (0, $dfrRC.default).delete;
const $075a85c7f4a8a969$export$82fece256a5a86e9 = (0, $6nYhF.withStoreForIssueViewShortcutActions_DO_NOT_USE)(// @ts-expect-error - TS2345 - Argument of type 'ComponentClass<Omit<ShortcutComponentProps & StateProps & DispatchProps, "onDeleteIssueClick">, any> & { ...; }' is not assignable to parameter of type 'ComponentType<ShortcutComponentProps>'.
$075a85c7f4a8a969$var$connectToProps((0, $ddP21.default)));

});
parcelRegister("ddP21", function(module, exports) {

$parcel$export(module.exports, "default", () => $576b7cab83043b5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");
const $576b7cab83043b5c$var$DeleteIssueButtonItem = ({ onDeleteIssueClick: onDeleteIssueClick, onClick: onClick, label: label, setDropdownItemRef: setDropdownItemRef, itemKey: itemKey, isSelected: isSelected = false })=>{
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        onDeleteIssueClick();
        onClick?.(itemKey);
    }, [
        onDeleteIssueClick,
        onClick,
        itemKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        key: "delete",
        isSelected: isSelected,
        ref: setDropdownItemRef,
        role: "menuitem",
        onClick: handleClick
    }, label);
};
var $576b7cab83043b5c$export$2e2bcd8739ae039 = $576b7cab83043b5c$var$DeleteIssueButtonItem;

});

parcelRegister("c5pQw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5a91469d2d22517$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");
const $a5a91469d2d22517$var$DeleteIssue = ({ onDeleteIssueClick: onDeleteIssueClick, onClick: onClick, label: label, itemKey: itemKey })=>{
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        onDeleteIssueClick();
        onClick?.(itemKey);
    }, [
        onDeleteIssueClick,
        onClick,
        itemKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        key: "delete",
        onClick: handleClick
    }, label);
};
var $a5a91469d2d22517$export$2e2bcd8739ae039 = $a5a91469d2d22517$var$DeleteIssue;

});

parcelRegister("dfrRC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d680c3d436a7941c$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $d680c3d436a7941c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    delete: {
        "id": "issue.delete",
        "defaultMessage": "Delete"
    }
});

});


parcelRegister("aWisG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef79721e331af361$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addToParentLevelLabel", () => $ef79721e331af361$export$737e69bc2de5db43);
$parcel$export(module.exports, "changeParentLevelLabel", () => $ef79721e331af361$export$e11fcbe19b6fa94a);
$parcel$export(module.exports, "LinkToParentButtonItem", () => $ef79721e331af361$export$15a0c4716b9497b8);

var $g0N0Z = parcelRequire("g0N0Z");

var $6nYhF = parcelRequire("6nYhF");

var $lqalZ = parcelRequire("lqalZ");

var $2W4Cf = parcelRequire("2W4Cf");

var $dmvDL = parcelRequire("dmvDL");

var $kjRlN = parcelRequire("kjRlN");

var $441zj = parcelRequire("441zj");
const $ef79721e331af361$var$connectToProps = (Component)=>(0, $lqalZ.connect)(null, (dispatch)=>({
            onLinkToParentClick: ()=>{
                (0, $g0N0Z.epicModalOpenInteraction).start();
                dispatch((0, $2W4Cf.showAssignIssueParentModal)());
            }
        }))(Component);
var $ef79721e331af361$export$2e2bcd8739ae039 = (0, $6nYhF.withStoreForIssueViewShortcutActions_DO_NOT_USE)(// @ts-expect-error - TS2345 - Argument of type 'ComponentClass<Omit<ShortcutComponentProps & StateProps & DispatchProps, "onLogTimeClick">> & { ...; }' is not assignable to parameter of type 'ComponentType<ShortcutComponentProps>'.
$ef79721e331af361$var$connectToProps((0, $kjRlN.default)));
const $ef79721e331af361$export$737e69bc2de5db43 = (0, $441zj.default).addToParentLevel;
const $ef79721e331af361$export$e11fcbe19b6fa94a = (0, $441zj.default).changeParentLevel;
const $ef79721e331af361$export$15a0c4716b9497b8 = (0, $6nYhF.withStoreForIssueViewShortcutActions_DO_NOT_USE)(// @ts-expect-error - TS2345 - Argument of type 'ComponentClass<Omit<ShortcutComponentProps & StateProps & DispatchProps, "onLogTimeClick">> & { ...; }' is not assignable to parameter of type 'ComponentType<ShortcutComponentProps>'.
$ef79721e331af361$var$connectToProps((0, $dmvDL.default)));

});
parcelRegister("dmvDL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b58a2f9914fa5b23$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");
const $b58a2f9914fa5b23$var$LinkToParentButtonItem = ({ onLinkToParentClick: onLinkToParentClick, onClick: onClick, label: label, setDropdownItemRef: setDropdownItemRef, itemKey: itemKey, isSelected: isSelected = false })=>{
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        onLinkToParentClick();
        onClick?.(itemKey);
    }, [
        onLinkToParentClick,
        onClick,
        itemKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        key: "link-to-parent",
        isSelected: isSelected,
        ref: setDropdownItemRef,
        role: "menuitem",
        onClick: handleClick
    }, label);
};
var $b58a2f9914fa5b23$export$2e2bcd8739ae039 = $b58a2f9914fa5b23$var$LinkToParentButtonItem;

});

parcelRegister("kjRlN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5f389cd0c23e4dc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");
const $c5f389cd0c23e4dc$var$LinkToParent = ({ onLinkToParentClick: onLinkToParentClick, onClick: onClick, label: label, itemKey: itemKey })=>{
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        onLinkToParentClick();
        onClick?.(itemKey);
    }, [
        onLinkToParentClick,
        onClick,
        itemKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        key: "link-to-parent",
        onClick: handleClick
    }, label);
};
var $c5f389cd0c23e4dc$export$2e2bcd8739ae039 = $c5f389cd0c23e4dc$var$LinkToParent;

});

parcelRegister("441zj", function(module, exports) {

$parcel$export(module.exports, "default", () => $555cbed3cc1e6d54$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $555cbed3cc1e6d54$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addToParentLevel: {
        "id": "issue.add-to-parent-level",
        "defaultMessage": "Add parent"
    },
    changeParentLevel: {
        "id": "issue.change-parent-level",
        "defaultMessage": "Change parent"
    }
});

});


parcelRegister("inAok", function(module, exports) {

$parcel$export(module.exports, "default", () => $121bb7280d6cacc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $gzyil = parcelRequire("gzyil");
const $121bb7280d6cacc7$var$MoveIssue = ({ onClick: onClick, label: label, itemKey: itemKey })=>{
    const handleClick = (0, $gzyil.default)(itemKey, onClick);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        key: "move",
        onClick: handleClick
    }, label);
};
var $121bb7280d6cacc7$export$2e2bcd8739ae039 = $121bb7280d6cacc7$var$MoveIssue;

});
parcelRegister("gzyil", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d64ca19f7623405$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");
const $3d64ca19f7623405$var$useMoveIssue = (itemKey, onClick)=>{
    const issueId = (0, $hJ992.useIssueId)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const [issueType] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: 'issuetype'
    });
    const isSubtask = issueType?.subtask;
    const href = isSubtask ? `/secure/MoveSubTaskChooseOperation!default.jspa?id=${issueId || ''}` : `/secure/MoveIssue!default.jspa?id=${issueId || ''}`;
    return (0, $eUqFw.useCallback)(()=>{
        onClick?.(itemKey);
        window.location.assign(href);
    }, [
        onClick,
        itemKey,
        href
    ]);
};
var $3d64ca19f7623405$export$2e2bcd8739ae039 = $3d64ca19f7623405$var$useMoveIssue;

});


parcelRegister("lH1Mh", function(module, exports) {

$parcel$export(module.exports, "default", () => $5be09159c5eba5f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");

var $gzyil = parcelRequire("gzyil");
const $5be09159c5eba5f6$var$MoveIssueButtonItem = ({ onClick: onClick, label: label, setDropdownItemRef: setDropdownItemRef, itemKey: itemKey, isSelected: isSelected = false })=>{
    const handleClick = (0, $gzyil.default)(itemKey, onClick);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        key: "move",
        isSelected: isSelected,
        ref: setDropdownItemRef,
        role: "menuitem",
        onClick: handleClick
    }, label);
};
var $5be09159c5eba5f6$export$2e2bcd8739ae039 = $5be09159c5eba5f6$var$MoveIssueButtonItem;

});

parcelRegister("dmwPX", function(module, exports) {

$parcel$export(module.exports, "moveIssueLabel", () => $12e70f74050b8f27$export$25943c9740f2f464);

var $20reX = parcelRequire("20reX");

var $inAok = parcelRequire("inAok");

var $lH1Mh = parcelRequire("lH1Mh");
const $12e70f74050b8f27$export$25943c9740f2f464 = (0, $20reX.default).move;

});
parcelRegister("20reX", function(module, exports) {

$parcel$export(module.exports, "default", () => $15ab7968ed6301ba$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $15ab7968ed6301ba$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    move: {
        "id": "issue.move",
        "defaultMessage": "Move"
    }
});

});


parcelRegister("bfBV8", function(module, exports) {

$parcel$export(module.exports, "unarchiveIssueLabel", () => $2f48cc85fc9424fa$export$f791fa75011697f6);
$parcel$export(module.exports, "default", () => $2f48cc85fc9424fa$export$2e2bcd8739ae039);

var $9oMqb = parcelRequire("9oMqb");

var $jgiMs = parcelRequire("jgiMs");

var $1Anod = parcelRequire("1Anod");
const $2f48cc85fc9424fa$export$f791fa75011697f6 = (0, $1Anod.default).unarchive;
var $2f48cc85fc9424fa$export$2e2bcd8739ae039 = (0, $jgiMs.default);

});
parcelRegister("9oMqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1649b13cdbd419ca$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");

var $hJ992 = parcelRequire("hJ992");

var $kKkx8 = parcelRequire("kKkx8");
const $1649b13cdbd419ca$var$UnarchiveIssueButtonItem = ({ onClick: onClick, label: label, setDropdownItemRef: setDropdownItemRef, itemKey: itemKey, isSelected: isSelected = false })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { openUnarchiveIssueModal: openUnarchiveIssueModal } = (0, $kKkx8.useUnarchiveIssueModalActions)();
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        openUnarchiveIssueModal(issueKey);
        onClick?.(itemKey);
    }, [
        openUnarchiveIssueModal,
        issueKey,
        onClick,
        itemKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        key: "unarchive",
        isSelected: isSelected,
        ref: setDropdownItemRef,
        role: "menuitem",
        onClick: handleClick
    }, label);
};
var $1649b13cdbd419ca$export$2e2bcd8739ae039 = $1649b13cdbd419ca$var$UnarchiveIssueButtonItem;

});

parcelRegister("jgiMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9f177ed6105cd2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $hJ992 = parcelRequire("hJ992");

var $kKkx8 = parcelRequire("kKkx8");
const $ba9f177ed6105cd2$var$UnarchiveIssue = ({ onClick: onClick, label: label, itemKey: itemKey })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { openUnarchiveIssueModal: openUnarchiveIssueModal } = (0, $kKkx8.useUnarchiveIssueModalActions)();
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        openUnarchiveIssueModal(issueKey);
        onClick?.(itemKey);
    }, [
        issueKey,
        openUnarchiveIssueModal,
        onClick,
        itemKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        key: "unarchive",
        onClick: handleClick
    }, label);
};
var $ba9f177ed6105cd2$export$2e2bcd8739ae039 = $ba9f177ed6105cd2$var$UnarchiveIssue;

});

parcelRegister("1Anod", function(module, exports) {

$parcel$export(module.exports, "default", () => $0def93795e4b51c3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0def93795e4b51c3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unarchive: {
        "id": "issue-view-foundation.issue-actions.issue-manipulation-dropdown-group.unarchive-issue.unarchive",
        "defaultMessage": "Restore"
    }
});

});



parcelRegister("NywdJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca328ea487dab413$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ca328ea487dab413$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    fieldsSectionLabel: {
        "id": "issue.issue-view.issue-details.register-shortcuts.fields-section-label",
        "defaultMessage": "Fields"
    },
    issueActionsSectionLabel: {
        "id": "issue.issue-view.issue-details.register-shortcuts.issue-actions-section-label",
        "defaultMessage": "Issue Actions"
    },
    issueWorkflowsSectionLabel: {
        "id": "issue.issue-view.issue-details.register-shortcuts.issue-workflows-section-label",
        "defaultMessage": "Workflow"
    },
    issueActionComment: {
        "id": "issue.issue-view.issue-details.register-shortcuts.issue-action-comment",
        "defaultMessage": "Comment"
    },
    issueActionAssignToMe: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.issue-action-assign-to-me",
        "defaultMessage": "Assign to me"
    },
    assignToMeSuccessTitle: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.assign-to-me-success-title",
        "defaultMessage": "Successfully assigned to you"
    },
    assignToMeSuccessDescription: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.assign-to-me-success-description",
        "defaultMessage": "You're now the assignee for {issueKey}."
    },
    assignToMeFailureTitle: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.assign-to-me-failure-title",
        "defaultMessage": "We couldn't set the assignee"
    },
    assignToMeFailureDescription: {
        "id": "issue.issue-base.foundation.quick-add.quick-add-items.assign-to-me-failure-description",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});

parcelRegister("bIIvG", function(module, exports) {

$parcel$export(module.exports, "getExtraActions", () => $474d0559ff7e03ef$export$8e9def3054e59e5c);
$parcel$export(module.exports, "quickAddItemsToShortcutOptions", () => $474d0559ff7e03ef$export$2c2b505e5565a1ec);
$parcel$export(module.exports, "transitionItemsToShortcutOptions", () => $474d0559ff7e03ef$export$9f814e55d6d47aa3);
$parcel$export(module.exports, "useClickActions", () => $474d0559ff7e03ef$export$eddb23372c8ea1e5);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $hJ992 = parcelRequire("hJ992");

var $dnK1q = parcelRequire("dnK1q");

var $gFVH5 = parcelRequire("gFVH5");

var $3Tszs = parcelRequire("3Tszs");

var $1a3la = parcelRequire("1a3la");

var $iUtze = parcelRequire("iUtze");



var $jMP2a = parcelRequire("jMP2a");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");

var $lGLse = parcelRequire("lGLse");

var $NywdJ = parcelRequire("NywdJ");
const $474d0559ff7e03ef$export$8e9def3054e59e5c = ({ onAddCommentLinkClick: onAddCommentLinkClick, onAssignToMeLinkClick: onAssignToMeLinkClick, onClickAddFormButton: onClickAddFormButton, shouldShowProformaForms: shouldShowProformaForms, formatMessage: formatMessage, canEdit: canEdit })=>[
        ...onAssignToMeLinkClick ? [
            {
                key: (0, $3b8db0345cd9e2d7$export$34c10ac17efea7b3),
                label: formatMessage((0, $NywdJ.default).issueActionAssignToMe),
                onClick: onAssignToMeLinkClick
            }
        ] : [],
        ...onAddCommentLinkClick ? [
            {
                key: (0, $3b8db0345cd9e2d7$export$c631bfba9a978dc7),
                label: formatMessage((0, $NywdJ.default).issueActionComment),
                onClick: onAddCommentLinkClick
            }
        ] : [],
        ...shouldShowProformaForms && canEdit ? [
            {
                key: (0, $186d4efeb1fdfd01$export$8764350a3b03b53),
                label: 'Add form',
                onClick: onClickAddFormButton
            }
        ] : []
    ];
const $474d0559ff7e03ef$export$2c2b505e5565a1ec = (quickAddItems)=>Object.keys(quickAddItems)// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'ItemList'.
    .map((key)=>quickAddItems[key]).flat().map(({ id: id, label: label, onClick: onClick })=>({
            label: label,
            onClick: onClick,
            key: id
        }));
const $474d0559ff7e03ef$export$9f814e55d6d47aa3 = (transitionItems, currentStatus, onClick)=>// @ts-expect-error - TS2322 - Type '{ onClick: () => Promise<void>; label: string; key: string; }[]' is not assignable to type 'ShortcutOption[]'.
    transitionItems.filter((transition)=>transition.to.id !== currentStatus?.id).map((transition)=>({
            onClick: ()=>onClick(transition),
            label: transition.name,
            key: String(transition.id)
        }));
const $474d0559ff7e03ef$export$eddb23372c8ea1e5 = ({ onChangeWorkflow: onChangeWorkflow, onAddComment: onAddComment })=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const issueId = (0, $3Tszs.useIssueAri)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const [permissions] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const [, { openIssueTransitionModal: openIssueTransitionModal }] = (0, $1a3la.useTriggerIssueTransitionModal)();
    const { showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag } = (0, $iUtze.useShowFlag)();
    const { onSuccess: onSuccess, onFailure: onFailure } = (0, $gFVH5.useFieldFlagsOld)();
    const onAssignToMeSuccess = (0, $eUqFw.useCallback)(()=>{
        onSuccess((0, $NywdJ.default).assignToMeSuccessTitle, [
            (0, $NywdJ.default).assignToMeSuccessDescription,
            {
                issueKey: issueKey
            }
        ]);
    }, [
        onSuccess,
        issueKey
    ]);
    const onAssignToMeFailure = (0, $eUqFw.useCallback)(()=>{
        onFailure((0, $NywdJ.default).assignToMeFailureTitle, (0, $NywdJ.default).assignToMeFailureDescription);
    }, [
        onFailure
    ]);
    const [{ value: assigneeFieldValue, fieldConfig: assigneeFieldConfig }, { saveValue: updateAssignee }] = (0, $dnK1q.default)({
        issueKey: issueKey,
        onSuccess: onAssignToMeSuccess,
        onFailure: onAssignToMeFailure
    });
    const onAssignToMeLinkClick = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({});
        updateAssignee(loggedInUser, null, analyticsEvent);
    }, [
        loggedInUser,
        updateAssignee,
        createAnalyticsEvent
    ]);
    const onWorkflowSelected = (0, $eUqFw.useCallback)(async (transition)=>{
        if (transition.hasScreen) {
            const event = createAnalyticsEvent({});
            const handleDialogSuccess = ()=>{
                (0, $jMP2a.fireTrackAnalytics)(event, 'issueTransition success', {
                    triggerPointKey: (0, $3b8db0345cd9e2d7$export$ed607ba791e755e7),
                    isModalOpen: true
                });
                (0, $1ybV0.ff)('show-new-issue-transition-flags_az3ds') && showIssueTransitionSuccessFlag(issueKey, transition.to.statusCategory.name || '');
                onChangeWorkflow(transition, true);
            };
            const handleDialogCancel = ()=>{
                (0, $jMP2a.fireTrackAnalytics)(event, 'issueTransition cancel', {
                    triggerPointKey: (0, $3b8db0345cd9e2d7$export$ed607ba791e755e7),
                    isModalOpen: true
                });
            };
            const handleDialogError = ()=>{
                (0, $jMP2a.fireTrackAnalytics)(event, 'issueTransition failed', {
                    triggerPointKey: (0, $3b8db0345cd9e2d7$export$ed607ba791e755e7),
                    isModalOpen: true
                });
            };
            openIssueTransitionModal?.({
                payload: {
                    issueId: issueId,
                    issueKey: issueKey,
                    transitionId: transition.id
                },
                triggerPointKey: 'issue-transition-issue-view-shortcut-dialog',
                onDialogSuccess: handleDialogSuccess,
                onDialogCancel: handleDialogCancel,
                onDialogError: handleDialogError
            });
        } else {
            await (0, $lRmyA.performPostRequest)(`/rest/api/2/issue/${issueKey}/transitions`, {
                body: JSON.stringify({
                    transition: transition
                })
            });
            onChangeWorkflow(transition, false);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTransition success', {
                triggerPointKey: (0, $3b8db0345cd9e2d7$export$ed607ba791e755e7),
                isModalOpen: false
            });
            (0, $1ybV0.ff)('show-new-issue-transition-flags_az3ds') && showIssueTransitionSuccessFlag(issueKey, transition.to.statusCategory.name || '');
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueStatus updated', {
                newValId: transition.to.id,
                newStatusCategoryId: transition.to.statusCategory.id,
                newStatusCategoryName: transition.to.statusCategory.name,
                hasScreen: transition.hasScreen,
                isConditional: transition.isConditional
            });
        }
    }, [
        createAnalyticsEvent,
        issueId,
        issueKey,
        onChangeWorkflow,
        openIssueTransitionModal,
        showIssueTransitionSuccessFlag
    ]);
    const shouldShowAssignToMe = !!(assigneeFieldConfig?.isEditable && permissions.canBeAssignedToIssues && assigneeFieldValue?.accountId !== loggedInUser?.accountId);
    return {
        onAssignToMeLinkClick: shouldShowAssignToMe ? onAssignToMeLinkClick : undefined,
        onAddCommentLinkClick: permissions.canAddComments ? onAddComment : undefined,
        onWorkflowSelected: onWorkflowSelected
    };
};

});
parcelRegister("iUtze", function(module, exports) {

$parcel$export(module.exports, "useShowFlag", () => $f828442776fe35a6$export$46b5557ad4264ef7);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jeyYc = parcelRequire("jeyYc");
const $f828442776fe35a6$export$46b5557ad4264ef7 = ()=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const showIssueTransitionSuccessFlag = (0, $eUqFw.useCallback)((issueKey, status)=>showFlag((0, $jeyYc.getTransitionSuccessFlag)(issueKey, status, formatMessage)), [
        formatMessage,
        showFlag
    ]);
    const showIssueTransitionFailureFlag = (0, $eUqFw.useCallback)((issueKey)=>showFlag((0, $jeyYc.getTransitionFailureFlag)(issueKey, formatMessage)), [
        formatMessage,
        showFlag
    ]);
    return {
        showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag,
        showIssueTransitionFailureFlag: showIssueTransitionFailureFlag
    };
};

});
parcelRegister("jeyYc", function(module, exports) {

$parcel$export(module.exports, "getTransitionSuccessFlag", () => $8041735303d9aa9a$export$8cfa71b43d733669);
$parcel$export(module.exports, "getTransitionFailureFlag", () => $8041735303d9aa9a$export$d9438db72c9548f1);

var $eo17r = parcelRequire("eo17r");

var $fNjDR = parcelRequire("fNjDR");
const $8041735303d9aa9a$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID = 'issueTransitionSuccessful';
const $8041735303d9aa9a$var$ISSUE_TRANSITION_FAILURE_FLAG_ID = 'issueTransitionFailure';
const $8041735303d9aa9a$export$8cfa71b43d733669 = (issueKey, status, formatMessage)=>{
    const showLinkToIssue = Boolean(issueKey && status);
    if (showLinkToIssue) return {
        id: (0, $eo17r.toFlagId)($8041735303d9aa9a$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
        type: 'success',
        title: formatMessage((0, $fNjDR.default).issueTransitionSuccessfulWithIssueKeyAndStatus, {
            issueKey: issueKey,
            status: status
        }),
        description: (0, $fNjDR.default).issueTransitionSuccessfulFlagDescription
    };
    return {
        id: (0, $eo17r.toFlagId)($8041735303d9aa9a$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
        type: 'success',
        title: formatMessage((0, $fNjDR.default).issueTransitionSuccessful)
    };
};
const $8041735303d9aa9a$export$d9438db72c9548f1 = (issueKey, formatMessage)=>({
        id: (0, $eo17r.toFlagId)($8041735303d9aa9a$var$ISSUE_TRANSITION_FAILURE_FLAG_ID),
        type: 'error',
        title: issueKey ? formatMessage((0, $fNjDR.default).issueTransitionFailureWithKey, {
            issueKey: issueKey
        }) : formatMessage((0, $fNjDR.default).issueTransitionFailure)
    });

});
parcelRegister("fNjDR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2f93f8e85030c1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1c2f93f8e85030c1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueTransitionSuccessful: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful",
        "defaultMessage": "Issue has been updated."
    },
    issueTransitionSuccessfulWithIssueKeyAndStatus: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status",
        "defaultMessage": "{issueKey} moved to {status}."
    },
    issueTransitionSuccessfulFlagDescription: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-flag-description",
        "defaultMessage": "Kudos for keeping things up-to-date!"
    },
    issueTransitionFailure: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure",
        "defaultMessage": "Issue could not be updated."
    },
    issueTransitionFailureWithKey: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key",
        "defaultMessage": "We couldn't update {issueKey}."
    },
    viewIssue: {
        "id": "issue-transition-use-show-flag.use-show-flag.view-issue",
        "defaultMessage": "View issue"
    }
});

});



const $3b8db0345cd9e2d7$export$a29989082612d0d9 = 'comment';
const $3b8db0345cd9e2d7$export$9934728f04ded7bc = 'logWork';
const $3b8db0345cd9e2d7$export$2cb085d8a6b69ae2 = 'attachFiles';
const $3b8db0345cd9e2d7$export$50aa55e768c08714 = 'createSubtask';
const $3b8db0345cd9e2d7$export$392ee7f4c3ff3fc8 = 'convertSubtask';
const $3b8db0345cd9e2d7$export$346f08c1f0d0fe41 = 'move';
const $3b8db0345cd9e2d7$export$c07b68c109124fe2 = 'clone';
const $3b8db0345cd9e2d7$export$b550abc3cf5b5518 = 'agileBoard';
const $3b8db0345cd9e2d7$export$44676822f5e6b099 = 'rankToTop';
const $3b8db0345cd9e2d7$export$571e574c8c336cd4 = 'rankToBottom';
const $3b8db0345cd9e2d7$export$97de66002300ed70 = 'addField';
const $3b8db0345cd9e2d7$export$743e517487373c63 = 'permissionHelper';
const $3b8db0345cd9e2d7$export$2792beb653acc784 = 'notificationHelper';
const $3b8db0345cd9e2d7$export$34c10ac17efea7b3 = 'assign-to-me';
const $3b8db0345cd9e2d7$export$c631bfba9a978dc7 = 'add-comment';
const $3b8db0345cd9e2d7$export$ed607ba791e755e7 = 'issue-view-transition-register-shortcuts';






parcelRegister("48mPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce578c493ad96d9e$export$2e2bcd8739ae039);
class $ce578c493ad96d9e$export$2e2bcd8739ae039 {
    constructor(issueId, mutationType, version = '1', matchStatus = [], // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lastModified){
        this.issueId = issueId;
        this.mutationType = mutationType;
        this.version = version;
        this.matchStatus = matchStatus;
        // create a new timeStamp whenever an object is initialized
        this.lastModified = new Date().toISOString();
    }
}

});

parcelRegister("d7Wfe", function(module, exports) {

$parcel$export(module.exports, "MutationSource", () => $598bd411eca1df87$export$17f28c4c94a74282);
$parcel$export(module.exports, "CacheType", () => $598bd411eca1df87$export$ba193b555633db78);
const $598bd411eca1df87$export$17f28c4c94a74282 = {
    CREATE: 0,
    UPDATE: 1,
    DELETE: 2
};
const $598bd411eca1df87$export$ba193b555633db78 = {
    LOCAL: 'local',
    SESSION: 'session'
};

});

parcelRegister("bsdZ2", function(module, exports) {

$parcel$export(module.exports, "useEcClient", () => $b40c4387cd757cd5$export$9da409beb25e67da);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $gd0Sp = parcelRequire("gd0Sp");

var $65uQX = parcelRequire("65uQX");
const $b40c4387cd757cd5$export$9da409beb25e67da = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let tenantContext;
    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        tenantContext = (0, $gd0Sp.useTenantContext)();
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', `tenant context : ${e?.toString() || ''}`);
    }
    (0, $eUqFw.useEffect)(()=>{
        (0, $65uQX.EcClient).setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    }, [
        tenantContext
    ]);
    const saveIssueMutationToCache = (0, $eUqFw.useCallback)((issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $65uQX.default).saveIssueMutationToCache(issueMutation, key, analyticsFailureEventObj), []);
    const saveIssueMutationsToCache = (0, $eUqFw.useCallback)((issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $65uQX.default).saveIssueMutationsToCache(issueMutations, key, analyticsFailureEventObj), []);
    const searchAndReconcile = (0, $eUqFw.useCallback)((matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability)=>(0, $65uQX.default).searchAndReconcile(matchApiUrl, jqlMatchingKey, search, parseIssueData, capability), []);
    const getIssueMutationFromCache = (key)=>(0, $65uQX.default).getIssueMutationFromCache(key);
    return {
        saveIssueMutationToCache: saveIssueMutationToCache,
        saveIssueMutationsToCache: saveIssueMutationsToCache,
        searchAndReconcile: searchAndReconcile,
        getIssueMutationFromCache: getIssueMutationFromCache
    };
};

});
parcelRegister("65uQX", function(module, exports) {

$parcel$export(module.exports, "EcClient", () => $9d182d4720e39d79$export$a736992aaac2307a);
$parcel$export(module.exports, "getEcClient", () => $9d182d4720e39d79$export$c9342bd32f51406b);
$parcel$export(module.exports, "default", () => $9d182d4720e39d79$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $3FyZ4 = parcelRequire("3FyZ4");

var $7S3WE = parcelRequire("7S3WE");

var $d7Wfe = parcelRequire("d7Wfe");

var $4qvSX = parcelRequire("4qvSX");
class $9d182d4720e39d79$export$a736992aaac2307a {
    #issueCache;
    #config;
    constructor(){
        this.#issueCache = new (0, $7S3WE.default)('issue-cache-v1');
        this.#config = {};
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, atlassianAccountId) {
        (0, $7S3WE.default).setTenantDetails(activationID, cloudID, atlassianAccountId);
    }
    /**
	 * A method to fire analytics events for both success and failure
	 */ static fireAnalyticsEvents(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, isSaved, analyticsFailureEventObj = {}) {
        try {
            // let mutationAnalyticsObj: any = [];
            let trackingId = '-1';
            if (Array.isArray(issueMutations)) //   mutationAnalyticsObj = issueMutations.map((item: IssueMutation) => item.issueId);
            trackingId = String(new Date(issueMutations[0]?.lastModified).valueOf()) + (0, $7S3WE.default).userID;
            else trackingId = String(new Date(issueMutations.lastModified).valueOf()) + (0, $7S3WE.default).userID;
            const payload = {
                action: 'mutated',
                actionSubject: 'issue',
                source: key?.analyticsMetadata?.scenario || 'unknown',
                attributes: {
                    ...key.analyticsMetadata,
                    trackingId: // issueMutationDetails: mutationAnalyticsObj,
                    trackingId
                }
            };
            // Error condition
            if (!isSaved) {
                if (!analyticsFailureEventObj) // eslint-disable-next-line no-param-reassign
                analyticsFailureEventObj = {
                    error: true,
                    errorMsg: payload.source
                };
                payload.attributes = {
                    ...payload.attributes,
                    ...analyticsFailureEventObj
                };
            }
            if (Object.prototype.hasOwnProperty.call(key, 'analyticsEventObj')) (0, $jMP2a.fireTrackAnalytics)(// @ts-expect-error - Argument of type 'Object' is not assignable to parameter of type 'UIAnalyticsEvent'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            key.analyticsEventObj, `${payload.actionSubject} ${payload.action}`, payload.attributes);
            else // if there is no UI component that triggers the event then we manually fire the event
            (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
                client.getInstance().sendTrackEvent(payload);
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', e);
        }
    }
    /**
	 * A method to save a single issue mutations in cache
	 */ async saveIssueMutationToCache(issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $7S3WE.default).setBackendCache(issueMutation);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return isSaved;
        }
        return this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
            let isSaved = false;
            if (issueMutation.mutationType === (0, $d7Wfe.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
            else if (result || issueMutation.mutationType === (0, $d7Wfe.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
            else isSaved = await this.#issueCache.create(issueMutation.issueId);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return new Promise((resolve)=>resolve(isSaved));
        });
    }
    /**
	 * A method to save multiple issue mutations in cache
	 */ async saveIssueMutationsToCache(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        const data = [];
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $7S3WE.default).setBackendCache(issueMutations);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            return [
                isSaved
            ];
        }
        issueMutations.forEach(async (issueMutation)=>{
            this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
                let isSaved = false;
                if (issueMutation.mutationType === (0, $d7Wfe.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
                else if (result || issueMutation.mutationType === (0, $d7Wfe.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
                else isSaved = await this.#issueCache.create(issueMutation.issueId);
                data.push(isSaved);
                $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            });
        });
        return new Promise((resolve)=>resolve(data));
    }
    /**
	 * A method to get issue mutations in saved in cache
	 */ getIssueMutationFromCache(key) {
        return this.#issueCache.get(key);
    }
    /**
	 * A method to remove the deleted issues from the search API
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async filterData(data) {
        const localStorageData = await this.getIssueMutationFromCache(null);
        const deletedData = new Set();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(localStorageData).forEach((element)=>{
            if (element.mutationType === (0, $d7Wfe.MutationSource).DELETE) deletedData.add(element.issueId);
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredData = [];
        let success = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(data).forEach((element)=>{
            if (!element.id || typeof element.id !== 'number') success = false;
            else if (!deletedData.has(element.id.toString())) filteredData.push(element);
        });
        return new Promise((// eslint-disable-next-line @typescript-eslint/no-explicit-any
        resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject)=>{
            if (success) resolve(filteredData);
            else reject(new Error());
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async constructMatchRequest() {
        const issueData = {
            issues: [],
            hydrationMode: 0
        };
        const data = await this.getIssueMutationFromCache(null);
        Object.values(data).forEach((issueMutation)=>{
            const element = {
                issueId: issueMutation.issueId,
                version: issueMutation.version
            };
            issueData.issues.push(element);
        });
        const options = {
            method: 'POST',
            headers: {
                content_type: 'application/json',
                // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
                'x-atlassian-capability': this.#config.capability
            },
            body: JSON.stringify(issueData)
        };
        return new Promise((resolve)=>resolve(options));
    }
    /**
	 * A method to get the relevant search data from the parsing function that the user has provided
	 */ static getIssueDataFromSearch(data, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData) {
        const result = parseIssueData(data);
        if (result == null) return [];
        return result;
    }
    /**
	 * A method to get the search data and reconcile it with the data present in cache
	 */ async searchAndReconcile(matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability) {
        // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
        this.#config.capability = capability;
        const matchRequest = await this.constructMatchRequest();
        if (matchRequest && matchRequest.body && matchRequest.body.issues && matchRequest.body.issues.length === 0) return search.then((data)=>new Promise((resolve)=>resolve({
                    reconciledIssues: $9d182d4720e39d79$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData),
                    matchAPIResponse: {
                        response: {
                            resultsByIssueId: {}
                        },
                        issue: {
                            issuesResponse: {}
                        }
                    }
                })));
        const matchPromise = (0, $2OdyW.default)(matchApiUrl, matchRequest);
        return Promise.all([
            search,
            matchPromise
        ]).then(([data, response])=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const structuredData = $9d182d4720e39d79$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData);
            return this.filterData(structuredData) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((filteredSearchData)=>{
                if (response == null || response.response == null || response.response.resultsByIssueId == null) throw new Error('Match response is invalid!');
                const matchedIssueIds = response.response.resultsByIssueId;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const filteredMatchedIssueIdsData = [];
                Object.entries(matchedIssueIds).forEach(([key, value])=>{
                    if (value === 'RESULT_MATCH') filteredMatchedIssueIdsData.push({
                        id: parseInt(key, 10)
                    });
                });
                return new Promise((resolve)=>{
                    resolve({
                        reconciledIssues: (0, $4qvSX.mergeResponseData)(filteredSearchData, filteredMatchedIssueIdsData),
                        matchAPIResponse: response
                    });
                });
            }).catch(()=>new Promise((resolve)=>resolve({
                        reconciledIssues: structuredData,
                        matchAPIResponse: response
                    })));
        });
    }
}
const $9d182d4720e39d79$var$ecClient = new $9d182d4720e39d79$export$a736992aaac2307a();
function $9d182d4720e39d79$export$c9342bd32f51406b(tenantContext = {}) {
    $9d182d4720e39d79$export$a736992aaac2307a.setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    return $9d182d4720e39d79$var$ecClient;
}
var $9d182d4720e39d79$export$2e2bcd8739ae039 = $9d182d4720e39d79$var$ecClient;

});
parcelRegister("7S3WE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed861ad8bfcfb81a$export$2e2bcd8739ae039);
// Issue Cache API is an internal tool and this file should not be edited. Please contact Odin team for any modifications.

var $kBiqn = parcelRequire("kBiqn");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $48mPv = parcelRequire("48mPv");

var $d7Wfe = parcelRequire("d7Wfe");

var $4qvSX = parcelRequire("4qvSX");
const $ed861ad8bfcfb81a$var$MAX_AGE_MIN = 5;
const $ed861ad8bfcfb81a$var$MAX_AGE = $ed861ad8bfcfb81a$var$MAX_AGE_MIN * 60000;
const $ed861ad8bfcfb81a$var$CACHE_SIZE = 100;
const $ed861ad8bfcfb81a$var$CACHE_KEY_PREFIX = '__storejs';
const $ed861ad8bfcfb81a$var$BE_CACHE_SAVE_ISSUE_MUTATION = '/gateway/api/jira-jql-service/api/v1/issue-mutation';
class $ed861ad8bfcfb81a$export$2e2bcd8739ae039 {
    #localCache;
    #sessionCache;
    constructor(namespace, maxAge = $ed861ad8bfcfb81a$var$MAX_AGE){
        this.maxAge = maxAge;
        this.namespace = namespace;
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#localCache = new (0, $kBiqn.Cache)({
            size: $ed861ad8bfcfb81a$var$CACHE_SIZE,
            storageType: (0, $d7Wfe.CacheType).LOCAL,
            cacheKey: namespace
        });
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#sessionCache = new (0, $kBiqn.Cache)({
            size: $ed861ad8bfcfb81a$var$CACHE_SIZE,
            storageType: (0, $d7Wfe.CacheType).SESSION,
            cacheKey: namespace
        });
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, userID) {
        if (activationID && activationID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID = activationID;
        if (cloudID && cloudID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID = cloudID;
        if (userID && userID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID = userID;
    }
    /**
	 * A util method to decide whether an issue mutation in cache is stale or not
	 */ static isIssueMutationStale(issueMutation) {
        const lastModified = new Date(issueMutation.lastModified).getTime();
        return Date.now() - lastModified < $ed861ad8bfcfb81a$var$MAX_AGE;
    }
    /**
	 * A util method to generate partial key containing username for storing in cache
	 */ static generateKey() {
        let anonymousId = window.localStorage.getItem('ajs_anonymous_id');
        anonymousId = anonymousId ? `.${anonymousId}` : '';
        anonymousId = anonymousId.replace(/["]+/g, '');
        // TODO : Replace this with something more generic
        return `jsis.ecCache.data${anonymousId}.newIssuesMutationList`;
    }
    /**
	 * A method to generate key containing username as well as namespace for storing in cache
	 */ generateReadKey() {
        return `${$ed861ad8bfcfb81a$var$CACHE_KEY_PREFIX}_${this.namespace}_${$ed861ad8bfcfb81a$export$2e2bcd8739ae039.generateKey()}`;
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds and returns corresponding issue mutations
	 * Returns all the issue mutations when provided with null argument in form of an array
	 * Cleans the cache before accessing issue mutations in order to avoid stale data
	 */ async get(key) {
        return this.cleanCache().then(()=>this.getWithoutClean(key));
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds to return selective issue mutations
	 * Returns all the issue mutations when provided with null argument
	 */ async getWithoutClean(key) {
        if (key == null) return new Promise((resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>data ? resolve(data) : resolve({}));
        });
        return new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>{
                if (!data) resolve({});
                else {
                    const iterableData = data;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const newData = {};
                    if (typeof key === 'string') newData[key] = iterableData[key];
                    else if (Array.isArray(key)) key.forEach((issueId)=>{
                        newData[issueId] = iterableData[issueId];
                    });
                    resolve(newData);
                }
            });
        });
    }
    /**
	 * A method to construct object to be stored in backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static constructBackendCacheObject(value) {
        if (value instanceof (0, $48mPv.default)) return {
            issueId: value.issueId,
            mutationType: value.mutationType,
            mutationTimestamp: value.lastModified
        };
        const result = [];
        value.forEach((data)=>{
            result.push($ed861ad8bfcfb81a$export$2e2bcd8739ae039.constructBackendCacheObject(data));
        });
        return result;
    }
    /**
	 * A method to save the issue mutations in the backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static setBackendCache(data) {
        try {
            let issueBody = $ed861ad8bfcfb81a$export$2e2bcd8739ae039.constructBackendCacheObject(data);
            let trackingId = '-1';
            if (data instanceof (0, $48mPv.default)) {
                trackingId = String(new Date(data.lastModified).valueOf()) + ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID || '');
                issueBody = [
                    issueBody
                ];
            } else trackingId = String(new Date(data[0].lastModified).valueOf()) + ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID || '');
            (0, $2OdyW.default)($ed861ad8bfcfb81a$var$BE_CACHE_SAVE_ISSUE_MUTATION, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'ATL-activationId': $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID || '',
                    'atl-CloudId': $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID || '',
                    trackingId: trackingId
                },
                body: JSON.stringify({
                    issueMutations: issueBody
                })
            });
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', `${e?.toString() || ''}mutationObj: ${data}`);
            return false;
        }
    }
    /**
	 * A method to save the issue mutations in the cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ async set(value) {
        return this.getWithoutClean().then(async (cacheData)=>{
            if (value instanceof (0, $48mPv.default)) {
                const storeValue = {
                    [value.issueId]: value
                };
                return new Promise((resolve)=>{
                    try {
                        this.#localCache.set(this.generateReadKey(), (0, $4qvSX.mergeData)(cacheData, storeValue));
                        resolve(true);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (e) {
                        resolve(false);
                    }
                });
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const storeData = {};
            value.forEach((data)=>{
                storeData[data.issueId] = data;
            });
            return new Promise((resolve)=>{
                try {
                    this.#localCache.set(this.generateReadKey(), (0, $4qvSX.mergeData)(cacheData, storeData));
                    resolve(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    resolve(false);
                }
            });
        });
    }
    /**
	 * A method to create a new issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be created in cache
	 */ async create(value) {
        return this.cleanCache().then(()=>{
            if (!Array.isArray(value)) return this.set(new (0, $48mPv.default)(value, (0, $d7Wfe.MutationSource).CREATE, '1', [], new Date().toISOString()));
            const storeData = value.map((data)=>new (0, $48mPv.default)(data, (0, $d7Wfe.MutationSource).CREATE, '1', [], new Date().toISOString()));
            return this.set(storeData);
        });
    }
    /**
	 * A method to update an already existing issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be updated in cache
	 */ async update(value) {
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            if (typeof value === 'string') return this.set(new (0, $48mPv.default)(value, (0, $d7Wfe.MutationSource).UPDATE, '1', []));
            return this.set(value.map((issueId)=>new (0, $48mPv.default)(issueId, (0, $d7Wfe.MutationSource).UPDATE, '1', [])));
        }
        return this.getWithoutClean(value).then((data)=>{
            const valueToUpdate = [];
            Object.entries(data).forEach(([issueId, issueMutationObj])=>{
                if (issueMutationObj instanceof (0, $48mPv.default)) {
                    if ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).UPDATE, issueMutationObj.version, issueMutationObj.matchStatus, new Date().toISOString()));
                    else valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).CREATE, '1', issueMutationObj.matchStatus, new Date().toISOString()));
                } else valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).UPDATE, // TODO: Incorporate the version and match status and change the update method signature
                '1', [], new Date().toISOString()));
            });
            return this.set(valueToUpdate);
        });
    }
    /**
	 * A method to delete an issue mutation in cache
	 */ async delete(key) {
        if (typeof key === 'string') return this.set(new (0, $48mPv.default)(key, (0, $d7Wfe.MutationSource).DELETE, '', [], new Date().toISOString()));
        const storeData = key.map((data)=>new (0, $48mPv.default)(data, (0, $d7Wfe.MutationSource).DELETE, '', [], new Date().toISOString()));
        return this.set(storeData);
    }
    /**
	 * A method to clear the cache
	 */ async clear() {
        return this.#localCache.clear();
    }
    /**
	 * A method that selectively deletes the stale cache entries
	 */ async cleanCache() {
        // We don't clean the backend cache
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) return Promise.resolve(true);
        return this.getWithoutClean(null).then((data)=>{
            const issuesToKeep = [];
            if (data && Object.keys(data).length !== 0 && Object.getPrototypeOf(data) === Object.prototype) Object.keys(data).forEach((issueId)=>{
                const issueMutationObj = data[issueId];
                if ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) issuesToKeep.push(issueMutationObj);
            });
            return this.clear().then(()=>this.set(issuesToKeep));
        });
    }
    /**
	 * A method to check if an issue id is present in the cache
	 */ isPresent(issueId) {
        return this.get(issueId).then((data)=>!!data && !!Object.values(data)[0]);
    }
    /**
	 * A method to check if any mutation is present in the cache
	 */ isEmpty() {
        return this.get(null).then((data)=>Object.keys(data).length === 0);
    }
    /**
	 * A method to find the size of the local storage for any given key
	 */ static getLocalStorageSizeForGivenKey(key) {
        const value = localStorage.getItem(key);
        if (value != null) {
            const keySize = value.length;
            return keySize;
        }
        return 0;
    }
    /**
	 * A method to find the size of the local storage for any given key
	 * It returns size of all the keys when provided with no key
	 */ static getLocalStorageSize(key) {
        if (key != null) return $ed861ad8bfcfb81a$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(key);
        let totalSize = 0;
        Object.keys(localStorage).forEach((keys)=>{
            totalSize += $ed861ad8bfcfb81a$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(keys);
        });
        return totalSize;
    }
}

});
parcelRegister("4qvSX", function(module, exports) {

$parcel$export(module.exports, "mergeData", () => $1b463beed4d472c8$export$696bf4df45a0ddde);
$parcel$export(module.exports, "mergeResponseData", () => $1b463beed4d472c8$export$71923bad28063cb1);
$parcel$export(module.exports, "createAnalyticsMetadata", () => $1b463beed4d472c8$export$eeaad9fa1f02ef4a);

var $6rW04 = parcelRequire("6rW04");
function $1b463beed4d472c8$export$696bf4df45a0ddde(oldData, newData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    Object.keys(oldData).forEach((issueId)=>{
        result[issueId] = oldData[issueId];
    });
    Object.keys(newData).forEach((issueId)=>{
        result[issueId] = newData[issueId];
    });
    return result;
}
function $1b463beed4d472c8$export$71923bad28063cb1(searchData, matchData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mergedData = [];
    const issueData = new Map();
    if (matchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matchData.forEach((element)=>{
        issueData.set(element.id, element);
    });
    if (searchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchData.forEach((element)=>{
        // TODO: if issueVersion in Match is less than Search, we should not be overwriting that issueID.
        if (issueData.has(element.id)) {
            mergedData.push(issueData.get(element.id));
            issueData.delete(element.id);
        } else mergedData.push(element);
    });
    if (issueData.size) issueData.forEach((value)=>{
        mergedData.push(value);
    });
    return mergedData;
}
function $1b463beed4d472c8$export$eeaad9fa1f02ef4a(customKeys) {
    return {
        shard: (0, $6rW04.default)('ajs-shard') || '',
        userId: (0, $6rW04.default)('ajs-atlassian-account-id') || '',
        projectId: (0, $6rW04.default)('ajs-project-key') || '',
        ...customKeys
    };
}

});




parcelRegister("dvBSb", function(module, exports) {

$parcel$export(module.exports, "issueViewRelayResource", () => $e26b3f39fd0cc4df$export$55131006e6699c0a);
$parcel$export(module.exports, "useIssueViewRelayRouteResource", () => $e26b3f39fd0cc4df$export$252bdba8c8e5f066);

var $1ybV0 = parcelRequire("1ybV0");

var $jBy23 = parcelRequire("jBy23");
var $2mP8r = parcelRequire("2mP8r");

var $buJlM = parcelRequire("buJlM");

var $lW5gg = parcelRequire("lW5gg");

var $3HCkE = parcelRequire("3HCkE");

var $9PXNH = parcelRequire("9PXNH");

var $2skem = parcelRequire("2skem");

const $e26b3f39fd0cc4df$var$getDataLoader = ()=>(parcelRequire("jDleI"));
const $e26b3f39fd0cc4df$var$shouldCaptureTraceIds = ()=>(0, $1ybV0.ff)('issue.view-add-traceids-to-issue-view-relay-errors_vm8h2');
const $e26b3f39fd0cc4df$export$5ce473a762cc813e = (0, $3HCkE.createResource)((0, $2skem.withResourceEarlyData)({
    type: 'ISSUE_AGG_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        return issueKey || '';
    },
    getDataLoader: $e26b3f39fd0cc4df$var$getDataLoader,
    maxAge: (0, $2skem.MIN_MAX_AGE),
    isBrowserOnly: true
}));
const $e26b3f39fd0cc4df$export$55131006e6699c0a = (0, $buJlM.createRelayResource)({
    type: 'ISSUE_RELAY_DATA',
    isBrowserOnly: true,
    captureErrors: true,
    captureTraceIds: $e26b3f39fd0cc4df$var$shouldCaptureTraceIds(),
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
        const { match: match } = routerContext;
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        const projectKey = issueKey ? (0, $jBy23.extractProjectKey)(issueKey) : '';
        return {
            parameters: (0, $lW5gg.default),
            variables: {
                cloudId: cloudId,
                issueKey: issueKey || '',
                projectKey: projectKey,
                ...(0, $2mP8r.getMainIssueViewAggQueryFeatureFlagVariables)()
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});
const $e26b3f39fd0cc4df$export$252bdba8c8e5f066 = (options)=>(0, $buJlM.useRelayResource)($e26b3f39fd0cc4df$export$55131006e6699c0a, options);

});
parcelRegister("lW5gg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f29749e4a66b033$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<353cc01fece1c8881e03e1decf5cbc73>>
 * @relayHash 8fecacabe46771ea2cc96b3cc62f9c72
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5c935b5b49b17fbea11e10a5708bd3178ec8ad8332a715ad2614caa6c7b18df
const $8f29749e4a66b033$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e5c935b5b49b17fbea11e10a5708bd3178ec8ad8332a715ad2614caa6c7b18df",
        "metadata": {},
        "name": "mainIssueAggQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8f29749e4a66b033$export$2e2bcd8739ae039 = $8f29749e4a66b033$var$node;

});

parcelRegister("jDleI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hJsnC');
        const value = parcelRequire('hNY4a');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hJsnC").then(()=>parcelRequire('hNY4a'));
}

});


parcelRegister("1rx5k", function(module, exports) {

$parcel$export(module.exports, "FullPageIssueContainer", () => $e6a16efa52554d80$export$f4550b4a355415eb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $e6a16efa52554d80$export$f4550b4a355415eb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("h4S45", function(module, exports) {

$parcel$export(module.exports, "getLegacyIssueViewUrl", () => $593f1f2df6cfbcec$export$10eafddc948a68e6);

var $53ciZ = parcelRequire("53ciZ");
const $593f1f2df6cfbcec$export$96489d9b108fd55f = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(window.location.search).rapidView;
const $593f1f2df6cfbcec$export$10eafddc948a68e6 = ()=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(window.location.search);
    params.oldIssueView = 'true';
    return `${window.location.protocol}//${window.location.host}${window.location.pathname}?${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(params)}${window.location.hash}`;
};

});





//# sourceMappingURL=async-issue-app--full-page.4f397179.js.map
